export const DICTIONARY_JSON = {
  "AA": "(Hawaiian) a volcanic rock consisting of angular blocks of lava with a very rough surface [n -S]\n",
  "AAH": "an interjection expressing surprise [interj] / to exclaim in surprise [v -ED, -ING, -S]\n",
  "AAHED": "AAH, to exclaim in surprise [v]\n",
  "AAHING": "AAH, to exclaim in surprise [v]\n",
  "AAHS": "AAH, to exclaim in surprise [v]\n",
  "AAL": "(Hindi) the Indian mulberry tree, aka noni, also AL [n -S]\n",
  "AALII": "(Hawaiian) a tropical tree [n -S]\n",
  "AALIIS": "AALII, (Hawaiian) a tropical tree [n]\n",
  "AALS": "AAL, (Hindi) the Indian mulberry tree, aka noni, also AL [n]\n",
  "AARDVARK": "(South African) a nocturnal, insectivorous, badger-sized mammal native to sub-Saharan Africa [n -S]\n",
  "AARDVARKS": "AARDVARK, (South African) a nocturnal, insectivorous, badger-sized mammal native to sub-Saharan Africa [n]\n",
  "AARDWOLF": "(South African) a hyena-like African mammal, aka earthwolf [n AARDWOLVES]\n",
  "AARDWOLVES": "AARDWOLF, (South African) a hyena-like African mammal, aka earthwolf [n]\n",
  "AARGH": "an exclamation indicating dismay, also AARRGH, AARRGHH, ARGH [interj]\n",
  "AARRGH": "an exclamation indicating dismay, also AARGH, AARRGHH, ARGH [interj]\n",
  "AARRGHH": "used to express disgust, also AARGH, AARRGH [interj]\n",
  "AARTI": "(Hindi) an Indian ceremony in which candles dipped in ghee are lighted and offered to various deities, also ARTI [n -S]\n",
  "AARTIS": "AARTI, (Hindi) an Indian ceremony in which candles dipped in ghee are lighted and offered to various deities, also ARTI [n]\n",
  "AAS": "AA, (Hawaiian) a volcanic rock consisting of angular blocks of lava with a very rough surface [n]\n",
  "AASVOGEL": "(South African) a South African vulture [n -S]\n",
  "AASVOGELS": "AASVOGEL, (South African) a South African vulture [n]\n",
  "AB": "an abdominal muscle [n -S]\n",
  "ABA": "a Syrian cloth of goat's or camel's hair; an outer garment made of it, also ABAYA [n -S]\n",
  "ABAC": "a nomogram, a chart or diagram of scaled lines or curves used to assist in mathematical calculations [n -S]\n",
  "ABACA": "(Tagalog) a Philippine plant, also ABAKA [n -S]\n",
  "ABACAS": "ABACA, (Tagalog) a Philippine plant, also ABAKA [n]\n",
  "ABACI": "ABACUS, (Latin) a counting frame using beads [n]\n",
  "ABACK": "towards the back [adv]\n",
  "ABACS": "ABAC, a nomogram, a chart or diagram of scaled lines or curves used to assist in mathematical calculations [n]\n",
  "ABACTERIAL": "not caused by or characterised by the presence of bacteria [adj]\n",
  "ABACTINAL": "remote from the actinal area (of a radiate animal) [adj ABACTINALLY]\n",
  "ABACTINALLY": "ABACTINAL, remote from the actinal area (of a radiate animal) [adv]\n",
  "ABACTOR": "(obsolete) a cattle thief [n -S]\n",
  "ABACTORS": "ABACTOR, (obsolete) a cattle thief [n]\n",
  "ABACUS": "(Latin) a counting frame using beads [n ABACUSES or ABACI]\n",
  "ABACUSES": "ABACUS, (Latin) a counting frame using beads [n]\n",
  "ABAFT": "towards or at the stern of a ship [adv]\n",
  "ABAKA": "(Tagalog) the Manila-hemp plant, or its fiber, also ABACA [n -S]\n",
  "ABAKAS": "ABAKA, (Tagalog) the Manila-hemp plant, or its fiber, also ABACA [n]\n",
  "ABALONE": "a sea snail of rocky coasts, aka ormer [n -S]\n",
  "ABALONES": "ABALONE, a sea snail of rocky coasts, aka ormer [n]\n",
  "ABAMP": "short for ABAMPERE, a unit of electric current equivalent to 10 amperes [n -S]\n",
  "ABAMPERE": "a unit of electric current equivalent to 10 amperes [n -S]\n",
  "ABAMPERES": "ABAMPERE, a unit of electric current equivalent to 10 amperes [n]\n",
  "ABAMPS": "ABAMP, short for ABAMPERE, a unit of electric current equivalent to 10 amperes [n]\n",
  "ABAND": "(Spenser) to abandon [v -ED, -ING, -S]\n",
  "ABANDED": "ABAND, (Spenser) to abandon [v]\n",
  "ABANDING": "ABAND, (Spenser) to abandon [v]\n",
  "ABANDON": "to leave or give up completely [v -ED, -ING, -S]\n",
  "ABANDONED": "ABANDON, to leave or give up completely [v]\n",
  "ABANDONEDLY": "ABANDONED, ABANDON, to leave or give up completely [adv]\n",
  "ABANDONEE": "one to whom anything is legally abandoned [n -S]\n",
  "ABANDONEES": "ABANDONEE, one to whom anything is legally abandoned [n]\n",
  "ABANDONER": "one who abandons [n -S]\n",
  "ABANDONERS": "ABANDONER, one who abandons [n]\n",
  "ABANDONING": "ABANDON, to leave or give up completely [v]\n",
  "ABANDONMENT": "the state of being abandoned [n -S]\n",
  "ABANDONMENTS": "ABANDONMENT, the state of being abandoned [n]\n",
  "ABANDONS": "ABANDON, to leave or give up completely [v]\n",
  "ABANDONWARE": "computer software that is no longer sold or supported by the publisher [n -S]\n",
  "ABANDONWARES": "ABANDONWARE, computer software that is no longer sold or supported by the publisher [n]\n",
  "ABANDS": "ABAND, (Spenser) to abandon [v]\n",
  "ABAPICAL": "directed away from the apex [adj]\n",
  "ABAS": "ABA, a Syrian cloth of goat's or camel's hair; an outer garment made of it, also ABAYA [n]\n",
  "ABASE": "to lower in rank, prestige, or esteem [v ABASED, ABASING, ABASES]\n",
  "ABASED": "ABASE, to lower in rank, prestige, or esteem [v]\n",
  "ABASEDLY": "ABASED, ABASE, to lower in rank, prestige, or esteem [adv]\n",
  "ABASEMENT": "the state of being abased (humbled); humiliation [n -S]\n",
  "ABASEMENTS": "ABASEMENT, the state of being abased (humbled); humiliation [n]\n",
  "ABASER": "one who abases [n -S]\n",
  "ABASERS": "ABASER, one who abases [n]\n",
  "ABASES": "ABASE, to lower in rank, prestige, or esteem [v]\n",
  "ABASH": "to strike with shame [v -ED, -ING, -ES]\n",
  "ABASHED": "ABASH, to strike with shame [v]\n",
  "ABASHEDLY": "ABASHED, ABASH, to strike with shame [adv]\n",
  "ABASHES": "ABASH, to strike with shame [v]\n",
  "ABASHING": "ABASH, to strike with shame [v]\n",
  "ABASHLESS": "(obsolete) unabashed (unashamed; not embarrassed) [adj]\n",
  "ABASHMENT": "the state of being abashed [n -S]\n",
  "ABASHMENTS": "ABASHMENT, the state of being abashed [n]\n",
  "ABASIA": "the inability to walk due to lack of muscular coordination [n -S]\n",
  "ABASIAS": "ABASIA, the inability to walk due to lack of muscular coordination [n]\n",
  "ABASING": "ABASE, to lower in rank, prestige, or esteem [v]\n",
  "ABASK": "in genial warmth [adv]\n",
  "ABATABLE": "able to be abated as, an abatable writ or nuisance [adj]\n",
  "ABATE": "to reduce in intensity [v ABATED, ABATING, ABATES]\n",
  "ABATED": "ABATE, to reduce in intensity [v]\n",
  "ABATEMENT": "a diminution; a mark of dishonour added to heraldic arms [n -S]\n",
  "ABATEMENTS": "ABATEMENT, a diminution; a mark of dishonour added to heraldic arms [n]\n",
  "ABATER": "one who abates [n -S]\n",
  "ABATERS": "ABATER, one who abates [n]\n",
  "ABATES": "ABATE, to reduce in intensity [v]\n",
  "ABATING": "ABATE, to reduce in intensity [v]\n",
  "ABATIS": "(French) a barrier made of felled trees, also ABATTIS [n -ES]\n",
  "ABATISES": "ABATIS, (French) a barrier made of felled trees, also ABATTIS [n]\n",
  "ABATOR": "one who unlawfully seizes an inheritance [n -S]\n",
  "ABATORS": "ABATOR, one who unlawfully seizes an inheritance [n]\n",
  "ABATTIS": "(French) a barrier made of felled trees or branches, also ABATIS [n -ES]\n",
  "ABATTISES": "ABATTIS, (French) a barrier made of felled trees or branches, also ABATIS [n]\n",
  "ABATTOIR": "(French) a public slaughterhouse [n -S]\n",
  "ABATTOIRS": "ABATTOIR, (French) a public slaughterhouse [n]\n",
  "ABATTU": "(French) cast down, dejected [adj]\n",
  "ABATURE": "(French) a trail through a wood beaten down by a stag [n -S]\n",
  "ABATURES": "ABATURE, (French) a trail through a wood beaten down by a stag [n]\n",
  "ABAXIAL": "facing away from the axis, as the surface of a leaf, also ABAXILE [adj]\n",
  "ABAXILE": "facing away from the axis, as the surface of a leaf, also ABAXIAL [adj]\n",
  "ABAYA": "a Syrian cloth of goat's or camel's hair; an outer garment made of it, also ABA, ABBA [n -S]\n",
  "ABAYAS": "ABAYA, a Syrian cloth of goat's or camel's hair; an outer garment made of it, also ABA, ABBA [n]\n",
  "ABB": "a woof yarn [n -S]\n",
  "ABBA": "a Syrian cloth of goat's or camel's hair; an outer garment made of it, also ABA, ABAYA [n -S]\n",
  "ABBACIES": "ABBACY, the office of an abbot, also ABBOTCY [n]\n",
  "ABBACY": "the office of an abbot, also ABBOTCY [n ABBACIES]\n",
  "ABBAS": "ABBA, a Syrian cloth of goat's or camel's hair; an outer garment made of it, also ABA, ABAYA [n]\n",
  "ABBATIAL": "pertaining to an abbot [adj]\n",
  "ABBE": "(French) a courtesy title given in France to every one vested with the ecclesiastical habit or dress [n -S]\n",
  "ABBED": "displaying well-developed abdominal muscles [adj]\n",
  "ABBES": "ABBE, (French) a courtesy title given in France to every one vested with the ecclesiastical habit or dress [n]\n",
  "ABBESS": "a female abbot, head of a nunnery [n -ES]\n",
  "ABBESSES": "ABBESS, a female abbot, head of a nunnery [n]\n",
  "ABBEY": "a building inhabited by a community of monks or nuns governed by an abbot or abbess [n -S]\n",
  "ABBEYS": "ABBEY, a building inhabited by a community of monks or nuns governed by an abbot or abbess [n]\n",
  "ABBOT": "the superior in a monastery [n -S]\n",
  "ABBOTCIES": "ABBOTCY, the office of an abbot, also ABBACY [n]\n",
  "ABBOTCY": "the office of an abbot, also ABBACY [n ABBOTCIES]\n",
  "ABBOTS": "ABBOT, the superior in a monastery [n]\n",
  "ABBOTSHIP": "the office of an abbot (the head of a monastery) [n -S]\n",
  "ABBOTSHIPS": "ABBOTSHIP, the office of an abbot (the head of a monastery) [n]\n",
  "ABBREVIATE": "to make briefer [v ABBREVIATED, ABBREVIATING, ABBREVIATES]\n",
  "ABBREVIATED": "ABBREVIATE, to make briefer [v]\n",
  "ABBREVIATES": "ABBREVIATE, to make briefer [v]\n",
  "ABBREVIATING": "ABBREVIATE, to make briefer [v]\n",
  "ABBREVIATION": "the act or result of abbreviating [n -S]\n",
  "ABBREVIATIONS": "ABBREVIATION, the act or result of abbreviating [n]\n",
  "ABBREVIATOR": "one who abbreviates [n -S]\n",
  "ABBREVIATORS": "ABBREVIATOR, one who abbreviates [n]\n",
  "ABBREVIATORY": "serving to abbreviate [adj]\n",
  "ABBREVIATURE": "(French) an abridgement; an abbreviated state or form [n -S]\n",
  "ABBREVIATURES": "ABBREVIATURE, (French) an abridgement; an abbreviated state or form [n]\n",
  "ABBS": "ABB, a woof yarn [n]\n",
  "ABCEE": "the alphabet, also ABSEY [n -S]\n",
  "ABCEES": "ABCEE, the alphabet, also ABSEY [n]\n",
  "ABCOULOMB": "the unit of electric charge, equal to ten coulombs [n -S]\n",
  "ABCOULOMBS": "ABCOULOMB, the unit of electric charge, equal to ten coulombs [n]\n",
  "ABDABS": "(slang) a state of extreme nervousness, as in 'the screaming abdabs' [n]\n",
  "ABDICABLE": "capable of being abdicated [adj]\n",
  "ABDICANT": "one who abdicates [n -S]\n",
  "ABDICANTS": "ABDICANT, one who abdicates [n]\n",
  "ABDICATE": "to renounce or surrender formally, as one's power or office [v ABDICATED, ABDICATING, ABDICATES]\n",
  "ABDICATED": "ABDICATE, to renounce or surrender formally, as one's power or office [v]\n",
  "ABDICATES": "ABDICATE, to renounce or surrender formally, as one's power or office [v]\n",
  "ABDICATING": "ABDICATE, to renounce or surrender formally, as one's power or office [v]\n",
  "ABDICATION": "an act of abdicating [n -S]\n",
  "ABDICATIONS": "ABDICATION, an act of abdicating [n]\n",
  "ABDICATIVE": "relating to abdication [adj]\n",
  "ABDICATOR": "one who abdicates [n -S]\n",
  "ABDICATORS": "ABDICATOR, one who abdicates [n]\n",
  "ABDOMEN": "in mammals, the part between diaphragm and pelvis; in arthropods, the hind-body [n ABDOMENS or ABDOMINA]\n",
  "ABDOMENS": "ABDOMEN, in mammals, the part between diaphragm and pelvis; in arthropods, the hind-body [n]\n",
  "ABDOMINA": "ABDOMEN, in mammals, the part between diaphragm and pelvis; in arthropods, the hind-body [n]\n",
  "ABDOMINAL": "relating to the abdomen [adj ABDOMINALLY] / an abdominal muscle [n -S]\n",
  "ABDOMINALLY": "ABDOMINAL, relating to the abdomen [adv]\n",
  "ABDOMINALS": "ABDOMINAL, an abdominal muscle [n]\n",
  "ABDOMINOPLASTY": "a plastic surgery procedure for the stomach [n]\n",
  "ABDOMINOUS": "potbellied [adj]\n",
  "ABDUCE": "to draw or conduct away [v ABDUCED, ABDUCING, ABDUCES]\n",
  "ABDUCED": "ABDUCE, to draw or conduct away [v]\n",
  "ABDUCENS": "(Latin) a cranial nerve [n ABDUCENTES]\n",
  "ABDUCENT": "drawing back [adj]\n",
  "ABDUCENTES": "ABDUCENS, (Latin) a cranial nerve [n]\n",
  "ABDUCES": "ABDUCE, to draw or conduct away [v]\n",
  "ABDUCING": "ABDUCE, to draw or conduct away [v]\n",
  "ABDUCT": "to carry someone away with force; to kidnap [v -ED, -ING, -S]\n",
  "ABDUCTED": "ABDUCT, to carry someone away with force; to kidnap [v]\n",
  "ABDUCTEE": "one who is abducted [n -S]\n",
  "ABDUCTEES": "ABDUCTEE, one who is abducted [n]\n",
  "ABDUCTING": "ABDUCT, to carry someone away with force; to kidnap [v]\n",
  "ABDUCTION": "the act of abducing or abducting [n -S]\n",
  "ABDUCTIONS": "ABDUCTION, the act of abducing or abducting [n]\n",
  "ABDUCTOR": "a person who abducts [n -S]\n",
  "ABDUCTORES": "ABDUCTOR, a person who abducts [n]\n",
  "ABDUCTORS": "ABDUCTOR, a person who abducts [n]\n",
  "ABDUCTS": "ABDUCT, to carry someone away with force; to kidnap [v]\n",
  "ABEAM": "in a line at right angles to the length of a vessel, on the beam [adv]\n",
  "ABEAR": "to bear; to behave [v ABORE, ABORNE, ABEARING, ABEARS]\n",
  "ABEARING": "ABEAR, to bear; to behave [v]\n",
  "ABEARS": "ABEAR, to bear; to behave [v]\n",
  "ABECEDARIAN": "one learning the alphabet; one learning the rudiments of something [n -S]\n",
  "ABECEDARIANS": "ABECEDARIAN, one learning the alphabet; one learning the rudiments of something [n]\n",
  "ABED": "in bed [adv]\n",
  "ABEGGING": "in the process of begging [adj]\n",
  "ABEIGH": "(Scots) aloof [adv]\n",
  "ABELE": "(Dutch) the white poplar tree [n -S]\n",
  "ABELES": "ABELE, (Dutch) the white poplar tree [n]\n",
  "ABELIA": "any of several hardy evergreen shrubs of the honeysuckle family, native to eastern Asia, having pink or white flowers [n -S]\n",
  "ABELIAN": "a term in group theory designating a type of commutative group, having the property a x b = b x a [adj]\n",
  "ABELIAS": "ABELIA, any of several hardy evergreen shrubs of the honeysuckle family, native to eastern Asia, having pink or white flowers [n]\n",
  "ABELMOSK": "an evergreen shrub of the East and West Indies, whose musky seeds are used in perfumery and to flavor coffee [n -S]\n",
  "ABELMOSKS": "ABELMOSK, an evergreen shrub of the East and West Indies, whose musky seeds are used in perfumery and to flavor coffee [n]\n",
  "ABER": "(Welsh) an estuary [n -S]\n",
  "ABERDEVINE": "a bird-fancier's name for the siskin [n -S]\n",
  "ABERDEVINES": "ABERDEVINE, a bird-fancier's name for the siskin [n]\n",
  "ABERNETHIES": "ABERNETHY, a crisp unleavened biscuit invented by Dr John Abernethy of Scotland [n]\n",
  "ABERNETHY": "a crisp unleavened biscuit invented by Dr John Abernethy of Scotland [n ABERNETHIES]\n",
  "ABERRANCE": "the state of being aberrant; deviation from a norm, also ABERRANCY [n -S]\n",
  "ABERRANCES": "ABERRANCE, the state of being aberrant; deviation from a norm, also ABERRANCY [n]\n",
  "ABERRANCIES": "ABERRANCY, the state of being aberrant; deviation from a norm, also ABERRANCE [n]\n",
  "ABERRANCY": "the state of being aberrant; deviation from a norm, also ABERRANCE [n ABERRANCIES]\n",
  "ABERRANT": "wandering or straying [adj ABERRANTLY] / one who commits an aberration [n -S]\n",
  "ABERRANTLY": "ABERRANT, wandering or straying [adv]\n",
  "ABERRANTS": "ABERRANT, one who commits an aberration [n]\n",
  "ABERRATE": "to go astray, deviate [v ABERRATED, ABERRATING, ABERRATES]\n",
  "ABERRATED": "ABERRATE, to go astray, deviate [v]\n",
  "ABERRATES": "ABERRATE, to go astray, deviate [v]\n",
  "ABERRATING": "ABERRATE, to go astray, deviate [v]\n",
  "ABERRATION": "an instance of being aberrant [n -S]\n",
  "ABERRATIONAL": "given to aberration, aberrant [adj]\n",
  "ABERRATIONS": "ABERRATION, an instance of being aberrant [n]\n",
  "ABERS": "ABER, (Welsh) an estuary [n]\n",
  "ABESSIVE": "a grammatical case denoting absence or lack [n -S]\n",
  "ABESSIVES": "ABESSIVE, a grammatical case denoting absence or lack [n]\n",
  "ABET": "to incite by encouragement and support [v ABETTED, ABETTING, ABETS]\n",
  "ABETMENT": "the act of abetting, also ABETTAL [n -S]\n",
  "ABETMENTS": "ABETMENT, the act of abetting, also ABETTAL [n]\n",
  "ABETS": "ABET, to incite by encouragement and support [v]\n",
  "ABETTAL": "the act of abetting, also ABETMENT [n -S]\n",
  "ABETTALS": "ABETTAL, the act of abetting, also ABETMENT [n]\n",
  "ABETTED": "ABET, to incite by encouragement and support [v]\n",
  "ABETTER": "one who abets, also ABETTOR [n -S]\n",
  "ABETTERS": "ABETTER, one who abets, also ABETTOR [n]\n",
  "ABETTING": "ABET, to incite by encouragement and support [v]\n",
  "ABETTOR": "one who abets, also ABETTER [n -S]\n",
  "ABETTORS": "ABETTOR, one who abets, also ABETTER [n]\n",
  "ABEYANCE": "a state of suspension or temporary inactivity, also ABEYANCY [n -S]\n",
  "ABEYANCES": "ABEYANCE, a state of suspension or temporary inactivity, also ABEYANCY [n]\n",
  "ABEYANCIES": "ABEYANCY, a state of suspension or temporary inactivity, also ABEYANCE [n]\n",
  "ABEYANCY": "a state of suspension or temporary inactivity, also ABEYANCE [n ABEYANCIES]\n",
  "ABEYANT": "in abeyance, suspended [adj]\n",
  "ABFARAD": "a unit of capacitance, the ability to store an electric charge [n -S]\n",
  "ABFARADS": "ABFARAD, a unit of capacitance, the ability to store an electric charge [n]\n",
  "ABHENRIES": "ABHENRY, a unit of inductance, the property of inducing an electromotive force by variation of current in a circuit [n]\n",
  "ABHENRY": "a unit of inductance, the property of inducing an electromotive force by variation of current in a circuit [n ABHENRYS or ABHENRIES]\n",
  "ABHENRYS": "ABHENRY, a unit of inductance, the property of inducing an electromotive force by variation of current in a circuit [n]\n",
  "ABHOMINABLE": "hateful, detestable, also ABOMINABLE [adj]\n",
  "ABHOR": "to loathe, hate [v ABHORRED, ABHORRING, ABHORS]\n",
  "ABHORRED": "ABHOR, to loathe, hate [v]\n",
  "ABHORRENCE": "the act of abhorring, also ABHORRENCY [n -S]\n",
  "ABHORRENCES": "ABHORRENCE, the act of abhorring, also ABHORRENCY [n]\n",
  "ABHORRENCIES": "ABHORRENCY, (obsolete) the act of abhorring, also ABHORRENCE [n]\n",
  "ABHORRENCY": "(obsolete) the act of abhorring, also ABHORRENCE [n ABHORRENCIES]\n",
  "ABHORRENT": "loathsome [adj]\n",
  "ABHORRENTLY": "ABHORRENT, loathsome [adv]\n",
  "ABHORRER": "one who abhors [n -S]\n",
  "ABHORRERS": "ABHORRER, one who abhors [n]\n",
  "ABHORRING": "an object of abhorrence [n -S]\n",
  "ABHORRINGS": "ABHORRING, an object of abhorrence [n]\n",
  "ABHORS": "ABHOR, to loathe, hate [v]\n",
  "ABID": "ABIDE, to wait for; to stay, dwell [v]\n",
  "ABIDANCE": "the act of abiding [n -S]\n",
  "ABIDANCES": "ABIDANCE, the act of abiding [n]\n",
  "ABIDDEN": "ABIDE, to wait for; to stay, dwell [v]\n",
  "ABIDE": "to wait for; to stay, dwell [v ABID or ABODE or ABIDED, ABIDDEN, ABIDING, ABIDES]\n",
  "ABIDED": "ABIDE, to wait for; to stay, dwell [v]\n",
  "ABIDER": "one who abides, or continues [n -S]\n",
  "ABIDERS": "ABIDER, one who abides, or continues [n]\n",
  "ABIDES": "ABIDE, to wait for; to stay, dwell [v]\n",
  "ABIDING": "continual [adj ABIDINGLY] / a continuance [n -S]\n",
  "ABIDINGLY": "ABIDING, continual [adv]\n",
  "ABIDINGS": "ABIDING, a continuance [n]\n",
  "ABIES": "(Latin) a fir tree [n ABIETES]\n",
  "ABIETES": "ABIES, (Latin) a fir tree [n]\n",
  "ABIETIC": "as in abietic acid, a soap ingredient [adj]\n",
  "ABIGAIL": "(archaic) a lady's maid [n -S]\n",
  "ABIGAILS": "ABIGAIL, (archaic) a lady's maid [n]\n",
  "ABILITIES": "ABILITY, a special skill [n]\n",
  "ABILITY": "a special skill [n ABILITIES]\n",
  "ABIOGENESES": "ABIOGENESIS, the supposed spontaneous origination of living organisms directly from lifeless matter [n]\n",
  "ABIOGENESIS": "the supposed spontaneous origination of living organisms directly from lifeless matter [n ABIOGENESES]\n",
  "ABIOGENETIC": "relating to abiogenesis, the origination of life by nonliving matter, also ABIOGENIC [adj ABIOGENETICALLY]\n",
  "ABIOGENETICALLY": "ABIOGENETIC, relating to abiogenesis, the origination of life by nonliving matter, also ABIOGENIC [adv]\n",
  "ABIOGENIC": "relating to abiogenesis, the origination of life by nonliving matter, also ABIOGENETIC [adj ABIOGENICALLY]\n",
  "ABIOGENICALLY": "ABIOGENIC, relating to abiogenesis, the origination of life by nonliving matter, also ABIOGENETIC [adv]\n",
  "ABIOGENIST": "a believer in abiogenesis, the supposed spontaneous origination of living organisms directly from lifeless matter [n -S]\n",
  "ABIOGENISTS": "ABIOGENIST, a believer in abiogenesis, the supposed spontaneous origination of living organisms directly from lifeless matter [n]\n",
  "ABIOLOGICAL": "not involving living organisms [adj]\n",
  "ABIOSES": "ABIOSIS, (Greek) absence of life [n]\n",
  "ABIOSIS": "(Greek) absence of life [n ABIOSES]\n",
  "ABIOTIC": "devoid of or inimical to life [adj ABIOTICALLY]\n",
  "ABIOTICALLY": "ABIOTIC, devoid of or inimical to life [adv]\n",
  "ABIOTROPHIC": "relating to abiotrophy, bodily or mental loss of function or degeneration for reasons unknown [adj]\n",
  "ABIOTROPHIES": "ABIOTROPHY, bodily or mental loss of function or degeneration for reasons unknown [n]\n",
  "ABIOTROPHY": "bodily or mental loss of function or degeneration for reasons unknown [n ABIOTROPHIES]\n",
  "ABIRRITANT": "any drug or agent that relieves irritation [n -S]\n",
  "ABIRRITANTS": "ABIRRITANT, any drug or agent that relieves irritation [n]\n",
  "ABIRRITATE": "to soothe or make less irritable [v ABIRRITATED, ABIRRITATING, ABIRRITATES]\n",
  "ABIRRITATED": "ABIRRITATE, to soothe or make less irritable [v]\n",
  "ABIRRITATES": "ABIRRITATE, to soothe or make less irritable [v]\n",
  "ABIRRITATING": "ABIRRITATE, to soothe or make less irritable [v]\n",
  "ABITUR": "(German) in Germany, the final-year school examinations [n -S]\n",
  "ABITURIENT": "a pupil leaving school for university [n -S]\n",
  "ABITURIENTS": "ABITURIENT, a pupil leaving school for university [n]\n",
  "ABITURS": "ABITUR, (German) in Germany, the final-year school examinations [n]\n",
  "ABJECT": "humble; miserable; craven [adj ABJECTLY] / to throw out, cast away [v -ED, -ING, -S]\n",
  "ABJECTED": "ABJECT, to throw out, cast away [v]\n",
  "ABJECTING": "ABJECT, to throw out, cast away [v]\n",
  "ABJECTION": "the act of bringing down or humbling [n -S]\n",
  "ABJECTIONS": "ABJECTION, the act of bringing down or humbling [n]\n",
  "ABJECTLY": "ABJECT, humble; miserable; craven [adv]\n",
  "ABJECTNESS": "the state of being abject [n -ES]\n",
  "ABJECTNESSES": "ABJECTNESS, the state of being abject [n]\n",
  "ABJECTS": "ABJECT, to throw out, cast away [v]\n",
  "ABJOINT": "to cut off by forming a septum [v -ED, -ING, -S]\n",
  "ABJOINTED": "ABJOINT, to cut off by forming a septum [v]\n",
  "ABJOINTING": "ABJOINT, to cut off by forming a septum [v]\n",
  "ABJOINTS": "ABJOINT, to cut off by forming a septum [v]\n",
  "ABJUNCTION": "the act of abjointing, cutting off by forming a septum [n -S]\n",
  "ABJUNCTIONS": "ABJUNCTION, the act of abjointing, cutting off by forming a septum [n]\n",
  "ABJURATION": "the act of abjuring [n -S]\n",
  "ABJURATIONS": "ABJURATION, the act of abjuring [n]\n",
  "ABJURE": "to renounce under oath [v ABJURED, ABJURING, ABJURES]\n",
  "ABJURED": "ABJURE, to renounce under oath [v]\n",
  "ABJURER": "one who abjures [n -S]\n",
  "ABJURERS": "ABJURER, one who abjures [n]\n",
  "ABJURES": "ABJURE, to renounce under oath [v]\n",
  "ABJURING": "ABJURE, to renounce under oath [v]\n",
  "ABLACTATION": "the weaning of a child from its mother's milk [n -S]\n",
  "ABLACTATIONS": "ABLACTATION, the weaning of a child from its mother's milk [n]\n",
  "ABLATE": "to remove or decrease by ablation [v ABLATED, ABLATING, ABLATES]\n",
  "ABLATED": "ABLATE, to remove or decrease by ablation [v]\n",
  "ABLATES": "ABLATE, to remove or decrease by ablation [v]\n",
  "ABLATING": "ABLATE, to remove or decrease by ablation [v]\n",
  "ABLATION": "surgical removal of a bodily part [n -S]\n",
  "ABLATIONS": "ABLATION, surgical removal of a bodily part [n]\n",
  "ABLATITIOUS": "relating to ablation, surgical removal; decrease caused by melting [adj]\n",
  "ABLATIVAL": "relating to the ablative case [adj]\n",
  "ABLATIVE": "indicating direction from or time when [adj ABLATIVELY] / a grammatical case indicating direction from or time when [n -S]\n",
  "ABLATIVELY": "ABLATIVE, indicating direction from or time when [adv]\n",
  "ABLATIVES": "ABLATIVE, a grammatical case indicating direction from or time when [n]\n",
  "ABLATOR": "a substance undergoing ablation, e.g. in a heat-shield [n -S]\n",
  "ABLATORS": "ABLATOR, a substance undergoing ablation, e.g. in a heat-shield [n]\n",
  "ABLAUT": "(German) vowel change in related words, esp. that in Indo-European, which survives in English in e.g. sing, sang, sung, song [n -S]\n",
  "ABLAUTS": "ABLAUT, (German) vowel change in related words, esp. that in Indo-European, which survives in English in e.g. sing, sang, sung, song [n]\n",
  "ABLAZE": "on fire [adj]\n",
  "ABLE": "competent, also HABLE [adj ABLER, ABLEST, ABLY] / (obsolete) to enable [v ABLED, ABLING, ABLES]\n",
  "ABLED": "ABLE, (obsolete) to enable [v]\n",
  "ABLEGATE": "a papal envoy [n -S]\n",
  "ABLEGATES": "ABLEGATE, a papal envoy [n]\n",
  "ABLEISM": "discrimination against disabled people [n -S]\n",
  "ABLEISMS": "ABLEISM, discrimination against disabled people [n]\n",
  "ABLEIST": "discriminatory against disabled people [adj] / someone who discriminates against disabled people [n -S]\n",
  "ABLEISTS": "ABLEIST, someone who discriminates against disabled people [n]\n",
  "ABLER": "ABLE, competent, also HABLE [adj]\n",
  "ABLES": "ABLE, (obsolete) to enable [v]\n",
  "ABLEST": "ABLE, competent, also HABLE [adj]\n",
  "ABLET": "a small freshwater fish, aka bleak [n -S]\n",
  "ABLETS": "ABLET, a small freshwater fish, aka bleak [n]\n",
  "ABLING": "ABLE, (obsolete) to enable [v]\n",
  "ABLINGS": "(dialect) perhaps, also ABLINS, AIBLINS [adv]\n",
  "ABLINS": "(dialect) perhaps, also ABLINGS, AIBLINS [adv]\n",
  "ABLOOM": "blooming [adj]\n",
  "ABLOW": "in a blowing state [adv]\n",
  "ABLUENT": "a cleansing agent [n -S]\n",
  "ABLUENTS": "ABLUENT, a cleansing agent [n]\n",
  "ABLUSH": "blushing [adj]\n",
  "ABLUTED": "washed clean [adj]\n",
  "ABLUTION": "the act of washing one's body or part of it [n -S]\n",
  "ABLUTIONARY": "relating to the act of ablution [adj]\n",
  "ABLUTIONS": "ABLUTION, the act of washing one's body or part of it [n]\n",
  "ABLUTOMANE": "one obsessed with washing [n -S]\n",
  "ABLUTOMANES": "ABLUTOMANE, one obsessed with washing [n]\n",
  "ABLY": "ABLE, competent, also HABLE [adv]\n",
  "ABMHO": "a unit of electrical conductance [n -S]\n",
  "ABMHOS": "ABMHO, a unit of electrical conductance [n]\n",
  "ABNEGATE": "to renounce or repudiate [v ABNEGATED, ABNEGATING, ABNEGATES]\n",
  "ABNEGATED": "ABNEGATE, to renounce or repudiate [v]\n",
  "ABNEGATES": "ABNEGATE, to renounce or repudiate [v]\n",
  "ABNEGATING": "ABNEGATE, to renounce or repudiate [v]\n",
  "ABNEGATION": "an act of abnegating [n -S]\n",
  "ABNEGATIONS": "ABNEGATION, an act of abnegating [n]\n",
  "ABNEGATOR": "one who abnegates, renounce [n -S]\n",
  "ABNEGATORS": "ABNEGATOR, one who abnegates, renounce [n]\n",
  "ABNORMAL": "not normal [adj ABNORMALLY] / a mentally deficient person [n -S]\n",
  "ABNORMALISM": "the state of being abnormal [n -S]\n",
  "ABNORMALISMS": "ABNORMALISM, the state of being abnormal [n]\n",
  "ABNORMALITIES": "ABNORMALITY, the state of being abnormal, also ABNORMITY [n]\n",
  "ABNORMALITY": "the state of being abnormal, also ABNORMITY [n ABNORMALITIES]\n",
  "ABNORMALLY": "ABNORMAL, not normal [adv]\n",
  "ABNORMALS": "ABNORMAL, a mentally deficient person [n]\n",
  "ABNORMITIES": "ABNORMITY, a deviation from the norm (rule); an irregularity [n]\n",
  "ABNORMITY": "a deviation from the norm (rule); an irregularity [n ABNORMITIES]\n",
  "ABNORMOUS": "deviating from the norm (rule); abnormal; irregular [adj]\n",
  "ABO": "(offensive) (short for) an aborigine [n -S]\n",
  "ABOARD": "on board [adv]\n",
  "ABODE": "a dwelling-place [n -S] / to presage, forebode [v ABODED, ABODING, ABODES]\n",
  "ABODED": "ABODE, to presage, forebode [v]\n",
  "ABODEMENT": "(obsolete) a foreboding; an evil omen [n -S]\n",
  "ABODEMENTS": "ABODEMENT, (obsolete) a foreboding; an evil omen [n]\n",
  "ABODES": "ABODE, to presage, forebode [v]\n",
  "ABODING": "ABODE, to presage, forebode [v]\n",
  "ABOHM": "a unit of electrical resistance [n -S]\n",
  "ABOHMS": "ABOHM, a unit of electrical resistance [n]\n",
  "ABOIDEAU": "(French) a tide gate, also ABOITEAU [n ABOIDEAUS or ABOIDEAUX]\n",
  "ABOIDEAUS": "ABOIDEAU, (French) a tide gate, also ABOITEAU [n]\n",
  "ABOIDEAUX": "ABOIDEAU, (French) a tide gate, also ABOITEAU [n]\n",
  "ABOIL": "boiling [adj]\n",
  "ABOITEAU": "(French) a tide gate, also ABOIDEAU [n ABOITEAUS or ABOITEAUX]\n",
  "ABOITEAUS": "ABOITEAU, (French) a tide gate, also ABOIDEAU [n]\n",
  "ABOITEAUX": "ABOITEAU, (French) a tide gate, also ABOIDEAU [n]\n",
  "ABOLISH": "to put an end to [v -ED, -ING, -ES]\n",
  "ABOLISHABLE": "able to be abolished [adj]\n",
  "ABOLISHED": "ABOLISH, to put an end to [v]\n",
  "ABOLISHER": "one who abolishes [n -S]\n",
  "ABOLISHERS": "ABOLISHER, one who abolishes [n]\n",
  "ABOLISHES": "ABOLISH, to put an end to [v]\n",
  "ABOLISHING": "ABOLISH, to put an end to [v]\n",
  "ABOLISHMENT": "the act of abolishing [n -S]\n",
  "ABOLISHMENTS": "ABOLISHMENT, the act of abolishing [n]\n",
  "ABOLITION": "the act of doing away with [n -S]\n",
  "ABOLITIONAL": "relating to abolition, also ABOLITIONARY [adj]\n",
  "ABOLITIONARY": "relating to abolition, also ABOLITIONAL [adj]\n",
  "ABOLITIONISM": "principles or measures fostering abolition esp. of slavery [n -S]\n",
  "ABOLITIONISMS": "ABOLITIONISM, principles or measures fostering abolition esp. of slavery [n]\n",
  "ABOLITIONIST": "a supporter of abolitionism [n -S]\n",
  "ABOLITIONISTS": "ABOLITIONIST, a supporter of abolitionism [n]\n",
  "ABOLITIONS": "ABOLITION, the act of doing away with [n]\n",
  "ABOLLA": "(historical) a Roman military cloak [n ABOLLAS or ABOLLAE]\n",
  "ABOLLAE": "ABOLLA, (historical) a Roman military cloak [n]\n",
  "ABOLLAS": "ABOLLA, (historical) a Roman military cloak [n]\n",
  "ABOMA": "a South American snake [n -S]\n",
  "ABOMAS": "ABOMA, a South American snake [n]\n",
  "ABOMASA": "ABOMASUM, (Latin) the fourth stomach of a ruminant, also ABOMASUS [n]\n",
  "ABOMASAL": "relating to the abomasum, the fourth of the four stomachs of a ruminant [adj]\n",
  "ABOMASI": "ABOMASUS, (Latin) the fourth stomach of a ruminant, also ABOMASUM [n]\n",
  "ABOMASUM": "(Latin) the fourth stomach of a ruminant, also ABOMASUS [n ABOMASA]\n",
  "ABOMASUS": "(Latin) the fourth stomach of a ruminant, also ABOMASUM [n ABOMASI]\n",
  "ABOMINABLE": "hateful, detestable, also ABHOMINABLE [adj ABOMINABLY]\n",
  "ABOMINABLENESS": "the state of being abominable [n]\n",
  "ABOMINABLY": "ABOMINABLE, hateful, detestable, also ABHOMINABLE [adv]\n",
  "ABOMINATE": "to loathe [v ABOMINATED, ABOMINATING, ABOMINATES]\n",
  "ABOMINATED": "ABOMINATE, to loathe [v]\n",
  "ABOMINATES": "ABOMINATE, to loathe [v]\n",
  "ABOMINATING": "ABOMINATE, to loathe [v]\n",
  "ABOMINATION": "something abominable [n -S]\n",
  "ABOMINATIONS": "ABOMINATION, something abominable [n]\n",
  "ABOMINATOR": "one who abominates [n -S]\n",
  "ABOMINATORS": "ABOMINATOR, one who abominates [n]\n",
  "ABONDANCE": "a call in whist to make nine tricks, also ABUNDANCE [n -S]\n",
  "ABONDANCES": "ABONDANCE, a call in whist to make nine tricks, also ABUNDANCE [n]\n",
  "ABONNEMENT": "(French) a subscription, as for a season ticket or newspaper [n -S]\n",
  "ABONNEMENTS": "ABONNEMENT, (French) a subscription, as for a season ticket or newspaper [n]\n",
  "ABOON": "(Scots) above [adv]\n",
  "ABORAL": "away from the mouth [adj]\n",
  "ABORALLY": "away from the mouth [adv]\n",
  "ABORD": "(archaic) to accost, approach [v -ED, -ING, -S]\n",
  "ABORDED": "ABORD, (archaic) to accost, approach [v]\n",
  "ABORDING": "ABORD, (archaic) to accost, approach [v]\n",
  "ABORDS": "ABORD, (archaic) to accost, approach [v]\n",
  "ABORE": "ABEAR, to bear; to behave [v]\n",
  "ABORIGEN": "an original or native inhabitant of a country, also ABORIGIN, ABORIGINE [n -S]\n",
  "ABORIGENS": "ABORIGEN, an original or native inhabitant of a country, also ABORIGIN, ABORIGINE [n]\n",
  "ABORIGIN": "an original or native inhabitant of a country, also ABORIGEN, ABORIGINE [n -S]\n",
  "ABORIGINAL": "indigenous [adj ABORIGINALLY] / an aborigine [n -S]\n",
  "ABORIGINALISM": "due recognition of native peoples [n -S]\n",
  "ABORIGINALISMS": "ABORIGINALISM, due recognition of native peoples [n]\n",
  "ABORIGINALITIES": "ABORIGINALITY, the state of being aboriginal [n]\n",
  "ABORIGINALITY": "the state of being aboriginal [n ABORIGINALITIES]\n",
  "ABORIGINALLY": "ABORIGINAL, indigenous [adv]\n",
  "ABORIGINALS": "ABORIGINAL, an aborigine [n]\n",
  "ABORIGINE": "a member of the original (indigenous) population of a region, also ABORIGEN, ABORIGIN, ABORIGINAL [n -S]\n",
  "ABORIGINES": "ABORIGINE, a member of the original (indigenous) population of a region, also ABORIGEN, ABORIGIN, ABORIGINAL [n]\n",
  "ABORIGINS": "ABORIGIN, an original or native inhabitant of a country, also ABORIGEN, ABORIGINE [n]\n",
  "ABORNE": "ABEAR, to bear; to behave [v]\n",
  "ABORNING": "while being born [adv]\n",
  "ABORT": "to bring forth a foetus prematurely, to cause to come to nothing [v -ED, -ING, -S]\n",
  "ABORTED": "ABORT, to bring forth a foetus prematurely, to cause to come to nothing [v]\n",
  "ABORTEE": "a woman who has had an abortion [n -S]\n",
  "ABORTEES": "ABORTEE, a woman who has had an abortion [n]\n",
  "ABORTER": "one who aborts [n -S]\n",
  "ABORTERS": "ABORTER, one who aborts [n]\n",
  "ABORTICIDE": "the killing of a fetus; abortion [n -S]\n",
  "ABORTICIDES": "ABORTICIDE, the killing of a fetus; abortion [n]\n",
  "ABORTIFACIENT": "a drug used to induce an abortion [n -S]\n",
  "ABORTIFACIENTS": "ABORTIFACIENT, a drug used to induce an abortion [n]\n",
  "ABORTING": "ABORT, to bring forth a foetus prematurely, to cause to come to nothing [v]\n",
  "ABORTION": "the induced expulsion of a nonviable fetus [n -S]\n",
  "ABORTIONAL": "pertaining to abortion [adj]\n",
  "ABORTIONIST": "one who induces abortions [n -S]\n",
  "ABORTIONISTS": "ABORTIONIST, one who induces abortions [n]\n",
  "ABORTIONS": "ABORTION, the induced expulsion of a nonviable fetus [n]\n",
  "ABORTIVE": "failing to succeed [adj]\n",
  "ABORTIVELY": "ABORTIVE, failing to succeed [adv]\n",
  "ABORTIVENESS": "the state of being abortive [n -ES]\n",
  "ABORTIVENESSES": "ABORTIVENESS, the state of being abortive [n]\n",
  "ABORTS": "ABORT, to bring forth a foetus prematurely, to cause to come to nothing [v]\n",
  "ABORTUARIES": "ABORTUARY, an antiabortion term for an abortion clinic [n]\n",
  "ABORTUARY": "an antiabortion term for an abortion clinic [n ABORTUARIES]\n",
  "ABORTUS": "an aborted fetus [n -ES]\n",
  "ABORTUSES": "ABORTUS, an aborted fetus [n]\n",
  "ABOS": "ABO, (offensive) (short for) an aborigine [n]\n",
  "ABOUGHT": "ABYE, (archaic) to pay the penalty for, also ABY [v]\n",
  "ABOULIA": "(Greek) an abnormal lack of ability to act or to make decisions, also ABULIA [n -S]\n",
  "ABOULIAS": "ABOULIA, (Greek) an abnormal lack of ability to act or to make decisions, also ABULIA [n]\n",
  "ABOULIC": "relating to aboulia, loss of willpower, also ABULIC [adj]\n",
  "ABOUND": "to exist in great plenty [v -ED, -ING, -S]\n",
  "ABOUNDED": "ABOUND, to exist in great plenty [v]\n",
  "ABOUNDING": "ABOUND, to exist in great plenty [v]\n",
  "ABOUNDS": "ABOUND, to exist in great plenty [v]\n",
  "ABOUT": "approximately [adv]\n",
  "ABOUTS": "(Spenser) about [prep]\n",
  "ABOVE": "the upper part [n -S]\n",
  "ABOVEBOARD": "in a straightforward manner [adj]\n",
  "ABOVEGROUND": "located above the surface of the ground [adj]\n",
  "ABOVES": "ABOVE, the upper part [n]\n",
  "ABRACADABRA": "a magic word, used as a charm [n -S]\n",
  "ABRACADABRAS": "ABRACADABRA, a magic word, used as a charm [n]\n",
  "ABRACHIA": "a congenital lack of arms [n -S]\n",
  "ABRACHIAS": "ABRACHIA, a congenital lack of arms [n]\n",
  "ABRADABLE": "capable of being abraded (worn away by friction) [adj]\n",
  "ABRADANT": "a material used for grinding, as emery, sand, powdered glass, etc. [n -S]\n",
  "ABRADANTS": "ABRADANT, a material used for grinding, as emery, sand, powdered glass, etc. [n]\n",
  "ABRADE": "to wear away by friction [v ABRADED, ABRADING, ABRADES]\n",
  "ABRADED": "ABRADE, to wear away by friction [v]\n",
  "ABRADER": "a tool for abrading [n -S]\n",
  "ABRADERS": "ABRADER, a tool for abrading [n]\n",
  "ABRADES": "ABRADE, to wear away by friction [v]\n",
  "ABRADING": "ABRADE, to wear away by friction [v]\n",
  "ABRAID": "(Spenser) to awake, arouse [v -ED, -ING, -S]\n",
  "ABRAIDED": "ABRAID, (Spenser) to awake, arouse [v]\n",
  "ABRAIDING": "ABRAID, (Spenser) to awake, arouse [v]\n",
  "ABRAIDS": "ABRAID, (Spenser) to awake, arouse [v]\n",
  "ABRAM": "(Shakespeare) auburn [adj]\n",
  "ABRANCHIAL": "lacking gills, also ABRANCHIATE [adj]\n",
  "ABRANCHIATE": "lacking gills, also ABRANCHIAL [adj]\n",
  "ABRASAX": "a mystic word, also ABRAXAS [n -ES]\n",
  "ABRASAXES": "ABRASAX, a mystic word, also ABRAXAS [n]\n",
  "ABRASION": "a graze on the skin [n -S]\n",
  "ABRASIONS": "ABRASION, a graze on the skin [n]\n",
  "ABRASIVE": "capable of grinding away another material [adj ABRASIVELY] / an abrasive substance [n -S]\n",
  "ABRASIVELY": "ABRASIVE, capable of grinding away another material [adv]\n",
  "ABRASIVENESS": "the quality of being abrasive [n -ES]\n",
  "ABRASIVENESSES": "ABRASIVENESS, the quality of being abrasive [n]\n",
  "ABRASIVES": "ABRASIVE, an abrasive substance [n]\n",
  "ABRAXAS": "a gem engraved with a mystical word and bearing a human-animal figure, also ABRASAX [n -ES]\n",
  "ABRAXASES": "ABRAXAS, a gem engraved with a mystical word and bearing a human-animal figure, also ABRASAX [n]\n",
  "ABRAY": "(Spenser) to awake, arouse, also ABRAID [v -ED, -ING, -S]\n",
  "ABRAYED": "ABRAY, (Spenser) to awake, arouse, also ABRAID [v]\n",
  "ABRAYING": "ABRAY, (Spenser) to awake, arouse, also ABRAID [v]\n",
  "ABRAYS": "ABRAY, (Spenser) to awake, arouse, also ABRAID [v]\n",
  "ABRAZO": "(Spanish) in Latin America, an embrace, used in greeting someone [n -S]\n",
  "ABRAZOS": "ABRAZO, (Spanish) in Latin America, an embrace, used in greeting someone [n]\n",
  "ABREACT": "to resolve a neurosis by reviving forgotten or repressed ideas of the event first causing it [v -ED, -ING, -S]\n",
  "ABREACTED": "ABREACT, to resolve a neurosis by reviving forgotten or repressed ideas of the event first causing it [v]\n",
  "ABREACTING": "ABREACT, to resolve a neurosis by reviving forgotten or repressed ideas of the event first causing it [v]\n",
  "ABREACTION": "the resolution of a neurosis by reviving forgotten or repressed ideas of the event first causing it [n -S]\n",
  "ABREACTIONS": "ABREACTION, the resolution of a neurosis by reviving forgotten or repressed ideas of the event first causing it [n]\n",
  "ABREACTIVE": "relating to abreaction, the resolution of a neurosis by reviving forgotten or repressed ideas of the event first causing it [adj]\n",
  "ABREACTS": "ABREACT, to resolve a neurosis by reviving forgotten or repressed ideas of the event first causing it [v]\n",
  "ABREAST": "side by side [adv]\n",
  "ABREGE": "(French) an abridgement [n -S]\n",
  "ABREGES": "ABREGE, (French) an abridgement [n]\n",
  "ABRI": "(French) a bomb shelter [n -S]\n",
  "ABRICOCK": "(obsolete) an apricot, also APRICOCK [n -S]\n",
  "ABRICOCKS": "ABRICOCK, (obsolete) an apricot, also APRICOCK [n]\n",
  "ABRIDGABLE": "that can abridged, also ABRIDGEABLE [adj]\n",
  "ABRIDGE": "to shorten [v ABRIDGED, ABRIDGING, ABRIDGES]\n",
  "ABRIDGEABLE": "that can abridged, also ABRIDGABLE [adj]\n",
  "ABRIDGED": "ABRIDGE, to shorten [v]\n",
  "ABRIDGEMENT": "the act of abridging, also ABRIDGMENT [n -S]\n",
  "ABRIDGEMENTS": "ABRIDGEMENT, the act of abridging, also ABRIDGMENT [n]\n",
  "ABRIDGER": "one who abridges [n -S]\n",
  "ABRIDGERS": "ABRIDGER, one who abridges [n]\n",
  "ABRIDGES": "ABRIDGE, to shorten [v]\n",
  "ABRIDGING": "ABRIDGE, to shorten [v]\n",
  "ABRIDGMENT": "the act of abridging, also ABRIDGEMENT [n -S]\n",
  "ABRIDGMENTS": "ABRIDGMENT, the act of abridging, also ABRIDGEMENT [n]\n",
  "ABRIM": "in a brimming state [adv]\n",
  "ABRIN": "a poisonous protein present in the jequirity bean [n -S]\n",
  "ABRINS": "ABRIN, a poisonous protein present in the jequirity bean [n]\n",
  "ABRIS": "ABRI, (French) a bomb shelter [n]\n",
  "ABROACH": "(obsolete) open, in a condition to allow liquor to run out [adv]\n",
  "ABROAD": "in or to a foreign country [adv] / a place abroad [n -S]\n",
  "ABROADS": "ABROAD, a place abroad [n]\n",
  "ABROGABLE": "that can be abrogated [adj]\n",
  "ABROGATE": "to repeal (a law, custom, etc.); to abolish authoritatively or formally [v ABROGATED, ABROGATING, ABROGATES]\n",
  "ABROGATED": "ABROGATE, to repeal (a law, custom, etc.); to abolish authoritatively or formally [v]\n",
  "ABROGATES": "ABROGATE, to repeal (a law, custom, etc.); to abolish authoritatively or formally [v]\n",
  "ABROGATING": "ABROGATE, to repeal (a law, custom, etc.); to abolish authoritatively or formally [v]\n",
  "ABROGATION": "the act of abrogating, formally annulling [n -S]\n",
  "ABROGATIONS": "ABROGATION, the act of abrogating, formally annulling [n]\n",
  "ABROGATIVE": "relating to annulment [adj]\n",
  "ABROGATOR": "one who abrogates, abolishes authoritatively or formally [n -S]\n",
  "ABROGATORS": "ABROGATOR, one who abrogates, abolishes authoritatively or formally [n]\n",
  "ABROOKE": "an erroneous spelling of Shakespeare's \"abrook\" (to brook; to tolerate or endure) found in late 20th century editions of Chambers [v ABROOKED, ABROOKING, ABROOKES]\n",
  "ABROOKED": "ABROOKE, an erroneous spelling of Shakespeare's \"abrook\" (to brook; to tolerate or endure) found in late 20th century editions of Chambers [v]\n",
  "ABROOKES": "ABROOKE, an erroneous spelling of Shakespeare's \"abrook\" (to brook; to tolerate or endure) found in late 20th century editions of Chambers [v]\n",
  "ABROOKING": "ABROOKE, an erroneous spelling of Shakespeare's \"abrook\" (to brook; to tolerate or endure) found in late 20th century editions of Chambers [v]\n",
  "ABROSIA": "fasting [n -S]\n",
  "ABROSIAS": "ABROSIA, fasting [n]\n",
  "ABRUPT": "sudden [adj ABRUPTER, ABRUPTEST, ABRUPTLY] / (Milton) an abyss [n -S]\n",
  "ABRUPTER": "ABRUPT, sudden [adj]\n",
  "ABRUPTEST": "ABRUPT, sudden [adj]\n",
  "ABRUPTION": "a sudden, violent separation [n -S]\n",
  "ABRUPTIONS": "ABRUPTION, a sudden, violent separation [n]\n",
  "ABRUPTLY": "ABRUPT, sudden [adv]\n",
  "ABRUPTNESS": "the quality of being abrupt [n -ES]\n",
  "ABRUPTNESSES": "ABRUPTNESS, the quality of being abrupt [n]\n",
  "ABRUPTS": "ABRUPT, (Milton) an abyss [n]\n",
  "ABS": "AB, an abdominal muscle [n]\n",
  "ABSCESS": "a collection of pus in a cavity, usually causing an inflamed swelling [n -ES] / to form an abscess [v -ED, -ING, -ES]\n",
  "ABSCESSED": "ABSCESS, to form an abscess [v]\n",
  "ABSCESSES": "ABSCESS, to form an abscess [v]\n",
  "ABSCESSING": "ABSCESS, to form an abscess [v]\n",
  "ABSCIND": "to cut off [v -ED, -ING, -S]\n",
  "ABSCINDED": "ABSCIND, to cut off [v]\n",
  "ABSCINDING": "ABSCIND, to cut off [v]\n",
  "ABSCINDS": "ABSCIND, to cut off [v]\n",
  "ABSCISE": "to cut off, to fall off by abscission [v ABSCISED, ABSCISING, ABSCISES]\n",
  "ABSCISED": "ABSCISE, to cut off, to fall off by abscission [v]\n",
  "ABSCISES": "ABSCISE, to cut off, to fall off by abscission [v]\n",
  "ABSCISIC": "as in abscisic acid, a type of acid that causes abscission [adj]\n",
  "ABSCISIN": "abscisic acid, a plant hormone which triggers the fall of autumn leaves in certain trees, also ABSCISSIN, DORMIN [n -S]\n",
  "ABSCISING": "ABSCISE, to cut off, to fall off by abscission [v]\n",
  "ABSCISINS": "ABSCISIN, abscisic acid, a plant hormone which triggers the fall of autumn leaves in certain trees, also ABSCISSIN, DORMIN [n]\n",
  "ABSCISS": "the distance of a point from the y-axis measured parallel to the x-axis, also ABSCISSA, ABSCISSE [n -ES]\n",
  "ABSCISSA": "(Latin) the distance of a point from the y-axis measured parallel to the x-axis, also ABSCISS, ABSCISSE [n ABSCISSAE or ABSCISSAS]\n",
  "ABSCISSAE": "ABSCISSA, (Latin) the distance of a point from the y-axis measured parallel to the x-axis, also ABSCISS, ABSCISSE [n]\n",
  "ABSCISSAS": "ABSCISSA, (Latin) the distance of a point from the y-axis measured parallel to the x-axis, also ABSCISS, ABSCISSE [n]\n",
  "ABSCISSE": "the distance of a point from the y-axis measured parallel to the x-axis, also ABSCISS, ABSCISSA [n -S]\n",
  "ABSCISSES": "ABSCISS, the distance of a point from the y-axis measured parallel to the x-axis, also ABSCISSA, ABSCISSE [n]\n",
  "ABSCISSIN": "abscisic acid, a plant hormone which triggers the fall of autumn leaves in certain trees, also ABSCISIN, DORMIN [n -S]\n",
  "ABSCISSINS": "ABSCISSIN, abscisic acid, a plant hormone which triggers the fall of autumn leaves in certain trees, also ABSCISIN, DORMIN [n]\n",
  "ABSCISSION": "the act of cutting off [n -S]\n",
  "ABSCISSIONS": "ABSCISSION, the act of cutting off [n]\n",
  "ABSCOND": "to depart suddenly and secretly [v -ED, -ING, -S]\n",
  "ABSCONDED": "ABSCOND, to depart suddenly and secretly [v]\n",
  "ABSCONDENCE": "the act of absconding [n -S]\n",
  "ABSCONDENCES": "ABSCONDENCE, the act of absconding [n]\n",
  "ABSCONDER": "one who absconds [n -S]\n",
  "ABSCONDERS": "ABSCONDER, one who absconds [n]\n",
  "ABSCONDING": "the act of departing suddenly and secretly [n -S]\n",
  "ABSCONDINGS": "ABSCONDING, the act of departing suddenly and secretly [n]\n",
  "ABSCONDS": "ABSCOND, to depart suddenly and secretly [v]\n",
  "ABSEIL": "(German) to descend a rock face using a double rope, to rappel [v -ED, -ING, -S]\n",
  "ABSEILED": "ABSEIL, (German) to descend a rock face using a double rope, to rappel [v]\n",
  "ABSEILER": "one that abseils [n -S]\n",
  "ABSEILERS": "ABSEILER, one that abseils [n]\n",
  "ABSEILING": "the act or sport of descending on a rope [n -S]\n",
  "ABSEILINGS": "ABSEILING, the act or sport of descending on a rope [n]\n",
  "ABSEILS": "ABSEIL, (German) to descend a rock face using a double rope, to rappel [v]\n",
  "ABSENCE": "the state of being away [n -S]\n",
  "ABSENCES": "ABSENCE, the state of being away [n]\n",
  "ABSENT": "not present [adj ABSENTLY] / to take or keep away [v -ED, -ING, -S]\n",
  "ABSENTED": "ABSENT, to take or keep away [v]\n",
  "ABSENTEE": "one who is not present [n -S]\n",
  "ABSENTEEISM": "prolonged absence of an owner from his or her property [n -S]\n",
  "ABSENTEEISMS": "ABSENTEEISM, prolonged absence of an owner from his or her property [n]\n",
  "ABSENTEES": "ABSENTEE, one who is not present [n]\n",
  "ABSENTER": "one who keeps away [n -S]\n",
  "ABSENTERS": "ABSENTER, one who keeps away [n]\n",
  "ABSENTING": "ABSENT, to take or keep away [v]\n",
  "ABSENTLY": "ABSENT, not present [adv]\n",
  "ABSENTMINDED": "lost in thought and unaware of one's surroundings or actions [adj ABSENTMINDEDLY]\n",
  "ABSENTMINDEDLY": "ABSENTMINDED [adv]\n",
  "ABSENTS": "ABSENT, to take or keep away [v]\n",
  "ABSEY": "(obsolete) the alphabet, also ABCEE [n -S]\n",
  "ABSEYS": "ABSEY, (obsolete) the alphabet, also ABCEE [n]\n",
  "ABSINTH": "(French) the wormwood plant or other species of Artemisia; a liqueur made from this, also ABSINTHE [n -S]\n",
  "ABSINTHE": "(French) the wormwood plant or other species of Artemisia; a liqueur made from this, also ABSINTH [n -S]\n",
  "ABSINTHES": "ABSINTHE, (French) the wormwood plant or other species of Artemisia; a liqueur made from this, also ABSINTH [n]\n",
  "ABSINTHIATED": "impregnated with absinth [adj]\n",
  "ABSINTHISM": "a disease resembling alcoholism [n -S]\n",
  "ABSINTHISMS": "ABSINTHISM, a disease resembling alcoholism [n]\n",
  "ABSINTHS": "ABSINTH, (French) the wormwood plant or other species of Artemisia; a liqueur made from this, also ABSINTHE [n]\n",
  "ABSIT": "(Latin) a student's leave to pass one night away from college [n -S]\n",
  "ABSITS": "ABSIT, (Latin) a student's leave to pass one night away from college [n]\n",
  "ABSOLUTE": "unconditional, fundamental [adj ABSOLUTER, ABSOLUTEST, ABSOLUTELY] / something unconditional [n -S]\n",
  "ABSOLUTELY": "ABSOLUTE, unconditional, fundamental [adv]\n",
  "ABSOLUTENESS": "the state of being absolute [n -ES]\n",
  "ABSOLUTENESSES": "ABSOLUTENESS, the state of being absolute [n]\n",
  "ABSOLUTER": "ABSOLUTE, unconditional, fundamental [adj]\n",
  "ABSOLUTES": "ABSOLUTE, something unconditional [n]\n",
  "ABSOLUTEST": "ABSOLUTE, unconditional, fundamental [adj]\n",
  "ABSOLUTION": "remission of sins, declared officially by a priest [n -S]\n",
  "ABSOLUTIONS": "ABSOLUTION, remission of sins, declared officially by a priest [n]\n",
  "ABSOLUTISE": "to make absolute, also ABSOLUTIZE [v ABSOLUTISED, ABSOLUTISING, ABSOLUTISES]\n",
  "ABSOLUTISED": "ABSOLUTISE, to make absolute, also ABSOLUTIZE [v]\n",
  "ABSOLUTISES": "ABSOLUTISE, to make absolute, also ABSOLUTIZE [v]\n",
  "ABSOLUTISING": "ABSOLUTISE, to make absolute, also ABSOLUTIZE [v]\n",
  "ABSOLUTISM": "the doctrine of government by a single absolute ruler [n -S]\n",
  "ABSOLUTISMS": "ABSOLUTISM, the doctrine of government by a single absolute ruler [n]\n",
  "ABSOLUTIST": "one who believes in absolutism [n -S]\n",
  "ABSOLUTISTIC": "relating to absolutism [adj]\n",
  "ABSOLUTISTS": "ABSOLUTIST, one who believes in absolutism [n]\n",
  "ABSOLUTIVE": "a grammatical case [n -S]\n",
  "ABSOLUTIVES": "ABSOLUTIVE, a grammatical case [n]\n",
  "ABSOLUTIZE": "to make absolute [v ABSOLUTIZED, ABSOLUTIZING, ABSOLUTIZES]\n",
  "ABSOLUTIZED": "ABSOLUTIZE, to make absolute [v]\n",
  "ABSOLUTIZES": "ABSOLUTIZE, to make absolute [v]\n",
  "ABSOLUTIZING": "ABSOLUTIZE, to make absolute [v]\n",
  "ABSOLUTORY": "forgiving or absolving [adj]\n",
  "ABSOLVABLE": "capable of being absolved [adj]\n",
  "ABSOLVE": "to free from the consequences of an action [v ABSOLVED, ABSOLVING, ABSOLVES]\n",
  "ABSOLVED": "ABSOLVE, to free from the consequences of an action [v]\n",
  "ABSOLVENT": "something that absolves [n -S]\n",
  "ABSOLVENTS": "ABSOLVENT, something that absolves [n]\n",
  "ABSOLVER": "one who absolves [n -S]\n",
  "ABSOLVERS": "ABSOLVER, one who absolves [n]\n",
  "ABSOLVES": "ABSOLVE, to free from the consequences of an action [v]\n",
  "ABSOLVING": "ABSOLVE, to free from the consequences of an action [v]\n",
  "ABSOLVITOR": "in Scots law, a judgment favourable to a defender [n -S]\n",
  "ABSOLVITORS": "ABSOLVITOR, in Scots law, a judgment favourable to a defender [n]\n",
  "ABSONANT": "discordant; abhorrent [adj]\n",
  "ABSORB": "to take up or in [v -ED, -ING, -S]\n",
  "ABSORBABILITIES": "ABSORBABILITY, the ability to be absorbed [n]\n",
  "ABSORBABILITY": "the ability to be absorbed [n ABSORBABILITIES]\n",
  "ABSORBABLE": "that can be absorbed [adj]\n",
  "ABSORBANCE": "the ability of a substance to absorb radiation [n -S]\n",
  "ABSORBANCES": "ABSORBANCE, the ability of a substance to absorb radiation [n]\n",
  "ABSORBANCIES": "ABSORBANCY, the state of being absorbent, also ABSORBENCY [n]\n",
  "ABSORBANCY": "the state of being absorbent, also ABSORBENCY [n ABSORBANCIES]\n",
  "ABSORBANT": "able to absorb [adj] / an absorbant substance, also ABSORBENT [n -S]\n",
  "ABSORBANTS": "ABSORBANT, an absorbant substance, also ABSORBENT [n]\n",
  "ABSORBATE": "an absorbed substance [n -S]\n",
  "ABSORBATES": "ABSORBATE, an absorbed substance [n]\n",
  "ABSORBED": "ABSORB, to take up or in [v]\n",
  "ABSORBEDLY": "ABSORBED, ABSORB, to take up or in [adv]\n",
  "ABSORBEFACIENT": "an agent causing or promoting absorption [n -S]\n",
  "ABSORBEFACIENTS": "ABSORBEFACIENT, an agent causing or promoting absorption [n]\n",
  "ABSORBENCIES": "ABSORBENCY, the state of being absorbent, also ABSORBANCY [n]\n",
  "ABSORBENCY": "the state of being absorbent, also ABSORBANCY [n ABSORBENCIES]\n",
  "ABSORBENT": "able to absorb [adj] / an absorbent substance, also ABSORBANT [n -S]\n",
  "ABSORBENTS": "ABSORBENT, an absorbent substance, also ABSORBANT [n]\n",
  "ABSORBER": "something that absorbs [n -S]\n",
  "ABSORBERS": "ABSORBER, something that absorbs [n]\n",
  "ABSORBING": "ABSORB, to take up or in [v]\n",
  "ABSORBINGLY": "ABSORBING, ABSORB, to take up or in [adv]\n",
  "ABSORBS": "ABSORB, to take up or in [v]\n",
  "ABSORPTANCE": "the ratio of the radiant flux absorbed by a body to that incident on it [n -S]\n",
  "ABSORPTANCES": "ABSORPTANCE, the ratio of the radiant flux absorbed by a body to that incident on it [n]\n",
  "ABSORPTIOMETER": "an instrument for measuring the solubility of gases in liquids [n -S]\n",
  "ABSORPTIOMETERS": "ABSORPTIOMETER, an instrument for measuring the solubility of gases in liquids [n]\n",
  "ABSORPTION": "the process of absorbing [n -S]\n",
  "ABSORPTIONS": "ABSORPTION, the process of absorbing [n]\n",
  "ABSORPTIVE": "capable of absorbing [adj]\n",
  "ABSORPTIVENESS": "the state of being absorptive, also ABSORPTIVITY [n]\n",
  "ABSORPTIVITIES": "ABSORPTIVITY, the property of a body that determines absorptance, also ABSORPTIVENESS [n]\n",
  "ABSORPTIVITY": "the property of a body that determines absorptance, also ABSORPTIVENESS [n ABSORPTIVITIES]\n",
  "ABSQUATULATE": "to decamp [v ABSQUATULATED, ABSQUATULATING, ABSQUATULATES]\n",
  "ABSQUATULATED": "ABSQUATULATE, to decamp [v]\n",
  "ABSQUATULATES": "ABSQUATULATE, to decamp [v]\n",
  "ABSQUATULATING": "ABSQUATULATE, to decamp [v]\n",
  "ABSTAIN": "to refrain deliberately and often with an effort of self-denial from an action or practice [v -ED, -ING, -S]\n",
  "ABSTAINED": "ABSTAIN, to refrain deliberately and often with an effort of self-denial from an action or practice [v]\n",
  "ABSTAINER": "one who abstains [n -S]\n",
  "ABSTAINERS": "ABSTAINER, one who abstains [n]\n",
  "ABSTAINING": "ABSTAIN, to refrain deliberately and often with an effort of self-denial from an action or practice [v]\n",
  "ABSTAINS": "ABSTAIN, to refrain deliberately and often with an effort of self-denial from an action or practice [v]\n",
  "ABSTEMIOUS": "sparing, esp. in matters of eating and drinking [adj ABSTEMIOUSLY]\n",
  "ABSTEMIOUSLY": "ABSTEMIOUS, sparing, esp. in matters of eating and drinking [adv]\n",
  "ABSTEMIOUSNESS": "the quality of being abstemious [n]\n",
  "ABSTENTION": "the act of abstaining [n -S]\n",
  "ABSTENTIONISM": "the policy of not using one's vote, esp. in a political election [n -S]\n",
  "ABSTENTIONISMS": "ABSTENTIONISM, the policy of not using one's vote, esp. in a political election [n]\n",
  "ABSTENTIONIST": "a believer in abstentionism [n -S]\n",
  "ABSTENTIONISTS": "ABSTENTIONIST, a believer in abstentionism [n]\n",
  "ABSTENTIONS": "ABSTENTION, the act of abstaining [n]\n",
  "ABSTENTIOUS": "given to abstaining [adj]\n",
  "ABSTERGE": "to cleanse by wiping [v ABSTERGED, ABSTERGING, ABSTERGES]\n",
  "ABSTERGED": "ABSTERGE, to cleanse by wiping [v]\n",
  "ABSTERGENT": "serving to cleanse, detergent [adj] / an abstergent substance [n -S]\n",
  "ABSTERGENTS": "ABSTERGENT, an abstergent substance [n]\n",
  "ABSTERGES": "ABSTERGE, to cleanse by wiping [v]\n",
  "ABSTERGING": "ABSTERGE, to cleanse by wiping [v]\n",
  "ABSTERSION": "the act of wiping clean; a cleansing; a purging [n -S]\n",
  "ABSTERSIONS": "ABSTERSION, the act of wiping clean; a cleansing; a purging [n]\n",
  "ABSTERSIVE": "serving to cleanse or purge [adj] / an abstersive substance [n -S]\n",
  "ABSTERSIVES": "ABSTERSIVE, an abstersive substance [n]\n",
  "ABSTINENCE": "voluntary forbearance esp. from indulgence of an appetite, also ABSTINENCY [n -S]\n",
  "ABSTINENCES": "ABSTINENCE, voluntary forbearance esp. from indulgence of an appetite, also ABSTINENCY [n]\n",
  "ABSTINENCIES": "ABSTINENCY, voluntary forbearance esp. from indulgence of an appetite, also ABSTINENCE [n]\n",
  "ABSTINENCY": "voluntary forbearance esp. from indulgence of an appetite, also ABSTINENCE [n ABSTINENCIES]\n",
  "ABSTINENT": "tending to abstain, esp. from alcohol [adj]\n",
  "ABSTINENTLY": "ABSTINENT, tending to abstain, esp. from alcohol [adv]\n",
  "ABSTRACT": "to draw away [v -ED, -ING, -S] / difficult to understand [adj ABSTRACTER, ABSTRACTEST, ABSTRACTLY]\n",
  "ABSTRACTABLE": "capable of being abstracted [adj]\n",
  "ABSTRACTED": "ABSTRACT, to draw away [v]\n",
  "ABSTRACTEDLY": "ABSTRACTED, ABSTRACT, to draw away [adv]\n",
  "ABSTRACTEDNESS": "the state of being abstracted [n]\n",
  "ABSTRACTER": "one who abstracts or makes an abstract [n -S]\n",
  "ABSTRACTERS": "ABSTRACTER, one who abstracts or makes an abstract [n]\n",
  "ABSTRACTEST": "ABSTRACT, difficult to understand [adj]\n",
  "ABSTRACTING": "ABSTRACT, to draw away [v]\n",
  "ABSTRACTION": "the act of abstracting [n -S]\n",
  "ABSTRACTIONAL": "relating to abstraction [adj]\n",
  "ABSTRACTIONISM": "the principles or practice of creating abstract art [n -S]\n",
  "ABSTRACTIONISMS": "ABSTRACTIONISM, the principles or practice of creating abstract art [n]\n",
  "ABSTRACTIONIST": "a practitioner of abstractionism [n -S]\n",
  "ABSTRACTIONISTS": "ABSTRACTIONIST, a practitioner of abstractionism [n]\n",
  "ABSTRACTIONS": "ABSTRACTION, the act of abstracting [n]\n",
  "ABSTRACTIVE": "able or tending to abstract [adj ABSTRACTIVELY] / anything abstractive [n -S]\n",
  "ABSTRACTIVELY": "ABSTRACTIVE, able or tending to abstract [adv]\n",
  "ABSTRACTIVES": "ABSTRACTIVE, anything abstractive [n]\n",
  "ABSTRACTLY": "ABSTRACT, difficult to understand [adv]\n",
  "ABSTRACTNESS": "the quality of being abstract [n -ES]\n",
  "ABSTRACTNESSES": "ABSTRACTNESS, the quality of being abstract [n]\n",
  "ABSTRACTOR": "one who abstracts, also ABSTRACTER [n -S]\n",
  "ABSTRACTORS": "ABSTRACTOR, one who abstracts, also ABSTRACTER [n]\n",
  "ABSTRACTS": "ABSTRACT, to draw away [v]\n",
  "ABSTRICT": "to set free spores etc. by constriction of the stalk [v -ED, -ING, -S]\n",
  "ABSTRICTED": "ABSTRICT, to set free spores etc. by constriction of the stalk [v]\n",
  "ABSTRICTING": "ABSTRICT, to set free spores etc. by constriction of the stalk [v]\n",
  "ABSTRICTION": "the act of abstricting [n -S]\n",
  "ABSTRICTIONS": "ABSTRICTION, the act of abstricting [n]\n",
  "ABSTRICTS": "ABSTRICT, to set free spores etc. by constriction of the stalk [v]\n",
  "ABSTRUSE": "difficult to understand [adj ABSTRUSER, ABSTRUSEST, ABSTRUSELY]\n",
  "ABSTRUSELY": "ABSTRUSE, difficult to understand [adv]\n",
  "ABSTRUSENESS": "the state of being abstruse [n -ES]\n",
  "ABSTRUSENESSES": "ABSTRUSENESS, the state of being abstruse [n]\n",
  "ABSTRUSER": "ABSTRUSE, difficult to understand [adj]\n",
  "ABSTRUSEST": "ABSTRUSE, difficult to understand [adj]\n",
  "ABSTRUSITIES": "ABSTRUSITY, the state of being abstruse [n]\n",
  "ABSTRUSITY": "the state of being abstruse [n ABSTRUSITIES]\n",
  "ABSURD": "the condition of man's existence in an irrational universe [n -S] / ridiculous [adj ABSURDER, ABSURDEST, ABSURDLY]\n",
  "ABSURDER": "ABSURD, ridiculous [adj]\n",
  "ABSURDEST": "ABSURD, ridiculous [adj]\n",
  "ABSURDISM": "the doctrine that we live in an irrational universe [n -S]\n",
  "ABSURDISMS": "ABSURDISM, the doctrine that we live in an irrational universe [n]\n",
  "ABSURDIST": "a person holding the doctrine of absurdism [n -S]\n",
  "ABSURDISTS": "ABSURDIST, a person holding the doctrine of absurdism [n]\n",
  "ABSURDITIES": "ABSURDITY, the quality of being absurd [n]\n",
  "ABSURDITY": "the quality of being absurd [n ABSURDITIES]\n",
  "ABSURDLY": "ABSURD, ridiculous [adv]\n",
  "ABSURDNESS": "the state of being absurd [n -ES]\n",
  "ABSURDNESSES": "ABSURDNESS, the state of being absurd [n]\n",
  "ABSURDS": "ABSURD, the condition of man's existence in an irrational universe [n]\n",
  "ABTHANE": "a monastic region of the old Irish church [n -S]\n",
  "ABTHANES": "ABTHANE, a monastic region of the old Irish church [n]\n",
  "ABUBBLE": "bubbling [adj]\n",
  "ABUILDING": "in the process of being built [adv]\n",
  "ABULIA": "(Greek) abnormal lack of ability to act or to make decisions, also ABOULIA [n -S]\n",
  "ABULIAS": "ABULIA, (Greek) abnormal lack of ability to act or to make decisions, also ABOULIA [n]\n",
  "ABULIC": "pertaining to loss of willpower [adj]\n",
  "ABUNA": "(Amharic) an Ethiopian patriarch [n -S]\n",
  "ABUNAS": "ABUNA, (Amharic) an Ethiopian patriarch [n]\n",
  "ABUNDANCE": "the state of being abundant, also ABUNDANCY [n -S]\n",
  "ABUNDANCES": "ABUNDANCE, the state of being abundant, also ABUNDANCY [n]\n",
  "ABUNDANCIES": "ABUNDANCY, the state of being abundant, also ABUNDANCE [n]\n",
  "ABUNDANCY": "the state of being abundant, also ABUNDANCE [n ABUNDANCIES]\n",
  "ABUNDANT": "in great quantity [adj ABUNDANTLY]\n",
  "ABUNDANTLY": "ABUNDANT, in great quantity [adv]\n",
  "ABUNE": "(Scots) above, also ABOON [prep]\n",
  "ABURST": "in a bursting condition [adv]\n",
  "ABUSABLE": "able to be abused [adj]\n",
  "ABUSAGE": "improper or incorrect use esp. of language [n -S]\n",
  "ABUSAGES": "ABUSAGE, improper or incorrect use esp. of language [n]\n",
  "ABUSE": "to revile or swear at; to use wrongly [v ABUSED, ABUSING, ABUSES]\n",
  "ABUSED": "ABUSE, to revile or swear at; to use wrongly [v]\n",
  "ABUSER": "one who abuses [n -S]\n",
  "ABUSERS": "ABUSER, one who abuses [n]\n",
  "ABUSES": "ABUSE, to revile or swear at; to use wrongly [v]\n",
  "ABUSING": "ABUSE, to revile or swear at; to use wrongly [v]\n",
  "ABUSION": "(Spenser) misuse, deception [n -S]\n",
  "ABUSIONS": "ABUSION, (Spenser) misuse, deception [n]\n",
  "ABUSIVE": "in the manner of wrong or improper use [adj ABUSIVELY]\n",
  "ABUSIVELY": "ABUSIVE, in the manner of wrong or improper use [adv]\n",
  "ABUSIVENESS": "the quality of being abusive [n -ES]\n",
  "ABUSIVENESSES": "ABUSIVENESS, the quality of being abusive [n]\n",
  "ABUT": "to be adjacent to and touching [v ABUTTED, ABUTTING, ABUTS]\n",
  "ABUTILON": "(Arabic) a flowering plant of the mallow family [n -S]\n",
  "ABUTILONS": "ABUTILON, (Arabic) a flowering plant of the mallow family [n]\n",
  "ABUTMENT": "a buttress of an arch, also BUTMENT [n -S]\n",
  "ABUTMENTS": "ABUTMENT, a buttress of an arch, also BUTMENT [n]\n",
  "ABUTS": "ABUT, to be adjacent to and touching [v]\n",
  "ABUTTAL": "the butting or boundary of land, particularly at the end [n -S]\n",
  "ABUTTALS": "ABUTTAL, the butting or boundary of land, particularly at the end [n]\n",
  "ABUTTED": "ABUT, to be adjacent to and touching [v]\n",
  "ABUTTER": "a person whose property abuts [n -S]\n",
  "ABUTTERS": "ABUTTER, a person whose property abuts [n]\n",
  "ABUTTING": "ABUT, to be adjacent to and touching [v]\n",
  "ABUZZ": "buzzing [adj]\n",
  "ABVOLT": "a unit of electrical potential equal to one hundred millionth of a volt [n -S]\n",
  "ABVOLTS": "ABVOLT, a unit of electrical potential equal to one hundred millionth of a volt [n]\n",
  "ABWATT": "a unit of power [n -S]\n",
  "ABWATTS": "ABWATT, a unit of power [n]\n",
  "ABY": "(archaic) to pay the penalty, also ABYE [v ABOUGHT, ABYING, ABYS]\n",
  "ABYE": "(archaic) to pay the penalty for, also ABY [v ABOUGHT, ABYEING, ABYES]\n",
  "ABYEING": "ABYE, (archaic) to pay the penalty for, also ABY [v]\n",
  "ABYES": "ABYE, (archaic) to pay the penalty for, also ABY [v]\n",
  "ABYING": "ABY, (archaic) to pay the penalty, also ABYE [v]\n",
  "ABYS": "ABY, (archaic) to pay the penalty, also ABYE [v]\n",
  "ABYSM": "(archaic) an abyss, a bottomless chasm [n -S]\n",
  "ABYSMAL": "immeasurably deep [adj ABYSMALLY]\n",
  "ABYSMALLY": "ABYSMAL, immeasurably deep [adv]\n",
  "ABYSMS": "ABYSM, (archaic) an abyss, a bottomless chasm [n]\n",
  "ABYSS": "a bottomless chasm [n -ES]\n",
  "ABYSSAL": "relating to a large area of extremely flat ocean floor lying near a continent and generally over 4 km in depth [adj]\n",
  "ABYSSES": "ABYSS, a bottomless chasm [n]\n",
  "ABYSSOPELAGIC": "pertaining to the deepest regions of the ocean [adj]\n",
  "ACACIA": "a genus of thorny leguminous trees and shrubs, found esp. in arid regions of Australia and tropical Africa [n -S]\n",
  "ACACIAS": "ACACIA, a genus of thorny leguminous trees and shrubs, found esp. in arid regions of Australia and tropical Africa [n]\n",
  "ACADEME": "the academic life or world, also ACADEMIA [n -S]\n",
  "ACADEMES": "ACADEME, the academic life or world, also ACADEMIA [n]\n",
  "ACADEMIA": "(Greek) the academic life or world, also ACADEME [n -S]\n",
  "ACADEMIAS": "ACADEMIA, (Greek) the academic life or world, also ACADEME [n]\n",
  "ACADEMIC": "relating to learning, also ACADEMICAL [adj ACADEMICALLY] / a college student or teacher [n -S]\n",
  "ACADEMICAL": "related to learning, also ACADEMIC [adj ACADEMICALLY] / a college student or teacher [n -S]\n",
  "ACADEMICALISM": "close adherence to formal academic teaching [n -S]\n",
  "ACADEMICALISMS": "ACADEMICALISM, close adherence to formal academic teaching [n]\n",
  "ACADEMICALLY": "ACADEMICAL, related to learning, also ACADEMIC [adv]\n",
  "ACADEMICALS": "ACADEMICAL, a college student or teacher [n]\n",
  "ACADEMICIAN": "a member of an academy [n -S]\n",
  "ACADEMICIANS": "ACADEMICIAN, a member of an academy [n]\n",
  "ACADEMICISM": "the doctrine that nothing can be known [n -S]\n",
  "ACADEMICISMS": "ACADEMICISM, the doctrine that nothing can be known [n]\n",
  "ACADEMICS": "ACADEMIC, a college student or teacher [n]\n",
  "ACADEMIES": "ACADEMY, a secondary school [n]\n",
  "ACADEMISM": "the doctrines of the Academic philosophy [n -S]\n",
  "ACADEMISMS": "ACADEMISM, the doctrines of the Academic philosophy [n]\n",
  "ACADEMIST": "a person belonging to an academy or society [n -S]\n",
  "ACADEMISTS": "ACADEMIST, a person belonging to an academy or society [n]\n",
  "ACADEMY": "a secondary school [n ACADEMIES]\n",
  "ACAI": "(Tupi) a berry found in the Brazilian rainforest, aka palm berry, also ASSAI [n -S]\n",
  "ACAIS": "ACAI, (Tupi) a berry found in the Brazilian rainforest, aka palm berry, also ASSAI [n]\n",
  "ACAJOU": "(Tupi) the cashew tree; also, its fruit [n -S]\n",
  "ACAJOUS": "ACAJOU, (Tupi) the cashew tree; also, its fruit [n]\n",
  "ACALCULIA": "an inability to do simple mathematical calculations, also DYSCALCULIA [n -S]\n",
  "ACALCULIAS": "ACALCULIA, an inability to do simple mathematical calculations, also DYSCALCULIA [n]\n",
  "ACALEPH": "(Greek) any cnidarian (jellyfish), also ACALEPHAN, ACALEPHE [n -S]\n",
  "ACALEPHAE": "all cnidarians (jellyfishes) collectively [n]\n",
  "ACALEPHAN": "any cnidarian (a jellyfish), also ACALEPH, ACALEPHE [n -S]\n",
  "ACALEPHANS": "ACALEPHAN, any cnidarian (a jellyfish), also ACALEPH, ACALEPHE [n]\n",
  "ACALEPHE": "(Greek) any cnidarian (a jellyfish), also ACALEPH, ACALEPHAN [n -S]\n",
  "ACALEPHES": "ACALEPHE, (Greek) any cnidarian (a jellyfish), also ACALEPH, ACALEPHAN [n]\n",
  "ACALEPHS": "ACALEPH, (Greek) any cnidarian (jellyfish), also ACALEPHAN, ACALEPHE [n]\n",
  "ACANACEOUS": "bearing prickles or thorns [adj]\n",
  "ACANTH": "a prickly plant with toothed leaves, also ACANTHUS, ACANTHA [n -S]\n",
  "ACANTHA": "(Greek) a sharp spiny part or structure, such as the spinous process of a vertebra [n ACANTHAS or ACANTHAE]\n",
  "ACANTHACEOUS": "prickly; of the Acanthaceae [adj]\n",
  "ACANTHAE": "ACANTHA, (Greek) a sharp spiny part or structure, such as the spinous process of a vertebra [n]\n",
  "ACANTHAS": "ACANTHA, (Greek) a sharp spiny part or structure, such as the spinous process of a vertebra [n]\n",
  "ACANTHI": "ACANTHUS, a prickly plant with toothed leaves, also ACANTH, ACANTHA [n]\n",
  "ACANTHIN": "a deposit within the skeletons of tiny animals [n -S]\n",
  "ACANTHINE": "of, pertaining to, or resembling, the plant acanthus [adj]\n",
  "ACANTHINS": "ACANTHIN, a deposit within the skeletons of tiny animals [n]\n",
  "ACANTHOCEPHALAN": "belonging to the Acanthocephala, a division of parasitic worms with spiny proboscis [adj]\n",
  "ACANTHOID": "spine-shaped [adj]\n",
  "ACANTHOUS": "spiny, prickly [adj]\n",
  "ACANTHS": "ACANTH, a prickly plant with toothed leaves, also ACANTHUS, ACANTHA [n]\n",
  "ACANTHUS": "a prickly plant with toothed leaves, also ACANTH, ACANTHA [n ACANTHUSES or ACANTHI]\n",
  "ACANTHUSES": "ACANTHUS, a prickly plant with toothed leaves, also ACANTH, ACANTHA [n]\n",
  "ACAPNIA": "a lack of carbon dioxide [n -S]\n",
  "ACAPNIAS": "ACAPNIA, a lack of carbon dioxide [n]\n",
  "ACARBOSE": "a drug for treating diabetes [n -S]\n",
  "ACARBOSES": "ACARBOSE, a drug for treating diabetes [n]\n",
  "ACARI": "ACARUS, (Latin) a mite, a kind of small arachnid [n]\n",
  "ACARIAN": "pertaining to mites, small arachnids [adj]\n",
  "ACARIASES": "ACARIASIS, an irritating itching insect infestation [n]\n",
  "ACARIASIS": "an irritating itching insect infestation [n ACARIASES]\n",
  "ACARICIDAL": "relating to an acaricide, a substance that kills mites and ticks [adj]\n",
  "ACARICIDE": "a substance that kills mites and ticks [n -S]\n",
  "ACARICIDES": "ACARICIDE, a substance that kills mites and ticks [n]\n",
  "ACARID": "a member of the mite or tick family, also ACARIDAN, ACARINE, ACARUS [n -S]\n",
  "ACARIDAN": "relating to the Acarida, mites and ticks [adj] / a mite or tick, also ACARID, ACARINE, ACARUS [n -S]\n",
  "ACARIDANS": "ACARIDAN, a mite or tick, also ACARID, ACARINE, ACARUS [n]\n",
  "ACARIDEAN": "relating to the Acarida, mites and ticks [adj] / a mite or tick, also ACARIDIAN [n -S]\n",
  "ACARIDEANS": "ACARIDEAN, a mite or tick, also ACARIDIAN [n]\n",
  "ACARIDIAN": "relating to the Acarida, mites and ticks [adj] / a mite or tick, also ACARIDEAN [n -S]\n",
  "ACARIDIANS": "ACARIDIAN, a mite or tick, also ACARIDEAN [n]\n",
  "ACARIDOMATIA": "ACARIDOMATIUM, a habitat for mites provided by certain plants that benefit from their presence, also ACARODOMATIUM [n]\n",
  "ACARIDOMATIUM": "a habitat for mites provided by certain plants that benefit from their presence, also ACARODOMATIUM [n ACARIDOMATIA]\n",
  "ACARIDS": "ACARID, a member of the mite or tick family, also ACARIDAN, ACARINE, ACARUS [n]\n",
  "ACARINE": "a tick-like animal, also ACARID, ACARIDAN [n -S]\n",
  "ACARINES": "ACARINE, a tick-like animal, also ACARID, ACARIDAN [n]\n",
  "ACARODOMATIA": "ACARODOMATIUM, a habitat for mites provided by certain plants that benefit from their presence, also ACARIDOMATIUM [n]\n",
  "ACARODOMATIUM": "a habitat for mites provided by certain plants that benefit from their presence, also ACARIDOMATIUM [n ACARODOMATIA]\n",
  "ACAROID": "resembling an acarid, a mite [adj]\n",
  "ACAROLOGIES": "ACAROLOGY, the study of mites [n]\n",
  "ACAROLOGIST": "a practitioner of acarology, the study of mites [n -S]\n",
  "ACAROLOGISTS": "ACAROLOGIST, a practitioner of acarology, the study of mites [n]\n",
  "ACAROLOGY": "the study of mites [n ACAROLOGIES]\n",
  "ACAROPHILIES": "ACAROPHILY, the symbiotic association of plants with mites [n]\n",
  "ACAROPHILY": "the symbiotic association of plants with mites [n ACAROPHILIES]\n",
  "ACARPELLOUS": "having no carpels, also ACARPELOUS [adj]\n",
  "ACARPELOUS": "(US) having no carpels, also ACARPELLOUS [adj]\n",
  "ACARPOUS": "not bearing fruit [adj]\n",
  "ACARUS": "(Latin) a mite, a kind of small arachnid [n ACARI]\n",
  "ACATALECTIC": "having a complete or full number of syllables [adj] / a poetic line having a complete number of syllables [n -S]\n",
  "ACATALECTICS": "ACATALECTIC, a poetic line having a complete number of syllables [n]\n",
  "ACATALEPSIES": "ACATALEPSY, the sceptic doctrine that knowledge cannot be certain [n]\n",
  "ACATALEPSY": "the sceptic doctrine that knowledge cannot be certain [n ACATALEPSIES]\n",
  "ACATALEPTIC": "a person who suspends judgment in the belief that certainty is impossible [n -S]\n",
  "ACATALEPTICS": "ACATALEPTIC, a person who suspends judgment in the belief that certainty is impossible [n]\n",
  "ACATAMATHESIA": "the inability to understand data presented to the senses [n -S]\n",
  "ACATAMATHESIAS": "ACATAMATHESIA, the inability to understand data presented to the senses [n]\n",
  "ACATER": "(obsolete) an officer who buys provisions; a chandler, also ACATOUR [n -S]\n",
  "ACATERS": "ACATER, (obsolete) an officer who buys provisions; a chandler, also ACATOUR [n]\n",
  "ACATES": "(obsolete) things purchased; provisions not made in the house; dainties, also ACHATES [n]\n",
  "ACATHISIA": "a psychological condition characterised by agitation and a frequent desire to alter the posture, also AKATHISIA [n -S]\n",
  "ACATHISIAS": "ACATHISIA, a psychological condition characterised by agitation and a frequent desire to alter the posture, also AKATHISIA [n]\n",
  "ACATOUR": "(obsolete) an officer who buys provisions; a chandler, also ACATER [n -S]\n",
  "ACATOURS": "ACATOUR, (obsolete) an officer who buys provisions; a chandler, also ACATER [n]\n",
  "ACAUDAL": "tailless, also ACAUDATE [adj]\n",
  "ACAUDATE": "tailless, also ACAUDAL [adj]\n",
  "ACAULESCENT": "having a very short stem [adj]\n",
  "ACAULINE": "having a very short stem, also ACAULOSE, ACAULOUS [adj]\n",
  "ACAULOSE": "having a very short stem, also ACAULINE, ACAULOUS [adj]\n",
  "ACAULOUS": "having a very short stem, also ACAULINE, ACAULOSE [adj]\n",
  "ACCA": "(Australian slang) an academic, also ACKER [n -S]\n",
  "ACCABLE": "(French) depressed, overwhelmed [adj]\n",
  "ACCAS": "ACCA, (Australian slang) an academic, also ACKER [n]\n",
  "ACCEDE": "to consent [v ACCEDED, ACCEDING, ACCEDES]\n",
  "ACCEDED": "ACCEDE, to consent [v]\n",
  "ACCEDENCE": "the act of acceding [n -S]\n",
  "ACCEDENCES": "ACCEDENCE, the act of acceding [n]\n",
  "ACCEDER": "one who accedes [n -S]\n",
  "ACCEDERS": "ACCEDER, one who accedes [n]\n",
  "ACCEDES": "ACCEDE, to consent [v]\n",
  "ACCEDING": "ACCEDE, to consent [v]\n",
  "ACCELERABLE": "that can be accelerated [adj]\n",
  "ACCELERANDO": "(Italian) getting quicker [adj] / a musical piece that gets quicker [n -S]\n",
  "ACCELERANDOS": "ACCELERANDO, a musical piece that gets quicker [n]\n",
  "ACCELERANT": "an accelerating agent [n -S]\n",
  "ACCELERANTS": "ACCELERANT, an accelerating agent [n]\n",
  "ACCELERATE": "to bring about at an earlier time [v ACCELERATED, ACCELERATING, ACCELERATES]\n",
  "ACCELERATED": "ACCELERATE, to bring about at an earlier time [v]\n",
  "ACCELERATES": "ACCELERATE, to bring about at an earlier time [v]\n",
  "ACCELERATING": "ACCELERATE, to bring about at an earlier time [v]\n",
  "ACCELERATINGLY": "ACCELERATING, ACCELERATE, to bring about at an earlier time [adv]\n",
  "ACCELERATION": "the rate at which velocity changes, either by increasing or decreasing [n -S]\n",
  "ACCELERATIONS": "ACCELERATION, the rate at which velocity changes, either by increasing or decreasing [n]\n",
  "ACCELERATIVE": "tending to cause acceleration, also ACCELERATORY [adj]\n",
  "ACCELERATOR": "something that accelerates [n -S]\n",
  "ACCELERATORS": "ACCELERATOR, something that accelerates [n]\n",
  "ACCELERATORY": "tending to cause acceleration, also ACCELERATIVE [adj]\n",
  "ACCELEROMETER": "an instrument for measuring acceleration or vibrations [n -S]\n",
  "ACCELEROMETERS": "ACCELEROMETER, an instrument for measuring acceleration or vibrations [n]\n",
  "ACCEND": "(obsolete) to kindle [v -ED, -ING, -S]\n",
  "ACCENDED": "ACCEND, (obsolete) to kindle [v]\n",
  "ACCENDING": "ACCEND, (obsolete) to kindle [v]\n",
  "ACCENDS": "ACCEND, (obsolete) to kindle [v]\n",
  "ACCENSION": "the act of kindling or the state of being kindled [n -S]\n",
  "ACCENSIONS": "ACCENSION, the act of kindling or the state of being kindled [n]\n",
  "ACCENT": "to pronounce with prominence [v -ED, -ING, -S]\n",
  "ACCENTED": "ACCENT, to pronounce with prominence [v]\n",
  "ACCENTING": "ACCENT, to pronounce with prominence [v]\n",
  "ACCENTLESS": "without an accent [adj]\n",
  "ACCENTOR": "a song bird [n -S]\n",
  "ACCENTORS": "ACCENTOR, a song bird [n]\n",
  "ACCENTS": "ACCENT, to pronounce with prominence [v]\n",
  "ACCENTUAL": "of or pertaining to accent [adj]\n",
  "ACCENTUALITIES": "ACCENTUALITY, the quality of having an accent [n]\n",
  "ACCENTUALITY": "the quality of having an accent [n ACCENTUALITIES]\n",
  "ACCENTUALLY": "ACCENTUAL, of or pertaining to accent [adv]\n",
  "ACCENTUATE": "to emphasize [v ACCENTUATED, ACCENTUATING, ACCENTUATES]\n",
  "ACCENTUATED": "ACCENTUATE, to emphasize [v]\n",
  "ACCENTUATES": "ACCENTUATE, to emphasize [v]\n",
  "ACCENTUATING": "ACCENTUATE, to emphasize [v]\n",
  "ACCENTUATION": "an instance of accentuating [n -S]\n",
  "ACCENTUATIONS": "ACCENTUATION, an instance of accentuating [n]\n",
  "ACCEPT": "to receive with favour [v -ED, -ING, -S]\n",
  "ACCEPTABILITIES": "ACCEPTABILITY, the state of being acceptable [n]\n",
  "ACCEPTABILITY": "the state of being acceptable [n ACCEPTABILITIES]\n",
  "ACCEPTABLE": "that can be accepted [adj ACCEPTABLY]\n",
  "ACCEPTABLENESS": "the quality of being acceptable [n]\n",
  "ACCEPTABLY": "ACCEPTABLE, that can be accepted [adv]\n",
  "ACCEPTANCE": "the act of accepting, also ACCEPTANCY [n -S]\n",
  "ACCEPTANCES": "ACCEPTANCE, the act of accepting, also ACCEPTANCY [n]\n",
  "ACCEPTANCIES": "ACCEPTANCY, the act of accepting, also ACCEPTANCE [n]\n",
  "ACCEPTANCY": "the act of accepting, also ACCEPTANCE [n ACCEPTANCIES]\n",
  "ACCEPTANT": "one who accepts [n -S]\n",
  "ACCEPTANTS": "ACCEPTANT, one who accepts [n]\n",
  "ACCEPTATION": "a kind reception; the sense in which a word, etc., is understood [n -S]\n",
  "ACCEPTATIONS": "ACCEPTATION, a kind reception; the sense in which a word, etc., is understood [n]\n",
  "ACCEPTED": "ACCEPT, to receive with favour [v]\n",
  "ACCEPTEDLY": "ACCEPTED, ACCEPT, to receive with favour [adv]\n",
  "ACCEPTEE": "one who is accepted [n -S]\n",
  "ACCEPTEES": "ACCEPTEE, one who is accepted [n]\n",
  "ACCEPTER": "a person who accepts, also ACCEPTOR [n -S]\n",
  "ACCEPTERS": "ACCEPTER, a person who accepts, also ACCEPTOR [n]\n",
  "ACCEPTILATION": "the remission of a debt without payment or by accepting a nominal payment only [n -S]\n",
  "ACCEPTILATIONS": "ACCEPTILATION, the remission of a debt without payment or by accepting a nominal payment only [n]\n",
  "ACCEPTING": "ACCEPT, to receive with favour [v]\n",
  "ACCEPTINGLY": "ACCEPTING, ACCEPT, to receive with favour [adv]\n",
  "ACCEPTINGNESS": "the state of being accepting [n -ES]\n",
  "ACCEPTINGNESSES": "ACCEPTINGNESS, the state of being accepting [n]\n",
  "ACCEPTIVE": "ready to receive [adj]\n",
  "ACCEPTIVITIES": "ACCEPTIVITY, the state of being acceptive, ready to receive [n]\n",
  "ACCEPTIVITY": "the state of being acceptive, ready to receive [n ACCEPTIVITIES]\n",
  "ACCEPTOR": "someone who accepts something [n -S]\n",
  "ACCEPTORS": "ACCEPTOR, someone who accepts something [n]\n",
  "ACCEPTS": "ACCEPT, to receive with favour [v]\n",
  "ACCESS": "approach, admittance [n -ES] / to have entrance to [v -ED, -ING, -ES]\n",
  "ACCESSARIES": "ACCESSARY, something accompanying [n]\n",
  "ACCESSARILY": "ACCESSARY, accompanying, as a subordinate, also ACCESSORY [adv]\n",
  "ACCESSARINESS": "the state of being accessary [n -ES]\n",
  "ACCESSARINESSES": "ACCESSARINESS, the state of being accessary [n]\n",
  "ACCESSARY": "accompanying, as a subordinate, also ACCESSORY [adj ACCESSARILY] / something accompanying [n ACCESSARIES]\n",
  "ACCESSED": "ACCESS, to have entrance to [v]\n",
  "ACCESSES": "ACCESS, to have entrance to [v]\n",
  "ACCESSIBILITIES": "ACCESSIBILITY, the ability to reach a place with respect to another place [n]\n",
  "ACCESSIBILITY": "the ability to reach a place with respect to another place [n ACCESSIBILITIES]\n",
  "ACCESSIBLE": "able to be accessed [adj ACCESSIBLY]\n",
  "ACCESSIBLENESS": "the state of being accessible [n]\n",
  "ACCESSIBLY": "ACCESSIBLE, able to be accessed [adv]\n",
  "ACCESSING": "ACCESS, to have entrance to [v]\n",
  "ACCESSION": "the act of acceding and becoming joined [n -S] / to record the addition of (a book etc.) to a library [v -ED, -ING, -S]\n",
  "ACCESSIONAL": "relating to accession [adj]\n",
  "ACCESSIONED": "ACCESSION, to record the addition of (a book etc.) to a library [v]\n",
  "ACCESSIONING": "ACCESSION, to record the addition of (a book etc.) to a library [v]\n",
  "ACCESSIONS": "ACCESSION, to record the addition of (a book etc.) to a library [v]\n",
  "ACCESSORIAL": "having the nature of an accessory [adj]\n",
  "ACCESSORIES": "ACCESSORY, something accompanying [n]\n",
  "ACCESSORII": "ACCESSORIUS, a muscle or nerve that has an augmenting action [n]\n",
  "ACCESSORILY": "ACCESSORY, accompanying, as a subordinate; additional, also ACCESSARY [adv]\n",
  "ACCESSORINESS": "the state of being accessory [n -ES]\n",
  "ACCESSORINESSES": "ACCESSORINESS, the state of being accessory [n]\n",
  "ACCESSORISE": "to furnish with accessories, also ACCESSORIZE [v ACCESSORISED, ACCESSORISING, ACCESSORISES]\n",
  "ACCESSORISED": "ACCESSORISE, to furnish with accessories, also ACCESSORIZE [v]\n",
  "ACCESSORISES": "ACCESSORISE, to furnish with accessories, also ACCESSORIZE [v]\n",
  "ACCESSORISING": "ACCESSORISE, to furnish with accessories, also ACCESSORIZE [v]\n",
  "ACCESSORIUS": "a muscle or nerve that has an augmenting action [n ACCESSORII]\n",
  "ACCESSORIZE": "to furnish with accessories, also ACCESSORISE [v ACCESSORIZED, ACCESSORIZING, ACCESSORIZES]\n",
  "ACCESSORIZED": "ACCESSORIZE, to furnish with accessories, also ACCESSORISE [v]\n",
  "ACCESSORIZES": "ACCESSORIZE, to furnish with accessories, also ACCESSORISE [v]\n",
  "ACCESSORIZING": "ACCESSORIZE, to furnish with accessories, also ACCESSORISE [v]\n",
  "ACCESSORY": "accompanying, as a subordinate; additional, also ACCESSARY [adj ACCESSORILY] / something accompanying [n ACCESSORIES]\n",
  "ACCIACCATURA": "(Italian) a grace-note performed quickly before an essential note of a melody [n ACCIACCATURAS or ACCIACCATURE]\n",
  "ACCIACCATURAS": "ACCIACCATURA, (Italian) a grace-note performed quickly before an essential note of a melody [n]\n",
  "ACCIACCATURE": "ACCIACCATURA, (Italian) a grace-note performed quickly before an essential note of a melody [n]\n",
  "ACCIDENCE": "the science of inflections in grammar [n -S]\n",
  "ACCIDENCES": "ACCIDENCE, the science of inflections in grammar [n]\n",
  "ACCIDENT": "a mishap [n -S]\n",
  "ACCIDENTAL": "by accident [adj ACCIDENTALLY] / a nonessential property [n -S]\n",
  "ACCIDENTALISM": "the theory that events do not have causes [n -S]\n",
  "ACCIDENTALISMS": "ACCIDENTALISM, the theory that events do not have causes [n]\n",
  "ACCIDENTALITIES": "ACCIDENTALITY, the quality of being accidental [n]\n",
  "ACCIDENTALITY": "the quality of being accidental [n ACCIDENTALITIES]\n",
  "ACCIDENTALLY": "ACCIDENTAL, by accident [adv]\n",
  "ACCIDENTALNESS": "the quality of being accidental [n]\n",
  "ACCIDENTALS": "ACCIDENTAL, a nonessential property [n]\n",
  "ACCIDENTED": "uneven, varied [adj]\n",
  "ACCIDENTLY": "by chance [adv]\n",
  "ACCIDENTOLOGIES": "ACCIDENTOLOGY, the study of accidents [n]\n",
  "ACCIDENTOLOGY": "the study of accidents [n ACCIDENTOLOGIES]\n",
  "ACCIDENTS": "ACCIDENT, a mishap [n]\n",
  "ACCIDIA": "(Latin) sloth; physical torpor, also ACCIDIE, ACEDIA [n -S]\n",
  "ACCIDIAS": "ACCIDIA, (Latin) sloth; physical torpor, also ACCIDIE, ACEDIA [n]\n",
  "ACCIDIE": "(Latin) sloth, physical torpor, also ACCIDIA, ACEDIA [n -S]\n",
  "ACCIDIES": "ACCIDIE, (Latin) sloth, physical torpor, also ACCIDIA, ACEDIA [n]\n",
  "ACCINGE": "to gird up one's loins, apply oneself [v ACCINGED, ACCINGING, ACCINGES]\n",
  "ACCINGED": "ACCINGE, to gird up one's loins, apply oneself [v]\n",
  "ACCINGES": "ACCINGE, to gird up one's loins, apply oneself [v]\n",
  "ACCINGING": "ACCINGE, to gird up one's loins, apply oneself [v]\n",
  "ACCIPITER": "(Latin) a bird belonging to the Accipiter genus of hawks [n -S]\n",
  "ACCIPITERS": "ACCIPITER, (Latin) a bird belonging to the Accipiter genus of hawks [n]\n",
  "ACCIPITRAL": "like an accipiter, a bird belonging to the Accipiter genus of hawks [adj]\n",
  "ACCIPITRINE": "relating to the bird family Accipitridae, which includes hawks [adj] / a member of the hawk family [n -S]\n",
  "ACCIPITRINES": "ACCIPITRINE, a member of the hawk family [n]\n",
  "ACCITE": "to cite; to summon [v ACCITED, ACCITING, ACCITES]\n",
  "ACCITED": "ACCITE, to cite; to summon [v]\n",
  "ACCITES": "ACCITE, to cite; to summon [v]\n",
  "ACCITING": "ACCITE, to cite; to summon [v]\n",
  "ACCLAIM": "to shout approval of [v -ED, -ING, -S]\n",
  "ACCLAIMED": "ACCLAIM, to shout approval of [v]\n",
  "ACCLAIMER": "one who acclaims [n -S]\n",
  "ACCLAIMERS": "ACCLAIMER, one who acclaims [n]\n",
  "ACCLAIMING": "ACCLAIM, to shout approval of [v]\n",
  "ACCLAIMS": "ACCLAIM, to shout approval of [v]\n",
  "ACCLAMATION": "a shout of approval [n -S]\n",
  "ACCLAMATIONS": "ACCLAMATION, a shout of approval [n]\n",
  "ACCLAMATORY": "expressing acclamation [adj]\n",
  "ACCLIMATABLE": "that can be acclimated [adj]\n",
  "ACCLIMATATION": "acclimatization [n -S]\n",
  "ACCLIMATATIONS": "ACCLIMATATION, acclimatization [n]\n",
  "ACCLIMATE": "(US) to habituate to a climate not native, also ACCLIMATIZE [v ACCLIMATED, ACCLIMATING, ACCLIMATES]\n",
  "ACCLIMATED": "ACCLIMATE, (US) to habituate to a climate not native, also ACCLIMATIZE [v]\n",
  "ACCLIMATES": "ACCLIMATE, (US) to habituate to a climate not native, also ACCLIMATIZE [v]\n",
  "ACCLIMATING": "ACCLIMATE, (US) to habituate to a climate not native, also ACCLIMATIZE [v]\n",
  "ACCLIMATION": "the act of acclimating [n -S]\n",
  "ACCLIMATIONS": "ACCLIMATION, the act of acclimating [n]\n",
  "ACCLIMATISABLE": "capable of being acclimatised, also ACCLIMATIZABLE [adj]\n",
  "ACCLIMATISATION": "the act of acclimatising, also ACCLIMATIZATION [n]\n",
  "ACCLIMATISE": "to accustom to a climate, also ACCLIMATIZE, ACCLIMATE [v ACCLIMATISED, ACCLIMATISING, ACCLIMATISES]\n",
  "ACCLIMATISED": "ACCLIMATISE, to accustom to a climate, also ACCLIMATIZE, ACCLIMATE [v]\n",
  "ACCLIMATISER": "one who acclimatises [n -S]\n",
  "ACCLIMATISERS": "ACCLIMATISER, one who acclimatises [n]\n",
  "ACCLIMATISES": "ACCLIMATISE, to accustom to a climate, also ACCLIMATIZE, ACCLIMATE [v]\n",
  "ACCLIMATISING": "ACCLIMATISE, to accustom to a climate, also ACCLIMATIZE, ACCLIMATE [v]\n",
  "ACCLIMATIZABLE": "capable of being acclimatised, also ACCLIMATISABLE [adj]\n",
  "ACCLIMATIZATION": "the act of acclimatizing, also ACCLIMATISATION [n]\n",
  "ACCLIMATIZE": "to accustom to a climate, also ACCLIMATISE, ACCLIMATE [v ACCLIMATIZED, ACCLIMATIZING, ACCLIMATIZES]\n",
  "ACCLIMATIZED": "ACCLIMATIZE, to accustom to a climate, also ACCLIMATISE, ACCLIMATE [v]\n",
  "ACCLIMATIZER": "one who acclimatizes [n -S]\n",
  "ACCLIMATIZERS": "ACCLIMATIZER, one who acclimatizes [n]\n",
  "ACCLIMATIZES": "ACCLIMATIZE, to accustom to a climate, also ACCLIMATISE, ACCLIMATE [v]\n",
  "ACCLIMATIZING": "ACCLIMATIZE, to accustom to a climate, also ACCLIMATISE, ACCLIMATE [v]\n",
  "ACCLIVITIES": "ACCLIVITY, an upward slope [n]\n",
  "ACCLIVITOUS": "sloping upwards, also ACCLIVOUS [adj]\n",
  "ACCLIVITY": "an upward slope [n ACCLIVITIES]\n",
  "ACCLIVOUS": "sloping upwards, also ACCLIVITOUS [adj]\n",
  "ACCLOY": "(Spenser) to injure with a horseshoe nail; to clog, choke [v -ED, -ING, -S]\n",
  "ACCLOYED": "ACCLOY, (Spenser) to injure with a horseshoe nail; to clog, choke [v]\n",
  "ACCLOYING": "ACCLOY, (Spenser) to injure with a horseshoe nail; to clog, choke [v]\n",
  "ACCLOYS": "ACCLOY, (Spenser) to injure with a horseshoe nail; to clog, choke [v]\n",
  "ACCOAST": "to lie or sail along the coast or side of; to accost [v -ED, -ING, -S]\n",
  "ACCOASTED": "ACCOAST, to lie or sail along the coast or side of; to accost [v]\n",
  "ACCOASTING": "ACCOAST, to lie or sail along the coast or side of; to accost [v]\n",
  "ACCOASTS": "ACCOAST, to lie or sail along the coast or side of; to accost [v]\n",
  "ACCOIED": "ACCOY, (Spenser) to subdue, pacify [v]\n",
  "ACCOIL": "a reception [n -S] / (Spenser) to assemble [v ACCOYLD]\n",
  "ACCOILS": "ACCOIL, (Spenser) to assemble [v]\n",
  "ACCOLADE": "(French) an expression of praise [n -S] / to give an accolade [v ACCOLADED, ACCOLADING, ACCOLADES]\n",
  "ACCOLADED": "ACCOLADE, to give an accolade [v]\n",
  "ACCOLADES": "ACCOLADE, to give an accolade [v]\n",
  "ACCOLADING": "ACCOLADE, to give an accolade [v]\n",
  "ACCOMMODABLE": "that can be accommodated [adj]\n",
  "ACCOMMODATE": "to make fit, suitable, or congruous [v ACCOMMODATED, ACCOMMODATING, ACCOMMODATES]\n",
  "ACCOMMODATED": "ACCOMMODATE, to make fit, suitable, or congruous [v]\n",
  "ACCOMMODATES": "ACCOMMODATE, to make fit, suitable, or congruous [v]\n",
  "ACCOMMODATING": "ACCOMMODATE, to make fit, suitable, or congruous [v]\n",
  "ACCOMMODATINGLY": "ACCOMMODATING, ACCOMMODATE, to make fit, suitable, or congruous [adv]\n",
  "ACCOMMODATION": "traveling space and related services [n -S]\n",
  "ACCOMMODATIONAL": "relating to accommodation [adj]\n",
  "ACCOMMODATIONS": "ACCOMMODATION, traveling space and related services [n]\n",
  "ACCOMMODATIVE": "relating to accomodation [adj]\n",
  "ACCOMMODATOR": "one who accommodates [n -S]\n",
  "ACCOMMODATORS": "ACCOMMODATOR, one who accommodates [n]\n",
  "ACCOMPANIED": "ACCOMPANY, to escort [v]\n",
  "ACCOMPANIER": "one who accompanies [n -S]\n",
  "ACCOMPANIERS": "ACCOMPANIER, one who accompanies [n]\n",
  "ACCOMPANIES": "ACCOMPANY, to escort [v]\n",
  "ACCOMPANIMENT": "an instrumental or vocal part designed to complement a melody [n -S]\n",
  "ACCOMPANIMENTS": "ACCOMPANIMENT, an instrumental or vocal part designed to complement a melody [n]\n",
  "ACCOMPANIST": "one who accompanies another, also ACCOMPANYIST [n -S]\n",
  "ACCOMPANISTS": "ACCOMPANIST, one who accompanies another, also ACCOMPANYIST [n]\n",
  "ACCOMPANY": "to escort [v ACCOMPANIED, ACCOMPANYING, ACCOMPANIES]\n",
  "ACCOMPANYING": "ACCOMPANY, to escort [v]\n",
  "ACCOMPANYIST": "one who accompanies another, also ACCOMPANIST [n -S]\n",
  "ACCOMPANYISTS": "ACCOMPANYIST, one who accompanies another, also ACCOMPANIST [n]\n",
  "ACCOMPLICE": "one associated with another esp. in wrongdoing, also COMPLICE [n -S]\n",
  "ACCOMPLICES": "ACCOMPLICE, one associated with another esp. in wrongdoing, also COMPLICE [n]\n",
  "ACCOMPLISH": "to bring about (a result) by effort, also COMPLISH [v -ED, -ING, -ES]\n",
  "ACCOMPLISHABLE": "capable of being accomplished [adj]\n",
  "ACCOMPLISHED": "ACCOMPLISH, to bring about (a result) by effort, also COMPLISH [v]\n",
  "ACCOMPLISHER": "one who accomplishes [n -S]\n",
  "ACCOMPLISHERS": "ACCOMPLISHER, one who accomplishes [n]\n",
  "ACCOMPLISHES": "ACCOMPLISH, to bring about (a result) by effort, also COMPLISH [v]\n",
  "ACCOMPLISHING": "ACCOMPLISH, to bring about (a result) by effort, also COMPLISH [v]\n",
  "ACCOMPLISHMENT": "the act of accomplishing [n -S]\n",
  "ACCOMPLISHMENTS": "ACCOMPLISHMENT, the act of accomplishing [n]\n",
  "ACCOMPT": "to explain in detail, also ACCOUNT [v -ED, -ING, -S]\n",
  "ACCOMPTABLE": "accountable, also ACCOUNTABLE [adj]\n",
  "ACCOMPTANT": "an accountant, also ACCOUNTANT [n -S]\n",
  "ACCOMPTANTS": "ACCOMPTANT, an accountant, also ACCOUNTANT [n]\n",
  "ACCOMPTED": "ACCOMPT, to explain in detail, also ACCOUNT [v]\n",
  "ACCOMPTING": "ACCOMPT, to explain in detail, also ACCOUNT [v]\n",
  "ACCOMPTS": "ACCOMPT, to explain in detail, also ACCOUNT [v]\n",
  "ACCORAGE": "(Spenser) to encourage [v ACCORAGED, ACCORAGING, ACCORAGES]\n",
  "ACCORAGED": "ACCORAGE, (Spenser) to encourage [v]\n",
  "ACCORAGES": "ACCORAGE, (Spenser) to encourage [v]\n",
  "ACCORAGING": "ACCORAGE, (Spenser) to encourage [v]\n",
  "ACCORD": "to bring into agreement [v -ED, -ING, -S]\n",
  "ACCORDABLE": "agreeing [adj]\n",
  "ACCORDANCE": "agreement, also ACCORDANCY [n -S]\n",
  "ACCORDANCES": "ACCORDANCE, agreement, also ACCORDANCY [n]\n",
  "ACCORDANCIES": "ACCORDANCY, accordance, also ACCORDANCE [n]\n",
  "ACCORDANCY": "accordance, also ACCORDANCE [n ACCORDANCIES]\n",
  "ACCORDANT": "agreeing; consonant [adj]\n",
  "ACCORDANTLY": "ACCORDANT, agreeing; consonant [adv]\n",
  "ACCORDED": "ACCORD, to bring into agreement [v]\n",
  "ACCORDER": "one who accords [n -S]\n",
  "ACCORDERS": "ACCORDER, one who accords [n]\n",
  "ACCORDING": "ACCORD, to bring into agreement [v]\n",
  "ACCORDINGLY": "therefore; in agreement with what came before [adv]\n",
  "ACCORDION": "a musical instrument played by squeezing [n -S]\n",
  "ACCORDIONIST": "one who plays the accordion [n -S]\n",
  "ACCORDIONISTS": "ACCORDIONIST, one who plays the accordion [n]\n",
  "ACCORDIONS": "ACCORDION, a musical instrument played by squeezing [n]\n",
  "ACCORDS": "ACCORD, to bring into agreement [v]\n",
  "ACCOST": "to approach and speak to [v -ED, -ING, -S]\n",
  "ACCOSTABLE": "approachable; affable [adj]\n",
  "ACCOSTED": "ACCOST, to approach and speak to [v]\n",
  "ACCOSTING": "ACCOST, to approach and speak to [v]\n",
  "ACCOSTS": "ACCOST, to approach and speak to [v]\n",
  "ACCOUCHEMENT": "(French) childbirth; a confinement [n -S]\n",
  "ACCOUCHEMENTS": "ACCOUCHEMENT, (French) childbirth; a confinement [n]\n",
  "ACCOUCHEUR": "(French) a male midwife [n -S]\n",
  "ACCOUCHEURS": "ACCOUCHEUR, (French) a male midwife [n]\n",
  "ACCOUCHEUSE": "(French) a female midwife [n -S]\n",
  "ACCOUCHEUSES": "ACCOUCHEUSE, (French) a female midwife [n]\n",
  "ACCOUNT": "to explain in detail, also ACCOMPT [v -ED, -ING, -S]\n",
  "ACCOUNTABILITY": "the state of being accountable [n]\n",
  "ACCOUNTABLE": "that can be held to account, also ACCOMPTABLE [adj ACCOUNTABLY]\n",
  "ACCOUNTABLENESS": "accountability [n]\n",
  "ACCOUNTABLY": "ACCOUNTABLE, that can be held to account, also ACCOMPTABLE [adv]\n",
  "ACCOUNTANCIES": "ACCOUNTANCY, the profession or practice of accounting [n]\n",
  "ACCOUNTANCY": "the profession or practice of accounting [n ACCOUNTANCIES]\n",
  "ACCOUNTANT": "one skilled in the practice of accounting, also ACCOMPTANT [n -S]\n",
  "ACCOUNTANTS": "ACCOUNTANT, one skilled in the practice of accounting, also ACCOMPTANT [n]\n",
  "ACCOUNTANTSHIP": "the office of an accountant [n -S]\n",
  "ACCOUNTANTSHIPS": "ACCOUNTANTSHIP, the office of an accountant [n]\n",
  "ACCOUNTED": "ACCOUNT, to explain in detail, also ACCOMPT [v]\n",
  "ACCOUNTING": "the setting up, maintaining and analysing of financial records [n -S]\n",
  "ACCOUNTINGS": "ACCOUNTING, the setting up, maintaining and analysing of financial records [n]\n",
  "ACCOUNTS": "ACCOUNT, to explain in detail, also ACCOMPT [v]\n",
  "ACCOUPLEMENT": "a timber joist or beam that serves as a tie or support [n -S]\n",
  "ACCOUPLEMENTS": "ACCOUPLEMENT, a timber joist or beam that serves as a tie or support [n]\n",
  "ACCOURAGE": "(Spenser) to encourage, also ACCORAGE, ENCOURAGE [v ACCOURAGED, ACCOURAGING, ACCOURAGES]\n",
  "ACCOURAGED": "ACCOURAGE, (Spenser) to encourage, also ACCORAGE, ENCOURAGE [v]\n",
  "ACCOURAGES": "ACCOURAGE, (Spenser) to encourage, also ACCORAGE, ENCOURAGE [v]\n",
  "ACCOURAGING": "ACCOURAGE, (Spenser) to encourage, also ACCORAGE, ENCOURAGE [v]\n",
  "ACCOURT": "to entertain [v -ED, -ING, -S]\n",
  "ACCOURTED": "ACCOURT, to entertain [v]\n",
  "ACCOURTING": "ACCOURT, to entertain [v]\n",
  "ACCOURTS": "ACCOURT, to entertain [v]\n",
  "ACCOUSTREMENT": "(obsolete) accoutrement, also ACCOUTERMENT, ACCOUTREMENT, ACCUSTREMENT [n -S]\n",
  "ACCOUSTREMENTS": "ACCOUSTREMENT, (obsolete) accoutrement, also ACCOUTERMENT, ACCOUTREMENT, ACCUSTREMENT [n]\n",
  "ACCOUTER": "(US) to dress or equip, esp. a warrior, also ACCOUTRE [v -ED, -ING, -S]\n",
  "ACCOUTERED": "ACCOUTER, (US) to dress or equip, esp. a warrior, also ACCOUTRE [v]\n",
  "ACCOUTERING": "ACCOUTER, (US) to dress or equip, esp. a warrior, also ACCOUTRE [v]\n",
  "ACCOUTERMENT": "an accoutrement, also ACCOUSTREMENT, ACCOUTREMENT, ACCUSTREMENT [n -S]\n",
  "ACCOUTERMENTS": "ACCOUTERMENT, an accoutrement, also ACCOUSTREMENT, ACCOUTREMENT, ACCUSTREMENT [n]\n",
  "ACCOUTERS": "ACCOUTER, (US) to dress or equip, esp. a warrior, also ACCOUTRE [v]\n",
  "ACCOUTRE": "to dress or equip, esp. a warrior, also ACCOUTER [v ACCOUTRED, ACCOUTRING, ACCOUTRES]\n",
  "ACCOUTRED": "ACCOUTRE, to dress or equip, esp. a warrior, also ACCOUTER [v]\n",
  "ACCOUTREMENT": "(French) an accessory item of clothing or equipment, also ACCOUSTREMENT, ACCOUTERMENT, ACCUSTREMENT [n -S]\n",
  "ACCOUTREMENTS": "ACCOUTREMENT, (French) an accessory item of clothing or equipment, also ACCOUSTREMENT, ACCOUTERMENT, ACCUSTREMENT [n]\n",
  "ACCOUTRES": "ACCOUTRE, to dress or equip, esp. a warrior, also ACCOUTER [v]\n",
  "ACCOUTRING": "ACCOUTRE, to dress or equip, esp. a warrior, also ACCOUTER [v]\n",
  "ACCOY": "(Spenser) to subdue, pacify [v ACCOYED or ACCOIED, ACCOYING, ACCOYS]\n",
  "ACCOYED": "ACCOY, (Spenser) to subdue, pacify [v]\n",
  "ACCOYING": "ACCOY, (Spenser) to subdue, pacify [v]\n",
  "ACCOYLD": "ACCOIL, (Spenser) to assemble [v]\n",
  "ACCOYS": "ACCOY, (Spenser) to subdue, pacify [v]\n",
  "ACCREDIT": "to accept as true [v -ED, -ING, -S]\n",
  "ACCREDITABLE": "capable of being accredited [adj]\n",
  "ACCREDITATION": "the act or result of accrediting [n -S]\n",
  "ACCREDITATIONS": "ACCREDITATION, the act or result of accrediting [n]\n",
  "ACCREDITED": "ACCREDIT, to accept as true [v]\n",
  "ACCREDITING": "ACCREDIT, to accept as true [v]\n",
  "ACCREDITS": "ACCREDIT, to accept as true [v]\n",
  "ACCRESCENCE": "growing together [n -S]\n",
  "ACCRESCENCES": "ACCRESCENCE, growing together [n]\n",
  "ACCRESCENT": "growing larger even after flowering [adj]\n",
  "ACCRETE": "to grow together [v ACCRETED, ACCRETING, ACCRETES]\n",
  "ACCRETED": "ACCRETE, to grow together [v]\n",
  "ACCRETES": "ACCRETE, to grow together [v]\n",
  "ACCRETING": "ACCRETE, to grow together [v]\n",
  "ACCRETION": "accumulation; the addition of parts to form a whole [n -S]\n",
  "ACCRETIONARY": "relating to accretion, also ACCRETIVE [adj]\n",
  "ACCRETIONS": "ACCRETION, accumulation; the addition of parts to form a whole [n]\n",
  "ACCRETIVE": "relating to accretion, also ACCRETIONARY [adj]\n",
  "ACCREW": "(Spenser) to accrue [v -ED, -ING, -S]\n",
  "ACCREWED": "ACCREW, (Spenser) to accrue [v]\n",
  "ACCREWING": "ACCREW, (Spenser) to accrue [v]\n",
  "ACCREWS": "ACCREW, (Spenser) to accrue [v]\n",
  "ACCROIDES": "a red alcohol-soluble resin [n ACCROIDES]\n",
  "ACCRUABLE": "capable of being accrued [adj]\n",
  "ACCRUAL": "an accumulation [n -S]\n",
  "ACCRUALS": "ACCRUAL, an accumulation [n]\n",
  "ACCRUE": "to accumulate, also ACCREW [v ACCRUED, ACCRUING, ACCRUES]\n",
  "ACCRUED": "ACCRUE, to accumulate, also ACCREW [v]\n",
  "ACCRUEMENT": "the act of accruing [n -S]\n",
  "ACCRUEMENTS": "ACCRUEMENT, the act of accruing [n]\n",
  "ACCRUES": "ACCRUE, to accumulate, also ACCREW [v]\n",
  "ACCRUING": "ACCRUE, to accumulate, also ACCREW [v]\n",
  "ACCUBATION": "the act of reclining while eating [n -S]\n",
  "ACCUBATIONS": "ACCUBATION, the act of reclining while eating [n]\n",
  "ACCULTURAL": "relating to acculturation, modification in a culture by the adoption of outside cultural traits [adj]\n",
  "ACCULTURATE": "to undergo acculturation [v ACCULTURATED, ACCULTURATING, ACCULTURATES]\n",
  "ACCULTURATED": "ACCULTURATE, to undergo acculturation [v]\n",
  "ACCULTURATES": "ACCULTURATE, to undergo acculturation [v]\n",
  "ACCULTURATING": "ACCULTURATE, to undergo acculturation [v]\n",
  "ACCULTURATION": "the assimilation, through continuous contact, of features (such as customs, beliefs, etc.) of another culture [n -S]\n",
  "ACCULTURATIONAL": "relating to acculturation, also ACCULTURATIVE [adj]\n",
  "ACCULTURATIONS": "ACCULTURATION, the assimilation, through continuous contact, of features (such as customs, beliefs, etc.) of another culture [n]\n",
  "ACCULTURATIVE": "relating to acculturation, also ACCULTURATIONAL [adj]\n",
  "ACCUMBENCIES": "ACCUMBENCY, the state of being accumbent or reclining [n]\n",
  "ACCUMBENCY": "the state of being accumbent or reclining [n ACCUMBENCIES]\n",
  "ACCUMBENT": "of plants, lying against something [adj]\n",
  "ACCUMULABLE": "that can be accumulated [adj]\n",
  "ACCUMULATE": "to gather or pile up esp. little by little [v ACCUMULATED, ACCUMULATING, ACCUMULATES]\n",
  "ACCUMULATED": "ACCUMULATE, to gather or pile up esp. little by little [v]\n",
  "ACCUMULATES": "ACCUMULATE, to gather or pile up esp. little by little [v]\n",
  "ACCUMULATING": "ACCUMULATE, to gather or pile up esp. little by little [v]\n",
  "ACCUMULATION": "something that has accumulated [n -S]\n",
  "ACCUMULATIONS": "ACCUMULATION, something that has accumulated [n]\n",
  "ACCUMULATIVE": "tending or given to accumulation [adj ACCUMULATIVELY]\n",
  "ACCUMULATIVELY": "ACCUMULATIVE, tending or given to accumulation [adv]\n",
  "ACCUMULATOR": "a thing or person that accumulates [n -S]\n",
  "ACCUMULATORS": "ACCUMULATOR, a thing or person that accumulates [n]\n",
  "ACCURACIES": "ACCURACY, exactness [n]\n",
  "ACCURACY": "exactness [n ACCURACIES]\n",
  "ACCURATE": "free from error [adj ACCURATELY]\n",
  "ACCURATELY": "ACCURATE, free from error [adv]\n",
  "ACCURATENESS": "accuracy [n -ES]\n",
  "ACCURATENESSES": "ACCURATENESS, accuracy [n]\n",
  "ACCURSE": "to make cursed [v ACCURSED or ACCURST, ACCURSING, ACCURSES]\n",
  "ACCURSED": "ACCURSE, to make cursed [v]\n",
  "ACCURSEDLY": "ACCURSED, ACCURSE, to make cursed [adv]\n",
  "ACCURSEDNESS": "the state of being accursed [n -ES]\n",
  "ACCURSEDNESSES": "ACCURSEDNESS, the state of being accursed [n]\n",
  "ACCURSES": "ACCURSE, to make cursed [v]\n",
  "ACCURSING": "ACCURSE, to make cursed [v]\n",
  "ACCURST": "doomed [adj]\n",
  "ACCUSABLE": "liable to be accused; chargeable with a crime or fault [adj]\n",
  "ACCUSABLY": "ACCUSABLE, liable to be accused; chargeable with a crime or fault [adv]\n",
  "ACCUSAL": "an accusation [n -S]\n",
  "ACCUSALS": "ACCUSAL, an accusation [n]\n",
  "ACCUSANT": "an accuser [n -S]\n",
  "ACCUSANTS": "ACCUSANT, an accuser [n]\n",
  "ACCUSATION": "the act of accusing [n -S]\n",
  "ACCUSATIONS": "ACCUSATION, the act of accusing [n]\n",
  "ACCUSATIVAL": "relating to the accusative case [adj]\n",
  "ACCUSATIVE": "accusing [adj ACCUSATIVELY] / a case indicating the direct object of a verb [n -S]\n",
  "ACCUSATIVELY": "ACCUSATIVE, accusing [adv]\n",
  "ACCUSATIVES": "ACCUSATIVE, a case indicating the direct object of a verb [n]\n",
  "ACCUSATORIAL": "denoting a judicial procedure in which the judge is not the same person as the prosecutor [adj]\n",
  "ACCUSATORY": "containing or expressing accusation [adj]\n",
  "ACCUSE": "to bring a charge against [v ACCUSED, ACCUSING, ACCUSES]\n",
  "ACCUSED": "ACCUSE, to bring a charge against [v]\n",
  "ACCUSEMENT": "(Spenser) an accusation [n -S]\n",
  "ACCUSEMENTS": "ACCUSEMENT, (Spenser) an accusation [n]\n",
  "ACCUSER": "one who accuses [n -S]\n",
  "ACCUSERS": "ACCUSER, one who accuses [n]\n",
  "ACCUSES": "ACCUSE, to bring a charge against [v]\n",
  "ACCUSING": "expressing accusation [adj ACCUSINGLY]\n",
  "ACCUSINGLY": "ACCUSING, expressing accusation [adv]\n",
  "ACCUSTOM": "to make familiar [v -ED, -ING, -S]\n",
  "ACCUSTOMARY": "made familiar by custom [adj]\n",
  "ACCUSTOMATION": "the act of accustoming [n -S]\n",
  "ACCUSTOMATIONS": "ACCUSTOMATION, the act of accustoming [n]\n",
  "ACCUSTOMED": "ACCUSTOM, to make familiar [v]\n",
  "ACCUSTOMEDNESS": "the state of being accustomed [n]\n",
  "ACCUSTOMING": "ACCUSTOM, to make familiar [v]\n",
  "ACCUSTOMS": "ACCUSTOM, to make familiar [v]\n",
  "ACCUSTREMENT": "(obsolete) accoutrement, also ACCOUSTREMENT, ACCOUTERMENT, ACCOUTREMENT [n -S]\n",
  "ACCUSTREMENTS": "ACCUSTREMENT, (obsolete) accoutrement, also ACCOUSTREMENT, ACCOUTERMENT, ACCOUTREMENT [n]\n",
  "ACE": "an expert [n -S] / to serve an unreturnable shot e.g. in tennis [v ACED, ACING, ACES]\n",
  "ACED": "ACE, to serve an unreturnable shot e.g. in tennis [v]\n",
  "ACEDIA": "(Greek) sloth, physical torpor, also ACCIDIA, ACCIDIE [n -S]\n",
  "ACEDIAS": "ACEDIA, (Greek) sloth, physical torpor, also ACCIDIA, ACCIDIE [n]\n",
  "ACELDAMA": "(Aramaic) a place of bloodshed [n -S]\n",
  "ACELDAMAS": "ACELDAMA, (Aramaic) a place of bloodshed [n]\n",
  "ACELLULAR": "not containing or made up of cells [adj]\n",
  "ACENTRIC": "without a centre [adj] / an acentric chromosome or fragment [n -S]\n",
  "ACENTRICS": "ACENTRIC, an acentric chromosome or fragment [n]\n",
  "ACEPHALIC": "headless [adj]\n",
  "ACEPHALOUS": "lacking a head or a leader; lacking the first syllable or foot (of a hexameter) [adj]\n",
  "ACEQUIA": "(Spanish) an irrigation ditch [n -S]\n",
  "ACEQUIAS": "ACEQUIA, (Spanish) an irrigation ditch [n]\n",
  "ACER": "(Latin) a plant of the maple genus [n -S]\n",
  "ACERACEOUS": "relating to a plant of the maple family [adj]\n",
  "ACERATE": "needle-shaped [adj]\n",
  "ACERATED": "needle-shaped, also ACERATE [adj]\n",
  "ACERB": "bitter and sour, also ACERBIC [adj ACERBER, ACERBEST]\n",
  "ACERBATE": "to embitter, to irritate [v ACERBATED, ACERBATING, ACERBATES]\n",
  "ACERBATED": "ACERBATE, to embitter, to irritate [v]\n",
  "ACERBATES": "ACERBATE, to embitter, to irritate [v]\n",
  "ACERBATING": "ACERBATE, to embitter, to irritate [v]\n",
  "ACERBER": "ACERB, bitter and sour, also ACERBIC [adj]\n",
  "ACERBEST": "ACERB, bitter and sour, also ACERBIC [adj]\n",
  "ACERBIC": "bitter and sour, also ACERB [adj ACERBICALLY]\n",
  "ACERBICALLY": "ACERBIC, bitter and sour, also ACERB [adv]\n",
  "ACERBITIES": "ACERBITY, sourness [n]\n",
  "ACERBITY": "sourness [n ACERBITIES]\n",
  "ACEROLA": "a West Indian shrub [n -S]\n",
  "ACEROLAS": "ACEROLA, a West Indian shrub [n]\n",
  "ACEROSE": "needle-shaped [adj]\n",
  "ACEROUS": "needle-shaped [adj]\n",
  "ACERS": "ACER, (Latin) a plant of the maple genus [n]\n",
  "ACERVATE": "heaped [adj ACERVATELY]\n",
  "ACERVATELY": "ACERVATE, heaped [adv]\n",
  "ACERVATION": "the action of heaping up; an accumulation [n -S]\n",
  "ACERVATIONS": "ACERVATION, the action of heaping up; an accumulation [n]\n",
  "ACERVULI": "ACERVULUS, (Latin) the spore-producing organ of certain fungi [n]\n",
  "ACERVULUS": "(Latin) the spore-producing organ of certain fungi [n ACERVULI]\n",
  "ACES": "ACE, to serve an unreturnable shot e.g. in tennis [v]\n",
  "ACESCENCE": "the act of turning sour, acetous fermentation, also ACESCENCY [n -S]\n",
  "ACESCENCES": "ACESCENCE, the act of turning sour, acetous fermentation, also ACESCENCY [n]\n",
  "ACESCENCIES": "ACESCENCY, the act of turning sour, acetous fermentation, also ACESCENCE [n]\n",
  "ACESCENCY": "the act of turning sour, acetous fermentation, also ACESCENCE [n ACESCENCIES]\n",
  "ACESCENT": "something that is slightly sour [n -S]\n",
  "ACESCENTS": "ACESCENT, something that is slightly sour [n]\n",
  "ACETA": "ACETUM, (Latin) vinegar [n]\n",
  "ACETABULA": "ACETABULUM, (Latin) a cuplike hollow on the hipbone to receive the thighbone [n]\n",
  "ACETABULAR": "cup-shaped; saucer-shaped [adj]\n",
  "ACETABULUM": "(Latin) a cuplike hollow on the hipbone to receive the thighbone [n ACETABULA or ACETABULUMS]\n",
  "ACETABULUMS": "ACETABULUM, (Latin) a cuplike hollow on the hipbone to receive the thighbone [n]\n",
  "ACETAL": "an odoriferous liquid formed by reaction of acetaldehyde and ethyl alcohol [n -S]\n",
  "ACETALDEHYDE": "a chemical compound [n -S]\n",
  "ACETALDEHYDES": "ACETALDEHYDE, a chemical compound [n]\n",
  "ACETALS": "ACETAL, an odoriferous liquid formed by reaction of acetaldehyde and ethyl alcohol [n]\n",
  "ACETAMID": "an amide of acetic acid [n -S]\n",
  "ACETAMIDE": "a white crystalline solid, derived from ammonia by replacement of an equivalent of hydrogen by acetyl, also ACETAMID [n -S]\n",
  "ACETAMIDES": "ACETAMIDE, a white crystalline solid, derived from ammonia by replacement of an equivalent of hydrogen by acetyl, also ACETAMID [n]\n",
  "ACETAMIDS": "ACETAMID, an amide of acetic acid [n]\n",
  "ACETAMINOPHEN": "(US) paracetamol, a chemical compound used in medicine to relieve pain and fever [n -S]\n",
  "ACETAMINOPHENS": "ACETAMINOPHEN, (US) paracetamol, a chemical compound used in medicine to relieve pain and fever [n]\n",
  "ACETANILID": "a white crystalline compound derived from aniline and acetic acid, also ACETANILIDE [n -S]\n",
  "ACETANILIDE": "a white crystalline compound derived from aniline and acetic acid, also ACETANILID [n -S]\n",
  "ACETANILIDES": "ACETANILIDE, a white crystalline compound derived from aniline and acetic acid, also ACETANILID [n]\n",
  "ACETANILIDS": "ACETANILID, a white crystalline compound derived from aniline and acetic acid, also ACETANILIDE [n]\n",
  "ACETATE": "an ester of acetic acid [n -S]\n",
  "ACETATED": "combined with acetic acid [adj]\n",
  "ACETATES": "ACETATE, an ester of acetic acid [n]\n",
  "ACETAZOLAMIDE": "a diuretic drug [n -S]\n",
  "ACETAZOLAMIDES": "ACETAZOLAMIDE, a diuretic drug [n]\n",
  "ACETIC": "pertaining to vinegar [adj]\n",
  "ACETIFICATION": "the process of acetifying [n -S]\n",
  "ACETIFICATIONS": "ACETIFICATION, the process of acetifying [n]\n",
  "ACETIFIED": "ACETIFY, to convert to vinegar [v]\n",
  "ACETIFIER": "an agent that acetifies, converts into acid or vinegar [n -S]\n",
  "ACETIFIERS": "ACETIFIER, an agent that acetifies, converts into acid or vinegar [n]\n",
  "ACETIFIES": "ACETIFY, to convert to vinegar [v]\n",
  "ACETIFY": "to convert to vinegar [v ACETIFIED, ACETIFYING, ACETIFIES]\n",
  "ACETIFYING": "ACETIFY, to convert to vinegar [v]\n",
  "ACETIN": "a combination of acetic acid with glycerin [n -S]\n",
  "ACETINS": "ACETIN, a combination of acetic acid with glycerin [n]\n",
  "ACETOACETIC": "as in acetoacetic acid, a weak acid which is an intermediate in the catabolism of fatty acids and amino acids [adj]\n",
  "ACETOMETER": "a device for measuring the concentration of acetic acid in a solution, esp. in vinegar [n -S]\n",
  "ACETOMETERS": "ACETOMETER, a device for measuring the concentration of acetic acid in a solution, esp. in vinegar [n]\n",
  "ACETONAEMIA": "an abnormal increase of ketone bodies in the blood, also ACETONEMIA [n -S]\n",
  "ACETONAEMIAS": "ACETONAEMIA, an abnormal increase of ketone bodies in the blood, also ACETONEMIA [n]\n",
  "ACETONE": "the simplest of the ketones; any ketone [n -S]\n",
  "ACETONEMIA": "an abnormal increase of ketone bodies in the blood, also ACETONAEMIA [n -S]\n",
  "ACETONEMIAS": "ACETONEMIA, an abnormal increase of ketone bodies in the blood, also ACETONAEMIA [n]\n",
  "ACETONES": "ACETONE, the simplest of the ketones; any ketone [n]\n",
  "ACETONIC": "of or pertaining to acetone, as, acetonic bodies [adj]\n",
  "ACETONITRILE": "a chemical compound [n -S]\n",
  "ACETONITRILES": "ACETONITRILE, a chemical compound [n]\n",
  "ACETONURIA": "the presence of acetone in the urine [n -S]\n",
  "ACETONURIAS": "ACETONURIA, the presence of acetone in the urine [n]\n",
  "ACETOPHENETIDIN": "another name for phenacetin, an antipyretic drug [n]\n",
  "ACETOSE": "like vinegar [adj]\n",
  "ACETOUS": "like vinegar [adj]\n",
  "ACETOXYL": "a univalent radical [n -S]\n",
  "ACETOXYLS": "ACETOXYL, a univalent radical [n]\n",
  "ACETUM": "(Latin) vinegar [n ACETA]\n",
  "ACETYL": "the radical of acetic acid [n -S]\n",
  "ACETYLATE": "to introduce the acetyl radical into (a compound) [v ACETYLATED, ACETYLATING, ACETYLATES]\n",
  "ACETYLATED": "ACETYLATE, to introduce the acetyl radical into (a compound) [v]\n",
  "ACETYLATES": "ACETYLATE, to introduce the acetyl radical into (a compound) [v]\n",
  "ACETYLATING": "ACETYLATE, to introduce the acetyl radical into (a compound) [v]\n",
  "ACETYLATION": "the act of acetylating [n -S]\n",
  "ACETYLATIONS": "ACETYLATION, the act of acetylating [n]\n",
  "ACETYLATIVE": "acting as an acetylate [adj]\n",
  "ACETYLCHOLINE": "a substance secreted at the ends of nerve fibres when they activate muscles [n -S]\n",
  "ACETYLCHOLINES": "ACETYLCHOLINE, a substance secreted at the ends of nerve fibres when they activate muscles [n]\n",
  "ACETYLENE": "a colourless toxic inflammable gas formed by the action of water on calcium carbide, aka ethyne [n -S]\n",
  "ACETYLENES": "ACETYLENE, a colourless toxic inflammable gas formed by the action of water on calcium carbide, aka ethyne [n]\n",
  "ACETYLENIC": "of or like acetylene, a colourless toxic inflammable gas formed by the action of water on calcium carbide [adj]\n",
  "ACETYLIC": "pertaining to the radical of acetic acid [adj]\n",
  "ACETYLIDE": "any of a class of carbides in which the carbon is present as a diatomic divalent ion [n -S]\n",
  "ACETYLIDES": "ACETYLIDE, any of a class of carbides in which the carbon is present as a diatomic divalent ion [n]\n",
  "ACETYLS": "ACETYL, the radical of acetic acid [n]\n",
  "ACETYLSALICYLIC": "as in acetylsalicylic acid, aspirin [adj]\n",
  "ACH": "(Scots) expressing regret or impatience, also OCH [interj]\n",
  "ACHAENIA": "ACHAENIUM, a small one-seeded fruit; a naked seed, also ACHENE, ACHENIUM, AKENE [n]\n",
  "ACHAENIUM": "a small one-seeded fruit; a naked seed, also ACHENE, ACHENIUM, AKENE [n ACHAENIA or ACHAENIUMS]\n",
  "ACHAENIUMS": "ACHAENIUM, a small one-seeded fruit; a naked seed, also ACHENE, ACHENIUM, AKENE [n]\n",
  "ACHAENOCARP": "any dry indehiscent fruit [n -S]\n",
  "ACHAENOCARPS": "ACHAENOCARP, any dry indehiscent fruit [n]\n",
  "ACHAGE": "(Tennyson) an ache, aching [n -S]\n",
  "ACHAGES": "ACHAGE, (Tennyson) an ache, aching [n]\n",
  "ACHALASIA": "(Greek) failure of the muscles of the lower part of the oesophagus to relax, which prevents food from passing into the stomach [n -S]\n",
  "ACHALASIAS": "ACHALASIA, (Greek) failure of the muscles of the lower part of the oesophagus to relax, which prevents food from passing into the stomach [n]\n",
  "ACHAR": "a spicy pickle made primarily from mango, used in Indian cooking [n -S]\n",
  "ACHARNE": "(French) furious, desperate (esp. of battles) [adj]\n",
  "ACHARS": "ACHAR, a spicy pickle made primarily from mango, used in Indian cooking [n]\n",
  "ACHARYA": "(Sanskrit) a Hindu teacher or learned man [n -S]\n",
  "ACHARYAS": "ACHARYA, (Sanskrit) a Hindu teacher or learned man [n]\n",
  "ACHATES": "(Spenser) bought provisions, also ACATES [n]\n",
  "ACHE": "to endure a dull lasting pain, also AKE [v ACHED, ACHING, ACHES]\n",
  "ACHED": "ACHE, to endure a dull lasting pain, also AKE [v]\n",
  "ACHENE": "a dry one-seeded fruit, also AKENE [n -S]\n",
  "ACHENES": "ACHENE, a dry one-seeded fruit, also AKENE [n]\n",
  "ACHENIA": "ACHENIUM, a small one-seeded fruit; a naked seed, also ACHAENIUM, ACHENE, AKENE [n]\n",
  "ACHENIAL": "relating to an achene, also AKENIAL [adj]\n",
  "ACHENIUM": "a small one-seeded fruit; a naked seed, also ACHAENIUM, ACHENE, AKENE [n ACHENIA or ACHENIUMS]\n",
  "ACHENIUMS": "ACHENIUM, a small one-seeded fruit; a naked seed, also ACHAENIUM, ACHENE, AKENE [n]\n",
  "ACHES": "ACHE, to endure a dull lasting pain, also AKE [v]\n",
  "ACHIER": "ACHY, aching [adj]\n",
  "ACHIEST": "ACHY, aching [adj]\n",
  "ACHIEVABLE": "that can be achieved [adj]\n",
  "ACHIEVE": "to carry out successfully [v ACHIEVED, ACHIEVING, ACHIEVES]\n",
  "ACHIEVED": "ACHIEVE, to carry out successfully [v]\n",
  "ACHIEVEMENT": "the act of achieving [n -S]\n",
  "ACHIEVEMENTS": "ACHIEVEMENT, the act of achieving [n]\n",
  "ACHIEVER": "one who achieves [n -S]\n",
  "ACHIEVERS": "ACHIEVER, one who achieves [n]\n",
  "ACHIEVES": "ACHIEVE, to carry out successfully [v]\n",
  "ACHIEVING": "ACHIEVE, to carry out successfully [v]\n",
  "ACHILLEA": "a plant of the yarrow genus [n -S]\n",
  "ACHILLEAS": "ACHILLEA, a plant of the yarrow genus [n]\n",
  "ACHIMENES": "(Latin) a genus of herbaceous perennial plants [n ACHIMENES]\n",
  "ACHINESS": "the state of having aches [n -ES]\n",
  "ACHINESSES": "ACHINESS, the state of having aches [n]\n",
  "ACHING": "hurting, throbbing [adj ACHINGLY] / a continuing pain [n -S]\n",
  "ACHINGLY": "ACHING, hurting, throbbing [adv]\n",
  "ACHINGS": "ACHING, a continuing pain [n]\n",
  "ACHIOTE": "(Nahuatl) the seeds of the annatto tree [n -S]\n",
  "ACHIOTES": "ACHIOTE, (Nahuatl) the seeds of the annatto tree [n]\n",
  "ACHIRAL": "of, relating to, or being a molecule that is superimposable on its mirror image [adj]\n",
  "ACHKAN": "(Hindi) in India, a knee-length coat with a high collar [n -S]\n",
  "ACHKANS": "ACHKAN, (Hindi) in India, a knee-length coat with a high collar [n]\n",
  "ACHLAMYDEOUS": "without a perianth [adj]\n",
  "ACHLORHYDRIA": "absence of hydrochloric acid from the gastric juice [n -S]\n",
  "ACHLORHYDRIAS": "ACHLORHYDRIA, absence of hydrochloric acid from the gastric juice [n]\n",
  "ACHLORHYDRIC": "relating to achlorhydria, absence of hydrochloric acid from the gastric juice [adj]\n",
  "ACHOLIA": "a lack of bile [n -S]\n",
  "ACHOLIAS": "ACHOLIA, a lack of bile [n]\n",
  "ACHONDRITE": "a stony meteorite without rounded grains [n -S]\n",
  "ACHONDRITES": "ACHONDRITE, a stony meteorite without rounded grains [n]\n",
  "ACHONDRITIC": "of or like an achondrite, a stony meteorite without rounded grains [adj]\n",
  "ACHONDROPLASIA": "a condition where cartilage does not develop normally, resulting in dwarfism [n -S]\n",
  "ACHONDROPLASIAS": "ACHONDROPLASIA, a condition where cartilage does not develop normally, resulting in dwarfism [n]\n",
  "ACHONDROPLASTIC": "suffering from achondroplasia [adj]\n",
  "ACHOO": "an imitation of the sound of a sneeze, also AHCHOO, ATISHOO [n -S]\n",
  "ACHOOS": "ACHOO, an imitation of the sound of a sneeze, also AHCHOO, ATISHOO [n]\n",
  "ACHROMAT": "a light transmitting lens [n -S]\n",
  "ACHROMATIC": "free from colour; transmitting light without decomposing it into its constituent colours [adj ACHROMATICALLY]\n",
  "ACHROMATICALLY": "ACHROMATIC, free from colour; transmitting light without decomposing it into its constituent colours [adv]\n",
  "ACHROMATICITIES": "ACHROMATICITY, the state of being achromatic [n]\n",
  "ACHROMATICITY": "the state of being achromatic [n ACHROMATICITIES]\n",
  "ACHROMATIN": "tissue which is not stained by fluid dyes [n -S]\n",
  "ACHROMATINS": "ACHROMATIN, tissue which is not stained by fluid dyes [n]\n",
  "ACHROMATISATION": "the process of achromatising, also ACHROMATIZATION [n]\n",
  "ACHROMATISE": "to make achromatic, also ACHROMATIZE [v ACHROMATISED, ACHROMATISING, ACHROMATISES]\n",
  "ACHROMATISED": "ACHROMATISE, to make achromatic, also ACHROMATIZE [v]\n",
  "ACHROMATISES": "ACHROMATISE, to make achromatic, also ACHROMATIZE [v]\n",
  "ACHROMATISING": "ACHROMATISE, to make achromatic, also ACHROMATIZE [v]\n",
  "ACHROMATISM": "the state of being achromatic [n -S]\n",
  "ACHROMATISMS": "ACHROMATISM, the state of being achromatic [n]\n",
  "ACHROMATIZATION": "the process of achromatizing, also ACHROMATISATION [n]\n",
  "ACHROMATIZE": "to make achromatic, also ACHROMATISE [v ACHROMATIZED, ACHROMATIZING, ACHROMATIZES]\n",
  "ACHROMATIZED": "ACHROMATIZE, to make achromatic, also ACHROMATISE [v]\n",
  "ACHROMATIZES": "ACHROMATIZE, to make achromatic, also ACHROMATISE [v]\n",
  "ACHROMATIZING": "ACHROMATIZE, to make achromatic, also ACHROMATISE [v]\n",
  "ACHROMATOPSIA": "total colour-blindness, where only white, grey and black are visible [n -S]\n",
  "ACHROMATOPSIAS": "ACHROMATOPSIA, total colour-blindness, where only white, grey and black are visible [n]\n",
  "ACHROMATOUS": "having little or no colour [adj]\n",
  "ACHROMATS": "ACHROMAT, a light transmitting lens [n]\n",
  "ACHROMIC": "having no colour [adj]\n",
  "ACHROMOUS": "colourless, also ACHROMIC [adj]\n",
  "ACHY": "aching [adj ACHIER, ACHIEST]\n",
  "ACICLOVIR": "a drug used in the treatment of forms of herpes and of HIV, also ACYCLOVIR [n -S]\n",
  "ACICLOVIRS": "ACICLOVIR, a drug used in the treatment of forms of herpes and of HIV, also ACYCLOVIR [n]\n",
  "ACICULA": "(Latin) a needlelike bristle or spine [n ACICULAS or ACICULAE]\n",
  "ACICULAE": "ACICULA, (Latin) a needlelike bristle or spine [n]\n",
  "ACICULAR": "needle-shaped [adj]\n",
  "ACICULAS": "ACICULA, (Latin) a needlelike bristle or spine [n]\n",
  "ACICULATE": "marked as if with needle scratches, also ACICULATED [adj]\n",
  "ACICULATED": "marked as if with needle scratches, also ACICULATE [adj]\n",
  "ACICULUM": "(Latin) a bristlelike part [n ACICULUMS or ACICULA]\n",
  "ACICULUMS": "ACICULUM, (Latin) a bristlelike part [n]\n",
  "ACID": "sharp, sour [adj ACIDER, ACIDEST, ACIDLY] / a type of chemical compound [n -S]\n",
  "ACIDANTHERA": "a plant of the genus Acidanthera of white-flowered plants of NE Africa [n -S]\n",
  "ACIDANTHERAS": "ACIDANTHERA, a plant of the genus Acidanthera of white-flowered plants of NE Africa [n]\n",
  "ACIDEMIA": "a condition of increased acidity of the blood [n -S]\n",
  "ACIDEMIAS": "ACIDEMIA, a condition of increased acidity of the blood [n]\n",
  "ACIDER": "ACID, sharp, sour [adj]\n",
  "ACIDEST": "ACID, sharp, sour [adj]\n",
  "ACIDHEAD": "a person who takes hallucinogenic drugs [n -S]\n",
  "ACIDHEADS": "ACIDHEAD, a person who takes hallucinogenic drugs [n]\n",
  "ACIDIC": "sour, acid [adj ACIDICALLY]\n",
  "ACIDICALLY": "ACIDIC, sour, acid [adv]\n",
  "ACIDIER": "ACIDY, resembling acid, sour [adj]\n",
  "ACIDIEST": "ACIDY, resembling acid, sour [adj]\n",
  "ACIDIFIABLE": "capable of being acidified [adj]\n",
  "ACIDIFICATION": "the act of acidifying [n -S]\n",
  "ACIDIFICATIONS": "ACIDIFICATION, the act of acidifying [n]\n",
  "ACIDIFIED": "ACIDIFY, to render acid [v]\n",
  "ACIDIFIER": "an agent that acidifies [n -S]\n",
  "ACIDIFIERS": "ACIDIFIER, an agent that acidifies [n]\n",
  "ACIDIFIES": "ACIDIFY, to render acid [v]\n",
  "ACIDIFY": "to render acid [v ACIDIFIED, ACIDIFYING, ACIDIFIES]\n",
  "ACIDIFYING": "ACIDIFY, to render acid [v]\n",
  "ACIDIMETER": "an instrument for measuring concentration of acids, also ACIDOMETER [n -S]\n",
  "ACIDIMETERS": "ACIDIMETER, an instrument for measuring concentration of acids, also ACIDOMETER [n]\n",
  "ACIDIMETRIC": "relating to acidimetry, the measurement of the strength of acids [adj ACIDIMETRICALLY]\n",
  "ACIDIMETRICAL": "relating to acidimetry, the measurement of the strength of acids [adj ACIDIMETRICALLY]\n",
  "ACIDIMETRICALLY": "ACIDIMETRICAL, relating to acidimetry, the measurement of the strength of acids [adv]\n",
  "ACIDIMETRIES": "ACIDIMETRY, the measurement of the strength of acids [n]\n",
  "ACIDIMETRY": "the measurement of the strength of acids [n ACIDIMETRIES]\n",
  "ACIDITIES": "ACIDITY, sourness [n]\n",
  "ACIDITY": "sourness [n ACIDITIES]\n",
  "ACIDLY": "ACID, sharp, sour [adv]\n",
  "ACIDNESS": "acidity; sourness [n -ES]\n",
  "ACIDNESSES": "ACIDNESS, acidity; sourness [n]\n",
  "ACIDOMETER": "a type of hydrometer for measuring the relative density of an acid solution, esp. the acid in a battery, also ACIDIMETER [n -S]\n",
  "ACIDOMETERS": "ACIDOMETER, a type of hydrometer for measuring the relative density of an acid solution, esp. the acid in a battery, also ACIDIMETER [n]\n",
  "ACIDOPHIL": "a substance, tissue or organism that stains readily with acid stains, also ACIDOPHILE [n -S]\n",
  "ACIDOPHILE": "a substance, tissue or organism that stains readily with acid stains, also ACIDOPHIL [n -S]\n",
  "ACIDOPHILES": "ACIDOPHILE, a substance, tissue or organism that stains readily with acid stains, also ACIDOPHIL [n]\n",
  "ACIDOPHILIC": "easily stained by acid dyes; thriving in acid environment [adj]\n",
  "ACIDOPHILOUS": "staining readily with acid stains [adj]\n",
  "ACIDOPHILS": "ACIDOPHIL, a substance, tissue or organism that stains readily with acid stains, also ACIDOPHILE [n]\n",
  "ACIDOPHILUS": "a bacterium used to counter intestinal imbalance and in making yoghurt [n -ES]\n",
  "ACIDOPHILUSES": "ACIDOPHILUS, a bacterium used to counter intestinal imbalance and in making yoghurt [n]\n",
  "ACIDOSES": "ACIDOSIS, the presence of abnormal acid in the blood [n]\n",
  "ACIDOSIS": "the presence of abnormal acid in the blood [n ACIDOSES]\n",
  "ACIDOTIC": "pertaining to an abnormal blood acid [adj]\n",
  "ACIDS": "ACID, a type of chemical compound [n]\n",
  "ACIDULATE": "to make acidulous [v ACIDULATED, ACIDULATING, ACIDULATES]\n",
  "ACIDULATED": "ACIDULATE, to make acidulous [v]\n",
  "ACIDULATES": "ACIDULATE, to make acidulous [v]\n",
  "ACIDULATING": "ACIDULATE, to make acidulous [v]\n",
  "ACIDULATION": "the process of making slightly acid [n -S]\n",
  "ACIDULATIONS": "ACIDULATION, the process of making slightly acid [n]\n",
  "ACIDULENT": "having an acid quality, also ACIDULOUS [adj]\n",
  "ACIDULOUS": "having an acid quality, also ACIDULENT [adj]\n",
  "ACIDURIA": "excessive acid in the urine [n -S]\n",
  "ACIDURIAS": "ACIDURIA, excessive acid in the urine [n]\n",
  "ACIDY": "resembling acid, sour [adj ACIDIER, ACIDIEST]\n",
  "ACIERAGE": "(French) the covering of a metal plate with an iron film [n -S]\n",
  "ACIERAGES": "ACIERAGE, (French) the covering of a metal plate with an iron film [n]\n",
  "ACIERATE": "to turn into steel [v ACIERATED, ACIERATING, ACIERATES]\n",
  "ACIERATED": "ACIERATE, to turn into steel [v]\n",
  "ACIERATES": "ACIERATE, to turn into steel [v]\n",
  "ACIERATING": "ACIERATE, to turn into steel [v]\n",
  "ACIERATION": "the process of turning into steel [n -S]\n",
  "ACIERATIONS": "ACIERATION, the process of turning into steel [n]\n",
  "ACIFORM": "needle-shaped [adj]\n",
  "ACINACEOUS": "full of kernels [adj]\n",
  "ACINACIFORM": "scimitar-shaped [adj]\n",
  "ACINAR": "relating to a sacklike division of a gland, also ACINOSE, ACINIC, ACINOUS [adj]\n",
  "ACINETOBACTER": "a kind of bacteria, instrumental in causing respiratory disease [n -S]\n",
  "ACINETOBACTERS": "ACINETOBACTER, a kind of bacteria, instrumental in causing respiratory disease [n]\n",
  "ACING": "ACE, to serve an unreturnable shot e.g. in tennis [v]\n",
  "ACINI": "ACINUS, (Latin) a small sacklike division of a gland [n]\n",
  "ACINIC": "relating to a sacklike division of a gland, also ACINOSE, ACINAR, ACINOUS [adj]\n",
  "ACINIFORM": "shaped like cluster of grapes [adj]\n",
  "ACINOSE": "relating to a saclike division of a gland, also ACINAR, ACINIC, ACINOUS [adj]\n",
  "ACINOUS": "relating to a saclike division of a gland, also ACINOSE, ACINAR, ACINIC [adj]\n",
  "ACINUS": "(Latin) a small sacklike division of a gland [n ACINI]\n",
  "ACKEE": "(Kru) a small African sapindaceous tree; its edible fruit, often used in Caribbean cookery, also AKEE [n -S]\n",
  "ACKEES": "ACKEE, (Kru) a small African sapindaceous tree; its edible fruit, often used in Caribbean cookery, also AKEE [n]\n",
  "ACKER": "(Australian slang) an academic, also ACCA [n -S]\n",
  "ACKERS": "ACKER, (Australian slang) an academic, also ACCA [n]\n",
  "ACKNEW": "ACKNOW, (obsolete) to recognize, acknowledge [v]\n",
  "ACKNOW": "(obsolete) to recognize, acknowledge [v ACKNEW, ACKNOWN or ACKNOWNE, ACKNOWING, ACKNOWS]\n",
  "ACKNOWING": "ACKNOW, (obsolete) to recognize, acknowledge [v]\n",
  "ACKNOWLEDGE": "to recognize the rights, authority, or status of [v ACKNOWLEDGED, ACKNOWLEDGING, ACKNOWLEDGES]\n",
  "ACKNOWLEDGEABLE": "capable of being acknowledged [adj ACKNOWLEDGEABLY]\n",
  "ACKNOWLEDGEABLY": "ACKNOWLEDGEABLE, capable of being acknowledged [adv]\n",
  "ACKNOWLEDGED": "ACKNOWLEDGE, to recognize the rights, authority, or status of [v]\n",
  "ACKNOWLEDGEDLY": "ACKNOWLEDGED, ACKNOWLEDGE, to recognize the rights, authority, or status of [adv]\n",
  "ACKNOWLEDGEMENT": "the act of acknowledging, also ACKNOWLEDGMENT [n]\n",
  "ACKNOWLEDGER": "one who acknowledges [n -S]\n",
  "ACKNOWLEDGERS": "ACKNOWLEDGER, one who acknowledges [n]\n",
  "ACKNOWLEDGES": "ACKNOWLEDGE, to recognize the rights, authority, or status of [v]\n",
  "ACKNOWLEDGING": "ACKNOWLEDGE, to recognize the rights, authority, or status of [v]\n",
  "ACKNOWLEDGMENT": "the act of acknowledging, also ACKNOWLEDGEMENT [n -S]\n",
  "ACKNOWLEDGMENTS": "ACKNOWLEDGMENT, the act of acknowledging, also ACKNOWLEDGEMENT [n]\n",
  "ACKNOWN": "ACKNOW, (obsolete) to recognize, acknowledge [v]\n",
  "ACKNOWNE": "(Shakespeare) aware, confessedly cognizant [adj]\n",
  "ACKNOWS": "ACKNOW, (obsolete) to recognize, acknowledge [v]\n",
  "ACLINIC": "applied to a line passing through all points where there is no magnetic inclination [adj]\n",
  "ACMATIC": "relating to the acme, the highest point [adj]\n",
  "ACME": "(Greek) the highest point [n -S]\n",
  "ACMES": "ACME, (Greek) the highest point [n]\n",
  "ACMIC": "relating to the highest point [adj]\n",
  "ACMITE": "a soda pyroxene whose crystals show a steep pyramid [n -S]\n",
  "ACMITES": "ACMITE, a soda pyroxene whose crystals show a steep pyramid [n]\n",
  "ACNE": "a skin disease caused by inflammation of the sebaceous follicles, esp. on the face, neck, and shoulders [n -S]\n",
  "ACNED": "afflicted with acne [adj]\n",
  "ACNES": "ACNE, a skin disease caused by inflammation of the sebaceous follicles, esp. on the face, neck, and shoulders [n]\n",
  "ACNODAL": "being an isolated point on a mathematical curve [adj]\n",
  "ACNODE": "an isolated point not upon a curve, but whose coordinates satisfy the equation of the curve so that it is considered as belonging to the curve [n -S]\n",
  "ACNODES": "ACNODE, an isolated point not upon a curve, but whose coordinates satisfy the equation of the curve so that it is considered as belonging to the curve [n]\n",
  "ACOCK": "in a cocked position, defiantly [adj]\n",
  "ACOELOMATE": "an animal that lacks a coelom, for example platyhelminths (flatworms) [n -S]\n",
  "ACOELOMATES": "ACOELOMATE, an animal that lacks a coelom, for example platyhelminths (flatworms) [n]\n",
  "ACOELOUS": "lacking a coelom, a body cavity [adj]\n",
  "ACOEMETI": "(Greek) an ancient monastic order who maintained an eternal choir service [n]\n",
  "ACOLD": "(Shakespeare) chilled [adj]\n",
  "ACOLOUTHIC": "pertaining to an afterimage or other aftersensation, also ACOLUTHIC [adj]\n",
  "ACOLOUTHITE": "(obsolete) an acolyte [n -S]\n",
  "ACOLOUTHITES": "ACOLOUTHITE, (obsolete) an acolyte [n]\n",
  "ACOLOUTHOS": "(historical) the head of the Varangian guard of the Byzantine emperors, also AKOLOUTHOS, AKOLUTHOS [n -ES]\n",
  "ACOLOUTHOSES": "ACOLOUTHOS, (historical) the head of the Varangian guard of the Byzantine emperors, also AKOLOUTHOS, AKOLUTHOS [n]\n",
  "ACOLUTHIC": "pertaining to an afterimage or other aftersensation, also ACOLOUTHIC [adj]\n",
  "ACOLYTE": "a faithful follower, also ACOLYTH [n -S]\n",
  "ACOLYTES": "ACOLYTE, a faithful follower, also ACOLYTH [n]\n",
  "ACOLYTH": "(obsolete) a faithful follower, also ACOLYTE [n -S]\n",
  "ACOLYTHS": "ACOLYTH, (obsolete) a faithful follower, also ACOLYTE [n]\n",
  "ACONITE": "a poisonous herb, the monkshood or wolfsbane plant, also ACONITUM [n -S]\n",
  "ACONITES": "ACONITE, a poisonous herb, the monkshood or wolfsbane plant, also ACONITUM [n]\n",
  "ACONITIC": "of or pertaining to aconite, an alkaloidal extract from monkshood or the like used as a poison or in pharmacy [adj]\n",
  "ACONITINE": "a poisonous alkaloid obtained from aconite [n -S]\n",
  "ACONITINES": "ACONITINE, a poisonous alkaloid obtained from aconite [n]\n",
  "ACONITUM": "(Latin) the poisonous herb aconite; also, an extract from it, also ACONITE [n -S]\n",
  "ACONITUMS": "ACONITUM, (Latin) the poisonous herb aconite; also, an extract from it, also ACONITE [n]\n",
  "ACORN": "the fruit of the oak tree [n -S]\n",
  "ACORNED": "bearing acorns [adj]\n",
  "ACORNS": "ACORN, the fruit of the oak tree [n]\n",
  "ACOSMISM": "a doctrine denying the existence of a universe distinct from God [n -S]\n",
  "ACOSMISMS": "ACOSMISM, a doctrine denying the existence of a universe distinct from God [n]\n",
  "ACOSMIST": "one who denies the existence of a universe distinct from God [n -S]\n",
  "ACOSMISTS": "ACOSMIST, one who denies the existence of a universe distinct from God [n]\n",
  "ACOTYLEDON": "a plant without differentiated seed lobes [n -S]\n",
  "ACOTYLEDONOUS": "relating to an acotyledon [adj]\n",
  "ACOTYLEDONS": "ACOTYLEDON, a plant without differentiated seed lobes [n]\n",
  "ACOUCHI": "(Tupi) a burrowing rodent, also AGOUTI, ACOUCHY, AGOUTY, AGUTI [n -S]\n",
  "ACOUCHIES": "ACOUCHY, (Tupi) a burrowing rodent, also AGOUTI, ACOUCHI, AGOUTY, AGUTI [n]\n",
  "ACOUCHIS": "ACOUCHI, (Tupi) a burrowing rodent, also AGOUTI, ACOUCHY, AGOUTY, AGUTI [n]\n",
  "ACOUCHY": "(Tupi) a burrowing rodent, also AGOUTI, ACOUCHI, AGOUTY, AGUTI [n ACOUCHIES]\n",
  "ACOUSTIC": "a sense of hearing [n -S]\n",
  "ACOUSTICAL": "relating to the science of sound, also ACOUSTIC [adj ACOUSTICALLY]\n",
  "ACOUSTICALLY": "ACOUSTICAL, relating to the science of sound, also ACOUSTIC [adv]\n",
  "ACOUSTICIAN": "one versed in the science of acoustics [n -S]\n",
  "ACOUSTICIANS": "ACOUSTICIAN, one versed in the science of acoustics [n]\n",
  "ACOUSTICS": "ACOUSTIC, a sense of hearing [n]\n",
  "ACQUAINT": "to cause to know [v -ED, -ING, -S]\n",
  "ACQUAINTANCE": "the state of being acquainted [n -S]\n",
  "ACQUAINTANCES": "ACQUAINTANCE, the state of being acquainted [n]\n",
  "ACQUAINTED": "ACQUAINT, to cause to know [v]\n",
  "ACQUAINTING": "ACQUAINT, to cause to know [v]\n",
  "ACQUAINTS": "ACQUAINT, to cause to know [v]\n",
  "ACQUEST": "a thing acquired; specifically property gained otherwise than by inheritance, also ACQUIST [n -S]\n",
  "ACQUESTS": "ACQUEST, a thing acquired; specifically property gained otherwise than by inheritance, also ACQUIST [n]\n",
  "ACQUIESCE": "to agree, accept [v ACQUIESCED, ACQUIESCING, ACQUIESCES]\n",
  "ACQUIESCED": "ACQUIESCE, to agree, accept [v]\n",
  "ACQUIESCENCE": "the act of acquiescing [n -S]\n",
  "ACQUIESCENCES": "ACQUIESCENCE, the act of acquiescing [n]\n",
  "ACQUIESCENT": "inclined to acquiesce [adj ACQUIESCENTLY] / a person who acquiesces [n -S]\n",
  "ACQUIESCENTLY": "ACQUIESCENT, inclined to acquiesce [adv]\n",
  "ACQUIESCENTS": "ACQUIESCENT, a person who acquiesces [n]\n",
  "ACQUIESCES": "ACQUIESCE, to agree, accept [v]\n",
  "ACQUIESCING": "ACQUIESCE, to agree, accept [v]\n",
  "ACQUIESCINGLY": "ACQUIESCING, ACQUIESCE, to agree, accept [adv]\n",
  "ACQUIGHT": "(obsolete) to free from a charge, also ACQUIT, ACQUITE [v ACQUIT, ACQUIGHTING, ACQUIGHTS]\n",
  "ACQUIGHTING": "ACQUIGHT, (obsolete) to free from a charge, also ACQUIT, ACQUITE [v]\n",
  "ACQUIGHTS": "ACQUIGHT, (obsolete) to free from a charge, also ACQUIT, ACQUITE [v]\n",
  "ACQUIRABILITIES": "ACQUIRABILITY, the ability to be acquired [n]\n",
  "ACQUIRABILITY": "the ability to be acquired [n ACQUIRABILITIES]\n",
  "ACQUIRABLE": "able to be acquired [adj]\n",
  "ACQUIRAL": "getting or attainment [n -S]\n",
  "ACQUIRALS": "ACQUIRAL, getting or attainment [n]\n",
  "ACQUIRE": "to come into possession of [v ACQUIRED, ACQUIRING, ACQUIRES]\n",
  "ACQUIRED": "ACQUIRE, to come into possession of [v]\n",
  "ACQUIREE": "one that is acquired [n -S]\n",
  "ACQUIREES": "ACQUIREE, one that is acquired [n]\n",
  "ACQUIREMENT": "a skill of mind or body usually resulting from continued endeavor [n -S]\n",
  "ACQUIREMENTS": "ACQUIREMENT, a skill of mind or body usually resulting from continued endeavor [n]\n",
  "ACQUIRER": "one who acquires [n -S]\n",
  "ACQUIRERS": "ACQUIRER, one who acquires [n]\n",
  "ACQUIRES": "ACQUIRE, to come into possession of [v]\n",
  "ACQUIRING": "ACQUIRE, to come into possession of [v]\n",
  "ACQUIS": "(French) a particular piece or section of European Union legislation [n ACQUIS]\n",
  "ACQUISITION": "the act of acquiring [n -S]\n",
  "ACQUISITIONAL": "of or like an acquisition [adj]\n",
  "ACQUISITIONS": "ACQUISITION, the act of acquiring [n]\n",
  "ACQUISITIVE": "strongly desirous of acquiring and possessing [adj ACQUISITIVELY]\n",
  "ACQUISITIVELY": "ACQUISITIVE, strongly desirous of acquiring and possessing [adv]\n",
  "ACQUISITIVENESS": "the quality of being acquisitive [n]\n",
  "ACQUISITOR": "one who makes an acquisition [n -S]\n",
  "ACQUISITORS": "ACQUISITOR, one who makes an acquisition [n]\n",
  "ACQUIST": "a thing acquired; specifically property gained otherwise than by inheritance, also ACQUEST [n -S]\n",
  "ACQUISTS": "ACQUIST, a thing acquired; specifically property gained otherwise than by inheritance, also ACQUEST [n]\n",
  "ACQUIT": "to free from a charge [v ACQUITTED, ACQUITTING, ACQUITS]\n",
  "ACQUITE": "(obsolete) to free from a charge, also ACQUIT, ACQUIGHT [v ACQUIT, ACQUITING, ACQUITES]\n",
  "ACQUITES": "ACQUITE, (obsolete) to free from a charge, also ACQUIT, ACQUIGHT [v]\n",
  "ACQUITING": "ACQUITE, (obsolete) to free from a charge, also ACQUIT, ACQUIGHT [v]\n",
  "ACQUITMENT": "(obsolete) acquittal [n -S]\n",
  "ACQUITMENTS": "ACQUITMENT, (obsolete) acquittal [n]\n",
  "ACQUITS": "ACQUIT, to free from a charge [v]\n",
  "ACQUITTAL": "the act of acquitting [n -S]\n",
  "ACQUITTALS": "ACQUITTAL, the act of acquitting [n]\n",
  "ACQUITTANCE": "payment of, or release from, debt [n -S] / (Shakespeare) to acquit or clear [v ACQUITTANCED, ACQUITTANCING, ACQUITTANCES]\n",
  "ACQUITTANCED": "ACQUITTANCE, (Shakespeare) to acquit or clear [v]\n",
  "ACQUITTANCES": "ACQUITTANCE, (Shakespeare) to acquit or clear [v]\n",
  "ACQUITTANCING": "ACQUITTANCE, (Shakespeare) to acquit or clear [v]\n",
  "ACQUITTED": "ACQUIT, to free from a charge [v]\n",
  "ACQUITTER": "one who acquits [n -S]\n",
  "ACQUITTERS": "ACQUITTER, one who acquits [n]\n",
  "ACQUITTING": "ACQUIT, to free from a charge [v]\n",
  "ACRASIA": "(Greek) a loss of self control [n -S]\n",
  "ACRASIAS": "ACRASIA, (Greek) a loss of self control [n]\n",
  "ACRASIN": "a substance secreted by a slime mould [n -S]\n",
  "ACRASINS": "ACRASIN, a substance secreted by a slime mould [n]\n",
  "ACRATIC": "pertaining to acrasia or lack of self-control [adj]\n",
  "ACRAWL": "crawling [adv]\n",
  "ACRE": "a measure of land equivalent to 4840 square yards [n -S]\n",
  "ACREAGE": "area in acres [n -S]\n",
  "ACREAGES": "ACREAGE, area in acres [n]\n",
  "ACRED": "possessing acres, landed [adj]\n",
  "ACRES": "ACRE, a measure of land equivalent to 4840 square yards [n]\n",
  "ACRID": "sharp to the taste or smell [adj ACRIDER, ACRIDEST, ACRIDLY]\n",
  "ACRIDER": "ACRID, sharp to the taste or smell [adj]\n",
  "ACRIDEST": "ACRID, sharp to the taste or smell [adj]\n",
  "ACRIDIN": "a chemical compound found in coal-tar, also ACRIDINE [n -S]\n",
  "ACRIDINE": "a chemical compound found in coal-tar, also ACRIDIN [n -S]\n",
  "ACRIDINES": "ACRIDINE, a chemical compound found in coal-tar, also ACRIDIN [n]\n",
  "ACRIDINS": "ACRIDIN, a chemical compound found in coal-tar, also ACRIDINE [n]\n",
  "ACRIDITIES": "ACRIDITY, the state of being acrid [n]\n",
  "ACRIDITY": "the state of being acrid [n ACRIDITIES]\n",
  "ACRIDLY": "ACRID, sharp to the taste or smell [adv]\n",
  "ACRIDNESS": "the quality of being acrid [n -ES]\n",
  "ACRIDNESSES": "ACRIDNESS, the quality of being acrid [n]\n",
  "ACRIFLAVIN": "an antiseptic, also ACRIFLAVINE [n -S]\n",
  "ACRIFLAVINE": "an antiseptic, also ACRIFLAVIN [n -S]\n",
  "ACRIFLAVINES": "ACRIFLAVINE, an antiseptic, also ACRIFLAVIN [n]\n",
  "ACRIFLAVINS": "ACRIFLAVIN, an antiseptic, also ACRIFLAVINE [n]\n",
  "ACRIMONIES": "ACRIMONY, bitterness of feeling [n]\n",
  "ACRIMONIOUS": "caustic, biting, or rancorous esp. in feeling, language, or manner [adj ACRIMONIOUSLY]\n",
  "ACRIMONIOUSLY": "ACRIMONIOUS, caustic, biting, or rancorous esp. in feeling, language, or manner [adv]\n",
  "ACRIMONIOUSNESS": "the quality of being acrimonious [n]\n",
  "ACRIMONY": "bitterness of feeling [n ACRIMONIES]\n",
  "ACRITARCH": "any of a group of fossil one-celled marine organisms [n -S]\n",
  "ACRITARCHS": "ACRITARCH, any of a group of fossil one-celled marine organisms [n]\n",
  "ACRITICAL": "not critical [adj]\n",
  "ACRO": "a skiing event in which a skier performs acrobatic moves to music [n -S]\n",
  "ACROAMATIC": "abstruse, esoteric, also ACROAMATICAL [adj]\n",
  "ACROAMATICAL": "abstruse, esoteric, also ACROAMATIC [adj]\n",
  "ACROBAT": "one skilled in gymnastic feats [n -S]\n",
  "ACROBATIC": "like an acrobat, agile [adj ACROBATICALLY]\n",
  "ACROBATICALLY": "ACROBATIC, like an acrobat, agile [adv]\n",
  "ACROBATICS": "the art, performance, or activity of an acrobat [n]\n",
  "ACROBATISM": "the art of the acrobat [n -S]\n",
  "ACROBATISMS": "ACROBATISM, the art of the acrobat [n]\n",
  "ACROBATS": "ACROBAT, one skilled in gymnastic feats [n]\n",
  "ACROCARPOUS": "of mosses, having the archegonia at the top of the stem [adj]\n",
  "ACROCENTRIC": "a rod-shaped chromosome [n -S]\n",
  "ACROCENTRICS": "ACROCENTRIC, a rod-shaped chromosome [n]\n",
  "ACROCYANOSES": "ACROCYANOSIS, persistent cyanosis of the hands and feet due to poor circulation of the blood [n]\n",
  "ACROCYANOSIS": "persistent cyanosis of the hands and feet due to poor circulation of the blood [n ACROCYANOSES]\n",
  "ACRODONT": "having teeth fused with the jaw [adj] / an acrodont animal [n -S]\n",
  "ACRODONTS": "ACRODONT, an acrodont animal [n]\n",
  "ACRODROME": "of the veins in a leaf, running parallel to the edges of the leaf and fusing at the tip, also ACRODROMOUS [adj]\n",
  "ACRODROMOUS": "of the veins in a leaf, running parallel to the edges of the leaf and fusing at the tip, also ACRODROME [adj]\n",
  "ACROGEN": "a cryptogam with a distinct permanent stem; a fern, a moss [n -S]\n",
  "ACROGENIC": "like or relating to an acrogen, a cryptogam with a distinct permanent stem [adj]\n",
  "ACROGENOUS": "like or relating to an acrogen, a cryptogam with a distinct permanent stem [adj ACROGENOUSLY]\n",
  "ACROGENOUSLY": "ACROGENOUS, like or relating to an acrogen, a cryptogam with a distinct permanent stem [adv]\n",
  "ACROGENS": "ACROGEN, a cryptogam with a distinct permanent stem; a fern, a moss [n]\n",
  "ACROLECT": "a variety of language closest to the prestige form [n -S]\n",
  "ACROLECTS": "ACROLECT, a variety of language closest to the prestige form [n]\n",
  "ACROLEIN": "a flammable liquid, an aldehyde of allyl alcohol [n -S]\n",
  "ACROLEINS": "ACROLEIN, a flammable liquid, an aldehyde of allyl alcohol [n]\n",
  "ACROLITH": "(Greek) a statue with a wooden trunk and stone head and extremities [n -S]\n",
  "ACROLITHIC": "pertaining to, or like, an acrolith, a statue with a wooden trunk and stone head and extremities [adj]\n",
  "ACROLITHS": "ACROLITH, (Greek) a statue with a wooden trunk and stone head and extremities [n]\n",
  "ACROMEGALIC": "relating to acromegaly [adj] / one suffering from acromegaly [n -S]\n",
  "ACROMEGALICS": "ACROMEGALIC, one suffering from acromegaly [n]\n",
  "ACROMEGALIES": "ACROMEGALY, a glandular disorder causing gigantism of extremities [n]\n",
  "ACROMEGALY": "a glandular disorder causing gigantism of extremities [n ACROMEGALIES]\n",
  "ACROMIA": "ACROMION, (Greek) the outer extremity of the shoulder blade [n]\n",
  "ACROMIAL": "of or pertaining to the acromion, the outer extremity of the shoulder blade [adj]\n",
  "ACROMION": "(Greek) the outer extremity of the shoulder blade [n ACROMIA]\n",
  "ACRONIC": "occurring at nightfall or sunset (esp. of the rising or setting of stars), also ACRONICAL, ACRONYCAL, ACRONYCHAL [adj ACRONICALLY]\n",
  "ACRONICAL": "occurring at nightfall or sunset, (esp. of the rising or setting of stars), also ACRONIC, ACRONYCAL, ACRONYCHAL [adj ACRONICALLY]\n",
  "ACRONICALLY": "ACRONICAL, occurring at nightfall or sunset, (esp. of the rising or setting of stars), also ACRONIC, ACRONYCAL, ACRONYCHAL [adv]\n",
  "ACRONYCAL": "occurring at nightfall or sunset, (esp. of the rising or setting of stars), also ACRONIC, ACRONICAL, ACRONYCHAL [adj ACRONYCALLY]\n",
  "ACRONYCALLY": "ACRONYCAL, occurring at nightfall or sunset, (esp. of the rising or setting of stars), also ACRONIC, ACRONICAL, ACRONYCHAL [adv]\n",
  "ACRONYCHAL": "occurring at nightfall or sunset (esp. of the rising or setting of stars), also ACRONIC, ACRONICAL, ACRONYCAL [adj ACRONYCHALLY]\n",
  "ACRONYCHALLY": "ACRONYCHAL, occurring at nightfall or sunset (esp. of the rising or setting of stars), also ACRONIC, ACRONICAL, ACRONYCAL [adv]\n",
  "ACRONYM": "a word formed from the initial letters of other words [n -S]\n",
  "ACRONYMANIA": "a craze for acronyms [n -S]\n",
  "ACRONYMANIAS": "ACRONYMANIA, a craze for acronyms [n]\n",
  "ACRONYMIC": "relating to an acronym, a word fabricated from the initial letters of a name or phrase [adj ACRONYMICALLY]\n",
  "ACRONYMICALLY": "ACRONYMIC, relating to an acronym, a word fabricated from the initial letters of a name or phrase [adv]\n",
  "ACRONYMOUS": "of or like an acronym, a word formed from the initial letters of other words [adj]\n",
  "ACRONYMS": "ACRONYM, a word formed from the initial letters of other words [n]\n",
  "ACROPARESTHESIA": "a persistent sensation of numbness and tingling in the hands and feet [n]\n",
  "ACROPETAL": "in the direction of the tip of the plant [adj ACROPETALLY]\n",
  "ACROPETALLY": "ACROPETAL, in the direction of the tip of the plant [adv]\n",
  "ACROPHOBE": "someone with an abnormal fear of heights [n -S]\n",
  "ACROPHOBES": "ACROPHOBE, someone with an abnormal fear of heights [n]\n",
  "ACROPHOBIA": "fear of heights [n -S]\n",
  "ACROPHOBIAS": "ACROPHOBIA, fear of heights [n]\n",
  "ACROPHOBIC": "suffering from acrophobia, fear of heights [adj] / one suffering from acrophobia [n -S]\n",
  "ACROPHOBICS": "ACROPHOBIC, one suffering from acrophobia [n]\n",
  "ACROPHONETIC": "relating to acrophony, the use of a word starting with a letter of the alphabet as the name of the letter, also ACROPHONIC [adj]\n",
  "ACROPHONIC": "relating to acrophony, the use of a word starting with a letter of the alphabet as the name of the letter, also ACROPHONETIC [adj]\n",
  "ACROPHONIES": "ACROPHONY, the use of a word starting with a letter of the alphabet as the name of the letter [n]\n",
  "ACROPHONY": "the use of a word starting with a letter of the alphabet as the name of the letter [n ACROPHONIES]\n",
  "ACROPOLIS": "(Greek) a citadel, esp. that of Athens [n -ES]\n",
  "ACROPOLISES": "ACROPOLIS, (Greek) a citadel, esp. that of Athens [n]\n",
  "ACROS": "ACRO, a skiing event in which a skier performs acrobatic moves to music [n]\n",
  "ACROSOMAL": "relating to an acrosome, a structure containing enzymes found at the tip of the spine [adj]\n",
  "ACROSOME": "a thin sac at the head of the sperm [n -S]\n",
  "ACROSOMES": "ACROSOME, a thin sac at the head of the sperm [n]\n",
  "ACROSPIRE": "the first real shoot developing in a germinating grain seed [n -S]\n",
  "ACROSPIRES": "ACROSPIRE, the first real shoot developing in a germinating grain seed [n]\n",
  "ACROSS": "from one side to the other [prep]\n",
  "ACROSTIC": "a poem in acronym form [n -S]\n",
  "ACROSTICAL": "pertaining to, or characterized by, acrostics [adj ACROSTICALLY]\n",
  "ACROSTICALLY": "ACROSTICAL, pertaining to, or characterized by, acrostics [adv]\n",
  "ACROSTICS": "ACROSTIC, a poem in acronym form [n]\n",
  "ACROTER": "a pedestal or ornament at the angle of a pediment, also ACROTERION, ACROTERIUM [n -S]\n",
  "ACROTERIA": "ACROTERIUM, a pedestal or ornament at the angle of a pediment, also ACROTER, ACROTERION [n]\n",
  "ACROTERIAL": "pertaining to an acroterium; as, acroterial ornaments [adj]\n",
  "ACROTERION": "a pedestal or ornament at the angle of a pediment, also ACROTER, ACROTERIUM [n ACROTERIA]\n",
  "ACROTERIUM": "a pedestal or ornament at the angle of a pediment, also ACROTER, ACROTERION [n ACROTERIA]\n",
  "ACROTERS": "ACROTER, a pedestal or ornament at the angle of a pediment, also ACROTERION, ACROTERIUM [n]\n",
  "ACROTIC": "in medicine, relating to the surface [adj]\n",
  "ACROTISM": "absence of pulsation [n -S]\n",
  "ACROTISMS": "ACROTISM, absence of pulsation [n]\n",
  "ACRYLAMIDE": "an amide used in the manufacture of synthetic textile fibers [n -S]\n",
  "ACRYLAMIDES": "ACRYLAMIDE, an amide used in the manufacture of synthetic textile fibers [n]\n",
  "ACRYLATE": "a compound used in plasters and resins [n -S]\n",
  "ACRYLATES": "ACRYLATE, a compound used in plasters and resins [n]\n",
  "ACRYLIC": "a type of resin [n -S]\n",
  "ACRYLICS": "ACRYLIC, a type of resin [n]\n",
  "ACRYLONITRILE": "vinyl cyanide, used in making synthetic fibres [n -S]\n",
  "ACRYLONITRILES": "ACRYLONITRILE, vinyl cyanide, used in making synthetic fibres [n]\n",
  "ACRYLYL": "an organic radical [n -S]\n",
  "ACRYLYLS": "ACRYLYL, an organic radical [n]\n",
  "ACT": "to do something in a specified way [v -ED, -ING, -S]\n",
  "ACTA": "(Latin) official minutes of proceedings [n]\n",
  "ACTABILITIES": "ACTABILITY, the ability to be acted [n]\n",
  "ACTABILITY": "the ability to be acted [n ACTABILITIES]\n",
  "ACTABLE": "suitable for performance on the stage [adj]\n",
  "ACTANT": "a noun phrase functioning as the agent of the main verb of a sentence [n -S]\n",
  "ACTANTS": "ACTANT, a noun phrase functioning as the agent of the main verb of a sentence [n]\n",
  "ACTED": "ACT, to do something in a specified way [v]\n",
  "ACTIN": "a protein found in muscle tissue [n -S]\n",
  "ACTINAL": "pertaining to the part of a radiate animal, such as a starfish, which contains the mouth [adj ACTINALLY]\n",
  "ACTINALLY": "ACTINAL, pertaining to the part of a radiate animal, such as a starfish, which contains the mouth [adv]\n",
  "ACTING": "the occupation of an actor [n -S]\n",
  "ACTINGS": "ACTING, the occupation of an actor [n]\n",
  "ACTINIA": "(Greek) a sea-anemone, also ACTINIAN [n ACTINIAS or ACTINIAE]\n",
  "ACTINIAE": "ACTINIA, (Greek) a sea-anemone, also ACTINIAN [n]\n",
  "ACTINIAN": "a sea-anemone, also ACTINIA [n -S]\n",
  "ACTINIANS": "ACTINIAN, a sea-anemone, also ACTINIA [n]\n",
  "ACTINIAS": "ACTINIA, (Greek) a sea-anemone, also ACTINIAN [n]\n",
  "ACTINIC": "of or pertaining to actinism, the property of solar radiation of causing chemical change [adj ACTINICALLY]\n",
  "ACTINICALLY": "ACTINIC, of or pertaining to actinism, the property of solar radiation of causing chemical change [adv]\n",
  "ACTINIDE": "any element of a group from element number 89 (actinium) to 103 (lawrencium), also ACTINOID [n -S]\n",
  "ACTINIDES": "ACTINIDE, any element of a group from element number 89 (actinium) to 103 (lawrencium), also ACTINOID [n]\n",
  "ACTINIFORM": "having a radiate form, like a starfish [adj]\n",
  "ACTINISM": "the property of radiant energy that effects chemical changes [n -S]\n",
  "ACTINISMS": "ACTINISM, the property of radiant energy that effects chemical changes [n]\n",
  "ACTINIUM": "a radioactive metallic chemical element, atomic number 89, the first element of the actinide series [n -S]\n",
  "ACTINIUMS": "ACTINIUM, a radioactive metallic chemical element, atomic number 89, the first element of the actinide series [n]\n",
  "ACTINOBACILLI": "ACTINOBACILLUS, a bacillus of the genus of bacteria Actinobacillus [n]\n",
  "ACTINOBACILLUS": "a bacillus of the genus of bacteria Actinobacillus [n ACTINOBACILLI]\n",
  "ACTINOBIOLOGIES": "ACTINOBIOLOGY, the branch of biology concerned with the effects of radiation on living organisms [n]\n",
  "ACTINOBIOLOGY": "the branch of biology concerned with the effects of radiation on living organisms [n ACTINOBIOLOGIES]\n",
  "ACTINOCHEMISTRY": "another name for photochemistry [n]\n",
  "ACTINOID": "any element of a group from element number 89 (actinium) upwards, also ACTINIDE [n -S]\n",
  "ACTINOIDS": "ACTINOID, any element of a group from element number 89 (actinium) upwards, also ACTINIDE [n]\n",
  "ACTINOLITE": "a bright green variety of amphibole [n -S]\n",
  "ACTINOLITES": "ACTINOLITE, a bright green variety of amphibole [n]\n",
  "ACTINOMERE": "one of any opposite symmetrical or homotypic parts in animals and plants [n -S]\n",
  "ACTINOMERES": "ACTINOMERE, one of any opposite symmetrical or homotypic parts in animals and plants [n]\n",
  "ACTINOMETER": "an instrument for measuring incident radiation [n -S]\n",
  "ACTINOMETERS": "ACTINOMETER, an instrument for measuring incident radiation [n]\n",
  "ACTINOMETRIC": "relating to actinometry, measurement of heating power of the sun's rays, also ACTINOMETRICAL [adj]\n",
  "ACTINOMETRICAL": "relating to actinometry, measurement of heating power of the sun's rays, also ACTINOMETRIC [adj]\n",
  "ACTINOMETRIES": "ACTINOMETRY, the measurement of heating power of the sun's rays [n]\n",
  "ACTINOMETRY": "the measurement of heating power of the sun's rays [n ACTINOMETRIES]\n",
  "ACTINOMORPHIC": "radially symmetric, also ACTINOMORPHOUS [adj]\n",
  "ACTINOMORPHIES": "ACTINOMORPHY, the quality of being actinomorphic [n]\n",
  "ACTINOMORPHOUS": "radially symmetric, also ACTINOMORPHIC [adj]\n",
  "ACTINOMORPHY": "the quality of being actinomorphic [n ACTINOMORPHIES]\n",
  "ACTINOMYCES": "a filamentous microorganism like both bacteria and fungi, also ACTINOMYCETE [n ACTINOMYCES]\n",
  "ACTINOMYCETE": "a filamentous microorganism like both bacteria and fungi, also ACTINOMYCES [n -S]\n",
  "ACTINOMYCETES": "ACTINOMYCETE, a filamentous microorganism like both bacteria and fungi, also ACTINOMYCES [n]\n",
  "ACTINOMYCETOUS": "of or like an actinomycete, a filamentous microorganism like both bacteria and fungi [adj]\n",
  "ACTINOMYCIN": "any of various antibiotics isolated from soil bacteria [n -S]\n",
  "ACTINOMYCINS": "ACTINOMYCIN, any of various antibiotics isolated from soil bacteria [n]\n",
  "ACTINOMYCOSES": "ACTINOMYCOSIS, a parasitic disease in men and cattle resulting in inflammation of the jaw [n]\n",
  "ACTINOMYCOSIS": "a parasitic disease in men and cattle resulting in inflammation of the jaw [n ACTINOMYCOSES]\n",
  "ACTINOMYCOTIC": "relating to actinomycosis, a parasitic disease in men and cattle resulting in inflammation of the jaw [adj]\n",
  "ACTINON": "an isotope of radon [n -S]\n",
  "ACTINONS": "ACTINON, an isotope of radon [n]\n",
  "ACTINOPOD": "any protozoan of the phylum Actinopoda, such as a radiolarian or a heliozoan, having stiff radiating cytoplasmic projections [n -S]\n",
  "ACTINOPODS": "ACTINOPOD, any protozoan of the phylum Actinopoda, such as a radiolarian or a heliozoan, having stiff radiating cytoplasmic projections [n]\n",
  "ACTINOTHERAPIES": "ACTINOTHERAPY, the use of ultraviolet and other actinic rays in medical treatment [n]\n",
  "ACTINOTHERAPY": "the use of ultraviolet and other actinic rays in medical treatment [n ACTINOTHERAPIES]\n",
  "ACTINOURANIUM": "the isotope of uranium that has a mass number of 235 [n -S]\n",
  "ACTINOURANIUMS": "ACTINOURANIUM, the isotope of uranium that has a mass number of 235 [n]\n",
  "ACTINOZOAN": "any of a class of marine coelenterates [n -S]\n",
  "ACTINOZOANS": "ACTINOZOAN, any of a class of marine coelenterates [n]\n",
  "ACTINS": "ACTIN, a protein found in muscle tissue [n]\n",
  "ACTION": "activity, a deed [n] / to carry out [v -ED, -ING, -S]\n",
  "ACTIONABLE": "that can be actioned [adj ACTIONABLY]\n",
  "ACTIONABLY": "ACTIONABLE, that can be actioned [adv]\n",
  "ACTIONED": "ACTION, to carry out [v]\n",
  "ACTIONER": "a film with a lot of action [n -S]\n",
  "ACTIONERS": "ACTIONER, a film with a lot of action [n]\n",
  "ACTIONING": "ACTION, to carry out [v]\n",
  "ACTIONIST": "a shareholder in a joint-stock company [n -S]\n",
  "ACTIONISTS": "ACTIONIST, a shareholder in a joint-stock company [n]\n",
  "ACTIONLESS": "marked by inaction [adj]\n",
  "ACTIONS": "ACTION, to carry out [v]\n",
  "ACTIVATE": "to set in motion [v ACTIVATED, ACTIVATING, ACTIVATES]\n",
  "ACTIVATED": "ACTIVATE, to set in motion [v]\n",
  "ACTIVATES": "ACTIVATE, to set in motion [v]\n",
  "ACTIVATING": "ACTIVATE, to set in motion [v]\n",
  "ACTIVATION": "the act of activating [n -S]\n",
  "ACTIVATIONS": "ACTIVATION, the act of activating [n]\n",
  "ACTIVATOR": "one who activates [n -S]\n",
  "ACTIVATORS": "ACTIVATOR, one who activates [n]\n",
  "ACTIVE": "expressing action [adj ACTIVELY] / the active mood of a verb [n -S]\n",
  "ACTIVELY": "with activity [adv]\n",
  "ACTIVENESS": "the quality of being active [n -ES]\n",
  "ACTIVENESSES": "ACTIVENESS, the quality of being active [n]\n",
  "ACTIVES": "ACTIVE, the active mood of a verb [n]\n",
  "ACTIVISE": "to activate, also ACTIVIZE [v ACTIVISED, ACTIVISING, ACTIVISES]\n",
  "ACTIVISED": "ACTIVISE, to activate, also ACTIVIZE [v]\n",
  "ACTIVISES": "ACTIVISE, to activate, also ACTIVIZE [v]\n",
  "ACTIVISING": "ACTIVISE, to activate, also ACTIVIZE [v]\n",
  "ACTIVISM": "a policy of direct action [n -S]\n",
  "ACTIVISMS": "ACTIVISM, a policy of direct action [n]\n",
  "ACTIVIST": "an advocate of activism [n -S]\n",
  "ACTIVISTIC": "relating to activism [adj]\n",
  "ACTIVISTS": "ACTIVIST, an advocate of activism [n]\n",
  "ACTIVITIES": "ACTIVITY, the state of being active [n]\n",
  "ACTIVITY": "the state of being active [n ACTIVITIES]\n",
  "ACTIVIZE": "to activate, also ACTIVISE [v ACTIVIZED, ACTIVIZING, ACTIVIZES]\n",
  "ACTIVIZED": "ACTIVIZE, to activate, also ACTIVISE [v]\n",
  "ACTIVIZES": "ACTIVIZE, to activate, also ACTIVISE [v]\n",
  "ACTIVIZING": "ACTIVIZE, to activate, also ACTIVISE [v]\n",
  "ACTOMYOSIN": "a protein found in skeletal muscle [n -S]\n",
  "ACTOMYOSINS": "ACTOMYOSIN, a protein found in skeletal muscle [n]\n",
  "ACTON": "a stuffed jacket worn under mail [n -S]\n",
  "ACTONS": "ACTON, a stuffed jacket worn under mail [n]\n",
  "ACTOR": "a theatrical performer [n -S]\n",
  "ACTORISH": "like an actor [adj]\n",
  "ACTORLIER": "ACTORLY, in the manner of an actor [adj]\n",
  "ACTORLIEST": "ACTORLY, in the manner of an actor [adj]\n",
  "ACTORLY": "in the manner of an actor [adj ACTORLIER, ACTORLIEST]\n",
  "ACTORS": "ACTOR, a theatrical performer [n]\n",
  "ACTRESS": "a female actor [n -ES]\n",
  "ACTRESSES": "ACTRESS, a female actor [n]\n",
  "ACTRESSIER": "ACTRESSY, like an actress [adj]\n",
  "ACTRESSIEST": "ACTRESSY, like an actress [adj]\n",
  "ACTRESSY": "like an actress [adj ACTRESSIER, ACTRESSIEST]\n",
  "ACTS": "ACT, to do something in a specified way [v]\n",
  "ACTUAL": "existing in fact [adj ACTUALLY] / a commercial commodity that can be bought and sold [n -S]\n",
  "ACTUALISATION": "the process of actualising, also ACTUALIZATION [n -S]\n",
  "ACTUALISATIONS": "ACTUALISATION, the process of actualising, also ACTUALIZATION [n]\n",
  "ACTUALISE": "to make actual, realise, also ACTUALIZE [v ACTUALISED, ACTUALISING, ACTUALISES]\n",
  "ACTUALISED": "ACTUALISE, to make actual, realise, also ACTUALIZE [v]\n",
  "ACTUALISES": "ACTUALISE, to make actual, realise, also ACTUALIZE [v]\n",
  "ACTUALISING": "ACTUALISE, to make actual, realise, also ACTUALIZE [v]\n",
  "ACTUALIST": "a person who deals with or considers actual facts [n -S]\n",
  "ACTUALISTS": "ACTUALIST, a person who deals with or considers actual facts [n]\n",
  "ACTUALITE": "(French) the real state of affairs [n -S]\n",
  "ACTUALITES": "ACTUALITE, (French) the real state of affairs [n]\n",
  "ACTUALITIES": "ACTUALITY, the state of being actual [n]\n",
  "ACTUALITY": "the state of being actual [n ACTUALITIES]\n",
  "ACTUALIZATION": "the process of actualizing, also ACTUALISATION [n -S]\n",
  "ACTUALIZATIONS": "ACTUALIZATION, the process of actualizing, also ACTUALISATION [n]\n",
  "ACTUALIZE": "to make actual, realise, also ACTUALISE [v ACTUALIZED, ACTUALIZING, ACTUALIZES]\n",
  "ACTUALIZED": "ACTUALIZE, to make actual, realise, also ACTUALISE [v]\n",
  "ACTUALIZES": "ACTUALIZE, to make actual, realise, also ACTUALISE [v]\n",
  "ACTUALIZING": "ACTUALIZE, to make actual, realise, also ACTUALISE [v]\n",
  "ACTUALLY": "ACTUAL, existing in fact [adv]\n",
  "ACTUALS": "commodities which can be used when purchased (e.g. not futures), also PHYSICALS [n]\n",
  "ACTUARIAL": "of or pertaining to actuaries [adj ACTUARIALLY]\n",
  "ACTUARIALLY": "ACTUARIAL, of or pertaining to actuaries [adv]\n",
  "ACTUARIES": "ACTUARY, a person who compiles statistics of mortality, accidents, etc., and calculates insurance risks and premiums [n]\n",
  "ACTUARY": "a person who compiles statistics of mortality, accidents, etc., and calculates insurance risks and premiums [n ACTUARIES]\n",
  "ACTUATE": "to put into action [v ACTUATED, ACTUATING, ACTUATES]\n",
  "ACTUATED": "ACTUATE, to put into action [v]\n",
  "ACTUATES": "ACTUATE, to put into action [v]\n",
  "ACTUATING": "ACTUATE, to put into action [v]\n",
  "ACTUATION": "a bringing into action; an effecting [n -S]\n",
  "ACTUATIONS": "ACTUATION, a bringing into action; an effecting [n]\n",
  "ACTUATOR": "one who actuates [n -S]\n",
  "ACTUATORS": "ACTUATOR, one who actuates [n]\n",
  "ACTURE": "(Shakespeare) action or performance [n -S]\n",
  "ACTURES": "ACTURE, (Shakespeare) action or performance [n]\n",
  "ACUATE": "to sharpen [v ACUATED, ACUATING, ACUATES]\n",
  "ACUATED": "ACUATE, to sharpen [v]\n",
  "ACUATES": "ACUATE, to sharpen [v]\n",
  "ACUATING": "ACUATE, to sharpen [v]\n",
  "ACUITIES": "ACUITY, sharpness [n]\n",
  "ACUITY": "sharpness [n ACUITIES]\n",
  "ACULEATE": "prickly; pointed; stinging, also ACULEATED [adj] / a stinging insect [n -S]\n",
  "ACULEATED": "prickly; pointed; stinging, also ACULEATE [adj]\n",
  "ACULEATES": "ACULEATE, a stinging insect [n]\n",
  "ACULEI": "ACULEUS, (Latin) a prickle growing on the bark, as in some brambles and roses [n]\n",
  "ACULEUS": "(Latin) a prickle growing on the bark, as in some brambles and roses [n ACULEI]\n",
  "ACUMEN": "(Latin) mental keenness [n -S]\n",
  "ACUMENS": "ACUMEN, (Latin) mental keenness [n]\n",
  "ACUMINATE": "to sharpen [v ACUMINATED, ACUMINATING, ACUMINATES]\n",
  "ACUMINATED": "ACUMINATE, to sharpen [v]\n",
  "ACUMINATES": "ACUMINATE, to sharpen [v]\n",
  "ACUMINATING": "ACUMINATE, to sharpen [v]\n",
  "ACUMINATION": "the state of being acuminate [n -S]\n",
  "ACUMINATIONS": "ACUMINATION, the state of being acuminate [n]\n",
  "ACUMINOUS": "characterized by acumen [adj]\n",
  "ACUPOINT": "an acupuncture site [n -S]\n",
  "ACUPOINTS": "ACUPOINT, an acupuncture site [n]\n",
  "ACUPRESSURE": "the application of pressure to discrete points on the body for therapeutic effects [n -S]\n",
  "ACUPRESSURES": "ACUPRESSURE, the application of pressure to discrete points on the body for therapeutic effects [n]\n",
  "ACUPUNCTURAL": "relating to acupuncture [adj]\n",
  "ACUPUNCTURE": "the complementary therapy of puncturing the skin with needles at specified points in order to cure illness [n -S]\n",
  "ACUPUNCTURES": "ACUPUNCTURE, the complementary therapy of puncturing the skin with needles at specified points in order to cure illness [n]\n",
  "ACUPUNCTURIST": "one who practices acupuncture [n -S]\n",
  "ACUPUNCTURISTS": "ACUPUNCTURIST, one who practices acupuncture [n]\n",
  "ACUSHLA": "(Irish) an Irish term of address, darling [n -S]\n",
  "ACUSHLAS": "ACUSHLA, (Irish) an Irish term of address, darling [n]\n",
  "ACUTANCE": "a measure of photographic clarity [n -S]\n",
  "ACUTANCES": "ACUTANCE, a measure of photographic clarity [n]\n",
  "ACUTE": "a type of accent mark [n -S] / sharply pointed [adj ACUTER, ACUTEST, ACUTELY]\n",
  "ACUTELY": "to a greater degree [adv]\n",
  "ACUTENESS": "the state of being acute [n -ES]\n",
  "ACUTENESSES": "ACUTENESS, the state of being acute [n]\n",
  "ACUTER": "ACUTE, sharply pointed [adj]\n",
  "ACUTES": "ACUTE, a type of accent mark [n]\n",
  "ACUTEST": "ACUTE, sharply pointed [adj]\n",
  "ACYCLIC": "not periodic [adj]\n",
  "ACYCLOVIR": "a drug used in the treatment of herpes and HIV, also ACICLOVIR [n -S]\n",
  "ACYCLOVIRS": "ACYCLOVIR, a drug used in the treatment of herpes and HIV, also ACICLOVIR [n]\n",
  "ACYL": "an organometallic compound [n -S]\n",
  "ACYLATE": "to introduce acyl into [v ACYLATED, ACYLATING, ACYLATES]\n",
  "ACYLATED": "ACYLATE, to introduce acyl into [v]\n",
  "ACYLATES": "ACYLATE, to introduce acyl into [v]\n",
  "ACYLATING": "ACYLATE, to introduce acyl into [v]\n",
  "ACYLATION": "the act of forming an acylate [n -S]\n",
  "ACYLATIONS": "ACYLATION, the act of forming an acylate [n]\n",
  "ACYLOIN": "a type of chemical compound, consisting of a hydroxyl group attached to a carboxyl group [n -S]\n",
  "ACYLOINS": "ACYLOIN, a type of chemical compound, consisting of a hydroxyl group attached to a carboxyl group [n]\n",
  "ACYLS": "ACYL, an organometallic compound [n]\n",
  "AD": "(colloquial) an advertisement [n -S]\n",
  "ADACTYLOUS": "lacking fingers or claws [adj]\n",
  "ADAGE": "a proverb, a traditional saying expressing a common observation [n -S]\n",
  "ADAGES": "ADAGE, a proverb, a traditional saying expressing a common observation [n]\n",
  "ADAGIAL": "pertaining to an adage, proverbial [adj]\n",
  "ADAGIO": "(Italian) slow [adv] / a piece of music to be played slowly [n -S]\n",
  "ADAGIOS": "ADAGIO, a piece of music to be played slowly [n]\n",
  "ADAMANCE": "unyielding hardness, also ADAMANCY [n -S]\n",
  "ADAMANCES": "ADAMANCE, unyielding hardness, also ADAMANCY [n]\n",
  "ADAMANCIES": "ADAMANCY, unyielding hardness, also ADAMANCE [n]\n",
  "ADAMANCY": "unyielding hardness, also ADAMANCE [n ADAMANCIES]\n",
  "ADAMANT": "very firm [adj ADAMANTLY] / a legendary impenetrable stone; diamond [n -S]\n",
  "ADAMANTEAN": "(Milton) of adamant; hard as adamant, also ADAMANTINE [adj]\n",
  "ADAMANTINE": "of adamant; hard as adamant, also ADAMANTEAN [adj]\n",
  "ADAMANTLY": "ADAMANT, very firm [adv]\n",
  "ADAMANTS": "ADAMANT, a legendary impenetrable stone; diamond [n]\n",
  "ADAMSITE": "a lung-irritating gas [n -S]\n",
  "ADAMSITES": "ADAMSITE, a lung-irritating gas [n]\n",
  "ADAPT": "to make suitable [v -ED, -ING, -S]\n",
  "ADAPTABILITIES": "ADAPTABILITY, the quality of being adaptable [n]\n",
  "ADAPTABILITY": "the quality of being adaptable [n ADAPTABILITIES]\n",
  "ADAPTABLE": "that can be adapted [adj]\n",
  "ADAPTABLENESS": "the state of being adaptable [n -ES]\n",
  "ADAPTABLENESSES": "ADAPTABLENESS, the state of being adaptable [n]\n",
  "ADAPTATION": "the act of adapting, also ADAPTION [n -S]\n",
  "ADAPTATIONAL": "relating to adaptation [adj ADAPTATIONALLY]\n",
  "ADAPTATIONALLY": "ADAPTATIONAL, relating to adaptation [adv]\n",
  "ADAPTATIONS": "ADAPTATION, the act of adapting, also ADAPTION [n]\n",
  "ADAPTATIVE": "adaptive [adj]\n",
  "ADAPTED": "ADAPT, to make suitable [v]\n",
  "ADAPTEDNESS": "the state of being adapted [n -ES]\n",
  "ADAPTEDNESSES": "ADAPTEDNESS, the state of being adapted [n]\n",
  "ADAPTER": "something that adapts, also ADAPTOR [n -S]\n",
  "ADAPTERS": "ADAPTER, something that adapts, also ADAPTOR [n]\n",
  "ADAPTING": "ADAPT, to make suitable [v]\n",
  "ADAPTION": "the act of adapting, also ADAPTATION [n -S]\n",
  "ADAPTIONS": "ADAPTION, the act of adapting, also ADAPTATION [n]\n",
  "ADAPTIVE": "able to be adapted [adj]\n",
  "ADAPTIVELY": "ADAPTIVE, able to be adapted [adv]\n",
  "ADAPTIVENESS": "the quality of being adaptive [n -ES]\n",
  "ADAPTIVENESSES": "ADAPTIVENESS, the quality of being adaptive [n]\n",
  "ADAPTIVITIES": "ADAPTIVITY, the quality of being adaptive [n]\n",
  "ADAPTIVITY": "the quality of being adaptive [n ADAPTIVITIES]\n",
  "ADAPTOGEN": "any of various natural substances used in herbal medicine as regulators [n -S]\n",
  "ADAPTOGENIC": "acting to normalize and regulate the systems of the body [adj]\n",
  "ADAPTOGENS": "ADAPTOGEN, any of various natural substances used in herbal medicine as regulators [n]\n",
  "ADAPTOR": "something that adapts, also ADAPTER [n -S]\n",
  "ADAPTORS": "ADAPTOR, something that adapts, also ADAPTER [n]\n",
  "ADAPTS": "ADAPT, to make suitable [v]\n",
  "ADAW": "(Spenser) to daunt, subdue [v -ED, -ING, -S]\n",
  "ADAWED": "ADAW, (Spenser) to daunt, subdue [v]\n",
  "ADAWING": "ADAW, (Spenser) to daunt, subdue [v]\n",
  "ADAWS": "ADAW, (Spenser) to daunt, subdue [v]\n",
  "ADAXIAL": "next to the axis [adj]\n",
  "ADAYS": "(Spenser) by day, daily [adv]\n",
  "ADBOT": "a specialized computer program that inflicts ads on users [n -S]\n",
  "ADBOTS": "ADBOT, a specialized computer program that inflicts ads on users [n]\n",
  "ADD": "to compute the sum of [v -ED, -ING, -S]\n",
  "ADDABLE": "able to be added [adj]\n",
  "ADDAX": "a large light-coloured African antelope with curled horns [n -ES]\n",
  "ADDAXES": "ADDAX, a large light-coloured African antelope with curled horns [n]\n",
  "ADDEBTED": "(Scots) indebted, owed [adj]\n",
  "ADDED": "ADD, to compute the sum of [v]\n",
  "ADDEDLY": "additionally [adv]\n",
  "ADDEEM": "(obsolete) to award; to adjudge, also ADDOOM [v -ED, -ING, -S]\n",
  "ADDEEMED": "ADDEEM, (obsolete) to award; to adjudge, also ADDOOM [v]\n",
  "ADDEEMING": "ADDEEM, (obsolete) to award; to adjudge, also ADDOOM [v]\n",
  "ADDEEMS": "ADDEEM, (obsolete) to award; to adjudge, also ADDOOM [v]\n",
  "ADDEND": "an amount to be added [n -S]\n",
  "ADDENDA": "ADDENDUM, (Latin) something to be added [n]\n",
  "ADDENDS": "ADDEND, an amount to be added [n]\n",
  "ADDENDUM": "(Latin) something to be added [n ADDENDUMS or ADDENDA]\n",
  "ADDENDUMS": "ADDENDUM, (Latin) something to be added [n]\n",
  "ADDER": "a venomous snake [n -S]\n",
  "ADDERBEAD": "a prehistoric ornamental bead, also ADDERSTONE [n -S]\n",
  "ADDERBEADS": "ADDERBEAD, a prehistoric ornamental bead, also ADDERSTONE [n]\n",
  "ADDERS": "ADDER, a venomous snake [n]\n",
  "ADDERSTONE": "a prehistoric spindle-whorl or bead, once thought to be due to the agency of adders, also ADDERBEAD [n -S]\n",
  "ADDERSTONES": "ADDERSTONE, a prehistoric spindle-whorl or bead, once thought to be due to the agency of adders, also ADDERBEAD [n]\n",
  "ADDERWORT": "the common bistort, aka snakeweed [n -S]\n",
  "ADDERWORTS": "ADDERWORT, the common bistort, aka snakeweed [n]\n",
  "ADDIBLE": "capable of being added [adj]\n",
  "ADDICT": "to make dependent on esp. a drug [v -ED, -ING, -S]\n",
  "ADDICTED": "ADDICT, to make dependent on esp. a drug [v]\n",
  "ADDICTEDNESS": "the state of being addicted [n -ES]\n",
  "ADDICTEDNESSES": "ADDICTEDNESS, the state of being addicted [n]\n",
  "ADDICTING": "ADDICT, to make dependent on esp. a drug [v]\n",
  "ADDICTION": "the state of being addicted [n -S]\n",
  "ADDICTIONS": "ADDICTION, the state of being addicted [n]\n",
  "ADDICTIVE": "causing addiction [adj]\n",
  "ADDICTIVENESS": "the quality of being addictive [n -ES]\n",
  "ADDICTIVENESSES": "ADDICTIVENESS, the quality of being addictive [n]\n",
  "ADDICTS": "ADDICT, to make dependent on esp. a drug [v]\n",
  "ADDIES": "ADDY, (slang) an email address [n]\n",
  "ADDING": "the act of addition [n -S]\n",
  "ADDINGS": "ADDING, the act of addition [n]\n",
  "ADDIO": "(Italian) goodbye [n -S]\n",
  "ADDIOS": "ADDIO, (Italian) goodbye [n]\n",
  "ADDITAMENT": "a thing added or appended; a heraldic ornament [n -S]\n",
  "ADDITAMENTS": "ADDITAMENT, a thing added or appended; a heraldic ornament [n]\n",
  "ADDITION": "something added [n -S]\n",
  "ADDITIONAL": "existing by way of addition [adj ADDITIONALLY]\n",
  "ADDITIONALITIES": "ADDITIONALITY, the quality of being additional [n]\n",
  "ADDITIONALITY": "the quality of being additional [n ADDITIONALITIES]\n",
  "ADDITIONALLY": "ADDITIONAL, existing by way of addition [adv]\n",
  "ADDITIONS": "ADDITION, something added [n]\n",
  "ADDITITIOUS": "of, pertaining to or resulting from addition [adj]\n",
  "ADDITIVE": "in addition [adj ADDITIVELY] / a substance added to another to impart desirable qualities [n -S]\n",
  "ADDITIVELY": "ADDITIVE, in addition [adv]\n",
  "ADDITIVES": "ADDITIVE, a substance added to another to impart desirable qualities [n]\n",
  "ADDITIVITIES": "ADDITIVITY, the quality of being additive [n]\n",
  "ADDITIVITY": "the quality of being additive [n ADDITIVITIES]\n",
  "ADDITORY": "making an addition [adj]\n",
  "ADDLE": "to confuse [v ADDLED, ADDLING, ADDLES]\n",
  "ADDLED": "ADDLE, to confuse [v]\n",
  "ADDLEMENT": "the state of being addled [n -S]\n",
  "ADDLEMENTS": "ADDLEMENT, the state of being addled [n]\n",
  "ADDLEPATED": "muddleheaded [adj]\n",
  "ADDLES": "ADDLE, to confuse [v]\n",
  "ADDLING": "ADDLE, to confuse [v]\n",
  "ADDOOM": "(Spenser) to award; to adjudge, also ADDEEM [v -ED, -ING, -S]\n",
  "ADDOOMED": "ADDOOM, (Spenser) to award; to adjudge, also ADDEEM [v]\n",
  "ADDOOMING": "ADDOOM, (Spenser) to award; to adjudge, also ADDEEM [v]\n",
  "ADDOOMS": "ADDOOM, (Spenser) to award; to adjudge, also ADDEEM [v]\n",
  "ADDORSED": "in heraldry, turned back to back [adj]\n",
  "ADDRESS": "to speak to [v ADDRESSED or ADDREST, ADDRESSING, ADDRESSES]\n",
  "ADDRESSABILITY": "the quality of being addressable [n]\n",
  "ADDRESSABLE": "able to be addressed [adj]\n",
  "ADDRESSED": "ADDRESS, to speak to [v]\n",
  "ADDRESSEE": "one who is addressed [n -S]\n",
  "ADDRESSEES": "ADDRESSEE, one who is addressed [n]\n",
  "ADDRESSER": "one who addresses, also ADDRESSOR [n -S]\n",
  "ADDRESSERS": "ADDRESSER, one who addresses, also ADDRESSOR [n]\n",
  "ADDRESSES": "ADDRESS, to speak to [v]\n",
  "ADDRESSING": "the act of speaking to [n -S]\n",
  "ADDRESSINGS": "ADDRESSING, the act of speaking to [n]\n",
  "ADDRESSOR": "one who addresses, also ADDRESSER [n -S]\n",
  "ADDRESSORS": "ADDRESSOR, one who addresses, also ADDRESSER [n]\n",
  "ADDREST": "ADDRESS, to speak to [v]\n",
  "ADDS": "ADD, to compute the sum of [v]\n",
  "ADDUCE": "to cite or quote [v ADDUCED, ADDUCING, ADDUCES]\n",
  "ADDUCEABLE": "that can be adduced [adj]\n",
  "ADDUCED": "ADDUCE, to cite or quote [v]\n",
  "ADDUCENT": "drawing inward or together, as a muscle does [adj]\n",
  "ADDUCER": "one who adduces [n -S]\n",
  "ADDUCERS": "ADDUCER, one who adduces [n]\n",
  "ADDUCES": "ADDUCE, to cite or quote [v]\n",
  "ADDUCIBLE": "capable of being adduced [adj]\n",
  "ADDUCING": "ADDUCE, to cite or quote [v]\n",
  "ADDUCT": "to draw inward, esp. of muscles [v -ED, -ING, -S]\n",
  "ADDUCTED": "ADDUCT, to draw inward, esp. of muscles [v]\n",
  "ADDUCTING": "ADDUCT, to draw inward, esp. of muscles [v]\n",
  "ADDUCTION": "the act of adducing or bringing forward [n -S]\n",
  "ADDUCTIONS": "ADDUCTION, the act of adducing or bringing forward [n]\n",
  "ADDUCTIVE": "adducing, bringing towards or to something [adj]\n",
  "ADDUCTOR": "an adducent muscle, one that draws towards a central axis [n -S]\n",
  "ADDUCTORS": "ADDUCTOR, an adducent muscle, one that draws towards a central axis [n]\n",
  "ADDUCTS": "ADDUCT, to draw inward, esp. of muscles [v]\n",
  "ADDY": "(slang) an email address [n ADDIES]\n",
  "ADEEM": "to cancel a bequest by destruction of the thing bequeathed [v -ED, -ING, -S]\n",
  "ADEEMED": "ADEEM, to cancel a bequest by destruction of the thing bequeathed [v]\n",
  "ADEEMING": "ADEEM, to cancel a bequest by destruction of the thing bequeathed [v]\n",
  "ADEEMS": "ADEEM, to cancel a bequest by destruction of the thing bequeathed [v]\n",
  "ADELANTADO": "(Spanish) a governor of a province; a commander [n -S]\n",
  "ADELANTADOS": "ADELANTADO, (Spanish) a governor of a province; a commander [n]\n",
  "ADELGID": "a kind of small insect related to the aphids [n -S]\n",
  "ADELGIDS": "ADELGID, a kind of small insect related to the aphids [n]\n",
  "ADEMPTION": "the revoking by testator, donor, etc. of a legacy, donation, etc., by previously paying a sum or parting with the object bequeathed [n -S]\n",
  "ADEMPTIONS": "ADEMPTION, the revoking by testator, donor, etc. of a legacy, donation, etc., by previously paying a sum or parting with the object bequeathed [n]\n",
  "ADENECTOMIES": "ADENECTOMY, the surgical removal of the adenoids, also ADENOIDECTOMY [n]\n",
  "ADENECTOMY": "the surgical removal of the adenoids, also ADENOIDECTOMY [n ADENECTOMIES]\n",
  "ADENINE": "one of the four bases in DNA [n -S]\n",
  "ADENINES": "ADENINE, one of the four bases in DNA [n]\n",
  "ADENITIS": "inflammation of glands [n -ES]\n",
  "ADENITISES": "ADENITIS, inflammation of glands [n]\n",
  "ADENOCARCINOMA": "a malignant tumor originating in glandular epithelium [n -S]\n",
  "ADENOCARCINOMAS": "ADENOCARCINOMA, a malignant tumor originating in glandular epithelium [n]\n",
  "ADENOHYPOPHYSES": "ADENOHYPOPHYSIS, the anterior glandular lobe of the pituitary gland [n]\n",
  "ADENOHYPOPHYSIS": "the anterior glandular lobe of the pituitary gland [n ADENOHYPOPHYSES]\n",
  "ADENOID": "relating to or like a gland, also ADENOIDAL [adj] / glandular tissue at the back of the nose [n -S]\n",
  "ADENOIDAL": "relating to or like a gland, also ADENOID [adj]\n",
  "ADENOIDECTOMIES": "ADENOIDECTOMY, the surgical removal of the adenoids, also ADENECTOMY [n]\n",
  "ADENOIDECTOMY": "the surgical removal of the adenoids, also ADENECTOMY [n ADENOIDECTOMIES]\n",
  "ADENOIDS": "ADENOID, glandular tissue at the back of the nose [n]\n",
  "ADENOMA": "(Greek) a tumor of glandular origin [n ADENOMAS or ADENOMATA]\n",
  "ADENOMAS": "ADENOMA, (Greek) a tumor of glandular origin [n]\n",
  "ADENOMATA": "ADENOMA, (Greek) a tumor of glandular origin [n]\n",
  "ADENOMATOUS": "relating to an adenoma [adj]\n",
  "ADENOPATHIES": "ADENOPATHY, enlargement of the lymph nodes [n]\n",
  "ADENOPATHY": "enlargement of the lymph nodes [n ADENOPATHIES]\n",
  "ADENOSES": "ADENOSIS, abnormal growth of glandular tissue [n]\n",
  "ADENOSINE": "a nucleotide made up of adenine and ribose [n -S]\n",
  "ADENOSINES": "ADENOSINE, a nucleotide made up of adenine and ribose [n]\n",
  "ADENOSIS": "abnormal growth of glandular tissue [n ADENOSES]\n",
  "ADENOVIRAL": "relating to an adenovirus [adj]\n",
  "ADENOVIRUS": "any of a group of viruses that attack the upper respiratory tract [n -ES]\n",
  "ADENOVIRUSES": "ADENOVIRUS, any of a group of viruses that attack the upper respiratory tract [n]\n",
  "ADENYL": "a nucleotide, a constituent of DNA [n -S]\n",
  "ADENYLATE": "an enzyme with key regulatory roles in cells, aka adenyl cyclase [n -S]\n",
  "ADENYLATES": "ADENYLATE, an enzyme with key regulatory roles in cells, aka adenyl cyclase [n]\n",
  "ADENYLIC": "as in adenylic acid, a component of DNA [adj]\n",
  "ADENYLS": "ADENYL, a nucleotide, a constituent of DNA [n]\n",
  "ADEPT": "an expert [n -S] / highly skilled [adj ADEPTER, ADEPTEST, ADEPTLY]\n",
  "ADEPTER": "ADEPT, highly skilled [adj]\n",
  "ADEPTEST": "ADEPT, highly skilled [adj]\n",
  "ADEPTLY": "ADEPT, highly skilled [adv]\n",
  "ADEPTNESS": "the state of being adept [n -ES]\n",
  "ADEPTNESSES": "ADEPTNESS, the state of being adept [n]\n",
  "ADEPTS": "ADEPT, an expert [n]\n",
  "ADEQUACIES": "ADEQUACY, the state of sufficiency [n]\n",
  "ADEQUACY": "the state of sufficiency [n ADEQUACIES]\n",
  "ADEQUATE": "sufficient [adj]\n",
  "ADEQUATELY": "ADEQUATE, sufficient [adv]\n",
  "ADEQUATENESS": "the quality of being adequate [n -ES]\n",
  "ADEQUATENESSES": "ADEQUATENESS, the quality of being adequate [n]\n",
  "ADEQUATIVE": "tending to be or make adequate [adj]\n",
  "ADERMIN": "a former name of pyridoxine, a member of the vitamin B complex [n -S]\n",
  "ADERMINS": "ADERMIN, a former name of pyridoxine, a member of the vitamin B complex [n]\n",
  "ADESPOTA": "(Greek) anonymous works [n]\n",
  "ADESSIVE": "a grammatical case indicating place where or proximity to [n -S]\n",
  "ADESSIVES": "ADESSIVE, a grammatical case indicating place where or proximity to [n]\n",
  "ADHAN": "(Arabic) the Muslim call to prayer, also AZAN [n -S]\n",
  "ADHANS": "ADHAN, (Arabic) the Muslim call to prayer, also AZAN [n]\n",
  "ADHARMA": "(Sanskrit) unrighteousness (the opposite of dharma) [n -S]\n",
  "ADHARMAS": "ADHARMA, (Sanskrit) unrighteousness (the opposite of dharma) [n]\n",
  "ADHERABLE": "capable of adhering [adj]\n",
  "ADHERE": "to become or remain attached or close to something [v ADHERED, ADHERING, ADHERES]\n",
  "ADHERED": "ADHERE, to become or remain attached or close to something [v]\n",
  "ADHERENCE": "the state of adhering [n -S]\n",
  "ADHERENCES": "ADHERENCE, the state of adhering [n]\n",
  "ADHEREND": "the surface to which an adhesive sticks [n -S]\n",
  "ADHERENDS": "ADHEREND, the surface to which an adhesive sticks [n]\n",
  "ADHERENT": "sticking, growing together [adj ADHERENTLY] / a supporter [n -S]\n",
  "ADHERENTLY": "ADHERENT, sticking, growing together [adv]\n",
  "ADHERENTS": "ADHERENT, a supporter [n]\n",
  "ADHERER": "one who remains close [n -S]\n",
  "ADHERERS": "ADHERER, one who remains close [n]\n",
  "ADHERES": "ADHERE, to become or remain attached or close to something [v]\n",
  "ADHERING": "ADHERE, to become or remain attached or close to something [v]\n",
  "ADHESION": "the act of sticking [n -S]\n",
  "ADHESIONAL": "relating to adhesion [adj]\n",
  "ADHESIONS": "ADHESION, the act of sticking [n]\n",
  "ADHESIVE": "sticking [adj ADHESIVELY] / a substance that causes adhesion [n -S]\n",
  "ADHESIVELY": "ADHESIVE, sticking [adv]\n",
  "ADHESIVENESS": "the quality of being adhesive [n -ES]\n",
  "ADHESIVENESSES": "ADHESIVENESS, the quality of being adhesive [n]\n",
  "ADHESIVES": "ADHESIVE, a substance that causes adhesion [n]\n",
  "ADHIBIT": "to attach; to administer, esp. as a remedy [v -ED, -ING, -S]\n",
  "ADHIBITED": "ADHIBIT, to attach; to administer, esp. as a remedy [v]\n",
  "ADHIBITING": "ADHIBIT, to attach; to administer, esp. as a remedy [v]\n",
  "ADHIBITION": "the act of adhibiting; application; use [n -S]\n",
  "ADHIBITIONS": "ADHIBITION, the act of adhibiting; application; use [n]\n",
  "ADHIBITS": "ADHIBIT, to attach; to administer, esp. as a remedy [v]\n",
  "ADHOCRACIES": "ADHOCRACY, management that responds to urgent problems rather than planning to avoid them [n]\n",
  "ADHOCRACY": "management that responds to urgent problems rather than planning to avoid them [n ADHOCRACIES]\n",
  "ADIABATIC": "without transference of heat [adj ADIABATICALLY] / a curve on a graph relating to an adiabatic process, one without transfer of heat [n -S]\n",
  "ADIABATICALLY": "ADIABATIC, without transference of heat [adv]\n",
  "ADIABATICS": "ADIABATIC, a curve on a graph relating to an adiabatic process, one without transfer of heat [n]\n",
  "ADIACTINIC": "denoting a substance that does not transmit radiation affecting photochemically sensitive materials, such as a safelight in a photographic darkroom [adj]\n",
  "ADIAPHORA": "ADIAPHORON, a tenet or belief on which a theological system is indifferent [n]\n",
  "ADIAPHORISM": "tolerance or indifference, esp. in the matters of religion [n -S]\n",
  "ADIAPHORISMS": "ADIAPHORISM, tolerance or indifference, esp. in the matters of religion [n]\n",
  "ADIAPHORIST": "an adherent of adiaphorism, the doctrine of theological indifference or latitudinarianism [n -S]\n",
  "ADIAPHORISTIC": "theologically indifferent [adj]\n",
  "ADIAPHORISTS": "ADIAPHORIST, an adherent of adiaphorism, the doctrine of theological indifference or latitudinarianism [n]\n",
  "ADIAPHORON": "a tenet or belief on which a theological system is indifferent [n ADIAPHORA]\n",
  "ADIAPHOROUS": "doing neither good nor harm [adj]\n",
  "ADIATHERMANCIES": "ADIATHERMANCY, impermeability to radiant energy [n]\n",
  "ADIATHERMANCY": "impermeability to radiant energy [n ADIATHERMANCIES]\n",
  "ADIATHERMANOUS": "not permeable by or able to conduct radiant heat [adj]\n",
  "ADIATHERMIC": "impervious to radiant heat [adj]\n",
  "ADIEU": "(French) a farewell [n ADIEUS or ADIEUX]\n",
  "ADIEUS": "ADIEU, (French) a farewell [n]\n",
  "ADIEUX": "ADIEU, (French) a farewell [n]\n",
  "ADIOS": "(Spanish) goodbye [n -ES]\n",
  "ADIOSES": "ADIOS, (Spanish) goodbye [n]\n",
  "ADIPIC": "relating to animal fat, as in adipic acid [adj]\n",
  "ADIPOCERE": "(Latin) a fatty substance occurring in corpses left in moist areas [n -S]\n",
  "ADIPOCERES": "ADIPOCERE, (Latin) a fatty substance occurring in corpses left in moist areas [n]\n",
  "ADIPOCEROUS": "like adipocere, a fatty substance occurring in corpses left in moist areas [adj]\n",
  "ADIPOCYTE": "a fat cell [n -S]\n",
  "ADIPOCYTES": "ADIPOCYTE, a fat cell [n]\n",
  "ADIPOSE": "of or pertaining to fatty substances, also ADIPOUS [adj]\n",
  "ADIPOSES": "ADIPOSIS, obesity [n]\n",
  "ADIPOSIS": "obesity [n ADIPOSES]\n",
  "ADIPOSITIES": "ADIPOSITY, the state of being fat [n]\n",
  "ADIPOSITY": "the state of being fat [n ADIPOSITIES]\n",
  "ADIPOUS": "pertaining to animal fat [adj]\n",
  "ADIPSIA": "complete lack of thirst [n -S]\n",
  "ADIPSIAS": "ADIPSIA, complete lack of thirst [n]\n",
  "ADIT": "a nearly horizontal shaft to the surface in a mine [n -S]\n",
  "ADITS": "ADIT, a nearly horizontal shaft to the surface in a mine [n]\n",
  "ADJACENCE": "the state of being adjacent or contiguous, also ADJACENCY [n -S]\n",
  "ADJACENCES": "ADJACENCE, the state of being adjacent or contiguous, also ADJACENCY [n]\n",
  "ADJACENCIES": "ADJACENCY, the state of being adjacent or contiguous, also ADJACENCE [n]\n",
  "ADJACENCY": "the state of being adjacent or contiguous, also ADJACENCE [n ADJACENCIES]\n",
  "ADJACENT": "next to [adj ADJACENTLY] / in a right angled triangle, the shorter of the two sides adjacent to a given angle [n -S]\n",
  "ADJACENTLY": "ADJACENT, next to [adv]\n",
  "ADJACENTS": "ADJACENT, in a right angled triangle, the shorter of the two sides adjacent to a given angle [n]\n",
  "ADJECTIVAL": "using many adjectives [adj ADJECTIVALLY]\n",
  "ADJECTIVALLY": "ADJECTIVAL, using many adjectives [adv]\n",
  "ADJECTIVE": "added, dependent [adj ADJECTIVELY] / a word added to a noun to qualify it [n -S]\n",
  "ADJECTIVELY": "ADJECTIVE, added, dependent [adv]\n",
  "ADJECTIVES": "ADJECTIVE, a word added to a noun to qualify it [n]\n",
  "ADJIGO": "(Native Australian) an Australian edible yam [n -S]\n",
  "ADJIGOS": "ADJIGO, (Native Australian) an Australian edible yam [n]\n",
  "ADJOIN": "to lie next to [v -ED, -ING, -S]\n",
  "ADJOINED": "ADJOIN, to lie next to [v]\n",
  "ADJOINING": "ADJOIN, to lie next to [v]\n",
  "ADJOINS": "ADJOIN, to lie next to [v]\n",
  "ADJOINT": "a form of a mathematical matrix [n -S]\n",
  "ADJOINTS": "ADJOINT, a form of a mathematical matrix [n]\n",
  "ADJOURN": "to suspend until a later time [v -ED, -ING, -S]\n",
  "ADJOURNED": "ADJOURN, to suspend until a later time [v]\n",
  "ADJOURNING": "ADJOURN, to suspend until a later time [v]\n",
  "ADJOURNMENT": "the act of adjourning [n -S]\n",
  "ADJOURNMENTS": "ADJOURNMENT, the act of adjourning [n]\n",
  "ADJOURNS": "ADJOURN, to suspend until a later time [v]\n",
  "ADJUDGE": "to decide; to award [v ADJUDGED, ADJUDGING, ADJUDGES]\n",
  "ADJUDGED": "ADJUDGE, to decide; to award [v]\n",
  "ADJUDGEMENT": "the act of adjudging, also ADJUDGMENT [n -S]\n",
  "ADJUDGEMENTS": "ADJUDGEMENT, the act of adjudging, also ADJUDGMENT [n]\n",
  "ADJUDGES": "ADJUDGE, to decide; to award [v]\n",
  "ADJUDGING": "ADJUDGE, to decide; to award [v]\n",
  "ADJUDGMENT": "the act of adjudging, also ADJUDGEMENT [n -S]\n",
  "ADJUDGMENTS": "ADJUDGMENT, the act of adjudging, also ADJUDGEMENT [n]\n",
  "ADJUDICATE": "to settle judicially [v ADJUDICATED, ADJUDICATING, ADJUDICATES]\n",
  "ADJUDICATED": "ADJUDICATE, to settle judicially [v]\n",
  "ADJUDICATES": "ADJUDICATE, to settle judicially [v]\n",
  "ADJUDICATING": "ADJUDICATE, to settle judicially [v]\n",
  "ADJUDICATION": "the act of adjudicating [n -S]\n",
  "ADJUDICATIONS": "ADJUDICATION, the act of adjudicating [n]\n",
  "ADJUDICATIVE": "relating to adjudication, also ADJUDICATORY [adj]\n",
  "ADJUDICATOR": "one who adjudicates [n -S]\n",
  "ADJUDICATORS": "ADJUDICATOR, one who adjudicates [n]\n",
  "ADJUDICATORY": "relating to adjudication, also ADJUDICATIVE [adj]\n",
  "ADJUNCT": "attached [adj ADJUNCTLY] / something attached in a subordinate position [n -S]\n",
  "ADJUNCTION": "the act of joining; the thing joined or added [n -S]\n",
  "ADJUNCTIONS": "ADJUNCTION, the act of joining; the thing joined or added [n]\n",
  "ADJUNCTIVE": "joining; forming an adjunct [adj ADJUNCTIVELY]\n",
  "ADJUNCTIVELY": "ADJUNCTIVE, joining; forming an adjunct [adv]\n",
  "ADJUNCTLY": "ADJUNCT, attached [adv]\n",
  "ADJUNCTS": "ADJUNCT, something attached in a subordinate position [n]\n",
  "ADJURATION": "the act of adjuring; a solemn charging on oath, or under the penalty of a curse [n -S]\n",
  "ADJURATIONS": "ADJURATION, the act of adjuring; a solemn charging on oath, or under the penalty of a curse [n]\n",
  "ADJURATORY": "containing an adjuration [adj]\n",
  "ADJURE": "to command solemnly [v ADJURED, ADJURING, ADJURES]\n",
  "ADJURED": "ADJURE, to command solemnly [v]\n",
  "ADJURER": "one who commands solemnly, also ADJUROR [n -S]\n",
  "ADJURERS": "ADJURER, one who commands solemnly, also ADJUROR [n]\n",
  "ADJURES": "ADJURE, to command solemnly [v]\n",
  "ADJURING": "ADJURE, to command solemnly [v]\n",
  "ADJUROR": "one who commands solemnly, also ADJURER [n -S]\n",
  "ADJURORS": "ADJUROR, one who commands solemnly, also ADJURER [n]\n",
  "ADJUST": "to bring to a more satisfactory state [v -ED, -ING, -S]\n",
  "ADJUSTABILITIES": "ADJUSTABILITY, the quality of being adjustable [n]\n",
  "ADJUSTABILITY": "the quality of being adjustable [n ADJUSTABILITIES]\n",
  "ADJUSTABLE": "that can be adjusted [adj ADJUSTABLY]\n",
  "ADJUSTABLY": "ADJUSTABLE, that can be adjusted [adv]\n",
  "ADJUSTED": "ADJUST, to bring to a more satisfactory state [v]\n",
  "ADJUSTER": "one who adjusts [n -S]\n",
  "ADJUSTERS": "ADJUSTER, one who adjusts [n]\n",
  "ADJUSTING": "ADJUST, to bring to a more satisfactory state [v]\n",
  "ADJUSTIVE": "tending to adjust [adj]\n",
  "ADJUSTMENT": "the act of adjusting [n -S]\n",
  "ADJUSTMENTAL": "relating to adjustment [adj]\n",
  "ADJUSTMENTS": "ADJUSTMENT, the act of adjusting [n]\n",
  "ADJUSTOR": "one who adjusts, e.g. losses for an insurance company [n -S]\n",
  "ADJUSTORS": "ADJUSTOR, one who adjusts, e.g. losses for an insurance company [n]\n",
  "ADJUSTS": "ADJUST, to bring to a more satisfactory state [v]\n",
  "ADJUTAGE": "(French) a tube added to or inserted into an aperture to control the outflow of water, as a pipe at the mouth of an artificial fountain, also AJUTAGE [n -S]\n",
  "ADJUTAGES": "ADJUTAGE, (French) a tube added to or inserted into an aperture to control the outflow of water, as a pipe at the mouth of an artificial fountain, also AJUTAGE [n]\n",
  "ADJUTANCIES": "ADJUTANCY, the office of an adjutant [n]\n",
  "ADJUTANCY": "the office of an adjutant [n ADJUTANCIES]\n",
  "ADJUTANT": "an officer who assists superior officers by communicating orders, conducting correspondence, etc. [n -S]\n",
  "ADJUTANTS": "ADJUTANT, an officer who assists superior officers by communicating orders, conducting correspondence, etc. [n]\n",
  "ADJUVANCIES": "ADJUVANCY, the state of being adjuvant, serving to aid [n]\n",
  "ADJUVANCY": "the state of being adjuvant, serving to aid [n ADJUVANCIES]\n",
  "ADJUVANT": "serving to aid or contribute [adj] / a substance added to make vaccine more effective [n -S]\n",
  "ADJUVANTS": "ADJUVANT, a substance added to make vaccine more effective [n]\n",
  "ADLAND": "an idealised land portrayed by advertisements [n -S]\n",
  "ADLANDS": "ADLAND, an idealised land portrayed by advertisements [n]\n",
  "ADMAN": "a man employed in advertising [n ADMEN]\n",
  "ADMASS": "the mass audience of advertisements [n -ES]\n",
  "ADMASSES": "ADMASS, the mass audience of advertisements [n]\n",
  "ADMEASURE": "to measure [v ADMEASURED, ADMEASURING, ADMEASURES]\n",
  "ADMEASURED": "ADMEASURE, to measure [v]\n",
  "ADMEASUREMENT": "the act of measuring or apportioning [n -S]\n",
  "ADMEASUREMENTS": "ADMEASUREMENT, the act of measuring or apportioning [n]\n",
  "ADMEASURES": "ADMEASURE, to measure [v]\n",
  "ADMEASURING": "ADMEASURE, to measure [v]\n",
  "ADMEN": "ADMAN, a man employed in advertising [n]\n",
  "ADMIN": "(short for) administration [n -S]\n",
  "ADMINICLE": "that which supports or aids, esp. evidence [n -S]\n",
  "ADMINICLES": "ADMINICLE, that which supports or aids, esp. evidence [n]\n",
  "ADMINICULAR": "corroborative [adj]\n",
  "ADMINICULATE": "to support by corroboratory evidence [v ADMINICULATED, ADMINICULATING, ADMINICULATES]\n",
  "ADMINICULATED": "ADMINICULATE, to support by corroboratory evidence [v]\n",
  "ADMINICULATES": "ADMINICULATE, to support by corroboratory evidence [v]\n",
  "ADMINICULATING": "ADMINICULATE, to support by corroboratory evidence [v]\n",
  "ADMINISTER": "to manage or supervise the execution, use, or conduct of [v -ED, -ING, -S]\n",
  "ADMINISTERED": "ADMINISTER, to manage or supervise the execution, use, or conduct of [v]\n",
  "ADMINISTERING": "ADMINISTER, to manage or supervise the execution, use, or conduct of [v]\n",
  "ADMINISTERS": "ADMINISTER, to manage or supervise the execution, use, or conduct of [v]\n",
  "ADMINISTRABLE": "capable of being administered [adj]\n",
  "ADMINISTRANT": "an administrator [n -S]\n",
  "ADMINISTRANTS": "ADMINISTRANT, an administrator [n]\n",
  "ADMINISTRATE": "to administer [v ADMINISTRATED, ADMINISTRATING, ADMINISTRATES]\n",
  "ADMINISTRATED": "ADMINISTRATE, to administer [v]\n",
  "ADMINISTRATES": "ADMINISTRATE, to administer [v]\n",
  "ADMINISTRATING": "ADMINISTRATE, to administer [v]\n",
  "ADMINISTRATION": "the performance of executive duties [n -S]\n",
  "ADMINISTRATIONS": "ADMINISTRATION, the performance of executive duties [n]\n",
  "ADMINISTRATIVE": "of or relating to administration [adj]\n",
  "ADMINISTRATOR": "one who administers business or governmental affairs [n -S]\n",
  "ADMINISTRATORS": "ADMINISTRATOR, one who administers business or governmental affairs [n]\n",
  "ADMINISTRATRIX": "a female administrator [n]\n",
  "ADMINS": "ADMIN, (short for) administration [n]\n",
  "ADMIRABILITIES": "ADMIRABILITY, the quality of being admirable [n]\n",
  "ADMIRABILITY": "the quality of being admirable [n ADMIRABILITIES]\n",
  "ADMIRABLE": "worthy of being admired [adj ADMIRABLY]\n",
  "ADMIRABLENESS": "the state of being admirable [n -ES]\n",
  "ADMIRABLENESSES": "ADMIRABLENESS, the state of being admirable [n]\n",
  "ADMIRABLY": "ADMIRABLE, worthy of being admired [adv]\n",
  "ADMIRAL": "the chief commander of a navy; a naval officer of rank equivalent to a general in the army, also AMMIRAL [n -S]\n",
  "ADMIRALS": "ADMIRAL, the chief commander of a navy; a naval officer of rank equivalent to a general in the army, also AMMIRAL [n]\n",
  "ADMIRALSHIP": "the office of admiral [n -S]\n",
  "ADMIRALSHIPS": "ADMIRALSHIP, the office of admiral [n]\n",
  "ADMIRALTIES": "ADMIRALTY, the office of admiral [n]\n",
  "ADMIRALTY": "the office of admiral [n ADMIRALTIES]\n",
  "ADMIRANCE": "(Spenser) admiration, also ADMIRATION, ADMIRAUNCE [n -S]\n",
  "ADMIRANCES": "ADMIRANCE, (Spenser) admiration, also ADMIRATION, ADMIRAUNCE [n]\n",
  "ADMIRATION": "delighted or astonished approbation, also ADMIRANCE, ADMIRAUNCE [n -S]\n",
  "ADMIRATIONS": "ADMIRATION, delighted or astonished approbation, also ADMIRANCE, ADMIRAUNCE [n]\n",
  "ADMIRATIVE": "(archaic) relating to or expressing admiration [adj]\n",
  "ADMIRAUNCE": "(Spenser) admiration, also ADMIRANCE, ADMIRATION [n -S]\n",
  "ADMIRAUNCES": "ADMIRAUNCE, (Spenser) admiration, also ADMIRANCE, ADMIRATION [n]\n",
  "ADMIRE": "to have a high opinion of [v ADMIRED, ADMIRING, ADMIRES]\n",
  "ADMIRED": "ADMIRE, to have a high opinion of [v]\n",
  "ADMIRER": "one who admires [n -S]\n",
  "ADMIRERS": "ADMIRER, one who admires [n]\n",
  "ADMIRES": "ADMIRE, to have a high opinion of [v]\n",
  "ADMIRING": "ADMIRE, to have a high opinion of [v]\n",
  "ADMIRINGLY": "ADMIRING, ADMIRE, to have a high opinion of [adv]\n",
  "ADMISSIBILITIES": "ADMISSIBILITY, the quality of being admissible [n]\n",
  "ADMISSIBILITY": "the quality of being admissible [n ADMISSIBILITIES]\n",
  "ADMISSIBLE": "that can be admitted, also ADMITTABLE [adj]\n",
  "ADMISSIBLENESS": "the state of being admissible [n]\n",
  "ADMISSION": "the act of admitting [n -S]\n",
  "ADMISSIONS": "ADMISSION, the act of admitting [n]\n",
  "ADMISSIVE": "relating to admission [adj]\n",
  "ADMIT": "to allow to enter; to confess [v ADMITTED, ADMITTING, ADMITS]\n",
  "ADMITS": "ADMIT, to allow to enter; to confess [v]\n",
  "ADMITTABLE": "that can be admitted, also ADMISSIBLE [adj]\n",
  "ADMITTANCE": "the act of admitting [n -S]\n",
  "ADMITTANCES": "ADMITTANCE, the act of admitting [n]\n",
  "ADMITTED": "ADMIT, to allow to enter; to confess [v]\n",
  "ADMITTEDLY": "granting that [adv]\n",
  "ADMITTEE": "one that is admitted [n -S]\n",
  "ADMITTEES": "ADMITTEE, one that is admitted [n]\n",
  "ADMITTER": "one who admits [n -S]\n",
  "ADMITTERS": "ADMITTER, one who admits [n]\n",
  "ADMITTING": "ADMIT, to allow to enter; to confess [v]\n",
  "ADMIX": "to mix [v ADMIXED or ADMIXT, ADMIXING, ADMIXES]\n",
  "ADMIXED": "ADMIX, to mix [v]\n",
  "ADMIXES": "ADMIX, to mix [v]\n",
  "ADMIXING": "ADMIX, to mix [v]\n",
  "ADMIXT": "ADMIX, to mix [v]\n",
  "ADMIXTURE": "the action of mixing [n -S]\n",
  "ADMIXTURES": "ADMIXTURE, the action of mixing [n]\n",
  "ADMONISH": "to reprove mildly [v -ED, -ING, -ES]\n",
  "ADMONISHED": "ADMONISH, to reprove mildly [v]\n",
  "ADMONISHER": "one who admonishes [n -S]\n",
  "ADMONISHERS": "ADMONISHER, one who admonishes [n]\n",
  "ADMONISHES": "ADMONISH, to reprove mildly [v]\n",
  "ADMONISHING": "ADMONISH, to reprove mildly [v]\n",
  "ADMONISHINGLY": "ADMONISHING, ADMONISH, to reprove mildly [adv]\n",
  "ADMONISHMENT": "a firm rebuke [n -S]\n",
  "ADMONISHMENTS": "ADMONISHMENT, a firm rebuke [n]\n",
  "ADMONITION": "gentle or friendly reproof [n -S]\n",
  "ADMONITIONS": "ADMONITION, gentle or friendly reproof [n]\n",
  "ADMONITIVE": "of or like an admonition, also ADMONITORY [adj]\n",
  "ADMONITOR": "an admonisher; a monitor [n -S]\n",
  "ADMONITORILY": "ADMONITORY, warning, also ADMONITIVE [adv]\n",
  "ADMONITORS": "ADMONITOR, an admonisher; a monitor [n]\n",
  "ADMONITORY": "warning, also ADMONITIVE [adj ADMONITORILY]\n",
  "ADNASCENT": "growing on some other thing [adj]\n",
  "ADNATE": "closely attached; growing together, esp. in an unusual fashion [adj]\n",
  "ADNATION": "the state of being adnate, closely attached [n -S]\n",
  "ADNATIONS": "ADNATION, the state of being adnate, closely attached [n]\n",
  "ADNEXA": "conjoined anatomical parts [n]\n",
  "ADNEXAL": "relating to conjoined anatomical parts [adj]\n",
  "ADNOMINAL": "pertaining to an adnoun; adjectival [adj] / a word attached to a noun [n -S]\n",
  "ADNOMINALS": "ADNOMINAL, a word attached to a noun [n]\n",
  "ADNOUN": "an adjective used as a noun [n -S]\n",
  "ADNOUNS": "ADNOUN, an adjective used as a noun [n]\n",
  "ADO": "bustle or fuss [n -S]\n",
  "ADOBE": "(Spanish) an unburned, sun-dried brick made of clay and straw, also DOBE, DOBIE, DOBY [n ADOBES]\n",
  "ADOBELIKE": "like adobe [adj]\n",
  "ADOBES": "ADOBE, (Spanish) an unburned, sun-dried brick made of clay and straw, also DOBE, DOBIE, DOBY [n]\n",
  "ADOBO": "(Spanish) a Philippine dish of fish or meat [n -S]\n",
  "ADOBOS": "ADOBO, (Spanish) a Philippine dish of fish or meat [n]\n",
  "ADOLESCENCE": "the state or process of growing up [n -S]\n",
  "ADOLESCENCES": "ADOLESCENCE, the state or process of growing up [n]\n",
  "ADOLESCENT": "in the state of adolescence [adj ADOLESCENTLY] / one of adolescent age [n -S]\n",
  "ADOLESCENTLY": "ADOLESCENT, in the state of adolescence [adv]\n",
  "ADOLESCENTS": "ADOLESCENT, one of adolescent age [n]\n",
  "ADONIS": "a handsome young man [n -ES]\n",
  "ADONISE": "to adorn (oneself), also ADONIZE [v ADONISED, ADONISING, ADONISES]\n",
  "ADONISED": "ADONISE, to adorn (oneself), also ADONIZE [v]\n",
  "ADONISES": "ADONISE, to adorn (oneself), also ADONIZE [v]\n",
  "ADONISING": "ADONISE, to adorn (oneself), also ADONIZE [v]\n",
  "ADONIZE": "to adorn (oneself), also ADONISE [v ADONIZED, ADONIZING, ADONIZES]\n",
  "ADONIZED": "ADONIZE, to adorn (oneself), also ADONISE [v]\n",
  "ADONIZES": "ADONIZE, to adorn (oneself), also ADONISE [v]\n",
  "ADONIZING": "ADONIZE, to adorn (oneself), also ADONISE [v]\n",
  "ADOORS": "(obsolete) at the door; of the door; as, out adoors [adv]\n",
  "ADOPT": "to take as one's own [v -ED, -ING, -S]\n",
  "ADOPTABILITIES": "ADOPTABILITY, the quality of being adoptable [n]\n",
  "ADOPTABILITY": "the quality of being adoptable [n ADOPTABILITIES]\n",
  "ADOPTABLE": "capable of being adopted [adj]\n",
  "ADOPTED": "ADOPT, to take as one's own [v]\n",
  "ADOPTEE": "one who is adopted [n -S]\n",
  "ADOPTEES": "ADOPTEE, one who is adopted [n]\n",
  "ADOPTER": "one who adopts [n -S]\n",
  "ADOPTERS": "ADOPTER, one who adopts [n]\n",
  "ADOPTIANISM": "the doctrine that Christ, as man, is the adopted son of God, also ADOPTIONISM [n -S]\n",
  "ADOPTIANISMS": "ADOPTIANISM, the doctrine that Christ, as man, is the adopted son of God, also ADOPTIONISM [n]\n",
  "ADOPTIANIST": "a believer in adoptianism, the doctrine that Christ, as man, is the adopted son of God, also ADOPTIONIST [n -S]\n",
  "ADOPTIANISTS": "ADOPTIANIST, a believer in adoptianism, the doctrine that Christ, as man, is the adopted son of God, also ADOPTIONIST [n]\n",
  "ADOPTING": "ADOPT, to take as one's own [v]\n",
  "ADOPTION": "the act of adopting [n -S]\n",
  "ADOPTIONISM": "the doctrine that Christ, as man, is the adopted son of God, also ADOPTIANISM [n -S]\n",
  "ADOPTIONISMS": "ADOPTIONISM, the doctrine that Christ, as man, is the adopted son of God, also ADOPTIANISM [n]\n",
  "ADOPTIONIST": "a believer in adoptionism, the doctrine that Christ, as man, is the adopted son of God, also ADOPTIANIST [n -S]\n",
  "ADOPTIONISTS": "ADOPTIONIST, a believer in adoptionism, the doctrine that Christ, as man, is the adopted son of God, also ADOPTIANIST [n]\n",
  "ADOPTIONS": "ADOPTION, the act of adopting [n]\n",
  "ADOPTIOUS": "(Shakespeare) adopted [adj]\n",
  "ADOPTIVE": "due to adoption; having the specified familial relation by adoption [adj]\n",
  "ADOPTIVELY": "ADOPTIVE, due to adoption; having the specified familial relation by adoption [adv]\n",
  "ADOPTS": "ADOPT, to take as one's own [v]\n",
  "ADORABILITIES": "ADORABILITY, the state of being adorable [n]\n",
  "ADORABILITY": "the state of being adorable [n ADORABILITIES]\n",
  "ADORABLE": "worthy of being adored [adj]\n",
  "ADORABLENESS": "the state of being adorable [n -ES]\n",
  "ADORABLENESSES": "ADORABLENESS, the state of being adorable [n]\n",
  "ADORABLY": "ADORABLE, worthy of being adored [adv]\n",
  "ADORATION": "the act of adoring [n -S]\n",
  "ADORATIONS": "ADORATION, the act of adoring [n]\n",
  "ADORE": "to love deeply [v ADORED, ADORING, ADORES]\n",
  "ADORED": "ADORE, to love deeply [v]\n",
  "ADORER": "one that adores [n -S]\n",
  "ADORERS": "ADORER, one that adores [n]\n",
  "ADORES": "ADORE, to love deeply [v]\n",
  "ADORING": "ADORE, to love deeply [v]\n",
  "ADORINGLY": "ADORING, ADORE, to love deeply [adv]\n",
  "ADORKABLE": "(slang) socially inept or unfashionable in a charming or endearing way [adj]\n",
  "ADORN": "to embellish [v -ED, -ING, -S]\n",
  "ADORNED": "ADORN, to embellish [v]\n",
  "ADORNER": "one who adorns [n -S]\n",
  "ADORNERS": "ADORNER, one who adorns [n]\n",
  "ADORNING": "ADORN, to embellish [v]\n",
  "ADORNMENT": "the act of adorning [n -S]\n",
  "ADORNMENTS": "ADORNMENT, the act of adorning [n]\n",
  "ADORNS": "ADORN, to embellish [v]\n",
  "ADOS": "ADO, bustle or fuss [n]\n",
  "ADOWN": "(archaic) from a higher to a lower situation [adv]\n",
  "ADOZE": "dozing [adj]\n",
  "ADPRESS": "to press together, also APPRESS [v -ED, -ING, -ES]\n",
  "ADPRESSED": "ADPRESS, to press together, also APPRESS [v]\n",
  "ADPRESSES": "ADPRESS, to press together, also APPRESS [v]\n",
  "ADPRESSING": "ADPRESS, to press together, also APPRESS [v]\n",
  "ADRAD": "(Spenser) afraid, also ADRED [adj]\n",
  "ADRATE": "the price or tariff that businesses pay to advertise [n -S]\n",
  "ADRATES": "ADRATE, the price or tariff that businesses pay to advertise [n]\n",
  "ADREAD": "(obsolete) to dread [v ADREADED, ADREADING, ADREADS]\n",
  "ADREADED": "ADREAD, (obsolete) to dread [v]\n",
  "ADREADING": "ADREAD, (obsolete) to dread [v]\n",
  "ADREADS": "ADREAD, (obsolete) to dread [v]\n",
  "ADRED": "(Spenser) afraid, also ADRAD [adj]\n",
  "ADRENAL": "relating to the adrenal system [adj ADRENALLY] / an adrenal gland [n -S]\n",
  "ADRENALECTOMIES": "ADRENALECTOMY, the surgical removal of the adrenal glands [n]\n",
  "ADRENALECTOMY": "the surgical removal of the adrenal glands [n ADRENALECTOMIES]\n",
  "ADRENALIN": "a hormone secreted by the adrenal glands, also ADRENALINE [n -S]\n",
  "ADRENALINE": "a hormone secreted by the adrenal glands, also ADRENALIN [n -S]\n",
  "ADRENALINES": "ADRENALINE, a hormone secreted by the adrenal glands, also ADRENALIN [n]\n",
  "ADRENALINS": "ADRENALIN, a hormone secreted by the adrenal glands, also ADRENALINE [n]\n",
  "ADRENALISED": "charged with adrenalin, also ADRENALIZED [adj]\n",
  "ADRENALIZED": "charged with adrenalin, also ADRENALISED [adj]\n",
  "ADRENALLY": "ADRENAL, relating to the adrenal system [adv]\n",
  "ADRENALS": "ADRENAL, an adrenal gland [n]\n",
  "ADRENERGIC": "released or activated by adrenalin [adj ADRENERGICALLY]\n",
  "ADRENERGICALLY": "ADRENERGIC, released or activated by adrenalin [adv]\n",
  "ADRENOCEPTOR": "an adrenal gland receptor [n -S]\n",
  "ADRENOCEPTORS": "ADRENOCEPTOR, an adrenal gland receptor [n]\n",
  "ADRENOCHROME": "a mixture of quinones [n -S]\n",
  "ADRENOCHROMES": "ADRENOCHROME, a mixture of quinones [n]\n",
  "ADRENOCORTICAL": "of, relating to, or derived from the cortex of the adrenal glands [adj]\n",
  "ADRIAMYCIN": "a trade name of the anticancer drug doxorubicin [n -S]\n",
  "ADRIAMYCINS": "ADRIAMYCIN, a trade name of the anticancer drug doxorubicin [n]\n",
  "ADRIFT": "drifting [adj]\n",
  "ADROIT": "skilful [adj ADROITER, ADROITEST, ADROITLY]\n",
  "ADROITER": "ADROIT, skilful [adj]\n",
  "ADROITEST": "ADROIT, skilful [adj]\n",
  "ADROITLY": "ADROIT, skilful [adv]\n",
  "ADROITNESS": "the quality of being adroit [n -ES]\n",
  "ADROITNESSES": "ADROITNESS, the quality of being adroit [n]\n",
  "ADRY": "(archaic) in a state of thirst or dryness [adv]\n",
  "ADS": "AD, (colloquial) an advertisement [n]\n",
  "ADSCITITIOUS": "added or assumed, also ASCITITIOUS [adj ADSCITITIOUSLY]\n",
  "ADSCITITIOUSLY": "ADSCITITIOUS, added or assumed, also ASCITITIOUS [adv]\n",
  "ADSCRIPT": "(historical) a feudal serf attached to the soil [n -S]\n",
  "ADSCRIPTION": "the state of being adscript, a feudal serf attached to the soil, also ASCRIPTION [n -S]\n",
  "ADSCRIPTIONS": "ADSCRIPTION, the state of being adscript, a feudal serf attached to the soil, also ASCRIPTION [n]\n",
  "ADSCRIPTS": "ADSCRIPT, (historical) a feudal serf attached to the soil [n]\n",
  "ADSORB": "to gather and hold another substance on the surface [v -ED, -ING, -S]\n",
  "ADSORBABILITIES": "ADSORBABILITY, the ability to be adsorbed [n]\n",
  "ADSORBABILITY": "the ability to be adsorbed [n ADSORBABILITIES]\n",
  "ADSORBABLE": "that can be adsorbed [adj]\n",
  "ADSORBATE": "a substance or molecules adsorbed [n -S]\n",
  "ADSORBATES": "ADSORBATE, a substance or molecules adsorbed [n]\n",
  "ADSORBED": "ADSORB, to gather and hold another substance on the surface [v]\n",
  "ADSORBENT": "a substance that adsorbs [n -S]\n",
  "ADSORBENTS": "ADSORBENT, a substance that adsorbs [n]\n",
  "ADSORBER": "something that adsorbs [n -S]\n",
  "ADSORBERS": "ADSORBER, something that adsorbs [n]\n",
  "ADSORBING": "ADSORB, to gather and hold another substance on the surface [v]\n",
  "ADSORBS": "ADSORB, to gather and hold another substance on the surface [v]\n",
  "ADSORPTION": "the adhering of atoms or molecules of gases, liquids, or solutes to exposed surfaces (usually of solids) [n -S]\n",
  "ADSORPTIONS": "ADSORPTION, the adhering of atoms or molecules of gases, liquids, or solutes to exposed surfaces (usually of solids) [n]\n",
  "ADSORPTIVE": "relating to adsorption [adj]\n",
  "ADSPEAK": "the kind of language or jargon used in advertising or in advertisements [n -S]\n",
  "ADSPEAKS": "ADSPEAK, the kind of language or jargon used in advertising or in advertisements [n]\n",
  "ADSUKI": "(Japanese) a kind of bean, also ADUKI, ADZUKI, AZUKI [n -S]\n",
  "ADSUKIS": "ADSUKI, (Japanese) a kind of bean, also ADUKI, ADZUKI, AZUKI [n]\n",
  "ADSUM": "(Latin) I am here (answering a roll call) [interj]\n",
  "ADUKI": "(Japanese) a kind of bean, also ADSUKI, ADZUKI, AZUKI [n -S]\n",
  "ADUKIS": "ADUKI, (Japanese) a kind of bean, also ADSUKI, ADZUKI, AZUKI [n]\n",
  "ADULARESCENCE": "the quality of being adularescent, having or emitting a milky or bluish iridescence [n -S]\n",
  "ADULARESCENCES": "ADULARESCENCE, the quality of being adularescent, having or emitting a milky or bluish iridescence [n]\n",
  "ADULARESCENT": "of minerals such as moonstone, having or emitting a milky or bluish iridescence [adj]\n",
  "ADULARIA": "a transparent or translucent variety of common feldspar, aka moonstone [n -S]\n",
  "ADULARIAS": "ADULARIA, a transparent or translucent variety of common feldspar, aka moonstone [n]\n",
  "ADULATE": "to fawn upon [v ADULATED, ADULATING, ADULATES]\n",
  "ADULATED": "ADULATE, to fawn upon [v]\n",
  "ADULATES": "ADULATE, to fawn upon [v]\n",
  "ADULATING": "ADULATE, to fawn upon [v]\n",
  "ADULATION": "the act of adulating [n -S]\n",
  "ADULATIONS": "ADULATION, the act of adulating [n]\n",
  "ADULATOR": "one who adulates [n -S]\n",
  "ADULATORS": "ADULATOR, one who adulates [n]\n",
  "ADULATORY": "showing adulation [adj]\n",
  "ADULT": "grown up [adj ADULTLY] / a fully developed individual [n -S]\n",
  "ADULTERANT": "that which is used to adulterate anything [n -S]\n",
  "ADULTERANTS": "ADULTERANT, that which is used to adulterate anything [n]\n",
  "ADULTERATE": "to make impure by the addition of a foreign substance [v ADULTERATED, ADULTERATING, ADULTERATES]\n",
  "ADULTERATED": "ADULTERATE, to make impure by the addition of a foreign substance [v]\n",
  "ADULTERATES": "ADULTERATE, to make impure by the addition of a foreign substance [v]\n",
  "ADULTERATING": "ADULTERATE, to make impure by the addition of a foreign substance [v]\n",
  "ADULTERATION": "the process of adulterating [n -S]\n",
  "ADULTERATIONS": "ADULTERATION, the process of adulterating [n]\n",
  "ADULTERATOR": "one who adulterates a commodity [n -S]\n",
  "ADULTERATORS": "ADULTERATOR, one who adulterates a commodity [n]\n",
  "ADULTERER": "one who commits adultery [n -S]\n",
  "ADULTERERS": "ADULTERER, one who commits adultery [n]\n",
  "ADULTERESS": "a female adulterer, also ADULTRESS [n -ES]\n",
  "ADULTERESSES": "ADULTERESS, a female adulterer, also ADULTRESS [n]\n",
  "ADULTERIES": "ADULTERY, voluntary sexual intercourse between a married person and someone other than his or her spouse [n]\n",
  "ADULTERINE": "an offspring of adultery [n -S]\n",
  "ADULTERINES": "ADULTERINE, an offspring of adultery [n]\n",
  "ADULTERISE": "(archaic) to commit adultery, also ADULTERIZE [v ADULTERISED, ADULTERISING, ADULTERISES]\n",
  "ADULTERISED": "ADULTERISE, (archaic) to commit adultery, also ADULTERIZE [v]\n",
  "ADULTERISES": "ADULTERISE, (archaic) to commit adultery, also ADULTERIZE [v]\n",
  "ADULTERISING": "ADULTERISE, (archaic) to commit adultery, also ADULTERIZE [v]\n",
  "ADULTERIZE": "(archaic) to commit adultery [v ADULTERIZED, ADULTERIZING, ADULTERIZES]\n",
  "ADULTERIZED": "ADULTERIZE, (archaic) to commit adultery [v]\n",
  "ADULTERIZES": "ADULTERIZE, (archaic) to commit adultery [v]\n",
  "ADULTERIZING": "ADULTERIZE, (archaic) to commit adultery [v]\n",
  "ADULTEROUS": "relating to, characterized by, or given to adultery [adj ADULTEROUSLY]\n",
  "ADULTEROUSLY": "ADULTEROUS, relating to, characterized by, or given to adultery [adv]\n",
  "ADULTERY": "voluntary sexual intercourse between a married person and someone other than his or her spouse [n ADULTERIES]\n",
  "ADULTESCENT": "an adult whose activities and interests are typically associated with youth culture [n -S]\n",
  "ADULTESCENTS": "ADULTESCENT, an adult whose activities and interests are typically associated with youth culture [n]\n",
  "ADULTHOOD": "the state of being an adult [n -S]\n",
  "ADULTHOODS": "ADULTHOOD, the state of being an adult [n]\n",
  "ADULTLIKE": "like an adult [adj]\n",
  "ADULTLY": "ADULT, grown up [adv]\n",
  "ADULTNESS": "the state of being adult [n -ES]\n",
  "ADULTNESSES": "ADULTNESS, the state of being adult [n]\n",
  "ADULTRESS": "a female adulterer, also ADULTERESS [n -ES]\n",
  "ADULTRESSES": "ADULTRESS, a female adulterer, also ADULTERESS [n]\n",
  "ADULTS": "ADULT, a fully developed individual [n]\n",
  "ADUMBRAL": "shadowy [adj]\n",
  "ADUMBRATE": "to foreshadow vaguely, to intimate [v ADUMBRATED, ADUMBRATING, ADUMBRATES]\n",
  "ADUMBRATED": "ADUMBRATE, to foreshadow vaguely, to intimate [v]\n",
  "ADUMBRATES": "ADUMBRATE, to foreshadow vaguely, to intimate [v]\n",
  "ADUMBRATING": "ADUMBRATE, to foreshadow vaguely, to intimate [v]\n",
  "ADUMBRATION": "a sketch or outline [n -S]\n",
  "ADUMBRATIONS": "ADUMBRATION, a sketch or outline [n]\n",
  "ADUMBRATIVE": "with the character of a sketch or outline [adj ADUMBRATIVELY]\n",
  "ADUMBRATIVELY": "ADUMBRATIVE, with the character of a sketch or outline [adv]\n",
  "ADUNC": "(Latin) hooked, also ADUNCATE, ADUNCATED, ADUNCOUS [adj]\n",
  "ADUNCATE": "hooked, also ADUNC [adj]\n",
  "ADUNCATED": "hooked, also ADUNC, ADUNCATE, ADUNCOUS [adj]\n",
  "ADUNCITIES": "ADUNCITY, state of being hooked [n]\n",
  "ADUNCITY": "state of being hooked [n ADUNCITIES]\n",
  "ADUNCOUS": "hooked [adj]\n",
  "ADUST": "(Milton) to scorch [v -ED, -ING, -S]\n",
  "ADUSTED": "ADUST, (Milton) to scorch [v]\n",
  "ADUSTING": "ADUST, (Milton) to scorch [v]\n",
  "ADUSTS": "ADUST, (Milton) to scorch [v]\n",
  "ADVANCE": "to put forward, to go forward [v ADVANCED, ADVANCING, ADVANCES]\n",
  "ADVANCED": "ADVANCE, to put forward, to go forward [v]\n",
  "ADVANCEMENT": "promotion or elevation to a higher rank or position [n -S]\n",
  "ADVANCEMENTS": "ADVANCEMENT, promotion or elevation to a higher rank or position [n]\n",
  "ADVANCER": "one who advances [n -S]\n",
  "ADVANCERS": "ADVANCER, one who advances [n]\n",
  "ADVANCES": "ADVANCE, to put forward, to go forward [v]\n",
  "ADVANCING": "ADVANCE, to put forward, to go forward [v]\n",
  "ADVANCINGLY": "ADVANCING, ADVANCE, to put forward, to go forward [adv]\n",
  "ADVANTAGE": "to confer an advantage, a favourable condition, upon [v ADVANTAGED, ADVANTAGING, ADVANTAGES]\n",
  "ADVANTAGEABLE": "profitable; convenient [adj]\n",
  "ADVANTAGED": "ADVANTAGE, to confer an advantage, a favourable condition, upon [v]\n",
  "ADVANTAGEOUS": "giving an advantage [adj]\n",
  "ADVANTAGEOUSLY": "ADVANTAGEOUS, giving an advantage [adv]\n",
  "ADVANTAGES": "ADVANTAGE, to confer an advantage, a favourable condition, upon [v]\n",
  "ADVANTAGING": "ADVANTAGE, to confer an advantage, a favourable condition, upon [v]\n",
  "ADVECT": "to transport by the flow of a fluid [v -ED, -ING, -S]\n",
  "ADVECTED": "ADVECT, to transport by the flow of a fluid [v]\n",
  "ADVECTING": "ADVECT, to transport by the flow of a fluid [v]\n",
  "ADVECTION": "the horizontal movement of air [n -S]\n",
  "ADVECTIONS": "ADVECTION, the horizontal movement of air [n]\n",
  "ADVECTIVE": "relating to advection, the horizontal movement of air [adj]\n",
  "ADVECTS": "ADVECT, to transport by the flow of a fluid [v]\n",
  "ADVENE": "to be added over and above [v ADVENED, ADVENING, ADVENES]\n",
  "ADVENED": "ADVENE, to be added over and above [v]\n",
  "ADVENES": "ADVENE, to be added over and above [v]\n",
  "ADVENING": "ADVENE, to be added over and above [v]\n",
  "ADVENT": "arrival [n -S]\n",
  "ADVENTITIA": "the outermost covering of an organ or part, esp. of a blood vessel [n -S]\n",
  "ADVENTITIAL": "relating to the adventitia, the outermost covering of an organ or part, esp. of a blood vessel [adj]\n",
  "ADVENTITIAS": "ADVENTITIA, the outermost covering of an organ or part, esp. of a blood vessel [n]\n",
  "ADVENTITIOUS": "coming from another source; arising or occurring sporadically or in other than the usual location [adj ADVENTITIOUSLY]\n",
  "ADVENTITIOUSLY": "ADVENTITIOUS, coming from another source; arising or occurring sporadically or in other than the usual location [adv]\n",
  "ADVENTIVE": "a thing or person coming from outside [n -S]\n",
  "ADVENTIVES": "ADVENTIVE, a thing or person coming from outside [n]\n",
  "ADVENTS": "ADVENT, arrival [n]\n",
  "ADVENTURE": "to risk, to dare, also AVENTURE [v ADVENTURED, ADVENTURING, ADVENTURES]\n",
  "ADVENTURED": "ADVENTURE, to risk, to dare, also AVENTURE [v]\n",
  "ADVENTUREFUL": "daring [adj]\n",
  "ADVENTURER": "one who adventures [n -S]\n",
  "ADVENTURERS": "ADVENTURER, one who adventures [n]\n",
  "ADVENTURES": "ADVENTURE, to risk, to dare, also AVENTURE [v]\n",
  "ADVENTURESOME": "inclined to take risks [adj]\n",
  "ADVENTURESS": "a female adventurer [n -ES]\n",
  "ADVENTURESSES": "ADVENTURESS, a female adventurer [n]\n",
  "ADVENTURING": "the act of having an adventure [n -S]\n",
  "ADVENTURINGS": "ADVENTURING, the act of having an adventure [n]\n",
  "ADVENTURISM": "improvisation in the absence or in defiance of accepted plans or principles [n -S]\n",
  "ADVENTURISMS": "ADVENTURISM, improvisation in the absence or in defiance of accepted plans or principles [n]\n",
  "ADVENTURIST": "a practitioner of adventurism [n -S]\n",
  "ADVENTURISTIC": "of or like adventurism [adj]\n",
  "ADVENTURISTS": "ADVENTURIST, a practitioner of adventurism [n]\n",
  "ADVENTUROUS": "disposed to seek adventure [adj ADVENTUROUSLY]\n",
  "ADVENTUROUSLY": "ADVENTUROUS, disposed to seek adventure [adv]\n",
  "ADVENTUROUSNESS": "the state of being adventurous [n]\n",
  "ADVERB": "a word used to modify the meaning of a verb, adjective, or other adverb [n -S]\n",
  "ADVERBIAL": "relating to an adverb [adj ADVERBIALLY] / an adverbial phrase [n -S]\n",
  "ADVERBIALISE": "to give the character of an adverb to, also ADVERBIALIZE [v ADVERBIALISED, ADVERBIALISING, ADVERBIALISES]\n",
  "ADVERBIALISED": "ADVERBIALISE, to give the character of an adverb to, also ADVERBIALIZE [v]\n",
  "ADVERBIALISES": "ADVERBIALISE, to give the character of an adverb to, also ADVERBIALIZE [v]\n",
  "ADVERBIALISING": "ADVERBIALISE, to give the character of an adverb to, also ADVERBIALIZE [v]\n",
  "ADVERBIALIZE": "to give the character of an adverb to, also ADVERBIALISE [v ADVERBIALIZED, ADVERBIALIZING, ADVERBIALIZES]\n",
  "ADVERBIALIZED": "ADVERBIALIZE, to give the character of an adverb to, also ADVERBIALISE [v]\n",
  "ADVERBIALIZES": "ADVERBIALIZE, to give the character of an adverb to, also ADVERBIALISE [v]\n",
  "ADVERBIALIZING": "ADVERBIALIZE, to give the character of an adverb to, also ADVERBIALISE [v]\n",
  "ADVERBIALLY": "ADVERBIAL, relating to an adverb [adv]\n",
  "ADVERBIALS": "ADVERBIAL, an adverbial phrase [n]\n",
  "ADVERBS": "ADVERB, a word used to modify the meaning of a verb, adjective, or other adverb [n]\n",
  "ADVERGAMING": "a method of interactive marketing in which free downloadable computer games appear on websites (often as pop-ups) to advertise a company or product [n -S]\n",
  "ADVERGAMINGS": "ADVERGAMING, a method of interactive marketing in which free downloadable computer games appear on websites (often as pop-ups) to advertise a company or product [n]\n",
  "ADVERSARIA": "miscellaneous notes; commonplace books [n]\n",
  "ADVERSARIAL": "combative, antagonistic [adj]\n",
  "ADVERSARIES": "ADVERSARY, an opponent [n]\n",
  "ADVERSARINESS": "the state of being an adversary [n -ES]\n",
  "ADVERSARINESSES": "ADVERSARINESS, the state of being an adversary [n]\n",
  "ADVERSARY": "an opponent [n ADVERSARIES]\n",
  "ADVERSATIVE": "expressing opposition [adj ADVERSATIVELY] / a word or phrase expressing opposition [n -S]\n",
  "ADVERSATIVELY": "ADVERSATIVE, expressing opposition [adv]\n",
  "ADVERSATIVES": "ADVERSATIVE, a word or phrase expressing opposition [n]\n",
  "ADVERSE": "acting against [adj ADVERSER, ADVERSEST, ADVERSELY]\n",
  "ADVERSELY": "ADVERSE, acting against [adv]\n",
  "ADVERSENESS": "the quality of being adverse [n -ES]\n",
  "ADVERSENESSES": "ADVERSENESS, the quality of being adverse [n]\n",
  "ADVERSER": "ADVERSE, acting against [adj]\n",
  "ADVERSEST": "ADVERSE, acting against [adj]\n",
  "ADVERSITIES": "ADVERSITY, a state, condition, or instance of serious or continued difficulty or adverse fortune [n]\n",
  "ADVERSITY": "a state, condition, or instance of serious or continued difficulty or adverse fortune [n ADVERSITIES]\n",
  "ADVERT": "an advertisement [n -S] / to refer to in speech or writing [v -ED, -ING, -S]\n",
  "ADVERTED": "ADVERT, to refer to in speech or writing [v]\n",
  "ADVERTENCE": "the act of adverting, of the quality of being advertent, also ADVERTENCY [n -S]\n",
  "ADVERTENCES": "ADVERTENCE, the act of adverting, of the quality of being advertent, also ADVERTENCY [n]\n",
  "ADVERTENCIES": "ADVERTENCY, the act of adverting, of the quality of being advertent, also ADVERTENCE [n]\n",
  "ADVERTENCY": "the act of adverting, of the quality of being advertent, also ADVERTENCE [n ADVERTENCIES]\n",
  "ADVERTENT": "attentive, heedful [adj ADVERTENTLY]\n",
  "ADVERTENTLY": "ADVERTENT, attentive, heedful [adv]\n",
  "ADVERTING": "ADVERT, to refer to in speech or writing [v]\n",
  "ADVERTISE": "to draw attention to (a product, service, or event) in a public medium to promote sales or attendance, also ADVERTIZE [v ADVERTISED, ADVERTISING, ADVERTISES]\n",
  "ADVERTISED": "ADVERTISE, to draw attention to (a product, service, or event) in a public medium to promote sales or attendance, also ADVERTIZE [v]\n",
  "ADVERTISEMENT": "the act of advertising [n -S]\n",
  "ADVERTISEMENTS": "ADVERTISEMENT, the act of advertising [n]\n",
  "ADVERTISER": "one who advertises, also ADVERTIZER [n -S]\n",
  "ADVERTISERS": "ADVERTISER, one who advertises, also ADVERTIZER [n]\n",
  "ADVERTISES": "ADVERTISE, to draw attention to (a product, service, or event) in a public medium to promote sales or attendance, also ADVERTIZE [v]\n",
  "ADVERTISING": "the business of producing advertisements [n -S]\n",
  "ADVERTISINGS": "ADVERTISING, the business of producing advertisements [n]\n",
  "ADVERTIZE": "to draw attention to (a product, service, or event) in a public medium to promote sales or attendance, also ADVERTISE [v ADVERTIZED, ADVERTIZING, ADVERTIZES]\n",
  "ADVERTIZED": "ADVERTIZE, to draw attention to (a product, service, or event) in a public medium to promote sales or attendance, also ADVERTISE [v]\n",
  "ADVERTIZEMENT": "an advertisement [n -S]\n",
  "ADVERTIZEMENTS": "ADVERTIZEMENT, an advertisement [n]\n",
  "ADVERTIZER": "one who advertises, also ADVERTISER [n -S]\n",
  "ADVERTIZERS": "ADVERTIZER, one who advertises, also ADVERTISER [n]\n",
  "ADVERTIZES": "ADVERTIZE, to draw attention to (a product, service, or event) in a public medium to promote sales or attendance, also ADVERTISE [v]\n",
  "ADVERTIZING": "the business of producing advertisements [n -S]\n",
  "ADVERTIZINGS": "ADVERTIZING, the business of producing advertisements [n]\n",
  "ADVERTORIAL": "an advertisement presented as if it were editorial material [n -S]\n",
  "ADVERTORIALS": "ADVERTORIAL, an advertisement presented as if it were editorial material [n]\n",
  "ADVERTS": "ADVERT, to refer to in speech or writing [v]\n",
  "ADVEW": "(Spenser) to view [v -ED, -ING, -S]\n",
  "ADVEWED": "ADVEW, (Spenser) to view [v]\n",
  "ADVEWING": "ADVEW, (Spenser) to view [v]\n",
  "ADVEWS": "ADVEW, (Spenser) to view [v]\n",
  "ADVICE": "counsel [n -S]\n",
  "ADVICEFUL": "full of advice [adj]\n",
  "ADVICES": "ADVICE, counsel [n]\n",
  "ADVISABILITIES": "ADVISABILITY, the quality of being advisable [n]\n",
  "ADVISABILITY": "the quality of being advisable [n ADVISABILITIES]\n",
  "ADVISABLE": "sensible, to be recommended [adj]\n",
  "ADVISABLENESS": "the state of being advisable [n -ES]\n",
  "ADVISABLENESSES": "ADVISABLENESS, the state of being advisable [n]\n",
  "ADVISABLY": "ADVISABLE, sensible, to be recommended [adv]\n",
  "ADVISATORY": "having the attribute of advising, also ADVISORY [adj]\n",
  "ADVISE": "to give advice to [v ADVISED, ADVISING, ADVISES]\n",
  "ADVISED": "ADVISE, to give advice to [v]\n",
  "ADVISEDLY": "ADVISED, ADVISE, to give advice to [adv]\n",
  "ADVISEDNESS": "the state of being advised [n -ES]\n",
  "ADVISEDNESSES": "ADVISEDNESS, the state of being advised [n]\n",
  "ADVISEE": "one who is given counsel [n -S]\n",
  "ADVISEES": "ADVISEE, one who is given counsel [n]\n",
  "ADVISEMENT": "counsel; advice, also AVISEMENT, VIZAMENT [n -S]\n",
  "ADVISEMENTS": "ADVISEMENT, counsel; advice, also AVISEMENT, VIZAMENT [n]\n",
  "ADVISER": "one who gives counsel [n -S]\n",
  "ADVISERS": "ADVISER, one who gives counsel [n]\n",
  "ADVISERSHIP": "the office of adviser [n -S]\n",
  "ADVISERSHIPS": "ADVISERSHIP, the office of adviser [n]\n",
  "ADVISES": "ADVISE, to give advice to [v]\n",
  "ADVISING": "(Shakespeare) counsel, advice [n -S]\n",
  "ADVISINGS": "ADVISING, (Shakespeare) counsel, advice [n]\n",
  "ADVISOR": "one who gives counsel [n -S]\n",
  "ADVISORATE": "the body of advisors appointed by an education authority [n -S]\n",
  "ADVISORATES": "ADVISORATE, the body of advisors appointed by an education authority [n]\n",
  "ADVISORIES": "ADVISORY, a report giving information [n]\n",
  "ADVISORS": "ADVISOR, one who gives counsel [n]\n",
  "ADVISORY": "a report giving information [n ADVISORIES]\n",
  "ADVOCAAT": "(Dutch) a liqueur containing rum and raw eggs [n -S]\n",
  "ADVOCAATS": "ADVOCAAT, (Dutch) a liqueur containing rum and raw eggs [n]\n",
  "ADVOCACIES": "ADVOCACY, the function of an advocate [n]\n",
  "ADVOCACY": "the function of an advocate [n ADVOCACIES]\n",
  "ADVOCATE": "to plead in favour of [v ADVOCATED, ADVOCATING, ADVOCATES]\n",
  "ADVOCATED": "ADVOCATE, to plead in favour of [v]\n",
  "ADVOCATES": "ADVOCATE, to plead in favour of [v]\n",
  "ADVOCATING": "ADVOCATE, to plead in favour of [v]\n",
  "ADVOCATION": "the act of advocating or pleading, also ADVOCACY [n -S]\n",
  "ADVOCATIONS": "ADVOCATION, the act of advocating or pleading, also ADVOCACY [n]\n",
  "ADVOCATIVE": "relating to the function of an advocate [adj]\n",
  "ADVOCATOR": "one who advocates [n ADVOCATORS]\n",
  "ADVOCATORS": "ADVOCATOR, one who advocates [n]\n",
  "ADVOCATORY": "of or pertaining to an advocate [adj]\n",
  "ADVOUTRER": "(obsolete) an adulterer [n -S]\n",
  "ADVOUTRERS": "ADVOUTRER, (obsolete) an adulterer [n]\n",
  "ADVOUTRIES": "ADVOUTRY, (obsolete) adultery, also AVOUTRY [n]\n",
  "ADVOUTRY": "(obsolete) adultery, also AVOUTRY [n ADVOUTRIES]\n",
  "ADVOWSON": "the right of presentation to a church benefice [n -S]\n",
  "ADVOWSONS": "ADVOWSON, the right of presentation to a church benefice [n]\n",
  "ADWARD": "(Spenser) to award [v -ED, -ING, -S]\n",
  "ADWARDED": "ADWARD, (Spenser) to award [v]\n",
  "ADWARDING": "ADWARD, (Spenser) to award [v]\n",
  "ADWARDS": "ADWARD, (Spenser) to award [v]\n",
  "ADWARE": "software with embedded advertisements [n -S]\n",
  "ADWARES": "ADWARE, software with embedded advertisements [n]\n",
  "ADWOMAN": "a female worker in the advertising industry [n ADWOMEN]\n",
  "ADWOMEN": "ADWOMAN, a female worker in the advertising industry [n]\n",
  "ADYNAMIA": "lack of physical strength [n -S]\n",
  "ADYNAMIAS": "ADYNAMIA, lack of physical strength [n]\n",
  "ADYNAMIC": "without strength [adj]\n",
  "ADYTA": "ADYTUM, (Latin) the inner sanctuary of a temple [n]\n",
  "ADYTUM": "(Latin) the inner sanctuary of a temple [n ADYTA]\n",
  "ADZ": "to dress timber with an arched blade set at right angles to the handle, also ADZE [v -ED, -ING, -ES]\n",
  "ADZE": "to dress timber with a cutting tool with an arched blade set at right angles to the handle, also ADZ [v ADZED, ADZING, ADZES]\n",
  "ADZED": "ADZ, to dress timber with an arched blade set at right angles to the handle, also ADZE [v]\n",
  "ADZELIKE": "like an adze [adj]\n",
  "ADZES": "ADZE, to dress timber with a cutting tool with an arched blade set at right angles to the handle, also ADZ [v]\n",
  "ADZING": "ADZ, to dress timber with an arched blade set at right angles to the handle, also ADZE [v]\n",
  "ADZUKI": "(Japanese) a kind of bean, also ADSUKI, ADUKI, AZUKI [n -S]\n",
  "ADZUKIS": "ADZUKI, (Japanese) a kind of bean, also ADSUKI, ADUKI, AZUKI [n]\n",
  "AE": "(Scots) one, also YAE [adj]\n",
  "AECIA": "AECIUM, (Greek) a cup-shaped structure in rust fungi, also AECIDIUM [n]\n",
  "AECIAL": "relating to an aecium, a cup-shaped fructification in rust fungi, also AECIDIAL [adj]\n",
  "AECIDIA": "AECIDIUM, (Greek) a cup-shaped structure in rust fungi, also AECIUM [n]\n",
  "AECIDIAL": "relating to an aecidium, a cup-shaped fructification in rust fungi, also AECIAL [adj]\n",
  "AECIDIOSPORE": "a spore produced in an aecidium [n -S]\n",
  "AECIDIOSPORES": "AECIDIOSPORE, a spore produced in an aecidium [n]\n",
  "AECIDIUM": "(Greek) a cup-shaped structure in rust fungi, also AECIUM [n AECIDIA]\n",
  "AECIDOSPORE": "a spore produced in an aecidium, also AECIOSPORE [n -S]\n",
  "AECIDOSPORES": "AECIDOSPORE, a spore produced in an aecidium, also AECIOSPORE [n]\n",
  "AECIOSPORE": "a spore produced in an aecidium, also AECIDOSPORE [n -S]\n",
  "AECIOSPORES": "AECIOSPORE, a spore produced in an aecidium, also AECIDOSPORE [n]\n",
  "AECIUM": "(Greek) a cup-shaped structure in rust fungi, also AECIDIUM [n AECIA]\n",
  "AEDES": "(Greek) any of a genus of mosquitoes, including one that carries dengue and yellow fever [n AEDES]\n",
  "AEDICULE": "a door or window with columns beside and a pediment above [n -S]\n",
  "AEDICULES": "AEDICULE, a door or window with columns beside and a pediment above [n]\n",
  "AEDILE": "(Latin) in classical times, a magistrate in charge of games, markets or buildings, also EDILE [n -S]\n",
  "AEDILES": "AEDILE, (Latin) in classical times, a magistrate in charge of games, markets or buildings, also EDILE [n]\n",
  "AEDILESHIP": "the office of an aedile [n -S]\n",
  "AEDILESHIPS": "AEDILESHIP, the office of an aedile [n]\n",
  "AEDINE": "pertaining to an aedes, a genus of mosquito [adj]\n",
  "AEFALD": "onefold, also AEFAULD, AFALD, AFAWLD [adj]\n",
  "AEFAULD": "onefold, also AEFALD, AFALD, AFAWLD [adj]\n",
  "AEGIRINE": "a green mineral, a silicate of iron and sodium, also AEGIRITE [n -S]\n",
  "AEGIRINES": "AEGIRINE, a green mineral, a silicate of iron and sodium, also AEGIRITE [n]\n",
  "AEGIRITE": "a green mineral, a silicate of iron and sodium, also AEGIRINE [n -S]\n",
  "AEGIRITES": "AEGIRITE, a green mineral, a silicate of iron and sodium, also AEGIRINE [n]\n",
  "AEGIS": "(Greek) protection, patronage, also EGIS [n -ES]\n",
  "AEGISES": "AEGIS, (Greek) protection, patronage, also EGIS [n]\n",
  "AEGLOGUE": "(archaic) a pastoral poem, often in the form of a dialogue between shepherds, also ECLOGUE [n -S]\n",
  "AEGLOGUES": "AEGLOGUE, (archaic) a pastoral poem, often in the form of a dialogue between shepherds, also ECLOGUE [n]\n",
  "AEGROTAT": "(archaic) an unclassified degree granted a university student prevented by illness from attending the final examinations [n -S]\n",
  "AEGROTATS": "AEGROTAT, (archaic) an unclassified degree granted a university student prevented by illness from attending the final examinations [n]\n",
  "AEMULE": "(Spenser) to emulate, also EMULE [v AEMULED, AEMULING, AEMULES]\n",
  "AEMULED": "AEMULE, (Spenser) to emulate, also EMULE [v]\n",
  "AEMULES": "AEMULE, (Spenser) to emulate, also EMULE [v]\n",
  "AEMULING": "AEMULE, (Spenser) to emulate, also EMULE [v]\n",
  "AENEOUS": "(Latin) of a shining bronze colour, also AENEUS [adj]\n",
  "AENEUS": "(Latin) of a shining bronze colour [adj] / a kind of aquarium fish, named for its bronze colour [n -ES]\n",
  "AENEUSES": "AENEUS, a kind of aquarium fish, named for its bronze colour [n]\n",
  "AEOLIAN": "(Latin) relating to, acted on by, or due to the agency of, the wind, also EOLIAN [adj]\n",
  "AEOLIPILE": "the first steam engine, with a globe made to revolve by steam jets, also AEOLIPYLE, EOLIPILE, EOLOPILE [n -S]\n",
  "AEOLIPILES": "AEOLIPILE, the first steam engine, with a globe made to revolve by steam jets, also AEOLIPYLE, EOLIPILE, EOLOPILE [n]\n",
  "AEOLIPYLE": "the first steam engine, with a globe made to revolve by steam jets, also AEOLIPILE, EOLIPILE, EOLOPILE [n -S]\n",
  "AEOLIPYLES": "AEOLIPYLE, the first steam engine, with a globe made to revolve by steam jets, also AEOLIPILE, EOLIPILE, EOLOPILE [n]\n",
  "AEOLOTROPIC": "having different physical properties in different positions or directions, anisotropic [adj]\n",
  "AEOLOTROPIES": "AEOLOTROPY, variation in physical properties on basis of position [n]\n",
  "AEOLOTROPY": "variation in physical properties on basis of position [n AEOLOTROPIES]\n",
  "AEON": "the largest division of geological time, composed of several eras, also EON [n -S]\n",
  "AEONIAN": "lasting for aeons, eternal, also AEONIC, EONIAN [adj]\n",
  "AEONIC": "lasting for aeons, eternal, also AEONIAN, EONIAN [adj]\n",
  "AEONS": "AEON, the largest division of geological time, composed of several eras, also EON [n]\n",
  "AEPYORNIS": "(Greek) a large fossil bird of Madagascar [n -ES]\n",
  "AEPYORNISES": "AEPYORNIS, (Greek) a large fossil bird of Madagascar [n]\n",
  "AEQUORIN": "a protein secreted by jellyfish [n -S]\n",
  "AEQUORINS": "AEQUORIN, a protein secreted by jellyfish [n]\n",
  "AERADIO": "(Canadian) a Canadian radio service for pilots [n -S]\n",
  "AERADIOS": "AERADIO, (Canadian) a Canadian radio service for pilots [n]\n",
  "AERATE": "to put air into [v AERATED, AERATING, AERATES]\n",
  "AERATED": "AERATE, to put air into [v]\n",
  "AERATES": "AERATE, to put air into [v]\n",
  "AERATING": "AERATE, to put air into [v]\n",
  "AERATION": "exposure to the action of air [n -S]\n",
  "AERATIONS": "AERATION, exposure to the action of air [n]\n",
  "AERATOR": "that which supplies with air; esp. an apparatus used for charging mineral waters with gas and in making soda water [n -S]\n",
  "AERATORS": "AERATOR, that which supplies with air; esp. an apparatus used for charging mineral waters with gas and in making soda water [n]\n",
  "AERENCHYMA": "respiratory tissue [n -S]\n",
  "AERENCHYMAS": "AERENCHYMA, respiratory tissue [n]\n",
  "AERENCHYMATOUS": "relating to aerenchyma, respiratory tissue [adj]\n",
  "AERIAL": "pertaining to the air [adj AERIALLY] / an antenna [n -S]\n",
  "AERIALIST": "one who performs on the high wire or trapeze [n -S]\n",
  "AERIALISTS": "AERIALIST, one who performs on the high wire or trapeze [n]\n",
  "AERIALITIES": "AERIALITY, the state of being aerial; insubstantiality [n]\n",
  "AERIALITY": "the state of being aerial; insubstantiality [n AERIALITIES]\n",
  "AERIALLY": "pertaining to the air [adv]\n",
  "AERIALS": "AERIAL, an antenna [n]\n",
  "AERIE": "the nest of a bird of prey, also EYRIE, EYRY [n -S]\n",
  "AERIED": "having aeries, e.g. of a crag [adj]\n",
  "AERIER": "AERY, airy [adj]\n",
  "AERIES": "AERIE, the nest of a bird of prey, also EYRIE, EYRY [n]\n",
  "AERIEST": "AERY, airy [adj]\n",
  "AERIFICATION": "the process of changing into a gas [n -S]\n",
  "AERIFICATIONS": "AERIFICATION, the process of changing into a gas [n]\n",
  "AERIFIED": "AERIFY, to infuse air into; to combine air with [v]\n",
  "AERIFIES": "AERIFY, to infuse air into; to combine air with [v]\n",
  "AERIFORM": "having the form of air [adj]\n",
  "AERIFY": "to infuse air into; to combine air with [v AERIFIED, AERIFYING, AERIFIES]\n",
  "AERIFYING": "AERIFY, to infuse air into; to combine air with [v]\n",
  "AERILY": "AERY, airy [adv]\n",
  "AERO": "(relating to) aircraft or aeronautics [n -S]\n",
  "AEROACOUSTICS": "the study of the generation and transmittance of sound by fluid flow [n]\n",
  "AEROBALLISTICS": "the ballistics of projectiles dropped, launched, or fired from aircraft [n]\n",
  "AEROBAT": "one who performs feats in an aircraft [n -S]\n",
  "AEROBATIC": "relating to the art of performing stunts in the air [adj]\n",
  "AEROBATICS": "spectacular flying feats and maneuvers (as rolls and dives) [n]\n",
  "AEROBATS": "AEROBAT, one who performs feats in an aircraft [n]\n",
  "AEROBE": "an organism that requires free oxygen, also AEROBIUM [n -S]\n",
  "AEROBES": "AEROBE, an organism that requires free oxygen, also AEROBIUM [n]\n",
  "AEROBIA": "AEROBIUM, (Latin) an organism that requires free oxygen, also AEROBE [n]\n",
  "AEROBIC": "requiring free oxygen [adj AEROBICALLY]\n",
  "AEROBICALLY": "AEROBIC, requiring free oxygen [adv]\n",
  "AEROBICISE": "to make aerobic, also AEROBICIZE [v AEROBICISED, AEROBICISING, AEROBICISES]\n",
  "AEROBICISED": "AEROBICISE, to make aerobic, also AEROBICIZE [v]\n",
  "AEROBICISES": "AEROBICISE, to make aerobic, also AEROBICIZE [v]\n",
  "AEROBICISING": "AEROBICISE, to make aerobic, also AEROBICIZE [v]\n",
  "AEROBICIST": "one who practises aerobics [n -S]\n",
  "AEROBICISTS": "AEROBICIST, one who practises aerobics [n]\n",
  "AEROBICIZE": "to make aerobic, also AEROBICISE [v AEROBICIZED, AEROBICIZING, AEROBICIZES]\n",
  "AEROBICIZED": "AEROBICIZE, to make aerobic, also AEROBICISE [v]\n",
  "AEROBICIZES": "AEROBICIZE, to make aerobic, also AEROBICISE [v]\n",
  "AEROBICIZING": "AEROBICIZE, to make aerobic, also AEROBICISE [v]\n",
  "AEROBICS": "exercise for conditioning the heart and lungs [n]\n",
  "AEROBIOLOGICAL": "related to aerobiology, the study of airborne organisms [adj]\n",
  "AEROBIOLOGIES": "AEROBIOLOGY, the study of airborne organisms [n]\n",
  "AEROBIOLOGIST": "one who studies airborne microorganisms [n -S]\n",
  "AEROBIOLOGISTS": "AEROBIOLOGIST, one who studies airborne microorganisms [n]\n",
  "AEROBIOLOGY": "the study of airborne organisms [n AEROBIOLOGIES]\n",
  "AEROBIONT": "an aerobe, an organism requiring oxygen to survive [n -S]\n",
  "AEROBIONTS": "AEROBIONT, an aerobe, an organism requiring oxygen to survive [n]\n",
  "AEROBIOSES": "AEROBIOSIS, life in the presence of oxygen [n]\n",
  "AEROBIOSIS": "life in the presence of oxygen [n AEROBIOSES]\n",
  "AEROBIOTIC": "related to, or of the nature of, aerobes; as, aerobiotic plants, which live only when supplied with free oxygen [adj AEROBIOTICALLY]\n",
  "AEROBIOTICALLY": "AEROBIOTIC, related to, or of the nature of, aerobes; as, aerobiotic plants, which live only when supplied with free oxygen [adv]\n",
  "AEROBIUM": "(Latin) an organism that requires free oxygen, also AEROBE [n AEROBIA]\n",
  "AEROBOMB": "a bomb for dropping from aircraft [n -S]\n",
  "AEROBOMBS": "AEROBOMB, a bomb for dropping from aircraft [n]\n",
  "AEROBOT": "an unmanned gas-filled craft used to conduct experiments in planetary atmospheres [n -S]\n",
  "AEROBOTS": "AEROBOT, an unmanned gas-filled craft used to conduct experiments in planetary atmospheres [n]\n",
  "AEROBRAKE": "to use a planet's atmosphere to reduce the speed of a spacecraft [v AEROBRAKED, AEROBRAKING, AEROBRAKES]\n",
  "AEROBRAKED": "AEROBRAKE, to use a planet's atmosphere to reduce the speed of a spacecraft [v]\n",
  "AEROBRAKES": "AEROBRAKE, to use a planet's atmosphere to reduce the speed of a spacecraft [v]\n",
  "AEROBRAKING": "using a planet's atmosphere to reduce the speed of a spacecraft [n -S]\n",
  "AEROBRAKINGS": "AEROBRAKING, using a planet's atmosphere to reduce the speed of a spacecraft [n]\n",
  "AEROBUS": "a type of monorail that is suspended by an overhead cable [n AEROBUSES or AEROBUSSES]\n",
  "AEROBUSES": "AEROBUS, a type of monorail that is suspended by an overhead cable [n]\n",
  "AEROBUSSES": "AEROBUS, a type of monorail that is suspended by an overhead cable [n]\n",
  "AERODART": "an arrow-headed missile of steel dropped by an aircraft [n -S]\n",
  "AERODARTS": "AERODART, an arrow-headed missile of steel dropped by an aircraft [n]\n",
  "AERODIGESTIVE": "of or relating to the organs and tissues of the respiratory tract and the upper part of the digestive tract [adj]\n",
  "AERODONETICS": "the study of soaring or gliding flight, esp. the study of gliders [n]\n",
  "AERODROME": "a place for aircraft [n -S]\n",
  "AERODROMES": "AERODROME, a place for aircraft [n]\n",
  "AERODUCT": "a type of jet engine [n -S]\n",
  "AERODUCTS": "AERODUCT, a type of jet engine [n]\n",
  "AERODYNAMIC": "relating to aerodynamics, also AERODYNAMICAL [adj AERODYNAMICALLY]\n",
  "AERODYNAMICAL": "relating to aerodynamics, also AERODYNAMIC [adj AERODYNAMICALLY]\n",
  "AERODYNAMICALLY": "AERODYNAMICAL, relating to aerodynamics, also AERODYNAMIC [adv]\n",
  "AERODYNAMICIST": "one who specializes in aerodynamics [n -S]\n",
  "AERODYNAMICISTS": "AERODYNAMICIST, one who specializes in aerodynamics [n]\n",
  "AERODYNAMICS": "the study of forces acting on bodies in motion relative to gaseous fluids [n]\n",
  "AERODYNE": "a heavier-than-air aircraft (as an airplane, helicopter, or glider), as opposed to aerostat [n -S]\n",
  "AERODYNES": "AERODYNE, a heavier-than-air aircraft (as an airplane, helicopter, or glider), as opposed to aerostat [n]\n",
  "AEROELASTIC": "able to be deformed by aerodynamic forces [adj]\n",
  "AEROELASTICIAN": "a person who studies flutter and vibration in high-speed aircraft [n -S]\n",
  "AEROELASTICIANS": "AEROELASTICIAN, a person who studies flutter and vibration in high-speed aircraft [n]\n",
  "AEROELASTICITY": "distortion in a structure caused by aerodynamic forces [n]\n",
  "AEROEMBOLISM": "sickness caused by exposure to rapidly lowered air pressure [n -S]\n",
  "AEROEMBOLISMS": "AEROEMBOLISM, sickness caused by exposure to rapidly lowered air pressure [n]\n",
  "AEROFOIL": "a structure which gives rise to a lift force when moving through the air, e.g. a wing of an aircraft, also AIRFOIL [n -S]\n",
  "AEROFOILS": "AEROFOIL, a structure which gives rise to a lift force when moving through the air, e.g. a wing of an aircraft, also AIRFOIL [n]\n",
  "AEROGEL": "a highly porous solid [n -S]\n",
  "AEROGELS": "AEROGEL, a highly porous solid [n]\n",
  "AEROGENERATOR": "a generator driven by wind [n -S]\n",
  "AEROGENERATORS": "AEROGENERATOR, a generator driven by wind [n]\n",
  "AEROGRAM": "an airmail letter, also AEROGRAMME [n -S]\n",
  "AEROGRAMME": "an airmail letter, also AEROGRAM [n -S]\n",
  "AEROGRAMMES": "AEROGRAMME, an airmail letter, also AEROGRAM [n]\n",
  "AEROGRAMS": "AEROGRAM, an airmail letter, also AEROGRAMME [n]\n",
  "AEROGRAPH": "an airborne meteorological recording instrument [n -S]\n",
  "AEROGRAPHIES": "AEROGRAPHY, a description of the air or atmosphere; aerology [n]\n",
  "AEROGRAPHS": "AEROGRAPH, an airborne meteorological recording instrument [n]\n",
  "AEROGRAPHY": "a description of the air or atmosphere; aerology [n AEROGRAPHIES]\n",
  "AEROHYDROPLANE": "a winged hydroplane or flying-boat [n -S]\n",
  "AEROHYDROPLANES": "AEROHYDROPLANE, a winged hydroplane or flying-boat [n]\n",
  "AEROLITE": "a meteorite [n -S]\n",
  "AEROLITES": "AEROLITE, a meteorite [n]\n",
  "AEROLITH": "a meteorite [n -S]\n",
  "AEROLITHOLOGIES": "AEROLITHOLOGY, the study of aerolites [n]\n",
  "AEROLITHOLOGY": "the study of aerolites [n AEROLITHOLOGIES]\n",
  "AEROLITHS": "AEROLITH, a meteorite [n]\n",
  "AEROLITIC": "of or pertaining to aerolites; meteoric; as, aerolitic iron [adj]\n",
  "AEROLOGIC": "relating to aerology, the study of the atmosphere [adj]\n",
  "AEROLOGICAL": "relating to aerology, the study of the atmosphere [adj]\n",
  "AEROLOGIES": "AEROLOGY, the study of the atmosphere [n]\n",
  "AEROLOGIST": "one versed in aerology [n -S]\n",
  "AEROLOGISTS": "AEROLOGIST, one versed in aerology [n]\n",
  "AEROLOGY": "the study of the atmosphere [n AEROLOGIES]\n",
  "AEROMAGNETIC": "relating to study of the earth's magnetic field esp. from the air [adj]\n",
  "AEROMANCIES": "AEROMANCY, divination by means of the weather [n]\n",
  "AEROMANCY": "divination by means of the weather [n AEROMANCIES]\n",
  "AEROMECHANIC": "an aircraft mechanic [n -S]\n",
  "AEROMECHANICAL": "relating to aeromechanics [adj]\n",
  "AEROMECHANICS": "the science of the mechanical properties of gases [n]\n",
  "AEROMEDICAL": "of or relating to aeromedicine [adj]\n",
  "AEROMEDICINE": "a branch of medicine that deals with the diseases arising from flying [n -S]\n",
  "AEROMEDICINES": "AEROMEDICINE, a branch of medicine that deals with the diseases arising from flying [n]\n",
  "AEROMETER": "an instrument for measuring the weight or density of gas [n -S]\n",
  "AEROMETERS": "AEROMETER, an instrument for measuring the weight or density of gas [n]\n",
  "AEROMETRIC": "of or pertaining to aerometry; as, aerometric investigations [adj]\n",
  "AEROMETRIES": "AEROMETRY, the measurement of the weight or density of gases [n]\n",
  "AEROMETRY": "the measurement of the weight or density of gases [n AEROMETRIES]\n",
  "AEROMODELLING": "the making and flying of model planes [n -S]\n",
  "AEROMODELLINGS": "AEROMODELLING, the making and flying of model planes [n]\n",
  "AEROMOTOR": "an engine for aircraft [n -S]\n",
  "AEROMOTORS": "AEROMOTOR, an engine for aircraft [n]\n",
  "AERONAUT": "a traveller through the air; a balloonist, a pilot [n -S]\n",
  "AERONAUTIC": "relating to aeronautics [adj AERONAUTICALLY]\n",
  "AERONAUTICAL": "relating to aeronautics [adj AERONAUTICALLY]\n",
  "AERONAUTICALLY": "AERONAUTICAL, relating to aeronautics [adv]\n",
  "AERONAUTICS": "a science dealing with the operation of aircraft [n]\n",
  "AERONAUTS": "AERONAUT, a traveller through the air; a balloonist, a pilot [n]\n",
  "AERONEUROSES": "AERONEUROSIS, flight fatigue, a nervous disorder of airmen, with emotional and physical symptoms [n]\n",
  "AERONEUROSIS": "flight fatigue, a nervous disorder of airmen, with emotional and physical symptoms [n AERONEUROSES]\n",
  "AERONOMER": "one who studies the earth's atmosphere, also AERONOMIST [n -S]\n",
  "AERONOMERS": "AERONOMER, one who studies the earth's atmosphere, also AERONOMIST [n]\n",
  "AERONOMIC": "relating to aeronomy, the study of chemical and physical phenomena in the upper atmosphere [adj]\n",
  "AERONOMICAL": "relating to aeronomy, the study of chemical and physical phenomena in the upper atmosphere [adj]\n",
  "AERONOMIES": "AERONOMY, the study of the upper atmosphere [n]\n",
  "AERONOMIST": "one who studies aeronomy, the science of the earth's atmosphere, also AERONOMER [n -S]\n",
  "AERONOMISTS": "AERONOMIST, one who studies aeronomy, the science of the earth's atmosphere, also AERONOMER [n]\n",
  "AERONOMY": "the study of the upper atmosphere [n AERONOMIES]\n",
  "AEROPAUSE": "the region of the earth's atmosphere above which aircraft cannot fly [n -S]\n",
  "AEROPAUSES": "AEROPAUSE, the region of the earth's atmosphere above which aircraft cannot fly [n]\n",
  "AEROPHAGIA": "spasmodic swallowing of air, a fairly common neurotic habit that may lead to belching and stomach pain [n -S]\n",
  "AEROPHAGIAS": "AEROPHAGIA, spasmodic swallowing of air, a fairly common neurotic habit that may lead to belching and stomach pain [n]\n",
  "AEROPHAGIES": "AEROPHAGY, spasmodic swallowing of air [n]\n",
  "AEROPHAGY": "spasmodic swallowing of air [n AEROPHAGIES]\n",
  "AEROPHOBE": "a person with a fear of flying [n -S]\n",
  "AEROPHOBES": "AEROPHOBE, a person with a fear of flying [n]\n",
  "AEROPHOBIA": "fear of flying or draughts [n -S]\n",
  "AEROPHOBIAS": "AEROPHOBIA, fear of flying or draughts [n]\n",
  "AEROPHOBIC": "having a morbid fear of draughts or of flying [adj]\n",
  "AEROPHONE": "any wind instrument [n -S]\n",
  "AEROPHONES": "AEROPHONE, any wind instrument [n]\n",
  "AEROPHORE": "a device for playing a wind instrument [n -S]\n",
  "AEROPHORES": "AEROPHORE, a device for playing a wind instrument [n]\n",
  "AEROPHYTE": "a plant obtaining all its nourishment from the air; an epiphyte [n -S]\n",
  "AEROPHYTES": "AEROPHYTE, a plant obtaining all its nourishment from the air; an epiphyte [n]\n",
  "AEROPLANE": "a flying machine [n -S]\n",
  "AEROPLANES": "AEROPLANE, a flying machine [n]\n",
  "AEROPLANKTON": "minute organisms carried in the air [n -S]\n",
  "AEROPLANKTONS": "AEROPLANKTON, minute organisms carried in the air [n]\n",
  "AEROPULSE": "a type of jet engine [n -S]\n",
  "AEROPULSES": "AEROPULSE, a type of jet engine [n]\n",
  "AEROS": "AERO, (relating to) aircraft or aeronautics [n]\n",
  "AEROSAT": "a satellite for air-traffic control [n -S]\n",
  "AEROSATS": "AEROSAT, a satellite for air-traffic control [n]\n",
  "AEROSCOPE": "a device for observing the atmosphere [n -S]\n",
  "AEROSCOPES": "AEROSCOPE, a device for observing the atmosphere [n]\n",
  "AEROSHELL": "a form of parachute to enable a space vehicle to make a soft landing [n -S]\n",
  "AEROSHELLS": "AEROSHELL, a form of parachute to enable a space vehicle to make a soft landing [n]\n",
  "AEROSIDERITE": "an iron meteorite [n -S]\n",
  "AEROSIDERITES": "AEROSIDERITE, an iron meteorite [n]\n",
  "AEROSOL": "a spray released under pressure [n -S]\n",
  "AEROSOLISATION": "the process of making into an aerosol, also AEROSOLIZATION [n -S]\n",
  "AEROSOLISATIONS": "AEROSOLISATION, the process of making into an aerosol, also AEROSOLIZATION [n]\n",
  "AEROSOLISE": "to turn into an aerosol, also AEROSOLIZE [v AEROSOLISED, AEROSOLISING, AEROSOLISES]\n",
  "AEROSOLISED": "AEROSOLISE, to turn into an aerosol, also AEROSOLIZE [v]\n",
  "AEROSOLISES": "AEROSOLISE, to turn into an aerosol, also AEROSOLIZE [v]\n",
  "AEROSOLISING": "AEROSOLISE, to turn into an aerosol, also AEROSOLIZE [v]\n",
  "AEROSOLIZATION": "the process of aerosolizing, also AEROSOLISATION [n -S]\n",
  "AEROSOLIZATIONS": "AEROSOLIZATION, the process of aerosolizing, also AEROSOLISATION [n]\n",
  "AEROSOLIZE": "to turn into an aerosol [v AEROSOLIZED, AEROSOLIZING, AEROSOLIZES]\n",
  "AEROSOLIZED": "AEROSOLIZE, to turn into an aerosol [v]\n",
  "AEROSOLIZES": "AEROSOLIZE, to turn into an aerosol [v]\n",
  "AEROSOLIZING": "AEROSOLIZE, to turn into an aerosol [v]\n",
  "AEROSOLS": "AEROSOL, a spray released under pressure [n]\n",
  "AEROSPACE": "the Earth's atmosphere and the space beyond it [n -S]\n",
  "AEROSPACES": "AEROSPACE, the Earth's atmosphere and the space beyond it [n]\n",
  "AEROSPHERE": "the entire atmosphere surrounding the earth [n -S]\n",
  "AEROSPHERES": "AEROSPHERE, the entire atmosphere surrounding the earth [n]\n",
  "AEROSPIKE": "a rocket engine with a specially designed nozzle that allows the exhaust gases to expand and so to be used most efficiently [n -S]\n",
  "AEROSPIKES": "AEROSPIKE, a rocket engine with a specially designed nozzle that allows the exhaust gases to expand and so to be used most efficiently [n]\n",
  "AEROSTAT": "any lighter-than-air craft e.g. a blimp or balloon, as opposed to an aerodyne [n -S]\n",
  "AEROSTATIC": "relating to aerostatics, also AEROSTATICAL [adj]\n",
  "AEROSTATICAL": "relating to aerostatics, also AEROSTATIC [adj]\n",
  "AEROSTATICS": "the science of gases in equilibrium [n]\n",
  "AEROSTATION": "ballooning [n -S]\n",
  "AEROSTATIONS": "AEROSTATION, ballooning [n]\n",
  "AEROSTATS": "AEROSTAT, any lighter-than-air craft e.g. a blimp or balloon, as opposed to an aerodyne [n]\n",
  "AEROSTRUCTURE": "any separately manufactured unit, component, or section of an aircraft or other vehicle capable of flight [n -S]\n",
  "AEROSTRUCTURES": "AEROSTRUCTURE, any separately manufactured unit, component, or section of an aircraft or other vehicle capable of flight [n]\n",
  "AEROTACTIC": "relating to or showing aerotaxis [adj]\n",
  "AEROTAXES": "AEROTAXIS, movement towards or from oxygen [n]\n",
  "AEROTAXIS": "movement towards or from oxygen [n AEROTAXES]\n",
  "AEROTONE": "a deep bath with massaging jets of compressed air [n -S]\n",
  "AEROTONES": "AEROTONE, a deep bath with massaging jets of compressed air [n]\n",
  "AEROTRAIN": "a train driven by an aircraft engine, riding on a cushion of air [n -S]\n",
  "AEROTRAINS": "AEROTRAIN, a train driven by an aircraft engine, riding on a cushion of air [n]\n",
  "AEROTROPIC": "showing aerotropism, curvature in response to concentration of oxygen [adj]\n",
  "AEROTROPISM": "curvature in response to concentration of oxygen [n -S]\n",
  "AEROTROPISMS": "AEROTROPISM, curvature in response to concentration of oxygen [n]\n",
  "AERUGINOUS": "relating to copper-rust or verdigris [adj]\n",
  "AERUGO": "(Latin) a green film that forms on copper, also ERUGO [n -S]\n",
  "AERUGOS": "AERUGO, (Latin) a green film that forms on copper, also ERUGO [n]\n",
  "AERY": "the nest of a bird of prey, also EYRIE, AERIE, AIERY, AYRIE [n AERIES] / airy [adj AERIER, AERIEST]\n",
  "AESC": "(Old English) an Old English rune used for AE [n -ES]\n",
  "AESCES": "AESC, (Old English) an Old English rune used for AE [n]\n",
  "AESCULIN": "a glucoside found in horse-chestnut bark [n -S]\n",
  "AESCULINS": "AESCULIN, a glucoside found in horse-chestnut bark [n]\n",
  "AESIR": "AS, a Norse god living in Asgard [n]\n",
  "AESTHESES": "AESTHESIS, the ability to receive sense impressions, also AESTHESIA, ESTHESIA, ESTHESIS [n]\n",
  "AESTHESIA": "the ability to receive sense impressions, also AESTHESIS, ESTHESIA, ESTHESIS [n -S]\n",
  "AESTHESIAS": "AESTHESIA, the ability to receive sense impressions, also AESTHESIS, ESTHESIA, ESTHESIS [n]\n",
  "AESTHESIOGEN": "something producing sensation, esp. a stimulus or suggestion producing a sensory effect on a subject under hypnosis, also ESTHESIOGEN [n -S]\n",
  "AESTHESIOGENIC": "producing or causing a sensation [adj]\n",
  "AESTHESIOGENS": "AESTHESIOGEN, something producing sensation, esp. a stimulus or suggestion producing a sensory effect on a subject under hypnosis, also ESTHESIOGEN [n]\n",
  "AESTHESIS": "the ability to receive sense impressions, also AESTHESIA, ESTHESIA, ESTHESIS [n AESTHESES]\n",
  "AESTHETE": "a person who affects an extravagant love of art [n -S]\n",
  "AESTHETES": "AESTHETE, a person who affects an extravagant love of art [n]\n",
  "AESTHETIC": "keenly appreciative of the beautiful, also AESTHETICAL, ESTHETIC, ESTHETICAL [adj AESTHETICALLY]\n",
  "AESTHETICAL": "keenly appreciative of the beautiful, also AESTHETIC, ESTHETIC, ESTHETICAL [adj AESTHETICALLY]\n",
  "AESTHETICALLY": "AESTHETICAL, keenly appreciative of the beautiful, also AESTHETIC, ESTHETIC, ESTHETICAL [adv]\n",
  "AESTHETICIAN": "a specialist in aesthetics, also ESTHETICIAN [n -S]\n",
  "AESTHETICIANS": "AESTHETICIAN, a specialist in aesthetics, also ESTHETICIAN [n]\n",
  "AESTHETICISE": "to make beautiful, also AESTHETICIZE [v AESTHETICISED, AESTHETICISING, AESTHETICISES]\n",
  "AESTHETICISED": "AESTHETICISE, to make beautiful, also AESTHETICIZE [v]\n",
  "AESTHETICISES": "AESTHETICISE, to make beautiful, also AESTHETICIZE [v]\n",
  "AESTHETICISING": "AESTHETICISE, to make beautiful, also AESTHETICIZE [v]\n",
  "AESTHETICISM": "the doctrine that beauty is central to other moral principles, also ESTHETICISM [n -S]\n",
  "AESTHETICISMS": "AESTHETICISM, the doctrine that beauty is central to other moral principles, also ESTHETICISM [n]\n",
  "AESTHETICIST": "an adherent of aestheticism [n -S]\n",
  "AESTHETICISTS": "AESTHETICIST, an adherent of aestheticism [n]\n",
  "AESTHETICIZE": "to make beautiful, also AESTHETICISE [v AESTHETICIZED, AESTHETICIZING, AESTHETICIZES]\n",
  "AESTHETICIZED": "AESTHETICIZE, to make beautiful, also AESTHETICISE [v]\n",
  "AESTHETICIZES": "AESTHETICIZE, to make beautiful, also AESTHETICISE [v]\n",
  "AESTHETICIZING": "AESTHETICIZE, to make beautiful, also AESTHETICISE [v]\n",
  "AESTHETICS": "the principles of taste and art; the philosophy of the fine arts, also ESTHETICS [n]\n",
  "AESTIVAL": "of summer [adj]\n",
  "AESTIVATE": "to pass the summer in a state of torpor, also ESTIVATE [v AESTIVATED, AESTIVATING, AESTIVATES]\n",
  "AESTIVATED": "AESTIVATE, to pass the summer in a state of torpor, also ESTIVATE [v]\n",
  "AESTIVATES": "AESTIVATE, to pass the summer in a state of torpor, also ESTIVATE [v]\n",
  "AESTIVATING": "AESTIVATE, to pass the summer in a state of torpor, also ESTIVATE [v]\n",
  "AESTIVATION": "the act of spending the summer in a state of torpor, also ESTIVATION [n -S]\n",
  "AESTIVATIONS": "AESTIVATION, the act of spending the summer in a state of torpor, also ESTIVATION [n]\n",
  "AESTIVATOR": "an animal that aestivates, also ESTIVATOR [n -S]\n",
  "AESTIVATORS": "AESTIVATOR, an animal that aestivates, also ESTIVATOR [n]\n",
  "AETATIS": "(Latin) at the age of [adj]\n",
  "AETHER": "the upper region of the atmosphere [n -S]\n",
  "AETHEREAL": "like a spirit, also ETHEREAL, ETHERIAL [adj]\n",
  "AETHEREALITIES": "AETHEREALITY, the state of being aethereal [n]\n",
  "AETHEREALITY": "the state of being aethereal [n AETHEREALITIES]\n",
  "AETHEREALLY": "AETHEREAL, like a spirit, also ETHEREAL, ETHERIAL [adv]\n",
  "AETHERIC": "pertaining to the aether [adj]\n",
  "AETHERS": "AETHER, the upper region of the atmosphere [n]\n",
  "AETHRIOSCOPE": "an instrument for measuring temperature variations due to sky conditions [n -S]\n",
  "AETHRIOSCOPES": "AETHRIOSCOPE, an instrument for measuring temperature variations due to sky conditions [n]\n",
  "AETIOLOGICAL": "relating to aetiology, the study of causes [adj AETIOLOGICALLY]\n",
  "AETIOLOGICALLY": "AETIOLOGICAL, relating to aetiology, the study of causes [adv]\n",
  "AETIOLOGIES": "AETIOLOGY, the science of causes, esp. of disease, also ETIOLOGY [n]\n",
  "AETIOLOGIST": "a student of aetiology, also ETIOLOGIST [n -S]\n",
  "AETIOLOGISTS": "AETIOLOGIST, a student of aetiology, also ETIOLOGIST [n]\n",
  "AETIOLOGY": "the science of causes, esp. of disease, also ETIOLOGY [n AETIOLOGIES]\n",
  "AFALD": "onefold, also AEFALD, AEFAULD, AFAWLD [adj]\n",
  "AFAR": "at a great distance [adv] / a great distance [n -S]\n",
  "AFARA": "(Yoruba) a type of West African tree having a light-coloured, straight-grained wood [n -S]\n",
  "AFARAS": "AFARA, (Yoruba) a type of West African tree having a light-coloured, straight-grained wood [n]\n",
  "AFARS": "AFAR, a great distance [n]\n",
  "AFAWLD": "onefold, also AEFALD, AEFAULD, AFALD [adj]\n",
  "AFEAR": "(Spenser) to frighten, also AFFEAR, AFFEARE [v AFEARED or AFEARD, AFEARING, AFEARS]\n",
  "AFEARD": "(Shakespeare) afraid, also AFFEARD, AFRAID, EFFRAIDE [adj]\n",
  "AFEARED": "AFEAR, (Spenser) to frighten, also AFFEAR, AFFEARE [v]\n",
  "AFEARING": "AFEAR, (Spenser) to frighten, also AFFEAR, AFFEARE [v]\n",
  "AFEARS": "AFEAR, (Spenser) to frighten, also AFFEAR, AFFEARE [v]\n",
  "AFEBRILE": "having no fever [adj]\n",
  "AFF": "(Scots) off [adv]\n",
  "AFFABILITIES": "AFFABILITY, the quality of being affable [n]\n",
  "AFFABILITY": "the quality of being affable [n AFFABILITIES]\n",
  "AFFABLE": "easy to speak to [adj AFFABLY]\n",
  "AFFABLY": "AFFABLE, easy to speak to [adv]\n",
  "AFFAIR": "something which is to be done [n -S]\n",
  "AFFAIRE": "(French) a brief amorous relationship [n -S]\n",
  "AFFAIRES": "AFFAIRE, (French) a brief amorous relationship [n]\n",
  "AFFAIRS": "AFFAIR, something which is to be done [n]\n",
  "AFFEAR": "(Spenser) to frighten, also AFEAR, AFFEARE [v -ED, -ING, -S]\n",
  "AFFEARD": "(Shakespeare) afraid, also AFEARD, AFRAID, EFFRAIDE [adj]\n",
  "AFFEARE": "(Spenser) to frighten, also AFEAR, AFFEAR [v AFFEARED, AFFEARING, AFFEARES]\n",
  "AFFEARED": "AFFEARE, (Spenser) to frighten, also AFEAR, AFFEAR [v]\n",
  "AFFEARES": "AFFEARE, (Spenser) to frighten, also AFEAR, AFFEAR [v]\n",
  "AFFEARING": "AFFEARE, (Spenser) to frighten, also AFEAR, AFFEAR [v]\n",
  "AFFEARS": "AFFEAR, (Spenser) to frighten, also AFEAR, AFFEARE [v]\n",
  "AFFECT": "to act upon [v -ED, -ING, -S]\n",
  "AFFECTABILITIES": "AFFECTABILITY, the quality of being affectable [n]\n",
  "AFFECTABILITY": "the quality of being affectable [n AFFECTABILITIES]\n",
  "AFFECTABLE": "that can be affected [adj]\n",
  "AFFECTATION": "the act of taking on an attitude not natural to oneself or not genuinely felt [n -S]\n",
  "AFFECTATIONS": "AFFECTATION, the act of taking on an attitude not natural to oneself or not genuinely felt [n]\n",
  "AFFECTED": "AFFECT, to act upon [v]\n",
  "AFFECTEDLY": "AFFECTED, AFFECT, to act upon [adv]\n",
  "AFFECTEDNESS": "the quality of being false or artificial [n -ES]\n",
  "AFFECTEDNESSES": "AFFECTEDNESS, the quality of being false or artificial [n]\n",
  "AFFECTER": "one who affects, assumes [n -S]\n",
  "AFFECTERS": "AFFECTER, one who affects, assumes [n]\n",
  "AFFECTING": "AFFECT, to act upon [v]\n",
  "AFFECTINGLY": "AFFECTING, AFFECT, to act upon [adv]\n",
  "AFFECTION": "a fond feeling [n] / to love [v -ED, -ING, -S]\n",
  "AFFECTIONAL": "relating to affection [adj AFFECTIONALLY]\n",
  "AFFECTIONALLY": "AFFECTIONAL, relating to affection [adv]\n",
  "AFFECTIONATE": "having affection or warm regard [adj AFFECTIONATELY]\n",
  "AFFECTIONATELY": "AFFECTIONATE, having affection or warm regard [adv]\n",
  "AFFECTIONED": "AFFECTION, to love [v]\n",
  "AFFECTIONING": "AFFECTION, to love [v]\n",
  "AFFECTIONLESS": "without affection [adj]\n",
  "AFFECTIONS": "AFFECTION, to love [v]\n",
  "AFFECTIVE": "of, arising from or influencing emotion [adj AFFECTIVELY]\n",
  "AFFECTIVELY": "AFFECTIVE, of, arising from or influencing emotion [adv]\n",
  "AFFECTIVENESS": "the state of being affective [n -ES]\n",
  "AFFECTIVENESSES": "AFFECTIVENESS, the state of being affective [n]\n",
  "AFFECTIVITIES": "AFFECTIVITY, the quality of being affective [n]\n",
  "AFFECTIVITY": "the quality of being affective [n AFFECTIVITIES]\n",
  "AFFECTLESS": "without affect [adj]\n",
  "AFFECTLESSNESS": "the state of being affectless, without affect [n]\n",
  "AFFECTS": "AFFECT, to act upon [v]\n",
  "AFFEER": "(archaic) to assess; to reduce to a certain fixed sum [v -ED, -ING, -S]\n",
  "AFFEERED": "AFFEER, (archaic) to assess; to reduce to a certain fixed sum [v]\n",
  "AFFEERING": "AFFEER, (archaic) to assess; to reduce to a certain fixed sum [v]\n",
  "AFFEERMENT": "the act of affeering [n -S]\n",
  "AFFEERMENTS": "AFFEERMENT, the act of affeering [n]\n",
  "AFFEERS": "AFFEER, (archaic) to assess; to reduce to a certain fixed sum [v]\n",
  "AFFENPINSCHER": "(German) a kind of dark, wiry, shaggy dog with a tufted muzzle [n -S]\n",
  "AFFENPINSCHERS": "AFFENPINSCHER, (German) a kind of dark, wiry, shaggy dog with a tufted muzzle [n]\n",
  "AFFERENT": "bearing, bringing or carrying towards [adj AFFERENTLY] / something that carries towards [n -S]\n",
  "AFFERENTLY": "AFFERENT, bearing, bringing or carrying towards [adv]\n",
  "AFFERENTS": "AFFERENT, something that carries towards [n]\n",
  "AFFETTUOSO": "(Italian) a musical direction to perform a passage with feeling [adv]\n",
  "AFFIANCE": "to betroth [v AFFIANCED, AFFIANCING, AFFIANCES]\n",
  "AFFIANCED": "AFFIANCE, to betroth [v]\n",
  "AFFIANCES": "AFFIANCE, to betroth [v]\n",
  "AFFIANCING": "AFFIANCE, to betroth [v]\n",
  "AFFIANT": "one who makes a written declaration under oath [n -S]\n",
  "AFFIANTS": "AFFIANT, one who makes a written declaration under oath [n]\n",
  "AFFICHE": "(French) a poster; a placard [n -S]\n",
  "AFFICHES": "AFFICHE, (French) a poster; a placard [n]\n",
  "AFFICIONADO": "(Spanish) a devotee, admirer, an enthusiastic fan, also AFICIONADO [n -S]\n",
  "AFFICIONADOS": "AFFICIONADO, (Spanish) a devotee, admirer, an enthusiastic fan, also AFICIONADO [n]\n",
  "AFFIDAVIT": "(Latin) a written statement, confirmed by oath, to be used as evidence [n -S]\n",
  "AFFIDAVITS": "AFFIDAVIT, (Latin) a written statement, confirmed by oath, to be used as evidence [n]\n",
  "AFFIED": "AFFY, (obsolete) to trust; to assure on one's faith [v]\n",
  "AFFIES": "AFFY, (obsolete) to trust; to assure on one's faith [v]\n",
  "AFFILIABLE": "capable of being affiliated to or on, or connected with in origin [adj]\n",
  "AFFILIATE": "to adopt or attach as a member or branch [v AFFILIATED, AFFILIATING, AFFILIATES]\n",
  "AFFILIATED": "AFFILIATE, to adopt or attach as a member or branch [v]\n",
  "AFFILIATES": "AFFILIATE, to adopt or attach as a member or branch [v]\n",
  "AFFILIATING": "AFFILIATE, to adopt or attach as a member or branch [v]\n",
  "AFFILIATION": "the result of affiliating [n -S]\n",
  "AFFILIATIONS": "AFFILIATION, the result of affiliating [n]\n",
  "AFFINAL": "related by marriage [adj]\n",
  "AFFINE": "related by marriage [adj AFFINELY] / a relation by marriage [n -S]\n",
  "AFFINED": "related [adj]\n",
  "AFFINELY": "in the manner of a type of mathematical mapping [adv]\n",
  "AFFINES": "AFFINE, a relation by marriage [n]\n",
  "AFFINITIES": "AFFINITY, a natural attraction or inclination [n]\n",
  "AFFINITIVE": "closely connected, as by affinity [adj]\n",
  "AFFINITY": "a natural attraction or inclination [n AFFINITIES]\n",
  "AFFIRM": "to state positively [v -ED, -ING, -S]\n",
  "AFFIRMABLE": "that can be affirmed [adj]\n",
  "AFFIRMANCE": "confirmation; ratification [n -S]\n",
  "AFFIRMANCES": "AFFIRMANCE, confirmation; ratification [n]\n",
  "AFFIRMANT": "one who affirms or asserts [n -S]\n",
  "AFFIRMANTS": "AFFIRMANT, one who affirms or asserts [n]\n",
  "AFFIRMATION": "the act of affirming [n -S]\n",
  "AFFIRMATIONS": "AFFIRMATION, the act of affirming [n]\n",
  "AFFIRMATIVE": "affirming [adj AFFIRMATIVELY] / an expression of affirmation or assent [n -S]\n",
  "AFFIRMATIVELY": "AFFIRMATIVE, affirming [adv]\n",
  "AFFIRMATIVES": "AFFIRMATIVE, an expression of affirmation or assent [n]\n",
  "AFFIRMATORY": "expressing affirmation [adj]\n",
  "AFFIRMED": "AFFIRM, to state positively [v]\n",
  "AFFIRMER": "one who affirms [n -S]\n",
  "AFFIRMERS": "AFFIRMER, one who affirms [n]\n",
  "AFFIRMING": "AFFIRM, to state positively [v]\n",
  "AFFIRMINGLY": "AFFIRMING, AFFIRM, to state positively [adv]\n",
  "AFFIRMS": "AFFIRM, to state positively [v]\n",
  "AFFIX": "to fix on to, append [v -ED, -ING, -ES]\n",
  "AFFIXABLE": "able to be affixed [adj]\n",
  "AFFIXAL": "pertaining to a prefix or suffix, also AFFIXIAL [adj]\n",
  "AFFIXATION": "the act of affixing [n -S]\n",
  "AFFIXATIONS": "AFFIXATION, the act of affixing [n]\n",
  "AFFIXED": "AFFIX, to fix on to, append [v]\n",
  "AFFIXER": "one who affixes [n -S]\n",
  "AFFIXERS": "AFFIXER, one who affixes [n]\n",
  "AFFIXES": "AFFIX, to fix on to, append [v]\n",
  "AFFIXIAL": "pertaining to a prefix or suffix, also AFFIXAL [adj]\n",
  "AFFIXING": "AFFIX, to fix on to, append [v]\n",
  "AFFIXMENT": "something affixed, also AFFIXTURE [n -S]\n",
  "AFFIXMENTS": "AFFIXMENT, something affixed, also AFFIXTURE [n]\n",
  "AFFIXTURE": "something affixed, also AFFIXMENT [n -S]\n",
  "AFFIXTURES": "AFFIXTURE, something affixed, also AFFIXMENT [n]\n",
  "AFFLATED": "inspired [adj]\n",
  "AFFLATION": "the act of breathing upon; inspiration [n -S]\n",
  "AFFLATIONS": "AFFLATION, the act of breathing upon; inspiration [n]\n",
  "AFFLATUS": "(Latin) inspiration, a divine imparting of knowledge or power [n -ES]\n",
  "AFFLATUSES": "AFFLATUS, (Latin) inspiration, a divine imparting of knowledge or power [n]\n",
  "AFFLICT": "to distress severely [v -ED, -ING, -S]\n",
  "AFFLICTED": "AFFLICT, to distress severely [v]\n",
  "AFFLICTER": "one who afflicts [n -S]\n",
  "AFFLICTERS": "AFFLICTER, one who afflicts [n]\n",
  "AFFLICTING": "the act of distressing [n -S]\n",
  "AFFLICTINGS": "AFFLICTING, the act of distressing [n]\n",
  "AFFLICTION": "the state of being afflicted [n -S]\n",
  "AFFLICTIONS": "AFFLICTION, the state of being afflicted [n]\n",
  "AFFLICTIVE": "causing distress [adj AFFLICTIVELY]\n",
  "AFFLICTIVELY": "AFFLICTIVE, causing distress [adv]\n",
  "AFFLICTS": "AFFLICT, to distress severely [v]\n",
  "AFFLUENCE": "the state of being affluent, also AFFLUENCY [n -S]\n",
  "AFFLUENCES": "AFFLUENCE, the state of being affluent, also AFFLUENCY [n]\n",
  "AFFLUENCIES": "AFFLUENCY, the state of being affluent, also AFFLUENCE [n]\n",
  "AFFLUENCY": "the state of being affluent, also AFFLUENCE [n AFFLUENCIES]\n",
  "AFFLUENT": "wealthy [adj AFFLUENTLY] / a stream that flows into another [n -S]\n",
  "AFFLUENTIAL": "an affluent person who does not display his or her wealth in the form of material possessions [n -S]\n",
  "AFFLUENTIALS": "AFFLUENTIAL, an affluent person who does not display his or her wealth in the form of material possessions [n]\n",
  "AFFLUENTLY": "AFFLUENT, wealthy [adv]\n",
  "AFFLUENTNESS": "the state of being affluent [n -ES]\n",
  "AFFLUENTNESSES": "AFFLUENTNESS, the state of being affluent [n]\n",
  "AFFLUENTS": "AFFLUENT, a stream that flows into another [n]\n",
  "AFFLUENZA": "a malaise said to affect affluent young people, characterised by guilt feelings [n -S]\n",
  "AFFLUENZAS": "AFFLUENZA, a malaise said to affect affluent young people, characterised by guilt feelings [n]\n",
  "AFFLUX": "a flowing towards or together, also AFFLUXION [n -ES]\n",
  "AFFLUXES": "AFFLUX, a flowing towards or together, also AFFLUXION [n]\n",
  "AFFLUXION": "a flowing towards or together, also AFFLUX [n -S]\n",
  "AFFLUXIONS": "AFFLUXION, a flowing towards or together, also AFFLUX [n]\n",
  "AFFOGATO": "(Italian) a dessert made by pouring espresso coffee over ice cream [n -S]\n",
  "AFFOGATOS": "AFFOGATO, (Italian) a dessert made by pouring espresso coffee over ice cream [n]\n",
  "AFFOORD": "(Spenser) to afford [v -ED, -ING, -S]\n",
  "AFFOORDED": "AFFOORD, (Spenser) to afford [v]\n",
  "AFFOORDING": "AFFOORD, (Spenser) to afford [v]\n",
  "AFFOORDS": "AFFOORD, (Spenser) to afford [v]\n",
  "AFFORCE": "to strengthen a jury by adding skilled people [v AFFORCED, AFFORCING, AFFORCES]\n",
  "AFFORCED": "AFFORCE, to strengthen a jury by adding skilled people [v]\n",
  "AFFORCEMENT": "the act of afforcing, strengthening a jury by adding skilled people [n -S]\n",
  "AFFORCEMENTS": "AFFORCEMENT, the act of afforcing, strengthening a jury by adding skilled people [n]\n",
  "AFFORCES": "AFFORCE, to strengthen a jury by adding skilled people [v]\n",
  "AFFORCING": "AFFORCE, to strengthen a jury by adding skilled people [v]\n",
  "AFFORD": "to have sufficient means for [v -ED, -ING, -S]\n",
  "AFFORDABILITIES": "AFFORDABILITY, the quality of being affordable [n]\n",
  "AFFORDABILITY": "the quality of being affordable [n AFFORDABILITIES]\n",
  "AFFORDABLE": "that can be afforded [adj AFFORDABLY]\n",
  "AFFORDABLY": "AFFORDABLE, that can be afforded [adv]\n",
  "AFFORDED": "AFFORD, to have sufficient means for [v]\n",
  "AFFORDING": "AFFORD, to have sufficient means for [v]\n",
  "AFFORDS": "AFFORD, to have sufficient means for [v]\n",
  "AFFOREST": "to cover with forest [v -ED, -ING, -S]\n",
  "AFFORESTABLE": "that can be afforested [adj]\n",
  "AFFORESTATION": "the process of establishing a forest esp. on land not previously forested [n -S]\n",
  "AFFORESTATIONS": "AFFORESTATION, the process of establishing a forest esp. on land not previously forested [n]\n",
  "AFFORESTED": "AFFOREST, to cover with forest [v]\n",
  "AFFORESTING": "AFFOREST, to cover with forest [v]\n",
  "AFFORESTS": "AFFOREST, to cover with forest [v]\n",
  "AFFRANCHISE": "to free from slavery or similar obligation [v AFFRANCHISED, AFFRANCHISING, AFFRANCHISES]\n",
  "AFFRANCHISED": "AFFRANCHISE, to free from slavery or similar obligation [v]\n",
  "AFFRANCHISEMENT": "the act of affranchising [n]\n",
  "AFFRANCHISES": "AFFRANCHISE, to free from slavery or similar obligation [v]\n",
  "AFFRANCHISING": "AFFRANCHISE, to free from slavery or similar obligation [v]\n",
  "AFFRAP": "(Spenser) to strike [v AFFRAPPED, AFFRAPPING, AFFRAPS]\n",
  "AFFRAPPED": "AFFRAP, (Spenser) to strike [v]\n",
  "AFFRAPPING": "AFFRAP, (Spenser) to strike [v]\n",
  "AFFRAPS": "AFFRAP, (Spenser) to strike [v]\n",
  "AFFRAY": "to disturb or frighten [v -ED, -ING, -S]\n",
  "AFFRAYED": "AFFRAY, to disturb or frighten [v]\n",
  "AFFRAYER": "a disturber of the peace [n -S]\n",
  "AFFRAYERS": "AFFRAYER, a disturber of the peace [n]\n",
  "AFFRAYING": "AFFRAY, to disturb or frighten [v]\n",
  "AFFRAYS": "AFFRAY, to disturb or frighten [v]\n",
  "AFFREIGHTMENT": "hiring of a vessel [n -S]\n",
  "AFFREIGHTMENTS": "AFFREIGHTMENT, hiring of a vessel [n]\n",
  "AFFRENDED": "(Spenser) reconciled [adj]\n",
  "AFFRET": "(Spenser) a furious onset [n -S]\n",
  "AFFRETS": "AFFRET, (Spenser) a furious onset [n]\n",
  "AFFRICATE": "a consonant that begins as a plosive and ends as a fricative [n -S] / to sound a consonant in this way [v AFFRICATED, AFFRICATING, AFFRICATES]\n",
  "AFFRICATED": "AFFRICATE, to sound a consonant in this way [v]\n",
  "AFFRICATES": "AFFRICATE, a consonant that begins as a plosive and ends as a fricative [n]\n",
  "AFFRICATING": "AFFRICATE, to sound a consonant in this way [v]\n",
  "AFFRICATION": "the act of making a sound affricative [n -S]\n",
  "AFFRICATIONS": "AFFRICATION, the act of making a sound affricative [n]\n",
  "AFFRICATIVE": "a sound like an affricate [n -S]\n",
  "AFFRICATIVES": "AFFRICATIVE, a sound like an affricate [n]\n",
  "AFFRIGHT": "to frighten [v -ED, -ING, -S]\n",
  "AFFRIGHTED": "AFFRIGHT, to frighten [v]\n",
  "AFFRIGHTEDLY": "AFFRIGHTED, AFFRIGHT, to frighten [adv]\n",
  "AFFRIGHTEN": "to frighten, also AFFRIGHT [v -ED, -ING, -S]\n",
  "AFFRIGHTENED": "AFFRIGHTEN, to frighten, also AFFRIGHT [v]\n",
  "AFFRIGHTENING": "AFFRIGHTEN, to frighten, also AFFRIGHT [v]\n",
  "AFFRIGHTENS": "AFFRIGHTEN, to frighten, also AFFRIGHT [v]\n",
  "AFFRIGHTFUL": "(archaic) frightful [adj]\n",
  "AFFRIGHTING": "AFFRIGHT, to frighten [v]\n",
  "AFFRIGHTMENT": "sudden fear [n -S]\n",
  "AFFRIGHTMENTS": "AFFRIGHTMENT, sudden fear [n]\n",
  "AFFRIGHTS": "AFFRIGHT, to frighten [v]\n",
  "AFFRONT": "to insult to one's face [v -ED, -ING, -S]\n",
  "AFFRONTE": "(French) in heraldry, facing each other [adj]\n",
  "AFFRONTED": "AFFRONT, to insult to one's face [v]\n",
  "AFFRONTEE": "(French) face to face, or front to front, also AFFRONTE [adj]\n",
  "AFFRONTING": "causing affront [adj AFFRONTINGLY] / the act of affronting [n -S]\n",
  "AFFRONTINGLY": "AFFRONTING, causing affront [adv]\n",
  "AFFRONTINGS": "AFFRONTING, the act of affronting [n]\n",
  "AFFRONTIVE": "tending to affront or offend [adj]\n",
  "AFFRONTS": "AFFRONT, to insult to one's face [v]\n",
  "AFFUSION": "the act of pouring a liquid on [n -S]\n",
  "AFFUSIONS": "AFFUSION, the act of pouring a liquid on [n]\n",
  "AFFY": "(obsolete) to trust; to assure on one's faith [v AFFIED or (Spenser) AFFYDE, AFFYING, AFFIES]\n",
  "AFFYDE": "AFFY, (obsolete) to trust; to assure on one's faith [v]\n",
  "AFFYING": "AFFY, (obsolete) to trust; to assure on one's faith [v]\n",
  "AFGHAN": "a heavy knitted or crocheted woollen blanket or shawl [n -S]\n",
  "AFGHANI": "a monetary unit of Afghanistan [n -S]\n",
  "AFGHANIS": "AFGHANI, a monetary unit of Afghanistan [n]\n",
  "AFGHANS": "AFGHAN, a heavy knitted or crocheted woollen blanket or shawl [n]\n",
  "AFICIONADA": "a female aficionado [n -S]\n",
  "AFICIONADAS": "AFICIONADA, a female aficionado [n]\n",
  "AFICIONADO": "(Spanish) a devotee, admirer, an enthusiastic fan, also AFFICIONADO [n -S]\n",
  "AFICIONADOS": "AFICIONADO, (Spanish) a devotee, admirer, an enthusiastic fan, also AFFICIONADO [n]\n",
  "AFIELD": "in the field [adv]\n",
  "AFIRE": "on fire [adj]\n",
  "AFLAJ": "FALAJ, (Arabic) an irrigation channel, esp. in Oman [n]\n",
  "AFLAME": "in a flaming state [adj]\n",
  "AFLATOXIN": "a toxin produced in foodstuffs by the action of the mould aspergillus [n -S]\n",
  "AFLATOXINS": "AFLATOXIN, a toxin produced in foodstuffs by the action of the mould aspergillus [n]\n",
  "AFLOAT": "floating [adj]\n",
  "AFLUTTER": "nervously excited [adj]\n",
  "AFOCAL": "denoting a method for transferring an image without bringing it into focus [adj]\n",
  "AFOOT": "on foot [adv]\n",
  "AFORE": "before [adv]\n",
  "AFOREHAND": "beforehand [adv]\n",
  "AFOREMENTIONED": "mentioned before in writing or speech, also FOREMENTIONED [adj]\n",
  "AFORESAID": "mentioned previously [adj]\n",
  "AFORETHOUGHT": "a premeditation [n -S]\n",
  "AFORETHOUGHTS": "AFORETHOUGHT, a premeditation [n]\n",
  "AFORETIME": "in time past; formerly [adv]\n",
  "AFOUL": "entangled [adj]\n",
  "AFRAID": "struck with fear [adj]\n",
  "AFREET": "(Arabic) an evil spirit in Arabic mythology, also AFRIT [n -S]\n",
  "AFREETS": "AFREET, (Arabic) an evil spirit in Arabic mythology, also AFRIT [n]\n",
  "AFRESH": "anew [adv]\n",
  "AFRIT": "(Arabic) an evil spirit in Arabic mythology, also AFREET [n -S]\n",
  "AFRITS": "AFRIT, (Arabic) an evil spirit in Arabic mythology, also AFREET [n]\n",
  "AFRO": "a thick curly African hairstyle, also FRO [n -S]\n",
  "AFRONT": "(Shakespeare) in front, abreast [adv]\n",
  "AFRORMOSIA": "a dense tropical hardwood resembling teak, used for furniture and panelling [n -S]\n",
  "AFRORMOSIAS": "AFRORMOSIA, a dense tropical hardwood resembling teak, used for furniture and panelling [n]\n",
  "AFROS": "AFRO, a thick curly African hairstyle, also FRO [n]\n",
  "AFT": "behind, nautically [adv]\n",
  "AFTER": "later in time [prep]\n",
  "AFTERBIRTH": "the placenta and fetal membranes that are expelled after delivery [n -S]\n",
  "AFTERBIRTHS": "AFTERBIRTH, the placenta and fetal membranes that are expelled after delivery [n]\n",
  "AFTERBODIES": "AFTERBODY, any discarded part that continues to trail after a rocket or satellite [n]\n",
  "AFTERBODY": "any discarded part that continues to trail after a rocket or satellite [n AFTERBODIES]\n",
  "AFTERBRAIN": "a nontechnical name for the myelencephalon [n -S]\n",
  "AFTERBRAINS": "AFTERBRAIN, a nontechnical name for the myelencephalon [n]\n",
  "AFTERBURN": "the burning of additional calories post-exercise [n -S]\n",
  "AFTERBURNER": "a device incorporated into a turbojet engine to provide extra thrust [n -S]\n",
  "AFTERBURNERS": "AFTERBURNER, a device incorporated into a turbojet engine to provide extra thrust [n]\n",
  "AFTERBURNING": "reheat, the use of a device to inject fuel into the hot exhaust gases of a turbojet in order to obtain increased thrust [n -S]\n",
  "AFTERBURNINGS": "AFTERBURNING, reheat, the use of a device to inject fuel into the hot exhaust gases of a turbojet in order to obtain increased thrust [n]\n",
  "AFTERBURNS": "AFTERBURN, the burning of additional calories post-exercise [n]\n",
  "AFTERCARE": "care subsequent to a period of treatment [n -S]\n",
  "AFTERCARES": "AFTERCARE, care subsequent to a period of treatment [n]\n",
  "AFTERCLAP": "an unexpected damaging or unsettling aftereffect [n -S]\n",
  "AFTERCLAPS": "AFTERCLAP, an unexpected damaging or unsettling aftereffect [n]\n",
  "AFTERDAMP": "poisonous gas formed after the explosion of firedamp in a mine [n -S]\n",
  "AFTERDAMPS": "AFTERDAMP, poisonous gas formed after the explosion of firedamp in a mine [n]\n",
  "AFTERDECK": "a deck behind a ship's bridge [n -S]\n",
  "AFTERDECKS": "AFTERDECK, a deck behind a ship's bridge [n]\n",
  "AFTEREFFECT": "an effect that follows its cause after an interval [n -S]\n",
  "AFTEREFFECTS": "AFTEREFFECT, an effect that follows its cause after an interval [n]\n",
  "AFTEREYE": "(Shakespeare) to gaze after [v AFTEREYED, AFTEREYEING or AFTEREYING, AFTEREYES]\n",
  "AFTEREYED": "AFTEREYE, (Shakespeare) to gaze after [v]\n",
  "AFTEREYEING": "AFTEREYE, (Shakespeare) to gaze after [v]\n",
  "AFTEREYES": "AFTEREYE, (Shakespeare) to gaze after [v]\n",
  "AFTEREYING": "AFTEREYE, (Shakespeare) to gaze after [v]\n",
  "AFTERGAME": "a rematch; a means employed after the first turn of affairs [n -S]\n",
  "AFTERGAMES": "AFTERGAME, a rematch; a means employed after the first turn of affairs [n]\n",
  "AFTERGLOW": "a glow remaining after a light source has faded [n -S]\n",
  "AFTERGLOWS": "AFTERGLOW, a glow remaining after a light source has faded [n]\n",
  "AFTERGRASS": "the grass that grows after the first crop has been mown; aftermath [n -ES]\n",
  "AFTERGRASSES": "AFTERGRASS, the grass that grows after the first crop has been mown; aftermath [n]\n",
  "AFTERGROWTH": "a later growth, an aftermath [n -S]\n",
  "AFTERGROWTHS": "AFTERGROWTH, a later growth, an aftermath [n]\n",
  "AFTERGUARD": "a sailor or group of sailors with the task of attending to the aft sails [n -S]\n",
  "AFTERGUARDS": "AFTERGUARD, a sailor or group of sailors with the task of attending to the aft sails [n]\n",
  "AFTERHEAT": "the heat from fission products in a nuclear reactor after it has been shut down [n -S]\n",
  "AFTERHEATS": "AFTERHEAT, the heat from fission products in a nuclear reactor after it has been shut down [n]\n",
  "AFTERIMAGE": "a usually visual sensation occurring after stimulation by its external cause has ceased [n -S]\n",
  "AFTERIMAGES": "AFTERIMAGE, a usually visual sensation occurring after stimulation by its external cause has ceased [n]\n",
  "AFTERINGS": "the last milk drawn when milking a cow [n]\n",
  "AFTERLIFE": "life after death [n AFTERLIVES or AFTERLIFES]\n",
  "AFTERLIFES": "AFTERLIFE, life after death [n]\n",
  "AFTERLIVES": "AFTERLIFE, life after death [n]\n",
  "AFTERMARKET": "the service offered to consumers after the purchase of goods and services [n -S]\n",
  "AFTERMARKETS": "AFTERMARKET, the service offered to consumers after the purchase of goods and services [n]\n",
  "AFTERMAST": "the mast nearest the stern [n -S]\n",
  "AFTERMASTS": "AFTERMAST, the mast nearest the stern [n]\n",
  "AFTERMATH": "a second mowing of grass in the same season [n -S]\n",
  "AFTERMATHS": "AFTERMATH, a second mowing of grass in the same season [n]\n",
  "AFTERMOST": "hindmost, as opposed to foremost [adj]\n",
  "AFTERNOON": "the time between morning and evening [n -S]\n",
  "AFTERNOONS": "AFTERNOON, the time between morning and evening [n]\n",
  "AFTERPAIN": "pain that comes after a while [n -S]\n",
  "AFTERPAINS": "AFTERPAIN, pain that comes after a while [n]\n",
  "AFTERPARTIES": "AFTERPARTY, a small party held after a larger event, such as a pop concert or film premiere, to which only a select group of guests is invited [n]\n",
  "AFTERPARTY": "a small party held after a larger event, such as a pop concert or film premiere, to which only a select group of guests is invited [n AFTERPARTIES]\n",
  "AFTERPEAK": "space behind the aftermost bulkhead, often used for storage [n -S]\n",
  "AFTERPEAKS": "AFTERPEAK, space behind the aftermost bulkhead, often used for storage [n]\n",
  "AFTERPIECE": "a minor piece after a play [n -S]\n",
  "AFTERPIECES": "AFTERPIECE, a minor piece after a play [n]\n",
  "AFTERS": "the latter part of a meal [n]\n",
  "AFTERSALES": "after a sale has been completed, usually with reference to servicing the goods, installation, etc. [adj]\n",
  "AFTERSENSATION": "an afterimage [n -S]\n",
  "AFTERSENSATIONS": "AFTERSENSATION, an afterimage [n]\n",
  "AFTERSHAFT": "the second shaft coming out of the quill of a feather [n -S]\n",
  "AFTERSHAFTS": "AFTERSHAFT, the second shaft coming out of the quill of a feather [n]\n",
  "AFTERSHAVE": "a usually scented lotion for use on the face after shaving [n -S]\n",
  "AFTERSHAVES": "AFTERSHAVE, a usually scented lotion for use on the face after shaving [n]\n",
  "AFTERSHOCK": "an earthquake that follows and has its epicenter near a larger earthquake [n -S]\n",
  "AFTERSHOCKS": "AFTERSHOCK, an earthquake that follows and has its epicenter near a larger earthquake [n]\n",
  "AFTERSHOW": "a party held after a public performance [n -S]\n",
  "AFTERSHOWS": "AFTERSHOW, a party held after a public performance [n]\n",
  "AFTERSUN": "moisturising lotion applied to the skin to soothe sunburn and prevent peeling [n -S]\n",
  "AFTERSUNS": "AFTERSUN, moisturising lotion applied to the skin to soothe sunburn and prevent peeling [n]\n",
  "AFTERSUPPER": "the time between supper and bedtime [n -S]\n",
  "AFTERSUPPERS": "AFTERSUPPER, the time between supper and bedtime [n]\n",
  "AFTERSWARM": "a second swarm or cast of bees [n -S]\n",
  "AFTERSWARMS": "AFTERSWARM, a second swarm or cast of bees [n]\n",
  "AFTERTASTE": "persistence of a sensation after the stimulating experience has gone [n -S]\n",
  "AFTERTASTES": "AFTERTASTE, persistence of a sensation after the stimulating experience has gone [n]\n",
  "AFTERTAX": "remaining after payment of taxes [adj]\n",
  "AFTERTHOUGHT": "an idea occurring later [n -S]\n",
  "AFTERTHOUGHTS": "AFTERTHOUGHT, an idea occurring later [n]\n",
  "AFTERTIME": "the time after the present [n -S]\n",
  "AFTERTIMES": "AFTERTIME, the time after the present [n]\n",
  "AFTERTREATMENT": "additional treatment that is given to a patient following an illness or medical procedure [n -S]\n",
  "AFTERTREATMENTS": "AFTERTREATMENT, additional treatment that is given to a patient following an illness or medical procedure [n]\n",
  "AFTERWARD": "at a later time, also AFTERWARDS [adv]\n",
  "AFTERWARDS": "at a later time, also AFTERWARD [adv]\n",
  "AFTERWORD": "an epilogue [n -S]\n",
  "AFTERWORDS": "AFTERWORD, an epilogue [n]\n",
  "AFTERWORLD": "a future world [n -S]\n",
  "AFTERWORLDS": "AFTERWORLD, a future world [n]\n",
  "AFTMOST": "nearest the stern [adj]\n",
  "AFTOSA": "a disease of hoofed mammals [n -S]\n",
  "AFTOSAS": "AFTOSA, a disease of hoofed mammals [n]\n",
  "AG": "(short for) agriculture [n -S]\n",
  "AGA": "(Turkish) a Turkish military officer, also AGHA [n -S]\n",
  "AGACANT": "(French) provoking, alluring, also AGACANTE [adj]\n",
  "AGACANTE": "(French) provoking, alluring, also AGACANT [adj]\n",
  "AGACERIE": "(French) an allurement, coquetry [n -S]\n",
  "AGACERIES": "AGACERIE, (French) an allurement, coquetry [n]\n",
  "AGAIN": "once more, also AGEN [adv]\n",
  "AGAINST": "opposite to [prep]\n",
  "AGALACTIA": "the failure or inability to produce milk [n -S]\n",
  "AGALACTIAS": "AGALACTIA, the failure or inability to produce milk [n]\n",
  "AGALLOCH": "(Greek) the fragrant wood of a tropical tree, also AGALWOOD [n -S]\n",
  "AGALLOCHS": "AGALLOCH, (Greek) the fragrant wood of a tropical tree, also AGALWOOD [n]\n",
  "AGALMATOLITE": "a soapstone or other soft mineral, esp. one in which Chinese figures are carved [n -S]\n",
  "AGALMATOLITES": "AGALMATOLITE, a soapstone or other soft mineral, esp. one in which Chinese figures are carved [n]\n",
  "AGALWOOD": "the wood of the aloe, aka agila, also AGARWOOD, ALOESWOOD [n -S]\n",
  "AGALWOODS": "AGALWOOD, the wood of the aloe, aka agila, also AGARWOOD, ALOESWOOD [n]\n",
  "AGAMA": "(Caribbean) a kind of tropical lizard, also AGAMID [n -S]\n",
  "AGAMAS": "AGAMA, (Caribbean) a kind of tropical lizard, also AGAMID [n]\n",
  "AGAMETE": "an asexual reproductive cell [n -S]\n",
  "AGAMETES": "AGAMETE, an asexual reproductive cell [n]\n",
  "AGAMI": "a crane-like bird of South America [n -S]\n",
  "AGAMIC": "asexual, also AGAMOUS [adj AGAMICALLY]\n",
  "AGAMICALLY": "AGAMIC, asexual, also AGAMOUS [adv]\n",
  "AGAMID": "a kind of tropical lizard with a thick tongue [n -S]\n",
  "AGAMIDS": "AGAMID, a kind of tropical lizard with a thick tongue [n]\n",
  "AGAMIS": "AGAMI, a crane-like bird of South America [n]\n",
  "AGAMOGENESES": "AGAMOGENESIS, reproduction by nonsexual means [n]\n",
  "AGAMOGENESIS": "reproduction by nonsexual means [n AGAMOGENESES]\n",
  "AGAMOGENETIC": "reproducing by agamogenesis, reproduction by nonsexual means [adj]\n",
  "AGAMOGONIES": "AGAMOGONY, asexual reproduction in protozoans characterised by multiple fission [n]\n",
  "AGAMOGONY": "asexual reproduction in protozoans characterised by multiple fission [n AGAMOGONIES]\n",
  "AGAMOID": "having the features of an agamid [adj] / a member of the agamid family [n -S]\n",
  "AGAMOIDS": "AGAMOID, a member of the agamid family [n]\n",
  "AGAMONT": "in protozoans, a SCHIZONT, a mature trophozoite about to reproduce by schizogony [n -S]\n",
  "AGAMONTS": "AGAMONT, in protozoans, a SCHIZONT, a mature trophozoite about to reproduce by schizogony [n]\n",
  "AGAMOSPERMIES": "AGAMOSPERMY, the formation of seeds without fertilisation [n]\n",
  "AGAMOSPERMY": "the formation of seeds without fertilisation [n AGAMOSPERMIES]\n",
  "AGAMOUS": "asexual, also AGAMIC [adj]\n",
  "AGAPAE": "AGAPE, (Greek) a love feast practised by early Christians in connection with the Last Supper; Christian love [n]\n",
  "AGAPAI": "AGAPE, (Greek) a love feast practised by early Christians in connection with the Last Supper; Christian love [n]\n",
  "AGAPANTHUS": "a genus of lily native to South Africa [n -ES]\n",
  "AGAPANTHUSES": "AGAPANTHUS, a genus of lily native to South Africa [n]\n",
  "AGAPE": "(Greek) a love feast practised by early Christians in connection with the Last Supper; Christian love [n AGAPES or AGAPAE or AGAPAI]\n",
  "AGAPEIC": "relating to agape, Christian love [adj]\n",
  "AGAPES": "AGAPE, (Greek) a love feast practised by early Christians in connection with the Last Supper; Christian love [n]\n",
  "AGAR": "(Malay) a jelly prepared from seaweed [n -S]\n",
  "AGARIC": "a kind of fungus [n -S]\n",
  "AGARICACEOUS": "belonging to the agaric family of fungi [adj]\n",
  "AGARICS": "AGARIC, a kind of fungus [n]\n",
  "AGAROSE": "a sugar obtained from agar [n -S]\n",
  "AGAROSES": "AGAROSE, a sugar obtained from agar [n]\n",
  "AGARS": "AGAR, (Malay) a jelly prepared from seaweed [n]\n",
  "AGARWOOD": "a soft, resinous wood of an Asian tree, known for its aromatic qualities, and used in incense, also AGALWOOD, ALOESWOOD [n -S]\n",
  "AGARWOODS": "AGARWOOD, a soft, resinous wood of an Asian tree, known for its aromatic qualities, and used in incense, also AGALWOOD, ALOESWOOD [n]\n",
  "AGAS": "AGA, (Turkish) a Turkish military officer, also AGHA [n]\n",
  "AGAST": "(Milton) to terrify [v -ED, -ING, -S]\n",
  "AGASTED": "AGAST, (Milton) to terrify [v]\n",
  "AGASTING": "AGAST, (Milton) to terrify [v]\n",
  "AGASTS": "AGAST, (Milton) to terrify [v]\n",
  "AGATE": "a variety of quartz [n -S]\n",
  "AGATES": "AGATE, a variety of quartz [n]\n",
  "AGATEWARE": "a form of ceramic made to look like agate [n -S]\n",
  "AGATEWARES": "AGATEWARE, a form of ceramic made to look like agate [n]\n",
  "AGATHODAIMON": "(Greek) one's good genius; the good part of one's conscience [n -S]\n",
  "AGATHODAIMONS": "AGATHODAIMON, (Greek) one's good genius; the good part of one's conscience [n]\n",
  "AGATISE": "to cause to resemble agate, also AGATIZE [v AGATISED, AGATISING, AGATISES]\n",
  "AGATISED": "AGATISE, to cause to resemble agate, also AGATIZE [v]\n",
  "AGATISES": "AGATISE, to cause to resemble agate, also AGATIZE [v]\n",
  "AGATISING": "AGATISE, to cause to resemble agate, also AGATIZE [v]\n",
  "AGATIZE": "to cause to resemble agate, also AGATISE [v AGATIZED, AGATIZING, AGATIZES]\n",
  "AGATIZED": "AGATIZE, to cause to resemble agate, also AGATISE [v]\n",
  "AGATIZES": "AGATIZE, to cause to resemble agate, also AGATISE [v]\n",
  "AGATIZING": "AGATIZE, to cause to resemble agate, also AGATISE [v]\n",
  "AGATOID": "like agate [adj]\n",
  "AGAVE": "any of numerous spiny-leaved plants of the American genus Agave [n -S]\n",
  "AGAVES": "AGAVE, any of numerous spiny-leaved plants of the American genus Agave [n]\n",
  "AGAZE": "(archaic) at gaze, gazing [adj]\n",
  "AGAZED": "(Shakespeare) struck with amazement [adj]\n",
  "AGE": "to grow old [v AGED, AGING or AGEING, AGES]\n",
  "AGED": "being of a certain age; old [adj AGEDLY]\n",
  "AGEDLY": "AGED, being of a certain age; old [adv]\n",
  "AGEDNESS": "the state of being aged [n -ES]\n",
  "AGEDNESSES": "AGEDNESS, the state of being aged [n]\n",
  "AGEE": "(Scots) off the straight; ajar, also AJEE [adv]\n",
  "AGEING": "the process of growing old [n -S]\n",
  "AGEINGS": "AGEING, the process of growing old [n]\n",
  "AGEISM": "discrimination based on age, also AGISM [n -S]\n",
  "AGEISMS": "AGEISM, discrimination based on age, also AGISM [n]\n",
  "AGEIST": "an advocate of ageisms [n -S]\n",
  "AGEISTS": "AGEIST, an advocate of ageisms [n]\n",
  "AGELAST": "(Greek) someone who never laughs [n -S]\n",
  "AGELASTIC": "never laughing [adj]\n",
  "AGELASTS": "AGELAST, (Greek) someone who never laughs [n]\n",
  "AGELESS": "never growing old [adj AGELESSLY]\n",
  "AGELESSLY": "AGELESS, never growing old [adv]\n",
  "AGELESSNESS": "the quality of being ageless [n -ES]\n",
  "AGELESSNESSES": "AGELESSNESS, the quality of being ageless [n]\n",
  "AGELONG": "lasting for a very long time [adj]\n",
  "AGEMATE": "a person of the same age as another [n -S]\n",
  "AGEMATES": "AGEMATE, a person of the same age as another [n]\n",
  "AGEN": "(dialect) once more, also AGAIN, AGIN [adv]\n",
  "AGENCIES": "AGENCY, an organization that does business for others [n]\n",
  "AGENCY": "an organization that does business for others [n AGENCIES]\n",
  "AGENDA": "(Latin) a list of things to be done [n -S]\n",
  "AGENDALESS": "without an agenda [adj]\n",
  "AGENDAS": "AGENDA, (Latin) a list of things to be done [n]\n",
  "AGENDER": "of or relating to a person who does not identify with any gender [adj]\n",
  "AGENDUM": "(Latin) an item on an agenda [n AGENDA or AGENDUMS]\n",
  "AGENDUMS": "AGENDUM, (Latin) an item on an agenda [n]\n",
  "AGENE": "a chemical compound used in bleaching flour [n -S]\n",
  "AGENES": "AGENE, a chemical compound used in bleaching flour [n]\n",
  "AGENESES": "AGENESIS, absence or imperfection of a bodily part, also AGENESIA [n]\n",
  "AGENESIA": "absence or imperfection of a bodily part, also AGENESIS [n -S]\n",
  "AGENESIAS": "AGENESIA, absence or imperfection of a bodily part, also AGENESIS [n]\n",
  "AGENESIS": "absence or imperfection of a bodily part, also AGENESIA [n AGENESES]\n",
  "AGENETIC": "relating to agenesis, imperfect development of bodily parts [adj]\n",
  "AGENISE": "to treat flour with agene, also AGENIZE [v AGENISED, AGENISING, AGENISES]\n",
  "AGENISED": "AGENISE, to treat flour with agene, also AGENIZE [v]\n",
  "AGENISES": "AGENISE, to treat flour with agene, also AGENIZE [v]\n",
  "AGENISING": "AGENISE, to treat flour with agene, also AGENIZE [v]\n",
  "AGENIZE": "to treat flour with agene, also AGENISE [v AGENIZED, AGENIZING, AGENIZES]\n",
  "AGENIZED": "AGENIZE, to treat flour with agene, also AGENISE [v]\n",
  "AGENIZES": "AGENIZE, to treat flour with agene, also AGENISE [v]\n",
  "AGENIZING": "AGENIZE, to treat flour with agene, also AGENISE [v]\n",
  "AGENT": "a person or thing that acts [n -S] / to act for another with authority [v -ED, -ING, -S]\n",
  "AGENTED": "AGENT, to act for another with authority [v]\n",
  "AGENTIAL": "pertaining to an agent [adj]\n",
  "AGENTING": "the business of an agent [n -S]\n",
  "AGENTINGS": "AGENTING, the business of an agent [n]\n",
  "AGENTIVAL": "of the performer of an action [adj]\n",
  "AGENTIVE": "a grammatical case indicating the agent performing an action [n -S]\n",
  "AGENTIVES": "AGENTIVE, a grammatical case indicating the agent performing an action [n]\n",
  "AGENTIVITIES": "AGENTIVITY, the state of being agentive [n]\n",
  "AGENTIVITY": "the state of being agentive [n AGENTIVITIES]\n",
  "AGENTRIES": "AGENTRY, the office or duties of an agent [n]\n",
  "AGENTRY": "the office or duties of an agent [n AGENTRIES]\n",
  "AGENTS": "AGENT, to act for another with authority [v]\n",
  "AGER": "one that ages [n -S]\n",
  "AGERATUM": "a flowering tropical plant [n -S]\n",
  "AGERATUMS": "AGERATUM, a flowering tropical plant [n]\n",
  "AGERS": "AGER, one that ages [n]\n",
  "AGES": "AGE, to grow old [v]\n",
  "AGEUSIA": "lack of a sense of taste [n -S]\n",
  "AGEUSIAS": "AGEUSIA, lack of a sense of taste [n]\n",
  "AGFLATION": "an economic situation in which increased demand causes an increase in the price of food products, and a potential rise in general inflation [n -S]\n",
  "AGFLATIONS": "AGFLATION, an economic situation in which increased demand causes an increase in the price of food products, and a potential rise in general inflation [n]\n",
  "AGGADA": "(Hebrew) the homiletic part of the Jewish scripture, also HAGGADAH, AGGADAH [n AGGADAS or AGGADOT or AGGADOTH]\n",
  "AGGADAH": "(Hebrew) the homiletic part of the Jewish scripture, also HAGGADAH, AGGADA [n AGGADAHS or AGGADOT or AGGADOTH]\n",
  "AGGADAHS": "AGGADAH, (Hebrew) the homiletic part of the Jewish scripture, also HAGGADAH, AGGADA [n]\n",
  "AGGADAS": "AGGADA, (Hebrew) the homiletic part of the Jewish scripture, also HAGGADAH, AGGADAH [n]\n",
  "AGGADIC": "(Hebrew) relating to the haggadah, the Pesach guidebook, used during Seder, also HAGADIC, HAGGADIC, HAGGADICAL [adj]\n",
  "AGGADOT": "AGGADAH, (Hebrew) the homiletic part of the Jewish scripture, also HAGGADAH, AGGADA [n]\n",
  "AGGADOTH": "AGGADAH, (Hebrew) the homiletic part of the Jewish scripture, also HAGGADAH, AGGADA [n]\n",
  "AGGER": "(historical) an artificial mound or elevation for military use [n -S]\n",
  "AGGERS": "AGGER, (historical) an artificial mound or elevation for military use [n]\n",
  "AGGIE": "a type of playing marble [n -S]\n",
  "AGGIES": "AGGIE, a type of playing marble [n]\n",
  "AGGIORNAMENTI": "AGGIORNAMENTO, (Italian) the modernization of ideas of the Catholic church [n]\n",
  "AGGIORNAMENTO": "(Italian) the modernization of ideas of the Catholic church [n AGGIORNAMENTI or AGGIORNAMENTOS]\n",
  "AGGIORNAMENTOS": "AGGIORNAMENTO, (Italian) the modernization of ideas of the Catholic church [n]\n",
  "AGGLOMERATE": "to collect, esp. into a mass [v AGGLOMERATED, AGGLOMERATING, AGGLOMERATES]\n",
  "AGGLOMERATED": "AGGLOMERATE, to collect, esp. into a mass [v]\n",
  "AGGLOMERATES": "AGGLOMERATE, to collect, esp. into a mass [v]\n",
  "AGGLOMERATING": "AGGLOMERATE, to collect, esp. into a mass [v]\n",
  "AGGLOMERATION": "the act of collecting in a mass [n -S]\n",
  "AGGLOMERATIONS": "AGGLOMERATION, the act of collecting in a mass [n]\n",
  "AGGLOMERATIVE": "tending to agglomerate [adj]\n",
  "AGGLUTINABILITY": "the capacity (as of red blood cells) to be agglutinated [n]\n",
  "AGGLUTINABLE": "able to be agglutinated [adj]\n",
  "AGGLUTINANT": "an agglutinating agent [n -S]\n",
  "AGGLUTINANTS": "AGGLUTINANT, an agglutinating agent [n]\n",
  "AGGLUTINATE": "to glue together; in philology, to make compound words by additions [v AGGLUTINATED, AGGLUTINATING, AGGLUTINATES]\n",
  "AGGLUTINATED": "AGGLUTINATE, to glue together; in philology, to make compound words by additions [v]\n",
  "AGGLUTINATES": "AGGLUTINATE, to glue together; in philology, to make compound words by additions [v]\n",
  "AGGLUTINATING": "AGGLUTINATE, to glue together; in philology, to make compound words by additions [v]\n",
  "AGGLUTINATION": "applied to agglutinated words or languages containing many such words [n -S]\n",
  "AGGLUTINATIONS": "AGGLUTINATION, applied to agglutinated words or languages containing many such words [n]\n",
  "AGGLUTINATIVE": "applied to agglutinated words or languages containing many such words [adj]\n",
  "AGGLUTININ": "a substance in blood causing coagulation [n -S]\n",
  "AGGLUTININS": "AGGLUTININ, a substance in blood causing coagulation [n]\n",
  "AGGLUTINOGEN": "a substance causing the production of agglutinin [n -S]\n",
  "AGGLUTINOGENIC": "of or like an agglutinogen [adj]\n",
  "AGGLUTINOGENS": "AGGLUTINOGEN, a substance causing the production of agglutinin [n]\n",
  "AGGRACE": "(Spenser) to please, gratify, also AGGRATE [v AGRASTE or AGGRACED, AGGRACING, AGGRACES]\n",
  "AGGRACED": "AGGRACE, (Spenser) to please, gratify, also AGGRATE [v]\n",
  "AGGRACES": "AGGRACE, (Spenser) to please, gratify, also AGGRATE [v]\n",
  "AGGRACING": "AGGRACE, (Spenser) to please, gratify, also AGGRATE [v]\n",
  "AGGRADATION": "the act of aggrading [n -S]\n",
  "AGGRADATIONS": "AGGRADATION, the act of aggrading [n]\n",
  "AGGRADE": "to raise the level of a surface through depositing detritus [v AGGRADED, AGGRADING, AGGRADES]\n",
  "AGGRADED": "AGGRADE, to raise the level of a surface through depositing detritus [v]\n",
  "AGGRADES": "AGGRADE, to raise the level of a surface through depositing detritus [v]\n",
  "AGGRADING": "AGGRADE, to raise the level of a surface through depositing detritus [v]\n",
  "AGGRANDISE": "to increase the power or rank of; to make greater, also AGGRANDIZE [v AGGRANDISED, AGGRANDISING, AGGRANDISES]\n",
  "AGGRANDISED": "AGGRANDISE, to increase the power or rank of; to make greater, also AGGRANDIZE [v]\n",
  "AGGRANDISEMENT": "the act of aggrandising, also AGGRANDIZEMENT [n -S]\n",
  "AGGRANDISEMENTS": "AGGRANDISEMENT, the act of aggrandising, also AGGRANDIZEMENT [n]\n",
  "AGGRANDISER": "one who aggrandises, also AGGRANDIZER [n -S]\n",
  "AGGRANDISERS": "AGGRANDISER, one who aggrandises, also AGGRANDIZER [n]\n",
  "AGGRANDISES": "AGGRANDISE, to increase the power or rank of; to make greater, also AGGRANDIZE [v]\n",
  "AGGRANDISING": "AGGRANDISE, to increase the power or rank of; to make greater, also AGGRANDIZE [v]\n",
  "AGGRANDIZE": "to increase the power or rank of; to make greater, also AGGRANDISE [v AGGRANDIZED, AGGRANDIZING, AGGRANDIZES]\n",
  "AGGRANDIZED": "AGGRANDIZE, to increase the power or rank of; to make greater, also AGGRANDISE [v]\n",
  "AGGRANDIZEMENT": "the act of aggrandizing, also AGGRANDISEMENT [n -S]\n",
  "AGGRANDIZEMENTS": "AGGRANDIZEMENT, the act of aggrandizing, also AGGRANDISEMENT [n]\n",
  "AGGRANDIZER": "one who aggrandizes, also AGGRANDISER [n -S]\n",
  "AGGRANDIZERS": "AGGRANDIZER, one who aggrandizes, also AGGRANDISER [n]\n",
  "AGGRANDIZES": "AGGRANDIZE, to increase the power or rank of; to make greater, also AGGRANDISE [v]\n",
  "AGGRANDIZING": "AGGRANDIZE, to increase the power or rank of; to make greater, also AGGRANDISE [v]\n",
  "AGGRATE": "(Spenser) to please, gratify, also AGGRACE [v AGGRATED, AGGRATING, AGGRATES]\n",
  "AGGRATED": "AGGRATE, (Spenser) to please, gratify, also AGGRACE [v]\n",
  "AGGRATES": "AGGRATE, (Spenser) to please, gratify, also AGGRACE [v]\n",
  "AGGRATING": "AGGRATE, (Spenser) to please, gratify, also AGGRACE [v]\n",
  "AGGRAVATE": "to make worse [v AGGRAVATED, AGGRAVATING, AGGRAVATES]\n",
  "AGGRAVATED": "AGGRAVATE, to make worse [v]\n",
  "AGGRAVATES": "AGGRAVATE, to make worse [v]\n",
  "AGGRAVATING": "AGGRAVATE, to make worse [v]\n",
  "AGGRAVATINGLY": "AGGRAVATING, AGGRAVATE, to make worse [adv]\n",
  "AGGRAVATION": "an act or circumstance that intensifies or makes worse [n -S]\n",
  "AGGRAVATIONS": "AGGRAVATION, an act or circumstance that intensifies or makes worse [n]\n",
  "AGGREGATE": "formed of parts that combine to make a whole [adj AGGREGATELY] / to cause to come together [v AGGREGATED, AGGREGATING, AGGREGATES]\n",
  "AGGREGATED": "AGGREGATE, to cause to come together [v]\n",
  "AGGREGATELY": "AGGREGATE, formed of parts that combine to make a whole [adv]\n",
  "AGGREGATENESS": "the quality resulting from aggregation [n -ES]\n",
  "AGGREGATENESSES": "AGGREGATENESS, the quality resulting from aggregation [n]\n",
  "AGGREGATES": "AGGREGATE, to cause to come together [v]\n",
  "AGGREGATING": "AGGREGATE, to cause to come together [v]\n",
  "AGGREGATION": "a group, body, or mass composed of many distinct parts or individuals [n -S]\n",
  "AGGREGATIONAL": "of or like aggregation [adj]\n",
  "AGGREGATIONS": "AGGREGATION, a group, body, or mass composed of many distinct parts or individuals [n]\n",
  "AGGREGATIVE": "of or relating to an aggregate [adj AGGREGATIVELY]\n",
  "AGGREGATIVELY": "AGGREGATIVE, of or relating to an aggregate [adv]\n",
  "AGGREGATOR": "one who aggregates [n -S]\n",
  "AGGREGATORS": "AGGREGATOR, one who aggregates [n]\n",
  "AGGRESS": "to attack first [v -ED, -ING, -ES]\n",
  "AGGRESSED": "AGGRESS, to attack first [v]\n",
  "AGGRESSES": "AGGRESS, to attack first [v]\n",
  "AGGRESSING": "AGGRESS, to attack first [v]\n",
  "AGGRESSION": "a forceful action intended to dominate or master [n -S]\n",
  "AGGRESSIONS": "AGGRESSION, a forceful action intended to dominate or master [n]\n",
  "AGGRESSIVE": "tending toward or exhibiting aggression [adj AGGRESSIVELY]\n",
  "AGGRESSIVELY": "AGGRESSIVE, tending toward or exhibiting aggression [adv]\n",
  "AGGRESSIVENESS": "the quality of being aggressive [n]\n",
  "AGGRESSIVITIES": "AGGRESSIVITY, aggressiveness [n]\n",
  "AGGRESSIVITY": "aggressiveness [n AGGRESSIVITIES]\n",
  "AGGRESSOR": "one who aggresses [n -S]\n",
  "AGGRESSORS": "AGGRESSOR, one who aggresses [n]\n",
  "AGGRI": "ancient West African variegated glass beads, also AGGRY [n]\n",
  "AGGRIEVE": "to distress [v AGGRIEVED, AGGRIEVING, AGGRIEVES]\n",
  "AGGRIEVED": "AGGRIEVE, to distress [v]\n",
  "AGGRIEVEDLY": "AGGRIEVED, AGGRIEVE, to distress [adv]\n",
  "AGGRIEVEMENT": "the state of being aggrieved [n -S]\n",
  "AGGRIEVEMENTS": "AGGRIEVEMENT, the state of being aggrieved [n]\n",
  "AGGRIEVES": "AGGRIEVE, to distress [v]\n",
  "AGGRIEVING": "AGGRIEVE, to distress [v]\n",
  "AGGRO": "(short for) aggressive behaviour, aggravation [n -S]\n",
  "AGGROS": "AGGRO, (short for) aggressive behaviour, aggravation [n]\n",
  "AGGRY": "ancient West African variegated glass beads, also AGGRI [n]\n",
  "AGHA": "(Turkish) a Turkish military officer, also AGA [n -S]\n",
  "AGHAS": "AGHA, (Turkish) a Turkish military officer, also AGA [n]\n",
  "AGHAST": "stupefied with horror, also AGAST [adj]\n",
  "AGILA": "(Tamil) the wood of the aloe, aka agalwood [n -S]\n",
  "AGILAS": "AGILA, (Tamil) the wood of the aloe, aka agalwood [n]\n",
  "AGILE": "able to move quickly and easily [adj AGILER, AGILEST, AGILELY]\n",
  "AGILELY": "AGILE, able to move quickly and easily [adv]\n",
  "AGILENESS": "the state of being agile [n -ES]\n",
  "AGILENESSES": "AGILENESS, the state of being agile [n]\n",
  "AGILER": "AGILE, able to move quickly and easily [adj]\n",
  "AGILEST": "AGILE, able to move quickly and easily [adj]\n",
  "AGILITIES": "AGILITY, nimbleness [n]\n",
  "AGILITY": "nimbleness [n AGILITIES]\n",
  "AGIN": "(dialect) again, also AGEN [adv]\n",
  "AGING": "the process of growing old [n -S]\n",
  "AGINGS": "AGING, the process of growing old [n]\n",
  "AGINNER": "an opponent of change [n -S]\n",
  "AGINNERS": "AGINNER, an opponent of change [n]\n",
  "AGIO": "(Italian) a premium paid for the exchange of currency [n -S]\n",
  "AGIOS": "AGIO, (Italian) a premium paid for the exchange of currency [n]\n",
  "AGIOTAGE": "(French) speculative manoeuvres in stocks and shares [n -S]\n",
  "AGIOTAGES": "AGIOTAGE, (French) speculative manoeuvres in stocks and shares [n]\n",
  "AGISM": "discrimination based on age, also AGEISM [n -S]\n",
  "AGISMS": "AGISM, discrimination based on age, also AGEISM [n]\n",
  "AGIST": "to admit (livestock) for a stated time into a forest [v -ED, -ING, -S]\n",
  "AGISTED": "AGIST, to admit (livestock) for a stated time into a forest [v]\n",
  "AGISTER": "a former officer of the king's forest, who had the care of cattle agisted, also AGISTOR [n -S]\n",
  "AGISTERS": "AGISTER, a former officer of the king's forest, who had the care of cattle agisted, also AGISTOR [n]\n",
  "AGISTING": "AGIST, to admit (livestock) for a stated time into a forest [v]\n",
  "AGISTMENT": "a land tax assessed for cattle pasturing [n -S]\n",
  "AGISTMENTS": "AGISTMENT, a land tax assessed for cattle pasturing [n]\n",
  "AGISTOR": "a former officer of the king's forest, who had the care of cattle agisted, also AGISTER [n -S]\n",
  "AGISTORS": "AGISTOR, a former officer of the king's forest, who had the care of cattle agisted, also AGISTER [n]\n",
  "AGISTS": "AGIST, to admit (livestock) for a stated time into a forest [v]\n",
  "AGITA": "a feeling of agitation [n -S]\n",
  "AGITABLE": "able to be agitated [adj]\n",
  "AGITANS": "as in paralysis agitans, Parkinson's disease [adj]\n",
  "AGITAS": "AGITA, a feeling of agitation [n]\n",
  "AGITATE": "to stir violently [v AGITATED, AGITATING, AGITATES]\n",
  "AGITATED": "AGITATE, to stir violently [v]\n",
  "AGITATEDLY": "AGITATED, AGITATE, to stir violently [adv]\n",
  "AGITATES": "AGITATE, to stir violently [v]\n",
  "AGITATING": "AGITATE, to stir violently [v]\n",
  "AGITATION": "the act of agitating [n -S]\n",
  "AGITATIONAL": "relating to agitation [adj]\n",
  "AGITATIONS": "AGITATION, the act of agitating [n]\n",
  "AGITATIVE": "tending to agitate [adj]\n",
  "AGITATO": "(Italian) of music, in an agitated manner [adv]\n",
  "AGITATOR": "one that agitates [n -S]\n",
  "AGITATORS": "AGITATOR, one that agitates [n]\n",
  "AGITPOP": "pop music as political propaganda [n -S]\n",
  "AGITPOPS": "AGITPOP, pop music as political propaganda [n]\n",
  "AGITPROP": "(Russian) pro-Communist propaganda [n -S]\n",
  "AGITPROPS": "AGITPROP, (Russian) pro-Communist propaganda [n]\n",
  "AGLARE": "glaring [adj]\n",
  "AGLEAM": "gleaming [adj]\n",
  "AGLEE": "(Scots) with a turn or twist to one side, also AGLEY, AGLY [adv]\n",
  "AGLET": "a metal sheath at the end of a lace, also AIGLET [n -S]\n",
  "AGLETS": "AGLET, a metal sheath at the end of a lace, also AIGLET [n]\n",
  "AGLEY": "(Scots) with a turn or twist to one side, also AGLEE, AGLY [adv]\n",
  "AGLIMMER": "glimmering [adj]\n",
  "AGLITTER": "glittering [adj]\n",
  "AGLOO": "(Inuit) a hole in the ice through which a seal breathes, also AGLU [n -S]\n",
  "AGLOOS": "AGLOO, (Inuit) a hole in the ice through which a seal breathes, also AGLU [n]\n",
  "AGLOSSAL": "having no tongue at birth [adj]\n",
  "AGLOSSATE": "relating to aglossia, the congenital lack of a tongue, also AGLOSSAL [adj]\n",
  "AGLOSSIA": "the congenital lack of a tongue [n -S]\n",
  "AGLOSSIAS": "AGLOSSIA, the congenital lack of a tongue [n]\n",
  "AGLOW": "glowing [adj]\n",
  "AGLU": "(Inuit) a hole in the ice through which a seal breathes, also AGLOO [n -S]\n",
  "AGLUS": "AGLU, (Inuit) a hole in the ice through which a seal breathes, also AGLOO [n]\n",
  "AGLY": "(Scots) with a turn or twist to one side, also AGLEE, AGLEY [adv]\n",
  "AGLYCON": "an organic compound, as a phenol or alcohol, combined with the sugar portion of a glycoside, also AGLYCONE [n -S]\n",
  "AGLYCONE": "an organic compound, as a phenol or alcohol, combined with the sugar portion of a glycoside, also AGLYCON [n -S]\n",
  "AGLYCONES": "AGLYCONE, an organic compound, as a phenol or alcohol, combined with the sugar portion of a glycoside, also AGLYCON [n]\n",
  "AGLYCONS": "AGLYCON, an organic compound, as a phenol or alcohol, combined with the sugar portion of a glycoside, also AGLYCONE [n]\n",
  "AGMA": "(Greek) a phonetic symbol representing the sound 'ng' [n -S]\n",
  "AGMAS": "AGMA, (Greek) a phonetic symbol representing the sound 'ng' [n]\n",
  "AGMINATE": "clustered together [adj]\n",
  "AGNAIL": "a torn shred of skin beside the nail [n -S]\n",
  "AGNAILS": "AGNAIL, a torn shred of skin beside the nail [n]\n",
  "AGNAME": "a name extra to one's usual name [n -S]\n",
  "AGNAMED": "having an agname, a name over and above the ordinary name and surname [adj]\n",
  "AGNAMES": "AGNAME, a name extra to one's usual name [n]\n",
  "AGNATE": "a relative on the father's side [n -S]\n",
  "AGNATES": "AGNATE, a relative on the father's side [n]\n",
  "AGNATHAN": "any of a family of eellike fishes, including the lamprey [n -S]\n",
  "AGNATHANS": "AGNATHAN, any of a family of eellike fishes, including the lamprey [n]\n",
  "AGNATHOUS": "lacking jaws, esp. of hagfish and lampreys [adj]\n",
  "AGNATIC": "pertaining to descent by the male line of ancestors, also AGNATICAL [adj AGNATICALLY]\n",
  "AGNATICAL": "pertaining to descent by the male line of ancestors, also AGNATIC [adj AGNATICALLY]\n",
  "AGNATICALLY": "AGNATICAL, pertaining to descent by the male line of ancestors, also AGNATIC [adv]\n",
  "AGNATION": "relationship traced through the male line [n -S]\n",
  "AGNATIONS": "AGNATION, relationship traced through the male line [n]\n",
  "AGNISE": "to acknowledge, also AGNIZE [v AGNISED, AGNISING, AGNISES]\n",
  "AGNISED": "AGNISE, to acknowledge, also AGNIZE [v]\n",
  "AGNISES": "AGNISE, to acknowledge, also AGNIZE [v]\n",
  "AGNISING": "AGNISE, to acknowledge, also AGNIZE [v]\n",
  "AGNIZE": "to acknowledge, also AGNISE [v AGNIZED, AGNIZING, AGNIZES]\n",
  "AGNIZED": "AGNIZE, to acknowledge, also AGNISE [v]\n",
  "AGNIZES": "AGNIZE, to acknowledge, also AGNISE [v]\n",
  "AGNIZING": "AGNIZE, to acknowledge, also AGNISE [v]\n",
  "AGNOIOLOGIES": "AGNOIOLOGY, the science or study of ignorance [n]\n",
  "AGNOIOLOGY": "the science or study of ignorance [n AGNOIOLOGIES]\n",
  "AGNOLOTTI": "a dish of small pasta shaped like half moons and usually filled with tortellini stuffing: boiled and served in broth or with a sauce [n -S]\n",
  "AGNOLOTTIS": "AGNOLOTTI, a dish of small pasta shaped like half moons and usually filled with tortellini stuffing: boiled and served in broth or with a sauce [n]\n",
  "AGNOMEN": "(Latin) a name added to the family name, generally on account of some great exploit, as Africanus to Publius Cornelius Scipio [n AGNOMENS or AGNOMINA]\n",
  "AGNOMENS": "AGNOMEN, (Latin) a name added to the family name, generally on account of some great exploit, as Africanus to Publius Cornelius Scipio [n]\n",
  "AGNOMINA": "AGNOMEN, (Latin) a name added to the family name, generally on account of some great exploit, as Africanus to Publius Cornelius Scipio [n]\n",
  "AGNOMINAL": "relating to an agnomen, an additional name [adj]\n",
  "AGNOSIA": "the loss of the ability to recognize familiar objects [n -S]\n",
  "AGNOSIAS": "AGNOSIA, the loss of the ability to recognize familiar objects [n]\n",
  "AGNOSIC": "relating to agnosia, the loss of the ability to recognize familiar things or people [adj]\n",
  "AGNOSTIC": "sceptic, denying the possibility of knowledge [adj] / one who believes that existence of God cannot be known but does not deny the possibility that God exists [n -S]\n",
  "AGNOSTICISM": "the doctrine that we can know nothing beyond material phenomena [n -S]\n",
  "AGNOSTICISMS": "AGNOSTICISM, the doctrine that we can know nothing beyond material phenomena [n]\n",
  "AGNOSTICS": "AGNOSTIC, one who believes that existence of God cannot be known but does not deny the possibility that God exists [n]\n",
  "AGO": "in the past [adv]\n",
  "AGOG": "in excited eagerness [adv]\n",
  "AGOGE": "(Greek) in Greek music, tempo; sequence in melody [n -S]\n",
  "AGOGES": "AGOGE, (Greek) in Greek music, tempo; sequence in melody [n]\n",
  "AGOGIC": "accenting a note by dwelling on it [adj]\n",
  "AGOGICS": "the art of accenting a note by dwelling on it [n AGOGICS]\n",
  "AGOING": "(archaic) going [adv]\n",
  "AGON": "the dramatic conflict between the chief characters in a literary work [n AGONS or AGONES]\n",
  "AGONAL": "relating to agon, the dramatic conflict between the chief characters in a literary work [adj]\n",
  "AGONE": "(archaic) gone, past [adv]\n",
  "AGONES": "AGON, the dramatic conflict between the chief characters in a literary work [n]\n",
  "AGONIC": "making no angle [adj]\n",
  "AGONIES": "AGONY, extreme suffering [n]\n",
  "AGONISE": "to suffer agony, also AGONIZE [v AGONISED, AGONISING, AGONISES]\n",
  "AGONISED": "AGONISE, to suffer agony, also AGONIZE [v]\n",
  "AGONISEDLY": "AGONISED, AGONISE, to suffer agony, also AGONIZE [adv]\n",
  "AGONISES": "AGONISE, to suffer agony, also AGONIZE [v]\n",
  "AGONISING": "AGONISE, to suffer agony, also AGONIZE [v]\n",
  "AGONISINGLY": "AGONISING, AGONISE, to suffer agony, also AGONIZE [adv]\n",
  "AGONISM": "a contest or struggle [n -S]\n",
  "AGONISMS": "AGONISM, a contest or struggle [n]\n",
  "AGONIST": "a protagonist in a literary work [n -S]\n",
  "AGONISTES": "(Greek) one who is in the grip of inner conflict [n AGONISTES]\n",
  "AGONISTIC": "relating to or being aggressive or argumentative, also AGONISTICAL [adj AGONISTICALLY]\n",
  "AGONISTICAL": "relating to athletic contest, also AGONISTIC [adj AGONISTICALLY]\n",
  "AGONISTICALLY": "AGONISTICAL, relating to athletic contest, also AGONISTIC [adv]\n",
  "AGONISTICS": "(archaic) the art and theory of prizefighting [n]\n",
  "AGONISTS": "AGONIST, a protagonist in a literary work [n]\n",
  "AGONIZE": "to suffer agony, also AGONISE [v AGONIZED, AGONIZING, AGONIZES]\n",
  "AGONIZED": "AGONIZE, to suffer agony, also AGONISE [v]\n",
  "AGONIZEDLY": "AGONIZED, AGONIZE, to suffer agony, also AGONISE [adv]\n",
  "AGONIZES": "AGONIZE, to suffer agony, also AGONISE [v]\n",
  "AGONIZING": "AGONIZE, to suffer agony, also AGONISE [v]\n",
  "AGONIZINGLY": "AGONIZING, AGONIZE, to suffer agony, also AGONISE [adv]\n",
  "AGONOTHETES": "a judge or director of public games [n AGONOTHETES]\n",
  "AGONS": "AGON, the dramatic conflict between the chief characters in a literary work [n]\n",
  "AGONY": "extreme suffering [n AGONIES]\n",
  "AGOOD": "(Shakespeare) in good, in earnest [adv]\n",
  "AGORA": "a marketplace in ancient Greece [n AGORAS or AGORAE] / a monetary unit of Israel [n AGOROT or AGOROTH]\n",
  "AGORAE": "AGORA, a marketplace in ancient Greece [n]\n",
  "AGORAPHOBE": "one with a morbid fear of open spaces [n -S]\n",
  "AGORAPHOBES": "AGORAPHOBE, one with a morbid fear of open spaces [n]\n",
  "AGORAPHOBIA": "a morbid fear of open spaces [n -S]\n",
  "AGORAPHOBIAS": "AGORAPHOBIA, a morbid fear of open spaces [n]\n",
  "AGORAPHOBIC": "one with a morbid fear of open spaces [n -S]\n",
  "AGORAPHOBICS": "AGORAPHOBIC, one with a morbid fear of open spaces [n]\n",
  "AGORAS": "AGORA, a marketplace in ancient Greece [n]\n",
  "AGOROT": "AGORA, a marketplace in ancient Greece [n]\n",
  "AGOROTH": "AGORA, a marketplace in ancient Greece [n]\n",
  "AGOUTA": "a small insectivorous mammal, allied to the moles, found only in Haiti [n -S]\n",
  "AGOUTAS": "AGOUTA, a small insectivorous mammal, allied to the moles, found only in Haiti [n]\n",
  "AGOUTI": "a burrowing rodent, also ACOUCHI, ACOUCHY, AGOUTY, AGUTI [n -S]\n",
  "AGOUTIES": "AGOUTY, a burrowing rodent, also AGOUTI, ACOUCHI, ACOUCHY, AGUTI [n]\n",
  "AGOUTIS": "AGOUTI, a burrowing rodent, also ACOUCHI, ACOUCHY, AGOUTY, AGUTI [n]\n",
  "AGOUTY": "a burrowing rodent, also AGOUTI, ACOUCHI, ACOUCHY, AGUTI [n AGOUTIES]\n",
  "AGRAFE": "(French) a hooked clasp used by masons to hold blocks together, also AGRAFFE [n -S]\n",
  "AGRAFES": "AGRAFE, (French) a hooked clasp used by masons to hold blocks together, also AGRAFFE [n]\n",
  "AGRAFFE": "(French) a hooked clasp used by masons to hold blocks together, also AGRAFE [n -S]\n",
  "AGRAFFES": "AGRAFFE, (French) a hooked clasp used by masons to hold blocks together, also AGRAFE [n]\n",
  "AGRAMMATICAL": "not grammatical [adj]\n",
  "AGRANULOCYTE": "a blood disorder in which there is a marked decrease in granulocytes [n -S]\n",
  "AGRANULOCYTES": "AGRANULOCYTE, a blood disorder in which there is a marked decrease in granulocytes [n]\n",
  "AGRANULOCYTOSES": "AGRANULOCYTOSIS, a blood disorder in which there is a marked decrease in granulocytes, with lesions of the mucous membrane and skin [n]\n",
  "AGRANULOCYTOSIS": "a blood disorder in which there is a marked decrease in granulocytes, with lesions of the mucous membrane and skin [n AGRANULOCYTOSES]\n",
  "AGRANULOSES": "AGRANULOSIS, a blood disorder in which there is a marked decrease in granulocytes, with lesions of the mucous membrane and skin [n]\n",
  "AGRANULOSIS": "a blood disorder in which there is a marked decrease in granulocytes, with lesions of the mucous membrane and skin [n AGRANULOSES]\n",
  "AGRAPHA": "AGRAPHON, (Greek) a saying of Jesus not found in the canonical gospels [n]\n",
  "AGRAPHIA": "the inability to write [n -S]\n",
  "AGRAPHIAS": "AGRAPHIA, the inability to write [n]\n",
  "AGRAPHIC": "characterized by agraphia, the inability to write [adj]\n",
  "AGRAPHON": "(Greek) a saying of Jesus not found in the canonical gospels [n AGRAPHA]\n",
  "AGRARIAN": "related to land [adj] / one who favours equitable distribution of land [n -S]\n",
  "AGRARIANISM": "a social or political movement designed to improve the economic status of the farmer [n -S]\n",
  "AGRARIANISMS": "AGRARIANISM, a social or political movement designed to improve the economic status of the farmer [n]\n",
  "AGRARIANS": "AGRARIAN, one who favours equitable distribution of land [n]\n",
  "AGRASTE": "AGGRACE, (Spenser) to please, gratify, also AGGRATE [v]\n",
  "AGRAVIC": "relating to zero gravity [adj]\n",
  "AGREE": "to have the same opinion [v AGREED, AGREEING, AGREES]\n",
  "AGREEABILITIES": "AGREEABILITY, the quality of being agreeable [n]\n",
  "AGREEABILITY": "the quality of being agreeable [n AGREEABILITIES]\n",
  "AGREEABLE": "pleasant [adj]\n",
  "AGREEABLENESS": "the state of being agreeable [n -ES]\n",
  "AGREEABLENESSES": "AGREEABLENESS, the state of being agreeable [n]\n",
  "AGREEABLY": "AGREEABLE, pleasant [adv]\n",
  "AGREED": "AGREE, to have the same opinion [v]\n",
  "AGREEING": "AGREE, to have the same opinion [v]\n",
  "AGREEMENT": "concord, conformity [n -S]\n",
  "AGREEMENTS": "AGREEMENT, concord, conformity [n]\n",
  "AGREES": "AGREE, to have the same opinion [v]\n",
  "AGREGATION": "(French) the examination for post of agrege, a French student who has passed a teaching examination [n -S]\n",
  "AGREGATIONS": "AGREGATION, (French) the examination for post of agrege, a French student who has passed a teaching examination [n]\n",
  "AGREGE": "(French) a French student who has passed a teaching examination [n -S]\n",
  "AGREGES": "AGREGE, (French) a French student who has passed a teaching examination [n]\n",
  "AGREMENS": "(French) courtesies, blandishments [n]\n",
  "AGREMENT": "(French) the approval by a state of a diplomatic representative sent to it [n -S]\n",
  "AGREMENTS": "AGREMENT, (French) the approval by a state of a diplomatic representative sent to it [n]\n",
  "AGRESTAL": "growing wild in cultivated ground (esp. of weeds), also AGRESTIAL [adj]\n",
  "AGRESTIAL": "growing wild in cultivated ground (esp. of weeds), also AGRESTAL [adj]\n",
  "AGRESTIC": "of or relating to the fields or country, rustic, uncouth [adj]\n",
  "AGRIA": "a skin condition with extensive pus blisters [n -S]\n",
  "AGRIAS": "AGRIA, a skin condition with extensive pus blisters [n]\n",
  "AGRIBUSINESS": "an industry engaged in operations associated with farming, also AGROBUSINESS [n -ES]\n",
  "AGRIBUSINESSES": "AGRIBUSINESS, an industry engaged in operations associated with farming, also AGROBUSINESS [n]\n",
  "AGRIBUSINESSMAN": "a person who works in or manages an agribusiness [n AGRIBUSINESSMEN]\n",
  "AGRIBUSINESSMEN": "AGRIBUSINESSMAN, a person who works in or manages an agribusiness [n]\n",
  "AGRICHEMICAL": "a chemical intended for agricultural use, also AGROCHEMICAL [n -S]\n",
  "AGRICHEMICALS": "AGRICHEMICAL, a chemical intended for agricultural use, also AGROCHEMICAL [n]\n",
  "AGRICULTURAL": "of, relating to, used in, or concerned with agriculture [adj]\n",
  "AGRICULTURALIST": "someone skilled in agriculture, a farmer, also AGRICULTURIST [n]\n",
  "AGRICULTURALLY": "AGRICULTURAL, of, relating to, used in, or concerned with agriculture [adv]\n",
  "AGRICULTURE": "the science or practice of operations associated with farming [n -S]\n",
  "AGRICULTURES": "AGRICULTURE, the science or practice of operations associated with farming [n]\n",
  "AGRICULTURIST": "someone skilled in agriculture, a farmer, also AGRICULTURALIST [n -S]\n",
  "AGRICULTURISTS": "AGRICULTURIST, someone skilled in agriculture, a farmer, also AGRICULTURALIST [n]\n",
  "AGRIFOODSTUFFS": "the foods produced by agriculture [n]\n",
  "AGRIMONIES": "AGRIMONY, a perennial herb of the rose family [n]\n",
  "AGRIMONY": "a perennial herb of the rose family [n AGRIMONIES]\n",
  "AGRIN": "a proteoglycan that plays a role in the development of the neuromuscular junction [n -S]\n",
  "AGRINS": "AGRIN, a proteoglycan that plays a role in the development of the neuromuscular junction [n]\n",
  "AGRIOLOGIES": "AGRIOLOGY, the comparative study of primitive peoples [n]\n",
  "AGRIOLOGY": "the comparative study of primitive peoples [n AGRIOLOGIES]\n",
  "AGRIPRODUCT": "a commodity for the use of farmers, e.g. fertilizer or animal feed [n -S]\n",
  "AGRIPRODUCTS": "AGRIPRODUCT, a commodity for the use of farmers, e.g. fertilizer or animal feed [n]\n",
  "AGRISE": "to terrify, also AGRIZE, AGRYZE [v AGRISED, AGRISING, AGRISES]\n",
  "AGRISED": "AGRISE, to terrify, also AGRIZE, AGRYZE [v]\n",
  "AGRISES": "AGRISE, to terrify, also AGRIZE, AGRYZE [v]\n",
  "AGRISING": "AGRISE, to terrify, also AGRIZE, AGRYZE [v]\n",
  "AGRITOURISM": "the business of providing holidays in an agricultural setting, also AGROTOURISM [n -S]\n",
  "AGRITOURISMS": "AGRITOURISM, the business of providing holidays in an agricultural setting, also AGROTOURISM [n]\n",
  "AGRITOURIST": "one who engages in agritourism, the business of providing holidays in an agricultural setting [n -S]\n",
  "AGRITOURISTS": "AGRITOURIST, one who engages in agritourism, the business of providing holidays in an agricultural setting [n]\n",
  "AGRIZE": "(obsolete) to terrify, also AGRISE, AGRYZE [v AGRIZED, AGRIZING, AGRIZES]\n",
  "AGRIZED": "AGRIZE, (obsolete) to terrify, also AGRISE, AGRYZE [v]\n",
  "AGRIZES": "AGRIZE, (obsolete) to terrify, also AGRISE, AGRYZE [v]\n",
  "AGRIZING": "AGRIZE, (obsolete) to terrify, also AGRISE, AGRYZE [v]\n",
  "AGRO": "a student of agricultural studies [n -S]\n",
  "AGROBIOLOGICAL": "relating to agrobiology, the study of plant nutrition and soil yields [adj]\n",
  "AGROBIOLOGIES": "AGROBIOLOGY, the study of plant nutrition and soil yields [n]\n",
  "AGROBIOLOGIST": "one who studies plant nutrition and soil yields [n -S]\n",
  "AGROBIOLOGISTS": "AGROBIOLOGIST, one who studies plant nutrition and soil yields [n]\n",
  "AGROBIOLOGY": "the study of plant nutrition and soil yields [n AGROBIOLOGIES]\n",
  "AGROBUSINESS": "the business of agriculture, also AGRIBUSINESS [n -ES]\n",
  "AGROBUSINESSES": "AGROBUSINESS, the business of agriculture, also AGRIBUSINESS [n]\n",
  "AGROCHEMICAL": "a chemical intended for agricultural use, also AGRICHEMICAL [n -S]\n",
  "AGROCHEMICALS": "AGROCHEMICAL, a chemical intended for agricultural use, also AGRICHEMICAL [n]\n",
  "AGRODOLCE": "(Italian) an Italian sweet-and-sour sauce [n -S]\n",
  "AGRODOLCES": "AGRODOLCE, (Italian) an Italian sweet-and-sour sauce [n]\n",
  "AGROFORESTER": "one who practices agroforestry [n -S]\n",
  "AGROFORESTERS": "AGROFORESTER, one who practices agroforestry [n]\n",
  "AGROFORESTRIES": "AGROFORESTRY, land management involving the growing of trees in association with food crops or pastures [n]\n",
  "AGROFORESTRY": "land management involving the growing of trees in association with food crops or pastures [n AGROFORESTRIES]\n",
  "AGROINDUSTRIAL": "relating to agroindustry [adj]\n",
  "AGROINDUSTRIES": "AGROINDUSTRY, the agricultural industry [n]\n",
  "AGROINDUSTRY": "the agricultural industry [n AGROINDUSTRIES]\n",
  "AGROLOGIC": "relating to agrology, the study of agricultural soils [adj]\n",
  "AGROLOGICAL": "relating to agrology, the study of agricultural soils [adj]\n",
  "AGROLOGIES": "AGROLOGY, the science of soils in relation to crops [n]\n",
  "AGROLOGIST": "a student of agrology, the study of agricultural soils [n -S]\n",
  "AGROLOGISTS": "AGROLOGIST, a student of agrology, the study of agricultural soils [n]\n",
  "AGROLOGY": "the science of soils in relation to crops [n AGROLOGIES]\n",
  "AGRONOMIAL": "relating to agronomy, scientific agriculture [adj]\n",
  "AGRONOMIC": "relating to agronomy, scientific agriculture [adj AGRONOMICALLY]\n",
  "AGRONOMICAL": "relating to agronomy, scientific agriculture [adj AGRONOMICALLY]\n",
  "AGRONOMICALLY": "AGRONOMICAL, relating to agronomy, scientific agriculture [adv]\n",
  "AGRONOMICS": "the science dealing with the management and productivity of land [n]\n",
  "AGRONOMIES": "AGRONOMY, rural economy [n]\n",
  "AGRONOMIST": "one versed in agronomy; a student of agronomy [n -S]\n",
  "AGRONOMISTS": "AGRONOMIST, one versed in agronomy; a student of agronomy [n]\n",
  "AGRONOMY": "rural economy [n AGRONOMIES]\n",
  "AGROS": "AGRO, a student of agricultural studies [n]\n",
  "AGROSTEMMA": "a European caryophyllaceous plant, aka corncockle [n AGROSTEMMAS or AGROSTEMMATA]\n",
  "AGROSTEMMAS": "AGROSTEMMA, a European caryophyllaceous plant, aka corncockle [n]\n",
  "AGROSTEMMATA": "AGROSTEMMA, a European caryophyllaceous plant, aka corncockle [n]\n",
  "AGROSTOLOGIC": "relating to agrostology [adj]\n",
  "AGROSTOLOGICAL": "relating to agrostology, the science or study of grasses [adj]\n",
  "AGROSTOLOGIES": "AGROSTOLOGY, the science or study of grasses [n]\n",
  "AGROSTOLOGIST": "one who studies grasses [n -S]\n",
  "AGROSTOLOGISTS": "AGROSTOLOGIST, one who studies grasses [n]\n",
  "AGROSTOLOGY": "the science or study of grasses [n AGROSTOLOGIES]\n",
  "AGROTERRORISM": "terrorism aimed at a country's agriculture [n -S]\n",
  "AGROTERRORISMS": "AGROTERRORISM, terrorism aimed at a country's agriculture [n]\n",
  "AGROTOURISM": "the business of providing holidays in an agricultural setting, also AGRITOURISM [n -S]\n",
  "AGROTOURISMS": "AGROTOURISM, the business of providing holidays in an agricultural setting, also AGRITOURISM [n]\n",
  "AGROTOURIST": "one who engages in agrotourism, the business of providing holidays in an agricultural setting [n -S]\n",
  "AGROTOURISTS": "AGROTOURIST, one who engages in agrotourism, the business of providing holidays in an agricultural setting [n]\n",
  "AGROUND": "on the ground [adv]\n",
  "AGRYPNIA": "wakefulness; sleeplessness [n -S]\n",
  "AGRYPNIAS": "AGRYPNIA, wakefulness; sleeplessness [n]\n",
  "AGRYPNOTIC": "a drug or agent that reduces insomnia [n -S]\n",
  "AGRYPNOTICS": "AGRYPNOTIC, a drug or agent that reduces insomnia [n]\n",
  "AGRYZE": "(obsolete) to terrify, also AGRISE, AGRIZE [v AGRYZED, AGRYZING, AGRYZES]\n",
  "AGRYZED": "AGRYZE, (obsolete) to terrify, also AGRISE, AGRIZE [v]\n",
  "AGRYZES": "AGRYZE, (obsolete) to terrify, also AGRISE, AGRIZE [v]\n",
  "AGRYZING": "AGRYZE, (obsolete) to terrify, also AGRISE, AGRIZE [v]\n",
  "AGS": "AG, (short for) agriculture [n]\n",
  "AGTERSKOT": "(South African) the final payment to a farmer for crops [n -S]\n",
  "AGTERSKOTS": "AGTERSKOT, (South African) the final payment to a farmer for crops [n]\n",
  "AGUACATE": "(Nahuatl) the avocado pear [n -S]\n",
  "AGUACATES": "AGUACATE, (Nahuatl) the avocado pear [n]\n",
  "AGUARDIENTE": "(Spanish) a kind of Spanish or Portuguese brandy [n -S]\n",
  "AGUARDIENTES": "AGUARDIENTE, (Spanish) a kind of Spanish or Portuguese brandy [n]\n",
  "AGUE": "a malarial fever [n -S]\n",
  "AGUED": "suffering from the ague, a malarial fever [adj]\n",
  "AGUELIKE": "like a fever [adj]\n",
  "AGUES": "AGUE, a malarial fever [n]\n",
  "AGUEWEED": "a North American plant of the gentian family, having clusters of pale blue-violet or white flowers [n -S]\n",
  "AGUEWEEDS": "AGUEWEED, a North American plant of the gentian family, having clusters of pale blue-violet or white flowers [n]\n",
  "AGUISE": "(Spenser) to adorn, also AGUIZE [v AGUISED, AGUISING, AGUISES]\n",
  "AGUISED": "AGUISE, (Spenser) to adorn, also AGUIZE [v]\n",
  "AGUISES": "AGUISE, (Spenser) to adorn, also AGUIZE [v]\n",
  "AGUISH": "having the qualities of an ague; feverish [adj]\n",
  "AGUISHLY": "AGUISH, having the qualities of an ague; feverish [adv]\n",
  "AGUISING": "AGUISE, (Spenser) to adorn, also AGUIZE [v]\n",
  "AGUIZE": "(Spenser) to adorn, also AGUISE [v AGUIZED, AGUIZING, AGUIZES]\n",
  "AGUIZED": "AGUIZE, (Spenser) to adorn, also AGUISE [v]\n",
  "AGUIZES": "AGUIZE, (Spenser) to adorn, also AGUISE [v]\n",
  "AGUIZING": "AGUIZE, (Spenser) to adorn, also AGUISE [v]\n",
  "AGUNA": "(Hebrew) a woman whose husband has abandoned her but fails to provide an official divorce, also AGUNAH [n AGUNOT, AGUNOTH]\n",
  "AGUNAH": "(Hebrew) a woman whose husband has abandoned her but fails to provide an official divorce, also AGUNA [n AGUNOT]\n",
  "AGUNOT": "AGUNA, (Hebrew) a woman whose husband has abandoned her but fails to provide an official divorce, also AGUNAH [n]\n",
  "AGUNOTH": "AGUNA, (Hebrew) a woman whose husband has abandoned her but fails to provide an official divorce, also AGUNAH [n]\n",
  "AGUTI": "a burrowing South American rodent, also AGOUTI, ACOUCHI, ACOUCHY, AGOUTY [n -S]\n",
  "AGUTIS": "AGUTI, a burrowing South American rodent, also AGOUTI, ACOUCHI, ACOUCHY, AGOUTY [n]\n",
  "AGYRIA": "a disease of the brain [n -S]\n",
  "AGYRIAS": "AGYRIA, a disease of the brain [n]\n",
  "AH": "an interjection expressing surprise, joy etc. [interj] / to say ah [v -ED, -ING, -S]\n",
  "AHA": "an interjection expressing exultation [interj]\n",
  "AHCHOO": "expressing a sneeze [interj]\n",
  "AHEAD": "further on [adv]\n",
  "AHEAP": "(obsolete) in a heap; huddled together [adv]\n",
  "AHED": "AH, to say ah [v]\n",
  "AHEIGHT": "(archaic) aloft; on high [adv]\n",
  "AHEM": "a sound expressing delicate interruption [interj]\n",
  "AHEMERAL": "not being a full 24 hour day [adj]\n",
  "AHENT": "(dialect) behind, also AHINT, AHIND [adv]\n",
  "AHI": "(Hawaiian) a fish (yellowfin tuna or bigeye) [n -S]\n",
  "AHIGH": "(obsolete) on high [adv]\n",
  "AHIMSA": "(Sanskrit) in Hindu philosophy, the principle of noninjury to living beings [n -S]\n",
  "AHIMSAS": "AHIMSA, (Sanskrit) in Hindu philosophy, the principle of noninjury to living beings [n]\n",
  "AHIND": "(dialect) behind, also AHINT, AHENT [adv]\n",
  "AHING": "AH, to say ah [v]\n",
  "AHINT": "(dialect) behind, also AHENT, AHIND [adv]\n",
  "AHIS": "AHI, (Hawaiian) a fish (yellowfin tuna or bigeye) [n]\n",
  "AHISTORIC": "not historical, also AHISTORICAL [adj]\n",
  "AHISTORICAL": "not historical, also AHISTORIC [adj]\n",
  "AHOLD": "(obsolete) near the wind; as, to lay a ship ahold, also AHOLDS [adv]\n",
  "AHOLDS": "near the wind; as, to lay a ship aholds, also AHOLD [adv]\n",
  "AHORSE": "(archaic) on horseback, also AHORSEBACK [adv]\n",
  "AHORSEBACK": "(archaic) on horseback, also AHORSE [adv]\n",
  "AHOY": "an interjection used to hail another vessel [interj]\n",
  "AHS": "AH, to say ah [v]\n",
  "AHULL": "with sails furled, and helm lashed to the lee side [adv]\n",
  "AHUNGERED": "(archaic) oppressed with hunger, also AHUNGRY, ANHUNGERED, ANHUNGRED [adj]\n",
  "AHUNGRY": "(archaic) oppressed with hunger, also AHUNGERED, ANHUNGERED, ANHUNGRED [adj]\n",
  "AHURU": "(Maori) a small pink cod of SW Pacific waters, also AHURUHURU [n -S]\n",
  "AHURUHURU": "(Maori) a small pink cod of SW Pacific waters, also AHURU [n -S]\n",
  "AHURUHURUS": "AHURUHURU, (Maori) a small pink cod of SW Pacific waters, also AHURU [n]\n",
  "AHURUS": "AHURU, (Maori) a small pink cod of SW Pacific waters, also AHURUHURU [n]\n",
  "AI": "(Tupi) a three-toed sloth [n -S]\n",
  "AIA": "in India, a maid or nurse, also AYAH [n -S]\n",
  "AIAS": "AIA, in India, a maid or nurse, also AYAH [n]\n",
  "AIBLINS": "(dialect) perhaps, also ABLINS, ABLINGS [adv]\n",
  "AICHMOPHOBIA": "an irrational fear of sharp or pointed objects [n -S]\n",
  "AICHMOPHOBIAS": "AICHMOPHOBIA, an irrational fear of sharp or pointed objects [n]\n",
  "AID": "to help [v -ED, -ING, -S]\n",
  "AIDA": "a finely-meshed cotton fabric used for cross-stitch embroidery [n -S]\n",
  "AIDANCE": "help [n -S]\n",
  "AIDANCES": "AIDANCE, help [n]\n",
  "AIDANT": "(archaic) a helper [n -S]\n",
  "AIDANTS": "AIDANT, (archaic) a helper [n]\n",
  "AIDAS": "AIDA, a finely-meshed cotton fabric used for cross-stitch embroidery [n]\n",
  "AIDE": "(French) a confidential assistant to a person of senior rank [n -S]\n",
  "AIDED": "AID, to help [v]\n",
  "AIDER": "one who aids [n -S]\n",
  "AIDERS": "AIDER, one who aids [n]\n",
  "AIDES": "AIDE, (French) a confidential assistant to a person of senior rank [n]\n",
  "AIDFUL": "helpful [adj]\n",
  "AIDING": "AID, to help [v]\n",
  "AIDLESS": "helpless; without aid [adj]\n",
  "AIDMAN": "a corpsman [n AIDMEN]\n",
  "AIDMEN": "AIDMAN, a corpsman [n]\n",
  "AIDOI": "AIDOS, (Greek) shame, modesty [n]\n",
  "AIDOS": "(Greek) shame, modesty [n AIDOI]\n",
  "AIDS": "AID, to help [v]\n",
  "AIERIES": "AIERY, the nest of a bird of prey, also EYRIE, AERIE, AERY, AYRIE [n]\n",
  "AIERY": "the nest of a bird of prey, also EYRIE, AERIE, AERY, AYRIE [n AIERIES]\n",
  "AIGA": "(Samoan) a large family, often spanning several generations, also AINGA [n -S]\n",
  "AIGAS": "AIGA, (Samoan) a large family, often spanning several generations, also AINGA [n]\n",
  "AIGHT": "an informal or dialect word for all right [interj]\n",
  "AIGLET": "a metal sheath at the end of a lace, also AGLET [n -S]\n",
  "AIGLETS": "AIGLET, a metal sheath at the end of a lace, also AGLET [n]\n",
  "AIGRET": "(French) a tuft of feathers worn as a head ornament, also AIGRETTE [n -S]\n",
  "AIGRETS": "AIGRET, (French) a tuft of feathers worn as a head ornament, also AIGRETTE [n]\n",
  "AIGRETTE": "(French) a tuft of feathers worn as a head ornament, also AIGRET [n -S]\n",
  "AIGRETTES": "AIGRETTE, (French) a tuft of feathers worn as a head ornament, also AIGRET [n]\n",
  "AIGUILLE": "(French) a needlelike peak of rock [n -S]\n",
  "AIGUILLES": "AIGUILLE, (French) a needlelike peak of rock [n]\n",
  "AIGUILLETTE": "(French) the tag covering the ends of a lace, also AGLET, AIGLET [n -S]\n",
  "AIGUILLETTES": "AIGUILLETTE, (French) the tag covering the ends of a lace, also AGLET, AIGLET [n]\n",
  "AIKIDO": "(Japanese) a type of martial art [n -S]\n",
  "AIKIDOS": "AIKIDO, (Japanese) a type of martial art [n]\n",
  "AIKONA": "(Bantu) it is not [interj]\n",
  "AIL": "to be indisposed [v -ED, -ING, -S]\n",
  "AILANTHIC": "of or like the ailanthus tree [adj]\n",
  "AILANTHUS": "(Amboina) an oriental tree, the tree of heaven, also AILANTO [n -ES]\n",
  "AILANTHUSES": "AILANTHUS, (Amboina) an oriental tree, the tree of heaven, also AILANTO [n]\n",
  "AILANTO": "(Amboina) an oriental tree, the tree of heaven, also AILANTHUS [n -S]\n",
  "AILANTOS": "AILANTO, (Amboina) an oriental tree, the tree of heaven, also AILANTHUS [n]\n",
  "AILED": "AIL, to be indisposed [v]\n",
  "AILERON": "(French) a balancing flap on an aeroplane [n -S]\n",
  "AILERONS": "AILERON, (French) a balancing flap on an aeroplane [n]\n",
  "AILETTE": "(French) a plate of armour for the shoulder [n -S]\n",
  "AILETTES": "AILETTE, (French) a plate of armour for the shoulder [n]\n",
  "AILING": "AIL, to be indisposed [v]\n",
  "AILMENT": "a physical or mental disorder [n -S]\n",
  "AILMENTS": "AILMENT, a physical or mental disorder [n]\n",
  "AILOUROPHILE": "a cat-lover, also AILUROPHILE [n -S]\n",
  "AILOUROPHILES": "AILOUROPHILE, a cat-lover, also AILUROPHILE [n]\n",
  "AILOUROPHILIA": "the love of cats, also AILUROPHILIA [n -S]\n",
  "AILOUROPHILIAS": "AILOUROPHILIA, the love of cats, also AILUROPHILIA [n]\n",
  "AILOUROPHILIC": "loving cats, also AILUROPHILIC [adj]\n",
  "AILOUROPHOBE": "one with a morbid fear of cats [n -S]\n",
  "AILOUROPHOBES": "AILOUROPHOBE, one with a morbid fear of cats [n]\n",
  "AILOUROPHOBIA": "fear of cats [n -S]\n",
  "AILOUROPHOBIAS": "AILOUROPHOBIA, fear of cats [n]\n",
  "AILOUROPHOBIC": "having a morbid fear of cats [adj]\n",
  "AILS": "AIL, to be indisposed [v]\n",
  "AILUROPHILE": "a cat-lover, also AILOUROPHILE [n -S]\n",
  "AILUROPHILES": "AILUROPHILE, a cat-lover, also AILOUROPHILE [n]\n",
  "AILUROPHILIA": "the love of cats, also AILOUROPHILIA [n -S]\n",
  "AILUROPHILIAS": "AILUROPHILIA, the love of cats, also AILOUROPHILIA [n]\n",
  "AILUROPHILIC": "loving cats, also AILOUROPHILIC [adj]\n",
  "AILUROPHOBE": "a person with a morbid fear of cats [n -S]\n",
  "AILUROPHOBES": "AILUROPHOBE, a person with a morbid fear of cats [n]\n",
  "AILUROPHOBIA": "fear of cats [n -S]\n",
  "AILUROPHOBIAS": "AILUROPHOBIA, fear of cats [n]\n",
  "AILUROPHOBIC": "having a morbid fear of cats [adj]\n",
  "AIM": "to direct a course [v -ED, -ING, -S]\n",
  "AIMED": "AIM, to direct a course [v]\n",
  "AIMER": "one who aims [n -S]\n",
  "AIMERS": "AIMER, one who aims [n]\n",
  "AIMFUL": "full of purpose [adj]\n",
  "AIMFULLY": "full of purpose [adv]\n",
  "AIMING": "AIM, to direct a course [v]\n",
  "AIMLESS": "without aim [adj]\n",
  "AIMLESSLY": "AIMLESS, without aim [adv]\n",
  "AIMLESSNESS": "the quality of being aimless [n -ES]\n",
  "AIMLESSNESSES": "AIMLESSNESS, the quality of being aimless [n]\n",
  "AIMS": "AIM, to direct a course [v]\n",
  "AIN": "a Hebrew letter [n -S]\n",
  "AINE": "(French) (of a male) elder, senior [adj]\n",
  "AINEE": "(French) (of a female) elder, senior [adj]\n",
  "AINGA": "(Samoan) a large family, often spanning several generations, also AIGA [n -S]\n",
  "AINGAS": "AINGA, (Samoan) a large family, often spanning several generations, also AIGA [n]\n",
  "AINS": "AIN, a Hebrew letter [n]\n",
  "AINSELL": "one's own self, also NAINSELL [n -S]\n",
  "AINSELLS": "AINSELL, one's own self, also NAINSELL [n]\n",
  "AIOLI": "(French) a garlic-flavoured mayonnaise [n -S]\n",
  "AIOLIS": "AIOLI, (French) a garlic-flavoured mayonnaise [n]\n",
  "AIR": "the mixture of gases breathed by people and animals, also AYRE [n -S] / to make known publicly [v -ED, -ING, -S]\n",
  "AIRBAG": "an inflatable safety device in an automobile [n -S]\n",
  "AIRBAGS": "AIRBAG, an inflatable safety device in an automobile [n]\n",
  "AIRBALL": "in basketball, to make a shot that completely fails to touch the target [v -ED, -ING, -S]\n",
  "AIRBALLED": "AIRBALL, in basketball, to make a shot that completely fails to touch the target [v]\n",
  "AIRBALLING": "AIRBALL, in basketball, to make a shot that completely fails to touch the target [v]\n",
  "AIRBALLS": "AIRBALL, in basketball, to make a shot that completely fails to touch the target [v]\n",
  "AIRBASE": "a centre for controlling aircraft [n -S]\n",
  "AIRBASES": "AIRBASE, a centre for controlling aircraft [n]\n",
  "AIRBOARD": "an inflatable board that is used in the sport of airboarding [n -S]\n",
  "AIRBOARDING": "the sport of riding an airboard [n -S]\n",
  "AIRBOARDINGS": "AIRBOARDING, the sport of riding an airboard [n]\n",
  "AIRBOARDS": "AIRBOARD, an inflatable board that is used in the sport of airboarding [n]\n",
  "AIRBOAT": "a kind of boat driven by an aircraft propeller [n -S]\n",
  "AIRBOATS": "AIRBOAT, a kind of boat driven by an aircraft propeller [n]\n",
  "AIRBORNE": "carried by air [adj]\n",
  "AIRBOUND": "stopped up by air [adj]\n",
  "AIRBRICK": "a brick with holes in it, put into the walls of a building for ventilation [n -S]\n",
  "AIRBRICKS": "AIRBRICK, a brick with holes in it, put into the walls of a building for ventilation [n]\n",
  "AIRBRUSH": "to apply a fine spray by compressed air [v -ED, -ING, -ES]\n",
  "AIRBRUSHED": "AIRBRUSH, to apply a fine spray by compressed air [v]\n",
  "AIRBRUSHES": "AIRBRUSH, to apply a fine spray by compressed air [v]\n",
  "AIRBRUSHING": "AIRBRUSH, to apply a fine spray by compressed air [v]\n",
  "AIRBURST": "to explode in the air [v -ED, -ING, -S]\n",
  "AIRBURSTED": "AIRBURST, to explode in the air [v]\n",
  "AIRBURSTING": "AIRBURST, to explode in the air [v]\n",
  "AIRBURSTS": "AIRBURST, to explode in the air [v]\n",
  "AIRBUS": "(tradename) an aeroplane that provides the equivalent of a bus service, also AEROBUS [n AIRBUSES or AIRBUSSES]\n",
  "AIRBUSES": "AIRBUS, (tradename) an aeroplane that provides the equivalent of a bus service, also AEROBUS [n]\n",
  "AIRBUSSES": "AIRBUS, (tradename) an aeroplane that provides the equivalent of a bus service, also AEROBUS [n]\n",
  "AIRCHECK": "a recording made from a radio broadcast [n -S]\n",
  "AIRCHECKS": "AIRCHECK, a recording made from a radio broadcast [n]\n",
  "AIRCOACH": "the cheaper accommodation in commercial aircraft [n -ES]\n",
  "AIRCOACHES": "AIRCOACH, the cheaper accommodation in commercial aircraft [n]\n",
  "AIRCON": "an air conditioner [n -S]\n",
  "AIRCONS": "AIRCON, an air conditioner [n]\n",
  "AIRCRAFT": "a machine for travelling in the air [n AIRCRAFT]\n",
  "AIRCRAFTMAN": "a member of the lowest (male) rank in the RAF, also AIRCRAFTSMAN [n AIRCRAFTMEN]\n",
  "AIRCRAFTMEN": "AIRCRAFTMAN, a member of the lowest (male) rank in the RAF, also AIRCRAFTSMAN [n]\n",
  "AIRCRAFTSMAN": "a member of the lowest (male) rank in the RAF, also AIRCRAFTMAN [n AIRCRAFTSMEN]\n",
  "AIRCRAFTSMEN": "AIRCRAFTSMAN, a member of the lowest (male) rank in the RAF, also AIRCRAFTMAN [n]\n",
  "AIRCRAFTSWOMAN": "a member of the lowest (female) rank in the RAF, also AIRCRAFTWOMAN [n AIRCRAFTSWOMEN]\n",
  "AIRCRAFTSWOMEN": "AIRCRAFTSWOMAN, a member of the lowest (female) rank in the RAF, also AIRCRAFTWOMAN [n]\n",
  "AIRCRAFTWOMAN": "a member of the lowest (female) rank in the RAF, also AIRCRAFTSWOMAN [n AIRCRAFTWOMEN]\n",
  "AIRCRAFTWOMEN": "AIRCRAFTWOMAN, a member of the lowest (female) rank in the RAF, also AIRCRAFTSWOMAN [n]\n",
  "AIRCREW": "the crew of an aircraft [n -S]\n",
  "AIRCREWS": "AIRCREW, the crew of an aircraft [n]\n",
  "AIRDATE": "the scheduled date of a broadcast [n -S]\n",
  "AIRDATES": "AIRDATE, the scheduled date of a broadcast [n]\n",
  "AIRDRAWN": "drawn in the air; visionary [adj]\n",
  "AIRDROME": "an aerodrome [n -S]\n",
  "AIRDROMES": "AIRDROME, an aerodrome [n]\n",
  "AIRDROP": "to drop from an aircraft [v AIRDROPPED, AIRDROPPING, AIRDROPS]\n",
  "AIRDROPPED": "AIRDROP, to drop from an aircraft [v]\n",
  "AIRDROPPING": "AIRDROP, to drop from an aircraft [v]\n",
  "AIRDROPS": "AIRDROP, to drop from an aircraft [v]\n",
  "AIRED": "AIR, to make known publicly [v]\n",
  "AIRER": "a frame on which to dry clothes [n -S]\n",
  "AIRERS": "AIRER, a frame on which to dry clothes [n]\n",
  "AIREST": "(Scots) earliest [adj]\n",
  "AIRFARE": "the price of a journey on a plane [n -S]\n",
  "AIRFARES": "AIRFARE, the price of a journey on a plane [n]\n",
  "AIRFIELD": "an area where planes take off and land [n -S]\n",
  "AIRFIELDS": "AIRFIELD, an area where planes take off and land [n]\n",
  "AIRFLOW": "a flow of air past a moving vehicle [n -S]\n",
  "AIRFLOWS": "AIRFLOW, a flow of air past a moving vehicle [n]\n",
  "AIRFOIL": "part of an aircraft providing lift or control [n -S]\n",
  "AIRFOILS": "AIRFOIL, part of an aircraft providing lift or control [n]\n",
  "AIRFRAME": "the body of an aircraft as opposed to its engine [n -S]\n",
  "AIRFRAMES": "AIRFRAME, the body of an aircraft as opposed to its engine [n]\n",
  "AIRFREIGHT": "to transport freight by air in volume [v -ED, -ING, -S]\n",
  "AIRFREIGHTED": "AIRFREIGHT, to transport freight by air in volume [v]\n",
  "AIRFREIGHTING": "AIRFREIGHT, to transport freight by air in volume [v]\n",
  "AIRFREIGHTS": "AIRFREIGHT, to transport freight by air in volume [v]\n",
  "AIRGAP": "a gap in a magnetic circuit [n -S]\n",
  "AIRGAPS": "AIRGAP, a gap in a magnetic circuit [n]\n",
  "AIRGLOW": "a faint light in the night sky, produced by radiation from the upper atmosphere [n -S]\n",
  "AIRGLOWS": "AIRGLOW, a faint light in the night sky, produced by radiation from the upper atmosphere [n]\n",
  "AIRGRAPH": "a letter photographically reduced for sending by air [n -S]\n",
  "AIRGRAPHS": "AIRGRAPH, a letter photographically reduced for sending by air [n]\n",
  "AIRGUN": "a gun that discharges missiles by means of compressed air [n -S]\n",
  "AIRGUNS": "AIRGUN, a gun that discharges missiles by means of compressed air [n]\n",
  "AIRHEAD": "an empty-headed, superficial person [n -S]\n",
  "AIRHEADED": "like an airhead [adj]\n",
  "AIRHEADS": "AIRHEAD, an empty-headed, superficial person [n]\n",
  "AIRHOLE": "a hole for the passage of air [n -S]\n",
  "AIRHOLES": "AIRHOLE, a hole for the passage of air [n]\n",
  "AIRIER": "AIRY, relating to air [adj]\n",
  "AIRIEST": "AIRY, relating to air [adj]\n",
  "AIRILY": "AIRY, relating to air [adv]\n",
  "AIRINESS": "the state of being airy [n -ES]\n",
  "AIRINESSES": "AIRINESS, the state of being airy [n]\n",
  "AIRING": "an exposure to the air [n -S]\n",
  "AIRINGS": "AIRING, an exposure to the air [n]\n",
  "AIRLESS": "having no air [adj]\n",
  "AIRLESSNESS": "the quality of being airless [n -ES]\n",
  "AIRLESSNESSES": "AIRLESSNESS, the quality of being airless [n]\n",
  "AIRLIFT": "to transport by air [v -ED, -ING, -S]\n",
  "AIRLIFTED": "AIRLIFT, to transport by air [v]\n",
  "AIRLIFTING": "AIRLIFT, to transport by air [v]\n",
  "AIRLIFTS": "AIRLIFT, to transport by air [v]\n",
  "AIRLIKE": "resembling air [adj]\n",
  "AIRLINE": "an air transportation system [n -S]\n",
  "AIRLINER": "a large passenger aircraft [n -S]\n",
  "AIRLINERS": "AIRLINER, a large passenger aircraft [n]\n",
  "AIRLINES": "AIRLINE, an air transportation system [n]\n",
  "AIRLOCK": "an obstructing bubble in a pipe [n -S]\n",
  "AIRLOCKS": "AIRLOCK, an obstructing bubble in a pipe [n]\n",
  "AIRMAIL": "to send mail by airplane [v -ED, -ING, -S]\n",
  "AIRMAILED": "AIRMAIL, to send mail by airplane [v]\n",
  "AIRMAILING": "AIRMAIL, to send mail by airplane [v]\n",
  "AIRMAILS": "AIRMAIL, to send mail by airplane [v]\n",
  "AIRMAN": "an aviator [n AIRMEN]\n",
  "AIRMANSHIP": "skill in piloting or navigating aircraft [n -S]\n",
  "AIRMANSHIPS": "AIRMANSHIP, skill in piloting or navigating aircraft [n]\n",
  "AIRMEN": "AIRMAN, an aviator [n]\n",
  "AIRMOBILE": "relating to a military unit whose members are transported by air [adj]\n",
  "AIRN": "(Scots) iron [n -S] / to iron [v -ED, -ING, -S]\n",
  "AIRNED": "AIRN, to iron [v]\n",
  "AIRNING": "AIRN, to iron [v]\n",
  "AIRNS": "AIRN, to iron [v]\n",
  "AIRPARK": "a small airport [n -S]\n",
  "AIRPARKS": "AIRPARK, a small airport [n]\n",
  "AIRPLANE": "a winged aircraft propelled by jet engines or propellers [n -S]\n",
  "AIRPLANES": "AIRPLANE, a winged aircraft propelled by jet engines or propellers [n]\n",
  "AIRPLAY": "the broadcasting of a play etc. on a radio program [n -S]\n",
  "AIRPLAYS": "AIRPLAY, the broadcasting of a play etc. on a radio program [n]\n",
  "AIRPORT": "a tract of land maintained for the landing and takeoff of aircraft [n -S]\n",
  "AIRPORTS": "AIRPORT, a tract of land maintained for the landing and takeoff of aircraft [n]\n",
  "AIRPOST": "the system of conveying mail by air [n -S]\n",
  "AIRPOSTS": "AIRPOST, the system of conveying mail by air [n]\n",
  "AIRPOWER": "military air strength [n -S]\n",
  "AIRPOWERS": "AIRPOWER, military air strength [n]\n",
  "AIRPROOF": "to make impermeable to air [v -ED, -ING, -S]\n",
  "AIRPROOFED": "AIRPROOF, to make impermeable to air [v]\n",
  "AIRPROOFING": "AIRPROOF, to make impermeable to air [v]\n",
  "AIRPROOFS": "AIRPROOF, to make impermeable to air [v]\n",
  "AIRPROX": "a near collision between aircraft in flight [n -ES]\n",
  "AIRPROXES": "AIRPROX, a near collision between aircraft in flight [n]\n",
  "AIRS": "AIR, to make known publicly [v]\n",
  "AIRSCAPE": "a view of the earth from an aircraft [n -S]\n",
  "AIRSCAPES": "AIRSCAPE, a view of the earth from an aircraft [n]\n",
  "AIRSCREW": "an airplane propeller [n -S]\n",
  "AIRSCREWS": "AIRSCREW, an airplane propeller [n]\n",
  "AIRSHAFT": "a passage for air e.g. in a mine [n -S]\n",
  "AIRSHAFTS": "AIRSHAFT, a passage for air e.g. in a mine [n]\n",
  "AIRSHED": "the air supply of a given region [n -S]\n",
  "AIRSHEDS": "AIRSHED, the air supply of a given region [n]\n",
  "AIRSHIP": "a mechanically driven lighter than air aircraft [n -S]\n",
  "AIRSHIPS": "AIRSHIP, a mechanically driven lighter than air aircraft [n]\n",
  "AIRSHOT": "in golf, a shot that misses the ball completely but counts as a shot [n -S]\n",
  "AIRSHOTS": "AIRSHOT, in golf, a shot that misses the ball completely but counts as a shot [n]\n",
  "AIRSHOW": "an occasion when an airbase is open to the public with flying displays etc. [n -S]\n",
  "AIRSHOWS": "AIRSHOW, an occasion when an airbase is open to the public with flying displays etc. [n]\n",
  "AIRSICK": "nauseated from flying [adj]\n",
  "AIRSICKNESS": "sickness induced by the motion that occurs during air flight [n -ES]\n",
  "AIRSICKNESSES": "AIRSICKNESS, sickness induced by the motion that occurs during air flight [n]\n",
  "AIRSIDE": "restricted area of an airport [n -S]\n",
  "AIRSIDES": "AIRSIDE, restricted area of an airport [n]\n",
  "AIRSOME": "(Canadian) cold [adj]\n",
  "AIRSPACE": "the portion of atmosphere above a certain land area [n -S]\n",
  "AIRSPACES": "AIRSPACE, the portion of atmosphere above a certain land area [n]\n",
  "AIRSPEED": "the speed of an aircraft [n -S]\n",
  "AIRSPEEDS": "AIRSPEED, the speed of an aircraft [n]\n",
  "AIRSTOP": "a helicopter stopping place [n -S]\n",
  "AIRSTOPS": "AIRSTOP, a helicopter stopping place [n]\n",
  "AIRSTREAM": "a flow of air [n -S]\n",
  "AIRSTREAMS": "AIRSTREAM, a flow of air [n]\n",
  "AIRSTRIKE": "an attack by military aircraft [n -S]\n",
  "AIRSTRIKES": "AIRSTRIKE, an attack by military aircraft [n]\n",
  "AIRSTRIP": "a runway [n -S]\n",
  "AIRSTRIPS": "AIRSTRIP, a runway [n]\n",
  "AIRT": "(Scots) direction, quarter [n -S] / to direct, also AIRTH [v -ED, -ING, -S]\n",
  "AIRTED": "AIRT, to direct, also AIRTH [v]\n",
  "AIRTH": "(Scots) to guide, also AIRT [v -ED, -ING, -S]\n",
  "AIRTHED": "AIRTH, (Scots) to guide, also AIRT [v]\n",
  "AIRTHING": "AIRTH, (Scots) to guide, also AIRT [v]\n",
  "AIRTHS": "AIRTH, (Scots) to guide, also AIRT [v]\n",
  "AIRTIGHT": "impermeable to air [adj]\n",
  "AIRTIGHTNESS": "the quality of being airtight [n -ES]\n",
  "AIRTIGHTNESSES": "AIRTIGHTNESS, the quality of being airtight [n]\n",
  "AIRTIME": "an allowable period of time for a broadcast [n -S]\n",
  "AIRTIMES": "AIRTIME, an allowable period of time for a broadcast [n]\n",
  "AIRTING": "AIRT, to direct, also AIRTH [v]\n",
  "AIRTRAM": "an aerial cable car [n -S]\n",
  "AIRTRAMS": "AIRTRAM, an aerial cable car [n]\n",
  "AIRTS": "AIRT, to direct, also AIRTH [v]\n",
  "AIRVAC": "evacuation by air ambulance [n -S]\n",
  "AIRVACS": "AIRVAC, evacuation by air ambulance [n]\n",
  "AIRWARD": "up into the air, also AIRWARDS [adv]\n",
  "AIRWARDS": "up into the air, also AIRWARD [adv]\n",
  "AIRWAVE": "a channel for broadcasting [n -S]\n",
  "AIRWAVES": "AIRWAVE, a channel for broadcasting [n]\n",
  "AIRWAY": "a passage for air [n -S]\n",
  "AIRWAYS": "AIRWAY, a passage for air [n]\n",
  "AIRWISE": "skillful in aviation [adj]\n",
  "AIRWOMAN": "a female aviator [n AIRWOMEN]\n",
  "AIRWOMEN": "AIRWOMAN, a female aviator [n]\n",
  "AIRWORTHIER": "AIRWORTHY, suitable for flying [adj]\n",
  "AIRWORTHIEST": "AIRWORTHY, suitable for flying [adj]\n",
  "AIRWORTHINESS": "the quality of being airworthy [n -ES]\n",
  "AIRWORTHINESSES": "AIRWORTHINESS, the quality of being airworthy [n]\n",
  "AIRWORTHY": "suitable for flying [adj AIRWORTHIER, AIRWORTHIEST]\n",
  "AIRY": "relating to air [adj AIRIER, AIRIEST, AIRILY]\n",
  "AIS": "AI, (Tupi) a three-toed sloth [n]\n",
  "AISLE": "a passage between seats [n -S]\n",
  "AISLED": "having aisles [adj]\n",
  "AISLELESS": "without an aisle [adj]\n",
  "AISLES": "AISLE, a passage between seats [n]\n",
  "AISLEWAY": "a passage for inside traffic [n -S]\n",
  "AISLEWAYS": "AISLEWAY, a passage for inside traffic [n]\n",
  "AISLING": "(Irish) a vision or dream [n -S]\n",
  "AISLINGS": "AISLING, (Irish) a vision or dream [n]\n",
  "AIT": "a small island, also EYOT [n -S]\n",
  "AITCH": "the letter H [n -ES]\n",
  "AITCHBONE": "the rump bone of cattle; the rump cut of beef, also EDGEBONE [n -S]\n",
  "AITCHBONES": "AITCHBONE, the rump bone of cattle; the rump cut of beef, also EDGEBONE [n]\n",
  "AITCHES": "AITCH, the letter H [n]\n",
  "AITS": "AIT, a small island, also EYOT [n]\n",
  "AITU": "a Polynesian demigod [n -S]\n",
  "AITUS": "AITU, a Polynesian demigod [n]\n",
  "AIVER": "(Scots) a draft horse [n -S]\n",
  "AIVERS": "AIVER, (Scots) a draft horse [n]\n",
  "AIYEE": "an interjection used to express great alarm [interj]\n",
  "AIZLE": "(Scots) hot ashes, also EASLE [n -S]\n",
  "AIZLES": "AIZLE, (Scots) hot ashes, also EASLE [n]\n",
  "AJAR": "partly open [adj]\n",
  "AJEE": "(Scots) off the straight; ajar, also AGEE [adv]\n",
  "AJI": "(Spanish) a spicy pepper [n AJIS or AJIES]\n",
  "AJIES": "AJI, (Spanish) a spicy pepper [n]\n",
  "AJIS": "AJI, (Spanish) a spicy pepper [n]\n",
  "AJIVA": "(Sanskrit) inanimate matter [n -S]\n",
  "AJIVAS": "AJIVA, (Sanskrit) inanimate matter [n]\n",
  "AJOWAN": "the fruit of an Egyptian plant of the caraway genus, also AJWAN [n -S]\n",
  "AJOWANS": "AJOWAN, the fruit of an Egyptian plant of the caraway genus, also AJWAN [n]\n",
  "AJUGA": "(Latin) a genus of plants, including bugle [n -S]\n",
  "AJUGAS": "AJUGA, (Latin) a genus of plants, including bugle [n]\n",
  "AJUTAGE": "(French) a tube added to or inserted into an aperture to control the outflow of water, as a pipe at the mouth of an artificial fountain, also ADJUTAGE [n -S]\n",
  "AJUTAGES": "AJUTAGE, (French) a tube added to or inserted into an aperture to control the outflow of water, as a pipe at the mouth of an artificial fountain, also ADJUTAGE [n]\n",
  "AJWAN": "the fruit of an Egyptian plant of the caraway genus, also AJOWAN [n -S]\n",
  "AJWANS": "AJWAN, the fruit of an Egyptian plant of the caraway genus, also AJOWAN [n]\n",
  "AKA": "(Maori) a New Zealand vine [n -S]\n",
  "AKARYOTE": "a cell without a nucleus [n -S]\n",
  "AKARYOTES": "AKARYOTE, a cell without a nucleus [n]\n",
  "AKARYOTIC": "of or like an akaryote, a cell that does not have a nucleus [adj]\n",
  "AKAS": "AKA, (Maori) a New Zealand vine [n]\n",
  "AKATEA": "(Maori) a New Zealand vine with white flowers [n -S]\n",
  "AKATEAS": "AKATEA, (Maori) a New Zealand vine with white flowers [n]\n",
  "AKATHISIA": "a psychological condition characterised by agitation and a frequent desire to alter the posture, also ACATHISIA [n -S]\n",
  "AKATHISIAS": "AKATHISIA, a psychological condition characterised by agitation and a frequent desire to alter the posture, also ACATHISIA [n]\n",
  "AKE": "to endure a dull lasting pain, also ACHE [v AKED, AKING, AKES]\n",
  "AKEAKE": "(Maori) a New Zealand tree with silver leaves and reddish bark [n -S]\n",
  "AKEAKES": "AKEAKE, (Maori) a New Zealand tree with silver leaves and reddish bark [n]\n",
  "AKEBIA": "(Japanese) a climbing shrub [n -S]\n",
  "AKEBIAS": "AKEBIA, (Japanese) a climbing shrub [n]\n",
  "AKED": "AKE, to endure a dull lasting pain, also ACHE [v]\n",
  "AKEDAH": "(Hebrew) the binding of Isaac in Genesis 22 [n -S]\n",
  "AKEDAHS": "AKEDAH, (Hebrew) the binding of Isaac in Genesis 22 [n]\n",
  "AKEE": "(Kru) a small African sapindaceous tree; its edible fruit, often used in Caribbean cookery, also ACKEE [n -S]\n",
  "AKEES": "AKEE, (Kru) a small African sapindaceous tree; its edible fruit, often used in Caribbean cookery, also ACKEE [n]\n",
  "AKELA": "a leader of a cub scout pack [n -S]\n",
  "AKELAS": "AKELA, a leader of a cub scout pack [n]\n",
  "AKENE": "a dry one-seeded fruit, also ACHENE [n -S]\n",
  "AKENES": "AKENE, a dry one-seeded fruit, also ACHENE [n]\n",
  "AKENIAL": "relating to an achene, also ACHENIAL [adj]\n",
  "AKES": "AKE, to endure a dull lasting pain, also ACHE [v]\n",
  "AKHARA": "(Hindi) a gymnasium [n -S]\n",
  "AKHARAS": "AKHARA, (Hindi) a gymnasium [n]\n",
  "AKIMBO": "with hands on hips and elbows turned outwards [adv]\n",
  "AKIN": "related by blood [adj]\n",
  "AKINESES": "AKINESIS, loss of voluntary movement, also AKINESIA [n]\n",
  "AKINESIA": "loss of voluntary movement, also AKINESIS [n -S]\n",
  "AKINESIAS": "AKINESIA, loss of voluntary movement, also AKINESIS [n]\n",
  "AKINESIS": "loss of voluntary movement, also AKINESIA [n AKINESES]\n",
  "AKINETIC": "relating to akinesia, the loss of the power of voluntary movement [adj]\n",
  "AKING": "AKE, to endure a dull lasting pain, also ACHE [v]\n",
  "AKIRAHO": "(Maori) a small New Zealand shrub with white flowers [n -S]\n",
  "AKIRAHOS": "AKIRAHO, (Maori) a small New Zealand shrub with white flowers [n]\n",
  "AKITA": "(Japanese) a large powerfully built breed of Japanese dog [n -S]\n",
  "AKITAS": "AKITA, (Japanese) a large powerfully built breed of Japanese dog [n]\n",
  "AKKAS": "(slang) money, also ACKERS [n]\n",
  "AKOLOUTHOS": "(historical) the head of the Varangian guard of the Byzantine emperors, also ACOLOUTHOS, AKOLUTHOS [n -ES]\n",
  "AKOLOUTHOSES": "AKOLOUTHOS, (historical) the head of the Varangian guard of the Byzantine emperors, also ACOLOUTHOS, AKOLUTHOS [n]\n",
  "AKOLUTHOS": "(historical) the head of the Varangian guard of the Byzantine emperors, also ACOLOUTHOS, AKOLOUTHOS [n -ES]\n",
  "AKOLUTHOSES": "AKOLUTHOS, (historical) the head of the Varangian guard of the Byzantine emperors, also ACOLOUTHOS, AKOLOUTHOS [n]\n",
  "AKRASIA": "(Greek) loss of self-control, also ACRASIA [n -S]\n",
  "AKRASIAS": "AKRASIA, (Greek) loss of self-control, also ACRASIA [n]\n",
  "AKRATIC": "going against ones moral values through weakness of will [adj]\n",
  "AKVAVIT": "(Norwegian) a Scandinavian spirit made from potatoes or grain and flavoured with caraway seeds, also AQUAVIT [n -S]\n",
  "AKVAVITS": "AKVAVIT, (Norwegian) a Scandinavian spirit made from potatoes or grain and flavoured with caraway seeds, also AQUAVIT [n]\n",
  "AL": "(Hindi) the Indian mulberry tree, aka noni, also AAL [n -S]\n",
  "ALA": "in biology, any flat winglike projection [n ALAE]\n",
  "ALAAP": "(Sanskrit) in Indian music, the introductory section of a raga, also ALAP, ALAPA [n -S]\n",
  "ALAAPS": "ALAAP, (Sanskrit) in Indian music, the introductory section of a raga, also ALAP, ALAPA [n]\n",
  "ALABAMINE": "an alternative name for the element astatine [n -S]\n",
  "ALABAMINES": "ALABAMINE, an alternative name for the element astatine [n]\n",
  "ALABANDINE": "a deep red garnet consisting of an iron aluminum silicate, also ALMANDINE, ALMANDITE, ALMONDITE [n -S]\n",
  "ALABANDINES": "ALABANDINE, a deep red garnet consisting of an iron aluminum silicate, also ALMANDINE, ALMANDITE, ALMONDITE [n]\n",
  "ALABANDITE": "a cubic mineral, magnesium sulphide [n -S]\n",
  "ALABANDITES": "ALABANDITE, a cubic mineral, magnesium sulphide [n]\n",
  "ALABASTER": "a soft, semitransparent gypsum [n -S]\n",
  "ALABASTERS": "ALABASTER, a soft, semitransparent gypsum [n]\n",
  "ALABASTRINE": "of or like alabaster [adj]\n",
  "ALABLASTER": "(obsolete) alabaster [n -S]\n",
  "ALABLASTERS": "ALABLASTER, (obsolete) alabaster [n]\n",
  "ALACHLOR": "a type of herbicide [n -S]\n",
  "ALACHLORS": "ALACHLOR, a type of herbicide [n]\n",
  "ALACK": "(archaic) an interjection expressing grief [interj]\n",
  "ALACKADAY": "an expression of regret or deprecation, also LACKADAY [interj]\n",
  "ALACRITIES": "ALACRITY, cheerful promptness [n]\n",
  "ALACRITOUS": "showing alacrity [adj]\n",
  "ALACRITY": "cheerful promptness [n ALACRITIES]\n",
  "ALAE": "ALA, in biology, any flat winglike projection [n]\n",
  "ALAIMENT": "an allayment, a lessening [n -S]\n",
  "ALAIMENTS": "ALAIMENT, an allayment, a lessening [n]\n",
  "ALALAGMOI": "ALALAGMOS, (Greek) a war-cry of 'alalai' [n]\n",
  "ALALAGMOS": "(Greek) a war-cry of 'alalai' [n ALALAGMOI]\n",
  "ALALIA": "loss of speech [n -S]\n",
  "ALALIAS": "ALALIA, loss of speech [n]\n",
  "ALAMEDA": "(Spanish) a public walkway between rows of poplar trees [n -S]\n",
  "ALAMEDAS": "ALAMEDA, (Spanish) a public walkway between rows of poplar trees [n]\n",
  "ALAMO": "(Spanish) a kind of poplar tree [n -S]\n",
  "ALAMODE": "(French) a light glossy silk fabric [n -S]\n",
  "ALAMODES": "ALAMODE, (French) a light glossy silk fabric [n]\n",
  "ALAMORT": "(French) half dead [adj]\n",
  "ALAMOS": "ALAMO, (Spanish) a kind of poplar tree [n]\n",
  "ALAN": "a large hunting dog, also ALAND, ALANT [n -S]\n",
  "ALAND": "a large hunting dog, also ALAN, ALANT [n -S]\n",
  "ALANDS": "ALAND, a large hunting dog, also ALAN, ALANT [n]\n",
  "ALANE": "(dialect) alone [adj]\n",
  "ALANG": "(Malay) a coarse grass of the Malay peninsula, also LALANG [n -S]\n",
  "ALANGS": "ALANG, (Malay) a coarse grass of the Malay peninsula, also LALANG [n]\n",
  "ALANIN": "an amino acid, also ALANINE [n -S]\n",
  "ALANINE": "an amino acid, also ALANIN [n -S]\n",
  "ALANINES": "ALANINE, an amino acid, also ALANIN [n]\n",
  "ALANINS": "ALANIN, an amino acid, also ALANINE [n]\n",
  "ALANNAH": "(Irish) my child, a term of endearment used with one's child [n -S]\n",
  "ALANNAHS": "ALANNAH, (Irish) my child, a term of endearment used with one's child [n]\n",
  "ALANS": "ALAN, a large hunting dog, also ALAND, ALANT [n]\n",
  "ALANT": "a large hunting dog, also ALAN, ALAND [n -S]\n",
  "ALANTS": "ALANT, a large hunting dog, also ALAN, ALAND [n]\n",
  "ALANYL": "a univalent radical [n -S]\n",
  "ALANYLS": "ALANYL, a univalent radical [n]\n",
  "ALAP": "(Sanskrit) in Indian music, the introductory section of a raga, also ALAAP, ALAPA [n -S]\n",
  "ALAPA": "(Sanskrit) in Indian music, the introductory section of a raga, also ALAAP, ALAP [n -S]\n",
  "ALAPAS": "ALAPA, (Sanskrit) in Indian music, the introductory section of a raga, also ALAAP, ALAP [n]\n",
  "ALAPS": "ALAP, (Sanskrit) in Indian music, the introductory section of a raga, also ALAAP, ALAPA [n]\n",
  "ALAR": "pertaining to wings [adj]\n",
  "ALARM": "to strike with fear [v -ED, -ING, -S]\n",
  "ALARMABLE": "that can be alarmed [adj]\n",
  "ALARMED": "ALARM, to strike with fear [v]\n",
  "ALARMEDLY": "ALARMED, ALARM, to strike with fear [adv]\n",
  "ALARMING": "ALARM, to strike with fear [v]\n",
  "ALARMINGLY": "ALARMING, ALARM, to strike with fear [adv]\n",
  "ALARMISM": "the practice of alarming others needlessly [n -S]\n",
  "ALARMISMS": "ALARMISM, the practice of alarming others needlessly [n]\n",
  "ALARMIST": "one who alarms others needlessly [n -S]\n",
  "ALARMISTS": "ALARMIST, one who alarms others needlessly [n]\n",
  "ALARMS": "ALARM, to strike with fear [v]\n",
  "ALARUM": "(archaic) to alarm, also LARUM [v -ED, -ING, -S]\n",
  "ALARUMED": "ALARUM, (archaic) to alarm, also LARUM [v]\n",
  "ALARUMING": "ALARUM, (archaic) to alarm, also LARUM [v]\n",
  "ALARUMS": "ALARUM, (archaic) to alarm, also LARUM [v]\n",
  "ALARY": "of or pertaining to the wing or shoulder, also ALAR [adj]\n",
  "ALAS": "an interjection expressing grief [interj]\n",
  "ALASKA": "a kind of dessert; a heavy fabric [n -S]\n",
  "ALASKAS": "ALASKA, a kind of dessert; a heavy fabric [n]\n",
  "ALASTOR": "(Greek) an avenging deity in Greek tragedy [n -S]\n",
  "ALASTORS": "ALASTOR, (Greek) an avenging deity in Greek tragedy [n]\n",
  "ALASTRIM": "(Portuguese) a mild form of smallpox [n -S]\n",
  "ALASTRIMS": "ALASTRIM, (Portuguese) a mild form of smallpox [n]\n",
  "ALATE": "having wings, also ALATED [adj] / a winged insect [n -S]\n",
  "ALATED": "having wings, also ALATE [adj]\n",
  "ALATES": "ALATE, a winged insect [n]\n",
  "ALATION": "the state of having wings [n -S]\n",
  "ALATIONS": "ALATION, the state of having wings [n]\n",
  "ALAY": "to quell, also ALLAY, ALEYE [v -ED, -ING, -S]\n",
  "ALAYED": "ALAY, to quell, also ALLAY, ALEYE [v]\n",
  "ALAYING": "ALAY, to quell, also ALLAY, ALEYE [v]\n",
  "ALAYS": "ALAY, to quell, also ALLAY, ALEYE [v]\n",
  "ALB": "a priest's long, white vestment [n -S]\n",
  "ALBA": "the white substance of the brain [n -S]\n",
  "ALBACORE": "(Arabic) a large tuna fish, also ALBICORE [n -S]\n",
  "ALBACORES": "ALBACORE, (Arabic) a large tuna fish, also ALBICORE [n]\n",
  "ALBARELLI": "ALBARELLO, (Italian) a cylindrical jar used to hold drugs [n]\n",
  "ALBARELLO": "(Italian) a cylindrical jar used to hold drugs [n ALBARELLOS or ALBARELLI]\n",
  "ALBARELLOS": "ALBARELLO, (Italian) a cylindrical jar used to hold drugs [n]\n",
  "ALBAS": "ALBA, the white substance of the brain [n]\n",
  "ALBATA": "(Latin) a variety of German silver [n -S]\n",
  "ALBATAS": "ALBATA, (Latin) a variety of German silver [n]\n",
  "ALBATROSS": "a large, long-winged seabird [n -ES]\n",
  "ALBATROSSES": "ALBATROSS, a large, long-winged seabird [n]\n",
  "ALBE": "(archaic) albeit, also ALBEE, ALBEIT [conj]\n",
  "ALBEDO": "(Latin) the measure of the reflecting power of an object [n ALBEDOS or ALBEDOES]\n",
  "ALBEDOES": "ALBEDO, (Latin) the measure of the reflecting power of an object [n]\n",
  "ALBEDOS": "ALBEDO, (Latin) the measure of the reflecting power of an object [n]\n",
  "ALBEE": "(archaic) albeit, also ALBE, ALBEIT [conj]\n",
  "ALBEIT": "although, also ALBE, ALBEE [conj]\n",
  "ALBERGHI": "ALBERGO, (Italian) an inn, also AUBERGE [n]\n",
  "ALBERGO": "(Italian) an inn, also AUBERGE [n ALBERGHI]\n",
  "ALBERT": "a kind of watch chain [n -S]\n",
  "ALBERTITE": "a bituminous mineral resembling asphalt, found in the county of Albert, New Brunswick [n -S]\n",
  "ALBERTITES": "ALBERTITE, a bituminous mineral resembling asphalt, found in the county of Albert, New Brunswick [n]\n",
  "ALBERTS": "ALBERT, a kind of watch chain [n]\n",
  "ALBESCENCE": "the act of becoming white [n -S]\n",
  "ALBESCENCES": "ALBESCENCE, the act of becoming white [n]\n",
  "ALBESCENT": "becoming white [adj]\n",
  "ALBESPINE": "(archaic) hawthorn, also ALBESPYNE [n -S]\n",
  "ALBESPINES": "ALBESPINE, (archaic) hawthorn, also ALBESPYNE [n]\n",
  "ALBESPYNE": "(archaic) hawthorn, also ALBESPINE [n -S]\n",
  "ALBESPYNES": "ALBESPYNE, (archaic) hawthorn, also ALBESPINE [n]\n",
  "ALBICORE": "(Arabic) a large tuna fish, also ALBACORE [n -S]\n",
  "ALBICORES": "ALBICORE, (Arabic) a large tuna fish, also ALBACORE [n]\n",
  "ALBINAL": "pertaining to albinism, also ALBINIC [adj]\n",
  "ALBINESS": "(archaic) a female albino [n -ES]\n",
  "ALBINESSES": "ALBINESS, (archaic) a female albino [n]\n",
  "ALBINIC": "pertaining to albinism, also ALBINAL [adj]\n",
  "ALBINISM": "the condition of being an albino [n -S]\n",
  "ALBINISMS": "ALBINISM, the condition of being an albino [n]\n",
  "ALBINISTIC": "affected with albinism [adj]\n",
  "ALBINO": "a person or organism lacking normal pigmentation [n -S]\n",
  "ALBINOISM": "the state or condition of being an albino, also ALBINISM [n -S]\n",
  "ALBINOISMS": "ALBINOISM, the state or condition of being an albino, also ALBINISM [n]\n",
  "ALBINOS": "ALBINO, a person or organism lacking normal pigmentation [n]\n",
  "ALBINOTIC": "affected with albinism [adj]\n",
  "ALBITE": "a sodium-rich mineral, sodium feldspar, occurring widely in silicate rocks [n -S]\n",
  "ALBITES": "ALBITE, a sodium-rich mineral, sodium feldspar, occurring widely in silicate rocks [n]\n",
  "ALBITIC": "pertaining to albite, a white silicate, also ALBITICAL [adj]\n",
  "ALBITICAL": "pertaining to albite, a white silicate, also ALBITIC [adj]\n",
  "ALBITISE": "to turn into albite, also ALBITIZE [v ALBITISED, ALBITISING, ALBITISES]\n",
  "ALBITISED": "ALBITISE, to turn into albite, also ALBITIZE [v]\n",
  "ALBITISES": "ALBITISE, to turn into albite, also ALBITIZE [v]\n",
  "ALBITISING": "ALBITISE, to turn into albite, also ALBITIZE [v]\n",
  "ALBITIZE": "to turn into albite, also ALBITISE [v ALBITIZED, ALBITIZING, ALBITIZES]\n",
  "ALBITIZED": "ALBITIZE, to turn into albite, also ALBITISE [v]\n",
  "ALBITIZES": "ALBITIZE, to turn into albite, also ALBITISE [v]\n",
  "ALBITIZING": "ALBITIZE, to turn into albite, also ALBITISE [v]\n",
  "ALBIZIA": "any of a genus of subtropical and tropical trees and shrubs in the mimosa subfamily, also ALBIZZIA [n -S]\n",
  "ALBIZIAS": "ALBIZIA, any of a genus of subtropical and tropical trees and shrubs in the mimosa subfamily, also ALBIZZIA [n]\n",
  "ALBIZZIA": "any of a genus of subtropical and tropical trees and shrubs in the mimosa subfamily, also ALBIZIA [n -S]\n",
  "ALBIZZIAS": "ALBIZZIA, any of a genus of subtropical and tropical trees and shrubs in the mimosa subfamily, also ALBIZIA [n]\n",
  "ALBRICIAS": "(Spanish) an expression of joy [interj]\n",
  "ALBS": "ALB, a priest's long, white vestment [n]\n",
  "ALBUGINEOUS": "like the white of an eye or an egg; white-coloured [adj]\n",
  "ALBUGO": "(Latin) a white opacity of the eye [n -S]\n",
  "ALBUGOS": "ALBUGO, (Latin) a white opacity of the eye [n]\n",
  "ALBUM": "a book for storing photographs and stamps [n -S]\n",
  "ALBUMBLATT": "(German) a short occasional instrumental composition, usually light in character [n ALBUMBLATTS or ALBUMBLATTER]\n",
  "ALBUMBLATTER": "ALBUMBLATT, (German) a short occasional instrumental composition, usually light in character [n]\n",
  "ALBUMBLATTS": "ALBUMBLATT, (German) a short occasional instrumental composition, usually light in character [n]\n",
  "ALBUMEN": "(Latin) the white of an egg [n -S]\n",
  "ALBUMENISE": "to cover or impregnate with albumen or an albuminous solution [v ALBUMENISED, ALBUMENISING, ALBUMENISES]\n",
  "ALBUMENISED": "ALBUMENISE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMENISES": "ALBUMENISE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMENISING": "ALBUMENISE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMENIZE": "to cover or impregnate with albumen or an albuminous solution [v ALBUMENIZED, ALBUMENIZING, ALBUMENIZES]\n",
  "ALBUMENIZED": "ALBUMENIZE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMENIZES": "ALBUMENIZE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMENIZING": "ALBUMENIZE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMENS": "ALBUMEN, (Latin) the white of an egg [n]\n",
  "ALBUMIN": "(Latin) the protein part of egg-white [n -S]\n",
  "ALBUMINATE": "a substance produced by the action of an alkali upon albumin [n -S]\n",
  "ALBUMINATES": "ALBUMINATE, a substance produced by the action of an alkali upon albumin [n]\n",
  "ALBUMINISE": "to cover or impregnate with albumen or an albuminous solution [v ALBUMINISED, ALBUMINISING, ALBUMINISES]\n",
  "ALBUMINISED": "ALBUMINISE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMINISES": "ALBUMINISE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMINISING": "ALBUMINISE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMINIZE": "to cover or impregnate with albumen or an albuminous solution [v ALBUMINIZED, ALBUMINIZING, ALBUMINIZES]\n",
  "ALBUMINIZED": "ALBUMINIZE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMINIZES": "ALBUMINIZE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMINIZING": "ALBUMINIZE, to cover or impregnate with albumen or an albuminous solution [v]\n",
  "ALBUMINOID": "an old name for protein in general; now any one of a class of substances including keratin [n -S]\n",
  "ALBUMINOIDS": "ALBUMINOID, an old name for protein in general; now any one of a class of substances including keratin [n]\n",
  "ALBUMINOUS": "of or like albumen [adj]\n",
  "ALBUMINS": "ALBUMIN, (Latin) the protein part of egg-white [n]\n",
  "ALBUMINURIA": "the presence of albumin in the urine [n -S]\n",
  "ALBUMINURIAS": "ALBUMINURIA, the presence of albumin in the urine [n]\n",
  "ALBUMINURIC": "relating to albuminuria, the presence of albumin in the urine [adj]\n",
  "ALBUMOSE": "a water-soluble protein [n -S]\n",
  "ALBUMOSES": "ALBUMOSE, a water-soluble protein [n]\n",
  "ALBUMS": "ALBUM, a book for storing photographs and stamps [n]\n",
  "ALBURNOUS": "of or pertaining to alburnum, the white and softer part of wood [adj]\n",
  "ALBURNUM": "the soft wood between inner bark and heartwood [n -S]\n",
  "ALBURNUMS": "ALBURNUM, the soft wood between inner bark and heartwood [n]\n",
  "ALBUTEROL": "a drug used to treat lung diseases [n -S]\n",
  "ALBUTEROLS": "ALBUTEROL, a drug used to treat lung diseases [n]\n",
  "ALCADE": "(Arabic) the mayor of a Spanish town, also ALCALDE [n -S]\n",
  "ALCADES": "ALCADE, (Arabic) the mayor of a Spanish town, also ALCALDE [n]\n",
  "ALCAHEST": "(Arabic) the hypothetical universal solvent sought by alchemists, also ALKAHEST [n -S]\n",
  "ALCAHESTS": "ALCAHEST, (Arabic) the hypothetical universal solvent sought by alchemists, also ALKAHEST [n]\n",
  "ALCAIC": "(Greek) a type of verse form [n -S]\n",
  "ALCAICERIA": "(Spanish) a bazaar [n -S]\n",
  "ALCAICERIAS": "ALCAICERIA, (Spanish) a bazaar [n]\n",
  "ALCAICS": "ALCAIC, (Greek) a type of verse form [n]\n",
  "ALCAIDE": "(Arabic) the commander of a Spanish fortress, also ALCAYDE [n -S]\n",
  "ALCAIDES": "ALCAIDE, (Arabic) the commander of a Spanish fortress, also ALCAYDE [n]\n",
  "ALCALDE": "(Arabic) the mayor of a Spanish town, also ALCADE [n -S]\n",
  "ALCALDES": "ALCALDE, (Arabic) the mayor of a Spanish town, also ALCADE [n]\n",
  "ALCARRAZA": "(Spanish) a vessel of porous earthenware, used for cooling liquids by evaporation from the exterior surface [n -S]\n",
  "ALCARRAZAS": "ALCARRAZA, (Spanish) a vessel of porous earthenware, used for cooling liquids by evaporation from the exterior surface [n]\n",
  "ALCATRAS": "(Arabic) a kind of large water bird [n -ES]\n",
  "ALCATRASES": "ALCATRAS, (Arabic) a kind of large water bird [n]\n",
  "ALCAYDE": "(Arabic) the commander of a Spanish fortress, also ALCAIDE [n -S]\n",
  "ALCAYDES": "ALCAYDE, (Arabic) the commander of a Spanish fortress, also ALCAIDE [n]\n",
  "ALCAZAR": "(Arabic) a Spanish fortress or palace [n -S]\n",
  "ALCAZARS": "ALCAZAR, (Arabic) a Spanish fortress or palace [n]\n",
  "ALCHEMIC": "relating to alchemy [adj ALCHEMICALLY]\n",
  "ALCHEMICAL": "relating to alchemy, also ALCHEMIC [adj ALCHEMICALLY]\n",
  "ALCHEMICALLY": "ALCHEMICAL, relating to alchemy, also ALCHEMIC [adv]\n",
  "ALCHEMIES": "ALCHEMY, the infant stage of chemistry, also ALCHYMY [n]\n",
  "ALCHEMISE": "to change by alchemy; to transmute, also ALCHEMIZE [v ALCHEMISED, ALCHEMISING, ALCHEMISES]\n",
  "ALCHEMISED": "ALCHEMISE, to change by alchemy; to transmute, also ALCHEMIZE [v]\n",
  "ALCHEMISES": "ALCHEMISE, to change by alchemy; to transmute, also ALCHEMIZE [v]\n",
  "ALCHEMISING": "ALCHEMISE, to change by alchemy; to transmute, also ALCHEMIZE [v]\n",
  "ALCHEMIST": "a practitioner of alchemy [n -S]\n",
  "ALCHEMISTIC": "relating to an alchemist [adj]\n",
  "ALCHEMISTICAL": "relating to an alchemist [adj]\n",
  "ALCHEMISTS": "ALCHEMIST, a practitioner of alchemy [n]\n",
  "ALCHEMIZE": "to change by alchemy; to transmute, also ALCHEMISE [v ALCHEMIZED, ALCHEMIZING, ALCHEMIZES]\n",
  "ALCHEMIZED": "ALCHEMIZE, to change by alchemy; to transmute, also ALCHEMISE [v]\n",
  "ALCHEMIZES": "ALCHEMIZE, to change by alchemy; to transmute, also ALCHEMISE [v]\n",
  "ALCHEMIZING": "ALCHEMIZE, to change by alchemy; to transmute, also ALCHEMISE [v]\n",
  "ALCHEMY": "the infant stage of chemistry, also ALCHYMY [n ALCHEMIES]\n",
  "ALCHERA": "(Native Australian) the dreamtime, also ALCHERINGA [n -S]\n",
  "ALCHERAS": "ALCHERA, (Native Australian) the dreamtime, also ALCHERINGA [n]\n",
  "ALCHERINGA": "(Native Australian) the dreamtime, also ALCHERA [n -S]\n",
  "ALCHERINGAS": "ALCHERINGA, (Native Australian) the dreamtime, also ALCHERA [n]\n",
  "ALCHYMIES": "ALCHYMY, the infant stage of chemistry, also ALCHEMY [n]\n",
  "ALCHYMY": "the infant stage of chemistry, also ALCHEMY [n ALCHYMIES]\n",
  "ALCID": "a diving sea bird, an auk [n -S]\n",
  "ALCIDINE": "pertaining to a family of seabirds, the auks [adj]\n",
  "ALCIDS": "ALCID, a diving sea bird, an auk [n]\n",
  "ALCO": "(Australian slang) a heavy drinker or alcoholic, also ALKO [n -S]\n",
  "ALCOHOL": "(Arabic) a flammable liquid [n -S]\n",
  "ALCOHOLIC": "related to alcohol [adj ALCOHOLICALLY] / one addicted to alcohol [n -S]\n",
  "ALCOHOLICALLY": "ALCOHOLIC, related to alcohol [adv]\n",
  "ALCOHOLICITIES": "ALCOHOLICITY, the strength of an alcoholic liquor [n]\n",
  "ALCOHOLICITY": "the strength of an alcoholic liquor [n ALCOHOLICITIES]\n",
  "ALCOHOLICS": "ALCOHOLIC, one addicted to alcohol [n]\n",
  "ALCOHOLISATION": "the process of alcoholising, also ALCOHOLIZATION [n -S]\n",
  "ALCOHOLISATIONS": "ALCOHOLISATION, the process of alcoholising, also ALCOHOLIZATION [n]\n",
  "ALCOHOLISE": "to convert into or saturate with alcohol, also ALCOHOLIZE [v ALCOHOLISED, ALCOHOLISING, ALCOHOLISES]\n",
  "ALCOHOLISED": "ALCOHOLISE, to convert into or saturate with alcohol, also ALCOHOLIZE [v]\n",
  "ALCOHOLISES": "ALCOHOLISE, to convert into or saturate with alcohol, also ALCOHOLIZE [v]\n",
  "ALCOHOLISING": "ALCOHOLISE, to convert into or saturate with alcohol, also ALCOHOLIZE [v]\n",
  "ALCOHOLISM": "continued excessive or compulsive use of alcoholic drinks [n -S]\n",
  "ALCOHOLISMS": "ALCOHOLISM, continued excessive or compulsive use of alcoholic drinks [n]\n",
  "ALCOHOLIZATION": "the process of alcoholizing, also ALCOHOLISATION [n -S]\n",
  "ALCOHOLIZATIONS": "ALCOHOLIZATION, the process of alcoholizing, also ALCOHOLISATION [n]\n",
  "ALCOHOLIZE": "to convert into or saturate with alcohol [v ALCOHOLIZED, ALCOHOLIZING, ALCOHOLIZES]\n",
  "ALCOHOLIZED": "ALCOHOLIZE, to convert into or saturate with alcohol [v]\n",
  "ALCOHOLIZES": "ALCOHOLIZE, to convert into or saturate with alcohol [v]\n",
  "ALCOHOLIZING": "ALCOHOLIZE, to convert into or saturate with alcohol [v]\n",
  "ALCOHOLOMETER": "an instrument for measuring the proportion of alcohol in solutions [n -S]\n",
  "ALCOHOLOMETERS": "ALCOHOLOMETER, an instrument for measuring the proportion of alcohol in solutions [n]\n",
  "ALCOHOLOMETRIES": "ALCOHOLOMETRY, the measurement of the proportion of alcohol in solutions [n]\n",
  "ALCOHOLOMETRY": "the measurement of the proportion of alcohol in solutions [n ALCOHOLOMETRIES]\n",
  "ALCOHOLS": "ALCOHOL, (Arabic) a flammable liquid [n]\n",
  "ALCOLOCK": "a breath-alcohol safety device fitted to the ignition of some cars [n -S]\n",
  "ALCOLOCKS": "ALCOLOCK, a breath-alcohol safety device fitted to the ignition of some cars [n]\n",
  "ALCOOL": "(French) a form of pure grain spirit distilled in Quebec [n -S]\n",
  "ALCOOLS": "ALCOOL, (French) a form of pure grain spirit distilled in Quebec [n]\n",
  "ALCOPOP": "a drink containing alcohol but packaged and tasting like a soft drink [n -S]\n",
  "ALCOPOPS": "ALCOPOP, a drink containing alcohol but packaged and tasting like a soft drink [n]\n",
  "ALCORZA": "(Spanish) a kind of Spanish sweet [n -S]\n",
  "ALCORZAS": "ALCORZA, (Spanish) a kind of Spanish sweet [n]\n",
  "ALCOS": "ALCO, (Australian slang) a heavy drinker or alcoholic, also ALKO [n]\n",
  "ALCOVE": "(Arabic) a vaulted or arched recess in a room-wall, formerly especially one for a bed [n -S]\n",
  "ALCOVED": "having an alcove [adj]\n",
  "ALCOVES": "ALCOVE, (Arabic) a vaulted or arched recess in a room-wall, formerly especially one for a bed [n]\n",
  "ALCYONARIAN": "a member of the Alcyonaria, the order to which sea-pens, red coral and organ-pipe coral belong [n -S]\n",
  "ALCYONARIANS": "ALCYONARIAN, a member of the Alcyonaria, the order to which sea-pens, red coral and organ-pipe coral belong [n]\n",
  "ALDEA": "(Spanish) a small village or a farm in Portugal, Spain, or one of their former territories [n -S]\n",
  "ALDEAS": "ALDEA, (Spanish) a small village or a farm in Portugal, Spain, or one of their former territories [n]\n",
  "ALDEHYDE": "a volatile liquid obtained from alcohol by certain processes of oxidation [n -S]\n",
  "ALDEHYDES": "ALDEHYDE, a volatile liquid obtained from alcohol by certain processes of oxidation [n]\n",
  "ALDEHYDIC": "of or pertaining to aldehyde; as, aldehydic acid [adj]\n",
  "ALDER": "any tree of the genus Alnus, related to the birches [n -S]\n",
  "ALDERFLIES": "ALDERFLY, a riverside winged insect [n]\n",
  "ALDERFLY": "a riverside winged insect [n ALDERFLIES]\n",
  "ALDERMAN": "a member of a municipal legislative body [n ALDERMEN]\n",
  "ALDERMANIC": "relating to, becoming to, or like, an alderman [adj]\n",
  "ALDERMANITIES": "ALDERMANITY, the state of being an alderman [n]\n",
  "ALDERMANITY": "the state of being an alderman [n ALDERMANITIES]\n",
  "ALDERMANLIER": "ALDERMANLY, pertaining to, or like, an alderman [adj]\n",
  "ALDERMANLIEST": "ALDERMANLY, pertaining to, or like, an alderman [adj]\n",
  "ALDERMANLIKE": "like an alderman [adj]\n",
  "ALDERMANLY": "pertaining to, or like, an alderman [adj ALDERMANLIER, ALDERMANLIEST]\n",
  "ALDERMANRIES": "ALDERMANRY, the district or ward of an alderman [n]\n",
  "ALDERMANRY": "the district or ward of an alderman [n ALDERMANRIES]\n",
  "ALDERMANSHIP": "the office of alderman [n -S]\n",
  "ALDERMANSHIPS": "ALDERMANSHIP, the office of alderman [n]\n",
  "ALDERMEN": "ALDERMAN, a member of a municipal legislative body [n]\n",
  "ALDERN": "made of alder wood [adj]\n",
  "ALDERS": "ALDER, any tree of the genus Alnus, related to the birches [n]\n",
  "ALDERWOMAN": "a female alderman [n ALDERWOMEN]\n",
  "ALDERWOMEN": "ALDERWOMAN, a female alderman [n]\n",
  "ALDICARB": "a kind of pesticide [n -S]\n",
  "ALDICARBS": "ALDICARB, a kind of pesticide [n]\n",
  "ALDOHEXOSE": "a class of sugars, including glucose [n -S]\n",
  "ALDOHEXOSES": "ALDOHEXOSE, a class of sugars, including glucose [n]\n",
  "ALDOL": "a chemical compound used as a solvent and also as a sedative [n -S]\n",
  "ALDOLASE": "an enzyme [n -S]\n",
  "ALDOLASES": "ALDOLASE, an enzyme [n]\n",
  "ALDOLISATION": "the formation of aldol, also ALDOLIZATION [n -S]\n",
  "ALDOLISATIONS": "ALDOLISATION, the formation of aldol, also ALDOLIZATION [n]\n",
  "ALDOLIZATION": "the formation of aldol, also ALDOLISATION [n -S]\n",
  "ALDOLIZATIONS": "ALDOLIZATION, the formation of aldol, also ALDOLISATION [n]\n",
  "ALDOLS": "ALDOL, a chemical compound used as a solvent and also as a sedative [n]\n",
  "ALDOPENTOSE": "a type of sugar [n -S]\n",
  "ALDOPENTOSES": "ALDOPENTOSE, a type of sugar [n]\n",
  "ALDOSE": "a class of sugars, containing an aldehyde [n -S]\n",
  "ALDOSES": "ALDOSE, a class of sugars, containing an aldehyde [n]\n",
  "ALDOSTERONE": "a steroid hormone [n -S]\n",
  "ALDOSTERONES": "ALDOSTERONE, a steroid hormone [n]\n",
  "ALDOSTERONISM": "excessive secretion of aldosterone [n -S]\n",
  "ALDOSTERONISMS": "ALDOSTERONISM, excessive secretion of aldosterone [n]\n",
  "ALDOXIME": "an oxime formed by reaction between hydroxylamine and an aldehyde [n -S]\n",
  "ALDOXIMES": "ALDOXIME, an oxime formed by reaction between hydroxylamine and an aldehyde [n]\n",
  "ALDRIN": "a chlorinated hydrocarbon, used as a contact insecticide [n -S]\n",
  "ALDRINS": "ALDRIN, a chlorinated hydrocarbon, used as a contact insecticide [n]\n",
  "ALE": "a kind of beer, made without using hops as a flavouring, also YILL [n -S]\n",
  "ALEATORIC": "dependent on chance, luck, or an uncertain outcome, also ALEATORY [adj]\n",
  "ALEATORIES": "ALEATORY, aleatoric music [n]\n",
  "ALEATORY": "dependent on chance, luck, or an uncertain outcome, also ALEATORIC [adj] / aleatoric music [n ALEATORIES]\n",
  "ALEBENCH": "a bench in or in front of an alehouse [n -ES]\n",
  "ALEBENCHES": "ALEBENCH, a bench in or in front of an alehouse [n]\n",
  "ALEC": "a herring [n -S]\n",
  "ALECITHAL": "of an ovum, having little or no yolk [adj]\n",
  "ALECK": "an irritatingly smart person [n -S]\n",
  "ALECKS": "ALECK, an irritatingly smart person [n]\n",
  "ALECOST": "a garden plant having a strong balsamic smell and used to flavour ale, aka costmary [n -S]\n",
  "ALECOSTS": "ALECOST, a garden plant having a strong balsamic smell and used to flavour ale, aka costmary [n]\n",
  "ALECS": "ALEC, a herring [n]\n",
  "ALECTRYON": "a sapindaceous tree of Australasia, Southeast Asia, and Micronesia [n -S]\n",
  "ALECTRYONS": "ALECTRYON, a sapindaceous tree of Australasia, Southeast Asia, and Micronesia [n]\n",
  "ALEE": "toward the side of a vessel sheltered from the wind [adv]\n",
  "ALEF": "(Hebrew) the first letter of the Hebrew alphabet, also ALEPH [n -S]\n",
  "ALEFS": "ALEF, (Hebrew) the first letter of the Hebrew alphabet, also ALEPH [n]\n",
  "ALEFT": "(archaic) on or to the left [adv]\n",
  "ALEGAR": "vinegar made by turning ale sour [n -S]\n",
  "ALEGARS": "ALEGAR, vinegar made by turning ale sour [n]\n",
  "ALEGGE": "(Spenser) to lighten, alleviate, also ALLEGGE [v ALEGGED, ALEGGING, ALEGGES]\n",
  "ALEGGEAUNCE": "(Spenser) alleviation [n -S]\n",
  "ALEGGEAUNCES": "ALEGGEAUNCE, (Spenser) alleviation [n]\n",
  "ALEGGED": "ALEGGE, (Spenser) to lighten, alleviate, also ALLEGGE [v]\n",
  "ALEGGES": "ALEGGE, (Spenser) to lighten, alleviate, also ALLEGGE [v]\n",
  "ALEGGING": "ALEGGE, (Spenser) to lighten, alleviate, also ALLEGGE [v]\n",
  "ALEHOUSE": "a tavern where ale is sold [n -S]\n",
  "ALEHOUSES": "ALEHOUSE, a tavern where ale is sold [n]\n",
  "ALEMBIC": "(Arabic) an old distilling apparatus [n -S]\n",
  "ALEMBICATED": "overrefined [adj]\n",
  "ALEMBICATION": "processing with an alembic [n -S]\n",
  "ALEMBICATIONS": "ALEMBICATION, processing with an alembic [n]\n",
  "ALEMBICS": "ALEMBIC, (Arabic) an old distilling apparatus [n]\n",
  "ALEMBROTH": "an alchemists' word for mercury ammonium chloride, aka salt of wisdom [n -S]\n",
  "ALEMBROTHS": "ALEMBROTH, an alchemists' word for mercury ammonium chloride, aka salt of wisdom [n]\n",
  "ALENCON": "(French) a needlepoint lace [n -S]\n",
  "ALENCONS": "ALENCON, (French) a needlepoint lace [n]\n",
  "ALENGTH": "at full length [adv]\n",
  "ALEPH": "(Hebrew) the first letter of the Hebrew alphabet, also ALEF [n -S]\n",
  "ALEPHS": "ALEPH, (Hebrew) the first letter of the Hebrew alphabet, also ALEF [n]\n",
  "ALEPINE": "(Arabic) a mixed wool and silk or mohair and cotton fabric [n -S]\n",
  "ALEPINES": "ALEPINE, (Arabic) a mixed wool and silk or mohair and cotton fabric [n]\n",
  "ALERCE": "(Spanish) the wood of the sandarach tree [n -S]\n",
  "ALERCES": "ALERCE, (Spanish) the wood of the sandarach tree [n]\n",
  "ALERION": "(French) in heraldry, an eagle displayed without feet or beak, also ALLERION [n -S]\n",
  "ALERIONS": "ALERION, (French) in heraldry, an eagle displayed without feet or beak, also ALLERION [n]\n",
  "ALERT": "ready for sudden action [adj ALERTER, ALERTEST, ALERTLY] / to warn [v -ED, -ING, -S]\n",
  "ALERTED": "ALERT, to warn [v]\n",
  "ALERTER": "ALERT, ready for sudden action [adj]\n",
  "ALERTEST": "ALERT, ready for sudden action [adj]\n",
  "ALERTING": "ALERT, to warn [v]\n",
  "ALERTLY": "ALERT, ready for sudden action [adv]\n",
  "ALERTNESS": "the state of being alert [n -ES]\n",
  "ALERTNESSES": "ALERTNESS, the state of being alert [n]\n",
  "ALERTS": "ALERT, to warn [v]\n",
  "ALES": "ALE, a kind of beer, made without using hops as a flavouring, also YILL [n]\n",
  "ALETHIC": "pertaining to truth or possibility [adj]\n",
  "ALEURON": "a protein found in some seeds, also ALEURONE [n -S]\n",
  "ALEURONE": "a protein found in some seeds, also ALEURON [n -S]\n",
  "ALEURONES": "ALEURONE, a protein found in some seeds, also ALEURON [n]\n",
  "ALEURONIC": "of or like aleuron, a protein found in flour [adj]\n",
  "ALEURONS": "ALEURON, a protein found in some seeds, also ALEURONE [n]\n",
  "ALEVIN": "a young fish [n -S]\n",
  "ALEVINS": "ALEVIN, a young fish [n]\n",
  "ALEW": "(Spenser) a greeting cry, halloo [n -S]\n",
  "ALEWASHED": "(Shakespeare) affected by drinking beer [adj]\n",
  "ALEWIFE": "a woman who sells ale [n ALEWIVES]\n",
  "ALEWIVES": "ALEWIFE, a woman who sells ale [n]\n",
  "ALEWS": "ALEW, (Spenser) a greeting cry, halloo [n]\n",
  "ALEXANDER": "a kind of cocktail, as in brandy alexander [n -S]\n",
  "ALEXANDERS": "an umbelliferous plant, the stems of which were formerly eaten as celery is now [n -ES]\n",
  "ALEXANDERSES": "ALEXANDERS, an umbelliferous plant, the stems of which were formerly eaten as celery is now [n]\n",
  "ALEXANDRINE": "(French) a French verse form [n -S]\n",
  "ALEXANDRINES": "ALEXANDRINE, (French) a French verse form [n]\n",
  "ALEXANDRITE": "a gem variety of chrysoberyl which appears green in daylight and red in artificial light [n -S]\n",
  "ALEXANDRITES": "ALEXANDRITE, a gem variety of chrysoberyl which appears green in daylight and red in artificial light [n]\n",
  "ALEXIA": "loss of power to read [n -S]\n",
  "ALEXIAS": "ALEXIA, loss of power to read [n]\n",
  "ALEXIC": "word-blind [adj]\n",
  "ALEXIN": "a substance in the blood which protects against disease, also ALEXINE [n -S]\n",
  "ALEXINE": "a substance in the blood which protects against disease, also ALEXIN [n -S]\n",
  "ALEXINES": "ALEXINE, a substance in the blood which protects against disease, also ALEXIN [n]\n",
  "ALEXINIC": "related to alexin [adj]\n",
  "ALEXINS": "ALEXIN, a substance in the blood which protects against disease, also ALEXINE [n]\n",
  "ALEXIPHARMAKON": "an antidote to poison [n -S]\n",
  "ALEXIPHARMAKONS": "ALEXIPHARMAKON, an antidote to poison [n]\n",
  "ALEXIPHARMIC": "acting as an antidote to poison [adj] / an antidote to poison [n -S]\n",
  "ALEXIPHARMICS": "ALEXIPHARMIC, an antidote to poison [n]\n",
  "ALEXITHYMIA": "an inability to recognize, understand, and describe emotions [n -S]\n",
  "ALEXITHYMIAS": "ALEXITHYMIA, an inability to recognize, understand, and describe emotions [n]\n",
  "ALEYE": "to quell, also ALLAY, ALAY [v ALEYED, ALEYING, ALEYES]\n",
  "ALEYED": "ALEYE, to quell, also ALLAY, ALAY [v]\n",
  "ALEYES": "ALEYE, to quell, also ALLAY, ALAY [v]\n",
  "ALEYING": "ALEYE, to quell, also ALLAY, ALAY [v]\n",
  "ALF": "(Australian slang) an uncultivated Australian [n -S]\n",
  "ALFA": "(Arabic) a North African esparto grass, also HALFA [n -S]\n",
  "ALFAKI": "(Arabic) a teacher of Muslim law, also ALFAQUI, ALFAQUIN [n -S]\n",
  "ALFAKIS": "ALFAKI, (Arabic) a teacher of Muslim law, also ALFAQUI, ALFAQUIN [n]\n",
  "ALFALFA": "(Arabic) the fodder plant lucerne [n -S]\n",
  "ALFALFAS": "ALFALFA, (Arabic) the fodder plant lucerne [n]\n",
  "ALFAQUI": "(Arabic) a teacher of Muslim law, also ALFAKI, ALFAQUIN [n -S]\n",
  "ALFAQUIN": "(Arabic) a teacher of Muslim law, also ALFAKI, ALFAQUI [n -S]\n",
  "ALFAQUINS": "ALFAQUIN, (Arabic) a teacher of Muslim law, also ALFAKI, ALFAQUI [n]\n",
  "ALFAQUIS": "ALFAQUI, (Arabic) a teacher of Muslim law, also ALFAKI, ALFAQUIN [n]\n",
  "ALFAS": "ALFA, (Arabic) a North African esparto grass, also HALFA [n]\n",
  "ALFERECES": "ALFEREZ, (Arabic) a standard-bearer [n]\n",
  "ALFEREZ": "(Arabic) a standard-bearer [n ALFERECES]\n",
  "ALFILARIA": "(Spanish) a Californian weed, aka pin grass, also ALFILERIA [n -S]\n",
  "ALFILARIAS": "ALFILARIA, (Spanish) a Californian weed, aka pin grass, also ALFILERIA [n]\n",
  "ALFILERIA": "(Spanish) a Californian weed, aka pin grass, also ALFILARIA [n -S]\n",
  "ALFILERIAS": "ALFILERIA, (Spanish) a Californian weed, aka pin grass, also ALFILARIA [n]\n",
  "ALFORJA": "(Arabic) a saddlebag [n -S]\n",
  "ALFORJAS": "ALFORJA, (Arabic) a saddlebag [n]\n",
  "ALFREDO": "cooked with a cheese and egg sauce [adj]\n",
  "ALFRESCO": "(Italian) outdoors [adv]\n",
  "ALFS": "ALF, (Australian slang) an uncultivated Australian [n]\n",
  "ALGA": "(Latin) a seaweed [n ALGAE or ALGAS]\n",
  "ALGAE": "ALGA, (Latin) a seaweed [n]\n",
  "ALGAECIDE": "a substance for killing algae, also ALGICIDE [n -S]\n",
  "ALGAECIDES": "ALGAECIDE, a substance for killing algae, also ALGICIDE [n]\n",
  "ALGAL": "of or like alga, any member of the algae, seaweeds [adj]\n",
  "ALGAROBA": "(Arabic) the carob, a leguminous tree of the Mediterranean region; its edible beans or pods, also ALGARROBA, ALGARROBO [n -S]\n",
  "ALGAROBAS": "ALGAROBA, (Arabic) the carob, a leguminous tree of the Mediterranean region; its edible beans or pods, also ALGARROBA, ALGARROBO [n]\n",
  "ALGARROBA": "(Arabic) the carob, a leguminous tree of the Mediterranean region; its edible beans or pods, also ALGAROBA, ALGARROBO [n -S]\n",
  "ALGARROBAS": "ALGARROBA, (Arabic) the carob, a leguminous tree of the Mediterranean region; its edible beans or pods, also ALGAROBA, ALGARROBO [n]\n",
  "ALGARROBO": "(Arabic) the carob, a leguminous tree of the Mediterranean region; its edible beans or pods, also ALGAROBA, ALGARROBA [n -S]\n",
  "ALGARROBOS": "ALGARROBO, (Arabic) the carob, a leguminous tree of the Mediterranean region; its edible beans or pods, also ALGAROBA, ALGARROBA [n]\n",
  "ALGAS": "ALGA, (Latin) a seaweed [n]\n",
  "ALGATE": "(obsolete) always; wholly; everywhere, also ALGATES [adv]\n",
  "ALGATES": "(obsolete) always; wholly; everywhere, also ALGATE [adv]\n",
  "ALGEBRA": "(Arabic) a method of calculating by symbols [n -S]\n",
  "ALGEBRAIC": "relating to algebra, also ALGEBRAICAL [adj ALGEBRAICALLY]\n",
  "ALGEBRAICAL": "relating to algebra, also ALGEBRAIC [adj ALGEBRAICALLY]\n",
  "ALGEBRAICALLY": "ALGEBRAICAL, relating to algebra, also ALGEBRAIC [adv]\n",
  "ALGEBRAIST": "one versed in algebra [n -S]\n",
  "ALGEBRAISTS": "ALGEBRAIST, one versed in algebra [n]\n",
  "ALGEBRAS": "ALGEBRA, (Arabic) a method of calculating by symbols [n]\n",
  "ALGERINE": "a kind of woollen fabric [n -S]\n",
  "ALGERINES": "ALGERINE, a kind of woollen fabric [n]\n",
  "ALGESES": "ALGESIS, the sensation of pain [n]\n",
  "ALGESIA": "sensitivity to pain [n -S]\n",
  "ALGESIAS": "ALGESIA, sensitivity to pain [n]\n",
  "ALGESIC": "relating to algesia, sensitivity to pain, also ALGETIC [adj]\n",
  "ALGESIS": "the sensation of pain [n ALGESES]\n",
  "ALGETIC": "relating to algesia, sensitivity to pain, also ALGESIC [adj]\n",
  "ALGICIDAL": "having the property of killing algae [adj]\n",
  "ALGICIDE": "a substance used to kill algae [n -S]\n",
  "ALGICIDES": "ALGICIDE, a substance used to kill algae [n]\n",
  "ALGID": "cold or chill, esp. applied to a cold fit in disease [adj]\n",
  "ALGIDITIES": "ALGIDITY, chilliness, esp. during fever [n]\n",
  "ALGIDITY": "chilliness, esp. during fever [n ALGIDITIES]\n",
  "ALGIDNESS": "the state of being algid [n -ES]\n",
  "ALGIDNESSES": "ALGIDNESS, the state of being algid [n]\n",
  "ALGIN": "sodium alginate, a gummy nitrogenous organic compound obtained from seaweeds [n -S]\n",
  "ALGINATE": "a salt of alginic acid [n -S]\n",
  "ALGINATES": "ALGINATE, a salt of alginic acid [n]\n",
  "ALGINIC": "as in alginic acid, an acid obtained from certain seaweeds [adj]\n",
  "ALGINS": "ALGIN, sodium alginate, a gummy nitrogenous organic compound obtained from seaweeds [n]\n",
  "ALGOID": "of the nature of, or resembling, an alga [adj]\n",
  "ALGOLAGNIA": "a perversion (as sadism or masochism) characterized by pleasure and esp. sexual gratification in inflicting or suffering pain [n -S]\n",
  "ALGOLAGNIAC": "one who suffers from algolagnia [n -S]\n",
  "ALGOLAGNIACS": "ALGOLAGNIAC, one who suffers from algolagnia [n]\n",
  "ALGOLAGNIAS": "ALGOLAGNIA, a perversion (as sadism or masochism) characterized by pleasure and esp. sexual gratification in inflicting or suffering pain [n]\n",
  "ALGOLAGNIC": "relating to algolagnia [adj]\n",
  "ALGOLAGNIST": "one who derives sexual gratification from pain [n -S]\n",
  "ALGOLAGNISTS": "ALGOLAGNIST, one who derives sexual gratification from pain [n]\n",
  "ALGOLOGICAL": "relating to algology, the study of algae [adj ALGOLOGICALLY]\n",
  "ALGOLOGICALLY": "ALGOLOGICAL, relating to algology, the study of algae [adv]\n",
  "ALGOLOGIES": "ALGOLOGY, the study of algae [n]\n",
  "ALGOLOGIST": "one learned about algae; a student of algology [n -S]\n",
  "ALGOLOGISTS": "ALGOLOGIST, one learned about algae; a student of algology [n]\n",
  "ALGOLOGY": "the study of algae [n ALGOLOGIES]\n",
  "ALGOMETER": "an instrument for measuring sensitivity to pressure or pain [n -S]\n",
  "ALGOMETERS": "ALGOMETER, an instrument for measuring sensitivity to pressure or pain [n]\n",
  "ALGOMETRIES": "ALGOMETRY, the measurement of sensitivity to pressure or pain [n]\n",
  "ALGOMETRY": "the measurement of sensitivity to pressure or pain [n ALGOMETRIES]\n",
  "ALGOPHOBIA": "a morbid fear of pain [n -S]\n",
  "ALGOPHOBIAS": "ALGOPHOBIA, a morbid fear of pain [n]\n",
  "ALGOR": "coldness; a shivering fit, esp. that experienced at the onset of a fever [n -S]\n",
  "ALGORISM": "(Arabic) the Arabic system of numeration [n -S]\n",
  "ALGORISMIC": "relating to algorism [adj]\n",
  "ALGORISMS": "ALGORISM, (Arabic) the Arabic system of numeration [n]\n",
  "ALGORITHM": "a step-by-step procedure for solving a particular problem or set of problems [n -S]\n",
  "ALGORITHMIC": "relating to an algorithm [adj ALGORITHMICALLY]\n",
  "ALGORITHMICALLY": "ALGORITHMIC, relating to an algorithm [adv]\n",
  "ALGORITHMS": "ALGORITHM, a step-by-step procedure for solving a particular problem or set of problems [n]\n",
  "ALGORS": "ALGOR, coldness; a shivering fit, esp. that experienced at the onset of a fever [n]\n",
  "ALGUACIL": "(Arabic) a Spanish arresting officer, also ALGUAZIL [n -S]\n",
  "ALGUACILS": "ALGUACIL, (Arabic) a Spanish arresting officer, also ALGUAZIL [n]\n",
  "ALGUAZIL": "(Arabic) a Spanish arresting officer, also ALGUACIL [n -S]\n",
  "ALGUAZILS": "ALGUAZIL, (Arabic) a Spanish arresting officer, also ALGUACIL [n]\n",
  "ALGUM": "(Hebrew) a wood imported into ancient Palestine, probably red sandalwood, also ALMUG [n -S]\n",
  "ALGUMS": "ALGUM, (Hebrew) a wood imported into ancient Palestine, probably red sandalwood, also ALMUG [n]\n",
  "ALIAS": "(Latin) an assumed name [n -ES] / to assume an alternative name [v ALIASED, ALIASING, ALIASED]\n",
  "ALIASED": "ALIAS, to assume an alternative name [v]\n",
  "ALIASES": "ALIAS, (Latin) an assumed name [n]\n",
  "ALIASING": "image imperfections resulting from limited detail in e.g. a raster display [n -S]\n",
  "ALIASINGS": "ALIASING, image imperfections resulting from limited detail in e.g. a raster display [n]\n",
  "ALIBI": "the plea in a criminal charge of having been elsewhere at the relevant time [n -S] / to give an alibi to [v ALIBIED, ALIBIING, ALIBIS or ALIBIES]\n",
  "ALIBIED": "ALIBI, to give an alibi to [v]\n",
  "ALIBIES": "ALIBI, to give an alibi to [v]\n",
  "ALIBIING": "ALIBI, to give an alibi to [v]\n",
  "ALIBIS": "ALIBI, to give an alibi to [v]\n",
  "ALIBLE": "nourishing [adj]\n",
  "ALICANT": "(Spanish) a wine made near Alicante in Spain [n -S]\n",
  "ALICANTS": "ALICANT, (Spanish) a wine made near Alicante in Spain [n]\n",
  "ALICYCLIC": "denoting organic compounds that are both aliphatic and cyclic, i.e. aliphatic in chemical behaviour but having their carbon atoms in a ring, also CYCLOALIPHATIC [adj]\n",
  "ALIDAD": "(Arabic) a device used in angular measurement, also ALIDADE [n -S]\n",
  "ALIDADE": "(Arabic) a device used in angular measurement, also ALIDAD [n -S]\n",
  "ALIDADES": "ALIDADE, (Arabic) a device used in angular measurement, also ALIDAD [n]\n",
  "ALIDADS": "ALIDAD, (Arabic) a device used in angular measurement, also ALIDADE [n]\n",
  "ALIEN": "foreign [adj ALIENLY] / to alienate [v -ED, -ING, -S]\n",
  "ALIENABILITIES": "ALIENABILITY, the ability to be alienated [n]\n",
  "ALIENABILITY": "the ability to be alienated [n ALIENABILITIES]\n",
  "ALIENABLE": "capable of being alienated, sold, or transferred to another; as, land is alienable according to the laws of the state [adj]\n",
  "ALIENAGE": "the state of being foreign, also ALIENISM [n -S]\n",
  "ALIENAGES": "ALIENAGE, the state of being foreign, also ALIENISM [n]\n",
  "ALIENATE": "to make indifferent or unfriendly [v ALIENATED, ALIENATING, ALIENATES]\n",
  "ALIENATED": "ALIENATE, to make indifferent or unfriendly [v]\n",
  "ALIENATES": "ALIENATE, to make indifferent or unfriendly [v]\n",
  "ALIENATING": "ALIENATE, to make indifferent or unfriendly [v]\n",
  "ALIENATION": "a separation of a person's affections from an object of former attachment [n -S]\n",
  "ALIENATIONS": "ALIENATION, a separation of a person's affections from an object of former attachment [n]\n",
  "ALIENATOR": "one who alienates [n -S]\n",
  "ALIENATORS": "ALIENATOR, one who alienates [n]\n",
  "ALIENED": "ALIEN, to alienate [v]\n",
  "ALIENEE": "one to whom the title of property is transferred, as opposed to alienor [n -S]\n",
  "ALIENEES": "ALIENEE, one to whom the title of property is transferred, as opposed to alienor [n]\n",
  "ALIENER": "one that transfers property [n -S]\n",
  "ALIENERS": "ALIENER, one that transfers property [n]\n",
  "ALIENING": "ALIEN, to alienate [v]\n",
  "ALIENISM": "the state of being foreign, also ALIENAGE [n -S]\n",
  "ALIENISMS": "ALIENISM, the state of being foreign, also ALIENAGE [n]\n",
  "ALIENIST": "a psychiatrist specialising in legal aspects of mental illness [n -S]\n",
  "ALIENISTS": "ALIENIST, a psychiatrist specialising in legal aspects of mental illness [n]\n",
  "ALIENLY": "ALIEN, foreign [adv]\n",
  "ALIENNESS": "the state of being alien [n -ES]\n",
  "ALIENNESSES": "ALIENNESS, the state of being alien [n]\n",
  "ALIENOR": "a person who transfers property, also ALIENER [n -S]\n",
  "ALIENORS": "ALIENOR, a person who transfers property, also ALIENER [n]\n",
  "ALIENS": "ALIEN, to alienate [v]\n",
  "ALIF": "(Arabic) an Arabic letter [n -S]\n",
  "ALIFORM": "wing-shaped [adj]\n",
  "ALIFS": "ALIF, (Arabic) an Arabic letter [n]\n",
  "ALIGARTA": "(obsolete) an alligator [n -S]\n",
  "ALIGARTAS": "ALIGARTA, (obsolete) an alligator [n]\n",
  "ALIGHT": "to dismount [v ALIGHTED or ALIT, ALIGHTING, ALIGHTS]\n",
  "ALIGHTED": "ALIGHT, to dismount [v]\n",
  "ALIGHTING": "ALIGHT, to dismount [v]\n",
  "ALIGHTMENT": "act of alighting [n -S]\n",
  "ALIGHTMENTS": "ALIGHTMENT, act of alighting [n]\n",
  "ALIGHTS": "ALIGHT, to dismount [v]\n",
  "ALIGN": "to arrange in line [v -ED, -ING, -S]\n",
  "ALIGNED": "ALIGN, to arrange in line [v]\n",
  "ALIGNER": "one who aligns, also ALINER [n -S]\n",
  "ALIGNERS": "ALIGNER, one who aligns, also ALINER [n]\n",
  "ALIGNING": "ALIGN, to arrange in line [v]\n",
  "ALIGNMENT": "the action of aligning, also ALINEMENT [n -S]\n",
  "ALIGNMENTS": "ALIGNMENT, the action of aligning, also ALINEMENT [n]\n",
  "ALIGNS": "ALIGN, to arrange in line [v]\n",
  "ALIKE": "having close resemblance [adj]\n",
  "ALIKENESS": "the state of being alike [n -ES]\n",
  "ALIKENESSES": "ALIKENESS, the state of being alike [n]\n",
  "ALIMENT": "food, nourishment [n -S] / to feed, nourish [v -ED, -ING, -S]\n",
  "ALIMENTAL": "affording food [adj]\n",
  "ALIMENTARY": "pertaining to food; nourishing [adj]\n",
  "ALIMENTATION": "the act of feeding or being fed [n -S]\n",
  "ALIMENTATIONS": "ALIMENTATION, the act of feeding or being fed [n]\n",
  "ALIMENTATIVE": "nourishing [adj]\n",
  "ALIMENTED": "ALIMENT, to feed, nourish [v]\n",
  "ALIMENTING": "ALIMENT, to feed, nourish [v]\n",
  "ALIMENTIVENESS": "a phrenologist's word for the instinct to seek food or drink [n]\n",
  "ALIMENTS": "ALIMENT, to feed, nourish [v]\n",
  "ALIMONIED": "provided with an alimony [adj]\n",
  "ALIMONIES": "ALIMONY, an allowance paid to a partner after divorce [n]\n",
  "ALIMONY": "an allowance paid to a partner after divorce [n ALIMONIES]\n",
  "ALINE": "to arrange in a straight line [v ALINED, ALINING, ALINES]\n",
  "ALINEATION": "alignment, also ALLINEATION [n -S]\n",
  "ALINEATIONS": "ALINEATION, alignment, also ALLINEATION [n]\n",
  "ALINED": "ALINE, to arrange in a straight line [v]\n",
  "ALINEMENT": "the action of alining, also ALIGNMENT [n -S]\n",
  "ALINEMENTS": "ALINEMENT, the action of alining, also ALIGNMENT [n]\n",
  "ALINER": "one who alines, also ALIGNER [n -S]\n",
  "ALINERS": "ALINER, one who alines, also ALIGNER [n]\n",
  "ALINES": "ALINE, to arrange in a straight line [v]\n",
  "ALINING": "ALINE, to arrange in a straight line [v]\n",
  "ALIPED": "an animal with winged feet [n -S]\n",
  "ALIPEDS": "ALIPED, an animal with winged feet [n]\n",
  "ALIPHATIC": "pertaining to fat or fats in general [adj]\n",
  "ALIQUANT": "(Latin) not dividing equally into another number [adj]\n",
  "ALIQUOT": "(Latin) a number that divides into another without leaving a remainder [n -S]\n",
  "ALIQUOTS": "ALIQUOT, (Latin) a number that divides into another without leaving a remainder [n]\n",
  "ALISMA": "(Greek) a plant of the water-plantain genus [n -S]\n",
  "ALISMACEOUS": "belonging to the water-plantain genus Alisma [adj]\n",
  "ALISMAS": "ALISMA, (Greek) a plant of the water-plantain genus [n]\n",
  "ALISON": "a small flowering plant, sweet alyssum [n -S]\n",
  "ALISONS": "ALISON, a small flowering plant, sweet alyssum [n]\n",
  "ALIST": "leaning to one side [adj]\n",
  "ALIT": "ALIGHT, to dismount [v]\n",
  "ALITERACIES": "ALITERACY, the state of being nonliterate [n]\n",
  "ALITERACY": "the state of being nonliterate [n ALITERACIES]\n",
  "ALITERATE": "not literate [adj] / one who is nonliterate [n -S]\n",
  "ALITERATES": "ALITERATE, one who is nonliterate [n]\n",
  "ALIUNDE": "(Latin) from another source [adv]\n",
  "ALIVE": "living [adj]\n",
  "ALIVENESS": "the state of being alive [n -ES]\n",
  "ALIVENESSES": "ALIVENESS, the state of being alive [n]\n",
  "ALIYA": "(Hebrew) the immigration of Jews to Israel, also ALIYAH [n ALIYAS or ALIYOS or ALIYOT or ALIYOTH]\n",
  "ALIYAH": "(Hebrew) the immigration of Jews to Israel, also ALIYA [n ALIYAHS, ALIYOS, ALIYOT or ALIYOTH]\n",
  "ALIYAHS": "ALIYAH, (Hebrew) the immigration of Jews to Israel, also ALIYA [n]\n",
  "ALIYAS": "ALIYA, (Hebrew) the immigration of Jews to Israel, also ALIYAH [n]\n",
  "ALIYOS": "ALIYA, (Hebrew) the immigration of Jews to Israel, also ALIYAH [n]\n",
  "ALIYOT": "ALIYA, (Hebrew) the immigration of Jews to Israel, also ALIYAH [n]\n",
  "ALIYOTH": "ALIYA, (Hebrew) the immigration of Jews to Israel, also ALIYAH [n]\n",
  "ALIZARI": "a Mediterranean plant which yields a dye [n -S]\n",
  "ALIZARIN": "(Arabic) a colouring principle found in madder, and now made artificially, also ALIZARINE [n -S]\n",
  "ALIZARINE": "(Arabic) a colouring principle found in madder, and now made artificially, also ALIZARIN [n -S]\n",
  "ALIZARINES": "ALIZARINE, (Arabic) a colouring principle found in madder, and now made artificially, also ALIZARIN [n]\n",
  "ALIZARINS": "ALIZARIN, (Arabic) a colouring principle found in madder, and now made artificially, also ALIZARINE [n]\n",
  "ALIZARIS": "ALIZARI, a Mediterranean plant which yields a dye [n]\n",
  "ALKAHEST": "(Arabic) the hypothetical universal solvent sought by alchemists, also ALCAHEST [n -S]\n",
  "ALKAHESTIC": "having the properties of an alkahest [adj]\n",
  "ALKAHESTS": "ALKAHEST, (Arabic) the hypothetical universal solvent sought by alchemists, also ALCAHEST [n]\n",
  "ALKALESCENCE": "the state of being alkalescent, also ALKALESCENCY [n -S]\n",
  "ALKALESCENCES": "ALKALESCENCE, the state of being alkalescent, also ALKALESCENCY [n]\n",
  "ALKALESCENCIES": "ALKALESCENCY, the state of being alkalescent, also ALKALESCENCE [n]\n",
  "ALKALESCENCY": "the state of being alkalescent, also ALKALESCENCE [n ALKALESCENCIES]\n",
  "ALKALESCENT": "tending to become alkaline; slightly alkaline [adj]\n",
  "ALKALI": "(Arabic) a substance which, dissolved in water, forms a solution containing hydroxyl ions and with a pH of more than 7 [n ALKALIES or ALKALIS]\n",
  "ALKALIC": "of a rock or mineral, containing large amounts of alkali, also ALKALIN [adj]\n",
  "ALKALIES": "ALKALI, (Arabic) a substance which, dissolved in water, forms a solution containing hydroxyl ions and with a pH of more than 7 [n]\n",
  "ALKALIFIED": "ALKALIFY, to convert into an alkali, also ALKALISE, ALKALIZE [v]\n",
  "ALKALIFIES": "ALKALIFY, to convert into an alkali, also ALKALISE, ALKALIZE [v]\n",
  "ALKALIFY": "to convert into an alkali, also ALKALISE, ALKALIZE [v ALKALIFIED, ALKALIFYING, ALKALIFIES]\n",
  "ALKALIFYING": "ALKALIFY, to convert into an alkali, also ALKALISE, ALKALIZE [v]\n",
  "ALKALIMETER": "an instrument for measuring the strength of alkalis [n -S]\n",
  "ALKALIMETERS": "ALKALIMETER, an instrument for measuring the strength of alkalis [n]\n",
  "ALKALIMETRIC": "relating to alkalimetry, the measurement of the strength of alkalies [adj]\n",
  "ALKALIMETRIES": "ALKALIMETRY, the measurement of the strength of alkalies [n]\n",
  "ALKALIMETRY": "the measurement of the strength of alkalies [n ALKALIMETRIES]\n",
  "ALKALIN": "containing an alkali, also ALKALINE [adj]\n",
  "ALKALINE": "containing an alkali, also ALKALIN [adj]\n",
  "ALKALINISATION": "the process of making alkaline, also ALKALINIZATION [n -S]\n",
  "ALKALINISATIONS": "ALKALINISATION, the process of making alkaline, also ALKALINIZATION [n]\n",
  "ALKALINISE": "to make alkaline, also ALKALINIZE [v ALKALINISED, ALKALINISING, ALKALINISES]\n",
  "ALKALINISED": "ALKALINISE, to make alkaline, also ALKALINIZE [v]\n",
  "ALKALINISES": "ALKALINISE, to make alkaline, also ALKALINIZE [v]\n",
  "ALKALINISING": "ALKALINISE, to make alkaline, also ALKALINIZE [v]\n",
  "ALKALINITIES": "ALKALINITY, the state of being alkaline [n]\n",
  "ALKALINITY": "the state of being alkaline [n ALKALINITIES]\n",
  "ALKALINIZATION": "the process of alkalinizing, also ALKALINISATION [n -S]\n",
  "ALKALINIZATIONS": "ALKALINIZATION, the process of alkalinizing, also ALKALINISATION [n]\n",
  "ALKALINIZE": "to make alkaline [v ALKALINIZED, ALKALINIZING, ALKALINIZES]\n",
  "ALKALINIZED": "ALKALINIZE, to make alkaline [v]\n",
  "ALKALINIZES": "ALKALINIZE, to make alkaline [v]\n",
  "ALKALINIZING": "ALKALINIZE, to make alkaline [v]\n",
  "ALKALIS": "ALKALI, (Arabic) a substance which, dissolved in water, forms a solution containing hydroxyl ions and with a pH of more than 7 [n]\n",
  "ALKALISABLE": "that can be alkalised, also ALKALIZABLE [adj]\n",
  "ALKALISE": "to convert into an alkali, also ALKALIFY, ALKALIZE [v ALKALISED, ALKALISING, ALKALISES]\n",
  "ALKALISED": "ALKALISE, to convert into an alkali, also ALKALIFY, ALKALIZE [v]\n",
  "ALKALISER": "an agent that alkalises, also ALKALIZER [n -S]\n",
  "ALKALISERS": "ALKALISER, an agent that alkalises, also ALKALIZER [n]\n",
  "ALKALISES": "ALKALISE, to convert into an alkali, also ALKALIFY, ALKALIZE [v]\n",
  "ALKALISING": "ALKALISE, to convert into an alkali, also ALKALIFY, ALKALIZE [v]\n",
  "ALKALIZABLE": "that can be alkalized, also ALKALISABLE [adj]\n",
  "ALKALIZE": "to convert into an alkali, also ALKALISE, ALKALIFY [v ALKALIZED, ALKALIZING, ALKALIZES]\n",
  "ALKALIZED": "ALKALIZE, to convert into an alkali, also ALKALISE, ALKALIFY [v]\n",
  "ALKALIZER": "an agent that alkalizes, also ALKALISER [n -S]\n",
  "ALKALIZERS": "ALKALIZER, an agent that alkalizes, also ALKALISER [n]\n",
  "ALKALIZES": "ALKALIZE, to convert into an alkali, also ALKALISE, ALKALIFY [v]\n",
  "ALKALIZING": "ALKALIZE, to convert into an alkali, also ALKALISE, ALKALIFY [v]\n",
  "ALKALOID": "any of a class of complex organic bases of vegetable origin [n -S]\n",
  "ALKALOIDAL": "pertaining to, resembling, or containing, alkali [adj]\n",
  "ALKALOIDS": "ALKALOID, any of a class of complex organic bases of vegetable origin [n]\n",
  "ALKALOSES": "ALKALOSIS, an illness in which the blood or tissues of the body become too alkaline [n]\n",
  "ALKALOSIS": "an illness in which the blood or tissues of the body become too alkaline [n ALKALOSES]\n",
  "ALKALOTIC": "affected by alkalosis, an illness in which the blood or tissues of the body become too alkaline [adj]\n",
  "ALKANE": "a group of hydrocarbons, the paraffins, which contains only single bonds between the carbon atoms [n -S]\n",
  "ALKANES": "ALKANE, a group of hydrocarbons, the paraffins, which contains only single bonds between the carbon atoms [n]\n",
  "ALKANET": "(Arabic) a wild flower; a reddish plant-based dye obtained from this, also ALKANNIN [n -S]\n",
  "ALKANETS": "ALKANET, (Arabic) a wild flower; a reddish plant-based dye obtained from this, also ALKANNIN [n]\n",
  "ALKANNIN": "(Arabic) a wild flower; a reddish plant-based dye obtained from this, also ALKANET [n -S]\n",
  "ALKANNINS": "ALKANNIN, (Arabic) a wild flower; a reddish plant-based dye obtained from this, also ALKANET [n]\n",
  "ALKENE": "an unsaturated hydrocarbon of the ethylene series [n -S]\n",
  "ALKENES": "ALKENE, an unsaturated hydrocarbon of the ethylene series [n]\n",
  "ALKIE": "an alcoholic, also ALKY [n -S]\n",
  "ALKIES": "ALKIE, an alcoholic, also ALKY [n]\n",
  "ALKINE": "a group of hydrocarbons that contain at least one carbon-carbon triple bond in its molecules [n -S]\n",
  "ALKINES": "ALKINE, a group of hydrocarbons that contain at least one carbon-carbon triple bond in its molecules [n]\n",
  "ALKO": "(Australian slang) a heavy drinker or alcoholic, also ALCO [n -S]\n",
  "ALKOS": "ALKO, (Australian slang) a heavy drinker or alcoholic, also ALCO [n]\n",
  "ALKOXIDE": "a basic salt derived from an alcohol by the replacement of a hydroxyl hydrogen with a metal [n -S]\n",
  "ALKOXIDES": "ALKOXIDE, a basic salt derived from an alcohol by the replacement of a hydroxyl hydrogen with a metal [n]\n",
  "ALKOXY": "containing a univalent radical of alkyl with oxygen [adj]\n",
  "ALKY": "an alcoholic, also ALKIE [n ALKIES]\n",
  "ALKYD": "any of a group of synthetic resins [n -S]\n",
  "ALKYDS": "ALKYD, any of a group of synthetic resins [n]\n",
  "ALKYL": "any radical derived from an alkane by removal of a hydrogen atom [n -S]\n",
  "ALKYLATE": "to combine with alkyl [v ALKYLATED, ALKYLATING, ALKYLATES]\n",
  "ALKYLATED": "ALKYLATE, to combine with alkyl [v]\n",
  "ALKYLATES": "ALKYLATE, to combine with alkyl [v]\n",
  "ALKYLATING": "ALKYLATE, to combine with alkyl [v]\n",
  "ALKYLATION": "making something an alkylate [n -S]\n",
  "ALKYLATIONS": "ALKYLATION, making something an alkylate [n]\n",
  "ALKYLIC": "having the properties of an alkyl, a type of chemical compound [adj]\n",
  "ALKYLS": "ALKYL, any radical derived from an alkane by removal of a hydrogen atom [n]\n",
  "ALKYNE": "a group of hydrocarbons that contain at least one carbon-carbon triple bond in its molecules [n -S]\n",
  "ALKYNES": "ALKYNE, a group of hydrocarbons that contain at least one carbon-carbon triple bond in its molecules [n]\n",
  "ALL": "the whole [n -S]\n",
  "ALLANITE": "a silicate containing a large amount of cerium [n -S]\n",
  "ALLANITES": "ALLANITE, a silicate containing a large amount of cerium [n]\n",
  "ALLANTOIC": "pertaining to the allantois; sausage-shaped, also ALLANTOIDAL [adj]\n",
  "ALLANTOID": "a saclike fetal membrane developing into umbilical cord and forming part of the placenta, also ALLANTOIS [n -S]\n",
  "ALLANTOIDAL": "pertaining to the allantois; sausage-shaped, also ALLANTOIC [adj]\n",
  "ALLANTOIDES": "ALLANTOID, a saclike fetal membrane developing into umbilical cord and forming part of the placenta, also ALLANTOIS [n]\n",
  "ALLANTOIDS": "ALLANTOID, a saclike fetal membrane developing into umbilical cord and forming part of the placenta, also ALLANTOIS [n]\n",
  "ALLANTOIN": "a crystalline base formed in the nitrogen metabolism of many mammals (excluding primates) [n -S]\n",
  "ALLANTOINS": "ALLANTOIN, a crystalline base formed in the nitrogen metabolism of many mammals (excluding primates) [n]\n",
  "ALLANTOIS": "a saclike fetal membrane developing into umbilical cord and forming part of the placenta, also ALLANTOID [n ALLANTOIDES or ALLANTOISES]\n",
  "ALLANTOISES": "ALLANTOIS, a saclike fetal membrane developing into umbilical cord and forming part of the placenta, also ALLANTOID [n]\n",
  "ALLARGANDO": "(Italian) with slowing tempo [adv]\n",
  "ALLATIVE": "a grammatical case denoting movement towards [n -S]\n",
  "ALLATIVES": "ALLATIVE, a grammatical case denoting movement towards [n]\n",
  "ALLAY": "to reduce in intensity or severity, also ALAY, ALEYE [v -ED, -ING, -S]\n",
  "ALLAYED": "ALLAY, to reduce in intensity or severity, also ALAY, ALEYE [v]\n",
  "ALLAYER": "one who, or that which, allays [n -S]\n",
  "ALLAYERS": "ALLAYER, one who, or that which, allays [n]\n",
  "ALLAYING": "tempering [n -S]\n",
  "ALLAYINGS": "ALLAYING, tempering [n]\n",
  "ALLAYMENT": "an allaying, a mitigation [n -S]\n",
  "ALLAYMENTS": "ALLAYMENT, an allaying, a mitigation [n]\n",
  "ALLAYS": "ALLAY, to reduce in intensity or severity, also ALAY, ALEYE [v]\n",
  "ALLCOMERS": "anyone who comes [n]\n",
  "ALLEDGE": "to allay, also ALEGGE, ALLEGGE [v ALLEDGED, ALLEDGING, ALLEDGES]\n",
  "ALLEDGED": "ALLEDGE, to allay, also ALEGGE, ALLEGGE [v]\n",
  "ALLEDGES": "ALLEDGE, to allay, also ALEGGE, ALLEGGE [v]\n",
  "ALLEDGING": "ALLEDGE, to allay, also ALEGGE, ALLEGGE [v]\n",
  "ALLEE": "(French) an avenue, walk or garden path [n -S]\n",
  "ALLEES": "ALLEE, (French) an avenue, walk or garden path [n]\n",
  "ALLEGATION": "the act of alleging or positively asserting [n -S]\n",
  "ALLEGATIONS": "ALLEGATION, the act of alleging or positively asserting [n]\n",
  "ALLEGE": "to assert without proof [v ALLEGED, ALLEGING, ALLEGES]\n",
  "ALLEGEANCE": "alleviation [n -S]\n",
  "ALLEGEANCES": "ALLEGEANCE, alleviation [n]\n",
  "ALLEGED": "ALLEGE, to assert without proof [v]\n",
  "ALLEGEDLY": "ALLEGED, ALLEGE, to assert without proof [adv]\n",
  "ALLEGER": "one who alleges [n -S]\n",
  "ALLEGERS": "ALLEGER, one who alleges [n]\n",
  "ALLEGES": "ALLEGE, to assert without proof [v]\n",
  "ALLEGGE": "(Spenser) to allay, also ALEGGE, ALLEDGE [v ALLEGGED, ALLEGGING, ALLEGGES]\n",
  "ALLEGGED": "ALLEGGE, (Spenser) to allay, also ALEGGE, ALLEDGE [v]\n",
  "ALLEGGES": "ALLEGGE, (Spenser) to allay, also ALEGGE, ALLEDGE [v]\n",
  "ALLEGGING": "ALLEGGE, (Spenser) to allay, also ALEGGE, ALLEDGE [v]\n",
  "ALLEGIANCE": "the obligation of a feudal vassal to his liege lord [n -S]\n",
  "ALLEGIANCES": "ALLEGIANCE, the obligation of a feudal vassal to his liege lord [n]\n",
  "ALLEGIANT": "(Shakespeare) loyal [adj] / one who is loyal [n -S]\n",
  "ALLEGIANTS": "ALLEGIANT, one who is loyal [n]\n",
  "ALLEGING": "ALLEGE, to assert without proof [v]\n",
  "ALLEGORIC": "having the properties of an allegory, also ALLEGORICAL [adj ALLEGORICALLY]\n",
  "ALLEGORICAL": "having the properties of an allegory, also ALLEGORIC [adj ALLEGORICALLY]\n",
  "ALLEGORICALLY": "ALLEGORICAL, having the properties of an allegory, also ALLEGORIC [adv]\n",
  "ALLEGORICALNESS": "the state of being allegorical [n]\n",
  "ALLEGORIES": "ALLEGORY, a story presenting a moral principle [n]\n",
  "ALLEGORISATION": "the act of making allegorical, also ALLEGORIZATION [n -S]\n",
  "ALLEGORISATIONS": "ALLEGORISATION, the act of making allegorical, also ALLEGORIZATION [n]\n",
  "ALLEGORISE": "to make an allegory of, also ALLEGORIZE [v ALLEGORISED, ALLEGORISING, ALLEGORISES]\n",
  "ALLEGORISED": "ALLEGORISE, to make an allegory of, also ALLEGORIZE [v]\n",
  "ALLEGORISER": "one who allegorises, also ALLEGORIZER [n -S]\n",
  "ALLEGORISERS": "ALLEGORISER, one who allegorises, also ALLEGORIZER [n]\n",
  "ALLEGORISES": "ALLEGORISE, to make an allegory of, also ALLEGORIZE [v]\n",
  "ALLEGORISING": "ALLEGORISE, to make an allegory of, also ALLEGORIZE [v]\n",
  "ALLEGORIST": "one who composes allegories [n -S]\n",
  "ALLEGORISTS": "ALLEGORIST, one who composes allegories [n]\n",
  "ALLEGORIZATION": "the act of making allegorical, also ALLEGORISATION [n -S]\n",
  "ALLEGORIZATIONS": "ALLEGORIZATION, the act of making allegorical, also ALLEGORISATION [n]\n",
  "ALLEGORIZE": "to make an allegory of, also ALLEGORISE [v ALLEGORIZED, ALLEGORIZING, ALLEGORIZES]\n",
  "ALLEGORIZED": "ALLEGORIZE, to make an allegory of, also ALLEGORISE [v]\n",
  "ALLEGORIZER": "one who allegorizes, also ALLEGORISER [n -S]\n",
  "ALLEGORIZERS": "ALLEGORIZER, one who allegorizes, also ALLEGORISER [n]\n",
  "ALLEGORIZES": "ALLEGORIZE, to make an allegory of, also ALLEGORISE [v]\n",
  "ALLEGORIZING": "ALLEGORIZE, to make an allegory of, also ALLEGORISE [v]\n",
  "ALLEGORY": "a story presenting a moral principle [n ALLEGORIES]\n",
  "ALLEGRETTO": "(Italian) a musical piece quicker than andante, but not so quick as allegro [n -S]\n",
  "ALLEGRETTOS": "ALLEGRETTO, (Italian) a musical piece quicker than andante, but not so quick as allegro [n]\n",
  "ALLEGRO": "(Italian) a musical passage to be played in rapid tempo [n -S]\n",
  "ALLEGROS": "ALLEGRO, (Italian) a musical passage to be played in rapid tempo [n]\n",
  "ALLEL": "(short for) allelomorph, any one of the two or more possible forms of a gene, also ALLELE, ALLELOMORPH [n -S]\n",
  "ALLELE": "any one of the two or more possible forms of a gene, also ALLEL, ALLELOMORPH [n -S]\n",
  "ALLELES": "ALLELE, any one of the two or more possible forms of a gene, also ALLEL, ALLELOMORPH [n]\n",
  "ALLELIC": "relating to an allele [adj]\n",
  "ALLELISM": "the state of possessing alleles [n -S]\n",
  "ALLELISMS": "ALLELISM, the state of possessing alleles [n]\n",
  "ALLELOMORPH": "any one of the two or more possible forms of a gene, also ALLEL, ALLELE [n -S]\n",
  "ALLELOMORPHIC": "of or like an allelomorph [adj]\n",
  "ALLELOMORPHISM": "the state of being an allelomorph [n -S]\n",
  "ALLELOMORPHISMS": "ALLELOMORPHISM, the state of being an allelomorph [n]\n",
  "ALLELOMORPHS": "ALLELOMORPH, any one of the two or more possible forms of a gene, also ALLEL, ALLELE [n]\n",
  "ALLELOPATHIC": "relating to allelopathy [adj]\n",
  "ALLELOPATHIES": "ALLELOPATHY, an adverse influence exerted either by one individual plant over another by the production of a chemical inhibitor [n]\n",
  "ALLELOPATHY": "an adverse influence exerted either by one individual plant over another by the production of a chemical inhibitor [n ALLELOPATHIES]\n",
  "ALLELS": "ALLEL, (short for) allelomorph, any one of the two or more possible forms of a gene, also ALLELE, ALLELOMORPH [n]\n",
  "ALLELUIA": "(Hebrew) a song of praise to God, also ALLELUIAH, HALLELUIAH, HALLELUJAH [n -S]\n",
  "ALLELUIAH": "(Hebrew) a song of praise to God, also ALLELUIA, HALLELUIAH, HALLELUJAH [n -S]\n",
  "ALLELUIAHS": "ALLELUIAH, (Hebrew) a song of praise to God, also ALLELUIA, HALLELUIAH, HALLELUJAH [n]\n",
  "ALLELUIAS": "ALLELUIA, (Hebrew) a song of praise to God, also ALLELUIAH, HALLELUIAH, HALLELUJAH [n]\n",
  "ALLEMANDE": "(French) a courtly baroque dance in which the arms are interlaced, also ALMAIN [n -S]\n",
  "ALLEMANDES": "ALLEMANDE, (French) a courtly baroque dance in which the arms are interlaced, also ALMAIN [n]\n",
  "ALLENARLY": "(Scots) solely, only [adv]\n",
  "ALLERGEN": "a substance that induces an allergic reaction, also ALLERGIN [n -S]\n",
  "ALLERGENIC": "causing an allergic reaction [adj]\n",
  "ALLERGENICITIES": "ALLERGENICITY, the state of being an allergen [n]\n",
  "ALLERGENICITY": "the state of being an allergen [n ALLERGENICITIES]\n",
  "ALLERGENS": "ALLERGEN, a substance that induces an allergic reaction, also ALLERGIN [n]\n",
  "ALLERGIC": "suffering from an allergy [adj] / one who suffers from an allergy [n -S]\n",
  "ALLERGICS": "ALLERGIC, one who suffers from an allergy [n]\n",
  "ALLERGIES": "ALLERGY, a state of hypersensitive reaction to certain things [n]\n",
  "ALLERGIN": "a substance that induces an allergic reaction, also ALLERGEN [n -S]\n",
  "ALLERGINS": "ALLERGIN, a substance that induces an allergic reaction, also ALLERGEN [n]\n",
  "ALLERGIST": "a doctor specialising in conditions caused by allergies [n -S]\n",
  "ALLERGISTS": "ALLERGIST, a doctor specialising in conditions caused by allergies [n]\n",
  "ALLERGY": "a state of hypersensitive reaction to certain things [n ALLERGIES]\n",
  "ALLERION": "(French) in heraldry, an eagle displayed without feet or beak, also ALERION [n -S]\n",
  "ALLERIONS": "ALLERION, (French) in heraldry, an eagle displayed without feet or beak, also ALERION [n]\n",
  "ALLETHRIN": "a light yellow viscous oily insecticide [n -S]\n",
  "ALLETHRINS": "ALLETHRIN, a light yellow viscous oily insecticide [n]\n",
  "ALLEVIANT": "a medical treatment that relieves pain but does not cure the underlying problem [n -S]\n",
  "ALLEVIANTS": "ALLEVIANT, a medical treatment that relieves pain but does not cure the underlying problem [n]\n",
  "ALLEVIATE": "to lighten, relieve [v ALLEVIATED, ALLEVIATING, ALLEVIATES]\n",
  "ALLEVIATED": "ALLEVIATE, to lighten, relieve [v]\n",
  "ALLEVIATES": "ALLEVIATE, to lighten, relieve [v]\n",
  "ALLEVIATING": "ALLEVIATE, to lighten, relieve [v]\n",
  "ALLEVIATION": "the process of alleviating [n -S]\n",
  "ALLEVIATIONS": "ALLEVIATION, the process of alleviating [n]\n",
  "ALLEVIATIVE": "tending to alleviate, also ALLEVIATORY [adj]\n",
  "ALLEVIATOR": "one who, or that which, alleviates [n -S]\n",
  "ALLEVIATORS": "ALLEVIATOR, one who, or that which, alleviates [n]\n",
  "ALLEVIATORY": "tending to alleviate, also ALLEVIATIVE [adj]\n",
  "ALLEY": "a narrow passageway, also ALLEYWAY [n -S]\n",
  "ALLEYCAT": "a cat who lives in alleys [n -S]\n",
  "ALLEYCATS": "ALLEYCAT, a cat who lives in alleys [n]\n",
  "ALLEYED": "furnished with alleys; forming an alley [adj]\n",
  "ALLEYS": "ALLEY, a narrow passageway, also ALLEYWAY [n]\n",
  "ALLEYWAY": "a narrow passageway, also ALLEY [n -S]\n",
  "ALLEYWAYS": "ALLEYWAY, a narrow passageway, also ALLEY [n]\n",
  "ALLHALLOND": "as in allhallond summer, a spell of fine weather about All Hallows, also ALLHALLOWEN, ALLHALLOWN, ALLHOLLOWN [adj]\n",
  "ALLHALLOWEN": "as in allhallowen summer, a spell of fine weather about All Hallows, also ALLHALLOND, ALLHALLOWN, ALLHOLLOWN [adj]\n",
  "ALLHALLOWN": "as in allhallown summer, a spell of fine weather about All Hallows, also ALLHALLOND, ALLHALLOWEN, ALLHOLLOWN [adj]\n",
  "ALLHEAL": "a medicinal herb [n -S]\n",
  "ALLHEALS": "ALLHEAL, a medicinal herb [n]\n",
  "ALLHOLLOWN": "as in allhollown summer, a spell of fine weather about All Hallows, also ALLHALLOND, ALLHALLOWEN, ALLHALLOWN [adj]\n",
  "ALLIABLE": "capable of being allied [adj]\n",
  "ALLIACEOUS": "of or relating to garlic [adj]\n",
  "ALLIAK": "(Inuit) an Inuit sledge [n -S]\n",
  "ALLIAKS": "ALLIAK, (Inuit) an Inuit sledge [n]\n",
  "ALLIANCE": "an association formed to further the common interests of its members [n -S]\n",
  "ALLIANCES": "ALLIANCE, an association formed to further the common interests of its members [n]\n",
  "ALLICE": "a fish of the shad family, also ALLIS [n -S]\n",
  "ALLICES": "ALLICE, a fish of the shad family, also ALLIS [n]\n",
  "ALLICHOLIES": "ALLICHOLY, (Shakespeare) melancholy, also ALLYCHOLLY [n]\n",
  "ALLICHOLY": "(Shakespeare) melancholy, also ALLYCHOLLY [n ALLICHOLIES]\n",
  "ALLICIN": "a liquid compound formed from garlic [n -S]\n",
  "ALLICINS": "ALLICIN, a liquid compound formed from garlic [n]\n",
  "ALLIED": "ALLY, to join by marriage, friendship, treaty etc. [v]\n",
  "ALLIES": "ALLY, to join by marriage, friendship, treaty etc. [v]\n",
  "ALLIGARTA": "(obsolete) an alligator, also ALIGARTA [n -S]\n",
  "ALLIGARTAS": "ALLIGARTA, (obsolete) an alligator, also ALIGARTA [n]\n",
  "ALLIGATE": "to unite by some tie [v ALLIGATED, ALLIGATING, ALLIGATES]\n",
  "ALLIGATED": "ALLIGATE, to unite by some tie [v]\n",
  "ALLIGATES": "ALLIGATE, to unite by some tie [v]\n",
  "ALLIGATING": "ALLIGATE, to unite by some tie [v]\n",
  "ALLIGATION": "the calculation of values or properties of a mixture [n -S]\n",
  "ALLIGATIONS": "ALLIGATION, the calculation of values or properties of a mixture [n]\n",
  "ALLIGATOR": "a reptile of a mainly American family related to the crocodile but with a shorter, broader snout and non-protruding teeth [n -S]\n",
  "ALLIGATORS": "ALLIGATOR, a reptile of a mainly American family related to the crocodile but with a shorter, broader snout and non-protruding teeth [n]\n",
  "ALLINEATION": "alignment, also ALINEATION [n -S]\n",
  "ALLINEATIONS": "ALLINEATION, alignment, also ALINEATION [n]\n",
  "ALLIS": "a fish of the shad family, also ALLICE [n -ES]\n",
  "ALLISES": "ALLIS, a fish of the shad family, also ALLICE [n]\n",
  "ALLITERATE": "to form an alliteration [v ALLITERATED, ALLITERATING, ALLITERATES]\n",
  "ALLITERATED": "ALLITERATE, to form an alliteration [v]\n",
  "ALLITERATES": "ALLITERATE, to form an alliteration [v]\n",
  "ALLITERATING": "ALLITERATE, to form an alliteration [v]\n",
  "ALLITERATION": "the repetition of the same sound beginning several words in sequence [n -S]\n",
  "ALLITERATIONS": "ALLITERATION, the repetition of the same sound beginning several words in sequence [n]\n",
  "ALLITERATIVE": "of, relating to, or marked by alliteration [adj ALLITERATIVELY]\n",
  "ALLITERATIVELY": "ALLITERATIVE, of, relating to, or marked by alliteration [adv]\n",
  "ALLIUM": "(Latin) a plant of the Allium genus to which onions, garlics, leeks etc. belong [n -S]\n",
  "ALLIUMS": "ALLIUM, (Latin) a plant of the Allium genus to which onions, garlics, leeks etc. belong [n]\n",
  "ALLNESS": "the condition of being all [n -ES]\n",
  "ALLNESSES": "ALLNESS, the condition of being all [n]\n",
  "ALLNIGHT": "lasting all night [adj]\n",
  "ALLNIGHTER": "any event, party etc. that lasts all night [n -S]\n",
  "ALLNIGHTERS": "ALLNIGHTER, any event, party etc. that lasts all night [n]\n",
  "ALLOANTIBODIES": "ALLOANTIBODY, an antibody [n]\n",
  "ALLOANTIBODY": "an antibody [n ALLOANTIBODIES]\n",
  "ALLOANTIGEN": "an antigen present only in some individuals of a species [n -S]\n",
  "ALLOANTIGENS": "ALLOANTIGEN, an antigen present only in some individuals of a species [n]\n",
  "ALLOBAR": "a change in barometric pressure [n -S]\n",
  "ALLOBARS": "ALLOBAR, a change in barometric pressure [n]\n",
  "ALLOCABLE": "that can be allocated, also ALLOCATABLE [adj]\n",
  "ALLOCARPIES": "ALLOCARPY, fruiting after cross-fertilization [n]\n",
  "ALLOCARPY": "fruiting after cross-fertilization [n ALLOCARPIES]\n",
  "ALLOCATABLE": "that can be allocated, also ALLOCABLE [adj]\n",
  "ALLOCATE": "to set apart for a particular purpose [v ALLOCATED, ALLOCATING, ALLOCATES]\n",
  "ALLOCATED": "ALLOCATE, to set apart for a particular purpose [v]\n",
  "ALLOCATES": "ALLOCATE, to set apart for a particular purpose [v]\n",
  "ALLOCATING": "ALLOCATE, to set apart for a particular purpose [v]\n",
  "ALLOCATION": "the act of result of allocating [n -S]\n",
  "ALLOCATIONS": "ALLOCATION, the act of result of allocating [n]\n",
  "ALLOCATOR": "one who allocates [n -S]\n",
  "ALLOCATORS": "ALLOCATOR, one who allocates [n]\n",
  "ALLOCHEIRIA": "attribution of a sensation to the wrong part of the body, also ALLOCHIRIA [n -S]\n",
  "ALLOCHEIRIAS": "ALLOCHEIRIA, attribution of a sensation to the wrong part of the body, also ALLOCHIRIA [n]\n",
  "ALLOCHIRIA": "attribution of a sensation to the wrong part of the body, also ALLOCHEIRIA [n -S]\n",
  "ALLOCHIRIAS": "ALLOCHIRIA, attribution of a sensation to the wrong part of the body, also ALLOCHEIRIA [n]\n",
  "ALLOCHTHONOUS": "refers to something, e.g. a rock, formed elsewhere than in its present location [adj]\n",
  "ALLOCUTION": "a formal speech or address, esp. one that exhorts [n -S]\n",
  "ALLOCUTIONS": "ALLOCUTION, a formal speech or address, esp. one that exhorts [n]\n",
  "ALLOD": "an estate held in absolute ownership [n -S]\n",
  "ALLODIA": "ALLODIUM, (Latin) an estate held in absolute ownership, also ALLOD, ALOD, ALODIUM [n]\n",
  "ALLODIAL": "relating to allod [adj]\n",
  "ALLODIUM": "(Latin) an estate held in absolute ownership, also ALLOD, ALOD, ALODIUM [n ALLODIA or ALLODIUMS]\n",
  "ALLODIUMS": "ALLODIUM, (Latin) an estate held in absolute ownership, also ALLOD, ALOD, ALODIUM [n]\n",
  "ALLODS": "ALLOD, an estate held in absolute ownership [n]\n",
  "ALLODYNIA": "the experience of severe pain as a result of a stimulus that would not normally cause it [n -S]\n",
  "ALLODYNIAS": "ALLODYNIA, the experience of severe pain as a result of a stimulus that would not normally cause it [n]\n",
  "ALLOGAMIES": "ALLOGAMY, cross-fertilization [n]\n",
  "ALLOGAMOUS": "relating to allogamy [adj]\n",
  "ALLOGAMY": "cross-fertilization [n ALLOGAMIES]\n",
  "ALLOGENEIC": "involving, derived from or being individuals of the same species that are sufficiently unlike genetically to interact antigenically, also ALLOGENIC [adj]\n",
  "ALLOGENIC": "involving, derived from or being individuals of the same species that are sufficiently unlike genetically to interact antigenically, also ALLOGENEIC [adj]\n",
  "ALLOGRAFT": "a surgical graft from a nonidentical donor [n -S] / to make a surgical graft from a nonidentical donor [v -ED, -ING, -S]\n",
  "ALLOGRAFTED": "ALLOGRAFT, to make a surgical graft from a nonidentical donor [v]\n",
  "ALLOGRAFTING": "ALLOGRAFT, to make a surgical graft from a nonidentical donor [v]\n",
  "ALLOGRAFTS": "ALLOGRAFT, a surgical graft from a nonidentical donor [n]\n",
  "ALLOGRAPH": "a writing, esp. a signature, for another, as opposed to an autograph [n -S]\n",
  "ALLOGRAPHIC": "relating to an allograph, a writing, esp. a signature, for another [adj]\n",
  "ALLOGRAPHS": "ALLOGRAPH, a writing, esp. a signature, for another, as opposed to an autograph [n]\n",
  "ALLOIOSTROPHOS": "irregularly divided, not in alternate strophe and antistrophe [adj]\n",
  "ALLOMERIC": "of similar crystalline structure [adj]\n",
  "ALLOMERISM": "similarity of crystalline structure in substances of different chemical composition [n -S]\n",
  "ALLOMERISMS": "ALLOMERISM, similarity of crystalline structure in substances of different chemical composition [n]\n",
  "ALLOMEROUS": "exhibiting allomerism, similarity of crystalline structure in substances of different chemical composition [adj]\n",
  "ALLOMETRIC": "relating to allometry, the study of growth of a part of an organism in relation to the whole [adj]\n",
  "ALLOMETRIES": "ALLOMETRY, the study of growth of a part of an organism in relation to the whole [n]\n",
  "ALLOMETRY": "the study of growth of a part of an organism in relation to the whole [n ALLOMETRIES]\n",
  "ALLOMONE": "a chemical substance secreted by certain insects that affects other species detrimentally [n -S]\n",
  "ALLOMONES": "ALLOMONE, a chemical substance secreted by certain insects that affects other species detrimentally [n]\n",
  "ALLOMORPH": "any one of two or more distinct crystalline forms of the same substance [n -S]\n",
  "ALLOMORPHIC": "of or like an allomorph [adj]\n",
  "ALLOMORPHISM": "the state of being an allomorph [n -S]\n",
  "ALLOMORPHISMS": "ALLOMORPHISM, the state of being an allomorph [n]\n",
  "ALLOMORPHS": "ALLOMORPH, any one of two or more distinct crystalline forms of the same substance [n]\n",
  "ALLONGE": "(archaic) to lunge [v ALLONGED, ALLONGING, ALLONGES]\n",
  "ALLONGED": "ALLONGE, (archaic) to lunge [v]\n",
  "ALLONGES": "ALLONGE, (archaic) to lunge [v]\n",
  "ALLONGING": "ALLONGE, (archaic) to lunge [v]\n",
  "ALLONS": "(French) let's go [interj]\n",
  "ALLONYM": "the name of a person, usually historical, taken by an author as a pen name (as opposed to using a fictional pseudonym) [n -S]\n",
  "ALLONYMOUS": "relating to an allonym [adj]\n",
  "ALLONYMS": "ALLONYM, the name of a person, usually historical, taken by an author as a pen name (as opposed to using a fictional pseudonym) [n]\n",
  "ALLOPATH": "one who practises allopathy, orthodox medical treatment, also ALLOPATHIST [n -S]\n",
  "ALLOPATHIC": "of or pertaining to allopathy [adj ALLOPATHICALLY]\n",
  "ALLOPATHICALLY": "ALLOPATHIC, of or pertaining to allopathy [adv]\n",
  "ALLOPATHIES": "ALLOPATHY, the treatment of disease by inducing an opposite condition (i.e. in the usual way) [n]\n",
  "ALLOPATHIST": "one who practises allopathy, orthodox medical treatment, also ALLOPATH [n -S]\n",
  "ALLOPATHISTS": "ALLOPATHIST, one who practises allopathy, orthodox medical treatment, also ALLOPATH [n]\n",
  "ALLOPATHS": "ALLOPATH, one who practises allopathy, orthodox medical treatment, also ALLOPATHIST [n]\n",
  "ALLOPATHY": "the treatment of disease by inducing an opposite condition (i.e. in the usual way) [n ALLOPATHIES]\n",
  "ALLOPATRIC": "pertaining to populations which inhabit separate geographical areas [adj ALLOPATRICALLY]\n",
  "ALLOPATRICALLY": "ALLOPATRIC, pertaining to populations which inhabit separate geographical areas [adv]\n",
  "ALLOPATRIES": "ALLOPATRY, the state of occurring in different geographical areas or in isolation [n]\n",
  "ALLOPATRY": "the state of occurring in different geographical areas or in isolation [n ALLOPATRIES]\n",
  "ALLOPHANE": "a translucent, coloured aluminum silicate [n -S]\n",
  "ALLOPHANES": "ALLOPHANE, a translucent, coloured aluminum silicate [n]\n",
  "ALLOPHONE": "any of several speech sounds regarded as variants of a given phoneme [n -S]\n",
  "ALLOPHONES": "ALLOPHONE, any of several speech sounds regarded as variants of a given phoneme [n]\n",
  "ALLOPHONIC": "of or like an allophone, any of several speech sounds regarded as variants of a given phoneme [adj]\n",
  "ALLOPLASM": "protoplasm differentiated to perform a particular function [n -S]\n",
  "ALLOPLASMIC": "relating to the alloplasm [adj]\n",
  "ALLOPLASMS": "ALLOPLASM, protoplasm differentiated to perform a particular function [n]\n",
  "ALLOPLASTIC": "affected by or affecting external factors [adj]\n",
  "ALLOPOLYPLOID": "a polyploid having a chromosome set composed of chromosome derived from different species [n -S]\n",
  "ALLOPOLYPLOIDS": "ALLOPOLYPLOID, a polyploid having a chromosome set composed of chromosome derived from different species [n]\n",
  "ALLOPOLYPLOIDY": "the state of being allopolyploid [n]\n",
  "ALLOPURINOL": "a drug used in the treatment of gout [n -S]\n",
  "ALLOPURINOLS": "ALLOPURINOL, a drug used in the treatment of gout [n]\n",
  "ALLOSAUR": "a large, lizard-hipped carnivorous dinosaur [n -S]\n",
  "ALLOSAURS": "ALLOSAUR, a large, lizard-hipped carnivorous dinosaur [n]\n",
  "ALLOSAURUS": "a kind of dinosaur [n -ES]\n",
  "ALLOSAURUSES": "ALLOSAURUS, a kind of dinosaur [n]\n",
  "ALLOSTERIC": "of an enzyme, influenced by a combination with another substance [adj]\n",
  "ALLOSTERICALLY": "ALLOSTERIC, of an enzyme, influenced by a combination with another substance [adv]\n",
  "ALLOSTERIES": "ALLOSTERY, of an enzyme, the property of being allosteric [n]\n",
  "ALLOSTERY": "of an enzyme, the property of being allosteric [n ALLOSTERIES]\n",
  "ALLOT": "to give as a share or portion [v ALLOTTED, ALLOTTING, ALLOTS]\n",
  "ALLOTETRAPLOID": "an organism having a diploid set of chromosomes from each of its parent [n -S]\n",
  "ALLOTETRAPLOIDS": "ALLOTETRAPLOID, an organism having a diploid set of chromosomes from each of its parent [n]\n",
  "ALLOTETRAPLOIDY": "an allotetraploid organism [n]\n",
  "ALLOTHEISM": "belief in or worship of strange gods [n -S]\n",
  "ALLOTHEISMS": "ALLOTHEISM, belief in or worship of strange gods [n]\n",
  "ALLOTMENT": "a piece of ground let out for spare-time cultivation [n -S]\n",
  "ALLOTMENTS": "ALLOTMENT, a piece of ground let out for spare-time cultivation [n]\n",
  "ALLOTRIOMORPHIC": "crystalline in internal structure but not in outward form [adj]\n",
  "ALLOTROPE": "an allotropic form of a substance [n -S]\n",
  "ALLOTROPES": "ALLOTROPE, an allotropic form of a substance [n]\n",
  "ALLOTROPIC": "relating to allotropy [adj ALLOTROPICALLY]\n",
  "ALLOTROPICALLY": "ALLOTROPIC, relating to allotropy [adv]\n",
  "ALLOTROPIES": "ALLOTROPY, the property whereby certain elements may exist in more than one crystal structure [n]\n",
  "ALLOTROPISM": "the state of an element existing in more than one form [n -S]\n",
  "ALLOTROPISMS": "ALLOTROPISM, the state of an element existing in more than one form [n]\n",
  "ALLOTROPOUS": "having nectar accessible to all kinds of insects [adj]\n",
  "ALLOTROPY": "the property whereby certain elements may exist in more than one crystal structure [n ALLOTROPIES]\n",
  "ALLOTS": "ALLOT, to give as a share or portion [v]\n",
  "ALLOTTED": "ALLOT, to give as a share or portion [v]\n",
  "ALLOTTEE": "one to whom something is allotted [n -S]\n",
  "ALLOTTEES": "ALLOTTEE, one to whom something is allotted [n]\n",
  "ALLOTTER": "one who allots [n -S]\n",
  "ALLOTTERIES": "ALLOTTERY, (Shakespeare) a share allotted [n]\n",
  "ALLOTTERS": "ALLOTTER, one who allots [n]\n",
  "ALLOTTERY": "(Shakespeare) a share allotted [n ALLOTTERIES]\n",
  "ALLOTTING": "ALLOT, to give as a share or portion [v]\n",
  "ALLOTYPE": "an allotypic variant of a protein or antigen [n -S]\n",
  "ALLOTYPES": "ALLOTYPE, an allotypic variant of a protein or antigen [n]\n",
  "ALLOTYPIC": "of or like an allotype, a type of antibody [adj ALLOTYPICALLY]\n",
  "ALLOTYPICALLY": "ALLOTYPIC, of or like an allotype, a type of antibody [adv]\n",
  "ALLOTYPIES": "ALLOTYPY, the condition of being an allotype, an allotypic variant of a protein or antigen [n]\n",
  "ALLOTYPY": "the condition of being an allotype, an allotypic variant of a protein or antigen [n ALLOTYPIES]\n",
  "ALLOVER": "a fabric with a pattern over the entire surface [n -S]\n",
  "ALLOVERS": "ALLOVER, a fabric with a pattern over the entire surface [n]\n",
  "ALLOW": "to put no obstacle in the way of [v -ED, -ING, -S]\n",
  "ALLOWABILITIES": "ALLOWABILITY, the state of being allowable [n]\n",
  "ALLOWABILITY": "the state of being allowable [n ALLOWABILITIES]\n",
  "ALLOWABLE": "that can be allowed [adj ALLOWABLY] / something allowed [n -S]\n",
  "ALLOWABLENESS": "the state of being allowable [n -ES]\n",
  "ALLOWABLENESSES": "ALLOWABLENESS, the state of being allowable [n]\n",
  "ALLOWABLES": "ALLOWABLE, something allowed [n]\n",
  "ALLOWABLY": "ALLOWABLE, that can be allowed [adv]\n",
  "ALLOWANCE": "something allowed, esp. a sum of money [n -S] / to make an allowance to [v ALLOWANCED, ALLOWANCING, ALLOWANCES]\n",
  "ALLOWANCED": "ALLOWANCE, to make an allowance to [v]\n",
  "ALLOWANCES": "ALLOWANCE, to make an allowance to [v]\n",
  "ALLOWANCING": "ALLOWANCE, to make an allowance to [v]\n",
  "ALLOWED": "ALLOW, to put no obstacle in the way of [v]\n",
  "ALLOWEDLY": "ALLOWED, ALLOW, to put no obstacle in the way of [adv]\n",
  "ALLOWING": "ALLOW, to put no obstacle in the way of [v]\n",
  "ALLOWS": "ALLOW, to put no obstacle in the way of [v]\n",
  "ALLOXAN": "an oxidation product of uric acid, of a pale reddish color, readily soluble in water or alcohol [n -S]\n",
  "ALLOXANS": "ALLOXAN, an oxidation product of uric acid, of a pale reddish color, readily soluble in water or alcohol [n]\n",
  "ALLOY": "to combine a mixture of metals [v -ED, -ING, -S]\n",
  "ALLOYED": "ALLOY, to combine a mixture of metals [v]\n",
  "ALLOYING": "ALLOY, to combine a mixture of metals [v]\n",
  "ALLOYS": "ALLOY, to combine a mixture of metals [v]\n",
  "ALLOZYME": "a different form of an enzyme coded by the same allele [n -S]\n",
  "ALLOZYMES": "ALLOZYME, a different form of an enzyme coded by the same allele [n]\n",
  "ALLS": "ALL, the whole [n]\n",
  "ALLSEED": "a weed of the flax family [n -S]\n",
  "ALLSEEDS": "ALLSEED, a weed of the flax family [n]\n",
  "ALLSORTS": "things of various shapes and sizes [n]\n",
  "ALLSPICE": "a widely used aromatic spice, so named because it combines the flavours of several different spices [n -S]\n",
  "ALLSPICES": "ALLSPICE, a widely used aromatic spice, so named because it combines the flavours of several different spices [n]\n",
  "ALLUDE": "to make an indirect reference [v ALLUDED, ALLUDING, ALLUDES]\n",
  "ALLUDED": "ALLUDE, to make an indirect reference [v]\n",
  "ALLUDES": "ALLUDE, to make an indirect reference [v]\n",
  "ALLUDING": "ALLUDE, to make an indirect reference [v]\n",
  "ALLURE": "to attract with something desirable [v ALLURED, ALLURING, ALLURES]\n",
  "ALLURED": "ALLURE, to attract with something desirable [v]\n",
  "ALLUREMENT": "the act of alluring [n -S]\n",
  "ALLUREMENTS": "ALLUREMENT, the act of alluring [n]\n",
  "ALLURER": "one who allures [n -S]\n",
  "ALLURERS": "ALLURER, one who allures [n]\n",
  "ALLURES": "ALLURE, to attract with something desirable [v]\n",
  "ALLURING": "ALLURE, to attract with something desirable [v]\n",
  "ALLURINGLY": "ALLURING, ALLURE, to attract with something desirable [adv]\n",
  "ALLUSION": "the act of alluding [n -S]\n",
  "ALLUSIONS": "ALLUSION, the act of alluding [n]\n",
  "ALLUSIVE": "alluding [adj]\n",
  "ALLUSIVELY": "ALLUSIVE, alluding [adv]\n",
  "ALLUSIVENESS": "a quality characterized by indirect reference [n -ES]\n",
  "ALLUSIVENESSES": "ALLUSIVENESS, a quality characterized by indirect reference [n]\n",
  "ALLUVIA": "ALLUVIUM, (Latin) land gained from the sea by the washing up of sand and earth, also ALLUVION [n]\n",
  "ALLUVIAL": "soil composed of alluvium [n -S]\n",
  "ALLUVIALS": "ALLUVIAL, soil composed of alluvium [n]\n",
  "ALLUVION": "(Latin) land gained from the sea by the washing up of sand and earth, also ALLUVIUM [n -S]\n",
  "ALLUVIONS": "ALLUVION, (Latin) land gained from the sea by the washing up of sand and earth, also ALLUVIUM [n]\n",
  "ALLUVIUM": "(Latin) land gained from the sea by the washing up of sand and earth, also ALLUVION [n ALLUVIUMS or ALLUVIA]\n",
  "ALLUVIUMS": "ALLUVIUM, (Latin) land gained from the sea by the washing up of sand and earth, also ALLUVION [n]\n",
  "ALLWEATHER": "a track or pitch suitable for use in all weathers [n -S]\n",
  "ALLWEATHERS": "ALLWEATHER, a track or pitch suitable for use in all weathers [n]\n",
  "ALLY": "to join by marriage, friendship, treaty etc. [v ALLIED, ALLYING, ALLIES]\n",
  "ALLYCHOLLIES": "ALLYCHOLLY, (Shakespeare) melancholy, also ALLICHOLY [n]\n",
  "ALLYCHOLLY": "(Shakespeare) melancholy, also ALLICHOLY [n ALLYCHOLLIES]\n",
  "ALLYING": "ALLY, to join by marriage, friendship, treaty etc. [v]\n",
  "ALLYL": "an organic radical existing esp. in oils of garlic and mustard [n -S]\n",
  "ALLYLIC": "of or like an allyl, a kind of organic radical [adj]\n",
  "ALLYLS": "ALLYL, an organic radical existing esp. in oils of garlic and mustard [n]\n",
  "ALLYOU": "(Caribbean) all of you [pron]\n",
  "ALMA": "(Arabic) an Egyptian girl who sings and dances professionally, also ALMAH, ALME, ALMEH [n -S]\n",
  "ALMACANTAR": "(Arabic) a circle of altitude, parallel to the horizon, also ALMUCANTAR [n -S]\n",
  "ALMACANTARS": "ALMACANTAR, (Arabic) a circle of altitude, parallel to the horizon, also ALMUCANTAR [n]\n",
  "ALMAGEST": "(Arabic) a medieval treatise on astrology and alchemy [n -S]\n",
  "ALMAGESTS": "ALMAGEST, (Arabic) a medieval treatise on astrology and alchemy [n]\n",
  "ALMAH": "(Arabic) an Egyptian girl who sings and dances professionally, also ALMA, ALME, ALMEH [n -S]\n",
  "ALMAHS": "ALMAH, (Arabic) an Egyptian girl who sings and dances professionally, also ALMA, ALME, ALMEH [n]\n",
  "ALMAIN": "an old courtly dance, also ALLEMANDE [n -S]\n",
  "ALMAINS": "ALMAIN, an old courtly dance, also ALLEMANDE [n]\n",
  "ALMANAC": "a register of the days, weeks and months of the year, also ALMANACK [n -S]\n",
  "ALMANACK": "a register of the days, weeks and months of the year, also ALMANAC [n -S]\n",
  "ALMANACKS": "ALMANACK, a register of the days, weeks and months of the year, also ALMANAC [n]\n",
  "ALMANACS": "ALMANAC, a register of the days, weeks and months of the year, also ALMANACK [n]\n",
  "ALMANDINE": "(French) a deep red garnet consisting of an iron aluminum silicate, also ALABANDINE, ALMANDITE, ALMONDITE [n -S]\n",
  "ALMANDINES": "ALMANDINE, (French) a deep red garnet consisting of an iron aluminum silicate, also ALABANDINE, ALMANDITE, ALMONDITE [n]\n",
  "ALMANDITE": "a deep red garnet consisting of an iron aluminum silicate, also ALABANDINE, ALMANDINE, ALMONDITE [n -S]\n",
  "ALMANDITES": "ALMANDITE, a deep red garnet consisting of an iron aluminum silicate, also ALABANDINE, ALMANDINE, ALMONDITE [n]\n",
  "ALMAS": "ALMA, (Arabic) an Egyptian girl who sings and dances professionally, also ALMAH, ALME, ALMEH [n]\n",
  "ALME": "(Arabic) an Egyptian girl who sings and dances professionally, also ALMA, ALMAH, ALMEH [n -S]\n",
  "ALMEH": "(Arabic) an Egyptian girl who sings and dances professionally, also ALMA, ALMAH, ALME [n -S]\n",
  "ALMEHS": "ALMEH, (Arabic) an Egyptian girl who sings and dances professionally, also ALMA, ALMAH, ALME [n]\n",
  "ALMEMAR": "(Hebrew) a platform in a synagogue [n -S]\n",
  "ALMEMARS": "ALMEMAR, (Hebrew) a platform in a synagogue [n]\n",
  "ALMERIES": "ALMERY, a cupboard for sacred vessels, also AMBRY, ALMIRAH, AMBERY, AUMBRY, AWMRIE, AWMRY [n]\n",
  "ALMERY": "a cupboard for sacred vessels, also AMBRY, ALMIRAH, AMBERY, AUMBRY, AWMRIE, AWMRY [n ALMERIES]\n",
  "ALMES": "ALME, (Arabic) an Egyptian girl who sings and dances professionally, also ALMA, ALMAH, ALMEH [n]\n",
  "ALMIGHTIER": "ALMIGHTY, having absolute power over all [adj]\n",
  "ALMIGHTIEST": "ALMIGHTY, having absolute power over all [adj]\n",
  "ALMIGHTILY": "ALMIGHTY, having absolute power over all [adv]\n",
  "ALMIGHTINESS": "the state of being almighty [n -ES]\n",
  "ALMIGHTINESSES": "ALMIGHTINESS, the state of being almighty [n]\n",
  "ALMIGHTY": "having absolute power over all [adj ALMIGHTIER, ALMIGHTIEST, ALMIGHTILY]\n",
  "ALMIRAH": "(Hindi) a wardrobe, a chest of drawers [n -S]\n",
  "ALMIRAHS": "ALMIRAH, (Hindi) a wardrobe, a chest of drawers [n]\n",
  "ALMNER": "a giver of alms; a social worker in a hospital, also ALMONER [n -S]\n",
  "ALMNERS": "ALMNER, a giver of alms; a social worker in a hospital, also ALMONER [n]\n",
  "ALMOND": "a kind of edible nut [n -S]\n",
  "ALMONDIER": "ALMONDY, having an almond flavour [adj]\n",
  "ALMONDIEST": "ALMONDY, having an almond flavour [adj]\n",
  "ALMONDITE": "a deep red garnet consisting of an iron aluminum silicate, also ALABANDINE, ALMANDINE, ALMANDITE [n -S]\n",
  "ALMONDITES": "ALMONDITE, a deep red garnet consisting of an iron aluminum silicate, also ALABANDINE, ALMANDINE, ALMANDITE [n]\n",
  "ALMONDS": "ALMOND, a kind of edible nut [n]\n",
  "ALMONDY": "having an almond flavour [adj ALMONDIER, ALMONDIEST]\n",
  "ALMONER": "a giver of alms; a social worker in a hospital, also ALMNER [n -S]\n",
  "ALMONERS": "ALMONER, a giver of alms; a social worker in a hospital, also ALMNER [n]\n",
  "ALMONRIES": "ALMONRY, a place where alms are distributed [n]\n",
  "ALMONRY": "a place where alms are distributed [n ALMONRIES]\n",
  "ALMOST": "very nearly [adv]\n",
  "ALMOUS": "(Scots) alms, also AWMOUS [n ALMOUS]\n",
  "ALMS": "money or goods given to the poor [n ALMS]\n",
  "ALMSGIVER": "one who gives alms [n -S]\n",
  "ALMSGIVERS": "ALMSGIVER, one who gives alms [n]\n",
  "ALMSGIVING": "the act of giving alms [n -S]\n",
  "ALMSGIVINGS": "ALMSGIVING, the act of giving alms [n]\n",
  "ALMSHOUSE": "a privately supported house offering accommodation to the aged or needy [n -S]\n",
  "ALMSHOUSES": "ALMSHOUSE, a privately supported house offering accommodation to the aged or needy [n]\n",
  "ALMSMAN": "one who receives alms [n ALMSMEN]\n",
  "ALMSMEN": "ALMSMAN, one who receives alms [n]\n",
  "ALMSWOMAN": "a woman who receives alms [n ALMSWOMEN]\n",
  "ALMSWOMEN": "ALMSWOMAN, a woman who receives alms [n]\n",
  "ALMUCANTAR": "(Arabic) a circle of altitude, parallel to the horizon, also ALMACANTAR [n -S]\n",
  "ALMUCANTARS": "ALMUCANTAR, (Arabic) a circle of altitude, parallel to the horizon, also ALMACANTAR [n]\n",
  "ALMUCE": "a furred hood with long ends hanging down in front, worn by certain religious orders, also AMICE [n -S]\n",
  "ALMUCES": "ALMUCE, a furred hood with long ends hanging down in front, worn by certain religious orders, also AMICE [n]\n",
  "ALMUD": "a Spanish unit of capacity, also ALMUDE [n -S]\n",
  "ALMUDE": "a Spanish unit of capacity, also ALMUD [n -S]\n",
  "ALMUDES": "ALMUDE, a Spanish unit of capacity, also ALMUD [n]\n",
  "ALMUDS": "ALMUD, a Spanish unit of capacity, also ALMUDE [n]\n",
  "ALMUG": "(Hebrew) a precious wood mentioned in the Bible [n -S]\n",
  "ALMUGS": "ALMUG, (Hebrew) a precious wood mentioned in the Bible [n]\n",
  "ALNAGE": "cloth inspection, also AULNAGE [n -S]\n",
  "ALNAGER": "an inspector of cloth, also AULNAGER [n -S]\n",
  "ALNAGERS": "ALNAGER, an inspector of cloth, also AULNAGER [n]\n",
  "ALNAGES": "ALNAGE, cloth inspection, also AULNAGE [n]\n",
  "ALNICO": "(tradename) a permanent magnetic alloy of aluminium, nickel and cobalt [n -S]\n",
  "ALNICOS": "ALNICO, (tradename) a permanent magnetic alloy of aluminium, nickel and cobalt [n]\n",
  "ALOCASIA": "any of various tropical plants of the genus Alocasia [n -S]\n",
  "ALOCASIAS": "ALOCASIA, any of various tropical plants of the genus Alocasia [n]\n",
  "ALOD": "an estate held in absolute ownership, without acknowledgement to a superior, also ALLOD, ALLODIUM, ALODIUM [n -S]\n",
  "ALODIA": "ALODIUM, (Latin) land held absolutely, also ALLODIUM, ALOD [n]\n",
  "ALODIAL": "relating to alodium, property under absolute ownership; freehold, also ALLODIAL [adj]\n",
  "ALODIUM": "(Latin) land held absolutely, also ALLODIUM, ALOD [n ALODIUMS or ALODIA]\n",
  "ALODIUMS": "ALODIUM, (Latin) land held absolutely, also ALLODIUM, ALOD [n]\n",
  "ALODS": "ALOD, an estate held in absolute ownership, without acknowledgement to a superior, also ALLOD, ALLODIUM, ALODIUM [n]\n",
  "ALOE": "any member of the genus Aloe, consisting mostly of trees and shrubs of the lily family [n -S]\n",
  "ALOED": "planted or flavoured with aloes [adj]\n",
  "ALOES": "ALOE, any member of the genus Aloe, consisting mostly of trees and shrubs of the lily family [n]\n",
  "ALOESWOOD": "a soft, resinous wood of an Asian tree, known for its aromatic qualities, and used in incense, also AGALWOOD, AGARWOOD [n -S]\n",
  "ALOESWOODS": "ALOESWOOD, a soft, resinous wood of an Asian tree, known for its aromatic qualities, and used in incense, also AGALWOOD, AGARWOOD [n]\n",
  "ALOETIC": "a medicine containing aloes [n -S]\n",
  "ALOETICS": "ALOETIC, a medicine containing aloes [n]\n",
  "ALOFT": "on high [adv]\n",
  "ALOGIA": "the inability to speak [n -S]\n",
  "ALOGIAS": "ALOGIA, the inability to speak [n]\n",
  "ALOGICAL": "outside the domain of logic [adj]\n",
  "ALOGICALLY": "ALOGICAL, outside the domain of logic [adv]\n",
  "ALOHA": "(Hawaiian) a greeting or farewell [n -S]\n",
  "ALOHAS": "ALOHA, (Hawaiian) a greeting or farewell [n]\n",
  "ALOIN": "a kind of laxative [n -S]\n",
  "ALOINS": "ALOIN, a kind of laxative [n]\n",
  "ALONE": "solitary, apart from others [adj ALONELY]\n",
  "ALONELY": "ALONE, solitary, apart from others [adv]\n",
  "ALONENESS": "the state of being alone [n -ES]\n",
  "ALONENESSES": "ALONENESS, the state of being alone [n]\n",
  "ALONG": "onward [adv]\n",
  "ALONGSHORE": "along the shore or coast [adv]\n",
  "ALONGSHOREMAN": "a stevedore; a person who makes a living along the shore by fishing, etc., also LONGSHOREMAN [n ALONGSHOREMEN]\n",
  "ALONGSHOREMEN": "ALONGSHOREMAN, a stevedore; a person who makes a living along the shore by fishing, etc., also LONGSHOREMAN [n]\n",
  "ALONGSIDE": "beside, side by side with [adv]\n",
  "ALONGST": "(dialect) along [prep]\n",
  "ALOO": "(Hindi) a potato, also ALU [n -S]\n",
  "ALOOF": "distant in interest or feeling [adj ALOOFLY]\n",
  "ALOOFLY": "ALOOF, distant in interest or feeling [adv]\n",
  "ALOOFNESS": "the state of being aloof [n -ES]\n",
  "ALOOFNESSES": "ALOOFNESS, the state of being aloof [n]\n",
  "ALOOS": "ALOO, (Hindi) a potato, also ALU [n]\n",
  "ALOPECIA": "(Latin) loss of hair, baldness [n -S]\n",
  "ALOPECIAS": "ALOPECIA, (Latin) loss of hair, baldness [n]\n",
  "ALOPECIC": "relating to baldness [adj]\n",
  "ALOPECOID": "a member of the fox family [n -S]\n",
  "ALOPECOIDS": "ALOPECOID, a member of the fox family [n]\n",
  "ALOUD": "audibly [adv]\n",
  "ALOW": "in or to a lower part of a vessel, as opposed to aloft [adv]\n",
  "ALOWE": "(Scots) ablaze [adv]\n",
  "ALP": "a high mountain [n -S]\n",
  "ALPACA": "a domestic animal related to the llama [n -S]\n",
  "ALPACAS": "ALPACA, a domestic animal related to the llama [n]\n",
  "ALPACCA": "a type of nickel silver used in jewellery [n -S]\n",
  "ALPACCAS": "ALPACCA, a type of nickel silver used in jewellery [n]\n",
  "ALPARGATA": "(Spanish) a light sandal with a hemp or rope sole [n -S]\n",
  "ALPARGATAS": "ALPARGATA, (Spanish) a light sandal with a hemp or rope sole [n]\n",
  "ALPEEN": "(Irish) a cudgel [n -S]\n",
  "ALPEENS": "ALPEEN, (Irish) a cudgel [n]\n",
  "ALPENGLOW": "a reddish glow seen near sunset or sunrise on the summits of mountains [n -S]\n",
  "ALPENGLOWS": "ALPENGLOW, a reddish glow seen near sunset or sunrise on the summits of mountains [n]\n",
  "ALPENHORN": "(German) a long powerful horn made of wood, used by Alpine cowherds, also ALPHORN [n -S]\n",
  "ALPENHORNS": "ALPENHORN, (German) a long powerful horn made of wood, used by Alpine cowherds, also ALPHORN [n]\n",
  "ALPENSTOCK": "(German) a long staff, pointed with iron, used in climbing the Alps [n -S]\n",
  "ALPENSTOCKS": "ALPENSTOCK, (German) a long staff, pointed with iron, used in climbing the Alps [n]\n",
  "ALPESTRINE": "of plants, growing at high altitude, subalpine [adj]\n",
  "ALPHA": "(Greek) a Greek letter [n -S]\n",
  "ALPHABET": "a set of letters [n -S] / to alphabetize [v -ED, -ING, -S]\n",
  "ALPHABETARIAN": "someone learning the alphabet, a beginner [n -S]\n",
  "ALPHABETARIANS": "ALPHABETARIAN, someone learning the alphabet, a beginner [n]\n",
  "ALPHABETED": "ALPHABET, to alphabetize [v]\n",
  "ALPHABETIC": "arranged in the order of the letters of the alphabet, also ALPHABETICAL [adj ALPHABETICALLY]\n",
  "ALPHABETICAL": "arranged in the order of the letters of the alphabet, also ALPHABETIC [adj]\n",
  "ALPHABETICALLY": "ALPHABETICAL, arranged in the order of the letters of the alphabet, also ALPHABETIC [adv]\n",
  "ALPHABETIFORM": "shaped like letters [adj]\n",
  "ALPHABETING": "ALPHABET, to alphabetize [v]\n",
  "ALPHABETISATION": "the act of alphabetising, also ALPHABETIZATION [n]\n",
  "ALPHABETISE": "to put into alphabetic order, also ALPHABET, ALPHABETIZE [v ALPHABETISED, ALPHABETISING, ALPHABETISES]\n",
  "ALPHABETISED": "ALPHABETISE, to put into alphabetic order, also ALPHABET, ALPHABETIZE [v]\n",
  "ALPHABETISER": "one who alphabetises, also ALPHABETIZER [n -S]\n",
  "ALPHABETISERS": "ALPHABETISER, one who alphabetises, also ALPHABETIZER [n]\n",
  "ALPHABETISES": "ALPHABETISE, to put into alphabetic order, also ALPHABET, ALPHABETIZE [v]\n",
  "ALPHABETISING": "ALPHABETISE, to put into alphabetic order, also ALPHABET, ALPHABETIZE [v]\n",
  "ALPHABETIZATION": "the act of alphabetizing, also ALPHABETISATION [n]\n",
  "ALPHABETIZE": "to put into alphabetic order, also ALPHABET, ALPHABETISE [v ALPHABETIZED, ALPHABETIZING, ALPHABETIZES]\n",
  "ALPHABETIZED": "ALPHABETIZE, to put into alphabetic order, also ALPHABET, ALPHABETISE [v]\n",
  "ALPHABETIZER": "something that alphabetizes, also ALPHABETISER [n -S]\n",
  "ALPHABETIZERS": "ALPHABETIZER, something that alphabetizes, also ALPHABETISER [n]\n",
  "ALPHABETIZES": "ALPHABETIZE, to put into alphabetic order, also ALPHABET, ALPHABETISE [v]\n",
  "ALPHABETIZING": "ALPHABETIZE, to put into alphabetic order, also ALPHABET, ALPHABETISE [v]\n",
  "ALPHABETS": "ALPHABET, to alphabetize [v]\n",
  "ALPHAMERIC": "consisting of, or (of a machine) using, both letters and numbers, also ALPHAMERICAL [adj ALPHAMERICALLY]\n",
  "ALPHAMERICAL": "consisting of, or (of a machine) using, both letters and numbers, also ALPHAMERIC [adj ALPHAMERICALLY]\n",
  "ALPHAMERICALLY": "ALPHAMERICAL, consisting of, or (of a machine) using, both letters and numbers, also ALPHAMERIC [adv]\n",
  "ALPHAMETIC": "a popular mathematical puzzle in which numbers are replaced by letters forming words [n -S]\n",
  "ALPHAMETICS": "ALPHAMETIC, a popular mathematical puzzle in which numbers are replaced by letters forming words [n]\n",
  "ALPHANUMERIC": "of data, consisting of both letters and numbers, also ALPHANUMERICAL [adj] / an alphanumeric character [n -S]\n",
  "ALPHANUMERICAL": "of data, consisting of both letters and numbers, also ALPHANUMERIC [adj]\n",
  "ALPHANUMERICS": "ALPHANUMERIC, an alphanumeric character [n]\n",
  "ALPHAS": "ALPHA, (Greek) a Greek letter [n]\n",
  "ALPHASORT": "to sort into alphabetic order [v -ED, -ING, -S]\n",
  "ALPHASORTED": "ALPHASORT, to sort into alphabetic order [v]\n",
  "ALPHASORTING": "ALPHASORT, to sort into alphabetic order [v]\n",
  "ALPHASORTS": "ALPHASORT, to sort into alphabetic order [v]\n",
  "ALPHATEST": "to carry out an alpha test of an experimental product, such as computer software [v -ED, -ING, -S]\n",
  "ALPHATESTED": "ALPHATEST, to carry out an alpha test of an experimental product, such as computer software [v]\n",
  "ALPHATESTING": "ALPHATEST, to carry out an alpha test of an experimental product, such as computer software [v]\n",
  "ALPHATESTS": "ALPHATEST, to carry out an alpha test of an experimental product, such as computer software [v]\n",
  "ALPHORN": "(German) a long powerful horn made of wood, used by Alpine cowherds, also ALPENHORN [n -S]\n",
  "ALPHORNS": "ALPHORN, (German) a long powerful horn made of wood, used by Alpine cowherds, also ALPENHORN [n]\n",
  "ALPHOSIS": "a lack of skin pigmentation [n -ES]\n",
  "ALPHOSISES": "ALPHOSIS, a lack of skin pigmentation [n]\n",
  "ALPHYL": "a univalent radical [n -S]\n",
  "ALPHYLS": "ALPHYL, a univalent radical [n]\n",
  "ALPINE": "related to mountains [adj] / an alpine plant [n -S]\n",
  "ALPINELY": "ALPINE, related to mountains [adv]\n",
  "ALPINES": "ALPINE, an alpine plant [n]\n",
  "ALPINISM": "the sport of climbing alpine peaks [n -S]\n",
  "ALPINISMS": "ALPINISM, the sport of climbing alpine peaks [n]\n",
  "ALPINIST": "a mountain climber [n -S]\n",
  "ALPINISTS": "ALPINIST, a mountain climber [n]\n",
  "ALPS": "ALP, a high mountain [n]\n",
  "ALREADY": "by this time [adv]\n",
  "ALRIGHT": "satisfactory [adj]\n",
  "ALS": "AL, (Hindi) the Indian mulberry tree, aka noni, also AAL [n]\n",
  "ALSIKE": "a kind of clover [n -S]\n",
  "ALSIKES": "ALSIKE, a kind of clover [n]\n",
  "ALSO": "in addition [adv]\n",
  "ALSOON": "(Spenser) as soon, also ALSOONE [adv]\n",
  "ALSOONE": "(Spenser) as soon, also ALSOON [adv]\n",
  "ALSTROEMERIA": "a plant of the South American genus Alstroemeria of the amaryllis family with inverted leaves [n -S]\n",
  "ALSTROEMERIAS": "ALSTROEMERIA, a plant of the South American genus Alstroemeria of the amaryllis family with inverted leaves [n]\n",
  "ALT": "a high musical note [n -S]\n",
  "ALTALTISSIMO": "(Italian) very very high [n -S]\n",
  "ALTALTISSIMOS": "ALTALTISSIMO, (Italian) very very high [n]\n",
  "ALTAR": "a raised structure used in worship [n -S]\n",
  "ALTARAGE": "offerings made upon the altar [n -S]\n",
  "ALTARAGES": "ALTARAGE, offerings made upon the altar [n]\n",
  "ALTARPIECE": "a work of art that decorates the space above and behind an altar [n -S]\n",
  "ALTARPIECES": "ALTARPIECE, a work of art that decorates the space above and behind an altar [n]\n",
  "ALTARS": "ALTAR, a raised structure used in worship [n]\n",
  "ALTARWISE": "in the proper position of an altar, that is, at the east of a church with its ends towards the north and south [adv]\n",
  "ALTAZIMUTH": "an instrument for measuring the altitude and azimuth of heavenly bodies [n -S]\n",
  "ALTAZIMUTHS": "ALTAZIMUTH, an instrument for measuring the altitude and azimuth of heavenly bodies [n]\n",
  "ALTER": "to make different [v -ED, -ING, -S]\n",
  "ALTERABILITIES": "ALTERABILITY, the state of being alterable [n]\n",
  "ALTERABILITY": "the state of being alterable [n ALTERABILITIES]\n",
  "ALTERABLE": "that can be altered [adj ALTERABLY]\n",
  "ALTERABLY": "ALTERABLE, that can be altered [adv]\n",
  "ALTERANT": "something that alters the state of something [n -S]\n",
  "ALTERANTS": "ALTERANT, something that alters the state of something [n]\n",
  "ALTERATION": "the act of altering [n -S]\n",
  "ALTERATIONS": "ALTERATION, the act of altering [n]\n",
  "ALTERATIVE": "a medicine or treatment that changes bodily functions [n -S]\n",
  "ALTERATIVES": "ALTERATIVE, a medicine or treatment that changes bodily functions [n]\n",
  "ALTERCATE": "to dispute, argue [v ALTERCATED, ALTERCATING, ALTERCATES]\n",
  "ALTERCATED": "ALTERCATE, to dispute, argue [v]\n",
  "ALTERCATES": "ALTERCATE, to dispute, argue [v]\n",
  "ALTERCATING": "ALTERCATE, to dispute, argue [v]\n",
  "ALTERCATION": "a disagreement [n -S]\n",
  "ALTERCATIONS": "ALTERCATION, a disagreement [n]\n",
  "ALTERCATIVE": "relating to altercation [adj]\n",
  "ALTERED": "ALTER, to make different [v]\n",
  "ALTERER": "one who alters [n -S]\n",
  "ALTERERS": "ALTERER, one who alters [n]\n",
  "ALTERING": "ALTER, to make different [v]\n",
  "ALTERITIES": "ALTERITY, otherness [n]\n",
  "ALTERITY": "otherness [n ALTERITIES]\n",
  "ALTERN": "(archaic) alternate [adj]\n",
  "ALTERNANCE": "alternation, change or variation; training by alternate periods of theoretical and practical work [n -S]\n",
  "ALTERNANCES": "ALTERNANCE, alternation, change or variation; training by alternate periods of theoretical and practical work [n]\n",
  "ALTERNANT": "composed of alternate layers, as some rocks [adj] / a spelling or sound variant that does not affect meaning (allomorph or allophone) [n -S]\n",
  "ALTERNANTS": "ALTERNANT, a spelling or sound variant that does not affect meaning (allomorph or allophone) [n]\n",
  "ALTERNAT": "(French) a way of determining diplomatic precedence by lot [n -S]\n",
  "ALTERNATE": "in turns [adj ALTERNATELY] / to cause to follow by turns or one after the other (properly, of two things) [v ALTERNATED, ALTERNATING, ALTERNATES]\n",
  "ALTERNATED": "ALTERNATE, to cause to follow by turns or one after the other (properly, of two things) [v]\n",
  "ALTERNATELY": "ALTERNATE, in turns [adv]\n",
  "ALTERNATES": "ALTERNATE, to cause to follow by turns or one after the other (properly, of two things) [v]\n",
  "ALTERNATIM": "(Latin) in sacred music, alternating between two modes [adv]\n",
  "ALTERNATING": "ALTERNATE, to cause to follow by turns or one after the other (properly, of two things) [v]\n",
  "ALTERNATION": "the act of alternating [n -S]\n",
  "ALTERNATIONS": "ALTERNATION, the act of alternating [n]\n",
  "ALTERNATIVE": "possible as a choice [adj ALTERNATIVELY] / a choice of two [n -S]\n",
  "ALTERNATIVELY": "ALTERNATIVE, possible as a choice [adv]\n",
  "ALTERNATIVENESS": "the state of being alternative [n]\n",
  "ALTERNATIVES": "ALTERNATIVE, a choice of two [n]\n",
  "ALTERNATOR": "an electric generator for producing alternating current [n -S]\n",
  "ALTERNATORS": "ALTERNATOR, an electric generator for producing alternating current [n]\n",
  "ALTERNATS": "ALTERNAT, (French) a way of determining diplomatic precedence by lot [n]\n",
  "ALTERNE": "one of two or more plant communities adjoining but differing greatly [n -S]\n",
  "ALTERNES": "ALTERNE, one of two or more plant communities adjoining but differing greatly [n]\n",
  "ALTERS": "ALTER, to make different [v]\n",
  "ALTESSE": "(French) highness, also ALTEZA, ALTEZZA [n -S]\n",
  "ALTESSES": "ALTESSE, (French) highness, also ALTEZA, ALTEZZA [n]\n",
  "ALTEZA": "(Spanish) highness, also ALTESSE, ALTEZZA [n -S]\n",
  "ALTEZAS": "ALTEZA, (Spanish) highness, also ALTESSE, ALTEZZA [n]\n",
  "ALTEZZA": "(Italian) highness, also ALTESSE, ALTEZA [n -S]\n",
  "ALTEZZAS": "ALTEZZA, (Italian) highness, also ALTESSE, ALTEZA [n]\n",
  "ALTHAEA": "(Greek) a genus of plants of the mallow family, that includes the garden hollyhock, also ALTHEA [n -S]\n",
  "ALTHAEAS": "ALTHAEA, (Greek) a genus of plants of the mallow family, that includes the garden hollyhock, also ALTHEA [n]\n",
  "ALTHEA": "a genus of plants of the mallow family, that includes the garden hollyhock, also ALTHAEA [n -S]\n",
  "ALTHEAS": "ALTHEA, a genus of plants of the mallow family, that includes the garden hollyhock, also ALTHAEA [n]\n",
  "ALTHO": "although [conj]\n",
  "ALTHORN": "(German) an instrument of the saxhorn family, used exclusively in military music [n -S]\n",
  "ALTHORNS": "ALTHORN, (German) an instrument of the saxhorn family, used exclusively in military music [n]\n",
  "ALTHOUGH": "despite the fact that [conj]\n",
  "ALTIGRAPH": "an instrument that measures altitude [n -S]\n",
  "ALTIGRAPHS": "ALTIGRAPH, an instrument that measures altitude [n]\n",
  "ALTIMETER": "a device for measuring altitude [n -S]\n",
  "ALTIMETERS": "ALTIMETER, a device for measuring altitude [n]\n",
  "ALTIMETRICAL": "relating to measurement by altimeter [adj]\n",
  "ALTIMETRICALLY": "ALTIMETRICAL, relating to measurement by altimeter [adv]\n",
  "ALTIMETRIES": "ALTIMETRY, the art of measuring altitudes, or heights [n]\n",
  "ALTIMETRY": "the art of measuring altitudes, or heights [n ALTIMETRIES]\n",
  "ALTIPLANO": "(Spanish) a high plateau in Andes [n -S]\n",
  "ALTIPLANOS": "ALTIPLANO, (Spanish) a high plateau in Andes [n]\n",
  "ALTISONANT": "high-sounding [adj]\n",
  "ALTISSIMO": "(Italian) very high [adj] / the octave commencing an octave above the treble clef [n -S]\n",
  "ALTISSIMOS": "ALTISSIMO, the octave commencing an octave above the treble clef [n]\n",
  "ALTITONANT": "thundering on high or loudly [adj]\n",
  "ALTITUDE": "height above sea level [n -S]\n",
  "ALTITUDES": "ALTITUDE, height above sea level [n]\n",
  "ALTITUDINAL": "relating to altitude [adj]\n",
  "ALTITUDINARIAN": "someone tending to loftiness in doctrine [n -S]\n",
  "ALTITUDINARIANS": "ALTITUDINARIAN, someone tending to loftiness in doctrine [n]\n",
  "ALTITUDINOUS": "high [adj]\n",
  "ALTO": "(Italian) a low female singing voice [n -S]\n",
  "ALTOCUMULI": "ALTOCUMULUS, (Latin) a type of cloud [n]\n",
  "ALTOCUMULUS": "(Latin) a type of cloud [n ALTOCUMULI]\n",
  "ALTOGETHER": "a state of nudity [n -S]\n",
  "ALTOGETHERS": "ALTOGETHER, a state of nudity [n]\n",
  "ALTOIST": "one who plays the alto saxophone [n -S]\n",
  "ALTOISTS": "ALTOIST, one who plays the alto saxophone [n]\n",
  "ALTORUFFLED": "(Milton) altogether ruffled [adj]\n",
  "ALTOS": "ALTO, (Italian) a low female singing voice [n]\n",
  "ALTOSTRATI": "ALTOSTRATUS, (Latin) a type of cloud [n]\n",
  "ALTOSTRATUS": "(Latin) a type of cloud [n ALTOSTRATI]\n",
  "ALTRICES": "(Latin) birds whose young are hatched in a very immature and helpless condition, so as to require the care of their parents for some time, as opposed to praecoces [n]\n",
  "ALTRICIAL": "having young requiring care for a lengthy period [adj] / an altricial bird [n -S]\n",
  "ALTRICIALS": "ALTRICIAL, an altricial bird [n]\n",
  "ALTRUISM": "selfless devotion to the welfare of others [n -S]\n",
  "ALTRUISMS": "ALTRUISM, selfless devotion to the welfare of others [n]\n",
  "ALTRUIST": "one that practices altruism [n -S]\n",
  "ALTRUISTIC": "relating to altruism [adj ALTRUISTICALLY]\n",
  "ALTRUISTICALLY": "ALTRUISTIC, relating to altruism [adv]\n",
  "ALTRUISTS": "ALTRUIST, one that practices altruism [n]\n",
  "ALTS": "ALT, a high musical note [n]\n",
  "ALU": "(Hindi) a potato, also ALOO [n -S]\n",
  "ALUDEL": "(Arabic) a pear-shaped pot used in sublimation [n -S]\n",
  "ALUDELS": "ALUDEL, (Arabic) a pear-shaped pot used in sublimation [n]\n",
  "ALULA": "(Latin) one of three feathers springing from the base of the primaries [n ALULAE or ALULAS]\n",
  "ALULAE": "ALULA, (Latin) one of three feathers springing from the base of the primaries [n]\n",
  "ALULAR": "pertaining to the alulae, three feathers springing from the base of the primaries [adj]\n",
  "ALULAS": "ALULA, (Latin) one of three feathers springing from the base of the primaries [n]\n",
  "ALUM": "a sulphate of ammonium and potassium, used as a mordant [n -S]\n",
  "ALUMIN": "an oxide of aluminum, also ALUMINA, ALUMINE [n -S]\n",
  "ALUMINA": "an oxide of aluminum, also ALUMIN, ALUMINE [n -S]\n",
  "ALUMINAS": "ALUMINA, an oxide of aluminum, also ALUMIN, ALUMINE [n]\n",
  "ALUMINATE": "a salt whose acid is aluminum hydroxide [n -S]\n",
  "ALUMINATES": "ALUMINATE, a salt whose acid is aluminum hydroxide [n]\n",
  "ALUMINE": "an oxide of aluminum, also ALUMIN, ALUMINA [n -S]\n",
  "ALUMINES": "ALUMINE, an oxide of aluminum, also ALUMIN, ALUMINA [n]\n",
  "ALUMINIC": "of or containing aluminium; as, aluminic phosphate [adj]\n",
  "ALUMINIDE": "a compound that has aluminium with more electropositive elements [n -S]\n",
  "ALUMINIDES": "ALUMINIDE, a compound that has aluminium with more electropositive elements [n]\n",
  "ALUMINIFEROUS": "bearing aluminum [adj]\n",
  "ALUMINISE": "to treat metal so as to form an aluminum coating on its surface, also ALUMINIZE [v ALUMINISED, ALUMINISING, ALUMINISES]\n",
  "ALUMINISED": "ALUMINISE, to treat metal so as to form an aluminum coating on its surface, also ALUMINIZE [v]\n",
  "ALUMINISES": "ALUMINISE, to treat metal so as to form an aluminum coating on its surface, also ALUMINIZE [v]\n",
  "ALUMINISING": "ALUMINISE, to treat metal so as to form an aluminum coating on its surface, also ALUMINIZE [v]\n",
  "ALUMINIUM": "a light silvery malleable and ductile metallic element, also ALUMINUM, ALUMIUM [n -S]\n",
  "ALUMINIUMS": "ALUMINIUM, a light silvery malleable and ductile metallic element, also ALUMINUM, ALUMIUM [n]\n",
  "ALUMINIZE": "to treat metal so as to form an aluminum coating on its surface, also ALUMINISE [v ALUMINIZED, ALUMINIZING, ALUMINIZES]\n",
  "ALUMINIZED": "ALUMINIZE, to treat metal so as to form an aluminum coating on its surface, also ALUMINISE [v]\n",
  "ALUMINIZES": "ALUMINIZE, to treat metal so as to form an aluminum coating on its surface, also ALUMINISE [v]\n",
  "ALUMINIZING": "ALUMINIZE, to treat metal so as to form an aluminum coating on its surface, also ALUMINISE [v]\n",
  "ALUMINOSILICATE": "a combined silicate and aluminate [n]\n",
  "ALUMINOSITIES": "ALUMINOSITY, the quality of resembling aluminium [n]\n",
  "ALUMINOSITY": "the quality of resembling aluminium [n ALUMINOSITIES]\n",
  "ALUMINOTHERMIES": "ALUMINOTHERMY, a process for reducing metallic oxides using finely divided aluminium powder [n]\n",
  "ALUMINOTHERMY": "a process for reducing metallic oxides using finely divided aluminium powder [n ALUMINOTHERMIES]\n",
  "ALUMINOUS": "pertaining to or containing alum, or alumina [adj]\n",
  "ALUMINS": "ALUMIN, an oxide of aluminum, also ALUMINA, ALUMINE [n]\n",
  "ALUMINUM": "a light silvery malleable and ductile metallic element, also ALUMINIUM, ALUMIUM [n -S]\n",
  "ALUMINUMS": "ALUMINUM, a light silvery malleable and ductile metallic element, also ALUMINIUM, ALUMIUM [n]\n",
  "ALUMISH": "somewhat like alum, a sulphate of ammonium and potassium [adj]\n",
  "ALUMIUM": "(obsolete) aluminium, as first named by Sir Humphrey Davy, also ALUMINIUM, ALUMINUM [n -S]\n",
  "ALUMIUMS": "ALUMIUM, (obsolete) aluminium, as first named by Sir Humphrey Davy, also ALUMINIUM, ALUMINUM [n]\n",
  "ALUMNA": "(Latin) a female graduate [n ALUMNAE]\n",
  "ALUMNAE": "ALUMNA, (Latin) a female graduate [n]\n",
  "ALUMNI": "ALUMNUS, (Latin) a former pupil [n]\n",
  "ALUMNUS": "(Latin) a former pupil [n ALUMNI]\n",
  "ALUMROOT": "a North American flower of the saxifrage genus [n -S]\n",
  "ALUMROOTS": "ALUMROOT, a North American flower of the saxifrage genus [n]\n",
  "ALUMS": "ALUM, a sulphate of ammonium and potassium, used as a mordant [n]\n",
  "ALUMSTONE": "a hydrous sulphate of aluminum and potassium, aka alunite [n -S]\n",
  "ALUMSTONES": "ALUMSTONE, a hydrous sulphate of aluminum and potassium, aka alunite [n]\n",
  "ALUNITE": "a hydrous sulphate of aluminum and potassium, aka alumstone [n -S]\n",
  "ALUNITES": "ALUNITE, a hydrous sulphate of aluminum and potassium, aka alumstone [n]\n",
  "ALURE": "(obsolete) a walk behind battlements; a gallery [n -S]\n",
  "ALURES": "ALURE, (obsolete) a walk behind battlements; a gallery [n]\n",
  "ALUS": "ALU, (Hindi) a potato, also ALOO [n]\n",
  "ALVAR": "(Swedish) an area of exposed limestone [n -S]\n",
  "ALVARS": "ALVAR, (Swedish) an area of exposed limestone [n]\n",
  "ALVEARIES": "ALVEARY, a beehive; the hollow of the ear where wax collects [n]\n",
  "ALVEARY": "a beehive; the hollow of the ear where wax collects [n ALVEARIES]\n",
  "ALVEATED": "vaulted like a beehive [adj]\n",
  "ALVEOLAR": "pertaining to an alveolus; pronounced with tongue and alveolus [adj ALVEOLARLY] / a sound pronounced with tongue and alveolus [n -S]\n",
  "ALVEOLARLY": "ALVEOLAR, pertaining to an alveolus; pronounced with tongue and alveolus [adv]\n",
  "ALVEOLARS": "ALVEOLAR, a sound pronounced with tongue and alveolus [n]\n",
  "ALVEOLATE": "of or like a honeycomb [adj]\n",
  "ALVEOLATION": "the state of being alveolate [n -S]\n",
  "ALVEOLATIONS": "ALVEOLATION, the state of being alveolate [n]\n",
  "ALVEOLE": "a small body cavity, also ALVEOLUS [n -S]\n",
  "ALVEOLES": "ALVEOLE, a small body cavity, also ALVEOLUS [n]\n",
  "ALVEOLI": "ALVEOLUS, (Latin) a small body cavity, also ALVEOLE [n]\n",
  "ALVEOLITIS": "inflammation of the alveoli in the lungs [n ALVEOLITISES]\n",
  "ALVEOLITISES": "ALVEOLITIS, inflammation of the alveoli in the lungs [n]\n",
  "ALVEOLUS": "(Latin) a small body cavity, also ALVEOLE [n ALVEOLI]\n",
  "ALVINE": "of the belly [adj]\n",
  "ALWAY": "(archaic) always [adv]\n",
  "ALWAYS": "every time [adv]\n",
  "ALYCOMPAINE": "an old name for the plant elecampane [n -S]\n",
  "ALYCOMPAINES": "ALYCOMPAINE, an old name for the plant elecampane [n]\n",
  "ALYSSUM": "a plant of the Alyssum genus of low-growing, cruciferous plants, also ALISON [n -S]\n",
  "ALYSSUMS": "ALYSSUM, a plant of the Alyssum genus of low-growing, cruciferous plants, also ALISON [n]\n",
  "AM": "BE, to exist [v]\n",
  "AMA": "(Hindi) a native maidservant or child's nurse, esp. a wet nurse, also AMAH [n -S]\n",
  "AMABILE": "(Italian) of wines [adj]\n",
  "AMADAVAT": "(Hindi) the strawberry finch, a small Indian song bird, commonly caged and kept for fighting, also AVADAVAT [n -S]\n",
  "AMADAVATS": "AMADAVAT, (Hindi) the strawberry finch, a small Indian song bird, commonly caged and kept for fighting, also AVADAVAT [n]\n",
  "AMADODA": "(South African) grown men [n]\n",
  "AMADOU": "(French) a tinder made from fungi [n -S]\n",
  "AMADOUS": "AMADOU, (French) a tinder made from fungi [n]\n",
  "AMAH": "(Portuguese) a native maidservant or child's nurse, esp. a wet nurse, also AMA [n -S]\n",
  "AMAHS": "AMAH, (Portuguese) a native maidservant or child's nurse, esp. a wet nurse, also AMA [n]\n",
  "AMAIN": "(archaic) to a high degree; exceedingly [adv]\n",
  "AMAKHOSI": "INKHOSI, a traditional leader of a Zulu clan, also INKOSI [n]\n",
  "AMAKOSI": "INKOSI, a traditional leader of a Zulu clan, also INKHOSI [n]\n",
  "AMAKWEREKWERE": "(South African) a term used by blacks to refer to foreign Africans [n]\n",
  "AMALGAM": "an alloy of mercury with another metal [n -S]\n",
  "AMALGAMATE": "to unite in or as if in an amalgam; esp. to merge into a single body [v AMALGAMATED, AMALGAMATING, AMALGAMATES]\n",
  "AMALGAMATED": "AMALGAMATE, to unite in or as if in an amalgam; esp. to merge into a single body [v]\n",
  "AMALGAMATES": "AMALGAMATE, to unite in or as if in an amalgam; esp. to merge into a single body [v]\n",
  "AMALGAMATING": "AMALGAMATE, to unite in or as if in an amalgam; esp. to merge into a single body [v]\n",
  "AMALGAMATION": "the act of amalgamating [n -S]\n",
  "AMALGAMATIONS": "AMALGAMATION, the act of amalgamating [n]\n",
  "AMALGAMATIVE": "tending to amalgamate [adj]\n",
  "AMALGAMATOR": "one who amalgamates [n -S]\n",
  "AMALGAMATORS": "AMALGAMATOR, one who amalgamates [n]\n",
  "AMALGAMS": "AMALGAM, an alloy of mercury with another metal [n]\n",
  "AMANDINE": "(French) albumin in sweet almonds; a cold cream composed of that substance [n -S]\n",
  "AMANDINES": "AMANDINE, (French) albumin in sweet almonds; a cold cream composed of that substance [n]\n",
  "AMANDLA": "(South African) a political slogan calling for Black power [n -S]\n",
  "AMANDLAS": "AMANDLA, (South African) a political slogan calling for Black power [n]\n",
  "AMANITA": "(Greek) a kind of poisonous fungus [n -S]\n",
  "AMANITAS": "AMANITA, (Greek) a kind of poisonous fungus [n]\n",
  "AMANITIN": "a toxin produced by certain mushrooms [n -S]\n",
  "AMANITINS": "AMANITIN, a toxin produced by certain mushrooms [n]\n",
  "AMANTADINE": "a drug used to prevent infection by preventing the virus penetration of host cells [n -S]\n",
  "AMANTADINES": "AMANTADINE, a drug used to prevent infection by preventing the virus penetration of host cells [n]\n",
  "AMANUENSES": "AMANUENSIS, (Latin) one employed to take dictation or to copy manuscript [n]\n",
  "AMANUENSIS": "(Latin) one employed to take dictation or to copy manuscript [n AMANUENSES]\n",
  "AMARACUS": "(Latin) the herb marjoram [n -ES]\n",
  "AMARACUSES": "AMARACUS, (Latin) the herb marjoram [n]\n",
  "AMARANT": "a fabled never-fading flower, also AMARANTH [n -S]\n",
  "AMARANTACEOUS": "belonging to the family Amarantaceae, also AMARANTHACEOUS [adj]\n",
  "AMARANTH": "a fabled never-fading flower, also AMARANT [n -S]\n",
  "AMARANTHACEOUS": "belonging to the family Amarantaceae, also AMARANTACEOUS [adj]\n",
  "AMARANTHINE": "like amaranth, of a dark reddish-purple colour, also AMARANTIN, AMARANTINE [adj]\n",
  "AMARANTHS": "AMARANTH, a fabled never-fading flower, also AMARANT [n]\n",
  "AMARANTIN": "(Milton) the plant amaranth, also AMARANTHINE, AMARANTINE [n -S]\n",
  "AMARANTINE": "like amaranth, of a dark reddish-purple colour, also AMARANTHINE, AMARANTIN [adj]\n",
  "AMARANTINS": "AMARANTIN, (Milton) the plant amaranth, also AMARANTHINE, AMARANTINE [n]\n",
  "AMARANTS": "AMARANT, a fabled never-fading flower, also AMARANTH [n]\n",
  "AMARELLE": "(French) a variety of sour cherry [n -S]\n",
  "AMARELLES": "AMARELLE, (French) a variety of sour cherry [n]\n",
  "AMARETTI": "macaroons made with bitter almonds [n]\n",
  "AMARETTO": "(Italian) a kind of liqueur flavoured with almonds [n -S]\n",
  "AMARETTOS": "AMARETTO, (Italian) a kind of liqueur flavoured with almonds [n]\n",
  "AMARNA": "pertaining to a certain historical period of ancient Egypt [adj]\n",
  "AMARONE": "(Italian) a strong dry red wine [n -S]\n",
  "AMARONES": "AMARONE, (Italian) a strong dry red wine [n]\n",
  "AMARYLLID": "any member of the amaryllis family, also AMARYLLIS [n -S]\n",
  "AMARYLLIDACEOUS": "belonging to the Amaryllis family [adj]\n",
  "AMARYLLIDS": "AMARYLLID, any member of the amaryllis family, also AMARYLLIS [n]\n",
  "AMARYLLIS": "(Greek) the belladonna lily, or any of several similar plants, also AMARYLLID [n AMARYLLISES]\n",
  "AMARYLLISES": "AMARYLLIS, (Greek) the belladonna lily, or any of several similar plants, also AMARYLLID [n]\n",
  "AMAS": "AMA, (Hindi) a native maidservant or child's nurse, esp. a wet nurse, also AMAH [n]\n",
  "AMASS": "to accumulate [v -ED, -ING, -ES]\n",
  "AMASSABLE": "capable of being amassed [adj]\n",
  "AMASSED": "AMASS, to accumulate [v]\n",
  "AMASSER": "one who amasses [n -S]\n",
  "AMASSERS": "AMASSER, one who amasses [n]\n",
  "AMASSES": "AMASS, to accumulate [v]\n",
  "AMASSING": "AMASS, to accumulate [v]\n",
  "AMASSMENT": "an amassing; an accumulation [n -S]\n",
  "AMASSMENTS": "AMASSMENT, an amassing; an accumulation [n]\n",
  "AMATE": "(archaic) to dismay, daunt [v AMATED, AMATING, AMATES]\n",
  "AMATED": "AMATE, (archaic) to dismay, daunt [v]\n",
  "AMATES": "AMATE, (archaic) to dismay, daunt [v]\n",
  "AMATEUR": "one who engages in an activity for pleasure [n -S]\n",
  "AMATEURISH": "like an amateur [adj AMATEURISHLY]\n",
  "AMATEURISHLY": "AMATEURISH, like an amateur [adv]\n",
  "AMATEURISHNESS": "the quality of being an amateur [n]\n",
  "AMATEURISM": "the state of being an amateur [n -S]\n",
  "AMATEURISMS": "AMATEURISM, the state of being an amateur [n]\n",
  "AMATEURS": "AMATEUR, one who engages in an activity for pleasure [n]\n",
  "AMATEURSHIP": "the state of being an amateur [n -S]\n",
  "AMATEURSHIPS": "AMATEURSHIP, the state of being an amateur [n]\n",
  "AMATING": "AMATE, (archaic) to dismay, daunt [v]\n",
  "AMATION": "lovemaking [n -S]\n",
  "AMATIONS": "AMATION, lovemaking [n]\n",
  "AMATIVE": "strongly moved by love esp. sexual love [adj]\n",
  "AMATIVELY": "AMATIVE, strongly moved by love esp. sexual love [adv]\n",
  "AMATIVENESS": "the state of being amative [n -ES]\n",
  "AMATIVENESSES": "AMATIVENESS, the state of being amative [n]\n",
  "AMATOL": "an explosive composed of TNT. and ammonium nitrate [n -S]\n",
  "AMATOLS": "AMATOL, an explosive composed of TNT. and ammonium nitrate [n]\n",
  "AMATORIAL": "of or pertaining to a lover or to love making; as, amatorial verses [adj AMATORIALLY]\n",
  "AMATORIALLY": "AMATORIAL, of or pertaining to a lover or to love making; as, amatorial verses [adv]\n",
  "AMATORIAN": "amatory, also AMATORIOUS, AMATORY [adj]\n",
  "AMATORIOUS": "amatory, also AMATORIAN, AMATORY [adj]\n",
  "AMATORY": "pertaining to sexual love [adj]\n",
  "AMAUROSES": "AMAUROSIS, partial or total blindness, without apparent change in the eye [n]\n",
  "AMAUROSIS": "partial or total blindness, without apparent change in the eye [n AMAUROSES]\n",
  "AMAUROTIC": "relating to amaurosis, partial or total blindness, without apparent change in the eye [adj]\n",
  "AMAUT": "(Inuit) a hood on a woman's parka for carrying a child, also AMAUTI, AMAUTIK, AMOWT [n -S]\n",
  "AMAUTI": "(Inuit) an Inuit woman's parka, also AMAUT, AMAUTIK, AMOWT [n -S]\n",
  "AMAUTIK": "(Inuit) an Inuit woman's parka, also AMAUT, AMAUTI, AMOWT [n -S]\n",
  "AMAUTIKS": "AMAUTIK, (Inuit) an Inuit woman's parka, also AMAUT, AMAUTI, AMOWT [n]\n",
  "AMAUTIS": "AMAUTI, (Inuit) an Inuit woman's parka, also AMAUT, AMAUTIK, AMOWT [n]\n",
  "AMAUTS": "AMAUT, (Inuit) a hood on a woman's parka for carrying a child, also AMAUTI, AMAUTIK, AMOWT [n]\n",
  "AMAZE": "to overwhelm with astonishment [v AMAZED, AMAZING, AMAZES]\n",
  "AMAZEBALLS": "an expression of enthusiastic approval [interj]\n",
  "AMAZED": "AMAZE, to overwhelm with astonishment [v]\n",
  "AMAZEDLY": "AMAZED, AMAZE, to overwhelm with astonishment [adv]\n",
  "AMAZEDNESS": "the state of being amazed [n -ES]\n",
  "AMAZEDNESSES": "AMAZEDNESS, the state of being amazed [n]\n",
  "AMAZEMENT": "the state of being amazed, also MAZEMENT [n -S]\n",
  "AMAZEMENTS": "AMAZEMENT, the state of being amazed, also MAZEMENT [n]\n",
  "AMAZES": "AMAZE, to overwhelm with astonishment [v]\n",
  "AMAZING": "AMAZE, to overwhelm with astonishment [v]\n",
  "AMAZINGLY": "AMAZING, AMAZE, to overwhelm with astonishment [adv]\n",
  "AMAZON": "a powerful woman [n -S]\n",
  "AMAZONIAN": "of masculine manners; warlike [adj] / a warlike woman [n -S]\n",
  "AMAZONIANS": "AMAZONIAN, a warlike woman [n]\n",
  "AMAZONITE": "a green microcline said to be given by the Brazilian Amazons to the men who visited them, aka amazonstone [n -S]\n",
  "AMAZONITES": "AMAZONITE, a green microcline said to be given by the Brazilian Amazons to the men who visited them, aka amazonstone [n]\n",
  "AMAZONS": "AMAZON, a powerful woman [n]\n",
  "AMAZONSTONE": "a green microcline, aka amazonite [n -S]\n",
  "AMAZONSTONES": "AMAZONSTONE, a green microcline, aka amazonite [n]\n",
  "AMBACH": "a pith tree, also AMBATCH [n -ES]\n",
  "AMBACHES": "AMBACH, a pith tree, also AMBATCH [n]\n",
  "AMBAGE": "(French) ambiguity [n -S]\n",
  "AMBAGES": "AMBAGE, (French) ambiguity [n]\n",
  "AMBAGIOUS": "(archaic) roundabout, circuitous [adj]\n",
  "AMBAGITORY": "(Scott) ambagious, circuitous [adj]\n",
  "AMBAN": "(Chinese) a Chinese resident official in a dependency [n -S]\n",
  "AMBANS": "AMBAN, (Chinese) a Chinese resident official in a dependency [n]\n",
  "AMBARI": "(Urdu) a fibre-yielding plant of East Indies, also AMBARY [n -S]\n",
  "AMBARIES": "AMBARY, (Hindi) a fibre-yielding plant of East Indies, also AMBARI [n]\n",
  "AMBARIS": "AMBARI, (Urdu) a fibre-yielding plant of East Indies, also AMBARY [n]\n",
  "AMBARY": "(Hindi) a fibre-yielding plant of East Indies, also AMBARI [n AMBARIES]\n",
  "AMBASSADOR": "an official envoy, also EMBASSADOR [n -S]\n",
  "AMBASSADORIAL": "of or like an ambassador [adj]\n",
  "AMBASSADORS": "AMBASSADOR, an official envoy, also EMBASSADOR [n]\n",
  "AMBASSADORSHIP": "the position of an ambassador [n -S]\n",
  "AMBASSADORSHIPS": "AMBASSADORSHIP, the position of an ambassador [n]\n",
  "AMBASSADRESS": "a woman who is an ambassador [n -ES]\n",
  "AMBASSADRESSES": "AMBASSADRESS, a woman who is an ambassador [n]\n",
  "AMBASSAGE": "an embassy, also EMBASSAGE [n -S]\n",
  "AMBASSAGES": "AMBASSAGE, an embassy, also EMBASSAGE [n]\n",
  "AMBASSIES": "AMBASSY, the offices of an ambassador, also EMBASSY [n]\n",
  "AMBASSY": "the offices of an ambassador, also EMBASSY [n AMBASSIES]\n",
  "AMBATCH": "(Ethiopian) a spongy wood, often used for rafts, also AMBACH [n -ES]\n",
  "AMBATCHES": "AMBATCH, (Ethiopian) a spongy wood, often used for rafts, also AMBACH [n]\n",
  "AMBEER": "the spittle produced when chewing tobacco [n -S]\n",
  "AMBEERS": "AMBEER, the spittle produced when chewing tobacco [n]\n",
  "AMBER": "a fossil resin, used for ornaments etc. [n -S]\n",
  "AMBERED": "embedded in amber [adj]\n",
  "AMBERGRIS": "an ash-grey strongly-scented substance, originating in the intestines of the spermaceti whale and used in the manufacture of perfumes [n -ES]\n",
  "AMBERGRISES": "AMBERGRIS, an ash-grey strongly-scented substance, originating in the intestines of the spermaceti whale and used in the manufacture of perfumes [n]\n",
  "AMBERIER": "AMBERY, like amber [adj]\n",
  "AMBERIES": "AMBERY, a recess for church vessels, a cupboard, also ALMERY, AMBRY, AUMBRY, AWMRIE, AWMRY [n]\n",
  "AMBERIEST": "AMBERY, like amber [adj]\n",
  "AMBERINA": "(tradename) a type of clear glassware [n -S]\n",
  "AMBERINAS": "AMBERINA, (tradename) a type of clear glassware [n]\n",
  "AMBERITE": "a kind of smokeless powder [n -S]\n",
  "AMBERITES": "AMBERITE, a kind of smokeless powder [n]\n",
  "AMBERJACK": "a large Atlantic gamefish having golden markings when young [n -S]\n",
  "AMBERJACKS": "AMBERJACK, a large Atlantic gamefish having golden markings when young [n]\n",
  "AMBEROID": "a synthetic amber, also AMBROID [n -S]\n",
  "AMBEROIDS": "AMBEROID, a synthetic amber, also AMBROID [n]\n",
  "AMBEROUS": "containing amber [adj]\n",
  "AMBERS": "AMBER, a fossil resin, used for ornaments etc. [n]\n",
  "AMBERY": "like amber [adj AMBERIER, AMBERIEST] / a recess for church vessels, a cupboard, also ALMERY, AMBRY, AUMBRY, AWMRIE, AWMRY [n AMBERIES]\n",
  "AMBIANCE": "the mood or atmosphere of a place or situation, also AMBIENCE [n -S]\n",
  "AMBIANCES": "AMBIANCE, the mood or atmosphere of a place or situation, also AMBIENCE [n]\n",
  "AMBIDENTATE": "of a ligand, able to coordinate through either of two different atoms, also AMPHIDENTATE [adj]\n",
  "AMBIDEXTER": "(archaic) someone who is ambidextrous [n -S]\n",
  "AMBIDEXTERITIES": "AMBIDEXTERITY, the state of being ambidextrous [n]\n",
  "AMBIDEXTERITY": "the state of being ambidextrous [n AMBIDEXTERITIES]\n",
  "AMBIDEXTEROUS": "able to use either hand with equal dexterity, also AMBIDEXTROUS [adj]\n",
  "AMBIDEXTERS": "AMBIDEXTER, (archaic) someone who is ambidextrous [n]\n",
  "AMBIDEXTROUS": "able to use either hand with equal dexterity, also AMBIDEXTEROUS [adj AMBIDEXTROUSLY]\n",
  "AMBIDEXTROUSLY": "AMBIDEXTROUS, able to use either hand with equal dexterity, also AMBIDEXTEROUS [adv]\n",
  "AMBIENCE": "the mood or atmosphere of a place or situation, also AMBIANCE [n -S]\n",
  "AMBIENCES": "AMBIENCE, the mood or atmosphere of a place or situation, also AMBIANCE [n]\n",
  "AMBIENT": "surrounding [adj] / something which encompasses, the earth and sky [n -S]\n",
  "AMBIENTS": "AMBIENT, something which encompasses, the earth and sky [n]\n",
  "AMBIGUITIES": "AMBIGUITY, the state of being ambiguous [n]\n",
  "AMBIGUITY": "the state of being ambiguous [n AMBIGUITIES]\n",
  "AMBIGUOUS": "open to more than one interpretation [adj]\n",
  "AMBIGUOUSLY": "AMBIGUOUS, open to more than one interpretation [adv]\n",
  "AMBIGUOUSNESS": "the state of being ambiguous [n -ES]\n",
  "AMBIGUOUSNESSES": "AMBIGUOUSNESS, the state of being ambiguous [n]\n",
  "AMBILATERAL": "relating to or involving both sides [adj]\n",
  "AMBIOPHONIES": "AMBIOPHONY, the reproduction of sound to create an illusion to a listener of being in a spacious room, such as a concert hall [n]\n",
  "AMBIOPHONY": "the reproduction of sound to create an illusion to a listener of being in a spacious room, such as a concert hall [n AMBIOPHONIES]\n",
  "AMBIPOLAR": "of plasmas and semiconductors, involving both positive and negative charge carriers [adj]\n",
  "AMBISEXUAL": "of sexual characteristics, common to both sexes, e.g. pubic hair [adj] / one of indeterminate sex, also AMBOSEXUAL [n -S]\n",
  "AMBISEXUALITIES": "AMBISEXUALITY, the state of being an ambisexual [n]\n",
  "AMBISEXUALITY": "the state of being an ambisexual [n AMBISEXUALITIES]\n",
  "AMBISEXUALS": "AMBISEXUAL, one of indeterminate sex, also AMBOSEXUAL [n]\n",
  "AMBISONICS": "the technique of reproducing and transmitting surround sound [n]\n",
  "AMBIT": "a circuit, compass, or circumference esp. a space surrounding a house, castle, town, etc. [n -S]\n",
  "AMBITION": "aspiration after success or advancement [n -S] / to seek with eagerness [v -ED, -ING, -S]\n",
  "AMBITIONED": "AMBITION, to seek with eagerness [v]\n",
  "AMBITIONING": "AMBITION, to seek with eagerness [v]\n",
  "AMBITIONLESS": "without ambition [adj]\n",
  "AMBITIONS": "AMBITION, to seek with eagerness [v]\n",
  "AMBITIOUS": "having ambition [adj AMBITIOUSLY]\n",
  "AMBITIOUSLY": "AMBITIOUS, having ambition [adv]\n",
  "AMBITIOUSNESS": "the state of being ambitious [n -ES]\n",
  "AMBITIOUSNESSES": "AMBITIOUSNESS, the state of being ambitious [n]\n",
  "AMBITS": "AMBIT, a circuit, compass, or circumference esp. a space surrounding a house, castle, town, etc. [n]\n",
  "AMBITTY": "denoting glass which has become devitrified and brittle [adj]\n",
  "AMBIVALENCE": "simultaneous and contradictory feelings toward something, also AMBIVALENCY [n -S]\n",
  "AMBIVALENCES": "AMBIVALENCE, simultaneous and contradictory feelings toward something, also AMBIVALENCY [n]\n",
  "AMBIVALENCIES": "AMBIVALENCY, simultaneous and contradictory feelings toward something, also AMBIVALENCE [n]\n",
  "AMBIVALENCY": "simultaneous and contradictory feelings toward something, also AMBIVALENCE [n AMBIVALENCIES]\n",
  "AMBIVALENT": "having conflicting emotional attitudes towards the same object [adj AMBIVALENTLY]\n",
  "AMBIVALENTLY": "AMBIVALENT, having conflicting emotional attitudes towards the same object [adv]\n",
  "AMBIVERSION": "the state of being an ambivert [n -S]\n",
  "AMBIVERSIONS": "AMBIVERSION, the state of being an ambivert [n]\n",
  "AMBIVERT": "someone who is both extroverted and introverted [n -S]\n",
  "AMBIVERTS": "AMBIVERT, someone who is both extroverted and introverted [n]\n",
  "AMBLE": "to saunter [v AMBLED, AMBLING, AMBLES]\n",
  "AMBLED": "AMBLE, to saunter [v]\n",
  "AMBLER": "one who ambles [n -S]\n",
  "AMBLERS": "AMBLER, one who ambles [n]\n",
  "AMBLES": "AMBLE, to saunter [v]\n",
  "AMBLING": "walking at a leisurely pace [n -S]\n",
  "AMBLINGS": "AMBLING, walking at a leisurely pace [n]\n",
  "AMBLYGONITE": "lithium ore [n -S]\n",
  "AMBLYGONITES": "AMBLYGONITE, lithium ore [n]\n",
  "AMBLYOPIA": "impaired sight without any apparent damage to the eye [n -S]\n",
  "AMBLYOPIAS": "AMBLYOPIA, impaired sight without any apparent damage to the eye [n]\n",
  "AMBLYOPIC": "of or pertaining to amblyopia, partial loss of sight not due to disease of eye [adj]\n",
  "AMBO": "a pulpit in an early Christian church [n AMBOS or AMBONES]\n",
  "AMBOCEPTOR": "in immunization, an antibody acting as a double receptor [n -S]\n",
  "AMBOCEPTORS": "AMBOCEPTOR, in immunization, an antibody acting as a double receptor [n]\n",
  "AMBOINA": "a reddish-brown, curly-grained Moluccan wood, also AMBOYNA [n -S]\n",
  "AMBOINAS": "AMBOINA, a reddish-brown, curly-grained Moluccan wood, also AMBOYNA [n]\n",
  "AMBONES": "AMBO, a pulpit in an early Christian church [n]\n",
  "AMBOS": "AMBO, a pulpit in an early Christian church [n]\n",
  "AMBOSEXUAL": "common to both sexes, also AMBISEXUAL [adj]\n",
  "AMBOYNA": "a reddish-brown, curly-grained Moluccan wood, also AMBOINA [n -S]\n",
  "AMBOYNAS": "AMBOYNA, a reddish-brown, curly-grained Moluccan wood, also AMBOINA [n]\n",
  "AMBRIES": "AMBRY, a cupboard for sacred vessels, also ALMERY, AMBERY, AUMBRY, AWMRIE, AWMRY [n]\n",
  "AMBROID": "a synthetic amber, also AMBEROID [n -S]\n",
  "AMBROIDS": "AMBROID, a synthetic amber, also AMBEROID [n]\n",
  "AMBROSIA": "(Greek) the food of the gods [n -S]\n",
  "AMBROSIAL": "consisting of, or partaking of the nature of, ambrosia, also AMBROSIAN [adj AMBROSIALLY]\n",
  "AMBROSIALLY": "AMBROSIAL, consisting of, or partaking of the nature of, ambrosia, also AMBROSIAN [adv]\n",
  "AMBROSIAN": "consisting of, or partaking of the nature of, ambrosia, also AMBROSIAL [adj]\n",
  "AMBROSIAS": "AMBROSIA, (Greek) the food of the gods [n]\n",
  "AMBROTYPE": "a picture taken on a plate of prepared glass, in which the lights are represented in silver, and the shades are produced by a dark background visible through the un-silvered portions of the glass [n -S]\n",
  "AMBROTYPES": "AMBROTYPE, a picture taken on a plate of prepared glass, in which the lights are represented in silver, and the shades are produced by a dark background visible through the un-silvered portions of the glass [n]\n",
  "AMBRY": "a cupboard for sacred vessels, also ALMERY, AMBERY, AUMBRY, AWMRIE, AWMRY [n AMBRIES]\n",
  "AMBSACE": "bad luck, also AMESACE [n -S]\n",
  "AMBSACES": "AMBSACE, bad luck, also AMESACE [n]\n",
  "AMBULACRA": "AMBULACRUM, a radial band in the shell of an echinoderm, bearing rows of pores through which the tube-feet protrude [n]\n",
  "AMBULACRAL": "of or pertaining to ambulacra, as the ambulacral ossicles, plates, spines, and suckers of echinoderms [adj]\n",
  "AMBULACRUM": "a radial band in the shell of an echinoderm, bearing rows of pores through which the tube-feet protrude [n AMBULACRA]\n",
  "AMBULANCE": "a vehicle for conveying sick people [n -S]\n",
  "AMBULANCEMAN": "one who operates an ambulance [n AMBULANCEMEN]\n",
  "AMBULANCEMEN": "AMBULANCEMAN, one who operates an ambulance [n]\n",
  "AMBULANCES": "AMBULANCE, a vehicle for conveying sick people [n]\n",
  "AMBULANCEWOMAN": "a woman who drives an ambulance [n AMBULANCEWOMEN]\n",
  "AMBULANCEWOMEN": "AMBULANCEWOMAN, a woman who drives an ambulance [n]\n",
  "AMBULANT": "walking; moving from place to place [adj] / a walking patient [n -S]\n",
  "AMBULANTS": "AMBULANT, a walking patient [n]\n",
  "AMBULATE": "to walk; to move about [v AMBULATED, AMBULATING, AMBULATES]\n",
  "AMBULATED": "AMBULATE, to walk; to move about [v]\n",
  "AMBULATES": "AMBULATE, to walk; to move about [v]\n",
  "AMBULATING": "AMBULATE, to walk; to move about [v]\n",
  "AMBULATION": "the act of walking [n -S]\n",
  "AMBULATIONS": "AMBULATION, the act of walking [n]\n",
  "AMBULATOR": "one who walks about; a walker [n -S]\n",
  "AMBULATORIES": "AMBULATORY, an aisle down the east end of a church, behind the altar [n]\n",
  "AMBULATORILY": "AMBULATORY, walking [adv]\n",
  "AMBULATORS": "AMBULATOR, one who walks about; a walker [n]\n",
  "AMBULATORY": "walking [adj AMBULATORILY] / an aisle down the east end of a church, behind the altar [n AMBULATORIES]\n",
  "AMBULETTE": "a motor vehicle for transporting ill or handicapped people [n -S]\n",
  "AMBULETTES": "AMBULETTE, a motor vehicle for transporting ill or handicapped people [n]\n",
  "AMBUSCADE": "(French) to lay an ambush, also AMBUSCADO [v AMBUSCADED, AMBUSCADING, AMBUSCADES]\n",
  "AMBUSCADED": "AMBUSCADE, (French) to lay an ambush, also AMBUSCADO [v]\n",
  "AMBUSCADER": "one who ambuscades [n -S]\n",
  "AMBUSCADERS": "AMBUSCADER, one who ambuscades [n]\n",
  "AMBUSCADES": "AMBUSCADE, (French) to lay an ambush, also AMBUSCADO [v]\n",
  "AMBUSCADING": "AMBUSCADE, (French) to lay an ambush, also AMBUSCADO [v]\n",
  "AMBUSCADO": "an ambuscade, also AMBUSCADE [n AMBUSCADOES or AMBUSCADOS]\n",
  "AMBUSCADOES": "AMBUSCADO, an ambuscade, also AMBUSCADE [n]\n",
  "AMBUSCADOS": "AMBUSCADO, an ambuscade, also AMBUSCADE [n]\n",
  "AMBUSH": "to attack from a concealed place [v -ED, -ING, -ES]\n",
  "AMBUSHED": "AMBUSH, to attack from a concealed place [v]\n",
  "AMBUSHER": "one who ambushes [n -S]\n",
  "AMBUSHERS": "AMBUSHER, one who ambushes [n]\n",
  "AMBUSHES": "AMBUSH, to attack from a concealed place [v]\n",
  "AMBUSHING": "AMBUSH, to attack from a concealed place [v]\n",
  "AMBUSHMENT": "(archaic) an ambush [n -S]\n",
  "AMBUSHMENTS": "AMBUSHMENT, (archaic) an ambush [n]\n",
  "AME": "(French) a soul [n -S]\n",
  "AMEARST": "AMERCE, to fine or punish [v]\n",
  "AMEBA": "(Greek) a one-celled animal of ever-changing shape, also AMOEBA [n AMEBAS or AMEBAE]\n",
  "AMEBAE": "AMEBA, (Greek) a one-celled animal of ever-changing shape, also AMOEBA [n]\n",
  "AMEBAN": "pertaining to an ameba, also AMOEBAN [adj]\n",
  "AMEBAS": "AMEBA, (Greek) a one-celled animal of ever-changing shape, also AMOEBA [n]\n",
  "AMEBEAN": "alternately responding, also AMOEBEAN [adj]\n",
  "AMEBIASES": "AMEBIASIS, infection of the colon by amoebae, also AMOEBIASIS [n]\n",
  "AMEBIASIS": "infection of the colon by amoebae, also AMOEBIASIS [n AMEBIASES]\n",
  "AMEBIC": "pertaining to an ameba, also AMOEBIC [adj]\n",
  "AMEBOCYTE": "a cell, like a leukocyte, having amoeboid form, also AMOEBOCYTE [n -S]\n",
  "AMEBOCYTES": "AMEBOCYTE, a cell, like a leukocyte, having amoeboid form, also AMOEBOCYTE [n]\n",
  "AMEBOID": "resembling an ameba, also AMOEBOID [adj]\n",
  "AMEER": "(Arabic) an Eastern ruler, also AMIR, EMEER, EMIR [n -S]\n",
  "AMEERATE": "(Arabic) the rank of an ameer, also AMIRATE [n -S]\n",
  "AMEERATES": "AMEERATE, (Arabic) the rank of an ameer, also AMIRATE [n]\n",
  "AMEERS": "AMEER, (Arabic) an Eastern ruler, also AMIR, EMEER, EMIR [n]\n",
  "AMEIOSES": "AMEIOSIS, the non-pairing of the chromosomes [n]\n",
  "AMEIOSIS": "the non-pairing of the chromosomes [n AMEIOSES]\n",
  "AMELCORN": "(German) a variety of wheat from which starch is produced [n -S]\n",
  "AMELCORNS": "AMELCORN, (German) a variety of wheat from which starch is produced [n]\n",
  "AMELIA": "being born without one or more limbs [n -S]\n",
  "AMELIAS": "AMELIA, being born without one or more limbs [n]\n",
  "AMELIORABLE": "that can be ameliorated [adj]\n",
  "AMELIORANT": "an agent that ameliorates [n -S]\n",
  "AMELIORANTS": "AMELIORANT, an agent that ameliorates [n]\n",
  "AMELIORATE": "to make better, also MELIORATE [v AMELIORATED, AMELIORATING, AMELIORATES]\n",
  "AMELIORATED": "AMELIORATE, to make better, also MELIORATE [v]\n",
  "AMELIORATES": "AMELIORATE, to make better, also MELIORATE [v]\n",
  "AMELIORATING": "AMELIORATE, to make better, also MELIORATE [v]\n",
  "AMELIORATION": "the act of ameliorating [n -S]\n",
  "AMELIORATIONS": "AMELIORATION, the act of ameliorating [n]\n",
  "AMELIORATIVE": "tending to ameliorate [adj]\n",
  "AMELIORATOR": "one who ameliorates [n -S]\n",
  "AMELIORATORS": "AMELIORATOR, one who ameliorates [n]\n",
  "AMELIORATORY": "serving to ameliorate [adj]\n",
  "AMELOBLAST": "an enamel-producing cell of a tooth [n -S]\n",
  "AMELOBLASTS": "AMELOBLAST, an enamel-producing cell of a tooth [n]\n",
  "AMELOGENESES": "AMELOGENESIS, the production of enamel by ameloblasts [n]\n",
  "AMELOGENESIS": "the production of enamel by ameloblasts [n AMELOGENESES]\n",
  "AMEN": "to conclude prayerfully [v -ED, -ING, -S]\n",
  "AMENABILITIES": "AMENABILITY, the state of being amenable [n]\n",
  "AMENABILITY": "the state of being amenable [n AMENABILITIES]\n",
  "AMENABLE": "capable of being persuaded [adj]\n",
  "AMENABLENESS": "the state of being amenable [n -ES]\n",
  "AMENABLENESSES": "AMENABLENESS, the state of being amenable [n]\n",
  "AMENABLY": "AMENABLE, capable of being persuaded [adv]\n",
  "AMENAGE": "(Spenser) to manage, control [v AMENAGED, AMENAGING, AMENAGES]\n",
  "AMENAGED": "AMENAGE, (Spenser) to manage, control [v]\n",
  "AMENAGES": "AMENAGE, (Spenser) to manage, control [v]\n",
  "AMENAGING": "AMENAGE, (Spenser) to manage, control [v]\n",
  "AMENAUNCE": "(Spenser) bearing, conduct [n -S]\n",
  "AMENAUNCES": "AMENAUNCE, (Spenser) bearing, conduct [n]\n",
  "AMEND": "to correct, improve [v -ED, -ING, -S]\n",
  "AMENDABLE": "that can be amended [adj]\n",
  "AMENDATORY": "supplying amendment [adj]\n",
  "AMENDE": "(French) a fine or reparation paid [n -S]\n",
  "AMENDED": "AMEND, to correct, improve [v]\n",
  "AMENDER": "one who amends [n -S]\n",
  "AMENDERS": "AMENDER, one who amends [n]\n",
  "AMENDES": "AMENDE, (French) a fine or reparation paid [n]\n",
  "AMENDING": "AMEND, to correct, improve [v]\n",
  "AMENDMENT": "a change, a correction [n -S]\n",
  "AMENDMENTS": "AMENDMENT, a change, a correction [n]\n",
  "AMENDS": "AMEND, to correct, improve [v]\n",
  "AMENE": "pleasant, offering amenity [adj]\n",
  "AMENED": "AMEN, to conclude prayerfully [v]\n",
  "AMENING": "AMEN, to conclude prayerfully [v]\n",
  "AMENITIES": "AMENITY, pleasantness [n]\n",
  "AMENITY": "pleasantness [n AMENITIES]\n",
  "AMENORRHEA": "abnormal absence or arrest of menstruation, also AMENORRHOEA [n -S]\n",
  "AMENORRHEAS": "AMENORRHEA, abnormal absence or arrest of menstruation, also AMENORRHOEA [n]\n",
  "AMENORRHEIC": "suffering from amenorrhoea, abnormal absence or arrest of menstruation [adj]\n",
  "AMENORRHOEA": "abnormal absence or arrest of menstruation, also AMENORRHEA [n -S]\n",
  "AMENORRHOEAS": "AMENORRHOEA, abnormal absence or arrest of menstruation, also AMENORRHEA [n]\n",
  "AMENS": "AMEN, to conclude prayerfully [v]\n",
  "AMENT": "a mentally deficient person [n -S]\n",
  "AMENTA": "AMENTUM, (Latin) a catkin [n]\n",
  "AMENTACEOUS": "like or composed of catkins [adj]\n",
  "AMENTAL": "of a catkin [adj]\n",
  "AMENTIA": "mental deficiency [n -S]\n",
  "AMENTIAS": "AMENTIA, mental deficiency [n]\n",
  "AMENTIFEROUS": "bearing catkins [adj]\n",
  "AMENTS": "AMENT, a mentally deficient person [n]\n",
  "AMENTUM": "(Latin) a catkin [n AMENTA]\n",
  "AMERCE": "to fine or punish [v AMEARST or AMERCED, AMERCING, AMERCES]\n",
  "AMERCEABLE": "liable to be amerced, also AMERCIABLE [adj]\n",
  "AMERCED": "AMERCE, to fine or punish [v]\n",
  "AMERCEMENT": "the infliction of a fine, also AMERCIAMENT [n -S]\n",
  "AMERCEMENTS": "AMERCEMENT, the infliction of a fine, also AMERCIAMENT [n]\n",
  "AMERCER": "one who amerces, fines, punishes [n -S]\n",
  "AMERCERS": "AMERCER, one who amerces, fines, punishes [n]\n",
  "AMERCES": "AMERCE, to fine or punish [v]\n",
  "AMERCIABLE": "liable to be amerced, also AMERCEABLE [adj]\n",
  "AMERCIAMENT": "the infliction of a fine, also AMERCEMENT [n -S]\n",
  "AMERCIAMENTS": "AMERCIAMENT, the infliction of a fine, also AMERCEMENT [n]\n",
  "AMERCING": "AMERCE, to fine or punish [v]\n",
  "AMERICIUM": "a white metallic transuranic element of the actinide series [n -S]\n",
  "AMERICIUMS": "AMERICIUM, a white metallic transuranic element of the actinide series [n]\n",
  "AMES": "AME, (French) a soul [n]\n",
  "AMESACE": "a double ace, the lowest possible throw at dice, also AMBSACE [n -S]\n",
  "AMESACES": "AMESACE, a double ace, the lowest possible throw at dice, also AMBSACE [n]\n",
  "AMETABOLIC": "of insects, showing little or no metamorphosis, also AMETABOLOUS [adj]\n",
  "AMETABOLISM": "the lack of metamorphosis in insects [n -S]\n",
  "AMETABOLISMS": "AMETABOLISM, the lack of metamorphosis in insects [n]\n",
  "AMETABOLOUS": "of insects, showing little or no metamorphosis, also AMETABOLIC [adj]\n",
  "AMETHYST": "a purple gemstone, believed to ward off drunkenness [n -S]\n",
  "AMETHYSTINE": "of or like amethyst [adj]\n",
  "AMETHYSTS": "AMETHYST, a purple gemstone, believed to ward off drunkenness [n]\n",
  "AMETROPIA": "abnormal optical refraction [n -S]\n",
  "AMETROPIAS": "AMETROPIA, abnormal optical refraction [n]\n",
  "AMETROPIC": "relating to ametropia, abnormal optical refraction [adj]\n",
  "AMI": "(French) a friend [n -S]\n",
  "AMIA": "a freshwater fish, aka bowfin [n -S]\n",
  "AMIABILITIES": "AMIABILITY, the state of being amiable [n]\n",
  "AMIABILITY": "the state of being amiable [n AMIABILITIES]\n",
  "AMIABLE": "(French) having a pleasant disposition [adj]\n",
  "AMIABLENESS": "the state of being amiable [n -ES]\n",
  "AMIABLENESSES": "AMIABLENESS, the state of being amiable [n]\n",
  "AMIABLY": "AMIABLE, (French) having a pleasant disposition [adv]\n",
  "AMIANTHINE": "of or like amianthus, asbestos with silky fibres, also AMIANTHOID, AMIANTHOIDAL [adj]\n",
  "AMIANTHOID": "of or like amianthus, asbestos with silky fibres, also AMIANTHINE, AMIANTHOIDAL [adj]\n",
  "AMIANTHOIDAL": "of or like amianthus, asbestos with silky fibres, also AMIANTHINE, AMIANTHOID [adj]\n",
  "AMIANTHUS": "(Greek) asbestos with silky fibres, also AMIANTUS [n -ES]\n",
  "AMIANTHUSES": "AMIANTHUS, (Greek) asbestos with silky fibres, also AMIANTUS [n]\n",
  "AMIANTUS": "(Greek) the finest fibrous asbestos [n -ES]\n",
  "AMIANTUSES": "AMIANTUS, (Greek) the finest fibrous asbestos [n]\n",
  "AMIAS": "AMIA, a freshwater fish, aka bowfin [n]\n",
  "AMICABILITIES": "AMICABILITY, the state of being amicable [n]\n",
  "AMICABILITY": "the state of being amicable [n AMICABILITIES]\n",
  "AMICABLE": "friendly [adj AMICABLY]\n",
  "AMICABLENESS": "the state of being amicable [n -ES]\n",
  "AMICABLENESSES": "AMICABLENESS, the state of being amicable [n]\n",
  "AMICABLY": "AMICABLE, friendly [adv]\n",
  "AMICE": "a furred hood with long ends hanging down in front, worn by certain religious orders, also ALMUCE [n -S]\n",
  "AMICES": "AMICE, a furred hood with long ends hanging down in front, worn by certain religious orders, also ALMUCE [n]\n",
  "AMICI": "AMICUS, (Latin) a legal expert witness [n]\n",
  "AMICUS": "(Latin) a legal expert witness [n AMICI]\n",
  "AMID": "a compound formed by the union of amidogen with an acid element or radical, also AMIDE [n -S]\n",
  "AMIDASE": "an enzyme that catalyses an amid [n -S]\n",
  "AMIDASES": "AMIDASE, an enzyme that catalyses an amid [n]\n",
  "AMIDE": "a compound formed by the union of amidogen with an acid element or radical, also AMID [n -S]\n",
  "AMIDES": "AMIDE, a compound formed by the union of amidogen with an acid element or radical, also AMID [n]\n",
  "AMIDIC": "of or like an amide, a compound formed by the union of amidogen with an acid element or radical [adj]\n",
  "AMIDIN": "the soluble matter of starch [n -S]\n",
  "AMIDINE": "the soluble matter in starch, also AMIDIN [n -S]\n",
  "AMIDINES": "AMIDINE, the soluble matter in starch, also AMIDIN [n]\n",
  "AMIDINS": "AMIDIN, the soluble matter of starch [n]\n",
  "AMIDMOST": "in the very middle [adv]\n",
  "AMIDO": "containing an amide united with an acid radical [adj]\n",
  "AMIDOGEN": "a derivative of ammonia in which a hydrogen atom is replaced by an acid radical [n -S]\n",
  "AMIDOGENS": "AMIDOGEN, a derivative of ammonia in which a hydrogen atom is replaced by an acid radical [n]\n",
  "AMIDOL": "a colourless chemical used as a photographic developer [n -S]\n",
  "AMIDOLS": "AMIDOL, a colourless chemical used as a photographic developer [n]\n",
  "AMIDONE": "a synthetic opioid used as an analgesic [n -S]\n",
  "AMIDONES": "AMIDONE, a synthetic opioid used as an analgesic [n]\n",
  "AMIDS": "AMID, a compound formed by the union of amidogen with an acid element or radical, also AMIDE [n]\n",
  "AMIDSHIP": "toward the middle of the ship, also AMIDSHIPS [adv]\n",
  "AMIDSHIPS": "toward the middle of the ship, also AMIDSHIP [adv]\n",
  "AMIDST": "in the middle of [prep]\n",
  "AMIE": "(French) a (female) friend [n -S]\n",
  "AMIES": "AMIE, (French) a (female) friend [n]\n",
  "AMIGA": "(Spanish) a (female) friend [n -S]\n",
  "AMIGAS": "AMIGA, (Spanish) a (female) friend [n]\n",
  "AMIGO": "(Spanish) a (male) friend [n -S]\n",
  "AMIGOS": "AMIGO, (Spanish) a (male) friend [n]\n",
  "AMILDAR": "(Urdu) a factor or manager in India, a collector of revenues [n -S]\n",
  "AMILDARS": "AMILDAR, (Urdu) a factor or manager in India, a collector of revenues [n]\n",
  "AMIN": "a compound derived from ammonia, also AMINE [n -S]\n",
  "AMINE": "a compound derived from ammonia, also AMIN [n -S]\n",
  "AMINES": "AMINE, a compound derived from ammonia, also AMIN [n]\n",
  "AMINIC": "of or like an amine, a compound derived from ammonia [adj]\n",
  "AMINITIES": "AMINITY, the state of being amine [n]\n",
  "AMINITY": "the state of being amine [n AMINITIES]\n",
  "AMINO": "a compound containing an amine with a nonacid radical [n -S]\n",
  "AMINOACETIC": "as in aminoacetic acid, another name for glycine [adj]\n",
  "AMINOACIDURIA": "a condition in which one or more amino acids are excreted in excessive amounts [n -S]\n",
  "AMINOACIDURIAS": "AMINOACIDURIA, a condition in which one or more amino acids are excreted in excessive amounts [n]\n",
  "AMINOBENZOIC": "as in aminobenzoic acid [adj]\n",
  "AMINOBUTENE": "a synthetic pain-relieving drug, less addictive than morphine [n -S]\n",
  "AMINOBUTENES": "AMINOBUTENE, a synthetic pain-relieving drug, less addictive than morphine [n]\n",
  "AMINOPEPTIDASE": "an enzyme [n -S]\n",
  "AMINOPEPTIDASES": "AMINOPEPTIDASE, an enzyme [n]\n",
  "AMINOPHENAZONE": "a pyrazole derivative with analgesic, anti-inflammatory, and antipyretic properties [n -S]\n",
  "AMINOPHENAZONES": "AMINOPHENAZONE, a pyrazole derivative with analgesic, anti-inflammatory, and antipyretic properties [n]\n",
  "AMINOPHENOL": "any of three isomeric forms that are white soluble crystalline solids, used as a dye and as a photograph developer [n -S]\n",
  "AMINOPHENOLS": "AMINOPHENOL, any of three isomeric forms that are white soluble crystalline solids, used as a dye and as a photograph developer [n]\n",
  "AMINOPHYLLINE": "a drug used to stimulate the heart and to dilate the air passages [n -S]\n",
  "AMINOPHYLLINES": "AMINOPHYLLINE, a drug used to stimulate the heart and to dilate the air passages [n]\n",
  "AMINOPTERIN": "a rodenticide [n -S]\n",
  "AMINOPTERINS": "AMINOPTERIN, a rodenticide [n]\n",
  "AMINOPYRINE": "a drug formerly used to relieve pain and fever [n -S]\n",
  "AMINOPYRINES": "AMINOPYRINE, a drug formerly used to relieve pain and fever [n]\n",
  "AMINOS": "AMINO, a compound containing an amine with a nonacid radical [n]\n",
  "AMINOTOLUENE": "another name for toluidine [n -S]\n",
  "AMINOTOLUENES": "AMINOTOLUENE, another name for toluidine [n]\n",
  "AMINS": "AMIN, a compound derived from ammonia, also AMINE [n]\n",
  "AMIR": "(Arabic) an Eastern ruler, also AMEER, EMEER, EMIR [n -S]\n",
  "AMIRATE": "the rank of an amir, also AMEERATE [n -S]\n",
  "AMIRATES": "AMIRATE, the rank of an amir, also AMEERATE [n]\n",
  "AMIRS": "AMIR, (Arabic) an Eastern ruler, also AMEER, EMEER, EMIR [n]\n",
  "AMIS": "(Spenser) a clerical garb worn on the shoulders, also AMICE [n -ES]\n",
  "AMISES": "AMIS, (Spenser) a clerical garb worn on the shoulders, also AMICE [n]\n",
  "AMISS": "wrongly, astray [adv] / an evil, a misdeed [n -ES]\n",
  "AMISSES": "AMISS, an evil, a misdeed [n]\n",
  "AMISSIBILITIES": "AMISSIBILITY, the state of being amissible, liable to be lost [n]\n",
  "AMISSIBILITY": "the state of being amissible, liable to be lost [n AMISSIBILITIES]\n",
  "AMISSIBLE": "liable to be lost [adj]\n",
  "AMISSING": "(Scots) wanting, lost [adv]\n",
  "AMITIES": "AMITY, friendship [n]\n",
  "AMITOSES": "AMITOSIS, direct cell division, without mitosis [n]\n",
  "AMITOSIS": "direct cell division, without mitosis [n AMITOSES]\n",
  "AMITOTIC": "relating to amitosis, direct cell division, without mitosis [adj AMITOTICALLY]\n",
  "AMITOTICALLY": "AMITOTIC, relating to amitosis, direct cell division, without mitosis [adv]\n",
  "AMITRIPTYLINE": "an antidepressant drug, also AMITRYPTYLINE [n -S]\n",
  "AMITRIPTYLINES": "AMITRIPTYLINE, an antidepressant drug, also AMITRYPTYLINE [n]\n",
  "AMITROLE": "a kind of herbicide [n -S]\n",
  "AMITROLES": "AMITROLE, a kind of herbicide [n]\n",
  "AMITRYPTYLINE": "an antidepressant drug, also AMITRIPTYLINE [n -S]\n",
  "AMITRYPTYLINES": "AMITRYPTYLINE, an antidepressant drug, also AMITRIPTYLINE [n]\n",
  "AMITY": "friendship [n AMITIES]\n",
  "AMLA": "an East Indian tree [n -S]\n",
  "AMLAS": "AMLA, an East Indian tree [n]\n",
  "AMMAN": "(German) in Germany, Switzerland, the Netherlands and Scandinavia, a district magistrate, also AMTMAN [n -S]\n",
  "AMMANS": "AMMAN, (German) in Germany, Switzerland, the Netherlands and Scandinavia, a district magistrate, also AMTMAN [n]\n",
  "AMMETER": "an instrument for measuring amperage [n -S]\n",
  "AMMETERS": "AMMETER, an instrument for measuring amperage [n]\n",
  "AMMINE": "a type of ammonia compound, also AMMONATE, AMMONIATE [n -S]\n",
  "AMMINES": "AMMINE, a type of ammonia compound, also AMMONATE, AMMONIATE [n]\n",
  "AMMINO": "pertaining to an ammine, a compound derived from ammonia [adj]\n",
  "AMMIRAL": "(Milton) a naval commander, also ADMIRAL [n -S]\n",
  "AMMIRALS": "AMMIRAL, (Milton) a naval commander, also ADMIRAL [n]\n",
  "AMMO": "(short for) ammunition [n -S]\n",
  "AMMOCETE": "the larva of a lamprey [n -S]\n",
  "AMMOCETES": "AMMOCETE, the larva of a lamprey [n]\n",
  "AMMOCOETE": "the larva of a lamprey, also AMMOCETE [n -S]\n",
  "AMMOCOETES": "AMMOCOETE, the larva of a lamprey, also AMMOCETE [n]\n",
  "AMMOLITE": "the fossilised shell of an ammonite [n -S]\n",
  "AMMOLITES": "AMMOLITE, the fossilised shell of an ammonite [n]\n",
  "AMMON": "(Greek) the Asian wild sheep, aka argali [n -S]\n",
  "AMMONAL": "a powerful explosive [n -S]\n",
  "AMMONALS": "AMMONAL, a powerful explosive [n]\n",
  "AMMONATE": "a type of ammonia compound, also AMMINE, AMMONIATE [n -S]\n",
  "AMMONATES": "AMMONATE, a type of ammonia compound, also AMMINE, AMMONIATE [n]\n",
  "AMMONIA": "a pungent compound [n -S]\n",
  "AMMONIAC": "a gum resin [n -S]\n",
  "AMMONIACAL": "of or pertaining to ammonia, also AMMONICAL [adj]\n",
  "AMMONIACS": "AMMONIAC, a gum resin [n]\n",
  "AMMONIACUM": "gum ammoniac [n -S]\n",
  "AMMONIACUMS": "AMMONIACUM, gum ammoniac [n]\n",
  "AMMONIAS": "AMMONIA, a pungent compound [n]\n",
  "AMMONIATE": "to compound with ammonia [v AMMONIATED, AMMONIATING, AMMONIATES]\n",
  "AMMONIATED": "AMMONIATE, to compound with ammonia [v]\n",
  "AMMONIATES": "AMMONIATE [n]\n",
  "AMMONIATING": "AMMONIATE, to compound with ammonia [v]\n",
  "AMMONIATION": "impregnation with ammonia [n -S]\n",
  "AMMONIATIONS": "AMMONIATION, impregnation with ammonia [n]\n",
  "AMMONIC": "of or pertaining to ammonia [adj]\n",
  "AMMONICAL": "of or pertaining to ammonia, also AMMONIACAL [adj]\n",
  "AMMONIFICATION": "the act of ammoniating [n -S]\n",
  "AMMONIFICATIONS": "AMMONIFICATION, the act of ammoniating [n]\n",
  "AMMONIFIED": "AMMONIFY, to treat with ammonia [v]\n",
  "AMMONIFIES": "AMMONIFY, to treat with ammonia [v]\n",
  "AMMONIFY": "to treat with ammonia [v AMMONIFIED, AMMONIFYING, AMMONIFIES]\n",
  "AMMONIFYING": "AMMONIFY, to treat with ammonia [v]\n",
  "AMMONITE": "the coiled shell of an extinct mollusk, also AMMONOID [n -S]\n",
  "AMMONITES": "AMMONITE, the coiled shell of an extinct mollusk, also AMMONOID [n]\n",
  "AMMONITIC": "of or like an ammonite, a type of fossil [adj]\n",
  "AMMONIUM": "the ion NH4+, which occurs in the salts formed by ammonia and in ammonia solutions [n -S]\n",
  "AMMONIUMS": "AMMONIUM, the ion NH4+, which occurs in the salts formed by ammonia and in ammonia solutions [n]\n",
  "AMMONO": "containing ammonia [adj]\n",
  "AMMONOID": "the coiled shell of an extinct mollusk, also AMMONITE [n -S]\n",
  "AMMONOIDS": "AMMONOID, the coiled shell of an extinct mollusk, also AMMONITE [n]\n",
  "AMMONOLYSES": "AMMONOLYSIS, solvolysis in liquid ammonia [n]\n",
  "AMMONOLYSIS": "solvolysis in liquid ammonia [n AMMONOLYSES]\n",
  "AMMONS": "AMMON, (Greek) the Asian wild sheep, aka argali [n]\n",
  "AMMOPHILOUS": "sand-loving [adj]\n",
  "AMMOS": "AMMO, (short for) ammunition [n]\n",
  "AMMUNITION": "the projectiles fired from guns [n -S] / to supply with ammunition [v -ED, -ING, -S]\n",
  "AMMUNITIONED": "AMMUNITION, to supply with ammunition [v]\n",
  "AMMUNITIONING": "AMMUNITION, to supply with ammunition [v]\n",
  "AMMUNITIONS": "AMMUNITION, to supply with ammunition [v]\n",
  "AMNESIA": "loss of memory [n -S]\n",
  "AMNESIAC": "one who suffers from amnesia, also AMNESIC [n -S]\n",
  "AMNESIACS": "AMNESIAC, one who suffers from amnesia, also AMNESIC [n]\n",
  "AMNESIAS": "AMNESIA, loss of memory [n]\n",
  "AMNESIC": "one who suffers from amnesia, also AMNESIAC [n -S]\n",
  "AMNESICS": "AMNESIC, one who suffers from amnesia, also AMNESIAC [n]\n",
  "AMNESTIC": "causing loss of memory [adj]\n",
  "AMNESTIED": "AMNESTY, to pardon during a limited period [v]\n",
  "AMNESTIES": "AMNESTY, to pardon during a limited period [v]\n",
  "AMNESTY": "to pardon during a limited period [v AMNESTIED, AMNESTYING, AMNESTIES]\n",
  "AMNESTYING": "AMNESTY, to pardon during a limited period [v]\n",
  "AMNIA": "AMNION, (Greek) the innermost membrane enveloping the embryo of reptiles, birds and mammals [n]\n",
  "AMNIC": "pertaining to the amnion [adj]\n",
  "AMNIO": "(short for) an amniocentesis, a test of amniotic fluid for foetal abnormalities [n -S]\n",
  "AMNIOCENTESES": "AMNIOCENTESIS, a surgical insertion of a needle into the uterus [n]\n",
  "AMNIOCENTESIS": "a surgical insertion of a needle into the uterus [n AMNIOCENTESES]\n",
  "AMNION": "(Greek) the innermost membrane enveloping the embryo of reptiles, birds and mammals [n AMNIA or AMNIONS]\n",
  "AMNIONIC": "pertaining to the amnion [adj]\n",
  "AMNIONS": "AMNION, (Greek) the innermost membrane enveloping the embryo of reptiles, birds and mammals [n]\n",
  "AMNIOS": "AMNIO, (short for) an amniocentesis, a test of amniotic fluid for foetal abnormalities [n]\n",
  "AMNIOTE": "a vertebrate that develops an amnion during the embryonic stage [n -S]\n",
  "AMNIOTES": "AMNIOTE, a vertebrate that develops an amnion during the embryonic stage [n]\n",
  "AMNIOTIC": "relating to an amniote, a vertebrate that develops an amnion during the embryonic stage [adj]\n",
  "AMNIOTOMIES": "AMNIOTOMY, surgical removal of the amnion [n]\n",
  "AMNIOTOMY": "surgical removal of the amnion [n AMNIOTOMIES]\n",
  "AMOBARBITAL": "a white crystalline powder used as a sedative [n -S]\n",
  "AMOBARBITALS": "AMOBARBITAL, a white crystalline powder used as a sedative [n]\n",
  "AMOEBA": "(Greek) a one-celled animal of ever-changing shape, also AMEBA [n AMOEBAS or AMOEBAE]\n",
  "AMOEBAE": "AMOEBA, (Greek) a one-celled animal of ever-changing shape, also AMEBA [n]\n",
  "AMOEBAEAN": "relating to an ameba, also AMEBAN, AMEBEAN, AMEBIC, AMOEBAN, AMOEBIC [adj]\n",
  "AMOEBAN": "relating to an amoeba, also AMEBAN, AMEBEAN, AMEBIC, AMOEBAEAN, AMOEBIC [adj]\n",
  "AMOEBAS": "AMOEBA, (Greek) a one-celled animal of ever-changing shape, also AMEBA [n]\n",
  "AMOEBEAN": "alternately answering, responsive, as often in pastoral poetry [adj]\n",
  "AMOEBIASES": "AMOEBIASIS, infection of the colon by amoebae, also AMEBIASIS [n]\n",
  "AMOEBIASIS": "infection of the colon by amoebae, also AMEBIASIS [n AMOEBIASES]\n",
  "AMOEBIC": "pertaining to an amoeba, also AMEBIC [adj]\n",
  "AMOEBIFORM": "resembling an amoeba; changing in shape like an amoeba, also AMEBOID, AMOEBOID [adj]\n",
  "AMOEBOCYTE": "a cell, like a leukocyte, having amoeboid form, also AMEBOCYTE [n -S]\n",
  "AMOEBOCYTES": "AMOEBOCYTE, a cell, like a leukocyte, having amoeboid form, also AMEBOCYTE [n]\n",
  "AMOEBOID": "resembling an ameba, also AMEBOID [adj]\n",
  "AMOK": "(Malay) a murderous frenzy, also AMUCK [n -S]\n",
  "AMOKS": "AMOK, (Malay) a murderous frenzy, also AMUCK [n]\n",
  "AMOKURA": "(Maori) a white pelagian bird of tropical latitudes, with a red beak and red tail feathers [n -S]\n",
  "AMOKURAS": "AMOKURA, (Maori) a white pelagian bird of tropical latitudes, with a red beak and red tail feathers [n]\n",
  "AMOLE": "a plant root used as soap [n -S]\n",
  "AMOLES": "AMOLE, a plant root used as soap [n]\n",
  "AMOMUM": "(Greek) a plant of the ginger family native to Asia and Africa [n -S]\n",
  "AMOMUMS": "AMOMUM, (Greek) a plant of the ginger family native to Asia and Africa [n]\n",
  "AMONG": "in the midst of, also EMONG, EMONGES [prep]\n",
  "AMONGST": "among, also EMONG, EMONGES, EMONGEST, EMONGST, MONGST [prep]\n",
  "AMONTILLADO": "a kind of sherry [n -S]\n",
  "AMONTILLADOS": "AMONTILLADO, a kind of sherry [n]\n",
  "AMOOVE": "(Spenser) to stir up, to rouse, also AMOVE [v AMOOVED, AMOOVING, AMOOVES]\n",
  "AMOOVED": "AMOOVE, (Spenser) to stir up, to rouse, also AMOVE [v]\n",
  "AMOOVES": "AMOOVE, (Spenser) to stir up, to rouse, also AMOVE [v]\n",
  "AMOOVING": "AMOOVE, (Spenser) to stir up, to rouse, also AMOVE [v]\n",
  "AMORAL": "lacking a sense of right and wrong [adj]\n",
  "AMORALISM": "the refusal to recognize the validity of any system of morality [n -S]\n",
  "AMORALISMS": "AMORALISM, the refusal to recognize the validity of any system of morality [n]\n",
  "AMORALIST": "a practitioner of amoralism, the refusal to recognize the validity of any system of morality [n -S]\n",
  "AMORALISTS": "AMORALIST, a practitioner of amoralism, the refusal to recognize the validity of any system of morality [n]\n",
  "AMORALITIES": "AMORALITY, the absence of morality [n]\n",
  "AMORALITY": "the absence of morality [n AMORALITIES]\n",
  "AMORALLY": "AMORAL, lacking a sense of right and wrong [adv]\n",
  "AMORANCE": "the state of being in love; romantic love [n -S]\n",
  "AMORANCES": "AMORANCE, the state of being in love; romantic love [n]\n",
  "AMORANT": "pertaining to romantic love [adj]\n",
  "AMORCE": "(French) a percussion cap for a toy pistol [n -S]\n",
  "AMORCES": "AMORCE, (French) a percussion cap for a toy pistol [n]\n",
  "AMORET": "a love sonnet or song; a sweetheart [n -S]\n",
  "AMORETS": "AMORET, a love sonnet or song; a sweetheart [n]\n",
  "AMORETTI": "AMORETTO, (Italian) a cherub or spirit of love [n]\n",
  "AMORETTO": "(Italian) a cherub or spirit of love [n AMORETTOS or AMORETTI]\n",
  "AMORETTOS": "AMORETTO, (Italian) a cherub or spirit of love [n]\n",
  "AMORINI": "AMORINO, (Italian) a cupid [n]\n",
  "AMORINO": "(Italian) a cupid [n AMORINI]\n",
  "AMORISM": "a love affair [n -S]\n",
  "AMORISMS": "AMORISM, a love affair [n]\n",
  "AMORIST": "a lover; a sexual adventurer [n -S]\n",
  "AMORISTIC": "amorous [adj]\n",
  "AMORISTS": "AMORIST, a lover; a sexual adventurer [n]\n",
  "AMORNINGS": "(dialect) of a morning [adv]\n",
  "AMOROSA": "(Italian) a wanton woman; a courtesan [n -S]\n",
  "AMOROSAS": "AMOROSA, (Italian) a wanton woman; a courtesan [n]\n",
  "AMOROSITIES": "AMOROSITY, the quality of being amorous [n]\n",
  "AMOROSITY": "the quality of being amorous [n AMOROSITIES]\n",
  "AMOROSO": "(Italian) a (male) lover; a dark sweet sherry [n -S]\n",
  "AMOROSOS": "AMOROSO, (Italian) a (male) lover; a dark sweet sherry [n]\n",
  "AMOROUS": "pertaining to love [adj]\n",
  "AMOROUSLY": "AMOROUS, pertaining to love [adv]\n",
  "AMOROUSNESS": "the quality of being amorous [n -ES]\n",
  "AMOROUSNESSES": "AMOROUSNESS, the quality of being amorous [n]\n",
  "AMORPHISM": "absence of regular form; amorphous quality [n -S]\n",
  "AMORPHISMS": "AMORPHISM, absence of regular form; amorphous quality [n]\n",
  "AMORPHOUS": "without definite shape [adj AMORPHOUSLY]\n",
  "AMORPHOUSLY": "AMORPHOUS, without definite shape [adv]\n",
  "AMORPHOUSNESS": "the state of being amorphous [n -ES]\n",
  "AMORPHOUSNESSES": "AMORPHOUSNESS, the state of being amorphous [n]\n",
  "AMORT": "(archaic) spiritless, dejected [adj]\n",
  "AMORTISABLE": "that can be amortised, also AMORTIZABLE [adj]\n",
  "AMORTISATION": "the act of amortising, also AMORTIZATION [n -S]\n",
  "AMORTISATIONS": "AMORTISATION, the act of amortising, also AMORTIZATION [n]\n",
  "AMORTISE": "to liquidate gradually, as a debt, also AMORTIZE [v AMORTISED, AMORTISING, AMORTISES]\n",
  "AMORTISED": "AMORTISE, to liquidate gradually, as a debt, also AMORTIZE [v]\n",
  "AMORTISEMENT": "the act of amortising, also AMORTIZEMENT [n -S]\n",
  "AMORTISEMENTS": "AMORTISEMENT, the act of amortising, also AMORTIZEMENT [n]\n",
  "AMORTISES": "AMORTISE, to liquidate gradually, as a debt, also AMORTIZE [v]\n",
  "AMORTISING": "AMORTISE, to liquidate gradually, as a debt, also AMORTIZE [v]\n",
  "AMORTIZABLE": "that can be amortized, also AMORTISABLE [adj]\n",
  "AMORTIZATION": "the act of amortising, also AMORTISATION [n -S]\n",
  "AMORTIZATIONS": "AMORTIZATION, the act of amortising, also AMORTISATION [n]\n",
  "AMORTIZE": "to liquidate gradually, as a debt, also AMORTISE [v AMORTIZED, AMORTIZING, AMORTIZES]\n",
  "AMORTIZED": "AMORTIZE, to liquidate gradually, as a debt, also AMORTISE [v]\n",
  "AMORTIZEMENT": "the act of amortizing, also AMORTISEMENT [n -S]\n",
  "AMORTIZEMENTS": "AMORTIZEMENT, the act of amortizing, also AMORTISEMENT [n]\n",
  "AMORTIZES": "AMORTIZE, to liquidate gradually, as a debt, also AMORTISE [v]\n",
  "AMORTIZING": "AMORTIZE, to liquidate gradually, as a debt, also AMORTISE [v]\n",
  "AMOSITE": "a brown form of asbestos [n -S]\n",
  "AMOSITES": "AMOSITE, a brown form of asbestos [n]\n",
  "AMOTION": "the removal of a corporate officer from his office [n -S]\n",
  "AMOTIONS": "AMOTION, the removal of a corporate officer from his office [n]\n",
  "AMOUNT": "to come to in total [v -ED, -ING, -S]\n",
  "AMOUNTED": "AMOUNT, to come to in total [v]\n",
  "AMOUNTING": "AMOUNT, to come to in total [v]\n",
  "AMOUNTS": "AMOUNT, to come to in total [v]\n",
  "AMOUR": "(French) a love affair [n -S]\n",
  "AMOURETTE": "(French) a brief or unimportant love affair [n -S]\n",
  "AMOURETTES": "AMOURETTE, (French) a brief or unimportant love affair [n]\n",
  "AMOURS": "AMOUR, (French) a love affair [n]\n",
  "AMOVE": "(obsolete) to stir up, to rouse, also AMOOVE [v AMOVED, AMOVING, AMOVES]\n",
  "AMOVED": "AMOVE, (obsolete) to stir up, to rouse, also AMOOVE [v]\n",
  "AMOVES": "AMOVE, (obsolete) to stir up, to rouse, also AMOOVE [v]\n",
  "AMOVING": "AMOVE, (obsolete) to stir up, to rouse, also AMOOVE [v]\n",
  "AMOWT": "(Inuit) a hood on a woman's parka for carrying a child, also AMAUT, AMAUTI, AMAUTIK [n -S]\n",
  "AMOWTS": "AMOWT, (Inuit) a hood on a woman's parka for carrying a child, also AMAUT, AMAUTI, AMAUTIK [n]\n",
  "AMOXICILLIN": "an antibiotic drug, a type of semisynthetic penicillin, also AMOXYCILLIN [n -S]\n",
  "AMOXICILLINS": "AMOXICILLIN, an antibiotic drug, a type of semisynthetic penicillin, also AMOXYCILLIN [n]\n",
  "AMOXYCILLIN": "an antibiotic drug, a type of semisynthetic penicillin, also AMOXICILLIN [n -S]\n",
  "AMOXYCILLINS": "AMOXYCILLIN, an antibiotic drug, a type of semisynthetic penicillin, also AMOXICILLIN [n]\n",
  "AMP": "(Australian slang) to excite [v -ED, -ING, -S]\n",
  "AMPACITIES": "AMPACITY, the largest amount of current that a wire can carry [n]\n",
  "AMPACITY": "the largest amount of current that a wire can carry [n AMPACITIES]\n",
  "AMPASSIES": "AMPASSY, ampersand, a symbol for plus in writing [n]\n",
  "AMPASSY": "ampersand, a symbol for plus in writing [n AMPASSIES]\n",
  "AMPED": "AMP, (Australian slang) to excite [v]\n",
  "AMPELOGRAPHIES": "AMPELOGRAPHY, the study of grapevines [n]\n",
  "AMPELOGRAPHY": "the study of grapevines [n AMPELOGRAPHIES]\n",
  "AMPELOPSES": "AMPELOPSIS, a woody vine [n]\n",
  "AMPELOPSIS": "a woody vine [n AMPELOPSES, AMPELOPSISES]\n",
  "AMPELOPSISES": "AMPELOPSIS, a woody vine [n]\n",
  "AMPERAGE": "the strength of an electric current expressed in amperes [n -S]\n",
  "AMPERAGES": "AMPERAGE, the strength of an electric current expressed in amperes [n]\n",
  "AMPERE": "(French) a unit of electric current strength [n -S]\n",
  "AMPERES": "AMPERE, (French) a unit of electric current strength [n]\n",
  "AMPEROMETRIC": "relating to a chemical titration utilizing electric current for detecting the end point [adj]\n",
  "AMPERSAND": "the and sign &, also AMPERZAND [n -S]\n",
  "AMPERSANDS": "AMPERSAND, the and sign &, also AMPERZAND [n]\n",
  "AMPERZAND": "the and sign &, also AMPERSAND [n -S]\n",
  "AMPERZANDS": "AMPERZAND, the and sign &, also AMPERSAND [n]\n",
  "AMPHETAMINE": "a synthetic, potentially habit-forming drug used as an appetite suppressant and in the treatment of narcolepsy [n -S]\n",
  "AMPHETAMINES": "AMPHETAMINE, a synthetic, potentially habit-forming drug used as an appetite suppressant and in the treatment of narcolepsy [n]\n",
  "AMPHIARTHROSES": "AMPHIARTHROSIS, a type of articulation permitting only slight movement, as between the vertebrae of the backbone [n]\n",
  "AMPHIARTHROSIS": "a type of articulation permitting only slight movement, as between the vertebrae of the backbone [n AMPHIARTHROSES]\n",
  "AMPHIASTER": "the structure that occurs in a cell undergoing mitosis, consisting of a spindle with an aster at each end [n -S]\n",
  "AMPHIASTERS": "AMPHIASTER, the structure that occurs in a cell undergoing mitosis, consisting of a spindle with an aster at each end [n]\n",
  "AMPHIBIA": "organisms adapted for life on land and sea [n]\n",
  "AMPHIBIAN": "any cold-blooded vertebrate of the class Amphibia, typically living on land but breeding in water, that includes newts and salamanders, frogs and toads, and caecilians [n -S]\n",
  "AMPHIBIANS": "AMPHIBIAN, any cold-blooded vertebrate of the class Amphibia, typically living on land but breeding in water, that includes newts and salamanders, frogs and toads, and caecilians [n]\n",
  "AMPHIBIOTIC": "having an aquatic larval form and a terrestrial adult form, as amphibians [adj]\n",
  "AMPHIBIOUS": "adapted for both land and water [adj AMPHIBIOUSLY]\n",
  "AMPHIBIOUSLY": "AMPHIBIOUS, adapted for both land and water [adv]\n",
  "AMPHIBIOUSNESS": "the state of being amphibious [n]\n",
  "AMPHIBLASTIC": "of animal ova, showing complete but unequal cleavage after fertilization [adj]\n",
  "AMPHIBLASTULA": "the free-swimming larva of certain sponges, which consists of a hollow spherical mass of cells some of which have flagella [n AMPHIBLASTULAE]\n",
  "AMPHIBLASTULAE": "AMPHIBLASTULA, the free-swimming larva of certain sponges, which consists of a hollow spherical mass of cells some of which have flagella [n]\n",
  "AMPHIBOLE": "any mineral of a group of dark-coloured, rock-forming silicates [n -S]\n",
  "AMPHIBOLES": "AMPHIBOLE, any mineral of a group of dark-coloured, rock-forming silicates [n]\n",
  "AMPHIBOLIC": "able to turn both backwards and forwards; double-jointed [adj]\n",
  "AMPHIBOLIES": "AMPHIBOLY, a grammatically ambiguous phrase or sentence, also AMPHIBOLOGY [n]\n",
  "AMPHIBOLITE": "rock composed of amphibole; hornblende [n -S]\n",
  "AMPHIBOLITES": "AMPHIBOLITE, rock composed of amphibole; hornblende [n]\n",
  "AMPHIBOLOGICAL": "related to amphibology [adj]\n",
  "AMPHIBOLOGIES": "AMPHIBOLOGY, a grammatically ambiguous phrase or sentence, also AMPHIBOLY [n]\n",
  "AMPHIBOLOGY": "a grammatically ambiguous phrase or sentence, also AMPHIBOLY [n AMPHIBOLOGIES]\n",
  "AMPHIBOLOUS": "ambiguous; capable of two meanings [adj]\n",
  "AMPHIBOLY": "a grammatically ambiguous phrase or sentence, also AMPHIBOLOGY [n AMPHIBOLIES]\n",
  "AMPHIBRACH": "a foot of three syllables, the middle one long, the first and last short [n -S]\n",
  "AMPHIBRACHIC": "of or like an amphibrach, a foot of three syllables, the middle one long, the first and last short [adj]\n",
  "AMPHIBRACHS": "AMPHIBRACH, a foot of three syllables, the middle one long, the first and last short [n]\n",
  "AMPHICHROIC": "producing two colours, one on reacting with an acid, the other on reacting with a base, also AMPHICHROMATIC [adj]\n",
  "AMPHICHROMATIC": "producing two colours, one on reacting with an acid, the other on reacting with a base, also AMPHICHROIC [adj]\n",
  "AMPHICOELOUS": "of the vertebrae of most fishes and some amphibians, concave at the anterior and posterior ends [adj]\n",
  "AMPHICTYON": "(historical) a delegate to a council of an amphictyony, a group of states sharing common shrine (e.g. the Greek states sharing Delphi) [n -S]\n",
  "AMPHICTYONIC": "applied to the ancient Greek council of state-deputies [adj]\n",
  "AMPHICTYONIES": "AMPHICTYONY, a group of states sharing common shrine (e.g. the Greek states sharing Delphi) [n]\n",
  "AMPHICTYONS": "AMPHICTYON, (historical) a delegate to a council of an amphictyony, a group of states sharing common shrine (e.g. the Greek states sharing Delphi) [n]\n",
  "AMPHICTYONY": "a group of states sharing common shrine (e.g. the Greek states sharing Delphi) [n AMPHICTYONIES]\n",
  "AMPHIDENTATE": "of a ligand, able to coordinate through either of two different atoms, also AMBIDENTATE [adj]\n",
  "AMPHIDIPLOID": "a hybrid having a complete diploid chromosome set from each parent [n -S]\n",
  "AMPHIDIPLOIDIES": "AMPHIDIPLOIDY, the state of being amphidiploid [n]\n",
  "AMPHIDIPLOIDS": "AMPHIDIPLOID, a hybrid having a complete diploid chromosome set from each parent [n]\n",
  "AMPHIDIPLOIDY": "the state of being amphidiploid [n AMPHIDIPLOIDIES]\n",
  "AMPHIGASTRIA": "AMPHIGASTRIUM, a scalelike leaf on the ventral side of some liverworts [n]\n",
  "AMPHIGASTRIUM": "a scalelike leaf on the ventral side of some liverworts [n AMPHIGASTRIA]\n",
  "AMPHIGORIC": "relating to amphigory, a nonsensical piece of writing, usually in verse form, typically composed as a parody [adj]\n",
  "AMPHIGORIES": "AMPHIGORY, a nonsensical piece of writing, usually in verse form, typically composed as a parody, also AMPHIGOURI [n]\n",
  "AMPHIGORY": "a nonsensical piece of writing, usually in verse form, typically composed as a parody, also AMPHIGOURI [n AMPHIGORIES]\n",
  "AMPHIGOURI": "a nonsensical piece of writing, usually in verse form, typically composed as a parody, also AMPHIGORY [n -S]\n",
  "AMPHIGOURIS": "AMPHIGOURI, a nonsensical piece of writing, usually in verse form, typically composed as a parody, also AMPHIGORY [n]\n",
  "AMPHIMACER": "a foot of three syllables, the middle one short and the others long, as in 'castitas' [n -S]\n",
  "AMPHIMACERS": "AMPHIMACER, a foot of three syllables, the middle one short and the others long, as in 'castitas' [n]\n",
  "AMPHIMICTIC": "relating to amphimixis [adj]\n",
  "AMPHIMIXES": "AMPHIMIXIS, interbreeding; intermixing of two individuals' genetic matter [n]\n",
  "AMPHIMIXIS": "interbreeding; intermixing of two individuals' genetic matter [n AMPHIMIXES]\n",
  "AMPHIOXI": "AMPHIOXUS, (Greek) a fishlike creature, two or three inches long, found in temperate seas, aka lancelet [n]\n",
  "AMPHIOXUS": "(Greek) a fishlike creature, two or three inches long, found in temperate seas, aka lancelet [n AMPHIOXI or AMPHIOXUSES]\n",
  "AMPHIOXUSES": "AMPHIOXUS, (Greek) a fishlike creature, two or three inches long, found in temperate seas, aka lancelet [n]\n",
  "AMPHIPATH": "of or relating to a molecule that possesses both hydrophobic and hydrophilic elements [adj]\n",
  "AMPHIPATHIC": "of an unsymmetrical molecular group of which one end is hydrophilic and the other end hydrophobic [adj]\n",
  "AMPHIPHILE": "a type of molecule that is amphiphilic, of or relating to a compound having a polar water-molecule attached to a water-soluble hydrocarbon chain [n -S]\n",
  "AMPHIPHILES": "AMPHIPHILE, a type of molecule that is amphiphilic, of or relating to a compound having a polar water-molecule attached to a water-soluble hydrocarbon chain [n]\n",
  "AMPHIPHILIC": "of or relating to a compound having a polar water-molecule attached to a water-soluble hydrocarbon chain [adj]\n",
  "AMPHIPLOID": "having at least one set of diploid chromosomes derived from each parent species [n -S]\n",
  "AMPHIPLOIDIES": "AMPHIPLOIDY, the state of being amphiploid, having at least one set of diploid chromosomes derived from each parent species [n]\n",
  "AMPHIPLOIDS": "AMPHIPLOID, having at least one set of diploid chromosomes derived from each parent species [n]\n",
  "AMPHIPLOIDY": "the state of being amphiploid, having at least one set of diploid chromosomes derived from each parent species [n AMPHIPLOIDIES]\n",
  "AMPHIPOD": "a crustacean of the order Amphipoda, that includes e.g. sand-hoppers [n -S]\n",
  "AMPHIPODOUS": "having both walking and swimming feet [adj]\n",
  "AMPHIPODS": "AMPHIPOD, a crustacean of the order Amphipoda, that includes e.g. sand-hoppers [n]\n",
  "AMPHIPROSTYLAR": "of or like an amphiprostyle [adj]\n",
  "AMPHIPROSTYLE": "with columns at each end but not at sides [adj] / a building with columns at each end but not at the sides [n -S]\n",
  "AMPHIPROSTYLES": "AMPHIPROSTYLE, a building with columns at each end but not at the sides [n]\n",
  "AMPHIPROTIC": "having both protophilic (basic) and protogenic (acidic) properties [adj]\n",
  "AMPHISBAENA": "a worm-lizard; also, a mythical two-headed serpent or lizard [n AMPHISBAENAE or AMPHISBAENAS]\n",
  "AMPHISBAENAE": "AMPHISBAENA, a worm-lizard; also, a mythical two-headed serpent or lizard [n]\n",
  "AMPHISBAENAS": "AMPHISBAENA, a worm-lizard; also, a mythical two-headed serpent or lizard [n]\n",
  "AMPHISBAENIC": "of or like an amphisbaena [adj]\n",
  "AMPHISCIAN": "an inhabitant of the torrid zone, whose shadow is thrown both ways [n -S]\n",
  "AMPHISCIANS": "AMPHISCIAN, an inhabitant of the torrid zone, whose shadow is thrown both ways [n]\n",
  "AMPHISTOMATAL": "of a leaf, having stomata on both surfaces, also AMPHISTOMATIC [adj]\n",
  "AMPHISTOMATIC": "of a leaf, having stomata on both surfaces, also AMPHISTOMATAL [adj]\n",
  "AMPHISTOMOUS": "having a sucker at either end, as some worms [adj]\n",
  "AMPHISTYLAR": "of a classical temple, having a set of columns at both ends or at both sides [adj] / a temple having a set of columns at both ends or at both sides [n -S]\n",
  "AMPHISTYLARS": "AMPHISTYLAR, a temple having a set of columns at both ends or at both sides [n]\n",
  "AMPHITHEATER": "an oval or circular building with rising tiers of seats ranged about an open space [n -S]\n",
  "AMPHITHEATERS": "AMPHITHEATER, an oval or circular building with rising tiers of seats ranged about an open space [n]\n",
  "AMPHITHEATRAL": "of or like an amphitheatre [adj]\n",
  "AMPHITHEATRE": "an oval or circular building with rising tiers of seats ranged about an open space [n -S]\n",
  "AMPHITHEATRES": "AMPHITHEATRE, an oval or circular building with rising tiers of seats ranged about an open space [n]\n",
  "AMPHITHEATRIC": "relating to an amphitheater, also AMPHITHEATRICAL [adj]\n",
  "AMPHITHEATRICAL": "relating to an amphitheater, also AMPHITHEATRIC [adj]\n",
  "AMPHITHECIA": "AMPHITHECIUM, the outer layer of cells of the embryo of mosses and liverworts that develops into the outer parts of the spore-bearing capsule [n]\n",
  "AMPHITHECIUM": "the outer layer of cells of the embryo of mosses and liverworts that develops into the outer parts of the spore-bearing capsule [n AMPHITHECIA]\n",
  "AMPHITRICHA": "bacteria that have flagella at both ends [n]\n",
  "AMPHITRICHOUS": "of or like amphitricha, bacteria that have flagella at both ends [adj]\n",
  "AMPHITROPOUS": "of an ovule, with its point of attachment in the middle [adj]\n",
  "AMPHOLYTE": "an amphoteric electrolyte [n -S]\n",
  "AMPHOLYTES": "AMPHOLYTE, an amphoteric electrolyte [n]\n",
  "AMPHORA": "(Latin) a two-handled jar [n AMPHORAS or AMPHORAE]\n",
  "AMPHORAE": "AMPHORA, (Latin) a two-handled jar [n]\n",
  "AMPHORAL": "relating to an amphora [adj]\n",
  "AMPHORAS": "AMPHORA, (Latin) a two-handled jar [n]\n",
  "AMPHORIC": "pertaining to the sound of blowing into a bottle [adj]\n",
  "AMPHOTERIC": "in chemistry, reacting as either alkali or acid [adj]\n",
  "AMPICILLIN": "an improved form of penicillin taken by mouth [n -S]\n",
  "AMPICILLINS": "AMPICILLIN, an improved form of penicillin taken by mouth [n]\n",
  "AMPING": "AMP, (Australian slang) to excite [v]\n",
  "AMPLE": "plentiful [adj AMPLER, AMPLEST, AMPLY]\n",
  "AMPLENESS": "the state of being ample [n -ES]\n",
  "AMPLENESSES": "AMPLENESS, the state of being ample [n]\n",
  "AMPLER": "AMPLE, plentiful [adj]\n",
  "AMPLEST": "AMPLE, plentiful [adj]\n",
  "AMPLEXICAUL": "stem-clasping [adj]\n",
  "AMPLEXUS": "(Latin) the mating embrace of frogs [n -ES]\n",
  "AMPLEXUSES": "AMPLEXUS, (Latin) the mating embrace of frogs [n]\n",
  "AMPLIATION": "enlargement; amplification [n -S]\n",
  "AMPLIATIONS": "AMPLIATION, enlargement; amplification [n]\n",
  "AMPLIATIVE": "amplifying (now chiefly in ampliative induction) [adj]\n",
  "AMPLIDYNE": "a type of direct-current generator [n -S]\n",
  "AMPLIDYNES": "AMPLIDYNE, a type of direct-current generator [n]\n",
  "AMPLIFIABLE": "that can be amplified [adj]\n",
  "AMPLIFICATION": "an act, example, or product of amplifying [n -S]\n",
  "AMPLIFICATIONS": "AMPLIFICATION, an act, example, or product of amplifying [n]\n",
  "AMPLIFIED": "AMPLIFY, to make larger or more powerful [v]\n",
  "AMPLIFIER": "a device for making sound louder [n -S]\n",
  "AMPLIFIERS": "AMPLIFIER, a device for making sound louder [n]\n",
  "AMPLIFIES": "AMPLIFY, to make larger or more powerful [v]\n",
  "AMPLIFY": "to make larger or more powerful [v AMPLIFIED, AMPLIFYING, AMPLIFIES]\n",
  "AMPLIFYING": "AMPLIFY, to make larger or more powerful [v]\n",
  "AMPLITUDE": "largeness, abundance [n -S]\n",
  "AMPLITUDES": "AMPLITUDE, largeness, abundance [n]\n",
  "AMPLOSOME": "the short or stocky type of human figure [n -S]\n",
  "AMPLOSOMES": "AMPLOSOME, the short or stocky type of human figure [n]\n",
  "AMPLY": "AMPLE, plentiful [adv]\n",
  "AMPOULE": "(French) a small sealed glass, also AMPUL, AMPULE [n -S]\n",
  "AMPOULES": "AMPOULE, (French) a small sealed glass, also AMPUL, AMPULE [n]\n",
  "AMPS": "AMP, (Australian slang) to excite [v]\n",
  "AMPUL": "a small sealed glass, also AMPOULE, AMPULE [n -S]\n",
  "AMPULE": "(French) a small sealed glass, also AMPOULE, AMPUL [n -S]\n",
  "AMPULES": "AMPULE, (French) a small sealed glass, also AMPOULE, AMPUL [n]\n",
  "AMPULLA": "(Latin) a small two-handled ancient Roman flask [n AMPULLAE]\n",
  "AMPULLACEAL": "resembling an ampulla, also AMPULLACEOUS [adj]\n",
  "AMPULLACEOUS": "of or like an ampulla, also AMPULLACEAL [adj]\n",
  "AMPULLAE": "AMPULLA, (Latin) a small two-handled ancient Roman flask [n]\n",
  "AMPULLAR": "resembling an ampulla, also AMPULLARY [adj]\n",
  "AMPULLARY": "resembling an ampulla, also AMPULLAR [adj]\n",
  "AMPULLOSITIES": "AMPULLOSITY, (Browning) turgidity, bombast [n]\n",
  "AMPULLOSITY": "(Browning) turgidity, bombast [n AMPULLOSITIES]\n",
  "AMPULS": "AMPUL, a small sealed glass, also AMPOULE, AMPULE [n]\n",
  "AMPUTATE": "to cut off [v AMPUTATED, AMPUTATING, AMPUTATES]\n",
  "AMPUTATED": "AMPUTATE, to cut off [v]\n",
  "AMPUTATES": "AMPUTATE, to cut off [v]\n",
  "AMPUTATING": "AMPUTATE, to cut off [v]\n",
  "AMPUTATION": "the act of amputating [n -S]\n",
  "AMPUTATIONS": "AMPUTATION, the act of amputating [n]\n",
  "AMPUTATOR": "one who amputates [n -S]\n",
  "AMPUTATORS": "AMPUTATOR, one who amputates [n]\n",
  "AMPUTEE": "one who has had a limb amputated [n -S]\n",
  "AMPUTEES": "AMPUTEE, one who has had a limb amputated [n]\n",
  "AMREETA": "(Sanskrit) a drink which bestows immortality in Hindu mythology, also AMRIT, AMRITA [n -S]\n",
  "AMREETAS": "AMREETA, (Sanskrit) a drink which bestows immortality in Hindu mythology, also AMRIT, AMRITA [n]\n",
  "AMRIT": "(Punjabi) a sacred sweetened water used in the Sikh baptismal ceremony, also AMREETA, AMRITA [n -S]\n",
  "AMRITA": "(Sanskrit) a beverage that bestows immortality in Hindu mythology, also AMRIT, AMREETA [n -S]\n",
  "AMRITAS": "AMRITA, (Sanskrit) a beverage that bestows immortality in Hindu mythology, also AMRIT, AMREETA [n]\n",
  "AMRITATTVA": "(Sanskrit) immortality [n -S]\n",
  "AMRITATTVAS": "AMRITATTVA, (Sanskrit) immortality [n]\n",
  "AMRITS": "AMRIT, (Punjabi) a sacred sweetened water used in the Sikh baptismal ceremony, also AMREETA, AMRITA [n]\n",
  "AMSINCKIA": "a Californian herb, aka fiddleneck [n -S]\n",
  "AMSINCKIAS": "AMSINCKIA, a Californian herb, aka fiddleneck [n]\n",
  "AMTMAN": "(German) in Germany, Switzerland, the Netherlands and Scandinavia, a district magistrate, also AMMAN [n -S]\n",
  "AMTMANS": "AMTMAN, (German) in Germany, Switzerland, the Netherlands and Scandinavia, a district magistrate, also AMMAN [n]\n",
  "AMTRAC": "an amphibious military vehicle, also AMTRACK [n -S]\n",
  "AMTRACK": "a military vehicle equipped to move on land and water, also AMTRAC, AMTRAK [n -S]\n",
  "AMTRACKS": "AMTRACK, a military vehicle equipped to move on land and water, also AMTRAC, AMTRAK [n]\n",
  "AMTRACS": "AMTRAC, an amphibious military vehicle, also AMTRACK [n]\n",
  "AMTRAK": "a military vehicle equipped to move on land and water, also AMTRAC, AMTRACK [n -S]\n",
  "AMTRAKS": "AMTRAK, a military vehicle equipped to move on land and water, also AMTRAC, AMTRACK [n]\n",
  "AMU": "a unit of mass [n -S]\n",
  "AMUCK": "(Malay) a murderous frenzy, also AMOK [n -S]\n",
  "AMUCKS": "AMUCK, (Malay) a murderous frenzy, also AMOK [n]\n",
  "AMULET": "(Latin) a charm worn to ward off evil, disease, etc [n -S]\n",
  "AMULETIC": "of amulets [adj]\n",
  "AMULETS": "AMULET, (Latin) a charm worn to ward off evil, disease, etc [n]\n",
  "AMUS": "AMU, a unit of mass [n]\n",
  "AMUSABLE": "able to be amused [adj]\n",
  "AMUSE": "to entertain [v AMUSED, AMUSING, AMUSES]\n",
  "AMUSEABLE": "capable of being amused, also AMUSABLE [adj]\n",
  "AMUSED": "AMUSE, to entertain [v]\n",
  "AMUSEDLY": "AMUSED, AMUSE, to entertain [adv]\n",
  "AMUSEMENT": "a recreation, pastime [n -S]\n",
  "AMUSEMENTS": "AMUSEMENT, a recreation, pastime [n]\n",
  "AMUSER": "one who amuses [n -S]\n",
  "AMUSERS": "AMUSER, one who amuses [n]\n",
  "AMUSES": "AMUSE, to entertain [v]\n",
  "AMUSETTE": "(French) a light field cannon, or stocked gun mounted on a swivel [n -S]\n",
  "AMUSETTES": "AMUSETTE, (French) a light field cannon, or stocked gun mounted on a swivel [n]\n",
  "AMUSIA": "the inability to recognize musical sounds [n -S]\n",
  "AMUSIAS": "AMUSIA, the inability to recognize musical sounds [n]\n",
  "AMUSIC": "suffering from amusia, the inability to distinguish differences in musical pitch [adj]\n",
  "AMUSING": "AMUSE, to entertain [v]\n",
  "AMUSINGLY": "AMUSING, AMUSE, to entertain [adv]\n",
  "AMUSINGNESS": "the state of being amusing [n -ES]\n",
  "AMUSINGNESSES": "AMUSINGNESS, the state of being amusing [n]\n",
  "AMUSIVE": "amusing [adj]\n",
  "AMUSIVENESS": "the state of being amusive [n -ES]\n",
  "AMUSIVENESSES": "AMUSIVENESS, the state of being amusive [n]\n",
  "AMYGDAL": "(obsolete) an almond [n -S]\n",
  "AMYGDALA": "(Latin) any almond-shaped formation in body, e.g. the tonsil [n AMYGDALAE]\n",
  "AMYGDALACEOUS": "related to the almond, also AMYGDALATE [adj]\n",
  "AMYGDALAE": "AMYGDALA, (Latin) any almond-shaped formation in body, e.g. the tonsil [n]\n",
  "AMYGDALATE": "related to the almond, also AMYGDALACEOUS [adj]\n",
  "AMYGDALE": "a small gas bubble in lava, also AMYGDULE [n -S]\n",
  "AMYGDALES": "AMYGDALE, a small gas bubble in lava, also AMYGDULE [n]\n",
  "AMYGDALIN": "a glucoside in bitter almonds, used as an expectorant [n -S]\n",
  "AMYGDALINE": "relating to tonsils [adj]\n",
  "AMYGDALINS": "AMYGDALIN, a glucoside in bitter almonds, used as an expectorant [n]\n",
  "AMYGDALOID": "an igneous rock in which almond-shaped steam-cavities have been filled with minerals [n -S]\n",
  "AMYGDALOIDAL": "having amygdules [adj]\n",
  "AMYGDALOIDS": "AMYGDALOID, an igneous rock in which almond-shaped steam-cavities have been filled with minerals [n]\n",
  "AMYGDALS": "AMYGDAL, (obsolete) an almond [n]\n",
  "AMYGDULE": "a small gas bubble in lava, also AMYGDALE [n -S]\n",
  "AMYGDULES": "AMYGDULE, a small gas bubble in lava, also AMYGDALE [n]\n",
  "AMYL": "an alcohol radical, also PENTYL [n -S]\n",
  "AMYLACEOUS": "pertaining to starch [adj]\n",
  "AMYLASE": "any of the enzymes that play a part in the hydrolysis of starch and other substances [n -S]\n",
  "AMYLASES": "AMYLASE, any of the enzymes that play a part in the hydrolysis of starch and other substances [n]\n",
  "AMYLENE": "an unsaturated hydrocarbon of the olefine series, aka pentene [n -S]\n",
  "AMYLENES": "AMYLENE, an unsaturated hydrocarbon of the olefine series, aka pentene [n]\n",
  "AMYLIC": "pertaining to, or derived from, amyl; as, amylic ether [adj]\n",
  "AMYLOBARBITONE": "a white crystalline powder used as a sedative, aka amobarbital [n -S]\n",
  "AMYLOBARBITONES": "AMYLOBARBITONE, a white crystalline powder used as a sedative, aka amobarbital [n]\n",
  "AMYLOGEN": "the relatively soluble component of starch, also AMYLOSE [n -S]\n",
  "AMYLOGENS": "AMYLOGEN, the relatively soluble component of starch, also AMYLOSE [n]\n",
  "AMYLOID": "containing or relating to starch [adj] / a substance containing starch [n -S]\n",
  "AMYLOIDAL": "resembling or containing starch [adj]\n",
  "AMYLOIDOSES": "AMYLOIDOSIS, the condition of the body in which amyloid is deposited in the tissues [n]\n",
  "AMYLOIDOSIS": "the condition of the body in which amyloid is deposited in the tissues [n AMYLOIDOSES]\n",
  "AMYLOIDS": "AMYLOID, a substance containing starch [n]\n",
  "AMYLOLYSES": "AMYLOLYSIS, the conversion of starch into sugar [n]\n",
  "AMYLOLYSIS": "the conversion of starch into sugar [n AMYLOLYSES]\n",
  "AMYLOLYTIC": "characterised by the enzymatic splitting of starch into soluble products [adj]\n",
  "AMYLOPECTIN": "the major component of starch, consisting of branched polysaccharide chains [n -S]\n",
  "AMYLOPECTINS": "AMYLOPECTIN, the major component of starch, consisting of branched polysaccharide chains [n]\n",
  "AMYLOPLAST": "a colourless plastid that forms and stores starch [n -S]\n",
  "AMYLOPLASTS": "AMYLOPLAST, a colourless plastid that forms and stores starch [n]\n",
  "AMYLOPSIN": "an enzyme in pancreatic juice [n -S]\n",
  "AMYLOPSINS": "AMYLOPSIN, an enzyme in pancreatic juice [n]\n",
  "AMYLOSE": "the relatively soluble component of starch, also AMYLOGEN [n -S]\n",
  "AMYLOSES": "AMYLOSE, the relatively soluble component of starch, also AMYLOGEN [n]\n",
  "AMYLS": "AMYL, an alcohol radical, also PENTYL [n]\n",
  "AMYLUM": "starch [n -S]\n",
  "AMYLUMS": "AMYLUM, starch [n]\n",
  "AMYOTONIA": "deficiency of muscle tone [n -S]\n",
  "AMYOTONIAS": "AMYOTONIA, deficiency of muscle tone [n]\n",
  "AMYOTROPHIC": "relating to amyotrophy, atrophy of the muscles [adj]\n",
  "AMYOTROPHIES": "AMYOTROPHY, atrophy of the muscles [n]\n",
  "AMYOTROPHY": "atrophy of the muscles [n AMYOTROPHIES]\n",
  "AMYTAL": "as in sodium amytal, another name for Amytal, a barbiturate, used as a sedative and hypnotic [n -S]\n",
  "AMYTALS": "AMYTAL, as in sodium amytal, another name for Amytal, a barbiturate, used as a sedative and hypnotic [n]\n",
  "AN": "the indefinite article [adj] / a dialect form of if, an additional consideration, as in ifs and ans [n -S]\n",
  "ANA": "a collection of someone's table-talk [n -S]\n",
  "ANABAENA": "(Greek) a kind of freshwater alga [n -S]\n",
  "ANABAENAS": "ANABAENA, (Greek) a kind of freshwater alga [n]\n",
  "ANABANTID": "any of various spiny-finned fishes of the family Anabantidae [n -S]\n",
  "ANABANTIDS": "ANABANTID, any of various spiny-finned fishes of the family Anabantidae [n]\n",
  "ANABAPTISE": "to rebaptise, also ANABAPTIZE [v ANABAPTISED, ANABAPTISING, ANABAPTISES]\n",
  "ANABAPTISED": "ANABAPTISE, to rebaptise, also ANABAPTIZE [v]\n",
  "ANABAPTISES": "ANABAPTISE, to rebaptise, also ANABAPTIZE [v]\n",
  "ANABAPTISING": "ANABAPTISE, to rebaptise, also ANABAPTIZE [v]\n",
  "ANABAPTISM": "the doctrine of the Anabaptists [n -S]\n",
  "ANABAPTISMS": "ANABAPTISM, the doctrine of the Anabaptists [n]\n",
  "ANABAPTIST": "a name sometimes applied to a member of any sect holding that rebaptism is necessary for those baptized in infancy [n -S]\n",
  "ANABAPTISTIC": "relating to anabaptism [adj]\n",
  "ANABAPTISTS": "ANABAPTIST, a name sometimes applied to a member of any sect holding that rebaptism is necessary for those baptized in infancy [n]\n",
  "ANABAPTIZE": "to rebaptize, also ANABAPTISE [v ANABAPTIZED, ANABAPTIZING, ANABAPTIZES]\n",
  "ANABAPTIZED": "ANABAPTIZE, to rebaptize, also ANABAPTISE [v]\n",
  "ANABAPTIZES": "ANABAPTIZE, to rebaptize, also ANABAPTISE [v]\n",
  "ANABAPTIZING": "ANABAPTIZE, to rebaptize, also ANABAPTISE [v]\n",
  "ANABAS": "(Greek) a genus of fishes, remarkable for their power of living long out of water [n -ES]\n",
  "ANABASES": "ANABASIS, (Greek) an expedition or an advance, esp. a military one; also, a difficult or dangerous retreat [n]\n",
  "ANABASIS": "(Greek) an expedition or an advance, esp. a military one; also, a difficult or dangerous retreat [n ANABASES]\n",
  "ANABATIC": "upward-moving [adj]\n",
  "ANABIOSES": "ANABIOSIS, a return to life after apparent death [n]\n",
  "ANABIOSIS": "a return to life after apparent death [n ANABIOSES]\n",
  "ANABIOTIC": "relating to anabiosis, return to life after apparent death [adj]\n",
  "ANABLEPS": "(Greek) any of a genus of bony fishes with open air-bladders and projecting eyes divided in two for vision in air and water [n -ES]\n",
  "ANABLEPSES": "ANABLEPS, (Greek) any of a genus of bony fishes with open air-bladders and projecting eyes divided in two for vision in air and water [n]\n",
  "ANABOLIC": "pertaining to a process of food being built up into protoplasm [adj]\n",
  "ANABOLISM": "the constructive metabolism of the body, as distinguished from katabolism [n -S]\n",
  "ANABOLISMS": "ANABOLISM, the constructive metabolism of the body, as distinguished from katabolism [n]\n",
  "ANABOLITE": "a product of anabolism, the constructive metabolism of the body, as distinguished from katabolism [n -S]\n",
  "ANABOLITES": "ANABOLITE, a product of anabolism, the constructive metabolism of the body, as distinguished from katabolism [n]\n",
  "ANABOLITIC": "relating to an anabolite, a product of anabolism [adj]\n",
  "ANABRANCH": "a stream that leaves a river and reenters lower down [n -ES]\n",
  "ANABRANCHES": "ANABRANCH, a stream that leaves a river and reenters lower down [n]\n",
  "ANACARDIACEOUS": "belonging to the Anacardiaceae, the cashew-nut family [adj]\n",
  "ANACARDIUM": "a genus of plants including the cashew tree [n -S]\n",
  "ANACARDIUMS": "ANACARDIUM, a genus of plants including the cashew tree [n]\n",
  "ANACATHARSES": "ANACATHARSIS, vomiting [n]\n",
  "ANACATHARSIS": "vomiting [n ANACATHARSES]\n",
  "ANACATHARTIC": "a drug causing vomiting or expectoration [n -S]\n",
  "ANACATHARTICS": "ANACATHARTIC, a drug causing vomiting or expectoration [n]\n",
  "ANACHARIS": "a freshwater weed of the frogbit family, native to America [n -ES]\n",
  "ANACHARISES": "ANACHARIS, a freshwater weed of the frogbit family, native to America [n]\n",
  "ANACHORISM": "a geographical misplacement; something located in an incongruous position [n -S]\n",
  "ANACHORISMS": "ANACHORISM, a geographical misplacement; something located in an incongruous position [n]\n",
  "ANACHRONIC": "out of (chronological) order; out of date, also ANACHRONICAL [adj ANACHRONICALLY]\n",
  "ANACHRONICAL": "out of (chronological) order; out of date, also ANACHRONIC [adj ANACHRONICALLY]\n",
  "ANACHRONICALLY": "ANACHRONICAL, out of (chronological) order; out of date, also ANACHRONIC [adv]\n",
  "ANACHRONISM": "the error of placing a person, object, custom, or event in the wrong historical period [n -S]\n",
  "ANACHRONISMS": "ANACHRONISM, the error of placing a person, object, custom, or event in the wrong historical period [n]\n",
  "ANACHRONISTIC": "relating to anachronism [adj]\n",
  "ANACHRONOUS": "relating to anachronism [adj ANACHRONOUSLY]\n",
  "ANACHRONOUSLY": "ANACHRONOUS, relating to anachronism [adv]\n",
  "ANACLASTIC": "refractive; of or pertaining to refraction [adj]\n",
  "ANACLINAL": "of valleys, progressing in a direction opposite to the dip of the surrounding rock strata [adj]\n",
  "ANACLISES": "ANACLISIS, the state of being anaclitic, characterised by strong emotional dependence on others [n]\n",
  "ANACLISIS": "the state of being anaclitic, characterised by strong emotional dependence on others [n ANACLISES]\n",
  "ANACLITIC": "characterised by anaclisis, strong emotional dependence on others [adj]\n",
  "ANACOLUTHA": "ANACOLUTHON, a sentence or construction lacking grammatical sequence [n]\n",
  "ANACOLUTHIA": "a nonsequential syntactic construction in which the latter part of a sentence does not grammatically fit the earlier [n -S]\n",
  "ANACOLUTHIAS": "ANACOLUTHIA, a nonsequential syntactic construction in which the latter part of a sentence does not grammatically fit the earlier [n]\n",
  "ANACOLUTHIC": "relating to anacoluthia [adj ANACOLUTHICALLY]\n",
  "ANACOLUTHICALLY": "ANACOLUTHIC, relating to anacoluthia [adv]\n",
  "ANACOLUTHON": "a sentence or construction lacking grammatical sequence [n ANACOLUTHA or ANACOLUTHONS]\n",
  "ANACOLUTHONS": "ANACOLUTHON, a sentence or construction lacking grammatical sequence [n]\n",
  "ANACONDA": "(Sinhalese) a large S American snake [n -S]\n",
  "ANACONDAS": "ANACONDA, (Sinhalese) a large S American snake [n]\n",
  "ANACOUSTIC": "unable to support the propagation of sound; soundless [adj]\n",
  "ANACREONTIC": "a drinking song or light lyric [n -S]\n",
  "ANACREONTICALLY": "in the manner of a drinking song [adv]\n",
  "ANACREONTICS": "ANACREONTIC, a drinking song or light lyric [n]\n",
  "ANACRUSES": "ANACRUSIS, (Greek) one or more unstressed notes immediately preceding the first bar line [n]\n",
  "ANACRUSIS": "(Greek) one or more unstressed notes immediately preceding the first bar line [n ANACRUSES]\n",
  "ANACRUSTIC": "relating to anacrusis [adj]\n",
  "ANADEM": "a wreath for the head [n -S]\n",
  "ANADEMS": "ANADEM, a wreath for the head [n]\n",
  "ANADIPLOSES": "ANADIPLOSIS, the beginning of a sentence, line, or clause with the concluding, or any prominent, word of the one preceding [n]\n",
  "ANADIPLOSIS": "the beginning of a sentence, line, or clause with the concluding, or any prominent, word of the one preceding [n ANADIPLOSES]\n",
  "ANADROMOUS": "of fish, migrating up rivers from the sea to spawn in fresh water [adj]\n",
  "ANADYOMENE": "coming up or emerging, esp. of Aphrodite from the sea [adj]\n",
  "ANAEMIA": "a disorder of the blood, also ANEMIA [n -S]\n",
  "ANAEMIAS": "ANAEMIA, a disorder of the blood, also ANEMIA [n]\n",
  "ANAEMIC": "suffering from anaemia, also ANEMIC [adj ANAEMICALLY]\n",
  "ANAEMICALLY": "ANAEMIC, suffering from anaemia, also ANEMIC [adv]\n",
  "ANAEROBE": "an organism that lives in absence of free oxygen [n -S]\n",
  "ANAEROBES": "ANAEROBE, an organism that lives in absence of free oxygen [n]\n",
  "ANAEROBIA": "ANAEROBIUM, an organism not requiring oxygen for its life processes, also ANAEROBE, ANAEROBIONT [n]\n",
  "ANAEROBIC": "living in the absence of free oxygen, also ANAEROBIOTIC [adj ANAEROBICALLY]\n",
  "ANAEROBICALLY": "ANAEROBIC, living in the absence of free oxygen, also ANAEROBIOTIC [adv]\n",
  "ANAEROBIONT": "an organism not requiring oxygen for its life processes, also ANAEROBE, ANAEROBIUM [n -S]\n",
  "ANAEROBIONTS": "ANAEROBIONT, an organism not requiring oxygen for its life processes, also ANAEROBE, ANAEROBIUM [n]\n",
  "ANAEROBIOSES": "ANAEROBIOSIS, life in the absence of air or free oxygen [n]\n",
  "ANAEROBIOSIS": "life in the absence of air or free oxygen [n ANAEROBIOSES]\n",
  "ANAEROBIOTIC": "living in the absence of free oxygen, also ANAEROBIC [adj]\n",
  "ANAEROBIUM": "an organism not requiring oxygen for its life processes, also ANAEROBE, ANAEROBIONT [n ANAEROBIA]\n",
  "ANAESTHESES": "ANAESTHESIS, loss of feeling [n]\n",
  "ANAESTHESIA": "lack of sensation, also ANESTHESIA [n -S]\n",
  "ANAESTHESIAS": "ANAESTHESIA, lack of sensation, also ANESTHESIA [n]\n",
  "ANAESTHESIOLOGY": "a branch of medical science dealing with anesthetics, also ANESTHESIOLOGY [n]\n",
  "ANAESTHESIS": "loss of feeling [n ANAESTHESES]\n",
  "ANAESTHETIC": "taking away sensation, also ANESTHETIC [adj ANAESTHETICALLY] / a drug taking away sensation [n -S]\n",
  "ANAESTHETICALLY": "ANAESTHETIC, taking away sensation, also ANESTHETIC [adv]\n",
  "ANAESTHETICS": "ANAESTHETIC, a drug taking away sensation [n]\n",
  "ANAESTHETISE": "to subject to anaesthetic, also ANAESTHETIZE, ANESTHETISE, ANESTHETIZE [v ANAESTHETISED, ANAESTHETISING, ANAESTHETISES]\n",
  "ANAESTHETISED": "ANAESTHETISE, to subject to anaesthetic, also ANAESTHETIZE, ANESTHETISE, ANESTHETIZE [v]\n",
  "ANAESTHETISES": "ANAESTHETISE, to subject to anaesthetic, also ANAESTHETIZE, ANESTHETISE, ANESTHETIZE [v]\n",
  "ANAESTHETISING": "ANAESTHETISE, to subject to anaesthetic, also ANAESTHETIZE, ANESTHETISE, ANESTHETIZE [v]\n",
  "ANAESTHETIST": "one who delivers anaesthetics [n -S]\n",
  "ANAESTHETISTS": "ANAESTHETIST, one who delivers anaesthetics [n]\n",
  "ANAESTHETIZE": "to subject to anaesthetic, also ANAESTHETISE, ANESTHETISE, ANESTHETIZE [v ANAESTHETIZED, ANAESTHETIZING, ANAESTHETIZES]\n",
  "ANAESTHETIZED": "ANAESTHETIZE, to subject to anaesthetic, also ANAESTHETISE, ANESTHETISE, ANESTHETIZE [v]\n",
  "ANAESTHETIZES": "ANAESTHETIZE, to subject to anaesthetic, also ANAESTHETISE, ANESTHETISE, ANESTHETIZE [v]\n",
  "ANAESTHETIZING": "ANAESTHETIZE, to subject to anaesthetic, also ANAESTHETISE, ANESTHETISE, ANESTHETIZE [v]\n",
  "ANAGEN": "the growth phase in the hair growth cycle during which a newly formed hair continues to grow [n -S]\n",
  "ANAGENESES": "ANAGENESIS, so-called progressive ('upward') evolution [n]\n",
  "ANAGENESIS": "so-called progressive ('upward') evolution [n ANAGENESES]\n",
  "ANAGENS": "ANAGEN, the growth phase in the hair growth cycle during which a newly formed hair continues to grow [n]\n",
  "ANAGLYPH": "(Greek) a type of carved ornament [n -S]\n",
  "ANAGLYPHIC": "of or like an anaglyph, an ornament in low relief, also ANAGLYPHICAL [adj]\n",
  "ANAGLYPHICAL": "of or like an anaglyph, an ornament in low relief, also ANAGLYPHIC [adj]\n",
  "ANAGLYPHIES": "ANAGLYPHY, (Greek) the art of carving in low relief [n]\n",
  "ANAGLYPHS": "ANAGLYPH, (Greek) a type of carved ornament [n]\n",
  "ANAGLYPHY": "(Greek) the art of carving in low relief [n ANAGLYPHIES]\n",
  "ANAGLYPTIC": "relating to the art of carving, enchasing, or embossing in low relief [adj]\n",
  "ANAGLYPTICAL": "of or like an anaglyph, an ornament in low relief [adj]\n",
  "ANAGNORISES": "ANAGNORISIS, (Greek) the moment of recognition or discovery (in a play, etc.) [n]\n",
  "ANAGNORISIS": "(Greek) the moment of recognition or discovery (in a play, etc.) [n ANAGNORISES]\n",
  "ANAGOGE": "(Greek) a mystical interpretation, also ANAGOGY [n -S]\n",
  "ANAGOGES": "ANAGOGE, (Greek) a mystical interpretation, also ANAGOGY [n]\n",
  "ANAGOGIC": "relating to mystical interpretation, also ANAGOGICAL [adj ANAGOGICALLY]\n",
  "ANAGOGICAL": "relating to mystical interpretation, also ANAGOGIC [adj ANAGOGICALLY]\n",
  "ANAGOGICALLY": "ANAGOGICAL, relating to mystical interpretation, also ANAGOGIC [adv]\n",
  "ANAGOGIES": "ANAGOGY, a spiritual, mystical, or allegorical interpretation, also ANAGOGE [n]\n",
  "ANAGOGY": "a spiritual, mystical, or allegorical interpretation, also ANAGOGE [n ANAGOGIES]\n",
  "ANAGRAM": "a word or phrase formed by the letters of another in different order [n -S] / to transpose letters to form new words [v ANAGRAMMED, ANAGRAMMING, ANAGRAMS]\n",
  "ANAGRAMMATIC": "like an anagram, also ANAGRAMMATICAL [adj]\n",
  "ANAGRAMMATICAL": "like an anagram, also ANAGRAMMATIC [adj]\n",
  "ANAGRAMMATISE": "to make into an anagram, also ANAGRAMMATIZE [v ANAGRAMMATISED, ANAGRAMMATISING, ANAGRAMMATISES]\n",
  "ANAGRAMMATISED": "ANAGRAMMATISE, to make into an anagram, also ANAGRAMMATIZE [v]\n",
  "ANAGRAMMATISES": "ANAGRAMMATISE, to make into an anagram, also ANAGRAMMATIZE [v]\n",
  "ANAGRAMMATISING": "ANAGRAMMATISE, to make into an anagram, also ANAGRAMMATIZE [v]\n",
  "ANAGRAMMATISM": "the practice of constructing anagrams [n -S]\n",
  "ANAGRAMMATISMS": "ANAGRAMMATISM, the practice of constructing anagrams [n]\n",
  "ANAGRAMMATIST": "one who constructs anagrams [n -S]\n",
  "ANAGRAMMATISTS": "ANAGRAMMATIST, one who constructs anagrams [n]\n",
  "ANAGRAMMATIZE": "to make into an anagram, also ANAGRAMMATISE [v ANAGRAMMATIZED, ANAGRAMMATIZING, ANAGRAMMATIZES]\n",
  "ANAGRAMMATIZED": "ANAGRAMMATIZE, to make into an anagram, also ANAGRAMMATISE [v]\n",
  "ANAGRAMMATIZES": "ANAGRAMMATIZE, to make into an anagram, also ANAGRAMMATISE [v]\n",
  "ANAGRAMMATIZING": "ANAGRAMMATIZE, to make into an anagram, also ANAGRAMMATISE [v]\n",
  "ANAGRAMMED": "ANAGRAM, to transpose letters to form new words [v]\n",
  "ANAGRAMMER": "one who solves anagrams [n -S]\n",
  "ANAGRAMMERS": "ANAGRAMMER, one who solves anagrams [n]\n",
  "ANAGRAMMING": "ANAGRAM, to transpose letters to form new words [v]\n",
  "ANAGRAMS": "ANAGRAM, to transpose letters to form new words [v]\n",
  "ANAL": "pertaining to the anus [adj]\n",
  "ANALCIME": "a white or flesh-red mineral of the zeolite family, also ANALCITE [n -S]\n",
  "ANALCIMES": "ANALCIME, a white or flesh-red mineral of the zeolite family, also ANALCITE [n]\n",
  "ANALCIMIC": "of or like analcime, a mineral of the zeolite family [adj]\n",
  "ANALCITE": "a white or flesh-red mineral of the zeolite family, also ANALCIME [n -S]\n",
  "ANALCITES": "ANALCITE, a white or flesh-red mineral of the zeolite family, also ANALCIME [n]\n",
  "ANALECTA": "(Greek) collected literary fragments, also ANALECTS [n]\n",
  "ANALECTIC": "relating to analects; made up of selections; as, an analectic magazine [adj]\n",
  "ANALECTS": "collected literary fragments, also ANALECTA [n]\n",
  "ANALEMMA": "(Greek) the figure-8 on a map showing the sun's seasonal course [n ANALEMMAS or ANALEMMATA]\n",
  "ANALEMMAS": "ANALEMMA, (Greek) the figure-8 on a map showing the sun's seasonal course [n]\n",
  "ANALEMMATA": "ANALEMMA, (Greek) the figure-8 on a map showing the sun's seasonal course [n]\n",
  "ANALEMMATIC": "relating to the seasonal difference between time as shown by clocks and by the sun [adj]\n",
  "ANALEPTIC": "restoring vigour [adj] / a restorative medicine [n -S]\n",
  "ANALEPTICS": "ANALEPTIC, a restorative medicine [n]\n",
  "ANALGESIA": "the inability to feel pain, also ANALGIA [n -S]\n",
  "ANALGESIAS": "ANALGESIA, the inability to feel pain, also ANALGIA [n]\n",
  "ANALGESIC": "relieving pain [adj] / a substance relieving pain, also ANALGETIC [n -S]\n",
  "ANALGESICS": "ANALGESIC, a substance relieving pain, also ANALGETIC [n]\n",
  "ANALGETIC": "relieving pain [adj] / a substance relieving pain, also ANALGESIC [n -S]\n",
  "ANALGETICS": "ANALGETIC, a substance relieving pain, also ANALGESIC [n]\n",
  "ANALGIA": "inability to feel pain [n -S]\n",
  "ANALGIAS": "ANALGIA, inability to feel pain [n]\n",
  "ANALITIES": "ANALITY, a stage of infantile development thought to involve a preoccupation with the anus and defecation [n]\n",
  "ANALITY": "a stage of infantile development thought to involve a preoccupation with the anus and defecation [n ANALITIES]\n",
  "ANALLY": "at or through the anus [adv]\n",
  "ANALOG": "something that bears a resemblance to something else, also ANALOGUE [n -S]\n",
  "ANALOGA": "ANALOGON, (Greek) that which is analogous to, or corresponds with, some other thing, also ANALOG, ANALOGUE [n]\n",
  "ANALOGIC": "of or belonging to analogy, also ANALOGICAL [adj ANALOGICALLY]\n",
  "ANALOGICAL": "of or belonging to analogy, also ANALOGIC [adj ANALOGICALLY]\n",
  "ANALOGICALLY": "ANALOGICAL, of or belonging to analogy, also ANALOGIC [adv]\n",
  "ANALOGIES": "ANALOGY, a figure of speech involving a comparison [n]\n",
  "ANALOGISE": "to make an analogy [v ANALOGISED, ANALOGISING, ANALOGISES]\n",
  "ANALOGISED": "ANALOGISE, to make an analogy [v]\n",
  "ANALOGISES": "ANALOGISE, to make an analogy [v]\n",
  "ANALOGISING": "ANALOGISE, to make an analogy [v]\n",
  "ANALOGISM": "the act of analogizing [n -S]\n",
  "ANALOGISMS": "ANALOGISM, the act of analogizing [n]\n",
  "ANALOGIST": "one who reasons from analogy, or represents by analogy [n -S]\n",
  "ANALOGISTS": "ANALOGIST, one who reasons from analogy, or represents by analogy [n]\n",
  "ANALOGIZE": "to make an analogy, also ANALOGISE [v ANALOGIZED, ANALOGIZING, ANALOGIZES]\n",
  "ANALOGIZED": "ANALOGIZE, to make an analogy, also ANALOGISE [v]\n",
  "ANALOGIZES": "ANALOGIZE, to make an analogy, also ANALOGISE [v]\n",
  "ANALOGIZING": "ANALOGIZE, to make an analogy, also ANALOGISE [v]\n",
  "ANALOGON": "(Greek) that which is analogous to, or corresponds with, some other thing, also ANALOG, ANALOGUE [n ANALOGONS or ANALOGA]\n",
  "ANALOGONS": "ANALOGON, (Greek) that which is analogous to, or corresponds with, some other thing, also ANALOG, ANALOGUE [n]\n",
  "ANALOGOUS": "bearing some correspondence or resemblance [adj ANALOGOUSLY]\n",
  "ANALOGOUSLY": "ANALOGOUS, bearing some correspondence or resemblance [adv]\n",
  "ANALOGOUSNESS": "the state of being analogous [n -ES]\n",
  "ANALOGOUSNESSES": "ANALOGOUSNESS, the state of being analogous [n]\n",
  "ANALOGS": "ANALOG, something that bears a resemblance to something else, also ANALOGUE [n]\n",
  "ANALOGUE": "something that bears a resemblance to something else, also ANALOG [n -S]\n",
  "ANALOGUES": "ANALOGUE, something that bears a resemblance to something else, also ANALOG [n]\n",
  "ANALOGY": "a figure of speech involving a comparison [n ANALOGIES]\n",
  "ANALPHABET": "an illiterate; one who doesn't know the alphabet or the basics of something, also ANALPHABETE [n -S]\n",
  "ANALPHABETE": "an illiterate; one who doesn't know the alphabet or the basics of something, also ANALPHABET [n -S]\n",
  "ANALPHABETES": "ANALPHABETE, an illiterate; one who doesn't know the alphabet or the basics of something, also ANALPHABET [n]\n",
  "ANALPHABETIC": "one who is unable to read [n -S]\n",
  "ANALPHABETICS": "ANALPHABETIC, one who is unable to read [n]\n",
  "ANALPHABETISM": "illiteracy [n -S]\n",
  "ANALPHABETISMS": "ANALPHABETISM, illiteracy [n]\n",
  "ANALPHABETS": "ANALPHABET, an illiterate; one who doesn't know the alphabet or the basics of something, also ANALPHABETE [n]\n",
  "ANALYSABILITIES": "ANALYSABILITY, the capacity for being analysed [n]\n",
  "ANALYSABILITY": "the capacity for being analysed [n ANALYSABILITIES]\n",
  "ANALYSABLE": "capable of being analysed, also ANALYZABLE [adj]\n",
  "ANALYSAND": "a person undergoing psychoanalysis [n -S]\n",
  "ANALYSANDS": "ANALYSAND, a person undergoing psychoanalysis [n]\n",
  "ANALYSATION": "analysis, also ANALYZATION [n -S]\n",
  "ANALYSATIONS": "ANALYSATION, analysis, also ANALYZATION [n]\n",
  "ANALYSE": "to separate a whole into parts, also ANALYZE [v ANALYSED, ANALYSING, ANALYSES]\n",
  "ANALYSED": "ANALYSE, to separate a whole into parts, also ANALYZE [v]\n",
  "ANALYSER": "one who analyses [n -S]\n",
  "ANALYSERS": "ANALYSER, one who analyses [n]\n",
  "ANALYSES": "ANALYSIS, the separation of a whole into its parts [n]\n",
  "ANALYSING": "ANALYSE, to separate a whole into parts, also ANALYZE [v]\n",
  "ANALYSIS": "the separation of a whole into its parts [n ANALYSES]\n",
  "ANALYST": "someone skilled in analysis [n -S]\n",
  "ANALYSTS": "ANALYST, someone skilled in analysis [n]\n",
  "ANALYTE": "a substance being analyzed [n -S]\n",
  "ANALYTES": "ANALYTE, a substance being analyzed [n]\n",
  "ANALYTIC": "pertaining to analysis, also ANALYTICAL [adj ANALYTICALLY] / analytic logic [n -S]\n",
  "ANALYTICAL": "pertaining to analysis, also ANALYTIC [adj ANALYTICALLY]\n",
  "ANALYTICALLY": "ANALYTICAL, pertaining to analysis, also ANALYTIC [adv]\n",
  "ANALYTICITIES": "ANALYTICITY, the quality of being analytic [n]\n",
  "ANALYTICITY": "the quality of being analytic [n ANALYTICITIES]\n",
  "ANALYTICS": "ANALYTIC, analytic logic [n]\n",
  "ANALYZABILITIES": "ANALYZABILITY, the state of being analyzable, also ANALYSABILITY [n]\n",
  "ANALYZABILITY": "the state of being analyzable, also ANALYSABILITY [n ANALYZABILITIES]\n",
  "ANALYZABLE": "capable of being analysed, also ANALYSABLE [adj]\n",
  "ANALYZATION": "analysis, also ANALYSATION [n -S]\n",
  "ANALYZATIONS": "ANALYZATION, analysis, also ANALYSATION [n]\n",
  "ANALYZE": "to subject to analysis, also ANALYSE [v ANALYZED, ANALYZING, ANALYZES]\n",
  "ANALYZED": "ANALYZE, to subject to analysis, also ANALYSE [v]\n",
  "ANALYZER": "a person who analyses, also ANALYSER [n -S]\n",
  "ANALYZERS": "ANALYZER, a person who analyses, also ANALYSER [n]\n",
  "ANALYZES": "ANALYZE, to subject to analysis, also ANALYSE [v]\n",
  "ANALYZING": "ANALYZE, to subject to analysis, also ANALYSE [v]\n",
  "ANAMNESES": "ANAMNESIS, a recalling to mind; a preliminary case history of a medical or psychiatric patient [n]\n",
  "ANAMNESIS": "a recalling to mind; a preliminary case history of a medical or psychiatric patient [n ANAMNESES]\n",
  "ANAMNESTIC": "relating to anamnesis, a recalling to mind [adj ANAMNESTICALLY]\n",
  "ANAMNESTICALLY": "ANAMNESTIC, relating to anamnesis, a recalling to mind [adv]\n",
  "ANAMNIOTE": "any vertebrate animal, such as a fish or amphibian, that lacks an amnion [n -S]\n",
  "ANAMNIOTES": "ANAMNIOTE, any vertebrate animal, such as a fish or amphibian, that lacks an amnion [n]\n",
  "ANAMNIOTIC": "of or like an anamniote, any vertebrate animal, such as a fish or amphibian, that lacks an amnion [adj]\n",
  "ANAMORPHIC": "relating to anamorphosis, also ANAMORPHOUS [adj]\n",
  "ANAMORPHISM": "metamorphism of a rock in which complex minerals are formed from simpler ones [n -S]\n",
  "ANAMORPHISMS": "ANAMORPHISM, metamorphism of a rock in which complex minerals are formed from simpler ones [n]\n",
  "ANAMORPHOSCOPE": "an optical device, such as a cylindrical lens, for correcting an image that has been distorted by anamorphosis [n -S]\n",
  "ANAMORPHOSCOPES": "ANAMORPHOSCOPE, an optical device, such as a cylindrical lens, for correcting an image that has been distorted by anamorphosis [n]\n",
  "ANAMORPHOSES": "ANAMORPHOSIS, a distorted projection or drawing of anything, which appears normal when viewed from a particular point or by means of a suitable mirror [n]\n",
  "ANAMORPHOSIS": "a distorted projection or drawing of anything, which appears normal when viewed from a particular point or by means of a suitable mirror [n ANAMORPHOSES]\n",
  "ANAMORPHOUS": "relating to anamorphosis, also ANAMORPHIC [adj]\n",
  "ANAN": "(to a person calling for attention) in a moment! coming, also ANON [interj]\n",
  "ANANA": "(French) a pineapple, also ANANAS [n -S]\n",
  "ANANAS": "(French) a pineapple, also ANANA [n -ES]\n",
  "ANANASES": "ANANAS, (French) a pineapple, also ANANA [n]\n",
  "ANANDA": "(Sanskrit) extreme happiness [n -S]\n",
  "ANANDAMIDE": "a brain receptor that is released naturally from neurons and is thought to be associated with the pleasurable effect of certain drugs [n -S]\n",
  "ANANDAMIDES": "ANANDAMIDE, a brain receptor that is released naturally from neurons and is thought to be associated with the pleasurable effect of certain drugs [n]\n",
  "ANANDAS": "ANANDA, (Sanskrit) extreme happiness [n]\n",
  "ANANDROUS": "without stamens [adj]\n",
  "ANANKE": "(Greek) necessity, the power of fate [n -S]\n",
  "ANANKES": "ANANKE, (Greek) necessity, the power of fate [n]\n",
  "ANANTHOUS": "having no flowers [adj]\n",
  "ANAPAEST": "(Greek) a type of metrical foot, also ANAPEST [n -S]\n",
  "ANAPAESTIC": "in the form of an anapaest, two short metrical syllables followed by one long one [adj]\n",
  "ANAPAESTICAL": "in the form of an anapaest, two short metrical syllables followed by one long one [adj]\n",
  "ANAPAESTS": "ANAPAEST, (Greek) a type of metrical foot, also ANAPEST [n]\n",
  "ANAPEST": "(Greek) a type of metrical foot, also ANAPAEST [n -S]\n",
  "ANAPESTIC": "a verse in the form of an anapest, two short metrical syllables followed by one long one [n ANAPESTICS]\n",
  "ANAPESTICS": "ANAPESTIC, a verse in the form of an anapest, two short metrical syllables followed by one long one [n]\n",
  "ANAPESTS": "ANAPEST, (Greek) a type of metrical foot, also ANAPAEST [n]\n",
  "ANAPHASE": "the stage of meiosis in which daughter chromosomes move towards the nuclear spindle [n -S]\n",
  "ANAPHASES": "ANAPHASE, the stage of meiosis in which daughter chromosomes move towards the nuclear spindle [n]\n",
  "ANAPHASIC": "relating to the anaphase, the stage of meiosis in which daughter chromosomes move towards the nuclear spindle [adj]\n",
  "ANAPHOR": "the repetition of a word or expression at the beginning of successive phrases, clauses, sentences or verses esp. for rhetorical effect, also ANAPHORA, EPANAPHORA [n -S]\n",
  "ANAPHORA": "(Greek) the repetition of a word or expression at the beginning of successive phrases, clauses, sentences or verses esp. for rhetorical effect, also ANAPHOR, EPANAPHORA [n -S]\n",
  "ANAPHORAL": "of or like anaphora, repetition of a word or expression at the beginning of successive phrases etc., also ANAPHORIC, ANAPHORICAL [adj]\n",
  "ANAPHORAS": "ANAPHORA, (Greek) the repetition of a word or expression at the beginning of successive phrases, clauses, sentences or verses esp. for rhetorical effect, also ANAPHOR, EPANAPHORA [n]\n",
  "ANAPHORESES": "ANAPHORESIS, the movement of suspended charged particles towards the anode in an electric field [n]\n",
  "ANAPHORESIS": "the movement of suspended charged particles towards the anode in an electric field [n ANAPHORESES]\n",
  "ANAPHORIC": "referring to a preceding word or group of words, also ANAPHORAL, ANAPHORICAL [adj ANAPHORICALLY]\n",
  "ANAPHORICAL": "referring to a preceding word or group of words, also ANAPHORAL, ANAPHORIC [adj ANAPHORICALLY]\n",
  "ANAPHORICALLY": "ANAPHORICAL, referring to a preceding word or group of words, also ANAPHORAL, ANAPHORIC [adv]\n",
  "ANAPHORS": "ANAPHOR, the repetition of a word or expression at the beginning of successive phrases, clauses, sentences or verses esp. for rhetorical effect, also ANAPHORA, EPANAPHORA [n]\n",
  "ANAPHRODISIA": "lessening of sexual desire [n -S]\n",
  "ANAPHRODISIAC": "reducing sexual desire [adj] / a drug that reduces sexual desire [n -S]\n",
  "ANAPHRODISIACS": "ANAPHRODISIAC, a drug that reduces sexual desire [n]\n",
  "ANAPHRODISIAS": "ANAPHRODISIA, lessening of sexual desire [n]\n",
  "ANAPHYLACTIC": "of, relating to, affected by, or causing anaphylaxis [adj]\n",
  "ANAPHYLACTOID": "of, relating to, affected by, or causing anaphylaxis [adj]\n",
  "ANAPHYLAXES": "ANAPHYLAXIS, an increased susceptibility to injected foreign material, also ANAPHYLAXY [n]\n",
  "ANAPHYLAXIES": "ANAPHYLAXY, an increased susceptibility to injected foreign material, also ANAPHYLAXIS [n]\n",
  "ANAPHYLAXIS": "an increased susceptibility to injected foreign material, also ANAPHYLAXY [n ANAPHYLAXES]\n",
  "ANAPHYLAXY": "an increased susceptibility to injected foreign material, also ANAPHYLAXIS [n ANAPHYLAXIES]\n",
  "ANAPLASIA": "reversion of plant or animal cells to a simpler form [n -S]\n",
  "ANAPLASIAS": "ANAPLASIA, reversion of plant or animal cells to a simpler form [n]\n",
  "ANAPLASMOSES": "ANAPLASMOSIS, a tick-borne disease of cattle and sheep [n]\n",
  "ANAPLASMOSIS": "a tick-borne disease of cattle and sheep [n ANAPLASMOSES]\n",
  "ANAPLASTIC": "of or pertaining to anaplasty [adj]\n",
  "ANAPLASTIES": "ANAPLASTY, the art or operation of restoring lost parts or the normal shape by the use of healthy tissue [n]\n",
  "ANAPLASTY": "the art or operation of restoring lost parts or the normal shape by the use of healthy tissue [n ANAPLASTIES]\n",
  "ANAPLEROSES": "ANAPLEROSIS, the filling up of a deficiency [n]\n",
  "ANAPLEROSIS": "the filling up of a deficiency [n ANAPLEROSES]\n",
  "ANAPLEROTIC": "filling up a deficiency [adj]\n",
  "ANAPTYCTIC": "relating to anaptyxis, the insertion of a vowel between two consonants for ease of pronunciation, also ANAPTYCTICAL [adj]\n",
  "ANAPTYCTICAL": "relating to anaptyxis, the insertion of a vowel between two consonants for ease of pronunciation, also ANAPTYCTIC [adj]\n",
  "ANAPTYXES": "ANAPTYXIS, (Greek) the insertion of a vowel between two consonants for ease of pronunciation [n]\n",
  "ANAPTYXIS": "(Greek) the insertion of a vowel between two consonants for ease of pronunciation [n ANAPTYXES]\n",
  "ANARCH": "a promoter of lawlessness [n -S]\n",
  "ANARCHAL": "relating to anarchy, the complete absence of law or government, also ANARCHIAL, ANARCHIC, ANARCHICAL [adj]\n",
  "ANARCHIAL": "relating to anarchy, the complete absence of law or government, also ANARCHAL, ANARCHIC, ANARCHICAL [adj]\n",
  "ANARCHIC": "relating to anarchy, the complete absence of law or government, also ANARCHAL, ANARCHIAL, ANARCHICAL [adj ANARCHICALLY]\n",
  "ANARCHICAL": "relating to anarchy, the complete absence of law or government, also ANARCHAL, ANARCHIAL, ANARCHIC [adj ANARCHICALLY]\n",
  "ANARCHICALLY": "ANARCHICAL, relating to anarchy, the complete absence of law or government, also ANARCHAL, ANARCHIAL, ANARCHIC [adv]\n",
  "ANARCHIES": "ANARCHY, the absence of law or government [n]\n",
  "ANARCHISE": "to reduce to anarchy, also ANARCHIZE [v ANARCHISED, ANARCHISING, ANARCHISES]\n",
  "ANARCHISED": "ANARCHISE, to reduce to anarchy, also ANARCHIZE [v]\n",
  "ANARCHISES": "ANARCHISE, to reduce to anarchy, also ANARCHIZE [v]\n",
  "ANARCHISING": "ANARCHISE, to reduce to anarchy, also ANARCHIZE [v]\n",
  "ANARCHISM": "the doctrine or practice of anarchists [n -S]\n",
  "ANARCHISMS": "ANARCHISM, the doctrine or practice of anarchists [n]\n",
  "ANARCHIST": "one who advocates anarchy or aims at the overthrow of civil government [n -S]\n",
  "ANARCHISTIC": "of or pertaining to anarchy [adj ANARCHISTICALLY]\n",
  "ANARCHISTICALLY": "ANARCHISTIC, of or pertaining to anarchy [adv]\n",
  "ANARCHISTS": "ANARCHIST, one who advocates anarchy or aims at the overthrow of civil government [n]\n",
  "ANARCHIZE": "to reduce to anarchy, also ANARCHISE [v ANARCHIZED, ANARCHIZING, ANARCHIZES]\n",
  "ANARCHIZED": "ANARCHIZE, to reduce to anarchy, also ANARCHISE [v]\n",
  "ANARCHIZES": "ANARCHIZE, to reduce to anarchy, also ANARCHISE [v]\n",
  "ANARCHIZING": "ANARCHIZE, to reduce to anarchy, also ANARCHISE [v]\n",
  "ANARCHS": "ANARCH, a promoter of lawlessness [n]\n",
  "ANARCHY": "the absence of law or government [n ANARCHIES]\n",
  "ANARTHRIA": "loss of the ability to speak coherently [n -S]\n",
  "ANARTHRIAS": "ANARTHRIA, loss of the ability to speak coherently [n]\n",
  "ANARTHRIC": "relating to anarthria, loss of the ability to speak coherently [adj]\n",
  "ANARTHROUS": "without distinct joints [adj ANARTHROUSLY]\n",
  "ANARTHROUSLY": "ANARTHROUS, without distinct joints [adv]\n",
  "ANARTHROUSNESS": "the state of being anarthrous [n]\n",
  "ANAS": "ANA, a collection of someone's table-talk [n]\n",
  "ANASARCA": "(Greek) dropsy of the subcutaneous cellular tissue [n -S]\n",
  "ANASARCAS": "ANASARCA, (Greek) dropsy of the subcutaneous cellular tissue [n]\n",
  "ANASARCOUS": "belonging, or affected by, anasarca, or dropsy; dropsical [adj]\n",
  "ANASTASES": "ANASTASIS, (Greek) in Byzantine art, the Harrowing of Hell [n]\n",
  "ANASTASIS": "(Greek) in Byzantine art, the Harrowing of Hell [n ANASTASES]\n",
  "ANASTATIC": "pertaining to a process or a style of printing from characters in relief on zinc plates [adj]\n",
  "ANASTIGMAT": "a lens esp. designed to avoid the defect of stigmatism [n -S]\n",
  "ANASTIGMATIC": "free from astigmatism [adj]\n",
  "ANASTIGMATISM": "being free from astigmatism [n -S]\n",
  "ANASTIGMATISMS": "ANASTIGMATISM, being free from astigmatism [n]\n",
  "ANASTIGMATS": "ANASTIGMAT, a lens esp. designed to avoid the defect of stigmatism [n]\n",
  "ANASTOMOSE": "to inosculate; to intercommunicate by anastomosis, as the arteries and veins [v ANASTOMOSED, ANASTOMOSING, ANASTOMOSES]\n",
  "ANASTOMOSED": "ANASTOMOSE, to inosculate; to intercommunicate by anastomosis, as the arteries and veins [v]\n",
  "ANASTOMOSES": "ANASTOMOSE, to inosculate; to intercommunicate by anastomosis, as the arteries and veins [v]\n",
  "ANASTOMOSING": "ANASTOMOSE, to inosculate; to intercommunicate by anastomosis, as the arteries and veins [v]\n",
  "ANASTOMOSIS": "cross-communication of channels to form a network [n ANASTOMOSES]\n",
  "ANASTOMOTIC": "relating to anastomosis [adj]\n",
  "ANASTROPHE": "an inversion of the usual syntactical order of words for rhetorical effect e.g. 'To market went she' [n -S]\n",
  "ANASTROPHES": "ANASTROPHE, an inversion of the usual syntactical order of words for rhetorical effect e.g. 'To market went she' [n]\n",
  "ANASTROZOLE": "a drug used for the treatment of advanced breast carcinoma in postmenopausal women [n -S]\n",
  "ANASTROZOLES": "ANASTROZOLE, a drug used for the treatment of advanced breast carcinoma in postmenopausal women [n]\n",
  "ANATA": "(Sanskrit) the Buddhist belief in the impermanence of self, also ANATMAN [n -S]\n",
  "ANATAS": "ANATA, (Sanskrit) the Buddhist belief in the impermanence of self, also ANATMAN [n]\n",
  "ANATASE": "a mineral, titanium oxide [n -S]\n",
  "ANATASES": "ANATASE, a mineral, titanium oxide [n]\n",
  "ANATEXES": "ANATEXIS, the partial melting of rocks, esp. in the formation of metamorphic rocks [n]\n",
  "ANATEXIS": "the partial melting of rocks, esp. in the formation of metamorphic rocks [n ANATEXES]\n",
  "ANATHEMA": "(Greek) the formal act or formula of consigning to damnation [n ANATHEMAS or ANATHEMATA]\n",
  "ANATHEMAS": "ANATHEMA, (Greek) the formal act or formula of consigning to damnation [n]\n",
  "ANATHEMATA": "ANATHEMA, (Greek) the formal act or formula of consigning to damnation [n]\n",
  "ANATHEMATICAL": "an anathema, a formal act or formula of consigning to damnation [n -S]\n",
  "ANATHEMATICALS": "ANATHEMATICAL, an anathema, a formal act or formula of consigning to damnation [n]\n",
  "ANATHEMATISE": "to subject to anathema, pronounce a curse upon, also ANATHEMATIZE [v ANATHEMATISED, ANATHEMATISING, ANATHEMATISES]\n",
  "ANATHEMATISED": "ANATHEMATISE, to subject to anathema, pronounce a curse upon, also ANATHEMATIZE [v]\n",
  "ANATHEMATISES": "ANATHEMATISE, to subject to anathema, pronounce a curse upon, also ANATHEMATIZE [v]\n",
  "ANATHEMATISING": "ANATHEMATISE, to subject to anathema, pronounce a curse upon, also ANATHEMATIZE [v]\n",
  "ANATHEMATIZE": "to subject to anathema, pronounce a curse upon, also ANATHEMATISE [v ANATHEMATIZED, ANATHEMATIZING, ANATHEMATIZES]\n",
  "ANATHEMATIZED": "ANATHEMATIZE, to subject to anathema, pronounce a curse upon, also ANATHEMATISE [v]\n",
  "ANATHEMATIZES": "ANATHEMATIZE, to subject to anathema, pronounce a curse upon, also ANATHEMATISE [v]\n",
  "ANATHEMATIZING": "ANATHEMATIZE, to subject to anathema, pronounce a curse upon, also ANATHEMATISE [v]\n",
  "ANATMAN": "(Sanskrit) the Buddhist belief in the impermanence of self, also ANATA [n -S]\n",
  "ANATMANS": "ANATMAN, (Sanskrit) the Buddhist belief in the impermanence of self, also ANATA [n]\n",
  "ANATOMIC": "relating to anatomy, also ANATOMICAL [adj ANATOMICALLY]\n",
  "ANATOMICAL": "relating to anatomy, also ANATOMIC [adj ANATOMICALLY]\n",
  "ANATOMICALLY": "ANATOMICAL, relating to anatomy, also ANATOMIC [adv]\n",
  "ANATOMIES": "ANATOMY, the structure of an organism [n]\n",
  "ANATOMISATION": "the process of anatomising, also ANATOMIZATION [n -S]\n",
  "ANATOMISATIONS": "ANATOMISATION, the process of anatomising, also ANATOMIZATION [n]\n",
  "ANATOMISE": "to dissect, examine minutely, also ANATOMIZE [v ANATOMISED, ANATOMISING, ANATOMISES]\n",
  "ANATOMISED": "ANATOMISE, to dissect, examine minutely, also ANATOMIZE [v]\n",
  "ANATOMISER": "one who anatomises, also ANATOMIZER [n -S]\n",
  "ANATOMISERS": "ANATOMISER, one who anatomises, also ANATOMIZER [n]\n",
  "ANATOMISES": "ANATOMISE, to dissect, examine minutely, also ANATOMIZE [v]\n",
  "ANATOMISING": "ANATOMISE, to dissect, examine minutely, also ANATOMIZE [v]\n",
  "ANATOMIST": "one who practises anatomy [n -S]\n",
  "ANATOMISTS": "ANATOMIST, one who practises anatomy [n]\n",
  "ANATOMIZATION": "the process of anatomizing, also ANATOMISATION [n -S]\n",
  "ANATOMIZATIONS": "ANATOMIZATION, the process of anatomizing, also ANATOMISATION [n]\n",
  "ANATOMIZE": "to dissect, examine minutely, also ANATOMISE [v ANATOMIZED, ANATOMIZING, ANATOMIZES]\n",
  "ANATOMIZED": "ANATOMIZE, to dissect, examine minutely, also ANATOMISE [v]\n",
  "ANATOMIZER": "one who anatomises, also ANATOMISER [n -S]\n",
  "ANATOMIZERS": "ANATOMIZER, one who anatomises, also ANATOMISER [n]\n",
  "ANATOMIZES": "ANATOMIZE, to dissect, examine minutely, also ANATOMISE [v]\n",
  "ANATOMIZING": "ANATOMIZE, to dissect, examine minutely, also ANATOMISE [v]\n",
  "ANATOMY": "the structure of an organism [n ANATOMIES]\n",
  "ANATOXIN": "a potent alkaloid toxin derived from a species of cyanobacteria [n -S]\n",
  "ANATOXINS": "ANATOXIN, a potent alkaloid toxin derived from a species of cyanobacteria [n]\n",
  "ANATROPIES": "ANATROPY, the state of being anatropous, having the ovule inverted at an early period in its development [n]\n",
  "ANATROPOUS": "of an ovule, inverted so that the micropyle is next to the stalk [adj]\n",
  "ANATROPY": "the state of being anatropous, having the ovule inverted at an early period in its development [n ANATROPIES]\n",
  "ANATTA": "(Caribbean) a yellowish red dye, also ANATTO, ANNATTA, ANNATTO, ARNATTO, ARNOTTO [n -S]\n",
  "ANATTAS": "ANATTA, (Caribbean) a yellowish red dye, also ANATTO, ANNATTA, ANNATTO, ARNATTO, ARNOTTO [n]\n",
  "ANATTO": "(Caribbean) a yellowish red dye, also ANATTA, ANNATTA, ANNATTO [n -S]\n",
  "ANATTOS": "ANATTO, (Caribbean) a yellowish red dye, also ANATTA, ANNATTA, ANNATTO [n]\n",
  "ANAXIAL": "asymmetrical [adj]\n",
  "ANBURIES": "ANBURY, a soft fleshy tumour in horses; a disease of turnips and cabbages, also ANGLEBERRY [n]\n",
  "ANBURY": "a soft fleshy tumour in horses; a disease of turnips and cabbages, also ANGLEBERRY [n ANBURIES]\n",
  "ANCE": "(dialect) once, also YINCE [adv]\n",
  "ANCESTOR": "someone from whom a person is descended, a forefather [n -S] / to be an ancestor to [v -ED, -ING, -S]\n",
  "ANCESTORED": "ANCESTOR, to be an ancestor to [v]\n",
  "ANCESTORIAL": "relating to ancestors [adj]\n",
  "ANCESTORING": "ANCESTOR, to be an ancestor to [v]\n",
  "ANCESTORS": "ANCESTOR, to be an ancestor to [v]\n",
  "ANCESTRAL": "relating to ancestors [adj ANCESTRALLY] / a type of relation in logic [n -S]\n",
  "ANCESTRALLY": "ANCESTRAL, relating to ancestors [adv]\n",
  "ANCESTRALS": "ANCESTRAL, a type of relation in logic [n]\n",
  "ANCESTRESS": "a female ancestor [n -ES]\n",
  "ANCESTRESSES": "ANCESTRESS, a female ancestor [n]\n",
  "ANCESTRIES": "ANCESTRY, a line of ancestors [n]\n",
  "ANCESTRY": "a line of ancestors [n ANCESTRIES]\n",
  "ANCHO": "a type of dried chili pepper [n -S]\n",
  "ANCHOR": "a device for holding a floating vessel in place [n -S] / to secure by means of an anchor [v -ED, -ING, -S]\n",
  "ANCHORAGE": "a place where a ship can anchor [n -S]\n",
  "ANCHORAGES": "ANCHORAGE, a place where a ship can anchor [n]\n",
  "ANCHORED": "ANCHOR, to secure by means of an anchor [v]\n",
  "ANCHORESS": "a female anchorite, one who lives in seclusion, usually for religious reasons, also ANCRESS [n -ES]\n",
  "ANCHORESSES": "ANCHORESS, a female anchorite, one who lives in seclusion, usually for religious reasons, also ANCRESS [n]\n",
  "ANCHORET": "one who lives in seclusion, usually for religious reasons, also ANCHORITE [n -S]\n",
  "ANCHORETIC": "of or like an anchoret, also ANCHORETICAL [adj]\n",
  "ANCHORETICAL": "of or like an anchoret, also ANCHORETIC [adj]\n",
  "ANCHORETS": "ANCHORET, one who lives in seclusion, usually for religious reasons, also ANCHORITE [n]\n",
  "ANCHORETTE": "a young inexperienced anchorwoman [n -S]\n",
  "ANCHORETTES": "ANCHORETTE, a young inexperienced anchorwoman [n]\n",
  "ANCHORING": "ANCHOR, to secure by means of an anchor [v]\n",
  "ANCHORITE": "one who lives in seclusion, usually for religious reasons, also ANCHORET [n -S]\n",
  "ANCHORITES": "ANCHORITE, one who lives in seclusion, usually for religious reasons, also ANCHORET [n]\n",
  "ANCHORITIC": "of or like an anchorite, also ANCHORITICAL [adj ANCHORITICALLY]\n",
  "ANCHORITICAL": "of or like an anchorite, also ANCHORITIC [adj ANCHORITICALLY]\n",
  "ANCHORITICALLY": "ANCHORITICAL, of or like an anchorite, also ANCHORITIC [adv]\n",
  "ANCHORLESS": "without an anchor or stay [adj]\n",
  "ANCHORMAN": "in broadcasting, a person in a central studio who links up and maintains contact with various outside camera units [n ANCHORMEN]\n",
  "ANCHORMEN": "ANCHORMAN, in broadcasting, a person in a central studio who links up and maintains contact with various outside camera units [n]\n",
  "ANCHORPEOPLE": "ANCHORPERSON, an anchorman or anchorwoman [n]\n",
  "ANCHORPERSON": "an anchorman or anchorwoman [n ANCHORPERSONS or ANCHORPEOPLE]\n",
  "ANCHORPERSONS": "ANCHORPERSON, an anchorman or anchorwoman [n]\n",
  "ANCHORS": "ANCHOR, to secure by means of an anchor [v]\n",
  "ANCHORWOMAN": "a female anchorman [n ANCHORWOMEN]\n",
  "ANCHORWOMEN": "ANCHORWOMAN, a female anchorman [n]\n",
  "ANCHOS": "ANCHO, a type of dried chili pepper [n]\n",
  "ANCHOVETA": "(Spanish) a small fish like an anchovy, also ANCHOVETTA [n -S]\n",
  "ANCHOVETAS": "ANCHOVETA, (Spanish) a small fish like an anchovy, also ANCHOVETTA [n]\n",
  "ANCHOVETTA": "(Spanish) a small fish like an anchovy, also ANCHOVETA [n -S]\n",
  "ANCHOVETTAS": "ANCHOVETTA, (Spanish) a small fish like an anchovy, also ANCHOVETA [n]\n",
  "ANCHOVIES": "ANCHOVY, a small edible Mediterranean fish of the herring family [n]\n",
  "ANCHOVY": "a small edible Mediterranean fish of the herring family [n ANCHOVIES]\n",
  "ANCHUSA": "(Latin) a hairy-stemmed plant of the borage family [n -S]\n",
  "ANCHUSAS": "ANCHUSA, (Latin) a hairy-stemmed plant of the borage family [n]\n",
  "ANCHUSIN": "a red dye obtained from alkanet root [n -S]\n",
  "ANCHUSINS": "ANCHUSIN, a red dye obtained from alkanet root [n]\n",
  "ANCHYLOSE": "of bones, to fuse or stiffen by ankylosis, also ANKYLOSE [v ANCHYLOSED, ANCHYLOSING, ANCHYLOSES]\n",
  "ANCHYLOSED": "ANCHYLOSE, of bones, to fuse or stiffen by ankylosis, also ANKYLOSE [v]\n",
  "ANCHYLOSES": "ANCHYLOSE, of bones, to fuse or stiffen by ankylosis, also ANKYLOSE [v]\n",
  "ANCHYLOSING": "ANCHYLOSE, of bones, to fuse or stiffen by ankylosis, also ANKYLOSE [v]\n",
  "ANCHYLOSIS": "the joining together of bones or hard parts; resulting stiffness, also ANKYLOSIS [n ANCHYLOSES]\n",
  "ANCHYLOTIC": "relating to anchylosis, the joining together of bones or hard parts, also ANKYLOTIC [adj]\n",
  "ANCIENT": "very old, also ANTIENT [adj ANCIENTER, ANCIENTEST, ANCIENTLY] / an old person [n -S]\n",
  "ANCIENTER": "ANCIENT, very old, also ANTIENT [adj]\n",
  "ANCIENTEST": "ANCIENT, very old, also ANTIENT [adj]\n",
  "ANCIENTLY": "ANCIENT, very old, also ANTIENT [adv]\n",
  "ANCIENTNESS": "the quality of being ancient [n -ES]\n",
  "ANCIENTNESSES": "ANCIENTNESS, the quality of being ancient [n]\n",
  "ANCIENTRIES": "ANCIENTRY, (archaic) the state of being ancient; old people collectively [n]\n",
  "ANCIENTRY": "(archaic) the state of being ancient; old people collectively [n ANCIENTRIES]\n",
  "ANCIENTS": "ANCIENT, an old person [n]\n",
  "ANCILE": "(Latin) the sacred shield of the Romans, the palladium of Rome, said to have fallen from heaven in the reign of Numa [n ANCILIA]\n",
  "ANCILIA": "ANCILE, (Latin) the sacred shield of the Romans, the palladium of Rome, said to have fallen from heaven in the reign of Numa [n]\n",
  "ANCILLA": "(Latin) a helper [n ANCILLAS or ANCILLAE]\n",
  "ANCILLAE": "ANCILLA, (Latin) a helper [n]\n",
  "ANCILLARIES": "ANCILLARY, something that functions as an accessory [n]\n",
  "ANCILLARY": "subordinate or subsidiary [adj] / something that functions as an accessory [n ANCILLARIES]\n",
  "ANCILLAS": "ANCILLA, (Latin) a helper [n]\n",
  "ANCIPITAL": "two-edged and flattened, also ANCIPITOUS [adj]\n",
  "ANCIPITOUS": "two-edged and flattened, also ANCIPITAL [adj]\n",
  "ANCLE": "(archaic) ankle [n -S]\n",
  "ANCLES": "ANCLE, (archaic) ankle [n]\n",
  "ANCOME": "a sudden inflammation [n -S]\n",
  "ANCOMES": "ANCOME, a sudden inflammation [n]\n",
  "ANCON": "(Greek) the elbow, also ANCONE [n -ES]\n",
  "ANCONAL": "pertaining to the elbow [adj]\n",
  "ANCONE": "(Greek) the elbow, also ANCON [n -S]\n",
  "ANCONEAL": "pertaining to the elbow [adj]\n",
  "ANCONES": "ANCON, (Greek) the elbow, also ANCONE [n]\n",
  "ANCONOID": "pertaining to the elbow [adj]\n",
  "ANCORA": "(Italian) encore [adv]\n",
  "ANCRESS": "a female anchorite, one who lives in seclusion, usually for religious reasons, also ANCHORESS [n -ES]\n",
  "ANCRESSES": "ANCRESS, a female anchorite, one who lives in seclusion, usually for religious reasons, also ANCHORESS [n]\n",
  "ANCYLOSTOMIASES": "ANCYLOSTOMIASIS, infestation with hookworms, leading to anaemia [n]\n",
  "ANCYLOSTOMIASIS": "infestation with hookworms, leading to anaemia [n ANCYLOSTOMIASES]\n",
  "AND": "a conjunction indicating addition [conj] / the symbol ampersand; something added [n -S]\n",
  "ANDALUSITE": "a silicate of aluminium, first found in Andalusia [n -S]\n",
  "ANDALUSITES": "ANDALUSITE, a silicate of aluminium, first found in Andalusia [n]\n",
  "ANDANTE": "(Italian) a moderately slow musical passage [n -S]\n",
  "ANDANTES": "ANDANTE, (Italian) a moderately slow musical passage [n]\n",
  "ANDANTINI": "ANDANTINO, a movement rather quicker than andante [n]\n",
  "ANDANTINO": "(Italian) rather quicker than andante [adj] / a movement rather quicker than andante [n ANDANTINOS or ANDANTINI]\n",
  "ANDANTINOS": "ANDANTINO, a movement rather quicker than andante [n]\n",
  "ANDESINE": "a kind of triclinic feldspar found in the Andes [n -S]\n",
  "ANDESINES": "ANDESINE, a kind of triclinic feldspar found in the Andes [n]\n",
  "ANDESITE": "a volcanic rock found in the Andes, also ANDESYTE [n -S]\n",
  "ANDESITES": "ANDESITE, a volcanic rock found in the Andes, also ANDESYTE [n]\n",
  "ANDESITIC": "of or like andesite, a fine-grained volcanic rock [adj]\n",
  "ANDESYTE": "a volcanic rock, also ANDESITE [n -S]\n",
  "ANDESYTES": "ANDESYTE, a volcanic rock, also ANDESITE [n]\n",
  "ANDIRON": "a metal support for logs in a fireplace, a firedog, also ENDIRON [n -S]\n",
  "ANDIRONS": "ANDIRON, a metal support for logs in a fireplace, a firedog, also ENDIRON [n]\n",
  "ANDOUILLE": "(French) a kind of sausage [n -S]\n",
  "ANDOUILLES": "ANDOUILLE, (French) a kind of sausage [n]\n",
  "ANDOUILLETTE": "(French) a kind of pork sausage [n -S]\n",
  "ANDOUILLETTES": "ANDOUILLETTE, (French) a kind of pork sausage [n]\n",
  "ANDRADITE": "a green-to-black garnet [n -S]\n",
  "ANDRADITES": "ANDRADITE, a green-to-black garnet [n]\n",
  "ANDRO": "a type of sex hormone [n -S]\n",
  "ANDROCENTRIC": "revolving around men; regarding the male sex as primary [adj]\n",
  "ANDROCENTRISM": "regarding the male sex as central or primary [n -S]\n",
  "ANDROCENTRISMS": "ANDROCENTRISM, regarding the male sex as central or primary [n]\n",
  "ANDROCEPHALOUS": "with a human head [adj]\n",
  "ANDROCLINIA": "ANDROCLINIUM, another name for the clinandrium, a cavity in the upper part of the column of an orchid flower that contains the anthers [n]\n",
  "ANDROCLINIUM": "another name for the clinandrium, a cavity in the upper part of the column of an orchid flower that contains the anthers [n ANDROCLINIA]\n",
  "ANDRODIOECIOUS": "having hermaphrodite and male flowers on separate plants [adj]\n",
  "ANDRODIOECISM": "the state of being androdioecious, having hermaphrodite and male flowers on separate plants [n -S]\n",
  "ANDRODIOECISMS": "ANDRODIOECISM, the state of being androdioecious, having hermaphrodite and male flowers on separate plants [n]\n",
  "ANDROECIA": "ANDROECIUM, the male organs (stamens) of a flower taken collectively [n]\n",
  "ANDROECIAL": "relating to the androecium, the male organs (stamens) of a flower taken collectively [adj]\n",
  "ANDROECIUM": "the male organs (stamens) of a flower taken collectively [n ANDROECIA]\n",
  "ANDROGEN": "a male sex hormone [n -S]\n",
  "ANDROGENESES": "ANDROGENESIS, the development of an embryo containing only paternal chromosomes [n]\n",
  "ANDROGENESIS": "the development of an embryo containing only paternal chromosomes [n ANDROGENESES]\n",
  "ANDROGENETIC": "relating to androgenesis [adj]\n",
  "ANDROGENIC": "of or like an androgen, a male sex hormone [adj]\n",
  "ANDROGENOUS": "having only male offspring [adj]\n",
  "ANDROGENS": "ANDROGEN, a male sex hormone [n]\n",
  "ANDROGYNE": "a hermaphrodite; an effeminate man; a masculine woman [n -S]\n",
  "ANDROGYNES": "ANDROGYNE, a hermaphrodite; an effeminate man; a masculine woman [n]\n",
  "ANDROGYNIES": "ANDROGYNY, hermaphroditism [n]\n",
  "ANDROGYNOPHORE": "another name for the androphore, a support or column on which stamens are raised [n -S]\n",
  "ANDROGYNOPHORES": "ANDROGYNOPHORE, another name for the androphore, a support or column on which stamens are raised [n]\n",
  "ANDROGYNOUS": "having the characteristics of both male and female in one individual [adj]\n",
  "ANDROGYNY": "hermaphroditism [n ANDROGYNIES]\n",
  "ANDROID": "an automaton resembling a human being [n -S]\n",
  "ANDROIDS": "ANDROID, an automaton resembling a human being [n]\n",
  "ANDROLOGIES": "ANDROLOGY, the branch of medicine dealing with diseases specific to males [n]\n",
  "ANDROLOGIST": "a student of andrology [n -S]\n",
  "ANDROLOGISTS": "ANDROLOGIST, a student of andrology [n]\n",
  "ANDROLOGY": "the branch of medicine dealing with diseases specific to males [n ANDROLOGIES]\n",
  "ANDROMEDA": "a plant of the genus Andromeda, shrubs of the heath family [n -S]\n",
  "ANDROMEDAS": "ANDROMEDA, a plant of the genus Andromeda, shrubs of the heath family [n]\n",
  "ANDROMEDOTOXIN": "a poisonous substance extracted from plants of the heath family and used in medicine to lower high blood pressure [n -S]\n",
  "ANDROMEDOTOXINS": "ANDROMEDOTOXIN, a poisonous substance extracted from plants of the heath family and used in medicine to lower high blood pressure [n]\n",
  "ANDROMONOECIOUS": "having hermaphrodite and male flowers on the same plant [adj]\n",
  "ANDROMONOECISM": "having hermaphrodite and male flowers on the same plant [n -S]\n",
  "ANDROMONOECISMS": "ANDROMONOECISM, having hermaphrodite and male flowers on the same plant [n]\n",
  "ANDROPAUSE": "the male menopause [n -S]\n",
  "ANDROPAUSES": "ANDROPAUSE, the male menopause [n]\n",
  "ANDROPHORE": "a support or column on which stamens are raised [n -S]\n",
  "ANDROPHORES": "ANDROPHORE, a support or column on which stamens are raised [n]\n",
  "ANDROS": "ANDRO, a type of sex hormone [n]\n",
  "ANDROSPHINGES": "ANDROSPHINX, a sphinx having the head of a man [n]\n",
  "ANDROSPHINX": "a sphinx having the head of a man [n ANDROSPHINGES or ANDROSPHINXES]\n",
  "ANDROSPHINXES": "ANDROSPHINX, a sphinx having the head of a man [n]\n",
  "ANDROSTERONE": "an androgenic steroid male hormone [n -S]\n",
  "ANDROSTERONES": "ANDROSTERONE, an androgenic steroid male hormone [n]\n",
  "ANDS": "AND, the symbol ampersand; something added [n]\n",
  "ANDVILE": "(Spenser) an anvil [n -S]\n",
  "ANDVILES": "ANDVILE, (Spenser) an anvil [n]\n",
  "ANE": "(Scots) one, also YIN [n -S]\n",
  "ANEAR": "(archaic) to draw near to [v -ED, -ING, -S]\n",
  "ANEARED": "ANEAR, (archaic) to draw near to [v]\n",
  "ANEARING": "ANEAR, (archaic) to draw near to [v]\n",
  "ANEARS": "ANEAR, (archaic) to draw near to [v]\n",
  "ANEATH": "(Scots) beneath [adv]\n",
  "ANECDOTA": "ANECDOTE, a brief story [n]\n",
  "ANECDOTAGE": "anecdotes collectively; a collection of anecdotes [n -S]\n",
  "ANECDOTAGES": "ANECDOTAGE, anecdotes collectively; a collection of anecdotes [n]\n",
  "ANECDOTAL": "relating to anecdote, also ANECDOTIC [adj ANECDOTALLY]\n",
  "ANECDOTALISM": "the relating of anecdotes [n -S]\n",
  "ANECDOTALISMS": "ANECDOTALISM, the relating of anecdotes [n]\n",
  "ANECDOTALIST": "a person who is given to or is skilled in telling anecdotes [n -S]\n",
  "ANECDOTALISTS": "ANECDOTALIST, a person who is given to or is skilled in telling anecdotes [n]\n",
  "ANECDOTALLY": "ANECDOTAL, relating to anecdote, also ANECDOTIC [adv]\n",
  "ANECDOTE": "a brief story [n ANECDOTES or ANECDOTA]\n",
  "ANECDOTES": "ANECDOTE, a brief story [n]\n",
  "ANECDOTIC": "pertaining to anecdote, also ANECDOTAL [adj ANECDOTICALLY]\n",
  "ANECDOTICAL": "having the quality of anecdote [adj ANECDOTICALLY]\n",
  "ANECDOTICALLY": "ANECDOTICAL, having the quality of anecdote [adv]\n",
  "ANECDOTIST": "one who relates or collects anecdotes [n -S]\n",
  "ANECDOTISTS": "ANECDOTIST, one who relates or collects anecdotes [n]\n",
  "ANECDYSES": "ANECDYSIS, a period between moults in arthropods [n]\n",
  "ANECDYSIS": "a period between moults in arthropods [n ANECDYSES]\n",
  "ANECHOIC": "free from echoes and reverberations [adj]\n",
  "ANELACE": "(archaic) a short two-edged dagger, also ANLACE, ANLAS [n -S]\n",
  "ANELACES": "ANELACE, (archaic) a short two-edged dagger, also ANLACE, ANLAS [n]\n",
  "ANELASTIC": "not elastic [adj]\n",
  "ANELASTICITIES": "ANELASTICITY, the quality of being anelastic [n]\n",
  "ANELASTICITY": "the quality of being anelastic [n ANELASTICITIES]\n",
  "ANELE": "to anoint with extreme unction [v ANELED, ANELING, ANELES]\n",
  "ANELED": "ANELE, to anoint with extreme unction [v]\n",
  "ANELES": "ANELE, to anoint with extreme unction [v]\n",
  "ANELING": "ANELE, to anoint with extreme unction [v]\n",
  "ANELLI": "(Italian) ring-shaped pieces of pasta, used especially in soups [n]\n",
  "ANEMIA": "a disorder of the blood, also ANAEMIA [n -S]\n",
  "ANEMIAS": "ANEMIA, a disorder of the blood, also ANAEMIA [n]\n",
  "ANEMIC": "suffering from anemia, also ANAEMIC [adj]\n",
  "ANEMICALLY": "ANEMIC, suffering from anemia, also ANAEMIC [adv]\n",
  "ANEMOCHORE": "a plant in which the fruits or seeds are dispersed by wind [n -S]\n",
  "ANEMOCHORES": "ANEMOCHORE, a plant in which the fruits or seeds are dispersed by wind [n]\n",
  "ANEMOCHOROUS": "of or like an anemochore, a plant in which the fruits or seeds are dispersed by wind [adj]\n",
  "ANEMOGRAM": "a record made by an anemograph, an instrument for measuring the pressure and velocity of wind [n -S]\n",
  "ANEMOGRAMS": "ANEMOGRAM, a record made by an anemograph, an instrument for measuring the pressure and velocity of wind [n]\n",
  "ANEMOGRAPH": "an instrument for measuring the pressure and velocity of wind [n -S]\n",
  "ANEMOGRAPHIC": "relating to an anemograph [adj]\n",
  "ANEMOGRAPHIES": "ANEMOGRAPHY, measurement by use of an anemograph, an instrument for measuring pressure and velocity of wind [n]\n",
  "ANEMOGRAPHS": "ANEMOGRAPH, an instrument for measuring the pressure and velocity of wind [n]\n",
  "ANEMOGRAPHY": "measurement by use of an anemograph, an instrument for measuring pressure and velocity of wind [n ANEMOGRAPHIES]\n",
  "ANEMOLOGIES": "ANEMOLOGY, the study of winds [n]\n",
  "ANEMOLOGY": "the study of winds [n ANEMOLOGIES]\n",
  "ANEMOMETER": "an instrument for measuring wind velocity [n -S]\n",
  "ANEMOMETERS": "ANEMOMETER, an instrument for measuring wind velocity [n]\n",
  "ANEMOMETRIC": "relating to anemometry, also ANEMOMETRICAL [adj]\n",
  "ANEMOMETRICAL": "relating to anemometry, also ANEMOMETRIC [adj]\n",
  "ANEMOMETRIES": "ANEMOMETRY, the process of ascertaining the force or velocity of the wind [n]\n",
  "ANEMOMETRY": "the process of ascertaining the force or velocity of the wind [n ANEMOMETRIES]\n",
  "ANEMONE": "any member of the genus Anemone of the crowfoot family [n -S]\n",
  "ANEMONES": "ANEMONE, any member of the genus Anemone of the crowfoot family [n]\n",
  "ANEMOPHILIES": "ANEMOPHILY, pollination by the wind [n]\n",
  "ANEMOPHILOUS": "pollinated by wind [adj]\n",
  "ANEMOPHILY": "pollination by the wind [n ANEMOPHILIES]\n",
  "ANEMOPHOBIA": "the fear of wind or draughts [n -S]\n",
  "ANEMOPHOBIAS": "ANEMOPHOBIA, the fear of wind or draughts [n]\n",
  "ANEMOSCOPE": "any device that shows the presence and direction of a wind [n -S]\n",
  "ANEMOSCOPES": "ANEMOSCOPE, any device that shows the presence and direction of a wind [n]\n",
  "ANEMOSES": "ANEMOSIS, the separation of rings of growth in timber due to wind [n]\n",
  "ANEMOSIS": "the separation of rings of growth in timber due to wind [n ANEMOSES]\n",
  "ANENCEPHALIA": "congenital absence of all or part of the brain, also ANENCEPHALY [n -S]\n",
  "ANENCEPHALIAS": "ANENCEPHALIA, congenital absence of all or part of the brain, also ANENCEPHALY [n]\n",
  "ANENCEPHALIC": "lacking a brain [adj]\n",
  "ANENCEPHALIES": "ANENCEPHALY, congenital absence of all or part of the brain, also ANENCEPHALIA [n]\n",
  "ANENCEPHALY": "congenital absence of all or part of the brain, also ANENCEPHALIA [n ANENCEPHALIES]\n",
  "ANENST": "(archaic) about; concerning, also ANENT [prep]\n",
  "ANENT": "(archaic) about; concerning, also ANENST [prep]\n",
  "ANERGIA": "lack of energy [n -S]\n",
  "ANERGIAS": "ANERGIA, lack of energy [n]\n",
  "ANERGIC": "relating to anergia; lacking in energy [adj]\n",
  "ANERGIES": "ANERGY, the failure of the immune system; loss of energy, also ANERGIA [n]\n",
  "ANERGY": "the failure of the immune system; loss of energy, also ANERGIA [n ANERGIES]\n",
  "ANERLY": "(Scots) only [adv]\n",
  "ANEROID": "a type of barometer [n -S]\n",
  "ANEROIDS": "ANEROID, a type of barometer [n]\n",
  "ANES": "ANE, (Scots) one, also YIN [n]\n",
  "ANESTHESIA": "lack of sensation, also ANAESTHESIA [n -S]\n",
  "ANESTHESIAS": "ANESTHESIA, lack of sensation, also ANAESTHESIA [n]\n",
  "ANESTHESIOLOGY": "a branch of medical science dealing with anesthetics, also ANAESTHESIOLOGY [n]\n",
  "ANESTHETIC": "taking away sensation, also ANAESTHETIC [adj ANESTHETICALLY] / a drug taking away sensation [n -S]\n",
  "ANESTHETICALLY": "ANESTHETIC, taking away sensation, also ANAESTHETIC [adv]\n",
  "ANESTHETICS": "ANESTHETIC, a drug taking away sensation [n]\n",
  "ANESTHETISATION": "the process of anesthetising, also ANESTHETIZATION [n]\n",
  "ANESTHETISE": "to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETIZE [v ANESTHETISED, ANESTHETISING, ANESTHETISES]\n",
  "ANESTHETISED": "ANESTHETISE, to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETIZE [v]\n",
  "ANESTHETISES": "ANESTHETISE, to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETIZE [v]\n",
  "ANESTHETISING": "ANESTHETISE, to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETIZE [v]\n",
  "ANESTHETIST": "one who administers anesthetics [n -S]\n",
  "ANESTHETISTS": "ANESTHETIST, one who administers anesthetics [n]\n",
  "ANESTHETIZATION": "the process of anesthetizing, also ANESTHETISATION [n]\n",
  "ANESTHETIZE": "to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETISE [v ANESTHETIZED, ANESTHETIZING, ANESTHETIZES]\n",
  "ANESTHETIZED": "ANESTHETIZE, to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETISE [v]\n",
  "ANESTHETIZES": "ANESTHETIZE, to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETISE [v]\n",
  "ANESTHETIZING": "ANESTHETIZE, to subject to anesthesia, also ANAESTHETISE, ANAESTHETIZE, ANESTHETISE [v]\n",
  "ANESTRA": "ANESTRUM, (Greek) a period of sexual inactivity between periods of oestrus, also ANESTRUS, ANOESTRUM, ANOESTRUS [n]\n",
  "ANESTRI": "ANESTRUS, (Greek) a period of sexual inactivity between periods of oestrus, also ANESTRUM, ANOESTRUM, ANOESTRUS [n]\n",
  "ANESTROUS": "relating to anestrus, a period of sexual inactivity between periods of estrus [adj]\n",
  "ANESTRUM": "(Greek) a period of sexual inactivity between periods of oestrus, also ANESTRUS, ANOESTRUM, ANOESTRUS [n ANESTRA]\n",
  "ANESTRUS": "(Greek) a period of sexual inactivity between periods of oestrus, also ANESTRUM, ANOESTRUM, ANOESTRUS [n ANESTRI]\n",
  "ANETHOL": "an aromatic ether which is the major constituent of certain oils, e.g. anise and fennel, also ANETHOLE [n -S]\n",
  "ANETHOLE": "an aromatic ether which is the major constituent of certain oils, e.g. anise and fennel, also ANETHOL [n -S]\n",
  "ANETHOLES": "ANETHOLE, an aromatic ether which is the major constituent of certain oils, e.g. anise and fennel, also ANETHOL [n]\n",
  "ANETHOLS": "ANETHOL, an aromatic ether which is the major constituent of certain oils, e.g. anise and fennel, also ANETHOLE [n]\n",
  "ANETIC": "soothing [adj]\n",
  "ANEUPLOID": "a cell or individual with missing or extra chromosomes [n -S]\n",
  "ANEUPLOIDIES": "ANEUPLOIDY, the condition of being aneuploid, having missing or extra chromosomes [n]\n",
  "ANEUPLOIDS": "ANEUPLOID, a cell or individual with missing or extra chromosomes [n]\n",
  "ANEUPLOIDY": "the condition of being aneuploid, having missing or extra chromosomes [n ANEUPLOIDIES]\n",
  "ANEURIN": "vitamin B1, thiamine [n -S]\n",
  "ANEURINS": "ANEURIN, vitamin B1, thiamine [n]\n",
  "ANEURISM": "dilatation of an artery, also ANEURYSM [n -S]\n",
  "ANEURISMAL": "of or pertaining to an aneurism, also ANEURYSMAL [adj ANEURISMALLY]\n",
  "ANEURISMALLY": "ANEURISMAL, of or pertaining to an aneurism, also ANEURYSMAL [adv]\n",
  "ANEURISMATIC": "of or like an aneurism, also ANEURYSMATIC [adj]\n",
  "ANEURISMS": "ANEURISM, dilatation of an artery, also ANEURYSM [n]\n",
  "ANEURYSM": "dilatation of an artery, also ANEURISM [n -S]\n",
  "ANEURYSMAL": "of or pertaining to an aneurysm, also ANEURISMAL [adj ANEURYSMALLY]\n",
  "ANEURYSMALLY": "ANEURYSMAL, of or pertaining to an aneurysm, also ANEURISMAL [adv]\n",
  "ANEURYSMATIC": "of or like an aneurysm, also ANEURISMATIC [adj]\n",
  "ANEURYSMS": "ANEURYSM, dilatation of an artery, also ANEURISM [n]\n",
  "ANEW": "afresh, again [adv]\n",
  "ANFRACTUOSITIES": "ANFRACTUOSITY, circuitousness, intricacy [n]\n",
  "ANFRACTUOSITY": "circuitousness, intricacy [n ANFRACTUOSITIES]\n",
  "ANFRACTUOUS": "full of twists and turns; winding [adj]\n",
  "ANGA": "(Sanskrit) any of the eight practises of yoga [n -S]\n",
  "ANGAKOK": "(Inuit) an Inuit sorcerer, also ANGEKKOK, ANGEKOK [n -S]\n",
  "ANGAKOKS": "ANGAKOK, (Inuit) an Inuit sorcerer, also ANGEKKOK, ANGEKOK [n]\n",
  "ANGARIA": "the legal right of a belligerent to seize, use, or destroy the property of a neutral, provided that full compensation is made, also ANGARY [n -S]\n",
  "ANGARIAS": "ANGARIA, the legal right of a belligerent to seize, use, or destroy the property of a neutral, provided that full compensation is made, also ANGARY [n]\n",
  "ANGARIES": "ANGARY, the legal right of a belligerent to seize, use, or destroy the property of a neutral, provided that full compensation is made, also ANGARIA [n]\n",
  "ANGARY": "the legal right of a belligerent to seize, use, or destroy the property of a neutral, provided that full compensation is made, also ANGARIA [n ANGARIES]\n",
  "ANGAS": "ANGA, (Sanskrit) any of the eight practises of yoga [n]\n",
  "ANGASHORE": "(Irish) a miserable person given to complaining, also ANGISHORE [n -S]\n",
  "ANGASHORES": "ANGASHORE, (Irish) a miserable person given to complaining, also ANGISHORE [n]\n",
  "ANGEKKOK": "(Inuit) an Inuit sorcerer, also ANGAKOK, ANGEKOK [n -S]\n",
  "ANGEKKOKS": "ANGEKKOK, (Inuit) an Inuit sorcerer, also ANGAKOK, ANGEKOK [n]\n",
  "ANGEKOK": "(Inuit) an Inuit sorcerer, also ANGAKOK, ANGEKKOK [n -S]\n",
  "ANGEKOKS": "ANGEKOK, (Inuit) an Inuit sorcerer, also ANGAKOK, ANGEKKOK [n]\n",
  "ANGEL": "to support financially [v -ED, -ING, -S]\n",
  "ANGELED": "ANGEL, to support financially [v]\n",
  "ANGELFISH": "a brightly coloured tropical fish [n -ES]\n",
  "ANGELFISHES": "ANGELFISH, a brightly coloured tropical fish [n]\n",
  "ANGELHOOD": "the state of being an angel [n -S]\n",
  "ANGELHOODS": "ANGELHOOD, the state of being an angel [n]\n",
  "ANGELIC": "of or like an angel, a divine messenger, also ANGELICAL [adj ANGELICALLY]\n",
  "ANGELICA": "an aromatic herb with white flowers, used in cooking and medicine [n -S]\n",
  "ANGELICAL": "of or like an angel, also ANGELIC [adj ANGELICALLY]\n",
  "ANGELICALLY": "ANGELICAL, of or like an angel, also ANGELIC [adv]\n",
  "ANGELICAS": "ANGELICA, an aromatic herb with white flowers, used in cooking and medicine [n]\n",
  "ANGELING": "ANGEL, to support financially [v]\n",
  "ANGELOLATRIES": "ANGELOLATRY, worship of or belief in angels [n]\n",
  "ANGELOLATRY": "worship of or belief in angels [n ANGELOLATRIES]\n",
  "ANGELOLOGIES": "ANGELOLOGY, the study of angels [n]\n",
  "ANGELOLOGIST": "one who studies angelology [n -S]\n",
  "ANGELOLOGISTS": "ANGELOLOGIST, one who studies angelology [n]\n",
  "ANGELOLOGY": "the study of angels [n ANGELOLOGIES]\n",
  "ANGELOPHANIES": "ANGELOPHANY, the manifestation of an angel to a human [n]\n",
  "ANGELOPHANY": "the manifestation of an angel to a human [n ANGELOPHANIES]\n",
  "ANGELS": "ANGEL, to support financially [v]\n",
  "ANGELUS": "(Latin) a prayer said in morning, at noon and at sunset [n -ES]\n",
  "ANGELUSES": "ANGELUS, (Latin) a prayer said in morning, at noon and at sunset [n]\n",
  "ANGER": "wrath [adj ANGERLY] / to make angry [v -ED, -ING, -S]\n",
  "ANGERED": "ANGER, to make angry [v]\n",
  "ANGERING": "ANGER, to make angry [v]\n",
  "ANGERLESS": "without anger [adj]\n",
  "ANGERLY": "ANGER, wrath [adv]\n",
  "ANGERS": "ANGER, to make angry [v]\n",
  "ANGICO": "(Portuguese) a South American tree of the mimosa family [n -S]\n",
  "ANGICOS": "ANGICO, (Portuguese) a South American tree of the mimosa family [n]\n",
  "ANGINA": "a disease of the heart marked by spasmodic attacks of intense pain [n -S]\n",
  "ANGINAL": "relating to angina [adj]\n",
  "ANGINAS": "ANGINA, a disease of the heart marked by spasmodic attacks of intense pain [n]\n",
  "ANGINOSE": "relating to angina [adj]\n",
  "ANGINOUS": "relating to angina [adj]\n",
  "ANGIOCARPOUS": "having the fruit (or in fungi the hymenium) within a special covering [adj]\n",
  "ANGIOGENESES": "ANGIOGENESIS, the development of blood vessels and heart tissue in the embryo [n]\n",
  "ANGIOGENESIS": "the development of blood vessels and heart tissue in the embryo [n ANGIOGENESES]\n",
  "ANGIOGENIC": "relating to angiogenesis, the development of blood vessels and heart tissue in the embryo [adj]\n",
  "ANGIOGRAM": "a photograph made by angiography [n -S]\n",
  "ANGIOGRAMS": "ANGIOGRAM, a photograph made by angiography [n]\n",
  "ANGIOGRAPHIC": "relating to angiography [adj]\n",
  "ANGIOGRAPHIES": "ANGIOGRAPHY, a technique for X-raying major blood vessels, using dye opaque to X-rays [n]\n",
  "ANGIOGRAPHY": "a technique for X-raying major blood vessels, using dye opaque to X-rays [n ANGIOGRAPHIES]\n",
  "ANGIOLOGIES": "ANGIOLOGY, the branch of medical science concerned with blood vessels and the lymphatic system [n]\n",
  "ANGIOLOGY": "the branch of medical science concerned with blood vessels and the lymphatic system [n ANGIOLOGIES]\n",
  "ANGIOMA": "a benign tumour due to dilated blood vessels [n ANGIOMAS or ANGIOMATA]\n",
  "ANGIOMAS": "ANGIOMA, a benign tumour due to dilated blood vessels [n]\n",
  "ANGIOMATA": "ANGIOMA, a benign tumour due to dilated blood vessels [n]\n",
  "ANGIOMATOUS": "having many angiomas [adj]\n",
  "ANGIOPLASTIES": "ANGIOPLASTY, the surgical repair of a damaged blood-vessel [n]\n",
  "ANGIOPLASTY": "the surgical repair of a damaged blood-vessel [n ANGIOPLASTIES]\n",
  "ANGIOSARCOMA": "a malignant tumour of the vascular epithelia, occurring e.g. in the liver [n ANGIOSARCOMAS or ANGIOSARCOMATA]\n",
  "ANGIOSARCOMAS": "ANGIOSARCOMA, a malignant tumour of the vascular epithelia, occurring e.g. in the liver [n]\n",
  "ANGIOSARCOMATA": "ANGIOSARCOMA, a malignant tumour of the vascular epithelia, occurring e.g. in the liver [n]\n",
  "ANGIOSPERM": "a plant of the Angiospermae, one of the main divisions of flowering plants, in which the seeds are in a closed ovary, not naked as in gymnosperms [n -S]\n",
  "ANGIOSPERMAL": "like an angiosperm, also ANGIOSPERMOUS [adj]\n",
  "ANGIOSPERMOUS": "like an angiosperm, also ANGIOSPERMAL [adj]\n",
  "ANGIOSPERMS": "ANGIOSPERM, a plant of the Angiospermae, one of the main divisions of flowering plants, in which the seeds are in a closed ovary, not naked as in gymnosperms [n]\n",
  "ANGIOSTOMATOUS": "narrow-mouthed; with a mouth that is not distensible, also ANGIOSTOMOUS [adj]\n",
  "ANGIOSTOMOUS": "narrow-mouthed; with a mouth that is not distensible, also ANGIOSTOMATOUS [adj]\n",
  "ANGIOTENSIN": "a protein that causes a rise in blood pressure [n -S]\n",
  "ANGIOTENSINS": "ANGIOTENSIN, a protein that causes a rise in blood pressure [n]\n",
  "ANGISHORE": "(Canadian) a weak, miserable person, also ANGASHORE [n -S]\n",
  "ANGISHORES": "ANGISHORE, (Canadian) a weak, miserable person, also ANGASHORE [n]\n",
  "ANGKLUNG": "(Javanese) a musical instrument of South Asia, composed of bamboo tubes, also ANKLONG, ANKLUNG [n -S]\n",
  "ANGKLUNGS": "ANGKLUNG, (Javanese) a musical instrument of South Asia, composed of bamboo tubes, also ANKLONG, ANKLUNG [n]\n",
  "ANGLE": "to with hook and line [v ANGLED, ANGLING, ANGLES]\n",
  "ANGLEBERRIES": "ANGLEBERRY, a soft fleshy tumour in horses; a disease of turnips and cabbages, also ANBURY [n]\n",
  "ANGLEBERRY": "a soft fleshy tumour in horses; a disease of turnips and cabbages, also ANBURY [n ANGLEBERRIES]\n",
  "ANGLED": "ANGLE, to with hook and line [v]\n",
  "ANGLEDOZER": "a bulldozer whose blade may be angled or tilted to left or right [n -S]\n",
  "ANGLEDOZERS": "ANGLEDOZER, a bulldozer whose blade may be angled or tilted to left or right [n]\n",
  "ANGLEDUG": "(English dialect) an earthworm, also ANGLETWITCH [n -S]\n",
  "ANGLEDUGS": "ANGLEDUG, (English dialect) an earthworm, also ANGLETWITCH [n]\n",
  "ANGLEPOD": "any of a genus of plants of the milkweed family [n -S]\n",
  "ANGLEPODS": "ANGLEPOD, any of a genus of plants of the milkweed family [n]\n",
  "ANGLER": "one that angles [n -S]\n",
  "ANGLERFISH": "a widemouthed voracious fish that attracts its prey by waving filaments attached to its head [n -ES]\n",
  "ANGLERFISHES": "ANGLERFISH, a widemouthed voracious fish that attracts its prey by waving filaments attached to its head [n]\n",
  "ANGLERS": "ANGLER, one that angles [n]\n",
  "ANGLES": "ANGLE, to with hook and line [v]\n",
  "ANGLESITE": "a native sulphate of lead, occurring in white or yellowish transparent, prismatic crystals [n -S]\n",
  "ANGLESITES": "ANGLESITE, a native sulphate of lead, occurring in white or yellowish transparent, prismatic crystals [n]\n",
  "ANGLETWITCH": "a worm used as bait in fishing [n -ES]\n",
  "ANGLETWITCHES": "ANGLETWITCH, a worm used as bait in fishing [n]\n",
  "ANGLEWISE": "in an angular manner; angularly [adv]\n",
  "ANGLEWORM": "an earthworm of the genus Lumbricus, frequently used by anglers for bait [n -S]\n",
  "ANGLEWORMS": "ANGLEWORM, an earthworm of the genus Lumbricus, frequently used by anglers for bait [n]\n",
  "ANGLICE": "(Latin) in English [adv]\n",
  "ANGLICISATION": "the process of anglicising, also ANGLICIZATION [n -S]\n",
  "ANGLICISATIONS": "ANGLICISATION, the process of anglicising, also ANGLICIZATION [n]\n",
  "ANGLICISE": "to make English, also ANGLICIZE [v ANGLICISED, ANGLICISING, ANGLICISES]\n",
  "ANGLICISED": "ANGLICISE, to make English, also ANGLICIZE [v]\n",
  "ANGLICISES": "ANGLICISE, to make English, also ANGLICIZE [v]\n",
  "ANGLICISING": "ANGLICISE, to make English, also ANGLICIZE [v]\n",
  "ANGLICISM": "an English idiom or peculiarity [n -S]\n",
  "ANGLICISMS": "ANGLICISM, an English idiom or peculiarity [n]\n",
  "ANGLICIST": "a person with a scholarly knowledge of the English language, also ANGLIST [n -S]\n",
  "ANGLICISTS": "ANGLICIST, a person with a scholarly knowledge of the English language, also ANGLIST [n]\n",
  "ANGLICIZATION": "the process of anglicizing, also ANGLICISATION [n -S]\n",
  "ANGLICIZATIONS": "ANGLICIZATION, the process of anglicizing, also ANGLICISATION [n]\n",
  "ANGLICIZE": "to make English, also ANGLICISE [v ANGLICIZED, ANGLICIZING, ANGLICIZES]\n",
  "ANGLICIZED": "ANGLICIZE, to make English, also ANGLICISE [v]\n",
  "ANGLICIZES": "ANGLICIZE, to make English, also ANGLICISE [v]\n",
  "ANGLICIZING": "ANGLICIZE, to make English, also ANGLICISE [v]\n",
  "ANGLIFIED": "ANGLIFY, to make English [v]\n",
  "ANGLIFIES": "ANGLIFY, to make English [v]\n",
  "ANGLIFY": "to make English [v ANGLIFIED, ANGLIFYING, ANGLIFIES]\n",
  "ANGLIFYING": "ANGLIFY, to make English [v]\n",
  "ANGLING": "the sport of fishing [n -S]\n",
  "ANGLINGS": "ANGLING, the sport of fishing [n]\n",
  "ANGLIST": "an expert on English language or culture [n -S]\n",
  "ANGLISTICS": "the study of English idioms or culture [n]\n",
  "ANGLISTS": "ANGLIST, an expert on English language or culture [n]\n",
  "ANGLO": "a white inhabitant of the US not of Latin origin [n -S]\n",
  "ANGLOMANIA": "a craze or obsession with England and the English [n -S]\n",
  "ANGLOMANIAC": "one suffering from anglomania [n -S]\n",
  "ANGLOMANIACS": "ANGLOMANIAC, one suffering from anglomania [n]\n",
  "ANGLOMANIAS": "ANGLOMANIA, a craze or obsession with England and the English [n]\n",
  "ANGLOPHIL": "one who loves the English, also ANGLOPHILE [n -S]\n",
  "ANGLOPHILE": "one who loves the English, also ANGLOPHIL [n -S]\n",
  "ANGLOPHILES": "ANGLOPHILE, one who loves the English, also ANGLOPHIL [n]\n",
  "ANGLOPHILIA": "love of England or the English language [n -S]\n",
  "ANGLOPHILIAS": "ANGLOPHILIA, love of England or the English language [n]\n",
  "ANGLOPHILIC": "having a love for things English [adj]\n",
  "ANGLOPHILS": "ANGLOPHIL, one who loves the English, also ANGLOPHILE [n]\n",
  "ANGLOPHOBE": "one who hates the English [n -S]\n",
  "ANGLOPHOBES": "ANGLOPHOBE, one who hates the English [n]\n",
  "ANGLOPHOBIA": "fear of England or the English [n -S]\n",
  "ANGLOPHOBIAC": "one who suffers from anglophobia, a fear of England [n -S]\n",
  "ANGLOPHOBIACS": "ANGLOPHOBIAC, one who suffers from anglophobia, a fear of England [n]\n",
  "ANGLOPHOBIAS": "ANGLOPHOBIA, fear of England or the English [n]\n",
  "ANGLOPHOBIC": "suffering from anglophobia, a fear of England, also ANGLOPHOBIAC [adj]\n",
  "ANGLOPHONE": "an English-speaking person in a state where English is not the only language [n -S]\n",
  "ANGLOPHONES": "ANGLOPHONE, an English-speaking person in a state where English is not the only language [n]\n",
  "ANGLOPHONIC": "speaking or using English (esp. as opposed to French), in everyday affairs [adj]\n",
  "ANGLOS": "ANGLO, a white inhabitant of the US not of Latin origin [n]\n",
  "ANGOLA": "relating to a fabric made from the wool of the Angora goat [adj]\n",
  "ANGOPHORA": "(Greek) an East Australian tree, related to the eucalyptus [n -S]\n",
  "ANGOPHORAS": "ANGOPHORA, (Greek) an East Australian tree, related to the eucalyptus [n]\n",
  "ANGORA": "fabric made from the hair of the angora goat, aka mohair [n -S]\n",
  "ANGORAS": "ANGORA, fabric made from the hair of the angora goat, aka mohair [n]\n",
  "ANGOSTURA": "a bitter aromatic bark, formerly used in medicine [n -S]\n",
  "ANGOSTURAS": "ANGOSTURA, a bitter aromatic bark, formerly used in medicine [n]\n",
  "ANGRIER": "ANGRY, having anger [adj]\n",
  "ANGRIES": "ANGRY, an angry person [n]\n",
  "ANGRIEST": "ANGRY, having anger [adj]\n",
  "ANGRILY": "ANGRY, having anger [adv]\n",
  "ANGRINESS": "the quality of being angry, or of being inclined to anger [n -ES]\n",
  "ANGRINESSES": "ANGRINESS, the quality of being angry, or of being inclined to anger [n]\n",
  "ANGRY": "having anger [adj ANGRIER, ANGRIEST, ANGRILY] / an angry person [n ANGRIES]\n",
  "ANGST": "(German) a feeling of anxiety [n -S]\n",
  "ANGSTIER": "ANGSTY, feeling anxious [adj]\n",
  "ANGSTIEST": "ANGSTY, feeling anxious [adj]\n",
  "ANGSTROM": "(Swedish) a unit of length, one ten-billionth of a meter [n -S]\n",
  "ANGSTROMS": "ANGSTROM, (Swedish) a unit of length, one ten-billionth of a meter [n]\n",
  "ANGSTS": "ANGST, (German) a feeling of anxiety [n]\n",
  "ANGSTY": "feeling anxious [adj ANGSTIER, ANGSTIEST]\n",
  "ANGUIFAUNA": "(Latin) the snakes of a region [n ANGUIFAUNAE or ANGUIFAUNAS]\n",
  "ANGUIFAUNAE": "ANGUIFAUNA, (Latin) the snakes of a region [n]\n",
  "ANGUIFAUNAS": "ANGUIFAUNA, (Latin) the snakes of a region [n]\n",
  "ANGUIFORM": "shaped like a snake [adj]\n",
  "ANGUILLIFORM": "shaped like an eel [adj]\n",
  "ANGUINE": "like a snake [adj]\n",
  "ANGUIPED": "(Latin) a mythical giant having feet or legs in the form of snakes, also ANGUIPEDE [n -S]\n",
  "ANGUIPEDE": "a mythical giant having feet or legs in the form of snakes, also ANGUIPED [n -S]\n",
  "ANGUIPEDES": "ANGUIPEDE, a mythical giant having feet or legs in the form of snakes, also ANGUIPED [n]\n",
  "ANGUIPEDS": "ANGUIPED, (Latin) a mythical giant having feet or legs in the form of snakes, also ANGUIPEDE [n]\n",
  "ANGUISH": "to suffer extreme pain [v -ED, -ING, -ES]\n",
  "ANGUISHED": "ANGUISH, to suffer extreme pain [v]\n",
  "ANGUISHES": "ANGUISH, to suffer extreme pain [v]\n",
  "ANGUISHING": "ANGUISH, to suffer extreme pain [v]\n",
  "ANGULAR": "having an angle [adj]\n",
  "ANGULARITIES": "ANGULARITY, the quality of being angular [n]\n",
  "ANGULARITY": "the quality of being angular [n ANGULARITIES]\n",
  "ANGULARLY": "ANGULAR, having an angle [adv]\n",
  "ANGULARNESS": "the state of being angular [n -ES]\n",
  "ANGULARNESSES": "ANGULARNESS, the state of being angular [n]\n",
  "ANGULATE": "to form with angles [v ANGULATED, ANGULATING, ANGULATES]\n",
  "ANGULATED": "ANGULATE, to form with angles [v]\n",
  "ANGULATES": "ANGULATE, to form with angles [v]\n",
  "ANGULATING": "ANGULATE, to form with angles [v]\n",
  "ANGULATION": "a making angular; an angular formation [n -S]\n",
  "ANGULATIONS": "ANGULATION, a making angular; an angular formation [n]\n",
  "ANGULOSE": "having an angle [adj]\n",
  "ANGULOUS": "having an angle [adj]\n",
  "ANGUSTIFOLIATE": "narrow-leaved [adj]\n",
  "ANGUSTIROSTRATE": "narrow-beaked [adj]\n",
  "ANGWANTIBO": "a small lemuroid mammal of Africa [n -S]\n",
  "ANGWANTIBOS": "ANGWANTIBO, a small lemuroid mammal of Africa [n]\n",
  "ANHARMONIC": "not harmonic [adj]\n",
  "ANHEDONIA": "an unresponsiveness to pleasure [n -S]\n",
  "ANHEDONIAS": "ANHEDONIA, an unresponsiveness to pleasure [n]\n",
  "ANHEDONIC": "suffering from anhedonia, unable to experience pleasure [adj]\n",
  "ANHEDRAL": "the downward inclination of an aircraft's wing [n -S]\n",
  "ANHEDRALS": "ANHEDRAL, the downward inclination of an aircraft's wing [n]\n",
  "ANHELATION": "shortness of breath [n -S]\n",
  "ANHELATIONS": "ANHELATION, shortness of breath [n]\n",
  "ANHIDROSES": "ANHIDROSIS, absence of sweating, also ANIDROSIS [n]\n",
  "ANHIDROSIS": "absence of sweating, also ANIDROSIS [n ANHIDROSES]\n",
  "ANHIDROTIC": "a substance that suppresses sweating [n -S]\n",
  "ANHIDROTICS": "ANHIDROTIC, a substance that suppresses sweating [n]\n",
  "ANHINGA": "(Tupi) an aquatic bird, the water turkey or snakebird [n -S]\n",
  "ANHINGAS": "ANHINGA, (Tupi) an aquatic bird, the water turkey or snakebird [n]\n",
  "ANHUNGERED": "(archaic) hungry, also AHUNGERED, AHUNGRY, ANHUNGRED [adj]\n",
  "ANHUNGRED": "(archaic) hungry, also AHUNGERED, AHUNGRY, ANHUNGERED [adj]\n",
  "ANHYDRASE": "an enzyme that catalyses the removal of water [n -S]\n",
  "ANHYDRASES": "ANHYDRASE, an enzyme that catalyses the removal of water [n]\n",
  "ANHYDRIDE": "a compound derived from an acid by the removal of one or more molecules of water [n -S]\n",
  "ANHYDRIDES": "ANHYDRIDE, a compound derived from an acid by the removal of one or more molecules of water [n]\n",
  "ANHYDRITE": "an anhydrous sulphate of lime, differing from gypsum in not containing water (whence the name) [n -S]\n",
  "ANHYDRITES": "ANHYDRITE, an anhydrous sulphate of lime, differing from gypsum in not containing water (whence the name) [n]\n",
  "ANHYDROUS": "destitute of water; as, anhydrous salts or acids [adj]\n",
  "ANI": "a tropical American bird [n -S]\n",
  "ANICCA": "(Sanskrit) the belief that everything is impermanent and constantly changing [n -S]\n",
  "ANICCAS": "ANICCA, (Sanskrit) the belief that everything is impermanent and constantly changing [n]\n",
  "ANICONIC": "symbolising without aiming at resemblance [adj]\n",
  "ANICONISM": "the worship of an object symbolising but not representing a god [n -S]\n",
  "ANICONISMS": "ANICONISM, the worship of an object symbolising but not representing a god [n]\n",
  "ANICONIST": "one who practises aniconism, the worship of an object symbolising but not representing a god [n -S]\n",
  "ANICONISTS": "ANICONIST, one who practises aniconism, the worship of an object symbolising but not representing a god [n]\n",
  "ANICUT": "(Tamil) a dam or mole made in the course of a stream for the purpose of regulating the flow of a system of irrigation, also ANNICUT [n -S]\n",
  "ANICUTS": "ANICUT, (Tamil) a dam or mole made in the course of a stream for the purpose of regulating the flow of a system of irrigation, also ANNICUT [n]\n",
  "ANIDROSES": "ANIDROSIS, absence of sweating, also ANHIDROSIS [n]\n",
  "ANIDROSIS": "absence of sweating, also ANHIDROSIS [n ANIDROSES]\n",
  "ANIGH": "nigh [adv]\n",
  "ANIGHT": "(Shakespeare) by night [adv]\n",
  "ANIL": "(Arabic) indigo, the plant or dye [n -S]\n",
  "ANILE": "old-womanish [adj]\n",
  "ANILIN": "a product of coal-tar used in dyeing, also ANILINE [n -S]\n",
  "ANILINCTUS": "oral stimulation of the anus, also ANILINGUS [n -ES]\n",
  "ANILINCTUSES": "ANILINCTUS, oral stimulation of the anus, also ANILINGUS [n]\n",
  "ANILINE": "a product of coal-tar used in dyeing, also ANILIN [n -S]\n",
  "ANILINES": "ANILINE, a product of coal-tar used in dyeing, also ANILIN [n]\n",
  "ANILINGUS": "oral stimulation of the anus, also ANILINCTUS [n -ES]\n",
  "ANILINGUSES": "ANILINGUS, oral stimulation of the anus, also ANILINCTUS [n]\n",
  "ANILINS": "ANILIN, a product of coal-tar used in dyeing, also ANILINE [n]\n",
  "ANILITIES": "ANILITY, the state of being an old woman [n]\n",
  "ANILITY": "the state of being an old woman [n ANILITIES]\n",
  "ANILS": "ANIL, (Arabic) indigo, the plant or dye [n]\n",
  "ANIMA": "(Latin) the soul, the innermost part of the personality [n -S]\n",
  "ANIMACIES": "ANIMACY, the state of being animate [n]\n",
  "ANIMACY": "the state of being animate [n ANIMACIES]\n",
  "ANIMADVERSION": "hostile criticism; a critical or censorious remark [n -S]\n",
  "ANIMADVERSIONS": "ANIMADVERSION, hostile criticism; a critical or censorious remark [n]\n",
  "ANIMADVERT": "to comment critically on; to censure [v -ED, -ING, -S]\n",
  "ANIMADVERTED": "ANIMADVERT, to comment critically on; to censure [v]\n",
  "ANIMADVERTER": "one who animadverts, comments on critically [n -S]\n",
  "ANIMADVERTERS": "ANIMADVERTER, one who animadverts, comments on critically [n]\n",
  "ANIMADVERTING": "ANIMADVERT, to comment critically on; to censure [v]\n",
  "ANIMADVERTS": "ANIMADVERT, to comment critically on; to censure [v]\n",
  "ANIMAL": "a living organism typically capable of voluntary motion and sensation [n -S] / of the nature of an animal [adj ANIMALLY]\n",
  "ANIMALCULA": "ANIMALCULUM, a microscopic animal [n]\n",
  "ANIMALCULAR": "of or like an animalcule [adj]\n",
  "ANIMALCULE": "a small animal, as a fly, spider, etc., also ANIMALCULUM [n -S]\n",
  "ANIMALCULES": "ANIMALCULE, a small animal, as a fly, spider, etc., also ANIMALCULUM [n]\n",
  "ANIMALCULISM": "the former biological theory that the spermatozoon contains all future generations in germ [n -S]\n",
  "ANIMALCULISMS": "ANIMALCULISM, the former biological theory that the spermatozoon contains all future generations in germ [n]\n",
  "ANIMALCULIST": "a believer in animalculism [n -S]\n",
  "ANIMALCULISTS": "ANIMALCULIST, a believer in animalculism [n]\n",
  "ANIMALCULUM": "a microscopic animal [n ANIMALCULA]\n",
  "ANIMALIAN": "of or like an animal, also ANIMALIC [adj]\n",
  "ANIMALIC": "of or like an animal, also ANIMALIAN [adj]\n",
  "ANIMALIER": "a sculptor or painter of animal subjects [n -S]\n",
  "ANIMALIERS": "ANIMALIER, a sculptor or painter of animal subjects [n]\n",
  "ANIMALISATION": "the process of animalising, also ANIMALIZATION [n -S]\n",
  "ANIMALISATIONS": "ANIMALISATION, the process of animalising, also ANIMALIZATION [n]\n",
  "ANIMALISE": "to endow with the properties of an animal; to represent in animal form, also ANIMALIZE [v ANIMALISED, ANIMALISING, ANIMALISES]\n",
  "ANIMALISED": "ANIMALISE, to endow with the properties of an animal; to represent in animal form, also ANIMALIZE [v]\n",
  "ANIMALISES": "ANIMALISE, to endow with the properties of an animal; to represent in animal form, also ANIMALIZE [v]\n",
  "ANIMALISING": "ANIMALISE, to endow with the properties of an animal; to represent in animal form, also ANIMALIZE [v]\n",
  "ANIMALISM": "physicality; the state of being actuated by mere animal appetites [n -S]\n",
  "ANIMALISMS": "ANIMALISM, physicality; the state of being actuated by mere animal appetites [n]\n",
  "ANIMALIST": "a person who believes in animalism [n -S]\n",
  "ANIMALISTIC": "relating to animalism [adj]\n",
  "ANIMALISTS": "ANIMALIST, a person who believes in animalism [n]\n",
  "ANIMALITIES": "ANIMALITY, animal existence or nature [n]\n",
  "ANIMALITY": "animal existence or nature [n ANIMALITIES]\n",
  "ANIMALIZATION": "the process of animalizing, also ANIMALISATION [n -S]\n",
  "ANIMALIZATIONS": "ANIMALIZATION, the process of animalizing, also ANIMALISATION [n]\n",
  "ANIMALIZE": "to endow with the properties of an animal; to represent in animal form, also ANIMALISE [v ANIMALIZED, ANIMALIZING, ANIMALIZES]\n",
  "ANIMALIZED": "ANIMALIZE, to endow with the properties of an animal; to represent in animal form, also ANIMALISE [v]\n",
  "ANIMALIZES": "ANIMALIZE, to endow with the properties of an animal; to represent in animal form, also ANIMALISE [v]\n",
  "ANIMALIZING": "ANIMALIZE, to endow with the properties of an animal; to represent in animal form, also ANIMALISE [v]\n",
  "ANIMALLIKE": "like an animal [adj]\n",
  "ANIMALLY": "ANIMAL, of the nature of an animal [adv]\n",
  "ANIMALS": "ANIMAL, a living organism typically capable of voluntary motion and sensation [n]\n",
  "ANIMAS": "ANIMA, (Latin) the soul, the innermost part of the personality [n]\n",
  "ANIMATE": "living, having animal life [adj ANIMATELY] / to give life to [v ANIMATED, ANIMATING, ANIMATES]\n",
  "ANIMATED": "ANIMATE, to give life to [v]\n",
  "ANIMATEDLY": "ANIMATED [adv]\n",
  "ANIMATELY": "ANIMATE, living, having animal life [adv]\n",
  "ANIMATENESS": "the state of being animate [n -ES]\n",
  "ANIMATENESSES": "ANIMATENESS, the state of being animate [n]\n",
  "ANIMATER": "one who, or that which, animates, also ANIMATOR [n -S]\n",
  "ANIMATERS": "ANIMATER, one who, or that which, animates, also ANIMATOR [n]\n",
  "ANIMATES": "ANIMATE, to give life to [v]\n",
  "ANIMATEUR": "a person who enlivens or encourages something, especially a promoter of artistic enterprises [n -S]\n",
  "ANIMATEURS": "ANIMATEUR, a person who enlivens or encourages something, especially a promoter of artistic enterprises [n]\n",
  "ANIMATI": "ANIMATO, (Italian) a passage to be played in a lively manner [n]\n",
  "ANIMATIC": "a section of animation in a TV commercial [n -S]\n",
  "ANIMATICS": "ANIMATIC, a section of animation in a TV commercial [n]\n",
  "ANIMATING": "ANIMATE, to give life to [v]\n",
  "ANIMATINGLY": "ANIMATING, ANIMATE, to give life to [adv]\n",
  "ANIMATION": "the state of being animated [n -S]\n",
  "ANIMATIONS": "ANIMATION, the state of being animated [n]\n",
  "ANIMATISM": "the primitive attribution of life to natural phenomena [n -S]\n",
  "ANIMATISMS": "ANIMATISM, the primitive attribution of life to natural phenomena [n]\n",
  "ANIMATIST": "one who believes in animatism, the primitive attribution of life to natural phenomena [n -S]\n",
  "ANIMATISTS": "ANIMATIST, one who believes in animatism, the primitive attribution of life to natural phenomena [n]\n",
  "ANIMATO": "(Italian) a passage to be played in a lively manner [n ANIMATI or ANIMATOS]\n",
  "ANIMATOR": "one who, or that which, animates, also ANIMATER [n -S]\n",
  "ANIMATORS": "ANIMATOR, one who, or that which, animates, also ANIMATER [n]\n",
  "ANIMATOS": "ANIMATO, (Italian) a passage to be played in a lively manner [n]\n",
  "ANIMATRONIC": "relating to animatronics [adj ANIMATRONICALLY]\n",
  "ANIMATRONICALLY": "ANIMATRONIC, relating to animatronics [adv]\n",
  "ANIMATRONICS": "a technique of constructing robot models in accurate likenesses of humans, animals, etc., which are programmed to perform intricate, lifelike bodily movements in synchronization with a prerecorded soundtrack [n]\n",
  "ANIME": "(Tupi) the resin of the West Indian locust-tree, also ANIMI [n -S]\n",
  "ANIMES": "ANIME, (Tupi) the resin of the West Indian locust-tree, also ANIMI [n]\n",
  "ANIMI": "(Tupi) the resin of the West Indian locust-tree, also ANIME [n -S]\n",
  "ANIMIS": "ANIMI, (Tupi) the resin of the West Indian locust-tree, also ANIME [n]\n",
  "ANIMISM": "the attribution of a soul to natural objects and phenomena [n -S]\n",
  "ANIMISMS": "ANIMISM, the attribution of a soul to natural objects and phenomena [n]\n",
  "ANIMIST": "one who indulges in animism, the attribution of a living soul to plants, inanimate objects, and natural phenomena [n -S]\n",
  "ANIMISTIC": "of or pertaining to animism, the attribution of soul to inanimate objects [adj]\n",
  "ANIMISTS": "ANIMIST, one who indulges in animism, the attribution of a living soul to plants, inanimate objects, and natural phenomena [n]\n",
  "ANIMOSITIES": "ANIMOSITY, hostility [n]\n",
  "ANIMOSITY": "hostility [n ANIMOSITIES]\n",
  "ANIMUS": "(Latin) a usually prejudiced and often spiteful or malevolent ill will [n -ES]\n",
  "ANIMUSES": "ANIMUS, (Latin) a usually prejudiced and often spiteful or malevolent ill will [n]\n",
  "ANION": "an ion with a negative electrical charge, having gained one or more electrons [n -S]\n",
  "ANIONIC": "relating to an anion [adj]\n",
  "ANIONS": "ANION, an ion with a negative electrical charge, having gained one or more electrons [n]\n",
  "ANIRIDIA": "a congenital condition in which the eye is incompletely formed [n -S]\n",
  "ANIRIDIAS": "ANIRIDIA, a congenital condition in which the eye is incompletely formed [n]\n",
  "ANIRIDIC": "suffering from ANIRIDIA, a congenital condition in which the eye is incompletely formed [adj]\n",
  "ANIS": "ANI, a tropical American bird [n]\n",
  "ANISE": "an annual Mediterranean plant of the carrot family [n -S]\n",
  "ANISEED": "the dried fruit of anise; a cordial made from it [n -S]\n",
  "ANISEEDS": "ANISEED, the dried fruit of anise; a cordial made from it [n]\n",
  "ANISEIKONIA": "a visual condition where image, shape, and size differ in each eye [n -S]\n",
  "ANISEIKONIAS": "ANISEIKONIA, a visual condition where image, shape, and size differ in each eye [n]\n",
  "ANISEIKONIC": "relating to aniseikonia [adj]\n",
  "ANISES": "ANISE, an annual Mediterranean plant of the carrot family [n]\n",
  "ANISETTE": "(French) a cordial or liqueur flavored with anise seeds [n -S]\n",
  "ANISETTES": "ANISETTE, (French) a cordial or liqueur flavored with anise seeds [n]\n",
  "ANISIC": "of or derived from anise; as, anisic acid [adj]\n",
  "ANISOCERCAL": "of fish, having unequal tail-lobes [adj]\n",
  "ANISODACTYL": "a bird having the first toe directed backwards and the other three toes directed forwards [n -S]\n",
  "ANISODACTYLOUS": "of birds, having three toes turned forward, one backwards [adj]\n",
  "ANISODACTYLS": "ANISODACTYL, a bird having the first toe directed backwards and the other three toes directed forwards [n]\n",
  "ANISOGAMIES": "ANISOGAMY, union between markedly different gametes e.g. as egg and sperm, as in humans [n]\n",
  "ANISOGAMOUS": "relating to anisogamy, union between markedly different gametes e.g. as egg and sperm, as in humans [adj]\n",
  "ANISOGAMY": "union between markedly different gametes e.g. as egg and sperm, as in humans [n ANISOGAMIES]\n",
  "ANISOLE": "a colourless liquid ether [n -S]\n",
  "ANISOLES": "ANISOLE, a colourless liquid ether [n]\n",
  "ANISOMERIC": "of a chemical compound, lacking isomers [adj]\n",
  "ANISOMEROUS": "with unequal numbers of parts in the floral whorls [adj]\n",
  "ANISOMETRIC": "not isometric; having unsymmetrical parts or unequal measurements [adj]\n",
  "ANISOMETROPIA": "the condition of the eyes having unequal refractive power [n -S]\n",
  "ANISOMETROPIAS": "ANISOMETROPIA, the condition of the eyes having unequal refractive power [n]\n",
  "ANISOMETROPIC": "relating to anisometropia [adj]\n",
  "ANISOMORPHIC": "differing in the semantic scope of terms referring to the real world e.g. colours [adj]\n",
  "ANISOPHYLLIES": "ANISOPHYLLY, the state of being anisophyllous [n]\n",
  "ANISOPHYLLOUS": "of leaves, usually a pair, of differing size and shape [adj]\n",
  "ANISOPHYLLY": "the state of being anisophyllous [n ANISOPHYLLIES]\n",
  "ANISOTROPIC": "not having the same properties in every direction [adj]\n",
  "ANISOTROPICALLY": "ANISOTROPIC, not having the same properties in every direction [adv]\n",
  "ANISOTROPIES": "ANISOTROPY, the characteristics of exhibiting different values of a property in different directions [n]\n",
  "ANISOTROPISM": "the state of being anisotropic [n -S]\n",
  "ANISOTROPISMS": "ANISOTROPISM, the state of being anisotropic [n]\n",
  "ANISOTROPY": "the characteristics of exhibiting different values of a property in different directions [n ANISOTROPIES]\n",
  "ANKER": "an old wine measure [n -S]\n",
  "ANKERITE": "a mineral closely related to dolomite, but containing iron [n -S]\n",
  "ANKERITES": "ANKERITE, a mineral closely related to dolomite, but containing iron [n]\n",
  "ANKERS": "ANKER, an old wine measure [n]\n",
  "ANKH": "(Arabic) an Egyptian symbol of life, resembling a looped cross, later adapted by Coptic Christians as their cross [n -S]\n",
  "ANKHS": "ANKH, (Arabic) an Egyptian symbol of life, resembling a looped cross, later adapted by Coptic Christians as their cross [n]\n",
  "ANKLE": "the joint connecting the foot and leg, also ANCLE [n -S] / to walk [v ANKLED, ANKLING, ANKLES]\n",
  "ANKLEBONE": "the bone of the ankle [n -S]\n",
  "ANKLEBONES": "ANKLEBONE, the bone of the ankle [n]\n",
  "ANKLED": "ANKLE, to walk [v]\n",
  "ANKLES": "ANKLE, to walk [v]\n",
  "ANKLET": "an ornament for the ankle [n -S]\n",
  "ANKLETS": "ANKLET, an ornament for the ankle [n]\n",
  "ANKLING": "ANKLE, to walk [v]\n",
  "ANKLONG": "(Javanese) a musical instrument of South Asia, composed of bamboo tubes, also ANGKLUNG, ANKLUNG [n -S]\n",
  "ANKLONGS": "ANKLONG, (Javanese) a musical instrument of South Asia, composed of bamboo tubes, also ANGKLUNG, ANKLUNG [n]\n",
  "ANKLUNG": "(Javanese) a musical instrument of South Asia, composed of bamboo tubes, also ANGKLUNG, ANKLONG [n -S]\n",
  "ANKLUNGS": "ANKLUNG, (Javanese) a musical instrument of South Asia, composed of bamboo tubes, also ANGKLUNG, ANKLONG [n]\n",
  "ANKUS": "(Hindi) an elephant goad, also ANKUSH [n -ES]\n",
  "ANKUSES": "ANKUS, (Hindi) an elephant goad, also ANKUSH [n]\n",
  "ANKUSH": "(Hindi) an elephant goad, also ANKUS [n -ES]\n",
  "ANKUSHES": "ANKUSH, (Hindi) an elephant goad, also ANKUS [n]\n",
  "ANKYLOSAUR": "a kind of dinosaur with a club tail, also ANKYLOSAURUS [n -S]\n",
  "ANKYLOSAURS": "ANKYLOSAUR, a kind of dinosaur with a club tail, also ANKYLOSAURUS [n]\n",
  "ANKYLOSAURUS": "a kind of dinosaur with a club tail, also ANKYLOSAUR [n -ES]\n",
  "ANKYLOSAURUSES": "ANKYLOSAURUS, a kind of dinosaur with a club tail, also ANKYLOSAUR [n]\n",
  "ANKYLOSE": "to fuse as the bones of a joint [v ANKYLOSED, ANKYLOSING, ANKYLOSES]\n",
  "ANKYLOSED": "ANKYLOSE, to fuse as the bones of a joint [v]\n",
  "ANKYLOSES": "ANKYLOSE, to fuse as the bones of a joint [v]\n",
  "ANKYLOSING": "ANKYLOSE, to fuse as the bones of a joint [v]\n",
  "ANKYLOSIS": "the joining together of bones or hard parts; the resulting stiffness, also ANCHYLOSIS [n ANKYLOSES]\n",
  "ANKYLOSTOMIASES": "ANKYLOSTOMIASIS, infestation with hookworms, leading to anaemia [n]\n",
  "ANKYLOSTOMIASIS": "infestation with hookworms, leading to anaemia [n ANKYLOSTOMIASES]\n",
  "ANKYLOTIC": "relating to ankylosis, the joining together of bones or hard parts, also ANCHYLOTIC [adj]\n",
  "ANLACE": "(archaic) a short two-edged dagger, also ANELACE, ANLAS [n -S]\n",
  "ANLACES": "ANLACE, (archaic) a short two-edged dagger, also ANELACE, ANLAS [n]\n",
  "ANLAGE": "(German) the first discernible rudiment of an organ [n ANLAGES or ANLAGEN]\n",
  "ANLAGEN": "ANLAGE, (German) the first discernible rudiment of an organ [n]\n",
  "ANLAGES": "ANLAGE, (German) the first discernible rudiment of an organ [n]\n",
  "ANLAS": "a short two-edged dagger, also ANELACE, ANLACE [n -ES]\n",
  "ANLASES": "ANLAS, a short two-edged dagger, also ANELACE, ANLACE [n]\n",
  "ANN": "(Scots) the half-year's stipend payable to a minister's wife on his death, also ANNAT [n -S]\n",
  "ANNA": "(Hindi) a former coin of India [n -S]\n",
  "ANNABERGITE": "an apple-green mineral, hydrous nickel arsenate [n -S]\n",
  "ANNABERGITES": "ANNABERGITE, an apple-green mineral, hydrous nickel arsenate [n]\n",
  "ANNAL": "a record of a single year [n -S]\n",
  "ANNALISE": "to record in annals, also ANNALIZE [v ANNALISED, ANNALISING, ANNALISES]\n",
  "ANNALISED": "ANNALISE, to record in annals, also ANNALIZE [v]\n",
  "ANNALISES": "ANNALISE, to record in annals, also ANNALIZE [v]\n",
  "ANNALISING": "ANNALISE, to record in annals, also ANNALIZE [v]\n",
  "ANNALIST": "a historian, esp. a chronicler of yearly events [n -S]\n",
  "ANNALISTIC": "relating to annals [adj]\n",
  "ANNALISTS": "ANNALIST, a historian, esp. a chronicler of yearly events [n]\n",
  "ANNALIZE": "to record in annals, also ANNALISE [v ANNALIZED, ANNALIZING, ANNALIZES]\n",
  "ANNALIZED": "ANNALIZE, to record in annals, also ANNALISE [v]\n",
  "ANNALIZES": "ANNALIZE, to record in annals, also ANNALISE [v]\n",
  "ANNALIZING": "ANNALIZE, to record in annals, also ANNALISE [v]\n",
  "ANNALS": "ANNAL, a record of a single year [n]\n",
  "ANNAS": "ANNA, (Hindi) a former coin of India [n]\n",
  "ANNAT": "(Scots) the half-year's stipend payable to a minister's wife on his death, also ANN [n ANNATS or ANNATES]\n",
  "ANNATES": "(historical) the first year's profits of a spiritual preferment, anciently paid by the clergy to the pope [n]\n",
  "ANNATS": "ANNAT, (Scots) the half-year's stipend payable to a minister's wife on his death, also ANN [n]\n",
  "ANNATTA": "(Caribbean) a yellowish red dye, also ANATTA, ANATTO, ANNATTO, ARNATTO, ARNOTTO [n -S]\n",
  "ANNATTAS": "ANNATTA, (Caribbean) a yellowish red dye, also ANATTA, ANATTO, ANNATTO, ARNATTO, ARNOTTO [n]\n",
  "ANNATTO": "(Caribbean) a yellowish red dye, also ANATTA, ANATTO, ANNATTA, ARNATTO, ARNOTTO [n -S]\n",
  "ANNATTOS": "ANNATTO, (Caribbean) a yellowish red dye, also ANATTA, ANATTO, ANNATTA, ARNATTO, ARNOTTO [n]\n",
  "ANNEAL": "to make (as steel or glass) less brittle by heating and then cooling [v -ED, -ING, -S]\n",
  "ANNEALED": "ANNEAL, to make (as steel or glass) less brittle by heating and then cooling [v]\n",
  "ANNEALER": "one who anneals [n -S]\n",
  "ANNEALERS": "ANNEALER, one who anneals [n]\n",
  "ANNEALING": "the process of making (as steel or glass) less brittle by heating and then cooling [n -S]\n",
  "ANNEALINGS": "ANNEALING, the process of making (as steel or glass) less brittle by heating and then cooling [n]\n",
  "ANNEALS": "ANNEAL, to make (as steel or glass) less brittle by heating and then cooling [v]\n",
  "ANNECTENT": "having intermediate features between two taxa [adj]\n",
  "ANNELID": "any of a phylum of segmented worms [n -S]\n",
  "ANNELIDAN": "a member of the Annelida, red-blooded worms [n -S]\n",
  "ANNELIDANS": "ANNELIDAN, a member of the Annelida, red-blooded worms [n]\n",
  "ANNELIDS": "ANNELID, any of a phylum of segmented worms [n]\n",
  "ANNEX": "to join or attach [v -ED, -ING, -ES]\n",
  "ANNEXABLE": "that can be annexed [adj]\n",
  "ANNEXATION": "the act of annexing, also ANNEXION [n -S]\n",
  "ANNEXATIONAL": "relating to annexation [adj]\n",
  "ANNEXATIONISM": "the policy of annexation [n -S]\n",
  "ANNEXATIONISMS": "ANNEXATIONISM, the policy of annexation [n]\n",
  "ANNEXATIONIST": "a supporter of annexation [n -S]\n",
  "ANNEXATIONISTS": "ANNEXATIONIST, a supporter of annexation [n]\n",
  "ANNEXATIONS": "ANNEXATION, the act of annexing, also ANNEXION [n]\n",
  "ANNEXE": "something joined or attached [n -S]\n",
  "ANNEXED": "ANNEX, to join or attach [v]\n",
  "ANNEXES": "ANNEXE, something joined or attached [n]\n",
  "ANNEXING": "ANNEX, to join or attach [v]\n",
  "ANNEXION": "(archaic) the act of annexing, also ANNEXATION [n -S]\n",
  "ANNEXIONS": "ANNEXION, (archaic) the act of annexing, also ANNEXATION [n]\n",
  "ANNEXMENT": "the act of annexing, or the thing annexed [n -S]\n",
  "ANNEXMENTS": "ANNEXMENT, the act of annexing, or the thing annexed [n]\n",
  "ANNEXURE": "something added, esp. to a public document [n -S]\n",
  "ANNEXURES": "ANNEXURE, something added, esp. to a public document [n]\n",
  "ANNICUT": "(Tamil) a dam or mole made in the course of a stream for the purpose of regulating the flow of a system of irrigation, also ANICUT [n -S]\n",
  "ANNICUTS": "ANNICUT, (Tamil) a dam or mole made in the course of a stream for the purpose of regulating the flow of a system of irrigation, also ANICUT [n]\n",
  "ANNIHILABLE": "that can be annihilated [adj]\n",
  "ANNIHILATE": "to destroy completely [v ANNIHILATED, ANNIHILATING, ANNIHILATES]\n",
  "ANNIHILATED": "ANNIHILATE, to destroy completely [v]\n",
  "ANNIHILATES": "ANNIHILATE, to destroy completely [v]\n",
  "ANNIHILATING": "ANNIHILATE, to destroy completely [v]\n",
  "ANNIHILATION": "the process or result of annihilating [n -S]\n",
  "ANNIHILATIONISM": "the belief that the soul (esp. of the unrepentant wicked) dies with the body [n]\n",
  "ANNIHILATIONS": "ANNIHILATION, the process or result of annihilating [n]\n",
  "ANNIHILATIVE": "tending to annihilate [adj]\n",
  "ANNIHILATOR": "one who annihilates [n -S]\n",
  "ANNIHILATORS": "ANNIHILATOR, one who annihilates [n]\n",
  "ANNIHILATORY": "tending to annihilate [adj]\n",
  "ANNIVERSARIES": "ANNIVERSARY, the annual recurrence of a date marking a notable event [n]\n",
  "ANNIVERSARY": "the annual recurrence of a date marking a notable event [n ANNIVERSARIES]\n",
  "ANNO": "(Latin) in the year [prep]\n",
  "ANNONA": "any of the various trees and shrubs of the genus Annona grown for their edible fruits [n -S]\n",
  "ANNONAS": "ANNONA, any of the various trees and shrubs of the genus Annona grown for their edible fruits [n]\n",
  "ANNOTATABLE": "that can be annotated [adj]\n",
  "ANNOTATE": "to append notes [v ANNOTATED, ANNOTATING, ANNOTATES]\n",
  "ANNOTATED": "ANNOTATE, to append notes [v]\n",
  "ANNOTATES": "ANNOTATE, to append notes [v]\n",
  "ANNOTATING": "ANNOTATE, to append notes [v]\n",
  "ANNOTATION": "a note added by way of comment or explanation [n -S]\n",
  "ANNOTATIONS": "ANNOTATION, a note added by way of comment or explanation [n]\n",
  "ANNOTATIVE": "characterized by annotations; of the nature of annotation [adj]\n",
  "ANNOTATOR": "one who annotates [n -S]\n",
  "ANNOTATORS": "ANNOTATOR, one who annotates [n]\n",
  "ANNOUNCE": "to make known publicly [v ANNOUNCED, ANNOUNCING, ANNOUNCES]\n",
  "ANNOUNCED": "ANNOUNCE, to make known publicly [v]\n",
  "ANNOUNCEMENT": "the act of announcing [n -S]\n",
  "ANNOUNCEMENTS": "ANNOUNCEMENT, the act of announcing [n]\n",
  "ANNOUNCER": "one who announces [n -S]\n",
  "ANNOUNCERS": "ANNOUNCER, one who announces [n]\n",
  "ANNOUNCES": "ANNOUNCE, to make known publicly [v]\n",
  "ANNOUNCING": "ANNOUNCE, to make known publicly [v]\n",
  "ANNOY": "to be troublesome to [v -ED, -ING, -S]\n",
  "ANNOYANCE": "something that annoys [n -S]\n",
  "ANNOYANCES": "ANNOYANCE, something that annoys [n]\n",
  "ANNOYED": "ANNOY, to be troublesome to [v]\n",
  "ANNOYER": "one who annoys [n -S]\n",
  "ANNOYERS": "ANNOYER, one who annoys [n]\n",
  "ANNOYING": "ANNOY, to be troublesome to [v]\n",
  "ANNOYINGLY": "ANNOYING, ANNOY, to be troublesome to [adv]\n",
  "ANNOYS": "ANNOY, to be troublesome to [v]\n",
  "ANNS": "ANN, (Scots) the half-year's stipend payable to a minister's wife on his death, also ANNAT [n]\n",
  "ANNUAL": "happening every year [adj ANNUALLY] / a plant that flowers for one year only [n -S]\n",
  "ANNUALISE": "to convert to a yearly rate, also ANNUALIZE [v ANNUALISED, ANNUALISING, ANNUALISES]\n",
  "ANNUALISED": "ANNUALISE, to convert to a yearly rate, also ANNUALIZE [v]\n",
  "ANNUALISES": "ANNUALISE, to convert to a yearly rate, also ANNUALIZE [v]\n",
  "ANNUALISING": "ANNUALISE, to convert to a yearly rate, also ANNUALIZE [v]\n",
  "ANNUALIZE": "to convert to a yearly rate, also ANNUALISE [v ANNUALIZED, ANNUALIZING, ANNUALIZES]\n",
  "ANNUALIZED": "ANNUALIZE, to convert to a yearly rate, also ANNUALISE [v]\n",
  "ANNUALIZES": "ANNUALIZE, to convert to a yearly rate, also ANNUALISE [v]\n",
  "ANNUALIZING": "ANNUALIZE, to convert to a yearly rate, also ANNUALISE [v]\n",
  "ANNUALLY": "ANNUAL, happening every year [adv]\n",
  "ANNUALS": "ANNUAL, a plant that flowers for one year only [n]\n",
  "ANNUITANT": "one who receives, or is entitled to receive, an annuity [n -S]\n",
  "ANNUITANTS": "ANNUITANT, one who receives, or is entitled to receive, an annuity [n]\n",
  "ANNUITIES": "ANNUITY, income paid at regular intervals [n]\n",
  "ANNUITISE": "to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITIZE [v ANNUITISED, ANNUITISING, ANNUITISES]\n",
  "ANNUITISED": "ANNUITISE, to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITIZE [v]\n",
  "ANNUITISES": "ANNUITISE, to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITIZE [v]\n",
  "ANNUITISING": "ANNUITISE, to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITIZE [v]\n",
  "ANNUITIZE": "to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITISE [v ANNUITIZED, ANNUITIZING, ANNUITIZES]\n",
  "ANNUITIZED": "ANNUITIZE, to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITISE [v]\n",
  "ANNUITIZES": "ANNUITIZE, to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITISE [v]\n",
  "ANNUITIZING": "ANNUITIZE, to commence a series of payments from the capital that has accumulated in an annuity, also ANNUITISE [v]\n",
  "ANNUITY": "income paid at regular intervals [n ANNUITIES]\n",
  "ANNUL": "to declare void [v ANNULLED, ANNULLING, ANNULS]\n",
  "ANNULAR": "ring-shaped [adj ANNULARLY] / the ring finger [n -S]\n",
  "ANNULARITIES": "ANNULARITY, the state of being ring-shaped [n]\n",
  "ANNULARITY": "the state of being ring-shaped [n ANNULARITIES]\n",
  "ANNULARLY": "ANNULAR, ring-shaped [adv]\n",
  "ANNULARS": "ANNULAR, the ring finger [n]\n",
  "ANNULATE": "(obsolete) an annelid worm [n -S]\n",
  "ANNULATED": "marked with a ring or rings [adj]\n",
  "ANNULATES": "ANNULATE, (obsolete) an annelid worm [n]\n",
  "ANNULATION": "a circular or ringlike formation [n -S]\n",
  "ANNULATIONS": "ANNULATION, a circular or ringlike formation [n]\n",
  "ANNULET": "a small ring around a classical column [n -S]\n",
  "ANNULETS": "ANNULET, a small ring around a classical column [n]\n",
  "ANNULI": "ANNULUS, (Latin) a ring or ringlike part [n]\n",
  "ANNULLABLE": "that can be annulled [adj]\n",
  "ANNULLED": "ANNUL, to declare void [v]\n",
  "ANNULLING": "ANNUL, to declare void [v]\n",
  "ANNULMENT": "the act of annulling [n -S]\n",
  "ANNULMENTS": "ANNULMENT, the act of annulling [n]\n",
  "ANNULOSE": "pertaining to a ring [adj]\n",
  "ANNULS": "ANNUL, to declare void [v]\n",
  "ANNULUS": "(Latin) a ring or ringlike part [n ANNULUSES or ANNULI]\n",
  "ANNULUSES": "ANNULUS, (Latin) a ring or ringlike part [n]\n",
  "ANNUNCIATE": "to announce, proclaim [v ANNUNCIATED, ANNUNCIATING, ANNUNCIATES]\n",
  "ANNUNCIATED": "ANNUNCIATE, to announce, proclaim [v]\n",
  "ANNUNCIATES": "ANNUNCIATE, to announce, proclaim [v]\n",
  "ANNUNCIATING": "ANNUNCIATE, to announce, proclaim [v]\n",
  "ANNUNCIATION": "a proclamation [n -S]\n",
  "ANNUNCIATIONS": "ANNUNCIATION, a proclamation [n]\n",
  "ANNUNCIATIVE": "relating to annunciation [adj]\n",
  "ANNUNCIATOR": "one who annunciates [n -S]\n",
  "ANNUNCIATORS": "ANNUNCIATOR, one who annunciates [n]\n",
  "ANNUNCIATORY": "relating to annunciation [adj]\n",
  "ANNUNTIATE": "(obsolete) to proclaim [v ANNUNTIATED, ANNUNTIATING, ANNUNTIATES]\n",
  "ANNUNTIATED": "ANNUNTIATE, (obsolete) to proclaim [v]\n",
  "ANNUNTIATES": "ANNUNTIATE, (obsolete) to proclaim [v]\n",
  "ANNUNTIATING": "ANNUNTIATE, (obsolete) to proclaim [v]\n",
  "ANOA": "a wild ox of the Celebes [n -S]\n",
  "ANOAS": "ANOA, a wild ox of the Celebes [n]\n",
  "ANOBIID": "any of a family of beetles with a hood, including the deathwatch beetle [n -S]\n",
  "ANOBIIDS": "ANOBIID, any of a family of beetles with a hood, including the deathwatch beetle [n]\n",
  "ANODAL": "relating to an anode [adj]\n",
  "ANODALLY": "ANODAL, relating to an anode [adv]\n",
  "ANODE": "a positively charged electrode [n -S]\n",
  "ANODES": "ANODE, a positively charged electrode [n]\n",
  "ANODIC": "of or like an anode [adj ANODICALLY]\n",
  "ANODICALLY": "ANODIC, of or like an anode [adv]\n",
  "ANODISATION": "the process of anodising, also ANODIZATION [n -S]\n",
  "ANODISATIONS": "ANODISATION, the process of anodising, also ANODIZATION [n]\n",
  "ANODISE": "to give a protective coat, also ANODIZE [v ANODISED, ANODISING, ANODISES]\n",
  "ANODISED": "ANODISE, to give a protective coat, also ANODIZE [v]\n",
  "ANODISER": "something that anodises, also ANODIZER [n -S]\n",
  "ANODISERS": "ANODISER, something that anodises, also ANODIZER [n]\n",
  "ANODISES": "ANODISE, to give a protective coat, also ANODIZE [v]\n",
  "ANODISING": "ANODISE, to give a protective coat, also ANODIZE [v]\n",
  "ANODIZATION": "the process of anodizing, also ANODISATION [n -S]\n",
  "ANODIZATIONS": "ANODIZATION, the process of anodizing, also ANODISATION [n]\n",
  "ANODIZE": "to give a protective coat, also ANODISE [v ANODIZED, ANODIZING, ANODIZES]\n",
  "ANODIZED": "ANODIZE, to give a protective coat, also ANODISE [v]\n",
  "ANODIZER": "something that anodises, also ANODISER [n -S]\n",
  "ANODIZERS": "ANODIZER, something that anodises, also ANODISER [n]\n",
  "ANODIZES": "ANODIZE, to give a protective coat, also ANODISE [v]\n",
  "ANODIZING": "ANODIZE, to give a protective coat, also ANODISE [v]\n",
  "ANODONTIA": "congenital absence of teeth [n -S]\n",
  "ANODONTIAS": "ANODONTIA, congenital absence of teeth [n]\n",
  "ANODYNE": "a medicine that relieves pain [n -S]\n",
  "ANODYNES": "ANODYNE, a medicine that relieves pain [n]\n",
  "ANODYNIC": "relating to an anodyne [adj]\n",
  "ANOESES": "ANOESIS, consciousness with sensation but without thought [n]\n",
  "ANOESIS": "consciousness with sensation but without thought [n ANOESES]\n",
  "ANOESTRA": "ANOESTRUM, (Greek) a period of sexual inactivity, also ANESTRUM [n]\n",
  "ANOESTRI": "ANOESTRUS, (Greek) a period of sexual dormancy, also ANESTRUS [n]\n",
  "ANOESTROUS": "relating to anoestrus, a period of sexual in activity between periods of oestrus [adj]\n",
  "ANOESTRUM": "(Greek) a period of sexual inactivity, also ANESTRUM [n ANOESTRA]\n",
  "ANOESTRUS": "(Greek) a period of sexual dormancy, also ANESTRUS [n ANOESTRI]\n",
  "ANOETIC": "of or pertaining to anoesis, consciousness with sensation but without thought [adj]\n",
  "ANOINT": "to consecrate with oil [v -ED, -ING, -S]\n",
  "ANOINTED": "ANOINT, to consecrate with oil [v]\n",
  "ANOINTER": "one who anoints [n -S]\n",
  "ANOINTERS": "ANOINTER, one who anoints [n]\n",
  "ANOINTING": "the act of consecrating with oil [n -S]\n",
  "ANOINTINGS": "ANOINTING, the act of consecrating with oil [n]\n",
  "ANOINTMENT": "the act of anointing [n -S]\n",
  "ANOINTMENTS": "ANOINTMENT, the act of anointing [n]\n",
  "ANOINTS": "ANOINT, to consecrate with oil [v]\n",
  "ANOLE": "(Caribbean) a tropical lizard of the Americas [n -S]\n",
  "ANOLES": "ANOLE, (Caribbean) a tropical lizard of the Americas [n]\n",
  "ANOLYTE": "the part of an electricity conduction solution near the anode [n -S]\n",
  "ANOLYTES": "ANOLYTE, the part of an electricity conduction solution near the anode [n]\n",
  "ANOMALIES": "ANOMALY, deviation from the rule [n]\n",
  "ANOMALISTIC": "anomalous, also ANOMALISTICAL [adj ANOMALISTICALLY]\n",
  "ANOMALISTICAL": "anomalous, also ANOMALISTIC [adj ANOMALISTICALLY]\n",
  "ANOMALISTICALLY": "ANOMALISTICAL, anomalous, also ANOMALISTIC [adv]\n",
  "ANOMALOUS": "irregular; deviating from rule [adj ANOMALOUSLY]\n",
  "ANOMALOUSLY": "ANOMALOUS, irregular; deviating from rule [adv]\n",
  "ANOMALOUSNESS": "the state of being anomalous [n -ES]\n",
  "ANOMALOUSNESSES": "ANOMALOUSNESS, the state of being anomalous [n]\n",
  "ANOMALY": "deviation from the rule [n ANOMALIES]\n",
  "ANOMIC": "pertaining to anomie, a state lacking social order and norms [adj]\n",
  "ANOMIE": "(French) hopelessness caused by a breakdown of rules, also ANOMY [n -S]\n",
  "ANOMIES": "ANOMY, (French) a condition of hopelessness caused or characterized by breakdown of rules of conduct and loss of belief and sense of purpose, also ANOMIE [n]\n",
  "ANOMY": "(French) a condition of hopelessness caused or characterized by breakdown of rules of conduct and loss of belief and sense of purpose, also ANOMIE [n ANOMIES]\n",
  "ANON": "at once; immediately, also ANAN [adj]\n",
  "ANONACEOUS": "pertaining to the order of plants including the soursop, custard apple, etc. [adj]\n",
  "ANONYM": "an anonymous person or publication [n -S]\n",
  "ANONYMA": "(obsolete) a showy woman of easy morals [n -S]\n",
  "ANONYMAS": "ANONYMA, (obsolete) a showy woman of easy morals [n]\n",
  "ANONYMISE": "to make anonymous, also ANONYMIZE [v ANONYMISED, ANONYMISING, ANONYMISES]\n",
  "ANONYMISED": "ANONYMISE, to make anonymous, also ANONYMIZE [v]\n",
  "ANONYMISES": "ANONYMISE, to make anonymous, also ANONYMIZE [v]\n",
  "ANONYMISING": "ANONYMISE, to make anonymous, also ANONYMIZE [v]\n",
  "ANONYMITIES": "ANONYMITY, the state of being anonymous [n]\n",
  "ANONYMITY": "the state of being anonymous [n ANONYMITIES]\n",
  "ANONYMIZE": "to make anonymous, also ANONYMISE [v ANONYMIZED, ANONYMIZING, ANONYMIZES]\n",
  "ANONYMIZED": "ANONYMIZE, to make anonymous, also ANONYMISE [v]\n",
  "ANONYMIZES": "ANONYMIZE, to make anonymous, also ANONYMISE [v]\n",
  "ANONYMIZING": "ANONYMIZE, to make anonymous, also ANONYMISE [v]\n",
  "ANONYMOUS": "without a name [adj ANONYMOUSLY]\n",
  "ANONYMOUSLY": "ANONYMOUS, without a name [adv]\n",
  "ANONYMOUSNESS": "the state of being anonymous [n -ES]\n",
  "ANONYMOUSNESSES": "ANONYMOUSNESS, the state of being anonymous [n]\n",
  "ANONYMS": "ANONYM, an anonymous person or publication [n]\n",
  "ANOOPSIA": "a visual defect, an upward squint [n -S]\n",
  "ANOOPSIAS": "ANOOPSIA, a visual defect, an upward squint [n]\n",
  "ANOPHELES": "(Greek) a kind of mosquito [n ANOPHELES]\n",
  "ANOPHELINE": "a mosquito of the anopheles genus [n -S]\n",
  "ANOPHELINES": "ANOPHELINE, a mosquito of the anopheles genus [n]\n",
  "ANOPIA": "a visual defect, an upward squint, also ANOOPSIA, ANOPSIA [n -S]\n",
  "ANOPIAS": "ANOPIA, a visual defect, an upward squint, also ANOOPSIA, ANOPSIA [n]\n",
  "ANOPSIA": "a visual defect, an upward squint, also ANOOPSIA, ANOPIA [n -S]\n",
  "ANOPSIAS": "ANOPSIA, a visual defect, an upward squint, also ANOOPSIA, ANOPIA [n]\n",
  "ANORAK": "(Inuit) a waterproof jacket with hood [n -S]\n",
  "ANORAKS": "ANORAK, (Inuit) a waterproof jacket with hood [n]\n",
  "ANORECTAL": "pertaining to anorexia, also ANORECTIC, ANORETIC, ANOREXIC [adj]\n",
  "ANORECTIC": "pertaining to anorexia [adj] / one suffering from anorexia, also ANORECTAL, ANORETIC, ANOREXIC [n -S]\n",
  "ANORECTICS": "ANORECTIC, one suffering from anorexia, also ANORECTAL, ANORETIC, ANOREXIC [n]\n",
  "ANORETIC": "pertaining to anorexia, also ANORECTAL [adj] / one suffering from anorexia also ANORECTIC, ANOREXIC [n -S]\n",
  "ANORETICS": "ANORETIC, one suffering from anorexia also ANORECTIC, ANOREXIC [n]\n",
  "ANOREXIA": "lack of appetite [n -S]\n",
  "ANOREXIAS": "ANOREXIA, lack of appetite [n]\n",
  "ANOREXIC": "pertaining to anorexia, also ANORECTAL [adj] / one suffering from anorexia also ANORECTIC, ANORETIC [n -S]\n",
  "ANOREXICS": "ANOREXIC, one suffering from anorexia also ANORECTIC, ANORETIC [n]\n",
  "ANOREXIES": "ANOREXY, lack of appetite, also ANOREXIA [n]\n",
  "ANOREXIGENIC": "promoting or causing anorexia [adj]\n",
  "ANOREXY": "lack of appetite, also ANOREXIA [n ANOREXIES]\n",
  "ANORTHIC": "of crystals, triclinic, referable to three unequal oblique axes [adj]\n",
  "ANORTHITE": "a plagioclase feldspar, calcium aluminium silicate [n -S]\n",
  "ANORTHITES": "ANORTHITE, a plagioclase feldspar, calcium aluminium silicate [n]\n",
  "ANORTHITIC": "of or like an anorthite [adj]\n",
  "ANORTHOSITE": "an igneous rock that consists of 90 or more percent of plagioclase feldspar, typically labradorite [n -S]\n",
  "ANORTHOSITES": "ANORTHOSITE, an igneous rock that consists of 90 or more percent of plagioclase feldspar, typically labradorite [n]\n",
  "ANORTHOSITIC": "of or like anorthosite [adj]\n",
  "ANOSMATIC": "relating to anosmia, lack or loss of sense of smell, also ANOSMIC [adj]\n",
  "ANOSMIA": "the loss of sense of smell [n -S]\n",
  "ANOSMIAS": "ANOSMIA, the loss of sense of smell [n]\n",
  "ANOSMIC": "relating to the loss of sense of smell [adj]\n",
  "ANOTHER": "one more [adj]\n",
  "ANOTHERGUESS": "(archaic) in another fashion [adv]\n",
  "ANOUGH": "enough [adj]\n",
  "ANOUROUS": "tailless, also ANUROUS [adj]\n",
  "ANOVULANT": "inhibiting ovulation [adj] / a drug that inhibits ovulation [n -S]\n",
  "ANOVULANTS": "ANOVULANT, a drug that inhibits ovulation [n]\n",
  "ANOVULAR": "not involving ovulation [adj]\n",
  "ANOVULATION": "a failure to produce eggs or to discharge them from an ovary [n -S]\n",
  "ANOVULATIONS": "ANOVULATION, a failure to produce eggs or to discharge them from an ovary [n]\n",
  "ANOVULATORY": "of a menstrual cycle, without ovulation [adj]\n",
  "ANOW": "(Milton) enough [adj]\n",
  "ANOXAEMIA": "a disorder of the blood, also ANOXEMIA [n -S]\n",
  "ANOXAEMIAS": "ANOXAEMIA, a disorder of the blood, also ANOXEMIA [n]\n",
  "ANOXAEMIC": "relating to anoxaemia, a disorder of the blood, also ANOXEMIC [adj]\n",
  "ANOXEMIA": "a disorder of the blood, also ANOXAEMIA [n -S]\n",
  "ANOXEMIAS": "ANOXEMIA, a disorder of the blood, also ANOXAEMIA [n]\n",
  "ANOXEMIC": "relating to anoxemia, a disorder of the blood, also ANOXAEMIC [adj]\n",
  "ANOXIA": "deficient supply of oxygen to the tissues [n -S]\n",
  "ANOXIAS": "ANOXIA, deficient supply of oxygen to the tissues [n]\n",
  "ANOXIC": "relation to a deficiency of oxygen to the tissues [adj]\n",
  "ANS": "as in ifs and ans, things that might have happened, but which did not [n]\n",
  "ANSA": "(Latin) the projecting part of Saturn's rings [n ANSAE]\n",
  "ANSAE": "ANSA, (Latin) the projecting part of Saturn's rings [n]\n",
  "ANSAPHONE": "another name for a telephone answering machine, also ANSWERPHONE [n -S]\n",
  "ANSAPHONES": "ANSAPHONE, another name for a telephone answering machine, also ANSWERPHONE [n]\n",
  "ANSATE": "having a handle, also ANSATED [adj]\n",
  "ANSATED": "having a handle, also ANSATE [adj]\n",
  "ANSATZ": "a possible solution to a problem [n -ES]\n",
  "ANSATZES": "ANSATZ, a possible solution to a problem [n]\n",
  "ANSERINE": "belonging to the goose family [adj] / a bird of the goose family [n -S]\n",
  "ANSERINES": "ANSERINE, a bird of the goose family [n]\n",
  "ANSEROUS": "resembling a goose; silly; simple [adj]\n",
  "ANSWER": "to say, write, or act in return [v -ED, -ING, -S]\n",
  "ANSWERABILITIES": "ANSWERABILITY, the quality of being answerable [n]\n",
  "ANSWERABILITY": "the quality of being answerable [n ANSWERABILITIES]\n",
  "ANSWERABLE": "that can be answered [adj ANSWERABLY]\n",
  "ANSWERABLENESS": "the state of being answerable [n]\n",
  "ANSWERABLY": "ANSWERABLE, that can be answered [adv]\n",
  "ANSWERED": "ANSWER, to say, write, or act in return [v]\n",
  "ANSWERER": "one that answers [n -S]\n",
  "ANSWERERS": "ANSWERER, one that answers [n]\n",
  "ANSWERING": "ANSWER, to say, write, or act in return [v]\n",
  "ANSWERLESS": "having no answer, or impossible to be answered [adj]\n",
  "ANSWERPHONE": "a device that automatically answers incoming telephone calls, also ANSAPHONE [n -S]\n",
  "ANSWERPHONES": "ANSWERPHONE, a device that automatically answers incoming telephone calls, also ANSAPHONE [n]\n",
  "ANSWERS": "ANSWER, to say, write, or act in return [v]\n",
  "ANT": "a small industrious insect [n -S]\n",
  "ANTA": "(Latin) a square pilaster on each side of a doorway [n ANTAE] / a kind of tapir [ANTAS]\n",
  "ANTACID": "a remedy for indigestion [n -S]\n",
  "ANTACIDS": "ANTACID, a remedy for indigestion [n]\n",
  "ANTAE": "ANTA, (Latin) a square pilaster on each side of a doorway [n]\n",
  "ANTAGONISABLE": "capable of being antagonised, also ANTAGONIZABLE [adj]\n",
  "ANTAGONISATION": "the process of antagonising, also ANTAGONIZATION [n -S]\n",
  "ANTAGONISATIONS": "ANTAGONISATION, the process of antagonising, also ANTAGONIZATION [n]\n",
  "ANTAGONISE": "to arouse opposition in, also ANTAGONIZE [v ANTAGONISED, ANTAGONISING, ANTAGONISES]\n",
  "ANTAGONISED": "ANTAGONISE, to arouse opposition in, also ANTAGONIZE [v]\n",
  "ANTAGONISES": "ANTAGONISE, to arouse opposition in, also ANTAGONIZE [v]\n",
  "ANTAGONISING": "ANTAGONISE, to arouse opposition in, also ANTAGONIZE [v]\n",
  "ANTAGONISM": "actively expressed opposition or hostility [n -S]\n",
  "ANTAGONISMS": "ANTAGONISM, actively expressed opposition or hostility [n]\n",
  "ANTAGONIST": "one that contends with or opposes another [n -S]\n",
  "ANTAGONISTIC": "marked by or resulting from antagonism [adj]\n",
  "ANTAGONISTS": "ANTAGONIST, one that contends with or opposes another [n]\n",
  "ANTAGONIZABLE": "capable of being antagonised, also ANTAGONISABLE [adj]\n",
  "ANTAGONIZATION": "the process of antagonizing, also ANTAGONISATION [n -S]\n",
  "ANTAGONIZATIONS": "ANTAGONIZATION, the process of antagonizing, also ANTAGONISATION [n]\n",
  "ANTAGONIZE": "to arouse opposition in, also ANTAGONISE [v ANTAGONIZED, ANTAGONIZING, ANTAGONIZES]\n",
  "ANTAGONIZED": "ANTAGONIZE, to arouse opposition in, also ANTAGONISE [v]\n",
  "ANTAGONIZES": "ANTAGONIZE, to arouse opposition in, also ANTAGONISE [v]\n",
  "ANTAGONIZING": "ANTAGONIZE, to arouse opposition in, also ANTAGONISE [v]\n",
  "ANTALGIC": "a medicine which relieves pain [n -S]\n",
  "ANTALGICS": "ANTALGIC, a medicine which relieves pain [n]\n",
  "ANTALKALI": "a substance that neutralises alkalis [n ANTALKALIS or ANTALKALIES]\n",
  "ANTALKALIES": "ANTALKALI, a substance that neutralises alkalis [n]\n",
  "ANTALKALINE": "a substance that neutralizes alkalis, esp. one used to treat alkalosis [n -S]\n",
  "ANTALKALINES": "ANTALKALINE, a substance that neutralizes alkalis, esp. one used to treat alkalosis [n]\n",
  "ANTALKALIS": "ANTALKALI, a substance that neutralises alkalis [n]\n",
  "ANTAPHRODISIAC": "a drug acting to reduce sexual desire [n -S]\n",
  "ANTAPHRODISIACS": "ANTAPHRODISIAC, a drug acting to reduce sexual desire [n]\n",
  "ANTAR": "(Shakespeare) a cave, also ANTRE [n -S]\n",
  "ANTARA": "(Quechua) a type of Andean panpipes [n -S]\n",
  "ANTARAS": "ANTARA, (Quechua) a type of Andean panpipes [n]\n",
  "ANTARCTIC": "of, near, or relating to the south pole [adj]\n",
  "ANTARS": "ANTAR, (Shakespeare) a cave, also ANTRE [n]\n",
  "ANTARTHRITIC": "used against arthritis [adj] / a drug used against arthritis [n -S]\n",
  "ANTARTHRITICS": "ANTARTHRITIC, a drug used against arthritis [n]\n",
  "ANTAS": "ANTA, (Latin) a square pilaster on each side of a doorway [n]\n",
  "ANTASTHMATIC": "an agent that counteracts asthma, also ANTIASTHMATIC [n -S]\n",
  "ANTASTHMATICS": "ANTASTHMATIC, an agent that counteracts asthma, also ANTIASTHMATIC [n]\n",
  "ANTBEAR": "the great anteater [n -S]\n",
  "ANTBEARS": "ANTBEAR, the great anteater [n]\n",
  "ANTBIRD": "any of a group of tropical birds [n -S]\n",
  "ANTBIRDS": "ANTBIRD, any of a group of tropical birds [n]\n",
  "ANTE": "to put a fixed stake in the pot at poker [v ANTEED or ANTED, ANTEING, ANTES]\n",
  "ANTEATER": "any of several mammals that feed on ants [n -S]\n",
  "ANTEATERS": "ANTEATER, any of several mammals that feed on ants [n]\n",
  "ANTEBELLUM": "relating to the period before a war, esp. the American Civil War (1861-1865) [adj]\n",
  "ANTECEDE": "to go before [v ANTECEDED, ANTECEDING, ANTECEDES]\n",
  "ANTECEDED": "ANTECEDE, to go before [v]\n",
  "ANTECEDENCE": "the state of being antecedent [n -S]\n",
  "ANTECEDENCES": "ANTECEDENCE, the state of being antecedent [n]\n",
  "ANTECEDENT": "foregoing [adj ANTECEDENTLY] / a clause whose denotation is referred to by a pronoun [n -S]\n",
  "ANTECEDENTLY": "ANTECEDENT, foregoing [adv]\n",
  "ANTECEDENTS": "ANTECEDENT, a clause whose denotation is referred to by a pronoun [n]\n",
  "ANTECEDES": "ANTECEDE, to go before [v]\n",
  "ANTECEDING": "ANTECEDE, to go before [v]\n",
  "ANTECESSOR": "one who goes before; a predecessor [n -S]\n",
  "ANTECESSORS": "ANTECESSOR, one who goes before; a predecessor [n]\n",
  "ANTECHAMBER": "a chamber or room leading to a more important apartment [n -S]\n",
  "ANTECHAMBERS": "ANTECHAMBER, a chamber or room leading to a more important apartment [n]\n",
  "ANTECHAPEL": "an anteroom to a chapel or church [n -S]\n",
  "ANTECHAPELS": "ANTECHAPEL, an anteroom to a chapel or church [n]\n",
  "ANTECHOIR": "the space in front of the choir in a church [n -S]\n",
  "ANTECHOIRS": "ANTECHOIR, the space in front of the choir in a church [n]\n",
  "ANTED": "ANTE, to put a fixed stake in the pot at poker [v]\n",
  "ANTEDATE": "to date from before [v ANTEDATED, ANTEDATING, ANTEDATES]\n",
  "ANTEDATED": "ANTEDATE, to date from before [v]\n",
  "ANTEDATES": "ANTEDATE, to date from before [v]\n",
  "ANTEDATING": "the act of dating from before [n -S]\n",
  "ANTEDATINGS": "ANTEDATING, the act of dating from before [n]\n",
  "ANTEDILUVIAL": "pertaining to the period before the Biblical flood or any great flood, also ANTEDILUVIAN [adj ANTEDILUVIALLY]\n",
  "ANTEDILUVIALLY": "ANTEDILUVIAL, pertaining to the period before the Biblical flood or any great flood, also ANTEDILUVIAN [adv]\n",
  "ANTEDILUVIAN": "pertaining to the period before the Biblical flood or any great flood, also ANTEDILUVIAL [adj] / someone or something occurring in the period before the Flood [n -S]\n",
  "ANTEDILUVIANS": "ANTEDILUVIAN, someone or something occurring in the period before the Flood [n]\n",
  "ANTEED": "ANTE, to put a fixed stake in the pot at poker [v]\n",
  "ANTEFIX": "an ornament at the end of a classical building, hiding the ends of roof tiles, also ANTEFIXA [n ANTEFIXA or ANTEFIXES]\n",
  "ANTEFIXA": "(Latin) an ornament at the end of a classical building, hiding the ends of roof tiles, also ANTEFIX [n ANTEFIXAE]\n",
  "ANTEFIXAE": "ANTEFIXA, (Latin) an ornament at the end of a classical building, hiding the ends of roof tiles, also ANTEFIX [n]\n",
  "ANTEFIXAL": "relating to an antefix, an ornament at the end of a classical building [adj]\n",
  "ANTEFIXES": "ANTEFIX, an ornament at the end of a classical building, hiding the ends of roof tiles, also ANTEFIXA [n]\n",
  "ANTEING": "ANTE, to put a fixed stake in the pot at poker [v]\n",
  "ANTELOPE": "any one of a group of hollow-horned, hoofed, ruminant mammals closely related to goats [n -S]\n",
  "ANTELOPES": "ANTELOPE, any one of a group of hollow-horned, hoofed, ruminant mammals closely related to goats [n]\n",
  "ANTELUCAN": "(archaic) pertaining to the hours before dawn [adj]\n",
  "ANTEMERIDIAN": "occurring before midday [adj]\n",
  "ANTEMORTEM": "taking place before death [adj]\n",
  "ANTEMUNDANE": "(archaic) before the creation of the world [adj]\n",
  "ANTENATAL": "before birth [adj ANTENATALLY] / an examination during pregnancy [n -S]\n",
  "ANTENATALLY": "ANTENATAL, before birth [adv]\n",
  "ANTENATALS": "ANTENATAL, an examination during pregnancy [n]\n",
  "ANTENATI": "(Latin) those born before a certain time [n]\n",
  "ANTENNA": "(Latin) a feeler in insects [n ANTENNAS or ANTENNAE]\n",
  "ANTENNAE": "ANTENNA, (Latin) a feeler in insects [n]\n",
  "ANTENNAL": "relating to an antenna [adj]\n",
  "ANTENNARY": "having antennae [adj]\n",
  "ANTENNAS": "ANTENNA, (Latin) a feeler in insects [n]\n",
  "ANTENNIFEROUS": "bearing antennae [adj]\n",
  "ANTENNIFORM": "shaped like an antenna [adj]\n",
  "ANTENNULAR": "of or like an antennule [adj]\n",
  "ANTENNULE": "one of a first or smaller pair of antennae in crustaceans [n -S]\n",
  "ANTENNULES": "ANTENNULE, one of a first or smaller pair of antennae in crustaceans [n]\n",
  "ANTENUPTIAL": "taking place before marriage [adj] / a contract made before marriage [n -S]\n",
  "ANTENUPTIALS": "ANTENUPTIAL, a contract made before marriage [n]\n",
  "ANTEORBITAL": "situated in front of the eyes [adj]\n",
  "ANTEPAST": "(obsolete) a foretaste, an appetiser [n -S]\n",
  "ANTEPASTS": "ANTEPAST, (obsolete) a foretaste, an appetiser [n]\n",
  "ANTEPENDIA": "ANTEPENDIUM, a cloth that hangs over the front of an altar, aka forecloth [n]\n",
  "ANTEPENDIUM": "a cloth that hangs over the front of an altar, aka forecloth [n ANTEPENDIA or ANTEPENDIUMS]\n",
  "ANTEPENDIUMS": "ANTEPENDIUM, a cloth that hangs over the front of an altar, aka forecloth [n]\n",
  "ANTEPENULT": "the antepenultimate (third from last) syllable or word [n -S]\n",
  "ANTEPENULTIMA": "the last syllable but one [n -S]\n",
  "ANTEPENULTIMAS": "ANTEPENULTIMA, the last syllable but one [n]\n",
  "ANTEPENULTIMATE": "before the next to the last (compare penultimate) [adj]\n",
  "ANTEPENULTS": "ANTEPENULT, the antepenultimate (third from last) syllable or word [n]\n",
  "ANTEPOSITION": "the position opposite a given part of a plant [n -S]\n",
  "ANTEPOSITIONS": "ANTEPOSITION, the position opposite a given part of a plant [n]\n",
  "ANTEPRANDIAL": "before dinner [adj]\n",
  "ANTERIOR": "in front [adj]\n",
  "ANTERIORITIES": "ANTERIORITY, the state of being anterior [n]\n",
  "ANTERIORITY": "the state of being anterior [n ANTERIORITIES]\n",
  "ANTERIORLY": "ANTERIOR, in front [adv]\n",
  "ANTEROGRADE": "as in anterograde amnesia, loss of memory for events after injury to the brain or mental trauma, with little effect on information acquired previously [adj]\n",
  "ANTEROOM": "a room before, or forming an entrance to, another; a waiting room [n -S]\n",
  "ANTEROOMS": "ANTEROOM, a room before, or forming an entrance to, another; a waiting room [n]\n",
  "ANTES": "ANTE, to put a fixed stake in the pot at poker [v]\n",
  "ANTETYPE": "something which a type or symbol represents, also ANTITYPE [n -S]\n",
  "ANTETYPES": "ANTETYPE, something which a type or symbol represents, also ANTITYPE [n]\n",
  "ANTEVERSION": "the abnormal tipping forward of a bodily organ, esp. the uterus [n -S]\n",
  "ANTEVERSIONS": "ANTEVERSION, the abnormal tipping forward of a bodily organ, esp. the uterus [n]\n",
  "ANTEVERT": "to displace a body organ forwards [v -ED, -ING, -S]\n",
  "ANTEVERTED": "ANTEVERT, to displace a body organ forwards [v]\n",
  "ANTEVERTING": "ANTEVERT, to displace a body organ forwards [v]\n",
  "ANTEVERTS": "ANTEVERT, to displace a body organ forwards [v]\n",
  "ANTHELIA": "ANTHELION, (Greek) a ring seen opposite the sun [n]\n",
  "ANTHELICES": "ANTHELIX, (Greek) the inner curved edge of the external ear [n]\n",
  "ANTHELION": "(Greek) a ring seen opposite the sun [n ANTHELIA]\n",
  "ANTHELIONS": "ANTHELION, (Greek) a ring seen opposite the sun [n]\n",
  "ANTHELIX": "(Greek) the inner curved edge of the external ear [n ANTHELIXES or ANTHELICES]\n",
  "ANTHELIXES": "ANTHELIX, (Greek) the inner curved edge of the external ear [n]\n",
  "ANTHELMINTHIC": "destroying or expelling worms [adj] / a drug used against intestinal worms, also ANTHELMINTIC [n -S]\n",
  "ANTHELMINTHICS": "ANTHELMINTHIC, a drug used against intestinal worms, also ANTHELMINTIC [n]\n",
  "ANTHELMINTIC": "destroying or expelling worms [adj] / a drug used against intestinal worms, also ANTHELMINTHIC [n -S]\n",
  "ANTHELMINTICS": "ANTHELMINTIC, a drug used against intestinal worms, also ANTHELMINTHIC [n]\n",
  "ANTHEM": "a song of praise or gladness [n -S] / to praise in a national song [v -ED, -ING, -S]\n",
  "ANTHEMED": "ANTHEM, to praise in a national song [v]\n",
  "ANTHEMIA": "ANTHEMION, (Greek) a flat cluster of leaves or flowers as an ornament in classical art [n]\n",
  "ANTHEMIC": "of rock music, having a strongly stirring beat [adj]\n",
  "ANTHEMING": "ANTHEM, to praise in a national song [v]\n",
  "ANTHEMION": "(Greek) a flat cluster of leaves or flowers as an ornament in classical art [n ANTHEMIA]\n",
  "ANTHEMIS": "a genus of aromatic herbs of the family native to the Mediterranean region and SW Asia [n -ES]\n",
  "ANTHEMISES": "ANTHEMIS, a genus of aromatic herbs of the family native to the Mediterranean region and SW Asia [n]\n",
  "ANTHEMS": "ANTHEM, to praise in a national song [v]\n",
  "ANTHEMWISE": "in the manner of an antiphonal anthem [adv]\n",
  "ANTHER": "the part of the stamen that produces pollen [n -S]\n",
  "ANTHERAL": "relating to the pollen producing part of the stamen [adj]\n",
  "ANTHERID": "the male reproductive organ of some plants [n -S]\n",
  "ANTHERIDIA": "ANTHERIDIUM, the male reproductive organ of some plants, also ANTHERID [n]\n",
  "ANTHERIDIAL": "relating to an antheridium, the organ on a gametophyte plant which produces the sperm cells [adj]\n",
  "ANTHERIDIUM": "the male reproductive organ of some plants, also ANTHERID [n ANTHERIDIA]\n",
  "ANTHERIDS": "ANTHERID, the male reproductive organ of some plants [n]\n",
  "ANTHEROZOID": "a motile male gamete produced in an antheridium, also ANTHEROZOOID [n -S]\n",
  "ANTHEROZOIDS": "ANTHEROZOID, a motile male gamete produced in an antheridium, also ANTHEROZOOID [n]\n",
  "ANTHEROZOOID": "a motile male gamete produced in an antheridium, also ANTHEROZOID [n -S]\n",
  "ANTHEROZOOIDS": "ANTHEROZOOID, a motile male gamete produced in an antheridium, also ANTHEROZOID [n]\n",
  "ANTHERS": "ANTHER, the part of the stamen that produces pollen [n]\n",
  "ANTHERSMUT": "a fungus causing a disease affecting plants of the carnation and pink family [n -S]\n",
  "ANTHERSMUTS": "ANTHERSMUT, a fungus causing a disease affecting plants of the carnation and pink family [n]\n",
  "ANTHESES": "ANTHESIS, (Greek) a fully opened flower [n]\n",
  "ANTHESIS": "(Greek) a fully opened flower [n ANTHESES]\n",
  "ANTHILL": "a mound raised by ants as a nest [n -S]\n",
  "ANTHILLS": "ANTHILL, a mound raised by ants as a nest [n]\n",
  "ANTHOCARP": "a fruit resulting from many flowers, such as a pineapple [n -S]\n",
  "ANTHOCARPOUS": "of or like an anthocarp, a fruit resulting from many flowers, such as a pineapple [adj]\n",
  "ANTHOCARPS": "ANTHOCARP, a fruit resulting from many flowers, such as a pineapple [n]\n",
  "ANTHOCHLORE": "a yellow pigment in flowers [n -S]\n",
  "ANTHOCHLORES": "ANTHOCHLORE, a yellow pigment in flowers [n]\n",
  "ANTHOCYAN": "a glucoside plant pigment, violet in neutral, red in acid, blue in alkaline cell-sap, also ANTHOCYANIN [n -S]\n",
  "ANTHOCYANIN": "a glucoside plant pigment, violet in neutral, red in acid, blue in alkaline cell-sap, also ANTHOCYAN [n -S]\n",
  "ANTHOCYANINS": "ANTHOCYANIN, a glucoside plant pigment, violet in neutral, red in acid, blue in alkaline cell-sap, also ANTHOCYAN [n]\n",
  "ANTHOCYANS": "ANTHOCYAN, a glucoside plant pigment, violet in neutral, red in acid, blue in alkaline cell-sap, also ANTHOCYANIN [n]\n",
  "ANTHODIA": "ANTHODIUM, the flower head of certain plants [n]\n",
  "ANTHODIUM": "the flower head of certain plants [n ANTHODIA]\n",
  "ANTHOID": "flowerlike [adj]\n",
  "ANTHOLOGICAL": "of or like an anthology [adj]\n",
  "ANTHOLOGIES": "ANTHOLOGY, a choice collection of writings [n]\n",
  "ANTHOLOGISE": "to make an anthology, also ANTHOLOGIZE [v ANTHOLOGISED, ANTHOLOGISING, ANTHOLOGISES]\n",
  "ANTHOLOGISED": "ANTHOLOGISE, to make an anthology, also ANTHOLOGIZE [v]\n",
  "ANTHOLOGISER": "one who makes an anthology, also ANTHOLOGIZER [n -S]\n",
  "ANTHOLOGISERS": "ANTHOLOGISER, one who makes an anthology, also ANTHOLOGIZER [n]\n",
  "ANTHOLOGISES": "ANTHOLOGISE, to make an anthology, also ANTHOLOGIZE [v]\n",
  "ANTHOLOGISING": "ANTHOLOGISE, to make an anthology, also ANTHOLOGIZE [v]\n",
  "ANTHOLOGIST": "a compiler of an anthology [n -S]\n",
  "ANTHOLOGISTS": "ANTHOLOGIST, a compiler of an anthology [n]\n",
  "ANTHOLOGIZE": "to make an anthology, also ANTHOLOGISE [v ANTHOLOGIZED, ANTHOLOGIZING, ANTHOLOGIZES]\n",
  "ANTHOLOGIZED": "ANTHOLOGIZE, to make an anthology, also ANTHOLOGISE [v]\n",
  "ANTHOLOGIZER": "one who makes an anthology, also ANTHOLOGISER [n -S]\n",
  "ANTHOLOGIZERS": "ANTHOLOGIZER, one who makes an anthology, also ANTHOLOGISER [n]\n",
  "ANTHOLOGIZES": "ANTHOLOGIZE, to make an anthology, also ANTHOLOGISE [v]\n",
  "ANTHOLOGIZING": "ANTHOLOGIZE, to make an anthology, also ANTHOLOGISE [v]\n",
  "ANTHOLOGY": "a choice collection of writings [n ANTHOLOGIES]\n",
  "ANTHOMANIA": "an obsession with flowers [n -S]\n",
  "ANTHOMANIAC": "one suffering from anthomania, an obsession with flowers [n -S]\n",
  "ANTHOMANIACS": "ANTHOMANIAC, one suffering from anthomania, an obsession with flowers [n]\n",
  "ANTHOMANIAS": "ANTHOMANIA, an obsession with flowers [n]\n",
  "ANTHOPHILOUS": "feeding upon or living among flowers e.g. the anthophilous parrots of Tasmania [adj]\n",
  "ANTHOPHORE": "the stipe when developed into an internode between calyx and corolla, as in the Pink family [n -S]\n",
  "ANTHOPHORES": "ANTHOPHORE, the stipe when developed into an internode between calyx and corolla, as in the Pink family [n]\n",
  "ANTHOPHYLLITE": "an orthorhombic ferromagnesian amphibole which occurs usually as fibrous or asbestiform masses [n -S]\n",
  "ANTHOPHYLLITES": "ANTHOPHYLLITE, an orthorhombic ferromagnesian amphibole which occurs usually as fibrous or asbestiform masses [n]\n",
  "ANTHOTAXIES": "ANTHOTAXY, the arrangement of flowers on a stem or parts on a flower [n]\n",
  "ANTHOTAXY": "the arrangement of flowers on a stem or parts on a flower [n ANTHOTAXIES]\n",
  "ANTHOXANTHIN": "a yellow pigment in plants [n -S]\n",
  "ANTHOXANTHINS": "ANTHOXANTHIN, a yellow pigment in plants [n]\n",
  "ANTHOZOAN": "any animal of the class Anthozoa of marine coelenterates, which includes sea anemones, corals, and sea-pens [n -S]\n",
  "ANTHOZOANS": "ANTHOZOAN, any animal of the class Anthozoa of marine coelenterates, which includes sea anemones, corals, and sea-pens [n]\n",
  "ANTHOZOIC": "of or like an anthozoan, any animal of the class Anthozoa of marine coelenterates [adj]\n",
  "ANTHRACENE": "a tricyclic aromatic hydrocarbon, found in coal tar and isolated as colourless crystals [n -S]\n",
  "ANTHRACENES": "ANTHRACENE, a tricyclic aromatic hydrocarbon, found in coal tar and isolated as colourless crystals [n]\n",
  "ANTHRACES": "ANTHRAX, a deadly disease of sheep or cattle [n]\n",
  "ANTHRACIC": "of or relating to anthrax; as, anthracic blood [adj]\n",
  "ANTHRACITE": "a kind of hard coal [n -S]\n",
  "ANTHRACITES": "ANTHRACITE, a kind of hard coal [n]\n",
  "ANTHRACITIC": "of or like anthracite [adj]\n",
  "ANTHRACNOSE": "any of several plant diseases caused by a fungus and characterized by the appearance of dark, sunken spots [n -S]\n",
  "ANTHRACNOSES": "ANTHRACNOSE, any of several plant diseases caused by a fungus and characterized by the appearance of dark, sunken spots [n]\n",
  "ANTHRACOID": "resembling anthrax; resembling carbon, coal or charcoal [adj]\n",
  "ANTHRACOSES": "ANTHRACOSIS, a diseased state of the lung due to breathing in coal dust [n]\n",
  "ANTHRACOSIS": "a diseased state of the lung due to breathing in coal dust [n ANTHRACOSES]\n",
  "ANTHRACYCLINE": "any of a class of antineoplastic drugs (as doxorubicin) derived from an actinomycete of the genus Streptomyces [n -S]\n",
  "ANTHRACYCLINES": "ANTHRACYCLINE, any of a class of antineoplastic drugs (as doxorubicin) derived from an actinomycete of the genus Streptomyces [n]\n",
  "ANTHRANILATE": "a salt or ester of anthranilic acid [n -S]\n",
  "ANTHRANILATES": "ANTHRANILATE, a salt or ester of anthranilic acid [n]\n",
  "ANTHRANILIC": "as in anthranilic acid, an aromatic acid [adj]\n",
  "ANTHRAQUINONE": "a chemical used in the manufacture of some dyes [n -S]\n",
  "ANTHRAQUINONES": "ANTHRAQUINONE, a chemical used in the manufacture of some dyes [n]\n",
  "ANTHRAX": "a deadly disease of sheep or cattle [n ANTHRAXES or ANTHRACES]\n",
  "ANTHRAXES": "ANTHRAX, a deadly disease of sheep or cattle [n]\n",
  "ANTHRO": "(short for) anthropology [n -S]\n",
  "ANTHROPIC": "of or relating to human beings or the period of their existence on earth, also ANTHROPICAL [adj]\n",
  "ANTHROPICAL": "of or relating to human beings or the period of their existence on earth, also ANTHROPIC [adj]\n",
  "ANTHROPOBIOLOGY": "the study of human biology [n]\n",
  "ANTHROPOCENTRIC": "considering human beings as the most significant entity of the universe [adj]\n",
  "ANTHROPOGENESES": "ANTHROPOGENESIS, the study of the origins of human beings, also ANTHROPOGONY [n]\n",
  "ANTHROPOGENESIS": "the study of the origins of human beings, also ANTHROPOGONY [n ANTHROPOGENESES]\n",
  "ANTHROPOGENETIC": "relating to anthropogenesis, the study of the origins of human beings [adj]\n",
  "ANTHROPOGENIC": "pertaining to anthropogeny, the study of human generation or evolution [adj]\n",
  "ANTHROPOGENIES": "ANTHROPOGENY, the study of human generation or evolution [n]\n",
  "ANTHROPOGENY": "the study of human generation or evolution [n ANTHROPOGENIES]\n",
  "ANTHROPOGONIES": "ANTHROPOGONY, the study of the origins of human beings, also ANTHROPOGENESIS [n]\n",
  "ANTHROPOGONY": "the study of the origins of human beings, also ANTHROPOGENESIS [n ANTHROPOGONIES]\n",
  "ANTHROPOGRAPHY": "the study of the geographical distribution of human races [n]\n",
  "ANTHROPOID": "any of a suborder of higher primates [n -S]\n",
  "ANTHROPOIDAL": "like an anthropoid [adj]\n",
  "ANTHROPOIDS": "ANTHROPOID, any of a suborder of higher primates [n]\n",
  "ANTHROPOLATRIES": "ANTHROPOLATRY, the worship of human beings [n]\n",
  "ANTHROPOLATRY": "the worship of human beings [n ANTHROPOLATRIES]\n",
  "ANTHROPOLOGICAL": "relating to anthropology, the science of human beings [adj]\n",
  "ANTHROPOLOGIES": "ANTHROPOLOGY, the science of human beings [n]\n",
  "ANTHROPOLOGIST": "one who studies anthropology [n -S]\n",
  "ANTHROPOLOGISTS": "ANTHROPOLOGIST, one who studies anthropology [n]\n",
  "ANTHROPOLOGY": "the science of human beings [n ANTHROPOLOGIES]\n",
  "ANTHROPOMETRIC": "relating to anthropometry [adj]\n",
  "ANTHROPOMETRIES": "ANTHROPOMETRY, the measurement of parts and functions of human body, esp. as part of study of evolution [n]\n",
  "ANTHROPOMETRIST": "one who engages in the comparative study of sizes and proportions of the human body [n]\n",
  "ANTHROPOMETRY": "the measurement of parts and functions of human body, esp. as part of study of evolution [n ANTHROPOMETRIES]\n",
  "ANTHROPOMORPH": "a stylized human figure [n -S]\n",
  "ANTHROPOMORPHIC": "described or thought of as having a human form or human attributes [adj]\n",
  "ANTHROPOMORPHS": "ANTHROPOMORPH, a stylized human figure [n]\n",
  "ANTHROPOPATHIC": "relating to anthropopathy, the ascription of human feelings to inanimate object [adj]\n",
  "ANTHROPOPATHIES": "ANTHROPOPATHY, the ascription of human feelings to inanimate object [n]\n",
  "ANTHROPOPATHISM": "the ascription of human feelings to something not human [n]\n",
  "ANTHROPOPATHY": "the ascription of human feelings to inanimate object [n ANTHROPOPATHIES]\n",
  "ANTHROPOPHAGI": "ANTHROPOPHAGUS, a cannibal; a man-eater [n]\n",
  "ANTHROPOPHAGIC": "like an anthropophagus [adj]\n",
  "ANTHROPOPHAGIES": "ANTHROPOPHAGY, cannibalism [n]\n",
  "ANTHROPOPHAGITE": "an anthropophagus, a cannibal [n]\n",
  "ANTHROPOPHAGOUS": "eating humans [adj]\n",
  "ANTHROPOPHAGUS": "a cannibal; a man-eater [n ANTHROPOPHAGI]\n",
  "ANTHROPOPHAGY": "cannibalism [n ANTHROPOPHAGIES]\n",
  "ANTHROPOPHOBIA": "fear of humans [n -S]\n",
  "ANTHROPOPHOBIAS": "ANTHROPOPHOBIA, fear of humans [n]\n",
  "ANTHROPOPHOBIC": "someone having a fear of humans [n -S]\n",
  "ANTHROPOPHOBICS": "ANTHROPOPHOBIC, someone having a fear of humans [n]\n",
  "ANTHROPOPHUISM": "the ascription of human nature to God or to the gods [n -S]\n",
  "ANTHROPOPHUISMS": "ANTHROPOPHUISM, the ascription of human nature to God or to the gods [n]\n",
  "ANTHROPOPHYTE": "a plant introduced incidentally in the course of cultivation [n -S]\n",
  "ANTHROPOPHYTES": "ANTHROPOPHYTE, a plant introduced incidentally in the course of cultivation [n]\n",
  "ANTHROPOPSYCHIC": "ascribing to nature or God of a soul or mind like man's [adj]\n",
  "ANTHROPOSOPHIC": "related to anthroposophy, knowledge of the nature of humanity [adj]\n",
  "ANTHROPOSOPHIES": "ANTHROPOSOPHY, knowledge of the nature of humanity; human wisdom [n]\n",
  "ANTHROPOSOPHIST": "one versed in anthroposophy, knowledge of the nature of humanity [n]\n",
  "ANTHROPOSOPHY": "knowledge of the nature of humanity; human wisdom [n ANTHROPOSOPHIES]\n",
  "ANTHROPOTOMIES": "ANTHROPOTOMY, human anatomy [n]\n",
  "ANTHROPOTOMY": "human anatomy [n ANTHROPOTOMIES]\n",
  "ANTHROS": "ANTHRO, (short for) anthropology [n]\n",
  "ANTHURIUM": "a tropical American plant [n -S]\n",
  "ANTHURIUMS": "ANTHURIUM, a tropical American plant [n]\n",
  "ANTI": "one who is opposed to anything [n -S]\n",
  "ANTIABORTION": "opposed to abortion [adj]\n",
  "ANTIABORTIONIST": "one who is antiabortion [n]\n",
  "ANTIABUSE": "designed to prevent abuse [adj]\n",
  "ANTIACADEMIC": "opposed to things academic [adj]\n",
  "ANTIACNE": "acting to clear up acne [adj]\n",
  "ANTIADITIS": "tonsillitis [n -ES]\n",
  "ANTIADITISES": "ANTIADITIS, tonsillitis [n]\n",
  "ANTIAGGRESSION": "opposed to aggression [adj]\n",
  "ANTIAGING": "designed to prevent ageing [adj]\n",
  "ANTIAIR": "directed against attacking aircraft [adj]\n",
  "ANTIAIRCRAFT": "antiaircraft guns or their fire [n -S]\n",
  "ANTIAIRCRAFTS": "ANTIAIRCRAFT, antiaircraft guns or their fire [n]\n",
  "ANTIALCOHOL": "against alcohol [adj]\n",
  "ANTIALCOHOLISM": "the doctrine of being opposed to alcoholism [n -S]\n",
  "ANTIALCOHOLISMS": "ANTIALCOHOLISM, the doctrine of being opposed to alcoholism [n]\n",
  "ANTIALIEN": "opposed to foreigners [adj]\n",
  "ANTIALLERGENIC": "denoting a herbal medicine that can reduce or relieve allergic reactions [adj]\n",
  "ANTIANDROGEN": "a substance that tends to inhibit the production, activity, or effects of a male sex hormone [n -S]\n",
  "ANTIANDROGENS": "ANTIANDROGEN, a substance that tends to inhibit the production, activity, or effects of a male sex hormone [n]\n",
  "ANTIANEMIA": "designed to prevent anaemia [adj]\n",
  "ANTIANXIETY": "designed to alleviate anxiety [adj]\n",
  "ANTIAPARTHEID": "opposed to apartheid [adj]\n",
  "ANTIAPHRODISIAC": "serving to reduce sexual desire [adj]\n",
  "ANTIAR": "(Javanese) the upas tree [n -S]\n",
  "ANTIARIN": "a poisonous principle obtained from antiar, used on arrows [n -S]\n",
  "ANTIARINS": "ANTIARIN, a poisonous principle obtained from antiar, used on arrows [n]\n",
  "ANTIARMOR": "designed or equipped to combat armored vehicles, also ANTIARMOUR [adj]\n",
  "ANTIARMOUR": "designed or equipped to combat armoured vehicles, also ANTIARMOR [adj]\n",
  "ANTIARRHYTHMIC": "tending to prevent or relieve cardiac arrhythmia [adj] / a drug to prevent cardiac arrhythmia [n -S]\n",
  "ANTIARRHYTHMICS": "ANTIARRHYTHMIC, a drug to prevent cardiac arrhythmia [n]\n",
  "ANTIARS": "ANTIAR, (Javanese) the upas tree [n]\n",
  "ANTIARTHRITIC": "a drug used to counter arthritis [n -S]\n",
  "ANTIARTHRITICS": "ANTIARTHRITIC, a drug used to counter arthritis [n]\n",
  "ANTIARTHRITIS": "designed to prevent arthritis [adj]\n",
  "ANTIASTHMA": "designed to prevent asthma [adj]\n",
  "ANTIASTHMATIC": "a drug used to counter asthma, also ANTASTHMATIC [n -S]\n",
  "ANTIASTHMATICS": "ANTIASTHMATIC, a drug used to counter asthma, also ANTASTHMATIC [n]\n",
  "ANTIATOM": "an atom comprised of antiparticles [n -S]\n",
  "ANTIATOMS": "ANTIATOM, an atom comprised of antiparticles [n]\n",
  "ANTIAUTHORITY": "opposed to authority [adj]\n",
  "ANTIAUXIN": "a plant substance that opposes or represses the effects of an auxin, a growth hormone [n -S]\n",
  "ANTIAUXINS": "ANTIAUXIN, a plant substance that opposes or represses the effects of an auxin, a growth hormone [n]\n",
  "ANTIBACCHII": "ANTIBACCHIUS, (Latin) a foot of two long (or stressed) syllables followed by a short (or unstressed) one [n]\n",
  "ANTIBACCHIUS": "(Latin) a foot of two long (or stressed) syllables followed by a short (or unstressed) one [n ANTIBACCHII]\n",
  "ANTIBACKLASH": "arising in opposition to a backlash [adj]\n",
  "ANTIBACTERIAL": "a substance used to kill bacteria [n -S]\n",
  "ANTIBACTERIALS": "ANTIBACTERIAL, a substance used to kill bacteria [n]\n",
  "ANTIBALLISTIC": "of a missile, etc., designed to destroy a ballistic missile [adj]\n",
  "ANTIBARBARUS": "a list of words and sayings to be avoided in the classical usage of a language [n -ES]\n",
  "ANTIBARBARUSES": "ANTIBARBARUS, a list of words and sayings to be avoided in the classical usage of a language [n]\n",
  "ANTIBARYON": "an antiparticle to the baryon [n -S]\n",
  "ANTIBARYONS": "ANTIBARYON, an antiparticle to the baryon [n]\n",
  "ANTIBIAS": "opposed to bias [adj]\n",
  "ANTIBILIOUS": "intending to cure biliousness [adj]\n",
  "ANTIBILLBOARD": "opposed to the use of billboards [adj]\n",
  "ANTIBIOSES": "ANTIBIOSIS, a state of mutual antagonism between associated organisms [n]\n",
  "ANTIBIOSIS": "a state of mutual antagonism between associated organisms [n ANTIBIOSES]\n",
  "ANTIBIOTIC": "inhibiting to life [adj ANTIBIOTICALLY] / a substance derived from a microorganism and able in dilute solution to inhibit or kill another microorganism [n -S]\n",
  "ANTIBIOTICALLY": "ANTIBIOTIC, inhibiting to life [adv]\n",
  "ANTIBIOTICS": "ANTIBIOTIC, a substance derived from a microorganism and able in dilute solution to inhibit or kill another microorganism [n]\n",
  "ANTIBLACK": "against black people [adj]\n",
  "ANTIBLACKISM": "prejudice against black people [n -S]\n",
  "ANTIBLACKISMS": "ANTIBLACKISM, prejudice against black people [n]\n",
  "ANTIBODIES": "ANTIBODY, a body substance that produces immunity against toxins [n]\n",
  "ANTIBODY": "a body substance that produces immunity against toxins [n ANTIBODIES]\n",
  "ANTIBOSS": "opposed to bosses [adj]\n",
  "ANTIBOURGEOIS": "opposed to the bourgeois [adj]\n",
  "ANTIBOYCOTT": "opposed to boycott [adj]\n",
  "ANTIBUG": "effective against bugs [adj]\n",
  "ANTIBURGLAR": "intended to prevent burglary [adj]\n",
  "ANTIBURGLARY": "designed to prevent burglary [adj]\n",
  "ANTIBUSER": "a person who opposes the busing of children to faraway schools to achieve racial balance [n -S]\n",
  "ANTIBUSERS": "ANTIBUSER, a person who opposes the busing of children to faraway schools to achieve racial balance [n]\n",
  "ANTIBUSINESS": "opposed to business [adj]\n",
  "ANTIBUSING": "opposed to the busing of schoolchildren [adj]\n",
  "ANTIC": "quaint, also ANTICK [adj ANTICLY or ANTICALLY] / to act in a clownish manner [v ANTICKED, ANTICKING, ANTICS]\n",
  "ANTICAKING": "of a food additive, intended to stop a powdered product from forming solid lumps [adj]\n",
  "ANTICAL": "above or in front of another plant part, anterior [adj ANTICALLY]\n",
  "ANTICALLY": "ANTICAL, above or in front of another plant part, anterior [adv]\n",
  "ANTICANCER": "of a drug, designed to prevent cancer [adj]\n",
  "ANTICAPITALISM": "opposition to capitalism [n -S]\n",
  "ANTICAPITALISMS": "ANTICAPITALISM, opposition to capitalism [n]\n",
  "ANTICAPITALIST": "one opposed to capitalism [n -S]\n",
  "ANTICAPITALISTS": "ANTICAPITALIST, one opposed to capitalism [n]\n",
  "ANTICAR": "opposed to cars [adj]\n",
  "ANTICARCINOGEN": "a substance designed to counter the effect of carcinogens [n -S]\n",
  "ANTICARCINOGENS": "ANTICARCINOGEN, a substance designed to counter the effect of carcinogens [n]\n",
  "ANTICARIES": "designed to prevent tooth decay [adj]\n",
  "ANTICATALYST": "a substance that destroys or diminishes the activity of a catalyst [n -S]\n",
  "ANTICATALYSTS": "ANTICATALYST, a substance that destroys or diminishes the activity of a catalyst [n]\n",
  "ANTICATHODE": "the target of an X-ray tube, on which the cathode rays are focused and from which X-rays are emitted [n -S]\n",
  "ANTICATHODES": "ANTICATHODE, the target of an X-ray tube, on which the cathode rays are focused and from which X-rays are emitted [n]\n",
  "ANTICATHOLIC": "opposed to the Catholic church [adj]\n",
  "ANTICELLULITE": "designed to reduce cellulite [adj]\n",
  "ANTICENSORSHIP": "opposed to censorship [adj]\n",
  "ANTICHLOR": "any substance used in removing the excess of chlorine left in paper pulp or stuffs after bleaching [n -S]\n",
  "ANTICHLORISTIC": "of or like antichlor [adj]\n",
  "ANTICHLORS": "ANTICHLOR, any substance used in removing the excess of chlorine left in paper pulp or stuffs after bleaching [n]\n",
  "ANTICHOICE": "opposed to abortion [adj]\n",
  "ANTICHOICER": "one opposed to choice, especially in the matter of abortion [n -S]\n",
  "ANTICHOICERS": "ANTICHOICER, one opposed to choice, especially in the matter of abortion [n]\n",
  "ANTICHOLESTEROL": "countering the effects of cholesterol [adj]\n",
  "ANTICHOLINERGIC": "blocking nerve impulses, in order to control intestinal spasms [adj]\n",
  "ANTICHRIST": "an enemy of Christ or Christianity [n -S]\n",
  "ANTICHRISTIAN": "opposed to Christianity [adj ANTICHRISTIANLY]\n",
  "ANTICHRISTIANLY": "ANTICHRISTIAN, opposed to Christianity [adv]\n",
  "ANTICHRISTS": "ANTICHRIST, an enemy of Christ or Christianity [n]\n",
  "ANTICHTHONES": "the antipodeans [n]\n",
  "ANTICHURCH": "opposed to the church [adj]\n",
  "ANTICIGARETTE": "opposed to the use of cigarettes [adj]\n",
  "ANTICIPANT": "anticipating; expectant [adj] / one who anticipates [n -S]\n",
  "ANTICIPANTS": "ANTICIPANT, one who anticipates [n]\n",
  "ANTICIPATABLE": "capable of being anticipated [adj]\n",
  "ANTICIPATE": "to expect, look forward to [v ANTICIPATED, ANTICIPATING, ANTICIPATES]\n",
  "ANTICIPATED": "ANTICIPATE, to expect, look forward to [v]\n",
  "ANTICIPATES": "ANTICIPATE, to expect, look forward to [v]\n",
  "ANTICIPATING": "ANTICIPATE, to expect, look forward to [v]\n",
  "ANTICIPATION": "a prior action that takes into account or forestalls a later action [n -S]\n",
  "ANTICIPATIONS": "ANTICIPATION, a prior action that takes into account or forestalls a later action [n]\n",
  "ANTICIPATIVE": "of anticipation [adj ANTICIPATIVELY]\n",
  "ANTICIPATIVELY": "ANTICIPATIVE, of anticipation [adv]\n",
  "ANTICIPATOR": "one who anticipates [n -S]\n",
  "ANTICIPATORILY": "ANTICIPATORY, in anticipation [adv]\n",
  "ANTICIPATORS": "ANTICIPATOR, one who anticipates [n]\n",
  "ANTICIPATORY": "in anticipation [adj ANTICIPATORILY]\n",
  "ANTICISE": "to play antics, also ANTICIZE [v ANTICISED, ANTICISING, ANTICISES]\n",
  "ANTICISED": "ANTICISE, to play antics, also ANTICIZE [v]\n",
  "ANTICISES": "ANTICISE, to play antics, also ANTICIZE [v]\n",
  "ANTICISING": "ANTICISE, to play antics, also ANTICIZE [v]\n",
  "ANTICITY": "opposed to cities [adj]\n",
  "ANTICIVIC": "opposed to citizenship [adj]\n",
  "ANTICIVISM": "opposition to the body politic of citizens [n -S]\n",
  "ANTICIVISMS": "ANTICIVISM, opposition to the body politic of citizens [n]\n",
  "ANTICIZE": "to play antics, also ANTICISE [v ANTICIZED, ANTICIZING, ANTICIZES]\n",
  "ANTICIZED": "ANTICIZE, to play antics, also ANTICISE [v]\n",
  "ANTICIZES": "ANTICIZE, to play antics, also ANTICISE [v]\n",
  "ANTICIZING": "ANTICIZE, to play antics, also ANTICISE [v]\n",
  "ANTICK": "(obsolete) an antic, also ANTIC [n -S]\n",
  "ANTICKE": "(obsolete) antique [adj] / an antic, also ANTICK [n -S]\n",
  "ANTICKED": "ANTIC, to act in a clownish manner [v]\n",
  "ANTICKES": "ANTICKE, an antic, also ANTICK [n]\n",
  "ANTICKING": "ANTIC, to act in a clownish manner [v]\n",
  "ANTICKS": "ANTICK, (obsolete) an antic, also ANTIC [n]\n",
  "ANTICLASSICAL": "opposed to the classical [adj]\n",
  "ANTICLASTIC": "of a surface, having a curvature, at a given point and in a particular direction, that is of the opposite sign to the curvature at that point in a perpendicular direction [adj]\n",
  "ANTICLERICAL": "one opposed to clericalism or to the interference or influence of the clergy in secular affairs [n -S]\n",
  "ANTICLERICALISM": "the state of being anticlerical [n]\n",
  "ANTICLERICALS": "ANTICLERICAL, one opposed to clericalism or to the interference or influence of the clergy in secular affairs [n]\n",
  "ANTICLIMACTIC": "of, relating to, or marked by anticlimax, also ANTICLIMACTICAL [adj]\n",
  "ANTICLIMACTICAL": "of, relating to, or marked by anticlimax, also ANTICLIMACTIC [adj]\n",
  "ANTICLIMAX": "the usually sudden transition in discourse from a significant idea to a trivial or ludicrous idea [n -ES]\n",
  "ANTICLIMAXES": "ANTICLIMAX, the usually sudden transition in discourse from a significant idea to a trivial or ludicrous idea [n]\n",
  "ANTICLINAL": "of or like an anticline [adj] / an anticlinal fold, axis, crest, or line; a line whence strata dip in opposite directions [n -S]\n",
  "ANTICLINALS": "ANTICLINAL, an anticlinal fold, axis, crest, or line; a line whence strata dip in opposite directions [n]\n",
  "ANTICLINE": "a fold that is convex upward, or that had such an attitude at some stage of its development [n -S]\n",
  "ANTICLINES": "ANTICLINE, a fold that is convex upward, or that had such an attitude at some stage of its development [n]\n",
  "ANTICLING": "designed to prevent clinging e.g. of fabrics [adj]\n",
  "ANTICLINORIA": "ANTICLINORIUM, an arch-shaped group of anticlines and synclines [n]\n",
  "ANTICLINORIUM": "an arch-shaped group of anticlines and synclines [n ANTICLINORIA]\n",
  "ANTICLOCKWISE": "in the opposite direction to clockwise [adv]\n",
  "ANTICLOTTING": "serving to prevent clots [adj]\n",
  "ANTICLY": "ANTIC, quaint, also ANTICK [adv]\n",
  "ANTICOAGULANT": "a substance that hinders the clotting of blood [n -S]\n",
  "ANTICOAGULANTS": "ANTICOAGULANT, a substance that hinders the clotting of blood [n]\n",
  "ANTICODON": "a triplet of nucleotide bases in transfer RNA [n -S]\n",
  "ANTICODONS": "ANTICODON, a triplet of nucleotide bases in transfer RNA [n]\n",
  "ANTICOINCIDENCE": "of or relating to an electronic circuit that produces an output pulse if one but not both of its input terminals receives a pulse within a specified interval of time [adj]\n",
  "ANTICOLD": "effective against the common cold [adj]\n",
  "ANTICOLLISION": "designed to prevent collisions [adj]\n",
  "ANTICOLONIAL": "one opposed to the colonial system [n -S]\n",
  "ANTICOLONIALISM": "opposition to colonialism [n]\n",
  "ANTICOLONIALIST": "one opposed to the colonial system [n]\n",
  "ANTICOLONIALS": "ANTICOLONIAL, one opposed to the colonial system [n]\n",
  "ANTICOMMERCIAL": "opposed to the commercial [adj]\n",
  "ANTICOMMUNISM": "opposition to communism [n -S]\n",
  "ANTICOMMUNISMS": "ANTICOMMUNISM, opposition to communism [n]\n",
  "ANTICOMMUNIST": "one opposed to communism [n -S]\n",
  "ANTICOMMUNISTS": "ANTICOMMUNIST, one opposed to communism [n]\n",
  "ANTICOMPETITIVE": "tending to reduce or discourage competition [adj]\n",
  "ANTICONSUMER": "opposed to the consumer ethos [adj]\n",
  "ANTICONVULSANT": "used or tending to control or to prevent convulsions [adj] / a drug used or tending to control or to prevent convulsions [n -S]\n",
  "ANTICONVULSANTS": "ANTICONVULSANT, a drug used or tending to control or to prevent convulsions [n]\n",
  "ANTICONVULSIVE": "an anticonvulsant drug [n -S]\n",
  "ANTICONVULSIVES": "ANTICONVULSIVE, an anticonvulsant drug [n]\n",
  "ANTICORPORATE": "opposed to the corporate ethos [adj]\n",
  "ANTICORROSION": "the prevention or counteracting of corrosion [n -S]\n",
  "ANTICORROSIONS": "ANTICORROSION, the prevention or counteracting of corrosion [n]\n",
  "ANTICORROSIVE": "a substance designed to counteract corrosion [n -S]\n",
  "ANTICORROSIVES": "ANTICORROSIVE, a substance designed to counteract corrosion [n]\n",
  "ANTICORRUPTION": "opposed to corruption [adj]\n",
  "ANTICOUS": "on the anterior side [adj]\n",
  "ANTICRACK": "opposed to the use of crack cocaine [adj]\n",
  "ANTICREATIVE": "stultifying creativity [adj]\n",
  "ANTICRIME": "opposed to crime [adj]\n",
  "ANTICRUELTY": "against cruelty [adj]\n",
  "ANTICS": "ANTIC, to act in a clownish manner [v]\n",
  "ANTICULT": "opposed to cults [adj] / an organisation opposed to cults [n -S]\n",
  "ANTICULTS": "ANTICULT, an organisation opposed to cults [n]\n",
  "ANTICULTURAL": "opposed to culture [adj]\n",
  "ANTICYCLONE": "a system of winds that rotates clockwise in the northern hemisphere and counterclockwise in the southern [n -S]\n",
  "ANTICYCLONES": "ANTICYCLONE, a system of winds that rotates clockwise in the northern hemisphere and counterclockwise in the southern [n]\n",
  "ANTICYCLONIC": "relating to an anticyclone [adj]\n",
  "ANTIDANDRUFF": "designed to cure dandruff [adj]\n",
  "ANTIDAZZLE": "designed to prevent dazzle [adj]\n",
  "ANTIDEFAMATION": "designed to counter defamation [adj]\n",
  "ANTIDEMOCRATIC": "opposed or hostile to the theories or policies of democracy [adj]\n",
  "ANTIDEPRESSANT": "an antidepressant drug [n -S]\n",
  "ANTIDEPRESSANTS": "ANTIDEPRESSANT, an antidepressant drug [n]\n",
  "ANTIDEPRESSION": "designed to counter depression [adj]\n",
  "ANTIDERIVATIVE": "an indefinite integral [n -S]\n",
  "ANTIDERIVATIVES": "ANTIDERIVATIVE, an indefinite integral [n]\n",
  "ANTIDESICCANT": "a chemical which prevents or inhibits the drying-out of a plant, etc. [n -S]\n",
  "ANTIDESICCANTS": "ANTIDESICCANT, a chemical which prevents or inhibits the drying-out of a plant, etc. [n]\n",
  "ANTIDEVELOPMENT": "opposed to development [adj]\n",
  "ANTIDIABETIC": "a drug which acts against diabetes [n -S]\n",
  "ANTIDIABETICS": "ANTIDIABETIC, a drug which acts against diabetes [n]\n",
  "ANTIDIARRHEAL": "a drug used to counter diarrhea [n -S]\n",
  "ANTIDIARRHEALS": "ANTIDIARRHEAL, a drug used to counter diarrhea [n]\n",
  "ANTIDIARRHOEAL": "a drug used to prevent or treat diarrhoea, also ANTIDIARRHEAL [n -S]\n",
  "ANTIDIARRHOEALS": "ANTIDIARRHOEAL, a drug used to prevent or treat diarrhoea, also ANTIDIARRHEAL [n]\n",
  "ANTIDILUTION": "opposed to dilution [adj]\n",
  "ANTIDIURETIC": "a drug inhibiting the formation of urine [n -S]\n",
  "ANTIDIURETICS": "ANTIDIURETIC, a drug inhibiting the formation of urine [n]\n",
  "ANTIDOGMATIC": "opposed to dogma [adj]\n",
  "ANTIDORA": "ANTIDORON, (Latin) the unconsecrated bread remaining after the Eucharistic Liturgy, blessed by the priests and given to noncommunicants as well as communicants [n]\n",
  "ANTIDORON": "(Latin) the unconsecrated bread remaining after the Eucharistic Liturgy, blessed by the priests and given to noncommunicants as well as communicants [n ANTIDORA]\n",
  "ANTIDOTAL": "having the quality of an antidote [adj ANTIDOTALLY]\n",
  "ANTIDOTALLY": "ANTIDOTAL, having the quality of an antidote [adv]\n",
  "ANTIDOTE": "something which counteracts a poison [n -S] / to counteract poison [v ANTIDOTED, ANTIDOTING, ANTIDOTES]\n",
  "ANTIDOTED": "ANTIDOTE, to counteract poison [v]\n",
  "ANTIDOTES": "ANTIDOTE, to counteract poison [v]\n",
  "ANTIDOTING": "ANTIDOTE, to counteract poison [v]\n",
  "ANTIDRAFT": "opposed to the draft (of conscripts) [adj]\n",
  "ANTIDROMIC": "of nerve fibres, conducting impulses in the opposite direction to normal [adj ANTIDROMICALLY]\n",
  "ANTIDROMICALLY": "ANTIDROMIC, of nerve fibres, conducting impulses in the opposite direction to normal [adv]\n",
  "ANTIDRUG": "opposed to illicit drugs [adj]\n",
  "ANTIDUMPING": "a method of trade protection intended to stop other countries dumping goods cheaply on a domestic market [n -S]\n",
  "ANTIDUMPINGS": "ANTIDUMPING, a method of trade protection intended to stop other countries dumping goods cheaply on a domestic market [n]\n",
  "ANTIDUNE": "a sandhill that forms a steep slope against the direction of the prevailing current [n -S]\n",
  "ANTIDUNES": "ANTIDUNE, a sandhill that forms a steep slope against the direction of the prevailing current [n]\n",
  "ANTIECONOMIC": "opposed to the economy [adj]\n",
  "ANTIEDUCATIONAL": "opposed to education [adj]\n",
  "ANTIEGALITARIAN": "opposed to egalitarianism [adj]\n",
  "ANTIELECTRON": "the antimatter equivalent of an electron [n -S]\n",
  "ANTIELECTRONS": "ANTIELECTRON, the antimatter equivalent of an electron [n]\n",
  "ANTIELITE": "opposed to an elite [adj] / a group opposed to an elite [n -S]\n",
  "ANTIELITES": "ANTIELITE, a group opposed to an elite [n]\n",
  "ANTIELITISM": "opposition to elitism [n -S]\n",
  "ANTIELITISMS": "ANTIELITISM, opposition to elitism [n]\n",
  "ANTIELITIST": "one who is opposed to elitism [n ANTIELITISTS]\n",
  "ANTIELITISTS": "ANTIELITIST, one who is opposed to elitism [n]\n",
  "ANTIEMETIC": "preventive of vomiting [adj] / a drug used to prevent vomiting [n -S]\n",
  "ANTIEMETICS": "ANTIEMETIC, a drug used to prevent vomiting [n]\n",
  "ANTIENT": "(obsolete) ancient [adj] / an ancient person [n -S]\n",
  "ANTIENTROPIC": "working to counter the effects of entropy [adj]\n",
  "ANTIENTS": "ANTIENT, an ancient person [n]\n",
  "ANTIEPILEPSY": "designed to combat epilepsy [adj]\n",
  "ANTIEPILEPTIC": "a drug used to prevent or suppress epilepsy [n -S]\n",
  "ANTIEPILEPTICS": "ANTIEPILEPTIC, a drug used to prevent or suppress epilepsy [n]\n",
  "ANTIEROTIC": "designed to prevent sexual arousal [adj]\n",
  "ANTIESTROGEN": "a drug designed to counter the effects of estrogen [n -S]\n",
  "ANTIESTROGENS": "ANTIESTROGEN, a drug designed to counter the effects of estrogen [n]\n",
  "ANTIEVOLUTION": "opposed to (the teaching of) evolution [adj] / a system of thought which argues against the biological theory of evolution [n -S]\n",
  "ANTIEVOLUTIONS": "ANTIEVOLUTION, a system of thought which argues against the biological theory of evolution [n]\n",
  "ANTIFA": "an antifascist organization; a member of an antifascist organization [n -S]\n",
  "ANTIFAMILY": "opposed to the family [adj]\n",
  "ANTIFAS": "ANTIFA, an antifascist organization; a member of an antifascist organization [n]\n",
  "ANTIFASCISM": "opposition to fascism [n -S]\n",
  "ANTIFASCISMS": "ANTIFASCISM, opposition to fascism [n]\n",
  "ANTIFASCIST": "one who opposes fascism [n -S]\n",
  "ANTIFASCISTS": "ANTIFASCIST, one who opposes fascism [n]\n",
  "ANTIFASHION": "a deliberately unfashionable style [n -S]\n",
  "ANTIFASHIONABLE": "opposed to things fashionable [adj]\n",
  "ANTIFASHIONS": "ANTIFASHION, a deliberately unfashionable style [n]\n",
  "ANTIFAT": "designed to reduce fat [adj]\n",
  "ANTIFATIGUE": "preventative of fatigue [adj]\n",
  "ANTIFEBRILE": "designed to cure a fever [adj] / a drug used to cure fever [n -S]\n",
  "ANTIFEBRILES": "ANTIFEBRILE, a drug used to cure fever [n]\n",
  "ANTIFEDERALIST": "one who is opposed to federalism [n -S]\n",
  "ANTIFEDERALISTS": "ANTIFEDERALIST, one who is opposed to federalism [n]\n",
  "ANTIFEMALE": "opposed to the female gender [adj]\n",
  "ANTIFEMININE": "opposed to women [adj]\n",
  "ANTIFEMINISM": "opposition to feminism [n -S]\n",
  "ANTIFEMINISMS": "ANTIFEMINISM, opposition to feminism [n]\n",
  "ANTIFEMINIST": "a supporter of antifeminism [n -S]\n",
  "ANTIFEMINISTS": "ANTIFEMINIST, a supporter of antifeminism [n]\n",
  "ANTIFERROMAGNET": "a magnet exhibiting antiferromagnetism [n]\n",
  "ANTIFERTILITY": "capable of or tending to reduce or destroy fertility [adj]\n",
  "ANTIFILIBUSTER": "a person or method in opposition to filibustering [n -S]\n",
  "ANTIFILIBUSTERS": "ANTIFILIBUSTER, a person or method in opposition to filibustering [n]\n",
  "ANTIFLU": "combating the flu [adj]\n",
  "ANTIFOAM": "reducing or preventing foam [adj]\n",
  "ANTIFOAMING": "designed to prevent foaming [adj]\n",
  "ANTIFOG": "acting to stop a car window from fogging up [adj]\n",
  "ANTIFOGGING": "of a device that prevents the buildup of moisture on a surface [adj]\n",
  "ANTIFORECLOSURE": "opposed to foreclosure [adj]\n",
  "ANTIFOREIGN": "opposed to foreignness [adj]\n",
  "ANTIFOREIGNER": "opposed to foreigners [adj]\n",
  "ANTIFORMALIST": "opposed to formalism [adj]\n",
  "ANTIFOULING": "an antifouling substance applied in paint form to ships' bottoms, etc. [n -S]\n",
  "ANTIFOULINGS": "ANTIFOULING, an antifouling substance applied in paint form to ships' bottoms, etc. [n]\n",
  "ANTIFRAUD": "designed to reduce fraud [adj]\n",
  "ANTIFREEZE": "a substance added to a liquid (as the water in an automobile engine) to lower its freezing point [n -S]\n",
  "ANTIFREEZES": "ANTIFREEZE, a substance added to a liquid (as the water in an automobile engine) to lower its freezing point [n]\n",
  "ANTIFRICTION": "designed to counter the effects of friction [adj]\n",
  "ANTIFUNGAL": "designed to prevent fungal infection [adj] / a drug designed to prevent fungal infection [n -S]\n",
  "ANTIFUNGALS": "ANTIFUNGAL, a drug designed to prevent fungal infection [n]\n",
  "ANTIFUR": "opposed to wearing animal fur [adj]\n",
  "ANTIGAMBLING": "opposed to gambling [adj]\n",
  "ANTIGANG": "opposed to gangs [adj]\n",
  "ANTIGAY": "opposed to homosexuals [adj]\n",
  "ANTIGEN": "a substance that stimulates the production of antibodies, also ANTIGENE [n -S]\n",
  "ANTIGENE": "a substance that stimulates the production of antibodies, also ANTIGEN [n -S]\n",
  "ANTIGENES": "ANTIGENE, a substance that stimulates the production of antibodies, also ANTIGEN [n]\n",
  "ANTIGENIC": "of or like an antigen, any substance that stimulates the production of an antibody [adj ANTIGENICALLY]\n",
  "ANTIGENICALLY": "ANTIGENIC, of or like an antigen, any substance that stimulates the production of an antibody [adv]\n",
  "ANTIGENICITIES": "ANTIGENICITY, the quality of being an antigen [n]\n",
  "ANTIGENICITY": "the quality of being an antigen [n ANTIGENICITIES]\n",
  "ANTIGENS": "ANTIGEN, a substance that stimulates the production of antibodies, also ANTIGENE [n]\n",
  "ANTIGLARE": "designed to counteract glare [adj]\n",
  "ANTIGLOBULIN": "an antibody that combines with and precipitates globulin [n -S]\n",
  "ANTIGLOBULINS": "ANTIGLOBULIN, an antibody that combines with and precipitates globulin [n]\n",
  "ANTIGOVERNMENT": "opposed to the government [adj]\n",
  "ANTIGRAFT": "designed to reduce corruption [adj]\n",
  "ANTIGRAVITIES": "ANTIGRAVITY, a hypothetical effect resulting from cancellation or reduction of a gravitational field [n]\n",
  "ANTIGRAVITY": "a hypothetical effect resulting from cancellation or reduction of a gravitational field [n ANTIGRAVITIES]\n",
  "ANTIGROPELOES": "waterproof leggings, also ANTIGROPELOS [n]\n",
  "ANTIGROPELOS": "waterproof leggings, also ANTIGROPELOES [n]\n",
  "ANTIGROWTH": "designed to prevent growth [adj]\n",
  "ANTIGUERRILLA": "designed to counter guerrillas [adj]\n",
  "ANTIGUN": "opposed to guns [adj]\n",
  "ANTIHALATION": "the prevention of halation, usually by placing a layer of dye on the back of the film to absorb light which has passed through the emulsion on it [n -S]\n",
  "ANTIHALATIONS": "ANTIHALATION, the prevention of halation, usually by placing a layer of dye on the back of the film to absorb light which has passed through the emulsion on it [n]\n",
  "ANTIHELICES": "ANTIHELIX, the curved elevation of the cartilage of the ear, within or in front of the helix, also ANTHELIX [n]\n",
  "ANTIHELIX": "the curved elevation of the cartilage of the ear, within or in front of the helix, also ANTHELIX [n ANTIHELICES]\n",
  "ANTIHELIXES": "ANTIHELIX, the curved elevation of the cartilage of the ear, within or in front of the helix, also ANTHELIX [n]\n",
  "ANTIHELMINTHIC": "a drug designed to cure intestinal worms [n -S]\n",
  "ANTIHELMINTHICS": "ANTIHELMINTHIC, a drug designed to cure intestinal worms [n]\n",
  "ANTIHERO": "a character with qualities opposite to those of the (conventional) hero [n -ES]\n",
  "ANTIHEROES": "ANTIHERO, a character with qualities opposite to those of the (conventional) hero [n]\n",
  "ANTIHEROIC": "like an antihero [adj]\n",
  "ANTIHEROINE": "a female antihero [n -S]\n",
  "ANTIHEROINES": "ANTIHEROINE, a female antihero [n]\n",
  "ANTIHERPES": "designed to prevent herpes [adj]\n",
  "ANTIHIJACK": "designed to prevent hijack [adj]\n",
  "ANTIHISTAMINE": "any of a group of drugs that prevents the action of histamines in allergic conditions [n -S]\n",
  "ANTIHISTAMINES": "ANTIHISTAMINE, any of a group of drugs that prevents the action of histamines in allergic conditions [n]\n",
  "ANTIHISTAMINIC": "an antihistamine [n -S]\n",
  "ANTIHISTAMINICS": "ANTIHISTAMINIC, an antihistamine [n]\n",
  "ANTIHISTORICAL": "against the grain of history [adj]\n",
  "ANTIHOMOSEXUAL": "opposed to homosexuality [adj]\n",
  "ANTIHUMAN": "opposed to humanity [adj]\n",
  "ANTIHUMANISM": "opposition to humanism [n -S]\n",
  "ANTIHUMANISMS": "ANTIHUMANISM, opposition to humanism [n]\n",
  "ANTIHUMANISTIC": "opposed to humanism [adj]\n",
  "ANTIHUNTER": "one who is opposed to hunting [n -S]\n",
  "ANTIHUNTERS": "ANTIHUNTER, one who is opposed to hunting [n]\n",
  "ANTIHUNTING": "opposed to hunting [adj]\n",
  "ANTIHYDROGEN": "an antimatter form of hydrogen [n -S]\n",
  "ANTIHYDROGENS": "ANTIHYDROGEN, an antimatter form of hydrogen [n]\n",
  "ANTIHYSTERIC": "a remedy for hysteria [n -S]\n",
  "ANTIHYSTERICS": "ANTIHYSTERIC, a remedy for hysteria [n]\n",
  "ANTIJACOBIN": "opposed to the Jacobins and to the French Revolution or to democratic principles [adj] / one opposed to the Jacobins [n -S]\n",
  "ANTIJACOBINS": "ANTIJACOBIN, one opposed to the Jacobins [n]\n",
  "ANTIJAM": "designed to prevent jamming of signals [adj]\n",
  "ANTIJAMMING": "measures taken to prevent jamming [n -S]\n",
  "ANTIJAMMINGS": "ANTIJAMMING, measures taken to prevent jamming [n]\n",
  "ANTIKICKBACK": "opposed to kickbacks [adj]\n",
  "ANTIKING": "a usurping king [n -S]\n",
  "ANTIKINGS": "ANTIKING, a usurping king [n]\n",
  "ANTIKNOCK": "an additive in petrol, used to prevent knock [n -S]\n",
  "ANTIKNOCKS": "ANTIKNOCK, an additive in petrol, used to prevent knock [n]\n",
  "ANTILABOR": "opposed to labour organisations [adj]\n",
  "ANTILEAK": "preventing leaks [adj]\n",
  "ANTILEFT": "opposed to leftism [adj]\n",
  "ANTILEGOMENA": "books of the New Testament not part of early Christian Bible [n]\n",
  "ANTILEPROSY": "designed to prevent leprosy [adj]\n",
  "ANTILEPTON": "an antiparticle to a lepton [n -S]\n",
  "ANTILEPTONS": "ANTILEPTON, an antiparticle to a lepton [n]\n",
  "ANTILEUKEMIC": "counteracting the effects of leukemia [adj]\n",
  "ANTILIBERAL": "one who is opposed to liberalism [n -S]\n",
  "ANTILIBERALISM": "opposition to liberalism [n -S]\n",
  "ANTILIBERALISMS": "ANTILIBERALISM, opposition to liberalism [n]\n",
  "ANTILIBERALS": "ANTILIBERAL, one who is opposed to liberalism [n]\n",
  "ANTILIBERTARIAN": "opposed to libertarianism [adj]\n",
  "ANTILIFE": "opposed to life [adj]\n",
  "ANTILIFER": "a person in favour of abortion [n -S]\n",
  "ANTILIFERS": "ANTILIFER, a person in favour of abortion [n]\n",
  "ANTILITERATE": "opposed to literacy [adj]\n",
  "ANTILITTER": "designed to prevent litter [adj]\n",
  "ANTILITTERING": "designed to counter littering [adj]\n",
  "ANTILOCK": "designed to stop wheels locking [adj]\n",
  "ANTILOG": "a number corresponding to a given logarithm [n -S]\n",
  "ANTILOGARITHM": "a number of which a given number is the logarithm, also ANTILOG [n -S]\n",
  "ANTILOGARITHMIC": "of or like an antilogarithm, a number of which a given number is the logarithm [adj]\n",
  "ANTILOGARITHMS": "ANTILOGARITHM, a number of which a given number is the logarithm, also ANTILOG [n]\n",
  "ANTILOGICAL": "opposed to logic [adj]\n",
  "ANTILOGIES": "ANTILOGY, a contradiction in terms of ideas [n]\n",
  "ANTILOGOUS": "contrary; inconsistent [adj]\n",
  "ANTILOGS": "ANTILOG, a number corresponding to a given logarithm [n]\n",
  "ANTILOGY": "a contradiction in terms of ideas [n ANTILOGIES]\n",
  "ANTILOPINE": "of antelopes [adj]\n",
  "ANTILYNCHING": "opposed to lynching [adj]\n",
  "ANTIMACASSAR": "a cover to protect the back or arms of furniture [n -S]\n",
  "ANTIMACASSARS": "ANTIMACASSAR, a cover to protect the back or arms of furniture [n]\n",
  "ANTIMACHO": "opposed to being macho [adj]\n",
  "ANTIMAGNETIC": "having a balance unit composed of alloys that will not remain magnetized [adj]\n",
  "ANTIMALARIA": "of a drug, used to combat malaria, also ANTIMALARIAL [adj]\n",
  "ANTIMALARIAL": "effective against malaria, also ANTIMALARIA [adj] / a drug used to treat malaria [n -S]\n",
  "ANTIMALARIALS": "ANTIMALARIAL, a drug used to treat malaria [n]\n",
  "ANTIMALE": "opposed to men [adj]\n",
  "ANTIMAN": "a homosexual man [n ANTIMEN]\n",
  "ANTIMANAGEMENT": "opposed to management [adj]\n",
  "ANTIMARIJUANA": "opposed to the use of marijuana [adj]\n",
  "ANTIMARKET": "opposed to the market [adj]\n",
  "ANTIMARKETEER": "a person who was opposed to the United Kingdom joining the European Union [n -S]\n",
  "ANTIMARKETEERS": "ANTIMARKETEER, a person who was opposed to the United Kingdom joining the European Union [n]\n",
  "ANTIMASK": "a secondary mask, or grotesque interlude, between the parts of a serious mask, also ANTIMASQUE [n -S]\n",
  "ANTIMASKS": "ANTIMASK, a secondary mask, or grotesque interlude, between the parts of a serious mask, also ANTIMASQUE [n]\n",
  "ANTIMASQUE": "a secondary mask, or grotesque interlude, between the parts of a serious mask, also ANTIMASK [n -S]\n",
  "ANTIMASQUES": "ANTIMASQUE, a secondary mask, or grotesque interlude, between the parts of a serious mask, also ANTIMASK [n]\n",
  "ANTIMATERIALISM": "opposition to materialism [n]\n",
  "ANTIMATERIALIST": "one who is opposed to materialism [n]\n",
  "ANTIMATTER": "matter composed of antiparticles [n -S]\n",
  "ANTIMATTERS": "ANTIMATTER, matter composed of antiparticles [n]\n",
  "ANTIMECHANIST": "one opposed to a mechanistic interpretation [n -S]\n",
  "ANTIMECHANISTS": "ANTIMECHANIST, one opposed to a mechanistic interpretation [n]\n",
  "ANTIMEN": "ANTIMAN, a homosexual man [n]\n",
  "ANTIMERE": "one of the two halves of bilaterally symmetrical animals [n -S]\n",
  "ANTIMERES": "ANTIMERE, one of the two halves of bilaterally symmetrical animals [n]\n",
  "ANTIMERGER": "opposed to a merger [adj]\n",
  "ANTIMERIC": "of or like an antimere, one of the two halves of bilaterally symmetrical animals [adj]\n",
  "ANTIMERISM": "the state of having antimeres [n -S]\n",
  "ANTIMERISMS": "ANTIMERISM, the state of having antimeres [n]\n",
  "ANTIMETABOLE": "repetition of words or ideas in different order e.g. to fail to plan is to plan to fail [n -S]\n",
  "ANTIMETABOLES": "ANTIMETABOLE, repetition of words or ideas in different order e.g. to fail to plan is to plan to fail [n]\n",
  "ANTIMETABOLIC": "of or like antimetabole, repetition of words or ideas in different order [adj]\n",
  "ANTIMETABOLITE": "a substance that replaces or inhibits an organism's utilization of a metabolite [n -S]\n",
  "ANTIMETABOLITES": "ANTIMETABOLITE, a substance that replaces or inhibits an organism's utilization of a metabolite [n]\n",
  "ANTIMETATHESES": "ANTIMETATHESIS, inversion of the members of an antithesis, as in Crabbe's 'A poem is a speaking picture; a picture, a mute poem' [n]\n",
  "ANTIMETATHESIS": "inversion of the members of an antithesis, as in Crabbe's 'A poem is a speaking picture; a picture, a mute poem' [n ANTIMETATHESES]\n",
  "ANTIMICROBIAL": "destroying or inhibiting the growth of microorganisms and esp. pathogenic microorganisms [adj] / an antimicrobial drug [n -S]\n",
  "ANTIMICROBIALS": "ANTIMICROBIAL, an antimicrobial drug [n]\n",
  "ANTIMILITARISM": "opposition to militarism [n -S]\n",
  "ANTIMILITARISMS": "ANTIMILITARISM, opposition to militarism [n]\n",
  "ANTIMILITARIST": "one opposed to militarism [n -S]\n",
  "ANTIMILITARISTS": "ANTIMILITARIST, one opposed to militarism [n]\n",
  "ANTIMILITARY": "opposed to things military [adj]\n",
  "ANTIMINE": "designed to counteract landmines [adj]\n",
  "ANTIMISSILE": "a missile for use against other missiles [n -S]\n",
  "ANTIMISSILES": "ANTIMISSILE, a missile for use against other missiles [n]\n",
  "ANTIMITOTIC": "an agent that inhibits or disrupts mitosis [n -S]\n",
  "ANTIMITOTICS": "ANTIMITOTIC, an agent that inhibits or disrupts mitosis [n]\n",
  "ANTIMNEMONIC": "tending to weaken the memory [adj] / something that weakens the memory [n -S]\n",
  "ANTIMNEMONICS": "ANTIMNEMONIC, something that weakens the memory [n]\n",
  "ANTIMODERN": "opposed to the modern [adj]\n",
  "ANTIMODERNIST": "one opposed to modernism [n -S]\n",
  "ANTIMODERNISTS": "ANTIMODERNIST, one opposed to modernism [n]\n",
  "ANTIMONARCHICAL": "opposed to the monarchy [adj]\n",
  "ANTIMONARCHIST": "one opposed to the monarchy [n -S]\n",
  "ANTIMONARCHISTS": "ANTIMONARCHIST, one opposed to the monarchy [n]\n",
  "ANTIMONATE": "a salt of any antimonic acid, also ANTIMONIATE [n -S]\n",
  "ANTIMONATES": "ANTIMONATE, a salt of any antimonic acid, also ANTIMONIATE [n]\n",
  "ANTIMONIAL": "a drug containing antimony [n -S]\n",
  "ANTIMONIALS": "ANTIMONIAL, a drug containing antimony [n]\n",
  "ANTIMONIATE": "a salt of any antimonic acid, also ANTIMONATE [n -S]\n",
  "ANTIMONIATES": "ANTIMONIATE, a salt of any antimonic acid, also ANTIMONATE [n]\n",
  "ANTIMONIC": "containing pentavalent antimony [adj]\n",
  "ANTIMONIDE": "a binary compound with antimony as one of its constituents [n -S]\n",
  "ANTIMONIDES": "ANTIMONIDE, a binary compound with antimony as one of its constituents [n]\n",
  "ANTIMONIES": "ANTIMONY, a brittle, bluish-white metallic element [n]\n",
  "ANTIMONIOUS": "containing trivalent antimony [adj]\n",
  "ANTIMONITE": "a compound of antimonious acid and a base or basic radical [n -S]\n",
  "ANTIMONITES": "ANTIMONITE, a compound of antimonious acid and a base or basic radical [n]\n",
  "ANTIMONOPOLIST": "one opposed to monopolies [n -S]\n",
  "ANTIMONOPOLISTS": "ANTIMONOPOLIST, one opposed to monopolies [n]\n",
  "ANTIMONOPOLY": "opposed to monopoly [adj]\n",
  "ANTIMONOUS": "of or containing antimony in the trivalent state [adj]\n",
  "ANTIMONY": "a brittle, bluish-white metallic element [n ANTIMONIES]\n",
  "ANTIMONYL": "a substance containing the monovalent group antimony oxide [n -S]\n",
  "ANTIMONYLS": "ANTIMONYL, a substance containing the monovalent group antimony oxide [n]\n",
  "ANTIMOSQUITO": "designed to repel mosquitoes [adj]\n",
  "ANTIMUON": "the antiparticle of a muon [n -S]\n",
  "ANTIMUONS": "ANTIMUON, the antiparticle of a muon [n]\n",
  "ANTIMUSIC": "music intended to overthrow traditional conventions [n -S]\n",
  "ANTIMUSICAL": "against music [adj]\n",
  "ANTIMUSICS": "ANTIMUSIC, music intended to overthrow traditional conventions [n]\n",
  "ANTIMUTAGEN": "a compound that inhibits the action of a mutagen [n -S]\n",
  "ANTIMUTAGENS": "ANTIMUTAGEN, a compound that inhibits the action of a mutagen [n]\n",
  "ANTIMYCIN": "a crystalline antibiotic used as a fungicide etc. [n -S]\n",
  "ANTIMYCINS": "ANTIMYCIN, a crystalline antibiotic used as a fungicide etc. [n]\n",
  "ANTIMYCOTIC": "antifungal [adj]\n",
  "ANTINARRATIVE": "a literary form eschewing conventional narrative [n -S]\n",
  "ANTINARRATIVES": "ANTINARRATIVE, a literary form eschewing conventional narrative [n]\n",
  "ANTINATIONAL": "opposed to nationalism [adj]\n",
  "ANTINATIONALIST": "one opposed to nationalism [n]\n",
  "ANTINATURAL": "opposed to nature [adj]\n",
  "ANTINATURE": "against nature [adj]\n",
  "ANTINAUSEA": "designed to prevent nausea [adj]\n",
  "ANTINEOPLASTIC": "a drug inhibiting or preventing the growth and spread of neoplasms or malignant cells [n -S]\n",
  "ANTINEOPLASTICS": "ANTINEOPLASTIC, a drug inhibiting or preventing the growth and spread of neoplasms or malignant cells [n]\n",
  "ANTINEPHRITIC": "acting against diseases of the kidney [adj] / a drug acting against diseases of the kidney [n -S]\n",
  "ANTINEPHRITICS": "ANTINEPHRITIC, a drug acting against diseases of the kidney [n]\n",
  "ANTINEPOTISM": "opposed to nepotism [adj]\n",
  "ANTINEUTRINO": "the antiparticle of the neutrino [n -S]\n",
  "ANTINEUTRINOS": "ANTINEUTRINO, the antiparticle of the neutrino [n]\n",
  "ANTINEUTRON": "the antiparticle of the neutron [n -S]\n",
  "ANTINEUTRONS": "ANTINEUTRON, the antiparticle of the neutron [n]\n",
  "ANTING": "the practice of certain birds in putting ants on their feathers to rid themselves of parasites [n -S]\n",
  "ANTINGS": "ANTING, the practice of certain birds in putting ants on their feathers to rid themselves of parasites [n]\n",
  "ANTINODAL": "relating to an antinode, a point of maximum disturbance midway between nodes [adj]\n",
  "ANTINODE": "a point of maximum disturbance midway between nodes [n -S]\n",
  "ANTINODES": "ANTINODE, a point of maximum disturbance midway between nodes [n]\n",
  "ANTINOISE": "a sound generated to reduce the level of another noise [n -S]\n",
  "ANTINOISES": "ANTINOISE, a sound generated to reduce the level of another noise [n]\n",
  "ANTINOME": "one that is opposite to another [n -S]\n",
  "ANTINOMES": "ANTINOME, one that is opposite to another [n]\n",
  "ANTINOMIAN": "one who holds that moral law is of no use because faith alone is necessary to salvation [n -S]\n",
  "ANTINOMIANISM": "the doctrine of the rejection of moral law [n -S]\n",
  "ANTINOMIANISMS": "ANTINOMIANISM, the doctrine of the rejection of moral law [n]\n",
  "ANTINOMIANS": "ANTINOMIAN, one who holds that moral law is of no use because faith alone is necessary to salvation [n]\n",
  "ANTINOMIC": "relating to, or of the nature of, an antinomy, a contradiction between two logical conclusions, also ANTINOMICAL [adj ANTINOMICALLY]\n",
  "ANTINOMICAL": "relating to, or of the nature of, an antinomy, a contradiction between two logical conclusions, also ANTINOMIC [adj ANTINOMICALLY]\n",
  "ANTINOMICALLY": "ANTINOMICAL, relating to, or of the nature of, an antinomy, a contradiction between two logical conclusions, also ANTINOMIC [adv]\n",
  "ANTINOMIES": "ANTINOMY, a conflict of authority [n]\n",
  "ANTINOMY": "a conflict of authority [n ANTINOMIES]\n",
  "ANTINOVEL": "a work written in defiance of novelistic convention [n -S]\n",
  "ANTINOVELIST": "one who writes antinovels [n -S]\n",
  "ANTINOVELISTS": "ANTINOVELIST, one who writes antinovels [n]\n",
  "ANTINOVELS": "ANTINOVEL, a work written in defiance of novelistic convention [n]\n",
  "ANTINUCLEAR": "tending to react with cell nuclei or their components (as DNA) [adj]\n",
  "ANTINUCLEARIST": "one opposed to nuclear power [n -S]\n",
  "ANTINUCLEARISTS": "ANTINUCLEARIST, one opposed to nuclear power [n]\n",
  "ANTINUCLEON": "the antiparticle of a nucleon [n -S]\n",
  "ANTINUCLEONS": "ANTINUCLEON, the antiparticle of a nucleon [n]\n",
  "ANTINUKE": "a person opposed to the use of nuclear weapons or nuclear energy, also ANTINUKER [n -S]\n",
  "ANTINUKER": "a person opposed to the use of nuclear weapons or nuclear energy, also ANTINUKE [n -S]\n",
  "ANTINUKERS": "ANTINUKER, a person opposed to the use of nuclear weapons or nuclear energy, also ANTINUKE [n]\n",
  "ANTINUKES": "ANTINUKE, a person opposed to the use of nuclear weapons or nuclear energy, also ANTINUKER [n]\n",
  "ANTIOBESITY": "opposed to obesity [adj]\n",
  "ANTIOBSCENITY": "opposed to obscenity [adj]\n",
  "ANTIODONTALGIC": "used against toothache [adj] / a drug used to alleviate toothache [n -S]\n",
  "ANTIODONTALGICS": "ANTIODONTALGIC, a drug used to alleviate toothache [n]\n",
  "ANTIOESTROGEN": "a drug that inhibits the activity of oestrogens [n -S]\n",
  "ANTIOESTROGENS": "ANTIOESTROGEN, a drug that inhibits the activity of oestrogens [n]\n",
  "ANTIOXIDANT": "a substance (as betacarotene or vitamin C) that inhibits oxidation [n -S]\n",
  "ANTIOXIDANTS": "ANTIOXIDANT, a substance (as betacarotene or vitamin C) that inhibits oxidation [n]\n",
  "ANTIOZONANT": "a substance that opposes ozonization or protects against it [n -S]\n",
  "ANTIOZONANTS": "ANTIOZONANT, a substance that opposes ozonization or protects against it [n]\n",
  "ANTIPAPAL": "opposed to the pope or to popery [adj]\n",
  "ANTIPARALLEL": "making with a transverse line an internal angle equal to the external angle made by another line [adj] / an antiparallel line [n -S]\n",
  "ANTIPARALLELS": "ANTIPARALLEL, an antiparallel line [n]\n",
  "ANTIPARASITIC": "a drug designed to counter parasites [n -S]\n",
  "ANTIPARASITICS": "ANTIPARASITIC, a drug designed to counter parasites [n]\n",
  "ANTIPARTICLE": "the 'pair' of an elementary particle, particle and antiparticle being mutually destructive, having the same mass and spin but having opposite values for their other properties (e.g. charge, baryon number, strangeness) [n -S]\n",
  "ANTIPARTICLES": "ANTIPARTICLE, the 'pair' of an elementary particle, particle and antiparticle being mutually destructive, having the same mass and spin but having opposite values for their other properties (e.g. charge, baryon number, strangeness) [n]\n",
  "ANTIPARTIES": "ANTIPARTY, a party opposed to a political party [n]\n",
  "ANTIPARTY": "opposed to a political party [adj] / a party opposed to a political party [n ANTIPARTIES]\n",
  "ANTIPASTI": "ANTIPASTO, (Italian) an hors d'oeuvre, an appetizer [n]\n",
  "ANTIPASTO": "(Italian) an hors d'oeuvre, an appetizer [n ANTIPASTOS or ANTIPASTI]\n",
  "ANTIPASTOS": "ANTIPASTO, (Italian) an hors d'oeuvre, an appetizer [n]\n",
  "ANTIPATHETIC": "related to antipathy, also ANTIPATHETICAL [adj]\n",
  "ANTIPATHETICAL": "related to antipathy, also ANTIPATHETIC [adj]\n",
  "ANTIPATHIC": "belonging to antipathy; contrary [adj]\n",
  "ANTIPATHIES": "ANTIPATHY, aversion, dislike [n]\n",
  "ANTIPATHIST": "a person possessed by an antipathy [n -S]\n",
  "ANTIPATHISTS": "ANTIPATHIST, a person possessed by an antipathy [n]\n",
  "ANTIPATHY": "aversion, dislike [n ANTIPATHIES]\n",
  "ANTIPERIODIC": "destroying the periodicity of diseases; antimalarial [adj] / a drug with an antiperiodic effect [n -S]\n",
  "ANTIPERIODICS": "ANTIPERIODIC, a drug with an antiperiodic effect [n]\n",
  "ANTIPERISTALSES": "ANTIPERISTALSIS, the action of intestinal waves of contraction contrary to normal, from anus to mouth, forcing the contents of the intestine upwards [n]\n",
  "ANTIPERISTALSIS": "the action of intestinal waves of contraction contrary to normal, from anus to mouth, forcing the contents of the intestine upwards [n ANTIPERISTALSES]\n",
  "ANTIPERISTALTIC": "relating to antiperistalsis [adj]\n",
  "ANTIPERISTASES": "ANTIPERISTASIS, (archaic) opposition or resistance [n]\n",
  "ANTIPERISTASIS": "(archaic) opposition or resistance [n ANTIPERISTASES]\n",
  "ANTIPERSONNEL": "designed for use against troops [adj]\n",
  "ANTIPERSPIRANT": "a preparation used to reduce perspiration [n -S]\n",
  "ANTIPERSPIRANTS": "ANTIPERSPIRANT, a preparation used to reduce perspiration [n]\n",
  "ANTIPESTICIDE": "designating one opposed to the use of pesticides [adj]\n",
  "ANTIPETALOUS": "opposite a petal [adj]\n",
  "ANTIPHLOGISTIC": "an antipyretic, a drug used against inflammation [n -S]\n",
  "ANTIPHLOGISTICS": "ANTIPHLOGISTIC, an antipyretic, a drug used against inflammation [n]\n",
  "ANTIPHON": "(Greek) alternate chanting or singing [n -S]\n",
  "ANTIPHONAL": "sung or recited in alternation [adj ANTIPHONALLY] / a book of antiphons or of anthems [n -S]\n",
  "ANTIPHONALLY": "ANTIPHONAL, sung or recited in alternation [adv]\n",
  "ANTIPHONALS": "ANTIPHONAL, a book of antiphons or of anthems [n]\n",
  "ANTIPHONARIES": "ANTIPHONARY, a book of antiphons or of anthems, also ANTIPHONAL, ANTIPHONER [n]\n",
  "ANTIPHONARY": "a book of antiphons or of anthems, also ANTIPHONAL, ANTIPHONER [n ANTIPHONARIES]\n",
  "ANTIPHONER": "a book of antiphons or of anthems, also ANTIPHONAL, ANTIPHONARY [n -S]\n",
  "ANTIPHONERS": "ANTIPHONER, a book of antiphons or of anthems, also ANTIPHONAL, ANTIPHONARY [n]\n",
  "ANTIPHONIC": "mutually responsive, also ANTIPHONICAL [adj ANTIPHONICALLY]\n",
  "ANTIPHONICAL": "(obsolete) mutually responsive, also ANTIPHONIC [adj ANTIPHONICALLY]\n",
  "ANTIPHONICALLY": "ANTIPHONICAL, (obsolete) mutually responsive, also ANTIPHONIC [adv]\n",
  "ANTIPHONIES": "ANTIPHONY, antiphonal chanting or singing [n]\n",
  "ANTIPHONS": "ANTIPHON, (Greek) alternate chanting or singing [n]\n",
  "ANTIPHONY": "antiphonal chanting or singing [n ANTIPHONIES]\n",
  "ANTIPHRASES": "ANTIPHRASIS, the humorous or ironic use of a word or a phrase in a sense opposite of its usual meaning [n]\n",
  "ANTIPHRASIS": "the humorous or ironic use of a word or a phrase in a sense opposite of its usual meaning [n ANTIPHRASES]\n",
  "ANTIPHRASTIC": "involving antiphrasis, ironical, also ANTIPHRASTICAL [adj]\n",
  "ANTIPHRASTICAL": "(obsolete) involving antiphrasis, ironical, also ANTIPHRASTIC [adj]\n",
  "ANTIPILL": "opposed to the contraceptive pill [adj]\n",
  "ANTIPIRACY": "designed to prevent piracy [adj]\n",
  "ANTIPLAGUE": "designed to prevent the plague [adj]\n",
  "ANTIPLAQUE": "designed to prevent plaque [adj]\n",
  "ANTIPLEASURE": "opposed to pleasure [adj]\n",
  "ANTIPOACHING": "opposed to poaching [adj]\n",
  "ANTIPODAL": "situated at the opposite side of the earth or moon; diametrically opposed [adj] / in flowering plants, a type of cell [n -S]\n",
  "ANTIPODALS": "ANTIPODAL, in flowering plants, a type of cell [n]\n",
  "ANTIPODE": "the point on the earth's surface exactly opposite of a given point [n -S]\n",
  "ANTIPODEAN": "relating to the antipodes [adj] / an inhabitant of the antipodes [n -S]\n",
  "ANTIPODEANS": "ANTIPODEAN, an inhabitant of the antipodes [n]\n",
  "ANTIPODES": "ANTIPODE, the point on the earth's surface exactly opposite of a given point [n]\n",
  "ANTIPOETIC": "of, relating to, or characterized by opposition to traditional poetic technique or style [adj]\n",
  "ANTIPOLAR": "relating to an antipole, the opposite pole [adj]\n",
  "ANTIPOLE": "the opposite pole [n -S]\n",
  "ANTIPOLES": "ANTIPOLE, the opposite pole [n]\n",
  "ANTIPOLICE": "opposed to the police [adj]\n",
  "ANTIPOLITICAL": "opposed to politics [adj]\n",
  "ANTIPOLITICS": "opposed to politics [adj]\n",
  "ANTIPOLLUTION": "designed to prevent or reduce pollution [adj] / a measure designed to prevent pollution [n -S]\n",
  "ANTIPOLLUTIONS": "ANTIPOLLUTION, a measure designed to prevent pollution [n]\n",
  "ANTIPOPE": "a pope who opposes the properly elected pope [n -S]\n",
  "ANTIPOPES": "ANTIPOPE, a pope who opposes the properly elected pope [n]\n",
  "ANTIPOPULAR": "opposed to popular culture [adj]\n",
  "ANTIPORN": "opposed to pornography [adj]\n",
  "ANTIPORNOGRAPHY": "opposed to pornography [adj]\n",
  "ANTIPORTER": "a membrane protein that transports substances across cell membranes [n -S]\n",
  "ANTIPORTERS": "ANTIPORTER, a membrane protein that transports substances across cell membranes [n]\n",
  "ANTIPOT": "opposed to using marijuana [adj]\n",
  "ANTIPOVERTY": "opposed to poverty [adj]\n",
  "ANTIPREDATOR": "designed to deter predators [adj]\n",
  "ANTIPRESS": "opposed to the Press [adj]\n",
  "ANTIPRIESTLY": "opposed to priests [adj]\n",
  "ANTIPROGRESSIVE": "opposed to progressivism [adj]\n",
  "ANTIPROTON": "the antiparticle of a proton [n -S]\n",
  "ANTIPROTONS": "ANTIPROTON, the antiparticle of a proton [n]\n",
  "ANTIPRURITIC": "alleviating itching [adj] / a drug used to relieve itching [n -S]\n",
  "ANTIPRURITICS": "ANTIPRURITIC, a drug used to relieve itching [n]\n",
  "ANTIPSYCHIATRY": "opposed to psychiatry [adj]\n",
  "ANTIPSYCHOTIC": "alleviating psychosis [adj] / an antipsychotic drug [n -S]\n",
  "ANTIPSYCHOTICS": "ANTIPSYCHOTIC, an antipsychotic drug [n]\n",
  "ANTIPYIC": "a medicine that prevents pus forming [n -S]\n",
  "ANTIPYICS": "ANTIPYIC, a medicine that prevents pus forming [n]\n",
  "ANTIPYRESES": "ANTIPYRESIS, medication with antipyretics to treat a fever [n]\n",
  "ANTIPYRESIS": "medication with antipyretics to treat a fever [n ANTIPYRESES]\n",
  "ANTIPYRETIC": "an agent which prevents or reduces fever [n -S]\n",
  "ANTIPYRETICS": "ANTIPYRETIC, an agent which prevents or reduces fever [n]\n",
  "ANTIPYRINE": "an artificial alkaloid, believed to be efficient in abating fever [n -S]\n",
  "ANTIPYRINES": "ANTIPYRINE, an artificial alkaloid, believed to be efficient in abating fever [n]\n",
  "ANTIQUARIAN": "one who collects or studies antiquities [n -S]\n",
  "ANTIQUARIANISM": "an interest in antiquarian things [n -S]\n",
  "ANTIQUARIANISMS": "ANTIQUARIANISM, an interest in antiquarian things [n]\n",
  "ANTIQUARIANS": "ANTIQUARIAN, one who collects or studies antiquities [n]\n",
  "ANTIQUARIES": "ANTIQUARY, a student or collector of antiquities or antiques [n]\n",
  "ANTIQUARK": "the antimatter equivalent of a quark [n -S]\n",
  "ANTIQUARKS": "ANTIQUARK, the antimatter equivalent of a quark [n]\n",
  "ANTIQUARY": "a student or collector of antiquities or antiques [n ANTIQUARIES]\n",
  "ANTIQUATE": "to make antique [v ANTIQUATED, ANTIQUATING, ANTIQUATES]\n",
  "ANTIQUATED": "ANTIQUATE, to make antique [v]\n",
  "ANTIQUATEDNESS": "the state of being antiquated [n]\n",
  "ANTIQUATES": "ANTIQUATE, to make antique [v]\n",
  "ANTIQUATING": "ANTIQUATE, to make antique [v]\n",
  "ANTIQUATION": "the act of antiquating [n -S]\n",
  "ANTIQUATIONS": "ANTIQUATION, the act of antiquating [n]\n",
  "ANTIQUE": "very old, also ANTICKE [adj ANTIQUELY] / to alter the appearance of e.g. wood to make it seem very old [v ANTIQUED, ANTIQUING, ANTIQUES]\n",
  "ANTIQUED": "ANTIQUE, to alter the appearance of e.g. wood to make it seem very old [v]\n",
  "ANTIQUELY": "ANTIQUE, very old, also ANTICKE [adv]\n",
  "ANTIQUENESS": "the state of being antique [n -ES]\n",
  "ANTIQUENESSES": "ANTIQUENESS, the state of being antique [n]\n",
  "ANTIQUER": "one who antiques, ages furniture [n -S]\n",
  "ANTIQUERS": "ANTIQUER, one who antiques, ages furniture [n]\n",
  "ANTIQUES": "ANTIQUE, to alter the appearance of e.g. wood to make it seem very old [v]\n",
  "ANTIQUEY": "having the appearance of an antique [adj ANTIQUIER, ANTIQUIEST]\n",
  "ANTIQUIER": "ANTIQUEY, having the appearance of an antique [adj]\n",
  "ANTIQUIEST": "ANTIQUEY, having the appearance of an antique [adj]\n",
  "ANTIQUING": "ANTIQUE, to alter the appearance of e.g. wood to make it seem very old [v]\n",
  "ANTIQUITARIAN": "a person attached to old ways or beliefs [n -S]\n",
  "ANTIQUITARIANS": "ANTIQUITARIAN, a person attached to old ways or beliefs [n]\n",
  "ANTIQUITIES": "ANTIQUITY, the quality of being ancient [n]\n",
  "ANTIQUITY": "the quality of being ancient [n ANTIQUITIES]\n",
  "ANTIRABIES": "designed to prevent rabies [adj]\n",
  "ANTIRACHITIC": "preventive of rickets, esp. applied to vitamin D or food containing it [adj] / a drug preventive of rickets [n -S]\n",
  "ANTIRACHITICS": "ANTIRACHITIC, a drug preventive of rickets [n]\n",
  "ANTIRACISM": "opposition to racism [n -S]\n",
  "ANTIRACISMS": "ANTIRACISM, opposition to racism [n]\n",
  "ANTIRACIST": "one opposed to racism [n -S]\n",
  "ANTIRACISTS": "ANTIRACIST, one opposed to racism [n]\n",
  "ANTIRADAR": "designed to foil radar [adj] / a device designed to foil radar [n -S]\n",
  "ANTIRADARS": "ANTIRADAR, a device designed to foil radar [n]\n",
  "ANTIRADICAL": "opposed to radicalism [adj]\n",
  "ANTIRADICALISM": "opposition to radicalism [n -S]\n",
  "ANTIRADICALISMS": "ANTIRADICALISM, opposition to radicalism [n]\n",
  "ANTIRAPE": "concerned with rape prevention [adj]\n",
  "ANTIRATIONAL": "opposed to the rational [adj]\n",
  "ANTIRATIONALISM": "opposition to rationalism [n]\n",
  "ANTIRATIONALIST": "one opposed to rationalism [n]\n",
  "ANTIRATIONALITY": "being opposed to rationality [n]\n",
  "ANTIREALISM": "opposition to realism [n -S]\n",
  "ANTIREALISMS": "ANTIREALISM, opposition to realism [n]\n",
  "ANTIREALIST": "one who is opposed to realism [n -S]\n",
  "ANTIREALISTS": "ANTIREALIST, one who is opposed to realism [n]\n",
  "ANTIRECESSION": "designed to counter recession [adj]\n",
  "ANTIRED": "opposed to communism [adj]\n",
  "ANTIREFLECTION": "designed to counter reflection [adj]\n",
  "ANTIREFLECTIVE": "designed to counter reflection [adj]\n",
  "ANTIREFORM": "opposed to reform [adj]\n",
  "ANTIREGULATORY": "opposed to regulation [adj]\n",
  "ANTIREJECTION": "used or tending to prevent organ or tissue transplant rejection [adj]\n",
  "ANTIRELIGION": "opposition to religion [n -S]\n",
  "ANTIRELIGIONS": "ANTIRELIGION, opposition to religion [n]\n",
  "ANTIRELIGIOUS": "opposed to religion [adj]\n",
  "ANTIREPUBLICAN": "one opposed to a republic [n -S]\n",
  "ANTIREPUBLICANS": "ANTIREPUBLICAN, one opposed to a republic [n]\n",
  "ANTIRETROVIRAL": "inhibiting the process by which a retrovirus replicates [adj] / any retroviral drug used to treat diseases caused by retroviruses, such as HIV [n -S]\n",
  "ANTIRETROVIRALS": "ANTIRETROVIRAL, any retroviral drug used to treat diseases caused by retroviruses, such as HIV [n]\n",
  "ANTIRHEUMATIC": "an agent that alleviates or prevents rheumatism [n -S]\n",
  "ANTIRHEUMATICS": "ANTIRHEUMATIC, an agent that alleviates or prevents rheumatism [n]\n",
  "ANTIRIOT": "designed to end riots [adj]\n",
  "ANTIRITUALISM": "opposition to ritual [n -S]\n",
  "ANTIRITUALISMS": "ANTIRITUALISM, opposition to ritual [n]\n",
  "ANTIROCK": "opposed to rock music [adj]\n",
  "ANTIROLL": "designed to reduce roll [adj]\n",
  "ANTIROMANTIC": "one who opposes romanticism [n -S]\n",
  "ANTIROMANTICISM": "opposed to romanticism [adj]\n",
  "ANTIROMANTICS": "ANTIROMANTIC, one who opposes romanticism [n]\n",
  "ANTIROYAL": "opposed to royalty [adj]\n",
  "ANTIROYALIST": "one opposed to royalty [n -S]\n",
  "ANTIROYALISTS": "ANTIROYALIST, one opposed to royalty [n]\n",
  "ANTIRRHINUM": "a garden flower, aka snapdragon [n -S]\n",
  "ANTIRRHINUMS": "ANTIRRHINUM, a garden flower, aka snapdragon [n]\n",
  "ANTIRUST": "intended to prevent rust [adj] / a preparation intended to prevent rust [n -S]\n",
  "ANTIRUSTS": "ANTIRUST, a preparation intended to prevent rust [n]\n",
  "ANTIS": "ANTI, one who is opposed to anything [n]\n",
  "ANTISAG": "designed to prevent sagging [adj]\n",
  "ANTISATELLITE": "designed to counter the use of satellites [adj]\n",
  "ANTISCIAN": "a dweller on the exact opposite side of the world [n -S]\n",
  "ANTISCIANS": "ANTISCIAN, a dweller on the exact opposite side of the world [n]\n",
  "ANTISCIENCE": "opposed to science [adj] / a discipline opposed to science [n -S]\n",
  "ANTISCIENCES": "ANTISCIENCE, a discipline opposed to science [n]\n",
  "ANTISCIENTIFIC": "opposed to science [adj]\n",
  "ANTISCORBUTIC": "preventive of scurvy, esp. applied to vitamin C or food containing it [adj] / a drug preventive of scurvy [n -S]\n",
  "ANTISCORBUTICS": "ANTISCORBUTIC, a drug preventive of scurvy [n]\n",
  "ANTISCRIPTURAL": "opposed to scripture [adj]\n",
  "ANTISECRECY": "against secrecy [adj]\n",
  "ANTISEGREGATION": "opposed to segregation [adj]\n",
  "ANTISEIZURE": "of drugs, designed to prevent seizures [adj]\n",
  "ANTISENSE": "of a drug, etc., designed to treat diseases and infection by inhibiting the production of pathogenic proteins [adj]\n",
  "ANTISENTIMENTAL": "opposed to the sentimental [adj]\n",
  "ANTISEPALOUS": "opposite a sepal [adj]\n",
  "ANTISEPARATIST": "one opposed to separatism [n -S]\n",
  "ANTISEPARATISTS": "ANTISEPARATIST, one opposed to separatism [n]\n",
  "ANTISEPSES": "ANTISEPSIS, the destruction of bacteria by a chemical agent [n]\n",
  "ANTISEPSIS": "the destruction of bacteria by a chemical agent [n ANTISEPSES]\n",
  "ANTISEPTIC": "inhibiting the growth of microorganisms [adj ANTISEPTICALLY] / a substance that inhibits the growth or action of microorganisms [n -S]\n",
  "ANTISEPTICALLY": "ANTISEPTIC, inhibiting the growth of microorganisms [adv]\n",
  "ANTISEPTICISE": "to render antiseptic, also ANTISEPTICIZE [v ANTISEPTICISED, ANTISEPTICISING, ANTISEPTICISES]\n",
  "ANTISEPTICISED": "ANTISEPTICISE, to render antiseptic, also ANTISEPTICIZE [v]\n",
  "ANTISEPTICISES": "ANTISEPTICISE, to render antiseptic, also ANTISEPTICIZE [v]\n",
  "ANTISEPTICISING": "ANTISEPTICISE, to render antiseptic, also ANTISEPTICIZE [v]\n",
  "ANTISEPTICISM": "antiseptic treatment [n -S]\n",
  "ANTISEPTICISMS": "ANTISEPTICISM, antiseptic treatment [n]\n",
  "ANTISEPTICIZE": "to render antiseptic, also ANTISEPTICISE [v ANTISEPTICIZED, ANTISEPTICIZING, ANTISEPTICIZES]\n",
  "ANTISEPTICIZED": "ANTISEPTICIZE, to render antiseptic, also ANTISEPTICISE [v]\n",
  "ANTISEPTICIZES": "ANTISEPTICIZE, to render antiseptic, also ANTISEPTICISE [v]\n",
  "ANTISEPTICIZING": "ANTISEPTICIZE, to render antiseptic, also ANTISEPTICISE [v]\n",
  "ANTISEPTICS": "ANTISEPTIC, a substance that inhibits the growth or action of microorganisms [n]\n",
  "ANTISERA": "ANTISERUM, a serum containing antibodies, usually for a particular antigen [n]\n",
  "ANTISERUM": "a serum containing antibodies, usually for a particular antigen [n ANTISERUMS or ANTISERA]\n",
  "ANTISERUMS": "ANTISERUM, a serum containing antibodies, usually for a particular antigen [n]\n",
  "ANTISEX": "opposed to sexual activity [adj]\n",
  "ANTISEXIST": "one opposed to sexism [n -S]\n",
  "ANTISEXISTS": "ANTISEXIST, one opposed to sexism [n]\n",
  "ANTISEXUAL": "one who is opposed to sexuality or sexual activity [n -S]\n",
  "ANTISEXUALITIES": "ANTISEXUALITY, being antisexual [n]\n",
  "ANTISEXUALITY": "being antisexual [n ANTISEXUALITIES]\n",
  "ANTISEXUALS": "ANTISEXUAL, one who is opposed to sexuality or sexual activity [n]\n",
  "ANTISHAKE": "denoting a technology that reduces the blurring caused by movement of the person taking a photograph [adj] / a system that uses antishake technology [n -S]\n",
  "ANTISHAKES": "ANTISHAKE, a system that uses antishake technology [n]\n",
  "ANTISHARK": "designed to keep away sharks [adj]\n",
  "ANTISHIP": "designed for use against ships [adj]\n",
  "ANTISHOCK": "designed to prevent shock [adj] / a device designed to prevent shock [n -S]\n",
  "ANTISHOCKS": "ANTISHOCK, a device designed to prevent shock [n]\n",
  "ANTISHOPLIFTING": "designed to prevent shoplifting [adj]\n",
  "ANTISKID": "designed to prevent skidding [adj]\n",
  "ANTISLAVERY": "opposed to slavery [adj]\n",
  "ANTISLEEP": "opposed to sleep [adj]\n",
  "ANTISLIP": "designed to prevent slipping [adj]\n",
  "ANTISMOG": "designed to reduce smog [adj]\n",
  "ANTISMOKE": "opposed to smoking [adj]\n",
  "ANTISMOKER": "someone opposed to smoking [n -S]\n",
  "ANTISMOKERS": "ANTISMOKER, someone opposed to smoking [n]\n",
  "ANTISMOKING": "opposed to smoking [adj]\n",
  "ANTISMUGGLING": "designed to counter smuggling [adj]\n",
  "ANTISMUT": "opposed to pornography [adj]\n",
  "ANTISNOB": "opposed to snobbery [adj] / a person opposed to snobbery [n -S]\n",
  "ANTISNOBS": "ANTISNOB, a person opposed to snobbery [n]\n",
  "ANTISOCIAL": "averse to the society of others [adj ANTISOCIALLY] / one who is averse to the society of others [n -S]\n",
  "ANTISOCIALISM": "being antisocial [n -S]\n",
  "ANTISOCIALISMS": "ANTISOCIALISM, being antisocial [n]\n",
  "ANTISOCIALIST": "one who is antisocial [n -S]\n",
  "ANTISOCIALISTS": "ANTISOCIALIST, one who is antisocial [n]\n",
  "ANTISOCIALITIES": "ANTISOCIALITY, the quality of being antisocial [n]\n",
  "ANTISOCIALITY": "the quality of being antisocial [n ANTISOCIALITIES]\n",
  "ANTISOCIALLY": "ANTISOCIAL, averse to the society of others [adv]\n",
  "ANTISOCIALS": "ANTISOCIAL, one who is averse to the society of others [n]\n",
  "ANTISOLAR": "opposite to the sun, said of the point in the heavens 180 degrees distant from the sun [adj]\n",
  "ANTISPAM": "acting to eliminate spam [adj]\n",
  "ANTISPASMODIC": "an agent capable of preventing or relieving spasms or convulsions [n -S]\n",
  "ANTISPASMODICS": "ANTISPASMODIC, an agent capable of preventing or relieving spasms or convulsions [n]\n",
  "ANTISPAST": "(Greek) a metrical foot comprising an iambus followed by a trochee [n -S]\n",
  "ANTISPASTIC": "a substance that prevents or reduces spasms [n -S]\n",
  "ANTISPASTICS": "ANTISPASTIC, a substance that prevents or reduces spasms [n]\n",
  "ANTISPASTS": "ANTISPAST, (Greek) a metrical foot comprising an iambus followed by a trochee [n]\n",
  "ANTISPECULATION": "opposed to speculation [adj]\n",
  "ANTISPECULATIVE": "opposed to speculation [adj]\n",
  "ANTISPENDING": "opposed to spending [adj]\n",
  "ANTISTAT": "something that opposes static electricity [n -S]\n",
  "ANTISTATE": "opposed to the state [adj]\n",
  "ANTISTATIC": "reducing, removing, or preventing the buildup of static electricity [adj] / an antistatic substance [n -S]\n",
  "ANTISTATICS": "ANTISTATIC, an antistatic substance [n]\n",
  "ANTISTATS": "ANTISTAT, something that opposes static electricity [n]\n",
  "ANTISTICK": "designed to prevent sticking [adj]\n",
  "ANTISTORIES": "ANTISTORY, a narrative that does not follow the normal conventions of story [n]\n",
  "ANTISTORY": "a narrative that does not follow the normal conventions of story [n ANTISTORIES]\n",
  "ANTISTRESS": "designed to prevent stress [adj]\n",
  "ANTISTRIKE": "opposed to a strike [adj]\n",
  "ANTISTROPHE": "the repetition of words in reverse order [n -S]\n",
  "ANTISTROPHES": "ANTISTROPHE, the repetition of words in reverse order [n]\n",
  "ANTISTROPHIC": "relating to antistrophe, the repetition of words in reverse order [adj]\n",
  "ANTISTROPHON": "an argument retorted on an opponent [n -S]\n",
  "ANTISTROPHONS": "ANTISTROPHON, an argument retorted on an opponent [n]\n",
  "ANTISTUDENT": "opposed to students [adj]\n",
  "ANTISTYLE": "a style that rejects traditional aesthetics [n -S]\n",
  "ANTISTYLES": "ANTISTYLE, a style that rejects traditional aesthetics [n]\n",
  "ANTISUBMARINE": "designed to counter submarines [adj]\n",
  "ANTISUBSIDY": "opposed to subsidy [adj]\n",
  "ANTISUBVERSION": "opposed to subversion [adj]\n",
  "ANTISUBVERSIVE": "opposed to subversion [adj]\n",
  "ANTISUICIDE": "opposed to suicide [adj]\n",
  "ANTISYMMETRIC": "relating to or being a relation (as is a subset of) that implies equality of any two quantities for which it holds in both directions [adj]\n",
  "ANTISYPHILITIC": "an agent that is effective against syphilis [n -S]\n",
  "ANTISYPHILITICS": "ANTISYPHILITIC, an agent that is effective against syphilis [n]\n",
  "ANTISYZYGIES": "ANTISYZYGY, a union of opposites [n]\n",
  "ANTISYZYGY": "a union of opposites [n ANTISYZYGIES]\n",
  "ANTITAKEOVER": "against a takeover [adj]\n",
  "ANTITANK": "designed to combat tanks [adj]\n",
  "ANTITARNISH": "designed to prevent tarnish [adj]\n",
  "ANTITAX": "opposed to taxes [adj]\n",
  "ANTITECHNOLOGY": "opposed to technology [adj]\n",
  "ANTITERRORISM": "opposition to terrorism [n -S]\n",
  "ANTITERRORISMS": "ANTITERRORISM, opposition to terrorism [n]\n",
  "ANTITERRORIST": "one opposed to terrorism [n -S]\n",
  "ANTITERRORISTS": "ANTITERRORIST, one opposed to terrorism [n]\n",
  "ANTITHALIAN": "opposed to mirth or fun [adj]\n",
  "ANTITHEFT": "designed to prevent theft [adj]\n",
  "ANTITHEISM": "the doctrine of antitheists [n -S]\n",
  "ANTITHEISMS": "ANTITHEISM, the doctrine of antitheists [n]\n",
  "ANTITHEIST": "a disbeliever in the existence of God [n -S]\n",
  "ANTITHEISTIC": "opposed to theism [adj]\n",
  "ANTITHEISTS": "ANTITHEIST, a disbeliever in the existence of God [n]\n",
  "ANTITHEORETICAL": "opposed to the theoretical [adj]\n",
  "ANTITHESES": "ANTITHESIS, the contrast of ideas by means of parallel arrangement of words or clauses [n]\n",
  "ANTITHESIS": "the contrast of ideas by means of parallel arrangement of words or clauses [n ANTITHESES]\n",
  "ANTITHET": "an instance of antithesis [n -S]\n",
  "ANTITHETIC": "relating to antithesis, also ANTITHETICAL [adj ANTITHETICALLY]\n",
  "ANTITHETICAL": "relating to antithesis, also ANTITHETIC [adj ANTITHETICALLY]\n",
  "ANTITHETICALLY": "ANTITHETICAL, relating to antithesis, also ANTITHETIC [adv]\n",
  "ANTITHETS": "ANTITHET, an instance of antithesis [n]\n",
  "ANTITHROMBIN": "a substance in blood preventing coagulation of blood [n -S]\n",
  "ANTITHROMBINS": "ANTITHROMBIN, a substance in blood preventing coagulation of blood [n]\n",
  "ANTITHROMBOTIC": "a drug effective against thrombosis [n -S]\n",
  "ANTITHROMBOTICS": "ANTITHROMBOTIC, a drug effective against thrombosis [n]\n",
  "ANTITHYROID": "able to counteract excessive thyroid activity [adj]\n",
  "ANTITOBACCO": "opposed to the use of tobacco [adj]\n",
  "ANTITOXIC": "serving to neutralize poison [adj]\n",
  "ANTITOXIN": "an antidote to a toxin [n -S]\n",
  "ANTITOXINS": "ANTITOXIN, an antidote to a toxin [n]\n",
  "ANTITRADE": "a contrary wind blowing at a high altitude above the trade wind [n -S]\n",
  "ANTITRADES": "ANTITRADE, a contrary wind blowing at a high altitude above the trade wind [n]\n",
  "ANTITRADITIONAL": "opposed to the traditional [adj]\n",
  "ANTITRAGI": "ANTITRAGUS, a prominence of the external ear, opposite the tragus [n]\n",
  "ANTITRAGUS": "a prominence of the external ear, opposite the tragus [n ANTITRAGI]\n",
  "ANTITRANSPIRANT": "any substance that decreases transpiration and, usually, photosynthesis [n]\n",
  "ANTITRINITARIAN": "opposed to Trinitarianism [adj]\n",
  "ANTITRUST": "of legislation etc., directed against the adverse effect of trusts and other monopolies on commerce [adj]\n",
  "ANTITRUSTER": "one who advocates or enforces antitrust provisions of the law [n -S]\n",
  "ANTITRUSTERS": "ANTITRUSTER, one who advocates or enforces antitrust provisions of the law [n]\n",
  "ANTITUBERCULAR": "designed to counter tuberculosis [adj]\n",
  "ANTITUBERCULOUS": "designed to counter tuberculosis [adj]\n",
  "ANTITUMOR": "a drug designed to prevent tumors [n -S]\n",
  "ANTITUMORAL": "intended to prevent tumors, also ANTITUMOR, ANTITUMOUR, ANTITUMOURAL [adj]\n",
  "ANTITUMORS": "ANTITUMOR, a drug designed to prevent tumors [n]\n",
  "ANTITUMOUR": "preventing or acting against tumours, also ANTITUMOR, ANTITUMORAL, ANTITUMOURAL [adj]\n",
  "ANTITUMOURAL": "preventing or acting against tumours, also ANTITUMOR, ANTITUMORAL, ANTITUMOUR [adj]\n",
  "ANTITUSSIVE": "an agent which relieves coughing [n -S]\n",
  "ANTITUSSIVES": "ANTITUSSIVE, an agent which relieves coughing [n]\n",
  "ANTITYPAL": "relating to an antitype, an object or person prefigured by the type or symbol, also ANTITYPIC, ANTITYPICAL [adj]\n",
  "ANTITYPE": "something which a type or symbol represents, also ANTETYPE [n -S]\n",
  "ANTITYPES": "ANTITYPE, something which a type or symbol represents, also ANTETYPE [n]\n",
  "ANTITYPHOID": "intended to prevent typhoid [adj]\n",
  "ANTITYPIC": "relating to an antitype, something which a type or symbol represents, also ANTITYPAL, ANTITYPICAL [adj ANTITYPICALLY]\n",
  "ANTITYPICAL": "relating to an antitype, an object or person prefigured by the type or symbol, also ANTITYPAL, ANTITYPIC [adj ANTITYPICALLY]\n",
  "ANTITYPICALLY": "ANTITYPICAL, relating to an antitype, an object or person prefigured by the type or symbol, also ANTITYPAL, ANTITYPIC [adv]\n",
  "ANTIULCER": "designed to prevent ulcers [adj]\n",
  "ANTIUNION": "opposed to trade unions [adj]\n",
  "ANTIUNIVERSITY": "opposed to university [adj]\n",
  "ANTIURBAN": "opposed to towns [adj]\n",
  "ANTIVAX": "opposed to vaccination [adj]\n",
  "ANTIVAXER": "one opposed to vaccination, also ANTIVAXXER [n -S]\n",
  "ANTIVAXERS": "ANTIVAXER, one opposed to vaccination, also ANTIVAXXER [n]\n",
  "ANTIVAXXER": "one opposed to vaccination, also ANTIVAXER [n -S]\n",
  "ANTIVAXXERS": "ANTIVAXXER, one opposed to vaccination, also ANTIVAXER [n]\n",
  "ANTIVENENE": "an antitoxin countering esp. snake venom, also ANTIVENIN, ANTIVENOM [n -S]\n",
  "ANTIVENENES": "ANTIVENENE, an antitoxin countering esp. snake venom, also ANTIVENIN, ANTIVENOM [n]\n",
  "ANTIVENIN": "an antitoxin countering esp. snake venom, also ANTIVENENE, ANTIVENOM [n -S]\n",
  "ANTIVENINS": "ANTIVENIN, an antitoxin countering esp. snake venom, also ANTIVENENE, ANTIVENOM [n]\n",
  "ANTIVENOM": "an antitoxin countering esp. snake venom, also ANTIVENENE, ANTIVENIN [n -S]\n",
  "ANTIVENOMS": "ANTIVENOM, an antitoxin countering esp. snake venom, also ANTIVENENE, ANTIVENIN [n]\n",
  "ANTIVIOLENCE": "opposed to violence [adj]\n",
  "ANTIVIRAL": "any drug designed to protect against viral infection [n -S]\n",
  "ANTIVIRALS": "ANTIVIRAL, any drug designed to protect against viral infection [n]\n",
  "ANTIVIRUS": "designed to counter viruses [adj] / a computer program designed to counter viruses [n -ES]\n",
  "ANTIVIRUSES": "ANTIVIRUS, a computer program designed to counter viruses [n]\n",
  "ANTIVITAMIN": "a substance that makes a vitamin metabolically ineffective [n -S]\n",
  "ANTIVITAMINS": "ANTIVITAMIN, a substance that makes a vitamin metabolically ineffective [n]\n",
  "ANTIVIVISECTION": "opposed to vivivsection [adj]\n",
  "ANTIWAR": "opposed to war [adj]\n",
  "ANTIWEAR": "designed to reduce wear [adj]\n",
  "ANTIWEED": "concerned with the destruction of weeds [adj]\n",
  "ANTIWELFARE": "opposed to welfare [adj]\n",
  "ANTIWHALING": "opposed to whaling [adj]\n",
  "ANTIWHITE": "opposed to white people [adj]\n",
  "ANTIWOMAN": "opposed to women [adj]\n",
  "ANTIWORLD": "a hypothetical world composed of antimatter [n -S]\n",
  "ANTIWORLDS": "ANTIWORLD, a hypothetical world composed of antimatter [n]\n",
  "ANTIWRINKLE": "intended to prevent wrinkles [adj]\n",
  "ANTLER": "the horn of an animal of the deer family [n -S]\n",
  "ANTLERED": "bearing antlers [adj]\n",
  "ANTLERS": "ANTLER, the horn of an animal of the deer family [n]\n",
  "ANTLIA": "(Latin) the sucking proboscis of moths and butterflies [n ANTLIAE]\n",
  "ANTLIAE": "ANTLIA, (Latin) the sucking proboscis of moths and butterflies [n]\n",
  "ANTLIATE": "pertaining to the antlia [adj]\n",
  "ANTLIKE": "like an ant [adj]\n",
  "ANTLION": "an insect that digs a pit to catch ants [n -S]\n",
  "ANTLIONS": "ANTLION, an insect that digs a pit to catch ants [n]\n",
  "ANTONINIANUS": "a Roman coin equal to two denarii in value [n -ES]\n",
  "ANTONINIANUSES": "ANTONINIANUS, a Roman coin equal to two denarii in value [n]\n",
  "ANTONOMASIA": "the substitution of a title or epithet for a proper name, as in calling a sovereign \"Your Majesty\" [n -S]\n",
  "ANTONOMASIAS": "ANTONOMASIA, the substitution of a title or epithet for a proper name, as in calling a sovereign \"Your Majesty\" [n]\n",
  "ANTONOMASTIC": "relating to antonomasia, the substitution of a title or epithet for a proper name [adj]\n",
  "ANTONYM": "a word opposite in meaning to another [n -S]\n",
  "ANTONYMIC": "of or like an antonym, a word opposite in meaning to another [adj]\n",
  "ANTONYMIES": "ANTONYMY, the state of being an antonym [n]\n",
  "ANTONYMOUS": "relating to an antonym, a word opposite in meaning to another [adj]\n",
  "ANTONYMS": "ANTONYM, a word opposite in meaning to another [n]\n",
  "ANTONYMY": "the state of being an antonym [n ANTONYMIES]\n",
  "ANTPITTA": "any of several S American birds related to the ant thrushes [n -S]\n",
  "ANTPITTAS": "ANTPITTA, any of several S American birds related to the ant thrushes [n]\n",
  "ANTRA": "ANTRUM, (Latin) a cavity in a bone [n]\n",
  "ANTRAL": "relating to an antrum, a cavity [adj]\n",
  "ANTRE": "(Shakespeare) a cave, also ANTAR [n -S]\n",
  "ANTRES": "ANTRE, (Shakespeare) a cave, also ANTAR [n]\n",
  "ANTRORSE": "turned forward or upward [adj]\n",
  "ANTRORSELY": "turned forward or upward [adv]\n",
  "ANTRUM": "(Latin) a cavity in a bone [n ANTRUMS or ANTRA]\n",
  "ANTRUMS": "ANTRUM, (Latin) a cavity in a bone [n]\n",
  "ANTS": "ANT, a small industrious insect [n]\n",
  "ANTSIER": "ANTSY, eager, excited [adj]\n",
  "ANTSIEST": "ANTSY, eager, excited [adj]\n",
  "ANTSINESS": "the state of being antsy, eager, excited [n -ES]\n",
  "ANTSINESSES": "ANTSINESS, the state of being antsy, eager, excited [n]\n",
  "ANTSY": "eager, excited [adj ANTSIER, ANTSIEST]\n",
  "ANTWACKIE": "old-fashioned [adj]\n",
  "ANUCLEATE": "without a nucleus, also ANUCLEATED [adj]\n",
  "ANUCLEATED": "without a nucleus, also ANUCLEATE [adj]\n",
  "ANURA": "frogs and toads [n]\n",
  "ANURAL": "having no tail [adj]\n",
  "ANURAN": "a toad or a frog [n -S]\n",
  "ANURANS": "ANURAN, a toad or a frog [n]\n",
  "ANURESES": "ANURESIS, (Greek) inability to urinate [n]\n",
  "ANURESIS": "(Greek) inability to urinate [n ANURESES]\n",
  "ANURETIC": "pertaining to inability to urinate [adj]\n",
  "ANURIA": "failure to urinate [n -S]\n",
  "ANURIAS": "ANURIA, failure to urinate [n]\n",
  "ANURIC": "relating to anuria, a failure to secrete urine [adj]\n",
  "ANUROUS": "tailless, also ANOUROUS [adj]\n",
  "ANUS": "(Latin) the opening at the end of the alimentary canal [n -ES]\n",
  "ANUSES": "ANUS, (Latin) the opening at the end of the alimentary canal [n]\n",
  "ANVIL": "an iron block on which metal can be hammered into shape [n -S] / to shape on a heavy iron block [v ANVILLED or ANVILED, ANVILLING or ANVILING, ANVILS]\n",
  "ANVILED": "ANVIL, to shape on a heavy iron block [v]\n",
  "ANVILING": "ANVIL, to shape on a heavy iron block [v]\n",
  "ANVILLED": "ANVIL, to shape on a heavy iron block [v]\n",
  "ANVILLING": "ANVIL, to shape on a heavy iron block [v]\n",
  "ANVILS": "ANVIL, to shape on a heavy iron block [v]\n",
  "ANVILTOP": "a cloud mass shaped like an anvil [n -S]\n",
  "ANVILTOPS": "ANVILTOP, a cloud mass shaped like an anvil [n]\n",
  "ANXIETIES": "ANXIETY, painful or apprehensive uneasiness of mind [n]\n",
  "ANXIETY": "painful or apprehensive uneasiness of mind [n ANXIETIES]\n",
  "ANXIOLYTIC": "serving to reduce tension or stress [adj] / a drug used to reduce tension [n -S]\n",
  "ANXIOLYTICS": "ANXIOLYTIC, a drug used to reduce tension [n]\n",
  "ANXIOUS": "full of fear [adj ANXIOUSLY]\n",
  "ANXIOUSLY": "ANXIOUS, full of fear [adv]\n",
  "ANXIOUSNESS": "the state of being anxious [n -ES]\n",
  "ANXIOUSNESSES": "ANXIOUSNESS, the state of being anxious [n]\n",
  "ANY": "whichever [adj]\n",
  "ANYBODIES": "ANYBODY, a single person [n]\n",
  "ANYBODY": "a single person [n ANYBODIES]\n",
  "ANYHOW": "in any way whatever [adv]\n",
  "ANYMORE": "any longer [adv]\n",
  "ANYON": "an elementary particle having properties intermediate between those of bosons and fermions [n -S]\n",
  "ANYONE": "anybody at all [n -S]\n",
  "ANYONES": "ANYONE, anybody at all [n]\n",
  "ANYONS": "ANYON, an elementary particle having properties intermediate between those of bosons and fermions [n]\n",
  "ANYPLACE": "anywhere at all [adv]\n",
  "ANYROAD": "anyway [adv]\n",
  "ANYTHING": "something as opposed to nothing [n -S]\n",
  "ANYTHINGARIAN": "a person with no beliefs in particular [n -S]\n",
  "ANYTHINGARIANS": "ANYTHINGARIAN, a person with no beliefs in particular [n]\n",
  "ANYTHINGS": "ANYTHING, something as opposed to nothing [n]\n",
  "ANYTIME": "at any time [adv]\n",
  "ANYWAY": "in any case [adv]\n",
  "ANYWAYS": "anywise; at all, also ANYWAY [adv]\n",
  "ANYWHEN": "taking place at no specific time [adv]\n",
  "ANYWHERE": "any place at all [n -S]\n",
  "ANYWHERES": "ANYWHERE, any place at all [n]\n",
  "ANYWHITHER": "to or towards any place [adv]\n",
  "ANYWISE": "in any degree [adv]\n",
  "ANZIANI": "(Italian) councillors, senators [n]\n",
  "AORIST": "(Greek) a tense expressing simple past time with no continuance [n -S]\n",
  "AORISTIC": "pertaining to the aorist verb tense [adj AORISTICALLY]\n",
  "AORISTICALLY": "AORISTIC, pertaining to the aorist verb tense [adv]\n",
  "AORISTS": "AORIST, (Greek) a tense expressing simple past time with no continuance [n]\n",
  "AORTA": "(Greek) the main blood vessel from the heart [n AORTAS or AORTAE]\n",
  "AORTAE": "AORTA, (Greek) the main blood vessel from the heart [n]\n",
  "AORTAL": "relating to the aorta, the main artery into the heart, also AORTIC [adj]\n",
  "AORTAS": "AORTA, (Greek) the main blood vessel from the heart [n]\n",
  "AORTIC": "relating to the aorta, the main artery into the heart, also AORTAL [adj]\n",
  "AORTITIS": "inflammation of the aorta [n -ES]\n",
  "AORTITISES": "AORTITIS, inflammation of the aorta [n]\n",
  "AORTOGRAPHIC": "relating to an aortography [adj]\n",
  "AORTOGRAPHIES": "AORTOGRAPHY, an arteriography of the aorta [n]\n",
  "AORTOGRAPHY": "an arteriography of the aorta [n AORTOGRAPHIES]\n",
  "AOUDAD": "a North African wild sheep, also AUDAD [n -S]\n",
  "AOUDADS": "AOUDAD, a North African wild sheep, also AUDAD [n]\n",
  "APACE": "in a state of haste [adv]\n",
  "APACHE": "(French) a member of the French underworld [n -S]\n",
  "APACHES": "APACHE, (French) a member of the French underworld [n]\n",
  "APADANA": "(Persian) the great hall of a Persian palace [n -S]\n",
  "APADANAS": "APADANA, (Persian) the great hall of a Persian palace [n]\n",
  "APAGE": "(Greek) away, depart, as in 'apage Satanas' [interj]\n",
  "APAGOGE": "proving a point by exposing the absurdity of the opposite [n -S]\n",
  "APAGOGES": "APAGOGE, proving a point by exposing the absurdity of the opposite [n]\n",
  "APAGOGIC": "proving indirectly, by showing the absurdity, or impossibility of the contrary, also APAGOGICAL [adj APAGOGICALLY]\n",
  "APAGOGICAL": "proving indirectly, by showing the absurdity, or impossibility of the contrary, also APAGOGIC [adj APAGOGICALLY]\n",
  "APAGOGICALLY": "APAGOGICAL, proving indirectly, by showing the absurdity, or impossibility of the contrary, also APAGOGIC [adv]\n",
  "APAID": "APAY, to satisfy, also APPAY [v]\n",
  "APANAGE": "endowment for a king's child, also APPANAGE [n -S]\n",
  "APANAGED": "having an apanage [adj]\n",
  "APANAGES": "APANAGE, endowment for a king's child, also APPANAGE [n]\n",
  "APAREJO": "(Spanish) a kind of pack saddle used in the American military service and among the Spanish Americans [n -S]\n",
  "APAREJOS": "APAREJO, (Spanish) a kind of pack saddle used in the American military service and among the Spanish Americans [n]\n",
  "APART": "separate [adv]\n",
  "APARTHEID": "(South African) segregation and separate development (of races) [n -S]\n",
  "APARTHEIDS": "APARTHEID, (South African) segregation and separate development (of races) [n]\n",
  "APARTHOTEL": "a hotel in which self-catering service apartments are available for rent [n -S]\n",
  "APARTHOTELS": "APARTHOTEL, a hotel in which self-catering service apartments are available for rent [n]\n",
  "APARTMENT": "a separate room in a house, used or occupied by a particular person or party [n -S]\n",
  "APARTMENTAL": "relating to an apartment [adj]\n",
  "APARTMENTS": "APARTMENT, a separate room in a house, used or occupied by a particular person or party [n]\n",
  "APARTNESS": "the state of being apart [n -ES]\n",
  "APARTNESSES": "APARTNESS, the state of being apart [n]\n",
  "APATETIC": "having the same colour as the animal's surroundings [adj]\n",
  "APATHATON": "(Shakespeare) an epitheton, an epithet, also EPITHET, EPITHETON [n -S]\n",
  "APATHATONS": "APATHATON, (Shakespeare) an epitheton, an epithet, also EPITHET, EPITHETON [n]\n",
  "APATHETIC": "lacking feeling or passion, also APATHETICAL [adj APATHETICALLY]\n",
  "APATHETICAL": "lacking feeling or passion, also APATHETIC [adj APATHETICALLY]\n",
  "APATHETICALLY": "APATHETICAL, lacking feeling or passion, also APATHETIC [adv]\n",
  "APATHIES": "APATHY, indifference [n]\n",
  "APATHY": "indifference [n APATHIES]\n",
  "APATITE": "a mineral, calcium fluoride phosphate, used as a fertilizer [n -S]\n",
  "APATITES": "APATITE, a mineral, calcium fluoride phosphate, used as a fertilizer [n]\n",
  "APATOSAUR": "a kind of long-necked dinosaur, also APATOSAURUS [n -S]\n",
  "APATOSAURS": "APATOSAUR, a kind of long-necked dinosaur, also APATOSAURUS [n]\n",
  "APATOSAURUS": "a kind of long-necked dinosaur, also APATOSAUR [n APATOSAURUSES]\n",
  "APATOSAURUSES": "APATOSAURUS, a kind of long-necked dinosaur, also APATOSAUR [n]\n",
  "APAY": "to satisfy, also APPAY [v APAYD or APAID, APAYING, APAYS]\n",
  "APAYD": "APAY, to satisfy, also APPAY [v]\n",
  "APAYING": "APAY, to satisfy, also APPAY [v]\n",
  "APAYS": "APAY, to satisfy, also APPAY [v]\n",
  "APE": "to mimic [v APED, APING, APES]\n",
  "APEAK": "of an anchor, in a vertical position, also APEEK [adv]\n",
  "APED": "APE, to mimic [v]\n",
  "APEDOM": "the world of apes [n -S]\n",
  "APEDOMS": "APEDOM, the world of apes [n]\n",
  "APEEK": "of an anchor, in a vertical position, also APEAK [adv]\n",
  "APEHOOD": "the state of being an ape [n -S]\n",
  "APEHOODS": "APEHOOD, the state of being an ape [n]\n",
  "APELIKE": "resembling a large monkey [adj]\n",
  "APEMAN": "any of several extinct primates thought to have been intermediate in development between man and the higher apes [n APEMEN]\n",
  "APEMEN": "APEMAN, any of several extinct primates thought to have been intermediate in development between man and the higher apes [n]\n",
  "APEPSIA": "failure or absence of the digestive function, also APEPSY [n -S]\n",
  "APEPSIAS": "APEPSIA, failure or absence of the digestive function, also APEPSY [n]\n",
  "APEPSIES": "APEPSY, failure or absence of digestive function, also APEPSIA [n]\n",
  "APEPSY": "failure or absence of digestive function, also APEPSIA [n APEPSIES]\n",
  "APER": "one who mimics [n -S]\n",
  "APERCU": "(French) a glimpse; an intuitive insight [n -S]\n",
  "APERCUS": "APERCU, (French) a glimpse; an intuitive insight [n]\n",
  "APERIENT": "a laxative [n -S]\n",
  "APERIENTS": "APERIENT, a laxative [n]\n",
  "APERIES": "APERY, the act of aping [n]\n",
  "APERIODIC": "not periodic [adj APERIODICALLY]\n",
  "APERIODICALLY": "APERIODIC, not periodic [adv]\n",
  "APERIODICITIES": "APERIODICITY, the state of being aperiodic [n]\n",
  "APERIODICITY": "the state of being aperiodic [n APERIODICITIES]\n",
  "APERITIF": "(French) an alcoholic drink taken as an appetiser [n -S]\n",
  "APERITIFS": "APERITIF, (French) an alcoholic drink taken as an appetiser [n]\n",
  "APERITIVE": "a laxative (medicine) [n -S]\n",
  "APERITIVES": "APERITIVE, a laxative (medicine) [n]\n",
  "APERS": "APER, one who mimics [n]\n",
  "APERT": "(archaic) open, public [adj]\n",
  "APERTNESS": "(archaic) openness; frankness [n -ES]\n",
  "APERTNESSES": "APERTNESS, (archaic) openness; frankness [n]\n",
  "APERTURAL": "related to an aperture [adj]\n",
  "APERTURE": "an opening [n -S]\n",
  "APERTURED": "having an aperture [adj]\n",
  "APERTURES": "APERTURE, an opening [n]\n",
  "APERY": "the act of aping [n APERIES]\n",
  "APES": "APE, to mimic [v]\n",
  "APESHIT": "(vulgar) berserk; destructively crazy [adj]\n",
  "APETALIES": "APETALY, the state of having no petals [n]\n",
  "APETALOUS": "having no petals, or flower leaves [adj]\n",
  "APETALY": "the state of having no petals [n APETALIES]\n",
  "APEX": "(Latin) the topmost point [n APEXES or APICES]\n",
  "APEXES": "APEX, (Latin) the topmost point [n]\n",
  "APFELSTRUDEL": "(German) apple strudel [n -S]\n",
  "APFELSTRUDELS": "APFELSTRUDEL, (German) apple strudel [n]\n",
  "APGAR": "as in apgar score, a system for determining the condition of an infant at birth [adj]\n",
  "APHAERESES": "APHAERESIS, the omission of a letter, sound or syllable at the beginning of a word, e.g. as knife becoming nife, also APHERESIS [n]\n",
  "APHAERESIS": "the omission of a letter, sound or syllable at the beginning of a word, e.g. as knife becoming nife, also APHERESIS [n APHAERESES]\n",
  "APHAERETIC": "relating to aphaeresis, cutting off the beginning of a word, also APHERETIC [adj]\n",
  "APHAGIA": "the inability to eat or swallow [n -S]\n",
  "APHAGIAS": "APHAGIA, the inability to eat or swallow [n]\n",
  "APHAKIA": "absence of the lens of the eye [n -S]\n",
  "APHAKIAS": "APHAKIA, absence of the lens of the eye [n]\n",
  "APHANIPTEROUS": "belonging to the Aphaniptera, an order of fleas [adj]\n",
  "APHANITE": "any rock of such close texture that separate minerals contained within it cannot be distinguished by the naked eye [n -S]\n",
  "APHANITES": "APHANITE, any rock of such close texture that separate minerals contained within it cannot be distinguished by the naked eye [n]\n",
  "APHANITIC": "of igneous rocks, like aphanite, fine-grained [adj]\n",
  "APHASIA": "the inability to use or comprehend words [n -S]\n",
  "APHASIAC": "one suffering from aphasia, the inability to use or comprehend words, also APHASIC [n -S]\n",
  "APHASIACS": "APHASIAC, one suffering from aphasia, the inability to use or comprehend words, also APHASIC [n]\n",
  "APHASIAS": "APHASIA, the inability to use or comprehend words [n]\n",
  "APHASIC": "one suffering from aphasia, also APHASIAC [n -S]\n",
  "APHASICS": "APHASIC, one suffering from aphasia, also APHASIAC [n]\n",
  "APHELANDRA": "any shrub of the evergreen genus Aphelandra, widely grown as a house plant for its variegated shiny leaves and brightly coloured flowers [n -S]\n",
  "APHELANDRAS": "APHELANDRA, any shrub of the evergreen genus Aphelandra, widely grown as a house plant for its variegated shiny leaves and brightly coloured flowers [n]\n",
  "APHELIA": "APHELION, (Greek) the farthest point of a planet's orbit from the sun [n]\n",
  "APHELIAN": "relating to an aphelion, the point when the earth is farthest from the sun during its annual orbit [adj]\n",
  "APHELION": "(Greek) the farthest point of a planet's orbit from the sun [n APHELIONS or APHELIA]\n",
  "APHELIONS": "APHELION, (Greek) the farthest point of a planet's orbit from the sun [n]\n",
  "APHELIOTROPIC": "growing away from the sun [adj]\n",
  "APHELIOTROPISM": "growth away from the sun [n -S]\n",
  "APHELIOTROPISMS": "APHELIOTROPISM, growth away from the sun [n]\n",
  "APHERESES": "APHERESIS, the omission of a letter, sound or syllable at the beginning of a word, e.g. as knife becoming nife, also APHAERESIS [n]\n",
  "APHERESIS": "the omission of a letter, sound or syllable at the beginning of a word, e.g. as knife becoming nife, also APHAERESIS [n APHERESES]\n",
  "APHERETIC": "relating to apheresis, the taking away of a syllable at the beginning of a word, also APHAERETIC [adj]\n",
  "APHESES": "APHESIS, (Greek) the loss of an unstressed vowel from the beginning of a word [n]\n",
  "APHESIS": "(Greek) the loss of an unstressed vowel from the beginning of a word [n APHESES]\n",
  "APHETIC": "relating to aphesis, the loss of an unaccented vowel at the beginning of a word [adj APHETICALLY]\n",
  "APHETICALLY": "APHETIC, relating to aphesis, the loss of an unaccented vowel at the beginning of a word [adv]\n",
  "APHETISE": "to lose the first vowel of a word, also APHETIZE [v APHETISED, APHETISING, APHETISES]\n",
  "APHETISED": "APHETISE, to lose the first vowel of a word, also APHETIZE [v]\n",
  "APHETISES": "APHETISE, to lose the first vowel of a word, also APHETIZE [v]\n",
  "APHETISING": "APHETISE, to lose the first vowel of a word, also APHETIZE [v]\n",
  "APHETIZE": "to lose the first vowel of a word, also APHETISE [v APHETIZED, APHETIZING, APHETIZES]\n",
  "APHETIZED": "APHETIZE, to lose the first vowel of a word, also APHETISE [v]\n",
  "APHETIZES": "APHETIZE, to lose the first vowel of a word, also APHETISE [v]\n",
  "APHETIZING": "APHETIZE, to lose the first vowel of a word, also APHETISE [v]\n",
  "APHICIDE": "a substance that kills aphids [n -S]\n",
  "APHICIDES": "APHICIDE, a substance that kills aphids [n]\n",
  "APHID": "a plant-louse, a small homopterous insect that sucks plant juices, also APHIS [n -S]\n",
  "APHIDES": "APHIS, a plant-louse, a member of genus Aphis which includes greenfly, etc., also APHID [n]\n",
  "APHIDIAN": "an aphid, any member of the family Aphidae [n -S]\n",
  "APHIDIANS": "APHIDIAN, an aphid, any member of the family Aphidae [n]\n",
  "APHIDICIDE": "something that kills aphids, also APHICIDE [n -S]\n",
  "APHIDICIDES": "APHIDICIDE, something that kills aphids, also APHICIDE [n]\n",
  "APHIDIOUS": "like an aphid [adj]\n",
  "APHIDS": "APHID, a plant-louse, a small homopterous insect that sucks plant juices, also APHIS [n]\n",
  "APHIS": "a plant-louse, a member of genus Aphis which includes greenfly, etc., also APHID [n APHIDES]\n",
  "APHOLATE": "a chemical used to kill houseflies [n -S]\n",
  "APHOLATES": "APHOLATE, a chemical used to kill houseflies [n]\n",
  "APHONIA": "loss of voice [n -S]\n",
  "APHONIAS": "APHONIA, loss of voice [n]\n",
  "APHONIC": "one suffering with aphonia [n -S]\n",
  "APHONICS": "APHONIC, one suffering with aphonia [n]\n",
  "APHONIES": "APHONY, loss of voice [n]\n",
  "APHONOUS": "voiceless [adj]\n",
  "APHONY": "loss of voice [n APHONIES]\n",
  "APHORISE": "to make a concise statement, also APHORIZE [v APHORISED, APHORISING, APHORISES]\n",
  "APHORISED": "APHORISE, to make a concise statement, also APHORIZE [v]\n",
  "APHORISER": "one who makes aphorisms, also APHORIST, APHORIZER [n -S]\n",
  "APHORISERS": "APHORISER, one who makes aphorisms, also APHORIST, APHORIZER [n]\n",
  "APHORISES": "APHORISE, to make a concise statement, also APHORIZE [v]\n",
  "APHORISING": "APHORISE, to make a concise statement, also APHORIZE [v]\n",
  "APHORISM": "a concise statement of a truth [n -S]\n",
  "APHORISMS": "APHORISM, a concise statement of a truth [n]\n",
  "APHORIST": "one who makes aphorisms, also APHORISER, APHORIZER [n -S]\n",
  "APHORISTIC": "relating to aphorism [adj APHORISTICALLY]\n",
  "APHORISTICALLY": "APHORISTIC, relating to aphorism [adv]\n",
  "APHORISTS": "APHORIST, one who makes aphorisms, also APHORISER, APHORIZER [n]\n",
  "APHORIZE": "to make a concise statement, also APHORISE [v APHORIZED, APHORIZING, APHORIZES]\n",
  "APHORIZED": "APHORIZE, to make a concise statement, also APHORISE [v]\n",
  "APHORIZER": "one who makes aphorisms, also APHORISER, APHORIST [n -S]\n",
  "APHORIZERS": "APHORIZER, one who makes aphorisms, also APHORISER, APHORIST [n]\n",
  "APHORIZES": "APHORIZE, to make a concise statement, also APHORISE [v]\n",
  "APHORIZING": "APHORIZE, to make a concise statement, also APHORISE [v]\n",
  "APHOTIC": "lightless, esp. as designating that part of the ocean not reached by sunlight [adj]\n",
  "APHRODISIA": "sexual desire, esp. violent [n -S]\n",
  "APHRODISIAC": "an agent (as a food or drug) that arouses or is held to arouse sexual desire [n -S]\n",
  "APHRODISIACAL": "relating to aphrodisiac [adj]\n",
  "APHRODISIACS": "APHRODISIAC, an agent (as a food or drug) that arouses or is held to arouse sexual desire [n]\n",
  "APHRODISIAS": "APHRODISIA, sexual desire, esp. violent [n]\n",
  "APHRODITE": "a kind of butterfly [n -S]\n",
  "APHRODITES": "APHRODITE, a kind of butterfly [n]\n",
  "APHTHA": "(Latin) the disease thrush; a small whitish ulcer on the surface of a mucous membrane [n APHTHAE]\n",
  "APHTHAE": "APHTHA, (Latin) the disease thrush; a small whitish ulcer on the surface of a mucous membrane [n]\n",
  "APHTHOUS": "pertaining to, or caused by, aphthae; as, aphthous ulcers [adj]\n",
  "APHYLLIES": "APHYLLY, absence of leaves [n]\n",
  "APHYLLOUS": "without leaves [adj]\n",
  "APHYLLY": "absence of leaves [n APHYLLIES]\n",
  "APIACEOUS": "parsley-like [adj]\n",
  "APIAN": "relating to bees [adj]\n",
  "APIARIAN": "of or relating to bees [adj] / a member of the bee family [n -S]\n",
  "APIARIANS": "APIARIAN, a member of the bee family [n]\n",
  "APIARIES": "APIARY, a place where bees are kept [n]\n",
  "APIARIST": "a bee keeper [n -S]\n",
  "APIARISTS": "APIARIST, a bee keeper [n]\n",
  "APIARY": "a place where bees are kept [n APIARIES]\n",
  "APICAL": "of or at the apex [adj APICALLY] / a sound articulated with the tip of the tongue [n -S]\n",
  "APICALLY": "at the tip [adv]\n",
  "APICALS": "APICAL, a sound articulated with the tip of the tongue [n]\n",
  "APICES": "APEX, (Latin) the topmost point [n]\n",
  "APICIAN": "luxurious in diet [adj]\n",
  "APICULATE": "of leaves, having a short point at the tip [adj]\n",
  "APICULI": "APICULUS, (Latin) a sharp point at the end of a leaf [n]\n",
  "APICULTURAL": "relating to apiculture, beekeeping [adj]\n",
  "APICULTURE": "beekeeping [n -S]\n",
  "APICULTURES": "APICULTURE, beekeeping [n]\n",
  "APICULTURIST": "a beekeeper [n -S]\n",
  "APICULTURISTS": "APICULTURIST, a beekeeper [n]\n",
  "APICULUS": "(Latin) a sharp point at the end of a leaf [n APICULI]\n",
  "APIECE": "for each one [adv]\n",
  "APIEZON": "(tradename) as in apiezon oils, the residue of almost zero vapour pressure left by vacuum distillation of petroleum products [adj]\n",
  "APIMANIA": "an excessive interest in bees [n -S]\n",
  "APIMANIAS": "APIMANIA, an excessive interest in bees [n]\n",
  "APING": "APE, to mimic [v]\n",
  "APIOL": "an oily liquid derived from parsley [n -S]\n",
  "APIOLOGIES": "APIOLOGY, the study of bees [n]\n",
  "APIOLOGY": "the study of bees [n APIOLOGIES]\n",
  "APIOLS": "APIOL, an oily liquid derived from parsley [n]\n",
  "APISH": "like an ape [adj APISHLY]\n",
  "APISHLY": "APISH, like an ape [adv]\n",
  "APISHNESS": "the quality of being like an ape [n -ES]\n",
  "APISHNESSES": "APISHNESS, the quality of being like an ape [n]\n",
  "APISM": "the state of being like an ape [n -S]\n",
  "APISMS": "APISM, the state of being like an ape [n]\n",
  "APITHERAPIES": "APITHERAPY, the therapeutic use of bee products, such as royal jelly and propolis [n]\n",
  "APITHERAPY": "the therapeutic use of bee products, such as royal jelly and propolis [n APITHERAPIES]\n",
  "APIVOROUS": "eating bees [adj]\n",
  "APLACENTAL": "having no placenta [adj]\n",
  "APLANAT": "an aplanatic lens, i.e. one free from spherical aberration [n -S]\n",
  "APLANATIC": "of a lens, free of spherical aberration [adj APLANATICALLY]\n",
  "APLANATICALLY": "APLANATIC, of a lens, free of spherical aberration [adv]\n",
  "APLANATISM": "freedom from spherical aberration [n -S]\n",
  "APLANATISMS": "APLANATISM, freedom from spherical aberration [n]\n",
  "APLANATS": "APLANAT, an aplanatic lens, i.e. one free from spherical aberration [n]\n",
  "APLANETIC": "of algal spores, lacking a motile stage [adj]\n",
  "APLANOGAMETE": "a nonmotile gamete [n -S]\n",
  "APLANOGAMETES": "APLANOGAMETE, a nonmotile gamete [n]\n",
  "APLANOSPORE": "a nonmotile spore [n -S]\n",
  "APLANOSPORES": "APLANOSPORE, a nonmotile spore [n]\n",
  "APLASIA": "defective development or absence of an organ [n -S]\n",
  "APLASIAS": "APLASIA, defective development or absence of an organ [n]\n",
  "APLASTIC": "relating to aplasia, incomplete development [adj]\n",
  "APLENTY": "in a state of plentifulness [adj]\n",
  "APLITE": "a fine-grained, light-coloured igneous rock, also HAPLITE [n -S]\n",
  "APLITES": "APLITE, a fine-grained, light-coloured igneous rock, also HAPLITE [n]\n",
  "APLITIC": "of or like aplite, a fine-grained, light-coloured igneous rock [adj]\n",
  "APLOMB": "self-confidence, poise [n -S]\n",
  "APLOMBS": "APLOMB, self-confidence, poise [n]\n",
  "APLUSTRE": "(Latin) an ornamental appendage of wood at a ship's stern, usually spreading like a fan and curved like a bird's feather [n -S]\n",
  "APLUSTRES": "APLUSTRE, (Latin) an ornamental appendage of wood at a ship's stern, usually spreading like a fan and curved like a bird's feather [n]\n",
  "APNEA": "a temporary cessation of breathing, also APNOEA [n -S]\n",
  "APNEAL": "relating to apnoea, suspension of breathing, esp. in sleep, also APNEIC, APNOEAL, APNOEIC [adj]\n",
  "APNEAS": "APNEA, a temporary cessation of breathing, also APNOEA [n]\n",
  "APNEIC": "relating to apnoea, suspension of breathing, esp. in sleep, also APNEAL, APNOEAL, APNOEIC [adj]\n",
  "APNEUSES": "APNEUSIS, protracted gasping inhalations followed by short inhalations [n]\n",
  "APNEUSIS": "protracted gasping inhalations followed by short inhalations [n APNEUSES]\n",
  "APNEUSTIC": "relating to apneusis, protracted gasping inhalations followed by short inhalations [adj]\n",
  "APNOEA": "a temporary cessation of breathing, also APNEA [n -S]\n",
  "APNOEAL": "relating to apnoea, suspension of breathing, esp. in sleep, also APNEAL, APNEIC, APNOEIC [adj]\n",
  "APNOEAS": "APNOEA, a temporary cessation of breathing, also APNEA [n]\n",
  "APNOEIC": "relating to apnoea, suspension of breathing esp. in sleep, also APNEAL, APNEIC, APNOEAL [adj]\n",
  "APO": "(short for) apolipoprotein, a type of protein [n -S]\n",
  "APOAPSES": "APOAPSIS, (Latin) the high point in an orbit [n]\n",
  "APOAPSIDES": "APOAPSIS, (Latin) the high point in an orbit [n]\n",
  "APOAPSIS": "(Latin) the high point in an orbit [n APOAPSES or APOAPSIDES]\n",
  "APOCALYPSE": "any book purporting to reveal the future or last things; a revelation or disclosure [n -S]\n",
  "APOCALYPSES": "APOCALYPSE, any book purporting to reveal the future or last things; a revelation or disclosure [n]\n",
  "APOCALYPTIC": "of, relating to, or resembling an apocalypse, also APOCALYPTICAL [adj APOCALYPTICALLY]\n",
  "APOCALYPTICAL": "of, relating to, or resembling an apocalypse, also APOCALYPTIC [adj APOCALYPTICALLY]\n",
  "APOCALYPTICALLY": "APOCALYPTICAL, of, relating to, or resembling an apocalypse, also APOCALYPTIC [adv]\n",
  "APOCALYPTICISM": "the doctrine of the imminent end of the world, also APOCALYPTISM [n -S]\n",
  "APOCALYPTICISMS": "APOCALYPTICISM, the doctrine of the imminent end of the world, also APOCALYPTISM [n]\n",
  "APOCALYPTISM": "the doctrine of the imminent end of the world, also APOCALYPTICISM [n -S]\n",
  "APOCALYPTISMS": "APOCALYPTISM, the doctrine of the imminent end of the world, also APOCALYPTICISM [n]\n",
  "APOCALYPTIST": "the writer of an apocalypse [n -S]\n",
  "APOCALYPTISTS": "APOCALYPTIST, the writer of an apocalypse [n]\n",
  "APOCARP": "a fruit having separated carpels [n -S]\n",
  "APOCARPIES": "APOCARPY, the state of being an apocarp [n]\n",
  "APOCARPOUS": "either entirely or partially separate, as the carpels of a compound pistil [adj]\n",
  "APOCARPS": "APOCARP, a fruit having separated carpels [n]\n",
  "APOCARPY": "the state of being an apocarp [n APOCARPIES]\n",
  "APOCATASTASES": "APOCATASTASIS, the state of being restored to a previous condition, esp. the final restitution of all things at the appearance of the Messiah [n]\n",
  "APOCATASTASIS": "the state of being restored to a previous condition, esp. the final restitution of all things at the appearance of the Messiah [n APOCATASTASES]\n",
  "APOCHROMAT": "an apochromatic lens or instrument [n -S]\n",
  "APOCHROMATIC": "free from chromatic and spherical aberration [adj]\n",
  "APOCHROMATISM": "being apochromatic [n -S]\n",
  "APOCHROMATISMS": "APOCHROMATISM, being apochromatic [n]\n",
  "APOCHROMATS": "APOCHROMAT, an apochromatic lens or instrument [n]\n",
  "APOCOPATE": "to cut off the end of a word [v APOCOPATED, APOCOPATING, APOCOPATES]\n",
  "APOCOPATED": "APOCOPATE, to cut off the end of a word [v]\n",
  "APOCOPATES": "APOCOPATE, to cut off the end of a word [v]\n",
  "APOCOPATING": "APOCOPATE, to cut off the end of a word [v]\n",
  "APOCOPATION": "the cutting off of the last sound or syllable of a word [n -S]\n",
  "APOCOPATIONS": "APOCOPATION, the cutting off of the last sound or syllable of a word [n]\n",
  "APOCOPE": "the omission of the last sound, syllable, or part of a word, e.g. mag for magazine, fab for fabulous [n -S]\n",
  "APOCOPES": "APOCOPE, the omission of the last sound, syllable, or part of a word, e.g. mag for magazine, fab for fabulous [n]\n",
  "APOCOPIC": "relating to apocope, the omission of the last sound or syllable of a word [adj]\n",
  "APOCRINE": "denoting a gland whose product is formed by the breakdown of its cells [adj]\n",
  "APOCRYPHA": "APOCRYPHON, a hidden or secret thing [n]\n",
  "APOCRYPHAL": "of doubtful authenticity [adj APOCRYPHALLY]\n",
  "APOCRYPHALLY": "APOCRYPHAL, of doubtful authenticity [adv]\n",
  "APOCRYPHALNESS": "the state of being apocryphal [n]\n",
  "APOCRYPHON": "a hidden or secret thing [n APOCRYPHA]\n",
  "APOCYNACEOUS": "belonging to the periwinkle family, Apocynaceae [adj]\n",
  "APOCYNTHION": "the point at which a spacecraft in lunar orbit is furthest from the moon [n -S]\n",
  "APOCYNTHIONS": "APOCYNTHION, the point at which a spacecraft in lunar orbit is furthest from the moon [n]\n",
  "APOD": "an animal without feet or fins, also APODE [n -S]\n",
  "APODAL": "lacking feet [adj]\n",
  "APODE": "an animal without feet or fins, also APOD [n -S]\n",
  "APODEICTIC": "necessarily true; beyond contradiction, also APODEICTICAL, APODICTIC, APODICTICAL [adj APODEICTICALLY]\n",
  "APODEICTICAL": "(archaic) necessarily true, also APODEICTIC, APODICTIC, APODICTICAL [adj APODEICTICALLY]\n",
  "APODEICTICALLY": "APODEICTICAL, (archaic) necessarily true, also APODEICTIC, APODICTIC, APODICTICAL [adv]\n",
  "APODES": "APODE, an animal without feet or fins, also APOD [n]\n",
  "APODICTIC": "necessarily true; beyond contradiction, also APODEICTIC, APODEICTICAL, APODICTICAL [adj APODICTICALLY]\n",
  "APODICTICAL": "(archaic) necessarily true, also APODEICTIC, APODEICTICAL, APODICTIC [adj APODICTICALLY]\n",
  "APODICTICALLY": "APODICTICAL, (archaic) necessarily true, also APODEICTIC, APODEICTICAL, APODICTIC [adv]\n",
  "APODOSES": "APODOSIS, (Greek) the main clause of a conditional sentence [n]\n",
  "APODOSIS": "(Greek) the main clause of a conditional sentence [n APODOSES]\n",
  "APODOUS": "footless [adj]\n",
  "APODS": "APOD, an animal without feet or fins, also APODE [n]\n",
  "APODYTERIUM": "an undressing-room at a Roman bath [n -S]\n",
  "APODYTERIUMS": "APODYTERIUM, an undressing-room at a Roman bath [n]\n",
  "APOENZYME": "a protein component which combines with a coenzyme [n -S]\n",
  "APOENZYMES": "APOENZYME, a protein component which combines with a coenzyme [n]\n",
  "APOGAEIC": "relating to an apogee, the outermost point in an orbit, also APOGEAL, APOGEAN, APOGEIC [adj]\n",
  "APOGAMIC": "relating to apogamy, interbreeding in a separated group which has no characteristic differentiating it from parents [adj]\n",
  "APOGAMIES": "APOGAMY, a form of plant reproduction [n]\n",
  "APOGAMOUS": "engaging in apogamy, asexual reproduction [adj APOGAMOUSLY]\n",
  "APOGAMOUSLY": "APOGAMOUS, engaging in apogamy, asexual reproduction [adv]\n",
  "APOGAMY": "a form of plant reproduction [n APOGAMIES]\n",
  "APOGEAL": "relating to an apogee, the outermost point in an orbit, also APOGAEIC, APOGEAN, APOGEIC [adj]\n",
  "APOGEAN": "relating to an apogee, the outermost point in an orbit, also APOGAEIC, APOGEAL, APOGEIC [adj]\n",
  "APOGEE": "the farthest point from the earth of a heavenly body [n -S]\n",
  "APOGEES": "APOGEE, the farthest point from the earth of a heavenly body [n]\n",
  "APOGEIC": "relating to an apogee, the outermost point in an orbit, also APOGAEIC, APOGEAL, APOGEAN [adj]\n",
  "APOGEOTROPIC": "bending up or away from the ground [adj]\n",
  "APOGEOTROPISM": "bending up or away from the ground [n -S]\n",
  "APOGEOTROPISMS": "APOGEOTROPISM, bending up or away from the ground [n]\n",
  "APOGRAPH": "an exact copy [n -S]\n",
  "APOGRAPHS": "APOGRAPH, an exact copy [n]\n",
  "APOLAUSTIC": "the philosophy of the pleasurable [n -S]\n",
  "APOLAUSTICS": "APOLAUSTIC, the philosophy of the pleasurable [n]\n",
  "APOLIPOPROTEIN": "a protein that combines with a lipid to form a lipoprotein [n -S]\n",
  "APOLIPOPROTEINS": "APOLIPOPROTEIN, a protein that combines with a lipid to form a lipoprotein [n]\n",
  "APOLITICAL": "not political [adj APOLITICALLY]\n",
  "APOLITICALITIES": "APOLITICALITY, the quality of being apolitical [n]\n",
  "APOLITICALITY": "the quality of being apolitical [n APOLITICALITIES]\n",
  "APOLITICALLY": "APOLITICAL, not political [adv]\n",
  "APOLITICISM": "being uninterested in politics [n -S]\n",
  "APOLITICISMS": "APOLITICISM, being uninterested in politics [n]\n",
  "APOLLO": "(Greek) a large tropical butterfly [n -S]\n",
  "APOLLONIAN": "in the philosophy of Nietzsche, denoting or relating to the set of static qualities that encompass form, reason, harmony [adj]\n",
  "APOLLONICON": "a gigantic barrel organ, partly automatic [n -S]\n",
  "APOLLONICONS": "APOLLONICON, a gigantic barrel organ, partly automatic [n]\n",
  "APOLLOS": "APOLLO, (Greek) a large tropical butterfly [n]\n",
  "APOLOG": "a story presenting a moral principle, also APOLOGUE [n -S]\n",
  "APOLOGAL": "relating to an apolog, a beast fable, a moral tale [adj]\n",
  "APOLOGETIC": "expressing apology [adj APOLOGETICALLY] / a formal defense or apology [n -S]\n",
  "APOLOGETICAL": "expressing apology, also APOLOGETIC [adj APOLOGETICALLY]\n",
  "APOLOGETICALLY": "APOLOGETICAL, expressing apology, also APOLOGETIC [adv]\n",
  "APOLOGETICS": "defense and proof of Christianity or other doctrine [n]\n",
  "APOLOGIA": "(Latin) a written defence [n APOLOGIAS or APOLOGIAE]\n",
  "APOLOGIAE": "APOLOGIA, (Latin) a written defence [n]\n",
  "APOLOGIAS": "APOLOGIA, (Latin) a written defence [n]\n",
  "APOLOGIES": "APOLOGY, an explanation with expression of regret [n]\n",
  "APOLOGISE": "to express regret, also APOLOGIZE [v APOLOGISED, APOLOGISING, APOLOGISES]\n",
  "APOLOGISED": "APOLOGISE, to express regret, also APOLOGIZE [v]\n",
  "APOLOGISER": "one who apologises, also APOLOGIZER [n -S]\n",
  "APOLOGISERS": "APOLOGISER, one who apologises, also APOLOGIZER [n]\n",
  "APOLOGISES": "APOLOGISE, to express regret, also APOLOGIZE [v]\n",
  "APOLOGISING": "APOLOGISE, to express regret, also APOLOGIZE [v]\n",
  "APOLOGIST": "a defender by argument [n -S]\n",
  "APOLOGISTS": "APOLOGIST, a defender by argument [n]\n",
  "APOLOGIZE": "to express regret, also APOLOGISE [v APOLOGIZED, APOLOGIZING, APOLOGIZES]\n",
  "APOLOGIZED": "APOLOGIZE, to express regret, also APOLOGISE [v]\n",
  "APOLOGIZER": "one who apologises, also APOLOGISER [n -S]\n",
  "APOLOGIZERS": "APOLOGIZER, one who apologises, also APOLOGISER [n]\n",
  "APOLOGIZES": "APOLOGIZE, to express regret, also APOLOGISE [v]\n",
  "APOLOGIZING": "APOLOGIZE, to express regret, also APOLOGISE [v]\n",
  "APOLOGS": "APOLOG, a story presenting a moral principle, also APOLOGUE [n]\n",
  "APOLOGUE": "a story presenting a moral principle, also APOLOG [n -S]\n",
  "APOLOGUES": "APOLOGUE, a story presenting a moral principle, also APOLOG [n]\n",
  "APOLOGY": "an explanation with expression of regret [n APOLOGIES]\n",
  "APOLUNE": "the point in the orbit of a body revolving round the moon that is farthest from the centre of the moon [n -S]\n",
  "APOLUNES": "APOLUNE, the point in the orbit of a body revolving round the moon that is farthest from the centre of the moon [n]\n",
  "APOMICT": "an organism reproducing by, or formed by, apomixis, nonsexual reproduction from an unfertilized ovum [n -S]\n",
  "APOMICTIC": "relating to apomixis, nonsexual reproduction, from an unfertilized ovum, also APOMICTICAL [adj APOMICTICALLY]\n",
  "APOMICTICAL": "relating to apomixis, nonsexual reproduction, from an unfertilized ovum, also APOMICTIC [adj APOMICTICALLY]\n",
  "APOMICTICALLY": "APOMICTICAL, relating to apomixis, nonsexual reproduction, from an unfertilized ovum, also APOMICTIC [adv]\n",
  "APOMICTS": "APOMICT, an organism reproducing by, or formed by, apomixis, nonsexual reproduction from an unfertilized ovum [n]\n",
  "APOMIXES": "APOMIXIS, (Greek) nonsexual reproduction, from an apomict or unfertilized ovum [n]\n",
  "APOMIXIS": "(Greek) nonsexual reproduction, from an apomict or unfertilized ovum [n APOMIXES]\n",
  "APOMORPHIA": "an alkaloid prepared by dehydrating morphine, also APOMORPHINE [n -S]\n",
  "APOMORPHIAS": "APOMORPHIA, an alkaloid prepared by dehydrating morphine, also APOMORPHINE [n]\n",
  "APOMORPHINE": "an alkaloid prepared by dehydrating morphine, also APOMORPHIA [n -S]\n",
  "APOMORPHINES": "APOMORPHINE, an alkaloid prepared by dehydrating morphine, also APOMORPHIA [n]\n",
  "APONEUROSES": "APONEUROSIS, a sheet that connects muscle to tendon [n]\n",
  "APONEUROSIS": "a sheet that connects muscle to tendon [n APONEUROSES]\n",
  "APONEUROTIC": "relating to an aponeurosis, a sheet that connects muscle to tendon [adj]\n",
  "APOOP": "on the poop, astern [adv]\n",
  "APOPEMPTIC": "relating to departing or leave-taking; valedictory [adj] / a parting address [n -S]\n",
  "APOPEMPTICS": "APOPEMPTIC, a parting address [n]\n",
  "APOPHASES": "APOPHASIS, the rhetorical device of emphasizing a fact, by pretending to ignore or deny it [n]\n",
  "APOPHASIS": "the rhetorical device of emphasizing a fact, by pretending to ignore or deny it [n APOPHASES]\n",
  "APOPHATIC": "emphasizing a fact, by pretending to ignore or deny it [adj]\n",
  "APOPHENIA": "the tendency to mistakenly perceive connections and meaning between unrelated things [n -S]\n",
  "APOPHENIAS": "APOPHENIA, the tendency to mistakenly perceive connections and meaning between unrelated things [n]\n",
  "APOPHLEGMATIC": "an agent preventing the flow of mucus [n -S]\n",
  "APOPHLEGMATICS": "APOPHLEGMATIC, an agent preventing the flow of mucus [n]\n",
  "APOPHONIES": "APOPHONY, a change in root vowels of verb forms [n]\n",
  "APOPHONY": "a change in root vowels of verb forms [n APOPHONIES]\n",
  "APOPHTHEGM": "(Greek) a short, pithy and instructive saying or formulation, also APOTHEGM [n -S]\n",
  "APOPHTHEGMATIC": "relating to an apophthegm [adj]\n",
  "APOPHTHEGMATISE": "to speak in apophthegms, also APOPHTHEGMATIZE [v]\n",
  "APOPHTHEGMATIST": "one who speaks in apophthegms, also APOTHEGMATIST [n]\n",
  "APOPHTHEGMATIZE": "to speak in apophthegms, also APOPHTHEGMATISE [v]\n",
  "APOPHTHEGMS": "APOPHTHEGM, (Greek) a short, pithy and instructive saying or formulation, also APOTHEGM [n]\n",
  "APOPHYGE": "(Greek) the curve where a column merges in its base or capital [n -S]\n",
  "APOPHYGES": "APOPHYGE, (Greek) the curve where a column merges in its base or capital [n]\n",
  "APOPHYLLITE": "a mineral, hydrated calcium potassium silicate, that exfoliates on heating [n -S]\n",
  "APOPHYLLITES": "APOPHYLLITE, a mineral, hydrated calcium potassium silicate, that exfoliates on heating [n]\n",
  "APOPHYSATE": "relating to an apophysis, an expanded or projecting part of an organism, esp. of bone, also APOPHYSEAL, APOPHYSIAL [adj]\n",
  "APOPHYSEAL": "relating to an apophysis, an expanded or projecting part of an organism, esp. of bone, also APOPHYSATE, APOPHYSIAL [adj]\n",
  "APOPHYSES": "APOPHYSIS, an expanded or projecting part of an organism, esp. of bone [n]\n",
  "APOPHYSIAL": "relating to an apophysis, an expanded or projecting part of an organism, esp. of bone, also APOPHYSATE, APOPHYSEAL [adj]\n",
  "APOPHYSIS": "an expanded or projecting part of an organism, esp. of bone [n APOPHYSES]\n",
  "APOPLAST": "the non-protoplasmic component of a plant, including the cell walls and intercellular material [n -S]\n",
  "APOPLASTS": "APOPLAST, the non-protoplasmic component of a plant, including the cell walls and intercellular material [n]\n",
  "APOPLECTIC": "suffering from apoplexy, also APOPLECTICAL [adj APOPLECTICALLY] / someone suffering from apoplexy [n -S]\n",
  "APOPLECTICAL": "(archaic) apoplectic, also APOPLECTIC [adj]\n",
  "APOPLECTICALLY": "APOPLECTICAL, (archaic) apoplectic, also APOPLECTIC [adv]\n",
  "APOPLECTICS": "APOPLECTIC, someone suffering from apoplexy [n]\n",
  "APOPLEX": "to affect with apoplexy [v -ED, -ING, -ES]\n",
  "APOPLEXED": "APOPLEX, to affect with apoplexy [v]\n",
  "APOPLEXES": "APOPLEX, to affect with apoplexy [v]\n",
  "APOPLEXIES": "APOPLEXY, a sudden loss of sensation and movement due to a disturbance of blood supply to the brain [n]\n",
  "APOPLEXING": "APOPLEX, to affect with apoplexy [v]\n",
  "APOPLEXY": "a sudden loss of sensation and movement due to a disturbance of blood supply to the brain [n APOPLEXIES]\n",
  "APOPROTEIN": "the protein component of a conjugated protein [n -S]\n",
  "APOPROTEINS": "APOPROTEIN, the protein component of a conjugated protein [n]\n",
  "APOPTOSES": "APOPTOSIS, the natural self-destruction of cells in a growing organism [n]\n",
  "APOPTOSIS": "the natural self-destruction of cells in a growing organism [n APOPTOSES]\n",
  "APOPTOTIC": "relating to apoptosis, the natural destruction of cells in a growing organism [adj]\n",
  "APORETIC": "relating to aporia, a professed doubt of what to say or to choose [adj]\n",
  "APORIA": "a professed doubt of what to say or to choose, as in 'to be or not to be' [n -S]\n",
  "APORIAS": "APORIA, a professed doubt of what to say or to choose, as in 'to be or not to be' [n]\n",
  "APORT": "towards the left side of a ship [adv]\n",
  "APOS": "APO, (short for) apolipoprotein, a type of protein [n]\n",
  "APOSEMATIC": "giving warning, applied to coloration, odour, etc., of animals [adj APOSEMATICALLY]\n",
  "APOSEMATICALLY": "APOSEMATIC, giving warning, applied to coloration, odour, etc., of animals [adv]\n",
  "APOSIOPESES": "APOSIOPESIS, a conscious breaking off in the middle of a sentence [n]\n",
  "APOSIOPESIS": "a conscious breaking off in the middle of a sentence [n APOSIOPESES]\n",
  "APOSIOPETIC": "relating to aposiopesis [adj]\n",
  "APOSITIA": "(Greek) an aversion to food [n -S]\n",
  "APOSITIAS": "APOSITIA, (Greek) an aversion to food [n]\n",
  "APOSITIC": "having an aversion to food [adj]\n",
  "APOSPORIC": "relating to apospory, the development of prothalli [adj]\n",
  "APOSPORIES": "APOSPORY, reproduction without spore formation [n]\n",
  "APOSPOROUS": "showing apospory, the development of prothalli from direct outgrowths from the fern frond [adj]\n",
  "APOSPORY": "reproduction without spore formation [n APOSPORIES]\n",
  "APOSTACIES": "APOSTACY, abandonment of one's faith or beliefs, also APOSTASY [n]\n",
  "APOSTACY": "abandonment of one's faith or beliefs, also APOSTASY [n APOSTACIES]\n",
  "APOSTASIES": "APOSTASY, abandonment of one's faith or beliefs, also APOSTACY [n]\n",
  "APOSTASY": "abandonment of one's faith or beliefs, also APOSTACY [n APOSTASIES]\n",
  "APOSTATE": "one who commits apostasy [n -S]\n",
  "APOSTATES": "APOSTATE, one who commits apostasy [n]\n",
  "APOSTATIC": "of the nature of apostates or apostasy, also APOSTATICAL [adj]\n",
  "APOSTATICAL": "of the nature of apostates or apostasy; heretical, also APOSTATIC [adj]\n",
  "APOSTATISE": "to change one's religious allegiance; forsake one's principles, also APOSTATIZE [v APOSTATISED, APOSTATISING, APOSTATISES]\n",
  "APOSTATISED": "APOSTATISE, to change one's religious allegiance; forsake one's principles, also APOSTATIZE [v]\n",
  "APOSTATISES": "APOSTATISE, to change one's religious allegiance; forsake one's principles, also APOSTATIZE [v]\n",
  "APOSTATISING": "APOSTATISE, to change one's religious allegiance; forsake one's principles, also APOSTATIZE [v]\n",
  "APOSTATIZE": "to change one's religious allegiance; forsake one's principles, also APOSTATISE [v APOSTATIZED, APOSTATIZING, APOSTATIZES]\n",
  "APOSTATIZED": "APOSTATIZE, to change one's religious allegiance; forsake one's principles, also APOSTATISE [v]\n",
  "APOSTATIZES": "APOSTATIZE, to change one's religious allegiance; forsake one's principles, also APOSTATISE [v]\n",
  "APOSTATIZING": "APOSTATIZE, to change one's religious allegiance; forsake one's principles, also APOSTATISE [v]\n",
  "APOSTIL": "(French) a marginal note, also APOSTILLE [n -S]\n",
  "APOSTILLE": "(French) a marginal note, also APOSTIL [n -S]\n",
  "APOSTILLES": "APOSTILLE, (French) a marginal note, also APOSTIL [n]\n",
  "APOSTILS": "APOSTIL, (French) a marginal note, also APOSTILLE [n]\n",
  "APOSTLE": "one sent by Christ to preach the gospel [n -S]\n",
  "APOSTLES": "APOSTLE, one sent by Christ to preach the gospel [n]\n",
  "APOSTLESHIP": "the state of being an apostle [n -S]\n",
  "APOSTLESHIPS": "APOSTLESHIP, the state of being an apostle [n]\n",
  "APOSTOLATE": "the office of an apostle [n -S]\n",
  "APOSTOLATES": "APOSTOLATE, the office of an apostle [n]\n",
  "APOSTOLIC": "relating to the office of apostle, also APOSTOLICAL [adj APOSTOLICALLY]\n",
  "APOSTOLICAL": "relating to the office of apostle, also APOSTOLIC [adj APOSTOLICALLY]\n",
  "APOSTOLICALLY": "APOSTOLICAL, relating to the office of apostle, also APOSTOLIC [adv]\n",
  "APOSTOLICISM": "the quality of being apostolic [n -S]\n",
  "APOSTOLICISMS": "APOSTOLICISM, the quality of being apostolic [n]\n",
  "APOSTOLICITIES": "APOSTOLICITY, the quality of being apostolic [n]\n",
  "APOSTOLICITY": "the quality of being apostolic [n APOSTOLICITIES]\n",
  "APOSTOLISE": "to preach, also APOSTOLIZE [v APOSTOLISED, APOSTOLISING, APOSTOLISES]\n",
  "APOSTOLISED": "APOSTOLISE, to preach, also APOSTOLIZE [v]\n",
  "APOSTOLISES": "APOSTOLISE, to preach, also APOSTOLIZE [v]\n",
  "APOSTOLISING": "APOSTOLISE, to preach, also APOSTOLIZE [v]\n",
  "APOSTOLIZE": "to preach, also APOSTOLISE [v APOSTOLIZED, APOSTOLIZING, APOSTOLIZES]\n",
  "APOSTOLIZED": "APOSTOLIZE, to preach, also APOSTOLISE [v]\n",
  "APOSTOLIZES": "APOSTOLIZE, to preach, also APOSTOLISE [v]\n",
  "APOSTOLIZING": "APOSTOLIZE, to preach, also APOSTOLISE [v]\n",
  "APOSTROPHE": "the addressing of a personified thing rhetorically [n -S]\n",
  "APOSTROPHES": "APOSTROPHE, the addressing of a personified thing rhetorically [n]\n",
  "APOSTROPHIC": "relating to apostrophe [adj]\n",
  "APOSTROPHISE": "to address an inanimate object, also APOSTROPHIZE [v APOSTROPHISED, APOSTROPHISING, APOSTROPHISES]\n",
  "APOSTROPHISED": "APOSTROPHISE, to address an inanimate object, also APOSTROPHIZE [v]\n",
  "APOSTROPHISES": "APOSTROPHISE, to address an inanimate object, also APOSTROPHIZE [v]\n",
  "APOSTROPHISING": "APOSTROPHISE, to address an inanimate object, also APOSTROPHIZE [v]\n",
  "APOSTROPHIZE": "to address by or in apostrophe, also APOSTROPHISE [v APOSTROPHIZED, APOSTROPHIZING, APOSTROPHIZES]\n",
  "APOSTROPHIZED": "APOSTROPHIZE, to address by or in apostrophe, also APOSTROPHISE [v]\n",
  "APOSTROPHIZES": "APOSTROPHIZE, to address by or in apostrophe, also APOSTROPHISE [v]\n",
  "APOSTROPHIZING": "APOSTROPHIZE, to address by or in apostrophe, also APOSTROPHISE [v]\n",
  "APOSTROPHUS": "(Greek) a symbol resembling a reversed letter C used in Roman numerals to denote large numbers [n -ES]\n",
  "APOSTROPHUSES": "APOSTROPHUS, (Greek) a symbol resembling a reversed letter C used in Roman numerals to denote large numbers [n]\n",
  "APOTHECARIES": "APOTHECARY, one who prepares and sells drugs or compounds for medicinal purposes, also POTHECARY, POTICARY, POTTINGAR [n]\n",
  "APOTHECARY": "one who prepares and sells drugs or compounds for medicinal purposes, also POTHECARY, POTICARY, POTTINGAR [n APOTHECARIES]\n",
  "APOTHECE": "the spore-producing organ of certain fungi [n -S]\n",
  "APOTHECES": "APOTHECE, the spore-producing organ of certain fungi [n]\n",
  "APOTHECIA": "APOTHECIUM, the spore-producing organ of certain fungi, also APOTHECE [n]\n",
  "APOTHECIAL": "relating to an apothecium, an open cup- or disc-shaped fruiting body borne by many lichens [adj]\n",
  "APOTHECIUM": "the spore-producing organ of certain fungi, also APOTHECE [n APOTHECIA]\n",
  "APOTHEGM": "(Greek) a short, pithy and instructive saying or formulation, also APOPHTHEGM [n -S]\n",
  "APOTHEGMATIC": "of or like an apothegm, also APOTHEGMATICAL [adj]\n",
  "APOTHEGMATICAL": "of or like an apophthegm, also APOTHEGMATIC [adj]\n",
  "APOTHEGMATISE": "to speak in apothegms, also APOTHEGMATIZE [v APOTHEGMATISED, APOTHEGMATISING, APOTHEGMATISES]\n",
  "APOTHEGMATISED": "APOTHEGMATISE, to speak in apothegms, also APOTHEGMATIZE [v]\n",
  "APOTHEGMATISES": "APOTHEGMATISE, to speak in apothegms, also APOTHEGMATIZE [v]\n",
  "APOTHEGMATISING": "APOTHEGMATISE, to speak in apothegms, also APOTHEGMATIZE [v]\n",
  "APOTHEGMATIST": "one who speaks in apothegms, also APOPHTHEGMATIST [n -S]\n",
  "APOTHEGMATISTS": "APOTHEGMATIST, one who speaks in apothegms, also APOPHTHEGMATIST [n]\n",
  "APOTHEGMATIZE": "to speak in apothegms, also APOTHEGMATISE [v APOTHEGMATIZED, APOTHEGMATIZING, APOTHEGMATIZES]\n",
  "APOTHEGMATIZED": "APOTHEGMATIZE, to speak in apothegms, also APOTHEGMATISE [v]\n",
  "APOTHEGMATIZES": "APOTHEGMATIZE, to speak in apothegms, also APOTHEGMATISE [v]\n",
  "APOTHEGMATIZING": "APOTHEGMATIZE, to speak in apothegms, also APOTHEGMATISE [v]\n",
  "APOTHEGMS": "APOTHEGM, (Greek) a short, pithy and instructive saying or formulation, also APOPHTHEGM [n]\n",
  "APOTHEM": "(Greek) the perpendicular from centre to the side of a polygon [n -S]\n",
  "APOTHEMS": "APOTHEM, (Greek) the perpendicular from centre to the side of a polygon [n]\n",
  "APOTHEOSES": "APOTHEOSIS, a perfect example of its type [n]\n",
  "APOTHEOSIS": "a perfect example of its type [n APOTHEOSES]\n",
  "APOTHEOSISE": "to bring to perfection, also APOTHEOSIZE [v APOTHEOSISED, APOTHEOSISING, APOTHEOSISES]\n",
  "APOTHEOSISED": "APOTHEOSISE, to bring to perfection, also APOTHEOSIZE [v]\n",
  "APOTHEOSISES": "APOTHEOSISE, to bring to perfection, also APOTHEOSIZE [v]\n",
  "APOTHEOSISING": "APOTHEOSISE, to bring to perfection, also APOTHEOSIZE [v]\n",
  "APOTHEOSIZE": "to bring to perfection, also APOTHEOSISE [v APOTHEOSIZED, APOTHEOSIZING, APOTHEOSIZES]\n",
  "APOTHEOSIZED": "APOTHEOSIZE, to bring to perfection, also APOTHEOSISE [v]\n",
  "APOTHEOSIZES": "APOTHEOSIZE, to bring to perfection, also APOTHEOSISE [v]\n",
  "APOTHEOSIZING": "APOTHEOSIZE, to bring to perfection, also APOTHEOSISE [v]\n",
  "APOTROPAIC": "averting or combating evil [adj APOTROPAICALLY]\n",
  "APOTROPAICALLY": "APOTROPAIC, averting or combating evil [adv]\n",
  "APOTROPAISM": "a magical practice averting evil [n -S]\n",
  "APOTROPAISMS": "APOTROPAISM, a magical practice averting evil [n]\n",
  "APOTROPOUS": "anatropous with a ventral raphe [adj]\n",
  "APOZEM": "(Greek) a medicine obtained by boiling [n -S]\n",
  "APOZEMS": "APOZEM, (Greek) a medicine obtained by boiling [n]\n",
  "APP": "(short for) application program [n -S]\n",
  "APPAID": "APPAY, to satisfy, also APAY [v]\n",
  "APPAIR": "(obsolete) to impair [v -ED, -ING, -S]\n",
  "APPAIRED": "APPAIR, (obsolete) to impair [v]\n",
  "APPAIRING": "APPAIR, (obsolete) to impair [v]\n",
  "APPAIRS": "APPAIR, (obsolete) to impair [v]\n",
  "APPAL": "to horrify, also APPALL [v APPALLED, APPALLING, APPALS]\n",
  "APPALL": "to horrify, also APPAL [v -ED, -ING, -S]\n",
  "APPALLED": "APPALL, to horrify, also APPAL [v]\n",
  "APPALLING": "APPALL, to horrify, also APPAL [v]\n",
  "APPALLINGLY": "APPALLING, APPALL, to horrify, also APPAL [adv]\n",
  "APPALLS": "APPALL, to horrify, also APPAL [v]\n",
  "APPALOOSA": "a North American breed of horse [n -S]\n",
  "APPALOOSAS": "APPALOOSA, a North American breed of horse [n]\n",
  "APPALS": "APPAL, to horrify, also APPALL [v]\n",
  "APPALTI": "APPALTO, (Italian) a contract or monopoly [n]\n",
  "APPALTO": "(Italian) a contract or monopoly [n APPALTI]\n",
  "APPANAGE": "a provision for maintenance, esp. of a king's younger child, also APANAGE [n -S]\n",
  "APPANAGED": "endowed with an appanage, a provision for maintenance, esp. of a king's younger child [adj]\n",
  "APPANAGES": "APPANAGE, a provision for maintenance, esp. of a king's younger child, also APANAGE [n]\n",
  "APPARAT": "(Russian) the structure, mechanism, etc. of an organization, esp. a political one [n -S]\n",
  "APPARATCHIK": "(Russian) a member of the (Soviet) bureaucracy; now extended to apply to any inflexible organisation man, particularly in a political party [n APPARATCHIKS or APPARATCHIKI]\n",
  "APPARATCHIKI": "APPARATCHIK, (Russian) a member of the (Soviet) bureaucracy; now extended to apply to any inflexible organisation man, particularly in a political party [n]\n",
  "APPARATCHIKS": "APPARATCHIK, (Russian) a member of the (Soviet) bureaucracy; now extended to apply to any inflexible organisation man, particularly in a political party [n]\n",
  "APPARATS": "APPARAT, (Russian) the structure, mechanism, etc. of an organization, esp. a political one [n]\n",
  "APPARATUS": "things prepared or provided [n -ES]\n",
  "APPARATUSES": "APPARATUS, things prepared or provided [n]\n",
  "APPAREL": "to dress [v APPARELED or APPARELLED, APPARELING or APPARELLING, APPARELS]\n",
  "APPARELED": "APPAREL, to dress [v]\n",
  "APPARELING": "APPAREL, to dress [v]\n",
  "APPARELLED": "APPAREL, to dress [v]\n",
  "APPARELLING": "APPAREL, to dress [v]\n",
  "APPARELMENT": "apparel, dress [n -S]\n",
  "APPARELMENTS": "APPARELMENT, apparel, dress [n]\n",
  "APPARELS": "APPAREL, to dress [v]\n",
  "APPARENCIES": "APPARENCY, (archaic) apparentness [n]\n",
  "APPARENCY": "(archaic) apparentness [n APPARENCIES]\n",
  "APPARENT": "seeming [adj APPARENTLY] / (Shakespeare) an heir-apparent [n -S]\n",
  "APPARENTLY": "APPARENT, seeming [adv]\n",
  "APPARENTNESS": "the state of being apparent [n -ES]\n",
  "APPARENTNESSES": "APPARENTNESS, the state of being apparent [n]\n",
  "APPARENTS": "APPARENT, (Shakespeare) an heir-apparent [n]\n",
  "APPARITION": "an unusual or unexpected sight [n -S]\n",
  "APPARITIONAL": "of or like an apparition [adj]\n",
  "APPARITIONS": "APPARITION, an unusual or unexpected sight [n]\n",
  "APPARITOR": "an officer in court who attends to execute orders, also PARITOR [n -S]\n",
  "APPARITORS": "APPARITOR, an officer in court who attends to execute orders, also PARITOR [n]\n",
  "APPARTEMENT": "(French) a set of rooms in a house for an individual or a family [n -S]\n",
  "APPARTEMENTS": "APPARTEMENT, (French) a set of rooms in a house for an individual or a family [n]\n",
  "APPASSIONATO": "to be performed in an impassioned manner [adv]\n",
  "APPAY": "to satisfy, also APAY [v APPAYD or APPAID, APPAYING, APPAYS]\n",
  "APPAYD": "APPAY, to satisfy, also APAY [v]\n",
  "APPAYING": "APPAY, to satisfy, also APAY [v]\n",
  "APPAYS": "APPAY, to satisfy, also APAY [v]\n",
  "APPEACH": "(Shakespeare) to accuse, impeach [v -ED, -ING, -ES]\n",
  "APPEACHED": "APPEACH, (Shakespeare) to accuse, impeach [v]\n",
  "APPEACHES": "APPEACH, (Shakespeare) to accuse, impeach [v]\n",
  "APPEACHING": "APPEACH, (Shakespeare) to accuse, impeach [v]\n",
  "APPEACHMENT": "(Shakespeare) the act of appeaching [n -S]\n",
  "APPEACHMENTS": "APPEACHMENT, (Shakespeare) the act of appeaching [n]\n",
  "APPEAL": "to make an earnest request [v -ED, -ING, -S]\n",
  "APPEALABILITIES": "APPEALABILITY, the quality of being appealable [n]\n",
  "APPEALABILITY": "the quality of being appealable [n APPEALABILITIES]\n",
  "APPEALABLE": "capable of being appealed against; that may be removed to a higher tribunal for decision; as, the cause is appealable [adj]\n",
  "APPEALED": "APPEAL, to make an earnest request [v]\n",
  "APPEALER": "one who appeals [n -S]\n",
  "APPEALERS": "APPEALER, one who appeals [n]\n",
  "APPEALING": "APPEAL, to make an earnest request [v]\n",
  "APPEALINGLY": "APPEALING [adv]\n",
  "APPEALINGNESS": "the state of being appealing [n -ES]\n",
  "APPEALINGNESSES": "APPEALINGNESS, the state of being appealing [n]\n",
  "APPEALS": "APPEAL, to make an earnest request [v]\n",
  "APPEAR": "to become visible [v -ED, -ING, -S]\n",
  "APPEARANCE": "external show [n -S]\n",
  "APPEARANCES": "APPEARANCE, external show [n]\n",
  "APPEARED": "APPEAR, to become visible [v]\n",
  "APPEARER": "one who appears [n -S]\n",
  "APPEARERS": "APPEARER, one who appears [n]\n",
  "APPEARING": "APPEAR, to become visible [v]\n",
  "APPEARS": "APPEAR, to become visible [v]\n",
  "APPEASABLE": "capable of being appeased or pacified; placable [adj]\n",
  "APPEASE": "to bring to a state of peace or contentment [v APPEASED, APPEASING, APPEASES]\n",
  "APPEASED": "APPEASE, to bring to a state of peace or contentment [v]\n",
  "APPEASEMENT": "the act of appeasing [n -S]\n",
  "APPEASEMENTS": "APPEASEMENT, the act of appeasing [n]\n",
  "APPEASER": "one who appeases [n -S]\n",
  "APPEASERS": "APPEASER, one who appeases [n]\n",
  "APPEASES": "APPEASE, to bring to a state of peace or contentment [v]\n",
  "APPEASING": "APPEASE, to bring to a state of peace or contentment [v]\n",
  "APPEASINGLY": "APPEASING, APPEASE, to bring to a state of peace or contentment [adv]\n",
  "APPEL": "(French) in fencing, a stamp of the foot in a false attack, in order to create an opening for a hit [n -S]\n",
  "APPELLANT": "a person who makes an appeal to a higher court or authority [n -S]\n",
  "APPELLANTS": "APPELLANT, a person who makes an appeal to a higher court or authority [n]\n",
  "APPELLATE": "relating to appeals; (of a tribunal) having the power to review cases on appeal [adj]\n",
  "APPELLATION": "a name or title [n -S]\n",
  "APPELLATIONAL": "of or like an appellation [adj]\n",
  "APPELLATIONS": "APPELLATION, a name or title [n]\n",
  "APPELLATIVE": "relating to naming [adj APPELLATIVELY] / a common noun or common name (as distinguished from a proper name) [n -S]\n",
  "APPELLATIVELY": "APPELLATIVE, relating to naming [adv]\n",
  "APPELLATIVES": "APPELLATIVE, a common noun or common name (as distinguished from a proper name) [n]\n",
  "APPELLEE": "the defendant in a judicial proceeding [n -S]\n",
  "APPELLEES": "APPELLEE, the defendant in a judicial proceeding [n]\n",
  "APPELLOR": "in law, the accuser or prosecutor [n -S]\n",
  "APPELLORS": "APPELLOR, in law, the accuser or prosecutor [n]\n",
  "APPELS": "APPEL, (French) in fencing, a stamp of the foot in a false attack, in order to create an opening for a hit [n]\n",
  "APPEND": "to add on to [v -ED, -ING, -S]\n",
  "APPENDAGE": "something appended [n -S]\n",
  "APPENDAGES": "APPENDAGE, something appended [n]\n",
  "APPENDANT": "attached, annexed [adj] / an adjunct, an appendage, also APPENDENT [n -S]\n",
  "APPENDANTS": "APPENDANT, an adjunct, an appendage, also APPENDENT [n]\n",
  "APPENDECTOMIES": "APPENDECTOMY, the surgical removal of the appendix, also APPENDICECTOMY [n]\n",
  "APPENDECTOMY": "the surgical removal of the appendix, also APPENDICECTOMY [n APPENDECTOMIES]\n",
  "APPENDED": "APPEND, to add on to [v]\n",
  "APPENDENT": "an adjunct, an appendage, also APPENDANT [n -S]\n",
  "APPENDENTS": "APPENDENT, an adjunct, an appendage, also APPENDANT [n]\n",
  "APPENDICECTOMY": "the surgical removal of the appendix, also APPENDECTOMY [n]\n",
  "APPENDICES": "APPENDIX, something added on [n]\n",
  "APPENDICITIS": "inflammation of the appendix [n -ES]\n",
  "APPENDICITISES": "APPENDICITIS, inflammation of the appendix [n]\n",
  "APPENDICLE": "a small appendage [n -S]\n",
  "APPENDICLES": "APPENDICLE, a small appendage [n]\n",
  "APPENDICULAR": "of or relating to an appendage and esp. a limb [adj]\n",
  "APPENDICULARIAN": "a member of the Appendicularia, a genus of ascidians [n]\n",
  "APPENDICULATE": "having small appendages attached [adj]\n",
  "APPENDING": "APPEND, to add on to [v]\n",
  "APPENDIX": "something added on [n APPENDIXES or APPENDICES]\n",
  "APPENDIXES": "APPENDIX, something added on [n]\n",
  "APPENDS": "APPEND, to add on to [v]\n",
  "APPERCEIVE": "to perceive an inner meaning [v APPERCEIVED, APPERCEIVING, APPERCEIVES]\n",
  "APPERCEIVED": "APPERCEIVE, to perceive an inner meaning [v]\n",
  "APPERCEIVES": "APPERCEIVE, to perceive an inner meaning [v]\n",
  "APPERCEIVING": "APPERCEIVE, to perceive an inner meaning [v]\n",
  "APPERCEPTION": "the mind's perception of itself as a conscious agent [n -S]\n",
  "APPERCEPTIONS": "APPERCEPTION, the mind's perception of itself as a conscious agent [n]\n",
  "APPERCEPTIVE": "relating to apperception [adj]\n",
  "APPERCIPIENT": "relating to apperception [adj]\n",
  "APPERIL": "(Shakespeare) peril, also APPERILL [n -S]\n",
  "APPERILL": "(Shakespeare) peril, also APPERIL [n -S]\n",
  "APPERILLS": "APPERILL, (Shakespeare) peril, also APPERIL [n]\n",
  "APPERILS": "APPERIL, (Shakespeare) peril, also APPERILL [n]\n",
  "APPERTAIN": "to relate to [v -ED, -ING, -S]\n",
  "APPERTAINANCE": "(obsolete) an appurtenance [n -S]\n",
  "APPERTAINANCES": "APPERTAINANCE, (obsolete) an appurtenance [n]\n",
  "APPERTAINED": "APPERTAIN, to relate to [v]\n",
  "APPERTAINING": "APPERTAIN, to relate to [v]\n",
  "APPERTAINMENT": "(Shakespeare) an appurtenance [n -S]\n",
  "APPERTAINMENTS": "APPERTAINMENT, (Shakespeare) an appurtenance [n]\n",
  "APPERTAINS": "APPERTAIN, to relate to [v]\n",
  "APPERTINENT": "appertaining [adj] / (Shakespeare) an appurtenance [n -S]\n",
  "APPERTINENTS": "APPERTINENT, (Shakespeare) an appurtenance [n]\n",
  "APPESTAT": "a neural centre in the hypothalamus believed to control (food) appetite [n -S]\n",
  "APPESTATS": "APPESTAT, a neural centre in the hypothalamus believed to control (food) appetite [n]\n",
  "APPETEEZEMENT": "(Scott) appetisement [n -S]\n",
  "APPETEEZEMENTS": "APPETEEZEMENT, (Scott) appetisement [n]\n",
  "APPETENCE": "strong craving or powerful desire, also APPETENCY [n -S]\n",
  "APPETENCES": "APPETENCE, strong craving or powerful desire, also APPETENCY [n]\n",
  "APPETENCIES": "APPETENCY, strong craving or powerful desire, also APPETENCE [n]\n",
  "APPETENCY": "strong craving or powerful desire, also APPETENCE [n APPETENCIES]\n",
  "APPETENT": "craving [adj]\n",
  "APPETIBLE": "desirable [adj]\n",
  "APPETISE": "to whet the appetite, also APPETIZE [v APPETISED, APPETISING, APPETISES]\n",
  "APPETISED": "APPETISE, to whet the appetite, also APPETIZE [v]\n",
  "APPETISEMENT": "the state of being appetising [n -S]\n",
  "APPETISEMENTS": "APPETISEMENT, the state of being appetising [n]\n",
  "APPETISER": "something that whets the appetite, also APPETIZER [n -S]\n",
  "APPETISERS": "APPETISER, something that whets the appetite, also APPETIZER [n]\n",
  "APPETISES": "APPETISE, to whet the appetite, also APPETIZE [v]\n",
  "APPETISING": "APPETISE, to whet the appetite, also APPETIZE [v]\n",
  "APPETISINGLY": "APPETISING, APPETISE, to whet the appetite, also APPETIZE [adv]\n",
  "APPETITE": "a desire for food or drink [n -S]\n",
  "APPETITES": "APPETITE, a desire for food or drink [n]\n",
  "APPETITION": "(archaic) direction of desire [n -S]\n",
  "APPETITIONS": "APPETITION, (archaic) direction of desire [n]\n",
  "APPETITIVE": "having or giving an appetite [adj]\n",
  "APPETIZE": "to whet the appetite, also APPETISE [v APPETIZED, APPETIZING, APPETIZES]\n",
  "APPETIZED": "APPETIZE, to whet the appetite, also APPETISE [v]\n",
  "APPETIZER": "something that whets the appetite, also APPETISER [n -S]\n",
  "APPETIZERS": "APPETIZER, something that whets the appetite, also APPETISER [n]\n",
  "APPETIZES": "APPETIZE, to whet the appetite, also APPETISE [v]\n",
  "APPETIZING": "APPETIZE, to whet the appetite, also APPETISE [v]\n",
  "APPETIZINGLY": "APPETIZING, APPETIZE, to whet the appetite, also APPETISE [adv]\n",
  "APPLAUD": "to express approval by clapping the hands [v -ED, -ING, -S]\n",
  "APPLAUDABLE": "worthy of applause [adj APPLAUDABLY]\n",
  "APPLAUDABLY": "APPLAUDABLE, worthy of applause [adv]\n",
  "APPLAUDED": "APPLAUD, to express approval by clapping the hands [v]\n",
  "APPLAUDER": "one who applauds [n -S]\n",
  "APPLAUDERS": "APPLAUDER, one who applauds [n]\n",
  "APPLAUDING": "APPLAUD, to express approval by clapping the hands [v]\n",
  "APPLAUDINGLY": "APPLAUDING, APPLAUD, to express approval by clapping the hands [adv]\n",
  "APPLAUDS": "APPLAUD, to express approval by clapping the hands [v]\n",
  "APPLAUSE": "the sound made by persons applauding [n -S]\n",
  "APPLAUSES": "APPLAUSE, the sound made by persons applauding [n]\n",
  "APPLAUSIVE": "expressing applause [adj APPLAUSIVELY]\n",
  "APPLAUSIVELY": "APPLAUSIVE, expressing applause [adv]\n",
  "APPLE": "the firm round edible fruit of the apple tree [n -S]\n",
  "APPLECART": "apple brandy, distilled from fermented apple juice, also APPLEJACK [n -S]\n",
  "APPLECARTS": "APPLECART, apple brandy, distilled from fermented apple juice, also APPLEJACK [n]\n",
  "APPLEDRAIN": "(US dialect) a wasp [n -S]\n",
  "APPLEDRAINS": "APPLEDRAIN, (US dialect) a wasp [n]\n",
  "APPLEJACK": "apple brandy, distilled from fermented apple juice, also APPLECART [n -S]\n",
  "APPLEJACKS": "APPLEJACK, apple brandy, distilled from fermented apple juice, also APPLECART [n]\n",
  "APPLERINGIE": "(Scots) an aromatic shrub, southernwood [n -S]\n",
  "APPLERINGIES": "APPLERINGIE, (Scots) an aromatic shrub, southernwood [n]\n",
  "APPLES": "APPLE, the firm round edible fruit of the apple tree [n]\n",
  "APPLESAUCE": "a relish or dessert made of apples stewed to a pulp and sweetened; (slang) bunkum, nonsense [n -S]\n",
  "APPLESAUCES": "APPLESAUCE, a relish or dessert made of apples stewed to a pulp and sweetened; (slang) bunkum, nonsense [n]\n",
  "APPLET": "a small single-purpose add-on computer program [n -S]\n",
  "APPLETINI": "a cocktail made with vodka and apple juice [n -S]\n",
  "APPLETINIS": "APPLETINI, a cocktail made with vodka and apple juice [n]\n",
  "APPLETS": "APPLET, a small single-purpose add-on computer program [n]\n",
  "APPLEY": "resembling or tasting of apple [adj APPLIER, APPLIEST]\n",
  "APPLIABLE": "that can be applied, also APPLICABLE [adj]\n",
  "APPLIANCE": "an instrument or tool used for a particular purpose [n -S]\n",
  "APPLIANCES": "APPLIANCE, an instrument or tool used for a particular purpose [n]\n",
  "APPLICABILITIES": "APPLICABILITY, the state of being applicable [n]\n",
  "APPLICABILITY": "the state of being applicable [n APPLICABILITIES]\n",
  "APPLICABLE": "that can be applied, also APPLIABLE [adj]\n",
  "APPLICABLENESS": "the state of being applicable [n]\n",
  "APPLICABLY": "APPLICABLE, that can be applied, also APPLIABLE [adv]\n",
  "APPLICANT": "one who applies [n -S]\n",
  "APPLICANTS": "APPLICANT, one who applies [n]\n",
  "APPLICATE": "applied or put to some use [adj]\n",
  "APPLICATION": "an act of putting to use [n -S]\n",
  "APPLICATIONS": "APPLICATION, an act of putting to use [n]\n",
  "APPLICATIVE": "that can be applied [adj APPLICATIVELY]\n",
  "APPLICATIVELY": "APPLICATIVE, that can be applied [adv]\n",
  "APPLICATOR": "a device used to applicate something [n -S]\n",
  "APPLICATORS": "APPLICATOR, a device used to applicate something [n]\n",
  "APPLICATORY": "capable of being applied [adj]\n",
  "APPLIED": "APPLY, to bring to bear [v]\n",
  "APPLIER": "one who applies [n -S]\n",
  "APPLIERS": "APPLIER, one who applies [n]\n",
  "APPLIES": "APPLY, to bring to bear [v]\n",
  "APPLIEST": "APPLEY, resembling or tasting of apple [adj]\n",
  "APPLIQUE": "(French) a work applied to, or laid on, another material, either of metalwork or lace etc. [n -S] / to do applique work [v APPLIQUED, APPLIQUEING, APPLIQUES]\n",
  "APPLIQUED": "APPLIQUE, to do applique work [v]\n",
  "APPLIQUEING": "APPLIQUE, to do applique work [v]\n",
  "APPLIQUES": "APPLIQUE, to do applique work [v]\n",
  "APPLY": "to bring to bear [v APPLIED, APPLYING, APPLIES]\n",
  "APPLYING": "APPLY, to bring to bear [v]\n",
  "APPOGGIATURA": "(Italian) a short note placed before a longer one [n APPOGGIATURE or APPOGGIATURAS]\n",
  "APPOGGIATURAS": "APPOGGIATURA, (Italian) a short note placed before a longer one [n]\n",
  "APPOGGIATURE": "APPOGGIATURA, (Italian) a short note placed before a longer one [n]\n",
  "APPOINT": "to assign to a job [v -ED, -ING, -S]\n",
  "APPOINTED": "APPOINT, to assign to a job [v]\n",
  "APPOINTEE": "one who is appointed [n -S]\n",
  "APPOINTEES": "APPOINTEE, one who is appointed [n]\n",
  "APPOINTER": "one who appoints [n -S]\n",
  "APPOINTERS": "APPOINTER, one who appoints [n]\n",
  "APPOINTING": "APPOINT, to assign to a job [v]\n",
  "APPOINTIVE": "subject to appointment; as, an appointive office [adj]\n",
  "APPOINTMENT": "an act of appointing [n -S]\n",
  "APPOINTMENTS": "APPOINTMENT, an act of appointing [n]\n",
  "APPOINTOR": "a person who is given (by the owner) the power to appoint property to other persons [n -S]\n",
  "APPOINTORS": "APPOINTOR, a person who is given (by the owner) the power to appoint property to other persons [n]\n",
  "APPOINTS": "APPOINT, to assign to a job [v]\n",
  "APPORT": "(French) in psychical research, the supposed transport of material objects without material agency [n -S]\n",
  "APPORTION": "to portion out [v -ED, -ING, -S]\n",
  "APPORTIONABLE": "that can be apportioned [adj]\n",
  "APPORTIONED": "APPORTION, to portion out [v]\n",
  "APPORTIONER": "one who apportions [n -S]\n",
  "APPORTIONERS": "APPORTIONER, one who apportions [n]\n",
  "APPORTIONING": "APPORTION, to portion out [v]\n",
  "APPORTIONMENT": "an act or result of apportioning [n -S]\n",
  "APPORTIONMENTS": "APPORTIONMENT, an act or result of apportioning [n]\n",
  "APPORTIONS": "APPORTION, to portion out [v]\n",
  "APPORTS": "APPORT, (French) in psychical research, the supposed transport of material objects without material agency [n]\n",
  "APPOSABLE": "that can be apposed [adj]\n",
  "APPOSE": "to place side by side [v APPOSED, APPOSING, APPOSES]\n",
  "APPOSED": "APPOSE, to place side by side [v]\n",
  "APPOSER": "(obsolete) an examiner; one whose business is to put questions [n -S]\n",
  "APPOSERS": "APPOSER, (obsolete) an examiner; one whose business is to put questions [n]\n",
  "APPOSES": "APPOSE, to place side by side [v]\n",
  "APPOSING": "APPOSE, to place side by side [v]\n",
  "APPOSITE": "appropriate [adj]\n",
  "APPOSITELY": "APPOSITE, appropriate [adv]\n",
  "APPOSITENESS": "the state of being apposite [n -ES]\n",
  "APPOSITENESSES": "APPOSITENESS, the state of being apposite [n]\n",
  "APPOSITION": "the position of a word parallel to another in syntactic relation [n -S]\n",
  "APPOSITIONAL": "relating to apposition [adj]\n",
  "APPOSITIONS": "APPOSITION, the position of a word parallel to another in syntactic relation [n]\n",
  "APPOSITIVE": "relating to apposition [adj] / a clause in apposition [n -S]\n",
  "APPOSITIVELY": "APPOSITIVE, relating to apposition [adv]\n",
  "APPOSITIVES": "APPOSITIVE, a clause in apposition [n]\n",
  "APPRAISABLE": "capable of being appraised [adj]\n",
  "APPRAISAL": "the act of appraising [n -S]\n",
  "APPRAISALS": "APPRAISAL, the act of appraising [n]\n",
  "APPRAISE": "to set a value on [v APPRAISED, APPRAISING, APPRAISES]\n",
  "APPRAISED": "APPRAISE, to set a value on [v]\n",
  "APPRAISEE": "one who is appraised [n -S]\n",
  "APPRAISEES": "APPRAISEE, one who is appraised [n]\n",
  "APPRAISEMENT": "the act of appraising [n -S]\n",
  "APPRAISEMENTS": "APPRAISEMENT, the act of appraising [n]\n",
  "APPRAISER": "one who appraises [n -S]\n",
  "APPRAISERS": "APPRAISER, one who appraises [n]\n",
  "APPRAISES": "APPRAISE, to set a value on [v]\n",
  "APPRAISING": "APPRAISE, to set a value on [v]\n",
  "APPRAISINGLY": "APPRAISING, APPRAISE, to set a value on [adv]\n",
  "APPRAISIVE": "having an appraising quality [adj APPRAISIVELY]\n",
  "APPRAISIVELY": "APPRAISIVE, having an appraising quality [adv]\n",
  "APPRECIABLE": "capable of being perceived or measured [adj APPRECIABLY]\n",
  "APPRECIABLY": "APPRECIABLE, capable of being perceived or measured [adv]\n",
  "APPRECIATE": "to grasp the nature, worth, quality, or significance of [v APPRECIATED, APPRECIATING, APPRECIATES]\n",
  "APPRECIATED": "APPRECIATE, to grasp the nature, worth, quality, or significance of [v]\n",
  "APPRECIATES": "APPRECIATE, to grasp the nature, worth, quality, or significance of [v]\n",
  "APPRECIATING": "APPRECIATE, to grasp the nature, worth, quality, or significance of [v]\n",
  "APPRECIATION": "judgment, evaluation [n -S]\n",
  "APPRECIATIONS": "APPRECIATION, judgment, evaluation [n]\n",
  "APPRECIATIVE": "having or showing appreciation [adj APPRECIATIVELY]\n",
  "APPRECIATIVELY": "APPRECIATIVE, having or showing appreciation [adv]\n",
  "APPRECIATOR": "one who appreciates [n -S]\n",
  "APPRECIATORILY": "APPRECIATORY, showing appreciation [adv]\n",
  "APPRECIATORS": "APPRECIATOR, one who appreciates [n]\n",
  "APPRECIATORY": "showing appreciation [adj APPRECIATORILY]\n",
  "APPREHEND": "to understand [v -ED, -ING, -S]\n",
  "APPREHENDED": "APPREHEND, to understand [v]\n",
  "APPREHENDING": "APPREHEND, to understand [v]\n",
  "APPREHENDS": "APPREHEND, to understand [v]\n",
  "APPREHENSIBLE": "capable of being apprehended [adj APPREHENSIBLY]\n",
  "APPREHENSIBLY": "APPREHENSIBLE, capable of being apprehended [adv]\n",
  "APPREHENSION": "the act or power of perceiving or comprehending [n -S]\n",
  "APPREHENSIONS": "APPREHENSION, the act or power of perceiving or comprehending [n]\n",
  "APPREHENSIVE": "fearful [adj APPREHENSIVELY]\n",
  "APPREHENSIVELY": "APPREHENSIVE, fearful [adv]\n",
  "APPRENTICE": "to set someone to work to learn a trade [v APPRENTICED, APPRENTICING, APPRENTICES]\n",
  "APPRENTICED": "APPRENTICE, to set someone to work to learn a trade [v]\n",
  "APPRENTICEHOOD": "(Shakespeare) apprenticeship [n -S]\n",
  "APPRENTICEHOODS": "APPRENTICEHOOD, (Shakespeare) apprenticeship [n]\n",
  "APPRENTICEMENT": "the state of being an apprentice [n -S]\n",
  "APPRENTICEMENTS": "APPRENTICEMENT, the state of being an apprentice [n]\n",
  "APPRENTICES": "APPRENTICE, to set someone to work to learn a trade [v]\n",
  "APPRENTICESHIP": "the state of being an apprentice [n -S]\n",
  "APPRENTICESHIPS": "APPRENTICESHIP, the state of being an apprentice [n]\n",
  "APPRENTICING": "APPRENTICE, to set someone to work to learn a trade [v]\n",
  "APPRESS": "to press together, also ADPRESS [v -ED, -ING, -ES]\n",
  "APPRESSED": "APPRESS, to press together, also ADPRESS [v]\n",
  "APPRESSES": "APPRESS, to press together, also ADPRESS [v]\n",
  "APPRESSING": "APPRESS, to press together, also ADPRESS [v]\n",
  "APPRESSORIA": "APPRESSORIUM, the flattened thickened tip of a hyphal branch by which some parasitic fungi attach to and penetrate their host [n]\n",
  "APPRESSORIUM": "the flattened thickened tip of a hyphal branch by which some parasitic fungi attach to and penetrate their host [n APPRESSORIA]\n",
  "APPRISE": "to inform, also APPRIZE [v APPRISED, APPRISING, APPRISES]\n",
  "APPRISED": "APPRISE, to inform, also APPRIZE [v]\n",
  "APPRISER": "one who informs, also APPRIZER [n -S]\n",
  "APPRISERS": "APPRISER, one who informs, also APPRIZER [n]\n",
  "APPRISES": "APPRISE, to inform, also APPRIZE [v]\n",
  "APPRISING": "(archaic) the sheriff's sentence directing property to be apprised [n -S]\n",
  "APPRISINGS": "APPRISING, (archaic) the sheriff's sentence directing property to be apprised [n]\n",
  "APPRIZE": "to inform, also APPRISE [v APPRIZED, APPRIZING, APPRIZES]\n",
  "APPRIZED": "APPRIZE, to inform, also APPRISE [v]\n",
  "APPRIZER": "one who informs, also APPRISER [n -S]\n",
  "APPRIZERS": "APPRIZER, one who informs, also APPRISER [n]\n",
  "APPRIZES": "APPRIZE, to inform, also APPRISE [v]\n",
  "APPRIZING": "(archaic) the sheriff's sentence directing property to be apprized [n -S]\n",
  "APPRIZINGS": "APPRIZING, (archaic) the sheriff's sentence directing property to be apprized [n]\n",
  "APPRO": "(colloquial) approval [n -S]\n",
  "APPROACH": "to come near to [v -ED, -ING, -ES]\n",
  "APPROACHABILITY": "the state of being approachable [n]\n",
  "APPROACHABLE": "capable of being approached [adj]\n",
  "APPROACHED": "APPROACH, to come near to [v]\n",
  "APPROACHES": "APPROACH, to come near to [v]\n",
  "APPROACHING": "APPROACH, to come near to [v]\n",
  "APPROBATE": "to approve expressly or formally [v APPROBATED, APPROBATING, APPROBATES]\n",
  "APPROBATED": "APPROBATE, to approve expressly or formally [v]\n",
  "APPROBATES": "APPROBATE, to approve expressly or formally [v]\n",
  "APPROBATING": "APPROBATE, to approve expressly or formally [v]\n",
  "APPROBATION": "approval, consent [n -S]\n",
  "APPROBATIONS": "APPROBATION, approval, consent [n]\n",
  "APPROBATIVE": "(archaic) expressing approbation [adj]\n",
  "APPROBATORY": "expressing approbation [adj]\n",
  "APPROOF": "(archaic) the act of proving; approbation [n -S]\n",
  "APPROOFS": "APPROOF, (archaic) the act of proving; approbation [n]\n",
  "APPROPINQUATE": "(archaic) to approach, also APPROPINQUE [v APPROPINQUATED, APPROPINQUATING, APPROPINQUATES]\n",
  "APPROPINQUATED": "APPROPINQUATE, (archaic) to approach, also APPROPINQUE [v]\n",
  "APPROPINQUATES": "APPROPINQUATE, (archaic) to approach, also APPROPINQUE [v]\n",
  "APPROPINQUATING": "APPROPINQUATE, (archaic) to approach, also APPROPINQUE [v]\n",
  "APPROPINQUATION": "approach [n]\n",
  "APPROPINQUE": "(archaic) to approach, also APPROPINQUATE [v APPROPINQUED, APPROPINQUING, APPROPINQUES]\n",
  "APPROPINQUED": "APPROPINQUE, (archaic) to approach, also APPROPINQUATE [v]\n",
  "APPROPINQUES": "APPROPINQUE, (archaic) to approach, also APPROPINQUATE [v]\n",
  "APPROPINQUING": "APPROPINQUE, (archaic) to approach, also APPROPINQUATE [v]\n",
  "APPROPINQUITIES": "APPROPINQUITY, nearness [n]\n",
  "APPROPINQUITY": "nearness [n APPROPINQUITIES]\n",
  "APPROPRIABLE": "capable of being appropriated [adj]\n",
  "APPROPRIACIES": "APPROPRIACY, the condition of delicate and precise fittingness of a word or expression to its context, even when it is chosen from a number of close synonyms [n]\n",
  "APPROPRIACY": "the condition of delicate and precise fittingness of a word or expression to its context, even when it is chosen from a number of close synonyms [n APPROPRIACIES]\n",
  "APPROPRIATE": "suitable [adj APPROPRIATELY] / to take exclusive possession of [v APPROPRIATED, APPROPRIATING, APPROPRIATES]\n",
  "APPROPRIATED": "APPROPRIATE, to take exclusive possession of [v]\n",
  "APPROPRIATELY": "APPROPRIATE, suitable [adv]\n",
  "APPROPRIATENESS": "the state of being appropriate [n]\n",
  "APPROPRIATES": "APPROPRIATE, to take exclusive possession of [v]\n",
  "APPROPRIATING": "APPROPRIATE, to take exclusive possession of [v]\n",
  "APPROPRIATION": "an act or instance of appropriating [n -S]\n",
  "APPROPRIATIONS": "APPROPRIATION, an act or instance of appropriating [n]\n",
  "APPROPRIATIVE": "relating to appropriation [adj]\n",
  "APPROPRIATOR": "one who appropriates [n -S]\n",
  "APPROPRIATORS": "APPROPRIATOR, one who appropriates [n]\n",
  "APPROS": "APPRO, (colloquial) approval [n]\n",
  "APPROVABLE": "worthy of being approved; meritorious [adj APPROVABLY]\n",
  "APPROVABLY": "APPROVABLE, worthy of being approved; meritorious [adv]\n",
  "APPROVAL": "the act of approving [n -S]\n",
  "APPROVALS": "APPROVAL, the act of approving [n]\n",
  "APPROVANCE": "(archaic) approval [n -S]\n",
  "APPROVANCES": "APPROVANCE, (archaic) approval [n]\n",
  "APPROVE": "to regard favourably [v APPROVED, APPROVING, APPROVES]\n",
  "APPROVED": "APPROVE, to regard favourably [v]\n",
  "APPROVER": "one that approves [n -S]\n",
  "APPROVERS": "APPROVER, one that approves [n]\n",
  "APPROVES": "APPROVE, to regard favourably [v]\n",
  "APPROVING": "APPROVE, to regard favourably [v]\n",
  "APPROVINGLY": "APPROVING, APPROVE, to regard favourably [adv]\n",
  "APPROXIMAL": "close together, next to [adj]\n",
  "APPROXIMATE": "close together [adj APPROXIMATELY] / to come close to [v APPROXIMATED, APPROXIMATING, APPROXIMATES]\n",
  "APPROXIMATED": "APPROXIMATE, to come close to [v]\n",
  "APPROXIMATELY": "APPROXIMATE, close together [adv]\n",
  "APPROXIMATES": "APPROXIMATE, to come close to [v]\n",
  "APPROXIMATING": "APPROXIMATE, to come close to [v]\n",
  "APPROXIMATION": "the act of drawing together [n -S]\n",
  "APPROXIMATIONS": "APPROXIMATION, the act of drawing together [n]\n",
  "APPROXIMATIVE": "approaching closely [adj]\n",
  "APPROXIMEETING": "the practice of a group of people making indefinite plans to meet and then altering those plans regularly via mobile phones according to changing circumstances [n -S]\n",
  "APPROXIMEETINGS": "APPROXIMEETING, the practice of a group of people making indefinite plans to meet and then altering those plans regularly via mobile phones according to changing circumstances [n]\n",
  "APPS": "APP, (short for) application program [n]\n",
  "APPUI": "(French) to support militarily, also APPUY [v APPUIED, APPUYING, APPUIS]\n",
  "APPUIED": "APPUI, (French) to support militarily, also APPUY [v]\n",
  "APPUIS": "APPUI, (French) to support militarily, also APPUY [v]\n",
  "APPULSE": "the close approach of a planet or asteroid to a star without the occurrence of an eclipse [n -S]\n",
  "APPULSES": "APPULSE, the close approach of a planet or asteroid to a star without the occurrence of an eclipse [n]\n",
  "APPULSIVE": "relating to an appulse, the close approach of a planet or asteroid to a star without the occurrence of an eclipse [adj APPULSIVELY]\n",
  "APPULSIVELY": "APPULSIVE, relating to an appulse, the close approach of a planet or asteroid to a star without the occurrence of an eclipse [adv]\n",
  "APPURTENANCE": "a subordinate or adjunct part of [n -S]\n",
  "APPURTENANCES": "APPURTENANCE, a subordinate or adjunct part of [n]\n",
  "APPURTENANT": "a right accompanying a property [n -S]\n",
  "APPURTENANTS": "APPURTENANT, a right accompanying a property [n]\n",
  "APPUY": "(French) to give military support, also APPUI [v -ED, -ING, -S]\n",
  "APPUYED": "APPUY, (French) to give military support, also APPUI [v]\n",
  "APPUYING": "APPUY, (French) to give military support, also APPUI [v]\n",
  "APPUYS": "APPUY, (French) to give military support, also APPUI [v]\n",
  "APRACTIC": "unable to perform voluntary bodily movements, also APRAXIC [adj]\n",
  "APRAXIA": "an inability to perform voluntary bodily movements [n -S]\n",
  "APRAXIAS": "APRAXIA, an inability to perform voluntary bodily movements [n]\n",
  "APRAXIC": "unable to perform voluntary bodily movements, also APRACTIC [adj]\n",
  "APRES": "(French) after [prep]\n",
  "APRICATE": "to expose to sunlight [v APRICATED, APRICATING, APRICATES]\n",
  "APRICATED": "APRICATE, to expose to sunlight [v]\n",
  "APRICATES": "APRICATE, to expose to sunlight [v]\n",
  "APRICATING": "APRICATE, to expose to sunlight [v]\n",
  "APRICATION": "basking in the sun [n -S]\n",
  "APRICATIONS": "APRICATION, basking in the sun [n]\n",
  "APRICOCK": "(obsolete) an apricot, also ABRICOCK [n -S]\n",
  "APRICOCKS": "APRICOCK, (obsolete) an apricot, also ABRICOCK [n]\n",
  "APRICOT": "a fruit of the plum genus, roundish, orange-coloured, with a downy skin, also ABRICOCK, APRICOCK [n -S]\n",
  "APRICOTS": "APRICOT, a fruit of the plum genus, roundish, orange-coloured, with a downy skin, also ABRICOCK, APRICOCK [n]\n",
  "APRIORISM": "an a priori principle [n -S]\n",
  "APRIORISMS": "APRIORISM, an a priori principle [n]\n",
  "APRIORIST": "a person who believes in Kant's theory of a priori cognition [n -S]\n",
  "APRIORISTS": "APRIORIST, a person who believes in Kant's theory of a priori cognition [n]\n",
  "APRIORITIES": "APRIORITY, the quality of being innate in the mind, or prior to experience [n]\n",
  "APRIORITY": "the quality of being innate in the mind, or prior to experience [n APRIORITIES]\n",
  "APRON": "a piece of cloth, leather, etc. worn in front, esp. to protect clothes from dirt or damage [n -S] / to cover with or as with an apron [v -ED, -ING, -S]\n",
  "APRONED": "APRON, to cover with or as with an apron [v]\n",
  "APRONFUL": "an amount carried in an upturned apron [n -S]\n",
  "APRONFULS": "APRONFUL, an amount carried in an upturned apron [n]\n",
  "APRONING": "APRON, to cover with or as with an apron [v]\n",
  "APRONLIKE": "like an apron [adj]\n",
  "APRONS": "APRON, to cover with or as with an apron [v]\n",
  "APROPOS": "(French) to the purpose; in reference to [prep]\n",
  "APROTIC": "of a solvent, incapable of acting as a proton donor [adj]\n",
  "APSARAS": "(Sanskrit) a divine water sprite [n -ES]\n",
  "APSARASES": "APSARAS, (Sanskrit) a divine water sprite [n]\n",
  "APSE": "a rounded extension at the end of a building, esp. at the east end of a church [n -S]\n",
  "APSES": "APSE, a rounded extension at the end of a building, esp. at the east end of a church [n]\n",
  "APSIDAL": "of an apse or apsis [adj]\n",
  "APSIDES": "APSIS, (Latin) the point at which a heavenly body is most or least distant from the centre of attraction [n]\n",
  "APSIDIOLE": "a subsidiary apse, a rounded extension at the end of a building, esp. at the east end of a church [n -S]\n",
  "APSIDIOLES": "APSIDIOLE, a subsidiary apse, a rounded extension at the end of a building, esp. at the east end of a church [n]\n",
  "APSIS": "(Latin) the point at which a heavenly body is most or least distant from the centre of attraction [n APSIDES]\n",
  "APSO": "(Tibetan) a Tibetan terrier [n -S]\n",
  "APSOS": "APSO, (Tibetan) a Tibetan terrier [n]\n",
  "APT": "suited to [adj APTER, APTEST, APTLY] / to adapt [v -ED, -ING, -S]\n",
  "APTAMER": "any of various created RNA-based molecules with therapeutic properties [n -S]\n",
  "APTAMERS": "APTAMER, any of various created RNA-based molecules with therapeutic properties [n]\n",
  "APTED": "APT, to adapt [v]\n",
  "APTER": "APT, suited to [adj]\n",
  "APTERAL": "wingless, also APTEROUS [adj]\n",
  "APTERIA": "APTERIUM, a bare patch on a bird's skin [n]\n",
  "APTERISM": "a lack of wings [n -S]\n",
  "APTERISMS": "APTERISM, a lack of wings [n]\n",
  "APTERIUM": "a bare patch on a bird's skin [n APTERIA]\n",
  "APTEROUS": "wingless, also APTERAL [adj]\n",
  "APTERYGIAL": "wingless; finless [adj]\n",
  "APTERYX": "(Greek) one of a genus of New Zealand birds that includes the kiwi [n -ES]\n",
  "APTERYXES": "APTERYX, (Greek) one of a genus of New Zealand birds that includes the kiwi [n]\n",
  "APTEST": "APT, suited to [adj]\n",
  "APTING": "APT, to adapt [v]\n",
  "APTITUDE": "an ability [n -S]\n",
  "APTITUDES": "APTITUDE, an ability [n]\n",
  "APTITUDINAL": "relating to aptitude [adj APTITUDINALLY]\n",
  "APTITUDINALLY": "APTITUDINAL, relating to aptitude [adv]\n",
  "APTLY": "APT, suited to [adv]\n",
  "APTNESS": "the quality of being apt [n -ES]\n",
  "APTNESSES": "APTNESS, the quality of being apt [n]\n",
  "APTOTE": "a noun that has no grammatical cases [n -S]\n",
  "APTOTES": "APTOTE, a noun that has no grammatical cases [n]\n",
  "APTOTIC": "grammatically uninflected [adj]\n",
  "APTS": "APT, to adapt [v]\n",
  "APYRASE": "any of several enzymes that hydrolyze ATP with the liberation of phosphate and energy [n -S]\n",
  "APYRASES": "APYRASE, any of several enzymes that hydrolyze ATP with the liberation of phosphate and energy [n]\n",
  "APYRETIC": "without fever [adj]\n",
  "APYREXIA": "a period of intermission in a fever [n -S]\n",
  "APYREXIAS": "APYREXIA, a period of intermission in a fever [n]\n",
  "AQUA": "(Latin) water [n AQUAS or AQUAE]\n",
  "AQUABATIC": "relating to spectacular feats in water [adj]\n",
  "AQUABATICS": "spectacular feats in water [n]\n",
  "AQUABOARD": "a board for riding on the surface of water [n -S]\n",
  "AQUABOARDS": "AQUABOARD, a board for riding on the surface of water [n]\n",
  "AQUACADE": "an exhibition of swimming and diving skills [n -S]\n",
  "AQUACADES": "AQUACADE, an exhibition of swimming and diving skills [n]\n",
  "AQUACEUTICAL": "a method of delivering food supplements [n -S]\n",
  "AQUACEUTICALS": "AQUACEUTICAL, a method of delivering food supplements [n]\n",
  "AQUACULTURAL": "relating to aquaculture [adj]\n",
  "AQUACULTURE": "the practice of using the sea, lakes etc. for fish-farming, also AQUICULTURE [n -S]\n",
  "AQUACULTURES": "AQUACULTURE, the practice of using the sea, lakes etc. for fish-farming, also AQUICULTURE [n]\n",
  "AQUACULTURIST": "one who practises aquaculture [n -S]\n",
  "AQUACULTURISTS": "AQUACULTURIST, one who practises aquaculture [n]\n",
  "AQUADROME": "a centre with facilities for waterskiing [n -S]\n",
  "AQUADROMES": "AQUADROME, a centre with facilities for waterskiing [n]\n",
  "AQUAE": "AQUA, (Latin) water [n]\n",
  "AQUAEROBICS": "a system of exercises, similar to aerobics, performed to music in chest-high water, also AQUAROBICS [n]\n",
  "AQUAFABA": "water in which pulses, esp chickpeas, have been cooked, used in vegan cookery as a substitute for egg whites [n -S]\n",
  "AQUAFABAS": "AQUAFABA, water in which pulses, esp chickpeas, have been cooked, used in vegan cookery as a substitute for egg whites [n]\n",
  "AQUAFARM": "to cultivate food fish [v -ED, -ING, -S]\n",
  "AQUAFARMED": "AQUAFARM, to cultivate food fish [v]\n",
  "AQUAFARMING": "marine farming [n -S]\n",
  "AQUAFARMINGS": "AQUAFARMING, marine farming [n]\n",
  "AQUAFARMS": "AQUAFARM, to cultivate food fish [v]\n",
  "AQUAFER": "an underground reservoir of water which can be extracted for surface use, also AQUIFER [n -S]\n",
  "AQUAFERS": "AQUAFER, an underground reservoir of water which can be extracted for surface use, also AQUIFER [n]\n",
  "AQUAFIT": "a type of aerobic exercise performed in water [n -S]\n",
  "AQUAFITNESS": "fitness obtained through water-based exercise [n -ES]\n",
  "AQUAFITNESSES": "AQUAFITNESS, fitness obtained through water-based exercise [n]\n",
  "AQUAFITS": "AQUAFIT, a type of aerobic exercise performed in water [n]\n",
  "AQUAFORTIS": "concentrated nitric acid, used for etching [n -ES]\n",
  "AQUAFORTISES": "AQUAFORTIS, concentrated nitric acid, used for etching [n]\n",
  "AQUAFORTIST": "an etcher or engraver who uses aquafortis [n -S]\n",
  "AQUAFORTISTS": "AQUAFORTIST, an etcher or engraver who uses aquafortis [n]\n",
  "AQUALEATHER": "leather made from fishskin [n -S]\n",
  "AQUALEATHERS": "AQUALEATHER, leather made from fishskin [n]\n",
  "AQUALUNG": "diving apparatus [n -S]\n",
  "AQUALUNGS": "AQUALUNG, diving apparatus [n]\n",
  "AQUAMANALE": "a ewer in the form of a human or animal figure for ceremonial hand-washing, also AQUAMANILE [n -S]\n",
  "AQUAMANALES": "AQUAMANALE, a ewer in the form of a human or animal figure for ceremonial hand-washing, also AQUAMANILE [n]\n",
  "AQUAMANILE": "a ewer in the form of a human or animal figure for ceremonial hand-washing, also AQUAMANALE [n -S]\n",
  "AQUAMANILES": "AQUAMANILE, a ewer in the form of a human or animal figure for ceremonial hand-washing, also AQUAMANALE [n]\n",
  "AQUAMARINE": "a transparent blue, blue-green, or green variety of beryl used as a gem [n -S]\n",
  "AQUAMARINES": "AQUAMARINE, a transparent blue, blue-green, or green variety of beryl used as a gem [n]\n",
  "AQUANAUT": "a skin-diver; someone who explores and/or lives in the sea at considerable depth [n -S]\n",
  "AQUANAUTICS": "skin-diving [n]\n",
  "AQUANAUTS": "AQUANAUT, a skin-diver; someone who explores and/or lives in the sea at considerable depth [n]\n",
  "AQUAPHOBE": "one with a morbid fear of water [n -S]\n",
  "AQUAPHOBES": "AQUAPHOBE, one with a morbid fear of water [n]\n",
  "AQUAPHOBIA": "fear of water [n -S]\n",
  "AQUAPHOBIAS": "AQUAPHOBIA, fear of water [n]\n",
  "AQUAPHOBIC": "having a morbid fear of water [adj] / someone with a morbid fear of water [n -S]\n",
  "AQUAPHOBICS": "AQUAPHOBIC, someone with a morbid fear of water [n]\n",
  "AQUAPLANE": "to skim across water [v AQUAPLANED, AQUAPLANING, AQUAPLANES]\n",
  "AQUAPLANED": "AQUAPLANE, to skim across water [v]\n",
  "AQUAPLANER": "one who aquaplanes [n -S]\n",
  "AQUAPLANERS": "AQUAPLANER, one who aquaplanes [n]\n",
  "AQUAPLANES": "AQUAPLANE, to skim across water [v]\n",
  "AQUAPLANING": "the sport of skimming across water [n -S]\n",
  "AQUAPLANINGS": "AQUAPLANING, the sport of skimming across water [n]\n",
  "AQUAPORIN": "any of a group of proteins in a cell membrane that allow the passage of water across the membrane [n -S]\n",
  "AQUAPORINS": "AQUAPORIN, any of a group of proteins in a cell membrane that allow the passage of water across the membrane [n]\n",
  "AQUARELLE": "(French) a method of painting in transparent watercolour; such a painting [n -S]\n",
  "AQUARELLES": "AQUARELLE, (French) a method of painting in transparent watercolour; such a painting [n]\n",
  "AQUARELLIST": "an artist painting aquarelles [n -S]\n",
  "AQUARELLISTS": "AQUARELLIST, an artist painting aquarelles [n]\n",
  "AQUARIA": "AQUARIUM, (Latin) a water filled museum for all forms of aquatic life [n]\n",
  "AQUARIAL": "of or pertaining to an aquarium, also AQUARIAN [adj]\n",
  "AQUARIAN": "a curator of an aquarium, also AQUARIST [n -S]\n",
  "AQUARIANS": "AQUARIAN, a curator of an aquarium, also AQUARIST [n]\n",
  "AQUARIIST": "(obsolete) a curator of an aquarium, also AQUARIST [n -S]\n",
  "AQUARIISTS": "AQUARIIST, (obsolete) a curator of an aquarium, also AQUARIST [n]\n",
  "AQUARIST": "a curator of an aquarium, also AQUARIIST [n -S]\n",
  "AQUARISTS": "AQUARIST, a curator of an aquarium, also AQUARIIST [n]\n",
  "AQUARIUM": "(Latin) a water filled museum for all forms of aquatic life [n AQUARIUMS or AQUARIA]\n",
  "AQUARIUMS": "AQUARIUM, (Latin) a water filled museum for all forms of aquatic life [n]\n",
  "AQUAROBIC": "relating to a system of exercises, similar to aerobics, performed to music in chest-high water [adj]\n",
  "AQUAROBICS": "a system of exercises, similar to aerobics, performed to music in chest-high water, also AQUAEROBICS [n]\n",
  "AQUAS": "AQUA, (Latin) water [n]\n",
  "AQUASCAPE": "a scenic view of a body of water [n -S]\n",
  "AQUASCAPES": "AQUASCAPE, a scenic view of a body of water [n]\n",
  "AQUASHOW": "an exhibition of swimming and diving [n -S]\n",
  "AQUASHOWS": "AQUASHOW, an exhibition of swimming and diving [n]\n",
  "AQUATIC": "relating to water [adj AQUATICALLY] / an organism living in or near water [n -S]\n",
  "AQUATICALLY": "AQUATIC, relating to water [adv]\n",
  "AQUATICS": "AQUATIC, an organism living in or near water [n]\n",
  "AQUATINT": "to etch using a certain process having the effect of watercolour drawing [v -ED, -ING, -S]\n",
  "AQUATINTA": "a print made by a method of etching having the effect of watercolour drawing, also AQUATINT [n -S]\n",
  "AQUATINTAS": "AQUATINTA, a print made by a method of etching having the effect of watercolour drawing, also AQUATINT [n]\n",
  "AQUATINTED": "AQUATINT, to etch using a certain process having the effect of watercolour drawing [v]\n",
  "AQUATINTER": "one who works with aquatints [n -S]\n",
  "AQUATINTERS": "AQUATINTER, one who works with aquatints [n]\n",
  "AQUATINTING": "AQUATINT, to etch using a certain process having the effect of watercolour drawing [v]\n",
  "AQUATINTIST": "one who works with aquatints [n -S]\n",
  "AQUATINTISTS": "AQUATINTIST, one who works with aquatints [n]\n",
  "AQUATINTS": "AQUATINT, to etch using a certain process having the effect of watercolour drawing [v]\n",
  "AQUATONE": "a type of printing process [n -S]\n",
  "AQUATONES": "AQUATONE, a type of printing process [n]\n",
  "AQUAVIT": "(Norwegian) a Scandinavian spirit made from potatoes or grain and flavoured with caraway seeds, also AKVAVIT [n -S]\n",
  "AQUAVITS": "AQUAVIT, (Norwegian) a Scandinavian spirit made from potatoes or grain and flavoured with caraway seeds, also AKVAVIT [n]\n",
  "AQUEDUCT": "an artificial channel or pipe for conveying water, most commonly a bridge across a valley [n -S]\n",
  "AQUEDUCTS": "AQUEDUCT, an artificial channel or pipe for conveying water, most commonly a bridge across a valley [n]\n",
  "AQUEOUS": "pertaining to water [adj]\n",
  "AQUEOUSLY": "AQUEOUS, pertaining to water [adv]\n",
  "AQUICULTURAL": "relating to aquiculture, the practice of using the sea, lakes etc. for fish-farming [adj]\n",
  "AQUICULTURE": "the practice of using the sea, lakes etc. for fish-farming, also AQUACULTURE [n -S]\n",
  "AQUICULTURES": "AQUICULTURE, the practice of using the sea, lakes etc. for fish-farming, also AQUACULTURE [n]\n",
  "AQUICULTURIST": "one who practises aquiculture [n -S]\n",
  "AQUICULTURISTS": "AQUICULTURIST, one who practises aquiculture [n]\n",
  "AQUIFER": "an underground reservoir of water which can be extracted for surface use, also AQUAFER [n -S]\n",
  "AQUIFEROUS": "consisting or conveying water or a watery fluid [adj]\n",
  "AQUIFERS": "AQUIFER, an underground reservoir of water which can be extracted for surface use, also AQUAFER [n]\n",
  "AQUIFOLIACEOUS": "belonging to the holly family [adj]\n",
  "AQUILEGIA": "a genus of plants including columbine [n -S]\n",
  "AQUILEGIAS": "AQUILEGIA, a genus of plants including columbine [n]\n",
  "AQUILINE": "hooked like an eagle's beak [adj]\n",
  "AQUILINITIES": "AQUILINITY, the state of being aquiline [n]\n",
  "AQUILINITY": "the state of being aquiline [n AQUILINITIES]\n",
  "AQUILON": "(Shakespeare) the north wind [n -S]\n",
  "AQUILONS": "AQUILON, (Shakespeare) the north wind [n]\n",
  "AQUIVER": "quivering [adj]\n",
  "AR": "the letter R [n -S]\n",
  "ARAARA": "(Maori) another name for trevally, a kind of horse-mackerel [n -S]\n",
  "ARAARAS": "ARAARA, (Maori) another name for trevally, a kind of horse-mackerel [n]\n",
  "ARABA": "(Arabic) a heavy screened wagon used by Tatars and others, also ARBA, AROBA [n -S]\n",
  "ARABAS": "ARABA, (Arabic) a heavy screened wagon used by Tatars and others, also ARBA, AROBA [n]\n",
  "ARABESK": "a design of intertwined floral figures [n -S]\n",
  "ARABESKS": "ARABESK, a design of intertwined floral figures [n]\n",
  "ARABESQUE": "a movement in dancing; a curve, also ARABESK [n -S]\n",
  "ARABESQUED": "ornamented in the style of arabesque [adj]\n",
  "ARABESQUES": "ARABESQUE, a movement in dancing; a curve, also ARABESK [n]\n",
  "ARABIC": "derived from gum arabic [adj]\n",
  "ARABICA": "(Latin) coffee produced from the shrub Coffea arabica, grown esp. in Brazil [n -S]\n",
  "ARABICAS": "ARABICA, (Latin) coffee produced from the shrub Coffea arabica, grown esp. in Brazil [n]\n",
  "ARABICISATION": "the act of arabicising, also ARABICIZATION [n -S]\n",
  "ARABICISATIONS": "ARABICISATION, the act of arabicising, also ARABICIZATION [n]\n",
  "ARABICISE": "to make Arabic, also ARABICIZE [v ARABICISED, ARABICISING, ARABICISES]\n",
  "ARABICISED": "ARABICISE, to make Arabic, also ARABICIZE [v]\n",
  "ARABICISES": "ARABICISE, to make Arabic, also ARABICIZE [v]\n",
  "ARABICISING": "ARABICISE, to make Arabic, also ARABICIZE [v]\n",
  "ARABICIZATION": "the act of arabicizing, also ARABICISATION [n -S]\n",
  "ARABICIZATIONS": "ARABICIZATION, the act of arabicizing, also ARABICISATION [n]\n",
  "ARABICIZE": "to make Arabic [v ARABICIZED, ARABICIZING, ARABICIZES]\n",
  "ARABICIZED": "ARABICIZE, to make Arabic [v]\n",
  "ARABICIZES": "ARABICIZE, to make Arabic [v]\n",
  "ARABICIZING": "ARABICIZE, to make Arabic [v]\n",
  "ARABILITIES": "ARABILITY, the ability to be ploughed [n]\n",
  "ARABILITY": "the ability to be ploughed [n ARABILITIES]\n",
  "ARABIN": "the essential chemical within gum arabic [n -S]\n",
  "ARABINOSE": "a pentose sugar which is a constituent of many plant gums [n -S]\n",
  "ARABINOSES": "ARABINOSE, a pentose sugar which is a constituent of many plant gums [n]\n",
  "ARABINOSIDE": "a glycoside that yields arabinose on hydrolysis [n -S]\n",
  "ARABINOSIDES": "ARABINOSIDE, a glycoside that yields arabinose on hydrolysis [n]\n",
  "ARABINS": "ARABIN, the essential chemical within gum arabic [n]\n",
  "ARABIS": "(Latin) any member of a large genus of trailing plants [n -ES]\n",
  "ARABISATION": "the process of arabising, also ARABIZATION [n -S]\n",
  "ARABISATIONS": "ARABISATION, the process of arabising, also ARABIZATION [n]\n",
  "ARABISE": "to adopt Arab customs, also ARABIZE [v ARABISED, ARABISING, ARABISES]\n",
  "ARABISED": "ARABISE, to adopt Arab customs, also ARABIZE [v]\n",
  "ARABISES": "ARABIS, (Latin) any member of a large genus of trailing plants [n]\n",
  "ARABISING": "ARABISE, to adopt Arab customs, also ARABIZE [v]\n",
  "ARABIZATION": "the process of arabizing, also ARABISATION [n -S]\n",
  "ARABIZATIONS": "ARABIZATION, the process of arabizing, also ARABISATION [n]\n",
  "ARABIZE": "to adopt Arab customs, also ARABISE [v ARABIZED, ARABIZING, ARABIZES]\n",
  "ARABIZED": "ARABIZE, to adopt Arab customs, also ARABISE [v]\n",
  "ARABIZES": "ARABIZE, to adopt Arab customs, also ARABISE [v]\n",
  "ARABIZING": "ARABIZE, to adopt Arab customs, also ARABISE [v]\n",
  "ARABLE": "land suitable for cultivation [n -S]\n",
  "ARABLES": "ARABLE, land suitable for cultivation [n]\n",
  "ARACEOUS": "pertaining to the arum family of plants [adj]\n",
  "ARACHIDONIC": "as in arachidonic acid, an unsaturated fatty acid occurring in animal cells [adj]\n",
  "ARACHIS": "(Greek) a Brazilian plant genus that includes monkey-nut [n -ES]\n",
  "ARACHISES": "ARACHIS, (Greek) a Brazilian plant genus that includes monkey-nut [n]\n",
  "ARACHNID": "any member of the Arachnida, the large class of arthropods that includes spiders, scorpions, mites, etc. [n -S]\n",
  "ARACHNIDAN": "any member of class Arachnida [n -S]\n",
  "ARACHNIDANS": "ARACHNIDAN, any member of class Arachnida [n]\n",
  "ARACHNIDS": "ARACHNID, any member of the Arachnida, the large class of arthropods that includes spiders, scorpions, mites, etc. [n]\n",
  "ARACHNOID": "like a cobweb [adj] / the arachnoid membrane, a fine delicate membrane which is the middle of the three meninges enveloping the brain and spinal cord [n -S]\n",
  "ARACHNOIDAL": "like a cobweb, covered with fine hairs [adj]\n",
  "ARACHNOIDITIS": "inflammation of the arachnoid membrane [n -ES]\n",
  "ARACHNOIDITISES": "ARACHNOIDITIS, inflammation of the arachnoid membrane [n]\n",
  "ARACHNOIDS": "ARACHNOID, the arachnoid membrane, a fine delicate membrane which is the middle of the three meninges enveloping the brain and spinal cord [n]\n",
  "ARACHNOLOGICAL": "related to arachnology [adj]\n",
  "ARACHNOLOGIES": "ARACHNOLOGY, the study of spiders [n]\n",
  "ARACHNOLOGIST": "one who studies arachnids [n -S]\n",
  "ARACHNOLOGISTS": "ARACHNOLOGIST, one who studies arachnids [n]\n",
  "ARACHNOLOGY": "the study of spiders [n ARACHNOLOGIES]\n",
  "ARACHNOPHOBE": "one with a morbid fear of spiders [n -S]\n",
  "ARACHNOPHOBES": "ARACHNOPHOBE, one with a morbid fear of spiders [n]\n",
  "ARACHNOPHOBIA": "fear of spiders [n -S]\n",
  "ARACHNOPHOBIAS": "ARACHNOPHOBIA, fear of spiders [n]\n",
  "ARACHNOPHOBIC": "one with a morbid fear of spiders [n -S]\n",
  "ARACHNOPHOBICS": "ARACHNOPHOBIC, one with a morbid fear of spiders [n]\n",
  "ARAEOMETER": "(historical) an instrument used for measuring specific gravity, also AREOMETER [n -S]\n",
  "ARAEOMETERS": "ARAEOMETER, (historical) an instrument used for measuring specific gravity, also AREOMETER [n]\n",
  "ARAEOMETRIC": "relating to araeometry, also ARAEOMETRICAL [adj]\n",
  "ARAEOMETRICAL": "relating to araeometry, also ARAEOMETRIC [adj]\n",
  "ARAEOMETRIES": "ARAEOMETRY, the measuring of specific gravity, also AREOMETRY [n]\n",
  "ARAEOMETRY": "the measuring of specific gravity, also AREOMETRY [n ARAEOMETRIES]\n",
  "ARAEOSTYLE": "a building or colonnade with columns four diameters or more apart, also AREOSTYLE [n -S]\n",
  "ARAEOSTYLES": "ARAEOSTYLE, a building or colonnade with columns four diameters or more apart, also AREOSTYLE [n]\n",
  "ARAEOSYSTYLE": "a building or colonnade alternately araeostyle and systyle, also AREOSYSTILE [n -S]\n",
  "ARAEOSYSTYLES": "ARAEOSYSTYLE, a building or colonnade alternately araeostyle and systyle, also AREOSYSTILE [n]\n",
  "ARAGONITE": "an orthorhombic mineral composed of calcium carbonate, also ARRAGONITE [n -S]\n",
  "ARAGONITES": "ARAGONITE, an orthorhombic mineral composed of calcium carbonate, also ARRAGONITE [n]\n",
  "ARAGONITIC": "of or like aragonite, an orthorhombic mineral composed of calcium carbonate, also ARRAGONITIC [adj]\n",
  "ARAHUANA": "a large tropical fish, also ARAWANA, AROWANA, ARUANA [n -S]\n",
  "ARAHUANAS": "ARAHUANA, a large tropical fish, also ARAWANA, AROWANA, ARUANA [n]\n",
  "ARAISE": "to raise, also ARAYSE [v ARAISED, ARAISING, ARAISES]\n",
  "ARAISED": "ARAISE, to raise, also ARAYSE [v]\n",
  "ARAISES": "ARAISE, to raise, also ARAYSE [v]\n",
  "ARAISING": "ARAISE, to raise, also ARAYSE [v]\n",
  "ARAK": "(Arabic) a strong alcoholic drink made from toddy, or the fermented juice of the coco and other palms, also ARRACK [n -S]\n",
  "ARAKS": "ARAK, (Arabic) a strong alcoholic drink made from toddy, or the fermented juice of the coco and other palms, also ARRACK [n]\n",
  "ARALIA": "a genus of ivylike plants [n -S]\n",
  "ARALIACEOUS": "belonging to the Aralia genus of tropical trees and shrubs [adj]\n",
  "ARALIAS": "ARALIA, a genus of ivylike plants [n]\n",
  "ARAME": "(Japanese) a type of edible seaweed, looking like black bootlaces [n -S]\n",
  "ARAMES": "ARAME, (Japanese) a type of edible seaweed, looking like black bootlaces [n]\n",
  "ARAMID": "a strong lightweight synthetic fibre, from which Kevlar is made [n -S]\n",
  "ARAMIDS": "ARAMID, a strong lightweight synthetic fibre, from which Kevlar is made [n]\n",
  "ARANCINI": "(Italian) a dish consisting of balls of rice stuffed with a savoury filling, coated in breadcrumbs and fried [n]\n",
  "ARANEID": "a spider [n -S]\n",
  "ARANEIDAN": "related to araneids, spiders [adj]\n",
  "ARANEIDS": "ARANEID, a spider [n]\n",
  "ARANEOUS": "transparent; delicate; like a spider's web [adj]\n",
  "ARAPAIMA": "(Tupi) a large freshwater food fish of South America, aka pirarucu [n -S]\n",
  "ARAPAIMAS": "ARAPAIMA, (Tupi) a large freshwater food fish of South America, aka pirarucu [n]\n",
  "ARAPONGA": "(Tupi) the campanero or South American bellbird, also ARAPUNGA [n -S]\n",
  "ARAPONGAS": "ARAPONGA, (Tupi) the campanero or South American bellbird, also ARAPUNGA [n]\n",
  "ARAPUNGA": "(Tupi) the campanero or S. American bellbird, also ARAPONGA [n -S]\n",
  "ARAPUNGAS": "ARAPUNGA, (Tupi) the campanero or S. American bellbird, also ARAPONGA [n]\n",
  "ARAR": "the sandarac tree [n -S]\n",
  "ARAROBA": "(Tupi) a Brazilian tree; a bitter yellow powder, Goa powder, obtained from it and used as a purgative [n -S]\n",
  "ARAROBAS": "ARAROBA, (Tupi) a Brazilian tree; a bitter yellow powder, Goa powder, obtained from it and used as a purgative [n]\n",
  "ARARS": "ARAR, the sandarac tree [n]\n",
  "ARAUCARIA": "a tree of the monkey puzzle genus [n -S]\n",
  "ARAUCARIAN": "relating to, or of the nature of, the araucaria, a genus of tall conifers [adj]\n",
  "ARAUCARIAS": "ARAUCARIA, a tree of the monkey puzzle genus [n]\n",
  "ARAWANA": "a large tropical fish, also ARAHUANA, AROWANA, ARUANA [n -S]\n",
  "ARAWANAS": "ARAWANA, a large tropical fish, also ARAHUANA, AROWANA, ARUANA [n]\n",
  "ARAYSE": "to raise, also ARAISE [v ARAYSED, ARAYSING, ARAYSES]\n",
  "ARAYSED": "ARAYSE, to raise, also ARAISE [v]\n",
  "ARAYSES": "ARAYSE, to raise, also ARAISE [v]\n",
  "ARAYSING": "ARAYSE, to raise, also ARAISE [v]\n",
  "ARB": "(short for) an arbitrageur, a stocks and shares shyster [n -S]\n",
  "ARBA": "(Arabic) a heavy screened wagon used by Tatars and others, also ARABA, AROBA [n -S]\n",
  "ARBALEST": "a type of crossbow, also ARBALIST, ARBELEST, ARBLAST [n -S]\n",
  "ARBALESTER": "a crossbowman, also ARBALISTER, ARBLASTER [n -S]\n",
  "ARBALESTERS": "ARBALESTER, a crossbowman, also ARBALISTER, ARBLASTER [n]\n",
  "ARBALESTS": "ARBALEST, a type of crossbow, also ARBALIST, ARBELEST, ARBLAST [n]\n",
  "ARBALIST": "a type of crossbow, also ARBALEST, ARBELEST, ARBLAST [n -S]\n",
  "ARBALISTER": "a crossbowman, also ARBALESTER, ARBLASTER [n -S]\n",
  "ARBALISTERS": "ARBALISTER, a crossbowman, also ARBALESTER, ARBLASTER [n]\n",
  "ARBALISTS": "ARBALIST, a type of crossbow, also ARBALEST, ARBELEST, ARBLAST [n]\n",
  "ARBAS": "ARBA, (Arabic) a heavy screened wagon used by Tatars and others, also ARABA, AROBA [n]\n",
  "ARBELEST": "a type of crossbow, also ARBALEST, ARBALIST, ARBLAST [n -S]\n",
  "ARBELESTS": "ARBELEST, a type of crossbow, also ARBALEST, ARBALIST, ARBLAST [n]\n",
  "ARBITER": "(Latin) a person with power to decide a dispute, a judge [n -S]\n",
  "ARBITERS": "ARBITER, (Latin) a person with power to decide a dispute, a judge [n]\n",
  "ARBITRABLE": "capable of being decided by arbitration [adj]\n",
  "ARBITRAGE": "the exploitation of market imperfections to make a profit, e.g. by buying stocks and shares in one country or market and selling them in another [n -S] / to exploit the market in this way [v ARBITRAGED, ARBITRAGING, ARBITRAGES]\n",
  "ARBITRAGED": "ARBITRAGE, to exploit the market in this way [v]\n",
  "ARBITRAGER": "one who carries out arbitrage, also ARBITRAGEUR [n -S]\n",
  "ARBITRAGERS": "ARBITRAGER, one who carries out arbitrage, also ARBITRAGEUR [n]\n",
  "ARBITRAGES": "ARBITRAGE, to exploit the market in this way [v]\n",
  "ARBITRAGEUR": "one who makes profit by dealing on the stock exchange, also ARBITRAGER [n -S]\n",
  "ARBITRAGEURS": "ARBITRAGEUR, one who makes profit by dealing on the stock exchange, also ARBITRAGER [n]\n",
  "ARBITRAGING": "ARBITRAGE, to exploit the market in this way [v]\n",
  "ARBITRAL": "in Scots law, of or relating to an arbiter or an arbitration [adj]\n",
  "ARBITRAMENT": "the decision of an arbiter, also ARBITREMENT [n -S]\n",
  "ARBITRAMENTS": "ARBITRAMENT, the decision of an arbiter, also ARBITREMENT [n]\n",
  "ARBITRARILY": "ARBITRARY, arising from accident rather than from rule [adv]\n",
  "ARBITRARINESS": "the state of being arbitrary [n -ES]\n",
  "ARBITRARINESSES": "ARBITRARINESS, the state of being arbitrary [n]\n",
  "ARBITRARY": "arising from accident rather than from rule [adj ARBITRARILY]\n",
  "ARBITRATE": "to judge as arbiter or arbitrator [v ARBITRATED, ARBITRATING, ARBITRATES]\n",
  "ARBITRATED": "ARBITRATE, to judge as arbiter or arbitrator [v]\n",
  "ARBITRATES": "ARBITRATE, to judge as arbiter or arbitrator [v]\n",
  "ARBITRATING": "ARBITRATE, to judge as arbiter or arbitrator [v]\n",
  "ARBITRATION": "the action of arbitrating [n -S]\n",
  "ARBITRATIONAL": "relating to arbitration, also ARBITRATIVE [adj]\n",
  "ARBITRATIONS": "ARBITRATION, the action of arbitrating [n]\n",
  "ARBITRATIVE": "relating to arbitration, also ARBITRATIONAL [adj]\n",
  "ARBITRATOR": "one that arbitrates [n -S]\n",
  "ARBITRATORS": "ARBITRATOR, one that arbitrates [n]\n",
  "ARBITRATRICES": "ARBITRATRIX, (archaic) a female arbitrator [n]\n",
  "ARBITRATRIX": "(archaic) a female arbitrator [n ARBITRATRICES or ARBITRATRIXES]\n",
  "ARBITRATRIXES": "ARBITRATRIX, (archaic) a female arbitrator [n]\n",
  "ARBITREMENT": "the decision of an arbiter, also ARBITRAMENT [n -S]\n",
  "ARBITREMENTS": "ARBITREMENT, the decision of an arbiter, also ARBITRAMENT [n]\n",
  "ARBITRESS": "a female arbitrator [n -ES]\n",
  "ARBITRESSES": "ARBITRESS, a female arbitrator [n]\n",
  "ARBITRIUM": "(Latin) a power of decision [n -S]\n",
  "ARBITRIUMS": "ARBITRIUM, (Latin) a power of decision [n]\n",
  "ARBLAST": "a type of crossbow, also ARBALEST, ARBALIST, ARBELEST [n -S]\n",
  "ARBLASTER": "a crossbowman, also ARBALESTER, ARBALISTER [n -S]\n",
  "ARBLASTERS": "ARBLASTER, a crossbowman, also ARBALESTER, ARBALISTER [n]\n",
  "ARBLASTS": "ARBLAST, a type of crossbow, also ARBALEST, ARBALIST, ARBELEST [n]\n",
  "ARBOR": "(Latin) a shady garden shelter, also ARBOUR [n ARBORS] / a tree [n ARBORS or ARBORES]\n",
  "ARBORACEOUS": "pertaining to or like a tree; wooded [adj]\n",
  "ARBOREAL": "tree-dwelling [adj ARBOREALLY]\n",
  "ARBOREALLY": "ARBOREAL, tree-dwelling [adv]\n",
  "ARBORED": "furnished with an arbor, a bower of trees [adj]\n",
  "ARBOREOUS": "having many trees [adj]\n",
  "ARBORES": "ARBOR, (Latin) a shady garden shelter, also ARBOUR [n]\n",
  "ARBORESCENCE": "shape or growth like a tree's [n -S]\n",
  "ARBORESCENCES": "ARBORESCENCE, shape or growth like a tree's [n]\n",
  "ARBORESCENT": "branched; branching; tree-shaped [adj]\n",
  "ARBORET": "(obsolete) a shrubbery [n -S]\n",
  "ARBORETA": "ARBORETUM, (Latin) a collection of trees [n]\n",
  "ARBORETS": "ARBORET, (obsolete) a shrubbery [n]\n",
  "ARBORETUM": "(Latin) a collection of trees [n ARBORETA or ARBORETUMS]\n",
  "ARBORETUMS": "ARBORETUM, (Latin) a collection of trees [n]\n",
  "ARBORICULTURAL": "relating to arboriculture [adj]\n",
  "ARBORICULTURE": "the cultivation of trees and shrubs esp. for ornamental purposes [n -S]\n",
  "ARBORICULTURES": "ARBORICULTURE, the cultivation of trees and shrubs esp. for ornamental purposes [n]\n",
  "ARBORICULTURIST": "one who practises arboriculture, the cultivation of trees and shrubs [n]\n",
  "ARBORIO": "(Italian) a round-grained rice used in making risotto [n -S]\n",
  "ARBORIOS": "ARBORIO, (Italian) a round-grained rice used in making risotto [n]\n",
  "ARBORISATION": "an arborescence, also ARBORIZATION [n -S]\n",
  "ARBORISATIONS": "ARBORISATION, an arborescence, also ARBORIZATION [n]\n",
  "ARBORISE": "to form many branches, also ARBORIZE [v ARBORISED, ARBORISING, ARBORISES]\n",
  "ARBORISED": "ARBORISE, to form many branches, also ARBORIZE [v]\n",
  "ARBORISES": "ARBORISE, to form many branches, also ARBORIZE [v]\n",
  "ARBORISING": "ARBORISE, to form many branches, also ARBORIZE [v]\n",
  "ARBORIST": "a tree specialist [n -S]\n",
  "ARBORISTS": "ARBORIST, a tree specialist [n]\n",
  "ARBORIZATION": "an arborescence, also ARBORISATION [n -S]\n",
  "ARBORIZATIONS": "ARBORIZATION, an arborescence, also ARBORISATION [n]\n",
  "ARBORIZE": "to form many branches, also ARBORISE [v ARBORIZED, ARBORIZING, ARBORIZES]\n",
  "ARBORIZED": "ARBORIZE, to form many branches, also ARBORISE [v]\n",
  "ARBORIZES": "ARBORIZE, to form many branches, also ARBORISE [v]\n",
  "ARBORIZING": "ARBORIZE, to form many branches, also ARBORISE [v]\n",
  "ARBOROUS": "pertaining to trees [adj]\n",
  "ARBORS": "ARBOR, (Latin) a shady garden shelter, also ARBOUR [n]\n",
  "ARBORVITAE": "any of a number of North American or Far Eastern evergreen conifers, belonging chiefly to the genus Thuja [n -S]\n",
  "ARBORVITAES": "ARBORVITAE, any of a number of North American or Far Eastern evergreen conifers, belonging chiefly to the genus Thuja [n]\n",
  "ARBOUR": "a shady garden shelter, also ARBOR [n -S]\n",
  "ARBOURED": "equipped with an arbour, a bower of trees [adj]\n",
  "ARBOURS": "ARBOUR, a shady garden shelter, also ARBOR [n]\n",
  "ARBOVIRAL": "relating to arbovirus, a group of viruses spread by mosquitoes [adj]\n",
  "ARBOVIRUS": "any of a group of viruses spread by mosquitoes [n -ES]\n",
  "ARBOVIRUSES": "ARBOVIRUS, any of a group of viruses spread by mosquitoes [n]\n",
  "ARBS": "ARB, (short for) an arbitrageur, a stocks and shares shyster [n]\n",
  "ARBUSCLE": "a dwarf or shrublike tree [n -S]\n",
  "ARBUSCLES": "ARBUSCLE, a dwarf or shrublike tree [n]\n",
  "ARBUSCULAR": "like an arbuscle, a dwarf or shrublike tree [adj]\n",
  "ARBUTE": "an evergreen tree, the strawberry tree, also ARBUTUS [n -S]\n",
  "ARBUTEAN": "relating to the arbute or strawberry-tree [adj]\n",
  "ARBUTES": "ARBUTE, an evergreen tree, the strawberry tree, also ARBUTUS [n]\n",
  "ARBUTUS": "(Latin) an evergreen tree, the strawberry tree, also ARBUTE [n -ES]\n",
  "ARBUTUSES": "ARBUTUS, (Latin) an evergreen tree, the strawberry tree, also ARBUTE [n]\n",
  "ARC": "a part of the circumference of a circle or other curve [n -S] / to make an electric discharge [v ARCKED or ARCED, ARCKING or ARCING, ARCS]\n",
  "ARCADE": "a set of arches and their supporting columns; a covered and sometimes arched passageway, usually with shops on one or both sides [n -S] / to furnish with an arcade [v ARCADED, ARCADING, ARCADES]\n",
  "ARCADED": "ARCADE, to furnish with an arcade [v]\n",
  "ARCADES": "ARCADE, to furnish with an arcade [v]\n",
  "ARCADIA": "(Latin) an ideal region of rural contentment [n -S]\n",
  "ARCADIAN": "one who lives in an arcadia [n -S]\n",
  "ARCADIANS": "ARCADIAN, one who lives in an arcadia [n]\n",
  "ARCADIAS": "ARCADIA, (Latin) an ideal region of rural contentment [n]\n",
  "ARCADING": "shops in an arcade [n -S]\n",
  "ARCADINGS": "ARCADING, shops in an arcade [n]\n",
  "ARCANA": "either of the two divisions of a pack of tarot cards [n -S]\n",
  "ARCANAS": "ARCANA, either of the two divisions of a pack of tarot cards [n]\n",
  "ARCANE": "mysterious [adj ARCANELY]\n",
  "ARCANELY": "ARCANE, mysterious [adv]\n",
  "ARCANENESS": "being arcane [n -ES]\n",
  "ARCANENESSES": "ARCANENESS, being arcane [n]\n",
  "ARCANIST": "a person knowing secrets of manufacture [n -S]\n",
  "ARCANISTS": "ARCANIST, a person knowing secrets of manufacture [n]\n",
  "ARCANUM": "(Latin) a secret; a mystery [n ARCANA or ARCANUMS]\n",
  "ARCANUMS": "ARCANUM, (Latin) a secret; a mystery [n]\n",
  "ARCATURE": "a small or blind arcade [n -S]\n",
  "ARCATURES": "ARCATURE, a small or blind arcade [n]\n",
  "ARCCOSINE": "a mathematical function [n -S]\n",
  "ARCCOSINES": "ARCCOSINE, a mathematical function [n]\n",
  "ARCED": "ARC, to make an electric discharge [v]\n",
  "ARCH": "sly, mischievous [adj ARCHER, ARCHEST, ARCHLY] / to bend like a curved structure [v -ED, -ING, -ES]\n",
  "ARCHAEA": "ARCHAEON, a single celled organism like bacterium [n]\n",
  "ARCHAEAL": "relating to the archaea, an order of prokaryotic microorganisms, also ARCHAEAN, ARCHAEON, ARCHEAN [adj]\n",
  "ARCHAEAN": "any member of the archaea, an order of prokaryootic microorganisms, also ARCHAEON, ARCHEAN [n -S]\n",
  "ARCHAEANS": "ARCHAEAN, any member of the archaea, an order of prokaryootic microorganisms, also ARCHAEON, ARCHEAN [n]\n",
  "ARCHAEBACTERIA": "ARCHAEBACTERIUM, any of the microorganisms comprising the archaea [n]\n",
  "ARCHAEBACTERIUM": "any of the microorganisms comprising the archaea [n ARCHAEBACTERIA]\n",
  "ARCHAEI": "ARCHAEUS, an inner controlling spirit, also ARCHEUS [n]\n",
  "ARCHAEOBOTANIES": "ARCHAEOBOTANY, the analysis and interpretation of plant remains found at archaeological sites, also ARCHEOBOTANY [n]\n",
  "ARCHAEOBOTANIST": "one who studies archaeobotany [n]\n",
  "ARCHAEOBOTANY": "the analysis and interpretation of plant remains found at archaeological sites, also ARCHEOBOTANY [n ARCHAEOBOTANIES]\n",
  "ARCHAEOLOGICAL": "relating to archaeology [adj]\n",
  "ARCHAEOLOGIES": "ARCHAEOLOGY, the study of ancient human artefacts, also ARCHEOLOGY [n]\n",
  "ARCHAEOLOGIST": "a practitioner of archaeology [n -S]\n",
  "ARCHAEOLOGISTS": "ARCHAEOLOGIST, a practitioner of archaeology [n]\n",
  "ARCHAEOLOGY": "the study of ancient human artefacts, also ARCHEOLOGY [n ARCHAEOLOGIES]\n",
  "ARCHAEOMETRIC": "relating to archaeometry [adj]\n",
  "ARCHAEOMETRIES": "ARCHAEOMETRY, the use of scientific methods in archaeology, also ARCHEOMETRY [n]\n",
  "ARCHAEOMETRIST": "one who practises archaeometry [n -S]\n",
  "ARCHAEOMETRISTS": "ARCHAEOMETRIST, one who practises archaeometry [n]\n",
  "ARCHAEOMETRY": "the use of scientific methods in archaeology, also ARCHEOMETRY [n ARCHAEOMETRIES]\n",
  "ARCHAEON": "a single celled organism like bacterium [n ARCHAEA]\n",
  "ARCHAEOPTERYX": "a Jurassic fossil bird of the Archaeopteryx genus, with a long bony tail, sharp-toothed jaws, and wings bearing three clawed digits [n ARCHAEOPTERYXES]\n",
  "ARCHAEOPTERYXES": "ARCHAEOPTERYX, a Jurassic fossil bird of the Archaeopteryx genus, with a long bony tail, sharp-toothed jaws, and wings bearing three clawed digits [n]\n",
  "ARCHAEORNIS": "a primitive reptile-like fossil bird [n -ES]\n",
  "ARCHAEORNISES": "ARCHAEORNIS, a primitive reptile-like fossil bird [n]\n",
  "ARCHAEOZOOLOGY": "the study of zoological remains in archaeology, also ARCHAEZOOLOGY, ARCHEOZOOLOGY [n]\n",
  "ARCHAEUS": "an inner controlling spirit, also ARCHEUS [n ARCHAEI]\n",
  "ARCHAEZOOLOGIES": "ARCHAEZOOLOGY, the study of zoological remains in archaeology, also ARCHAEOZOOLOGY, ARCHEOZOOLOGY [n]\n",
  "ARCHAEZOOLOGY": "the study of zoological remains in archaeology, also ARCHAEOZOOLOGY, ARCHEOZOOLOGY [n ARCHAEZOOLOGIES]\n",
  "ARCHAIC": "pertaining to an earlier time [adj ARCHAICALLY]\n",
  "ARCHAICAL": "ancient, also ARCHAIC [adj ARCHAICALLY]\n",
  "ARCHAICALLY": "ARCHAICAL, ancient, also ARCHAIC [adv]\n",
  "ARCHAICISM": "an archaic expression [n -S]\n",
  "ARCHAICISMS": "ARCHAICISM, an archaic expression [n]\n",
  "ARCHAISE": "to use idioms, also ARCHAIZE [v ARCHAISED, ARCHAISING, ARCHAISES]\n",
  "ARCHAISED": "ARCHAISE, to use idioms, also ARCHAIZE [v]\n",
  "ARCHAISER": "one who archaises, also ARCHAIZER [n -S]\n",
  "ARCHAISERS": "ARCHAISER, one who archaises, also ARCHAIZER [n]\n",
  "ARCHAISES": "ARCHAISE, to use idioms, also ARCHAIZE [v]\n",
  "ARCHAISING": "ARCHAISE, to use idioms, also ARCHAIZE [v]\n",
  "ARCHAISM": "an expression or idiom [n -S]\n",
  "ARCHAISMS": "ARCHAISM, an expression or idiom [n]\n",
  "ARCHAIST": "an antiquary [n -S]\n",
  "ARCHAISTIC": "like, or imitative of, anything archaic; pertaining to an archaism [adj]\n",
  "ARCHAISTS": "ARCHAIST, an antiquary [n]\n",
  "ARCHAIZE": "to use idioms, also ARCHAISE [v ARCHAIZED, ARCHAIZING, ARCHAIZES]\n",
  "ARCHAIZED": "ARCHAIZE, to use idioms, also ARCHAISE [v]\n",
  "ARCHAIZER": "one who archaizes, also ARCHAISER [n -S]\n",
  "ARCHAIZERS": "ARCHAIZER, one who archaizes, also ARCHAISER [n]\n",
  "ARCHAIZES": "ARCHAIZE, to use idioms, also ARCHAISE [v]\n",
  "ARCHAIZING": "ARCHAIZE, to use idioms, also ARCHAISE [v]\n",
  "ARCHANGEL": "a top-ranking angel [n -S]\n",
  "ARCHANGELIC": "relating to an archangel [adj]\n",
  "ARCHANGELS": "ARCHANGEL, a top-ranking angel [n]\n",
  "ARCHBISHOP": "a bishop at the head of an ecclesiastical province or one of equivalent honorary rank [n -S]\n",
  "ARCHBISHOPRIC": "the see or province over which an archbishop exercises authority [n -S]\n",
  "ARCHBISHOPRICS": "ARCHBISHOPRIC, the see or province over which an archbishop exercises authority [n]\n",
  "ARCHBISHOPS": "ARCHBISHOP, a bishop at the head of an ecclesiastical province or one of equivalent honorary rank [n]\n",
  "ARCHDEACON": "a clergyman having the duty of assisting a diocesan bishop in ceremonial functions or administrative work [n -S]\n",
  "ARCHDEACONRIES": "ARCHDEACONRY, the district or residence of an archdeacon [n]\n",
  "ARCHDEACONRY": "the district or residence of an archdeacon [n ARCHDEACONRIES]\n",
  "ARCHDEACONS": "ARCHDEACON, a clergyman having the duty of assisting a diocesan bishop in ceremonial functions or administrative work [n]\n",
  "ARCHDIOCESAN": "relating to archdiocese [adj]\n",
  "ARCHDIOCESE": "the diocese of an archbishop [n -S]\n",
  "ARCHDIOCESES": "ARCHDIOCESE, the diocese of an archbishop [n]\n",
  "ARCHDRUID": "a chief or presiding druid [n -S]\n",
  "ARCHDRUIDS": "ARCHDRUID, a chief or presiding druid [n]\n",
  "ARCHDUCAL": "of or pertaining to an archduke or archduchy [adj]\n",
  "ARCHDUCHESS": "the wife or widow of an archduke [n -ES]\n",
  "ARCHDUCHESSES": "ARCHDUCHESS, the wife or widow of an archduke [n]\n",
  "ARCHDUCHIES": "ARCHDUCHY, the territory of an archduke or archduchess [n]\n",
  "ARCHDUCHY": "the territory of an archduke or archduchess [n ARCHDUCHIES]\n",
  "ARCHDUKE": "(historical) a chief duke, esp. a son of the Emperor of Austria [n -S]\n",
  "ARCHDUKEDOM": "the domain of an archduke [n -S]\n",
  "ARCHDUKEDOMS": "ARCHDUKEDOM, the domain of an archduke [n]\n",
  "ARCHDUKES": "ARCHDUKE, (historical) a chief duke, esp. a son of the Emperor of Austria [n]\n",
  "ARCHEAN": "relating to the archaea, an order of prokaryootic microorganisms, also ARCHAEAL, ARCHAEAN, ARCHAEON [adj]\n",
  "ARCHED": "ARCH, to bend like a curved structure [v]\n",
  "ARCHEGONIA": "ARCHEGONIUM, the structure on the pteridophyte prothallus that produces the sessile female gametes [n]\n",
  "ARCHEGONIAL": "relating to an archegonium [adj]\n",
  "ARCHEGONIATE": "having archegonia [adj] / a plant having archegonia [n -S]\n",
  "ARCHEGONIATES": "ARCHEGONIATE, a plant having archegonia [n]\n",
  "ARCHEGONIUM": "the structure on the pteridophyte prothallus that produces the sessile female gametes [n ARCHEGONIA]\n",
  "ARCHEI": "ARCHEUS, an inner controlling spirit, also ARCHAEUS [n]\n",
  "ARCHENEMIES": "ARCHENEMY, a chief enemy [n]\n",
  "ARCHENEMY": "a chief enemy [n ARCHENEMIES]\n",
  "ARCHENTERA": "ARCHENTERON, in the developing embryo, the primitive gut [n]\n",
  "ARCHENTERIC": "relating to the archenteron; as, archenteric invagination [adj]\n",
  "ARCHENTERON": "in the developing embryo, the primitive gut [n ARCHENTERA or ARCHENTERONS]\n",
  "ARCHENTERONS": "ARCHENTERON, in the developing embryo, the primitive gut [n]\n",
  "ARCHEOASTRONOMY": "the scientific study of the beliefs and practices concerning astronomy that existed in ancient and prehistoric civilizations [n]\n",
  "ARCHEOBOTANIES": "ARCHEOBOTANY, the analysis and interpretation of plant remains found at archaeological sites, also ARCHAEOBOTANY [n]\n",
  "ARCHEOBOTANIST": "one who studies archeobotany [n -S]\n",
  "ARCHEOBOTANISTS": "ARCHEOBOTANIST, one who studies archeobotany [n]\n",
  "ARCHEOBOTANY": "the analysis and interpretation of plant remains found at archaeological sites, also ARCHAEOBOTANY [n ARCHEOBOTANIES]\n",
  "ARCHEOLOGICAL": "relating to archeology, also ARCHAEOLOGICAL [adj ARCHEOLOGICALLY]\n",
  "ARCHEOLOGICALLY": "ARCHEOLOGICAL, relating to archeology, also ARCHAEOLOGICAL [adv]\n",
  "ARCHEOLOGIES": "ARCHEOLOGY, the study of ancient human artefacts, also ARCHAEOLOGY [n]\n",
  "ARCHEOLOGIST": "one who does archeology, also ARCHAEOLOGIST [n -S]\n",
  "ARCHEOLOGISTS": "ARCHEOLOGIST, one who does archeology, also ARCHAEOLOGIST [n]\n",
  "ARCHEOLOGY": "the study of ancient human artefacts, also ARCHAEOLOGY [n ARCHEOLOGIES]\n",
  "ARCHEOMAGNETISM": "an archaeological technique for dating certain clay objects by measuring the extent to which they have been magnetized by the earth's magnetic field [n]\n",
  "ARCHEOMETRIES": "ARCHEOMETRY, the use of scientific methods in archaeology, also ARCHAEOMETRY [n]\n",
  "ARCHEOMETRY": "the use of scientific methods in archaeology, also ARCHAEOMETRY [n ARCHEOMETRIES]\n",
  "ARCHEOZOOLOGIES": "ARCHEOZOOLOGY, the study of zoological remains in archaeology, also ARCHAEOZOOLOGY, ARCHAEZOOLOGY [n]\n",
  "ARCHEOZOOLOGIST": "a specialist in archeozoology [n]\n",
  "ARCHEOZOOLOGY": "the study of zoological remains in archaeology, also ARCHAEOZOOLOGY, ARCHAEZOOLOGY [n ARCHEOZOOLOGIES]\n",
  "ARCHER": "someone who uses a bow and arrow [n -S]\n",
  "ARCHERESS": "(archaic) a female archer [n -ES]\n",
  "ARCHERESSES": "ARCHERESS, (archaic) a female archer [n]\n",
  "ARCHERFISH": "a kind of fish that shoots a jet of water to knock down insects [n -ES]\n",
  "ARCHERFISHES": "ARCHERFISH, a kind of fish that shoots a jet of water to knock down insects [n]\n",
  "ARCHERIES": "ARCHERY, the sport of shooting with bows and arrows [n]\n",
  "ARCHERS": "ARCHER, someone who uses a bow and arrow [n]\n",
  "ARCHERY": "the sport of shooting with bows and arrows [n ARCHERIES]\n",
  "ARCHES": "ARCH, to bend like a curved structure [v]\n",
  "ARCHESPORE": "the cell or group of cells in a sporangium that gives rise to spores [n -S]\n",
  "ARCHESPORES": "ARCHESPORE, the cell or group of cells in a sporangium that gives rise to spores [n]\n",
  "ARCHESPORIA": "ARCHESPORIUM, a primitive cell or group of cells from which a mother cell develops [n]\n",
  "ARCHESPORIAL": "of or like an archesporium, a primitive cell or group of cells from which a mother cell develops [adj]\n",
  "ARCHESPORIUM": "a primitive cell or group of cells from which a mother cell develops [n ARCHESPORIA]\n",
  "ARCHEST": "ARCH, sly, mischievous [adj]\n",
  "ARCHETYPAL": "of or like an archetype, also ARCHETYPICAL [adj ARCHETYPALLY]\n",
  "ARCHETYPALLY": "ARCHETYPAL, of or like an archetype, also ARCHETYPICAL [adv]\n",
  "ARCHETYPE": "the original pattern or model from which copies are made, also ARCHITYPE [n -S]\n",
  "ARCHETYPES": "ARCHETYPE, the original pattern or model from which copies are made, also ARCHITYPE [n]\n",
  "ARCHETYPICAL": "of or like an archetype, also ARCHETYPAL [adj ARCHETYPICALLY]\n",
  "ARCHETYPICALLY": "ARCHETYPICAL, of or like an archetype, also ARCHETYPAL [adv]\n",
  "ARCHEUS": "an inner controlling spirit, also ARCHAEUS [n ARCHEI]\n",
  "ARCHFIEND": "the chief devil, Satan [n -S]\n",
  "ARCHFIENDS": "ARCHFIEND, the chief devil, Satan [n]\n",
  "ARCHFOE": "a principal foe [n -S]\n",
  "ARCHFOES": "ARCHFOE, a principal foe [n]\n",
  "ARCHFOOL": "a complete fool [n -S]\n",
  "ARCHFOOLS": "ARCHFOOL, a complete fool [n]\n",
  "ARCHGENETHLIAC": "(Browning) in derogatory sense, the greatest of genethliacs or astrologers [n -S]\n",
  "ARCHGENETHLIACS": "ARCHGENETHLIAC, (Browning) in derogatory sense, the greatest of genethliacs or astrologers [n]\n",
  "ARCHI": "ARCO, (Italian) the bow of a stringed instrument [n]\n",
  "ARCHICARP": "a female reproductive structure in certain types of fungi [n -S]\n",
  "ARCHICARPS": "ARCHICARP, a female reproductive structure in certain types of fungi [n]\n",
  "ARCHIDIACONAL": "of or relating to an archdeacon [adj]\n",
  "ARCHIDIACONATE": "the office of archdeacon [n -S]\n",
  "ARCHIDIACONATES": "ARCHIDIACONATE, the office of archdeacon [n]\n",
  "ARCHIEPISCOPACY": "the rank or province of an archbishop [n]\n",
  "ARCHIEPISCOPAL": "pertaining to an archbishop [adj]\n",
  "ARCHIEPISCOPATE": "the rank or province of an archbishop [n]\n",
  "ARCHIL": "a red or violet dye, also ORCHEL, ORCHELLA, ORCHILLA, ORSEILLE [n -S]\n",
  "ARCHILOWE": "(Scots) a treat given in return [n -S]\n",
  "ARCHILOWES": "ARCHILOWE, (Scots) a treat given in return [n]\n",
  "ARCHILS": "ARCHIL, a red or violet dye, also ORCHEL, ORCHELLA, ORCHILLA, ORSEILLE [n]\n",
  "ARCHIMAGE": "a great magician [n -S]\n",
  "ARCHIMAGES": "ARCHIMAGE, a great magician [n]\n",
  "ARCHIMANDRITE": "the head of a monastery or convent [n -S]\n",
  "ARCHIMANDRITES": "ARCHIMANDRITE, the head of a monastery or convent [n]\n",
  "ARCHINE": "(Turkish) an old Russian unit of length, also ARSHEEN, ARSHIN, ARSHINE [n -S]\n",
  "ARCHINES": "ARCHINE, (Turkish) an old Russian unit of length, also ARSHEEN, ARSHIN, ARSHINE [n]\n",
  "ARCHING": "a series of arches [n -S]\n",
  "ARCHINGS": "ARCHING, a series of arches [n]\n",
  "ARCHIPELAGIAN": "of, relating to, or located in an archipelago, also ARCHIPELAGIC [adj]\n",
  "ARCHIPELAGIC": "of, relating to, or located in an archipelago, also ARCHIPELAGIAN [adj]\n",
  "ARCHIPELAGO": "a chain or set of islands grouped together [n ARCHIPELAGOS or ARCHIPELAGOES]\n",
  "ARCHIPELAGOES": "ARCHIPELAGO, a chain or set of islands grouped together [n]\n",
  "ARCHIPELAGOS": "ARCHIPELAGO, a chain or set of islands grouped together [n]\n",
  "ARCHIPHONEME": "an abstract linguistic unit representing two or more phonemes when the distinction between these has been neutralized, conventionally shown by a capital letter within slashes [n -S]\n",
  "ARCHIPHONEMES": "ARCHIPHONEME, an abstract linguistic unit representing two or more phonemes when the distinction between these has been neutralized, conventionally shown by a capital letter within slashes [n]\n",
  "ARCHIPLASM": "the protoplasmic material surrounding the centrosome, formerly thought to be involved in the formation of the asters and spindle during mitosis, also ARCHOPLASM [n -S]\n",
  "ARCHIPLASMIC": "relating to archiplasm, the protoplasmic material surrounding the centrosome [adj]\n",
  "ARCHIPLASMS": "ARCHIPLASM, the protoplasmic material surrounding the centrosome, formerly thought to be involved in the formation of the asters and spindle during mitosis, also ARCHOPLASM [n]\n",
  "ARCHITECT": "a designer of buildings [n -S] / to construct [v -ED, -ING, -S]\n",
  "ARCHITECTED": "ARCHITECT, to construct [v]\n",
  "ARCHITECTING": "ARCHITECT, to construct [v]\n",
  "ARCHITECTONIC": "of or pertaining to architecture or architects [adj]\n",
  "ARCHITECTONICS": "the study of the arrangement of knowledge [n]\n",
  "ARCHITECTS": "ARCHITECT, to construct [v]\n",
  "ARCHITECTURAL": "of or relating to architecture [adj ARCHITECTURALLY]\n",
  "ARCHITECTURALLY": "ARCHITECTURAL, of or relating to architecture [adv]\n",
  "ARCHITECTURE": "the art or science of building [n -S]\n",
  "ARCHITECTURES": "ARCHITECTURE, the art or science of building [n]\n",
  "ARCHITRAVE": "the collective name for the various parts, jambs, lintels, etc., that surround a door or window [n ARCHITRAVES]\n",
  "ARCHITRAVED": "having an architrave [adj]\n",
  "ARCHITRAVES": "ARCHITRAVE, the collective name for the various parts, jambs, lintels, etc., that surround a door or window [n]\n",
  "ARCHITYPE": "the original pattern or model from which copies are made, also ARCHETYPE [n -S]\n",
  "ARCHITYPES": "ARCHITYPE, the original pattern or model from which copies are made, also ARCHETYPE [n]\n",
  "ARCHIVAL": "pertaining to archive [adj]\n",
  "ARCHIVE": "a repository of public records or records generally [n -S] / to file in an archive [v ARCHIVED, ARCHIVING, ARCHIVES]\n",
  "ARCHIVED": "ARCHIVE, to file in an archive [v]\n",
  "ARCHIVES": "ARCHIVE, to file in an archive [v]\n",
  "ARCHIVING": "ARCHIVE, to file in an archive [v]\n",
  "ARCHIVIST": "one who keeps an archive [n -S]\n",
  "ARCHIVISTS": "ARCHIVIST, one who keeps an archive [n]\n",
  "ARCHIVOLT": "a curved moulding on the face of an arch [n -S]\n",
  "ARCHIVOLTS": "ARCHIVOLT, a curved moulding on the face of an arch [n]\n",
  "ARCHLET": "a little arch [n -S]\n",
  "ARCHLETS": "ARCHLET, a little arch [n]\n",
  "ARCHLIKE": "like an arch [adj]\n",
  "ARCHLUTE": "a large double-necked bass lute [n -S]\n",
  "ARCHLUTES": "ARCHLUTE, a large double-necked bass lute [n]\n",
  "ARCHLY": "ARCH, sly, mischievous [adv]\n",
  "ARCHNESS": "slyness [n -ES]\n",
  "ARCHNESSES": "ARCHNESS, slyness [n]\n",
  "ARCHOLOGIES": "ARCHOLOGY, the science of the origins of government [n]\n",
  "ARCHOLOGY": "the science of the origins of government [n ARCHOLOGIES]\n",
  "ARCHON": "the chief magistrate of ancient Athens [n -S]\n",
  "ARCHONS": "ARCHON, the chief magistrate of ancient Athens [n]\n",
  "ARCHONSHIP": "the office of an archon [n -S]\n",
  "ARCHONSHIPS": "ARCHONSHIP, the office of an archon [n]\n",
  "ARCHONTATE": "an archon's term of office [n -S]\n",
  "ARCHONTATES": "ARCHONTATE, an archon's term of office [n]\n",
  "ARCHONTIC": "relating to an archon, the chief magistrate in ancient Athens [adj]\n",
  "ARCHOPLASM": "the protoplasmic material surrounding the centrosome, formerly thought to be involved in the formation of the asters and spindle during mitosis, also ARCHIPLASM [n -S]\n",
  "ARCHOPLASMIC": "relating to archoplasm, the protoplasmic material surrounding the centrosome [adj]\n",
  "ARCHOPLASMS": "ARCHOPLASM, the protoplasmic material surrounding the centrosome, formerly thought to be involved in the formation of the asters and spindle during mitosis, also ARCHIPLASM [n]\n",
  "ARCHOSAUR": "any of a subclass of reptiles comprising pterosaurs, dinosaurs and crocodilians [n -S]\n",
  "ARCHOSAURIAN": "any of a subclass of reptiles comprising pterosaurs, dinosaurs and crocodilians, also ARCHOSAUR [n -S]\n",
  "ARCHOSAURIANS": "ARCHOSAURIAN, any of a subclass of reptiles comprising pterosaurs, dinosaurs and crocodilians, also ARCHOSAUR [n]\n",
  "ARCHOSAURS": "ARCHOSAUR, any of a subclass of reptiles comprising pterosaurs, dinosaurs and crocodilians [n]\n",
  "ARCHPRIEST": "a chief priest [n -S]\n",
  "ARCHPRIESTHOOD": "the office of archpriest [n -S]\n",
  "ARCHPRIESTHOODS": "ARCHPRIESTHOOD, the office of archpriest [n]\n",
  "ARCHPRIESTS": "ARCHPRIEST, a chief priest [n]\n",
  "ARCHPRIESTSHIP": "the office of archpriest [n -S]\n",
  "ARCHPRIESTSHIPS": "ARCHPRIESTSHIP, the office of archpriest [n]\n",
  "ARCHRIVAL": "a chief rival [n -S]\n",
  "ARCHRIVALS": "ARCHRIVAL, a chief rival [n]\n",
  "ARCHSTONE": "a stone in an arch, a voussoir [n -S]\n",
  "ARCHSTONES": "ARCHSTONE, a stone in an arch, a voussoir [n]\n",
  "ARCHWAY": "a passageway under an arch [n -S]\n",
  "ARCHWAYS": "ARCHWAY, a passageway under an arch [n]\n",
  "ARCHWISE": "in the manner of an arch [adv]\n",
  "ARCIFORM": "having the form of an arch [adj]\n",
  "ARCING": "an electrical discharge, also ARCKING [n -S]\n",
  "ARCINGS": "ARCING, an electrical discharge, also ARCKING [n]\n",
  "ARCKED": "ARC, to make an electric discharge [v]\n",
  "ARCKING": "an electrical discharge, also ARCING [n -S]\n",
  "ARCKINGS": "ARCKING, an electrical discharge, also ARCING [n]\n",
  "ARCMIN": "an angular measure, one sixtieth of a degree [n -S]\n",
  "ARCMINS": "ARCMIN, an angular measure, one sixtieth of a degree [n]\n",
  "ARCMINUTE": "a unit of angular measurement, one sixtieth of a degree [n -S]\n",
  "ARCMINUTES": "ARCMINUTE, a unit of angular measurement, one sixtieth of a degree [n]\n",
  "ARCO": "(Italian) the bow of a stringed instrument [n ARCOS or ARCHI]\n",
  "ARCOGRAPH": "an instrument for drawing arcs without using a central point [n -S]\n",
  "ARCOGRAPHS": "ARCOGRAPH, an instrument for drawing arcs without using a central point [n]\n",
  "ARCOLOGIES": "ARCOLOGY, a system of architecture that integrates buildings with the environment [n]\n",
  "ARCOLOGY": "a system of architecture that integrates buildings with the environment [n ARCOLOGIES]\n",
  "ARCOS": "ARCO, (Italian) the bow of a stringed instrument [n]\n",
  "ARCS": "ARC, to make an electric discharge [v]\n",
  "ARCSEC": "an angular measure, 1/3600 of a degree [n -S]\n",
  "ARCSECOND": "a unit of angle measurement, 1/3600 of a degree, also ARCSEC [n -S]\n",
  "ARCSECONDS": "ARCSECOND, a unit of angle measurement, 1/3600 of a degree, also ARCSEC [n]\n",
  "ARCSECS": "ARCSEC, an angular measure, 1/3600 of a degree [n]\n",
  "ARCSINE": "a trigonometric inverse function [n -S]\n",
  "ARCSINES": "ARCSINE, a trigonometric inverse function [n]\n",
  "ARCTANGENT": "a geometrical ratio [n -S]\n",
  "ARCTANGENTS": "ARCTANGENT, a geometrical ratio [n]\n",
  "ARCTIC": "relating to the northern cold zone [adj ARCTICALLY] / a waterproof overshoe [n -S]\n",
  "ARCTICALLY": "ARCTIC, relating to the northern cold zone [adv]\n",
  "ARCTICS": "ARCTIC, a waterproof overshoe [n]\n",
  "ARCTIID": "a moth of the Arctiidae family [n -S]\n",
  "ARCTIIDS": "ARCTIID, a moth of the Arctiidae family [n]\n",
  "ARCTOID": "bearlike [adj]\n",
  "ARCTOPHIL": "a lover or collector of teddy-bears, also ARCTOPHILE [n -S]\n",
  "ARCTOPHILE": "a lover or collector of teddy bears, also ARCTOPHIL [n -S]\n",
  "ARCTOPHILES": "ARCTOPHILE, a lover or collector of teddy bears, also ARCTOPHIL [n]\n",
  "ARCTOPHILIA": "the love of teddy-bears [n -S]\n",
  "ARCTOPHILIAS": "ARCTOPHILIA, the love of teddy-bears [n]\n",
  "ARCTOPHILIES": "ARCTOPHILY, the study of teddy bears [n]\n",
  "ARCTOPHILIST": "a collector of teddy bears [n -S]\n",
  "ARCTOPHILISTS": "ARCTOPHILIST, a collector of teddy bears [n]\n",
  "ARCTOPHILS": "ARCTOPHIL, a lover or collector of teddy-bears, also ARCTOPHILE [n]\n",
  "ARCTOPHILY": "the study of teddy bears [n ARCTOPHILIES]\n",
  "ARCUATE": "arched like a bow, also ARCUATED [adj ARCUATELY]\n",
  "ARCUATED": "arched like a bow, also ARCUATE [adj]\n",
  "ARCUATELY": "ARCUATE, arched like a bow, also ARCUATED [adv]\n",
  "ARCUATION": "the state of being shaped like a bow [n -S]\n",
  "ARCUATIONS": "ARCUATION, the state of being shaped like a bow [n]\n",
  "ARCUBALIST": "a crossbow [n -S]\n",
  "ARCUBALISTS": "ARCUBALIST, a crossbow [n]\n",
  "ARCUS": "(Latin) a bow-shaped or ring-shaped fatty deposit found in the cornea [n -ES]\n",
  "ARCUSES": "ARCUS, (Latin) a bow-shaped or ring-shaped fatty deposit found in the cornea [n]\n",
  "ARD": "a kind of primitive plough [n -S]\n",
  "ARDEB": "(Arabic) an Egyptian measure [n -S]\n",
  "ARDEBS": "ARDEB, (Arabic) an Egyptian measure [n]\n",
  "ARDENCIES": "ARDENCY, a burning quality; (figuratively) warmth of feeling or desire, ardour [n]\n",
  "ARDENCY": "a burning quality; (figuratively) warmth of feeling or desire, ardour [n ARDENCIES]\n",
  "ARDENT": "burning with emotion [adj]\n",
  "ARDENTLY": "ARDENT, burning with emotion [adv]\n",
  "ARDOR": "(US) passion of feeling, also ARDOUR [n -S]\n",
  "ARDORS": "ARDOR, (US) passion of feeling, also ARDOUR [n]\n",
  "ARDOUR": "passion of feeling, also ARDOR [n -S]\n",
  "ARDOURS": "ARDOUR, passion of feeling, also ARDOR [n]\n",
  "ARDRI": "(Irish) a title given to the High King of Ireland, also ARDRIGH [n -S]\n",
  "ARDRIGH": "(Irish) a title given to the High King of Ireland, also ARDRI [n -S]\n",
  "ARDRIGHS": "ARDRIGH, (Irish) a title given to the High King of Ireland, also ARDRI [n]\n",
  "ARDRIS": "ARDRI, (Irish) a title given to the High King of Ireland, also ARDRIGH [n]\n",
  "ARDS": "ARD, a kind of primitive plough [n]\n",
  "ARDUOUS": "laborious [adj ARDUOUSLY]\n",
  "ARDUOUSLY": "ARDUOUS, laborious [adv]\n",
  "ARDUOUSNESS": "the state of being arduous [n -ES]\n",
  "ARDUOUSNESSES": "ARDUOUSNESS, the state of being arduous [n]\n",
  "ARE": "a unit of metric land measure [n -S]\n",
  "AREA": "(Latin) a region [n AREAS] / part of the cerebral cortex [n AREAE]\n",
  "AREACH": "(Spenser) to reach [v ARRAUGHT or AREACHED, AREACHING, AREACHES]\n",
  "AREACHED": "AREACH, (Spenser) to reach [v]\n",
  "AREACHES": "AREACH, (Spenser) to reach [v]\n",
  "AREACHING": "AREACH, (Spenser) to reach [v]\n",
  "AREAD": "(Spenser) to counsel, also AREDE, ARREEDE [v ARED or AREDD, AREADING, AREADS]\n",
  "AREADING": "AREAD, (Spenser) to counsel, also AREDE, ARREEDE [v]\n",
  "AREADS": "AREAD, (Spenser) to counsel, also AREDE, ARREEDE [v]\n",
  "AREAE": "AREA, (Latin) a region [n]\n",
  "AREAL": "relating to an area [adj AREALLY]\n",
  "AREALLY": "AREAL, relating to an area [adv]\n",
  "AREAR": "an unpaid and overdue debt, also ARREAR [n -S]\n",
  "AREARS": "AREAR, an unpaid and overdue debt, also ARREAR [n]\n",
  "AREAS": "AREA, (Latin) a region [n]\n",
  "AREAWAY": "a sunken area leading to a basement entrance [n -S]\n",
  "AREAWAYS": "AREAWAY, a sunken area leading to a basement entrance [n]\n",
  "ARECA": "(Malay) a tree of the betelnut genus of palms, native to SE Asia and the Indian subcontinent [n -S]\n",
  "ARECAS": "ARECA, (Malay) a tree of the betelnut genus of palms, native to SE Asia and the Indian subcontinent [n]\n",
  "ARECOLINE": "a toxic alkaloid used as a veterinary anthelmintic [n -S]\n",
  "ARECOLINES": "ARECOLINE, a toxic alkaloid used as a veterinary anthelmintic [n]\n",
  "ARED": "AREAD, (Spenser) to counsel, also AREDE, ARREEDE [v]\n",
  "AREDD": "AREAD, (Spenser) to counsel, also AREDE, ARREEDE [v]\n",
  "AREDE": "(Spenser) to declare, also AREAD, ARREEDE [v ARED or AREDD, AREDING, AREDES]\n",
  "AREDES": "AREDE, (Spenser) to declare, also AREAD, ARREEDE [v]\n",
  "AREDING": "AREDE, (Spenser) to declare, also AREAD, ARREEDE [v]\n",
  "AREFACTION": "the act of drying, or the state of growing dry [n -S]\n",
  "AREFACTIONS": "AREFACTION, the act of drying, or the state of growing dry [n]\n",
  "AREFIED": "AREFY, to dry up [v]\n",
  "AREFIES": "AREFY, to dry up [v]\n",
  "AREFY": "to dry up [v AREFIED, AREFYING, AREFIES]\n",
  "AREFYING": "AREFY, to dry up [v]\n",
  "AREG": "ERG, a unit of work [n]\n",
  "AREIC": "of an area of the earth with little surface drainage [adj]\n",
  "ARENA": "(Latin) any sphere of action [n -S]\n",
  "ARENACEOUS": "having the appearance or consistency of sand [adj]\n",
  "ARENAS": "ARENA, (Latin) any sphere of action [n]\n",
  "ARENATION": "the remedial application of hot sand to the body [n -S]\n",
  "ARENATIONS": "ARENATION, the remedial application of hot sand to the body [n]\n",
  "ARENE": "an aromatic hydrocarbon [n -S]\n",
  "ARENES": "ARENE, an aromatic hydrocarbon [n]\n",
  "ARENICOLOUS": "living in sand [adj]\n",
  "ARENITE": "a rock made up chiefly of sandy grains [n -S]\n",
  "ARENITES": "ARENITE, a rock made up chiefly of sandy grains [n]\n",
  "ARENITIC": "of or like arenite, a rock made up chiefly of sandy grains [adj]\n",
  "ARENOSE": "sandy; containing much sand, also ARENOUS [adj]\n",
  "ARENOUS": "sandy, containing much sand, also ARENOSE [adj]\n",
  "AREOCENTRIC": "of a coordinate system based on the planet Mars [adj]\n",
  "AREOGRAPHIC": "relating to areography, the description of the physical features of the planet Mars [adj]\n",
  "AREOGRAPHIES": "AREOGRAPHY, the description of the physical features of the planet Mars [n]\n",
  "AREOGRAPHY": "the description of the physical features of the planet Mars [n AREOGRAPHIES]\n",
  "AREOLA": "(Latin) a small space in a network of leaf veins, also AREOLE [n AREOLAS or AREOLAE]\n",
  "AREOLAE": "AREOLA, (Latin) a small space in a network of leaf veins, also AREOLE [n]\n",
  "AREOLAR": "pertaining to an areola [adj]\n",
  "AREOLAS": "AREOLA, (Latin) a small space in a network of leaf veins, also AREOLE [n]\n",
  "AREOLATE": "divided into areolae [adj]\n",
  "AREOLATED": "divided into areolae, also AREOLAR, AREOLATE [adj]\n",
  "AREOLATION": "division into areolae [n -S]\n",
  "AREOLATIONS": "AREOLATION, division into areolae [n]\n",
  "AREOLE": "a small space in a network of leaf veins, also AREOLA [n -S]\n",
  "AREOLES": "AREOLE, a small space in a network of leaf veins, also AREOLA [n]\n",
  "AREOLOGIES": "AREOLOGY, the study of the planet Mars [n]\n",
  "AREOLOGY": "the study of the planet Mars [n AREOLOGIES]\n",
  "AREOMETER": "(historical) an instrument used for measuring specific gravity, also ARAEOMETER [n -S]\n",
  "AREOMETERS": "AREOMETER, (historical) an instrument used for measuring specific gravity, also ARAEOMETER [n]\n",
  "AREOMETRIES": "AREOMETRY, the science of estimating the specific gravity of fluids through the use of an araeometer, also ARAEOMETRY [n]\n",
  "AREOMETRY": "the science of estimating the specific gravity of fluids through the use of an araeometer, also ARAEOMETRY [n AREOMETRIES]\n",
  "AREOSTYLE": "having columns four diameters or more apart [adj] / a building or colonnade having columns four diameters or more apart, also ARAEOSTYLE [n -S]\n",
  "AREOSTYLES": "AREOSTYLE, a building or colonnade having columns four diameters or more apart, also ARAEOSTYLE [n]\n",
  "AREOSYSTILE": "a building or colonnade alternately araeostyle and systyle, also ARAEOSYSTYLE [n -S]\n",
  "AREOSYSTILES": "AREOSYSTILE, a building or colonnade alternately araeostyle and systyle, also ARAEOSYSTYLE [n]\n",
  "AREPA": "(Spanish) a usually grilled cornmeal cake served in Latin-American cuisine [n -S]\n",
  "AREPAS": "AREPA, (Spanish) a usually grilled cornmeal cake served in Latin-American cuisine [n]\n",
  "ARERE": "(Spenser) backward, behind, also AREAR [adv]\n",
  "ARES": "ARE, a unit of metric land measure [n]\n",
  "ARET": "(Spenser) to entrust, also ARETT [v ARETTED, ARETTING, ARETS]\n",
  "ARETE": "(French) a sharp mountain ridge [n -S]\n",
  "ARETES": "ARETE, (French) a sharp mountain ridge [n]\n",
  "ARETHUSA": "a kind of orchid [n -S]\n",
  "ARETHUSAS": "ARETHUSA, a kind of orchid [n]\n",
  "ARETS": "ARET, (Spenser) to entrust, also ARETT [v]\n",
  "ARETT": "(obsolete) to entrust, also ARET [v -ED, -ING, -S]\n",
  "ARETTED": "ARET, (Spenser) to entrust, also ARETT [v]\n",
  "ARETTING": "ARET, (Spenser) to entrust, also ARETT [v]\n",
  "ARETTS": "ARETT, (obsolete) to entrust, also ARET [v]\n",
  "AREW": "(Spenser) in a row, also AROW [adv]\n",
  "ARF": "a barking sound [n -S]\n",
  "ARFS": "ARF, a barking sound [n]\n",
  "ARFVEDSONITE": "(Swedish) an iron-rich sodium amphibole [n -S]\n",
  "ARFVEDSONITES": "ARFVEDSONITE, (Swedish) an iron-rich sodium amphibole [n]\n",
  "ARGAL": "a hard crust (generally reddish) formed on the sides of wine-vessels, also ARGOL [n -S]\n",
  "ARGALA": "(Hindi) the adjutant stork of India [n -S]\n",
  "ARGALAS": "ARGALA, (Hindi) the adjutant stork of India [n]\n",
  "ARGALI": "(Mongolian) the great wild sheep of Asia [n -S]\n",
  "ARGALIS": "ARGALI, (Mongolian) the great wild sheep of Asia [n]\n",
  "ARGALS": "ARGAL, a hard crust (generally reddish) formed on the sides of wine-vessels, also ARGOL [n]\n",
  "ARGAN": "(Arabic) a Moroccan timber-tree; its oil-bearing seed [n -S]\n",
  "ARGAND": "(French) a gas lamp named after its inventor [n -S]\n",
  "ARGANDS": "ARGAND, (French) a gas lamp named after its inventor [n]\n",
  "ARGANS": "ARGAN, (Arabic) a Moroccan timber-tree; its oil-bearing seed [n]\n",
  "ARGEMONE": "(Greek) a plant of the prickly poppy genus [n -S]\n",
  "ARGEMONES": "ARGEMONE, (Greek) a plant of the prickly poppy genus [n]\n",
  "ARGENT": "silver [n -S]\n",
  "ARGENTAL": "of or pertaining to silver [adj]\n",
  "ARGENTIC": "containing silver in lower valency [adj]\n",
  "ARGENTIFEROUS": "bearing silver e.g. galena [adj]\n",
  "ARGENTINE": "of or like silver [adj] / a small marine fish with silvery sides [n -S]\n",
  "ARGENTINES": "ARGENTINE, a small marine fish with silvery sides [n]\n",
  "ARGENTITE": "a native sulphide of silver, aka silver glance [n -S]\n",
  "ARGENTITES": "ARGENTITE, a native sulphide of silver, aka silver glance [n]\n",
  "ARGENTOUS": "of or containing silver in the monovalent state [adj]\n",
  "ARGENTS": "ARGENT, silver [n]\n",
  "ARGENTUM": "(Latin) silver [n -S]\n",
  "ARGENTUMS": "ARGENTUM, (Latin) silver [n]\n",
  "ARGH": "an interjection expressing pain or dismay, also AARGH, AARRGH, AARRGHH [interj]\n",
  "ARGHAN": "pita fibre [n -S]\n",
  "ARGHANS": "ARGHAN, pita fibre [n]\n",
  "ARGIL": "a potter's clay [n -S]\n",
  "ARGILLACEOUS": "containing clay; claylike [adj]\n",
  "ARGILLIFEROUS": "containing or yielding clay [adj]\n",
  "ARGILLITE": "an indurated clay rock [n -S]\n",
  "ARGILLITES": "ARGILLITE, an indurated clay rock [n]\n",
  "ARGILLITIC": "like argillite, an indurated argillaceous rock [adj]\n",
  "ARGILS": "ARGIL, a potter's clay [n]\n",
  "ARGINASE": "a manganese-containing enzyme, forming part of the urea cycle [n -S]\n",
  "ARGINASES": "ARGINASE, a manganese-containing enzyme, forming part of the urea cycle [n]\n",
  "ARGININE": "one of the essential amino acids [n -S]\n",
  "ARGININES": "ARGININE, one of the essential amino acids [n]\n",
  "ARGLE": "to argue [v ARGLED, ARGLING, ARGLES]\n",
  "ARGLED": "ARGLE, to argue [v]\n",
  "ARGLES": "ARGLE, to argue [v]\n",
  "ARGLING": "ARGLE, to argue [v]\n",
  "ARGOL": "a hard crust (generally reddish) formed on the sides of wine-vessels, also ARGAL [n -S]\n",
  "ARGOLS": "ARGOL, a hard crust (generally reddish) formed on the sides of wine-vessels, also ARGAL [n]\n",
  "ARGON": "an inert gaseous element [n -S]\n",
  "ARGONAUT": "(Greek) a sort of cuttlefish, aka paper nautilus [n -S]\n",
  "ARGONAUTIC": "of or pertaining to the Argonauts [adj]\n",
  "ARGONAUTS": "ARGONAUT, (Greek) a sort of cuttlefish, aka paper nautilus [n]\n",
  "ARGONON": "another name for any of the inert gases [n -S]\n",
  "ARGONONS": "ARGONON, another name for any of the inert gases [n]\n",
  "ARGONS": "ARGON, an inert gaseous element [n]\n",
  "ARGOSIES": "ARGOSY, a large merchant ship [n]\n",
  "ARGOSY": "a large merchant ship [n ARGOSIES]\n",
  "ARGOT": "(French) an often more or less secret vocabulary and idiom peculiar to a particular group [n -S]\n",
  "ARGOTIC": "relating to argot [adj]\n",
  "ARGOTS": "ARGOT, (French) an often more or less secret vocabulary and idiom peculiar to a particular group [n]\n",
  "ARGUABLE": "capable of being disputed [adj]\n",
  "ARGUABLY": "ARGUABLE, capable of being disputed [adv]\n",
  "ARGUE": "to discuss with reasoning [v ARGUED, ARGUING, ARGUES]\n",
  "ARGUED": "ARGUE, to discuss with reasoning [v]\n",
  "ARGUER": "one who argues [n -S]\n",
  "ARGUERS": "ARGUER, one who argues [n]\n",
  "ARGUES": "ARGUE, to discuss with reasoning [v]\n",
  "ARGUFIED": "ARGUFY, to argue stubbornly [v]\n",
  "ARGUFIER": "one who argues stubbornly [n -S]\n",
  "ARGUFIERS": "ARGUFIER, one who argues stubbornly [n]\n",
  "ARGUFIES": "ARGUFY, to argue stubbornly [v]\n",
  "ARGUFY": "to argue stubbornly [v ARGUFIED, ARGUFYING, ARGUFIES]\n",
  "ARGUFYING": "ARGUFY, to argue stubbornly [v]\n",
  "ARGUING": "ARGUE, to discuss with reasoning [v]\n",
  "ARGULI": "ARGULUS, (Latin) a fish louse [n]\n",
  "ARGULUS": "(Latin) a fish louse [n ARGULI]\n",
  "ARGUMENT": "an exchange of differing reasons [n -S]\n",
  "ARGUMENTA": "ARGUMENTUM, (Latin) logical argument, proof [n]\n",
  "ARGUMENTATION": "the process of forming reasons and of drawing conclusions and applying them to a case in discussion [n -S]\n",
  "ARGUMENTATIONS": "ARGUMENTATION, the process of forming reasons and of drawing conclusions and applying them to a case in discussion [n]\n",
  "ARGUMENTATIVE": "given to argument, also ARGUMENTIVE [adj ARGUMENTATIVELY]\n",
  "ARGUMENTATIVELY": "ARGUMENTATIVE, given to argument, also ARGUMENTIVE [adv]\n",
  "ARGUMENTIVE": "given to argument, also ARGUMENTATIVE [adj]\n",
  "ARGUMENTS": "ARGUMENT, an exchange of differing reasons [n]\n",
  "ARGUMENTUM": "(Latin) logical argument, proof [n ARGUMENTA or ARGUMENTUMS]\n",
  "ARGUMENTUMS": "ARGUMENTUM, (Latin) logical argument, proof [n]\n",
  "ARGUS": "(Greek) an East Indian pheasant with a long colourful tail with eyespots [n -ES]\n",
  "ARGUSES": "ARGUS, (Greek) an East Indian pheasant with a long colourful tail with eyespots [n]\n",
  "ARGUTE": "shrill, keen [adj]\n",
  "ARGUTELY": "ARGUTE, shrill, keen [adv]\n",
  "ARGUTENESS": "acuteness [n -ES]\n",
  "ARGUTENESSES": "ARGUTENESS, acuteness [n]\n",
  "ARGYLE": "a silver gravy dish, also ARGYLL [n -S]\n",
  "ARGYLES": "ARGYLE, a silver gravy dish, also ARGYLL [n]\n",
  "ARGYLL": "a silver gravy dish, also ARGYLE [n -S]\n",
  "ARGYLLS": "ARGYLL, a silver gravy dish, also ARGYLE [n]\n",
  "ARGYRIA": "skin pigmentation caused by long exposure to silver [n -S]\n",
  "ARGYRIAS": "ARGYRIA, skin pigmentation caused by long exposure to silver [n]\n",
  "ARGYRITE": "a silver ore [n -S]\n",
  "ARGYRITES": "ARGYRITE, a silver ore [n]\n",
  "ARGYRODITE": "a mineral composed of silver, germanium and sulphur [n -S]\n",
  "ARGYRODITES": "ARGYRODITE, a mineral composed of silver, germanium and sulphur [n]\n",
  "ARHAT": "(Sanskrit) a Buddhist who has attained nirvana [n -S]\n",
  "ARHATS": "ARHAT, (Sanskrit) a Buddhist who has attained nirvana [n]\n",
  "ARHATSHIP": "the state of being an arhat, a Buddhist who has attained nirvana [n -S]\n",
  "ARHATSHIPS": "ARHATSHIP, the state of being an arhat, a Buddhist who has attained nirvana [n]\n",
  "ARHYTHMIA": "absence or irregularity of rhythm, esp. of the pulse, also ARRHYTHMIA, ARYTHMIA [n -S]\n",
  "ARHYTHMIAS": "ARHYTHMIA, absence or irregularity of rhythm, esp. of the pulse, also ARRHYTHMIA, ARYTHMIA [n]\n",
  "ARHYTHMIC": "with an irregular rhythm, also ARRHYTHMIC, ARYTHMIC [adj]\n",
  "ARIA": "(Italian) an accompanied vocal solo [n -S]\n",
  "ARIARIES": "ARIARY, a currency of Madagascar [n]\n",
  "ARIARY": "a currency of Madagascar [n ARIARIES]\n",
  "ARIAS": "ARIA, (Italian) an accompanied vocal solo [n]\n",
  "ARIBOFLAVINOSES": "ARIBOFLAVINOSIS, a deficiency disease due to inadequate intake of riboflavin and characterized by sores on the mouth [n]\n",
  "ARIBOFLAVINOSIS": "a deficiency disease due to inadequate intake of riboflavin and characterized by sores on the mouth [n ARIBOFLAVINOSES]\n",
  "ARID": "very dry [adj ARIDER, ARIDEST, ARIDLY]\n",
  "ARIDER": "ARID, very dry [adj]\n",
  "ARIDEST": "ARID, very dry [adj]\n",
  "ARIDITIES": "ARIDITY, the state of being arid [n]\n",
  "ARIDITY": "the state of being arid [n ARIDITIES]\n",
  "ARIDLY": "ARID, very dry [adv]\n",
  "ARIDNESS": "the state of being arid [n -ES]\n",
  "ARIDNESSES": "ARIDNESS, the state of being arid [n]\n",
  "ARIEL": "(Arabic) a kind of mountain gazelle native to Arabia [n -S]\n",
  "ARIELS": "ARIEL, (Arabic) a kind of mountain gazelle native to Arabia [n]\n",
  "ARIETTA": "(Italian) a short aria, also ARIETTE [n -S]\n",
  "ARIETTAS": "ARIETTA, (Italian) a short aria, also ARIETTE [n]\n",
  "ARIETTE": "a short aria, also ARIETTA [n -S]\n",
  "ARIETTES": "ARIETTE, a short aria, also ARIETTA [n]\n",
  "ARIGHT": "(archaic) right; correctly [adv]\n",
  "ARIKI": "(Maori) the firstborn male or female of a notable family [n -S]\n",
  "ARIKIS": "ARIKI, (Maori) the firstborn male or female of a notable family [n]\n",
  "ARIL": "an additional envelope, often fleshy, developed around the seed in certain plants (e.g. yew), also ARILLUS [n -S]\n",
  "ARILED": "having an aril, also ARILLATE, ARILLARY [adj]\n",
  "ARILLARY": "having an aril, also ARILLATE, ARILED [adj]\n",
  "ARILLATE": "having an aril, also ARILED, ARILLARY [adj]\n",
  "ARILLATED": "having an aril, a protective seed-coat, also ARILLARY, ARILLATE [adj]\n",
  "ARILLI": "ARILLUS, (Latin) an outer covering of some seeds, also ARIL [n]\n",
  "ARILLODE": "a caruncle or false aril, from near the micropyle [n -S]\n",
  "ARILLODES": "ARILLODE, a caruncle or false aril, from near the micropyle [n]\n",
  "ARILLOID": "like an aril, a protective seed-coat [adj]\n",
  "ARILLUS": "(Latin) an outer covering of some seeds, also ARIL [n ARILLI]\n",
  "ARILS": "ARIL, an additional envelope, often fleshy, developed around the seed in certain plants (e.g. yew), also ARILLUS [n]\n",
  "ARIOSE": "in the manner of an aria [adj]\n",
  "ARIOSI": "ARIOSO, (Italian) a melody resembling an aria [n]\n",
  "ARIOSO": "(Italian) a melody resembling an aria [n ARIOSOS or ARIOSI]\n",
  "ARIOSOS": "ARIOSO, (Italian) a melody resembling an aria [n]\n",
  "ARIOT": "in riot [adv]\n",
  "ARIPPLE": "in a ripple [adv]\n",
  "ARIS": "(Cockney slang) arse [n -ES]\n",
  "ARISE": "to come up [v AROSE, ARISEN, ARISING, ARISES]\n",
  "ARISEN": "ARISE, to come up [v]\n",
  "ARISES": "ARISE, to come up [v]\n",
  "ARISH": "(dialect) a stubble field, also ARRISH [n -ES]\n",
  "ARISHES": "ARISH, (dialect) a stubble field, also ARRISH [n]\n",
  "ARISING": "ARISE, to come up [v]\n",
  "ARISTA": "(Latin) a bristlelike structure e.g. on grass [n ARISTAS or ARISTAE]\n",
  "ARISTAE": "ARISTA, (Latin) a bristlelike structure e.g. on grass [n]\n",
  "ARISTAS": "ARISTA, (Latin) a bristlelike structure e.g. on grass [n]\n",
  "ARISTATE": "awned [adj]\n",
  "ARISTO": "(short for) an aristocrat [n -S]\n",
  "ARISTOCRACIES": "ARISTOCRACY, government by the best individuals or by a small privileged class [n]\n",
  "ARISTOCRACY": "government by the best individuals or by a small privileged class [n ARISTOCRACIES]\n",
  "ARISTOCRAT": "a member of an aristocracy [n -S]\n",
  "ARISTOCRATIC": "belonging to an aristocracy, also ARISTOCRATICAL [adj]\n",
  "ARISTOCRATICAL": "belonging to an aristocracy, also ARISTOCRATIC [adj]\n",
  "ARISTOCRATISM": "the spirit of, practices of, or belief in aristocracy [n -S]\n",
  "ARISTOCRATISMS": "ARISTOCRATISM, the spirit of, practices of, or belief in aristocracy [n]\n",
  "ARISTOCRATS": "ARISTOCRAT, a member of an aristocracy [n]\n",
  "ARISTOLOCHIA": "any plant of the birthwort genus Aristolochia [n -S]\n",
  "ARISTOLOCHIAS": "ARISTOLOCHIA, any plant of the birthwort genus Aristolochia [n]\n",
  "ARISTOLOGIES": "ARISTOLOGY, the science of dining [n]\n",
  "ARISTOLOGY": "the science of dining [n ARISTOLOGIES]\n",
  "ARISTOS": "ARISTO, (short for) an aristocrat [n]\n",
  "ARISTOTLE": "(slang) a bottle [n -S]\n",
  "ARISTOTLES": "ARISTOTLE, (slang) a bottle [n]\n",
  "ARITHMETIC": "the science of numbers, including addition, subtraction, multiplication, division [n -S]\n",
  "ARITHMETICAL": "relating to arithmetic [adj ARITHMETICALLY]\n",
  "ARITHMETICALLY": "ARITHMETICAL, relating to arithmetic [adv]\n",
  "ARITHMETICIAN": "one who practises arithmetic [n -S]\n",
  "ARITHMETICIANS": "ARITHMETICIAN, one who practises arithmetic [n]\n",
  "ARITHMETICS": "ARITHMETIC, the science of numbers, including addition, subtraction, multiplication, division [n]\n",
  "ARITHMOMANIA": "an obsession with numbers, esp. compulsion to count things [n -S]\n",
  "ARITHMOMANIAS": "ARITHMOMANIA, an obsession with numbers, esp. compulsion to count things [n]\n",
  "ARITHMOMETER": "(obsolete) an early adding machine [n -S]\n",
  "ARITHMOMETERS": "ARITHMOMETER, (obsolete) an early adding machine [n]\n",
  "ARITHMOPHOBIA": "a fear of numbers [n -S]\n",
  "ARITHMOPHOBIAS": "ARITHMOPHOBIA, a fear of numbers [n]\n",
  "ARK": "to put into an ark (a coffer) [v -ED, -ING, -S]\n",
  "ARKED": "ARK, to put into an ark (a coffer) [v]\n",
  "ARKING": "ARK, to put into an ark (a coffer) [v]\n",
  "ARKITE": "an inmate of Noah's ark [n -S]\n",
  "ARKITES": "ARKITE, an inmate of Noah's ark [n]\n",
  "ARKOSE": "a sedimentary rock formed by the cementation of sand-sized grains of feldspar and quartz [n -S]\n",
  "ARKOSES": "ARKOSE, a sedimentary rock formed by the cementation of sand-sized grains of feldspar and quartz [n]\n",
  "ARKOSIC": "pertaining to arkose, a type of sandstone [adj]\n",
  "ARKS": "ARK, to put into an ark (a coffer) [v]\n",
  "ARLE": "to give earnest-money [v ARLED, ARLING, ARLES]\n",
  "ARLED": "ARLE, to give earnest-money [v]\n",
  "ARLES": "ARLE, to give earnest-money [v]\n",
  "ARLING": "ARLE, to give earnest-money [v]\n",
  "ARM": "to supply with weapons [v -ED, -ING, -S]\n",
  "ARMADA": "(Spanish) a fleet of war ships [n -S]\n",
  "ARMADAS": "ARMADA, (Spanish) a fleet of war ships [n]\n",
  "ARMADILLO": "(Spanish) any of a number of burrowing edentate mammals native to South and Central America [n -S]\n",
  "ARMADILLOS": "ARMADILLO, (Spanish) any of a number of burrowing edentate mammals native to South and Central America [n]\n",
  "ARMAGNAC": "(French) a dry French brandy [n -S]\n",
  "ARMAGNACS": "ARMAGNAC, (French) a dry French brandy [n]\n",
  "ARMAMENT": "a military force equipped for war [n -S]\n",
  "ARMAMENTARIA": "ARMAMENTARIUM, the collection of equipment and techniques available to one in a particular field, esp. in medicine [n]\n",
  "ARMAMENTARIUM": "the collection of equipment and techniques available to one in a particular field, esp. in medicine [n ARMAMENTARIA or ARMAMENTARIUMS]\n",
  "ARMAMENTARIUMS": "ARMAMENTARIUM, the collection of equipment and techniques available to one in a particular field, esp. in medicine [n]\n",
  "ARMAMENTS": "ARMAMENT, a military force equipped for war [n]\n",
  "ARMATURE": "to furnish with armor [v ARMATURED, ARMATURING, ARMATURES]\n",
  "ARMATURED": "ARMATURE, to furnish with armor [v]\n",
  "ARMATURES": "ARMATURE, to furnish with armor [v]\n",
  "ARMATURING": "ARMATURE, to furnish with armor [v]\n",
  "ARMBAND": "a band of cloth worn on the arm [n -S]\n",
  "ARMBANDS": "ARMBAND, a band of cloth worn on the arm [n]\n",
  "ARMCHAIR": "a chair with armrests [n -S]\n",
  "ARMCHAIRS": "ARMCHAIR, a chair with armrests [n]\n",
  "ARMED": "ARM, to supply with weapons [v]\n",
  "ARMER": "one who arms [n -S]\n",
  "ARMERIA": "the generic name for the plant thrift [n -S]\n",
  "ARMERIAS": "ARMERIA, the generic name for the plant thrift [n]\n",
  "ARMERS": "ARMER, one who arms [n]\n",
  "ARMET": "a kind of medieval helmet [n -S]\n",
  "ARMETS": "ARMET, a kind of medieval helmet [n]\n",
  "ARMFUL": "as much as the arm can hold [n ARMFULS or ARMSFUL]\n",
  "ARMFULS": "ARMFUL, as much as the arm can hold [n]\n",
  "ARMGAUNT": "(Shakespeare) with gaunt limbs [adj]\n",
  "ARMGUARD": "a covering to protect the arm [n -S]\n",
  "ARMGUARDS": "ARMGUARD, a covering to protect the arm [n]\n",
  "ARMHOLE": "a hole in a garment for the arm [n -S]\n",
  "ARMHOLES": "ARMHOLE, a hole in a garment for the arm [n]\n",
  "ARMIES": "ARMY, a large body of people armed for war [n]\n",
  "ARMIGER": "an armour-bearer; a person entitled to bear heraldic arms, also ARMIGERO [n -S]\n",
  "ARMIGERAL": "relating to an armiger, a person bearing heraldic arms [adj]\n",
  "ARMIGERO": "(Shakespeare) a person entitled to bear arms, also ARMIGER [n -S]\n",
  "ARMIGEROS": "ARMIGERO, (Shakespeare) a person entitled to bear arms, also ARMIGER [n]\n",
  "ARMIGEROUS": "entitled to bear heraldic arms [adj]\n",
  "ARMIGERS": "ARMIGER, an armour-bearer; a person entitled to bear heraldic arms, also ARMIGERO [n]\n",
  "ARMIL": "a bracelet, also ARMILLA [n -S]\n",
  "ARMILLA": "(Latin) a bracelet, also ARMIL [n ARMILLAE or ARMILLAS]\n",
  "ARMILLAE": "ARMILLA, (Latin) a bracelet, also ARMIL [n]\n",
  "ARMILLARIA": "any fungus of the genus Armillaria, the honey fungus [n -S]\n",
  "ARMILLARIAS": "ARMILLARIA, any fungus of the genus Armillaria, the honey fungus [n]\n",
  "ARMILLARY": "of bracelets or hoops [adj]\n",
  "ARMILLAS": "ARMILLA, (Latin) a bracelet, also ARMIL [n]\n",
  "ARMILS": "ARMIL, a bracelet, also ARMILLA [n]\n",
  "ARMING": "the act of one that arms [n -S]\n",
  "ARMINGS": "ARMING, the act of one that arms [n]\n",
  "ARMIPOTENCE": "power in arms [n -S]\n",
  "ARMIPOTENCES": "ARMIPOTENCE, power in arms [n]\n",
  "ARMIPOTENT": "(archaic) having strong weapons; militarily potent [adj]\n",
  "ARMISTICE": "a suspension of hostilities [n -S]\n",
  "ARMISTICES": "ARMISTICE, a suspension of hostilities [n]\n",
  "ARMLESS": "without arms [adj]\n",
  "ARMLET": "an ornament or band worn round the arm [n -S]\n",
  "ARMLETS": "ARMLET, an ornament or band worn round the arm [n]\n",
  "ARMLIKE": "like an arm [adj]\n",
  "ARMLOAD": "as much as may be carried in the arms [n -S]\n",
  "ARMLOADS": "ARMLOAD, as much as may be carried in the arms [n]\n",
  "ARMLOCK": "to grip by the arms in a kind of wrestling hold [v -ED, -ING, -S]\n",
  "ARMLOCKED": "ARMLOCK, to grip by the arms in a kind of wrestling hold [v]\n",
  "ARMLOCKING": "ARMLOCK, to grip by the arms in a kind of wrestling hold [v]\n",
  "ARMLOCKS": "ARMLOCK, to grip by the arms in a kind of wrestling hold [v]\n",
  "ARMOIRE": "(French) a large ornate cabinet [n -S]\n",
  "ARMOIRES": "ARMOIRE, (French) a large ornate cabinet [n]\n",
  "ARMONICA": "a kind of musical instrument [n -S]\n",
  "ARMONICAS": "ARMONICA, a kind of musical instrument [n]\n",
  "ARMOR": "(US) to dress with defensive covering, also ARMOUR [v -ED, -ING, -S]\n",
  "ARMORED": "ARMOR, (US) to dress with defensive covering, also ARMOUR [v]\n",
  "ARMORER": "(US) one who makes or repairs armour, also ARMOURER [n -S]\n",
  "ARMORERS": "ARMORER, (US) one who makes or repairs armour, also ARMOURER [n]\n",
  "ARMORIAL": "heraldic [adj ARMORIALLY] / a book of coats of arms [n -S]\n",
  "ARMORIALLY": "ARMORIAL, heraldic [adv]\n",
  "ARMORIALS": "ARMORIAL, a book of coats of arms [n]\n",
  "ARMORIES": "ARMORY, a place where weapons are stored, also ARMOURY [n]\n",
  "ARMORING": "ARMOR, (US) to dress with defensive covering, also ARMOUR [v]\n",
  "ARMORIST": "a person skilled in heraldry [n -S]\n",
  "ARMORISTS": "ARMORIST, a person skilled in heraldry [n]\n",
  "ARMORLESS": "without armor, also ARMOURLESS [adj]\n",
  "ARMORS": "ARMOR, (US) to dress with defensive covering, also ARMOUR [v]\n",
  "ARMORY": "a place where weapons are stored, also ARMOURY [n ARMORIES]\n",
  "ARMOUR": "to dress with defensive covering, also ARMOR [v -ED, -ING, -S]\n",
  "ARMOURED": "ARMOUR, to dress with defensive covering, also ARMOR [v]\n",
  "ARMOURER": "one who makes or repairs armour, also ARMORER [n -S]\n",
  "ARMOURERS": "ARMOURER, one who makes or repairs armour, also ARMORER [n]\n",
  "ARMOURIES": "ARMOURY, a place where weapons are stored, also ARMORY [n]\n",
  "ARMOURING": "ARMOUR, to dress with defensive covering, also ARMOR [v]\n",
  "ARMOURLESS": "without armour, also ARMORLESS [adj]\n",
  "ARMOURS": "ARMOUR, to dress with defensive covering, also ARMOR [v]\n",
  "ARMOURY": "a place where weapons are stored, also ARMORY [n ARMOURIES]\n",
  "ARMOZEEN": "(French) a thick plain silk, generally black, and used for clerical gowns, also ARMOZINE [n -S]\n",
  "ARMOZEENS": "ARMOZEEN, (French) a thick plain silk, generally black, and used for clerical gowns, also ARMOZINE [n]\n",
  "ARMOZINE": "(French) a thick plain silk, generally black, and used for clerical gowns, also ARMOZEEN [n -S]\n",
  "ARMOZINES": "ARMOZINE, (French) a thick plain silk, generally black, and used for clerical gowns, also ARMOZEEN [n]\n",
  "ARMPIT": "the hollow under the arm [n -S]\n",
  "ARMPITS": "ARMPIT, the hollow under the arm [n]\n",
  "ARMREST": "a support for the arm [n -S]\n",
  "ARMRESTS": "ARMREST, a support for the arm [n]\n",
  "ARMS": "ARM, to supply with weapons [v]\n",
  "ARMSFUL": "ARMFUL, as much as the arm can hold [n]\n",
  "ARMURE": "(French) a type of fabric with a pebbled surface [n -S]\n",
  "ARMURES": "ARMURE, (French) a type of fabric with a pebbled surface [n]\n",
  "ARMY": "a large body of people armed for war [n ARMIES]\n",
  "ARMYWORM": "the larva of a small fly or moth that moves in large armies destroying crops [n -S]\n",
  "ARMYWORMS": "ARMYWORM, the larva of a small fly or moth that moves in large armies destroying crops [n]\n",
  "ARNA": "(Hindi) an Indian water-buffalo [n -S]\n",
  "ARNAS": "ARNA, (Hindi) an Indian water-buffalo [n]\n",
  "ARNATTO": "(Caribbean) a bright orange colouring matter, also ANATTA, ANATTO, ANNATTA, ANNATTO, ARNOTTO [n -S]\n",
  "ARNATTOS": "ARNATTO, (Caribbean) a bright orange colouring matter, also ANATTA, ANATTO, ANNATTA, ANNATTO, ARNOTTO [n]\n",
  "ARNICA": "a tincture obtained from mountain tobacco used for bruises, sprains etc. [n -S]\n",
  "ARNICAS": "ARNICA, a tincture obtained from mountain tobacco used for bruises, sprains etc. [n]\n",
  "ARNOTTO": "(Caribbean) a bright orange colouring matter, also ANATTA, ANATTO, ANNATTA, ANNATTO, ARNATTO [n -S]\n",
  "ARNOTTOS": "ARNOTTO, (Caribbean) a bright orange colouring matter, also ANATTA, ANATTO, ANNATTA, ANNATTO, ARNATTO [n]\n",
  "ARNUT": "the earthnut, an edible root tuber of a woodland umbellifer [n -S]\n",
  "ARNUTS": "ARNUT, the earthnut, an edible root tuber of a woodland umbellifer [n]\n",
  "AROBA": "(Arabic) a heavy screened wagon used by Tatars and others, also ARABA, ARBA [n -S]\n",
  "AROBAS": "AROBA, (Arabic) a heavy screened wagon used by Tatars and others, also ARABA, ARBA [n]\n",
  "AROHA": "(Maori) love, compassion [n -S]\n",
  "AROHAS": "AROHA, (Maori) love, compassion [n]\n",
  "AROID": "any plant of the arum family [n -S]\n",
  "AROIDS": "AROID, any plant of the arum family [n]\n",
  "AROINT": "(archaic) to drive or frighten away, also AROYNT [v -ED, -ING, -S]\n",
  "AROINTED": "AROINT, (archaic) to drive or frighten away, also AROYNT [v]\n",
  "AROINTING": "AROINT, (archaic) to drive or frighten away, also AROYNT [v]\n",
  "AROINTS": "AROINT, (archaic) to drive or frighten away, also AROYNT [v]\n",
  "AROLLA": "the Swiss stone pine or Siberian cedar [n -S]\n",
  "AROLLAS": "AROLLA, the Swiss stone pine or Siberian cedar [n]\n",
  "AROMA": "a distinctive fragrance [n -S]\n",
  "AROMAS": "AROMA, a distinctive fragrance [n]\n",
  "AROMATASE": "an enzyme involved in the production of oestrogen [n -S]\n",
  "AROMATASES": "AROMATASE, an enzyme involved in the production of oestrogen [n]\n",
  "AROMATHERAPIES": "AROMATHERAPY, a therapy involving the use of scents [n]\n",
  "AROMATHERAPIST": "one who practises aromatherapy [n -S]\n",
  "AROMATHERAPISTS": "AROMATHERAPIST, one who practises aromatherapy [n]\n",
  "AROMATHERAPY": "a therapy involving the use of scents [n AROMATHERAPIES]\n",
  "AROMATIC": "sweet-smelling [adj AROMATICALLY] / a sweet-smelling substance [n -S]\n",
  "AROMATICALLY": "AROMATIC, sweet-smelling [adv]\n",
  "AROMATICITIES": "AROMATICITY, the state of being aromatic [n]\n",
  "AROMATICITY": "the state of being aromatic [n AROMATICITIES]\n",
  "AROMATICS": "AROMATIC, a sweet-smelling substance [n]\n",
  "AROMATISATION": "the act of aromatising, also AROMATIZATION [n -S]\n",
  "AROMATISATIONS": "AROMATISATION, the act of aromatising, also AROMATIZATION [n]\n",
  "AROMATISE": "to render aromatic, also AROMATIZE [v AROMATISED, AROMATISING, AROMATISES]\n",
  "AROMATISED": "AROMATISE, to render aromatic, also AROMATIZE [v]\n",
  "AROMATISES": "AROMATISE, to render aromatic, also AROMATIZE [v]\n",
  "AROMATISING": "AROMATISE, to render aromatic, also AROMATIZE [v]\n",
  "AROMATIZATION": "the act of aromatizing, also AROMATISATION [n -S]\n",
  "AROMATIZATIONS": "AROMATIZATION, the act of aromatizing, also AROMATISATION [n]\n",
  "AROMATIZE": "to render aromatic, also AROMATISE [v AROMATIZED, AROMATIZING, AROMATIZES]\n",
  "AROMATIZED": "AROMATIZE, to render aromatic, also AROMATISE [v]\n",
  "AROMATIZES": "AROMATIZE, to render aromatic, also AROMATISE [v]\n",
  "AROMATIZING": "AROMATIZE, to render aromatic, also AROMATISE [v]\n",
  "AROSE": "ARISE, to come up [v]\n",
  "AROUND": "on all sides [prep]\n",
  "AROUSABLE": "that can be aroused [adj]\n",
  "AROUSAL": "the act of arousing [n -S]\n",
  "AROUSALS": "AROUSAL, the act of arousing [n]\n",
  "AROUSE": "to stimulate [v AROUSED, AROUSING, AROUSES]\n",
  "AROUSED": "AROUSE, to stimulate [v]\n",
  "AROUSER": "one who arouses [n -S]\n",
  "AROUSERS": "AROUSER, one who arouses [n]\n",
  "AROUSES": "AROUSE, to stimulate [v]\n",
  "AROUSING": "AROUSE, to stimulate [v]\n",
  "AROW": "(obsolete) in a row, also AREW [adv]\n",
  "AROWANA": "a large tropical fish, also ARAHUANA, ARAWANA, ARUANA [n -S]\n",
  "AROWANAS": "AROWANA, a large tropical fish, also ARAHUANA, ARAWANA, ARUANA [n]\n",
  "AROYNT": "(archaic) to frighten away, also AROINT [v -ED, -ING, -S]\n",
  "AROYNTED": "AROYNT, (archaic) to frighten away, also AROINT [v]\n",
  "AROYNTING": "AROYNT, (archaic) to frighten away, also AROINT [v]\n",
  "AROYNTS": "AROYNT, (archaic) to frighten away, also AROINT [v]\n",
  "ARPA": "a top level internet domain [n -S]\n",
  "ARPAS": "ARPA, a top level internet domain [n]\n",
  "ARPEGGIATE": "to perform or write in arpeggios [v ARPEGGIATED, ARPEGGIATING, ARPEGGIATES]\n",
  "ARPEGGIATED": "ARPEGGIATE, to perform or write in arpeggios [v]\n",
  "ARPEGGIATES": "ARPEGGIATE, to perform or write in arpeggios [v]\n",
  "ARPEGGIATING": "ARPEGGIATE, to perform or write in arpeggios [v]\n",
  "ARPEGGIATION": "the act of arpeggiating [n -S]\n",
  "ARPEGGIATIONS": "ARPEGGIATION, the act of arpeggiating [n]\n",
  "ARPEGGIO": "(Italian) a technique of playing a musical chord, with each note sounded in rapid succession [n -S]\n",
  "ARPEGGIONE": "(Italian) an early 19th century bowed stringed instrument [n -S]\n",
  "ARPEGGIONES": "ARPEGGIONE, (Italian) an early 19th century bowed stringed instrument [n]\n",
  "ARPEGGIOS": "ARPEGGIO, (Italian) a technique of playing a musical chord, with each note sounded in rapid succession [n]\n",
  "ARPEN": "(French) an old French land measure, also ARPENT [n -S]\n",
  "ARPENS": "ARPEN, (French) an old French land measure, also ARPENT [n]\n",
  "ARPENT": "(French) an old French land measure, also ARPEN [n -S]\n",
  "ARPENTS": "ARPENT, (French) an old French land measure, also ARPEN [n]\n",
  "ARPILLERA": "(Spanish) a pictorial Peruvian wall decoration consisting of colourful threads and scraps stitched on to a sackcloth backing [n -S]\n",
  "ARPILLERAS": "ARPILLERA, (Spanish) a pictorial Peruvian wall decoration consisting of colourful threads and scraps stitched on to a sackcloth backing [n]\n",
  "ARQUEBUS": "(historical) a portable long-barrelled gun, also HARQUEBUS, HARQUEBUSE, HARQUEBUSS [n -ES]\n",
  "ARQUEBUSADE": "(French) a lotion for shot-wounds [n -S]\n",
  "ARQUEBUSADES": "ARQUEBUSADE, (French) a lotion for shot-wounds [n]\n",
  "ARQUEBUSES": "ARQUEBUS, (historical) a portable long-barrelled gun, also HARQUEBUS, HARQUEBUSE, HARQUEBUSS [n]\n",
  "ARQUEBUSIER": "a soldier armed with an arquebus [n -S]\n",
  "ARQUEBUSIERS": "ARQUEBUSIER, a soldier armed with an arquebus [n]\n",
  "ARRACACHA": "(Quechua) an umbelliferous South American food-plant with edible tubers [n -S]\n",
  "ARRACACHAS": "ARRACACHA, (Quechua) an umbelliferous South American food-plant with edible tubers [n]\n",
  "ARRACK": "(Arabic) an alcoholic drink made from toddy, or the fermented juice of the coco and other palms, also ARAK [n -S]\n",
  "ARRACKS": "ARRACK, (Arabic) an alcoholic drink made from toddy, or the fermented juice of the coco and other palms, also ARAK [n]\n",
  "ARRAGONITE": "an orthorhombic mineral composed of calcium carbonate, also ARAGONITE [n -S]\n",
  "ARRAGONITES": "ARRAGONITE, an orthorhombic mineral composed of calcium carbonate, also ARAGONITE [n]\n",
  "ARRAGONITIC": "of or like aragonite, an orthorhombic mineral composed of calcium carbonate, also ARAGONITIC [adj]\n",
  "ARRAH": "(Irish) an Anglo-Irish exclamation expressing wonder etc. [interj]\n",
  "ARRAIGN": "to call before a court of law to answer an indictment [v -ED, -ING, -S]\n",
  "ARRAIGNED": "ARRAIGN, to call before a court of law to answer an indictment [v]\n",
  "ARRAIGNER": "one who arraigns [n -S]\n",
  "ARRAIGNERS": "ARRAIGNER, one who arraigns [n]\n",
  "ARRAIGNING": "a calling before a court of law to answer an indictment [n -S]\n",
  "ARRAIGNINGS": "ARRAIGNING, a calling before a court of law to answer an indictment [n]\n",
  "ARRAIGNMENT": "the act of arraigning [n -S]\n",
  "ARRAIGNMENTS": "ARRAIGNMENT, the act of arraigning [n]\n",
  "ARRAIGNS": "ARRAIGN, to call before a court of law to answer an indictment [v]\n",
  "ARRANGE": "to put in order [v ARRANGED, ARRANGING, ARRANGES]\n",
  "ARRANGEABLE": "that can be arranged [adj]\n",
  "ARRANGED": "ARRANGE, to put in order [v]\n",
  "ARRANGEMENT": "a preliminary measure [n -S]\n",
  "ARRANGEMENTS": "ARRANGEMENT, a preliminary measure [n]\n",
  "ARRANGER": "one that arranges [n -S]\n",
  "ARRANGERS": "ARRANGER, one that arranges [n]\n",
  "ARRANGES": "ARRANGE, to put in order [v]\n",
  "ARRANGING": "ARRANGE, to put in order [v]\n",
  "ARRANT": "thoroughgoing; notoriously or outstandingly bad [adj]\n",
  "ARRANTLY": "ARRANT, thoroughgoing; notoriously or outstandingly bad [adv]\n",
  "ARRAS": "a rich tapestry [n -ES]\n",
  "ARRASED": "covered with an arras [adj]\n",
  "ARRASENE": "an embroidery material of silk and wool [n -S]\n",
  "ARRASENES": "ARRASENE, an embroidery material of silk and wool [n]\n",
  "ARRASES": "ARRAS, a rich tapestry [n]\n",
  "ARRAUGHT": "AREACH, (Spenser) to reach [v]\n",
  "ARRAY": "to place in order [v -ED, -ING, -S]\n",
  "ARRAYAL": "the act of arraying [n -S]\n",
  "ARRAYALS": "ARRAYAL, the act of arraying [n]\n",
  "ARRAYED": "ARRAY, to place in order [v]\n",
  "ARRAYER": "one who arrays [n -S]\n",
  "ARRAYERS": "ARRAYER, one who arrays [n]\n",
  "ARRAYING": "ARRAY, to place in order [v]\n",
  "ARRAYMENT": "clothes; raiment [n -S]\n",
  "ARRAYMENTS": "ARRAYMENT, clothes; raiment [n]\n",
  "ARRAYS": "ARRAY, to place in order [v]\n",
  "ARREAR": "an unpaid and overdue debt [n -S]\n",
  "ARREARAGE": "that which remains unpaid and overdue, after payment of a part [n -S]\n",
  "ARREARAGES": "ARREARAGE, that which remains unpaid and overdue, after payment of a part [n]\n",
  "ARREARS": "ARREAR, an unpaid and overdue debt [n]\n",
  "ARRECT": "of an animal's ears, upright, pricked up [adj]\n",
  "ARREEDE": "(Spenser) to declare, also AREAD, AREDE [v ARED or AREDD, ARREEDING, ARREEDES]\n",
  "ARREEDES": "ARREEDE, (Spenser) to declare, also AREAD, AREDE [v]\n",
  "ARREEDING": "ARREEDE, (Spenser) to declare, also AREAD, AREDE [v]\n",
  "ARREST": "to bring to a standstill [v -ED, -ING, -S]\n",
  "ARRESTABLE": "that can be arrested [adj]\n",
  "ARRESTANT": "a substance causing an insect to stop moving [n -S]\n",
  "ARRESTANTS": "ARRESTANT, a substance causing an insect to stop moving [n]\n",
  "ARRESTATION": "the act of arresting [n -S]\n",
  "ARRESTATIONS": "ARRESTATION, the act of arresting [n]\n",
  "ARRESTED": "ARREST, to bring to a standstill [v]\n",
  "ARRESTEE": "one that is arrested [n -S]\n",
  "ARRESTEES": "ARRESTEE, one that is arrested [n]\n",
  "ARRESTER": "one who makes an arrest, also ARRESTOR [n -S]\n",
  "ARRESTERS": "ARRESTER, one who makes an arrest, also ARRESTOR [n]\n",
  "ARRESTING": "ARREST, to bring to a standstill [v]\n",
  "ARRESTINGLY": "ARRESTING, ARREST, to bring to a standstill [adv]\n",
  "ARRESTIVE": "tending to arrest [adj]\n",
  "ARRESTMENT": "the arrest of a person, or the seizure of his effects; esp. a process by which money or movables in the possession of a third party are attached [n -S]\n",
  "ARRESTMENTS": "ARRESTMENT, the arrest of a person, or the seizure of his effects; esp. a process by which money or movables in the possession of a third party are attached [n]\n",
  "ARRESTOR": "one who makes an arrest, also ARRESTER [n -S]\n",
  "ARRESTORS": "ARRESTOR, one who makes an arrest, also ARRESTER [n]\n",
  "ARRESTS": "ARREST, to bring to a standstill [v]\n",
  "ARRET": "(French) a decision; the judgment of a tribunal [n -S]\n",
  "ARRETS": "ARRET, (French) a decision; the judgment of a tribunal [n]\n",
  "ARRHENOTOKIES": "ARRHENOTOKY, giving birth only to boys [n]\n",
  "ARRHENOTOKY": "giving birth only to boys [n ARRHENOTOKIES]\n",
  "ARRHIZAL": "lacking roots [adj]\n",
  "ARRHYTHMIA": "absence or irregularity of rhythm e.g. of the heart, also ARHYTHMIA, ARYTHMIA [n -S]\n",
  "ARRHYTHMIAS": "ARRHYTHMIA, absence or irregularity of rhythm e.g. of the heart, also ARHYTHMIA, ARYTHMIA [n]\n",
  "ARRHYTHMIC": "with an irregular rhythm, also ARHYTHMIC, ARYTHMIC [adj]\n",
  "ARRIAGE": "(historical) a former feudal service rendered by a tenant with his beasts of burden [n -S]\n",
  "ARRIAGES": "ARRIAGE, (historical) a former feudal service rendered by a tenant with his beasts of burden [n]\n",
  "ARRIBA": "(Spanish) expressing pleasure, approval, or elation [interj]\n",
  "ARRIDE": "(archaic) to please, to gratify [v ARRIDED, ARRIDING, ARRIDES]\n",
  "ARRIDED": "ARRIDE, (archaic) to please, to gratify [v]\n",
  "ARRIDES": "ARRIDE, (archaic) to please, to gratify [v]\n",
  "ARRIDING": "ARRIDE, (archaic) to please, to gratify [v]\n",
  "ARRIERE": "(French) in the rear, backward [adj]\n",
  "ARRIERO": "(Spanish) a muleteer [n -S]\n",
  "ARRIEROS": "ARRIERO, (Spanish) a muleteer [n]\n",
  "ARRIS": "a sharp edge on stone, metal etc. at the meeting of two surfaces [n -ES]\n",
  "ARRISES": "ARRIS, a sharp edge on stone, metal etc. at the meeting of two surfaces [n]\n",
  "ARRISH": "(dialect) a stubble field, also ARISH [n -ES]\n",
  "ARRISHES": "ARRISH, (dialect) a stubble field, also ARISH [n]\n",
  "ARRIVAL": "the act of arriving [n -S]\n",
  "ARRIVALS": "ARRIVAL, the act of arriving [n]\n",
  "ARRIVANCE": "(Shakespeare) company arriving, also ARRIVANCY [n -S]\n",
  "ARRIVANCES": "ARRIVANCE, (Shakespeare) company arriving, also ARRIVANCY [n]\n",
  "ARRIVANCIES": "ARRIVANCY, (Shakespeare) company arriving, also ARRIVANCE [n]\n",
  "ARRIVANCY": "(Shakespeare) company arriving, also ARRIVANCE [n ARRIVANCIES]\n",
  "ARRIVE": "to reach a destination [v ARRIVED, ARRIVING, ARRIVES]\n",
  "ARRIVED": "ARRIVE, to reach a destination [v]\n",
  "ARRIVEDERCI": "(Italian) goodbye [interj]\n",
  "ARRIVER": "one who arrives [n -S]\n",
  "ARRIVERS": "ARRIVER, one who arrives [n]\n",
  "ARRIVES": "ARRIVE, to reach a destination [v]\n",
  "ARRIVING": "ARRIVE, to reach a destination [v]\n",
  "ARRIVISME": "(French) the state of being an arriviste, an upstart [n -S]\n",
  "ARRIVISMES": "ARRIVISME, (French) the state of being an arriviste, an upstart [n]\n",
  "ARRIVISTE": "(French) one that is a new and uncertain arrival (as in social position or artistic endeavor) [n -S]\n",
  "ARRIVISTES": "ARRIVISTE, (French) one that is a new and uncertain arrival (as in social position or artistic endeavor) [n]\n",
  "ARROBA": "(Spanish) a Spanish unit of weight [n -S]\n",
  "ARROBAS": "ARROBA, (Spanish) a Spanish unit of weight [n]\n",
  "ARROCES": "ARROZ, (Spanish) rice [n]\n",
  "ARROGANCE": "the quality of being arrogant, also ARROGANCY [n -S]\n",
  "ARROGANCES": "ARROGANCE, the quality of being arrogant, also ARROGANCY [n]\n",
  "ARROGANCIES": "ARROGANCY, the quality of being arrogant, also ARROGANCE [n]\n",
  "ARROGANCY": "the quality of being arrogant, also ARROGANCE [n ARROGANCIES]\n",
  "ARROGANT": "overbearing [adj ARROGANTLY]\n",
  "ARROGANTLY": "ARROGANT, overbearing [adv]\n",
  "ARROGATE": "to claim unduly as one's own [v ARROGATED, ARROGATING, ARROGATES]\n",
  "ARROGATED": "ARROGATE, to claim unduly as one's own [v]\n",
  "ARROGATES": "ARROGATE, to claim unduly as one's own [v]\n",
  "ARROGATING": "ARROGATE, to claim unduly as one's own [v]\n",
  "ARROGATION": "the act of arrogating, or making exorbitant claims; the act of taking more than one is justly entitled to [n -S]\n",
  "ARROGATIONS": "ARROGATION, the act of arrogating, or making exorbitant claims; the act of taking more than one is justly entitled to [n]\n",
  "ARROGATIVE": "relating to arrogation, the act of arrogating [adj]\n",
  "ARROGATOR": "one who arrogates [n -S]\n",
  "ARROGATORS": "ARROGATOR, one who arrogates [n]\n",
  "ARRONDISSEMENT": "(French) the largest subdivision of a French department [n -S]\n",
  "ARRONDISSEMENTS": "ARRONDISSEMENT, (French) the largest subdivision of a French department [n]\n",
  "ARROW": "to indicate the position with a straight pointed missile [v -ED, -ING, -S]\n",
  "ARROWED": "ARROW, to indicate the position with a straight pointed missile [v]\n",
  "ARROWGRASS": "a grass of a genus of marsh plants whose burst capsule is like an arrowhead [n -ES]\n",
  "ARROWGRASSES": "ARROWGRASS, a grass of a genus of marsh plants whose burst capsule is like an arrowhead [n]\n",
  "ARROWHEAD": "the head or pointed part of an arrow [n -S]\n",
  "ARROWHEADS": "ARROWHEAD, the head or pointed part of an arrow [n]\n",
  "ARROWIER": "ARROWY, like an arrow, in shape, motion, etc [adj]\n",
  "ARROWIEST": "ARROWY, like an arrow, in shape, motion, etc [adj]\n",
  "ARROWING": "ARROW, to indicate the position with a straight pointed missile [v]\n",
  "ARROWLESS": "without arrows [adj]\n",
  "ARROWLIKE": "like an arrow [adj]\n",
  "ARROWROOT": "a West Indian plant with fleshy tuberous rhizomes; a pure edible starch made from this [n -S]\n",
  "ARROWROOTS": "ARROWROOT, a West Indian plant with fleshy tuberous rhizomes; a pure edible starch made from this [n]\n",
  "ARROWS": "ARROW, to indicate the position with a straight pointed missile [v]\n",
  "ARROWWOOD": "a shrub growing in damp woods and thickets, so called from the long, straight, slender shoots [n -S]\n",
  "ARROWWOODS": "ARROWWOOD, a shrub growing in damp woods and thickets, so called from the long, straight, slender shoots [n]\n",
  "ARROWWORM": "a peculiar transparent worm of the genus Sagitta, living at the surface of the sea [n -S]\n",
  "ARROWWORMS": "ARROWWORM, a peculiar transparent worm of the genus Sagitta, living at the surface of the sea [n]\n",
  "ARROWY": "like an arrow, in shape, motion, etc [adj ARROWIER, ARROWIEST]\n",
  "ARROYO": "(Spanish) a dry desert gully [n -S]\n",
  "ARROYOS": "ARROYO, (Spanish) a dry desert gully [n]\n",
  "ARROZ": "(Spanish) rice [n ARROCES or ARROZES]\n",
  "ARROZES": "ARROZ, (Spanish) rice [n]\n",
  "ARS": "AR, the letter R [n]\n",
  "ARSE": "as in \"to arse about\", to muck around [v ARSED, ARSING, ARSES]\n",
  "ARSED": "ARSE, as in \"to arse about\", to muck around [v]\n",
  "ARSEHOLE": "(offensive) an unpleasant and/or stupid person, also ASSHOLE [n -S]\n",
  "ARSEHOLED": "(colloquial) very drunk [adj]\n",
  "ARSEHOLES": "ARSEHOLE, (offensive) an unpleasant and/or stupid person, also ASSHOLE [n]\n",
  "ARSENAL": "a storehouse for weapons [n -S]\n",
  "ARSENALS": "ARSENAL, a storehouse for weapons [n]\n",
  "ARSENATE": "a salt of arsenic acid, also ARSENIATE [n -S]\n",
  "ARSENATES": "ARSENATE, a salt of arsenic acid, also ARSENIATE [n]\n",
  "ARSENIATE": "a salt of arsenic acid, also ARSENATE [n -S]\n",
  "ARSENIATES": "ARSENIATE, a salt of arsenic acid, also ARSENATE [n]\n",
  "ARSENIC": "a metallic element [n -S]\n",
  "ARSENICAL": "a compound (esp. organic) of arsenic [n -S]\n",
  "ARSENICALS": "ARSENICAL, a compound (esp. organic) of arsenic [n]\n",
  "ARSENICS": "ARSENIC, a metallic element [n]\n",
  "ARSENIDE": "a compound of arsenic with a metal [n -S]\n",
  "ARSENIDES": "ARSENIDE, a compound of arsenic with a metal [n]\n",
  "ARSENIOUS": "containing arsenic in the trivalent state [adj]\n",
  "ARSENITE": "a salt formed by the union of arsenious acid with a base [n -S]\n",
  "ARSENITES": "ARSENITE, a salt formed by the union of arsenious acid with a base [n]\n",
  "ARSENO": "forming names of compounds and derivatives of arsenic [adj]\n",
  "ARSENOPYRITE": "arsenical iron pyrites [n -S]\n",
  "ARSENOPYRITES": "ARSENOPYRITE, arsenical iron pyrites [n]\n",
  "ARSENOUS": "pertaining to arsenic [adj]\n",
  "ARSES": "ARSE [n]\n",
  "ARSEY": "(Australian slang) aggressive, irritable, also ARSY [adj ARSIER, ARSIEST]\n",
  "ARSHEEN": "(Turkish) a Russian unit of length, also ARCHINE, ARSHIN, ARSHINE [n -S]\n",
  "ARSHEENS": "ARSHEEN, (Turkish) a Russian unit of length, also ARCHINE, ARSHIN, ARSHINE [n]\n",
  "ARSHIN": "(Turkish) a Russian unit of length, also ARCHINE, ARSHEEN, ARSHINE [n -S]\n",
  "ARSHINE": "(Turkish) a Russian unit of length, also ARCHINE, ARSHEEN, ARSHIN [n -S]\n",
  "ARSHINES": "ARSHINE, (Turkish) a Russian unit of length, also ARCHINE, ARSHEEN, ARSHIN [n]\n",
  "ARSHINS": "ARSHIN, (Turkish) a Russian unit of length, also ARCHINE, ARSHEEN, ARSHINE [n]\n",
  "ARSIER": "ARSY, (Australian slang) aggressive, irritable, also ARSEY [adj]\n",
  "ARSIEST": "ARSY, (Australian slang) aggressive, irritable, also ARSEY [adj]\n",
  "ARSINE": "a poisonous gas, arsenic hydride [n -S]\n",
  "ARSINES": "ARSINE, a poisonous gas, arsenic hydride [n]\n",
  "ARSING": "ARSE, as in \"to arse about\", to muck around [v]\n",
  "ARSINO": "containing a certain univalent chemical radical [adj]\n",
  "ARSIS": "(Latin) the accented or longer part of a poetic foot; the point where an ictus is put [n ARSES]\n",
  "ARSMETRICK": "(obsolete) arithmetic (on false analogy with 'ars metrica') [n -S]\n",
  "ARSMETRICKS": "ARSMETRICK, (obsolete) arithmetic (on false analogy with 'ars metrica') [n]\n",
  "ARSON": "the malicious or fraudulent burning of property [n -S]\n",
  "ARSONIST": "one who maliciously lights fires, also ARSONITE [n -S]\n",
  "ARSONISTS": "ARSONIST, one who maliciously lights fires, also ARSONITE [n]\n",
  "ARSONITE": "one who maliciously lights fires, also ARSONIST [n -S]\n",
  "ARSONITES": "ARSONITE, one who maliciously lights fires, also ARSONIST [n]\n",
  "ARSONOUS": "relating to arson [adj]\n",
  "ARSONS": "ARSON, the malicious or fraudulent burning of property [n]\n",
  "ARSPHENAMINE": "another name for salvarsan, a compound of arsenic once used as a remedy for syphilis [n -S]\n",
  "ARSPHENAMINES": "ARSPHENAMINE, another name for salvarsan, a compound of arsenic once used as a remedy for syphilis [n]\n",
  "ARSY": "(Australian slang) aggressive, irritable, also ARSEY [adj ARSIER, ARSIEST]\n",
  "ART": "works of creative imagination [n -S]\n",
  "ARTAL": "ROTL, (Arabic) a variable Levantine weight, also ROTOLO [n]\n",
  "ARTEFACT": "an object made by man, also ARTIFACT [n -S]\n",
  "ARTEFACTS": "ARTEFACT, an object made by man, also ARTIFACT [n]\n",
  "ARTEFACTUAL": "of or like an artefact, also ARTIFACTUAL [adj]\n",
  "ARTEL": "(Russian) a Russian workers' guild [n -S]\n",
  "ARTELS": "ARTEL, (Russian) a Russian workers' guild [n]\n",
  "ARTEMISIA": "(Greek) any plant of the Artemisia genus of composites including wormwood, sagebrush, etc. [n -S]\n",
  "ARTEMISIAS": "ARTEMISIA, (Greek) any plant of the Artemisia genus of composites including wormwood, sagebrush, etc. [n]\n",
  "ARTEMISININ": "a crystalline compound extracted from the artemisia plant, used esp. to treat malaria, aka qinghaosu [n -S]\n",
  "ARTEMISININS": "ARTEMISININ, a crystalline compound extracted from the artemisia plant, used esp. to treat malaria, aka qinghaosu [n]\n",
  "ARTERIAL": "relating to an artery [adj ARTERIALLY] / a type of highway [n -S]\n",
  "ARTERIALISATION": "the process of arterialising, also ARTERIALIZATION [n]\n",
  "ARTERIALISE": "to make arterial, also ARTERIALIZE [v ARTERIALISED, ARTERIALISING, ARTERIALISES]\n",
  "ARTERIALISED": "ARTERIALISE, to make arterial, also ARTERIALIZE [v]\n",
  "ARTERIALISES": "ARTERIALISE, to make arterial, also ARTERIALIZE [v]\n",
  "ARTERIALISING": "ARTERIALISE, to make arterial, also ARTERIALIZE [v]\n",
  "ARTERIALIZATION": "the process of arterializing, also ARTERIALISATION [n]\n",
  "ARTERIALIZE": "to make arterial, also ARTERIALISE [v ARTERIALIZED, ARTERIALIZING, ARTERIALIZES]\n",
  "ARTERIALIZED": "ARTERIALIZE, to make arterial, also ARTERIALISE [v]\n",
  "ARTERIALIZES": "ARTERIALIZE, to make arterial, also ARTERIALISE [v]\n",
  "ARTERIALIZING": "ARTERIALIZE, to make arterial, also ARTERIALISE [v]\n",
  "ARTERIALLY": "ARTERIAL, relating to an artery [adv]\n",
  "ARTERIALS": "ARTERIAL, a type of highway [n]\n",
  "ARTERIES": "ARTERY, a vessel that carries blood from the heart [n]\n",
  "ARTERIOGRAM": "a radiograph of an artery made by arteriography [n -S]\n",
  "ARTERIOGRAMS": "ARTERIOGRAM, a radiograph of an artery made by arteriography [n]\n",
  "ARTERIOGRAPHIC": "relating to arteriography [adj]\n",
  "ARTERIOGRAPHIES": "ARTERIOGRAPHY, the radiographic visualization of an artery after injection of a radiopaque substance [n]\n",
  "ARTERIOGRAPHY": "the radiographic visualization of an artery after injection of a radiopaque substance [n ARTERIOGRAPHIES]\n",
  "ARTERIOLAR": "relating to an arteriole, a very small artery [adj]\n",
  "ARTERIOLE": "a small artery [n -S]\n",
  "ARTERIOLES": "ARTERIOLE, a small artery [n]\n",
  "ARTERIOTOMIES": "ARTERIOTOMY, the surgical excision of an artery [n]\n",
  "ARTERIOTOMY": "the surgical excision of an artery [n ARTERIOTOMIES]\n",
  "ARTERIOVENOUS": "of, relating to, or connecting the arteries and veins [adj]\n",
  "ARTERITIDES": "ARTERITIS, inflammation of an artery or arteries [n]\n",
  "ARTERITIS": "inflammation of an artery or arteries [n ARTERITISES or ARTERITIDES]\n",
  "ARTERITISES": "ARTERITIS, inflammation of an artery or arteries [n]\n",
  "ARTERY": "a vessel that carries blood from the heart [n ARTERIES]\n",
  "ARTESIAN": "pertaining to a well that has water rising to the surface under natural pressure, without the need of a pump [adj]\n",
  "ARTFUL": "crafty [adj ARTFULLY]\n",
  "ARTFULLY": "ARTFUL, crafty [adv]\n",
  "ARTFULNESS": "the state of being artful [n -ES]\n",
  "ARTFULNESSES": "ARTFULNESS, the state of being artful [n]\n",
  "ARTHOUSE": "a cinema that shows films regarded as artistic as distinct from popular [n -S]\n",
  "ARTHOUSES": "ARTHOUSE, a cinema that shows films regarded as artistic as distinct from popular [n]\n",
  "ARTHRALGIA": "pain in a joint [n -S]\n",
  "ARTHRALGIAS": "ARTHRALGIA, pain in a joint [n]\n",
  "ARTHRALGIC": "relating to arthralgia, pain in a joint [adj]\n",
  "ARTHRECTOMIES": "ARTHRECTOMY, the surgical excision of a joint [n]\n",
  "ARTHRECTOMY": "the surgical excision of a joint [n ARTHRECTOMIES]\n",
  "ARTHRITIC": "suffering from arthritis [adj ARTHRITICALLY] / one who suffers from arthritis [n -S]\n",
  "ARTHRITICALLY": "ARTHRITIC, suffering from arthritis [adv]\n",
  "ARTHRITICS": "ARTHRITIC, one who suffers from arthritis [n]\n",
  "ARTHRITIDES": "ARTHRITIS, inflammation of the joints [n]\n",
  "ARTHRITIS": "inflammation of the joints [n ARTHRITISES or ARTHRITIDES]\n",
  "ARTHRITISES": "ARTHRITIS, inflammation of the joints [n]\n",
  "ARTHRODESES": "ARTHRODESIS, the surgical immobilization of a joint so that the bones grow solidly together [n]\n",
  "ARTHRODESIS": "the surgical immobilization of a joint so that the bones grow solidly together [n ARTHRODESES]\n",
  "ARTHRODIA": "in zoology, a joint [n ARTHRODIAE]\n",
  "ARTHRODIAE": "ARTHRODIA, in zoology, a joint [n]\n",
  "ARTHRODIAL": "relating to arthrodia, a joint [adj]\n",
  "ARTHROGRAPHIES": "ARTHROGRAPHY, the X-ray examination of a joint after injection of a contrast medium into the joint space [n]\n",
  "ARTHROGRAPHY": "the X-ray examination of a joint after injection of a contrast medium into the joint space [n ARTHROGRAPHIES]\n",
  "ARTHROMERE": "an arthropod body segment [n -S]\n",
  "ARTHROMERES": "ARTHROMERE, an arthropod body segment [n]\n",
  "ARTHROMERIC": "relating to an arthromere [adj]\n",
  "ARTHROPATHIES": "ARTHROPATHY, a disease of a joint [n]\n",
  "ARTHROPATHY": "a disease of a joint [n ARTHROPATHIES]\n",
  "ARTHROPLASTIES": "ARTHROPLASTY, surgical reconstruction of a joint [n]\n",
  "ARTHROPLASTY": "surgical reconstruction of a joint [n ARTHROPLASTIES]\n",
  "ARTHROPOD": "any member of the phylum Arthropoda, members of which (e.g. insects, arachnids, and crustaceans) are characterized by segmented bodies and jointed limbs [n -S]\n",
  "ARTHROPODAL": "of or like an arthropod, also ARTHROPODAN, ARTHROPODOUS [adj]\n",
  "ARTHROPODAN": "of or like an arthropod, also ARTHROPODAL, ARTHROPODOUS [adj]\n",
  "ARTHROPODOUS": "of or like an arthropod, also ARTHROPODAL, ARTHROPODAN [adj]\n",
  "ARTHROPODS": "ARTHROPOD, any member of the phylum Arthropoda, members of which (e.g. insects, arachnids, and crustaceans) are characterized by segmented bodies and jointed limbs [n]\n",
  "ARTHROSCOPE": "an instrument for examining the interior of a joint [n -S]\n",
  "ARTHROSCOPES": "ARTHROSCOPE, an instrument for examining the interior of a joint [n]\n",
  "ARTHROSCOPIC": "relating to arthroscope [adj]\n",
  "ARTHROSCOPIES": "ARTHROSCOPY, the examination of joints with an arthroscope [n]\n",
  "ARTHROSCOPY": "the examination of joints with an arthroscope [n ARTHROSCOPIES]\n",
  "ARTHROSES": "ARTHROSIS, a degenerative, noninflammatory, disease of the joints [n]\n",
  "ARTHROSIS": "a degenerative, noninflammatory, disease of the joints [n ARTHROSES]\n",
  "ARTHROSPORE": "another name for an oidium [n -S]\n",
  "ARTHROSPORES": "ARTHROSPORE, another name for an oidium [n]\n",
  "ARTHROSPORIC": "of or like an arthrospore, also ARTHROSPOROUS [adj]\n",
  "ARTHROSPOROUS": "of or like an arthrospore, also ARTHROSPORIC [adj]\n",
  "ARTI": "(Hindi) an Indian ceremony in which candles dipped in ghee are lighted and offered to various deities, also AARTI [n -S]\n",
  "ARTIC": "(short for) an articulated lorry [n -S]\n",
  "ARTICHOKE": "a thistle-like perennial plant with large fleshy scaly head and bracts and edible receptacle [n -S]\n",
  "ARTICHOKES": "ARTICHOKE, a thistle-like perennial plant with large fleshy scaly head and bracts and edible receptacle [n]\n",
  "ARTICLE": "in law, to charge with specific offenses [v ARTICLED, ARTICLING, ARTICLES]\n",
  "ARTICLED": "ARTICLE, in law, to charge with specific offenses [v]\n",
  "ARTICLES": "ARTICLE, in law, to charge with specific offenses [v]\n",
  "ARTICLING": "ARTICLE, in law, to charge with specific offenses [v]\n",
  "ARTICS": "ARTIC, (short for) an articulated lorry [n]\n",
  "ARTICULABLE": "that can be articulated [adj]\n",
  "ARTICULACIES": "ARTICULACY, the state of being articulate [n]\n",
  "ARTICULACY": "the state of being articulate [n ARTICULACIES]\n",
  "ARTICULAR": "pertaining to joints [adj]\n",
  "ARTICULATE": "speaking clearly [adj ARTICULATELY] / to give clear and effective utterance to [v ARTICULATED, ARTICULATING, ARTICULATES]\n",
  "ARTICULATED": "ARTICULATE, to give clear and effective utterance to [v]\n",
  "ARTICULATELY": "ARTICULATE, speaking clearly [adv]\n",
  "ARTICULATENESS": "the state of being articulate [n]\n",
  "ARTICULATES": "ARTICULATE, to give clear and effective utterance to [v]\n",
  "ARTICULATING": "ARTICULATE, to give clear and effective utterance to [v]\n",
  "ARTICULATION": "a joint or juncture between bones or cartilages in the skeleton of a vertebrate [n -S]\n",
  "ARTICULATIONS": "ARTICULATION, a joint or juncture between bones or cartilages in the skeleton of a vertebrate [n]\n",
  "ARTICULATIVE": "relating to articulation [adj]\n",
  "ARTICULATOR": "one who articulates [n -S]\n",
  "ARTICULATORS": "ARTICULATOR, one who articulates [n]\n",
  "ARTICULATORY": "of or relating to articulation [adj]\n",
  "ARTIER": "ARTY, artistic in a flashy way, also ARTSY [adj]\n",
  "ARTIES": "ARTY, an artistic person, also ARTSY [n]\n",
  "ARTIEST": "ARTY, artistic in a flashy way, also ARTSY [adj]\n",
  "ARTIFACT": "an object made by man, also ARTEFACT [n -S]\n",
  "ARTIFACTS": "ARTIFACT, an object made by man, also ARTEFACT [n]\n",
  "ARTIFACTUAL": "of or like an artifact, also ARTEFACTUAL [adj]\n",
  "ARTIFICE": "a clever stratagem [n -S]\n",
  "ARTIFICER": "a craftsman [n -S]\n",
  "ARTIFICERS": "ARTIFICER, a craftsman [n]\n",
  "ARTIFICES": "ARTIFICE, a clever stratagem [n]\n",
  "ARTIFICIAL": "humanly contrived often on a natural model [adj ARTIFICIALLY]\n",
  "ARTIFICIALISE": "to make artificial, also ARTIFICIALIZE [v ARTIFICIALISED, ARTIFICIALISING, ARTIFICIALISES]\n",
  "ARTIFICIALISED": "ARTIFICIALISE, to make artificial, also ARTIFICIALIZE [v]\n",
  "ARTIFICIALISES": "ARTIFICIALISE, to make artificial, also ARTIFICIALIZE [v]\n",
  "ARTIFICIALISING": "ARTIFICIALISE, to make artificial, also ARTIFICIALIZE [v]\n",
  "ARTIFICIALITIES": "ARTIFICIALITY, the quality of being artificial [n]\n",
  "ARTIFICIALITY": "the quality of being artificial [n ARTIFICIALITIES]\n",
  "ARTIFICIALIZE": "to make artificial, also ARTIFICIALISE [v ARTIFICIALIZED, ARTIFICIALIZING, ARTIFICIALIZES]\n",
  "ARTIFICIALIZED": "ARTIFICIALIZE, to make artificial, also ARTIFICIALISE [v]\n",
  "ARTIFICIALIZES": "ARTIFICIALIZE, to make artificial, also ARTIFICIALISE [v]\n",
  "ARTIFICIALIZING": "ARTIFICIALIZE, to make artificial, also ARTIFICIALISE [v]\n",
  "ARTIFICIALLY": "ARTIFICIAL, humanly contrived often on a natural model [adv]\n",
  "ARTIFICIALNESS": "the state of being artificial [n]\n",
  "ARTIGI": "(Inuit) a kind of parka worn in Canada, also ATIGI [n -S]\n",
  "ARTIGIS": "ARTIGI, (Inuit) a kind of parka worn in Canada, also ATIGI [n]\n",
  "ARTILLERIES": "ARTILLERY, offensive weapons of war esp. heavy guns [n]\n",
  "ARTILLERIST": "one who operates artillery [n -S]\n",
  "ARTILLERISTS": "ARTILLERIST, one who operates artillery [n]\n",
  "ARTILLERY": "offensive weapons of war esp. heavy guns [n ARTILLERIES]\n",
  "ARTILLERYMAN": "a soldier in the artillery [n ARTILLERYMEN]\n",
  "ARTILLERYMEN": "ARTILLERYMAN, a soldier in the artillery [n]\n",
  "ARTILY": "ARTY, artistic in a flashy way, also ARTSY [adv]\n",
  "ARTINESS": "the quality of being arty [n -ES]\n",
  "ARTINESSES": "ARTINESS, the quality of being arty [n]\n",
  "ARTIODACTYL": "an animal having an even number of toes on each foot, such as pig, camel, cattle, deer [n -S]\n",
  "ARTIODACTYLOUS": "of or like an artiodactyl, a two-toed animal [adj]\n",
  "ARTIODACTYLS": "ARTIODACTYL, an animal having an even number of toes on each foot, such as pig, camel, cattle, deer [n]\n",
  "ARTIS": "ARTI, (Hindi) an Indian ceremony in which candles dipped in ghee are lighted and offered to various deities, also AARTI [n]\n",
  "ARTISAN": "a skilled workman [n -S]\n",
  "ARTISANAL": "relating to an artisan, involving or utilizing traditional, small-scale, or non-mechanized methods or techniques [adj]\n",
  "ARTISANS": "ARTISAN, a skilled workman [n]\n",
  "ARTISANSHIP": "the state of being an artisan [n -S]\n",
  "ARTISANSHIPS": "ARTISANSHIP, the state of being an artisan [n]\n",
  "ARTIST": "one who is skilled in art [n -S]\n",
  "ARTISTE": "(French) a performing artist; a professional singer, dancer, actor, etc. [n -S]\n",
  "ARTISTES": "ARTISTE, (French) a performing artist; a professional singer, dancer, actor, etc. [n]\n",
  "ARTISTIC": "characteristic of art, also ARTISTICAL [adj ARTISTICALLY]\n",
  "ARTISTICAL": "characteristic of art, also ARTISTIC [adj ARTISTICALLY]\n",
  "ARTISTICALLY": "ARTISTICAL, characteristic of art, also ARTISTIC [adv]\n",
  "ARTISTRIES": "ARTISTRY, artistic workmanship [n]\n",
  "ARTISTRY": "artistic workmanship [n ARTISTRIES]\n",
  "ARTISTS": "ARTIST, one who is skilled in art [n]\n",
  "ARTLESS": "lacking cunning [adj]\n",
  "ARTLESSLY": "ARTLESS, lacking cunning [adv]\n",
  "ARTLESSNESS": "the state of being artless [n -ES]\n",
  "ARTLESSNESSES": "ARTLESSNESS, the state of being artless [n]\n",
  "ARTMAKER": "one that produces art [n -S]\n",
  "ARTMAKERS": "ARTMAKER, one that produces art [n]\n",
  "ARTMAKING": "the process of making art [n -S]\n",
  "ARTMAKINGS": "ARTMAKING, the process of making art [n]\n",
  "ARTOCARPUS": "a plant of the genus Artocarpus of the mulberry family, that includes breadfruit and jack [n -ES]\n",
  "ARTOCARPUSES": "ARTOCARPUS, a plant of the genus Artocarpus of the mulberry family, that includes breadfruit and jack [n]\n",
  "ARTS": "ART, works of creative imagination [n]\n",
  "ARTSIE": "a student on an arts course, also ARTSY [n ARTSIES]\n",
  "ARTSIER": "ARTSY, arty [adj]\n",
  "ARTSIES": "ARTSY, an arty person [n]\n",
  "ARTSIEST": "ARTSY, arty [adj]\n",
  "ARTSINESS": "the state of being artsy [n -ES]\n",
  "ARTSINESSES": "ARTSINESS, the state of being artsy [n]\n",
  "ARTSMAN": "craftsman [n ARTSMEN]\n",
  "ARTSMEN": "ARTSMAN, craftsman [n]\n",
  "ARTSY": "arty [adj ARTSIER, ARTSIEST] / an arty person [n ARTSIES]\n",
  "ARTWORK": "illustrative or decorative work in printed matter [n -S]\n",
  "ARTWORKS": "ARTWORK, illustrative or decorative work in printed matter [n]\n",
  "ARTY": "artistic in a flashy way, also ARTSY [adj ARTIER, ARTIEST, ARTILY] / an artistic person, also ARTSY [n ARTIES]\n",
  "ARUANA": "a large tropical fish, also ARAHUANA, ARAWANA, AROWANA [n -S]\n",
  "ARUANAS": "ARUANA, a large tropical fish, also ARAHUANA, ARAWANA, AROWANA [n]\n",
  "ARUGOLA": "(Italian) a Mediterranean plant used in salads, also ARUGULA, RUCOLA, RUGOLA [n -S]\n",
  "ARUGOLAS": "ARUGOLA, (Italian) a Mediterranean plant used in salads, also ARUGULA, RUCOLA, RUGOLA [n]\n",
  "ARUGULA": "(Italian) a Mediterranean plant used in salads, also ARUGOLA, RUCOLA, RUGOLA [n -S]\n",
  "ARUGULAS": "ARUGULA, (Italian) a Mediterranean plant used in salads, also ARUGOLA, RUCOLA, RUGOLA [n]\n",
  "ARUHE": "(Maori) the edible root of a New Zealand fern [n -S]\n",
  "ARUHES": "ARUHE, (Maori) the edible root of a New Zealand fern [n]\n",
  "ARUM": "a perennial plant of the cuckoo pint or wake-robin genus [n -S]\n",
  "ARUMS": "ARUM, a perennial plant of the cuckoo pint or wake-robin genus [n]\n",
  "ARUNDINACEOUS": "like a reed [adj]\n",
  "ARUSPEX": "(Latin) a person who inspected the entrails of sacrificial victims in order to foretell the future, also HARUSPEX [n ARUSPICES]\n",
  "ARUSPICES": "ARUSPEX, (Latin) a person who inspected the entrails of sacrificial victims in order to foretell the future, also HARUSPEX [n]\n",
  "ARVAL": "(Latin) pertaining to plowed land [adj]\n",
  "ARVEE": "(short for) recreational vehicle (RV) [n -S]\n",
  "ARVEES": "ARVEE, (short for) recreational vehicle (RV) [n]\n",
  "ARVICOLE": "(Latin) a mouse of the genus Arvicola, the fieldmouse [n -S]\n",
  "ARVICOLES": "ARVICOLE, (Latin) a mouse of the genus Arvicola, the fieldmouse [n]\n",
  "ARVICOLINE": "relating to the water-vole genus Arvicola [adj]\n",
  "ARVO": "(Australian slang) afternoon [n -S]\n",
  "ARVOS": "ARVO, (Australian slang) afternoon [n]\n",
  "ARY": "(dialect) any [adj]\n",
  "ARYBALLOID": "in the form of an aryballos, a globular oil-flask with a neck [adj]\n",
  "ARYBALLOS": "(Greek) a globular oil-flask with a neck [n ARYBALLOSES]\n",
  "ARYBALLOSES": "ARYBALLOS, (Greek) a globular oil-flask with a neck [n]\n",
  "ARYL": "any aromatic univalent hydrocarbon radical [n -S]\n",
  "ARYLS": "ARYL, any aromatic univalent hydrocarbon radical [n]\n",
  "ARYTAENOID": "one of a pair of cartilages or muscles of the larynx, also ARYTENOID [n -S]\n",
  "ARYTAENOIDS": "ARYTAENOID, one of a pair of cartilages or muscles of the larynx, also ARYTENOID [n]\n",
  "ARYTENOID": "one of a pair of cartilages or muscles of the larynx, also ARYTAENOID [n -S]\n",
  "ARYTENOIDAL": "pertaining to either of two small cartilages on top of the cricoid cartilage at the upper, back part of the larynx [adj]\n",
  "ARYTENOIDS": "ARYTENOID, one of a pair of cartilages or muscles of the larynx, also ARYTAENOID [n]\n",
  "ARYTHMIA": "absence or irregularity of rhythm e.g. of the heart, also ARHYTHMIA, ARRHYTHMIA [n -S]\n",
  "ARYTHMIAS": "ARYTHMIA, absence or irregularity of rhythm e.g. of the heart, also ARHYTHMIA, ARRHYTHMIA [n]\n",
  "ARYTHMIC": "relating to arythmia, absence or irregularity of rhythm e.g. of the heart, also ARHYTHMIC, ARRHYTHMIC [adj]\n",
  "AS": "a Norse god living in Asgard [n AESIR] / a gravel ridge or kame [n ASAR] / a Roman coin [n ASSES]\n",
  "ASAFETIDA": "an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFOETIDA, ASSAFETIDA, ASSAFOETIDA [n -S]\n",
  "ASAFETIDAS": "ASAFETIDA, an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFOETIDA, ASSAFETIDA, ASSAFOETIDA [n]\n",
  "ASAFOETIDA": "an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFETIDA, ASSAFETIDA, ASSAFOETIDA [n -S]\n",
  "ASAFOETIDAS": "ASAFOETIDA, an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFETIDA, ASSAFETIDA, ASSAFOETIDA [n]\n",
  "ASANA": "(Sanskrit) a yoga posture [n -S]\n",
  "ASANAS": "ASANA, (Sanskrit) a yoga posture [n]\n",
  "ASAR": "AS, a Norse god living in Asgard [n]\n",
  "ASARABACCA": "an acrid herbaceous plant of the birthwort family, the leaves and roots of which are emetic and cathartic [n -S]\n",
  "ASARABACCAS": "ASARABACCA, an acrid herbaceous plant of the birthwort family, the leaves and roots of which are emetic and cathartic [n]\n",
  "ASARUM": "(Latin) the dried root of the wild ginger [n -S]\n",
  "ASARUMS": "ASARUM, (Latin) the dried root of the wild ginger [n]\n",
  "ASBESTIC": "of or like asbestos, also ASBESTINE, ASBESTOUS [adj]\n",
  "ASBESTIFORM": "of or like asbestos [adj]\n",
  "ASBESTINE": "of or like asbestos, also ASBESTIC, ASBESTOUS [adj]\n",
  "ASBESTOS": "(Greek) fine fibrous mineral made into incombustible material, also ASBESTUS [n -ES]\n",
  "ASBESTOSES": "ASBESTOS, (Greek) fine fibrous mineral made into incombustible material, also ASBESTUS [n]\n",
  "ASBESTOSIS": "a lung disease caused by inhaling asbestos dust [n ASBESTOSES]\n",
  "ASBESTOUS": "of or like asbestos, also ASBESTIC, ASBESTINE [adj]\n",
  "ASBESTUS": "(Greek) a fine fibrous mineral made into incombustible material, also ASBESTOS [n -ES]\n",
  "ASBESTUSES": "ASBESTUS, (Greek) a fine fibrous mineral made into incombustible material, also ASBESTOS [n]\n",
  "ASCARED": "afraid [adv]\n",
  "ASCARIASES": "ASCARIASIS, infestation with, or disease caused by, ascarids [n]\n",
  "ASCARIASIS": "infestation with, or disease caused by, ascarids [n ASCARIASES]\n",
  "ASCARID": "any nematode worm of the parasitic genus Ascaris, infesting the small intestines, also ASCARIS [n -S]\n",
  "ASCARIDES": "ASCARIS, (Greek) any nematode worm of the parasitic genus Ascaris, infesting the small intestines, also ASCARID [n]\n",
  "ASCARIDS": "ASCARID, any nematode worm of the parasitic genus Ascaris, infesting the small intestines, also ASCARIS [n]\n",
  "ASCARIS": "(Greek) any nematode worm of the parasitic genus Ascaris, infesting the small intestines, also ASCARID [n ASCARIDES or ASCARISES]\n",
  "ASCARISES": "ASCARIS, (Greek) any nematode worm of the parasitic genus Ascaris, infesting the small intestines, also ASCARID [n]\n",
  "ASCAUNT": "(Shakespeare) slantways across, also ASCONCE, ASKANCE, ASKANT [adv]\n",
  "ASCEND": "to go or move upward [v -ED, -ING, -S]\n",
  "ASCENDABLE": "capable of being ascended, also ASCENDIBLE [adj]\n",
  "ASCENDANCE": "the state of being ascendant, also ASCENDANCY, ASCENDENCE, ASCENDENCY [n -S]\n",
  "ASCENDANCES": "ASCENDANCE, the state of being ascendant, also ASCENDANCY, ASCENDENCE, ASCENDENCY [n]\n",
  "ASCENDANCIES": "ASCENDANCY, the state of being ascendant, also ASCENDANCE, ASCENDENCE, ASCENDENCY [n]\n",
  "ASCENDANCY": "the state of being ascendant, also ASCENDANCE, ASCENDENCE, ASCENDENCY [n ASCENDANCIES]\n",
  "ASCENDANT": "rising, also ASCENDENT [adj ASCENDANTLY] / the part of the ecliptic just risen or about to rise above the horizon [n -S]\n",
  "ASCENDANTLY": "ASCENDANT, rising, also ASCENDENT [adv]\n",
  "ASCENDANTS": "ASCENDANT, the part of the ecliptic just risen or about to rise above the horizon [n]\n",
  "ASCENDED": "ASCEND, to go or move upward [v]\n",
  "ASCENDENCE": "the state of being ascendent, also ASCENDANCE, ASCENDANCY, ASCENDENCY [n -S]\n",
  "ASCENDENCES": "ASCENDENCE, the state of being ascendent, also ASCENDANCE, ASCENDANCY, ASCENDENCY [n]\n",
  "ASCENDENCIES": "ASCENDENCY, the state of being ascendent, also ASCENDANCE, ASCENDANCY, ASCENDENCE [n]\n",
  "ASCENDENCY": "the state of being ascendent, also ASCENDANCE, ASCENDANCY, ASCENDENCE [n ASCENDENCIES]\n",
  "ASCENDENT": "the part of the ecliptic just risen or about to rise above the horizon, also ASCENDANT [n -S]\n",
  "ASCENDENTS": "ASCENDENT, the part of the ecliptic just risen or about to rise above the horizon, also ASCENDANT [n]\n",
  "ASCENDER": "a part or stroke projecting above letters such as x [n -S]\n",
  "ASCENDERS": "ASCENDER, a part or stroke projecting above letters such as x [n]\n",
  "ASCENDEUR": "(French) a metal grip that is threaded on a rope as a climbing aid [n -S]\n",
  "ASCENDEURS": "ASCENDEUR, (French) a metal grip that is threaded on a rope as a climbing aid [n]\n",
  "ASCENDIBLE": "capable of being ascended, also ASCENDABLE [adj]\n",
  "ASCENDING": "ASCEND, to go or move upward [v]\n",
  "ASCENDS": "ASCEND, to go or move upward [v]\n",
  "ASCENSION": "an ascent to heaven, esp. Christ's [n -S]\n",
  "ASCENSIONAL": "of or relating to ascension or ascent [adj]\n",
  "ASCENSIONIST": "a person who has completed a mountain ascent, esp. a notable one [n -S]\n",
  "ASCENSIONISTS": "ASCENSIONIST, a person who has completed a mountain ascent, esp. a notable one [n]\n",
  "ASCENSIONS": "ASCENSION, an ascent to heaven, esp. Christ's [n]\n",
  "ASCENSIVE": "rising; curving up from a prostrate to an erect position [adj]\n",
  "ASCENT": "a going up [n -S]\n",
  "ASCENTS": "ASCENT, a going up [n]\n",
  "ASCERTAIN": "to make sure [v -ED, -ING, -S]\n",
  "ASCERTAINABLE": "capable of being ascertained [adj ASCERTAINABLY]\n",
  "ASCERTAINABLY": "ASCERTAINABLE, capable of being ascertained [adv]\n",
  "ASCERTAINED": "ASCERTAIN, to make sure [v]\n",
  "ASCERTAINING": "ASCERTAIN, to make sure [v]\n",
  "ASCERTAINMENT": "the act of ascertaining [n -S]\n",
  "ASCERTAINMENTS": "ASCERTAINMENT, the act of ascertaining [n]\n",
  "ASCERTAINS": "ASCERTAIN, to make sure [v]\n",
  "ASCESES": "ASCESIS, (Greek) the conduct of an ascetic, also ASKESIS [n]\n",
  "ASCESIS": "(Greek) the conduct of an ascetic, also ASKESIS [n ASCESES]\n",
  "ASCETIC": "practising severe abstinence or austerity, esp. for religious or spiritual reasons, also ASCETICAL [adj ASCETICALLY] / one who practises asceticism [n -S]\n",
  "ASCETICAL": "practising severe abstinence or austerity, esp. for religious or spiritual reasons, also ASCETIC [adj ASCETICALLY]\n",
  "ASCETICALLY": "ASCETICAL, practising severe abstinence or austerity, esp. for religious or spiritual reasons, also ASCETIC [adv]\n",
  "ASCETICISM": "the state of being ascetic [n -S]\n",
  "ASCETICISMS": "ASCETICISM, the state of being ascetic [n]\n",
  "ASCETICS": "ASCETIC, one who practises asceticism [n]\n",
  "ASCI": "ASCUS, (Greek) an enlarged cell which has formed eight spores [n]\n",
  "ASCIAN": "an inhabitant of the torrid zone, shadowless when the sun is right overhead [n -S]\n",
  "ASCIANS": "ASCIAN, an inhabitant of the torrid zone, shadowless when the sun is right overhead [n]\n",
  "ASCIDIA": "ASCIDIUM, a pitcher-shaped, or flask-shaped, organ or appendage of a plant [n]\n",
  "ASCIDIAN": "a sea-squirt or tunicate [n -S]\n",
  "ASCIDIANS": "ASCIDIAN, a sea-squirt or tunicate [n]\n",
  "ASCIDIATE": "like an ascidium [adj]\n",
  "ASCIDIUM": "a pitcher-shaped, or flask-shaped, organ or appendage of a plant [n ASCIDIA]\n",
  "ASCITES": "(Greek) dropsy of the abdomen [n ASCITES]\n",
  "ASCITIC": "relating to dropsy of the abdomen [adj]\n",
  "ASCITICAL": "of, pertaining to, or affected by, ascites; dropsical, also ASCITIC [adj]\n",
  "ASCITITIOUS": "added or assumed, also ADSCITITIOUS [adj]\n",
  "ASCLEPIAD": "a choriambic verse, first used by the Greek poet Asclepias, consisting of four feet, viz. a spondee, two choriambi, and an iambus [n -S]\n",
  "ASCLEPIADACEOUS": "belonging to the Asclepiadaceae, the milkweed and swallowwort family [adj]\n",
  "ASCLEPIADS": "ASCLEPIAD, a choriambic verse, first used by the Greek poet Asclepias, consisting of four feet, viz. a spondee, two choriambi, and an iambus [n]\n",
  "ASCLEPIAS": "(Greek) an American plant of the milkweed genus [n ASCLEPIASES]\n",
  "ASCLEPIASES": "ASCLEPIAS, (Greek) an American plant of the milkweed genus [n]\n",
  "ASCOCARP": "a spore-producing organ of certain fungi [n -S]\n",
  "ASCOCARPIC": "relating to an ascocarp, a spore-producing organ of certain fungi [adj]\n",
  "ASCOCARPS": "ASCOCARP, a spore-producing organ of certain fungi [n]\n",
  "ASCOGONIA": "ASCOGONIUM, the female reproductive structure of fungi [n]\n",
  "ASCOGONIUM": "the female reproductive structure of fungi [n ASCOGONIA]\n",
  "ASCOMYCETE": "one of the main divisions of the Fungi [n -S]\n",
  "ASCOMYCETES": "ASCOMYCETE, one of the main divisions of the Fungi [n]\n",
  "ASCOMYCETOUS": "relating to ascomycete [adj]\n",
  "ASCON": "a type of sponge [n -S]\n",
  "ASCONCE": "(obsolete) askance, also ASCAUNT, ASKANCE, ASKANT [adv]\n",
  "ASCONOID": "like an ascon, a type of sponge [adj]\n",
  "ASCONS": "ASCON, a type of sponge [n]\n",
  "ASCORBATE": "a salt of ascorbic acid [n -S]\n",
  "ASCORBATES": "ASCORBATE, a salt of ascorbic acid [n]\n",
  "ASCORBIC": "antiscorbutic, relieving scurvy, as in ascorbic acid [adj]\n",
  "ASCOSPORE": "one of the spores contained in the asci of lichens and fungi [n -S]\n",
  "ASCOSPORES": "ASCOSPORE, one of the spores contained in the asci of lichens and fungi [n]\n",
  "ASCOSPORIC": "of or like an ascospore, one of the spores contained in the asci of lichens and fungi [adj]\n",
  "ASCOT": "a type of necktie with broad ends [n -S]\n",
  "ASCOTS": "ASCOT, a type of necktie with broad ends [n]\n",
  "ASCRIBABLE": "capable of being ascribed; attributable [adj]\n",
  "ASCRIBE": "to attribute [v ASCRIBED, ASCRIBING, ASCRIBES]\n",
  "ASCRIBED": "ASCRIBE, to attribute [v]\n",
  "ASCRIBES": "ASCRIBE, to attribute [v]\n",
  "ASCRIBING": "ASCRIBE, to attribute [v]\n",
  "ASCRIPTION": "the act of ascribing, also ADSCRIPTION [n -S]\n",
  "ASCRIPTIONS": "ASCRIPTION, the act of ascribing, also ADSCRIPTION [n]\n",
  "ASCRIPTIVE": "relating to ascription [adj]\n",
  "ASCUS": "(Greek) an enlarged cell which has formed eight spores [n ASCI]\n",
  "ASDIC": "an apparatus for locating e.g. submarines underwater by the use of ultrasonics [n -S]\n",
  "ASDICS": "ASDIC, an apparatus for locating e.g. submarines underwater by the use of ultrasonics [n]\n",
  "ASEA": "at sea [adv]\n",
  "ASEISMIC": "free from earthquakes; designed to withstand earthquakes [adj]\n",
  "ASEITIES": "ASEITY, self-origination [n]\n",
  "ASEITY": "self-origination [n ASEITIES]\n",
  "ASEMANTIC": "not semantic [adj]\n",
  "ASEPALOUS": "without sepals [adj]\n",
  "ASEPSES": "ASEPSIS, (Greek) freedom from blood poisoning [n]\n",
  "ASEPSIS": "(Greek) freedom from blood poisoning [n ASEPSES]\n",
  "ASEPTATE": "not partitioned by septa [adj]\n",
  "ASEPTIC": "free from sepsis [adj ASEPTICALLY] / an aseptic substance [n -S]\n",
  "ASEPTICALLY": "ASEPTIC, free from sepsis [adv]\n",
  "ASEPTICISE": "to make aseptic; to treat with aseptics, also ASEPTICIZE [v ASEPTICISED, ASEPTICISING, ASEPTICISES]\n",
  "ASEPTICISED": "ASEPTICISE, to make aseptic; to treat with aseptics, also ASEPTICIZE [v]\n",
  "ASEPTICISES": "ASEPTICISE, to make aseptic; to treat with aseptics, also ASEPTICIZE [v]\n",
  "ASEPTICISING": "ASEPTICISE, to make aseptic; to treat with aseptics, also ASEPTICIZE [v]\n",
  "ASEPTICISM": "aseptic treatment [n -S]\n",
  "ASEPTICISMS": "ASEPTICISM, aseptic treatment [n]\n",
  "ASEPTICIZE": "to make aseptic; to treat with aseptics, also ASEPTICISE [v ASEPTICIZED, ASEPTICIZING, ASEPTICIZES]\n",
  "ASEPTICIZED": "ASEPTICIZE, to make aseptic; to treat with aseptics, also ASEPTICISE [v]\n",
  "ASEPTICIZES": "ASEPTICIZE, to make aseptic; to treat with aseptics, also ASEPTICISE [v]\n",
  "ASEPTICIZING": "ASEPTICIZE, to make aseptic; to treat with aseptics, also ASEPTICISE [v]\n",
  "ASEPTICS": "ASEPTIC, an aseptic substance [n]\n",
  "ASEXUAL": "of reproduction, involving only one parent; it usually produces genetically identical offspring [adj ASEXUALLY]\n",
  "ASEXUALITIES": "ASEXUALITY, the state of being asexual [n]\n",
  "ASEXUALITY": "the state of being asexual [n ASEXUALITIES]\n",
  "ASEXUALLY": "ASEXUAL, of reproduction, involving only one parent; it usually produces genetically identical offspring [adv]\n",
  "ASH": "the dust or remains of anything burnt [n -ES] / to convert something into ash [v -ED, -ING, -ES]\n",
  "ASHAKE": "(archaic) in a shaking state [adv]\n",
  "ASHAME": "(archaic) to shame [v ASHAMED, ASHAMING, ASHAMES]\n",
  "ASHAMED": "feeling shame [adj ASHAMEDLY]\n",
  "ASHAMEDLY": "ASHAMED, feeling shame [adv]\n",
  "ASHAMEDNESS": "the state of being ashamed [n -ES]\n",
  "ASHAMEDNESSES": "ASHAMEDNESS, the state of being ashamed [n]\n",
  "ASHAMES": "ASHAME, (archaic) to shame [v]\n",
  "ASHAMING": "ASHAME, (archaic) to shame [v]\n",
  "ASHCAKE": "a cornmeal cake [n -S]\n",
  "ASHCAKES": "ASHCAKE, a cornmeal cake [n]\n",
  "ASHCAN": "a metal receptacle for garbage [n -S]\n",
  "ASHCANS": "ASHCAN, a metal receptacle for garbage [n]\n",
  "ASHED": "ASH, to convert something into ash [v]\n",
  "ASHEN": "very pale [adj]\n",
  "ASHERIES": "ASHERY, a place where potash is made [n]\n",
  "ASHERY": "a place where potash is made [n ASHERIES]\n",
  "ASHES": "ASH, to convert something into ash [v]\n",
  "ASHET": "(Scots) a large plate [n -S]\n",
  "ASHETS": "ASHET, (Scots) a large plate [n]\n",
  "ASHFALL": "a deposit of volcanic ash [n -S]\n",
  "ASHFALLS": "ASHFALL, a deposit of volcanic ash [n]\n",
  "ASHIER": "ASHY, covered with ashes [adj]\n",
  "ASHIEST": "ASHY, covered with ashes [adj]\n",
  "ASHINE": "(archaic) shining [adv]\n",
  "ASHINESS": "the condition of being ashy [n -ES]\n",
  "ASHINESSES": "ASHINESS, the condition of being ashy [n]\n",
  "ASHING": "ASH, to convert something into ash [v]\n",
  "ASHIVER": "(archaic) shivering [adj]\n",
  "ASHKEY": "the winged fruit of the ash tree [n -S]\n",
  "ASHKEYS": "ASHKEY, the winged fruit of the ash tree [n]\n",
  "ASHLAR": "to build with squared stones, also ASHLER [v -ED, -ING, -S]\n",
  "ASHLARED": "ASHLAR, to build with squared stones, also ASHLER [v]\n",
  "ASHLARING": "facing with ashlars, also ASHLERING [n -S]\n",
  "ASHLARINGS": "ASHLARING, facing with ashlars, also ASHLERING [n]\n",
  "ASHLARS": "ASHLAR, to build with squared stones, also ASHLER [v]\n",
  "ASHLER": "to build with squared stones, also ASHLAR [v -ED, -ING, -S]\n",
  "ASHLERED": "ASHLER, to build with squared stones, also ASHLAR [v]\n",
  "ASHLERING": "facing with ashlars, also ASHLARING [n -S]\n",
  "ASHLERINGS": "ASHLERING, facing with ashlars, also ASHLARING [n]\n",
  "ASHLERS": "ASHLER, to build with squared stones, also ASHLAR [v]\n",
  "ASHLESS": "having no ashes [adj]\n",
  "ASHMAN": "one who collects and removes ashes [n ASHMEN]\n",
  "ASHMEN": "ASHMAN, one who collects and removes ashes [n]\n",
  "ASHORE": "toward or on the shore [adv]\n",
  "ASHPAN": "a tray under a grate to catch the ashes [n -S]\n",
  "ASHPANS": "ASHPAN, a tray under a grate to catch the ashes [n]\n",
  "ASHPLANT": "a walking stick made of ash [n -S]\n",
  "ASHPLANTS": "ASHPLANT, a walking stick made of ash [n]\n",
  "ASHRAF": "SHARIF, (Arabic) a descendant of Mohammed through his daughter Fatima, also SHEREEF, SHERIF [n]\n",
  "ASHRAM": "(Sanskrit) the dwelling of a Hindu religious philosopher, also ASRAMA [n -S]\n",
  "ASHRAMA": "(Sanskrit) any one of the four stages of life which a man should pass through [n -S]\n",
  "ASHRAMAS": "ASHRAMA, (Sanskrit) any one of the four stages of life which a man should pass through [n]\n",
  "ASHRAMITE": "a person living in an ashram [n -S]\n",
  "ASHRAMITES": "ASHRAMITE, a person living in an ashram [n]\n",
  "ASHRAMS": "ASHRAM, (Sanskrit) the dwelling of a Hindu religious philosopher, also ASRAMA [n]\n",
  "ASHTANGA": "a form of yoga aiming to synchronize breathing and posture, also ASTANGA, ASTHANGA [n -S]\n",
  "ASHTANGAS": "ASHTANGA, a form of yoga aiming to synchronize breathing and posture, also ASTANGA, ASTHANGA [n]\n",
  "ASHTRAY": "a receptacle for tobacco ashes [n -S]\n",
  "ASHTRAYS": "ASHTRAY, a receptacle for tobacco ashes [n]\n",
  "ASHY": "covered with ashes [adj ASHIER, ASHIEST]\n",
  "ASIAGO": "(Italian) a type of Italian cheese [n -S]\n",
  "ASIAGOS": "ASIAGO, (Italian) a type of Italian cheese [n]\n",
  "ASIDE": "on or to one side [adv] / a comment by an actor intended to be heard by the audience but not the other actors [n -S]\n",
  "ASIDES": "ASIDE, a comment by an actor intended to be heard by the audience but not the other actors [n]\n",
  "ASINICO": "(Shakespeare) a stupid fellow [n -S]\n",
  "ASINICOS": "ASINICO, (Shakespeare) a stupid fellow [n]\n",
  "ASININE": "of or like an ass; stupid [adj ASININELY]\n",
  "ASININELY": "ASININE, of or like an ass; stupid [adv]\n",
  "ASININITIES": "ASININITY, stupidity [n]\n",
  "ASININITY": "stupidity [n ASININITIES]\n",
  "ASK": "to inquire or request [v -ED, -ING, -S]\n",
  "ASKANCE": "sideways; obliquely [adv] / (Shakespeare) to turn aside, also ASKANT [v ASKANCED, ASKANCING, ASKANCES]\n",
  "ASKANCED": "ASKANCE, (Shakespeare) to turn aside, also ASKANT [v]\n",
  "ASKANCES": "ASKANCE, (Shakespeare) to turn aside, also ASKANT [v]\n",
  "ASKANCING": "ASKANCE, (Shakespeare) to turn aside, also ASKANT [v]\n",
  "ASKANT": "sideways; obliquely [adv] / (Shakespeare) to turn aside, also ASKANCE [v -ED, -ING, -S]\n",
  "ASKANTED": "ASKANT, (Shakespeare) to turn aside, also ASKANCE [v]\n",
  "ASKANTING": "ASKANT, (Shakespeare) to turn aside, also ASKANCE [v]\n",
  "ASKANTS": "ASKANT, (Shakespeare) to turn aside, also ASKANCE [v]\n",
  "ASKARI": "(Arabic) an East African soldier or policeman [n -S]\n",
  "ASKARIS": "ASKARI, (Arabic) an East African soldier or policeman [n]\n",
  "ASKED": "ASK, to inquire or request [v]\n",
  "ASKER": "one who asks [n -S]\n",
  "ASKERS": "ASKER, one who asks [n]\n",
  "ASKESES": "ASKESIS, (Greek) the conduct of an ascetic, also ASCESIS [n]\n",
  "ASKESIS": "(Greek) the conduct of an ascetic, also ASCESIS [n ASKESES]\n",
  "ASKEW": "awry [adj]\n",
  "ASKEWNESS": "the state of being askew [n -ES]\n",
  "ASKEWNESSES": "ASKEWNESS, the state of being askew [n]\n",
  "ASKING": "the act of asking [n -S]\n",
  "ASKINGS": "ASKING, the act of asking [n]\n",
  "ASKLENT": "(Scots) athwart, aslant [adv]\n",
  "ASKOI": "ASKOS, (Greek) an ancient Greek oil jar [n]\n",
  "ASKOS": "(Greek) an ancient Greek oil jar [n ASKOI]\n",
  "ASKS": "ASK, to inquire or request [v]\n",
  "ASLAKE": "(archaic) to mitigate; to moderate [v ASLAKED, ASLAKING, ASLAKES]\n",
  "ASLAKED": "ASLAKE, (archaic) to mitigate; to moderate [v]\n",
  "ASLAKES": "ASLAKE, (archaic) to mitigate; to moderate [v]\n",
  "ASLAKING": "ASLAKE, (archaic) to mitigate; to moderate [v]\n",
  "ASLANT": "slanting [adv]\n",
  "ASLEEP": "sleeping [adj]\n",
  "ASLOPE": "(archaic) on a slope [adv]\n",
  "ASLOSH": "awash [adv]\n",
  "ASMEAR": "(archaic) smeared over [adv]\n",
  "ASMOULDER": "(archaic) smouldering [adv]\n",
  "ASOCIAL": "avoiding contact with others [adj] / someone who is asocial [n -S]\n",
  "ASOCIALS": "ASOCIAL, someone who is asocial [n]\n",
  "ASP": "a venomous snake, also ASPICK [n -S]\n",
  "ASPARAGINASE": "an enzyme that causes asparagine to hydrolyse to aspartic acid and ammonia [n -S]\n",
  "ASPARAGINASES": "ASPARAGINASE, an enzyme that causes asparagine to hydrolyse to aspartic acid and ammonia [n]\n",
  "ASPARAGINE": "an amino acid found in asparagus and other vegetables [n -S]\n",
  "ASPARAGINES": "ASPARAGINE, an amino acid found in asparagus and other vegetables [n]\n",
  "ASPARAGUS": "any plant of the Asparagus genus, one species having young shoots eaten as a delicacy [n -ES]\n",
  "ASPARAGUSES": "ASPARAGUS, any plant of the Asparagus genus, one species having young shoots eaten as a delicacy [n]\n",
  "ASPARKLE": "in a sparkling state [adj]\n",
  "ASPARTAME": "an artificial sweetener [n -S]\n",
  "ASPARTAMES": "ASPARTAME, an artificial sweetener [n]\n",
  "ASPARTATE": "a salt of aspartic acid [n -S]\n",
  "ASPARTATES": "ASPARTATE, a salt of aspartic acid [n]\n",
  "ASPARTIC": "as in aspartic acid, an amino acid found in young sugarcane, etc., and formed by the hydrolysis of asparagine [adj]\n",
  "ASPECT": "to look at [v -ED, -ING, -S]\n",
  "ASPECTABLE": "(archaic) visible; worth looking at [adj]\n",
  "ASPECTED": "ASPECT, to look at [v]\n",
  "ASPECTING": "ASPECT, to look at [v]\n",
  "ASPECTS": "ASPECT, to look at [v]\n",
  "ASPECTUAL": "relating to aspect [adj]\n",
  "ASPEN": "the trembling poplar, also ASPINE [n -S]\n",
  "ASPENS": "ASPEN, the trembling poplar, also ASPINE [n]\n",
  "ASPER": "(Greek) a Turkish money of account [n -S]\n",
  "ASPERATE": "to make rough or harsh [v ASPERATED, ASPERATING, ASPERATES]\n",
  "ASPERATED": "ASPERATE, to make rough or harsh [v]\n",
  "ASPERATES": "ASPERATE, to make rough or harsh [v]\n",
  "ASPERATING": "ASPERATE, to make rough or harsh [v]\n",
  "ASPERGATION": "the act of asperging [n -S]\n",
  "ASPERGATIONS": "ASPERGATION, the act of asperging [n]\n",
  "ASPERGE": "to sprinkle [v ASPERGED, ASPERGING, ASPERGES]\n",
  "ASPERGED": "ASPERGE, to sprinkle [v]\n",
  "ASPERGER": "a vessel for sprinkling holy water or incense [n -S]\n",
  "ASPERGERS": "ASPERGER, a vessel for sprinkling holy water or incense [n]\n",
  "ASPERGES": "ASPERGE, to sprinkle [v]\n",
  "ASPERGILL": "a holy water sprinkler, also ASPERGILLUM [n -S]\n",
  "ASPERGILLA": "ASPERGILLUM, a holy water sprinkler, also ASPERGILL [n]\n",
  "ASPERGILLI": "ASPERGILLUS, (Latin) a minute fungus forming mould [n]\n",
  "ASPERGILLOSES": "ASPERGILLOSIS, animal disease caused by aspergilli [n]\n",
  "ASPERGILLOSIS": "animal disease caused by aspergilli [n ASPERGILLOSES]\n",
  "ASPERGILLS": "ASPERGILL, a holy water sprinkler, also ASPERGILLUM [n]\n",
  "ASPERGILLUM": "a holy water sprinkler, also ASPERGILL [n ASPERGILLUMS or ASPERGILLA]\n",
  "ASPERGILLUMS": "ASPERGILLUM, a holy water sprinkler, also ASPERGILL [n]\n",
  "ASPERGILLUS": "(Latin) a minute fungus forming mould [n ASPERGILLI]\n",
  "ASPERGING": "ASPERGE, to sprinkle [v]\n",
  "ASPERITIES": "ASPERITY, roughness [n]\n",
  "ASPERITY": "roughness [n ASPERITIES]\n",
  "ASPERMIA": "failure to produce sperm [n -S]\n",
  "ASPERMIAS": "ASPERMIA, failure to produce sperm [n]\n",
  "ASPEROUS": "rough with short hairs [adj]\n",
  "ASPERS": "ASPER, (Greek) a Turkish money of account [n]\n",
  "ASPERSE": "to slander, disparage [v ASPERSED, ASPERSING, ASPERSES]\n",
  "ASPERSED": "ASPERSE, to slander, disparage [v]\n",
  "ASPERSER": "one who asperses, also ASPERSOR [n -S]\n",
  "ASPERSERS": "ASPERSER, one who asperses, also ASPERSOR [n]\n",
  "ASPERSES": "ASPERSE, to slander, disparage [v]\n",
  "ASPERSING": "ASPERSE, to slander, disparage [v]\n",
  "ASPERSION": "calumny, slander [n -S]\n",
  "ASPERSIONS": "ASPERSION, calumny, slander [n]\n",
  "ASPERSIVE": "tending to asperse, defamatory [adj ASPERSIVELY]\n",
  "ASPERSIVELY": "ASPERSIVE, tending to asperse, defamatory [adv]\n",
  "ASPERSOIR": "(French) a brushlike implement used to sprinkle holy water [n -S]\n",
  "ASPERSOIRS": "ASPERSOIR, (French) a brushlike implement used to sprinkle holy water [n]\n",
  "ASPERSOR": "one who asperses, also ASPERSER [n -S]\n",
  "ASPERSORIA": "ASPERSORIUM, a basin for holy water [n]\n",
  "ASPERSORIES": "ASPERSORY, a vessel for holding holy water [n]\n",
  "ASPERSORIUM": "a basin for holy water [n ASPERSORIUMS or ASPERSORIA]\n",
  "ASPERSORIUMS": "ASPERSORIUM, a basin for holy water [n]\n",
  "ASPERSORS": "ASPERSOR, one who asperses, also ASPERSER [n]\n",
  "ASPERSORY": "a vessel for holding holy water [n ASPERSORIES]\n",
  "ASPHALT": "to coat with a bituminous pitch [v -ED, -ING, -S]\n",
  "ASPHALTED": "ASPHALT, to coat with a bituminous pitch [v]\n",
  "ASPHALTER": "a person who lays asphalt [n -S]\n",
  "ASPHALTERS": "ASPHALTER, a person who lays asphalt [n]\n",
  "ASPHALTIC": "of or like asphalt [adj]\n",
  "ASPHALTING": "ASPHALT, to coat with a bituminous pitch [v]\n",
  "ASPHALTITE": "a native asphalt occurring in veins below the ground [n -S]\n",
  "ASPHALTITES": "ASPHALTITE, a native asphalt occurring in veins below the ground [n]\n",
  "ASPHALTS": "ASPHALT, to coat with a bituminous pitch [v]\n",
  "ASPHALTUM": "(Greek) a mixture of bituminous pitch with sand etc. used for surfacing paths, roads, etc., also ASPHALT [n -S]\n",
  "ASPHALTUMS": "ASPHALTUM, (Greek) a mixture of bituminous pitch with sand etc. used for surfacing paths, roads, etc., also ASPHALT [n]\n",
  "ASPHERIC": "a lens that has a shape that is not completely round; a contact lens with changing lens strength [n -S]\n",
  "ASPHERICAL": "not spherical, also ASPHERIC [adj]\n",
  "ASPHERICS": "ASPHERIC, a lens that has a shape that is not completely round; a contact lens with changing lens strength [n]\n",
  "ASPHETERISE": "to deny the right of private property, also ASPHETERIZE [v ASPHETERISED, ASPHETERISING, ASPHETERISES]\n",
  "ASPHETERISED": "ASPHETERISE, to deny the right of private property, also ASPHETERIZE [v]\n",
  "ASPHETERISES": "ASPHETERISE, to deny the right of private property, also ASPHETERIZE [v]\n",
  "ASPHETERISING": "ASPHETERISE, to deny the right of private property, also ASPHETERIZE [v]\n",
  "ASPHETERISM": "the belief that there should be no private property [n -S]\n",
  "ASPHETERISMS": "ASPHETERISM, the belief that there should be no private property [n]\n",
  "ASPHETERIZE": "to deny the right of private property, also ASPHETERISE [v ASPHETERIZED, ASPHETERIZING, ASPHETERIZES]\n",
  "ASPHETERIZED": "ASPHETERIZE, to deny the right of private property, also ASPHETERISE [v]\n",
  "ASPHETERIZES": "ASPHETERIZE, to deny the right of private property, also ASPHETERISE [v]\n",
  "ASPHETERIZING": "ASPHETERIZE, to deny the right of private property, also ASPHETERISE [v]\n",
  "ASPHODEL": "(Greek) a plant of the lily family; in literature, the flower of the Elysian fields [n -S]\n",
  "ASPHODELS": "ASPHODEL, (Greek) a plant of the lily family; in literature, the flower of the Elysian fields [n]\n",
  "ASPHYXIA": "stoppage of vital functions due to lack of oxygen, also ASPHYXY [n -S]\n",
  "ASPHYXIAL": "of or relating to asphyxia [adj]\n",
  "ASPHYXIANT": "an agent causing asphyxiation [n -S]\n",
  "ASPHYXIANTS": "ASPHYXIANT, an agent causing asphyxiation [n]\n",
  "ASPHYXIAS": "ASPHYXIA, stoppage of vital functions due to lack of oxygen, also ASPHYXY [n]\n",
  "ASPHYXIATE": "to cause asphyxia in [v ASPHYXIATED, ASPHYXIATING, ASPHYXIATES]\n",
  "ASPHYXIATED": "ASPHYXIATE, to cause asphyxia in [v]\n",
  "ASPHYXIATES": "ASPHYXIATE, to cause asphyxia in [v]\n",
  "ASPHYXIATING": "ASPHYXIATE, to cause asphyxia in [v]\n",
  "ASPHYXIATION": "the act of asphyxiation [n -S]\n",
  "ASPHYXIATIONS": "ASPHYXIATION, the act of asphyxiation [n]\n",
  "ASPHYXIATOR": "one of who asphyxiates [n -S]\n",
  "ASPHYXIATORS": "ASPHYXIATOR, one of who asphyxiates [n]\n",
  "ASPHYXIED": "ASPHYXY, to suffer defective aeration of the blood caused by failure of the oxygen supply, also ASPHYXIA [v]\n",
  "ASPHYXIES": "ASPHYXY, to suffer defective aeration of the blood caused by failure of the oxygen supply, also ASPHYXIA [v]\n",
  "ASPHYXY": "to suffer defective aeration of the blood caused by failure of the oxygen supply, also ASPHYXIA [v ASPHYXIED, ASPHYXYING, ASPHYXIES]\n",
  "ASPHYXYING": "ASPHYXY, to suffer defective aeration of the blood caused by failure of the oxygen supply, also ASPHYXIA [v]\n",
  "ASPIC": "a clear savoury meat or fish-jelly used as a glaze, also ASPIS [n -S]\n",
  "ASPICK": "a venomous snake, also ASP [n -S]\n",
  "ASPICKS": "ASPICK, a venomous snake, also ASP [n]\n",
  "ASPICS": "ASPIC, a clear savoury meat or fish-jelly used as a glaze, also ASPIS [n]\n",
  "ASPIDIA": "ASPIDIUM, (Greek) a type of fern [n]\n",
  "ASPIDIOID": "like an aspidium, a shield-fern [adj]\n",
  "ASPIDISTRA": "an evergreen perennial house plant [n -S]\n",
  "ASPIDISTRAS": "ASPIDISTRA, an evergreen perennial house plant [n]\n",
  "ASPIDIUM": "(Greek) a type of fern [n ASPIDIA]\n",
  "ASPIE": "(offensive) a person who has Asperger's syndrome [n -S]\n",
  "ASPIES": "ASPIE, (offensive) a person who has Asperger's syndrome [n]\n",
  "ASPINE": "(Spenser) aspen [n -S]\n",
  "ASPINES": "ASPINE, (Spenser) aspen [n]\n",
  "ASPIRANT": "a candidate [n -S]\n",
  "ASPIRANTS": "ASPIRANT, a candidate [n]\n",
  "ASPIRATA": "(Latin) a breathed sound like \"ph\" or \"th\" [n ASPIRATAE]\n",
  "ASPIRATAE": "ASPIRATA, (Latin) a breathed sound like \"ph\" or \"th\" [n]\n",
  "ASPIRATE": "to pronounce breathily [v ASPIRATED, ASPIRATING, ASPIRATES]\n",
  "ASPIRATED": "ASPIRATE, to pronounce breathily [v]\n",
  "ASPIRATES": "ASPIRATE, to pronounce breathily [v]\n",
  "ASPIRATING": "ASPIRATE, to pronounce breathily [v]\n",
  "ASPIRATION": "the act of breathing and esp. of breathing in [n -S]\n",
  "ASPIRATIONAL": "relating to aspiration [adj]\n",
  "ASPIRATIONS": "ASPIRATION, the act of breathing and esp. of breathing in [n]\n",
  "ASPIRATOR": "an instrument for removing fluids or solids from cavities of the body [n -S]\n",
  "ASPIRATORS": "ASPIRATOR, an instrument for removing fluids or solids from cavities of the body [n]\n",
  "ASPIRATORY": "of or pertaining to breathing; suited to the inhaling of air [adj]\n",
  "ASPIRE": "to aim for higher things [v ASPIRED, ASPIRING, ASPIRES]\n",
  "ASPIRED": "ASPIRE, to aim for higher things [v]\n",
  "ASPIRER": "one who aspires [n -S]\n",
  "ASPIRERS": "ASPIRER, one who aspires [n]\n",
  "ASPIRES": "ASPIRE, to aim for higher things [v]\n",
  "ASPIRIN": "a pain relieving drug [n -S]\n",
  "ASPIRING": "ASPIRE, to aim for higher things [v]\n",
  "ASPIRINGLY": "ASPIRING, ASPIRE, to aim for higher things [adv]\n",
  "ASPIRINGNESS": "the state of being aspiring [n -ES]\n",
  "ASPIRINGNESSES": "ASPIRINGNESS, the state of being aspiring [n]\n",
  "ASPIRINS": "ASPIRIN, a pain relieving drug [n]\n",
  "ASPIS": "a clear savoury meat or fish-jelly used as a glaze, also ASPIC [n -ES]\n",
  "ASPISES": "ASPIS, a clear savoury meat or fish-jelly used as a glaze, also ASPIC [n]\n",
  "ASPISH": "like an asp [adj]\n",
  "ASPLANCHNIC": "having no gut [adj]\n",
  "ASPLENIUM": "(Greek) a genus of fern, aka spleenwort [n -S]\n",
  "ASPLENIUMS": "ASPLENIUM, (Greek) a genus of fern, aka spleenwort [n]\n",
  "ASPORT": "to carry away, especially wrongfully [v -ED, -ING, -S]\n",
  "ASPORTATION": "the act of carrying property away wrongfully [n -S]\n",
  "ASPORTATIONS": "ASPORTATION, the act of carrying property away wrongfully [n]\n",
  "ASPORTED": "ASPORT, to carry away, especially wrongfully [v]\n",
  "ASPORTING": "ASPORT, to carry away, especially wrongfully [v]\n",
  "ASPORTS": "ASPORT, to carry away, especially wrongfully [v]\n",
  "ASPOUT": "(archaic) in a spouting way [adv]\n",
  "ASPRAWL": "in a sprawl [adv]\n",
  "ASPREAD": "(archaic) in a spreading state [adv]\n",
  "ASPRO": "(Australian slang) an associate professor [n -S]\n",
  "ASPROS": "ASPRO, (Australian slang) an associate professor [n]\n",
  "ASPROUT": "(archaic) in a sprouting state [adv]\n",
  "ASPS": "ASP, a venomous snake, also ASPICK [n]\n",
  "ASQUAT": "(archaic) in a squatting position [adv]\n",
  "ASQUINT": "obliquely, with a squint [adv]\n",
  "ASRAMA": "(Sanskrit) the dwelling of a Hindu religious philosopher, also ASHRAM [n -S]\n",
  "ASRAMAS": "ASRAMA, (Sanskrit) the dwelling of a Hindu religious philosopher, also ASHRAM [n]\n",
  "ASS": "a longhaired animal like a small horse; a stupid person [n -ES]\n",
  "ASSAFETIDA": "an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFETIDA, ASAFOETIDA, ASSAFOETIDA [n -S]\n",
  "ASSAFETIDAS": "ASSAFETIDA, an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFETIDA, ASAFOETIDA, ASSAFOETIDA [n]\n",
  "ASSAFOETIDA": "an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFETIDA, ASAFOETIDA, ASSAFETIDA [n -S]\n",
  "ASSAFOETIDAS": "ASSAFOETIDA, an acrid gum resin with a strong smell like that of garlic, obtained from certain Asian plants, also ASAFETIDA, ASAFOETIDA, ASSAFETIDA [n]\n",
  "ASSAGAI": "(Arabic) to pierce with a light spear, also ASSEGAAI [v -ED, -ING, -S]\n",
  "ASSAGAIED": "ASSAGAI, (Arabic) to pierce with a light spear, also ASSEGAAI [v]\n",
  "ASSAGAIING": "ASSAGAI, (Arabic) to pierce with a light spear, also ASSEGAAI [v]\n",
  "ASSAGAIS": "ASSAGAI, (Arabic) to pierce with a light spear, also ASSEGAAI [v]\n",
  "ASSAI": "(Tupi) a berry found in the Brazilian rainforest, aka palm berry, also ACAI [n -S]\n",
  "ASSAIL": "to attack [v -ED, -ING, -S]\n",
  "ASSAILABLE": "that can be assailed [adj]\n",
  "ASSAILANT": "one who assails [n -S]\n",
  "ASSAILANTS": "ASSAILANT, one who assails [n]\n",
  "ASSAILED": "ASSAIL, to attack [v]\n",
  "ASSAILER": "one who assails [n -S]\n",
  "ASSAILERS": "ASSAILER, one who assails [n]\n",
  "ASSAILING": "ASSAIL, to attack [v]\n",
  "ASSAILMENT": "the act or power of assailing [n -S]\n",
  "ASSAILMENTS": "ASSAILMENT, the act or power of assailing [n]\n",
  "ASSAILS": "ASSAIL, to attack [v]\n",
  "ASSAIS": "ASSAI, (Tupi) a berry found in the Brazilian rainforest, aka palm berry, also ACAI [n]\n",
  "ASSAM": "(Malay) in Malaysia, tamarind as used in cooking [n -S]\n",
  "ASSAMS": "ASSAM, (Malay) in Malaysia, tamarind as used in cooking [n]\n",
  "ASSART": "(historical) to reclaim for agriculture by clearing away trees [v -ED, -ING, -S]\n",
  "ASSARTED": "ASSART, (historical) to reclaim for agriculture by clearing away trees [v]\n",
  "ASSARTING": "ASSART, (historical) to reclaim for agriculture by clearing away trees [v]\n",
  "ASSARTS": "ASSART, (historical) to reclaim for agriculture by clearing away trees [v]\n",
  "ASSASSIN": "a murderer [n -S]\n",
  "ASSASSINATE": "to murder by secret assault [v ASSASSINATED, ASSASSINATING, ASSASSINATES]\n",
  "ASSASSINATED": "ASSASSINATE, to murder by secret assault [v]\n",
  "ASSASSINATES": "ASSASSINATE, to murder by secret assault [v]\n",
  "ASSASSINATING": "ASSASSINATE, to murder by secret assault [v]\n",
  "ASSASSINATION": "the act of assassinating [n -S]\n",
  "ASSASSINATIONS": "ASSASSINATION, the act of assassinating [n]\n",
  "ASSASSINATOR": "one who assassinates [n -S]\n",
  "ASSASSINATORS": "ASSASSINATOR, one who assassinates [n]\n",
  "ASSASSINS": "ASSASSIN, a murderer [n]\n",
  "ASSAULT": "to attack [v -ED, -ING, -S]\n",
  "ASSAULTED": "ASSAULT, to attack [v]\n",
  "ASSAULTER": "one who assaults [n -S]\n",
  "ASSAULTERS": "ASSAULTER, one who assaults [n]\n",
  "ASSAULTING": "ASSAULT, to attack [v]\n",
  "ASSAULTIVE": "relating to assault [adj ASSAULTIVELY]\n",
  "ASSAULTIVELY": "ASSAULTIVE, relating to assault [adv]\n",
  "ASSAULTIVENESS": "the state of being assaultive [n]\n",
  "ASSAULTS": "ASSAULT, to attack [v]\n",
  "ASSAY": "to put to the proof, to make trial of [v -ED, -ING, -S]\n",
  "ASSAYABLE": "that may be assayed [adj]\n",
  "ASSAYED": "ASSAY, to put to the proof, to make trial of [v]\n",
  "ASSAYER": "one that assays [n -S]\n",
  "ASSAYERS": "ASSAYER, one that assays [n]\n",
  "ASSAYING": "the act of testing [n -S]\n",
  "ASSAYINGS": "ASSAYING, the act of testing [n]\n",
  "ASSAYS": "ASSAY, to put to the proof, to make trial of [v]\n",
  "ASSEGAAI": "(Arabic) to kill or stab with a kind of spear, also ASSAGAI, ASSEGAI [v -ED, -ING, -S]\n",
  "ASSEGAAIED": "ASSEGAAI, (Arabic) to kill or stab with a kind of spear, also ASSAGAI, ASSEGAI [v]\n",
  "ASSEGAAIING": "ASSEGAAI, (Arabic) to kill or stab with a kind of spear, also ASSAGAI, ASSEGAI [v]\n",
  "ASSEGAAIS": "ASSEGAAI, (Arabic) to kill or stab with a kind of spear, also ASSAGAI, ASSEGAI [v]\n",
  "ASSEGAI": "(Arabic) to pierce with a light spear, also ASSAGAI [v -ED, -ING, -S]\n",
  "ASSEGAIED": "ASSEGAI, (Arabic) to pierce with a light spear, also ASSAGAI [v]\n",
  "ASSEGAIING": "ASSEGAI, (Arabic) to pierce with a light spear, also ASSAGAI [v]\n",
  "ASSEGAIS": "ASSEGAI, (Arabic) to pierce with a light spear, also ASSAGAI [v]\n",
  "ASSEMBLAGE": "(French) the collection of minerals that characterize a rock or a facies [n -S]\n",
  "ASSEMBLAGES": "ASSEMBLAGE, (French) the collection of minerals that characterize a rock or a facies [n]\n",
  "ASSEMBLAGIST": "an artist who specializes in assemblages [n -S]\n",
  "ASSEMBLAGISTS": "ASSEMBLAGIST, an artist who specializes in assemblages [n]\n",
  "ASSEMBLANCE": "(Spenser) an assembly, also ASSEMBLAUNCE [n -S]\n",
  "ASSEMBLANCES": "ASSEMBLANCE, (Spenser) an assembly, also ASSEMBLAUNCE [n]\n",
  "ASSEMBLAUNCE": "(Spenser) an assembly, also ASSEMBLANCE [n -S]\n",
  "ASSEMBLAUNCES": "ASSEMBLAUNCE, (Spenser) an assembly, also ASSEMBLANCE [n]\n",
  "ASSEMBLE": "to collect together [v ASSEMBLED, ASSEMBLING, ASSEMBLES]\n",
  "ASSEMBLED": "ASSEMBLE, to collect together [v]\n",
  "ASSEMBLER": "a type of computer program that converts a program written in assembly language to machine code [n -S]\n",
  "ASSEMBLERS": "ASSEMBLER, a type of computer program that converts a program written in assembly language to machine code [n]\n",
  "ASSEMBLES": "ASSEMBLE, to collect together [v]\n",
  "ASSEMBLIES": "ASSEMBLY, the act of assembling [n]\n",
  "ASSEMBLING": "ASSEMBLE, to collect together [v]\n",
  "ASSEMBLY": "the act of assembling [n ASSEMBLIES]\n",
  "ASSEMBLYMAN": "a member of an assembly [n ASSEMBLYMEN]\n",
  "ASSEMBLYMEN": "ASSEMBLYMAN, a member of an assembly [n]\n",
  "ASSEMBLYWOMAN": "a female member of an assembly [n ASSEMBLYWOMEN]\n",
  "ASSEMBLYWOMEN": "ASSEMBLYWOMAN, a female member of an assembly [n]\n",
  "ASSENT": "to express agreement [v -ED, -ING, -S]\n",
  "ASSENTANEOUS": "acquiescent [adj]\n",
  "ASSENTATION": "obsequious assent [n -S]\n",
  "ASSENTATIONS": "ASSENTATION, obsequious assent [n]\n",
  "ASSENTATOR": "a flatterer; one assenting insincerely or conniving [n -S]\n",
  "ASSENTATORS": "ASSENTATOR, a flatterer; one assenting insincerely or conniving [n]\n",
  "ASSENTED": "ASSENT, to express agreement [v]\n",
  "ASSENTER": "one who agrees, also ASSENTOR [n -S]\n",
  "ASSENTERS": "ASSENTER, one who agrees, also ASSENTOR [n]\n",
  "ASSENTIENT": "assenting [adj] / one who assents [n -S]\n",
  "ASSENTIENTS": "ASSENTIENT, one who assents [n]\n",
  "ASSENTING": "ASSENT, to express agreement [v]\n",
  "ASSENTINGLY": "ASSENTING, ASSENT, to express agreement [adv]\n",
  "ASSENTIVE": "giving assent [adj]\n",
  "ASSENTIVENESS": "the state of being assentive [n -ES]\n",
  "ASSENTIVENESSES": "ASSENTIVENESS, the state of being assentive [n]\n",
  "ASSENTOR": "one who agrees, also ASSENTER [n -S]\n",
  "ASSENTORS": "ASSENTOR, one who agrees, also ASSENTER [n]\n",
  "ASSENTS": "ASSENT, to express agreement [v]\n",
  "ASSERT": "to state positively [v -ED, -ING, -S]\n",
  "ASSERTABLE": "that can be asserted, also ASSERTIBLE [adj]\n",
  "ASSERTED": "ASSERT, to state positively [v]\n",
  "ASSERTEDLY": "ASSERTED, ASSERT, to state positively [adv]\n",
  "ASSERTER": "one who asserts, also ASSERTOR [n -S]\n",
  "ASSERTERS": "ASSERTER, one who asserts, also ASSERTOR [n]\n",
  "ASSERTIBLE": "that can be asserted, also ASSERTABLE [adj]\n",
  "ASSERTING": "ASSERT, to state positively [v]\n",
  "ASSERTION": "the act of asserting [n -S]\n",
  "ASSERTIONS": "ASSERTION, the act of asserting [n]\n",
  "ASSERTIVE": "given to assertion [adj ASSERTIVELY]\n",
  "ASSERTIVELY": "ASSERTIVE, given to assertion [adv]\n",
  "ASSERTIVENESS": "the state of being assertive [n -ES]\n",
  "ASSERTIVENESSES": "ASSERTIVENESS, the state of being assertive [n]\n",
  "ASSERTOR": "one who asserts, also ASSERTER [n -S]\n",
  "ASSERTORIC": "of a statement, stating a fact, as opposed to expressing an evaluative judgment [adj]\n",
  "ASSERTORS": "ASSERTOR, one who asserts, also ASSERTER [n]\n",
  "ASSERTORY": "affirmative [adj]\n",
  "ASSERTS": "ASSERT, to state positively [v]\n",
  "ASSES": "ASS, a longhaired animal like a small horse; a stupid person [n]\n",
  "ASSESS": "to estimate the value of for taxation [v -ED, -ING, -ES]\n",
  "ASSESSABLE": "liable to be assessed or taxed; as, assessable property [adj]\n",
  "ASSESSED": "ASSESS, to estimate the value of for taxation [v]\n",
  "ASSESSES": "ASSESS, to estimate the value of for taxation [v]\n",
  "ASSESSING": "ASSESS, to estimate the value of for taxation [v]\n",
  "ASSESSMENT": "the act of assessing [n -S]\n",
  "ASSESSMENTS": "ASSESSMENT, the act of assessing [n]\n",
  "ASSESSOR": "one who assesses [n -S]\n",
  "ASSESSORIAL": "relating to an assessor [adj]\n",
  "ASSESSORS": "ASSESSOR, one who assesses [n]\n",
  "ASSESSORSHIP": "the office of assessor [n -S]\n",
  "ASSESSORSHIPS": "ASSESSORSHIP, the office of assessor [n]\n",
  "ASSET": "an item of worth [n -S]\n",
  "ASSETLESS": "without assets [adj]\n",
  "ASSETS": "ASSET, an item of worth [n]\n",
  "ASSEVER": "to solemnly declare [v -ED, -ING, -S]\n",
  "ASSEVERATE": "to state positively, emphatically, also ASSEVER [v ASSEVERATED, ASSEVERATING, ASSEVERATES]\n",
  "ASSEVERATED": "ASSEVERATE, to state positively, emphatically, also ASSEVER [v]\n",
  "ASSEVERATES": "ASSEVERATE, to state positively, emphatically, also ASSEVER [v]\n",
  "ASSEVERATING": "ASSEVERATE, to state positively, emphatically, also ASSEVER [v]\n",
  "ASSEVERATINGLY": "ASSEVERATING, ASSEVERATE, to state positively, emphatically, also ASSEVER [adv]\n",
  "ASSEVERATION": "an earnest affirmation [n -S]\n",
  "ASSEVERATIONS": "ASSEVERATION, an earnest affirmation [n]\n",
  "ASSEVERATIVE": "relating to asseveration [adj]\n",
  "ASSEVERED": "ASSEVER, to solemnly declare [v]\n",
  "ASSEVERING": "ASSEVER, to solemnly declare [v]\n",
  "ASSEVERS": "ASSEVER, to solemnly declare [v]\n",
  "ASSEZ": "(French) as part of a musical direction, fairly, e.g. assez lent: fairly slowly [adv]\n",
  "ASSHOLE": "(offensive) an unpleasant and/or stupid person, also ARSEHOLE [n -S]\n",
  "ASSHOLES": "ASSHOLE, (offensive) an unpleasant and/or stupid person, also ARSEHOLE [n]\n",
  "ASSIBILATE": "to pronounce with a hiss or sibilant [v ASSIBILATED, ASSIBILATING, ASSIBILATES]\n",
  "ASSIBILATED": "ASSIBILATE, to pronounce with a hiss or sibilant [v]\n",
  "ASSIBILATES": "ASSIBILATE, to pronounce with a hiss or sibilant [v]\n",
  "ASSIBILATING": "ASSIBILATE, to pronounce with a hiss or sibilant [v]\n",
  "ASSIBILATION": "speaking with a sibilant sound [n -S]\n",
  "ASSIBILATIONS": "ASSIBILATION, speaking with a sibilant sound [n]\n",
  "ASSIDUITIES": "ASSIDUITY, persevering application to a pursuit [n]\n",
  "ASSIDUITY": "persevering application to a pursuit [n ASSIDUITIES]\n",
  "ASSIDUOUS": "diligent; persistent [adj ASSIDUOUSLY]\n",
  "ASSIDUOUSLY": "ASSIDUOUS, diligent; persistent [adv]\n",
  "ASSIDUOUSNESS": "the state of being assiduous [n -ES]\n",
  "ASSIDUOUSNESSES": "ASSIDUOUSNESS, the state of being assiduous [n]\n",
  "ASSIEGE": "(Spenser) to besiege [v ASSIEGED, ASSIEGING, ASSIEGES]\n",
  "ASSIEGED": "ASSIEGE, (Spenser) to besiege [v]\n",
  "ASSIEGES": "ASSIEGE, (Spenser) to besiege [v]\n",
  "ASSIEGING": "ASSIEGE, (Spenser) to besiege [v]\n",
  "ASSIENTO": "(Spanish) a treaty, esp. that between Spain and Britain, 1713 for the supply of African slaves for Spanish American dominions [n -S]\n",
  "ASSIENTOS": "ASSIENTO, (Spanish) a treaty, esp. that between Spain and Britain, 1713 for the supply of African slaves for Spanish American dominions [n]\n",
  "ASSIGN": "to set apart for a particular purpose [v -ED, -ING, -S]\n",
  "ASSIGNABILITIES": "ASSIGNABILITY, the quality of being assignable [n]\n",
  "ASSIGNABILITY": "the quality of being assignable [n ASSIGNABILITIES]\n",
  "ASSIGNABLE": "that can be assigned [adj]\n",
  "ASSIGNABLY": "ASSIGNABLE, that can be assigned [adv]\n",
  "ASSIGNAT": "(historical) one of the paper bonds first issued in 1789 by the French government on the security of the appropriated church lands, and later accepted as notes of currency [n -S]\n",
  "ASSIGNATION": "the act of assigning or the assignment made [n -S]\n",
  "ASSIGNATIONS": "ASSIGNATION, the act of assigning or the assignment made [n]\n",
  "ASSIGNATS": "ASSIGNAT, (historical) one of the paper bonds first issued in 1789 by the French government on the security of the appropriated church lands, and later accepted as notes of currency [n]\n",
  "ASSIGNED": "ASSIGN, to set apart for a particular purpose [v]\n",
  "ASSIGNEE": "one to whom property is allotted [n -S]\n",
  "ASSIGNEES": "ASSIGNEE, one to whom property is allotted [n]\n",
  "ASSIGNER": "a person who transfers a right or asset under an assignment, also ASSIGNOR [n -S]\n",
  "ASSIGNERS": "ASSIGNER, a person who transfers a right or asset under an assignment, also ASSIGNOR [n]\n",
  "ASSIGNING": "ASSIGN, to set apart for a particular purpose [v]\n",
  "ASSIGNMENT": "the act of assigning [n -S]\n",
  "ASSIGNMENTS": "ASSIGNMENT, the act of assigning [n]\n",
  "ASSIGNOR": "a person who transfers a right or asset under an assignment, also ASSIGNER [n -S]\n",
  "ASSIGNORS": "ASSIGNOR, a person who transfers a right or asset under an assignment, also ASSIGNER [n]\n",
  "ASSIGNS": "ASSIGN, to set apart for a particular purpose [v]\n",
  "ASSIMILABILITY": "the state of being assimilable [n]\n",
  "ASSIMILABLE": "that can be assimilated [adj ASSIMILABLY]\n",
  "ASSIMILABLY": "ASSIMILABLE, that can be assimilated [adv]\n",
  "ASSIMILATE": "to make or be like [v ASSIMILATED, ASSIMILATING, ASSIMILATES]\n",
  "ASSIMILATED": "ASSIMILATE, to make or be like [v]\n",
  "ASSIMILATES": "ASSIMILATE, to make or be like [v]\n",
  "ASSIMILATING": "ASSIMILATE, to make or be like [v]\n",
  "ASSIMILATION": "the act of assimilating [n -S]\n",
  "ASSIMILATIONISM": "a policy of assimilation, esp. of racial groups [n]\n",
  "ASSIMILATIONIST": "a person who advocates a policy of assimilating differing racial or cultural groups [n]\n",
  "ASSIMILATIONS": "ASSIMILATION, the act of assimilating [n]\n",
  "ASSIMILATIVE": "of, relating to, or causing assimilation [adj ASSIMILATIVELY]\n",
  "ASSIMILATIVELY": "ASSIMILATIVE, of, relating to, or causing assimilation [adv]\n",
  "ASSIMILATOR": "one who assimilates [n -S]\n",
  "ASSIMILATORS": "ASSIMILATOR, one who assimilates [n]\n",
  "ASSIMILATORY": "tending to assimilate [adj]\n",
  "ASSIST": "to give aid or support to [v -ED, -ING, -S]\n",
  "ASSISTANCE": "the act of assisting or the help supplied [n -S]\n",
  "ASSISTANCES": "ASSISTANCE, the act of assisting or the help supplied [n]\n",
  "ASSISTANT": "one who assists [n -S]\n",
  "ASSISTANTS": "ASSISTANT, one who assists [n]\n",
  "ASSISTANTSHIP": "the post of assistant [n -S]\n",
  "ASSISTANTSHIPS": "ASSISTANTSHIP, the post of assistant [n]\n",
  "ASSISTED": "ASSIST, to give aid or support to [v]\n",
  "ASSISTER": "one who assists, also ASSISTOR [n -S]\n",
  "ASSISTERS": "ASSISTER, one who assists, also ASSISTOR [n]\n",
  "ASSISTING": "ASSIST, to give aid or support to [v]\n",
  "ASSISTIVE": "providing a means of reducing a physical impairment [adj]\n",
  "ASSISTOR": "one who assists, also ASSISTER [n -S]\n",
  "ASSISTORS": "ASSISTOR, one who assists, also ASSISTER [n]\n",
  "ASSISTS": "ASSIST, to give aid or support to [v]\n",
  "ASSIZE": "a legislative session, dealing e.g. with weights, measures, and prices [n -S] / (obsolete) to assess, to fix the quantity of [v ASSIZED, ASSIZING, ASSIZES]\n",
  "ASSIZED": "ASSIZE, (obsolete) to assess, to fix the quantity of [v]\n",
  "ASSIZER": "an officer in charge of weights and measures [n -S]\n",
  "ASSIZERS": "ASSIZER, an officer in charge of weights and measures [n]\n",
  "ASSIZES": "ASSIZE, (obsolete) to assess, to fix the quantity of [v]\n",
  "ASSIZING": "ASSIZE, (obsolete) to assess, to fix the quantity of [v]\n",
  "ASSLIKE": "like an ass [adj]\n",
  "ASSOCIABILITIES": "ASSOCIABILITY, the quality of being associable [n]\n",
  "ASSOCIABILITY": "the quality of being associable [n ASSOCIABILITIES]\n",
  "ASSOCIABLE": "capable of being associated or joined [adj]\n",
  "ASSOCIATE": "to join, connect [v ASSOCIATED, ASSOCIATING, ASSOCIATES]\n",
  "ASSOCIATED": "ASSOCIATE, to join, connect [v]\n",
  "ASSOCIATES": "ASSOCIATE, to join, connect [v]\n",
  "ASSOCIATESHIP": "the post of associate [n -S]\n",
  "ASSOCIATESHIPS": "ASSOCIATESHIP, the post of associate [n]\n",
  "ASSOCIATING": "ASSOCIATE, to join, connect [v]\n",
  "ASSOCIATION": "the act of associating [n -S]\n",
  "ASSOCIATIONAL": "relating to association [adj]\n",
  "ASSOCIATIONISM": "the theory which considers association of ideas to be the basis of all mental activity [n -S]\n",
  "ASSOCIATIONISMS": "ASSOCIATIONISM, the theory which considers association of ideas to be the basis of all mental activity [n]\n",
  "ASSOCIATIONIST": "one who believes in the theory of associationism [n -S]\n",
  "ASSOCIATIONISTS": "ASSOCIATIONIST, one who believes in the theory of associationism [n]\n",
  "ASSOCIATIONS": "ASSOCIATION, the act of associating [n]\n",
  "ASSOCIATIVE": "of or relating to association esp. of ideas or images [adj ASSOCIATIVELY]\n",
  "ASSOCIATIVELY": "ASSOCIATIVE, of or relating to association esp. of ideas or images [adv]\n",
  "ASSOCIATIVITIES": "ASSOCIATIVITY, the quality of being associative [n]\n",
  "ASSOCIATIVITY": "the quality of being associative [n ASSOCIATIVITIES]\n",
  "ASSOCIATOR": "one who associates [n -S]\n",
  "ASSOCIATORS": "ASSOCIATOR, one who associates [n]\n",
  "ASSOCIATORY": "characterized by or causing or resulting from association [adj]\n",
  "ASSOIL": "to absolve, acquit [v -ED, -ING, -S]\n",
  "ASSOILED": "ASSOIL, to absolve, acquit [v]\n",
  "ASSOILING": "ASSOIL, to absolve, acquit [v]\n",
  "ASSOILMENT": "(archaic) absolution [n -S]\n",
  "ASSOILMENTS": "ASSOILMENT, (archaic) absolution [n]\n",
  "ASSOILS": "ASSOIL, to absolve, acquit [v]\n",
  "ASSOILZIE": "to absolve, to clear a defendant of a charge [v ASSOILZIED, ASSOILZIEING, ASSOILZIES]\n",
  "ASSOILZIED": "ASSOILZIE, to absolve, to clear a defendant of a charge [v]\n",
  "ASSOILZIEING": "ASSOILZIE, to absolve, to clear a defendant of a charge [v]\n",
  "ASSOILZIES": "ASSOILZIE, to absolve, to clear a defendant of a charge [v]\n",
  "ASSONANCE": "vowel-rhyme, coincidence of vowel sound without regard to consonants [n -S]\n",
  "ASSONANCES": "ASSONANCE, vowel-rhyme, coincidence of vowel sound without regard to consonants [n]\n",
  "ASSONANT": "corresponding in vowel sound, also ASSONANTAL [adj] / a word or syllable that resembles another in sound [n -S]\n",
  "ASSONANTAL": "corresponding in vowel sound, also ASSONANT [adj]\n",
  "ASSONANTS": "ASSONANT, a word or syllable that resembles another in sound [n]\n",
  "ASSONATE": "to match in a vowel sound [v ASSONATED, ASSONATING, ASSONATES]\n",
  "ASSONATED": "ASSONATE, to match in a vowel sound [v]\n",
  "ASSONATES": "ASSONATE, to match in a vowel sound [v]\n",
  "ASSONATING": "ASSONATE, to match in a vowel sound [v]\n",
  "ASSORT": "to distribute into groups according to kind or class [v -ED, -ING, -S]\n",
  "ASSORTATIVE": "denoting a nonrandom form of mating, e.g. by pollinating insects [adj ASSORTATIVELY]\n",
  "ASSORTATIVELY": "ASSORTATIVE, denoting a nonrandom form of mating, e.g. by pollinating insects [adv]\n",
  "ASSORTED": "ASSORT, to distribute into groups according to kind or class [v]\n",
  "ASSORTEDNESS": "the state of being assorted [n -ES]\n",
  "ASSORTEDNESSES": "ASSORTEDNESS, the state of being assorted [n]\n",
  "ASSORTER": "one who assorts [n -S]\n",
  "ASSORTERS": "ASSORTER, one who assorts [n]\n",
  "ASSORTING": "ASSORT, to distribute into groups according to kind or class [v]\n",
  "ASSORTIVE": "tending to assort [adj]\n",
  "ASSORTMENT": "the act of assorting [n -S]\n",
  "ASSORTMENTS": "ASSORTMENT, the act of assorting [n]\n",
  "ASSORTS": "ASSORT, to distribute into groups according to kind or class [v]\n",
  "ASSOT": "to make a fool of [v ASSOTTED, ASSOTTING, ASSOTS]\n",
  "ASSOTS": "ASSOT, to make a fool of [v]\n",
  "ASSOTT": "(Spenser) infatuated [adj]\n",
  "ASSOTTED": "ASSOT, to make a fool of [v]\n",
  "ASSOTTING": "ASSOT, to make a fool of [v]\n",
  "ASSUAGE": "to make less severe, also ASSWAGE [v ASSUAGED, ASSUAGING, ASSUAGES]\n",
  "ASSUAGED": "ASSUAGE, to make less severe, also ASSWAGE [v]\n",
  "ASSUAGEMENT": "the act of assuaging [n -S]\n",
  "ASSUAGEMENTS": "ASSUAGEMENT, the act of assuaging [n]\n",
  "ASSUAGER": "one who assuages [n -S]\n",
  "ASSUAGERS": "ASSUAGER, one who assuages [n]\n",
  "ASSUAGES": "ASSUAGE, to make less severe, also ASSWAGE [v]\n",
  "ASSUAGING": "the act of making less severe [n -S]\n",
  "ASSUAGINGS": "ASSUAGING, the act of making less severe [n]\n",
  "ASSUASIVE": "mitigating, soothing [adj]\n",
  "ASSUBJUGATE": "(Shakespeare) to reduce to subjection [v ASSUBJUGATED, ASSUBJUGATING, ASSUBJUGATES]\n",
  "ASSUBJUGATED": "ASSUBJUGATE, (Shakespeare) to reduce to subjection [v]\n",
  "ASSUBJUGATES": "ASSUBJUGATE, (Shakespeare) to reduce to subjection [v]\n",
  "ASSUBJUGATING": "ASSUBJUGATE, (Shakespeare) to reduce to subjection [v]\n",
  "ASSUEFACTION": "(obsolete) habituation [n -S]\n",
  "ASSUEFACTIONS": "ASSUEFACTION, (obsolete) habituation [n]\n",
  "ASSUETUDE": "accustomedness; habit [n -S]\n",
  "ASSUETUDES": "ASSUETUDE, accustomedness; habit [n]\n",
  "ASSUMABILITIES": "ASSUMABILITY, the capacity to be assumed [n]\n",
  "ASSUMABILITY": "the capacity to be assumed [n ASSUMABILITIES]\n",
  "ASSUMABLE": "that may be assumed [adj ASSUMABLY]\n",
  "ASSUMABLY": "ASSUMABLE, that may be assumed [adv]\n",
  "ASSUME": "to take for granted [v ASSUMED, ASSUMING, ASSUMES]\n",
  "ASSUMED": "ASSUME, to take for granted [v]\n",
  "ASSUMEDLY": "ASSUMED, ASSUME, to take for granted [adv]\n",
  "ASSUMER": "one who assumes or arrogates [n -S]\n",
  "ASSUMERS": "ASSUMER, one who assumes or arrogates [n]\n",
  "ASSUMES": "ASSUME, to take for granted [v]\n",
  "ASSUMING": "the act of making an assumption [n -S]\n",
  "ASSUMINGLY": "ASSUMING [adv]\n",
  "ASSUMINGS": "ASSUMING, the act of making an assumption [n]\n",
  "ASSUMPSIT": "(Latin) a contract (not under seal); a suit for breach of such a contract [n -S]\n",
  "ASSUMPSITS": "ASSUMPSIT, (Latin) a contract (not under seal); a suit for breach of such a contract [n]\n",
  "ASSUMPTION": "the taking up of a person into heaven [n -S]\n",
  "ASSUMPTIONS": "ASSUMPTION, the taking up of a person into heaven [n]\n",
  "ASSUMPTIVE": "assumed, or capable of being assumed [adj ASSUMPTIVELY]\n",
  "ASSUMPTIVELY": "ASSUMPTIVE, assumed, or capable of being assumed [adv]\n",
  "ASSURABLE": "capable of being assured [adj]\n",
  "ASSURANCE": "confidence, a feeling of certainty, also SURANCE [n -S]\n",
  "ASSURANCES": "ASSURANCE, confidence, a feeling of certainty, also SURANCE [n]\n",
  "ASSURE": "to insure; to assert as true [v ASSURED, ASSURING, ASSURES]\n",
  "ASSURED": "an insured person [n -S]\n",
  "ASSUREDLY": "ASSURED [adv]\n",
  "ASSUREDNESS": "the state of being assured [n -ES]\n",
  "ASSUREDNESSES": "ASSUREDNESS, the state of being assured [n]\n",
  "ASSUREDS": "ASSURED, an insured person [n]\n",
  "ASSURER": "one who assures, takes out assurance, also ASSUROR [n -S]\n",
  "ASSURERS": "ASSURER, one who assures, takes out assurance, also ASSUROR [n]\n",
  "ASSURES": "ASSURE, to insure; to assert as true [v]\n",
  "ASSURGENCIES": "ASSURGENCY, upward curving growth [n]\n",
  "ASSURGENCY": "upward curving growth [n ASSURGENCIES]\n",
  "ASSURGENT": "depicted as rising from the sea [adj]\n",
  "ASSURING": "ASSURE, to insure; to assert as true [v]\n",
  "ASSUROR": "one who assures, takes out assurance, also ASSURER [n -S]\n",
  "ASSURORS": "ASSUROR, one who assures, takes out assurance, also ASSURER [n]\n",
  "ASSWAGE": "(obsolete) to make less severe, also ASSUAGE [v ASSWAGED, ASSWAGING, ASSWAGES]\n",
  "ASSWAGED": "ASSWAGE, (obsolete) to make less severe, also ASSUAGE [v]\n",
  "ASSWAGES": "ASSWAGE, (obsolete) to make less severe, also ASSUAGE [v]\n",
  "ASSWAGING": "ASSWAGE, (obsolete) to make less severe, also ASSUAGE [v]\n",
  "ASSWIPE": "(US offensive) another term for arse [n -S]\n",
  "ASSWIPES": "ASSWIPE, (US offensive) another term for arse [n]\n",
  "ASSYTHMENT": "in Scots law, indemnification for injury; satisfaction [n -S]\n",
  "ASSYTHMENTS": "ASSYTHMENT, in Scots law, indemnification for injury; satisfaction [n]\n",
  "ASTABLE": "not stable [adj]\n",
  "ASTACOLOGICAL": "related to astacology [adj]\n",
  "ASTACOLOGIES": "ASTACOLOGY, the science of crayfish [n]\n",
  "ASTACOLOGIST": "a specialist in astacology, the breeding of crayfish [n -S]\n",
  "ASTACOLOGISTS": "ASTACOLOGIST, a specialist in astacology, the breeding of crayfish [n]\n",
  "ASTACOLOGY": "the science of crayfish [n ASTACOLOGIES]\n",
  "ASTANGA": "(Sanskrit) a form of yoga, also ASHTANGA, ASTHANGA [n -S]\n",
  "ASTANGAS": "ASTANGA, (Sanskrit) a form of yoga, also ASHTANGA, ASTHANGA [n]\n",
  "ASTARBOARD": "on or towards the starboard [adv]\n",
  "ASTARE": "(archaic) in a state of staring [adv]\n",
  "ASTART": "(Spenser) to start up, also ASTERT [v -ED, -ING, -S]\n",
  "ASTARTED": "ASTART, (Spenser) to start up, also ASTERT [v]\n",
  "ASTARTING": "ASTART, (Spenser) to start up, also ASTERT [v]\n",
  "ASTARTS": "ASTART, (Spenser) to start up, also ASTERT [v]\n",
  "ASTASIA": "the inability, due to imperfect muscular coordination, to keep erect [n -S]\n",
  "ASTASIAS": "ASTASIA, the inability, due to imperfect muscular coordination, to keep erect [n]\n",
  "ASTATIC": "having no tendency to stand in a fixed position [adj ASTATICALLY]\n",
  "ASTATICALLY": "ASTATIC, having no tendency to stand in a fixed position [adv]\n",
  "ASTATICISM": "the quality of being astatic, having no fixed position of stability [n -S]\n",
  "ASTATICISMS": "ASTATICISM, the quality of being astatic, having no fixed position of stability [n]\n",
  "ASTATIDE": "a compound of astatine [n -S]\n",
  "ASTATIDES": "ASTATIDE, a compound of astatine [n]\n",
  "ASTATINE": "a radioactive element of the halogen group [n -S]\n",
  "ASTATINES": "ASTATINE, a radioactive element of the halogen group [n]\n",
  "ASTATKI": "(Russian) the residue of petroleum distillation, used as fuel [n -S]\n",
  "ASTATKIS": "ASTATKI, (Russian) the residue of petroleum distillation, used as fuel [n]\n",
  "ASTEISM": "(Greek) refined irony [n -S]\n",
  "ASTEISMS": "ASTEISM, (Greek) refined irony [n]\n",
  "ASTELIC": "without a central column or stele [adj]\n",
  "ASTELIES": "ASTELY, the absence of a central cylinder or stele [n]\n",
  "ASTELY": "the absence of a central cylinder or stele [n ASTELIES]\n",
  "ASTER": "a plant of the Aster genus of Compositae, with large showy flowers [n -S]\n",
  "ASTEREOGNOSES": "ASTEREOGNOSIS, the inability to recognize objects by touch [n]\n",
  "ASTEREOGNOSIS": "the inability to recognize objects by touch [n ASTEREOGNOSES]\n",
  "ASTERIA": "a precious stone that shows asterism when cut en cabochon [n -S]\n",
  "ASTERIAS": "ASTERIA, a precious stone that shows asterism when cut en cabochon [n]\n",
  "ASTERIATED": "having starlike rays [adj]\n",
  "ASTERID": "a starfish, also ASTERIDIAN [n -S]\n",
  "ASTERIDIAN": "a starfish, also ASTERID [n -S]\n",
  "ASTERIDIANS": "ASTERIDIAN, a starfish, also ASTERID [n]\n",
  "ASTERIDS": "ASTERID, a starfish, also ASTERIDIAN [n]\n",
  "ASTERISK": "a star-shaped mark [n -S] / to mark with an asterisk [v -ED, -ING, -S]\n",
  "ASTERISKED": "ASTERISK, to mark with an asterisk [v]\n",
  "ASTERISKING": "ASTERISK, to mark with an asterisk [v]\n",
  "ASTERISKLESS": "without an asterisk [adj]\n",
  "ASTERISKS": "ASTERISK, to mark with an asterisk [v]\n",
  "ASTERISM": "a constellation of stars; a group of asterisks [n -S]\n",
  "ASTERISMS": "ASTERISM, a constellation of stars; a group of asterisks [n]\n",
  "ASTERN": "towards the stern [adj]\n",
  "ASTERNAL": "not sternal, said of ribs which do not join the sternum [adj]\n",
  "ASTEROID": "a rocky object, a type of celestial body [n -S]\n",
  "ASTEROIDAL": "of or pertaining to an asteroid, or to the asteroids [adj]\n",
  "ASTEROIDEAN": "an echinoderm of the class Asteroidea, comprising the starfishes [n -S]\n",
  "ASTEROIDEANS": "ASTEROIDEAN, an echinoderm of the class Asteroidea, comprising the starfishes [n]\n",
  "ASTEROIDS": "ASTEROID, a rocky object, a type of celestial body [n]\n",
  "ASTERS": "ASTER, a plant of the Aster genus of Compositae, with large showy flowers [n]\n",
  "ASTERT": "(obsolete) to start up, also ASTART [v -ED, -ING, -S]\n",
  "ASTERTED": "ASTERT, (obsolete) to start up, also ASTART [v]\n",
  "ASTERTING": "ASTERT, (obsolete) to start up, also ASTART [v]\n",
  "ASTERTS": "ASTERT, (obsolete) to start up, also ASTART [v]\n",
  "ASTHANGA": "(Sanskrit) a form of yoga, also ASHTANGA, ASTANGA [n -S]\n",
  "ASTHANGAS": "ASTHANGA, (Sanskrit) a form of yoga, also ASHTANGA, ASTANGA [n]\n",
  "ASTHENIA": "a lack of strength, also ASTHENY [n -S]\n",
  "ASTHENIAS": "ASTHENIA, a lack of strength, also ASTHENY [n]\n",
  "ASTHENIC": "a slender, lightly muscled person [n -S]\n",
  "ASTHENICS": "ASTHENIC, a slender, lightly muscled person [n]\n",
  "ASTHENIES": "ASTHENY, a lack of strength, also ASTHENIA [n]\n",
  "ASTHENOPIA": "eyestrain [n -S]\n",
  "ASTHENOPIAS": "ASTHENOPIA, eyestrain [n]\n",
  "ASTHENOPIC": "suffering from asthenopia, eyestrain [adj]\n",
  "ASTHENOSPHERE": "the upper layer of the earth's mantle, below the lithosphere, characterized by a relatively low resistance to plastic flow [n -S]\n",
  "ASTHENOSPHERES": "ASTHENOSPHERE, the upper layer of the earth's mantle, below the lithosphere, characterized by a relatively low resistance to plastic flow [n]\n",
  "ASTHENOSPHERIC": "relating to the asthenosphere [adj]\n",
  "ASTHENY": "a lack of strength, also ASTHENIA [n ASTHENIES]\n",
  "ASTHMA": "a chronic respiratory disorder [n -S]\n",
  "ASTHMAS": "ASTHMA, a chronic respiratory disorder [n]\n",
  "ASTHMATIC": "suffering from asthma [adj ASTHMATICALLY] / one suffering from asthma [n -S]\n",
  "ASTHMATICAL": "suffering from asthma [adj ASTHMATICALLY]\n",
  "ASTHMATICALLY": "ASTHMATICAL, suffering from asthma [adv]\n",
  "ASTHMATICS": "ASTHMATIC, one suffering from asthma [n]\n",
  "ASTHORE": "(Irish) darling [n -S]\n",
  "ASTHORES": "ASTHORE, (Irish) darling [n]\n",
  "ASTICHOUS": "not in rows [adj]\n",
  "ASTIGMATIC": "affected with, or pertaining to, astigmatism [adj ASTIGMATICALLY] / a person with astigmatism [n -S]\n",
  "ASTIGMATICALLY": "ASTIGMATIC, affected with, or pertaining to, astigmatism [adv]\n",
  "ASTIGMATICS": "ASTIGMATIC, a person with astigmatism [n]\n",
  "ASTIGMATISM": "a defect in the eye or a lens by which rays from a single source are not focused at a single point, also ASTIGMIA [n -S]\n",
  "ASTIGMATISMS": "ASTIGMATISM, a defect in the eye or a lens by which rays from a single source are not focused at a single point, also ASTIGMIA [n]\n",
  "ASTIGMIA": "a defect in the eye or a lens by which rays from a single source are not focused at a single point, also ASTIGMATISM [n -S]\n",
  "ASTIGMIAS": "ASTIGMIA, a defect in the eye or a lens by which rays from a single source are not focused at a single point, also ASTIGMATISM [n]\n",
  "ASTILBE": "a plant of the Astilbe genus of perennial plants, with clusters of usually red or white flowers [n -S]\n",
  "ASTILBES": "ASTILBE, a plant of the Astilbe genus of perennial plants, with clusters of usually red or white flowers [n]\n",
  "ASTIR": "on the move [adj]\n",
  "ASTOMATAL": "having no stomata [adj]\n",
  "ASTOMATOUS": "having no stomata, also ASTOMOUS [adj]\n",
  "ASTOMOUS": "having no mouthlike opening [adj]\n",
  "ASTONE": "to amaze or shock, also ASTONISH, ASTONY [v ASTONED, ASTONING, ASTONES]\n",
  "ASTONED": "ASTONE, to amaze or shock, also ASTONISH, ASTONY [v]\n",
  "ASTONES": "ASTONE, to amaze or shock, also ASTONISH, ASTONY [v]\n",
  "ASTONIED": "ASTONY, to amaze or shock, also ASTONISH, ASTONE [v]\n",
  "ASTONIES": "ASTONY, to amaze or shock, also ASTONISH, ASTONE [v]\n",
  "ASTONING": "ASTONE, to amaze or shock, also ASTONISH, ASTONY [v]\n",
  "ASTONISH": "to amaze or shock, also ASTONE, ASTONY [v -ED, -ING, -ES]\n",
  "ASTONISHED": "ASTONISH, to amaze or shock, also ASTONE, ASTONY [v]\n",
  "ASTONISHES": "ASTONISH, to amaze or shock, also ASTONE, ASTONY [v]\n",
  "ASTONISHING": "ASTONISH, to amaze or shock, also ASTONE, ASTONY [v]\n",
  "ASTONISHINGLY": "ASTONISHING, ASTONISH, to amaze or shock, also ASTONE, ASTONY [adv]\n",
  "ASTONISHMENT": "the state of being astonished [n -S]\n",
  "ASTONISHMENTS": "ASTONISHMENT, the state of being astonished [n]\n",
  "ASTONY": "to amaze or shock, also ASTONISH, ASTONE [v ASTONIED, ASTONYING, ASTONIES]\n",
  "ASTONYING": "ASTONY, to amaze or shock, also ASTONISH, ASTONE [v]\n",
  "ASTOOP": "(archaic) in a stooping or inclined position [adv]\n",
  "ASTOUND": "to amaze [v -ED, -ING, -S]\n",
  "ASTOUNDED": "ASTOUND, to amaze [v]\n",
  "ASTOUNDING": "ASTOUND, to amaze [v]\n",
  "ASTOUNDINGLY": "ASTOUNDING, ASTOUND, to amaze [adv]\n",
  "ASTOUNDMENT": "(archaic) great surprise [n -S]\n",
  "ASTOUNDMENTS": "ASTOUNDMENT, (archaic) great surprise [n]\n",
  "ASTOUNDS": "ASTOUND, to amaze [v]\n",
  "ASTRACHAN": "a closely-curled black or grey fur from the fleece of karakul lambs, also ASTRAKHAN [n -S]\n",
  "ASTRACHANS": "ASTRACHAN, a closely-curled black or grey fur from the fleece of karakul lambs, also ASTRAKHAN [n]\n",
  "ASTRADDLE": "in a straddling position [adv]\n",
  "ASTRAGAL": "(Greek) a rounded beading or moulding on column [n -S]\n",
  "ASTRAGALI": "ASTRAGALUS, (Latin) the anklebone [n]\n",
  "ASTRAGALS": "ASTRAGAL, (Greek) a rounded beading or moulding on column [n]\n",
  "ASTRAGALUS": "(Latin) the anklebone [n ASTRAGALI]\n",
  "ASTRAKHAN": "a closely-curled black or grey fur from the fleece of karakul lambs, also ASTRACHAN [n -S]\n",
  "ASTRAKHANS": "ASTRAKHAN, a closely-curled black or grey fur from the fleece of karakul lambs, also ASTRACHAN [n]\n",
  "ASTRAL": "related to stars [adj ASTRALLY] / a type of oil lamp [n -S]\n",
  "ASTRALLY": "ASTRAL, related to stars [adv]\n",
  "ASTRALS": "ASTRAL, a type of oil lamp [n]\n",
  "ASTRAND": "on the strand [adv]\n",
  "ASTRANTIA": "a plant of the Astrantia genus of hardy, perennial umbelliferous plants with showy petallike bracts [n -S]\n",
  "ASTRANTIAS": "ASTRANTIA, a plant of the Astrantia genus of hardy, perennial umbelliferous plants with showy petallike bracts [n]\n",
  "ASTRAPHOBIA": "a morbid fear of thunder and lightning, also ASTRAPOPHOBIA, ASTROPHOBIA [n -S]\n",
  "ASTRAPHOBIAS": "ASTRAPHOBIA, a morbid fear of thunder and lightning, also ASTRAPOPHOBIA, ASTROPHOBIA [n]\n",
  "ASTRAPHOBIC": "suffering from astraphobia, a morbid fear of thunder and lightning, also ASTROPHOBIC [adj]\n",
  "ASTRAPOPHOBIA": "a morbid fear of thunder and lightning, also ASTRAPHOBIA, ASTROPHOBIA [n -S]\n",
  "ASTRAPOPHOBIAS": "ASTRAPOPHOBIA, a morbid fear of thunder and lightning, also ASTRAPHOBIA, ASTROPHOBIA [n]\n",
  "ASTRAY": "off course [adv]\n",
  "ASTRICT": "(archaic) to bind, constrict; to bind by moral or legal obligation [v -ED, -ING, -S]\n",
  "ASTRICTED": "ASTRICT, (archaic) to bind, constrict; to bind by moral or legal obligation [v]\n",
  "ASTRICTING": "ASTRICT, (archaic) to bind, constrict; to bind by moral or legal obligation [v]\n",
  "ASTRICTION": "a binding obligation [n -S]\n",
  "ASTRICTIONS": "ASTRICTION, a binding obligation [n]\n",
  "ASTRICTIVE": "binding; astringent [adj ASTRICTIVELY]\n",
  "ASTRICTIVELY": "ASTRICTIVE, binding; astringent [adv]\n",
  "ASTRICTS": "ASTRICT, (archaic) to bind, constrict; to bind by moral or legal obligation [v]\n",
  "ASTRIDE": "with a leg on each side [adv]\n",
  "ASTRINGE": "to draw together [v ASTRINGED, ASTRINGING, ASTRINGES]\n",
  "ASTRINGED": "ASTRINGE, to draw together [v]\n",
  "ASTRINGENCE": "being astringent, also ASTRINGENCY [n -S]\n",
  "ASTRINGENCES": "ASTRINGENCE, being astringent, also ASTRINGENCY [n]\n",
  "ASTRINGENCIES": "ASTRINGENCY, being astringent, also ASTRINGENCE [n]\n",
  "ASTRINGENCY": "being astringent, also ASTRINGENCE [n ASTRINGENCIES]\n",
  "ASTRINGENT": "contracting, drawing together [adj ASTRINGENTLY] / an astringent agent or substance [n -S]\n",
  "ASTRINGENTLY": "ASTRINGENT, contracting, drawing together [adv]\n",
  "ASTRINGENTS": "ASTRINGENT, an astringent agent or substance [n]\n",
  "ASTRINGER": "a falconer who keeps a goshawk, also AUSTRINGER, OSTREGER [n -S]\n",
  "ASTRINGERS": "ASTRINGER, a falconer who keeps a goshawk, also AUSTRINGER, OSTREGER [n]\n",
  "ASTRINGES": "ASTRINGE, to draw together [v]\n",
  "ASTRINGING": "ASTRINGE, to draw together [v]\n",
  "ASTROBIOLOGIES": "ASTROBIOLOGY, exobiology [n]\n",
  "ASTROBIOLOGIST": "one who studies astrobiology [n -S]\n",
  "ASTROBIOLOGISTS": "ASTROBIOLOGIST, one who studies astrobiology [n]\n",
  "ASTROBIOLOGY": "exobiology [n ASTROBIOLOGIES]\n",
  "ASTROBLEME": "the wound left by a meteorite strike [n -S]\n",
  "ASTROBLEMES": "ASTROBLEME, the wound left by a meteorite strike [n]\n",
  "ASTROBOTANIES": "ASTROBOTANY, the branch of botany that investigates the possibility that plants grow on other planets [n]\n",
  "ASTROBOTANY": "the branch of botany that investigates the possibility that plants grow on other planets [n ASTROBOTANIES]\n",
  "ASTROCHEMISTRY": "the study of molecules and radicals in outer space [n]\n",
  "ASTROCOMPASS": "a navigational instrument for giving directional bearings from the centre of the earth to a particular star [n -ES]\n",
  "ASTROCOMPASSES": "ASTROCOMPASS, a navigational instrument for giving directional bearings from the centre of the earth to a particular star [n]\n",
  "ASTROCYTE": "a much-branched, star-shaped neuroglia cell [n -S]\n",
  "ASTROCYTES": "ASTROCYTE, a much-branched, star-shaped neuroglia cell [n]\n",
  "ASTROCYTIC": "relating to an astrocyte, a much-branched, star-shaped neuroglia cell [adj]\n",
  "ASTROCYTOMA": "a tumour of the central nervous system [n ASTROCYTOMAS or ASTROCYTOMATA]\n",
  "ASTROCYTOMAS": "ASTROCYTOMA, a tumour of the central nervous system [n]\n",
  "ASTROCYTOMATA": "ASTROCYTOMA, a tumour of the central nervous system [n]\n",
  "ASTRODOME": "a stadium with a domed roof [n -S]\n",
  "ASTRODOMES": "ASTRODOME, a stadium with a domed roof [n]\n",
  "ASTRODYNAMICIST": "one who studies astrodynamics, the science of the motion of bodies in outer space and the forces that act on them [n]\n",
  "ASTRODYNAMICS": "the science of the motion of bodies in outer space and the forces that act on them [n]\n",
  "ASTROFELL": "(Spenser) an unidentified bitter starlike plant, possibly aster, also ASTROPHEL [n -S]\n",
  "ASTROFELLS": "ASTROFELL, (Spenser) an unidentified bitter starlike plant, possibly aster, also ASTROPHEL [n]\n",
  "ASTROGEOLOGIES": "ASTROGEOLOGY, the study of extraterrestrial geology [n]\n",
  "ASTROGEOLOGIST": "a specialist in astrogeology [n -S]\n",
  "ASTROGEOLOGISTS": "ASTROGEOLOGIST, a specialist in astrogeology [n]\n",
  "ASTROGEOLOGY": "the study of extraterrestrial geology [n ASTROGEOLOGIES]\n",
  "ASTROHATCH": "a domed window in an aircraft for astronomical observations [n -ES]\n",
  "ASTROHATCHES": "ASTROHATCH, a domed window in an aircraft for astronomical observations [n]\n",
  "ASTROID": "a four cusped geometrical figure [n -S]\n",
  "ASTROIDS": "ASTROID, a four cusped geometrical figure [n]\n",
  "ASTROLABE": "a compact instrument used to observe and calculate the position of celestial bodies before the invention of the sextant [n -S]\n",
  "ASTROLABES": "ASTROLABE, a compact instrument used to observe and calculate the position of celestial bodies before the invention of the sextant [n]\n",
  "ASTROLATRIES": "ASTROLATRY, worship of stars [n]\n",
  "ASTROLATRY": "worship of stars [n ASTROLATRIES]\n",
  "ASTROLOGER": "one who affects to tell fortunes from the stars, also ASTROLOGIST [n -S]\n",
  "ASTROLOGERS": "ASTROLOGER, one who affects to tell fortunes from the stars, also ASTROLOGIST [n]\n",
  "ASTROLOGIC": "related to astrology, also ASTROLOGICAL [adj ASTROLOGICALLY]\n",
  "ASTROLOGICAL": "relating to astrology, also ASTROLOGIC [adj ASTROLOGICALLY]\n",
  "ASTROLOGICALLY": "ASTROLOGICAL, relating to astrology, also ASTROLOGIC [adv]\n",
  "ASTROLOGIES": "ASTROLOGY, the study of the supposed influence of the movements and positions of the stars and planets [n]\n",
  "ASTROLOGIST": "one who affects to tell fortunes from the stars, also ASTROLOGER [n -S]\n",
  "ASTROLOGISTS": "ASTROLOGIST, one who affects to tell fortunes from the stars, also ASTROLOGER [n]\n",
  "ASTROLOGY": "the study of the supposed influence of the movements and positions of the stars and planets [n ASTROLOGIES]\n",
  "ASTROMETRIC": "relating to astrometry, also ASTROMETRICAL [adj]\n",
  "ASTROMETRICAL": "relating to astrometry, also ASTROMETRIC [adj]\n",
  "ASTROMETRIES": "ASTROMETRY, the art of making measurements among the stars, or of determining their relative magnitudes [n]\n",
  "ASTROMETRY": "the art of making measurements among the stars, or of determining their relative magnitudes [n ASTROMETRIES]\n",
  "ASTRONAUT": "a person engaged in space travel [n -S]\n",
  "ASTRONAUTIC": "relating to astronautics, also ASTRONAUTICAL [adj ASTRONAUTICALLY]\n",
  "ASTRONAUTICAL": "relating to astronautics, also ASTRONAUTIC [adj ASTRONAUTICALLY]\n",
  "ASTRONAUTICALLY": "ASTRONAUTICAL, relating to astronautics, also ASTRONAUTIC [adv]\n",
  "ASTRONAUTICS": "the science of the construction and operation of vehicles for travel in space beyond the earth's atmosphere [n]\n",
  "ASTRONAUTS": "ASTRONAUT, a person engaged in space travel [n]\n",
  "ASTRONAVIGATION": "the navigation of aircraft, spacecraft or sailing craft by means of observation of the stars [n]\n",
  "ASTRONAVIGATOR": "one who practises astronavigation [n -S]\n",
  "ASTRONAVIGATORS": "ASTRONAVIGATOR, one who practises astronavigation [n]\n",
  "ASTRONOMER": "a person who is skilled in astronomy or who makes observations of celestial phenomena [n -S]\n",
  "ASTRONOMERS": "ASTRONOMER, a person who is skilled in astronomy or who makes observations of celestial phenomena [n]\n",
  "ASTRONOMIC": "related to astronomy, also ASTRONOMICAL [adj ASTRONOMICALLY]\n",
  "ASTRONOMICAL": "related to astronomy, also ASTRONOMIC [adj ASTRONOMICALLY]\n",
  "ASTRONOMICALLY": "ASTRONOMICAL, related to astronomy, also ASTRONOMIC [adv]\n",
  "ASTRONOMIES": "ASTRONOMY, the study of the celestial bodies and the heavens in all scientific aspects [n]\n",
  "ASTRONOMISE": "to study astronomy, also ASTRONOMIZE [v ASTRONOMISED, ASTRONOMISING, ASTRONOMISES]\n",
  "ASTRONOMISED": "ASTRONOMISE, to study astronomy, also ASTRONOMIZE [v]\n",
  "ASTRONOMISES": "ASTRONOMISE, to study astronomy, also ASTRONOMIZE [v]\n",
  "ASTRONOMISING": "ASTRONOMISE, to study astronomy, also ASTRONOMIZE [v]\n",
  "ASTRONOMIZE": "to study astronomy, also ASTRONOMISE [v ASTRONOMIZED, ASTRONOMIZING, ASTRONOMIZES]\n",
  "ASTRONOMIZED": "ASTRONOMIZE, to study astronomy, also ASTRONOMISE [v]\n",
  "ASTRONOMIZES": "ASTRONOMIZE, to study astronomy, also ASTRONOMISE [v]\n",
  "ASTRONOMIZING": "ASTRONOMIZE, to study astronomy, also ASTRONOMISE [v]\n",
  "ASTRONOMY": "the study of the celestial bodies and the heavens in all scientific aspects [n ASTRONOMIES]\n",
  "ASTROPHEL": "(Spenser) an unidentified bitter starlike plant, possibly aster, also ASTROFELL [n -S]\n",
  "ASTROPHELS": "ASTROPHEL, (Spenser) an unidentified bitter starlike plant, possibly aster, also ASTROFELL [n]\n",
  "ASTROPHOBIA": "a morbid fear of thunder and lightning, also ASTRAPHOBIA, ASTRAPOPHOBIA [n -S]\n",
  "ASTROPHOBIAS": "ASTROPHOBIA, a morbid fear of thunder and lightning, also ASTRAPHOBIA, ASTRAPOPHOBIA [n]\n",
  "ASTROPHOBIC": "suffering from astrophobia, a morbid fear of thunder and lightning, also ASTRAPHOBIC [adj]\n",
  "ASTROPHOTOGRAPH": "a photograph of a celestial body [n]\n",
  "ASTROPHYSICAL": "relating to astrophysics [adj ASTROPHYSICALLY]\n",
  "ASTROPHYSICALLY": "ASTROPHYSICAL, relating to astrophysics [adv]\n",
  "ASTROPHYSICIST": "a student of astrophysics [n -S]\n",
  "ASTROPHYSICISTS": "ASTROPHYSICIST, a student of astrophysics [n]\n",
  "ASTROPHYSICS": "a branch of astronomy dealing esp. with the behavior, physical properties, and dynamic processes of celestial objects and phenomena [n]\n",
  "ASTROSPHERE": "another name for a centrosome [n -S]\n",
  "ASTROSPHERES": "ASTROSPHERE, another name for a centrosome [n]\n",
  "ASTROTOURISM": "tourism in space [n -S]\n",
  "ASTROTOURISMS": "ASTROTOURISM, tourism in space [n]\n",
  "ASTROTOURIST": "one who pays to visit space as a tourist [n -S]\n",
  "ASTROTOURISTS": "ASTROTOURIST, one who pays to visit space as a tourist [n]\n",
  "ASTROTURFER": "one who engages in ASTROTURFING [n -S]\n",
  "ASTROTURFERS": "ASTROTURFER, one who engages in ASTROTURFING [n]\n",
  "ASTROTURFING": "political, advertising, or public relations campaigning that seeks to create the impression of being spontaneous 'grassroots' behavior [n -S]\n",
  "ASTROTURFINGS": "ASTROTURFING, political, advertising, or public relations campaigning that seeks to create the impression of being spontaneous 'grassroots' behavior [n]\n",
  "ASTRUT": "(archaic) in a protruding or distended manner [adv]\n",
  "ASTUCIOUS": "(Scott) of astute and penetrating discernment [adj ASTUCIOUSLY]\n",
  "ASTUCIOUSLY": "ASTUCIOUS, (Scott) of astute and penetrating discernment [adv]\n",
  "ASTUCITIES": "ASTUCITY, astuteness [n]\n",
  "ASTUCITY": "astuteness [n ASTUCITIES]\n",
  "ASTUN": "(obsolete) to astonish [v ASTUNNED, ASTUNNING, ASTUNS]\n",
  "ASTUNNED": "ASTUN, (obsolete) to astonish [v]\n",
  "ASTUNNING": "ASTUN, (obsolete) to astonish [v]\n",
  "ASTUNS": "ASTUN, (obsolete) to astonish [v]\n",
  "ASTUTE": "shrewd and perceptive [adj ASTUTER, ASTUTEST, ASTUTELY]\n",
  "ASTUTELY": "ASTUTE, shrewd and perceptive [adv]\n",
  "ASTUTENESS": "the quality of being astute [n -ES]\n",
  "ASTUTENESSES": "ASTUTENESS, the quality of being astute [n]\n",
  "ASTUTER": "ASTUTE, shrewd and perceptive [adj]\n",
  "ASTUTEST": "ASTUTE, shrewd and perceptive [adj]\n",
  "ASTYLAR": "without columns [adj]\n",
  "ASUDDEN": "(archaic) suddenly [adv]\n",
  "ASUNDER": "into parts [adv]\n",
  "ASURA": "(Sanskrit) a Hindu demon [n -S]\n",
  "ASURAS": "ASURA, (Sanskrit) a Hindu demon [n]\n",
  "ASWARM": "swarming [adj]\n",
  "ASWAY": "in a swaying state [adv]\n",
  "ASWIM": "afloat [adv]\n",
  "ASWING": "swingingly [adv]\n",
  "ASWIRL": "swirling [adj]\n",
  "ASWOON": "swooning [adj]\n",
  "ASYLA": "ASYLUM, (Latin) an institution for the mentally ill [n]\n",
  "ASYLEE": "one who is granted asylum [n -S]\n",
  "ASYLEES": "ASYLEE, one who is granted asylum [n]\n",
  "ASYLLABIC": "without syllables [adj]\n",
  "ASYLUM": "(Latin) an institution for the mentally ill [n ASYLUMS or ASYLA]\n",
  "ASYLUMS": "ASYLUM, (Latin) an institution for the mentally ill [n]\n",
  "ASYMMETRIC": "not symmetric, also ASYMMETRICAL [adj ASYMMETRICALLY]\n",
  "ASYMMETRICAL": "not symmetrical, also ASYMMETRIC [adj ASYMMETRICALLY]\n",
  "ASYMMETRICALLY": "ASYMMETRICAL, not symmetrical, also ASYMMETRIC [adv]\n",
  "ASYMMETRIES": "ASYMMETRY, lack of symmetry [n]\n",
  "ASYMMETRY": "lack of symmetry [n ASYMMETRIES]\n",
  "ASYMPTOMATIC": "having, displaying or producing no symptoms [adj]\n",
  "ASYMPTOTE": "a line (usually straight) that continually approaches a curve but never meets it [n -S]\n",
  "ASYMPTOTES": "ASYMPTOTE, a line (usually straight) that continually approaches a curve but never meets it [n]\n",
  "ASYMPTOTIC": "of a line, approaching a curve but meeting it only at infinity, also ASYMPTOTICAL [adj]\n",
  "ASYMPTOTICAL": "of a line, approaching a curve but meeting it only at infinity, also ASYMPTOTIC [adj ASYMPTOTICALLY]\n",
  "ASYMPTOTICALLY": "ASYMPTOTICAL, of a line, approaching a curve but meeting it only at infinity, also ASYMPTOTIC [adv]\n",
  "ASYNAPSES": "ASYNAPSIS, a failure of the pairing of homologous chromosomes in meiosis [n]\n",
  "ASYNAPSIS": "a failure of the pairing of homologous chromosomes in meiosis [n ASYNAPSES]\n",
  "ASYNARTETE": "not connected, consisting of parts having different rhythms [adj] / a verse consisting of parts having different rhythms [n -S]\n",
  "ASYNARTETES": "ASYNARTETE, a verse consisting of parts having different rhythms [n]\n",
  "ASYNARTETIC": "having two parts with different rhythms [adj]\n",
  "ASYNCHRONIES": "ASYNCHRONY, lack of synchronisation [n]\n",
  "ASYNCHRONISM": "the state of being asynchronous [n -S]\n",
  "ASYNCHRONISMS": "ASYNCHRONISM, the state of being asynchronous [n]\n",
  "ASYNCHRONOUS": "not synchronous [adj ASYNCHRONOUSLY]\n",
  "ASYNCHRONOUSLY": "ASYNCHRONOUS, not synchronous [adv]\n",
  "ASYNCHRONY": "lack of synchronisation [n ASYNCHRONIES]\n",
  "ASYNDETA": "ASYNDETON, the omission of conjunctions, as in 'I came, I saw, I conquered' [n]\n",
  "ASYNDETIC": "not connected by conjunctions, as in 'I came, I saw, I conquered' [adj ASYNDETICALLY]\n",
  "ASYNDETICALLY": "ASYNDETIC, not connected by conjunctions, as in 'I came, I saw, I conquered' [adv]\n",
  "ASYNDETON": "the omission of conjunctions, as in 'I came, I saw, I conquered' [n ASYNDETA or ASYNDETONS]\n",
  "ASYNDETONS": "ASYNDETON, the omission of conjunctions, as in 'I came, I saw, I conquered' [n]\n",
  "ASYNERGIA": "lack of coordination, esp. of muscles, also ASYNERGY [n -S]\n",
  "ASYNERGIAS": "ASYNERGIA, lack of coordination, esp. of muscles, also ASYNERGY [n]\n",
  "ASYNERGIES": "ASYNERGY, lack of muscle coordination [n]\n",
  "ASYNERGY": "lack of muscle coordination [n ASYNERGIES]\n",
  "ASYNTACTIC": "loosely put together, irregular, ungrammatical [adj]\n",
  "ASYSTOLE": "a heart malfunction [n -S]\n",
  "ASYSTOLES": "ASYSTOLE, a heart malfunction [n]\n",
  "ASYSTOLIC": "related to an asystole, a weakening or cessation of the contractile power of the heart [adj]\n",
  "ASYSTOLISM": "the state or symptoms characteristic of asystole [n -S]\n",
  "ASYSTOLISMS": "ASYSTOLISM, the state or symptoms characteristic of asystole [n]\n",
  "AT": "a monetary unit of Laos [n -S]\n",
  "ATAATA": "(Maori) a grazing marine gastropod [n -S]\n",
  "ATAATAS": "ATAATA, (Maori) a grazing marine gastropod [n]\n",
  "ATABAL": "(Spanish) a Moorish kettledrum [n -S]\n",
  "ATABALS": "ATABAL, (Spanish) a Moorish kettledrum [n]\n",
  "ATABEG": "(Turkish) a Turkish ruler or high official, also ATABEK [n -S]\n",
  "ATABEGS": "ATABEG, (Turkish) a Turkish ruler or high official, also ATABEK [n]\n",
  "ATABEK": "(Turkish) a Turkish ruler or high official, also ATABEG [n -S]\n",
  "ATABEKS": "ATABEK, (Turkish) a Turkish ruler or high official, also ATABEG [n]\n",
  "ATABRIN": "(tradename) a bitter yellow powder, formerly used against malaria, also ATABRINE, ATEBRIN [n -S]\n",
  "ATABRINE": "(tradename) a bitter yellow powder, formerly used against malaria, also ATABRIN, ATEBRIN [n -S]\n",
  "ATABRINES": "ATABRINE, (tradename) a bitter yellow powder, formerly used against malaria, also ATABRIN, ATEBRIN [n]\n",
  "ATABRINS": "ATABRIN, (tradename) a bitter yellow powder, formerly used against malaria, also ATABRINE, ATEBRIN [n]\n",
  "ATACAMITE": "an oxy-chloride of copper, usually in emerald-green prismatic crystals [n -S]\n",
  "ATACAMITES": "ATACAMITE, an oxy-chloride of copper, usually in emerald-green prismatic crystals [n]\n",
  "ATACTIC": "unable to coordinate voluntary movements [adj]\n",
  "ATAGHAN": "(Turkish) a Muslim long curved knife, also YATAGAN, YATAGHAN [n -S]\n",
  "ATAGHANS": "ATAGHAN, (Turkish) a Muslim long curved knife, also YATAGAN, YATAGHAN [n]\n",
  "ATALAYA": "(Spanish) a watchtower [n -S]\n",
  "ATALAYAS": "ATALAYA, (Spanish) a watchtower [n]\n",
  "ATAMAN": "(Russian) a chief of the Cossacks, also HETMAN [n -S]\n",
  "ATAMANS": "ATAMAN, (Russian) a chief of the Cossacks, also HETMAN [n]\n",
  "ATAMASCO": "a plant of the southeastern US, bearing a single white lilylike flower [n -S]\n",
  "ATAMASCOS": "ATAMASCO, a plant of the southeastern US, bearing a single white lilylike flower [n]\n",
  "ATAP": "(Malay) the nipa palm [n -S]\n",
  "ATAPS": "ATAP, (Malay) the nipa palm [n]\n",
  "ATARACTIC": "able to calm or tranquillize [adj] / a tranquillizing drug, also ATARAXIC [n -S]\n",
  "ATARACTICS": "ATARACTIC, a tranquillizing drug, also ATARAXIC [n]\n",
  "ATARAXIA": "peace of mind, also ATARAXY [n -S]\n",
  "ATARAXIAS": "ATARAXIA, peace of mind, also ATARAXY [n]\n",
  "ATARAXIC": "a tranquillizing drug [n -S]\n",
  "ATARAXICS": "ATARAXIC, a tranquillizing drug [n]\n",
  "ATARAXIES": "ATARAXY, peace of mind, also ATARAXIA [n]\n",
  "ATARAXY": "peace of mind, also ATARAXIA [n ATARAXIES]\n",
  "ATAVIC": "pertaining to a remote ancestor [adj]\n",
  "ATAVISM": "the reappearance of ancestral characteristics [n -S]\n",
  "ATAVISMS": "ATAVISM, the reappearance of ancestral characteristics [n]\n",
  "ATAVIST": "a person with ancestral characteristics [n -S]\n",
  "ATAVISTIC": "showing atavism, a resemblance to more remote ancestors rather than to parents [adj ATAVISTICALLY]\n",
  "ATAVISTICALLY": "ATAVISTIC, showing atavism, a resemblance to more remote ancestors rather than to parents [adv]\n",
  "ATAVISTS": "ATAVIST, a person with ancestral characteristics [n]\n",
  "ATAXIA": "loss of muscular coordination, also ATAXY [n -S]\n",
  "ATAXIAS": "ATAXIA, loss of muscular coordination, also ATAXY [n]\n",
  "ATAXIC": "one suffering from ataxia [n -S]\n",
  "ATAXICS": "ATAXIC, one suffering from ataxia [n]\n",
  "ATAXIES": "ATAXY, loss of muscular coordination, also ATAXIA [n]\n",
  "ATAXY": "loss of muscular coordination, also ATAXIA [n ATAXIES]\n",
  "ATCHIEVE": "(obsolete) to achieve [v ATCHIEVED, ATCHIEVING, ATCHIEVES]\n",
  "ATCHIEVED": "ATCHIEVE, (obsolete) to achieve [v]\n",
  "ATCHIEVES": "ATCHIEVE, (obsolete) to achieve [v]\n",
  "ATCHIEVING": "ATCHIEVE, (obsolete) to achieve [v]\n",
  "ATE": "reckless ambition that drives one to ruin [n -S]\n",
  "ATEBRIN": "(tradename) a bitter yellow powder, formerly used against malaria, also ATABRIN, ATABRINE [n -S]\n",
  "ATEBRINS": "ATEBRIN, (tradename) a bitter yellow powder, formerly used against malaria, also ATABRIN, ATABRINE [n]\n",
  "ATECHNIC": "a person without technical or artistic knowledge [n -S]\n",
  "ATECHNICS": "ATECHNIC, a person without technical or artistic knowledge [n]\n",
  "ATELECTASES": "ATELECTASIS, incomplete dilatation or collapse of lungs [n]\n",
  "ATELECTASIS": "incomplete dilatation or collapse of lungs [n ATELECTASES]\n",
  "ATELECTATIC": "suffering from atelectasis, incomplete dilatation or collapse of lungs [adj]\n",
  "ATELEIOSES": "ATELEIOSIS, dwarfism with disproportion [n]\n",
  "ATELEIOSIS": "dwarfism with disproportion [n ATELEIOSES]\n",
  "ATELIC": "of a verb, presenting an action or event as being incomplete [adj]\n",
  "ATELIER": "(French) an artist's studio [n -S]\n",
  "ATELIERS": "ATELIER, (French) an artist's studio [n]\n",
  "ATEMOYA": "a tropical fruit of a tree that is a hybrid of the sweetsop and the cherimoya [n -S]\n",
  "ATEMOYAS": "ATEMOYA, a tropical fruit of a tree that is a hybrid of the sweetsop and the cherimoya [n]\n",
  "ATEMPORAL": "without consideration of time [adj]\n",
  "ATENOLOL": "a drug used to treat hypertension [n -S]\n",
  "ATENOLOLS": "ATENOLOL, a drug used to treat hypertension [n]\n",
  "ATES": "ATE, reckless ambition that drives one to ruin [n]\n",
  "ATHAME": "a witch's ceremonial knife [n -S]\n",
  "ATHAMES": "ATHAME, a witch's ceremonial knife [n]\n",
  "ATHANASIES": "ATHANASY, immortality [n]\n",
  "ATHANASY": "immortality [n ATHANASIES]\n",
  "ATHANOR": "(Arabic) an alchemist's furnace [n -S]\n",
  "ATHANORS": "ATHANOR, (Arabic) an alchemist's furnace [n]\n",
  "ATHEISE": "to talk as an atheist, also ATHEIZE [v ATHEISED, ATHEISING, ATHEISES]\n",
  "ATHEISED": "ATHEISE, to talk as an atheist, also ATHEIZE [v]\n",
  "ATHEISES": "ATHEISE, to talk as an atheist, also ATHEIZE [v]\n",
  "ATHEISING": "ATHEISE, to talk as an atheist, also ATHEIZE [v]\n",
  "ATHEISM": "a belief that there is no god [n -S]\n",
  "ATHEISMS": "ATHEISM, a belief that there is no god [n]\n",
  "ATHEIST": "one who believes that there is no god [n -S]\n",
  "ATHEISTIC": "like an atheist, also ATHEISTICAL [adj ATHEISTICALLY]\n",
  "ATHEISTICAL": "like an atheist, also ATHEISTIC [adj ATHEISTICALLY]\n",
  "ATHEISTICALLY": "ATHEISTICAL, like an atheist, also ATHEISTIC [adv]\n",
  "ATHEISTS": "ATHEIST, one who believes that there is no god [n]\n",
  "ATHEIZE": "to talk as an atheist, also ATHEISE [v ATHEIZED, ATHEIZING, ATHEIZES]\n",
  "ATHEIZED": "ATHEIZE, to talk as an atheist, also ATHEISE [v]\n",
  "ATHEIZES": "ATHEIZE, to talk as an atheist, also ATHEISE [v]\n",
  "ATHEIZING": "ATHEIZE, to talk as an atheist, also ATHEISE [v]\n",
  "ATHELING": "(historical) an Anglo-Saxon nobleman [n -S]\n",
  "ATHELINGS": "ATHELING, (historical) an Anglo-Saxon nobleman [n]\n",
  "ATHEMATIC": "without a thematic vowel [adj ATHEMATICALLY]\n",
  "ATHEMATICALLY": "ATHEMATIC, without a thematic vowel [adv]\n",
  "ATHENAEUM": "(Greek) a literary or scientific association, also ATHENEUM [n -S]\n",
  "ATHENAEUMS": "ATHENAEUM, (Greek) a literary or scientific association, also ATHENEUM [n]\n",
  "ATHENEUM": "(Greek) a literary or scientific association, also ATHENAEUM [n -S]\n",
  "ATHENEUMS": "ATHENEUM, (Greek) a literary or scientific association, also ATHENAEUM [n]\n",
  "ATHEOLOGICAL": "related to atheology [adj]\n",
  "ATHEOLOGIES": "ATHEOLOGY, antagonism to theology [n]\n",
  "ATHEOLOGY": "antagonism to theology [n ATHEOLOGIES]\n",
  "ATHEORETICAL": "not based on or concerned with theory [adj]\n",
  "ATHEOUS": "(Milton) atheistic; impious [adj]\n",
  "ATHERINE": "a fish resembling the grey mullet [n -S]\n",
  "ATHERINES": "ATHERINE, a fish resembling the grey mullet [n]\n",
  "ATHERMANCIES": "ATHERMANCY, imperviousness to radiant heat [n]\n",
  "ATHERMANCY": "imperviousness to radiant heat [n ATHERMANCIES]\n",
  "ATHERMANOUS": "impervious to radiant heat [adj]\n",
  "ATHEROGENESES": "ATHEROGENESIS, the formation of atheromata [n]\n",
  "ATHEROGENESIS": "the formation of atheromata [n ATHEROGENESES]\n",
  "ATHEROGENIC": "leading to atheroma [adj]\n",
  "ATHEROMA": "a fatty deposit in the lining of the arteries [n -S]\n",
  "ATHEROMAS": "ATHEROMA, a fatty deposit in the lining of the arteries [n]\n",
  "ATHEROMATA": "ATHEROMA, a fatty deposit in the lining of the arteries [n]\n",
  "ATHEROMATOUS": "relating to atheroma [adj]\n",
  "ATHEROSCLEROSES": "ATHEROSCLEROSIS, hardening of the inner lining of the arteries with fatty degeneration [n]\n",
  "ATHEROSCLEROSIS": "hardening of the inner lining of the arteries with fatty degeneration [n ATHEROSCLEROSES]\n",
  "ATHEROSCLEROTIC": "relating to atherosclerosis [adj]\n",
  "ATHETESES": "ATHETESIS, the rejection of a passage as spurious [n]\n",
  "ATHETESIS": "the rejection of a passage as spurious [n ATHETESES]\n",
  "ATHETISE": "in textual criticism, to reject (a passage) as spurious, also ATHETIZE [v ATHETISED, ATHETISING, ATHETISES]\n",
  "ATHETISED": "ATHETISE, in textual criticism, to reject (a passage) as spurious, also ATHETIZE [v]\n",
  "ATHETISES": "ATHETISE, in textual criticism, to reject (a passage) as spurious, also ATHETIZE [v]\n",
  "ATHETISING": "ATHETISE, in textual criticism, to reject (a passage) as spurious, also ATHETIZE [v]\n",
  "ATHETIZE": "in textual criticism, to reject (a passage) as spurious, also ATHETISE [v ATHETIZED, ATHETIZING, ATHETIZES]\n",
  "ATHETIZED": "ATHETIZE, in textual criticism, to reject (a passage) as spurious, also ATHETISE [v]\n",
  "ATHETIZES": "ATHETIZE, in textual criticism, to reject (a passage) as spurious, also ATHETISE [v]\n",
  "ATHETIZING": "ATHETIZE, in textual criticism, to reject (a passage) as spurious, also ATHETISE [v]\n",
  "ATHETOID": "showing symptoms of athetosis, nervous twitching of digits and extremities [adj]\n",
  "ATHETOSES": "ATHETOSIS, nervous twitching of digits and extremities [n]\n",
  "ATHETOSIC": "showing symptoms of athetosis, nervous twitching of digits and extremities, also ATHETOTIC [adj]\n",
  "ATHETOSIS": "nervous twitching of digits and extremities [n ATHETOSES]\n",
  "ATHETOTIC": "showing symptoms of athetosis, nervous twitching of digits and extremities, also ATHETOSIC [adj]\n",
  "ATHIRST": "having a strong desire [adj]\n",
  "ATHLEISURE": "the wearing of sports clothes as leisurewear [n -S]\n",
  "ATHLEISURES": "ATHLEISURE, the wearing of sports clothes as leisurewear [n]\n",
  "ATHLETA": "(obsolete) a competitor in contests of strength and speed, also ATHLETE [n -S]\n",
  "ATHLETAS": "ATHLETA, (obsolete) a competitor in contests of strength and speed, also ATHLETE [n]\n",
  "ATHLETE": "a competitor in contests of strength and speed, also ATHLETA [n -S]\n",
  "ATHLETES": "ATHLETE, a competitor in contests of strength and speed, also ATHLETA [n]\n",
  "ATHLETIC": "relating to vigorous physical exercise [adj ATHLETICALLY]\n",
  "ATHLETICALLY": "ATHLETIC, relating to vigorous physical exercise [adv]\n",
  "ATHLETICISM": "the quality of being athletic [n -S]\n",
  "ATHLETICISMS": "ATHLETICISM, the quality of being athletic [n]\n",
  "ATHLETICS": "athletic sports [n]\n",
  "ATHODYD": "a type of jet engine [n -S]\n",
  "ATHODYDS": "ATHODYD, a type of jet engine [n]\n",
  "ATHRILL": "(archaic) in a thrill [adv]\n",
  "ATHROB": "with throbs [adj]\n",
  "ATHROCYTE": "a cell having the ability to move and store foreign matter [n -S]\n",
  "ATHROCYTES": "ATHROCYTE, a cell having the ability to move and store foreign matter [n]\n",
  "ATHROCYTOSES": "ATHROCYTOSIS, of a cell, having the ability to absorb and store foreign matter [n]\n",
  "ATHROCYTOSIS": "of a cell, having the ability to absorb and store foreign matter [n ATHROCYTOSES]\n",
  "ATHWART": "across; transversely [adv]\n",
  "ATHWARTSHIP": "transverse to a ship, also ATHWARTSHIPS, THWARTSHIP [adv]\n",
  "ATHWARTSHIPS": "transverse to a ship, also ATHWARTSHIP, THWARTSHIP [adv]\n",
  "ATIGI": "(Inuit) a kind of parka worn in Canada, also ARTIGI [n ATIGIS]\n",
  "ATIGIS": "ATIGI, (Inuit) a kind of parka worn in Canada, also ARTIGI [n]\n",
  "ATILT": "being in a tilted position [adj]\n",
  "ATIMIES": "ATIMY, loss of honour [n]\n",
  "ATIMY": "loss of honour [n ATIMIES]\n",
  "ATINGLE": "tingling [adj]\n",
  "ATISHOO": "an imitation of the sound of a sneeze, also ACHOO, AHCHOO [n -S]\n",
  "ATISHOOS": "ATISHOO, an imitation of the sound of a sneeze, also ACHOO, AHCHOO [n]\n",
  "ATLANTES": "ATLAS, a book of maps [n]\n",
  "ATLAS": "a book of maps [n -ES] / a male figure serving as a column of a building [n ATLANTES]\n",
  "ATLASES": "ATLAS, a book of maps [n]\n",
  "ATLATL": "(Nahuatl) an American Indian throwing stick [n -S]\n",
  "ATLATLS": "ATLATL, (Nahuatl) an American Indian throwing stick [n]\n",
  "ATMA": "(Sanskrit) the essential self, also ATMAN [n -S]\n",
  "ATMAN": "(Sanskrit) the essential self, also ATMA [n -S]\n",
  "ATMANS": "ATMAN, (Sanskrit) the essential self, also ATMA [n]\n",
  "ATMAS": "ATMA, (Sanskrit) the essential self, also ATMAN [n]\n",
  "ATMOLOGIES": "ATMOLOGY, the science of water vapour [n]\n",
  "ATMOLOGIST": "one who is versed in atmology [n -S]\n",
  "ATMOLOGISTS": "ATMOLOGIST, one who is versed in atmology [n]\n",
  "ATMOLOGY": "the science of water vapour [n ATMOLOGIES]\n",
  "ATMOLYSE": "to separate gases by diffusion, also ATMOLYZE [v ATMOLYSED, ATMOLYSING, ATMOLYSES]\n",
  "ATMOLYSED": "ATMOLYSE, to separate gases by diffusion, also ATMOLYZE [v]\n",
  "ATMOLYSES": "ATMOLYSE, to separate gases by diffusion, also ATMOLYZE [v]\n",
  "ATMOLYSING": "ATMOLYSE, to separate gases by diffusion, also ATMOLYZE [v]\n",
  "ATMOLYSIS": "a method of separating gases of different densities [n ATMOLYSES]\n",
  "ATMOLYZE": "to separate gases by diffusion, also ATMOLYSE [v ATMOLYZED, ATMOLYZING, ATMOLYZES]\n",
  "ATMOLYZED": "ATMOLYZE, to separate gases by diffusion, also ATMOLYSE [v]\n",
  "ATMOLYZES": "ATMOLYZE, to separate gases by diffusion, also ATMOLYSE [v]\n",
  "ATMOLYZING": "ATMOLYZE, to separate gases by diffusion, also ATMOLYSE [v]\n",
  "ATMOMETER": "an instrument for measuring the evaporating capacity of air [n -S]\n",
  "ATMOMETERS": "ATMOMETER, an instrument for measuring the evaporating capacity of air [n]\n",
  "ATMOMETRIES": "ATMOMETRY, measurement by atmometer, an instrument for measuring evaporating capacity of air [n]\n",
  "ATMOMETRY": "measurement by atmometer, an instrument for measuring evaporating capacity of air [n ATMOMETRIES]\n",
  "ATMOS": "(short for) atmosphere [n -ES]\n",
  "ATMOSES": "ATMOS, (short for) atmosphere [n]\n",
  "ATMOSPHERE": "the body of air and gas which surrounds the earth [n -S]\n",
  "ATMOSPHERED": "having an atmosphere [adj]\n",
  "ATMOSPHERES": "ATMOSPHERE, the body of air and gas which surrounds the earth [n]\n",
  "ATMOSPHERIC": "of, relating to, or occurring in the atmosphere, also ATMOSPHERICAL [adj ATMOSPHERICALLY]\n",
  "ATMOSPHERICAL": "related to the atmosphere, also ATMOSPHERIC [adj ATMOSPHERICALLY]\n",
  "ATMOSPHERICALLY": "ATMOSPHERICAL, related to the atmosphere, also ATMOSPHERIC [adv]\n",
  "ATMOSPHERICS": "audible disturbances produced in radio receiving apparatus by atmospheric electrical phenomena (as lightning) [n]\n",
  "ATOC": "a species of skunk, also ATOK [n -S]\n",
  "ATOCIA": "sterility in a female [n -S]\n",
  "ATOCIAS": "ATOCIA, sterility in a female [n]\n",
  "ATOCS": "ATOC, a species of skunk, also ATOK [n]\n",
  "ATOK": "a species of skunk, also ATOC [n -S]\n",
  "ATOKAL": "without offspring, also ATOKOUS [adj]\n",
  "ATOKE": "a sexless part of some worms [n -S]\n",
  "ATOKES": "ATOKE, a sexless part of some worms [n]\n",
  "ATOKOUS": "without offspring, also ATOKAL [adj]\n",
  "ATOKS": "ATOK, a species of skunk, also ATOC [n]\n",
  "ATOLL": "a coral island consisting of a reef surrounding a lagoon [n -S]\n",
  "ATOLLS": "ATOLL, a coral island consisting of a reef surrounding a lagoon [n]\n",
  "ATOM": "the smallest particle in an element which can take part in a chemical reaction [n -S]\n",
  "ATOMIC": "of or pertaining to atoms, also ATOMICAL [adj ATOMICALLY]\n",
  "ATOMICAL": "relating to an atom [adj ATOMICALLY]\n",
  "ATOMICALLY": "ATOMICAL, relating to an atom [adv]\n",
  "ATOMICITIES": "ATOMICITY, the number of atoms in an elementary molecule [n]\n",
  "ATOMICITY": "the number of atoms in an elementary molecule [n ATOMICITIES]\n",
  "ATOMICS": "the science of dealing with atoms [n]\n",
  "ATOMIES": "ATOMY, (archaic) an atom, a mote [n]\n",
  "ATOMISATION": "the reduction of liquids to the form of spray, also ATOMIZATION [n -S]\n",
  "ATOMISATIONS": "ATOMISATION, the reduction of liquids to the form of spray, also ATOMIZATION [n]\n",
  "ATOMISE": "to reduce to a fine spray, also ATOMIZE [v ATOMISED, ATOMISING, ATOMISES]\n",
  "ATOMISED": "ATOMISE, to reduce to a fine spray, also ATOMIZE [v]\n",
  "ATOMISER": "a device which sprays finely, also ATOMIZER [n -S]\n",
  "ATOMISERS": "ATOMISER, a device which sprays finely, also ATOMIZER [n]\n",
  "ATOMISES": "ATOMISE, to reduce to a fine spray, also ATOMIZE [v]\n",
  "ATOMISING": "ATOMISE, to reduce to a fine spray, also ATOMIZE [v]\n",
  "ATOMISM": "the theory that atoms arranged themselves in the universe [n -S]\n",
  "ATOMISMS": "ATOMISM, the theory that atoms arranged themselves in the universe [n]\n",
  "ATOMIST": "an adherent of atomism, the belief that the universe consists of small indivisible particles [n -S]\n",
  "ATOMISTIC": "relating to atomism, also ATOMISTICAL [adj ATOMISTICALLY]\n",
  "ATOMISTICAL": "relating to atomism, also ATOMISTIC [adj ATOMISTICALLY]\n",
  "ATOMISTICALLY": "ATOMISTICAL, relating to atomism, also ATOMISTIC [adv]\n",
  "ATOMISTS": "ATOMIST, an adherent of atomism, the belief that the universe consists of small indivisible particles [n]\n",
  "ATOMIZATION": "the reduction of liquids to the form of spray, also ATOMISATION [n -S]\n",
  "ATOMIZATIONS": "ATOMIZATION, the reduction of liquids to the form of spray, also ATOMISATION [n]\n",
  "ATOMIZE": "to reduce to a fine spray, also ATOMISE [v ATOMIZED, ATOMIZING, ATOMIZES]\n",
  "ATOMIZED": "ATOMIZE, to reduce to a fine spray, also ATOMISE [v]\n",
  "ATOMIZER": "a device which sprays finely, also ATOMISER [n -S]\n",
  "ATOMIZERS": "ATOMIZER, a device which sprays finely, also ATOMISER [n]\n",
  "ATOMIZES": "ATOMIZE, to reduce to a fine spray, also ATOMISE [v]\n",
  "ATOMIZING": "ATOMIZE, to reduce to a fine spray, also ATOMISE [v]\n",
  "ATOMS": "ATOM, the smallest particle in an element which can take part in a chemical reaction [n]\n",
  "ATOMY": "(archaic) an atom, a mote [n ATOMIES]\n",
  "ATONABLE": "able to be atoned for [adj]\n",
  "ATONAL": "not referring to any scale or tonic [adj ATONALLY]\n",
  "ATONALISM": "an adherence to atonal music [n -S]\n",
  "ATONALISMS": "ATONALISM, an adherence to atonal music [n]\n",
  "ATONALIST": "one who adheres to atonal music [n -S]\n",
  "ATONALISTS": "ATONALIST, one who adheres to atonal music [n]\n",
  "ATONALITIES": "ATONALITY, the state of being atonal [n]\n",
  "ATONALITY": "the state of being atonal [n ATONALITIES]\n",
  "ATONALLY": "ATONAL, not referring to any scale or tonic [adv]\n",
  "ATONE": "to make amends [v ATONED, ATONING, ATONES]\n",
  "ATONEABLE": "capable of being atoned for, also ATONABLE [adj]\n",
  "ATONED": "ATONE, to make amends [v]\n",
  "ATONEMENT": "the act of atoning [n -S]\n",
  "ATONEMENTS": "ATONEMENT, the act of atoning [n]\n",
  "ATONER": "one who atones [n -S]\n",
  "ATONERS": "ATONER, one who atones [n]\n",
  "ATONES": "ATONE, to make amends [v]\n",
  "ATONIA": "muscular debility, also ATONY [n -S]\n",
  "ATONIAS": "ATONIA, muscular debility, also ATONY [n]\n",
  "ATONIC": "an unaccented syllable or word [n -S]\n",
  "ATONICITIES": "ATONICITY, the quality of being atonic [n]\n",
  "ATONICITY": "the quality of being atonic [n ATONICITIES]\n",
  "ATONICS": "ATONIC, an unaccented syllable or word [n]\n",
  "ATONIES": "ATONY, muscular debility, also ATONIA [n]\n",
  "ATONING": "ATONE, to make amends [v]\n",
  "ATONINGLY": "ATONING, ATONE, to make amends [adv]\n",
  "ATONY": "muscular debility, also ATONIA [n ATONIES]\n",
  "ATOP": "on top of [adj]\n",
  "ATOPIC": "relating to atopy [adj]\n",
  "ATOPIES": "ATOPY, an inherited tendency to general allergy [n]\n",
  "ATOPY": "an inherited tendency to general allergy [n ATOPIES]\n",
  "ATORVASTATIN": "a type of statin drug [n -S]\n",
  "ATORVASTATINS": "ATORVASTATIN, a type of statin drug [n]\n",
  "ATRABILIAR": "melancholy or morose, also ATRABILIOUS [adj]\n",
  "ATRABILIOUS": "(archaic) melancholy or morose, also ATRABILIAR [adj]\n",
  "ATRABILIOUSNESS": "(archaic) the state of being atrabilious, melancholy or morose [n]\n",
  "ATRACURIUM": "a muscle-relaxing drug used in surgery [n -S]\n",
  "ATRACURIUMS": "ATRACURIUM, a muscle-relaxing drug used in surgery [n]\n",
  "ATRAMENT": "(archaic) blacking; ink; any black fluid [n -S]\n",
  "ATRAMENTAL": "inky black, also ATRAMENTOUS [adj]\n",
  "ATRAMENTOUS": "inky black, also ATRAMENTAL [adj]\n",
  "ATRAMENTS": "ATRAMENT, (archaic) blacking; ink; any black fluid [n]\n",
  "ATRAZINE": "a kind of weedkiller [n -S]\n",
  "ATRAZINES": "ATRAZINE, a kind of weedkiller [n]\n",
  "ATREMBLE": "(archaic) in a trembling state [adv]\n",
  "ATRESIA": "absence or closure of a bodily passage [n -S]\n",
  "ATRESIAS": "ATRESIA, absence or closure of a bodily passage [n]\n",
  "ATRESIC": "relating to atresia, absence of, or closure of, a body passage, also ATRETIC [adj]\n",
  "ATRETIC": "relating to atresia, absence of, or closure of, a body passage, also ATRESIC [adj]\n",
  "ATRIA": "ATRIUM, (Latin) a square hall lighted from above, into which rooms open at one or more levels [n]\n",
  "ATRIAL": "of or pertaining to an atrium, a square hall lighted from above, into which rooms open at one or more levels [adj]\n",
  "ATRIP": "of an anchor when it is just drawn out of the ground, in a perpendicular position [adv]\n",
  "ATRIUM": "(Latin) a square hall lighted from above, into which rooms open at one or more levels [n ATRIUMS or ATRIA]\n",
  "ATRIUMS": "ATRIUM, (Latin) a square hall lighted from above, into which rooms open at one or more levels [n]\n",
  "ATROCIOUS": "terrible [adj ATROCIOUSLY]\n",
  "ATROCIOUSLY": "ATROCIOUS, terrible [adv]\n",
  "ATROCIOUSNESS": "the state of being atrocious [n -ES]\n",
  "ATROCIOUSNESSES": "ATROCIOUSNESS, the state of being atrocious [n]\n",
  "ATROCITIES": "ATROCITY, a heinous act [n]\n",
  "ATROCITY": "a heinous act [n ATROCITIES]\n",
  "ATROPHIA": "a wasting away of body parts [n -S]\n",
  "ATROPHIAS": "ATROPHIA, a wasting away of body parts [n]\n",
  "ATROPHIC": "relating to atrophia [adj]\n",
  "ATROPHIED": "ATROPHY, to waste away [v]\n",
  "ATROPHIES": "ATROPHY, to waste away [v]\n",
  "ATROPHY": "to waste away [v ATROPHIED, ATROPHYING, ATROPHIES]\n",
  "ATROPHYING": "ATROPHY, to waste away [v]\n",
  "ATROPIA": "a medicine derived from the deadly nightshade, also ATROPIN, ATROPINE [n -S]\n",
  "ATROPIAS": "ATROPIA, a medicine derived from the deadly nightshade, also ATROPIN, ATROPINE [n]\n",
  "ATROPIN": "a medicine derived from the deadly nightshade, also ATROPIA, ATROPINE [n -S]\n",
  "ATROPINE": "a medicine derived from the deadly nightshade, also ATROPIN, ATROPIA [n -S]\n",
  "ATROPINES": "ATROPINE, a medicine derived from the deadly nightshade, also ATROPIN, ATROPIA [n]\n",
  "ATROPINS": "ATROPIN, a medicine derived from the deadly nightshade, also ATROPIA, ATROPINE [n]\n",
  "ATROPISM": "atropine poisoning [n -S]\n",
  "ATROPISMS": "ATROPISM, atropine poisoning [n]\n",
  "ATROPOUS": "having a straight ovule [adj]\n",
  "ATS": "AT, a monetary unit of Laos [n]\n",
  "ATT": "a monetary unit of Laos, also AT [n ATT]\n",
  "ATTABOY": "an interjection expressing encouragement to a male [n -S]\n",
  "ATTABOYS": "ATTABOY, an interjection expressing encouragement to a male [n]\n",
  "ATTACH": "to connect as an associated part [v -ED, -ING, -ES]\n",
  "ATTACHABLE": "that can be attached [adj]\n",
  "ATTACHE": "(French) a junior member of an ambassador's staff [n -S]\n",
  "ATTACHED": "ATTACH, to connect as an associated part [v]\n",
  "ATTACHER": "one who attaches [n -S]\n",
  "ATTACHERS": "ATTACHER, one who attaches [n]\n",
  "ATTACHES": "ATTACH, to connect as an associated part [v]\n",
  "ATTACHING": "ATTACH, to connect as an associated part [v]\n",
  "ATTACHMENT": "something attached [n -S]\n",
  "ATTACHMENTS": "ATTACHMENT, something attached [n]\n",
  "ATTACK": "to set upon violently [v -ED, -ING, -S]\n",
  "ATTACKABLE": "capable of being attacked [adj]\n",
  "ATTACKED": "ATTACK, to set upon violently [v]\n",
  "ATTACKER": "one that attacks [n -S]\n",
  "ATTACKERS": "ATTACKER, one that attacks [n]\n",
  "ATTACKING": "ATTACK, to set upon violently [v]\n",
  "ATTACKMAN": "a soldier or sportsman with attacking role [n ATTACKMEN]\n",
  "ATTACKMEN": "ATTACKMAN, a soldier or sportsman with attacking role [n]\n",
  "ATTACKS": "ATTACK, to set upon violently [v]\n",
  "ATTAGIRL": "an interjection expressing encouragement to a female [interj]\n",
  "ATTAIN": "to gain or achieve by mental or physical effort [v -ED, -ING, -S]\n",
  "ATTAINABILITIES": "ATTAINABILITY, the quality of being attainable [n]\n",
  "ATTAINABILITY": "the quality of being attainable [n ATTAINABILITIES]\n",
  "ATTAINABLE": "that can be attained [adj]\n",
  "ATTAINABLENESS": "the state of being attainable [n]\n",
  "ATTAINDER": "the loss of civil rights, formerly a result of outlawry or a death sentence [n -S]\n",
  "ATTAINDERS": "ATTAINDER, the loss of civil rights, formerly a result of outlawry or a death sentence [n]\n",
  "ATTAINED": "ATTAIN, to gain or achieve by mental or physical effort [v]\n",
  "ATTAINER": "one who attains [n -S]\n",
  "ATTAINERS": "ATTAINER, one who attains [n]\n",
  "ATTAINING": "ATTAIN, to gain or achieve by mental or physical effort [v]\n",
  "ATTAINMENT": "the act of attaining [n -S]\n",
  "ATTAINMENTS": "ATTAINMENT, the act of attaining [n]\n",
  "ATTAINS": "ATTAIN, to gain or achieve by mental or physical effort [v]\n",
  "ATTAINT": "to pass sentence of attainder on; to sully [v -ED, -ING, -S]\n",
  "ATTAINTED": "ATTAINT, to pass sentence of attainder on; to sully [v]\n",
  "ATTAINTING": "ATTAINT, to pass sentence of attainder on; to sully [v]\n",
  "ATTAINTMENT": "the state of being attainted [n -S]\n",
  "ATTAINTMENTS": "ATTAINTMENT, the state of being attainted [n]\n",
  "ATTAINTS": "ATTAINT, to pass sentence of attainder on; to sully [v]\n",
  "ATTAINTURE": "process of attaint [n -S]\n",
  "ATTAINTURES": "ATTAINTURE, process of attaint [n]\n",
  "ATTAP": "(Malay) the nipa palm [n -S]\n",
  "ATTAPS": "ATTAP, (Malay) the nipa palm [n]\n",
  "ATTAR": "(Persian) a fragrant essential oil made from the damask rose, also OTTAR, OTTO [n -S]\n",
  "ATTARS": "ATTAR, (Persian) a fragrant essential oil made from the damask rose, also OTTAR, OTTO [n]\n",
  "ATTASK": "to take to task [v ATTASKT or ATTASKED, ATTASKING, ATTASKS]\n",
  "ATTASKED": "ATTASK, to take to task [v]\n",
  "ATTASKING": "ATTASK, to take to task [v]\n",
  "ATTASKS": "ATTASK, to take to task [v]\n",
  "ATTASKT": "ATTASK, to take to task [v]\n",
  "ATTEMPER": "(archaic) to alter quality by addition or mixture; to moderate [v -ED, -ING, -S]\n",
  "ATTEMPERED": "ATTEMPER, (archaic) to alter quality by addition or mixture; to moderate [v]\n",
  "ATTEMPERING": "ATTEMPER, (archaic) to alter quality by addition or mixture; to moderate [v]\n",
  "ATTEMPERMENT": "the act of attempering [n -S]\n",
  "ATTEMPERMENTS": "ATTEMPERMENT, the act of attempering [n]\n",
  "ATTEMPERS": "ATTEMPER, (archaic) to alter quality by addition or mixture; to moderate [v]\n",
  "ATTEMPT": "to endeavour [v -ED, -ING, -S]\n",
  "ATTEMPTABILITY": "the quality of being attemptable [n]\n",
  "ATTEMPTABLE": "that can be attempted [adj]\n",
  "ATTEMPTED": "ATTEMPT, to endeavour [v]\n",
  "ATTEMPTER": "one who attempts [n -S]\n",
  "ATTEMPTERS": "ATTEMPTER, one who attempts [n]\n",
  "ATTEMPTING": "ATTEMPT, to endeavour [v]\n",
  "ATTEMPTS": "ATTEMPT, to endeavour [v]\n",
  "ATTEND": "to be present at [v -ED, -ING, -S]\n",
  "ATTENDANCE": "the act of attending [n -S]\n",
  "ATTENDANCES": "ATTENDANCE, the act of attending [n]\n",
  "ATTENDANCIES": "ATTENDANCY, the quality of attending or accompanying [n]\n",
  "ATTENDANCY": "the quality of attending or accompanying [n ATTENDANCIES]\n",
  "ATTENDANT": "a servant [n -S]\n",
  "ATTENDANTS": "ATTENDANT, a servant [n]\n",
  "ATTENDED": "ATTEND, to be present at [v]\n",
  "ATTENDEE": "one who attends a function [n -S]\n",
  "ATTENDEES": "ATTENDEE, one who attends a function [n]\n",
  "ATTENDEMENT": "(Spenser) intention [n -S]\n",
  "ATTENDEMENTS": "ATTENDEMENT, (Spenser) intention [n]\n",
  "ATTENDER": "one who is attentive [n -S]\n",
  "ATTENDERS": "ATTENDER, one who is attentive [n]\n",
  "ATTENDING": "the act of attending [n -S]\n",
  "ATTENDINGS": "ATTENDING, the act of attending [n]\n",
  "ATTENDMENT": "an attendant circumstance [n -S]\n",
  "ATTENDMENTS": "ATTENDMENT, an attendant circumstance [n]\n",
  "ATTENDS": "ATTEND, to be present at [v]\n",
  "ATTENT": "(Spenser) attention [n -S]\n",
  "ATTENTAT": "(French) an (esp. unsuccessful) attempt at an (esp. political) crime of violence [n -S]\n",
  "ATTENTATS": "ATTENTAT, (French) an (esp. unsuccessful) attempt at an (esp. political) crime of violence [n]\n",
  "ATTENTION": "the act of attending [n -S]\n",
  "ATTENTIONAL": "relating to attention or concentration [adj]\n",
  "ATTENTIONS": "ATTENTION, the act of attending [n]\n",
  "ATTENTIVE": "full of attention [adj ATTENTIVELY]\n",
  "ATTENTIVELY": "ATTENTIVE, full of attention [adv]\n",
  "ATTENTIVENESS": "the state of being attentive [n -ES]\n",
  "ATTENTIVENESSES": "ATTENTIVENESS, the state of being attentive [n]\n",
  "ATTENTS": "ATTENT, (Spenser) attention [n]\n",
  "ATTENUANT": "a drug or other agent that attenuates [n -S]\n",
  "ATTENUANTS": "ATTENUANT, a drug or other agent that attenuates [n]\n",
  "ATTENUATE": "to make thin; to reduce in value [v ATTENUATED, ATTENUATING, ATTENUATES]\n",
  "ATTENUATED": "ATTENUATE, to make thin; to reduce in value [v]\n",
  "ATTENUATES": "ATTENUATE, to make thin; to reduce in value [v]\n",
  "ATTENUATING": "ATTENUATE, to make thin; to reduce in value [v]\n",
  "ATTENUATION": "the action of attenuating [n -S]\n",
  "ATTENUATIONS": "ATTENUATION, the action of attenuating [n]\n",
  "ATTENUATOR": "a device for attenuating [n -S]\n",
  "ATTENUATORS": "ATTENUATOR, a device for attenuating [n]\n",
  "ATTERCOP": "(Old English) a spider, also ETHERCAP, ETTERCAP [n -S]\n",
  "ATTERCOPS": "ATTERCOP, (Old English) a spider, also ETHERCAP, ETTERCAP [n]\n",
  "ATTEST": "to affirm to be genuine [v -ED, -ING, -S]\n",
  "ATTESTABLE": "that can be attested [adj]\n",
  "ATTESTANT": "one who attests [n -S]\n",
  "ATTESTANTS": "ATTESTANT, one who attests [n]\n",
  "ATTESTATION": "the act of attesting [n -S]\n",
  "ATTESTATIONS": "ATTESTATION, the act of attesting [n]\n",
  "ATTESTATIVE": "relating to attestation [adj]\n",
  "ATTESTATOR": "one who attests [n -S]\n",
  "ATTESTATORS": "ATTESTATOR, one who attests [n]\n",
  "ATTESTED": "ATTEST, to affirm to be genuine [v]\n",
  "ATTESTER": "one who attests, also ATTESTOR [n -S]\n",
  "ATTESTERS": "ATTESTER, one who attests, also ATTESTOR [n]\n",
  "ATTESTING": "ATTEST, to affirm to be genuine [v]\n",
  "ATTESTOR": "one who attests, also ATTESTER [n -S]\n",
  "ATTESTORS": "ATTESTOR, one who attests, also ATTESTER [n]\n",
  "ATTESTS": "ATTEST, to affirm to be genuine [v]\n",
  "ATTIC": "a room in the roof of a house [n -S]\n",
  "ATTICISE": "to use atticisms, also ATTICIZE [v ATTICISED, ATTICISING, ATTICISES]\n",
  "ATTICISED": "ATTICISE, to use atticisms, also ATTICIZE [v]\n",
  "ATTICISES": "ATTICISE, to use atticisms, also ATTICIZE [v]\n",
  "ATTICISING": "ATTICISE, to use atticisms, also ATTICIZE [v]\n",
  "ATTICISM": "a succinct and elegant expression [n -S]\n",
  "ATTICISMS": "ATTICISM, a succinct and elegant expression [n]\n",
  "ATTICIST": "one who uses atticisms [n -S]\n",
  "ATTICISTS": "ATTICIST, one who uses atticisms [n]\n",
  "ATTICIZE": "to use atticisms, also ATTICISE [v ATTICIZED, ATTICIZING, ATTICIZES]\n",
  "ATTICIZED": "ATTICIZE, to use atticisms, also ATTICISE [v]\n",
  "ATTICIZES": "ATTICIZE, to use atticisms, also ATTICISE [v]\n",
  "ATTICIZING": "ATTICIZE, to use atticisms, also ATTICISE [v]\n",
  "ATTICS": "ATTIC, a room in the roof of a house [n]\n",
  "ATTIRE": "to clothe [v ATTIRED, ATTIRING, ATTIRES]\n",
  "ATTIRED": "ATTIRE, to clothe [v]\n",
  "ATTIREMENT": "attire; adornment [n -S]\n",
  "ATTIREMENTS": "ATTIREMENT, attire; adornment [n]\n",
  "ATTIRES": "ATTIRE, to clothe [v]\n",
  "ATTIRING": "the act of dressing [n -S]\n",
  "ATTIRINGS": "ATTIRING, the act of dressing [n]\n",
  "ATTITUDE": "a posture or position [n -S]\n",
  "ATTITUDES": "ATTITUDE, a posture or position [n]\n",
  "ATTITUDINAL": "relating to attitude [adj ATTITUDINALLY]\n",
  "ATTITUDINALLY": "ATTITUDINAL, relating to attitude [adv]\n",
  "ATTITUDINARIAN": "a person who studies attitudes [n -S]\n",
  "ATTITUDINARIANS": "ATTITUDINARIAN, a person who studies attitudes [n]\n",
  "ATTITUDINISE": "to assume affected attitudes, also ATTITUDINIZE [v ATTITUDINISED, ATTITUDINISING, ATTITUDINISES]\n",
  "ATTITUDINISED": "ATTITUDINISE, to assume affected attitudes, also ATTITUDINIZE [v]\n",
  "ATTITUDINISER": "one who attitudinises, also ATTITUDINIZER [n -S]\n",
  "ATTITUDINISERS": "ATTITUDINISER, one who attitudinises, also ATTITUDINIZER [n]\n",
  "ATTITUDINISES": "ATTITUDINISE, to assume affected attitudes, also ATTITUDINIZE [v]\n",
  "ATTITUDINISING": "the assumption of affected attitudes [n -S]\n",
  "ATTITUDINISINGS": "ATTITUDINISING, the assumption of affected attitudes [n]\n",
  "ATTITUDINIZE": "to assume an affected mental attitude, also ATTITUDINISE [v ATTITUDINIZED, ATTITUDINIZING, ATTITUDINIZES]\n",
  "ATTITUDINIZED": "ATTITUDINIZE, to assume an affected mental attitude, also ATTITUDINISE [v]\n",
  "ATTITUDINIZER": "one who attitudinizes, also ATTITUDINISER [n -S]\n",
  "ATTITUDINIZERS": "ATTITUDINIZER, one who attitudinizes, also ATTITUDINISER [n]\n",
  "ATTITUDINIZES": "ATTITUDINIZE, to assume an affected mental attitude, also ATTITUDINISE [v]\n",
  "ATTITUDINIZING": "the assumption of affected attitudes [n -S]\n",
  "ATTITUDINIZINGS": "ATTITUDINIZING, the assumption of affected attitudes [n]\n",
  "ATTOLASER": "a high-powered laser capable of producing pulses measured in quintillionths of a second [n -S]\n",
  "ATTOLASERS": "ATTOLASER, a high-powered laser capable of producing pulses measured in quintillionths of a second [n]\n",
  "ATTOLLENS": "(Latin) of a muscle, that raises, also ATTOLLENT [adj]\n",
  "ATTOLLENT": "lifting up, raising [adj] / a muscle that raises, also ATTOLLENS [n -S]\n",
  "ATTOLLENTS": "ATTOLLENT, a muscle that raises, also ATTOLLENS [n]\n",
  "ATTOMETER": "ten to the power of minus eighteen metres, also ATTOMETRE [n -S]\n",
  "ATTOMETERS": "ATTOMETER, ten to the power of minus eighteen metres, also ATTOMETRE [n]\n",
  "ATTOMETRE": "ten to the power of minus eighteen metres, also ATTOMETER [n -S]\n",
  "ATTOMETRES": "ATTOMETRE, ten to the power of minus eighteen metres, also ATTOMETER [n]\n",
  "ATTONCE": "(Spenser) at one, at once, together, also ATTONE, ATTONES [adv]\n",
  "ATTONE": "to atone [v ATTONED, ATTONING, ATTONES]\n",
  "ATTONED": "ATTONE, to atone [v]\n",
  "ATTONES": "at one, at once, together, also ATTONCE, ATTONE [adv]\n",
  "ATTONING": "ATTONE, to atone [v]\n",
  "ATTOPHYSICS": "the branch of physics concerned with dynamic processes that take place with a time resolution of the order of quintillionths of a second [n]\n",
  "ATTORN": "to accept tenancy from a new landlord [v -ED, -ING, -S]\n",
  "ATTORNED": "ATTORN, to accept tenancy from a new landlord [v]\n",
  "ATTORNEY": "a person formally appointed to act for another in legal or business matters [n -S] / (Shakespeare) to perform by proxy [v -ED, -ING, -S]\n",
  "ATTORNEYDOM": "the office of attorney [n -S]\n",
  "ATTORNEYDOMS": "ATTORNEYDOM, the office of attorney [n]\n",
  "ATTORNEYED": "ATTORNEY, (Shakespeare) to perform by proxy [v]\n",
  "ATTORNEYING": "ATTORNEY, (Shakespeare) to perform by proxy [v]\n",
  "ATTORNEYISM": "the state of being an attorney [n -S]\n",
  "ATTORNEYISMS": "ATTORNEYISM, the state of being an attorney [n]\n",
  "ATTORNEYS": "ATTORNEY, a person formally appointed to act for another in legal or business matters [n]\n",
  "ATTORNEYSHIP": "the office of attorney [n -S]\n",
  "ATTORNEYSHIPS": "ATTORNEYSHIP, the office of attorney [n]\n",
  "ATTORNING": "ATTORN, to accept tenancy from a new landlord [v]\n",
  "ATTORNMENT": "the acknowledgement of a new landlord [n -S]\n",
  "ATTORNMENTS": "ATTORNMENT, the acknowledgement of a new landlord [n]\n",
  "ATTORNS": "ATTORN, to accept tenancy from a new landlord [v]\n",
  "ATTOSECOND": "ten to the power of minus eighteen seconds [n -S]\n",
  "ATTOSECONDS": "ATTOSECOND, ten to the power of minus eighteen seconds [n]\n",
  "ATTOTESLA": "ten to the power of minus eighteen teslas [n -S]\n",
  "ATTOTESLAS": "ATTOTESLA, ten to the power of minus eighteen teslas [n]\n",
  "ATTRACT": "to cause to approach or adhere [v -ED, -ING, -S]\n",
  "ATTRACTABLE": "capable of being attracted [adj]\n",
  "ATTRACTANCE": "the state of being attracted, also ATTRACTANCY [n -S]\n",
  "ATTRACTANCES": "ATTRACTANCE, the state of being attracted, also ATTRACTANCY [n]\n",
  "ATTRACTANCIES": "ATTRACTANCY, the state of being attracted, also ATTRACTANCE [n]\n",
  "ATTRACTANCY": "the state of being attracted, also ATTRACTANCE [n ATTRACTANCIES]\n",
  "ATTRACTANT": "a substance that attracts [n -S]\n",
  "ATTRACTANTS": "ATTRACTANT, a substance that attracts [n]\n",
  "ATTRACTED": "ATTRACT, to cause to approach or adhere [v]\n",
  "ATTRACTER": "one who attracts, also ATTRACTOR [n -S]\n",
  "ATTRACTERS": "ATTRACTER, one who attracts, also ATTRACTOR [n]\n",
  "ATTRACTING": "ATTRACT, to cause to approach or adhere [v]\n",
  "ATTRACTINGLY": "ATTRACTING, ATTRACT, to cause to approach or adhere [adv]\n",
  "ATTRACTION": "the act, process, or power of attracting [n -S]\n",
  "ATTRACTIONS": "ATTRACTION, the act, process, or power of attracting [n]\n",
  "ATTRACTIVE": "having or relating to the power to attract [adj ATTRACTIVELY]\n",
  "ATTRACTIVELY": "ATTRACTIVE, having or relating to the power to attract [adv]\n",
  "ATTRACTIVENESS": "the state of being attractive [n]\n",
  "ATTRACTOR": "one who attracts, also ATTRACTER [n -S]\n",
  "ATTRACTORS": "ATTRACTOR, one who attracts, also ATTRACTER [n]\n",
  "ATTRACTS": "ATTRACT, to cause to approach or adhere [v]\n",
  "ATTRAHENS": "(Latin) attracting [adj]\n",
  "ATTRAHENT": "attracting; drawing towards or forward, also ATTRAHENS [adj] / a muscle that draws towards [n -S]\n",
  "ATTRAHENTS": "ATTRAHENT, a muscle that draws towards [n]\n",
  "ATTRAP": "(Spenser) to adorn with trappings [v ATTRAPPED, ATTRAPPING, ATTRAPS]\n",
  "ATTRAPPED": "ATTRAP, (Spenser) to adorn with trappings [v]\n",
  "ATTRAPPING": "ATTRAP, (Spenser) to adorn with trappings [v]\n",
  "ATTRAPS": "ATTRAP, (Spenser) to adorn with trappings [v]\n",
  "ATTRIBUTABLE": "capable of being attributed [adj]\n",
  "ATTRIBUTE": "to ascribe [v ATTRIBUTED, ATTRIBUTING, ATTRIBUTES]\n",
  "ATTRIBUTED": "ATTRIBUTE, to ascribe [v]\n",
  "ATTRIBUTER": "one who attributes, also ATTRIBUTOR [n -S]\n",
  "ATTRIBUTERS": "ATTRIBUTER, one who attributes, also ATTRIBUTOR [n]\n",
  "ATTRIBUTES": "ATTRIBUTE, to ascribe [v]\n",
  "ATTRIBUTING": "ATTRIBUTE, to ascribe [v]\n",
  "ATTRIBUTION": "the act of attributing [n -S]\n",
  "ATTRIBUTIONAL": "relating to attribution [adj]\n",
  "ATTRIBUTIONS": "ATTRIBUTION, the act of attributing [n]\n",
  "ATTRIBUTIVE": "expressing an attribute [adj ATTRIBUTIVELY] / a word added to another to denote an attribute [n -S]\n",
  "ATTRIBUTIVELY": "ATTRIBUTIVE, expressing an attribute [adv]\n",
  "ATTRIBUTIVENESS": "the state of being attributive [n]\n",
  "ATTRIBUTIVES": "ATTRIBUTIVE, a word added to another to denote an attribute [n]\n",
  "ATTRIBUTOR": "one who attributes, also ATTRIBUTER [n -S]\n",
  "ATTRIBUTORS": "ATTRIBUTOR, one who attributes, also ATTRIBUTER [n]\n",
  "ATTRIST": "(obsolete) to sadden [v -ED, -ING, -S]\n",
  "ATTRISTED": "ATTRIST, (obsolete) to sadden [v]\n",
  "ATTRISTING": "ATTRIST, (obsolete) to sadden [v]\n",
  "ATTRISTS": "ATTRIST, (obsolete) to sadden [v]\n",
  "ATTRIT": "to wear down, also ATTRITE [v ATTRITTED, ATTRITTING, ATTRITS]\n",
  "ATTRITE": "to wear down, also ATTRIT [v ATTRITED, ATTRITING, ATTRITES]\n",
  "ATTRITED": "ATTRITE, to wear down, also ATTRIT [v]\n",
  "ATTRITES": "ATTRITE, to wear down, also ATTRIT [v]\n",
  "ATTRITING": "ATTRITE, to wear down, also ATTRIT [v]\n",
  "ATTRITION": "a wearing away [n -S]\n",
  "ATTRITIONAL": "relating to attrition [adj]\n",
  "ATTRITIONS": "ATTRITION, a wearing away [n]\n",
  "ATTRITIVE": "tending to attrite, wear down [adj]\n",
  "ATTRITS": "ATTRIT, to wear down, also ATTRITE [v]\n",
  "ATTRITTED": "ATTRIT, to wear down, also ATTRITE [v]\n",
  "ATTRITTING": "ATTRIT, to wear down, also ATTRITE [v]\n",
  "ATTUENT": "operating between sensation and perception [adj]\n",
  "ATTUITE": "to sense but not quite perceive [v ATTUITED, ATTUITING, ATTUITES]\n",
  "ATTUITED": "ATTUITE, to sense but not quite perceive [v]\n",
  "ATTUITES": "ATTUITE, to sense but not quite perceive [v]\n",
  "ATTUITING": "ATTUITE, to sense but not quite perceive [v]\n",
  "ATTUITION": "a mental operation intermediate between sensation and perception [n -S]\n",
  "ATTUITIONAL": "relating to attuition [adj]\n",
  "ATTUITIONS": "ATTUITION, a mental operation intermediate between sensation and perception [n]\n",
  "ATTUITIVE": "relating to attuition, a mental operation intermediate between sensation and perception [adj ATTUITIVELY]\n",
  "ATTUITIVELY": "ATTUITIVE, relating to attuition, a mental operation intermediate between sensation and perception [adv]\n",
  "ATTUNE": "to put in tune [v ATTUNED, ATTUNING, ATTUNES]\n",
  "ATTUNED": "ATTUNE, to put in tune [v]\n",
  "ATTUNEMENT": "the state of being attuned [n -S]\n",
  "ATTUNEMENTS": "ATTUNEMENT, the state of being attuned [n]\n",
  "ATTUNES": "ATTUNE, to put in tune [v]\n",
  "ATTUNING": "ATTUNE, to put in tune [v]\n",
  "ATUA": "(Polynesian) the spirit of an ancestor [n -S]\n",
  "ATUAS": "ATUA, (Polynesian) the spirit of an ancestor [n]\n",
  "ATWAIN": "(archaic) in twain; asunder [adv]\n",
  "ATWEEL": "(Scots) well, indeed, also AWEEL [interj]\n",
  "ATWEEN": "between [prep]\n",
  "ATWITTER": "twittering [adj]\n",
  "ATWIXT": "betwixt [adv]\n",
  "ATYPIC": "not typical, also ATYPICAL [adj ATYPICALLY]\n",
  "ATYPICAL": "not typical, also ATYPIC [adj ATYPICALLY]\n",
  "ATYPICALITIES": "ATYPICALITY, the state of being atypical [n]\n",
  "ATYPICALITY": "the state of being atypical [n ATYPICALITIES]\n",
  "ATYPICALLY": "ATYPICAL, not typical, also ATYPIC [adv]\n",
  "AUA": "(Maori) the yellow-eye mullet [n -S]\n",
  "AUAS": "AUA, (Maori) the yellow-eye mullet [n]\n",
  "AUBADE": "(French) a song or poem greeting the dawn or about lovers parting at dawn [n -S]\n",
  "AUBADES": "AUBADE, (French) a song or poem greeting the dawn or about lovers parting at dawn [n]\n",
  "AUBERGE": "(French) an inn, also ALBERGO [n -S]\n",
  "AUBERGES": "AUBERGE, (French) an inn, also ALBERGO [n]\n",
  "AUBERGINE": "(French) an eggplant [n -S]\n",
  "AUBERGINES": "AUBERGINE, (French) an eggplant [n]\n",
  "AUBERGISTE": "(French) an innkeeper [n -S]\n",
  "AUBERGISTES": "AUBERGISTE, (French) an innkeeper [n]\n",
  "AUBRETIA": "any of several dwarf trailing cruciferous plants of the genus Aubrieta, usually bearing violet or purple flowers, also AUBRIETA, AUBRIETIA [n -S]\n",
  "AUBRETIAS": "AUBRETIA, any of several dwarf trailing cruciferous plants of the genus Aubrieta, usually bearing violet or purple flowers, also AUBRIETA, AUBRIETIA [n]\n",
  "AUBRIETA": "any of several dwarf trailing cruciferous plants of the genus Aubrieta, usually bearing violet or purple flowers, also AUBRETIA, AUBRIETIA [n -S]\n",
  "AUBRIETAS": "AUBRIETA, any of several dwarf trailing cruciferous plants of the genus Aubrieta, usually bearing violet or purple flowers, also AUBRETIA, AUBRIETIA [n]\n",
  "AUBRIETIA": "any of several dwarf trailing cruciferous plants of the genus Aubrieta, usually bearing violet or purple flowers, also AUBRETIA, AUBRIETA [n -S]\n",
  "AUBRIETIAS": "AUBRIETIA, any of several dwarf trailing cruciferous plants of the genus Aubrieta, usually bearing violet or purple flowers, also AUBRETIA, AUBRIETA [n]\n",
  "AUBURN": "a reddish brown colour [n -S]\n",
  "AUBURNS": "AUBURN, a reddish brown colour [n]\n",
  "AUCEPS": "(Latin) a hawker or bird-tender [n -ES]\n",
  "AUCEPSES": "AUCEPS, (Latin) a hawker or bird-tender [n]\n",
  "AUCTION": "to sell publicly to the highest bidder [v -ED, -ING, -S]\n",
  "AUCTIONARY": "of or pertaining to an auction or an auctioneer [adj]\n",
  "AUCTIONED": "AUCTION, to sell publicly to the highest bidder [v]\n",
  "AUCTIONEER": "an agent who sells goods at auction [n -S] / to sell by auction [v -ED, -ING, -S]\n",
  "AUCTIONEERED": "AUCTIONEER, to sell by auction [v]\n",
  "AUCTIONEERING": "AUCTIONEER, to sell by auction [v]\n",
  "AUCTIONEERS": "AUCTIONEER, an agent who sells goods at auction [n]\n",
  "AUCTIONING": "AUCTION, to sell publicly to the highest bidder [v]\n",
  "AUCTIONS": "AUCTION, to sell publicly to the highest bidder [v]\n",
  "AUCTORIAL": "of or relating to an author [adj]\n",
  "AUCUBA": "a shrub of the dogwood family [n -S]\n",
  "AUCUBAS": "AUCUBA, a shrub of the dogwood family [n]\n",
  "AUDACIOUS": "bold, also OUTDACIOUS [adj AUDACIOUSLY]\n",
  "AUDACIOUSLY": "AUDACIOUS, bold, also OUTDACIOUS [adv]\n",
  "AUDACIOUSNESS": "the state of being audacious [n -ES]\n",
  "AUDACIOUSNESSES": "AUDACIOUSNESS, the state of being audacious [n]\n",
  "AUDACITIES": "AUDACITY, boldness [n]\n",
  "AUDACITY": "boldness [n AUDACITIES]\n",
  "AUDAD": "a North African wild sheep, also AOUDAD [n -S]\n",
  "AUDADS": "AUDAD, a North African wild sheep, also AOUDAD [n]\n",
  "AUDIAL": "relating to hearing or sounds [adj]\n",
  "AUDIBILITIES": "AUDIBILITY, the state of being audible [n]\n",
  "AUDIBILITY": "the state of being audible [n AUDIBILITIES]\n",
  "AUDIBLE": "able to be heard [adj AUDIBLY] / a tactic or game plan shouted out in coded form by a quarterback in American football [n -S] / to call out such a plan [v AUDIBLED, AUDIBLING, AUDIBLES]\n",
  "AUDIBLED": "AUDIBLE, to call out such a plan [v]\n",
  "AUDIBLENESS": "the state of being audible [n -ES]\n",
  "AUDIBLENESSES": "AUDIBLENESS, the state of being audible [n]\n",
  "AUDIBLES": "AUDIBLE, to call out such a plan [v]\n",
  "AUDIBLING": "AUDIBLE, to call out such a plan [v]\n",
  "AUDIBLY": "able to be heard [adv]\n",
  "AUDIENCE": "a group of listeners or spectators [n -S]\n",
  "AUDIENCES": "AUDIENCE, a group of listeners or spectators [n]\n",
  "AUDIENCIA": "(Spanish) a court of government or justice in the Spanish American empire [n -S]\n",
  "AUDIENCIAS": "AUDIENCIA, (Spanish) a court of government or justice in the Spanish American empire [n]\n",
  "AUDIENT": "a hearer [n -S]\n",
  "AUDIENTS": "AUDIENT, a hearer [n]\n",
  "AUDILE": "one who thinks in terms of sounds [n -S]\n",
  "AUDILES": "AUDILE, one who thinks in terms of sounds [n]\n",
  "AUDING": "hearing, recognizing and interpreting a language [n -S]\n",
  "AUDINGS": "AUDING, hearing, recognizing and interpreting a language [n]\n",
  "AUDIO": "reproduction of recorded or broadcast sounds [n -S]\n",
  "AUDIOBOOK": "a recorded reading of a book [n -S]\n",
  "AUDIOBOOKS": "AUDIOBOOK, a recorded reading of a book [n]\n",
  "AUDIOCASSETTE": "an audiotape recording mounted in a cassette [n -S]\n",
  "AUDIOCASSETTES": "AUDIOCASSETTE, an audiotape recording mounted in a cassette [n]\n",
  "AUDIOGENIC": "caused by sound waves, esp. of high frequency [adj]\n",
  "AUDIOGRAM": "a graphic representation of the relation of vibration frequency and the minimum sound intensity for hearing [n -S]\n",
  "AUDIOGRAMS": "AUDIOGRAM, a graphic representation of the relation of vibration frequency and the minimum sound intensity for hearing [n]\n",
  "AUDIOGRAPH": "a machine used to test a patient's hearing by transmitting sound waves directly to the inner ear [n -S]\n",
  "AUDIOGRAPHS": "AUDIOGRAPH, a machine used to test a patient's hearing by transmitting sound waves directly to the inner ear [n]\n",
  "AUDIOLOGIC": "relating to the study of hearing, also AUDIOLOGICAL [adj]\n",
  "AUDIOLOGICAL": "relating to the study of hearing, also AUDIOLOGIC [adj AUDIOLOGICALLY]\n",
  "AUDIOLOGICALLY": "AUDIOLOGICAL, relating to the study of hearing, also AUDIOLOGIC [adv]\n",
  "AUDIOLOGIES": "AUDIOLOGY, the study of hearing [n]\n",
  "AUDIOLOGIST": "one who studies hearing [n -S]\n",
  "AUDIOLOGISTS": "AUDIOLOGIST, one who studies hearing [n]\n",
  "AUDIOLOGY": "the study of hearing [n AUDIOLOGIES]\n",
  "AUDIOMETER": "an instrument for measuring acuity of hearing [n -S]\n",
  "AUDIOMETERS": "AUDIOMETER, an instrument for measuring acuity of hearing [n]\n",
  "AUDIOMETRIC": "relating to audiometry, the measurement of the acuity of hearing [adj AUDIOMETRICALLY]\n",
  "AUDIOMETRICALLY": "AUDIOMETRIC, relating to audiometry, the measurement of the acuity of hearing [adv]\n",
  "AUDIOMETRICIAN": "one who measures differences in hearing, also AUDIOMETRIST [n -S]\n",
  "AUDIOMETRICIANS": "AUDIOMETRICIAN, one who measures differences in hearing, also AUDIOMETRIST [n]\n",
  "AUDIOMETRIES": "AUDIOMETRY, the measurement of the acuity of hearing [n]\n",
  "AUDIOMETRIST": "one who measures differences in hearing, also AUDIOMETRICIAN [n -S]\n",
  "AUDIOMETRISTS": "AUDIOMETRIST, one who measures differences in hearing, also AUDIOMETRICIAN [n]\n",
  "AUDIOMETRY": "the measurement of the acuity of hearing [n AUDIOMETRIES]\n",
  "AUDIOPHIL": "a person who is enthusiastic about hi-fidelity sound reproduction, also AUDIOPHILE [n -S]\n",
  "AUDIOPHILE": "a person who is enthusiastic about hi-fidelity sound reproduction, also AUDIOPHIL [n -S]\n",
  "AUDIOPHILES": "AUDIOPHILE, a person who is enthusiastic about hi-fidelity sound reproduction, also AUDIOPHIL [n]\n",
  "AUDIOPHILS": "AUDIOPHIL, a person who is enthusiastic about hi-fidelity sound reproduction, also AUDIOPHILE [n]\n",
  "AUDIOS": "AUDIO, reproduction of recorded or broadcast sounds [n]\n",
  "AUDIOTAPE": "magnetic tape for recording and reproducing sound [n -S] / to record on audiotape [v AUDIOTAPED, AUDIOTAPING, AUDIOTAPES]\n",
  "AUDIOTAPED": "AUDIOTAPE, to record on audiotape [v]\n",
  "AUDIOTAPES": "AUDIOTAPE, to record on audiotape [v]\n",
  "AUDIOTAPING": "AUDIOTAPE, to record on audiotape [v]\n",
  "AUDIOTYPING": "typing directly from a dictating machine [n -S]\n",
  "AUDIOTYPINGS": "AUDIOTYPING, typing directly from a dictating machine [n]\n",
  "AUDIOTYPIST": "one who does audiotyping [n -S]\n",
  "AUDIOTYPISTS": "AUDIOTYPIST, one who does audiotyping [n]\n",
  "AUDIOVISUAL": "relating to hearing and sight [adj AUDIOVISUALLY] / a device designed to aid in learning or teaching by making use of both hearing and sight [n -S]\n",
  "AUDIOVISUALLY": "AUDIOVISUAL, relating to hearing and sight [adv]\n",
  "AUDIOVISUALS": "AUDIOVISUAL, a device designed to aid in learning or teaching by making use of both hearing and sight [n]\n",
  "AUDIPHONE": "an instrument which, pressed against the teeth, communicates sounds through the bones to the ears [n -S]\n",
  "AUDIPHONES": "AUDIPHONE, an instrument which, pressed against the teeth, communicates sounds through the bones to the ears [n]\n",
  "AUDISM": "discrimination or prejudice against deaf people [n -S]\n",
  "AUDISMS": "AUDISM, discrimination or prejudice against deaf people [n]\n",
  "AUDIST": "one who practises audism, prejudice against the deaf [n -S]\n",
  "AUDISTS": "AUDIST, one who practises audism, prejudice against the deaf [n]\n",
  "AUDIT": "to examine accounts [v -ED, -ING, -S]\n",
  "AUDITABLE": "that can be audited [adj]\n",
  "AUDITED": "AUDIT, to examine accounts [v]\n",
  "AUDITEE": "one that is audited [n -S]\n",
  "AUDITEES": "AUDITEE, one that is audited [n]\n",
  "AUDITING": "the act of performing an audit [n -S]\n",
  "AUDITINGS": "AUDITING, the act of performing an audit [n]\n",
  "AUDITION": "to give a trial performance [v -ED, -ING, -S]\n",
  "AUDITIONED": "AUDITION, to give a trial performance [v]\n",
  "AUDITIONER": "one who auditions [n -S]\n",
  "AUDITIONERS": "AUDITIONER, one who auditions [n]\n",
  "AUDITIONING": "AUDITION, to give a trial performance [v]\n",
  "AUDITIONS": "AUDITION, to give a trial performance [v]\n",
  "AUDITIVE": "a group of listeners, also AUDITORY [n -S]\n",
  "AUDITIVES": "AUDITIVE, a group of listeners, also AUDITORY [n]\n",
  "AUDITOR": "one that audits [n -S]\n",
  "AUDITORIA": "AUDITORIUM, (Latin) the part of a theatre, lecture-hall, or other public building occupied by the audience [n]\n",
  "AUDITORIAL": "relating to an auditor [adj]\n",
  "AUDITORIES": "AUDITORY, a group of listeners, also AUDITIVE [n]\n",
  "AUDITORILY": "AUDITORY, related to hearing [adv]\n",
  "AUDITORIUM": "(Latin) the part of a theatre, lecture-hall, or other public building occupied by the audience [n AUDITORIUMS or AUDITORIA]\n",
  "AUDITORIUMS": "AUDITORIUM, (Latin) the part of a theatre, lecture-hall, or other public building occupied by the audience [n]\n",
  "AUDITORS": "AUDITOR, one that audits [n]\n",
  "AUDITORSHIP": "the office of auditor [n -S]\n",
  "AUDITORSHIPS": "AUDITORSHIP, the office of auditor [n]\n",
  "AUDITORY": "related to hearing [adj AUDITORILY] / a group of listeners, also AUDITIVE [n AUDITORIES]\n",
  "AUDITRESS": "a female hearer [n -ES]\n",
  "AUDITRESSES": "AUDITRESS, a female hearer [n]\n",
  "AUDITS": "AUDIT, to examine accounts [v]\n",
  "AUE": "(Maori) an exclamation of pain, distress or astonishment [interj]\n",
  "AUF": "(obsolete) an elf's child [n -S]\n",
  "AUFGABE": "(German) a set experimental task in psychology [n -S]\n",
  "AUFGABES": "AUFGABE, (German) a set experimental task in psychology [n]\n",
  "AUFS": "AUF, (obsolete) an elf's child [n]\n",
  "AUGEND": "(German) a number to which another is added [n -S]\n",
  "AUGENDS": "AUGEND, (German) a number to which another is added [n]\n",
  "AUGER": "a kind of boring tool [n -S]\n",
  "AUGERS": "AUGER, a kind of boring tool [n]\n",
  "AUGH": "an interjection expressing despair or frustration [interj]\n",
  "AUGHT": "anything, also OUCHT, OWT [n -S]\n",
  "AUGHTS": "AUGHT, anything, also OUCHT, OWT [n]\n",
  "AUGITE": "one of the pyroxene group of minerals, very similar to hornblende [n -S]\n",
  "AUGITES": "AUGITE, one of the pyroxene group of minerals, very similar to hornblende [n]\n",
  "AUGITIC": "pertaining to, or like, augite, one of the pyroxene group of minerals [adj]\n",
  "AUGMENT": "to increase [v -ED, -ING, -S]\n",
  "AUGMENTABLE": "that can be augmented [adj]\n",
  "AUGMENTATION": "the act of augmenting [n -S]\n",
  "AUGMENTATIONS": "AUGMENTATION, the act of augmenting [n]\n",
  "AUGMENTATIVE": "serving to augment [adj AUGMENTATIVELY] / an augmentative word or affix [n -S]\n",
  "AUGMENTATIVELY": "AUGMENTATIVE, serving to augment [adv]\n",
  "AUGMENTATIVES": "AUGMENTATIVE, an augmentative word or affix [n]\n",
  "AUGMENTED": "AUGMENT, to increase [v]\n",
  "AUGMENTER": "one who, or that which, augments, also AUGMENTOR [n -S]\n",
  "AUGMENTERS": "AUGMENTER, one who, or that which, augments, also AUGMENTOR [n]\n",
  "AUGMENTING": "AUGMENT, to increase [v]\n",
  "AUGMENTOR": "one who, or that which, augments, also AUGMENTER [n -S]\n",
  "AUGMENTORS": "AUGMENTOR, one who, or that which, augments, also AUGMENTER [n]\n",
  "AUGMENTS": "AUGMENT, to increase [v]\n",
  "AUGUR": "to foretell from signs [v -ED, -ING, -S]\n",
  "AUGURAL": "of or pertaining to augurs or augury [adj]\n",
  "AUGURED": "AUGUR, to foretell from signs [v]\n",
  "AUGURER": "(Shakespeare) an augur [n -S]\n",
  "AUGURERS": "AUGURER, (Shakespeare) an augur [n]\n",
  "AUGURIES": "AUGURY, the art of auguring [n]\n",
  "AUGURING": "AUGUR, to foretell from signs [v]\n",
  "AUGURS": "AUGUR, to foretell from signs [v]\n",
  "AUGURSHIP": "the office, or period of office, of an augur [n -S]\n",
  "AUGURSHIPS": "AUGURSHIP, the office, or period of office, of an augur [n]\n",
  "AUGURY": "the art of auguring [n AUGURIES]\n",
  "AUGUST": "stately, venerable [adj AUGUSTER, AUGUSTEST, AUGUSTLY] / a white-faced circus clown [n -S]\n",
  "AUGUSTE": "(French) a circus clown of the white-faced, bungling type [n -S]\n",
  "AUGUSTER": "AUGUST, stately, venerable [adj]\n",
  "AUGUSTES": "AUGUSTE, (French) a circus clown of the white-faced, bungling type [n]\n",
  "AUGUSTEST": "AUGUST, stately, venerable [adj]\n",
  "AUGUSTLY": "AUGUST, stately, venerable [adv]\n",
  "AUGUSTNESS": "the state of being august [n -ES]\n",
  "AUGUSTNESSES": "AUGUSTNESS, the state of being august [n]\n",
  "AUGUSTS": "AUGUST, a white-faced circus clown [n]\n",
  "AUK": "a type of seabird [n -S]\n",
  "AUKLET": "a small auk [n -S]\n",
  "AUKLETS": "AUKLET, a small auk [n]\n",
  "AUKS": "AUK, a type of seabird [n]\n",
  "AULA": "(Latin) a hall [n -S]\n",
  "AULARIAN": "a member of a hall at Oxford [n -S]\n",
  "AULARIANS": "AULARIAN, a member of a hall at Oxford [n]\n",
  "AULAS": "AULA, (Latin) a hall [n]\n",
  "AULD": "(Scots) old [adj AULDER, AULDEST]\n",
  "AULDER": "AULD, (Scots) old [adj]\n",
  "AULDEST": "AULD, (Scots) old [adj]\n",
  "AULIC": "relating to a royal court [adj]\n",
  "AULNAGE": "cloth inspection, also ALNAGE [n -S]\n",
  "AULNAGER": "cloth inspector, also ALNAGER [n -S]\n",
  "AULNAGERS": "AULNAGER, cloth inspector, also ALNAGER [n]\n",
  "AULNAGES": "AULNAGE, cloth inspection, also ALNAGE [n]\n",
  "AULOI": "AULOS, (Greek) an ancient wind instrument [n]\n",
  "AULOS": "(Greek) an ancient wind instrument [n AULOI]\n",
  "AUMAIL": "(archaic) to enamel [v -ED, -ING, -S]\n",
  "AUMAILED": "AUMAIL, (archaic) to enamel [v]\n",
  "AUMAILING": "AUMAIL, (archaic) to enamel [v]\n",
  "AUMAILS": "AUMAIL, (archaic) to enamel [v]\n",
  "AUMBRIES": "AUMBRY, a cupboard for sacred vessels, also AMBRY, ALMERY, AMBERY, AWMRIE, AWMRY [n]\n",
  "AUMBRY": "a cupboard for sacred vessels, also AMBRY, ALMERY, AMBERY, AWMRIE, AWMRY [n AUMBRIES]\n",
  "AUMIL": "a factor or manager in India, a collector of revenues [n -S]\n",
  "AUMILS": "AUMIL, a factor or manager in India, a collector of revenues [n]\n",
  "AUNE": "(obsolete) an ell; a French measure of cloth [n -S]\n",
  "AUNES": "AUNE, (obsolete) an ell; a French measure of cloth [n]\n",
  "AUNT": "the sister of a mother or father [n -S]\n",
  "AUNTER": "(obsolete) an adventure [n -S]\n",
  "AUNTERS": "AUNTER, (obsolete) an adventure [n]\n",
  "AUNTHOOD": "the state of being an aunt [n -S]\n",
  "AUNTHOODS": "AUNTHOOD, the state of being an aunt [n]\n",
  "AUNTIE": "a familiar name for an aunt, also AUNTY [n -S]\n",
  "AUNTIES": "AUNTY, an aunt, also AUNTIE [n]\n",
  "AUNTLIER": "AUNTLY, like an aunt [adj]\n",
  "AUNTLIEST": "AUNTLY, like an aunt [adj]\n",
  "AUNTLIKE": "like an aunt [adj]\n",
  "AUNTLY": "like an aunt [adj AUNTLIER, AUNTLIEST]\n",
  "AUNTS": "AUNT, the sister of a mother or father [n]\n",
  "AUNTY": "an aunt, also AUNTIE [n AUNTIES]\n",
  "AURA": "(Latin) a subtle emanation [n AURAS or AURAE]\n",
  "AURAE": "AURA, (Latin) a subtle emanation [n]\n",
  "AURAL": "pertaining to the ear or hearing [adj AURALLY]\n",
  "AURALITIES": "AURALITY, the quality of being aural [n]\n",
  "AURALITY": "the quality of being aural [n AURALITIES]\n",
  "AURALLY": "like an ear [adv]\n",
  "AURAR": "EYRIR, (Icelandic) a monetary unit of Iceland [n]\n",
  "AURAS": "AURA, (Latin) a subtle emanation [n]\n",
  "AURATE": "a salt derived from auric acid [n -S]\n",
  "AURATED": "gold-coloured [adj]\n",
  "AURATES": "AURATE, a salt derived from auric acid [n]\n",
  "AUREATE": "pertaining to the fancy or flowery words used by poets [adj AUREATELY]\n",
  "AUREATELY": "AUREATE, pertaining to the fancy or flowery words used by poets [adv]\n",
  "AUREATENESS": "the state of being aureate [n -ES]\n",
  "AUREATENESSES": "AUREATENESS, the state of being aureate [n]\n",
  "AUREI": "AUREUS, (Latin) a gold coin of ancient Rome [n]\n",
  "AUREITIES": "AUREITY, properties of gold [n]\n",
  "AUREITY": "properties of gold [n AUREITIES]\n",
  "AURELIA": "(Italian) a genus of jellyfish [n -S]\n",
  "AURELIAN": "one who studies moths and butterflies [n -S]\n",
  "AURELIANS": "AURELIAN, one who studies moths and butterflies [n]\n",
  "AURELIAS": "AURELIA, (Italian) a genus of jellyfish [n]\n",
  "AUREOLA": "(Latin) a halo [n AUREOLAS or AUREOLAE]\n",
  "AUREOLAE": "AUREOLA, (Latin) a halo [n]\n",
  "AUREOLAS": "AUREOLA, (Latin) a halo [n]\n",
  "AUREOLE": "a glorifying halo, also AUREOLA [n -S] / to surround with a halo [v AUREOLED, AUREOLING, AUREOLES]\n",
  "AUREOLED": "AUREOLE, to surround with a halo [v]\n",
  "AUREOLES": "AUREOLE, to surround with a halo [v]\n",
  "AUREOLING": "AUREOLE, to surround with a halo [v]\n",
  "AURES": "AURIS, (Latin) the ear [n]\n",
  "AUREUS": "(Latin) a gold coin of ancient Rome [n AUREI]\n",
  "AURIC": "pertaining to, like or composed of gold [adj]\n",
  "AURICLE": "the outer projecting part of the ear; an upper cavity of the heart [n -S]\n",
  "AURICLED": "having ear-shaped appendages or lobes [adj]\n",
  "AURICLES": "AURICLE, the outer projecting part of the ear; an upper cavity of the heart [n]\n",
  "AURICULA": "(Latin) a species of Primula, or primrose, aka, from the shape of its leaves, bear's-ear [n AURICULAE or AURICULAS]\n",
  "AURICULAE": "AURICULA, (Latin) a species of Primula, or primrose, aka, from the shape of its leaves, bear's-ear [n]\n",
  "AURICULAR": "pertaining to the ear; spoken secretly [adj AURICULARLY] / an auricular feather [n -S]\n",
  "AURICULARLY": "AURICULAR, pertaining to the ear; spoken secretly [adv]\n",
  "AURICULARS": "AURICULAR, an auricular feather [n]\n",
  "AURICULAS": "AURICULA, (Latin) a species of Primula, or primrose, aka, from the shape of its leaves, bear's-ear [n]\n",
  "AURICULATE": "having ears or ear-shaped appendages, also AURICULATED [adj AURICULATELY]\n",
  "AURICULATED": "having ears or ear-shaped appendages, also AURICULATE [adj]\n",
  "AURICULATELY": "AURICULATE, having ears or ear-shaped appendages, also AURICULATED [adv]\n",
  "AURIFEROUS": "containing gold [adj]\n",
  "AURIFIED": "AURIFY, to turn into gold [v]\n",
  "AURIFIES": "AURIFY, to turn into gold [v]\n",
  "AURIFORM": "ear shaped [adj]\n",
  "AURIFY": "to turn into gold [v AURIFIED, AURIFYING, AURIFIES]\n",
  "AURIFYING": "AURIFY, to turn into gold [v]\n",
  "AURIS": "(Latin) the ear [n AURES]\n",
  "AURISCOPE": "an instrument for examining the ear [n -S]\n",
  "AURISCOPES": "AURISCOPE, an instrument for examining the ear [n]\n",
  "AURISCOPIC": "relating to an auriscope, an instrument for examining the ear [adj]\n",
  "AURIST": "a specialist on the ear and its diseases [n -S]\n",
  "AURISTS": "AURIST, a specialist on the ear and its diseases [n]\n",
  "AUROCHS": "(German) an extinct wild ox, aka ure or urus [n -ES]\n",
  "AUROCHSES": "AUROCHS, (German) an extinct wild ox, aka ure or urus [n]\n",
  "AURORA": "(Latin) a luminous atmospheric phenomenon [n AURORAS or AURORAE]\n",
  "AURORAE": "AURORA, (Latin) a luminous atmospheric phenomenon [n]\n",
  "AURORAL": "relating to the dawn, also AUROREAN [adj]\n",
  "AURORALLY": "AURORAL, relating to the dawn, also AUROREAN [adv]\n",
  "AURORAS": "AURORA, (Latin) a luminous atmospheric phenomenon [n]\n",
  "AUROREAN": "relating to the dawn, also AURORAL [adj]\n",
  "AUROUS": "containing univalent gold [adj]\n",
  "AURUM": "(Latin) gold [n -S]\n",
  "AURUMS": "AURUM, (Latin) gold [n]\n",
  "AUSCULTATE": "to listen to the sounds made by internal organs (heart, lungs, etc.) to aid in a medical diagnosis [v AUSCULTATED, AUSCULTATING, AUSCULTATES]\n",
  "AUSCULTATED": "AUSCULTATE, to listen to the sounds made by internal organs (heart, lungs, etc.) to aid in a medical diagnosis [v]\n",
  "AUSCULTATES": "AUSCULTATE, to listen to the sounds made by internal organs (heart, lungs, etc.) to aid in a medical diagnosis [v]\n",
  "AUSCULTATING": "AUSCULTATE, to listen to the sounds made by internal organs (heart, lungs, etc.) to aid in a medical diagnosis [v]\n",
  "AUSCULTATION": "the act of listening, esp. the act of listening for sounds made by internal organs, as the heart and lungs, to aid in the diagnosis of certain disorders [n -S]\n",
  "AUSCULTATIONS": "AUSCULTATION, the act of listening, esp. the act of listening for sounds made by internal organs, as the heart and lungs, to aid in the diagnosis of certain disorders [n]\n",
  "AUSCULTATIVE": "related to auscultation, also AUSCULTATORY [adj]\n",
  "AUSCULTATOR": "a person practising auscultation [n -S]\n",
  "AUSCULTATORS": "AUSCULTATOR, a person practising auscultation [n]\n",
  "AUSCULTATORY": "relating to auscultation, also AUSCULTATIVE [adj]\n",
  "AUSFORM": "(German) to deform, quench, and temper a metal [v -ED, -ING, -S]\n",
  "AUSFORMED": "AUSFORM, (German) to deform, quench, and temper a metal [v]\n",
  "AUSFORMING": "the act of deforming, quenching, and tempering a metal [n -S]\n",
  "AUSFORMINGS": "AUSFORMING, the act of deforming, quenching, and tempering a metal [n]\n",
  "AUSFORMS": "AUSFORM, (German) to deform, quench, and temper a metal [v]\n",
  "AUSLANDER": "(German) a foreigner [n -S]\n",
  "AUSLANDERS": "AUSLANDER, (German) a foreigner [n]\n",
  "AUSPEX": "(Latin) a soothsayer of ancient Rome [n AUSPICES]\n",
  "AUSPICATE": "to prognosticate, predict [v AUSPICATED, AUSPICATING, AUSPICATES]\n",
  "AUSPICATED": "AUSPICATE, to prognosticate, predict [v]\n",
  "AUSPICATES": "AUSPICATE, to prognosticate, predict [v]\n",
  "AUSPICATING": "AUSPICATE, to prognosticate, predict [v]\n",
  "AUSPICE": "a good omen [n -S]\n",
  "AUSPICES": "AUSPICE, a good omen [n]\n",
  "AUSPICIOUS": "affording a favorable auspice [adj AUSPICIOUSLY]\n",
  "AUSPICIOUSLY": "AUSPICIOUS, affording a favorable auspice [adv]\n",
  "AUSPICIOUSNESS": "the state of being auspicious [n]\n",
  "AUSTENITE": "a solid solution of carbon in a nonmagnetic high-temperature allotropic form of iron [n -S]\n",
  "AUSTENITES": "AUSTENITE, a solid solution of carbon in a nonmagnetic high-temperature allotropic form of iron [n]\n",
  "AUSTENITIC": "of stainless steels, composed chiefly of austenite [adj]\n",
  "AUSTERE": "severe [adj AUSTERER, AUSTEREST, AUSTERELY]\n",
  "AUSTERELY": "AUSTERE, severe [adv]\n",
  "AUSTERENESS": "the state of being austere [n -ES]\n",
  "AUSTERENESSES": "AUSTERENESS, the state of being austere [n]\n",
  "AUSTERER": "AUSTERE, severe [adj]\n",
  "AUSTEREST": "AUSTERE, severe [adj]\n",
  "AUSTERITIES": "AUSTERITY, the quality of being austere [n]\n",
  "AUSTERITY": "the quality of being austere [n AUSTERITIES]\n",
  "AUSTRAL": "(Latin) a unit of currency in Argentina [n -ES or -S]\n",
  "AUSTRALES": "AUSTRAL, (Latin) a unit of currency in Argentina [n]\n",
  "AUSTRALIS": "as in aurora australis, lights seen round the South Pole [adj]\n",
  "AUSTRALITE": "a tektite found in the interior of Australia [n -S]\n",
  "AUSTRALITES": "AUSTRALITE, a tektite found in the interior of Australia [n]\n",
  "AUSTRALS": "AUSTRAL, (Latin) a unit of currency in Argentina [n]\n",
  "AUSTRINGER": "a falconer who keeps a goshawk, also ASTRINGER, OSTREGER [n -S]\n",
  "AUSTRINGERS": "AUSTRINGER, a falconer who keeps a goshawk, also ASTRINGER, OSTREGER [n]\n",
  "AUSUBO": "a large evergreen tropical tree, aka balata [n -S]\n",
  "AUSUBOS": "AUSUBO, a large evergreen tropical tree, aka balata [n]\n",
  "AUTACOID": "a hormone secreted into blood, lymph, or sap, also AUTOCOID [n -S]\n",
  "AUTACOIDS": "AUTACOID, a hormone secreted into blood, lymph, or sap, also AUTOCOID [n]\n",
  "AUTARCH": "an absolute ruler [n -S]\n",
  "AUTARCHIC": "relating to autarchy, absolute sovereignty, also AUTARCHICAL, AUTARKIC, AUTARKICAL [adj]\n",
  "AUTARCHICAL": "relating to autarchy, absolute sovereignty, also AUTARCHIC, AUTARKIC, AUTARKICAL [adj]\n",
  "AUTARCHIES": "AUTARCHY, absolute sovereignty [n]\n",
  "AUTARCHIST": "one who practises autarchy [n -S]\n",
  "AUTARCHISTS": "AUTARCHIST, one who practises autarchy [n]\n",
  "AUTARCHS": "AUTARCH, an absolute ruler [n]\n",
  "AUTARCHY": "absolute sovereignty [n AUTARCHIES]\n",
  "AUTARKIC": "relating to autarchy, absolute sovereignty, also AUTARCHIC, AUTARCHICAL, AUTARKICAL [adj]\n",
  "AUTARKICAL": "relating to autarky, absolute sovereignty, also AUTARCHIC, AUTARCHICAL, AUTARKIC [adj]\n",
  "AUTARKIES": "AUTARKY, a policy of national self-sufficiency and non-reliance on imports or economic aid [n]\n",
  "AUTARKIST": "one who is autarkic, self-sufficient [n -S]\n",
  "AUTARKISTS": "AUTARKIST, one who is autarkic, self-sufficient [n]\n",
  "AUTARKY": "a policy of national self-sufficiency and non-reliance on imports or economic aid [n AUTARKIES]\n",
  "AUTECIOUS": "of parasites, completing the entire life cycle on a single species of host [adj]\n",
  "AUTECISM": "the development of the entire life cycle of a parasite on a single host, also AUTOECISM [n -S]\n",
  "AUTECISMS": "AUTECISM, the development of the entire life cycle of a parasite on a single host, also AUTOECISM [n]\n",
  "AUTECOLOGIC": "relating to autecology, the study of one species, also AUTECOLOGICAL [adj]\n",
  "AUTECOLOGICAL": "relating to autecology, the study of one species, also AUTECOLOGIC [adj]\n",
  "AUTECOLOGIES": "AUTECOLOGY, the study of the ecology of one species [n]\n",
  "AUTECOLOGY": "the study of the ecology of one species [n AUTECOLOGIES]\n",
  "AUTEUR": "(French) a film director, esp. when thought of as the creator of a particular genre and carrying a personal stamp, also AUTEURIST [n -S]\n",
  "AUTEURISM": "the profession of auteur, film director [n -S]\n",
  "AUTEURISMS": "AUTEURISM, the profession of auteur, film director [n]\n",
  "AUTEURIST": "a film director whose practice accords with the auteur theory, also AUTEUR [n -S]\n",
  "AUTEURISTS": "AUTEURIST, a film director whose practice accords with the auteur theory, also AUTEUR [n]\n",
  "AUTEURS": "AUTEUR, (French) a film director, esp. when thought of as the creator of a particular genre and carrying a personal stamp, also AUTEURIST [n]\n",
  "AUTHENTIC": "genuine [adj AUTHENTICALLY]\n",
  "AUTHENTICAL": "(archaic) authentic [adj]\n",
  "AUTHENTICALLY": "AUTHENTICAL, (archaic) authentic [adv]\n",
  "AUTHENTICATE": "to prove or serve to prove the authenticity of [v AUTHENTICATED, AUTHENTICATING, AUTHENTICATES]\n",
  "AUTHENTICATED": "AUTHENTICATE, to prove or serve to prove the authenticity of [v]\n",
  "AUTHENTICATES": "AUTHENTICATE, to prove or serve to prove the authenticity of [v]\n",
  "AUTHENTICATING": "AUTHENTICATE, to prove or serve to prove the authenticity of [v]\n",
  "AUTHENTICATION": "the act of authenticating [n -S]\n",
  "AUTHENTICATIONS": "AUTHENTICATION, the act of authenticating [n]\n",
  "AUTHENTICATOR": "one who authenticates [n -S]\n",
  "AUTHENTICATORS": "AUTHENTICATOR, one who authenticates [n]\n",
  "AUTHENTICITIES": "AUTHENTICITY, the state of being authentic [n]\n",
  "AUTHENTICITY": "the state of being authentic [n AUTHENTICITIES]\n",
  "AUTHIGENIC": "of minerals, having crystallized in a sediment during or after deposition [adj]\n",
  "AUTHOR": "to bring into being [v -ED, -ING, -S]\n",
  "AUTHORCRAFT": "the craft of the author [n -S]\n",
  "AUTHORCRAFTS": "AUTHORCRAFT, the craft of the author [n]\n",
  "AUTHORED": "AUTHOR, to bring into being [v]\n",
  "AUTHORESS": "a female author [n -ES]\n",
  "AUTHORESSES": "AUTHORESS, a female author [n]\n",
  "AUTHORIAL": "relating to an author [adj]\n",
  "AUTHORING": "the act of authoring [n -S]\n",
  "AUTHORINGS": "AUTHORING, the act of authoring [n]\n",
  "AUTHORISABLE": "capable of being authorised, also AUTHORIZABLE [adj]\n",
  "AUTHORISATION": "the act of authorising, also AUTHORIZATION [n -S]\n",
  "AUTHORISATIONS": "AUTHORISATION, the act of authorising, also AUTHORIZATION [n]\n",
  "AUTHORISE": "to give authority to, also AUTHORIZE [v AUTHORISED, AUTHORISING, AUTHORISES]\n",
  "AUTHORISED": "AUTHORISE, to give authority to, also AUTHORIZE [v]\n",
  "AUTHORISER": "one who authorises, also AUTHORIZER [n -S]\n",
  "AUTHORISERS": "AUTHORISER, one who authorises, also AUTHORIZER [n]\n",
  "AUTHORISES": "AUTHORISE, to give authority to, also AUTHORIZE [v]\n",
  "AUTHORISH": "like an author [adj]\n",
  "AUTHORISING": "AUTHORISE, to give authority to, also AUTHORIZE [v]\n",
  "AUTHORISM": "authorship [n -S]\n",
  "AUTHORISMS": "AUTHORISM, authorship [n]\n",
  "AUTHORITARIAN": "one who favours blind submission to authority [n -S]\n",
  "AUTHORITARIANS": "AUTHORITARIAN, one who favours blind submission to authority [n]\n",
  "AUTHORITATIVE": "having or proceeding from authority [adj AUTHORITATIVELY]\n",
  "AUTHORITATIVELY": "AUTHORITATIVE, having or proceeding from authority [adv]\n",
  "AUTHORITIES": "AUTHORITY, the power or right to control the behaviour of others [n]\n",
  "AUTHORITY": "the power or right to control the behaviour of others [n AUTHORITIES]\n",
  "AUTHORIZABLE": "capable of being authorized, also AUTHORISABLE [adj]\n",
  "AUTHORIZATION": "the act of authorizing, also AUTHORISATION [n -S]\n",
  "AUTHORIZATIONS": "AUTHORIZATION, the act of authorizing, also AUTHORISATION [n]\n",
  "AUTHORIZE": "to give authority to, also AUTHORISE [v AUTHORIZED, AUTHORIZING, AUTHORIZES]\n",
  "AUTHORIZED": "AUTHORIZE, to give authority to, also AUTHORISE [v]\n",
  "AUTHORIZER": "one who authorises, also AUTHORISER [n -S]\n",
  "AUTHORIZERS": "AUTHORIZER, one who authorises, also AUTHORISER [n]\n",
  "AUTHORIZES": "AUTHORIZE, to give authority to, also AUTHORISE [v]\n",
  "AUTHORIZING": "AUTHORIZE, to give authority to, also AUTHORISE [v]\n",
  "AUTHORLESS": "without an author; anonymous [adj]\n",
  "AUTHORS": "AUTHOR, to bring into being [v]\n",
  "AUTHORSHIP": "the profession of writing [n -S]\n",
  "AUTHORSHIPS": "AUTHORSHIP, the profession of writing [n]\n",
  "AUTISM": "absorption in imaginative activity directed by the thinker's wishes, with loss of contact with reality [n -S]\n",
  "AUTISMS": "AUTISM, absorption in imaginative activity directed by the thinker's wishes, with loss of contact with reality [n]\n",
  "AUTIST": "one who suffers from autism [n -S]\n",
  "AUTISTIC": "relating to autism [adj AUTISTICALLY] / a person affected by autism, also AUTIST [n -S]\n",
  "AUTISTICALLY": "AUTISTIC, relating to autism [adv]\n",
  "AUTISTICS": "AUTISTIC, a person affected by autism, also AUTIST [n]\n",
  "AUTISTS": "AUTIST, one who suffers from autism [n]\n",
  "AUTO": "to ride in an automobile [v -ED, -ING, -S]\n",
  "AUTOALLOGAMIES": "AUTOALLOGAMY, the ability of some plants of a species to cross-pollinate and others to self-pollinate [n]\n",
  "AUTOALLOGAMY": "the ability of some plants of a species to cross-pollinate and others to self-pollinate [n AUTOALLOGAMIES]\n",
  "AUTOANTIBODIES": "AUTOANTIBODY, an antibody produced in reaction to an antigenic constituent of the body's own tissues [n]\n",
  "AUTOANTIBODY": "an antibody produced in reaction to an antigenic constituent of the body's own tissues [n AUTOANTIBODIES]\n",
  "AUTOBAHN": "(German) a motorway [n AUTOBAHNEN or AUTOBAHNS]\n",
  "AUTOBAHNEN": "AUTOBAHN, (German) a motorway [n]\n",
  "AUTOBAHNS": "AUTOBAHN, (German) a motorway [n]\n",
  "AUTOBANK": "a machine offering cash and other banking services [n -S]\n",
  "AUTOBANKS": "AUTOBANK, a machine offering cash and other banking services [n]\n",
  "AUTOBIOGRAPHER": "one who writes autobiographies [n -S]\n",
  "AUTOBIOGRAPHERS": "AUTOBIOGRAPHER, one who writes autobiographies [n]\n",
  "AUTOBIOGRAPHIC": "relating to autobiography [adj]\n",
  "AUTOBIOGRAPHIES": "AUTOBIOGRAPHY, the biography of a person narrated by himself or herself [n]\n",
  "AUTOBIOGRAPHY": "the biography of a person narrated by himself or herself [n AUTOBIOGRAPHIES]\n",
  "AUTOBODIES": "AUTOBODY, the shell of a motor vehicle [n]\n",
  "AUTOBODY": "the shell of a motor vehicle [n AUTOBODIES]\n",
  "AUTOBUS": "a motorbus [n AUTOBUSES or AUTOBUSSES]\n",
  "AUTOBUSES": "AUTOBUS, a motorbus [n]\n",
  "AUTOBUSSES": "AUTOBUS, a motorbus [n]\n",
  "AUTOCADE": "(French) a procession of motorcars [n -S]\n",
  "AUTOCADES": "AUTOCADE, (French) a procession of motorcars [n]\n",
  "AUTOCAR": "a motor car [n -S]\n",
  "AUTOCARP": "a fruit produced by self-fertilization [n -S]\n",
  "AUTOCARPS": "AUTOCARP, a fruit produced by self-fertilization [n]\n",
  "AUTOCARS": "AUTOCAR, a motor car [n]\n",
  "AUTOCATALYSE": "to effect autocatalysis, also AUTOCATALYZE [v AUTOCATALYSED, AUTOCATALYSING, AUTOCATALYSES]\n",
  "AUTOCATALYSED": "AUTOCATALYSE, to effect autocatalysis, also AUTOCATALYZE [v]\n",
  "AUTOCATALYSES": "AUTOCATALYSE, to effect autocatalysis, also AUTOCATALYZE [v]\n",
  "AUTOCATALYSING": "AUTOCATALYSE, to effect autocatalysis, also AUTOCATALYZE [v]\n",
  "AUTOCATALYSIS": "the catalysis of a reaction by a product of that reaction [n AUTOCATALYSES]\n",
  "AUTOCATALYTIC": "relating to the catalysis of a reaction by a product of that reaction [adj]\n",
  "AUTOCATALYZE": "to subject to autocatalysis, also AUTOCATALYSE [v AUTOCATALYZED, AUTOCATALYZING, AUTOCATALYZES]\n",
  "AUTOCATALYZED": "AUTOCATALYZE, to subject to autocatalysis, also AUTOCATALYSE [v]\n",
  "AUTOCATALYZES": "AUTOCATALYZE, to subject to autocatalysis, also AUTOCATALYSE [v]\n",
  "AUTOCATALYZING": "AUTOCATALYZE, to subject to autocatalysis, also AUTOCATALYSE [v]\n",
  "AUTOCEPHALIC": "of a bishop, independent of any higher governing body, also AUTOCEPHALOUS [adj]\n",
  "AUTOCEPHALIES": "AUTOCEPHALY, self-government [n]\n",
  "AUTOCEPHALOUS": "of a bishop, independent of any higher governing body, also AUTOCEPHALIC [adj]\n",
  "AUTOCEPHALY": "self-government [n AUTOCEPHALIES]\n",
  "AUTOCHANGER": "a device by means of which records are dropped from a stack one at a time onto the turntable [n -S]\n",
  "AUTOCHANGERS": "AUTOCHANGER, a device by means of which records are dropped from a stack one at a time onto the turntable [n]\n",
  "AUTOCHTHON": "one sprung from the ground he inhabits, aborigine, native [n AUTOCHTHONS or AUTOCHTHONES]\n",
  "AUTOCHTHONAL": "indigenous, aboriginal, also AUTOCHTHONIC, AUTOCHTHONOUS [adj]\n",
  "AUTOCHTHONES": "AUTOCHTHON, one sprung from the ground he inhabits, aborigine, native [n]\n",
  "AUTOCHTHONIC": "indigenous, aboriginal, also AUTOCHTHONAL, AUTOCHTHONOUS [adj]\n",
  "AUTOCHTHONIES": "AUTOCHTHONY, the state of being aboriginal [n]\n",
  "AUTOCHTHONISM": "the condition of being autochthonous [n -S]\n",
  "AUTOCHTHONISMS": "AUTOCHTHONISM, the condition of being autochthonous [n]\n",
  "AUTOCHTHONOUS": "indigenous, aboriginal, also AUTOCHTHONAL, AUTOCHTHONIC [adj AUTOCHTHONOUSLY]\n",
  "AUTOCHTHONOUSLY": "AUTOCHTHONOUS, indigenous, aboriginal, also AUTOCHTHONAL, AUTOCHTHONIC [adv]\n",
  "AUTOCHTHONS": "AUTOCHTHON, one sprung from the ground he inhabits, aborigine, native [n]\n",
  "AUTOCHTHONY": "the state of being aboriginal [n AUTOCHTHONIES]\n",
  "AUTOCIDAL": "of pest control, effected by the introduction of sterile or genetically altered individuals into the wild population [adj]\n",
  "AUTOCLAVE": "(French) a kind of French stewpan with a steamtight lid [n -S] / to heat in an autoclave [v AUTOCLAVED, AUTOCLAVING, AUTOCLAVES]\n",
  "AUTOCLAVED": "AUTOCLAVE, to heat in an autoclave [v]\n",
  "AUTOCLAVES": "AUTOCLAVE, (French) a kind of French stewpan with a steamtight lid [n]\n",
  "AUTOCLAVING": "AUTOCLAVE, to heat in an autoclave [v]\n",
  "AUTOCOID": "a hormone secreted into blood, lymph, or sap, also AUTACOID [n -S]\n",
  "AUTOCOIDS": "AUTOCOID, a hormone secreted into blood, lymph, or sap, also AUTACOID [n]\n",
  "AUTOCOMPLETE": "a software feature that predicts which words the user is typing and completes them automatically [n -S]\n",
  "AUTOCOMPLETES": "AUTOCOMPLETE, a software feature that predicts which words the user is typing and completes them automatically [n]\n",
  "AUTOCOPROPHAGY": "eating one's own feces [n]\n",
  "AUTOCORRECT": "a function that attempts to correct errors made by the user when entering text into an electronic device [n -S]\n",
  "AUTOCORRECTS": "AUTOCORRECT, a function that attempts to correct errors made by the user when entering text into an electronic device [n]\n",
  "AUTOCORRELATION": "the correlation between paired values of a function of a mathematical or statistical variable taken at usually constant intervals that indicates the degree of periodicity of the function [n]\n",
  "AUTOCRACIES": "AUTOCRACY, government by one individual [n]\n",
  "AUTOCRACY": "government by one individual [n AUTOCRACIES]\n",
  "AUTOCRAT": "an absolute ruler [n -S]\n",
  "AUTOCRATIC": "of, relating to, or being an autocracy, also AUTOCRATICAL [adj AUTOCRATICALLY]\n",
  "AUTOCRATICAL": "of, relating to, or being an autocracy, also AUTOCRATIC [adj AUTOCRATICALLY]\n",
  "AUTOCRATICALLY": "AUTOCRATICAL, of, relating to, or being an autocracy, also AUTOCRATIC [adv]\n",
  "AUTOCRATS": "AUTOCRAT, an absolute ruler [n]\n",
  "AUTOCRIME": "crime related to cars [n -S]\n",
  "AUTOCRIMES": "AUTOCRIME, crime related to cars [n]\n",
  "AUTOCRINE": "relating to self-stimulation [adj]\n",
  "AUTOCRITIQUE": "(French) self-criticism, esp. political [n -S]\n",
  "AUTOCRITIQUES": "AUTOCRITIQUE, (French) self-criticism, esp. political [n]\n",
  "AUTOCROSS": "motor racing round a rough grass track [n -ES]\n",
  "AUTOCROSSES": "AUTOCROSS, motor racing round a rough grass track [n]\n",
  "AUTOCUE": "(tradename) a text device to assist newsreaders [n -S]\n",
  "AUTOCUES": "AUTOCUE, (tradename) a text device to assist newsreaders [n]\n",
  "AUTOCUTIE": "a young and attractive but inexperienced female televison presenter [n -S]\n",
  "AUTOCUTIES": "AUTOCUTIE, a young and attractive but inexperienced female televison presenter [n]\n",
  "AUTOCYCLE": "a motorcycle [n -S]\n",
  "AUTOCYCLES": "AUTOCYCLE, a motorcycle [n]\n",
  "AUTODESTRUCT": "to self-destruct [v -ED, -ING, -S]\n",
  "AUTODESTRUCTED": "AUTODESTRUCT, to self-destruct [v]\n",
  "AUTODESTRUCTING": "AUTODESTRUCT, to self-destruct [v]\n",
  "AUTODESTRUCTIVE": "AUTODESTRUCT, to self-destruct [adj]\n",
  "AUTODESTRUCTS": "AUTODESTRUCT, to self-destruct [v]\n",
  "AUTODIAL": "to dial a telephone number automatically [v AUTODIALED or AUTODIALLED, AUTODIALING or AUTODIALLING, AUTODIALS]\n",
  "AUTODIALED": "AUTODIAL, to dial a telephone number automatically [v]\n",
  "AUTODIALING": "AUTODIAL, to dial a telephone number automatically [v]\n",
  "AUTODIALLED": "AUTODIAL, to dial a telephone number automatically [v]\n",
  "AUTODIALLING": "AUTODIAL, to dial a telephone number automatically [v]\n",
  "AUTODIALS": "AUTODIAL, to dial a telephone number automatically [v]\n",
  "AUTODIDACT": "a self-taught person [n -S]\n",
  "AUTODIDACTIC": "self-taught [adj]\n",
  "AUTODIDACTICISM": "the state of being autodidactic [n]\n",
  "AUTODIDACTS": "AUTODIDACT, a self-taught person [n]\n",
  "AUTODROME": "a track or circuit for racing cars, go-karts, etc. [n -S]\n",
  "AUTODROMES": "AUTODROME, a track or circuit for racing cars, go-karts, etc. [n]\n",
  "AUTODYNE": "a type of electrical circuit [n -S]\n",
  "AUTODYNES": "AUTODYNE, a type of electrical circuit [n]\n",
  "AUTOECIOUS": "of fungus, etc., passing through all life stages on same species of host, also AUTECIOUS [adj]\n",
  "AUTOECIOUSLY": "AUTOECIOUS, of fungus, etc., passing through all life stages on same species of host, also AUTECIOUS [adv]\n",
  "AUTOECISM": "the development of the entire life cycle of a parasite on a single host, also AUTECISM [n -S]\n",
  "AUTOECISMS": "AUTOECISM, the development of the entire life cycle of a parasite on a single host, also AUTECISM [n]\n",
  "AUTOED": "AUTO, to ride in an automobile [v]\n",
  "AUTOEROTIC": "relating to sexual excitement or gratification gained from one's own body, with or without external stimulation [adj]\n",
  "AUTOEROTICISM": "sexual feeling arising without known external stimulation, also AUTOEROTISM [n -S]\n",
  "AUTOEROTICISMS": "AUTOEROTICISM, sexual feeling arising without known external stimulation, also AUTOEROTISM [n]\n",
  "AUTOEROTISM": "self-love, also AUTOEROTICISM [n -S]\n",
  "AUTOEROTISMS": "AUTOEROTISM, self-love, also AUTOEROTICISM [n]\n",
  "AUTOEXPOSURE": "a system for automatically adjusting the aperture and/or shutter speed of a camera according to the lighting conditions [n -S]\n",
  "AUTOEXPOSURES": "AUTOEXPOSURE, a system for automatically adjusting the aperture and/or shutter speed of a camera according to the lighting conditions [n]\n",
  "AUTOFLARE": "an aircraft automatic landing system [n -S]\n",
  "AUTOFLARES": "AUTOFLARE, an aircraft automatic landing system [n]\n",
  "AUTOFOCUS": "a device which automatically focusses a camera [n AUTOFOCUSES]\n",
  "AUTOFOCUSES": "AUTOFOCUS, a device which automatically focusses a camera [n]\n",
  "AUTOGAMIC": "self-fertilizing, also AUTOGAMOUS [adj]\n",
  "AUTOGAMIES": "AUTOGAMY, self-fertilization [n]\n",
  "AUTOGAMOUS": "self-fertilizing, also AUTOGAMIC [adj]\n",
  "AUTOGAMY": "self-fertilization [n AUTOGAMIES]\n",
  "AUTOGENESES": "AUTOGENESIS, spontaneous generation [n]\n",
  "AUTOGENESIS": "spontaneous generation [n AUTOGENESES]\n",
  "AUTOGENETIC": "relating to autogenesis [adj]\n",
  "AUTOGENIC": "self-generated, produced by the body's own functions [n -S]\n",
  "AUTOGENICS": "a system of relaxation teaching voluntary control of bodily tension [n]\n",
  "AUTOGENIES": "AUTOGENY, spontaneous generation [n]\n",
  "AUTOGENOUS": "self-generated [adj AUTOGENOUSLY]\n",
  "AUTOGENOUSLY": "AUTOGENOUS, self-generated [adv]\n",
  "AUTOGENY": "spontaneous generation [n AUTOGENIES]\n",
  "AUTOGIRO": "(Spanish) a rotating wing aircraft, also AUTOGYRO [n -S]\n",
  "AUTOGIROS": "AUTOGIRO, (Spanish) a rotating wing aircraft, also AUTOGYRO [n]\n",
  "AUTOGRAFT": "a graft from one part of the body to another [n -S] / to make such a graft [v -ED, -ING, -S]\n",
  "AUTOGRAFTED": "AUTOGRAFT, to make such a graft [v]\n",
  "AUTOGRAFTING": "AUTOGRAFT, to make such a graft [v]\n",
  "AUTOGRAFTS": "AUTOGRAFT, to make such a graft [v]\n",
  "AUTOGRAPH": "a handwritten signature, esp. that of a famous person [n -S] / to sign with an autograph [v -ED, -ING, -S]\n",
  "AUTOGRAPHED": "AUTOGRAPH, to sign with an autograph [v]\n",
  "AUTOGRAPHIC": "of, relating to, or constituting an autograph, also AUTOGRAPHICAL [adj AUTOGRAPHICALLY]\n",
  "AUTOGRAPHICAL": "of, relating to, or constituting an autograph, also AUTOGRAPHIC [adj AUTOGRAPHICALLY]\n",
  "AUTOGRAPHICALLY": "AUTOGRAPHICAL, of, relating to, or constituting an autograph, also AUTOGRAPHIC [adv]\n",
  "AUTOGRAPHIES": "AUTOGRAPHY, the act of writing with one's own hand; something handwritten [n]\n",
  "AUTOGRAPHING": "AUTOGRAPH, to sign with an autograph [v]\n",
  "AUTOGRAPHS": "AUTOGRAPH, to sign with an autograph [v]\n",
  "AUTOGRAPHY": "the act of writing with one's own hand; something handwritten [n AUTOGRAPHIES]\n",
  "AUTOGRAVURE": "a process of photoengraving similar to autotype [n -S]\n",
  "AUTOGRAVURES": "AUTOGRAVURE, a process of photoengraving similar to autotype [n]\n",
  "AUTOGUIDE": "a system whereby information on traffic conditions is collected by roadside sensors and relayed to drivers via receivers in their vehicles [n -S]\n",
  "AUTOGUIDES": "AUTOGUIDE, a system whereby information on traffic conditions is collected by roadside sensors and relayed to drivers via receivers in their vehicles [n]\n",
  "AUTOGYRO": "(Spanish) a rotating wing aircraft, also AUTOGIRO [n -S]\n",
  "AUTOGYROS": "AUTOGYRO, (Spanish) a rotating wing aircraft, also AUTOGIRO [n]\n",
  "AUTOHARP": "(tradename) a zither with a keyboard chord-making mechanism which mutes unwanted strings [n -S]\n",
  "AUTOHARPS": "AUTOHARP, (tradename) a zither with a keyboard chord-making mechanism which mutes unwanted strings [n]\n",
  "AUTOHYPNOSES": "AUTOHYPNOSIS, self-induced and usually automatic hypnosis [n]\n",
  "AUTOHYPNOSIS": "self-induced and usually automatic hypnosis [n AUTOHYPNOSES]\n",
  "AUTOHYPNOTIC": "relating to autohypnosis [adj]\n",
  "AUTOICOUS": "having male and female reproductive organs on the same plant [adj]\n",
  "AUTOIMMUNE": "of, relating to, or caused by autoantibodies or T cells that attack molecules, cells, or tissues of the organism producing them [adj]\n",
  "AUTOIMMUNITIES": "AUTOIMMUNITY, the production by a living body of antibodies which attack constituents of its own tissues, the cause of certain serious disease [n]\n",
  "AUTOIMMUNITY": "the production by a living body of antibodies which attack constituents of its own tissues, the cause of certain serious disease [n AUTOIMMUNITIES]\n",
  "AUTOINFECTION": "reinfection with larvae produced by parasitic worms already in the body [n -S]\n",
  "AUTOINFECTIONS": "AUTOINFECTION, reinfection with larvae produced by parasitic worms already in the body [n]\n",
  "AUTOING": "AUTO, to ride in an automobile [v]\n",
  "AUTOINOCULATION": "self-inoculation [n]\n",
  "AUTOIONISATION": "self-ionizing, also AUTOIONIZATION [n -S]\n",
  "AUTOIONISATIONS": "AUTOIONISATION, self-ionizing, also AUTOIONIZATION [n]\n",
  "AUTOIONIZATION": "self-ionizing, also AUTOIONISATION [n -S]\n",
  "AUTOIONIZATIONS": "AUTOIONIZATION, self-ionizing, also AUTOIONISATION [n]\n",
  "AUTOJUMBLE": "a jumble sale involving cars or car accessories [n -S]\n",
  "AUTOJUMBLES": "AUTOJUMBLE, a jumble sale involving cars or car accessories [n]\n",
  "AUTOKINESES": "AUTOKINESIS, voluntary or automatic movement [n]\n",
  "AUTOKINESIS": "voluntary or automatic movement [n AUTOKINESES]\n",
  "AUTOKINETIC": "relating to autokinesis [adj]\n",
  "AUTOLATRIES": "AUTOLATRY, self-worship [n]\n",
  "AUTOLATRY": "self-worship [n AUTOLATRIES]\n",
  "AUTOLOAD": "to load automatically [v -ED, -ING, -S]\n",
  "AUTOLOADED": "AUTOLOAD, to load automatically [v]\n",
  "AUTOLOADING": "self-loading [adj]\n",
  "AUTOLOADS": "AUTOLOAD, to load automatically [v]\n",
  "AUTOLOGIES": "AUTOLOGY, scientific study of oneself [n]\n",
  "AUTOLOGOUS": "involving a situation in which the donor and the recipient (of blood, skin, bone, etc.) are the same person [adj]\n",
  "AUTOLOGY": "scientific study of oneself [n AUTOLOGIES]\n",
  "AUTOLYSATE": "a product of autolysis, also AUTOLYZATE [n -S]\n",
  "AUTOLYSATES": "AUTOLYSATE, a product of autolysis, also AUTOLYZATE [n]\n",
  "AUTOLYSE": "to break down tissue by enzyme action, also AUTOLYZE [v AUTOLYSED, AUTOLYSING, AUTOLYSES]\n",
  "AUTOLYSED": "AUTOLYSE, to break down tissue by enzyme action, also AUTOLYZE [v]\n",
  "AUTOLYSES": "AUTOLYSE, to break down tissue by enzyme action, also AUTOLYZE [v]\n",
  "AUTOLYSIN": "any agent that produces autolysis [n -S]\n",
  "AUTOLYSING": "AUTOLYSE, to break down tissue by enzyme action, also AUTOLYZE [v]\n",
  "AUTOLYSINS": "AUTOLYSIN, any agent that produces autolysis [n]\n",
  "AUTOLYSIS": "self destruction of cells [n AUTOLYSES]\n",
  "AUTOLYTIC": "relating to autolysis, the breaking down of tissue by the action of its own enzymes [adj]\n",
  "AUTOLYZATE": "a product of autolysis, also AUTOLYSATE [n -S]\n",
  "AUTOLYZATES": "AUTOLYZATE, a product of autolysis, also AUTOLYSATE [n]\n",
  "AUTOLYZE": "to break down tissue by enzyme action, also AUTOLYSE [v AUTOLYZED, AUTOLYZING, AUTOLYZES]\n",
  "AUTOLYZED": "AUTOLYZE, to break down tissue by enzyme action, also AUTOLYSE [v]\n",
  "AUTOLYZES": "AUTOLYZE, to break down tissue by enzyme action, also AUTOLYSE [v]\n",
  "AUTOLYZING": "AUTOLYZE, to break down tissue by enzyme action, also AUTOLYSE [v]\n",
  "AUTOMAGIC": "performing a task with astonishing ease and speed [adj AUTOMAGICALLY]\n",
  "AUTOMAGICALLY": "AUTOMAGIC, performing a task with astonishing ease and speed [adv]\n",
  "AUTOMAKER": "a manufacturer of automobiles [n -S]\n",
  "AUTOMAKERS": "AUTOMAKER, a manufacturer of automobiles [n]\n",
  "AUTOMAN": "a maker of automobiles [n AUTOMEN]\n",
  "AUTOMAT": "a restaurant or shop where hot dishes are obtained from slot machines [n -S]\n",
  "AUTOMATA": "AUTOMATON, (Greek) a machine that imitates the movement of a living creature, activated by a concealed mechanism such as clockwork [n]\n",
  "AUTOMATABLE": "capable of being automated [adj]\n",
  "AUTOMATE": "to convert to automatic control [v AUTOMATED, AUTOMATING, AUTOMATES]\n",
  "AUTOMATED": "AUTOMATE, to convert to automatic control [v]\n",
  "AUTOMATES": "AUTOMATE, to convert to automatic control [v]\n",
  "AUTOMATIC": "without conscious thought [adj AUTOMATICALLY] / an automatic gun [n -S]\n",
  "AUTOMATICAL": "(archaic) automatic [adj AUTOMATICALLY]\n",
  "AUTOMATICALLY": "AUTOMATICAL, (archaic) automatic [adv]\n",
  "AUTOMATICITIES": "AUTOMATICITY, the state of being automatic [n]\n",
  "AUTOMATICITY": "the state of being automatic [n AUTOMATICITIES]\n",
  "AUTOMATICS": "AUTOMATIC, an automatic gun [n]\n",
  "AUTOMATING": "AUTOMATE, to convert to automatic control [v]\n",
  "AUTOMATION": "the technique of making an apparatus, a process, or a system operate automatically [n -S]\n",
  "AUTOMATIONS": "AUTOMATION, the technique of making an apparatus, a process, or a system operate automatically [n]\n",
  "AUTOMATISATION": "the process of automatising, also AUTOMATIZATION [n -S]\n",
  "AUTOMATISATIONS": "AUTOMATISATION, the process of automatising, also AUTOMATIZATION [n]\n",
  "AUTOMATISE": "to make automatic, also AUTOMATIZE [v AUTOMATISED, AUTOMATISING, AUTOMATISES]\n",
  "AUTOMATISED": "AUTOMATISE, to make automatic, also AUTOMATIZE [v]\n",
  "AUTOMATISES": "AUTOMATISE, to make automatic, also AUTOMATIZE [v]\n",
  "AUTOMATISING": "AUTOMATISE, to make automatic, also AUTOMATIZE [v]\n",
  "AUTOMATISM": "the state of being automatic [n -S]\n",
  "AUTOMATISMS": "AUTOMATISM, the state of being automatic [n]\n",
  "AUTOMATIST": "a person who holds the doctrine of automatism [n -S]\n",
  "AUTOMATISTS": "AUTOMATIST, a person who holds the doctrine of automatism [n]\n",
  "AUTOMATIZATION": "the process of automatizing, also AUTOMATISATION [n -S]\n",
  "AUTOMATIZATIONS": "AUTOMATIZATION, the process of automatizing, also AUTOMATISATION [n]\n",
  "AUTOMATIZE": "to make automatic, also AUTOMATISE [v AUTOMATIZED, AUTOMATIZING, AUTOMATIZES]\n",
  "AUTOMATIZED": "AUTOMATIZE, to make automatic, also AUTOMATISE [v]\n",
  "AUTOMATIZES": "AUTOMATIZE, to make automatic, also AUTOMATISE [v]\n",
  "AUTOMATIZING": "AUTOMATIZE, to make automatic, also AUTOMATISE [v]\n",
  "AUTOMATON": "(Greek) a machine that imitates the movement of a living creature, activated by a concealed mechanism such as clockwork [n AUTOMATA or AUTOMATONS]\n",
  "AUTOMATONS": "AUTOMATON, (Greek) a machine that imitates the movement of a living creature, activated by a concealed mechanism such as clockwork [n]\n",
  "AUTOMATOUS": "like an automaton [adj]\n",
  "AUTOMATS": "AUTOMAT, a restaurant or shop where hot dishes are obtained from slot machines [n]\n",
  "AUTOMEN": "AUTOMAN, a maker of automobiles [n]\n",
  "AUTOMETER": "a small device fitted into a photocopier to count the number of copies made [n -S]\n",
  "AUTOMETERS": "AUTOMETER, a small device fitted into a photocopier to count the number of copies made [n]\n",
  "AUTOMOBILE": "a usually four-wheeled automotive vehicle designed for passenger transportation [n -S] / to travel by car [v AUTOMOBILED, AUTOMOBILING, AUTOMOBILES]\n",
  "AUTOMOBILED": "AUTOMOBILE, to travel by car [v]\n",
  "AUTOMOBILES": "AUTOMOBILE, a usually four-wheeled automotive vehicle designed for passenger transportation [n]\n",
  "AUTOMOBILIA": "collectable items of motoring interest [n]\n",
  "AUTOMOBILING": "AUTOMOBILE, to travel by car [v]\n",
  "AUTOMOBILISM": "an interest in cars [n -S]\n",
  "AUTOMOBILISMS": "AUTOMOBILISM, an interest in cars [n]\n",
  "AUTOMOBILIST": "one with an interest in cars [n -S]\n",
  "AUTOMOBILISTS": "AUTOMOBILIST, one with an interest in cars [n]\n",
  "AUTOMOBILITIES": "AUTOMOBILITY, the use of automobiles as the major means of transportation [n]\n",
  "AUTOMOBILITY": "the use of automobiles as the major means of transportation [n AUTOMOBILITIES]\n",
  "AUTOMORPHIC": "formed after its or one's own pattern [adj AUTOMORPHICALLY]\n",
  "AUTOMORPHICALLY": "AUTOMORPHIC, formed after its or one's own pattern [adv]\n",
  "AUTOMORPHISM": "ascription to others of one's own characteristics [n -S]\n",
  "AUTOMORPHISMS": "AUTOMORPHISM, ascription to others of one's own characteristics [n]\n",
  "AUTOMOTIVE": "self-propelling; relating to automobiles [adj]\n",
  "AUTONOMIC": "self-governing, also AUTONOMICAL [adj AUTONOMICALLY]\n",
  "AUTONOMICAL": "self-governing, also AUTONOMIC [adj AUTONOMICALLY]\n",
  "AUTONOMICALLY": "AUTONOMICAL, self-governing, also AUTONOMIC [adv]\n",
  "AUTONOMICS": "the study of self-regulating systems for process control [n]\n",
  "AUTONOMIES": "AUTONOMY, self-government [n]\n",
  "AUTONOMIST": "one who practises autonomy [n -S]\n",
  "AUTONOMISTS": "AUTONOMIST, one who practises autonomy [n]\n",
  "AUTONOMOUS": "of, relating to, or marked by autonomy [adj AUTONOMOUSLY]\n",
  "AUTONOMOUSLY": "AUTONOMOUS, of, relating to, or marked by autonomy [adv]\n",
  "AUTONOMY": "self-government [n AUTONOMIES]\n",
  "AUTONYM": "an author's real name [n -S]\n",
  "AUTONYMOUS": "(of a word or words) appearing in its own form or directly quoted [adj]\n",
  "AUTONYMS": "AUTONYM, an author's real name [n]\n",
  "AUTOPEN": "a mechanical device used to produce imitation signatures [n -S]\n",
  "AUTOPENS": "AUTOPEN, a mechanical device used to produce imitation signatures [n]\n",
  "AUTOPHAGIA": "sustenance by self-absorption of the tissues of the body, also AUTOPHAGY [n -S]\n",
  "AUTOPHAGIAS": "AUTOPHAGIA, sustenance by self-absorption of the tissues of the body, also AUTOPHAGY [n]\n",
  "AUTOPHAGIES": "AUTOPHAGY, sustenance by self-absorption of the tissues of the body, also AUTOPHAGIA [n]\n",
  "AUTOPHAGOUS": "related to autophagy, sustenance by self-absorption of the tissues of the body [adj]\n",
  "AUTOPHAGY": "sustenance by self-absorption of the tissues of the body, also AUTOPHAGIA [n AUTOPHAGIES]\n",
  "AUTOPHANOUS": "self-luminous [adj]\n",
  "AUTOPHOBIA": "a morbid fear of solitude [n -S]\n",
  "AUTOPHOBIAS": "AUTOPHOBIA, a morbid fear of solitude [n]\n",
  "AUTOPHOBIES": "AUTOPHOBY, a shrinking from making any reference to oneself [n]\n",
  "AUTOPHOBY": "a shrinking from making any reference to oneself [n AUTOPHOBIES]\n",
  "AUTOPHONIES": "AUTOPHONY, apparent distortion of one's own voice due to infection or stoppage of ears [n]\n",
  "AUTOPHONY": "apparent distortion of one's own voice due to infection or stoppage of ears [n AUTOPHONIES]\n",
  "AUTOPHYTE": "an autotrophic plant, as any green plant [n -S]\n",
  "AUTOPHYTES": "AUTOPHYTE, an autotrophic plant, as any green plant [n]\n",
  "AUTOPHYTIC": "like an autophyte, an autotrophic plant, as any green plant [adj AUTOPHYTICALLY]\n",
  "AUTOPHYTICALLY": "AUTOPHYTIC, like an autophyte, an autotrophic plant, as any green plant [adv]\n",
  "AUTOPILOT": "a device which can be set to guide and control an aircraft or a ship on a chosen course [n -S]\n",
  "AUTOPILOTS": "AUTOPILOT, a device which can be set to guide and control an aircraft or a ship on a chosen course [n]\n",
  "AUTOPISTA": "(Spanish) a motorway [n -S]\n",
  "AUTOPISTAS": "AUTOPISTA, (Spanish) a motorway [n]\n",
  "AUTOPLASTIC": "relating to autoplasty, grafting tissue from patient's own body [adj]\n",
  "AUTOPLASTIES": "AUTOPLASTY, grafting tissue from patient's own body [n]\n",
  "AUTOPLASTY": "grafting tissue from patient's own body [n AUTOPLASTIES]\n",
  "AUTOPOINT": "a point-to-point over rough country in motor vehicles [n -S]\n",
  "AUTOPOINTS": "AUTOPOINT, a point-to-point over rough country in motor vehicles [n]\n",
  "AUTOPOLYPLOID": "an individual or strain whose chromosome complement consists of more than two complete copies of the genome of a single ancestral species [n -S]\n",
  "AUTOPOLYPLOIDS": "AUTOPOLYPLOID, an individual or strain whose chromosome complement consists of more than two complete copies of the genome of a single ancestral species [n]\n",
  "AUTOPOLYPLOIDY": "the state of being an autopolyploid, an individual or strain whose chromosome complement consists of more than two complete copies of the genome of a single ancestral species [n]\n",
  "AUTOPSIA": "a postmortem examination of a corpse, also AUTOPSY [n -S]\n",
  "AUTOPSIAS": "AUTOPSIA, a postmortem examination of a corpse, also AUTOPSY [n]\n",
  "AUTOPSIC": "pertaining to an autopsy [adj]\n",
  "AUTOPSIED": "AUTOPSY, to carry out a postmortem examination of a corpse [v]\n",
  "AUTOPSIES": "AUTOPSY, to carry out a postmortem examination of a corpse [v]\n",
  "AUTOPSIST": "one who carries out an autopsy [n -S]\n",
  "AUTOPSISTS": "AUTOPSIST, one who carries out an autopsy [n]\n",
  "AUTOPSY": "a postmortem examination of a corpse, also AUTOPSIA [n AUTOPSIES] / to carry out a postmortem examination of a corpse [v AUTOPSIED, AUTOPSYING, AUTOPSIES]\n",
  "AUTOPSYING": "AUTOPSY, to carry out a postmortem examination of a corpse [v]\n",
  "AUTOPTIC": "based on personal observation, as autoptic testimony, also AUTOPTICAL [adj AUTOPTICALLY]\n",
  "AUTOPTICAL": "based on personal observation, as autoptic testimony, also AUTOPTIC [adj AUTOPTICALLY]\n",
  "AUTOPTICALLY": "AUTOPTICAL, based on personal observation, as autoptic testimony, also AUTOPTIC [adv]\n",
  "AUTOPUT": "a motorway in Yugoslavia [n -S]\n",
  "AUTOPUTS": "AUTOPUT, a motorway in Yugoslavia [n]\n",
  "AUTORADIOGRAM": "an autoradiographic record, also AUTORADIOGRAPH [n -S]\n",
  "AUTORADIOGRAMS": "AUTORADIOGRAM, an autoradiographic record, also AUTORADIOGRAPH [n]\n",
  "AUTORADIOGRAPH": "an autoradiographic record, also RADIOAUTOGRAPH [n -S]\n",
  "AUTORADIOGRAPHS": "AUTORADIOGRAPH, an autoradiographic record, also RADIOAUTOGRAPH [n]\n",
  "AUTORADIOGRAPHY": "a technique used to show the distribution of radioactively labelled molecules in cells or tissues [n]\n",
  "AUTOREPLIES": "AUTOREPLY, a facility which allows a previously-written response to be sent automatically in reply to incoming email; a message sent by this [n]\n",
  "AUTOREPLY": "a facility which allows a previously-written response to be sent automatically in reply to incoming email; a message sent by this [n AUTOREPLIES]\n",
  "AUTOREVERSE": "a system in a tape player that automatically reverses the tape and plays another track when one track has finished [n -S]\n",
  "AUTOREVERSES": "AUTOREVERSE, a system in a tape player that automatically reverses the tape and plays another track when one track has finished [n]\n",
  "AUTORICKSHAW": "a light, three-wheeled vehicle powered by a motorcycle engine, used in India, etc. [n -S]\n",
  "AUTORICKSHAWS": "AUTORICKSHAW, a light, three-wheeled vehicle powered by a motorcycle engine, used in India, etc. [n]\n",
  "AUTOROTATE": "to self-turn [v AUTOROTATED, AUTOROTATING, AUTOROTATES]\n",
  "AUTOROTATED": "AUTOROTATE, to self-turn [v]\n",
  "AUTOROTATES": "AUTOROTATE, to self-turn [v]\n",
  "AUTOROTATING": "AUTOROTATE, to self-turn [v]\n",
  "AUTOROTATION": "the act of self-turning [n -S]\n",
  "AUTOROTATIONS": "AUTOROTATION, the act of self-turning [n]\n",
  "AUTOROUTE": "a Continental motorway [n -S]\n",
  "AUTOROUTES": "AUTOROUTE, a Continental motorway [n]\n",
  "AUTOS": "AUTO, to ride in an automobile [v]\n",
  "AUTOSAVE": "to save by a facility which automatically saves newly-recorded data at regular intervals [v AUTOSAVED, AUTOSAVING, AUTOSAVES]\n",
  "AUTOSAVED": "AUTOSAVE, to save by a facility which automatically saves newly-recorded data at regular intervals [v]\n",
  "AUTOSAVES": "AUTOSAVE, to save by a facility which automatically saves newly-recorded data at regular intervals [v]\n",
  "AUTOSAVING": "AUTOSAVE, to save by a facility which automatically saves newly-recorded data at regular intervals [v]\n",
  "AUTOSCHEDIASM": "anything which is extemporized [n -S]\n",
  "AUTOSCHEDIASMS": "AUTOSCHEDIASM, anything which is extemporized [n]\n",
  "AUTOSCHEDIASTIC": "impromptu; on the spur of the moment [adj]\n",
  "AUTOSCHEDIAZE": "to improvise [v AUTOSCHEDIAZED, AUTOSCHEDIAZING, AUTOSCHEDIAZES]\n",
  "AUTOSCHEDIAZED": "AUTOSCHEDIAZE, to improvise [v]\n",
  "AUTOSCHEDIAZES": "AUTOSCHEDIAZE, to improvise [v]\n",
  "AUTOSCHEDIAZING": "AUTOSCHEDIAZE, to improvise [v]\n",
  "AUTOSCOPIC": "relating to autoscopy, hallucination of an image of one's body [adj]\n",
  "AUTOSCOPIES": "AUTOSCOPY, a hallucination of an image of one's own body [n]\n",
  "AUTOSCOPY": "a hallucination of an image of one's own body [n AUTOSCOPIES]\n",
  "AUTOSEXING": "the act of self-sexing [n -S]\n",
  "AUTOSEXINGS": "AUTOSEXING, the act of self-sexing [n]\n",
  "AUTOSOMAL": "of or like an autosome, a chromosome other than a sex chromosome [adj AUTOSOMALLY]\n",
  "AUTOSOMALLY": "AUTOSOMAL, of or like an autosome, a chromosome other than a sex chromosome [adv]\n",
  "AUTOSOME": "a chromosome other than a sex chromosome [n -S]\n",
  "AUTOSOMES": "AUTOSOME, a chromosome other than a sex chromosome [n]\n",
  "AUTOSPORE": "a nonmotile algal spore [n -S]\n",
  "AUTOSPORES": "AUTOSPORE, a nonmotile algal spore [n]\n",
  "AUTOSPORT": "the sport of motor-racing [n -S]\n",
  "AUTOSPORTS": "AUTOSPORT, the sport of motor-racing [n]\n",
  "AUTOSTABILITIES": "AUTOSTABILITY, the state of being self-stable [n]\n",
  "AUTOSTABILITY": "the state of being self-stable [n AUTOSTABILITIES]\n",
  "AUTOSTRADA": "(Italian) a motorway [n AUTOSTRADAS or AUTOSTRADE]\n",
  "AUTOSTRADAS": "AUTOSTRADA, (Italian) a motorway [n]\n",
  "AUTOSTRADE": "AUTOSTRADA, (Italian) a motorway [n]\n",
  "AUTOSUGGEST": "to influence one's own actions by self-suggestion [v -ED, -ING, -S]\n",
  "AUTOSUGGESTED": "AUTOSUGGEST, to influence one's own actions by self-suggestion [v]\n",
  "AUTOSUGGESTING": "AUTOSUGGEST, to influence one's own actions by self-suggestion [v]\n",
  "AUTOSUGGESTION": "an influencing of one's own attitudes, behavior, or physical condition by mental processes other than conscious thought [n -S]\n",
  "AUTOSUGGESTIONS": "AUTOSUGGESTION, an influencing of one's own attitudes, behavior, or physical condition by mental processes other than conscious thought [n]\n",
  "AUTOSUGGESTIVE": "AUTOSUGGEST, to influence one's own actions by self-suggestion [adj]\n",
  "AUTOSUGGESTS": "AUTOSUGGEST, to influence one's own actions by self-suggestion [v]\n",
  "AUTOTELIC": "being an end in itself, or its own justification [adj]\n",
  "AUTOTELLER": "an automatic telling machine [n -S]\n",
  "AUTOTELLERS": "AUTOTELLER, an automatic telling machine [n]\n",
  "AUTOTEST": "a competition in which drivers race standard cars around a circuit [n -S]\n",
  "AUTOTESTS": "AUTOTEST, a competition in which drivers race standard cars around a circuit [n]\n",
  "AUTOTETRAPLOID": "an individual or strain whose chromosome complement consists of four copies of a single genome due to doubling of an ancestral chromosome complement [n -S]\n",
  "AUTOTETRAPLOIDS": "AUTOTETRAPLOID, an individual or strain whose chromosome complement consists of four copies of a single genome due to doubling of an ancestral chromosome complement [n]\n",
  "AUTOTETRAPLOIDY": "the state of being autotetraploid [n]\n",
  "AUTOTHEISM": "belief that one is God incarnate or that one is Christ [n -S]\n",
  "AUTOTHEISMS": "AUTOTHEISM, belief that one is God incarnate or that one is Christ [n]\n",
  "AUTOTHEIST": "the individual who is not only self-centered but self-deifying, or at least self-worshipping [n -S]\n",
  "AUTOTHEISTS": "AUTOTHEIST, the individual who is not only self-centered but self-deifying, or at least self-worshipping [n]\n",
  "AUTOTIMER": "a device on a cooker that can be adjusted in advance to turn the apparatus off or on at a set time [n -S]\n",
  "AUTOTIMERS": "AUTOTIMER, a device on a cooker that can be adjusted in advance to turn the apparatus off or on at a set time [n]\n",
  "AUTOTOMIC": "relating to autotomy, the reflex loss of part of the body to save the whole [adj]\n",
  "AUTOTOMIES": "AUTOTOMY, the reflex loss of part of the body to save the whole (in lizards, etc.) [n]\n",
  "AUTOTOMISE": "to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMIZE [v AUTOTOMISED, AUTOTOMISING, AUTOTOMISES]\n",
  "AUTOTOMISED": "AUTOTOMISE, to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMIZE [v]\n",
  "AUTOTOMISES": "AUTOTOMISE, to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMIZE [v]\n",
  "AUTOTOMISING": "AUTOTOMISE, to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMIZE [v]\n",
  "AUTOTOMIZE": "to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMISE [v AUTOTOMIZED, AUTOTOMIZING, AUTOTOMIZES]\n",
  "AUTOTOMIZED": "AUTOTOMIZE, to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMISE [v]\n",
  "AUTOTOMIZES": "AUTOTOMIZE, to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMISE [v]\n",
  "AUTOTOMIZING": "AUTOTOMIZE, to effect an autotomy, the reflex loss of part of the body to save the whole (in lizards, etc.), also AUTOTOMISE [v]\n",
  "AUTOTOMOUS": "relating to autotomy [adj]\n",
  "AUTOTOMY": "the reflex loss of part of the body to save the whole (in lizards, etc.) [n AUTOTOMIES]\n",
  "AUTOTOXAEMIA": "self-poisoning caused by absorption of toxic products originating within the body, also AUTOTOXEMIA [n -S]\n",
  "AUTOTOXAEMIAS": "AUTOTOXAEMIA, self-poisoning caused by absorption of toxic products originating within the body, also AUTOTOXEMIA [n]\n",
  "AUTOTOXEMIA": "self-poisoning caused by absorption of toxic products originating within the body, also AUTOTOXAEMIA [n -S]\n",
  "AUTOTOXEMIAS": "AUTOTOXEMIA, self-poisoning caused by absorption of toxic products originating within the body, also AUTOTOXAEMIA [n]\n",
  "AUTOTOXIC": "like an autotoxin, a poisonous substance formed within the body within which it acts [adj]\n",
  "AUTOTOXIN": "a poisonous substance formed within the body within which it acts [n -S]\n",
  "AUTOTOXINS": "AUTOTOXIN, a poisonous substance formed within the body within which it acts [n]\n",
  "AUTOTRANSFORMER": "a transformer in which the primary and secondary coils have part or all of their turns in common [n]\n",
  "AUTOTRANSFUSION": "the return of autologous blood to the patient's own circulatory system [n]\n",
  "AUTOTROPH": "an organism that is able to manufacture its own food from inorganic substances [n -S]\n",
  "AUTOTROPHIC": "capable of building up food materials from inorganic matter [adj AUTOTROPHICALLY]\n",
  "AUTOTROPHICALLY": "AUTOTROPHIC, capable of building up food materials from inorganic matter [adv]\n",
  "AUTOTROPHIES": "AUTOTROPHY, the state of being an autotroph, an organism that is able to manufacture its own food from inorganic substances [n]\n",
  "AUTOTROPHS": "AUTOTROPH, an organism that is able to manufacture its own food from inorganic substances [n]\n",
  "AUTOTROPHY": "the state of being an autotroph, an organism that is able to manufacture its own food from inorganic substances [n AUTOTROPHIES]\n",
  "AUTOTUNE": "a software package that manipulates a vocal track until it is in tune [n -S]\n",
  "AUTOTUNES": "AUTOTUNE, a software package that manipulates a vocal track until it is in tune [n]\n",
  "AUTOTYPE": "to reproduce by a photographic process [v AUTOTYPED, AUTOTYPING, AUTOTYPES]\n",
  "AUTOTYPED": "AUTOTYPE, to reproduce by a photographic process [v]\n",
  "AUTOTYPES": "AUTOTYPE, to reproduce by a photographic process [v]\n",
  "AUTOTYPIC": "like an autotype, a facsimile [adj]\n",
  "AUTOTYPIES": "AUTOTYPY, a photographic printing process [n]\n",
  "AUTOTYPING": "AUTOTYPE, to reproduce by a photographic process [v]\n",
  "AUTOTYPOGRAPHY": "a process by which drawings made on gelatine are transferred to a plate from which impressions may be taken [n]\n",
  "AUTOTYPY": "a photographic printing process [n AUTOTYPIES]\n",
  "AUTOVAC": "a vacuum mechanism in a car for raising petrol to a higher tank so that it may flow by gravity into the carburettor [n -S]\n",
  "AUTOVACS": "AUTOVAC, a vacuum mechanism in a car for raising petrol to a higher tank so that it may flow by gravity into the carburettor [n]\n",
  "AUTOWINDER": "a battery-operated device for advancing the film in a camera automatically after each exposure [n -S]\n",
  "AUTOWINDERS": "AUTOWINDER, a battery-operated device for advancing the film in a camera automatically after each exposure [n]\n",
  "AUTOWORKER": "a person employed in the automobile manufacturing industry [n -S]\n",
  "AUTOWORKERS": "AUTOWORKER, a person employed in the automobile manufacturing industry [n]\n",
  "AUTOXIDATION": "oxidation by direct combination with oxygen at ordinary temperatures [n -S]\n",
  "AUTOXIDATIONS": "AUTOXIDATION, oxidation by direct combination with oxygen at ordinary temperatures [n]\n",
  "AUTUMN": "a season of the year [n -S]\n",
  "AUTUMNAL": "pertaining to autumn [adj AUTUMNALLY]\n",
  "AUTUMNALLY": "AUTUMNAL, pertaining to autumn [adv]\n",
  "AUTUMNIER": "AUTUMNY, (colloq.) autumn-like [adj]\n",
  "AUTUMNIEST": "AUTUMNY, (colloq.) autumn-like [adj]\n",
  "AUTUMNS": "AUTUMN, a season of the year [n]\n",
  "AUTUMNY": "(colloq.) autumn-like [adj AUTUMNIER, AUTUMNIEST]\n",
  "AUTUNITE": "a fluorescent minor ore of uranium [n -S]\n",
  "AUTUNITES": "AUTUNITE, a fluorescent minor ore of uranium [n]\n",
  "AUXANOMETER": "an instrument for measuring growth of plants [n -S]\n",
  "AUXANOMETERS": "AUXANOMETER, an instrument for measuring growth of plants [n]\n",
  "AUXESES": "AUXESIS, a growth in tissue due to an increase cell size [n]\n",
  "AUXESIS": "a growth in tissue due to an increase cell size [n AUXESES]\n",
  "AUXETIC": "involving an increase in size [adj] / something that promotes auxesis [n -S]\n",
  "AUXETICS": "AUXETIC, something that promotes auxesis [n]\n",
  "AUXILIAR": "(archaic) an auxiliary [n -S]\n",
  "AUXILIARIES": "AUXILIARY, a helper, a subordinate, also AUXILIAR [n]\n",
  "AUXILIARS": "AUXILIAR, (archaic) an auxiliary [n]\n",
  "AUXILIARY": "a helper, a subordinate, also AUXILIAR [n AUXILIARIES]\n",
  "AUXIN": "a substance increasing the growth of plants; a plant hormone [n -S]\n",
  "AUXINIC": "relating to an auxin, a plant hormone [adj]\n",
  "AUXINS": "AUXIN, a substance increasing the growth of plants; a plant hormone [n]\n",
  "AUXOCHROME": "a group of atoms that can be attached to a chromogen to convert it into a dye [n -S]\n",
  "AUXOCHROMES": "AUXOCHROME, a group of atoms that can be attached to a chromogen to convert it into a dye [n]\n",
  "AUXOCYTE": "a cell undergoing meiosis [n -S]\n",
  "AUXOCYTES": "AUXOCYTE, a cell undergoing meiosis [n]\n",
  "AUXOMETER": "an instrument for measuring magnifying power [n -S]\n",
  "AUXOMETERS": "AUXOMETER, an instrument for measuring magnifying power [n]\n",
  "AUXOSPORE": "a diatom cell before its siliceous wall is formed [n -S]\n",
  "AUXOSPORES": "AUXOSPORE, a diatom cell before its siliceous wall is formed [n]\n",
  "AUXOTONIC": "of muscle contraction, occurring against increasing force [adj]\n",
  "AUXOTROPH": "an auxotrophic strain or individual, i.e. one requiring a specific growth substance beyond the minimum required for normal metabolism [n -S]\n",
  "AUXOTROPHIC": "requiring a specific growth substance beyond the minimum required for normal metabolism [adj]\n",
  "AUXOTROPHIES": "AUXOTROPHY, the state of being auxotrophic, requiring a specific growth substance beyond the minimum required for normal metabolism [n]\n",
  "AUXOTROPHS": "AUXOTROPH, an auxotrophic strain or individual, i.e. one requiring a specific growth substance beyond the minimum required for normal metabolism [n]\n",
  "AUXOTROPHY": "the state of being auxotrophic, requiring a specific growth substance beyond the minimum required for normal metabolism [n AUXOTROPHIES]\n",
  "AVA": "an aromatic plant of the pepper family; a narcotic drink prepared from its root and stem, also KAVA, KAVAKAVA [n -S]\n",
  "AVADAVAT": "(Hindi) the strawberry finch, a small Indian song bird, commonly caged and kept for fighting, also AMADAVAT [n -S]\n",
  "AVADAVATS": "AVADAVAT, (Hindi) the strawberry finch, a small Indian song bird, commonly caged and kept for fighting, also AMADAVAT [n]\n",
  "AVAIL": "to be of use or advantage to [v -ED, -ING, -S]\n",
  "AVAILABILITIES": "AVAILABILITY, the state of being available [n]\n",
  "AVAILABILITY": "the state of being available [n AVAILABILITIES]\n",
  "AVAILABLE": "at hand [adj AVAILABLY]\n",
  "AVAILABLENESS": "the state of being available [n -ES]\n",
  "AVAILABLENESSES": "AVAILABLENESS, the state of being available [n]\n",
  "AVAILABLY": "AVAILABLE, at hand [adv]\n",
  "AVAILE": "(Spenser) to descend, also AVALE [v AVAILED, AVAILING, AVAILES]\n",
  "AVAILED": "AVAIL, to be of use or advantage to [v]\n",
  "AVAILES": "AVAILE, (Spenser) to descend, also AVALE [v]\n",
  "AVAILFUL": "(obsolete) of avail, serviceable [adj]\n",
  "AVAILING": "AVAIL, to be of use or advantage to [v]\n",
  "AVAILINGLY": "AVAILING, AVAIL, to be of use or advantage to [adv]\n",
  "AVAILS": "AVAIL, to be of use or advantage to [v]\n",
  "AVAL": "pertaining to a grandparent [adj]\n",
  "AVALANCHE": "a generic term for any slide of snow, ice, and debris [n -S] / to descend as an avalanche [v AVALANCHED, AVALANCHING, AVALANCHES]\n",
  "AVALANCHED": "AVALANCHE, to descend as an avalanche [v]\n",
  "AVALANCHES": "AVALANCHE, a generic term for any slide of snow, ice, and debris [n]\n",
  "AVALANCHING": "AVALANCHE, to descend as an avalanche [v]\n",
  "AVALE": "(obsolete) to descend, also AVAILE [v AVALED, AVALING, AVALES]\n",
  "AVALED": "AVALE, (obsolete) to descend, also AVAILE [v]\n",
  "AVALEMENT": "a skiing technique that involves keeping the knees flexible so as to absorb bumps and remain in contact with the snow [n -S]\n",
  "AVALEMENTS": "AVALEMENT, a skiing technique that involves keeping the knees flexible so as to absorb bumps and remain in contact with the snow [n]\n",
  "AVALES": "AVALE, (obsolete) to descend, also AVAILE [v]\n",
  "AVALING": "AVALE, (obsolete) to descend, also AVAILE [v]\n",
  "AVANT": "(French) before [prep]\n",
  "AVANTI": "(Italian) go forward [interj]\n",
  "AVANTIST": "an avant-garde artist, writer or musician [n -S]\n",
  "AVANTISTS": "AVANTIST, an avant-garde artist, writer or musician [n]\n",
  "AVANTURINE": "a glass containing golden or green flecks; quartz containing mica flakes, also AVENTURIN, AVENTURINE [n -S]\n",
  "AVANTURINES": "AVANTURINE, a glass containing golden or green flecks; quartz containing mica flakes, also AVENTURIN, AVENTURINE [n]\n",
  "AVARICE": "greed [n -S]\n",
  "AVARICES": "AVARICE, greed [n]\n",
  "AVARICIOUS": "greedy of gain [adj AVARICIOUSLY]\n",
  "AVARICIOUSLY": "AVARICIOUS, greedy of gain [adv]\n",
  "AVARICIOUSNESS": "the state of being avaricious [n]\n",
  "AVAS": "AVA, an aromatic plant of the pepper family; a narcotic drink prepared from its root and stem, also KAVA, KAVAKAVA [n]\n",
  "AVASCULAR": "not having blood vessels [adj]\n",
  "AVASCULARITIES": "AVASCULARITY, the state of being avascular [n]\n",
  "AVASCULARITY": "the state of being avascular [n AVASCULARITIES]\n",
  "AVAST": "stop [interj]\n",
  "AVATAR": "(Sanskrit) the incarnation of a Hindu deity [n -S]\n",
  "AVATARS": "AVATAR, (Sanskrit) the incarnation of a Hindu deity [n]\n",
  "AVAUNT": "(archaic) to advance [v -ED, -ING, -S]\n",
  "AVAUNTED": "AVAUNT, (archaic) to advance [v]\n",
  "AVAUNTING": "AVAUNT, (archaic) to advance [v]\n",
  "AVAUNTS": "AVAUNT, (archaic) to advance [v]\n",
  "AVE": "hail [n -S]\n",
  "AVEL": "(Hebrew) a mourner of nearest blood relations, also OVEL [n -S]\n",
  "AVELLAN": "(of heraldic crosses) with arms shaped like filberts [adj]\n",
  "AVELLANE": "of a cross, having four arms shaped like filberts at the end, also AVELLAN [adj]\n",
  "AVELS": "AVEL, (Hebrew) a mourner of nearest blood relations, also OVEL [n]\n",
  "AVENACEOUS": "pertaining to or like oats [adj]\n",
  "AVENGE": "to take retribution for, also VENGE [v AVENGED, AVENGING, AVENGES]\n",
  "AVENGED": "AVENGE, to take retribution for, also VENGE [v]\n",
  "AVENGEFUL": "seeking to avenge, also VENGEFUL [adj]\n",
  "AVENGEMENT": "(archaic) the inflicting of retributive punishment [n -S]\n",
  "AVENGEMENTS": "AVENGEMENT, (archaic) the inflicting of retributive punishment [n]\n",
  "AVENGER": "one that avenges, also VENGER [n -S]\n",
  "AVENGERESS": "a female avenger [n -ES]\n",
  "AVENGERESSES": "AVENGERESS, a female avenger [n]\n",
  "AVENGERS": "AVENGER, one that avenges, also VENGER [n]\n",
  "AVENGES": "AVENGE, to take retribution for, also VENGE [v]\n",
  "AVENGING": "AVENGE, to take retribution for, also VENGE [v]\n",
  "AVENIR": "(French) the future [n -S]\n",
  "AVENIRS": "AVENIR, (French) the future [n]\n",
  "AVENS": "any plant of the genus Geum e.g. water avens [n -ES]\n",
  "AVENSES": "AVENS, any plant of the genus Geum e.g. water avens [n]\n",
  "AVENTAIL": "(historical) the movable front to a helmet, also AVENTAILE, VENTAIL, VENTAILE, VENTAYLE [n -S]\n",
  "AVENTAILE": "(historical) the movable front to a helmet, also AVENTAIL, VENTAIL, VENTAILE, VENTAYLE [n -S]\n",
  "AVENTAILES": "AVENTAILE, (historical) the movable front to a helmet, also AVENTAIL, VENTAIL, VENTAILE, VENTAYLE [n]\n",
  "AVENTAILS": "AVENTAIL, (historical) the movable front to a helmet, also AVENTAILE, VENTAIL, VENTAILE, VENTAYLE [n]\n",
  "AVENTRE": "(Spenser) to thrust, direct [v AVENTRED, AVENTRING, AVENTRES]\n",
  "AVENTRED": "AVENTRE, (Spenser) to thrust, direct [v]\n",
  "AVENTRES": "AVENTRE, (Spenser) to thrust, direct [v]\n",
  "AVENTRING": "AVENTRE, (Spenser) to thrust, direct [v]\n",
  "AVENTURE": "(obsolete) an adventure [n -S]\n",
  "AVENTURES": "AVENTURE, (obsolete) an adventure [n]\n",
  "AVENTURIN": "a glass containing golden or green flecks; quartz containing mica flakes, also AVANTURINE, AVENTURINE [n -S]\n",
  "AVENTURINE": "a glass containing golden or green flecks; quartz containing mica flakes, also AVANTURINE, AVENTURIN [n -S]\n",
  "AVENTURINES": "AVENTURINE, a glass containing golden or green flecks; quartz containing mica flakes, also AVANTURINE, AVENTURIN [n]\n",
  "AVENTURINS": "AVENTURIN, a glass containing golden or green flecks; quartz containing mica flakes, also AVANTURINE, AVENTURINE [n]\n",
  "AVENUE": "a wide street [n -S]\n",
  "AVENUES": "AVENUE, a wide street [n]\n",
  "AVER": "to declare positively [v AVERRED, AVERRING, AVERS]\n",
  "AVERAGE": "mediocre [adj AVERAGELY] / to calculate the arithmetical mean value of [v AVERAGED, AVERAGING, AVERAGES]\n",
  "AVERAGED": "AVERAGE, to calculate the arithmetical mean value of [v]\n",
  "AVERAGELY": "AVERAGE, mediocre [adv]\n",
  "AVERAGENESS": "the state of being average [n -ES]\n",
  "AVERAGENESSES": "AVERAGENESS, the state of being average [n]\n",
  "AVERAGER": "in maritime law, a person who calculates average claims [n -S]\n",
  "AVERAGERS": "AVERAGER, in maritime law, a person who calculates average claims [n]\n",
  "AVERAGES": "AVERAGE, to calculate the arithmetical mean value of [v]\n",
  "AVERAGING": "the act of taking an average [n -S]\n",
  "AVERAGINGS": "AVERAGING, the act of taking an average [n]\n",
  "AVERMENT": "a positive assertion [n -S]\n",
  "AVERMENTS": "AVERMENT, a positive assertion [n]\n",
  "AVERRABLE": "that can be averred [adj]\n",
  "AVERRED": "AVER, to declare positively [v]\n",
  "AVERRING": "AVER, to declare positively [v]\n",
  "AVERRUNCATE": "(archaic) to ward off; to uproot [v AVERRUNCATED, AVERRUNCATING, AVERRUNCATES]\n",
  "AVERRUNCATED": "AVERRUNCATE, (archaic) to ward off; to uproot [v]\n",
  "AVERRUNCATES": "AVERRUNCATE, (archaic) to ward off; to uproot [v]\n",
  "AVERRUNCATING": "AVERRUNCATE, (archaic) to ward off; to uproot [v]\n",
  "AVERRUNCATION": "the act of averruncating [n -S]\n",
  "AVERRUNCATIONS": "AVERRUNCATION, the act of averruncating [n]\n",
  "AVERRUNCATOR": "an instrument (on a pole) for pruning trees [n -S]\n",
  "AVERRUNCATORS": "AVERRUNCATOR, an instrument (on a pole) for pruning trees [n]\n",
  "AVERS": "AVER, to declare positively [v]\n",
  "AVERSE": "opposed, reluctant [adj AVERSELY]\n",
  "AVERSELY": "AVERSE, opposed, reluctant [adv]\n",
  "AVERSENESS": "the state of being averse [n -ES]\n",
  "AVERSENESSES": "AVERSENESS, the state of being averse [n]\n",
  "AVERSION": "a feeling of repugnance [n -S]\n",
  "AVERSIONS": "AVERSION, a feeling of repugnance [n]\n",
  "AVERSIVE": "relating to aversion [adj AVERSIVELY] / a technique designed to repel [n -S]\n",
  "AVERSIVELY": "AVERSIVE, relating to aversion [adv]\n",
  "AVERSIVENESS": "the state of being aversive, showing aversion [n -ES]\n",
  "AVERSIVENESSES": "AVERSIVENESS, the state of being aversive, showing aversion [n]\n",
  "AVERSIVES": "AVERSIVE, a technique designed to repel [n]\n",
  "AVERT": "to ward off [v -ED, -ING, -S]\n",
  "AVERTABLE": "capable of being averted, also AVERTIBLE [adj]\n",
  "AVERTED": "AVERT, to ward off [v]\n",
  "AVERTEDLY": "AVERTED, AVERT, to ward off [adv]\n",
  "AVERTER": "one who averts [n -S]\n",
  "AVERTERS": "AVERTER, one who averts [n]\n",
  "AVERTIBLE": "capable of being averted, also AVERTABLE [adj]\n",
  "AVERTIMENT": "(Milton) advertisement [n -S]\n",
  "AVERTIMENTS": "AVERTIMENT, (Milton) advertisement [n]\n",
  "AVERTING": "AVERT, to ward off [v]\n",
  "AVERTS": "AVERT, to ward off [v]\n",
  "AVES": "AVE, hail [n]\n",
  "AVGAS": "any kind of aviation gasoline [n AVGASES or AVGASSES]\n",
  "AVGASES": "AVGAS, any kind of aviation gasoline [n]\n",
  "AVGASSES": "AVGAS, any kind of aviation gasoline [n]\n",
  "AVGOLEMONO": "(Modern Greek) a soup or sauce made from chicken stock, lemon juice and egg yolks [n -S]\n",
  "AVGOLEMONOS": "AVGOLEMONO, (Modern Greek) a soup or sauce made from chicken stock, lemon juice and egg yolks [n]\n",
  "AVIAN": "of or relating to birds [adj] / a bird [n -S]\n",
  "AVIANISE": "to make eg a virus less severe by repeated culture in a chicken embryo stock, also AVIANIZE [v AVIANISED, AVIANISING, AVIANISES]\n",
  "AVIANISED": "AVIANISE, to make eg a virus less severe by repeated culture in a chicken embryo stock, also AVIANIZE [v]\n",
  "AVIANISES": "AVIANISE, to make eg a virus less severe by repeated culture in a chicken embryo stock, also AVIANIZE [v]\n",
  "AVIANISING": "AVIANISE, to make eg a virus less severe by repeated culture in a chicken embryo stock, also AVIANIZE [v]\n",
  "AVIANIZE": "to modify by repeated culture in a chick embryo, also AVIANISE [v AVIANIZED, AVIANIZING, AVIANIZES]\n",
  "AVIANIZED": "AVIANIZE, to modify by repeated culture in a chick embryo, also AVIANISE [v]\n",
  "AVIANIZES": "AVIANIZE, to modify by repeated culture in a chick embryo, also AVIANISE [v]\n",
  "AVIANIZING": "AVIANIZE, to modify by repeated culture in a chick embryo, also AVIANISE [v]\n",
  "AVIANS": "AVIAN, a bird [n]\n",
  "AVIARIES": "AVIARY, a large bird enclosure [n]\n",
  "AVIARIST": "a keeper of an aviary [n -S]\n",
  "AVIARISTS": "AVIARIST, a keeper of an aviary [n]\n",
  "AVIARY": "a large bird enclosure [n AVIARIES]\n",
  "AVIATE": "to fly an aircraft [v AVIATED, AVIATING, AVIATES]\n",
  "AVIATED": "AVIATE, to fly an aircraft [v]\n",
  "AVIATES": "AVIATE, to fly an aircraft [v]\n",
  "AVIATIC": "relating to aviation [adj]\n",
  "AVIATING": "AVIATE, to fly an aircraft [v]\n",
  "AVIATION": "the aircraft industry [n -S]\n",
  "AVIATIONS": "AVIATION, the aircraft industry [n]\n",
  "AVIATOR": "a pilot who flies aircraft [n -S]\n",
  "AVIATORS": "AVIATOR, a pilot who flies aircraft [n]\n",
  "AVIATRESS": "a female aviator, also AVIATRICE, AVIATRIX [n -ES]\n",
  "AVIATRESSES": "AVIATRESS, a female aviator, also AVIATRICE, AVIATRIX [n]\n",
  "AVIATRICE": "a female aviator, also AVIATRESS, AVIATRIX [n -S]\n",
  "AVIATRICES": "AVIATRIX, a female aviator [n]\n",
  "AVIATRIX": "a female aviator [n AVIATRIXES or AVIATRICES]\n",
  "AVIATRIXES": "AVIATRIX, a female aviator [n]\n",
  "AVICULAR": "pertaining to birds [adj]\n",
  "AVICULTURE": "the rearing of birds [n -S]\n",
  "AVICULTURES": "AVICULTURE, the rearing of birds [n]\n",
  "AVICULTURIST": "one who practises aviculture [n -S]\n",
  "AVICULTURISTS": "AVICULTURIST, one who practises aviculture [n]\n",
  "AVID": "eager [adj AVIDER, AVIDEST, AVIDLY]\n",
  "AVIDER": "AVID, eager [adj]\n",
  "AVIDEST": "AVID, eager [adj]\n",
  "AVIDIN": "a protein found in egg-white [n -S]\n",
  "AVIDINS": "AVIDIN, a protein found in egg-white [n]\n",
  "AVIDITIES": "AVIDITY, greed [n]\n",
  "AVIDITY": "greed [n AVIDITIES]\n",
  "AVIDLY": "AVID, eager [adv]\n",
  "AVIDNESS": "avidity [n -ES]\n",
  "AVIDNESSES": "AVIDNESS, avidity [n]\n",
  "AVIETTE": "(historical) an aeroplane driven by manpower, a kind of glider [n -S]\n",
  "AVIETTES": "AVIETTE, (historical) an aeroplane driven by manpower, a kind of glider [n]\n",
  "AVIFAUNA": "(Latin) the bird life of a particular region [n AVIFAUNAS or AVIFAUNAE]\n",
  "AVIFAUNAE": "AVIFAUNA, (Latin) the bird life of a particular region [n]\n",
  "AVIFAUNAL": "relating to avifauna, the birdlife of a region [adj]\n",
  "AVIFAUNAS": "AVIFAUNA, (Latin) the bird life of a particular region [n]\n",
  "AVIFORM": "birdlike in structure [adj]\n",
  "AVIGATOR": "one who navigates aircraft [n -S]\n",
  "AVIGATORS": "AVIGATOR, one who navigates aircraft [n]\n",
  "AVINE": "pertaining to birds [adj]\n",
  "AVION": "(French) an aeroplane [n -S]\n",
  "AVIONIC": "of or pertaining to avionics, the science of electronic devices for aircraft [adj]\n",
  "AVIONICS": "the science of aviation electronics [n]\n",
  "AVIONS": "AVION, (French) an aeroplane [n]\n",
  "AVIRULENT": "of bacteria, not virulent [adj]\n",
  "AVISANDUM": "(Scots) a private consideration of a case by a judge, also AVIZANDUM [n -S]\n",
  "AVISANDUMS": "AVISANDUM, (Scots) a private consideration of a case by a judge, also AVIZANDUM [n]\n",
  "AVISE": "to advise, also AVIZE, AVYZE [v AVISED, AVISING, AVISES]\n",
  "AVISED": "AVISE, to advise, also AVIZE, AVYZE [v]\n",
  "AVISEMENT": "(Spenser) advisement, also ADVISEMENT, VIZAMENT [n -S]\n",
  "AVISEMENTS": "AVISEMENT, (Spenser) advisement, also ADVISEMENT, VIZAMENT [n]\n",
  "AVISES": "AVISE, to advise, also AVIZE, AVYZE [v]\n",
  "AVISING": "AVISE, to advise, also AVIZE, AVYZE [v]\n",
  "AVISO": "(Spanish) a boat bringing news, a dispatch-boat [n -S]\n",
  "AVISOS": "AVISO, (Spanish) a boat bringing news, a dispatch-boat [n]\n",
  "AVITAL": "(obsolete) of a grandfather, ancestral [adj]\n",
  "AVITAMINOSES": "AVITAMINOSIS, a disease (such as pellagra) resulting from a deficiency of one or more vitamins [n]\n",
  "AVITAMINOSIS": "a disease (such as pellagra) resulting from a deficiency of one or more vitamins [n AVITAMINOSES]\n",
  "AVITAMINOTIC": "relating to avitaminosis [adj]\n",
  "AVIZANDUM": "(Scots) a private consideration of a case by a judge, also AVISANDUM [n -S]\n",
  "AVIZANDUMS": "AVIZANDUM, (Scots) a private consideration of a case by a judge, also AVISANDUM [n]\n",
  "AVIZE": "to advise, also AVISE, AVYZE [v AVIZED, AVIZING, AVIZES]\n",
  "AVIZED": "AVIZE, to advise, also AVISE, AVYZE [v]\n",
  "AVIZEFULL": "(Spenser) watchful [adj]\n",
  "AVIZES": "AVIZE, to advise, also AVISE, AVYZE [v]\n",
  "AVIZING": "AVIZE, to advise, also AVISE, AVYZE [v]\n",
  "AVO": "a monetary unit of Macao [n -S]\n",
  "AVOCADO": "(Nahuatl) a rough-skinned pear-shaped edible fruit of a tropical tree [n AVOCADOS or AVOCADOES]\n",
  "AVOCADOES": "AVOCADO, (Nahuatl) a rough-skinned pear-shaped edible fruit of a tropical tree [n]\n",
  "AVOCADOS": "AVOCADO, (Nahuatl) a rough-skinned pear-shaped edible fruit of a tropical tree [n]\n",
  "AVOCATION": "a minor occupation undertaken as a diversion [n -S]\n",
  "AVOCATIONAL": "of or relating to an avocation [adj AVOCATIONALLY]\n",
  "AVOCATIONALLY": "AVOCATIONAL, of or relating to an avocation [adv]\n",
  "AVOCATIONS": "AVOCATION, a minor occupation undertaken as a diversion [n]\n",
  "AVOCET": "a wading bird with a long bill bent upwards towards the tip, also AVOSET [n -S]\n",
  "AVOCETS": "AVOCET, a wading bird with a long bill bent upwards towards the tip, also AVOSET [n]\n",
  "AVODIRE": "(French) a yellow hardwood from an African tree [n -S]\n",
  "AVODIRES": "AVODIRE, (French) a yellow hardwood from an African tree [n]\n",
  "AVOID": "to evade [v -ED, -ING, -S]\n",
  "AVOIDABLE": "capable of being avoided [adj AVOIDABLY]\n",
  "AVOIDABLY": "AVOIDABLE, capable of being avoided [adv]\n",
  "AVOIDANCE": "the act of avoiding [n -S]\n",
  "AVOIDANCES": "AVOIDANCE, the act of avoiding [n]\n",
  "AVOIDANT": "of behaviour, demonstrating a tendency to avoid interaction with others [adj]\n",
  "AVOIDED": "AVOID, to evade [v]\n",
  "AVOIDER": "one who avoids [n -S]\n",
  "AVOIDERS": "AVOIDER, one who avoids [n]\n",
  "AVOIDING": "AVOID, to evade [v]\n",
  "AVOIDS": "AVOID, to evade [v]\n",
  "AVOIRDUPOIS": "(French) a system of weights in which the pound (lb.) has 16 ounces [n -ES]\n",
  "AVOIRDUPOISES": "AVOIRDUPOIS, (French) a system of weights in which the pound (lb.) has 16 ounces [n]\n",
  "AVOISION": "a portmanteau coinage to denote blurring between tax avoidance and tax evasion [n -S]\n",
  "AVOISIONS": "AVOISION, a portmanteau coinage to denote blurring between tax avoidance and tax evasion [n]\n",
  "AVOPARCIN": "an antibiotic, formerly used to promote growth in farm animals [n -S]\n",
  "AVOPARCINS": "AVOPARCIN, an antibiotic, formerly used to promote growth in farm animals [n]\n",
  "AVOS": "AVO, a monetary unit of Macao [n]\n",
  "AVOSET": "a wading bird with a long bill bent upwards towards the tip, also AVOCET [n -S]\n",
  "AVOSETS": "AVOSET, a wading bird with a long bill bent upwards towards the tip, also AVOCET [n]\n",
  "AVOUCH": "(archaic) to justify [v -ED, -ING, -ES]\n",
  "AVOUCHABLE": "(archaic) capable of being avouched [adj]\n",
  "AVOUCHED": "AVOUCH, (archaic) to justify [v]\n",
  "AVOUCHER": "one who avouches [n -S]\n",
  "AVOUCHERS": "AVOUCHER, one who avouches [n]\n",
  "AVOUCHES": "AVOUCH, (archaic) to justify [v]\n",
  "AVOUCHING": "AVOUCH, (archaic) to justify [v]\n",
  "AVOUCHMENT": "(archaic) the act of avouching; positive declaration [n -S]\n",
  "AVOUCHMENTS": "AVOUCHMENT, (archaic) the act of avouching; positive declaration [n]\n",
  "AVOURE": "(Spenser) avowal [n -S]\n",
  "AVOURES": "AVOURE, (Spenser) avowal [n]\n",
  "AVOUTERER": "(obsolete) an adulterer, also AVOUTRER [n -S]\n",
  "AVOUTERERS": "AVOUTERER, (obsolete) an adulterer, also AVOUTRER [n]\n",
  "AVOUTRER": "an adulterer [n -S]\n",
  "AVOUTRERS": "AVOUTRER, an adulterer [n]\n",
  "AVOUTRIES": "AVOUTRY, (obsolete) adultery, also ADVOUTRY [n]\n",
  "AVOUTRY": "(obsolete) adultery, also ADVOUTRY [n AVOUTRIES]\n",
  "AVOW": "to declare [v -ED, -ING, -S]\n",
  "AVOWABLE": "able to be declared [adj]\n",
  "AVOWABLENESS": "the state of being avowable [n -ES]\n",
  "AVOWABLENESSES": "AVOWABLENESS, the state of being avowable [n]\n",
  "AVOWABLY": "AVOWABLE, able to be declared [adv]\n",
  "AVOWAL": "a declaration [n -S]\n",
  "AVOWALS": "AVOWAL, a declaration [n]\n",
  "AVOWED": "AVOW, to declare [v]\n",
  "AVOWEDLY": "certainly [adv]\n",
  "AVOWER": "one who avows [n -S]\n",
  "AVOWERS": "AVOWER, one who avows [n]\n",
  "AVOWING": "AVOW, to declare [v]\n",
  "AVOWRIES": "AVOWRY, the act of avowing and justifying in one's own right the distraining of goods [n]\n",
  "AVOWRY": "the act of avowing and justifying in one's own right the distraining of goods [n AVOWRIES]\n",
  "AVOWS": "AVOW, to declare [v]\n",
  "AVOYER": "(French) a chief magistrate of a free imperial city or canton of Switzerland [n -S]\n",
  "AVOYERS": "AVOYER, (French) a chief magistrate of a free imperial city or canton of Switzerland [n]\n",
  "AVRUGA": "(Spanish) herring roe with a smoky flavour, sometimes used as a substitute for caviar [n -S]\n",
  "AVRUGAS": "AVRUGA, (Spanish) herring roe with a smoky flavour, sometimes used as a substitute for caviar [n]\n",
  "AVULSE": "to tear away forcibly [v AVULSED, AVULSING, AVULSES]\n",
  "AVULSED": "AVULSE, to tear away forcibly [v]\n",
  "AVULSES": "AVULSE, to tear away forcibly [v]\n",
  "AVULSING": "AVULSE, to tear away forcibly [v]\n",
  "AVULSION": "the act of pulling away part of the body, either by injury or surgery [n -S]\n",
  "AVULSIONS": "AVULSION, the act of pulling away part of the body, either by injury or surgery [n]\n",
  "AVUNCULAR": "suggestive of an uncle, esp. in kindliness or geniality [adj AVUNCULARLY]\n",
  "AVUNCULARITIES": "AVUNCULARITY, the state of being avuncular [n]\n",
  "AVUNCULARITY": "the state of being avuncular [n AVUNCULARITIES]\n",
  "AVUNCULARLY": "AVUNCULAR, suggestive of an uncle, esp. in kindliness or geniality [adv]\n",
  "AVUNCULATE": "the custom in some societies of assigning rights and duties to a maternal uncle concerning his sister's son [n -S]\n",
  "AVUNCULATES": "AVUNCULATE, the custom in some societies of assigning rights and duties to a maternal uncle concerning his sister's son [n]\n",
  "AVVOGADORE": "(Italian) an official criminal prosecutor in Venice [n -S]\n",
  "AVVOGADORES": "AVVOGADORE, (Italian) an official criminal prosecutor in Venice [n]\n",
  "AVYZE": "to advise, also AVISE, AVIZE [v AVYZED, AVYZING, AVYZES]\n",
  "AVYZED": "AVYZE, to advise, also AVISE, AVIZE [v]\n",
  "AVYZES": "AVYZE, to advise, also AVISE, AVIZE [v]\n",
  "AVYZING": "AVYZE, to advise, also AVISE, AVIZE [v]\n",
  "AW": "an interjection used to express disgust, sympathy [interj]\n",
  "AWA": "(Scots) away, also AWAYES [adv]\n",
  "AWAIT": "to wait for [v -ED, -ING, -S]\n",
  "AWAITED": "AWAIT, to wait for [v]\n",
  "AWAITER": "one who awaits [n -S]\n",
  "AWAITERS": "AWAITER, one who awaits [n]\n",
  "AWAITING": "AWAIT, to wait for [v]\n",
  "AWAITS": "AWAIT, to wait for [v]\n",
  "AWAKE": "to rouse from sleep [v AWOKE or AWAKED, AWOKEN, AWAKING, AWAKES]\n",
  "AWAKED": "AWAKE, to rouse from sleep [v]\n",
  "AWAKEN": "to rouse from sleep [v -ED, -ING, -S]\n",
  "AWAKENED": "AWAKEN, to rouse from sleep [v]\n",
  "AWAKENER": "one that awakens [n -S]\n",
  "AWAKENERS": "AWAKENER, one that awakens [n]\n",
  "AWAKENING": "the act of waking up [n -S]\n",
  "AWAKENINGS": "AWAKENING, the act of waking up [n]\n",
  "AWAKENS": "AWAKEN, to rouse from sleep [v]\n",
  "AWAKES": "AWAKE, to rouse from sleep [v]\n",
  "AWAKING": "the act of waking [n -S]\n",
  "AWAKINGS": "AWAKING, the act of waking [n]\n",
  "AWANTING": "(Scots) missing; wanting [adj]\n",
  "AWARD": "to grant as merited [v -ED, -ING, -S]\n",
  "AWARDABLE": "that can be awarded [adj]\n",
  "AWARDED": "AWARD, to grant as merited [v]\n",
  "AWARDEE": "a recipient of an award [n -S]\n",
  "AWARDEES": "AWARDEE, a recipient of an award [n]\n",
  "AWARDER": "one who awards [n -S]\n",
  "AWARDERS": "AWARDER, one who awards [n]\n",
  "AWARDING": "AWARD, to grant as merited [v]\n",
  "AWARDS": "AWARD, to grant as merited [v]\n",
  "AWARE": "knowing and alert [adj AWARER, AWAREST]\n",
  "AWARENESS": "the state of being aware [n -ES]\n",
  "AWARENESSES": "AWARENESS, the state of being aware [n]\n",
  "AWARER": "AWARE, knowing and alert [adj]\n",
  "AWAREST": "AWARE, knowing and alert [adj]\n",
  "AWARN": "(Spenser) to warn [v -ED, -ING, -S]\n",
  "AWARNED": "AWARN, (Spenser) to warn [v]\n",
  "AWARNING": "AWARN, (Spenser) to warn [v]\n",
  "AWARNS": "AWARN, (Spenser) to warn [v]\n",
  "AWASH": "covered with water [adj]\n",
  "AWATCH": "(archaic) in a watchful state [adv]\n",
  "AWATO": "(Maori) the so-called vegetable caterpillar of New Zealand, also AWETO, AWHATO, AWHETO [n -S]\n",
  "AWATOS": "AWATO, (Maori) the so-called vegetable caterpillar of New Zealand, also AWETO, AWHATO, AWHETO [n]\n",
  "AWAVE": "(archaic) in a wave, in waves [adv]\n",
  "AWAY": "at or to a distance, also AWA, AWAYES [adv] / a game played on the opponent's territory [n -S]\n",
  "AWAYDAY": "a one day excursion [n -S]\n",
  "AWAYDAYS": "AWAYDAY, a one day excursion [n]\n",
  "AWAYES": "(Spenser) away [adv]\n",
  "AWAYNESS": "the state of being distant [n -ES]\n",
  "AWAYNESSES": "AWAYNESS, the state of being distant [n]\n",
  "AWAYS": "AWAY, a game played on the opponent's territory [n]\n",
  "AWDL": "(Welsh) a Welsh ode [n -S]\n",
  "AWDLS": "AWDL, (Welsh) a Welsh ode [n]\n",
  "AWE": "to strike with fear [v AWED, AWEING or AWING, AWES]\n",
  "AWEARIED": "(archaic) wearied [adj]\n",
  "AWEARY": "(archaic) weary [adj]\n",
  "AWEATHER": "on the weather side; in the direction from which the wind blows, as opposed to alee [adv]\n",
  "AWED": "AWE, to strike with fear [v]\n",
  "AWEE": "awhile [adv]\n",
  "AWEEL": "(Scots) well, indeed, also ATWEEL [interj]\n",
  "AWEIGH": "in the process of being raised, as an anchor just raised from the bottom [adv]\n",
  "AWEING": "AWE, to strike with fear [v]\n",
  "AWELESS": "without awe, also AWLESS [adj]\n",
  "AWELESSNESS": "the state of being aweless [n -ES]\n",
  "AWELESSNESSES": "AWELESSNESS, the state of being aweless [n]\n",
  "AWES": "AWE, to strike with fear [v]\n",
  "AWESOME": "impressive or inspiring awe, also AWSOME [adj]\n",
  "AWESOMELY": "AWESOME, impressive or inspiring awe, also AWSOME [adv]\n",
  "AWESOMENESS": "the state of being awesome [n -ES]\n",
  "AWESOMENESSES": "AWESOMENESS, the state of being awesome [n]\n",
  "AWESTRICKEN": "stricken with awe [adj]\n",
  "AWESTRIKE": "to inspire great awe in [v AWESTRUCK, AWESTRICKEN, AWESTRIKING, AWESTRIKES]\n",
  "AWESTRIKES": "AWESTRIKE, to inspire great awe in [v]\n",
  "AWESTRIKING": "AWESTRIKE, to inspire great awe in [v]\n",
  "AWESTRUCK": "stricken with awe [adj]\n",
  "AWETO": "(Maori) a wormlike fungus, also AWATO, AWHATO, AWHETO [n -S]\n",
  "AWETOS": "AWETO, (Maori) a wormlike fungus, also AWATO, AWHATO, AWHETO [n]\n",
  "AWFUL": "horrible [adj AWFULLER, AWFULLEST, AWFULLY]\n",
  "AWFULLER": "AWFUL, horrible [adj]\n",
  "AWFULLEST": "AWFUL, horrible [adj]\n",
  "AWFULLY": "AWFUL, horrible [adv]\n",
  "AWFULNESS": "the state of being awful [n -ES]\n",
  "AWFULNESSES": "AWFULNESS, the state of being awful [n]\n",
  "AWFY": "(Scots) awfully, extremely [adv]\n",
  "AWHAPE": "(Spenser) to confound, amaze [v AWHAPED, AWHAPING, AWHAPES]\n",
  "AWHAPED": "AWHAPE, (Spenser) to confound, amaze [v]\n",
  "AWHAPES": "AWHAPE, (Spenser) to confound, amaze [v]\n",
  "AWHAPING": "AWHAPE, (Spenser) to confound, amaze [v]\n",
  "AWHATO": "(Maori) the so-called vegetable caterpillar of New Zealand, also AWATO, AWETO, AWHETO [n -S]\n",
  "AWHATOS": "AWHATO, (Maori) the so-called vegetable caterpillar of New Zealand, also AWATO, AWETO, AWHETO [n]\n",
  "AWHEEL": "on wheels, also AWHEELS [adv]\n",
  "AWHEELS": "on wheels, also AWHEEL [adv]\n",
  "AWHETO": "(Maori) the so-called vegetable caterpillar of New Zealand [n -S]\n",
  "AWHETOS": "AWHETO, (Maori) the so-called vegetable caterpillar of New Zealand [n]\n",
  "AWHILE": "for a short time [adv]\n",
  "AWHIRL": "whirling [adj]\n",
  "AWING": "AWE, to strike with fear [v]\n",
  "AWK": "a computer-programming language used for data processing [n -S]\n",
  "AWKS": "AWK, a computer-programming language used for data processing [n]\n",
  "AWKWARD": "lacking grace [adj AWKWARDER, AWKWARDEST, AWKWARDLY]\n",
  "AWKWARDER": "AWKWARD, lacking grace [adj]\n",
  "AWKWARDEST": "AWKWARD, lacking grace [adj]\n",
  "AWKWARDISH": "somewhat awkward [adj]\n",
  "AWKWARDLY": "AWKWARD, lacking grace [adv]\n",
  "AWKWARDNESS": "the state of being awkward [n -ES]\n",
  "AWKWARDNESSES": "AWKWARDNESS, the state of being awkward [n]\n",
  "AWL": "a pointed tool for making holes [n -S]\n",
  "AWLBIRD": "(dialect) the green woodpecker [n -S]\n",
  "AWLBIRDS": "AWLBIRD, (dialect) the green woodpecker [n]\n",
  "AWLESS": "without awe, also AWELESS [adj]\n",
  "AWLS": "AWL, a pointed tool for making holes [n]\n",
  "AWLWORT": "an aquatic plant with awl-shaped leaves [n -S]\n",
  "AWLWORTS": "AWLWORT, an aquatic plant with awl-shaped leaves [n]\n",
  "AWMOUS": "(Scots) alms, also ALMOUS [n]\n",
  "AWMRIE": "a cupboard for sacred vessels, also AMBRY, ALMERY, AMBERY, AUMBRY, AWMRY [n -S]\n",
  "AWMRIES": "AWMRIE, a cupboard for sacred vessels, also AMBRY, ALMERY, AMBERY, AUMBRY, AWMRY [n]\n",
  "AWMRY": "a cupboard for sacred vessels, also AMBRY, ALMERY, AMBERY, AUMBRY, AWMRIE [n AWMRIES]\n",
  "AWN": "a beard on grass [n -S] / to shelter with an awning [v -ED, -ING, -S]\n",
  "AWNED": "AWN, to shelter with an awning [v]\n",
  "AWNER": "a machine for removing the awns from grain [n -S]\n",
  "AWNERS": "AWNER, a machine for removing the awns from grain [n]\n",
  "AWNIER": "AWNY, bristly like an awn [adj]\n",
  "AWNIEST": "AWNY, bristly like an awn [adj]\n",
  "AWNING": "a rooflike canvas cover [n -S]\n",
  "AWNINGED": "having an awning [adj]\n",
  "AWNINGS": "AWNING, a rooflike canvas cover [n]\n",
  "AWNLESS": "without an awning [adj]\n",
  "AWNS": "AWN, a beard on grass [n]\n",
  "AWNY": "bristly like an awn [adj AWNIER, AWNIEST]\n",
  "AWOKE": "AWAKE, to rouse from sleep [v]\n",
  "AWOKEN": "AWAKE, to rouse from sleep [v]\n",
  "AWOL": "one who is absent without leave [n -S]\n",
  "AWOLS": "AWOL, one who is absent without leave [n]\n",
  "AWORK": "at work [adv]\n",
  "AWRACK": "(obsolete) in a state of wreck [adv]\n",
  "AWRONG": "(obsolete) wrongly [adv]\n",
  "AWRY": "askew [adv]\n",
  "AWSOME": "impressive or inspiring awe, also AWESOME [adj]\n",
  "AX": "(US) to chop with a cutting tool, also AXE [v -ED, -ING, -ES]\n",
  "AXAL": "pertaining to an axis, also AXIAL [adj]\n",
  "AXE": "to chop or cut down, also AX [v AXED, AXING, AXES]\n",
  "AXEBIRD": "a kind of nightjar from Queensland, sounding like a chopping axe [n -S]\n",
  "AXEBIRDS": "AXEBIRD, a kind of nightjar from Queensland, sounding like a chopping axe [n]\n",
  "AXED": "AX, (US) to chop with a cutting tool, also AXE [v]\n",
  "AXEL": "in figure-skating, a jump from one skate to the other [n -S]\n",
  "AXELIKE": "like an axe in form, also AXLIKE [adj]\n",
  "AXELS": "AXEL, in figure-skating, a jump from one skate to the other [n]\n",
  "AXEMAN": "a man who uses an axe, also AXMAN [n AXEMEN]\n",
  "AXEMEN": "AXEMAN, a man who uses an axe, also AXMAN [n]\n",
  "AXENIC": "not contaminated by or associated with any other living organisms, e.g. of pure cultures of microorganisms [adj AXENICALLY]\n",
  "AXENICALLY": "AXENIC, not contaminated by or associated with any other living organisms, e.g. of pure cultures of microorganisms [adv]\n",
  "AXEROPHTHOL": "vitamin A, a pale yellow crystalline substance, deficiency of which causes xerophthalmia [n -S]\n",
  "AXEROPHTHOLS": "AXEROPHTHOL, vitamin A, a pale yellow crystalline substance, deficiency of which causes xerophthalmia [n]\n",
  "AXES": "AX, (US) to chop with a cutting tool, also AXE [v]\n",
  "AXIAL": "pertaining to an axis, also AXAL [adj]\n",
  "AXIALITIES": "AXIALITY, the state of being axial [n]\n",
  "AXIALITY": "the state of being axial [n AXIALITIES]\n",
  "AXIALLY": "pertaining to an axial [adv]\n",
  "AXIL": "the upper angle between leaf and stem [n -S]\n",
  "AXILE": "coinciding with an axis, also AXAL, AXIAL [adj]\n",
  "AXILEMMA": "the membrane that encloses the axons of a nerve cell, also AXOLEMMA [n -S]\n",
  "AXILEMMAS": "AXILEMMA, the membrane that encloses the axons of a nerve cell, also AXOLEMMA [n]\n",
  "AXILLA": "(Latin) the armpit [n AXILLAS or AXILLAE]\n",
  "AXILLAE": "AXILLA, (Latin) the armpit [n]\n",
  "AXILLAR": "a feather on the undersurface of a bird's wing, also AXILLARY [n -S]\n",
  "AXILLARIES": "AXILLARY, a feather on the undersurface of a bird's wing, also AXILLAR [n]\n",
  "AXILLARS": "AXILLAR, a feather on the undersurface of a bird's wing, also AXILLARY [n]\n",
  "AXILLARY": "a feather on the undersurface of a bird's wing, also AXILLAR [n AXILLARIES]\n",
  "AXILLAS": "AXILLA, (Latin) the armpit [n]\n",
  "AXILS": "AXIL, the upper angle between leaf and stem [n]\n",
  "AXING": "AX, (US) to chop with a cutting tool, also AXE [v]\n",
  "AXINITE": "a silicate of the epidote group [n -S]\n",
  "AXINITES": "AXINITE, a silicate of the epidote group [n]\n",
  "AXINOMANCIES": "AXINOMANCY, divination using an axe or hatchet [n]\n",
  "AXINOMANCY": "divination using an axe or hatchet [n AXINOMANCIES]\n",
  "AXIOLOGICAL": "relating to axiology, the science of the ultimate nature of values [adj AXIOLOGICALLY]\n",
  "AXIOLOGICALLY": "AXIOLOGICAL, relating to axiology, the science of the ultimate nature of values [adv]\n",
  "AXIOLOGIES": "AXIOLOGY, the science of the ultimate nature of values [n]\n",
  "AXIOLOGIST": "one who studies ultimate values [n -S]\n",
  "AXIOLOGISTS": "AXIOLOGIST, one who studies ultimate values [n]\n",
  "AXIOLOGY": "the science of the ultimate nature of values [n AXIOLOGIES]\n",
  "AXIOM": "a self-evident truth [n -S]\n",
  "AXIOMATIC": "indisputably true, self-evident, also AXIOMATICAL [adj AXIOMATICALLY]\n",
  "AXIOMATICAL": "indisputably true, self-evident, also AXIOMATIC [adj AXIOMATICALLY]\n",
  "AXIOMATICALLY": "AXIOMATICAL, indisputably true, self-evident, also AXIOMATIC [adv]\n",
  "AXIOMATICS": "the study of axioms and axiom systems [n]\n",
  "AXIOMATISATION": "the act of reducing to a system of axioms, also AXIOMATIZATION [n -S]\n",
  "AXIOMATISATIONS": "AXIOMATISATION, the act of reducing to a system of axioms, also AXIOMATIZATION [n]\n",
  "AXIOMATISE": "to make axiomatic, also AXIOMATIZE [v AXIOMATISED, AXIOMATISING, AXIOMATISES]\n",
  "AXIOMATISED": "AXIOMATISE, to make axiomatic, also AXIOMATIZE [v]\n",
  "AXIOMATISES": "AXIOMATISE, to make axiomatic, also AXIOMATIZE [v]\n",
  "AXIOMATISING": "AXIOMATISE, to make axiomatic, also AXIOMATIZE [v]\n",
  "AXIOMATIZATION": "the act of reducing to a system of axioms, also AXIOMATISATION [n -S]\n",
  "AXIOMATIZATIONS": "AXIOMATIZATION, the act of reducing to a system of axioms, also AXIOMATISATION [n]\n",
  "AXIOMATIZE": "to reduce to a system of axioms, also AXIOMATISE [v AXIOMATIZED, AXIOMATIZING, AXIOMATIZES]\n",
  "AXIOMATIZED": "AXIOMATIZE, to reduce to a system of axioms, also AXIOMATISE [v]\n",
  "AXIOMATIZES": "AXIOMATIZE, to reduce to a system of axioms, also AXIOMATISE [v]\n",
  "AXIOMATIZING": "AXIOMATIZE, to reduce to a system of axioms, also AXIOMATISE [v]\n",
  "AXIOMS": "AXIOM, a self-evident truth [n]\n",
  "AXION": "a hypothetical subatomic particle [n -S]\n",
  "AXIONS": "AXION, a hypothetical subatomic particle [n]\n",
  "AXIS": "(Latin) the imaginary straight line about which a body rotates [n AXISES or AXES] / a white-spotted Asian deer [n AXISES]\n",
  "AXISED": "having an axis [adj]\n",
  "AXISES": "AXIS, (Latin) the imaginary straight line about which a body rotates [n]\n",
  "AXISYMMETRIC": "symmetrical in respect to an axis, also AXISYMMETRICAL [adj]\n",
  "AXISYMMETRICAL": "symmetrical in respect to an axis, also AXISYMMETRIC [adj]\n",
  "AXISYMMETRIES": "AXISYMMETRY, the state of being axisymmetric [n]\n",
  "AXISYMMETRY": "the state of being axisymmetric [n AXISYMMETRIES]\n",
  "AXITE": "a type of smokeless gunpowder [n -S]\n",
  "AXITES": "AXITE, a type of smokeless gunpowder [n]\n",
  "AXLE": "a shaft upon which a wheel revolves [n -S]\n",
  "AXLED": "having an axle [adj]\n",
  "AXLES": "AXLE, a shaft upon which a wheel revolves [n]\n",
  "AXLETREE": "a bar used as a primitive wheel axle for animal-drawn vehicle [n -S]\n",
  "AXLETREES": "AXLETREE, a bar used as a primitive wheel axle for animal-drawn vehicle [n]\n",
  "AXLIKE": "like an ax, also AXELIKE [adj]\n",
  "AXMAN": "a man who uses an axe, also AXEMAN [n AXMEN]\n",
  "AXMEN": "AXMAN, a man who uses an axe, also AXEMAN [n]\n",
  "AXOID": "a curve generated by the revolution of a point round an advancing axis [n -S]\n",
  "AXOIDS": "AXOID, a curve generated by the revolution of a point round an advancing axis [n]\n",
  "AXOLEMMA": "the membrane that encloses the axons of a nerve cell, also AXILEMMA [n AXOLEMMAS or AXOLEMMATA]\n",
  "AXOLEMMAS": "AXOLEMMA, the membrane that encloses the axons of a nerve cell, also AXILEMMA [n]\n",
  "AXOLEMMATA": "AXOLEMMA, the membrane that encloses the axons of a nerve cell, also AXILEMMA [n]\n",
  "AXOLOTL": "(Nahuatl) a type of Mexican salamander [n -S]\n",
  "AXOLOTLS": "AXOLOTL, (Nahuatl) a type of Mexican salamander [n]\n",
  "AXON": "(Greek) a nerve fibre, also AXONE [n -S]\n",
  "AXONAL": "relating to an axon, also AXONIC [adj]\n",
  "AXONE": "a nerve fibre, also AXON [n -S]\n",
  "AXONEMAL": "relating to an axoneme, part of a cilium [adj]\n",
  "AXONEME": "a central strand of a locomotor organelle such as a cilium or flagellum [n -S]\n",
  "AXONEMES": "AXONEME, a central strand of a locomotor organelle such as a cilium or flagellum [n]\n",
  "AXONES": "AXONE, a nerve fibre, also AXON [n]\n",
  "AXONIC": "relating to an axon, also AXONAL [adj]\n",
  "AXONOMETRIC": "relating to the projection of objects on the drawing surface so that they appear inclined with three sides showing and with horizontal and vertical distances drawn to scale but diagonal and curved lines distorted [adj]\n",
  "AXONOMETRIES": "AXONOMETRY, the branch of crystallography concerned with measurement of the axes of crystals [n]\n",
  "AXONOMETRY": "the branch of crystallography concerned with measurement of the axes of crystals [n AXONOMETRIES]\n",
  "AXONS": "AXON, (Greek) a nerve fibre, also AXONE [n]\n",
  "AXOPLASM": "the cytoplasm of an axon, a nerve fibre [n -S]\n",
  "AXOPLASMIC": "relating to axoplasm [adj]\n",
  "AXOPLASMS": "AXOPLASM, the cytoplasm of an axon, a nerve fibre [n]\n",
  "AXSEED": "a kind of vetch, aka crown vetch [n -S]\n",
  "AXSEEDS": "AXSEED, a kind of vetch, aka crown vetch [n]\n",
  "AY": "an affirmative vote, also AYE [n -S]\n",
  "AYAH": "(Hindi) in India, a maid or nurse, also AIA [n -S]\n",
  "AYAHS": "AYAH, (Hindi) in India, a maid or nurse, also AIA [n]\n",
  "AYAHUASCA": "(Quechua) a South American vine, the roots of which yield a drink having a hallucinatory effect, also AYAHUASCO [n -S]\n",
  "AYAHUASCAS": "AYAHUASCA, (Quechua) a South American vine, the roots of which yield a drink having a hallucinatory effect, also AYAHUASCO [n]\n",
  "AYAHUASCO": "(Quechua) a South American vine, the roots of which yield a drink having a hallucinatory effect, also AYAHUASCA [n -S]\n",
  "AYAHUASCOS": "AYAHUASCO, (Quechua) a South American vine, the roots of which yield a drink having a hallucinatory effect, also AYAHUASCA [n]\n",
  "AYATOLLAH": "(Arabic) an Iranian religious leader [n -S]\n",
  "AYATOLLAHS": "AYATOLLAH, (Arabic) an Iranian religious leader [n]\n",
  "AYAYA": "(Inuit) a type of singing among the Inuit [n -S]\n",
  "AYAYAS": "AYAYA, (Inuit) a type of singing among the Inuit [n]\n",
  "AYE": "an affirmative vote, also AY [n -S]\n",
  "AYELP": "in a state of yelping [adv]\n",
  "AYENBITE": "(obsolete) remorse [n -S]\n",
  "AYENBITES": "AYENBITE, (obsolete) remorse [n]\n",
  "AYES": "AYE, an affirmative vote, also AY [n]\n",
  "AYGRE": "(Shakespeare) eager [adj]\n",
  "AYIN": "(Hebrew) the sixteenth letter of the Hebrew alphabet [n -S]\n",
  "AYINS": "AYIN, (Hebrew) the sixteenth letter of the Hebrew alphabet [n]\n",
  "AYONT": "(archaic) beyond [adv]\n",
  "AYRE": "(obsolete) an air, esp. in the sense of a tune, also AIR [n -S]\n",
  "AYRES": "AYRE, (obsolete) an air, esp. in the sense of a tune, also AIR [n]\n",
  "AYRIE": "the nest of a bird of prey, also EYRIE, AERIE, AERY, AIERY [n -S]\n",
  "AYRIES": "AYRIE, the nest of a bird of prey, also EYRIE, AERIE, AERY, AIERY [n]\n",
  "AYS": "AY, an affirmative vote, also AYE [n]\n",
  "AYU": "(Japanese) a small edible Japanese fish [n -S]\n",
  "AYUNTAMIENTO": "(Spanish) a municipal council [n -S]\n",
  "AYUNTAMIENTOS": "AYUNTAMIENTO, (Spanish) a municipal council [n]\n",
  "AYURVEDA": "(Sanskrit) the traditional system of Indian medicine [n -S]\n",
  "AYURVEDAS": "AYURVEDA, (Sanskrit) the traditional system of Indian medicine [n]\n",
  "AYURVEDIC": "relating to ayurveda, the traditional system of Indian medicine [adj]\n",
  "AYURVEDICS": "the traditional system of Indian medicine [n]\n",
  "AYUS": "AYU, (Japanese) a small edible Japanese fish [n]\n",
  "AYWORD": "(Shakespeare) a byword, proverbial reproach [n -S]\n",
  "AYWORDS": "AYWORD, (Shakespeare) a byword, proverbial reproach [n]\n",
  "AZALEA": "a flowering shrub [n -S]\n",
  "AZALEAS": "AZALEA, a flowering shrub [n]\n",
  "AZAN": "(Arabic) the Muslim call to prayer, also ADHAN [n -S]\n",
  "AZANS": "AZAN, (Arabic) the Muslim call to prayer, also ADHAN [n]\n",
  "AZATHIOPRINE": "a synthetic drug used in transplant surgery to suppress the body's immune system [n -S]\n",
  "AZATHIOPRINES": "AZATHIOPRINE, a synthetic drug used in transplant surgery to suppress the body's immune system [n]\n",
  "AZEDARACH": "(Persian) the stringent bark of the chinaberry, used as an emetic and cathartic [n -S]\n",
  "AZEDARACHS": "AZEDARACH, (Persian) the stringent bark of the chinaberry, used as an emetic and cathartic [n]\n",
  "AZEOTROPE": "a chemical term for a certain type of liquid mixture [n -S]\n",
  "AZEOTROPES": "AZEOTROPE, a chemical term for a certain type of liquid mixture [n]\n",
  "AZEOTROPIC": "of or like an azeotrope, a chemical term for a certain type of liquid mixture [adj]\n",
  "AZEOTROPIES": "AZEOTROPY, the state of being an azeotrope [n]\n",
  "AZEOTROPY": "the state of being an azeotrope [n AZEOTROPIES]\n",
  "AZERTY": "designating a European version of the typewriter keyboard, as opposed to qwerty [adj]\n",
  "AZIDE": "a salt of hydrazoic acid [n -S]\n",
  "AZIDES": "AZIDE, a salt of hydrazoic acid [n]\n",
  "AZIDO": "of a compound, containing azide [adj]\n",
  "AZIDOTHYMIDINE": "a derivative of thymidine [n -S]\n",
  "AZIDOTHYMIDINES": "AZIDOTHYMIDINE, a derivative of thymidine [n]\n",
  "AZIMUTH": "(Arabic) the angle a celestial object makes from due north, when measured in an eastwards direction along the horizon [n -S]\n",
  "AZIMUTHAL": "of or pertaining to the azimuth [adj AZIMUTHALLY]\n",
  "AZIMUTHALLY": "AZIMUTHAL, of or pertaining to the azimuth [adv]\n",
  "AZIMUTHS": "AZIMUTH, (Arabic) the angle a celestial object makes from due north, when measured in an eastwards direction along the horizon [n]\n",
  "AZINE": "a type of nitrogen compound [n -S]\n",
  "AZINES": "AZINE, a type of nitrogen compound [n]\n",
  "AZIONE": "(Italian) a composition like an oratorio but performed as a drama [n -S]\n",
  "AZIONES": "AZIONE, (Italian) a composition like an oratorio but performed as a drama [n]\n",
  "AZLON": "a textile fibre made from regenerated soybean protein [n -S]\n",
  "AZLONS": "AZLON, a textile fibre made from regenerated soybean protein [n]\n",
  "AZO": "of compounds, containing nitrogen, as in azo dye [adj]\n",
  "AZOBENZENE": "a dye containing an azo compound [n -S]\n",
  "AZOBENZENES": "AZOBENZENE, a dye containing an azo compound [n]\n",
  "AZOIC": "lacking life, esp. of geological period [adj]\n",
  "AZOLE": "any of various organic compounds with a five-membered ring [n -S]\n",
  "AZOLES": "AZOLE, any of various organic compounds with a five-membered ring [n]\n",
  "AZOLLA": "a tiny water fern [n -S]\n",
  "AZOLLAS": "AZOLLA, a tiny water fern [n]\n",
  "AZON": "a radio-controlled aerial bomb [n -S]\n",
  "AZONAL": "of e.g. soil, not arranged in zones [adj]\n",
  "AZONIC": "not limited to a zone, not local [adj]\n",
  "AZONS": "AZON, a radio-controlled aerial bomb [n]\n",
  "AZOOSPERMIA": "absence of spermatozoa from the seminal fluid [n -S]\n",
  "AZOOSPERMIAS": "AZOOSPERMIA, absence of spermatozoa from the seminal fluid [n]\n",
  "AZOOSPERMIC": "relating to azoospermia, absence of spermatozoa from the seminal fluid [adj]\n",
  "AZOTAEMIA": "a less common name for uraemia, the retention of waste materials normally excreted, also AZOTEMIA [n -S]\n",
  "AZOTAEMIAS": "AZOTAEMIA, a less common name for uraemia, the retention of waste materials normally excreted, also AZOTEMIA [n]\n",
  "AZOTAEMIC": "relating to azotaemia, an excess of nitrogen in the blood, also AZOTEMIC [adj]\n",
  "AZOTE": "an old name for nitrogen [n -S]\n",
  "AZOTED": "combined with azote, nitrogen [adj]\n",
  "AZOTEMIA": "an excess of nitrogenous substances in the blood, also AZOTAEMIA [n -S]\n",
  "AZOTEMIAS": "AZOTEMIA, an excess of nitrogenous substances in the blood, also AZOTAEMIA [n]\n",
  "AZOTEMIC": "relating to azotemia, also AZOTAEMIC [adj]\n",
  "AZOTES": "AZOTE, an old name for nitrogen [n]\n",
  "AZOTH": "(Arabic) an alchemist's name for mercury [n -S]\n",
  "AZOTHS": "AZOTH, (Arabic) an alchemist's name for mercury [n]\n",
  "AZOTIC": "nitric [adj]\n",
  "AZOTISE": "to combine with nitrogen, also AZOTIZE [v AZOTISED, AZOTISING, AZOTISES]\n",
  "AZOTISED": "AZOTISE, to combine with nitrogen, also AZOTIZE [v]\n",
  "AZOTISES": "AZOTISE, to combine with nitrogen, also AZOTIZE [v]\n",
  "AZOTISING": "AZOTISE, to combine with nitrogen, also AZOTIZE [v]\n",
  "AZOTIZE": "to combine with nitrogen, also AZOTISE [v AZOTIZED, AZOTIZING, AZOTIZES]\n",
  "AZOTIZED": "AZOTIZE, to combine with nitrogen, also AZOTISE [v]\n",
  "AZOTIZES": "AZOTIZE, to combine with nitrogen, also AZOTISE [v]\n",
  "AZOTIZING": "AZOTIZE, to combine with nitrogen, also AZOTISE [v]\n",
  "AZOTOBACTER": "a nitrogen-fixing bacteria [n -S]\n",
  "AZOTOBACTERS": "AZOTOBACTER, a nitrogen-fixing bacteria [n]\n",
  "AZOTOUS": "nitrous; as, azotous acid [adj]\n",
  "AZOTURIA": "an excess of urea in the urine [n -S]\n",
  "AZOTURIAS": "AZOTURIA, an excess of urea in the urine [n]\n",
  "AZUKI": "(Japanese) a kind of bean, also ADUKI, ADSUKI, ADZUKI [n -S]\n",
  "AZUKIS": "AZUKI, (Japanese) a kind of bean, also ADUKI, ADSUKI, ADZUKI [n]\n",
  "AZULEJO": "(Spanish) a painted pottery tile [n -S]\n",
  "AZULEJOS": "AZULEJO, (Spanish) a painted pottery tile [n]\n",
  "AZURE": "a delicate blue colour, also AZURY [n -S]\n",
  "AZUREAN": "azure, also AZURN [adj]\n",
  "AZURES": "AZURE, a delicate blue colour, also AZURY [n]\n",
  "AZURIES": "AZURY, a bluish colour, also AZURE, AZUREAN, AZURN [n]\n",
  "AZURINE": "a freshwater fish, the blue roach [n -S]\n",
  "AZURINES": "AZURINE, a freshwater fish, the blue roach [n]\n",
  "AZURITE": "a blue carbonate of copper, aka blue malachite [n -S]\n",
  "AZURITES": "AZURITE, a blue carbonate of copper, aka blue malachite [n]\n",
  "AZURN": "(Milton) azure, also AZURE, AZUREAN, AZURY [adj]\n",
  "AZURY": "a bluish colour, also AZURE, AZUREAN, AZURN [n AZURIES]\n",
  "AZYGIES": "AZYGY, a state of being unpaired [n]\n",
  "AZYGOS": "an unpaired structure [n -ES]\n",
  "AZYGOSES": "AZYGOS, an unpaired structure [n]\n",
  "AZYGOSPORE": "a thick-walled spore produced by parthenogenesis in certain algae and fungi [n -S]\n",
  "AZYGOSPORES": "AZYGOSPORE, a thick-walled spore produced by parthenogenesis in certain algae and fungi [n]\n",
  "AZYGOUS": "not being one of a pair [adj AZYGOUSLY]\n",
  "AZYGOUSLY": "AZYGOUS, not being one of a pair [adv]\n",
  "AZYGY": "a state of being unpaired [n AZYGIES]\n",
  "AZYM": "unleavened bread, also AZYME [n -S]\n",
  "AZYME": "unleavened bread, also AZYM [n -S]\n",
  "AZYMES": "AZYME, unleavened bread, also AZYM [n]\n",
  "AZYMITE": "a member of any church using unleavened bread in the Eucharist [n -S]\n",
  "AZYMITES": "AZYMITE, a member of any church using unleavened bread in the Eucharist [n]\n",
  "AZYMOUS": "unleavened [adj]\n",
  "AZYMS": "AZYM, unleavened bread, also AZYME [n]\n",
  "BA": "the soul, in ancient Egyptian religion [n -S]\n",
  "BAA": "to cry like a sheep [v -ED, -ING, -S]\n",
  "BAAED": "BAA, to cry like a sheep [v]\n",
  "BAAING": "the cry of a sheep [n -S]\n",
  "BAAINGS": "BAAING, the cry of a sheep [n]\n",
  "BAAL": "(Hebrew) a false god [n BAALS or BAALIM]\n",
  "BAALEBATIM": "BAALEBOS, (Yiddish) master of the house [n]\n",
  "BAALEBOS": "(Yiddish) master of the house [n BAALEBATIM]\n",
  "BAALIM": "BAAL, (Hebrew) a false god [n]\n",
  "BAALISM": "the worship of baal [n -S]\n",
  "BAALISMS": "BAALISM, the worship of baal [n]\n",
  "BAALS": "BAAL, (Hebrew) a false god [n]\n",
  "BAAS": "(South African) a boss [n -ES]\n",
  "BAASES": "BAAS, (South African) a boss [n]\n",
  "BAASKAAP": "(South African) the policy of domination of white people in South Africa, also BAASKAP, BAASSKAP [n -S]\n",
  "BAASKAAPS": "BAASKAAP, (South African) the policy of domination of white people in South Africa, also BAASKAP, BAASSKAP [n]\n",
  "BAASKAP": "(South African) the policy of domination of white people in South Africa, also BAASKAAP, BAASSKAP [n -S]\n",
  "BAASKAPS": "BAASKAP, (South African) the policy of domination of white people in South Africa, also BAASKAAP, BAASSKAP [n]\n",
  "BAASSKAP": "(South African) a theory of racial politics [n -S]\n",
  "BAASSKAPS": "BAASSKAP, (South African) a theory of racial politics [n]\n",
  "BABA": "(Polish) a kind of coffee-cake, containing almonds, raisins, rum, orange rind, also BABKA [n -S]\n",
  "BABACO": "(Spanish) a subtropical five-sided fruit related to the papaya [n -S]\n",
  "BABACOOTE": "(Malagasy) a large lemur, the indri or closely related species [n -S]\n",
  "BABACOOTES": "BABACOOTE, (Malagasy) a large lemur, the indri or closely related species [n]\n",
  "BABACOS": "BABACO, (Spanish) a subtropical five-sided fruit related to the papaya [n]\n",
  "BABACU": "(Tupi) a Brazilian palm tree, also BABASSU [n -S]\n",
  "BABACUS": "BABACU, (Tupi) a Brazilian palm tree, also BABASSU [n]\n",
  "BABALAS": "(Zulu) drunk, also BABBELAS [adj]\n",
  "BABAS": "BABA, (Polish) a kind of coffee-cake, containing almonds, raisins, rum, orange rind, also BABKA [n]\n",
  "BABASSU": "(Tupi) a Brazilian palm tree, also BABACU [n -S]\n",
  "BABASSUS": "BABASSU, (Tupi) a Brazilian palm tree, also BABACU [n]\n",
  "BABBELAS": "(Zulu) drunk, also BABALAS [adj]\n",
  "BABBITRIES": "BABBITRY, conventional middle-class attitudes and behavior stressing respectability and material success [n]\n",
  "BABBITRY": "conventional middle-class attitudes and behavior stressing respectability and material success [n BABBITRIES]\n",
  "BABBITT": "to fit with Babbitt metal, a soft antifriction alloy tin [v -ED, -ING, -S]\n",
  "BABBITTED": "BABBITT, to fit with Babbitt metal, a soft antifriction alloy tin [v]\n",
  "BABBITTING": "BABBITT, to fit with Babbitt metal, a soft antifriction alloy tin [v]\n",
  "BABBITTRIES": "BABBITTRY, narrow-minded middle-class complacence, also BABBITRY [n]\n",
  "BABBITTRY": "narrow-minded middle-class complacence, also BABBITRY [n BABBITTRIES]\n",
  "BABBITTS": "BABBITT, to fit with Babbitt metal, a soft antifriction alloy tin [v]\n",
  "BABBLATIVE": "given to babbling, loquacious [adj]\n",
  "BABBLE": "to talk incessantly [v BABBLED, BABBLING, BABBLES]\n",
  "BABBLED": "BABBLE, to talk incessantly [v]\n",
  "BABBLEMENT": "babble [n -S]\n",
  "BABBLEMENTS": "BABBLEMENT, babble [n]\n",
  "BABBLER": "any of a family of tropical birds [n -S]\n",
  "BABBLERS": "BABBLER, any of a family of tropical birds [n]\n",
  "BABBLES": "BABBLE, to talk incessantly [v]\n",
  "BABBLIER": "BABBLY, given to babbling, chattery [adj]\n",
  "BABBLIEST": "BABBLY, given to babbling, chattery [adj]\n",
  "BABBLING": "idle talk [n -S]\n",
  "BABBLINGS": "BABBLING, idle talk [n]\n",
  "BABBLY": "given to babbling, chattery [adj BABBLIER, BABBLIEST]\n",
  "BABE": "a baby; an attractive young woman [n -S]\n",
  "BABEL": "a confused sound of voices [n -S]\n",
  "BABELDOM": "a confused sound of voices [n -S]\n",
  "BABELDOMS": "BABELDOM, a confused sound of voices [n]\n",
  "BABELESQUE": "full of confused sound and voices [adj]\n",
  "BABELISH": "in a confused state [adj]\n",
  "BABELISM": "a state of confused sound [n -S]\n",
  "BABELISMS": "BABELISM, a state of confused sound [n]\n",
  "BABELS": "BABEL, a confused sound of voices [n]\n",
  "BABES": "BABE, a baby; an attractive young woman [n]\n",
  "BABESIA": "a parasite causing cattle fever [n BABESIAE or BABESIAS]\n",
  "BABESIAE": "BABESIA, a parasite causing cattle fever [n]\n",
  "BABESIAS": "BABESIA, a parasite causing cattle fever [n]\n",
  "BABESIASES": "BABESIASIS, redwater, a cattle infection caused by the parasite babesia, also BABESIOSIS [n]\n",
  "BABESIASIS": "redwater, a cattle infection caused by the parasite babesia, also BABESIOSIS [n BABESIASES]\n",
  "BABESIOSES": "BABESIOSIS, redwater, a cattle infection caused by the parasite babesia, also BABESIASIS [n]\n",
  "BABESIOSIS": "redwater, a cattle infection caused by the parasite babesia, also BABESIASIS [n BABESIOSES]\n",
  "BABICHE": "(French) a thong or lace made of rawhide [n -S]\n",
  "BABICHES": "BABICHE, (French) a thong or lace made of rawhide [n]\n",
  "BABIED": "BABY, to treat like a baby [v]\n",
  "BABIER": "BABY, like a baby [adj]\n",
  "BABIES": "BABY, to treat like a baby [v]\n",
  "BABIEST": "BABY, like a baby [adj]\n",
  "BABINGTONITE": "a triclinic basic silicate of iron and calcium, occurring as glassy greenish-black crystals [n -S]\n",
  "BABINGTONITES": "BABINGTONITE, a triclinic basic silicate of iron and calcium, occurring as glassy greenish-black crystals [n]\n",
  "BABIROUSSA": "(Malay) a large hoglike quadruped of the East Indies, also BABIRUSA, BABIRUSSA [n -S]\n",
  "BABIROUSSAS": "BABIROUSSA, (Malay) a large hoglike quadruped of the East Indies, also BABIRUSA, BABIRUSSA [n]\n",
  "BABIRUSA": "(Malay) a large hoglike quadruped of the East Indies, also BABIROUSSA, BABIRUSSA [n -S]\n",
  "BABIRUSAS": "BABIRUSA, (Malay) a large hoglike quadruped of the East Indies, also BABIROUSSA, BABIRUSSA [n]\n",
  "BABIRUSSA": "(Malay) a large hoglike quadruped of the East Indies, also BABIROUSSA, BABIRUSA [n -S]\n",
  "BABIRUSSAS": "BABIRUSSA, (Malay) a large hoglike quadruped of the East Indies, also BABIROUSSA, BABIRUSA [n]\n",
  "BABKA": "(Polish) a kind of coffee-cake, containing almonds, raisins, rum, orange rind, also BABA [n -S]\n",
  "BABKAS": "BABKA, (Polish) a kind of coffee-cake, containing almonds, raisins, rum, orange rind, also BABA [n]\n",
  "BABLAH": "(Hindi) a species of acacia from which gum arabic is obtained, also BABOOL, BABUL [n -S]\n",
  "BABLAHS": "BABLAH, (Hindi) a species of acacia from which gum arabic is obtained, also BABOOL, BABUL [n]\n",
  "BABOO": "(Hindi) a native clerk who writes English; also, a Hindu title answering to Mr. or Esquire, also BABU [n -S]\n",
  "BABOOL": "(Hindi) a species of acacia from which gum arabic is obtained, also BABLAH, BABUL [n -S]\n",
  "BABOOLS": "BABOOL, (Hindi) a species of acacia from which gum arabic is obtained, also BABLAH, BABUL [n]\n",
  "BABOON": "a large ape [n -S]\n",
  "BABOONERIES": "BABOONERY, baboonish behavior [n]\n",
  "BABOONERY": "baboonish behavior [n BABOONERIES]\n",
  "BABOONISH": "like a baboon [adj]\n",
  "BABOONS": "BABOON, a large ape [n]\n",
  "BABOOS": "BABOO, (Hindi) a native clerk who writes English; also, a Hindu title answering to Mr. or Esquire, also BABU [n]\n",
  "BABOOSH": "(French) a kind of heelless slipper, also BABOUCHE, BABUCHE [n -ES]\n",
  "BABOOSHES": "BABOOSH, (French) a kind of heelless slipper, also BABOUCHE, BABUCHE [n]\n",
  "BABOUCHE": "(French) a kind of heelless slipper, also BABOOSH, BABUCHE [n -S]\n",
  "BABOUCHES": "BABOUCHE, (French) a kind of heelless slipper, also BABOOSH, BABUCHE [n]\n",
  "BABU": "(Hindi) a native clerk who writes English; also, a Hindu title answering to Mr. or Esquire, also BABOO [n -S]\n",
  "BABUCHE": "(French) a kind of heelless slipper, also BABOUCHE, BABOOSH [n -S]\n",
  "BABUCHES": "BABUCHE, (French) a kind of heelless slipper, also BABOUCHE, BABOOSH [n]\n",
  "BABUDOM": "the state of being a babu, a Hindoo gentleman, also BABUISM [n -S]\n",
  "BABUDOMS": "BABUDOM, the state of being a babu, a Hindoo gentleman, also BABUISM [n]\n",
  "BABUISM": "the state of being a babu, a Hindoo gentleman, also BABUDOM [n -S]\n",
  "BABUISMS": "BABUISM, the state of being a babu, a Hindoo gentleman, also BABUDOM [n]\n",
  "BABUL": "(Hindi) a species of acacia from which gum arabic is obtained, also BABLAH, BABOOL [n -S]\n",
  "BABULS": "BABUL, (Hindi) a species of acacia from which gum arabic is obtained, also BABLAH, BABOOL [n]\n",
  "BABUS": "BABU, (Hindi) a native clerk who writes English; also, a Hindu title answering to Mr. or Esquire, also BABOO [n]\n",
  "BABUSHKA": "(Russian) a triangular headscarf tied under the chin [n -S]\n",
  "BABUSHKAS": "BABUSHKA, (Russian) a triangular headscarf tied under the chin [n]\n",
  "BABY": "like a baby [adj BABIER, BABIEST] / to treat like a baby [v BABIED, BABYING, BABIES]\n",
  "BABYCCINO": "a drink of frothy steamed milk, often served with a sweet topping, also BABYCINO [n -S]\n",
  "BABYCCINOS": "BABYCCINO, a drink of frothy steamed milk, often served with a sweet topping, also BABYCINO [n]\n",
  "BABYCINO": "a drink of frothy steamed milk, often served with a sweet topping, also BABYCCINO [n -S]\n",
  "BABYCINOS": "BABYCINO, a drink of frothy steamed milk, often served with a sweet topping, also BABYCCINO [n]\n",
  "BABYDADDIES": "BABYDADDY, (US slang) the father of a child, esp a man who is not the current partner of the child\u0012s mother [n]\n",
  "BABYDADDY": "(US slang) the father of a child, esp a man who is not the current partner of the child\u0012s mother [n BABYDADDIES]\n",
  "BABYDOLL": "a woman's short nightdress [n -S]\n",
  "BABYDOLLS": "BABYDOLL, a woman's short nightdress [n]\n",
  "BABYFOOD": "food prepared for babies [n -S]\n",
  "BABYFOODS": "BABYFOOD, food prepared for babies [n]\n",
  "BABYHOOD": "the state of being an infant [n -S]\n",
  "BABYHOODS": "BABYHOOD, the state of being an infant [n]\n",
  "BABYING": "BABY, to treat like a baby [v]\n",
  "BABYISH": "resembling a baby [adj BABYISHLY]\n",
  "BABYISHLY": "BABYISH, resembling a baby [adv]\n",
  "BABYLIKE": "resembling a baby [adj]\n",
  "BABYMOON": "the early period of new parenthood during which parents and a newborn baby form a relationship [n -S]\n",
  "BABYMOONS": "BABYMOON, the early period of new parenthood during which parents and a newborn baby form a relationship [n]\n",
  "BABYPROOF": "to render e.g. a room safe for babies [v -ED, -ING, -S]\n",
  "BABYPROOFED": "BABYPROOF, to render e.g. a room safe for babies [v]\n",
  "BABYPROOFING": "BABYPROOF, to render e.g. a room safe for babies [v]\n",
  "BABYPROOFS": "BABYPROOF, to render e.g. a room safe for babies [v]\n",
  "BABYSAT": "BABYSIT, to care for a child temporarily [v]\n",
  "BABYSIT": "to care for a child temporarily [v BABYSAT, BABYSITTING, BABYSITS]\n",
  "BABYSITS": "BABYSIT, to care for a child temporarily [v]\n",
  "BABYSITTING": "BABYSIT, to care for a child temporarily [v]\n",
  "BAC": "(short for) baccalaureate, a university degree [n -S]\n",
  "BACALAO": "(Spanish) salted cod, also BACALHAU, BACCALA [n -S]\n",
  "BACALAOS": "BACALAO, (Spanish) salted cod, also BACALHAU, BACCALA [n]\n",
  "BACALHAU": "(Spanish) salted cod, also BACALAO, BACCALA [n -S]\n",
  "BACALHAUS": "BACALHAU, (Spanish) salted cod, also BACALAO, BACCALA [n]\n",
  "BACCA": "(Latin) a botanical name for a berry [n BACCAS or BACCAE]\n",
  "BACCAE": "BACCA, (Latin) a botanical name for a berry [n]\n",
  "BACCALA": "(Spanish) salted cod, also BACALAO, BACALHAU [n -S]\n",
  "BACCALAS": "BACCALA, (Spanish) salted cod, also BACALAO, BACALHAU [n]\n",
  "BACCALAUREAN": "relating to a baccalaureate [adj]\n",
  "BACCALAUREATE": "a set of examinations intended to qualify successful candidates for higher education in any of several countries [n -S]\n",
  "BACCALAUREATES": "BACCALAUREATE, a set of examinations intended to qualify successful candidates for higher education in any of several countries [n]\n",
  "BACCARA": "(French) a French card game, also BACCARAT [n -S]\n",
  "BACCARAS": "BACCARA, (French) a French card game, also BACCARAT [n]\n",
  "BACCARAT": "(French) a French card game, also BACCARA [n -S]\n",
  "BACCARATS": "BACCARAT, (French) a French card game, also BACCARA [n]\n",
  "BACCARE": "(Shakespeare) back! stand back!, also BACKARE [interj]\n",
  "BACCAS": "BACCA, (Latin) a botanical name for a berry [n]\n",
  "BACCATE": "having berries; berrylike, also BACCATED [adj]\n",
  "BACCATED": "having berries; berrylike, also BACCATE [adj]\n",
  "BACCHANAL": "a drunken reveller, also BACCHANALIAN [n -S]\n",
  "BACCHANALIA": "a Roman festival of Bacchus celebrated with dancing, song, and revelry [n]\n",
  "BACCHANALIAN": "related to drinking [adj] / a drunken reveller, also BACCHANAL [n -S]\n",
  "BACCHANALIANISM": "wild revelry [n]\n",
  "BACCHANALIANS": "BACCHANALIAN, a drunken reveller, also BACCHANAL [n]\n",
  "BACCHANALS": "BACCHANAL, a drunken reveller, also BACCHANALIAN [n]\n",
  "BACCHANT": "a priest of Bacchus, a reveller [n BACCHANTS or BACCHANTES]\n",
  "BACCHANTE": "a priestess of Bacchus [n -S]\n",
  "BACCHANTES": "BACCHANTE, a priestess of Bacchus [n]\n",
  "BACCHANTS": "BACCHANT, a priest of Bacchus, a reveller [n]\n",
  "BACCHIAC": "relating to the bacchius, a type of metrical foot, also BACCHIAN [adj]\n",
  "BACCHIAN": "relating to the bacchius, a type of metrical foot, also BACCHIAC [adj]\n",
  "BACCHIC": "relating to the worship of Bacchus; orgiastic [adj]\n",
  "BACCHII": "BACCHIUS, (Latin) a metrical foot composed of a short syllable and two long ones [n]\n",
  "BACCHIUS": "(Latin) a metrical foot composed of a short syllable and two long ones [n BACCHII]\n",
  "BACCIES": "BACCY, (colloquial) tobacco, also BACCO [n]\n",
  "BACCIFEROUS": "bearing berries [adj]\n",
  "BACCIFORM": "shaped like a berry [adj]\n",
  "BACCIVOROUS": "eating berries [adj]\n",
  "BACCO": "(short for) tobacco, also BACCY [n BACCOS or BACCOES]\n",
  "BACCOES": "BACCO, (short for) tobacco, also BACCY [n]\n",
  "BACCOS": "BACCO, (short for) tobacco, also BACCY [n]\n",
  "BACCY": "(colloquial) tobacco, also BACCO [n BACCIES]\n",
  "BACH": "a Welsh term of address [n -S] / to live as a bachelor [v -ED, -ING, -ES]\n",
  "BACHA": "(Hinglish) in India, a young child, also BACHCHA [n -S]\n",
  "BACHARACH": "(German) a wine from Bacharach, on the Rhine [n -S]\n",
  "BACHARACHS": "BACHARACH, (German) a wine from Bacharach, on the Rhine [n]\n",
  "BACHAS": "BACHA, (Hinglish) in India, a young child, also BACHCHA [n]\n",
  "BACHATA": "(Spanish) a type of Latin American music played with guitar and percussion; a dance performed to this music [n -S]\n",
  "BACHATAS": "BACHATA, (Spanish) a type of Latin American music played with guitar and percussion; a dance performed to this music [n]\n",
  "BACHCHA": "(Hinglish) in India, a young child, also BACHA [n -S]\n",
  "BACHCHAS": "BACHCHA, (Hinglish) in India, a young child, also BACHA [n]\n",
  "BACHED": "BACH, to live as a bachelor [v]\n",
  "BACHELOR": "an unmarried man [n -S]\n",
  "BACHELORDOM": "the state of being a bachelor [n -S]\n",
  "BACHELORDOMS": "BACHELORDOM, the state of being a bachelor [n]\n",
  "BACHELORETTE": "an unmarried woman [n -S]\n",
  "BACHELORETTES": "BACHELORETTE, an unmarried woman [n]\n",
  "BACHELORHOOD": "the state of being a bachelor [n -S]\n",
  "BACHELORHOODS": "BACHELORHOOD, the state of being a bachelor [n]\n",
  "BACHELORISM": "the state of being a bachelor [n -S]\n",
  "BACHELORISMS": "BACHELORISM, the state of being a bachelor [n]\n",
  "BACHELORS": "BACHELOR, an unmarried man [n]\n",
  "BACHELORSHIP": "the state of being a bachelor [n -S]\n",
  "BACHELORSHIPS": "BACHELORSHIP, the state of being a bachelor [n]\n",
  "BACHES": "BACH, to live as a bachelor [v]\n",
  "BACHING": "BACH, to live as a bachelor [v]\n",
  "BACHS": "BACH, a Welsh term of address [n]\n",
  "BACILLAEMIA": "the presence of bacilli in the blood, also BACILLEMIA [n -S]\n",
  "BACILLAEMIAS": "BACILLAEMIA, the presence of bacilli in the blood, also BACILLEMIA [n]\n",
  "BACILLAR": "of the shape or nature of a bacillus, rodlike, also BACILLARY [adj]\n",
  "BACILLARY": "of the shape or nature of a bacillus, rodlike, also BACILLAR [adj]\n",
  "BACILLEMIA": "the presence of bacilli in the blood, also BACILLAEMIA [n -S]\n",
  "BACILLEMIAS": "BACILLEMIA, the presence of bacilli in the blood, also BACILLAEMIA [n]\n",
  "BACILLI": "BACILLUS, (Latin) any of the genus of rod-shaped bacteria [n]\n",
  "BACILLICIDE": "something which destroys bacteria [n -S]\n",
  "BACILLICIDES": "BACILLICIDE, something which destroys bacteria [n]\n",
  "BACILLIFORM": "shaped like a bacillus [adj]\n",
  "BACILLURIA": "the presence of bacteria in the urine [n -S]\n",
  "BACILLURIAS": "BACILLURIA, the presence of bacteria in the urine [n]\n",
  "BACILLUS": "(Latin) any of the genus of rod-shaped bacteria [n BACILLI]\n",
  "BACITRACIN": "an antibiotic used for treating bacterial skin infections [n -S]\n",
  "BACITRACINS": "BACITRACIN, an antibiotic used for treating bacterial skin infections [n]\n",
  "BACK": "to help or support [v -ED, -ING, -S]\n",
  "BACKACHE": "pain in the back [n -S]\n",
  "BACKACHES": "BACKACHE, pain in the back [n]\n",
  "BACKACTER": "a mechanical excavator with an extension consisting of a bucket on an extending arm, which can be used to scoop up earth as it is drawn back towards the machine, aka backhoe [n -S]\n",
  "BACKACTERS": "BACKACTER, a mechanical excavator with an extension consisting of a bucket on an extending arm, which can be used to scoop up earth as it is drawn back towards the machine, aka backhoe [n]\n",
  "BACKARE": "(Shakespeare) back! Stand back! give place, also BACCARE [interj]\n",
  "BACKBAND": "the band which passes over the back of a horse and holds up the shafts of a carriage [n -S]\n",
  "BACKBANDS": "BACKBAND, the band which passes over the back of a horse and holds up the shafts of a carriage [n]\n",
  "BACKBAR": "the space behind a bar with shelves for bottles [n -S]\n",
  "BACKBARS": "BACKBAR, the space behind a bar with shelves for bottles [n]\n",
  "BACKBEAT": "one of the normally unstressed beats in a musical bar, used as a secondary syncopated beat [n -S]\n",
  "BACKBEATS": "BACKBEAT, one of the normally unstressed beats in a musical bar, used as a secondary syncopated beat [n]\n",
  "BACKBENCH": "a rear bench (in Parliament) [n -ES]\n",
  "BACKBENCHER": "a Member of Parliament who sits on the backbenches [n -S]\n",
  "BACKBENCHERS": "BACKBENCHER, a Member of Parliament who sits on the backbenches [n]\n",
  "BACKBENCHES": "BACKBENCH, a rear bench (in Parliament) [n]\n",
  "BACKBEND": "an acrobatic feat [n -S]\n",
  "BACKBENDS": "BACKBEND, an acrobatic feat [n]\n",
  "BACKBIT": "BACKBITE, to speak ill of [v]\n",
  "BACKBITE": "to speak ill of [v BACKBIT, BACKBITTEN, BACKBITING, BACKBITES]\n",
  "BACKBITER": "one who engages in malicious gossip [n -S]\n",
  "BACKBITERS": "BACKBITER, one who engages in malicious gossip [n]\n",
  "BACKBITES": "BACKBITE, to speak ill of [v]\n",
  "BACKBITING": "malicious gossip [n -S]\n",
  "BACKBITINGS": "BACKBITING, malicious gossip [n]\n",
  "BACKBITTEN": "BACKBITE, to speak ill of [v]\n",
  "BACKBLOCK": "(Australian) of the backblocks, remote, sparsely populated country [adj]\n",
  "BACKBLOCKER": "one who lives in the backblocks [n -S]\n",
  "BACKBLOCKERS": "BACKBLOCKER, one who lives in the backblocks [n]\n",
  "BACKBLOCKS": "(Australian) remote, sparsely populated country [n]\n",
  "BACKBOARD": "a board which supports the back when one is sitting [n -S]\n",
  "BACKBOARDS": "BACKBOARD, a board which supports the back when one is sitting [n]\n",
  "BACKBOND": "a deed attaching a qualification or condition to the terms of a conveyance or other instrument [n -S]\n",
  "BACKBONDS": "BACKBOND, a deed attaching a qualification or condition to the terms of a conveyance or other instrument [n]\n",
  "BACKBONE": "the spine [n -S]\n",
  "BACKBONED": "having a backbone, vertebrate [adj]\n",
  "BACKBONELESS": "without a backbone [adj]\n",
  "BACKBONES": "BACKBONE, the spine [n]\n",
  "BACKBREAKER": "a strenuous task [n -S]\n",
  "BACKBREAKERS": "BACKBREAKER, a strenuous task [n]\n",
  "BACKBREAKING": "exhausting [adj]\n",
  "BACKBURN": "to set a fire in order to halt the spread of another fire [v -ED, -ING, -S]\n",
  "BACKBURNED": "BACKBURN, to set a fire in order to halt the spread of another fire [v]\n",
  "BACKBURNING": "BACKBURN, to set a fire in order to halt the spread of another fire [v]\n",
  "BACKBURNS": "BACKBURN, to set a fire in order to halt the spread of another fire [v]\n",
  "BACKCAST": "to make a backward cast in fishing [v BACKCAST, BACKCASTING, BACKCASTS]\n",
  "BACKCASTING": "BACKCAST, to make a backward cast in fishing [v]\n",
  "BACKCASTS": "BACKCAST, to make a backward cast in fishing [v]\n",
  "BACKCHANNEL": "an unofficial or covert means of conveying information, originally or esp. in political or diplomatic circles [n -S]\n",
  "BACKCHANNELS": "BACKCHANNEL, an unofficial or covert means of conveying information, originally or esp. in political or diplomatic circles [n]\n",
  "BACKCHAT": "impertinence, repartee [n -S] / to engage in repartee [v BACKCHATTED, BACKCHATTING, BACKCHATS]\n",
  "BACKCHATS": "BACKCHAT, to engage in repartee [v]\n",
  "BACKCHATTED": "BACKCHAT, to engage in repartee [v]\n",
  "BACKCHATTING": "BACKCHAT, to engage in repartee [v]\n",
  "BACKCHECK": "in ice hockey, to return from attack to defence [v -ED, -ING, -S]\n",
  "BACKCHECKED": "BACKCHECK, in ice hockey, to return from attack to defence [v]\n",
  "BACKCHECKING": "BACKCHECK, in ice hockey, to return from attack to defence [v]\n",
  "BACKCHECKS": "BACKCHECK, in ice hockey, to return from attack to defence [v]\n",
  "BACKCLOTH": "the painted cloth or curtain at the back of the stage [n -S]\n",
  "BACKCLOTHS": "BACKCLOTH, the painted cloth or curtain at the back of the stage [n]\n",
  "BACKCOMB": "to comb back e.g. the hair [v -ED, -ING, -S]\n",
  "BACKCOMBED": "BACKCOMB, to comb back e.g. the hair [v]\n",
  "BACKCOMBING": "BACKCOMB, to comb back e.g. the hair [v]\n",
  "BACKCOMBS": "BACKCOMB, to comb back e.g. the hair [v]\n",
  "BACKCOUNTRIES": "BACKCOUNTRY, a remote rural region [n]\n",
  "BACKCOUNTRY": "a remote rural region [n BACKCOUNTRIES]\n",
  "BACKCOURT": "in lawn tennis, that part of the court lying behind the service line [n -S]\n",
  "BACKCOURTMAN": "a guard on a basketball team [n BACKCOURTMEN]\n",
  "BACKCOURTMEN": "BACKCOURTMAN, a guard on a basketball team [n]\n",
  "BACKCOURTS": "BACKCOURT, in lawn tennis, that part of the court lying behind the service line [n]\n",
  "BACKCROSS": "a cross between a hybrid and a parent [n -ES] / to create a cross between a hybrid and a parent [v -ED, -ING, -ES]\n",
  "BACKCROSSED": "BACKCROSS, to create a cross between a hybrid and a parent [v]\n",
  "BACKCROSSES": "BACKCROSS, a cross between a hybrid and a parent [n]\n",
  "BACKCROSSING": "BACKCROSS, to create a cross between a hybrid and a parent [v]\n",
  "BACKDATE": "to date to an earlier time [v BACKDATED, BACKDATING, BACKDATES]\n",
  "BACKDATED": "BACKDATE, to date to an earlier time [v]\n",
  "BACKDATES": "BACKDATE, to date to an earlier time [v]\n",
  "BACKDATING": "BACKDATE, to date to an earlier time [v]\n",
  "BACKDOOR": "clandestine [adj]\n",
  "BACKDOWN": "the abandonment of one's position [n -S]\n",
  "BACKDOWNS": "BACKDOWN, the abandonment of one's position [n]\n",
  "BACKDRAFT": "a reverse movement of air, also BACKDRAUGHT [n -S]\n",
  "BACKDRAFTS": "BACKDRAFT, a reverse movement of air, also BACKDRAUGHT [n]\n",
  "BACKDRAUGHT": "a reverse movement of air, also BACKDRAFT [n -S]\n",
  "BACKDRAUGHTS": "BACKDRAUGHT, a reverse movement of air, also BACKDRAFT [n]\n",
  "BACKDROP": "to create a background for a stage [v BACKDROPT or BACKDROPPED, BACKDROPPING, BACKDROPS]\n",
  "BACKDROPPED": "BACKDROP, to create a background for a stage [v]\n",
  "BACKDROPPING": "BACKDROP, to create a background for a stage [v]\n",
  "BACKDROPS": "BACKDROP, to create a background for a stage [v]\n",
  "BACKDROPT": "BACKDROP, to create a background for a stage [v]\n",
  "BACKED": "BACK, to help or support [v]\n",
  "BACKER": "a supporter [n -S]\n",
  "BACKERS": "BACKER, a supporter [n]\n",
  "BACKET": "(Scots) a shallow wooden trough for carrying ashes [n -S]\n",
  "BACKETS": "BACKET, (Scots) a shallow wooden trough for carrying ashes [n]\n",
  "BACKFALL": "a fall or throw on the back in wrestling [n -S]\n",
  "BACKFALLS": "BACKFALL, a fall or throw on the back in wrestling [n]\n",
  "BACKFAT": "the layer of fat between the skin and muscle in animals [n -S]\n",
  "BACKFATS": "BACKFAT, the layer of fat between the skin and muscle in animals [n]\n",
  "BACKFIELD": "in American football, the backs collectively [n -S]\n",
  "BACKFIELDS": "BACKFIELD, in American football, the backs collectively [n]\n",
  "BACKFILE": "the back numbers of a newspaper [n -S]\n",
  "BACKFILES": "BACKFILE, the back numbers of a newspaper [n]\n",
  "BACKFILL": "to refill e.g. a foundation with earth, debris [v -ED, -ING, -S]\n",
  "BACKFILLED": "BACKFILL, to refill e.g. a foundation with earth, debris [v]\n",
  "BACKFILLING": "the act of refilling with earth [n -S]\n",
  "BACKFILLINGS": "BACKFILLING, the act of refilling with earth [n]\n",
  "BACKFILLS": "BACKFILL, to refill e.g. a foundation with earth, debris [v]\n",
  "BACKFIRE": "to go wrong [v BACKFIRED, BACKFIRING, BACKFIRES]\n",
  "BACKFIRED": "BACKFIRE, to go wrong [v]\n",
  "BACKFIRES": "BACKFIRE, to go wrong [v]\n",
  "BACKFIRING": "BACKFIRE, to go wrong [v]\n",
  "BACKFISCH": "(German) a young girl, a flapper [n -ES]\n",
  "BACKFISCHES": "BACKFISCH, (German) a young girl, a flapper [n]\n",
  "BACKFIT": "to modify later [v BACKFITTED, BACKFITTING, BACKFITS]\n",
  "BACKFITS": "BACKFIT, to modify later [v]\n",
  "BACKFITTED": "BACKFIT, to modify later [v]\n",
  "BACKFITTING": "the act of retrofitting or furnishing with new parts not originally available [n -S]\n",
  "BACKFITTINGS": "BACKFITTING, the act of retrofitting or furnishing with new parts not originally available [n]\n",
  "BACKFLIP": "to perform a backward somersault [v BACKFLIPPED, BACKFLIPPING, BACKFLIPS]\n",
  "BACKFLIPPED": "BACKFLIP, to perform a backward somersault [v]\n",
  "BACKFLIPPING": "the act of performing a reverse somersault [n -S]\n",
  "BACKFLIPPINGS": "BACKFLIPPING, the act of performing a reverse somersault [n]\n",
  "BACKFLIPS": "BACKFLIP, to perform a backward somersault [v]\n",
  "BACKFLOW": "the action of flowing back towards a source [n -S]\n",
  "BACKFLOWS": "BACKFLOW, the action of flowing back towards a source [n]\n",
  "BACKGAMMON": "a board game played with dice and counters [n -S] / to defeat at the game of backgammon [v -ED, -ING, -S]\n",
  "BACKGAMMONED": "BACKGAMMON, to defeat at the game of backgammon [v]\n",
  "BACKGAMMONING": "BACKGAMMON, to defeat at the game of backgammon [v]\n",
  "BACKGAMMONS": "BACKGAMMON, to defeat at the game of backgammon [v]\n",
  "BACKGROUND": "to provide with background [v -ED, -ING, -S]\n",
  "BACKGROUNDED": "BACKGROUND, to provide with background [v]\n",
  "BACKGROUNDER": "an off the record briefing for reporters [n -S]\n",
  "BACKGROUNDERS": "BACKGROUNDER, an off the record briefing for reporters [n]\n",
  "BACKGROUNDING": "BACKGROUND, to provide with background [v]\n",
  "BACKGROUNDS": "BACKGROUND, to provide with background [v]\n",
  "BACKHAND": "to strike with the back of the hand [v -ED, -ING, -S]\n",
  "BACKHANDED": "BACKHAND, to strike with the back of the hand [v]\n",
  "BACKHANDEDLY": "BACKHANDED, BACKHAND, to strike with the back of the hand [adv]\n",
  "BACKHANDEDNESS": "the state of being backhanded [n]\n",
  "BACKHANDER": "a bribe [n -S]\n",
  "BACKHANDERS": "BACKHANDER, a bribe [n]\n",
  "BACKHANDING": "BACKHAND, to strike with the back of the hand [v]\n",
  "BACKHANDS": "BACKHAND, to strike with the back of the hand [v]\n",
  "BACKHAUL": "to return after delivering a cargo [v -ED, -ING, -S]\n",
  "BACKHAULED": "BACKHAUL, to return after delivering a cargo [v]\n",
  "BACKHAULING": "BACKHAUL, to return after delivering a cargo [v]\n",
  "BACKHAULS": "BACKHAUL, to return after delivering a cargo [v]\n",
  "BACKHOE": "an excavating machine [n -S] / to dig with a backhoe [v BACKHOED, BACKHOEING, BACKHOES]\n",
  "BACKHOED": "BACKHOE, to dig with a backhoe [v]\n",
  "BACKHOEING": "BACKHOE, to dig with a backhoe [v]\n",
  "BACKHOES": "BACKHOE, to dig with a backhoe [v]\n",
  "BACKHOUSE": "(Canadian) an outhouse, a building behind the main building, especially a privy [n -S]\n",
  "BACKHOUSES": "BACKHOUSE, (Canadian) an outhouse, a building behind the main building, especially a privy [n]\n",
  "BACKIE": "(slang) a ride on the back of someone's bicycle [n -S]\n",
  "BACKIES": "BACKIE, (slang) a ride on the back of someone's bicycle [n]\n",
  "BACKING": "a support [n -S]\n",
  "BACKINGS": "BACKING, a support [n]\n",
  "BACKLAND": "a piece of land at the back of an established property [n -S]\n",
  "BACKLANDS": "BACKLAND, a piece of land at the back of an established property [n]\n",
  "BACKLASH": "to cause a reaction [v -ED, -ING, -ES]\n",
  "BACKLASHED": "BACKLASH, to cause a reaction [v]\n",
  "BACKLASHER": "one who backlashes [n -S]\n",
  "BACKLASHERS": "BACKLASHER, one who backlashes [n]\n",
  "BACKLASHES": "BACKLASH, to cause a reaction [v]\n",
  "BACKLASHING": "BACKLASH, to cause a reaction [v]\n",
  "BACKLESS": "having no back [adj]\n",
  "BACKLIFT": "the backwards lifting of a bat [n -S]\n",
  "BACKLIFTS": "BACKLIFT, the backwards lifting of a bat [n]\n",
  "BACKLIGHT": "to illumine a subject from the rear [v BACKLIT or BACKLIGHTED, BACKLIGHTING, BACKLIGHTS]\n",
  "BACKLIGHTED": "BACKLIGHT, to illumine a subject from the rear [v]\n",
  "BACKLIGHTING": "BACKLIGHT, to illumine a subject from the rear [v]\n",
  "BACKLIGHTS": "BACKLIGHT, to illumine a subject from the rear [v]\n",
  "BACKLINE": "in some team sports, the defensive players considered as a unit [n -S]\n",
  "BACKLINER": "(Canadian) a defenceman, especially in hockey [n -S]\n",
  "BACKLINERS": "BACKLINER, (Canadian) a defenceman, especially in hockey [n]\n",
  "BACKLINES": "BACKLINE, in some team sports, the defensive players considered as a unit [n]\n",
  "BACKLIST": "to include in a publisher's list of old books [v -ED, -ING, -S]\n",
  "BACKLISTED": "BACKLIST, to include in a publisher's list of old books [v]\n",
  "BACKLISTING": "BACKLIST, to include in a publisher's list of old books [v]\n",
  "BACKLISTS": "BACKLIST, to include in a publisher's list of old books [v]\n",
  "BACKLIT": "lit from behind [adj]\n",
  "BACKLOAD": "to load a lorry for a return journey [v -ED, -ING, -S]\n",
  "BACKLOADED": "BACKLOAD, to load a lorry for a return journey [v]\n",
  "BACKLOADING": "BACKLOAD, to load a lorry for a return journey [v]\n",
  "BACKLOADS": "BACKLOAD, to load a lorry for a return journey [v]\n",
  "BACKLOG": "to accumulate [v BACKLOGGED, BACKLOGGING, BACKLOGS]\n",
  "BACKLOGGED": "BACKLOG, to accumulate [v]\n",
  "BACKLOGGING": "BACKLOG, to accumulate [v]\n",
  "BACKLOGS": "BACKLOG, to accumulate [v]\n",
  "BACKLOT": "an outdoor area, often next to a TV studio, used for exterior scenes [n -S]\n",
  "BACKLOTS": "BACKLOT, an outdoor area, often next to a TV studio, used for exterior scenes [n]\n",
  "BACKMARKER": "a person who starts a race with the least advantageous handicap [n -S]\n",
  "BACKMARKERS": "BACKMARKER, a person who starts a race with the least advantageous handicap [n]\n",
  "BACKMOST": "hindmost [adj]\n",
  "BACKOUT": "a reversal of launching procedures [n -S]\n",
  "BACKOUTS": "BACKOUT, a reversal of launching procedures [n]\n",
  "BACKPACK": "to hike with a pack on one's back [v -ED, -ING, -S]\n",
  "BACKPACKED": "BACKPACK, to hike with a pack on one's back [v]\n",
  "BACKPACKER": "one who travels with a backpack [n -S]\n",
  "BACKPACKERS": "BACKPACKER, one who travels with a backpack [n]\n",
  "BACKPACKING": "hiking with a pack on one's back [n -S]\n",
  "BACKPACKINGS": "BACKPACKING, hiking with a pack on one's back [n]\n",
  "BACKPACKS": "BACKPACK, to hike with a pack on one's back [v]\n",
  "BACKPEDAL": "to pedal backwards [v BACKPEDALED or BACKPEDALLED, BACKPEDALING or BACKPEDALLING, BACKPEDALS]\n",
  "BACKPEDALED": "BACKPEDAL, to pedal backwards [v]\n",
  "BACKPEDALING": "BACKPEDAL, to pedal backwards [v]\n",
  "BACKPEDALLED": "BACKPEDAL, to pedal backwards [v]\n",
  "BACKPEDALLING": "BACKPEDAL, to pedal backwards [v]\n",
  "BACKPEDALS": "BACKPEDAL, to pedal backwards [v]\n",
  "BACKPIECE": "a piece or plate of armour for the back [n -S]\n",
  "BACKPIECES": "BACKPIECE, a piece or plate of armour for the back [n]\n",
  "BACKPLANE": "the circuit board on a computer to which other circuit boards and components can be connected [n -S]\n",
  "BACKPLANES": "BACKPLANE, the circuit board on a computer to which other circuit boards and components can be connected [n]\n",
  "BACKPLATE": "a piece of armour for the back [n -S]\n",
  "BACKPLATES": "BACKPLATE, a piece of armour for the back [n]\n",
  "BACKRA": "(Caribbean) in the West Indies, a white person, also BAKRA, BUCKRA [n -S]\n",
  "BACKRAS": "BACKRA, (Caribbean) in the West Indies, a white person, also BAKRA, BUCKRA [n]\n",
  "BACKREST": "a back support [n -S]\n",
  "BACKRESTS": "BACKREST, a back support [n]\n",
  "BACKRONYM": "an acronym formed using the initial letters or syllables of an existing word, also BACRONYM [n -S]\n",
  "BACKRONYMS": "BACKRONYM, an acronym formed using the initial letters or syllables of an existing word, also BACRONYM [n]\n",
  "BACKROOM": "a room at the back [n -S] / behind-the-scenes [adj]\n",
  "BACKROOMS": "BACKROOM, a room at the back [n]\n",
  "BACKRUSH": "the seaward return of water from a wave [n -ES]\n",
  "BACKRUSHES": "BACKRUSH, the seaward return of water from a wave [n]\n",
  "BACKS": "BACK, to help or support [v]\n",
  "BACKSAW": "a saw (as a tenon saw) whose blade is stiffened by an added metallic back [n -S]\n",
  "BACKSAWS": "BACKSAW, a saw (as a tenon saw) whose blade is stiffened by an added metallic back [n]\n",
  "BACKSCATTER": "the deflection of radiation or particles by scattering through angles greater than 90 degrees with reference to the original direction of travel [n -S] / to scatter in this way [v -ED, -ING, -S]\n",
  "BACKSCATTERED": "BACKSCATTER, to scatter in this way [v]\n",
  "BACKSCATTERING": "the act of backscattering [n -S]\n",
  "BACKSCATTERINGS": "BACKSCATTERING, the act of backscattering [n]\n",
  "BACKSCATTERS": "BACKSCATTER, to scatter in this way [v]\n",
  "BACKSCRATCH": "to scratch the back; (figurative) to do favours in return for favours, to engage in servile flattery [v -ED, -ING, -ES]\n",
  "BACKSCRATCHED": "BACKSCRATCH, to scratch the back; (figurative) to do favours in return for favours, to engage in servile flattery [v]\n",
  "BACKSCRATCHER": "a person who practises backscratching [n -S]\n",
  "BACKSCRATCHERS": "BACKSCRATCHER, a person who practises backscratching [n]\n",
  "BACKSCRATCHES": "BACKSCRATCH, to scratch the back; (figurative) to do favours in return for favours, to engage in servile flattery [v]\n",
  "BACKSCRATCHING": "the act of scratching another's back [n -S]\n",
  "BACKSCRATCHINGS": "BACKSCRATCHING, the act of scratching another's back [n]\n",
  "BACKSEAT": "a rear seat [n -S]\n",
  "BACKSEATS": "BACKSEAT, a rear seat [n]\n",
  "BACKSET": "to attack from the rear [v BACKSET, BACKSETTING, BACKSETS]\n",
  "BACKSETS": "BACKSET, to attack from the rear [v]\n",
  "BACKSETTING": "BACKSET, to attack from the rear [v]\n",
  "BACKSEY": "(Scots) sirloin [n -S]\n",
  "BACKSEYS": "BACKSEY, (Scots) sirloin [n]\n",
  "BACKSHEESH": "(Persian) in Eastern countries, a gift or present of money, a tip [n -ES] / to give a tip, also BACKSHISH, BAKHSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v -ED, -ING, -ES]\n",
  "BACKSHEESHED": "BACKSHEESH, to give a tip, also BACKSHISH, BAKHSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v]\n",
  "BACKSHEESHES": "BACKSHEESH, (Persian) in Eastern countries, a gift or present of money, a tip [n]\n",
  "BACKSHEESHING": "BACKSHEESH, to give a tip, also BACKSHISH, BAKHSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v]\n",
  "BACKSHISH": "(Persian) in Eastern countries, a gift or present of money, a tip [n -ES] / to give a tip, also BACKSHEESH, BAKHSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v -ED, -ING, -ES]\n",
  "BACKSHISHED": "BACKSHISH, to give a tip, also BACKSHEESH, BAKHSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v]\n",
  "BACKSHISHES": "BACKSHISH, (Persian) in Eastern countries, a gift or present of money, a tip [n]\n",
  "BACKSHISHING": "BACKSHISH, to give a tip, also BACKSHEESH, BAKHSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v]\n",
  "BACKSHORE": "an area of beach [n -S]\n",
  "BACKSHORES": "BACKSHORE, an area of beach [n]\n",
  "BACKSIDE": "the buttocks [n -S]\n",
  "BACKSIDES": "BACKSIDE, the buttocks [n]\n",
  "BACKSIGHT": "the sight of a rifle nearer the stock [n -S]\n",
  "BACKSIGHTS": "BACKSIGHT, the sight of a rifle nearer the stock [n]\n",
  "BACKSLAP": "to show approval [v BACKSLAPPED, BACKSLAPPING, BACKSLAPS]\n",
  "BACKSLAPPED": "BACKSLAP, to show approval [v]\n",
  "BACKSLAPPER": "one who backslaps [n -S]\n",
  "BACKSLAPPERS": "BACKSLAPPER, one who backslaps [n]\n",
  "BACKSLAPPING": "BACKSLAP, to show approval [v]\n",
  "BACKSLAPS": "BACKSLAP, to show approval [v]\n",
  "BACKSLASH": "the character \\ [n -ES]\n",
  "BACKSLASHES": "BACKSLASH, the character \\ [n]\n",
  "BACKSLID": "BACKSLIDE, to fall back [v]\n",
  "BACKSLIDDEN": "BACKSLIDE, to fall back [v]\n",
  "BACKSLIDE": "to fall back [v BACKSLID, BACKSLIDDEN, BACKSLIDING, BACKSLIDES]\n",
  "BACKSLIDER": "one who backslides [n -S]\n",
  "BACKSLIDERS": "BACKSLIDER, one who backslides [n]\n",
  "BACKSLIDES": "BACKSLIDE, to fall back [v]\n",
  "BACKSLIDING": "a lapse, a moral transgression [n -S]\n",
  "BACKSLIDINGS": "BACKSLIDING, a lapse, a moral transgression [n]\n",
  "BACKSPACE": "to move the cursor of a computer or the carriage of a typewriter one or more spaces back by means of a particular key [v BACKSPACED, BACKSPACING, BACKSPACES]\n",
  "BACKSPACED": "BACKSPACE, to move the cursor of a computer or the carriage of a typewriter one or more spaces back by means of a particular key [v]\n",
  "BACKSPACER": "the backspace key on a typewriter [n -S]\n",
  "BACKSPACERS": "BACKSPACER, the backspace key on a typewriter [n]\n",
  "BACKSPACES": "BACKSPACE, to move the cursor of a computer or the carriage of a typewriter one or more spaces back by means of a particular key [v]\n",
  "BACKSPACING": "BACKSPACE, to move the cursor of a computer or the carriage of a typewriter one or more spaces back by means of a particular key [v]\n",
  "BACKSPEER": "(Scots) to cross-question, also BACKSPEIR [v -ED, -ING, -S]\n",
  "BACKSPEERED": "BACKSPEER, (Scots) to cross-question, also BACKSPEIR [v]\n",
  "BACKSPEERING": "BACKSPEER, (Scots) to cross-question, also BACKSPEIR [v]\n",
  "BACKSPEERS": "BACKSPEER, (Scots) to cross-question, also BACKSPEIR [v]\n",
  "BACKSPEIR": "(Scots) to cross-question, also BACKSPEER [v -ED, -ING, -S]\n",
  "BACKSPEIRED": "BACKSPEIR, (Scots) to cross-question, also BACKSPEER [v]\n",
  "BACKSPEIRING": "BACKSPEIR, (Scots) to cross-question, also BACKSPEER [v]\n",
  "BACKSPEIRS": "BACKSPEIR, (Scots) to cross-question, also BACKSPEER [v]\n",
  "BACKSPIN": "a backward rotation [n -S]\n",
  "BACKSPINS": "BACKSPIN, a backward rotation [n]\n",
  "BACKSPLASH": "a vertical surface (as of tiles) designed to protect the wall behind a stove or countertop [n -ES]\n",
  "BACKSPLASHES": "BACKSPLASH, a vertical surface (as of tiles) designed to protect the wall behind a stove or countertop [n]\n",
  "BACKSPLIT": "(Canadian) a house with floors raised half a storey at the rear, having an upper and lower main floor, and an upper and lower basement [n -S]\n",
  "BACKSPLITS": "BACKSPLIT, (Canadian) a house with floors raised half a storey at the rear, having an upper and lower main floor, and an upper and lower basement [n]\n",
  "BACKSTAB": "to stab in the back [v BACKSTABBED, BACKSTABBING, BACKSTABS]\n",
  "BACKSTABBED": "BACKSTAB, to stab in the back [v]\n",
  "BACKSTABBER": "one who backstabs [n -S]\n",
  "BACKSTABBERS": "BACKSTABBER, one who backstabs [n]\n",
  "BACKSTABBING": "the act of stabbing someone in the back [n -S]\n",
  "BACKSTABBINGS": "BACKSTABBING, the act of stabbing someone in the back [n]\n",
  "BACKSTABS": "BACKSTAB, to stab in the back [v]\n",
  "BACKSTAGE": "behind the scenes, unobserved by the public [adj] / the back area of a stage [n -S]\n",
  "BACKSTAGES": "BACKSTAGE, the back area of a stage [n]\n",
  "BACKSTAIR": "underhand [n -S]\n",
  "BACKSTAIRS": "behind the scenes, unobserved by the public [adj]\n",
  "BACKSTALL": "of a kite, to lose power and begin to drop in low winds [v -ED, -ING, -S]\n",
  "BACKSTALLED": "BACKSTALL, of a kite, to lose power and begin to drop in low winds [v]\n",
  "BACKSTALLING": "BACKSTALL, of a kite, to lose power and begin to drop in low winds [v]\n",
  "BACKSTALLS": "BACKSTALL, of a kite, to lose power and begin to drop in low winds [v]\n",
  "BACKSTAMP": "a mark stamped on the back of an envelope [n -S] / to mark with a backstamp [v BACKSTAMPED, BACKSTAMPING, BACKSTAMPS]\n",
  "BACKSTAMPED": "BACKSTAMP, to mark with a backstamp [v]\n",
  "BACKSTAMPING": "BACKSTAMP, to mark with a backstamp [v]\n",
  "BACKSTAMPS": "BACKSTAMP, to mark with a backstamp [v]\n",
  "BACKSTARTING": "a marketing technique in publishing, whereby new customers are sent back issues of magazines or journals as part of their subscription [n -S]\n",
  "BACKSTARTINGS": "BACKSTARTING, a marketing technique in publishing, whereby new customers are sent back issues of magazines or journals as part of their subscription [n]\n",
  "BACKSTAY": "a stay extending from ship's mastheads to the side of the ship [n -S]\n",
  "BACKSTAYS": "BACKSTAY, a stay extending from ship's mastheads to the side of the ship [n]\n",
  "BACKSTITCH": "a stitch made by setting the needle back of the end of the last stitch, and bringing it out in front of the end [n -ES] / to stitch in this way [v -ED, -ING, -ES]\n",
  "BACKSTITCHED": "BACKSTITCH, to stitch in this way [v]\n",
  "BACKSTITCHES": "BACKSTITCH, a stitch made by setting the needle back of the end of the last stitch, and bringing it out in front of the end [n]\n",
  "BACKSTITCHING": "BACKSTITCH, to stitch in this way [v]\n",
  "BACKSTOP": "something preventing excessive backward movement [n -S] / to act as a backstop [v BACKSTOPPED, BACKSTOPPING, BACKSTOPS]\n",
  "BACKSTOPPED": "BACKSTOP, to act as a backstop [v]\n",
  "BACKSTOPPING": "BACKSTOP, to act as a backstop [v]\n",
  "BACKSTOPS": "BACKSTOP, to act as a backstop [v]\n",
  "BACKSTORIES": "BACKSTORY, events assumed before a story begins [n]\n",
  "BACKSTORY": "events assumed before a story begins [n BACKSTORIES]\n",
  "BACKSTRAP": "(Canadian) any of various cuts of meat from the back of an animal, especially a tenderloin [n -S]\n",
  "BACKSTRAPS": "BACKSTRAP, (Canadian) any of various cuts of meat from the back of an animal, especially a tenderloin [n]\n",
  "BACKSTREET": "a street away from the main thoroughfares [n -S]\n",
  "BACKSTREETS": "BACKSTREET, a street away from the main thoroughfares [n]\n",
  "BACKSTRETCH": "a back straight [n -ES]\n",
  "BACKSTRETCHES": "BACKSTRETCH, a back straight [n]\n",
  "BACKSTROKE": "to swim on the back [v BACKSTROKED, BACKSTROKING, BACKSTROKES]\n",
  "BACKSTROKED": "BACKSTROKE, to swim on the back [v]\n",
  "BACKSTROKES": "BACKSTROKE, to swim on the back [v]\n",
  "BACKSTROKING": "BACKSTROKE, to swim on the back [v]\n",
  "BACKSWEPT": "swept backwards [adj]\n",
  "BACKSWIMMER": "one who swims on the back [n -S]\n",
  "BACKSWIMMERS": "BACKSWIMMER, one who swims on the back [n]\n",
  "BACKSWING": "the first stage in a swing of a club, racket, etc. in which it is swung back and away from the ball [n -S]\n",
  "BACKSWINGS": "BACKSWING, the first stage in a swing of a club, racket, etc. in which it is swung back and away from the ball [n]\n",
  "BACKSWORD": "an archaic, edged, unpointed sword used in prizefighting [n -S]\n",
  "BACKSWORDMAN": "one who uses a backsword, a sword with one sharp edge, also BACKSWORDSMAN [n BACKSWORDMEN]\n",
  "BACKSWORDMEN": "BACKSWORDMAN, one who uses a backsword, a sword with one sharp edge, also BACKSWORDSMAN [n]\n",
  "BACKSWORDS": "BACKSWORD, an archaic, edged, unpointed sword used in prizefighting [n]\n",
  "BACKSWORDSMAN": "one who uses a backsword, a sword with one sharp edge, also BACKSWORDMAN [n BACKSWORDSMEN]\n",
  "BACKSWORDSMEN": "BACKSWORDSMAN, one who uses a backsword, a sword with one sharp edge, also BACKSWORDMAN [n]\n",
  "BACKTALK": "an impudent reply [n -S]\n",
  "BACKTALKS": "BACKTALK, an impudent reply [n]\n",
  "BACKTRACK": "to go back on a previous statement [v -ED, -ING, -S]\n",
  "BACKTRACKED": "BACKTRACK, to go back on a previous statement [v]\n",
  "BACKTRACKING": "the act of backtracking [n -S]\n",
  "BACKTRACKINGS": "BACKTRACKING, the act of backtracking [n]\n",
  "BACKTRACKS": "BACKTRACK, to go back on a previous statement [v]\n",
  "BACKUP": "a substitute, a standby [n -S]\n",
  "BACKUPS": "BACKUP, a substitute, a standby [n]\n",
  "BACKVELD": "(South African) a remote area [n -S]\n",
  "BACKVELDER": "(South African) one who lives in the backveld, country remote from towns [n -S]\n",
  "BACKVELDERS": "BACKVELDER, (South African) one who lives in the backveld, country remote from towns [n]\n",
  "BACKVELDS": "BACKVELD, (South African) a remote area [n]\n",
  "BACKWALL": "a rear wall [n -S]\n",
  "BACKWALLS": "BACKWALL, a rear wall [n]\n",
  "BACKWARD": "in a reverse direction, also BACKWARDS [adv BACKWARDLY]\n",
  "BACKWARDATION": "on the Stock Exchange, the postponement of the delivery of stock; a charge associated with this [n -S]\n",
  "BACKWARDATIONS": "BACKWARDATION, on the Stock Exchange, the postponement of the delivery of stock; a charge associated with this [n]\n",
  "BACKWARDLY": "in a reverse direction [adv]\n",
  "BACKWARDNESS": "the state of being backward [n -ES]\n",
  "BACKWARDNESSES": "BACKWARDNESS, the state of being backward [n]\n",
  "BACKWARDS": "in a reverse direction, also BACKWARD [adv]\n",
  "BACKWASH": "to affect with receding water [v -ED, -ING, -ES]\n",
  "BACKWASHED": "BACKWASH, to affect with receding water [v]\n",
  "BACKWASHES": "BACKWASH, to affect with receding water [v]\n",
  "BACKWASHING": "BACKWASH, to affect with receding water [v]\n",
  "BACKWATER": "water turned back in its course by an obstruction, or an opposing current, as in a river channel, or across a river bar [n -S]\n",
  "BACKWATERS": "BACKWATER, water turned back in its course by an obstruction, or an opposing current, as in a river channel, or across a river bar [n]\n",
  "BACKWIND": "to deflect airflow into the back of a sail [v -ED, -ING, -S]\n",
  "BACKWINDED": "BACKWIND, to deflect airflow into the back of a sail [v]\n",
  "BACKWINDING": "BACKWIND, to deflect airflow into the back of a sail [v]\n",
  "BACKWINDS": "BACKWIND, to deflect airflow into the back of a sail [v]\n",
  "BACKWOOD": "uncouth [adj]\n",
  "BACKWOODS": "the forest beyond cleared country [n]\n",
  "BACKWOODSIER": "BACKWOODSY, uncouth, rustic [adj]\n",
  "BACKWOODSIEST": "BACKWOODSY, uncouth, rustic [adj]\n",
  "BACKWOODSMAN": "a provincial, a country bumpkin [n BACKWOODSMEN]\n",
  "BACKWOODSMEN": "BACKWOODSMAN, a provincial, a country bumpkin [n]\n",
  "BACKWOODSY": "uncouth, rustic [adj BACKWOODSIER, BACKWOODSIEST]\n",
  "BACKWORD": "a retort [n -S]\n",
  "BACKWORDS": "BACKWORD, a retort [n]\n",
  "BACKWORK": "work done underground but not at the coalface [n -S]\n",
  "BACKWORKER": "a miner who does backwork, work done underground but not at the coalface [n -S]\n",
  "BACKWORKERS": "BACKWORKER, a miner who does backwork, work done underground but not at the coalface [n]\n",
  "BACKWORKS": "BACKWORK, work done underground but not at the coalface [n]\n",
  "BACKWRAP": "a wrap around garment that fastens at the back [n -S]\n",
  "BACKWRAPS": "BACKWRAP, a wrap around garment that fastens at the back [n]\n",
  "BACKYARD": "the area at the rear of a house [n -S]\n",
  "BACKYARDS": "BACKYARD, the area at the rear of a house [n]\n",
  "BACLAVA": "(Turkish) a Middle Eastern dessert, also BAKLAVA, BAKLAWA [n -S]\n",
  "BACLAVAS": "BACLAVA, (Turkish) a Middle Eastern dessert, also BAKLAVA, BAKLAWA [n]\n",
  "BACLOFEN": "a drug used to treat stroke victims [n -S]\n",
  "BACLOFENS": "BACLOFEN, a drug used to treat stroke victims [n]\n",
  "BACON": "cured and salted pig flesh [n -S]\n",
  "BACONER": "a pig suitable for bacon [n -S]\n",
  "BACONERS": "BACONER, a pig suitable for bacon [n]\n",
  "BACONS": "BACON, cured and salted pig flesh [n]\n",
  "BACRONYM": "an acronym formed using the initial letters or syllables of an existing word, also BACKRONYM [n -S]\n",
  "BACRONYMS": "BACRONYM, an acronym formed using the initial letters or syllables of an existing word, also BACKRONYM [n]\n",
  "BACS": "BAC, (short for) baccalaureate, a university degree [n]\n",
  "BACTERAEMIA": "the presence of bacteria in the blood, also BACTEREMIA [n -S]\n",
  "BACTERAEMIAS": "BACTERAEMIA, the presence of bacteria in the blood, also BACTEREMIA [n]\n",
  "BACTERAEMIC": "containing, caused by, or pertaining to bacteraemia, also BACTEREMIC [adj]\n",
  "BACTEREMIA": "the presence of bacteria in the blood, also BACTERAEMIA [n -S]\n",
  "BACTEREMIAS": "BACTEREMIA, the presence of bacteria in the blood, also BACTERAEMIA [n]\n",
  "BACTEREMIC": "having bacteria in the blood, also BACTERAEMIC [adj]\n",
  "BACTERIA": "a microscopic organism [n -S]\n",
  "BACTERIAL": "of or like bacteria, also BACTERIAN [adj BACTERIALLY] / a bacterial substance [n -S]\n",
  "BACTERIALLY": "BACTERIAL, of or like bacteria, also BACTERIAN [adv]\n",
  "BACTERIALS": "BACTERIAL, a bacterial substance [n]\n",
  "BACTERIAN": "of or like bacteria, also BACTERIAL [adj]\n",
  "BACTERIAS": "BACTERIA, a microscopic organism [n]\n",
  "BACTERIC": "of bacteria [adj]\n",
  "BACTERICIDAL": "destroying bacteria [adj BACTERICIDALLY]\n",
  "BACTERICIDALLY": "BACTERICIDAL, destroying bacteria [adv]\n",
  "BACTERICIDE": "an agent that kills bacteria [n -S]\n",
  "BACTERICIDES": "BACTERICIDE, an agent that kills bacteria [n]\n",
  "BACTERIN": "a vaccine derived from dead bacteria [n -S]\n",
  "BACTERINS": "BACTERIN, a vaccine derived from dead bacteria [n]\n",
  "BACTERIOCIN": "an antibiotic (as colicin) produced by bacteria [n -S]\n",
  "BACTERIOCINS": "BACTERIOCIN, an antibiotic (as colicin) produced by bacteria [n]\n",
  "BACTERIOID": "a swollen bacterium living symbiotically in the root-nodules of beans and other plants, also BACTEROID [n -S]\n",
  "BACTERIOIDS": "BACTERIOID, a swollen bacterium living symbiotically in the root-nodules of beans and other plants, also BACTEROID [n]\n",
  "BACTERIOLOGIC": "relating to bacteriology, also BACTERIOLOGICAL [adj]\n",
  "BACTERIOLOGICAL": "relating to bacteriology, also BACTERIOLOGIC [adj]\n",
  "BACTERIOLOGIES": "BACTERIOLOGY, the scientific study of bacteria [n]\n",
  "BACTERIOLOGIST": "one who studies bacteriology [n -S]\n",
  "BACTERIOLOGISTS": "BACTERIOLOGIST, one who studies bacteriology [n]\n",
  "BACTERIOLOGY": "the scientific study of bacteria [n BACTERIOLOGIES]\n",
  "BACTERIOLYSES": "BACTERIOLYSIS, destruction or dissolution of bacterial cells [n]\n",
  "BACTERIOLYSIN": "an antibody that destroys bacteria [n -S]\n",
  "BACTERIOLYSINS": "BACTERIOLYSIN, an antibody that destroys bacteria [n]\n",
  "BACTERIOLYSIS": "destruction or dissolution of bacterial cells [n BACTERIOLYSES]\n",
  "BACTERIOLYTIC": "relating to bacteriolysis [adj]\n",
  "BACTERIOPHAGE": "a bacterium that eats other bacteria [n -S]\n",
  "BACTERIOPHAGES": "BACTERIOPHAGE, a bacterium that eats other bacteria [n]\n",
  "BACTERIOPHAGIC": "of or like a bacteriophage, a bacterium that eats other bacteria, also BACTERIOPHAGOUS [adj]\n",
  "BACTERIOPHAGIES": "BACTERIOPHAGY, the eating of bacteria [n]\n",
  "BACTERIOPHAGOUS": "of or like a bacteriophage, a bacterium that eats other bacteria, also BACTERIOPHAGIC [adj]\n",
  "BACTERIOPHAGY": "the eating of bacteria [n BACTERIOPHAGIES]\n",
  "BACTERIOSES": "BACTERIOSIS, any bacterial plant disease [n]\n",
  "BACTERIOSIS": "any bacterial plant disease [n BACTERIOSES]\n",
  "BACTERIOSTASES": "BACTERIOSTASIS, the inhibition of the growth of bacteria without destruction [n]\n",
  "BACTERIOSTASIS": "the inhibition of the growth of bacteria without destruction [n BACTERIOSTASES]\n",
  "BACTERIOSTAT": "an agent that causes bacteriostasis [n -S]\n",
  "BACTERIOSTATIC": "of or like a bacteriostat, an agent that causes bacteriostasis [adj]\n",
  "BACTERIOSTATS": "BACTERIOSTAT, an agent that causes bacteriostasis [n]\n",
  "BACTERIOTOXIN": "a toxin of bacterial origin [n -S]\n",
  "BACTERIOTOXINS": "BACTERIOTOXIN, a toxin of bacterial origin [n]\n",
  "BACTERISATION": "treatment with bacteria, also BACTERIZATION [n -S]\n",
  "BACTERISATIONS": "BACTERISATION, treatment with bacteria, also BACTERIZATION [n]\n",
  "BACTERISE": "to treat with bacteria, also BACTERIZE [v BACTERISED, BACTERISING, BACTERISES]\n",
  "BACTERISED": "BACTERISE, to treat with bacteria, also BACTERIZE [v]\n",
  "BACTERISES": "BACTERISE, to treat with bacteria, also BACTERIZE [v]\n",
  "BACTERISING": "BACTERISE, to treat with bacteria, also BACTERIZE [v]\n",
  "BACTERIUM": "a class of unicellular or filamentous microorganisms [n BACTERIA]\n",
  "BACTERIURIA": "the presence of bacteria in the urine, also BACTERURIA [n -S]\n",
  "BACTERIURIAS": "BACTERIURIA, the presence of bacteria in the urine, also BACTERURIA [n]\n",
  "BACTERIZATION": "treatment with bacteria, also BACTERISATION [n -S]\n",
  "BACTERIZATIONS": "BACTERIZATION, treatment with bacteria, also BACTERISATION [n]\n",
  "BACTERIZE": "to treat with bacteria, also BACTERISE [v BACTERIZED, BACTERIZING, BACTERIZES]\n",
  "BACTERIZED": "BACTERIZE, to treat with bacteria, also BACTERISE [v]\n",
  "BACTERIZES": "BACTERIZE, to treat with bacteria, also BACTERISE [v]\n",
  "BACTERIZING": "BACTERIZE, to treat with bacteria, also BACTERISE [v]\n",
  "BACTEROID": "a swollen bacterium living symbiotically in the root-nodules of beans and other plants, also BACTERIOID [n -S]\n",
  "BACTEROIDS": "BACTEROID, a swollen bacterium living symbiotically in the root-nodules of beans and other plants, also BACTERIOID [n]\n",
  "BACTERURIA": "the presence of bacteria in the urine, also BACTERIURIA [n -S]\n",
  "BACTERURIAS": "BACTERURIA, the presence of bacteria in the urine, also BACTERIURIA [n]\n",
  "BACULA": "BACULUM, (Latin) the bone in the penis of certain mammals [n]\n",
  "BACULIFORM": "rod-shaped [adj]\n",
  "BACULINE": "pertaining to the stick or cane; pertaining to flogging [adj]\n",
  "BACULITE": "a fossil of the genus Baculites, allied to the ammonites, with a straight, tapering shell [n -S]\n",
  "BACULITES": "BACULITE, a fossil of the genus Baculites, allied to the ammonites, with a straight, tapering shell [n]\n",
  "BACULOVIRUS": "a type of virus found only to attack insects [n -ES]\n",
  "BACULOVIRUSES": "BACULOVIRUS, a type of virus found only to attack insects [n]\n",
  "BACULUM": "(Latin) the bone in the penis of certain mammals [n BACULUMS or BACULA]\n",
  "BACULUMS": "BACULUM, (Latin) the bone in the penis of certain mammals [n]\n",
  "BAD": "something evil [n BADS] / not good [adj WORSE, WORST or WARST or WAURST] / (slang) very good [adj BADDER, BADDEST]\n",
  "BADASS": "a difficult person [n -ES]\n",
  "BADASSED": "touchy, difficult, intimidating, also BADASS [adj]\n",
  "BADASSES": "BADASS, a difficult person [n]\n",
  "BADDELEYITE": "zirconium dioxide, occurring as colourless, yellow, brown, or black monoclinic crystals [n -S]\n",
  "BADDELEYITES": "BADDELEYITE, zirconium dioxide, occurring as colourless, yellow, brown, or black monoclinic crystals [n]\n",
  "BADDER": "BAD, not good [adj]\n",
  "BADDERLOCK": "an edible seaweed, also BALDERLOCKS [n -S]\n",
  "BADDERLOCKS": "BADDERLOCK, an edible seaweed, also BALDERLOCKS [n]\n",
  "BADDEST": "BAD, not good [adj]\n",
  "BADDIE": "a bad person, also BADDY [n -S]\n",
  "BADDIES": "BADDY, a bad person, also BADDIE [n]\n",
  "BADDISH": "not very good [adj]\n",
  "BADDY": "a bad person, also BADDIE [n BADDIES]\n",
  "BADE": "BID, to make an offer [v]\n",
  "BADGE": "to supply with an insignia [v BADGED, BADGING, BADGES]\n",
  "BADGED": "BADGE, to supply with an insignia [v]\n",
  "BADGELESS": "without a badge [adj]\n",
  "BADGER": "to pester or harass [v -ED, -ING, -S]\n",
  "BADGERED": "BADGER, to pester or harass [v]\n",
  "BADGERING": "BADGER, to pester or harass [v]\n",
  "BADGERLIER": "BADGERLY, like a badger, greyish-haired, elderly; bothersome [adj]\n",
  "BADGERLIEST": "BADGERLY, like a badger, greyish-haired, elderly; bothersome [adj]\n",
  "BADGERLY": "like a badger, greyish-haired, elderly; bothersome [adj BADGERLIER, BADGERLIEST]\n",
  "BADGERS": "BADGER, to pester or harass [v]\n",
  "BADGES": "BADGE, to supply with an insignia [v]\n",
  "BADGING": "BADGE, to supply with an insignia [v]\n",
  "BADINAGE": "(French) to banter [v BADINAGED, BADINAGING, BADINAGES]\n",
  "BADINAGED": "BADINAGE, (French) to banter [v]\n",
  "BADINAGES": "BADINAGE, (French) to banter [v]\n",
  "BADINAGING": "BADINAGE, (French) to banter [v]\n",
  "BADINERIE": "(French) a name given in the 18th century to a type of quick, light movement in a suite [n -S]\n",
  "BADINERIES": "BADINERIE, (French) a name given in the 18th century to a type of quick, light movement in a suite [n]\n",
  "BADIOUS": "chestnut-coloured [adj]\n",
  "BADLAND": "a barren, hilly area [n -S]\n",
  "BADLANDS": "BADLAND, a barren, hilly area [n]\n",
  "BADLY": "BAD, not good [adv]\n",
  "BADMAN": "an outlaw [n BADMEN]\n",
  "BADMASH": "(Urdu) an evildoer, a worthless person, also BUDMASH [n -ES]\n",
  "BADMASHES": "BADMASH, (Urdu) an evildoer, a worthless person, also BUDMASH [n]\n",
  "BADMEN": "BADMAN, an outlaw [n]\n",
  "BADMINTON": "a game played with a shuttlecock [n -S]\n",
  "BADMINTONS": "BADMINTON, a game played with a shuttlecock [n]\n",
  "BADMOUTH": "to abuse [v -ED, -ING, -S]\n",
  "BADMOUTHED": "BADMOUTH, to abuse [v]\n",
  "BADMOUTHING": "BADMOUTH, to abuse [v]\n",
  "BADMOUTHS": "BADMOUTH, to abuse [v]\n",
  "BADNESS": "the state of being bad [n -ES]\n",
  "BADNESSES": "BADNESS, the state of being bad [n]\n",
  "BADS": "BAD, something evil [n]\n",
  "BADWARE": "malicious computer software, aka malware [n -S]\n",
  "BADWARES": "BADWARE, malicious computer software, aka malware [n]\n",
  "BAE": "(US) a person's sweetheart or lover: often used as an affectionate term of address [n -S]\n",
  "BAEL": "(Hindi) a thorny Indian tree [n -S]\n",
  "BAELS": "BAEL, (Hindi) a thorny Indian tree [n]\n",
  "BAES": "BAE, (US) a person's sweetheart or lover: often used as an affectionate term of address [n]\n",
  "BAETYL": "(Greek) a magical or holy meteoric stone [n -S]\n",
  "BAETYLS": "BAETYL, (Greek) a magical or holy meteoric stone [n]\n",
  "BAFF": "in golf, to strike the ground with the sole of the club and so send the ball up in the air [v -ED, -ING, -S]\n",
  "BAFFED": "BAFF, in golf, to strike the ground with the sole of the club and so send the ball up in the air [v]\n",
  "BAFFIES": "BAFFY, a wooden golf club [n]\n",
  "BAFFING": "BAFF, in golf, to strike the ground with the sole of the club and so send the ball up in the air [v]\n",
  "BAFFLE": "to confuse, confound [v BAFFLED, BAFFLING, BAFFLES]\n",
  "BAFFLED": "BAFFLE, to confuse, confound [v]\n",
  "BAFFLEGAB": "official or professional jargon which confuses more than it clarifies, gobbledegook [n -S]\n",
  "BAFFLEGABS": "BAFFLEGAB, official or professional jargon which confuses more than it clarifies, gobbledegook [n]\n",
  "BAFFLEMENT": "the state of being baffled [n -S]\n",
  "BAFFLEMENTS": "BAFFLEMENT, the state of being baffled [n]\n",
  "BAFFLER": "a person who or thing which baffles [n -S]\n",
  "BAFFLERS": "BAFFLER, a person who or thing which baffles [n]\n",
  "BAFFLES": "BAFFLE, to confuse, confound [v]\n",
  "BAFFLING": "BAFFLE, to confuse, confound [v]\n",
  "BAFFLINGLY": "BAFFLING, BAFFLE, to confuse, confound [adv]\n",
  "BAFFS": "BAFF, in golf, to strike the ground with the sole of the club and so send the ball up in the air [v]\n",
  "BAFFY": "a wooden golf club [n BAFFIES]\n",
  "BAFT": "(Urdu) a kind of coarse fabric [n -S]\n",
  "BAFTS": "BAFT, (Urdu) a kind of coarse fabric [n]\n",
  "BAG": "to put in a pouch or sack [v BAGGED, BAGGING, BAGS]\n",
  "BAGARRE": "(French) a scuffle or brawl [n -S]\n",
  "BAGARRES": "BAGARRE, (French) a scuffle or brawl [n]\n",
  "BAGASS": "(French) dry refuse in sugar-making, also BAGASSE [n -ES]\n",
  "BAGASSE": "(French) dry refuse in sugar-making, also BAGASS [n -S]\n",
  "BAGASSES": "BAGASSE, (French) dry refuse in sugar-making, also BAGASS [n]\n",
  "BAGASSOSES": "BAGASSOSIS, an industrial disease caused by inhaling bagasse [n]\n",
  "BAGASSOSIS": "an industrial disease caused by inhaling bagasse [n BAGASSOSES]\n",
  "BAGATELLE": "(French) a trifle, a thing of no value or importance [n -S]\n",
  "BAGATELLES": "BAGATELLE, (French) a trifle, a thing of no value or importance [n]\n",
  "BAGEL": "(Yiddish) a hard, leavened, ring-shaped roll, also BEIGEL [n -S] / to defeat in a tennis set by six games to love [v BAGELED or BAGELLED, BAGELING or BAGELLING, BAGELS]\n",
  "BAGELED": "BAGEL, to defeat in a tennis set by six games to love [v]\n",
  "BAGELING": "BAGEL, to defeat in a tennis set by six games to love [v]\n",
  "BAGELLED": "BAGEL, to defeat in a tennis set by six games to love [v]\n",
  "BAGELLING": "BAGEL, to defeat in a tennis set by six games to love [v]\n",
  "BAGELS": "BAGEL, (Yiddish) a hard, leavened, ring-shaped roll, also BEIGEL [n]\n",
  "BAGFUL": "as much as a bag can hold [n BAGFULS or BAGSFUL]\n",
  "BAGFULS": "BAGFUL, as much as a bag can hold [n]\n",
  "BAGGAGE": "luggage [n -S]\n",
  "BAGGAGES": "BAGGAGE, luggage [n]\n",
  "BAGGED": "BAG, to put in a pouch or sack [v]\n",
  "BAGGER": "one that bags [n -S]\n",
  "BAGGERS": "BAGGER, one that bags [n]\n",
  "BAGGIE": "(tradename) a variety of thin strong sealable plastic bag, used primarily for storing food [n -S]\n",
  "BAGGIER": "BAGGY, loose fitting [adj]\n",
  "BAGGIES": "BAGGIE, (tradename) a variety of thin strong sealable plastic bag, used primarily for storing food [n]\n",
  "BAGGIEST": "BAGGY, loose fitting [adj]\n",
  "BAGGILY": "BAGGY, loose fitting [adv]\n",
  "BAGGINESS": "the state of being baggy [n -ES]\n",
  "BAGGINESSES": "BAGGINESS, the state of being baggy [n]\n",
  "BAGGING": "material for bags [n -S]\n",
  "BAGGINGS": "BAGGING, material for bags [n]\n",
  "BAGGIT": "(Scots) a ripe female salmon who has retained her eggs [n -S]\n",
  "BAGGITS": "BAGGIT, (Scots) a ripe female salmon who has retained her eggs [n]\n",
  "BAGGY": "loose fitting [adj BAGGIER, BAGGIEST, BAGGILY]\n",
  "BAGH": "(Hindi) a garden [n -S]\n",
  "BAGHOUSE": "a means of cleaning exhaust gases [n -S]\n",
  "BAGHOUSES": "BAGHOUSE, a means of cleaning exhaust gases [n]\n",
  "BAGHS": "BAGH, (Hindi) a garden [n]\n",
  "BAGIE": "(Northumbrian dialect) a turnip [n -S]\n",
  "BAGIES": "BAGIE, (Northumbrian dialect) a turnip [n]\n",
  "BAGLESS": "not having a bag [adj]\n",
  "BAGLIKE": "like a bag [adj]\n",
  "BAGMAN": "a travelling salesman [n BAGMEN]\n",
  "BAGMEN": "BAGMAN, a travelling salesman [n]\n",
  "BAGNETTE": "(French) a long French loaf, also BAGUETTE [n -S]\n",
  "BAGNETTES": "BAGNETTE, (French) a long French loaf, also BAGUETTE [n]\n",
  "BAGNIO": "(Italian) a brothel; a slave prison [n -S]\n",
  "BAGNIOS": "BAGNIO, (Italian) a brothel; a slave prison [n]\n",
  "BAGPIPE": "a wind instrument [n -S] / to play the bagpipes [v BAGPIPED, BAGPIPING, BAGPIPES]\n",
  "BAGPIPED": "BAGPIPE, to play the bagpipes [v]\n",
  "BAGPIPER": "one who plays the bagpipes [n -S]\n",
  "BAGPIPERS": "BAGPIPER, one who plays the bagpipes [n]\n",
  "BAGPIPES": "BAGPIPE, to play the bagpipes [v]\n",
  "BAGPIPING": "playing the bagpipes [n -S]\n",
  "BAGPIPINGS": "BAGPIPING, playing the bagpipes [n]\n",
  "BAGS": "BAG, to put in a pouch or sack [v]\n",
  "BAGSFUL": "BAGFUL, as much as a bag can hold [n]\n",
  "BAGSWINGER": "(Australian slang) a streetwalker [n -S]\n",
  "BAGSWINGERS": "BAGSWINGER, (Australian slang) a streetwalker [n]\n",
  "BAGUET": "(French) a long French loaf, also BAGUETTE, BAGNETTE [n -S]\n",
  "BAGUETS": "BAGUET, (French) a long French loaf, also BAGUETTE, BAGNETTE [n]\n",
  "BAGUETTE": "(French) a long French loaf, also BAGUET, BAGNETTE [n -S]\n",
  "BAGUETTES": "BAGUETTE, (French) a long French loaf, also BAGUET, BAGNETTE [n]\n",
  "BAGUIO": "(Spanish) a hurricane [n -S]\n",
  "BAGUIOS": "BAGUIO, (Spanish) a hurricane [n]\n",
  "BAGWASH": "a laundry service offering basic washing only [n -ES]\n",
  "BAGWASHES": "BAGWASH, a laundry service offering basic washing only [n]\n",
  "BAGWIG": "a wig, in use in the 18th century, with the hair at the back of the head in a bag [n -S]\n",
  "BAGWIGS": "BAGWIG, a wig, in use in the 18th century, with the hair at the back of the head in a bag [n]\n",
  "BAGWORM": "one of several lepidopterous insects which construct a baglike case in the larval state [n -S]\n",
  "BAGWORMS": "BAGWORM, one of several lepidopterous insects which construct a baglike case in the larval state [n]\n",
  "BAH": "expressing disgust [interj]\n",
  "BAHADA": "(Spanish) a broad, sloping depositional deposit caused by the coalescing of alluvial fans, also BAJADA [n -S]\n",
  "BAHADAS": "BAHADA, (Spanish) a broad, sloping depositional deposit caused by the coalescing of alluvial fans, also BAJADA [n]\n",
  "BAHADUR": "(Urdu) a Hindu title of respect, meaning hero or great one [n -S]\n",
  "BAHADURS": "BAHADUR, (Urdu) a Hindu title of respect, meaning hero or great one [n]\n",
  "BAHOOKIE": "(colloquial) the buttocks [n -S]\n",
  "BAHOOKIES": "BAHOOKIE, (colloquial) the buttocks [n]\n",
  "BAHT": "(Thai) the monetary unit of Thailand, also BHAT [n -S]\n",
  "BAHTS": "BAHT, (Thai) the monetary unit of Thailand, also BHAT [n]\n",
  "BAHU": "(Hindi) a daughter-in-law, especially one who lives with her husband's family when married [n -S]\n",
  "BAHUS": "BAHU, (Hindi) a daughter-in-law, especially one who lives with her husband's family when married [n]\n",
  "BAHUT": "(French) an ornamental, usually round-topped chest or cabinet [n -S]\n",
  "BAHUTS": "BAHUT, (French) an ornamental, usually round-topped chest or cabinet [n]\n",
  "BAHUVRIHI": "(Sanskrit) a class of compound words where the first element describes the second but cannot substitute for it, e.g. turncoat [n -S]\n",
  "BAHUVRIHIS": "BAHUVRIHI, (Sanskrit) a class of compound words where the first element describes the second but cannot substitute for it, e.g. turncoat [n]\n",
  "BAIDAR": "(Russian) an Alaskan Inuit kayak, also BAIDARKA, BIDARKA, BIDARKEE [n -S]\n",
  "BAIDARKA": "(Russian) an Alaskan Inuit kayak, also BAIDAR, BIDARKA, BIDARKEE [n -S]\n",
  "BAIDARKAS": "BAIDARKA, (Russian) an Alaskan Inuit kayak, also BAIDAR, BIDARKA, BIDARKEE [n]\n",
  "BAIDARS": "BAIDAR, (Russian) an Alaskan Inuit kayak, also BAIDARKA, BIDARKA, BIDARKEE [n]\n",
  "BAIGNOIRE": "(French) a theatre box on a level with the stalls [n -S]\n",
  "BAIGNOIRES": "BAIGNOIRE, (French) a theatre box on a level with the stalls [n]\n",
  "BAIL": "to set free by putting up security [v -ED, -ING, -S]\n",
  "BAILABLE": "able to be bailed [adj]\n",
  "BAILBOND": "a bond given by a prisoner [n -S]\n",
  "BAILBONDS": "BAILBOND, a bond given by a prisoner [n]\n",
  "BAILED": "BAIL, to set free by putting up security [v]\n",
  "BAILEE": "a person to whom property is bailed [n -S]\n",
  "BAILEES": "BAILEE, a person to whom property is bailed [n]\n",
  "BAILER": "(US) a person who bails property to another, also BAILOR [n -S]\n",
  "BAILERS": "BAILER, (US) a person who bails property to another, also BAILOR [n]\n",
  "BAILEY": "the outer wall or courtyard of a castle [n -S]\n",
  "BAILEYS": "BAILEY, the outer wall or courtyard of a castle [n]\n",
  "BAILIE": "in Scotland, a magistrate who presides in a burgh court, also BAILLIE [n -S]\n",
  "BAILIES": "BAILIE, in Scotland, a magistrate who presides in a burgh court, also BAILLIE [n]\n",
  "BAILIESHIP": "the office of bailie [n -S]\n",
  "BAILIESHIPS": "BAILIESHIP, the office of bailie [n]\n",
  "BAILIFF": "a sheriff's officer [n -S]\n",
  "BAILIFFS": "BAILIFF, a sheriff's officer [n]\n",
  "BAILIFFSHIP": "the office of bailiff [n -S]\n",
  "BAILIFFSHIPS": "BAILIFFSHIP, the office of bailiff [n]\n",
  "BAILING": "BAIL, to set free by putting up security [v]\n",
  "BAILIWICK": "the region in which a sheriff (bailie) has legal powers [n -S]\n",
  "BAILIWICKS": "BAILIWICK, the region in which a sheriff (bailie) has legal powers [n]\n",
  "BAILLI": "(French) a magistrate, also BAILLIE [n -S]\n",
  "BAILLIAGE": "(French) the jurisdiction of a bailli [n -S]\n",
  "BAILLIAGES": "BAILLIAGE, (French) the jurisdiction of a bailli [n]\n",
  "BAILLIE": "in Scotland, a magistrate who presides in a burgh court, also BAILIE [n -S]\n",
  "BAILLIES": "BAILLIE, in Scotland, a magistrate who presides in a burgh court, also BAILIE [n]\n",
  "BAILLIESHIP": "the office of baillie [n -S]\n",
  "BAILLIESHIPS": "BAILLIESHIP, the office of baillie [n]\n",
  "BAILLIS": "BAILLI, (French) a magistrate, also BAILLIE [n]\n",
  "BAILMENT": "a delivery of goods in trust [n -S]\n",
  "BAILMENTS": "BAILMENT, a delivery of goods in trust [n]\n",
  "BAILOR": "a person who bails property to another, also BAILER [n -S]\n",
  "BAILORS": "BAILOR, a person who bails property to another, also BAILER [n]\n",
  "BAILOUT": "the act of parachuting from an aircraft [n -S]\n",
  "BAILOUTS": "BAILOUT, the act of parachuting from an aircraft [n]\n",
  "BAILS": "BAIL, to set free by putting up security [v]\n",
  "BAILSMAN": "a person who stands bail for another [n BAILSMEN]\n",
  "BAILSMEN": "BAILSMAN, a person who stands bail for another [n]\n",
  "BAININ": "(Irish) a white, close-woven woollen material used for making jackets, also BAWNEEN [n -S]\n",
  "BAININS": "BAININ, (Irish) a white, close-woven woollen material used for making jackets, also BAWNEEN [n]\n",
  "BAINITE": "a byproduct of steel treatment [n -S]\n",
  "BAINITES": "BAINITE, a byproduct of steel treatment [n]\n",
  "BAIRN": "(Scots) a child [n -S]\n",
  "BAIRNISH": "like a bairn, a child [adj]\n",
  "BAIRNLIER": "BAIRNLY, like a bairn, a child [adj]\n",
  "BAIRNLIEST": "BAIRNLY, like a bairn, a child [adj]\n",
  "BAIRNLIKE": "(Scots) childlike [adj]\n",
  "BAIRNLY": "like a bairn, a child [adj BAIRNLIER, BAIRNLIEST]\n",
  "BAIRNS": "BAIRN, (Scots) a child [n]\n",
  "BAISA": "(Arabic) a unit of currency in Oman, worth one-thousandth of a rial, also BAIZA [n -S]\n",
  "BAISAS": "BAISA, (Arabic) a unit of currency in Oman, worth one-thousandth of a rial, also BAIZA [n]\n",
  "BAISEMAIN": "(French) a kiss on the hand [n -S]\n",
  "BAISEMAINS": "BAISEMAIN, (French) a kiss on the hand [n]\n",
  "BAIT": "to set a trap etc. with food [v -ED, -ING, -S]\n",
  "BAITED": "BAIT, to set a trap etc. with food [v]\n",
  "BAITER": "one who baits [n -S]\n",
  "BAITERS": "BAITER, one who baits [n]\n",
  "BAITFISH": "a fish used as bait [n -ES]\n",
  "BAITFISHES": "BAITFISH, a fish used as bait [n]\n",
  "BAITH": "(Scots) both [adj]\n",
  "BAITING": "fish or worms used as bait [n -S]\n",
  "BAITINGS": "BAITING, fish or worms used as bait [n]\n",
  "BAITS": "BAIT, to set a trap etc. with food [v]\n",
  "BAIZA": "(Arabic) a monetary unit of Oman, also BAISA [n -S]\n",
  "BAIZAS": "BAIZA, (Arabic) a monetary unit of Oman, also BAISA [n]\n",
  "BAIZE": "to cover with a green cloth [v BAIZED, BAIZING, BAIZES]\n",
  "BAIZED": "BAIZE, to cover with a green cloth [v]\n",
  "BAIZES": "BAIZE, to cover with a green cloth [v]\n",
  "BAIZING": "BAIZE, to cover with a green cloth [v]\n",
  "BAJADA": "(Spanish) a broad, sloping depositional deposit caused by the coalescing of alluvial fans, also BAHADA [n -S]\n",
  "BAJADAS": "BAJADA, (Spanish) a broad, sloping depositional deposit caused by the coalescing of alluvial fans, also BAHADA [n]\n",
  "BAJAN": "(Scots) a freshman at Aberdeen university [n -S]\n",
  "BAJANS": "BAJAN, (Scots) a freshman at Aberdeen university [n]\n",
  "BAJILLION": "an unspecified but extremely large number [n -S]\n",
  "BAJILLIONS": "BAJILLION, an unspecified but extremely large number [n]\n",
  "BAJRA": "(Hindi) in the Indian subcontinent, pearl millet or a similar grain, also BAJREE, BAJRI [n -S]\n",
  "BAJRAS": "BAJRA, (Hindi) in the Indian subcontinent, pearl millet or a similar grain, also BAJREE, BAJRI [n]\n",
  "BAJREE": "(Hindi) in the Indian subcontinent, pearl millet or a similar grain, also BAJRA, BAJRI [n -S]\n",
  "BAJREES": "BAJREE, (Hindi) in the Indian subcontinent, pearl millet or a similar grain, also BAJRA, BAJRI [n]\n",
  "BAJRI": "(Hindi) in the Indian subcontinent, pearl millet or a similar grain, also BAJRA, BAJREE [n -S]\n",
  "BAJRIS": "BAJRI, (Hindi) in the Indian subcontinent, pearl millet or a similar grain, also BAJRA, BAJREE [n]\n",
  "BAJU": "(Malay) a short loose jacket worn in Malaysia and Indonesia [n -S]\n",
  "BAJUS": "BAJU, (Malay) a short loose jacket worn in Malaysia and Indonesia [n]\n",
  "BAKE": "to cook in an oven [v BAKED, BAKEN or BAKED, BAKING, BAKES]\n",
  "BAKEAPPLE": "(Canadian) the fruit of the cloudberry [n -S]\n",
  "BAKEAPPLES": "BAKEAPPLE, (Canadian) the fruit of the cloudberry [n]\n",
  "BAKEBOARD": "(Scots) a board for kneading dough on [n -S]\n",
  "BAKEBOARDS": "BAKEBOARD, (Scots) a board for kneading dough on [n]\n",
  "BAKED": "BAKE, to cook in an oven [v]\n",
  "BAKEHOUSE": "a place where bread is made [n -S]\n",
  "BAKEHOUSES": "BAKEHOUSE, a place where bread is made [n]\n",
  "BAKELITE": "(tradename) a thermosetting resin used in electric insulators etc. [n -S]\n",
  "BAKELITES": "BAKELITE, (tradename) a thermosetting resin used in electric insulators etc. [n]\n",
  "BAKEMEAT": "(Biblical) pastry, pies [n -S]\n",
  "BAKEMEATS": "BAKEMEAT, (Biblical) pastry, pies [n]\n",
  "BAKEN": "BAKE, to cook in an oven [v]\n",
  "BAKEOFF": "a baking contest in which competitors gather to prepare their specialties for judging [n -S]\n",
  "BAKEOFFS": "BAKEOFF, a baking contest in which competitors gather to prepare their specialties for judging [n]\n",
  "BAKER": "one that bakes [n -S]\n",
  "BAKERIES": "BAKERY, a baker's shop [n]\n",
  "BAKERS": "BAKER, one that bakes [n]\n",
  "BAKERY": "a baker's shop [n BAKERIES]\n",
  "BAKES": "BAKE, to cook in an oven [v]\n",
  "BAKESHOP": "a bakery [n -S]\n",
  "BAKESHOPS": "BAKESHOP, a bakery [n]\n",
  "BAKESTONE": "a flat stone or iron plate on which cakes are baked in an oven [n -S]\n",
  "BAKESTONES": "BAKESTONE, a flat stone or iron plate on which cakes are baked in an oven [n]\n",
  "BAKEWARE": "heat-resistant dishes suitable for use in an oven [n -S]\n",
  "BAKEWARES": "BAKEWARE, heat-resistant dishes suitable for use in an oven [n]\n",
  "BAKGAT": "(South African) fine, excellent [adj]\n",
  "BAKHSHISH": "(Persian) in Eastern countries to give a tip, also BACKSHEESH, BACKSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v -ED, -ING, -ES]\n",
  "BAKHSHISHED": "BAKHSHISH, (Persian) in Eastern countries to give a tip, also BACKSHEESH, BACKSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v]\n",
  "BAKHSHISHES": "BAKHSHISH [n]\n",
  "BAKHSHISHING": "BAKHSHISH, (Persian) in Eastern countries to give a tip, also BACKSHEESH, BACKSHISH, BAKSHEESH, BAKSHISH, BUCKSHISH [v]\n",
  "BAKING": "the process by which bread is baked [n -S]\n",
  "BAKINGS": "BAKING, the process by which bread is baked [n]\n",
  "BAKKIE": "(South African) a small truck with an open body and low sides [n -S]\n",
  "BAKKIES": "BAKKIE, (South African) a small truck with an open body and low sides [n]\n",
  "BAKLAVA": "(Turkish) a Middle Eastern dessert made of layers of filo pastry, honey, nuts, etc., also BACLAVA, BAKLAWA [n -S]\n",
  "BAKLAVAS": "BAKLAVA, (Turkish) a Middle Eastern dessert made of layers of filo pastry, honey, nuts, etc., also BACLAVA, BAKLAWA [n]\n",
  "BAKLAWA": "(Turkish) a Middle Eastern dessert made of layers of filo pastry, honey, nuts, etc., also BACLAVA, BAKLAVA [n -S]\n",
  "BAKLAWAS": "BAKLAWA, (Turkish) a Middle Eastern dessert made of layers of filo pastry, honey, nuts, etc., also BACLAVA, BAKLAVA [n]\n",
  "BAKRA": "(Caribbean) a white person, esp. from Britain, also BACKRA, BUCKRA [n -S]\n",
  "BAKRAS": "BAKRA, (Caribbean) a white person, esp. from Britain, also BACKRA, BUCKRA [n]\n",
  "BAKSHEESH": "(Persian) in Eastern countries, a gift or present of money, a tip [n -ES] / to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHISH, BUCKSHISH [v -ED, -ING, -ES]\n",
  "BAKSHEESHED": "BAKSHEESH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHISH, BUCKSHISH [v]\n",
  "BAKSHEESHES": "BAKSHEESH, (Persian) in Eastern countries, a gift or present of money, a tip [n]\n",
  "BAKSHEESHING": "BAKSHEESH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHISH, BUCKSHISH [v]\n",
  "BAKSHISH": "(Persian) in Eastern countries, a gift or present of money, a tip [n -ES] / to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BUCKSHISH [v -ED, -ING, -ES]\n",
  "BAKSHISHED": "BAKSHISH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BUCKSHISH [v]\n",
  "BAKSHISHES": "BAKSHISH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BUCKSHISH [v]\n",
  "BAKSHISHING": "BAKSHISH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BUCKSHISH [v]\n",
  "BAL": "(short for) a balmoral, a type of Scottish bonnet or boot [n -S]\n",
  "BALACLAVA": "a knitted hat which covers the head and neck [n -S]\n",
  "BALACLAVAS": "BALACLAVA, a knitted hat which covers the head and neck [n]\n",
  "BALADIN": "(French) a (male) theatrical dancer, also BALLADIN [n -S]\n",
  "BALADINE": "(French) a (female) theatrical dancer, also BALLADINE [n -S]\n",
  "BALADINES": "BALADINE, (French) a (female) theatrical dancer, also BALLADINE [n]\n",
  "BALADINS": "BALADIN, (French) a (male) theatrical dancer, also BALLADIN [n]\n",
  "BALAFON": "a musical instrument of Africa [n -S]\n",
  "BALAFONS": "BALAFON, a musical instrument of Africa [n]\n",
  "BALALAIKA": "(Russian) a Russian musical instrument [n -S]\n",
  "BALALAIKAS": "BALALAIKA, (Russian) a Russian musical instrument [n]\n",
  "BALANCE": "to have equal weight or power [v BALANCED, BALANCING, BALANCES]\n",
  "BALANCEABLE": "that can be balanced [adj]\n",
  "BALANCED": "BALANCE, to have equal weight or power [v]\n",
  "BALANCER": "one who balances [n -S]\n",
  "BALANCERS": "BALANCER, one who balances [n]\n",
  "BALANCES": "BALANCE, to have equal weight or power [v]\n",
  "BALANCING": "the act of putting in equilibrium [n -S]\n",
  "BALANCINGS": "BALANCING, the act of putting in equilibrium [n]\n",
  "BALANITIS": "inflammation of the glans penis in mammals [n BALANITISES]\n",
  "BALANITISES": "BALANITIS, inflammation of the glans penis in mammals [n]\n",
  "BALAS": "a variety of spinel ruby, of a pale rose red [n -ES]\n",
  "BALASES": "BALAS, a variety of spinel ruby, of a pale rose red [n]\n",
  "BALATA": "(Tupi) a large evergreen tropical tree; a gum produced from this, used as a substitute for rubber [n -S]\n",
  "BALATAS": "BALATA, (Tupi) a large evergreen tropical tree; a gum produced from this, used as a substitute for rubber [n]\n",
  "BALAYAGE": "to highlight hair by painting bleach or dye onto sections with a brush [v BALAYAGED, BALAYAGING, BALAYAGES]\n",
  "BALAYAGED": "BALAYAGE, to highlight hair by painting bleach or dye onto sections with a brush [v]\n",
  "BALAYAGES": "BALAYAGE, to highlight hair by painting bleach or dye onto sections with a brush [v]\n",
  "BALAYAGING": "BALAYAGE, to highlight hair by painting bleach or dye onto sections with a brush [v]\n",
  "BALBOA": "(Spanish) the monetary unit of Panama [n -S]\n",
  "BALBOAS": "BALBOA, (Spanish) the monetary unit of Panama [n]\n",
  "BALBRIGGAN": "a knitted, unbleached cotton fabric, used in hosiery and underwear [n -S]\n",
  "BALBRIGGANS": "BALBRIGGAN, a knitted, unbleached cotton fabric, used in hosiery and underwear [n]\n",
  "BALBUTIENT": "stammering [adj]\n",
  "BALCONET": "a miniature balcony, also BALCONETTE [n -S]\n",
  "BALCONETS": "BALCONET, a miniature balcony, also BALCONETTE [n]\n",
  "BALCONETTE": "a miniature balcony, also BALCONET [n -S]\n",
  "BALCONETTES": "BALCONETTE, a miniature balcony, also BALCONET [n]\n",
  "BALCONIED": "having a balcony [adj]\n",
  "BALCONIES": "BALCONY, a platform projecting from the wall of a building, often with access from a door or window [n]\n",
  "BALCONY": "a platform projecting from the wall of a building, often with access from a door or window [n BALCONIES]\n",
  "BALD": "without hair [adj BALDER, BALDEST, BALDLY] / to lose one's hair [v -ED, -ING, -S]\n",
  "BALDACHIN": "a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHINO, BALDAQUIN, BAUDEKIN, BAWDKIN [n -S]\n",
  "BALDACHINO": "a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDAQUIN, BAUDEKIN, BAWDKIN [n -S]\n",
  "BALDACHINOS": "BALDACHINO, a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDAQUIN, BAUDEKIN, BAWDKIN [n]\n",
  "BALDACHINS": "BALDACHIN, a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHINO, BALDAQUIN, BAUDEKIN, BAWDKIN [n]\n",
  "BALDAQUIN": "a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDACHINO, BAUDEKIN, BAWDKIN [n -S]\n",
  "BALDAQUINS": "BALDAQUIN, a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDACHINO, BAUDEKIN, BAWDKIN [n]\n",
  "BALDED": "BALD, to lose one's hair [v]\n",
  "BALDER": "BALD, without hair [adj]\n",
  "BALDERDASH": "nonsense, drivel [n -ES]\n",
  "BALDERDASHES": "BALDERDASH, nonsense, drivel [n]\n",
  "BALDERLOCKS": "an edible seaweed, also BADDERLOCK [n -ES]\n",
  "BALDERLOCKSES": "BALDERLOCKS, an edible seaweed, also BADDERLOCK [n]\n",
  "BALDEST": "BALD, without hair [adj]\n",
  "BALDFACED": "bald [adj]\n",
  "BALDHEAD": "a bald person [n -S]\n",
  "BALDHEADED": "bald [adj]\n",
  "BALDHEADS": "BALDHEAD, a bald person [n]\n",
  "BALDICOOT": "the coot, from its white frontal shield [n -S]\n",
  "BALDICOOTS": "BALDICOOT, the coot, from its white frontal shield [n]\n",
  "BALDIE": "a baldheaded person, also BALDY [n -S]\n",
  "BALDIER": "BALDY, having no hair [adj]\n",
  "BALDIES": "BALDY, a bald person [n]\n",
  "BALDIEST": "BALDY, having no hair [adj]\n",
  "BALDING": "BALD, to lose one's hair [v]\n",
  "BALDISH": "somewhat bald [adj]\n",
  "BALDLY": "BALD, without hair [adv]\n",
  "BALDMONEY": "a wild flower, aka meu, spignel or spicknel [n -S]\n",
  "BALDMONEYS": "BALDMONEY, a wild flower, aka meu, spignel or spicknel [n]\n",
  "BALDNESS": "the state of being bald [n -ES]\n",
  "BALDNESSES": "BALDNESS, the state of being bald [n]\n",
  "BALDPATE": "a bald person [n -S]\n",
  "BALDPATED": "destitute of hair on the head [adj]\n",
  "BALDPATES": "BALDPATE, a bald person [n]\n",
  "BALDRIC": "a warrior's sword belt, also BALDRICK, BAUDRIC, BAUDRICK, BAWDRIC [n -S]\n",
  "BALDRICK": "a warrior's sword belt, also BALDRIC, BAUDRIC, BAUDRICK, BAWDRIC [n -S]\n",
  "BALDRICKS": "BALDRICK, a warrior's sword belt, also BALDRIC, BAUDRIC, BAUDRICK, BAWDRIC [n]\n",
  "BALDRICS": "BALDRIC, a warrior's sword belt, also BALDRICK, BAUDRIC, BAUDRICK, BAWDRIC [n]\n",
  "BALDS": "BALD, to lose one's hair [v]\n",
  "BALDY": "a bald person [n BALDIES] / having no hair [adj BALDIER, BALDIEST]\n",
  "BALE": "to form into tightly compressed bundles [v BALED, BALING, BALES]\n",
  "BALECTION": "a moulding around a panel, projecting beyond the surface of the framing, also BILECTION, BOLECTION [n -S]\n",
  "BALECTIONS": "BALECTION, a moulding around a panel, projecting beyond the surface of the framing, also BILECTION, BOLECTION [n]\n",
  "BALED": "BALE, to form into tightly compressed bundles [v]\n",
  "BALEEN": "whalebone [n -S]\n",
  "BALEENS": "BALEEN, whalebone [n]\n",
  "BALEFIRE": "a bonfire or beacon-fire [n -S]\n",
  "BALEFIRES": "BALEFIRE, a bonfire or beacon-fire [n]\n",
  "BALEFUL": "foreboding or threatening evil [adj BALEFULLY]\n",
  "BALEFULLY": "BALEFUL, foreboding or threatening evil [adv]\n",
  "BALEFULNESS": "the state of being baleful [n -ES]\n",
  "BALEFULNESSES": "BALEFULNESS, the state of being baleful [n]\n",
  "BALER": "one who bales [n -S]\n",
  "BALERS": "BALER, one who bales [n]\n",
  "BALES": "BALE, to form into tightly compressed bundles [v]\n",
  "BALIBUNTAL": "(Tagalog) fine, closely-woven straw; a hat made of this [n -S]\n",
  "BALIBUNTALS": "BALIBUNTAL, (Tagalog) fine, closely-woven straw; a hat made of this [n]\n",
  "BALING": "the act of making into a bale [n -S]\n",
  "BALINGS": "BALING, the act of making into a bale [n]\n",
  "BALISAUR": "a long-tailed badger [n -S]\n",
  "BALISAURS": "BALISAUR, a long-tailed badger [n]\n",
  "BALISE": "an electronic beacon or transponder placed between the rails of a railway as part of an Automatic Train Protection (ATS) system [n -S]\n",
  "BALISES": "BALISE, an electronic beacon or transponder placed between the rails of a railway as part of an Automatic Train Protection (ATS) system [n]\n",
  "BALISTA": "(Latin) a Roman machine for throwing projectiles, also BALLISTA [n BALISTAS or BALISTAE]\n",
  "BALISTAE": "BALISTA, (Latin) a Roman machine for throwing projectiles, also BALLISTA [n]\n",
  "BALISTAS": "BALISTA, (Latin) a Roman machine for throwing projectiles, also BALLISTA [n]\n",
  "BALK": "to refrain from proceeding, also BAUK, BAULK [v -ED, -ING, -S]\n",
  "BALKANISATION": "the act of balkanising, also BALKANIZATION [n -S]\n",
  "BALKANISATIONS": "BALKANISATION, the act of balkanising, also BALKANIZATION [n]\n",
  "BALKANISE": "to divide (a region or territory) into small, often hostile units, also BALKANIZE [v BALKANISED, BALKANISING, BALKANISES]\n",
  "BALKANISED": "BALKANISE, to divide (a region or territory) into small, often hostile units, also BALKANIZE [v]\n",
  "BALKANISES": "BALKANISE, to divide (a region or territory) into small, often hostile units, also BALKANIZE [v]\n",
  "BALKANISING": "BALKANISE, to divide (a region or territory) into small, often hostile units, also BALKANIZE [v]\n",
  "BALKANIZATION": "the act of balkanizing, also BALKANISATION [n -S]\n",
  "BALKANIZATIONS": "BALKANIZATION, the act of balkanizing, also BALKANISATION [n]\n",
  "BALKANIZE": "to divide (a region or territory) into small, often hostile units, also BALKANISE [v BALKANIZED, BALKANIZING, BALKANIZES]\n",
  "BALKANIZED": "BALKANIZE, to divide (a region or territory) into small, often hostile units, also BALKANISE [v]\n",
  "BALKANIZES": "BALKANIZE, to divide (a region or territory) into small, often hostile units, also BALKANISE [v]\n",
  "BALKANIZING": "BALKANIZE, to divide (a region or territory) into small, often hostile units, also BALKANISE [v]\n",
  "BALKED": "BALK, to refrain from proceeding, also BAUK, BAULK [v]\n",
  "BALKER": "one who, or that which balks [n -S]\n",
  "BALKERS": "BALKER, one who, or that which balks [n]\n",
  "BALKIER": "BALKY, apt to balk; as, a balky horse, also BAULKY [adj]\n",
  "BALKIEST": "BALKY, apt to balk; as, a balky horse, also BAULKY [adj]\n",
  "BALKILY": "BALKY, apt to balk; as, a balky horse, also BAULKY [adv]\n",
  "BALKINESS": "the state of being balky, apt to balk [n -ES]\n",
  "BALKINESSES": "BALKINESS, the state of being balky, apt to balk [n]\n",
  "BALKING": "the act of balking [n -S]\n",
  "BALKINGLY": "BALKING [adv]\n",
  "BALKINGS": "BALKING, the act of balking [n]\n",
  "BALKLINE": "a line drawn across a billiard table, also BAULKLINE [n -S]\n",
  "BALKLINES": "BALKLINE, a line drawn across a billiard table, also BAULKLINE [n]\n",
  "BALKS": "BALK, to refrain from proceeding, also BAUK, BAULK [v]\n",
  "BALKY": "apt to balk; as, a balky horse, also BAULKY [adj BALKIER, BALKIEST, BALKILY]\n",
  "BALL": "to form into a sphere [v -ED, -ING, -S]\n",
  "BALLABILE": "(Italian) a part of a ballet danced by the whole corps de ballet [n BALLABILI or BALLABILES]\n",
  "BALLABILES": "BALLABILE, (Italian) a part of a ballet danced by the whole corps de ballet [n]\n",
  "BALLABILI": "BALLABILE, (Italian) a part of a ballet danced by the whole corps de ballet [n]\n",
  "BALLAD": "a slow, sentimental song; a simple narrative poem in short stanzas [n -S] / to make ballads about, also BALLANT, BALLAT, BALLET [v -ED, -ING, -S]\n",
  "BALLADE": "(French) a poetic form, originally for singing [n -S]\n",
  "BALLADED": "BALLAD, to make ballads about, also BALLANT, BALLAT, BALLET [v]\n",
  "BALLADEER": "one who sings ballads [n -S] / to sing ballads [v -ED, -ING, -S]\n",
  "BALLADEERED": "BALLADEER, to sing ballads [v]\n",
  "BALLADEERING": "BALLADEER, to sing ballads [v]\n",
  "BALLADEERS": "BALLADEER, one who sings ballads [n]\n",
  "BALLADES": "BALLADE, (French) a poetic form, originally for singing [n]\n",
  "BALLADIC": "relating to a ballad [adj]\n",
  "BALLADIN": "(French) a (male) theatre dancer, also BALADIN [n -S]\n",
  "BALLADINE": "(French) a (female) theatre dancer, also BALADINE [n -S]\n",
  "BALLADINES": "BALLADINE, (French) a (female) theatre dancer, also BALADINE [n]\n",
  "BALLADING": "BALLAD, to make ballads about, also BALLANT, BALLAT, BALLET [v]\n",
  "BALLADINS": "BALLADIN, (French) a (male) theatre dancer, also BALADIN [n]\n",
  "BALLADIST": "one who composes ballads [n -S]\n",
  "BALLADISTS": "BALLADIST, one who composes ballads [n]\n",
  "BALLADMONGER": "a dealer in or composer of ballads [n -S]\n",
  "BALLADMONGERS": "BALLADMONGER, a dealer in or composer of ballads [n]\n",
  "BALLADRIES": "BALLADRY, ballads collectively [n]\n",
  "BALLADRY": "ballads collectively [n BALLADRIES]\n",
  "BALLADS": "BALLAD, to make ballads about, also BALLANT, BALLAT, BALLET [v]\n",
  "BALLAN": "a species of wrasse [n -S]\n",
  "BALLANS": "BALLAN, a species of wrasse [n]\n",
  "BALLANT": "(Scots) a ballad [n -S] / to make ballads about, also BALLAD, BALLAT, BALLET [v -ED, -ING, -S]\n",
  "BALLANTED": "BALLANT, to make ballads about, also BALLAD, BALLAT, BALLET [v]\n",
  "BALLANTING": "BALLANT, to make ballads about, also BALLAD, BALLAT, BALLET [v]\n",
  "BALLANTS": "BALLANT, to make ballads about, also BALLAD, BALLAT, BALLET [v]\n",
  "BALLANWRASSE": "a species of wrasse, also BALLAN [n -S]\n",
  "BALLANWRASSES": "BALLANWRASSE, a species of wrasse, also BALLAN [n]\n",
  "BALLAST": "heavy material used to weigh down and steady a ship or balloon [n -S] / to load with ballast [v -ED, -ING, -S]\n",
  "BALLASTED": "BALLAST, to load with ballast [v]\n",
  "BALLASTER": "one who ballasts [n -S]\n",
  "BALLASTERS": "BALLASTER, one who ballasts [n]\n",
  "BALLASTING": "BALLAST, to load with ballast [v]\n",
  "BALLASTS": "BALLAST, to load with ballast [v]\n",
  "BALLAT": "(Scots) a ballad [n -S] / to make ballads about, also BALLAD, BALLANT, BALLET [v -ED, -ING, -S]\n",
  "BALLATED": "BALLAT, to make ballads about, also BALLAD, BALLANT, BALLET [v]\n",
  "BALLATING": "BALLAT, to make ballads about, also BALLAD, BALLANT, BALLET [v]\n",
  "BALLATS": "BALLAT, to make ballads about, also BALLAD, BALLANT, BALLET [v]\n",
  "BALLBOY": "a boy who retrieves balls during a game [n -S]\n",
  "BALLBOYS": "BALLBOY, a boy who retrieves balls during a game [n]\n",
  "BALLBREAKER": "(offensive) an aggressively feminist woman [n -S]\n",
  "BALLBREAKERS": "BALLBREAKER, (offensive) an aggressively feminist woman [n]\n",
  "BALLCARRIER": "one who carries a ball [n -S]\n",
  "BALLCARRIERS": "BALLCARRIER, one who carries a ball [n]\n",
  "BALLCLAY": "a fine-textured highly plastic clay used for ceramics [n -S]\n",
  "BALLCLAYS": "BALLCLAY, a fine-textured highly plastic clay used for ceramics [n]\n",
  "BALLCOCK": "the stopcock in a cistern [n -S]\n",
  "BALLCOCKS": "BALLCOCK, the stopcock in a cistern [n]\n",
  "BALLED": "BALL, to form into a sphere [v]\n",
  "BALLER": "a person who or a machine which makes balls [n -S]\n",
  "BALLERINA": "(Italian) a female ballet-dancer [n BALLERINAS or BALLERINE]\n",
  "BALLERINAS": "BALLERINA, (Italian) a female ballet-dancer [n]\n",
  "BALLERINE": "BALLERINA, (Italian) a female ballet-dancer [n]\n",
  "BALLERS": "BALLER, a person who or a machine which makes balls [n]\n",
  "BALLET": "a theatrical performance of formalized dancing [n -S] / to make ballads about, also BALLAD, BALLANT, BALLAT [v -ED, -ING, -S]\n",
  "BALLETED": "BALLET, to make ballads about, also BALLAD, BALLANT, BALLAT [v]\n",
  "BALLETIC": "relating to ballet [adj]\n",
  "BALLETICALLY": "BALLETIC, relating to ballet [adv]\n",
  "BALLETING": "BALLET, to make ballads about, also BALLAD, BALLANT, BALLAT [v]\n",
  "BALLETOMANE": "a devotee of ballet [n -S]\n",
  "BALLETOMANES": "BALLETOMANE, a devotee of ballet [n]\n",
  "BALLETOMANIA": "an abnormal fondness for ballet [n -S]\n",
  "BALLETOMANIAS": "BALLETOMANIA, an abnormal fondness for ballet [n]\n",
  "BALLETS": "BALLET, to make ballads about, also BALLAD, BALLANT, BALLAT [v]\n",
  "BALLFIELD": "a field for playing a sport using a ball; especially a baseball field [n -S]\n",
  "BALLFIELDS": "BALLFIELD, a field for playing a sport using a ball; especially a baseball field [n]\n",
  "BALLFLOWER": "a carved ornament in the form of a ball enclosed by the three petals of a circular flower [n -S]\n",
  "BALLFLOWERS": "BALLFLOWER, a carved ornament in the form of a ball enclosed by the three petals of a circular flower [n]\n",
  "BALLGAME": "a game played with a ball [n -S]\n",
  "BALLGAMES": "BALLGAME, a game played with a ball [n]\n",
  "BALLGIRL": "a girl who retrieves balls during a game [n -S]\n",
  "BALLGIRLS": "BALLGIRL, a girl who retrieves balls during a game [n]\n",
  "BALLGOWN": "a long formal dress worn to a formal dance or other social occasion [n -S]\n",
  "BALLGOWNS": "BALLGOWN, a long formal dress worn to a formal dance or other social occasion [n]\n",
  "BALLHANDLING": "the art of handling a ball [n -S]\n",
  "BALLHANDLINGS": "BALLHANDLING, the art of handling a ball [n]\n",
  "BALLHAWK": "to act as a good defensive player [v -ED, -ING, -S]\n",
  "BALLHAWKED": "BALLHAWK, to act as a good defensive player [v]\n",
  "BALLHAWKING": "BALLHAWK, to act as a good defensive player [v]\n",
  "BALLHAWKS": "BALLHAWK, to act as a good defensive player [v]\n",
  "BALLICATTER": "in Newfoundland, ice that forms along a shore from waves and freezing spray [n -S]\n",
  "BALLICATTERS": "BALLICATTER, in Newfoundland, ice that forms along a shore from waves and freezing spray [n]\n",
  "BALLIER": "BALLY, a euphemism for bloody [adj]\n",
  "BALLIES": "BALLY, a noisy uproar [n]\n",
  "BALLIEST": "BALLY, a euphemism for bloody [adj]\n",
  "BALLING": "forming into a ball [n -S]\n",
  "BALLINGS": "BALLING, forming into a ball [n]\n",
  "BALLISTA": "(Latin) a Roman machine for throwing projectiles, also BALISTA [n BALLISTAS or BALLISTAE]\n",
  "BALLISTAE": "BALLISTA, (Latin) a Roman machine for throwing projectiles, also BALISTA [n]\n",
  "BALLISTAS": "BALLISTA, (Latin) a Roman machine for throwing projectiles, also BALISTA [n]\n",
  "BALLISTIC": "relating to projectiles [adj BALLISTICALLY]\n",
  "BALLISTICALLY": "BALLISTIC, relating to projectiles [adv]\n",
  "BALLISTICS": "the science of the motion of projectiles; esp. that part of the subject connected with firearms [n]\n",
  "BALLISTITE": "a kind of smokeless explosive power [n -S]\n",
  "BALLISTITES": "BALLISTITE, a kind of smokeless explosive power [n]\n",
  "BALLISTOSPORE": "a spore, esp. a fungal spore, that is forcefully ejected from its source [n -S]\n",
  "BALLISTOSPORES": "BALLISTOSPORE, a spore, esp. a fungal spore, that is forcefully ejected from its source [n]\n",
  "BALLIUM": "the outer wall and first line of defence of a castle [n -S]\n",
  "BALLIUMS": "BALLIUM, the outer wall and first line of defence of a castle [n]\n",
  "BALLOCKS": "(vulgar) to make a mess of, also BOLLIX, BOLIX, BOLLOCKS, BOLLOX [v -ED, -ING, -ES]\n",
  "BALLOCKSED": "BALLOCKS, (vulgar) to make a mess of, also BOLLIX, BOLIX, BOLLOCKS, BOLLOX [v]\n",
  "BALLOCKSES": "BALLOCKS, (vulgar) to make a mess of, also BOLLIX, BOLIX, BOLLOCKS, BOLLOX [v]\n",
  "BALLOCKSING": "BALLOCKS, (vulgar) to make a mess of, also BOLLIX, BOLIX, BOLLOCKS, BOLLOX [v]\n",
  "BALLON": "(French) in dancing, lightness of movement [n -S]\n",
  "BALLONET": "in a balloon or dirigible, a small bag into which air is force or released [n -S]\n",
  "BALLONETS": "BALLONET, in a balloon or dirigible, a small bag into which air is force or released [n]\n",
  "BALLONNE": "(French) a kind of ballet jump [n -S]\n",
  "BALLONNES": "BALLONNE, (French) a kind of ballet jump [n]\n",
  "BALLONS": "BALLON, (French) in dancing, lightness of movement [n]\n",
  "BALLOON": "to swell out [v -ED, -ING, -S]\n",
  "BALLOONED": "BALLOON, to swell out [v]\n",
  "BALLOONING": "the act or sport of riding in a balloon [n -S]\n",
  "BALLOONINGS": "BALLOONING, the act or sport of riding in a balloon [n]\n",
  "BALLOONIST": "a person who operates or rides in a balloon [n -S]\n",
  "BALLOONISTS": "BALLOONIST, a person who operates or rides in a balloon [n]\n",
  "BALLOONS": "BALLOON, to swell out [v]\n",
  "BALLOT": "to vote by ballot [v -ED, -ING, -S]\n",
  "BALLOTED": "BALLOT, to vote by ballot [v]\n",
  "BALLOTEE": "a candidate in a ballot [n -S]\n",
  "BALLOTEES": "BALLOTEE, a candidate in a ballot [n]\n",
  "BALLOTER": "one who votes by ballot [n -S]\n",
  "BALLOTERS": "BALLOTER, one who votes by ballot [n]\n",
  "BALLOTING": "the act of conducting a ballot [n -S]\n",
  "BALLOTINGS": "BALLOTING, the act of conducting a ballot [n]\n",
  "BALLOTINI": "(Italian) small glass beads used in reflective paint [n]\n",
  "BALLOTS": "BALLOT, to vote by ballot [v]\n",
  "BALLOTTEMENT": "a technique of feeling for a movable object in the body, esp. confirmation of pregnancy by feeling the rebound of the fetus following a quick digital tap on the wall of the uterus [n -S]\n",
  "BALLOTTEMENTS": "BALLOTTEMENT, a technique of feeling for a movable object in the body, esp. confirmation of pregnancy by feeling the rebound of the fetus following a quick digital tap on the wall of the uterus [n]\n",
  "BALLOW": "(Shakespeare) a cudgel [n -S]\n",
  "BALLOWS": "BALLOW, (Shakespeare) a cudgel [n]\n",
  "BALLPARK": "a baseball park [n -S]\n",
  "BALLPARKS": "BALLPARK, a baseball park [n]\n",
  "BALLPEEN": "as in ballpeen hammer, a type of hammer [adj]\n",
  "BALLPLAYER": "a person who plays ball [n -S]\n",
  "BALLPLAYERS": "BALLPLAYER, a person who plays ball [n]\n",
  "BALLPOINT": "a type of pen [n -S]\n",
  "BALLPOINTS": "BALLPOINT, a type of pen [n]\n",
  "BALLROOM": "a large room for dancing [n -S]\n",
  "BALLROOMS": "BALLROOM, a large room for dancing [n]\n",
  "BALLS": "to mess up [v BALLSED, BALLSING, BALLSES]\n",
  "BALLSED": "BALLS, to mess up [v]\n",
  "BALLSES": "BALLS, to mess up [v]\n",
  "BALLSIER": "BALLSY, gutsy [adj]\n",
  "BALLSIEST": "BALLSY, gutsy [adj]\n",
  "BALLSINESS": "spunk, spiritedness [n -ES]\n",
  "BALLSINESSES": "BALLSINESS, spunk, spiritedness [n]\n",
  "BALLSING": "BALLS, to mess up [v]\n",
  "BALLSY": "gutsy [adj BALLSIER, BALLSIEST]\n",
  "BALLUP": "(US) a botched confusion [n -S]\n",
  "BALLUPS": "BALLUP, (US) a botched confusion [n]\n",
  "BALLUTE": "a small inflatable parachute [n -S]\n",
  "BALLUTES": "BALLUTE, a small inflatable parachute [n]\n",
  "BALLY": "a euphemism for bloody [adj BALLIER, BALLIEST] / a noisy uproar [n BALLIES]\n",
  "BALLYARD": "a baseball ground [n -S]\n",
  "BALLYARDS": "BALLYARD, a baseball ground [n]\n",
  "BALLYHOO": "to promote by uproar [v -ED, -ING, -S]\n",
  "BALLYHOOED": "BALLYHOO, to promote by uproar [v]\n",
  "BALLYHOOING": "BALLYHOO, to promote by uproar [v]\n",
  "BALLYHOOS": "BALLYHOO, to promote by uproar [v]\n",
  "BALLYRAG": "to overawe; to maltreat by jeering at or playing practical jokes on [v BALLYRAGGED, BALLYRAGGING, BALLYRAGS]\n",
  "BALLYRAGGED": "BALLYRAG, to overawe; to maltreat by jeering at or playing practical jokes on [v]\n",
  "BALLYRAGGING": "BALLYRAG, to overawe; to maltreat by jeering at or playing practical jokes on [v]\n",
  "BALLYRAGS": "BALLYRAG, to overawe; to maltreat by jeering at or playing practical jokes on [v]\n",
  "BALM": "to embalm [v -ED, -ING, -S]\n",
  "BALMACAAN": "a man's loose overcoat with raglan sleeves [n -S]\n",
  "BALMACAANS": "BALMACAAN, a man's loose overcoat with raglan sleeves [n]\n",
  "BALMED": "BALM, to embalm [v]\n",
  "BALMIER": "BALMY, mild, temperate [adj]\n",
  "BALMIEST": "BALMY, mild, temperate [adj]\n",
  "BALMILY": "BALMY, mild, temperate [adv]\n",
  "BALMINESS": "the state of being balmy [n -ES]\n",
  "BALMINESSES": "BALMINESS, the state of being balmy [n]\n",
  "BALMING": "BALM, to embalm [v]\n",
  "BALMLIKE": "like balm [adj]\n",
  "BALMORAL": "a flat Scottish bonnet [n -S]\n",
  "BALMORALITIES": "BALMORALITY, superficial enthusiasm for Scottish culture [n]\n",
  "BALMORALITY": "superficial enthusiasm for Scottish culture [n BALMORALITIES]\n",
  "BALMORALS": "BALMORAL, a flat Scottish bonnet [n]\n",
  "BALMS": "BALM, to embalm [v]\n",
  "BALMY": "mild, temperate [adj BALMIER, BALMIEST, BALMILY]\n",
  "BALNEAL": "of or pertaining to a bath [adj]\n",
  "BALNEARIES": "BALNEARY, a bath; a medicinal spring [n]\n",
  "BALNEARY": "a bath; a medicinal spring [n BALNEARIES]\n",
  "BALNEATION": "the act of bathing [n -S]\n",
  "BALNEATIONS": "BALNEATION, the act of bathing [n]\n",
  "BALNEOLOGICAL": "related to balneology, the science of the therapeutic use of baths [adj]\n",
  "BALNEOLOGIES": "BALNEOLOGY, the science of the therapeutic use of baths [n]\n",
  "BALNEOLOGIST": "a student of balneology [n -S]\n",
  "BALNEOLOGISTS": "BALNEOLOGIST, a student of balneology [n]\n",
  "BALNEOLOGY": "the science of the therapeutic use of baths [n BALNEOLOGIES]\n",
  "BALNEOTHERAPIES": "BALNEOTHERAPY, treatment by natural waters [n]\n",
  "BALNEOTHERAPY": "treatment by natural waters [n BALNEOTHERAPIES]\n",
  "BALONEY": "deceptive talk, nonsense; Bologna sausage, also BOLONEY [n -S]\n",
  "BALONEYS": "BALONEY, deceptive talk, nonsense; Bologna sausage, also BOLONEY [n]\n",
  "BALOO": "(Hindi) a bear, also BALU [n -S]\n",
  "BALOOS": "BALOO, (Hindi) a bear, also BALU [n]\n",
  "BALS": "BAL, (short for) a balmoral, a type of Scottish bonnet or boot [n]\n",
  "BALSA": "(Spanish) a tropical American tree, aka corkwood [n -S]\n",
  "BALSAM": "a resinous substance obtained from various trees and used to soothe and heal [n -S] / to soothe; to embalm [v -ED, -ING, -S]\n",
  "BALSAMED": "BALSAM, to soothe; to embalm [v]\n",
  "BALSAMIC": "relating to balsam [adj]\n",
  "BALSAMIER": "BALSAMY, fragrant [adj]\n",
  "BALSAMIEST": "BALSAMY, fragrant [adj]\n",
  "BALSAMIFEROUS": "producing balsam [adj]\n",
  "BALSAMINACEOUS": "belonging to the Balsaminaceae, a family of flowering plants, including balsam and touch-me-not [adj]\n",
  "BALSAMING": "BALSAM, to soothe; to embalm [v]\n",
  "BALSAMS": "BALSAM, to soothe; to embalm [v]\n",
  "BALSAMY": "fragrant [adj BALSAMIER, BALSAMIEST]\n",
  "BALSAS": "BALSA, (Spanish) a tropical American tree, aka corkwood [n]\n",
  "BALSAWOOD": "the very light wood of the balsa tree [n -S]\n",
  "BALSAWOODS": "BALSAWOOD, the very light wood of the balsa tree [n]\n",
  "BALTHASAR": "a large wine bottle containing 2.80 gallons, also BALTHAZAR, BELSHAZZAR [n -S]\n",
  "BALTHASARS": "BALTHASAR, a large wine bottle containing 2.80 gallons, also BALTHAZAR, BELSHAZZAR [n]\n",
  "BALTHAZAR": "a large wine bottle containing 2.80 gallons, also BALTHASAR, BELSHAZZAR [n -S]\n",
  "BALTHAZARS": "BALTHAZAR, a large wine bottle containing 2.80 gallons, also BALTHASAR, BELSHAZZAR [n]\n",
  "BALTI": "(Hindi) a spicy Indian dish [n -S]\n",
  "BALTIC": "(colloquial) extremely cold [adj]\n",
  "BALTIS": "BALTI, (Hindi) a spicy Indian dish [n]\n",
  "BALU": "(Hindi) a bear, also BALOO [n -S]\n",
  "BALUN": "a device for coupling two electrical circuits [n -S]\n",
  "BALUNS": "BALUN, a device for coupling two electrical circuits [n]\n",
  "BALUS": "BALU, (Hindi) a bear, also BALOO [n]\n",
  "BALUSTER": "a small pillar supporting a stair-rail [n -S]\n",
  "BALUSTERED": "having balusters [adj]\n",
  "BALUSTERS": "BALUSTER, a small pillar supporting a stair-rail [n]\n",
  "BALUSTRADE": "a row of columns supporting a stair rail [n -S]\n",
  "BALUSTRADED": "having a balustrade [adj]\n",
  "BALUSTRADES": "BALUSTRADE, a row of columns supporting a stair rail [n]\n",
  "BALZARINE": "(French) a light cotton dress material [n -S]\n",
  "BALZARINES": "BALZARINE, (French) a light cotton dress material [n]\n",
  "BAM": "to hoax or cheat [v BAMMED, BAMMING, BAMS]\n",
  "BAMBI": "(colloquial) a born again middle aged biker [n -S]\n",
  "BAMBINI": "BAMBINO, (Italian) a child [n]\n",
  "BAMBINO": "(Italian) a child [n BAMBINI or BAMBINOS]\n",
  "BAMBINOS": "BAMBINO, (Italian) a child [n]\n",
  "BAMBIS": "BAMBI, (colloquial) a born again middle aged biker [n]\n",
  "BAMBOO": "(Malay) a giant tropical grass [n -S]\n",
  "BAMBOOS": "BAMBOO, (Malay) a giant tropical grass [n]\n",
  "BAMBOOZLE": "to deceive by underhanded methods; to frustrate [v BAMBOOZLED, BAMBOOZLING, BAMBOOZLES]\n",
  "BAMBOOZLED": "BAMBOOZLE, to deceive by underhanded methods; to frustrate [v]\n",
  "BAMBOOZLEMENT": "the act of bamboozling [n -S]\n",
  "BAMBOOZLEMENTS": "BAMBOOZLEMENT, the act of bamboozling [n]\n",
  "BAMBOOZLER": "one who bamboozles, deceives by underhanded methods [n -S]\n",
  "BAMBOOZLERS": "BAMBOOZLER, one who bamboozles, deceives by underhanded methods [n]\n",
  "BAMBOOZLES": "BAMBOOZLE, to deceive by underhanded methods; to frustrate [v]\n",
  "BAMBOOZLING": "BAMBOOZLE, to deceive by underhanded methods; to frustrate [v]\n",
  "BAMMED": "BAM, to hoax or cheat [v]\n",
  "BAMMER": "a fool [n -S]\n",
  "BAMMERS": "BAMMER, a fool [n]\n",
  "BAMMING": "BAM, to hoax or cheat [v]\n",
  "BAMPOT": "(Scots) an idiot, fool, also BARMPOT [n -S]\n",
  "BAMPOTS": "BAMPOT, (Scots) an idiot, fool, also BARMPOT [n]\n",
  "BAMS": "BAM, to hoax or cheat [v]\n",
  "BAN": "to forbid or prohibit [v BANNED, BANNING, BANS] / a monetary unit of Romania [n BANI]\n",
  "BANAK": "(Honduran) a Central American tree [n -S]\n",
  "BANAKS": "BANAK, (Honduran) a Central American tree [n]\n",
  "BANAL": "flat and uninteresting [adj BANALER, BANALEST, BANALLY]\n",
  "BANALER": "BANAL, flat and uninteresting [adj]\n",
  "BANALEST": "BANAL, flat and uninteresting [adj]\n",
  "BANALISATION": "the act of making banal, also BANALIZATION [n -S]\n",
  "BANALISATIONS": "BANALISATION, the act of making banal, also BANALIZATION [n]\n",
  "BANALISE": "to make banal, also BANALIZE [v BANALISED, BANALISING, BANALISES]\n",
  "BANALISED": "BANALISE, to make banal, also BANALIZE [v]\n",
  "BANALISES": "BANALISE, to make banal, also BANALIZE [v]\n",
  "BANALISING": "BANALISE, to make banal, also BANALIZE [v]\n",
  "BANALITIES": "BANALITY, triteness [n]\n",
  "BANALITY": "triteness [n BANALITIES]\n",
  "BANALIZATION": "the act of making banal, also BANALISATION [n -S]\n",
  "BANALIZATIONS": "BANALIZATION, the act of making banal, also BANALISATION [n]\n",
  "BANALIZE": "to make banal, also BANALISE [v BANALIZED, BANALIZING, BANALIZES]\n",
  "BANALIZED": "BANALIZE, to make banal, also BANALISE [v]\n",
  "BANALIZES": "BANALIZE, to make banal, also BANALISE [v]\n",
  "BANALIZING": "BANALIZE, to make banal, also BANALISE [v]\n",
  "BANALLY": "BANAL, flat and uninteresting [adv]\n",
  "BANANA": "an edible fruit [n -S]\n",
  "BANANAS": "BANANA, an edible fruit [n]\n",
  "BANAUSIAN": "mechanical, utilitarian or routine, as opposed to inspiring or imaginative, also BANAUSIC [adj]\n",
  "BANAUSIC": "mechanical, utilitarian or routine, as opposed to inspiring or imaginative, also BANAUSIAN [adj]\n",
  "BANC": "(French) the judges' bench [n -S]\n",
  "BANCASSURANCE": "the provision of financial services spanning both banking and insurance [n -S]\n",
  "BANCASSURANCES": "BANCASSURANCE, the provision of financial services spanning both banking and insurance [n]\n",
  "BANCASSURER": "one involved in bancassurance [n -S]\n",
  "BANCASSURERS": "BANCASSURER, one involved in bancassurance [n]\n",
  "BANCO": "the standard money for a bank's accounts [n -S]\n",
  "BANCOS": "BANCO, the standard money for a bank's accounts [n]\n",
  "BANCS": "BANC, (French) the judges' bench [n]\n",
  "BAND": "to decorate with strips of material [v -ED, -ING, -S]\n",
  "BANDA": "(Swahili) in Africa, a thatched hut [n -S]\n",
  "BANDAGE": "to cover a wound with a strip of cloth [v BANDAGED, BANDAGING, BANDAGES]\n",
  "BANDAGED": "BANDAGE, to cover a wound with a strip of cloth [v]\n",
  "BANDAGER": "one who bandages [n -S]\n",
  "BANDAGERS": "BANDAGER, one who bandages [n]\n",
  "BANDAGES": "BANDAGE, to cover a wound with a strip of cloth [v]\n",
  "BANDAGING": "the act of putting a bandage on [n -S]\n",
  "BANDAGINGS": "BANDAGING, the act of putting a bandage on [n]\n",
  "BANDAID": "acting as a quick fix, as in bandaid solution [adj]\n",
  "BANDALORE": "(obsolete) an eighteenth century toy resembling a yo-yo [n -S]\n",
  "BANDALORES": "BANDALORE, (obsolete) an eighteenth century toy resembling a yo-yo [n]\n",
  "BANDANA": "(Hindi) a large coloured handkerchief or headscarf, also BANDANNA [n -S]\n",
  "BANDANAS": "BANDANA, (Hindi) a large coloured handkerchief or headscarf, also BANDANNA [n]\n",
  "BANDANNA": "(Hindi) a coloured silk or cotton handkerchief or headscarf, also BANDANA [n -S]\n",
  "BANDANNAS": "BANDANNA, (Hindi) a coloured silk or cotton handkerchief or headscarf, also BANDANA [n]\n",
  "BANDAR": "(Hindi) a rhesus monkey [n -S]\n",
  "BANDARI": "(Hindi) a female monkey, or a cheeky girl [n -S]\n",
  "BANDARIS": "BANDARI, (Hindi) a female monkey, or a cheeky girl [n]\n",
  "BANDARS": "BANDAR, (Hindi) a rhesus monkey [n]\n",
  "BANDAS": "BANDA, (Swahili) in Africa, a thatched hut [n]\n",
  "BANDBOX": "a box for holding bands, caps, millinery etc. [n -ES]\n",
  "BANDBOXES": "BANDBOX, a box for holding bands, caps, millinery etc. [n]\n",
  "BANDBRAKE": "a brake or clutch in the form of a flexible band [n -S]\n",
  "BANDBRAKES": "BANDBRAKE, a brake or clutch in the form of a flexible band [n]\n",
  "BANDEAU": "(French) a narrow band or fillet; a part of a headdress [n BANDEAUS or BANDEAUX]\n",
  "BANDEAUS": "BANDEAU, (French) a narrow band or fillet; a part of a headdress [n]\n",
  "BANDEAUX": "BANDEAU, (French) a narrow band or fillet; a part of a headdress [n]\n",
  "BANDED": "BAND, to decorate with strips of material [v]\n",
  "BANDEIRA": "an expedition in search of gold and slaves in seventeenth century Brazil [n -S]\n",
  "BANDEIRANTE": "(Portuguese) a pioneer, explorer or adventurer, esp. one who took part in expeditions in search of gold and slaves in seventeenth century Brazil [n -S]\n",
  "BANDEIRANTES": "BANDEIRANTE, (Portuguese) a pioneer, explorer or adventurer, esp. one who took part in expeditions in search of gold and slaves in seventeenth century Brazil [n]\n",
  "BANDEIRAS": "BANDEIRA, an expedition in search of gold and slaves in seventeenth century Brazil [n]\n",
  "BANDELET": "(French) a flat moulding around a column [n -S]\n",
  "BANDELETS": "BANDELET, (French) a flat moulding around a column [n]\n",
  "BANDELIER": "(French) a shoulder belt for carrying ammunition, also BANDOLEER, BANDOLIER [n -S]\n",
  "BANDELIERS": "BANDELIER, (French) a shoulder belt for carrying ammunition, also BANDOLEER, BANDOLIER [n]\n",
  "BANDER": "a member of a league, a confederate [n -S]\n",
  "BANDERILLA": "a dart stuck into a bull at a bullfight [n -S]\n",
  "BANDERILLAS": "BANDERILLA, a dart stuck into a bull at a bullfight [n]\n",
  "BANDERILLERO": "a person who thrusts in the banderillas in a bullfight [n -S]\n",
  "BANDERILLEROS": "BANDERILLERO, a person who thrusts in the banderillas in a bullfight [n]\n",
  "BANDEROL": "(French) a small banner or streamer, also BANDEROLE, BANDROL, BANNERALL, BANNEROL [n -S]\n",
  "BANDEROLE": "(French) a small banner or streamer, also BANDEROL, BANDROL, BANNERALL, BANNEROL [n -S]\n",
  "BANDEROLES": "BANDEROLE, (French) a small banner or streamer, also BANDEROL, BANDROL, BANNERALL, BANNEROL [n]\n",
  "BANDEROLS": "BANDEROL, (French) a small banner or streamer, also BANDEROLE, BANDROL, BANNERALL, BANNEROL [n]\n",
  "BANDERS": "BANDER, a member of a league, a confederate [n]\n",
  "BANDERSNATCH": "an imaginary wild animal of fierce disposition [n -ES]\n",
  "BANDERSNATCHES": "BANDERSNATCH, an imaginary wild animal of fierce disposition [n]\n",
  "BANDFISH": "a bright-red Mediterranean fish, or other ribbon-shaped fish [n -ES]\n",
  "BANDFISHES": "BANDFISH, a bright-red Mediterranean fish, or other ribbon-shaped fish [n]\n",
  "BANDH": "(Hindi) in India, a general strike, also BUNDH [n -S]\n",
  "BANDHS": "BANDH, (Hindi) in India, a general strike, also BUNDH [n]\n",
  "BANDICOOT": "a species of very large rat, found in India and Ceylon [n -S] / to remove potatoes from the ground leaving the tops undisturbed [v BANDICOOTED, BANDICOOTING, BANDICOOTS]\n",
  "BANDICOOTED": "BANDICOOT, to remove potatoes from the ground leaving the tops undisturbed [v]\n",
  "BANDICOOTING": "BANDICOOT, to remove potatoes from the ground leaving the tops undisturbed [v]\n",
  "BANDICOOTS": "BANDICOOT, to remove potatoes from the ground leaving the tops undisturbed [v]\n",
  "BANDIED": "BANDY, to toss to and fro [v]\n",
  "BANDIER": "BANDY, having crooked legs [adj]\n",
  "BANDIES": "BANDY, to toss to and fro [v]\n",
  "BANDIEST": "BANDY, having crooked legs [adj]\n",
  "BANDINESS": "the state of being bandy [n -ES]\n",
  "BANDINESSES": "BANDINESS, the state of being bandy [n]\n",
  "BANDING": "a streaming system for school classes [n -S]\n",
  "BANDINGS": "BANDING, a streaming system for school classes [n]\n",
  "BANDIT": "a robber [n BANDITS or BANDITTI]\n",
  "BANDITO": "(Spanish) a Mexican bandit [n -S]\n",
  "BANDITOS": "BANDITO, (Spanish) a Mexican bandit [n]\n",
  "BANDITRIES": "BANDITRY, robbery by bandits [n]\n",
  "BANDITRY": "robbery by bandits [n BANDITRIES]\n",
  "BANDITS": "BANDIT, a robber [n]\n",
  "BANDITTI": "(Italian) a gang of Italian bandits [n -S]\n",
  "BANDITTIS": "BANDITTI, (Italian) a gang of Italian bandits [n]\n",
  "BANDLEADER": "the conductor of a band, also BANDMASTER [n -S]\n",
  "BANDLEADERS": "BANDLEADER, the conductor of a band, also BANDMASTER [n]\n",
  "BANDLIKE": "like a band [adj]\n",
  "BANDMASTER": "the conductor of a band, also BANDLEADER [n -S]\n",
  "BANDMASTERS": "BANDMASTER, the conductor of a band, also BANDLEADER [n]\n",
  "BANDMATE": "a fellow member of a band [n -S]\n",
  "BANDMATES": "BANDMATE, a fellow member of a band [n]\n",
  "BANDOBAST": "(Urdu) an organisation, also BANDOBUST, BUNDOBUST [n -S]\n",
  "BANDOBASTS": "BANDOBAST, (Urdu) an organisation, also BANDOBUST, BUNDOBUST [n]\n",
  "BANDOBUST": "(Urdu) (in India and Pakistan) an arrangement, also BANDOBAST, BUNDOBUST [n -S]\n",
  "BANDOBUSTS": "BANDOBUST, (Urdu) (in India and Pakistan) an arrangement, also BANDOBAST, BUNDOBUST [n]\n",
  "BANDOG": "a mastiff or other large and fierce dog [n -S]\n",
  "BANDOGS": "BANDOG, a mastiff or other large and fierce dog [n]\n",
  "BANDOLEER": "(French) a shoulder belt for carrying ammunition, also BANDELIER, BANDOLIER [n -S]\n",
  "BANDOLEERED": "wearing a bandoleer, also BANDOLIERED [adj]\n",
  "BANDOLEERS": "BANDOLEER, (French) a shoulder belt for carrying ammunition, also BANDELIER, BANDOLIER [n]\n",
  "BANDOLEON": "a kind of button accordion popular in South America, also BANDONEON, BANDONION [n -S]\n",
  "BANDOLEONS": "BANDOLEON, a kind of button accordion popular in South America, also BANDONEON, BANDONION [n]\n",
  "BANDOLERO": "(Spanish) a highwayman [n -S]\n",
  "BANDOLEROS": "BANDOLERO, (Spanish) a highwayman [n]\n",
  "BANDOLIER": "(French) a shoulder belt for carrying ammunition, also BANDELIER, BANDOLEER [n -S]\n",
  "BANDOLIERED": "wearing a bandolier, also BANDOLEERED [adj]\n",
  "BANDOLIERS": "BANDOLIER, (French) a shoulder belt for carrying ammunition, also BANDELIER, BANDOLEER [n]\n",
  "BANDOLINE": "(French) a glutinous pomatum for the hair [n -S] / to apply pomatum to the hair [v BANDOLINED, BANDOLINING, BANDOLINES]\n",
  "BANDOLINED": "BANDOLINE, to apply pomatum to the hair [v]\n",
  "BANDOLINES": "BANDOLINE, (French) a glutinous pomatum for the hair [n]\n",
  "BANDOLINING": "BANDOLINE, to apply pomatum to the hair [v]\n",
  "BANDONEON": "a kind of button accordion popular in South America, also BANDOLEON, BANDONION [n -S]\n",
  "BANDONEONS": "BANDONEON, a kind of button accordion popular in South America, also BANDOLEON, BANDONION [n]\n",
  "BANDONION": "a kind of button accordion popular in South America, also BANDOLEON, BANDONEON [n -S]\n",
  "BANDONIONS": "BANDONION, a kind of button accordion popular in South America, also BANDOLEON, BANDONEON [n]\n",
  "BANDOOK": "(Urdu) Indian army slang for a rifle, a shotgun, also BUNDOOK [n -S]\n",
  "BANDOOKS": "BANDOOK, (Urdu) Indian army slang for a rifle, a shotgun, also BUNDOOK [n]\n",
  "BANDORA": "(Spanish) an ancient lute, also BANDORE, PANDORA, PANDORE, PANDURA [n -S]\n",
  "BANDORAS": "BANDORA, (Spanish) an ancient lute, also BANDORE, PANDORA, PANDORE, PANDURA [n]\n",
  "BANDORE": "(Spanish) an ancient lute, also BANDORA, PANDORA, PANDORE, PANDURA [n -S]\n",
  "BANDORES": "BANDORE, (Spanish) an ancient lute, also BANDORA, PANDORA, PANDORE, PANDURA [n]\n",
  "BANDPASS": "the range of frequencies transmitted through a filter [n -ES]\n",
  "BANDPASSES": "BANDPASS, the range of frequencies transmitted through a filter [n]\n",
  "BANDROL": "a small banner or streamer, also BANDEROL, BANDEROLE, BANNERALL, BANNEROL [n -S]\n",
  "BANDROLS": "BANDROL, a small banner or streamer, also BANDEROL, BANDEROLE, BANNERALL, BANNEROL [n]\n",
  "BANDS": "BAND, to decorate with strips of material [v]\n",
  "BANDSAW": "a type of power saw with a continuous blade [n -S]\n",
  "BANDSAWED": "BANDSAW [v]\n",
  "BANDSAWING": "BANDSAW [v]\n",
  "BANDSAWS": "BANDSAW [v]\n",
  "BANDSHELL": "a bandstand concave at the back [n -S]\n",
  "BANDSHELLS": "BANDSHELL, a bandstand concave at the back [n]\n",
  "BANDSMAN": "a member of a band of musicians [n BANDSMEN]\n",
  "BANDSMEN": "BANDSMAN, a member of a band of musicians [n]\n",
  "BANDSPREADING": "an additional tuning control in some radio receivers whereby a selected narrow band of frequencies can be spread over a wider frequency band, in order to give finer control of tuning [n -S]\n",
  "BANDSPREADINGS": "BANDSPREADING, an additional tuning control in some radio receivers whereby a selected narrow band of frequencies can be spread over a wider frequency band, in order to give finer control of tuning [n]\n",
  "BANDSTAND": "a structure for accommodating a band of musicians [n -S]\n",
  "BANDSTANDS": "BANDSTAND, a structure for accommodating a band of musicians [n]\n",
  "BANDSTER": "a binder of sheaves after the reaper [n -S]\n",
  "BANDSTERS": "BANDSTER, a binder of sheaves after the reaper [n]\n",
  "BANDURA": "a twelve-stringed instrument of the lute family [n -S]\n",
  "BANDURAS": "BANDURA, a twelve-stringed instrument of the lute family [n]\n",
  "BANDURIST": "one who plays the bandura [n -S]\n",
  "BANDURISTS": "BANDURIST, one who plays the bandura [n]\n",
  "BANDWAGON": "a large wagon used by a band in a parade etc. [n -S]\n",
  "BANDWAGONS": "BANDWAGON, a large wagon used by a band in a parade etc. [n]\n",
  "BANDWIDTH": "the width of a band of radio or TV frequencies [n -S]\n",
  "BANDWIDTHS": "BANDWIDTH, the width of a band of radio or TV frequencies [n]\n",
  "BANDY": "to toss to and fro [v BANDIED, BANDYING, BANDIES] / having crooked legs [adj BANDIER, BANDIEST]\n",
  "BANDYING": "the act of bandying [n -S]\n",
  "BANDYINGS": "BANDYING, the act of bandying [n]\n",
  "BANDYMAN": "in India, one who drives a bandy, a carriage or bullock cart [n BANDYMEN]\n",
  "BANDYMEN": "BANDYMAN, in India, one who drives a bandy, a carriage or bullock cart [n]\n",
  "BANE": "an evil, a poison [n -S] / to kill with poison [v BANED, BANING, BANES]\n",
  "BANEBERRIES": "BANEBERRY, a black poisonous berry, the fruit of the plant Actaea spicata [n]\n",
  "BANEBERRY": "a black poisonous berry, the fruit of the plant Actaea spicata [n BANEBERRIES]\n",
  "BANED": "BANE, to kill with poison [v]\n",
  "BANEFUL": "poisonous [adj BANEFULLY]\n",
  "BANEFULLY": "BANEFUL, poisonous [adv]\n",
  "BANEFULNESS": "the state of being baneful [n -ES]\n",
  "BANEFULNESSES": "BANEFULNESS, the state of being baneful [n]\n",
  "BANES": "BANE, to kill with poison [v]\n",
  "BANG": "to make a loud, explosive noise [v -ED, -ING, -S]\n",
  "BANGALAY": "(Native Australian) an Australian myrtaceous tree with hard red wood [n -S]\n",
  "BANGALAYS": "BANGALAY, (Native Australian) an Australian myrtaceous tree with hard red wood [n]\n",
  "BANGALORE": "as in bangalore torpedo, an explosive device in a long metal tube, used for blowing holes in barbed wire [adj]\n",
  "BANGALOW": "(Native Australian) an Australian palm-tree [n -S]\n",
  "BANGALOWS": "BANGALOW, (Native Australian) an Australian palm-tree [n]\n",
  "BANGBELLIES": "BANGBELLY, (Canadian) a dense cake made of cooked rice, flour, molasses, raisins, salt pork, and spices [n]\n",
  "BANGBELLY": "(Canadian) a dense cake made of cooked rice, flour, molasses, raisins, salt pork, and spices [n BANGBELLIES]\n",
  "BANGED": "BANG, to make a loud, explosive noise [v]\n",
  "BANGER": "(colloquial) a sausage; an old car [n -S]\n",
  "BANGERS": "BANGER, (colloquial) a sausage; an old car [n]\n",
  "BANGING": "BANG, to make a loud, explosive noise [v]\n",
  "BANGKOK": "a straw hat [n -S]\n",
  "BANGKOKS": "BANGKOK, a straw hat [n]\n",
  "BANGLE": "(Hindi) a rigid ring as a bracelet or anklet [n -S]\n",
  "BANGLED": "wearing bangles [adj]\n",
  "BANGLES": "BANGLE, (Hindi) a rigid ring as a bracelet or anklet [n]\n",
  "BANGS": "BANG, to make a loud, explosive noise [v]\n",
  "BANGSRING": "(Javanese) a tree-shrew, an East Indian insectivorous mammal, also BANXRING [n -S]\n",
  "BANGSRINGS": "BANGSRING, (Javanese) a tree-shrew, an East Indian insectivorous mammal, also BANXRING [n]\n",
  "BANGSTER": "(Scots) a violent person [n -S]\n",
  "BANGSTERS": "BANGSTER, (Scots) a violent person [n]\n",
  "BANGTAIL": "a mustang or wild horse, whose tail hair is banged, i.e. with the end tuft squared [n -S]\n",
  "BANGTAILS": "BANGTAIL, a mustang or wild horse, whose tail hair is banged, i.e. with the end tuft squared [n]\n",
  "BANI": "BAN, a monetary unit of Romania [n]\n",
  "BANIA": "(Hindi) an Indian fig tree [n -S]\n",
  "BANIAN": "(Hindi) a Hindu trader [n -S]\n",
  "BANIANS": "BANIAN, (Hindi) a Hindu trader [n]\n",
  "BANIAS": "BANIA, (Hindi) an Indian fig tree [n]\n",
  "BANING": "BANE, to kill with poison [v]\n",
  "BANISH": "to expel, exile [v -ED, -ING, -ES]\n",
  "BANISHED": "BANISH, to expel, exile [v]\n",
  "BANISHER": "one that banishes [n -S]\n",
  "BANISHERS": "BANISHER, one that banishes [n]\n",
  "BANISHES": "BANISH, to expel, exile [v]\n",
  "BANISHING": "BANISH, to expel, exile [v]\n",
  "BANISHMENT": "the act of banishing, or the state of being banished [n -S]\n",
  "BANISHMENTS": "BANISHMENT, the act of banishing, or the state of being banished [n]\n",
  "BANISTER": "a stair handrail [n -S]\n",
  "BANISTERED": "having a banister [adj]\n",
  "BANISTERS": "BANISTER, a stair handrail [n]\n",
  "BANJAX": "(slang) to ruin, destroy [v BANJAXED, BANJAXING, BANJAXES]\n",
  "BANJAXED": "BANJAX, (slang) to ruin, destroy [v]\n",
  "BANJAXES": "BANJAX, (slang) to ruin, destroy [v]\n",
  "BANJAXING": "BANJAX, (slang) to ruin, destroy [v]\n",
  "BANJO": "a stringed musical instrument [n BANJOS or BANJOES]\n",
  "BANJOES": "BANJO, a stringed musical instrument [n]\n",
  "BANJOIST": "one who plays the banjo [n -S]\n",
  "BANJOISTS": "BANJOIST, one who plays the banjo [n]\n",
  "BANJOLELE": "a four-stringed musical instrument with a neck like a ukulele and a body like a banjo, also BANJULELE [n -S]\n",
  "BANJOLELES": "BANJOLELE, a four-stringed musical instrument with a neck like a ukulele and a body like a banjo, also BANJULELE [n]\n",
  "BANJOS": "BANJO, a stringed musical instrument [n]\n",
  "BANJULELE": "a small banjo with gut strings, also BANJOLELE [n -S]\n",
  "BANJULELES": "BANJULELE, a small banjo with gut strings, also BANJOLELE [n]\n",
  "BANK": "an institution for the keeping of money [n -S] / to deposit money for safe keeping in an institution [v -ED, -ING, -S]\n",
  "BANKABILITIES": "BANKABILITY, being bankable, reliable [n]\n",
  "BANKABILITY": "being bankable, reliable [n BANKABILITIES]\n",
  "BANKABLE": "able to be banked [adj]\n",
  "BANKBOOK": "a depositor's book [n -S]\n",
  "BANKBOOKS": "BANKBOOK, a depositor's book [n]\n",
  "BANKCARD": "a card issued by a bank allowing withdrawal of money etc. [n -S]\n",
  "BANKCARDS": "BANKCARD, a card issued by a bank allowing withdrawal of money etc. [n]\n",
  "BANKED": "BANK, to deposit money for safe keeping in an institution [v]\n",
  "BANKER": "a person who works in a bank [n -S]\n",
  "BANKERLIER": "BANKERLY, like a banker [adj]\n",
  "BANKERLIEST": "BANKERLY, like a banker [adj]\n",
  "BANKERLY": "like a banker [adj BANKERLIER, BANKERLIEST]\n",
  "BANKERS": "BANKER, a person who works in a bank [n]\n",
  "BANKET": "a gold-bearing conglomerate [n -S]\n",
  "BANKETS": "BANKET, a gold-bearing conglomerate [n]\n",
  "BANKING": "the business of a bank [n -S]\n",
  "BANKINGS": "BANKING, the business of a bank [n]\n",
  "BANKIT": "a raised sidewalk [n -S]\n",
  "BANKITS": "BANKIT, a raised sidewalk [n]\n",
  "BANKNOTE": "a paper unit of currency [n -S]\n",
  "BANKNOTES": "BANKNOTE, a paper unit of currency [n]\n",
  "BANKROLL": "to provide with financial support [v -ED, -ING, -S]\n",
  "BANKROLLED": "BANKROLL, to provide with financial support [v]\n",
  "BANKROLLER": "one who bankrolls [n -S]\n",
  "BANKROLLERS": "BANKROLLER, one who bankrolls [n]\n",
  "BANKROLLING": "BANKROLL, to provide with financial support [v]\n",
  "BANKROLLS": "BANKROLL, to provide with financial support [v]\n",
  "BANKRUPT": "to make insolvent [v -ED, -ING, -S]\n",
  "BANKRUPTCIES": "BANKRUPTCY, the state of being bankrupt [n]\n",
  "BANKRUPTCY": "the state of being bankrupt [n BANKRUPTCIES]\n",
  "BANKRUPTED": "BANKRUPT, to make insolvent [v]\n",
  "BANKRUPTING": "BANKRUPT, to make insolvent [v]\n",
  "BANKRUPTS": "BANKRUPT, to make insolvent [v]\n",
  "BANKS": "BANK, to deposit money for safe keeping in an institution [v]\n",
  "BANKSIA": "an evergreen, flowering shrub, native to Australia [n -S]\n",
  "BANKSIAS": "BANKSIA, an evergreen, flowering shrub, native to Australia [n]\n",
  "BANKSIDE": "the slope of a river bank [n -S]\n",
  "BANKSIDES": "BANKSIDE, the slope of a river bank [n]\n",
  "BANKSMAN": "an overseer of a pit mouth [n BANKSMEN]\n",
  "BANKSMEN": "BANKSMAN, an overseer of a pit mouth [n]\n",
  "BANKSTER": "a banker or investor whose financial practices have been exposed as illegal [n -S]\n",
  "BANKSTERS": "BANKSTER, a banker or investor whose financial practices have been exposed as illegal [n]\n",
  "BANLIEUE": "(French) a suburb [n -S]\n",
  "BANLIEUES": "BANLIEUE, (French) a suburb [n]\n",
  "BANNABLE": "able to be banned [adj]\n",
  "BANNED": "BAN, to forbid or prohibit [v]\n",
  "BANNER": "a square flag bearing a coat of arms [n -S] / to furnish with a flag [v -ED, -ING, -S]\n",
  "BANNERALL": "(Spenser) a small banner or streamer, also BANDEROL, BANDEROLE, BANDROL, BANNEROL [n -S]\n",
  "BANNERALLS": "BANNERALL, (Spenser) a small banner or streamer, also BANDEROL, BANDEROLE, BANDROL, BANNEROL [n]\n",
  "BANNERED": "BANNER, to furnish with a flag [v]\n",
  "BANNERET": "(historical) a knight of higher grade, originally one bringing vassals under his own banner [n -S]\n",
  "BANNERETS": "BANNERET, (historical) a knight of higher grade, originally one bringing vassals under his own banner [n]\n",
  "BANNERETTE": "a small banner [n -S]\n",
  "BANNERETTES": "BANNERETTE, a small banner [n]\n",
  "BANNERING": "BANNER, to furnish with a flag [v]\n",
  "BANNEROL": "a streamer, also BANDEROL [n -S]\n",
  "BANNEROLS": "BANNEROL, a streamer, also BANDEROL [n]\n",
  "BANNERS": "BANNER, to furnish with a flag [v]\n",
  "BANNET": "a bonnet [n -S]\n",
  "BANNETS": "BANNET, a bonnet [n]\n",
  "BANNING": "the act of imposing a ban [n -S]\n",
  "BANNINGS": "BANNING, the act of imposing a ban [n]\n",
  "BANNISTER": "any of the upright pillars supporting the handrail of a staircase; the whole structure of rail and uprights, also BANISTER [n -S]\n",
  "BANNISTERS": "BANNISTER, any of the upright pillars supporting the handrail of a staircase; the whole structure of rail and uprights, also BANISTER [n]\n",
  "BANNOCK": "(Scots) a flat oatmeal cake, also BONNOCK [n -S]\n",
  "BANNOCKS": "BANNOCK, (Scots) a flat oatmeal cake, also BONNOCK [n]\n",
  "BANNS": "a marriage notice [n]\n",
  "BANOFFEE": "banana and toffee as a pie filling, also BANOFFI [n -S]\n",
  "BANOFFEES": "BANOFFEE, banana and toffee as a pie filling, also BANOFFI [n]\n",
  "BANOFFI": "banana and toffee as a pie filling, also BANOFFEE [n -S]\n",
  "BANOFFIS": "BANOFFI, banana and toffee as a pie filling, also BANOFFEE [n]\n",
  "BANQUET": "to feast [v -ED, -ING, -S]\n",
  "BANQUETED": "BANQUET, to feast [v]\n",
  "BANQUETEER": "one who attends a banquet [n -S]\n",
  "BANQUETEERS": "BANQUETEER, one who attends a banquet [n]\n",
  "BANQUETER": "one who banquets [n -S]\n",
  "BANQUETERS": "BANQUETER, one who banquets [n]\n",
  "BANQUETING": "feasting [n -S]\n",
  "BANQUETINGS": "BANQUETING, feasting [n]\n",
  "BANQUETS": "BANQUET, to feast [v]\n",
  "BANQUETTE": "(French) a raised way or footway above a parapet, also BANKIT [n -S]\n",
  "BANQUETTES": "BANQUETTE, (French) a raised way or footway above a parapet, also BANKIT [n]\n",
  "BANS": "BAN, to forbid or prohibit [v]\n",
  "BANSELA": "(Zulu) a gratuity to a black South African, also BONSELA, BONSELLA, PASELA [n -S]\n",
  "BANSELAS": "BANSELA, (Zulu) a gratuity to a black South African, also BONSELA, BONSELLA, PASELA [n]\n",
  "BANSHEE": "(Irish) in Irish folklore, a female spirit who wails and shrieks before the death of a member of a family, also BANSHIE [n -S]\n",
  "BANSHEES": "BANSHEE, (Irish) in Irish folklore, a female spirit who wails and shrieks before the death of a member of a family, also BANSHIE [n]\n",
  "BANSHIE": "(Irish) in Irish folklore, a female spirit who wails and shrieks before the death of a member of a family, also BANSHEE [n -S]\n",
  "BANSHIES": "BANSHIE, (Irish) in Irish folklore, a female spirit who wails and shrieks before the death of a member of a family, also BANSHEE [n]\n",
  "BANT": "to diet [v -ED, -ING, -S]\n",
  "BANTAM": "a small variety of the common domestic fowl [n -S]\n",
  "BANTAMS": "BANTAM, a small variety of the common domestic fowl [n]\n",
  "BANTAMWEIGHT": "a weight category in boxing [n -S]\n",
  "BANTAMWEIGHTS": "BANTAMWEIGHT, a weight category in boxing [n]\n",
  "BANTED": "BANT, to diet [v]\n",
  "BANTENG": "(Malay) the wild ox of Java [n -S]\n",
  "BANTENGS": "BANTENG, (Malay) the wild ox of Java [n]\n",
  "BANTER": "to exchange mildly teasing remarks [v -ED, -ING, -S]\n",
  "BANTERED": "BANTER, to exchange mildly teasing remarks [v]\n",
  "BANTERER": "one who banters or rallies [n -S]\n",
  "BANTERERS": "BANTERER, one who banters or rallies [n]\n",
  "BANTERING": "the exchange of mildly teasing remarks [n -S]\n",
  "BANTERINGLY": "BANTERING [adv]\n",
  "BANTERINGS": "BANTERING, the exchange of mildly teasing remarks [n]\n",
  "BANTERS": "BANTER, to exchange mildly teasing remarks [v]\n",
  "BANTIES": "BANTY, a bantam [n]\n",
  "BANTING": "weight-reduction by avoiding fat, sugar and starch, also BANTINGISM [n -S]\n",
  "BANTINGISM": "slimming by avoiding food containing much farinaceous, saccharine, or oily matter, also BANTING [n -S]\n",
  "BANTINGISMS": "BANTINGISM, slimming by avoiding food containing much farinaceous, saccharine, or oily matter, also BANTING [n]\n",
  "BANTINGS": "BANTING, weight-reduction by avoiding fat, sugar and starch, also BANTINGISM [n]\n",
  "BANTLING": "(archaic) a baby, a very young child [n -S]\n",
  "BANTLINGS": "BANTLING, (archaic) a baby, a very young child [n]\n",
  "BANTS": "BANT, to diet [v]\n",
  "BANTU": "a group of African languages [n -S]\n",
  "BANTUS": "BANTU, a group of African languages [n]\n",
  "BANTY": "a bantam [n BANTIES]\n",
  "BANXRING": "(Javanese) a tree-shrew, an E. Indian insectivorous mammal, also BANGSRING [n -S]\n",
  "BANXRINGS": "BANXRING, (Javanese) a tree-shrew, an E. Indian insectivorous mammal, also BANGSRING [n]\n",
  "BANYA": "a Russian sauna-type bath [n -S]\n",
  "BANYAN": "(Hindi) an Indian fig tree with vast spreading branches; a Hindu trader, also BANIA, BANIAN [n -S]\n",
  "BANYANS": "BANYAN, (Hindi) an Indian fig tree with vast spreading branches; a Hindu trader, also BANIA, BANIAN [n]\n",
  "BANYAS": "BANYA, a Russian sauna-type bath [n]\n",
  "BANZAI": "(Japanese) a Japanese battle cry [n -S]\n",
  "BANZAIS": "BANZAI, (Japanese) a Japanese battle cry [n]\n",
  "BAO": "(Chinese) a steamed dumpling, usually eaten with a filling [n -S]\n",
  "BAOBAB": "an African tree with an enormously thick trunk and large edible pulpy fruit [n -S]\n",
  "BAOBABS": "BAOBAB, an African tree with an enormously thick trunk and large edible pulpy fruit [n]\n",
  "BAOS": "BAO, (Chinese) a steamed dumpling, usually eaten with a filling [n]\n",
  "BAP": "a large flat breakfast roll [n -S]\n",
  "BAPHOMETIC": "relating to Baphomet, a mysterious idol worshipped by the Templars [adj]\n",
  "BAPS": "BAP, a large flat breakfast roll [n]\n",
  "BAPTISE": "to administer baptism, also BAPTIZE [v BAPTISED, BAPTISING, BAPTISES]\n",
  "BAPTISED": "BAPTISE, to administer baptism, also BAPTIZE [v]\n",
  "BAPTISER": "one who baptizes, also BAPTIZER [n -S]\n",
  "BAPTISERS": "BAPTISER, one who baptizes, also BAPTIZER [n]\n",
  "BAPTISES": "BAPTISE, to administer baptism, also BAPTIZE [v]\n",
  "BAPTISIA": "a genus of North American leguminous plants [n -S]\n",
  "BAPTISIAS": "BAPTISIA, a genus of North American leguminous plants [n]\n",
  "BAPTISING": "BAPTISE, to administer baptism, also BAPTIZE [v]\n",
  "BAPTISM": "immersion in water as a religious ceremony [n -S]\n",
  "BAPTISMAL": "relating to baptism [adj BAPTISMALLY]\n",
  "BAPTISMALLY": "BAPTISMAL, relating to baptism [adv]\n",
  "BAPTISMS": "BAPTISM, immersion in water as a religious ceremony [n]\n",
  "BAPTIST": "one who baptises [n -S]\n",
  "BAPTISTERIES": "BAPTISTERY, a part of a church reserved for performing baptisms, also BAPTISTRY [n]\n",
  "BAPTISTERY": "a part of a church reserved for performing baptisms, also BAPTISTRY [n BAPTISTERIES]\n",
  "BAPTISTRIES": "BAPTISTRY, a part of church reserved for performing baptisms, also BAPTISTERY [n]\n",
  "BAPTISTRY": "a part of church reserved for performing baptisms, also BAPTISTERY [n BAPTISTRIES]\n",
  "BAPTISTS": "BAPTIST, one who baptises [n]\n",
  "BAPTIZE": "to administer baptism, also BAPTISE [v BAPTIZED, BAPTIZING, BAPTIZES]\n",
  "BAPTIZED": "BAPTIZE, to administer baptism, also BAPTISE [v]\n",
  "BAPTIZER": "one who baptizes, also BAPTISER [n -S]\n",
  "BAPTIZERS": "BAPTIZER, one who baptizes, also BAPTISER [n]\n",
  "BAPTIZES": "BAPTIZE, to administer baptism, also BAPTISE [v]\n",
  "BAPTIZING": "BAPTIZE, to administer baptism, also BAPTISE [v]\n",
  "BAPU": "(Hindi) a spiritual father [n -S]\n",
  "BAPUS": "BAPU, (Hindi) a spiritual father [n]\n",
  "BAR": "to obstruct or prevent [v BARRED, BARRING, BARS]\n",
  "BARACAN": "(French) a coarsely woven fabric of wool, silk, and goat's hair, also BARRACAN [n -S]\n",
  "BARACANS": "BARACAN, (French) a coarsely woven fabric of wool, silk, and goat's hair, also BARRACAN [n]\n",
  "BARACHOIS": "(French) a shallow lagoon formed by a sandbar, also BARRASWAY [n -ES]\n",
  "BARACHOISES": "BARACHOIS, (French) a shallow lagoon formed by a sandbar, also BARRASWAY [n]\n",
  "BARAESTHESIA": "the sense of pressure, also BARESTHESIA [n -S]\n",
  "BARAESTHESIAS": "BARAESTHESIA, the sense of pressure, also BARESTHESIA [n]\n",
  "BARAGOUIN": "(French) any jargon or unintelligible language [n -S]\n",
  "BARAGOUINS": "BARAGOUIN, (French) any jargon or unintelligible language [n]\n",
  "BARASINGA": "(Hindi) the Indian swamp-deer, also BARASINGHA [n -S]\n",
  "BARASINGAS": "BARASINGA, (Hindi) the Indian swamp-deer, also BARASINGHA [n]\n",
  "BARASINGHA": "(Hindi) the Indian swamp-deer, also BARASINGA [n -S]\n",
  "BARASINGHAS": "BARASINGHA, (Hindi) the Indian swamp-deer, also BARASINGA [n]\n",
  "BARATHEA": "a pebbly silk or worsted fabric with a broken rib weave [n -S]\n",
  "BARATHEAS": "BARATHEA, a pebbly silk or worsted fabric with a broken rib weave [n]\n",
  "BARATHRUM": "(Latin) an insatiable extortioner or glutton; (historical) a pit in Athens into which condemned criminals were thrown [n -S]\n",
  "BARATHRUMS": "BARATHRUM, (Latin) an insatiable extortioner or glutton; (historical) a pit in Athens into which condemned criminals were thrown [n]\n",
  "BARAZA": "(Swahili) in East Africa, a public meeting-place [n -S]\n",
  "BARAZAS": "BARAZA, (Swahili) in East Africa, a public meeting-place [n]\n",
  "BARB": "to pierce with a sharp point [v -ED, -ING, -S]\n",
  "BARBAL": "pertaining to the beard [adj]\n",
  "BARBARESQUE": "relating to Barbary, the country of the Berbers [adj]\n",
  "BARBARIAN": "a member of a primitive or uncivilized people; a coarse, insensitive, or uncultured person [n -S]\n",
  "BARBARIANISM": "the state of being a barbarian [n -S]\n",
  "BARBARIANISMS": "BARBARIANISM, the state of being a barbarian [n]\n",
  "BARBARIANS": "BARBARIAN, a member of a primitive or uncivilized people; a coarse, insensitive, or uncultured person [n]\n",
  "BARBARIC": "uncivilized [adj BARBARICALLY]\n",
  "BARBARICALLY": "BARBARIC, uncivilized [adv]\n",
  "BARBARISATION": "the act of barbarising, also BARBARIZATION [n -S]\n",
  "BARBARISATIONS": "BARBARISATION, the act of barbarising, also BARBARIZATION [n]\n",
  "BARBARISE": "to reduce to a state of barbarism, also BARBARIZE [v BARBARISED, BARBARISING, BARBARISES]\n",
  "BARBARISED": "BARBARISE, to reduce to a state of barbarism, also BARBARIZE [v]\n",
  "BARBARISES": "BARBARISE, to reduce to a state of barbarism, also BARBARIZE [v]\n",
  "BARBARISING": "BARBARISE, to reduce to a state of barbarism, also BARBARIZE [v]\n",
  "BARBARISM": "the state of being a barbarian [n -S]\n",
  "BARBARISMS": "BARBARISM, the state of being a barbarian [n]\n",
  "BARBARITIES": "BARBARITY, the state of being barbaric [n]\n",
  "BARBARITY": "the state of being barbaric [n BARBARITIES]\n",
  "BARBARIZATION": "the act of barbarizing, also BARBARISATION [n -S]\n",
  "BARBARIZATIONS": "BARBARIZATION, the act of barbarizing, also BARBARISATION [n]\n",
  "BARBARIZE": "to reduce to a state of barbarism, also BARBARISE [v BARBARIZED, BARBARIZING, BARBARIZES]\n",
  "BARBARIZED": "BARBARIZE, to reduce to a state of barbarism, also BARBARISE [v]\n",
  "BARBARIZES": "BARBARIZE, to reduce to a state of barbarism, also BARBARISE [v]\n",
  "BARBARIZING": "BARBARIZE, to reduce to a state of barbarism, also BARBARISE [v]\n",
  "BARBAROUS": "uncivilized [adj BARBAROUSLY]\n",
  "BARBAROUSLY": "BARBAROUS, uncivilized [adv]\n",
  "BARBAROUSNESS": "the state of being barbarous [n -ES]\n",
  "BARBAROUSNESSES": "BARBAROUSNESS, the state of being barbarous [n]\n",
  "BARBASCO": "(Spanish) any of a variety of South American plants, the roots of which are used to make fish-poison etc. [n BARBASCOS or BARBASCOES]\n",
  "BARBASCOES": "BARBASCO, (Spanish) any of a variety of South American plants, the roots of which are used to make fish-poison etc. [n]\n",
  "BARBASCOS": "BARBASCO, (Spanish) any of a variety of South American plants, the roots of which are used to make fish-poison etc. [n]\n",
  "BARBASTEL": "(French) a long-eared species of bat with hairy lips, also BARBASTELLE [n -S]\n",
  "BARBASTELLE": "(French) a long-eared species of bat with hairy lips, also BARBASTEL [n -S]\n",
  "BARBASTELLES": "BARBASTELLE, (French) a long-eared species of bat with hairy lips, also BARBASTEL [n]\n",
  "BARBASTELS": "BARBASTEL, (French) a long-eared species of bat with hairy lips, also BARBASTELLE [n]\n",
  "BARBATE": "barbed, bearded, also BARBATED [adj]\n",
  "BARBATED": "barbed, bearded, also BARBATE [adj]\n",
  "BARBE": "(French) a piece of vertically pleated linen cloth worn over or under the chin, as by nuns [n -S]\n",
  "BARBECUE": "to grill over an open fire, also BARBEQUE [v BARBECUED, BARBECUING, BARBECUES]\n",
  "BARBECUED": "BARBECUE, to grill over an open fire, also BARBEQUE [v]\n",
  "BARBECUER": "one who barbecues [n -S]\n",
  "BARBECUERS": "BARBECUER, one who barbecues [n]\n",
  "BARBECUES": "BARBECUE, to grill over an open fire, also BARBEQUE [v]\n",
  "BARBECUING": "BARBECUE, to grill over an open fire, also BARBEQUE [v]\n",
  "BARBED": "BARB, to pierce with a sharp point [v]\n",
  "BARBEL": "a fleshy appendage on head of certain fishes; a carp-like fish having a barbel [n -S]\n",
  "BARBELL": "a weightlifting bar [n -S]\n",
  "BARBELLATE": "having short, stiff hairs, often barbed at the point [adj]\n",
  "BARBELLS": "BARBELL, a weightlifting bar [n]\n",
  "BARBELS": "BARBEL, a fleshy appendage on head of certain fishes; a carp-like fish having a barbel [n]\n",
  "BARBEQUE": "to grill over an open fire, also BARBECUE [v BARBEQUED, BARBEQUING, BARBEQUES]\n",
  "BARBEQUED": "BARBEQUE, to grill over an open fire, also BARBECUE [v]\n",
  "BARBEQUES": "BARBEQUE, to grill over an open fire, also BARBECUE [v]\n",
  "BARBEQUING": "BARBEQUE, to grill over an open fire, also BARBECUE [v]\n",
  "BARBER": "to shave or cut the hair [v -ED, -ING, -S]\n",
  "BARBERED": "BARBER, to shave or cut the hair [v]\n",
  "BARBERING": "BARBER, to shave or cut the hair [v]\n",
  "BARBERRIES": "BARBERRY, a thorny shrub of the genus Berberis, common along roadsides and in neglected fields [n]\n",
  "BARBERRY": "a thorny shrub of the genus Berberis, common along roadsides and in neglected fields [n BARBERRIES]\n",
  "BARBERS": "BARBER, to shave or cut the hair [v]\n",
  "BARBERSHOP": "a type of music originating in the US, played, or esp. sung, in close chromatic harmony [n -S]\n",
  "BARBERSHOPS": "BARBERSHOP, a type of music originating in the US, played, or esp. sung, in close chromatic harmony [n]\n",
  "BARBES": "BARBE, (French) a piece of vertically pleated linen cloth worn over or under the chin, as by nuns [n]\n",
  "BARBET": "(French) a variety of small dog, having long curly hair [n -S]\n",
  "BARBETS": "BARBET, (French) a variety of small dog, having long curly hair [n]\n",
  "BARBETTE": "(French) an earthen terrace inside the parapet of a rampart, acting as a platform for guns [n -S]\n",
  "BARBETTES": "BARBETTE, (French) an earthen terrace inside the parapet of a rampart, acting as a platform for guns [n]\n",
  "BARBICAN": "an outer defensive work; esp. a tower at a gate or bridge [n -S]\n",
  "BARBICANS": "BARBICAN, an outer defensive work; esp. a tower at a gate or bridge [n]\n",
  "BARBICEL": "one of the small hooklike processes on the barbules of feathers [n -S]\n",
  "BARBICELS": "BARBICEL, one of the small hooklike processes on the barbules of feathers [n]\n",
  "BARBIE": "(Australian slang) a barbecue, also BARBY [n -S]\n",
  "BARBIES": "BARBIE, (Australian slang) a barbecue, also BARBY [n]\n",
  "BARBING": "BARB, to pierce with a sharp point [v]\n",
  "BARBITAL": "(US) a derivative of barbituric acid used as a sedative, also BARBITONE [n -S]\n",
  "BARBITALS": "BARBITAL, (US) a derivative of barbituric acid used as a sedative, also BARBITONE [n]\n",
  "BARBITONE": "a sleep-inducing drug, aka veronal, also BARBITAL [n -S]\n",
  "BARBITONES": "BARBITONE, a sleep-inducing drug, aka veronal, also BARBITAL [n]\n",
  "BARBITURATE": "a sleeping drug [n -S]\n",
  "BARBITURATES": "BARBITURATE, a sleeping drug [n]\n",
  "BARBITURIC": "denoting an acid got from malonic acid and urea, a source of important sedatives [adj]\n",
  "BARBLESS": "having no barbs [adj]\n",
  "BARBOLA": "an ornamentation of small flowers, fruit etc. made of plastic paste and coloured [n -S]\n",
  "BARBOLAS": "BARBOLA, an ornamentation of small flowers, fruit etc. made of plastic paste and coloured [n]\n",
  "BARBOT": "a kind of large catfish, also BARBOTTE [n -S]\n",
  "BARBOTINE": "(French) a paste of clay used in decorating coarse pottery in relief [n -S]\n",
  "BARBOTINES": "BARBOTINE, (French) a paste of clay used in decorating coarse pottery in relief [n]\n",
  "BARBOTS": "BARBOT, a kind of large catfish, also BARBOTTE [n]\n",
  "BARBOTTE": "a kind of large catfish, also BARBOT, BURBOT [n -S]\n",
  "BARBOTTES": "BARBOTTE, a kind of large catfish, also BARBOT, BURBOT [n]\n",
  "BARBS": "BARB, to pierce with a sharp point [v]\n",
  "BARBULE": "a small barb [n -S]\n",
  "BARBULES": "BARBULE, a small barb [n]\n",
  "BARBUT": "a type of helmet [n -S]\n",
  "BARBUTS": "BARBUT, a type of helmet [n]\n",
  "BARBWIRE": "(US) barbed wire [n -S]\n",
  "BARBWIRES": "BARBWIRE, (US) barbed wire [n]\n",
  "BARBY": "(Australian slang) a barbecue, also BARBIE [n BARBIES]\n",
  "BARCA": "(Italian) a boat, a barge [n -S]\n",
  "BARCAROLE": "(French) a gondolier's song, also BARCAROLLE [n -S]\n",
  "BARCAROLES": "BARCAROLE, (French) a gondolier's song, also BARCAROLLE [n]\n",
  "BARCAROLLE": "(French) a gondolier's song, also BARCAROLE [n -S]\n",
  "BARCAROLLES": "BARCAROLLE, (French) a gondolier's song, also BARCAROLE [n]\n",
  "BARCAS": "BARCA, (Italian) a boat, a barge [n]\n",
  "BARCHAN": "(Turkish) a crescent-shaped sand dune, also BARKHAN, BARCHANE, BARKAN [n -S]\n",
  "BARCHANE": "(Turkish) a crescent-shaped sand dune, also BARKHAN, BARCHAN, BARKAN [n -S]\n",
  "BARCHANES": "BARCHANE, (Turkish) a crescent-shaped sand dune, also BARKHAN, BARCHAN, BARKAN [n]\n",
  "BARCHANS": "BARCHAN, (Turkish) a crescent-shaped sand dune, also BARKHAN, BARCHANE, BARKAN [n]\n",
  "BARCODE": "an arrangement, readable by computer, of thick and thin parallel lines, e.g. printed on, and giving coded details of, goods at a point of sale, library books, etc. [n -S]\n",
  "BARCODED": "marked with a BARCODE [adj]\n",
  "BARCODES": "BARCODE, an arrangement, readable by computer, of thick and thin parallel lines, e.g. printed on, and giving coded details of, goods at a point of sale, library books, etc. [n]\n",
  "BARD": "to cover a horse with armour, also BARDE [v -ED, -ING, -S]\n",
  "BARDASH": "(obsolete) a homosexual male, a catamite [n -ES]\n",
  "BARDASHES": "BARDASH, (obsolete) a homosexual male, a catamite [n]\n",
  "BARDE": "to cover a horse with armour, also BARD [v BARDED, BARDING, BARDES]\n",
  "BARDED": "BARDE, to cover a horse with armour, also BARD [v]\n",
  "BARDES": "BARDE, to cover a horse with armour, also BARD [v]\n",
  "BARDIC": "pertaining to a bard, poetic [adj]\n",
  "BARDIE": "(Native Australian) an Australian wood-boring grub [n -S]\n",
  "BARDIER": "BARDY, (Scots) scolding, impudent [adj]\n",
  "BARDIES": "BARDIE, (Native Australian) an Australian wood-boring grub [n]\n",
  "BARDIEST": "BARDY, (Scots) scolding, impudent [adj]\n",
  "BARDING": "BARDE, to cover a horse with armour, also BARD [v]\n",
  "BARDISM": "the study of the music and wisdom of bards [n -S]\n",
  "BARDISMS": "BARDISM, the study of the music and wisdom of bards [n]\n",
  "BARDLING": "a petty poet [n -S]\n",
  "BARDLINGS": "BARDLING, a petty poet [n]\n",
  "BARDO": "in Tibetan Buddhism, the intermediate stage between death and rebirth [n -S]\n",
  "BARDOLATER": "a person who idolizes Shakespeare [n -S]\n",
  "BARDOLATERS": "BARDOLATER, a person who idolizes Shakespeare [n]\n",
  "BARDOLATRIES": "BARDOLATRY, excessive devotion to or worship of Shakespeare [n]\n",
  "BARDOLATROUS": "showing bardolatry, excessive devotion to or worship of Shakespeare [adj]\n",
  "BARDOLATRY": "excessive devotion to or worship of Shakespeare [n BARDOLATRIES]\n",
  "BARDOS": "BARDO, in Tibetan Buddhism, the intermediate stage between death and rebirth [n]\n",
  "BARDS": "BARD, to cover a horse with armour, also BARDE [v]\n",
  "BARDSHIP": "the office of a bard [n -S]\n",
  "BARDSHIPS": "BARDSHIP, the office of a bard [n]\n",
  "BARDY": "(Scots) scolding, impudent [adj BARDIER, BARDIEST]\n",
  "BARE": "unclothed, uncovered [adj BARER, BAREST, BARELY] / to make bare [v BARED, BARING, BARES]\n",
  "BAREBACK": "without a saddle [adv] / to have unprotected sex [v -ED, -ING, -S]\n",
  "BAREBACKED": "BAREBACK, to have unprotected sex [v]\n",
  "BAREBACKING": "the act of practising unprotected sex [n -S]\n",
  "BAREBACKINGS": "BAREBACKING, the act of practising unprotected sex [n]\n",
  "BAREBACKS": "BAREBACK, to have unprotected sex [v]\n",
  "BAREBOAT": "a pleasure-boat rented without personnel [n -S]\n",
  "BAREBOATS": "BAREBOAT, a pleasure-boat rented without personnel [n]\n",
  "BAREBONE": "(Shakespeare) a very lean person; one whose bones show through the skin [n -S]\n",
  "BAREBONED": "short of resources [adj]\n",
  "BAREBONES": "BAREBONE, (Shakespeare) a very lean person; one whose bones show through the skin [n]\n",
  "BARED": "BARE, to make bare [v]\n",
  "BAREFACED": "blatant, undisguised [adj BAREFACEDLY]\n",
  "BAREFACEDLY": "BAREFACED, blatant, undisguised [adv]\n",
  "BAREFACEDNESS": "the state of being barefaced [n -ES]\n",
  "BAREFACEDNESSES": "BAREFACEDNESS, the state of being barefaced [n]\n",
  "BAREFIT": "(Scots) barefoot [adj]\n",
  "BAREFOOT": "being without shoes [adj]\n",
  "BAREFOOTED": "without footwear, also BAREFIT, BAREFOOT [adj]\n",
  "BAREGE": "(French) a light silky dress fabric [n -S]\n",
  "BAREGES": "BAREGE, (French) a light silky dress fabric [n]\n",
  "BAREGINE": "(French) a gelatinous mass of bacteria and sulphur found in mineral waters [n -S]\n",
  "BAREGINES": "BAREGINE, (French) a gelatinous mass of bacteria and sulphur found in mineral waters [n]\n",
  "BAREHAND": "to field the ball in baseball with bare hands rather than with gloves [v -ED, -ING, -S]\n",
  "BAREHANDED": "BAREHAND, to field the ball in baseball with bare hands rather than with gloves [v]\n",
  "BAREHANDING": "BAREHAND, to field the ball in baseball with bare hands rather than with gloves [v]\n",
  "BAREHANDS": "BAREHAND, to field the ball in baseball with bare hands rather than with gloves [v]\n",
  "BAREHEAD": "having the head uncovered, also BAREHEADED [adj]\n",
  "BAREHEADED": "having the head uncovered, also BAREHEAD [adj]\n",
  "BARELAND": "as in bareland croft, a croft with no croft house [adj]\n",
  "BARELEGGED": "having the legs bare [adj]\n",
  "BARELY": "BARE, unclothed, uncovered [adv]\n",
  "BARENESS": "the state of being bare [n -ES]\n",
  "BARENESSES": "BARENESS, the state of being bare [n]\n",
  "BARER": "BARE, unclothed, uncovered [adj]\n",
  "BARES": "BARE, to make bare [v]\n",
  "BARESARK": "(Old Norse) a Norse warrior who fought without armour, or shirt of mail, also BERSERK, BERSERKER [n -S]\n",
  "BARESARKS": "BARESARK, (Old Norse) a Norse warrior who fought without armour, or shirt of mail, also BERSERK, BERSERKER [n]\n",
  "BAREST": "BARE, unclothed, uncovered [adj]\n",
  "BARESTHESIA": "the sense of pressure, also BARAESTHESIA [n -S]\n",
  "BARESTHESIAS": "BARESTHESIA, the sense of pressure, also BARAESTHESIA [n]\n",
  "BARF": "(colloquial) to vomit [v -ED, -ING, -S]\n",
  "BARFED": "BARF, (colloquial) to vomit [v]\n",
  "BARFI": "(Hindi) an Indian dessert made from milk solids and sugar, also BURFI [n -S]\n",
  "BARFING": "BARF, (colloquial) to vomit [v]\n",
  "BARFIS": "BARFI, (Hindi) an Indian dessert made from milk solids and sugar, also BURFI [n]\n",
  "BARFLIES": "BARFLY, a drinker who frequents bars [n]\n",
  "BARFLY": "a drinker who frequents bars [n BARFLIES]\n",
  "BARFS": "BARF, (colloquial) to vomit [v]\n",
  "BARFUL": "full of obstructions [adj]\n",
  "BARGAIN": "to haggle over costs [v -ED, -ING, -S]\n",
  "BARGAINED": "BARGAIN, to haggle over costs [v]\n",
  "BARGAINER": "one who bargains [n -S]\n",
  "BARGAINERS": "BARGAINER, one who bargains [n]\n",
  "BARGAINING": "the act of bargaining [n -S]\n",
  "BARGAININGS": "BARGAINING, the act of bargaining [n]\n",
  "BARGAINS": "BARGAIN, to haggle over costs [v]\n",
  "BARGANDER": "the shelduck, also BERGANDER [n -S]\n",
  "BARGANDERS": "BARGANDER, the shelduck, also BERGANDER [n]\n",
  "BARGE": "to push one's way rudely [v BARGED, BARGING, BARGES]\n",
  "BARGEBOARD": "a board projecting from a roof gable [n -S]\n",
  "BARGEBOARDS": "BARGEBOARD, a board projecting from a roof gable [n]\n",
  "BARGED": "BARGE, to push one's way rudely [v]\n",
  "BARGEE": "a bargeman [n -S]\n",
  "BARGEES": "BARGEE, a bargeman [n]\n",
  "BARGEESE": "BARGOOSE, a kind of wild goose [n]\n",
  "BARGELIKE": "like a barge [adj]\n",
  "BARGELLO": "(Italian) a type of needlework stitch that makes a zigzag pattern [n -S]\n",
  "BARGELLOS": "BARGELLO, (Italian) a type of needlework stitch that makes a zigzag pattern [n]\n",
  "BARGEMAN": "a man who manages a barge, or one of the crew of a barge [n BARGEMEN]\n",
  "BARGEMASTER": "one in charge of a barge [n -S]\n",
  "BARGEMASTERS": "BARGEMASTER, one in charge of a barge [n]\n",
  "BARGEMEN": "BARGEMAN, a man who manages a barge, or one of the crew of a barge [n]\n",
  "BARGEPOLE": "a pole for propelling a barge [n -S]\n",
  "BARGEPOLES": "BARGEPOLE, a pole for propelling a barge [n]\n",
  "BARGES": "BARGE, to push one's way rudely [v]\n",
  "BARGEST": "a doglike goblin whose appearance portends death, also BARGHEST, BARGUEST [n -S]\n",
  "BARGESTS": "BARGEST, a doglike goblin whose appearance portends death, also BARGHEST, BARGUEST [n]\n",
  "BARGHEST": "a doglike goblin whose appearance portends death, also BARGEST, BARGUEST [n -S]\n",
  "BARGHESTS": "BARGHEST, a doglike goblin whose appearance portends death, also BARGEST, BARGUEST [n]\n",
  "BARGING": "BARGE, to push one's way rudely [v]\n",
  "BARGOON": "(Canadian slang) a bargain [n -S]\n",
  "BARGOONS": "BARGOON, (Canadian slang) a bargain [n]\n",
  "BARGOOSE": "a kind of wild goose [n BARGEESE]\n",
  "BARGUEST": "a doglike goblin whose appearance portends death, also BARGEST, BARGHEST [n -S]\n",
  "BARGUESTS": "BARGUEST, a doglike goblin whose appearance portends death, also BARGEST, BARGHEST [n]\n",
  "BARHOP": "to go from one bar to another [v BARHOPPED, BARHOPPING, BARHOPS]\n",
  "BARHOPPED": "BARHOP, to go from one bar to another [v]\n",
  "BARHOPPING": "BARHOP, to go from one bar to another [v]\n",
  "BARHOPS": "BARHOP, to go from one bar to another [v]\n",
  "BARIATRIC": "relating to the treatment of obesity [adj]\n",
  "BARIATRICS": "the medical treatment of obesity [n]\n",
  "BARIC": "of or containing barium [adj]\n",
  "BARILLA": "(Spanish) the alkali plant; an impure alkali made by burning this [n -S]\n",
  "BARILLAS": "BARILLA, (Spanish) the alkali plant; an impure alkali made by burning this [n]\n",
  "BARING": "BARE, to make bare [v]\n",
  "BARISH": "somewhat bare [adj]\n",
  "BARISTA": "one who makes and serves coffee to the public [n -S]\n",
  "BARISTAS": "BARISTA, one who makes and serves coffee to the public [n]\n",
  "BARITE": "a native sulphate of barium, also BARYTE [n -S]\n",
  "BARITES": "BARITE, a native sulphate of barium, also BARYTE [n]\n",
  "BARITONAL": "of or like a baritone [adj]\n",
  "BARITONE": "a deep male voice, also BARYTONE [n -S]\n",
  "BARITONES": "BARITONE, a deep male voice, also BARYTONE [n]\n",
  "BARIUM": "a metallic element [n -S]\n",
  "BARIUMS": "BARIUM, a metallic element [n]\n",
  "BARK": "to make a sound like a dog [v -ED, -ING, -S]\n",
  "BARKAN": "(Turkish) a crescent-shaped sand dune, also BARKHAN, BARCHAN, BARCHANE [n -S]\n",
  "BARKANS": "BARKAN, (Turkish) a crescent-shaped sand dune, also BARKHAN, BARCHAN, BARCHANE [n]\n",
  "BARKANTINE": "a three-masted vessel, with the foremast square-rigged, and the mainmast and mizzenmast fore-and-aft-rigged, also BARKENTINE, BARQUANTINE, BARQUENTINE [n -S]\n",
  "BARKANTINES": "BARKANTINE, a three-masted vessel, with the foremast square-rigged, and the mainmast and mizzenmast fore-and-aft-rigged, also BARKENTINE, BARQUANTINE, BARQUENTINE [n]\n",
  "BARKED": "BARK, to make a sound like a dog [v]\n",
  "BARKEEP": "(US) a bartender [n -S]\n",
  "BARKEEPER": "a bartender [n -S]\n",
  "BARKEEPERS": "BARKEEPER, a bartender [n]\n",
  "BARKEEPS": "BARKEEP, (US) a bartender [n]\n",
  "BARKEN": "to dry up in a barky crust [v -ED, -ING, -S]\n",
  "BARKENED": "BARKEN, to dry up in a barky crust [v]\n",
  "BARKENING": "BARKEN, to dry up in a barky crust [v]\n",
  "BARKENS": "BARKEN, to dry up in a barky crust [v]\n",
  "BARKENTINE": "a three-masted vessel, with the foremast square-rigged, and the mainmast and mizzenmast fore-and-aft-rigged, also BARKANTINE, BARQUANTINE, BARQUENTINE [n -S]\n",
  "BARKENTINES": "BARKENTINE, a three-masted vessel, with the foremast square-rigged, and the mainmast and mizzenmast fore-and-aft-rigged, also BARKANTINE, BARQUANTINE, BARQUENTINE [n]\n",
  "BARKER": "(slang) a pistol [n -S]\n",
  "BARKERS": "BARKER, (slang) a pistol [n]\n",
  "BARKHAN": "(Turkish) a crescent-shaped sand dune, also BARCHAN, BARCHANE, BARKAN [n -S]\n",
  "BARKHANS": "BARKHAN, (Turkish) a crescent-shaped sand dune, also BARCHAN, BARCHANE, BARKAN [n]\n",
  "BARKIER": "BARKY, having a tough outer covering [adj]\n",
  "BARKIEST": "BARKY, having a tough outer covering [adj]\n",
  "BARKING": "BARK, to make a sound like a dog [v]\n",
  "BARKLESS": "having no bark [adj]\n",
  "BARKLIKE": "like a dog's bark [adj]\n",
  "BARKS": "BARK, to make a sound like a dog [v]\n",
  "BARKY": "having a tough outer covering [adj BARKIER, BARKIEST]\n",
  "BARLEDUC": "a kind of gooseberry jam [n -S]\n",
  "BARLEDUCS": "BARLEDUC, a kind of gooseberry jam [n]\n",
  "BARLESS": "without a bar [adj]\n",
  "BARLEY": "a cereal grass [n -S]\n",
  "BARLEYCORN": "an old unit of length equal to one-third inch [n -S]\n",
  "BARLEYCORNS": "BARLEYCORN, an old unit of length equal to one-third inch [n]\n",
  "BARLEYS": "BARLEY, a cereal grass [n]\n",
  "BARLOW": "a jackknife [n -S]\n",
  "BARLOWS": "BARLOW, a jackknife [n]\n",
  "BARM": "the froth of malt liquors [n -S]\n",
  "BARMAID": "a female bartender [n -S]\n",
  "BARMAIDS": "BARMAID, a female bartender [n]\n",
  "BARMAN": "a male bartender [n BARMEN]\n",
  "BARMBRACK": "(Irish) a currant bun, also BARNBRACK [n -S]\n",
  "BARMBRACKS": "BARMBRACK, (Irish) a currant bun, also BARNBRACK [n]\n",
  "BARMEN": "BARMAN, a male bartender [n]\n",
  "BARMIE": "foamy; dotty, also BARMY [adj BARMIER, BARMIEST]\n",
  "BARMIER": "BARMIE, foamy; dotty, also BARMY [adj]\n",
  "BARMIEST": "BARMIE, foamy; dotty, also BARMY [adj]\n",
  "BARMILY": "BARMY, foamy, dotty, also BARMIE [adv]\n",
  "BARMINESS": "the state of being barmy, dotty [n -ES]\n",
  "BARMINESSES": "BARMINESS, the state of being barmy, dotty [n]\n",
  "BARMITSVAH": "(Hebrew) in the Jewish religion, a boy attaining the age (usually 13) of religious responsibility, also BARMITZVAH [n -S]\n",
  "BARMITSVAHS": "BARMITSVAH, (Hebrew) in the Jewish religion, a boy attaining the age (usually 13) of religious responsibility, also BARMITZVAH [n]\n",
  "BARMITZVAH": "(Hebrew) in the Jewish religion, a boy attaining the age (usually 13) of religious responsibility, also BARMITSVAH [n -S]\n",
  "BARMITZVAHS": "BARMITZVAH, (Hebrew) in the Jewish religion, a boy attaining the age (usually 13) of religious responsibility, also BARMITSVAH [n]\n",
  "BARMKIN": "(archaic) a battlement or turret on the outer wall of a castle [n -S]\n",
  "BARMKINS": "BARMKIN, (archaic) a battlement or turret on the outer wall of a castle [n]\n",
  "BARMPOT": "an idiot, fool, also BAMPOT [n -S]\n",
  "BARMPOTS": "BARMPOT, an idiot, fool, also BAMPOT [n]\n",
  "BARMS": "BARM, the froth of malt liquors [n]\n",
  "BARMY": "foamy, dotty, also BARMIE [adj BARMIER, BARMIEST, BARMILY]\n",
  "BARN": "a building for storing hay, straw etc. [n -S] / to store in a large storage building [v -ED, -ING, -S]\n",
  "BARNACLE": "a kind of crustacean that adheres to rocks and ship bottoms [n -S]\n",
  "BARNACLED": "wearing spectacles [adj]\n",
  "BARNACLES": "BARNACLE, a kind of crustacean that adheres to rocks and ship bottoms [n]\n",
  "BARNBOARD": "wide softwood boards that have not been planed, used especially for building barns [n -S]\n",
  "BARNBOARDS": "BARNBOARD, wide softwood boards that have not been planed, used especially for building barns [n]\n",
  "BARNBRACK": "(Irish) a currant bun, also BARMBRACK [n -S]\n",
  "BARNBRACKS": "BARNBRACK, (Irish) a currant bun, also BARMBRACK [n]\n",
  "BARNED": "BARN, to store in a large storage building [v]\n",
  "BARNET": "(slang) hair [n -S]\n",
  "BARNETS": "BARNET, (slang) hair [n]\n",
  "BARNEY": "a loud quarrel [n -S] / to quarrel loudly [v -ED, -ING, -S]\n",
  "BARNEYED": "BARNEY, to quarrel loudly [v]\n",
  "BARNEYING": "BARNEY, to quarrel loudly [v]\n",
  "BARNEYS": "BARNEY, to quarrel loudly [v]\n",
  "BARNIER": "BARNY, like a barn [adj]\n",
  "BARNIEST": "BARNY, like a barn [adj]\n",
  "BARNING": "BARN, to store in a large storage building [v]\n",
  "BARNLIKE": "like a barn [adj]\n",
  "BARNS": "BARN, to store in a large storage building [v]\n",
  "BARNSBREAKING": "(Scots) a boisterous frolic; an injurious or mischievous activity [n -S]\n",
  "BARNSBREAKINGS": "BARNSBREAKING, (Scots) a boisterous frolic; an injurious or mischievous activity [n]\n",
  "BARNSTORM": "to tour country areas giving theatrical performances [v -ED, -ING, -S]\n",
  "BARNSTORMED": "BARNSTORM, to tour country areas giving theatrical performances [v]\n",
  "BARNSTORMER": "one who barnstorms [n -S]\n",
  "BARNSTORMERS": "BARNSTORMER, one who barnstorms [n]\n",
  "BARNSTORMING": "touring country areas giving theatrical performances [n -S]\n",
  "BARNSTORMINGS": "BARNSTORMING, touring country areas giving theatrical performances [n]\n",
  "BARNSTORMS": "BARNSTORM, to tour country areas giving theatrical performances [v]\n",
  "BARNWOOD": "a wide wood for building barns [n -S]\n",
  "BARNWOODS": "BARNWOOD, a wide wood for building barns [n]\n",
  "BARNY": "like a barn [adj BARNIER, BARNIEST]\n",
  "BARNYARD": "a yard near a barn [n -S]\n",
  "BARNYARDS": "BARNYARD, a yard near a barn [n]\n",
  "BAROCCO": "(Italian) a bold decorative style, also BAROQUE, BAROCK [n -S]\n",
  "BAROCCOS": "BAROCCO, (Italian) a bold decorative style, also BAROQUE, BAROCK [n]\n",
  "BAROCEPTOR": "a sensory receptor sensitive to a pressure stimulus [n -S]\n",
  "BAROCEPTORS": "BAROCEPTOR, a sensory receptor sensitive to a pressure stimulus [n]\n",
  "BAROCK": "a bold decorative style, also BAROQUE, BAROCCO [n -S]\n",
  "BAROCKS": "BAROCK, a bold decorative style, also BAROQUE, BAROCCO [n]\n",
  "BARODYNAMICS": "the science of the support and mechanics of bridges [n]\n",
  "BAROGNOSES": "BAROGNOSIS, the ability to judge weight [n]\n",
  "BAROGNOSIS": "the ability to judge weight [n BAROGNOSES]\n",
  "BAROGRAM": "a recording made by a barograph, an instrument for recording air pressure [n -S]\n",
  "BAROGRAMS": "BAROGRAM, a recording made by a barograph, an instrument for recording air pressure [n]\n",
  "BAROGRAPH": "a recording barometer [n -S]\n",
  "BAROGRAPHIC": "relating to the measurement of pressure [adj]\n",
  "BAROGRAPHS": "BAROGRAPH, a recording barometer [n]\n",
  "BAROLO": "(Italian) a red Italian wine [n -S]\n",
  "BAROLOS": "BAROLO, (Italian) a red Italian wine [n]\n",
  "BAROMETER": "an instrument for measuring atmospheric pressure [n -S]\n",
  "BAROMETERS": "BAROMETER, an instrument for measuring atmospheric pressure [n]\n",
  "BAROMETRIC": "as measured by a barometer, also BAROMETRICAL [adj BAROMETRICALLY]\n",
  "BAROMETRICAL": "as measured by a barometer, also BAROMETRIC [adj BAROMETRICALLY]\n",
  "BAROMETRICALLY": "BAROMETRICAL, as measured by a barometer, also BAROMETRIC [adv]\n",
  "BAROMETRIES": "BAROMETRY, the art or process of making barometrical measurements [n]\n",
  "BAROMETRY": "the art or process of making barometrical measurements [n BAROMETRIES]\n",
  "BAROMETZ": "(Russian) a fabulous Russian creature, half plant and half sheep [n -ES]\n",
  "BAROMETZES": "BAROMETZ, (Russian) a fabulous Russian creature, half plant and half sheep [n]\n",
  "BARON": "a lower member of the nobility [n -S]\n",
  "BARONAGE": "the rank of a baron [n -S]\n",
  "BARONAGES": "BARONAGE, the rank of a baron [n]\n",
  "BARONESS": "the wife of a baron [n -ES]\n",
  "BARONESSES": "BARONESS, the wife of a baron [n]\n",
  "BARONET": "the lowest British hereditary title [n -S]\n",
  "BARONETAGE": "the title of baronet [n -S]\n",
  "BARONETAGES": "BARONETAGE, the title of baronet [n]\n",
  "BARONETCIES": "BARONETCY, the office of a baronet [n]\n",
  "BARONETCY": "the office of a baronet [n BARONETCIES]\n",
  "BARONETESS": "a female baronet [n -ES]\n",
  "BARONETESSES": "BARONETESS, a female baronet [n]\n",
  "BARONETICAL": "of or like a baronet [adj]\n",
  "BARONETS": "BARONET, the lowest British hereditary title [n]\n",
  "BARONG": "a broad-bladed Philippine knife [n -S]\n",
  "BARONGS": "BARONG, a broad-bladed Philippine knife [n]\n",
  "BARONIAL": "relating to a baron or barony [adj]\n",
  "BARONIES": "BARONY, the territory of a baron [n]\n",
  "BARONNE": "(French) a baroness [n -S]\n",
  "BARONNES": "BARONNE, (French) a baroness [n]\n",
  "BARONS": "BARON, a lower member of the nobility [n]\n",
  "BARONY": "the territory of a baron [n BARONIES]\n",
  "BAROPHILE": "a bacterium able to tolerate high atmospheric pressure [n -S]\n",
  "BAROPHILES": "BAROPHILE, a bacterium able to tolerate high atmospheric pressure [n]\n",
  "BAROPHILIC": "of bacteria, able to tolerate or growing best in conditions of high atmospheric pressure, also BAROPHILE [adj]\n",
  "BAROPHORESES": "BAROPHORESIS, the diffusion of suspended particles at a rate dependent on external forces [n]\n",
  "BAROPHORESIS": "the diffusion of suspended particles at a rate dependent on external forces [n BAROPHORESES]\n",
  "BAROQUE": "(French) a bold decorative style, also BAROCCO, BAROCK [n -S] / in baroque style [adj BAROQUELY]\n",
  "BAROQUELY": "BAROQUE, in baroque style [adv]\n",
  "BAROQUES": "BAROQUE, (French) a bold decorative style, also BAROCCO, BAROCK [n]\n",
  "BARORECEPTOR": "a sensory nerve ending, esp. in the walls of large arteries, that is sensitive to changes in blood pressure [n -S]\n",
  "BARORECEPTORS": "BARORECEPTOR, a sensory nerve ending, esp. in the walls of large arteries, that is sensitive to changes in blood pressure [n]\n",
  "BAROSAUR": "a large dinosaur [n -S]\n",
  "BAROSAURS": "BAROSAUR, a large dinosaur [n]\n",
  "BAROSCOPE": "a weatherglass [n -S]\n",
  "BAROSCOPES": "BAROSCOPE, a weatherglass [n]\n",
  "BAROSCOPIC": "relating to a baroscope, a weatherglass [adj]\n",
  "BAROSTAT": "an automatic device for regulating pressure, e.g. in an aircraft [n -S]\n",
  "BAROSTATS": "BAROSTAT, an automatic device for regulating pressure, e.g. in an aircraft [n]\n",
  "BAROTITIS": "inflammation and pain in the ear caused by pressure changes, esp. during air travel [n -ES]\n",
  "BAROTITISES": "BAROTITIS, inflammation and pain in the ear caused by pressure changes, esp. during air travel [n]\n",
  "BAROTRAUMA": "injury sustained from failure to equalize the pressure of an air-containing space with that of the surrounding environment [n BAROTRAUMAS or BAROTRAUMATA]\n",
  "BAROTRAUMAS": "BAROTRAUMA, injury sustained from failure to equalize the pressure of an air-containing space with that of the surrounding environment [n]\n",
  "BAROTRAUMATA": "BAROTRAUMA, injury sustained from failure to equalize the pressure of an air-containing space with that of the surrounding environment [n]\n",
  "BAROUCHE": "a four-wheeled hooded carriage [n -S]\n",
  "BAROUCHES": "BAROUCHE, a four-wheeled hooded carriage [n]\n",
  "BARP": "(Scots) a mound or cairn [n -S]\n",
  "BARPERSON": "one who serves in a bar [n -S]\n",
  "BARPERSONS": "BARPERSON, one who serves in a bar [n]\n",
  "BARPS": "BARP, (Scots) a mound or cairn [n]\n",
  "BARQUANTINE": "a three-masted vessel, also BARKANTINE, BARKENTINE, BARQUENTINE [n -S]\n",
  "BARQUANTINES": "BARQUANTINE, a three-masted vessel, also BARKANTINE, BARKENTINE, BARQUENTINE [n]\n",
  "BARQUE": "a three-masted vessel whose mizzenmast is fore-and-aft-rigged [n -S]\n",
  "BARQUENTINE": "a three-masted vessel, with the foremast square-rigged, and the mainmast and mizzenmast fore-and-aft-rigged, also BARKANTINE, BARKENTINE, BARQUANTINE [n -S]\n",
  "BARQUENTINES": "BARQUENTINE, a three-masted vessel, with the foremast square-rigged, and the mainmast and mizzenmast fore-and-aft-rigged, also BARKANTINE, BARKENTINE, BARQUANTINE [n]\n",
  "BARQUES": "BARQUE, a three-masted vessel whose mizzenmast is fore-and-aft-rigged [n]\n",
  "BARQUETTE": "(French) a small barque [n -S]\n",
  "BARQUETTES": "BARQUETTE, (French) a small barque [n]\n",
  "BARRA": "(Australian slang) short for barramundi, an Australian fish [n -S]\n",
  "BARRABLE": "able to be barred [adj]\n",
  "BARRACAN": "(French) a coarsely woven fabric of wool, silk, and goat's hair, also BARACAN [n -S]\n",
  "BARRACANS": "BARRACAN, (French) a coarsely woven fabric of wool, silk, and goat's hair, also BARACAN [n]\n",
  "BARRACE": "(obsolete) the lists in a tournament [n -S]\n",
  "BARRACES": "BARRACE, (obsolete) the lists in a tournament [n]\n",
  "BARRACK": "to shout encouragement [v -ED, -ING, -S]\n",
  "BARRACKED": "BARRACK, to shout encouragement [v]\n",
  "BARRACKER": "one who barracks [n -S]\n",
  "BARRACKERS": "BARRACKER, one who barracks [n]\n",
  "BARRACKING": "heckling [n -S]\n",
  "BARRACKINGS": "BARRACKING, heckling [n]\n",
  "BARRACKS": "BARRACK, to shout encouragement [v]\n",
  "BARRACOON": "(Spanish) an enclosure or barrack formerly used for the temporary confinement of slaves or convicts [n -S]\n",
  "BARRACOONS": "BARRACOON, (Spanish) an enclosure or barrack formerly used for the temporary confinement of slaves or convicts [n]\n",
  "BARRACOUTA": "(Spanish) a large marine fish resembling the mackerel, aka snoek [n -S]\n",
  "BARRACOUTAS": "BARRACOUTA, (Spanish) a large marine fish resembling the mackerel, aka snoek [n]\n",
  "BARRACUDA": "(Spanish) a voracious tropical fish [n -S]\n",
  "BARRACUDAS": "BARRACUDA, (Spanish) a voracious tropical fish [n]\n",
  "BARRAGE": "to subject to a massive attack [v BARRAGED, BARRAGING, BARRAGES]\n",
  "BARRAGED": "BARRAGE, to subject to a massive attack [v]\n",
  "BARRAGES": "BARRAGE, to subject to a massive attack [v]\n",
  "BARRAGING": "BARRAGE, to subject to a massive attack [v]\n",
  "BARRAMUNDA": "(Native Australian) an Australian river-fish, also BARRAMUNDI, BURRAMUNDI [n -S]\n",
  "BARRAMUNDAS": "BARRAMUNDA, (Native Australian) an Australian river-fish, also BARRAMUNDI, BURRAMUNDI [n]\n",
  "BARRAMUNDI": "(Native Australian) an Australian river-fish, also BARRAMUNDA, BURRAMUNDI [n BARRAMUNDIS or BARRAMUNDIES]\n",
  "BARRAMUNDIES": "BARRAMUNDI, (Native Australian) an Australian river-fish, also BARRAMUNDA, BURRAMUNDI [n]\n",
  "BARRAMUNDIS": "BARRAMUNDI, (Native Australian) an Australian river-fish, also BARRAMUNDA, BURRAMUNDI [n]\n",
  "BARRANCA": "(Spanish) a deep ravine, also BARRANCO [n -S]\n",
  "BARRANCAS": "BARRANCA, (Spanish) a deep ravine, also BARRANCO [n]\n",
  "BARRANCO": "(Spanish) a deep ravine, also BARRANCA [n -S]\n",
  "BARRANCOS": "BARRANCO, (Spanish) a deep ravine, also BARRANCA [n]\n",
  "BARRAS": "BARRA, (Australian slang) short for barramundi, an Australian fish [n]\n",
  "BARRASWAY": "(Canadian) a shallow lagoon formed by a sandbar, also BARACHOIS [n -S]\n",
  "BARRASWAYS": "BARRASWAY, (Canadian) a shallow lagoon formed by a sandbar, also BARACHOIS [n]\n",
  "BARRAT": "to quarrel, especially at law [v -ED, -ING, -S]\n",
  "BARRATED": "BARRAT, to quarrel, especially at law [v]\n",
  "BARRATER": "one that persistently instigates lawsuits, also BARRATOR, BARRETOR [n -S]\n",
  "BARRATERS": "BARRATER, one that persistently instigates lawsuits, also BARRATOR, BARRETOR [n]\n",
  "BARRATING": "BARRAT, to quarrel, especially at law [v]\n",
  "BARRATOR": "one that persistently instigates lawsuits, also BARRATER, BARRETOR [n -S]\n",
  "BARRATORS": "BARRATOR, one that persistently instigates lawsuits, also BARRATER, BARRETOR [n]\n",
  "BARRATRIES": "BARRATRY, the practice of stirring up groundless lawsuits, also BARRETRY [n]\n",
  "BARRATROUS": "tainted with, or constituting, barratry, also BARRETROUS [adj BARRATROUSLY]\n",
  "BARRATROUSLY": "BARRATROUS, tainted with, or constituting, barratry, also BARRETROUS [adv]\n",
  "BARRATRY": "the practice of stirring up groundless lawsuits, also BARRETRY [n BARRATRIES]\n",
  "BARRATS": "BARRAT, to quarrel, especially at law [v]\n",
  "BARRE": "(French) a chord on a guitar [n -S] / to execute barre chords [v BARREED or BARRED, BARREING, BARRES]\n",
  "BARRED": "BARRE, to execute barre chords [v]\n",
  "BARREED": "BARRE, to execute barre chords [v]\n",
  "BARREFULL": "full of obstructions, also BARFUL [adj]\n",
  "BARREING": "BARRE, to execute barre chords [v]\n",
  "BARREL": "to move fast [v BARRELED or BARRELLED, BARRELING or BARRELLING, BARRELS]\n",
  "BARRELAGE": "barrels taken collectively [n -S]\n",
  "BARRELAGES": "BARRELAGE, barrels taken collectively [n]\n",
  "BARRELED": "BARREL, to move fast [v]\n",
  "BARRELFUL": "the contents of a barrel [n BARRELFULS or BARRELSFUL]\n",
  "BARRELFULS": "BARRELFUL, the contents of a barrel [n]\n",
  "BARRELHEAD": "the flat end of a barrel [n -S]\n",
  "BARRELHEADS": "BARRELHEAD, the flat end of a barrel [n]\n",
  "BARRELHOUSE": "a cheap saloon [n -S]\n",
  "BARRELHOUSES": "BARRELHOUSE, a cheap saloon [n]\n",
  "BARRELING": "BARREL, to move fast [v]\n",
  "BARRELLED": "BARREL, to move fast [v]\n",
  "BARRELLING": "BARREL, to move fast [v]\n",
  "BARRELS": "BARREL, to move fast [v]\n",
  "BARRELSFUL": "BARRELFUL, the contents of a barrel [n]\n",
  "BARREN": "a tract of infertile land [n -S] / unproductive [adj BARRENER, BARRENEST, BARRENLY]\n",
  "BARRENER": "BARREN, unproductive [adj]\n",
  "BARRENEST": "BARREN, unproductive [adj]\n",
  "BARRENLY": "BARREN, unproductive [adv]\n",
  "BARRENNESS": "the state of being barren [n -ES]\n",
  "BARRENNESSES": "BARRENNESS, the state of being barren [n]\n",
  "BARRENS": "BARREN, a tract of infertile land [n]\n",
  "BARRENWORT": "a herbaceous plant of the Barberry family, having leaves that are bitter and said to be sudorific [n -S]\n",
  "BARRENWORTS": "BARRENWORT, a herbaceous plant of the Barberry family, having leaves that are bitter and said to be sudorific [n]\n",
  "BARRES": "BARRE, to execute barre chords [v]\n",
  "BARRET": "(French) a kind of cap formerly worn by soldiers [n -S]\n",
  "BARRETOR": "one that persistently instigates lawsuits, also BARRATER, BARRATOR [n -S]\n",
  "BARRETORS": "BARRETOR, one that persistently instigates lawsuits, also BARRATER, BARRATOR [n]\n",
  "BARRETRIES": "BARRETRY, the practice of stirring up groundless lawsuits, also BARRATRY [n]\n",
  "BARRETROUS": "tainted with, or constituting, barratry, also BARRATROUS [adj]\n",
  "BARRETROUSLY": "BARRETROUS, tainted with, or constituting, barratry, also BARRATROUS [adv]\n",
  "BARRETRY": "the practice of stirring up groundless lawsuits, also BARRATRY [n BARRETRIES]\n",
  "BARRETS": "BARRET, (French) a kind of cap formerly worn by soldiers [n]\n",
  "BARRETTE": "(French) a bar-shaped hair-clip or hair ornament [n -S]\n",
  "BARRETTER": "a resistor capable of variation and used e.g. for detecting radio waves or stabilizing electric current [n -S]\n",
  "BARRETTERS": "BARRETTER, a resistor capable of variation and used e.g. for detecting radio waves or stabilizing electric current [n]\n",
  "BARRETTES": "BARRETTE, (French) a bar-shaped hair-clip or hair ornament [n]\n",
  "BARRICADE": "(French) to block with a barricade, a temporary defensive barrier [v BARRICADED, BARRICADING, BARRICADES]\n",
  "BARRICADED": "BARRICADE, (French) to block with a barricade, a temporary defensive barrier [v]\n",
  "BARRICADER": "one who barricades [n -S]\n",
  "BARRICADERS": "BARRICADER, one who barricades [n]\n",
  "BARRICADES": "BARRICADE, (French) to block with a barricade, a temporary defensive barrier [v]\n",
  "BARRICADING": "BARRICADE, (French) to block with a barricade, a temporary defensive barrier [v]\n",
  "BARRICADO": "a barricade [n -S] / to barricade [v BARRICADOED, BARRICADOING, BARRICADOES]\n",
  "BARRICADOED": "BARRICADO, to barricade [v]\n",
  "BARRICADOES": "BARRICADO, a barricade [n]\n",
  "BARRICADOING": "BARRICADO, to barricade [v]\n",
  "BARRICADOS": "BARRICADO, a barricade [n]\n",
  "BARRICO": "(Spanish) a small cask [n BARRICOS or BARRICOES]\n",
  "BARRICOES": "BARRICO, (Spanish) a small cask [n]\n",
  "BARRICOS": "BARRICO, (Spanish) a small cask [n]\n",
  "BARRIE": "(Scots) terrific, also BARRY [adj BARRIER, BARRIEST]\n",
  "BARRIER": "to shut by means of a fence [v -ED, -ING, -S]\n",
  "BARRIERED": "BARRIER, to shut by means of a fence [v]\n",
  "BARRIERING": "BARRIER, to shut by means of a fence [v]\n",
  "BARRIERS": "BARRIER, to shut by means of a fence [v]\n",
  "BARRIES": "BARRY, (Australian slang) an embarrassing mistake (rhyming slang, a Barry Crocker, a shocker) [n]\n",
  "BARRIEST": "BARRIE, (Scots) terrific, also BARRY [adj]\n",
  "BARRING": "an exclusion [n -S]\n",
  "BARRINGS": "BARRING, an exclusion [n]\n",
  "BARRIO": "(Spanish) a Spanish-speaking usually poor community or district [n -S]\n",
  "BARRIOS": "BARRIO, (Spanish) a Spanish-speaking usually poor community or district [n]\n",
  "BARRIQUE": "a wine barrel, also BARRICO [n -S]\n",
  "BARRIQUES": "BARRIQUE, a wine barrel, also BARRICO [n]\n",
  "BARRISTER": "a person who is qualified to plead at the bar in a lawcourt [n -S]\n",
  "BARRISTERIAL": "of or like a barrister [adj]\n",
  "BARRISTERS": "BARRISTER, a person who is qualified to plead at the bar in a lawcourt [n]\n",
  "BARRISTERSHIP": "the office of barrister [n -S]\n",
  "BARRISTERSHIPS": "BARRISTERSHIP, the office of barrister [n]\n",
  "BARRO": "(Australian slang) embarrassing [adj]\n",
  "BARROOM": "a room in which drinks are served, forming part of a public house [n -S]\n",
  "BARROOMS": "BARROOM, a room in which drinks are served, forming part of a public house [n]\n",
  "BARROW": "a hand propelled cart [n -S]\n",
  "BARROWFUL": "the contents of a barrow [n -S]\n",
  "BARROWFULS": "BARROWFUL, the contents of a barrow [n]\n",
  "BARROWS": "BARROW, a hand propelled cart [n]\n",
  "BARRULET": "(French) a thin horizontal heraldic band [n -S]\n",
  "BARRULETS": "BARRULET, (French) a thin horizontal heraldic band [n]\n",
  "BARRY": "(Australian slang) an embarrassing mistake (rhyming slang, a Barry Crocker, a shocker) [n BARRIES]\n",
  "BARS": "BAR, to obstruct or prevent [v]\n",
  "BARSTOOL": "a stool in a barroom [n -S]\n",
  "BARSTOOLS": "BARSTOOL, a stool in a barroom [n]\n",
  "BARTEND": "to serve in a bar [v -ED, -ING, -S]\n",
  "BARTENDED": "BARTEND, to serve in a bar [v]\n",
  "BARTENDER": "one who tends a bar [n -S]\n",
  "BARTENDERS": "BARTENDER, one who tends a bar [n]\n",
  "BARTENDING": "the act of keeping a bar [n -S]\n",
  "BARTENDINGS": "BARTENDING, the act of keeping a bar [n]\n",
  "BARTENDS": "BARTEND, to serve in a bar [v]\n",
  "BARTER": "to trade by exchange [v -ED, -ING, -S]\n",
  "BARTERED": "BARTER, to trade by exchange [v]\n",
  "BARTERER": "a person who barters [n -S]\n",
  "BARTERERS": "BARTERER, a person who barters [n]\n",
  "BARTERING": "BARTER, to trade by exchange [v]\n",
  "BARTERS": "BARTER, to trade by exchange [v]\n",
  "BARTISAN": "a small overhanging turret projecting from an angle on the top of a tower, also BARTIZAN [n -S]\n",
  "BARTISANS": "BARTISAN, a small overhanging turret projecting from an angle on the top of a tower, also BARTIZAN [n]\n",
  "BARTIZAN": "a corner turret, also BARTISAN [n -S]\n",
  "BARTIZANED": "having a bartizan [adj]\n",
  "BARTIZANS": "BARTIZAN, a corner turret, also BARTISAN [n]\n",
  "BARTON": "a farmyard [n -S]\n",
  "BARTONS": "BARTON, a farmyard [n]\n",
  "BARTSIA": "a wild flower of the family Scrophulariaceae [n -S]\n",
  "BARTSIAS": "BARTSIA, a wild flower of the family Scrophulariaceae [n]\n",
  "BARWARE": "barroom equipment [n -S]\n",
  "BARWARES": "BARWARE, barroom equipment [n]\n",
  "BARWOOD": "a hard red African dyewood [n -S]\n",
  "BARWOODS": "BARWOOD, a hard red African dyewood [n]\n",
  "BARYCENTRE": "a centre of mass, esp. of the earth-moon system [n -S]\n",
  "BARYCENTRES": "BARYCENTRE, a centre of mass, esp. of the earth-moon system [n]\n",
  "BARYCENTRIC": "relating to the centre of gravity [adj]\n",
  "BARYE": "a unit of pressure [n -S]\n",
  "BARYES": "BARYE, a unit of pressure [n]\n",
  "BARYON": "a heavier class of subatomic particles [n -S]\n",
  "BARYONIC": "relating to baryon [adj]\n",
  "BARYONS": "BARYON, a heavier class of subatomic particles [n]\n",
  "BARYSPHERE": "the area of earth underlying the lithosphere [n -S]\n",
  "BARYSPHERES": "BARYSPHERE, the area of earth underlying the lithosphere [n]\n",
  "BARYTA": "barium monoxide [n -S]\n",
  "BARYTAS": "BARYTA, barium monoxide [n]\n",
  "BARYTE": "a native sulphate of barium, also BARITE [n -S]\n",
  "BARYTES": "BARYTE, a native sulphate of barium, also BARITE [n]\n",
  "BARYTIC": "relating to baryta [adj]\n",
  "BARYTON": "a kind of bass viol [n -S]\n",
  "BARYTONE": "a deep male voice, also BARITONE [n -S]\n",
  "BARYTONES": "BARYTONE, a deep male voice, also BARITONE [n]\n",
  "BARYTONS": "BARYTON, a kind of bass viol [n]\n",
  "BAS": "BA, the soul, in ancient Egyptian religion [n]\n",
  "BASAL": "relating to, or forming, the base [adj BASALLY]\n",
  "BASALLY": "BASAL, relating to, or forming, the base [adv]\n",
  "BASALT": "an igneous volcanic rock [n -S]\n",
  "BASALTES": "(Latin) unglazed stoneware [n BASALTES]\n",
  "BASALTIC": "relating to basalt [adj]\n",
  "BASALTINE": "a black or brown-green mineral [n -S]\n",
  "BASALTINES": "BASALTINE, a black or brown-green mineral [n]\n",
  "BASALTS": "BASALT, an igneous volcanic rock [n]\n",
  "BASALTWARE": "a hard fine-grained black stoneware [n -S]\n",
  "BASALTWARES": "BASALTWARE, a hard fine-grained black stoneware [n]\n",
  "BASAN": "(Arabic) a sheepskin roughly tanned and undressed [n -S]\n",
  "BASANITE": "a black form of jasper or quartzite, formerly used as a touchstone [n -S]\n",
  "BASANITES": "BASANITE, a black form of jasper or quartzite, formerly used as a touchstone [n]\n",
  "BASANS": "BASAN, (Arabic) a sheepskin roughly tanned and undressed [n]\n",
  "BASANT": "(Urdu) a Pakistani spring festival [n -S]\n",
  "BASANTS": "BASANT, (Urdu) a Pakistani spring festival [n]\n",
  "BASCINET": "a light helmet, also BASINET, BASNET [n -S]\n",
  "BASCINETS": "BASCINET, a light helmet, also BASINET, BASNET [n]\n",
  "BASCULE": "(French) a type of bridge [n -S]\n",
  "BASCULES": "BASCULE, (French) a type of bridge [n]\n",
  "BASE": "mean [adj BASER, BASEST, BASELY] / to place on a foundation [v BASED, BASING, BASES]\n",
  "BASEBALL": "a team game, played with a bat and ball [n -S]\n",
  "BASEBALLER": "one who plays baseball [n -S]\n",
  "BASEBALLERS": "BASEBALLER, one who plays baseball [n]\n",
  "BASEBALLS": "BASEBALL, a team game, played with a bat and ball [n]\n",
  "BASEBAND": "a communication device operating over limited frequencies [n -S]\n",
  "BASEBANDS": "BASEBAND, a communication device operating over limited frequencies [n]\n",
  "BASEBOARD": "a board which forms a base for something; a skirting-board [n -S]\n",
  "BASEBOARDS": "BASEBOARD, a board which forms a base for something; a skirting-board [n]\n",
  "BASEBORN": "of low birth [adj]\n",
  "BASEBURNER": "a type of wood stove [n -S]\n",
  "BASEBURNERS": "BASEBURNER, a type of wood stove [n]\n",
  "BASED": "BASE, to place on a foundation [v]\n",
  "BASEEJ": "in Iran, volunteer vigilantes who enforce strict Islamic behaviour and dress code, esp. on women, also BASIJ [n]\n",
  "BASEHEAD": "a habitual user of freebase or crack [n -S]\n",
  "BASEHEADS": "BASEHEAD, a habitual user of freebase or crack [n]\n",
  "BASELARD": "(obsolete) a short sword or dagger, worn in the fifteenth century [n -S]\n",
  "BASELARDS": "BASELARD, (obsolete) a short sword or dagger, worn in the fifteenth century [n]\n",
  "BASELESS": "without foundation [adj BASELESSLY]\n",
  "BASELESSLY": "BASELESS, without foundation [adv]\n",
  "BASELESSNESS": "the state of being baseless [n -ES]\n",
  "BASELESSNESSES": "BASELESSNESS, the state of being baseless [n]\n",
  "BASELINE": "a line at both ends of a sporting arena [n -S]\n",
  "BASELINER": "a tennis-player who stays on or near the baseline [n -S]\n",
  "BASELINERS": "BASELINER, a tennis-player who stays on or near the baseline [n]\n",
  "BASELINES": "BASELINE, a line at both ends of a sporting arena [n]\n",
  "BASELOAD": "the permanent load on power supplies [n -S]\n",
  "BASELOADS": "BASELOAD, the permanent load on power supplies [n]\n",
  "BASELY": "lowly [adv]\n",
  "BASEMAN": "a player who stands near a base in baseball [n BASEMEN]\n",
  "BASEMEN": "BASEMAN, a player who stands near a base in baseball [n]\n",
  "BASEMENT": "the part of the building below ground level [n -S]\n",
  "BASEMENTLESS": "without a basement [adj]\n",
  "BASEMENTS": "BASEMENT, the part of the building below ground level [n]\n",
  "BASEN": "(Spenser) like a basin (from Mother Hubberd's Tale, \"with big lookes basen wide\") [adj]\n",
  "BASENESS": "the state of being base [n -ES]\n",
  "BASENESSES": "BASENESS, the state of being base [n]\n",
  "BASENJI": "(Bantu) a small African hunting-dog [n -S]\n",
  "BASENJIS": "BASENJI, (Bantu) a small African hunting-dog [n]\n",
  "BASEPATH": "a baserunner's path between bases [n -S]\n",
  "BASEPATHS": "BASEPATH, a baserunner's path between bases [n]\n",
  "BASEPLATE": "the foundation plate of a piece of heavy machinery [n -S]\n",
  "BASEPLATES": "BASEPLATE, the foundation plate of a piece of heavy machinery [n]\n",
  "BASER": "BASE, mean [adj]\n",
  "BASERUNNER": "a baseball player of the team on bat who is on base or trying to reach base [n -S]\n",
  "BASERUNNERS": "BASERUNNER, a baseball player of the team on bat who is on base or trying to reach base [n]\n",
  "BASERUNNING": "attempting to perform a circuit of the bases [n -S]\n",
  "BASERUNNINGS": "BASERUNNING, attempting to perform a circuit of the bases [n]\n",
  "BASES": "BASE, to place on a foundation [v]\n",
  "BASEST": "BASE, mean [adj]\n",
  "BASH": "to strike [v BASHED, BASHING, BASHES]\n",
  "BASHAW": "(Turkish) a former Turkish official [n -S]\n",
  "BASHAWISM": "(Turkish) the state of being a bashaw, a pasha [n -S]\n",
  "BASHAWISMS": "BASHAWISM, (Turkish) the state of being a bashaw, a pasha [n]\n",
  "BASHAWS": "BASHAW, (Turkish) a former Turkish official [n]\n",
  "BASHAWSHIP": "the office of bashaw [n -S]\n",
  "BASHAWSHIPS": "BASHAWSHIP, the office of bashaw [n]\n",
  "BASHED": "BASH, to strike [v]\n",
  "BASHER": "one who bashes [n -S]\n",
  "BASHERS": "BASHER, one who bashes [n]\n",
  "BASHES": "BASH, to strike [v]\n",
  "BASHFUL": "shy, timid [adj BASHFULLER, BASHFULLEST]\n",
  "BASHFULLER": "BASHFUL, shy, timid [adj]\n",
  "BASHFULLEST": "BASHFUL, shy, timid [adj]\n",
  "BASHFULLY": "BASHFUL, shy, timid [adv]\n",
  "BASHFULNESS": "the state of being bashful [n -ES]\n",
  "BASHFULNESSES": "BASHFULNESS, the state of being bashful [n]\n",
  "BASHIBAZOUK": "one of a group of irregular Turkish soldiers notorious for their brutality [n -S]\n",
  "BASHIBAZOUKS": "BASHIBAZOUK, one of a group of irregular Turkish soldiers notorious for their brutality [n]\n",
  "BASHING": "a malicious physical or verbal attack [n -S]\n",
  "BASHINGS": "BASHING, a malicious physical or verbal attack [n]\n",
  "BASHLESS": "unashamed [adj]\n",
  "BASHLIK": "(Russian) a long Russian hood, also BASHLYK [n -S]\n",
  "BASHLIKS": "BASHLIK, (Russian) a long Russian hood, also BASHLYK [n]\n",
  "BASHLYK": "(Russian) a long Russian hood, also BASHLIK [n -S]\n",
  "BASHLYKS": "BASHLYK, (Russian) a long Russian hood, also BASHLIK [n]\n",
  "BASHMENT": "a large gathering for a Caribbean dance or party [n -S]\n",
  "BASHMENTS": "BASHMENT, a large gathering for a Caribbean dance or party [n]\n",
  "BASHO": "(Japanese) a sumo wrestling tournament [n BASHO]\n",
  "BASHTAG": "a hashtag used for critical or abusive comments [n -S]\n",
  "BASHTAGS": "BASHTAG, a hashtag used for critical or abusive comments [n]\n",
  "BASIC": "fundamental [adj BASICALLY] / a fundamental [n -S]\n",
  "BASICALLY": "BASIC, fundamental [adv]\n",
  "BASICITIES": "BASICITY, the state of being a base; the number of hydrogen ions available to react with an alkali [n]\n",
  "BASICITY": "the state of being a base; the number of hydrogen ions available to react with an alkali [n BASICITIES]\n",
  "BASICRANIAL": "of or relating to the base of the skull [adj]\n",
  "BASICS": "BASIC, a fundamental [n]\n",
  "BASIDIA": "BASIDIUM, (Greek) a fungal fructification from which spores are released [n]\n",
  "BASIDIAL": "relating to basidium [adj]\n",
  "BASIDIOCARP": "the fruiting body of basidiomycetous fungi; the mushroom of agarics [n -S]\n",
  "BASIDIOCARPS": "BASIDIOCARP, the fruiting body of basidiomycetous fungi; the mushroom of agarics [n]\n",
  "BASIDIOMYCETE": "any fungus of a subdivision Basidiomycotina that includes the agarics [n -S]\n",
  "BASIDIOMYCETES": "BASIDIOMYCETE, any fungus of a subdivision Basidiomycotina that includes the agarics [n]\n",
  "BASIDIOMYCETOUS": "of or like a basidiomycete [adj]\n",
  "BASIDIOSPORE": "a spore produced by a basidium [n -S]\n",
  "BASIDIOSPORES": "BASIDIOSPORE, a spore produced by a basidium [n]\n",
  "BASIDIOSPOROUS": "of or like a basidiospore, a spore produced by a basidium [adj]\n",
  "BASIDIUM": "(Greek) a fungal fructification from which spores are released [n BASIDIA]\n",
  "BASIFICATION": "the process of basifying [n -S]\n",
  "BASIFICATIONS": "BASIFICATION, the process of basifying [n]\n",
  "BASIFIED": "BASIFY, to convert into a salifiable base [v]\n",
  "BASIFIER": "that which converts into a salifiable base [n -S]\n",
  "BASIFIERS": "BASIFIER, that which converts into a salifiable base [n]\n",
  "BASIFIES": "BASIFY, to convert into a salifiable base [v]\n",
  "BASIFIXED": "attached by the base [adj]\n",
  "BASIFUGAL": "developing in a direction away from the base [adj]\n",
  "BASIFY": "to convert into a salifiable base [v BASIFIED, BASIFYING, BASIFIES]\n",
  "BASIFYING": "BASIFY, to convert into a salifiable base [v]\n",
  "BASIJ": "in Iran, volunteer vigilantes who enforce strict Islamic behaviour and dress code, esp. on women, also BASEEJ [n]\n",
  "BASIL": "an aromatic herb [n -S]\n",
  "BASILAR": "relating to, or situated at, the base, esp. of the skull, also BASILARY [adj]\n",
  "BASILARY": "relating to, or situated at, the base, esp. of the skull, also BASILAR [adj]\n",
  "BASILECT": "the least prestigious language of an area [n -S]\n",
  "BASILECTS": "BASILECT, the least prestigious language of an area [n]\n",
  "BASILIC": "pertaining to the large vein in the upper arm [adj]\n",
  "BASILICA": "(Latin) a large oblong hall with double colonnades and a semicircular apse [n BASILICAS or BASILICAE]\n",
  "BASILICAE": "BASILICA, (Latin) a large oblong hall with double colonnades and a semicircular apse [n]\n",
  "BASILICAL": "of, relating to, or resembling, a basilica, also BASILICAN [adj]\n",
  "BASILICAN": "of, relating to, or resembling, a basilica, also BASILICAL [adj]\n",
  "BASILICAS": "BASILICA, (Latin) a large oblong hall with double colonnades and a semicircular apse [n]\n",
  "BASILICON": "(Greek) any of several ointments supposed to possess sovereign virtues [n -S]\n",
  "BASILICONS": "BASILICON, (Greek) any of several ointments supposed to possess sovereign virtues [n]\n",
  "BASILISK": "a harmless crested lizard of Central America; also, a legendary lizard/serpent with lethal breath and glance [n -S]\n",
  "BASILISKS": "BASILISK, a harmless crested lizard of Central America; also, a legendary lizard/serpent with lethal breath and glance [n]\n",
  "BASILS": "BASIL, an aromatic herb [n]\n",
  "BASIN": "a wide dish, also BASON [n -S]\n",
  "BASINAL": "pertaining to a basin [adj]\n",
  "BASINED": "put in a basin [adj]\n",
  "BASINET": "a light helmet, also BASCINET, BASNET [n -S]\n",
  "BASINETS": "BASINET, a light helmet, also BASCINET, BASNET [n]\n",
  "BASINFUL": "as much as fills a basin [n -S]\n",
  "BASINFULS": "BASINFUL, as much as fills a basin [n]\n",
  "BASING": "BASE, to place on a foundation [v]\n",
  "BASINLIKE": "like a basin [adj]\n",
  "BASINS": "BASIN, a wide dish, also BASON [n]\n",
  "BASION": "a part of the skull [n -S]\n",
  "BASIONS": "BASION, a part of the skull [n]\n",
  "BASIPETAL": "produced in succession towards the base [adj BASIPETALLY]\n",
  "BASIPETALLY": "BASIPETAL, produced in succession towards the base [adv]\n",
  "BASIS": "the foundation [n BASES]\n",
  "BASK": "to relax in pleasant warmth [v -ED, -ING, -S]\n",
  "BASKED": "BASK, to relax in pleasant warmth [v]\n",
  "BASKET": "a container made of flexible material [n -S]\n",
  "BASKETBALL": "a usually indoor court game between two teams of usually five players each who score by tossing an inflated ball through a raised goal [n -S]\n",
  "BASKETBALLS": "BASKETBALL, a usually indoor court game between two teams of usually five players each who score by tossing an inflated ball through a raised goal [n]\n",
  "BASKETFUL": "the contents of a basket [n BASKETFULS or BASKETSFUL]\n",
  "BASKETFULS": "BASKETFUL, the contents of a basket [n]\n",
  "BASKETLIKE": "like a basket [adj]\n",
  "BASKETRIES": "BASKETRY, basket work [n]\n",
  "BASKETRY": "basket work [n BASKETRIES]\n",
  "BASKETS": "BASKET, a container made of flexible material [n]\n",
  "BASKETSFUL": "BASKETFUL, the contents of a basket [n]\n",
  "BASKETWEAVE": "a form of weaving using two or more strands in the warp and weft [n -S]\n",
  "BASKETWEAVER": "one who weaves baskets [n -S]\n",
  "BASKETWEAVERS": "BASKETWEAVER, one who weaves baskets [n]\n",
  "BASKETWEAVES": "BASKETWEAVE, a form of weaving using two or more strands in the warp and weft [n]\n",
  "BASKETWORK": "objects produced by basketry [n -S]\n",
  "BASKETWORKS": "BASKETWORK, objects produced by basketry [n]\n",
  "BASKING": "BASK, to relax in pleasant warmth [v]\n",
  "BASKS": "BASK, to relax in pleasant warmth [v]\n",
  "BASMATI": "(Hindi) a type of long grain rice [n -S]\n",
  "BASMATIS": "BASMATI, (Hindi) a type of long grain rice [n]\n",
  "BASMITZVAH": "(Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BATHMITSVAH, BATHMITZVAH, BATHMIZVAH, BATMITZVAH [n -S]\n",
  "BASMITZVAHS": "BASMITZVAH, (Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BATHMITSVAH, BATHMITZVAH, BATHMIZVAH, BATMITZVAH [n]\n",
  "BASNET": "a light helmet, also BASCINET, BASINET [n -S]\n",
  "BASNETS": "BASNET, a light helmet, also BASCINET, BASINET [n]\n",
  "BASOCHE": "(French) a mediaeval guild of clerks of the parliament of Paris, performers of mystery plays [n -S]\n",
  "BASOCHES": "BASOCHE, (French) a mediaeval guild of clerks of the parliament of Paris, performers of mystery plays [n]\n",
  "BASON": "(archaic) a basin, also BASEN, BASIN [n -S]\n",
  "BASONS": "BASON, (archaic) a basin, also BASEN, BASIN [n]\n",
  "BASOPHIL": "of white blood cells, having an affinity for basic stains, also BASOPHILE, BASOPHILIC [adj] / a basophil cell [n -S]\n",
  "BASOPHILE": "of white blood cells, having an affinity for basic stains, also BASOPHIL, BASOPHILIC [adj] / such a cell [n -S]\n",
  "BASOPHILES": "BASOPHILE, such a cell [n]\n",
  "BASOPHILIA": "of white blood cells, the state of having an affinity for stains [n -S]\n",
  "BASOPHILIAS": "BASOPHILIA, of white blood cells, the state of having an affinity for stains [n]\n",
  "BASOPHILIC": "of white blood cells, having an affinity for stains, also BASOPHIL, BASOPHILE [adj]\n",
  "BASOPHILS": "BASOPHIL, a basophil cell [n]\n",
  "BASQUE": "a kind of bodice [n -S]\n",
  "BASQUED": "furnished with a basque [adj]\n",
  "BASQUES": "BASQUE, a kind of bodice [n]\n",
  "BASQUINE": "(French) an outer petticoat worn by Basque and Spanish women [n -S]\n",
  "BASQUINES": "BASQUINE, (French) an outer petticoat worn by Basque and Spanish women [n]\n",
  "BASS": "of a voice, low in pitch [adj BASSER, BASSEST, BASSLY] / to utter in a deep tone [v -ED, -ING, -ES]\n",
  "BASSE": "a European fish of the sea-perch family [n -S]\n",
  "BASSED": "BASS, to utter in a deep tone [v]\n",
  "BASSER": "someone who plays the bass guitar [n -S]\n",
  "BASSERS": "BASSER, someone who plays the bass guitar [n]\n",
  "BASSES": "BASS [n]\n",
  "BASSEST": "BASS, of a voice, low in pitch [adj]\n",
  "BASSET": "to outcrop, also BASSETT [v -ED, -ING, -S]\n",
  "BASSETED": "BASSET, to outcrop, also BASSETT [v]\n",
  "BASSETING": "BASSET, to outcrop, also BASSETT [v]\n",
  "BASSETS": "BASSET, to outcrop, also BASSETT [v]\n",
  "BASSETT": "to outcrop, also BASSET [v -ED, -ING, -S]\n",
  "BASSETTED": "BASSETT, to outcrop, also BASSET [v]\n",
  "BASSETTING": "BASSETT, to outcrop, also BASSET [v]\n",
  "BASSETTS": "BASSETT, to outcrop, also BASSET [v]\n",
  "BASSI": "BASSO, (Italian) a low-pitched singer [n]\n",
  "BASSIER": "BASSY, somewhat deep in sound [adj]\n",
  "BASSIEST": "BASSY, somewhat deep in sound [adj]\n",
  "BASSINET": "a basket used as a bed for a baby [n -S]\n",
  "BASSINETS": "BASSINET, a basket used as a bed for a baby [n]\n",
  "BASSING": "BASS, to utter in a deep tone [v]\n",
  "BASSIST": "a person who plays a double bass [n -S]\n",
  "BASSISTS": "BASSIST, a person who plays a double bass [n]\n",
  "BASSLINE": "the lowest line in a piece of jazz or popular music, provided by a bass instrument or electronically [n -S]\n",
  "BASSLINES": "BASSLINE, the lowest line in a piece of jazz or popular music, provided by a bass instrument or electronically [n]\n",
  "BASSLY": "BASS, of a voice, low in pitch [adv]\n",
  "BASSNESS": "the state of being low in pitch [n -ES]\n",
  "BASSNESSES": "BASSNESS, the state of being low in pitch [n]\n",
  "BASSO": "(Italian) a low-pitched singer [n BASSOS or BASSI]\n",
  "BASSOON": "a woodwind instrument [n -S]\n",
  "BASSOONIST": "a performer on the bassoon [n -S]\n",
  "BASSOONISTS": "BASSOONIST, a performer on the bassoon [n]\n",
  "BASSOONS": "BASSOON, a woodwind instrument [n]\n",
  "BASSOS": "BASSO, (Italian) a low-pitched singer [n]\n",
  "BASSWOOD": "an American lime-tree or its wood [n -S]\n",
  "BASSWOODS": "BASSWOOD, an American lime-tree or its wood [n]\n",
  "BASSY": "somewhat deep in sound [adj BASSIER, BASSIEST]\n",
  "BAST": "the inner bark, esp. of lime [n -S]\n",
  "BASTA": "(Shakespeare) enough [interj]\n",
  "BASTARD": "a child whose parents are not married to each other [n -S]\n",
  "BASTARDIES": "BASTARDY, the state of being a bastard [n]\n",
  "BASTARDISATION": "the process of bastardising, also BASTARDIZATION [n -S]\n",
  "BASTARDISATIONS": "BASTARDISATION, the process of bastardising, also BASTARDIZATION [n]\n",
  "BASTARDISE": "to make a bastard of, also BASTARDIZE [v BASTARDISED, BASTARDISING, BASTARDISES]\n",
  "BASTARDISED": "BASTARDISE, to make a bastard of, also BASTARDIZE [v]\n",
  "BASTARDISES": "BASTARDISE, to make a bastard of, also BASTARDIZE [v]\n",
  "BASTARDISING": "BASTARDISE, to make a bastard of, also BASTARDIZE [v]\n",
  "BASTARDISM": "the state of being a bastard; bastardy [n -S]\n",
  "BASTARDISMS": "BASTARDISM, the state of being a bastard; bastardy [n]\n",
  "BASTARDIZATION": "the process of bastardizing, also BASTARDISATION [n -S]\n",
  "BASTARDIZATIONS": "BASTARDIZATION, the process of bastardizing, also BASTARDISATION [n]\n",
  "BASTARDIZE": "to make or prove to be a bastard; to stigmatize as a bastard, also BASTARDISE [v BASTARDIZED, BASTARDIZING, BASTARDIZES]\n",
  "BASTARDIZED": "BASTARDIZE, to make or prove to be a bastard; to stigmatize as a bastard, also BASTARDISE [v]\n",
  "BASTARDIZES": "BASTARDIZE, to make or prove to be a bastard; to stigmatize as a bastard, also BASTARDISE [v]\n",
  "BASTARDIZING": "BASTARDIZE, to make or prove to be a bastard; to stigmatize as a bastard, also BASTARDISE [v]\n",
  "BASTARDLIER": "BASTARDLY, like a bastard; baseborn; spurious [adj]\n",
  "BASTARDLIEST": "BASTARDLY, like a bastard; baseborn; spurious [adj]\n",
  "BASTARDLY": "like a bastard; baseborn; spurious [adj BASTARDLIER, BASTARDLIEST]\n",
  "BASTARDRIES": "BASTARDRY, (Australian slang) malicious or cruel behaviour, also BASTARDY [n]\n",
  "BASTARDRY": "(Australian slang) malicious or cruel behaviour, also BASTARDY [n BASTARDRIES]\n",
  "BASTARDS": "BASTARD, a child whose parents are not married to each other [n]\n",
  "BASTARDY": "the state of being a bastard [n BASTARDIES]\n",
  "BASTE": "to keep (meat) moist when roasting by drizzling melted fat or butter over [v BASTED, BASTING, BASTES]\n",
  "BASTED": "BASTE, to keep (meat) moist when roasting by drizzling melted fat or butter over [v]\n",
  "BASTER": "one who bastes [n -S]\n",
  "BASTERS": "BASTER, one who bastes [n]\n",
  "BASTES": "BASTE, to keep (meat) moist when roasting by drizzling melted fat or butter over [v]\n",
  "BASTI": "(Urdu) a slum, also BUSTI, BUSTEE [n -S]\n",
  "BASTIDE": "(French) a French country house [n -S]\n",
  "BASTIDES": "BASTIDE, (French) a French country house [n]\n",
  "BASTILE": "a tower or an elevated work, used for the defense, or in the siege, of a fortified place, also BASTILLE [n -S]\n",
  "BASTILES": "BASTILE, a tower or an elevated work, used for the defense, or in the siege, of a fortified place, also BASTILLE [n]\n",
  "BASTILLE": "(French) a tower or an elevated work, used for the defense, or in the siege, of a fortified place, also BASTILE [n -S]\n",
  "BASTILLES": "BASTILLE, (French) a tower or an elevated work, used for the defense, or in the siege, of a fortified place, also BASTILE [n]\n",
  "BASTINADE": "(French) to beat with a stick or baton, esp. on the feet, also BASTINADO [v BASTINADED, BASTINADING, BASTINADES]\n",
  "BASTINADED": "BASTINADE, (French) to beat with a stick or baton, esp. on the feet, also BASTINADO [v]\n",
  "BASTINADES": "BASTINADE, (French) to beat with a stick or baton, esp. on the feet, also BASTINADO [v]\n",
  "BASTINADING": "BASTINADE, (French) to beat with a stick or baton, esp. on the feet, also BASTINADO [v]\n",
  "BASTINADO": "(Spanish) torture by beating on the soles of the feet [n -ES] / to torture thus, also BASTINADE [v -ED, -ING, -ES]\n",
  "BASTINADOED": "BASTINADO, to torture thus, also BASTINADE [v]\n",
  "BASTINADOES": "BASTINADO, to torture thus, also BASTINADE [v]\n",
  "BASTINADOING": "BASTINADO, to torture thus, also BASTINADE [v]\n",
  "BASTING": "loose temporary stitches [n -S]\n",
  "BASTINGS": "BASTING, loose temporary stitches [n]\n",
  "BASTION": "a tower at the corner of a fortification [n -S]\n",
  "BASTIONED": "having a defence [adj]\n",
  "BASTIONS": "BASTION, a tower at the corner of a fortification [n]\n",
  "BASTIS": "BASTI, (Urdu) a slum, also BUSTI, BUSTEE [n]\n",
  "BASTLE": "a fortified house with vaulted ground floor [n -S]\n",
  "BASTLES": "BASTLE, a fortified house with vaulted ground floor [n]\n",
  "BASTNAESITE": "(Swedish) a reddish-brown fluorite of cerium, also BASTNASITE [n -S]\n",
  "BASTNAESITES": "BASTNAESITE, (Swedish) a reddish-brown fluorite of cerium, also BASTNASITE [n]\n",
  "BASTNASITE": "(Swedish) a reddish-brown fluorite of cerium, also BASTNAESITE [n -S]\n",
  "BASTNASITES": "BASTNASITE, (Swedish) a reddish-brown fluorite of cerium, also BASTNAESITE [n]\n",
  "BASTO": "(Spanish) the ace of clubs in the game of quadrille [n -S]\n",
  "BASTOS": "BASTO, (Spanish) the ace of clubs in the game of quadrille [n]\n",
  "BASTS": "BAST, the inner bark, esp. of lime [n]\n",
  "BASUCO": "(Spanish) a low grade of cocaine mixed with coca paste [n -S]\n",
  "BASUCOS": "BASUCO, (Spanish) a low grade of cocaine mixed with coca paste [n]\n",
  "BAT": "to hit a ball with a bat (cricket, baseball) [v BATTED, BATTING, BATS]\n",
  "BATABLE": "debatable, disputable [adj]\n",
  "BATARD": "a birchbark canoe [n -S]\n",
  "BATARDS": "BATARD, a birchbark canoe [n]\n",
  "BATATA": "an aboriginal American name for the sweet potato [n -S]\n",
  "BATATAS": "BATATA, an aboriginal American name for the sweet potato [n]\n",
  "BATAVIA": "a variety of lettuce with smooth pale green leaves [n -S]\n",
  "BATAVIAS": "BATAVIA, a variety of lettuce with smooth pale green leaves [n]\n",
  "BATBOY": "a boy who minds baseball equipment [n -S]\n",
  "BATBOYS": "BATBOY, a boy who minds baseball equipment [n]\n",
  "BATCH": "to collect together [v -ED, -ING, -ES]\n",
  "BATCHED": "BATCH, to collect together [v]\n",
  "BATCHER": "one who puts things together [n -S]\n",
  "BATCHERS": "BATCHER, one who puts things together [n]\n",
  "BATCHES": "BATCH, to collect together [v]\n",
  "BATCHING": "the act of sorting into batches [n -S]\n",
  "BATCHINGS": "BATCHING, the act of sorting into batches [n]\n",
  "BATE": "to diminish, also BAYT [v BATED, BATING, BATES]\n",
  "BATEAU": "(Canadian) a boat; especially a flat-bottomed, clumsy boat used on the Canadian lakes and rivers, also BATTEAU [n BATEAUX]\n",
  "BATEAUX": "BATEAU, (Canadian) a boat; especially a flat-bottomed, clumsy boat used on the Canadian lakes and rivers, also BATTEAU [n]\n",
  "BATED": "BATE, to diminish, also BAYT [v]\n",
  "BATELESS": "(Shakespeare) that cannot be blunted [adj]\n",
  "BATELEUR": "(French) an African eagle [n -S]\n",
  "BATELEURS": "BATELEUR, (French) an African eagle [n]\n",
  "BATEMENT": "reduction [n -S]\n",
  "BATEMENTS": "BATEMENT, reduction [n]\n",
  "BATES": "BATE, to diminish, also BAYT [v]\n",
  "BATFISH": "a name given to several species of fish with winglike projections [n -ES]\n",
  "BATFISHES": "BATFISH, a name given to several species of fish with winglike projections [n]\n",
  "BATFOWL": "to catch birds at night by confusing them with light [v -ED, -ING, -S]\n",
  "BATFOWLED": "BATFOWL, to catch birds at night by confusing them with light [v]\n",
  "BATFOWLER": "one who batfowls, catches birds at night by confusing them with light [n -S]\n",
  "BATFOWLERS": "BATFOWLER, one who batfowls, catches birds at night by confusing them with light [n]\n",
  "BATFOWLING": "catching birds at night by confusing them with light [n -S]\n",
  "BATFOWLINGS": "BATFOWLING, catching birds at night by confusing them with light [n]\n",
  "BATFOWLS": "BATFOWL, to catch birds at night by confusing them with light [v]\n",
  "BATGIRL": "a girl who minds baseball equipment [n -S]\n",
  "BATGIRLS": "BATGIRL, a girl who minds baseball equipment [n]\n",
  "BATH": "water for immersing the body [n -S] / to take a bath [v -ED, -ING, -S]\n",
  "BATHCUBE": "a fragrant cube for dissolving in a bath [n -S]\n",
  "BATHCUBES": "BATHCUBE, a fragrant cube for dissolving in a bath [n]\n",
  "BATHE": "to wash by immersion in water [v BATHED, BATHING, BATHES]\n",
  "BATHED": "BATHE, to wash by immersion in water [v]\n",
  "BATHER": "one who bathes [n -S]\n",
  "BATHERS": "BATHER, one who bathes [n]\n",
  "BATHES": "BATHE, to wash by immersion in water [v]\n",
  "BATHETIC": "characterized by triteness or sentimentalism [adj BATHETICALLY]\n",
  "BATHETICALLY": "BATHETIC, characterized by triteness or sentimentalism [adv]\n",
  "BATHHOUSE": "a public bathing establishment [n -S]\n",
  "BATHHOUSES": "BATHHOUSE, a public bathing establishment [n]\n",
  "BATHING": "the act of taking a bath [n -S]\n",
  "BATHINGS": "BATHING, the act of taking a bath [n]\n",
  "BATHLESS": "without a bath [adj]\n",
  "BATHMAT": "a mat used in bathrooms [n -S]\n",
  "BATHMATS": "BATHMAT, a mat used in bathrooms [n]\n",
  "BATHMIC": "relating to bathmism, directive evolutionary force [adj]\n",
  "BATHMISM": "a theory of directed evolution [n -S]\n",
  "BATHMISMS": "BATHMISM, a theory of directed evolution [n]\n",
  "BATHMITSVAH": "(Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITZVAH, BATHMIZVAH, BATMITZVAH [n -S]\n",
  "BATHMITSVAHS": "BATHMITSVAH, (Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITZVAH, BATHMIZVAH, BATMITZVAH [n]\n",
  "BATHMITZVAH": "(Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITSVAH, BATHMIZVAH, BATMITZVAH [n -S]\n",
  "BATHMITZVAHS": "BATHMITZVAH, (Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITSVAH, BATHMIZVAH, BATMITZVAH [n]\n",
  "BATHMIZVAH": "(Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITSVAH, BATHMITZVAH, BATMITZVAH [n -S]\n",
  "BATHMIZVAHS": "BATHMIZVAH, (Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITSVAH, BATHMITZVAH, BATMITZVAH [n]\n",
  "BATHOCHROME": "a shift to a longer wavelength in the absorption spectrum of a compound [n -S]\n",
  "BATHOCHROMES": "BATHOCHROME, a shift to a longer wavelength in the absorption spectrum of a compound [n]\n",
  "BATHOCHROMIC": "denoting or relating to a shift to a longer wavelength in the absorption spectrum of a compound [adj]\n",
  "BATHOLITE": "a mass of igneous rock that has risen from a great depth, also BATHOLITH, BATHYLITE, BATHYLITH [n -S]\n",
  "BATHOLITES": "BATHOLITE, a mass of igneous rock that has risen from a great depth, also BATHOLITH, BATHYLITE, BATHYLITH [n]\n",
  "BATHOLITH": "a mass of igneous rock that has risen from a great depth, also BATHOLITE, BATHYLITE, BATHYLITH [n -S]\n",
  "BATHOLITHIC": "of or like a batholith, a large mass of intruded igneous rock [adj]\n",
  "BATHOLITHS": "BATHOLITH, a mass of igneous rock that has risen from a great depth, also BATHOLITE, BATHYLITE, BATHYLITH [n]\n",
  "BATHOLITIC": "of or like a batholite, a mass of igneous rock that has risen from a great depth [adj]\n",
  "BATHOMETER": "an instrument for measuring depths, esp. one for taking soundings without a sounding line [n -S]\n",
  "BATHOMETERS": "BATHOMETER, an instrument for measuring depths, esp. one for taking soundings without a sounding line [n]\n",
  "BATHOMETRIC": "relating to a bathometer, an instrument for measuring depths [adj BATHOMETRICALLY]\n",
  "BATHOMETRICALLY": "BATHOMETRIC, relating to a bathometer, an instrument for measuring depths [adv]\n",
  "BATHOMETRIES": "BATHOMETRY, measurement of the depth of water [n]\n",
  "BATHOMETRY": "measurement of the depth of water [n BATHOMETRIES]\n",
  "BATHOPHILOUS": "of an organism, living in very deep water [adj]\n",
  "BATHOPHOBIA": "fear of falling from a high place [n -S]\n",
  "BATHOPHOBIAS": "BATHOPHOBIA, fear of falling from a high place [n]\n",
  "BATHORSE": "(archaic) a horse which carries an officer's baggage during a campaign [n -S]\n",
  "BATHORSES": "BATHORSE, (archaic) a horse which carries an officer's baggage during a campaign [n]\n",
  "BATHOS": "(Greek) the appearance of the commonplace in elevated matter [n -ES]\n",
  "BATHOSES": "BATHOS, (Greek) the appearance of the commonplace in elevated matter [n]\n",
  "BATHROBE": "a robe worn for taking a bath [n -S]\n",
  "BATHROBES": "BATHROBE, a robe worn for taking a bath [n]\n",
  "BATHROOM": "a room for bathing [n -S]\n",
  "BATHROOMS": "BATHROOM, a room for bathing [n]\n",
  "BATHS": "BATH, to take a bath [v]\n",
  "BATHTUB": "a tub for bathing [n -S]\n",
  "BATHTUBS": "BATHTUB, a tub for bathing [n]\n",
  "BATHWATER": "the water in a bath [n -S]\n",
  "BATHWATERS": "BATHWATER, the water in a bath [n]\n",
  "BATHYAL": "pertaining to the zone of the sea from 600 feet down to the abyssal zone [adj]\n",
  "BATHYBIUS": "a substance on the sea bottom formerly thought to be living matter [n -ES]\n",
  "BATHYBIUSES": "BATHYBIUS, a substance on the sea bottom formerly thought to be living matter [n]\n",
  "BATHYGRAPHIC": "of or relating to the depths of the ocean, also BATHYGRAPHICAL [adj]\n",
  "BATHYGRAPHICAL": "of maps, representing the contours of the seabed, also BATHYGRAPHIC [adj]\n",
  "BATHYLIMNETIC": "of an organism, living in the depths of lakes and marshes [adj]\n",
  "BATHYLITE": "a mass of igneous rock that has risen from a great depth, also BATHOLITE, BATHOLITH, BATHYLITH [n -S]\n",
  "BATHYLITES": "BATHYLITE, a mass of igneous rock that has risen from a great depth, also BATHOLITE, BATHOLITH, BATHYLITH [n]\n",
  "BATHYLITH": "a mass of igneous rock that has risen from a great depth, also BATHOLITE, BATHOLITH, BATHYLITE [n -S]\n",
  "BATHYLITHIC": "like a bathylith, a mass of igneous rock that has risen from a great depth [adj]\n",
  "BATHYLITHS": "BATHYLITH, a mass of igneous rock that has risen from a great depth, also BATHOLITE, BATHOLITH, BATHYLITE [n]\n",
  "BATHYLITIC": "like a bathylite, a mass of igneous rock that has risen from a great depth [adj]\n",
  "BATHYMETER": "an instrument for recording the contours of deep oceans [n -S]\n",
  "BATHYMETERS": "BATHYMETER, an instrument for recording the contours of deep oceans [n]\n",
  "BATHYMETRIC": "relating to measurement by a bathymeter, also BATHYMETRICAL [adj BATHYMETRICALLY]\n",
  "BATHYMETRICAL": "relating to measurement by a bathymeter, also BATHYMETRIC [adj BATHYMETRICALLY]\n",
  "BATHYMETRICALLY": "BATHYMETRICAL, relating to measurement by a bathymeter, also BATHYMETRIC [adv]\n",
  "BATHYMETRIES": "BATHYMETRY, the art or science of sounding, or measuring depths in the sea [n]\n",
  "BATHYMETRY": "the art or science of sounding, or measuring depths in the sea [n BATHYMETRIES]\n",
  "BATHYPELAGIC": "found in the depths of the sea, down to 4000 metres below sea level [adj]\n",
  "BATHYSCAPE": "a submersible observation chamber [n -S]\n",
  "BATHYSCAPES": "BATHYSCAPE, a submersible observation chamber [n]\n",
  "BATHYSCAPH": "a submersible observation chamber, also BATHYSCAPHE [n -S]\n",
  "BATHYSCAPHE": "a submersible observation chamber, also BATHYSCAPH [n -S]\n",
  "BATHYSCAPHES": "BATHYSCAPHE, a submersible observation chamber, also BATHYSCAPH [n]\n",
  "BATHYSCAPHS": "BATHYSCAPH, a submersible observation chamber, also BATHYSCAPHE [n]\n",
  "BATHYSPHERE": "a submersible observation chamber [n -S]\n",
  "BATHYSPHERES": "BATHYSPHERE, a submersible observation chamber [n]\n",
  "BATIK": "(Malay) an Indonesian dyed fabric, also BATTIK [n -S] / to produce batik designs [v -ED, -ING, -S]\n",
  "BATIKED": "BATIK, to produce batik designs [v]\n",
  "BATIKING": "BATIK, to produce batik designs [v]\n",
  "BATIKS": "BATIK, to produce batik designs [v]\n",
  "BATING": "BATE, to diminish, also BAYT [v]\n",
  "BATISTE": "(French) a fine fabric of linen, cotton or wool [n -S]\n",
  "BATISTES": "BATISTE, (French) a fine fabric of linen, cotton or wool [n]\n",
  "BATLER": "(Shakespeare) a small bat used for beating clothes, also BATLET [n -S]\n",
  "BATLERS": "BATLER, (Shakespeare) a small bat used for beating clothes, also BATLET [n]\n",
  "BATLET": "a wooden mallet for beating clothes, also BATLER [n -S]\n",
  "BATLETS": "BATLET, a wooden mallet for beating clothes, also BATLER [n]\n",
  "BATLIKE": "resembling a bat (a flying mammal) [adj]\n",
  "BATMAN": "an officer's personal attendant [n BATMEN]\n",
  "BATMEN": "BATMAN, an officer's personal attendant [n]\n",
  "BATMITZVAH": "(Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITSVAH, BATHMITZVAH, BATHMIZVAH [n -S]\n",
  "BATMITZVAHS": "BATMITZVAH, (Hebrew) in the Jewish religion, a girl attaining the age of religious responsibility, also BASMITZVAH, BATHMITSVAH, BATHMITZVAH, BATHMIZVAH [n]\n",
  "BATOLOGICAL": "relating to batology, the scientific study of brambles [adj]\n",
  "BATOLOGIES": "BATOLOGY, the study of brambles [n]\n",
  "BATOLOGIST": "one who studies batology, the science of brambles [n -S]\n",
  "BATOLOGISTS": "BATOLOGIST, one who studies batology, the science of brambles [n]\n",
  "BATOLOGY": "the study of brambles [n BATOLOGIES]\n",
  "BATON": "to strike with a truncheon, also BATOON [v -ED, -ING, -S]\n",
  "BATONED": "BATON, to strike with a truncheon, also BATOON [v]\n",
  "BATONING": "BATON, to strike with a truncheon, also BATOON [v]\n",
  "BATONNIER": "(Canadian) in Quebec, a president of a Bar Association [n -S]\n",
  "BATONNIERS": "BATONNIER, (Canadian) in Quebec, a president of a Bar Association [n]\n",
  "BATONS": "BATON, to strike with a truncheon, also BATOON [v]\n",
  "BATOON": "to strike with a truncheon, also BATON [v -ED, -ING, -S]\n",
  "BATOONED": "BATOON, to strike with a truncheon, also BATON [v]\n",
  "BATOONING": "BATOON, to strike with a truncheon, also BATON [v]\n",
  "BATOONS": "BATOON, to strike with a truncheon, also BATON [v]\n",
  "BATRACHIA": "the order of tailless amphibians which includes the frogs and toads [n]\n",
  "BATRACHIAN": "pertaining to frogs or toads [adj] / a frog or toad [n -S]\n",
  "BATRACHIANS": "BATRACHIAN, a frog or toad [n]\n",
  "BATRACHOPHOBIA": "fear of frogs and toads [n -S]\n",
  "BATRACHOPHOBIAS": "BATRACHOPHOBIA, fear of frogs and toads [n]\n",
  "BATRACHOPHOBIC": "having a morbid fear of frogs and toads [adj]\n",
  "BATS": "BAT, to hit a ball with a bat (cricket, baseball) [v]\n",
  "BATSHIT": "completely mad or crazy [adj]\n",
  "BATSMAN": "one who bats [n BATSMEN]\n",
  "BATSMANSHIP": "skill with the cricket bat [n -S]\n",
  "BATSMANSHIPS": "BATSMANSHIP, skill with the cricket bat [n]\n",
  "BATSMEN": "BATSMAN, one who bats [n]\n",
  "BATSWING": "shaped like a bat's wing [adj]\n",
  "BATSWOMAN": "a female person who wields the bat at cricket [n BATSWOMEN]\n",
  "BATSWOMEN": "BATSWOMAN, a female person who wields the bat at cricket [n]\n",
  "BATT": "a sheet of batting, cotton-wool prepared in sheets for quilting [n -S]\n",
  "BATTA": "extra pay; esp. an extra allowance to an English officer serving in India [n -S]\n",
  "BATTAILOUS": "(Spenser) warlike [adj]\n",
  "BATTALIA": "(Italian) the main body of an army [n -S]\n",
  "BATTALIAS": "BATTALIA, (Italian) the main body of an army [n]\n",
  "BATTALION": "a body of soldiers consisting of several companies [n -S]\n",
  "BATTALIONS": "BATTALION, a body of soldiers consisting of several companies [n]\n",
  "BATTAS": "BATTA, extra pay; esp. an extra allowance to an English officer serving in India [n]\n",
  "BATTEAU": "(Canadian) a boat; especially a flat-bottomed, clumsy boat used on the Canadian lakes and rivers, also BATEAU [n BATTEAUX]\n",
  "BATTEAUX": "BATTEAU, (Canadian) a boat; especially a flat-bottomed, clumsy boat used on the Canadian lakes and rivers, also BATEAU [n]\n",
  "BATTED": "BAT, to hit a ball with a bat (cricket, baseball) [v]\n",
  "BATTEILANT": "(Spenser) combatant [adj]\n",
  "BATTEL": "to have an account for kitchen provisions [v BATTELED or BATTELLED, BATTELING or BATTELLING, BATTELS]\n",
  "BATTELED": "BATTEL, to have an account for kitchen provisions [v]\n",
  "BATTELER": "someone who battels; a student rank below that of commoner [n -S]\n",
  "BATTELERS": "BATTELER, someone who battels; a student rank below that of commoner [n]\n",
  "BATTELING": "BATTEL, to have an account for kitchen provisions [v]\n",
  "BATTELLED": "BATTEL, to have an account for kitchen provisions [v]\n",
  "BATTELLING": "BATTEL, to have an account for kitchen provisions [v]\n",
  "BATTELS": "BATTEL, to have an account for kitchen provisions [v]\n",
  "BATTEMENT": "(French) a movement in ballet, in which one leg is extended to the rear, side and front [n -S]\n",
  "BATTEMENTS": "BATTEMENT, (French) a movement in ballet, in which one leg is extended to the rear, side and front [n]\n",
  "BATTEN": "to fasten with strips of wood [v -ED, -ING, -S]\n",
  "BATTENED": "BATTEN, to fasten with strips of wood [v]\n",
  "BATTENER": "one who battens [n -S]\n",
  "BATTENERS": "BATTENER, one who battens [n]\n",
  "BATTENING": "battens forming a structure [n -S]\n",
  "BATTENINGS": "BATTENING, battens forming a structure [n]\n",
  "BATTENS": "BATTEN, to fasten with strips of wood [v]\n",
  "BATTER": "to beat repeatedly [v -ED, -ING, -S]\n",
  "BATTERED": "BATTER, to beat repeatedly [v]\n",
  "BATTERER": "someone who batters [n -S]\n",
  "BATTERERS": "BATTERER, someone who batters [n]\n",
  "BATTERIE": "(French) a ballet jump [n -S]\n",
  "BATTERIES": "BATTERY, a device for generating an electric current [n]\n",
  "BATTERING": "a beating involving repeated blows [n -S]\n",
  "BATTERINGS": "BATTERING, a beating involving repeated blows [n]\n",
  "BATTERO": "(Shakespeare) a cudgel [n -S]\n",
  "BATTEROS": "BATTERO, (Shakespeare) a cudgel [n]\n",
  "BATTERS": "BATTER, to beat repeatedly [v]\n",
  "BATTERY": "a device for generating an electric current [n BATTERIES]\n",
  "BATTIER": "BATTY, (colloquial) crazy [adj]\n",
  "BATTIES": "BATTY, (West Indian slang) a person's bottom [n]\n",
  "BATTIEST": "BATTY, (colloquial) crazy [adj]\n",
  "BATTIK": "(Malay) an Indonesian method of producing designs on cloth, also BATIK [n -S]\n",
  "BATTIKS": "BATTIK, (Malay) an Indonesian method of producing designs on cloth, also BATIK [n]\n",
  "BATTILL": "to make fertile, also BATTEL, BATTLE [v -ED, -ING, -S]\n",
  "BATTILLED": "BATTILL, to make fertile, also BATTEL, BATTLE [v]\n",
  "BATTILLING": "BATTILL, to make fertile, also BATTEL, BATTLE [v]\n",
  "BATTILLS": "BATTILL, to make fertile, also BATTEL, BATTLE [v]\n",
  "BATTILY": "BATTY, (colloquial) crazy [adv]\n",
  "BATTINESS": "the state of being batty [n -ES]\n",
  "BATTINESSES": "BATTINESS, the state of being batty [n]\n",
  "BATTING": "cotton-wool prepared in sheets for quilting, also BATT [n -S]\n",
  "BATTINGS": "BATTING, cotton-wool prepared in sheets for quilting, also BATT [n]\n",
  "BATTLE": "to fight [v BATTLED, BATTLING, BATTLES]\n",
  "BATTLEAX": "a kind of axe once used in battle; a domineering, usually older woman, also BATTLEAXE [n -ES]\n",
  "BATTLEAXE": "a kind of axe once used in battle; a domineering, usually older woman, also BATTLEAX [n -S]\n",
  "BATTLEAXES": "BATTLEAXE, a kind of axe once used in battle; a domineering, usually older woman, also BATTLEAX [n]\n",
  "BATTLEBUS": "a campaign bus in an election [n BATTLEBUSES or BATTLEBUSSES]\n",
  "BATTLEBUSES": "BATTLEBUS, a campaign bus in an election [n]\n",
  "BATTLEBUSSES": "BATTLEBUS, a campaign bus in an election [n]\n",
  "BATTLED": "BATTLE, to fight [v]\n",
  "BATTLEDOOR": "(obsolete) a light bat for striking a shuttlecock, also BATTLEDORE [n -S]\n",
  "BATTLEDOORS": "BATTLEDOOR, (obsolete) a light bat for striking a shuttlecock, also BATTLEDORE [n]\n",
  "BATTLEDORE": "a light bat for striking a shuttlecock, also BATTLEDOOR [n -S]\n",
  "BATTLEDORES": "BATTLEDORE, a light bat for striking a shuttlecock, also BATTLEDOOR [n]\n",
  "BATTLEDRESS": "a soldier's attire for battle [n -ES]\n",
  "BATTLEDRESSES": "BATTLEDRESS, a soldier's attire for battle [n]\n",
  "BATTLEFIELD": "a place where a battle is fought [n -S]\n",
  "BATTLEFIELDS": "BATTLEFIELD, a place where a battle is fought [n]\n",
  "BATTLEFRONT": "the military sector in which actual combat takes place [n -S]\n",
  "BATTLEFRONTS": "BATTLEFRONT, the military sector in which actual combat takes place [n]\n",
  "BATTLEGROUND": "the site of a battle [n -S]\n",
  "BATTLEGROUNDS": "BATTLEGROUND, the site of a battle [n]\n",
  "BATTLEMENT": "a parapet with open spaces that surmounts a wall and is used for defense or decoration [n -S]\n",
  "BATTLEMENTED": "having a battlement [adj]\n",
  "BATTLEMENTS": "BATTLEMENT, a parapet with open spaces that surmounts a wall and is used for defense or decoration [n]\n",
  "BATTLEPIECE": "a painting, relief, mosaic, etc., depicting a battle, usually commemorating an actual event [n -S]\n",
  "BATTLEPIECES": "BATTLEPIECE, a painting, relief, mosaic, etc., depicting a battle, usually commemorating an actual event [n]\n",
  "BATTLEPLANE": "a plane used in war [n -S]\n",
  "BATTLEPLANES": "BATTLEPLANE, a plane used in war [n]\n",
  "BATTLER": "one who battles [n -S]\n",
  "BATTLERS": "BATTLER, one who battles [n]\n",
  "BATTLES": "BATTLE, to fight [v]\n",
  "BATTLESHIP": "a heavily armoured warship of the largest type having many large-calibre guns [n -S]\n",
  "BATTLESHIPS": "BATTLESHIP, a heavily armoured warship of the largest type having many large-calibre guns [n]\n",
  "BATTLESPACE": "the area of air, sea, and land that is directly involved in war [n -S]\n",
  "BATTLESPACES": "BATTLESPACE, the area of air, sea, and land that is directly involved in war [n]\n",
  "BATTLEWAGON": "a battleship [n -S]\n",
  "BATTLEWAGONS": "BATTLEWAGON, a battleship [n]\n",
  "BATTLING": "BATTLE, to fight [v]\n",
  "BATTOLOGICAL": "pertaining to battology, unnecessarily repetitive writing or speaking [adj]\n",
  "BATTOLOGIES": "BATTOLOGY, a needless repetition of words in speaking or writing [n]\n",
  "BATTOLOGY": "a needless repetition of words in speaking or writing [n BATTOLOGIES]\n",
  "BATTS": "BATT, a sheet of batting, cotton-wool prepared in sheets for quilting [n]\n",
  "BATTU": "(French) pertaining to a type of ballet movement [adj]\n",
  "BATTUE": "(French) indiscriminate slaughter; the driving of game towards slaughter [n -S]\n",
  "BATTUES": "BATTUE, (French) indiscriminate slaughter; the driving of game towards slaughter [n]\n",
  "BATTUTA": "(Italian) the measurement of time by beating [n -S]\n",
  "BATTUTAS": "BATTUTA, (Italian) the measurement of time by beating [n]\n",
  "BATTUTO": "(Italian) a selection of chopped herbs, used in Italian cookery [n -S]\n",
  "BATTUTOS": "BATTUTO, (Italian) a selection of chopped herbs, used in Italian cookery [n]\n",
  "BATTY": "(colloquial) crazy [adj BATTIER, BATTIEST, BATTILY] / (West Indian slang) a person's bottom [n BATTIES]\n",
  "BATWING": "as in batwing sleeve, a sleeve with a deep armhole and a tight cuff [adj]\n",
  "BATWOMAN": "an officer's female attendant [n BATWOMEN]\n",
  "BATWOMEN": "BATWOMAN, an officer's female attendant [n]\n",
  "BAUBEE": "(Scots) a halfpenny, also BAWBEE [n -S]\n",
  "BAUBEES": "BAUBEE, (Scots) a halfpenny, also BAWBEE [n]\n",
  "BAUBLE": "a cheap trinket, also BAWBLE [n -S]\n",
  "BAUBLES": "BAUBLE, a cheap trinket, also BAWBLE [n]\n",
  "BAUBLING": "(Shakespeare) trifling [adj]\n",
  "BAUCHLE": "(Scots) to make shapeless, bungle [v BAUCHLED, BAUCHLING, BAUCHLES]\n",
  "BAUCHLED": "BAUCHLE, (Scots) to make shapeless, bungle [v]\n",
  "BAUCHLES": "BAUCHLE, (Scots) to make shapeless, bungle [v]\n",
  "BAUCHLING": "BAUCHLE, (Scots) to make shapeless, bungle [v]\n",
  "BAUD": "a unit of data transmission speed of one bit per second [n -S]\n",
  "BAUDEKIN": "a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDACHINO, BALDAQUIN, BAWDKIN [n -S]\n",
  "BAUDEKINS": "BAUDEKIN, a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDACHINO, BALDAQUIN, BAWDKIN [n]\n",
  "BAUDRIC": "a warrior's sword belt, also BALDRIC, BALDRICK, BAUDRICK, BAWDRIC [n -S]\n",
  "BAUDRICK": "a warrior's sword belt, also BALDRIC, BALDRICK, BAUDRIC, BAWDRIC [n -S]\n",
  "BAUDRICKE": "(Spenser) the zodiac [n -S]\n",
  "BAUDRICKES": "BAUDRICKE, (Spenser) the zodiac [n]\n",
  "BAUDRICKS": "BAUDRICK, a warrior's sword belt, also BALDRIC, BALDRICK, BAUDRIC, BAWDRIC [n]\n",
  "BAUDRICS": "BAUDRIC, a warrior's sword belt, also BALDRIC, BALDRICK, BAUDRICK, BAWDRIC [n]\n",
  "BAUDRONS": "(Scots) a quasi-proper name for the cat; also for the hare [n -ES]\n",
  "BAUDRONSES": "BAUDRONS, (Scots) a quasi-proper name for the cat; also for the hare [n]\n",
  "BAUDS": "BAUD, a unit of data transmission speed of one bit per second [n]\n",
  "BAUERA": "a kind of evergreen shrub with pink flowers [n -S]\n",
  "BAUERAS": "BAUERA, a kind of evergreen shrub with pink flowers [n]\n",
  "BAUHINIA": "a plant of the Bauhinia genus of tropical trees [n -S]\n",
  "BAUHINIAS": "BAUHINIA, a plant of the Bauhinia genus of tropical trees [n]\n",
  "BAUK": "to refrain from proceeding, also BALK, BAULK [v -ED, -ING, -S]\n",
  "BAUKED": "BAUK, to refrain from proceeding, also BALK, BAULK [v]\n",
  "BAUKING": "BAUK, to refrain from proceeding, also BALK, BAULK [v]\n",
  "BAUKS": "BAUK, to refrain from proceeding, also BALK, BAULK [v]\n",
  "BAULK": "to refrain from proceeding, also BALK, BAUK [v -ED, -ING, -S]\n",
  "BAULKED": "BAULK, to refrain from proceeding, also BALK, BAUK [v]\n",
  "BAULKER": "one who baulks [n -S]\n",
  "BAULKERS": "BAULKER, one who baulks [n]\n",
  "BAULKIER": "BAULKY, stubborn [adj]\n",
  "BAULKIEST": "BAULKY, stubborn [adj]\n",
  "BAULKILY": "BAULKY, stubborn [adv]\n",
  "BAULKINESS": "the state of being baulky [n -ES]\n",
  "BAULKINESSES": "BAULKINESS, the state of being baulky [n]\n",
  "BAULKING": "BAULK, to refrain from proceeding, also BALK, BAUK [v]\n",
  "BAULKINGLY": "BAULKING, BAULK, to refrain from proceeding, also BALK, BAUK [adv]\n",
  "BAULKLINE": "a straight line across a billiard table behind which the cue balls are placed at the start of a game, also BALKLINE [n -S]\n",
  "BAULKLINES": "BAULKLINE, a straight line across a billiard table behind which the cue balls are placed at the start of a game, also BALKLINE [n]\n",
  "BAULKS": "BAULK, to refrain from proceeding, also BALK, BAUK [v]\n",
  "BAULKY": "stubborn [adj BAULKIER, BAULKIEST, BAULKILY]\n",
  "BAUR": "(Scots) a joke, amusing incident, also BAWR [n -S]\n",
  "BAURS": "BAUR, (Scots) a joke, amusing incident, also BAWR [n]\n",
  "BAUSOND": "of animals, having white spots on the forehead, also BAWSUNT [adj]\n",
  "BAUXITE": "an ore of aluminium, also BEAUXITE [n -S]\n",
  "BAUXITES": "BAUXITE, an ore of aluminium, also BEAUXITE [n]\n",
  "BAUXITIC": "of or like bauxite, an ore of aluminium [adj]\n",
  "BAVARDAGE": "(French) small talk or chitchat; idle chatter [n -S]\n",
  "BAVARDAGES": "BAVARDAGE, (French) small talk or chitchat; idle chatter [n]\n",
  "BAVAROIS": "a cold dessert consisting of a rich custard set with gelatine and flavoured in various ways [n -ES]\n",
  "BAVAROISES": "BAVAROIS, a cold dessert consisting of a rich custard set with gelatine and flavoured in various ways [n]\n",
  "BAVIN": "to tie brushwood into bundles [v -ED, -ING, -S]\n",
  "BAVINED": "BAVIN, to tie brushwood into bundles [v]\n",
  "BAVINING": "BAVIN, to tie brushwood into bundles [v]\n",
  "BAVINS": "BAVIN, to tie brushwood into bundles [v]\n",
  "BAWBEE": "(Scots) a halfpenny, also BAUBEE [n -S]\n",
  "BAWBEES": "BAWBEE, (Scots) a halfpenny, also BAUBEE [n]\n",
  "BAWBLE": "a cheap trinket, also BAUBLE [n -S]\n",
  "BAWBLES": "BAWBLE, a cheap trinket, also BAUBLE [n]\n",
  "BAWCOCK": "(Shakespeare) a fine fellow [n -S]\n",
  "BAWCOCKS": "BAWCOCK, (Shakespeare) a fine fellow [n]\n",
  "BAWD": "a female brothel-keeper [n -S]\n",
  "BAWDIER": "BAWDY, obscene [adj]\n",
  "BAWDIES": "BAWDY, obscene language [n]\n",
  "BAWDIEST": "BAWDY, obscene [adj]\n",
  "BAWDILY": "BAWDY, obscene [adv]\n",
  "BAWDINESS": "the state of being bawdy [n -ES]\n",
  "BAWDINESSES": "BAWDINESS, the state of being bawdy [n]\n",
  "BAWDKIN": "a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDACHINO, BALDAQUIN, BAUDEKIN [n -S]\n",
  "BAWDKINS": "BAWDKIN, a rich embroidered material, originally woven with woof of silk and warp of gold thread, also BALDACHIN, BALDACHINO, BALDAQUIN, BAUDEKIN [n]\n",
  "BAWDRIC": "a warrior's sword belt, also BALDRIC, BALDRICK, BAUDRIC, BAUDRICK [n -S]\n",
  "BAWDRICS": "BAWDRIC, a warrior's sword belt, also BALDRIC, BALDRICK, BAUDRIC, BAUDRICK [n]\n",
  "BAWDRIES": "BAWDRY, (archaic) lewd talk, procuring [n]\n",
  "BAWDRY": "(archaic) lewd talk, procuring [n BAWDRIES]\n",
  "BAWDS": "BAWD, a female brothel-keeper [n]\n",
  "BAWDY": "obscene [adj BAWDIER, BAWDIEST, BAWDILY] / obscene language [n BAWDIES]\n",
  "BAWDYHOUSE": "a brothel [n -S]\n",
  "BAWDYHOUSES": "BAWDYHOUSE, a brothel [n]\n",
  "BAWK": "an Atlantic seabird [n -S]\n",
  "BAWKS": "BAWK, an Atlantic seabird [n]\n",
  "BAWL": "to shout or cry very loudly [v -ED, -ING, -S]\n",
  "BAWLED": "BAWL, to shout or cry very loudly [v]\n",
  "BAWLER": "one who bawls [n -S]\n",
  "BAWLERS": "BAWLER, one who bawls [n]\n",
  "BAWLEY": "in Essex and Kent, a small fishing-smack [n -S]\n",
  "BAWLEYS": "BAWLEY, in Essex and Kent, a small fishing-smack [n]\n",
  "BAWLING": "loud crying [n -S]\n",
  "BAWLINGS": "BAWLING, loud crying [n]\n",
  "BAWLS": "BAWL, to shout or cry very loudly [v]\n",
  "BAWN": "(Irish) in Ireland, the fortification round a house, an enclosure for cattle [n -S]\n",
  "BAWNEEN": "(Irish) a white, close-woven woollen material used for making jackets, also BAININ [n -S]\n",
  "BAWNEENS": "BAWNEEN, (Irish) a white, close-woven woollen material used for making jackets, also BAININ [n]\n",
  "BAWNS": "BAWN, (Irish) in Ireland, the fortification round a house, an enclosure for cattle [n]\n",
  "BAWR": "(Scots) a joke, amusing incident, also BAUR [n -S]\n",
  "BAWRS": "BAWR, (Scots) a joke, amusing incident, also BAUR [n]\n",
  "BAWSUNT": "having white marks, also BAUSOND [adj]\n",
  "BAWTIE": "(Scots) a dog [n -S]\n",
  "BAWTIES": "BAWTIE, (Scots) a dog [n]\n",
  "BAWTY": "a kind of dog, also BAWTIE [n BAWTIES]\n",
  "BAXTER": "(obsolete) a baker [n -S]\n",
  "BAXTERS": "BAXTER, (obsolete) a baker [n]\n",
  "BAY": "of a certain colour [adj BAYER, BAYEST] / to bark or howl [v -ED, -ING, -S]\n",
  "BAYADEER": "(French) a fabric with horizontal stripes in strongly contrasting colours, also BAYADERE [n -S]\n",
  "BAYADEERS": "BAYADEER, (French) a fabric with horizontal stripes in strongly contrasting colours, also BAYADERE [n]\n",
  "BAYADERE": "(French) a fabric with horizontal stripes in strongly contrasting colours, also BAYADEER [n -S]\n",
  "BAYADERES": "BAYADERE, (French) a fabric with horizontal stripes in strongly contrasting colours, also BAYADEER [n]\n",
  "BAYAMO": "a strong wind, esp. one blowing from the bight of Bayamo (the capital city of Granma Province, Cuba) [n -S]\n",
  "BAYAMOS": "BAYAMO, a strong wind, esp. one blowing from the bight of Bayamo (the capital city of Granma Province, Cuba) [n]\n",
  "BAYARD": "a bay horse, or horse generally [n -S]\n",
  "BAYARDS": "BAYARD, a bay horse, or horse generally [n]\n",
  "BAYBERRIES": "BAYBERRY, the berry of the bay tree [n]\n",
  "BAYBERRY": "the berry of the bay tree [n BAYBERRIES]\n",
  "BAYE": "(Spenser) to bathe [v BAYED, BAYING, BAYES]\n",
  "BAYED": "BAY, to bark or howl [v]\n",
  "BAYER": "BAY, of a certain colour [adj]\n",
  "BAYES": "BAYE, (Spenser) to bathe [v]\n",
  "BAYEST": "BAY, of a certain colour [adj]\n",
  "BAYFRONT": "the shoreline of a bay [n -S]\n",
  "BAYFRONTS": "BAYFRONT, the shoreline of a bay [n]\n",
  "BAYING": "BAY, to bark or howl [v]\n",
  "BAYLE": "a pole, a barrier separating horses in a field [n -S]\n",
  "BAYLES": "BAYLE, a pole, a barrier separating horses in a field [n]\n",
  "BAYMAN": "a person who works about a bay [n BAYMEN]\n",
  "BAYMEN": "BAYMAN, a person who works about a bay [n]\n",
  "BAYNODDIES": "BAYNODDY, a bayman [n]\n",
  "BAYNODDY": "a bayman [n BAYNODDIES]\n",
  "BAYONET": "to stab with a daggerlike weapon [v BAYONETED or BAYONETTED, BAYONETING or BAYONETTING, BAYONETS]\n",
  "BAYONETED": "BAYONET, to stab with a daggerlike weapon [v]\n",
  "BAYONETING": "BAYONET, to stab with a daggerlike weapon [v]\n",
  "BAYONETS": "BAYONET, to stab with a daggerlike weapon [v]\n",
  "BAYONETTED": "BAYONET, to stab with a daggerlike weapon [v]\n",
  "BAYONETTING": "BAYONET, to stab with a daggerlike weapon [v]\n",
  "BAYOU": "(Native American) a marshy offshoot of a lake or river [n -S]\n",
  "BAYOUS": "BAYOU, (Native American) a marshy offshoot of a lake or river [n]\n",
  "BAYS": "BAY, to bark or howl [v]\n",
  "BAYSIDE": "the shore of a bay [n -S]\n",
  "BAYSIDES": "BAYSIDE, the shore of a bay [n]\n",
  "BAYT": "(Spenser) to bate, abate, also BATE [v -ED, -ING, -S]\n",
  "BAYTED": "BAYT, (Spenser) to bate, abate, also BATE [v]\n",
  "BAYTING": "BAYT, (Spenser) to bate, abate, also BATE [v]\n",
  "BAYTS": "BAYT, (Spenser) to bate, abate, also BATE [v]\n",
  "BAYWOOD": "a coarse mahogany [n -S]\n",
  "BAYWOODS": "BAYWOOD, a coarse mahogany [n]\n",
  "BAYWOP": "(offensive) in Newfoundland, a derogatory term for people coming from outport communities [n -S]\n",
  "BAYWOPS": "BAYWOP, (offensive) in Newfoundland, a derogatory term for people coming from outport communities [n]\n",
  "BAYYAN": "(Arabic) an official declaration in Islam [n -S]\n",
  "BAYYANS": "BAYYAN, (Arabic) an official declaration in Islam [n]\n",
  "BAZAAR": "(Persian) an Eastern marketplace, also BAZAR [n -S]\n",
  "BAZAARS": "BAZAAR, (Persian) an Eastern marketplace, also BAZAR [n]\n",
  "BAZAR": "(Persian) an Eastern market-place, also BAZAAR [n -S]\n",
  "BAZARS": "BAZAR, (Persian) an Eastern market-place, also BAZAAR [n]\n",
  "BAZAZZ": "flamboyance, also BEZZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "BAZAZZES": "BAZAZZ, flamboyance, also BEZZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n]\n",
  "BAZILLION": "an indefinitely large number [n -S]\n",
  "BAZILLIONS": "BAZILLION, an indefinitely large number [n]\n",
  "BAZOO": "(US slang) the mouth [n -S]\n",
  "BAZOOKA": "a small rocket launcher [n -S]\n",
  "BAZOOKAS": "BAZOOKA, a small rocket launcher [n]\n",
  "BAZOOM": "a woman's breast [n -S]\n",
  "BAZOOMS": "BAZOOM, a woman's breast [n]\n",
  "BAZOOS": "BAZOO, (US slang) the mouth [n]\n",
  "BAZOUKI": "(Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BOUSOUKI, BOUZOUKI, BUZUKI [n -S]\n",
  "BAZOUKIS": "BAZOUKI, (Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BOUSOUKI, BOUZOUKI, BUZUKI [n]\n",
  "BAZZ": "to throw (as a stone) [v -ED, -ING, -ES]\n",
  "BAZZAZZ": "panache, flamboyance, also BAZAZZ, BEZZAZZ, PAZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "BAZZAZZES": "BAZZAZZ, panache, flamboyance, also BAZAZZ, BEZZAZZ, PAZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n]\n",
  "BAZZED": "BAZZ, to throw (as a stone) [v]\n",
  "BAZZES": "BAZZ, to throw (as a stone) [v]\n",
  "BAZZING": "BAZZ, to throw (as a stone) [v]\n",
  "BDELLIUM": "(Latin) a fragrant gum resin from trees of the genus Commiphora [n -S]\n",
  "BDELLIUMS": "BDELLIUM, (Latin) a fragrant gum resin from trees of the genus Commiphora [n]\n",
  "BE": "to exist [v IS, ARE, BEING, WAS, (obsolete) WAST, (obsolete) WERT, WERE, BEEN, (obsolete) ART, AM]\n",
  "BEACH": "to drive onto the shore by a lake or the sea [v -ED, -ING, -ES]\n",
  "BEACHBALL": "a light ball for playing on a beach [n -S]\n",
  "BEACHBALLS": "BEACHBALL, a light ball for playing on a beach [n]\n",
  "BEACHBOY": "a male beach attendant [n -S]\n",
  "BEACHBOYS": "BEACHBOY, a male beach attendant [n]\n",
  "BEACHCOMB": "to wander along a beach looking for useful objects [v -ED, -ING, -S]\n",
  "BEACHCOMBED": "BEACHCOMB, to wander along a beach looking for useful objects [v]\n",
  "BEACHCOMBER": "a white man living as a drifter or loafer especially on the islands of the South Pacific [n -S]\n",
  "BEACHCOMBERS": "BEACHCOMBER, a white man living as a drifter or loafer especially on the islands of the South Pacific [n]\n",
  "BEACHCOMBING": "wandering along a beach looking for useful objects [n -S]\n",
  "BEACHCOMBINGS": "BEACHCOMBING, wandering along a beach looking for useful objects [n]\n",
  "BEACHCOMBS": "BEACHCOMB, to wander along a beach looking for useful objects [v]\n",
  "BEACHED": "BEACH, to drive onto the shore by a lake or the sea [v]\n",
  "BEACHES": "BEACH, to drive onto the shore by a lake or the sea [v]\n",
  "BEACHFRONT": "a strip of land that fronts a beach [n -S]\n",
  "BEACHFRONTS": "BEACHFRONT, a strip of land that fronts a beach [n]\n",
  "BEACHGOER": "one who frequents the beach [n -S]\n",
  "BEACHGOERS": "BEACHGOER, one who frequents the beach [n]\n",
  "BEACHHEAD": "an area held on an enemy's shore for the purpose of landing [n -S]\n",
  "BEACHHEADS": "BEACHHEAD, an area held on an enemy's shore for the purpose of landing [n]\n",
  "BEACHIER": "BEACHY, sandy or pebbly [adj]\n",
  "BEACHIEST": "BEACHY, sandy or pebbly [adj]\n",
  "BEACHING": "BEACH, to drive onto the shore by a lake or the sea [v]\n",
  "BEACHSIDE": "situated at the side of a beach [adj]\n",
  "BEACHWEAR": "wear suitable for the beach [n -S]\n",
  "BEACHWEARS": "BEACHWEAR, wear suitable for the beach [n]\n",
  "BEACHY": "sandy or pebbly [adj BEACHIER, BEACHIEST]\n",
  "BEACON": "to shine like a light on high [v -ED, -ING, -S]\n",
  "BEACONED": "BEACON, to shine like a light on high [v]\n",
  "BEACONING": "BEACON, to shine like a light on high [v]\n",
  "BEACONS": "BEACON, to shine like a light on high [v]\n",
  "BEAD": "to adorn with round balls of glass, wood or plastic [v -ED, -ING, -S]\n",
  "BEADBLAST": "a jet of small glass beads blown under pressure [n -S] / to clean with such a jet [v -ED, -ING, -S]\n",
  "BEADBLASTED": "BEADBLAST, to clean with such a jet [v]\n",
  "BEADBLASTER": "an apparatus used for beadblasting [n -S]\n",
  "BEADBLASTERS": "BEADBLASTER, an apparatus used for beadblasting [n]\n",
  "BEADBLASTING": "BEADBLAST, to clean with such a jet [v]\n",
  "BEADBLASTS": "BEADBLAST, to clean with such a jet [v]\n",
  "BEADED": "BEAD, to adorn with round balls of glass, wood or plastic [v]\n",
  "BEADER": "one who makes things with beads [n -S]\n",
  "BEADERS": "BEADER, one who makes things with beads [n]\n",
  "BEADHOUSE": "a chapel, also BEDEHOUSE [n -S]\n",
  "BEADHOUSES": "BEADHOUSE, a chapel, also BEDEHOUSE [n]\n",
  "BEADIER": "BEADY, resembling beads [adj]\n",
  "BEADIEST": "BEADY, resembling beads [adj]\n",
  "BEADILY": "BEADY, resembling beads [adv]\n",
  "BEADINESS": "the state of being beady [n -ES]\n",
  "BEADINESSES": "BEADINESS, the state of being beady [n]\n",
  "BEADING": "decoration in the form of or resembling beads [n -S]\n",
  "BEADINGS": "BEADING, decoration in the form of or resembling beads [n]\n",
  "BEADLE": "a minor parish official whose duties include ushering and preserving order, also BEDEL, BEDELL [n -S]\n",
  "BEADLEDOM": "the office of beadle, also BEADLEHOOD [n -S]\n",
  "BEADLEDOMS": "BEADLEDOM, the office of beadle, also BEADLEHOOD [n]\n",
  "BEADLEHOOD": "the office of beadle, also BEADLEDOM [n -S]\n",
  "BEADLEHOODS": "BEADLEHOOD, the office of beadle, also BEADLEDOM [n]\n",
  "BEADLES": "BEADLE, a minor parish official whose duties include ushering and preserving order, also BEDEL, BEDELL [n]\n",
  "BEADLESHIP": "the state of being, or the personality of, a beadle, also BEDELLSHIP, BEDELSHIP [n -S]\n",
  "BEADLESHIPS": "BEADLESHIP, the state of being, or the personality of, a beadle, also BEDELLSHIP, BEDELSHIP [n]\n",
  "BEADLIKE": "like a bead [adj]\n",
  "BEADMAN": "one who prays for another, also BEADSMAN, BEDEMAN, BEDESMAN [n BEADMEN]\n",
  "BEADMEN": "BEADMAN, one who prays for another, also BEADSMAN, BEDEMAN, BEDESMAN [n]\n",
  "BEADROLL": "a list of the dead to be prayed for [n -S]\n",
  "BEADROLLS": "BEADROLL, a list of the dead to be prayed for [n]\n",
  "BEADS": "BEAD, to adorn with round balls of glass, wood or plastic [v]\n",
  "BEADSMAN": "one who prays for another, also BEADMAN, BEDEMAN, BEDESMAN [n BEADSMEN]\n",
  "BEADSMEN": "BEADSMAN, one who prays for another, also BEADMAN, BEDEMAN, BEDESMAN [n]\n",
  "BEADSWOMAN": "a female beadsman, a monk or almoner who prays for a benefactor [n BEADSWOMEN]\n",
  "BEADSWOMEN": "BEADSWOMAN, a female beadsman, a monk or almoner who prays for a benefactor [n]\n",
  "BEADWORK": "decorative work done with beads [n -S]\n",
  "BEADWORKS": "BEADWORK, decorative work done with beads [n]\n",
  "BEADY": "resembling beads [adj BEADIER, BEADIEST, BEADILY]\n",
  "BEAGLE": "to hunt with a breed of dog, beagles [v BEAGLED, BEAGLING, BEAGLES]\n",
  "BEAGLED": "BEAGLE, to hunt with a breed of dog, beagles [v]\n",
  "BEAGLER": "one who hunts with beagles [n -S]\n",
  "BEAGLERS": "BEAGLER, one who hunts with beagles [n]\n",
  "BEAGLES": "BEAGLE, to hunt with a breed of dog, beagles [v]\n",
  "BEAGLING": "hunting with beagles [n -S]\n",
  "BEAGLINGS": "BEAGLING, hunting with beagles [n]\n",
  "BEAK": "a bird's bill [n -S]\n",
  "BEAKED": "having a beak [adj]\n",
  "BEAKER": "a large cup [n -S]\n",
  "BEAKERFUL": "the contents of a full beaker [n -S]\n",
  "BEAKERFULS": "BEAKERFUL, the contents of a full beaker [n]\n",
  "BEAKERS": "BEAKER, a large cup [n]\n",
  "BEAKIER": "BEAKY, resembling a beak [adj]\n",
  "BEAKIEST": "BEAKY, resembling a beak [adj]\n",
  "BEAKLESS": "without a beak [adj]\n",
  "BEAKLIKE": "like a beak [adj]\n",
  "BEAKS": "BEAK, a bird's bill [n]\n",
  "BEAKY": "resembling a beak [adj BEAKIER, BEAKIEST]\n",
  "BEAL": "an infected sore, also BEALING [n -S]\n",
  "BEALING": "an infected sore, also BEAL [n -S]\n",
  "BEALINGS": "BEALING, an infected sore, also BEAL [n]\n",
  "BEALS": "BEAL, an infected sore, also BEALING [n]\n",
  "BEAM": "to emit a ray of light [v -ED, -ING, -S]\n",
  "BEAMED": "BEAM, to emit a ray of light [v]\n",
  "BEAMER": "a workman or machine that puts yarn on the arm of a loom [n -S]\n",
  "BEAMERS": "BEAMER, a workman or machine that puts yarn on the arm of a loom [n]\n",
  "BEAMIER": "BEAMY, radiant [adj]\n",
  "BEAMIEST": "BEAMY, radiant [adj]\n",
  "BEAMILY": "radiantly [adv]\n",
  "BEAMINESS": "the state of being beamy [n -ES]\n",
  "BEAMINESSES": "BEAMINESS, the state of being beamy [n]\n",
  "BEAMING": "smiling broadly [adj BEAMINGLY] / the act of beaming [n -S]\n",
  "BEAMINGLY": "BEAMING, smiling broadly [adv]\n",
  "BEAMINGS": "BEAMING, the act of beaming [n]\n",
  "BEAMISH": "radiant [adj BEAMISHLY]\n",
  "BEAMISHLY": "BEAMISH, radiant [adv]\n",
  "BEAMLESS": "without beams [adj]\n",
  "BEAMLET": "a small beam of light [n -S]\n",
  "BEAMLETS": "BEAMLET, a small beam of light [n]\n",
  "BEAMLIKE": "like a beam [adj]\n",
  "BEAMS": "BEAM, to emit a ray of light [v]\n",
  "BEAMY": "radiant [adj BEAMIER, BEAMIEST, BEAMILY]\n",
  "BEAN": "to hit on the head [v -ED, -ING, -S]\n",
  "BEANBAG": "a small cloth bag containing dried beans and the like [n -S]\n",
  "BEANBAGS": "BEANBAG, a small cloth bag containing dried beans and the like [n]\n",
  "BEANBALL": "a baseball thrown at the head [n -S]\n",
  "BEANBALLS": "BEANBALL, a baseball thrown at the head [n]\n",
  "BEANED": "BEAN, to hit on the head [v]\n",
  "BEANERIES": "BEANERY, a cheap restaurant [n]\n",
  "BEANERY": "a cheap restaurant [n BEANERIES]\n",
  "BEANFEAST": "a lavish meal [n -S]\n",
  "BEANFEASTS": "BEANFEAST, a lavish meal [n]\n",
  "BEANIE": "a small close-fitting hat, also BEANY [n -S]\n",
  "BEANIES": "BEANIE, a small close-fitting hat, also BEANY [n]\n",
  "BEANING": "BEAN, to hit on the head [v]\n",
  "BEANLIKE": "like a bean [adj]\n",
  "BEANO": "(slang) a feast [n -S]\n",
  "BEANOS": "BEANO, (slang) a feast [n]\n",
  "BEANPOLE": "a pole support for climbing beans [n -S]\n",
  "BEANPOLES": "BEANPOLE, a pole support for climbing beans [n]\n",
  "BEANS": "BEAN, to hit on the head [v]\n",
  "BEANSPROUT": "the sprout of a newly germinated mung bean, eaten as a vegetable, esp. in Chinese dishes [n -S]\n",
  "BEANSPROUTS": "BEANSPROUT, the sprout of a newly germinated mung bean, eaten as a vegetable, esp. in Chinese dishes [n]\n",
  "BEANSTALK": "the stem of a bean plant [n -S]\n",
  "BEANSTALKS": "BEANSTALK, the stem of a bean plant [n]\n",
  "BEANY": "a small close-fitting hat, also BEANIE [n BEANIES]\n",
  "BEAR": "to endure [v BORE, BORN or BORNE or (archaic) YBORE, BEARING, BEARS] / to act like a bear (on the stock exchange) [v BEARED, BEARING, BEARS]\n",
  "BEARABILITIES": "BEARABILITY, the ability to be borne [n]\n",
  "BEARABILITY": "the ability to be borne [n BEARABILITIES]\n",
  "BEARABLE": "able to be borne [adj BEARABLY]\n",
  "BEARABLENESS": "the state of being bearable [n -ES]\n",
  "BEARABLENESSES": "BEARABLENESS, the state of being bearable [n]\n",
  "BEARABLY": "BEARABLE, able to be borne [adv]\n",
  "BEARBAITING": "the sport of tormenting bears with dogs [n -S]\n",
  "BEARBAITINGS": "BEARBAITING, the sport of tormenting bears with dogs [n]\n",
  "BEARBERRIES": "BEARBERRY, a trailing plant of the heath family, having leaves which are tonic and astringent, and glossy red berries of which bears are said to be fond [n]\n",
  "BEARBERRY": "a trailing plant of the heath family, having leaves which are tonic and astringent, and glossy red berries of which bears are said to be fond [n BEARBERRIES]\n",
  "BEARBINE": "a bindweed [n -S]\n",
  "BEARBINES": "BEARBINE, a bindweed [n]\n",
  "BEARCAT": "the lesser panda [n -S]\n",
  "BEARCATS": "BEARCAT, the lesser panda [n]\n",
  "BEARD": "hair on the lower face [n -S] / to oppose with effrontery [v -ED, -ING, -S]\n",
  "BEARDED": "BEARD, to oppose with effrontery [v]\n",
  "BEARDEDNESS": "the state of having a beard [n -ES]\n",
  "BEARDEDNESSES": "BEARDEDNESS, the state of having a beard [n]\n",
  "BEARDIE": "a fish, the bearded loach [n -S]\n",
  "BEARDIER": "BEARDY, having a beard [adj]\n",
  "BEARDIES": "BEARDIE, a fish, the bearded loach [n]\n",
  "BEARDIEST": "BEARDY, having a beard [adj]\n",
  "BEARDING": "BEARD, to oppose with effrontery [v]\n",
  "BEARDLESS": "without a beard [adj]\n",
  "BEARDLESSNESS": "the state of being beardless [n -ES]\n",
  "BEARDLESSNESSES": "BEARDLESSNESS, the state of being beardless [n]\n",
  "BEARDLIKE": "like a beard [adj]\n",
  "BEARDS": "BEARD, to oppose with effrontery [v]\n",
  "BEARDTONGUE": "a name for the flower penstemon [n -S]\n",
  "BEARDTONGUES": "BEARDTONGUE, a name for the flower penstemon [n]\n",
  "BEARDY": "a bearded person, also BEARDIE [n BEARDIES] / having a beard [adj BEARDIER, BEARDIEST]\n",
  "BEARE": "(Spenser) a burden; a bier [n -S]\n",
  "BEARED": "BEAR, to endure [v]\n",
  "BEARER": "one who bears [n -S]\n",
  "BEARERS": "BEARER, one who bears [n]\n",
  "BEARES": "BEARE, (Spenser) a burden; a bier [n]\n",
  "BEARGRASS": "a North American plant [n -ES]\n",
  "BEARGRASSES": "BEARGRASS, a North American plant [n]\n",
  "BEARHUG": "a firm embrace [n -S] / to embrace firmly [v BEARHUGGED, BEARHUGGING, BEARHUGS]\n",
  "BEARHUGGED": "BEARHUG, to embrace firmly [v]\n",
  "BEARHUGGING": "BEARHUG, to embrace firmly [v]\n",
  "BEARHUGS": "BEARHUG, a firm embrace [n]\n",
  "BEARING": "demeanour, carriage [n -S]\n",
  "BEARINGS": "BEARING, demeanour, carriage [n]\n",
  "BEARISH": "in the manner of a bear [adj BEARISHLY]\n",
  "BEARISHLY": "BEARISH, in the manner of a bear [adv]\n",
  "BEARISHNESS": "the state of being bearish [n -ES]\n",
  "BEARISHNESSES": "BEARISHNESS, the state of being bearish [n]\n",
  "BEARLIKE": "like a bear [adj]\n",
  "BEARNAISE": "(French) a rich white sauce flavoured with tarragon [n -S]\n",
  "BEARNAISES": "BEARNAISE, (French) a rich white sauce flavoured with tarragon [n]\n",
  "BEARPAW": "the paw of a bear [n -S]\n",
  "BEARPAWS": "BEARPAW, the paw of a bear [n]\n",
  "BEARS": "BEAR, to endure [v]\n",
  "BEARSKIN": "the pelt of a bear [n -S]\n",
  "BEARSKINS": "BEARSKIN, the pelt of a bear [n]\n",
  "BEARWARD": "a keeper of bears [n -S]\n",
  "BEARWARDS": "BEARWARD, a keeper of bears [n]\n",
  "BEARWOOD": "a small tree of the genus buckthorn [n -S]\n",
  "BEARWOODS": "BEARWOOD, a small tree of the genus buckthorn [n]\n",
  "BEAST": "to punish or torture (someone) in a manner that involves excessive physical exercise [v -ED, -ING, -S]\n",
  "BEASTED": "BEAST, to punish or torture (someone) in a manner that involves excessive physical exercise [v]\n",
  "BEASTHOOD": "the state or nature of a beast [n -S]\n",
  "BEASTHOODS": "BEASTHOOD, the state or nature of a beast [n]\n",
  "BEASTIE": "a small beast [n -S]\n",
  "BEASTIES": "BEASTIE, a small beast [n]\n",
  "BEASTILY": "bestially [adv]\n",
  "BEASTING": "BEAST, to punish or torture (someone) in a manner that involves excessive physical exercise [v]\n",
  "BEASTINGS": "the first milk drawn from a cow after calving, also BEESTINGS, BIESTINGS [n]\n",
  "BEASTLIER": "BEASTLY, resembling a beast [adj]\n",
  "BEASTLIEST": "BEASTLY, resembling a beast [adj]\n",
  "BEASTLIKE": "like a beast [adj]\n",
  "BEASTLINESS": "the state of being beastly [n -ES]\n",
  "BEASTLINESSES": "BEASTLINESS, the state of being beastly [n]\n",
  "BEASTLY": "resembling a beast [adj BEASTLIER, BEASTLIEST]\n",
  "BEASTS": "BEAST, to punish or torture (someone) in a manner that involves excessive physical exercise [v]\n",
  "BEAT": "to strike repeatedly [v BEATEN or BEAT, YBET, BEATING, BEATS]\n",
  "BEATABLE": "able to be beaten [adj]\n",
  "BEATBOX": "to use a kind of drum machine [v -ED, -ING, -ES]\n",
  "BEATBOXED": "BEATBOX, to use a kind of drum machine [v]\n",
  "BEATBOXER": "one who practises beatboxing, using a drum machine [n -S]\n",
  "BEATBOXERS": "BEATBOXER, one who practises beatboxing, using a drum machine [n]\n",
  "BEATBOXES": "BEATBOX, to use a kind of drum machine [v]\n",
  "BEATBOXING": "a form of hip-hop music in which the voice is used to simulate percussion instruments [n -S]\n",
  "BEATBOXINGS": "BEATBOXING, a form of hip-hop music in which the voice is used to simulate percussion instruments [n]\n",
  "BEATDOWN": "an overwhelming defeat [n -S]\n",
  "BEATDOWNS": "BEATDOWN, an overwhelming defeat [n]\n",
  "BEATEN": "BEAT, to strike repeatedly [v]\n",
  "BEATER": "one who beats [n -S]\n",
  "BEATERS": "BEATER, one who beats [n]\n",
  "BEATH": "(Spenser) to bathe, heat, also BATHE [v -ED, -ING, -S]\n",
  "BEATHED": "BEATH, (Spenser) to bathe, heat, also BATHE [v]\n",
  "BEATHING": "BEATH, (Spenser) to bathe, heat, also BATHE [v]\n",
  "BEATHS": "BEATH, (Spenser) to bathe, heat, also BATHE [v]\n",
  "BEATIER": "BEATY, of music, having a marked beat [adj]\n",
  "BEATIEST": "BEATY, of music, having a marked beat [adj]\n",
  "BEATIFIC": "making supremely happy, also BEATIFICAL [adj BEATIFICALLY]\n",
  "BEATIFICAL": "making supremely happy, also BEATIFIC [adj BEATIFICALLY]\n",
  "BEATIFICALLY": "BEATIFICAL, making supremely happy, also BEATIFIC [adv]\n",
  "BEATIFICATION": "the attainment of the blessedness of heaven, which bestows on the beatified person the title of \"blessed\" [n -S]\n",
  "BEATIFICATIONS": "BEATIFICATION, the attainment of the blessedness of heaven, which bestows on the beatified person the title of \"blessed\" [n]\n",
  "BEATIFIED": "BEATIFY, to make blessed [v]\n",
  "BEATIFIES": "BEATIFY, to make blessed [v]\n",
  "BEATIFY": "to make blessed [v BEATIFIED, BEATIFYING, BEATIFIES]\n",
  "BEATIFYING": "BEATIFY, to make blessed [v]\n",
  "BEATING": "a defeat [n -S]\n",
  "BEATINGS": "BEATING, a defeat [n]\n",
  "BEATITUDE": "a state of blessedness [n -S]\n",
  "BEATITUDES": "BEATITUDE, a state of blessedness [n]\n",
  "BEATLESS": "having no rhythm [adj]\n",
  "BEATNIK": "a member of the beat generation [n -S]\n",
  "BEATNIKS": "BEATNIK, a member of the beat generation [n]\n",
  "BEATS": "BEAT, to strike repeatedly [v]\n",
  "BEATY": "of music, having a marked beat [adj BEATIER, BEATIEST]\n",
  "BEAU": "(French) a boyfriend [n BEAUS or BEAUX]\n",
  "BEAUCOUP": "(French) many or much [adj] / a great amount [n -S]\n",
  "BEAUCOUPS": "BEAUCOUP, a great amount [n]\n",
  "BEAUFET": "(obsolete) a sideboard, also BEAUFFET [n -S]\n",
  "BEAUFETS": "BEAUFET, (obsolete) a sideboard, also BEAUFFET [n]\n",
  "BEAUFFET": "(obsolete) a sideboard, also BEAUFET [n -S]\n",
  "BEAUFFETS": "BEAUFFET, (obsolete) a sideboard, also BEAUFET [n]\n",
  "BEAUFIN": "a red cooking apple [n -S]\n",
  "BEAUFINS": "BEAUFIN, a red cooking apple [n]\n",
  "BEAUISH": "like a beau, foppish [adj]\n",
  "BEAUJOLAIS": "a kind of wine [n -ES]\n",
  "BEAUJOLAISES": "BEAUJOLAIS, a kind of wine [n]\n",
  "BEAUMONTAGE": "a composition for hiding cracks and holes in wood or iron, varying in makeup, also BEAUMONTAGUE [n -S]\n",
  "BEAUMONTAGES": "BEAUMONTAGE, a composition for hiding cracks and holes in wood or iron, varying in makeup, also BEAUMONTAGUE [n]\n",
  "BEAUMONTAGUE": "a composition for hiding cracks and holes in wood or iron, also BEAUMONTAGE [n -S]\n",
  "BEAUMONTAGUES": "BEAUMONTAGUE, a composition for hiding cracks and holes in wood or iron, also BEAUMONTAGE [n]\n",
  "BEAUS": "BEAU, (French) a boyfriend [n]\n",
  "BEAUT": "(colloquial) a beauty [n -S] / beautiful [adj BEAUTER, BEAUTEST]\n",
  "BEAUTEOUS": "beautiful [adj BEAUTEOUSLY]\n",
  "BEAUTEOUSLY": "BEAUTEOUS, beautiful [adv]\n",
  "BEAUTEOUSNESS": "the state of being beauteous [n -ES]\n",
  "BEAUTEOUSNESSES": "BEAUTEOUSNESS, the state of being beauteous [n]\n",
  "BEAUTER": "BEAUT, beautiful [adj]\n",
  "BEAUTEST": "BEAUT, beautiful [adj]\n",
  "BEAUTICIAN": "a person engaged in hairdressing, facial makeup, manicuring, etc. [n -S]\n",
  "BEAUTICIANS": "BEAUTICIAN, a person engaged in hairdressing, facial makeup, manicuring, etc. [n]\n",
  "BEAUTIED": "BEAUTY, (Shakespeare) to make beautiful [v]\n",
  "BEAUTIES": "BEAUTY, (Shakespeare) to make beautiful [v]\n",
  "BEAUTIFICATION": "the process of making beautiful, as done by e.g. a cosmetic surgeon [n -S]\n",
  "BEAUTIFICATIONS": "BEAUTIFICATION, the process of making beautiful, as done by e.g. a cosmetic surgeon [n]\n",
  "BEAUTIFIED": "BEAUTIFY, to make beautiful [v]\n",
  "BEAUTIFIER": "one who beautifies [n -S]\n",
  "BEAUTIFIERS": "BEAUTIFIER, one who beautifies [n]\n",
  "BEAUTIFIES": "BEAUTIFY, to make beautiful [v]\n",
  "BEAUTIFUL": "fair to look at [adj BEAUTIFULLER, BEAUTIFULLEST, BEAUTIFULLY]\n",
  "BEAUTIFULLER": "BEAUTIFUL, fair to look at [adj]\n",
  "BEAUTIFULLEST": "BEAUTIFUL, fair to look at [adj]\n",
  "BEAUTIFULLY": "BEAUTIFUL, fair to look at [adv]\n",
  "BEAUTIFULNESS": "the state of being beautiful [n -ES]\n",
  "BEAUTIFULNESSES": "BEAUTIFULNESS, the state of being beautiful [n]\n",
  "BEAUTIFY": "to make beautiful [v BEAUTIFIED, BEAUTIFYING, BEAUTIFIES]\n",
  "BEAUTIFYING": "BEAUTIFY, to make beautiful [v]\n",
  "BEAUTS": "BEAUT, (colloquial) a beauty [n]\n",
  "BEAUTY": "(Shakespeare) to make beautiful [v BEAUTIED, BEAUTYING, BEAUTIES]\n",
  "BEAUTYING": "BEAUTY, (Shakespeare) to make beautiful [v]\n",
  "BEAUX": "BEAU, (French) a boyfriend [n]\n",
  "BEAUXITE": "a claylike compound which is the main ore of aluminium, also BAUXITE [n -S]\n",
  "BEAUXITES": "BEAUXITE, a claylike compound which is the main ore of aluminium, also BAUXITE [n]\n",
  "BEAVER": "to work hard [v -ED, -ING, -S]\n",
  "BEAVERBOARD": "a building-board of wood fibre [n -S]\n",
  "BEAVERBOARDS": "BEAVERBOARD, a building-board of wood fibre [n]\n",
  "BEAVERED": "BEAVER, to work hard [v]\n",
  "BEAVERIES": "BEAVERY, a place where beavers are kept [n]\n",
  "BEAVERING": "BEAVER, to work hard [v]\n",
  "BEAVERS": "BEAVER, to work hard [v]\n",
  "BEAVERY": "a place where beavers are kept [n BEAVERIES]\n",
  "BEBEERINE": "an alkaloid yielded by the bebeeru tree [n -S]\n",
  "BEBEERINES": "BEBEERINE, an alkaloid yielded by the bebeeru tree [n]\n",
  "BEBEERU": "(Spanish) a tropical tree, aka greenheart [n -S]\n",
  "BEBEERUS": "BEBEERU, (Spanish) a tropical tree, aka greenheart [n]\n",
  "BEBLOOD": "to cover with blood [v -ED, -ING, -S]\n",
  "BEBLOODED": "BEBLOOD, to cover with blood [v]\n",
  "BEBLOODING": "BEBLOOD, to cover with blood [v]\n",
  "BEBLOODS": "BEBLOOD, to cover with blood [v]\n",
  "BEBLUBBERED": "disfigured from weeping [adj]\n",
  "BEBOP": "to play a style of jazz [v BEBOPPED, BEBOPPING, BEBOPS]\n",
  "BEBOPPED": "BEBOP, to play a style of jazz [v]\n",
  "BEBOPPER": "one who plays bebop, a kind of jazz music, also BOPPER [n -S]\n",
  "BEBOPPERS": "BEBOPPER, one who plays bebop, a kind of jazz music, also BOPPER [n]\n",
  "BEBOPPING": "BEBOP, to play a style of jazz [v]\n",
  "BEBOPS": "BEBOP, to play a style of jazz [v]\n",
  "BEBUNG": "(German) a tremolo effect on the clavichord [n -S]\n",
  "BEBUNGS": "BEBUNG, (German) a tremolo effect on the clavichord [n]\n",
  "BECALL": "to call names [v -ED, -ING, -S]\n",
  "BECALLED": "BECALL, to call names [v]\n",
  "BECALLING": "BECALL, to call names [v]\n",
  "BECALLS": "BECALL, to call names [v]\n",
  "BECALM": "to make calm [v -ED, -ING, -S]\n",
  "BECALMED": "BECALM, to make calm [v]\n",
  "BECALMING": "BECALM, to make calm [v]\n",
  "BECALMS": "BECALM, to make calm [v]\n",
  "BECAME": "BECOME, to come to be [v]\n",
  "BECAP": "to put a cap on [v BECAPPED, BECAPPING, BECAPS]\n",
  "BECAPPED": "BECAP, to put a cap on [v]\n",
  "BECAPPING": "BECAP, to put a cap on [v]\n",
  "BECAPS": "BECAP, to put a cap on [v]\n",
  "BECARPET": "to cover with a carpet [v -ED, -ING, -S]\n",
  "BECARPETED": "BECARPET, to cover with a carpet [v]\n",
  "BECARPETING": "BECARPET, to cover with a carpet [v]\n",
  "BECARPETS": "BECARPET, to cover with a carpet [v]\n",
  "BECASSE": "(French) a woodcock [n -S]\n",
  "BECASSES": "BECASSE, (French) a woodcock [n]\n",
  "BECAUSE": "for the reason that [conj]\n",
  "BECCACCIA": "(Italian) a woodcock [n -S]\n",
  "BECCACCIAS": "BECCACCIA, (Italian) a woodcock [n]\n",
  "BECCAFICO": "(Italian) a garden warbler or related bird, considered a delicacy by Italians [n -S]\n",
  "BECCAFICOS": "BECCAFICO, (Italian) a garden warbler or related bird, considered a delicacy by Italians [n]\n",
  "BECHALK": "to cover with chalk [v -ED, -ING, -S]\n",
  "BECHALKED": "BECHALK, to cover with chalk [v]\n",
  "BECHALKING": "BECHALK, to cover with chalk [v]\n",
  "BECHALKS": "BECHALK, to cover with chalk [v]\n",
  "BECHAMEL": "(French) a rich, white sauce, prepared with butter and cream [n -S]\n",
  "BECHAMELS": "BECHAMEL, (French) a rich, white sauce, prepared with butter and cream [n]\n",
  "BECHANCE": "to happen by chance [v BECHANCED, BECHANCING, BECHANCES]\n",
  "BECHANCED": "BECHANCE, to happen by chance [v]\n",
  "BECHANCES": "BECHANCE, to happen by chance [v]\n",
  "BECHANCING": "BECHANCE, to happen by chance [v]\n",
  "BECHARM": "to enchant [v -ED, -ING, -S]\n",
  "BECHARMED": "BECHARM, to enchant [v]\n",
  "BECHARMING": "BECHARM, to enchant [v]\n",
  "BECHARMS": "BECHARM, to enchant [v]\n",
  "BECK": "to beckon [v -ED, -ING, -S]\n",
  "BECKE": "(Spenser) a beak, also BEAK [n -S]\n",
  "BECKED": "BECK, to beckon [v]\n",
  "BECKES": "BECKE, (Spenser) a beak, also BEAK [n]\n",
  "BECKET": "a loop of rope having a knot at one end and an eye at the other [n -S]\n",
  "BECKETS": "BECKET, a loop of rope having a knot at one end and an eye at the other [n]\n",
  "BECKING": "BECK, to beckon [v]\n",
  "BECKON": "to indicate by sign [v -ED, -ING, -S]\n",
  "BECKONED": "BECKON, to indicate by sign [v]\n",
  "BECKONER": "one who beckons [n -S]\n",
  "BECKONERS": "BECKONER, one who beckons [n]\n",
  "BECKONING": "the act of signalling by sign or gesture [n -S]\n",
  "BECKONINGLY": "BECKONING [adv]\n",
  "BECKONINGS": "BECKONING, the act of signalling by sign or gesture [n]\n",
  "BECKONS": "BECKON, to indicate by sign [v]\n",
  "BECKS": "BECK, to beckon [v]\n",
  "BECLAMOR": "to beset with noise, also BECLAMOUR [v -ED, -ING, -S]\n",
  "BECLAMORED": "BECLAMOR, to beset with noise, also BECLAMOUR [v]\n",
  "BECLAMORING": "BECLAMOR, to beset with noise, also BECLAMOUR [v]\n",
  "BECLAMORS": "BECLAMOR, to beset with noise, also BECLAMOUR [v]\n",
  "BECLAMOUR": "to make a clamour, also BECLAMOR [v -ED, -ING, -S]\n",
  "BECLAMOURED": "BECLAMOUR, to make a clamour, also BECLAMOR [v]\n",
  "BECLAMOURING": "BECLAMOUR, to make a clamour, also BECLAMOR [v]\n",
  "BECLAMOURS": "BECLAMOUR, to make a clamour, also BECLAMOR [v]\n",
  "BECLASP": "to clasp, embrace [v -ED, -ING, -S]\n",
  "BECLASPED": "BECLASP, to clasp, embrace [v]\n",
  "BECLASPING": "BECLASP, to clasp, embrace [v]\n",
  "BECLASPS": "BECLASP, to clasp, embrace [v]\n",
  "BECLOAK": "to place a cloak on [v -ED, -ING, -S]\n",
  "BECLOAKED": "BECLOAK, to place a cloak on [v]\n",
  "BECLOAKING": "BECLOAK, to place a cloak on [v]\n",
  "BECLOAKS": "BECLOAK, to place a cloak on [v]\n",
  "BECLOG": "to clog up [v BECLOGGED, BECLOGGING, BECLOGS]\n",
  "BECLOGGED": "BECLOG, to clog up [v]\n",
  "BECLOGGING": "BECLOG, to clog up [v]\n",
  "BECLOGS": "BECLOG, to clog up [v]\n",
  "BECLOTHE": "to put clothes on [v BECLOTHED, BECLOTHING, BECLOTHES]\n",
  "BECLOTHED": "BECLOTHE, to put clothes on [v]\n",
  "BECLOTHES": "BECLOTHE, to put clothes on [v]\n",
  "BECLOTHING": "BECLOTHE, to put clothes on [v]\n",
  "BECLOUD": "to make dim, cloud [v -ED, -ING, -S]\n",
  "BECLOUDED": "BECLOUD, to make dim, cloud [v]\n",
  "BECLOUDING": "BECLOUD, to make dim, cloud [v]\n",
  "BECLOUDS": "BECLOUD, to make dim, cloud [v]\n",
  "BECLOWN": "to make ridiculous [v -ED, -ING, -S]\n",
  "BECLOWNED": "BECLOWN, to make ridiculous [v]\n",
  "BECLOWNING": "BECLOWN, to make ridiculous [v]\n",
  "BECLOWNS": "BECLOWN, to make ridiculous [v]\n",
  "BECOME": "to come to be [v BECAME, BECOMING, BECOMES]\n",
  "BECOMES": "BECOME, to come to be [v]\n",
  "BECOMING": "fitting [adj BECOMINGLY] / a process of change [n -S]\n",
  "BECOMINGLY": "BECOMING, fitting [adv]\n",
  "BECOMINGNESS": "the state of being becoming [n -ES]\n",
  "BECOMINGNESSES": "BECOMINGNESS, the state of being becoming [n]\n",
  "BECOMINGS": "BECOMING, a process of change [n]\n",
  "BECOWARD": "to accuse of cowardice [v -ED, -ING, -S]\n",
  "BECOWARDED": "BECOWARD, to accuse of cowardice [v]\n",
  "BECOWARDING": "BECOWARD, to accuse of cowardice [v]\n",
  "BECOWARDS": "BECOWARD, to accuse of cowardice [v]\n",
  "BECQUEREL": "(French) the SI unit of radioactivity [n -S]\n",
  "BECQUERELS": "BECQUEREL, (French) the SI unit of radioactivity [n]\n",
  "BECRAWL": "to creep over [v -ED, -ING, -S]\n",
  "BECRAWLED": "BECRAWL, to creep over [v]\n",
  "BECRAWLING": "BECRAWL, to creep over [v]\n",
  "BECRAWLS": "BECRAWL, to creep over [v]\n",
  "BECRIME": "to make guilty of a crime [v BECRIMED, BECRIMING, BECRIMES]\n",
  "BECRIMED": "BECRIME, to make guilty of a crime [v]\n",
  "BECRIMES": "BECRIME, to make guilty of a crime [v]\n",
  "BECRIMING": "BECRIME, to make guilty of a crime [v]\n",
  "BECROWD": "to press closely together [v -ED, -ING, -S]\n",
  "BECROWDED": "BECROWD, to press closely together [v]\n",
  "BECROWDING": "BECROWD, to press closely together [v]\n",
  "BECROWDS": "BECROWD, to press closely together [v]\n",
  "BECRUST": "to cover with a crust [v -ED, -ING, -S]\n",
  "BECRUSTED": "BECRUST, to cover with a crust [v]\n",
  "BECRUSTING": "BECRUST, to cover with a crust [v]\n",
  "BECRUSTS": "BECRUST, to cover with a crust [v]\n",
  "BECUDGEL": "to beat with a club [v BECUDGELED or BECUDGELLED, BECUDGELING or BECUDGELLING, BECUDGELS]\n",
  "BECUDGELED": "BECUDGEL, to beat with a club [v]\n",
  "BECUDGELING": "BECUDGEL, to beat with a club [v]\n",
  "BECUDGELLED": "BECUDGEL, to beat with a club [v]\n",
  "BECUDGELLING": "BECUDGEL, to beat with a club [v]\n",
  "BECUDGELS": "BECUDGEL, to beat with a club [v]\n",
  "BECURL": "to curl; to adorn with curls [v -ED, -ING, -S]\n",
  "BECURLED": "BECURL, to curl; to adorn with curls [v]\n",
  "BECURLING": "BECURL, to curl; to adorn with curls [v]\n",
  "BECURLS": "BECURL, to curl; to adorn with curls [v]\n",
  "BECURSE": "to put a curse on [v BECURSED, BECURST, BECURSING, BECURSES]\n",
  "BECURSED": "BECURSE, to put a curse on [v]\n",
  "BECURSES": "BECURSE, to put a curse on [v]\n",
  "BECURSING": "BECURSE, to put a curse on [v]\n",
  "BECURST": "BECURSE, to put a curse on [v]\n",
  "BED": "to provide with a receptacle for sleeping [v BEDDED, BEDDING, BEDS]\n",
  "BEDABBLE": "to make wet by dabbling [v BEDABBLED, BEDABBLING, BEDABBLES]\n",
  "BEDABBLED": "BEDABBLE, to make wet by dabbling [v]\n",
  "BEDABBLES": "BEDABBLE, to make wet by dabbling [v]\n",
  "BEDABBLING": "BEDABBLE, to make wet by dabbling [v]\n",
  "BEDAD": "an Irish oath, by God, also BEGAD [interj]\n",
  "BEDAGGLE": "to soil by dragging in the wet or dirt, also BEDRAGGLE [v BEDAGGLED, BEDAGGLING, BEDAGGLES]\n",
  "BEDAGGLED": "BEDAGGLE, to soil by dragging in the wet or dirt, also BEDRAGGLE [v]\n",
  "BEDAGGLES": "BEDAGGLE, to soil by dragging in the wet or dirt, also BEDRAGGLE [v]\n",
  "BEDAGGLING": "BEDAGGLE, to soil by dragging in the wet or dirt, also BEDRAGGLE [v]\n",
  "BEDAMN": "to swear at [v -ED, -ING, -S]\n",
  "BEDAMNED": "BEDAMN, to swear at [v]\n",
  "BEDAMNING": "BEDAMN, to swear at [v]\n",
  "BEDAMNS": "BEDAMN, to swear at [v]\n",
  "BEDARKEN": "to make dark [v -ED, -ING, -S]\n",
  "BEDARKENED": "BEDARKEN, to make dark [v]\n",
  "BEDARKENING": "BEDARKEN, to make dark [v]\n",
  "BEDARKENS": "BEDARKEN, to make dark [v]\n",
  "BEDASH": "to wet by dashing or throwing water or other liquid upon [v BEDASHED, BEDASHING, BEDASHES]\n",
  "BEDASHED": "BEDASH, to wet by dashing or throwing water or other liquid upon [v]\n",
  "BEDASHES": "BEDASH, to wet by dashing or throwing water or other liquid upon [v]\n",
  "BEDASHING": "BEDASH, to wet by dashing or throwing water or other liquid upon [v]\n",
  "BEDAUB": "to cover with daubs [v -ED, -ING, -S]\n",
  "BEDAUBED": "BEDAUB, to cover with daubs [v]\n",
  "BEDAUBING": "BEDAUB, to cover with daubs [v]\n",
  "BEDAUBS": "BEDAUB, to cover with daubs [v]\n",
  "BEDAWIN": "a nomadic Arab, also BEDOUIN, BEDU, BEDUIN [n -S]\n",
  "BEDAWINS": "BEDAWIN, a nomadic Arab, also BEDOUIN, BEDU, BEDUIN [n]\n",
  "BEDAZE": "to daze thoroughly [v BEDAZED, BEDAZING, BEDAZES]\n",
  "BEDAZED": "BEDAZE, to daze thoroughly [v]\n",
  "BEDAZES": "BEDAZE, to daze thoroughly [v]\n",
  "BEDAZING": "BEDAZE, to daze thoroughly [v]\n",
  "BEDAZZLE": "to dazzle or make dim by a strong light [v BEDAZZLED, BEDAZZLING, BEDAZZLES]\n",
  "BEDAZZLED": "BEDAZZLE, to dazzle or make dim by a strong light [v]\n",
  "BEDAZZLEMENT": "the state of being bedazzled [n -S]\n",
  "BEDAZZLEMENTS": "BEDAZZLEMENT, the state of being bedazzled [n]\n",
  "BEDAZZLES": "BEDAZZLE, to dazzle or make dim by a strong light [v]\n",
  "BEDAZZLING": "BEDAZZLE, to dazzle or make dim by a strong light [v]\n",
  "BEDBATH": "the washing of a sick person in their bed, a blanket bath [n -S]\n",
  "BEDBATHS": "BEDBATH, the washing of a sick person in their bed, a blanket bath [n]\n",
  "BEDBOARD": "a board placed between a mattress and a bedspring [n -S]\n",
  "BEDBOARDS": "BEDBOARD, a board placed between a mattress and a bedspring [n]\n",
  "BEDBUG": "a bloodsucking insect that infests beds [n -S]\n",
  "BEDBUGS": "BEDBUG, a bloodsucking insect that infests beds [n]\n",
  "BEDCHAIR": "a chair with adjustable back, for the sick, to support them while sitting up in bed [n -S]\n",
  "BEDCHAIRS": "BEDCHAIR, a chair with adjustable back, for the sick, to support them while sitting up in bed [n]\n",
  "BEDCHAMBER": "(archaic) a bedroom [n -S]\n",
  "BEDCHAMBERS": "BEDCHAMBER, (archaic) a bedroom [n]\n",
  "BEDCLOTHES": "the covering (as sheets and blankets) used on a bed [n]\n",
  "BEDCOVER": "a cover for a bed [n -S]\n",
  "BEDCOVERING": "linen etc. used to cover beds [n -S]\n",
  "BEDCOVERINGS": "BEDCOVERING, linen etc. used to cover beds [n]\n",
  "BEDCOVERS": "BEDCOVER, a cover for a bed [n]\n",
  "BEDDABLE": "sexually attractive [adj]\n",
  "BEDDED": "BED, to provide with a receptacle for sleeping [v]\n",
  "BEDDER": "one that makes up beds [n -S]\n",
  "BEDDERS": "BEDDER, one that makes up beds [n]\n",
  "BEDDING": "articles used in making up a bed [n -S]\n",
  "BEDDINGS": "BEDDING, articles used in making up a bed [n]\n",
  "BEDE": "(obsolete) a prayer [n -S]\n",
  "BEDEAFEN": "to make deaf [v -ED, -ING, -S]\n",
  "BEDEAFENED": "BEDEAFEN, to make deaf [v]\n",
  "BEDEAFENING": "BEDEAFEN, to make deaf [v]\n",
  "BEDEAFENS": "BEDEAFEN, to make deaf [v]\n",
  "BEDECK": "to attire with finery [v -ED, -ING, -S]\n",
  "BEDECKED": "BEDECK, to attire with finery [v]\n",
  "BEDECKING": "BEDECK, to attire with finery [v]\n",
  "BEDECKS": "BEDECK, to attire with finery [v]\n",
  "BEDEGUAR": "(French) a soft spongy gall formed on the branches of sweetbrier and other roses [n -S]\n",
  "BEDEGUARS": "BEDEGUAR, (French) a soft spongy gall formed on the branches of sweetbrier and other roses [n]\n",
  "BEDEHOUSE": "a chapel, also BEADHOUSE [n -S]\n",
  "BEDEHOUSES": "BEDEHOUSE, a chapel, also BEADHOUSE [n]\n",
  "BEDEL": "(obsolete) a minor parish official whose duties include ushering and preserving order, also BEADLE, BEDELL [n -S]\n",
  "BEDELL": "(obsolete) a minor parish official whose duties include ushering and preserving order, also BEADLE, BEDEL [n -S]\n",
  "BEDELLS": "BEDELL, (obsolete) a minor parish official whose duties include ushering and preserving order, also BEADLE, BEDEL [n]\n",
  "BEDELLSHIP": "the office of bedell, also BEADLESHIP, BEDELSHIP [n -S]\n",
  "BEDELLSHIPS": "BEDELLSHIP, the office of bedell, also BEADLESHIP, BEDELSHIP [n]\n",
  "BEDELS": "BEDEL, (obsolete) a minor parish official whose duties include ushering and preserving order, also BEADLE, BEDELL [n]\n",
  "BEDELSHIP": "the office of bedel, also BEADLESHIP, BEDELLSHIP [n -S]\n",
  "BEDELSHIPS": "BEDELSHIP, the office of bedel, also BEADLESHIP, BEDELLSHIP [n]\n",
  "BEDEMAN": "one who prays for another, also BEADMAN, BEADSMAN, BEDESMAN [n BEDEMEN]\n",
  "BEDEMEN": "BEDEMAN, one who prays for another, also BEADMAN, BEADSMAN, BEDESMAN [n]\n",
  "BEDERAL": "(Scots) a beadle, also BEDRAL [n -S]\n",
  "BEDERALS": "BEDERAL, (Scots) a beadle, also BEDRAL [n]\n",
  "BEDES": "BEDE, (obsolete) a prayer [n]\n",
  "BEDESMAN": "one who prays for another, also BEADMAN, BEADSMAN, BEDEMAN [n BEDESMEN]\n",
  "BEDESMEN": "BEDESMAN, one who prays for another, also BEADMAN, BEADSMAN, BEDEMAN [n]\n",
  "BEDEVIL": "to plague, torment [v BEDEVILLED or BEDEVILED, BEDEVILLING or BEDEVILING, BEDEVILS]\n",
  "BEDEVILED": "BEDEVIL, to plague, torment [v]\n",
  "BEDEVILING": "BEDEVIL, to plague, torment [v]\n",
  "BEDEVILLED": "BEDEVIL, to plague, torment [v]\n",
  "BEDEVILLING": "BEDEVIL, to plague, torment [v]\n",
  "BEDEVILMENT": "the state of being bedevilled [n -S]\n",
  "BEDEVILMENTS": "BEDEVILMENT, the state of being bedevilled [n]\n",
  "BEDEVILS": "BEDEVIL, to plague, torment [v]\n",
  "BEDEW": "to cover with dew [v -ED, -ING, -S]\n",
  "BEDEWED": "BEDEW, to cover with dew [v]\n",
  "BEDEWING": "BEDEW, to cover with dew [v]\n",
  "BEDEWS": "BEDEW, to cover with dew [v]\n",
  "BEDFAST": "confined to bed [adj]\n",
  "BEDFELLOW": "one who shares a bed [n -S]\n",
  "BEDFELLOWS": "BEDFELLOW, one who shares a bed [n]\n",
  "BEDFRAME": "the frame of a bed [n -S]\n",
  "BEDFRAMES": "BEDFRAME, the frame of a bed [n]\n",
  "BEDGOWN": "a nightgown [n -S]\n",
  "BEDGOWNS": "BEDGOWN, a nightgown [n]\n",
  "BEDHEAD": "the headboard of a bed [n -S]\n",
  "BEDHEADS": "BEDHEAD, the headboard of a bed [n]\n",
  "BEDIAPER": "to put a nappy on [v -ED, -ING, -S]\n",
  "BEDIAPERED": "BEDIAPER, to put a nappy on [v]\n",
  "BEDIAPERING": "BEDIAPER, to put a nappy on [v]\n",
  "BEDIAPERS": "BEDIAPER, to put a nappy on [v]\n",
  "BEDIDE": "BEDYE, to dye or stain [v]\n",
  "BEDIGHT": "(archaic) to equip, array, furnish [v -ED, -ING, -S]\n",
  "BEDIGHTED": "BEDIGHT, (archaic) to equip, array, furnish [v]\n",
  "BEDIGHTING": "BEDIGHT, (archaic) to equip, array, furnish [v]\n",
  "BEDIGHTS": "BEDIGHT, (archaic) to equip, array, furnish [v]\n",
  "BEDIM": "to make dim [v BEDIMMED, BEDIMMING, BEDIMS]\n",
  "BEDIMMED": "BEDIM, to make dim [v]\n",
  "BEDIMMING": "the act of making dim [n -S]\n",
  "BEDIMMINGS": "BEDIMMING, the act of making dim [n]\n",
  "BEDIMPLE": "to make a small impression in [v BEDIMPLED, BEDIMPLING, BEDIMPLES]\n",
  "BEDIMPLED": "BEDIMPLE, to make a small impression in [v]\n",
  "BEDIMPLES": "BEDIMPLE, to make a small impression in [v]\n",
  "BEDIMPLING": "BEDIMPLE, to make a small impression in [v]\n",
  "BEDIMS": "BEDIM, to make dim [v]\n",
  "BEDIRTIED": "BEDIRTY, to make dirty [v]\n",
  "BEDIRTIES": "BEDIRTY, to make dirty [v]\n",
  "BEDIRTY": "to make dirty [v BEDIRTIED, BEDIRTYING, BEDIRTIES]\n",
  "BEDIRTYING": "BEDIRTY, to make dirty [v]\n",
  "BEDIZEN": "to dress gaudily [v -ED, -ING, -S]\n",
  "BEDIZENED": "BEDIZEN, to dress gaudily [v]\n",
  "BEDIZENING": "BEDIZEN, to dress gaudily [v]\n",
  "BEDIZENMENT": "the act of bedizening [n -S]\n",
  "BEDIZENMENTS": "BEDIZENMENT, the act of bedizening [n]\n",
  "BEDIZENS": "BEDIZEN, to dress gaudily [v]\n",
  "BEDLAM": "pandemonium [n -S]\n",
  "BEDLAMER": "(Canadian) a young harp seal [n -S]\n",
  "BEDLAMERS": "BEDLAMER, (Canadian) a young harp seal [n]\n",
  "BEDLAMISM": "anything characteristic of madness [n -S]\n",
  "BEDLAMISMS": "BEDLAMISM, anything characteristic of madness [n]\n",
  "BEDLAMITE": "an inhabitant of a madhouse [n -S]\n",
  "BEDLAMITES": "BEDLAMITE, an inhabitant of a madhouse [n]\n",
  "BEDLAMP": "a reading light near a bed [n -S]\n",
  "BEDLAMPS": "BEDLAMP, a reading light near a bed [n]\n",
  "BEDLAMS": "BEDLAM, pandemonium [n]\n",
  "BEDLESS": "without a bed [adj]\n",
  "BEDLIKE": "resembling a bed [adj]\n",
  "BEDLINER": "a protective covering for the bed of a truck [n -S]\n",
  "BEDLINERS": "BEDLINER, a protective covering for the bed of a truck [n]\n",
  "BEDMAKER": "one who makes beds [n -S]\n",
  "BEDMAKERS": "BEDMAKER, one who makes beds [n]\n",
  "BEDMATE": "one who shares a bed [n -S]\n",
  "BEDMATES": "BEDMATE, one who shares a bed [n]\n",
  "BEDOTTED": "covered with dots [adj]\n",
  "BEDOUIN": "a nomadic Arab, also BEDAWIN, BEDU, BEDUIN [n -S]\n",
  "BEDOUINS": "BEDOUIN, a nomadic Arab, also BEDAWIN, BEDU, BEDUIN [n]\n",
  "BEDPAN": "a toilet pan for use in bed [n -S]\n",
  "BEDPANS": "BEDPAN, a toilet pan for use in bed [n]\n",
  "BEDPLATE": "a foundation framing or piece, by which the other parts are supported and held in place [n -S]\n",
  "BEDPLATES": "BEDPLATE, a foundation framing or piece, by which the other parts are supported and held in place [n]\n",
  "BEDPOST": "a post of a bed [n -S]\n",
  "BEDPOSTS": "BEDPOST, a post of a bed [n]\n",
  "BEDPRESSER": "(Shakespeare) a heavy, lazy fellow [n -S]\n",
  "BEDPRESSERS": "BEDPRESSER, (Shakespeare) a heavy, lazy fellow [n]\n",
  "BEDQUILT": "a quilt for a bed; a coverlet [n -S]\n",
  "BEDQUILTS": "BEDQUILT, a quilt for a bed; a coverlet [n]\n",
  "BEDRAGGLE": "to soil by dragging in the wet or dirt, also BEDAGGLE [v BEDRAGGLED, BEDRAGGLING, BEDRAGGLES]\n",
  "BEDRAGGLED": "BEDRAGGLE, to soil by dragging in the wet or dirt, also BEDAGGLE [v]\n",
  "BEDRAGGLES": "BEDRAGGLE, to soil by dragging in the wet or dirt, also BEDAGGLE [v]\n",
  "BEDRAGGLING": "BEDRAGGLE, to soil by dragging in the wet or dirt, also BEDAGGLE [v]\n",
  "BEDRAIL": "a rail that runs along the side of a bed [n -S]\n",
  "BEDRAILS": "BEDRAIL, a rail that runs along the side of a bed [n]\n",
  "BEDRAL": "(Scots) a beadle, also BEDERAL [n -S]\n",
  "BEDRALS": "BEDRAL, (Scots) a beadle, also BEDERAL [n]\n",
  "BEDRAPE": "to cover with cloth [v BEDRAPED, BEDRAPING, BEDRAPES]\n",
  "BEDRAPED": "BEDRAPE, to cover with cloth [v]\n",
  "BEDRAPES": "BEDRAPE, to cover with cloth [v]\n",
  "BEDRAPING": "BEDRAPE, to cover with cloth [v]\n",
  "BEDRENCH": "to wet thoroughly [v -ED, -ING, -ES]\n",
  "BEDRENCHED": "BEDRENCH, to wet thoroughly [v]\n",
  "BEDRENCHES": "BEDRENCH, to wet thoroughly [v]\n",
  "BEDRENCHING": "BEDRENCH, to wet thoroughly [v]\n",
  "BEDREST": "confinement to bed, for health reasons [n -S]\n",
  "BEDRESTS": "BEDREST, confinement to bed, for health reasons [n]\n",
  "BEDRID": "(obsolete) confined to bed, also BEDRIDDEN [adj]\n",
  "BEDRIDDEN": "confined to bed, also BEDRID [adj]\n",
  "BEDRIGHT": "(Shakespeare) the privilege or due of the marriage bed, also BEDRITE [n -S]\n",
  "BEDRIGHTS": "BEDRIGHT, (Shakespeare) the privilege or due of the marriage bed, also BEDRITE [n]\n",
  "BEDRITE": "the privilege or due of the marriage-bed, also BEDRIGHT [n -S]\n",
  "BEDRITES": "BEDRITE, the privilege or due of the marriage-bed, also BEDRIGHT [n]\n",
  "BEDRIVEL": "to cover with saliva [v BEDRIVELED or BEDRIVELLED, BEDRIVELING or BEDRIVELLING, BEDRIVELS]\n",
  "BEDRIVELED": "BEDRIVEL, to cover with saliva [v]\n",
  "BEDRIVELING": "BEDRIVEL, to cover with saliva [v]\n",
  "BEDRIVELLED": "BEDRIVEL, to cover with saliva [v]\n",
  "BEDRIVELLING": "BEDRIVEL, to cover with saliva [v]\n",
  "BEDRIVELS": "BEDRIVEL, to cover with saliva [v]\n",
  "BEDROCK": "the rock underlying other unconsolidated material, i.e. soil [n -S]\n",
  "BEDROCKS": "BEDROCK, the rock underlying other unconsolidated material, i.e. soil [n]\n",
  "BEDROLL": "a portable roll of bedding [n -S]\n",
  "BEDROLLS": "BEDROLL, a portable roll of bedding [n]\n",
  "BEDROOM": "a room for sleeping [n -S]\n",
  "BEDROOMED": "having a bedroom [adj]\n",
  "BEDROOMS": "BEDROOM, a room for sleeping [n]\n",
  "BEDROP": "to sprinkle as with drops [v BEDROPPED, BEDROPT, BEDROPPING, BEDROPS]\n",
  "BEDROPPED": "BEDROP, to sprinkle as with drops [v]\n",
  "BEDROPPING": "BEDROP, to sprinkle as with drops [v]\n",
  "BEDROPS": "BEDROP, to sprinkle as with drops [v]\n",
  "BEDROPT": "sprinkled as with drops [adj]\n",
  "BEDRUG": "to drug abundantly or excessively [v BEDRUGGED, BEDRUGGING, BEDRUGS]\n",
  "BEDRUGGED": "BEDRUG, to drug abundantly or excessively [v]\n",
  "BEDRUGGING": "BEDRUG, to drug abundantly or excessively [v]\n",
  "BEDRUGS": "BEDRUG, to drug abundantly or excessively [v]\n",
  "BEDS": "BED, to provide with a receptacle for sleeping [v]\n",
  "BEDSHEET": "a sheet for a bed [n -S]\n",
  "BEDSHEETS": "BEDSHEET, a sheet for a bed [n]\n",
  "BEDSIDE": "the side of a bed [n -S]\n",
  "BEDSIDES": "BEDSIDE, the side of a bed [n]\n",
  "BEDSIT": "a one-room dwelling serving as bedroom and sitting room [n -S]\n",
  "BEDSITS": "BEDSIT, a one-room dwelling serving as bedroom and sitting room [n]\n",
  "BEDSITTER": "a furnished room without a bed, also BEDSIT [n -S]\n",
  "BEDSITTERS": "BEDSITTER, a furnished room without a bed, also BEDSIT [n]\n",
  "BEDSITTING": "as in bedsitting room [adj]\n",
  "BEDSKIRT": "drapery attached to a bed frame [n -S]\n",
  "BEDSKIRTS": "BEDSKIRT, drapery attached to a bed frame [n]\n",
  "BEDSOCK": "a sock for wear in bed [n -S]\n",
  "BEDSOCKS": "socks worn in bed [n]\n",
  "BEDSONIA": "a kind of virus [n -S]\n",
  "BEDSONIAS": "BEDSONIA, a kind of virus [n]\n",
  "BEDSORE": "a type of sore caused by lying in bed [n -S]\n",
  "BEDSORES": "BEDSORE, a type of sore caused by lying in bed [n]\n",
  "BEDSPREAD": "a coverlet for a bed [n -S]\n",
  "BEDSPREADS": "BEDSPREAD, a coverlet for a bed [n]\n",
  "BEDSPRING": "the spring of a bed [n -S]\n",
  "BEDSPRINGS": "BEDSPRING, the spring of a bed [n]\n",
  "BEDSTAND": "a table beside a bed [n -S]\n",
  "BEDSTANDS": "BEDSTAND, a table beside a bed [n]\n",
  "BEDSTEAD": "a support for a bed [n -S]\n",
  "BEDSTEADS": "BEDSTEAD, a support for a bed [n]\n",
  "BEDSTRAW": "any of numerous straggling plants of the genus Galium, belonging to the madder family and bearing many tiny flowers [n -S]\n",
  "BEDSTRAWS": "BEDSTRAW, any of numerous straggling plants of the genus Galium, belonging to the madder family and bearing many tiny flowers [n]\n",
  "BEDTICK": "a tick or bag made of cloth, used for inclosing the materials of a bed [n -S]\n",
  "BEDTICKS": "BEDTICK, a tick or bag made of cloth, used for inclosing the materials of a bed [n]\n",
  "BEDTIME": "the time at which one goes to bed [n -S]\n",
  "BEDTIMES": "BEDTIME, the time at which one goes to bed [n]\n",
  "BEDU": "a nomadic Arab, also BEDOUIN, BEDAWIN, BEDUIN [n BEDU]\n",
  "BEDUCK": "to plunge under water [v -ED, -ING, -S]\n",
  "BEDUCKED": "BEDUCK, to plunge under water [v]\n",
  "BEDUCKING": "BEDUCK, to plunge under water [v]\n",
  "BEDUCKS": "BEDUCK, to plunge under water [v]\n",
  "BEDUIN": "a nomadic Arab, also BEDOUIN, BEDAWIN, BEDU [n -S]\n",
  "BEDUINS": "BEDUIN, a nomadic Arab, also BEDOUIN, BEDAWIN, BEDU [n]\n",
  "BEDUMB": "to render speechless [v -ED, -ING, -S]\n",
  "BEDUMBED": "BEDUMB, to render speechless [v]\n",
  "BEDUMBING": "BEDUMB, to render speechless [v]\n",
  "BEDUMBS": "BEDUMB, to render speechless [v]\n",
  "BEDUNCE": "to make a dunce of [v BEDUNCED, BEDUNCING, BEDUNCES]\n",
  "BEDUNCED": "BEDUNCE, to make a dunce of [v]\n",
  "BEDUNCES": "BEDUNCE, to make a dunce of [v]\n",
  "BEDUNCING": "BEDUNCE, to make a dunce of [v]\n",
  "BEDUNG": "to cover with dung [v -ED, -ING, -S]\n",
  "BEDUNGED": "BEDUNG, to cover with dung [v]\n",
  "BEDUNGING": "BEDUNG, to cover with dung [v]\n",
  "BEDUNGS": "BEDUNG, to cover with dung [v]\n",
  "BEDUST": "to cover with dust [v -ED, -ING, -S]\n",
  "BEDUSTED": "BEDUST, to cover with dust [v]\n",
  "BEDUSTING": "BEDUST, to cover with dust [v]\n",
  "BEDUSTS": "BEDUST, to cover with dust [v]\n",
  "BEDWARD": "towards bed [adv]\n",
  "BEDWARDS": "towards bed [adv]\n",
  "BEDWARF": "to make small by comparison [v -ED, -ING, -S]\n",
  "BEDWARFED": "BEDWARF, to make small by comparison [v]\n",
  "BEDWARFING": "BEDWARF, to make small by comparison [v]\n",
  "BEDWARFS": "BEDWARF, to make small by comparison [v]\n",
  "BEDWARMER": "a metal pan containing hot coals, formerly used to warm a bed [n -S]\n",
  "BEDWARMERS": "BEDWARMER, a metal pan containing hot coals, formerly used to warm a bed [n]\n",
  "BEDWETTER": "a person who urinates in bed [n -S]\n",
  "BEDWETTERS": "BEDWETTER, a person who urinates in bed [n]\n",
  "BEDYDE": "BEDYE, to dye or stain [v]\n",
  "BEDYE": "to dye or stain [v BEDYED or (Spenser) BEDIDE or BEDYDE, BEDYEING, BEDYES]\n",
  "BEDYED": "BEDYE, to dye or stain [v]\n",
  "BEDYEING": "BEDYE, to dye or stain [v]\n",
  "BEDYES": "BEDYE, to dye or stain [v]\n",
  "BEE": "a four-winged insect that makes honey [n -S]\n",
  "BEEBEE": "a pellet e.g. for an airgun [n -S]\n",
  "BEEBEES": "BEEBEE, a pellet e.g. for an airgun [n]\n",
  "BEEBREAD": "a mixture of pollen and nectar prepared by worker bees and fed to the larvae [n -S]\n",
  "BEEBREADS": "BEEBREAD, a mixture of pollen and nectar prepared by worker bees and fed to the larvae [n]\n",
  "BEECH": "a common forest tree [n -ES]\n",
  "BEECHDROPS": "an American plant like a broomrape, parasitic on beech roots [n]\n",
  "BEECHEN": "relating to a beech tree [adj]\n",
  "BEECHES": "BEECH, a common forest tree [n]\n",
  "BEECHIER": "BEECHY, abounding in beeches [adj]\n",
  "BEECHIEST": "BEECHY, abounding in beeches [adj]\n",
  "BEECHMAST": "the nuts of a beech tree [n -S]\n",
  "BEECHMASTS": "BEECHMAST, the nuts of a beech tree [n]\n",
  "BEECHNUT": "the nut of the beech [n -S]\n",
  "BEECHNUTS": "BEECHNUT, the nut of the beech [n]\n",
  "BEECHWOOD": "the wood of the beech [n -S]\n",
  "BEECHWOODS": "BEECHWOOD, the wood of the beech [n]\n",
  "BEECHY": "abounding in beeches [adj BEECHIER, BEECHIEST]\n",
  "BEEDI": "(Hindi) a hand rolled cigarette, also BIDI, BEEDIE [n BEEDIES]\n",
  "BEEDIE": "(Hindi) a cheap thin Indian cigarette, sometimes fruit-flavoured, also BIDI, BEEDI [n -S]\n",
  "BEEDIES": "BEEDIE, (Hindi) a cheap thin Indian cigarette, sometimes fruit-flavoured, also BIDI, BEEDI [n]\n",
  "BEEF": "to grumble [v -ED, -ING, -S] / a steer or cow [n BEEVES]\n",
  "BEEFALO": "a cross between a cow and a buffalo [n BEEFALOS or BEEFALOES]\n",
  "BEEFALOES": "BEEFALO, a cross between a cow and a buffalo [n]\n",
  "BEEFALOS": "BEEFALO, a cross between a cow and a buffalo [n]\n",
  "BEEFBURGER": "a round flat cake of minced meat, usually fried or grilled [n -S]\n",
  "BEEFBURGERS": "BEEFBURGER, a round flat cake of minced meat, usually fried or grilled [n]\n",
  "BEEFCAKE": "a picture of a male muscleman [n -S]\n",
  "BEEFCAKES": "BEEFCAKE, a picture of a male muscleman [n]\n",
  "BEEFEATER": "an African bird, aka oxpecker [n -S]\n",
  "BEEFEATERS": "BEEFEATER, an African bird, aka oxpecker [n]\n",
  "BEEFED": "BEEF, to grumble [v]\n",
  "BEEFIER": "BEEFY, thickly built [adj]\n",
  "BEEFIEST": "BEEFY, thickly built [adj]\n",
  "BEEFILY": "BEEFY, thickly built [adv]\n",
  "BEEFINESS": "the state of being beefy [n -ES]\n",
  "BEEFINESSES": "BEEFINESS, the state of being beefy [n]\n",
  "BEEFING": "BEEF, to grumble [v]\n",
  "BEEFLESS": "being without beef [adj]\n",
  "BEEFS": "BEEF, to grumble [v]\n",
  "BEEFSTEAK": "a thick lean slice of beef for grilling or frying [n -S]\n",
  "BEEFSTEAKS": "BEEFSTEAK, a thick lean slice of beef for grilling or frying [n]\n",
  "BEEFWOOD": "an Australian tree and its red wood, used for cabinetwork [n -S]\n",
  "BEEFWOODS": "BEEFWOOD, an Australian tree and its red wood, used for cabinetwork [n]\n",
  "BEEFY": "thickly built [adj BEEFIER, BEEFIEST, BEEFILY]\n",
  "BEEGAH": "(Hindi) an Indian land measure, also BIGHA [n -S]\n",
  "BEEGAHS": "BEEGAH, (Hindi) an Indian land measure, also BIGHA [n]\n",
  "BEEHIVE": "a hive for bees [n -S]\n",
  "BEEHIVED": "having a hairdo shaped like a beehive [adj]\n",
  "BEEHIVES": "BEEHIVE, a hive for bees [n]\n",
  "BEEKEEPER": "one who keeps bees [n -S]\n",
  "BEEKEEPERS": "BEEKEEPER, one who keeps bees [n]\n",
  "BEEKEEPING": "the act of keeping bees [n -S]\n",
  "BEEKEEPINGS": "BEEKEEPING, the act of keeping bees [n]\n",
  "BEELIKE": "resembling a bee [adj]\n",
  "BEELINE": "to head directly towards [v BEELINED, BEELINING, BEELINES]\n",
  "BEELINED": "BEELINE, to head directly towards [v]\n",
  "BEELINES": "BEELINE, to head directly towards [v]\n",
  "BEELINING": "BEELINE, to head directly towards [v]\n",
  "BEEN": "BE, to exist [v]\n",
  "BEENAH": "(Arabic) a form of marriage in Sri Lanka, in which the man goes to live with his wife's relatives [n -S]\n",
  "BEENAHS": "BEENAH, (Arabic) a form of marriage in Sri Lanka, in which the man goes to live with his wife's relatives [n]\n",
  "BEENTO": "in West Africa, a person who has resided in Britain, esp. as part of his education [n -S]\n",
  "BEENTOS": "BEENTO, in West Africa, a person who has resided in Britain, esp. as part of his education [n]\n",
  "BEEP": "to honk a horn [v -ED, -ING, -S]\n",
  "BEEPED": "BEEP, to honk a horn [v]\n",
  "BEEPER": "a paging device [n -S]\n",
  "BEEPERS": "BEEPER, a paging device [n]\n",
  "BEEPING": "BEEP, to honk a horn [v]\n",
  "BEEPS": "BEEP, to honk a horn [v]\n",
  "BEER": "an alcoholic drink made from malted barley flavoured with hops [n -S]\n",
  "BEERAGE": "the brewing industry [n -S]\n",
  "BEERAGES": "BEERAGE, the brewing industry [n]\n",
  "BEERFEST": "(US) a beer festival [n -S]\n",
  "BEERFESTS": "BEERFEST, (US) a beer festival [n]\n",
  "BEERHALL": "a large drinking place [n -S]\n",
  "BEERHALLS": "BEERHALL, a large drinking place [n]\n",
  "BEERIER": "BEERY, smelling of beer [adj]\n",
  "BEERIEST": "BEERY, smelling of beer [adj]\n",
  "BEERILY": "BEERY, smelling of beer [adv]\n",
  "BEERINESS": "the quality of being beery [n -ES]\n",
  "BEERINESSES": "BEERINESS, the quality of being beery [n]\n",
  "BEERMAT": "a cardboard mat to put under a glass of beer [n -S]\n",
  "BEERMATS": "BEERMAT, a cardboard mat to put under a glass of beer [n]\n",
  "BEERNUT": "a peanut with a sweet coating [n -S]\n",
  "BEERNUTS": "BEERNUT, a peanut with a sweet coating [n]\n",
  "BEERS": "BEER, an alcoholic drink made from malted barley flavoured with hops [n]\n",
  "BEERSIES": "(New Zealand) slang for beers [n]\n",
  "BEERY": "smelling of beer [adj BEERIER, BEERIEST, BEERILY]\n",
  "BEES": "BEE, a four-winged insect that makes honey [n]\n",
  "BEESOME": "(Shakespeare) supposedly for bisson, blind, also BISSON [adj]\n",
  "BEESTING": "as in beesting lips, pouting or sensuous lips, also BEESTUNG [adj]\n",
  "BEESTINGS": "the first milk drawn from a cow after calving, aka colostrum or foremilk, also BEASTINGS, BIESTINGS [n]\n",
  "BEESTUNG": "as in beestung lips, pouting or sensuous lips, also BEESTING [adj]\n",
  "BEESWAX": "to polish with the wax of bees [v -ED, -ING, -ES]\n",
  "BEESWAXED": "BEESWAX, to polish with the wax of bees [v]\n",
  "BEESWAXES": "BEESWAX, to polish with the wax of bees [v]\n",
  "BEESWAXING": "BEESWAX, to polish with the wax of bees [v]\n",
  "BEESWING": "a crust that forms on old wines [n -S]\n",
  "BEESWINGED": "of wine, so old as to show beeswing, a crust [adj]\n",
  "BEESWINGS": "BEESWING, a crust that forms on old wines [n]\n",
  "BEET": "to improve or mend, esp. a fire [v -ED, -ING, -S]\n",
  "BEETED": "BEET, to improve or mend, esp. a fire [v]\n",
  "BEETFLIES": "BEETFLY, a fly which attacks beet plants [n]\n",
  "BEETFLY": "a fly which attacks beet plants [n BEETFLIES]\n",
  "BEETING": "BEET, to improve or mend, esp. a fire [v]\n",
  "BEETLE": "to jut out, overhang [v BEETLED, BEETLING, BEETLES]\n",
  "BEETLEBRAIN": "a heavy stupid person, also BEETLEHEAD [n -S]\n",
  "BEETLEBRAINED": "stupid [adj]\n",
  "BEETLEBRAINS": "BEETLEBRAIN, a heavy stupid person, also BEETLEHEAD [n]\n",
  "BEETLED": "BEETLE, to jut out, overhang [v]\n",
  "BEETLEHEAD": "a heavy stupid person, also BEETLEBRAIN [n -S]\n",
  "BEETLEHEADED": "like a beetlehead, stupid [adj]\n",
  "BEETLEHEADS": "BEETLEHEAD, a heavy stupid person, also BEETLEBRAIN [n]\n",
  "BEETLER": "an operator of a cloth-finishing machine [n -S]\n",
  "BEETLERS": "BEETLER, an operator of a cloth-finishing machine [n]\n",
  "BEETLES": "BEETLE, to jut out, overhang [v]\n",
  "BEETLING": "BEETLE, to jut out, overhang [v]\n",
  "BEETMASTER": "(Scots) a help in need, also BEETMISTER [n -S]\n",
  "BEETMASTERS": "BEETMASTER, (Scots) a help in need, also BEETMISTER [n]\n",
  "BEETMISTER": "(Scots) a help in need, also BEETMASTER [n -S]\n",
  "BEETMISTERS": "BEETMISTER, (Scots) a help in need, also BEETMASTER [n]\n",
  "BEETROOT": "the dark-red root of the beet plant eaten as a vegetable [n -S]\n",
  "BEETROOTS": "BEETROOT, the dark-red root of the beet plant eaten as a vegetable [n]\n",
  "BEETS": "BEET, to improve or mend, esp. a fire [v]\n",
  "BEEVES": "BEEF, a steer or cow [n]\n",
  "BEEYARD": "an apiary [n -S]\n",
  "BEEYARDS": "BEEYARD, an apiary [n]\n",
  "BEEZER": "(Scots) something of exceptional quality [n -S]\n",
  "BEEZERS": "BEEZER, (Scots) something of exceptional quality [n]\n",
  "BEFALL": "to happen or occur to [v BEFELL or BEFELD, BEFALLEN or BEFELD, BEFALLING, BEFALLS]\n",
  "BEFALLEN": "BEFALL, to happen or occur to [v]\n",
  "BEFALLING": "BEFALL, to happen or occur to [v]\n",
  "BEFALLS": "BEFALL, to happen or occur to [v]\n",
  "BEFANA": "(Italian) an Epiphany gift, also BEFFANA [n -S]\n",
  "BEFANAS": "BEFANA, (Italian) an Epiphany gift, also BEFFANA [n]\n",
  "BEFELD": "BEFALL, to happen or occur to [v]\n",
  "BEFELL": "BEFALL, to happen or occur to [v]\n",
  "BEFFANA": "(Italian) an Epiphany gift, also BEFANA [n -S]\n",
  "BEFFANAS": "BEFFANA, (Italian) an Epiphany gift, also BEFANA [n]\n",
  "BEFINGER": "to touch all over [v -ED, -ING, -S]\n",
  "BEFINGERED": "BEFINGER, to touch all over [v]\n",
  "BEFINGERING": "BEFINGER, to touch all over [v]\n",
  "BEFINGERS": "BEFINGER, to touch all over [v]\n",
  "BEFINNED": "having fins [adj]\n",
  "BEFIT": "to be suitable for [v BEFITTED, BEFITTING, BEFITS]\n",
  "BEFITS": "BEFIT, to be suitable for [v]\n",
  "BEFITTED": "BEFIT, to be suitable for [v]\n",
  "BEFITTING": "BEFIT, to be suitable for [v]\n",
  "BEFITTINGLY": "BEFITTING, BEFIT, to be suitable for [adv]\n",
  "BEFLAG": "to deck with flags [v BEFLAGGED, BEFLAGGING, BEFLAGS]\n",
  "BEFLAGGED": "BEFLAG, to deck with flags [v]\n",
  "BEFLAGGING": "BEFLAG, to deck with flags [v]\n",
  "BEFLAGS": "BEFLAG, to deck with flags [v]\n",
  "BEFLEA": "to infest with fleas [v -ED, -ING, -S]\n",
  "BEFLEAED": "BEFLEA, to infest with fleas [v]\n",
  "BEFLEAING": "BEFLEA, to infest with fleas [v]\n",
  "BEFLEAS": "BEFLEA, to infest with fleas [v]\n",
  "BEFLECK": "to cover with flecks [v -ED, -ING, -S]\n",
  "BEFLECKED": "BEFLECK, to cover with flecks [v]\n",
  "BEFLECKING": "BEFLECK, to cover with flecks [v]\n",
  "BEFLECKS": "BEFLECK, to cover with flecks [v]\n",
  "BEFLOWER": "to cover with flowers [v -ED, -ING, -S]\n",
  "BEFLOWERED": "BEFLOWER, to cover with flowers [v]\n",
  "BEFLOWERING": "BEFLOWER, to cover with flowers [v]\n",
  "BEFLOWERS": "BEFLOWER, to cover with flowers [v]\n",
  "BEFLUM": "(Scott) to befool, cajole [v BEFLUMMED, BEFLUMMING, BEFLUMS]\n",
  "BEFLUMMED": "BEFLUM, (Scott) to befool, cajole [v]\n",
  "BEFLUMMING": "BEFLUM, (Scott) to befool, cajole [v]\n",
  "BEFLUMS": "BEFLUM, (Scott) to befool, cajole [v]\n",
  "BEFOAM": "to cover with foam [v -ED, -ING, -S]\n",
  "BEFOAMED": "BEFOAM, to cover with foam [v]\n",
  "BEFOAMING": "BEFOAM, to cover with foam [v]\n",
  "BEFOAMS": "BEFOAM, to cover with foam [v]\n",
  "BEFOG": "to fog up, obscure [v BEFOGGED, BEFOGGING, BEFOGS]\n",
  "BEFOGGED": "BEFOG, to fog up, obscure [v]\n",
  "BEFOGGING": "BEFOG, to fog up, obscure [v]\n",
  "BEFOGS": "BEFOG, to fog up, obscure [v]\n",
  "BEFOOL": "to fool; to delude or lead into error [v -ED, -ING, -S]\n",
  "BEFOOLED": "BEFOOL, to fool; to delude or lead into error [v]\n",
  "BEFOOLING": "BEFOOL, to fool; to delude or lead into error [v]\n",
  "BEFOOLS": "BEFOOL, to fool; to delude or lead into error [v]\n",
  "BEFORE": "in front of [prep]\n",
  "BEFOREHAND": "before a particular time [adv]\n",
  "BEFORETIME": "(archaic) formerly [adv]\n",
  "BEFORTUNE": "(Shakespeare) to befall [v BEFORTUNED, BEFORTUNING, BEFORTUNES]\n",
  "BEFORTUNED": "BEFORTUNE, (Shakespeare) to befall [v]\n",
  "BEFORTUNES": "BEFORTUNE, (Shakespeare) to befall [v]\n",
  "BEFORTUNING": "BEFORTUNE, (Shakespeare) to befall [v]\n",
  "BEFOUL": "to make foul [v -ED, -ING, -S]\n",
  "BEFOULED": "BEFOUL, to make foul [v]\n",
  "BEFOULER": "one who befouls [n -S]\n",
  "BEFOULERS": "BEFOULER, one who befouls [n]\n",
  "BEFOULING": "BEFOUL, to make foul [v]\n",
  "BEFOULMENT": "the act of befouling [n -S]\n",
  "BEFOULMENTS": "BEFOULMENT, the act of befouling [n]\n",
  "BEFOULS": "BEFOUL, to make foul [v]\n",
  "BEFRET": "to gnaw [v BEFRETTED, BEFRETTING, BEFRETS]\n",
  "BEFRETS": "BEFRET, to gnaw [v]\n",
  "BEFRETTED": "BEFRET, to gnaw [v]\n",
  "BEFRETTING": "BEFRET, to gnaw [v]\n",
  "BEFRIEND": "to act as a friend to [v -ED, -ING, -S]\n",
  "BEFRIENDED": "BEFRIEND, to act as a friend to [v]\n",
  "BEFRIENDER": "one who befriends others [n -S]\n",
  "BEFRIENDERS": "BEFRIENDER, one who befriends others [n]\n",
  "BEFRIENDING": "BEFRIEND, to act as a friend to [v]\n",
  "BEFRIENDS": "BEFRIEND, to act as a friend to [v]\n",
  "BEFRINGE": "to adorn with fringes [v BEFRINGED, BEFRINGING, BEFRINGES]\n",
  "BEFRINGED": "BEFRINGE, to adorn with fringes [v]\n",
  "BEFRINGES": "BEFRINGE, to adorn with fringes [v]\n",
  "BEFRINGING": "BEFRINGE, to adorn with fringes [v]\n",
  "BEFUDDLE": "to confuse [v BEFUDDLED, BEFUDDLING, BEFUDDLES]\n",
  "BEFUDDLED": "BEFUDDLE, to confuse [v]\n",
  "BEFUDDLEMENT": "the state of being befuddled [n -S]\n",
  "BEFUDDLEMENTS": "BEFUDDLEMENT, the state of being befuddled [n]\n",
  "BEFUDDLES": "BEFUDDLE, to confuse [v]\n",
  "BEFUDDLING": "BEFUDDLE, to confuse [v]\n",
  "BEG": "to ask for [v BEGGED, BEGGING, BEGS]\n",
  "BEGAD": "(Shakespeare) an interjection, by God, also BEDAD [interj]\n",
  "BEGALL": "to make sore by rubbing [v -ED, -ING, -S]\n",
  "BEGALLED": "BEGALL, to make sore by rubbing [v]\n",
  "BEGALLING": "BEGALL, to make sore by rubbing [v]\n",
  "BEGALLS": "BEGALL, to make sore by rubbing [v]\n",
  "BEGAN": "BEGIN, to start [v]\n",
  "BEGAR": "(Hindi) forced labour in India [n -S]\n",
  "BEGARS": "BEGAR, (Hindi) forced labour in India [n]\n",
  "BEGAT": "BEGET, to cause to exist [v]\n",
  "BEGAZE": "to look at fixedly [v BEGAZED, BEGAZING, BEGAZES]\n",
  "BEGAZED": "BEGAZE, to look at fixedly [v]\n",
  "BEGAZES": "BEGAZE, to look at fixedly [v]\n",
  "BEGAZING": "BEGAZE, to look at fixedly [v]\n",
  "BEGEM": "to adorn with gems [v BEGEMMED, BEGEMMING, BEGEMS]\n",
  "BEGEMMED": "BEGEM, to adorn with gems [v]\n",
  "BEGEMMING": "BEGEM, to adorn with gems [v]\n",
  "BEGEMS": "BEGEM, to adorn with gems [v]\n",
  "BEGET": "to cause to exist [v BEGAT or BEGOT, BEGOTTEN, BEGETTING, BEGETS]\n",
  "BEGETS": "BEGET, to cause to exist [v]\n",
  "BEGETTER": "one who begets [n -S]\n",
  "BEGETTERS": "BEGETTER, one who begets [n]\n",
  "BEGETTING": "BEGET, to cause to exist [v]\n",
  "BEGGAR": "to impoverish [v -ED, -ING, -S]\n",
  "BEGGARDOM": "the state of being a beggar [n -S]\n",
  "BEGGARDOMS": "BEGGARDOM, the state of being a beggar [n]\n",
  "BEGGARED": "BEGGAR, to impoverish [v]\n",
  "BEGGARHOOD": "the state of being a beggar [n -S]\n",
  "BEGGARHOODS": "BEGGARHOOD, the state of being a beggar [n]\n",
  "BEGGARIES": "BEGGARY, extreme poverty [n]\n",
  "BEGGARING": "BEGGAR, to impoverish [v]\n",
  "BEGGARLIER": "BEGGARLY, like a beggar, very poor [adj]\n",
  "BEGGARLIEST": "BEGGARLY, like a beggar, very poor [adj]\n",
  "BEGGARLINESS": "the state of being beggarly [n -ES]\n",
  "BEGGARLINESSES": "BEGGARLINESS, the state of being beggarly [n]\n",
  "BEGGARLY": "like a beggar, very poor [adj BEGGARLIER, BEGGARLIEST]\n",
  "BEGGARS": "BEGGAR, to impoverish [v]\n",
  "BEGGARWEED": "any of various plants, such as knotweed, spurrey or dodder, that grows on waste ground [n -S]\n",
  "BEGGARWEEDS": "BEGGARWEED, any of various plants, such as knotweed, spurrey or dodder, that grows on waste ground [n]\n",
  "BEGGARY": "extreme poverty [n BEGGARIES]\n",
  "BEGGED": "BEG, to ask for [v]\n",
  "BEGGING": "the act of begging [n -S]\n",
  "BEGGINGLY": "BEGGING [adv]\n",
  "BEGGINGS": "BEGGING, the act of begging [n]\n",
  "BEGHARD": "(French) in Flanders, a man living a monastic life without vows and with power to return to the world, also BEGUIN [n -S]\n",
  "BEGHARDS": "BEGHARD, (French) in Flanders, a man living a monastic life without vows and with power to return to the world, also BEGUIN [n]\n",
  "BEGIFT": "to present with gifts [v -ED, -ING, -S]\n",
  "BEGIFTED": "BEGIFT, to present with gifts [v]\n",
  "BEGIFTING": "BEGIFT, to present with gifts [v]\n",
  "BEGIFTS": "BEGIFT, to present with gifts [v]\n",
  "BEGILD": "to gild [v BEGILT or BEGILDED, BEGILDING, BEGILDS]\n",
  "BEGILDED": "BEGILD, to gild [v]\n",
  "BEGILDING": "BEGILD, to gild [v]\n",
  "BEGILDS": "BEGILD, to gild [v]\n",
  "BEGILT": "BEGILD, to gild [v]\n",
  "BEGIN": "to start [v BEGAN, BEGUN, BEGINNING, BEGINS]\n",
  "BEGINNE": "(Spenser) a beginning [n -S]\n",
  "BEGINNER": "one who begins, a novice [n -S]\n",
  "BEGINNERS": "BEGINNER, one who begins, a novice [n]\n",
  "BEGINNES": "BEGINNE, (Spenser) a beginning [n]\n",
  "BEGINNING": "the start of something [n -S]\n",
  "BEGINNINGLESS": "without a beginning [adj]\n",
  "BEGINNINGS": "BEGINNING, the start of something [n]\n",
  "BEGINS": "BEGIN, to start [v]\n",
  "BEGIRD": "(archaic) to bind with a band or girdle [v BEGIRDED or BEGIRT, BEGIRDING, BEGIRDS]\n",
  "BEGIRDED": "BEGIRD, (archaic) to bind with a band or girdle [v]\n",
  "BEGIRDING": "BEGIRD, (archaic) to bind with a band or girdle [v]\n",
  "BEGIRDLE": "to surround as with a girdle [v BEGIRDLED, BEGIRDLING, BEGIRDLES]\n",
  "BEGIRDLED": "BEGIRDLE, to surround as with a girdle [v]\n",
  "BEGIRDLES": "BEGIRDLE, to surround as with a girdle [v]\n",
  "BEGIRDLING": "BEGIRDLE, to surround as with a girdle [v]\n",
  "BEGIRDS": "BEGIRD, (archaic) to bind with a band or girdle [v]\n",
  "BEGIRT": "BEGIRD, (archaic) to bind with a band or girdle [v]\n",
  "BEGLAD": "to make glad [v BEGLADDED, BEGLADDING, BEGLADS]\n",
  "BEGLADDED": "BEGLAD, to make glad [v]\n",
  "BEGLADDING": "BEGLAD, to make glad [v]\n",
  "BEGLADS": "BEGLAD, to make glad [v]\n",
  "BEGLAMOR": "to dazzle with glamor [v -ED, -ING, -S]\n",
  "BEGLAMORED": "BEGLAMOR, to dazzle with glamor [v]\n",
  "BEGLAMORING": "BEGLAMOR, to dazzle with glamor [v]\n",
  "BEGLAMORS": "BEGLAMOR, to dazzle with glamor [v]\n",
  "BEGLAMOUR": "to impress with glamour, also BEGLAMOR [v -ED, -ING, -S]\n",
  "BEGLAMOURED": "BEGLAMOUR, to impress with glamour, also BEGLAMOR [v]\n",
  "BEGLAMOURING": "BEGLAMOUR, to impress with glamour, also BEGLAMOR [v]\n",
  "BEGLAMOURS": "BEGLAMOUR, to impress with glamour, also BEGLAMOR [v]\n",
  "BEGLERBEG": "(Turkish) the governor of a province of the Ottoman empire, next in dignity to the grand vizier [n -S]\n",
  "BEGLERBEGS": "BEGLERBEG, (Turkish) the governor of a province of the Ottoman empire, next in dignity to the grand vizier [n]\n",
  "BEGLOOM": "to make gloomy [v -ED, -ING, -S]\n",
  "BEGLOOMED": "BEGLOOM, to make gloomy [v]\n",
  "BEGLOOMING": "BEGLOOM, to make gloomy [v]\n",
  "BEGLOOMS": "BEGLOOM, to make gloomy [v]\n",
  "BEGNAW": "to gnaw [v -ED, -ING, -S]\n",
  "BEGNAWED": "BEGNAW, to gnaw [v]\n",
  "BEGNAWING": "BEGNAW, to gnaw [v]\n",
  "BEGNAWS": "BEGNAW, to gnaw [v]\n",
  "BEGO": "to beset [v BEWENT, BEGONE, BEGOING, BEGOES]\n",
  "BEGOES": "BEGO, to beset [v]\n",
  "BEGOGGLED": "wearing goggles [adj]\n",
  "BEGOING": "BEGO, to beset [v]\n",
  "BEGONE": "be off [interj]\n",
  "BEGONIA": "a garden plant with waxy leaves and ornamental flowers [n -S]\n",
  "BEGONIAS": "BEGONIA, a garden plant with waxy leaves and ornamental flowers [n]\n",
  "BEGORAH": "(Irish) an interjection attributed to Irish speakers, by God, also BEGORRA, BEGORRAH [interj]\n",
  "BEGORED": "(Spenser) smeared with gore [adj]\n",
  "BEGORRA": "(Irish) an interjection attributed to Irish speakers, by God, also BEGORAH, BEGORRAH [interj]\n",
  "BEGORRAH": "(Irish) an interjection attributed to Irish speakers, by God, also BEGORAH, BEGORRA [interj]\n",
  "BEGOT": "BEGET, to cause to exist [v]\n",
  "BEGOTTEN": "BEGET, to cause to exist [v]\n",
  "BEGRIM": "to soil with grime, also BEGRIME [v BEGRIMMED, BEGRIMMING, BEGRIMS]\n",
  "BEGRIME": "to soil with grime, also BEGRIM [v BEGRIMED, BEGRIMING, BEGRIMES]\n",
  "BEGRIMED": "BEGRIME, to soil with grime, also BEGRIM [v]\n",
  "BEGRIMES": "BEGRIME, to soil with grime, also BEGRIM [v]\n",
  "BEGRIMING": "BEGRIME, to soil with grime, also BEGRIM [v]\n",
  "BEGRIMMED": "BEGRIM, to soil with grime, also BEGRIME [v]\n",
  "BEGRIMMING": "BEGRIM, to soil with grime, also BEGRIME [v]\n",
  "BEGRIMS": "BEGRIM, to soil with grime, also BEGRIME [v]\n",
  "BEGROAN": "to groan at [v -ED, -ING, -S]\n",
  "BEGROANED": "BEGROAN, to groan at [v]\n",
  "BEGROANING": "BEGROAN, to groan at [v]\n",
  "BEGROANS": "BEGROAN, to groan at [v]\n",
  "BEGRUDGE": "to concede reluctantly [v BEGRUDGED, BEGRUDGING, BEGRUDGES]\n",
  "BEGRUDGED": "BEGRUDGE, to concede reluctantly [v]\n",
  "BEGRUDGER": "one who begrudges [n -S]\n",
  "BEGRUDGERIES": "BEGRUDGERY, the act of begrudging [n]\n",
  "BEGRUDGERS": "BEGRUDGER, one who begrudges [n]\n",
  "BEGRUDGERY": "the act of begrudging [n BEGRUDGERIES]\n",
  "BEGRUDGES": "BEGRUDGE, to concede reluctantly [v]\n",
  "BEGRUDGING": "BEGRUDGE, to concede reluctantly [v]\n",
  "BEGRUDGINGLY": "BEGRUDGING, BEGRUDGE, to concede reluctantly [adv]\n",
  "BEGS": "BEG, to ask for [v]\n",
  "BEGUILE": "to deceive [v BEGUILED, BEGUILING, BEGUILES]\n",
  "BEGUILED": "BEGUILE, to deceive [v]\n",
  "BEGUILEMENT": "the state of being beguiled [n -S]\n",
  "BEGUILEMENTS": "BEGUILEMENT, the state of being beguiled [n]\n",
  "BEGUILER": "one who beguiles [n -S]\n",
  "BEGUILERS": "BEGUILER, one who beguiles [n]\n",
  "BEGUILES": "BEGUILE, to deceive [v]\n",
  "BEGUILING": "BEGUILE, to deceive [v]\n",
  "BEGUILINGLY": "BEGUILING, BEGUILE, to deceive [adv]\n",
  "BEGUIN": "(French) in Flanders, a man living a monastic life without vows and with power to return to the world, also BEGHARD [n -S]\n",
  "BEGUINAGE": "(French) an establishment for beguins [n -S]\n",
  "BEGUINAGES": "BEGUINAGE, (French) an establishment for beguins [n]\n",
  "BEGUINE": "(French) a dance of French West Indian origin, also BIGUINE [n -S]\n",
  "BEGUINES": "BEGUINE, (French) a dance of French West Indian origin, also BIGUINE [n]\n",
  "BEGUINS": "BEGUIN, (French) in Flanders, a man living a monastic life without vows and with power to return to the world, also BEGHARD [n]\n",
  "BEGULF": "to engulf [v -ED, -ING, -S]\n",
  "BEGULFED": "BEGULF, to engulf [v]\n",
  "BEGULFING": "BEGULF, to engulf [v]\n",
  "BEGULFS": "BEGULF, to engulf [v]\n",
  "BEGUM": "(Urdu) a high ranking Muslim lady [n -S]\n",
  "BEGUMS": "BEGUM, (Urdu) a high ranking Muslim lady [n]\n",
  "BEGUN": "BEGIN, to start [v]\n",
  "BEGUNK": "(Scots) to trick, to play a trick on [v -ED, -ING, -S]\n",
  "BEGUNKED": "BEGUNK, (Scots) to trick, to play a trick on [v]\n",
  "BEGUNKING": "BEGUNK, (Scots) to trick, to play a trick on [v]\n",
  "BEGUNKS": "BEGUNK, (Scots) to trick, to play a trick on [v]\n",
  "BEHALF": "interest or benefit [n BEHALVES]\n",
  "BEHALVES": "BEHALF, interest or benefit [n]\n",
  "BEHAPPEN": "(Spenser) to happen to [v -ED, -ING, -S]\n",
  "BEHAPPENED": "BEHAPPEN, (Spenser) to happen to [v]\n",
  "BEHAPPENING": "BEHAPPEN, (Spenser) to happen to [v]\n",
  "BEHAPPENS": "BEHAPPEN, (Spenser) to happen to [v]\n",
  "BEHATTED": "wearing a hat [adj]\n",
  "BEHAVE": "to act properly [v BEHAVED, BEHAVING, BEHAVES]\n",
  "BEHAVED": "BEHAVE, to act properly [v]\n",
  "BEHAVER": "one who behaves [n -S]\n",
  "BEHAVERS": "BEHAVER, one who behaves [n]\n",
  "BEHAVES": "BEHAVE, to act properly [v]\n",
  "BEHAVING": "BEHAVE, to act properly [v]\n",
  "BEHAVIOR": "conduct, also BEHAVIOUR [n -S]\n",
  "BEHAVIORAL": "(US) relating to behaviour, also BEHAVIOURAL [adj BEHAVIORALLY]\n",
  "BEHAVIORALLY": "BEHAVIORAL, (US) relating to behaviour, also BEHAVIOURAL [adv]\n",
  "BEHAVIORISM": "(US) the psychological theory that behaviour is governed by conditioning rather than internal processes and that by changing behaviour patterns it is possible to treat psychological disorders, also BEHAVIOURISM [n -S]\n",
  "BEHAVIORISMS": "BEHAVIORISM, (US) the psychological theory that behaviour is governed by conditioning rather than internal processes and that by changing behaviour patterns it is possible to treat psychological disorders, also BEHAVIOURISM [n]\n",
  "BEHAVIORIST": "a student of behaviorism [n -S]\n",
  "BEHAVIORISTIC": "relating to behaviorism, also BEHAVIOURISTIC [adj]\n",
  "BEHAVIORISTS": "BEHAVIORIST, a student of behaviorism [n]\n",
  "BEHAVIORS": "BEHAVIOR, conduct, also BEHAVIOUR [n]\n",
  "BEHAVIOUR": "conduct, also BEHAVIOR [n -S]\n",
  "BEHAVIOURAL": "relating to behaviour, also BEHAVIORAL [adj BEHAVIOURALLY]\n",
  "BEHAVIOURALLY": "BEHAVIOURAL, relating to behaviour, also BEHAVIORAL [adv]\n",
  "BEHAVIOURISM": "the psychological theory that behaviour is governed by conditioning rather than internal processes and that by changing behaviour patterns it is possible to treat psychological disorders, also BEHAVIORISM [n -S]\n",
  "BEHAVIOURISMS": "BEHAVIOURISM, the psychological theory that behaviour is governed by conditioning rather than internal processes and that by changing behaviour patterns it is possible to treat psychological disorders, also BEHAVIORISM [n]\n",
  "BEHAVIOURIST": "an adherent of behaviourism [n -S]\n",
  "BEHAVIOURISTIC": "relating to behaviourism, also BEHAVIORISTIC [adj]\n",
  "BEHAVIOURISTS": "BEHAVIOURIST, an adherent of behaviourism [n]\n",
  "BEHAVIOURS": "BEHAVIOUR, conduct, also BEHAVIOR [n]\n",
  "BEHEAD": "to cut off the head of [v -ED, -ING, -S]\n",
  "BEHEADAL": "the cutting off of a head [n -S]\n",
  "BEHEADALS": "BEHEADAL, the cutting off of a head [n]\n",
  "BEHEADED": "BEHEAD, to cut off the head of [v]\n",
  "BEHEADER": "one who beheads [n -S]\n",
  "BEHEADERS": "BEHEADER, one who beheads [n]\n",
  "BEHEADING": "an execution by decapitation [n -S]\n",
  "BEHEADINGS": "BEHEADING, an execution by decapitation [n]\n",
  "BEHEADS": "BEHEAD, to cut off the head of [v]\n",
  "BEHELD": "BEHOLD, to view [v]\n",
  "BEHEMOTH": "(Hebrew) an enormous creature (in Job 40.15 probably a hippopotamus or a crocodile); (figurative) something vast [n -S]\n",
  "BEHEMOTHS": "BEHEMOTH, (Hebrew) an enormous creature (in Job 40.15 probably a hippopotamus or a crocodile); (figurative) something vast [n]\n",
  "BEHEST": "a command [n -S]\n",
  "BEHESTS": "BEHEST, a command [n]\n",
  "BEHIGHT": "(obsolete) to vow, to promise, also BEHOTE [v BEHIGHT or BEHIGHTED or BEHOTE, BEHIGHTING, BEHIGHTS]\n",
  "BEHIGHTED": "BEHIGHT, (obsolete) to vow, to promise, also BEHOTE [v]\n",
  "BEHIGHTING": "BEHIGHT, (obsolete) to vow, to promise, also BEHOTE [v]\n",
  "BEHIGHTS": "BEHIGHT, (obsolete) to vow, to promise, also BEHOTE [v]\n",
  "BEHIND": "the buttocks [n -S]\n",
  "BEHINDHAND": "being in arrears [adj]\n",
  "BEHINDS": "BEHIND, the buttocks [n]\n",
  "BEHOLD": "to view [v BEHELD, BEHOLDEN, BEHOLDING, BEHOLDS]\n",
  "BEHOLDEN": "under an obligation [adj]\n",
  "BEHOLDER": "one that beholds [n -S]\n",
  "BEHOLDERS": "BEHOLDER, one that beholds [n]\n",
  "BEHOLDING": "(Shakespeare) sight, contemplation [n -S]\n",
  "BEHOLDINGS": "BEHOLDING, (Shakespeare) sight, contemplation [n]\n",
  "BEHOLDS": "BEHOLD, to view [v]\n",
  "BEHOOF": "a benefit resulting from some course of action [n -S]\n",
  "BEHOOFS": "BEHOOF, a benefit resulting from some course of action [n]\n",
  "BEHOOVE": "to be fit, right or necessary, also BEHOVE [v BEHOOVED, BEHOOVING, BEHOOVES]\n",
  "BEHOOVED": "BEHOOVE, to be fit, right or necessary, also BEHOVE [v]\n",
  "BEHOOVES": "BEHOOVE, to be fit, right or necessary, also BEHOVE [v]\n",
  "BEHOOVING": "BEHOOVE, to be fit, right or necessary, also BEHOVE [v]\n",
  "BEHOTE": "to vow, promise [v BEHOTE, BEHOTING, BEHOTES]\n",
  "BEHOTES": "BEHOTE, to vow, promise [v]\n",
  "BEHOTING": "BEHOTE, to vow, promise [v]\n",
  "BEHOVE": "to be fit, right or necessary, also BEHOOVE [v BEHOVED, BEHOVING, BEHOVES]\n",
  "BEHOVED": "BEHOVE, to be fit, right or necessary, also BEHOOVE [v]\n",
  "BEHOVEFUL": "(archaic) right, necessary [adj]\n",
  "BEHOVELY": "(obsolete) useful, profitable [adj]\n",
  "BEHOVES": "BEHOVE, to be fit, right or necessary, also BEHOOVE [v]\n",
  "BEHOVING": "BEHOVE, to be fit, right or necessary, also BEHOOVE [v]\n",
  "BEHOWL": "(Shakespeare) to howl at [v -ED, -ING, -S]\n",
  "BEHOWLED": "BEHOWL, (Shakespeare) to howl at [v]\n",
  "BEHOWLING": "BEHOWL, (Shakespeare) to howl at [v]\n",
  "BEHOWLS": "BEHOWL, (Shakespeare) to howl at [v]\n",
  "BEIGE": "a woollen fabric of undyed wool [n -S] / greyish buff with a hint of pink [adj BEIGER, BEIGEST]\n",
  "BEIGEL": "(Yiddish) a hard, leavened, ring-shaped roll, also BAGEL [n -S]\n",
  "BEIGELS": "BEIGEL, (Yiddish) a hard, leavened, ring-shaped roll, also BAGEL [n]\n",
  "BEIGER": "BEIGE, greyish buff with a hint of pink [adj]\n",
  "BEIGES": "BEIGE, a woollen fabric of undyed wool [n]\n",
  "BEIGEST": "BEIGE, greyish buff with a hint of pink [adj]\n",
  "BEIGIER": "BEIGY, relating to the color beige [adj]\n",
  "BEIGIEST": "BEIGY, relating to the color beige [adj]\n",
  "BEIGNE": "a fritter, a deep-fried ball of choux pastry, also BEIGNET [n -S]\n",
  "BEIGNES": "BEIGNE, a fritter, a deep-fried ball of choux pastry, also BEIGNET [n]\n",
  "BEIGNET": "(French) a fritter, a deep-fried ball of choux pastry, also BEIGNE [n -S]\n",
  "BEIGNETS": "BEIGNET, (French) a fritter, a deep-fried ball of choux pastry, also BEIGNE [n]\n",
  "BEIGY": "relating to the color beige [adj BEIGIER, BEIGIEST]\n",
  "BEIN": "(Scots) well off, comfortable, also BIEN [adj] / to fill [v -ED, -ING, -S]\n",
  "BEINED": "BEIN, to fill [v]\n",
  "BEING": "something that exists [n -S]\n",
  "BEINGLESS": "without being [adj]\n",
  "BEINGNESS": "a state of being [n -ES]\n",
  "BEINGNESSES": "BEINGNESS, a state of being [n]\n",
  "BEINGS": "BEING, something that exists [n]\n",
  "BEINING": "BEIN, to fill [v]\n",
  "BEINKED": "smeared with ink [adj]\n",
  "BEINNESS": "(Scots) wellbeing [n -ES]\n",
  "BEINNESSES": "BEINNESS, (Scots) wellbeing [n]\n",
  "BEINS": "BEIN, to fill [v]\n",
  "BEJABBERS": "an interjection attributed to Irish speakers, also BEJABERS, BEJEEBERS [interj]\n",
  "BEJABERS": "an interjection attributed to Irish speakers, also BEJABBERS, BEJEEBERS [n -ES]\n",
  "BEJABERSES": "BEJABERS, an interjection attributed to Irish speakers, also BEJABBERS, BEJEEBERS [n]\n",
  "BEJADE": "to tire out [v BEJADED, BEJADING, BEJADES]\n",
  "BEJADED": "BEJADE, to tire out [v]\n",
  "BEJADES": "BEJADE, to tire out [v]\n",
  "BEJADING": "BEJADE, to tire out [v]\n",
  "BEJANT": "(Scots) a freshman at St Andrews [n -S]\n",
  "BEJANTS": "BEJANT, (Scots) a freshman at St Andrews [n]\n",
  "BEJASUS": "an oath, by Jesus, also BEJEEZUS, BEJESUS [n -ES]\n",
  "BEJASUSES": "BEJASUS, an oath, by Jesus, also BEJEEZUS, BEJESUS [n]\n",
  "BEJEEBERS": "an interjection attributed to Irish speakers, also BEJABBERS, BEJABERS [interj]\n",
  "BEJEEZUS": "a mild oath, also BEJASUS, BEJESUS [n -ES]\n",
  "BEJEEZUSES": "BEJEEZUS, a mild oath, also BEJASUS, BEJESUS [n]\n",
  "BEJESUIT": "to initiate into Jesuitism [v -ED, -ING, -S]\n",
  "BEJESUITED": "BEJESUIT, to initiate into Jesuitism [v]\n",
  "BEJESUITING": "BEJESUIT, to initiate into Jesuitism [v]\n",
  "BEJESUITS": "BEJESUIT, to initiate into Jesuitism [v]\n",
  "BEJESUS": "a mild oath, also BEJASUS, BEJEEZUS [n -ES]\n",
  "BEJESUSES": "BEJESUS, a mild oath, also BEJASUS, BEJEEZUS [n]\n",
  "BEJEWEL": "to adorn with jewels [v BEJEWELED or BEJEWELLED, BEJEWELING or BEJEWELLING, BEJEWELS]\n",
  "BEJEWELED": "BEJEWEL, to adorn with jewels [v]\n",
  "BEJEWELING": "BEJEWEL, to adorn with jewels [v]\n",
  "BEJEWELLED": "BEJEWEL, to adorn with jewels [v]\n",
  "BEJEWELLING": "BEJEWEL, to adorn with jewels [v]\n",
  "BEJEWELS": "BEJEWEL, to adorn with jewels [v]\n",
  "BEJUMBLE": "to mix confusedly [v BEJUMBLED, BEJUMBLING, BEJUMBLES]\n",
  "BEJUMBLED": "BEJUMBLE, to mix confusedly [v]\n",
  "BEJUMBLES": "BEJUMBLE, to mix confusedly [v]\n",
  "BEJUMBLING": "BEJUMBLE, to mix confusedly [v]\n",
  "BEKAH": "(Hebrew) half a shekel [n -S]\n",
  "BEKAHS": "BEKAH, (Hebrew) half a shekel [n]\n",
  "BEKISS": "to cover with kisses [v -ED, -ING, -ES]\n",
  "BEKISSED": "BEKISS, to cover with kisses [v]\n",
  "BEKISSES": "BEKISS, to cover with kisses [v]\n",
  "BEKISSING": "BEKISS, to cover with kisses [v]\n",
  "BEKNAVE": "to treat as a knave [v BEKNAVED, BEKNAVING, BEKNAVES]\n",
  "BEKNAVED": "BEKNAVE, to treat as a knave [v]\n",
  "BEKNAVES": "BEKNAVE, to treat as a knave [v]\n",
  "BEKNAVING": "BEKNAVE, to treat as a knave [v]\n",
  "BEKNIGHT": "to raise to knighthood [v -ED, -ING, -S]\n",
  "BEKNIGHTED": "BEKNIGHT, to raise to knighthood [v]\n",
  "BEKNIGHTING": "BEKNIGHT, to raise to knighthood [v]\n",
  "BEKNIGHTS": "BEKNIGHT, to raise to knighthood [v]\n",
  "BEKNOT": "to tie in knots [v BEKNOTTED, BEKNOTTING, BEKNOTS]\n",
  "BEKNOTS": "BEKNOT, to tie in knots [v]\n",
  "BEKNOTTED": "BEKNOT, to tie in knots [v]\n",
  "BEKNOTTING": "BEKNOT, to tie in knots [v]\n",
  "BEKNOWN": "(archaic) known [adj]\n",
  "BEL": "a noise measure [n -S]\n",
  "BELABOR": "to buffet, beat, also BELABOUR [v -ED, -ING, -S]\n",
  "BELABORED": "BELABOR, to buffet, beat, also BELABOUR [v]\n",
  "BELABORING": "BELABOR, to buffet, beat, also BELABOUR [v]\n",
  "BELABORS": "BELABOR, to buffet, beat, also BELABOUR [v]\n",
  "BELABOUR": "to buffet, beat, also BELABOR [v -ED, -ING, -S]\n",
  "BELABOURED": "BELABOUR, to buffet, beat, also BELABOR [v]\n",
  "BELABOURING": "BELABOUR, to buffet, beat, also BELABOR [v]\n",
  "BELABOURS": "BELABOUR, to buffet, beat, also BELABOR [v]\n",
  "BELACE": "to adorn with lace [v BELACED, BELACING, BELACES]\n",
  "BELACED": "BELACE, to adorn with lace [v]\n",
  "BELACES": "BELACE, to adorn with lace [v]\n",
  "BELACING": "BELACE, to adorn with lace [v]\n",
  "BELADIED": "BELADY, to apply the title of lady to [v]\n",
  "BELADIES": "BELADY, to apply the title of lady to [v]\n",
  "BELADY": "to apply the title of lady to [v BELADIED, BELADYING, BELADIES]\n",
  "BELADYING": "BELADY, to apply the title of lady to [v]\n",
  "BELAH": "(Native Australian) an Australian tree of the Casuarina genus, aka beefwood, also BELAR [n -S]\n",
  "BELAHS": "BELAH, (Native Australian) an Australian tree of the Casuarina genus, aka beefwood, also BELAR [n]\n",
  "BELAMIES": "BELAMY, (Spenser) a good friend [n]\n",
  "BELAMOUR": "(Spenser) a beloved, also BELAMOURE, BELLAMOURE [n -S]\n",
  "BELAMOURE": "(Spenser) a beloved, also BELAMOUR, BELLAMOURE [n -S]\n",
  "BELAMOURES": "BELAMOURE, (Spenser) a beloved, also BELAMOUR, BELLAMOURE [n]\n",
  "BELAMOURS": "BELAMOUR, (Spenser) a beloved, also BELAMOURE, BELLAMOURE [n]\n",
  "BELAMY": "(Spenser) a good friend [n BELAMIES]\n",
  "BELAR": "an Australian tree of the Casuarina genus, aka beefwood, also BELAH [n -S]\n",
  "BELARS": "BELAR, an Australian tree of the Casuarina genus, aka beefwood, also BELAH [n]\n",
  "BELATE": "(archaic) to retard or make too late [v BELATED, BELATING, BELATES]\n",
  "BELATED": "BELATE, (archaic) to retard or make too late [v]\n",
  "BELATEDLY": "BELATED, BELATE, (archaic) to retard or make too late [adv]\n",
  "BELATEDNESS": "the state of being belated [n -ES]\n",
  "BELATEDNESSES": "BELATEDNESS, the state of being belated [n]\n",
  "BELATES": "BELATE, (archaic) to retard or make too late [v]\n",
  "BELATING": "BELATE, (archaic) to retard or make too late [v]\n",
  "BELAUD": "to laud or praise greatly [v -ED, -ING, -S]\n",
  "BELAUDED": "BELAUD, to laud or praise greatly [v]\n",
  "BELAUDING": "BELAUD, to laud or praise greatly [v]\n",
  "BELAUDS": "BELAUD, to laud or praise greatly [v]\n",
  "BELAY": "to fasten a rope [v -ED, -ING, -S]\n",
  "BELAYED": "BELAY, to fasten a rope [v]\n",
  "BELAYER": "one who belays [n -S]\n",
  "BELAYERS": "BELAYER, one who belays [n]\n",
  "BELAYING": "BELAY, to fasten a rope [v]\n",
  "BELAYS": "BELAY, to fasten a rope [v]\n",
  "BELCH": "to expel gas through the mouth [v -ED, -ING, -ES]\n",
  "BELCHED": "BELCH, to expel gas through the mouth [v]\n",
  "BELCHER": "a kind of spotted neckerchief [n -S]\n",
  "BELCHERS": "BELCHER, a kind of spotted neckerchief [n]\n",
  "BELCHES": "BELCH, to expel gas through the mouth [v]\n",
  "BELCHING": "BELCH, to expel gas through the mouth [v]\n",
  "BELDAM": "an old woman, esp. an ugly one, also BELDAME [n -S]\n",
  "BELDAME": "an old woman, esp. an ugly one, also BELDAM [n -S]\n",
  "BELDAMES": "BELDAME, an old woman, esp. an ugly one, also BELDAM [n]\n",
  "BELDAMS": "BELDAM, an old woman, esp. an ugly one, also BELDAME [n]\n",
  "BELEAGUER": "to surround with an army so as to preclude escape; to besiege [v -ED, -ING, -S]\n",
  "BELEAGUERED": "BELEAGUER, to surround with an army so as to preclude escape; to besiege [v]\n",
  "BELEAGUERING": "BELEAGUER, to surround with an army so as to preclude escape; to besiege [v]\n",
  "BELEAGUERMENT": "the state of being beleaguered [n -S]\n",
  "BELEAGUERMENTS": "BELEAGUERMENT, the state of being beleaguered [n]\n",
  "BELEAGUERS": "BELEAGUER, to surround with an army so as to preclude escape; to besiege [v]\n",
  "BELEAP": "to leap upon [v BELEAPED, BELEAPT, BELEAPING, BELEAPS]\n",
  "BELEAPED": "BELEAP, to leap upon [v]\n",
  "BELEAPING": "BELEAP, to leap upon [v]\n",
  "BELEAPS": "BELEAP, to leap upon [v]\n",
  "BELEAPT": "BELEAP, to leap upon [v]\n",
  "BELEE": "(Shakespeare) to put on the lee side [v BELEED, BELEEING, BELEES]\n",
  "BELEED": "BELEE, (Shakespeare) to put on the lee side [v]\n",
  "BELEEING": "BELEE, (Shakespeare) to put on the lee side [v]\n",
  "BELEES": "BELEE, (Shakespeare) to put on the lee side [v]\n",
  "BELEMNITE": "a fossil pointed like a dart, being the internal shell of a cephalopod mollusc [n -S]\n",
  "BELEMNITES": "BELEMNITE, a fossil pointed like a dart, being the internal shell of a cephalopod mollusc [n]\n",
  "BELEMNOID": "of a fossil, shaped like a dart [adj]\n",
  "BELFRIED": "having a belfry [adj]\n",
  "BELFRIES": "BELFRY, a bell-tower [n]\n",
  "BELFRY": "a bell-tower [n BELFRIES]\n",
  "BELGA": "(Latin) a former currency unit of Belgium [n -S]\n",
  "BELGARD": "(Spenser) a fair or kind look [n -S]\n",
  "BELGARDS": "BELGARD, (Spenser) a fair or kind look [n]\n",
  "BELGAS": "BELGA, (Latin) a former currency unit of Belgium [n]\n",
  "BELGICISM": "a word or expression used by Belgians when speaking French or Dutch [n -S]\n",
  "BELGICISMS": "BELGICISM, a word or expression used by Belgians when speaking French or Dutch [n]\n",
  "BELIE": "to misrepresent [v BELIED, BELYING, BELIES]\n",
  "BELIED": "BELIE, to misrepresent [v]\n",
  "BELIEF": "a conviction of the truth of anything [n -S]\n",
  "BELIEFLESS": "without belief [adj]\n",
  "BELIEFS": "BELIEF, a conviction of the truth of anything [n]\n",
  "BELIER": "one who belies [n -S]\n",
  "BELIERS": "BELIER, one who belies [n]\n",
  "BELIES": "BELIE, to misrepresent [v]\n",
  "BELIEVABILITIES": "BELIEVABILITY, the quality of being believable [n]\n",
  "BELIEVABILITY": "the quality of being believable [n BELIEVABILITIES]\n",
  "BELIEVABLE": "that can be believed [adj BELIEVABLY]\n",
  "BELIEVABLY": "BELIEVABLE, that can be believed [adv]\n",
  "BELIEVE": "to accept as true [v BELIEVED, BELIEVING, BELIEVES]\n",
  "BELIEVED": "BELIEVE, to accept as true [v]\n",
  "BELIEVER": "one who believes [n -S]\n",
  "BELIEVERS": "BELIEVER, one who believes [n]\n",
  "BELIEVES": "BELIEVE, to accept as true [v]\n",
  "BELIEVING": "accepting as true or real [adj BELIEVINGLY] / the act of believing [n -S]\n",
  "BELIEVINGLY": "BELIEVING, accepting as true or real [adv]\n",
  "BELIEVINGS": "BELIEVING, the act of believing [n]\n",
  "BELIKE": "(archaic) most likely; probably [adv]\n",
  "BELIQUOR": "to soak with liquor [v -ED, -ING, -S]\n",
  "BELIQUORED": "BELIQUOR, to soak with liquor [v]\n",
  "BELIQUORING": "BELIQUOR, to soak with liquor [v]\n",
  "BELIQUORS": "BELIQUOR, to soak with liquor [v]\n",
  "BELITTLE": "to disparage [v BELITTLED, BELITTLING, BELITTLES]\n",
  "BELITTLED": "BELITTLE, to disparage [v]\n",
  "BELITTLEMENT": "the act of belittling [n -S]\n",
  "BELITTLEMENTS": "BELITTLEMENT, the act of belittling [n]\n",
  "BELITTLER": "one who belittles [n -S]\n",
  "BELITTLERS": "BELITTLER, one who belittles [n]\n",
  "BELITTLES": "BELITTLE, to disparage [v]\n",
  "BELITTLING": "BELITTLE, to disparage [v]\n",
  "BELITTLINGLY": "BELITTLING, BELITTLE, to disparage [adv]\n",
  "BELIVE": "(Scots) immediately, also BLIVE, BYLIVE [adv]\n",
  "BELL": "to provide with a ringing device [v -ED, -ING, -S]\n",
  "BELLADONNA": "(Italian) a herbaceous plant, very poisonous, with reddish bell-shaped flowers and shining black berries [n -S]\n",
  "BELLADONNAS": "BELLADONNA, (Italian) a herbaceous plant, very poisonous, with reddish bell-shaped flowers and shining black berries [n]\n",
  "BELLAMOURE": "(Spenser) a beloved, also BELAMOUR, BELAMOURE [n -S]\n",
  "BELLAMOURES": "BELLAMOURE, (Spenser) a beloved, also BELAMOUR, BELAMOURE [n]\n",
  "BELLARMINE": "a large jug with rounded belly and narrow neck [n -S]\n",
  "BELLARMINES": "BELLARMINE, a large jug with rounded belly and narrow neck [n]\n",
  "BELLBIND": "hedge or field bindweed [n -S]\n",
  "BELLBINDS": "BELLBIND, hedge or field bindweed [n]\n",
  "BELLBIRD": "any of several tropical American birds having a bell-like call, aka campanero [n -S]\n",
  "BELLBIRDS": "BELLBIRD, any of several tropical American birds having a bell-like call, aka campanero [n]\n",
  "BELLBOY": "a pageboy in a hotel or club, also BELLHOP [n -S]\n",
  "BELLBOYS": "BELLBOY, a pageboy in a hotel or club, also BELLHOP [n]\n",
  "BELLBUOY": "a buoy having a bell [n -S]\n",
  "BELLBUOYS": "BELLBUOY, a buoy having a bell [n]\n",
  "BELLCAST": "designating a style of roof architecture [adj]\n",
  "BELLCOTE": "an ornamental structure to hold one or two large bells [n -S]\n",
  "BELLCOTES": "BELLCOTE, an ornamental structure to hold one or two large bells [n]\n",
  "BELLE": "(French) a young lady of superior beauty and attractions [n -S]\n",
  "BELLED": "BELL, to provide with a ringing device [v]\n",
  "BELLEEK": "a thin translucent porcelain [n -S]\n",
  "BELLEEKS": "BELLEEK, a thin translucent porcelain [n]\n",
  "BELLES": "BELLE, (French) a young lady of superior beauty and attractions [n]\n",
  "BELLETER": "a bellfounder [n -S]\n",
  "BELLETERS": "BELLETER, a bellfounder [n]\n",
  "BELLETRISM": "the writing of belles-lettres [n -S]\n",
  "BELLETRISMS": "BELLETRISM, the writing of belles-lettres [n]\n",
  "BELLETRIST": "one who engages in belles-lettres, also BELLETTRIST [n -S]\n",
  "BELLETRISTIC": "relating to belles-lettres, also BELLETRISTICAL [adj]\n",
  "BELLETRISTICAL": "relating to belles-lettres, also BELLETRISTIC [adj]\n",
  "BELLETRISTS": "BELLETRIST, one who engages in belles-lettres, also BELLETTRIST [n]\n",
  "BELLETTRIST": "one who engages in belles-lettres, also BELLETRIST [n -S]\n",
  "BELLETTRISTS": "BELLETTRIST, one who engages in belles-lettres, also BELLETRIST [n]\n",
  "BELLFLOWER": "a plant of the genus Campanula, so named from its bell-shaped flowers [n -S]\n",
  "BELLFLOWERS": "BELLFLOWER, a plant of the genus Campanula, so named from its bell-shaped flowers [n]\n",
  "BELLFOUNDER": "a foundry worker who casts bells [n -S]\n",
  "BELLFOUNDERS": "BELLFOUNDER, a foundry worker who casts bells [n]\n",
  "BELLFOUNDRIES": "BELLFOUNDRY, a place where bells are made [n]\n",
  "BELLFOUNDRY": "a place where bells are made [n BELLFOUNDRIES]\n",
  "BELLHANGER": "a person who hangs and repairs bells [n -S]\n",
  "BELLHANGERS": "BELLHANGER, a person who hangs and repairs bells [n]\n",
  "BELLHOP": "a pageboy in a hotel or club, also BELLBOY [n -S]\n",
  "BELLHOPS": "BELLHOP, a pageboy in a hotel or club, also BELLBOY [n]\n",
  "BELLIBONE": "(Spenser) a woman excelling both in beauty and goodness, also BONIBELL, BONNIBELL [n -S]\n",
  "BELLIBONES": "BELLIBONE, (Spenser) a woman excelling both in beauty and goodness, also BONIBELL, BONNIBELL [n]\n",
  "BELLICOSE": "warlike [adj BELLICOSELY]\n",
  "BELLICOSELY": "BELLICOSE, warlike [adv]\n",
  "BELLICOSITIES": "BELLICOSITY, the state of being bellicose [n]\n",
  "BELLICOSITY": "the state of being bellicose [n BELLICOSITIES]\n",
  "BELLIED": "BELLY, to swell out [v]\n",
  "BELLIES": "BELLY, to swell out [v]\n",
  "BELLIGERATI": "members of the intelligentsia in favour of war [n]\n",
  "BELLIGERENCE": "an aggressive or truculent attitude, also BELLIGERENCY [n -S]\n",
  "BELLIGERENCES": "BELLIGERENCE, an aggressive or truculent attitude, also BELLIGERENCY [n]\n",
  "BELLIGERENCIES": "BELLIGERENCY, an aggressive or truculent attitude, also BELLIGERENCE [n]\n",
  "BELLIGERENCY": "an aggressive or truculent attitude, also BELLIGERENCE [n BELLIGERENCIES]\n",
  "BELLIGERENT": "aggressive [adj BELLIGERENTLY] / one who wages war [n -S]\n",
  "BELLIGERENTLY": "BELLIGERENT, aggressive [adv]\n",
  "BELLIGERENTS": "BELLIGERENT, one who wages war [n]\n",
  "BELLING": "a mock serenade for newlyweds [n -S]\n",
  "BELLINGS": "BELLING, a mock serenade for newlyweds [n]\n",
  "BELLINI": "a cocktail consisting of prosecco and peach puree [n -S]\n",
  "BELLINIS": "BELLINI, a cocktail consisting of prosecco and peach puree [n]\n",
  "BELLMAN": "a watchman employed to patrol city streets calling out the hour [n BELLMEN]\n",
  "BELLMEN": "BELLMAN, a watchman employed to patrol city streets calling out the hour [n]\n",
  "BELLOCK": "to shout [v -ED, -ING, -S]\n",
  "BELLOCKED": "BELLOCK, to shout [v]\n",
  "BELLOCKING": "BELLOCK, to shout [v]\n",
  "BELLOCKS": "BELLOCK, to shout [v]\n",
  "BELLOW": "to roar like a bull [v -ED, -ING, -S]\n",
  "BELLOWED": "BELLOW, to roar like a bull [v]\n",
  "BELLOWER": "one who bellows [n -S]\n",
  "BELLOWERS": "BELLOWER, one who bellows [n]\n",
  "BELLOWING": "the act of emitting a bellow [n -S]\n",
  "BELLOWINGS": "BELLOWING, the act of emitting a bellow [n]\n",
  "BELLOWS": "BELLOW, to roar like a bull [v]\n",
  "BELLPULL": "a cord pulled to ring a bell [n -S]\n",
  "BELLPULLS": "BELLPULL, a cord pulled to ring a bell [n]\n",
  "BELLS": "BELL, to provide with a ringing device [v]\n",
  "BELLWETHER": "the leading sheep of a flock; fig, a ringleader, a trendsetter [n -S]\n",
  "BELLWETHERS": "BELLWETHER, the leading sheep of a flock; fig, a ringleader, a trendsetter [n]\n",
  "BELLWORT": "a genus of plants with yellowish bell-shaped flowers [n -S]\n",
  "BELLWORTS": "BELLWORT, a genus of plants with yellowish bell-shaped flowers [n]\n",
  "BELLY": "to swell out [v BELLIED, BELLYING, BELLIES]\n",
  "BELLYACHE": "a pain in the stomach [n -S] / to moan, complain [v BELLYACHED, BELLYACHING, BELLYACHES]\n",
  "BELLYACHED": "BELLYACHE, to moan, complain [v]\n",
  "BELLYACHER": "one who complains [n -S]\n",
  "BELLYACHERS": "BELLYACHER, one who complains [n]\n",
  "BELLYACHES": "BELLYACHE, to moan, complain [v]\n",
  "BELLYACHING": "the act of complaining [n -S]\n",
  "BELLYACHINGS": "BELLYACHING, the act of complaining [n]\n",
  "BELLYBAND": "a saddle-girth [n -S]\n",
  "BELLYBANDS": "BELLYBAND, a saddle-girth [n]\n",
  "BELLYBOAT": "a water safety device, chiefly used in angling, consisting of a large, circular inflated rubber tube attached around a person's waist [n -S]\n",
  "BELLYBOATS": "BELLYBOAT, a water safety device, chiefly used in angling, consisting of a large, circular inflated rubber tube attached around a person's waist [n]\n",
  "BELLYBUTTON": "(colloquial) the navel [n -S]\n",
  "BELLYBUTTONS": "BELLYBUTTON, (colloquial) the navel [n]\n",
  "BELLYFLOP": "to perform a dive into water in which the body lands horizontally [v BELLYFLOPPED, BELLYFLOPPING, BELLYFLOPS]\n",
  "BELLYFLOPPED": "BELLYFLOP, to perform a dive into water in which the body lands horizontally [v]\n",
  "BELLYFLOPPING": "BELLYFLOP, to perform a dive into water in which the body lands horizontally [v]\n",
  "BELLYFLOPS": "BELLYFLOP, to perform a dive into water in which the body lands horizontally [v]\n",
  "BELLYFUL": "more than enough [n -S]\n",
  "BELLYFULS": "BELLYFUL, more than enough [n]\n",
  "BELLYING": "the act of swelling out [n -S]\n",
  "BELLYINGS": "BELLYING, the act of swelling out [n]\n",
  "BELLYLIKE": "shaped like a belly [adj]\n",
  "BELOMANCIES": "BELOMANCY, divination by means of arrows [n]\n",
  "BELOMANCY": "divination by means of arrows [n BELOMANCIES]\n",
  "BELON": "a type of oyster [n -S]\n",
  "BELONG": "to be a member of [v -ED, -ING, -S]\n",
  "BELONGED": "BELONG, to be a member of [v]\n",
  "BELONGER": "a person of conservative values [n -S]\n",
  "BELONGERS": "BELONGER, a person of conservative values [n]\n",
  "BELONGING": "BELONG, to be a member of [v]\n",
  "BELONGINGNESS": "the state of belonging [n -ES]\n",
  "BELONGINGNESSES": "BELONGINGNESS, the state of belonging [n]\n",
  "BELONGINGS": "the things that a person owns or has with him; possessions [n]\n",
  "BELONGS": "BELONG, to be a member of [v]\n",
  "BELONS": "BELON, a type of oyster [n]\n",
  "BELOVE": "(obsolete) to love [v BELOVED, BELOVING, BELOVES]\n",
  "BELOVED": "a person who is much loved [n -S]\n",
  "BELOVEDS": "BELOVED, a person who is much loved [n]\n",
  "BELOVES": "BELOVE, (obsolete) to love [v]\n",
  "BELOVING": "BELOVE, (obsolete) to love [v]\n",
  "BELOW": "the lower part of something [n -S]\n",
  "BELOWDECKS": "inside or into the superstructure of a boat [adv]\n",
  "BELOWGROUND": "underground [adv]\n",
  "BELOWS": "BELOW, the lower part of something [n]\n",
  "BELOWSTAIRS": "in or belonging to the servants' quarters [adv]\n",
  "BELS": "BEL, a noise measure [n]\n",
  "BELSHAZZAR": "a large wine bottle containing 2.80 gallons, also BALTHASAR, BALTHAZAR [n -S]\n",
  "BELSHAZZARS": "BELSHAZZAR, a large wine bottle containing 2.80 gallons, also BALTHASAR, BALTHAZAR [n]\n",
  "BELT": "to thrash with a belt [v -ED, -ING, -S]\n",
  "BELTCOURSE": "an ornamental projecting band or continuous moulding along a wall [n -S]\n",
  "BELTCOURSES": "BELTCOURSE, an ornamental projecting band or continuous moulding along a wall [n]\n",
  "BELTED": "BELT, to thrash with a belt [v]\n",
  "BELTER": "an impressive performer; an outstanding person or thing [n -S]\n",
  "BELTERS": "BELTER, an impressive performer; an outstanding person or thing [n]\n",
  "BELTING": "a thrashing [n -S]\n",
  "BELTINGS": "BELTING, a thrashing [n]\n",
  "BELTLESS": "without a belt [adj]\n",
  "BELTLIKE": "like a belt [adj]\n",
  "BELTLINE": "the waistline [n -S]\n",
  "BELTLINES": "BELTLINE, the waistline [n]\n",
  "BELTMAN": "a lifesaver with a line tied to his belt [n BELTMEN]\n",
  "BELTMEN": "BELTMAN, a lifesaver with a line tied to his belt [n]\n",
  "BELTS": "BELT, to thrash with a belt [v]\n",
  "BELTWAY": "a highway round an urban area [n -S]\n",
  "BELTWAYS": "BELTWAY, a highway round an urban area [n]\n",
  "BELUGA": "(Russian) the white whale [n -S]\n",
  "BELUGAS": "BELUGA, (Russian) the white whale [n]\n",
  "BELVEDERE": "(Italian) a structure (such as a cupola or a summerhouse) designed to command a view [n -S]\n",
  "BELVEDERES": "BELVEDERE, (Italian) a structure (such as a cupola or a summerhouse) designed to command a view [n]\n",
  "BELYING": "BELIE, to misrepresent [v]\n",
  "BEMA": "(Greek) a platform in a synagogue, also BIMA, BIMAH [n BEMAS or BEMATA]\n",
  "BEMAD": "(archaic) to make mad, also BEMADDEN [v BEMADDED, BEMADDING, BEMADS]\n",
  "BEMADAM": "to call by the title of madam [v -ED, -ING, -S]\n",
  "BEMADAMED": "BEMADAM, to call by the title of madam [v]\n",
  "BEMADAMING": "BEMADAM, to call by the title of madam [v]\n",
  "BEMADAMS": "BEMADAM, to call by the title of madam [v]\n",
  "BEMADDED": "BEMAD, (archaic) to make mad, also BEMADDEN [v]\n",
  "BEMADDEN": "to make mad, also BEMAD [v -ED, -ING, -S]\n",
  "BEMADDENED": "BEMADDEN, to make mad, also BEMAD [v]\n",
  "BEMADDENING": "BEMADDEN, to make mad, also BEMAD [v]\n",
  "BEMADDENS": "BEMADDEN, to make mad, also BEMAD [v]\n",
  "BEMADDING": "BEMAD, (archaic) to make mad, also BEMADDEN [v]\n",
  "BEMADS": "BEMAD, (archaic) to make mad, also BEMADDEN [v]\n",
  "BEMAS": "BEMA, (Greek) a platform in a synagogue, also BIMA, BIMAH [n]\n",
  "BEMATA": "BEMA, (Greek) a platform in a synagogue, also BIMA, BIMAH [n]\n",
  "BEMAUL": "(archaic) to maul or beat severely; to bruise [v -ED, -ING, -S]\n",
  "BEMAULED": "BEMAUL, (archaic) to maul or beat severely; to bruise [v]\n",
  "BEMAULING": "BEMAUL, (archaic) to maul or beat severely; to bruise [v]\n",
  "BEMAULS": "BEMAUL, (archaic) to maul or beat severely; to bruise [v]\n",
  "BEMAZED": "(archaic) stupefied, bewildered [adj]\n",
  "BEMBEX": "(Greek) a noisy sand-wasp, also BEMBIX [n -ES]\n",
  "BEMBEXES": "BEMBEX, (Greek) a noisy sand-wasp, also BEMBIX [n]\n",
  "BEMBIX": "(Greek) a noisy sand-wasp, also BEMBEX [n -ES]\n",
  "BEMBIXES": "BEMBIX, (Greek) a noisy sand-wasp, also BEMBEX [n]\n",
  "BEMEAN": "(archaic) to make mean, debase [v -ED, -ING, -S] / to signify [v BEMEANT, BEMEANING, BEMEANS]\n",
  "BEMEANED": "BEMEAN, (archaic) to make mean, debase [v]\n",
  "BEMEANING": "BEMEAN, (archaic) to make mean, debase [v]\n",
  "BEMEANS": "BEMEAN, (archaic) to make mean, debase [v]\n",
  "BEMEANT": "BEMEAN, (archaic) to make mean, debase [v]\n",
  "BEMEDAL": "(archaic) to decorate with medals [v BEMEDALED or BEMEDALLED, BEMEDALING or BEMEDALLING, BEMEDALS]\n",
  "BEMEDALED": "BEMEDAL, (archaic) to decorate with medals [v]\n",
  "BEMEDALING": "BEMEDAL, (archaic) to decorate with medals [v]\n",
  "BEMEDALLED": "BEMEDAL, (archaic) to decorate with medals [v]\n",
  "BEMEDALLING": "BEMEDAL, (archaic) to decorate with medals [v]\n",
  "BEMEDALS": "BEMEDAL, (archaic) to decorate with medals [v]\n",
  "BEMETE": "(archaic) to measure [v BEMETED, BEMETING, BEMETES]\n",
  "BEMETED": "BEMETE, (archaic) to measure [v]\n",
  "BEMETES": "BEMETE, (archaic) to measure [v]\n",
  "BEMETING": "BEMETE, (archaic) to measure [v]\n",
  "BEMINGLE": "to mix together [v BEMINGLED, BEMINGLING, BEMINGLES]\n",
  "BEMINGLED": "BEMINGLE, to mix together [v]\n",
  "BEMINGLES": "BEMINGLE, to mix together [v]\n",
  "BEMINGLING": "BEMINGLE, to mix together [v]\n",
  "BEMIRE": "(archaic) to make muddy [v BEMIRED, BEMIRING, BEMIRES]\n",
  "BEMIRED": "BEMIRE, (archaic) to make muddy [v]\n",
  "BEMIRES": "BEMIRE, (archaic) to make muddy [v]\n",
  "BEMIRING": "BEMIRE, (archaic) to make muddy [v]\n",
  "BEMIST": "to envelop in a mist [v -ED, -ING, -S]\n",
  "BEMISTED": "BEMIST, to envelop in a mist [v]\n",
  "BEMISTING": "BEMIST, to envelop in a mist [v]\n",
  "BEMISTS": "BEMIST, to envelop in a mist [v]\n",
  "BEMIX": "to mix well [v BEMIXED, BEMIXT, BEMIXING, BEMIXES]\n",
  "BEMIXED": "BEMIX, to mix well [v]\n",
  "BEMIXES": "BEMIX, to mix well [v]\n",
  "BEMIXING": "BEMIX, to mix well [v]\n",
  "BEMIXT": "BEMIX, to mix well [v]\n",
  "BEMOAN": "to lament [v -ED, -ING, -S]\n",
  "BEMOANED": "BEMOAN, to lament [v]\n",
  "BEMOANER": "one who bemoans [n -S]\n",
  "BEMOANERS": "BEMOANER, one who bemoans [n]\n",
  "BEMOANING": "lamentation [n -S]\n",
  "BEMOANINGS": "BEMOANING, lamentation [n]\n",
  "BEMOANS": "BEMOAN, to lament [v]\n",
  "BEMOCK": "(archaic) to mock [v -ED, -ING, -S]\n",
  "BEMOCKED": "BEMOCK, (archaic) to mock [v]\n",
  "BEMOCKING": "BEMOCK, (archaic) to mock [v]\n",
  "BEMOCKS": "BEMOCK, (archaic) to mock [v]\n",
  "BEMOIL": "(Shakespeare) to bemire, bedraggle [v -ED, -ING, -S]\n",
  "BEMOILED": "BEMOIL, (Shakespeare) to bemire, bedraggle [v]\n",
  "BEMOILING": "BEMOIL, (Shakespeare) to bemire, bedraggle [v]\n",
  "BEMOILS": "BEMOIL, (Shakespeare) to bemire, bedraggle [v]\n",
  "BEMONSTER": "(archaic) to make monstrous or like a monster [v -ED, -ING, -S]\n",
  "BEMONSTERED": "BEMONSTER, (archaic) to make monstrous or like a monster [v]\n",
  "BEMONSTERING": "BEMONSTER, (archaic) to make monstrous or like a monster [v]\n",
  "BEMONSTERS": "BEMONSTER, (archaic) to make monstrous or like a monster [v]\n",
  "BEMOUTH": "(archaic) to mouth about [v -ED, -ING, -S]\n",
  "BEMOUTHED": "BEMOUTH, (archaic) to mouth about [v]\n",
  "BEMOUTHING": "BEMOUTH, (archaic) to mouth about [v]\n",
  "BEMOUTHS": "BEMOUTH, (archaic) to mouth about [v]\n",
  "BEMUD": "(archaic) to spatter with mud [v BEMUDDED, BEMUDDING, BEMUDS]\n",
  "BEMUDDED": "BEMUD, (archaic) to spatter with mud [v]\n",
  "BEMUDDING": "BEMUD, (archaic) to spatter with mud [v]\n",
  "BEMUDDLE": "(archaic) to confuse, muddle [v BEMUDDLED, BEMUDDLING, BEMUDDLES]\n",
  "BEMUDDLED": "BEMUDDLE, (archaic) to confuse, muddle [v]\n",
  "BEMUDDLES": "BEMUDDLE, (archaic) to confuse, muddle [v]\n",
  "BEMUDDLING": "BEMUDDLE, (archaic) to confuse, muddle [v]\n",
  "BEMUDS": "BEMUD, (archaic) to spatter with mud [v]\n",
  "BEMUFFLE": "to wrap or muffle [v BEMUFFLED, BEMUFFLING, BEMUFFLES]\n",
  "BEMUFFLED": "BEMUFFLE, to wrap or muffle [v]\n",
  "BEMUFFLES": "BEMUFFLE, to wrap or muffle [v]\n",
  "BEMUFFLING": "BEMUFFLE, to wrap or muffle [v]\n",
  "BEMURMUR": "to murmur at [v -ED, -ING, -S]\n",
  "BEMURMURED": "BEMURMUR, to murmur at [v]\n",
  "BEMURMURING": "BEMURMUR, to murmur at [v]\n",
  "BEMURMURS": "BEMURMUR, to murmur at [v]\n",
  "BEMUSE": "to confuse [v BEMUSED, BEMUSING, BEMUSES]\n",
  "BEMUSED": "BEMUSE, to confuse [v]\n",
  "BEMUSEDLY": "BEMUSED, BEMUSE, to confuse [adv]\n",
  "BEMUSEMENT": "the act of bemusing [n -S]\n",
  "BEMUSEMENTS": "BEMUSEMENT, the act of bemusing [n]\n",
  "BEMUSES": "BEMUSE, to confuse [v]\n",
  "BEMUSING": "BEMUSE, to confuse [v]\n",
  "BEMUZZLE": "to put a gag on [v BEMUZZLED, BEMUZZLING, BEMUZZLES]\n",
  "BEMUZZLED": "BEMUZZLE, to put a gag on [v]\n",
  "BEMUZZLES": "BEMUZZLE, to put a gag on [v]\n",
  "BEMUZZLING": "BEMUZZLE, to put a gag on [v]\n",
  "BEN": "(Gaelic) a mountain [n -S]\n",
  "BENADRYL": "(tradename) an antihistamine drug used in sleeping tablets [n -S]\n",
  "BENADRYLS": "BENADRYL, (tradename) an antihistamine drug used in sleeping tablets [n]\n",
  "BENAME": "to name, mention [v BYNEMPT or BENAMED, BENEMPT or BENEMPTED, BENAMING, BENAMES]\n",
  "BENAMED": "BENAME, to name, mention [v]\n",
  "BENAMES": "BENAME, to name, mention [v]\n",
  "BENAMING": "BENAME, to name, mention [v]\n",
  "BENCH": "to provide with benches [v -ED, -ING, -ES]\n",
  "BENCHED": "BENCH, to provide with benches [v]\n",
  "BENCHER": "a senior member of an inn of court; a person who sits on a bench in some official capacity [n -S]\n",
  "BENCHERS": "BENCHER, a senior member of an inn of court; a person who sits on a bench in some official capacity [n]\n",
  "BENCHERSHIP": "the office of bencher [n -S]\n",
  "BENCHERSHIPS": "BENCHERSHIP, the office of bencher [n]\n",
  "BENCHES": "BENCH, to provide with benches [v]\n",
  "BENCHIER": "BENCHY, (New Zealand) of a hillside, hollowed out in bench shapes [adj]\n",
  "BENCHIEST": "BENCHY, (New Zealand) of a hillside, hollowed out in bench shapes [adj]\n",
  "BENCHING": "BENCH, to provide with benches [v]\n",
  "BENCHLAND": "a former wave-cut shore of a sea or lake [n -S]\n",
  "BENCHLANDS": "BENCHLAND, a former wave-cut shore of a sea or lake [n]\n",
  "BENCHLESS": "without a bench [adj]\n",
  "BENCHMARK": "to test by a preset standard [v -ED, -ING, -S]\n",
  "BENCHMARKED": "BENCHMARK, to test by a preset standard [v]\n",
  "BENCHMARKING": "the process of testing by a benchmark [n -S]\n",
  "BENCHMARKINGS": "BENCHMARKING, the process of testing by a benchmark [n]\n",
  "BENCHMARKS": "BENCHMARK, to test by a preset standard [v]\n",
  "BENCHTOP": "a flat surface area to work on [n -S]\n",
  "BENCHTOPS": "BENCHTOP, a flat surface area to work on [n]\n",
  "BENCHWARMER": "(slang) in sport, a reserve player [n -S]\n",
  "BENCHWARMERS": "BENCHWARMER, (slang) in sport, a reserve player [n]\n",
  "BENCHY": "(New Zealand) of a hillside, hollowed out in bench shapes [adj BENCHIER, BENCHIEST]\n",
  "BEND": "to curve [v -ED, -ING, -S]\n",
  "BENDABLE": "able to be bent [adj]\n",
  "BENDAY": "to reproduce using a certain process [v -ED, -ING, -S]\n",
  "BENDAYED": "BENDAY, to reproduce using a certain process [v]\n",
  "BENDAYING": "BENDAY, to reproduce using a certain process [v]\n",
  "BENDAYS": "BENDAY, to reproduce using a certain process [v]\n",
  "BENDED": "BEND, to curve [v]\n",
  "BENDEE": "divided into an even number of bends, coloured alternately [adj] / a heraldic field divided into bends [n -S]\n",
  "BENDEES": "BENDEE, a heraldic field divided into bends [n]\n",
  "BENDER": "a drunken spree [n -S]\n",
  "BENDERS": "BENDER, a drunken spree [n]\n",
  "BENDIER": "BENDY, full of bends [adj]\n",
  "BENDIEST": "BENDY, full of bends [adj]\n",
  "BENDINESS": "the state of being bendy [n -ES]\n",
  "BENDINESSES": "BENDINESS, the state of being bendy [n]\n",
  "BENDING": "the act of bending [n -S]\n",
  "BENDINGLY": "BENDING [adv]\n",
  "BENDINGS": "BENDING, the act of bending [n]\n",
  "BENDLET": "in heraldry, a narrow bend, esp. one half the width of the bend [n -S]\n",
  "BENDLETS": "BENDLET, in heraldry, a narrow bend, esp. one half the width of the bend [n]\n",
  "BENDS": "BEND, to curve [v]\n",
  "BENDWAYS": "diagonally, also BENDWISE [adv]\n",
  "BENDWISE": "diagonally, also BENDWAYS [adv]\n",
  "BENDY": "a tropical plant [n BENDYS] / full of bends [adj BENDIER, BENDIEST]\n",
  "BENDYS": "BENDY, a tropical plant [n]\n",
  "BENE": "a prayer, a boon [n -S]\n",
  "BENEATH": "under, also ANEATH, NEATH, UNNEATH [adv]\n",
  "BENEDICITE": "(Latin) a blessing, a grace at table [n -S]\n",
  "BENEDICITES": "BENEDICITE, (Latin) a blessing, a grace at table [n]\n",
  "BENEDICK": "a newly married husband, esp. one formerly a confirmed bachelor, also BENEDICT [n -S]\n",
  "BENEDICKS": "BENEDICK, a newly married husband, esp. one formerly a confirmed bachelor, also BENEDICT [n]\n",
  "BENEDICT": "a newly married husband, esp. one formerly a confirmed bachelor, also BENEDICK [n -S]\n",
  "BENEDICTION": "the invocation of a blessing [n -S]\n",
  "BENEDICTIONAL": "a book of benedictions [n -S]\n",
  "BENEDICTIONALS": "BENEDICTIONAL, a book of benedictions [n]\n",
  "BENEDICTIONS": "BENEDICTION, the invocation of a blessing [n]\n",
  "BENEDICTIVE": "giving benediction [adj]\n",
  "BENEDICTORY": "of or expressing benediction [adj]\n",
  "BENEDICTS": "BENEDICT, a newly married husband, esp. one formerly a confirmed bachelor, also BENEDICK [n]\n",
  "BENEDICTUS": "a short canticle beginning 'Benedictus qui venit in nomine Domini' in Latin and 'Blessed is he that cometh in the name of the Lord' in English [n -ES]\n",
  "BENEDICTUSES": "BENEDICTUS, a short canticle beginning 'Benedictus qui venit in nomine Domini' in Latin and 'Blessed is he that cometh in the name of the Lord' in English [n]\n",
  "BENEDIGHT": "blessed [adj]\n",
  "BENEFACT": "to confer a benefit upon [v -ED, -ING, -S]\n",
  "BENEFACTED": "BENEFACT, to confer a benefit upon [v]\n",
  "BENEFACTING": "BENEFACT, to confer a benefit upon [v]\n",
  "BENEFACTION": "the act of benefiting [n -S]\n",
  "BENEFACTIONS": "BENEFACTION, the act of benefiting [n]\n",
  "BENEFACTOR": "one that confers a benefit [n -S]\n",
  "BENEFACTORS": "BENEFACTOR, one that confers a benefit [n]\n",
  "BENEFACTORY": "having the nature of a benefactor [adj]\n",
  "BENEFACTRESS": "a female benefactor [n -ES]\n",
  "BENEFACTRESSES": "BENEFACTRESS, a female benefactor [n]\n",
  "BENEFACTS": "BENEFACT, to confer a benefit upon [v]\n",
  "BENEFIC": "of, having, or exerting a favorable influence [adj]\n",
  "BENEFICE": "an ecclesiastical office to which revenue is attached [n -S] / to endow with a benefice [v BENEFICED, BENEFICING, BENEFICES]\n",
  "BENEFICED": "BENEFICE, to endow with a benefice [v]\n",
  "BENEFICENCE": "the state of being beneficent [n -S]\n",
  "BENEFICENCES": "BENEFICENCE, the state of being beneficent [n]\n",
  "BENEFICENT": "doing or producing good, also BENEFICENTIAL [adj BENEFICENTLY]\n",
  "BENEFICENTIAL": "doing or producing good, also BENEFICENT [adj]\n",
  "BENEFICENTLY": "BENEFICENT, doing or producing good, also BENEFICENTIAL [adv]\n",
  "BENEFICES": "BENEFICE, to endow with a benefice [v]\n",
  "BENEFICIAL": "doing good [adj BENEFICIALLY] / (Spenser) a letter of presentation to a benefice [n -S]\n",
  "BENEFICIALLY": "BENEFICIAL, doing good [adv]\n",
  "BENEFICIALNESS": "the state of being beneficial [n]\n",
  "BENEFICIALS": "BENEFICIAL, (Spenser) a letter of presentation to a benefice [n]\n",
  "BENEFICIARIES": "BENEFICIARY, one that benefits from something [n]\n",
  "BENEFICIARY": "one that benefits from something [n BENEFICIARIES]\n",
  "BENEFICIATE": "to treat ores to remove impurities [v BENEFICIATED, BENEFICIATING, BENEFICIATES]\n",
  "BENEFICIATED": "BENEFICIATE, to treat ores to remove impurities [v]\n",
  "BENEFICIATES": "BENEFICIATE, to treat ores to remove impurities [v]\n",
  "BENEFICIATING": "BENEFICIATE, to treat ores to remove impurities [v]\n",
  "BENEFICIATION": "the treatment of raw material, such as iron ore, to improve physical or chemical properties esp. in preparation for smelting [n -S]\n",
  "BENEFICIATIONS": "BENEFICIATION, the treatment of raw material, such as iron ore, to improve physical or chemical properties esp. in preparation for smelting [n]\n",
  "BENEFICING": "BENEFICE, to endow with a benefice [v]\n",
  "BENEFIT": "to obtain an advantage [v BENEFITED or BENEFITTED, BENEFITING or BENEFITTING, BENEFITS]\n",
  "BENEFITED": "BENEFIT, to obtain an advantage [v]\n",
  "BENEFITER": "one who benefits [n -S]\n",
  "BENEFITERS": "BENEFITER, one who benefits [n]\n",
  "BENEFITING": "BENEFIT, to obtain an advantage [v]\n",
  "BENEFITS": "BENEFIT, to obtain an advantage [v]\n",
  "BENEFITTED": "BENEFIT, to obtain an advantage [v]\n",
  "BENEFITTING": "BENEFIT, to obtain an advantage [v]\n",
  "BENEMPT": "BENAME, to name, mention [v]\n",
  "BENEMPTED": "BENAME, to name, mention [v]\n",
  "BENEPLACITO": "(Italian) good pleasure; by your leave [interj]\n",
  "BENES": "BENE, a prayer, a boon [n]\n",
  "BENET": "to catch in a net, to ensnare [v BENETTED, BENETTING, BENETS]\n",
  "BENETS": "BENET, to catch in a net, to ensnare [v]\n",
  "BENETTED": "BENET, to catch in a net, to ensnare [v]\n",
  "BENETTING": "BENET, to catch in a net, to ensnare [v]\n",
  "BENEVOLENCE": "a disposition to do good [n -S]\n",
  "BENEVOLENCES": "BENEVOLENCE, a disposition to do good [n]\n",
  "BENEVOLENT": "marked by or disposed to doing good [adj BENEVOLENTLY]\n",
  "BENEVOLENTLY": "BENEVOLENT, marked by or disposed to doing good [adv]\n",
  "BENEVOLENTNESS": "the state of being benevolent [n]\n",
  "BENGA": "a form of Kenyan popular music featuring guitars [n -S]\n",
  "BENGALINE": "a crosswise ribbed fabric [n -S]\n",
  "BENGALINES": "BENGALINE, a crosswise ribbed fabric [n]\n",
  "BENGAS": "BENGA, a form of Kenyan popular music featuring guitars [n]\n",
  "BENI": "the sesame plant, also BENNE, BENNI [n -S]\n",
  "BENIGHT": "to be overtaken by night [v -ED, -ING, -S]\n",
  "BENIGHTED": "BENIGHT, to be overtaken by night [v]\n",
  "BENIGHTEDLY": "BENIGHTED, BENIGHT, to be overtaken by night [adv]\n",
  "BENIGHTEDNESS": "the state of being benighted [n -ES]\n",
  "BENIGHTEDNESSES": "BENIGHTEDNESS, the state of being benighted [n]\n",
  "BENIGHTEN": "to overtake with night, also BENIGHT [v -ED, -ING, -S]\n",
  "BENIGHTENED": "BENIGHTEN, to overtake with night, also BENIGHT [v]\n",
  "BENIGHTENING": "being overtaken by night [n -S]\n",
  "BENIGHTENINGS": "BENIGHTENING, being overtaken by night [n]\n",
  "BENIGHTENS": "BENIGHTEN, to overtake with night, also BENIGHT [v]\n",
  "BENIGHTER": "one who benights [n -S]\n",
  "BENIGHTERS": "BENIGHTER, one who benights [n]\n",
  "BENIGHTING": "being overtaken with night [n -S]\n",
  "BENIGHTINGS": "BENIGHTING, being overtaken with night [n]\n",
  "BENIGHTMENT": "the state of being benighted [n -S]\n",
  "BENIGHTMENTS": "BENIGHTMENT, the state of being benighted [n]\n",
  "BENIGHTS": "BENIGHT, to be overtaken by night [v]\n",
  "BENIGN": "favourably disposed [adj BENIGNER, BENIGNEST, BENIGNLY]\n",
  "BENIGNANCIES": "BENIGNANCY, a benignant quality [n]\n",
  "BENIGNANCY": "a benignant quality [n BENIGNANCIES]\n",
  "BENIGNANT": "kind; gracious, as a king to his subjects [adj BENIGNANTLY]\n",
  "BENIGNANTLY": "BENIGNANT, kind; gracious, as a king to his subjects [adv]\n",
  "BENIGNER": "BENIGN, favourably disposed [adj]\n",
  "BENIGNEST": "BENIGN, favourably disposed [adj]\n",
  "BENIGNITIES": "BENIGNITY, the state of being benign [n]\n",
  "BENIGNITY": "the state of being benign [n BENIGNITIES]\n",
  "BENIGNLY": "BENIGN, favourably disposed [adv]\n",
  "BENIS": "BENI, the sesame plant, also BENNE, BENNI [n]\n",
  "BENISEED": "sesame seed [n -S]\n",
  "BENISEEDS": "BENISEED, sesame seed [n]\n",
  "BENISON": "a blessing, a benediction [n -S]\n",
  "BENISONS": "BENISON, a blessing, a benediction [n]\n",
  "BENITIER": "(French) a holy-water font [n -S]\n",
  "BENITIERS": "BENITIER, (French) a holy-water font [n]\n",
  "BENJ": "(Arabic) cannabis, Indian hemp, used as a weak narcotic, also BHANG [n -ES]\n",
  "BENJAMIN": "a kind of overcoat [n -S]\n",
  "BENJAMINS": "BENJAMIN, a kind of overcoat [n]\n",
  "BENJES": "BENJ, (Arabic) cannabis, Indian hemp, used as a weak narcotic, also BHANG [n]\n",
  "BENNE": "the sesame plant, also BENI, BENNI [n -S]\n",
  "BENNES": "BENNE, the sesame plant, also BENI, BENNI [n]\n",
  "BENNET": "a dry grass stalk [n -S]\n",
  "BENNETS": "BENNET, a dry grass stalk [n]\n",
  "BENNI": "the sesame plant, also BENNE, BENI [n -S]\n",
  "BENNIES": "BENNY, (slang) an overcoat [n]\n",
  "BENNIS": "BENNI, the sesame plant, also BENNE, BENI [n]\n",
  "BENNY": "(slang) an overcoat [n BENNIES]\n",
  "BENOMYL": "a pesticide and fungicide [n -S]\n",
  "BENOMYLS": "BENOMYL, a pesticide and fungicide [n]\n",
  "BENS": "BEN, (Gaelic) a mountain [n]\n",
  "BENT": "a stiff wiry grass, also BENTGRASS [n -S]\n",
  "BENTGRASS": "a stiff wiry grass, also BENT [n -ES]\n",
  "BENTGRASSES": "BENTGRASS, a stiff wiry grass, also BENT [n]\n",
  "BENTHAL": "living on the sea bottom, also BENTHIC, BENTHOAL, BENTHONIC [adj]\n",
  "BENTHIC": "living on the sea bottom, also BENTHAL, BENTHOAL, BENTHONIC [adj]\n",
  "BENTHOAL": "living on the sea bottom, also BENTHAL, BENTHIC, BENTHONIC [adj]\n",
  "BENTHON": "the flora and fauna of the ocean floor, also BENTHOS [n -S]\n",
  "BENTHONIC": "living on the sea bottom, also BENTHAL, BENTHIC, BENTHOAL [adj]\n",
  "BENTHONS": "BENTHON, the flora and fauna of the ocean floor, also BENTHOS [n]\n",
  "BENTHOPELAGIC": "living just above the seabed [adj]\n",
  "BENTHOS": "(Greek) the flora and fauna of the ocean floor, also BENTHON [n -ES]\n",
  "BENTHOSCOPE": "a submersible sphere from which to study deep-sea life [n -S]\n",
  "BENTHOSCOPES": "BENTHOSCOPE, a submersible sphere from which to study deep-sea life [n]\n",
  "BENTHOSES": "BENTHOS, (Greek) the flora and fauna of the ocean floor, also BENTHON [n]\n",
  "BENTIER": "BENTY, like wiry grass [adj]\n",
  "BENTIEST": "BENTY, like wiry grass [adj]\n",
  "BENTO": "(Japanese) a Japanese meal packed in a box, also OBENTO [n -S]\n",
  "BENTONITE": "a kind of clay, used in industry as a filler etc. [n -S]\n",
  "BENTONITES": "BENTONITE, a kind of clay, used in industry as a filler etc. [n]\n",
  "BENTONITIC": "of or like bentonite [adj]\n",
  "BENTOS": "BENTO, (Japanese) a Japanese meal packed in a box, also OBENTO [n]\n",
  "BENTS": "BENT, a stiff wiry grass, also BENTGRASS [n]\n",
  "BENTWOOD": "wood artificially curved for furniture making etc. [n -S]\n",
  "BENTWOODS": "BENTWOOD, wood artificially curved for furniture making etc. [n]\n",
  "BENTY": "like wiry grass [adj BENTIER, BENTIEST]\n",
  "BENUMB": "to make numb [v -ED, -ING, -S]\n",
  "BENUMBED": "BENUMB, to make numb [v]\n",
  "BENUMBEDNESS": "the state of being benumbed [n -ES]\n",
  "BENUMBEDNESSES": "BENUMBEDNESS, the state of being benumbed [n]\n",
  "BENUMBING": "BENUMB, to make numb [v]\n",
  "BENUMBINGLY": "BENUMBING, BENUMB, to make numb [adv]\n",
  "BENUMBMENT": "the state of being benumbed [n -S]\n",
  "BENUMBMENTS": "BENUMBMENT, the state of being benumbed [n]\n",
  "BENUMBS": "BENUMB, to make numb [v]\n",
  "BENZAL": "a radical in oil of bitter almonds [n -S]\n",
  "BENZALDEHYDE": "oil of bitter almonds [n -S]\n",
  "BENZALDEHYDES": "BENZALDEHYDE, oil of bitter almonds [n]\n",
  "BENZALS": "BENZAL, a radical in oil of bitter almonds [n]\n",
  "BENZANTHRACENE": "a crystalline carcinogenic cyclic hydrocarbon that is found in small amounts in coal tar [n -S]\n",
  "BENZANTHRACENES": "BENZANTHRACENE, a crystalline carcinogenic cyclic hydrocarbon that is found in small amounts in coal tar [n]\n",
  "BENZENE": "a solvent distilled from petroleum [n -S]\n",
  "BENZENECARBONYL": "a systemic name for benzoyl [n]\n",
  "BENZENES": "BENZENE, a solvent distilled from petroleum [n]\n",
  "BENZENOID": "like benzene, a hydrocarbon [adj] / a substance like benzene [n -S]\n",
  "BENZENOIDS": "BENZENOID, a substance like benzene [n]\n",
  "BENZIDIN": "a hydrocarbon used in some dyes [n -S]\n",
  "BENZIDINE": "a base used in preparing azo-dyes, also BENZIDIN [n -S]\n",
  "BENZIDINES": "BENZIDINE, a base used in preparing azo-dyes, also BENZIDIN [n]\n",
  "BENZIDINS": "BENZIDIN, a hydrocarbon used in some dyes [n]\n",
  "BENZIL": "a hydrocarbon radical [n -S]\n",
  "BENZILS": "BENZIL, a hydrocarbon radical [n]\n",
  "BENZIMIDAZOLE": "a crystalline base used esp. to inhibit the growth of various viruses, parasitic worms, or fungi [n -S]\n",
  "BENZIMIDAZOLES": "BENZIMIDAZOLE, a crystalline base used esp. to inhibit the growth of various viruses, parasitic worms, or fungi [n]\n",
  "BENZIN": "a solvent distilled from petroleum, also BENZINE [n -S]\n",
  "BENZINE": "a mixture of hydrocarbons obtained by the distillation of petroleum, also BENZIN [n -S]\n",
  "BENZINES": "BENZINE, a mixture of hydrocarbons obtained by the distillation of petroleum, also BENZIN [n]\n",
  "BENZINS": "BENZIN, a solvent distilled from petroleum, also BENZINE [n]\n",
  "BENZOAPYRENE": "a carcinogenic hydrocarbon found in coal tar, also BENZPYRENE [n -S]\n",
  "BENZOAPYRENES": "BENZOAPYRENE, a carcinogenic hydrocarbon found in coal tar, also BENZPYRENE [n]\n",
  "BENZOATE": "a salt of benzoic acid [n -S]\n",
  "BENZOATES": "BENZOATE, a salt of benzoic acid [n]\n",
  "BENZOCAINE": "a drug used as a local anaesthetic [n -S]\n",
  "BENZOCAINES": "BENZOCAINE, a drug used as a local anaesthetic [n]\n",
  "BENZODIAZEPINE": "any of a group of amines (as diazepam and chlordiazepoxide) used esp. as tranquilizers [n -S]\n",
  "BENZODIAZEPINES": "BENZODIAZEPINE, any of a group of amines (as diazepam and chlordiazepoxide) used esp. as tranquilizers [n]\n",
  "BENZOFURAN": "a compound found in coal tar [n -S]\n",
  "BENZOFURANS": "BENZOFURAN, a compound found in coal tar [n]\n",
  "BENZOIC": "relating to benzoin, as in benzoic acid, found in benzoin and other gums [adj]\n",
  "BENZOIN": "a fragrant aromatic resin obtained from eastern Asian trees of the genus Styrax [n -S]\n",
  "BENZOINS": "BENZOIN, a fragrant aromatic resin obtained from eastern Asian trees of the genus Styrax [n]\n",
  "BENZOL": "a crude form of benzene, also BENZOLE [n -S]\n",
  "BENZOLE": "crude benzene, used as a motor-spirit, also BENZOL [n -S]\n",
  "BENZOLES": "BENZOLE, crude benzene, used as a motor-spirit, also BENZOL [n]\n",
  "BENZOLINE": "impure benzene [n -S]\n",
  "BENZOLINES": "BENZOLINE, impure benzene [n]\n",
  "BENZOLS": "BENZOL, a crude form of benzene, also BENZOLE [n]\n",
  "BENZOPHENONE": "a colorless crystalline ketone used esp. as a perfume fixative and in sunscreens [n -S]\n",
  "BENZOPHENONES": "BENZOPHENONE, a colorless crystalline ketone used esp. as a perfume fixative and in sunscreens [n]\n",
  "BENZOQUINONE": "quinone [n -S]\n",
  "BENZOQUINONES": "BENZOQUINONE, quinone [n]\n",
  "BENZOYL": "a compound radical, the base of benzoic acid [n -S]\n",
  "BENZOYLS": "BENZOYL, a compound radical, the base of benzoic acid [n]\n",
  "BENZPYRENE": "a cancer-inducing hydrocarbon, also BENZOAPYRENE [n -S]\n",
  "BENZPYRENES": "BENZPYRENE, a cancer-inducing hydrocarbon, also BENZOAPYRENE [n]\n",
  "BENZYL": "a compound radical, related to toluene and benzoic acid [n -S]\n",
  "BENZYLIC": "of or like benzyl [adj]\n",
  "BENZYLIDINE": "a radical whose oxide is benzaldehyde or oil of bitter almonds [n -S]\n",
  "BENZYLIDINES": "BENZYLIDINE, a radical whose oxide is benzaldehyde or oil of bitter almonds [n]\n",
  "BENZYLS": "BENZYL, a compound radical, related to toluene and benzoic acid [n]\n",
  "BEPAINT": "(archaic) to paint over, to colour [v -ED, -ING, -S]\n",
  "BEPAINTED": "BEPAINT, (archaic) to paint over, to colour [v]\n",
  "BEPAINTING": "BEPAINT, (archaic) to paint over, to colour [v]\n",
  "BEPAINTS": "BEPAINT, (archaic) to paint over, to colour [v]\n",
  "BEPAT": "to pat often [v BEPATTED, BEPATTING, BEPATS]\n",
  "BEPATCHED": "(archaic) covered with patches [adj]\n",
  "BEPATS": "BEPAT, to pat often [v]\n",
  "BEPATTED": "BEPAT, to pat often [v]\n",
  "BEPATTING": "BEPAT, to pat often [v]\n",
  "BEPEARL": "to cover with pearls [v -ED, -ING, -S]\n",
  "BEPEARLED": "BEPEARL, to cover with pearls [v]\n",
  "BEPEARLING": "BEPEARL, to cover with pearls [v]\n",
  "BEPEARLS": "BEPEARL, to cover with pearls [v]\n",
  "BEPELT": "to pelt hard [v -ED, -ING, -S]\n",
  "BEPELTED": "BEPELT, to pelt hard [v]\n",
  "BEPELTING": "BEPELT, to pelt hard [v]\n",
  "BEPELTS": "BEPELT, to pelt hard [v]\n",
  "BEPEPPER": "to hit hard with gunshot [v -ED, -ING, -S]\n",
  "BEPEPPERED": "BEPEPPER, to hit hard with gunshot [v]\n",
  "BEPEPPERING": "BEPEPPER, to hit hard with gunshot [v]\n",
  "BEPEPPERS": "BEPEPPER, to hit hard with gunshot [v]\n",
  "BEPESTER": "(archaic) to pester, bother [v -ED, -ING, -S]\n",
  "BEPESTERED": "BEPESTER, (archaic) to pester, bother [v]\n",
  "BEPESTERING": "BEPESTER, (archaic) to pester, bother [v]\n",
  "BEPESTERS": "BEPESTER, (archaic) to pester, bother [v]\n",
  "BEPIMPLE": "to cover with pimples [v BEPIMPLED, BEPIMPLING, BEPIMPLES]\n",
  "BEPIMPLED": "BEPIMPLE, to cover with pimples [v]\n",
  "BEPIMPLES": "BEPIMPLE, to cover with pimples [v]\n",
  "BEPIMPLING": "BEPIMPLE, to cover with pimples [v]\n",
  "BEPITIED": "BEPITY, to pity greatly [v]\n",
  "BEPITIES": "BEPITY, to pity greatly [v]\n",
  "BEPITY": "to pity greatly [v BEPITIED, BEPITYING, BEPITIES]\n",
  "BEPITYING": "BEPITY, to pity greatly [v]\n",
  "BEPLASTER": "(archaic) to plaster thickly [v -ED, -ING, -S]\n",
  "BEPLASTERED": "BEPLASTER, (archaic) to plaster thickly [v]\n",
  "BEPLASTERING": "BEPLASTER, (archaic) to plaster thickly [v]\n",
  "BEPLASTERS": "BEPLASTER, (archaic) to plaster thickly [v]\n",
  "BEPLUMED": "(archaic) adorned with feathers [adj]\n",
  "BEPOMMEL": "to pommel soundly [v BEPOMMELLED, BEPOMMELLING, BEPOMMELS]\n",
  "BEPOMMELLED": "BEPOMMEL, to pommel soundly [v]\n",
  "BEPOMMELLING": "BEPOMMEL, to pommel soundly [v]\n",
  "BEPOMMELS": "BEPOMMEL, to pommel soundly [v]\n",
  "BEPOWDER": "to powder over [v -ED, -ING, -S]\n",
  "BEPOWDERED": "BEPOWDER, to powder over [v]\n",
  "BEPOWDERING": "BEPOWDER, to powder over [v]\n",
  "BEPOWDERS": "BEPOWDER, to powder over [v]\n",
  "BEPRAISE": "to lavish praise upon [v BEPRAISED, BEPRAISING, BEPRAISES]\n",
  "BEPRAISED": "BEPRAISE, to lavish praise upon [v]\n",
  "BEPRAISES": "BEPRAISE, to lavish praise upon [v]\n",
  "BEPRAISING": "BEPRAISE, to lavish praise upon [v]\n",
  "BEPROSE": "to reduce to prose [v BEPROSED, BEPROSING, BEPROSES]\n",
  "BEPROSED": "BEPROSE, to reduce to prose [v]\n",
  "BEPROSES": "BEPROSE, to reduce to prose [v]\n",
  "BEPROSING": "BEPROSE, to reduce to prose [v]\n",
  "BEPUFF": "(archaic) to puff out, to praise to excess [v -ED, -ING, -S]\n",
  "BEPUFFED": "BEPUFF, (archaic) to puff out, to praise to excess [v]\n",
  "BEPUFFING": "BEPUFF, (archaic) to puff out, to praise to excess [v]\n",
  "BEPUFFS": "BEPUFF, (archaic) to puff out, to praise to excess [v]\n",
  "BEQUEATH": "to leave by will [v -ED, -ING, -S]\n",
  "BEQUEATHABLE": "capable of being bequeathed [adj]\n",
  "BEQUEATHAL": "the act of bequeathing [n -S]\n",
  "BEQUEATHALS": "BEQUEATHAL, the act of bequeathing [n]\n",
  "BEQUEATHED": "BEQUEATH, to leave by will [v]\n",
  "BEQUEATHER": "one who bequeaths [n -S]\n",
  "BEQUEATHERS": "BEQUEATHER, one who bequeaths [n]\n",
  "BEQUEATHING": "BEQUEATH, to leave by will [v]\n",
  "BEQUEATHMENT": "the act of bequeathing [n -S]\n",
  "BEQUEATHMENTS": "BEQUEATHMENT, the act of bequeathing [n]\n",
  "BEQUEATHS": "BEQUEATH, to leave by will [v]\n",
  "BEQUEST": "a legacy [n -S]\n",
  "BEQUESTS": "BEQUEST, a legacy [n]\n",
  "BERAKE": "to rake all over [v BERAKED, BERAKING, BERAKES]\n",
  "BERAKED": "BERAKE, to rake all over [v]\n",
  "BERAKES": "BERAKE, to rake all over [v]\n",
  "BERAKING": "BERAKE, to rake all over [v]\n",
  "BERASCAL": "to accuse of being a rascal [v -ED, -ING, -S]\n",
  "BERASCALED": "BERASCAL, to accuse of being a rascal [v]\n",
  "BERASCALING": "BERASCAL, to accuse of being a rascal [v]\n",
  "BERASCALS": "BERASCAL, to accuse of being a rascal [v]\n",
  "BERATE": "to scold severely [v BERATED, BERATING, BERATES]\n",
  "BERATED": "BERATE, to scold severely [v]\n",
  "BERATES": "BERATE, to scold severely [v]\n",
  "BERATING": "BERATE, to scold severely [v]\n",
  "BERAY": "(obsolete) to befoul [v -ED, -ING, -S]\n",
  "BERAYED": "BERAY, (obsolete) to befoul [v]\n",
  "BERAYING": "BERAY, (obsolete) to befoul [v]\n",
  "BERAYS": "BERAY, (obsolete) to befoul [v]\n",
  "BERBER": "a type of carpet [n -S]\n",
  "BERBERE": "(French) an Ethiopian hot paste used in stews [n -S]\n",
  "BERBERES": "BERBERE, (French) an Ethiopian hot paste used in stews [n]\n",
  "BERBERIDACEOUS": "belonging to the Berberidaceae, that includes barberry [adj]\n",
  "BERBERIN": "an alkaloid obtained from barberry roots, also BERBERINE [n -S]\n",
  "BERBERINE": "an alkaloid obtained from barberry roots, also BERBERIN [n -S]\n",
  "BERBERINES": "BERBERINE, an alkaloid obtained from barberry roots, also BERBERIN [n]\n",
  "BERBERINS": "BERBERIN, an alkaloid obtained from barberry roots, also BERBERINE [n]\n",
  "BERBERIS": "a flowering shrub [n -ES]\n",
  "BERBERISES": "BERBERIS, a flowering shrub [n]\n",
  "BERBERS": "BERBER, a type of carpet [n]\n",
  "BERBICE": "as in berbice chair, a type of armchair with long arms that can be folded inwards to act as leg rests [adj]\n",
  "BERCEAU": "(French) a cradle, a covered walk [n BERCEAUX]\n",
  "BERCEAUX": "BERCEAU, (French) a cradle, a covered walk [n]\n",
  "BERCEUSE": "(French) a lullaby [n -S]\n",
  "BERCEUSES": "BERCEUSE, (French) a lullaby [n]\n",
  "BERDACHE": "(French) an American Indian transvestite, also BERDASH [n -S]\n",
  "BERDACHES": "BERDACHE, (French) an American Indian transvestite, also BERDASH [n]\n",
  "BERDASH": "(French) an American Indian transvestite, also BERDACHE [n -ES]\n",
  "BERDASHES": "BERDASH, (French) an American Indian transvestite, also BERDACHE [n]\n",
  "BERE": "barley, esp. the six-rowed barley [n -S]\n",
  "BEREAVE": "to deprive esp. by death [v BEREAVED, BEREAVEN or BEREFT, BEREAVING, BEREAVES]\n",
  "BEREAVED": "BEREAVE, to deprive esp. by death [v]\n",
  "BEREAVEMENT": "the state or fact of being bereaved [n -S]\n",
  "BEREAVEMENTS": "BEREAVEMENT, the state or fact of being bereaved [n]\n",
  "BEREAVEN": "BEREAVE, to deprive esp. by death [v]\n",
  "BEREAVER": "one who bereaves [n -S]\n",
  "BEREAVERS": "BEREAVER, one who bereaves [n]\n",
  "BEREAVES": "BEREAVE, to deprive esp. by death [v]\n",
  "BEREAVING": "BEREAVE, to deprive esp. by death [v]\n",
  "BEREFT": "BEREAVE, to deprive esp. by death [v]\n",
  "BERES": "BERE, barley, esp. the six-rowed barley [n]\n",
  "BERET": "a flat round woollen cap, also BERRET [n -S]\n",
  "BERETS": "BERET, a flat round woollen cap, also BERRET [n]\n",
  "BERETTA": "(Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERRETTA, BIRETTA, BIRRETTA [n -S]\n",
  "BERETTAS": "BERETTA, (Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERRETTA, BIRETTA, BIRRETTA [n]\n",
  "BERG": "(South African) a hill or mountain in S. Africa [n -S]\n",
  "BERGALL": "a fish of the wrasse family found in British coastal areas, aka cunner [n -S]\n",
  "BERGALLS": "BERGALL, a fish of the wrasse family found in British coastal areas, aka cunner [n]\n",
  "BERGAMA": "a type of rug [n -S]\n",
  "BERGAMAS": "BERGAMA, a type of rug [n]\n",
  "BERGAMASK": "a rustic dance, also BERGOMASK [n -S]\n",
  "BERGAMASKO": "an inhabitant of Bergamo [n -S]\n",
  "BERGAMASKOS": "BERGAMASKO, an inhabitant of Bergamo [n]\n",
  "BERGAMASKS": "BERGAMASK, a rustic dance, also BERGOMASK [n]\n",
  "BERGAMOT": "(French) a citrus tree [n -S]\n",
  "BERGAMOTS": "BERGAMOT, (French) a citrus tree [n]\n",
  "BERGANDER": "the shelduck, also BARGANDER [n -S]\n",
  "BERGANDERS": "BERGANDER, the shelduck, also BARGANDER [n]\n",
  "BERGEN": "a type of large rucksack [n -S]\n",
  "BERGENIA": "(German) any of various perennial plants of the genus Bergenia, of the saxifrage family [n -S]\n",
  "BERGENIAS": "BERGENIA, (German) any of various perennial plants of the genus Bergenia, of the saxifrage family [n]\n",
  "BERGENS": "BERGEN, a type of large rucksack [n]\n",
  "BERGERE": "(French) a type of easy chair or sofa with cane back and arms [n -S]\n",
  "BERGERES": "BERGERE, (French) a type of easy chair or sofa with cane back and arms [n]\n",
  "BERGFALL": "(German) a fall of mountain rock [n -S]\n",
  "BERGFALLS": "BERGFALL, (German) a fall of mountain rock [n]\n",
  "BERGHAAN": "(South African) the bateleur eagle [n -S]\n",
  "BERGHAANS": "BERGHAAN, (South African) the bateleur eagle [n]\n",
  "BERGMEHL": "(German) a powdery deposit of diatom frustules, aka kieselguhr [n -S]\n",
  "BERGMEHLS": "BERGMEHL, (German) a powdery deposit of diatom frustules, aka kieselguhr [n]\n",
  "BERGOMASK": "a rustic dance, also BERGAMASK [n -S]\n",
  "BERGOMASKS": "BERGOMASK, a rustic dance, also BERGAMASK [n]\n",
  "BERGS": "BERG, (South African) a hill or mountain in S. Africa [n]\n",
  "BERGSCHRUND": "(German) a crevasse formed where a glacier or snowfield moves away from a mountain wall [n -S]\n",
  "BERGSCHRUNDS": "BERGSCHRUND, (German) a crevasse formed where a glacier or snowfield moves away from a mountain wall [n]\n",
  "BERGYLT": "(Norwegian) the Norway haddock [n -S]\n",
  "BERGYLTS": "BERGYLT, (Norwegian) the Norway haddock [n]\n",
  "BERHYME": "to compose in rhyme, also BERIME [v BERHYMED, BERHYMING, BERHYMES]\n",
  "BERHYMED": "BERHYME, to compose in rhyme, also BERIME [v]\n",
  "BERHYMES": "BERHYME, to compose in rhyme, also BERIME [v]\n",
  "BERHYMING": "BERHYME, to compose in rhyme, also BERIME [v]\n",
  "BERIBBONED": "adorned with ribbons [adj]\n",
  "BERIBERI": "(Sinhalese) a disease caused by a lack of vitamin B [n -S]\n",
  "BERIBERIS": "BERIBERI, (Sinhalese) a disease caused by a lack of vitamin B [n]\n",
  "BERIMBAU": "a Brazilian single-stringed bowed instrument, used to accompany capoeira [n -S]\n",
  "BERIMBAUS": "BERIMBAU, a Brazilian single-stringed bowed instrument, used to accompany capoeira [n]\n",
  "BERIME": "to compose in rhyme, also BERHYME [v BERIMED, BERIMING, BERIMES]\n",
  "BERIMED": "BERIME, to compose in rhyme, also BERHYME [v]\n",
  "BERIMES": "BERIME, to compose in rhyme, also BERHYME [v]\n",
  "BERIMING": "BERIME, to compose in rhyme, also BERHYME [v]\n",
  "BERINGED": "adorned with rings [adj]\n",
  "BERK": "(colloquial) a fool, also BURK [n -S]\n",
  "BERKELIUM": "a radioactive, metallic element made artificially [n -S]\n",
  "BERKELIUMS": "BERKELIUM, a radioactive, metallic element made artificially [n]\n",
  "BERKO": "(Australian slang) berserk [adj]\n",
  "BERKS": "BERK, (colloquial) a fool, also BURK [n]\n",
  "BERLEY": "(Australian) to scatter fish bait on water, also BURLEY [v -ED, -ING, -S]\n",
  "BERLEYED": "BERLEY, (Australian) to scatter fish bait on water, also BURLEY [v]\n",
  "BERLEYING": "BERLEY, (Australian) to scatter fish bait on water, also BURLEY [v]\n",
  "BERLEYS": "BERLEY, (Australian) to scatter fish bait on water, also BURLEY [v]\n",
  "BERLIN": "(German) an old four-wheeled carriage, also BERLINE [n -S]\n",
  "BERLINE": "(German) an old four-wheeled carriage, also BERLIN [n -S]\n",
  "BERLINES": "BERLINE, (German) an old four-wheeled carriage, also BERLIN [n]\n",
  "BERLINS": "BERLIN, (German) an old four-wheeled carriage, also BERLINE [n]\n",
  "BERM": "a narrow shelf or path between the bottom of a parapet and the ditch [n -S] / to provide a berm, also BERME [v -ED, -ING, -S]\n",
  "BERME": "a narrow shelf or path between the bottom of a parapet and the ditch, also BERM [n -S]\n",
  "BERMED": "BERM, to provide a berm, also BERME [v]\n",
  "BERMES": "BERME, a narrow shelf or path between the bottom of a parapet and the ditch, also BERM [n]\n",
  "BERMING": "BERM, to provide a berm, also BERME [v]\n",
  "BERMS": "BERM, to provide a berm, also BERME [v]\n",
  "BERMUDAS": "knee-length walking shorts [n]\n",
  "BERNICLE": "a kind of wild goose, aka brant or barnacle [n -S]\n",
  "BERNICLES": "BERNICLE, a kind of wild goose, aka brant or barnacle [n]\n",
  "BEROB": "(Spenser) to rob [v BEROBBED, BEROBBING, BEROBS]\n",
  "BEROBBED": "BEROB, (Spenser) to rob [v]\n",
  "BEROBBING": "BEROB, (Spenser) to rob [v]\n",
  "BEROBED": "wearing a robe [adj]\n",
  "BEROBS": "BEROB, (Spenser) to rob [v]\n",
  "BEROUGED": "thickly rouged [adj]\n",
  "BERRET": "a round close-fitting brimless cap of soft wool material or felt, also BERET [n -S]\n",
  "BERRETS": "BERRET, a round close-fitting brimless cap of soft wool material or felt, also BERET [n]\n",
  "BERRETTA": "(Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERETTA, BIRETTA, BIRRETTA [n -S]\n",
  "BERRETTAS": "BERRETTA, (Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERETTA, BIRETTA, BIRRETTA [n]\n",
  "BERRIED": "BERRY, to collect berries [v]\n",
  "BERRIES": "BERRY, to collect berries [v]\n",
  "BERRIGAN": "an Australian tree with hanging branches [n -S]\n",
  "BERRIGANS": "BERRIGAN, an Australian tree with hanging branches [n]\n",
  "BERRY": "a fleshy fruit which has no stony layer and usually contains many seeds [n BERRIES] / to collect berries [v BERRIED, BERRYING, BERRIES]\n",
  "BERRYFRUIT": "a fruit in the form of a berry [n -S]\n",
  "BERRYFRUITS": "BERRYFRUIT, a fruit in the form of a berry [n]\n",
  "BERRYING": "the gathering of berries [n -S]\n",
  "BERRYINGS": "BERRYING, the gathering of berries [n]\n",
  "BERRYLESS": "without berries [adj]\n",
  "BERRYLIKE": "like a berry [adj]\n",
  "BERSAGLIERE": "(Italian) a rifleman of the Italian army [n BERSAGLIERI]\n",
  "BERSAGLIERI": "BERSAGLIERE, (Italian) a rifleman of the Italian army [n]\n",
  "BERSEEM": "a Mediterranean clover, grown as a forage crop [n -S]\n",
  "BERSEEMS": "BERSEEM, a Mediterranean clover, grown as a forage crop [n]\n",
  "BERSERK": "(Old Norse) out of control [adj BERSERKLY] / a Norse warrior who fought without armor, or shirt of mail, also BERSERKER, BARESARK [n -S]\n",
  "BERSERKER": "(Old Norse) a Norse warrior who fought without armor, or shirt of mail, also BARESARK, BERSERK [n -S]\n",
  "BERSERKERS": "BERSERKER, (Old Norse) a Norse warrior who fought without armor, or shirt of mail, also BARESARK, BERSERK [n]\n",
  "BERSERKLY": "BERSERK, (Old Norse) out of control [adv]\n",
  "BERSERKS": "BERSERK, a Norse warrior who fought without armor, or shirt of mail, also BERSERKER, BARESARK [n]\n",
  "BERTH": "to moor a ship [v -ED, -ING, -S]\n",
  "BERTHA": "a woman's deep lace collar to hide a low neckline, also BERTHE [n -S]\n",
  "BERTHAGE": "a place for mooring vessels in a dock or harbor [n -S]\n",
  "BERTHAGES": "BERTHAGE, a place for mooring vessels in a dock or harbor [n]\n",
  "BERTHAS": "BERTHA, a woman's deep lace collar to hide a low neckline, also BERTHE [n]\n",
  "BERTHE": "a woman's deep lace collar to hide a low neckline, also BERTHA [n -S]\n",
  "BERTHED": "BERTH, to moor a ship [v]\n",
  "BERTHES": "BERTHE, a woman's deep lace collar to hide a low neckline, also BERTHA [n]\n",
  "BERTHING": "the act of occupying a berth [n -S]\n",
  "BERTHINGS": "BERTHING, the act of occupying a berth [n]\n",
  "BERTHS": "BERTH, to moor a ship [v]\n",
  "BERTILLONAGE": "(French) a system of criminal identification by detailed measurements [n -S]\n",
  "BERTILLONAGES": "BERTILLONAGE, (French) a system of criminal identification by detailed measurements [n]\n",
  "BERYL": "a semiprecious stone [n -S]\n",
  "BERYLINE": "of or like beryl, the semiprecious stone [adj]\n",
  "BERYLLIA": "an oxide of beryllium used as a hardener, aka glucina [n -S]\n",
  "BERYLLIAS": "BERYLLIA, an oxide of beryllium used as a hardener, aka glucina [n]\n",
  "BERYLLIOSES": "BERYLLIOSIS, beryllium poisoning [n]\n",
  "BERYLLIOSIS": "beryllium poisoning [n BERYLLIOSES]\n",
  "BERYLLIUM": "a metallic element [n -S]\n",
  "BERYLLIUMS": "BERYLLIUM, a metallic element [n]\n",
  "BERYLS": "BERYL, a semiprecious stone [n]\n",
  "BES": "(Hebrew) the second letter of the Hebrew alphabet, also BETH [n -ES]\n",
  "BESAINT": "to make a saint of [v -ED, -ING, -S]\n",
  "BESAINTED": "BESAINT, to make a saint of [v]\n",
  "BESAINTING": "BESAINT, to make a saint of [v]\n",
  "BESAINTS": "BESAINT, to make a saint of [v]\n",
  "BESANG": "BESING, (archaic) to celebrate in song [v]\n",
  "BESAT": "BESIT, (archaic) to suit, to become [v]\n",
  "BESAW": "BESEE, (obsolete) to look to [v]\n",
  "BESCATTER": "(archaic) to scatter over [v -ED, -ING, -S]\n",
  "BESCATTERED": "BESCATTER, (archaic) to scatter over [v]\n",
  "BESCATTERING": "BESCATTER, (archaic) to scatter over [v]\n",
  "BESCATTERS": "BESCATTER, (archaic) to scatter over [v]\n",
  "BESCORCH": "to scorch thoroughly [v -ED, -ING, -ES]\n",
  "BESCORCHED": "BESCORCH, to scorch thoroughly [v]\n",
  "BESCORCHES": "BESCORCH, to scorch thoroughly [v]\n",
  "BESCORCHING": "BESCORCH, to scorch thoroughly [v]\n",
  "BESCOUR": "to scour thoroughly [v -ED, -ING, -S]\n",
  "BESCOURED": "BESCOUR, to scour thoroughly [v]\n",
  "BESCOURING": "BESCOUR, to scour thoroughly [v]\n",
  "BESCOURS": "BESCOUR, to scour thoroughly [v]\n",
  "BESCRAWL": "to cover with scrawls [v -ED, -ING, -S]\n",
  "BESCRAWLED": "BESCRAWL, to cover with scrawls [v]\n",
  "BESCRAWLING": "BESCRAWL, to cover with scrawls [v]\n",
  "BESCRAWLS": "BESCRAWL, to cover with scrawls [v]\n",
  "BESCREEN": "to cover with a screen, or as with a screen [v -ED, -ING, -S]\n",
  "BESCREENED": "BESCREEN, to cover with a screen, or as with a screen [v]\n",
  "BESCREENING": "BESCREEN, to cover with a screen, or as with a screen [v]\n",
  "BESCREENS": "BESCREEN, to cover with a screen, or as with a screen [v]\n",
  "BESCRIBBLE": "(archaic) to scribble over [v BESCRIBBLED, BESCRIBBLING, BESCRIBBLES]\n",
  "BESCRIBBLED": "BESCRIBBLE, (archaic) to scribble over [v]\n",
  "BESCRIBBLES": "BESCRIBBLE, (archaic) to scribble over [v]\n",
  "BESCRIBBLING": "BESCRIBBLE, (archaic) to scribble over [v]\n",
  "BESEE": "(obsolete) to look to [v BESAW, BESEEN, BESEEING, BESEES]\n",
  "BESEECH": "to implore, also BESEEKE [v BESEECHED or BESOUGHT, BESEECHING, BESEECHES]\n",
  "BESEECHED": "BESEECH, to implore, also BESEEKE [v]\n",
  "BESEECHER": "one who beseeches [n -S]\n",
  "BESEECHERS": "BESEECHER, one who beseeches [n]\n",
  "BESEECHES": "BESEECH, to implore, also BESEEKE [v]\n",
  "BESEECHING": "the act of imploring [n -S]\n",
  "BESEECHINGLY": "BESEECHING [adv]\n",
  "BESEECHINGNESS": "the state of being beseeching [n]\n",
  "BESEECHINGS": "BESEECHING, the act of imploring [n]\n",
  "BESEEING": "BESEE, (obsolete) to look to [v]\n",
  "BESEEKE": "(Spenser) to entreat, implore, also BESEECH [v BESOUGHT, BESEEKING, BESEEKES]\n",
  "BESEEKES": "BESEEKE, (Spenser) to entreat, implore, also BESEECH [v]\n",
  "BESEEKING": "BESEEKE, (Spenser) to entreat, implore, also BESEECH [v]\n",
  "BESEEM": "to be becoming [v -ED, -ING, -S]\n",
  "BESEEMED": "BESEEM, to be becoming [v]\n",
  "BESEEMING": "befitting [adj BESEEMINGLY] / the act of befitting [n -S]\n",
  "BESEEMINGLY": "BESEEMING [adv]\n",
  "BESEEMINGNESS": "the state of being beseeming [n -ES]\n",
  "BESEEMINGNESSES": "BESEEMINGNESS, the state of being beseeming [n]\n",
  "BESEEMINGS": "BESEEMING, the act of befitting [n]\n",
  "BESEEMLIER": "BESEEMLY, fit; suitable [adj]\n",
  "BESEEMLIEST": "BESEEMLY, fit; suitable [adj]\n",
  "BESEEMLY": "fit; suitable [adj BESEEMLIER, BESEEMLIEST]\n",
  "BESEEMS": "BESEEM, to be becoming [v]\n",
  "BESEEN": "BESEE, (obsolete) to look to [v]\n",
  "BESEES": "BESEE, (obsolete) to look to [v]\n",
  "BESES": "BES, (Hebrew) the second letter of the Hebrew alphabet, also BETH [n]\n",
  "BESET": "to assail [v BESET, BESETTING, BESETS]\n",
  "BESETMENT": "the act of besetting, or the state of being beset [n -S]\n",
  "BESETMENTS": "BESETMENT, the act of besetting, or the state of being beset [n]\n",
  "BESETS": "BESET, to assail [v]\n",
  "BESETTER": "one who, or that which, besets [n -S]\n",
  "BESETTERS": "BESETTER, one who, or that which, besets [n]\n",
  "BESETTING": "BESET, to assail [v]\n",
  "BESHADOW": "to cast a shadow on [v -ED, -ING, -S]\n",
  "BESHADOWED": "BESHADOW, to cast a shadow on [v]\n",
  "BESHADOWING": "BESHADOW, to cast a shadow on [v]\n",
  "BESHADOWS": "BESHADOW, to cast a shadow on [v]\n",
  "BESHAME": "(archaic) to put to shame [v BESHAMED, BESHAMING, BESHAMES]\n",
  "BESHAMED": "BESHAME, (archaic) to put to shame [v]\n",
  "BESHAMES": "BESHAME, (archaic) to put to shame [v]\n",
  "BESHAMING": "BESHAME, (archaic) to put to shame [v]\n",
  "BESHINE": "(archaic) to light up [v BESHONE, BESHINING, BESHINES]\n",
  "BESHINES": "BESHINE, (archaic) to light up [v]\n",
  "BESHINING": "BESHINE, (archaic) to light up [v]\n",
  "BESHIVER": "to break into small pieces [v -ED, -ING, -S]\n",
  "BESHIVERED": "BESHIVER, to break into small pieces [v]\n",
  "BESHIVERING": "BESHIVER, to break into small pieces [v]\n",
  "BESHIVERS": "BESHIVER, to break into small pieces [v]\n",
  "BESHONE": "BESHINE, (archaic) to light up [v]\n",
  "BESHOUT": "to shout at [v -ED, -ING, -S]\n",
  "BESHOUTED": "BESHOUT, to shout at [v]\n",
  "BESHOUTING": "BESHOUT, to shout at [v]\n",
  "BESHOUTS": "BESHOUT, to shout at [v]\n",
  "BESHREW": "(archaic) to wish evil on, to curse [v -ED, -ING, -S]\n",
  "BESHREWED": "BESHREW, (archaic) to wish evil on, to curse [v]\n",
  "BESHREWING": "BESHREW, (archaic) to wish evil on, to curse [v]\n",
  "BESHREWS": "BESHREW, (archaic) to wish evil on, to curse [v]\n",
  "BESHROUD": "to cover with, or as with, a shroud [v -ED, -ING, -S]\n",
  "BESHROUDED": "BESHROUD, to cover with, or as with, a shroud [v]\n",
  "BESHROUDING": "BESHROUD, to cover with, or as with, a shroud [v]\n",
  "BESHROUDS": "BESHROUD, to cover with, or as with, a shroud [v]\n",
  "BESIDE": "next to [prep]\n",
  "BESIDES": "in addition [adv]\n",
  "BESIEGE": "to attack and surround [v BESIEGED, BESIEGING, BESIEGES]\n",
  "BESIEGED": "BESIEGE, to attack and surround [v]\n",
  "BESIEGEMENT": "the state of being besieged [n -S]\n",
  "BESIEGEMENTS": "BESIEGEMENT, the state of being besieged [n]\n",
  "BESIEGER": "one who besieges, also SIEGER [n -S]\n",
  "BESIEGERS": "BESIEGER, one who besieges, also SIEGER [n]\n",
  "BESIEGES": "BESIEGE, to attack and surround [v]\n",
  "BESIEGING": "the act of surrounding [n -S]\n",
  "BESIEGINGLY": "BESIEGING [adv]\n",
  "BESIEGINGS": "BESIEGING, the act of surrounding [n]\n",
  "BESIGH": "(archaic) to sigh over [v -ED, -ING, -S]\n",
  "BESIGHED": "BESIGH, (archaic) to sigh over [v]\n",
  "BESIGHING": "BESIGH, (archaic) to sigh over [v]\n",
  "BESIGHS": "BESIGH, (archaic) to sigh over [v]\n",
  "BESING": "(archaic) to celebrate in song [v BESANG, BESUNG, BESINGING, BESINGS]\n",
  "BESINGING": "BESING, (archaic) to celebrate in song [v]\n",
  "BESINGS": "BESING, (archaic) to celebrate in song [v]\n",
  "BESIT": "(archaic) to suit, to become [v BESAT, BESITTING, BESITS]\n",
  "BESITS": "BESIT, (archaic) to suit, to become [v]\n",
  "BESITTING": "BESIT, (archaic) to suit, to become [v]\n",
  "BESLAVE": "to make a slave of [v BESLAVED, BESLAVING, BESLAVES]\n",
  "BESLAVED": "BESLAVE, to make a slave of [v]\n",
  "BESLAVER": "to slobber upon [v -ED, -ING, -S]\n",
  "BESLAVERED": "BESLAVER, to slobber upon [v]\n",
  "BESLAVERING": "BESLAVER, to slobber upon [v]\n",
  "BESLAVERS": "BESLAVER, to slobber upon [v]\n",
  "BESLAVES": "BESLAVE, to make a slave of [v]\n",
  "BESLAVING": "BESLAVE, to make a slave of [v]\n",
  "BESLIME": "to cover with slime [v BESLIMED, BESLIMING, BESLIMES]\n",
  "BESLIMED": "BESLIME, to cover with slime [v]\n",
  "BESLIMES": "BESLIME, to cover with slime [v]\n",
  "BESLIMING": "BESLIME, to cover with slime [v]\n",
  "BESLOBBER": "to slobber on; to smear with spittle running from the mouth, also BESLUBBER [v -ED, -ING, -S]\n",
  "BESLOBBERED": "BESLOBBER, to slobber on; to smear with spittle running from the mouth, also BESLUBBER [v]\n",
  "BESLOBBERING": "BESLOBBER, to slobber on; to smear with spittle running from the mouth, also BESLUBBER [v]\n",
  "BESLOBBERS": "BESLOBBER, to slobber on; to smear with spittle running from the mouth, also BESLUBBER [v]\n",
  "BESLUBBER": "to slobber on; to smear with spittle running from the mouth, also BESLOBBER [v -ED, -ING, -S]\n",
  "BESLUBBERED": "BESLUBBER, to slobber on; to smear with spittle running from the mouth, also BESLOBBER [v]\n",
  "BESLUBBERING": "BESLUBBER, to slobber on; to smear with spittle running from the mouth, also BESLOBBER [v]\n",
  "BESLUBBERS": "BESLUBBER, to slobber on; to smear with spittle running from the mouth, also BESLOBBER [v]\n",
  "BESMEAR": "to smear, bedaub [v -ED, -ING, -S]\n",
  "BESMEARED": "BESMEAR, to smear, bedaub [v]\n",
  "BESMEARER": "one who besmears [n -S]\n",
  "BESMEARERS": "BESMEARER, one who besmears [n]\n",
  "BESMEARING": "BESMEAR, to smear, bedaub [v]\n",
  "BESMEARS": "BESMEAR, to smear, bedaub [v]\n",
  "BESMILE": "to smile on [v BESMILED, BESMILING, BESMILES]\n",
  "BESMILED": "BESMILE, to smile on [v]\n",
  "BESMILES": "BESMILE, to smile on [v]\n",
  "BESMILING": "BESMILE, to smile on [v]\n",
  "BESMIRCH": "to soil, make dirty [v -ED, -ING, -ES]\n",
  "BESMIRCHED": "BESMIRCH, to soil, make dirty [v]\n",
  "BESMIRCHES": "BESMIRCH, to soil, make dirty [v]\n",
  "BESMIRCHING": "BESMIRCH, to soil, make dirty [v]\n",
  "BESMOKE": "to pollute with smoke [v BESMOKED, BESMOKING, BESMOKES]\n",
  "BESMOKED": "BESMOKE, to pollute with smoke [v]\n",
  "BESMOKES": "BESMOKE, to pollute with smoke [v]\n",
  "BESMOKING": "BESMOKE, to pollute with smoke [v]\n",
  "BESMOOTH": "to make smooth [v -ED, -ING, -S]\n",
  "BESMOOTHED": "BESMOOTH, to make smooth [v]\n",
  "BESMOOTHING": "BESMOOTH, to make smooth [v]\n",
  "BESMOOTHS": "BESMOOTH, to make smooth [v]\n",
  "BESMUDGE": "to cover with smudges [v BESMUDGED, BESMUDGING, BESMUDGES]\n",
  "BESMUDGED": "BESMUDGE, to cover with smudges [v]\n",
  "BESMUDGES": "BESMUDGE, to cover with smudges [v]\n",
  "BESMUDGING": "BESMUDGE, to cover with smudges [v]\n",
  "BESMUT": "to blacken with soot [v BESMUTTED, BESMUTTING, BESMUTS]\n",
  "BESMUTCH": "(archaic) to soil, besmirch [v -ED, -ING, -ES]\n",
  "BESMUTCHED": "BESMUTCH, (archaic) to soil, besmirch [v]\n",
  "BESMUTCHES": "BESMUTCH, (archaic) to soil, besmirch [v]\n",
  "BESMUTCHING": "BESMUTCH, (archaic) to soil, besmirch [v]\n",
  "BESMUTS": "BESMUT, to blacken with soot [v]\n",
  "BESMUTTED": "BESMUT, to blacken with soot [v]\n",
  "BESMUTTING": "BESMUT, to blacken with soot [v]\n",
  "BESNOW": "to cover with snow [v -ED, -ING, -S]\n",
  "BESNOWED": "BESNOW, to cover with snow [v]\n",
  "BESNOWING": "BESNOW, to cover with snow [v]\n",
  "BESNOWS": "BESNOW, to cover with snow [v]\n",
  "BESOGNIO": "(Italian) a beggar [n -S]\n",
  "BESOGNIOS": "BESOGNIO, (Italian) a beggar [n]\n",
  "BESOIN": "(French) need, want, desire [n -S]\n",
  "BESOINS": "BESOIN, (French) need, want, desire [n]\n",
  "BESOM": "a broom, esp. one made of twigs, also BISOM [n -S] / to sweep with a besom [v -ED, -ING, -S]\n",
  "BESOMED": "BESOM, to sweep with a besom [v]\n",
  "BESOMING": "BESOM, to sweep with a besom [v]\n",
  "BESOMS": "BESOM, to sweep with a besom [v]\n",
  "BESONIAN": "(Shakespeare) a beggar, also BEZONIAN [n -S]\n",
  "BESONIANS": "BESONIAN, (Shakespeare) a beggar, also BEZONIAN [n]\n",
  "BESOOTHE": "to soothe [v BESOOTHED, BESOOTHING, BESOOTHES]\n",
  "BESOOTHED": "BESOOTHE, to soothe [v]\n",
  "BESOOTHES": "BESOOTHE, to soothe [v]\n",
  "BESOOTHING": "BESOOTHE, to soothe [v]\n",
  "BESORT": "(Shakespeare) to match, befit [v -ED, -ING, -S]\n",
  "BESORTED": "BESORT, (Shakespeare) to match, befit [v]\n",
  "BESORTING": "BESORT, (Shakespeare) to match, befit [v]\n",
  "BESORTS": "BESORT, (Shakespeare) to match, befit [v]\n",
  "BESOT": "to infatuate [v BESOTTED, BESOTTING, BESOTS]\n",
  "BESOTS": "BESOT, to infatuate [v]\n",
  "BESOTTED": "BESOT, to infatuate [v]\n",
  "BESOTTEDLY": "BESOTTED, BESOT, to infatuate [adv]\n",
  "BESOTTEDNESS": "the state of being besotted [n -ES]\n",
  "BESOTTEDNESSES": "BESOTTEDNESS, the state of being besotted [n]\n",
  "BESOTTING": "BESOT, to infatuate [v]\n",
  "BESOUGHT": "BESEECH, to implore, also BESEEKE [v]\n",
  "BESOULED": "(archaic) having a soul [adj]\n",
  "BESPAKE": "BESPEAK, to request in advance [v]\n",
  "BESPANGLE": "to adorn with spangles [v BESPANGLED, BESPANGLING, BESPANGLES]\n",
  "BESPANGLED": "BESPANGLE, to adorn with spangles [v]\n",
  "BESPANGLES": "BESPANGLE, to adorn with spangles [v]\n",
  "BESPANGLING": "BESPANGLE, to adorn with spangles [v]\n",
  "BESPAT": "BESPIT, to spit upon [v]\n",
  "BESPATE": "BESPIT, to spit upon [v]\n",
  "BESPATTER": "to soil by spattering [v -ED, -ING, -S]\n",
  "BESPATTERED": "BESPATTER, to soil by spattering [v]\n",
  "BESPATTERING": "BESPATTER, to soil by spattering [v]\n",
  "BESPATTERS": "BESPATTER, to soil by spattering [v]\n",
  "BESPEAK": "to request in advance [v BESPAKE or BESPOKE, BESPOKEN, BESPEAKING, BESPEAKS]\n",
  "BESPEAKING": "BESPEAK, to request in advance [v]\n",
  "BESPEAKS": "BESPEAK, to request in advance [v]\n",
  "BESPECKLE": "to mark with speckles or spots [v BESPECKLED, BESPECKLING, BESPECKLES]\n",
  "BESPECKLED": "BESPECKLE, to mark with speckles or spots [v]\n",
  "BESPECKLES": "BESPECKLE, to mark with speckles or spots [v]\n",
  "BESPECKLING": "BESPECKLE, to mark with speckles or spots [v]\n",
  "BESPECTACLED": "wearing spectacles [adj]\n",
  "BESPED": "BESPEED, to help on [v]\n",
  "BESPEED": "to help on [v BESPED, BESPEEDING, BESPEEDS]\n",
  "BESPEEDING": "BESPEED, to help on [v]\n",
  "BESPEEDS": "BESPEED, to help on [v]\n",
  "BESPICE": "(Shakespeare) to season with spice [v BESPICED, BESPICING, BESPICES]\n",
  "BESPICED": "BESPICE, (Shakespeare) to season with spice [v]\n",
  "BESPICES": "BESPICE, (Shakespeare) to season with spice [v]\n",
  "BESPICING": "BESPICE, (Shakespeare) to season with spice [v]\n",
  "BESPIT": "to spit upon [v BESPAT or BESPATE, BESPITTING, BESPITS]\n",
  "BESPITS": "BESPIT, to spit upon [v]\n",
  "BESPITTING": "BESPIT, to spit upon [v]\n",
  "BESPOKE": "BESPEAK, to request in advance [v]\n",
  "BESPOKEN": "BESPEAK, to request in advance [v]\n",
  "BESPORT": "to sport, play [v -ED, -ING, -S]\n",
  "BESPORTED": "BESPORT, to sport, play [v]\n",
  "BESPORTING": "BESPORT, to sport, play [v]\n",
  "BESPORTS": "BESPORT, to sport, play [v]\n",
  "BESPOT": "to cover with spots [v BESPOTTED, BESPOTTING, BESPOTS]\n",
  "BESPOTS": "BESPOT, to cover with spots [v]\n",
  "BESPOTTED": "BESPOT, to cover with spots [v]\n",
  "BESPOTTEDNESS": "the state of being bespotted [n -ES]\n",
  "BESPOTTEDNESSES": "BESPOTTEDNESS, the state of being bespotted [n]\n",
  "BESPOTTING": "BESPOT, to cover with spots [v]\n",
  "BESPOUSE": "to marry [v BESPOUSED, BESPOUSING, BESPOUSES]\n",
  "BESPOUSED": "BESPOUSE, to marry [v]\n",
  "BESPOUSES": "BESPOUSE, to marry [v]\n",
  "BESPOUSING": "BESPOUSE, to marry [v]\n",
  "BESPOUT": "to spout over [v -ED, -ING, -S]\n",
  "BESPOUTED": "BESPOUT, to spout over [v]\n",
  "BESPOUTING": "BESPOUT, to spout over [v]\n",
  "BESPOUTS": "BESPOUT, to spout over [v]\n",
  "BESPREAD": "to spread over [v BESPREAD, BESPREADING, BESPREADS]\n",
  "BESPREADING": "BESPREAD, to spread over [v]\n",
  "BESPREADS": "BESPREAD, to spread over [v]\n",
  "BESPRENT": "(obsolete) sprinkled over [adj]\n",
  "BESPRINKLE": "to sprinkle over; to scatter over [v BESPRINKLED, BESPRINKLING, BESPRINKLES]\n",
  "BESPRINKLED": "BESPRINKLE, to sprinkle over; to scatter over [v]\n",
  "BESPRINKLES": "BESPRINKLE, to sprinkle over; to scatter over [v]\n",
  "BESPRINKLING": "BESPRINKLE, to sprinkle over; to scatter over [v]\n",
  "BEST": "to outdo [v -ED, -ING, -S]\n",
  "BESTAD": "(Spenser) beset by, also BESTADDE [adj]\n",
  "BESTADDE": "(Spenser) beset by, also BESTAD [adj]\n",
  "BESTAIN": "to stain all over [v -ED, -ING, -S]\n",
  "BESTAINED": "BESTAIN, to stain all over [v]\n",
  "BESTAINING": "BESTAIN, to stain all over [v]\n",
  "BESTAINS": "BESTAIN, to stain all over [v]\n",
  "BESTAR": "to cover with stars [v BESTARRED, BESTARRING, BESTARS]\n",
  "BESTARRED": "BESTAR, to cover with stars [v]\n",
  "BESTARRING": "BESTAR, to cover with stars [v]\n",
  "BESTARS": "BESTAR, to cover with stars [v]\n",
  "BESTEAD": "(archaic) to help, relieve [v -ED, -ING, -S]\n",
  "BESTEADED": "BESTEAD, (archaic) to help, relieve [v]\n",
  "BESTEADING": "BESTEAD, (archaic) to help, relieve [v]\n",
  "BESTEADS": "BESTEAD, (archaic) to help, relieve [v]\n",
  "BESTED": "BEST, to outdo [v]\n",
  "BESTEST": "indisputably best [adj]\n",
  "BESTI": "(Hinglish) in India, shame [n -S]\n",
  "BESTIAL": "animallike [adj BESTIALLY] / a collective name for cattle [n -S]\n",
  "BESTIALISE": "to make bestial, also BESTIALIZE [v BESTIALISED, BESTIALISING, BESTIALISES]\n",
  "BESTIALISED": "BESTIALISE, to make bestial, also BESTIALIZE [v]\n",
  "BESTIALISES": "BESTIALISE, to make bestial, also BESTIALIZE [v]\n",
  "BESTIALISING": "BESTIALISE, to make bestial, also BESTIALIZE [v]\n",
  "BESTIALISM": "having sexual intercourse with animals [n -S]\n",
  "BESTIALISMS": "BESTIALISM, having sexual intercourse with animals [n]\n",
  "BESTIALITIES": "BESTIALITY, the state of being bestial [n]\n",
  "BESTIALITY": "the state of being bestial [n BESTIALITIES]\n",
  "BESTIALIZE": "to make bestial, also BESTIALISE [v BESTIALIZED, BESTIALIZING, BESTIALIZES]\n",
  "BESTIALIZED": "BESTIALIZE, to make bestial, also BESTIALISE [v]\n",
  "BESTIALIZES": "BESTIALIZE, to make bestial, also BESTIALISE [v]\n",
  "BESTIALIZING": "BESTIALIZE, to make bestial, also BESTIALISE [v]\n",
  "BESTIALLY": "BESTIAL, animallike [adv]\n",
  "BESTIALS": "BESTIAL, a collective name for cattle [n]\n",
  "BESTIARIES": "BESTIARY, a book of animal fables [n]\n",
  "BESTIARY": "a book of animal fables [n BESTIARIES]\n",
  "BESTICK": "to stick over, as with sharp points pressed in [v BESTUCK, BESTICKING, BESTICKS]\n",
  "BESTICKING": "BESTICK, to stick over, as with sharp points pressed in [v]\n",
  "BESTICKS": "BESTICK, to stick over, as with sharp points pressed in [v]\n",
  "BESTIE": "(slang) one's best friend, also BEZZIE, BEZZY [n -S]\n",
  "BESTIES": "BESTIE, (slang) one's best friend, also BEZZIE, BEZZY [n]\n",
  "BESTILL": "(archaic) to make still [v -ED, -ING, -S]\n",
  "BESTILLED": "BESTILL, (archaic) to make still [v]\n",
  "BESTILLING": "BESTILL, (archaic) to make still [v]\n",
  "BESTILLS": "BESTILL, (archaic) to make still [v]\n",
  "BESTING": "BEST, to outdo [v]\n",
  "BESTIR": "to rouse to activity [v BESTIRRED, BESTIRRING, BESTIRS]\n",
  "BESTIRRED": "BESTIR, to rouse to activity [v]\n",
  "BESTIRRING": "BESTIR, to rouse to activity [v]\n",
  "BESTIRS": "BESTIR, to rouse to activity [v]\n",
  "BESTIS": "BESTI, (Hinglish) in India, shame [n]\n",
  "BESTORM": "to assail with storms [v -ED, -ING, -S]\n",
  "BESTORMED": "BESTORM, to assail with storms [v]\n",
  "BESTORMING": "BESTORM, to assail with storms [v]\n",
  "BESTORMS": "BESTORM, to assail with storms [v]\n",
  "BESTOW": "to present as a gift [v -ED, -ING, -S]\n",
  "BESTOWAL": "a gift [n -S]\n",
  "BESTOWALS": "BESTOWAL, a gift [n]\n",
  "BESTOWED": "BESTOW, to present as a gift [v]\n",
  "BESTOWER": "one who bestows [n -S]\n",
  "BESTOWERS": "BESTOWER, one who bestows [n]\n",
  "BESTOWING": "BESTOW, to present as a gift [v]\n",
  "BESTOWMENT": "the act of giving or bestowing [n -S]\n",
  "BESTOWMENTS": "BESTOWMENT, the act of giving or bestowing [n]\n",
  "BESTOWS": "BESTOW, to present as a gift [v]\n",
  "BESTRADDLE": "to bestride [v BESTRADDLED, BESTRADDLING, BESTRADDLES]\n",
  "BESTRADDLED": "BESTRADDLE, to bestride [v]\n",
  "BESTRADDLES": "BESTRADDLE, to bestride [v]\n",
  "BESTRADDLING": "BESTRADDLE, to bestride [v]\n",
  "BESTRAUGHT": "(obsolete) out of one's senses; distracted; mad [adj]\n",
  "BESTREAK": "to overspread with streaks [v -ED, -ING, -S]\n",
  "BESTREAKED": "BESTREAK, to overspread with streaks [v]\n",
  "BESTREAKING": "BESTREAK, to overspread with streaks [v]\n",
  "BESTREAKS": "BESTREAK, to overspread with streaks [v]\n",
  "BESTREW": "to strew, scatter [v BESTREWED, BESTREWN, BESTREWING, BESTREWS]\n",
  "BESTREWED": "BESTREW, to strew, scatter [v]\n",
  "BESTREWING": "BESTREW, to strew, scatter [v]\n",
  "BESTREWN": "BESTREW, to strew, scatter [v]\n",
  "BESTREWS": "BESTREW, to strew, scatter [v]\n",
  "BESTRID": "BESTRIDE, to stride across, straddle [v]\n",
  "BESTRIDABLE": "that can be bestridden [adj]\n",
  "BESTRIDDEN": "BESTRIDE, to stride across, straddle [v]\n",
  "BESTRIDE": "to stride across, straddle [v BESTRODE, BESTRID, BESTRIDDEN, BESTRIDING, BESTRIDES]\n",
  "BESTRIDES": "BESTRIDE, to stride across, straddle [v]\n",
  "BESTRIDING": "BESTRIDE, to stride across, straddle [v]\n",
  "BESTRODE": "BESTRIDE, to stride across, straddle [v]\n",
  "BESTROW": "to strew, scatter, also BESTREW [v BESTROWED, BESTROWN, BESTROWING, BESTROWS]\n",
  "BESTROWED": "BESTROW, to strew, scatter, also BESTREW [v]\n",
  "BESTROWING": "BESTROW, to strew, scatter, also BESTREW [v]\n",
  "BESTROWN": "BESTROW, to strew, scatter, also BESTREW [v]\n",
  "BESTROWS": "BESTROW, to strew, scatter, also BESTREW [v]\n",
  "BESTS": "BEST, to outdo [v]\n",
  "BESTSELLER": "a book, etc. that has sold many copies [n -S]\n",
  "BESTSELLERDOM": "the world of bestsellers [n -S]\n",
  "BESTSELLERDOMS": "BESTSELLERDOM, the world of bestsellers [n]\n",
  "BESTSELLERS": "BESTSELLER, a book, etc. that has sold many copies [n]\n",
  "BESTSELLING": "selling in large numbers [adj]\n",
  "BESTUCK": "BESTICK, to stick over, as with sharp points pressed in [v]\n",
  "BESTUD": "to adorn with dots [v BESTUDDED, BESTUDDING, BESTUDS]\n",
  "BESTUDDED": "BESTUD, to adorn with dots [v]\n",
  "BESTUDDING": "BESTUD, to adorn with dots [v]\n",
  "BESTUDS": "BESTUD, to adorn with dots [v]\n",
  "BESUITED": "wearing a suit [adj]\n",
  "BESUNG": "BESING, (archaic) to celebrate in song [v]\n",
  "BESWARM": "to swarm all over [v -ED, -ING, -S]\n",
  "BESWARMED": "BESWARM, to swarm all over [v]\n",
  "BESWARMING": "BESWARM, to swarm all over [v]\n",
  "BESWARMS": "BESWARM, to swarm all over [v]\n",
  "BET": "to wager [v BETTED, BETTING, BETS]\n",
  "BETA": "(Greek) a Greek letter [n -S]\n",
  "BETACAROTENE": "a nutrient found in yellow and orange fruits and vegetables [n -S]\n",
  "BETACAROTENES": "BETACAROTENE, a nutrient found in yellow and orange fruits and vegetables [n]\n",
  "BETACISM": "the pronunciation of the sound B as V [n -S]\n",
  "BETACISMS": "BETACISM, the pronunciation of the sound B as V [n]\n",
  "BETACYANIN": "any one of a group of red nitrogenous pigments found in certain plants, such as beetroot [n -S]\n",
  "BETACYANINS": "BETACYANIN, any one of a group of red nitrogenous pigments found in certain plants, such as beetroot [n]\n",
  "BETAINE": "a crystalline, sweet-tasting alkaloid occurring in sugar beet and other plants [n -S]\n",
  "BETAINES": "BETAINE, a crystalline, sweet-tasting alkaloid occurring in sugar beet and other plants [n]\n",
  "BETAKE": "to take oneself to [v BETOOK, BETAKEN, BETAKING, BETAKES]\n",
  "BETAKEN": "BETAKE, to take oneself to [v]\n",
  "BETAKES": "BETAKE, to take oneself to [v]\n",
  "BETAKING": "BETAKE, to take oneself to [v]\n",
  "BETAS": "BETA, (Greek) a Greek letter [n]\n",
  "BETATOPIC": "of atoms, differing in proton number by one [adj]\n",
  "BETATRON": "an electron accelerator [n -S]\n",
  "BETATRONS": "BETATRON, an electron accelerator [n]\n",
  "BETATTER": "to tatter [v -ED, -ING, -S]\n",
  "BETATTERED": "BETATTER, to tatter [v]\n",
  "BETATTERING": "BETATTER, to tatter [v]\n",
  "BETATTERS": "BETATTER, to tatter [v]\n",
  "BETAXED": "burdened with taxes [adj]\n",
  "BETCHA": "a spelling of 'bet you' representing colloquial pronunciation [v]\n",
  "BETE": "to mend, improve [v BETED, BETING, BETES]\n",
  "BETED": "BETE, to mend, improve [v]\n",
  "BETEEM": "(Spenser) to grant, vouchsafe, also BETEEME [v -ED, -ING, -S]\n",
  "BETEEME": "(Spenser) to grant, vouchsafe, also BETEEM [v BETEEMED, BETEEMING, BETEEMES]\n",
  "BETEEMED": "BETEEME, (Spenser) to grant, vouchsafe, also BETEEM [v]\n",
  "BETEEMES": "BETEEME, (Spenser) to grant, vouchsafe, also BETEEM [v]\n",
  "BETEEMING": "BETEEME, (Spenser) to grant, vouchsafe, also BETEEM [v]\n",
  "BETEEMS": "BETEEM, (Spenser) to grant, vouchsafe, also BETEEME [v]\n",
  "BETEL": "(Malay) the leaf of the betel-pepper which is chewed in the East along with the areca-nut and lime [n -S]\n",
  "BETELNUT": "the areca nut [n -S]\n",
  "BETELNUTS": "BETELNUT, the areca nut [n]\n",
  "BETELS": "BETEL, (Malay) the leaf of the betel-pepper which is chewed in the East along with the areca-nut and lime [n]\n",
  "BETES": "BETE, to mend, improve [v]\n",
  "BETH": "(Hebrew) the second letter of the Hebrew alphabet [n -S]\n",
  "BETHANK": "to ply with thanks [v -ED, -ING, -S]\n",
  "BETHANKED": "BETHANK, to ply with thanks [v]\n",
  "BETHANKING": "BETHANK, to ply with thanks [v]\n",
  "BETHANKIT": "(Scots) a grace, elliptical for God be thanked [n -S]\n",
  "BETHANKITS": "BETHANKIT, (Scots) a grace, elliptical for God be thanked [n]\n",
  "BETHANKS": "BETHANK, to ply with thanks [v]\n",
  "BETHEL": "(Hebrew) a place of worship for seamen; a nonconformist chapel [n -S]\n",
  "BETHELS": "BETHEL, (Hebrew) a place of worship for seamen; a nonconformist chapel [n]\n",
  "BETHESDA": "a Nonconformist church building [n -S]\n",
  "BETHESDAS": "BETHESDA, a Nonconformist church building [n]\n",
  "BETHINK": "to call to mind [v BETHOUGHT, BETHINKING, BETHINKS]\n",
  "BETHINKING": "BETHINK, to call to mind [v]\n",
  "BETHINKS": "BETHINK, to call to mind [v]\n",
  "BETHORN": "to fill with thorns [v -ED, -ING, -S]\n",
  "BETHORNED": "BETHORN, to fill with thorns [v]\n",
  "BETHORNING": "BETHORN, to fill with thorns [v]\n",
  "BETHORNS": "BETHORN, to fill with thorns [v]\n",
  "BETHOUGHT": "BETHINK, to call to mind [v]\n",
  "BETHRALL": "(Spenser) to enslave [v -ED, -ING, -S]\n",
  "BETHRALLED": "BETHRALL, (Spenser) to enslave [v]\n",
  "BETHRALLING": "BETHRALL, (Spenser) to enslave [v]\n",
  "BETHRALLS": "BETHRALL, (Spenser) to enslave [v]\n",
  "BETHS": "BETH, (Hebrew) the second letter of the Hebrew alphabet [n]\n",
  "BETHUMB": "to wear or soil with one's thumb [v -ED, -ING, -S]\n",
  "BETHUMBED": "BETHUMB, to wear or soil with one's thumb [v]\n",
  "BETHUMBING": "BETHUMB, to wear or soil with one's thumb [v]\n",
  "BETHUMBS": "BETHUMB, to wear or soil with one's thumb [v]\n",
  "BETHUMP": "to thump soundly [v -ED, -ING, -S]\n",
  "BETHUMPED": "BETHUMP, to thump soundly [v]\n",
  "BETHUMPING": "BETHUMP, to thump soundly [v]\n",
  "BETHUMPS": "BETHUMP, to thump soundly [v]\n",
  "BETHWACK": "to thrash soundly [v -ED, -ING, -S]\n",
  "BETHWACKED": "BETHWACK, to thrash soundly [v]\n",
  "BETHWACKING": "BETHWACK, to thrash soundly [v]\n",
  "BETHWACKS": "BETHWACK, to thrash soundly [v]\n",
  "BETID": "BETIDE, to befall, happen to [v]\n",
  "BETIDE": "to befall, happen to [v BETID or BETIGHT or BETIDED, BETIDING, BETIDES]\n",
  "BETIDED": "BETIDE, to befall, happen to [v]\n",
  "BETIDES": "BETIDE, to befall, happen to [v]\n",
  "BETIDING": "BETIDE, to befall, happen to [v]\n",
  "BETIGHT": "BETIDE, to befall, happen to [v]\n",
  "BETIME": "(Shakespeare) to betide [v BETIMED, BETIMING, BETIMES]\n",
  "BETIMED": "BETIME, (Shakespeare) to betide [v]\n",
  "BETIMES": "BETIME, (Shakespeare) to betide [v]\n",
  "BETIMING": "BETIME, (Shakespeare) to betide [v]\n",
  "BETING": "BETE, to mend, improve [v]\n",
  "BETISE": "(French) stupidity, a stupid act [n -S]\n",
  "BETISES": "BETISE, (French) stupidity, a stupid act [n]\n",
  "BETITLE": "to furnish with a title or titles [v BETITLED, BETITLING, BETITLES]\n",
  "BETITLED": "BETITLE, to furnish with a title or titles [v]\n",
  "BETITLES": "BETITLE, to furnish with a title or titles [v]\n",
  "BETITLING": "BETITLE, to furnish with a title or titles [v]\n",
  "BETOIL": "to weary with toil [v -ED, -ING, -S]\n",
  "BETOILED": "BETOIL, to weary with toil [v]\n",
  "BETOILING": "BETOIL, to weary with toil [v]\n",
  "BETOILS": "BETOIL, to weary with toil [v]\n",
  "BETOKEN": "to signify [v -ED, -ING, -S]\n",
  "BETOKENED": "BETOKEN, to signify [v]\n",
  "BETOKENING": "BETOKEN, to signify [v]\n",
  "BETOKENS": "BETOKEN, to signify [v]\n",
  "BETON": "(French) lime concrete [n -S]\n",
  "BETONIES": "BETONY, a labiate plant of woodland [n]\n",
  "BETONS": "BETON, (French) lime concrete [n]\n",
  "BETONY": "a labiate plant of woodland [n BETONIES]\n",
  "BETOOK": "BETAKE, to take oneself to [v]\n",
  "BETOSS": "(Shakespeare) to agitate [v -ED, -ING, -ES]\n",
  "BETOSSED": "BETOSS, (Shakespeare) to agitate [v]\n",
  "BETOSSES": "BETOSS, (Shakespeare) to agitate [v]\n",
  "BETOSSING": "BETOSS, (Shakespeare) to agitate [v]\n",
  "BETRAY": "to disclose in breach of trust [v -ED, -ING, -S]\n",
  "BETRAYAL": "the act of betraying [n -S]\n",
  "BETRAYALS": "BETRAYAL, the act of betraying [n]\n",
  "BETRAYED": "BETRAY, to disclose in breach of trust [v]\n",
  "BETRAYER": "one who betrays [n -S]\n",
  "BETRAYERS": "BETRAYER, one who betrays [n]\n",
  "BETRAYING": "BETRAY, to disclose in breach of trust [v]\n",
  "BETRAYS": "BETRAY, to disclose in breach of trust [v]\n",
  "BETREAD": "to walk upon [v BETROD, BETRODDEN, BETREADING, BETREADS]\n",
  "BETREADING": "BETREAD, to walk upon [v]\n",
  "BETREADS": "BETREAD, to walk upon [v]\n",
  "BETRIM": "to deck with trimmings [v BETRIMMED, BETRIMMING, BETRIMS]\n",
  "BETRIMMED": "BETRIM, to deck with trimmings [v]\n",
  "BETRIMMING": "BETRIM, to deck with trimmings [v]\n",
  "BETRIMS": "BETRIM, to deck with trimmings [v]\n",
  "BETROD": "BETREAD, to walk upon [v]\n",
  "BETRODDEN": "BETREAD, to walk upon [v]\n",
  "BETROTH": "to engage to marry [v -ED, -ING, -S]\n",
  "BETROTHAL": "an engagement to marry [n -S]\n",
  "BETROTHALS": "BETROTHAL, an engagement to marry [n]\n",
  "BETROTHED": "one who is engaged to be married [n -S]\n",
  "BETROTHEDS": "BETROTHED, one who is engaged to be married [n]\n",
  "BETROTHING": "BETROTH, to engage to marry [v]\n",
  "BETROTHMENT": "the state of being betrothed [n -S]\n",
  "BETROTHMENTS": "BETROTHMENT, the state of being betrothed [n]\n",
  "BETROTHS": "BETROTH, to engage to marry [v]\n",
  "BETS": "BET, to wager [v]\n",
  "BETTA": "a strikingly-colored Asiatic fish [n -S]\n",
  "BETTAS": "BETTA, a strikingly-colored Asiatic fish [n]\n",
  "BETTED": "BET, to wager [v]\n",
  "BETTER": "to improve [v -ED, -ING, -S]\n",
  "BETTERED": "BETTER, to improve [v]\n",
  "BETTERING": "improvement [n -S]\n",
  "BETTERINGS": "BETTERING, improvement [n]\n",
  "BETTERMENT": "a making or becoming better [n -S]\n",
  "BETTERMENTS": "BETTERMENT, a making or becoming better [n]\n",
  "BETTERMOST": "best [adj]\n",
  "BETTERNESS": "the quality of being better [n -ES]\n",
  "BETTERNESSES": "BETTERNESS, the quality of being better [n]\n",
  "BETTERS": "BETTER, to improve [v]\n",
  "BETTIES": "BETTY, a burglar's tool, a type of short crowbar [n]\n",
  "BETTING": "the act of placing a bet [n -S]\n",
  "BETTINGS": "BETTING, the act of placing a bet [n]\n",
  "BETTONG": "(Native Australian) an Australian rat kangaroo [n -S]\n",
  "BETTONGS": "BETTONG, (Native Australian) an Australian rat kangaroo [n]\n",
  "BETTOR": "one who bets [n -S]\n",
  "BETTORS": "BETTOR, one who bets [n]\n",
  "BETTY": "a burglar's tool, a type of short crowbar [n BETTIES]\n",
  "BETULACEOUS": "belonging to the birch family [adj]\n",
  "BETUMBLED": "(Shakespeare) in a tumbled state, e.g. of hair [adj]\n",
  "BETWEEN": "a needle of middling size [n -S]\n",
  "BETWEENBRAIN": "the diencephalon [n -S]\n",
  "BETWEENBRAINS": "BETWEENBRAIN, the diencephalon [n]\n",
  "BETWEENITIES": "BETWEENITY, a jocular word for the state of being between [n]\n",
  "BETWEENITY": "a jocular word for the state of being between [n BETWEENITIES]\n",
  "BETWEENNESS": "the state of being between [n -ES]\n",
  "BETWEENNESSES": "BETWEENNESS, the state of being between [n]\n",
  "BETWEENS": "BETWEEN, a needle of middling size [n]\n",
  "BETWEENTIME": "at intervals, also BETWEENTIMES, BETWEENWHILES [adv]\n",
  "BETWEENTIMES": "at intervals, also BETWEENTIME, BETWEENWHILES [adv]\n",
  "BETWEENWHILES": "at intervals, also BETWEENTIME, BETWEENTIMES [adv]\n",
  "BETWIXT": "between [prep]\n",
  "BEUNCLED": "having too many uncles [adj]\n",
  "BEURRE": "(French) a pear with the meat soft and melting [n -S]\n",
  "BEURRES": "BEURRE, (French) a pear with the meat soft and melting [n]\n",
  "BEVATRON": "a proton accelerator [n -S]\n",
  "BEVATRONS": "BEVATRON, a proton accelerator [n]\n",
  "BEVEL": "to cut at an angle [v BEVELED or BEVELLED, BEVELING or BEVELLING, BEVELS]\n",
  "BEVELED": "BEVEL, to cut at an angle [v]\n",
  "BEVELER": "one who bevels, also BEVELLER [n -S]\n",
  "BEVELERS": "BEVELER, one who bevels, also BEVELLER [n]\n",
  "BEVELING": "BEVEL, to cut at an angle [v]\n",
  "BEVELLED": "BEVEL, to cut at an angle [v]\n",
  "BEVELLER": "one who bevels, also BEVELER [n -S]\n",
  "BEVELLERS": "BEVELLER, one who bevels, also BEVELER [n]\n",
  "BEVELLING": "a bevel or slant [n -S]\n",
  "BEVELLINGS": "BEVELLING, a bevel or slant [n]\n",
  "BEVELMENT": "the process of bevelling [n -S]\n",
  "BEVELMENTS": "BEVELMENT, the process of bevelling [n]\n",
  "BEVELS": "BEVEL, to cut at an angle [v]\n",
  "BEVER": "to snack [v -ED, -ING, -S]\n",
  "BEVERAGE": "any liquid for drinking [n -S]\n",
  "BEVERAGES": "BEVERAGE, any liquid for drinking [n]\n",
  "BEVERED": "BEVER, to snack [v]\n",
  "BEVERING": "BEVER, to snack [v]\n",
  "BEVERS": "BEVER, to snack [v]\n",
  "BEVIES": "BEVY, a group, esp. of girls [n]\n",
  "BEVOMIT": "to vomit all over [v -ED, -ING, -S]\n",
  "BEVOMITED": "BEVOMIT, to vomit all over [v]\n",
  "BEVOMITING": "BEVOMIT, to vomit all over [v]\n",
  "BEVOMITS": "BEVOMIT, to vomit all over [v]\n",
  "BEVOR": "armour for the face [n -S]\n",
  "BEVORS": "BEVOR, armour for the face [n]\n",
  "BEVUE": "(French) a blunder, an inadvertent error [n -S]\n",
  "BEVUES": "BEVUE, (French) a blunder, an inadvertent error [n]\n",
  "BEVVIED": "BEVVY, to engage in a drinking session [v]\n",
  "BEVVIES": "BEVVY, to engage in a drinking session [v]\n",
  "BEVVY": "an alcoholic drink [n BEVVIES] / to engage in a drinking session [v BEVVIED, BEVVYING, BEVVIES]\n",
  "BEVVYING": "BEVVY, to engage in a drinking session [v]\n",
  "BEVY": "a group, esp. of girls [n BEVIES]\n",
  "BEWAIL": "to lament [v -ED, -ING, -S]\n",
  "BEWAILED": "BEWAIL, to lament [v]\n",
  "BEWAILER": "one who bewails or laments [n -S]\n",
  "BEWAILERS": "BEWAILER, one who bewails or laments [n]\n",
  "BEWAILING": "the act of bewailing [n -S]\n",
  "BEWAILINGLY": "BEWAILING [adv]\n",
  "BEWAILINGS": "BEWAILING, the act of bewailing [n]\n",
  "BEWAILS": "BEWAIL, to lament [v]\n",
  "BEWARE": "to be on one's guard [v BEWARED, BEWARING, BEWARES]\n",
  "BEWARED": "BEWARE, to be on one's guard [v]\n",
  "BEWARES": "BEWARE, to be on one's guard [v]\n",
  "BEWARING": "BEWARE, to be on one's guard [v]\n",
  "BEWEARIED": "BEWEARY, to make weary [v]\n",
  "BEWEARIES": "BEWEARY, to make weary [v]\n",
  "BEWEARY": "to make weary [v BEWEARIED, BEWEARYING, BEWEARIES]\n",
  "BEWEARYING": "BEWEARY, to make weary [v]\n",
  "BEWEEP": "to weep over, lament [v BEWEPT, BEWEEPING, BEWEEPS]\n",
  "BEWEEPING": "BEWEEP, to weep over, lament [v]\n",
  "BEWEEPS": "BEWEEP, to weep over, lament [v]\n",
  "BEWELTERED": "(archaic) in a welter e.g. of blood [adj]\n",
  "BEWENT": "BEGO, to beset [v]\n",
  "BEWEPT": "BEWEEP, to weep over, lament [v]\n",
  "BEWET": "(Shakespeare) to make wet [v BEWETTED, BEWETTING, BEWETS]\n",
  "BEWETS": "BEWET, (Shakespeare) to make wet [v]\n",
  "BEWETTED": "BEWET, (Shakespeare) to make wet [v]\n",
  "BEWETTING": "BEWET, (Shakespeare) to make wet [v]\n",
  "BEWHISKERED": "having whiskers [adj]\n",
  "BEWHORE": "(Shakespeare) to call someone a whore [v BEWHORED, BEWHORING, BEWHORES]\n",
  "BEWHORED": "BEWHORE, (Shakespeare) to call someone a whore [v]\n",
  "BEWHORES": "BEWHORE, (Shakespeare) to call someone a whore [v]\n",
  "BEWHORING": "BEWHORE, (Shakespeare) to call someone a whore [v]\n",
  "BEWIG": "to dress in a wig [v BEWIGGED, BEWIGGING, BEWIGS]\n",
  "BEWIGGED": "BEWIG, to dress in a wig [v]\n",
  "BEWIGGING": "BEWIG, to dress in a wig [v]\n",
  "BEWIGS": "BEWIG, to dress in a wig [v]\n",
  "BEWILDER": "to confuse [v -ED, -ING, -S]\n",
  "BEWILDERED": "BEWILDER, to confuse [v]\n",
  "BEWILDEREDLY": "BEWILDERED, BEWILDER, to confuse [adv]\n",
  "BEWILDEREDNESS": "the state of being bewildered [n]\n",
  "BEWILDERING": "BEWILDER, to confuse [v]\n",
  "BEWILDERINGLY": "BEWILDERING, BEWILDER, to confuse [adv]\n",
  "BEWILDERMENT": "the state of being bewildered [n -S]\n",
  "BEWILDERMENTS": "BEWILDERMENT, the state of being bewildered [n]\n",
  "BEWILDERS": "BEWILDER, to confuse [v]\n",
  "BEWINGED": "having wings [adj]\n",
  "BEWITCH": "to affect by witchcraft [v -ED, -ING, -ES]\n",
  "BEWITCHED": "BEWITCH, to affect by witchcraft [v]\n",
  "BEWITCHER": "one who bewitches [n -S]\n",
  "BEWITCHERIES": "BEWITCHERY, the power of bewitching or fascinating [n]\n",
  "BEWITCHERS": "BEWITCHER, one who bewitches [n]\n",
  "BEWITCHERY": "the power of bewitching or fascinating [n BEWITCHERIES]\n",
  "BEWITCHES": "BEWITCH, to affect by witchcraft [v]\n",
  "BEWITCHING": "BEWITCH, to affect by witchcraft [v]\n",
  "BEWITCHINGLY": "BEWITCHING, BEWITCH, to affect by witchcraft [adv]\n",
  "BEWITCHMENT": "the state of being bewitched [n -S]\n",
  "BEWITCHMENTS": "BEWITCHMENT, the state of being bewitched [n]\n",
  "BEWORM": "to cover with worms [v -ED, -ING, -S]\n",
  "BEWORMED": "BEWORM, to cover with worms [v]\n",
  "BEWORMING": "BEWORM, to cover with worms [v]\n",
  "BEWORMS": "BEWORM, to cover with worms [v]\n",
  "BEWORRIED": "BEWORRY, to worry [v]\n",
  "BEWORRIES": "BEWORRY, to worry [v]\n",
  "BEWORRY": "to worry [v BEWORRIED, BEWORRYING, BEWORRIES]\n",
  "BEWORRYING": "BEWORRY, to worry [v]\n",
  "BEWRAP": "to wrap completely [v BEWRAPPED, BEWRAPT, BEWRAPPING, BEWRAPS]\n",
  "BEWRAPPED": "BEWRAP, to wrap completely [v]\n",
  "BEWRAPPING": "BEWRAP, to wrap completely [v]\n",
  "BEWRAPS": "BEWRAP, to wrap completely [v]\n",
  "BEWRAPT": "BEWRAP, to wrap completely [v]\n",
  "BEWRAY": "(archaic) to reveal unintentionally, esp. the existence, presence, or true character of (a person or thing) [v -ED, -ING, -S]\n",
  "BEWRAYED": "BEWRAY, (archaic) to reveal unintentionally, esp. the existence, presence, or true character of (a person or thing) [v]\n",
  "BEWRAYER": "one who, or that which, bewrays [n -S]\n",
  "BEWRAYERS": "BEWRAYER, one who, or that which, bewrays [n]\n",
  "BEWRAYING": "BEWRAY, (archaic) to reveal unintentionally, esp. the existence, presence, or true character of (a person or thing) [v]\n",
  "BEWRAYS": "BEWRAY, (archaic) to reveal unintentionally, esp. the existence, presence, or true character of (a person or thing) [v]\n",
  "BEY": "a Turkish governor [n -S]\n",
  "BEYLIC": "(Turkish) the domain of a bey, also BEYLIK [n -S]\n",
  "BEYLICS": "BEYLIC, (Turkish) the domain of a bey, also BEYLIK [n]\n",
  "BEYLIK": "(Turkish) the domain of a bey, also BEYLIC [n -S]\n",
  "BEYLIKS": "BEYLIK, (Turkish) the domain of a bey, also BEYLIC [n]\n",
  "BEYOND": "the unknown, the hereafter [n -S]\n",
  "BEYONDS": "BEYOND, the unknown, the hereafter [n]\n",
  "BEYS": "BEY, a Turkish governor [n]\n",
  "BEZ": "the second tine of a deer's horn [n -ES]\n",
  "BEZANT": "a gold coin first struck at Byzantium or Constantinople; in heraldry, a charge like this, a gold roundel, also BEZZANT, BYZANT [n -S]\n",
  "BEZANTS": "BEZANT, a gold coin first struck at Byzantium or Constantinople; in heraldry, a charge like this, a gold roundel, also BEZZANT, BYZANT [n]\n",
  "BEZAZZ": "panache, flamboyance, also BIZAZZ, PAZZAZZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "BEZAZZES": "BEZAZZ, panache, flamboyance, also BIZAZZ, PAZZAZZ, PIZZAZZ, PZAZZ [n]\n",
  "BEZEL": "the oblique side or face of a cut gem, also BEZIL [n -S]\n",
  "BEZELLESS": "without a bezel [adj]\n",
  "BEZELS": "BEZEL, the oblique side or face of a cut gem, also BEZIL [n]\n",
  "BEZES": "BEZ, the second tine of a deer's horn [n]\n",
  "BEZIL": "the oblique side or face of a cut gem, also BEZEL [n -S]\n",
  "BEZILS": "BEZIL, the oblique side or face of a cut gem, also BEZEL [n]\n",
  "BEZIQUE": "(French) a card game played with two decks of cards [n -S]\n",
  "BEZIQUES": "BEZIQUE, (French) a card game played with two decks of cards [n]\n",
  "BEZOAR": "(Persian) a concretion found in the stomach or intestines of certain animals (chiefly ruminants), formerly believed to be antidotal [n -S]\n",
  "BEZOARDIC": "pertaining to, or compounded with, bezoar [adj]\n",
  "BEZOARS": "BEZOAR, (Persian) a concretion found in the stomach or intestines of certain animals (chiefly ruminants), formerly believed to be antidotal [n]\n",
  "BEZONIAN": "(Shakespeare) a beggar, also BESONIAN [n -S]\n",
  "BEZONIANS": "BEZONIAN, (Shakespeare) a beggar, also BESONIAN [n]\n",
  "BEZZANT": "a gold coin first struck at Byzantium or Constantinople; in heraldry, a charge like this, a gold roundel, also BEZANT, BYZANT [n -S]\n",
  "BEZZANTS": "BEZZANT, a gold coin first struck at Byzantium or Constantinople; in heraldry, a charge like this, a gold roundel, also BEZANT, BYZANT [n]\n",
  "BEZZAZZ": "flamboyance, also BAZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "BEZZAZZES": "BEZZAZZ, flamboyance, also BAZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n]\n",
  "BEZZIE": "a person's best friend, also BESTIE, BEZZY [n -S]\n",
  "BEZZIES": "BEZZIE, a person's best friend, also BESTIE, BEZZY [n]\n",
  "BEZZLE": "to drink hard [v BEZZLED, BEZZLING, BEZZLES]\n",
  "BEZZLED": "BEZZLE, to drink hard [v]\n",
  "BEZZLES": "BEZZLE, to drink hard [v]\n",
  "BEZZLING": "BEZZLE, to drink hard [v]\n",
  "BEZZY": "(slang) one's best friend, also BESTIE, BEZZIE [n BEZZIES]\n",
  "BHAGEE": "(Hindi) in Indian cookery, an appetizer, also BHAJEE, BHAJI [n -S]\n",
  "BHAGEES": "BHAGEE, (Hindi) in Indian cookery, an appetizer, also BHAJEE, BHAJI [n]\n",
  "BHAI": "(Hindi) brother; a form of address for a man [n -S]\n",
  "BHAIS": "BHAI, (Hindi) brother; a form of address for a man [n]\n",
  "BHAJAN": "a Hindu religious song [n -S]\n",
  "BHAJANS": "BHAJAN, a Hindu religious song [n]\n",
  "BHAJEE": "(Hindi) in Indian cookery, an appetizer, also BHAJI, BHAGEE [n -S]\n",
  "BHAJEES": "BHAJEE, (Hindi) in Indian cookery, an appetizer, also BHAJI, BHAGEE [n]\n",
  "BHAJI": "(Hindi) in Indian cookery, an appetizer consisting of vegetables cooked in batter, also BHAGEE, BHAJEE [n BHAJIA or BHAJIS]\n",
  "BHAJIA": "BHAJI, (Hindi) in Indian cookery, an appetizer consisting of vegetables cooked in batter, also BHAGEE, BHAJEE [n]\n",
  "BHAJIS": "BHAJI, (Hindi) in Indian cookery, an appetizer consisting of vegetables cooked in batter, also BHAGEE, BHAJEE [n]\n",
  "BHAKTA": "(Sanskrit) devotion to a god, as a path to salvation, also BHAKTI [n -S]\n",
  "BHAKTAS": "BHAKTA, (Sanskrit) devotion to a god, as a path to salvation, also BHAKTI [n]\n",
  "BHAKTI": "(Sanskrit) devotion to a god, as a path to salvation, also BHAKTA [n -S]\n",
  "BHAKTIS": "BHAKTI, (Sanskrit) devotion to a god, as a path to salvation, also BHAKTA [n]\n",
  "BHANG": "(Hindi) cannabis, Indian hemp, used as a weak narcotic, also BENJ [n -S]\n",
  "BHANGRA": "(Punjabi) a combination of traditional Punjabi and Western pop music [n -S]\n",
  "BHANGRAS": "BHANGRA, (Punjabi) a combination of traditional Punjabi and Western pop music [n]\n",
  "BHANGS": "BHANG, (Hindi) cannabis, Indian hemp, used as a weak narcotic, also BENJ [n]\n",
  "BHARAL": "(Hindi) a blue Himalayan sheep, also BURRELL, BURRHEL [n -S]\n",
  "BHARALS": "BHARAL, (Hindi) a blue Himalayan sheep, also BURRELL, BURRHEL [n]\n",
  "BHAT": "a dancer in a Thai troupe [n -S]\n",
  "BHATS": "BHAT, a dancer in a Thai troupe [n]\n",
  "BHAVAN": "(Hindi) a large house, also BHAWAN [n -S]\n",
  "BHAVANS": "BHAVAN, (Hindi) a large house, also BHAWAN [n]\n",
  "BHAWAN": "(Hindi) a large house, also BHAVAN [n -S]\n",
  "BHAWANS": "BHAWAN, (Hindi) a large house, also BHAVAN [n]\n",
  "BHEESTIE": "(Urdu) an Indian water carrier, also BHEESTY, BHISHTI, BHISTEE, BHISTI, BHISTIE [n -S]\n",
  "BHEESTIES": "BHEESTY, (Urdu) an Indian water carrier, also BHEESTIE, BHISHTI, BHISTEE, BHISTI, BHISTIE [n]\n",
  "BHEESTY": "(Urdu) an Indian water carrier, also BHEESTIE, BHISHTI, BHISTEE, BHISTI, BHISTIE [n BHEESTIES]\n",
  "BHEL": "(Hindi) a thorny Indian tree, also BAEL [n -S]\n",
  "BHELPURI": "an Indian dish of puffed rice with onions [n -S]\n",
  "BHELPURIS": "BHELPURI, an Indian dish of puffed rice with onions [n]\n",
  "BHELS": "BHEL, (Hindi) a thorny Indian tree, also BAEL [n]\n",
  "BHIKHU": "(Pali) a fully ordained Buddhist monk, also BHIKKHUNI [n -S]\n",
  "BHIKHUS": "BHIKHU, (Pali) a fully ordained Buddhist monk, also BHIKKHUNI [n]\n",
  "BHIKKHUNI": "(Pali) a fully ordained Buddhist monk, also BHIKHU [n -S]\n",
  "BHIKKHUNIS": "BHIKKHUNI, (Pali) a fully ordained Buddhist monk, also BHIKHU [n]\n",
  "BHINDI": "(Hindi) the vegetable okra as used in Indian cookery [n -S]\n",
  "BHINDIS": "BHINDI, (Hindi) the vegetable okra as used in Indian cookery [n]\n",
  "BHISHTI": "(Hindi) an Indian water carrier, also BHEESTIE, BHEESTY, BHISTEE, BHISTI, BHISTIE [n -S]\n",
  "BHISHTIS": "BHISHTI, (Hindi) an Indian water carrier, also BHEESTIE, BHEESTY, BHISTEE, BHISTI, BHISTIE [n]\n",
  "BHISTEE": "(Urdu) an Indian water carrier, also BHEESTIE, BHEESTY, BHISHTI, BHISTI, BHISTIE [n -S]\n",
  "BHISTEES": "BHISTEE, (Urdu) an Indian water carrier, also BHEESTIE, BHEESTY, BHISHTI, BHISTI, BHISTIE [n]\n",
  "BHISTI": "(Urdu) an Indian water carrier, also BHEESTIE, BHEESTY, BHISHTI, BHISTEE, BHISTIE [n -S]\n",
  "BHISTIE": "(Urdu) an Indian water carrier, also BHEESTIE, BHEESTY, BHISHTI, BHISTEE, BHISTI [n -S]\n",
  "BHISTIES": "BHISTIE, (Urdu) an Indian water carrier, also BHEESTIE, BHEESTY, BHISHTI, BHISTEE, BHISTI [n]\n",
  "BHISTIS": "BHISTI, (Urdu) an Indian water carrier, also BHEESTIE, BHEESTY, BHISHTI, BHISTEE, BHISTIE [n]\n",
  "BHOONA": "a dish sauteed in oil and a mix of spices, also BHUNA [n -S]\n",
  "BHOONAS": "BHOONA, a dish sauteed in oil and a mix of spices, also BHUNA [n]\n",
  "BHOOT": "(Hindi) a small whirlwind, also BHUT [n -S]\n",
  "BHOOTS": "BHOOT, (Hindi) a small whirlwind, also BHUT [n]\n",
  "BHUNA": "(Urdu) an Indian sauce, also BHOONA [n -S]\n",
  "BHUNAS": "BHUNA, (Urdu) an Indian sauce, also BHOONA [n]\n",
  "BHUT": "(Hindi) a small whirlwind, also BHOOT [n -S]\n",
  "BHUTS": "BHUT, (Hindi) a small whirlwind, also BHOOT [n]\n",
  "BI": "(short for) a bisexual [n -S]\n",
  "BIACETYL": "a chemical flavor enhancer [n -S]\n",
  "BIACETYLS": "BIACETYL, a chemical flavor enhancer [n]\n",
  "BIACH": "(slang) a bitch, also BIATCH, BITCH [n -ES]\n",
  "BIACHES": "BIACH, (slang) a bitch, also BIATCH, BITCH [n]\n",
  "BIALI": "(Yiddish) an onion roll, also BIALY [n -S]\n",
  "BIALIES": "BIALY, (Yiddish) an onion roll, also BIALI [n]\n",
  "BIALIS": "BIALI, (Yiddish) an onion roll, also BIALY [n]\n",
  "BIALY": "(Yiddish) an onion roll, also BIALI [n BIALYS or BIALIES]\n",
  "BIALYS": "BIALY, (Yiddish) an onion roll, also BIALI [n]\n",
  "BIANNUAL": "taking place twice a year [adj BIANNUALLY] / something appearing, occurring, etc., twice a year [n -S]\n",
  "BIANNUALLY": "BIANNUAL, taking place twice a year [adv]\n",
  "BIANNUALS": "BIANNUAL, something appearing, occurring, etc., twice a year [n]\n",
  "BIANNULATE": "having two bands, esp. of colour [adj]\n",
  "BIAS": "to cause to incline to one side [v BIASSED or BIASED, BIASING or BIASSING, BIASSES or BIASES]\n",
  "BIASED": "BIAS, to cause to incline to one side [v]\n",
  "BIASEDLY": "BIASED, BIAS, to cause to incline to one side [adv]\n",
  "BIASES": "BIAS, to cause to incline to one side [v]\n",
  "BIASING": "the act of making a bias [n -S]\n",
  "BIASINGS": "BIASING, the act of making a bias [n]\n",
  "BIASNESS": "the state of being slanted [n -ES]\n",
  "BIASNESSES": "BIASNESS, the state of being slanted [n]\n",
  "BIASSED": "BIAS, to cause to incline to one side [v]\n",
  "BIASSEDLY": "BIASSED, BIAS, to cause to incline to one side [adv]\n",
  "BIASSES": "BIAS, to cause to incline to one side [v]\n",
  "BIASSING": "BIAS, to cause to incline to one side [v]\n",
  "BIATCH": "(slang) a bitch, also BIACH, BITCH [n -ES]\n",
  "BIATCHES": "BIATCH, (slang) a bitch, also BIACH, BITCH [n]\n",
  "BIATHLETE": "one who takes part in a biathlon [n -S]\n",
  "BIATHLETES": "BIATHLETE, one who takes part in a biathlon [n]\n",
  "BIATHLON": "a competition in cross-country skiing and shooting [n -S]\n",
  "BIATHLONS": "BIATHLON, a competition in cross-country skiing and shooting [n]\n",
  "BIAURICULAR": "having two auricles or earlike parts, also BIAURICULATE [adj]\n",
  "BIAURICULATE": "having two auricles or earlike parts, also BIAURICULAR [adj]\n",
  "BIAXAL": "having two axes, also BIAXIAL [adj]\n",
  "BIAXIAL": "having two axes, also BIAXAL [adj]\n",
  "BIAXIALLY": "BIAXIAL, having two axes, also BIAXAL [adv]\n",
  "BIB": "to tipple [v BIBBED, BIBBING, BIBS]\n",
  "BIBACIOUS": "overly fond of drinking [adj]\n",
  "BIBASIC": "of acids, having two replaceable hydrogen atoms, also DIBASIC [adj]\n",
  "BIBATION": "tippling [n -S]\n",
  "BIBATIONS": "BIBATION, tippling [n]\n",
  "BIBB": "a mast support [n -S]\n",
  "BIBBED": "BIB, to tipple [v]\n",
  "BIBBER": "a tippler [n -S]\n",
  "BIBBERIES": "BIBBERY, the act of tippling [n]\n",
  "BIBBERS": "BIBBER, a tippler [n]\n",
  "BIBBERY": "the act of tippling [n BIBBERIES]\n",
  "BIBBING": "the act of imbibing wine [n -S]\n",
  "BIBBINGS": "BIBBING, the act of imbibing wine [n]\n",
  "BIBBLE": "(English dialect) a pebble [n -S]\n",
  "BIBBLES": "BIBBLE, (English dialect) a pebble [n]\n",
  "BIBBS": "BIBB, a mast support [n]\n",
  "BIBCOCK": "a tap with a downturned nozzle [n -S]\n",
  "BIBCOCKS": "BIBCOCK, a tap with a downturned nozzle [n]\n",
  "BIBE": "(Irish) a type of banshee whose crying is an omen of death [n -S]\n",
  "BIBELOT": "(French) a small household ornament or decorative object, a knickknack [n -S]\n",
  "BIBELOTS": "BIBELOT, (French) a small household ornament or decorative object, a knickknack [n]\n",
  "BIBES": "BIBE, (Irish) a type of banshee whose crying is an omen of death [n]\n",
  "BIBFUL": "as in to spill a bibful, to divulge secrets [n -S]\n",
  "BIBFULS": "BIBFUL, as in to spill a bibful, to divulge secrets [n]\n",
  "BIBIMBAP": "(Korean) a dish of rice, sautied and seasoned vegetables, and hot pepper paste [n -S]\n",
  "BIBIMBAPS": "BIBIMBAP, (Korean) a dish of rice, sautied and seasoned vegetables, and hot pepper paste [n]\n",
  "BIBLE": "an authoritative publication [n -S]\n",
  "BIBLES": "BIBLE, an authoritative publication [n]\n",
  "BIBLESS": "not wearing a bib [adj]\n",
  "BIBLICAL": "relating to the bible [adj BIBLICALLY]\n",
  "BIBLICALLY": "BIBLICAL, relating to the bible [adv]\n",
  "BIBLICISM": "learning or literature relating to the Bible [n -S]\n",
  "BIBLICISMS": "BIBLICISM, learning or literature relating to the Bible [n]\n",
  "BIBLICIST": "one skilled in the knowledge of the Bible [n -S]\n",
  "BIBLICISTS": "BIBLICIST, one skilled in the knowledge of the Bible [n]\n",
  "BIBLIKE": "resembling a bib [adj]\n",
  "BIBLIOGRAPHER": "an expert in bibliography [n -S]\n",
  "BIBLIOGRAPHERS": "BIBLIOGRAPHER, an expert in bibliography [n]\n",
  "BIBLIOGRAPHIC": "relating to bibliography, also BIBLIOGRAPHICAL [adj]\n",
  "BIBLIOGRAPHICAL": "relating to bibliography, also BIBLIOGRAPHIC [adj]\n",
  "BIBLIOGRAPHIES": "BIBLIOGRAPHY, the history, identification, or description of writings or publications [n]\n",
  "BIBLIOGRAPHY": "the history, identification, or description of writings or publications [n BIBLIOGRAPHIES]\n",
  "BIBLIOLATER": "one having excessive reverence for the Bible as literally interpreted; one with extravagant devotion to or dependence upon books [n -S]\n",
  "BIBLIOLATERS": "BIBLIOLATER, one having excessive reverence for the Bible as literally interpreted; one with extravagant devotion to or dependence upon books [n]\n",
  "BIBLIOLATRIES": "BIBLIOLATRY, worship of the Bible or other books [n]\n",
  "BIBLIOLATRIST": "a person given to bibliolatry [n -S]\n",
  "BIBLIOLATRISTS": "BIBLIOLATRIST, a person given to bibliolatry [n]\n",
  "BIBLIOLATROUS": "loving books [adj]\n",
  "BIBLIOLATRY": "worship of the Bible or other books [n BIBLIOLATRIES]\n",
  "BIBLIOLOGICAL": "related to bibliology [adj]\n",
  "BIBLIOLOGIES": "BIBLIOLOGY, the study of books [n]\n",
  "BIBLIOLOGIST": "a student of bibliology [n -S]\n",
  "BIBLIOLOGISTS": "BIBLIOLOGIST, a student of bibliology [n]\n",
  "BIBLIOLOGY": "the study of books [n BIBLIOLOGIES]\n",
  "BIBLIOMANCIES": "BIBLIOMANCY, divination by interpreting a passage picked at random from a book, esp. from a religious book such as the Bible [n]\n",
  "BIBLIOMANCY": "divination by interpreting a passage picked at random from a book, esp. from a religious book such as the Bible [n BIBLIOMANCIES]\n",
  "BIBLIOMANE": "one with a mania for collecting books [n -S]\n",
  "BIBLIOMANES": "BIBLIOMANE, one with a mania for collecting books [n]\n",
  "BIBLIOMANIA": "a craze for books or reading [n -S]\n",
  "BIBLIOMANIAC": "one suffering from bibliomania [n -S]\n",
  "BIBLIOMANIACAL": "relating to bibliomania [adj]\n",
  "BIBLIOMANIACS": "BIBLIOMANIAC, one suffering from bibliomania [n]\n",
  "BIBLIOMANIAS": "BIBLIOMANIA, a craze for books or reading [n]\n",
  "BIBLIOPEGIC": "relating to bibliopegy, the art of binding books [adj]\n",
  "BIBLIOPEGIES": "BIBLIOPEGY, the art of binding books [n]\n",
  "BIBLIOPEGIST": "a bookbinder [n -S]\n",
  "BIBLIOPEGISTS": "BIBLIOPEGIST, a bookbinder [n]\n",
  "BIBLIOPEGY": "the art of binding books [n BIBLIOPEGIES]\n",
  "BIBLIOPHAGIST": "a voracious reader [n -S]\n",
  "BIBLIOPHAGISTS": "BIBLIOPHAGIST, a voracious reader [n]\n",
  "BIBLIOPHIL": "a lover of books, also BIBLIOPHILE [n -S]\n",
  "BIBLIOPHILE": "a lover of books, also BIBLIOPHIL [n -S]\n",
  "BIBLIOPHILES": "BIBLIOPHILE, a lover of books, also BIBLIOPHIL [n]\n",
  "BIBLIOPHILIC": "loving books [adj]\n",
  "BIBLIOPHILIES": "BIBLIOPHILY, the love of books [n]\n",
  "BIBLIOPHILISM": "love of books [n -S]\n",
  "BIBLIOPHILISMS": "BIBLIOPHILISM, love of books [n]\n",
  "BIBLIOPHILIST": "one who loves books [n -S]\n",
  "BIBLIOPHILISTIC": "of or like a bibliophile, a lover of books [adj]\n",
  "BIBLIOPHILISTS": "BIBLIOPHILIST, one who loves books [n]\n",
  "BIBLIOPHILS": "BIBLIOPHIL, a lover of books, also BIBLIOPHILE [n]\n",
  "BIBLIOPHILY": "the love of books [n BIBLIOPHILIES]\n",
  "BIBLIOPHOBIA": "fear of books [n -S]\n",
  "BIBLIOPHOBIAS": "BIBLIOPHOBIA, fear of books [n]\n",
  "BIBLIOPOLE": "(archaic) a bookseller, also BIBLIOPOLIST [n -S]\n",
  "BIBLIOPOLES": "BIBLIOPOLE, (archaic) a bookseller, also BIBLIOPOLIST [n]\n",
  "BIBLIOPOLIC": "relating to a bibliopole, a dealer esp. in rare books, also BIBLIOPOLICAL [adj]\n",
  "BIBLIOPOLICAL": "relating to a bibliopole, a dealer esp. in rare books, also BIBLIOPOLIC [adj]\n",
  "BIBLIOPOLIES": "BIBLIOPOLY, bookselling [n]\n",
  "BIBLIOPOLIST": "a bookseller [n -S]\n",
  "BIBLIOPOLISTS": "BIBLIOPOLIST, a bookseller [n]\n",
  "BIBLIOPOLY": "bookselling [n BIBLIOPOLIES]\n",
  "BIBLIOTHECA": "a collection of books; a list of books [n -S]\n",
  "BIBLIOTHECAE": "BIBLIOTHECA, a collection of books; a list of books [n]\n",
  "BIBLIOTHECAL": "of or like a bibliotheca, a collection of books; a list of books [adj]\n",
  "BIBLIOTHECARIES": "BIBLIOTHECARY, a librarian [n]\n",
  "BIBLIOTHECARY": "a librarian [n BIBLIOTHECARIES]\n",
  "BIBLIOTHECAS": "BIBLIOTHECA, a collection of books; a list of books [n]\n",
  "BIBLIOTHERAPIES": "BIBLIOTHERAPY, the use of reading materials for help in solving personal problems or for psychiatric therapy [n]\n",
  "BIBLIOTHERAPY": "the use of reading materials for help in solving personal problems or for psychiatric therapy [n BIBLIOTHERAPIES]\n",
  "BIBLIOTIC": "relating to bibliotics, the study of documents to determine authenticity [adj]\n",
  "BIBLIOTICS": "the study of handwriting, documents, and writing materials esp. for determining genuineness or authorship [n]\n",
  "BIBLIOTIST": "one who practises bibliotics, the study of handwriting, documents, and writing materials [n -S]\n",
  "BIBLIOTISTS": "BIBLIOTIST, one who practises bibliotics, the study of handwriting, documents, and writing materials [n]\n",
  "BIBLIST": "one skilled in biblical learning [n -S]\n",
  "BIBLISTS": "BIBLIST, one skilled in biblical learning [n]\n",
  "BIBS": "BIB, to tipple [v]\n",
  "BIBULOUS": "addicted to strong drink [adj]\n",
  "BIBULOUSLY": "BIBULOUS, addicted to strong drink [adv]\n",
  "BIBULOUSNESS": "the state of being bibulous [n -ES]\n",
  "BIBULOUSNESSES": "BIBULOUSNESS, the state of being bibulous [n]\n",
  "BICAMERAL": "consisting of, or including, two chambers, or legislative branches [adj]\n",
  "BICAMERALISM": "the state of being bicameral, having two chambers [n -S]\n",
  "BICAMERALISMS": "BICAMERALISM, the state of being bicameral, having two chambers [n]\n",
  "BICAMERALIST": "a supporter of bicameralism [n -S]\n",
  "BICAMERALISTS": "BICAMERALIST, a supporter of bicameralism [n]\n",
  "BICAPSULAR": "of plants, having two capsules or one capsule with two chambers [adj]\n",
  "BICARB": "(short for) bicarbonate [n -S]\n",
  "BICARBONATE": "an acid carbonate [n -S]\n",
  "BICARBONATES": "BICARBONATE, an acid carbonate [n]\n",
  "BICARBS": "BICARB, (short for) bicarbonate [n]\n",
  "BICARPELLARY": "of an ovary, having two carpels [adj]\n",
  "BICAUDAL": "having two tails [adj]\n",
  "BICCIES": "BICCY, (slang) biscuit, also BICKIE, BIKKIE [n]\n",
  "BICCY": "(slang) biscuit, also BICKIE, BIKKIE [n BICCIES]\n",
  "BICE": "a pale blue or green paint [n -S]\n",
  "BICENTENARIES": "BICENTENARY, a two hundred year anniversary, also BICENTENNIAL [n]\n",
  "BICENTENARY": "happening every two hundred years [adj] / a two hundred year anniversary, also BICENTENNIAL [n BICENTENARIES]\n",
  "BICENTENNIAL": "happening every two hundred years [adj] / a two hundred year anniversary, also BICENTENARY [n -S]\n",
  "BICENTENNIALS": "BICENTENNIAL, a two hundred year anniversary, also BICENTENARY [n]\n",
  "BICENTRIC": "having two centres [adj]\n",
  "BICEP": "the two-headed muscle at the front of the arm, also BICEPS [n -S]\n",
  "BICEPHALOUS": "having two heads [adj]\n",
  "BICEPS": "(Latin) the two-headed muscle at the front of the arm, also BICEP [n -ES]\n",
  "BICEPSES": "BICEPS, (Latin) the two-headed muscle at the front of the arm, also BICEP [n]\n",
  "BICES": "BICE, a pale blue or green paint [n]\n",
  "BICHIR": "any of various primitive African freshwater fishes of the genus Polypterus, also BIRCHIR [n -S]\n",
  "BICHIRS": "BICHIR, any of various primitive African freshwater fishes of the genus Polypterus, also BIRCHIR [n]\n",
  "BICHLORIDE": "a compound in which two atoms of chlorine are combined with another atom or group, also DICHLORIDE [n -S]\n",
  "BICHLORIDES": "BICHLORIDE, a compound in which two atoms of chlorine are combined with another atom or group, also DICHLORIDE [n]\n",
  "BICHORD": "of a musical instrument, having two strings, esp. two strings for each note [adj]\n",
  "BICHROMATE": "a salt of dichromic acid [n -S]\n",
  "BICHROMATED": "relating to a salt of dichromic acid [adj]\n",
  "BICHROMATES": "BICHROMATE, a salt of dichromic acid [n]\n",
  "BICHROME": "two-colored [adj]\n",
  "BICIPITAL": "having two heads or origins, as a muscle [adj]\n",
  "BICKER": "to squabble [v -ED, -ING, -S]\n",
  "BICKERED": "BICKER, to squabble [v]\n",
  "BICKERER": "one who bickers [n -S]\n",
  "BICKERERS": "BICKERER, one who bickers [n]\n",
  "BICKERING": "a petty quarrel [n -S]\n",
  "BICKERINGS": "BICKERING, a petty quarrel [n]\n",
  "BICKERS": "BICKER, to squabble [v]\n",
  "BICKIE": "(colloquial) a biscuit, also BICCY, BIKKIE [n -S]\n",
  "BICKIES": "BICKIE, (colloquial) a biscuit, also BICCY, BIKKIE [n]\n",
  "BICOASTAL": "living or based simultaneously on two coasts, esp. in North America [adj]\n",
  "BICOLLATERAL": "of a vascular bundle, having two phloem groups to the inside and outside, respectively, of the xylem [adj]\n",
  "BICOLOR": "something having two colors, also BICOLOUR [n -S]\n",
  "BICOLORED": "(US) having two colors, also BICOLOURED [adj]\n",
  "BICOLORS": "BICOLOR, something having two colors, also BICOLOUR [n]\n",
  "BICOLOUR": "something having two colors, also BICOLOR [n -S]\n",
  "BICOLOURED": "having two colours, also BICOLORED [adj]\n",
  "BICOLOURS": "BICOLOUR, something having two colors, also BICOLOR [n]\n",
  "BICOMPONENT": "a fiber made of two polymers having slightly different physical properties so that the fiber has a permanent crimp and fabrics made from it have inherent bulk and stretchability [n -S]\n",
  "BICOMPONENTS": "BICOMPONENT, a fiber made of two polymers having slightly different physical properties so that the fiber has a permanent crimp and fabrics made from it have inherent bulk and stretchability [n]\n",
  "BICONCAVE": "concave on both sides [adj]\n",
  "BICONCAVITIES": "BICONCAVITY, the state of being biconcave [n]\n",
  "BICONCAVITY": "the state of being biconcave [n BICONCAVITIES]\n",
  "BICONDITIONAL": "a relation between two propositions that is true only when both propositions are simultaneously true or false [n -S]\n",
  "BICONDITIONALS": "BICONDITIONAL, a relation between two propositions that is true only when both propositions are simultaneously true or false [n]\n",
  "BICONVEX": "convex on both sides [adj]\n",
  "BICONVEXITIES": "BICONVEXITY, the state of being biconvex [n]\n",
  "BICONVEXITY": "the state of being biconvex [n BICONVEXITIES]\n",
  "BICORN": "a hat with two corners e.g. as worn by Napoleon, also BICORNE [n -S]\n",
  "BICORNATE": "having two horns or hornlike parts, also BICORNUATE [adj]\n",
  "BICORNE": "a hat with two corners, e.g. as worn by Napoleon, also BICORN [n -S]\n",
  "BICORNES": "BICORNE, a hat with two corners, e.g. as worn by Napoleon, also BICORN [n]\n",
  "BICORNS": "BICORN, a hat with two corners e.g. as worn by Napoleon, also BICORNE [n]\n",
  "BICORNUATE": "having two horns or hornlike parts, also BICORNATE [adj]\n",
  "BICORPORATE": "double-bodied, as the head of a lion to which two bodies are attached [adj]\n",
  "BICRON": "one billionth of a meter [n -S]\n",
  "BICRONS": "BICRON, one billionth of a meter [n]\n",
  "BICULTURAL": "having two cultures [adj]\n",
  "BICULTURALISM": "the state of being bicultural [n -S]\n",
  "BICULTURALISMS": "BICULTURALISM, the state of being bicultural [n]\n",
  "BICURIOUS": "not identifying oneself as bisexual but interested in the possibilites [adj]\n",
  "BICUSPID": "having two cusps [adj] / a tooth having two cusps, also BICUSPIDATE [n -S]\n",
  "BICUSPIDATE": "having two cusps [adj] / a tooth having two cusps, also BICUSPID [n -S]\n",
  "BICUSPIDATES": "BICUSPIDATE, a tooth having two cusps, also BICUSPID [n]\n",
  "BICUSPIDS": "BICUSPID, a tooth having two cusps, also BICUSPIDATE [n]\n",
  "BICYCLE": "to ride a two-wheeled vehicle [v BICYCLED, BICYCLING, BICYCLES]\n",
  "BICYCLED": "BICYCLE, to ride a two-wheeled vehicle [v]\n",
  "BICYCLER": "one who rides a bicycle [n -S]\n",
  "BICYCLERS": "BICYCLER, one who rides a bicycle [n]\n",
  "BICYCLES": "BICYCLE, to ride a two-wheeled vehicle [v]\n",
  "BICYCLIC": "having two cycles [adj]\n",
  "BICYCLICAL": "having two rings of atoms in a molecule, also BICYCLIC [adj]\n",
  "BICYCLING": "BICYCLE, to ride a two-wheeled vehicle [v]\n",
  "BICYCLIST": "one who rides a bicycle [n -S]\n",
  "BICYCLISTS": "BICYCLIST, one who rides a bicycle [n]\n",
  "BID": "to make an offer [v BID or BADE or BIDDEN, BIDDING, BIDS]\n",
  "BIDARKA": "(Russian) an Alaskan Inuit kayak, also BAIDAR, BAIDARKA, BIDARKEE [n -S]\n",
  "BIDARKAS": "BIDARKA, (Russian) an Alaskan Inuit kayak, also BAIDAR, BAIDARKA, BIDARKEE [n]\n",
  "BIDARKEE": "(Russian) an Alaskan Inuit kayak, also BAIDAR, BAIDARKA, BIDARKA [n -S]\n",
  "BIDARKEES": "BIDARKEE, (Russian) an Alaskan Inuit kayak, also BAIDAR, BAIDARKA, BIDARKA [n]\n",
  "BIDDABILITIES": "BIDDABILITY, being biddable [n]\n",
  "BIDDABILITY": "being biddable [n BIDDABILITIES]\n",
  "BIDDABLE": "obedient, docile [adj BIDDABLY]\n",
  "BIDDABLENESS": "the state of being biddable, obedient [n -ES]\n",
  "BIDDABLENESSES": "BIDDABLENESS, the state of being biddable, obedient [n]\n",
  "BIDDABLY": "BIDDABLE, obedient, docile [adv]\n",
  "BIDDEN": "BID, to make an offer [v]\n",
  "BIDDER": "one who bids [n -S]\n",
  "BIDDERS": "BIDDER, one who bids [n]\n",
  "BIDDIES": "BIDDY, a chicken or hen; an old woman, usually somewhat derogatory [n]\n",
  "BIDDING": "a command [n -S]\n",
  "BIDDINGS": "BIDDING, a command [n]\n",
  "BIDDY": "a chicken or hen; an old woman, usually somewhat derogatory [n BIDDIES]\n",
  "BIDE": "to wait, dwell, also BYDE [v BIDED or BODE, BIDDEN, BIDING, BIDES]\n",
  "BIDED": "BIDE, to wait, dwell, also BYDE [v]\n",
  "BIDENT": "a two-pronged spear [n -S]\n",
  "BIDENTAL": "a place struck by lightning then consecrated [n -S]\n",
  "BIDENTALS": "BIDENTAL, a place struck by lightning then consecrated [n]\n",
  "BIDENTATE": "having two teeth or toothlike parts, also BIDENTATED [adj]\n",
  "BIDENTATED": "having two teeth or toothlike parts, also BIDENTATE [adj]\n",
  "BIDENTS": "BIDENT, a two-pronged spear [n]\n",
  "BIDER": "one who bides [n -S]\n",
  "BIDERS": "BIDER, one who bides [n]\n",
  "BIDES": "BIDE, to wait, dwell, also BYDE [v]\n",
  "BIDET": "(French) a shallow oval basin used for washing esp. the genital and anal regions [n -S]\n",
  "BIDETS": "BIDET, (French) a shallow oval basin used for washing esp. the genital and anal regions [n]\n",
  "BIDI": "(Hindi) a hand rolled cigarette, also BEEDI, BEEDIE [n -S]\n",
  "BIDIALECTAL": "speaking two dialects [adj]\n",
  "BIDIALECTALISM": "facility in using two dialects of the same language [n -S]\n",
  "BIDIALECTALISMS": "BIDIALECTALISM, facility in using two dialects of the same language [n]\n",
  "BIDING": "a residence [n -S]\n",
  "BIDINGS": "BIDING, a residence [n]\n",
  "BIDIRECTIONAL": "involving two usually opposite directions [adj BIDIRECTIONALLY]\n",
  "BIDIRECTIONALLY": "BIDIRECTIONAL, involving two usually opposite directions [adv]\n",
  "BIDIS": "BIDI, (Hindi) a hand rolled cigarette, also BEEDI, BEEDIE [n]\n",
  "BIDON": "(French) a container for liquids [n -S]\n",
  "BIDONS": "BIDON, (French) a container for liquids [n]\n",
  "BIDONVILLE": "(French) a shanty town with dwellings made from oil-drums [n -S]\n",
  "BIDONVILLES": "BIDONVILLE, (French) a shanty town with dwellings made from oil-drums [n]\n",
  "BIDS": "BID, to make an offer [v]\n",
  "BIELD": "(Scots) to give shelter [v -ED, -ING, -S]\n",
  "BIELDED": "BIELD, (Scots) to give shelter [v]\n",
  "BIELDIER": "BIELDY, (Scots) affording shelter [adj]\n",
  "BIELDIEST": "BIELDY, (Scots) affording shelter [adj]\n",
  "BIELDING": "BIELD, (Scots) to give shelter [v]\n",
  "BIELDS": "BIELD, (Scots) to give shelter [v]\n",
  "BIELDY": "(Scots) affording shelter [adj BIELDIER, BIELDIEST]\n",
  "BIEN": "(Scots) well off, comfortable, also BEIN [adj]\n",
  "BIENNALE": "(Italian) an international arts festival held in Venice every two years [n -S]\n",
  "BIENNALES": "BIENNALE, (Italian) an international arts festival held in Venice every two years [n]\n",
  "BIENNIA": "BIENNIUM, (Latin) a period of two years [n]\n",
  "BIENNIAL": "occurring every two years [adj BIENNIALLY] / something e.g. a plant occurring every two years; lasting for two years [n -S]\n",
  "BIENNIALLY": "BIENNIAL, occurring every two years [adv]\n",
  "BIENNIALS": "BIENNIAL, something e.g. a plant occurring every two years; lasting for two years [n]\n",
  "BIENNIUM": "(Latin) a period of two years [n BIENNIUMS or BIENNIA]\n",
  "BIENNIUMS": "BIENNIUM, (Latin) a period of two years [n]\n",
  "BIENSEANCE": "proper, correct or fitting things [n -S]\n",
  "BIENSEANCES": "BIENSEANCE, proper, correct or fitting things [n]\n",
  "BIER": "a coffin stand [n -S]\n",
  "BIERKELLER": "(German) a beer cellar [n -S]\n",
  "BIERKELLERS": "BIERKELLER, (German) a beer cellar [n]\n",
  "BIERS": "BIER, a coffin stand [n]\n",
  "BIERWURST": "(German) a chunky, tubular, dark red, cooked and smoked sausage made from chopped seasoned beef and pork [n -S]\n",
  "BIERWURSTS": "BIERWURST, (German) a chunky, tubular, dark red, cooked and smoked sausage made from chopped seasoned beef and pork [n]\n",
  "BIESTINGS": "the first milk drawn from a cow after calving, aka colostrum or foremilk, also BEASTINGS, BEESTINGS [n]\n",
  "BIFACE": "a type of prehistoric stone implement flaked on both faces [n -S]\n",
  "BIFACES": "BIFACE, a type of prehistoric stone implement flaked on both faces [n]\n",
  "BIFACIAL": "having two faces [adj]\n",
  "BIFACIALLY": "BIFACIAL, having two faces [adv]\n",
  "BIFARIOUS": "organized in two rows [adj BIFARIOUSLY]\n",
  "BIFARIOUSLY": "BIFARIOUS, organized in two rows [adv]\n",
  "BIFF": "to strike hard [v -ED, -ING, -S]\n",
  "BIFFED": "BIFF, to strike hard [v]\n",
  "BIFFER": "in sports, someone with a reputation for hitting hard [n -S]\n",
  "BIFFERS": "BIFFER, in sports, someone with a reputation for hitting hard [n]\n",
  "BIFFIES": "BIFFY, (US) an outdoor toilet, an outhouse [n]\n",
  "BIFFIN": "a variety of red cooking apple, also BEAUFIN [n -S]\n",
  "BIFFING": "BIFF, to strike hard [v]\n",
  "BIFFINS": "BIFFIN, a variety of red cooking apple, also BEAUFIN [n]\n",
  "BIFFO": "(Australian slang) fighting or aggressive behaviour [n -S]\n",
  "BIFFOS": "BIFFO, (Australian slang) fighting or aggressive behaviour [n]\n",
  "BIFFS": "BIFF, to strike hard [v]\n",
  "BIFFY": "(US) an outdoor toilet, an outhouse [n BIFFIES]\n",
  "BIFID": "divided into two parts [adj]\n",
  "BIFIDA": "BIFIDUM, a bacterium present in the human digestive system, often added to yogurt, also BIFIDUS [n]\n",
  "BIFIDITIES": "BIFIDITY, the state of being divided into two parts [n]\n",
  "BIFIDITY": "the state of being divided into two parts [n BIFIDITIES]\n",
  "BIFIDLY": "BIFID, divided into two parts [adv]\n",
  "BIFIDUM": "a bacterium present in the human digestive system, often added to yogurt, also BIFIDUS [n BIFIDA or BIFIDUMS]\n",
  "BIFIDUMS": "BIFIDUM, a bacterium present in the human digestive system, often added to yogurt, also BIFIDUS [n]\n",
  "BIFIDUS": "a bacterium present in the human digestive system, often added to yogurt, also BIFIDUM [n -ES]\n",
  "BIFIDUSES": "BIFIDUS, a bacterium present in the human digestive system, often added to yogurt, also BIFIDUM [n]\n",
  "BIFILAR": "having two threads [adj]\n",
  "BIFILARLY": "BIFILAR, having two threads [adv]\n",
  "BIFLAGELLATE": "having two flagella [adj]\n",
  "BIFLEX": "bent in two places [adj]\n",
  "BIFOCAL": "having two focal points [adj]\n",
  "BIFOCALED": "wearing bifocals [adj]\n",
  "BIFOCALS": "spectacles with bifocal lenses [n]\n",
  "BIFOLD": "a two-piece door [n -S]\n",
  "BIFOLDS": "BIFOLD, a two-piece door [n]\n",
  "BIFOLIATE": "having two leaves or leaflets [adj]\n",
  "BIFOLIOLATE": "having two leaflets [adj]\n",
  "BIFORATE": "having two perforations [adj]\n",
  "BIFORKED": "divided into two branches [adj]\n",
  "BIFORM": "having two forms, also BIFORMED [adj]\n",
  "BIFORMED": "having two forms, also BIFORM [adj]\n",
  "BIFTAH": "(slang) a cannabis cigarette, also BIFTER [n -S]\n",
  "BIFTAHS": "BIFTAH, (slang) a cannabis cigarette, also BIFTER [n]\n",
  "BIFTER": "(slang) a cannabis cigarette, also BIFTAH [n -S]\n",
  "BIFTERS": "BIFTER, (slang) a cannabis cigarette, also BIFTAH [n]\n",
  "BIFUNCTIONAL": "having two functions [adj]\n",
  "BIFURCATE": "to fork [v BIFURCATED, BIFURCATING, BIFURCATES]\n",
  "BIFURCATED": "BIFURCATE, to fork [v]\n",
  "BIFURCATES": "BIFURCATE, to fork [v]\n",
  "BIFURCATING": "BIFURCATE, to fork [v]\n",
  "BIFURCATION": "the state of being bifurcated [n -S]\n",
  "BIFURCATIONS": "BIFURCATION, the state of being bifurcated [n]\n",
  "BIG": "to build [v BIGGED, BIGGING, BIGS] / of large size [adj BIGGER, BIGGEST, BIGLY]\n",
  "BIGA": "(Latin) a two-horse chariot [n BIGAE]\n",
  "BIGAE": "BIGA, (Latin) a two-horse chariot [n]\n",
  "BIGAMIES": "BIGAMY, the crime of being married to two people at once [n]\n",
  "BIGAMIST": "a person who commits bigamy [n -S]\n",
  "BIGAMISTS": "BIGAMIST, a person who commits bigamy [n]\n",
  "BIGAMOUS": "guilty of bigamy [adj]\n",
  "BIGAMOUSLY": "BIGAMOUS, guilty of bigamy [adv]\n",
  "BIGAMY": "the crime of being married to two people at once [n BIGAMIES]\n",
  "BIGARADE": "(French) a bitter Seville orange [n -S]\n",
  "BIGARADES": "BIGARADE, (French) a bitter Seville orange [n]\n",
  "BIGAROON": "any of several heart-shaped varieties of cherry, also BIGARREAU [n -S]\n",
  "BIGAROONS": "BIGAROON, any of several heart-shaped varieties of cherry, also BIGARREAU [n]\n",
  "BIGARREAU": "any of several heart-shaped varieties of cherry, also BIGAROON [n -S]\n",
  "BIGARREAUS": "BIGARREAU, any of several heart-shaped varieties of cherry, also BIGAROON [n]\n",
  "BIGEMINAL": "having a double pulse [adj]\n",
  "BIGEMINIES": "BIGEMINY, the state of having a double pulse [n]\n",
  "BIGEMINY": "the state of having a double pulse [n BIGEMINIES]\n",
  "BIGENER": "(Latin) a hybrid between genera [n -S]\n",
  "BIGENERIC": "relating to a bigener, a hybrid arising from two genera [adj]\n",
  "BIGENERS": "BIGENER, (Latin) a hybrid between genera [n]\n",
  "BIGEYE": "a kind of marine fish with large eyes [n -S]\n",
  "BIGEYES": "BIGEYE, a kind of marine fish with large eyes [n]\n",
  "BIGFEET": "BIGFOOT, a large hairy primate [n]\n",
  "BIGFOOT": "a large hairy primate [n BIGFOOTS or BIGFEET] / to throw one's weight around [v -ED, -ING, -S]\n",
  "BIGFOOTED": "BIGFOOT, to throw one's weight around [v]\n",
  "BIGFOOTING": "BIGFOOT, to throw one's weight around [v]\n",
  "BIGFOOTS": "BIGFOOT, to throw one's weight around [v]\n",
  "BIGG": "a four-rowed barley [n -S]\n",
  "BIGGED": "BIG, to build [v]\n",
  "BIGGER": "BIG, of large size [adj]\n",
  "BIGGEST": "BIG, of large size [adj]\n",
  "BIGGETIER": "BIGGETY, conceited, also BIGGITY [adj]\n",
  "BIGGETIEST": "BIGGETY, conceited, also BIGGITY [adj]\n",
  "BIGGETY": "conceited, also BIGGITY [adj BIGGETIER, BIGGETIEST]\n",
  "BIGGIE": "a biggish thing, also BIGGY [n -S]\n",
  "BIGGIES": "BIGGY, a biggish thing, also BIGGIE [n]\n",
  "BIGGIN": "a child's cap worn in the Middle Ages, also BIGGON [n -S]\n",
  "BIGGING": "(Scots) a building [n -S]\n",
  "BIGGINGS": "BIGGING, (Scots) a building [n]\n",
  "BIGGINS": "BIGGIN, a child's cap worn in the Middle Ages, also BIGGON [n]\n",
  "BIGGISH": "somewhat big [adj]\n",
  "BIGGITIER": "BIGGITY, conceited, also BIGGETY [adj]\n",
  "BIGGITIEST": "BIGGITY, conceited, also BIGGETY [adj]\n",
  "BIGGITY": "conceited, also BIGGETY [adj BIGGITIER, BIGGITIEST]\n",
  "BIGGON": "a child's cap worn in the Middle Ages, also BIGGIN [n -S]\n",
  "BIGGONS": "BIGGON, a child's cap worn in the Middle Ages, also BIGGIN [n]\n",
  "BIGGS": "BIGG, a four-rowed barley [n]\n",
  "BIGGY": "a biggish thing, also BIGGIE [n BIGGIES]\n",
  "BIGHA": "(Hindi) an Indian land measure, also BEEGAH [n -S]\n",
  "BIGHAS": "BIGHA, (Hindi) an Indian land measure, also BEEGAH [n]\n",
  "BIGHEAD": "a conceited person [n -S]\n",
  "BIGHEADED": "conceited [adj BIGHEADEDLY]\n",
  "BIGHEADEDLY": "BIGHEADED, conceited [adv]\n",
  "BIGHEADEDNESS": "the state of being bigheaded [n -ES]\n",
  "BIGHEADEDNESSES": "BIGHEADEDNESS, the state of being bigheaded [n]\n",
  "BIGHEADS": "BIGHEAD, a conceited person [n]\n",
  "BIGHEARTED": "generous, charitable [adj BIGHEARTEDLY]\n",
  "BIGHEARTEDLY": "BIGHEARTED, generous, charitable [adv]\n",
  "BIGHEARTEDNESS": "the state of being bighearted [n]\n",
  "BIGHORN": "a kind of wild sheep [n -S]\n",
  "BIGHORNS": "BIGHORN, a kind of wild sheep [n]\n",
  "BIGHT": "to fasten with a loop of rope [v -ED, -ING, -S]\n",
  "BIGHTED": "BIGHT, to fasten with a loop of rope [v]\n",
  "BIGHTING": "BIGHT, to fasten with a loop of rope [v]\n",
  "BIGHTS": "BIGHT, to fasten with a loop of rope [v]\n",
  "BIGLY": "BIG, of large size [adv]\n",
  "BIGMOUTH": "a loud conceited person [n -S]\n",
  "BIGMOUTHED": "having a large mouth [adj]\n",
  "BIGMOUTHS": "BIGMOUTH, a loud conceited person [n]\n",
  "BIGNESS": "the state of being big [n -ES]\n",
  "BIGNESSES": "BIGNESS, the state of being big [n]\n",
  "BIGNONIA": "any member of the Bignonia genus of tropical plants with trumpet-shaped flowers [n -S]\n",
  "BIGNONIACEOUS": "belonging to the bignonia family [adj]\n",
  "BIGNONIAS": "BIGNONIA, any member of the Bignonia genus of tropical plants with trumpet-shaped flowers [n]\n",
  "BIGOS": "a kind of Polish stew [n -ES]\n",
  "BIGOSES": "BIGOS, a kind of Polish stew [n]\n",
  "BIGOT": "a prejudiced person [n -S]\n",
  "BIGOTED": "like a bigot, intolerant [adj BIGOTEDLY]\n",
  "BIGOTEDLY": "BIGOTED, like a bigot, intolerant [adv]\n",
  "BIGOTRIES": "BIGOTRY, prejudice [n]\n",
  "BIGOTRY": "prejudice [n BIGOTRIES]\n",
  "BIGOTS": "BIGOT, a prejudiced person [n]\n",
  "BIGS": "BIG, to build [v]\n",
  "BIGSTICK": "of or relating to irresistible military strength [adj]\n",
  "BIGTIME": "significant, renowned [adj]\n",
  "BIGUANIDE": "one of a group of drugs used in the late onset of diabetes [n -S]\n",
  "BIGUANIDES": "BIGUANIDE, one of a group of drugs used in the late onset of diabetes [n]\n",
  "BIGUINE": "(French) a dance of French West Indian origin, also BEGUINE [n -S]\n",
  "BIGUINES": "BIGUINE, (French) a dance of French West Indian origin, also BEGUINE [n]\n",
  "BIGWIG": "an important person [n -S]\n",
  "BIGWIGS": "BIGWIG, an important person [n]\n",
  "BIHOURLY": "occurring every two hours [adj]\n",
  "BIJECTION": "in maths, a kind of mapping function [n -S]\n",
  "BIJECTIONS": "BIJECTION, in maths, a kind of mapping function [n]\n",
  "BIJECTIVE": "having the properties of a bijection, a kind of mapping function [adj]\n",
  "BIJOU": "(French) a trinket, a jewel [n BIJOUS or BIJOUX]\n",
  "BIJOUS": "BIJOU, (French) a trinket, a jewel [n]\n",
  "BIJOUTERIE": "(French) jewellery, esp. trinkets [n -S]\n",
  "BIJOUTERIES": "BIJOUTERIE, (French) jewellery, esp. trinkets [n]\n",
  "BIJOUX": "BIJOU, (French) a trinket, a jewel [n]\n",
  "BIJUGATE": "having two pairs of leaflets [adj]\n",
  "BIJUGOUS": "having two pairs of leaflets [adj]\n",
  "BIJURAL": "pertaining to a single jurisdiction with two legal systems [adj]\n",
  "BIJWONER": "(South African) the subtenant of a farm; an agricultural labourer, also BYWONER [n -S]\n",
  "BIJWONERS": "BIJWONER, (South African) the subtenant of a farm; an agricultural labourer, also BYWONER [n]\n",
  "BIKE": "to ride a bicycle [v BIKED, BIKING, BIKES]\n",
  "BIKED": "BIKE, to ride a bicycle [v]\n",
  "BIKER": "one who rides a bike [n -S]\n",
  "BIKERS": "BIKER, one who rides a bike [n]\n",
  "BIKES": "BIKE, to ride a bicycle [v]\n",
  "BIKEWAY": "(US) a route set aside for bicycles [n -S]\n",
  "BIKEWAYS": "BIKEWAY, (US) a route set aside for bicycles [n]\n",
  "BIKIE": "(Australian slang) a member of a gang of motorbike riders [n -S]\n",
  "BIKIES": "BIKIE, (Australian slang) a member of a gang of motorbike riders [n]\n",
  "BIKING": "the act of riding of a bike [n -S]\n",
  "BIKINGS": "BIKING, the act of riding of a bike [n]\n",
  "BIKINI": "a brief two-piece swimming costume [n -S]\n",
  "BIKINIED": "wearing a bikini [adj]\n",
  "BIKINIS": "BIKINI, a brief two-piece swimming costume [n]\n",
  "BIKKIE": "(slang) a biscuit, also BICCY, BICKIE [n -S]\n",
  "BIKKIES": "BIKKIE, (slang) a biscuit, also BICCY, BICKIE [n]\n",
  "BILABIAL": "a sound produced by both lips, for example p, b, m [n -S]\n",
  "BILABIALS": "BILABIAL, a sound produced by both lips, for example p, b, m [n]\n",
  "BILABIATE": "having two lips, as the corollas of certain flowers [adj]\n",
  "BILANDER": "(Dutch) a two-masted cargo vessel used in Holland, also BYLANDER [n -S]\n",
  "BILANDERS": "BILANDER, (Dutch) a two-masted cargo vessel used in Holland, also BYLANDER [n]\n",
  "BILATERAL": "having or involving two sides [adj BILATERALLY]\n",
  "BILATERALISM": "two-sidedness; equality in value of trade between two countries [n -S]\n",
  "BILATERALISMS": "BILATERALISM, two-sidedness; equality in value of trade between two countries [n]\n",
  "BILATERALLY": "BILATERAL, having or involving two sides [adv]\n",
  "BILAYER": "a film with two molecular layers [n -S]\n",
  "BILAYERS": "BILAYER, a film with two molecular layers [n]\n",
  "BILBERRIES": "BILBERRY, a whortleberry shrub; its dark-blue edible berry, also BLAEBERRY [n]\n",
  "BILBERRY": "a whortleberry shrub; its dark-blue edible berry, also BLAEBERRY [n BILBERRIES]\n",
  "BILBIES": "BILBY, (Native Australian) a burrowing marsupial of Australia [n]\n",
  "BILBO": "(Spanish) a rapier, also BILBOA [n BILBOS or BILBOES]\n",
  "BILBOA": "(Spanish) a rapier, also BILBO [n -S]\n",
  "BILBOAS": "BILBOA, (Spanish) a rapier, also BILBO [n]\n",
  "BILBOES": "BILBO, (Spanish) a rapier, also BILBOA [n]\n",
  "BILBOS": "BILBO, (Spanish) a rapier, also BILBOA [n]\n",
  "BILBY": "(Native Australian) a burrowing marsupial of Australia [n BILBIES]\n",
  "BILDUNGSROMAN": "(German) a psychological novel dealing with the early moral development of the protagonist [n -S]\n",
  "BILDUNGSROMANS": "BILDUNGSROMAN, (German) a psychological novel dealing with the early moral development of the protagonist [n]\n",
  "BILE": "(Scots) to boil [v BILED, BILING, BILES]\n",
  "BILECTION": "a moulding around a panel, projecting beyond the surface of the framing, also BALECTION, BOLECTION [n -S]\n",
  "BILECTIONS": "BILECTION, a moulding around a panel, projecting beyond the surface of the framing, also BALECTION, BOLECTION [n]\n",
  "BILED": "BILE, (Scots) to boil [v]\n",
  "BILES": "BILE, (Scots) to boil [v]\n",
  "BILESTONE": "a gallstone [n -S]\n",
  "BILESTONES": "BILESTONE, a gallstone [n]\n",
  "BILEVEL": "of an image, showing only two colours, black and white [n -S]\n",
  "BILEVELS": "BILEVEL, of an image, showing only two colours, black and white [n]\n",
  "BILGE": "to spring a leak [v BILGED, BILGING, BILGES]\n",
  "BILGED": "BILGE, to spring a leak [v]\n",
  "BILGES": "BILGE, to spring a leak [v]\n",
  "BILGEWATER": "the water that collects in a ship's bilge [n -S]\n",
  "BILGEWATERS": "BILGEWATER, the water that collects in a ship's bilge [n]\n",
  "BILGIER": "BILGY, having the smell of bilge water [adj]\n",
  "BILGIEST": "BILGY, having the smell of bilge water [adj]\n",
  "BILGING": "BILGE, to spring a leak [v]\n",
  "BILGY": "having the smell of bilge water [adj BILGIER, BILGIEST]\n",
  "BILHARZIA": "a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka schistosomiasis, also BILHARZIASIS, BILHARZIOSIS [n -S]\n",
  "BILHARZIAL": "relating to bilharzia [adj]\n",
  "BILHARZIAS": "BILHARZIA, a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka schistosomiasis, also BILHARZIASIS, BILHARZIOSIS [n]\n",
  "BILHARZIASES": "BILHARZIASIS, a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka schistosomiasis, also BILHARZIA, BILHARZIOSIS [n]\n",
  "BILHARZIASIS": "a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka schistosomiasis, also BILHARZIA, BILHARZIOSIS [n BILHARZIASES]\n",
  "BILHARZIOSES": "BILHARZIOSIS, a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka schistosomiasis, also BILHARZIA, BILHARZIASIS [n]\n",
  "BILHARZIOSIS": "a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka schistosomiasis, also BILHARZIA, BILHARZIASIS [n BILHARZIOSES]\n",
  "BILIAN": "(Malay) a heavy ant-proof timber tree of Borneo [n -S]\n",
  "BILIANS": "BILIAN, (Malay) a heavy ant-proof timber tree of Borneo [n]\n",
  "BILIARIES": "BILIARY, infectious canine jaundice [n]\n",
  "BILIARY": "infectious canine jaundice [n BILIARIES]\n",
  "BILIMBI": "(Malay) an East Indian tree of the wood-sorrel family; its sour green fruit, used in chutneys, also BILIMBING, BLIMBING [n -S]\n",
  "BILIMBING": "(Malay) an East Indian tree of the wood-sorrel family; its sour green fruit, used in chutneys, also BILIMBI, BLIMBING [n -S]\n",
  "BILIMBINGS": "BILIMBING, (Malay) an East Indian tree of the wood-sorrel family; its sour green fruit, used in chutneys, also BILIMBI, BLIMBING [n]\n",
  "BILIMBIS": "BILIMBI, (Malay) an East Indian tree of the wood-sorrel family; its sour green fruit, used in chutneys, also BILIMBING, BLIMBING [n]\n",
  "BILINEAR": "pertaining to two lines [adj]\n",
  "BILING": "BILE, (Scots) to boil [v]\n",
  "BILINGUAL": "speaking two languages [adj BILINGUALLY] / one who can speak two languages equally well [n -S]\n",
  "BILINGUALISM": "the ability to speak two languages [n -S]\n",
  "BILINGUALISMS": "BILINGUALISM, the ability to speak two languages [n]\n",
  "BILINGUALLY": "BILINGUAL, speaking two languages [adv]\n",
  "BILINGUALS": "BILINGUAL, one who can speak two languages equally well [n]\n",
  "BILINGUIST": "one versed in two languages [n -S]\n",
  "BILINGUISTS": "BILINGUIST, one versed in two languages [n]\n",
  "BILIOUS": "pertaining to bile; ill-tempered [adj BILIOUSLY]\n",
  "BILIOUSLY": "BILIOUS, pertaining to bile; ill-tempered [adv]\n",
  "BILIOUSNESS": "the state of being bilious [n -ES]\n",
  "BILIOUSNESSES": "BILIOUSNESS, the state of being bilious [n]\n",
  "BILIRUBIN": "a reddish yellow pigment present in bile [n -S]\n",
  "BILIRUBINS": "BILIRUBIN, a reddish yellow pigment present in bile [n]\n",
  "BILITERAL": "consisting of two letters; as, a biliteral root of a Sanskrit verb [adj]\n",
  "BILIVERDIN": "a green pigment present in the bile [n -S]\n",
  "BILIVERDINS": "BILIVERDIN, a green pigment present in the bile [n]\n",
  "BILK": "to avoid paying someone what is due [v -ED, -ING, -S]\n",
  "BILKED": "BILK, to avoid paying someone what is due [v]\n",
  "BILKER": "one who bilks, eludes payment of what is due [n -S]\n",
  "BILKERS": "BILKER, one who bilks, eludes payment of what is due [n]\n",
  "BILKING": "BILK, to avoid paying someone what is due [v]\n",
  "BILKS": "BILK, to avoid paying someone what is due [v]\n",
  "BILL": "to charge someone for services [v -ED, -ING, -S]\n",
  "BILLABLE": "that can be billed, e.g. of a lawyer's hours [adj]\n",
  "BILLABONG": "(Native Australian) in Australia, an isolated loop of a river, replenished only by floods [n -S]\n",
  "BILLABONGS": "BILLABONG, (Native Australian) in Australia, an isolated loop of a river, replenished only by floods [n]\n",
  "BILLBOARD": "a board on which large advertising posters are stuck [n -S] / to advertise by means of billboards [v -ED, -ING, -S]\n",
  "BILLBOARDED": "BILLBOARD, to advertise by means of billboards [v]\n",
  "BILLBOARDING": "BILLBOARD, to advertise by means of billboards [v]\n",
  "BILLBOARDS": "BILLBOARD, to advertise by means of billboards [v]\n",
  "BILLBOOK": "a book used in commerce in which an entry is made of bills issued and received [n -S]\n",
  "BILLBOOKS": "BILLBOOK, a book used in commerce in which an entry is made of bills issued and received [n]\n",
  "BILLBUG": "a weevil or curculio of various species, as the corn weevil [n -S]\n",
  "BILLBUGS": "BILLBUG, a weevil or curculio of various species, as the corn weevil [n]\n",
  "BILLED": "BILL, to charge someone for services [v]\n",
  "BILLER": "one who bills [n -S]\n",
  "BILLERS": "BILLER, one who bills [n]\n",
  "BILLET": "to accommodate or quarter [v -ED, -ING, -S]\n",
  "BILLETED": "BILLET, to accommodate or quarter [v]\n",
  "BILLETEE": "one who is billeted [n -S]\n",
  "BILLETEES": "BILLETEE, one who is billeted [n]\n",
  "BILLETER": "one who billets [n -S]\n",
  "BILLETERS": "BILLETER, one who billets [n]\n",
  "BILLETING": "the act of allocating a billet [n -S]\n",
  "BILLETINGS": "BILLETING, the act of allocating a billet [n]\n",
  "BILLETS": "BILLET, to accommodate or quarter [v]\n",
  "BILLFISH": "a kind of fish with long jaws [n -ES]\n",
  "BILLFISHES": "BILLFISH, a kind of fish with long jaws [n]\n",
  "BILLFOLD": "a wallet [n -S]\n",
  "BILLFOLDS": "BILLFOLD, a wallet [n]\n",
  "BILLHEAD": "a printed form, used by merchants in making out bills or rendering accounts [n -S]\n",
  "BILLHEADS": "BILLHEAD, a printed form, used by merchants in making out bills or rendering accounts [n]\n",
  "BILLHOOK": "a tool for cutting brushwood etc. [n -S]\n",
  "BILLHOOKS": "BILLHOOK, a tool for cutting brushwood etc. [n]\n",
  "BILLIARD": "a carom shot in billiards [n -S]\n",
  "BILLIARDS": "BILLIARD, a carom shot in billiards [n]\n",
  "BILLIE": "(Australian slang) a metal camp pot, also BILLY, BILLYCAN [n -S]\n",
  "BILLIES": "BILLY, (Australian slang) a metal camp pot, also BILLIE, BILLYCAN [n]\n",
  "BILLING": "the relative position in which a performer is listed [n -S]\n",
  "BILLINGS": "BILLING, the relative position in which a performer is listed [n]\n",
  "BILLINGSGATE": "coarsely abusive language [n -S]\n",
  "BILLINGSGATES": "BILLINGSGATE, coarsely abusive language [n]\n",
  "BILLION": "a thousand million [n -S]\n",
  "BILLIONAIRE": "one possessing a billion dollars or more [n -S]\n",
  "BILLIONAIRES": "BILLIONAIRE, one possessing a billion dollars or more [n]\n",
  "BILLIONS": "BILLION, a thousand million [n]\n",
  "BILLIONTH": "the ordinal of billion [adj] / a thousand millionth part [n -S]\n",
  "BILLIONTHS": "BILLIONTH, a thousand millionth part [n]\n",
  "BILLMAN": "one who uses, or is armed with, a bill or hooked ax [n BILLMEN]\n",
  "BILLMEN": "BILLMAN, one who uses, or is armed with, a bill or hooked ax [n]\n",
  "BILLON": "(French) base metal, an alloy of copper, tin or silver [n -S]\n",
  "BILLONS": "BILLON, (French) base metal, an alloy of copper, tin or silver [n]\n",
  "BILLOW": "to swell up [v -ED, -ING, -S]\n",
  "BILLOWED": "BILLOW, to swell up [v]\n",
  "BILLOWIER": "BILLOWY, swelling [adj]\n",
  "BILLOWIEST": "BILLOWY, swelling [adj]\n",
  "BILLOWINESS": "the state of being billowy [n -ES]\n",
  "BILLOWINESSES": "BILLOWINESS, the state of being billowy [n]\n",
  "BILLOWING": "a swelling out [n -S]\n",
  "BILLOWINGS": "BILLOWING, a swelling out [n]\n",
  "BILLOWS": "BILLOW, to swell up [v]\n",
  "BILLOWY": "swelling [adj BILLOWIER, BILLOWIEST]\n",
  "BILLPOSTER": "one who sticks up bills, also BILLSTICKER [n -S]\n",
  "BILLPOSTERS": "BILLPOSTER, one who sticks up bills, also BILLSTICKER [n]\n",
  "BILLPOSTING": "the act of posting a bill [n -S]\n",
  "BILLPOSTINGS": "BILLPOSTING, the act of posting a bill [n]\n",
  "BILLS": "BILL, to charge someone for services [v]\n",
  "BILLSTICKER": "one who sticks up bills, also BILLPOSTER [n -S]\n",
  "BILLSTICKERS": "BILLSTICKER, one who sticks up bills, also BILLPOSTER [n]\n",
  "BILLSTICKING": "the act of posting bills [n -S]\n",
  "BILLSTICKINGS": "BILLSTICKING, the act of posting bills [n]\n",
  "BILLY": "(Australian slang) a metal camp pot, also BILLIE, BILLYCAN [n BILLIES]\n",
  "BILLYBOY": "a flat-bottomed river barge or coasting vessel [n -S]\n",
  "BILLYBOYS": "BILLYBOY, a flat-bottomed river barge or coasting vessel [n]\n",
  "BILLYCAN": "(Australian slang) a metal camp pot, also BILLIE, BILLY [n -S]\n",
  "BILLYCANS": "BILLYCAN, (Australian slang) a metal camp pot, also BILLIE, BILLY [n]\n",
  "BILLYCOCK": "a kind of felt hat [n -S]\n",
  "BILLYCOCKS": "BILLYCOCK, a kind of felt hat [n]\n",
  "BILLYO": "in the phrase \"like billyo\", extremely, also BILLYOH [n -S]\n",
  "BILLYOH": "in the phrase \"like billyoh\", extremely, also BILLYO [n -S]\n",
  "BILLYOHS": "BILLYOH, in the phrase \"like billyoh\", extremely, also BILLYO [n]\n",
  "BILLYOS": "BILLYO, in the phrase \"like billyo\", extremely, also BILLYOH [n]\n",
  "BILOBAR": "having two lobes [adj]\n",
  "BILOBATE": "having two lobes, also BILOBATED [adj]\n",
  "BILOBATED": "having two lobes, also BILOBAR, BILOBATE, BILOBED [adj]\n",
  "BILOBED": "having two lobes [adj]\n",
  "BILOBULAR": "having two lobules [adj]\n",
  "BILOCATION": "the ability to be in two places at once [n -S]\n",
  "BILOCATIONS": "BILOCATION, the ability to be in two places at once [n]\n",
  "BILOCULAR": "divided into two chambers or cavities, also BILOCULATE [adj]\n",
  "BILOCULATE": "divided into two chambers or cavities, also BILOCULAR [adj]\n",
  "BILSTED": "a North American tree of the genus Liquidambar, aka sweet gum [n -S]\n",
  "BILSTEDS": "BILSTED, a North American tree of the genus Liquidambar, aka sweet gum [n]\n",
  "BILTONG": "(South African) a kind of dried meat [n -S]\n",
  "BILTONGS": "BILTONG, (South African) a kind of dried meat [n]\n",
  "BIMA": "(Hebrew) a raised platform in a synagogue, also BEMA, BIMAH [n -S]\n",
  "BIMAH": "(Hebrew) a raised platform in a synagogue, also BEMA, BIMA [n -S]\n",
  "BIMAHS": "BIMAH, (Hebrew) a raised platform in a synagogue, also BEMA, BIMA [n]\n",
  "BIMANAL": "two-handed, also BIMANOUS [adj]\n",
  "BIMANOUS": "two-handed, also BIMANAL [adj]\n",
  "BIMANUAL": "done with two hands [adj BIMANUALLY]\n",
  "BIMANUALLY": "BIMANUAL, done with two hands [adv]\n",
  "BIMAS": "BIMA, (Hebrew) a raised platform in a synagogue, also BEMA, BIMAH [n]\n",
  "BIMATERNAL": "having the genetic material of two mothers but no father [adj]\n",
  "BIMBASHI": "(Turkish) a Turkish military officer [n -S]\n",
  "BIMBASHIS": "BIMBASHI, (Turkish) a Turkish military officer [n]\n",
  "BIMBETTE": "(offensive) a very dumb female bimbo [n -S]\n",
  "BIMBETTES": "BIMBETTE, (offensive) a very dumb female bimbo [n]\n",
  "BIMBLE": "(Native Australian) as in bimble box, a type of dense Australian tree [adj]\n",
  "BIMBO": "(offensive) a woman who is attractive but dim witted [n BIMBOS or BIMBOES]\n",
  "BIMBOES": "BIMBO, (offensive) a woman who is attractive but dim witted [n]\n",
  "BIMBOS": "BIMBO, (offensive) a woman who is attractive but dim witted [n]\n",
  "BIMENSAL": "occurring every two months [adj]\n",
  "BIMESTER": "a two-month period [n -S]\n",
  "BIMESTERS": "BIMESTER, a two-month period [n]\n",
  "BIMESTRIAL": "occurring every two months; lasting two months [adj BIMESTRIALLY]\n",
  "BIMESTRIALLY": "BIMESTRIAL, occurring every two months; lasting two months [adv]\n",
  "BIMETAL": "something composed of two metals [n -S]\n",
  "BIMETALLIC": "using a double metallic standard (as gold and silver) [adj] / a bimetallic monetary system [n -S]\n",
  "BIMETALLICS": "BIMETALLIC, a bimetallic monetary system [n]\n",
  "BIMETALLISM": "currency exchange on both the gold and silver standards [n -S]\n",
  "BIMETALLISMS": "BIMETALLISM, currency exchange on both the gold and silver standards [n]\n",
  "BIMETALLIST": "a practitioner of bimetallism [n -S]\n",
  "BIMETALLISTIC": "relating to bimetallism [adj]\n",
  "BIMETALLISTS": "BIMETALLIST, a practitioner of bimetallism [n]\n",
  "BIMETALS": "BIMETAL, something composed of two metals [n]\n",
  "BIMETHYL": "ethane [n -S]\n",
  "BIMETHYLS": "BIMETHYL, ethane [n]\n",
  "BIMILLENARIES": "BIMILLENARY, a two thousandth anniversary [n]\n",
  "BIMILLENARY": "happening every two thousand years [adj] / a two thousandth anniversary [n BIMILLENARIES]\n",
  "BIMILLENNIA": "BIMILLENNIUM, (Latin) a period of two thousand years [n]\n",
  "BIMILLENNIAL": "an anniversary recurring every two thousand years [n -S]\n",
  "BIMILLENNIALS": "BIMILLENNIAL, an anniversary recurring every two thousand years [n]\n",
  "BIMILLENNIUM": "(Latin) a period of two thousand years [n BIMILLENNIUMS or BIMILLENNIA]\n",
  "BIMILLENNIUMS": "BIMILLENNIUM, (Latin) a period of two thousand years [n]\n",
  "BIMINI": "a kind of awning for a yacht [n -S]\n",
  "BIMINIS": "BIMINI, a kind of awning for a yacht [n]\n",
  "BIMODAL": "in statistics, having two modes [adj]\n",
  "BIMODALITIES": "BIMODALITY, the state of being bimodal, having two modes [n]\n",
  "BIMODALITY": "the state of being bimodal, having two modes [n BIMODALITIES]\n",
  "BIMOLECULAR": "having two molecules [adj BIMOLECULARLY]\n",
  "BIMOLECULARLY": "BIMOLECULAR, having two molecules [adv]\n",
  "BIMONTHLIES": "BIMONTHLY, a periodical that comes every other month [n]\n",
  "BIMONTHLY": "occurring once every two months [adj] / a periodical that comes every other month [n BIMONTHLIES]\n",
  "BIMORPH": "a device consisting of two crystals cemented together [n -S]\n",
  "BIMORPHEMIC": "consisting of two morphemes [adj]\n",
  "BIMORPHS": "BIMORPH, a device consisting of two crystals cemented together [n]\n",
  "BIN": "to store in a large receptacle [v BINNED, BINNING, BINS]\n",
  "BINAL": "twofold [adj]\n",
  "BINARIES": "BINARY, a combination of two things [n]\n",
  "BINARISM": "a mode of thought based on oppositions [n -S]\n",
  "BINARISMS": "BINARISM, a mode of thought based on oppositions [n]\n",
  "BINARY": "a combination of two things [n BINARIES]\n",
  "BINATE": "growing in pairs [adj BINATELY]\n",
  "BINATELY": "BINATE, growing in pairs [adv]\n",
  "BINATIONAL": "of or relating to two nations [adj]\n",
  "BINAURAL": "hearing with both ears [adj BINAURALLY]\n",
  "BINAURALLY": "BINAURAL, hearing with both ears [adv]\n",
  "BIND": "to tie, fasten [v BOUND or (archaic) YBOUND, BOUND or (archaic) YBOUNDEN, BINDING, BINDS]\n",
  "BINDABLE": "able to be bound [adj]\n",
  "BINDER": "one who binds [n -S]\n",
  "BINDERIES": "BINDERY, a place where books are bound [n]\n",
  "BINDERS": "BINDER, one who binds [n]\n",
  "BINDERY": "a place where books are bound [n BINDERIES]\n",
  "BINDHI": "(Hindi) a dot worn on the forehead by women in India, also BINDI [n -S]\n",
  "BINDHIS": "BINDHI, (Hindi) a dot worn on the forehead by women in India, also BINDI [n]\n",
  "BINDI": "(Hindi) a dot worn on the forehead by women in India, also BINDHI [n -S]\n",
  "BINDING": "obligatory [adj BINDINGLY] / the cover and fastenings of a book [n -S]\n",
  "BINDINGLY": "BINDING, obligatory [adv]\n",
  "BINDINGNESS": "being binding [n -ES]\n",
  "BINDINGNESSES": "BINDINGNESS, being binding [n]\n",
  "BINDINGS": "BINDING, the cover and fastenings of a book [n]\n",
  "BINDIS": "BINDI, (Hindi) a dot worn on the forehead by women in India, also BINDHI [n]\n",
  "BINDLE": "the bundle in which a hobo carries all his worldly possessions [n -S]\n",
  "BINDLES": "BINDLE, the bundle in which a hobo carries all his worldly possessions [n]\n",
  "BINDS": "BIND, to tie, fasten [v]\n",
  "BINDWEED": "any of various weeds that trail along the ground and twine themselves around other plants [n -S]\n",
  "BINDWEEDS": "BINDWEED, any of various weeds that trail along the ground and twine themselves around other plants [n]\n",
  "BINE": "the flexible shoot of climbing plant, esp. hop [n -S]\n",
  "BINER": "(short for) karabiner, a clip used by climbers [n -S]\n",
  "BINERS": "BINER, (short for) karabiner, a clip used by climbers [n]\n",
  "BINERVATE": "of leaves, having two longitudinal ribs or nerves [adj]\n",
  "BINES": "BINE, the flexible shoot of climbing plant, esp. hop [n]\n",
  "BING": "a heap or pile, as of wood [n -S]\n",
  "BINGE": "to eat or drink to excess [v BINGED, BINGING or BINGEING, BINGES]\n",
  "BINGEABLE": "easy to watch, eat, drink, etc. in large quantities [adj]\n",
  "BINGED": "BINGE, to eat or drink to excess [v]\n",
  "BINGEING": "overindulgence in food or drink [n -S]\n",
  "BINGEINGS": "BINGEING, overindulgence in food or drink [n]\n",
  "BINGER": "someone who binges [n -S]\n",
  "BINGERS": "BINGER, someone who binges [n]\n",
  "BINGES": "BINGE, to eat or drink to excess [v]\n",
  "BINGHI": "(offensive Australian slang) the archetypal aboriginal [n -S]\n",
  "BINGHIS": "BINGHI, (offensive Australian slang) the archetypal aboriginal [n]\n",
  "BINGIES": "BINGY, (Australian slang) the stomach [n]\n",
  "BINGING": "the act of indulging in alcohol etc. [n -S]\n",
  "BINGINGS": "BINGING, the act of indulging in alcohol etc. [n]\n",
  "BINGLE": "to style the hair a particular way, midway between a bob and a shingle [v BINGLED, BINGLING, BINGLES]\n",
  "BINGLED": "BINGLE, to style the hair a particular way, midway between a bob and a shingle [v]\n",
  "BINGLES": "BINGLE, to style the hair a particular way, midway between a bob and a shingle [v]\n",
  "BINGLING": "BINGLE, to style the hair a particular way, midway between a bob and a shingle [v]\n",
  "BINGO": "a lottery-type game [n BINGOS or BINGOES] / to play all seven of one's tiles at Scrabble [v -ED, -ING, -ES]\n",
  "BINGOED": "BINGO, to play all seven of one's tiles at Scrabble [v]\n",
  "BINGOES": "BINGO, a lottery-type game [n]\n",
  "BINGOING": "BINGO, to play all seven of one's tiles at Scrabble [v]\n",
  "BINGOS": "BINGO, a lottery-type game [n]\n",
  "BINGS": "BING, a heap or pile, as of wood [n]\n",
  "BINGY": "(Australian slang) the stomach [n BINGIES]\n",
  "BINIOU": "a small Breton bagpipe [n -S]\n",
  "BINIOUS": "BINIOU, a small Breton bagpipe [n]\n",
  "BINIT": "a unit of computer information [n -S]\n",
  "BINITS": "BINIT, a unit of computer information [n]\n",
  "BINK": "a bench [n -S]\n",
  "BINKS": "BINK, a bench [n]\n",
  "BINMAN": "a refuse disposal man [n BINMEN]\n",
  "BINMEN": "BINMAN, a refuse disposal man [n]\n",
  "BINNACLE": "a casing for a ship's compass, also BITTACLE [n -S]\n",
  "BINNACLES": "BINNACLE, a casing for a ship's compass, also BITTACLE [n]\n",
  "BINNED": "BIN, to store in a large receptacle [v]\n",
  "BINNING": "BIN, to store in a large receptacle [v]\n",
  "BINOCLE": "(French) a telescope for use with both eyes at once [n -S]\n",
  "BINOCLES": "BINOCLE, (French) a telescope for use with both eyes at once [n]\n",
  "BINOCS": "(short for) binoculars [n]\n",
  "BINOCULAR": "with two eyes or eyepieces [adj BINOCULARLY] / a binocular telescope [n -S]\n",
  "BINOCULARITIES": "BINOCULARITY, the state of being binocular [n]\n",
  "BINOCULARITY": "the state of being binocular [n BINOCULARITIES]\n",
  "BINOCULARLY": "BINOCULAR, with two eyes or eyepieces [adv]\n",
  "BINOCULARS": "BINOCULAR, a binocular telescope [n]\n",
  "BINOMIAL": "containing the sum or difference of two terms [adj BINOMIALLY] / a binomial expression [n -S]\n",
  "BINOMIALLY": "BINOMIAL, containing the sum or difference of two terms [adv]\n",
  "BINOMIALS": "BINOMIAL, a binomial expression [n]\n",
  "BINOMINAL": "making use of two names, as the Linnaean nomenclature which names every species by giving first the generic and then the specific name [adj] / a binominal appellation [n -S]\n",
  "BINOMINALS": "BINOMINAL, a binominal appellation [n]\n",
  "BINOVULAR": "relating to or derived from two different ova [adj]\n",
  "BINS": "BIN, to store in a large receptacle [v]\n",
  "BINT": "(slang) a woman [n -S]\n",
  "BINTS": "BINT, (slang) a woman [n]\n",
  "BINTURONG": "(Malay) a small Asiatic civet of the genus Arctilis [n -S]\n",
  "BINTURONGS": "BINTURONG, (Malay) a small Asiatic civet of the genus Arctilis [n]\n",
  "BINUCLEAR": "having two nuclei [adj]\n",
  "BINUCLEATE": "having two nuclei; as, binucleate cells, also BINUCLEATED [adj]\n",
  "BINUCLEATED": "having two nuclei; as, binucleate cells, also BINUCLEATE [adj]\n",
  "BIO": "(short for) a biography [n -S]\n",
  "BIOACCUMULATE": "to accumulate in a biological system over time [v BIOACCUMULATED, BIOACCUMULATING, BIOACCUMULATES]\n",
  "BIOACCUMULATED": "BIOACCUMULATE, to accumulate in a biological system over time [v]\n",
  "BIOACCUMULATES": "BIOACCUMULATE, to accumulate in a biological system over time [v]\n",
  "BIOACCUMULATING": "BIOACCUMULATE, to accumulate in a biological system over time [v]\n",
  "BIOACCUMULATION": "accumulation in a biological system over time [n]\n",
  "BIOACOUSTICS": "a branch of science concerned with the production of sound by and its effects on living organisms [n]\n",
  "BIOACTIVE": "having an effect on a living organism [adj]\n",
  "BIOACTIVITIES": "BIOACTIVITY, the state of being bioactive [n]\n",
  "BIOACTIVITY": "the state of being bioactive [n BIOACTIVITIES]\n",
  "BIOAERATION": "the oxidative treatment of raw sewage by aeration [n -S]\n",
  "BIOAERATIONS": "BIOAERATION, the oxidative treatment of raw sewage by aeration [n]\n",
  "BIOAERONAUTICS": "the use of aircraft in the discovery, development, and protection of natural and biological resources [n]\n",
  "BIOARCHAEOLOGY": "the branch of archaeology that deals with the remains of living things [n]\n",
  "BIOASSAY": "to test the strength and effect of a drug on a living organism [v -ED, -ING, -S]\n",
  "BIOASSAYED": "BIOASSAY, to test the strength and effect of a drug on a living organism [v]\n",
  "BIOASSAYING": "BIOASSAY, to test the strength and effect of a drug on a living organism [v]\n",
  "BIOASSAYS": "BIOASSAY, to test the strength and effect of a drug on a living organism [v]\n",
  "BIOASTRONAUTICS": "the science dealing with the effects of travel in space on living organisms [n]\n",
  "BIOASTRONOMIES": "BIOASTRONOMY, the branch of biology which deals with the study or the discovery of life forms on other planets or in space [n]\n",
  "BIOASTRONOMY": "the branch of biology which deals with the study or the discovery of life forms on other planets or in space [n BIOASTRONOMIES]\n",
  "BIOAVAILABILITY": "the degree and rate at which a substance (as a drug) is absorbed into a living system or is made available at the site of physiological activity [n]\n",
  "BIOAVAILABLE": "relating to bioavailability [adj]\n",
  "BIOBANK": "any large store of human biological samples for research into the genetic and environmental causes of diseases [n -S]\n",
  "BIOBANKING": "the practice of creating large-scale repositories of human biological material (e.g. blood, urine, tissue samples, DNA, etc.) designed to further medical research [n -S]\n",
  "BIOBANKINGS": "BIOBANKING, the practice of creating large-scale repositories of human biological material (e.g. blood, urine, tissue samples, DNA, etc.) designed to further medical research [n]\n",
  "BIOBANKS": "BIOBANK, any large store of human biological samples for research into the genetic and environmental causes of diseases [n]\n",
  "BIOBLAST": "a tiny granule of protoplasm [n -S]\n",
  "BIOBLASTS": "BIOBLAST, a tiny granule of protoplasm [n]\n",
  "BIOCATALYST": "a substance, e.g. an enzyme, that produces or speeds up a biochemical reaction [n -S]\n",
  "BIOCATALYSTS": "BIOCATALYST, a substance, e.g. an enzyme, that produces or speeds up a biochemical reaction [n]\n",
  "BIOCATALYTIC": "of or like a biocatalyst [adj]\n",
  "BIOCELLATE": "of animals and plants, marked with two eyelike spots or ocelli [adj]\n",
  "BIOCENOLOGIES": "BIOCENOLOGY, the branch of ecology concerned with the relationships and interactions between the members of a natural community [n]\n",
  "BIOCENOLOGY": "the branch of ecology concerned with the relationships and interactions between the members of a natural community [n BIOCENOLOGIES]\n",
  "BIOCENOSE": "living together in mutual dependence [adj]\n",
  "BIOCENOSES": "BIOCENOSIS, an association of organisms ecologically interdependent, also BIOCOENOSIS [n]\n",
  "BIOCENOSIS": "an association of organisms ecologically interdependent, also BIOCOENOSIS [n BIOCENOSES]\n",
  "BIOCENOTIC": "relating to a biocenosis, a state of association of creatures in a certain region, also BIOCOENOTIC [adj]\n",
  "BIOCHEMIC": "relating to the chemistry of living things, also BIOCHEMICAL [adj]\n",
  "BIOCHEMICAL": "of or relating to biochemistry, also BIOCHEMIC [adj BIOCHEMICALLY] / a chemical of biological origin [n -S]\n",
  "BIOCHEMICALLY": "BIOCHEMICAL, of or relating to biochemistry, also BIOCHEMIC [adv]\n",
  "BIOCHEMICALS": "BIOCHEMICAL, a chemical of biological origin [n]\n",
  "BIOCHEMIST": "a chemist specialising in the chemistry of living things [n -S]\n",
  "BIOCHEMISTRIES": "BIOCHEMISTRY, chemistry that deals with the chemical compounds and processes occurring in organisms [n]\n",
  "BIOCHEMISTRY": "chemistry that deals with the chemical compounds and processes occurring in organisms [n BIOCHEMISTRIES]\n",
  "BIOCHEMISTS": "BIOCHEMIST, a chemist specialising in the chemistry of living things [n]\n",
  "BIOCHIP": "a computer logic circuit whose components are formed from biological molecules or structures [n -S]\n",
  "BIOCHIPS": "BIOCHIP, a computer logic circuit whose components are formed from biological molecules or structures [n]\n",
  "BIOCIDAL": "killing living material [adj]\n",
  "BIOCIDE": "a substance that kills living material [n -S]\n",
  "BIOCIDES": "BIOCIDE, a substance that kills living material [n]\n",
  "BIOCLASTIC": "of deposits, esp. limestones, derived from shell fragments or similar organic remains [adj]\n",
  "BIOCLEAN": "free of harmful organisms [adj]\n",
  "BIOCLIMATIC": "of or relating to the relations of climate and living matter [adj]\n",
  "BIOCLIMATOLOGY": "the study of the effect of weather and climate on plants, animals and man [n]\n",
  "BIOCOENOLOGIES": "BIOCOENOLOGY, the study of biocoenoses [n]\n",
  "BIOCOENOLOGY": "the study of biocoenoses [n BIOCOENOLOGIES]\n",
  "BIOCOENOSES": "BIOCOENOSIS, a state of association of creatures in a certain region, also BIOCENOSIS [n]\n",
  "BIOCOENOSIS": "a state of association of creatures in a certain region, also BIOCENOSIS [n BIOCOENOSES]\n",
  "BIOCOENOTIC": "ecological, also BIOCENOTIC [adj]\n",
  "BIOCOMPATIBLE": "compatible with and not harmful to living tissue [adj]\n",
  "BIOCOMPUTING": "the application of computers to problems in biology and biochemistry [n -S]\n",
  "BIOCOMPUTINGS": "BIOCOMPUTING, the application of computers to problems in biology and biochemistry [n]\n",
  "BIOCONTROL": "pest control by biological means e.g. cane toads [n -S]\n",
  "BIOCONTROLS": "BIOCONTROL, pest control by biological means e.g. cane toads [n]\n",
  "BIOCONVERSION": "the conversion of organic materials (as wastes) into an energy source (as methane) by processes (as fermentation) involving living organisms [n -S]\n",
  "BIOCONVERSIONS": "BIOCONVERSION, the conversion of organic materials (as wastes) into an energy source (as methane) by processes (as fermentation) involving living organisms [n]\n",
  "BIOCYCLE": "the cycling of chemicals through the biosphere [n -S]\n",
  "BIOCYCLES": "BIOCYCLE, the cycling of chemicals through the biosphere [n]\n",
  "BIODATA": "biographical information [n]\n",
  "BIODEGRADABLE": "a product capable of being broken down esp into innocuous products by the action of living things (as microorganisms) [n -S]\n",
  "BIODEGRADABLES": "BIODEGRADABLE, a product capable of being broken down esp into innocuous products by the action of living things (as microorganisms) [n]\n",
  "BIODEGRADATION": "the state of being biodegraded [n -S]\n",
  "BIODEGRADATIONS": "BIODEGRADATION, the state of being biodegraded [n]\n",
  "BIODEGRADE": "to break down by biological action [v BIODEGRADED, BIODEGRADING, BIODEGRADES]\n",
  "BIODEGRADED": "BIODEGRADE, to break down by biological action [v]\n",
  "BIODEGRADES": "BIODEGRADE, to break down by biological action [v]\n",
  "BIODEGRADING": "BIODEGRADE, to break down by biological action [v]\n",
  "BIODESTRUCTIBLE": "biodegradable [adj]\n",
  "BIODIESEL": "a biofuel for use in diesel engines [n -S]\n",
  "BIODIESELS": "BIODIESEL, a biofuel for use in diesel engines [n]\n",
  "BIODIVERSE": "of an environment, having many different kinds of plants and animals [adj]\n",
  "BIODIVERSITIES": "BIODIVERSITY, the number of species present in a given ecosystem [n]\n",
  "BIODIVERSITY": "the number of species present in a given ecosystem [n BIODIVERSITIES]\n",
  "BIODOT": "a temperature-sensitive device stuck to the skin to monitor depression [n -S]\n",
  "BIODOTS": "BIODOT, a temperature-sensitive device stuck to the skin to monitor depression [n]\n",
  "BIODYNAMIC": "using only organic materials for fertilising and soil conditioning, also BIODYNAMICAL [adj] / a biodynamic system of farming [n -S]\n",
  "BIODYNAMICAL": "relating to biodynamics, the study of the activities of living organisms, also BIODYNAMIC [adj]\n",
  "BIODYNAMICS": "the study of the activities of living organisms [n]\n",
  "BIOECOLOGICAL": "related to bioecology [adj BIOECOLOGICALLY]\n",
  "BIOECOLOGICALLY": "BIOECOLOGICAL, related to bioecology [adv]\n",
  "BIOECOLOGIES": "BIOECOLOGY, the study of interaction of life in the environment [n]\n",
  "BIOECOLOGIST": "a specialist in bioecology [n -S]\n",
  "BIOECOLOGISTS": "BIOECOLOGIST, a specialist in bioecology [n]\n",
  "BIOECOLOGY": "the study of interaction of life in the environment [n BIOECOLOGIES]\n",
  "BIOELECTRIC": "of or relating to electric phenomena in living organisms, also BIOELECTRICAL [adj]\n",
  "BIOELECTRICAL": "of or relating to electric phenomena in living organisms, also BIOELECTRIC [adj]\n",
  "BIOELECTRICITY": "electric phenomena in living organisms [n]\n",
  "BIOENERGETIC": "relating to bioenergetics [adj]\n",
  "BIOENERGETICS": "the biology of energy transformations and energy exchanges (as in photosynthesis) within and between living things and their environments [n]\n",
  "BIOENERGIES": "BIOENERGY, fuel or electricity produced from organic matter [n]\n",
  "BIOENERGY": "fuel or electricity produced from organic matter [n BIOENERGIES]\n",
  "BIOENGINEER": "to engineer life-forms [v -ED, -ING, -S]\n",
  "BIOENGINEERED": "BIOENGINEER, to engineer life-forms [v]\n",
  "BIOENGINEERING": "the engineering of life-forms [n -S]\n",
  "BIOENGINEERINGS": "BIOENGINEERING, the engineering of life-forms [n]\n",
  "BIOENGINEERS": "BIOENGINEER, to engineer life-forms [v]\n",
  "BIOETHANOL": "ethanol produced from fermented plant material, used as a petrol additive or substitute [n -S]\n",
  "BIOETHANOLS": "BIOETHANOL, ethanol produced from fermented plant material, used as a petrol additive or substitute [n]\n",
  "BIOETHIC": "relating to ethical questions in biology [adj]\n",
  "BIOETHICAL": "relating to bioethics, the study of the ethical problems produced by medical research [adj]\n",
  "BIOETHICIST": "a practitioner of bioethics, the study of the ethical problems produced by medical research etc. [n -S]\n",
  "BIOETHICISTS": "BIOETHICIST, a practitioner of bioethics, the study of the ethical problems produced by medical research etc. [n]\n",
  "BIOETHICS": "the study of ethical problems in biology [n]\n",
  "BIOFACT": "an item of biological information [n -S]\n",
  "BIOFACTS": "BIOFACT, an item of biological information [n]\n",
  "BIOFEEDBACK": "a technique for learning control of autonomic body functions in response to monitoring by electronic instruments such as an electrocardiograph [n -S]\n",
  "BIOFEEDBACKS": "BIOFEEDBACK, a technique for learning control of autonomic body functions in response to monitoring by electronic instruments such as an electrocardiograph [n]\n",
  "BIOFIBERS": "vegetable, animal, or mineral fibres existing in nature which are used by man, also BIOFIBRES [n]\n",
  "BIOFIBRES": "vegetable, animal, or mineral fibres existing in nature which are used by man, also BIOFIBERS [n]\n",
  "BIOFILM": "a thin layer of microorganisms [n -S]\n",
  "BIOFILMS": "BIOFILM, a thin layer of microorganisms [n]\n",
  "BIOFLAVONOID": "vitamin P, a vitamin found in citrus fruit, blackcurrants and rosehips, aka citrin [n -S]\n",
  "BIOFLAVONOIDS": "BIOFLAVONOID, vitamin P, a vitamin found in citrus fruit, blackcurrants and rosehips, aka citrin [n]\n",
  "BIOFOULER": "an animal that obstructs or corrupts the environment [n -S]\n",
  "BIOFOULERS": "BIOFOULER, an animal that obstructs or corrupts the environment [n]\n",
  "BIOFOULING": "fouling due to biological agents [n -S]\n",
  "BIOFOULINGS": "BIOFOULING, fouling due to biological agents [n]\n",
  "BIOFUEL": "a fuel (as wood or ethanol) composed of or produced from biological raw materials [n -S]\n",
  "BIOFUELED": "running on biofuels, also BIOFUELLED [adj]\n",
  "BIOFUELLED": "running on biofuel, also BIOFUELED [adj]\n",
  "BIOFUELS": "BIOFUEL, a fuel (as wood or ethanol) composed of or produced from biological raw materials [n]\n",
  "BIOG": "(colloquial) biography, also BIO [n -S]\n",
  "BIOGAS": "gas obtained by bioconversion [n BIOGASES or BIOGASSES]\n",
  "BIOGASES": "BIOGAS, gas obtained by bioconversion [n]\n",
  "BIOGASSES": "BIOGAS, gas obtained by bioconversion [n]\n",
  "BIOGEN": "a hypothetical unit of protoplasm [n -S]\n",
  "BIOGENESES": "BIOGENESIS, the theory that all life is derived from living matter alone [n]\n",
  "BIOGENESIS": "the theory that all life is derived from living matter alone [n BIOGENESES]\n",
  "BIOGENETIC": "pertaining to biogenesis, the theory that all life is derived from living matter alone, also BIOGENETICAL [adj BIOGENETICALLY]\n",
  "BIOGENETICAL": "pertaining to biogenesis, the theory that all life is derived from living matter alone, also BIOGENETIC [adj BIOGENETICALLY]\n",
  "BIOGENETICALLY": "BIOGENETICAL, pertaining to biogenesis, the theory that all life is derived from living matter alone, also BIOGENETIC [adv]\n",
  "BIOGENETICS": "the direct manipulation of an organism's genes [n]\n",
  "BIOGENIC": "relating to biogens [adj]\n",
  "BIOGENIES": "BIOGENY, the development of life from preexisting life [n]\n",
  "BIOGENOUS": "parasitic; biogenic [adj]\n",
  "BIOGENS": "BIOGEN, a hypothetical unit of protoplasm [n]\n",
  "BIOGENY": "the development of life from preexisting life [n BIOGENIES]\n",
  "BIOGEOCHEMICAL": "relating to biogeochemistry, the science of plants and animals in relation to chemicals in the soil [adj]\n",
  "BIOGEOCHEMICALS": "the science of plants and animals in relation to chemicals in the soil [n]\n",
  "BIOGEOCHEMISTRY": "the science of plants and animals in relation to chemicals in the soil [n]\n",
  "BIOGEOGRAPHER": "a practitioner of biogeography [n -S]\n",
  "BIOGEOGRAPHERS": "BIOGEOGRAPHER, a practitioner of biogeography [n]\n",
  "BIOGEOGRAPHIC": "relating to biogeography, also BIOGEOGRAPHICAL [adj]\n",
  "BIOGEOGRAPHICAL": "relating to biogeography, also BIOGEOGRAPHIC [adj]\n",
  "BIOGEOGRAPHIES": "BIOGEOGRAPHY, the study of the geographical distribution of plants and animals [n]\n",
  "BIOGEOGRAPHY": "the study of the geographical distribution of plants and animals [n BIOGEOGRAPHIES]\n",
  "BIOGRAPH": "to write a biography of [v -ED, -ING, -S]\n",
  "BIOGRAPHED": "BIOGRAPH, to write a biography of [v]\n",
  "BIOGRAPHEE": "a person about whom a biography is written [n -S]\n",
  "BIOGRAPHEES": "BIOGRAPHEE, a person about whom a biography is written [n]\n",
  "BIOGRAPHER": "a writer of a biography [n -S]\n",
  "BIOGRAPHERS": "BIOGRAPHER, a writer of a biography [n]\n",
  "BIOGRAPHIC": "relating to biography, also BIOGRAPHICAL [adj BIOGRAPHICALLY]\n",
  "BIOGRAPHICAL": "relating to biography, also BIOGRAPHIC [adj BIOGRAPHICALLY]\n",
  "BIOGRAPHICALLY": "BIOGRAPHICAL, relating to biography, also BIOGRAPHIC [adv]\n",
  "BIOGRAPHIES": "BIOGRAPHY, the story of someone's life [n]\n",
  "BIOGRAPHING": "BIOGRAPH, to write a biography of [v]\n",
  "BIOGRAPHISE": "to make the subject of a biography, also BIOGRAPHIZE [v BIOGRAPHISED, BIOGRAPHISING, BIOGRAPHISES]\n",
  "BIOGRAPHISED": "BIOGRAPHISE, to make the subject of a biography, also BIOGRAPHIZE [v]\n",
  "BIOGRAPHISES": "BIOGRAPHISE, to make the subject of a biography, also BIOGRAPHIZE [v]\n",
  "BIOGRAPHISING": "BIOGRAPHISE, to make the subject of a biography, also BIOGRAPHIZE [v]\n",
  "BIOGRAPHIZE": "to make the subject of a biography, also BIOGRAPHISE [v BIOGRAPHIZED, BIOGRAPHIZING, BIOGRAPHIZES]\n",
  "BIOGRAPHIZED": "BIOGRAPHIZE, to make the subject of a biography, also BIOGRAPHISE [v]\n",
  "BIOGRAPHIZES": "BIOGRAPHIZE, to make the subject of a biography, also BIOGRAPHISE [v]\n",
  "BIOGRAPHIZING": "BIOGRAPHIZE, to make the subject of a biography, also BIOGRAPHISE [v]\n",
  "BIOGRAPHS": "BIOGRAPH, to write a biography of [v]\n",
  "BIOGRAPHY": "the story of someone's life [n BIOGRAPHIES]\n",
  "BIOGS": "BIOG, (colloquial) biography, also BIO [n]\n",
  "BIOHACKER": "one who engages in biohacking [n -S]\n",
  "BIOHACKERS": "BIOHACKER, one who engages in biohacking [n]\n",
  "BIOHAZARD": "a danger of disease or pollution from living organisms [n -S]\n",
  "BIOHAZARDOUS": "of or like a biohazard [adj]\n",
  "BIOHAZARDS": "BIOHAZARD, a danger of disease or pollution from living organisms [n]\n",
  "BIOHERM": "a mound of material laid down by sedentary marine organisms, esp. a coral reef [n -S]\n",
  "BIOHERMS": "BIOHERM, a mound of material laid down by sedentary marine organisms, esp. a coral reef [n]\n",
  "BIOINDUSTRIES": "BIOINDUSTRY, industry centred on biological products [n]\n",
  "BIOINDUSTRY": "industry centred on biological products [n BIOINDUSTRIES]\n",
  "BIOINFORMATICS": "the branch of information science dealing with large databases of biochemical or pharmaceutical information [n]\n",
  "BIOLOGIC": "related to biology [adj BIOLOGICALLY] / a biological product used in medicine [n -S]\n",
  "BIOLOGICAL": "relating to biology [adj BIOLOGICALLY] / a drug of biological origin [n -S]\n",
  "BIOLOGICALLY": "BIOLOGICAL, relating to biology [adv]\n",
  "BIOLOGICALS": "BIOLOGICAL, a drug of biological origin [n]\n",
  "BIOLOGICS": "BIOLOGIC, a biological product used in medicine [n]\n",
  "BIOLOGIES": "BIOLOGY, the science of life [n]\n",
  "BIOLOGISM": "biological theory; the use of biological terms [n -S]\n",
  "BIOLOGISMS": "BIOLOGISM, biological theory; the use of biological terms [n]\n",
  "BIOLOGIST": "one who studies biology [n -S]\n",
  "BIOLOGISTIC": "relating to biologism [adj]\n",
  "BIOLOGISTS": "BIOLOGIST, one who studies biology [n]\n",
  "BIOLOGY": "the science of life [n BIOLOGIES]\n",
  "BIOLUMINESCENCE": "the emission of light from living organisms [n]\n",
  "BIOLUMINESCENT": "relating to bioluminescence [adj]\n",
  "BIOLYSES": "BIOLYSIS, the breakdown of organic matter by bacteria [n]\n",
  "BIOLYSIS": "the breakdown of organic matter by bacteria [n BIOLYSES]\n",
  "BIOLYTIC": "relating to biolysis, the destruction of life [adj]\n",
  "BIOMAGNETICS": "a type of magnetic therapy in which small magnets are placed on acupuncture points [n]\n",
  "BIOMARKER": "anything that might indicate the presence of a disease or pathological condition [n -S]\n",
  "BIOMARKERS": "BIOMARKER, anything that might indicate the presence of a disease or pathological condition [n]\n",
  "BIOMASS": "the total mass of living material in an ecosystem [n -ES]\n",
  "BIOMASSES": "BIOMASS, the total mass of living material in an ecosystem [n]\n",
  "BIOMATERIAL": "suitable synthetic material from which to produce artificial body parts that are to be in direct contact with living tissue [n -S]\n",
  "BIOMATERIALS": "BIOMATERIAL, suitable synthetic material from which to produce artificial body parts that are to be in direct contact with living tissue [n]\n",
  "BIOMATHEMATICAL": "relating to biomathematics, mathematics as applied to the biological sciences [adj]\n",
  "BIOMATHEMATICS": "mathematics as applied to the biological sciences [n]\n",
  "BIOME": "an extensive ecological community, esp. one with a dominant vegetation [n -S]\n",
  "BIOMECHANICAL": "relating to biomechanics [adj BIOMECHANICALLY]\n",
  "BIOMECHANICALLY": "BIOMECHANICAL, relating to biomechanics [adv]\n",
  "BIOMECHANICS": "the mechanics of biological and esp. muscular activity [n]\n",
  "BIOMEDICAL": "relating to both biology and medicine [adj]\n",
  "BIOMEDICINE": "medicine based on the application of the principles of the natural sciences and esp. biology and biochemistry [n -S]\n",
  "BIOMEDICINES": "BIOMEDICINE, medicine based on the application of the principles of the natural sciences and esp. biology and biochemistry [n]\n",
  "BIOMES": "BIOME, an extensive ecological community, esp. one with a dominant vegetation [n]\n",
  "BIOMETEOROLOGY": "the study of how the weather affects people [n]\n",
  "BIOMETER": "a device for measuring carbon dioxide given off by living matter [n -S]\n",
  "BIOMETERS": "BIOMETER, a device for measuring carbon dioxide given off by living matter [n]\n",
  "BIOMETRIC": "relating to biometry, the statistical analysis of biological observations and phenomena, also BIOMETRICAL [adj BIOMETRICALLY]\n",
  "BIOMETRICAL": "relating to biometry, the statistical analysis of biological observations and phenomena, also BIOMETRIC [adj BIOMETRICALLY]\n",
  "BIOMETRICALLY": "BIOMETRICAL, relating to biometry, the statistical analysis of biological observations and phenomena, also BIOMETRIC [adv]\n",
  "BIOMETRICIAN": "a practitioner of biometrics [n -S]\n",
  "BIOMETRICIANS": "BIOMETRICIAN, a practitioner of biometrics [n]\n",
  "BIOMETRICS": "the study of biological measurement [n]\n",
  "BIOMETRIES": "BIOMETRY, the statistical study of biological data [n]\n",
  "BIOMETRY": "the statistical study of biological data [n BIOMETRIES]\n",
  "BIOMIMETIC": "relating to biomimetics, the science of deriving useful structures and processes from the study of natural parallels [adj]\n",
  "BIOMIMETICS": "the science of deriving useful structures and processes from the study of natural parallels e.g. Velcro from plant burrs [n]\n",
  "BIOMIMICRIES": "BIOMIMICRY, the mimicry of one living organism by another [n]\n",
  "BIOMIMICRY": "the mimicry of one living organism by another [n BIOMIMICRIES]\n",
  "BIOMINING": "microbiological mining [n -S]\n",
  "BIOMININGS": "BIOMINING, microbiological mining [n]\n",
  "BIOMOLECULAR": "relating to biomolecules [adj]\n",
  "BIOMOLECULE": "an organic molecule and esp. a macromolecule (as a protein or nucleic acid) in living organisms [n -S]\n",
  "BIOMOLECULES": "BIOMOLECULE, an organic molecule and esp. a macromolecule (as a protein or nucleic acid) in living organisms [n]\n",
  "BIOMORPH": "a representation of a living thing as decoration [n -S]\n",
  "BIOMORPHIC": "of or like a biomorph, a representation of a living thing as decoration [adj]\n",
  "BIOMORPHS": "BIOMORPH, a representation of a living thing as decoration [n]\n",
  "BIONIC": "relating to bionics, esp. in the context of parts of the body replaced by electronic components [adj]\n",
  "BIONICS": "the study of the replacement of parts of the body by electronic components [n]\n",
  "BIONOMIC": "relating to bionomics [adj BIONOMICALLY]\n",
  "BIONOMICALLY": "BIONOMIC, relating to bionomics [adv]\n",
  "BIONOMICS": "the study of organisms interacting in their environments [n]\n",
  "BIONOMIES": "BIONOMY, physiology [n]\n",
  "BIONOMIST": "a student of bionomics, the study of organisms interacting in their environments [n -S]\n",
  "BIONOMISTS": "BIONOMIST, a student of bionomics, the study of organisms interacting in their environments [n]\n",
  "BIONOMY": "physiology [n BIONOMIES]\n",
  "BIONT": "a physiologically independent living organism [n -S]\n",
  "BIONTIC": "of or like a biont, a living organism [adj]\n",
  "BIONTS": "BIONT, a physiologically independent living organism [n]\n",
  "BIOPARENT": "a biological parent, not a stepparent [n -S]\n",
  "BIOPARENTS": "BIOPARENT, a biological parent, not a stepparent [n]\n",
  "BIOPESTICIDAL": "of or like a biopesticide [adj]\n",
  "BIOPESTICIDE": "a biological pesticide [n -S]\n",
  "BIOPESTICIDES": "BIOPESTICIDE, a biological pesticide [n]\n",
  "BIOPHILIA": "innate love for the natural world, supposed to be felt by all mankind [n -S]\n",
  "BIOPHILIAS": "BIOPHILIA, innate love for the natural world, supposed to be felt by all mankind [n]\n",
  "BIOPHOR": "a hypothetical unit of living matter, also BIOPHORE [n -S]\n",
  "BIOPHORE": "a hypothetical unit of living matter, also BIOPHOR [n -S]\n",
  "BIOPHORES": "BIOPHORE, a hypothetical unit of living matter, also BIOPHOR [n]\n",
  "BIOPHORS": "BIOPHOR, a hypothetical unit of living matter, also BIOPHORE [n]\n",
  "BIOPHYSICAL": "relating to biophysics [adj BIOPHYSICALLY]\n",
  "BIOPHYSICALLY": "BIOPHYSICAL, relating to biophysics [adv]\n",
  "BIOPHYSICIST": "a practitioner of biophysics [n -S]\n",
  "BIOPHYSICISTS": "BIOPHYSICIST, a practitioner of biophysics [n]\n",
  "BIOPHYSICS": "the science of the application of the laws of physics to biological phenomena [n]\n",
  "BIOPIC": "a film telling the life-story of a celebrity [n -S]\n",
  "BIOPICS": "BIOPIC, a film telling the life-story of a celebrity [n]\n",
  "BIOPIRACIES": "BIOPIRACY, the use of wild plants by international corporations to develop drugs without recompensing the countries from which they are taken [n]\n",
  "BIOPIRACY": "the use of wild plants by international corporations to develop drugs without recompensing the countries from which they are taken [n BIOPIRACIES]\n",
  "BIOPIRATE": "one who practises biopiracy [n -S]\n",
  "BIOPIRATES": "BIOPIRATE, one who practises biopiracy [n]\n",
  "BIOPLASM": "living matter [n -S]\n",
  "BIOPLASMIC": "pertaining to, or consisting of, bioplasm [adj]\n",
  "BIOPLASMS": "BIOPLASM, living matter [n]\n",
  "BIOPLAST": "a tiny mass of bioplasm, in itself a living unit and having formative power, as a living white blood corpuscle, also BIOBLAST [n -S]\n",
  "BIOPLASTIC": "a plastic that is made from organic matter rather than oil [n -S]\n",
  "BIOPLASTICS": "BIOPLASTIC, a plastic that is made from organic matter rather than oil [n]\n",
  "BIOPLASTS": "BIOPLAST, a tiny mass of bioplasm, in itself a living unit and having formative power, as a living white blood corpuscle, also BIOBLAST [n]\n",
  "BIOPLAY": "a play based on the life of a famous person, esp. one giving a popular treatment [n -S]\n",
  "BIOPLAYS": "BIOPLAY, a play based on the life of a famous person, esp. one giving a popular treatment [n]\n",
  "BIOPOIESES": "BIOPOIESIS, the creation of living from nonliving material as an evolutionary process [n]\n",
  "BIOPOIESIS": "the creation of living from nonliving material as an evolutionary process [n BIOPOIESES]\n",
  "BIOPOLYMER": "a polymeric substance formed in a biological system [n -S]\n",
  "BIOPOLYMERS": "BIOPOLYMER, a polymeric substance formed in a biological system [n]\n",
  "BIOPRINTING": "the construction of replacement body parts using techniques developed for three-dimensional printing [n -S]\n",
  "BIOPRINTINGS": "BIOPRINTING, the construction of replacement body parts using techniques developed for three-dimensional printing [n]\n",
  "BIOPRIVACIES": "BIOPRIVACY, the state of freedom from others having unauthorized access to biometric data about oneself [n]\n",
  "BIOPRIVACY": "the state of freedom from others having unauthorized access to biometric data about oneself [n BIOPRIVACIES]\n",
  "BIOPROSPECTING": "the exploitation of traditional medicines [n -S]\n",
  "BIOPROSPECTINGS": "BIOPROSPECTING, the exploitation of traditional medicines [n]\n",
  "BIOPSIC": "relating to a biopsy [adj]\n",
  "BIOPSIED": "BIOPSY, to examine tissue from a living body [v]\n",
  "BIOPSIES": "BIOPSY, to examine tissue from a living body [v]\n",
  "BIOPSY": "to examine tissue from a living body [v BIOPSIED, BIOPSYING, BIOPSIES]\n",
  "BIOPSYCHOLOGIES": "BIOPSYCHOLOGY, the branch of psychology, or of biology, which deals with the interaction of mind and body, and the effects of this interaction [n]\n",
  "BIOPSYCHOLOGY": "the branch of psychology, or of biology, which deals with the interaction of mind and body, and the effects of this interaction [n BIOPSYCHOLOGIES]\n",
  "BIOPSYING": "BIOPSY, to examine tissue from a living body [v]\n",
  "BIOPTIC": "relating to biopsy [adj]\n",
  "BIOREACTOR": "a device or apparatus in which living organisms, such as bacteria, synthesise useful substances or break down waste [n -S]\n",
  "BIOREACTORS": "BIOREACTOR, a device or apparatus in which living organisms, such as bacteria, synthesise useful substances or break down waste [n]\n",
  "BIOREAGENT": "a biological agent that reacts [n -S]\n",
  "BIOREAGENTS": "BIOREAGENT, a biological agent that reacts [n]\n",
  "BIOREGION": "an area in which climate and environment are consistent [n -S]\n",
  "BIOREGIONAL": "relating to a bioregion [adj]\n",
  "BIOREGIONALISM": "an environmentalist movement to make political boundaries coincide with bioregions [n -S]\n",
  "BIOREGIONALISMS": "BIOREGIONALISM, an environmentalist movement to make political boundaries coincide with bioregions [n]\n",
  "BIOREGIONALIST": "one who studies bioregionalism [n -S]\n",
  "BIOREGIONALISTS": "BIOREGIONALIST, one who studies bioregionalism [n]\n",
  "BIOREGIONS": "BIOREGION, an area in which climate and environment are consistent [n]\n",
  "BIOREMEDIATION": "the treatment of pollutants or waste (as in an oil spill, contaminated groundwater, or an industrial process) by the use of microorganisms (as bacteria) that break down the undesirable substances [n -S]\n",
  "BIOREMEDIATIONS": "BIOREMEDIATION, the treatment of pollutants or waste (as in an oil spill, contaminated groundwater, or an industrial process) by the use of microorganisms (as bacteria) that break down the undesirable substances [n]\n",
  "BIORHYTHM": "a periodic change in the behaviour or physiology of many animals and plants (e.g. hibernation and migration) mediated by hormones which are in turn influenced by changes in day-length [n -S]\n",
  "BIORHYTHMIC": "relating to biorhythms [adj BIORHYTHMICALLY]\n",
  "BIORHYTHMICALLY": "BIORHYTHMIC, relating to biorhythms [adv]\n",
  "BIORHYTHMICS": "the study of biorhythms [n]\n",
  "BIORHYTHMS": "BIORHYTHM, a periodic change in the behaviour or physiology of many animals and plants (e.g. hibernation and migration) mediated by hormones which are in turn influenced by changes in day-length [n]\n",
  "BIOS": "BIO, (short for) a biography [n]\n",
  "BIOSAFETIES": "BIOSAFETY, safety with respect to the effects of biological research [n]\n",
  "BIOSAFETY": "safety with respect to the effects of biological research [n BIOSAFETIES]\n",
  "BIOSATELLITE": "an artificial satellite containing living organisms to be studied during flight [n -S]\n",
  "BIOSATELLITES": "BIOSATELLITE, an artificial satellite containing living organisms to be studied during flight [n]\n",
  "BIOSCIENCE": "any one of the biological sciences [n -S]\n",
  "BIOSCIENCES": "BIOSCIENCE, any one of the biological sciences [n]\n",
  "BIOSCIENTIFIC": "relating to bioscience [adj]\n",
  "BIOSCIENTIST": "a practitioner of bioscience [n -S]\n",
  "BIOSCIENTISTS": "BIOSCIENTIST, a practitioner of bioscience [n]\n",
  "BIOSCOPE": "an early movie projector [n -S]\n",
  "BIOSCOPES": "BIOSCOPE, an early movie projector [n]\n",
  "BIOSCOPIES": "BIOSCOPY, a type of medical examination [n]\n",
  "BIOSCOPY": "a type of medical examination [n BIOSCOPIES]\n",
  "BIOSENSOR": "a living organism used to detect the presence of chemicals [n -S]\n",
  "BIOSENSORS": "BIOSENSOR, a living organism used to detect the presence of chemicals [n]\n",
  "BIOSOCIAL": "relating to the interaction of the biological aspects and social relationships of living organisms [adj BIOSOCIALLY]\n",
  "BIOSOCIALLY": "BIOSOCIAL, relating to the interaction of the biological aspects and social relationships of living organisms [adv]\n",
  "BIOSOLID": "solid organic matter obtained from treated sewage [n -S]\n",
  "BIOSOLIDS": "BIOSOLID, solid organic matter obtained from treated sewage [n]\n",
  "BIOSPHERE": "the plant and animal life on the earth [n -S]\n",
  "BIOSPHERES": "BIOSPHERE, the plant and animal life on the earth [n]\n",
  "BIOSPHERIC": "relating to the biosphere, the plant and animal life on the earth [adj]\n",
  "BIOSTABLE": "not affected by the biological environment [adj]\n",
  "BIOSTATIC": "of or relating to the branch of biology that deals with the structure of organisms in relation to their function [adj BIOSTATICALLY]\n",
  "BIOSTATICALLY": "BIOSTATIC, of or relating to the branch of biology that deals with the structure of organisms in relation to their function [adv]\n",
  "BIOSTATICS": "the branch of biology that deals with the structure of organisms in relation to their function [n]\n",
  "BIOSTATISTICAL": "relating to biostatistics [adj]\n",
  "BIOSTATISTICIAN": "one who studies biostatistics [n]\n",
  "BIOSTATISTICS": "statistics applied to the analysis of biological data [n]\n",
  "BIOSTRATIGRAPHY": "the determination of age, etc., of sedimentary strata from fossils which they contain [n]\n",
  "BIOSTROME": "a rock layer consisting of a deposit of organic material such as fossils [n -S]\n",
  "BIOSTROMES": "BIOSTROME, a rock layer consisting of a deposit of organic material such as fossils [n]\n",
  "BIOSURGERIES": "BIOSURGERY, medical treatment with living agents e.g. maggots to clean wounds [n]\n",
  "BIOSURGERY": "medical treatment with living agents e.g. maggots to clean wounds [n BIOSURGERIES]\n",
  "BIOSYNTHESES": "BIOSYNTHESIS, the production of a chemical compound by a living organism [n]\n",
  "BIOSYNTHESIS": "the production of a chemical compound by a living organism [n BIOSYNTHESES]\n",
  "BIOSYNTHETIC": "relating to biosynthesis [adj]\n",
  "BIOSYSTEMATIC": "relating to taxonomy esp. as based on cytogenetics and genetics [adj]\n",
  "BIOSYSTEMATICS": "taxonomy esp. as based on cytogenetics and genetics [n]\n",
  "BIOSYSTEMATIST": "one who studies biosystematics [n -S]\n",
  "BIOSYSTEMATISTS": "BIOSYSTEMATIST, one who studies biosystematics [n]\n",
  "BIOTA": "(Greek) the flora and fauna of a region [n -S]\n",
  "BIOTAS": "BIOTA, (Greek) the flora and fauna of a region [n]\n",
  "BIOTECH": "applied biological science [n -S]\n",
  "BIOTECHNICAL": "of or relating to biotechnology [adj]\n",
  "BIOTECHNOLOGIES": "BIOTECHNOLOGY, the utilisation of living organisms in industry [n]\n",
  "BIOTECHNOLOGIST": "one who studies biotechnology [n]\n",
  "BIOTECHNOLOGY": "the utilisation of living organisms in industry [n BIOTECHNOLOGIES]\n",
  "BIOTECHS": "BIOTECH, applied biological science [n]\n",
  "BIOTELEMETRIC": "relating to biotelemetry [adj]\n",
  "BIOTELEMETRIES": "BIOTELEMETRY, automatic transmission over a distance, for measurements of the condition, functions, etc., of a living creature, e.g. of an astronaut on space flight [n]\n",
  "BIOTELEMETRY": "automatic transmission over a distance, for measurements of the condition, functions, etc., of a living creature, e.g. of an astronaut on space flight [n]\n",
  "BIOTERROR": "use of biological weapons by terrorists [n -S]\n",
  "BIOTERRORS": "BIOTERROR, use of biological weapons by terrorists [n]\n",
  "BIOTIC": "relating to living organisms, also BIOTICAL [adj BIOTICALLY]\n",
  "BIOTICAL": "relating to living organisms, also BIOTIC [adj BIOTICALLY]\n",
  "BIOTICALLY": "BIOTICAL, relating to living organisms, also BIOTIC [adv]\n",
  "BIOTICS": "the science of living organisms [n]\n",
  "BIOTIN": "a growth-promoting vitamin of the vitamin B complex, found in liver and yeast [n -S]\n",
  "BIOTINS": "BIOTIN, a growth-promoting vitamin of the vitamin B complex, found in liver and yeast [n]\n",
  "BIOTITE": "mica containing iron and magnesia, generally of a black or dark green color [n -S]\n",
  "BIOTITES": "BIOTITE, mica containing iron and magnesia, generally of a black or dark green color [n]\n",
  "BIOTITIC": "of or like biotite, a kind of mica [adj]\n",
  "BIOTOPE": "an area having uniform conditions and supporting a particular, uniform association of animal life [n -S]\n",
  "BIOTOPES": "BIOTOPE, an area having uniform conditions and supporting a particular, uniform association of animal life [n]\n",
  "BIOTOXIN": "a poison of biological origin [n -S]\n",
  "BIOTOXINS": "BIOTOXIN, a poison of biological origin [n]\n",
  "BIOTRON": "a climate control chamber [n -S]\n",
  "BIOTRONS": "BIOTRON, a climate control chamber [n]\n",
  "BIOTROPH": "a parasitic organism such as a fungus [n -S]\n",
  "BIOTROPHS": "BIOTROPH, a parasitic organism such as a fungus [n]\n",
  "BIOTURBATION": "the restructuring of sedimentary deposits (as in a lake bottom or seabed) by moving organisms (as worms and burrowing clams) [n -S]\n",
  "BIOTURBATIONS": "BIOTURBATION, the restructuring of sedimentary deposits (as in a lake bottom or seabed) by moving organisms (as worms and burrowing clams) [n]\n",
  "BIOTURBED": "stirred by organisms [adj]\n",
  "BIOTYPE": "a set of organisms having the same genetic constitution [n -S]\n",
  "BIOTYPES": "BIOTYPE, a set of organisms having the same genetic constitution [n]\n",
  "BIOTYPIC": "relating to a biotype, a set of organisms having the same genetic constitution [adj]\n",
  "BIOVULAR": "derived from two ova [adj]\n",
  "BIOWASTE": "waste composed chiefly of organic matter [n -S]\n",
  "BIOWASTES": "BIOWASTE, waste composed chiefly of organic matter [n]\n",
  "BIOWEAPON": "a biological weapon [n -S]\n",
  "BIOWEAPONS": "BIOWEAPON, a biological weapon [n]\n",
  "BIPACK": "a pair of films [n -S]\n",
  "BIPACKS": "BIPACK, a pair of films [n]\n",
  "BIPARENTAL": "relating to or derived from two parents [adj BIPARENTALLY]\n",
  "BIPARENTALLY": "BIPARENTAL, relating to or derived from two parents [adv]\n",
  "BIPARIETAL": "relating to or connected to both parietal bones [adj]\n",
  "BIPAROUS": "producing offspring in twos [adj]\n",
  "BIPARTED": "having two parts [adj]\n",
  "BIPARTISAN": "of, relating to, or involving members of two parties [adj]\n",
  "BIPARTISANISM": "the state of being bipartisan [n -S]\n",
  "BIPARTISANISMS": "BIPARTISANISM, the state of being bipartisan [n]\n",
  "BIPARTISANSHIP": "the state of being bipartisan [n -S]\n",
  "BIPARTISANSHIPS": "BIPARTISANSHIP, the state of being bipartisan [n]\n",
  "BIPARTITE": "being in two parts e.g. of a document [adj BIPARTITELY]\n",
  "BIPARTITELY": "BIPARTITE, being in two parts e.g. of a document [adv]\n",
  "BIPARTITION": "division into two parts [n -S]\n",
  "BIPARTITIONS": "BIPARTITION, division into two parts [n]\n",
  "BIPARTY": "of two parties [adj]\n",
  "BIPED": "an animal with two feet [n -S]\n",
  "BIPEDAL": "having two feet [adj BIPEDALLY]\n",
  "BIPEDALISM": "the state of being bipedal, having two legs [n -S]\n",
  "BIPEDALISMS": "BIPEDALISM, the state of being bipedal, having two legs [n]\n",
  "BIPEDALITIES": "BIPEDALITY, the state of being bipedal, having two legs [n]\n",
  "BIPEDALITY": "the state of being bipedal, having two legs [n BIPEDALITIES]\n",
  "BIPEDALLY": "BIPEDAL, having two feet [adv]\n",
  "BIPEDS": "BIPED, an animal with two feet [n]\n",
  "BIPETALOUS": "having two petals [adj]\n",
  "BIPHASIC": "having two phases [adj]\n",
  "BIPHENYL": "a hydrocarbon consisting of two phenyl groups, used as a fungicide and in dye-manufacture, also DIPHENYL [n -S]\n",
  "BIPHENYLS": "BIPHENYL, a hydrocarbon consisting of two phenyl groups, used as a fungicide and in dye-manufacture, also DIPHENYL [n]\n",
  "BIPINNARIA": "the larva of certain starfishes as developed in the free-swimming stage [n -S]\n",
  "BIPINNARIAS": "BIPINNARIA, the larva of certain starfishes as developed in the free-swimming stage [n]\n",
  "BIPINNATE": "of a compound leaf, pinnately divided, with the leaflets themselves pinnate [adj BIPINNATELY]\n",
  "BIPINNATELY": "BIPINNATE, of a compound leaf, pinnately divided, with the leaflets themselves pinnate [adv]\n",
  "BIPLANE": "a plane with two sets of wings [n -S]\n",
  "BIPLANES": "BIPLANE, a plane with two sets of wings [n]\n",
  "BIPOD": "a two-legged stand [n -S]\n",
  "BIPODS": "BIPOD, a two-legged stand [n]\n",
  "BIPOLAR": "having two poles [adj]\n",
  "BIPOLARISATION": "the act of making bipolar, also BIPOLARIZATION [n -S]\n",
  "BIPOLARISATIONS": "BIPOLARISATION, the act of making bipolar, also BIPOLARIZATION [n]\n",
  "BIPOLARISE": "to make bipolar, also BIPOLARIZE [v BIPOLARISED, BIPOLARISING, BIPOLARISES]\n",
  "BIPOLARISED": "BIPOLARISE, to make bipolar, also BIPOLARIZE [v]\n",
  "BIPOLARISES": "BIPOLARISE, to make bipolar, also BIPOLARIZE [v]\n",
  "BIPOLARISING": "BIPOLARISE, to make bipolar, also BIPOLARIZE [v]\n",
  "BIPOLARITIES": "BIPOLARITY, the state of being bipolar [n]\n",
  "BIPOLARITY": "the state of being bipolar [n BIPOLARITIES]\n",
  "BIPOLARIZATION": "the act of bipolarizing, also BIPOLARISATION [n -S]\n",
  "BIPOLARIZATIONS": "BIPOLARIZATION, the act of bipolarizing, also BIPOLARISATION [n]\n",
  "BIPOLARIZE": "to make bipolar, also BIPOLARISE [v BIPOLARIZED, BIPOLARIZING, BIPOLARIZES]\n",
  "BIPOLARIZED": "BIPOLARIZE, to make bipolar, also BIPOLARISE [v]\n",
  "BIPOLARIZES": "BIPOLARIZE, to make bipolar, also BIPOLARISE [v]\n",
  "BIPOLARIZING": "BIPOLARIZE, to make bipolar, also BIPOLARISE [v]\n",
  "BIPRISM": "a prism having a highly obtuse angle to facilitate beam splitting [n -S]\n",
  "BIPRISMS": "BIPRISM, a prism having a highly obtuse angle to facilitate beam splitting [n]\n",
  "BIPROPELLANT": "a rocket propellant consisting of fuel and oxidizer stored separately until ignition [n -S]\n",
  "BIPROPELLANTS": "BIPROPELLANT, a rocket propellant consisting of fuel and oxidizer stored separately until ignition [n]\n",
  "BIPYRAMID": "a crystal formed of two pyramids base to base [n -S]\n",
  "BIPYRAMIDAL": "in the form of a bipyramid [adj]\n",
  "BIPYRAMIDS": "BIPYRAMID, a crystal formed of two pyramids base to base [n]\n",
  "BIQUADRATE": "the fourth power [n -S]\n",
  "BIQUADRATES": "BIQUADRATE, the fourth power [n]\n",
  "BIQUADRATIC": "a quantity twice squared, or raised to the fourth power [n -S]\n",
  "BIQUADRATICS": "BIQUADRATIC, a quantity twice squared, or raised to the fourth power [n]\n",
  "BIQUARTERLY": "occurring every second quarter [adj]\n",
  "BIQUINTILE": "the aspect of planets when they are twice the fifth part of a great circle (i.e. 144 degrees) from each other [n -S]\n",
  "BIQUINTILES": "BIQUINTILE, the aspect of planets when they are twice the fifth part of a great circle (i.e. 144 degrees) from each other [n]\n",
  "BIRACIAL": "including members of two races [adj BIRACIALLY]\n",
  "BIRACIALISM": "the state of being biracial [n -S]\n",
  "BIRACIALISMS": "BIRACIALISM, the state of being biracial [n]\n",
  "BIRACIALLY": "BIRACIAL, including members of two races [adv]\n",
  "BIRADIAL": "having dual symmetry [adj]\n",
  "BIRADICAL": "a molecule with two centres [n -S]\n",
  "BIRADICALS": "BIRADICAL, a molecule with two centres [n]\n",
  "BIRAMOSE": "divided into branches, also BIRAMOUS [adj]\n",
  "BIRAMOUS": "divided into branches, also BIRAMOSE [adj]\n",
  "BIRCH": "to flog [v -ED, -ING, -ES]\n",
  "BIRCHBARK": "the bark of the birch tree [n -S]\n",
  "BIRCHBARKS": "BIRCHBARK, the bark of the birch tree [n]\n",
  "BIRCHED": "BIRCH, to flog [v]\n",
  "BIRCHEN": "made of birch [adj]\n",
  "BIRCHES": "BIRCH, to flog [v]\n",
  "BIRCHING": "a flogging [n -S]\n",
  "BIRCHINGS": "BIRCHING, a flogging [n]\n",
  "BIRCHIR": "any of various primitive African freshwater fishes of the genus Polypterus, also BICHIR [n -S]\n",
  "BIRCHIRS": "BIRCHIR, any of various primitive African freshwater fishes of the genus Polypterus, also BICHIR [n]\n",
  "BIRCHWOOD": "the wood of the birch tree [n -S]\n",
  "BIRCHWOODS": "BIRCHWOOD, the wood of the birch tree [n]\n",
  "BIRD": "to hunt birds [v -ED, -ING, -S]\n",
  "BIRDBATH": "a bath for birds [n -S]\n",
  "BIRDBATHS": "BIRDBATH, a bath for birds [n]\n",
  "BIRDBRAIN": "one of very limited intelligence [n -S]\n",
  "BIRDBRAINED": "simpleminded [adj]\n",
  "BIRDBRAINS": "BIRDBRAIN, one of very limited intelligence [n]\n",
  "BIRDCAGE": "a cage for birds [n -S]\n",
  "BIRDCAGES": "BIRDCAGE, a cage for birds [n]\n",
  "BIRDCALL": "the call of a bird [n -S]\n",
  "BIRDCALLS": "BIRDCALL, the call of a bird [n]\n",
  "BIRDDOG": "to follow closely [v BIRDDOGGED, BIRDDOGGING, BIRDDOGS]\n",
  "BIRDDOGGED": "BIRDDOG, to follow closely [v]\n",
  "BIRDDOGGING": "the act of controlling closely with unceasing vigilance [n -S]\n",
  "BIRDDOGGINGS": "BIRDDOGGING, the act of controlling closely with unceasing vigilance [n]\n",
  "BIRDDOGS": "BIRDDOG, to follow closely [v]\n",
  "BIRDED": "BIRD, to hunt birds [v]\n",
  "BIRDER": "a birdwatching enthusiast [n -S]\n",
  "BIRDERS": "BIRDER, a birdwatching enthusiast [n]\n",
  "BIRDFARM": "(US colloquial) an aircraft carrier [n -S]\n",
  "BIRDFARMS": "BIRDFARM, (US colloquial) an aircraft carrier [n]\n",
  "BIRDFEED": "food suitable for birds to eat [n -S]\n",
  "BIRDFEEDS": "BIRDFEED, food suitable for birds to eat [n]\n",
  "BIRDHOUSE": "a nesting-box; an aviary [n -S]\n",
  "BIRDHOUSES": "BIRDHOUSE, a nesting-box; an aviary [n]\n",
  "BIRDIE": "to score one under par in golf [v BIRDIED, BIRDIEING, BIRDIES]\n",
  "BIRDIED": "BIRDIE, to score one under par in golf [v]\n",
  "BIRDIEING": "BIRDIE, to score one under par in golf [v]\n",
  "BIRDIES": "BIRDIE, to score one under par in golf [v]\n",
  "BIRDING": "the occupation of catching or watching birds [n -S]\n",
  "BIRDINGS": "BIRDING, the occupation of catching or watching birds [n]\n",
  "BIRDLIFE": "birds collectively [n -S]\n",
  "BIRDLIFES": "BIRDLIFE, birds collectively [n]\n",
  "BIRDLIKE": "like a bird [adj]\n",
  "BIRDLIME": "a sticky substance put on tree branches to catch birds [n -S] / to smear or catch (as) with birdlime [v BIRDLIMED, BIRDLIMING, BIRDLIMES]\n",
  "BIRDLIMED": "BIRDLIME, to smear or catch (as) with birdlime [v]\n",
  "BIRDLIMES": "BIRDLIME, to smear or catch (as) with birdlime [v]\n",
  "BIRDLIMING": "BIRDLIME, to smear or catch (as) with birdlime [v]\n",
  "BIRDMAN": "a fowler or bird-catcher [n BIRDMEN]\n",
  "BIRDMEN": "BIRDMAN, a fowler or bird-catcher [n]\n",
  "BIRDS": "BIRD, to hunt birds [v]\n",
  "BIRDSEED": "seed used for feeding birds [n -S]\n",
  "BIRDSEEDS": "BIRDSEED, seed used for feeding birds [n]\n",
  "BIRDSEYE": "a kind of primrose [n -S]\n",
  "BIRDSEYES": "BIRDSEYE, a kind of primrose [n]\n",
  "BIRDSFOOT": "a papilionaceous genus of plants with clawlike pods [n -S]\n",
  "BIRDSFOOTS": "BIRDSFOOT, a papilionaceous genus of plants with clawlike pods [n]\n",
  "BIRDSHOT": "small shot for shooting birds [n -S]\n",
  "BIRDSHOTS": "BIRDSHOT, small shot for shooting birds [n]\n",
  "BIRDSONG": "the song of a bird [n -S]\n",
  "BIRDSONGS": "BIRDSONG, the song of a bird [n]\n",
  "BIRDWATCH": "to watch birds as a hobby [v -ED, -ING, -ES]\n",
  "BIRDWATCHED": "BIRDWATCH, to watch birds as a hobby [v]\n",
  "BIRDWATCHER": "one who watches birds as a hobby [n -S]\n",
  "BIRDWATCHERS": "BIRDWATCHER, one who watches birds as a hobby [n]\n",
  "BIRDWATCHES": "BIRDWATCH, to watch birds as a hobby [v]\n",
  "BIRDWATCHING": "the occupation of watching birds [n -S]\n",
  "BIRDWATCHINGS": "BIRDWATCHING, the occupation of watching birds [n]\n",
  "BIRDWING": "a large tropical butterfly [n -S]\n",
  "BIRDWINGS": "BIRDWING, a large tropical butterfly [n]\n",
  "BIREFRINGENCE": "the refraction of light in an anisotropic material (as calcite) in two slightly different directions to form two rays [n -S]\n",
  "BIREFRINGENCES": "BIREFRINGENCE, the refraction of light in an anisotropic material (as calcite) in two slightly different directions to form two rays [n]\n",
  "BIREFRINGENT": "relating to birefringence [adj]\n",
  "BIREME": "an ancient galley with two banks of oars [n -S]\n",
  "BIREMES": "BIREME, an ancient galley with two banks of oars [n]\n",
  "BIRETTA": "(Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERETTA, BERRETTA, BIRRETTA [n -S]\n",
  "BIRETTAS": "BIRETTA, (Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERETTA, BERRETTA, BIRRETTA [n]\n",
  "BIRIANI": "(Urdu) a spicy rice dish, also BIRIYANI, BIRYANI [n -S]\n",
  "BIRIANIS": "BIRIANI, (Urdu) a spicy rice dish, also BIRIYANI, BIRYANI [n]\n",
  "BIRIYANI": "(Urdu) a spicy rice dish, also BIRIANI, BIRYANI [n -S]\n",
  "BIRIYANIS": "BIRIYANI, (Urdu) a spicy rice dish, also BIRIANI, BIRYANI [n]\n",
  "BIRK": "(Scots) birch [n -S]\n",
  "BIRKEN": "made of birch wood, also BIRCHEN [adj]\n",
  "BIRKIE": "(Scots) active, lively [adj BIRKIER, BIRKIEST] / a lively or mettlesome fellow [n -S]\n",
  "BIRKIER": "BIRKIE, (Scots) active, lively [adj]\n",
  "BIRKIES": "BIRKIE, a lively or mettlesome fellow [n]\n",
  "BIRKIEST": "BIRKIE, (Scots) active, lively [adj]\n",
  "BIRKS": "BIRK, (Scots) birch [n]\n",
  "BIRL": "to spin round [v -ED, -ING, -S]\n",
  "BIRLE": "to carouse, also BIRL, BYRL [v BIRLED, BIRLING, BIRLES]\n",
  "BIRLED": "BIRLE, to carouse, also BIRL, BYRL [v]\n",
  "BIRLER": "one who birls, carouses [n -S]\n",
  "BIRLERS": "BIRLER, one who birls, carouses [n]\n",
  "BIRLES": "BIRLE, to carouse, also BIRL, BYRL [v]\n",
  "BIRLIEMAN": "(Scott) a byrlaw-man, an arbiter, oddsman or umpire in such matters [n BIRLIEMEN]\n",
  "BIRLIEMEN": "BIRLIEMAN, (Scott) a byrlaw-man, an arbiter, oddsman or umpire in such matters [n]\n",
  "BIRLING": "a lumberjack game involving spinning on a floating log [n -S]\n",
  "BIRLINGS": "BIRLING, a lumberjack game involving spinning on a floating log [n]\n",
  "BIRLINN": "(Gaelic) a Gaelic chief's barge [n -S]\n",
  "BIRLINNS": "BIRLINN, (Gaelic) a Gaelic chief's barge [n]\n",
  "BIRLS": "BIRL, to spin round [v]\n",
  "BIRO": "(tradename) a kind of ballpoint pen [n -S]\n",
  "BIROS": "BIRO, (tradename) a kind of ballpoint pen [n]\n",
  "BIROSTRATE": "double-beaked [adj]\n",
  "BIRR": "(Amharic) to make a whirring noise [v -ED, -ING, -S] / a monetary unit of Ethiopia [n BIRROTCH]\n",
  "BIRRED": "BIRR, (Amharic) to make a whirring noise [v]\n",
  "BIRRETTA": "(Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERETTA, BERRETTA, BIRETTA [n -S]\n",
  "BIRRETTAS": "BIRRETTA, (Spanish) a square cap worn by Roman Catholic ecclesiastics, also BERETTA, BERRETTA, BIRETTA [n]\n",
  "BIRRING": "BIRR, (Amharic) to make a whirring noise [v]\n",
  "BIRROTCH": "BIRR, a monetary unit of Ethiopia [n]\n",
  "BIRRS": "BIRR, (Amharic) to make a whirring noise [v]\n",
  "BIRSE": "(Scots) to bruise [v BIRSED, BIRSING, BIRSES]\n",
  "BIRSED": "BIRSE, (Scots) to bruise [v]\n",
  "BIRSES": "BIRSE, (Scots) to bruise [v]\n",
  "BIRSIER": "BIRSY, (Scots) bristly [adj]\n",
  "BIRSIEST": "BIRSY, (Scots) bristly [adj]\n",
  "BIRSING": "BIRSE, (Scots) to bruise [v]\n",
  "BIRSLE": "to scorch, toast [v BIRSLED, BIRSLING, BIRSLES]\n",
  "BIRSLED": "BIRSLE, to scorch, toast [v]\n",
  "BIRSLES": "BIRSLE, to scorch, toast [v]\n",
  "BIRSLING": "BIRSLE, to scorch, toast [v]\n",
  "BIRSY": "(Scots) bristly [adj BIRSIER, BIRSIEST]\n",
  "BIRTH": "to originate [v -ED, -ING, -S]\n",
  "BIRTHDATE": "the date on which a person was born [n -S]\n",
  "BIRTHDATES": "BIRTHDATE, the date on which a person was born [n]\n",
  "BIRTHDAY": "the day of one's birth, or its anniversary [n -S]\n",
  "BIRTHDAYS": "BIRTHDAY, the day of one's birth, or its anniversary [n]\n",
  "BIRTHDOM": "(Shakespeare) birthright [n -S]\n",
  "BIRTHDOMS": "BIRTHDOM, (Shakespeare) birthright [n]\n",
  "BIRTHED": "BIRTH, to originate [v]\n",
  "BIRTHER": "a person who believes that Barack Obama, US President from 2009, was not born in the USA and is therefore not eligible to be President [n -S]\n",
  "BIRTHERS": "BIRTHER, a person who believes that Barack Obama, US President from 2009, was not born in the USA and is therefore not eligible to be President [n]\n",
  "BIRTHING": "the act of giving birth [n -S]\n",
  "BIRTHINGS": "BIRTHING, the act of giving birth [n]\n",
  "BIRTHMARK": "a mark, e.g. a pigmented area or spot, on one's body at birth [n -S]\n",
  "BIRTHMARKS": "BIRTHMARK, a mark, e.g. a pigmented area or spot, on one's body at birth [n]\n",
  "BIRTHNAME": "the name given one at birth [n -S]\n",
  "BIRTHNAMES": "BIRTHNAME, the name given one at birth [n]\n",
  "BIRTHNIGHT": "the night in which a person is born; the anniversary of that night in succeeding years [n -S]\n",
  "BIRTHNIGHTS": "BIRTHNIGHT, the night in which a person is born; the anniversary of that night in succeeding years [n]\n",
  "BIRTHPLACE": "a place of birth or origin [n -S]\n",
  "BIRTHPLACES": "BIRTHPLACE, a place of birth or origin [n]\n",
  "BIRTHRATE": "the proportion of live births to population [n -S]\n",
  "BIRTHRATES": "BIRTHRATE, the proportion of live births to population [n]\n",
  "BIRTHRIGHT": "a right, privilege, or possession to which a person is entitled by birth [n -S]\n",
  "BIRTHRIGHTS": "BIRTHRIGHT, a right, privilege, or possession to which a person is entitled by birth [n]\n",
  "BIRTHROOT": "a herbaceous plant with an astringent rootstock, said to have medicinal properties, also BIRTHWORT [n -S]\n",
  "BIRTHROOTS": "BIRTHROOT, a herbaceous plant with an astringent rootstock, said to have medicinal properties, also BIRTHWORT [n]\n",
  "BIRTHS": "BIRTH, to originate [v]\n",
  "BIRTHSTONE": "a gemstone associated symbolically with the month of one's birth [n -S]\n",
  "BIRTHSTONES": "BIRTHSTONE, a gemstone associated symbolically with the month of one's birth [n]\n",
  "BIRTHWORT": "a plant formerly reputed to help parturition, also BIRTHROOT [n -S]\n",
  "BIRTHWORTS": "BIRTHWORT, a plant formerly reputed to help parturition, also BIRTHROOT [n]\n",
  "BIRYANI": "(Urdu) a spicy rice dish, also BIRIANI, BIRIYANI [n -S]\n",
  "BIRYANIS": "BIRYANI, (Urdu) a spicy rice dish, also BIRIANI, BIRIYANI [n]\n",
  "BIS": "BI, (short for) a bisexual [n]\n",
  "BISCACHA": "a South American rodent, also BIZCACHA [n -S]\n",
  "BISCACHAS": "BISCACHA, a South American rodent, also BIZCACHA [n]\n",
  "BISCOTTI": "BISCOTTO, (Italian) a crisp, anise-flavored cookie [n]\n",
  "BISCOTTO": "(Italian) a crisp, anise-flavored cookie [n BISCOTTI]\n",
  "BISCUIT": "a small, thin, crisp cake [n -S]\n",
  "BISCUITIER": "BISCUITY, like a biscuit in texture [adj]\n",
  "BISCUITIEST": "BISCUITY, like a biscuit in texture [adj]\n",
  "BISCUITS": "BISCUIT, a small, thin, crisp cake [n]\n",
  "BISCUITY": "like a biscuit in texture [adj BISCUITIER, BISCUITIEST]\n",
  "BISE": "(French) a cold wind in Switzerland, also BIZE [n -S]\n",
  "BISECT": "to divide into two parts [v -ED, -ING, -S]\n",
  "BISECTED": "BISECT, to divide into two parts [v]\n",
  "BISECTING": "BISECT, to divide into two parts [v]\n",
  "BISECTION": "the act of bisecting [n -S]\n",
  "BISECTIONAL": "relating to bisection [adj BISECTIONALLY]\n",
  "BISECTIONALLY": "BISECTIONAL, relating to bisection [adv]\n",
  "BISECTIONS": "BISECTION, the act of bisecting [n]\n",
  "BISECTOR": "a line that divides into two parts [n -S]\n",
  "BISECTORS": "BISECTOR, a line that divides into two parts [n]\n",
  "BISECTRICES": "BISECTRIX, the bisector of the angle between the optic axes of a crystal [n]\n",
  "BISECTRIX": "the bisector of the angle between the optic axes of a crystal [n BISECTRICES]\n",
  "BISECTS": "BISECT, to divide into two parts [v]\n",
  "BISERIAL": "arranged in two rows [adj]\n",
  "BISERIATE": "of petals etc. arranged in two rows or whorls [adj]\n",
  "BISERRATE": "doubly serrated [adj]\n",
  "BISES": "BISE, (French) a cold wind in Switzerland, also BIZE [n]\n",
  "BISEXUAL": "hermaphrodite [adj BISEXUALLY] / one who is attracted to both sexes [n -S]\n",
  "BISEXUALISM": "being bisexual [n -S]\n",
  "BISEXUALISMS": "BISEXUALISM, being bisexual [n]\n",
  "BISEXUALITIES": "BISEXUALITY, the state of being bisexual [n]\n",
  "BISEXUALITY": "the state of being bisexual [n BISEXUALITIES]\n",
  "BISEXUALLY": "BISEXUAL, hermaphrodite [adv]\n",
  "BISEXUALS": "BISEXUAL, one who is attracted to both sexes [n]\n",
  "BISH": "a mistake, a blunder [n -ES]\n",
  "BISHES": "BISH, a mistake, a blunder [n]\n",
  "BISHOP": "a senior clergyman in charge of a diocese [n -S] / to fill, or otherwise tamper with, the teeth of a horse, to make it seem younger [v -ED, -ING, -S]\n",
  "BISHOPBIRD": "a genus of African weaverbird, the males of which have black plumage marked with red or yellow [n -S]\n",
  "BISHOPBIRDS": "BISHOPBIRD, a genus of African weaverbird, the males of which have black plumage marked with red or yellow [n]\n",
  "BISHOPDOM": "the jurisdiction of a bishop [n -S]\n",
  "BISHOPDOMS": "BISHOPDOM, the jurisdiction of a bishop [n]\n",
  "BISHOPED": "BISHOP, to fill, or otherwise tamper with, the teeth of a horse, to make it seem younger [v]\n",
  "BISHOPESS": "a female bishop [n -ES]\n",
  "BISHOPESSES": "BISHOPESS, a female bishop [n]\n",
  "BISHOPING": "BISHOP, to fill, or otherwise tamper with, the teeth of a horse, to make it seem younger [v]\n",
  "BISHOPRIC": "the diocese or jurisdiction of a bishop; the rank or office of a bishop [n -S]\n",
  "BISHOPRICS": "BISHOPRIC, the diocese or jurisdiction of a bishop; the rank or office of a bishop [n]\n",
  "BISHOPS": "BISHOP, to fill, or otherwise tamper with, the teeth of a horse, to make it seem younger [v]\n",
  "BISHOPWEED": "goutweed [n -S]\n",
  "BISHOPWEEDS": "BISHOPWEED, goutweed [n]\n",
  "BISK": "a kind of rich thick soup, also BISQUE [n -S]\n",
  "BISKS": "BISK, a kind of rich thick soup, also BISQUE [n]\n",
  "BISMAR": "(Old Norse) in Orkney and Shetland, a kind of steelyard [n -S]\n",
  "BISMARCK": "(Canadian) a type of pastry [n -S]\n",
  "BISMARCKS": "BISMARCK, (Canadian) a type of pastry [n]\n",
  "BISMARS": "BISMAR, (Old Norse) in Orkney and Shetland, a kind of steelyard [n]\n",
  "BISMILLAH": "(Arabic) in the name of Allah [interj]\n",
  "BISMUTH": "a brittle reddish-white metallic element [n -S]\n",
  "BISMUTHAL": "of or like bismuth [adj]\n",
  "BISMUTHIC": "containing bismuth in its higher valence; as, bismuthic oxide [adj]\n",
  "BISMUTHINITE": "a grey mineral consisting of bismuth sulphide in orthorhombic crystalline form [n -S]\n",
  "BISMUTHINITES": "BISMUTHINITE, a grey mineral consisting of bismuth sulphide in orthorhombic crystalline form [n]\n",
  "BISMUTHOUS": "containing bismuth [adj]\n",
  "BISMUTHS": "BISMUTH, a brittle reddish-white metallic element [n]\n",
  "BISNAGA": "a type of cactus, also BIZNAGA [n -S]\n",
  "BISNAGAS": "BISNAGA, a type of cactus, also BIZNAGA [n]\n",
  "BISOCIATION": "the association of an object with two or more ideas [n -S]\n",
  "BISOCIATIONS": "BISOCIATION, the association of an object with two or more ideas [n]\n",
  "BISOCIATIVE": "relating to bisociation, the association of an object with two or more ideas [adj]\n",
  "BISOM": "a term of reproach esp. for a woman, implying slatternliness [n -S]\n",
  "BISOMS": "BISOM, a term of reproach esp. for a woman, implying slatternliness [n]\n",
  "BISON": "either of two heavily-built wild oxen of the genus Bison [n -S]\n",
  "BISONS": "BISON, either of two heavily-built wild oxen of the genus Bison [n]\n",
  "BISONTINE": "of or relating to bison [adj]\n",
  "BISPHENOL": "a hydrocarbon used in the manufacture of plastics and resins [n -S]\n",
  "BISPHENOLS": "BISPHENOL, a hydrocarbon used in the manufacture of plastics and resins [n]\n",
  "BISPHOSPHONATE": "any of a family of drugs primarily used to prevent and treat osteoporosis [n -S]\n",
  "BISPHOSPHONATES": "BISPHOSPHONATE, any of a family of drugs primarily used to prevent and treat osteoporosis [n]\n",
  "BISQUE": "(French) a rich shellfish soup, made with wine and cream, also BISK [n -S]\n",
  "BISQUES": "BISQUE, (French) a rich shellfish soup, made with wine and cream, also BISK [n]\n",
  "BISSEXTILE": "the extra day in the leap year [n -S]\n",
  "BISSEXTILES": "BISSEXTILE, the extra day in the leap year [n]\n",
  "BISSON": "(Shakespeare) to cause to be blind [v -ED, -ING, -S]\n",
  "BISSONED": "BISSON, (Shakespeare) to cause to be blind [v]\n",
  "BISSONING": "BISSON, (Shakespeare) to cause to be blind [v]\n",
  "BISSONS": "BISSON, (Shakespeare) to cause to be blind [v]\n",
  "BIST": "(archaic) 2nd person singular of be, to exist [v]\n",
  "BISTABLE": "having two stable states [adj] / a valve or transistor circuit having two stable states [n -S]\n",
  "BISTABLES": "BISTABLE, a valve or transistor circuit having two stable states [n]\n",
  "BISTATE": "pertaining to two states [adj]\n",
  "BISTER": "a pigment of warm brown colour, also BISTRE [n -S]\n",
  "BISTERED": "painted with bister, a pigment with brownish colour derived from soot, also BISTRED [adj]\n",
  "BISTERS": "BISTER, a pigment of warm brown colour, also BISTRE [n]\n",
  "BISTORT": "a plant of the dock family with a twisted astringent root, aka snakeweed [n -S]\n",
  "BISTORTS": "BISTORT, a plant of the dock family with a twisted astringent root, aka snakeweed [n]\n",
  "BISTOURIES": "BISTOURY, a narrow surgical knife [n]\n",
  "BISTOURY": "a narrow surgical knife [n BISTOURIES]\n",
  "BISTRE": "a pigment of warm brown colour, also BISTER [n -S]\n",
  "BISTRED": "painted with bistre, a pigment with brownish colour derived from soot, also BISTERED [adj]\n",
  "BISTRES": "BISTRE, a pigment of warm brown colour, also BISTER [n]\n",
  "BISTRO": "(Russian) a small bar or restaurant [n -S]\n",
  "BISTROIC": "of or like a bistro, a small bar or restaurant [adj]\n",
  "BISTROS": "BISTRO, (Russian) a small bar or restaurant [n]\n",
  "BISULCATE": "cloven-footed [adj]\n",
  "BISULFATE": "an acid sulphate, also BISULPHATE [n -S]\n",
  "BISULFATES": "BISULFATE, an acid sulphate, also BISULPHATE [n]\n",
  "BISULFIDE": "a sulphide having two atoms of sulphur in the molecule, also BISULPHIDE [n -S]\n",
  "BISULFIDES": "BISULFIDE, a sulphide having two atoms of sulphur in the molecule, also BISULPHIDE [n]\n",
  "BISULFITE": "an acid sulfite, also BISULPHITE [n -S]\n",
  "BISULFITES": "BISULFITE, an acid sulfite, also BISULPHITE [n]\n",
  "BISULPHATE": "a salt containing double the proportion of the acid radical present in a sulphate, also BISULFATE [n -S]\n",
  "BISULPHATES": "BISULPHATE, a salt containing double the proportion of the acid radical present in a sulphate, also BISULFATE [n]\n",
  "BISULPHIDE": "a sulphide having two atoms of sulphur in the molecule, also BISULFIDE [n -S]\n",
  "BISULPHIDES": "BISULPHIDE, a sulphide having two atoms of sulphur in the molecule, also BISULFIDE [n]\n",
  "BISULPHITE": "a salt or ester of sulphurous acid containing the monovalent group, also BISULFITE [n -S]\n",
  "BISULPHITES": "BISULPHITE, a salt or ester of sulphurous acid containing the monovalent group, also BISULFITE [n]\n",
  "BISYMMETRIC": "showing symmetry in two planes at right angles to each other, also BISYMMETRICAL [adj BISYMMETRICALLY]\n",
  "BISYMMETRICAL": "showing symmetry in two planes at right angles to each other, also BISYMMETRIC [adj BISYMMETRICALLY]\n",
  "BISYMMETRICALLY": "BISYMMETRICAL, showing symmetry in two planes at right angles to each other, also BISYMMETRIC [adv]\n",
  "BISYMMETRIES": "BISYMMETRY, symmetry in two planes at right angles to each other [n]\n",
  "BISYMMETRY": "symmetry in two planes at right angles to each other [n BISYMMETRIES]\n",
  "BIT": "to curb or restrain [v BITTED, BITTING, BITS]\n",
  "BITABLE": "capable of being bitten [adj]\n",
  "BITARTRATE": "a salt of tartaric acid in which the base replaces but half the acid hydrogen [n -S]\n",
  "BITARTRATES": "BITARTRATE, a salt of tartaric acid in which the base replaces but half the acid hydrogen [n]\n",
  "BITCH": "to complain [v -ED, -ING, -ES]\n",
  "BITCHED": "BITCH, to complain [v]\n",
  "BITCHEN": "(slang) marvellous [adj]\n",
  "BITCHERIES": "BITCHERY, ill-tempered, malicious behaviour [n]\n",
  "BITCHERY": "ill-tempered, malicious behaviour [n BITCHERIES]\n",
  "BITCHES": "BITCH, to complain [v]\n",
  "BITCHFEST": "malicious discussion of people, events etc. [n -S]\n",
  "BITCHFESTS": "BITCHFEST, malicious discussion of people, events etc. [n]\n",
  "BITCHIER": "BITCHY, catty [adj]\n",
  "BITCHIEST": "BITCHY, catty [adj]\n",
  "BITCHILY": "BITCHY, catty [adv]\n",
  "BITCHINESS": "the state of being bitchy [n -ES]\n",
  "BITCHINESSES": "BITCHINESS, the state of being bitchy [n]\n",
  "BITCHING": "BITCH, to complain [v]\n",
  "BITCHY": "catty [adj BITCHIER, BITCHIEST, BITCHILY]\n",
  "BITCOIN": "a unit of digital currency held and exchanged for goods by means of computer software [n -S]\n",
  "BITCOINS": "BITCOIN, a unit of digital currency held and exchanged for goods by means of computer software [n]\n",
  "BITE": "to seize with the teeth [v BIT, BITTEN, BITING, BITES]\n",
  "BITEABLE": "that can be bitten, also BITABLE [adj]\n",
  "BITEPLATE": "a device used by dentists [n -S]\n",
  "BITEPLATES": "BITEPLATE, a device used by dentists [n]\n",
  "BITER": "that which bites [n -S]\n",
  "BITERS": "BITER, that which bites [n]\n",
  "BITES": "BITE, to seize with the teeth [v]\n",
  "BITESIZE": "of food, small enough to be eaten in one bite [adj]\n",
  "BITEWING": "a dental X-ray film [n -S]\n",
  "BITEWINGS": "BITEWING, a dental X-ray film [n]\n",
  "BITING": "sharp, sarcastic [adj BITINGLY] / the act of biting [n -S]\n",
  "BITINGLY": "BITING, sharp, sarcastic [adv]\n",
  "BITINGS": "BITING, the act of biting [n]\n",
  "BITLESS": "not having a bit or bridle [adj]\n",
  "BITMAP": "a pattern of bits representing a graphical object [n -S] / to produce a bitmap display [v BITMAPPED, BITMAPPING, BITMAPS]\n",
  "BITMAPPED": "BITMAP, to produce a bitmap display [v]\n",
  "BITMAPPING": "BITMAP, to produce a bitmap display [v]\n",
  "BITMAPS": "BITMAP, to produce a bitmap display [v]\n",
  "BITO": "a tree of dry tropical Africa and Asia [n -S]\n",
  "BITONAL": "using two musical keys together [adj]\n",
  "BITONALITIES": "BITONALITY, the use of two musical keys simultaneously [n]\n",
  "BITONALITY": "the use of two musical keys simultaneously [n BITONALITIES]\n",
  "BITOS": "BITO, a tree of dry tropical Africa and Asia [n]\n",
  "BITOU": "as in bitou bush, a sprawling woody South African shrub [adj]\n",
  "BITRATE": "the speed of data processing [n -S]\n",
  "BITRATES": "BITRATE, the speed of data processing [n]\n",
  "BITS": "BIT, to curb or restrain [v]\n",
  "BITSER": "(Australian slang) a mongrel [n -S]\n",
  "BITSERS": "BITSER, (Australian slang) a mongrel [n]\n",
  "BITSIER": "BITSY, small and attractive [adj]\n",
  "BITSIEST": "BITSY, small and attractive [adj]\n",
  "BITSTOCK": "a brace on a drill [n -S]\n",
  "BITSTOCKS": "BITSTOCK, a brace on a drill [n]\n",
  "BITSTREAM": "a sequence of digital data [n -S]\n",
  "BITSTREAMS": "BITSTREAM, a sequence of digital data [n]\n",
  "BITSY": "small and attractive [adj BITSIER, BITSIEST]\n",
  "BITT": "to secure a cable to a bitt or post [v BITTED, BITTING, BITTS]\n",
  "BITTACLE": "a casing for a ship's compass, also BINNACLE [n -S]\n",
  "BITTACLES": "BITTACLE, a casing for a ship's compass, also BINNACLE [n]\n",
  "BITTE": "(German) please [interj]\n",
  "BITTED": "BITT, to secure a cable to a bitt or post [v]\n",
  "BITTEN": "BITE, to seize with the teeth [v]\n",
  "BITTER": "having a disagreeable taste [adj BITTERER, BITTEREST, BITTERLY] / to make resentful [v -ED, -ING, -S]\n",
  "BITTERBARK": "an Australian tree with bitter tasting bark, used for tonic medicine [n -S]\n",
  "BITTERBARKS": "BITTERBARK, an Australian tree with bitter tasting bark, used for tonic medicine [n]\n",
  "BITTERBRUSH": "a silvery shrub of NW America [n -ES]\n",
  "BITTERBRUSHES": "BITTERBRUSH, a silvery shrub of NW America [n]\n",
  "BITTERCRESS": "one of several perennial or annual cruciferous plants of the genus Cardamine [n -ES]\n",
  "BITTERCRESSES": "BITTERCRESS, one of several perennial or annual cruciferous plants of the genus Cardamine [n]\n",
  "BITTERED": "BITTER, to make resentful [v]\n",
  "BITTERER": "BITTER, having a disagreeable taste [adj]\n",
  "BITTEREST": "BITTER, having a disagreeable taste [adj]\n",
  "BITTERING": "BITTER, to make resentful [v]\n",
  "BITTERISH": "somewhat bitter [adj]\n",
  "BITTERLING": "a roach-like European fish [n -S]\n",
  "BITTERLINGS": "BITTERLING, a roach-like European fish [n]\n",
  "BITTERLY": "BITTER, having a disagreeable taste [adv]\n",
  "BITTERN": "a wading bird, also BITTOR, BITTOUR, BITTUR [n -S]\n",
  "BITTERNESS": "the state of being bitter [n -ES]\n",
  "BITTERNESSES": "BITTERNESS, the state of being bitter [n]\n",
  "BITTERNS": "BITTERN, a wading bird, also BITTOR, BITTOUR, BITTUR [n]\n",
  "BITTERNUT": "a North American hickory tree [n -S]\n",
  "BITTERNUTS": "BITTERNUT, a North American hickory tree [n]\n",
  "BITTERROOT": "a plant allied to the purslane, growing in the mountains of Idaho, Montana, etc. [n -S]\n",
  "BITTERROOTS": "BITTERROOT, a plant allied to the purslane, growing in the mountains of Idaho, Montana, etc. [n]\n",
  "BITTERS": "BITTER, to make resentful [v]\n",
  "BITTERSWEET": "part bitter, part sweet [adj BITTERSWEETLY] / the woody nightshade, whose stems when chewed taste first bitter, then sweet [n -S]\n",
  "BITTERSWEETLY": "BITTERSWEET, part bitter, part sweet [adv]\n",
  "BITTERSWEETNESS": "the state of being bittersweet [n]\n",
  "BITTERSWEETS": "BITTERSWEET, the woody nightshade, whose stems when chewed taste first bitter, then sweet [n]\n",
  "BITTERWEED": "any of various plants containing a bitter-tasting substance [n -S]\n",
  "BITTERWEEDS": "BITTERWEED, any of various plants containing a bitter-tasting substance [n]\n",
  "BITTERWOOD": "a West Indian tree from the wood of which the bitter drug Jamaica quassia is obtained [n -S]\n",
  "BITTERWOODS": "BITTERWOOD, a West Indian tree from the wood of which the bitter drug Jamaica quassia is obtained [n]\n",
  "BITTIE": "(Scots) a small piece, a short time [n -S]\n",
  "BITTIER": "BITTY, fragmented [adj]\n",
  "BITTIES": "BITTIE, (Scots) a small piece, a short time [n]\n",
  "BITTIEST": "BITTY, fragmented [adj]\n",
  "BITTILY": "BITTY, fragmented [adv]\n",
  "BITTINESS": "the state of being bitty [n -ES]\n",
  "BITTINESSES": "BITTINESS, the state of being bitty [n]\n",
  "BITTING": "an indentation of a key [n -S]\n",
  "BITTINGS": "BITTING, an indentation of a key [n]\n",
  "BITTOCK": "(Scots) a small bit of anything; a short distance [n -S]\n",
  "BITTOCKS": "BITTOCK, (Scots) a small bit of anything; a short distance [n]\n",
  "BITTOR": "(Spenser) the bittern, also BITTERN, BITTOUR, BITTUR [n -S]\n",
  "BITTORS": "BITTOR, (Spenser) the bittern, also BITTERN, BITTOUR, BITTUR [n]\n",
  "BITTOUR": "(Spenser) the bittern, also BITTERN, BITTOR, BITTUR [n -S]\n",
  "BITTOURS": "BITTOUR, (Spenser) the bittern, also BITTERN, BITTOR, BITTUR [n]\n",
  "BITTS": "BITT, to secure a cable to a bitt or post [v]\n",
  "BITTUR": "(Spenser) the bittern, also BITTERN, BITTOR, BITTOUR [n -S]\n",
  "BITTURS": "BITTUR, (Spenser) the bittern, also BITTERN, BITTOR, BITTOUR [n]\n",
  "BITTY": "fragmented [adj BITTIER, BITTIEST, BITTILY]\n",
  "BITUMED": "(Shakespeare) impregnated with bitumen [adj]\n",
  "BITUMEN": "(Latin) naturally occurring asphalt from the Middle East, used as mortar etc. [n -S]\n",
  "BITUMENS": "BITUMEN, (Latin) naturally occurring asphalt from the Middle East, used as mortar etc. [n]\n",
  "BITUMINATE": "to treat or impregnate with bitumen [v BITUMINATED, BITUMINATING, BITUMINATES]\n",
  "BITUMINATED": "BITUMINATE, to treat or impregnate with bitumen [v]\n",
  "BITUMINATES": "BITUMINATE, to treat or impregnate with bitumen [v]\n",
  "BITUMINATING": "BITUMINATE, to treat or impregnate with bitumen [v]\n",
  "BITUMINISATION": "the process of bituminising, also BITUMINIZATION [n -S]\n",
  "BITUMINISATIONS": "BITUMINISATION, the process of bituminising, also BITUMINIZATION [n]\n",
  "BITUMINISE": "to treat with bitumen, also BITUMINIZE [v BITUMINISED, BITUMINISING, BITUMINISES]\n",
  "BITUMINISED": "BITUMINISE, to treat with bitumen, also BITUMINIZE [v]\n",
  "BITUMINISES": "BITUMINISE, to treat with bitumen, also BITUMINIZE [v]\n",
  "BITUMINISING": "BITUMINISE, to treat with bitumen, also BITUMINIZE [v]\n",
  "BITUMINIZATION": "the act of bituminizing, also BITUMINISATION [n -S]\n",
  "BITUMINIZATIONS": "BITUMINIZATION, the act of bituminizing, also BITUMINISATION [n]\n",
  "BITUMINIZE": "to treat with bitumen, also BITUMINISE [v BITUMINIZED, BITUMINIZING, BITUMINIZES]\n",
  "BITUMINIZED": "BITUMINIZE, to treat with bitumen, also BITUMINISE [v]\n",
  "BITUMINIZES": "BITUMINIZE, to treat with bitumen, also BITUMINISE [v]\n",
  "BITUMINIZING": "BITUMINIZE, to treat with bitumen, also BITUMINISE [v]\n",
  "BITUMINOUS": "(Shakespeare) impregnated with bitumen [adj]\n",
  "BITURBO": "an engine with two turbos [n -S]\n",
  "BITURBOS": "BITURBO, an engine with two turbos [n]\n",
  "BITWISE": "designating an operator in a programming language that manipulates the individual bits in a byte or word [adj]\n",
  "BIUNIQUE": "being a type of correspondence between two sets [adj]\n",
  "BIUNIQUENESS": "the state of being biunique [n -ES]\n",
  "BIUNIQUENESSES": "BIUNIQUENESS, the state of being biunique [n]\n",
  "BIVALENCE": "the state of being bivalent, having a valency of two, also BIVALENCY [n -S]\n",
  "BIVALENCES": "BIVALENCE, the state of being bivalent, having a valency of two, also BIVALENCY [n]\n",
  "BIVALENCIES": "BIVALENCY, the state of being bivalent, having a valency of two, also BIVALENCE [n]\n",
  "BIVALENCY": "the state of being bivalent, having a valency of two, also BIVALENCE [n BIVALENCIES]\n",
  "BIVALENT": "a pair of chromosomes, also DIVALENT [n -S]\n",
  "BIVALENTS": "BIVALENT, a pair of chromosomes, also DIVALENT [n]\n",
  "BIVALVATE": "of molluscs, having two valves [adj]\n",
  "BIVALVE": "a mollusc having a shell in two valves or parts [n -S]\n",
  "BIVALVED": "having a two-valved shell [adj]\n",
  "BIVALVES": "BIVALVE, a mollusc having a shell in two valves or parts [n]\n",
  "BIVALVULAR": "having two valves [adj]\n",
  "BIVARIANT": "involving two variables [adj] / an expression involving two variables [n -S]\n",
  "BIVARIANTS": "BIVARIANT, an expression involving two variables [n]\n",
  "BIVARIATE": "involving or depending on two variables [adj] / a formula involving two variables [n -S]\n",
  "BIVARIATES": "BIVARIATE, a formula involving two variables [n]\n",
  "BIVIA": "BIVIUM, (Latin) in echinoderms, the two rays enclosing the madreporite [n]\n",
  "BIVINYL": "a flammable gas used in making synthetic rubber [n -S]\n",
  "BIVINYLS": "BIVINYL, a flammable gas used in making synthetic rubber [n]\n",
  "BIVIOUS": "(obsolete) offering a choice; splitting between two directions [adj]\n",
  "BIVIUM": "(Latin) in echinoderms, the two rays enclosing the madreporite [n BIVIA]\n",
  "BIVOUAC": "(French) to spend the night in a makeshift camp without tents etc. [v BIVOUACKED, BIVOUACKING, BIVOUACKS or BIVOUACS]\n",
  "BIVOUACKED": "BIVOUAC, (French) to spend the night in a makeshift camp without tents etc. [v]\n",
  "BIVOUACKING": "BIVOUAC, (French) to spend the night in a makeshift camp without tents etc. [v]\n",
  "BIVOUACKS": "BIVOUAC, (French) to spend the night in a makeshift camp without tents etc. [v]\n",
  "BIVOUACS": "BIVOUAC, (French) to spend the night in a makeshift camp without tents etc. [v]\n",
  "BIVVIED": "BIVVY, to bivouac, to remain in the open air (esp. during the night) without tents etc. [v]\n",
  "BIVVIES": "BIVVY, to bivouac, to remain in the open air (esp. during the night) without tents etc. [v]\n",
  "BIVVY": "to bivouac, to remain in the open air (esp. during the night) without tents etc. [v BIVVIED, BIVVYING, BIVVIES]\n",
  "BIVVYING": "BIVVY, to bivouac, to remain in the open air (esp. during the night) without tents etc. [v]\n",
  "BIWEEKLIES": "BIWEEKLY, a publication issued every two weeks [n]\n",
  "BIWEEKLY": "a publication issued every two weeks [n BIWEEKLIES]\n",
  "BIYEARLY": "occurring every two years [adj]\n",
  "BIZ": "(slang) business [n BIZES or BIZZES]\n",
  "BIZARRE": "strange [adj BIZARRELY] / a strangely striped flower [n -S]\n",
  "BIZARRELY": "BIZARRE, strange [adv]\n",
  "BIZARRENESS": "the state of being bizarre [n -ES]\n",
  "BIZARRENESSES": "BIZARRENESS, the state of being bizarre [n]\n",
  "BIZARRERIE": "(French) something bizarre [n -S]\n",
  "BIZARRERIES": "BIZARRERIE, (French) something bizarre [n]\n",
  "BIZARRES": "BIZARRE, a strangely striped flower [n]\n",
  "BIZARRO": "one that is strikingly unusual [n -S]\n",
  "BIZARROS": "BIZARRO, one that is strikingly unusual [n]\n",
  "BIZAZZ": "flamboyance, also BAZAZZ, BEZZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "BIZAZZES": "BIZAZZ, flamboyance, also BAZAZZ, BEZZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n]\n",
  "BIZCACHA": "a South American rodent, also BISCACHA [n -S]\n",
  "BIZCACHAS": "BIZCACHA, a South American rodent, also BISCACHA [n]\n",
  "BIZE": "(French) a cold N or NE wind prevalent at certain seasons in and near Switzerland, also BISE [n -S]\n",
  "BIZES": "BIZE, (French) a cold N or NE wind prevalent at certain seasons in and near Switzerland, also BISE [n]\n",
  "BIZJET": "a small airplane used for business [n -S]\n",
  "BIZJETS": "BIZJET, a small airplane used for business [n]\n",
  "BIZNAGA": "a type of cactus, also BISNAGA [n -S]\n",
  "BIZNAGAS": "BIZNAGA, a type of cactus, also BISNAGA [n]\n",
  "BIZONAL": "pertaining to a zone [adj]\n",
  "BIZONE": "a country formed of two zones [n -S]\n",
  "BIZONES": "BIZONE, a country formed of two zones [n]\n",
  "BIZZAZZ": "panache [n -ES]\n",
  "BIZZAZZES": "BIZZAZZ, panache [n]\n",
  "BIZZES": "BIZ, (slang) business [n]\n",
  "BIZZIES": "BIZZY, a policeman [n]\n",
  "BIZZO": "(Australian slang) irrelevant talk [n -S]\n",
  "BIZZOS": "BIZZO, (Australian slang) irrelevant talk [n]\n",
  "BIZZY": "a policeman [n BIZZIES]\n",
  "BLAB": "to tell tales [v BLABBED, BLABBING, BLABS]\n",
  "BLABBED": "BLAB, to tell tales [v]\n",
  "BLABBER": "to reveal secrets [v -ED, -ING, -S]\n",
  "BLABBERED": "BLABBER, to reveal secrets [v]\n",
  "BLABBERING": "BLABBER, to reveal secrets [v]\n",
  "BLABBERMOUTH": "an indiscreetly talkative person [n -S]\n",
  "BLABBERMOUTHS": "BLABBERMOUTH, an indiscreetly talkative person [n]\n",
  "BLABBERS": "BLABBER, to reveal secrets [v]\n",
  "BLABBIER": "BLABBY, tending to blab [adj]\n",
  "BLABBIEST": "BLABBY, tending to blab [adj]\n",
  "BLABBING": "the act of blabbing, taletelling [n -S]\n",
  "BLABBINGS": "BLABBING, the act of blabbing, taletelling [n]\n",
  "BLABBY": "tending to blab [adj BLABBIER, BLABBIEST]\n",
  "BLABS": "BLAB, to tell tales [v]\n",
  "BLACK": "being of the darkest colour [adj BLACKER, BLACKEST, BLACKLY] / to blacken [v -ED, -ING, -S]\n",
  "BLACKAMOOR": "(archaic) a negro or negress [n -S]\n",
  "BLACKAMOORS": "BLACKAMOOR, (archaic) a negro or negress [n]\n",
  "BLACKBALL": "to vote against someone becoming member of a club [v -ED, -ING, -S]\n",
  "BLACKBALLED": "BLACKBALL, to vote against someone becoming member of a club [v]\n",
  "BLACKBALLING": "the act of voting against someone becoming member of a club [n -S]\n",
  "BLACKBALLINGS": "BLACKBALLING, the act of voting against someone becoming member of a club [n]\n",
  "BLACKBALLS": "BLACKBALL, to vote against someone becoming member of a club [v]\n",
  "BLACKBAND": "iron ore containing enough coal to calcine it [n -S]\n",
  "BLACKBANDS": "BLACKBAND, iron ore containing enough coal to calcine it [n]\n",
  "BLACKBERRIED": "BLACKBERRY, to collect the fruit of the bramble [v]\n",
  "BLACKBERRIES": "BLACKBERRY, to collect the fruit of the bramble [v]\n",
  "BLACKBERRY": "to collect the fruit of the bramble [v BLACKBERRIED, BLACKBERRYING, BLACKBERRIES]\n",
  "BLACKBERRYING": "the act of collecting blackberries [n -S]\n",
  "BLACKBERRYINGS": "BLACKBERRYING, the act of collecting blackberries [n]\n",
  "BLACKBIRD": "a bird of the thrush family [n -S] / to traffic in slaves [v -ED, -ING, -S]\n",
  "BLACKBIRDED": "BLACKBIRD, to traffic in slaves [v]\n",
  "BLACKBIRDER": "(Australian slang) a person engaged in press-ganging or kidnapping labourers in the south Pacific region for work on the sugar plantations; a slave trader [n -S]\n",
  "BLACKBIRDERS": "BLACKBIRDER, (Australian slang) a person engaged in press-ganging or kidnapping labourers in the south Pacific region for work on the sugar plantations; a slave trader [n]\n",
  "BLACKBIRDING": "trafficking in slaves [n -S]\n",
  "BLACKBIRDINGS": "BLACKBIRDING, trafficking in slaves [n]\n",
  "BLACKBIRDS": "BLACKBIRD, to traffic in slaves [v]\n",
  "BLACKBOARD": "a hard smooth usually dark surface used esp. in a classroom for writing or drawing on with chalk [n -S]\n",
  "BLACKBOARDS": "BLACKBOARD, a hard smooth usually dark surface used esp. in a classroom for writing or drawing on with chalk [n]\n",
  "BLACKBODIES": "BLACKBODY, a body absorbing all incident radiation [n]\n",
  "BLACKBODY": "a body absorbing all incident radiation [n BLACKBODIES]\n",
  "BLACKBOY": "an Australian grass tree, aka yacca [n -S]\n",
  "BLACKBOYS": "BLACKBOY, an Australian grass tree, aka yacca [n]\n",
  "BLACKBUCK": "an Indian antelope [n -S]\n",
  "BLACKBUCKS": "BLACKBUCK, an Indian antelope [n]\n",
  "BLACKBUTT": "a type of eucalyptus tree [n -S]\n",
  "BLACKBUTTS": "BLACKBUTT, a type of eucalyptus tree [n]\n",
  "BLACKCAP": "a small European bird [n -S]\n",
  "BLACKCAPS": "BLACKCAP, a small European bird [n]\n",
  "BLACKCOCK": "the male of the black grouse [n -S]\n",
  "BLACKCOCKS": "BLACKCOCK, the male of the black grouse [n]\n",
  "BLACKCURRANT": "the small black berry of the garden shrub Ribes nigrum of the gooseberry genus [n -S]\n",
  "BLACKCURRANTS": "BLACKCURRANT, the small black berry of the garden shrub Ribes nigrum of the gooseberry genus [n]\n",
  "BLACKDAMP": "air that is low in oxygen and high in carbon dioxide as a result of an explosion in a mine [n -S]\n",
  "BLACKDAMPS": "BLACKDAMP, air that is low in oxygen and high in carbon dioxide as a result of an explosion in a mine [n]\n",
  "BLACKED": "BLACK, to blacken [v]\n",
  "BLACKEN": "to make black, to defame [v -ED, -ING, -S]\n",
  "BLACKENED": "BLACKEN, to make black, to defame [v]\n",
  "BLACKENER": "something that blackens [n -S]\n",
  "BLACKENERS": "BLACKENER, something that blackens [n]\n",
  "BLACKENING": "the act of making black [n -S]\n",
  "BLACKENINGS": "BLACKENING, the act of making black [n]\n",
  "BLACKENS": "BLACKEN, to make black, to defame [v]\n",
  "BLACKER": "BLACK, being of the darkest colour [adj]\n",
  "BLACKEST": "BLACK, being of the darkest colour [adj]\n",
  "BLACKFACE": "a breed of sheep [n -S]\n",
  "BLACKFACED": "of sheep, having a black face [adj]\n",
  "BLACKFACES": "BLACKFACE, a breed of sheep [n]\n",
  "BLACKFELLA": "(Australian offensive) an Aborigine or Black person [n -S]\n",
  "BLACKFELLAS": "BLACKFELLA, (Australian offensive) an Aborigine or Black person [n]\n",
  "BLACKFIN": "a food fish, a kind of tuna [n -S]\n",
  "BLACKFINS": "BLACKFIN, a food fish, a kind of tuna [n]\n",
  "BLACKFISH": "a colloquial name for various species of fish [n -ES]\n",
  "BLACKFISHES": "BLACKFISH, a colloquial name for various species of fish [n]\n",
  "BLACKFLIES": "BLACKFLY, a biting fly [n]\n",
  "BLACKFLY": "a biting fly [n BLACKFLIES]\n",
  "BLACKGAME": "black grouse [n -S]\n",
  "BLACKGAMES": "BLACKGAME, black grouse [n]\n",
  "BLACKGUARD": "a scoundrel [n -S] / to vituperate; to portray as a scoundrel [v -ED, -ING, -S]\n",
  "BLACKGUARDED": "BLACKGUARD, to vituperate; to portray as a scoundrel [v]\n",
  "BLACKGUARDING": "BLACKGUARD, to vituperate; to portray as a scoundrel [v]\n",
  "BLACKGUARDISM": "being a blackguard [n -S]\n",
  "BLACKGUARDISMS": "BLACKGUARDISM, being a blackguard [n]\n",
  "BLACKGUARDLIER": "BLACKGUARDLY, like a blackguard [adj]\n",
  "BLACKGUARDLIEST": "BLACKGUARDLY, like a blackguard [adj]\n",
  "BLACKGUARDLY": "like a blackguard [adj BLACKGUARDLIER, BLACKGUARDLIEST]\n",
  "BLACKGUARDS": "BLACKGUARD, to vituperate; to portray as a scoundrel [v]\n",
  "BLACKGUM": "a kind of dogwood, aka black tupelo [n -S]\n",
  "BLACKGUMS": "BLACKGUM, a kind of dogwood, aka black tupelo [n]\n",
  "BLACKHANDER": "a member of the Black Hand, a lawless secret society [n -S]\n",
  "BLACKHANDERS": "BLACKHANDER, a member of the Black Hand, a lawless secret society [n]\n",
  "BLACKHEAD": "a spot, a pimple [n -S]\n",
  "BLACKHEADED": "having a black head [adj]\n",
  "BLACKHEADS": "BLACKHEAD, a spot, a pimple [n]\n",
  "BLACKHEART": "a heart-shaped cherry with a very dark-colored skin [n -S]\n",
  "BLACKHEARTS": "BLACKHEART, a heart-shaped cherry with a very dark-colored skin [n]\n",
  "BLACKING": "a black shoe polish [n -S]\n",
  "BLACKINGS": "BLACKING, a black shoe polish [n]\n",
  "BLACKISH": "somewhat black [adj BLACKISHLY]\n",
  "BLACKISHLY": "BLACKISH, somewhat black [adv]\n",
  "BLACKJACK": "a kind of cosh [n -S] / to hit with a blackjack [v -ED, -ING, -S]\n",
  "BLACKJACKED": "BLACKJACK, to hit with a blackjack [v]\n",
  "BLACKJACKING": "BLACKJACK, to hit with a blackjack [v]\n",
  "BLACKJACKS": "BLACKJACK, to hit with a blackjack [v]\n",
  "BLACKLAND": "a heavy, sticky black soil such as that covering large areas of Texas [n -S]\n",
  "BLACKLANDS": "BLACKLAND, a heavy, sticky black soil such as that covering large areas of Texas [n]\n",
  "BLACKLEAD": "graphite used in making pencils, blacking grates, etc. [n -S] / to coat with blacklead [v -ED, -ING, -S]\n",
  "BLACKLEADED": "BLACKLEAD, to coat with blacklead [v]\n",
  "BLACKLEADING": "BLACKLEAD, to coat with blacklead [v]\n",
  "BLACKLEADS": "BLACKLEAD, graphite used in making pencils, blacking grates, etc. [n]\n",
  "BLACKLEG": "to work even though a strike has been declared [v BLACKLEGGED, BLACKLEGGING, BLACKLEGS]\n",
  "BLACKLEGGED": "BLACKLEG, to work even though a strike has been declared [v]\n",
  "BLACKLEGGING": "BLACKLEG, to work even though a strike has been declared [v]\n",
  "BLACKLEGS": "BLACKLEG, to work even though a strike has been declared [v]\n",
  "BLACKLIST": "to ban or deem unacceptable [v -ED, -ING, -S]\n",
  "BLACKLISTED": "BLACKLIST, to ban or deem unacceptable [v]\n",
  "BLACKLISTER": "one who blacklists [n -S]\n",
  "BLACKLISTERS": "BLACKLISTER, one who blacklists [n]\n",
  "BLACKLISTING": "the act of putting on a blacklist [n -S]\n",
  "BLACKLISTINGS": "BLACKLISTING, the act of putting on a blacklist [n]\n",
  "BLACKLISTS": "BLACKLIST, to ban or deem unacceptable [v]\n",
  "BLACKLY": "BLACK, being of the darkest colour [adv]\n",
  "BLACKMAIL": "to extort money from a person by threats [v -ED, -ING, -S]\n",
  "BLACKMAILED": "BLACKMAIL, to extort money from a person by threats [v]\n",
  "BLACKMAILER": "one who commits blackmail [n -S]\n",
  "BLACKMAILERS": "BLACKMAILER, one who commits blackmail [n]\n",
  "BLACKMAILING": "BLACKMAIL, to extort money from a person by threats [v]\n",
  "BLACKMAILS": "BLACKMAIL, to extort money from a person by threats [v]\n",
  "BLACKNESS": "the state of being black [n -ES]\n",
  "BLACKNESSES": "BLACKNESS, the state of being black [n]\n",
  "BLACKOUT": "a power failure [n -S]\n",
  "BLACKOUTS": "BLACKOUT, a power failure [n]\n",
  "BLACKPOLL": "a warbler of the United States [n -S]\n",
  "BLACKPOLLS": "BLACKPOLL, a warbler of the United States [n]\n",
  "BLACKS": "BLACK, to blacken [v]\n",
  "BLACKSMITH": "a smith who forges iron [n -S]\n",
  "BLACKSMITHING": "the occupation of blacksmith [n -S]\n",
  "BLACKSMITHINGS": "BLACKSMITHING, the occupation of blacksmith [n]\n",
  "BLACKSMITHS": "BLACKSMITH, a smith who forges iron [n]\n",
  "BLACKSNAKE": "a snake of a black color, found in the US [n -S]\n",
  "BLACKSNAKES": "BLACKSNAKE, a snake of a black color, found in the US [n]\n",
  "BLACKSPOT": "as in accident blackspot, a spot where many accidents occur [n -S]\n",
  "BLACKSPOTS": "BLACKSPOT, as in accident blackspot, a spot where many accidents occur [n]\n",
  "BLACKSTRAP": "a kind of port wine; a drink made of a mixture of rum and treacle [n -S]\n",
  "BLACKSTRAPS": "BLACKSTRAP, a kind of port wine; a drink made of a mixture of rum and treacle [n]\n",
  "BLACKTAIL": "a small fish, aka ruff or pope [n -S]\n",
  "BLACKTAILS": "BLACKTAIL, a small fish, aka ruff or pope [n]\n",
  "BLACKTHORN": "a dark-coloured thornbush bearing sloes [n -S]\n",
  "BLACKTHORNS": "BLACKTHORN, a dark-coloured thornbush bearing sloes [n]\n",
  "BLACKTIP": "a kind of small shark [n -S]\n",
  "BLACKTIPS": "BLACKTIP, a kind of small shark [n]\n",
  "BLACKTOP": "bituminous material used for surfacing roads [n -S] / to pave with asphalt [v BLACKTOPPED, BLACKTOPPING, BLACKTOPS]\n",
  "BLACKTOPPED": "BLACKTOP, to pave with asphalt [v]\n",
  "BLACKTOPPING": "BLACKTOP, to pave with asphalt [v]\n",
  "BLACKTOPS": "BLACKTOP, to pave with asphalt [v]\n",
  "BLACKWASH": "to treat with blackwash, a lotion made by mixing calomel and lime water [v -ED, -ING, -ES]\n",
  "BLACKWASHED": "BLACKWASH, to treat with blackwash, a lotion made by mixing calomel and lime water [v]\n",
  "BLACKWASHES": "BLACKWASH, to treat with blackwash, a lotion made by mixing calomel and lime water [v]\n",
  "BLACKWASHING": "BLACKWASH, to treat with blackwash, a lotion made by mixing calomel and lime water [v]\n",
  "BLACKWATER": "a complication of malaria [n -S]\n",
  "BLACKWATERS": "BLACKWATER, a complication of malaria [n]\n",
  "BLACKWOOD": "a tall Australian acacia tree [n -S]\n",
  "BLACKWOODS": "BLACKWOOD, a tall Australian acacia tree [n]\n",
  "BLAD": "(Scots) to strike, disfigure [v BLADDED, BLADDING, BLADS]\n",
  "BLADDED": "BLAD, (Scots) to strike, disfigure [v]\n",
  "BLADDER": "a saclike receptacle [n -S]\n",
  "BLADDERED": "(slang) drunk [adj]\n",
  "BLADDERIER": "BLADDERY, having bladders; like a bladder [adj]\n",
  "BLADDERIEST": "BLADDERY, having bladders; like a bladder [adj]\n",
  "BLADDERLIKE": "like a bladder in form [adj]\n",
  "BLADDERNOSE": "the hooded seal [n -S]\n",
  "BLADDERNOSES": "BLADDERNOSE, the hooded seal [n]\n",
  "BLADDERNUT": "a genus of shrubs with inflated capsule [n -S]\n",
  "BLADDERNUTS": "BLADDERNUT, a genus of shrubs with inflated capsule [n]\n",
  "BLADDERS": "BLADDER, a saclike receptacle [n]\n",
  "BLADDERWORT": "a kind of seaweed [n -S]\n",
  "BLADDERWORTS": "BLADDERWORT, a kind of seaweed [n]\n",
  "BLADDERWRACK": "a common brown seaweed with air-bladders [n -S]\n",
  "BLADDERWRACKS": "BLADDERWRACK, a common brown seaweed with air-bladders [n]\n",
  "BLADDERY": "having bladders; like a bladder [adj BLADDERIER, BLADDERIEST]\n",
  "BLADDING": "BLAD, (Scots) to strike, disfigure [v]\n",
  "BLADE": "the cutting part of a knife [n -S]\n",
  "BLADED": "having a blade [adj]\n",
  "BLADELESS": "without blades [adj]\n",
  "BLADELIKE": "like a blade [adj]\n",
  "BLADER": "a person skating with in-line skates [n -S]\n",
  "BLADERS": "BLADER, a person skating with in-line skates [n]\n",
  "BLADES": "BLADE, the cutting part of a knife [n]\n",
  "BLADEWORK": "in rowing, management of the oars [n -S]\n",
  "BLADEWORKS": "BLADEWORK, in rowing, management of the oars [n]\n",
  "BLADIER": "BLADY, as in blady grass, a coarse Australian grass [adj]\n",
  "BLADIEST": "BLADY, as in blady grass, a coarse Australian grass [adj]\n",
  "BLADING": "the act of skating on in-line skates [n -S]\n",
  "BLADINGS": "BLADING, the act of skating on in-line skates [n]\n",
  "BLADS": "BLAD, (Scots) to strike, disfigure [v]\n",
  "BLADY": "as in blady grass, a coarse Australian grass [adj BLADIER, BLADIEST]\n",
  "BLAE": "(Old Norse) blackish blue [adj BLAER, BLAEST]\n",
  "BLAEBERRIES": "BLAEBERRY, (Scots) the bilberry, also BILBERRY [n]\n",
  "BLAEBERRY": "(Scots) the bilberry, also BILBERRY [n BLAEBERRIES]\n",
  "BLAER": "BLAE, (Old Norse) blackish blue [adj]\n",
  "BLAES": "a kind of clay, livid or red in colour, also BLAISE, BLAIZE [n]\n",
  "BLAEST": "BLAE, (Old Norse) blackish blue [adj]\n",
  "BLAFF": "to bark [v -ED, -ING, -S]\n",
  "BLAFFED": "BLAFF, to bark [v]\n",
  "BLAFFING": "BLAFF, to bark [v]\n",
  "BLAFFS": "BLAFF, to bark [v]\n",
  "BLAG": "to rob, steal [v BLAGGED, BLAGGING, BLAGS]\n",
  "BLAGGED": "BLAG, to rob, steal [v]\n",
  "BLAGGER": "one who blags, a thief [n -S]\n",
  "BLAGGERS": "BLAGGER, one who blags, a thief [n]\n",
  "BLAGGING": "an act of theft [n -S]\n",
  "BLAGGINGS": "BLAGGING, an act of theft [n]\n",
  "BLAGS": "BLAG, to rob, steal [v]\n",
  "BLAGUE": "(French) humbug [n -S]\n",
  "BLAGUER": "one who talks pretentious nonsense, also BLAGUEUR [n -S]\n",
  "BLAGUERS": "BLAGUER, one who talks pretentious nonsense, also BLAGUEUR [n]\n",
  "BLAGUES": "BLAGUE, (French) humbug [n]\n",
  "BLAGUEUR": "(French) one who talks pretentious nonsense, also BLAGUER [n -S]\n",
  "BLAGUEURS": "BLAGUEUR, (French) one who talks pretentious nonsense, also BLAGUER [n]\n",
  "BLAH": "to talk stupidly or insipidly [v -ED, -ING, -S] / dull, insipid [adj BLAHER, BLAHEST]\n",
  "BLAHED": "BLAH, to talk stupidly or insipidly [v]\n",
  "BLAHER": "BLAH, dull, insipid [adj]\n",
  "BLAHEST": "BLAH, dull, insipid [adj]\n",
  "BLAHING": "BLAH, to talk stupidly or insipidly [v]\n",
  "BLAHS": "BLAH, to talk stupidly or insipidly [v]\n",
  "BLAIN": "a blister [n -S]\n",
  "BLAINS": "BLAIN, a blister [n]\n",
  "BLAISE": "a kind of clay, livid or red in colour, also BLAES, BLAIZE [n]\n",
  "BLAIZE": "a kind of clay, livid or red in colour, also BLAES, BLAISE [n]\n",
  "BLAM": "to make a sound like a gunshot [v BLAMMED, BLAMMING, BLAMS]\n",
  "BLAMABLE": "being at fault [adj]\n",
  "BLAMABLENESS": "the state of being blamable, also BLAMEABLENESS [n -ES]\n",
  "BLAMABLENESSES": "BLAMABLENESS, the state of being blamable, also BLAMEABLENESS [n]\n",
  "BLAMABLY": "BLAMABLE, being at fault [adv]\n",
  "BLAME": "to find fault with [v BLAMED, BLAMING, BLAMES]\n",
  "BLAMEABLE": "deserving of blame, also BLAMABLE [adj BLAMEABLY]\n",
  "BLAMEABLENESS": "the state of being blameable, also BLAMABLENESS [n -ES]\n",
  "BLAMEABLENESSES": "BLAMEABLENESS, the state of being blameable, also BLAMABLENESS [n]\n",
  "BLAMEABLY": "BLAMEABLE, deserving of blame, also BLAMABLE [adv]\n",
  "BLAMED": "BLAME, to find fault with [v]\n",
  "BLAMEFUL": "deserving blame [adj BLAMEFULLY]\n",
  "BLAMEFULLY": "BLAMEFUL, deserving blame [adv]\n",
  "BLAMEFULNESS": "the state of being blameful [n -ES]\n",
  "BLAMEFULNESSES": "BLAMEFULNESS, the state of being blameful [n]\n",
  "BLAMELESS": "without blame [adj BLAMELESSLY]\n",
  "BLAMELESSLY": "BLAMELESS, without blame [adv]\n",
  "BLAMELESSNESS": "the state of being blameless [n -ES]\n",
  "BLAMELESSNESSES": "BLAMELESSNESS, the state of being blameless [n]\n",
  "BLAMER": "one who blames [n -S]\n",
  "BLAMERS": "BLAMER, one who blames [n]\n",
  "BLAMES": "BLAME, to find fault with [v]\n",
  "BLAMESTORM": "(of colleagues in a business, government, etc.) to meet in order to apportion blame for an error or failure [v -ED, -ING, -S]\n",
  "BLAMESTORMED": "BLAMESTORM, (of colleagues in a business, government, etc.) to meet in order to apportion blame for an error or failure [v]\n",
  "BLAMESTORMING": "meeting in order to apportion blame for an error or failure [n -S]\n",
  "BLAMESTORMINGS": "BLAMESTORMING, meeting in order to apportion blame for an error or failure [n]\n",
  "BLAMESTORMS": "BLAMESTORM, (of colleagues in a business, government, etc.) to meet in order to apportion blame for an error or failure [v]\n",
  "BLAMEWORTHIER": "BLAMEWORTHY, worthy of censure [adj]\n",
  "BLAMEWORTHIEST": "BLAMEWORTHY, worthy of censure [adj]\n",
  "BLAMEWORTHINESS": "the state of being blameworthy [n]\n",
  "BLAMEWORTHY": "worthy of censure [adj BLAMEWORTHIER, BLAMEWORTHIEST]\n",
  "BLAMING": "BLAME, to find fault with [v]\n",
  "BLAMMED": "BLAM, to make a sound like a gunshot [v]\n",
  "BLAMMING": "BLAM, to make a sound like a gunshot [v]\n",
  "BLAMS": "BLAM, to make a sound like a gunshot [v]\n",
  "BLANCH": "to whiten [v -ED, -ING, -ES]\n",
  "BLANCHED": "BLANCH, to whiten [v]\n",
  "BLANCHER": "one who, or that which, blanches or whitens [n -S]\n",
  "BLANCHERS": "BLANCHER, one who, or that which, blanches or whitens [n]\n",
  "BLANCHES": "BLANCH, to whiten [v]\n",
  "BLANCHING": "BLANCH, to whiten [v]\n",
  "BLANCHISSEUSE": "(French) a laundress [n -S]\n",
  "BLANCHISSEUSES": "BLANCHISSEUSE, (French) a laundress [n]\n",
  "BLANCMANGE": "(French) an opaque jelly made with isinglass or gelatin and milk or (now usually) cornflour and milk, often flavoured and sweetened [n -S]\n",
  "BLANCMANGES": "BLANCMANGE, (French) an opaque jelly made with isinglass or gelatin and milk or (now usually) cornflour and milk, often flavoured and sweetened [n]\n",
  "BLANCO": "(tradename) a white substance used for treating uniform belts etc. [n -S] / to whiten with blanco [v -ED, -ING, -S]\n",
  "BLANCOED": "BLANCO, to whiten with blanco [v]\n",
  "BLANCOING": "BLANCO, to whiten with blanco [v]\n",
  "BLANCOS": "BLANCO, to whiten with blanco [v]\n",
  "BLAND": "neutral-tasting, insipid [adj BLANDER, BLANDEST, BLANDLY] / to become bland [v -ED, -ING, -S]\n",
  "BLANDED": "BLAND, to become bland [v]\n",
  "BLANDER": "BLAND, neutral-tasting, insipid [adj]\n",
  "BLANDEST": "BLAND, neutral-tasting, insipid [adj]\n",
  "BLANDING": "BLAND, to become bland [v]\n",
  "BLANDISH": "to coax and flatter [v -ED, -ING, -ES]\n",
  "BLANDISHED": "BLANDISH, to coax and flatter [v]\n",
  "BLANDISHER": "one who uses blandishments [n -S]\n",
  "BLANDISHERS": "BLANDISHER, one who uses blandishments [n]\n",
  "BLANDISHES": "BLANDISH, to coax and flatter [v]\n",
  "BLANDISHING": "BLANDISH, to coax and flatter [v]\n",
  "BLANDISHMENT": "something that tends to coax or cajole [n -S]\n",
  "BLANDISHMENTS": "BLANDISHMENT, something that tends to coax or cajole [n]\n",
  "BLANDLY": "BLAND, neutral-tasting, insipid [adv]\n",
  "BLANDNESS": "something that is boringly ordinary [n -ES]\n",
  "BLANDNESSES": "BLANDNESS, something that is boringly ordinary [n]\n",
  "BLANDS": "BLAND, to become bland [v]\n",
  "BLANK": "empty [adj BLANKER, BLANKEST, BLANKLY] / to delete [v -ED, -ING, -S]\n",
  "BLANKED": "BLANK, to delete [v]\n",
  "BLANKER": "BLANK, empty [adj]\n",
  "BLANKEST": "BLANK, empty [adj]\n",
  "BLANKET": "to cover uniformly [v -ED, -ING, -S]\n",
  "BLANKETED": "BLANKET, to cover uniformly [v]\n",
  "BLANKETFLOWER": "another name for gaillardia [n -S]\n",
  "BLANKETFLOWERS": "BLANKETFLOWER, another name for gaillardia [n]\n",
  "BLANKETIES": "BLANKETY, an unmentionable word [n]\n",
  "BLANKETING": "cloth for blankets [n -S]\n",
  "BLANKETINGS": "BLANKETING, cloth for blankets [n]\n",
  "BLANKETLIKE": "like a blanket [adj]\n",
  "BLANKETS": "BLANKET, to cover uniformly [v]\n",
  "BLANKETWEED": "a rapidly spreading green filamentous alga that forms in ponds [n -S]\n",
  "BLANKETWEEDS": "BLANKETWEED, a rapidly spreading green filamentous alga that forms in ponds [n]\n",
  "BLANKETY": "an unmentionable word [n BLANKETIES]\n",
  "BLANKIE": "a child's blanket, also BLANKY [n -S]\n",
  "BLANKIES": "BLANKIE, a child's blanket, also BLANKY [n]\n",
  "BLANKING": "the act of blanking, ignoring someone [n -S]\n",
  "BLANKINGS": "BLANKING, the act of blanking, ignoring someone [n]\n",
  "BLANKLY": "BLANK, empty [adv]\n",
  "BLANKNESS": "emptiness [n -ES]\n",
  "BLANKNESSES": "BLANKNESS, emptiness [n]\n",
  "BLANKS": "BLANK, to delete [v]\n",
  "BLANKY": "a child's blanket, also BLANKIE [n BLANKIES]\n",
  "BLANQUET": "(French) a variety of pear [n -S]\n",
  "BLANQUETS": "BLANQUET, (French) a variety of pear [n]\n",
  "BLANQUETTE": "(French) a stew based on lamb, chicken and veal [n -S]\n",
  "BLANQUETTES": "BLANQUETTE, (French) a stew based on lamb, chicken and veal [n]\n",
  "BLARE": "to sound loudly [v BLARED, BLARING, BLARES]\n",
  "BLARED": "BLARE, to sound loudly [v]\n",
  "BLARES": "BLARE, to sound loudly [v]\n",
  "BLARING": "BLARE, to sound loudly [v]\n",
  "BLARNEY": "to cajole, flatter [v -ED, -ING, -S]\n",
  "BLARNEYED": "BLARNEY, to cajole, flatter [v]\n",
  "BLARNEYING": "BLARNEY, to cajole, flatter [v]\n",
  "BLARNEYS": "BLARNEY, to cajole, flatter [v]\n",
  "BLART": "to shout loudly and harshly [v -ED, -ING, -S]\n",
  "BLARTED": "BLART, to shout loudly and harshly [v]\n",
  "BLARTING": "BLART, to shout loudly and harshly [v]\n",
  "BLARTS": "BLART, to shout loudly and harshly [v]\n",
  "BLASE": "(French) having the sensibilities deadened by excess or frequency of enjoyment [adj]\n",
  "BLASH": "(Scots) to splash [v -ED, -ING, -ES]\n",
  "BLASHED": "BLASH, (Scots) to splash [v]\n",
  "BLASHES": "BLASH, (Scots) to splash [v]\n",
  "BLASHIER": "BLASHY, showery; of beer or tea, watery and thin [adj]\n",
  "BLASHIEST": "BLASHY, showery; of beer or tea, watery and thin [adj]\n",
  "BLASHING": "BLASH, (Scots) to splash [v]\n",
  "BLASHY": "showery; of beer or tea, watery and thin [adj BLASHIER, BLASHIEST]\n",
  "BLASPHEME": "to speak impiously or contemptuously [v BLASPHEMED, BLASPHEMING, BLASPHEMES]\n",
  "BLASPHEMED": "BLASPHEME, to speak impiously or contemptuously [v]\n",
  "BLASPHEMER": "one who blasphemes [n -S]\n",
  "BLASPHEMERS": "BLASPHEMER, one who blasphemes [n]\n",
  "BLASPHEMES": "BLASPHEME, to speak impiously or contemptuously [v]\n",
  "BLASPHEMIES": "BLASPHEMY, impious speech [n]\n",
  "BLASPHEMING": "BLASPHEME, to speak impiously or contemptuously [v]\n",
  "BLASPHEMOUS": "related to blasphemy [adj]\n",
  "BLASPHEMOUSLY": "BLASPHEMOUS, related to blasphemy [adv]\n",
  "BLASPHEMOUSNESS": "the state of being blasphemous [n]\n",
  "BLASPHEMY": "impious speech [n BLASPHEMIES]\n",
  "BLAST": "to use explosives [v -ED, -ING, -S]\n",
  "BLASTED": "BLAST, to use explosives [v]\n",
  "BLASTEMA": "the protoplasmic part of an ovum, distinguished from the yolk [n BLASTEMAS or BLASTEMATA]\n",
  "BLASTEMAL": "relating to the blastema, the protoplasmic part of an ovum [adj]\n",
  "BLASTEMAS": "BLASTEMA, the protoplasmic part of an ovum, distinguished from the yolk [n]\n",
  "BLASTEMATA": "BLASTEMA, the protoplasmic part of an ovum, distinguished from the yolk [n]\n",
  "BLASTEMATIC": "of or like a blastema [adj]\n",
  "BLASTEMIC": "of or like a blastema, the protoplasmic part of an ovum [adj]\n",
  "BLASTER": "one who blasts [n -S]\n",
  "BLASTERS": "BLASTER, one who blasts [n]\n",
  "BLASTHOLE": "a hole containing an explosive charge for blasting [n -S]\n",
  "BLASTHOLES": "BLASTHOLE, a hole containing an explosive charge for blasting [n]\n",
  "BLASTIE": "a dwarf [n -S]\n",
  "BLASTIER": "BLASTY, characterised by gusts of wind [adj]\n",
  "BLASTIES": "BLASTIE, a dwarf [n]\n",
  "BLASTIEST": "BLASTY, characterised by gusts of wind [adj]\n",
  "BLASTING": "the act of one that blasts [n -S]\n",
  "BLASTINGS": "BLASTING, the act of one that blasts [n]\n",
  "BLASTMENT": "(Shakespeare) a blight [n -S]\n",
  "BLASTMENTS": "BLASTMENT, (Shakespeare) a blight [n]\n",
  "BLASTOCHYLE": "the fluid in a blastocoel [n -S]\n",
  "BLASTOCHYLES": "BLASTOCHYLE, the fluid in a blastocoel [n]\n",
  "BLASTOCOEL": "the cavity inside a blastula, also BLASTOCOELE [n -S]\n",
  "BLASTOCOELE": "the cavity inside a blastula, also BLASTOCOEL [n -S]\n",
  "BLASTOCOELES": "BLASTOCOELE, the cavity inside a blastula, also BLASTOCOEL [n]\n",
  "BLASTOCOELIC": "of or like a blastocoel [adj]\n",
  "BLASTOCOELS": "BLASTOCOEL, the cavity inside a blastula, also BLASTOCOELE [n]\n",
  "BLASTOCYST": "a mammalian blastula in which some differentiation of cells has occurred [n -S]\n",
  "BLASTOCYSTS": "BLASTOCYST, a mammalian blastula in which some differentiation of cells has occurred [n]\n",
  "BLASTODERM": "the germinal membrane in an ovum, from which the embryo is developed [n -S]\n",
  "BLASTODERMIC": "of or like a blastoderm [adj]\n",
  "BLASTODERMS": "BLASTODERM, the germinal membrane in an ovum, from which the embryo is developed [n]\n",
  "BLASTODISC": "the embryo-forming portion of an egg with discoid cleavage [n -S]\n",
  "BLASTODISCS": "BLASTODISC, the embryo-forming portion of an egg with discoid cleavage [n]\n",
  "BLASTOFF": "the launching of a rocket [n -S]\n",
  "BLASTOFFS": "BLASTOFF, the launching of a rocket [n]\n",
  "BLASTOGENESES": "BLASTOGENESIS, reproduction by budding [n]\n",
  "BLASTOGENESIS": "reproduction by budding [n BLASTOGENESES]\n",
  "BLASTOGENETIC": "related to blastogenesis, reproduction by budding, also BLASTOGENIC [adj]\n",
  "BLASTOGENIC": "related to blastogenesis, reproduction by budding, also BLASTOGENETIC [adj]\n",
  "BLASTOID": "one of the Blastoidea, a group of budlike calcareous fossil echinoderms [n -S]\n",
  "BLASTOIDS": "BLASTOID, one of the Blastoidea, a group of budlike calcareous fossil echinoderms [n]\n",
  "BLASTOMA": "a type of tumour [n BLASTOMAS or BLASTOMATA]\n",
  "BLASTOMAS": "BLASTOMA, a type of tumour [n]\n",
  "BLASTOMATA": "BLASTOMA, a type of tumour [n]\n",
  "BLASTOMERE": "one of the segments first formed by the division of the ovum [n -S]\n",
  "BLASTOMERES": "BLASTOMERE, one of the segments first formed by the division of the ovum [n]\n",
  "BLASTOMERIC": "like a blastomere [adj]\n",
  "BLASTOMYCOSES": "BLASTOMYCOSIS, any of several fungal infections [n]\n",
  "BLASTOMYCOSIS": "any of several fungal infections [n BLASTOMYCOSES]\n",
  "BLASTOPOR": "the opening of the archenteron in the gastrula that develops into the anus of some animals, also BLASTOPORE [n -S]\n",
  "BLASTOPORAL": "like a blastopor [adj]\n",
  "BLASTOPORE": "the opening of the archenteron in the gastrula that develops into the anus of some animals, also BLASTOPOR [n -S]\n",
  "BLASTOPORES": "BLASTOPORE, the opening of the archenteron in the gastrula that develops into the anus of some animals, also BLASTOPOR [n]\n",
  "BLASTOPORIC": "relating to a blastospore [adj]\n",
  "BLASTOPORS": "BLASTOPOR, the opening of the archenteron in the gastrula that develops into the anus of some animals, also BLASTOPORE [n]\n",
  "BLASTOSPHERE": "a blastula [n -S]\n",
  "BLASTOSPHERES": "BLASTOSPHERE, a blastula [n]\n",
  "BLASTOSPORE": "the orifice of a gastrula [n -S]\n",
  "BLASTOSPORES": "BLASTOSPORE, the orifice of a gastrula [n]\n",
  "BLASTS": "BLAST, to use explosives [v]\n",
  "BLASTULA": "(Greek) a hollow sphere of cells, one cell thick, formed in the cleavage of a fertilized ovum [n BLASTULAE or BLASTULAS]\n",
  "BLASTULAE": "BLASTULA, (Greek) a hollow sphere of cells, one cell thick, formed in the cleavage of a fertilized ovum [n]\n",
  "BLASTULAR": "relating to the blastula, a hollow sphere of cells, one cell thick, formed in the cleavage of a fertilized ovum [adj]\n",
  "BLASTULAS": "BLASTULA, (Greek) a hollow sphere of cells, one cell thick, formed in the cleavage of a fertilized ovum [n]\n",
  "BLASTULATION": "the act of forming a blastula [n -S]\n",
  "BLASTULATIONS": "BLASTULATION, the act of forming a blastula [n]\n",
  "BLASTY": "characterised by gusts of wind [adj BLASTIER, BLASTIEST]\n",
  "BLAT": "to bleat, cry like a sheep [v BLATTED, BLATTING, BLATS]\n",
  "BLATANCIES": "BLATANCY, something blatant [n]\n",
  "BLATANCY": "something blatant [n BLATANCIES]\n",
  "BLATANT": "offensively obvious, also BLATTANT [adj BLATANTLY]\n",
  "BLATANTLY": "BLATANT, offensively obvious, also BLATTANT [adv]\n",
  "BLATE": "(Scots) timidly awkward, bashful [adj BLATER, BLATEST] / to babble [v BLATED, BLATING, BLATES]\n",
  "BLATED": "BLATE, to babble [v]\n",
  "BLATER": "BLATE, (Scots) timidly awkward, bashful [adj]\n",
  "BLATES": "BLATE, to babble [v]\n",
  "BLATEST": "BLATE, (Scots) timidly awkward, bashful [adj]\n",
  "BLATHER": "to talk foolishly [v -ED, -ING, -S]\n",
  "BLATHERED": "BLATHER, to talk foolishly [v]\n",
  "BLATHERER": "one who blathers, also BLETHERER [n -S]\n",
  "BLATHERERS": "BLATHERER, one who blathers, also BLETHERER [n]\n",
  "BLATHERING": "the act of talking loquacious nonsense [n -S]\n",
  "BLATHERINGS": "BLATHERING, the act of talking loquacious nonsense [n]\n",
  "BLATHERS": "BLATHER, to talk foolishly [v]\n",
  "BLATHERSKITE": "(Scots) a garrulous talker of nonsense, also BLETHERANSKATE, BLETHERSKATE [n -S]\n",
  "BLATHERSKITES": "BLATHERSKITE, (Scots) a garrulous talker of nonsense, also BLETHERANSKATE, BLETHERSKATE [n]\n",
  "BLATING": "BLATE, to babble [v]\n",
  "BLATS": "BLAT, to bleat, cry like a sheep [v]\n",
  "BLATT": "(slang) a newspaper [n -S]\n",
  "BLATTANT": "(Spenser) offensively obvious, also BLATANT [adj]\n",
  "BLATTED": "BLAT, to bleat, cry like a sheep [v]\n",
  "BLATTER": "(Scots) to beat like rain on a window [v -ED, -ING, -S]\n",
  "BLATTERED": "BLATTER, (Scots) to beat like rain on a window [v]\n",
  "BLATTERING": "BLATTER, (Scots) to beat like rain on a window [v]\n",
  "BLATTERS": "BLATTER, (Scots) to beat like rain on a window [v]\n",
  "BLATTING": "BLAT, to bleat, cry like a sheep [v]\n",
  "BLATTS": "BLATT, (slang) a newspaper [n]\n",
  "BLAUBOK": "(South African) the blue buck, also BLOUBOK, BLUEBUCK [n -S]\n",
  "BLAUBOKS": "BLAUBOK, (South African) the blue buck, also BLOUBOK, BLUEBUCK [n]\n",
  "BLAUD": "(Scots) a fragment, a broken off piece [n -S] / to strike, disfigure [v -ED, -ING, -S]\n",
  "BLAUDED": "BLAUD, to strike, disfigure [v]\n",
  "BLAUDING": "BLAUD, to strike, disfigure [v]\n",
  "BLAUDS": "BLAUD, to strike, disfigure [v]\n",
  "BLAW": "(Scots) to blow [v BLAWED, BLAWN, BLAWING, BLAWS]\n",
  "BLAWED": "BLAW, (Scots) to blow [v]\n",
  "BLAWING": "BLAW, (Scots) to blow [v]\n",
  "BLAWN": "BLAW, (Scots) to blow [v]\n",
  "BLAWORT": "(Scots) the harebell; the corn bluebottle, also BLEWART [n -S]\n",
  "BLAWORTS": "BLAWORT, (Scots) the harebell; the corn bluebottle, also BLEWART [n]\n",
  "BLAWS": "BLAW, (Scots) to blow [v]\n",
  "BLAXPLOITATION": "exploitation of black people, esp. in the American film industry, by casting them in negative, stereotypical roles [n -S]\n",
  "BLAXPLOITATIONS": "BLAXPLOITATION, exploitation of black people, esp. in the American film industry, by casting them in negative, stereotypical roles [n]\n",
  "BLAY": "a small fish, also BLEY [n -S]\n",
  "BLAYS": "BLAY, a small fish, also BLEY [n]\n",
  "BLAZAR": "a type of active galaxy that is a more energetic source of radiation than a quasar [n -S]\n",
  "BLAZARS": "BLAZAR, a type of active galaxy that is a more energetic source of radiation than a quasar [n]\n",
  "BLAZE": "to burn with a strong flame [v BLAZED, BLAZING, BLAZES]\n",
  "BLAZED": "BLAZE, to burn with a strong flame [v]\n",
  "BLAZER": "a light jacket, often in the colours or with the badge of a club, school, etc. [n -S]\n",
  "BLAZERED": "wearing a blazer [adj]\n",
  "BLAZERS": "BLAZER, a light jacket, often in the colours or with the badge of a club, school, etc. [n]\n",
  "BLAZES": "BLAZE, to burn with a strong flame [v]\n",
  "BLAZING": "BLAZE, to burn with a strong flame [v]\n",
  "BLAZINGLY": "BLAZING, BLAZE, to burn with a strong flame [adv]\n",
  "BLAZON": "heraldic arms painted on knight's shield or surcoat [n -S] / to read such arms, also EMBLAZON [v -ED, -ING, -S]\n",
  "BLAZONED": "BLAZON, to read such arms, also EMBLAZON [v]\n",
  "BLAZONER": "a person who blazons arms, a herald [n -S]\n",
  "BLAZONERS": "BLAZONER, a person who blazons arms, a herald [n]\n",
  "BLAZONING": "the act of reading a coat of arms [n -S]\n",
  "BLAZONINGS": "BLAZONING, the act of reading a coat of arms [n]\n",
  "BLAZONRIES": "BLAZONRY, the correct description or depicting of heraldic devices or armorial bearings [n]\n",
  "BLAZONRY": "the correct description or depicting of heraldic devices or armorial bearings [n BLAZONRIES]\n",
  "BLAZONS": "BLAZON, to read such arms, also EMBLAZON [v]\n",
  "BLEACH": "to whiten [v -ED, -ING, -ES]\n",
  "BLEACHABLE": "able to be bleached [adj]\n",
  "BLEACHED": "BLEACH, to whiten [v]\n",
  "BLEACHER": "an outdoor uncovered bench for spectators at a sports ground [n -S]\n",
  "BLEACHERIES": "BLEACHERY, a place or an establishment where bleaching is done [n]\n",
  "BLEACHERITE": "one who sits in the bleachers, uncovered seats [n -S]\n",
  "BLEACHERITES": "BLEACHERITE, one who sits in the bleachers, uncovered seats [n]\n",
  "BLEACHERS": "BLEACHER, an outdoor uncovered bench for spectators at a sports ground [n]\n",
  "BLEACHERY": "a place or an establishment where bleaching is done [n BLEACHERIES]\n",
  "BLEACHES": "BLEACH, to whiten [v]\n",
  "BLEACHING": "the act of whitening [n -S]\n",
  "BLEACHINGS": "BLEACHING, the act of whitening [n]\n",
  "BLEAK": "a freshwater fish [n -S] / dull and cheerless [adj BLEAKER, BLEAKEST, BLEAKLY]\n",
  "BLEAKER": "BLEAK, dull and cheerless [adj]\n",
  "BLEAKEST": "BLEAK, dull and cheerless [adj]\n",
  "BLEAKISH": "somewhat bleak [adj]\n",
  "BLEAKLY": "BLEAK, dull and cheerless [adv]\n",
  "BLEAKNESS": "starkness [n -ES]\n",
  "BLEAKNESSES": "BLEAKNESS, starkness [n]\n",
  "BLEAKS": "BLEAK, a freshwater fish [n]\n",
  "BLEAKY": "bleak [adj]\n",
  "BLEAR": "of the eyes, dim, watery [adj BLEARER, BLEAREST] / to make bleary [v -ED, -ING, -S]\n",
  "BLEARED": "BLEAR, to make bleary [v]\n",
  "BLEARER": "BLEAR, of the eyes, dim, watery [adj]\n",
  "BLEAREST": "BLEAR, of the eyes, dim, watery [adj]\n",
  "BLEAREYED": "bleary eyed [adj]\n",
  "BLEARIER": "BLEARY, dim [adj]\n",
  "BLEARIEST": "BLEARY, dim [adj]\n",
  "BLEARILY": "BLEARY, dim [adv]\n",
  "BLEARINESS": "the state of being bleary [n -ES]\n",
  "BLEARINESSES": "BLEARINESS, the state of being bleary [n]\n",
  "BLEARING": "BLEAR, to make bleary [v]\n",
  "BLEARS": "BLEAR, to make bleary [v]\n",
  "BLEARY": "dim [adj BLEARIER, BLEARIEST, BLEARILY]\n",
  "BLEAT": "to cry like a sheep [v -ED, -ING, -S]\n",
  "BLEATED": "BLEAT, to cry like a sheep [v]\n",
  "BLEATER": "(colloquial) a complainer [n -S]\n",
  "BLEATERS": "BLEATER, (colloquial) a complainer [n]\n",
  "BLEATING": "the cry of a sheep [n -S]\n",
  "BLEATINGS": "BLEATING, the cry of a sheep [n]\n",
  "BLEATS": "BLEAT, to cry like a sheep [v]\n",
  "BLEB": "a bubble or blister [n -S]\n",
  "BLEBBIER": "BLEBBY, containing blebs, as, blebby glass [adj]\n",
  "BLEBBIEST": "BLEBBY, containing blebs, as, blebby glass [adj]\n",
  "BLEBBING": "the forming of a blister [n -S]\n",
  "BLEBBINGS": "BLEBBING, the forming of a blister [n]\n",
  "BLEBBY": "containing blebs, as, blebby glass [adj BLEBBIER, BLEBBIEST]\n",
  "BLEBS": "BLEB, a bubble or blister [n]\n",
  "BLECH": "an interjection expressing disgust [interj]\n",
  "BLED": "BLEED, to lose blood [v]\n",
  "BLEE": "(archaic) complexion [n -S]\n",
  "BLEED": "to lose blood [v BLED, BLEEDING, BLEEDS]\n",
  "BLEEDER": "one who bleeds [n -S]\n",
  "BLEEDERS": "BLEEDER, one who bleeds [n]\n",
  "BLEEDING": "a discharge of blood [n -S]\n",
  "BLEEDINGS": "BLEEDING, a discharge of blood [n]\n",
  "BLEEDS": "BLEED, to lose blood [v]\n",
  "BLEEP": "to emit a short high sound [v -ED, -ING, -S]\n",
  "BLEEPED": "BLEEP, to emit a short high sound [v]\n",
  "BLEEPER": "a device that bleeps [n -S]\n",
  "BLEEPERS": "BLEEPER, a device that bleeps [n]\n",
  "BLEEPING": "BLEEP, to emit a short high sound [v]\n",
  "BLEEPS": "BLEEP, to emit a short high sound [v]\n",
  "BLEES": "BLEE, (archaic) complexion [n]\n",
  "BLELLUM": "(Scots) an idle boring chatterer [n -S]\n",
  "BLELLUMS": "BLELLUM, (Scots) an idle boring chatterer [n]\n",
  "BLEMISH": "to mar [v -ED, -ING, -ES]\n",
  "BLEMISHED": "BLEMISH, to mar [v]\n",
  "BLEMISHER": "one who blemishes [n -S]\n",
  "BLEMISHERS": "BLEMISHER, one who blemishes [n]\n",
  "BLEMISHES": "BLEMISH, to mar [v]\n",
  "BLEMISHING": "BLEMISH, to mar [v]\n",
  "BLEMISHMENT": "(Spenser) a blemish [n -S]\n",
  "BLEMISHMENTS": "BLEMISHMENT, (Spenser) a blemish [n]\n",
  "BLENCH": "to shrink or flinch [v -ED, -ING, -ES]\n",
  "BLENCHED": "BLENCH, to shrink or flinch [v]\n",
  "BLENCHER": "a person stationed to prevent the escape of the deer, at a hunt [n -S]\n",
  "BLENCHERS": "BLENCHER, a person stationed to prevent the escape of the deer, at a hunt [n]\n",
  "BLENCHES": "BLENCH, to shrink or flinch [v]\n",
  "BLENCHING": "BLENCH, to shrink or flinch [v]\n",
  "BLEND": "to mix together [v BLENT or BLENDED, YBLENT, BLENDING, BLENDS]\n",
  "BLENDABLE": "capable of being blended [adj]\n",
  "BLENDE": "(German) a zinc sulphide, often containing some iron [n -S]\n",
  "BLENDED": "BLEND, to mix together [v]\n",
  "BLENDER": "one that blends [n -S]\n",
  "BLENDERS": "BLENDER, one that blends [n]\n",
  "BLENDES": "BLENDE, (German) a zinc sulphide, often containing some iron [n]\n",
  "BLENDING": "the act of blending [n -S]\n",
  "BLENDINGS": "BLENDING, the act of blending [n]\n",
  "BLENDS": "BLEND, to mix together [v]\n",
  "BLENNIES": "BLENNY, a long, slender, spiny-rayed marine fish [n]\n",
  "BLENNIOID": "any member of the blenny family of fishes [n -S]\n",
  "BLENNIOIDS": "BLENNIOID, any member of the blenny family of fishes [n]\n",
  "BLENNORRHEA": "an excessive discharge of watery mucus, esp. from the urethra or the vagina, also BLENNORRHOEA [n -S]\n",
  "BLENNORRHEAS": "BLENNORRHEA, an excessive discharge of watery mucus, esp. from the urethra or the vagina, also BLENNORRHOEA [n]\n",
  "BLENNORRHOEA": "an excessive discharge of watery mucus, esp. from the urethra or the vagina, also BLENNORRHEA [n -S]\n",
  "BLENNORRHOEAS": "BLENNORRHOEA, an excessive discharge of watery mucus, esp. from the urethra or the vagina, also BLENNORRHEA [n]\n",
  "BLENNY": "a long, slender, spiny-rayed marine fish [n BLENNIES]\n",
  "BLENT": "BLEND, to mix together [v]\n",
  "BLEOMYCIN": "a glycopeptide antibiotic drug used in the treatment of cancer and Hodgkins Disease [n -S]\n",
  "BLEOMYCINS": "BLEOMYCIN, a glycopeptide antibiotic drug used in the treatment of cancer and Hodgkins Disease [n]\n",
  "BLEPHARISM": "spasm of the eyelid [n -S]\n",
  "BLEPHARISMS": "BLEPHARISM, spasm of the eyelid [n]\n",
  "BLEPHARITIC": "relating to blepharitis, inflammation of the eyelid [adj]\n",
  "BLEPHARITIS": "inflammation of the eyelid [n -ES]\n",
  "BLEPHARITISES": "BLEPHARITIS, inflammation of the eyelid [n]\n",
  "BLEPHAROPLAST": "a basal body esp. of a flagellated cell [n -S]\n",
  "BLEPHAROPLASTS": "BLEPHAROPLAST, a basal body esp. of a flagellated cell [n]\n",
  "BLEPHAROPLASTY": "plastic surgery on the eyelid esp. to remove fatty or excess tissue [n]\n",
  "BLEPHAROSPASM": "a form of constant winking [n -S]\n",
  "BLEPHAROSPASMS": "BLEPHAROSPASM, a form of constant winking [n]\n",
  "BLERT": "(colloquial) a foolish person [n -S]\n",
  "BLERTS": "BLERT, (colloquial) a foolish person [n]\n",
  "BLESBOK": "(South African) a South African antelope, having a large white spot on the forehead, also BLESBUCK [n -S]\n",
  "BLESBOKS": "BLESBOK, (South African) a South African antelope, having a large white spot on the forehead, also BLESBUCK [n]\n",
  "BLESBUCK": "(South African) a South African antelope, having a large white spot on the forehead, also BLESBOK [n -S]\n",
  "BLESBUCKS": "BLESBUCK, (South African) a South African antelope, having a large white spot on the forehead, also BLESBOK [n]\n",
  "BLESS": "to sanctify [v BLESSED or BLEST, BLESSING, BLESSES] / (Spenser) to brandish [v BLIST, BLESSING, BLESSES]\n",
  "BLESSED": "holy [adj BLESSEDER, BLESSEDEST, BLESSEDLY]\n",
  "BLESSEDER": "BLESSED, holy [adj]\n",
  "BLESSEDEST": "BLESSED, holy [adj]\n",
  "BLESSEDLY": "BLESSED, holy [adv]\n",
  "BLESSEDNESS": "the state of being blessed [n -ES]\n",
  "BLESSEDNESSES": "BLESSEDNESS, the state of being blessed [n]\n",
  "BLESSER": "one who blesses [n -S]\n",
  "BLESSERS": "BLESSER, one who blesses [n]\n",
  "BLESSES": "BLESS, to sanctify [v]\n",
  "BLESSING": "a prayer, a wish for success [n -S]\n",
  "BLESSINGS": "BLESSING, a prayer, a wish for success [n]\n",
  "BLEST": "BLESS, to sanctify [v]\n",
  "BLET": "a form of decay in fruit which is overripe [n -S] / to decay like this [v BLETTED, BLETTING, BLETS]\n",
  "BLETHER": "to talk nonsense [v -ED, -ING, -S]\n",
  "BLETHERANSKATE": "(Scots) a garrulous talker of nonsense, also BLATHERSKITE, BLETHERSKATE [n -S]\n",
  "BLETHERANSKATES": "BLETHERANSKATE, (Scots) a garrulous talker of nonsense, also BLATHERSKITE, BLETHERSKATE [n]\n",
  "BLETHERATION": "blethering [n -S]\n",
  "BLETHERATIONS": "BLETHERATION, blethering [n]\n",
  "BLETHERED": "BLETHER, to talk nonsense [v]\n",
  "BLETHERER": "one who blethers, talks loquacious nonsense, also BLATHERER [n -S]\n",
  "BLETHERERS": "BLETHERER, one who blethers, talks loquacious nonsense, also BLATHERER [n]\n",
  "BLETHERING": "the act of talking loquacious nonsense [n -S]\n",
  "BLETHERINGS": "BLETHERING, the act of talking loquacious nonsense [n]\n",
  "BLETHERS": "BLETHER, to talk nonsense [v]\n",
  "BLETHERSKATE": "(Scots) a garrulous talker of nonsense, also BLATHERSKITE, BLETHERANSKATE [n -S]\n",
  "BLETHERSKATES": "BLETHERSKATE, (Scots) a garrulous talker of nonsense, also BLATHERSKITE, BLETHERANSKATE [n]\n",
  "BLETS": "BLET, to decay like this [v]\n",
  "BLETTED": "BLET, to decay like this [v]\n",
  "BLETTING": "BLET, to decay like this [v]\n",
  "BLEUATRE": "(French) bluish [adj]\n",
  "BLEW": "BLOW, to propel by a current of air [v]\n",
  "BLEWART": "(Scots) the harebell; the corn bluebottle, also BLAWORT [n -S]\n",
  "BLEWARTS": "BLEWART, (Scots) the harebell; the corn bluebottle, also BLAWORT [n]\n",
  "BLEWIT": "an edible wild mushroom of Europe and North America, with a pale buff or lilac cap and a lilac stem, also BLEWITS [n -S]\n",
  "BLEWITS": "a woodland fungus, also BLEWIT [n -ES]\n",
  "BLEWITSES": "BLEWITS, a woodland fungus, also BLEWIT [n]\n",
  "BLEY": "a small fish, also BLAY [n -S]\n",
  "BLEYS": "BLEY, a small fish, also BLAY [n]\n",
  "BLIGHT": "to cause decay [v -ED, -ING, -S]\n",
  "BLIGHTED": "BLIGHT, to cause decay [v]\n",
  "BLIGHTER": "an unpleasant person [n -S]\n",
  "BLIGHTERS": "BLIGHTER, an unpleasant person [n]\n",
  "BLIGHTIES": "BLIGHTY, a soldier's wound that gets him sent home [n]\n",
  "BLIGHTING": "causing decay [adj BLIGHTINGLY] / the act of blighting [n -S]\n",
  "BLIGHTINGLY": "BLIGHTING, causing decay [adv]\n",
  "BLIGHTINGS": "BLIGHTING, the act of blighting [n]\n",
  "BLIGHTS": "BLIGHT, to cause decay [v]\n",
  "BLIGHTY": "a soldier's wound that gets him sent home [n BLIGHTIES]\n",
  "BLIKSEM": "(South African) of surprise, shock etc. [interj]\n",
  "BLIMBING": "(Malay) an East Indian tree of the wood-sorrel family; its sour green fruit, used in chutneys, also BILIMBI, BILIMBING [n -S]\n",
  "BLIMBINGS": "BLIMBING, (Malay) an East Indian tree of the wood-sorrel family; its sour green fruit, used in chutneys, also BILIMBI, BILIMBING [n]\n",
  "BLIMEY": "an interjection expressing surprise and annoyance, also BLIMY [interj]\n",
  "BLIMP": "to swell out [v -ED, -ING, -S]\n",
  "BLIMPED": "BLIMP, to swell out [v]\n",
  "BLIMPERIES": "BLIMPERY, pompous behaviour [n]\n",
  "BLIMPERY": "pompous behaviour [n BLIMPERIES]\n",
  "BLIMPING": "BLIMP, to swell out [v]\n",
  "BLIMPISH": "like Colonel Blimp, pompous [adj]\n",
  "BLIMPISHLY": "BLIMPISH, like Colonel Blimp, pompous [adv]\n",
  "BLIMPISHNESS": "the state of being blimpish [n -ES]\n",
  "BLIMPISHNESSES": "BLIMPISHNESS, the state of being blimpish [n]\n",
  "BLIMPS": "BLIMP, to swell out [v]\n",
  "BLIMY": "an interjection expressing surprise and annoyance, also BLIMEY [interj]\n",
  "BLIN": "(Russian) a small buckwheat pancake, also BLINI, BLINTZ, BLINTZE [n BLINI, BLINIS or BLINY] / (Spenser) to cease from, stop [v BLINNED, BLINNING, BLINS]\n",
  "BLIND": "to make sightless [v -ED, -ING, -S] / sightless [adj BLINDER, BLINDEST, BLINDLY]\n",
  "BLINDAGE": "a cover or protection for an advanced trench or approach, formed of fascines and earth supported by a framework [n -S]\n",
  "BLINDAGES": "BLINDAGE, a cover or protection for an advanced trench or approach, formed of fascines and earth supported by a framework [n]\n",
  "BLINDED": "BLIND, to make sightless [v]\n",
  "BLINDER": "a thing that blinds [n -S]\n",
  "BLINDERS": "BLINDER, a thing that blinds [n]\n",
  "BLINDEST": "BLIND, sightless [adj]\n",
  "BLINDFISH": "an eyeless fish of the Kentucky Mammoth Cave [n -ES]\n",
  "BLINDFISHES": "BLINDFISH, an eyeless fish of the Kentucky Mammoth Cave [n]\n",
  "BLINDFOLD": "to cover someone's eyes to prevent them seeing [v -ED, -ING, -S]\n",
  "BLINDFOLDED": "BLINDFOLD, to cover someone's eyes to prevent them seeing [v]\n",
  "BLINDFOLDING": "BLINDFOLD, to cover someone's eyes to prevent them seeing [v]\n",
  "BLINDFOLDS": "BLINDFOLD, to cover someone's eyes to prevent them seeing [v]\n",
  "BLINDGUT": "the caecum [n -S]\n",
  "BLINDGUTS": "BLINDGUT, the caecum [n]\n",
  "BLINDING": "causing blindness, dazzling [adj BLINDINGLY] / the act of blinding [n -S]\n",
  "BLINDINGLY": "BLINDING, causing blindness, dazzling [adv]\n",
  "BLINDINGS": "BLINDING, the act of blinding [n]\n",
  "BLINDLESS": "without blinds [adj]\n",
  "BLINDLY": "BLIND, sightless [adv]\n",
  "BLINDNESS": "the state of being blind [n -ES]\n",
  "BLINDNESSES": "BLINDNESS, the state of being blind [n]\n",
  "BLINDS": "BLIND, to make sightless [v]\n",
  "BLINDSIDE": "to hit unexpectedly; to surprise unpleasantly [v BLINDSIDED, BLINDSIDING, BLINDSIDES]\n",
  "BLINDSIDED": "BLINDSIDE, to hit unexpectedly; to surprise unpleasantly [v]\n",
  "BLINDSIDES": "BLINDSIDE, to hit unexpectedly; to surprise unpleasantly [v]\n",
  "BLINDSIDING": "BLINDSIDE, to hit unexpectedly; to surprise unpleasantly [v]\n",
  "BLINDSIGHT": "the ability to respond to visual stimuli without having any conscious visual experience; it can occur after some forms of brain damage [n -S]\n",
  "BLINDSIGHTS": "BLINDSIGHT, the ability to respond to visual stimuli without having any conscious visual experience; it can occur after some forms of brain damage [n]\n",
  "BLINDSTOREY": "a storey without windows, such as a gallery in a Gothic church, also BLINDSTORY [n -S]\n",
  "BLINDSTOREYS": "BLINDSTOREY, a storey without windows, such as a gallery in a Gothic church, also BLINDSTORY [n]\n",
  "BLINDSTORIES": "BLINDSTORY, a storey without windows, such as a gallery in a Gothic church, also BLINDSTOREY [n]\n",
  "BLINDSTORY": "a storey without windows, such as a gallery in a Gothic church, also BLINDSTOREY [n BLINDSTORIES]\n",
  "BLINDWORM": "a slowworm [n -S]\n",
  "BLINDWORMS": "BLINDWORM, a slowworm [n]\n",
  "BLING": "flashy [adj BLINGER, BLINGEST] / to adopt a flamboyant appearance [v -ED, -ING, -S]\n",
  "BLINGED": "BLING, to adopt a flamboyant appearance [v]\n",
  "BLINGER": "BLING, flashy [adj]\n",
  "BLINGEST": "BLING, flashy [adj]\n",
  "BLINGIER": "BLINGY, bling, flashy [adj]\n",
  "BLINGIEST": "BLINGY, bling, flashy [adj]\n",
  "BLINGING": "flashy and expensive [adj]\n",
  "BLINGLISH": "English mixed with black slang [n -ES]\n",
  "BLINGLISHES": "BLINGLISH, English mixed with black slang [n]\n",
  "BLINGS": "BLING, to adopt a flamboyant appearance [v]\n",
  "BLINGY": "bling, flashy [adj BLINGIER, BLINGIEST]\n",
  "BLINI": "a small buckwheat pancake, also BLIN, BLINTZ, BLINTZE [n -S]\n",
  "BLINIS": "BLINI, a small buckwheat pancake, also BLIN, BLINTZ, BLINTZE [n]\n",
  "BLINK": "to open and shut the eyes quickly [v -ED, -ING, -S]\n",
  "BLINKARD": "(archaic) one who blinks or has weak eyes [n -S]\n",
  "BLINKARDS": "BLINKARD, (archaic) one who blinks or has weak eyes [n]\n",
  "BLINKED": "BLINK, to open and shut the eyes quickly [v]\n",
  "BLINKER": "a leather flap to prevent a horse from seeing sideways or backwards [n -S] / to put blinkers on [v -ED, -ING, -S]\n",
  "BLINKERED": "BLINKER, to put blinkers on [v]\n",
  "BLINKERING": "BLINKER, to put blinkers on [v]\n",
  "BLINKERS": "BLINKER, to put blinkers on [v]\n",
  "BLINKING": "BLINK, to open and shut the eyes quickly [v]\n",
  "BLINKS": "BLINK, to open and shut the eyes quickly [v]\n",
  "BLINNED": "BLIN, (Spenser) to cease from, stop [v]\n",
  "BLINNING": "BLIN, (Spenser) to cease from, stop [v]\n",
  "BLINS": "BLIN, (Spenser) to cease from, stop [v]\n",
  "BLINTZ": "(Yiddish) a thin filled pancake, also BLIN, BLINI, BLINTZE [n -ES]\n",
  "BLINTZE": "(Yiddish) a thin filled pancake, also BLIN, BLINI, BLINTZ [n -S]\n",
  "BLINTZES": "BLINTZ, (Yiddish) a thin filled pancake, also BLIN, BLINI, BLINTZE [n]\n",
  "BLINY": "BLIN, (Russian) a small buckwheat pancake, also BLINI, BLINTZ, BLINTZE [n]\n",
  "BLIP": "to remove sound from a recording [v BLIPPED, BLIPPING, BLIPS]\n",
  "BLIPPED": "BLIP, to remove sound from a recording [v]\n",
  "BLIPPING": "BLIP, to remove sound from a recording [v]\n",
  "BLIPS": "BLIP, to remove sound from a recording [v]\n",
  "BLIPVERT": "a very short advertisement on television [n -S]\n",
  "BLIPVERTS": "BLIPVERT, a very short advertisement on television [n]\n",
  "BLISS": "to experience ecstasy [v -ED, -ING, -ES]\n",
  "BLISSED": "BLISS, to experience ecstasy [v]\n",
  "BLISSES": "BLISS, to experience ecstasy [v]\n",
  "BLISSFUL": "very happy [adj BLISSFULLY]\n",
  "BLISSFULLY": "BLISSFUL, very happy [adv]\n",
  "BLISSFULNESS": "the state of being blissful [n -ES]\n",
  "BLISSFULNESSES": "BLISSFULNESS, the state of being blissful [n]\n",
  "BLISSING": "BLISS, to experience ecstasy [v]\n",
  "BLISSLESS": "destitute of bliss [adj]\n",
  "BLIST": "BLESS, to sanctify [v]\n",
  "BLISTER": "to cause fluid filled swellings on the skin [v -ED, -ING, -S]\n",
  "BLISTERED": "BLISTER, to cause fluid filled swellings on the skin [v]\n",
  "BLISTERIER": "BLISTERY, having blisters [adj]\n",
  "BLISTERIEST": "BLISTERY, having blisters [adj]\n",
  "BLISTERING": "BLISTER, to cause fluid filled swellings on the skin [v]\n",
  "BLISTERINGLY": "BLISTERING, BLISTER, to cause fluid filled swellings on the skin [adv]\n",
  "BLISTERS": "BLISTER, to cause fluid filled swellings on the skin [v]\n",
  "BLISTERY": "having blisters [adj BLISTERIER, BLISTERIEST]\n",
  "BLIT": "to transfer a large array of bits between different locations in a computer's memory [v BLITTED, BLITTING, BLITS]\n",
  "BLITE": "a genus of herbs of the goosefoot family [n -S]\n",
  "BLITES": "BLITE, a genus of herbs of the goosefoot family [n]\n",
  "BLITHE": "merry [adj BLITHER, BLITHEST, BLITHELY]\n",
  "BLITHEFUL": "joyous [adj]\n",
  "BLITHELY": "BLITHE, merry [adv]\n",
  "BLITHENESS": "the state of being blithe [n -ES]\n",
  "BLITHENESSES": "BLITHENESS, the state of being blithe [n]\n",
  "BLITHER": "to talk loquacious nonsense, also BLATHER, BLETHER [v -ED, -ING, -S]\n",
  "BLITHERED": "BLITHER, to talk loquacious nonsense, also BLATHER, BLETHER [v]\n",
  "BLITHERING": "BLITHER, to talk loquacious nonsense, also BLATHER, BLETHER [v]\n",
  "BLITHERS": "BLITHER, to talk loquacious nonsense, also BLATHER, BLETHER [v]\n",
  "BLITHESOME": "gay, merry [adj BLITHESOMELY]\n",
  "BLITHESOMELY": "BLITHESOME, gay, merry [adv]\n",
  "BLITHESOMENESS": "the state of being blithesome [n]\n",
  "BLITHEST": "BLITHE, merry [adj]\n",
  "BLITS": "BLIT, to transfer a large array of bits between different locations in a computer's memory [v]\n",
  "BLITTED": "BLIT, to transfer a large array of bits between different locations in a computer's memory [v]\n",
  "BLITTER": "a chip or system that performs blit transfers [n -S]\n",
  "BLITTERS": "BLITTER, a chip or system that performs blit transfers [n]\n",
  "BLITTING": "BLIT, to transfer a large array of bits between different locations in a computer's memory [v]\n",
  "BLITZ": "(German) to wage a bombing attack from the air [v -ED, -ING, -ES]\n",
  "BLITZED": "BLITZ, (German) to wage a bombing attack from the air [v]\n",
  "BLITZER": "one who blitzes [n -S]\n",
  "BLITZERS": "BLITZER, one who blitzes [n]\n",
  "BLITZES": "BLITZ, (German) to wage a bombing attack from the air [v]\n",
  "BLITZING": "BLITZ, (German) to wage a bombing attack from the air [v]\n",
  "BLITZKRIEG": "(German) a rapid advance in warfare [n -S]\n",
  "BLITZKRIEGS": "BLITZKRIEG, (German) a rapid advance in warfare [n]\n",
  "BLIVE": "(Spenser) immediately, also BELIVE, BYLIVE [adv]\n",
  "BLIZZARD": "to rage like a snowstorm [v -ED, -ING, -S]\n",
  "BLIZZARDED": "BLIZZARD, to rage like a snowstorm [v]\n",
  "BLIZZARDIER": "BLIZZARDY, like a blizzard [adj]\n",
  "BLIZZARDIEST": "BLIZZARDY, like a blizzard [adj]\n",
  "BLIZZARDING": "BLIZZARD, to rage like a snowstorm [v]\n",
  "BLIZZARDLY": "like a blizzard [adj]\n",
  "BLIZZARDS": "BLIZZARD, to rage like a snowstorm [v]\n",
  "BLIZZARDY": "like a blizzard [adj BLIZZARDIER, BLIZZARDIEST]\n",
  "BLOAT": "to swell [v -ED, -ING, -S]\n",
  "BLOATED": "BLOAT, to swell [v]\n",
  "BLOATEDNESS": "the state of being bloated [n -ES]\n",
  "BLOATEDNESSES": "BLOATEDNESS, the state of being bloated [n]\n",
  "BLOATER": "a smoked herring [n -S]\n",
  "BLOATERS": "BLOATER, a smoked herring [n]\n",
  "BLOATING": "a disease of cattle and sheep, aka hoove [n -S]\n",
  "BLOATINGS": "BLOATING, a disease of cattle and sheep, aka hoove [n]\n",
  "BLOATS": "BLOAT, to swell [v]\n",
  "BLOATWARE": "excessively large software [n -S]\n",
  "BLOATWARES": "BLOATWARE, excessively large software [n]\n",
  "BLOB": "to form into a globule [v BLOBBED, BLOBBING, BLOBS]\n",
  "BLOBBED": "BLOB, to form into a globule [v]\n",
  "BLOBBIER": "BLOBBY, having blobs, blob-shaped [adj]\n",
  "BLOBBIEST": "BLOBBY, having blobs, blob-shaped [adj]\n",
  "BLOBBING": "BLOB, to form into a globule [v]\n",
  "BLOBBY": "having blobs, blob-shaped [adj BLOBBIER, BLOBBIEST]\n",
  "BLOBS": "BLOB, to form into a globule [v]\n",
  "BLOC": "(French) a combination of parties, nations or other units to achieve a common purpose [n -S]\n",
  "BLOCK": "to obstruct [v -ED, -ING, -S]\n",
  "BLOCKABLE": "that can be blocked [adj]\n",
  "BLOCKADE": "to block with troops or ships [v BLOCKADED, BLOCKADING, BLOCKADES]\n",
  "BLOCKADED": "BLOCKADE, to block with troops or ships [v]\n",
  "BLOCKADER": "one who blockades [n -S]\n",
  "BLOCKADERS": "BLOCKADER, one who blockades [n]\n",
  "BLOCKADES": "BLOCKADE, to block with troops or ships [v]\n",
  "BLOCKADING": "BLOCKADE, to block with troops or ships [v]\n",
  "BLOCKAGE": "the act of blocking [n -S]\n",
  "BLOCKAGES": "BLOCKAGE, the act of blocking [n]\n",
  "BLOCKBOARD": "plywood board made of veneer enclosing thin strips of wood [n -S]\n",
  "BLOCKBOARDS": "BLOCKBOARD, plywood board made of veneer enclosing thin strips of wood [n]\n",
  "BLOCKBUST": "to bring about the sale of property in an area by stirring up fears of racial change [v -ED, -ING, -S]\n",
  "BLOCKBUSTED": "BLOCKBUST, to bring about the sale of property in an area by stirring up fears of racial change [v]\n",
  "BLOCKBUSTER": "a bomb large enough to destroy a city block [n -S]\n",
  "BLOCKBUSTERS": "BLOCKBUSTER, a bomb large enough to destroy a city block [n]\n",
  "BLOCKBUSTING": "the act of bringing about the sale of property in an area by stirring up fears of racial change [n -S]\n",
  "BLOCKBUSTINGS": "BLOCKBUSTING, the act of bringing about the sale of property in an area by stirring up fears of racial change [n]\n",
  "BLOCKBUSTS": "BLOCKBUST, to bring about the sale of property in an area by stirring up fears of racial change [v]\n",
  "BLOCKCHAIN": "a system in which records of transactions using bitcoins are stored and may be accessed by linked computers [n -S]\n",
  "BLOCKCHAINS": "BLOCKCHAIN, a system in which records of transactions using bitcoins are stored and may be accessed by linked computers [n]\n",
  "BLOCKED": "BLOCK, to obstruct [v]\n",
  "BLOCKER": "one that blocks [n -S]\n",
  "BLOCKERS": "BLOCKER, one that blocks [n]\n",
  "BLOCKHEAD": "a stupid person [n -S]\n",
  "BLOCKHEADED": "stupid [adj BLOCKHEADEDLY]\n",
  "BLOCKHEADEDLY": "BLOCKHEADED, stupid [adv]\n",
  "BLOCKHEADEDNESS": "the state of being blockheaded [n]\n",
  "BLOCKHEADS": "BLOCKHEAD, a stupid person [n]\n",
  "BLOCKHOLE": "the place where a batsman rests his bat [n -S]\n",
  "BLOCKHOLES": "BLOCKHOLE, the place where a batsman rests his bat [n]\n",
  "BLOCKHOUSE": "a wooden or concrete fortification with ports or loopholes for defensive fire, observation, etc. [n -S]\n",
  "BLOCKHOUSES": "BLOCKHOUSE, a wooden or concrete fortification with ports or loopholes for defensive fire, observation, etc. [n]\n",
  "BLOCKIE": "(Australian slang) the owner of a small property, esp. a farm [n -S]\n",
  "BLOCKIER": "BLOCKY, block-like [adj]\n",
  "BLOCKIES": "BLOCKIE, (Australian slang) the owner of a small property, esp. a farm [n]\n",
  "BLOCKIEST": "BLOCKY, block-like [adj]\n",
  "BLOCKINESS": "the state of being blocky, block-like [n -ES]\n",
  "BLOCKINESSES": "BLOCKINESS, the state of being blocky, block-like [n]\n",
  "BLOCKING": "an interruption to thought [n -S]\n",
  "BLOCKINGS": "BLOCKING, an interruption to thought [n]\n",
  "BLOCKISH": "block shaped [adj BLOCKISHLY]\n",
  "BLOCKISHLY": "BLOCKISH, block shaped [adv]\n",
  "BLOCKISHNESS": "the state of being blockish [n -ES]\n",
  "BLOCKISHNESSES": "BLOCKISHNESS, the state of being blockish [n]\n",
  "BLOCKS": "BLOCK, to obstruct [v]\n",
  "BLOCKSHIP": "a warship too old for action, but useful in port defence [n -S]\n",
  "BLOCKSHIPS": "BLOCKSHIP, a warship too old for action, but useful in port defence [n]\n",
  "BLOCKWORK": "hollow blocks of precast concrete used for building [n -S]\n",
  "BLOCKWORKS": "BLOCKWORK, hollow blocks of precast concrete used for building [n]\n",
  "BLOCKY": "block-like [adj BLOCKIER, BLOCKIEST]\n",
  "BLOCS": "BLOC, (French) a combination of parties, nations or other units to achieve a common purpose [n]\n",
  "BLOG": "to keep a personal online journal [v BLOGGED, BLOGGING, BLOGS]\n",
  "BLOGGABLE": "forming a suitable subject for a blog [adj]\n",
  "BLOGGED": "BLOG, to keep a personal online journal [v]\n",
  "BLOGGER": "one who maintains a weblog [n -S]\n",
  "BLOGGERATI": "those considered to be important or influential in the world of blogging [n]\n",
  "BLOGGERS": "BLOGGER, one who maintains a weblog [n]\n",
  "BLOGGIER": "BLOGGY, characteristic of blogging [adj]\n",
  "BLOGGIEST": "BLOGGY, characteristic of blogging [adj]\n",
  "BLOGGING": "the act or practice of maintaining a blog [n -S]\n",
  "BLOGGINGS": "BLOGGING, the act or practice of maintaining a blog [n]\n",
  "BLOGGY": "characteristic of blogging [adj BLOGGIER, BLOGGIEST]\n",
  "BLOGJACKING": "the use of another person's blog without his or her consent, esp. for malicious or satirical purposes [n -S]\n",
  "BLOGJACKINGS": "BLOGJACKING, the use of another person's blog without his or her consent, esp. for malicious or satirical purposes [n]\n",
  "BLOGOSPHERE": "the part of the World Wide Web that contains weblogs [n -S]\n",
  "BLOGOSPHERES": "BLOGOSPHERE, the part of the World Wide Web that contains weblogs [n]\n",
  "BLOGPOST": "a single entry in a blog [n -S]\n",
  "BLOGPOSTS": "BLOGPOST, a single entry in a blog [n]\n",
  "BLOGRING": "a number of blogs joined in a ring [n -S]\n",
  "BLOGRINGS": "BLOGRING, a number of blogs joined in a ring [n]\n",
  "BLOGROLL": "a list of blogs [n -S]\n",
  "BLOGROLLS": "BLOGROLL, a list of blogs [n]\n",
  "BLOGS": "BLOG, to keep a personal online journal [v]\n",
  "BLOGSTREAM": "the alternative news and information network growing up around weblogs [n -S]\n",
  "BLOGSTREAMS": "BLOGSTREAM, the alternative news and information network growing up around weblogs [n]\n",
  "BLOKART": "a land vehicle with a sail, also BLOWKART [n -S]\n",
  "BLOKARTING": "the sport of travelling by a land vehicle with a sail [n -S]\n",
  "BLOKARTINGS": "BLOKARTING, the sport of travelling by a land vehicle with a sail [n]\n",
  "BLOKARTS": "BLOKART, a land vehicle with a sail, also BLOWKART [n]\n",
  "BLOKE": "a fellow [n -S]\n",
  "BLOKEDOM": "the world of blokes [n -S]\n",
  "BLOKEDOMS": "BLOKEDOM, the world of blokes [n]\n",
  "BLOKEISH": "affecting a masculine style, also BLOKISH [adj]\n",
  "BLOKEISHNESS": "the state of being blokeish, affecting a masculine style, also BLOKISHNESS [n -ES]\n",
  "BLOKEISHNESSES": "BLOKEISHNESS, the state of being blokeish, affecting a masculine style, also BLOKISHNESS [n]\n",
  "BLOKES": "BLOKE, a fellow [n]\n",
  "BLOKEY": "like one of the blokes, also BLOKISH, BLOKEISH [adj BLOKIER, BLOKIEST]\n",
  "BLOKIER": "BLOKEY, like one of the blokes, also BLOKISH, BLOKEISH [adj]\n",
  "BLOKIEST": "BLOKEY, like one of the blokes, also BLOKISH, BLOKEISH [adj]\n",
  "BLOKISH": "like one of the blokes, also BLOKEY, BLOKEISH [adj]\n",
  "BLOKISHNESS": "the state of being blokish, affecting a masculine style, also BLOKEISHNESS [n -ES]\n",
  "BLOKISHNESSES": "BLOKISHNESS, the state of being blokish, affecting a masculine style, also BLOKEISHNESS [n]\n",
  "BLONCKET": "(Spenser) grey [adj]\n",
  "BLOND": "a fair complexioned and haired person [n -S] / light coloured, also BLONDE [adj BLONDER, BLONDEST]\n",
  "BLONDE": "fair [adj BLONDER, BLONDEST] / someone (female) having blond hair [n -S]\n",
  "BLONDENESS": "the state of being blonde [n -ES]\n",
  "BLONDENESSES": "BLONDENESS, the state of being blonde [n]\n",
  "BLONDER": "BLOND, light coloured, also BLONDE [adj]\n",
  "BLONDES": "BLONDE, someone (female) having blond hair [n]\n",
  "BLONDEST": "BLOND, light coloured, also BLONDE [adj]\n",
  "BLONDINE": "to bleach hair blond [v BLONDINED, BLONDINING, BLONDINES]\n",
  "BLONDINED": "BLONDINE, to bleach hair blond [v]\n",
  "BLONDINES": "BLONDINE, to bleach hair blond [v]\n",
  "BLONDING": "the act of dyeing blonde [n -S]\n",
  "BLONDINGS": "BLONDING, the act of dyeing blonde [n]\n",
  "BLONDINING": "BLONDINE, to bleach hair blond [v]\n",
  "BLONDISH": "somewhat blonde [adj]\n",
  "BLONDNESS": "the state of being blond [n -ES]\n",
  "BLONDNESSES": "BLONDNESS, the state of being blond [n]\n",
  "BLONDS": "BLOND, a fair complexioned and haired person [n]\n",
  "BLOOD": "the oxygenating fluid (red in the higher animals) circulating in the body, also BLUD, BLUDE, BLUID [n -S] / to stain with blood (the fluid circulated by the heart) [v -ED, -ING, -S]\n",
  "BLOODBATH": "a massacre [n -S]\n",
  "BLOODBATHS": "BLOODBATH, a massacre [n]\n",
  "BLOODCURDLING": "arousing fright or horror [adj BLOODCURDLINGLY]\n",
  "BLOODCURDLINGLY": "BLOODCURDLING, arousing fright or horror [adv]\n",
  "BLOODED": "BLOOD, to stain with blood (the fluid circulated by the heart) [v]\n",
  "BLOODFIN": "a freshwater fish [n -S]\n",
  "BLOODFINS": "BLOODFIN, a freshwater fish [n]\n",
  "BLOODGUILT": "the guilt of shedding blood, e.g. in murder [n -S]\n",
  "BLOODGUILTIER": "BLOODGUILTY, guilty of shedding blood [adj]\n",
  "BLOODGUILTIEST": "BLOODGUILTY, guilty of shedding blood [adj]\n",
  "BLOODGUILTINESS": "the state of being bloodguilty [n]\n",
  "BLOODGUILTS": "BLOODGUILT, the guilt of shedding blood, e.g. in murder [n]\n",
  "BLOODGUILTY": "guilty of shedding blood [adj BLOODGUILTIER, BLOODGUILTIEST]\n",
  "BLOODHOUND": "a large breed of hound formerly much used in tracking and police work [n -S]\n",
  "BLOODHOUNDS": "BLOODHOUND, a large breed of hound formerly much used in tracking and police work [n]\n",
  "BLOODIED": "BLOODY, to make bloodstained [v]\n",
  "BLOODIER": "BLOODY, stained with blood, also BLUDIE, BLUDY, BLUIDY [adj]\n",
  "BLOODIES": "BLOODY, to make bloodstained [v]\n",
  "BLOODIEST": "BLOODY, stained with blood, also BLUDIE, BLUDY, BLUIDY [adj]\n",
  "BLOODILY": "BLOODY, stained with blood, also BLUDIE, BLUDY, BLUIDY [adv]\n",
  "BLOODINESS": "the state of being bloody [n -ES]\n",
  "BLOODINESSES": "BLOODINESS, the state of being bloody [n]\n",
  "BLOODING": "a fox hunting ceremony [n -S]\n",
  "BLOODINGS": "BLOODING, a fox hunting ceremony [n]\n",
  "BLOODLESS": "without blood [adj BLOODLESSLY]\n",
  "BLOODLESSLY": "BLOODLESS, without blood [adv]\n",
  "BLOODLESSNESS": "the state of being bloodless [n -ES]\n",
  "BLOODLESSNESSES": "BLOODLESSNESS, the state of being bloodless [n]\n",
  "BLOODLETTER": "one who lets blood [n -S]\n",
  "BLOODLETTERS": "BLOODLETTER, one who lets blood [n]\n",
  "BLOODLETTING": "the act of letting blood [n -S]\n",
  "BLOODLETTINGS": "BLOODLETTING, the act of letting blood [n]\n",
  "BLOODLIKE": "like blood [adj]\n",
  "BLOODLINE": "all the individuals in a family line over a number of generations [n -S]\n",
  "BLOODLINES": "BLOODLINE, all the individuals in a family line over a number of generations [n]\n",
  "BLOODLUST": "desire for bloodshed [n -S]\n",
  "BLOODLUSTS": "BLOODLUST, desire for bloodshed [n]\n",
  "BLOODMOBILE": "a vehicle used to carry blood [n -S]\n",
  "BLOODMOBILES": "BLOODMOBILE, a vehicle used to carry blood [n]\n",
  "BLOODRED": "the colour of blood [adj]\n",
  "BLOODROOT": "a plant with a red root and red sap, and bearing a pretty, white flower in early spring, aka puccoon, redroot [n -S]\n",
  "BLOODROOTS": "BLOODROOT, a plant with a red root and red sap, and bearing a pretty, white flower in early spring, aka puccoon, redroot [n]\n",
  "BLOODS": "BLOOD, to stain with blood (the fluid circulated by the heart) [v]\n",
  "BLOODSHED": "the shedding of blood [n -S]\n",
  "BLOODSHEDS": "BLOODSHED, the shedding of blood [n]\n",
  "BLOODSHOT": "of the eye, red or inflamed with blood [adj]\n",
  "BLOODSPRENT": "(archaic) sprinkled with blood [adj]\n",
  "BLOODSTAIN": "a discoloration caused by blood [n -S]\n",
  "BLOODSTAINED": "stained with blood [adj]\n",
  "BLOODSTAINS": "BLOODSTAIN, a discoloration caused by blood [n]\n",
  "BLOODSTOCK": "horses of thoroughbred breeding [n -S]\n",
  "BLOODSTOCKS": "BLOODSTOCK, horses of thoroughbred breeding [n]\n",
  "BLOODSTONE": "a green chalcedony sprinkled with red spots resembling blood [n -S]\n",
  "BLOODSTONES": "BLOODSTONE, a green chalcedony sprinkled with red spots resembling blood [n]\n",
  "BLOODSTREAM": "the flowing blood in a circulatory system [n -S]\n",
  "BLOODSTREAMS": "BLOODSTREAM, the flowing blood in a circulatory system [n]\n",
  "BLOODSUCKER": "an animal that sucks blood [n -S]\n",
  "BLOODSUCKERS": "BLOODSUCKER, an animal that sucks blood [n]\n",
  "BLOODSUCKING": "sucking blood [adj]\n",
  "BLOODTHIRSTIER": "BLOODTHIRSTY, eager for bloodshed [adj]\n",
  "BLOODTHIRSTIEST": "BLOODTHIRSTY, eager for bloodshed [adj]\n",
  "BLOODTHIRSTILY": "BLOODTHIRSTY, eager for bloodshed [adv]\n",
  "BLOODTHIRSTY": "eager for bloodshed [adj BLOODTHIRSTIER, BLOODTHIRSTIEST, BLOODTHIRSTILY]\n",
  "BLOODWOOD": "a tree having the wood or the sap of the color of blood [n -S]\n",
  "BLOODWOODS": "BLOODWOOD, a tree having the wood or the sap of the color of blood [n]\n",
  "BLOODWORM": "the larva of the midge [n -S]\n",
  "BLOODWORMS": "BLOODWORM, the larva of the midge [n]\n",
  "BLOODWORT": "a plant with a red dye in the roots [n -S]\n",
  "BLOODWORTS": "BLOODWORT, a plant with a red dye in the roots [n]\n",
  "BLOODY": "to make bloodstained [v BLOODIED, BLOODYING, BLOODIES] / stained with blood, also BLUDIE, BLUDY, BLUIDY [adj BLOODIER, BLOODIEST]\n",
  "BLOODYING": "BLOODY, to make bloodstained [v]\n",
  "BLOOEY": "(slang) out of order, also BLOOIE [adj]\n",
  "BLOOIE": "(slang) out of order, also BLOOEY [adj]\n",
  "BLOOK": "a book serialized on a blog platform [n -S]\n",
  "BLOOKS": "BLOOK, a book serialized on a blog platform [n]\n",
  "BLOOM": "to bear flowers [v -ED, -ING, -S]\n",
  "BLOOMED": "BLOOM, to bear flowers [v]\n",
  "BLOOMER": "a large loaf with a rounded diagonally slashed top [n -S]\n",
  "BLOOMERIES": "BLOOMERY, a furnace for smelting iron [n]\n",
  "BLOOMERS": "BLOOMER, a large loaf with a rounded diagonally slashed top [n]\n",
  "BLOOMERY": "a furnace for smelting iron [n BLOOMERIES]\n",
  "BLOOMIER": "BLOOMY, covered with flowers [adj]\n",
  "BLOOMIEST": "BLOOMY, covered with flowers [adj]\n",
  "BLOOMING": "the act of coming into flower [n -S]\n",
  "BLOOMINGS": "BLOOMING, the act of coming into flower [n]\n",
  "BLOOMLESS": "destitute of bloom [adj]\n",
  "BLOOMS": "BLOOM, to bear flowers [v]\n",
  "BLOOMY": "covered with flowers [adj BLOOMIER, BLOOMIEST]\n",
  "BLOOP": "in baseball, to hit a short fly ball [v -ED, -ING, -S]\n",
  "BLOOPED": "BLOOP, in baseball, to hit a short fly ball [v]\n",
  "BLOOPER": "a public blunder [n -S]\n",
  "BLOOPERS": "BLOOPER, a public blunder [n]\n",
  "BLOOPIER": "BLOOPY, in baseball, being a hit that is a short fly ball [adj]\n",
  "BLOOPIEST": "BLOOPY, in baseball, being a hit that is a short fly ball [adj]\n",
  "BLOOPING": "BLOOP, in baseball, to hit a short fly ball [v]\n",
  "BLOOPS": "BLOOP, in baseball, to hit a short fly ball [v]\n",
  "BLOOPY": "in baseball, being a hit that is a short fly ball [adj BLOOPIER, BLOOPIEST]\n",
  "BLOOSME": "(Spenser) to bloom [v BLOOSMED, BLOOSMING, BLOOSMES]\n",
  "BLOOSMED": "BLOOSME, (Spenser) to bloom [v]\n",
  "BLOOSMES": "BLOOSME, (Spenser) to bloom [v]\n",
  "BLOOSMING": "BLOOSME, (Spenser) to bloom [v]\n",
  "BLOOTERED": "(Scots) drunk [adj]\n",
  "BLOQUISTE": "(Canadian) a supporter of autonomy for Quebec [n -S]\n",
  "BLOQUISTES": "BLOQUISTE, (Canadian) a supporter of autonomy for Quebec [n]\n",
  "BLORE": "(archaic) a violent gust of wind [n -S]\n",
  "BLORES": "BLORE, (archaic) a violent gust of wind [n]\n",
  "BLOSSOM": "to flourish and prosper [v -ED, -ING, -S]\n",
  "BLOSSOMED": "BLOSSOM, to flourish and prosper [v]\n",
  "BLOSSOMIER": "BLOSSOMY, full of blossoms, flowery [adj]\n",
  "BLOSSOMIEST": "BLOSSOMY, full of blossoms, flowery [adj]\n",
  "BLOSSOMING": "the act of blooming [n -S]\n",
  "BLOSSOMINGS": "BLOSSOMING, the act of blooming [n]\n",
  "BLOSSOMLESS": "without blossom [adj]\n",
  "BLOSSOMS": "BLOSSOM, to flourish and prosper [v]\n",
  "BLOSSOMY": "full of blossoms, flowery [adj BLOSSOMIER, BLOSSOMIEST]\n",
  "BLOT": "to spot or stain [v BLOTTED, BLOTTING, BLOTS]\n",
  "BLOTCH": "to mark with large spots [v -ED, -ING, -ES]\n",
  "BLOTCHED": "BLOTCH, to mark with large spots [v]\n",
  "BLOTCHES": "BLOTCH, to mark with large spots [v]\n",
  "BLOTCHIER": "BLOTCHY, covered with blotches [adj]\n",
  "BLOTCHIEST": "BLOTCHY, covered with blotches [adj]\n",
  "BLOTCHILY": "BLOTCHY, covered with blotches [adv]\n",
  "BLOTCHINESS": "the state of being blotchy [n -ES]\n",
  "BLOTCHINESSES": "BLOTCHINESS, the state of being blotchy [n]\n",
  "BLOTCHING": "a pattern of large spots [n -S]\n",
  "BLOTCHINGS": "BLOTCHING, a pattern of large spots [n]\n",
  "BLOTCHY": "covered with blotches [adj BLOTCHIER, BLOTCHIEST, BLOTCHILY]\n",
  "BLOTLESS": "without blots [adj]\n",
  "BLOTS": "BLOT, to spot or stain [v]\n",
  "BLOTTED": "BLOT, to spot or stain [v]\n",
  "BLOTTER": "a piece of ink-absorbing paper [n -S]\n",
  "BLOTTERS": "BLOTTER, a piece of ink-absorbing paper [n]\n",
  "BLOTTESQUE": "characterized by blots or heavy touches; coarsely depicted [adj] / a daub [n -S]\n",
  "BLOTTESQUES": "BLOTTESQUE, a daub [n]\n",
  "BLOTTIER": "BLOTTY, smudged [adj]\n",
  "BLOTTIEST": "BLOTTY, smudged [adj]\n",
  "BLOTTING": "the method for transferring biological molecules usually from a gel to a membrane filter [n -S]\n",
  "BLOTTINGS": "BLOTTING, the method for transferring biological molecules usually from a gel to a membrane filter [n]\n",
  "BLOTTO": "(slang) drunk [adj]\n",
  "BLOTTY": "smudged [adj BLOTTIER, BLOTTIEST]\n",
  "BLOUBOK": "(South African) the blue buck, also BLAUBOK, BLUEBUCK [n -S]\n",
  "BLOUBOKS": "BLOUBOK, (South African) the blue buck, also BLAUBOK, BLUEBUCK [n]\n",
  "BLOUSE": "to puff out loosely [v BLOUSED, BLOUSING, BLOUSES]\n",
  "BLOUSED": "BLOUSE, to puff out loosely [v]\n",
  "BLOUSES": "BLOUSE, to puff out loosely [v]\n",
  "BLOUSIER": "BLOUSY, coarse and ruddy-faced, also BLOWSY, BLOWZY [adj]\n",
  "BLOUSIEST": "BLOUSY, coarse and ruddy-faced, also BLOWSY, BLOWZY [adj]\n",
  "BLOUSILY": "BLOUSY, coarse and ruddy-faced, also BLOWSY, BLOWZY [adv]\n",
  "BLOUSING": "BLOUSE, to puff out loosely [v]\n",
  "BLOUSON": "(French) a loose outer garment gathered into a waistband [n -S]\n",
  "BLOUSONS": "BLOUSON, (French) a loose outer garment gathered into a waistband [n]\n",
  "BLOUSY": "coarse and ruddy-faced, also BLOWSY, BLOWZY [adj BLOUSIER, BLOUSIEST, BLOUSILY]\n",
  "BLOVIATE": "to speak pompously [v BLOVIATED, BLOVIATING, BLOVIATES]\n",
  "BLOVIATED": "BLOVIATE, to speak pompously [v]\n",
  "BLOVIATES": "BLOVIATE, to speak pompously [v]\n",
  "BLOVIATING": "BLOVIATE, to speak pompously [v]\n",
  "BLOVIATION": "long-winded speech [n -S]\n",
  "BLOVIATIONS": "BLOVIATION, long-winded speech [n]\n",
  "BLOW": "to propel by a current of air [v BLEW or BLOWED, BLOWN, BLOWING, BLOWS]\n",
  "BLOWBACK": "an escape of gases [n -S]\n",
  "BLOWBACKS": "BLOWBACK, an escape of gases [n]\n",
  "BLOWBALL": "a fluffy seed ball [n -S]\n",
  "BLOWBALLS": "BLOWBALL, a fluffy seed ball [n]\n",
  "BLOWBY": "leakage of exhaust fumes [n -S]\n",
  "BLOWBYS": "BLOWBY, leakage of exhaust fumes [n]\n",
  "BLOWDART": "a dart shot from a blowpipe [n -S]\n",
  "BLOWDARTS": "BLOWDART, a dart shot from a blowpipe [n]\n",
  "BLOWDOWN": "an accident in a nuclear reactor [n -S]\n",
  "BLOWDOWNS": "BLOWDOWN, an accident in a nuclear reactor [n]\n",
  "BLOWED": "BLOW, to propel by a current of air [v]\n",
  "BLOWER": "something or someone that blows [n -S]\n",
  "BLOWERS": "BLOWER, something or someone that blows [n]\n",
  "BLOWFISH": "a marine fish, aka globefish [n -ES]\n",
  "BLOWFISHES": "BLOWFISH, a marine fish, aka globefish [n]\n",
  "BLOWFLIES": "BLOWFLY, a type of fly [n]\n",
  "BLOWFLY": "a type of fly [n BLOWFLIES]\n",
  "BLOWGUN": "a long straight tube from which an arrow, pellet, etc. is blown by the breath, also BLOWPIPE, BLOWTUBE [n -S]\n",
  "BLOWGUNS": "BLOWGUN, a long straight tube from which an arrow, pellet, etc. is blown by the breath, also BLOWPIPE, BLOWTUBE [n]\n",
  "BLOWHARD": "a boaster [n -S]\n",
  "BLOWHARDS": "BLOWHARD, a boaster [n]\n",
  "BLOWHOLE": "a hole for breathing through; the nostril of a whale etc. [n -S]\n",
  "BLOWHOLES": "BLOWHOLE, a hole for breathing through; the nostril of a whale etc. [n]\n",
  "BLOWIE": "(Australian slang) a blowfly [n -S]\n",
  "BLOWIER": "BLOWY, windy, gusty [adj]\n",
  "BLOWIES": "BLOWIE, (Australian slang) a blowfly [n]\n",
  "BLOWIEST": "BLOWY, windy, gusty [adj]\n",
  "BLOWINESS": "the state of being blowy [n -ES]\n",
  "BLOWINESSES": "BLOWINESS, the state of being blowy [n]\n",
  "BLOWING": "the act of blowing, as in dry blowing, the use of a current of air to separate particles of mineral (esp. gold) from the material in which it is found [n -S]\n",
  "BLOWINGS": "BLOWING, the act of blowing, as in dry blowing, the use of a current of air to separate particles of mineral (esp. gold) from the material in which it is found [n]\n",
  "BLOWJOB": "(offensive) oral sex, fellatio [n -S]\n",
  "BLOWJOBS": "BLOWJOB, (offensive) oral sex, fellatio [n]\n",
  "BLOWKART": "a land vehicle with a sail, also BLOKART [n -S]\n",
  "BLOWKARTS": "BLOWKART, a land vehicle with a sail, also BLOKART [n]\n",
  "BLOWLAMP": "a portable lamp producing a jet of hot flame [n -S]\n",
  "BLOWLAMPS": "BLOWLAMP, a portable lamp producing a jet of hot flame [n]\n",
  "BLOWN": "BLOW, to propel by a current of air [v]\n",
  "BLOWOFF": "the expelling of gas [n -S]\n",
  "BLOWOFFS": "BLOWOFF, the expelling of gas [n]\n",
  "BLOWOUT": "an irregular depression excavated by wind, usually in previously deposited blown sand [n -S]\n",
  "BLOWOUTS": "BLOWOUT, an irregular depression excavated by wind, usually in previously deposited blown sand [n]\n",
  "BLOWPIPE": "a long straight tube from which an arrow, pellet, etc. is blown by the breath, also BLOWGUN, BLOWTUBE [n -S]\n",
  "BLOWPIPES": "BLOWPIPE, a long straight tube from which an arrow, pellet, etc. is blown by the breath, also BLOWGUN, BLOWTUBE [n]\n",
  "BLOWS": "BLOW, to propel by a current of air [v]\n",
  "BLOWSE": "a ruddy, fat-faced woman, also BLOWZE [n -S]\n",
  "BLOWSED": "blowsy, red-faced, also BLOWZED [adj]\n",
  "BLOWSES": "BLOWSE, a ruddy, fat-faced woman, also BLOWZE [n]\n",
  "BLOWSIER": "BLOWSY, coarse and ruddy-faced, also BLOUSY, BLOWZY [adj]\n",
  "BLOWSIEST": "BLOWSY, coarse and ruddy-faced, also BLOUSY, BLOWZY [adj]\n",
  "BLOWSILY": "BLOWSY, coarse and ruddy-faced, also BLOUSY, BLOWZY [adv]\n",
  "BLOWSINESS": "the state of being blowsy, also BLOWZINESS [n -ES]\n",
  "BLOWSINESSES": "BLOWSINESS, the state of being blowsy, also BLOWZINESS [n]\n",
  "BLOWSY": "coarse and ruddy-faced, also BLOUSY, BLOWZY [adj BLOWSIER, BLOWSIEST, BLOWSILY]\n",
  "BLOWTORCH": "(US) a blowlamp [n -ES] / to apply a blowtorch to [v -ED, -ING, -ES]\n",
  "BLOWTORCHED": "BLOWTORCH, to apply a blowtorch to [v]\n",
  "BLOWTORCHES": "BLOWTORCH, to apply a blowtorch to [v]\n",
  "BLOWTORCHING": "BLOWTORCH, to apply a blowtorch to [v]\n",
  "BLOWTUBE": "a long straight tube from which an arrow, pellet, etc. is blown by the breath, also BLOWGUN, BLOWPIPE [n -S]\n",
  "BLOWTUBES": "BLOWTUBE, a long straight tube from which an arrow, pellet, etc. is blown by the breath, also BLOWGUN, BLOWPIPE [n]\n",
  "BLOWUP": "an enlargement e.g. of a picture [n -S]\n",
  "BLOWUPS": "BLOWUP, an enlargement e.g. of a picture [n]\n",
  "BLOWY": "windy, gusty [adj BLOWIER, BLOWIEST]\n",
  "BLOWZE": "a ruddy, fat-faced woman, also BLOWSE [n -S]\n",
  "BLOWZED": "blowsy, red-faced, also BLOWSED [adj]\n",
  "BLOWZES": "BLOWZE, a ruddy, fat-faced woman, also BLOWSE [n]\n",
  "BLOWZIER": "BLOWZY, coarse and ruddy-faced, also BLOUSY, BLOWSY [adj]\n",
  "BLOWZIEST": "BLOWZY, coarse and ruddy-faced, also BLOUSY, BLOWSY [adj]\n",
  "BLOWZILY": "BLOWZY, coarse and ruddy-faced, also BLOUSY, BLOWSY [adv]\n",
  "BLOWZINESS": "the state of being blowzy, also BLOWSINESS [n -ES]\n",
  "BLOWZINESSES": "BLOWZINESS, the state of being blowzy, also BLOWSINESS [n]\n",
  "BLOWZY": "coarse and ruddy-faced, also BLOUSY, BLOWSY [adj BLOWZIER, BLOWZIEST, BLOWZILY]\n",
  "BLUB": "to weep [v BLUBBED, BLUBBING, BLUBS]\n",
  "BLUBBED": "BLUB, to weep [v]\n",
  "BLUBBER": "to weep effusively [v -ED, -ING, -S]\n",
  "BLUBBERED": "BLUBBER, to weep effusively [v]\n",
  "BLUBBERER": "one who blubbers [n -S]\n",
  "BLUBBERERS": "BLUBBERER, one who blubbers [n]\n",
  "BLUBBERIER": "BLUBBERY, swollen, protuberant [adj]\n",
  "BLUBBERIEST": "BLUBBERY, swollen, protuberant [adj]\n",
  "BLUBBERING": "BLUBBER, to weep effusively [v]\n",
  "BLUBBERS": "BLUBBER, to weep effusively [v]\n",
  "BLUBBERY": "swollen, protuberant [adj BLUBBERIER, BLUBBERIEST]\n",
  "BLUBBING": "BLUB, to weep [v]\n",
  "BLUBS": "BLUB, to weep [v]\n",
  "BLUCHER": "(German) a leather half-boot [n -S]\n",
  "BLUCHERS": "BLUCHER, (German) a leather half-boot [n]\n",
  "BLUD": "blood, in the sense of a close friend [n -S]\n",
  "BLUDE": "(Scots) blood, also BLOOD, BLUID [n -S]\n",
  "BLUDES": "BLUDE, (Scots) blood, also BLOOD, BLUID [n]\n",
  "BLUDGE": "(Australian slang) to loaf; to scrounge [v BLUDGED, BLUDGING, BLUDGES]\n",
  "BLUDGED": "BLUDGE, (Australian slang) to loaf; to scrounge [v]\n",
  "BLUDGEON": "to hit with a club [v -ED, -ING, -S]\n",
  "BLUDGEONED": "BLUDGEON, to hit with a club [v]\n",
  "BLUDGEONER": "one who bludgeons [n -S]\n",
  "BLUDGEONERS": "BLUDGEONER, one who bludgeons [n]\n",
  "BLUDGEONING": "BLUDGEON, to hit with a club [v]\n",
  "BLUDGEONS": "BLUDGEON, to hit with a club [v]\n",
  "BLUDGER": "(Australian slang) an idler, a scrounger [n -S]\n",
  "BLUDGERS": "BLUDGER, (Australian slang) an idler, a scrounger [n]\n",
  "BLUDGES": "BLUDGE, (Australian slang) to loaf; to scrounge [v]\n",
  "BLUDGING": "BLUDGE, (Australian slang) to loaf; to scrounge [v]\n",
  "BLUDIE": "(Scots) stained with blood, also BLOODY, BLUDY, BLUIDY [adj BLUDIER, BLUDIEST]\n",
  "BLUDIER": "BLUDY, (Scots) stained with blood, also BLOODY, BLUDIE, BLUIDY [adj]\n",
  "BLUDIEST": "BLUDY, (Scots) stained with blood, also BLOODY, BLUDIE, BLUIDY [adj]\n",
  "BLUDS": "BLUD, blood, in the sense of a close friend [n]\n",
  "BLUDY": "(Scots) stained with blood, also BLOODY, BLUDIE, BLUIDY [adj BLUDIER, BLUDIEST]\n",
  "BLUE": "to make the colour of a clear sky [v BLUED, BLUING or BLUEING, BLUES] / having the colour of a clear sky [adj BLUER, BLUEST, BLUELY]\n",
  "BLUEBACK": "a kind of trout inhabiting some of the lakes of Maine [n -S]\n",
  "BLUEBACKS": "BLUEBACK, a kind of trout inhabiting some of the lakes of Maine [n]\n",
  "BLUEBALL": "a medicinal herb [n -S]\n",
  "BLUEBALLS": "BLUEBALL, a medicinal herb [n]\n",
  "BLUEBEARD": "a man who has murdered several wives and concealed their bodies, or has other mysterious or horrible things to conceal [n -S]\n",
  "BLUEBEARDS": "BLUEBEARD, a man who has murdered several wives and concealed their bodies, or has other mysterious or horrible things to conceal [n]\n",
  "BLUEBEAT": "a type of West Indian pop music [n -S]\n",
  "BLUEBEATS": "BLUEBEAT, a type of West Indian pop music [n]\n",
  "BLUEBELL": "in South England, the wood hyacinth; in Scotland and North England, the harebell [n -S]\n",
  "BLUEBELLS": "BLUEBELL, in South England, the wood hyacinth; in Scotland and North England, the harebell [n]\n",
  "BLUEBERRIES": "BLUEBERRY, the edible fruit of Vaccinium vacillans and other American species [n]\n",
  "BLUEBERRY": "the edible fruit of Vaccinium vacillans and other American species [n BLUEBERRIES]\n",
  "BLUEBILL": "an American duck of the genus Fuligula [n -S]\n",
  "BLUEBILLS": "BLUEBILL, an American duck of the genus Fuligula [n]\n",
  "BLUEBIRD": "a small American bird related to the warblers [n -S]\n",
  "BLUEBIRDS": "BLUEBIRD, a small American bird related to the warblers [n]\n",
  "BLUEBLOOD": "a royal or aristocratic person [n -S]\n",
  "BLUEBLOODS": "BLUEBLOOD, a royal or aristocratic person [n]\n",
  "BLUEBONNET": "a Scottish peasant; a round cap [n -S]\n",
  "BLUEBONNETS": "BLUEBONNET, a Scottish peasant; a round cap [n]\n",
  "BLUEBOOK": "a parliamentary report [n -S]\n",
  "BLUEBOOKS": "BLUEBOOK, a parliamentary report [n]\n",
  "BLUEBOTTLE": "a large fly with metallic blue abdomen, aka blowfly [n -S]\n",
  "BLUEBOTTLES": "BLUEBOTTLE, a large fly with metallic blue abdomen, aka blowfly [n]\n",
  "BLUEBREAST": "the blue-throated warbler [n -S]\n",
  "BLUEBREASTS": "BLUEBREAST, the blue-throated warbler [n]\n",
  "BLUEBUCK": "an extinct antelope, also BLAUBOK, BLOUBOK [n -S]\n",
  "BLUEBUCKS": "BLUEBUCK, an extinct antelope, also BLAUBOK, BLOUBOK [n]\n",
  "BLUEBUSH": "an Australian blue-grey shrub [n -ES]\n",
  "BLUEBUSHES": "BLUEBUSH, an Australian blue-grey shrub [n]\n",
  "BLUECAP": "a one-year salmon, with blue-spotted head [n -S]\n",
  "BLUECAPS": "BLUECAP, a one-year salmon, with blue-spotted head [n]\n",
  "BLUECOAT": "one dressed in blue, as a soldier, a sailor, a beadle, etc. [n -S]\n",
  "BLUECOATS": "BLUECOAT, one dressed in blue, as a soldier, a sailor, a beadle, etc. [n]\n",
  "BLUECURLS": "a North American plant [n]\n",
  "BLUED": "BLUE, to make the colour of a clear sky [v]\n",
  "BLUEFIN": "a species of whitefish found in Lake Michigan [n -S]\n",
  "BLUEFINS": "BLUEFIN, a species of whitefish found in Lake Michigan [n]\n",
  "BLUEFISH": "a large voracious fish of the Serranidae, on the US Atlantic coast [n -ES]\n",
  "BLUEFISHES": "BLUEFISH, a large voracious fish of the Serranidae, on the US Atlantic coast [n]\n",
  "BLUEGILL": "an edible sunfish [n -S]\n",
  "BLUEGILLS": "BLUEGILL, an edible sunfish [n]\n",
  "BLUEGOWN": "one of a former class of licensed beggars in Scotland [n -S]\n",
  "BLUEGOWNS": "BLUEGOWN, one of a former class of licensed beggars in Scotland [n]\n",
  "BLUEGRASS": "a style of country music [n -ES]\n",
  "BLUEGRASSES": "BLUEGRASS, a style of country music [n]\n",
  "BLUEGUM": "any of several species of eucalyptus [n -S]\n",
  "BLUEGUMS": "BLUEGUM, any of several species of eucalyptus [n]\n",
  "BLUEHEAD": "a marine fish, a kind of wrasse [n -S]\n",
  "BLUEHEADS": "BLUEHEAD, a marine fish, a kind of wrasse [n]\n",
  "BLUEING": "the process of imparting a blue colour to a metal, also BLUING [n -S]\n",
  "BLUEINGS": "BLUEING, the process of imparting a blue colour to a metal, also BLUING [n]\n",
  "BLUEISH": "somewhat blue [adj]\n",
  "BLUEISHNESS": "the state of being blueish [n -ES]\n",
  "BLUEISHNESSES": "BLUEISHNESS, the state of being blueish [n]\n",
  "BLUEJACK": "a kind of oak tree [n -S]\n",
  "BLUEJACKET": "an enlisted man in the navy [n -S]\n",
  "BLUEJACKETS": "BLUEJACKET, an enlisted man in the navy [n]\n",
  "BLUEJACKING": "the sending of unsolicited messages over Bluetooth to Bluetooth-enabled devices such as mobile phones [n -S]\n",
  "BLUEJACKINGS": "BLUEJACKING, the sending of unsolicited messages over Bluetooth to Bluetooth-enabled devices such as mobile phones [n]\n",
  "BLUEJACKS": "BLUEJACK, a kind of oak tree [n]\n",
  "BLUEJAY": "a North American bird [n -S]\n",
  "BLUEJAYS": "BLUEJAY, a North American bird [n]\n",
  "BLUEJEANS": "blue denim jeans [n]\n",
  "BLUELINE": "a line that divides a hockey rink [n -S]\n",
  "BLUELINER": "a machine which makes blueprints [n -S]\n",
  "BLUELINERS": "BLUELINER, a machine which makes blueprints [n]\n",
  "BLUELINES": "BLUELINE, a line that divides a hockey rink [n]\n",
  "BLUELY": "BLUE, having the colour of a clear sky [adv]\n",
  "BLUEMOUTH": "a deepwater fish [n -S]\n",
  "BLUEMOUTHS": "BLUEMOUTH, a deepwater fish [n]\n",
  "BLUENESS": "the state of being blue [n -ES]\n",
  "BLUENESSES": "BLUENESS, the state of being blue [n]\n",
  "BLUENOSE": "(Canadian) a nickname for a Nova Scotian [n -S]\n",
  "BLUENOSED": "puritanical [adj]\n",
  "BLUENOSES": "BLUENOSE, (Canadian) a nickname for a Nova Scotian [n]\n",
  "BLUEPOINT": "a small oyster typically from the south shore of Long Island [n -S]\n",
  "BLUEPOINTS": "BLUEPOINT, a small oyster typically from the south shore of Long Island [n]\n",
  "BLUEPRINT": "a detailed plan of work to be done [n -S] / to draw up a blueprint [v -ED, -ING, -S]\n",
  "BLUEPRINTED": "BLUEPRINT, to draw up a blueprint [v]\n",
  "BLUEPRINTING": "BLUEPRINT, to draw up a blueprint [v]\n",
  "BLUEPRINTS": "BLUEPRINT, to draw up a blueprint [v]\n",
  "BLUER": "BLUE, having the colour of a clear sky [adj]\n",
  "BLUES": "BLUE, to make the colour of a clear sky [v]\n",
  "BLUESHIFT": "a shift of the spectrum towards the blue [n -S]\n",
  "BLUESHIFTED": "of a spectrum, shifted towards the blue [adj]\n",
  "BLUESHIFTS": "BLUESHIFT, a shift of the spectrum towards the blue [n]\n",
  "BLUESIER": "BLUESY, resembling blues music [adj]\n",
  "BLUESIEST": "BLUESY, resembling blues music [adj]\n",
  "BLUESMAN": "a man who plays the blues [n BLUESMEN]\n",
  "BLUESMEN": "BLUESMAN, a man who plays the blues [n]\n",
  "BLUESNARFING": "the unauthorized access of information from a wireless device through a Bluetooth connection [n -S]\n",
  "BLUESNARFINGS": "BLUESNARFING, the unauthorized access of information from a wireless device through a Bluetooth connection [n]\n",
  "BLUEST": "BLUE, having the colour of a clear sky [adj]\n",
  "BLUESTEM": "a kind of prairie grass [n -S]\n",
  "BLUESTEMS": "BLUESTEM, a kind of prairie grass [n]\n",
  "BLUESTOCKING": "an early feminist; an educated or literary woman [n -S]\n",
  "BLUESTOCKINGS": "BLUESTOCKING, an early feminist; an educated or literary woman [n]\n",
  "BLUESTONE": "hydrated copper sulphate, aka blue vitriol [n -S]\n",
  "BLUESTONES": "BLUESTONE, hydrated copper sulphate, aka blue vitriol [n]\n",
  "BLUESY": "resembling blues music [adj BLUESIER, BLUESIEST]\n",
  "BLUET": "(French) a meadow flower [n -S]\n",
  "BLUETHROAT": "a singing bird of northern Europe and Asia, related to the nightingales [n -S]\n",
  "BLUETHROATS": "BLUETHROAT, a singing bird of northern Europe and Asia, related to the nightingales [n]\n",
  "BLUETICK": "a hunting dog [n -S]\n",
  "BLUETICKS": "BLUETICK, a hunting dog [n]\n",
  "BLUETIT": "a small bird of the tit family [n -S]\n",
  "BLUETITS": "BLUETIT, a small bird of the tit family [n]\n",
  "BLUETONGUE": "an Australian lizard [n -S]\n",
  "BLUETONGUES": "BLUETONGUE, an Australian lizard [n]\n",
  "BLUETS": "BLUET, (French) a meadow flower [n]\n",
  "BLUETTE": "(French) a spark, a flash; a short playful piece of music [n -S]\n",
  "BLUETTES": "BLUETTE, (French) a spark, a flash; a short playful piece of music [n]\n",
  "BLUEWEED": "a bristly weed, viper's bugloss [n -S]\n",
  "BLUEWEEDS": "BLUEWEED, a bristly weed, viper's bugloss [n]\n",
  "BLUEWING": "the blue-winged teal [n -S]\n",
  "BLUEWINGS": "BLUEWING, the blue-winged teal [n]\n",
  "BLUEWOOD": "a thorny shrub growing in Texas [n -S]\n",
  "BLUEWOODS": "BLUEWOOD, a thorny shrub growing in Texas [n]\n",
  "BLUEY": "a swagman's bundle of personal effects [n -S] / somewhat blue [adj BLUIER, BLUIEST]\n",
  "BLUEYS": "BLUEY, a swagman's bundle of personal effects [n]\n",
  "BLUFF": "to deceive [v -ED, -ING, -S] / rough and hearty [adj BLUFFER, BLUFFEST, BLUFFLY]\n",
  "BLUFFABLE": "able to be bluffed [adj]\n",
  "BLUFFED": "BLUFF, to deceive [v]\n",
  "BLUFFER": "one that bluffs [n -S]\n",
  "BLUFFERS": "BLUFFER, one that bluffs [n]\n",
  "BLUFFEST": "BLUFF, rough and hearty [adj]\n",
  "BLUFFING": "BLUFF, to deceive [v]\n",
  "BLUFFLY": "BLUFF, rough and hearty [adv]\n",
  "BLUFFNESS": "the state of being bluff, open, frank [n -ES]\n",
  "BLUFFNESSES": "BLUFFNESS, the state of being bluff, open, frank [n]\n",
  "BLUFFS": "BLUFF, to deceive [v]\n",
  "BLUGGIER": "BLUGGY, (colloquial) bloody [adj]\n",
  "BLUGGIEST": "BLUGGY, (colloquial) bloody [adj]\n",
  "BLUGGY": "(colloquial) bloody [adj BLUGGIER, BLUGGIEST]\n",
  "BLUID": "(Scots) blood BLUDE [n -S]\n",
  "BLUIDIER": "BLUIDY, (Scots) stained with blood, also BLOODY, BLUDIE, BLUDY [adj]\n",
  "BLUIDIEST": "BLUIDY, (Scots) stained with blood, also BLOODY, BLUDIE, BLUDY [adj]\n",
  "BLUIDS": "BLUID, (Scots) blood BLUDE [n]\n",
  "BLUIDY": "(Scots) stained with blood, also BLOODY, BLUDIE, BLUDY [adj BLUIDIER, BLUIDIEST]\n",
  "BLUIER": "BLUEY, somewhat blue [adj]\n",
  "BLUIEST": "BLUEY, somewhat blue [adj]\n",
  "BLUING": "the process of imparting a blue colour to metal, also BLUEING [n -S]\n",
  "BLUINGS": "BLUING, the process of imparting a blue colour to metal, also BLUEING [n]\n",
  "BLUISH": "somewhat blue [adj]\n",
  "BLUISHNESS": "the state of being bluish [n -ES]\n",
  "BLUISHNESSES": "BLUISHNESS, the state of being bluish [n]\n",
  "BLUME": "to blossom [v BLUMED, BLUMING, BLUMES]\n",
  "BLUMED": "BLUME, to blossom [v]\n",
  "BLUMES": "BLUME, to blossom [v]\n",
  "BLUMING": "BLUME, to blossom [v]\n",
  "BLUNDER": "to make a mistake [v -ED, -ING, -S]\n",
  "BLUNDERBUSS": "an old-fashioned gun [n -ES]\n",
  "BLUNDERBUSSES": "BLUNDERBUSS, an old-fashioned gun [n]\n",
  "BLUNDERED": "BLUNDER, to make a mistake [v]\n",
  "BLUNDERER": "one who blunders [n -S]\n",
  "BLUNDERERS": "BLUNDERER, one who blunders [n]\n",
  "BLUNDERING": "the act of blundering, making a mistake [n -S]\n",
  "BLUNDERINGLY": "BLUNDERING [adv]\n",
  "BLUNDERINGS": "BLUNDERING, the act of blundering, making a mistake [n]\n",
  "BLUNDERS": "BLUNDER, to make a mistake [v]\n",
  "BLUNGE": "to mix clay with water [v BLUNGED, BLUNGING, BLUNGES]\n",
  "BLUNGED": "BLUNGE, to mix clay with water [v]\n",
  "BLUNGER": "a machine or person that blunges, i.e. mixes clay and water [n -S]\n",
  "BLUNGERS": "BLUNGER, a machine or person that blunges, i.e. mixes clay and water [n]\n",
  "BLUNGES": "BLUNGE, to mix clay with water [v]\n",
  "BLUNGING": "BLUNGE, to mix clay with water [v]\n",
  "BLUNK": "(Scots) to spoil, bungle [v -ED, -ING, -S]\n",
  "BLUNKED": "BLUNK, (Scots) to spoil, bungle [v]\n",
  "BLUNKER": "(Scots) a bungler [n -S]\n",
  "BLUNKERS": "BLUNKER, (Scots) a bungler [n]\n",
  "BLUNKING": "BLUNK, (Scots) to spoil, bungle [v]\n",
  "BLUNKS": "BLUNK, (Scots) to spoil, bungle [v]\n",
  "BLUNT": "not sharp or pointed [adj BLUNTER, BLUNTEST, BLUNTLY] / to make blunt [v -ED, -ING, -S]\n",
  "BLUNTED": "BLUNT, to make blunt [v]\n",
  "BLUNTER": "BLUNT, not sharp or pointed [adj]\n",
  "BLUNTEST": "BLUNT, not sharp or pointed [adj]\n",
  "BLUNTHEAD": "a frequent user of marijuana [n -S]\n",
  "BLUNTHEADS": "BLUNTHEAD, a frequent user of marijuana [n]\n",
  "BLUNTING": "BLUNT, to make blunt [v]\n",
  "BLUNTISH": "somewhat blunt [adj]\n",
  "BLUNTLY": "BLUNT, not sharp or pointed [adv]\n",
  "BLUNTNESS": "the state of being blunt [n -ES]\n",
  "BLUNTNESSES": "BLUNTNESS, the state of being blunt [n]\n",
  "BLUNTS": "BLUNT, to make blunt [v]\n",
  "BLUR": "to make indistinct [v BLURRED, BLURRING, BLURS]\n",
  "BLURB": "to praise in a publicity notice [v -ED, -ING, -S]\n",
  "BLURBED": "BLURB, to praise in a publicity notice [v]\n",
  "BLURBING": "BLURB, to praise in a publicity notice [v]\n",
  "BLURBIST": "a writer of blurbs [n -S]\n",
  "BLURBISTS": "BLURBIST, a writer of blurbs [n]\n",
  "BLURBS": "BLURB, to praise in a publicity notice [v]\n",
  "BLURRED": "BLUR, to make indistinct [v]\n",
  "BLURREDLY": "BLURRED [adv]\n",
  "BLURREDNESS": "the state of being blurred [n -ES]\n",
  "BLURREDNESSES": "BLURREDNESS, the state of being blurred [n]\n",
  "BLURRIER": "BLURRY, blurred [adj]\n",
  "BLURRIEST": "BLURRY, blurred [adj]\n",
  "BLURRILY": "BLURRY, blurred [adv]\n",
  "BLURRINESS": "the state of being blurry [n -ES]\n",
  "BLURRINESSES": "BLURRINESS, the state of being blurry [n]\n",
  "BLURRING": "BLUR, to make indistinct [v]\n",
  "BLURRINGLY": "BLURRING, BLUR, to make indistinct [adv]\n",
  "BLURRY": "blurred [adj BLURRIER, BLURRIEST, BLURRILY]\n",
  "BLURS": "BLUR, to make indistinct [v]\n",
  "BLURT": "to utter unadvisedly [v -ED, -ING, -S]\n",
  "BLURTED": "BLURT, to utter unadvisedly [v]\n",
  "BLURTER": "one who blurts [n -S]\n",
  "BLURTERS": "BLURTER, one who blurts [n]\n",
  "BLURTING": "the act of blurting, speaking without due thought [n -S]\n",
  "BLURTINGS": "BLURTING, the act of blurting, speaking without due thought [n]\n",
  "BLURTS": "BLURT, to utter unadvisedly [v]\n",
  "BLUSH": "to become red [v -ED, -ING, -ES]\n",
  "BLUSHED": "BLUSH, to become red [v]\n",
  "BLUSHER": "one who blushes [n -S]\n",
  "BLUSHERS": "BLUSHER, one who blushes [n]\n",
  "BLUSHES": "BLUSH, to become red [v]\n",
  "BLUSHET": "a modest, blushing girl [n -S]\n",
  "BLUSHETS": "BLUSHET, a modest, blushing girl [n]\n",
  "BLUSHFUL": "of a red colour [adj]\n",
  "BLUSHING": "the act of blushing [n -S]\n",
  "BLUSHINGLY": "BLUSHING [adv]\n",
  "BLUSHINGS": "BLUSHING, the act of blushing [n]\n",
  "BLUSHLESS": "free from blushes, shameless [adj BLUSHLESSLY]\n",
  "BLUSHLESSLY": "BLUSHLESS, free from blushes, shameless [adv]\n",
  "BLUSTER": "to blow violently [v -ED, -ING, -S]\n",
  "BLUSTERED": "BLUSTER, to blow violently [v]\n",
  "BLUSTERER": "one who blusters [n -S]\n",
  "BLUSTERERS": "BLUSTERER, one who blusters [n]\n",
  "BLUSTERIER": "BLUSTERY, windy [adj]\n",
  "BLUSTERIEST": "BLUSTERY, windy [adj]\n",
  "BLUSTERING": "blowing violently [adj BLUSTERINGLY] / the act of blustering [n -S]\n",
  "BLUSTERINGLY": "BLUSTERING [adv]\n",
  "BLUSTERINGS": "BLUSTERING, the act of blustering [n]\n",
  "BLUSTEROUS": "inclined to bluster, also BLUSTROUS [adj BLUSTEROUSLY]\n",
  "BLUSTEROUSLY": "BLUSTEROUS, inclined to bluster, also BLUSTROUS [adv]\n",
  "BLUSTERS": "BLUSTER, to blow violently [v]\n",
  "BLUSTERY": "windy [adj BLUSTERIER, BLUSTERIEST]\n",
  "BLUSTROUS": "(Shakespeare) inclined to bluster, also BLUSTEROUS [adj]\n",
  "BLUTWURST": "(German) a kind of German sausage [n -S]\n",
  "BLUTWURSTS": "BLUTWURST, (German) a kind of German sausage [n]\n",
  "BLYPE": "(Scots) a piece of skin that peels off after a sunburn [n -S]\n",
  "BLYPES": "BLYPE, (Scots) a piece of skin that peels off after a sunburn [n]\n",
  "BO": "a pal, a buddy [n -S]\n",
  "BOA": "a large constricting snake [n -S]\n",
  "BOAB": "a tropical tree with a swollen trunk, also BAOBAB [n -S]\n",
  "BOABS": "BOAB, a tropical tree with a swollen trunk, also BAOBAB [n]\n",
  "BOAK": "(dialect) to belch, vomit, also BOKE, BOCK [v -ED, -ING, -S]\n",
  "BOAKED": "BOAK, (dialect) to belch, vomit, also BOKE, BOCK [v]\n",
  "BOAKING": "BOAK, (dialect) to belch, vomit, also BOKE, BOCK [v]\n",
  "BOAKS": "BOAK, (dialect) to belch, vomit, also BOKE, BOCK [v]\n",
  "BOAR": "a male pig [n -S]\n",
  "BOARD": "to supply food and lodging for a fee [v -ED, -ING, -S]\n",
  "BOARDABLE": "that can be boarded [adj]\n",
  "BOARDED": "BOARD, to supply food and lodging for a fee [v]\n",
  "BOARDER": "one that boards [n -S]\n",
  "BOARDERS": "BOARDER, one that boards [n]\n",
  "BOARDIES": "(Australian slang) a pair of board shorts [n]\n",
  "BOARDING": "the act of boarding a ship etc. [n -S]\n",
  "BOARDINGHOUSE": "a private house in which accommodation and meals are provided for paying guests [n -S]\n",
  "BOARDINGHOUSES": "BOARDINGHOUSE, a private house in which accommodation and meals are provided for paying guests [n]\n",
  "BOARDINGS": "BOARDING, the act of boarding a ship etc. [n]\n",
  "BOARDLIKE": "like a board [adj]\n",
  "BOARDMAN": "a board member [n BOARDMEN]\n",
  "BOARDMEN": "BOARDMAN, a board member [n]\n",
  "BOARDROOM": "a room where the board of directors of a company meets [n -S]\n",
  "BOARDROOMS": "BOARDROOM, a room where the board of directors of a company meets [n]\n",
  "BOARDS": "BOARD, to supply food and lodging for a fee [v]\n",
  "BOARDSAILING": "the sport of sailing on a board [n -S]\n",
  "BOARDSAILINGS": "BOARDSAILING, the sport of sailing on a board [n]\n",
  "BOARDSAILOR": "one who practises sailboarding [n -S]\n",
  "BOARDSAILORS": "BOARDSAILOR, one who practises sailboarding [n]\n",
  "BOARDWALK": "(US) a footpath made of boards [n -S]\n",
  "BOARDWALKS": "BOARDWALK, (US) a footpath made of boards [n]\n",
  "BOARFISH": "a Mediterranean fish, so called from the resemblance of the extended lips to a hog's snout [n -ES]\n",
  "BOARFISHES": "BOARFISH, a Mediterranean fish, so called from the resemblance of the extended lips to a hog's snout [n]\n",
  "BOARHOUND": "a dog used to hunt boar [n -S]\n",
  "BOARHOUNDS": "BOARHOUND, a dog used to hunt boar [n]\n",
  "BOARISH": "swinish; brutal [adj BOARISHLY]\n",
  "BOARISHLY": "BOARISH, swinish; brutal [adv]\n",
  "BOARISHNESS": "the state of being boarish [n -ES]\n",
  "BOARISHNESSES": "BOARISHNESS, the state of being boarish [n]\n",
  "BOARS": "BOAR, a male pig [n]\n",
  "BOART": "diamond dust or fragments, also BORT, BORTZ [n -S]\n",
  "BOARTS": "BOART, diamond dust or fragments, also BORT, BORTZ [n]\n",
  "BOAS": "BOA, a large constricting snake [n]\n",
  "BOAST": "to brag [v -ED, -ING, -S]\n",
  "BOASTED": "BOAST, to brag [v]\n",
  "BOASTER": "one that boasts [n -S]\n",
  "BOASTERS": "BOASTER, one that boasts [n]\n",
  "BOASTFUL": "given to boasting [adj BOASTFULLY]\n",
  "BOASTFULLY": "BOASTFUL, given to boasting [adv]\n",
  "BOASTFULNESS": "the state of being boastful [n -ES]\n",
  "BOASTFULNESSES": "BOASTFULNESS, the state of being boastful [n]\n",
  "BOASTING": "the act of boasting [n -S]\n",
  "BOASTINGLY": "BOASTING [adv]\n",
  "BOASTINGS": "BOASTING, the act of boasting [n]\n",
  "BOASTLESS": "without boasting or ostentation [adj]\n",
  "BOASTS": "BOAST, to brag [v]\n",
  "BOAT": "to travel on a watercraft [v -ED, -ING, -S]\n",
  "BOATABLE": "able to be negotiated by boat [adj]\n",
  "BOATBILL": "a bird of the heron family (from the shape of its bill) [n -S]\n",
  "BOATBILLS": "BOATBILL, a bird of the heron family (from the shape of its bill) [n]\n",
  "BOATBUILDER": "one that builds boats [n -S]\n",
  "BOATBUILDERS": "BOATBUILDER, one that builds boats [n]\n",
  "BOATBUILDING": "the industry of building boats [n -S]\n",
  "BOATBUILDINGS": "BOATBUILDING, the industry of building boats [n]\n",
  "BOATED": "BOAT, to travel on a watercraft [v]\n",
  "BOATEL": "a waterside hotel, also BOTEL [n -S]\n",
  "BOATELS": "BOATEL, a waterside hotel, also BOTEL [n]\n",
  "BOATER": "a kind of straw hat [n -S]\n",
  "BOATERS": "BOATER, a kind of straw hat [n]\n",
  "BOATFUL": "as much as a boat can hold [n -S]\n",
  "BOATFULS": "BOATFUL, as much as a boat can hold [n]\n",
  "BOATHOOK": "a pole with a hook for use on a boat [n -S]\n",
  "BOATHOOKS": "BOATHOOK, a pole with a hook for use on a boat [n]\n",
  "BOATHOUSE": "a place for keeping boats [n -S]\n",
  "BOATHOUSES": "BOATHOUSE, a place for keeping boats [n]\n",
  "BOATIE": "(slang) a rowing enthusiast [n -S]\n",
  "BOATIES": "BOATIE, (slang) a rowing enthusiast [n]\n",
  "BOATING": "the sport of travelling by boat [n -S]\n",
  "BOATINGS": "BOATING, the sport of travelling by boat [n]\n",
  "BOATLIFT": "to transport by boats [v -ED, -ING, -S]\n",
  "BOATLIFTED": "BOATLIFT, to transport by boats [v]\n",
  "BOATLIFTING": "BOATLIFT, to transport by boats [v]\n",
  "BOATLIFTS": "BOATLIFT, to transport by boats [v]\n",
  "BOATLIKE": "resembling a boat [adj]\n",
  "BOATLOAD": "the amount that a boat holds [n -S]\n",
  "BOATLOADS": "BOATLOAD, the amount that a boat holds [n]\n",
  "BOATMAN": "a man who works on a boat, also BOATSMAN [n BOATMEN]\n",
  "BOATMEN": "BOATMAN, a man who works on a boat, also BOATSMAN [n]\n",
  "BOATNECK": "a wide open neck on a garment [n -S]\n",
  "BOATNECKS": "BOATNECK, a wide open neck on a garment [n]\n",
  "BOATPORT": "an enclosure for boats [n -S]\n",
  "BOATPORTS": "BOATPORT, an enclosure for boats [n]\n",
  "BOATS": "BOAT, to travel on a watercraft [v]\n",
  "BOATSMAN": "a man who works on a boat, also BOATMAN [n BOATSMEN]\n",
  "BOATSMEN": "BOATSMAN, a man who works on a boat, also BOATMAN [n]\n",
  "BOATSWAIN": "a ship's officer in charge of equipment and maintenance, also BOSUN [n -S]\n",
  "BOATSWAINS": "BOATSWAIN, a ship's officer in charge of equipment and maintenance, also BOSUN [n]\n",
  "BOATTAIL": "a North American bird, aka grackle [n -S]\n",
  "BOATTAILS": "BOATTAIL, a North American bird, aka grackle [n]\n",
  "BOATYARD": "a marina, a place for boats [n -S]\n",
  "BOATYARDS": "BOATYARD, a marina, a place for boats [n]\n",
  "BOB": "to move quickly up and down [v BOBBED, BOBBING, BOBS]\n",
  "BOBA": "a contagious skin disease resembling syphilis, aka yaws, also BUBA [n -S]\n",
  "BOBAC": "(Polish) a type of marmot, also BOBAK [n -S]\n",
  "BOBACS": "BOBAC, (Polish) a type of marmot, also BOBAK [n]\n",
  "BOBAK": "(Polish) a type of marmot, also BOBAC [n -S]\n",
  "BOBAKS": "BOBAK, (Polish) a type of marmot, also BOBAC [n]\n",
  "BOBAS": "BOBA, a contagious skin disease resembling syphilis, aka yaws, also BUBA [n]\n",
  "BOBBED": "BOB, to move quickly up and down [v]\n",
  "BOBBEJAAN": "(South African) a baboon; a large black spider [n -S]\n",
  "BOBBEJAANS": "BOBBEJAAN, (South African) a baboon; a large black spider [n]\n",
  "BOBBER": "a bobsleigh rider [n -S]\n",
  "BOBBERIES": "BOBBERY, a noisy row [n]\n",
  "BOBBERS": "BOBBER, a bobsleigh rider [n]\n",
  "BOBBERY": "a noisy row [n BOBBERIES]\n",
  "BOBBIES": "BOBBY, (slang) a policeman [n]\n",
  "BOBBIN": "a thread holder [n -S]\n",
  "BOBBINET": "a kind of cotton lace wrought by machines, and not by hand [n -S]\n",
  "BOBBINETS": "BOBBINET, a kind of cotton lace wrought by machines, and not by hand [n]\n",
  "BOBBING": "BOB, to move quickly up and down [v]\n",
  "BOBBINS": "BOBBIN, a thread holder [n]\n",
  "BOBBISH": "in good spirits [adj]\n",
  "BOBBITT": "to cut off the penis (of one's lover) [v -ED, -ING, -S]\n",
  "BOBBITTED": "BOBBITT, to cut off the penis (of one's lover) [v]\n",
  "BOBBITTING": "BOBBITT, to cut off the penis (of one's lover) [v]\n",
  "BOBBITTS": "BOBBITT, to cut off the penis (of one's lover) [v]\n",
  "BOBBLE": "to bob rapidly [v BOBBLED, BOBBLING, BOBBLES]\n",
  "BOBBLED": "BOBBLE, to bob rapidly [v]\n",
  "BOBBLEHEAD": "a type of collectible doll, with head often oversized compared to its body [n -S]\n",
  "BOBBLEHEADS": "BOBBLEHEAD, a type of collectible doll, with head often oversized compared to its body [n]\n",
  "BOBBLES": "BOBBLE, to bob rapidly [v]\n",
  "BOBBLIER": "BOBBLY, like pilled cloth [adj]\n",
  "BOBBLIEST": "BOBBLY, like pilled cloth [adj]\n",
  "BOBBLING": "BOBBLE, to bob rapidly [v]\n",
  "BOBBLY": "like pilled cloth [adj BOBBLIER, BOBBLIEST]\n",
  "BOBBY": "(slang) a policeman [n BOBBIES]\n",
  "BOBBYSOCK": "an ankle-sock, esp. as worn by teenage girls [n BOBBYSOCKS or BOBBYSOX]\n",
  "BOBBYSOCKS": "BOBBYSOCK, an ankle-sock, esp. as worn by teenage girls [n]\n",
  "BOBBYSOX": "BOBBYSOCK, an ankle-sock, esp. as worn by teenage girls [n]\n",
  "BOBBYSOXER": "(colloquial) an adolescent girl wearing bobby socks [n -S]\n",
  "BOBBYSOXERS": "BOBBYSOXER, (colloquial) an adolescent girl wearing bobby socks [n]\n",
  "BOBCAT": "a short-tailed North American lynx [n -S]\n",
  "BOBCATS": "BOBCAT, a short-tailed North American lynx [n]\n",
  "BOBECHE": "a circular wax catcher that fits over a candle [n -S]\n",
  "BOBECHES": "BOBECHE, a circular wax catcher that fits over a candle [n]\n",
  "BOBFLOAT": "a small buoyant float used in angling [n -S]\n",
  "BOBFLOATS": "BOBFLOAT, a small buoyant float used in angling [n]\n",
  "BOBLET": "a two-man bobsleigh [n -S]\n",
  "BOBLETS": "BOBLET, a two-man bobsleigh [n]\n",
  "BOBO": "a well-to-do person who holds bohemian values and leads a bourgeois life [n -S]\n",
  "BOBOL": "to commit a type of fraud carried out by one with access to public funds [v BOBOLLED, BOBOLLING, BOBOLS]\n",
  "BOBOLINK": "a North American songbird of the warbler family [n -S]\n",
  "BOBOLINKS": "BOBOLINK, a North American songbird of the warbler family [n]\n",
  "BOBOLLED": "BOBOL, to commit a type of fraud carried out by one with access to public funds [v]\n",
  "BOBOLLING": "BOBOL, to commit a type of fraud carried out by one with access to public funds [v]\n",
  "BOBOLS": "BOBOL, to commit a type of fraud carried out by one with access to public funds [v]\n",
  "BOBOS": "BOBO, a well-to-do person who holds bohemian values and leads a bourgeois life [n]\n",
  "BOBOTIE": "(South African) curried mincemeat topped with a baked egg crust [n -S]\n",
  "BOBOTIES": "BOBOTIE, (South African) curried mincemeat topped with a baked egg crust [n]\n",
  "BOBOWLER": "a type of large moth [n -S]\n",
  "BOBOWLERS": "BOBOWLER, a type of large moth [n]\n",
  "BOBS": "BOB, to move quickly up and down [v]\n",
  "BOBSKATE": "a child's skate having two parallel blades [n -S]\n",
  "BOBSKATES": "BOBSKATE, a child's skate having two parallel blades [n]\n",
  "BOBSLED": "to ride on a racing sled [v BOBSLEDDED, BOBSLEDDING, BOBSLEDS]\n",
  "BOBSLEDDED": "BOBSLED, to ride on a racing sled [v]\n",
  "BOBSLEDDER": "one who rides a bobsled [n -S]\n",
  "BOBSLEDDERS": "BOBSLEDDER, one who rides a bobsled [n]\n",
  "BOBSLEDDING": "riding in a bobsled [n -S]\n",
  "BOBSLEDDINGS": "BOBSLEDDING, riding in a bobsled [n]\n",
  "BOBSLEDS": "BOBSLED, to ride on a racing sled [v]\n",
  "BOBSLEIGH": "a short sledge [n -S] / to travel by bobsleigh [v -ED, -ING, -S]\n",
  "BOBSLEIGHED": "BOBSLEIGH, to travel by bobsleigh [v]\n",
  "BOBSLEIGHING": "the act of travelling by bobsleigh [n -S]\n",
  "BOBSLEIGHINGS": "BOBSLEIGHING, the act of travelling by bobsleigh [n]\n",
  "BOBSLEIGHS": "BOBSLEIGH, a short sledge [n]\n",
  "BOBSTAY": "a rope used on ships to steady the bowsprit [n -S]\n",
  "BOBSTAYS": "BOBSTAY, a rope used on ships to steady the bowsprit [n]\n",
  "BOBTAIL": "an animal (as a horse or dog) with a short tail [n -S] / to cut a tail short [v -ED, -ING, -S]\n",
  "BOBTAILED": "BOBTAIL, to cut a tail short [v]\n",
  "BOBTAILING": "BOBTAIL, to cut a tail short [v]\n",
  "BOBTAILS": "BOBTAIL, to cut a tail short [v]\n",
  "BOBWEIGHT": "a balance weight [n -S]\n",
  "BOBWEIGHTS": "BOBWEIGHT, a balance weight [n]\n",
  "BOBWHEEL": "the bob (short line near the end of a stanza) with the lines following it [n -S]\n",
  "BOBWHEELS": "BOBWHEEL, the bob (short line near the end of a stanza) with the lines following it [n]\n",
  "BOBWHITE": "a kind of quail [n -S]\n",
  "BOBWHITES": "BOBWHITE, a kind of quail [n]\n",
  "BOBWIG": "a wig with short turned up curls [n -S]\n",
  "BOBWIGS": "BOBWIG, a wig with short turned up curls [n]\n",
  "BOCACCIO": "a rockfish [n -S]\n",
  "BOCACCIOS": "BOCACCIO, a rockfish [n]\n",
  "BOCAGE": "(French) a decorative representation of trees, leaves, etc. [n -S]\n",
  "BOCAGES": "BOCAGE, (French) a decorative representation of trees, leaves, etc. [n]\n",
  "BOCCA": "(Italian) a mouth [n -S]\n",
  "BOCCAS": "BOCCA, (Italian) a mouth [n]\n",
  "BOCCE": "(Italian) an Italian bowling game, also BOCCI, BOCCIA, BOCCIE [n -S]\n",
  "BOCCES": "BOCCE, (Italian) an Italian bowling game, also BOCCI, BOCCIA, BOCCIE [n]\n",
  "BOCCI": "(Italian) an Italian bowling game, also BOCCE, BOCCIA, BOCCIE [n -S]\n",
  "BOCCIA": "(Italian) an Italian bowling game, also BOCCE, BOCCI, BOCCIE [n -S]\n",
  "BOCCIAS": "BOCCIA, (Italian) an Italian bowling game, also BOCCE, BOCCI, BOCCIE [n]\n",
  "BOCCIE": "(Italian) an Italian bowling game, also BOCCE, BOCCI, BOCCIA [n -S]\n",
  "BOCCIES": "BOCCIE, (Italian) an Italian bowling game, also BOCCE, BOCCI, BOCCIA [n]\n",
  "BOCCIS": "BOCCI, (Italian) an Italian bowling game, also BOCCE, BOCCIA, BOCCIE [n]\n",
  "BOCCONCINI": "(Italian) small pieces of mozzarella cheese, also BOCONCINI [n]\n",
  "BOCHE": "an offensive term for a German, also BOSCHE [n -S]\n",
  "BOCHES": "BOCHE, an offensive term for a German, also BOSCHE [n]\n",
  "BOCK": "to belch, also BOKE, BOAK [v -ED, -ING, -S]\n",
  "BOCKED": "BOCK, to belch, also BOKE, BOAK [v]\n",
  "BOCKEDY": "of a structure such as a piece of furniture, unsteady [adj]\n",
  "BOCKING": "BOCK, to belch, also BOKE, BOAK [v]\n",
  "BOCKS": "BOCK, to belch, also BOKE, BOAK [v]\n",
  "BOCONCINI": "(Italian) small pieces of mozzarella cheese, also BOCCONCINI [n]\n",
  "BOD": "(colloquial) a person [n -S]\n",
  "BODACH": "(Gaelic) an old man, a churl; a goblin or spectre [n -S]\n",
  "BODACHS": "BODACH, (Gaelic) an old man, a churl; a goblin or spectre [n]\n",
  "BODACIOUS": "remarkable; gutsy [adj BODACIOUSLY]\n",
  "BODACIOUSLY": "BODACIOUS, remarkable; gutsy [adv]\n",
  "BODDHISATTVA": "one who gives up Nirvana out of compassion for others, also BODHISATTVA [n -S]\n",
  "BODDHISATTVAS": "BODDHISATTVA, one who gives up Nirvana out of compassion for others, also BODHISATTVA [n]\n",
  "BODDLE": "(Scots) a former Scottish coin, also BODLE [n -S]\n",
  "BODDLES": "BODDLE, (Scots) a former Scottish coin, also BODLE [n]\n",
  "BODE": "to foretell, be an omen of [v BODED, BODING, BODES]\n",
  "BODED": "BODE, to foretell, be an omen of [v]\n",
  "BODEFUL": "boding [adj]\n",
  "BODEGA": "(Spanish) a shop selling wine and sometimes groceries [n -S]\n",
  "BODEGAS": "BODEGA, (Spanish) a shop selling wine and sometimes groceries [n]\n",
  "BODEGUERO": "(Spanish) a man who owns or runs a bodega [n -S]\n",
  "BODEGUEROS": "BODEGUERO, (Spanish) a man who owns or runs a bodega [n]\n",
  "BODEMENT": "a prediction or prophecy, also ABODEMENT [n -S]\n",
  "BODEMENTS": "BODEMENT, a prediction or prophecy, also ABODEMENT [n]\n",
  "BODES": "BODE, to foretell, be an omen of [v]\n",
  "BODGE": "to patch up [v BODGED, BODGING, BODGES]\n",
  "BODGED": "BODGE, to patch up [v]\n",
  "BODGER": "a maker of beechwood furniture in the Chilterns [n -S]\n",
  "BODGERS": "BODGER, a maker of beechwood furniture in the Chilterns [n]\n",
  "BODGES": "BODGE, to patch up [v]\n",
  "BODGIE": "fake [adj BODGIER, BODGIEST] / an Australian Teddy boy of the 1950s [n -S]\n",
  "BODGIER": "BODGIE, fake [adj]\n",
  "BODGIES": "BODGIE, an Australian Teddy boy of the 1950s [n]\n",
  "BODGIEST": "BODGIE, fake [adj]\n",
  "BODGING": "BODGE, to patch up [v]\n",
  "BODHI": "in Buddhism, enlightenment [n -S]\n",
  "BODHIS": "BODHI, in Buddhism, enlightenment [n]\n",
  "BODHISATTVA": "one who gives up Nirvana out of compassion for others, also BODDHISATTVA [n -S]\n",
  "BODHISATTVAS": "BODHISATTVA, one who gives up Nirvana out of compassion for others, also BODDHISATTVA [n]\n",
  "BODHRAN": "(Irish) a shallow one-sided drum used in Gaelic music [n -S]\n",
  "BODHRANS": "BODHRAN, (Irish) a shallow one-sided drum used in Gaelic music [n]\n",
  "BODICE": "a woman's stiffened inner garment [n -S]\n",
  "BODICES": "BODICE, a woman's stiffened inner garment [n]\n",
  "BODIED": "BODY, to give form to [v]\n",
  "BODIES": "BODY, to give form to [v]\n",
  "BODIKIN": "a diminutive of body, in Od's bodikins, God's little body [n -S]\n",
  "BODIKINS": "BODIKIN, a diminutive of body, in Od's bodikins, God's little body [n]\n",
  "BODILESS": "lacking material form [adj]\n",
  "BODILY": "of the body [adj]\n",
  "BODING": "ominous [adj BODINGLY] / an omen [n -S]\n",
  "BODINGLY": "BODING, ominous [adv]\n",
  "BODINGS": "BODING, an omen [n]\n",
  "BODKIN": "a dagger, stiletto; a blunt needle [n -S]\n",
  "BODKINS": "BODKIN, a dagger, stiletto; a blunt needle [n]\n",
  "BODLE": "(Scots) a former Scottish coin, also BODDLE [n -S]\n",
  "BODLES": "BODLE, (Scots) a former Scottish coin, also BODDLE [n]\n",
  "BODRAG": "(Spenser) a hostile attack [n -S]\n",
  "BODRAGS": "BODRAG, (Spenser) a hostile attack [n]\n",
  "BODS": "BOD, (colloquial) a person [n]\n",
  "BODY": "to give form to [v BODIED, BODYING, BODIES]\n",
  "BODYBOARD": "to ride a surfboard that is shorter and blunter than a standard board, on which the surfer lies rather than stands [v -ED, -ING, -S]\n",
  "BODYBOARDED": "BODYBOARD, to ride a surfboard that is shorter and blunter than a standard board, on which the surfer lies rather than stands [v]\n",
  "BODYBOARDING": "the sport of riding a surfboard that is shorter and blunter than a standard board [n -S]\n",
  "BODYBOARDINGS": "BODYBOARDING, the sport of riding a surfboard that is shorter and blunter than a standard board [n]\n",
  "BODYBOARDS": "BODYBOARD, to ride a surfboard that is shorter and blunter than a standard board, on which the surfer lies rather than stands [v]\n",
  "BODYBUILD": "to build up one's body [v BODYBUILT, BODYBUILDING, BODYBUILDS]\n",
  "BODYBUILDER": "one who engages in bodybuilding [n -S]\n",
  "BODYBUILDERS": "BODYBUILDER, one who engages in bodybuilding [n]\n",
  "BODYBUILDING": "the sport of building up one's physique [n -S]\n",
  "BODYBUILDINGS": "BODYBUILDING, the sport of building up one's physique [n]\n",
  "BODYBUILDS": "BODYBUILD, to build up one's body [v]\n",
  "BODYBUILT": "BODYBUILD, to build up one's body [v]\n",
  "BODYCHECK": "to make a blocking move in football [v -ED, -ING, -S]\n",
  "BODYCHECKED": "BODYCHECK, to make a blocking move in football [v]\n",
  "BODYCHECKING": "BODYCHECK, to make a blocking move in football [v]\n",
  "BODYCHECKS": "BODYCHECK, to make a blocking move in football [v]\n",
  "BODYGUARD": "a guard consisting of one person or several people, to give physical protection to someone [n -S] / to act as a bodyguard [v -ED, -ING, -S]\n",
  "BODYGUARDED": "BODYGUARD, to act as a bodyguard [v]\n",
  "BODYGUARDING": "BODYGUARD, to act as a bodyguard [v]\n",
  "BODYGUARDS": "BODYGUARD, to act as a bodyguard [v]\n",
  "BODYING": "BODY, to give form to [v]\n",
  "BODYLINE": "in cricket, a style of bowling, directly at the batsman [n -S]\n",
  "BODYLINES": "BODYLINE, in cricket, a style of bowling, directly at the batsman [n]\n",
  "BODYMAN": "one who repairs autobodies [n BODYMEN]\n",
  "BODYMEN": "BODYMAN, one who repairs autobodies [n]\n",
  "BODYSHAPER": "an undergarment which flattens the stomach, bottom etc. [n -S]\n",
  "BODYSHAPERS": "BODYSHAPER, an undergarment which flattens the stomach, bottom etc. [n]\n",
  "BODYSHELL": "a vehicle's bodywork [n -S]\n",
  "BODYSHELLS": "BODYSHELL, a vehicle's bodywork [n]\n",
  "BODYSIDE": "the side of a body of an automobile or vehicle [n -S]\n",
  "BODYSIDES": "BODYSIDE, the side of a body of an automobile or vehicle [n]\n",
  "BODYSNATCHER": "one who steals bodies to sell [n -S]\n",
  "BODYSNATCHERS": "BODYSNATCHER, one who steals bodies to sell [n]\n",
  "BODYSUIT": "a close fitting one-piece garment [n -S]\n",
  "BODYSUITS": "BODYSUIT, a close fitting one-piece garment [n]\n",
  "BODYSURF": "to ride a wave without a surfboard [v -ED, -ING, -S]\n",
  "BODYSURFED": "BODYSURF, to ride a wave without a surfboard [v]\n",
  "BODYSURFER": "one who bodysurfs [n -S]\n",
  "BODYSURFERS": "BODYSURFER, one who bodysurfs [n]\n",
  "BODYSURFING": "the sport of surfing without a surfboard [n -S]\n",
  "BODYSURFINGS": "BODYSURFING, the sport of surfing without a surfboard [n]\n",
  "BODYSURFS": "BODYSURF, to ride a wave without a surfboard [v]\n",
  "BODYWASH": "a liquid product for cleansing the body [n -ES]\n",
  "BODYWASHES": "BODYWASH, a liquid product for cleansing the body [n]\n",
  "BODYWORK": "the metal outer shell of a motor vehicle [n -S]\n",
  "BODYWORKER": "a therapist using bodywork techniques [n -S]\n",
  "BODYWORKERS": "BODYWORKER, a therapist using bodywork techniques [n]\n",
  "BODYWORKS": "BODYWORK, the metal outer shell of a motor vehicle [n]\n",
  "BOEHMITE": "(German) a mineral present in bauxite, a hydroxide of aluminium [n -S]\n",
  "BOEHMITES": "BOEHMITE, (German) a mineral present in bauxite, a hydroxide of aluminium [n]\n",
  "BOEP": "(South African) a protruding belly [n -S]\n",
  "BOEPS": "BOEP, (South African) a protruding belly [n]\n",
  "BOERBUL": "(South African) a mastiff, often used as a watchdog [n -S]\n",
  "BOERBULL": "(South African) a crossbred mastiff used esp as a watchdog, also BOERBUL [n -S]\n",
  "BOERBULLS": "BOERBULL, (South African) a crossbred mastiff used esp as a watchdog, also BOERBUL [n]\n",
  "BOERBULS": "BOERBUL, (South African) a mastiff, often used as a watchdog [n]\n",
  "BOEREMUSIEK": "(South African) a special variety of light music associated with the culture of the Afrikaners [n -S]\n",
  "BOEREMUSIEKS": "BOEREMUSIEK, (South African) a special variety of light music associated with the culture of the Afrikaners [n]\n",
  "BOEREWORS": "(South African) a traditional South African sausage [n -ES]\n",
  "BOEREWORSES": "BOEREWORS, (South African) a traditional South African sausage [n]\n",
  "BOERTJIE": "(South African) friend, as a form of greeting [n -S]\n",
  "BOERTJIES": "BOERTJIE, (South African) friend, as a form of greeting [n]\n",
  "BOET": "(South African) a brother, or a buddy [n -S]\n",
  "BOETS": "BOET, (South African) a brother, or a buddy [n]\n",
  "BOEUF": "(French) beef, as in boeuf bourguignon, a casserole of beef, herbs etc. cooked in red wine [n -S]\n",
  "BOEUFS": "BOEUF, (French) beef, as in boeuf bourguignon, a casserole of beef, herbs etc. cooked in red wine [n]\n",
  "BOFF": "to hit, strike [v -ED, -ING, -S]\n",
  "BOFFED": "BOFF, to hit, strike [v]\n",
  "BOFFIN": "a scientific expert [n -S]\n",
  "BOFFING": "BOFF, to hit, strike [v]\n",
  "BOFFINIER": "BOFFINY, like a boffin, a scientific expert [adj]\n",
  "BOFFINIEST": "BOFFINY, like a boffin, a scientific expert [adj]\n",
  "BOFFINS": "BOFFIN, a scientific expert [n]\n",
  "BOFFINY": "like a boffin, a scientific expert [adj BOFFINIER, BOFFINIEST]\n",
  "BOFFO": "a hearty laugh, also BOFFOLA [n -S]\n",
  "BOFFOLA": "a hearty laugh, also BOFFO [n -S]\n",
  "BOFFOLAS": "BOFFOLA, a hearty laugh, also BOFFO [n]\n",
  "BOFFOS": "BOFFO, a hearty laugh, also BOFFOLA [n]\n",
  "BOFFS": "BOFF, to hit, strike [v]\n",
  "BOG": "to sink into a bog [v BOGGED, BOGGING, BOGS]\n",
  "BOGAN": "(Canadian) a quiet tributary or backwater, aka pokelogan [n -S]\n",
  "BOGANS": "BOGAN, (Canadian) a quiet tributary or backwater, aka pokelogan [n]\n",
  "BOGART": "to monopolise something, keep something esp. a marijuana cigarette to oneself [v -ED, -ING, -S]\n",
  "BOGARTED": "BOGART, to monopolise something, keep something esp. a marijuana cigarette to oneself [v]\n",
  "BOGARTING": "BOGART, to monopolise something, keep something esp. a marijuana cigarette to oneself [v]\n",
  "BOGARTS": "BOGART, to monopolise something, keep something esp. a marijuana cigarette to oneself [v]\n",
  "BOGBEAN": "a marsh plant of the gentian family [n -S]\n",
  "BOGBEANS": "BOGBEAN, a marsh plant of the gentian family [n]\n",
  "BOGEY": "to shoot one over par in golf [v -ED, -ING, -S] / a goblin, also BOGIE, BOGY, BOGGARD, BOGGART, BOGLE [n -S]\n",
  "BOGEYED": "BOGEY, to shoot one over par in golf [v]\n",
  "BOGEYING": "BOGEY, to shoot one over par in golf [v]\n",
  "BOGEYISM": "belief in bogeys, also BOGYISM [n -S]\n",
  "BOGEYISMS": "BOGEYISM, belief in bogeys, also BOGYISM [n]\n",
  "BOGEYMAN": "a terrifying creature, also BOGYMAN, BOOGYMAN [n BOGEYMEN]\n",
  "BOGEYMEN": "BOGEYMAN, a terrifying creature, also BOGYMAN, BOOGYMAN [n]\n",
  "BOGEYS": "BOGEY, to shoot one over par in golf [v]\n",
  "BOGGARD": "a spectre or goblin, also BOGGART, BOGLE [n -S]\n",
  "BOGGARDS": "BOGGARD, a spectre or goblin, also BOGGART, BOGLE [n]\n",
  "BOGGART": "a spectre or goblin, also BOGGARD, BOGLE [n -S]\n",
  "BOGGARTS": "BOGGART, a spectre or goblin, also BOGGARD, BOGLE [n]\n",
  "BOGGED": "BOG, to sink into a bog [v]\n",
  "BOGGER": "(Australian slang) a toilet [n -S]\n",
  "BOGGERS": "BOGGER, (Australian slang) a toilet [n]\n",
  "BOGGIER": "BOGGY, like a bog [adj]\n",
  "BOGGIEST": "BOGGY, like a bog [adj]\n",
  "BOGGINESS": "the state of being boggy [n -ES]\n",
  "BOGGINESSES": "BOGGINESS, the state of being boggy [n]\n",
  "BOGGING": "BOG, to sink into a bog [v]\n",
  "BOGGISH": "boggy [adj]\n",
  "BOGGLE": "to baffle, overwhelm mentally [v BOGGLED, BOGGLING, BOGGLES]\n",
  "BOGGLED": "BOGGLE, to baffle, overwhelm mentally [v]\n",
  "BOGGLER": "one who boggles or hesitates [n -S]\n",
  "BOGGLERS": "BOGGLER, one who boggles or hesitates [n]\n",
  "BOGGLES": "BOGGLE, to baffle, overwhelm mentally [v]\n",
  "BOGGLING": "BOGGLE, to baffle, overwhelm mentally [v]\n",
  "BOGGY": "like a bog [adj BOGGIER, BOGGIEST]\n",
  "BOGHEAD": "as in boghead coal, a variety of coal from which paraffin oil can be derived, aka torbanite [adj]\n",
  "BOGHOLE": "a natural hole in the ground with a swampy bottom [n -S]\n",
  "BOGHOLES": "BOGHOLE, a natural hole in the ground with a swampy bottom [n]\n",
  "BOGIE": "(Australian slang) to bathe or swim [v BOGIED, BOGIEING, BOGIES]\n",
  "BOGIED": "BOGIE, (Australian slang) to bathe or swim [v]\n",
  "BOGIEING": "BOGIE, (Australian slang) to bathe or swim [v]\n",
  "BOGIES": "BOGIE, (Australian slang) to bathe or swim [v]\n",
  "BOGLAND": "marshland [n -S]\n",
  "BOGLANDS": "BOGLAND, marshland [n]\n",
  "BOGLE": "to perform the bogle, a kind of rhythmic dance [v BOGLED, BOGLING, BOGLES]\n",
  "BOGLED": "BOGLE, to perform the bogle, a kind of rhythmic dance [v]\n",
  "BOGLES": "BOGLE, to perform the bogle, a kind of rhythmic dance [v]\n",
  "BOGLING": "BOGLE, to perform the bogle, a kind of rhythmic dance [v]\n",
  "BOGMAN": "the body of a man preserved in peat [n BOGMEN]\n",
  "BOGMEN": "BOGMAN, the body of a man preserved in peat [n]\n",
  "BOGOAK": "trunks of oak embedded in bogs and so preserved from decay [n -S]\n",
  "BOGOAKS": "BOGOAK, trunks of oak embedded in bogs and so preserved from decay [n]\n",
  "BOGONG": "(Native Australian) a noctuid moth eaten by Australian aborigines, also BUGONG [n -S]\n",
  "BOGONGS": "BOGONG, (Native Australian) a noctuid moth eaten by Australian aborigines, also BUGONG [n]\n",
  "BOGS": "BOG, to sink into a bog [v]\n",
  "BOGTROTTER": "one who lives in a boggy country, applied in derision to the lowest class of Irish [n -S]\n",
  "BOGTROTTERS": "BOGTROTTER, one who lives in a boggy country, applied in derision to the lowest class of Irish [n]\n",
  "BOGTROTTING": "the practice of wandering round bogs, ascribed to Irishmen [n -S]\n",
  "BOGTROTTINGS": "BOGTROTTING, the practice of wandering round bogs, ascribed to Irishmen [n]\n",
  "BOGUE": "a Mediterranean fish [n -S]\n",
  "BOGUES": "BOGUE, a Mediterranean fish [n]\n",
  "BOGUS": "not genuine, counterfeit [adj BOGUSLY]\n",
  "BOGUSLY": "BOGUS, not genuine, counterfeit [adv]\n",
  "BOGUSNESS": "the state of being bogus [n -ES]\n",
  "BOGUSNESSES": "BOGUSNESS, the state of being bogus [n]\n",
  "BOGWOOD": "the wood of trees, esp. of oaks, dug up from peat bogs [n -S]\n",
  "BOGWOODS": "BOGWOOD, the wood of trees, esp. of oaks, dug up from peat bogs [n]\n",
  "BOGY": "a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGYMAN, BOOGERMAN, BOOGEYMAN, BOOGIEMAN, BOOGYMAN [n BOGIES]\n",
  "BOGYISM": "belief in bogies, also BOGEYISM [n -S]\n",
  "BOGYISMS": "BOGYISM, belief in bogies, also BOGEYISM [n]\n",
  "BOGYMAN": "a terrifying creature, also BOGEYMAN, BOOGYMAN [n BOGYMEN]\n",
  "BOGYMEN": "BOGYMAN, a terrifying creature, also BOGEYMAN, BOOGYMAN [n]\n",
  "BOH": "an exclamation used to startle [n -S]\n",
  "BOHEA": "(Chinese) an inferior kind of black tea [n -S]\n",
  "BOHEAS": "BOHEA, (Chinese) an inferior kind of black tea [n]\n",
  "BOHEMIA": "a community of bohemians [n -S]\n",
  "BOHEMIAN": "an unconventional person [n -S]\n",
  "BOHEMIANISM": "the unconventional way of life of bohemians [n -S]\n",
  "BOHEMIANISMS": "BOHEMIANISM, the unconventional way of life of bohemians [n]\n",
  "BOHEMIANS": "BOHEMIAN, an unconventional person [n]\n",
  "BOHEMIAS": "BOHEMIA, a community of bohemians [n]\n",
  "BOHO": "(short for) a bohemian [n -S]\n",
  "BOHOS": "BOHO, (short for) a bohemian [n]\n",
  "BOHRIUM": "a radioactive element [n -S]\n",
  "BOHRIUMS": "BOHRIUM, a radioactive element [n]\n",
  "BOHS": "BOH, an exclamation used to startle [n]\n",
  "BOHUNK": "(offensive US slang) a Slav or Hungarian, esp. an unskilled worker [n -S]\n",
  "BOHUNKS": "BOHUNK, (offensive US slang) a Slav or Hungarian, esp. an unskilled worker [n]\n",
  "BOI": "(slang) a lesbian who adopts a boyish appearance or manners [n -S]\n",
  "BOIL": "to pass rapidly from liquid into vapour [v -ED, -ING, -S]\n",
  "BOILABLE": "able to be boiled [adj]\n",
  "BOILED": "BOIL, to pass rapidly from liquid into vapour [v]\n",
  "BOILER": "a vessel for boiling [n -S]\n",
  "BOILERIES": "BOILERY, a place and apparatus for boiling, as for evaporating brine in salt making [n]\n",
  "BOILERMAKER": "a drink of whiskey followed by a beer chaser [n -S]\n",
  "BOILERMAKERS": "BOILERMAKER, a drink of whiskey followed by a beer chaser [n]\n",
  "BOILERMAKING": "metalworking in heavy industry; plating or welding [n -S]\n",
  "BOILERMAKINGS": "BOILERMAKING, metalworking in heavy industry; plating or welding [n]\n",
  "BOILERMAN": "a man who looks after boilers [n BOILERMEN]\n",
  "BOILERMEN": "BOILERMAN, a man who looks after boilers [n]\n",
  "BOILERPLATE": "syndicated material supplied esp. to weekly newspapers in matrix or plate form [n -S] / to print as a boilerplate [v BOILERPLATED, BOILERPLATING, BOILERPLATES]\n",
  "BOILERPLATED": "BOILERPLATE, to print as a boilerplate [v]\n",
  "BOILERPLATES": "BOILERPLATE, to print as a boilerplate [v]\n",
  "BOILERPLATING": "BOILERPLATE, to print as a boilerplate [v]\n",
  "BOILERS": "BOILER, a vessel for boiling [n]\n",
  "BOILERSUIT": "a coverall [n -S]\n",
  "BOILERSUITS": "BOILERSUIT, a coverall [n]\n",
  "BOILERY": "a place and apparatus for boiling, as for evaporating brine in salt making [n BOILERIES]\n",
  "BOILING": "at boiling point; very hot [adj BOILINGLY] / the act of boiling [n -S]\n",
  "BOILINGLY": "BOILING, at boiling point; very hot [adv]\n",
  "BOILINGS": "BOILING, the act of boiling [n]\n",
  "BOILOFF": "the removal of impurities etc. by boiling [n -S]\n",
  "BOILOFFS": "BOILOFF, the removal of impurities etc. by boiling [n]\n",
  "BOILOVER": "(Australian) a surprising result in a sporting event, esp. a horserace [n -S]\n",
  "BOILOVERS": "BOILOVER, (Australian) a surprising result in a sporting event, esp. a horserace [n]\n",
  "BOILS": "BOIL, to pass rapidly from liquid into vapour [v]\n",
  "BOING": "to reverberate by bouncing, also BOINK [v -ED, -ING, -S]\n",
  "BOINGED": "BOING, to reverberate by bouncing, also BOINK [v]\n",
  "BOINGING": "BOING, to reverberate by bouncing, also BOINK [v]\n",
  "BOINGS": "BOING, to reverberate by bouncing, also BOINK [v]\n",
  "BOINK": "to reverberate by bouncing, also BOING [v -ED, -ING, -S]\n",
  "BOINKED": "BOINK, to reverberate by bouncing, also BOING [v]\n",
  "BOINKING": "BOINK, to reverberate by bouncing, also BOING [v]\n",
  "BOINKS": "BOINK, to reverberate by bouncing, also BOING [v]\n",
  "BOIS": "BOI, (slang) a lesbian who adopts a boyish appearance or manners [n]\n",
  "BOISERIE": "(French) wood panelling on a wall [n -S]\n",
  "BOISERIES": "BOISERIE, (French) wood panelling on a wall [n]\n",
  "BOISTEROUS": "rowdy, high-spirited [adj BOISTEROUSLY]\n",
  "BOISTEROUSLY": "BOISTEROUS, rowdy, high-spirited [adv]\n",
  "BOISTEROUSNESS": "the state of being boisterous [n]\n",
  "BOITE": "(French) a nightclub [n -S]\n",
  "BOITES": "BOITE, (French) a nightclub [n]\n",
  "BOK": "(South African) a goat or antelope [n -S]\n",
  "BOKE": "(dialect) to belch, also BOAK, BOCK [v BOKED, BOKING, BOKES]\n",
  "BOKED": "BOKE, (dialect) to belch, also BOAK, BOCK [v]\n",
  "BOKEH": "the blurred quality of a photograph [n -S]\n",
  "BOKEHS": "BOKEH, the blurred quality of a photograph [n]\n",
  "BOKES": "BOKE, (dialect) to belch, also BOAK, BOCK [v]\n",
  "BOKING": "BOKE, (dialect) to belch, also BOAK, BOCK [v]\n",
  "BOKKEN": "(Japanese) a wooden sword for training [n -S]\n",
  "BOKKENS": "BOKKEN, (Japanese) a wooden sword for training [n]\n",
  "BOKMAKIERIE": "(South African) a large yellow shrike [n -S]\n",
  "BOKMAKIERIES": "BOKMAKIERIE, (South African) a large yellow shrike [n]\n",
  "BOKO": "(slang) the nose [n -S]\n",
  "BOKOS": "BOKO, (slang) the nose [n]\n",
  "BOKS": "BOK, (South African) a goat or antelope [n]\n",
  "BOLA": "(Spanish) a South American missile, consisting of two or more balls tied together, also BOLAS [n -S]\n",
  "BOLAR": "pertaining to a fine clay [adj]\n",
  "BOLAS": "(Spanish) a South American missile, consisting of two or more balls tied together, also BOLA [n -ES]\n",
  "BOLASES": "BOLAS, (Spanish) a South American missile, consisting of two or more balls tied together, also BOLA [n]\n",
  "BOLD": "brave, daring [adj BOLDER, BOLDEST, BOLDLY] / to make type bold [v -ED, -ING, -S]\n",
  "BOLDED": "BOLD, to make type bold [v]\n",
  "BOLDEN": "(obsolete) to make bold [v -ED, -ING, -S]\n",
  "BOLDENED": "BOLDEN, (obsolete) to make bold [v]\n",
  "BOLDENING": "BOLDEN, (obsolete) to make bold [v]\n",
  "BOLDENS": "BOLDEN, (obsolete) to make bold [v]\n",
  "BOLDER": "BOLD, brave, daring [adj]\n",
  "BOLDEST": "BOLD, brave, daring [adj]\n",
  "BOLDFACE": "to print in thick type [v BOLDFACED, BOLDFACING, BOLDFACES]\n",
  "BOLDFACED": "BOLDFACE, to print in thick type [v]\n",
  "BOLDFACES": "BOLDFACE, to print in thick type [v]\n",
  "BOLDFACING": "BOLDFACE, to print in thick type [v]\n",
  "BOLDING": "BOLD, to make type bold [v]\n",
  "BOLDLY": "BOLD, brave, daring [adv]\n",
  "BOLDNESS": "the quality of being bold [n -ES]\n",
  "BOLDNESSES": "BOLDNESS, the quality of being bold [n]\n",
  "BOLDS": "BOLD, to make type bold [v]\n",
  "BOLE": "a fine earthy clay [n -S]\n",
  "BOLECTION": "a moulding around a panel, projecting beyond the surface of the framing, also BALECTION, BILECTION [n -S]\n",
  "BOLECTIONS": "BOLECTION, a moulding around a panel, projecting beyond the surface of the framing, also BALECTION, BILECTION [n]\n",
  "BOLERO": "(Spanish) a Spanish dance with sudden pauses and sharp turns [n -S]\n",
  "BOLEROS": "BOLERO, (Spanish) a Spanish dance with sudden pauses and sharp turns [n]\n",
  "BOLES": "BOLE, a fine earthy clay [n]\n",
  "BOLETE": "any fungus of the family Boletaceae [n -S]\n",
  "BOLETES": "BOLETE, any fungus of the family Boletaceae [n]\n",
  "BOLETI": "BOLETUS, (Latin) a genus of fungi with a pore-like surface instead of gills [n]\n",
  "BOLETUS": "(Latin) a genus of fungi with a pore-like surface instead of gills [n BOLETI or BOLETUSES]\n",
  "BOLETUSES": "BOLETUS, (Latin) a genus of fungi with a pore-like surface instead of gills [n]\n",
  "BOLIDE": "a large meteor that bursts; a fireball [n -S]\n",
  "BOLIDES": "BOLIDE, a large meteor that bursts; a fireball [n]\n",
  "BOLINE": "in wicca, a sickle-shaped knife used for gathering herbs and carving symbols [n -S]\n",
  "BOLINES": "BOLINE, in wicca, a sickle-shaped knife used for gathering herbs and carving symbols [n]\n",
  "BOLIVAR": "(Spanish) the monetary unit of Venezuela [n BOLIVARS or BOLIVARES]\n",
  "BOLIVARES": "BOLIVAR, (Spanish) the monetary unit of Venezuela [n]\n",
  "BOLIVARS": "BOLIVAR, (Spanish) the monetary unit of Venezuela [n]\n",
  "BOLIVIA": "(Spanish) a soft fabric [n -S]\n",
  "BOLIVIANO": "(Spanish) a Bolivian dollar [n -S]\n",
  "BOLIVIANOS": "BOLIVIANO, (Spanish) a Bolivian dollar [n]\n",
  "BOLIVIAS": "BOLIVIA, (Spanish) a soft fabric [n]\n",
  "BOLIX": "to make a mess of, also BOLLIX, BALLOCKS, BOLLOCKS, BOLLOX [v -ED, -ING, -ES]\n",
  "BOLIXED": "BOLIX, to make a mess of, also BOLLIX, BALLOCKS, BOLLOCKS, BOLLOX [v]\n",
  "BOLIXES": "BOLIX, to make a mess of, also BOLLIX, BALLOCKS, BOLLOCKS, BOLLOX [v]\n",
  "BOLIXING": "BOLIX, to make a mess of, also BOLLIX, BALLOCKS, BOLLOCKS, BOLLOX [v]\n",
  "BOLL": "to form pods [v -ED, -ING, -S]\n",
  "BOLLARD": "a post of metal or wood on a wharf or ship around which to fasten lines [n -S]\n",
  "BOLLARDS": "BOLLARD, a post of metal or wood on a wharf or ship around which to fasten lines [n]\n",
  "BOLLED": "BOLL, to form pods [v]\n",
  "BOLLEN": "(obsolete) swollen [adj]\n",
  "BOLLETRIE": "a West Indian saponaceous tree, aka balata, also BULLETRIE [n -S]\n",
  "BOLLETRIES": "BOLLETRIE, a West Indian saponaceous tree, aka balata, also BULLETRIE [n]\n",
  "BOLLING": "BOLL, to form pods [v]\n",
  "BOLLIX": "to make a mess of, also BALLOCKS, BOLIX, BOLLOCKS, BOLLOX [v -ED, -ING, -ES]\n",
  "BOLLIXED": "BOLLIX, to make a mess of, also BALLOCKS, BOLIX, BOLLOCKS, BOLLOX [v]\n",
  "BOLLIXES": "BOLLIX, to make a mess of, also BALLOCKS, BOLIX, BOLLOCKS, BOLLOX [v]\n",
  "BOLLIXING": "BOLLIX, to make a mess of, also BALLOCKS, BOLIX, BOLLOCKS, BOLLOX [v]\n",
  "BOLLOCK": "to reprimand severely [v -ED, -ING, -S]\n",
  "BOLLOCKED": "BOLLOCK, to reprimand severely [v]\n",
  "BOLLOCKING": "a reprimand [n -S]\n",
  "BOLLOCKINGS": "BOLLOCKING, a reprimand [n]\n",
  "BOLLOCKS": "to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOX [v -ED, -ING, -ES]\n",
  "BOLLOCKSED": "BOLLOCKS, to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOX [v]\n",
  "BOLLOCKSES": "BOLLOCKS, to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOX [v]\n",
  "BOLLOCKSING": "BOLLOCKS, to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOX [v]\n",
  "BOLLOX": "to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOCKS [v -ED, -ING, -ES]\n",
  "BOLLOXED": "BOLLOX, to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOCKS [v]\n",
  "BOLLOXES": "BOLLOX, to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOCKS [v]\n",
  "BOLLOXING": "BOLLOX, to make a mess of, also BOLLIX, BALLOCKS, BOLIX, BOLLOCKS [v]\n",
  "BOLLS": "BOLL, to form pods [v]\n",
  "BOLLWORM": "the larva of a moth which devours the bolls or unripe pods of the cotton plant [n -S]\n",
  "BOLLWORMS": "BOLLWORM, the larva of a moth which devours the bolls or unripe pods of the cotton plant [n]\n",
  "BOLO": "(Spanish) a traditional long-bladed Philippine knife [n -S]\n",
  "BOLOGNA": "(Italian) a seasoned sausage, also BOLONEY [n -S]\n",
  "BOLOGNAS": "BOLOGNA, (Italian) a seasoned sausage, also BOLONEY [n]\n",
  "BOLOGNESE": "a meat and tomato sauce [n -S]\n",
  "BOLOGNESES": "BOLOGNESE, a meat and tomato sauce [n]\n",
  "BOLOGRAPH": "a record made by a bolometer, an instrument for measuring radiant energy [n -S]\n",
  "BOLOGRAPHS": "BOLOGRAPH, a record made by a bolometer, an instrument for measuring radiant energy [n]\n",
  "BOLOMETER": "an instrument for measuring radiant energy or infrared light [n -S]\n",
  "BOLOMETERS": "BOLOMETER, an instrument for measuring radiant energy or infrared light [n]\n",
  "BOLOMETRIC": "relating to bolometry, measurement of radiant energy [adj BOLOMETRICALLY]\n",
  "BOLOMETRICALLY": "BOLOMETRIC, relating to bolometry, measurement of radiant energy [adv]\n",
  "BOLOMETRIES": "BOLOMETRY, measurement by a bolometer, an instrument for measuring radiant energy or infrared light [n]\n",
  "BOLOMETRY": "measurement by a bolometer, an instrument for measuring radiant energy or infrared light [n BOLOMETRIES]\n",
  "BOLONEY": "deceptive talk, nonsense; Bologna sausage, also BALONEY [n -S]\n",
  "BOLONEYS": "BOLONEY, deceptive talk, nonsense; Bologna sausage, also BALONEY [n]\n",
  "BOLOS": "BOLO, (Spanish) a traditional long-bladed Philippine knife [n]\n",
  "BOLSHEVIK": "(Russian) a violent revolutionary [n BOLSHEVIKS or BOLSHEVIKI]\n",
  "BOLSHEVIKI": "BOLSHEVIK, (Russian) a violent revolutionary [n]\n",
  "BOLSHEVIKS": "BOLSHEVIK, (Russian) a violent revolutionary [n]\n",
  "BOLSHEVISE": "to make a bolshevik, also BOLSHEVIZE [v BOLSHEVISED, BOLSHEVISING, BOLSHEVISES]\n",
  "BOLSHEVISED": "BOLSHEVISE, to make a bolshevik, also BOLSHEVIZE [v]\n",
  "BOLSHEVISES": "BOLSHEVISE, to make a bolshevik, also BOLSHEVIZE [v]\n",
  "BOLSHEVISING": "BOLSHEVISE, to make a bolshevik, also BOLSHEVIZE [v]\n",
  "BOLSHEVISM": "being a bolshevik [n -S]\n",
  "BOLSHEVISMS": "BOLSHEVISM, being a bolshevik [n]\n",
  "BOLSHEVIZE": "to make a bolshevik, also BOLSHEVISE [v BOLSHEVIZED, BOLSHEVIZING, BOLSHEVIZES]\n",
  "BOLSHEVIZED": "BOLSHEVIZE, to make a bolshevik, also BOLSHEVISE [v]\n",
  "BOLSHEVIZES": "BOLSHEVIZE, to make a bolshevik, also BOLSHEVISE [v]\n",
  "BOLSHEVIZING": "BOLSHEVIZE, to make a bolshevik, also BOLSHEVISE [v]\n",
  "BOLSHIE": "a Bolshevik [n -S] / leftwing, obstreperous, also BOLSHY [adj BOLSHIER, BOLSHIEST]\n",
  "BOLSHIER": "BOLSHIE, leftwing, obstreperous, also BOLSHY [adj]\n",
  "BOLSHIES": "BOLSHIE, a Bolshevik [n]\n",
  "BOLSHIEST": "BOLSHIE, leftwing, obstreperous, also BOLSHY [adj]\n",
  "BOLSHY": "leftwing, obstreperous, also BOLSHIE [adj BOLSHIER, BOLSHIEST]\n",
  "BOLSON": "(Spanish) a basin-shaped depression surrounded by mountains, esp. in the southern US and Mexico [n -S]\n",
  "BOLSONS": "BOLSON, (Spanish) a basin-shaped depression surrounded by mountains, esp. in the southern US and Mexico [n]\n",
  "BOLSTER": "to support [v -ED, -ING, -S]\n",
  "BOLSTERED": "BOLSTER, to support [v]\n",
  "BOLSTERER": "one who bolsters [n -S]\n",
  "BOLSTERERS": "BOLSTERER, one who bolsters [n]\n",
  "BOLSTERING": "the act of propping up [n -S]\n",
  "BOLSTERINGS": "BOLSTERING, the act of propping up [n]\n",
  "BOLSTERS": "BOLSTER, to support [v]\n",
  "BOLT": "to run away [v -ED, -ING, -S]\n",
  "BOLTED": "BOLT, to run away [v]\n",
  "BOLTER": "a sieve, a machine for separating bran from flour, also BOULTER [n -S]\n",
  "BOLTERS": "BOLTER, a sieve, a machine for separating bran from flour, also BOULTER [n]\n",
  "BOLTHEAD": "a straight-necked distillation vessel or flask [n -S]\n",
  "BOLTHEADS": "BOLTHEAD, a straight-necked distillation vessel or flask [n]\n",
  "BOLTHOLE": "a place or way of escape [n -S]\n",
  "BOLTHOLES": "BOLTHOLE, a place or way of escape [n]\n",
  "BOLTING": "the act of sieving through cloth, also BOULTING [n -S]\n",
  "BOLTINGS": "BOLTING, the act of sieving through cloth, also BOULTING [n]\n",
  "BOLTLESS": "without a bolt [adj]\n",
  "BOLTLIKE": "like a bolt [adj]\n",
  "BOLTONIA": "a tall perennial flower of the eastern US, aka false aster [n -S]\n",
  "BOLTONIAS": "BOLTONIA, a tall perennial flower of the eastern US, aka false aster [n]\n",
  "BOLTROPE": "a strong rope stitched to the edges of a sail [n -S]\n",
  "BOLTROPES": "BOLTROPE, a strong rope stitched to the edges of a sail [n]\n",
  "BOLTS": "BOLT, to run away [v]\n",
  "BOLUS": "(Latin) a large pill; a soft rounded mass of chewed food [n -ES]\n",
  "BOLUSES": "BOLUS, (Latin) a large pill; a soft rounded mass of chewed food [n]\n",
  "BOMA": "(Swahili) in Africa, a thorn enclosure [n -S]\n",
  "BOMAS": "BOMA, (Swahili) in Africa, a thorn enclosure [n]\n",
  "BOMB": "to attack with an exploding device [v -ED, -ING, -S]\n",
  "BOMBABLE": "able to be bombed [adj]\n",
  "BOMBACACEOUS": "relating to the family Bombacaceae, silk-cotton trees [adj]\n",
  "BOMBARD": "to attack with artillery [v -ED, -ING, -S]\n",
  "BOMBARDE": "an alto wind instrument similar to the oboe [n -S]\n",
  "BOMBARDED": "BOMBARD, to attack with artillery [v]\n",
  "BOMBARDER": "one who bombards [n -S]\n",
  "BOMBARDERS": "BOMBARDER, one who bombards [n]\n",
  "BOMBARDES": "BOMBARDE, an alto wind instrument similar to the oboe [n]\n",
  "BOMBARDIER": "(French) in the British army, a noncommissioned officer in the artillery [n -S]\n",
  "BOMBARDIERS": "BOMBARDIER, (French) in the British army, a noncommissioned officer in the artillery [n]\n",
  "BOMBARDING": "BOMBARD, to attack with artillery [v]\n",
  "BOMBARDMENT": "the act of bombarding [n -S]\n",
  "BOMBARDMENTS": "BOMBARDMENT, the act of bombarding [n]\n",
  "BOMBARDON": "the bass tuba [n -S]\n",
  "BOMBARDONS": "BOMBARDON, the bass tuba [n]\n",
  "BOMBARDS": "BOMBARD, to attack with artillery [v]\n",
  "BOMBASINE": "(French) a twilled silk and worsted fabric, also BOMBAZINE [n -S]\n",
  "BOMBASINES": "BOMBASINE, (French) a twilled silk and worsted fabric, also BOMBAZINE [n]\n",
  "BOMBAST": "pompous speech or writing [n -S] / to stuff or pad with cotton wool or the like [v -ED, -ING, -S]\n",
  "BOMBASTED": "BOMBAST, to stuff or pad with cotton wool or the like [v]\n",
  "BOMBASTER": "one who speaks bombast [n -S]\n",
  "BOMBASTERS": "BOMBASTER, one who speaks bombast [n]\n",
  "BOMBASTIC": "of or like bombast, high-flown [adj BOMBASTICALLY]\n",
  "BOMBASTICALLY": "BOMBASTIC, of or like bombast, high-flown [adv]\n",
  "BOMBASTING": "BOMBAST, to stuff or pad with cotton wool or the like [v]\n",
  "BOMBASTS": "BOMBAST, to stuff or pad with cotton wool or the like [v]\n",
  "BOMBAX": "(Latin) a tree of the genus Bombax, the silk-cotton tree [n -ES]\n",
  "BOMBAXES": "BOMBAX, (Latin) a tree of the genus Bombax, the silk-cotton tree [n]\n",
  "BOMBAZINE": "(French) a twilled silk and worsted fabric, also BOMBASINE [n -S]\n",
  "BOMBAZINES": "BOMBAZINE, (French) a twilled silk and worsted fabric, also BOMBASINE [n]\n",
  "BOMBE": "(French) a dessert, usually ice-cream in a melon shape [n -S]\n",
  "BOMBED": "BOMB, to attack with an exploding device [v]\n",
  "BOMBER": "an aeroplane that carries bombs [n -S]\n",
  "BOMBERS": "BOMBER, an aeroplane that carries bombs [n]\n",
  "BOMBES": "BOMBE, (French) a dessert, usually ice-cream in a melon shape [n]\n",
  "BOMBESIN": "a hormone partly responsible for regulating appetite [n -S]\n",
  "BOMBESINS": "BOMBESIN, a hormone partly responsible for regulating appetite [n]\n",
  "BOMBILATE": "to buzz, drone, also BOMBINATE [v BOMBILATED, BOMBILATING, BOMBILATES]\n",
  "BOMBILATED": "BOMBILATE, to buzz, drone, also BOMBINATE [v]\n",
  "BOMBILATES": "BOMBILATE, to buzz, drone, also BOMBINATE [v]\n",
  "BOMBILATING": "BOMBILATE, to buzz, drone, also BOMBINATE [v]\n",
  "BOMBILATION": "a buzzing or droning sound, also BOMBINATION [n -S]\n",
  "BOMBILATIONS": "BOMBILATION, a buzzing or droning sound, also BOMBINATION [n]\n",
  "BOMBINATE": "to buzz, drone, also BOMBILATE [v BOMBINATED, BOMBINATING, BOMBINATES]\n",
  "BOMBINATED": "BOMBINATE, to buzz, drone, also BOMBILATE [v]\n",
  "BOMBINATES": "BOMBINATE, to buzz, drone, also BOMBILATE [v]\n",
  "BOMBINATING": "BOMBINATE, to buzz, drone, also BOMBILATE [v]\n",
  "BOMBINATION": "a buzzing or droning sound, also BOMBILATION [n -S]\n",
  "BOMBINATIONS": "BOMBINATION, a buzzing or droning sound, also BOMBILATION [n]\n",
  "BOMBING": "an attack with bombs [n -S]\n",
  "BOMBINGS": "BOMBING, an attack with bombs [n]\n",
  "BOMBLET": "a small bomb [n -S]\n",
  "BOMBLETS": "BOMBLET, a small bomb [n]\n",
  "BOMBLOAD": "as many bombs as a plane may carry [n -S]\n",
  "BOMBLOADS": "BOMBLOAD, as many bombs as a plane may carry [n]\n",
  "BOMBO": "(Australian slang) cheap wine [n -S]\n",
  "BOMBORA": "(Native Australian) a submerged reef [n -S]\n",
  "BOMBORAS": "BOMBORA, (Native Australian) a submerged reef [n]\n",
  "BOMBOS": "BOMBO, (Australian slang) cheap wine [n]\n",
  "BOMBPROOF": "proof against bombs [adj] / to make proof against bombs [v -ED, -ING, -S]\n",
  "BOMBPROOFED": "BOMBPROOF, to make proof against bombs [v]\n",
  "BOMBPROOFING": "BOMBPROOF, to make proof against bombs [v]\n",
  "BOMBPROOFS": "BOMBPROOF, to make proof against bombs [v]\n",
  "BOMBS": "BOMB, to attack with an exploding device [v]\n",
  "BOMBSHELL": "a bomb; a sudden and surprising piece of news [n -S]\n",
  "BOMBSHELLS": "BOMBSHELL, a bomb; a sudden and surprising piece of news [n]\n",
  "BOMBSIGHT": "a device for aiming and releasing bombs from a bomber [n -S]\n",
  "BOMBSIGHTS": "BOMBSIGHT, a device for aiming and releasing bombs from a bomber [n]\n",
  "BOMBSITE": "an area that has been bombed [n -S]\n",
  "BOMBSITES": "BOMBSITE, an area that has been bombed [n]\n",
  "BOMBYCID": "a silkworm [n -S]\n",
  "BOMBYCIDS": "BOMBYCID, a silkworm [n]\n",
  "BOMBYCOID": "of or like a moth of the silkworm family, also BOMBYCID [adj]\n",
  "BOMBYX": "(Greek) a moth of the genus Bombyx, which includes the silkworm moth [n -ES]\n",
  "BOMBYXES": "BOMBYX, (Greek) a moth of the genus Bombyx, which includes the silkworm moth [n]\n",
  "BOMMIE": "(Australian slang) a bombora, a submerged reef [n -S]\n",
  "BOMMIES": "BOMMIE, (Australian slang) a bombora, a submerged reef [n]\n",
  "BON": "(French) good [adj]\n",
  "BONA": "(Latin) goods [n]\n",
  "BONACI": "an edible fish of the grouper family [n -S]\n",
  "BONACIS": "BONACI, an edible fish of the grouper family [n]\n",
  "BONAMANI": "BONAMANO, (Italian) a tip [n]\n",
  "BONAMANO": "(Italian) a tip [n BONAMANI]\n",
  "BONAMIA": "a parasite that attacks oysters [n -S]\n",
  "BONAMIAS": "BONAMIA, a parasite that attacks oysters [n]\n",
  "BONAMIASES": "BONAMIASIS, a fatal disease of oysters [n]\n",
  "BONAMIASIS": "a fatal disease of oysters [n BONAMIASES]\n",
  "BONANZA": "(Spanish) a lucky strike in e.g. mining [n -S]\n",
  "BONANZAS": "BONANZA, (Spanish) a lucky strike in e.g. mining [n]\n",
  "BONASSUS": "(Latin) a bison, also BONASUS [n -ES]\n",
  "BONASSUSES": "BONASSUS, (Latin) a bison, also BONASUS [n]\n",
  "BONASUS": "(Latin) a bison, also BONASSUS [n -ES]\n",
  "BONASUSES": "BONASUS, (Latin) a bison, also BONASSUS [n]\n",
  "BONBON": "(French) a confection [n -S]\n",
  "BONBONNIERE": "(French) a fancy box for holding sweets [n -S]\n",
  "BONBONNIERES": "BONBONNIERE, (French) a fancy box for holding sweets [n]\n",
  "BONBONS": "BONBON, (French) a confection [n]\n",
  "BONCE": "a large marble used in games [n -S]\n",
  "BONCES": "BONCE, a large marble used in games [n]\n",
  "BOND": "to join together [v -ED, -ING, -S]\n",
  "BONDABLE": "that can be bonded [adj]\n",
  "BONDAGE": "slavery [n -S]\n",
  "BONDAGER": "(historical) a field worker, esp. a woman who works in the field [n -S]\n",
  "BONDAGERS": "BONDAGER, (historical) a field worker, esp. a woman who works in the field [n]\n",
  "BONDAGES": "BONDAGE, slavery [n]\n",
  "BONDED": "BOND, to join together [v]\n",
  "BONDER": "one who bonds [n -S]\n",
  "BONDERS": "BONDER, one who bonds [n]\n",
  "BONDHOLDER": "a person who holds the bonds of a public or private corporation for the payment of money at a certain time [n -S]\n",
  "BONDHOLDERS": "BONDHOLDER, a person who holds the bonds of a public or private corporation for the payment of money at a certain time [n]\n",
  "BONDING": "the act of bonding [n -S]\n",
  "BONDINGS": "BONDING, the act of bonding [n]\n",
  "BONDLESS": "without a bond [adj]\n",
  "BONDMAID": "a female slave [n -S]\n",
  "BONDMAIDS": "BONDMAID, a female slave [n]\n",
  "BONDMAN": "a male slave [n BONDMEN]\n",
  "BONDMANSHIP": "the state of being a bondsman [n -S]\n",
  "BONDMANSHIPS": "BONDMANSHIP, the state of being a bondsman [n]\n",
  "BONDMEN": "BONDMAN, a male slave [n]\n",
  "BONDS": "BOND, to join together [v]\n",
  "BONDSERVANT": "a slave [n -S]\n",
  "BONDSERVANTS": "BONDSERVANT, a slave [n]\n",
  "BONDSMAN": "a male slave [n BONDSMEN]\n",
  "BONDSMEN": "BONDSMAN, a male slave [n]\n",
  "BONDSTONE": "a stone running through a wall from one face to another, to bind it together [n -S]\n",
  "BONDSTONES": "BONDSTONE, a stone running through a wall from one face to another, to bind it together [n]\n",
  "BONDSWOMAN": "a woman who is a slave, or in bondage, also BONDWOMAN [n BONDSWOMEN]\n",
  "BONDSWOMEN": "BONDSWOMAN, a woman who is a slave, or in bondage, also BONDWOMAN [n]\n",
  "BONDUC": "(Arabic) the seed of a tropical leguminous tree, aka nicker or nickar [n -S]\n",
  "BONDUCS": "BONDUC, (Arabic) the seed of a tropical leguminous tree, aka nicker or nickar [n]\n",
  "BONDWOMAN": "a woman who is a slave, or in bondage, also BONDSWOMAN [n BONDWOMEN]\n",
  "BONDWOMEN": "BONDWOMAN, a woman who is a slave, or in bondage, also BONDSWOMAN [n]\n",
  "BONE": "to take the bones out of [v BONED, BONING, BONES]\n",
  "BONEBED": "an area containing dinosaur fossils [n -S]\n",
  "BONEBEDS": "BONEBED, an area containing dinosaur fossils [n]\n",
  "BONEBLACK": "black residue from the destructive distillation of bones [n -S]\n",
  "BONEBLACKS": "BONEBLACK, black residue from the destructive distillation of bones [n]\n",
  "BONED": "BONE, to take the bones out of [v]\n",
  "BONEFISH": "a slender marine fish [n -ES]\n",
  "BONEFISHES": "BONEFISH, a slender marine fish [n]\n",
  "BONEFISHING": "the sport of fishing for bonefish [n -S]\n",
  "BONEFISHINGS": "BONEFISHING, the sport of fishing for bonefish [n]\n",
  "BONEHEAD": "a blockhead [n -S]\n",
  "BONEHEADED": "stupid [adj]\n",
  "BONEHEADEDNESS": "the state of being boneheaded [n]\n",
  "BONEHEADS": "BONEHEAD, a blockhead [n]\n",
  "BONELESS": "without bones [adj]\n",
  "BONELIKE": "like bone [adj]\n",
  "BONEMEAL": "a fertilizer made from crushed bone [n -S]\n",
  "BONEMEALS": "BONEMEAL, a fertilizer made from crushed bone [n]\n",
  "BONER": "(US slang) a stupid mistake [n -S]\n",
  "BONERS": "BONER, (US slang) a stupid mistake [n]\n",
  "BONES": "BONE, to take the bones out of [v]\n",
  "BONESET": "a medicinal plant, aka thoroughwort, thought to heal fractures [n -S]\n",
  "BONESETS": "BONESET, a medicinal plant, aka thoroughwort, thought to heal fractures [n]\n",
  "BONESETTER": "one who sets broken or dislocated bones [n -S]\n",
  "BONESETTERS": "BONESETTER, one who sets broken or dislocated bones [n]\n",
  "BONESHAKER": "a car or bicycle with inadequate suspension [n -S]\n",
  "BONESHAKERS": "BONESHAKER, a car or bicycle with inadequate suspension [n]\n",
  "BONETIRED": "extremely tired [adj]\n",
  "BONEY": "like bone, also BONY [adj BONIER or BONEYER, BONIEST or BONEYEST]\n",
  "BONEYARD": "a place where the bones of dead animals are deposited; (slang) a cemetery [n -S]\n",
  "BONEYARDS": "BONEYARD, a place where the bones of dead animals are deposited; (slang) a cemetery [n]\n",
  "BONEYER": "BONEY, like bone, also BONY [adj]\n",
  "BONEYEST": "BONEY, like bone, also BONY [adj]\n",
  "BONFIRE": "a large fire in the open air [n -S]\n",
  "BONFIRES": "BONFIRE, a large fire in the open air [n]\n",
  "BONG": "to make a deep ringing sound [v -ED, -ING, -S]\n",
  "BONGED": "BONG, to make a deep ringing sound [v]\n",
  "BONGING": "BONG, to make a deep ringing sound [v]\n",
  "BONGO": "(Bantu) a kind of antelope [n BONGOS or BONGOES]\n",
  "BONGOES": "BONGO, (Bantu) a kind of antelope [n]\n",
  "BONGOIST": "a bongo player [n -S]\n",
  "BONGOISTS": "BONGOIST, a bongo player [n]\n",
  "BONGOS": "BONGO, (Bantu) a kind of antelope [n]\n",
  "BONGRACE": "(French) a sunshade worn over a hat [n -S]\n",
  "BONGRACES": "BONGRACE, (French) a sunshade worn over a hat [n]\n",
  "BONGS": "BONG, to make a deep ringing sound [v]\n",
  "BONHAM": "(Irish) a piglet [n -S]\n",
  "BONHAMS": "BONHAM, (Irish) a piglet [n]\n",
  "BONHOMIE": "(French) good nature; a pleasant and easy manner, also BONHOMMIE [n -S]\n",
  "BONHOMIES": "BONHOMIE, (French) good nature; a pleasant and easy manner, also BONHOMMIE [n]\n",
  "BONHOMMIE": "(French) good nature; a pleasant and easy manner, also BONHOMIE [n -S]\n",
  "BONHOMMIES": "BONHOMMIE, (French) good nature; a pleasant and easy manner, also BONHOMIE [n]\n",
  "BONHOMOUS": "full of bonhomie, good nature; pleasant and easy manner [adj]\n",
  "BONIATO": "a sweet potato [n -S]\n",
  "BONIATOS": "BONIATO, a sweet potato [n]\n",
  "BONIBELL": "(Spenser) a good and fair maid, also BELLIBONE, BONNIBELL [n -S]\n",
  "BONIBELLS": "BONIBELL, (Spenser) a good and fair maid, also BELLIBONE, BONNIBELL [n]\n",
  "BONIE": "(Scots) bonny [adj]\n",
  "BONIER": "BONEY, like bone, also BONY [adj]\n",
  "BONIEST": "BONY, like bone, also BONEY [adj]\n",
  "BONIFACE": "(French) the proprietor of a hotel, nightclub or restaurant [n -S]\n",
  "BONIFACES": "BONIFACE, (French) the proprietor of a hotel, nightclub or restaurant [n]\n",
  "BONILASSE": "(Spenser) a bonny lass, also BONNILASSE [n -S]\n",
  "BONILASSES": "BONILASSE, (Spenser) a bonny lass, also BONNILASSE [n]\n",
  "BONINESS": "the state of being bony [n -ES]\n",
  "BONINESSES": "BONINESS, the state of being bony [n]\n",
  "BONING": "the process of estimating straightness by looking along a row of poles [n -S]\n",
  "BONINGS": "BONING, the process of estimating straightness by looking along a row of poles [n]\n",
  "BONISM": "the doctrine that the world is mainly good but not perfect [n -S]\n",
  "BONISMS": "BONISM, the doctrine that the world is mainly good but not perfect [n]\n",
  "BONIST": "one who holds the doctrine of bonism [n -S]\n",
  "BONISTS": "BONIST, one who holds the doctrine of bonism [n]\n",
  "BONITA": "(Spanish) a large fish of the mackerel family, also BONITO [n -S]\n",
  "BONITAS": "BONITA, (Spanish) a large fish of the mackerel family, also BONITO [n]\n",
  "BONITO": "(Spanish) a large fish of the mackerel family, also BONITA [n BONITOS or BONITOES]\n",
  "BONITOES": "BONITO, (Spanish) a large fish of the mackerel family, also BONITA [n]\n",
  "BONITOS": "BONITO, (Spanish) a large fish of the mackerel family, also BONITA [n]\n",
  "BONJOUR": "(French) good morning [interj]\n",
  "BONK": "to hit or thump, to have sexual intercourse [v -ED, -ING, -S]\n",
  "BONKBUSTER": "a work of popular fiction centering on erotic encounters [n -S]\n",
  "BONKBUSTERS": "BONKBUSTER, a work of popular fiction centering on erotic encounters [n]\n",
  "BONKED": "BONK, to hit or thump, to have sexual intercourse [v]\n",
  "BONKERS": "crazy [adj]\n",
  "BONKING": "the act of bonking [n -S]\n",
  "BONKINGS": "BONKING, the act of bonking [n]\n",
  "BONKS": "BONK, to hit or thump, to have sexual intercourse [v]\n",
  "BONNE": "(French) a French maid or nursemaid [n -S]\n",
  "BONNES": "BONNE, (French) a French maid or nursemaid [n]\n",
  "BONNET": "to put on a head covering tied with ribbon [v -ED, -ING, -S]\n",
  "BONNETED": "BONNET, to put on a head covering tied with ribbon [v]\n",
  "BONNETING": "BONNET, to put on a head covering tied with ribbon [v]\n",
  "BONNETS": "BONNET, to put on a head covering tied with ribbon [v]\n",
  "BONNIBELL": "(Spenser) a good and fair maid, also BELLIBONE, BONIBELL [n -S]\n",
  "BONNIBELLS": "BONNIBELL, (Spenser) a good and fair maid, also BELLIBONE, BONIBELL [n]\n",
  "BONNIE": "a sweetheart, also BONNY [n -S] / pretty or healthy [adj BONNIER, BONNIEST]\n",
  "BONNIER": "BONNY, pretty or healthy, also BONNIE [adj]\n",
  "BONNIES": "BONNY, a sweetheart [n]\n",
  "BONNIEST": "BONNY, pretty or healthy, also BONNIE [adj]\n",
  "BONNILASSE": "(Spenser) a bonny lass, also BONILASSE [n -S]\n",
  "BONNILASSES": "BONNILASSE, (Spenser) a bonny lass, also BONILASSE [n]\n",
  "BONNILY": "BONNY, pretty or healthy, also BONNIE [adv]\n",
  "BONNINESS": "the state of being bonny [n -ES]\n",
  "BONNINESSES": "BONNINESS, the state of being bonny [n]\n",
  "BONNOCK": "(Scots) a flat oatmeal cake, also BANNOCK [n -S]\n",
  "BONNOCKS": "BONNOCK, (Scots) a flat oatmeal cake, also BANNOCK [n]\n",
  "BONNY": "a sweetheart [n BONNIES] / pretty or healthy, also BONNIE [adj BONNIER, BONNIEST]\n",
  "BONNYCLABBER": "(Irish) milk naturally clotted on souring [n -S]\n",
  "BONNYCLABBERS": "BONNYCLABBER, (Irish) milk naturally clotted on souring [n]\n",
  "BONOBO": "a chimpanzee-like primate [n -S]\n",
  "BONOBOS": "BONOBO, a chimpanzee-like primate [n]\n",
  "BONSAI": "(Japanese) the practice of cultivating artificially dwarfed potted plants or small trees [n]\n",
  "BONSELA": "(Zulu) a gratuity to a black South African, also BONSELLA, BANSELA, PASELA [n -S]\n",
  "BONSELAS": "BONSELA, (Zulu) a gratuity to a black South African, also BONSELLA, BANSELA, PASELA [n]\n",
  "BONSELLA": "(Zulu) a gratuity to a black South African, also BONSELA, BANSELA, PASELA [n -S]\n",
  "BONSELLAS": "BONSELLA, (Zulu) a gratuity to a black South African, also BONSELA, BANSELA, PASELA [n]\n",
  "BONSOIR": "(French) good evening [interj]\n",
  "BONSPELL": "(Scots) a curling match between clubs, also BONSPIEL [n -S]\n",
  "BONSPELLS": "BONSPELL, (Scots) a curling match between clubs, also BONSPIEL [n]\n",
  "BONSPIEL": "(Scots) a curling match between clubs, also BONSPELL [n -S]\n",
  "BONSPIELS": "BONSPIEL, (Scots) a curling match between clubs, also BONSPELL [n]\n",
  "BONTBOK": "a kind of antelope, also BONTEBOK [n -S]\n",
  "BONTBOKS": "BONTBOK, a kind of antelope, also BONTEBOK [n]\n",
  "BONTEBOK": "(South African) the pied antelope of South Africa, also BONTBOK [n -S]\n",
  "BONTEBOKS": "BONTEBOK, (South African) the pied antelope of South Africa, also BONTBOK [n]\n",
  "BONUS": "in Scrabble, to play all seven of one's tiles in a single turn [v BONUSED or BONUSSED, BONUSING or BONUSSING, BONUSES or BONUSSES]\n",
  "BONUSED": "BONUS, in Scrabble, to play all seven of one's tiles in a single turn [v]\n",
  "BONUSES": "BONUS, in Scrabble, to play all seven of one's tiles in a single turn [v]\n",
  "BONUSING": "at Scrabble, the act of playing all seven of one's tiles in a single turn [n -S]\n",
  "BONUSINGS": "BONUSING, at Scrabble, the act of playing all seven of one's tiles in a single turn [n]\n",
  "BONUSSED": "BONUS, in Scrabble, to play all seven of one's tiles in a single turn [v]\n",
  "BONUSSES": "BONUS, in Scrabble, to play all seven of one's tiles in a single turn [v]\n",
  "BONUSSING": "BONUS, in Scrabble, to play all seven of one's tiles in a single turn [v]\n",
  "BONXIE": "the great skua [n -S]\n",
  "BONXIES": "BONXIE, the great skua [n]\n",
  "BONY": "like bone, also BONEY [adj BONIER, BONIEST]\n",
  "BONZA": "(Australian slang) very good, also BONZER [adj]\n",
  "BONZE": "(Japanese) a Japanese or Chinese Buddhist religious teacher [n -S]\n",
  "BONZER": "(Australian slang) very good, also BONZA [adj]\n",
  "BONZES": "BONZE, (Japanese) a Japanese or Chinese Buddhist religious teacher [n]\n",
  "BOO": "to show disapproval by making this sound, also BOOH [v -ED, -ING, -S]\n",
  "BOOAI": "(New Zealand) a remote rural place, as in up the booai, thoroughly lost, also BOOAY, BOOHAI [n -S]\n",
  "BOOAIS": "BOOAI, (New Zealand) a remote rural place, as in up the booai, thoroughly lost, also BOOAY, BOOHAI [n]\n",
  "BOOAY": "(New Zealand) a remote rural place, as in up the booay, thoroughly lost, also BOOAI, BOOHAI [n -S]\n",
  "BOOAYS": "BOOAY, (New Zealand) a remote rural place, as in up the booay, thoroughly lost, also BOOAI, BOOHAI [n]\n",
  "BOOB": "to make a mistake [v -ED, -ING, -S]\n",
  "BOOBED": "BOOB, to make a mistake [v]\n",
  "BOOBHEAD": "(Australian slang) a repeat offender in prison [n -S]\n",
  "BOOBHEADS": "BOOBHEAD, (Australian slang) a repeat offender in prison [n]\n",
  "BOOBIALLA": "(Native Australian) an Australian tree, aka golden wattle [n -S]\n",
  "BOOBIALLAS": "BOOBIALLA, (Native Australian) an Australian tree, aka golden wattle [n]\n",
  "BOOBIE": "(slang) a breast [n -S]\n",
  "BOOBIES": "BOOBIE, (slang) a breast [n]\n",
  "BOOBING": "BOOB, to make a mistake [v]\n",
  "BOOBIRD": "a fan who boos players of the home team [n -S]\n",
  "BOOBIRDS": "BOOBIRD, a fan who boos players of the home team [n]\n",
  "BOOBISH": "doltish [adj]\n",
  "BOOBOISIE": "boobs as a class; the general public regarded as consisting of boobies [n -S]\n",
  "BOOBOISIES": "BOOBOISIE, boobs as a class; the general public regarded as consisting of boobies [n]\n",
  "BOOBOO": "a mistake [n -S]\n",
  "BOOBOOK": "(Native Australian) a kind of owl found in Australasia, aka mopoke, morepork [n -S]\n",
  "BOOBOOKS": "BOOBOOK, (Native Australian) a kind of owl found in Australasia, aka mopoke, morepork [n]\n",
  "BOOBOOS": "BOOBOO, a mistake [n]\n",
  "BOOBS": "BOOB, to make a mistake [v]\n",
  "BOOBY": "a name for various kinds of gannet [n BOOBIES]\n",
  "BOOBYISH": "stupid; dull [adj]\n",
  "BOOBYISM": "a state of stupidity [n -S]\n",
  "BOOBYISMS": "BOOBYISM, a state of stupidity [n]\n",
  "BOOCOO": "(slang) much or many, also BOOKOO [n -S]\n",
  "BOOCOOS": "BOOCOO, (slang) much or many, also BOOKOO [n]\n",
  "BOODIE": "(Native Australian) a species of rat-kangaroo [n -S]\n",
  "BOODIED": "BOODY, to sulk or mope [v]\n",
  "BOODIES": "BOODIE, (Native Australian) a species of rat-kangaroo [n]\n",
  "BOODLE": "(Dutch) to take bribes [v BOODLED, BOODLING, BOODLES]\n",
  "BOODLED": "BOODLE, (Dutch) to take bribes [v]\n",
  "BOODLER": "someone involved in bribery [n -S]\n",
  "BOODLERS": "BOODLER, someone involved in bribery [n]\n",
  "BOODLES": "BOODLE, (Dutch) to take bribes [v]\n",
  "BOODLING": "BOODLE, (Dutch) to take bribes [v]\n",
  "BOODY": "to sulk or mope [v BOODIED, BOODYING, BOODIES]\n",
  "BOODYING": "BOODY, to sulk or mope [v]\n",
  "BOOED": "BOO, to show disapproval by making this sound, also BOOH [v]\n",
  "BOOFHEAD": "(Australian slang) a stupid person [n -S]\n",
  "BOOFHEADS": "BOOFHEAD, (Australian slang) a stupid person [n]\n",
  "BOOFIER": "BOOFY, muscular and strong but stupid [adj]\n",
  "BOOFIEST": "BOOFY, muscular and strong but stupid [adj]\n",
  "BOOFY": "muscular and strong but stupid [adj BOOFIER, BOOFIEST]\n",
  "BOOGALOO": "a kind of dance [n -S] / to dance the boogaloo [v -ED, -ING, -S]\n",
  "BOOGALOOED": "BOOGALOO, to dance the boogaloo [v]\n",
  "BOOGALOOING": "BOOGALOO, to dance the boogaloo [v]\n",
  "BOOGALOOS": "BOOGALOO, to dance the boogaloo [v]\n",
  "BOOGER": "a bogeyman [n -S]\n",
  "BOOGERMAN": "a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGY, BOGYMAN, BOOGEYMAN, BOOGIEMAN, BOOGYMAN [n BOOGERMEN]\n",
  "BOOGERMEN": "BOOGERMAN, a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGY, BOGYMAN, BOOGEYMAN, BOOGIEMAN, BOOGYMAN [n]\n",
  "BOOGERS": "BOOGER, a bogeyman [n]\n",
  "BOOGEY": "to dance to rock music, also BOOGIE, BOOGY [v -ED, -ING, -S]\n",
  "BOOGEYED": "BOOGEY, to dance to rock music, also BOOGIE, BOOGY [v]\n",
  "BOOGEYING": "BOOGEY, to dance to rock music, also BOOGIE, BOOGY [v]\n",
  "BOOGEYMAN": "a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGY, BOGYMAN, BOOGERMAN, BOOGIEMAN, BOOGYMAN [n BOOGEYMEN]\n",
  "BOOGEYMEN": "BOOGEYMAN, a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGY, BOGYMAN, BOOGERMAN, BOOGIEMAN, BOOGYMAN [n]\n",
  "BOOGEYS": "BOOGEY, to dance to rock music, also BOOGIE, BOOGY [v]\n",
  "BOOGIE": "to dance to rock music, also BOOGEY, BOOGY [v BOOGIED, BOOGIEING, BOOGIES]\n",
  "BOOGIED": "BOOGIE, to dance to rock music, also BOOGEY, BOOGY [v]\n",
  "BOOGIEING": "BOOGIE, to dance to rock music, also BOOGEY, BOOGY [v]\n",
  "BOOGIEMAN": "a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGY, BOGYMAN, BOOGERMAN, BOOGEYMAN, BOOGYMAN [n BOOGIEMEN]\n",
  "BOOGIEMEN": "BOOGIEMAN, a goblin, a bugbear, an object of special dread, also BOGEY, BOGEYMAN, BOGY, BOGYMAN, BOOGERMAN, BOOGEYMAN, BOOGYMAN [n]\n",
  "BOOGIES": "BOOGIE, to dance to rock music, also BOOGEY, BOOGY [v]\n",
  "BOOGY": "to dance to rock music, also BOOGIE, BOOGEY [v BOOGIED, BOOGYING, BOOGIES]\n",
  "BOOGYING": "BOOGY, to dance to rock music, also BOOGIE, BOOGEY [v]\n",
  "BOOGYMAN": "a terrifying creature, also BOGEYMAN, BOGYMAN [n BOOGYMEN]\n",
  "BOOGYMEN": "BOOGYMAN, a terrifying creature, also BOGEYMAN, BOGYMAN [n]\n",
  "BOOH": "to show disapproval by making this sound, also BOO [v -ED, -ING, -S]\n",
  "BOOHAI": "(New Zealand) a remote rural place, as in up the boohai, thoroughly lost, also BOOAI, BOOAY [n -S]\n",
  "BOOHAIS": "BOOHAI, (New Zealand) a remote rural place, as in up the boohai, thoroughly lost, also BOOAI, BOOAY [n]\n",
  "BOOHED": "BOOH, to show disapproval by making this sound, also BOO [v]\n",
  "BOOHING": "BOOH, to show disapproval by making this sound, also BOO [v]\n",
  "BOOHOO": "to cry [v -ED, -ING, -S]\n",
  "BOOHOOED": "BOOHOO, to cry [v]\n",
  "BOOHOOING": "BOOHOO, to cry [v]\n",
  "BOOHOOS": "BOOHOO, to cry [v]\n",
  "BOOHS": "BOOH, to show disapproval by making this sound, also BOO [v]\n",
  "BOOING": "the act of saying boo [n -S]\n",
  "BOOINGS": "BOOING, the act of saying boo [n]\n",
  "BOOJUM": "a spiny desert tree [n -S]\n",
  "BOOJUMS": "BOOJUM, a spiny desert tree [n]\n",
  "BOOK": "to reserve in advance [v -ED, -ING, -S]\n",
  "BOOKABLE": "able to be booked [adj]\n",
  "BOOKBAG": "a bag for carrying books [n -S]\n",
  "BOOKBAGS": "BOOKBAG, a bag for carrying books [n]\n",
  "BOOKBINDER": "one who binds books [n -S]\n",
  "BOOKBINDERIES": "BOOKBINDERY, a place where books are bound [n]\n",
  "BOOKBINDERS": "BOOKBINDER, one who binds books [n]\n",
  "BOOKBINDERY": "a place where books are bound [n BOOKBINDERIES]\n",
  "BOOKBINDING": "the art or trade of binding books [n -S]\n",
  "BOOKBINDINGS": "BOOKBINDING, the art or trade of binding books [n]\n",
  "BOOKCASE": "furniture for holding books [n -S]\n",
  "BOOKCASES": "BOOKCASE, furniture for holding books [n]\n",
  "BOOKCROSSING": "the practice of leaving a book in a public location to be found and read by others, who then do the same [n -S]\n",
  "BOOKCROSSINGS": "BOOKCROSSING, the practice of leaving a book in a public location to be found and read by others, who then do the same [n]\n",
  "BOOKED": "BOOK, to reserve in advance [v]\n",
  "BOOKEND": "a support for a row of books [n -S] / to place something at either end of [v -ED, -ING, -S]\n",
  "BOOKENDED": "BOOKEND, to place something at either end of [v]\n",
  "BOOKENDING": "BOOKEND, to place something at either end of [v]\n",
  "BOOKENDS": "BOOKEND, a support for a row of books [n]\n",
  "BOOKER": "one who engages entertainers in advance [n -S]\n",
  "BOOKERS": "BOOKER, one who engages entertainers in advance [n]\n",
  "BOOKFUL": "as much as a book can hold [n -S]\n",
  "BOOKFULS": "BOOKFUL, as much as a book can hold [n]\n",
  "BOOKIE": "(short for) a bookmaker, a bet taker [n -S]\n",
  "BOOKIER": "BOOKY, by way of being literary, also BOOKSIE, BOOKSY [adj]\n",
  "BOOKIES": "BOOKIE, (short for) a bookmaker, a bet taker [n]\n",
  "BOOKIEST": "BOOKY, by way of being literary, also BOOKSIE, BOOKSY [adj]\n",
  "BOOKING": "an engagement [n -S]\n",
  "BOOKINGS": "BOOKING, an engagement [n]\n",
  "BOOKISH": "pertaining to books [adj BOOKISHLY]\n",
  "BOOKISHLY": "BOOKISH, pertaining to books [adv]\n",
  "BOOKISHNESS": "the state of being bookish [n -ES]\n",
  "BOOKISHNESSES": "BOOKISHNESS, the state of being bookish [n]\n",
  "BOOKKEEPER": "a person responsible for keeping the accounts of a trader, public office, etc. [n -S]\n",
  "BOOKKEEPERS": "BOOKKEEPER, a person responsible for keeping the accounts of a trader, public office, etc. [n]\n",
  "BOOKKEEPING": "the job of keeping books [n -S]\n",
  "BOOKKEEPINGS": "BOOKKEEPING, the job of keeping books [n]\n",
  "BOOKLAND": "(Old English) in Old English law, land taken from the folkland or common land and granted by written charter to a private owner [n -S]\n",
  "BOOKLANDS": "BOOKLAND, (Old English) in Old English law, land taken from the folkland or common land and granted by written charter to a private owner [n]\n",
  "BOOKLESS": "without books, unlearned [adj]\n",
  "BOOKLET": "a little book [n -S]\n",
  "BOOKLETS": "BOOKLET, a little book [n]\n",
  "BOOKLICE": "BOOKLOUSE, an insect that eats books [n]\n",
  "BOOKLIGHT": "a light that clips on to a book [n -S]\n",
  "BOOKLIGHTS": "BOOKLIGHT, a light that clips on to a book [n]\n",
  "BOOKLIKE": "like a book [adj]\n",
  "BOOKLORE": "book learning [n -S]\n",
  "BOOKLORES": "BOOKLORE, book learning [n]\n",
  "BOOKLOUSE": "an insect that eats books [n BOOKLICE]\n",
  "BOOKMAKER": "a person who accepts bets at racecourses, etc., and pays out the winnings [n -S]\n",
  "BOOKMAKERS": "BOOKMAKER, a person who accepts bets at racecourses, etc., and pays out the winnings [n]\n",
  "BOOKMAKING": "the business of a bookmaker [n -S]\n",
  "BOOKMAKINGS": "BOOKMAKING, the business of a bookmaker [n]\n",
  "BOOKMAN": "a scholar, a student [n BOOKMEN]\n",
  "BOOKMARK": "a marker for indicating the reader's current place, also BOOKMARKER [n -S] / to place a bookmark [v -ED, -ING, -S]\n",
  "BOOKMARKED": "BOOKMARK, to place a bookmark [v]\n",
  "BOOKMARKER": "a marker for indicating the reader's current place, also BOOKMARK [n -S]\n",
  "BOOKMARKERS": "BOOKMARKER, a marker for indicating the reader's current place, also BOOKMARK [n]\n",
  "BOOKMARKING": "BOOKMARK, to place a bookmark [v]\n",
  "BOOKMARKS": "BOOKMARK, a marker for indicating the reader's current place, also BOOKMARKER [n]\n",
  "BOOKMEN": "BOOKMAN, a scholar, a student [n]\n",
  "BOOKMOBILE": "(US) a truck that serves as a travelling library [n -S]\n",
  "BOOKMOBILES": "BOOKMOBILE, (US) a truck that serves as a travelling library [n]\n",
  "BOOKOO": "(slang) many or much, also BOOCOO [n BOOKOOS]\n",
  "BOOKOOS": "BOOKOO, (slang) many or much, also BOOCOO [n]\n",
  "BOOKPLATE": "a label usually pasted inside the cover of a book, bearing the owner's name or other distinguishing information [n -S]\n",
  "BOOKPLATES": "BOOKPLATE, a label usually pasted inside the cover of a book, bearing the owner's name or other distinguishing information [n]\n",
  "BOOKRACK": "a support for an open book [n -S]\n",
  "BOOKRACKS": "BOOKRACK, a support for an open book [n]\n",
  "BOOKREST": "a rack for books [n -S]\n",
  "BOOKRESTS": "BOOKREST, a rack for books [n]\n",
  "BOOKS": "BOOK, to reserve in advance [v]\n",
  "BOOKSELLER": "one that sells books [n -S]\n",
  "BOOKSELLERS": "BOOKSELLER, one that sells books [n]\n",
  "BOOKSELLING": "the profession of selling books [n -S]\n",
  "BOOKSELLINGS": "BOOKSELLING, the profession of selling books [n]\n",
  "BOOKSHELF": "a shelf for books [n BOOKSHELVES]\n",
  "BOOKSHELVES": "BOOKSHELF, a shelf for books [n]\n",
  "BOOKSHOP": "a shop that sells books [n -S]\n",
  "BOOKSHOPS": "BOOKSHOP, a shop that sells books [n]\n",
  "BOOKSIE": "in a literary way, also BOOKSY [adj BOOKSIER, BOOKSIEST]\n",
  "BOOKSIER": "BOOKSY, in a literary way, also BOOKSIE [adj]\n",
  "BOOKSIEST": "BOOKSY, in a literary way, also BOOKSIE [adj]\n",
  "BOOKSTALL": "a stall for the sale of books [n -S]\n",
  "BOOKSTALLS": "BOOKSTALL, a stall for the sale of books [n]\n",
  "BOOKSTAND": "a stand or support for holding up a book in reading [n -S]\n",
  "BOOKSTANDS": "BOOKSTAND, a stand or support for holding up a book in reading [n]\n",
  "BOOKSTORE": "a bookshop [n -S]\n",
  "BOOKSTORES": "BOOKSTORE, a bookshop [n]\n",
  "BOOKSY": "in a literary way, also BOOKSIE [adj BOOKSIER, BOOKSIEST]\n",
  "BOOKWORK": "work done upon a book or books (as in a printing office), in distinction from newspaper or job work [n -S]\n",
  "BOOKWORKS": "BOOKWORK, work done upon a book or books (as in a printing office), in distinction from newspaper or job work [n]\n",
  "BOOKWORM": "an avid book reader [n -S]\n",
  "BOOKWORMS": "BOOKWORM, an avid book reader [n]\n",
  "BOOKY": "by way of being literary, also BOOKSIE, BOOKSY [adj BOOKIER, BOOKIEST]\n",
  "BOOL": "(Scots) to play bowls [v -ED, -ING, -S]\n",
  "BOOLED": "BOOL, (Scots) to play bowls [v]\n",
  "BOOLING": "BOOL, (Scots) to play bowls [v]\n",
  "BOOLS": "BOOL, (Scots) to play bowls [v]\n",
  "BOOM": "to make a roaring sound [v -ED, -ING, -S]\n",
  "BOOMBOX": "a powerful portable radio and cassette recorder [n -ES]\n",
  "BOOMBOXES": "BOOMBOX, a powerful portable radio and cassette recorder [n]\n",
  "BOOMBURB": "a large suburb experiencing rapid population growth [n -S]\n",
  "BOOMBURBS": "BOOMBURB, a large suburb experiencing rapid population growth [n]\n",
  "BOOMED": "BOOM, to make a roaring sound [v]\n",
  "BOOMER": "a large male kangaroo [n -S]\n",
  "BOOMERANG": "(Native Australian) a curved missile used by the Australian Aborigines, sometimes so balanced that it returns towards the thrower [n -S] / to return like a boomerang [v -ED, -ING, -S]\n",
  "BOOMERANGED": "BOOMERANG, to return like a boomerang [v]\n",
  "BOOMERANGING": "BOOMERANG, to return like a boomerang [v]\n",
  "BOOMERANGS": "BOOMERANG, to return like a boomerang [v]\n",
  "BOOMERS": "BOOMER, a large male kangaroo [n]\n",
  "BOOMIER": "BOOMY, hollow-sounding [adj]\n",
  "BOOMIEST": "BOOMY, hollow-sounding [adj]\n",
  "BOOMING": "making a hollow sound [adj BOOMINGLY] / the act of booming [n -S]\n",
  "BOOMINGLY": "BOOMING, making a hollow sound [adv]\n",
  "BOOMINGS": "BOOMING, the act of booming [n]\n",
  "BOOMKIN": "a spar projecting from the stern of a ship, also BUMKIN, BUMPKIN [n -S]\n",
  "BOOMKINS": "BOOMKIN, a spar projecting from the stern of a ship, also BUMKIN, BUMPKIN [n]\n",
  "BOOMLET": "a minor economic boom [n -S]\n",
  "BOOMLETS": "BOOMLET, a minor economic boom [n]\n",
  "BOOMS": "BOOM, to make a roaring sound [v]\n",
  "BOOMSLANG": "(South African) a highly venomous southern African tree-snake [n -S]\n",
  "BOOMSLANGS": "BOOMSLANG, (South African) a highly venomous southern African tree-snake [n]\n",
  "BOOMSTICK": "(Canadian) one of the logs that surrounds a boom and holds it together [n -S]\n",
  "BOOMSTICKS": "BOOMSTICK, (Canadian) one of the logs that surrounds a boom and holds it together [n]\n",
  "BOOMTOWN": "a town which has expanded rapidly and prospered [n -S]\n",
  "BOOMTOWNS": "BOOMTOWN, a town which has expanded rapidly and prospered [n]\n",
  "BOOMY": "hollow-sounding [adj BOOMIER, BOOMIEST]\n",
  "BOON": "as in boon companion [adj BOONER, BOONEST] / a timely benefit, a blessing [n -S]\n",
  "BOONDOCK": "(Tagalog) a remote and wild place [n -S]\n",
  "BOONDOCKS": "BOONDOCK, (Tagalog) a remote and wild place [n]\n",
  "BOONDOGGLE": "an unnecessary activity or wasteful expenditure [n -S] / to carry out unnecessary work [v BOONDOGGLED, BOONDOGGLING, BOONDOGGLES]\n",
  "BOONDOGGLED": "BOONDOGGLE, to carry out unnecessary work [v]\n",
  "BOONDOGGLER": "one who engages in boondoggling [n -S]\n",
  "BOONDOGGLERS": "BOONDOGGLER, one who engages in boondoggling [n]\n",
  "BOONDOGGLES": "BOONDOGGLE, to carry out unnecessary work [v]\n",
  "BOONDOGGLING": "BOONDOGGLE, to carry out unnecessary work [v]\n",
  "BOONER": "(Australian slang) a young working class person from Canberra [n -S]\n",
  "BOONERS": "BOONER, (Australian slang) a young working class person from Canberra [n]\n",
  "BOONEST": "BOON, as in boon companion [adj]\n",
  "BOONG": "(offensive) an aborigine, a New Guinea native [n -S]\n",
  "BOONGA": "(offensive New Zealand slang) offensive word for a Pacific Islander [n -S]\n",
  "BOONGARIES": "BOONGARY, (Native Australian) a tree kangaroo from Queensland [n]\n",
  "BOONGARY": "(Native Australian) a tree kangaroo from Queensland [n BOONGARIES]\n",
  "BOONGAS": "BOONGA, (offensive New Zealand slang) offensive word for a Pacific Islander [n]\n",
  "BOONGS": "BOONG, (offensive) an aborigine, a New Guinea native [n]\n",
  "BOONIES": "remote, undeveloped country [n]\n",
  "BOONLESS": "having no boon [adj]\n",
  "BOONS": "BOON, a timely benefit, a blessing [n]\n",
  "BOOR": "a rude person [n -S]\n",
  "BOORD": "(Spenser) board, also BOORDE, BORD, BORDE [n -S]\n",
  "BOORDE": "(Spenser) board, also BOORD, BORD, BORDE [n -S]\n",
  "BOORDES": "BOORDE, (Spenser) board, also BOORD, BORD, BORDE [n]\n",
  "BOORDS": "BOORD, (Spenser) board, also BOORDE, BORD, BORDE [n]\n",
  "BOORISH": "rude [adj BOORISHLY]\n",
  "BOORISHLY": "BOORISH, rude [adv]\n",
  "BOORISHNESS": "the state of being boorish [n -ES]\n",
  "BOORISHNESSES": "BOORISHNESS, the state of being boorish [n]\n",
  "BOORKA": "(Urdu) a coverall worn by Muslim women, also BURKA, BOURKHA, BURQA [n -S]\n",
  "BOORKAS": "BOORKA, (Urdu) a coverall worn by Muslim women, also BURKA, BOURKHA, BURQA [n]\n",
  "BOORS": "BOOR, a rude person [n]\n",
  "BOORTREE": "(Scots) the elder-tree, also BOURTREE, BOUNTREE [n -S]\n",
  "BOORTREES": "BOORTREE, (Scots) the elder-tree, also BOURTREE, BOUNTREE [n]\n",
  "BOOS": "BOO, to show disapproval by making this sound, also BOOH [v]\n",
  "BOOSE": "to drink excessively, also BOOZE [v BOOSED, BOOSING, BOOSES]\n",
  "BOOSED": "BOOSE, to drink excessively, also BOOZE [v]\n",
  "BOOSES": "BOOSE, to drink excessively, also BOOZE [v]\n",
  "BOOSHIT": "(Australian slang) excellent [adj]\n",
  "BOOSING": "BOOSE, to drink excessively, also BOOZE [v]\n",
  "BOOST": "to support, increase [v -ED, -ING, -S]\n",
  "BOOSTED": "BOOST, to support, increase [v]\n",
  "BOOSTER": "an engine that gives extra power e.g. on a rocket [n -S]\n",
  "BOOSTERISH": "exhibiting boosterism, the practice of boosting or promoting a product or idea [adj]\n",
  "BOOSTERISM": "the practice of boosting or promoting a product or idea [n -S]\n",
  "BOOSTERISMS": "BOOSTERISM, the practice of boosting or promoting a product or idea [n]\n",
  "BOOSTERS": "BOOSTER, an engine that gives extra power e.g. on a rocket [n]\n",
  "BOOSTING": "BOOST, to support, increase [v]\n",
  "BOOSTS": "BOOST, to support, increase [v]\n",
  "BOOT": "to kick with the foot [v -ED, -ING, -S]\n",
  "BOOTABLE": "of a computer, capable of being self-started [adj]\n",
  "BOOTBLACK": "a person whose job is to clean and polish shoes [n -S]\n",
  "BOOTBLACKS": "BOOTBLACK, a person whose job is to clean and polish shoes [n]\n",
  "BOOTCUT": "of trousers, cut wide at the hem to allow for high heels or boots [adj]\n",
  "BOOTED": "BOOT, to kick with the foot [v]\n",
  "BOOTEE": "a baby's sock, also BOOTIE [n -S]\n",
  "BOOTEES": "BOOTEE, a baby's sock, also BOOTIE [n]\n",
  "BOOTERIES": "BOOTERY, a shoe store [n]\n",
  "BOOTERY": "a shoe store [n BOOTERIES]\n",
  "BOOTH": "a stall for the display or sale of goods [n -S]\n",
  "BOOTHOSE": "(Shakespeare) a long stocking which covers the leg like a boot [n BOOTHOSE]\n",
  "BOOTHS": "BOOTH, a stall for the display or sale of goods [n]\n",
  "BOOTIE": "a baby's sock, also BOOTEE [n -S]\n",
  "BOOTIES": "BOOTIE, a baby's sock, also BOOTEE [n]\n",
  "BOOTIKIN": "(obsolete) a little boot, legging, or gaiter [n -S]\n",
  "BOOTIKINS": "BOOTIKIN, (obsolete) a little boot, legging, or gaiter [n]\n",
  "BOOTING": "BOOT, to kick with the foot [v]\n",
  "BOOTJACK": "a device for pulling off boots [n -S]\n",
  "BOOTJACKS": "BOOTJACK, a device for pulling off boots [n]\n",
  "BOOTLACE": "a lace for fastening boots [n -S]\n",
  "BOOTLACES": "BOOTLACE, a lace for fastening boots [n]\n",
  "BOOTLAST": "a footlike last on which boots or shoes are made [n -S]\n",
  "BOOTLASTS": "BOOTLAST, a footlike last on which boots or shoes are made [n]\n",
  "BOOTLEG": "to smuggle illicit goods [v BOOTLEGGED, BOOTLEGGING, BOOTLEGS]\n",
  "BOOTLEGGED": "BOOTLEG, to smuggle illicit goods [v]\n",
  "BOOTLEGGER": "one who supplies e.g. illicit whisky [n -S]\n",
  "BOOTLEGGERS": "BOOTLEGGER, one who supplies e.g. illicit whisky [n]\n",
  "BOOTLEGGING": "the act of distilling illicit whisky [n -S]\n",
  "BOOTLEGGINGS": "BOOTLEGGING, the act of distilling illicit whisky [n]\n",
  "BOOTLEGS": "BOOTLEG, to smuggle illicit goods [v]\n",
  "BOOTLESS": "profitless [adj BOOTLESSLY]\n",
  "BOOTLESSLY": "BOOTLESS, profitless [adv]\n",
  "BOOTLESSNESS": "the state of being bootless [n -ES]\n",
  "BOOTLESSNESSES": "BOOTLESSNESS, the state of being bootless [n]\n",
  "BOOTLICK": "to toady [v -ED, -ING, -S]\n",
  "BOOTLICKED": "BOOTLICK, to toady [v]\n",
  "BOOTLICKER": "a toady [n -S]\n",
  "BOOTLICKERS": "BOOTLICKER, a toady [n]\n",
  "BOOTLICKING": "the act of toadying [n -S]\n",
  "BOOTLICKINGS": "BOOTLICKING, the act of toadying [n]\n",
  "BOOTLICKS": "BOOTLICK, to toady [v]\n",
  "BOOTLOADER": "a system program that takes a program close in form to machine code and loads it into memory [n -S]\n",
  "BOOTLOADERS": "BOOTLOADER, a system program that takes a program close in form to machine code and loads it into memory [n]\n",
  "BOOTMAKER": "one who makes boots [n -S]\n",
  "BOOTMAKERS": "BOOTMAKER, one who makes boots [n]\n",
  "BOOTMAKING": "the craft of making boots [n -S]\n",
  "BOOTMAKINGS": "BOOTMAKING, the craft of making boots [n]\n",
  "BOOTS": "BOOT, to kick with the foot [v]\n",
  "BOOTSTRAP": "to prepare (a computer) for operation by causing an operating system to be loaded into its memory [v BOOTSTRAPPED, BOOTSTRAPPING, BOOTSTRAPS]\n",
  "BOOTSTRAPPED": "BOOTSTRAP, to prepare (a computer) for operation by causing an operating system to be loaded into its memory [v]\n",
  "BOOTSTRAPPING": "BOOTSTRAP, to prepare (a computer) for operation by causing an operating system to be loaded into its memory [v]\n",
  "BOOTSTRAPS": "BOOTSTRAP, to prepare (a computer) for operation by causing an operating system to be loaded into its memory [v]\n",
  "BOOTY": "a rich prize [n BOOTIES]\n",
  "BOOTYLICIOUS": "(colloquial) delicious [adj]\n",
  "BOOZE": "to drink excessively, also BOOSE [v BOOZED, BOOZING, BOOZES]\n",
  "BOOZED": "BOOZE, to drink excessively, also BOOSE [v]\n",
  "BOOZEHOUND": "(colloquial) an alcoholic [n -S]\n",
  "BOOZEHOUNDS": "BOOZEHOUND, (colloquial) an alcoholic [n]\n",
  "BOOZER": "(slang) a drunkard [n -S]\n",
  "BOOZERS": "BOOZER, (slang) a drunkard [n]\n",
  "BOOZES": "BOOZE, to drink excessively, also BOOSE [v]\n",
  "BOOZEY": "inclined to booze, also BOOZY, BOUSY [adj]\n",
  "BOOZIER": "BOOZY, inclined to booze, also BOOZEY, BOUSY [adj]\n",
  "BOOZIEST": "BOOZY, inclined to booze, also BOOZEY, BOUSY [adj]\n",
  "BOOZILY": "BOOZY, inclined to booze, also BOOZEY, BOUSY [adv]\n",
  "BOOZINESS": "the state of being boozy [n -ES]\n",
  "BOOZINESSES": "BOOZINESS, the state of being boozy [n]\n",
  "BOOZING": "an act of boozing [n -S]\n",
  "BOOZINGS": "BOOZING, an act of boozing [n]\n",
  "BOOZY": "inclined to booze, also BOOZEY, BOUSY [adj BOOZIER, BOOZIEST]\n",
  "BOP": "to dance to pop music [v BOPPED, BOPPING, BOPS]\n",
  "BOPEEP": "a child's peeping game, aka peekaboo [n -S]\n",
  "BOPEEPS": "BOPEEP, a child's peeping game, aka peekaboo [n]\n",
  "BOPPED": "BOP, to dance to pop music [v]\n",
  "BOPPER": "one who dances to pop music [n -S]\n",
  "BOPPERS": "BOPPER, one who dances to pop music [n]\n",
  "BOPPIER": "BOPPY, suggestive of bebop [adj]\n",
  "BOPPIEST": "BOPPY, suggestive of bebop [adj]\n",
  "BOPPING": "BOP, to dance to pop music [v]\n",
  "BOPPISH": "suggestive of bebop [adj]\n",
  "BOPPY": "suggestive of bebop [adj BOPPIER, BOPPIEST]\n",
  "BOPS": "BOP, to dance to pop music [v]\n",
  "BOR": "an East Anglian form of address meaning neighbour [n -S]\n",
  "BORA": "(Italian) a violent cold north wind that blows from the mountains towards the East coast of the Adriatic [n -S]\n",
  "BORACES": "BORAX, a mineral, a hydrated sodium borate, found on alkaline lake shores, aka tincal [n]\n",
  "BORACHIO": "(Spanish) a Spanish wineskin; a drunken fellow [n -S]\n",
  "BORACHIOS": "BORACHIO, (Spanish) a Spanish wineskin; a drunken fellow [n]\n",
  "BORACIC": "of or relating to borax; (colloquial) skint [adj]\n",
  "BORACITE": "a compound of magnesium usually occurring as greyish-white cubic crystals [n -S]\n",
  "BORACITES": "BORACITE, a compound of magnesium usually occurring as greyish-white cubic crystals [n]\n",
  "BORAGE": "a rough-stemmed aromatic herb used in salads [n -S]\n",
  "BORAGES": "BORAGE, a rough-stemmed aromatic herb used in salads [n]\n",
  "BORAGINACEOUS": "belonging to the borage family [adj]\n",
  "BORAK": "(Native Australian) nonsense, banter [n -S]\n",
  "BORAKS": "BORAK, (Native Australian) nonsense, banter [n]\n",
  "BORAL": "a mixture of boron carbide and aluminum [n -S]\n",
  "BORALS": "BORAL, a mixture of boron carbide and aluminum [n]\n",
  "BORANE": "any boron hydride, efficient as a high-energy fuel [n -S]\n",
  "BORANES": "BORANE, any boron hydride, efficient as a high-energy fuel [n]\n",
  "BORAS": "BORA, (Italian) a violent cold north wind that blows from the mountains towards the East coast of the Adriatic [n]\n",
  "BORATE": "to mix with borax or boric acid [v BORATED, BORATING, BORATES]\n",
  "BORATED": "BORATE, to mix with borax or boric acid [v]\n",
  "BORATES": "BORATE, to mix with borax or boric acid [v]\n",
  "BORATING": "BORATE, to mix with borax or boric acid [v]\n",
  "BORAX": "a mineral, a hydrated sodium borate, found on alkaline lake shores, aka tincal [n BORAXES or BORACES]\n",
  "BORAXES": "BORAX, a mineral, a hydrated sodium borate, found on alkaline lake shores, aka tincal [n]\n",
  "BORAZON": "a manmade compound of nitrogen and boron, as hard as diamond [n -S]\n",
  "BORAZONS": "BORAZON, a manmade compound of nitrogen and boron, as hard as diamond [n]\n",
  "BORBORYGMAL": "relating to borborygmus, the rumbling sound of gas passing through the intestine, also BORBORYGMIC [adj]\n",
  "BORBORYGMI": "BORBORYGMUS, (Greek) a rumbling noise produced by the movement of gas through the intestines [n]\n",
  "BORBORYGMIC": "relating to borborygmus, intestinal rumbling caused by moving gas, also BORBORYGMAL [adj]\n",
  "BORBORYGMUS": "(Greek) a rumbling noise produced by the movement of gas through the intestines [n BORBORYGMI]\n",
  "BORD": "(obsolete) a board, also BOORD, BOORDE, BORDE [n -S]\n",
  "BORDAR": "(historical) a tenant who holds land at his lord's pleasure [n -S]\n",
  "BORDARS": "BORDAR, (historical) a tenant who holds land at his lord's pleasure [n]\n",
  "BORDE": "(obsolete) board, also BOORD, BOORDE, BORD [n -S]\n",
  "BORDEAUX": "(French) a red or white wine [n BORDEAUX]\n",
  "BORDEL": "(archaic) a brothel, also BORDELLO [n -S]\n",
  "BORDELLO": "(Italian) a brothel, also BORDEL [n -S]\n",
  "BORDELLOS": "BORDELLO, (Italian) a brothel, also BORDEL [n]\n",
  "BORDELS": "BORDEL, (archaic) a brothel, also BORDELLO [n]\n",
  "BORDER": "to be adjacent to [v -ED, -ING, -S]\n",
  "BORDEREAU": "(French) a detailed bill or invoice [n BORDEREAUX]\n",
  "BORDEREAUX": "BORDEREAU, (French) a detailed bill or invoice [n]\n",
  "BORDERED": "BORDER, to be adjacent to [v]\n",
  "BORDERER": "a person who lives or was born on the border of a country [n -S]\n",
  "BORDERERS": "BORDERER, a person who lives or was born on the border of a country [n]\n",
  "BORDERING": "BORDER, to be adjacent to [v]\n",
  "BORDERLAND": "territory at or near a border [n -S]\n",
  "BORDERLANDS": "BORDERLAND, territory at or near a border [n]\n",
  "BORDERLESS": "without a border [adj]\n",
  "BORDERLINE": "an intermediate position or state [n -S]\n",
  "BORDERLINES": "BORDERLINE, an intermediate position or state [n]\n",
  "BORDERS": "BORDER, to be adjacent to [v]\n",
  "BORDES": "BORDE, (obsolete) board, also BOORD, BOORDE, BORD [n]\n",
  "BORDRAGING": "(Spenser) a hostile attack, a raid, also BODRAG [n -S]\n",
  "BORDRAGINGS": "BORDRAGING, (Spenser) a hostile attack, a raid, also BODRAG [n]\n",
  "BORDS": "BORD, (obsolete) a board, also BOORD, BOORDE, BORDE [n]\n",
  "BORDURE": "a border surrounding a heraldic shield [n -S]\n",
  "BORDURES": "BORDURE, a border surrounding a heraldic shield [n]\n",
  "BORE": "to pierce with a tool [v BORED, BORING, BORES]\n",
  "BOREAL": "pertaining to the north [adj]\n",
  "BOREALIS": "(Latin) as in aurora borealis, lights seen round the North Pole [adj]\n",
  "BOREAS": "(Latin) the north wind [n -ES]\n",
  "BOREASES": "BOREAS, (Latin) the north wind [n]\n",
  "BORECOLE": "(Dutch) a variety of cabbage [n -S]\n",
  "BORECOLES": "BORECOLE, (Dutch) a variety of cabbage [n]\n",
  "BORED": "BORE, to pierce with a tool [v]\n",
  "BOREDOM": "tedium [n -S]\n",
  "BOREDOMS": "BOREDOM, tedium [n]\n",
  "BOREE": "(Native Australian) any of several species of Australian acacia [n -S]\n",
  "BOREEN": "(Irish) a lane [n -S]\n",
  "BOREENS": "BOREEN, (Irish) a lane [n]\n",
  "BOREES": "BOREE, (Native Australian) any of several species of Australian acacia [n]\n",
  "BOREHOLE": "a hole made in the earth's crust [n -S]\n",
  "BOREHOLES": "BOREHOLE, a hole made in the earth's crust [n]\n",
  "BOREL": "a boring tool [n -S]\n",
  "BORELS": "BOREL, a boring tool [n]\n",
  "BORER": "one that bores [n -S]\n",
  "BORERS": "BORER, one that bores [n]\n",
  "BORES": "BORE, to pierce with a tool [v]\n",
  "BORESCOPE": "an optical device, e.g. a prism, used to inspect an inaccessible space e.g. an engine cylinder [n -S]\n",
  "BORESCOPES": "BORESCOPE, an optical device, e.g. a prism, used to inspect an inaccessible space e.g. an engine cylinder [n]\n",
  "BORESOME": "tedious, boring [adj]\n",
  "BORGHETTO": "(Italian) a big village [n -S]\n",
  "BORGHETTOS": "BORGHETTO, (Italian) a big village [n]\n",
  "BORGO": "(Italian) a market town [n -S]\n",
  "BORGOS": "BORGO, (Italian) a market town [n]\n",
  "BORIC": "of, pertaining to, or containing, boron [adj]\n",
  "BORIDE": "a boron compound [n -S]\n",
  "BORIDES": "BORIDE, a boron compound [n]\n",
  "BORING": "an inner cavity [n -S]\n",
  "BORINGLY": "BORING [adv]\n",
  "BORINGNESS": "the quality of being boring [n -ES]\n",
  "BORINGNESSES": "BORINGNESS, the quality of being boring [n]\n",
  "BORINGS": "BORING, an inner cavity [n]\n",
  "BORK": "to denigrate a job applicant for partisan reasons [v -ED, -ING, -S]\n",
  "BORKED": "BORK, to denigrate a job applicant for partisan reasons [v]\n",
  "BORKING": "the act of attacking a candidate or public figure systematically, esp. in the media [n -S]\n",
  "BORKINGS": "BORKING, the act of attacking a candidate or public figure systematically, esp. in the media [n]\n",
  "BORKS": "BORK, to denigrate a job applicant for partisan reasons [v]\n",
  "BORLOTTI": "(Italian) as in borlotti bean, a variety of kidney bean [adj]\n",
  "BORM": "(dialect) to smear with paint or oil [v -ED, -ING, -S]\n",
  "BORMED": "BORM, (dialect) to smear with paint or oil [v]\n",
  "BORMING": "BORM, (dialect) to smear with paint or oil [v]\n",
  "BORMS": "BORM, (dialect) to smear with paint or oil [v]\n",
  "BORN": "BEAR, to endure [v]\n",
  "BORNA": "as in borna disease, a type of viral disease [adj]\n",
  "BORNE": "BEAR, to endure [v]\n",
  "BORNEOL": "an alcohol used in perfumes, also BORNYL [n -S]\n",
  "BORNEOLS": "BORNEOL, an alcohol used in perfumes, also BORNYL [n]\n",
  "BORNITE": "a valuable ore of copper, aka peacock ore [n -S]\n",
  "BORNITES": "BORNITE, a valuable ore of copper, aka peacock ore [n]\n",
  "BORNITIC": "of or like bornite, a valuable ore of copper [adj]\n",
  "BORNYL": "an alcohol used in perfumes, also BORNEOL [n -S]\n",
  "BORNYLS": "BORNYL, an alcohol used in perfumes, also BORNEOL [n]\n",
  "BOROHYDRIDE": "a compound of boron and hydrogen, used as a reducing agent [n -S]\n",
  "BOROHYDRIDES": "BOROHYDRIDE, a compound of boron and hydrogen, used as a reducing agent [n]\n",
  "BORON": "a relatively inert nonmetallic chemical element [n -S]\n",
  "BORONIA": "an Australian scented shrub [n -S]\n",
  "BORONIAS": "BORONIA, an Australian scented shrub [n]\n",
  "BORONIC": "of or like boron [adj]\n",
  "BORONS": "BORON, a relatively inert nonmetallic chemical element [n]\n",
  "BOROSILICATE": "a salt of boric and silicic acids, used in making heat- and chemical-resistant glass [n -S]\n",
  "BOROSILICATES": "BOROSILICATE, a salt of boric and silicic acids, used in making heat- and chemical-resistant glass [n]\n",
  "BOROUGH": "an incorporated town, also BRUGH [n -S]\n",
  "BOROUGHS": "BOROUGH, an incorporated town, also BRUGH [n]\n",
  "BORREL": "rustic, also BOREL, BORRELL [adj]\n",
  "BORRELIA": "a type of bacterium [n -S]\n",
  "BORRELIAS": "BORRELIA, a type of bacterium [n]\n",
  "BORRELL": "rustic, also BORREL, BOREL [adj]\n",
  "BORROW": "to obtain on loan or trust [v -ED, -ING, -S]\n",
  "BORROWED": "BORROW, to obtain on loan or trust [v]\n",
  "BORROWER": "one who borrows [n -S]\n",
  "BORROWERS": "BORROWER, one who borrows [n]\n",
  "BORROWING": "a loan [n -S]\n",
  "BORROWINGS": "BORROWING, a loan [n]\n",
  "BORROWS": "BORROW, to obtain on loan or trust [v]\n",
  "BORS": "BOR, an East Anglian form of address meaning neighbour [n]\n",
  "BORSCH": "(Russian) cold beetroot soup, also BORSCHT, BORSHCH, BORSHT, BORTSCH [n -ES]\n",
  "BORSCHES": "BORSCH, (Russian) cold beetroot soup, also BORSCHT, BORSHCH, BORSHT, BORTSCH [n]\n",
  "BORSCHT": "(Russian) cold beetroot soup, also BORSCH, BORSHCH, BORSHT, BORTSCH [n -S]\n",
  "BORSCHTS": "BORSCHT, (Russian) cold beetroot soup, also BORSCH, BORSHCH, BORSHT, BORTSCH [n]\n",
  "BORSHCH": "(Russian) cold beetroot soup, also BORSCH, BORSCHT, BORSHT, BORTSCH [n -ES]\n",
  "BORSHCHES": "BORSHCH, (Russian) cold beetroot soup, also BORSCH, BORSCHT, BORSHT, BORTSCH [n]\n",
  "BORSHT": "(Russian) cold beetroot soup, also BORSCH, BORSCHT, BORSHCH, BORTSCH [n -S]\n",
  "BORSHTS": "BORSHT, (Russian) cold beetroot soup, also BORSCH, BORSCHT, BORSHCH, BORTSCH [n]\n",
  "BORSIC": "a strong light compound of boron and silicon carbide used in the aviation industry [n -S]\n",
  "BORSICS": "BORSIC, a strong light compound of boron and silicon carbide used in the aviation industry [n]\n",
  "BORSTAL": "an establishment for the detention of young adult delinquents, also BORSTALL [n -S]\n",
  "BORSTALL": "an establishment for the detention of young adult delinquents, also BORSTAL [n -S]\n",
  "BORSTALLS": "BORSTALL, an establishment for the detention of young adult delinquents, also BORSTAL [n]\n",
  "BORSTALS": "BORSTAL, an establishment for the detention of young adult delinquents, also BORSTALL [n]\n",
  "BORT": "diamond dust or fragments, also BOART, BORTZ [n -S]\n",
  "BORTIER": "BORTY, relating to bort, diamond dust [adj]\n",
  "BORTIEST": "BORTY, relating to bort, diamond dust [adj]\n",
  "BORTS": "BORT, diamond dust or fragments, also BOART, BORTZ [n]\n",
  "BORTSCH": "(Russian) cold beetroot soup, also BORSCH, BORSCHT, BORSHCH, BORSHT [n -ES]\n",
  "BORTSCHES": "BORTSCH, (Russian) cold beetroot soup, also BORSCH, BORSCHT, BORSHCH, BORSHT [n]\n",
  "BORTY": "relating to bort, diamond dust [adj BORTIER, BORTIEST]\n",
  "BORTZ": "(Dutch) diamond dust or fragments, also BOART, BORT [n -ES]\n",
  "BORTZES": "BORTZ, (Dutch) diamond dust or fragments, also BOART, BORT [n]\n",
  "BORZOI": "(Russian) a kind of wolfhound [n -S]\n",
  "BORZOIS": "BORZOI, (Russian) a kind of wolfhound [n]\n",
  "BOS": "BO, a pal, a buddy [n]\n",
  "BOSBERAAD": "(South African) a meeting in an isolated venue to break a political deadlock [n -S]\n",
  "BOSBERAADS": "BOSBERAAD, (South African) a meeting in an isolated venue to break a political deadlock [n]\n",
  "BOSBOK": "(South African) a kind of antelope, the bushbuck, also BOSCHBOK, BOSHBOK, BUSHBUCK [n -S]\n",
  "BOSBOKS": "BOSBOK, (South African) a kind of antelope, the bushbuck, also BOSCHBOK, BOSHBOK, BUSHBUCK [n]\n",
  "BOSCAGE": "(French) thick foliage; woodland, also BOSKAGE [n -S]\n",
  "BOSCAGES": "BOSCAGE, (French) thick foliage; woodland, also BOSKAGE [n]\n",
  "BOSCHBOK": "(South African) a kind of antelope, the bushbuck, also BOSBOK, BOSHBOK, BUSHBUCK [n -S]\n",
  "BOSCHBOKS": "BOSCHBOK, (South African) a kind of antelope, the bushbuck, also BOSBOK, BOSHBOK, BUSHBUCK [n]\n",
  "BOSCHE": "offensive term for a German, also BOCHE [n -S]\n",
  "BOSCHES": "BOSCHE, offensive term for a German, also BOCHE [n]\n",
  "BOSCHVARK": "(South African) another name for the bushpig, an African wild pig, also BOSHVARK [n -S]\n",
  "BOSCHVARKS": "BOSCHVARK, (South African) another name for the bushpig, an African wild pig, also BOSHVARK [n]\n",
  "BOSCHVELD": "(South African) veld made up largely of woodland, also BUSHVELD [n -S]\n",
  "BOSCHVELDS": "BOSCHVELD, (South African) veld made up largely of woodland, also BUSHVELD [n]\n",
  "BOSH": "(colloquial) meaningless talk [n -ES]\n",
  "BOSHBOK": "(South African) a kind of antelope, the bushbuck, also BOSBOK, BOSCHBOK, BUSHBUCK [n -S]\n",
  "BOSHBOKS": "BOSHBOK, (South African) a kind of antelope, the bushbuck, also BOSBOK, BOSCHBOK, BUSHBUCK [n]\n",
  "BOSHES": "BOSH, (colloquial) meaningless talk [n]\n",
  "BOSHTA": "(Australian slang) very good, also BOSHTER, BOSKER [adj]\n",
  "BOSHTER": "(Australian slang) very good, also BOSHTA, BOSKER [adj]\n",
  "BOSHVARK": "(South African) the bush hog, also BOSCHVARK [n -S]\n",
  "BOSHVARKS": "BOSHVARK, (South African) the bush hog, also BOSCHVARK [n]\n",
  "BOSIE": "a kind of delivery in cricket, a googly [n -S]\n",
  "BOSIES": "BOSIE, a kind of delivery in cricket, a googly [n]\n",
  "BOSK": "a bush, a thicket, also BOSKET, BOSQUE, BOSQUET, BUSKET [n -S]\n",
  "BOSKAGE": "thick foliage; woodland, also BOSCAGE [n -S]\n",
  "BOSKAGES": "BOSKAGE, thick foliage; woodland, also BOSCAGE [n]\n",
  "BOSKER": "(Australian slang) very good, also BOSHTA, BOSHTER [adj]\n",
  "BOSKET": "a thicket, a plantation, also BOSK, BOSQUE, BOSQUET, BUSKET [n -S]\n",
  "BOSKETS": "BOSKET, a thicket, a plantation, also BOSK, BOSQUE, BOSQUET, BUSKET [n]\n",
  "BOSKIER": "BOSKY, woody or bushy [adj]\n",
  "BOSKIEST": "BOSKY, woody or bushy [adj]\n",
  "BOSKINESS": "the state of being bosky, wooded [n -ES]\n",
  "BOSKINESSES": "BOSKINESS, the state of being bosky, wooded [n]\n",
  "BOSKS": "BOSK, a bush, a thicket, also BOSKET, BOSQUE, BOSQUET, BUSKET [n]\n",
  "BOSKY": "woody or bushy [adj BOSKIER, BOSKIEST]\n",
  "BOSOM": "to enclose in the bosom [v -ED, -ING, -S]\n",
  "BOSOMED": "BOSOM, to enclose in the bosom [v]\n",
  "BOSOMIER": "BOSOMY, having large breasts [adj]\n",
  "BOSOMIEST": "BOSOMY, having large breasts [adj]\n",
  "BOSOMING": "BOSOM, to enclose in the bosom [v]\n",
  "BOSOMS": "BOSOM, to enclose in the bosom [v]\n",
  "BOSOMY": "having large breasts [adj BOSOMIER, BOSOMIEST]\n",
  "BOSON": "any of a certain class of subatomic particles [n -S]\n",
  "BOSONIC": "relating to a boson, a kind of subatomic particle [adj]\n",
  "BOSONS": "BOSON, any of a certain class of subatomic particles [n]\n",
  "BOSQUE": "a thicket, a plantation, also BOSK, BOSKET, BOSQUET, BUSKET [n -S]\n",
  "BOSQUES": "BOSQUE, a thicket, a plantation, also BOSK, BOSKET, BOSQUET, BUSKET [n]\n",
  "BOSQUET": "a thicket, a plantation, also BOSK, BOSKET, BOSQUE, BUSKET [n -S]\n",
  "BOSQUETS": "BOSQUET, a thicket, a plantation, also BOSK, BOSKET, BOSQUE, BUSKET [n]\n",
  "BOSS": "to domineer over [v -ED, -ING, -ES] / excellent [adj BOSSER, BOSSEST]\n",
  "BOSSBOY": "a Black African foreman of a gang of workers [n -S]\n",
  "BOSSBOYS": "BOSSBOY, a Black African foreman of a gang of workers [n]\n",
  "BOSSDOM": "the domain of a political boss [n -S]\n",
  "BOSSDOMS": "BOSSDOM, the domain of a political boss [n]\n",
  "BOSSED": "BOSS, to domineer over [v]\n",
  "BOSSER": "BOSS, excellent [adj]\n",
  "BOSSES": "BOSS, to domineer over [v]\n",
  "BOSSEST": "BOSS, excellent [adj]\n",
  "BOSSET": "a rudimentary antler found on a young deer [n -S]\n",
  "BOSSETS": "BOSSET, a rudimentary antler found on a young deer [n]\n",
  "BOSSIER": "BOSSY, domineering [adj]\n",
  "BOSSIES": "BOSSY, a cow [n]\n",
  "BOSSIEST": "BOSSY, domineering [adj]\n",
  "BOSSILY": "BOSSY, domineering [adv]\n",
  "BOSSINESS": "the state of being bossy [n -ES]\n",
  "BOSSINESSES": "BOSSINESS, the state of being bossy [n]\n",
  "BOSSING": "the act of bossing, ordering about [n -S]\n",
  "BOSSINGS": "BOSSING, the act of bossing, ordering about [n]\n",
  "BOSSISM": "the rule or practices of bosses, esp. political bosses [n -S]\n",
  "BOSSISMS": "BOSSISM, the rule or practices of bosses, esp. political bosses [n]\n",
  "BOSSNAPPING": "kidnapping a company executive as part of industrial action [n -S]\n",
  "BOSSNAPPINGS": "BOSSNAPPING, kidnapping a company executive as part of industrial action [n]\n",
  "BOSSY": "a cow [n BOSSIES] / domineering [adj BOSSIER, BOSSIEST, BOSSILY]\n",
  "BOSSYBOOTS": "(colloquial) a bossy person [n]\n",
  "BOSTANGI": "a Turkish palace guard [n -S]\n",
  "BOSTANGIS": "BOSTANGI, a Turkish palace guard [n]\n",
  "BOSTHOON": "(Irish) a boor [n -S]\n",
  "BOSTHOONS": "BOSTHOON, (Irish) a boor [n]\n",
  "BOSTON": "a card game [n -S]\n",
  "BOSTONS": "BOSTON, a card game [n]\n",
  "BOSTRYX": "(Greek) a type of inflorescence, a way in which flower stems are arranged [n -ES]\n",
  "BOSTRYXES": "BOSTRYX, (Greek) a type of inflorescence, a way in which flower stems are arranged [n]\n",
  "BOSUN": "a ship's officer in charge of equipment and maintenance, also BOATSWAIN [n -S]\n",
  "BOSUNS": "BOSUN, a ship's officer in charge of equipment and maintenance, also BOATSWAIN [n]\n",
  "BOT": "to cadge [v BOTTED, BOTTING, BOTS]\n",
  "BOTA": "(Spanish) a leather bottle for wine [n -S]\n",
  "BOTANIC": "relating to botany [adj BOTANICALLY] / a drug made from plants [n -S]\n",
  "BOTANICA": "(Greek) a shop that sells herbs and magic charms [n -S]\n",
  "BOTANICAL": "related to botany [adj BOTANICALLY] / a drug made from vegetable matter [n -S]\n",
  "BOTANICALLY": "BOTANICAL, related to botany [adv]\n",
  "BOTANICALS": "BOTANICAL, a drug made from vegetable matter [n]\n",
  "BOTANICAS": "BOTANICA, (Greek) a shop that sells herbs and magic charms [n]\n",
  "BOTANICS": "BOTANIC, a drug made from plants [n]\n",
  "BOTANIES": "BOTANY, the science of plants [n]\n",
  "BOTANISE": "to collect plants for study, also BOTANIZE [v BOTANISED, BOTANISING, BOTANISES]\n",
  "BOTANISED": "BOTANISE, to collect plants for study, also BOTANIZE [v]\n",
  "BOTANISER": "one who botanises, also BOTANIZER [n -S]\n",
  "BOTANISERS": "BOTANISER, one who botanises, also BOTANIZER [n]\n",
  "BOTANISES": "BOTANISE, to collect plants for study, also BOTANIZE [v]\n",
  "BOTANISING": "BOTANISE, to collect plants for study, also BOTANIZE [v]\n",
  "BOTANIST": "one skilled in botany [n -S]\n",
  "BOTANISTS": "BOTANIST, one skilled in botany [n]\n",
  "BOTANIZE": "to collect plants for study, also BOTANISE [v BOTANIZED, BOTANIZING, BOTANIZES]\n",
  "BOTANIZED": "BOTANIZE, to collect plants for study, also BOTANISE [v]\n",
  "BOTANIZER": "one who botanizes, also BOTANISER [n -S]\n",
  "BOTANIZERS": "BOTANIZER, one who botanizes, also BOTANISER [n]\n",
  "BOTANIZES": "BOTANIZE, to collect plants for study, also BOTANISE [v]\n",
  "BOTANIZING": "BOTANIZE, to collect plants for study, also BOTANISE [v]\n",
  "BOTANOMANCIES": "BOTANOMANCY, divination using burning branches or plants [n]\n",
  "BOTANOMANCY": "divination using burning branches or plants [n BOTANOMANCIES]\n",
  "BOTANY": "the science of plants [n BOTANIES]\n",
  "BOTARGO": "(Italian) a type of relish made from mullet roe [n BOTARGOS or BOTARGOES]\n",
  "BOTARGOES": "BOTARGO, (Italian) a type of relish made from mullet roe [n]\n",
  "BOTARGOS": "BOTARGO, (Italian) a type of relish made from mullet roe [n]\n",
  "BOTAS": "BOTA, (Spanish) a leather bottle for wine [n]\n",
  "BOTCH": "to bungle [v -ED, -ING, -ES]\n",
  "BOTCHED": "BOTCH, to bungle [v]\n",
  "BOTCHEDLY": "BOTCHED, BOTCH, to bungle [adv]\n",
  "BOTCHER": "one who makes a botch of things [n -S]\n",
  "BOTCHERIES": "BOTCHERY, something botched [n]\n",
  "BOTCHERS": "BOTCHER, one who makes a botch of things [n]\n",
  "BOTCHERY": "something botched [n BOTCHERIES]\n",
  "BOTCHES": "BOTCH, to bungle [v]\n",
  "BOTCHIER": "BOTCHY, done badly [adj]\n",
  "BOTCHIEST": "BOTCHY, done badly [adj]\n",
  "BOTCHILY": "BOTCHY, done badly [adv]\n",
  "BOTCHINESS": "the state of being botchy, full of botches [n -ES]\n",
  "BOTCHINESSES": "BOTCHINESS, the state of being botchy, full of botches [n]\n",
  "BOTCHING": "the act of botching [n -S]\n",
  "BOTCHINGS": "BOTCHING, the act of botching [n]\n",
  "BOTCHY": "done badly [adj BOTCHIER, BOTCHIEST, BOTCHILY]\n",
  "BOTE": "compensation for injury or damage to property [n -S]\n",
  "BOTEL": "a waterside hotel, catering esp. for boat-owners, also BOATEL [n -S]\n",
  "BOTELS": "BOTEL, a waterside hotel, catering esp. for boat-owners, also BOATEL [n]\n",
  "BOTES": "BOTE, compensation for injury or damage to property [n]\n",
  "BOTFLIES": "BOTFLY, a name for various flies that lay their eggs on horses, etc. [n]\n",
  "BOTFLY": "a name for various flies that lay their eggs on horses, etc. [n BOTFLIES]\n",
  "BOTH": "the two; the one and the other, also BAITH [adj]\n",
  "BOTHAN": "(Gaelic) a booth, a hut [n -S]\n",
  "BOTHANS": "BOTHAN, (Gaelic) a booth, a hut [n]\n",
  "BOTHER": "to annoy [v -ED, -ING, -S]\n",
  "BOTHERATION": "trouble, bother [n -S]\n",
  "BOTHERATIONS": "BOTHERATION, trouble, bother [n]\n",
  "BOTHERED": "BOTHER, to annoy [v]\n",
  "BOTHERING": "BOTHER, to annoy [v]\n",
  "BOTHERS": "BOTHER, to annoy [v]\n",
  "BOTHERSOME": "causing bother [adj]\n",
  "BOTHIE": "(Scots) a hut, cabin, also BOTHY [n -S]\n",
  "BOTHIES": "BOTHY, (Scots) a hut, cabin, also BOTHIE [n]\n",
  "BOTHOLE": "a hole in a hide caused by maggots [n -S]\n",
  "BOTHOLES": "BOTHOLE, a hole in a hide caused by maggots [n]\n",
  "BOTHRIA": "BOTHRIUM, (Latin) a groove on a tapeworm [n]\n",
  "BOTHRIUM": "(Latin) a groove on a tapeworm [n BOTHRIUMS or BOTHRIA]\n",
  "BOTHRIUMS": "BOTHRIUM, (Latin) a groove on a tapeworm [n]\n",
  "BOTHY": "(Scots) a hut, cabin, also BOTHIE [n BOTHIES]\n",
  "BOTHYMAN": "one who lives in a bothy [n BOTHYMEN]\n",
  "BOTHYMEN": "BOTHYMAN, one who lives in a bothy [n]\n",
  "BOTNET": "a network of infected computers [n -S]\n",
  "BOTNETS": "BOTNET, a network of infected computers [n]\n",
  "BOTONE": "having buds or knobs at the extremity, applied to a cross, also BOTONEE, BOTONNEE, BOTTONY [adj]\n",
  "BOTONEE": "having buds or knobs at the extremities, applied to a cross, also BOTONE, BOTONNEE, BOTTONY [adj]\n",
  "BOTONNEE": "having buds or knobs at the extremities, applied to a cross, also BOTONE, BOTONEE, BOTTONY [adj]\n",
  "BOTOXED": "(tradename) having had Botox treatment [adj]\n",
  "BOTRYOID": "of minerals, occurring in grape-shaped masses, also BOTRYOIDAL, BOTRYOSE [adj]\n",
  "BOTRYOIDAL": "of minerals, occurring in grape-shaped masses, also BOTRYOID, BOTRYOSE [adj]\n",
  "BOTRYOSE": "having the form of a cluster of grapes, also BOTRYOID, BOTRYOIDAL [adj]\n",
  "BOTRYTIS": "a genus of fungi which cause plant diseases [n -ES]\n",
  "BOTRYTISES": "BOTRYTIS, a genus of fungi which cause plant diseases [n]\n",
  "BOTS": "BOT, to cadge [v]\n",
  "BOTT": "the maggot of a botfly, also BOT [n -S]\n",
  "BOTTARGA": "(Italian) a relish made of mullet or tunny roe, also BOTARGO [n -S]\n",
  "BOTTARGAS": "BOTTARGA, (Italian) a relish made of mullet or tunny roe, also BOTARGO [n]\n",
  "BOTTE": "a thrust in fencing [n -S]\n",
  "BOTTED": "BOT, to cadge [v]\n",
  "BOTTEGA": "(Italian) a wineshop [n -S]\n",
  "BOTTEGAS": "BOTTEGA, (Italian) a wineshop [n]\n",
  "BOTTES": "BOTTE, a thrust in fencing [n]\n",
  "BOTTIES": "BOTTY, (colloquial) a bottom [n]\n",
  "BOTTINE": "(French) a small boot; a surgical boot for correcting deformity [n -S]\n",
  "BOTTINES": "BOTTINE, (French) a small boot; a surgical boot for correcting deformity [n]\n",
  "BOTTING": "BOT, to cadge [v]\n",
  "BOTTLE": "to enclose in a narrow-necked vessel [v BOTTLED, BOTTLING, BOTTLES]\n",
  "BOTTLEBRUSH": "an Australian flower [n -ES]\n",
  "BOTTLEBRUSHES": "BOTTLEBRUSH, an Australian flower [n]\n",
  "BOTTLED": "BOTTLE, to enclose in a narrow-necked vessel [v]\n",
  "BOTTLEFUL": "the contents of a bottle [n -S]\n",
  "BOTTLEFULS": "BOTTLEFUL, the contents of a bottle [n]\n",
  "BOTTLENECK": "a narrow place in a road where traffic is apt to be congested [n -S] / to slow down or impede by creating an obstruction [v -ED, -ING, -S]\n",
  "BOTTLENECKED": "BOTTLENECK, to slow down or impede by creating an obstruction [v]\n",
  "BOTTLENECKING": "BOTTLENECK, to slow down or impede by creating an obstruction [v]\n",
  "BOTTLENECKS": "BOTTLENECK, to slow down or impede by creating an obstruction [v]\n",
  "BOTTLENOSE": "a kind of whale or dolphin [n -S]\n",
  "BOTTLENOSES": "BOTTLENOSE, a kind of whale or dolphin [n]\n",
  "BOTTLER": "(Australian slang) an outstanding person or thing [n -S]\n",
  "BOTTLERS": "BOTTLER, (Australian slang) an outstanding person or thing [n]\n",
  "BOTTLES": "BOTTLE, to enclose in a narrow-necked vessel [v]\n",
  "BOTTLING": "a bottled beverage [n -S]\n",
  "BOTTLINGS": "BOTTLING, a bottled beverage [n]\n",
  "BOTTOM": "to reach the lowest point before stabilising or improving [v -ED, -ING, -S]\n",
  "BOTTOMED": "BOTTOM, to reach the lowest point before stabilising or improving [v]\n",
  "BOTTOMER": "a person who provides or fits bottoms (esp. for chairs) [n -S]\n",
  "BOTTOMERS": "BOTTOMER, a person who provides or fits bottoms (esp. for chairs) [n]\n",
  "BOTTOMING": "the act of reaching the lowest point before stabilising or improving [n -S]\n",
  "BOTTOMINGS": "BOTTOMING, the act of reaching the lowest point before stabilising or improving [n]\n",
  "BOTTOMLAND": "(US) alluvial deposits [n -S]\n",
  "BOTTOMLANDS": "BOTTOMLAND, (US) alluvial deposits [n]\n",
  "BOTTOMLESS": "having no bottom [adj BOTTOMLESSLY]\n",
  "BOTTOMLESSLY": "BOTTOMLESS, having no bottom [adv]\n",
  "BOTTOMLESSNESS": "the state of being bottomless [n]\n",
  "BOTTOMMOST": "situated at the very bottom [adj]\n",
  "BOTTOMNESS": "a property that characterizes quarks and hadrons [n -ES]\n",
  "BOTTOMNESSES": "BOTTOMNESS, a property that characterizes quarks and hadrons [n]\n",
  "BOTTOMRIES": "BOTTOMRY, the use of a ship as collateral to finance a sea voyage [n]\n",
  "BOTTOMRY": "the use of a ship as collateral to finance a sea voyage [n BOTTOMRIES]\n",
  "BOTTOMS": "BOTTOM, to reach the lowest point before stabilising or improving [v]\n",
  "BOTTOMSET": "as in bottomset bed, fine sediment deposited at the foot of a growing delta [adj]\n",
  "BOTTONY": "having buds or knobs at the extremities, applied to a cross, also BOTONE, BOTONEE, BOTONNEE [adj]\n",
  "BOTTS": "BOTT, the maggot of a botfly, also BOT [n]\n",
  "BOTTY": "(colloquial) a bottom [n BOTTIES]\n",
  "BOTULIN": "a powerful bacterial toxin, also BOTULINUM, BOTULINUS [n -S]\n",
  "BOTULINAL": "relating to botulin, a powerful bacterial toxin [adj]\n",
  "BOTULINS": "BOTULIN, a powerful bacterial toxin, also BOTULINUM, BOTULINUS [n]\n",
  "BOTULINUM": "a powerful bacterial toxin, also BOTULIN, BOTULINUS [n -S]\n",
  "BOTULINUMS": "BOTULINUM, a powerful bacterial toxin, also BOTULIN, BOTULINUS [n]\n",
  "BOTULINUS": "a powerful bacterial toxin, also BOTULIN, BOTULINUM [n -ES]\n",
  "BOTULINUSES": "BOTULINUS, a powerful bacterial toxin, also BOTULIN, BOTULINUM [n]\n",
  "BOTULISM": "botulin poisoning [n -S]\n",
  "BOTULISMS": "BOTULISM, botulin poisoning [n]\n",
  "BOUBOU": "a long flowing garment worn in Mali, also BUBU [n -S]\n",
  "BOUBOUS": "BOUBOU, a long flowing garment worn in Mali, also BUBU [n]\n",
  "BOUCHE": "(French) the staff of cooks in a large house [n -S]\n",
  "BOUCHEE": "(French) a small patty [n -S]\n",
  "BOUCHEES": "BOUCHEE, (French) a small patty [n]\n",
  "BOUCHES": "BOUCHE, (French) the staff of cooks in a large house [n]\n",
  "BOUCLE": "(French) a kind of rough-textured yarn or cloth [n -S]\n",
  "BOUCLEE": "(French) a loop made with forefinger and thumb to guide a billiard stick [n -S]\n",
  "BOUCLEES": "BOUCLEE, (French) a loop made with forefinger and thumb to guide a billiard stick [n]\n",
  "BOUCLES": "BOUCLE, (French) a kind of rough-textured yarn or cloth [n]\n",
  "BOUDERIE": "(French) a pouting, sulking [n -S]\n",
  "BOUDERIES": "BOUDERIE, (French) a pouting, sulking [n]\n",
  "BOUDIN": "(French) a spicy Cajun sausage [n -S]\n",
  "BOUDINS": "BOUDIN, (French) a spicy Cajun sausage [n]\n",
  "BOUDOIR": "(French) a woman's bedroom [n -S]\n",
  "BOUDOIRS": "BOUDOIR, (French) a woman's bedroom [n]\n",
  "BOUFFANT": "(French) a woman's hairdo [n -S]\n",
  "BOUFFANTS": "BOUFFANT, (French) a woman's hairdo [n]\n",
  "BOUFFE": "(French) a comic opera [n -S]\n",
  "BOUFFES": "BOUFFE, (French) a comic opera [n]\n",
  "BOUGAINVILIA": "a tropical flower, also BOUGAINVILLAEA, BOUGAINVILLEA [n -S]\n",
  "BOUGAINVILIAS": "BOUGAINVILIA, a tropical flower, also BOUGAINVILLAEA, BOUGAINVILLEA [n]\n",
  "BOUGAINVILLAEA": "a tropical flower, also BOUGAINVILIA, BOUGAINVILLEA [n -S]\n",
  "BOUGAINVILLAEAS": "BOUGAINVILLAEA, a tropical flower, also BOUGAINVILIA, BOUGAINVILLEA [n]\n",
  "BOUGAINVILLEA": "a tropical flower, also BOUGAINVILIA, BOUGAINVILLAEA [n -S]\n",
  "BOUGAINVILLEAS": "BOUGAINVILLEA, a tropical flower, also BOUGAINVILIA, BOUGAINVILLAEA [n]\n",
  "BOUGE": "(Shakespeare) to budge [v BOUGED, BOUGING, BOUGES]\n",
  "BOUGED": "BOUGE, (Shakespeare) to budge [v]\n",
  "BOUGES": "BOUGE, (Shakespeare) to budge [v]\n",
  "BOUGET": "(Spenser) a budget, a sack [n -S]\n",
  "BOUGETS": "BOUGET, (Spenser) a budget, a sack [n]\n",
  "BOUGH": "a tree branch [n -S]\n",
  "BOUGHED": "having a bough [adj]\n",
  "BOUGHLESS": "without boughs [adj]\n",
  "BOUGHPOT": "(archaic) a pot for boughs as an ornament, also BOWPOT [n -S]\n",
  "BOUGHPOTS": "BOUGHPOT, (archaic) a pot for boughs as an ornament, also BOWPOT [n]\n",
  "BOUGHS": "BOUGH, a tree branch [n]\n",
  "BOUGHT": "(Spenser) a coil, fold [n -S]\n",
  "BOUGHTEN": "(archaic) purchased; not obtained or produced at home [adj]\n",
  "BOUGHTS": "BOUGHT, (Spenser) a coil, fold [n]\n",
  "BOUGIE": "(French) a wax candle; a flexible medical instrument for insertion into body passages [n -S]\n",
  "BOUGIES": "BOUGIE, (French) a wax candle; a flexible medical instrument for insertion into body passages [n]\n",
  "BOUGING": "BOUGE, (Shakespeare) to budge [v]\n",
  "BOUILLABAISSE": "(French) a kind of fish soup [n -S]\n",
  "BOUILLABAISSES": "BOUILLABAISSE, (French) a kind of fish soup [n]\n",
  "BOUILLI": "(French) boiled meat [n -S]\n",
  "BOUILLIS": "BOUILLI, (French) boiled meat [n]\n",
  "BOUILLON": "(French) a strong broth [n -S]\n",
  "BOUILLONS": "BOUILLON, (French) a strong broth [n]\n",
  "BOUILLOTTE": "(French) a card game resembling poker [n -S]\n",
  "BOUILLOTTES": "BOUILLOTTE, (French) a card game resembling poker [n]\n",
  "BOUK": "(Scots) the body; bulk [n -S]\n",
  "BOUKS": "BOUK, (Scots) the body; bulk [n]\n",
  "BOULDER": "a large rock, also BOWLDER [n -S] / to climb boulders [v -ED, -ING, -S]\n",
  "BOULDERED": "BOULDER, to climb boulders [v]\n",
  "BOULDERER": "someone who climbs boulders [n -S]\n",
  "BOULDERERS": "BOULDERER, someone who climbs boulders [n]\n",
  "BOULDERIER": "BOULDERY, of a landscape, characterized by boulders [adj]\n",
  "BOULDERIEST": "BOULDERY, of a landscape, characterized by boulders [adj]\n",
  "BOULDERING": "the practice of rock climbing on large boulders or small outcrops either as practice or as a sport in its own right [n -S]\n",
  "BOULDERINGS": "BOULDERING, the practice of rock climbing on large boulders or small outcrops either as practice or as a sport in its own right [n]\n",
  "BOULDERS": "BOULDER, a large rock, also BOWLDER [n]\n",
  "BOULDERY": "of a landscape, characterized by boulders [adj BOULDERIER, BOULDERIEST]\n",
  "BOULE": "(Greek) in ancient Greece, a council or senate [n -S]\n",
  "BOULES": "BOULE, (Greek) in ancient Greece, a council or senate [n]\n",
  "BOULEVARD": "(French) a broad street (esp. in France) with rows of trees planted along it [n -S]\n",
  "BOULEVARDIER": "(French) a socially active man who likes to visit fashionable places [n -S]\n",
  "BOULEVARDIERS": "BOULEVARDIER, (French) a socially active man who likes to visit fashionable places [n]\n",
  "BOULEVARDS": "BOULEVARD, (French) a broad street (esp. in France) with rows of trees planted along it [n]\n",
  "BOULEVERSEMENT": "(French) an overturning, a reversal [n -S]\n",
  "BOULEVERSEMENTS": "BOULEVERSEMENT, (French) an overturning, a reversal [n]\n",
  "BOULLE": "(French) a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLEWORK, BUHL, BUHLWORK [n -S]\n",
  "BOULLES": "BOULLE, (French) a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLEWORK, BUHL, BUHLWORK [n]\n",
  "BOULLEWORK": "(French) a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLE, BUHL, BUHLWORK [n -S]\n",
  "BOULLEWORKS": "BOULLEWORK, (French) a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLE, BUHL, BUHLWORK [n]\n",
  "BOULT": "to sieve through a cloth [v -ED, -ING, -S]\n",
  "BOULTED": "BOULT, to sieve through a cloth [v]\n",
  "BOULTER": "a sieve, a machine for separating bran from flour, also BOLTER [n -S]\n",
  "BOULTERS": "BOULTER, a sieve, a machine for separating bran from flour, also BOLTER [n]\n",
  "BOULTING": "the act of sieving through cloth, also BOLTING [n -S]\n",
  "BOULTINGS": "BOULTING, the act of sieving through cloth, also BOLTING [n]\n",
  "BOULTS": "BOULT, to sieve through a cloth [v]\n",
  "BOUN": "to prepare, also BOWNE [v -ED, -ING, -S]\n",
  "BOUNCE": "to spring back [v BOUNCED, BOUNCING, BOUNCES]\n",
  "BOUNCED": "BOUNCE, to spring back [v]\n",
  "BOUNCEDOWN": "in Australian rules football, an occasion of restarting play by the umpire by bouncing the ball [n -S]\n",
  "BOUNCEDOWNS": "BOUNCEDOWN, in Australian rules football, an occasion of restarting play by the umpire by bouncing the ball [n]\n",
  "BOUNCER": "a person or thing that bounces [n -S]\n",
  "BOUNCERS": "BOUNCER, a person or thing that bounces [n]\n",
  "BOUNCES": "BOUNCE, to spring back [v]\n",
  "BOUNCIER": "BOUNCY, tending to bounce [adj]\n",
  "BOUNCIEST": "BOUNCY, tending to bounce [adj]\n",
  "BOUNCILY": "BOUNCY, tending to bounce [adv]\n",
  "BOUNCINESS": "the state of being bouncy [n -ES]\n",
  "BOUNCINESSES": "BOUNCINESS, the state of being bouncy [n]\n",
  "BOUNCING": "BOUNCE, to spring back [v]\n",
  "BOUNCINGLY": "BOUNCING, BOUNCE, to spring back [adv]\n",
  "BOUNCY": "tending to bounce [adj BOUNCIER, BOUNCIEST, BOUNCILY]\n",
  "BOUND": "to leap [v -ED, -ING, -S]\n",
  "BOUNDABLE": "that can be bound [adj]\n",
  "BOUNDARIES": "BOUNDARY, a final limit [n]\n",
  "BOUNDARY": "a final limit [n BOUNDARIES]\n",
  "BOUNDED": "BOUND, to leap [v]\n",
  "BOUNDEDNESS": "the state of being bounded [n -ES]\n",
  "BOUNDEDNESSES": "BOUNDEDNESS, the state of being bounded [n]\n",
  "BOUNDEN": "(archaic) being under obligation; obliged [adj]\n",
  "BOUNDER": "a cad [n -S]\n",
  "BOUNDERISH": "like a bounder, caddish [adj]\n",
  "BOUNDERS": "BOUNDER, a cad [n]\n",
  "BOUNDING": "BOUND, to leap [v]\n",
  "BOUNDLESS": "having no limits [adj BOUNDLESSLY]\n",
  "BOUNDLESSLY": "BOUNDLESS, having no limits [adv]\n",
  "BOUNDLESSNESS": "the state of being boundless [n -ES]\n",
  "BOUNDLESSNESSES": "BOUNDLESSNESS, the state of being boundless [n]\n",
  "BOUNDNESS": "the state of being bound [n -ES]\n",
  "BOUNDNESSES": "BOUNDNESS, the state of being bound [n]\n",
  "BOUNDS": "BOUND, to leap [v]\n",
  "BOUNED": "BOUN, to prepare, also BOWNE [v]\n",
  "BOUNING": "BOUN, to prepare, also BOWNE [v]\n",
  "BOUNS": "BOUN, to prepare, also BOWNE [v]\n",
  "BOUNTEOUS": "generous [adj BOUNTEOUSLY]\n",
  "BOUNTEOUSLY": "BOUNTEOUS, generous [adv]\n",
  "BOUNTEOUSNESS": "the state of being bounteous [n -ES]\n",
  "BOUNTEOUSNESSES": "BOUNTEOUSNESS, the state of being bounteous [n]\n",
  "BOUNTIED": "with a bounty on one's head [adj]\n",
  "BOUNTIES": "BOUNTY, a reward [n]\n",
  "BOUNTIFUL": "generous in giving [adj BOUNTIFULLY]\n",
  "BOUNTIFULLY": "BOUNTIFUL, generous in giving [adv]\n",
  "BOUNTIFULNESS": "BOUNTIFUL, generous in giving [n]\n",
  "BOUNTIFULNESSES": "BOUNTIFULNESS, BOUNTIFUL, generous in giving [n]\n",
  "BOUNTREE": "(Scots) the elder tree, also BOORTREE, BOURTREE [n -S]\n",
  "BOUNTREES": "BOUNTREE, (Scots) the elder tree, also BOORTREE, BOURTREE [n]\n",
  "BOUNTY": "a reward [n BOUNTIES]\n",
  "BOUNTYHED": "(Spenser) bounteousness [n -S]\n",
  "BOUNTYHEDS": "BOUNTYHED, (Spenser) bounteousness [n]\n",
  "BOUQUET": "(French) a bunch of flowers [n -S]\n",
  "BOUQUETIERE": "(French) a flower-girl [n -S]\n",
  "BOUQUETIERES": "BOUQUETIERE, (French) a flower-girl [n]\n",
  "BOUQUETS": "BOUQUET, (French) a bunch of flowers [n]\n",
  "BOURASQUE": "(French) a tempest [n -S]\n",
  "BOURASQUES": "BOURASQUE, (French) a tempest [n]\n",
  "BOURBON": "a kind of whisky [n -S]\n",
  "BOURBONISM": "the principles of those adhering to the house of Bourbon; obstinate conservatism [n -S]\n",
  "BOURBONISMS": "BOURBONISM, the principles of those adhering to the house of Bourbon; obstinate conservatism [n]\n",
  "BOURBONS": "BOURBON, a kind of whisky [n]\n",
  "BOURD": "(obsolete) to jest [v -ED, -ING, -S]\n",
  "BOURDED": "BOURD, (obsolete) to jest [v]\n",
  "BOURDER": "a jester [n -S]\n",
  "BOURDERS": "BOURDER, a jester [n]\n",
  "BOURDING": "BOURD, (obsolete) to jest [v]\n",
  "BOURDON": "(French) the drone bass of a bagpipe or organ [n -S]\n",
  "BOURDONS": "BOURDON, (French) the drone bass of a bagpipe or organ [n]\n",
  "BOURDS": "BOURD, (obsolete) to jest [v]\n",
  "BOURG": "(French) a market-town [n -S]\n",
  "BOURGEOIS": "(French) middle-class; conventionally respectable and unimaginative [adj] / a member of the bourgeois class [n]\n",
  "BOURGEOISE": "(French) a female bourgeois [n -S]\n",
  "BOURGEOISES": "BOURGEOISE, (French) a female bourgeois [n]\n",
  "BOURGEOISIE": "(French) the middle classes [n -S]\n",
  "BOURGEOISIES": "BOURGEOISIE, (French) the middle classes [n]\n",
  "BOURGEOISIFIED": "BOURGEOISIFY, to make bourgeois [v]\n",
  "BOURGEOISIFIES": "BOURGEOISIFY, to make bourgeois [v]\n",
  "BOURGEOISIFY": "to make bourgeois [v BOURGEOISIFIED, BOURGEOISIFYING, BOURGEOISIFIES]\n",
  "BOURGEOISIFYING": "BOURGEOISIFY, to make bourgeois [v]\n",
  "BOURGEON": "(obsolete) to sprout; to put forth bud, also BURGEON [v -ED, -ING, -S]\n",
  "BOURGEONED": "BOURGEON, (obsolete) to sprout; to put forth bud, also BURGEON [v]\n",
  "BOURGEONING": "BOURGEON, (obsolete) to sprout; to put forth bud, also BURGEON [v]\n",
  "BOURGEONS": "BOURGEON, (obsolete) to sprout; to put forth bud, also BURGEON [v]\n",
  "BOURGS": "BOURG, (French) a market-town [n]\n",
  "BOURGUIGNON": "(French) a meat dish stewed with onions, mushrooms and Burgundy wine, also BOURGUIGNONNE [n -S]\n",
  "BOURGUIGNONNE": "(French) a meat dish stewed with onions, mushrooms and Burgundy wine, also BOURGUIGNON [n -S]\n",
  "BOURGUIGNONNES": "BOURGUIGNONNE, (French) a meat dish stewed with onions, mushrooms and Burgundy wine, also BOURGUIGNON [n]\n",
  "BOURGUIGNONS": "BOURGUIGNON, (French) a meat dish stewed with onions, mushrooms and Burgundy wine, also BOURGUIGNONNE [n]\n",
  "BOURKHA": "(Urdu) a coverall worn by Muslim women, also BURKA, BOORKA, BURQA [n -S]\n",
  "BOURKHAS": "BOURKHA, (Urdu) a coverall worn by Muslim women, also BURKA, BOORKA, BURQA [n]\n",
  "BOURLAW": "(archaic) a local law dealing with local customs and civil disputes, also BYRLAW [n -S]\n",
  "BOURLAWS": "BOURLAW, (archaic) a local law dealing with local customs and civil disputes, also BYRLAW [n]\n",
  "BOURN": "a small stream [n -S]\n",
  "BOURNE": "a boundary, limit, also BOURN [n -S]\n",
  "BOURNES": "BOURNE, a boundary, limit, also BOURN [n]\n",
  "BOURNS": "BOURN, a small stream [n]\n",
  "BOURREE": "(French) a brisk French dance in triple time [n -S]\n",
  "BOURREES": "BOURREE, (French) a brisk French dance in triple time [n]\n",
  "BOURRIDE": "(French) a fish dish from Provence [n -S]\n",
  "BOURRIDES": "BOURRIDE, (French) a fish dish from Provence [n]\n",
  "BOURSE": "(French) a commercial exchange; specifically, a European stock exchange [n -S]\n",
  "BOURSES": "BOURSE, (French) a commercial exchange; specifically, a European stock exchange [n]\n",
  "BOURSIER": "(French) a foundation-scholar; a speculator on the Stock Exchange [n -S]\n",
  "BOURSIERS": "BOURSIER, (French) a foundation-scholar; a speculator on the Stock Exchange [n]\n",
  "BOURSIN": "a mild, smooth, creamy cheese without rind [n -S]\n",
  "BOURSINS": "BOURSIN, a mild, smooth, creamy cheese without rind [n]\n",
  "BOURTREE": "(Scots) the elder tree, also BOORTREE, BOUNTREE [n -S]\n",
  "BOURTREES": "BOURTREE, (Scots) the elder tree, also BOORTREE, BOUNTREE [n]\n",
  "BOUSE": "to haul with tackle, also BOWSE [v BOUSED, BOUSING, BOUSES]\n",
  "BOUSED": "BOUSE, to haul with tackle, also BOWSE [v]\n",
  "BOUSES": "BOUSE, to haul with tackle, also BOWSE [v]\n",
  "BOUSIER": "BOUSY, inclined to booze, also BOOZY, BOOZEY [adj]\n",
  "BOUSIEST": "BOUSY, inclined to booze, also BOOZY, BOOZEY [adj]\n",
  "BOUSING": "BOUSE, to haul with tackle, also BOWSE [v]\n",
  "BOUSINGKEN": "(obsolete) in thieves' slang, a low drinking shop [n -S]\n",
  "BOUSINGKENS": "BOUSINGKEN, (obsolete) in thieves' slang, a low drinking shop [n]\n",
  "BOUSOUKI": "(Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUZOUKI, BUZUKI [n BOUSOUKIA or BOUSOUKIS]\n",
  "BOUSOUKIA": "BOUSOUKI, (Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUZOUKI, BUZUKI [n]\n",
  "BOUSOUKIS": "BOUSOUKI, (Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUZOUKI, BUZUKI [n]\n",
  "BOUSTROPHEDON": "(Greek) a method of writing in which lines are written alternately in opposite direction, from left to right, and right to left [n -S]\n",
  "BOUSTROPHEDONIC": "having alternate lines written in opposite directions [adj]\n",
  "BOUSTROPHEDONS": "BOUSTROPHEDON, (Greek) a method of writing in which lines are written alternately in opposite direction, from left to right, and right to left [n]\n",
  "BOUSY": "inclined to booze, also BOOZY, BOOZEY [adj BOUSIER, BOUSIEST]\n",
  "BOUT": "a contest [n -S]\n",
  "BOUTADE": "(French) a sudden outburst [n -S]\n",
  "BOUTADES": "BOUTADE, (French) a sudden outburst [n]\n",
  "BOUTIQUE": "(French) a shop, or department in a store, selling (esp. fashionable) clothes or accessories [n -S]\n",
  "BOUTIQUES": "BOUTIQUE, (French) a shop, or department in a store, selling (esp. fashionable) clothes or accessories [n]\n",
  "BOUTIQUEY": "like a boutique [adj BOUTIQUIER, BOUTIQUIEST]\n",
  "BOUTIQUIER": "BOUTIQUEY, like a boutique [adj]\n",
  "BOUTIQUIEST": "BOUTIQUEY, like a boutique [adj]\n",
  "BOUTON": "(French) an enlarged end of a nerve fibre [n -S]\n",
  "BOUTONNE": "(French) reserved, reticent (of a male) [adj]\n",
  "BOUTONNEE": "(French) reserved, reticent (of a female) [adj]\n",
  "BOUTONNIERE": "(French) a flower for the buttonhole, etc. [n -S]\n",
  "BOUTONNIERES": "BOUTONNIERE, (French) a flower for the buttonhole, etc. [n]\n",
  "BOUTONS": "BOUTON, (French) an enlarged end of a nerve fibre [n]\n",
  "BOUTS": "BOUT, a contest [n]\n",
  "BOUVARDIA": "a genus of flowering herbs and shrubs native to tropical parts of Central America [n -S]\n",
  "BOUVARDIAS": "BOUVARDIA, a genus of flowering herbs and shrubs native to tropical parts of Central America [n]\n",
  "BOUVIER": "(French) a large rough-coated dog originally bred in Flanders to herd and guard cattle [n -S]\n",
  "BOUVIERS": "BOUVIER, (French) a large rough-coated dog originally bred in Flanders to herd and guard cattle [n]\n",
  "BOUZOUKI": "(Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUSOUKI, BUZUKI [n BOUZOUKIA or BOUZOUKIS]\n",
  "BOUZOUKIA": "BOUZOUKI, (Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUSOUKI, BUZUKI [n]\n",
  "BOUZOUKIS": "BOUZOUKI, (Modern Greek) a Greek long-necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUSOUKI, BUZUKI [n]\n",
  "BOVATE": "(historical) an old measure of land, an oxgang [n -S]\n",
  "BOVATES": "BOVATE, (historical) an old measure of land, an oxgang [n]\n",
  "BOVID": "an animal of the cattle family [n -S]\n",
  "BOVIDS": "BOVID, an animal of the cattle family [n]\n",
  "BOVINE": "relating to cattle [adj BOVINELY] / an animal of the cattle family [n -S]\n",
  "BOVINELY": "BOVINE, relating to cattle [adv]\n",
  "BOVINES": "BOVINE, an animal of the cattle family [n]\n",
  "BOVINITIES": "BOVINITY, the state of being a bovine [n]\n",
  "BOVINITY": "the state of being a bovine [n BOVINITIES]\n",
  "BOVVER": "(slang) rowdy or violent behaviour by street gangs [n -S]\n",
  "BOVVERS": "BOVVER, (slang) rowdy or violent behaviour by street gangs [n]\n",
  "BOW": "to bend or incline downwards [v -ED, -ING, -S]\n",
  "BOWAT": "(Scots) a lantern, also BOWET, BUAT [n -S]\n",
  "BOWATS": "BOWAT, (Scots) a lantern, also BOWET, BUAT [n]\n",
  "BOWBENT": "(Milton) bent like a bow [adj]\n",
  "BOWDLERISATION": "the act of bowdlerising, also BOWDLERIZATION [n -S]\n",
  "BOWDLERISATIONS": "BOWDLERISATION, the act of bowdlerising, also BOWDLERIZATION [n]\n",
  "BOWDLERISE": "to expurgate a book or writing, by removing whatever might be considered indelicate, esp. to do so unnecessarily, also BOWDLERIZE [v BOWDLERISED, BOWDLERISING, BOWDLERISES]\n",
  "BOWDLERISED": "BOWDLERISE, to expurgate a book or writing, by removing whatever might be considered indelicate, esp. to do so unnecessarily, also BOWDLERIZE [v]\n",
  "BOWDLERISER": "one who bowdlerises, also BOWDLERIZER [n -S]\n",
  "BOWDLERISERS": "BOWDLERISER, one who bowdlerises, also BOWDLERIZER [n]\n",
  "BOWDLERISES": "BOWDLERISE, to expurgate a book or writing, by removing whatever might be considered indelicate, esp. to do so unnecessarily, also BOWDLERIZE [v]\n",
  "BOWDLERISING": "BOWDLERISE, to expurgate a book or writing, by removing whatever might be considered indelicate, esp. to do so unnecessarily, also BOWDLERIZE [v]\n",
  "BOWDLERISM": "the censoring of a literary text [n -S]\n",
  "BOWDLERISMS": "BOWDLERISM, the censoring of a literary text [n]\n",
  "BOWDLERIZATION": "the act of bowdlerizing, also BOWDLERISATION [n -S]\n",
  "BOWDLERIZATIONS": "BOWDLERIZATION, the act of bowdlerizing, also BOWDLERISATION [n]\n",
  "BOWDLERIZE": "to purge literature of all possibly offensive or morally impure material, also BOWDLERISE [v BOWDLERIZED, BOWDLERIZING, BOWDLERIZES]\n",
  "BOWDLERIZED": "BOWDLERIZE, to purge literature of all possibly offensive or morally impure material, also BOWDLERISE [v]\n",
  "BOWDLERIZER": "one who bowdlerizes, also BOWDLERISER [n -S]\n",
  "BOWDLERIZERS": "BOWDLERIZER, one who bowdlerizes, also BOWDLERISER [n]\n",
  "BOWDLERIZES": "BOWDLERIZE, to purge literature of all possibly offensive or morally impure material, also BOWDLERISE [v]\n",
  "BOWDLERIZING": "BOWDLERIZE, to purge literature of all possibly offensive or morally impure material, also BOWDLERISE [v]\n",
  "BOWED": "BOW, to bend or incline downwards [v]\n",
  "BOWEL": "to take out the entrails [v BOWELED or BOWELLED, BOWELING or BOWELLING, BOWELS]\n",
  "BOWELED": "BOWEL, to take out the entrails [v]\n",
  "BOWELING": "BOWEL, to take out the entrails [v]\n",
  "BOWELLED": "BOWEL, to take out the entrails [v]\n",
  "BOWELLESS": "without pity [adj]\n",
  "BOWELLING": "BOWEL, to take out the entrails [v]\n",
  "BOWELS": "BOWEL, to take out the entrails [v]\n",
  "BOWER": "to enclose in a shady recess [v -ED, -ING, -S]\n",
  "BOWERBIRD": "any of various passerine birds native to Australia and New Guinea, which construct elaborate runs adorned with feathers, shells, etc. during courtship [n -S]\n",
  "BOWERBIRDS": "BOWERBIRD, any of various passerine birds native to Australia and New Guinea, which construct elaborate runs adorned with feathers, shells, etc. during courtship [n]\n",
  "BOWERED": "BOWER, to enclose in a shady recess [v]\n",
  "BOWERIES": "BOWERY, a colonial Dutch farm [n]\n",
  "BOWERING": "BOWER, to enclose in a shady recess [v]\n",
  "BOWERS": "BOWER, to enclose in a shady recess [v]\n",
  "BOWERWOMAN": "(archaic) a chamber-woman, a lady's maid [n BOWERWOMEN]\n",
  "BOWERWOMEN": "BOWERWOMAN, (archaic) a chamber-woman, a lady's maid [n]\n",
  "BOWERY": "a colonial Dutch farm [n BOWERIES]\n",
  "BOWES": "(Milton) boughs [n]\n",
  "BOWET": "(Scots) a lantern, also BOWAT, BUAT [n -S]\n",
  "BOWETS": "BOWET, (Scots) a lantern, also BOWAT, BUAT [n]\n",
  "BOWFIN": "a voracious ganoid fish found in the fresh waters of the United States [n -S]\n",
  "BOWFINS": "BOWFIN, a voracious ganoid fish found in the fresh waters of the United States [n]\n",
  "BOWFRONT": "having a curved front [adj]\n",
  "BOWGET": "(obsolete) an ancient water vessel consisting of a yoke with two leather pouches or skins attached [n -S]\n",
  "BOWGETS": "BOWGET, (obsolete) an ancient water vessel consisting of a yoke with two leather pouches or skins attached [n]\n",
  "BOWHEAD": "the great Arctic or Greenland whale [n -S]\n",
  "BOWHEADS": "BOWHEAD, the great Arctic or Greenland whale [n]\n",
  "BOWHUNT": "to hunt with a bow and arrow [v -ED, -ING, -S]\n",
  "BOWHUNTED": "BOWHUNT, to hunt with a bow and arrow [v]\n",
  "BOWHUNTER": "a person who hunts with a bow and arrow [n -S]\n",
  "BOWHUNTERS": "BOWHUNTER, a person who hunts with a bow and arrow [n]\n",
  "BOWHUNTING": "the act of hunting with a bow and arrow [n -S]\n",
  "BOWHUNTINGS": "BOWHUNTING, the act of hunting with a bow and arrow [n]\n",
  "BOWHUNTS": "BOWHUNT, to hunt with a bow and arrow [v]\n",
  "BOWIE": "as in bowie knife, a type of hunting knife [adj]\n",
  "BOWING": "the technique of playing a stringed instrument with a bow [n -S]\n",
  "BOWINGLY": "BOWING [adv]\n",
  "BOWINGS": "BOWING, the technique of playing a stringed instrument with a bow [n]\n",
  "BOWKNOT": "a type of knot [n -S]\n",
  "BOWKNOTS": "BOWKNOT, a type of knot [n]\n",
  "BOWL": "to make a delivery of a ball [v -ED, -ING, -S]\n",
  "BOWLDER": "a large rock, also BOULDER [n -S]\n",
  "BOWLDERS": "BOWLDER, a large rock, also BOULDER [n]\n",
  "BOWLED": "BOWL, to make a delivery of a ball [v]\n",
  "BOWLEG": "an outwardly curved leg [n -S]\n",
  "BOWLEGGED": "with outward curving legs [adj]\n",
  "BOWLEGS": "BOWLEG, an outwardly curved leg [n]\n",
  "BOWLER": "a stiff felt hat with a round crown and narrow brim [n -S]\n",
  "BOWLERS": "BOWLER, a stiff felt hat with a round crown and narrow brim [n]\n",
  "BOWLESS": "being without a bow [adj]\n",
  "BOWLFUL": "as much as a bowl can hold [n -S]\n",
  "BOWLFULS": "BOWLFUL, as much as a bowl can hold [n]\n",
  "BOWLIKE": "curved [adj]\n",
  "BOWLINE": "a simple knot which makes a loop that will not slip at the end of a rope [n -S]\n",
  "BOWLINES": "BOWLINE, a simple knot which makes a loop that will not slip at the end of a rope [n]\n",
  "BOWLING": "a game in which bowls are used [n -S]\n",
  "BOWLINGS": "BOWLING, a game in which bowls are used [n]\n",
  "BOWLINGUAL": "a device that allegedly translates a dog's bark and grunts into a human language [n -S]\n",
  "BOWLINGUALS": "BOWLINGUAL, a device that allegedly translates a dog's bark and grunts into a human language [n]\n",
  "BOWLLIKE": "concave [adj]\n",
  "BOWLS": "BOWL, to make a delivery of a ball [v]\n",
  "BOWMAN": "an archer [n BOWMEN]\n",
  "BOWMEN": "BOWMAN, an archer [n]\n",
  "BOWNE": "to prepare, also BOUN [v BOWNED, BOWNING, BOWNES]\n",
  "BOWNED": "BOWNE, to prepare, also BOUN [v]\n",
  "BOWNES": "BOWNE, to prepare, also BOUN [v]\n",
  "BOWNING": "BOWNE, to prepare, also BOUN [v]\n",
  "BOWPOT": "a pot for boughs as an ornament, also BOUGHPOT [n -S]\n",
  "BOWPOTS": "BOWPOT, a pot for boughs as an ornament, also BOUGHPOT [n]\n",
  "BOWR": "(Spenser) a muscle [n -S]\n",
  "BOWRS": "BOWR, (Spenser) a muscle [n]\n",
  "BOWS": "BOW, to bend or incline downwards [v]\n",
  "BOWSAW": "a saw with a thin blade in a bow-shaped frame [n -S]\n",
  "BOWSAWS": "BOWSAW, a saw with a thin blade in a bow-shaped frame [n]\n",
  "BOWSE": "to haul with tackle, also BOUSE [v BOWSED, BOWSING, BOWSES]\n",
  "BOWSED": "BOWSE, to haul with tackle, also BOUSE [v]\n",
  "BOWSER": "(tradename) a light tanker used for refuelling aircraft [n -S]\n",
  "BOWSERS": "BOWSER, (tradename) a light tanker used for refuelling aircraft [n]\n",
  "BOWSES": "BOWSE, to haul with tackle, also BOUSE [v]\n",
  "BOWSEY": "(Irish) a mean person, also BOWSIE [n -S]\n",
  "BOWSEYS": "BOWSEY, (Irish) a mean person, also BOWSIE [n]\n",
  "BOWSHOT": "the distance to which an arrow can be shot from a bow [n -S]\n",
  "BOWSHOTS": "BOWSHOT, the distance to which an arrow can be shot from a bow [n]\n",
  "BOWSIE": "(Irish) an inferior person, also BOWSEY [n -S]\n",
  "BOWSIES": "BOWSIE, (Irish) an inferior person, also BOWSEY [n]\n",
  "BOWSING": "BOWSE, to haul with tackle, also BOUSE [v]\n",
  "BOWSMAN": "a bowman (one who hunts with a bow) [n BOWSMEN]\n",
  "BOWSMEN": "BOWSMAN, a bowman (one who hunts with a bow) [n]\n",
  "BOWSPRIT": "a spar that extends at the bows of a ship [n -S]\n",
  "BOWSPRITS": "BOWSPRIT, a spar that extends at the bows of a ship [n]\n",
  "BOWSTRING": "the string of a bow [n -S] / to strangle with a bowstring [v BOWSTRINGED or BOWSTRUNG, BOWSTRINGING, BOWSTRINGS]\n",
  "BOWSTRINGED": "BOWSTRING, to strangle with a bowstring [v]\n",
  "BOWSTRINGING": "BOWSTRING, to strangle with a bowstring [v]\n",
  "BOWSTRINGS": "BOWSTRING, to strangle with a bowstring [v]\n",
  "BOWSTRUNG": "BOWSTRING, to strangle with a bowstring [v]\n",
  "BOWWOOD": "a deciduous tree of America [n -S]\n",
  "BOWWOODS": "BOWWOOD, a deciduous tree of America [n]\n",
  "BOWWOW": "to bark like a dog [v -ED, -ING, -S]\n",
  "BOWWOWED": "BOWWOW, to bark like a dog [v]\n",
  "BOWWOWING": "BOWWOW, to bark like a dog [v]\n",
  "BOWWOWS": "BOWWOW, to bark like a dog [v]\n",
  "BOWYANG": "(Australian) a strap tied around a trouser-leg [n -S]\n",
  "BOWYANGS": "BOWYANG, (Australian) a strap tied around a trouser-leg [n]\n",
  "BOWYER": "a maker of archery bows [n -S]\n",
  "BOWYERS": "BOWYER, a maker of archery bows [n]\n",
  "BOX": "to put in a container [v -ED, -ING, -ES]\n",
  "BOXBALL": "a form of handball [n -S]\n",
  "BOXBALLS": "BOXBALL, a form of handball [n]\n",
  "BOXBERRIES": "BOXBERRY, an evergreen plant, the wintergreen or teaberry [n]\n",
  "BOXBERRY": "an evergreen plant, the wintergreen or teaberry [n BOXBERRIES]\n",
  "BOXBOARD": "a kind of stiff paperboard [n -S]\n",
  "BOXBOARDS": "BOXBOARD, a kind of stiff paperboard [n]\n",
  "BOXCAR": "a roofed freight car [n -S]\n",
  "BOXCARS": "BOXCAR, a roofed freight car [n]\n",
  "BOXED": "BOX, to put in a container [v]\n",
  "BOXEN": "made of boxwood [adj]\n",
  "BOXER": "a person who boxes or is skilled in boxing [n -S]\n",
  "BOXERCISE": "exercise via boxing [n -S]\n",
  "BOXERCISES": "BOXERCISE, exercise via boxing [n]\n",
  "BOXERS": "BOXER, a person who boxes or is skilled in boxing [n]\n",
  "BOXES": "BOX, to put in a container [v]\n",
  "BOXFISH": "any one of several species of fishes of the genus Ostracion, aka trunkfish [n -ES]\n",
  "BOXFISHES": "BOXFISH, any one of several species of fishes of the genus Ostracion, aka trunkfish [n]\n",
  "BOXFUL": "as much as a box can hold [n -S]\n",
  "BOXFULS": "BOXFUL, as much as a box can hold [n]\n",
  "BOXHAUL": "to put (a vessel) on the other tack by veering her short round on her heel [v -ED, -ING, -S]\n",
  "BOXHAULED": "BOXHAUL, to put (a vessel) on the other tack by veering her short round on her heel [v]\n",
  "BOXHAULING": "BOXHAUL, to put (a vessel) on the other tack by veering her short round on her heel [v]\n",
  "BOXHAULS": "BOXHAUL, to put (a vessel) on the other tack by veering her short round on her heel [v]\n",
  "BOXIER": "BOXY, like a box [adj]\n",
  "BOXIEST": "BOXY, like a box [adj]\n",
  "BOXILY": "resembling boxes [adv]\n",
  "BOXINESS": "the state of being boxy, like a box [n -ES]\n",
  "BOXINESSES": "BOXINESS, the state of being boxy, like a box [n]\n",
  "BOXING": "the sport of fighting with fists [n -S]\n",
  "BOXINGS": "BOXING, the sport of fighting with fists [n]\n",
  "BOXKEEPER": "an attendant at a theatre who has charge of the boxes [n -S]\n",
  "BOXKEEPERS": "BOXKEEPER, an attendant at a theatre who has charge of the boxes [n]\n",
  "BOXLA": "a form of indoor lacrosse [n -S]\n",
  "BOXLAS": "BOXLA, a form of indoor lacrosse [n]\n",
  "BOXLIKE": "like a box [adj]\n",
  "BOXPLOT": "a type of statistical graph [n -S]\n",
  "BOXPLOTS": "BOXPLOT, a type of statistical graph [n]\n",
  "BOXROOM": "a room for storing boxes [n -S]\n",
  "BOXROOMS": "BOXROOM, a room for storing boxes [n]\n",
  "BOXTHORN": "a thorny shrub with red berries [n -S]\n",
  "BOXTHORNS": "BOXTHORN, a thorny shrub with red berries [n]\n",
  "BOXTIES": "BOXTY, an Irish dish of potato griddlecakes, eaten with various fillings [n]\n",
  "BOXTY": "an Irish dish of potato griddlecakes, eaten with various fillings [n BOXTIES]\n",
  "BOXWALLAH": "(Hindi) a pedlar; a businessman [n -S]\n",
  "BOXWALLAHS": "BOXWALLAH, (Hindi) a pedlar; a businessman [n]\n",
  "BOXWOOD": "the wood of the box, noted for its fine grain [n -S]\n",
  "BOXWOODS": "BOXWOOD, the wood of the box, noted for its fine grain [n]\n",
  "BOXY": "like a box [adj BOXIER, BOXIEST, BOXILY]\n",
  "BOY": "to act a female role as a boy [v -ED, -ING, -S]\n",
  "BOYAR": "(Russian) a member of the old Russian aristocracy, abolished by Peter the Great, also BOYARD [n -S]\n",
  "BOYARD": "(Russian) a member of the old Russian aristocracy, abolished by Peter the Great, also BOYAR [n -S]\n",
  "BOYARDS": "BOYARD, (Russian) a member of the old Russian aristocracy, abolished by Peter the Great, also BOYAR [n]\n",
  "BOYARISM": "(Russian) rule by the boyars, the old Russian aristocracy [n -S]\n",
  "BOYARISMS": "BOYARISM, (Russian) rule by the boyars, the old Russian aristocracy [n]\n",
  "BOYARS": "BOYAR, (Russian) a member of the old Russian aristocracy, abolished by Peter the Great, also BOYARD [n]\n",
  "BOYAU": "(French) a communication trench [n BOYAUX]\n",
  "BOYAUX": "BOYAU, (French) a communication trench [n]\n",
  "BOYCHICK": "(Yiddish) boy, a term of endearment, also BOYCHIK [n -S]\n",
  "BOYCHICKS": "BOYCHICK, (Yiddish) boy, a term of endearment, also BOYCHIK [n]\n",
  "BOYCHIK": "(Yiddish) boy, a term of endearment, also BOYCHICK [n -S]\n",
  "BOYCHIKS": "BOYCHIK, (Yiddish) boy, a term of endearment, also BOYCHICK [n]\n",
  "BOYCOTT": "to refuse to have dealings with [v -ED, -ING, -S]\n",
  "BOYCOTTED": "BOYCOTT, to refuse to have dealings with [v]\n",
  "BOYCOTTER": "one who boycotts [n -S]\n",
  "BOYCOTTERS": "BOYCOTTER, one who boycotts [n]\n",
  "BOYCOTTING": "BOYCOTT, to refuse to have dealings with [v]\n",
  "BOYCOTTS": "BOYCOTT, to refuse to have dealings with [v]\n",
  "BOYED": "BOY, to act a female role as a boy [v]\n",
  "BOYF": "boyfriend [n -S]\n",
  "BOYFRIEND": "a girl's favourite boy for the time being [n -S]\n",
  "BOYFRIENDS": "BOYFRIEND, a girl's favourite boy for the time being [n]\n",
  "BOYFS": "BOYF, boyfriend [n]\n",
  "BOYG": "(Norwegian) a problem difficult to get to grips with [n -S]\n",
  "BOYGS": "BOYG, (Norwegian) a problem difficult to get to grips with [n]\n",
  "BOYHOOD": "the state of being a boy [n -S]\n",
  "BOYHOODS": "BOYHOOD, the state of being a boy [n]\n",
  "BOYING": "BOY, to act a female role as a boy [v]\n",
  "BOYISH": "like a boy [adj BOYISHLY]\n",
  "BOYISHLY": "BOYISH, like a boy [adv]\n",
  "BOYISHNESS": "the state of being boyish [n -ES]\n",
  "BOYISHNESSES": "BOYISHNESS, the state of being boyish [n]\n",
  "BOYKIE": "(colloquial) a chap or fellow [n -S]\n",
  "BOYKIES": "BOYKIE, (colloquial) a chap or fellow [n]\n",
  "BOYLA": "(Native Australian) a witch doctor [n -S]\n",
  "BOYLAS": "BOYLA, (Native Australian) a witch doctor [n]\n",
  "BOYO": "a young man [n -S]\n",
  "BOYOS": "BOYO, a young man [n]\n",
  "BOYS": "BOY, to act a female role as a boy [v]\n",
  "BOYSENBERRIES": "BOYSENBERRY, a fruit growing on a bramble, a hybrid of certain raspberries and blackberries [n]\n",
  "BOYSENBERRY": "a fruit growing on a bramble, a hybrid of certain raspberries and blackberries [n BOYSENBERRIES]\n",
  "BOYSHORTS": "a sort of lingerie that goes all the way down the hips [n]\n",
  "BOYSIER": "BOYSY, suited to or typical of boys or young men [adj]\n",
  "BOYSIEST": "BOYSY, suited to or typical of boys or young men [adj]\n",
  "BOYSY": "suited to or typical of boys or young men [adj BOYSIER, BOYSIEST]\n",
  "BOZO": "(US slang) a man, a fellow [n -S]\n",
  "BOZOS": "BOZO, (US slang) a man, a fellow [n]\n",
  "BOZZETTI": "BOZZETTO, (Italian) a small sketch of a projected sculpture [n]\n",
  "BOZZETTO": "(Italian) a small sketch of a projected sculpture [n BOZZETTI]\n",
  "BRA": "(short for) brassiere [n -S]\n",
  "BRAAI": "(South African) to grill or roast meat over open coals [v -ED, -ING, -S]\n",
  "BRAAIED": "BRAAI, (South African) to grill or roast meat over open coals [v]\n",
  "BRAAIING": "BRAAI, (South African) to grill or roast meat over open coals [v]\n",
  "BRAAIS": "BRAAI, (South African) to grill or roast meat over open coals [v]\n",
  "BRAAIVLEIS": "(South African) a barbecue party [n -ES]\n",
  "BRAAIVLEISES": "BRAAIVLEIS, (South African) a barbecue party [n]\n",
  "BRAATA": "(Spanish) a small portion added to a purchase of food by a vendor to encourage the person to return, also BRAATAS, BROUGHTA, BROUGHTAS [n -S]\n",
  "BRAATAS": "(Spanish) a small portion added to a purchase of food by a vendor to encourage the person to return, also BRAATA, BROUGHTA, BROUGHTAS [n -ES]\n",
  "BRAATASES": "BRAATAS, (Spanish) a small portion added to a purchase of food by a vendor to encourage the person to return, also BRAATA, BROUGHTA, BROUGHTAS [n]\n",
  "BRABBLE": "to squabble [v BRABBLED, BRABBLING, BRABBLES]\n",
  "BRABBLED": "BRABBLE, to squabble [v]\n",
  "BRABBLEMENT": "(archaic) a squabbling [n -S]\n",
  "BRABBLEMENTS": "BRABBLEMENT, (archaic) a squabbling [n]\n",
  "BRABBLER": "a clamorous, quarrelsome, noisy fellow [n -S]\n",
  "BRABBLERS": "BRABBLER, a clamorous, quarrelsome, noisy fellow [n]\n",
  "BRABBLES": "BRABBLE, to squabble [v]\n",
  "BRABBLING": "BRABBLE, to squabble [v]\n",
  "BRACCATE": "having feathered legs [adj]\n",
  "BRACCIA": "BRACCIO, (Italian) an Italian measure of length [n]\n",
  "BRACCIO": "(Italian) an Italian measure of length [n BRACCIA]\n",
  "BRACE": "to support [v BRACED, BRACING, BRACES]\n",
  "BRACED": "BRACE, to support [v]\n",
  "BRACELET": "an ornamental band or ring, for the wrist or the arm [n -S]\n",
  "BRACELETS": "BRACELET, an ornamental band or ring, for the wrist or the arm [n]\n",
  "BRACER": "an archer's leather arm protection [n -S]\n",
  "BRACERO": "(Spanish) a Mexican labourer [n -S]\n",
  "BRACEROS": "BRACERO, (Spanish) a Mexican labourer [n]\n",
  "BRACERS": "BRACER, an archer's leather arm protection [n]\n",
  "BRACES": "BRACE, to support [v]\n",
  "BRACH": "a female hunting hound, also BRACHET, BRATCHET [n BRACHES or BRACHS]\n",
  "BRACHAH": "(Hebrew) a blessing, also BROCHO [n BRACHAHS or BRACHOT]\n",
  "BRACHAHS": "BRACHAH, (Hebrew) a blessing, also BROCHO [n]\n",
  "BRACHES": "BRACH, a female hunting hound, also BRACHET, BRATCHET [n]\n",
  "BRACHET": "(Scots) a hunting dog, also BRACH, BRATCHET [n -S]\n",
  "BRACHETS": "BRACHET, (Scots) a hunting dog, also BRACH, BRATCHET [n]\n",
  "BRACHIA": "BRACHIUM, (Latin) the upper arm; the segment of the fore limb between the shoulder and the elbow [n]\n",
  "BRACHIAL": "pertaining or belonging to the arm [adj] / the brachial artery or nerve [n -S]\n",
  "BRACHIALS": "BRACHIAL, the brachial artery or nerve [n]\n",
  "BRACHIATE": "to progress by swinging hand over hand, like a gibbon [v BRACHIATED, BRACHIATING, BRACHIATES]\n",
  "BRACHIATED": "BRACHIATE, to progress by swinging hand over hand, like a gibbon [v]\n",
  "BRACHIATES": "BRACHIATE, to progress by swinging hand over hand, like a gibbon [v]\n",
  "BRACHIATING": "BRACHIATE, to progress by swinging hand over hand, like a gibbon [v]\n",
  "BRACHIATION": "the act of swinging by one's arms from place to place [n -S]\n",
  "BRACHIATIONS": "BRACHIATION, the act of swinging by one's arms from place to place [n]\n",
  "BRACHIATOR": "an animal, such as a gibbon, that progresses by brachiation [n -S]\n",
  "BRACHIATORS": "BRACHIATOR, an animal, such as a gibbon, that progresses by brachiation [n]\n",
  "BRACHIOCEPHALIC": "relating to the arms and head [adj]\n",
  "BRACHIOPOD": "a bivalve marine invertebrate [n -S]\n",
  "BRACHIOPODS": "BRACHIOPOD, a bivalve marine invertebrate [n]\n",
  "BRACHIOSAURUS": "any member of a genus of huge lizard-hipped plant-eating dinosaurs [n -ES]\n",
  "BRACHIOSAURUSES": "BRACHIOSAURUS, any member of a genus of huge lizard-hipped plant-eating dinosaurs [n]\n",
  "BRACHISTOCHRONE": "the curve along which a particle acted on by a force (e.g. gravity) will pass in the shortest time from one given point to another [n]\n",
  "BRACHIUM": "(Latin) the upper arm; the segment of the fore limb between the shoulder and the elbow [n BRACHIA or BRACHIUMS]\n",
  "BRACHIUMS": "BRACHIUM, (Latin) the upper arm; the segment of the fore limb between the shoulder and the elbow [n]\n",
  "BRACHOT": "BRACHAH, (Hebrew) a blessing, also BROCHO [n]\n",
  "BRACHS": "BRACH, a female hunting hound, also BRACHET, BRATCHET [n]\n",
  "BRACHYAXES": "BRACHYAXIS, in crystallography, the shorter lateral axis [n]\n",
  "BRACHYAXIS": "in crystallography, the shorter lateral axis [n BRACHYAXES]\n",
  "BRACHYCEPHAL": "a short-headed person [n -S]\n",
  "BRACHYCEPHALIC": "short-headed, esp. having a skull whose breadth is 80 per cent or more of its length [adj] / a short-headed person [n -S]\n",
  "BRACHYCEPHALICS": "BRACHYCEPHALIC, a short-headed person [n]\n",
  "BRACHYCEPHALIES": "BRACHYCEPHALY, the state of being brachycephalic, short-headed [n]\n",
  "BRACHYCEPHALISM": "the state of being brachycephalic, short-headed [n]\n",
  "BRACHYCEPHALOUS": "short-headed, esp. having a skull whose breadth is 80 per cent or more of its length [adj]\n",
  "BRACHYCEPHALS": "BRACHYCEPHAL, a short-headed person [n]\n",
  "BRACHYCEPHALY": "the state of being brachycephalic, short-headed [n BRACHYCEPHALIES]\n",
  "BRACHYCEROUS": "of insects, having short antennae [adj]\n",
  "BRACHYDACTYL": "having abnormally short fingers and toes, also BRACHYDACTYLIC [adj]\n",
  "BRACHYDACTYLIC": "having abnormally short fingers and toes, also BRACHYDACTYL [adj]\n",
  "BRACHYDACTYLIES": "BRACHYDACTYLY, abnormal shortness of fingers and toes [n]\n",
  "BRACHYDACTYLISM": "abnormal shortness of fingers and toes [n]\n",
  "BRACHYDACTYLOUS": "having short or stubby fingers [adj]\n",
  "BRACHYDACTYLY": "abnormal shortness of fingers and toes [n BRACHYDACTYLIES]\n",
  "BRACHYDIAGONAL": "in crystallography, the shorter lateral axis [n -S]\n",
  "BRACHYDIAGONALS": "BRACHYDIAGONAL, in crystallography, the shorter lateral axis [n]\n",
  "BRACHYDOME": "a dome parallel to the shorter lateral axis [n -S]\n",
  "BRACHYDOMES": "BRACHYDOME, a dome parallel to the shorter lateral axis [n]\n",
  "BRACHYGRAPHIES": "BRACHYGRAPHY, certain old systems of shorthand [n]\n",
  "BRACHYGRAPHY": "certain old systems of shorthand [n BRACHYGRAPHIES]\n",
  "BRACHYLOGIES": "BRACHYLOGY, brevity of diction, abbreviated or condensed expression [n]\n",
  "BRACHYLOGOUS": "condensed in expression [adj]\n",
  "BRACHYLOGY": "brevity of diction, abbreviated or condensed expression [n BRACHYLOGIES]\n",
  "BRACHYODONT": "of mammals, such as humans, having teeth with short crowns [adj]\n",
  "BRACHYPINAKOID": "a pinakoid or prism parallel to the brachydiagonal [n -S]\n",
  "BRACHYPINAKOIDS": "BRACHYPINAKOID, a pinakoid or prism parallel to the brachydiagonal [n]\n",
  "BRACHYPRISM": "a prism parallel to the brachydiagonal [n -S]\n",
  "BRACHYPRISMS": "BRACHYPRISM, a prism parallel to the brachydiagonal [n]\n",
  "BRACHYPTERISM": "the state of having abnormally short wings [n -S]\n",
  "BRACHYPTERISMS": "BRACHYPTERISM, the state of having abnormally short wings [n]\n",
  "BRACHYPTEROUS": "having short wings [adj]\n",
  "BRACHYTHERAPIES": "BRACHYTHERAPY, a medical procedure used in the treatment of prostate cancer [n]\n",
  "BRACHYTHERAPY": "a medical procedure used in the treatment of prostate cancer [n BRACHYTHERAPIES]\n",
  "BRACHYURAL": "relating to the Brachyura, a group of decapod crustaceans, also BRACHYUROUS [adj]\n",
  "BRACHYURAN": "any member of the Brachyura, a group of decapod crustaceans [n -S]\n",
  "BRACHYURANS": "BRACHYURAN, any member of the Brachyura, a group of decapod crustaceans [n]\n",
  "BRACHYUROUS": "relating to the Brachyura, a group of decapod crustaceans, also BRACHYURAL [adj]\n",
  "BRACING": "invigorating [adj BRACINGLY] / a reinforcement [n -S]\n",
  "BRACINGLY": "BRACING, invigorating [adv]\n",
  "BRACINGS": "BRACING, a reinforcement [n]\n",
  "BRACIOLA": "(Italian) a thin slice of meat, also BRACIOLE [n -S]\n",
  "BRACIOLAS": "BRACIOLA, (Italian) a thin slice of meat, also BRACIOLE [n]\n",
  "BRACIOLE": "(Italian) a thin slice of meat, also BRACIOLA [n -S]\n",
  "BRACIOLES": "BRACIOLE, (Italian) a thin slice of meat, also BRACIOLA [n]\n",
  "BRACK": "a flaw in cloth [n -S]\n",
  "BRACKEN": "a large fern [n -S]\n",
  "BRACKENS": "BRACKEN, a large fern [n]\n",
  "BRACKET": "to group, classify [v -ED, -ING, -S]\n",
  "BRACKETED": "BRACKET, to group, classify [v]\n",
  "BRACKETING": "the act of putting in brackets [n -S]\n",
  "BRACKETINGS": "BRACKETING, the act of putting in brackets [n]\n",
  "BRACKETS": "BRACKET, to group, classify [v]\n",
  "BRACKISH": "somewhat salty [adj]\n",
  "BRACKISHNESS": "the state of being brackish [n -ES]\n",
  "BRACKISHNESSES": "BRACKISHNESS, the state of being brackish [n]\n",
  "BRACKS": "BRACK, a flaw in cloth [n]\n",
  "BRACONID": "any of a family of parasitic wasps [n -S]\n",
  "BRACONIDS": "BRACONID, any of a family of parasitic wasps [n]\n",
  "BRACT": "any reduced leaflike structure associated with a cone or flower [n -S]\n",
  "BRACTEAL": "of a bract [adj]\n",
  "BRACTEATE": "thin beaten plate of gold or silver [n -S]\n",
  "BRACTEATES": "BRACTEATE, thin beaten plate of gold or silver [n]\n",
  "BRACTED": "having a bract [adj]\n",
  "BRACTEOLATE": "having bracteoles [adj]\n",
  "BRACTEOLE": "a small or secondary bract, also BRACTLET [n -S]\n",
  "BRACTEOLES": "BRACTEOLE, a small or secondary bract, also BRACTLET [n]\n",
  "BRACTLESS": "destitute of bracts [adj]\n",
  "BRACTLET": "a small leaf on the axis of a flower [n -S]\n",
  "BRACTLETS": "BRACTLET, a small leaf on the axis of a flower [n]\n",
  "BRACTS": "BRACT, any reduced leaflike structure associated with a cone or flower [n]\n",
  "BRAD": "to fasten with thin nails [v BRADDED, BRADDING, BRADS]\n",
  "BRADAWL": "a small boring tool [n -S]\n",
  "BRADAWLS": "BRADAWL, a small boring tool [n]\n",
  "BRADDED": "BRAD, to fasten with thin nails [v]\n",
  "BRADDING": "BRAD, to fasten with thin nails [v]\n",
  "BRADOON": "(French) a light military bridle, also BRIDOON [n -S]\n",
  "BRADOONS": "BRADOON, (French) a light military bridle, also BRIDOON [n]\n",
  "BRADS": "BRAD, to fasten with thin nails [v]\n",
  "BRADYCARDIA": "an abnormally slow heart rate [n -S]\n",
  "BRADYCARDIAC": "having an abnormally low rate of heartbeat [adj]\n",
  "BRADYCARDIAS": "BRADYCARDIA, an abnormally slow heart rate [n]\n",
  "BRADYKINESIA": "abnormal slowness of physical movement, esp. as a symptom of Parkinson's disease [n -S]\n",
  "BRADYKINESIAS": "BRADYKINESIA, abnormal slowness of physical movement, esp. as a symptom of Parkinson's disease [n]\n",
  "BRADYKININ": "a blood hormone causing dilation of blood vessels [n -S]\n",
  "BRADYKININS": "BRADYKININ, a blood hormone causing dilation of blood vessels [n]\n",
  "BRADYPEPTIC": "one who is slow of digestion [n -S]\n",
  "BRADYPEPTICS": "BRADYPEPTIC, one who is slow of digestion [n]\n",
  "BRADYSEISM": "a slow up-and-down movement of the earth's crust [n -S]\n",
  "BRADYSEISMS": "BRADYSEISM, a slow up-and-down movement of the earth's crust [n]\n",
  "BRAE": "(Scots) a steep bank beside a river valley [n -S]\n",
  "BRAEHEID": "(Scots) the summit of a hill [n -S]\n",
  "BRAEHEIDS": "BRAEHEID, (Scots) the summit of a hill [n]\n",
  "BRAES": "BRAE, (Scots) a steep bank beside a river valley [n]\n",
  "BRAG": "to boast [v BRAGGED, BRAGGING, BRAGS] / first-rate [adj BRAGGER, BRAGGEST, BRAGLY]\n",
  "BRAGADISME": "(Shakespeare) braggartism, boastfulness [n -S]\n",
  "BRAGADISMES": "BRAGADISME, (Shakespeare) braggartism, boastfulness [n]\n",
  "BRAGGADOCIO": "(Italian) swagger, braggartism [n -S]\n",
  "BRAGGADOCIOS": "BRAGGADOCIO, (Italian) swagger, braggartism [n]\n",
  "BRAGGADOCIOUS": "boastful [adj]\n",
  "BRAGGART": "a boaster [n -S]\n",
  "BRAGGARTISM": "boastfulness [n -S]\n",
  "BRAGGARTISMS": "BRAGGARTISM, boastfulness [n]\n",
  "BRAGGARTLIER": "BRAGGARTLY, like a braggart, boastful [adj]\n",
  "BRAGGARTLIEST": "BRAGGARTLY, like a braggart, boastful [adj]\n",
  "BRAGGARTLY": "like a braggart, boastful [adj BRAGGARTLIER, BRAGGARTLIEST]\n",
  "BRAGGARTS": "BRAGGART, a boaster [n]\n",
  "BRAGGED": "BRAG, to boast [v]\n",
  "BRAGGER": "one who brags [n -S]\n",
  "BRAGGERS": "BRAGGER, one who brags [n]\n",
  "BRAGGEST": "BRAG, first-rate [adj]\n",
  "BRAGGIER": "BRAGGY, tending to brag [adj]\n",
  "BRAGGIEST": "BRAGGY, tending to brag [adj]\n",
  "BRAGGING": "an act of bragging [n -S]\n",
  "BRAGGINGLY": "BRAGGING [adv]\n",
  "BRAGGINGS": "BRAGGING, an act of bragging [n]\n",
  "BRAGGY": "tending to brag [adj BRAGGIER, BRAGGIEST]\n",
  "BRAGLY": "(Spenser) proudly [adv]\n",
  "BRAGS": "BRAG, to boast [v]\n",
  "BRAHMA": "(Hindi) a large domestic fowl [n -S]\n",
  "BRAHMAN": "(Hindi) a member of the highest Hindu caste, also BRAHMIN [n -S]\n",
  "BRAHMANI": "(Hindi) a female member of the highest Hindu caste, also BRAHMIN [n -S]\n",
  "BRAHMANIS": "BRAHMANI, (Hindi) a female member of the highest Hindu caste, also BRAHMIN [n]\n",
  "BRAHMANISM": "the religious and social system of orthodox Hinduism, also BRAHMINISM [n -S]\n",
  "BRAHMANISMS": "BRAHMANISM, the religious and social system of orthodox Hinduism, also BRAHMINISM [n]\n",
  "BRAHMANIST": "a practitioner of brahmanism, also BRAHMINIST [n -S]\n",
  "BRAHMANISTS": "BRAHMANIST, a practitioner of brahmanism, also BRAHMINIST [n]\n",
  "BRAHMANS": "BRAHMAN, (Hindi) a member of the highest Hindu caste, also BRAHMIN [n]\n",
  "BRAHMAS": "BRAHMA, (Hindi) a large domestic fowl [n]\n",
  "BRAHMIN": "(Hindi) a member of the highest Hindu caste, also BRAHMAN [n -S]\n",
  "BRAHMINISM": "the religious and social system of orthodox Hinduism, also BRAHMANISM [n -S]\n",
  "BRAHMINISMS": "BRAHMINISM, the religious and social system of orthodox Hinduism, also BRAHMANISM [n]\n",
  "BRAHMINIST": "a practitioner of brahmanism, also BRAHMANIST [n -S]\n",
  "BRAHMINISTS": "BRAHMINIST, a practitioner of brahmanism, also BRAHMANIST [n]\n",
  "BRAHMINS": "BRAHMIN, (Hindi) a member of the highest Hindu caste, also BRAHMAN [n]\n",
  "BRAID": "broad [adj BRAIDER, BRAIDEST] / to form into a braid, a plait [v -ED, -ING, -S]\n",
  "BRAIDE": "(Shakespeare) dissembling, deceitful [adj]\n",
  "BRAIDED": "BRAID, to form into a braid, a plait [v]\n",
  "BRAIDER": "one who braids; a machine that braids [n -S]\n",
  "BRAIDERS": "BRAIDER, one who braids; a machine that braids [n]\n",
  "BRAIDEST": "BRAID, broad [adj]\n",
  "BRAIDING": "a piece of braided work [n -S]\n",
  "BRAIDINGS": "BRAIDING, a piece of braided work [n]\n",
  "BRAIDS": "BRAID, to form into a braid, a plait [v]\n",
  "BRAIL": "a line fastened to a sail [n -S] / to haul in a sail [v -ED, -ING, -S]\n",
  "BRAILED": "BRAIL, to haul in a sail [v]\n",
  "BRAILING": "BRAIL, to haul in a sail [v]\n",
  "BRAILLE": "to write in raised print for the blind [v BRAILLED, BRAILLING, BRAILLES]\n",
  "BRAILLED": "BRAILLE, to write in raised print for the blind [v]\n",
  "BRAILLER": "a Braille writing machine [n -S]\n",
  "BRAILLERS": "BRAILLER, a Braille writing machine [n]\n",
  "BRAILLES": "BRAILLE, to write in raised print for the blind [v]\n",
  "BRAILLEWRITER": "a machine for writing braille [n -S]\n",
  "BRAILLEWRITERS": "BRAILLEWRITER, a machine for writing braille [n]\n",
  "BRAILLING": "BRAILLE, to write in raised print for the blind [v]\n",
  "BRAILLIST": "one who uses braille, also BRAILLER [n -S]\n",
  "BRAILLISTS": "BRAILLIST, one who uses braille, also BRAILLER [n]\n",
  "BRAILS": "BRAIL, to haul in a sail [v]\n",
  "BRAIN": "to dash out the brains of [v -ED, -ING, -S]\n",
  "BRAINBOX": "a clever person [n -ES]\n",
  "BRAINBOXES": "BRAINBOX, a clever person [n]\n",
  "BRAINCASE": "the cranium [n -S]\n",
  "BRAINCASES": "BRAINCASE, the cranium [n]\n",
  "BRAINCHILD": "a product of one's creative imagination [n BRAINCHILDREN]\n",
  "BRAINCHILDREN": "BRAINCHILD, a product of one's creative imagination [n]\n",
  "BRAINDEAD": "dead as evidenced by the absence of electrical activity in the brain [adj]\n",
  "BRAINED": "BRAIN, to dash out the brains of [v]\n",
  "BRAINFART": "an idea expressed without much previous thought [n -S]\n",
  "BRAINFARTS": "BRAINFART, an idea expressed without much previous thought [n]\n",
  "BRAINFOOD": "any foodstuff containing nutrients thought to promote brain function, such as oily fish which is rich in omega-3 oils [n -S]\n",
  "BRAINFOODS": "BRAINFOOD, any foodstuff containing nutrients thought to promote brain function, such as oily fish which is rich in omega-3 oils [n]\n",
  "BRAINIAC": "a very intelligent person [n -S]\n",
  "BRAINIACS": "BRAINIAC, a very intelligent person [n]\n",
  "BRAINIER": "BRAINY, intelligent [adj]\n",
  "BRAINIEST": "BRAINY, intelligent [adj]\n",
  "BRAINILY": "BRAINY, intelligent [adv]\n",
  "BRAININESS": "the quality of being brainy [n -ES]\n",
  "BRAININESSES": "BRAININESS, the quality of being brainy [n]\n",
  "BRAINING": "BRAIN, to dash out the brains of [v]\n",
  "BRAINISH": "(Shakespeare) hotheaded, furious [adj]\n",
  "BRAINLESS": "without brains [adj BRAINLESSLY]\n",
  "BRAINLESSLY": "BRAINLESS, without brains [adv]\n",
  "BRAINLESSNESS": "BRAINLESS, without brains [n]\n",
  "BRAINLESSNESSES": "BRAINLESSNESS, BRAINLESS, without brains [n]\n",
  "BRAINPAN": "the upper part of the skull [n -S]\n",
  "BRAINPANS": "BRAINPAN, the upper part of the skull [n]\n",
  "BRAINPOWER": "intellectual ability [n -S]\n",
  "BRAINPOWERS": "BRAINPOWER, intellectual ability [n]\n",
  "BRAINS": "BRAIN, to dash out the brains of [v]\n",
  "BRAINSICK": "diseased in the understanding, deranged [adj BRAINSICKLY]\n",
  "BRAINSICKLY": "BRAINSICK, diseased in the understanding, deranged [adv]\n",
  "BRAINSICKNESS": "BRAINSICK, diseased in the understanding, deranged [n]\n",
  "BRAINSICKNESSES": "BRAINSICKNESS, BRAINSICK, diseased in the understanding, deranged [n]\n",
  "BRAINSTEM": "the stem of the brain [n -S]\n",
  "BRAINSTEMS": "BRAINSTEM, the stem of the brain [n]\n",
  "BRAINSTORM": "a sudden disturbance of the mind; a sudden inspiration [n -S] / to conduct a thinking session [v -ED, -ING, -S]\n",
  "BRAINSTORMED": "BRAINSTORM, to conduct a thinking session [v]\n",
  "BRAINSTORMER": "one who engages in brainstorming [n -S]\n",
  "BRAINSTORMERS": "BRAINSTORMER, one who engages in brainstorming [n]\n",
  "BRAINSTORMING": "the practice of thrashing out a problem, developing a strategy, etc. by intensive group discussion in which ideas are put forward in an extempore fashion [n -S]\n",
  "BRAINSTORMINGS": "BRAINSTORMING, the practice of thrashing out a problem, developing a strategy, etc. by intensive group discussion in which ideas are put forward in an extempore fashion [n]\n",
  "BRAINSTORMS": "BRAINSTORM, to conduct a thinking session [v]\n",
  "BRAINTEASER": "something (as a puzzle) that demands mental effort and acuity for its solution [n -S]\n",
  "BRAINTEASERS": "BRAINTEASER, something (as a puzzle) that demands mental effort and acuity for its solution [n]\n",
  "BRAINWASH": "to indoctrinate [v -ED, -ING, -ES]\n",
  "BRAINWASHED": "BRAINWASH, to indoctrinate [v]\n",
  "BRAINWASHER": "one who brainwashes [n -S]\n",
  "BRAINWASHERS": "BRAINWASHER, one who brainwashes [n]\n",
  "BRAINWASHES": "BRAINWASH, to indoctrinate [v]\n",
  "BRAINWASHING": "indoctrination [n -S]\n",
  "BRAINWASHINGS": "BRAINWASHING, indoctrination [n]\n",
  "BRAINWAVE": "a sudden good idea [n -S]\n",
  "BRAINWAVES": "BRAINWAVE, a sudden good idea [n]\n",
  "BRAINWORK": "work done with the brain [n -S]\n",
  "BRAINWORKS": "BRAINWORK, work done with the brain [n]\n",
  "BRAINY": "intelligent [adj BRAINIER, BRAINIEST, BRAINILY]\n",
  "BRAIRD": "(Scots) to sprout above ground, also BREER [v -ED, -ING, -S]\n",
  "BRAIRDED": "BRAIRD, (Scots) to sprout above ground, also BREER [v]\n",
  "BRAIRDING": "BRAIRD, (Scots) to sprout above ground, also BREER [v]\n",
  "BRAIRDS": "BRAIRD, (Scots) to sprout above ground, also BREER [v]\n",
  "BRAISE": "to cook slowly with a little liquid in a tightly closed vessel [v BRAISED, BRAISING, BRAISES]\n",
  "BRAISED": "BRAISE, to cook slowly with a little liquid in a tightly closed vessel [v]\n",
  "BRAISES": "BRAISE, to cook slowly with a little liquid in a tightly closed vessel [v]\n",
  "BRAISING": "BRAISE, to cook slowly with a little liquid in a tightly closed vessel [v]\n",
  "BRAIZE": "a marine fish, aka sea-bream or porgy [n -S]\n",
  "BRAIZES": "BRAIZE, a marine fish, aka sea-bream or porgy [n]\n",
  "BRAK": "(South African) a mongrel dog [n -S]\n",
  "BRAKE": "to slow down or stop [v BRAKED, BRAKING, BRAKES]\n",
  "BRAKEAGE": "the act of braking [n -S]\n",
  "BRAKEAGES": "BRAKEAGE, the act of braking [n]\n",
  "BRAKED": "BRAKE, to slow down or stop [v]\n",
  "BRAKELESS": "without brakes [adj]\n",
  "BRAKEMAN": "a man in charge of a brake or brakes [n BRAKEMEN]\n",
  "BRAKEMEN": "BRAKEMAN, a man in charge of a brake or brakes [n]\n",
  "BRAKES": "BRAKE, to slow down or stop [v]\n",
  "BRAKESMAN": "a pithead winch operator [n BRAKESMEN]\n",
  "BRAKESMEN": "BRAKESMAN, a pithead winch operator [n]\n",
  "BRAKIER": "BRAKY, abounding in shrubs or ferns [adj]\n",
  "BRAKIEST": "BRAKY, abounding in shrubs or ferns [adj]\n",
  "BRAKING": "the act of applying a brake [n -S]\n",
  "BRAKINGS": "BRAKING, the act of applying a brake [n]\n",
  "BRAKS": "BRAK, (South African) a mongrel dog [n]\n",
  "BRAKY": "abounding in shrubs or ferns [adj BRAKIER, BRAKIEST]\n",
  "BRALESS": "without a bra [adj]\n",
  "BRAMBLE": "to gather blackberries [v BRAMBLED, BRAMBLING, BRAMBLES]\n",
  "BRAMBLED": "BRAMBLE, to gather blackberries [v]\n",
  "BRAMBLES": "BRAMBLE, to gather blackberries [v]\n",
  "BRAMBLIER": "BRAMBLY, full of brambles [adj]\n",
  "BRAMBLIEST": "BRAMBLY, full of brambles [adj]\n",
  "BRAMBLING": "a bird of the finch family [n -S]\n",
  "BRAMBLINGS": "BRAMBLING, a bird of the finch family [n]\n",
  "BRAMBLY": "full of brambles [adj BRAMBLIER, BRAMBLIEST]\n",
  "BRAME": "(Spenser) a fierce longing [n -S]\n",
  "BRAMES": "BRAME, (Spenser) a fierce longing [n]\n",
  "BRAN": "to soak in water mixed with the outer coat of cereals [v BRANNED, BRANNING, BRANS]\n",
  "BRANCARD": "(French) a horse-litter [n -S]\n",
  "BRANCARDS": "BRANCARD, (French) a horse-litter [n]\n",
  "BRANCH": "to spread like a tree branch, also BRAUNCH [v -ED, -ING, -ES]\n",
  "BRANCHED": "BRANCH, to spread like a tree branch, also BRAUNCH [v]\n",
  "BRANCHER": "a young hawk or other bird when it leaves the nest and begins to take to the branches [n -S]\n",
  "BRANCHERIES": "BRANCHERY, a system of branches [n]\n",
  "BRANCHERS": "BRANCHER, a young hawk or other bird when it leaves the nest and begins to take to the branches [n]\n",
  "BRANCHERY": "a system of branches [n BRANCHERIES]\n",
  "BRANCHES": "BRANCH, to spread like a tree branch, also BRAUNCH [v]\n",
  "BRANCHIA": "(Latin) a gill [n BRANCHIAE]\n",
  "BRANCHIAE": "BRANCHIA, (Latin) a gill [n]\n",
  "BRANCHIAL": "of or relating to gills [adj]\n",
  "BRANCHIATE": "furnished with branchiae; as, branchiate segments [adj]\n",
  "BRANCHIER": "BRANCHY, having many branches [adj]\n",
  "BRANCHIEST": "BRANCHY, having many branches [adj]\n",
  "BRANCHING": "the formation of a branch [n -S]\n",
  "BRANCHINGS": "BRANCHING, the formation of a branch [n]\n",
  "BRANCHIOPOD": "any of a subclass of Crustacea with numerous flattened, leaf-shaped, lobed swimming-feet [n -S]\n",
  "BRANCHIOPODS": "BRANCHIOPOD, any of a subclass of Crustacea with numerous flattened, leaf-shaped, lobed swimming-feet [n]\n",
  "BRANCHIOSTEGAL": "of or relating to the operculum covering the gill slits of fish [adj]\n",
  "BRANCHLESS": "without branches [adj]\n",
  "BRANCHLET": "a little branch [n -S]\n",
  "BRANCHLETS": "BRANCHLET, a little branch [n]\n",
  "BRANCHLIKE": "like a branch [adj]\n",
  "BRANCHLINE": "a secondary line, usually of a railroad [n -S]\n",
  "BRANCHLINES": "BRANCHLINE, a secondary line, usually of a railroad [n]\n",
  "BRANCHY": "having many branches [adj BRANCHIER, BRANCHIEST]\n",
  "BRAND": "to mark with a hot iron [v -ED, -ING, -S]\n",
  "BRANDADE": "(French) a Provencal dish made with salt fish, olive oil, garlic and cream [n -S]\n",
  "BRANDADES": "BRANDADE, (French) a Provencal dish made with salt fish, olive oil, garlic and cream [n]\n",
  "BRANDED": "BRAND, to mark with a hot iron [v]\n",
  "BRANDER": "(Scots) a gridiron [n -S] / to cook on a gridiron [v -ED, -ING, -S]\n",
  "BRANDERED": "BRANDER, to cook on a gridiron [v]\n",
  "BRANDERING": "BRANDER, to cook on a gridiron [v]\n",
  "BRANDERS": "BRANDER, to cook on a gridiron [v]\n",
  "BRANDIED": "BRANDY, to mix with brandy (a liquor) [v]\n",
  "BRANDIES": "BRANDY, to mix with brandy (a liquor) [v]\n",
  "BRANDING": "the promoting of a product by associating it with a brand name [n -S]\n",
  "BRANDINGS": "BRANDING, the promoting of a product by associating it with a brand name [n]\n",
  "BRANDISE": "a trivet [n -S]\n",
  "BRANDISES": "BRANDISE, a trivet [n]\n",
  "BRANDISH": "to move or wave, esp. a weapon [v -ED, -ING, -ES]\n",
  "BRANDISHED": "BRANDISH, to move or wave, esp. a weapon [v]\n",
  "BRANDISHER": "one who brandishes [n -S]\n",
  "BRANDISHERS": "BRANDISHER, one who brandishes [n]\n",
  "BRANDISHES": "BRANDISH, to move or wave, esp. a weapon [v]\n",
  "BRANDISHING": "BRANDISH, to move or wave, esp. a weapon [v]\n",
  "BRANDLESS": "without a brand [adj]\n",
  "BRANDLING": "a striped earthworm used as fishing bait [n -S]\n",
  "BRANDLINGS": "BRANDLING, a striped earthworm used as fishing bait [n]\n",
  "BRANDRETH": "a stand of wood for a cask or hayrick [n -S]\n",
  "BRANDRETHS": "BRANDRETH, a stand of wood for a cask or hayrick [n]\n",
  "BRANDS": "BRAND, to mark with a hot iron [v]\n",
  "BRANDY": "to mix with brandy (a liquor) [v BRANDIED, BRANDYING, BRANDIES]\n",
  "BRANDYING": "BRANDY, to mix with brandy (a liquor) [v]\n",
  "BRANE": "a multidimensional surface embedded in a space with extra dimensions [n -S]\n",
  "BRANES": "BRANE, a multidimensional surface embedded in a space with extra dimensions [n]\n",
  "BRANFULNESS": "the state of being full of bran [n -ES]\n",
  "BRANFULNESSES": "BRANFULNESS, the state of being full of bran [n]\n",
  "BRANGLE": "to wrangle [v BRANGLED, BRANGLING, BRANGLES]\n",
  "BRANGLED": "BRANGLE, to wrangle [v]\n",
  "BRANGLES": "BRANGLE, to wrangle [v]\n",
  "BRANGLING": "the act of wrangling [n -S]\n",
  "BRANGLINGS": "BRANGLING, the act of wrangling [n]\n",
  "BRANK": "(Scots) to prance, toss the head [v -ED, -ING, -S]\n",
  "BRANKED": "BRANK, (Scots) to prance, toss the head [v]\n",
  "BRANKIER": "BRANKY, (Scots) showy [adj]\n",
  "BRANKIEST": "BRANKY, (Scots) showy [adj]\n",
  "BRANKING": "BRANK, (Scots) to prance, toss the head [v]\n",
  "BRANKS": "BRANK, (Scots) to prance, toss the head [v]\n",
  "BRANKURSINE": "acanthus, or bear's-breech [n -S]\n",
  "BRANKURSINES": "BRANKURSINE, acanthus, or bear's-breech [n]\n",
  "BRANKY": "(Scots) showy [adj BRANKIER, BRANKIEST]\n",
  "BRANLE": "(French) an old French dance, also BRANSLE, BRANTLE [n -S]\n",
  "BRANLES": "BRANLE, (French) an old French dance, also BRANSLE, BRANTLE [n]\n",
  "BRANNED": "BRAN, to soak in water mixed with the outer coat of cereals [v]\n",
  "BRANNER": "one that brans [n -S]\n",
  "BRANNERS": "BRANNER, one that brans [n]\n",
  "BRANNIER": "BRANNY, containing bran [adj]\n",
  "BRANNIEST": "BRANNY, containing bran [adj]\n",
  "BRANNIGAN": "a drinking spree; a noisy altercation or quarrel [n -S]\n",
  "BRANNIGANS": "BRANNIGAN, a drinking spree; a noisy altercation or quarrel [n]\n",
  "BRANNING": "BRAN, to soak in water mixed with the outer coat of cereals [v]\n",
  "BRANNY": "containing bran [adj BRANNIER, BRANNIEST]\n",
  "BRANS": "BRAN, to soak in water mixed with the outer coat of cereals [v]\n",
  "BRANSLE": "(French) an old French dance, also BRANLE, BRANTLE [n -S]\n",
  "BRANSLES": "BRANSLE, (French) an old French dance, also BRANLE, BRANTLE [n]\n",
  "BRANT": "a wild goose, also BRENT [n -S]\n",
  "BRANTAIL": "the redstart, so called from the red color of its tail [n -S]\n",
  "BRANTAILS": "BRANTAIL, the redstart, so called from the red color of its tail [n]\n",
  "BRANTLE": "(French) an old French dance, also BRANSLE, BRANLE [n -S]\n",
  "BRANTLES": "BRANTLE, (French) an old French dance, also BRANSLE, BRANLE [n]\n",
  "BRANTS": "BRANT, a wild goose, also BRENT [n]\n",
  "BRAP": "an exclamation used to imitate the sound of a burst of gunfire from an automatic weapon [interj]\n",
  "BRAS": "(Spenser) brass [n -ES]\n",
  "BRASCO": "(Australian slang) a lavatory [n -S]\n",
  "BRASCOS": "BRASCO, (Australian slang) a lavatory [n]\n",
  "BRASERO": "(Spanish) a brazier; a place where criminals and heretics are burned [n -S]\n",
  "BRASEROS": "BRASERO, (Spanish) a brazier; a place where criminals and heretics are burned [n]\n",
  "BRASES": "BRAS, (Spenser) brass [n]\n",
  "BRASH": "forward, overconfident [adj BRASHER, BRASHEST, BRASHLY] / (obsolete) to attack [v -ED, -ING, -ES]\n",
  "BRASHED": "BRASH, (obsolete) to attack [v]\n",
  "BRASHER": "BRASH, forward, overconfident [adj]\n",
  "BRASHES": "BRASH, (obsolete) to attack [v]\n",
  "BRASHEST": "BRASH, forward, overconfident [adj]\n",
  "BRASHIER": "BRASHY, covered with brash, fragments of rock or ice [adj]\n",
  "BRASHIEST": "BRASHY, covered with brash, fragments of rock or ice [adj]\n",
  "BRASHINESS": "the state of being brashy [n -ES]\n",
  "BRASHINESSES": "BRASHINESS, the state of being brashy [n]\n",
  "BRASHING": "BRASH, (obsolete) to attack [v]\n",
  "BRASHLY": "BRASH, forward, overconfident [adv]\n",
  "BRASHNESS": "the state of being brash, over-confident [n -ES]\n",
  "BRASHNESSES": "BRASHNESS, the state of being brash, over-confident [n]\n",
  "BRASHY": "covered with brash, fragments of rock or ice [adj BRASHIER, BRASHIEST]\n",
  "BRASIER": "one who works in brass [n -S]\n",
  "BRASIERS": "BRASIER, one who works in brass [n]\n",
  "BRASIL": "an oily, three-sided nut, the seed of the Bertholletia excelsa [n -S]\n",
  "BRASILEIN": "a dyestuff obtained by the oxidation of brasilin, also BRASILIN, BRAZILEIN, BRAZILIN [n -S]\n",
  "BRASILEINS": "BRASILEIN, a dyestuff obtained by the oxidation of brasilin, also BRASILIN, BRAZILEIN, BRAZILIN [n]\n",
  "BRASILIN": "a dyestuff obtained from brazilwood, also BRASILEIN, BRAZILEIN, BRAZILIN [n -S]\n",
  "BRASILINS": "BRASILIN, a dyestuff obtained from brazilwood, also BRASILEIN, BRAZILEIN, BRAZILIN [n]\n",
  "BRASILS": "BRASIL, an oily, three-sided nut, the seed of the Bertholletia excelsa [n]\n",
  "BRASS": "to coat with an alloy of copper and zinc [v -ED, -ING, -ES]\n",
  "BRASSAGE": "(French) a mint-charge to cover the cost of coining money [n -S]\n",
  "BRASSAGES": "BRASSAGE, (French) a mint-charge to cover the cost of coining money [n]\n",
  "BRASSARD": "(French) a piece of armour for the upper arm, also BRASSART, BRASSET [n -S]\n",
  "BRASSARDS": "BRASSARD, (French) a piece of armour for the upper arm, also BRASSART, BRASSET [n]\n",
  "BRASSART": "(historical) a piece of armour for the upper arm, also BRASSARD, BRASSET [n -S]\n",
  "BRASSARTS": "BRASSART, (historical) a piece of armour for the upper arm, also BRASSARD, BRASSET [n]\n",
  "BRASSBOUND": "covered with brass e.g. a chest [adj]\n",
  "BRASSED": "BRASS, to coat with an alloy of copper and zinc [v]\n",
  "BRASSERIE": "(French) a restaurant serving alcoholic beverages, esp. beer, as well as food [n -S]\n",
  "BRASSERIES": "BRASSERIE, (French) a restaurant serving alcoholic beverages, esp. beer, as well as food [n]\n",
  "BRASSES": "BRASS, to coat with an alloy of copper and zinc [v]\n",
  "BRASSET": "a piece of armour for the arm [n -S]\n",
  "BRASSETS": "BRASSET, a piece of armour for the arm [n]\n",
  "BRASSFOUNDER": "a person who casts objects in brass [n -S]\n",
  "BRASSFOUNDERS": "BRASSFOUNDER, a person who casts objects in brass [n]\n",
  "BRASSFOUNDING": "the craft of casting objects in brass [n -S]\n",
  "BRASSFOUNDINGS": "BRASSFOUNDING, the craft of casting objects in brass [n]\n",
  "BRASSICA": "(Latin) a plant of the turnip and cabbage genus [n -S]\n",
  "BRASSICACEOUS": "belonging to the brassica family [adj]\n",
  "BRASSICAS": "BRASSICA, (Latin) a plant of the turnip and cabbage genus [n]\n",
  "BRASSIE": "a golf club [n -S]\n",
  "BRASSIER": "BRASSY, resembling brass [adj]\n",
  "BRASSIERE": "(French) a woman's undergarment worn to support the breasts [n -S]\n",
  "BRASSIERES": "BRASSIERE, (French) a woman's undergarment worn to support the breasts [n]\n",
  "BRASSIES": "BRASSIE, a golf club [n]\n",
  "BRASSIEST": "BRASSY, resembling brass [adj]\n",
  "BRASSILY": "BRASSY, resembling brass [adv]\n",
  "BRASSINESS": "the quality of being brassy [n -ES]\n",
  "BRASSINESSES": "BRASSINESS, the quality of being brassy [n]\n",
  "BRASSING": "BRASS, to coat with an alloy of copper and zinc [v]\n",
  "BRASSISH": "like brass [adj]\n",
  "BRASSWARE": "goods made of brass [n -S]\n",
  "BRASSWARES": "BRASSWARE, goods made of brass [n]\n",
  "BRASSY": "resembling brass [adj BRASSIER, BRASSIEST, BRASSILY]\n",
  "BRAST": "(dialect) to break open violently, also BURST, BRUST [v BRAST, BRASTING, BRASTS]\n",
  "BRASTING": "BRAST, (dialect) to break open violently, also BURST, BRUST [v]\n",
  "BRASTS": "BRAST, (dialect) to break open violently, also BURST, BRUST [v]\n",
  "BRAT": "a badly behaved child [n -S]\n",
  "BRATCHET": "(Scots) a hunting dog, also BRACH, BRACHET [n -S]\n",
  "BRATCHETS": "BRATCHET, (Scots) a hunting dog, also BRACH, BRACHET [n]\n",
  "BRATLING": "a little brat [n -S]\n",
  "BRATLINGS": "BRATLING, a little brat [n]\n",
  "BRATPACK": "a clique of rowdy film stars [n -S]\n",
  "BRATPACKER": "a member of a bratpack [n -S]\n",
  "BRATPACKERS": "BRATPACKER, a member of a bratpack [n]\n",
  "BRATPACKS": "BRATPACK, a clique of rowdy film stars [n]\n",
  "BRATS": "BRAT, a badly behaved child [n]\n",
  "BRATTICE": "a wooden tower used in mediaeval siege operations [n -S] / to provide with a brattice, also BRATTISH, BRETTICE [v BRATTICED, BRATTICING, BRATTICES]\n",
  "BRATTICED": "BRATTICE, to provide with a brattice, also BRATTISH, BRETTICE [v]\n",
  "BRATTICES": "BRATTICE, to provide with a brattice, also BRATTISH, BRETTICE [v]\n",
  "BRATTICING": "work in the form of brattices; cresting or ornamental work along a ridge [n -S]\n",
  "BRATTICINGS": "BRATTICING, work in the form of brattices; cresting or ornamental work along a ridge [n]\n",
  "BRATTIER": "BRATTY, like a brat, spoilt [adj]\n",
  "BRATTIEST": "BRATTY, like a brat, spoilt [adj]\n",
  "BRATTINESS": "the state of being bratty [n -ES]\n",
  "BRATTINESSES": "BRATTINESS, the state of being bratty [n]\n",
  "BRATTISH": "a wooden tower used in mediaeval siege operations [n -ES] / to provide with a brattish [v -ED, -ING, -ES]\n",
  "BRATTISHED": "BRATTISH, to provide with a brattish [v]\n",
  "BRATTISHES": "BRATTISH, to provide with a brattish [v]\n",
  "BRATTISHING": "work in the form of brattices; cresting or ornamental work along a ridge [n -S]\n",
  "BRATTISHINGS": "BRATTISHING, work in the form of brattices; cresting or ornamental work along a ridge [n]\n",
  "BRATTLE": "(Scots) to rush noisily [v BRATTLED, BRATTLING, BRATTLES]\n",
  "BRATTLED": "BRATTLE, (Scots) to rush noisily [v]\n",
  "BRATTLES": "BRATTLE, (Scots) to rush noisily [v]\n",
  "BRATTLING": "a clattering noise [n -S]\n",
  "BRATTLINGS": "BRATTLING, a clattering noise [n]\n",
  "BRATTY": "like a brat, spoilt [adj BRATTIER, BRATTIEST]\n",
  "BRATWURST": "(German) a type of German sausage [n -S]\n",
  "BRATWURSTS": "BRATWURST, (German) a type of German sausage [n]\n",
  "BRAUNCH": "to spread like a tree branch, also BRANCH [v -ED, -ING, -ES]\n",
  "BRAUNCHED": "BRAUNCH, to spread like a tree branch, also BRANCH [v]\n",
  "BRAUNCHES": "BRAUNCH, to spread like a tree branch, also BRANCH [v]\n",
  "BRAUNCHING": "BRAUNCH, to spread like a tree branch, also BRANCH [v]\n",
  "BRAUNITE": "a native oxide of manganese, of dark brownish black color [n -S]\n",
  "BRAUNITES": "BRAUNITE, a native oxide of manganese, of dark brownish black color [n]\n",
  "BRAUNSCHWEIGER": "(German) smoked liverwurst [n -S]\n",
  "BRAUNSCHWEIGERS": "BRAUNSCHWEIGER, (German) smoked liverwurst [n]\n",
  "BRAVA": "(Italian) a shout of approval to a woman [n -S]\n",
  "BRAVADO": "(Spanish) to display bravery [v -ED, -ING, -S] / a display of bravery [n BRAVADOS or BRAVADOES]\n",
  "BRAVADOED": "BRAVADO, (Spanish) to display bravery [v]\n",
  "BRAVADOES": "BRAVADO, (Spanish) to display bravery [v]\n",
  "BRAVADOING": "BRAVADO, (Spanish) to display bravery [v]\n",
  "BRAVADOS": "BRAVADO, (Spanish) to display bravery [v]\n",
  "BRAVAS": "BRAVA, (Italian) a shout of approval to a woman [n]\n",
  "BRAVE": "to face with courage [v BRAVED, BRAVING, BRAVES] / showing courage [adj BRAVER, BRAVEST, BRAVELY]\n",
  "BRAVED": "BRAVE, to face with courage [v]\n",
  "BRAVELY": "BRAVE, showing courage [adv]\n",
  "BRAVENESS": "the state of being brave [n -ES]\n",
  "BRAVENESSES": "BRAVENESS, the state of being brave [n]\n",
  "BRAVER": "one who braves [n -S]\n",
  "BRAVERIES": "BRAVERY, courage [n]\n",
  "BRAVERS": "BRAVER, one who braves [n]\n",
  "BRAVERY": "courage [n BRAVERIES]\n",
  "BRAVES": "BRAVE, to face with courage [v]\n",
  "BRAVEST": "BRAVE, showing courage [adj]\n",
  "BRAVI": "(Italian) bravo, when addressed to a number of people [interj]\n",
  "BRAVING": "BRAVE, to face with courage [v]\n",
  "BRAVISSIMO": "(Italian) very well done! excellent! [interj]\n",
  "BRAVO": "(Italian) to applaud by shouting \"bravo\" [v -ED, -ING, -S] / a hired killer [n BRAVOS or BRAVOES]\n",
  "BRAVOED": "BRAVO, (Italian) to applaud by shouting \"bravo\" [v]\n",
  "BRAVOES": "BRAVO, a hired killer [n]\n",
  "BRAVOING": "BRAVO, (Italian) to applaud by shouting \"bravo\" [v]\n",
  "BRAVOS": "BRAVO, (Italian) to applaud by shouting \"bravo\" [v]\n",
  "BRAVURA": "(Italian) a brilliant display of musical technique [n BRAVURAS or BRAVURE]\n",
  "BRAVURAS": "BRAVURA, (Italian) a brilliant display of musical technique [n]\n",
  "BRAVURE": "BRAVURA, (Italian) a brilliant display of musical technique [n]\n",
  "BRAW": "(Scots) fine, brave [adj BRAWER, BRAWEST, BRAWLY]\n",
  "BRAWER": "BRAW, (Scots) fine, brave [adj]\n",
  "BRAWEST": "BRAW, (Scots) fine, brave [adj]\n",
  "BRAWL": "to fight rowdily [v -ED, -ING, -S]\n",
  "BRAWLED": "BRAWL, to fight rowdily [v]\n",
  "BRAWLER": "a fighter [n -S]\n",
  "BRAWLERS": "BRAWLER, a fighter [n]\n",
  "BRAWLIE": "(Scots) in a fine manner [adv]\n",
  "BRAWLIER": "BRAWLIE, (Scots) in a fine manner [adv]\n",
  "BRAWLIEST": "BRAWLIE, (Scots) in a fine manner [adv]\n",
  "BRAWLING": "rowdy fighting [n -S]\n",
  "BRAWLINGS": "BRAWLING, rowdy fighting [n]\n",
  "BRAWLS": "BRAWL, to fight rowdily [v]\n",
  "BRAWLY": "(US) inclined to brawl [adj BRAWLIER, BRAWLIEST]\n",
  "BRAWN": "muscular strength [n -S]\n",
  "BRAWNED": "brawny; muscular [adj]\n",
  "BRAWNIER": "BRAWNY, strongly built [adj]\n",
  "BRAWNIEST": "BRAWNY, strongly built [adj]\n",
  "BRAWNILY": "BRAWNY, strongly built [adv]\n",
  "BRAWNINESS": "the state of being brawny [n -ES]\n",
  "BRAWNINESSES": "BRAWNINESS, the state of being brawny [n]\n",
  "BRAWNS": "BRAWN, muscular strength [n]\n",
  "BRAWNY": "strongly built [adj BRAWNIER, BRAWNIEST, BRAWNILY]\n",
  "BRAWS": "(Scots) fine clothes [n]\n",
  "BRAXIES": "BRAXY, a bacterial disease of sheep [n]\n",
  "BRAXY": "a bacterial disease of sheep [n BRAXIES]\n",
  "BRAY": "to cry like an ass [v -ED, -ING, -S]\n",
  "BRAYED": "BRAY, to cry like an ass [v]\n",
  "BRAYER": "an instrument for spreading ink in printing [n -S]\n",
  "BRAYERS": "BRAYER, an instrument for spreading ink in printing [n]\n",
  "BRAYING": "BRAY, to cry like an ass [v]\n",
  "BRAYS": "BRAY, to cry like an ass [v]\n",
  "BRAZA": "(Spanish) a Spanish unit of length [n -S]\n",
  "BRAZAS": "BRAZA, (Spanish) a Spanish unit of length [n]\n",
  "BRAZE": "to solder with an alloy of copper and zinc [v BRAZED, BRAZING, BRAZES]\n",
  "BRAZED": "BRAZE, to solder with an alloy of copper and zinc [v]\n",
  "BRAZELESS": "without soldering [adj]\n",
  "BRAZEN": "impudent [adj BRAZENLY] / to face boldly [v -ED, -ING, -S]\n",
  "BRAZENED": "BRAZEN, to face boldly [v]\n",
  "BRAZENING": "BRAZEN, to face boldly [v]\n",
  "BRAZENLY": "BRAZEN, impudent [adv]\n",
  "BRAZENNESS": "the state of being brazen [n -ES]\n",
  "BRAZENNESSES": "BRAZENNESS, the state of being brazen [n]\n",
  "BRAZENRIES": "BRAZENRY, effrontery [n]\n",
  "BRAZENRY": "effrontery [n BRAZENRIES]\n",
  "BRAZENS": "BRAZEN, to face boldly [v]\n",
  "BRAZER": "one that brazes [n -S]\n",
  "BRAZERS": "BRAZER, one that brazes [n]\n",
  "BRAZES": "BRAZE, to solder with an alloy of copper and zinc [v]\n",
  "BRAZIER": "a container for hot coals [n -S]\n",
  "BRAZIERIES": "BRAZIERY, a place where brass is worked [n]\n",
  "BRAZIERS": "BRAZIER, a container for hot coals [n]\n",
  "BRAZIERY": "a place where brass is worked [n BRAZIERIES]\n",
  "BRAZIL": "the hard reddish wood of the East Indian sappan tree [n -S]\n",
  "BRAZILEIN": "a dyestuff obtained by the oxidation of brazilin, also BRASILEIN, BRASILIN, BRAZILIN [n -S]\n",
  "BRAZILEINS": "BRAZILEIN, a dyestuff obtained by the oxidation of brazilin, also BRASILEIN, BRASILIN, BRAZILIN [n]\n",
  "BRAZILIN": "a dyestuff obtained from brazilwood, also BRASILEIN, BRASILIN, BRAZILEIN [n -S]\n",
  "BRAZILINS": "BRAZILIN, a dyestuff obtained from brazilwood, also BRASILEIN, BRASILIN, BRAZILEIN [n]\n",
  "BRAZILS": "BRAZIL, the hard reddish wood of the East Indian sappan tree [n]\n",
  "BRAZILWOOD": "a red tropical wood [n -S]\n",
  "BRAZILWOODS": "BRAZILWOOD, a red tropical wood [n]\n",
  "BRAZING": "BRAZE, to solder with an alloy of copper and zinc [v]\n",
  "BREACH": "to break through [v -ED, -ING, -ES]\n",
  "BREACHED": "BREACH, to break through [v]\n",
  "BREACHER": "one who breaches [n -S]\n",
  "BREACHERS": "BREACHER, one who breaches [n]\n",
  "BREACHES": "BREACH, to break through [v]\n",
  "BREACHING": "BREACH, to break through [v]\n",
  "BREAD": "to cover with breadcrumbs [v -ED, -ING, -S]\n",
  "BREADBASKET": "(colloquial) the stomach [n -S]\n",
  "BREADBASKETS": "BREADBASKET, (colloquial) the stomach [n]\n",
  "BREADBERRIES": "BREADBERRY, bread steeped in hot milk [n]\n",
  "BREADBERRY": "bread steeped in hot milk [n BREADBERRIES]\n",
  "BREADBIN": "a household container for bread, usually quite small [n -S]\n",
  "BREADBINS": "BREADBIN, a household container for bread, usually quite small [n]\n",
  "BREADBOARD": "to make an experimental version of (an electronic circuit) [v -ED, -ING, -S]\n",
  "BREADBOARDED": "BREADBOARD, to make an experimental version of (an electronic circuit) [v]\n",
  "BREADBOARDING": "BREADBOARD, to make an experimental version of (an electronic circuit) [v]\n",
  "BREADBOARDS": "BREADBOARD, to make an experimental version of (an electronic circuit) [v]\n",
  "BREADBOX": "a container for bread [n -ES]\n",
  "BREADBOXES": "BREADBOX, a container for bread [n]\n",
  "BREADCRUMB": "bread crumbled down, e.g. as a dressing [n -S] / to cover with breadcrumbs [v -ED, -ING, -S]\n",
  "BREADCRUMBED": "BREADCRUMB, to cover with breadcrumbs [v]\n",
  "BREADCRUMBING": "BREADCRUMB, to cover with breadcrumbs [v]\n",
  "BREADCRUMBS": "BREADCRUMB, bread crumbled down, e.g. as a dressing [n]\n",
  "BREADED": "BREAD, to cover with breadcrumbs [v]\n",
  "BREADFRUIT": "a fruit found in the Pacific [n -S]\n",
  "BREADFRUITS": "BREADFRUIT, a fruit found in the Pacific [n]\n",
  "BREADHEAD": "a drug-dealer who is not an addict, but is motivated by money alone [n -S]\n",
  "BREADHEADS": "BREADHEAD, a drug-dealer who is not an addict, but is motivated by money alone [n]\n",
  "BREADIER": "BREADY, resembling bread [adj]\n",
  "BREADIEST": "BREADY, resembling bread [adj]\n",
  "BREADING": "BREAD, to cover with breadcrumbs [v]\n",
  "BREADKNIFE": "a knife for cutting bread [n BREADKNIVES]\n",
  "BREADKNIVES": "BREADKNIFE, a knife for cutting bread [n]\n",
  "BREADLESS": "without bread [adj]\n",
  "BREADLIKE": "like bread [adj]\n",
  "BREADLINE": "the threshold of poverty [n -S]\n",
  "BREADLINES": "BREADLINE, the threshold of poverty [n]\n",
  "BREADNUT": "a tropical fruit [n -S]\n",
  "BREADNUTS": "BREADNUT, a tropical fruit [n]\n",
  "BREADROOM": "an apartment in a ship's hold where the bread is kept [n -S]\n",
  "BREADROOMS": "BREADROOM, an apartment in a ship's hold where the bread is kept [n]\n",
  "BREADROOT": "the edible root of a leguminous plant, found near the Rocky Mountains, aka prairie turnip [n -S]\n",
  "BREADROOTS": "BREADROOT, the edible root of a leguminous plant, found near the Rocky Mountains, aka prairie turnip [n]\n",
  "BREADS": "BREAD, to cover with breadcrumbs [v]\n",
  "BREADSTICK": "a stick of bread [n -S]\n",
  "BREADSTICKS": "BREADSTICK, a stick of bread [n]\n",
  "BREADSTUFF": "grain, flour, or meal of which bread is made [n -S]\n",
  "BREADSTUFFS": "BREADSTUFF, grain, flour, or meal of which bread is made [n]\n",
  "BREADTH": "width [n -S]\n",
  "BREADTHS": "BREADTH, width [n]\n",
  "BREADTHWAYS": "in terms of breadth, broadside on, also BREADTHWISE [adv]\n",
  "BREADTHWISE": "in terms of breadth, broadside on, also BREADTHWAYS [adv]\n",
  "BREADWINNER": "the person who earns a living for a family [n -S]\n",
  "BREADWINNERS": "BREADWINNER, the person who earns a living for a family [n]\n",
  "BREADWINNING": "the act of earning a living [n -S]\n",
  "BREADWINNINGS": "BREADWINNING, the act of earning a living [n]\n",
  "BREADY": "resembling bread [adj BREADIER, BREADIEST]\n",
  "BREAK": "to shatter or damage [v BROKE, BROKEN, BREAKING, BREAKS]\n",
  "BREAKABLE": "that can be broken [adj] / something that can be broken [n -S]\n",
  "BREAKABLENESS": "BREAKABLE, that can be broken [n]\n",
  "BREAKABLENESSES": "BREAKABLENESS, BREAKABLE, that can be broken [n]\n",
  "BREAKABLES": "BREAKABLE, something that can be broken [n]\n",
  "BREAKAGE": "the act of breaking [n -S]\n",
  "BREAKAGES": "BREAKAGE, the act of breaking [n]\n",
  "BREAKAWAY": "a revolt, a defection [n -S]\n",
  "BREAKAWAYS": "BREAKAWAY, a revolt, a defection [n]\n",
  "BREAKBACK": "crushing [adj]\n",
  "BREAKBEAT": "in house music, a short sample of drum beats taken from old soul or jazz records [n -S]\n",
  "BREAKBEATS": "BREAKBEAT, in house music, a short sample of drum beats taken from old soul or jazz records [n]\n",
  "BREAKBONE": "as in breakbone fever, aka dengue [adj]\n",
  "BREAKDANCE": "to do a breakdance, an energetic form of dance to rock or disco [v BREAKDANCED, BREAKDANCING, BREAKDANCES]\n",
  "BREAKDANCED": "BREAKDANCE, to do a breakdance, an energetic form of dance to rock or disco [v]\n",
  "BREAKDANCER": "one who does breakdancing [n -S]\n",
  "BREAKDANCERS": "BREAKDANCER, one who does breakdancing [n]\n",
  "BREAKDANCES": "BREAKDANCE, to do a breakdance, an energetic form of dance to rock or disco [v]\n",
  "BREAKDANCING": "a type of vigorous dance [n -S]\n",
  "BREAKDANCINGS": "BREAKDANCING, a type of vigorous dance [n]\n",
  "BREAKDOWN": "a collapse, a failure [n -S]\n",
  "BREAKDOWNS": "BREAKDOWN, a collapse, a failure [n]\n",
  "BREAKER": "one that breaks [n -S]\n",
  "BREAKERS": "BREAKER, one that breaks [n]\n",
  "BREAKEVEN": "the point at which revenue equals costs [n -S]\n",
  "BREAKEVENS": "BREAKEVEN, the point at which revenue equals costs [n]\n",
  "BREAKFAST": "the first meal of the day [n -S] / to take breakfast [v -ED, -ING, -S]\n",
  "BREAKFASTED": "BREAKFAST, to take breakfast [v]\n",
  "BREAKFASTER": "one who takes breakfast [n -S]\n",
  "BREAKFASTERS": "BREAKFASTER, one who takes breakfast [n]\n",
  "BREAKFASTING": "BREAKFAST, to take breakfast [v]\n",
  "BREAKFASTS": "BREAKFAST, to take breakfast [v]\n",
  "BREAKFRONT": "a kind of cabinet with center beyond ends [n -S]\n",
  "BREAKFRONTS": "BREAKFRONT, a kind of cabinet with center beyond ends [n]\n",
  "BREAKING": "the act of breaking [n -S]\n",
  "BREAKINGS": "BREAKING, the act of breaking [n]\n",
  "BREAKNECK": "at full speed [adj]\n",
  "BREAKOFF": "an act of breaking off or stopping [n -S]\n",
  "BREAKOFFS": "BREAKOFF, an act of breaking off or stopping [n]\n",
  "BREAKOUT": "an escape [n -S]\n",
  "BREAKOUTS": "BREAKOUT, an escape [n]\n",
  "BREAKPOINT": "a point at tennis that if won gives the player a service break [n -S]\n",
  "BREAKPOINTS": "BREAKPOINT, a point at tennis that if won gives the player a service break [n]\n",
  "BREAKS": "BREAK, to shatter or damage [v]\n",
  "BREAKTHROUGH": "an offensive thrust that penetrates and carries beyond a defensive line in warfare [n -S]\n",
  "BREAKTHROUGHS": "BREAKTHROUGH, an offensive thrust that penetrates and carries beyond a defensive line in warfare [n]\n",
  "BREAKTIME": "in schools etc., a recess, a break between lessons [n -S]\n",
  "BREAKTIMES": "BREAKTIME, in schools etc., a recess, a break between lessons [n]\n",
  "BREAKUP": "the act of breaking up [n -S]\n",
  "BREAKUPS": "BREAKUP, the act of breaking up [n]\n",
  "BREAKWALL": "a protective wall built offshore and usually parallel to the shore [n -S]\n",
  "BREAKWALLS": "BREAKWALL, a protective wall built offshore and usually parallel to the shore [n]\n",
  "BREAKWATER": "a protective wall built offshore and usually parallel to the shore [n -S]\n",
  "BREAKWATERS": "BREAKWATER, a protective wall built offshore and usually parallel to the shore [n]\n",
  "BREAM": "to clean a ship's bottom by burning off seaweed [v -ED, -ING, -S]\n",
  "BREAMED": "BREAM, to clean a ship's bottom by burning off seaweed [v]\n",
  "BREAMING": "BREAM, to clean a ship's bottom by burning off seaweed [v]\n",
  "BREAMS": "BREAM, to clean a ship's bottom by burning off seaweed [v]\n",
  "BREARE": "(Spenser) brier, also BRERE [n -S]\n",
  "BREARES": "BREARE, (Spenser) brier, also BRERE [n]\n",
  "BREASKIT": "meat from the breast of an animal, also BRISKET [n -S]\n",
  "BREASKITS": "BREASKIT, meat from the breast of an animal, also BRISKET [n]\n",
  "BREAST": "to confront boldly [v -ED, -ING, -S]\n",
  "BREASTBONE": "the large bone of the breast, aka sternum [n -S]\n",
  "BREASTBONES": "BREASTBONE, the large bone of the breast, aka sternum [n]\n",
  "BREASTED": "BREAST, to confront boldly [v]\n",
  "BREASTFED": "BREASTFEED, to feed with the breast [v]\n",
  "BREASTFEED": "to feed with the breast [v BREASTFED, BREASTFEEDING, BREASTFEEDS]\n",
  "BREASTFEEDING": "the act of feeding with the breast [n -S]\n",
  "BREASTFEEDINGS": "BREASTFEEDING, the act of feeding with the breast [n]\n",
  "BREASTFEEDS": "BREASTFEED, to feed with the breast [v]\n",
  "BREASTING": "BREAST, to confront boldly [v]\n",
  "BREASTPIN": "an ornamental pin for the breast [n -S]\n",
  "BREASTPINS": "BREASTPIN, an ornamental pin for the breast [n]\n",
  "BREASTPLATE": "a usually metal plate worn as defensive armor for the breast [n -S]\n",
  "BREASTPLATES": "BREASTPLATE, a usually metal plate worn as defensive armor for the breast [n]\n",
  "BREASTPLOUGH": "a kind of spade for cutting turf, with a crossbar against which the breast is pressed [n -S]\n",
  "BREASTPLOUGHS": "BREASTPLOUGH, a kind of spade for cutting turf, with a crossbar against which the breast is pressed [n]\n",
  "BREASTRAIL": "the upper rail of any parapet of ordinary height, as of a balcony [n -S]\n",
  "BREASTRAILS": "BREASTRAIL, the upper rail of any parapet of ordinary height, as of a balcony [n]\n",
  "BREASTS": "BREAST, to confront boldly [v]\n",
  "BREASTSTROKE": "a swimming-stroke performed breast-down, with circling movements of the arms and a froglike movement of the legs [n -S]\n",
  "BREASTSTROKER": "one who swims using breaststroke [n -S]\n",
  "BREASTSTROKERS": "BREASTSTROKER, one who swims using breaststroke [n]\n",
  "BREASTSTROKES": "BREASTSTROKE, a swimming-stroke performed breast-down, with circling movements of the arms and a froglike movement of the legs [n]\n",
  "BREASTSUMMER": "a beam supporting the front of a building, also BRESSUMMER [n -S]\n",
  "BREASTSUMMERS": "BREASTSUMMER, a beam supporting the front of a building, also BRESSUMMER [n]\n",
  "BREASTWORK": "a temporary fortification [n -S]\n",
  "BREASTWORKS": "BREASTWORK, a temporary fortification [n]\n",
  "BREATH": "air inhaled and exhaled [n -S]\n",
  "BREATHABILITIES": "BREATHABILITY, the quality of being breathable [n]\n",
  "BREATHABILITY": "the quality of being breathable [n BREATHABILITIES]\n",
  "BREATHABLE": "suitable for breathing [adj]\n",
  "BREATHALYSE": "to use a device which measures the amount of alcohol on a person's breath, also BREATHALYZE [v BREATHALYSED, BREATHALYSING, BREATHALYSES]\n",
  "BREATHALYSED": "BREATHALYSE, to use a device which measures the amount of alcohol on a person's breath, also BREATHALYZE [v]\n",
  "BREATHALYSER": "(tradename) a device which measures the amount of alcohol on a person's breath, also BREATHALYZER [n -S]\n",
  "BREATHALYSERS": "BREATHALYSER, (tradename) a device which measures the amount of alcohol on a person's breath, also BREATHALYZER [n]\n",
  "BREATHALYSES": "BREATHALYSE, to use a device which measures the amount of alcohol on a person's breath, also BREATHALYZE [v]\n",
  "BREATHALYSING": "BREATHALYSE, to use a device which measures the amount of alcohol on a person's breath, also BREATHALYZE [v]\n",
  "BREATHALYZE": "to use a device which measures the amount of alcohol on a person's breath, also BREATHALYSE [v BREATHALYZED, BREATHALYZING, BREATHALYZES]\n",
  "BREATHALYZED": "BREATHALYZE, to use a device which measures the amount of alcohol on a person's breath, also BREATHALYSE [v]\n",
  "BREATHALYZER": "(tradename) a device which measures the amount of alcohol on a person's breath, also BREATHALYSER [n -S]\n",
  "BREATHALYZERS": "BREATHALYZER, (tradename) a device which measures the amount of alcohol on a person's breath, also BREATHALYSER [n]\n",
  "BREATHALYZES": "BREATHALYZE, to use a device which measures the amount of alcohol on a person's breath, also BREATHALYSE [v]\n",
  "BREATHALYZING": "BREATHALYZE, to use a device which measures the amount of alcohol on a person's breath, also BREATHALYSE [v]\n",
  "BREATHARIAN": "a person who believes that it is possible, through meditation, to reach a level of consciousness where one can exist on air alone [n -S]\n",
  "BREATHARIANISM": "the belief that human beings can be sustained solely by prana, a vital force in the breath [n -S]\n",
  "BREATHARIANISMS": "BREATHARIANISM, the belief that human beings can be sustained solely by prana, a vital force in the breath [n]\n",
  "BREATHARIANS": "BREATHARIAN, a person who believes that it is possible, through meditation, to reach a level of consciousness where one can exist on air alone [n]\n",
  "BREATHE": "to inhale and exhale air [v BREATHED, BREATHING, BREATHES]\n",
  "BREATHED": "BREATHE, to inhale and exhale air [v]\n",
  "BREATHER": "a rest to recover breath [n -S]\n",
  "BREATHERS": "BREATHER, a rest to recover breath [n]\n",
  "BREATHES": "BREATHE, to inhale and exhale air [v]\n",
  "BREATHFUL": "(Spenser) full of breath or odour [adj]\n",
  "BREATHIER": "BREATHY, marked by loud breathing [adj]\n",
  "BREATHIEST": "BREATHY, marked by loud breathing [adj]\n",
  "BREATHILY": "BREATHY, marked by loud breathing [adv]\n",
  "BREATHINESS": "the state of being breathy [n -ES]\n",
  "BREATHINESSES": "BREATHINESS, the state of being breathy [n]\n",
  "BREATHING": "the act of taking breath [n -S]\n",
  "BREATHINGS": "BREATHING, the act of taking breath [n]\n",
  "BREATHLESS": "not breathing [adj BREATHLESSLY]\n",
  "BREATHLESSLY": "BREATHLESS, not breathing [adv]\n",
  "BREATHLESSNESS": "the state of being breathless [n]\n",
  "BREATHS": "BREATH, air inhaled and exhaled [n]\n",
  "BREATHTAKING": "making one out of breath [adj BREATHTAKINGLY]\n",
  "BREATHTAKINGLY": "BREATHTAKING, making one out of breath [adv]\n",
  "BREATHY": "marked by loud breathing [adj BREATHIER, BREATHIEST]\n",
  "BRECCIA": "(Italian) a geological formation consisting of angular fragments of rock [n -S]\n",
  "BRECCIAL": "of or like breccia, a geological formation consisting of angular fragments of rock [adj]\n",
  "BRECCIAS": "BRECCIA, (Italian) a geological formation consisting of angular fragments of rock [n]\n",
  "BRECCIATE": "of a rock, composed of angular fragments [adj] / to break a rock down into angular fragments [v BRECCIATED, BRECCIATING, BRECCIATES]\n",
  "BRECCIATED": "BRECCIATE, to break a rock down into angular fragments [v]\n",
  "BRECCIATES": "BRECCIATE, to break a rock down into angular fragments [v]\n",
  "BRECCIATING": "BRECCIATE, to break a rock down into angular fragments [v]\n",
  "BRECCIATION": "the process of forming breccia [n -S]\n",
  "BRECCIATIONS": "BRECCIATION, the process of forming breccia [n]\n",
  "BRECHAM": "(Scots) a horse-collar, also BRECHAN [n -S]\n",
  "BRECHAMS": "BRECHAM, (Scots) a horse-collar, also BRECHAN [n]\n",
  "BRECHAN": "(Scots) a horse-collar, also BRECHAM [n -S]\n",
  "BRECHANS": "BRECHAN, (Scots) a horse-collar, also BRECHAM [n]\n",
  "BRED": "someone living in a remote part of Australia [n -S]\n",
  "BREDE": "to braid, to plait [v BREDED, BREDING, BREDES]\n",
  "BREDED": "BREDE, to braid, to plait [v]\n",
  "BREDES": "BREDE, to braid, to plait [v]\n",
  "BREDIE": "(South African) a meat and vegetable stew [n -S]\n",
  "BREDIES": "BREDIE, (South African) a meat and vegetable stew [n]\n",
  "BREDING": "BREDE, to braid, to plait [v]\n",
  "BREDREN": "(colloquial) a close male friend, also BREDRIN [n -S]\n",
  "BREDRENS": "BREDREN, (colloquial) a close male friend, also BREDRIN [n]\n",
  "BREDRIN": "(colloquial) a close male friend, also BREDREN [n -S]\n",
  "BREDRINS": "BREDRIN, (colloquial) a close male friend, also BREDREN [n]\n",
  "BREDS": "BRED, someone living in a remote part of Australia [n]\n",
  "BREE": "(Scots) the liquor in which anything has been boiled, also BRIE [n -S]\n",
  "BREECH": "to clothe with breeches [v -ED, -ING, -ES]\n",
  "BREECHBLOCK": "part of a gun [n -S]\n",
  "BREECHBLOCKS": "BREECHBLOCK, part of a gun [n]\n",
  "BREECHCLOTH": "a loincloth [n -S]\n",
  "BREECHCLOTHS": "BREECHCLOTH, a loincloth [n]\n",
  "BREECHCLOUT": "a loincloth [n -S]\n",
  "BREECHCLOUTS": "BREECHCLOUT, a loincloth [n]\n",
  "BREECHED": "BREECH, to clothe with breeches [v]\n",
  "BREECHES": "BREECH, to clothe with breeches [v]\n",
  "BREECHING": "a harness strap behind the haunches; a rope tied to cannon on ship [n -S]\n",
  "BREECHINGS": "BREECHING, a harness strap behind the haunches; a rope tied to cannon on ship [n]\n",
  "BREECHLESS": "without a breech [adj]\n",
  "BREECHLOADER": "a firearm that loads at the breech [n -S]\n",
  "BREECHLOADERS": "BREECHLOADER, a firearm that loads at the breech [n]\n",
  "BREED": "to produce by giving birth [v BRED, BREEDING, BREEDS]\n",
  "BREEDER": "one who breeds [n -S]\n",
  "BREEDERS": "BREEDER, one who breeds [n]\n",
  "BREEDING": "upbringing [n -S]\n",
  "BREEDINGS": "BREEDING, upbringing [n]\n",
  "BREEDS": "BREED, to produce by giving birth [v]\n",
  "BREEKS": "a type of trousers, also BREECHES, BRITCHES [n]\n",
  "BREEM": "(Spenser) fierce, keen, also BREME [adj]\n",
  "BREENGE": "(Scots) to plunge forward, also BREINGE [v BREENGED, BREENGING, BREENGES]\n",
  "BREENGED": "BREENGE, (Scots) to plunge forward, also BREINGE [v]\n",
  "BREENGES": "BREENGE, (Scots) to plunge forward, also BREINGE [v]\n",
  "BREENGING": "BREENGE, (Scots) to plunge forward, also BREINGE [v]\n",
  "BREER": "(Scots) to sprout above ground, also BRAIRD [v -ED, -ING, -S]\n",
  "BREERED": "BREER, (Scots) to sprout above ground, also BRAIRD [v]\n",
  "BREERING": "BREER, (Scots) to sprout above ground, also BRAIRD [v]\n",
  "BREERS": "BREER, (Scots) to sprout above ground, also BRAIRD [v]\n",
  "BREES": "BREE, (Scots) the liquor in which anything has been boiled, also BRIE [n]\n",
  "BREESE": "(archaic) the gadfly [n -S]\n",
  "BREESES": "BREESE, (archaic) the gadfly [n]\n",
  "BREEST": "(Scots) breast, also BREIST [n -S]\n",
  "BREESTS": "BREEST, (Scots) breast, also BREIST [n]\n",
  "BREEZE": "to move briskly [v BREEZED, BREEZING, BREEZES]\n",
  "BREEZED": "BREEZE, to move briskly [v]\n",
  "BREEZELESS": "motionless; destitute of breezes [adj]\n",
  "BREEZES": "BREEZE, to move briskly [v]\n",
  "BREEZEWAY": "a roofed often open passage connecting two buildings or two halves of a building [n -S]\n",
  "BREEZEWAYS": "BREEZEWAY, a roofed often open passage connecting two buildings or two halves of a building [n]\n",
  "BREEZIER": "BREEZY, windy [adj]\n",
  "BREEZIEST": "BREEZY, windy [adj]\n",
  "BREEZILY": "BREEZY, windy [adv]\n",
  "BREEZINESS": "the state of being breezy [n -ES]\n",
  "BREEZINESSES": "BREEZINESS, the state of being breezy [n]\n",
  "BREEZING": "BREEZE, to move briskly [v]\n",
  "BREEZY": "windy [adj BREEZIER, BREEZIEST, BREEZILY]\n",
  "BREGMA": "(Greek) the point of junction of the coronal and sagittal sutures of the skull [n BREGMATA or BREGMAS]\n",
  "BREGMAS": "BREGMA, (Greek) the point of junction of the coronal and sagittal sutures of the skull [n]\n",
  "BREGMATA": "BREGMA, (Greek) the point of junction of the coronal and sagittal sutures of the skull [n]\n",
  "BREGMATE": "relating to the bregma [adj]\n",
  "BREGMATIC": "relating to the bregma, the point of junction of the coronal and sagittal sutures of the skull, also BREGMATE [adj]\n",
  "BREHON": "(historical) a judge or magistrate in ancient Ireland [n -S]\n",
  "BREHONS": "BREHON, (historical) a judge or magistrate in ancient Ireland [n]\n",
  "BREI": "(South African) to pronounce r sound at the back of the throat, also BREY [v BREID, BREIING, BREIS]\n",
  "BREID": "bread [n -S]\n",
  "BREIDS": "BREID, bread [n]\n",
  "BREIING": "BREI, (South African) to pronounce r sound at the back of the throat, also BREY [v]\n",
  "BREINGE": "(Scots) to plunge forward, also BREENGE [v BREINGED, BREINGING, BREINGES]\n",
  "BREINGED": "BREINGE, (Scots) to plunge forward, also BREENGE [v]\n",
  "BREINGES": "BREINGE, (Scots) to plunge forward, also BREENGE [v]\n",
  "BREINGING": "BREINGE, (Scots) to plunge forward, also BREENGE [v]\n",
  "BREIS": "BREI, (South African) to pronounce r sound at the back of the throat, also BREY [v]\n",
  "BREIST": "(Scots) breast, also BREEST [n -S]\n",
  "BREISTS": "BREIST, (Scots) breast, also BREEST [n]\n",
  "BREKKIE": "(colloquial) breakfast, also BREKKY [n -S]\n",
  "BREKKIES": "BREKKY, (colloquial) breakfast, also BREKKIE [n]\n",
  "BREKKY": "(colloquial) breakfast, also BREKKIE [n BREKKIES]\n",
  "BRELOQUE": "(French) a watch chain [n -S]\n",
  "BRELOQUES": "BRELOQUE, (French) a watch chain [n]\n",
  "BREME": "(Spenser) fierce, keen, also BREEM [adj]\n",
  "BREMSSTRAHLUNG": "(German) electromagnetic radiation given off when an electron collides with a positive nucleus [n -S]\n",
  "BREMSSTRAHLUNGS": "BREMSSTRAHLUNG, (German) electromagnetic radiation given off when an electron collides with a positive nucleus [n]\n",
  "BREN": "(archaic) to burn, also BRENNE [v BRENT, BRENNING, BRENS]\n",
  "BRENNE": "(archaic) to burn, also BREN [v BRENT, BRENNING, BRENNES]\n",
  "BRENNES": "BRENNE, (archaic) to burn, also BREN [v]\n",
  "BRENNING": "BRENNE, (archaic) to burn, also BREN [v]\n",
  "BRENS": "BREN, (archaic) to burn, also BRENNE [v]\n",
  "BRENT": "(Scots) lofty, steep [adj BRENTER, BRENTEST] / a wild goose, also BRANT [n -S]\n",
  "BRENTER": "BRENT, (Scots) lofty, steep [adj]\n",
  "BRENTEST": "BRENT, (Scots) lofty, steep [adj]\n",
  "BRENTS": "BRENT, a wild goose, also BRANT [n]\n",
  "BRER": "(US dialect) brother [n -S]\n",
  "BRERE": "(Spenser) a briar, also BREARE [n -S]\n",
  "BRERES": "BRERE, (Spenser) a briar, also BREARE [n]\n",
  "BRERS": "BRER, (US dialect) brother [n]\n",
  "BRESAOLA": "salt-cured, air-dried beef, served thinly sliced with oil, lemon juice and black pepper [n -S]\n",
  "BRESAOLAS": "BRESAOLA, salt-cured, air-dried beef, served thinly sliced with oil, lemon juice and black pepper [n]\n",
  "BRESSUMMER": "a beam supporting a wall over an opening, also BREASTSUMMER [n -S]\n",
  "BRESSUMMERS": "BRESSUMMER, a beam supporting a wall over an opening, also BREASTSUMMER [n]\n",
  "BRETASCHE": "a wooden tower used in mediaeval siege operations, also BRATTICE, BRATTISH, BRETESSE, BRETTICE [n -S]\n",
  "BRETASCHES": "BRETASCHE, a wooden tower used in mediaeval siege operations, also BRATTICE, BRATTISH, BRETESSE, BRETTICE [n]\n",
  "BRETESSE": "a wooden tower used in mediaeval siege operations, also BRATTICE, BRATTISH, BRETASCHE, BRETTICE [n -S]\n",
  "BRETESSES": "BRETESSE, a wooden tower used in mediaeval siege operations, also BRATTICE, BRATTISH, BRETASCHE, BRETTICE [n]\n",
  "BRETHREN": "BROTHER, a male sibling [n]\n",
  "BRETON": "(French) a hat with rounded crown and turned up brim [n -S]\n",
  "BRETONS": "BRETON, (French) a hat with rounded crown and turned up brim [n]\n",
  "BRETTICE": "a wooden tower used in mediaeval siege operations [n -S] / to provide with a brettice [v BRETTICED, BRETTICING, BRETTICES]\n",
  "BRETTICED": "BRETTICE, to provide with a brettice [v]\n",
  "BRETTICES": "BRETTICE, to provide with a brettice [v]\n",
  "BRETTICING": "BRETTICE, to provide with a brettice [v]\n",
  "BREUNNERITE": "an iron-containing type of magnesite used in the manufacture of refractory bricks [n -S]\n",
  "BREUNNERITES": "BREUNNERITE, an iron-containing type of magnesite used in the manufacture of refractory bricks [n]\n",
  "BREVE": "an obsolescent musical note, twice as long as the longest now generally used (the semibreve) [n -S]\n",
  "BREVES": "BREVE, an obsolescent musical note, twice as long as the longest now generally used (the semibreve) [n]\n",
  "BREVET": "to confer an honorary military rank upon [v BREVETED or BREVETTED, BREVETING or BREVETTING, BREVETS]\n",
  "BREVETCIES": "BREVETCY, an honorary military rank [n]\n",
  "BREVETCY": "an honorary military rank [n BREVETCIES]\n",
  "BREVETE": "(French) patented [adj]\n",
  "BREVETED": "BREVET, to confer an honorary military rank upon [v]\n",
  "BREVETING": "BREVET, to confer an honorary military rank upon [v]\n",
  "BREVETS": "BREVET, to confer an honorary military rank upon [v]\n",
  "BREVETTED": "BREVET, to confer an honorary military rank upon [v]\n",
  "BREVETTING": "BREVET, to confer an honorary military rank upon [v]\n",
  "BREVIARIES": "BREVIARY, a prayer book [n]\n",
  "BREVIARY": "a prayer book [n BREVIARIES]\n",
  "BREVIATE": "a lawyer's brief [n -S]\n",
  "BREVIATES": "BREVIATE, a lawyer's brief [n]\n",
  "BREVIER": "an old type size [n -S]\n",
  "BREVIERS": "BREVIER, an old type size [n]\n",
  "BREVIPENNATE": "having short wings [adj]\n",
  "BREVIS": "broth, esp. beef broth, also BREWIS [n -ES]\n",
  "BREVISES": "BREVIS, broth, esp. beef broth, also BREWIS [n]\n",
  "BREVITIES": "BREVITY, shortness of duration [n]\n",
  "BREVITY": "shortness of duration [n BREVITIES]\n",
  "BREW": "to make beer [v -ED, -ING, -S]\n",
  "BREWAGE": "the process of brewing [n -S]\n",
  "BREWAGES": "BREWAGE, the process of brewing [n]\n",
  "BREWED": "BREW, to make beer [v]\n",
  "BREWER": "one who brews, also BREWSTER [n -S]\n",
  "BREWERIES": "BREWERY, a place for brewing [n]\n",
  "BREWERS": "BREWER, one who brews, also BREWSTER [n]\n",
  "BREWERY": "a place for brewing [n BREWERIES]\n",
  "BREWHOUSE": "a brewery [n -S]\n",
  "BREWHOUSES": "BREWHOUSE, a brewery [n]\n",
  "BREWING": "a quantity brewed at one time [n -S]\n",
  "BREWINGS": "BREWING, a quantity brewed at one time [n]\n",
  "BREWIS": "(archaic) broth, esp. beef broth, also BREVIS [n -ES]\n",
  "BREWISES": "BREWIS, (archaic) broth, esp. beef broth, also BREVIS [n]\n",
  "BREWMASTER": "the supervisor of the brewing in a brewery [n -S]\n",
  "BREWMASTERS": "BREWMASTER, the supervisor of the brewing in a brewery [n]\n",
  "BREWPUB": "a combined pub and brewery [n -S]\n",
  "BREWPUBS": "BREWPUB, a combined pub and brewery [n]\n",
  "BREWS": "BREW, to make beer [v]\n",
  "BREWSKI": "(colloquial) beer [n BREWSKIS or BREWSKIES]\n",
  "BREWSKIES": "BREWSKI, (colloquial) beer [n]\n",
  "BREWSKIS": "BREWSKI, (colloquial) beer [n]\n",
  "BREWSTER": "(Scots) a brewer, also BREWER [n -S]\n",
  "BREWSTERS": "BREWSTER, (Scots) a brewer, also BREWER [n]\n",
  "BREY": "(South African) to pronounce r sound at the back of the throat, also BREI [v -ED, -ING, -S]\n",
  "BREYED": "BREY, (South African) to pronounce r sound at the back of the throat, also BREI [v]\n",
  "BREYING": "BREY, (South African) to pronounce r sound at the back of the throat, also BREI [v]\n",
  "BREYS": "BREY, (South African) to pronounce r sound at the back of the throat, also BREI [v]\n",
  "BRIAR": "a prickly bush, esp. of a wild rose, also BREARE, BRERE, BRIER [n -S]\n",
  "BRIARD": "(French) a kind of rugged French dog [n -S]\n",
  "BRIARDS": "BRIARD, (French) a kind of rugged French dog [n]\n",
  "BRIARED": "covered with briars [adj]\n",
  "BRIARIER": "BRIARY, full of briars, also BRIERY [adj]\n",
  "BRIARIEST": "BRIARY, full of briars, also BRIERY [adj]\n",
  "BRIARROOT": "the root of a briar, also BRIERROOT [n -S]\n",
  "BRIARROOTS": "BRIARROOT, the root of a briar, also BRIERROOT [n]\n",
  "BRIARS": "BRIAR, a prickly bush, esp. of a wild rose, also BREARE, BRERE, BRIER [n]\n",
  "BRIARWOOD": "the wood of a briar stem, also BRIERWOOD [n -S]\n",
  "BRIARWOODS": "BRIARWOOD, the wood of a briar stem, also BRIERWOOD [n]\n",
  "BRIARY": "full of briars, also BRIERY [adj BRIARIER, BRIARIEST]\n",
  "BRIBABLE": "able to be bribed [adj]\n",
  "BRIBE": "to influence by offering a reward [v BRIBED, BRIBING, BRIBES]\n",
  "BRIBEABLE": "capable of being bribed, also BRIBABLE [adj]\n",
  "BRIBED": "BRIBE, to influence by offering a reward [v]\n",
  "BRIBEE": "one who receives a bribe [n -S]\n",
  "BRIBEES": "BRIBEE, one who receives a bribe [n]\n",
  "BRIBER": "one who bribes [n -S]\n",
  "BRIBERIES": "BRIBERY, an act of influencing corruptly [n]\n",
  "BRIBERS": "BRIBER, one who bribes [n]\n",
  "BRIBERY": "an act of influencing corruptly [n BRIBERIES]\n",
  "BRIBES": "BRIBE, to influence by offering a reward [v]\n",
  "BRIBING": "BRIBE, to influence by offering a reward [v]\n",
  "BRICABRAC": "(French) old curiosities, knickknacks [n -S]\n",
  "BRICABRACS": "BRICABRAC, (French) old curiosities, knickknacks [n]\n",
  "BRICHT": "(Scots) bright [adj BRICHTER, BRICHTEST]\n",
  "BRICHTER": "BRICHT, (Scots) bright [adj]\n",
  "BRICHTEST": "BRICHT, (Scots) bright [adj]\n",
  "BRICK": "to build with blocks of clay [v -ED, -ING, -S]\n",
  "BRICKBAT": "a piece of brick [n -S]\n",
  "BRICKBATS": "BRICKBAT, a piece of brick [n]\n",
  "BRICKCLAY": "a clay containing sand and a good deal of iron; any clay used for brickmaking [n -S]\n",
  "BRICKCLAYS": "BRICKCLAY, a clay containing sand and a good deal of iron; any clay used for brickmaking [n]\n",
  "BRICKEARTH": "a clayey alluvium suitable for the making of bricks [n -S]\n",
  "BRICKEARTHS": "BRICKEARTH, a clayey alluvium suitable for the making of bricks [n]\n",
  "BRICKED": "BRICK, to build with blocks of clay [v]\n",
  "BRICKEN": "made of brick [adj]\n",
  "BRICKFIELD": "a brickyard [n -S]\n",
  "BRICKFIELDER": "a hot dry wind in Australia [n -S]\n",
  "BRICKFIELDERS": "BRICKFIELDER, a hot dry wind in Australia [n]\n",
  "BRICKFIELDS": "BRICKFIELD, a brickyard [n]\n",
  "BRICKIE": "(colloquial) a bricklayer [n -S]\n",
  "BRICKIER": "BRICKY, made of bricks [adj]\n",
  "BRICKIES": "BRICKIE, (colloquial) a bricklayer [n]\n",
  "BRICKIEST": "BRICKY, made of bricks [adj]\n",
  "BRICKING": "brickwork [n -S]\n",
  "BRICKINGS": "BRICKING, brickwork [n]\n",
  "BRICKKILN": "a kiln where bricks are made [n -S]\n",
  "BRICKKILNS": "BRICKKILN, a kiln where bricks are made [n]\n",
  "BRICKLAYER": "a person who lays bricks [n -S]\n",
  "BRICKLAYERS": "BRICKLAYER, a person who lays bricks [n]\n",
  "BRICKLAYING": "the job of laying bricks [n -S]\n",
  "BRICKLAYINGS": "BRICKLAYING, the job of laying bricks [n]\n",
  "BRICKLE": "a brittle candy [n -S]\n",
  "BRICKLES": "BRICKLE, a brittle candy [n]\n",
  "BRICKLIKE": "like a brick [adj]\n",
  "BRICKMAKER": "one whose occupation is to make bricks [n -S]\n",
  "BRICKMAKERS": "BRICKMAKER, one whose occupation is to make bricks [n]\n",
  "BRICKMAKING": "the making of bricks [n -S]\n",
  "BRICKMAKINGS": "BRICKMAKING, the making of bricks [n]\n",
  "BRICKS": "BRICK, to build with blocks of clay [v]\n",
  "BRICKSHAPED": "shaped like a brick [adj]\n",
  "BRICKWALL": "a shot in billiards, involving a rebound, also BRICOLE [n -S]\n",
  "BRICKWALLS": "BRICKWALL, a shot in billiards, involving a rebound, also BRICOLE [n]\n",
  "BRICKWORK": "a structure, such as a wall, built of bricks [n -S]\n",
  "BRICKWORKS": "BRICKWORK, a structure, such as a wall, built of bricks [n]\n",
  "BRICKY": "made of bricks [adj BRICKIER, BRICKIEST]\n",
  "BRICKYARD": "a place where bricks are made [n -S]\n",
  "BRICKYARDS": "BRICKYARD, a place where bricks are made [n]\n",
  "BRICOLAGE": "(French) a construction using whatever comes to hand [n -S]\n",
  "BRICOLAGES": "BRICOLAGE, (French) a construction using whatever comes to hand [n]\n",
  "BRICOLE": "(French) a shot in billiards, involving a rebound, also BRICKWALL [n -S]\n",
  "BRICOLES": "BRICOLE, (French) a shot in billiards, involving a rebound, also BRICKWALL [n]\n",
  "BRICOLEUR": "one who engages in bricolage, potters about [n -S]\n",
  "BRICOLEURS": "BRICOLEUR, one who engages in bricolage, potters about [n]\n",
  "BRIDAL": "related to brides [adj BRIDALLY] / a wedding [n -S]\n",
  "BRIDALLY": "BRIDAL, related to brides [adv]\n",
  "BRIDALS": "BRIDAL, a wedding [n]\n",
  "BRIDE": "to act the bride [v BRIDED, BRIDING, BRIDES]\n",
  "BRIDECAKE": "rich or highly ornamented cake, to be distributed to the guests at a wedding [n -S]\n",
  "BRIDECAKES": "BRIDECAKE, rich or highly ornamented cake, to be distributed to the guests at a wedding [n]\n",
  "BRIDED": "BRIDE, to act the bride [v]\n",
  "BRIDEGROOM": "a man just married or about to be married [n -S]\n",
  "BRIDEGROOMS": "BRIDEGROOM, a man just married or about to be married [n]\n",
  "BRIDEMAID": "a woman who is an attendant of a bride, also BRIDESMAID, BRIDEMAIDEN [n -S]\n",
  "BRIDEMAIDEN": "a woman who is an attendant of a bride, also BRIDEMAID, BRIDESMAID [n -S]\n",
  "BRIDEMAIDENS": "BRIDEMAIDEN, a woman who is an attendant of a bride, also BRIDEMAID, BRIDESMAID [n]\n",
  "BRIDEMAIDS": "BRIDEMAID, a woman who is an attendant of a bride, also BRIDESMAID, BRIDEMAIDEN [n]\n",
  "BRIDEMAN": "a groom's attendant at a wedding [n BRIDEMEN]\n",
  "BRIDEMEN": "BRIDEMAN, a groom's attendant at a wedding [n]\n",
  "BRIDES": "BRIDE, to act the bride [v]\n",
  "BRIDESMAID": "a woman who is an attendant of a bride, also BRIDEMAID, BRIDEMAIDEN [n -S]\n",
  "BRIDESMAIDS": "BRIDESMAID, a woman who is an attendant of a bride, also BRIDEMAID, BRIDEMAIDEN [n]\n",
  "BRIDESMAN": "a male equivalent of a bridesmaid, also BRIDEMAN [n BRIDESMEN]\n",
  "BRIDESMEN": "BRIDESMAN, a male equivalent of a bridesmaid, also BRIDEMAN [n]\n",
  "BRIDEWEALTH": "in tribal societies, etc., a price paid (usually in kind) to a bride's family by the bridegroom [n -S]\n",
  "BRIDEWEALTHS": "BRIDEWEALTH, in tribal societies, etc., a price paid (usually in kind) to a bride's family by the bridegroom [n]\n",
  "BRIDEWELL": "a house of correction, a jail [n -S]\n",
  "BRIDEWELLS": "BRIDEWELL, a house of correction, a jail [n]\n",
  "BRIDEZILLA": "a woman whose behaviour in planning the details of her wedding is regarded as intolerable [n -S]\n",
  "BRIDEZILLAS": "BRIDEZILLA, a woman whose behaviour in planning the details of her wedding is regarded as intolerable [n]\n",
  "BRIDGABLE": "that can be bridged, also BRIDGEABLE [adj]\n",
  "BRIDGE": "to connect across a gap [v BRIDGED, BRIDGING, BRIDGES]\n",
  "BRIDGEABLE": "that can be bridged, also BRIDGABLE [adj]\n",
  "BRIDGEBOARD": "a board on both sides of a staircase that is cut to support the treads and risers [n -S]\n",
  "BRIDGEBOARDS": "BRIDGEBOARD, a board on both sides of a staircase that is cut to support the treads and risers [n]\n",
  "BRIDGED": "BRIDGE, to connect across a gap [v]\n",
  "BRIDGEHEAD": "a fortification protecting the end of a bridge nearest an enemy [n -S]\n",
  "BRIDGEHEADS": "BRIDGEHEAD, a fortification protecting the end of a bridge nearest an enemy [n]\n",
  "BRIDGELESS": "having no bridge; not bridged [adj]\n",
  "BRIDGELIKE": "like a bridge [adj]\n",
  "BRIDGES": "BRIDGE, to connect across a gap [v]\n",
  "BRIDGEWORK": "a dental bridge [n -S]\n",
  "BRIDGEWORKS": "BRIDGEWORK, a dental bridge [n]\n",
  "BRIDGING": "the process of constructing a bridge [n -S]\n",
  "BRIDGINGS": "BRIDGING, the process of constructing a bridge [n]\n",
  "BRIDIE": "(Scots) a meat and onion turnover [n -S]\n",
  "BRIDIES": "BRIDIE, (Scots) a meat and onion turnover [n]\n",
  "BRIDING": "BRIDE, to act the bride [v]\n",
  "BRIDLE": "to check or restrain [v BRIDLED, BRIDLING, BRIDLES]\n",
  "BRIDLED": "BRIDLE, to check or restrain [v]\n",
  "BRIDLER": "one who restrains and governs, as with a bridle [n -S]\n",
  "BRIDLERS": "BRIDLER, one who restrains and governs, as with a bridle [n]\n",
  "BRIDLES": "BRIDLE, to check or restrain [v]\n",
  "BRIDLEWAY": "a path on which horses may be ridden [n -S]\n",
  "BRIDLEWAYS": "BRIDLEWAY, a path on which horses may be ridden [n]\n",
  "BRIDLEWISE": "of a horse, obedient to the pressure of the reins on the neck rather than to the bit [adj]\n",
  "BRIDLING": "BRIDLE, to check or restrain [v]\n",
  "BRIDOON": "(French) a light military bridle, also BRADOON [n -S]\n",
  "BRIDOONS": "BRIDOON, (French) a light military bridle, also BRADOON [n]\n",
  "BRIE": "(Scots) the liquor in which anything has been boiled, also BREE [n -S]\n",
  "BRIEF": "to give instructions [v -ED, -ING, -S] / short [adj BRIEFER, BRIEFEST, BRIEFLY]\n",
  "BRIEFCASE": "a small case for carrying briefs, or for documents in general [n -S]\n",
  "BRIEFCASES": "BRIEFCASE, a small case for carrying briefs, or for documents in general [n]\n",
  "BRIEFED": "BRIEF, to give instructions [v]\n",
  "BRIEFER": "one who gives instructions [n -S]\n",
  "BRIEFERS": "BRIEFER, one who gives instructions [n]\n",
  "BRIEFEST": "BRIEF, short [adj]\n",
  "BRIEFING": "a short lecture [n -S]\n",
  "BRIEFINGS": "BRIEFING, a short lecture [n]\n",
  "BRIEFLESS": "having no brief; without clients; as, a briefless barrister [adj]\n",
  "BRIEFLY": "BRIEF, short [adv]\n",
  "BRIEFNESS": "the state of being brief [n -ES]\n",
  "BRIEFNESSES": "BRIEFNESS, the state of being brief [n]\n",
  "BRIEFS": "BRIEF, to give instructions [v]\n",
  "BRIER": "a prickly shrub, also BREARE, BRERE, BRIAR [n -S]\n",
  "BRIERED": "full of briers, also BRIARED [adj]\n",
  "BRIERIER": "BRIERY, thorny, full of briers, also BRIARY [adj]\n",
  "BRIERIEST": "BRIERY, thorny, full of briers, also BRIARY [adj]\n",
  "BRIERROOT": "the root of a briar, also BRIARROOT [n -S]\n",
  "BRIERROOTS": "BRIERROOT, the root of a briar, also BRIARROOT [n]\n",
  "BRIERS": "BRIER, a prickly shrub, also BREARE, BRERE, BRIAR [n]\n",
  "BRIERWOOD": "the wood of a brier stem, also BRIARWOOD [n -S]\n",
  "BRIERWOODS": "BRIERWOOD, the wood of a brier stem, also BRIARWOOD [n]\n",
  "BRIERY": "thorny, full of briers, also BRIARY [adj BRIERIER, BRIERIEST]\n",
  "BRIES": "BRIE, (Scots) the liquor in which anything has been boiled, also BREE [n]\n",
  "BRIG": "a two-masted, square-rigged vessel [n -S]\n",
  "BRIGADE": "to group together [v BRIGADED, BRIGADING, BRIGADES]\n",
  "BRIGADED": "BRIGADE, to group together [v]\n",
  "BRIGADES": "BRIGADE, to group together [v]\n",
  "BRIGADIER": "an officer having command of a brigade, ranking above a colonel [n -S]\n",
  "BRIGADIERS": "BRIGADIER, an officer having command of a brigade, ranking above a colonel [n]\n",
  "BRIGADING": "BRIGADE, to group together [v]\n",
  "BRIGALOW": "(Native Australian) any of several species of acacia [n -S]\n",
  "BRIGALOWS": "BRIGALOW, (Native Australian) any of several species of acacia [n]\n",
  "BRIGAND": "a bandit [n -S]\n",
  "BRIGANDAGE": "the practice of brigands [n -S]\n",
  "BRIGANDAGES": "BRIGANDAGE, the practice of brigands [n]\n",
  "BRIGANDINE": "leather armour with metal scales [n -S]\n",
  "BRIGANDINES": "BRIGANDINE, leather armour with metal scales [n]\n",
  "BRIGANDRIES": "BRIGANDRY, the act of being a brigand [n]\n",
  "BRIGANDRY": "the act of being a brigand [n BRIGANDRIES]\n",
  "BRIGANDS": "BRIGAND, a bandit [n]\n",
  "BRIGANTINE": "a two-masted ship [n -S]\n",
  "BRIGANTINES": "BRIGANTINE, a two-masted ship [n]\n",
  "BRIGHT": "a light-hued tobacco [n -S] / shining [adj BRIGHTER, BRIGHTEST, BRIGHTLY]\n",
  "BRIGHTEN": "to make bright [v -ED, -ING, -S]\n",
  "BRIGHTENED": "BRIGHTEN, to make bright [v]\n",
  "BRIGHTENER": "something that brightens [n -S]\n",
  "BRIGHTENERS": "BRIGHTENER, something that brightens [n]\n",
  "BRIGHTENING": "BRIGHTEN, to make bright [v]\n",
  "BRIGHTENS": "BRIGHTEN, to make bright [v]\n",
  "BRIGHTER": "BRIGHT, shining [adj]\n",
  "BRIGHTEST": "BRIGHT, shining [adj]\n",
  "BRIGHTISH": "somewhat bright [adj]\n",
  "BRIGHTLY": "BRIGHT, shining [adv]\n",
  "BRIGHTNESS": "the state of being bright [n -ES]\n",
  "BRIGHTNESSES": "BRIGHTNESS, the state of being bright [n]\n",
  "BRIGHTS": "BRIGHT, a light-hued tobacco [n]\n",
  "BRIGHTSOME": "bright; clear; brilliant [adj]\n",
  "BRIGHTWORK": "polished metal on cars etc. [n -S]\n",
  "BRIGHTWORKS": "BRIGHTWORK, polished metal on cars etc. [n]\n",
  "BRIGS": "BRIG, a two-masted, square-rigged vessel [n]\n",
  "BRIGUE": "(French) to intrigue [v BRIGUED, BRIGUING, BRIGUES]\n",
  "BRIGUED": "BRIGUE, (French) to intrigue [v]\n",
  "BRIGUES": "BRIGUE, (French) to intrigue [v]\n",
  "BRIGUING": "canvassing [n -S]\n",
  "BRIGUINGS": "BRIGUING, canvassing [n]\n",
  "BRIK": "(Arabic) a Tunisian deep fried spicy pastry filled with fish or meat and sometimes an egg [n -S]\n",
  "BRIKI": "the Greek name for a cezve, a small metal pot used for preparing coffee [n -S]\n",
  "BRIKIS": "BRIKI, the Greek name for a cezve, a small metal pot used for preparing coffee [n]\n",
  "BRIKS": "BRIK, (Arabic) a Tunisian deep fried spicy pastry filled with fish or meat and sometimes an egg [n]\n",
  "BRILL": "a fish spotted with white [n -S] / brilliant [adj BRILLER, BRILLEST]\n",
  "BRILLER": "BRILL, brilliant [adj]\n",
  "BRILLEST": "BRILL, brilliant [adj]\n",
  "BRILLIANCE": "the state of being brilliant, also BRILLIANCY [n -S]\n",
  "BRILLIANCES": "BRILLIANCE, the state of being brilliant, also BRILLIANCY [n]\n",
  "BRILLIANCIES": "BRILLIANCY, the state of being brilliant, also BRILLIANCE [n]\n",
  "BRILLIANCY": "the state of being brilliant, also BRILLIANCE [n BRILLIANCIES]\n",
  "BRILLIANT": "shining [adj BRILLIANTLY] / to cut and polish a diamond [v -ED, -ING, -S]\n",
  "BRILLIANTE": "(French) with spirit, lively [adj]\n",
  "BRILLIANTED": "BRILLIANT, to cut and polish a diamond [v]\n",
  "BRILLIANTINE": "a perfumed hair oil for making the hair glossy; a glossy cotton and mohair fabric [n -S]\n",
  "BRILLIANTINED": "having had brilliantine applied [adj]\n",
  "BRILLIANTINES": "BRILLIANTINE, a perfumed hair oil for making the hair glossy; a glossy cotton and mohair fabric [n]\n",
  "BRILLIANTING": "BRILLIANT, to cut and polish a diamond [v]\n",
  "BRILLIANTLY": "BRILLIANT, shining [adv]\n",
  "BRILLIANTNESS": "the state of being brilliant [n -ES]\n",
  "BRILLIANTNESSES": "BRILLIANTNESS, the state of being brilliant [n]\n",
  "BRILLIANTS": "BRILLIANT, to cut and polish a diamond [v]\n",
  "BRILLO": "(tradename) a type of scouring pad [n -S]\n",
  "BRILLOS": "BRILLO, (tradename) a type of scouring pad [n]\n",
  "BRILLS": "BRILL, a fish spotted with white [n]\n",
  "BRIM": "to fill to the top [v BRIMMED, BRIMMING, BRIMS]\n",
  "BRIMFUL": "full to the brim [adj]\n",
  "BRIMFULL": "full to the brim [adj BRIMFULLY]\n",
  "BRIMFULLNESS": "the state of being brimfull, also BRIMFULNESS [n -ES]\n",
  "BRIMFULLNESSES": "BRIMFULLNESS, the state of being brimfull, also BRIMFULNESS [n]\n",
  "BRIMFULLY": "BRIMFULL, full to the brim [adv]\n",
  "BRIMFULNESS": "the state of being brimful, also BRIMFULLNESS [n -ES]\n",
  "BRIMFULNESSES": "BRIMFULNESS, the state of being brimful, also BRIMFULLNESS [n]\n",
  "BRIMING": "phosphorescence of the sea [n -S]\n",
  "BRIMINGS": "BRIMING, phosphorescence of the sea [n]\n",
  "BRIMLESS": "having no upper edge [adj]\n",
  "BRIMMED": "BRIM, to fill to the top [v]\n",
  "BRIMMER": "a bowl or glass full to the brim [n -S]\n",
  "BRIMMERS": "BRIMMER, a bowl or glass full to the brim [n]\n",
  "BRIMMING": "BRIM, to fill to the top [v]\n",
  "BRIMS": "BRIM, to fill to the top [v]\n",
  "BRIMSTONE": "sulphur; esp. (otherwise archaic) burning sulphur, (the fuel of) hellfire [n -S]\n",
  "BRIMSTONES": "BRIMSTONE, sulphur; esp. (otherwise archaic) burning sulphur, (the fuel of) hellfire [n]\n",
  "BRIMSTONIER": "BRIMSTONY, containing or resembling brimstone [adj]\n",
  "BRIMSTONIEST": "BRIMSTONY, containing or resembling brimstone [adj]\n",
  "BRIMSTONY": "containing or resembling brimstone [adj BRIMSTONIER, BRIMSTONIEST]\n",
  "BRIN": "the rib of a fan [n -S]\n",
  "BRINDED": "marked with spots or streaks, also BRINDLED [adj]\n",
  "BRINDISI": "(Italian) a toast; a drinking-song [n -S]\n",
  "BRINDISIS": "BRINDISI, (Italian) a toast; a drinking-song [n]\n",
  "BRINDLE": "an animal marked with spots [n -S]\n",
  "BRINDLED": "marked with spots or streaks, also BRINDED [adj]\n",
  "BRINDLES": "BRINDLE, an animal marked with spots [n]\n",
  "BRINE": "to treat with salt water [v BRINED, BRINING, BRINES]\n",
  "BRINED": "BRINE, to treat with salt water [v]\n",
  "BRINELESS": "without brine [adj]\n",
  "BRINELLING": "a localized surface corrosion; a cause of damage to bearings [n -S]\n",
  "BRINELLINGS": "BRINELLING, a localized surface corrosion; a cause of damage to bearings [n]\n",
  "BRINER": "one that brines [n -S]\n",
  "BRINERS": "BRINER, one that brines [n]\n",
  "BRINES": "BRINE, to treat with salt water [v]\n",
  "BRING": "to take with oneself to a place [v BROUGHT or BRUNG, BRINGING, BRINGS]\n",
  "BRINGDOWN": "a comedown, a letdown [n -S]\n",
  "BRINGDOWNS": "BRINGDOWN, a comedown, a letdown [n]\n",
  "BRINGER": "one who brings [n -S]\n",
  "BRINGERS": "BRINGER, one who brings [n]\n",
  "BRINGING": "the act of bringing [n -S]\n",
  "BRINGINGS": "BRINGING, the act of bringing [n]\n",
  "BRINGS": "BRING, to take with oneself to a place [v]\n",
  "BRINIER": "BRINY, salty [adj]\n",
  "BRINIES": "BRINY, the sea [n]\n",
  "BRINIEST": "BRINY, salty [adj]\n",
  "BRININESS": "the state of being briny [n -ES]\n",
  "BRININESSES": "BRININESS, the state of being briny [n]\n",
  "BRINING": "BRINE, to treat with salt water [v]\n",
  "BRINISH": "like brine [adj]\n",
  "BRINJAL": "(Sanskrit) the aubergine [n -S]\n",
  "BRINJALS": "BRINJAL, (Sanskrit) the aubergine [n]\n",
  "BRINJARRIES": "BRINJARRY, (Hindi) a travelling dealer in grain and salt in South India [n]\n",
  "BRINJARRY": "(Hindi) a travelling dealer in grain and salt in South India [n BRINJARRIES]\n",
  "BRINK": "an extreme edge [n -S]\n",
  "BRINKMAN": "someone whose policy gets very close to war [n BRINKMEN]\n",
  "BRINKMANSHIP": "the art or practice of pushing a dangerous situation or confrontation to the limit of safety esp. to force a desired outcome, also BRINKSMANSHIP [n -S]\n",
  "BRINKMANSHIPS": "BRINKMANSHIP, the art or practice of pushing a dangerous situation or confrontation to the limit of safety esp. to force a desired outcome, also BRINKSMANSHIP [n]\n",
  "BRINKMEN": "BRINKMAN, someone whose policy gets very close to war [n]\n",
  "BRINKS": "BRINK, an extreme edge [n]\n",
  "BRINKSMANSHIP": "the art or practice of pushing a dangerous situation or confrontation to the limit of safety esp. to force a desired outcome, also BRINKMANSHIP [n -S]\n",
  "BRINKSMANSHIPS": "BRINKSMANSHIP, the art or practice of pushing a dangerous situation or confrontation to the limit of safety esp. to force a desired outcome, also BRINKMANSHIP [n]\n",
  "BRINNIES": "BRINNY, (Australian slang) a stone, when thrown [n]\n",
  "BRINNY": "(Australian slang) a stone, when thrown [n BRINNIES]\n",
  "BRINS": "BRIN, the rib of a fan [n]\n",
  "BRINY": "the sea [n BRINIES] / salty [adj BRINIER, BRINIEST]\n",
  "BRIO": "(Italian) liveliness, enthusiastic vigour, as in con brio [n -S]\n",
  "BRIOCHE": "(French) a kind of soft roll, made with eggs, butter, flour and yeast [n -S]\n",
  "BRIOCHES": "BRIOCHE, (French) a kind of soft roll, made with eggs, butter, flour and yeast [n]\n",
  "BRIOLETTE": "(French) a pear-shaped gem [n -S]\n",
  "BRIOLETTES": "BRIOLETTE, (French) a pear-shaped gem [n]\n",
  "BRIONIES": "BRIONY, a climbing plant [n]\n",
  "BRIONY": "a climbing plant [n BRIONIES]\n",
  "BRIOS": "BRIO, (Italian) liveliness, enthusiastic vigour, as in con brio [n]\n",
  "BRIQUET": "(French) a brickshaped block made of compressed coaldust, also BRIQUETTE [n -S] / to form into briquettes [v BRIQUETTED, BRIQUETTING, BRIQUETS]\n",
  "BRIQUETS": "BRIQUET, (French) a brickshaped block made of compressed coaldust, also BRIQUETTE [n]\n",
  "BRIQUETTE": "(French) a brick-shaped block made of compressed coal-dust, also BRIQUET [n -S] / to form into briquettes [v BRIQUETTED, BRIQUETTING, BRIQUETTES]\n",
  "BRIQUETTED": "BRIQUETTE, to form into briquettes [v]\n",
  "BRIQUETTES": "BRIQUETTE, to form into briquettes [v]\n",
  "BRIQUETTING": "BRIQUET, to form into briquettes [v]\n",
  "BRIS": "(Hebrew) a Jewish circumcision rite, also BRISS, BRITH [n BRISES or BRISSES]\n",
  "BRISANCE": "(French) the shattering or crushing effect of an explosion [n -S]\n",
  "BRISANCES": "BRISANCE, (French) the shattering or crushing effect of an explosion [n]\n",
  "BRISANT": "(French) explosive, shattering [adj]\n",
  "BRISE": "(French) a movement in dancing [n -S]\n",
  "BRISES": "BRISE, (French) a movement in dancing [n]\n",
  "BRISK": "to make quick of movement [v -ED, -ING, -S] / quick of movement [adj BRISKER, BRISKEST, BRISKLY]\n",
  "BRISKED": "BRISK, to make quick of movement [v]\n",
  "BRISKEN": "to make brisk [v -ED, -ING, -S]\n",
  "BRISKENED": "BRISKEN, to make brisk [v]\n",
  "BRISKENING": "BRISKEN, to make brisk [v]\n",
  "BRISKENS": "BRISKEN, to make brisk [v]\n",
  "BRISKER": "BRISK, quick of movement [adj]\n",
  "BRISKEST": "BRISK, quick of movement [adj]\n",
  "BRISKET": "meat from the breast of an animal, also BREASKIT [n -S]\n",
  "BRISKETS": "BRISKET, meat from the breast of an animal, also BREASKIT [n]\n",
  "BRISKIER": "BRISKY, (Shakespeare) brisk [adj]\n",
  "BRISKIEST": "BRISKY, (Shakespeare) brisk [adj]\n",
  "BRISKING": "BRISK, to make quick of movement [v]\n",
  "BRISKISH": "somewhat brisk [adj]\n",
  "BRISKLY": "BRISK, quick of movement [adv]\n",
  "BRISKNESS": "the state of being brisk [n -ES]\n",
  "BRISKNESSES": "BRISKNESS, the state of being brisk [n]\n",
  "BRISKS": "BRISK, to make quick of movement [v]\n",
  "BRISKY": "(Shakespeare) brisk [adj BRISKIER, BRISKIEST]\n",
  "BRISLING": "(Norwegian) a Norwegian sprat [n -S]\n",
  "BRISLINGS": "BRISLING, (Norwegian) a Norwegian sprat [n]\n",
  "BRISS": "(Hebrew) a Jewish circumcision rite, also BRITH, BRIS [n -ES]\n",
  "BRISSES": "BRISS, (Hebrew) a Jewish circumcision rite, also BRITH, BRIS [n]\n",
  "BRISTLE": "to stand erect stiffly [v BRISTLED, BRISTLING, BRISTLES]\n",
  "BRISTLECONE": "a western American pine with bristlelike prickles on its cones [n -S]\n",
  "BRISTLECONES": "BRISTLECONE, a western American pine with bristlelike prickles on its cones [n]\n",
  "BRISTLED": "BRISTLE, to stand erect stiffly [v]\n",
  "BRISTLELIKE": "like a bristle [adj]\n",
  "BRISTLES": "BRISTLE, to stand erect stiffly [v]\n",
  "BRISTLETAIL": "another name for the silverfish [n -S]\n",
  "BRISTLETAILS": "BRISTLETAIL, another name for the silverfish [n]\n",
  "BRISTLIER": "BRISTLY, stiffly erect [adj]\n",
  "BRISTLIEST": "BRISTLY, stiffly erect [adj]\n",
  "BRISTLINESS": "the state of being bristly [n -ES]\n",
  "BRISTLINESSES": "BRISTLINESS, the state of being bristly [n]\n",
  "BRISTLING": "BRISTLE, to stand erect stiffly [v]\n",
  "BRISTLY": "stiffly erect [adj BRISTLIER, BRISTLIEST]\n",
  "BRISTOL": "a smooth cardboard [n -S]\n",
  "BRISTOLS": "BRISTOL, a smooth cardboard [n]\n",
  "BRISURE": "(French) a part of a parapet breaking from the general direction [n -S]\n",
  "BRISURES": "BRISURE, (French) a part of a parapet breaking from the general direction [n]\n",
  "BRIT": "a young herring, also BRITT [n -S]\n",
  "BRITANNIA": "an alloy of tin and antimony with a low melting point, also BRITTANIA [n -S]\n",
  "BRITANNIAS": "BRITANNIA, an alloy of tin and antimony with a low melting point, also BRITTANIA [n]\n",
  "BRITCHES": "a type of trousers, also BREECHES, BREEKS [n]\n",
  "BRITH": "(Hebrew) a Jewish circumcision rite, also BRISS, BRIS [n -S]\n",
  "BRITHS": "BRITH, (Hebrew) a Jewish circumcision rite, also BRISS, BRIS [n]\n",
  "BRITS": "BRIT, a young herring, also BRITT [n]\n",
  "BRITSCHKA": "(Polish) an open four-wheeled carriage with a folding top, also BRITSKA, BRITZKA, BRITZSKA [n -S]\n",
  "BRITSCHKAS": "BRITSCHKA, (Polish) an open four-wheeled carriage with a folding top, also BRITSKA, BRITZKA, BRITZSKA [n]\n",
  "BRITSKA": "(Polish) a four-wheeled carriage with a folding top, also BRITZKA, BRITZSKA [n -S]\n",
  "BRITSKAS": "BRITSKA, (Polish) a four-wheeled carriage with a folding top, also BRITZKA, BRITZSKA [n]\n",
  "BRITT": "a young herring, also BRIT [n -S]\n",
  "BRITTANIA": "an alloy of tin and antimony with a low melting point, also BRITANNIA [n -S]\n",
  "BRITTANIAS": "BRITTANIA, an alloy of tin and antimony with a low melting point, also BRITANNIA [n]\n",
  "BRITTLE": "to become fragile [v BRITTLED, BRITTLING, BRITTLES] / frail [adj BRITTLER, BRITTLEST, BRITTLELY or BRITTLY]\n",
  "BRITTLED": "BRITTLE, to become fragile [v]\n",
  "BRITTLELY": "BRITTLE, frail [adv]\n",
  "BRITTLENESS": "the state of being brittle [n -ES]\n",
  "BRITTLENESSES": "BRITTLENESS, the state of being brittle [n]\n",
  "BRITTLER": "BRITTLE, frail [adj]\n",
  "BRITTLES": "BRITTLE, to become fragile [v]\n",
  "BRITTLEST": "BRITTLE, frail [adj]\n",
  "BRITTLING": "BRITTLE, to become fragile [v]\n",
  "BRITTLY": "BRITTLE, frail [adv]\n",
  "BRITTS": "BRITT, a young herring, also BRIT [n]\n",
  "BRITZKA": "(Polish) a four-wheeled carriage with a folding top, also BRITSKA, BRITZSKA [n -S]\n",
  "BRITZKAS": "BRITZKA, (Polish) a four-wheeled carriage with a folding top, also BRITSKA, BRITZSKA [n]\n",
  "BRITZSKA": "(Polish) a four-wheeled carriage with a folding top, also BRITSKA, BRITZKA [n -S]\n",
  "BRITZSKAS": "BRITZSKA, (Polish) a four-wheeled carriage with a folding top, also BRITSKA, BRITZKA [n]\n",
  "BRIZE": "furnace refuse used in making breeze blocks [n -S]\n",
  "BRIZES": "BRIZE, furnace refuse used in making breeze blocks [n]\n",
  "BRO": "buddy, pal, also BRU [n -S]\n",
  "BROACH": "to pierce (a cask) [v -ED, -ING, -ES]\n",
  "BROACHED": "BROACH, to pierce (a cask) [v]\n",
  "BROACHER": "a spit; a broach [n -S]\n",
  "BROACHERS": "BROACHER, a spit; a broach [n]\n",
  "BROACHES": "BROACH, to pierce (a cask) [v]\n",
  "BROACHING": "BROACH, to pierce (a cask) [v]\n",
  "BROAD": "an expansion of a river [n -S] / broad [adj BROADER, BROADEST]\n",
  "BROADAX": "an ancient military weapon; a battleax, also BROADAXE [n -ES]\n",
  "BROADAXE": "an ancient military weapon; a battleax, also BROADAX [n -S]\n",
  "BROADAXES": "BROADAXE, an ancient military weapon; a battleax, also BROADAX [n]\n",
  "BROADBAND": "across, involving, or designed to operate across, a wide range of frequencies [adj] / a broadband service [n -S]\n",
  "BROADBANDS": "BROADBAND, a broadband service [n]\n",
  "BROADBEAN": "a leguminous vegetable [n -S]\n",
  "BROADBEANS": "BROADBEAN, a leguminous vegetable [n]\n",
  "BROADBILL": "any of several birds with a broad bill, such as the spoonbill or scaup [n -S]\n",
  "BROADBILLS": "BROADBILL, any of several birds with a broad bill, such as the spoonbill or scaup [n]\n",
  "BROADBRIM": "a broad-brimmed hat esp. one worn by the Quakers in the 17th century [n -S]\n",
  "BROADBRIMS": "BROADBRIM, a broad-brimmed hat esp. one worn by the Quakers in the 17th century [n]\n",
  "BROADBRUSH": "rough, not worked out in detail [adj]\n",
  "BROADCAST": "to scatter, send out, disseminate [v BROADCAST or BROADCASTED, BROADCASTING, BROADCASTS]\n",
  "BROADCASTED": "BROADCAST, to scatter, send out, disseminate [v]\n",
  "BROADCASTER": "one who broadcasts [n -S]\n",
  "BROADCASTERS": "BROADCASTER, one who broadcasts [n]\n",
  "BROADCASTING": "sending out, dissemination [n -S]\n",
  "BROADCASTINGS": "BROADCASTING, sending out, dissemination [n]\n",
  "BROADCASTS": "BROADCAST, to scatter, send out, disseminate [v]\n",
  "BROADCLOTH": "dense twilled wool or worsted fabric [n -S]\n",
  "BROADCLOTHS": "BROADCLOTH, dense twilled wool or worsted fabric [n]\n",
  "BROADEN": "to make wider [v -ED, -ING, -S]\n",
  "BROADENED": "BROADEN, to make wider [v]\n",
  "BROADENER": "one who broadens [n -S]\n",
  "BROADENERS": "BROADENER, one who broadens [n]\n",
  "BROADENING": "BROADEN, to make wider [v]\n",
  "BROADENS": "BROADEN, to make wider [v]\n",
  "BROADER": "BROAD, broad [adj]\n",
  "BROADEST": "BROAD, broad [adj]\n",
  "BROADISH": "somewhat broad [adj]\n",
  "BROADLEAF": "a tree having broad leaves, specifically having leaves that are not needles [n BROADLEAVES]\n",
  "BROADLEAVED": "having broad leaves, deciduous [adj]\n",
  "BROADLEAVES": "BROADLEAF, a tree having broad leaves, specifically having leaves that are not needles [n]\n",
  "BROADLINE": "a company dealing in large volumes of cheap products [n -S]\n",
  "BROADLINES": "BROADLINE, a company dealing in large volumes of cheap products [n]\n",
  "BROADLOOM": "woven on a wide loom [adj] / a broadloom carpet [n -S]\n",
  "BROADLOOMS": "BROADLOOM, a broadloom carpet [n]\n",
  "BROADLY": "BROAD, broad [adv]\n",
  "BROADNESS": "the state of being broad [n -ES]\n",
  "BROADNESSES": "BROADNESS, the state of being broad [n]\n",
  "BROADPIECE": "an old English gold coin, broader than a guinea, as a Carolus or Jacobus [n -S]\n",
  "BROADPIECES": "BROADPIECE, an old English gold coin, broader than a guinea, as a Carolus or Jacobus [n]\n",
  "BROADS": "BROAD, an expansion of a river [n]\n",
  "BROADSCALE": "broad in extent, range or effect [adj]\n",
  "BROADSHEET": "a newspaper of large format, measuring approximately 40 by 60 cm. (about 16 by 24 in.); a quality newspaper [n -S]\n",
  "BROADSHEETS": "BROADSHEET, a newspaper of large format, measuring approximately 40 by 60 cm. (about 16 by 24 in.); a quality newspaper [n]\n",
  "BROADSIDE": "all the guns on one side of a ship of war; their simultaneous discharge [n -S] / to deliver a broadside [v BROADSIDED, BROADSIDING, BROADSIDES]\n",
  "BROADSIDED": "BROADSIDE, to deliver a broadside [v]\n",
  "BROADSIDES": "BROADSIDE, all the guns on one side of a ship of war; their simultaneous discharge [n]\n",
  "BROADSIDING": "BROADSIDE, to deliver a broadside [v]\n",
  "BROADSWORD": "a large heavy sword with a broad blade for cutting rather than thrusting [n -S]\n",
  "BROADSWORDS": "BROADSWORD, a large heavy sword with a broad blade for cutting rather than thrusting [n]\n",
  "BROADTAIL": "a karakul sheep; fur prepared from the skin of very young karakul lambs [n -S]\n",
  "BROADTAILS": "BROADTAIL, a karakul sheep; fur prepared from the skin of very young karakul lambs [n]\n",
  "BROADWAY": "a broad road [n -S]\n",
  "BROADWAYS": "BROADWAY, a broad road [n]\n",
  "BROADWISE": "breadthwise [adv]\n",
  "BROAST": "to boil and roast food [v -ED, -ING, -S]\n",
  "BROASTED": "BROAST, to boil and roast food [v]\n",
  "BROASTING": "BROAST, to boil and roast food [v]\n",
  "BROASTS": "BROAST, to boil and roast food [v]\n",
  "BROBDINGNAGIAN": "marked by tremendous size [adj]\n",
  "BROCADE": "(French) to weave a silky fabric with a raised design [v BROCADED, BROCADING, BROCADES]\n",
  "BROCADED": "BROCADE, (French) to weave a silky fabric with a raised design [v]\n",
  "BROCADES": "BROCADE, (French) to weave a silky fabric with a raised design [v]\n",
  "BROCADING": "BROCADE, (French) to weave a silky fabric with a raised design [v]\n",
  "BROCAGE": "the business of a broker [n -S]\n",
  "BROCAGES": "BROCAGE, the business of a broker [n]\n",
  "BROCARD": "(French) an elementary legal principle or maxim [n -S]\n",
  "BROCARDS": "BROCARD, (French) an elementary legal principle or maxim [n]\n",
  "BROCATEL": "(French) a stiff, originally silk-and-linen, heavy-figured fabric like brocade, also BROCATELLE [n -S]\n",
  "BROCATELLE": "(French) a stiff, originally silk-and-linen, heavy-figured fabric like brocade, also BROCATEL [n -S]\n",
  "BROCATELLES": "BROCATELLE, (French) a stiff, originally silk-and-linen, heavy-figured fabric like brocade, also BROCATEL [n]\n",
  "BROCATELS": "BROCATEL, (French) a stiff, originally silk-and-linen, heavy-figured fabric like brocade, also BROCATELLE [n]\n",
  "BROCCOLI": "a plant of the cabbage species, resembling the cauliflower, also BROCOLI [n -S]\n",
  "BROCCOLINI": "(tradename) a cultivated variety of cabbage [n -S]\n",
  "BROCCOLINIS": "BROCCOLINI, (tradename) a cultivated variety of cabbage [n]\n",
  "BROCCOLIS": "BROCCOLI, a plant of the cabbage species, resembling the cauliflower, also BROCOLI [n]\n",
  "BROCH": "to broach, to pierce [v -ED, -ING, -S] / a circular tower, also BROGH, BROUGH [n -S]\n",
  "BROCHAN": "(Gaelic) gruel, porridge [n -S]\n",
  "BROCHANS": "BROCHAN, (Gaelic) gruel, porridge [n]\n",
  "BROCHE": "(French) a fabric similar to brocade [n -S]\n",
  "BROCHED": "BROCH, to broach, to pierce [v]\n",
  "BROCHES": "BROCHE, (French) a fabric similar to brocade [n]\n",
  "BROCHETTE": "(French) a skewer for holding food steady while cooking [n -S]\n",
  "BROCHETTES": "BROCHETTE, (French) a skewer for holding food steady while cooking [n]\n",
  "BROCHING": "BROCH, to broach, to pierce [v]\n",
  "BROCHO": "(Hebrew) a blessing, also BRACHAH [n -S]\n",
  "BROCHOS": "BROCHO, (Hebrew) a blessing, also BRACHAH [n]\n",
  "BROCHS": "BROCH, to broach, to pierce [v]\n",
  "BROCHURE": "a pamphlet, information or publicity booklet [n -S]\n",
  "BROCHURES": "BROCHURE, a pamphlet, information or publicity booklet [n]\n",
  "BROCK": "a badger [n -S]\n",
  "BROCKAGE": "(Scots) fragments of crockery etc. [n -S]\n",
  "BROCKAGES": "BROCKAGE, (Scots) fragments of crockery etc. [n]\n",
  "BROCKED": "(Scots) variegated, esp. black and white, also BROCKIT [adj]\n",
  "BROCKET": "a male red deer two years old, with its first dagger-shaped horns [n -S]\n",
  "BROCKETS": "BROCKET, a male red deer two years old, with its first dagger-shaped horns [n]\n",
  "BROCKIT": "(Scots) variegated, esp. black and white, also BROCKED [adj]\n",
  "BROCKRAM": "(dialect) fragmented rock, breccia [n -S]\n",
  "BROCKRAMS": "BROCKRAM, (dialect) fragmented rock, breccia [n]\n",
  "BROCKS": "BROCK, a badger [n]\n",
  "BROCOLI": "a plant of the cabbage species, resembling the cauliflower, also BROCCOLI [n -S]\n",
  "BROCOLIS": "BROCOLI, a plant of the cabbage species, resembling the cauliflower, also BROCCOLI [n]\n",
  "BROD": "(dialect) to prod [v BRODDED, BRODDING, BRODS]\n",
  "BRODDED": "BROD, (dialect) to prod [v]\n",
  "BRODDING": "BROD, (dialect) to prod [v]\n",
  "BRODDLE": "(dialect) to poke or pierce [v BRODDLED, BRODDLING, BRODDLES]\n",
  "BRODDLED": "BRODDLE, (dialect) to poke or pierce [v]\n",
  "BRODDLES": "BRODDLE, (dialect) to poke or pierce [v]\n",
  "BRODDLING": "BRODDLE, (dialect) to poke or pierce [v]\n",
  "BRODEKIN": "a high boot worn by classical actors, also BRODKIN [n -S]\n",
  "BRODEKINS": "BRODEKIN, a high boot worn by classical actors, also BRODKIN [n]\n",
  "BRODKIN": "a high boot worn by classical actors, also BRODEKIN [n -S]\n",
  "BRODKINS": "BRODKIN, a high boot worn by classical actors, also BRODEKIN [n]\n",
  "BRODS": "BROD, (dialect) to prod [v]\n",
  "BROEKIES": "(South African) underpants [n]\n",
  "BROG": "(Scots) to prick with an awl [v BROGGED, BROGGING, BROGS]\n",
  "BROGAN": "a strong and tough working shoe, also BROGUE [n -S]\n",
  "BROGANS": "BROGAN, a strong and tough working shoe, also BROGUE [n]\n",
  "BROGGED": "BROG, (Scots) to prick with an awl [v]\n",
  "BROGGING": "BROG, (Scots) to prick with an awl [v]\n",
  "BROGH": "a dry-built circular tower of the late Iron Age, also BROCH, BROUGH [n -S]\n",
  "BROGHS": "BROGH, a dry-built circular tower of the late Iron Age, also BROCH, BROUGH [n]\n",
  "BROGS": "BROG, (Scots) to prick with an awl [v]\n",
  "BROGUE": "a strong and tough working shoe, also BROGAN [n -S]\n",
  "BROGUEISH": "having a slight brogue, also BROGUISH [adj]\n",
  "BROGUERIES": "BROGUERY, the use of an Irish accent [n]\n",
  "BROGUERY": "the use of an Irish accent [n BROGUERIES]\n",
  "BROGUES": "BROGUE, a strong and tough working shoe, also BROGAN [n]\n",
  "BROGUISH": "having a brogue [adj]\n",
  "BROIDER": "to adorn with needlework [v -ED, -ING, -S]\n",
  "BROIDERED": "BROIDER, to adorn with needlework [v]\n",
  "BROIDERER": "(archaic) one who embroiders, also EMBROIDERER [n -S]\n",
  "BROIDERERS": "BROIDERER, (archaic) one who embroiders, also EMBROIDERER [n]\n",
  "BROIDERIES": "BROIDERY, the act of broidering [n]\n",
  "BROIDERING": "embroidery [n -S]\n",
  "BROIDERINGS": "BROIDERING, embroidery [n]\n",
  "BROIDERS": "BROIDER, to adorn with needlework [v]\n",
  "BROIDERY": "the act of broidering [n BROIDERIES]\n",
  "BROIL": "to cook over hot coals [v -ED, -ING, -S]\n",
  "BROILED": "BROIL, to cook over hot coals [v]\n",
  "BROILER": "a quickly-reared young chicken sold ready for broiling [n -S]\n",
  "BROILERS": "BROILER, a quickly-reared young chicken sold ready for broiling [n]\n",
  "BROILING": "BROIL, to cook over hot coals [v]\n",
  "BROILS": "BROIL, to cook over hot coals [v]\n",
  "BROKAGE": "the business or employment of a broker, also BROCAGE, BROKERAGE, BROKERY [n -S]\n",
  "BROKAGES": "BROKAGE, the business or employment of a broker, also BROCAGE, BROKERAGE, BROKERY [n]\n",
  "BROKE": "to act as a stockbroker, also BROKER [v BROKED, BROKING, BROKES]\n",
  "BROKED": "BROKE, to act as a stockbroker, also BROKER [v]\n",
  "BROKEN": "BREAK, to shatter or damage [v]\n",
  "BROKENHEARTED": "greatly depressed or hurt [adj BROKENHEARTEDLY]\n",
  "BROKENHEARTEDLY": "BROKENHEARTED, greatly depressed or hurt [adv]\n",
  "BROKENLY": "BROKEN, BREAK, to shatter or damage [adv]\n",
  "BROKENNESS": "the state of being broken [n -ES]\n",
  "BROKENNESSES": "BROKENNESS, the state of being broken [n]\n",
  "BROKER": "to act as a stockbroker, also BROKE [v -ED, -ING, -S]\n",
  "BROKERAGE": "the business or employment of a broker, also BROCAGE, BROKAGE, BROKERY [n -S]\n",
  "BROKERAGES": "BROKERAGE, the business or employment of a broker, also BROCAGE, BROKAGE, BROKERY [n]\n",
  "BROKERED": "BROKER, to act as a stockbroker, also BROKE [v]\n",
  "BROKERIES": "BROKERY, a broker's business [n]\n",
  "BROKERING": "bargaining, negotiation [n -S]\n",
  "BROKERINGS": "BROKERING, bargaining, negotiation [n]\n",
  "BROKERS": "BROKER, to act as a stockbroker, also BROKE [v]\n",
  "BROKERY": "a broker's business [n BROKERIES]\n",
  "BROKES": "BROKE, to act as a stockbroker, also BROKER [v]\n",
  "BROKING": "the business of buying stocks and shares [n -S]\n",
  "BROKINGS": "BROKING, the business of buying stocks and shares [n]\n",
  "BROLGA": "(Native Australian) a large grey Australian crane [n -S]\n",
  "BROLGAS": "BROLGA, (Native Australian) a large grey Australian crane [n]\n",
  "BROLLIES": "BROLLY, an umbrella [n]\n",
  "BROLLY": "an umbrella [n BROLLIES]\n",
  "BROMAL": "an oily, colorless fluid obtained by the action of bromine on alcohol [n -S]\n",
  "BROMALS": "BROMAL, an oily, colorless fluid obtained by the action of bromine on alcohol [n]\n",
  "BROMANCE": "a close but not romantic or sexual relationship between two men [n -S]\n",
  "BROMANCES": "BROMANCE, a close but not romantic or sexual relationship between two men [n]\n",
  "BROMANTIC": "characterising a close but not romantic or sexual relationship between two men [adj]\n",
  "BROMATE": "to combine with bromine [v BROMATED, BROMATING, BROMATES]\n",
  "BROMATED": "BROMATE, to combine with bromine [v]\n",
  "BROMATES": "BROMATE, to combine with bromine [v]\n",
  "BROMATING": "BROMATE, to combine with bromine [v]\n",
  "BROME": "a kind of grass resembling oats, also BROMEGRASS [n -S]\n",
  "BROMEGRASS": "a kind of grass resembling oats, also BROME [n -ES]\n",
  "BROMEGRASSES": "BROMEGRASS, a kind of grass resembling oats, also BROME [n]\n",
  "BROMELAIN": "an enzyme obtained from the juice of the pineapple plant, used medically and in skincare products, also BROMELIN [n -S]\n",
  "BROMELAINS": "BROMELAIN, an enzyme obtained from the juice of the pineapple plant, used medically and in skincare products, also BROMELIN [n]\n",
  "BROMELIA": "any plant of the genus Bromelia, that includes pineapples, also BROMELIAD [n -S]\n",
  "BROMELIACEOUS": "belonging to the Bromeliaceae, the pineapple family [adj]\n",
  "BROMELIAD": "any plant of the genus Bromelia, that includes pineapples, also BROMELIA [n -S]\n",
  "BROMELIADS": "BROMELIAD, any plant of the genus Bromelia, that includes pineapples, also BROMELIA [n]\n",
  "BROMELIAS": "BROMELIA, any plant of the genus Bromelia, that includes pineapples, also BROMELIAD [n]\n",
  "BROMELIN": "an enzyme obtained from the juice of the pineapple plant, used medically and in skincare products, also BROMELAIN [n -S]\n",
  "BROMELINS": "BROMELIN, an enzyme obtained from the juice of the pineapple plant, used medically and in skincare products, also BROMELAIN [n]\n",
  "BROMEOSIN": "another name for eosin, a red dye stuff [n -S]\n",
  "BROMEOSINS": "BROMEOSIN, another name for eosin, a red dye stuff [n]\n",
  "BROMES": "BROME, a kind of grass resembling oats, also BROMEGRASS [n]\n",
  "BROMHIDROSES": "BROMHIDROSIS, foul-smelling sweat; body odor, also BROMIDROSIS [n]\n",
  "BROMHIDROSIS": "foul-smelling sweat; body odor, also BROMIDROSIS [n BROMHIDROSES]\n",
  "BROMIC": "as in bromic acid, an acid derived from bromine [adj]\n",
  "BROMID": "a bromine compound, also BROMIDE [n -S]\n",
  "BROMIDE": "a bromine compound, also BROMID [n -S]\n",
  "BROMIDES": "BROMIDE, a bromine compound, also BROMID [n]\n",
  "BROMIDIC": "conventional, commonplace [adj]\n",
  "BROMIDROSES": "BROMIDROSIS, foul-smelling sweat; body odor, also BROMHIDROSIS [n]\n",
  "BROMIDROSIS": "foul-smelling sweat; body odor, also BROMHIDROSIS [n BROMIDROSES]\n",
  "BROMIDS": "BROMID, a bromine compound, also BROMIDE [n]\n",
  "BROMIN": "a volatile liquid element, also BROMINE [n -S]\n",
  "BROMINATE": "to treat with bromine [v BROMINATED, BROMINATING, BROMINATES]\n",
  "BROMINATED": "BROMINATE, to treat with bromine [v]\n",
  "BROMINATES": "BROMINATE, to treat with bromine [v]\n",
  "BROMINATING": "BROMINATE, to treat with bromine [v]\n",
  "BROMINATION": "the substitution by bromine in or the addition of bromine to organic compounds [n -S]\n",
  "BROMINATIONS": "BROMINATION, the substitution by bromine in or the addition of bromine to organic compounds [n]\n",
  "BROMINE": "a volatile liquid element, also BROMIN [n -S]\n",
  "BROMINES": "BROMINE, a volatile liquid element, also BROMIN [n]\n",
  "BROMINISM": "poisoning by an overdose of bromine, also BROMISM [n -S]\n",
  "BROMINISMS": "BROMINISM, poisoning by an overdose of bromine, also BROMISM [n]\n",
  "BROMINS": "BROMIN, a volatile liquid element, also BROMINE [n]\n",
  "BROMISE": "to treat with bromine, also BROMIZE [v BROMISED, BROMISING, BROMISES]\n",
  "BROMISED": "BROMISE, to treat with bromine, also BROMIZE [v]\n",
  "BROMISES": "BROMISE, to treat with bromine, also BROMIZE [v]\n",
  "BROMISING": "BROMISE, to treat with bromine, also BROMIZE [v]\n",
  "BROMISM": "poisoning by an overdose of bromine, also BROMINISM [n -S]\n",
  "BROMISMS": "BROMISM, poisoning by an overdose of bromine, also BROMINISM [n]\n",
  "BROMIZE": "to treat with bromine, also BROMISE [v BROMIZED, BROMIZING, BROMIZES]\n",
  "BROMIZED": "BROMIZE, to treat with bromine, also BROMISE [v]\n",
  "BROMIZES": "BROMIZE, to treat with bromine, also BROMISE [v]\n",
  "BROMIZING": "BROMIZE, to treat with bromine, also BROMISE [v]\n",
  "BROMMER": "(South African) a bluebottle, also BRUMMER [n -S]\n",
  "BROMMERS": "BROMMER, (South African) a bluebottle, also BRUMMER [n]\n",
  "BROMO": "a medicinal compound containing bromine [n -S]\n",
  "BROMOCRIPTINE": "a polypeptide ergot derivative that mimics the activity of dopamine in inhibiting prolactin secretion [n -S]\n",
  "BROMOCRIPTINES": "BROMOCRIPTINE, a polypeptide ergot derivative that mimics the activity of dopamine in inhibiting prolactin secretion [n]\n",
  "BROMOFORM": "a bromine compound analogous to chloroform [n -S]\n",
  "BROMOFORMS": "BROMOFORM, a bromine compound analogous to chloroform [n]\n",
  "BROMOS": "BROMO, a medicinal compound containing bromine [n]\n",
  "BROMOURACIL": "a uracil derivative that is an analog of thymine and pairs readily with adenine and sometimes with guanine [n -S]\n",
  "BROMOURACILS": "BROMOURACIL, a uracil derivative that is an analog of thymine and pairs readily with adenine and sometimes with guanine [n]\n",
  "BRONC": "a native or a Mexican horse of small size, also BRONCO [n -S]\n",
  "BRONCHI": "BRONCHUS, (Latin) one of the main forks of the windpipe [n]\n",
  "BRONCHIA": "BRONCHIUM, (Latin) a small branch of the windpipe [n]\n",
  "BRONCHIAL": "belonging to the bronchi and their ramifications in the lungs [adj BRONCHIALLY]\n",
  "BRONCHIALLY": "BRONCHIAL, belonging to the bronchi and their ramifications in the lungs [adv]\n",
  "BRONCHIECTASES": "BRONCHIECTASIS, a chronic dilatation of bronchi or bronchioles [n]\n",
  "BRONCHIECTASIS": "a chronic dilatation of bronchi or bronchioles [n BRONCHIECTASES]\n",
  "BRONCHIOLAR": "like a bronchiole [adj]\n",
  "BRONCHIOLE": "a minute bronchial tube [n -S]\n",
  "BRONCHIOLES": "BRONCHIOLE, a minute bronchial tube [n]\n",
  "BRONCHIOLITIS": "inflammation of the bronchial tubes [n -ES]\n",
  "BRONCHIOLITISES": "BRONCHIOLITIS, inflammation of the bronchial tubes [n]\n",
  "BRONCHITIC": "of or pertaining to bronchitis [adj] / one suffering from bronchitis [n -S]\n",
  "BRONCHITICS": "BRONCHITIC, one suffering from bronchitis [n]\n",
  "BRONCHITIS": "inflammation, acute or chronic, of the bronchial tubes or any part of them [n -ES]\n",
  "BRONCHITISES": "BRONCHITIS, inflammation, acute or chronic, of the bronchial tubes or any part of them [n]\n",
  "BRONCHIUM": "(Latin) a small branch of the windpipe [n BRONCHIA]\n",
  "BRONCHO": "(Spanish) a native or a Mexican horse of small size, also BRONC, BRONCO [n -S]\n",
  "BRONCHODILATOR": "a drug that relaxes bronchial muscle resulting in expansion of the bronchial air passages [n -S]\n",
  "BRONCHODILATORS": "BRONCHODILATOR, a drug that relaxes bronchial muscle resulting in expansion of the bronchial air passages [n]\n",
  "BRONCHOGENIC": "of, relating to, or arising in or by way of the air passages of the lungs [adj]\n",
  "BRONCHOGRAPHIES": "BRONCHOGRAPHY, radiological examination of the trachea or bronchi [n]\n",
  "BRONCHOGRAPHY": "radiological examination of the trachea or bronchi [n BRONCHOGRAPHIES]\n",
  "BRONCHOS": "BRONCHO, (Spanish) a native or a Mexican horse of small size, also BRONC, BRONCO [n]\n",
  "BRONCHOSCOPE": "an instrument for examining the windpipe [n -S]\n",
  "BRONCHOSCOPES": "BRONCHOSCOPE, an instrument for examining the windpipe [n]\n",
  "BRONCHOSCOPIC": "relating to bronchoscopy, examination of the bronchi, also BRONCHOSCOPICAL [adj]\n",
  "BRONCHOSCOPICAL": "relating to bronchoscopy, examination of the bronchi, also BRONCHOSCOPIC [adj]\n",
  "BRONCHOSCOPIES": "BRONCHOSCOPY, examination of the bronchi [n]\n",
  "BRONCHOSCOPIST": "one who uses a bronchoscope, an instrument for examining the windpipe [n -S]\n",
  "BRONCHOSCOPISTS": "BRONCHOSCOPIST, one who uses a bronchoscope, an instrument for examining the windpipe [n]\n",
  "BRONCHOSCOPY": "examination of the bronchi [n BRONCHOSCOPIES]\n",
  "BRONCHOSPASM": "constriction of the air passages of the lung (as in asthma) by spasmodic contraction of the bronchial muscles [n -S]\n",
  "BRONCHOSPASMS": "BRONCHOSPASM, constriction of the air passages of the lung (as in asthma) by spasmodic contraction of the bronchial muscles [n]\n",
  "BRONCHOSPASTIC": "relating to bronchospasm [adj]\n",
  "BRONCHUS": "(Latin) one of the main forks of the windpipe [n BRONCHI]\n",
  "BRONCO": "(Spanish) a native or a Mexican horse of small size, also BRONC, BRONCHO [n -S]\n",
  "BRONCOBUSTER": "one who breaks wild horses to the saddle [n -S]\n",
  "BRONCOBUSTERS": "BRONCOBUSTER, one who breaks wild horses to the saddle [n]\n",
  "BRONCOS": "BRONCO, (Spanish) a native or a Mexican horse of small size, also BRONC, BRONCHO [n]\n",
  "BRONCS": "BRONC, a native or a Mexican horse of small size, also BRONCO [n]\n",
  "BROND": "(obsolete) a brand, a sword [n -S]\n",
  "BRONDE": "of a shade between blonde and brunette [adj BRONDER, BRONDEST] / a woman whose hair is of this colour [n-S]\n",
  "BRONDER": "BRONDE, of a shade between blonde and brunette [adj]\n",
  "BRONDES": "BRONDE, a woman whose hair is of this colour [n]\n",
  "BRONDEST": "BRONDE, of a shade between blonde and brunette [adj]\n",
  "BRONDS": "BROND, (obsolete) a brand, a sword [n]\n",
  "BRONDYRON": "(Spenser) a brand, a sword [n -S]\n",
  "BRONDYRONS": "BRONDYRON, (Spenser) a brand, a sword [n]\n",
  "BRONTOBYTE": "a very large unit of computer memory [n -S]\n",
  "BRONTOBYTES": "BRONTOBYTE, a very large unit of computer memory [n]\n",
  "BRONTOSAUR": "any of a genus of large sauropod dinosaurs of the Jurassic, also BRONTOSAURUS [n -S]\n",
  "BRONTOSAURS": "BRONTOSAUR, any of a genus of large sauropod dinosaurs of the Jurassic, also BRONTOSAURUS [n]\n",
  "BRONTOSAURUS": "any of a genus of large sauropod dinosaurs of the Jurassic, also BRONTOSAUR [n -ES]\n",
  "BRONTOSAURUSES": "BRONTOSAURUS, any of a genus of large sauropod dinosaurs of the Jurassic, also BRONTOSAUR [n]\n",
  "BRONZE": "to colour brown or tan [v BRONZED, BRONZING, BRONZES]\n",
  "BRONZED": "BRONZE, to colour brown or tan [v]\n",
  "BRONZEN": "like bronze [adj]\n",
  "BRONZER": "a tanning cosmetic [n -S]\n",
  "BRONZERS": "BRONZER, a tanning cosmetic [n]\n",
  "BRONZES": "BRONZE, to colour brown or tan [v]\n",
  "BRONZIER": "BRONZY, of a brownish colour [adj]\n",
  "BRONZIEST": "BRONZY, of a brownish colour [adj]\n",
  "BRONZIFIED": "BRONZIFY, to make bronze [v]\n",
  "BRONZIFIES": "BRONZIFY, to make bronze [v]\n",
  "BRONZIFY": "to make bronze [v BRONZIFIED, BRONZIFYING, BRONZIFIES]\n",
  "BRONZIFYING": "BRONZIFY, to make bronze [v]\n",
  "BRONZING": "a brownish colouring [n -S]\n",
  "BRONZINGS": "BRONZING, a brownish colouring [n]\n",
  "BRONZITE": "a variety of the mineral enstatite with bronze-like lustre [n -S]\n",
  "BRONZITES": "BRONZITE, a variety of the mineral enstatite with bronze-like lustre [n]\n",
  "BRONZY": "of a brownish colour [adj BRONZIER, BRONZIEST]\n",
  "BROO": "(Scots) unemployment benefit; the office at which people receive it, also BUROO [n -S]\n",
  "BROOCH": "an ornament clasp [n -ES] / to adorn with a brooch [v -ED, -ING, -ES]\n",
  "BROOCHED": "BROOCH, to adorn with a brooch [v]\n",
  "BROOCHES": "BROOCH, to adorn with a brooch [v]\n",
  "BROOCHING": "BROOCH, to adorn with a brooch [v]\n",
  "BROOD": "to ponder gloomily [v -ED, -ING, -S]\n",
  "BROODED": "BROOD, to ponder gloomily [v]\n",
  "BROODER": "a heated building or enclosure for rearing young chicks [n -S]\n",
  "BROODERS": "BROODER, a heated building or enclosure for rearing young chicks [n]\n",
  "BROODIER": "BROODY, tending to brood [adj]\n",
  "BROODIEST": "BROODY, tending to brood [adj]\n",
  "BROODILY": "BROODY, tending to brood [adv]\n",
  "BROODINESS": "the state of being broody [n -ES]\n",
  "BROODINESSES": "BROODINESS, the state of being broody [n]\n",
  "BROODING": "pondering gloomily [adj BROODINGLY] / an act of brooding [n -S]\n",
  "BROODINGLY": "BROODING, pondering gloomily [adv]\n",
  "BROODINGS": "BROODING, an act of brooding [n]\n",
  "BROODLESS": "without a brood [adj]\n",
  "BROODMARE": "a mare for breeding [n -S]\n",
  "BROODMARES": "BROODMARE, a mare for breeding [n]\n",
  "BROODS": "BROOD, to ponder gloomily [v]\n",
  "BROODY": "tending to brood [adj BROODIER, BROODIEST]\n",
  "BROOK": "to tolerate [v -ED, -ING, -S]\n",
  "BROOKABLE": "that can be brooked, tolerated [adj]\n",
  "BROOKED": "BROOK, to tolerate [v]\n",
  "BROOKIE": "an American brook trout [n -S]\n",
  "BROOKIES": "BROOKIE, an American brook trout [n]\n",
  "BROOKING": "BROOK, to tolerate [v]\n",
  "BROOKITE": "a mineral, titanium oxide [n -S]\n",
  "BROOKITES": "BROOKITE, a mineral, titanium oxide [n]\n",
  "BROOKLET": "a small brook [n -S]\n",
  "BROOKLETS": "BROOKLET, a small brook [n]\n",
  "BROOKLIKE": "like a brook [adj]\n",
  "BROOKLIME": "a wild flower with small blue flowers [n -S]\n",
  "BROOKLIMES": "BROOKLIME, a wild flower with small blue flowers [n]\n",
  "BROOKS": "BROOK, to tolerate [v]\n",
  "BROOKWEED": "a small white-flowered herb found usually in wet places [n -S]\n",
  "BROOKWEEDS": "BROOKWEED, a small white-flowered herb found usually in wet places [n]\n",
  "BROOL": "(German) a deep murmur [n -S]\n",
  "BROOLS": "BROOL, (German) a deep murmur [n]\n",
  "BROOM": "to sweep with a broom [v -ED, -ING, -S]\n",
  "BROOMBALL": "(Canadian) a team game played on ice with brooms and a plastic ball [n -S]\n",
  "BROOMBALLER": "(Canadian) one who plays broomball [n -S]\n",
  "BROOMBALLERS": "BROOMBALLER, (Canadian) one who plays broomball [n]\n",
  "BROOMBALLS": "BROOMBALL, (Canadian) a team game played on ice with brooms and a plastic ball [n]\n",
  "BROOMCORN": "a kind of millet of whose stalks brooms are made [n -S]\n",
  "BROOMCORNS": "BROOMCORN, a kind of millet of whose stalks brooms are made [n]\n",
  "BROOMED": "BROOM, to sweep with a broom [v]\n",
  "BROOMIER": "BROOMY, abounding in broom (a shrub) [adj]\n",
  "BROOMIEST": "BROOMY, abounding in broom (a shrub) [adj]\n",
  "BROOMING": "BROOM, to sweep with a broom [v]\n",
  "BROOMRAPE": "a parasitic plant [n -S]\n",
  "BROOMRAPES": "BROOMRAPE, a parasitic plant [n]\n",
  "BROOMS": "BROOM, to sweep with a broom [v]\n",
  "BROOMSTAFF": "(archaic) a broomstick [n -S]\n",
  "BROOMSTAFFS": "BROOMSTAFF, (archaic) a broomstick [n]\n",
  "BROOMSTICK": "the long thin handle of a broom [n -S]\n",
  "BROOMSTICKS": "BROOMSTICK, the long thin handle of a broom [n]\n",
  "BROOMY": "abounding in broom (a shrub) [adj BROOMIER, BROOMIEST]\n",
  "BROOS": "BROO, (Scots) unemployment benefit; the office at which people receive it, also BUROO [n]\n",
  "BROOSE": "(Scots) a race at a wedding, also BROUZE [n -S]\n",
  "BROOSES": "BROOSE, (Scots) a race at a wedding, also BROUZE [n]\n",
  "BROS": "BRO, buddy, pal, also BRU [n]\n",
  "BROSE": "(Scots) a dish of oatmeal with boiling water or milk poured on it [n -S]\n",
  "BROSES": "BROSE, (Scots) a dish of oatmeal with boiling water or milk poured on it [n]\n",
  "BROSIER": "BROSY, having the quality of brose, a dish of oatmeal with boiling water or milk poured on it [adj]\n",
  "BROSIEST": "BROSY, having the quality of brose, a dish of oatmeal with boiling water or milk poured on it [adj]\n",
  "BROSY": "having the quality of brose, a dish of oatmeal with boiling water or milk poured on it [adj BROSIER, BROSIEST]\n",
  "BROTH": "a clear thin soup [n -S]\n",
  "BROTHA": "an African-American man [n -S]\n",
  "BROTHAS": "BROTHA, an African-American man [n]\n",
  "BROTHEL": "a house of prostitution [n -S]\n",
  "BROTHELS": "BROTHEL, a house of prostitution [n]\n",
  "BROTHER": "a male sibling [n BROTHERS or BRETHREN] / to treat like a brother [v -ED, -ING, -S]\n",
  "BROTHERED": "BROTHER, to treat like a brother [v]\n",
  "BROTHERHOOD": "the state of being brothers [n -S]\n",
  "BROTHERHOODS": "BROTHERHOOD, the state of being brothers [n]\n",
  "BROTHERING": "BROTHER, to treat like a brother [v]\n",
  "BROTHERLIER": "BROTHERLY, like a brother [adj]\n",
  "BROTHERLIEST": "BROTHERLY, like a brother [adj]\n",
  "BROTHERLIKE": "like a brother [adj]\n",
  "BROTHERLINESS": "the state of being brotherly [n -ES]\n",
  "BROTHERLINESSES": "BROTHERLINESS, the state of being brotherly [n]\n",
  "BROTHERLY": "like a brother [adj BROTHERLIER, BROTHERLIEST]\n",
  "BROTHERS": "BROTHER, to treat like a brother [v]\n",
  "BROTHIER": "BROTHY, like broth [adj]\n",
  "BROTHIEST": "BROTHY, like broth [adj]\n",
  "BROTHS": "BROTH, a clear thin soup [n]\n",
  "BROTHY": "like broth [adj BROTHIER, BROTHIEST]\n",
  "BROUGH": "a circular tower, also BROGH, BROCH [n -S]\n",
  "BROUGHAM": "a one-horse closed carriage [n -S]\n",
  "BROUGHAMS": "BROUGHAM, a one-horse closed carriage [n]\n",
  "BROUGHS": "BROUGH, a circular tower, also BROGH, BROCH [n]\n",
  "BROUGHT": "BRING, to take with oneself to a place [v]\n",
  "BROUGHTA": "a small portion added to a purchase of food by a vendor to encourage the person to return, also BRAATA, BRAATAS, BROUGHTAS [n -S]\n",
  "BROUGHTAS": "a small portion added to a purchase of food by a vendor to encourage the person to return, also BRAATA, BRAATAS, BROUGHTA [n -ES]\n",
  "BROUGHTASES": "BROUGHTAS, a small portion added to a purchase of food by a vendor to encourage the person to return, also BRAATA, BRAATAS, BROUGHTA [n]\n",
  "BROUHAHA": "(French) fuss, also BRUHAHA [n -S]\n",
  "BROUHAHAS": "BROUHAHA, (French) fuss, also BRUHAHA [n]\n",
  "BROUZE": "a wedding race, also BROOSE [n -S]\n",
  "BROUZES": "BROUZE, a wedding race, also BROOSE [n]\n",
  "BROW": "the eyebrow; the ridge over the eyes [n -S]\n",
  "BROWALLIA": "a flowering plant [n -S]\n",
  "BROWALLIAS": "BROWALLIA, a flowering plant [n]\n",
  "BROWBAND": "the bridle-strap that goes over a horse's forehead [n -S]\n",
  "BROWBANDS": "BROWBAND, the bridle-strap that goes over a horse's forehead [n]\n",
  "BROWBEAT": "to intimidate [v BROWBEAT, BROWBEATEN, BROWBEATING, BROWBEATS]\n",
  "BROWBEATEN": "BROWBEAT, to intimidate [v]\n",
  "BROWBEATER": "one who browbeats [n -S]\n",
  "BROWBEATERS": "BROWBEATER, one who browbeats [n]\n",
  "BROWBEATING": "intimidation [n -S]\n",
  "BROWBEATINGS": "BROWBEATING, intimidation [n]\n",
  "BROWBEATS": "BROWBEAT, to intimidate [v]\n",
  "BROWBONE": "the bone of the brow [n -S]\n",
  "BROWBONES": "BROWBONE, the bone of the brow [n]\n",
  "BROWED": "having a brow [adj]\n",
  "BROWLESS": "without eyebrows [adj]\n",
  "BROWN": "to make brown [v -ED, -ING, -S] / of a dark colour [adj BROWNER, BROWNEST]\n",
  "BROWNED": "BROWN, to make brown [v]\n",
  "BROWNER": "a fawning person [n -S]\n",
  "BROWNERS": "BROWNER, a fawning person [n]\n",
  "BROWNEST": "BROWN, of a dark colour [adj]\n",
  "BROWNFIELD": "a site that has previously been developed for urban or industrial use [n -S]\n",
  "BROWNFIELDS": "BROWNFIELD, a site that has previously been developed for urban or industrial use [n]\n",
  "BROWNIE": "a benevolent creature who may secretly help with domestic work [n -S]\n",
  "BROWNIER": "BROWNY, somewhat brown [adj]\n",
  "BROWNIES": "BROWNIE, a benevolent creature who may secretly help with domestic work [n]\n",
  "BROWNIEST": "BROWNY, somewhat brown [adj]\n",
  "BROWNING": "the process of making brown [n -S]\n",
  "BROWNINGS": "BROWNING, the process of making brown [n]\n",
  "BROWNISH": "somewhat brown [adj]\n",
  "BROWNNESS": "the state of being brown [n -ES]\n",
  "BROWNNESSES": "BROWNNESS, the state of being brown [n]\n",
  "BROWNNOSE": "to act sycophantically [v BROWNNOSED, BROWNNOSING, BROWNNOSES]\n",
  "BROWNNOSED": "BROWNNOSE, to act sycophantically [v]\n",
  "BROWNNOSER": "a sycophant [n -S]\n",
  "BROWNNOSERS": "BROWNNOSER, a sycophant [n]\n",
  "BROWNNOSES": "BROWNNOSE, to act sycophantically [v]\n",
  "BROWNNOSING": "BROWNNOSE, to act sycophantically [v]\n",
  "BROWNOUT": "a reduction in electrical power, a partial blackout [n -S]\n",
  "BROWNOUTS": "BROWNOUT, a reduction in electrical power, a partial blackout [n]\n",
  "BROWNS": "BROWN, to make brown [v]\n",
  "BROWNSHIRT": "a Nazi, a Fascist [n -S]\n",
  "BROWNSHIRTS": "BROWNSHIRT, a Nazi, a Fascist [n]\n",
  "BROWNSTONE": "a dark variety of sandstone, much used for building purposes [n -S]\n",
  "BROWNSTONES": "BROWNSTONE, a dark variety of sandstone, much used for building purposes [n]\n",
  "BROWNTAIL": "as in browntail moth, a brown and white European moth [adj]\n",
  "BROWNY": "somewhat brown [adj BROWNIER, BROWNIEST]\n",
  "BROWRIDGE": "a prominence of the frontal bone above the eye [n -S]\n",
  "BROWRIDGES": "BROWRIDGE, a prominence of the frontal bone above the eye [n]\n",
  "BROWS": "BROW, the eyebrow; the ridge over the eyes [n]\n",
  "BROWSABLE": "that can be browsed [adj] / something that can be browsed [n -S]\n",
  "BROWSABLES": "BROWSABLE, something that can be browsed [n]\n",
  "BROWSE": "to look at casually [v BROWSED, BROWSING, BROWSES]\n",
  "BROWSED": "BROWSE, to look at casually [v]\n",
  "BROWSER": "one who browses [n -S]\n",
  "BROWSERS": "BROWSER, one who browses [n]\n",
  "BROWSES": "BROWSE, to look at casually [v]\n",
  "BROWSIER": "BROWSY, relating to casual shopping [adj]\n",
  "BROWSIEST": "BROWSY, relating to casual shopping [adj]\n",
  "BROWSING": "the shoots of leaves and plants [n -S]\n",
  "BROWSINGS": "BROWSING, the shoots of leaves and plants [n]\n",
  "BROWST": "(Scots) a brewing [n -S]\n",
  "BROWSTS": "BROWST, (Scots) a brewing [n]\n",
  "BROWSY": "relating to casual shopping [adj BROWSIER, BROWSIEST]\n",
  "BRR": "used to indicate that one is cold, also BRRR [interj]\n",
  "BRRR": "used to indicate that one is cold, also BRR [interj]\n",
  "BRU": "(South African) buddy, pal, also BRO [n -S]\n",
  "BRUCELLA": "Any of a genus of harmful bacteria [n BRUCELLAS or BRUCELLAE]\n",
  "BRUCELLAE": "BRUCELLA, Any of a genus of harmful bacteria [n]\n",
  "BRUCELLAS": "BRUCELLA, Any of a genus of harmful bacteria [n]\n",
  "BRUCELLOSES": "BRUCELLOSIS, an undulant fever of cattle [n]\n",
  "BRUCELLOSIS": "an undulant fever of cattle [n BRUCELLOSES]\n",
  "BRUCHID": "a beetle of the family Bruchidae, whose larvae live on peas, beans etc. [n -S]\n",
  "BRUCHIDS": "BRUCHID, a beetle of the family Bruchidae, whose larvae live on peas, beans etc. [n]\n",
  "BRUCIN": "a poisonous alkaloid, also BRUCINE [n -S]\n",
  "BRUCINE": "a poisonous alkaloid, also BRUCIN [n -S]\n",
  "BRUCINES": "BRUCINE, a poisonous alkaloid, also BRUCIN [n]\n",
  "BRUCINS": "BRUCIN, a poisonous alkaloid, also BRUCINE [n]\n",
  "BRUCITE": "a mineral, magnesium hydroxide [n -S]\n",
  "BRUCITES": "BRUCITE, a mineral, magnesium hydroxide [n]\n",
  "BRUCKLE": "(Scots) liable to break, brittle [adj]\n",
  "BRUGH": "a borough [n -S]\n",
  "BRUGHS": "BRUGH, a borough [n]\n",
  "BRUGMANSIA": "any of a genus of woody shrubs or trees with pendulous flowers [n -S]\n",
  "BRUGMANSIAS": "BRUGMANSIA, any of a genus of woody shrubs or trees with pendulous flowers [n]\n",
  "BRUHAHA": "(French) a fuss, clamour, also BROUHAHA [n -S]\n",
  "BRUHAHAS": "BRUHAHA, (French) a fuss, clamour, also BROUHAHA [n]\n",
  "BRUILZIE": "(Scots) a broil, a noisy disturbance, also BRULYIE, BRULZIE [n -S]\n",
  "BRUILZIES": "BRUILZIE, (Scots) a broil, a noisy disturbance, also BRULYIE, BRULZIE [n]\n",
  "BRUIN": "a bear [n -S]\n",
  "BRUINS": "BRUIN, a bear [n]\n",
  "BRUISE": "to injure and discolour the skin [v BRUISED, BRUISING, BRUISES]\n",
  "BRUISED": "BRUISE, to injure and discolour the skin [v]\n",
  "BRUISER": "a big husky man [n -S]\n",
  "BRUISERS": "BRUISER, a big husky man [n]\n",
  "BRUISES": "BRUISE, to injure and discolour the skin [v]\n",
  "BRUISING": "the act of bruising [n -S]\n",
  "BRUISINGS": "BRUISING, the act of bruising [n]\n",
  "BRUIT": "(French) to spread by rumour [v -ED, -ING, -S]\n",
  "BRUITED": "BRUIT, (French) to spread by rumour [v]\n",
  "BRUITER": "one that bruits [n -S]\n",
  "BRUITERS": "BRUITER, one that bruits [n]\n",
  "BRUITING": "BRUIT, (French) to spread by rumour [v]\n",
  "BRUITS": "BRUIT, (French) to spread by rumour [v]\n",
  "BRULE": "(French) a mixed race person of Canadian Indian and French ancestry [n -S]\n",
  "BRULES": "BRULE, (French) a mixed race person of Canadian Indian and French ancestry [n]\n",
  "BRULOT": "(Canadian) a biting fly [n -S]\n",
  "BRULOTS": "BRULOT, (Canadian) a biting fly [n]\n",
  "BRULYIE": "(Scots) a broil, a noisy disturbance, also BRUILZIE, BRULZIE [n -S]\n",
  "BRULYIES": "BRULYIE, (Scots) a broil, a noisy disturbance, also BRUILZIE, BRULZIE [n]\n",
  "BRULZIE": "(Scots) a broil, a noisy disturbance, also BRUILZIE, BRULYIE [n -S]\n",
  "BRULZIES": "BRULZIE, (Scots) a broil, a noisy disturbance, also BRUILZIE, BRULYIE [n]\n",
  "BRUMAL": "indicative of or occurring in the winter [adj]\n",
  "BRUMBIES": "BRUMBY, (Australian slang) a wild horse [n]\n",
  "BRUMBY": "(Australian slang) a wild horse [n BRUMBIES]\n",
  "BRUME": "mist or fog [n -S]\n",
  "BRUMES": "BRUME, mist or fog [n]\n",
  "BRUMMAGEM": "making an imposing display but inferior and of little worth [adj] / something showy but cheap [n -S]\n",
  "BRUMMAGEMS": "BRUMMAGEM, something showy but cheap [n]\n",
  "BRUMMER": "(South African) a bluebottle, also BROMMER [n -S]\n",
  "BRUMMERS": "BRUMMER, (South African) a bluebottle, also BROMMER [n]\n",
  "BRUMOUS": "relating to fog [adj]\n",
  "BRUNCH": "to eat a late morning meal [v -ED, -ING, -ES]\n",
  "BRUNCHED": "BRUNCH, to eat a late morning meal [v]\n",
  "BRUNCHER": "someone who eats brunch [n -S]\n",
  "BRUNCHERS": "BRUNCHER, someone who eats brunch [n]\n",
  "BRUNCHES": "BRUNCH, to eat a late morning meal [v]\n",
  "BRUNCHING": "BRUNCH, to eat a late morning meal [v]\n",
  "BRUNET": "a (male) person with brown or dark hair [n -S]\n",
  "BRUNETS": "BRUNET, a (male) person with brown or dark hair [n]\n",
  "BRUNETTE": "a (female) person with brown or dark hair [n -S]\n",
  "BRUNETTES": "BRUNETTE, a (female) person with brown or dark hair [n]\n",
  "BRUNG": "BRING, to take with oneself to a place [v]\n",
  "BRUNIZEM": "(Russian) a prairie soil [n -S]\n",
  "BRUNIZEMS": "BRUNIZEM, (Russian) a prairie soil [n]\n",
  "BRUNT": "to bear the chief stress of [v -ED, -ING, -S]\n",
  "BRUNTED": "BRUNT, to bear the chief stress of [v]\n",
  "BRUNTING": "BRUNT, to bear the chief stress of [v]\n",
  "BRUNTS": "BRUNT, to bear the chief stress of [v]\n",
  "BRUS": "BRU, (South African) buddy, pal, also BRO [n]\n",
  "BRUSCHETTA": "(Italian) toasted ciabatta or other bread coated with olive oil and topped with grilled tomatoes etc. [n BRUSCHETTAS or BRUSCHETTE]\n",
  "BRUSCHETTAS": "BRUSCHETTA, (Italian) toasted ciabatta or other bread coated with olive oil and topped with grilled tomatoes etc. [n]\n",
  "BRUSCHETTE": "BRUSCHETTA, (Italian) toasted ciabatta or other bread coated with olive oil and topped with grilled tomatoes etc. [n]\n",
  "BRUSH": "to touch lightly [v -ED, -ING, -ES]\n",
  "BRUSHABILITIES": "BRUSHABILITY, the capacity for being brushed [n]\n",
  "BRUSHABILITY": "the capacity for being brushed [n BRUSHABILITIES]\n",
  "BRUSHABLE": "able to be brushed [adj]\n",
  "BRUSHBACK": "a fastball intentionally thrown near the batter's head or body [n -S]\n",
  "BRUSHBACKS": "BRUSHBACK, a fastball intentionally thrown near the batter's head or body [n]\n",
  "BRUSHED": "BRUSH, to touch lightly [v]\n",
  "BRUSHER": "one who brushes [n -S]\n",
  "BRUSHERS": "BRUSHER, one who brushes [n]\n",
  "BRUSHES": "BRUSH, to touch lightly [v]\n",
  "BRUSHFIRE": "a border war, involving mobilization only on a small and local scale [n -S]\n",
  "BRUSHFIRES": "BRUSHFIRE, a border war, involving mobilization only on a small and local scale [n]\n",
  "BRUSHIER": "BRUSHY, resembling a brush; shaggy [adj]\n",
  "BRUSHIEST": "BRUSHY, resembling a brush; shaggy [adj]\n",
  "BRUSHING": "the act of brushing [n -S]\n",
  "BRUSHINGS": "BRUSHING, the act of brushing [n]\n",
  "BRUSHLAND": "an area covered with brush growth [n -S]\n",
  "BRUSHLANDS": "BRUSHLAND, an area covered with brush growth [n]\n",
  "BRUSHLESS": "without a brush [adj]\n",
  "BRUSHLIKE": "like a brush [adj]\n",
  "BRUSHMARK": "an indented line left by a brush [n -S]\n",
  "BRUSHMARKS": "BRUSHMARK, an indented line left by a brush [n]\n",
  "BRUSHOFF": "an abrupt dismissal [n -S]\n",
  "BRUSHOFFS": "BRUSHOFF, an abrupt dismissal [n]\n",
  "BRUSHSTROKE": "a stroke with a brush [n -S]\n",
  "BRUSHSTROKES": "BRUSHSTROKE, a stroke with a brush [n]\n",
  "BRUSHUP": "a quick review [n -S]\n",
  "BRUSHUPS": "BRUSHUP, a quick review [n]\n",
  "BRUSHWHEEL": "a revolving brush [n -S]\n",
  "BRUSHWHEELS": "BRUSHWHEEL, a revolving brush [n]\n",
  "BRUSHWOOD": "loppings and broken branches; underwood or stunted wood [n -S]\n",
  "BRUSHWOODS": "BRUSHWOOD, loppings and broken branches; underwood or stunted wood [n]\n",
  "BRUSHWORK": "work done with a brush; a painter's individual manner of using the brush [n -S]\n",
  "BRUSHWORKS": "BRUSHWORK, work done with a brush; a painter's individual manner of using the brush [n]\n",
  "BRUSHY": "resembling a brush; shaggy [adj BRUSHIER, BRUSHIEST]\n",
  "BRUSK": "abrupt in manner, also BRUSQUE [adj BRUSKER, BRUSKEST]\n",
  "BRUSKER": "BRUSK, abrupt in manner, also BRUSQUE [adj]\n",
  "BRUSKEST": "BRUSK, abrupt in manner, also BRUSQUE [adj]\n",
  "BRUSQUE": "abrupt in manner, also BRUSK [adj BRUSQUER, BRUSQUEST, BRUSQUELY]\n",
  "BRUSQUELY": "BRUSQUE, abrupt in manner, also BRUSK [adv]\n",
  "BRUSQUENESS": "the state of being brusque [n -ES]\n",
  "BRUSQUENESSES": "BRUSQUENESS, the state of being brusque [n]\n",
  "BRUSQUER": "BRUSQUE, abrupt in manner, also BRUSK [adj]\n",
  "BRUSQUERIE": "(French) a demonstration of brusqueness [n -S]\n",
  "BRUSQUERIES": "BRUSQUERIE, (French) a demonstration of brusqueness [n]\n",
  "BRUSQUEST": "BRUSQUE, abrupt in manner, also BRUSK [adj]\n",
  "BRUSSELS": "as in brussels sprout, a variety of the common cabbage with many heads, each like a miniature cabbage [adj]\n",
  "BRUSSEN": "(dialect) bold [adj]\n",
  "BRUST": "(Spenser) to burst [v BRUST, BRUSTING, BRUSTS]\n",
  "BRUSTING": "BRUST, (Spenser) to burst [v]\n",
  "BRUSTS": "BRUST, (Spenser) to burst [v]\n",
  "BRUT": "(French) a very dry champagne [n -S]\n",
  "BRUTAL": "cruel, savage [adj BRUTALLY]\n",
  "BRUTALISATION": "the act of brutalising, also BRUTALIZATION [n -S]\n",
  "BRUTALISATIONS": "BRUTALISATION, the act of brutalising, also BRUTALIZATION [n]\n",
  "BRUTALISE": "to make brutal, also BRUTALIZE [v BRUTALISED, BRUTALISING, BRUTALISES]\n",
  "BRUTALISED": "BRUTALISE, to make brutal, also BRUTALIZE [v]\n",
  "BRUTALISES": "BRUTALISE, to make brutal, also BRUTALIZE [v]\n",
  "BRUTALISING": "BRUTALISE, to make brutal, also BRUTALIZE [v]\n",
  "BRUTALISM": "a style of art, architecture, etc. characterized by a deliberate crudity of design [n -S]\n",
  "BRUTALISMS": "BRUTALISM, a style of art, architecture, etc. characterized by a deliberate crudity of design [n]\n",
  "BRUTALIST": "an exponent of brutalism, esp. in art, architecture, or literature [n -S]\n",
  "BRUTALISTS": "BRUTALIST, an exponent of brutalism, esp. in art, architecture, or literature [n]\n",
  "BRUTALITIES": "BRUTALITY, a brutal act [n]\n",
  "BRUTALITY": "a brutal act [n BRUTALITIES]\n",
  "BRUTALIZATION": "the act of brutalizing, also BRUTALISATION [n -S]\n",
  "BRUTALIZATIONS": "BRUTALIZATION, the act of brutalizing, also BRUTALISATION [n]\n",
  "BRUTALIZE": "to make brutal, also BRUTALISE [v BRUTALIZED, BRUTALIZING, BRUTALIZES]\n",
  "BRUTALIZED": "BRUTALIZE, to make brutal, also BRUTALISE [v]\n",
  "BRUTALIZES": "BRUTALIZE, to make brutal, also BRUTALISE [v]\n",
  "BRUTALIZING": "BRUTALIZE, to make brutal, also BRUTALISE [v]\n",
  "BRUTALLY": "BRUTAL, cruel, savage [adj]\n",
  "BRUTE": "brutal [adj BRUTER, BRUTEST] / to girdle or shape (a diamond) [v BRUTED, BRUTING, BRUTES]\n",
  "BRUTED": "BRUTE, to girdle or shape (a diamond) [v]\n",
  "BRUTELIKE": "like a brute [adj]\n",
  "BRUTELY": "BRUTE, brutal [adv]\n",
  "BRUTENESS": "the quality of being a brute [n -ES]\n",
  "BRUTENESSES": "BRUTENESS, the quality of being a brute [n]\n",
  "BRUTER": "one that shapes diamonds [n -S]\n",
  "BRUTERS": "BRUTER, one that shapes diamonds [n]\n",
  "BRUTES": "BRUTE, to girdle or shape (a diamond) [v]\n",
  "BRUTEST": "BRUTE, brutal [adj]\n",
  "BRUTIFIED": "BRUTIFY, to make brutal [v]\n",
  "BRUTIFIES": "BRUTIFY, to make brutal [v]\n",
  "BRUTIFY": "to make brutal [v BRUTIFIED, BRUTIFYING, BRUTIFIES]\n",
  "BRUTIFYING": "BRUTIFY, to make brutal [v]\n",
  "BRUTING": "a process of diamond shaping [n -S]\n",
  "BRUTINGS": "BRUTING, a process of diamond shaping [n]\n",
  "BRUTISH": "brutal [adj BRUTISHLY]\n",
  "BRUTISHLY": "BRUTISH, brutal [adv]\n",
  "BRUTISHNESS": "the state of being brutish [n -ES]\n",
  "BRUTISHNESSES": "BRUTISHNESS, the state of being brutish [n]\n",
  "BRUTISM": "the nature or characteristic qualities or actions of a brute [n -S]\n",
  "BRUTISMS": "BRUTISM, the nature or characteristic qualities or actions of a brute [n]\n",
  "BRUTS": "BRUT, (French) a very dry champagne [n]\n",
  "BRUX": "to grind teeth together [v -ED, -ING, -ES]\n",
  "BRUXED": "BRUX, to grind teeth together [v]\n",
  "BRUXES": "BRUX, to grind teeth together [v]\n",
  "BRUXING": "BRUX, to grind teeth together [v]\n",
  "BRUXISM": "a nervous grinding of the teeth [n -S]\n",
  "BRUXISMS": "BRUXISM, a nervous grinding of the teeth [n]\n",
  "BRYOLOGICAL": "relating to the study of mosses and liverworts [adj]\n",
  "BRYOLOGIES": "BRYOLOGY, the study of mosses [n]\n",
  "BRYOLOGIST": "one versed in bryology [n -S]\n",
  "BRYOLOGISTS": "BRYOLOGIST, one versed in bryology [n]\n",
  "BRYOLOGY": "the study of mosses [n BRYOLOGIES]\n",
  "BRYONIES": "BRYONY, a wild climbing plant of the gourd family, also BRIONY [n]\n",
  "BRYONY": "a wild climbing plant of the gourd family, also BRIONY [n BRYONIES]\n",
  "BRYOPHYLLUM": "another name for kalanchoe, a succulent plant [n -S]\n",
  "BRYOPHYLLUMS": "BRYOPHYLLUM, another name for kalanchoe, a succulent plant [n]\n",
  "BRYOPHYTE": "a member of the Bryophyta, one of the main groups of the vegetable kingdom, mosses and liverworts [n -S]\n",
  "BRYOPHYTES": "BRYOPHYTE, a member of the Bryophyta, one of the main groups of the vegetable kingdom, mosses and liverworts [n]\n",
  "BRYOPHYTIC": "of or like a bryophyte [adj]\n",
  "BRYOZOAN": "a type of small aquatic animal, also POLYZOAN [n -S]\n",
  "BRYOZOANS": "BRYOZOAN, a type of small aquatic animal, also POLYZOAN [n]\n",
  "BUAT": "(Scots) a lantern, also BOWAT, BOWET [n -S]\n",
  "BUATS": "BUAT, (Scots) a lantern, also BOWAT, BOWET [n]\n",
  "BUAZE": "an African shrub, also BWAZI [n -S]\n",
  "BUAZES": "BUAZE, an African shrub, also BWAZI [n]\n",
  "BUB": "a young fellow [n -S]\n",
  "BUBA": "a contagious skin disease resembling syphilis, aka yaws, also BOBA [n -S]\n",
  "BUBAL": "(Greek) a large antelope, also BUBALE, BUBALIS [n -S]\n",
  "BUBALE": "(Greek) a large antelope, also BUBAL, BUBALIS [n -S]\n",
  "BUBALES": "BUBALE, (Greek) a large antelope, also BUBAL, BUBALIS [n]\n",
  "BUBALINE": "pertaining to the bubal [adj]\n",
  "BUBALIS": "(Greek) a large antelope, also BUBAL, BUBALE [n -ES]\n",
  "BUBALISES": "BUBALIS, (Greek) a large antelope, also BUBAL, BUBALE [n]\n",
  "BUBALS": "BUBAL, (Greek) a large antelope, also BUBALE, BUBALIS [n]\n",
  "BUBAS": "BUBA, a contagious skin disease resembling syphilis, aka yaws, also BOBA [n]\n",
  "BUBBA": "(colloquial) a redneck, a stereotypical Southern white male [n -S]\n",
  "BUBBAS": "BUBBA, (colloquial) a redneck, a stereotypical Southern white male [n]\n",
  "BUBBE": "(Yiddish) a Jewish grandma, also BUBBIE [n -S]\n",
  "BUBBES": "BUBBE, (Yiddish) a Jewish grandma, also BUBBIE [n]\n",
  "BUBBIE": "(Yiddish) a Jewish grandma, also BUBBE [n -S]\n",
  "BUBBIES": "BUBBY, (colloquial) a woman's breast [n]\n",
  "BUBBLE": "to form a globule of liquid blown out with gas [v BUBBLED, BUBBLING, BUBBLES]\n",
  "BUBBLED": "BUBBLE, to form a globule of liquid blown out with gas [v]\n",
  "BUBBLEGUM": "a kind of chewing-gum [n -S]\n",
  "BUBBLEGUMS": "BUBBLEGUM, a kind of chewing-gum [n]\n",
  "BUBBLEHEAD": "a flighty, frivolous woman [n -S]\n",
  "BUBBLEHEADED": "frivolous, flighty [adj]\n",
  "BUBBLEHEADS": "BUBBLEHEAD, a flighty, frivolous woman [n]\n",
  "BUBBLER": "(tradename) a kind of drinking fountain [n -S]\n",
  "BUBBLERS": "BUBBLER, (tradename) a kind of drinking fountain [n]\n",
  "BUBBLES": "BUBBLE, to form a globule of liquid blown out with gas [v]\n",
  "BUBBLIER": "BUBBLY, full of bubbles [adj]\n",
  "BUBBLIES": "BUBBLY, champagne [n]\n",
  "BUBBLIEST": "BUBBLY, full of bubbles [adj]\n",
  "BUBBLING": "BUBBLE, to form a globule of liquid blown out with gas [v]\n",
  "BUBBLY": "champagne [n BUBBLIES] / full of bubbles [adj BUBBLIER, BUBBLIEST]\n",
  "BUBBY": "(colloquial) a woman's breast [n BUBBIES]\n",
  "BUBINGA": "(Bantu) a species of West African tree [n -S]\n",
  "BUBINGAS": "BUBINGA, (Bantu) a species of West African tree [n]\n",
  "BUBKES": "(Yiddish) a very small amount, also BUBKIS, BUPKES, BUPKIS, BUPKUS [n BUBKES]\n",
  "BUBKIS": "(Yiddish) a very small amount, also BUBKES, BUPKES, BUPKIS, BUPKUS [n BUBKIS]\n",
  "BUBO": "(Latin) an inflammatory swelling of the lymph nodes [n -ES]\n",
  "BUBOED": "relating to the bubo [adj]\n",
  "BUBOES": "BUBO, (Latin) an inflammatory swelling of the lymph nodes [n]\n",
  "BUBONIC": "pertaining to a bubo, an inflammatory swelling of the lymph nodes [adj]\n",
  "BUBONOCELE": "an inguinal hernia; esp. that incomplete variety in which the hernial pouch descends only as far as the groin, forming a swelling there like a bubo [n -S]\n",
  "BUBONOCELES": "BUBONOCELE, an inguinal hernia; esp. that incomplete variety in which the hernial pouch descends only as far as the groin, forming a swelling there like a bubo [n]\n",
  "BUBS": "BUB, a young fellow [n]\n",
  "BUBU": "a long flowing garment worn in Mali, also BOUBOU [n -S]\n",
  "BUBUKLE": "(Shakespeare) Fluellen's word for a red pimple [n -S]\n",
  "BUBUKLES": "BUBUKLE, (Shakespeare) Fluellen's word for a red pimple [n]\n",
  "BUBUS": "BUBU, a long flowing garment worn in Mali, also BOUBOU [n]\n",
  "BUCARDO": "(Spanish) a recently extinct species of Spanish mountain goat [n -S]\n",
  "BUCARDOS": "BUCARDO, (Spanish) a recently extinct species of Spanish mountain goat [n]\n",
  "BUCATINI": "pasta in the form of long thin hollow tubes [n]\n",
  "BUCCAL": "pertaining to the cheek [adj BUCCALLY]\n",
  "BUCCALLY": "BUCCAL, pertaining to the cheek [adv]\n",
  "BUCCANEER": "a pirate, originally of the Spanish-American coasts; an unscrupulous adventurer [n -S] / to act as a buccaneer, also BUCCANIER [v -ED, -ING, -S]\n",
  "BUCCANEERED": "BUCCANEER, to act as a buccaneer, also BUCCANIER [v]\n",
  "BUCCANEERING": "acting as a buccaneer [n -S]\n",
  "BUCCANEERINGS": "BUCCANEERING, acting as a buccaneer [n]\n",
  "BUCCANEERISH": "of or like a buccaneer [adj]\n",
  "BUCCANEERS": "BUCCANEER, to act as a buccaneer, also BUCCANIER [v]\n",
  "BUCCANIER": "to act as a buccaneer, a pirate, originally of the Spanish-American coasts; an unscrupulous adventurer, also BUCCANEER [v -ED, -ING, -S]\n",
  "BUCCANIERED": "BUCCANIER, to act as a buccaneer, a pirate, originally of the Spanish-American coasts; an unscrupulous adventurer, also BUCCANEER [v]\n",
  "BUCCANIERING": "BUCCANIER, to act as a buccaneer, a pirate, originally of the Spanish-American coasts; an unscrupulous adventurer, also BUCCANEER [v]\n",
  "BUCCANIERS": "BUCCANIER, to act as a buccaneer, a pirate, originally of the Spanish-American coasts; an unscrupulous adventurer, also BUCCANEER [v]\n",
  "BUCCINA": "(Latin) a Roman curved trumpet [n -S]\n",
  "BUCCINAS": "BUCCINA, (Latin) a Roman curved trumpet [n]\n",
  "BUCCINATOR": "a flat cheek muscle used in chewing and blowing [n -S]\n",
  "BUCCINATORS": "BUCCINATOR, a flat cheek muscle used in chewing and blowing [n]\n",
  "BUCCINATORY": "of or like a buccinator, a muscle of the cheek [adj]\n",
  "BUCELLAS": "(Portuguese) a white wine from Bucellas near Lisbon [n -ES]\n",
  "BUCELLASES": "BUCELLAS, (Portuguese) a white wine from Bucellas near Lisbon [n]\n",
  "BUCENTAUR": "(Italian) a state barge of Venice from which the Doge dropped a ring into the sea [n -S]\n",
  "BUCENTAURS": "BUCENTAUR, (Italian) a state barge of Venice from which the Doge dropped a ring into the sea [n]\n",
  "BUCHU": "(Hottentot) an African medicinal plant, also BUCKU [n -S]\n",
  "BUCHUS": "BUCHU, (Hottentot) an African medicinal plant, also BUCKU [n]\n",
  "BUCK": "to leap forward and upward suddenly [v -ED, -ING, -S]\n",
  "BUCKAROO": "(US) a cowboy, also BUCKAYRO, BUCKEROO [n -S]\n",
  "BUCKAROOS": "BUCKAROO, (US) a cowboy, also BUCKAYRO, BUCKEROO [n]\n",
  "BUCKAYRO": "(US) a cowboy, also BUCKAROO, BUCKEROO [n -S]\n",
  "BUCKAYROS": "BUCKAYRO, (US) a cowboy, also BUCKAROO, BUCKEROO [n]\n",
  "BUCKBEAN": "a marsh plant [n -S]\n",
  "BUCKBEANS": "BUCKBEAN, a marsh plant [n]\n",
  "BUCKBOARD": "a light horse-drawn vehicle consisting of a flexible board on four wheels, with a two-person seat [n -S]\n",
  "BUCKBOARDS": "BUCKBOARD, a light horse-drawn vehicle consisting of a flexible board on four wheels, with a two-person seat [n]\n",
  "BUCKBRUSH": "an American shrub [n -ES]\n",
  "BUCKBRUSHES": "BUCKBRUSH, an American shrub [n]\n",
  "BUCKED": "BUCK, to leap forward and upward suddenly [v]\n",
  "BUCKEEN": "(Anglo-Irish) a poor man who acts as if wealthy [n -S]\n",
  "BUCKEENS": "BUCKEEN, (Anglo-Irish) a poor man who acts as if wealthy [n]\n",
  "BUCKER": "a hammer for bucking ore, i.e. breaking it into small pieces [n -S]\n",
  "BUCKEROO": "(US) a cowboy, also BUCKAROO, BUCKAYRO [n -S]\n",
  "BUCKEROOS": "BUCKEROO, (US) a cowboy, also BUCKAROO, BUCKAYRO [n]\n",
  "BUCKERS": "BUCKER, a hammer for bucking ore, i.e. breaking it into small pieces [n]\n",
  "BUCKET": "to push forward hurriedly [v -ED, -ING, -S]\n",
  "BUCKETED": "BUCKET, to push forward hurriedly [v]\n",
  "BUCKETFUL": "the contents of a bucket [n BUCKETFULS or BUCKETSFUL]\n",
  "BUCKETFULS": "BUCKETFUL, the contents of a bucket [n]\n",
  "BUCKETING": "the act of bucketing [n -S]\n",
  "BUCKETINGS": "BUCKETING, the act of bucketing [n]\n",
  "BUCKETS": "BUCKET, to push forward hurriedly [v]\n",
  "BUCKETSFUL": "BUCKETFUL, the contents of a bucket [n]\n",
  "BUCKEYE": "the American horse-chestnut [n -S]\n",
  "BUCKEYES": "BUCKEYE, the American horse-chestnut [n]\n",
  "BUCKHORN": "the material of a buck's horn as used for handles etc. [n -S]\n",
  "BUCKHORNS": "BUCKHORN, the material of a buck's horn as used for handles etc. [n]\n",
  "BUCKHOUND": "a hound for hunting deer [n -S]\n",
  "BUCKHOUNDS": "BUCKHOUND, a hound for hunting deer [n]\n",
  "BUCKIE": "(Scots) a large spiral marine shell, esp. the common whelk [n -S]\n",
  "BUCKIES": "BUCKIE, (Scots) a large spiral marine shell, esp. the common whelk [n]\n",
  "BUCKING": "the process of steeping in lye before bleaching [n -S]\n",
  "BUCKINGS": "BUCKING, the process of steeping in lye before bleaching [n]\n",
  "BUCKISH": "dandified; foppish [adj BUCKISHLY]\n",
  "BUCKISHLY": "BUCKISH, dandified; foppish [adv]\n",
  "BUCKJUMPER": "(Australian) an untamed horse [n -S]\n",
  "BUCKJUMPERS": "BUCKJUMPER, (Australian) an untamed horse [n]\n",
  "BUCKJUMPING": "(Australian) a competitive event for buckjumpers in a rodeo [n -S]\n",
  "BUCKJUMPINGS": "BUCKJUMPING, (Australian) a competitive event for buckjumpers in a rodeo [n]\n",
  "BUCKLE": "to bend or warp [v BUCKLED, BUCKLING, BUCKLES]\n",
  "BUCKLED": "BUCKLE, to bend or warp [v]\n",
  "BUCKLER": "a light shield [n -S] / (Shakespeare) to protect, shield [v -ED, -ING, -S]\n",
  "BUCKLERED": "BUCKLER, (Shakespeare) to protect, shield [v]\n",
  "BUCKLERING": "BUCKLER, (Shakespeare) to protect, shield [v]\n",
  "BUCKLERS": "BUCKLER, (Shakespeare) to protect, shield [v]\n",
  "BUCKLES": "BUCKLE, to bend or warp [v]\n",
  "BUCKLING": "a smoked Baltic herring [n -S]\n",
  "BUCKLINGS": "BUCKLING, a smoked Baltic herring [n]\n",
  "BUCKO": "a bully [n BUCKOS or BUCKOES]\n",
  "BUCKOES": "BUCKO, a bully [n]\n",
  "BUCKOS": "BUCKO, a bully [n]\n",
  "BUCKRA": "among West Indian and Southern US black people, a white man, also BACKRA, BAKRA [n -S]\n",
  "BUCKRAKE": "a large agricultural rake, often attached to a tractor [n -S]\n",
  "BUCKRAKES": "BUCKRAKE, a large agricultural rake, often attached to a tractor [n]\n",
  "BUCKRAM": "a stiff-finished cotton or linen used for linings of garments [n -S] / to pad or stiffen with buckram [v -ED, -ING, -S]\n",
  "BUCKRAMED": "BUCKRAM, to pad or stiffen with buckram [v]\n",
  "BUCKRAMING": "BUCKRAM, to pad or stiffen with buckram [v]\n",
  "BUCKRAMS": "BUCKRAM, to pad or stiffen with buckram [v]\n",
  "BUCKRAS": "BUCKRA, among West Indian and Southern US black people, a white man, also BACKRA, BAKRA [n]\n",
  "BUCKS": "BUCK, to leap forward and upward suddenly [v]\n",
  "BUCKSAW": "a large saw in an H-frame [n -S]\n",
  "BUCKSAWS": "BUCKSAW, a large saw in an H-frame [n]\n",
  "BUCKSHEE": "something in addition to the usual allowance; something extra or free [n -S]\n",
  "BUCKSHEES": "BUCKSHEE, something in addition to the usual allowance; something extra or free [n]\n",
  "BUCKSHISH": "(Persian) in Eastern countries, a gift or present of money, a tip [n -ES] / to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BAKSHISH [v -ED, -ING, -ES]\n",
  "BUCKSHISHED": "BUCKSHISH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BAKSHISH [v]\n",
  "BUCKSHISHES": "BUCKSHISH, (Persian) in Eastern countries, a gift or present of money, a tip [n]\n",
  "BUCKSHISHING": "BUCKSHISH, to give a tip, also BACKSHEESH, BACKSHISH, BAKHSHISH, BAKSHEESH, BAKSHISH [v]\n",
  "BUCKSHOT": "a large kind of shot, used in shooting deer [n -S]\n",
  "BUCKSHOTS": "BUCKSHOT, a large kind of shot, used in shooting deer [n]\n",
  "BUCKSKIN": "the skin of a male deer [n -S]\n",
  "BUCKSKINNED": "wearing buckskin [adj]\n",
  "BUCKSKINS": "BUCKSKIN, the skin of a male deer [n]\n",
  "BUCKSOM": "(Milton) buxom [adj]\n",
  "BUCKTAIL": "a fishing lure [n -S]\n",
  "BUCKTAILS": "BUCKTAIL, a fishing lure [n]\n",
  "BUCKTEETH": "BUCKTOOTH, any tooth that juts out [n]\n",
  "BUCKTHORN": "a shrub of the Rhamnus genus [n -S]\n",
  "BUCKTHORNS": "BUCKTHORN, a shrub of the Rhamnus genus [n]\n",
  "BUCKTOOTH": "any tooth that juts out [n BUCKTEETH]\n",
  "BUCKTOOTHED": "having buckteeth, teeth that jut out [adj]\n",
  "BUCKU": "(Hottentot) an African medicinal plant, also BUCHU [n -S]\n",
  "BUCKUS": "BUCKU, (Hottentot) an African medicinal plant, also BUCHU [n]\n",
  "BUCKWHEAT": "a cereal plant, the seed of which is used for horse and poultry food, and in North America is milled for making breakfast pancakes [n -S]\n",
  "BUCKWHEATS": "BUCKWHEAT, a cereal plant, the seed of which is used for horse and poultry food, and in North America is milled for making breakfast pancakes [n]\n",
  "BUCKYBALL": "a ball-shaped molecule containing 60 carbon atoms [n -S]\n",
  "BUCKYBALLS": "BUCKYBALL, a ball-shaped molecule containing 60 carbon atoms [n]\n",
  "BUCKYTUBE": "a tube of carbon atoms [n -S]\n",
  "BUCKYTUBES": "BUCKYTUBE, a tube of carbon atoms [n]\n",
  "BUCOLIC": "of or relating to shepherds or herdsmen, pastoral, also BUCOLICAL [adj BUCOLICALLY] / a pastoral poet, a rustic [n -S]\n",
  "BUCOLICAL": "relating to the tending of cattle, also BUCOLIC [adj BUCOLICALLY]\n",
  "BUCOLICALLY": "BUCOLICAL, relating to the tending of cattle, also BUCOLIC [adv]\n",
  "BUCOLICS": "BUCOLIC, a pastoral poet, a rustic [n]\n",
  "BUD": "to produce unopened flowers [v BUDDED, BUDDING, BUDS]\n",
  "BUDA": "(offensive Hinglish) an insulting term for an old man [n -S]\n",
  "BUDAS": "BUDA, (offensive Hinglish) an insulting term for an old man [n]\n",
  "BUDDED": "BUD, to produce unopened flowers [v]\n",
  "BUDDER": "one that buds [n -S]\n",
  "BUDDERS": "BUDDER, one that buds [n]\n",
  "BUDDHA": "(Sanskrit) a statue of the Buddha [n -S]\n",
  "BUDDHAS": "BUDDHA, (Sanskrit) a statue of the Buddha [n]\n",
  "BUDDIED": "BUDDY, to become close friends [v]\n",
  "BUDDIER": "BUDDY, having buds [adj]\n",
  "BUDDIES": "BUDDY, to become close friends [v]\n",
  "BUDDIEST": "BUDDY, having buds [adj]\n",
  "BUDDING": "a type of asexual reproduction [n -S]\n",
  "BUDDINGS": "BUDDING, a type of asexual reproduction [n]\n",
  "BUDDLE": "to wash for ore on shallow tray [v BUDDLED, BUDDLING, BUDDLES]\n",
  "BUDDLED": "BUDDLE, to wash for ore on shallow tray [v]\n",
  "BUDDLEIA": "a flowering shrub, aka butterfly bush [n -S]\n",
  "BUDDLEIAS": "BUDDLEIA, a flowering shrub, aka butterfly bush [n]\n",
  "BUDDLES": "BUDDLE, to wash for ore on shallow tray [v]\n",
  "BUDDLING": "BUDDLE, to wash for ore on shallow tray [v]\n",
  "BUDDY": "to become close friends [v BUDDIED, BUDDYING, BUDDIES] / having buds [adj BUDDIER, BUDDIEST]\n",
  "BUDDYING": "BUDDY, to become close friends [v]\n",
  "BUDGE": "to move or stir [v BUDGED, BUDGING, BUDGES]\n",
  "BUDGED": "BUDGE, to move or stir [v]\n",
  "BUDGER": "one who budges [n -S]\n",
  "BUDGEREE": "(Native Australian) good [adj]\n",
  "BUDGERIGAR": "(Native Australian) an Australian parakeet [n -S]\n",
  "BUDGERIGARS": "BUDGERIGAR, (Native Australian) an Australian parakeet [n]\n",
  "BUDGERO": "(Hindi) a heavy keelless barge, also BUDGEROW [n -S]\n",
  "BUDGEROS": "BUDGERO, (Hindi) a heavy keelless barge, also BUDGEROW [n]\n",
  "BUDGEROW": "(Hindi) a heavy keelless barge, also BUDGERO [n -S]\n",
  "BUDGEROWS": "BUDGEROW, (Hindi) a heavy keelless barge, also BUDGERO [n]\n",
  "BUDGERS": "BUDGER, one who budges [n]\n",
  "BUDGES": "BUDGE, to move or stir [v]\n",
  "BUDGET": "to estimate expenses [v -ED, -ING, -S]\n",
  "BUDGETARY": "relating to a budget [adj]\n",
  "BUDGETED": "BUDGET, to estimate expenses [v]\n",
  "BUDGETEER": "one who prepares a budget, also BUDGETER [n -S]\n",
  "BUDGETEERS": "BUDGETEER, one who prepares a budget, also BUDGETER [n]\n",
  "BUDGETER": "one who prepares a budget, also BUDGETEER [n -S]\n",
  "BUDGETERS": "BUDGETER, one who prepares a budget, also BUDGETEER [n]\n",
  "BUDGETING": "the act of operating a budget [n -S]\n",
  "BUDGETINGS": "BUDGETING, the act of operating a budget [n]\n",
  "BUDGETS": "BUDGET, to estimate expenses [v]\n",
  "BUDGIE": "(colloquial) a budgerigar [n -S]\n",
  "BUDGIES": "BUDGIE, (colloquial) a budgerigar [n]\n",
  "BUDGING": "BUDGE, to move or stir [v]\n",
  "BUDI": "(Hindi) an insulting term for an old woman [n -S]\n",
  "BUDIS": "BUDI, (Hindi) an insulting term for an old woman [n]\n",
  "BUDLESS": "without buds [adj]\n",
  "BUDLIKE": "like a bud [adj]\n",
  "BUDMASH": "(Urdu) an evildoer, a worthless person, also BADMASH [n -ES]\n",
  "BUDMASHES": "BUDMASH, (Urdu) an evildoer, a worthless person, also BADMASH [n]\n",
  "BUDO": "(Japanese) the system or philosophy of the martial arts [n -S]\n",
  "BUDOS": "BUDO, (Japanese) the system or philosophy of the martial arts [n]\n",
  "BUDS": "BUD, to produce unopened flowers [v]\n",
  "BUDTENDER": "a staff member who works within a dispensary or store where medical or recreational cannabis is sold [n -S]\n",
  "BUDTENDERS": "BUDTENDER, a staff member who works within a dispensary or store where medical or recreational cannabis is sold [n]\n",
  "BUDWOOD": "a branch having buds that is used for grafting [n -S]\n",
  "BUDWOODS": "BUDWOOD, a branch having buds that is used for grafting [n]\n",
  "BUDWORM": "a moth larva that feeds on plant buds [n -S]\n",
  "BUDWORMS": "BUDWORM, a moth larva that feeds on plant buds [n]\n",
  "BUFF": "to polish [v -ED, -ING, -S] / dull yellow brown [adj BUFFER, BUFFEST]\n",
  "BUFFA": "(Italian) the comic actress in an opera [n BUFFE or BUFFAS]\n",
  "BUFFABLE": "able to be buffed [adj]\n",
  "BUFFALO": "to intimidate [v -ED, -ING, -S] / an oxlike animal [n BUFFALOS or BUFFALOES]\n",
  "BUFFALOBERRIES": "BUFFALOBERRY, an American shrub of the oleaster family; its edible scarlet berry [n]\n",
  "BUFFALOBERRY": "an American shrub of the oleaster family; its edible scarlet berry [n BUFFALOBERRIES]\n",
  "BUFFALOED": "BUFFALO, to intimidate [v]\n",
  "BUFFALOES": "BUFFALO, an oxlike animal [n]\n",
  "BUFFALOFISH": "a fish of the Mississippi valley [n -ES]\n",
  "BUFFALOFISHES": "BUFFALOFISH, a fish of the Mississippi valley [n]\n",
  "BUFFALOING": "BUFFALO, to intimidate [v]\n",
  "BUFFALOS": "BUFFALO, to intimidate [v]\n",
  "BUFFAS": "BUFFA, (Italian) the comic actress in an opera [n]\n",
  "BUFFE": "BUFFA, (Italian) the comic actress in an opera [n]\n",
  "BUFFED": "BUFF, to polish [v]\n",
  "BUFFEL": "as in buffel grass, grass used for pasture in Africa etc. [adj]\n",
  "BUFFER": "to protect against shock [v -ED, -ING, -S]\n",
  "BUFFERED": "BUFFER, to protect against shock [v]\n",
  "BUFFERING": "the act of using a buffer [n -S]\n",
  "BUFFERINGS": "BUFFERING, the act of using a buffer [n]\n",
  "BUFFERS": "BUFFER, to protect against shock [v]\n",
  "BUFFEST": "BUFF, dull yellow brown [adj]\n",
  "BUFFET": "to hit sharply [v -ED, -ING, -S]\n",
  "BUFFETED": "BUFFET, to hit sharply [v]\n",
  "BUFFETER": "one who buffets; a boxer [n -S]\n",
  "BUFFETERS": "BUFFETER, one who buffets; a boxer [n]\n",
  "BUFFETING": "the act of striking with a buffet [n -S]\n",
  "BUFFETINGS": "BUFFETING, the act of striking with a buffet [n]\n",
  "BUFFETS": "BUFFET, to hit sharply [v]\n",
  "BUFFI": "BUFFO, (Italian) the comic actor in an opera [n]\n",
  "BUFFIER": "BUFFY, of a yellowish-brown colour [adj]\n",
  "BUFFIEST": "BUFFY, of a yellowish-brown colour [adj]\n",
  "BUFFING": "the process of polishing [n -S]\n",
  "BUFFINGS": "BUFFING, the process of polishing [n]\n",
  "BUFFLEHEAD": "one who has a large head; a heavy, stupid fellow [n -S]\n",
  "BUFFLEHEADS": "BUFFLEHEAD, one who has a large head; a heavy, stupid fellow [n]\n",
  "BUFFO": "(Italian) the comic actor in an opera [n BUFFI or BUFFOS]\n",
  "BUFFOON": "a clown [n -S]\n",
  "BUFFOONERIES": "BUFFOONERY, foolish or playful behavior [n]\n",
  "BUFFOONERY": "foolish or playful behavior [n BUFFOONERIES]\n",
  "BUFFOONISH": "like a buffoon [adj]\n",
  "BUFFOONS": "BUFFOON, a clown [n]\n",
  "BUFFOS": "BUFFO, (Italian) the comic actor in an opera [n]\n",
  "BUFFS": "BUFF, to polish [v]\n",
  "BUFFY": "of a yellowish-brown colour [adj BUFFIER, BUFFIEST]\n",
  "BUFO": "(Latin) a black tincture in alchemy [n -S]\n",
  "BUFOS": "BUFO, (Latin) a black tincture in alchemy [n]\n",
  "BUFOTALIN": "a poisonous substance in the skin and saliva of a common European toad [n -S]\n",
  "BUFOTALINS": "BUFOTALIN, a poisonous substance in the skin and saliva of a common European toad [n]\n",
  "BUFOTENINE": "a poisonous paralytic hallucinogenic drug [n -S]\n",
  "BUFOTENINES": "BUFOTENINE, a poisonous paralytic hallucinogenic drug [n]\n",
  "BUFTIE": "(colloquial) a homosexual, also BUFTY [n -S]\n",
  "BUFTIES": "BUFTIE, (colloquial) a homosexual, also BUFTY [n]\n",
  "BUFTY": "(colloquial) a homosexual, also BUFTIE [n BUFTIES]\n",
  "BUG": "to annoy [v BUGGED, BUGGING, BUGS]\n",
  "BUGABOO": "(Welsh) a cause for anxiety, also BUGBEAR [n -S]\n",
  "BUGABOOS": "BUGABOO, (Welsh) a cause for anxiety, also BUGBEAR [n]\n",
  "BUGBANE": "a perennial white-flowered herb of the order Ranunculaceae, aka bugwort [n -S]\n",
  "BUGBANES": "BUGBANE, a perennial white-flowered herb of the order Ranunculaceae, aka bugwort [n]\n",
  "BUGBEAR": "a cause for anxiety, also BUGABOO [n -S]\n",
  "BUGBEARS": "BUGBEAR, a cause for anxiety, also BUGABOO [n]\n",
  "BUGEYE": "a kind of small boat [n -S]\n",
  "BUGEYES": "BUGEYE, a kind of small boat [n]\n",
  "BUGGAN": "(dialect) an evil spirit, a hobgoblin, also BUGGANE, BUGGIN [n -S]\n",
  "BUGGANE": "(dialect) an evil spirit, a hobgoblin, also BUGGAN, BUGGIN [n -S]\n",
  "BUGGANES": "BUGGANE, (dialect) an evil spirit, a hobgoblin, also BUGGAN, BUGGIN [n]\n",
  "BUGGANS": "BUGGAN, (dialect) an evil spirit, a hobgoblin, also BUGGANE, BUGGIN [n]\n",
  "BUGGED": "BUG, to annoy [v]\n",
  "BUGGER": "to practise buggery [v -ED, -ING, -S]\n",
  "BUGGERED": "BUGGER, to practise buggery [v]\n",
  "BUGGERIES": "BUGGERY, sodomy [n]\n",
  "BUGGERING": "BUGGER, to practise buggery [v]\n",
  "BUGGERS": "BUGGER, to practise buggery [v]\n",
  "BUGGERY": "sodomy [n BUGGERIES]\n",
  "BUGGIER": "BUGGY, full of bugs [adj]\n",
  "BUGGIES": "BUGGY, a light carriage [n]\n",
  "BUGGIEST": "BUGGY, full of bugs [adj]\n",
  "BUGGIN": "(dialect) an evil spirit, a hobgoblin, also BUGGAN, BUGGANE [n -S]\n",
  "BUGGINESS": "the state of being buggy [n -ES]\n",
  "BUGGINESSES": "BUGGINESS, the state of being buggy [n]\n",
  "BUGGING": "the concealment of a listening device [n -S]\n",
  "BUGGINGS": "BUGGING, the concealment of a listening device [n]\n",
  "BUGGINS": "BUGGIN, (dialect) an evil spirit, a hobgoblin, also BUGGAN, BUGGANE [n]\n",
  "BUGGY": "a light carriage [n BUGGIES] / full of bugs [adj BUGGIER, BUGGIEST]\n",
  "BUGHOUSE": "(offensive) an insane asylum [n -S]\n",
  "BUGHOUSES": "BUGHOUSE, (offensive) an insane asylum [n]\n",
  "BUGLE": "to play a brass wind instrument [v BUGLED, BUGLING, BUGLES]\n",
  "BUGLED": "BUGLE, to play a brass wind instrument [v]\n",
  "BUGLER": "one who plays the bugle [n -S]\n",
  "BUGLERS": "BUGLER, one who plays the bugle [n]\n",
  "BUGLES": "BUGLE, to play a brass wind instrument [v]\n",
  "BUGLET": "a small bugle [n -S]\n",
  "BUGLETS": "BUGLET, a small bugle [n]\n",
  "BUGLEWEED": "a plant of the mint family, having mild narcotic and astringent properties [n -S]\n",
  "BUGLEWEEDS": "BUGLEWEED, a plant of the mint family, having mild narcotic and astringent properties [n]\n",
  "BUGLING": "BUGLE, to play a brass wind instrument [v]\n",
  "BUGLOSS": "a wild flower, with bristly stem and vivid blue flowers [n -ES]\n",
  "BUGLOSSES": "BUGLOSS, a wild flower, with bristly stem and vivid blue flowers [n]\n",
  "BUGONG": "(Native Australian) a noctuid moth eaten by Australian aborigines, also BOGONG [n -S]\n",
  "BUGONGS": "BUGONG, (Native Australian) a noctuid moth eaten by Australian aborigines, also BOGONG [n]\n",
  "BUGOUT": "the act of running away [n -S]\n",
  "BUGOUTS": "BUGOUT, the act of running away [n]\n",
  "BUGS": "BUG, to annoy [v]\n",
  "BUGSEED": "an American plant of the goosefoot family [n -S]\n",
  "BUGSEEDS": "BUGSEED, an American plant of the goosefoot family [n]\n",
  "BUGSHA": "a monetary unit of Yemen [n -S]\n",
  "BUGSHAS": "BUGSHA, a monetary unit of Yemen [n]\n",
  "BUGWORT": "a perennial white-flowered herb of the buttercup family, aka bugbane [n -S]\n",
  "BUGWORTS": "BUGWORT, a perennial white-flowered herb of the buttercup family, aka bugbane [n]\n",
  "BUHL": "a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLE, BOULLEWORK, BUHLWORK [n -S]\n",
  "BUHLS": "BUHL, a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLE, BOULLEWORK, BUHLWORK [n]\n",
  "BUHLWORK": "(French) a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLE, BOULLEWORK, BUHL [n -S]\n",
  "BUHLWORKS": "BUHLWORK, (French) a form of marquetry with e.g. gold and silver inlaid in tortoiseshell, also BOULLE, BOULLEWORK, BUHL [n]\n",
  "BUHR": "a cellular, flinty rock, used for millstones, also BUHRSTONE, BURRSTONE, BURSTONE [n -S]\n",
  "BUHRS": "BUHR, a cellular, flinty rock, used for millstones, also BUHRSTONE, BURRSTONE, BURSTONE [n]\n",
  "BUHRSTONE": "a cellular, flinty rock, used for millstones, also BUHR, BURRSTONE, BURSTONE [n -S]\n",
  "BUHRSTONES": "BUHRSTONE, a cellular, flinty rock, used for millstones, also BUHR, BURRSTONE, BURSTONE [n]\n",
  "BUHUND": "(Norwegian) a medium-sized Norwegian spitz dog [n -S]\n",
  "BUHUNDS": "BUHUND, (Norwegian) a medium-sized Norwegian spitz dog [n]\n",
  "BUIBUI": "(Swahili) a black shawl worn by African Muslim women [n -S]\n",
  "BUIBUIS": "BUIBUI, (Swahili) a black shawl worn by African Muslim women [n]\n",
  "BUIK": "(Scots) a book, also BUKE [n -S]\n",
  "BUIKS": "BUIK, (Scots) a book, also BUKE [n]\n",
  "BUILD": "to construct [v BUILT or BUILDED, BUILDING, BUILDS]\n",
  "BUILDABLE": "that can be built [adj]\n",
  "BUILDDOWN": "a planned reduction [n -S]\n",
  "BUILDDOWNS": "BUILDDOWN, a planned reduction [n]\n",
  "BUILDED": "BUILD, to construct [v]\n",
  "BUILDER": "one that builds [n -S]\n",
  "BUILDERS": "BUILDER, one that builds [n]\n",
  "BUILDING": "the process of erecting houses [n -S]\n",
  "BUILDINGS": "BUILDING, the process of erecting houses [n]\n",
  "BUILDOUT": "a process of expansion or growth [n -S]\n",
  "BUILDOUTS": "BUILDOUT, a process of expansion or growth [n]\n",
  "BUILDS": "BUILD, to construct [v]\n",
  "BUILDUP": "an accumulation [n -S]\n",
  "BUILDUPS": "BUILDUP, an accumulation [n]\n",
  "BUILT": "BUILD, to construct [v]\n",
  "BUIRDLIER": "BUIRDLY, (Scots) stalwart; large and well made [adj]\n",
  "BUIRDLIEST": "BUIRDLY, (Scots) stalwart; large and well made [adj]\n",
  "BUIRDLY": "(Scots) stalwart; large and well made [adj BUIRDLIER, BUIRDLIEST]\n",
  "BUIST": "(Scots) a box, a tar-box; an owner's mark on sheep and cattle [n -S] / to mark a sheep with tar [v -ED, -ING, -S]\n",
  "BUISTED": "BUIST, to mark a sheep with tar [v]\n",
  "BUISTING": "BUIST, to mark a sheep with tar [v]\n",
  "BUISTS": "BUIST, to mark a sheep with tar [v]\n",
  "BUKE": "(Scots) a book, also BUIK [n -S]\n",
  "BUKES": "BUKE, (Scots) a book, also BUIK [n]\n",
  "BUKKAKE": "(Japanese) a type of sexual practice [n -S]\n",
  "BUKKAKES": "BUKKAKE, (Japanese) a type of sexual practice [n]\n",
  "BUKSHEE": "(Persian) a paymaster, also BUKSHI [n -S]\n",
  "BUKSHEES": "BUKSHEE, (Persian) a paymaster, also BUKSHI [n]\n",
  "BUKSHI": "(Persian) a paymaster, also BUKSHEE [n -S]\n",
  "BUKSHIS": "BUKSHI, (Persian) a paymaster, also BUKSHEE [n]\n",
  "BULB": "to swell out, form bulbs [v -ED, -ING, -S]\n",
  "BULBAR": "relating to a bulb [adj]\n",
  "BULBED": "BULB, to swell out, form bulbs [v]\n",
  "BULBEL": "a small bulb, also BULBIL, BULBLET [n -S]\n",
  "BULBELS": "BULBEL, a small bulb, also BULBIL, BULBLET [n]\n",
  "BULBIFEROUS": "bearing bulbs [adj]\n",
  "BULBIL": "a small bulb, also BULBEL, BULBLET [n -S]\n",
  "BULBILS": "BULBIL, a small bulb, also BULBEL, BULBLET [n]\n",
  "BULBING": "BULB, to swell out, form bulbs [v]\n",
  "BULBLET": "a small bulb, also BULBEL, BULBIL [n -S]\n",
  "BULBLETS": "BULBLET, a small bulb, also BULBEL, BULBIL [n]\n",
  "BULBOSITIES": "BULBOSITY, the state of being bulbous [n]\n",
  "BULBOSITY": "the state of being bulbous [n BULBOSITIES]\n",
  "BULBOUS": "bulb-shaped [adj BULBOUSLY]\n",
  "BULBOUSLY": "BULBOUS, bulb-shaped [adv]\n",
  "BULBOUSNESS": "the state of being bulbous [n -ES]\n",
  "BULBOUSNESSES": "BULBOUSNESS, the state of being bulbous [n]\n",
  "BULBS": "BULB, to swell out, form bulbs [v]\n",
  "BULBUL": "(Arabic) an Indian songbird [n -S]\n",
  "BULBULS": "BULBUL, (Arabic) an Indian songbird [n]\n",
  "BULGAR": "(Turkish) a form of cooked, broken wheat, also BULGHUR, BULGUR, BURGHUL [n -S]\n",
  "BULGARS": "BULGAR, (Turkish) a form of cooked, broken wheat, also BULGHUR, BULGUR, BURGHUL [n]\n",
  "BULGE": "to swell out [v BULGED, BULGING, BULGES]\n",
  "BULGED": "BULGE, to swell out [v]\n",
  "BULGER": "a wooden golf club with a convex face [n -S]\n",
  "BULGERS": "BULGER, a wooden golf club with a convex face [n]\n",
  "BULGES": "BULGE, to swell out [v]\n",
  "BULGHUR": "(Turkish) a form of cooked, broken wheat, also BULGAR, BULGUR, BURGHUL [n -S]\n",
  "BULGHURS": "BULGHUR, (Turkish) a form of cooked, broken wheat, also BULGAR, BULGUR, BURGHUL [n]\n",
  "BULGIER": "BULGY, bulging [adj]\n",
  "BULGIEST": "BULGY, bulging [adj]\n",
  "BULGINE": "(US) a steam locomotive, also BULLGINE [n -S]\n",
  "BULGINES": "BULGINE, (US) a steam locomotive, also BULLGINE [n]\n",
  "BULGINESS": "the state of being bulgy [n -ES]\n",
  "BULGINESSES": "BULGINESS, the state of being bulgy [n]\n",
  "BULGING": "BULGE, to swell out [v]\n",
  "BULGINGLY": "BULGING, BULGE, to swell out [adv]\n",
  "BULGUR": "(Turkish) a form of cooked, broken wheat, also BULGAR, BULGHUR, BURGHUL [n -S]\n",
  "BULGURS": "BULGUR, (Turkish) a form of cooked, broken wheat, also BULGAR, BULGHUR, BURGHUL [n]\n",
  "BULGY": "bulging [adj BULGIER, BULGIEST]\n",
  "BULIMIA": "(Greek) an eating disorder in which binge eating is followed by depression and guilt, self-induced vomiting and purging, etc., also BULIMUS, BULIMY [n -S]\n",
  "BULIMIAC": "one suffering from bulimia, also BULIMIC [n -S]\n",
  "BULIMIACS": "BULIMIAC, one suffering from bulimia, also BULIMIC [n]\n",
  "BULIMIAS": "BULIMIA, (Greek) an eating disorder in which binge eating is followed by depression and guilt, self-induced vomiting and purging, etc., also BULIMUS, BULIMY [n]\n",
  "BULIMIC": "relating to bulimia, also BULIMIAC [adj] / one suffering from bulimia [n -S]\n",
  "BULIMICS": "BULIMIC, one suffering from bulimia [n]\n",
  "BULIMIES": "BULIMY, (Greek) an eating disorder in which binge eating is followed by depression and guilt, self-induced vomiting and purging, etc., also BULIMIA, BULIMUS [n]\n",
  "BULIMUS": "(Greek) an eating disorder in which binge eating is followed by depression and guilt, self-induced vomiting and purging, etc., also BULIMIA, BULIMY [n -ES]\n",
  "BULIMUSES": "BULIMUS, (Greek) an eating disorder in which binge eating is followed by depression and guilt, self-induced vomiting and purging, etc., also BULIMIA, BULIMY [n]\n",
  "BULIMY": "(Greek) an eating disorder in which binge eating is followed by depression and guilt, self-induced vomiting and purging, etc., also BULIMIA, BULIMUS [n BULIMIES]\n",
  "BULK": "to gather into a mass [v -ED, -ING, -S]\n",
  "BULKAGE": "a peristaltic stimulant [n -S]\n",
  "BULKAGES": "BULKAGE, a peristaltic stimulant [n]\n",
  "BULKED": "BULK, to gather into a mass [v]\n",
  "BULKER": "(archaic) a street thief or prostitute [n -S]\n",
  "BULKERS": "BULKER, (archaic) a street thief or prostitute [n]\n",
  "BULKHEAD": "a partition on a ship [n -S]\n",
  "BULKHEADED": "fitted with a bulkhead [adj]\n",
  "BULKHEADS": "BULKHEAD, a partition on a ship [n]\n",
  "BULKIER": "BULKY, having bulk [adj]\n",
  "BULKIEST": "BULKY, having bulk [adj]\n",
  "BULKILY": "BULKY, having bulk [adv]\n",
  "BULKINESS": "the state of being bulky [n -ES]\n",
  "BULKINESSES": "BULKINESS, the state of being bulky [n]\n",
  "BULKING": "the act of gathering into a mass [n -S]\n",
  "BULKINGS": "BULKING, the act of gathering into a mass [n]\n",
  "BULKS": "BULK, to gather into a mass [v]\n",
  "BULKY": "having bulk [adj BULKIER, BULKIEST, BULKILY]\n",
  "BULL": "an uncastrated male of the cattle family [n -S] / to copulate with a cow [v -ED, -ING, -S]\n",
  "BULLA": "(Latin) a round seal attached to a papal bull [n BULLAE]\n",
  "BULLACE": "a small wild plum fruit and tree [n -S]\n",
  "BULLACES": "BULLACE, a small wild plum fruit and tree [n]\n",
  "BULLAE": "BULLA, (Latin) a round seal attached to a papal bull [n]\n",
  "BULLARIES": "BULLARY, a collection of papal bulls [n]\n",
  "BULLARY": "a collection of papal bulls [n BULLARIES]\n",
  "BULLATE": "having a blistered appearance [adj]\n",
  "BULLBAITING": "the former practice of baiting bulls with dogs [n -S]\n",
  "BULLBAITINGS": "BULLBAITING, the former practice of baiting bulls with dogs [n]\n",
  "BULLBARS": "a strong protective metal grille on the front of a car [n]\n",
  "BULLBAT": "(US) a nocturnal bird, aka nighthawk [n -S]\n",
  "BULLBATS": "BULLBAT, (US) a nocturnal bird, aka nighthawk [n]\n",
  "BULLBRIER": "a prickly American vine [n -S]\n",
  "BULLBRIERS": "BULLBRIER, a prickly American vine [n]\n",
  "BULLCOOK": "a worker in a logging camp [n -S]\n",
  "BULLCOOKS": "BULLCOOK, a worker in a logging camp [n]\n",
  "BULLDIKE": "an aggressive lesbian, also BULLDYKE [n -S]\n",
  "BULLDIKES": "BULLDIKE, an aggressive lesbian, also BULLDYKE [n]\n",
  "BULLDOG": "to wrestle and throw a steer [v BULLDOGGED, BULLDOGGING, BULLDOGS]\n",
  "BULLDOGGED": "BULLDOG, to wrestle and throw a steer [v]\n",
  "BULLDOGGER": "one who bulldogs, wrestles steers [n -S]\n",
  "BULLDOGGERS": "BULLDOGGER, one who bulldogs, wrestles steers [n]\n",
  "BULLDOGGING": "the act of bulldogging [n -S]\n",
  "BULLDOGGINGS": "BULLDOGGING, the act of bulldogging [n]\n",
  "BULLDOGS": "BULLDOG, to wrestle and throw a steer [v]\n",
  "BULLDOZE": "to override objections [v BULLDOZED, BULLDOZING, BULLDOZES]\n",
  "BULLDOZED": "BULLDOZE, to override objections [v]\n",
  "BULLDOZER": "a powerful, heavy tractor with a vertical blade at the front, used for levelling and clearing land [n -S]\n",
  "BULLDOZERS": "BULLDOZER, a powerful, heavy tractor with a vertical blade at the front, used for levelling and clearing land [n]\n",
  "BULLDOZES": "BULLDOZE, to override objections [v]\n",
  "BULLDOZING": "BULLDOZE, to override objections [v]\n",
  "BULLDUST": "(Australian slang) a euphemism for bullshit [n -S]\n",
  "BULLDUSTS": "BULLDUST, (Australian slang) a euphemism for bullshit [n]\n",
  "BULLDYKE": "(offensive) an aggressive lesbian, also BULLDIKE [n BULLDYKES]\n",
  "BULLDYKES": "BULLDYKE, (offensive) an aggressive lesbian, also BULLDIKE [n]\n",
  "BULLED": "BULL, to copulate with a cow [v]\n",
  "BULLER": "to seethe, gurgle [v -ED, -ING, -S]\n",
  "BULLERED": "BULLER, to seethe, gurgle [v]\n",
  "BULLERING": "BULLER, to seethe, gurgle [v]\n",
  "BULLERS": "BULLER, to seethe, gurgle [v]\n",
  "BULLET": "to move swiftly [v -ED, -ING, -S]\n",
  "BULLETED": "BULLET, to move swiftly [v]\n",
  "BULLETIN": "an official report of public news [n -S] / to make known by or describe in a bulletin [v -ED, -ING, -S]\n",
  "BULLETINED": "BULLETIN, to make known by or describe in a bulletin [v]\n",
  "BULLETING": "BULLET, to move swiftly [v]\n",
  "BULLETINING": "BULLETIN, to make known by or describe in a bulletin [v]\n",
  "BULLETINS": "BULLETIN, to make known by or describe in a bulletin [v]\n",
  "BULLETPROOF": "impenetrable to bullets [adj] / to make impenetrable to bullets [v -ED, -ING, -S]\n",
  "BULLETPROOFED": "BULLETPROOF, to make impenetrable to bullets [v]\n",
  "BULLETPROOFING": "BULLETPROOF, to make impenetrable to bullets [v]\n",
  "BULLETPROOFS": "BULLETPROOF, to make impenetrable to bullets [v]\n",
  "BULLETRIE": "a West Indian saponaceous tree, also BOLLETRIE [n -S]\n",
  "BULLETRIES": "BULLETRIE, a West Indian saponaceous tree, also BOLLETRIE [n]\n",
  "BULLETS": "BULLET, to move swiftly [v]\n",
  "BULLETWOOD": "the wood of a tropical American sapotaceous tree, widely used for construction due to its durability and toughness [n -S]\n",
  "BULLETWOODS": "BULLETWOOD, the wood of a tropical American sapotaceous tree, widely used for construction due to its durability and toughness [n]\n",
  "BULLEY": "a two-masted fishing boat [n -S]\n",
  "BULLEYS": "BULLEY, a two-masted fishing boat [n]\n",
  "BULLFIGHT": "a fight with a bull [n -S]\n",
  "BULLFIGHTER": "one who takes part in a bullfight, a matador [n -S]\n",
  "BULLFIGHTERS": "BULLFIGHTER, one who takes part in a bullfight, a matador [n]\n",
  "BULLFIGHTING": "the action involved in a bullfight [n -S]\n",
  "BULLFIGHTINGS": "BULLFIGHTING, the action involved in a bullfight [n]\n",
  "BULLFIGHTS": "BULLFIGHT, a fight with a bull [n]\n",
  "BULLFINCH": "a type of finch [n -ES]\n",
  "BULLFINCHES": "BULLFINCH, a type of finch [n]\n",
  "BULLFROG": "a large frog [n -S]\n",
  "BULLFROGS": "BULLFROG, a large frog [n]\n",
  "BULLGINE": "(US slang) a steam locomotive, also BULGINE [n -S]\n",
  "BULLGINES": "BULLGINE, (US slang) a steam locomotive, also BULGINE [n]\n",
  "BULLHEAD": "a freshwater fish of many species, aka bullpout or pogge [n -S]\n",
  "BULLHEADED": "having a head like that of a bull; (figuratively) headstrong; obstinate [adj BULLHEADEDLY]\n",
  "BULLHEADEDLY": "BULLHEADED, having a head like that of a bull; (figuratively) headstrong; obstinate [adv]\n",
  "BULLHEADEDNESS": "BULLHEADED, having a head like that of a bull; (figuratively) headstrong; obstinate [n]\n",
  "BULLHEADS": "BULLHEAD, a freshwater fish of many species, aka bullpout or pogge [n]\n",
  "BULLHORN": "(US) a loudhailer [n -S]\n",
  "BULLHORNS": "BULLHORN, (US) a loudhailer [n]\n",
  "BULLIED": "BULLY, to treat threateningly [v]\n",
  "BULLIER": "BULLY, wonderful [adj]\n",
  "BULLIES": "BULLY, to treat threateningly [v]\n",
  "BULLIEST": "BULLY, wonderful [adj]\n",
  "BULLING": "copulation with a cow [n -S]\n",
  "BULLINGS": "BULLING, copulation with a cow [n]\n",
  "BULLION": "uncoined gold or silver [n -S]\n",
  "BULLIONIST": "one in favour of metallic currency [n -S]\n",
  "BULLIONISTS": "BULLIONIST, one in favour of metallic currency [n]\n",
  "BULLIONS": "BULLION, uncoined gold or silver [n]\n",
  "BULLISH": "anticipating or associated with a rise in price [adj BULLISHLY]\n",
  "BULLISHLY": "BULLISH, anticipating or associated with a rise in price [adv]\n",
  "BULLISHNESS": "the state of being bullish [n -ES]\n",
  "BULLISHNESSES": "BULLISHNESS, the state of being bullish [n]\n",
  "BULLMASTIFF": "a breed of dog [n -S]\n",
  "BULLMASTIFFS": "BULLMASTIFF, a breed of dog [n]\n",
  "BULLNECK": "a thick short neck [n -S]\n",
  "BULLNECKED": "having a thick neck [adj]\n",
  "BULLNECKS": "BULLNECK, a thick short neck [n]\n",
  "BULLNOSE": "swine snout disease [n -S]\n",
  "BULLNOSED": "of the edge of a surface, rounded [adj]\n",
  "BULLNOSES": "BULLNOSE, swine snout disease [n]\n",
  "BULLOCK": "to force one's way [v -ED, -ING, -S]\n",
  "BULLOCKED": "BULLOCK, to force one's way [v]\n",
  "BULLOCKIER": "BULLOCKY, like a bullock [adj]\n",
  "BULLOCKIES": "BULLOCKY, a bullock-driver [n]\n",
  "BULLOCKIEST": "BULLOCKY, like a bullock [adj]\n",
  "BULLOCKING": "BULLOCK, to force one's way [v]\n",
  "BULLOCKS": "BULLOCK, to force one's way [v]\n",
  "BULLOCKY": "like a bullock [adj BULLOCKIER, BULLOCKIEST] / a bullock-driver [n BULLOCKIES]\n",
  "BULLOSA": "as in epidermolysis bullosa, a disease where one's skin falls off [adj]\n",
  "BULLOUS": "blistered, puckered, bubble-like, also BULLATE [adj]\n",
  "BULLPEN": "an enclosure for bulls or prisoners [n -S]\n",
  "BULLPENS": "BULLPEN, an enclosure for bulls or prisoners [n]\n",
  "BULLPOUT": "a freshwater fish of many species, aka bullhead [n -S]\n",
  "BULLPOUTS": "BULLPOUT, a freshwater fish of many species, aka bullhead [n]\n",
  "BULLRING": "a bullfight arena [n -S]\n",
  "BULLRINGS": "BULLRING, a bullfight arena [n]\n",
  "BULLROARER": "a wooden slat attached to a thong that makes a roaring sound when the thong is whirled, used esp. by native Australians in religious rites [n -S]\n",
  "BULLROARERS": "BULLROARER, a wooden slat attached to a thong that makes a roaring sound when the thong is whirled, used esp. by native Australians in religious rites [n]\n",
  "BULLRUSH": "an aquatic plant, reed-mace, also BULRUSH [n -ES]\n",
  "BULLRUSHES": "BULLRUSH, an aquatic plant, reed-mace, also BULRUSH [n]\n",
  "BULLS": "BULL, to copulate with a cow [v]\n",
  "BULLSEYE": "the center of a target [n -S]\n",
  "BULLSEYES": "BULLSEYE, the center of a target [n]\n",
  "BULLSHAT": "BULLSHIT, (offensive) to talk nonsense [v]\n",
  "BULLSHIT": "(offensive) to talk nonsense [v BULLSHAT or BULLSHITTED, BULLSHITTING, BULLSHITS]\n",
  "BULLSHITS": "BULLSHIT, (offensive) to talk nonsense [v]\n",
  "BULLSHITTED": "BULLSHIT, (offensive) to talk nonsense [v]\n",
  "BULLSHITTER": "(offensive) one who bullshits [n -S]\n",
  "BULLSHITTERS": "BULLSHITTER, (offensive) one who bullshits [n]\n",
  "BULLSHITTING": "talking nonsense [n -S]\n",
  "BULLSHITTINGS": "BULLSHITTING, talking nonsense [n]\n",
  "BULLSHOT": "a drink made of vodka and bouillon [n -S]\n",
  "BULLSHOTS": "BULLSHOT, a drink made of vodka and bouillon [n]\n",
  "BULLSNAKE": "an American burrowing snake [n -S]\n",
  "BULLSNAKES": "BULLSNAKE, an American burrowing snake [n]\n",
  "BULLTERRIER": "a breed of dog [n -S]\n",
  "BULLTERRIERS": "BULLTERRIER, a breed of dog [n]\n",
  "BULLWADDIE": "(Native Australian) an Australian tree, also BULWADDY, BULLWADDY [n -S]\n",
  "BULLWADDIES": "BULLWADDY, (Native Australian) an Australian tree, also BULWADDY, BULLWADDIE [n]\n",
  "BULLWADDY": "(Native Australian) an Australian tree, also BULWADDY, BULLWADDIE [n BULLWADDIES]\n",
  "BULLWEED": "knapweed [n -S]\n",
  "BULLWEEDS": "BULLWEED, knapweed [n]\n",
  "BULLWHACK": "to strike with a kind of heavy whip [v -ED, -ING, -S]\n",
  "BULLWHACKED": "BULLWHACK, to strike with a kind of heavy whip [v]\n",
  "BULLWHACKING": "BULLWHACK, to strike with a kind of heavy whip [v]\n",
  "BULLWHACKS": "BULLWHACK, to strike with a kind of heavy whip [v]\n",
  "BULLWHIP": "to strike with a long whip [v BULLWHIPPED, BULLWHIPPING, BULLWHIPS]\n",
  "BULLWHIPPED": "BULLWHIP, to strike with a long whip [v]\n",
  "BULLWHIPPING": "BULLWHIP, to strike with a long whip [v]\n",
  "BULLWHIPS": "BULLWHIP, to strike with a long whip [v]\n",
  "BULLY": "to treat threateningly [v BULLIED, BULLYING, BULLIES] / wonderful [adj BULLIER, BULLIEST]\n",
  "BULLYBOY": "a ruffian hired to beat or intimidate someone [n -S]\n",
  "BULLYBOYS": "BULLYBOY, a ruffian hired to beat or intimidate someone [n]\n",
  "BULLYCIDE": "the act or an instance of killing oneself intentionally as a result of bullying [n -S]\n",
  "BULLYCIDES": "BULLYCIDE, the act or an instance of killing oneself intentionally as a result of bullying [n]\n",
  "BULLYING": "the act of oppressing cruelly [n -S]\n",
  "BULLYINGS": "BULLYING, the act of oppressing cruelly [n]\n",
  "BULLYISM": "rule by bullies [n -S]\n",
  "BULLYISMS": "BULLYISM, rule by bullies [n]\n",
  "BULLYRAG": "to intimidate by bullying [v BULLYRAGGED, BULLYRAGGING, BULLYRAGS]\n",
  "BULLYRAGGED": "BULLYRAG, to intimidate by bullying [v]\n",
  "BULLYRAGGING": "BULLYRAG, to intimidate by bullying [v]\n",
  "BULLYRAGS": "BULLYRAG, to intimidate by bullying [v]\n",
  "BULNBULN": "(Native Australian) the lyrebird [n -S]\n",
  "BULNBULNS": "BULNBULN, (Native Australian) the lyrebird [n]\n",
  "BULRUSH": "an aquatic plant, reed-mace, also BULLRUSH [n -ES]\n",
  "BULRUSHES": "BULRUSH, an aquatic plant, reed-mace, also BULLRUSH [n]\n",
  "BULRUSHIER": "BULRUSHY, full of bulrushes [adj]\n",
  "BULRUSHIEST": "BULRUSHY, full of bulrushes [adj]\n",
  "BULRUSHY": "full of bulrushes [adj BULRUSHIER, BULRUSHIEST]\n",
  "BULSE": "a small bag for diamonds, gold dust etc. [n -S]\n",
  "BULSES": "BULSE, a small bag for diamonds, gold dust etc. [n]\n",
  "BULWADDEE": "(Native Australian) a North Australian tree, also BULLWADDIE, BULLWADDY, BULWADDY [n -S]\n",
  "BULWADDEES": "BULWADDEE, (Native Australian) a North Australian tree, also BULLWADDIE, BULLWADDY, BULWADDY [n]\n",
  "BULWADDIES": "BULWADDY, (Native Australian) a North Australian tree, also BULLWADDIE, BULLWADDY, BULWADDEE [n]\n",
  "BULWADDY": "(Native Australian) a North Australian tree, also BULLWADDIE, BULLWADDY, BULWADDEE [n BULWADDIES]\n",
  "BULWARK": "to fortify [v -ED, -ING, -S]\n",
  "BULWARKED": "BULWARK, to fortify [v]\n",
  "BULWARKING": "BULWARK, to fortify [v]\n",
  "BULWARKS": "BULWARK, to fortify [v]\n",
  "BUM": "to live idly [v BUMMED, BUMMING, BUMS] / worthless [adj BUMMER, BUMMEST]\n",
  "BUMALO": "(Marathi) a small marine Asiatic fish used in India as a relish; aka Bombay duck, also BUMALOTI, BUMMALO, BUMMALOTI [n]\n",
  "BUMALOTI": "(Marathi) a small marine Asiatic fish used in India as a relish, aka Bombay duck, also BUMALO, BUMMALO, BUMMALOTI [n -S]\n",
  "BUMALOTIS": "BUMALOTI, (Marathi) a small marine Asiatic fish used in India as a relish, aka Bombay duck, also BUMALO, BUMMALO, BUMMALOTI [n]\n",
  "BUMBAG": "a small bag, usually worn on a belt round the waist [n -S]\n",
  "BUMBAGS": "BUMBAG, a small bag, usually worn on a belt round the waist [n]\n",
  "BUMBAILIFF": "a bailiff who comes behind to make arrests [n -S]\n",
  "BUMBAILIFFS": "BUMBAILIFF, a bailiff who comes behind to make arrests [n]\n",
  "BUMBAZE": "(Scots) to perplex, bamboozle [v BUMBAZED, BUMBAZING, BUMBAZES]\n",
  "BUMBAZED": "BUMBAZE, (Scots) to perplex, bamboozle [v]\n",
  "BUMBAZES": "BUMBAZE, (Scots) to perplex, bamboozle [v]\n",
  "BUMBAZING": "BUMBAZE, (Scots) to perplex, bamboozle [v]\n",
  "BUMBERSHOOT": "(US slang) umbrella [n -S]\n",
  "BUMBERSHOOTS": "BUMBERSHOOT, (US slang) umbrella [n]\n",
  "BUMBLE": "to bungle, also BUMMLE [v BUMBLED, BUMBLING, BUMBLES]\n",
  "BUMBLEBEE": "a large bee of the genus Bombus [n -S]\n",
  "BUMBLEBEES": "BUMBLEBEE, a large bee of the genus Bombus [n]\n",
  "BUMBLEBERRIES": "BUMBLEBERRY, (Canadian) a mixture of berries used in pie fillings and in preserves [n]\n",
  "BUMBLEBERRY": "(Canadian) a mixture of berries used in pie fillings and in preserves [n BUMBLEBERRIES]\n",
  "BUMBLED": "BUMBLE, to bungle, also BUMMLE [v]\n",
  "BUMBLEDOM": "self-importance in a minor office [n -S]\n",
  "BUMBLEDOMS": "BUMBLEDOM, self-importance in a minor office [n]\n",
  "BUMBLER": "a bungler [n -S]\n",
  "BUMBLERS": "BUMBLER, a bungler [n]\n",
  "BUMBLES": "BUMBLE, to bungle, also BUMMLE [v]\n",
  "BUMBLING": "clumsy [adj BUMBLINGLY] / an instance of clumsiness [n -S]\n",
  "BUMBLINGLY": "BUMBLING, clumsy [adv]\n",
  "BUMBLINGS": "BUMBLING, an instance of clumsiness [n]\n",
  "BUMBO": "a drink mixed from gin, water, sugar and nutmeg [n -S]\n",
  "BUMBOAT": "a boat used to peddle wares to larger ships [n -S]\n",
  "BUMBOATS": "BUMBOAT, a boat used to peddle wares to larger ships [n]\n",
  "BUMBOS": "BUMBO, a drink mixed from gin, water, sugar and nutmeg [n]\n",
  "BUMBOY": "a young male homosexual, especially a prostitute [n -S]\n",
  "BUMBOYS": "BUMBOY, a young male homosexual, especially a prostitute [n]\n",
  "BUMELIA": "a thorny tree [n -S]\n",
  "BUMELIAS": "BUMELIA, a thorny tree [n]\n",
  "BUMF": "paperwork, also BUMPH [n -S]\n",
  "BUMFLUFF": "an adolescent's soft and fluffy growth, not deserving to be called a beard [n -S]\n",
  "BUMFLUFFS": "BUMFLUFF, an adolescent's soft and fluffy growth, not deserving to be called a beard [n]\n",
  "BUMFREEZER": "a short jacket [n -S]\n",
  "BUMFREEZERS": "BUMFREEZER, a short jacket [n]\n",
  "BUMFS": "BUMF, paperwork, also BUMPH [n]\n",
  "BUMFUCK": "(offensive US slang) a remote or insignificant place [n -S]\n",
  "BUMFUCKS": "BUMFUCK, (offensive US slang) a remote or insignificant place [n]\n",
  "BUMFUZZLE": "to confuse [v BUMFUZZLED, BUMFUZZLING, BUMFUZZLES]\n",
  "BUMFUZZLED": "BUMFUZZLE, to confuse [v]\n",
  "BUMFUZZLES": "BUMFUZZLE, to confuse [v]\n",
  "BUMFUZZLING": "BUMFUZZLE, to confuse [v]\n",
  "BUMKIN": "a spar projecting from the stern of ship, also BOOMKIN, BUMPKIN [n -S]\n",
  "BUMKINS": "BUMKIN, a spar projecting from the stern of ship, also BOOMKIN, BUMPKIN [n]\n",
  "BUMMALO": "(Marathi) a small marine Asiatic fish used in India as a relish; aka Bombay duck, also BUMALO, BUMALOTI, BUMMALOTI [n -S]\n",
  "BUMMALOS": "BUMMALO, (Marathi) a small marine Asiatic fish used in India as a relish; aka Bombay duck, also BUMALO, BUMALOTI, BUMMALOTI [n]\n",
  "BUMMALOTI": "(Marathi) a small marine Asiatic fish used in India as a relish; aka Bombay duck, also BUMALO, BUMALOTI, BUMMALO [n -S]\n",
  "BUMMALOTIS": "BUMMALOTI, (Marathi) a small marine Asiatic fish used in India as a relish; aka Bombay duck, also BUMALO, BUMALOTI, BUMMALO [n]\n",
  "BUMMAREE": "a middleman in Billingsgate fish-market [n -S]\n",
  "BUMMAREES": "BUMMAREE, a middleman in Billingsgate fish-market [n]\n",
  "BUMMED": "BUM, to live idly [v]\n",
  "BUMMEL": "(German) a stroll; a leisurely journey [n -S]\n",
  "BUMMELS": "BUMMEL, (German) a stroll; a leisurely journey [n]\n",
  "BUMMER": "a disappointment [n -S]\n",
  "BUMMERS": "BUMMER, a disappointment [n]\n",
  "BUMMEST": "BUM, worthless [adj]\n",
  "BUMMING": "BUM, to live idly [v]\n",
  "BUMMLE": "to bungle, also BUMBLE [v BUMMLED, BUMMLING, BUMMLES]\n",
  "BUMMLED": "BUMMLE, to bungle, also BUMBLE [v]\n",
  "BUMMLES": "BUMMLE, to bungle, also BUMBLE [v]\n",
  "BUMMLING": "BUMMLE, to bungle, also BUMBLE [v]\n",
  "BUMMOCK": "a submerged mass of ice projecting downwards [n -S]\n",
  "BUMMOCKS": "BUMMOCK, a submerged mass of ice projecting downwards [n]\n",
  "BUMP": "to knock against [v -ED, -ING, -S]\n",
  "BUMPED": "BUMP, to knock against [v]\n",
  "BUMPER": "a cup or glass full to the brim [n -S] / to drink bumpers [v -ED, -ING, -S]\n",
  "BUMPERED": "BUMPER, to drink bumpers [v]\n",
  "BUMPERING": "BUMPER, to drink bumpers [v]\n",
  "BUMPERS": "BUMPER, to drink bumpers [v]\n",
  "BUMPH": "toilet paper; also, worthless paperwork, literature, or junk mail, also BUMF [n -S]\n",
  "BUMPHS": "BUMPH, toilet paper; also, worthless paperwork, literature, or junk mail, also BUMF [n]\n",
  "BUMPIER": "BUMPY, of uneven surface [adj]\n",
  "BUMPIEST": "BUMPY, of uneven surface [adj]\n",
  "BUMPILY": "BUMPY, of uneven surface [adv]\n",
  "BUMPINESS": "the state of being bumpy [n -ES]\n",
  "BUMPINESSES": "BUMPINESS, the state of being bumpy [n]\n",
  "BUMPING": "the act of bumping [n -S]\n",
  "BUMPINGS": "BUMPING, the act of bumping [n]\n",
  "BUMPKIN": "a clumsy rustic [n -S]\n",
  "BUMPKINISH": "like a bumpkin, also BUMPKINLY [adj]\n",
  "BUMPKINLIER": "BUMPKINLY, like a bumpkin, also BUMPKINISH [adj]\n",
  "BUMPKINLIEST": "BUMPKINLY, like a bumpkin, also BUMPKINISH [adj]\n",
  "BUMPKINLY": "like a bumpkin, also BUMPKINISH [adj BUMPKINLIER, BUMPKINLIEST]\n",
  "BUMPKINS": "BUMPKIN, a clumsy rustic [n]\n",
  "BUMPOLOGIES": "BUMPOLOGY, jocularly, the study of bumps on the head, aka phrenology [n]\n",
  "BUMPOLOGY": "jocularly, the study of bumps on the head, aka phrenology [n BUMPOLOGIES]\n",
  "BUMPS": "BUMP, to knock against [v]\n",
  "BUMPSADAISY": "an exclamation on bumping into someone or something, or to a child on falling [interj]\n",
  "BUMPTIOUS": "offensively conceited or self-assertive [adj BUMPTIOUSLY]\n",
  "BUMPTIOUSLY": "BUMPTIOUS, offensively conceited or self-assertive [adv]\n",
  "BUMPTIOUSNESS": "the state of being bumptious [n -ES]\n",
  "BUMPTIOUSNESSES": "BUMPTIOUSNESS, the state of being bumptious [n]\n",
  "BUMPY": "of uneven surface [adj BUMPIER, BUMPIEST, BUMPILY]\n",
  "BUMS": "BUM, to live idly [v]\n",
  "BUMSTER": "of trousers, cut in a style low enough to show the cleavage at the top of the buttocks [adj]\n",
  "BUMSTERS": "trousers cut just above the buttocks [n]\n",
  "BUMSUCKER": "(slang) a toady [n -S]\n",
  "BUMSUCKERS": "BUMSUCKER, (slang) a toady [n]\n",
  "BUMSUCKING": "sycophancy [n -S]\n",
  "BUMSUCKINGS": "BUMSUCKING, sycophancy [n]\n",
  "BUMWAD": "a type of paper used for sketching [n -S]\n",
  "BUMWADS": "BUMWAD, a type of paper used for sketching [n]\n",
  "BUN": "a small sweet cake [n -S]\n",
  "BUNA": "a kind of artificial rubber made from butadiene [n -S]\n",
  "BUNAS": "BUNA, a kind of artificial rubber made from butadiene [n]\n",
  "BUNBURIED": "BUNBURY, to create a fictitious scenario that provides an excuse for avoiding unwanted engagements [v]\n",
  "BUNBURIES": "BUNBURY, to create a fictitious scenario that provides an excuse for avoiding unwanted engagements [v]\n",
  "BUNBURY": "to create a fictitious scenario that provides an excuse for avoiding unwanted engagements [v BUNBURIED, BUNBURYING, BUNBURIES]\n",
  "BUNBURYING": "BUNBURY, to create a fictitious scenario that provides an excuse for avoiding unwanted engagements [v]\n",
  "BUNCE": "to disguise pilfering by overcharging customers [v BUNCED, BUNCING, BUNCES]\n",
  "BUNCED": "BUNCE, to disguise pilfering by overcharging customers [v]\n",
  "BUNCES": "BUNCE, to disguise pilfering by overcharging customers [v]\n",
  "BUNCH": "to gather together [v -ED, -ING, -ES]\n",
  "BUNCHBERRIES": "BUNCHBERRY, the dwarf cornel, which bears a dense cluster of bright red, edible berries [n]\n",
  "BUNCHBERRY": "the dwarf cornel, which bears a dense cluster of bright red, edible berries [n BUNCHBERRIES]\n",
  "BUNCHED": "BUNCH, to gather together [v]\n",
  "BUNCHER": "one that gathers things together [n -S]\n",
  "BUNCHERS": "BUNCHER, one that gathers things together [n]\n",
  "BUNCHES": "BUNCH, to gather together [v]\n",
  "BUNCHGRASS": "a kind of West American grass, that grows in clumps [n -ES]\n",
  "BUNCHGRASSES": "BUNCHGRASS, a kind of West American grass, that grows in clumps [n]\n",
  "BUNCHIER": "BUNCHY, clustered [adj]\n",
  "BUNCHIEST": "BUNCHY, clustered [adj]\n",
  "BUNCHILY": "BUNCHY, clustered [adv]\n",
  "BUNCHINESS": "the state of being bunchy [n -ES]\n",
  "BUNCHINESSES": "BUNCHINESS, the state of being bunchy [n]\n",
  "BUNCHING": "the act of grouping together [n -S]\n",
  "BUNCHINGS": "BUNCHING, the act of grouping together [n]\n",
  "BUNCHY": "clustered [adj BUNCHIER, BUNCHIEST, BUNCHILY]\n",
  "BUNCING": "BUNCE, to disguise pilfering by overcharging customers [v]\n",
  "BUNCO": "(US slang) a confidence trick [n -S] / to practice such a trick, also BUNKO [v -ED, -ING, -ES]\n",
  "BUNCOED": "BUNCO, to practice such a trick, also BUNKO [v]\n",
  "BUNCOES": "BUNCO, to practice such a trick, also BUNKO [v]\n",
  "BUNCOING": "BUNCO, to practice such a trick, also BUNKO [v]\n",
  "BUNCOMBE": "insincere or foolish talk, nonsense, also BUNKUM [n -S]\n",
  "BUNCOMBES": "BUNCOMBE, insincere or foolish talk, nonsense, also BUNKUM [n]\n",
  "BUNCOS": "BUNCO, to practice such a trick, also BUNKO [v]\n",
  "BUND": "to make an embankment [v -ED, -ING, -S] / a German federation or league [n BUNDS or BUNDE]\n",
  "BUNDE": "BUND, a German federation or league [n]\n",
  "BUNDED": "BUND, to make an embankment [v]\n",
  "BUNDH": "(Hindi) in India, a general strike, also BANDH [n -S]\n",
  "BUNDHS": "BUNDH, (Hindi) in India, a general strike, also BANDH [n]\n",
  "BUNDIED": "BUNDY, to clock on or clock off work [v]\n",
  "BUNDIES": "BUNDY, to clock on or clock off work [v]\n",
  "BUNDING": "BUND, to make an embankment [v]\n",
  "BUNDIST": "a member of a bund, a confederacy [n -S]\n",
  "BUNDISTS": "BUNDIST, a member of a bund, a confederacy [n]\n",
  "BUNDLE": "to fasten together [v BUNDLED, BUNDLING, BUNDLES]\n",
  "BUNDLED": "BUNDLE, to fasten together [v]\n",
  "BUNDLER": "one that bundles [n -S]\n",
  "BUNDLERS": "BUNDLER, one that bundles [n]\n",
  "BUNDLES": "BUNDLE, to fasten together [v]\n",
  "BUNDLING": "the act of making a bundle [n -S]\n",
  "BUNDLINGS": "BUNDLING, the act of making a bundle [n]\n",
  "BUNDOBUST": "(Urdu) an organisation, also BANDOBAST, BANDOBUST [n -S]\n",
  "BUNDOBUSTS": "BUNDOBUST, (Urdu) an organisation, also BANDOBAST, BANDOBUST [n]\n",
  "BUNDOOK": "(Urdu) Indian army slang for a rifle, a shotgun, also BANDOOK [n -S]\n",
  "BUNDOOKS": "BUNDOOK, (Urdu) Indian army slang for a rifle, a shotgun, also BANDOOK [n]\n",
  "BUNDS": "BUND, to make an embankment [v]\n",
  "BUNDT": "a type of cake pan [n -S]\n",
  "BUNDTS": "BUNDT, a type of cake pan [n]\n",
  "BUNDU": "(Bantu) a remote uncultivated region [n -S]\n",
  "BUNDUS": "BUNDU, (Bantu) a remote uncultivated region [n]\n",
  "BUNDWALL": "a concrete or earth wall surrounding a storage tank containing crude oil [n -S]\n",
  "BUNDWALLS": "BUNDWALL, a concrete or earth wall surrounding a storage tank containing crude oil [n]\n",
  "BUNDY": "to clock on or clock off work [v BUNDIED, BUNDYING, BUNDIES]\n",
  "BUNDYING": "BUNDY, to clock on or clock off work [v]\n",
  "BUNFIGHT": "a tea party, a petty squabble [n -S]\n",
  "BUNFIGHTS": "BUNFIGHT, a tea party, a petty squabble [n]\n",
  "BUNG": "to plug with a stopper [v -ED, -ING, -S]\n",
  "BUNGALOID": "(facetious) of or like a bungalow [adj] / a dwelling like a bungalow [n -S]\n",
  "BUNGALOIDS": "BUNGALOID, a dwelling like a bungalow [n]\n",
  "BUNGALOW": "(Hindi) a lightly-built house, properly one with a veranda and one storey [n -S]\n",
  "BUNGALOWS": "BUNGALOW, (Hindi) a lightly-built house, properly one with a veranda and one storey [n]\n",
  "BUNGED": "BUNG, to plug with a stopper [v]\n",
  "BUNGEE": "a strong rubber rope, also BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJIE, BUNJY [n -S]\n",
  "BUNGEES": "BUNGEE, a strong rubber rope, also BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJIE, BUNJY [n]\n",
  "BUNGER": "(Australian slang) a firecracker [n -S]\n",
  "BUNGERS": "BUNGER, (Australian slang) a firecracker [n]\n",
  "BUNGEY": "a strong rubber rope, also BUNGEE, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJIE, BUNJY [n -S]\n",
  "BUNGEYS": "BUNGEY, a strong rubber rope, also BUNGEE, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJIE, BUNJY [n]\n",
  "BUNGHOLE": "(Australian slang) mouth [n -S]\n",
  "BUNGHOLES": "BUNGHOLE, (Australian slang) mouth [n]\n",
  "BUNGIE": "a strong rubber rope, also BUNGEE, BUNGEY, BUNGY, BUNJE, BUNJEE, BUNJIE, BUNJY [n -S]\n",
  "BUNGIES": "BUNGY, a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNJE, BUNJEE, BUNJIE, BUNJY [n]\n",
  "BUNGING": "BUNG, to plug with a stopper [v]\n",
  "BUNGLE": "to mismanage [v BUNGLED, BUNGLING, BUNGLES]\n",
  "BUNGLED": "BUNGLE, to mismanage [v]\n",
  "BUNGLER": "one who mismanages [n -S]\n",
  "BUNGLERS": "BUNGLER, one who mismanages [n]\n",
  "BUNGLES": "BUNGLE, to mismanage [v]\n",
  "BUNGLESOME": "clumsy, awkward [adj]\n",
  "BUNGLING": "clumsy, awkward [adj BUNGLINGLY] / an instance of clumsiness [n -S]\n",
  "BUNGLINGLY": "BUNGLING, clumsy, awkward [adv]\n",
  "BUNGLINGS": "BUNGLING, an instance of clumsiness [n]\n",
  "BUNGS": "BUNG, to plug with a stopper [v]\n",
  "BUNGWALL": "(Native Australian) an Australian fern with an edible rhizome [n -S]\n",
  "BUNGWALLS": "BUNGWALL, (Native Australian) an Australian fern with an edible rhizome [n]\n",
  "BUNGY": "a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNJE, BUNJEE, BUNJIE, BUNJY [n BUNGIES]\n",
  "BUNHEAD": "a female ballet dancer [n -S]\n",
  "BUNHEADS": "BUNHEAD, a female ballet dancer [n]\n",
  "BUNIA": "(Hindi) an (Indian) corn-merchant, also BUNNIA [n -S]\n",
  "BUNIAS": "BUNIA, (Hindi) an (Indian) corn-merchant, also BUNNIA [n]\n",
  "BUNION": "a painful swelling on the toe [n -S]\n",
  "BUNIONS": "BUNION, a painful swelling on the toe [n]\n",
  "BUNJE": "a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJEE, BUNJIE, BUNJY [n -S]\n",
  "BUNJEE": "a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJIE, BUNJY [n -S]\n",
  "BUNJEES": "BUNJEE, a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJIE, BUNJY [n]\n",
  "BUNJES": "BUNJE, a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJEE, BUNJIE, BUNJY [n]\n",
  "BUNJIE": "a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJY [n -S]\n",
  "BUNJIES": "BUNJIE, a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJY [n]\n",
  "BUNJY": "a strong rubber rope, also BUNGEE, BUNGEY, BUNGIE, BUNGY, BUNJE, BUNJEE, BUNJIE [n BUNJIES]\n",
  "BUNK": "to go to bed [v -ED, -ING, -S]\n",
  "BUNKED": "BUNK, to go to bed [v]\n",
  "BUNKER": "to store in a large bin [v -ED, -ING, -S]\n",
  "BUNKERED": "BUNKER, to store in a large bin [v]\n",
  "BUNKERING": "BUNKER, to store in a large bin [v]\n",
  "BUNKERS": "BUNKER, to store in a large bin [v]\n",
  "BUNKHOUSE": "a place where cowboys etc. sleep [n -S]\n",
  "BUNKHOUSES": "BUNKHOUSE, a place where cowboys etc. sleep [n]\n",
  "BUNKIE": "a small separate building for guests [n -S]\n",
  "BUNKIES": "BUNKIE, a small separate building for guests [n]\n",
  "BUNKING": "BUNK, to go to bed [v]\n",
  "BUNKMATE": "one who shares sleeping quarters [n -S]\n",
  "BUNKMATES": "BUNKMATE, one who shares sleeping quarters [n]\n",
  "BUNKO": "to practice a confidence trick, also BUNCO [v -ED, -ING, -S]\n",
  "BUNKOED": "BUNKO, to practice a confidence trick, also BUNCO [v]\n",
  "BUNKOING": "BUNKO, to practice a confidence trick, also BUNCO [v]\n",
  "BUNKOS": "BUNKO, to practice a confidence trick, also BUNCO [v]\n",
  "BUNKS": "BUNK, to go to bed [v]\n",
  "BUNKUM": "insincere or foolish talk, nonsense, also BUNCOMBE [n -S]\n",
  "BUNKUMS": "BUNKUM, insincere or foolish talk, nonsense, also BUNCOMBE [n]\n",
  "BUNN": "a kind of sweet roll or cake, also BUN [n -S]\n",
  "BUNNET": "a bonnet, also BONNET [n -S]\n",
  "BUNNETS": "BUNNET, a bonnet, also BONNET [n]\n",
  "BUNNIA": "(Hindi) an (Indian) corn-merchant, also BUNIA [n -S]\n",
  "BUNNIAS": "BUNNIA, (Hindi) an (Indian) corn-merchant, also BUNIA [n]\n",
  "BUNNIES": "BUNNY, (colloquial) a rabbit [n]\n",
  "BUNNS": "BUNN, a kind of sweet roll or cake, also BUN [n]\n",
  "BUNNY": "(colloquial) a rabbit [n BUNNIES]\n",
  "BUNODONT": "having rounded molar teeth [adj]\n",
  "BUNRAKU": "(Japanese) a form of puppet theater with large puppets [n -S]\n",
  "BUNRAKUS": "BUNRAKU, (Japanese) a form of puppet theater with large puppets [n]\n",
  "BUNS": "BUN, a small sweet cake [n]\n",
  "BUNSEN": "a type of gas-burner used in laboratories [n -S]\n",
  "BUNSENS": "BUNSEN, a type of gas-burner used in laboratories [n]\n",
  "BUNT": "to push with the horns, butt [v -ED, -ING, -S]\n",
  "BUNTAL": "(Tagalog) the straw of the talipot palm [n -S]\n",
  "BUNTALS": "BUNTAL, (Tagalog) the straw of the talipot palm [n]\n",
  "BUNTED": "BUNT, to push with the horns, butt [v]\n",
  "BUNTER": "a female ragpicker [n -S]\n",
  "BUNTERS": "BUNTER, a female ragpicker [n]\n",
  "BUNTIER": "BUNTY, having bunt, a disease of wheat [adj]\n",
  "BUNTIEST": "BUNTY, having bunt, a disease of wheat [adj]\n",
  "BUNTING": "any of the small finch-like birds of the subfamily Emberizinae [n -S]\n",
  "BUNTINGS": "BUNTING, any of the small finch-like birds of the subfamily Emberizinae [n]\n",
  "BUNTLINE": "a rope attached to the middle of a square sail to haul it up to the yard [n -S]\n",
  "BUNTLINES": "BUNTLINE, a rope attached to the middle of a square sail to haul it up to the yard [n]\n",
  "BUNTS": "BUNT, to push with the horns, butt [v]\n",
  "BUNTY": "having bunt, a disease of wheat [adj BUNTIER, BUNTIEST]\n",
  "BUNYA": "(Native Australian) an Australian coniferous tree with edible seeds [n -S]\n",
  "BUNYAS": "BUNYA, (Native Australian) an Australian coniferous tree with edible seeds [n]\n",
  "BUNYIP": "(Native Australian) a fabulous monster of swamps and lagoons [n -S]\n",
  "BUNYIPS": "BUNYIP, (Native Australian) a fabulous monster of swamps and lagoons [n]\n",
  "BUOY": "to mark with a warning float [v -ED, -ING, -S]\n",
  "BUOYAGE": "a group of buoys [n -S]\n",
  "BUOYAGES": "BUOYAGE, a group of buoys [n]\n",
  "BUOYANCE": "the tendency to float, also BUOYANCY [n -S]\n",
  "BUOYANCES": "BUOYANCE, the tendency to float, also BUOYANCY [n]\n",
  "BUOYANCIES": "BUOYANCY, the tendency to float, also BUOYANCE [n]\n",
  "BUOYANCY": "the tendency to float, also BUOYANCE [n BUOYANCIES]\n",
  "BUOYANT": "having buoyancy [adj BUOYANTLY]\n",
  "BUOYANTLY": "BUOYANT, having buoyancy [adv]\n",
  "BUOYANTNESS": "the state of being buoyant [n -ES]\n",
  "BUOYANTNESSES": "BUOYANTNESS, the state of being buoyant [n]\n",
  "BUOYED": "BUOY, to mark with a warning float [v]\n",
  "BUOYING": "BUOY, to mark with a warning float [v]\n",
  "BUOYS": "BUOY, to mark with a warning float [v]\n",
  "BUPIVACAINE": "a local anaesthetic of long duration, used for nerve blocks [n -S]\n",
  "BUPIVACAINES": "BUPIVACAINE, a local anaesthetic of long duration, used for nerve blocks [n]\n",
  "BUPKES": "(Yiddish) a very small amount, also BUBKES, BUBKIS, BUPKIS, BUPKUS [n BUPKES]\n",
  "BUPKIS": "(Yiddish) a very small amount, also BUBKES, BUBKIS, BUPKES, BUPKUS [n BUPKIS]\n",
  "BUPKUS": "(Yiddish) a very small amount, also BUBKES, BUBKIS, BUPKES, BUPKIS [n BUPKUS]\n",
  "BUPLEVER": "the hare's-ear plant [n -S]\n",
  "BUPLEVERS": "BUPLEVER, the hare's-ear plant [n]\n",
  "BUPPIE": "a black urban professional, also BUPPY [n -S]\n",
  "BUPPIES": "BUPPIE, a black urban professional, also BUPPY [n]\n",
  "BUPPY": "a black urban professional, also BUPPIE [n BUPPIES]\n",
  "BUPRENORPHINE": "an opiate used medicinally as a powerful analgesic [n -S]\n",
  "BUPRENORPHINES": "BUPRENORPHINE, an opiate used medicinally as a powerful analgesic [n]\n",
  "BUPRESTID": "a kind of wood-boring beetle [n -S]\n",
  "BUPRESTIDS": "BUPRESTID, a kind of wood-boring beetle [n]\n",
  "BUPROPION": "an antidepressant drug used in the treatment of nicotine addiction [n -S]\n",
  "BUPROPIONS": "BUPROPION, an antidepressant drug used in the treatment of nicotine addiction [n]\n",
  "BUQSHA": "a monetary unit of Yemen [n -S]\n",
  "BUQSHAS": "BUQSHA, a monetary unit of Yemen [n]\n",
  "BUR": "to remove a rough edge from, also BURR [v BURRED, BURRING, BURS]\n",
  "BURA": "(Russian) a violent blizzard blowing from the NE in Siberia and central Asia, also BURAN [n -S]\n",
  "BURAN": "(Russian) a violent blizzard blowing from the NE in Siberia and central Asia, also BURA [n -S]\n",
  "BURANS": "BURAN, (Russian) a violent blizzard blowing from the NE in Siberia and central Asia, also BURA [n]\n",
  "BURAS": "BURA, (Russian) a violent blizzard blowing from the NE in Siberia and central Asia, also BURAN [n]\n",
  "BURB": "(short for) a suburb [n -S]\n",
  "BURBLE": "to speak quickly and incoherently [v BURBLED, BURBLING, BURBLES]\n",
  "BURBLED": "BURBLE, to speak quickly and incoherently [v]\n",
  "BURBLER": "one who burbles [n -S]\n",
  "BURBLERS": "BURBLER, one who burbles [n]\n",
  "BURBLES": "BURBLE, to speak quickly and incoherently [v]\n",
  "BURBLIER": "BURBLY, burbling [adj]\n",
  "BURBLIEST": "BURBLY, burbling [adj]\n",
  "BURBLING": "talking incoherently [n -S]\n",
  "BURBLINGS": "BURBLING, talking incoherently [n]\n",
  "BURBLY": "burbling [adj BURBLIER, BURBLIEST]\n",
  "BURBOT": "a long, slender, freshwater fish of cod family, aka eelpout [n -S]\n",
  "BURBOTS": "BURBOT, a long, slender, freshwater fish of cod family, aka eelpout [n]\n",
  "BURBS": "BURB, (short for) a suburb [n]\n",
  "BURD": "(Scots) a bird [n -S]\n",
  "BURDASH": "a fringed sash worn by gentlemen in the time of Anne and George [n -ES]\n",
  "BURDASHES": "BURDASH, a fringed sash worn by gentlemen in the time of Anne and George [n]\n",
  "BURDEN": "to load heavily [v -ED, -ING, -S]\n",
  "BURDENED": "BURDEN, to load heavily [v]\n",
  "BURDENER": "one who burdens [n -S]\n",
  "BURDENERS": "BURDENER, one who burdens [n]\n",
  "BURDENING": "BURDEN, to load heavily [v]\n",
  "BURDENOUS": "inflicting a burden, also BURDENSOME, BURTHENSOME [adj]\n",
  "BURDENS": "BURDEN, to load heavily [v]\n",
  "BURDENSOME": "imposing or constituting a burden, also BURDENOUS, BURTHENSOME [adj]\n",
  "BURDIE": "(Scots) a (small) bird, also BIRDIE [n -S]\n",
  "BURDIES": "BURDIE, (Scots) a (small) bird, also BIRDIE [n]\n",
  "BURDIZZO": "a surgical instrument used to castrate animals [n -S]\n",
  "BURDIZZOS": "BURDIZZO, a surgical instrument used to castrate animals [n]\n",
  "BURDOCK": "a coarse dandelion-like plant [n -S]\n",
  "BURDOCKS": "BURDOCK, a coarse dandelion-like plant [n]\n",
  "BURDS": "BURD, (Scots) a bird [n]\n",
  "BUREAU": "(French) a writing-desk with drawers for papers etc. [n BUREAUS or BUREAUX]\n",
  "BUREAUCRACIES": "BUREAUCRACY, a body of nonelective government officials [n]\n",
  "BUREAUCRACY": "a body of nonelective government officials [n BUREAUCRACIES]\n",
  "BUREAUCRAT": "a member of a bureaucracy [n -S]\n",
  "BUREAUCRATESE": "the language of bureaucrats [n -S]\n",
  "BUREAUCRATESES": "BUREAUCRATESE, the language of bureaucrats [n]\n",
  "BUREAUCRATIC": "of, relating to, or having the characteristics of a bureaucracy or a bureaucrat [adj]\n",
  "BUREAUCRATISE": "to make bureaucratic, also BUREAUCRATIZE [v BUREAUCRATISED, BUREAUCRATISING, BUREAUCRATISES]\n",
  "BUREAUCRATISED": "BUREAUCRATISE, to make bureaucratic, also BUREAUCRATIZE [v]\n",
  "BUREAUCRATISES": "BUREAUCRATISE, to make bureaucratic, also BUREAUCRATIZE [v]\n",
  "BUREAUCRATISING": "BUREAUCRATISE, to make bureaucratic, also BUREAUCRATIZE [v]\n",
  "BUREAUCRATISM": "bureaucracy [n -S]\n",
  "BUREAUCRATISMS": "BUREAUCRATISM, bureaucracy [n]\n",
  "BUREAUCRATIST": "a believer in bureaucracy [n -S]\n",
  "BUREAUCRATISTS": "BUREAUCRATIST, a believer in bureaucracy [n]\n",
  "BUREAUCRATIZE": "to make bureaucratic, also BUREAUCRATISE [v BUREAUCRATIZED, BUREAUCRATIZING, BUREAUCRATIZES]\n",
  "BUREAUCRATIZED": "BUREAUCRATIZE, to make bureaucratic, also BUREAUCRATISE [v]\n",
  "BUREAUCRATIZES": "BUREAUCRATIZE, to make bureaucratic, also BUREAUCRATISE [v]\n",
  "BUREAUCRATIZING": "BUREAUCRATIZE, to make bureaucratic, also BUREAUCRATISE [v]\n",
  "BUREAUCRATS": "BUREAUCRAT, a member of a bureaucracy [n]\n",
  "BUREAUS": "BUREAU, (French) a writing-desk with drawers for papers etc. [n]\n",
  "BUREAUX": "BUREAU, (French) a writing-desk with drawers for papers etc. [n]\n",
  "BURET": "(French) a glass measuring tube for liquid, also BURETTE [n -S]\n",
  "BURETS": "BURET, (French) a glass measuring tube for liquid, also BURETTE [n]\n",
  "BURETTE": "(French) a glass measuring tube for liquid, also BURET [n -S]\n",
  "BURETTES": "BURETTE, (French) a glass measuring tube for liquid, also BURET [n]\n",
  "BURFI": "(Hindi) an Indian dessert made from milk solids and sugar, also BARFI [n -S]\n",
  "BURFIS": "BURFI, (Hindi) an Indian dessert made from milk solids and sugar, also BARFI [n]\n",
  "BURG": "a fortified town [n -S]\n",
  "BURGAGE": "a kind of feudal tenure, tenure in socage for a yearly rent [n -S]\n",
  "BURGAGES": "BURGAGE, a kind of feudal tenure, tenure in socage for a yearly rent [n]\n",
  "BURGANET": "(French) a visored helmet that can be fitted or attached to the gorget or neckpiece, also BURGONET [n -S]\n",
  "BURGANETS": "BURGANET, (French) a visored helmet that can be fitted or attached to the gorget or neckpiece, also BURGONET [n]\n",
  "BURGEE": "a small ship's flag used for identification or signalling [n -S]\n",
  "BURGEES": "BURGEE, a small ship's flag used for identification or signalling [n]\n",
  "BURGEON": "to grow rapidly [v -ED, -ING, -S]\n",
  "BURGEONED": "BURGEON, to grow rapidly [v]\n",
  "BURGEONING": "BURGEON, to grow rapidly [v]\n",
  "BURGEONS": "BURGEON, to grow rapidly [v]\n",
  "BURGER": "a hamburger [n -S]\n",
  "BURGERS": "BURGER, a hamburger [n]\n",
  "BURGESS": "a citizen of a borough, also PORTMAN [n -ES]\n",
  "BURGESSES": "BURGESS, a citizen of a borough, also PORTMAN [n]\n",
  "BURGH": "a borough or incorporated town, esp. in Scotland [n -S]\n",
  "BURGHAL": "relating to a burgh [adj]\n",
  "BURGHER": "a freeman or citizen of a borough [n -S]\n",
  "BURGHERS": "BURGHER, a freeman or citizen of a borough [n]\n",
  "BURGHS": "BURGH, a borough or incorporated town, esp. in Scotland [n]\n",
  "BURGHUL": "(Turkish) a form of cooked, broken wheat, also BULGAR, BULGHUR, BULGUR [n -S]\n",
  "BURGHULS": "BURGHUL, (Turkish) a form of cooked, broken wheat, also BULGAR, BULGHUR, BULGUR [n]\n",
  "BURGLAR": "to enter a building to steal [v -ED, -ING, -S]\n",
  "BURGLARED": "BURGLAR, to enter a building to steal [v]\n",
  "BURGLARIES": "BURGLARY, a felonious theft [n]\n",
  "BURGLARING": "BURGLAR, to enter a building to steal [v]\n",
  "BURGLARIOUS": "(facetious) like a burglar [adj BURGLARIOUSLY]\n",
  "BURGLARIOUSLY": "BURGLARIOUS, (facetious) like a burglar [adv]\n",
  "BURGLARISE": "to commit burglary, also BURGLARIZE [v BURGLARISED, BURGLARISING, BURGLARISES]\n",
  "BURGLARISED": "BURGLARISE, to commit burglary, also BURGLARIZE [v]\n",
  "BURGLARISES": "BURGLARISE, to commit burglary, also BURGLARIZE [v]\n",
  "BURGLARISING": "BURGLARISE, to commit burglary, also BURGLARIZE [v]\n",
  "BURGLARIZE": "to commit burglary, also BURGLARISE [v BURGLARIZED, BURGLARIZING, BURGLARIZES]\n",
  "BURGLARIZED": "BURGLARIZE, to commit burglary, also BURGLARISE [v]\n",
  "BURGLARIZES": "BURGLARIZE, to commit burglary, also BURGLARISE [v]\n",
  "BURGLARIZING": "BURGLARIZE, to commit burglary, also BURGLARISE [v]\n",
  "BURGLARPROOF": "protected against or designed to afford protection against burglary [adj]\n",
  "BURGLARS": "BURGLAR, to enter a building to steal [v]\n",
  "BURGLARY": "a felonious theft [n BURGLARIES]\n",
  "BURGLE": "to trespass to steal [v BURGLED, BURGLING, BURGLES]\n",
  "BURGLED": "BURGLE, to trespass to steal [v]\n",
  "BURGLES": "BURGLE, to trespass to steal [v]\n",
  "BURGLING": "BURGLE, to trespass to steal [v]\n",
  "BURGOMASTER": "(Dutch) the mayor of a Dutch or Flemish town [n -S]\n",
  "BURGOMASTERS": "BURGOMASTER, (Dutch) the mayor of a Dutch or Flemish town [n]\n",
  "BURGONET": "(French) a visored helmet that can be fitted or attached to the gorget or neckpiece, also BURGANET [n -S]\n",
  "BURGONETS": "BURGONET, (French) a visored helmet that can be fitted or attached to the gorget or neckpiece, also BURGANET [n]\n",
  "BURGOO": "a kind of oatmeal pudding, or thick gruel, used by seamen, also BURGOUT [n -S]\n",
  "BURGOOS": "BURGOO, a kind of oatmeal pudding, or thick gruel, used by seamen, also BURGOUT [n]\n",
  "BURGOUT": "a kind of oatmeal pudding, or thick gruel, used by seamen, also BURGOO [n -S]\n",
  "BURGOUTS": "BURGOUT, a kind of oatmeal pudding, or thick gruel, used by seamen, also BURGOO [n]\n",
  "BURGRAVE": "(historical) the commander of a German town or castle [n -S]\n",
  "BURGRAVES": "BURGRAVE, (historical) the commander of a German town or castle [n]\n",
  "BURGS": "BURG, a fortified town [n]\n",
  "BURGUNDIES": "BURGUNDY, a red wine [n]\n",
  "BURGUNDY": "a red wine [n BURGUNDIES]\n",
  "BURHEL": "(Hindi) a blue Himalayan sheep [n -S]\n",
  "BURHELS": "BURHEL, (Hindi) a blue Himalayan sheep [n]\n",
  "BURIAL": "the act of burying [n -S]\n",
  "BURIALS": "BURIAL, the act of burying [n]\n",
  "BURIED": "BURY, to put in the ground and cover with earth [v]\n",
  "BURIER": "one who buries [n -S]\n",
  "BURIERS": "BURIER, one who buries [n]\n",
  "BURIES": "BURY, to put in the ground and cover with earth [v]\n",
  "BURIN": "an engraver's tool, a chisel of tempered steel [n -S]\n",
  "BURINIST": "one who works with the burin, an engraver's tool [n -S]\n",
  "BURINISTS": "BURINIST, one who works with the burin, an engraver's tool [n]\n",
  "BURINS": "BURIN, an engraver's tool, a chisel of tempered steel [n]\n",
  "BURITI": "(Tupi) a kind of South American palm-tree [n -S]\n",
  "BURITIS": "BURITI, (Tupi) a kind of South American palm-tree [n]\n",
  "BURK": "(colloquial) a fool, also BERK [n -S]\n",
  "BURKA": "(Urdu) a coverall worn by Muslim women, also BOORKA, BOURKHA, BURQA [n -S]\n",
  "BURKAS": "BURKA, (Urdu) a coverall worn by Muslim women, also BOORKA, BOURKHA, BURQA [n]\n",
  "BURKE": "to murder by suffocation [v BURKED, BURKING, BURKES]\n",
  "BURKED": "BURKE, to murder by suffocation [v]\n",
  "BURKER": "one that burkes, murders by suffocation, also BURKITE [n -S]\n",
  "BURKERS": "BURKER, one that burkes, murders by suffocation, also BURKITE [n]\n",
  "BURKES": "BURKE, to murder by suffocation [v]\n",
  "BURKHA": "(Urdu) an Arab woman's head-covering, also BOORKA, BOURKHA, BURKA, BURQA [n -S]\n",
  "BURKHAS": "BURKHA, (Urdu) an Arab woman's head-covering, also BOORKA, BOURKHA, BURKA, BURQA [n]\n",
  "BURKING": "BURKE, to murder by suffocation [v]\n",
  "BURKINI": "a swimming costume which covers the whole body with the exception of the face, hands, and feet, suitable for wear by Muslim women, also BURQUINI [n -S]\n",
  "BURKINIS": "BURKINI, a swimming costume which covers the whole body with the exception of the face, hands, and feet, suitable for wear by Muslim women, also BURQUINI [n]\n",
  "BURKITE": "one that burkes, murders by suffocation, also BURKER [n -S]\n",
  "BURKITES": "BURKITE, one that burkes, murders by suffocation, also BURKER [n]\n",
  "BURKS": "BURK, (colloquial) a fool, also BERK [n]\n",
  "BURL": "to finish cloth by removing knots [v -ED, -ING, -S]\n",
  "BURLADERO": "(Spanish) the wooden barrier in a bullring used for protection [n -S]\n",
  "BURLADEROS": "BURLADERO, (Spanish) the wooden barrier in a bullring used for protection [n]\n",
  "BURLAP": "a coarse canvas material [n -S]\n",
  "BURLAPS": "BURLAP, a coarse canvas material [n]\n",
  "BURLED": "BURL, to finish cloth by removing knots [v]\n",
  "BURLER": "one who burls or dresses cloth [n -S]\n",
  "BURLERS": "BURLER, one who burls or dresses cloth [n]\n",
  "BURLESK": "a type of stage show [n -S]\n",
  "BURLESKS": "BURLESK, a type of stage show [n]\n",
  "BURLESQUE": "(French) a ludicrous imitation, also BURLESK, BURLEYCUE [n -S] / resembling a burlesque [adj BURLESQUELY] / to make a burlesque of [v BURLESQUED, BURLESQUING, BURLESQUES]\n",
  "BURLESQUED": "BURLESQUE, to make a burlesque of [v]\n",
  "BURLESQUELY": "BURLESQUE, resembling a burlesque [adv]\n",
  "BURLESQUER": "one who burlesques [n -S]\n",
  "BURLESQUERS": "BURLESQUER, one who burlesques [n]\n",
  "BURLESQUES": "BURLESQUE, (French) a ludicrous imitation, also BURLESK, BURLEYCUE [n]\n",
  "BURLESQUING": "BURLESQUE, to make a burlesque of [v]\n",
  "BURLETTA": "(Italian) a comic operetta; a music farce [n -S]\n",
  "BURLETTAS": "BURLETTA, (Italian) a comic operetta; a music farce [n]\n",
  "BURLEY": "(Australian) to scatter fish bait on water, also BERLEY [v -ED, -ING, -S]\n",
  "BURLEYCUE": "a ludicrous imitation, also BURLESK, BURLESQUE [n -S]\n",
  "BURLEYCUES": "BURLEYCUE, a ludicrous imitation, also BURLESK, BURLESQUE [n]\n",
  "BURLEYED": "BURLEY, (Australian) to scatter fish bait on water, also BERLEY [v]\n",
  "BURLEYING": "BURLEY, (Australian) to scatter fish bait on water, also BERLEY [v]\n",
  "BURLEYS": "BURLEY, (Australian) to scatter fish bait on water, also BERLEY [v]\n",
  "BURLIER": "BURLY, heavy and muscular [adj]\n",
  "BURLIEST": "BURLY, heavy and muscular [adj]\n",
  "BURLIKE": "like a bur [adj]\n",
  "BURLILY": "BURLY, heavy and muscular [adv]\n",
  "BURLINESS": "the state of being burly [n -ES]\n",
  "BURLINESSES": "BURLINESS, the state of being burly [n]\n",
  "BURLING": "BURL, to finish cloth by removing knots [v]\n",
  "BURLS": "BURL, to finish cloth by removing knots [v]\n",
  "BURLY": "heavy and muscular [adj BURLIER, BURLIEST, BURLILY]\n",
  "BURN": "to destroy by fire [v BURNT or BURNED or YBRENT, YBRENT, BURNING, BURNS]\n",
  "BURNABLE": "something that can be burnt [n -S]\n",
  "BURNABLES": "BURNABLE, something that can be burnt [n]\n",
  "BURNED": "BURN, to destroy by fire [v]\n",
  "BURNER": "one that burns [n -S]\n",
  "BURNERS": "BURNER, one that burns [n]\n",
  "BURNET": "a moth of the genus Zygaena, having red-spotted wings [n -S]\n",
  "BURNETS": "BURNET, a moth of the genus Zygaena, having red-spotted wings [n]\n",
  "BURNETTISE": "to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTIZE [v BURNETTISED, BURNETTISING, BURNETTISES]\n",
  "BURNETTISED": "BURNETTISE, to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTIZE [v]\n",
  "BURNETTISES": "BURNETTISE, to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTIZE [v]\n",
  "BURNETTISING": "BURNETTISE, to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTIZE [v]\n",
  "BURNETTIZE": "to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTISE [v BURNETTIZED, BURNETTIZING, BURNETTIZES]\n",
  "BURNETTIZED": "BURNETTIZE, to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTISE [v]\n",
  "BURNETTIZES": "BURNETTIZE, to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTISE [v]\n",
  "BURNETTIZING": "BURNETTIZE, to subject (wood, fabrics, etc.) to a process of saturation in a solution of chloride of zinc, to prevent decay, also BURNETTISE [v]\n",
  "BURNIE": "(Scots) a small brook [n -S]\n",
  "BURNIES": "BURNIE, (Scots) a small brook [n]\n",
  "BURNING": "very hot, ardent [adj BURNINGLY] / the firing of ceramic materials [n -S]\n",
  "BURNINGLY": "BURNING, very hot, ardent [adv]\n",
  "BURNINGS": "BURNING, the firing of ceramic materials [n]\n",
  "BURNISH": "to polish [v -ED, -ING, -ES]\n",
  "BURNISHABLE": "that can be burnished [adj]\n",
  "BURNISHED": "BURNISH, to polish [v]\n",
  "BURNISHER": "one who burnishes [n -S]\n",
  "BURNISHERS": "BURNISHER, one who burnishes [n]\n",
  "BURNISHES": "BURNISH, to polish [v]\n",
  "BURNISHING": "the act of creating a burnish [n -S]\n",
  "BURNISHINGS": "BURNISHING, the act of creating a burnish [n]\n",
  "BURNISHMENT": "the act of burnishing [n -S]\n",
  "BURNISHMENTS": "BURNISHMENT, the act of burnishing [n]\n",
  "BURNOOSE": "(Arabic) a hooded cloak worn by Arabs, also BURNOUS, BURNOUSE [n -S]\n",
  "BURNOOSED": "wearing a burnoose, a cape with a hood worn by Arabs, also BURNOUSED [adj]\n",
  "BURNOOSES": "BURNOOSE, (Arabic) a hooded cloak worn by Arabs, also BURNOUS, BURNOUSE [n]\n",
  "BURNOUS": "(Arabic) a hooded cloak worn by Arabs, also BURNOOSE, BURNOUSE [n -ES]\n",
  "BURNOUSE": "(Arabic) a hooded cloak worn by Arabs, also BURNOOSE, BURNOUS [n -S]\n",
  "BURNOUSED": "wearing a burnous, a cape with a hood worn by Arabs, also BURNOOSED [adj]\n",
  "BURNOUSES": "BURNOUSE, (Arabic) a hooded cloak worn by Arabs, also BURNOOSE, BURNOUS [n]\n",
  "BURNOUT": "exhaustion due to stress [n -S]\n",
  "BURNOUTS": "BURNOUT, exhaustion due to stress [n]\n",
  "BURNS": "BURN, to destroy by fire [v]\n",
  "BURNSIDE": "the ground beside a brook [n -S]\n",
  "BURNSIDES": "BURNSIDE, the ground beside a brook [n]\n",
  "BURNT": "BURN, to destroy by fire [v]\n",
  "BUROO": "(Scots) unemployment benefit; the office at which people receive it, also BROO [n -S]\n",
  "BUROOS": "BUROO, (Scots) unemployment benefit; the office at which people receive it, also BROO [n]\n",
  "BURP": "to belch [v -ED, -ING, -S]\n",
  "BURPED": "BURP, to belch [v]\n",
  "BURPEE": "a type of physical exercise movement [n -S]\n",
  "BURPEES": "BURPEE, a type of physical exercise movement [n]\n",
  "BURPING": "BURP, to belch [v]\n",
  "BURPS": "BURP, to belch [v]\n",
  "BURQA": "(Urdu) a coverall worn by Muslim women, also BURKA, BOORKA, BOURKHA [n -S]\n",
  "BURQAS": "BURQA, (Urdu) a coverall worn by Muslim women, also BURKA, BOORKA, BOURKHA [n]\n",
  "BURQUINI": "a swimming costume which covers the whole body with the exception of the face, hands, and feet, suitable for wear by Muslim women, also BURKINI [n -S]\n",
  "BURQUINIS": "BURQUINI, a swimming costume which covers the whole body with the exception of the face, hands, and feet, suitable for wear by Muslim women, also BURKINI [n]\n",
  "BURR": "to remove the rough edge from, also BUR [v -ED, -ING, -S]\n",
  "BURRAMUNDI": "(Native Australian) any of several Australian river-fish, also BARRAMUNDA, BARRAMUNDI [n -S]\n",
  "BURRAMUNDIS": "BURRAMUNDI, (Native Australian) any of several Australian river-fish, also BARRAMUNDA, BARRAMUNDI [n]\n",
  "BURRAMYS": "a rare pigmy possum from Australia [n -ES]\n",
  "BURRAMYSES": "BURRAMYS, a rare pigmy possum from Australia [n]\n",
  "BURRATA": "(Italian) an Italian cheese made from mozzarella and cream [n -S]\n",
  "BURRATAS": "BURRATA, (Italian) an Italian cheese made from mozzarella and cream [n]\n",
  "BURRAWANG": "(Native Australian) any of various palmlike plants having edible nuts [n -S]\n",
  "BURRAWANGS": "BURRAWANG, (Native Australian) any of various palmlike plants having edible nuts [n]\n",
  "BURRED": "BURR, to remove the rough edge from, also BUR [v]\n",
  "BURREL": "(Hindi) a Himalayan blue sheep, also BHARAL, BURHEL, BURRELL, BURRHEL [n -S]\n",
  "BURRELL": "(Hindi) a Himalayan blue sheep, also BHARAL, BURHEL, BURREL, BURRHEL [n -S]\n",
  "BURRELLS": "BURRELL, (Hindi) a Himalayan blue sheep, also BHARAL, BURHEL, BURREL, BURRHEL [n]\n",
  "BURRELS": "BURREL, (Hindi) a Himalayan blue sheep, also BHARAL, BURHEL, BURRELL, BURRHEL [n]\n",
  "BURRER": "one that burrs [n -S]\n",
  "BURRERS": "BURRER, one that burrs [n]\n",
  "BURRFISH": "a fish with erect spines [n -ES]\n",
  "BURRFISHES": "BURRFISH, a fish with erect spines [n]\n",
  "BURRHEL": "(Hindi) a Himalayan blue sheep, also BHARAL, BURHEL, BURREL, BURRELL [n -S]\n",
  "BURRHELS": "BURRHEL, (Hindi) a Himalayan blue sheep, also BHARAL, BURHEL, BURREL, BURRELL [n]\n",
  "BURRIER": "BURRY, abounding in burs, or containing burs, as, burry wool [adj]\n",
  "BURRIEST": "BURRY, abounding in burs, or containing burs, as, burry wool [adj]\n",
  "BURRING": "BURR, to remove the rough edge from, also BUR [v]\n",
  "BURRITO": "(Spanish) a Mexican dish consisting of a flour tortilla, filled with meat, beans, chilli etc. [n -S]\n",
  "BURRITOS": "BURRITO, (Spanish) a Mexican dish consisting of a flour tortilla, filled with meat, beans, chilli etc. [n]\n",
  "BURRO": "(Spanish) a small donkey [n -S]\n",
  "BURROS": "BURRO, (Spanish) a small donkey [n]\n",
  "BURROW": "to dig a hole or tunnel in the ground [v -ED, -ING, -S]\n",
  "BURROWED": "BURROW, to dig a hole or tunnel in the ground [v]\n",
  "BURROWER": "one that burrows [n -S]\n",
  "BURROWERS": "BURROWER, one that burrows [n]\n",
  "BURROWING": "BURROW, to dig a hole or tunnel in the ground [v]\n",
  "BURROWS": "BURROW, to dig a hole or tunnel in the ground [v]\n",
  "BURROWSTOWN": "(Scots) a town that is a burgh [n -S]\n",
  "BURROWSTOWNS": "BURROWSTOWN, (Scots) a town that is a burgh [n]\n",
  "BURRS": "BURR, to remove the rough edge from, also BUR [v]\n",
  "BURRSTONE": "a cellular, flinty rock, used for millstones, also BUHR, BUHRSTONE, BURSTONE [n -S]\n",
  "BURRSTONES": "BURRSTONE, a cellular, flinty rock, used for millstones, also BUHR, BUHRSTONE, BURSTONE [n]\n",
  "BURRY": "abounding in burs, or containing burs, as, burry wool [adj BURRIER, BURRIEST]\n",
  "BURS": "BUR, to remove a rough edge from, also BURR [v]\n",
  "BURSA": "(Latin) a pouch or sac, esp. one containing viscid lubricating fluid at points of friction [n BURSAE or BURSAS]\n",
  "BURSAE": "BURSA, (Latin) a pouch or sac, esp. one containing viscid lubricating fluid at points of friction [n]\n",
  "BURSAL": "relating to a bursa, a pouch or sac [adj]\n",
  "BURSAR": "a person who keeps the purse, a treasurer [n -S]\n",
  "BURSARIAL": "relating to a bursar [adj]\n",
  "BURSARIES": "BURSARY, a college treasury [n]\n",
  "BURSARS": "BURSAR, a person who keeps the purse, a treasurer [n]\n",
  "BURSARSHIP": "the office of a bursar [n -S]\n",
  "BURSARSHIPS": "BURSARSHIP, the office of a bursar [n]\n",
  "BURSARY": "a college treasury [n BURSARIES]\n",
  "BURSAS": "BURSA, (Latin) a pouch or sac, esp. one containing viscid lubricating fluid at points of friction [n]\n",
  "BURSATE": "pertaining to a bursa, any sac or saclike cavity [adj]\n",
  "BURSE": "a square cloth case to carry the corporal during Communion service [n -S]\n",
  "BURSEED": "a coarse weed [n -S]\n",
  "BURSEEDS": "BURSEED, a coarse weed [n]\n",
  "BURSERA": "designating a tropical American genus of trees yielding elemi and timber [adj]\n",
  "BURSERACEOUS": "belonging to a genus of tropical plants related to the rue family [adj]\n",
  "BURSES": "BURSE, a square cloth case to carry the corporal during Communion service [n]\n",
  "BURSICON": "a hormone produced by the insect brain that regulates processes associated with ecdysis [n -S]\n",
  "BURSICONS": "BURSICON, a hormone produced by the insect brain that regulates processes associated with ecdysis [n]\n",
  "BURSICULATE": "shaped like small pouch [adj]\n",
  "BURSIFORM": "shaped like a pouch or purse [adj]\n",
  "BURSITIS": "inflammation of a bursa, one of the synovial sacs [n -ES]\n",
  "BURSITISES": "BURSITIS, inflammation of a bursa, one of the synovial sacs [n]\n",
  "BURST": "to break open violently, also BRAST, BRUST [v BURST or BURSTED, BURSTEN, BURSTING, BURSTS]\n",
  "BURSTED": "BURST, to break open violently, also BRAST, BRUST [v]\n",
  "BURSTEN": "BURST, to break open violently, also BRAST, BRUST [v]\n",
  "BURSTER": "a machine for separating continuous stationery into its constituent sheets [n -S]\n",
  "BURSTERS": "BURSTER, a machine for separating continuous stationery into its constituent sheets [n]\n",
  "BURSTIER": "BURSTY, occurring in short sudden episodes or bursts [adj]\n",
  "BURSTIEST": "BURSTY, occurring in short sudden episodes or bursts [adj]\n",
  "BURSTING": "BURST, to break open violently, also BRAST, BRUST [v]\n",
  "BURSTONE": "a cellular, flinty rock, used for millstones, also BUHR, BUHRSTONE, BURRSTONE [n -S]\n",
  "BURSTONES": "BURSTONE, a cellular, flinty rock, used for millstones, also BUHR, BUHRSTONE, BURRSTONE [n]\n",
  "BURSTS": "BURST, to break open violently, also BRAST, BRUST [v]\n",
  "BURSTY": "occurring in short sudden episodes or bursts [adj BURSTIER, BURSTIEST]\n",
  "BURTHEN": "to burden [v -ED, -ING, -S]\n",
  "BURTHENED": "BURTHEN, to burden [v]\n",
  "BURTHENING": "BURTHEN, to burden [v]\n",
  "BURTHENS": "BURTHEN, to burden [v]\n",
  "BURTHENSOME": "heavy, oppressive, also BURDENOUS, BURDENSOME [adj]\n",
  "BURTON": "a light handy two-block tackle [n -S]\n",
  "BURTONS": "BURTON, a light handy two-block tackle [n]\n",
  "BURWEED": "any of various burry plants such as a burdock [n -S]\n",
  "BURWEEDS": "BURWEED, any of various burry plants such as a burdock [n]\n",
  "BURY": "to put in the ground and cover with earth [v BURIED, BURYING, BURIES]\n",
  "BURYING": "BURY, to put in the ground and cover with earth [v]\n",
  "BUS": "a road vehicle for transporting a considerable number of passengers [n -ES] / to travel or transport by bus [v BUSED or BUSSED, BUSING or BUSSING, BUSES or BUSSES]\n",
  "BUSBAR": "an electric conductor connecting various circuits [n -S]\n",
  "BUSBARS": "BUSBAR, an electric conductor connecting various circuits [n]\n",
  "BUSBIES": "BUSBY, a fur hat with a bag hanging on its right side, esp. as worn by hussars [n]\n",
  "BUSBOY": "an assistant waiter [n -S]\n",
  "BUSBOYS": "BUSBOY, an assistant waiter [n]\n",
  "BUSBY": "a fur hat with a bag hanging on its right side, esp. as worn by hussars [n BUSBIES]\n",
  "BUSED": "BUS, to travel or transport by bus [v]\n",
  "BUSERA": "a Ugandan alcoholic drink made from millet [n -S]\n",
  "BUSERAS": "BUSERA, a Ugandan alcoholic drink made from millet [n]\n",
  "BUSES": "BUS, to travel or transport by bus [v]\n",
  "BUSGIRL": "an assistant waitress [n -S]\n",
  "BUSGIRLS": "BUSGIRL, an assistant waitress [n]\n",
  "BUSH": "to cover with shrubs [v -ED, -ING, -ES]\n",
  "BUSHBABIES": "BUSHBABY, a small African tree-living primate with large eyes [n]\n",
  "BUSHBABY": "a small African tree-living primate with large eyes [n BUSHBABIES]\n",
  "BUSHBASHING": "the process of forcing a path through the bush [n -S]\n",
  "BUSHBASHINGS": "BUSHBASHING, the process of forcing a path through the bush [n]\n",
  "BUSHBUCK": "a small South African antelope, also BOSBOK, BOSCHBOK, BOSHBOK [n -S]\n",
  "BUSHBUCKS": "BUSHBUCK, a small South African antelope, also BOSBOK, BOSCHBOK, BOSHBOK [n]\n",
  "BUSHCRAFT": "practical knowledge of the bush and skill in its ways [n -S]\n",
  "BUSHCRAFTS": "BUSHCRAFT, practical knowledge of the bush and skill in its ways [n]\n",
  "BUSHED": "BUSH, to cover with shrubs [v]\n",
  "BUSHEL": "to mend or alter e.g. men's clothes [v BUSHELED or BUSHELLED, BUSHELING or BUSHELLING, BUSHELS]\n",
  "BUSHELED": "BUSHEL, to mend or alter e.g. men's clothes [v]\n",
  "BUSHELER": "one who bushels, mends or alters clothes, also BUSHELLER, BUSHELMAN [n -S]\n",
  "BUSHELERS": "BUSHELER, one who bushels, mends or alters clothes, also BUSHELLER, BUSHELMAN [n]\n",
  "BUSHELFUL": "an amount equivalent to a bushel, a measure of capacity equal to 8 gallons [n -S]\n",
  "BUSHELFULS": "BUSHELFUL, an amount equivalent to a bushel, a measure of capacity equal to 8 gallons [n]\n",
  "BUSHELING": "BUSHEL, to mend or alter e.g. men's clothes [v]\n",
  "BUSHELLED": "BUSHEL, to mend or alter e.g. men's clothes [v]\n",
  "BUSHELLER": "one who bushels, mends and alters men's clothes, also BUSHELER, BUSHELMAN [n -S]\n",
  "BUSHELLERS": "BUSHELLER, one who bushels, mends and alters men's clothes, also BUSHELER, BUSHELMAN [n]\n",
  "BUSHELLING": "mending or altering eg men's clothes [n -S]\n",
  "BUSHELLINGS": "BUSHELLING, mending or altering eg men's clothes [n]\n",
  "BUSHELMAN": "one who bushels, mends and alters men's clothes, also BUSHELER, BUSHELLER [n BUSHELMEN]\n",
  "BUSHELMEN": "BUSHELMAN, one who bushels, mends and alters men's clothes, also BUSHELER, BUSHELLER [n]\n",
  "BUSHELS": "BUSHEL, to mend or alter e.g. men's clothes [v]\n",
  "BUSHELWOMAN": "one who alters men's clothes [n BUSHELWOMEN]\n",
  "BUSHELWOMEN": "BUSHELWOMAN, one who alters men's clothes [n]\n",
  "BUSHER": "a minor league baseball player [n -S]\n",
  "BUSHERS": "BUSHER, a minor league baseball player [n]\n",
  "BUSHES": "BUSH, to cover with shrubs [v]\n",
  "BUSHFIGHTING": "fighting in the bush [n -S]\n",
  "BUSHFIGHTINGS": "BUSHFIGHTING, fighting in the bush [n]\n",
  "BUSHFIRE": "a fire in a wooded area [n -S]\n",
  "BUSHFIRES": "BUSHFIRE, a fire in a wooded area [n]\n",
  "BUSHFLIES": "BUSHFLY, a fly which breeds in faeces and dung [n]\n",
  "BUSHFLY": "a fly which breeds in faeces and dung [n BUSHFLIES]\n",
  "BUSHGOAT": "a small antelope, also BUSHBUCK [n -S]\n",
  "BUSHGOATS": "BUSHGOAT, a small antelope, also BUSHBUCK [n]\n",
  "BUSHHAMMER": "a hammer with small pyramids projecting from its working face, used for dressing stone [n -S]\n",
  "BUSHHAMMERS": "BUSHHAMMER, a hammer with small pyramids projecting from its working face, used for dressing stone [n]\n",
  "BUSHIDO": "(Japanese) a Japanese code of chivalry [n -S]\n",
  "BUSHIDOS": "BUSHIDO, (Japanese) a Japanese code of chivalry [n]\n",
  "BUSHIE": "one who lives in the bush, also BUSHY [n -S]\n",
  "BUSHIER": "BUSHY, having many bushes [adj]\n",
  "BUSHIES": "BUSHIE, one who lives in the bush, also BUSHY [n]\n",
  "BUSHIEST": "BUSHY, having many bushes [adj]\n",
  "BUSHILY": "BUSHY, having many bushes [adv]\n",
  "BUSHINESS": "the condition of being bushy [n -ES]\n",
  "BUSHINESSES": "BUSHINESS, the condition of being bushy [n]\n",
  "BUSHING": "a bush, an insulator which allows a live wire to pass through a wall [n -S]\n",
  "BUSHINGS": "BUSHING, a bush, an insulator which allows a live wire to pass through a wall [n]\n",
  "BUSHLAND": "unsettled forest land [n -S]\n",
  "BUSHLANDS": "BUSHLAND, unsettled forest land [n]\n",
  "BUSHLESS": "having no bushes [adj]\n",
  "BUSHLIKE": "resembling a bush [adj]\n",
  "BUSHLOT": "a woodlot [n -S]\n",
  "BUSHLOTS": "BUSHLOT, a woodlot [n]\n",
  "BUSHMAN": "(Australian) a settler or traveller in the bush [n BUSHMEN]\n",
  "BUSHMANSHIP": "the craft of the bushman [n -S]\n",
  "BUSHMANSHIPS": "BUSHMANSHIP, the craft of the bushman [n]\n",
  "BUSHMASTER": "a venomous snake of South America [n -S]\n",
  "BUSHMASTERS": "BUSHMASTER, a venomous snake of South America [n]\n",
  "BUSHMEAT": "meat from animals native to African forests [n -S]\n",
  "BUSHMEATS": "BUSHMEAT, meat from animals native to African forests [n]\n",
  "BUSHMEN": "BUSHMAN, (Australian) a settler or traveller in the bush [n]\n",
  "BUSHPIG": "an African wild pig [n -S]\n",
  "BUSHPIGS": "BUSHPIG, an African wild pig [n]\n",
  "BUSHRANGER": "(Australian) an escaped criminal living in the bush [n -S]\n",
  "BUSHRANGERS": "BUSHRANGER, (Australian) an escaped criminal living in the bush [n]\n",
  "BUSHRANGING": "being a bushranger [n -S]\n",
  "BUSHRANGINGS": "BUSHRANGING, being a bushranger [n]\n",
  "BUSHTIT": "a small long-tailed tit of West America, which builds a large hanging nest [n -S]\n",
  "BUSHTITS": "BUSHTIT, a small long-tailed tit of West America, which builds a large hanging nest [n]\n",
  "BUSHVELD": "(South African) veld made up largely of woodland, also BOSCHVELD [n -S]\n",
  "BUSHVELDS": "BUSHVELD, (South African) veld made up largely of woodland, also BOSCHVELD [n]\n",
  "BUSHWA": "nonsense, also BUSHWAH [n -S]\n",
  "BUSHWAH": "nonsense, also BUSHWA [n -S]\n",
  "BUSHWAHS": "BUSHWAH, nonsense, also BUSHWA [n]\n",
  "BUSHWALK": "to walk or hike through the bush as a leisure activity [v -ED, -ING, -S]\n",
  "BUSHWALKED": "BUSHWALK, to walk or hike through the bush as a leisure activity [v]\n",
  "BUSHWALKER": "one who goes hiking in the bush [n -S]\n",
  "BUSHWALKERS": "BUSHWALKER, one who goes hiking in the bush [n]\n",
  "BUSHWALKING": "hiking through the bush as a leisure activity [n -S]\n",
  "BUSHWALKINGS": "BUSHWALKING, hiking through the bush as a leisure activity [n]\n",
  "BUSHWALKS": "BUSHWALK, to walk or hike through the bush as a leisure activity [v]\n",
  "BUSHWAS": "BUSHWA, nonsense, also BUSHWAH [n]\n",
  "BUSHWHACK": "to shoot from ambush [v -ED, -ING, -S]\n",
  "BUSHWHACKED": "BUSHWHACK, to shoot from ambush [v]\n",
  "BUSHWHACKER": "a guerrilla fighter; a bumpkin [n -S]\n",
  "BUSHWHACKERS": "BUSHWHACKER, a guerrilla fighter; a bumpkin [n]\n",
  "BUSHWHACKING": "the act of shooting someone from ambush [n -S]\n",
  "BUSHWHACKINGS": "BUSHWHACKING, the act of shooting someone from ambush [n]\n",
  "BUSHWHACKS": "BUSHWHACK, to shoot from ambush [v]\n",
  "BUSHWOMAN": "a woman living in the African or Australian bush [n BUSHWOMEN]\n",
  "BUSHWOMEN": "BUSHWOMAN, a woman living in the African or Australian bush [n]\n",
  "BUSHY": "having many bushes [adj BUSHIER, BUSHIEST, BUSHILY] / one who lives in the bush, also BUSHIE [n BUSHIES]\n",
  "BUSIED": "BUSY, to occupy oneself [v]\n",
  "BUSIER": "BUSY, occupied [adj]\n",
  "BUSIES": "BUSY, to occupy oneself [v]\n",
  "BUSIEST": "BUSY, occupied [adj]\n",
  "BUSILY": "BUSY, occupied [adv]\n",
  "BUSINESS": "an occupation, profession or trade [n -ES]\n",
  "BUSINESSES": "BUSINESS, an occupation, profession or trade [n]\n",
  "BUSINESSIER": "BUSINESSY, relating to business [adj]\n",
  "BUSINESSIEST": "BUSINESSY, relating to business [adj]\n",
  "BUSINESSLIKE": "exhibiting qualities believed to be advantageous in business [adj]\n",
  "BUSINESSMAN": "a man who transacts business [n BUSINESSMEN]\n",
  "BUSINESSMEN": "BUSINESSMAN, a man who transacts business [n]\n",
  "BUSINESSPEOPLE": "persons active in business [n]\n",
  "BUSINESSPERSON": "a businessman or businesswoman [n -S]\n",
  "BUSINESSPERSONS": "BUSINESSPERSON, a businessman or businesswoman [n]\n",
  "BUSINESSWOMAN": "a woman who transacts business [n BUSINESSWOMEN]\n",
  "BUSINESSWOMEN": "BUSINESSWOMAN, a woman who transacts business [n]\n",
  "BUSINESSY": "relating to business [adj BUSINESSIER, BUSINESSIEST]\n",
  "BUSING": "the act of transporting by bus, also BUSSING [n -S]\n",
  "BUSINGS": "BUSING, the act of transporting by bus, also BUSSING [n]\n",
  "BUSK": "to perform in the street for donations [v -ED, -ING, -S]\n",
  "BUSKED": "BUSK, to perform in the street for donations [v]\n",
  "BUSKER": "a street entertainer [n -S]\n",
  "BUSKERS": "BUSKER, a street entertainer [n]\n",
  "BUSKET": "(Spenser) a small bush, also BOSK, BOSKET, BOSQUE, BOSQUET [n -S]\n",
  "BUSKETS": "BUSKET, (Spenser) a small bush, also BOSK, BOSKET, BOSQUE, BOSQUET [n]\n",
  "BUSKIN": "a thick-soled boot worn by actors in ancient Greek tragedy, aka cothurnus [n -S]\n",
  "BUSKINED": "having a buskin [adj]\n",
  "BUSKING": "the art of busking [n -S]\n",
  "BUSKINGS": "BUSKING, the art of busking [n]\n",
  "BUSKINS": "BUSKIN, a thick-soled boot worn by actors in ancient Greek tragedy, aka cothurnus [n]\n",
  "BUSKS": "BUSK, to perform in the street for donations [v]\n",
  "BUSKY": "(Shakespeare) bushy [adj]\n",
  "BUSLOAD": "a load that fills a bus [n -S]\n",
  "BUSLOADS": "BUSLOAD, a load that fills a bus [n]\n",
  "BUSMAN": "a bus operator [n BUSMEN]\n",
  "BUSMEN": "BUSMAN, a bus operator [n]\n",
  "BUSS": "to kiss [v -ED, -ING, -ES]\n",
  "BUSSED": "BUSS, to kiss [v]\n",
  "BUSSES": "BUSS, to kiss [v]\n",
  "BUSSING": "the act of transporting by bus, also BUSING [n -S]\n",
  "BUSSINGS": "BUSSING, the act of transporting by bus, also BUSING [n]\n",
  "BUSSU": "(Tupi) a tropical American palm with gigantic leaves that serve for cloth [n -S]\n",
  "BUSSUS": "BUSSU, (Tupi) a tropical American palm with gigantic leaves that serve for cloth [n]\n",
  "BUST": "to break, shatter [v -ED, -ING, -S]\n",
  "BUSTARD": "any bird of the genus Otis, resembling cranes [n -S]\n",
  "BUSTARDS": "BUSTARD, any bird of the genus Otis, resembling cranes [n]\n",
  "BUSTED": "BUST, to break, shatter [v]\n",
  "BUSTEE": "(Urdu) in India, a flimsy hut, a squatter colony, also BASTI, BUSTI [n -S]\n",
  "BUSTEES": "BUSTEE, (Urdu) in India, a flimsy hut, a squatter colony, also BASTI, BUSTI [n]\n",
  "BUSTER": "a horse-breaker [n -S]\n",
  "BUSTERS": "BUSTER, a horse-breaker [n]\n",
  "BUSTI": "(Urdu) in India, a flimsy hut, a squatter colony, also BASTI, BUSTEE [n -S]\n",
  "BUSTIC": "a species of tropical tree [n -S]\n",
  "BUSTICATE": "(colloquial) to break [v BUSTICATED, BUSTICATING, BUSTICATES]\n",
  "BUSTICATED": "BUSTICATE, (colloquial) to break [v]\n",
  "BUSTICATES": "BUSTICATE, (colloquial) to break [v]\n",
  "BUSTICATING": "BUSTICATE, (colloquial) to break [v]\n",
  "BUSTICS": "BUSTIC, a species of tropical tree [n]\n",
  "BUSTIER": "(French) a kind of strapless brassiere [n -S]\n",
  "BUSTIERS": "BUSTIER, (French) a kind of strapless brassiere [n]\n",
  "BUSTIEST": "BUSTY, full-bosomed [adj]\n",
  "BUSTINESS": "the state of being busty [n -ES]\n",
  "BUSTINESSES": "BUSTINESS, the state of being busty [n]\n",
  "BUSTING": "the act of busting [n -S]\n",
  "BUSTINGS": "BUSTING, the act of busting [n]\n",
  "BUSTIS": "BUSTI, (Urdu) in India, a flimsy hut, a squatter colony, also BASTI, BUSTEE [n]\n",
  "BUSTLE": "to move noisily [v BUSTLED, BUSTLING, BUSTLES]\n",
  "BUSTLED": "BUSTLE, to move noisily [v]\n",
  "BUSTLER": "one who bustles [n -S]\n",
  "BUSTLERS": "BUSTLER, one who bustles [n]\n",
  "BUSTLES": "BUSTLE, to move noisily [v]\n",
  "BUSTLINE": "the width around a woman's upper torso [n -S]\n",
  "BUSTLINES": "BUSTLINE, the width around a woman's upper torso [n]\n",
  "BUSTLING": "lively and busy [adj BUSTLINGLY]\n",
  "BUSTLINGLY": "BUSTLING, lively and busy [adv]\n",
  "BUSTS": "BUST, to break, shatter [v]\n",
  "BUSTY": "full-bosomed [adj BUSTIER, BUSTIEST]\n",
  "BUSULFAN": "a drug used to treat leukaemia [n -S]\n",
  "BUSULFANS": "BUSULFAN, a drug used to treat leukaemia [n]\n",
  "BUSUUTI": "a long garment with a square neckline worn by Ugandan women [n -S]\n",
  "BUSUUTIS": "BUSUUTI, a long garment with a square neckline worn by Ugandan women [n]\n",
  "BUSY": "to occupy oneself [v BUSIED, BUSYING, BUSIES] / occupied [adj BUSIER, BUSIEST, BUSILY]\n",
  "BUSYBODIED": "BUSYBODY, to act in a nosy way [v]\n",
  "BUSYBODIES": "BUSYBODY, to act in a nosy way [v]\n",
  "BUSYBODY": "a nosy person [n BUSYBODIES] / to act in a nosy way [v BUSYBODIED, BUSYBODYING, BUSYBODIES]\n",
  "BUSYBODYING": "acting like a busybody [n -S]\n",
  "BUSYBODYINGS": "BUSYBODYING, acting like a busybody [n]\n",
  "BUSYING": "BUSY, to occupy oneself [v]\n",
  "BUSYNESS": "the state of being busy [n -ES]\n",
  "BUSYNESSES": "BUSYNESS, the state of being busy [n]\n",
  "BUSYWORK": "active but valueless work [n -S]\n",
  "BUSYWORKS": "BUSYWORK, active but valueless work [n]\n",
  "BUT": "to put forward as an objection [v BUTTED, BUTTING, BUTS]\n",
  "BUTADIENE": "a hydrocarbon used in making synthetic rubber [n -S]\n",
  "BUTADIENES": "BUTADIENE, a hydrocarbon used in making synthetic rubber [n]\n",
  "BUTANE": "a hydrocarbon of an alkane series, widely used as a fuel [n -S]\n",
  "BUTANES": "BUTANE, a hydrocarbon of an alkane series, widely used as a fuel [n]\n",
  "BUTANOIC": "as in butanoic acid, another name for butyric acid [adj]\n",
  "BUTANOL": "a flammable alcohol [n -S]\n",
  "BUTANOLS": "BUTANOL, a flammable alcohol [n]\n",
  "BUTANONE": "a flammable ketone [n -S]\n",
  "BUTANONES": "BUTANONE, a flammable ketone [n]\n",
  "BUTCH": "a lesbian with mannish traits [n -ES] / tough [adj BUTCHER, BUTCHEST]\n",
  "BUTCHER": "to slaughter [v -ED, -ING, -S]\n",
  "BUTCHERBIRD": "the shrike [n -S]\n",
  "BUTCHERBIRDS": "BUTCHERBIRD, the shrike [n]\n",
  "BUTCHERED": "BUTCHER, to slaughter [v]\n",
  "BUTCHERER": "one who butchers [n -S]\n",
  "BUTCHERERS": "BUTCHERER, one who butchers [n]\n",
  "BUTCHERIES": "BUTCHERY, wanton or cruel killing [n]\n",
  "BUTCHERING": "slaughtering [n -S]\n",
  "BUTCHERINGS": "BUTCHERING, slaughtering [n]\n",
  "BUTCHERLIER": "BUTCHERLY, like a butcher, savage, bloody [adj]\n",
  "BUTCHERLIEST": "BUTCHERLY, like a butcher, savage, bloody [adj]\n",
  "BUTCHERLY": "like a butcher, savage, bloody [adj BUTCHERLIER, BUTCHERLIEST]\n",
  "BUTCHERS": "BUTCHER, to slaughter [v]\n",
  "BUTCHERY": "wanton or cruel killing [n BUTCHERIES]\n",
  "BUTCHES": "BUTCH, a lesbian with mannish traits [n]\n",
  "BUTCHEST": "BUTCH, tough [adj]\n",
  "BUTCHING": "killing cruelly [n -S]\n",
  "BUTCHINGS": "BUTCHING, killing cruelly [n]\n",
  "BUTCHNESS": "the state of being butch [n -ES]\n",
  "BUTCHNESSES": "BUTCHNESS, the state of being butch [n]\n",
  "BUTE": "a shortened form of Butazolidin [n -S]\n",
  "BUTENE": "any one of three metameric hydrocarbons of the ethylene series, also BUTYLENE [n -S]\n",
  "BUTENEDIOIC": "designating a type of acid [adj]\n",
  "BUTENES": "BUTENE, any one of three metameric hydrocarbons of the ethylene series, also BUTYLENE [n]\n",
  "BUTEO": "(Latin) a buzzard [n -S]\n",
  "BUTEONINE": "like a buzzard [adj] / a bird of the buzzard family [n -S]\n",
  "BUTEONINES": "BUTEONINE, a bird of the buzzard family [n]\n",
  "BUTEOS": "BUTEO, (Latin) a buzzard [n]\n",
  "BUTES": "BUTE, a shortened form of Butazolidin [n]\n",
  "BUTLE": "to serve as a butler [v BUTLED, BUTLING, BUTLES]\n",
  "BUTLED": "BUTLE, to serve as a butler [v]\n",
  "BUTLER": "a male servant in charge of liquors, plate, etc. [n -S] / to act as a butler [v -ED, -ING, -S]\n",
  "BUTLERAGE": "the department of a domestic butler [n -S]\n",
  "BUTLERAGES": "BUTLERAGE, the department of a domestic butler [n]\n",
  "BUTLERED": "BUTLER, to act as a butler [v]\n",
  "BUTLERIES": "BUTLERY, a storage room [n]\n",
  "BUTLERING": "BUTLER, to act as a butler [v]\n",
  "BUTLERS": "BUTLER, to act as a butler [v]\n",
  "BUTLERSHIP": "the office of a butler [n -S]\n",
  "BUTLERSHIPS": "BUTLERSHIP, the office of a butler [n]\n",
  "BUTLERY": "a storage room [n BUTLERIES]\n",
  "BUTLES": "BUTLE, to serve as a butler [v]\n",
  "BUTLING": "BUTLE, to serve as a butler [v]\n",
  "BUTMENT": "the base of an architectural arch [n -S]\n",
  "BUTMENTS": "BUTMENT, the base of an architectural arch [n]\n",
  "BUTOH": "(Japanese) a style of modern Japanese dance [n -S]\n",
  "BUTOHS": "BUTOH, (Japanese) a style of modern Japanese dance [n]\n",
  "BUTS": "BUT, to put forward as an objection [v]\n",
  "BUTSUDAN": "(Japanese) a small Buddhist household altar [n -S]\n",
  "BUTSUDANS": "BUTSUDAN, (Japanese) a small Buddhist household altar [n]\n",
  "BUTT": "to hit with the head [v -ED, -ING, -S]\n",
  "BUTTALS": "boundary lines [n]\n",
  "BUTTE": "(French) an isolated hill rising abruptly from the surrounding area, having steep sides and a flat top [n -S]\n",
  "BUTTED": "BUTT, to hit with the head [v]\n",
  "BUTTER": "to spread with a milk product [v -ED, -ING, -S]\n",
  "BUTTERBALL": "the buffel duck; also, a chubby person [n -S]\n",
  "BUTTERBALLS": "BUTTERBALL, the buffel duck; also, a chubby person [n]\n",
  "BUTTERBUR": "a plant of damp places with very broad leaves [n -S]\n",
  "BUTTERBURS": "BUTTERBUR, a plant of damp places with very broad leaves [n]\n",
  "BUTTERCREAM": "a kind of cream [n -S]\n",
  "BUTTERCREAMS": "BUTTERCREAM, a kind of cream [n]\n",
  "BUTTERCUP": "a crowfoot (genus Ranunculus), esp. of one of those species that have golden-yellow cup-shaped flowers [n -S]\n",
  "BUTTERCUPS": "BUTTERCUP, a crowfoot (genus Ranunculus), esp. of one of those species that have golden-yellow cup-shaped flowers [n]\n",
  "BUTTERDOCK": "a wild plant, butterbur [n -S]\n",
  "BUTTERDOCKS": "BUTTERDOCK, a wild plant, butterbur [n]\n",
  "BUTTERED": "BUTTER, to spread with a milk product [v]\n",
  "BUTTERFAT": "the fat contained in butter [n -S]\n",
  "BUTTERFATS": "BUTTERFAT, the fat contained in butter [n]\n",
  "BUTTERFINGERED": "apt to let things fall or slip through the fingers [adj]\n",
  "BUTTERFINGERS": "one who is apt to let things fall or slip through the fingers, a careless person [n]\n",
  "BUTTERFISH": "a name given to several different fishes, in allusion to their slippery coating of mucus [n -ES]\n",
  "BUTTERFISHES": "BUTTERFISH, a name given to several different fishes, in allusion to their slippery coating of mucus [n]\n",
  "BUTTERFLIED": "BUTTERFLY, to split almost entirely and spread apart e.g. a steak [v]\n",
  "BUTTERFLIES": "BUTTERFLY, to split almost entirely and spread apart e.g. a steak [v]\n",
  "BUTTERFLY": "a general name for any of the daylight Lepidoptera [n BUTTERFLIES] / to split almost entirely and spread apart e.g. a steak [v BUTTERFLIED, BUTTERFLYING, BUTTERFLIES]\n",
  "BUTTERFLYER": "a swimmer who does the butterfly stroke [n -S]\n",
  "BUTTERFLYERS": "BUTTERFLYER, a swimmer who does the butterfly stroke [n]\n",
  "BUTTERFLYFISH": "any tropical marine percoid fish of the genera Chaetodon, Chelmon, etc., that has a deep flattened brightly coloured or strikingly marked body [n -ES]\n",
  "BUTTERFLYFISHES": "BUTTERFLYFISH, any tropical marine percoid fish of the genera Chaetodon, Chelmon, etc., that has a deep flattened brightly coloured or strikingly marked body [n]\n",
  "BUTTERFLYING": "BUTTERFLY, to split almost entirely and spread apart e.g. a steak [v]\n",
  "BUTTERIER": "BUTTERY, containing butter [adj]\n",
  "BUTTERIES": "BUTTERY, a wine cellar [n]\n",
  "BUTTERIEST": "BUTTERY, containing butter [adj]\n",
  "BUTTERINE": "a substance prepared from animal fat with some other ingredients intermixed, as an imitation of butter [n -S]\n",
  "BUTTERINES": "BUTTERINE, a substance prepared from animal fat with some other ingredients intermixed, as an imitation of butter [n]\n",
  "BUTTERINESS": "the state of being buttery [n -ES]\n",
  "BUTTERINESSES": "BUTTERINESS, the state of being buttery [n]\n",
  "BUTTERING": "BUTTER, to spread with a milk product [v]\n",
  "BUTTERLESS": "without butter [adj]\n",
  "BUTTERMILK": "the milk that remains after the butter is separated from the cream [n -S]\n",
  "BUTTERMILKS": "BUTTERMILK, the milk that remains after the butter is separated from the cream [n]\n",
  "BUTTERNUT": "the oily nut of the North American white walnut; the tree itself [n -S]\n",
  "BUTTERNUTS": "BUTTERNUT, the oily nut of the North American white walnut; the tree itself [n]\n",
  "BUTTERS": "BUTTER, to spread with a milk product [v]\n",
  "BUTTERSCOTCH": "a candy made from brown sugar, butter, corn syrup, and water [n -ES]\n",
  "BUTTERSCOTCHES": "BUTTERSCOTCH, a candy made from brown sugar, butter, corn syrup, and water [n]\n",
  "BUTTERWEED": "an annual composite plant of the Mississippi valley [n -S]\n",
  "BUTTERWEEDS": "BUTTERWEED, an annual composite plant of the Mississippi valley [n]\n",
  "BUTTERWORT": "a genus of low insectivorous herbs [n -S]\n",
  "BUTTERWORTS": "BUTTERWORT, a genus of low insectivorous herbs [n]\n",
  "BUTTERY": "a wine cellar [n BUTTERIES] / containing butter [adj BUTTERIER, BUTTERIEST]\n",
  "BUTTES": "BUTTE, (French) an isolated hill rising abruptly from the surrounding area, having steep sides and a flat top [n]\n",
  "BUTTHEAD": "a stupid person [n -S]\n",
  "BUTTHEADS": "BUTTHEAD, a stupid person [n]\n",
  "BUTTIES": "BUTTY, a fellow workman, esp. in a coalmine [n]\n",
  "BUTTING": "BUTT, to hit with the head [v]\n",
  "BUTTINSKI": "a person given to butting in, a troublesome meddler, also BUTTINSKY [n BUTTINSKIES or BUTTINSKIS]\n",
  "BUTTINSKIES": "BUTTINSKY, a person given to butting in, a troublesome meddler, also BUTTINSKI [n]\n",
  "BUTTINSKIS": "BUTTINSKI, a person given to butting in, a troublesome meddler, also BUTTINSKY [n]\n",
  "BUTTINSKY": "a person given to butting in, a troublesome meddler, also BUTTINSKI [n BUTTINSKIES]\n",
  "BUTTLE": "to act as a butler [v BUTTLED, BUTTLING, BUTTLES]\n",
  "BUTTLED": "BUTTLE, to act as a butler [v]\n",
  "BUTTLES": "BUTTLE, to act as a butler [v]\n",
  "BUTTLING": "BUTTLE, to act as a butler [v]\n",
  "BUTTOCK": "in wrestling, to throw by the buttocks [v -ED, -ING, -S]\n",
  "BUTTOCKED": "BUTTOCK, in wrestling, to throw by the buttocks [v]\n",
  "BUTTOCKING": "BUTTOCK, in wrestling, to throw by the buttocks [v]\n",
  "BUTTOCKS": "BUTTOCK, in wrestling, to throw by the buttocks [v]\n",
  "BUTTON": "to fasten with a small disk [v -ED, -ING, -S]\n",
  "BUTTONBALL": "the American plane tree, a large tree, producing rough balls, from which it is named, also BUTTONWOOD [n -S]\n",
  "BUTTONBALLS": "BUTTONBALL, the American plane tree, a large tree, producing rough balls, from which it is named, also BUTTONWOOD [n]\n",
  "BUTTONBUSH": "a North American shrub of the madder family with globular flower heads [n -ES]\n",
  "BUTTONBUSHES": "BUTTONBUSH, a North American shrub of the madder family with globular flower heads [n]\n",
  "BUTTONED": "BUTTON, to fasten with a small disk [v]\n",
  "BUTTONER": "one who buttons [n -S]\n",
  "BUTTONERS": "BUTTONER, one who buttons [n]\n",
  "BUTTONHELD": "BUTTONHOLD, to detain in talk, also BUTTONHOLE [v]\n",
  "BUTTONHOLD": "to detain in talk, also BUTTONHOLE [v BUTTONHELD, BUTTONHOLDING, BUTTONHOLDS]\n",
  "BUTTONHOLDING": "BUTTONHOLD, to detain in talk, also BUTTONHOLE [v]\n",
  "BUTTONHOLDS": "BUTTONHOLD, to detain in talk, also BUTTONHOLE [v]\n",
  "BUTTONHOLE": "the slit through which a button is passed [n -S] / to detain in talk, also BUTTONHOLD [v BUTTONHOLED, BUTTONHOLING, BUTTONHOLES]\n",
  "BUTTONHOLED": "BUTTONHOLE, to detain in talk, also BUTTONHOLD [v]\n",
  "BUTTONHOLER": "a person or sewing-machine attachment that makes buttonholes [n -S]\n",
  "BUTTONHOLERS": "BUTTONHOLER, a person or sewing-machine attachment that makes buttonholes [n]\n",
  "BUTTONHOLES": "BUTTONHOLE, to detain in talk, also BUTTONHOLD [v]\n",
  "BUTTONHOLING": "BUTTONHOLE, to detain in talk, also BUTTONHOLD [v]\n",
  "BUTTONHOOK": "a hook for drawing small buttons through buttonholes [n -S] / to make a kind of offensive play in American football [v -ED, -ING, -S]\n",
  "BUTTONHOOKED": "BUTTONHOOK, to make a kind of offensive play in American football [v]\n",
  "BUTTONHOOKING": "BUTTONHOOK, to make a kind of offensive play in American football [v]\n",
  "BUTTONHOOKS": "BUTTONHOOK, a hook for drawing small buttons through buttonholes [n]\n",
  "BUTTONIER": "BUTTONY, ornamented with a large number of buttons [adj]\n",
  "BUTTONIEST": "BUTTONY, ornamented with a large number of buttons [adj]\n",
  "BUTTONING": "BUTTON, to fasten with a small disk [v]\n",
  "BUTTONLESS": "without buttons [adj]\n",
  "BUTTONMOULD": "the small core of plastic, wood, or metal that is the base for buttons covered with fabric, leather, etc. [n -S]\n",
  "BUTTONMOULDS": "BUTTONMOULD, the small core of plastic, wood, or metal that is the base for buttons covered with fabric, leather, etc. [n]\n",
  "BUTTONS": "BUTTON, to fasten with a small disk [v]\n",
  "BUTTONWOOD": "the American plane tree, a large tree, producing rough balls, from which it is named, also BUTTONBALL [n -S]\n",
  "BUTTONWOODS": "BUTTONWOOD, the American plane tree, a large tree, producing rough balls, from which it is named, also BUTTONBALL [n]\n",
  "BUTTONY": "ornamented with a large number of buttons [adj BUTTONIER, BUTTONIEST]\n",
  "BUTTRESS": "to prop up [v -ED, -ING, -ES]\n",
  "BUTTRESSED": "BUTTRESS, to prop up [v]\n",
  "BUTTRESSES": "BUTTRESS, to prop up [v]\n",
  "BUTTRESSING": "BUTTRESS, to prop up [v]\n",
  "BUTTS": "BUTT, to hit with the head [v]\n",
  "BUTTSTOCK": "the stock of a firearm in the rear of the breech mechanism [n -S]\n",
  "BUTTSTOCKS": "BUTTSTOCK, the stock of a firearm in the rear of the breech mechanism [n]\n",
  "BUTTY": "a fellow workman, esp. in a coalmine [n BUTTIES]\n",
  "BUTTYMAN": "a comrade in a coalmine [n BUTTYMEN]\n",
  "BUTTYMEN": "BUTTYMAN, a comrade in a coalmine [n]\n",
  "BUTUT": "(Wolof) a monetary unit of Gambia [n -S]\n",
  "BUTUTS": "BUTUT, (Wolof) a monetary unit of Gambia [n]\n",
  "BUTYL": "a compound radical, regarded as butane, less one atom of hydrogen [n -S]\n",
  "BUTYLATE": "to add a butyl to [v BUTYLATED, BUTYLATING, BUTYLATES]\n",
  "BUTYLATED": "BUTYLATE, to add a butyl to [v]\n",
  "BUTYLATES": "BUTYLATE, to add a butyl to [v]\n",
  "BUTYLATING": "BUTYLATE, to add a butyl to [v]\n",
  "BUTYLATION": "combination with the butyl group [n -S]\n",
  "BUTYLATIONS": "BUTYLATION, combination with the butyl group [n]\n",
  "BUTYLENE": "a gaseous hydrocarbon [n -S]\n",
  "BUTYLENES": "BUTYLENE, a gaseous hydrocarbon [n]\n",
  "BUTYLS": "BUTYL, a compound radical, regarded as butane, less one atom of hydrogen [n]\n",
  "BUTYRACEOUS": "resembling, producing or having the qualities of butter, also BUTYROUS [adj]\n",
  "BUTYRAL": "a kind of resin [n -S]\n",
  "BUTYRALDEHYDE": "either of two aldehydes used esp. in making synthetic resins [n -S]\n",
  "BUTYRALDEHYDES": "BUTYRALDEHYDE, either of two aldehydes used esp. in making synthetic resins [n]\n",
  "BUTYRALS": "BUTYRAL, a kind of resin [n]\n",
  "BUTYRATE": "a salt of butyric acid [n -S]\n",
  "BUTYRATES": "BUTYRATE, a salt of butyric acid [n]\n",
  "BUTYRIC": "as in butyric acid, an acid found in butter [adj]\n",
  "BUTYRIN": "a butyrate of glycerin; a fat contained in small quantity in milk, which helps to give to butter its peculiar flavor [n -S]\n",
  "BUTYRINS": "BUTYRIN, a butyrate of glycerin; a fat contained in small quantity in milk, which helps to give to butter its peculiar flavor [n]\n",
  "BUTYROPHENONE": "any of a class of antipsychotic drugs (as haloperidol) used esp. in the treatment of schizophrenia [n -S]\n",
  "BUTYROPHENONES": "BUTYROPHENONE, any of a class of antipsychotic drugs (as haloperidol) used esp. in the treatment of schizophrenia [n]\n",
  "BUTYROUS": "resembling butter [adj]\n",
  "BUTYRYL": "a radical of butyric acid [n -S]\n",
  "BUTYRYLS": "BUTYRYL, a radical of butyric acid [n]\n",
  "BUVETTE": "(obsolete) in France, a small refreshment bar at the roadside [n -S]\n",
  "BUVETTES": "BUVETTE, (obsolete) in France, a small refreshment bar at the roadside [n]\n",
  "BUXOM": "healthily plump [adj BUXOMER, BUXOMEST, BUXOMLY]\n",
  "BUXOMER": "BUXOM, healthily plump [adj]\n",
  "BUXOMEST": "BUXOM, healthily plump [adj]\n",
  "BUXOMLY": "BUXOM, healthily plump [adv]\n",
  "BUXOMNESS": "the state of being buxom [n -ES]\n",
  "BUXOMNESSES": "BUXOMNESS, the state of being buxom [n]\n",
  "BUY": "to purchase [v BOUGHT, BOUGHTEN, BUYING, BUYS]\n",
  "BUYABLE": "something available for purchase [n -S]\n",
  "BUYABLES": "BUYABLE, something available for purchase [n]\n",
  "BUYBACK": "the optional or obligatory buying back by the seller of all or part of what was sold [n -S]\n",
  "BUYBACKS": "BUYBACK, the optional or obligatory buying back by the seller of all or part of what was sold [n]\n",
  "BUYER": "one that buys [n -S]\n",
  "BUYERS": "BUYER, one that buys [n]\n",
  "BUYING": "the act of purchasing [n -S]\n",
  "BUYINGS": "BUYING, the act of purchasing [n]\n",
  "BUYOFF": "the act of buying off, paying (a person or group) to drop a charge, end opposition, relinquish a claim, etc. [n -S]\n",
  "BUYOFFS": "BUYOFF, the act of buying off, paying (a person or group) to drop a charge, end opposition, relinquish a claim, etc. [n]\n",
  "BUYOUT": "the buying out or taking over of another company [n -S]\n",
  "BUYOUTS": "BUYOUT, the buying out or taking over of another company [n]\n",
  "BUYS": "BUY, to purchase [v]\n",
  "BUZKASHI": "(Persian) a game played in Afghanistan by teams of horsemen contesting for possession of a goat's carcass [n -S]\n",
  "BUZKASHIS": "BUZKASHI, (Persian) a game played in Afghanistan by teams of horsemen contesting for possession of a goat's carcass [n]\n",
  "BUZUKI": "(Modern Greek) a Greek long necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUSOUKI, BOUZOUKI [n BUZUKIA or BUZUKIS]\n",
  "BUZUKIA": "BUZUKI, (Modern Greek) a Greek long necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUSOUKI, BOUZOUKI [n]\n",
  "BUZUKIS": "BUZUKI, (Modern Greek) a Greek long necked lute with 3 or 4 double courses of metal strings, also BAZOUKI, BOUSOUKI, BOUZOUKI [n]\n",
  "BUZZ": "to make a vibrating sound [v -ED, -ING, -ES]\n",
  "BUZZARD": "a large bird of prey [n -S]\n",
  "BUZZARDS": "BUZZARD, a large bird of prey [n]\n",
  "BUZZBAIT": "an artificial bait with small blades that stir the water [n -S]\n",
  "BUZZBAITS": "BUZZBAIT, an artificial bait with small blades that stir the water [n]\n",
  "BUZZCUT": "a very short haircut [n -S]\n",
  "BUZZCUTS": "BUZZCUT, a very short haircut [n]\n",
  "BUZZED": "BUZZ, to make a vibrating sound [v]\n",
  "BUZZER": "an apparatus that makes a buzzing sound [n -S]\n",
  "BUZZERS": "BUZZER, an apparatus that makes a buzzing sound [n]\n",
  "BUZZES": "BUZZ, to make a vibrating sound [v]\n",
  "BUZZIER": "BUZZY, having a buzzing quality [adj]\n",
  "BUZZIEST": "BUZZY, having a buzzing quality [adj]\n",
  "BUZZING": "busy, vibrant [adj BUZZINGLY] / a buzzing sound [n -S]\n",
  "BUZZINGLY": "BUZZING, busy, vibrant [adv]\n",
  "BUZZINGS": "BUZZING, a buzzing sound [n]\n",
  "BUZZKILL": "someone or something that stops people from enjoying themselves, also BUZZKILLER [n -S]\n",
  "BUZZKILLER": "someone or something that stops people from enjoying themselves, also BUZZKILL [n -S]\n",
  "BUZZKILLERS": "BUZZKILLER, someone or something that stops people from enjoying themselves, also BUZZKILL [n]\n",
  "BUZZKILLS": "BUZZKILL, someone or something that stops people from enjoying themselves, also BUZZKILLER [n]\n",
  "BUZZSAW": "a power-operated circular saw [n -S]\n",
  "BUZZSAWS": "BUZZSAW, a power-operated circular saw [n]\n",
  "BUZZWIG": "a large thick wig [n -S]\n",
  "BUZZWIGS": "BUZZWIG, a large thick wig [n]\n",
  "BUZZWORD": "a word used to impress someone [n -S]\n",
  "BUZZWORDS": "BUZZWORD, a word used to impress someone [n]\n",
  "BUZZY": "having a buzzing quality [adj BUZZIER, BUZZIEST]\n",
  "BWANA": "(Swahili) a master, sir [n -S]\n",
  "BWANAS": "BWANA, (Swahili) a master, sir [n]\n",
  "BWAZI": "an African shrub, also BUAZE [n -S]\n",
  "BWAZIS": "BWAZI, an African shrub, also BUAZE [n]\n",
  "BY": "a pass to the next round (of a competition, etc.), also BYE [n -S]\n",
  "BYCATCH": "an immature fish, esp. one caught along with the main catch [n -ES]\n",
  "BYCATCHES": "BYCATCH, an immature fish, esp. one caught along with the main catch [n]\n",
  "BYCOKET": "an ornamental cap with peaks at both back and front, worn in the 15th century [n -S]\n",
  "BYCOKETS": "BYCOKET, an ornamental cap with peaks at both back and front, worn in the 15th century [n]\n",
  "BYDE": "(Scots) to bide [v BYDED, BYDING, BYDES]\n",
  "BYDED": "BYDE, (Scots) to bide [v]\n",
  "BYDES": "BYDE, (Scots) to bide [v]\n",
  "BYDING": "BYDE, (Scots) to bide [v]\n",
  "BYE": "a pass to the next round (of a competition, etc.), also BY [n -S]\n",
  "BYELAW": "the law of a local authority or private corporation, also BYLAW [n -S]\n",
  "BYELAWS": "BYELAW, the law of a local authority or private corporation, also BYLAW [n]\n",
  "BYES": "BYE, a pass to the next round (of a competition, etc.), also BY [n]\n",
  "BYGONE": "something belonging to a past time [n -S]\n",
  "BYGONES": "BYGONE, something belonging to a past time [n]\n",
  "BYKE": "(Scots) a nest of wasps or wild bees; a swarm, throng [n -S] / to swarm [v BYKED, BYKING, BYKES]\n",
  "BYKED": "BYKE, to swarm [v]\n",
  "BYKES": "BYKE, to swarm [v]\n",
  "BYKING": "BYKE, to swarm [v]\n",
  "BYLANDER": "(Dutch) a two-masted cargo vessel used in Holland, also BILANDER [n -S]\n",
  "BYLANDERS": "BYLANDER, (Dutch) a two-masted cargo vessel used in Holland, also BILANDER [n]\n",
  "BYLANE": "a side lane [n -S]\n",
  "BYLANES": "BYLANE, a side lane [n]\n",
  "BYLAW": "the law of a local authority or private corporation, also BYELAW [n -S]\n",
  "BYLAWS": "BYLAW, the law of a local authority or private corporation, also BYELAW [n]\n",
  "BYLINE": "to write giving the author's name [v BYLINED, BYLINING, BYLINES]\n",
  "BYLINED": "BYLINE, to write giving the author's name [v]\n",
  "BYLINER": "one that writes under a byline [n -S]\n",
  "BYLINERS": "BYLINER, one that writes under a byline [n]\n",
  "BYLINES": "BYLINE, to write giving the author's name [v]\n",
  "BYLINING": "BYLINE, to write giving the author's name [v]\n",
  "BYLIVE": "(Spenser) immediately, also BELIVE, BLIVE [adv]\n",
  "BYNAME": "a secondary name, a nickname [n -S]\n",
  "BYNAMES": "BYNAME, a secondary name, a nickname [n]\n",
  "BYNEMPT": "BENAME, to name, mention [v]\n",
  "BYPASS": "to avoid by going around [v -ED, -ING, -ES]\n",
  "BYPASSED": "BYPASS, to avoid by going around [v]\n",
  "BYPASSES": "BYPASS, to avoid by going around [v]\n",
  "BYPASSING": "BYPASS, to avoid by going around [v]\n",
  "BYPAST": "gone by [adj]\n",
  "BYPATH": "a secluded or indirect path [n -S]\n",
  "BYPATHS": "BYPATH, a secluded or indirect path [n]\n",
  "BYPLACE": "a secluded place [n -S]\n",
  "BYPLACES": "BYPLACE, a secluded place [n]\n",
  "BYPLAY": "action subordinate to the main action, as in a play [n -S]\n",
  "BYPLAYS": "BYPLAY, action subordinate to the main action, as in a play [n]\n",
  "BYPRODUCT": "a secondary product [n -S]\n",
  "BYPRODUCTS": "BYPRODUCT, a secondary product [n]\n",
  "BYRE": "a cow shed [n -S]\n",
  "BYREMAN": "a farm-servant who tends cows [n BYREMEN]\n",
  "BYREMEN": "BYREMAN, a farm-servant who tends cows [n]\n",
  "BYRES": "BYRE, a cow shed [n]\n",
  "BYREWOMAN": "a woman who tends cattle [n BYREWOMEN]\n",
  "BYREWOMEN": "BYREWOMAN, a woman who tends cattle [n]\n",
  "BYRL": "to carouse, also BIRL, BIRLE [v -ED, -ING, -S]\n",
  "BYRLADY": "(archaic) a mediaeval oath, by Our Lady, also BYRLAKIN [interj]\n",
  "BYRLAKIN": "(archaic) a mediaeval oath, by Our Lady, also BYRLADY [interj]\n",
  "BYRLAW": "(archaic) a local law dealing with local customs and civil disputes, also BOURLAW [n -S]\n",
  "BYRLAWS": "BYRLAW, (archaic) a local law dealing with local customs and civil disputes, also BOURLAW [n]\n",
  "BYRLED": "BYRL, to carouse, also BIRL, BIRLE [v]\n",
  "BYRLING": "BYRL, to carouse, also BIRL, BIRLE [v]\n",
  "BYRLS": "BYRL, to carouse, also BIRL, BIRLE [v]\n",
  "BYRNIE": "(historical) a coat of mail [n -S]\n",
  "BYRNIES": "BYRNIE, (historical) a coat of mail [n]\n",
  "BYROAD": "a side road [n -S]\n",
  "BYROADS": "BYROAD, a side road [n]\n",
  "BYROOM": "(Shakespeare) a private room [n -S]\n",
  "BYROOMS": "BYROOM, (Shakespeare) a private room [n]\n",
  "BYS": "BY, a pass to the next round (of a competition, etc.), also BYE [n]\n",
  "BYSSACEOUS": "composed of a mass of fine threads; delicately filamentous, also BYSSOID [adj]\n",
  "BYSSAL": "of or like byssus, a filamentous tuft by which molluscs attach themselves to rocks [adj]\n",
  "BYSSI": "BYSSUS, (Latin) a filamentous tuft by which molluscs attach themselves to rocks; a fine flax and fabric woven from it [n]\n",
  "BYSSINE": "made of byssus or fine linen [adj]\n",
  "BYSSINOSES": "BYSSINOSIS, cotton dust pneumoconiosis [n]\n",
  "BYSSINOSIS": "cotton dust pneumoconiosis [n BYSSINOSES]\n",
  "BYSSOID": "having delicate filaments [adj]\n",
  "BYSSUS": "(Latin) a filamentous tuft by which molluscs attach themselves to rocks; a fine flax and fabric woven from it [n BYSSI or BYSSUSES]\n",
  "BYSSUSES": "BYSSUS, (Latin) a filamentous tuft by which molluscs attach themselves to rocks; a fine flax and fabric woven from it [n]\n",
  "BYSTANDER": "someone who stands by or near one; an onlooker [n -S]\n",
  "BYSTANDERS": "BYSTANDER, someone who stands by or near one; an onlooker [n]\n",
  "BYSTREET": "a side street [n -S]\n",
  "BYSTREETS": "BYSTREET, a side street [n]\n",
  "BYTALK": "small talk [n -S]\n",
  "BYTALKS": "BYTALK, small talk [n]\n",
  "BYTE": "a set of usually eight binary digits (bits) considered as a unit [n -S]\n",
  "BYTES": "BYTE, a set of usually eight binary digits (bits) considered as a unit [n]\n",
  "BYTOWNITE": "a plagioclase intermediate between anorthite and labradorite [n -S]\n",
  "BYTOWNITES": "BYTOWNITE, a plagioclase intermediate between anorthite and labradorite [n]\n",
  "BYWAY": "a side road [n -S]\n",
  "BYWAYS": "BYWAY, a side road [n]\n",
  "BYWONER": "(South African) the subtenant of a farm; an agricultural labourer, also BIJWONER [n -S]\n",
  "BYWONERS": "BYWONER, (South African) the subtenant of a farm; an agricultural labourer, also BIJWONER [n]\n",
  "BYWORD": "a well known saying [n -S]\n",
  "BYWORDS": "BYWORD, a well known saying [n]\n",
  "BYWORK": "work done during leisure time [n -S]\n",
  "BYWORKS": "BYWORK, work done during leisure time [n]\n",
  "BYZANT": "a gold coin first struck at Byzantium or Constantinople; in heraldry, a charge like this, a gold roundel, also BEZANT, BEZZANT [n -S]\n",
  "BYZANTINE": "intricately involved and often devious [adj]\n",
  "BYZANTS": "BYZANT, a gold coin first struck at Byzantium or Constantinople; in heraldry, a charge like this, a gold roundel, also BEZANT, BEZZANT [n]\n",
  "CAA": "(Scots) to call [v -ED, -ING, -S]\n",
  "CAAED": "CAA, (Scots) to call [v]\n",
  "CAAING": "CAA, (Scots) to call [v]\n",
  "CAAS": "CAA, (Scots) to call [v]\n",
  "CAATINGA": "(Tupi) in Brazil, open, low forest on white sandy soil derived from granite [n -S]\n",
  "CAATINGAS": "CAATINGA, (Tupi) in Brazil, open, low forest on white sandy soil derived from granite [n]\n",
  "CAB": "to travel by taxicab [v CABBED, CABBING, CABS]\n",
  "CABA": "(French) a woman's work basket [n -S]\n",
  "CABAL": "to conspire [v CABALLED, CABALLING, CABALS]\n",
  "CABALA": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABBALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALA, QABALAH [n -S]\n",
  "CABALAS": "CABALA, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABBALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALA, QABALAH [n]\n",
  "CABALETTA": "(Italian) a simple operatic song or melody in rondo form [n CABALETTE or CABALETTAS]\n",
  "CABALETTAS": "CABALETTA, (Italian) a simple operatic song or melody in rondo form [n]\n",
  "CABALETTE": "CABALETTA, (Italian) a simple operatic song or melody in rondo form [n]\n",
  "CABALISM": "(Hebrew) a sect based on cabala, also KABALISM, KABBALISM, QABALISM, CABBALISM [n -S]\n",
  "CABALISMS": "CABALISM, (Hebrew) a sect based on cabala, also KABALISM, KABBALISM, QABALISM, CABBALISM [n]\n",
  "CABALIST": "(Hebrew) someone who finds hidden meanings in sacred texts, also KABALIST, KABBALIST, QABALIST [n -S]\n",
  "CABALISTIC": "relating to the cabala, also CABBALISTIC, CABBALISTICAL, KABALISTIC [adj]\n",
  "CABALISTICAL": "relating to the cabbala [adj]\n",
  "CABALISTS": "CABALIST, (Hebrew) someone who finds hidden meanings in sacred texts, also KABALIST, KABBALIST, QABALIST [n]\n",
  "CABALLED": "CABAL, to conspire [v]\n",
  "CABALLER": "one who cabals, intrigues [n -S]\n",
  "CABALLERO": "(Spanish) a Spanish gentleman; a horseman, also CAVALERO [n -S]\n",
  "CABALLEROS": "CABALLERO, (Spanish) a Spanish gentleman; a horseman, also CAVALERO [n]\n",
  "CABALLERS": "CABALLER, one who cabals, intrigues [n]\n",
  "CABALLINE": "pertaining to or suited to a horse [adj]\n",
  "CABALLING": "CABAL, to conspire [v]\n",
  "CABALS": "CABAL, to conspire [v]\n",
  "CABANA": "(Spanish) a small tentlike cabin [n -S]\n",
  "CABANAS": "CABANA, (Spanish) a small tentlike cabin [n]\n",
  "CABARET": "a music hall [n -S]\n",
  "CABARETS": "CABARET, a music hall [n]\n",
  "CABAS": "CABA, (French) a woman's work basket [n]\n",
  "CABBAGE": "to steal or purloin, originally of tailors who took small pieces of customer's cloth as a perquisite [v CABBAGED, CABBAGING, CABBAGES]\n",
  "CABBAGED": "CABBAGE, to steal or purloin, originally of tailors who took small pieces of customer's cloth as a perquisite [v]\n",
  "CABBAGES": "CABBAGE, to steal or purloin, originally of tailors who took small pieces of customer's cloth as a perquisite [v]\n",
  "CABBAGETOWN": "from Cabbagetown, a depressed area of Toronto, where the Anglo-Saxon population was thought to exist on cabbage [n -S]\n",
  "CABBAGETOWNS": "CABBAGETOWN, from Cabbagetown, a depressed area of Toronto, where the Anglo-Saxon population was thought to exist on cabbage [n]\n",
  "CABBAGEWORM": "the larva of the cabbage butterfly [n -S]\n",
  "CABBAGEWORMS": "CABBAGEWORM, the larva of the cabbage butterfly [n]\n",
  "CABBAGEY": "like a cabbage, also CABBAGY [adj CABBAGIER, CABBAGIEST]\n",
  "CABBAGIER": "CABBAGY, like a cabbage, also CABBAGEY [adj]\n",
  "CABBAGIEST": "CABBAGY, like a cabbage, also CABBAGEY [adj]\n",
  "CABBAGING": "CABBAGE, to steal or purloin, originally of tailors who took small pieces of customer's cloth as a perquisite [v]\n",
  "CABBAGY": "like a cabbage, also CABBAGEY [adj CABBAGIER, CABBAGIEST]\n",
  "CABBALA": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALA, QABALAH [n -S]\n",
  "CABBALAH": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, KABALA, KABBALA, KABBALAH, QABALA, QABALAH [n -S]\n",
  "CABBALAHS": "CABBALAH, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, KABALA, KABBALA, KABBALAH, QABALA, QABALAH [n]\n",
  "CABBALAS": "CABBALA, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALA, QABALAH [n]\n",
  "CABBALISM": "a sect based on cabbala, also KABALISM, KABBALISM, QABALISM, CABALISM [n -S]\n",
  "CABBALISMS": "CABBALISM, a sect based on cabbala, also KABALISM, KABBALISM, QABALISM, CABALISM [n]\n",
  "CABBALIST": "one who practices cabbalism, also CABALIST, KABALIST, KABBALIST, QABALIST [n -S]\n",
  "CABBALISTIC": "relating to the cabbala, also CABALISTIC, CABBALISTICAL, KABALISTIC [adj]\n",
  "CABBALISTICAL": "relating to the cabbala, also CABALISTIC, CABBALISTIC, KABALISTIC [adj]\n",
  "CABBALISTS": "CABBALIST, one who practices cabbalism, also CABALIST, KABALIST, KABBALIST, QABALIST [n]\n",
  "CABBED": "CAB, to travel by taxicab [v]\n",
  "CABBIE": "(colloquial) a cabdriver, also CABBY [n -S]\n",
  "CABBIES": "CABBY, (colloquial) a cabdriver, also CABBIE [n]\n",
  "CABBING": "CAB, to travel by taxicab [v]\n",
  "CABBY": "(colloquial) a cabdriver, also CABBIE [n CABBIES]\n",
  "CABDRIVER": "one who drives a cab [n -S]\n",
  "CABDRIVERS": "CABDRIVER, one who drives a cab [n]\n",
  "CABER": "(Scots) a heavy wooden heaving pole, also KABAR, KEBAR [n -S]\n",
  "CABERNET": "(French) a type of black grape used to produce a dry red wine [n -S]\n",
  "CABERNETS": "CABERNET, (French) a type of black grape used to produce a dry red wine [n]\n",
  "CABERS": "CABER, (Scots) a heavy wooden heaving pole, also KABAR, KEBAR [n]\n",
  "CABESTRO": "(Spanish) a lasso, also CABRESTA, CABRESTO [n -S]\n",
  "CABESTROS": "CABESTRO, (Spanish) a lasso, also CABRESTA, CABRESTO [n]\n",
  "CABEZON": "(Spanish) a Californian fish, allied to the sculpin, also CABEZONE [n -S]\n",
  "CABEZONE": "(Spanish) a Californian fish, allied to the sculpin, also CABEZON [n -S]\n",
  "CABEZONES": "CABEZONE, (Spanish) a Californian fish, allied to the sculpin, also CABEZON [n]\n",
  "CABEZONS": "CABEZON, (Spanish) a Californian fish, allied to the sculpin, also CABEZONE [n]\n",
  "CABILDO": "(Spanish) a town council [n -S]\n",
  "CABILDOS": "CABILDO, (Spanish) a town council [n]\n",
  "CABIN": "to live in a roughly built house [v -ED, -ING, -S]\n",
  "CABINED": "CABIN, to live in a roughly built house [v]\n",
  "CABINET": "a piece of furniture with shelves and drawers [n -S]\n",
  "CABINETMAKER": "a skilled woodworker who makes fine furniture [n -S]\n",
  "CABINETMAKERS": "CABINETMAKER, a skilled woodworker who makes fine furniture [n]\n",
  "CABINETMAKING": "the craft of the cabinetmaker [n -S]\n",
  "CABINETMAKINGS": "CABINETMAKING, the craft of the cabinetmaker [n]\n",
  "CABINETRIES": "CABINETRY, cabinetwork [n]\n",
  "CABINETRY": "cabinetwork [n CABINETRIES]\n",
  "CABINETS": "CABINET, a piece of furniture with shelves and drawers [n]\n",
  "CABINETWORK": "finished woodwork made by a cabinetmaker [n -S]\n",
  "CABINETWORKS": "CABINETWORK, finished woodwork made by a cabinetmaker [n]\n",
  "CABINING": "CABIN, to live in a roughly built house [v]\n",
  "CABINMATE": "one who shares a cabin [n -S]\n",
  "CABINMATES": "CABINMATE, one who shares a cabin [n]\n",
  "CABINS": "CABIN, to live in a roughly built house [v]\n",
  "CABLE": "to fasten with a heavy rope [v CABLED, CABLING, CABLES]\n",
  "CABLECAST": "to broadcast on cable [v -ED, -ING, -S]\n",
  "CABLECASTED": "CABLECAST, to broadcast on cable [v]\n",
  "CABLECASTING": "CABLECAST, to broadcast on cable [v]\n",
  "CABLECASTS": "CABLECAST, to broadcast on cable [v]\n",
  "CABLED": "CABLE, to fasten with a heavy rope [v]\n",
  "CABLEGRAM": "a message sent by a submarine telegraphic cable [n -S]\n",
  "CABLEGRAMS": "CABLEGRAM, a message sent by a submarine telegraphic cable [n]\n",
  "CABLER": "one that supplies a cable [n -S]\n",
  "CABLERS": "CABLER, one that supplies a cable [n]\n",
  "CABLES": "CABLE, to fasten with a heavy rope [v]\n",
  "CABLET": "a little cable less than ten inches in circumference [n -S]\n",
  "CABLETS": "CABLET, a little cable less than ten inches in circumference [n]\n",
  "CABLEVISION": "(tradename) television transmission by cable [n -S]\n",
  "CABLEVISIONS": "CABLEVISION, (tradename) television transmission by cable [n]\n",
  "CABLEWAY": "a structure for transport of material in cars, suspended from a cable [n -S]\n",
  "CABLEWAYS": "CABLEWAY, a structure for transport of material in cars, suspended from a cable [n]\n",
  "CABLING": "a bead or moulding like a thick rope [n -S]\n",
  "CABLINGS": "CABLING, a bead or moulding like a thick rope [n]\n",
  "CABMAN": "a driver of a cab [n CABMEN]\n",
  "CABMEN": "CABMAN, a driver of a cab [n]\n",
  "CABOB": "(Arabic) to skewer [v CABOBBED, CABOBBING, CABOBS]\n",
  "CABOBBED": "CABOB, (Arabic) to skewer [v]\n",
  "CABOBBING": "CABOB, (Arabic) to skewer [v]\n",
  "CABOBS": "CABOB, (Arabic) to skewer [v]\n",
  "CABOC": "(Scots) a double cream cheese rolled in oatmeal, also KEBBOCK, KEBBUCK [n -S]\n",
  "CABOCEER": "(Portuguese) a West African headman [n -S]\n",
  "CABOCEERS": "CABOCEER, (Portuguese) a West African headman [n]\n",
  "CABOCHED": "in heraldry, full faced with no neck showing, also CABOSHED [adj]\n",
  "CABOCHON": "(French) a precious stone polished but uncut, or cut rounded on the top but flat on the back [n -S]\n",
  "CABOCHONS": "CABOCHON, (French) a precious stone polished but uncut, or cut rounded on the top but flat on the back [n]\n",
  "CABOCS": "CABOC, (Scots) a double cream cheese rolled in oatmeal, also KEBBOCK, KEBBUCK [n]\n",
  "CABOMBA": "(Spanish) a small genus of aquatic plants, known commonly as fanwort [n -S]\n",
  "CABOMBAS": "CABOMBA, (Spanish) a small genus of aquatic plants, known commonly as fanwort [n]\n",
  "CABOODLE": "a crowd or collection, also KABOODLE [n -S]\n",
  "CABOODLES": "CABOODLE, a crowd or collection, also KABOODLE [n]\n",
  "CABOOSE": "(Dutch) a kitchen on the deck of a ship [n -S]\n",
  "CABOOSES": "CABOOSE, (Dutch) a kitchen on the deck of a ship [n]\n",
  "CABOSHED": "in heraldry, full faced with no neck showing, also CABOCHED [adj]\n",
  "CABOTAGE": "(French) shipping and sailing between points in the same country [n -S]\n",
  "CABOTAGES": "CABOTAGE, (French) shipping and sailing between points in the same country [n]\n",
  "CABOVER": "a truck or lorry with the cab over the engine [n -S]\n",
  "CABOVERS": "CABOVER, a truck or lorry with the cab over the engine [n]\n",
  "CABRE": "(French) in heraldry, rearing up [adj]\n",
  "CABRESTA": "(Spanish) a lasso, also CABESTRO, CABRESTO [n -S]\n",
  "CABRESTAS": "CABRESTA, (Spanish) a lasso, also CABESTRO, CABRESTO [n]\n",
  "CABRESTO": "(Spanish) a lasso, also CABESTRO, CABRESTA [n -S]\n",
  "CABRESTOS": "CABRESTO, (Spanish) a lasso, also CABESTRO, CABRESTA [n]\n",
  "CABRETTA": "(Spanish) a soft leather made from the skins of a hairy South American sheep [n -S]\n",
  "CABRETTAS": "CABRETTA, (Spanish) a soft leather made from the skins of a hairy South American sheep [n]\n",
  "CABRIE": "(Spanish) a pronghorn antelope, also CABRIT [n -S]\n",
  "CABRIES": "CABRIE, (Spanish) a pronghorn antelope, also CABRIT [n]\n",
  "CABRILLA": "(Spanish) a name applied to various species of edible fishes of the genus Serranus [n -S]\n",
  "CABRILLAS": "CABRILLA, (Spanish) a name applied to various species of edible fishes of the genus Serranus [n]\n",
  "CABRIO": "a kind of two-wheeled carriage [n -S]\n",
  "CABRIOLE": "(French) a curved furniture leg ending in a ball [n -S]\n",
  "CABRIOLES": "CABRIOLE, (French) a curved furniture leg ending in a ball [n]\n",
  "CABRIOLET": "(French) a kind of two-wheeled carriage [n -S]\n",
  "CABRIOLETS": "CABRIOLET, (French) a kind of two-wheeled carriage [n]\n",
  "CABRIOS": "CABRIO, a kind of two-wheeled carriage [n]\n",
  "CABRIT": "(Spanish) a pronghorn antelope, also CABRIE [n -S]\n",
  "CABRITS": "CABRIT, (Spanish) a pronghorn antelope, also CABRIE [n]\n",
  "CABS": "CAB, to travel by taxicab [v]\n",
  "CABSTAND": "a place where cabs await hire [n -S]\n",
  "CABSTANDS": "CABSTAND, a place where cabs await hire [n]\n",
  "CACA": "(slang) faeces, also KAK, CACK, KACK [n -S]\n",
  "CACAFOGO": "(Spanish) a spitfire, a blusterer, also CACAFUEGO [n -S]\n",
  "CACAFOGOS": "CACAFOGO, (Spanish) a spitfire, a blusterer, also CACAFUEGO [n]\n",
  "CACAFUEGO": "(Spanish) a spitfire, blusterer, also CACAFOGO [n -S]\n",
  "CACAFUEGOS": "CACAFUEGO, (Spanish) a spitfire, blusterer, also CACAFOGO [n]\n",
  "CACAO": "(Nahuatl) a small evergreen tree of South America and the West Indies, from the fruit of which cocoa and chocolate are prepared [n -S]\n",
  "CACAOS": "CACAO, (Nahuatl) a small evergreen tree of South America and the West Indies, from the fruit of which cocoa and chocolate are prepared [n]\n",
  "CACAS": "CACA, (slang) faeces, also KAK, CACK, KACK [n]\n",
  "CACCIATORA": "(Italian) of meat, cooked with tomatoes, mushrooms, onions and herbs, also CACCIATORE [adj]\n",
  "CACCIATORE": "(Italian) of meat, cooked with tomatoes, mushrooms, onions and herbs, also CACCIATORA [adj]\n",
  "CACHACA": "a white Brazilian rum made from sugarcane [n -S]\n",
  "CACHACAS": "CACHACA, a white Brazilian rum made from sugarcane [n]\n",
  "CACHAEMIA": "(archaic) a degenerated or poisoned condition of the blood [n -S]\n",
  "CACHAEMIAS": "CACHAEMIA, (archaic) a degenerated or poisoned condition of the blood [n]\n",
  "CACHAEMIC": "(archaic) relating to cachaemia, a degenerated or poisoned condition of the blood [adj]\n",
  "CACHALOT": "(French) a large whale, also CACHOLOT [n -S]\n",
  "CACHALOTS": "CACHALOT, (French) a large whale, also CACHOLOT [n]\n",
  "CACHE": "to store in a hiding place [v CACHED, CACHING, CACHES]\n",
  "CACHECTIC": "relating to cachexy, severe wasting of the body, also CACHECTICAL, CACHEXIC [adj]\n",
  "CACHECTICAL": "relating to cachexy, severe wasting of the body, also CACHECTIC, CACHEXIC [adj]\n",
  "CACHED": "CACHE, to store in a hiding place [v]\n",
  "CACHEPOT": "(French) an ornamental container used to conceal a flowerpot [n -S]\n",
  "CACHEPOTS": "CACHEPOT, (French) an ornamental container used to conceal a flowerpot [n]\n",
  "CACHES": "CACHE, to store in a hiding place [v]\n",
  "CACHET": "(French) to print a design on an envelope [v -ED, -ING, -S]\n",
  "CACHETED": "CACHET, (French) to print a design on an envelope [v]\n",
  "CACHETING": "CACHET, (French) to print a design on an envelope [v]\n",
  "CACHETS": "CACHET, (French) to print a design on an envelope [v]\n",
  "CACHEXIA": "general ill health, also CACHEXY [n -S]\n",
  "CACHEXIAS": "CACHEXIA, general ill health, also CACHEXY [n]\n",
  "CACHEXIC": "pertaining to ill health [adj]\n",
  "CACHEXIES": "CACHEXY, general ill health, also CACHEXIA [n]\n",
  "CACHEXY": "general ill health, also CACHEXIA [n CACHEXIES]\n",
  "CACHING": "CACHE, to store in a hiding place [v]\n",
  "CACHINNATE": "to laugh loudly or immoderately [v CACHINNATED, CACHINNATING, CACHINNATES]\n",
  "CACHINNATED": "CACHINNATE, to laugh loudly or immoderately [v]\n",
  "CACHINNATES": "CACHINNATE, to laugh loudly or immoderately [v]\n",
  "CACHINNATING": "CACHINNATE, to laugh loudly or immoderately [v]\n",
  "CACHINNATION": "loud or hysterical laughter [n -S]\n",
  "CACHINNATIONS": "CACHINNATION, loud or hysterical laughter [n]\n",
  "CACHINNATORY": "like loud laughter [adj]\n",
  "CACHOLONG": "(French) an opaque or milk-white chalcedony, a variety of quartz [n -S]\n",
  "CACHOLONGS": "CACHOLONG, (French) an opaque or milk-white chalcedony, a variety of quartz [n]\n",
  "CACHOLOT": "(French) a large whale, also CACHALOT [n -S]\n",
  "CACHOLOTS": "CACHOLOT, (French) a large whale, also CACHALOT [n]\n",
  "CACHOU": "(Malay) a resin used in tanning, also CATECHU, CASHOO, CUTCH, KUTCH [n -S]\n",
  "CACHOUS": "CACHOU, (Malay) a resin used in tanning, also CATECHU, CASHOO, CUTCH, KUTCH [n]\n",
  "CACHUCHA": "(Spanish) an Andalusian dance in three-four time, resembling the bolero [n -S]\n",
  "CACHUCHAS": "CACHUCHA, (Spanish) an Andalusian dance in three-four time, resembling the bolero [n]\n",
  "CACIQUE": "a West Indian or American Indian chief, also CAZIQUE [n -S]\n",
  "CACIQUES": "CACIQUE, a West Indian or American Indian chief, also CAZIQUE [n]\n",
  "CACIQUISM": "government by a cacique, a West Indian or American Indian chief [n -S]\n",
  "CACIQUISMS": "CACIQUISM, government by a cacique, a West Indian or American Indian chief [n]\n",
  "CACK": "faeces, rubbish, also CACA, KACK, KAK [n -S] / to defecate [v -ED, -ING, -S]\n",
  "CACKED": "CACK, to defecate [v]\n",
  "CACKERMANDER": "(dialect) a friend [n -S]\n",
  "CACKERMANDERS": "CACKERMANDER, (dialect) a friend [n]\n",
  "CACKIER": "CACKY, of or like excrement [adj]\n",
  "CACKIEST": "CACKY, of or like excrement [adj]\n",
  "CACKING": "CACK, to defecate [v]\n",
  "CACKLE": "to make the sound of a hen [v CACKLED, CACKLING, CACKLES]\n",
  "CACKLEBERRIES": "CACKLEBERRY, (slang) an egg [n]\n",
  "CACKLEBERRY": "(slang) an egg [n CACKLEBERRIES]\n",
  "CACKLED": "CACKLE, to make the sound of a hen [v]\n",
  "CACKLER": "one who cackles [n -S]\n",
  "CACKLERS": "CACKLER, one who cackles [n]\n",
  "CACKLES": "CACKLE, to make the sound of a hen [v]\n",
  "CACKLING": "CACKLE, to make the sound of a hen [v]\n",
  "CACKS": "CACK, faeces, rubbish, also CACA, KACK, KAK [n]\n",
  "CACKY": "of or like excrement [adj CACKIER, CACKIEST]\n",
  "CACODAEMON": "(Greek) an evil spirit, a devil, also CACODEMON [n -S]\n",
  "CACODAEMONS": "CACODAEMON, (Greek) an evil spirit, a devil, also CACODEMON [n]\n",
  "CACODEMON": "(Greek) an evil spirit, a devil, also CACODAEMON [n -S]\n",
  "CACODEMONIC": "like a cacodemon, an evil spirit [adj]\n",
  "CACODEMONS": "CACODEMON, (Greek) an evil spirit, a devil, also CACODAEMON [n]\n",
  "CACODOXIES": "CACODOXY, incorrect doctrine, heresy [n]\n",
  "CACODOXY": "incorrect doctrine, heresy [n CACODOXIES]\n",
  "CACODYL": "a colourless, poisonous, foul-smelling liquid, composed of arsenic, carbon and hydrogen, also KAKODYL [n -S]\n",
  "CACODYLIC": "of, pertaining to, or derived from, cacodyl, a colorless, poisonous, arsenical liquid [adj]\n",
  "CACODYLS": "CACODYL, a colourless, poisonous, foul-smelling liquid, composed of arsenic, carbon and hydrogen, also KAKODYL [n]\n",
  "CACOEPIES": "CACOEPY, a wrong pronunciation [n]\n",
  "CACOEPISTIC": "relating to cacoepy, incorrect pronunciation [adj]\n",
  "CACOEPY": "a wrong pronunciation [n CACOEPIES]\n",
  "CACOETHES": "(Greek) an insatiable desire or mania; a bad habit [n CACOETHES]\n",
  "CACOETHIC": "relating to cacoethes, an insatiable desire or mania [adj]\n",
  "CACOGASTRIC": "of or relating to an upset stomach [adj]\n",
  "CACOGENIC": "reducing the quality of a race [adj]\n",
  "CACOGENICS": "the study of racial degeneration [n]\n",
  "CACOGRAPHER": "a bad writer or speller [n -S]\n",
  "CACOGRAPHERS": "CACOGRAPHER, a bad writer or speller [n]\n",
  "CACOGRAPHIC": "relating to cacography, bad handwriting or spelling, also CACOGRAPHICAL [adj]\n",
  "CACOGRAPHICAL": "relating to cacography, bad handwriting or spelling, also CACOGRAPHIC [adj]\n",
  "CACOGRAPHIES": "CACOGRAPHY, bad handwriting (the antithesis of calligraphy) or orthography [n]\n",
  "CACOGRAPHY": "bad handwriting (the antithesis of calligraphy) or orthography [n CACOGRAPHIES]\n",
  "CACOLET": "(French) a military mule litter [n -S]\n",
  "CACOLETS": "CACOLET, (French) a military mule litter [n]\n",
  "CACOLOGIES": "CACOLOGY, a bad choice of words [n]\n",
  "CACOLOGY": "a bad choice of words [n CACOLOGIES]\n",
  "CACOMISTLE": "(Nahuatl) a North American carnivore, about the size of a cat, related to the raccoons, also CACOMIXL, CACOMIXLE [n -S]\n",
  "CACOMISTLES": "CACOMISTLE, (Nahuatl) a North American carnivore, about the size of a cat, related to the raccoons, also CACOMIXL, CACOMIXLE [n]\n",
  "CACOMIXL": "(Nahuatl) a North American carnivore, about the size of a cat, related to the raccoons, also CACOMISTLE, CACOMIXLE [n -S]\n",
  "CACOMIXLE": "(Nahuatl) a North American carnivore, about the size of a cat, related to the raccoons, also CACOMISTLE, CACOMIXL [n -S]\n",
  "CACOMIXLES": "CACOMIXLE, (Nahuatl) a North American carnivore, about the size of a cat, related to the raccoons, also CACOMISTLE, CACOMIXL [n]\n",
  "CACOMIXLS": "CACOMIXL, (Nahuatl) a North American carnivore, about the size of a cat, related to the raccoons, also CACOMISTLE, CACOMIXLE [n]\n",
  "CACONYM": "an erroneous name [n -S]\n",
  "CACONYMIES": "CACONYMY, the state of having an erroneous name [n]\n",
  "CACONYMS": "CACONYM, an erroneous name [n]\n",
  "CACONYMY": "the state of having an erroneous name [n CACONYMIES]\n",
  "CACOON": "the large seed of a tropical climber of the mimosa family [n -S]\n",
  "CACOONS": "CACOON, the large seed of a tropical climber of the mimosa family [n]\n",
  "CACOPHONIC": "of or like a cacophony, also CACOPHONICAL, CACOPHONIOUS, CACOPHONOUS [adj CACOPHONICALLY]\n",
  "CACOPHONICAL": "of or like a cacophony, also CACOPHONIC, CACOPHONIOUS, CACOPHONOUS [adj CACOPHONICALLY]\n",
  "CACOPHONICALLY": "CACOPHONICAL, of or like a cacophony, also CACOPHONIC, CACOPHONIOUS, CACOPHONOUS [adv]\n",
  "CACOPHONIES": "CACOPHONY, the harsh joining of sounds [n]\n",
  "CACOPHONIOUS": "relating to a cacophony, also CACOPHONIC, CACOPHONICAL, CACOPHONOUS [adj]\n",
  "CACOPHONOUS": "discordant, unpleasantly noisy, also CACOPHONIC, CACOPHONICAL, CACOPHONIOUS [adj CACOPHONOUSLY]\n",
  "CACOPHONOUSLY": "CACOPHONOUS, discordant, unpleasantly noisy, also CACOPHONIC, CACOPHONICAL, CACOPHONIOUS [adv]\n",
  "CACOPHONY": "the harsh joining of sounds [n CACOPHONIES]\n",
  "CACOTOPIA": "a state in which everything is as bad as it can be [n -S]\n",
  "CACOTOPIAN": "of or like a cacotopia, a state in which everything is as bad as it can be [adj]\n",
  "CACOTOPIAS": "CACOTOPIA, a state in which everything is as bad as it can be [n]\n",
  "CACOTROPHIES": "CACOTROPHY, bad or inadequate diet [n]\n",
  "CACOTROPHY": "bad or inadequate diet [n CACOTROPHIES]\n",
  "CACTACEOUS": "belonging to, or like, the family of plants of which the prickly pear is a common example [adj]\n",
  "CACTI": "CACTUS, (Latin) a succulent plant of the family Cactaceae, with thick fleshy stems, usually spiny and without leaves [n]\n",
  "CACTIFORM": "cactus-shaped [adj]\n",
  "CACTOBLASTES": "CACTOBLASTIS, a moth introduced into Australia as a biological control for the prickly pear [n]\n",
  "CACTOBLASTIS": "a moth introduced into Australia as a biological control for the prickly pear [n CACTOBLASTES]\n",
  "CACTOID": "cactus-shaped [adj]\n",
  "CACTUS": "(Latin) a succulent plant of the family Cactaceae, with thick fleshy stems, usually spiny and without leaves [n CACTI or CACTUSES]\n",
  "CACTUSES": "CACTUS, (Latin) a succulent plant of the family Cactaceae, with thick fleshy stems, usually spiny and without leaves [n]\n",
  "CACUMEN": "(Latin) a top or point [n CACUMINA or CACUMENS]\n",
  "CACUMENS": "CACUMEN, (Latin) a top or point [n]\n",
  "CACUMINA": "CACUMEN, (Latin) a top or point [n]\n",
  "CACUMINAL": "pronounced with the tongue-tip curled up towards the hard palate [adj] / a sound so produced [n -S]\n",
  "CACUMINALS": "CACUMINAL, a sound so produced [n]\n",
  "CACUMINOUS": "with pointed or pyramidal top [adj]\n",
  "CAD": "an ungentlemanly man [n -S]\n",
  "CADAGA": "an Australian eucalyptus with smooth green bark, also CADAGI [n -S]\n",
  "CADAGAS": "CADAGA, an Australian eucalyptus with smooth green bark, also CADAGI [n]\n",
  "CADAGI": "an Australian eucalyptus with smooth green bark, also CADAGA [n -S]\n",
  "CADAGIS": "CADAGI, an Australian eucalyptus with smooth green bark, also CADAGA [n]\n",
  "CADASTER": "a public record of land ownership, also CADASTRE [n -S]\n",
  "CADASTERS": "CADASTER, a public record of land ownership, also CADASTRE [n]\n",
  "CADASTRAL": "of or relating to a map or survey showing property lines, boundaries, etc. [adj CADASTRALLY]\n",
  "CADASTRALLY": "CADASTRAL, of or relating to a map or survey showing property lines, boundaries, etc. [adv]\n",
  "CADASTRE": "a public record of land ownership, also CADASTER [n -S]\n",
  "CADASTRES": "CADASTRE, a public record of land ownership, also CADASTER [n]\n",
  "CADAVER": "a corpse [n -S]\n",
  "CADAVERIC": "of or resembling a corpse, or the changes produced by death, also CADAVEROUS [adj]\n",
  "CADAVERINE": "a deadly ptomaine [n -S]\n",
  "CADAVERINES": "CADAVERINE, a deadly ptomaine [n]\n",
  "CADAVEROUS": "resembling a corpse, also CADAVERIC [adj CADAVEROUSLY]\n",
  "CADAVEROUSLY": "CADAVEROUS, resembling a corpse, also CADAVERIC [adv]\n",
  "CADAVEROUSNESS": "CADAVEROUS, resembling a corpse, also CADAVERIC [n]\n",
  "CADAVERS": "CADAVER, a corpse [n]\n",
  "CADDICE": "a coarse woollen fabric, also CADDIS [n -S]\n",
  "CADDICES": "CADDICE, a coarse woollen fabric, also CADDIS [n]\n",
  "CADDIE": "to serve as a golfer's assistant, also CADDY [v CADDIED, CADDYING, CADDIES]\n",
  "CADDIED": "CADDY, to serve as a golfer's assistant, also CADDIE [v]\n",
  "CADDIES": "CADDY, to serve as a golfer's assistant, also CADDIE [v]\n",
  "CADDIS": "a coarse woollen braid, also CADDICE [n -ES]\n",
  "CADDISED": "trimmed with caddis, a coarse woollen braid [adj]\n",
  "CADDISES": "CADDIS, a coarse woollen braid, also CADDICE [n]\n",
  "CADDISFLIES": "CADDISFLY, any small mothlike insect of the order Trichoptera that lives near, and lays its eggs in, water [n]\n",
  "CADDISFLY": "any small mothlike insect of the order Trichoptera that lives near, and lays its eggs in, water [n CADDISFLIES]\n",
  "CADDISH": "like a cad; lowbred and presuming [adj CADDISHLY]\n",
  "CADDISHLY": "CADDISH, like a cad; lowbred and presuming [adv]\n",
  "CADDISHNESS": "the state of being caddish [n -ES]\n",
  "CADDISHNESSES": "CADDISHNESS, the state of being caddish [n]\n",
  "CADDISWORM": "the larva of the caddisfly [n -S]\n",
  "CADDISWORMS": "CADDISWORM, the larva of the caddisfly [n]\n",
  "CADDY": "to serve as a golfer's assistant, also CADDIE [v CADDIED, CADDYING, CADDIES]\n",
  "CADDYING": "CADDY, to serve as a golfer's assistant, also CADDIE [v]\n",
  "CADDYSS": "(Shakespeare) a worsted ribbon or braid, also CADDICE, CADDIS [n -ES]\n",
  "CADDYSSES": "CADDYSS, (Shakespeare) a worsted ribbon or braid, also CADDICE, CADDIS [n]\n",
  "CADE": "a Mediterranean medicinal shrub [n -S]\n",
  "CADEAU": "(French) a present [n CADEAUX]\n",
  "CADEAUX": "CADEAU, (French) a present [n]\n",
  "CADEE": "(Scots) a caddie, also CADIE [n -S]\n",
  "CADEES": "CADEE, (Scots) a caddie, also CADIE [n]\n",
  "CADELLE": "(French) a small black beetle [n -S]\n",
  "CADELLES": "CADELLE, (French) a small black beetle [n]\n",
  "CADENCE": "to make rhythmic [v CADENCED, CADENCING, CADENCES]\n",
  "CADENCED": "CADENCE, to make rhythmic [v]\n",
  "CADENCES": "CADENCE, to make rhythmic [v]\n",
  "CADENCIES": "CADENCY, the status of a younger branch of a family [n]\n",
  "CADENCING": "CADENCE, to make rhythmic [v]\n",
  "CADENCY": "the status of a younger branch of a family [n CADENCIES]\n",
  "CADENT": "(Shakespeare) falling [adj]\n",
  "CADENTIAL": "relating to a cadence [adj]\n",
  "CADENZA": "(Italian) an elaborate musical passage [n -S]\n",
  "CADENZAS": "CADENZA, (Italian) an elaborate musical passage [n]\n",
  "CADES": "CADE, a Mediterranean medicinal shrub [n]\n",
  "CADET": "a student at a military school [n -S]\n",
  "CADETS": "CADET, a student at a military school [n]\n",
  "CADETSHIP": "the position, rank, or commission of a cadet [n -S]\n",
  "CADETSHIPS": "CADETSHIP, the position, rank, or commission of a cadet [n]\n",
  "CADGE": "to get by begging [v CADGED, CADGING, CADGES]\n",
  "CADGED": "CADGE, to get by begging [v]\n",
  "CADGER": "a scrounger; originally a dealer who travelled around remote country areas, buying and selling farm produce [n -S]\n",
  "CADGERS": "CADGER, a scrounger; originally a dealer who travelled around remote country areas, buying and selling farm produce [n]\n",
  "CADGES": "CADGE, to get by begging [v]\n",
  "CADGIER": "CADGY, cheerful, also KIDGIE [adj]\n",
  "CADGIEST": "CADGY, cheerful, also KIDGIE [adj]\n",
  "CADGING": "CADGE, to get by begging [v]\n",
  "CADGY": "cheerful, also KIDGIE [adj CADGIER, CADGIEST]\n",
  "CADI": "(Arabic) a civil judge in a Muslim country, also CAID, KADI, KAID, QADI, QAID [n -S]\n",
  "CADIE": "(Scots) a caddie, also CADEE [n -S]\n",
  "CADIES": "CADIE, (Scots) a caddie, also CADEE [n]\n",
  "CADIS": "CADI, (Arabic) a civil judge in a Muslim country, also CAID, KADI, KAID, QADI, QAID [n]\n",
  "CADMIC": "relating to cadmium [adj]\n",
  "CADMIUM": "a metallic element [n -S]\n",
  "CADMIUMS": "CADMIUM, a metallic element [n]\n",
  "CADRANS": "(French) an instrument used in gem cutting [n -ES]\n",
  "CADRANSES": "CADRANS, (French) an instrument used in gem cutting [n]\n",
  "CADRE": "(French) a permanent establishment of trained personnel forming a nucleus for expansion at need [n -S]\n",
  "CADRES": "CADRE, (French) a permanent establishment of trained personnel forming a nucleus for expansion at need [n]\n",
  "CADS": "CAD, an ungentlemanly man [n]\n",
  "CADUAC": "(obsolete) an incidental payment; a windfall [n -S]\n",
  "CADUACS": "CADUAC, (obsolete) an incidental payment; a windfall [n]\n",
  "CADUCEAN": "of or belonging to Mercury's caduceus, or wand [adj]\n",
  "CADUCEI": "CADUCEUS, (Latin) a Greek or Roman herald's wand; specifically the wand carried by the messenger-god Hermes or Mercury, usually represented with two serpents twined round it [n]\n",
  "CADUCEUS": "(Latin) a Greek or Roman herald's wand; specifically the wand carried by the messenger-god Hermes or Mercury, usually represented with two serpents twined round it [n CADUCEI]\n",
  "CADUCITIES": "CADUCITY, the quality of being transitory or perishable [n]\n",
  "CADUCITY": "the quality of being transitory or perishable [n CADUCITIES]\n",
  "CADUCOUS": "of parts of a plant or animal, shed or falling at an early stage [adj]\n",
  "CAECA": "CAECUM, (Latin) a bodily cavity with one opening, also CECUM [n]\n",
  "CAECAL": "pertaining to the caecum, a part of the intestine, also CECAL [adj CAECALLY]\n",
  "CAECALLY": "CAECAL, pertaining to the caecum, a part of the intestine, also CECAL [adv]\n",
  "CAECILIAN": "a tropical burrowing, wormlike amphibian, also COECILIAN [n -S]\n",
  "CAECILIANS": "CAECILIAN, a tropical burrowing, wormlike amphibian, also COECILIAN [n]\n",
  "CAECITIS": "a caecum inflammation, also CECITIS [n -ES]\n",
  "CAECITISES": "CAECITIS, a caecum inflammation, also CECITIS [n]\n",
  "CAECUM": "(Latin) a bodily cavity with one opening, also CECUM [n CAECA]\n",
  "CAENOGENESES": "CAENOGENESIS, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CENOGENESIS, KAINOGENESIS, KENOGENESIS [n]\n",
  "CAENOGENESIS": "the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CENOGENESIS, KAINOGENESIS, KENOGENESIS [n CAENOGENESES]\n",
  "CAENOGENETIC": "relating to caenogenesis, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CAINOGENETIC, CENOGENETIC [adj]\n",
  "CAEOMA": "a spore-forming organ of a fungus [n -S]\n",
  "CAEOMAS": "CAEOMA, a spore-forming organ of a fungus [n]\n",
  "CAERULE": "(Spenser) sky-blue, also CERULE, CERULEAN [adj]\n",
  "CAERULEAN": "sky-blue; dark blue; sea-green, also CERULEAN, CERULEOUS [adj]\n",
  "CAESALPINOID": "belonging to the Caesalpinoidea, a tropical subfamily of leguminous plants [adj]\n",
  "CAESAR": "(Latin) a Caesarean section [n -S]\n",
  "CAESAREAN": "relating to a birth by caesarean section [adj] / an operation to deliver a baby by cutting through the walls of the abdomen, also CAESARIAN, CESAREAN, CESARIAN [n -S]\n",
  "CAESAREANS": "CAESAREAN, an operation to deliver a baby by cutting through the walls of the abdomen, also CAESARIAN, CESAREAN, CESARIAN [n]\n",
  "CAESARIAN": "relating to a birth by caesarean section [adj] / an operation to deliver a baby by cutting through the walls of the abdomen, also CAESAREAN, CESAREAN, CESARIAN [n -S]\n",
  "CAESARIANS": "CAESARIAN, an operation to deliver a baby by cutting through the walls of the abdomen, also CAESAREAN, CESAREAN, CESARIAN [n]\n",
  "CAESARISM": "imperialism [n -S]\n",
  "CAESARISMS": "CAESARISM, imperialism [n]\n",
  "CAESAROPAPISM": "control of the church by a secular ruler [n -S]\n",
  "CAESAROPAPISMS": "CAESAROPAPISM, control of the church by a secular ruler [n]\n",
  "CAESARS": "CAESAR, (Latin) a Caesarean section [n]\n",
  "CAESE": "(Shakespeare) enough said, also CEAS, SESE, SESEY, SESSA [interj]\n",
  "CAESIOUS": "having a bluish coating, also CESIOUS [adj]\n",
  "CAESIUM": "a metallic element [n -S]\n",
  "CAESIUMS": "CAESIUM, a metallic element [n]\n",
  "CAESPITOSE": "growing in clusters or tufts [adj CAESPITOSELY]\n",
  "CAESPITOSELY": "CAESPITOSE, growing in clusters or tufts [adv]\n",
  "CAESTUS": "(Latin) a hand covering for ancient Roman boxers, also CESTUS [n -ES]\n",
  "CAESTUSES": "CAESTUS, (Latin) a hand covering for ancient Roman boxers, also CESTUS [n]\n",
  "CAESURA": "(Latin) a pause in a line of verse, also CESURA [n CAESURAS or CAESURAE]\n",
  "CAESURAE": "CAESURA, (Latin) a pause in a line of verse, also CESURA [n]\n",
  "CAESURAL": "relating to a caesura [adj]\n",
  "CAESURAS": "CAESURA, (Latin) a pause in a line of verse, also CESURA [n]\n",
  "CAESURIC": "relating to a caesura [adj]\n",
  "CAF": "(short for) a cafeteria or cafe [n -S]\n",
  "CAFARD": "(French) severe depression or apathy [n -S]\n",
  "CAFARDS": "CAFARD, (French) severe depression or apathy [n]\n",
  "CAFE": "a small restaurant [n -S]\n",
  "CAFES": "CAFE, a small restaurant [n]\n",
  "CAFETERIA": "a restaurant where customers serve themselves, or are served from, and usually pay at, a counter before sitting down to eat [n -S]\n",
  "CAFETERIAS": "CAFETERIA, a restaurant where customers serve themselves, or are served from, and usually pay at, a counter before sitting down to eat [n]\n",
  "CAFETIERE": "(French) a type of coffee-maker [n -S]\n",
  "CAFETIERES": "CAFETIERE, (French) a type of coffee-maker [n]\n",
  "CAFETORIA": "CAFETORIUM, a large room designed for use as both a cafe and an auditorium [n]\n",
  "CAFETORIUM": "a large room designed for use as both a cafe and an auditorium [n CAFETORIA or CAFETORIUMS]\n",
  "CAFETORIUMS": "CAFETORIUM, a large room designed for use as both a cafe and an auditorium [n]\n",
  "CAFF": "(slang) cafe, also CAF [n -S]\n",
  "CAFFEIN": "a bitter alkaloid used as a stimulant, also CAFFEINE [n -S]\n",
  "CAFFEINATED": "containing caffeine [adj]\n",
  "CAFFEINE": "a bitter alkaloid used as a stimulant, also CAFFEIN [n -S]\n",
  "CAFFEINES": "CAFFEINE, a bitter alkaloid used as a stimulant, also CAFFEIN [n]\n",
  "CAFFEINIC": "of or containing caffeine [adj]\n",
  "CAFFEINISM": "an unhealthy condition caused by taking too much caffeine [n -S]\n",
  "CAFFEINISMS": "CAFFEINISM, an unhealthy condition caused by taking too much caffeine [n]\n",
  "CAFFEINS": "CAFFEIN, a bitter alkaloid used as a stimulant, also CAFFEINE [n]\n",
  "CAFFEISM": "an addiction to caffeine [n -S]\n",
  "CAFFEISMS": "CAFFEISM, an addiction to caffeine [n]\n",
  "CAFFILA": "(Arabic) a caravan, caravan-train, also CAFILA, KAFILA [n -S]\n",
  "CAFFILAS": "CAFFILA, (Arabic) a caravan, caravan-train, also CAFILA, KAFILA [n]\n",
  "CAFFS": "CAFF, (slang) cafe, also CAF [n]\n",
  "CAFILA": "(Arabic) a caravan, caravan-train, also CAFFILA, KAFILA [n -S]\n",
  "CAFILAS": "CAFILA, (Arabic) a caravan, caravan-train, also CAFFILA, KAFILA [n]\n",
  "CAFS": "CAF, (short for) a cafeteria or cafe [n]\n",
  "CAFTAN": "(Turkish) a full-length tunic, also KAFTAN [n -S]\n",
  "CAFTANED": "wearing a caftan [adj]\n",
  "CAFTANS": "CAFTAN, (Turkish) a full-length tunic, also KAFTAN [n]\n",
  "CAG": "(short for) cagoule, a light anorak [n -S]\n",
  "CAGANER": "a traditional character in Catalan Christmas scenes, a squatting defecating person [n -S]\n",
  "CAGANERS": "CAGANER, a traditional character in Catalan Christmas scenes, a squatting defecating person [n]\n",
  "CAGE": "to cage [v CAGED, CAGING, CAGES]\n",
  "CAGED": "CAGE, to cage [v]\n",
  "CAGEFUL": "as much as a cage can hold [n -S]\n",
  "CAGEFULS": "CAGEFUL, as much as a cage can hold [n]\n",
  "CAGELIKE": "like a cage [adj]\n",
  "CAGELING": "a caged bird [n -S]\n",
  "CAGELINGS": "CAGELING, a caged bird [n]\n",
  "CAGER": "a basketball player [n -S]\n",
  "CAGERS": "CAGER, a basketball player [n]\n",
  "CAGES": "CAGE, to cage [v]\n",
  "CAGEWORK": "open work like the bars of a cage [n -S]\n",
  "CAGEWORKS": "CAGEWORK, open work like the bars of a cage [n]\n",
  "CAGEY": "shrewd, also CAGY [adj CAGIER, CAGIEST]\n",
  "CAGEYNESS": "the quality of being cagey, also CAGINESS, CAGYNESS [n -ES]\n",
  "CAGEYNESSES": "CAGEYNESS, the quality of being cagey, also CAGINESS, CAGYNESS [n]\n",
  "CAGIER": "CAGY, shrewd, also CAGEY [adj]\n",
  "CAGIEST": "CAGY, shrewd, also CAGEY [adj]\n",
  "CAGILY": "CAGY, shrewd, also CAGEY [adv]\n",
  "CAGINESS": "the quality of being cagy, also CAGEYNESS, CAGYNESS [n -ES]\n",
  "CAGINESSES": "CAGINESS, the quality of being cagy, also CAGEYNESS, CAGYNESS [n]\n",
  "CAGING": "CAGE, to cage [v]\n",
  "CAGMAG": "to chat idly [v CAGMAGGED, CAGMAGGING, CAGMAGS]\n",
  "CAGMAGGED": "CAGMAG, to chat idly [v]\n",
  "CAGMAGGING": "CAGMAG, to chat idly [v]\n",
  "CAGMAGS": "CAGMAG, to chat idly [v]\n",
  "CAGOT": "(French) one of an outcast class found in the Pyrenees, supposed to be the descendants of lepers [n -S]\n",
  "CAGOTS": "CAGOT, (French) one of an outcast class found in the Pyrenees, supposed to be the descendants of lepers [n]\n",
  "CAGOUL": "(French) a light anorak, also CAGOULE, KAGOOL, KAGOUL, KAGOULE [n -S]\n",
  "CAGOULE": "(French) a light anorak, also CAGOUL, KAGOOL, KAGOUL, KAGOULE [n -S]\n",
  "CAGOULES": "CAGOULE, (French) a light anorak, also CAGOUL, KAGOOL, KAGOUL, KAGOULE [n]\n",
  "CAGOULS": "CAGOUL, (French) a light anorak, also CAGOULE, KAGOOL, KAGOUL, KAGOULE [n]\n",
  "CAGS": "CAG, (short for) cagoule, a light anorak [n]\n",
  "CAGY": "shrewd, also CAGEY [adj CAGIER, CAGIEST]\n",
  "CAGYNESS": "the quality of being cagy, also CAGEYNESS, CAGINESS [n -ES]\n",
  "CAGYNESSES": "CAGYNESS, the quality of being cagy, also CAGEYNESS, CAGINESS [n]\n",
  "CAHIER": "(French) a number of sheets of paper put loosely together; esp. one of the successive portions of a work printed in numbers [n -S]\n",
  "CAHIERS": "CAHIER, (French) a number of sheets of paper put loosely together; esp. one of the successive portions of a work printed in numbers [n]\n",
  "CAHOOT": "partnership; as, to go in cahoot with a person [n -S]\n",
  "CAHOOTS": "CAHOOT, partnership; as, to go in cahoot with a person [n]\n",
  "CAHOUN": "(Spanish) a South American palm tree, also COHUNE [n -S]\n",
  "CAHOUNS": "CAHOUN, (Spanish) a South American palm tree, also COHUNE [n]\n",
  "CAHOW": "a large rare petrel which breeds in Bermuda [n -S]\n",
  "CAHOWS": "CAHOW, a large rare petrel which breeds in Bermuda [n]\n",
  "CAID": "(Arabic) a North African chief, also CADI, KADI, KAID, QADI, QAID [n -S]\n",
  "CAIDS": "CAID, (Arabic) a North African chief, also CADI, KADI, KAID, QADI, QAID [n]\n",
  "CAILLACH": "(Gaelic) an old woman, also CAILLEACH, CAILLIACH [n -S]\n",
  "CAILLACHS": "CAILLACH, (Gaelic) an old woman, also CAILLEACH, CAILLIACH [n]\n",
  "CAILLE": "(French) in cooking, a quail [n -S]\n",
  "CAILLEACH": "(Gaelic) an old woman, also CAILLACH, CAILLIACH [n -S]\n",
  "CAILLEACHS": "CAILLEACH, (Gaelic) an old woman, also CAILLACH, CAILLIACH [n]\n",
  "CAILLES": "CAILLE, (French) in cooking, a quail [n]\n",
  "CAILLIACH": "(Gaelic) an old woman, also CAILLACH, CAILLEACH [n -S]\n",
  "CAILLIACHS": "CAILLIACH, (Gaelic) an old woman, also CAILLACH, CAILLEACH [n]\n",
  "CAIMAC": "(Turkish) a Turkish governor, also CAIMACAM, KAIMAKAM, QAIMAQAM [n -S]\n",
  "CAIMACAM": "(Turkish) a Turkish governor, also CAIMAC, KAIMAKAM, QAIMAQAM [n -S]\n",
  "CAIMACAMS": "CAIMACAM, (Turkish) a Turkish governor, also CAIMAC, KAIMAKAM, QAIMAQAM [n]\n",
  "CAIMACS": "CAIMAC, (Turkish) a Turkish governor, also CAIMACAM, KAIMAKAM, QAIMAQAM [n]\n",
  "CAIMAN": "the South American alligator, also CAYMAN [n -S]\n",
  "CAIMANS": "CAIMAN, the South American alligator, also CAYMAN [n]\n",
  "CAIN": "(Gaelic) a tenanted farm rent paid in kind, also KAIN, KANE [n -S]\n",
  "CAINOGENESES": "CAINOGENESIS, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage [n]\n",
  "CAINOGENESIS": "the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage [n CAINOGENESES]\n",
  "CAINOGENETIC": "relating to cainogenesis, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CAENOGENETIC, CENOGENETIC [adj]\n",
  "CAINS": "CAIN, (Gaelic) a tenanted farm rent paid in kind, also KAIN, KANE [n]\n",
  "CAIQUE": "(French) a light skiff used on the Bosphorus [n -S]\n",
  "CAIQUES": "CAIQUE, (French) a light skiff used on the Bosphorus [n]\n",
  "CAIRD": "a travelling tinker; also a tramp or sturdy beggar [n -S]\n",
  "CAIRDS": "CAIRD, a travelling tinker; also a tramp or sturdy beggar [n]\n",
  "CAIRN": "a mound of stones set up as a memorial, also CARN [n -S]\n",
  "CAIRNED": "piled into a cairn [adj]\n",
  "CAIRNGORM": "(Gaelic) a yellow-brown quartz [n -S]\n",
  "CAIRNGORMS": "CAIRNGORM, (Gaelic) a yellow-brown quartz [n]\n",
  "CAIRNIER": "CAIRNY, relating to a cairn [adj]\n",
  "CAIRNIEST": "CAIRNY, relating to a cairn [adj]\n",
  "CAIRNS": "CAIRN, a mound of stones set up as a memorial, also CARN [n]\n",
  "CAIRNY": "relating to a cairn [adj CAIRNIER, CAIRNIEST]\n",
  "CAISSON": "(French) a watertight chamber [n -S]\n",
  "CAISSONS": "CAISSON, (French) a watertight chamber [n]\n",
  "CAITIFF": "a despicable person, also CAITIVE [n -S]\n",
  "CAITIFFS": "CAITIFF, a despicable person, also CAITIVE [n]\n",
  "CAITIVE": "(Spenser) a captive, subject, also CAITIFF [n -S]\n",
  "CAITIVES": "CAITIVE, (Spenser) a captive, subject, also CAITIFF [n]\n",
  "CAJAPUT": "(Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJEPUT, CAJUPUT, KAJEPUT [n -S]\n",
  "CAJAPUTS": "CAJAPUT, (Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJEPUT, CAJUPUT, KAJEPUT [n]\n",
  "CAJEPUT": "(Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJAPUT, CAJUPUT, KAJEPUT [n -S]\n",
  "CAJEPUTS": "CAJEPUT, (Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJAPUT, CAJUPUT, KAJEPUT [n]\n",
  "CAJOLE": "to persuade by flattery [v CAJOLED, CAJOLING, CAJOLES]\n",
  "CAJOLED": "CAJOLE, to persuade by flattery [v]\n",
  "CAJOLEMENT": "the act of cajoling; the state of being cajoled [n -S]\n",
  "CAJOLEMENTS": "CAJOLEMENT, the act of cajoling; the state of being cajoled [n]\n",
  "CAJOLER": "one who cajoles [n -S]\n",
  "CAJOLERIES": "CAJOLERY, persuasion by flattery [n]\n",
  "CAJOLERS": "CAJOLER, one who cajoles [n]\n",
  "CAJOLERY": "persuasion by flattery [n CAJOLERIES]\n",
  "CAJOLES": "CAJOLE, to persuade by flattery [v]\n",
  "CAJOLING": "CAJOLE, to persuade by flattery [v]\n",
  "CAJOLINGLY": "CAJOLING, CAJOLE, to persuade by flattery [adv]\n",
  "CAJON": "(Spanish) a steep canyon [n -ES]\n",
  "CAJONES": "CAJON, (Spanish) a steep canyon [n]\n",
  "CAJUN": "(French) relating to descendants of the French-speaking Acadians deported to Louisiana in 1755 [adj]\n",
  "CAJUPUT": "(Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJAPUT, CAJEPUT, KAJEPUT [n -S]\n",
  "CAJUPUTS": "CAJUPUT, (Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJAPUT, CAJEPUT, KAJEPUT [n]\n",
  "CAKE": "to form into a hardened mass [v CAKED, CAKING, CAKES]\n",
  "CAKEAGE": "a charge levied in a restaurant for serving cake (such as a birthday cake) brought in from outside the premises [n -S]\n",
  "CAKEAGES": "CAKEAGE, a charge levied in a restaurant for serving cake (such as a birthday cake) brought in from outside the premises [n]\n",
  "CAKEBOX": "a container for a cake [n -ES]\n",
  "CAKEBOXES": "CAKEBOX, a container for a cake [n]\n",
  "CAKED": "CAKE, to form into a hardened mass [v]\n",
  "CAKEHOLE": "a person's mouth [n -S]\n",
  "CAKEHOLES": "CAKEHOLE, a person's mouth [n]\n",
  "CAKES": "CAKE, to form into a hardened mass [v]\n",
  "CAKEWALK": "to step stylishly [v -ED, -ING, -S]\n",
  "CAKEWALKED": "CAKEWALK, to step stylishly [v]\n",
  "CAKEWALKER": "one who does the cakewalk [n -S]\n",
  "CAKEWALKERS": "CAKEWALKER, one who does the cakewalk [n]\n",
  "CAKEWALKING": "CAKEWALK, to step stylishly [v]\n",
  "CAKEWALKS": "CAKEWALK, to step stylishly [v]\n",
  "CAKEY": "lumpy, also CAKY [adj CAKIER, CAKIEST]\n",
  "CAKIER": "CAKY, lumpy, also CAKEY [adj]\n",
  "CAKIEST": "CAKY, lumpy, also CAKEY [adj]\n",
  "CAKINESS": "the state of being caky [n -ES]\n",
  "CAKINESSES": "CAKINESS, the state of being caky [n]\n",
  "CAKING": "the act of caking [n -S]\n",
  "CAKINGS": "CAKING, the act of caking [n]\n",
  "CAKY": "lumpy, also CAKEY [adj CAKIER, CAKIEST]\n",
  "CAL": "(short for) calorie, as in low cal [n -S]\n",
  "CALABASH": "a variety of squash; a dish made from the gourd, also CALABAZA [n -ES]\n",
  "CALABASHES": "CALABASH, a variety of squash; a dish made from the gourd, also CALABAZA [n]\n",
  "CALABAZA": "a variety of squash, also CALABASH [n -S]\n",
  "CALABAZAS": "CALABAZA, a variety of squash, also CALABASH [n]\n",
  "CALABOGUS": "(Canadian) a Canadian drink of rum, spruce beer and molasses [n -ES]\n",
  "CALABOGUSES": "CALABOGUS, (Canadian) a Canadian drink of rum, spruce beer and molasses [n]\n",
  "CALABOOSE": "(Spanish) a prison, jail [n -S]\n",
  "CALABOOSES": "CALABOOSE, (Spanish) a prison, jail [n]\n",
  "CALABRESE": "(Italian) a variety of sprouting broccoli [n -S]\n",
  "CALABRESES": "CALABRESE, (Italian) a variety of sprouting broccoli [n]\n",
  "CALADIUM": "(Malay) any tropical plant of the genus Caladium, of the arum family, the plants of which are grown for their attractive foliage [n -S]\n",
  "CALADIUMS": "CALADIUM, (Malay) any tropical plant of the genus Caladium, of the arum family, the plants of which are grown for their attractive foliage [n]\n",
  "CALALOO": "(Caribbean) a soup made with greens, onions and crabmeat, also CALALU, CALLALOO, CALLALOU [n -S]\n",
  "CALALOOS": "CALALOO, (Caribbean) a soup made with greens, onions and crabmeat, also CALALU, CALLALOO, CALLALOU [n]\n",
  "CALALU": "(Caribbean) a soup made with greens, onions and crabmeat, also CALALOO, CALLALOO, CALLALOU [n -S]\n",
  "CALALUS": "CALALU, (Caribbean) a soup made with greens, onions and crabmeat, also CALALOO, CALLALOO, CALLALOU [n]\n",
  "CALAMANCO": "a glossy woollen stuff, plain, striped, or checked [n CALAMANCOS or CALAMANCOES]\n",
  "CALAMANCOES": "CALAMANCO, a glossy woollen stuff, plain, striped, or checked [n]\n",
  "CALAMANCOS": "CALAMANCO, a glossy woollen stuff, plain, striped, or checked [n]\n",
  "CALAMANDER": "(Sinhalese) a hard valuable wood of the ebony genus [n -S]\n",
  "CALAMANDERS": "CALAMANDER, (Sinhalese) a hard valuable wood of the ebony genus [n]\n",
  "CALAMANSI": "a citrus hybrid predominantly cultivated in the Philippines, aka calamondin, also KALAMANSI [n CALAMANSI]\n",
  "CALAMAR": "any of various species of squid, also CALAMARI, CALAMARY [n -S]\n",
  "CALAMARI": "(Italian) any of various species of squid, also CALAMAR, CALAMARY [n -S]\n",
  "CALAMARIES": "CALAMARY, any of various species of squid, also CALAMAR, CALAMARI [n]\n",
  "CALAMARIS": "CALAMARI, (Italian) any of various species of squid, also CALAMAR, CALAMARY [n]\n",
  "CALAMARS": "CALAMAR, any of various species of squid, also CALAMARI, CALAMARY [n]\n",
  "CALAMARY": "any of various species of squid, also CALAMAR, CALAMARI [n CALAMARIES]\n",
  "CALAMATA": "(Modern Greek) a black olive grown in Greece, also KALAMATA [n -S]\n",
  "CALAMATAS": "CALAMATA, (Modern Greek) a black olive grown in Greece, also KALAMATA [n]\n",
  "CALAMI": "CALAMUS, (Latin) a quill or reed used as a pen [n]\n",
  "CALAMINE": "to apply a skin ointment [v CALAMINED, CALAMINING, CALAMINES]\n",
  "CALAMINED": "CALAMINE, to apply a skin ointment [v]\n",
  "CALAMINES": "CALAMINE, to apply a skin ointment [v]\n",
  "CALAMINING": "CALAMINE, to apply a skin ointment [v]\n",
  "CALAMINT": "a genus of labiate aromatic plants allied to mint and thyme [n -S]\n",
  "CALAMINTS": "CALAMINT, a genus of labiate aromatic plants allied to mint and thyme [n]\n",
  "CALAMITE": "a reedlike plant of an extinct group related to the horsetails, found as fossils chiefly of Carboniferous age [n -S]\n",
  "CALAMITES": "CALAMITE, a reedlike plant of an extinct group related to the horsetails, found as fossils chiefly of Carboniferous age [n]\n",
  "CALAMITIES": "CALAMITY, a grievous misfortune, a disaster [n]\n",
  "CALAMITOUS": "disastrous [adj CALAMITOUSLY]\n",
  "CALAMITOUSLY": "CALAMITOUS, disastrous [adv]\n",
  "CALAMITOUSNESS": "CALAMITOUS, disastrous [n]\n",
  "CALAMITY": "a grievous misfortune, a disaster [n CALAMITIES]\n",
  "CALAMONDIN": "(Tagalog) a small citrus tree, native to the Philippines; its acid-tasting orange-like fruit [n -S]\n",
  "CALAMONDINS": "CALAMONDIN, (Tagalog) a small citrus tree, native to the Philippines; its acid-tasting orange-like fruit [n]\n",
  "CALAMUS": "(Latin) a quill or reed used as a pen [n CALAMI or CALAMUSES]\n",
  "CALAMUSES": "CALAMUS, (Latin) a quill or reed used as a pen [n]\n",
  "CALANDO": "(Italian) slowing with gradually lowering volume [adv]\n",
  "CALANDRIA": "(Spanish) a sealed vessel through which tubes pass, used in the core of nuclear reactors as a heat exchanger [n -S]\n",
  "CALANDRIAS": "CALANDRIA, (Spanish) a sealed vessel through which tubes pass, used in the core of nuclear reactors as a heat exchanger [n]\n",
  "CALANTHE": "(Greek) an orchid of the genus Calanthe, having tall spikes of long-lasting flowers [n -S]\n",
  "CALANTHES": "CALANTHE, (Greek) an orchid of the genus Calanthe, having tall spikes of long-lasting flowers [n]\n",
  "CALASH": "(French) a light low-wheeled carriage with folding top, also CALECHE, CALESA [n -ES]\n",
  "CALASHES": "CALASH, (French) a light low-wheeled carriage with folding top, also CALECHE, CALESA [n]\n",
  "CALATHEA": "a showy indoor plant [n -S]\n",
  "CALATHEAS": "CALATHEA, a showy indoor plant [n]\n",
  "CALATHI": "CALATHUS, (Latin) a vase-shaped Ancient Greek basket, carried on the head, also CALATHOS [n]\n",
  "CALATHOS": "(Greek) a vase-shaped Ancient Greek basket, carried on the head, also CALATHUS [n CALATHI]\n",
  "CALATHUS": "(Latin) a vase-shaped Ancient Greek basket, carried on the head, also CALATHOS [n CALATHI]\n",
  "CALAVANCE": "a kind of pulse, also CARAVANCE [n -S]\n",
  "CALAVANCES": "CALAVANCE, a kind of pulse, also CARAVANCE [n]\n",
  "CALAVERITE": "a metallic pale yellow mineral consisting of a telluride of gold in the form of elongated striated crystals [n -S]\n",
  "CALAVERITES": "CALAVERITE, a metallic pale yellow mineral consisting of a telluride of gold in the form of elongated striated crystals [n]\n",
  "CALCANEA": "CALCANEUM, (Latin) one of the bones of the tarsus which in man forms the great bone of the heel, also CALCANEUS [n]\n",
  "CALCANEAL": "pertaining to the calcaneum, one of the bones of the tarsus, also CALCANEAN [adj]\n",
  "CALCANEAN": "pertaining to the calcaneum, one of the bones of the tarsus, also CALCANEAL [adj]\n",
  "CALCANEI": "CALCANEUS, (Latin) one of the bones of the tarsus which in man forms the great bone of the heel, also CALCANEUM [n]\n",
  "CALCANEUM": "(Latin) one of the bones of the tarsus which in man forms the great bone of the heel, also CALCANEUS [n CALCANEA]\n",
  "CALCANEUS": "(Latin) one of the bones of the tarsus which in man forms the great bone of the heel, also CALCANEUM [n CALCANEI]\n",
  "CALCAR": "(Latin) a spur-like projection [n CALCARIA or CALCARS]\n",
  "CALCARATE": "relating to a calcar, a spur-like projection on a bird's leg [adj]\n",
  "CALCAREOUS": "chalky; of or containing calcium carbonate [adj CALCAREOUSLY]\n",
  "CALCAREOUSLY": "CALCAREOUS, chalky; of or containing calcium carbonate [adv]\n",
  "CALCARIA": "CALCAR, (Latin) a spur-like projection [n]\n",
  "CALCARIFEROUS": "having or bearing spurs [adj]\n",
  "CALCARIFORM": "spur-shaped [adj]\n",
  "CALCARINE": "pertaining to, or situated near, the calcar of the brain [adj]\n",
  "CALCARS": "CALCAR, (Latin) a spur-like projection [n]\n",
  "CALCEAMENTA": "CALCEAMENTUM, (Latin) a red silk embroidered sandal forming part of the insignia of the Holy Roman Empire [n]\n",
  "CALCEAMENTUM": "(Latin) a red silk embroidered sandal forming part of the insignia of the Holy Roman Empire [n CALCEAMENTA]\n",
  "CALCEATE": "to shoe [v CALCEATED, CALCEATING, CALCEATES]\n",
  "CALCEATED": "CALCEATE, to shoe [v]\n",
  "CALCEATES": "CALCEATE, to shoe [v]\n",
  "CALCEATING": "CALCEATE, to shoe [v]\n",
  "CALCED": "wearing shoes, esp. of religious orders, as opposed to discalced [adj]\n",
  "CALCEDONIES": "CALCEDONY, a form of quartz, microscopically fibrous with waxy luster, also CHALCEDONY [n]\n",
  "CALCEDONIO": "a type of Venetian coloured glass resembling natural stones like chalcedony [n -S]\n",
  "CALCEDONIOS": "CALCEDONIO, a type of Venetian coloured glass resembling natural stones like chalcedony [n]\n",
  "CALCEDONY": "a form of quartz, microscopically fibrous with waxy luster, also CHALCEDONY [n CALCEDONIES]\n",
  "CALCEIFORM": "slipper-shaped [adj]\n",
  "CALCEOLARIA": "any plant of the South American genus Calceolaria, the plants of which are largely cultivated for the beauty of their slipper-like flowers [n -S]\n",
  "CALCEOLARIAS": "CALCEOLARIA, any plant of the South American genus Calceolaria, the plants of which are largely cultivated for the beauty of their slipper-like flowers [n]\n",
  "CALCEOLATE": "slipper-shaped [adj]\n",
  "CALCES": "CALX, (Latin) a mineral residue [n]\n",
  "CALCIC": "pertaining to lime of calcium [adj]\n",
  "CALCICOLE": "a plant thriving on limy soil [n -S]\n",
  "CALCICOLES": "CALCICOLE, a plant thriving on limy soil [n]\n",
  "CALCICOLOUS": "living on chalky soil [adj]\n",
  "CALCIFEROL": "vitamin D2 [n -S]\n",
  "CALCIFEROLS": "CALCIFEROL, vitamin D2 [n]\n",
  "CALCIFEROUS": "bearing lime [adj]\n",
  "CALCIFIC": "containing salts of calcium [adj]\n",
  "CALCIFICATION": "the act of calcifying [n -S]\n",
  "CALCIFICATIONS": "CALCIFICATION, the act of calcifying [n]\n",
  "CALCIFIED": "CALCIFY, to convert into calcium carbonate or other insoluble calcium compounds [v]\n",
  "CALCIFIES": "CALCIFY, to convert into calcium carbonate or other insoluble calcium compounds [v]\n",
  "CALCIFUGAL": "like a calcifuge, a plant that will not tolerate limy soil, also CALCIFUGOUS [adj]\n",
  "CALCIFUGE": "a plant that will not tolerate limy soil [n -S]\n",
  "CALCIFUGES": "CALCIFUGE, a plant that will not tolerate limy soil [n]\n",
  "CALCIFUGOUS": "like a calcifuge, a plant that will not tolerate limy soil, also CALCIFUGAL [adj]\n",
  "CALCIFY": "to convert into calcium carbonate or other insoluble calcium compounds [v CALCIFIED, CALCIFYING, CALCIFIES]\n",
  "CALCIFYING": "CALCIFY, to convert into calcium carbonate or other insoluble calcium compounds [v]\n",
  "CALCIGEROUS": "containing lime [adj]\n",
  "CALCIMINE": "(tradename) a kind of whitewash or colour wash for walls, also KALSOMINE [n -S] / to whitewash with this [v CALCIMINED, CALCIMINING, CALCIMINES]\n",
  "CALCIMINED": "CALCIMINE, to whitewash with this [v]\n",
  "CALCIMINES": "CALCIMINE, to whitewash with this [v]\n",
  "CALCIMINING": "CALCIMINE, to whitewash with this [v]\n",
  "CALCINABLE": "that may be calcined; as, a calcinable fossil [adj]\n",
  "CALCINATION": "the act of calcining [n -S]\n",
  "CALCINATIONS": "CALCINATION, the act of calcining [n]\n",
  "CALCINE": "to reduce to a calx by heating [v CALCINED, CALCINING, CALCINES]\n",
  "CALCINED": "CALCINE, to reduce to a calx by heating [v]\n",
  "CALCINES": "CALCINE, to reduce to a calx by heating [v]\n",
  "CALCINING": "CALCINE, to reduce to a calx by heating [v]\n",
  "CALCINOSES": "CALCINOSIS, the abnormal deposition of calcium salts in the tissues of the body [n]\n",
  "CALCINOSIS": "the abnormal deposition of calcium salts in the tissues of the body [n CALCINOSES]\n",
  "CALCITE": "a mineral, limestone or Iceland spar [n -S]\n",
  "CALCITES": "CALCITE, a mineral, limestone or Iceland spar [n]\n",
  "CALCITIC": "relating to a calcite [adj]\n",
  "CALCITONIN": "a hormone secreted by the thyroid gland, controlling the rate of bone destruction [n -S]\n",
  "CALCITONINS": "CALCITONIN, a hormone secreted by the thyroid gland, controlling the rate of bone destruction [n]\n",
  "CALCIUM": "a metallic element [n -S]\n",
  "CALCIUMS": "CALCIUM, a metallic element [n]\n",
  "CALCRETE": "a composite rock of sand and gravel cemented with calcium carbonate [n -S]\n",
  "CALCRETES": "CALCRETE, a composite rock of sand and gravel cemented with calcium carbonate [n]\n",
  "CALCSINTER": "a pale limestone deposited from solution, aka travertine [n -S]\n",
  "CALCSINTERS": "CALCSINTER, a pale limestone deposited from solution, aka travertine [n]\n",
  "CALCSPAR": "a mineral, calcite [n -S]\n",
  "CALCSPARS": "CALCSPAR, a mineral, calcite [n]\n",
  "CALCTUFA": "a rock made of fine volcanic detritus, also TOPH, TOPHE, TUFA [n -S]\n",
  "CALCTUFAS": "CALCTUFA, a rock made of fine volcanic detritus, also TOPH, TOPHE, TUFA [n]\n",
  "CALCTUFF": "a general term for all consolidated pyroclastic rock, also TUFF [n -S]\n",
  "CALCTUFFS": "CALCTUFF, a general term for all consolidated pyroclastic rock, also TUFF [n]\n",
  "CALCULABILITIES": "CALCULABILITY, the ability to be calculated [n]\n",
  "CALCULABILITY": "the ability to be calculated [n CALCULABILITIES]\n",
  "CALCULABLE": "that can be calculated [adj CALCULABLY]\n",
  "CALCULABLY": "CALCULABLE, that can be calculated [adv]\n",
  "CALCULAR": "relating to the mathematical calculus [adj]\n",
  "CALCULARY": "of or pertaining to calculi, stonelike concretions that form in certain vessels of the body, also CALCULOSE, CALCULOUS [adj]\n",
  "CALCULATE": "to count or reckon [v CALCULATED, CALCULATING, CALCULATES]\n",
  "CALCULATED": "CALCULATE, to count or reckon [v]\n",
  "CALCULATEDLY": "CALCULATED, CALCULATE, to count or reckon [adv]\n",
  "CALCULATEDNESS": "the state of being calculated [n]\n",
  "CALCULATES": "CALCULATE, to count or reckon [v]\n",
  "CALCULATING": "CALCULATE, to count or reckon [v]\n",
  "CALCULATINGLY": "CALCULATING, CALCULATE, to count or reckon [adv]\n",
  "CALCULATION": "the process or an act of calculating [n -S]\n",
  "CALCULATIONAL": "relating to calculation, also CALCULATIVE [adj]\n",
  "CALCULATIONS": "CALCULATION, the process or an act of calculating [n]\n",
  "CALCULATIVE": "relating to calculation, also CALCULATIONAL [adj]\n",
  "CALCULATOR": "one that calculates [n -S]\n",
  "CALCULATORS": "CALCULATOR, one that calculates [n]\n",
  "CALCULI": "CALCULUS, (Latin) a branch of mathematics [n]\n",
  "CALCULOSE": "of or pertaining to calculi, stonelike concretions that form in certain vessels of the body, also CALCULARY, CALCULOUS [adj]\n",
  "CALCULOUS": "of or pertaining to calculi, stonelike concretions that form in certain vessels of the body, also CALCULARY, CALCULOSE [adj]\n",
  "CALCULUS": "(Latin) a branch of mathematics [n CALCULUSES] / a kidney or gall bladder stone [n CALCULI]\n",
  "CALCULUSES": "CALCULUS, (Latin) a branch of mathematics [n]\n",
  "CALDARIA": "CALDARIUM, (Latin) a hot room in a Roman bathhouse [n]\n",
  "CALDARIUM": "(Latin) a hot room in a Roman bathhouse [n CALDARIA]\n",
  "CALDERA": "(Spanish) a large, basin-shaped volcanic depression, more or less circular in form [n -S]\n",
  "CALDERAS": "CALDERA, (Spanish) a large, basin-shaped volcanic depression, more or less circular in form [n]\n",
  "CALDRON": "a large kettle or boiler, also CAULDRON [n -S]\n",
  "CALDRONS": "CALDRON, a large kettle or boiler, also CAULDRON [n]\n",
  "CALECHE": "(French) a light low-wheeled carriage with folding top, also CALASH, CALESA [n -S]\n",
  "CALECHES": "CALECHE, (French) a light low-wheeled carriage with folding top, also CALASH, CALESA [n]\n",
  "CALEFACIENT": "a substance (e.g. mustard) that produces a sensation of warmth when applied to a part of the body [n -S]\n",
  "CALEFACIENTS": "CALEFACIENT, a substance (e.g. mustard) that produces a sensation of warmth when applied to a part of the body [n]\n",
  "CALEFACTION": "the act of heating [n -S]\n",
  "CALEFACTIONS": "CALEFACTION, the act of heating [n]\n",
  "CALEFACTIVE": "communicating heat [adj]\n",
  "CALEFACTOR": "a heater; one who, or that which, makes hot, as a stove, etc. [n -S]\n",
  "CALEFACTORIES": "CALEFACTORY, a monastery sitting room [n]\n",
  "CALEFACTORS": "CALEFACTOR, a heater; one who, or that which, makes hot, as a stove, etc. [n]\n",
  "CALEFACTORY": "a monastery sitting room [n CALEFACTORIES]\n",
  "CALEFIED": "CALEFY, to make warm or hot [v]\n",
  "CALEFIES": "CALEFY, to make warm or hot [v]\n",
  "CALEFY": "to make warm or hot [v CALEFIED, CALEFYING, CALEFIES]\n",
  "CALEFYING": "CALEFY, to make warm or hot [v]\n",
  "CALEMBOUR": "(French) a pun [n -S]\n",
  "CALEMBOURS": "CALEMBOUR, (French) a pun [n]\n",
  "CALENDAL": "pertaining to calends, the first day of the ancient Roman month from which days were counted backwards to the Ides [adj]\n",
  "CALENDAR": "to schedule, also KALENDAR [v -ED, -ING, -S]\n",
  "CALENDARED": "CALENDAR, to schedule, also KALENDAR [v]\n",
  "CALENDARER": "one who makes a calendar, also CALENDERER [n -S]\n",
  "CALENDARERS": "CALENDARER, one who makes a calendar, also CALENDERER [n]\n",
  "CALENDARING": "CALENDAR, to schedule, also KALENDAR [v]\n",
  "CALENDARISATION": "the process of calendarising, also CALENDARIZATION [n]\n",
  "CALENDARISE": "in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARIZE [v CALENDARISED, CALENDARISING, CALENDARISES]\n",
  "CALENDARISED": "CALENDARISE, in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARIZE [v]\n",
  "CALENDARISES": "CALENDARISE, in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARIZE [v]\n",
  "CALENDARISING": "CALENDARISE, in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARIZE [v]\n",
  "CALENDARIST": "one who makes calendars [n -S]\n",
  "CALENDARISTS": "CALENDARIST, one who makes calendars [n]\n",
  "CALENDARIZATION": "the process of calendarizing, also CALENDARISATION [n]\n",
  "CALENDARIZE": "in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARISE [v CALENDARIZED, CALENDARIZING, CALENDARIZES]\n",
  "CALENDARIZED": "CALENDARIZE, in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARISE [v]\n",
  "CALENDARIZES": "CALENDARIZE, in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARISE [v]\n",
  "CALENDARIZING": "CALENDARIZE, in accounting, to divide (something, e.g. a budget) into equal units of time within a year (usually months), also CALENDARISE [v]\n",
  "CALENDARS": "CALENDAR, to schedule, also KALENDAR [v]\n",
  "CALENDER": "to smooth by pressing between rollers [v -ED, -ING, -S]\n",
  "CALENDERED": "CALENDER, to smooth by pressing between rollers [v]\n",
  "CALENDERER": "one who makes a calendar, also CALENDARER [n -S]\n",
  "CALENDERERS": "CALENDERER, one who makes a calendar, also CALENDARER [n]\n",
  "CALENDERING": "pressing paper or cloth with a calender [n -S]\n",
  "CALENDERINGS": "CALENDERING, pressing paper or cloth with a calender [n]\n",
  "CALENDERS": "CALENDER, to smooth by pressing between rollers [v]\n",
  "CALENDRER": "a person who calenders cloth [n -S]\n",
  "CALENDRERS": "CALENDRER, a person who calenders cloth [n]\n",
  "CALENDRIC": "relating to the calendar, also CALENDRICAL [adj]\n",
  "CALENDRICAL": "relating to the calendar, also CALENDRIC [adj]\n",
  "CALENDRIES": "CALENDRY, a place where calendering is done [n]\n",
  "CALENDRY": "a place where calendering is done [n CALENDRIES]\n",
  "CALENDS": "(Latin) the first day of the ancient Roman month from which days were counted backwards to the Ides, also KALENDS [n]\n",
  "CALENDULA": "(Latin) a marigold [n -S]\n",
  "CALENDULAS": "CALENDULA, (Latin) a marigold [n]\n",
  "CALENTURE": "(historical) sunstroke, or other fever or delirium due to heat [n -S]\n",
  "CALENTURES": "CALENTURE, (historical) sunstroke, or other fever or delirium due to heat [n]\n",
  "CALESA": "(French) a light low-wheeled carriage with folding top, also CALASH, CALECHE [n -S]\n",
  "CALESAS": "CALESA, (French) a light low-wheeled carriage with folding top, also CALASH, CALECHE [n]\n",
  "CALESCENCE": "an increase in heat [n -S]\n",
  "CALESCENCES": "CALESCENCE, an increase in heat [n]\n",
  "CALESCENT": "increasing in heat [adj]\n",
  "CALF": "a young cow [n CALVES] / the skin of a calf, calfskin [n -S]\n",
  "CALFDOZER": "a small bulldozer [n -S]\n",
  "CALFDOZERS": "CALFDOZER, a small bulldozer [n]\n",
  "CALFHOOD": "the state or time of being a calf [n -S]\n",
  "CALFHOODS": "CALFHOOD, the state or time of being a calf [n]\n",
  "CALFLESS": "having a thin leg [adj]\n",
  "CALFLICK": "a cowlick (a lock of unruly hair) [n -S]\n",
  "CALFLICKS": "CALFLICK, a cowlick (a lock of unruly hair) [n]\n",
  "CALFLIKE": "like a calf [adj]\n",
  "CALFS": "plural of calf in the sense of a calfskin [n]\n",
  "CALFSKIN": "the skin of a calf [n -S]\n",
  "CALFSKINS": "CALFSKIN, the skin of a calf [n]\n",
  "CALIATOUR": "an old term for a tropical dyewood, perhaps red-sanders, also CALLIATURE [n -S]\n",
  "CALIATOURS": "CALIATOUR, an old term for a tropical dyewood, perhaps red-sanders, also CALLIATURE [n]\n",
  "CALIBER": "the diameter of a gun barrel, also CALIBRE [n -S]\n",
  "CALIBERED": "having a given caliber, also CALIBRED [adj]\n",
  "CALIBERS": "CALIBER, the diameter of a gun barrel, also CALIBRE [n]\n",
  "CALIBRATE": "to determine true values by comparison with an accurate standard [v CALIBRATED, CALIBRATING, CALIBRATES]\n",
  "CALIBRATED": "CALIBRATE, to determine true values by comparison with an accurate standard [v]\n",
  "CALIBRATER": "one who calibrates, also CALIBRATOR [n -S]\n",
  "CALIBRATERS": "CALIBRATER, one who calibrates, also CALIBRATOR [n]\n",
  "CALIBRATES": "CALIBRATE, to determine true values by comparison with an accurate standard [v]\n",
  "CALIBRATING": "CALIBRATE, to determine true values by comparison with an accurate standard [v]\n",
  "CALIBRATION": "the act of calibrating [n -S]\n",
  "CALIBRATIONS": "CALIBRATION, the act of calibrating [n]\n",
  "CALIBRATOR": "one who calibrates, also CALIBRATER [n -S]\n",
  "CALIBRATORS": "CALIBRATOR, one who calibrates, also CALIBRATER [n]\n",
  "CALIBRE": "the diameter of a gun barrel, also CALIBER [n -S]\n",
  "CALIBRED": "having a given calibre, also CALIBERED [adj]\n",
  "CALIBRES": "CALIBRE, the diameter of a gun barrel, also CALIBER [n]\n",
  "CALICES": "CALIX, (Latin) a cup; esp. an ecclesiastical chalice [n]\n",
  "CALICHE": "(Spanish) gravel, sand, or desert debris cemented by calcium carbonate, an accumulated product of chemical weathering in a dry climate [n -S]\n",
  "CALICHES": "CALICHE, (Spanish) gravel, sand, or desert debris cemented by calcium carbonate, an accumulated product of chemical weathering in a dry climate [n]\n",
  "CALICLE": "a cup-shaped anatomical structure [n -S]\n",
  "CALICLES": "CALICLE, a cup-shaped anatomical structure [n]\n",
  "CALICO": "a brightly printed coarse cotton cloth [n CALICOS or CALICOES]\n",
  "CALICOES": "CALICO, a brightly printed coarse cotton cloth [n]\n",
  "CALICOS": "CALICO, a brightly printed coarse cotton cloth [n]\n",
  "CALICULAR": "like a calicle, a row of small bracts at the base of the calyx [adj]\n",
  "CALID": "hot; burning; ardent [adj]\n",
  "CALIDITIES": "CALIDITY, the state of being warm [n]\n",
  "CALIDITY": "the state of being warm [n CALIDITIES]\n",
  "CALIF": "(Arabic) an Eastern ruler, also CALIPH, KALIF, KALIPH, KHALIF [n -S]\n",
  "CALIFATE": "(Arabic) the office of caliph, also CALIPHATE, KALIPHATE, KHALIFAT, KHALIFATE, KHILAFAT [n -S]\n",
  "CALIFATES": "CALIFATE, (Arabic) the office of caliph, also CALIPHATE, KALIPHATE, KHALIFAT, KHALIFATE, KHILAFAT [n]\n",
  "CALIFONT": "(tradename) a kind of gas water heater [n -S]\n",
  "CALIFONTS": "CALIFONT, (tradename) a kind of gas water heater [n]\n",
  "CALIFORNIUM": "a synthetic element produced in trace quantities by helium isotope bombardment of curium [n -S]\n",
  "CALIFORNIUMS": "CALIFORNIUM, a synthetic element produced in trace quantities by helium isotope bombardment of curium [n]\n",
  "CALIFS": "CALIF, (Arabic) an Eastern ruler, also CALIPH, KALIF, KALIPH, KHALIF [n]\n",
  "CALIGINOSITIES": "CALIGINOSITY, darkness, sootiness [n]\n",
  "CALIGINOSITY": "darkness, sootiness [n CALIGINOSITIES]\n",
  "CALIGINOUS": "(archaic) dark, shadowy [adj]\n",
  "CALIGO": "(Latin) a reduction in vision due to a speck on the cornea [n CALIGOS or CALIGOES]\n",
  "CALIGOES": "CALIGO, (Latin) a reduction in vision due to a speck on the cornea [n]\n",
  "CALIGOS": "CALIGO, (Latin) a reduction in vision due to a speck on the cornea [n]\n",
  "CALIMA": "(Spanish) a dust storm or cloud that spreads from the Sahara into southern Europe [n -S]\n",
  "CALIMAS": "CALIMA, (Spanish) a dust storm or cloud that spreads from the Sahara into southern Europe [n]\n",
  "CALIMOCHO": "(Spanish) a cocktail popular in Spanish-speaking countries, consisting of a mixture of cola and red wine [n -S]\n",
  "CALIMOCHOS": "CALIMOCHO, (Spanish) a cocktail popular in Spanish-speaking countries, consisting of a mixture of cola and red wine [n]\n",
  "CALIOLOGIES": "CALIOLOGY, the study of bird's nests [n]\n",
  "CALIOLOGY": "the study of bird's nests [n CALIOLOGIES]\n",
  "CALIPASH": "a part of a turtle which is next to the upper shell, the carapace, also CALLIPASH [n -ES]\n",
  "CALIPASHES": "CALIPASH, a part of a turtle which is next to the upper shell, the carapace, also CALLIPASH [n]\n",
  "CALIPEE": "a part of a turtle which is attached to the lower shell, aka plastron, also CALLIPEE [n -S]\n",
  "CALIPEES": "CALIPEE, a part of a turtle which is attached to the lower shell, aka plastron, also CALLIPEE [n]\n",
  "CALIPER": "in papermaking, a measure of the thickness of a single sheet of paper, also CALLIPER [n -S] / to measure with calipers [v -ED, -ING, -S]\n",
  "CALIPERED": "CALIPER, to measure with calipers [v]\n",
  "CALIPERING": "CALIPER, to measure with calipers [v]\n",
  "CALIPERS": "CALIPER, to measure with calipers [v]\n",
  "CALIPH": "(Arabic) an Eastern ruler, also CALIF, KALIF, KALIPH, KHALIF [n -S]\n",
  "CALIPHAL": "(Arabic) relating to a caliph [adj]\n",
  "CALIPHATE": "(Arabic) the office of caliph, also CALIFATE, KALIPHATE, KHALIFAT, KHALIFATE, KHILAFAT [n -S]\n",
  "CALIPHATES": "CALIPHATE, (Arabic) the office of caliph, also CALIFATE, KALIPHATE, KHALIFAT, KHALIFATE, KHILAFAT [n]\n",
  "CALIPHS": "CALIPH, (Arabic) an Eastern ruler, also CALIF, KALIF, KALIPH, KHALIF [n]\n",
  "CALISAYA": "(Spanish) the medicinal bark of the cinchona [n -S]\n",
  "CALISAYAS": "CALISAYA, (Spanish) the medicinal bark of the cinchona [n]\n",
  "CALISTHENIC": "relating to calisthenics, exercises designed to achieve gracefulness, fitness and strength, also CALLISTHENIC [adj]\n",
  "CALISTHENICS": "exercises designed to achieve gracefulness, fitness and strength, also CALLISTHENICS [n]\n",
  "CALIVER": "(Shakespeare) a type of light musket [n -S]\n",
  "CALIVERS": "CALIVER, (Shakespeare) a type of light musket [n]\n",
  "CALIX": "(Latin) a cup; esp. an ecclesiastical chalice [n CALICES or CALIXES]\n",
  "CALIXES": "CALIX, (Latin) a cup; esp. an ecclesiastical chalice [n]\n",
  "CALK": "to make the seams of a ship watertight, also CAULK [v -ED, -ING, -S]\n",
  "CALKED": "CALK, to make the seams of a ship watertight, also CAULK [v]\n",
  "CALKER": "a pointed piece on a horseshoe to prevent slipping, also CALK, CALKIN, CAWKER [n -S]\n",
  "CALKERS": "CALKER, a pointed piece on a horseshoe to prevent slipping, also CALK, CALKIN, CAWKER [n]\n",
  "CALKIN": "a pointed piece on a horseshoe to prevent slipping, also CALK, CALKER, CAWKER [n -S]\n",
  "CALKING": "material used to calk [n -S]\n",
  "CALKINGS": "CALKING, material used to calk [n]\n",
  "CALKINS": "CALKIN, a pointed piece on a horseshoe to prevent slipping, also CALK, CALKER, CAWKER [n]\n",
  "CALKS": "CALK, to make the seams of a ship watertight, also CAULK [v]\n",
  "CALL": "to summon [v -ED, -ING, -S]\n",
  "CALLA": "any of a genus of tropical plants [n -S]\n",
  "CALLABLE": "able to be called [adj]\n",
  "CALLAIDES": "CALLAIS, (Greek) a green stone bead ornament from the late Neolithic or early Bronze Age [n]\n",
  "CALLAIS": "(Greek) a green stone bead ornament from the late Neolithic or early Bronze Age [n CALLAIDES]\n",
  "CALLALOO": "(Caribbean) a soup made with greens, onions and crabmeat, also CALALOO, CALALU, CALLALOU [n -S]\n",
  "CALLALOOS": "CALLALOO, (Caribbean) a soup made with greens, onions and crabmeat, also CALALOO, CALALU, CALLALOU [n]\n",
  "CALLALOU": "(Caribbean) a crabmeat soup, also CALALOO, CALALU, CALLALOO [n -S]\n",
  "CALLALOUS": "CALLALOU, (Caribbean) a crabmeat soup, also CALALOO, CALALU, CALLALOO [n]\n",
  "CALLAN": "(Scots) a boy, a fellow, also CALLANT [n -S]\n",
  "CALLANS": "CALLAN, (Scots) a boy, a fellow, also CALLANT [n]\n",
  "CALLANT": "(Scots) a boy, a fellow, also CALLAN [n -S]\n",
  "CALLANTS": "CALLANT, (Scots) a boy, a fellow, also CALLAN [n]\n",
  "CALLAS": "CALLA, any of a genus of tropical plants [n]\n",
  "CALLBACK": "a recall of a defective product [n -S]\n",
  "CALLBACKS": "CALLBACK, a recall of a defective product [n]\n",
  "CALLBOARD": "a noticeboard listing opportunities for performers [n -S]\n",
  "CALLBOARDS": "CALLBOARD, a noticeboard listing opportunities for performers [n]\n",
  "CALLBOY": "a boy who calls actors when they are required on stage [n -S]\n",
  "CALLBOYS": "CALLBOY, a boy who calls actors when they are required on stage [n]\n",
  "CALLED": "CALL, to summon [v]\n",
  "CALLEE": "a computer function being used [n -S]\n",
  "CALLEES": "CALLEE, a computer function being used [n]\n",
  "CALLER": "one that calls [n -S]\n",
  "CALLERS": "CALLER, one that calls [n]\n",
  "CALLET": "(Shakespeare) a drab untidy woman [n -S]\n",
  "CALLETS": "CALLET, (Shakespeare) a drab untidy woman [n]\n",
  "CALLIATURE": "an old term for a tropical dyewood, perhaps red-sanders, also CALIATOUR [n -S]\n",
  "CALLIATURES": "CALLIATURE, an old term for a tropical dyewood, perhaps red-sanders, also CALIATOUR [n]\n",
  "CALLID": "cunning, shrewd [adj]\n",
  "CALLIDITIES": "CALLIDITY, shrewdness [n]\n",
  "CALLIDITY": "shrewdness [n CALLIDITIES]\n",
  "CALLIGRAM": "a design using the letters of a word, also CALLIGRAMME [n -S]\n",
  "CALLIGRAMME": "a design using the letters of a word, also CALLIGRAM [n -S]\n",
  "CALLIGRAMMES": "CALLIGRAMME, a design using the letters of a word, also CALLIGRAM [n]\n",
  "CALLIGRAMS": "CALLIGRAM, a design using the letters of a word, also CALLIGRAMME [n]\n",
  "CALLIGRAPHER": "a professional copyist or engrosser, also CALLIGRAPHIST [n -S]\n",
  "CALLIGRAPHERS": "CALLIGRAPHER, a professional copyist or engrosser, also CALLIGRAPHIST [n]\n",
  "CALLIGRAPHIC": "relating to calligraphy, also CALLIGRAPHICAL [adj]\n",
  "CALLIGRAPHICAL": "relating to calligraphy, also CALLIGRAPHIC [adj]\n",
  "CALLIGRAPHIES": "CALLIGRAPHY, artistic, stylized, or elegant handwriting or lettering [n]\n",
  "CALLIGRAPHIST": "a professional copyist or engrosser, also CALLIGRAPHER [n -S]\n",
  "CALLIGRAPHISTS": "CALLIGRAPHIST, a professional copyist or engrosser, also CALLIGRAPHER [n]\n",
  "CALLIGRAPHY": "artistic, stylized, or elegant handwriting or lettering [n CALLIGRAPHIES]\n",
  "CALLING": "a vocation or profession [n -S]\n",
  "CALLINGS": "CALLING, a vocation or profession [n]\n",
  "CALLIOPE": "(Greek) a keyboard musical instrument [n -S]\n",
  "CALLIOPES": "CALLIOPE, (Greek) a keyboard musical instrument [n]\n",
  "CALLIOPSIS": "a genus of herbaceous composite plants, mostly America [n CALLIOPSIS]\n",
  "CALLIPASH": "a part of a turtle which is next to the upper shell, also CALIPASH [n -ES]\n",
  "CALLIPASHES": "CALLIPASH, a part of a turtle which is next to the upper shell, also CALIPASH [n]\n",
  "CALLIPEE": "a part of a turtle which is attached to the lower shell, aka plastron, also CALIPEE [n -S]\n",
  "CALLIPEES": "CALLIPEE, a part of a turtle which is attached to the lower shell, aka plastron, also CALIPEE [n]\n",
  "CALLIPER": "in papermaking, a measure of the thickness of a single sheet of paper, also CALIPER [n -S] / to measure with callipers [v -ED, -ING, -S]\n",
  "CALLIPERED": "CALLIPER, to measure with callipers [v]\n",
  "CALLIPERING": "CALLIPER, to measure with callipers [v]\n",
  "CALLIPERS": "CALLIPER, to measure with callipers [v]\n",
  "CALLIPYGEAN": "having beautiful buttocks, also CALLIPYGIAN, CALLIPYGOUS [adj]\n",
  "CALLIPYGIAN": "having beautiful buttocks, also CALLIPYGEAN, CALLIPYGOUS [adj]\n",
  "CALLIPYGOUS": "having beautiful buttocks, also CALLIPYGEAN, CALLIPYGIAN [adj]\n",
  "CALLISTEMON": "an Australian genus of the myrtle family, bottlebrush shrubs [n -S]\n",
  "CALLISTEMONS": "CALLISTEMON, an Australian genus of the myrtle family, bottlebrush shrubs [n]\n",
  "CALLISTHENIC": "relating to callisthenics, exercises designed to achieve gracefulness, fitness and strength, also CALISTHENIC [adj]\n",
  "CALLISTHENICS": "exercises designed to achieve gracefulness, fitness and strength, also CALISTHENICS [n]\n",
  "CALLITHUMP": "a noisy, boisterous parade [n -S]\n",
  "CALLITHUMPIAN": "relating to the sounds of a callithump, a noisy, boisterous parade [adj]\n",
  "CALLITHUMPS": "CALLITHUMP, a noisy, boisterous parade [n]\n",
  "CALLOP": "(Native Australian) an Australian edible freshwater fish [n -S]\n",
  "CALLOPS": "CALLOP, (Native Australian) an Australian edible freshwater fish [n]\n",
  "CALLOSE": "a part of a plant cell wall [n -S]\n",
  "CALLOSES": "CALLOSE, a part of a plant cell wall [n]\n",
  "CALLOSITIES": "CALLOSITY, a hardening and thickening of the skin or bark, esp. as a result of continued pressure or friction [n]\n",
  "CALLOSITY": "a hardening and thickening of the skin or bark, esp. as a result of continued pressure or friction [n CALLOSITIES]\n",
  "CALLOUS": "unfeeling [adj CALLOUSLY] / to make or become hard [v -ED, -ING, -ES]\n",
  "CALLOUSED": "CALLOUS, to make or become hard [v]\n",
  "CALLOUSES": "CALLOUS, to make or become hard [v]\n",
  "CALLOUSING": "CALLOUS, to make or become hard [v]\n",
  "CALLOUSLY": "CALLOUS, unfeeling [adv]\n",
  "CALLOUSNESS": "the state of being callous [n -ES]\n",
  "CALLOUSNESSES": "CALLOUSNESS, the state of being callous [n]\n",
  "CALLOUT": "an inset in a printed article [n -S]\n",
  "CALLOUTS": "CALLOUT, an inset in a printed article [n]\n",
  "CALLOW": "immature [adj CALLOWER, CALLOWEST, CALLOWLY] / an alluvial flat [n -S]\n",
  "CALLOWER": "CALLOW, immature [adj]\n",
  "CALLOWEST": "CALLOW, immature [adj]\n",
  "CALLOWLY": "CALLOW, immature [adv]\n",
  "CALLOWNESS": "the state of being callow [n -ES]\n",
  "CALLOWNESSES": "CALLOWNESS, the state of being callow [n]\n",
  "CALLOWS": "CALLOW, an alluvial flat [n]\n",
  "CALLS": "CALL, to summon [v]\n",
  "CALLTIME": "time available for use in making calls on a mobile phone; the time used on a single phone call [n -S]\n",
  "CALLTIMES": "CALLTIME, time available for use in making calls on a mobile phone; the time used on a single phone call [n]\n",
  "CALLUNA": "(Greek) any plant of the ling genus [n -S]\n",
  "CALLUNAS": "CALLUNA, (Greek) any plant of the ling genus [n]\n",
  "CALLUS": "to form a hard growth [v -ED, -ING, -ES]\n",
  "CALLUSED": "CALLUS, to form a hard growth [v]\n",
  "CALLUSES": "CALLUS, to form a hard growth [v]\n",
  "CALLUSING": "CALLUS, to form a hard growth [v]\n",
  "CALM": "to become not agitated [v -ED, -ING, -S] / free from agitation [adj CALMER, CALMEST, CALMLY]\n",
  "CALMANT": "a drug that calms [n -S]\n",
  "CALMANTS": "CALMANT, a drug that calms [n]\n",
  "CALMATIVE": "having a calming effect [adj] / a drug having a calming effect [n -S]\n",
  "CALMATIVES": "CALMATIVE, a drug having a calming effect [n]\n",
  "CALMED": "CALM, to become not agitated [v]\n",
  "CALMER": "CALM, free from agitation [adj]\n",
  "CALMEST": "CALM, free from agitation [adj]\n",
  "CALMIER": "CALMY, clayey [adj]\n",
  "CALMIEST": "CALMY, clayey [adj]\n",
  "CALMING": "effecting calm [adj CALMINGLY] / an act of calming [n -S]\n",
  "CALMINGLY": "in a way which calms [adv]\n",
  "CALMINGS": "CALMING, an act of calming [n]\n",
  "CALMLY": "CALM, free from agitation [adv]\n",
  "CALMNESS": "the state of being calm [n -ES]\n",
  "CALMNESSES": "CALMNESS, the state of being calm [n]\n",
  "CALMODULIN": "a protein found in plant and animal cells [n -S]\n",
  "CALMODULINS": "CALMODULIN, a protein found in plant and animal cells [n]\n",
  "CALMS": "CALM, to become not agitated [v]\n",
  "CALMSTANE": "a white argillaceous stone used for whitening hearthstones and doorsteps [n -S]\n",
  "CALMSTANES": "CALMSTANE, a white argillaceous stone used for whitening hearthstones and doorsteps [n]\n",
  "CALMSTONE": "(Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CAMSTANE, CAMSTONE, CAUMSTANE, CAUMSTONE [n -S]\n",
  "CALMSTONES": "CALMSTONE, (Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CAMSTANE, CAMSTONE, CAUMSTANE, CAUMSTONE [n]\n",
  "CALMY": "clayey [adj CALMIER, CALMIEST]\n",
  "CALO": "A non-combatant servant to a soldier in the Roman army [n -S]\n",
  "CALOMEL": "a strong purgative, a compound of mercury, acting on the liver [n -S]\n",
  "CALOMELS": "CALOMEL, a strong purgative, a compound of mercury, acting on the liver [n]\n",
  "CALORESCENCE": "the transmutation of heat rays into luminous rays [n -S]\n",
  "CALORESCENCES": "CALORESCENCE, the transmutation of heat rays into luminous rays [n]\n",
  "CALORESCENT": "relating to calorescence [adj]\n",
  "CALORIC": "related to heat [adj CALORICALLY] / a hypothetical fluid formerly thought to be responsible for the phenomena of heat [n -S]\n",
  "CALORICALLY": "CALORIC, related to heat [adv]\n",
  "CALORICITIES": "CALORICITY, a faculty in animals of developing and preserving the heat necessary to life [n]\n",
  "CALORICITY": "a faculty in animals of developing and preserving the heat necessary to life [n CALORICITIES]\n",
  "CALORICS": "CALORIC, a hypothetical fluid formerly thought to be responsible for the phenomena of heat [n]\n",
  "CALORIE": "the amount of heat needed to raise one gram of water one degree Centigrade in temperature, also CALORY [n -S]\n",
  "CALORIES": "CALORIE, the amount of heat needed to raise one gram of water one degree Centigrade in temperature, also CALORY [n]\n",
  "CALORIFIC": "of, pertaining to, or causing heat [adj CALORIFICALLY]\n",
  "CALORIFICALLY": "CALORIFIC, of, pertaining to, or causing heat [adv]\n",
  "CALORIFICATION": "the process of supplying heat to something [n -S]\n",
  "CALORIFICATIONS": "CALORIFICATION, the process of supplying heat to something [n]\n",
  "CALORIFIER": "an apparatus for heating water in a tank [n -S]\n",
  "CALORIFIERS": "CALORIFIER, an apparatus for heating water in a tank [n]\n",
  "CALORIMETER": "an instrument for measuring absorbed or evolved heat [n -S]\n",
  "CALORIMETERS": "CALORIMETER, an instrument for measuring absorbed or evolved heat [n]\n",
  "CALORIMETRIC": "relating to calorimetry, the measurement of heat, also CALORIMETRICAL [adj]\n",
  "CALORIMETRICAL": "relating to calorimetry, the measurement of heat, also CALORIMETRIC [adj]\n",
  "CALORIMETRIES": "CALORIMETRY, the measurement of heat [n]\n",
  "CALORIMETRY": "the measurement of heat [n CALORIMETRIES]\n",
  "CALORISE": "to coat steel with aluminum, also CALORIZE [v CALORISED, CALORISING, CALORISES]\n",
  "CALORISED": "CALORISE, to coat steel with aluminum, also CALORIZE [v]\n",
  "CALORISES": "CALORISE, to coat steel with aluminum, also CALORIZE [v]\n",
  "CALORISING": "CALORISE, to coat steel with aluminum, also CALORIZE [v]\n",
  "CALORIST": "a person who believes in the caloric theory [n -S]\n",
  "CALORISTS": "CALORIST, a person who believes in the caloric theory [n]\n",
  "CALORIZE": "to coat steel with aluminum, also CALORISE [v CALORIZED, CALORIZING, CALORIZES]\n",
  "CALORIZED": "CALORIZE, to coat steel with aluminum, also CALORISE [v]\n",
  "CALORIZES": "CALORIZE, to coat steel with aluminum, also CALORISE [v]\n",
  "CALORIZING": "CALORIZE, to coat steel with aluminum, also CALORISE [v]\n",
  "CALORY": "the amount of heat needed to raise one gram of water one degree Centigrade in temperature, also CALORIE [n CALORIES]\n",
  "CALOS": "CALO, A non-combatant servant to a soldier in the Roman army [n]\n",
  "CALOTTE": "(French) a Roman Catholic skullcap [n -S]\n",
  "CALOTTES": "CALOTTE, (French) a Roman Catholic skullcap [n]\n",
  "CALOTYPE": "(tradename) an early type of photography, also KALOTYPE [n -S]\n",
  "CALOTYPES": "CALOTYPE, (tradename) an early type of photography, also KALOTYPE [n]\n",
  "CALOTYPIST": "one who works with calotypes, an early kind of photograph [n -S]\n",
  "CALOTYPISTS": "CALOTYPIST, one who works with calotypes, an early kind of photograph [n]\n",
  "CALOYER": "(French) a Greek Orthodox monk, esp. of the order of St Basil [n -S]\n",
  "CALOYERS": "CALOYER, (French) a Greek Orthodox monk, esp. of the order of St Basil [n]\n",
  "CALP": "in Ireland, a dark shaly limestone [n -S]\n",
  "CALPA": "(Sanskrit) one of the Brahmanic eons, a period of 4,320,000,000 years, also KALPA [n -S]\n",
  "CALPAC": "(Turkish) a triangular Turkish or Tatar felt cap, also CALPACK, KALPAC [n -S]\n",
  "CALPACK": "(Turkish) a triangular Turkish or Tatar felt cap, also CALPAC, KALPAC [n -S]\n",
  "CALPACKS": "CALPACK, (Turkish) a triangular Turkish or Tatar felt cap, also CALPAC, KALPAC [n]\n",
  "CALPACS": "CALPAC, (Turkish) a triangular Turkish or Tatar felt cap, also CALPACK, KALPAC [n]\n",
  "CALPAIN": "an enzyme for digesting proteins [n -S]\n",
  "CALPAINS": "CALPAIN, an enzyme for digesting proteins [n]\n",
  "CALPAS": "CALPA, (Sanskrit) one of the Brahmanic eons, a period of 4,320,000,000 years, also KALPA [n]\n",
  "CALPS": "CALP, in Ireland, a dark shaly limestone [n]\n",
  "CALQUE": "to process the tracing of a design [v CALQUED, CALQUING, CALQUES]\n",
  "CALQUED": "CALQUE, to process the tracing of a design [v]\n",
  "CALQUES": "CALQUE, to process the tracing of a design [v]\n",
  "CALQUING": "CALQUE, to process the tracing of a design [v]\n",
  "CALS": "CAL, (short for) calorie, as in low cal [n]\n",
  "CALTHA": "(Latin) a genus of plants including the marsh marigold [n -S]\n",
  "CALTHAS": "CALTHA, (Latin) a genus of plants including the marsh marigold [n]\n",
  "CALTHROP": "a device with four metal points so arranged so that one points upward as a hazard, also CALTRAP, CALTROP [n -S]\n",
  "CALTHROPS": "CALTHROP, a device with four metal points so arranged so that one points upward as a hazard, also CALTRAP, CALTROP [n]\n",
  "CALTRAP": "a device with four metal points so arranged so that one points upward as a hazard, also CALTHROP, CALTROP [n -S]\n",
  "CALTRAPS": "CALTRAP, a device with four metal points so arranged so that one points upward as a hazard, also CALTHROP, CALTROP [n]\n",
  "CALTROP": "a device with four metal points so arranged so that one points upward as a hazard, also CALTHROP, CALTRAP [n -S]\n",
  "CALTROPS": "CALTROP, a device with four metal points so arranged so that one points upward as a hazard, also CALTHROP, CALTRAP [n]\n",
  "CALUMBA": "the dried root of a tree native to East Africa and Madagascar, used as a bitter tonic [n -S]\n",
  "CALUMBAS": "CALUMBA, the dried root of a tree native to East Africa and Madagascar, used as a bitter tonic [n]\n",
  "CALUMET": "(Canadian) an ornamented ceremonial pipe [n -S]\n",
  "CALUMETS": "CALUMET, (Canadian) an ornamented ceremonial pipe [n]\n",
  "CALUMNIABLE": "worthy of being calumniated [adj]\n",
  "CALUMNIATE": "to slander; misrepresent; besmirch [v CALUMNIATED, CALUMNIATING, CALUMNIATES]\n",
  "CALUMNIATED": "CALUMNIATE, to slander; misrepresent; besmirch [v]\n",
  "CALUMNIATES": "CALUMNIATE, to slander; misrepresent; besmirch [v]\n",
  "CALUMNIATING": "CALUMNIATE, to slander; misrepresent; besmirch [v]\n",
  "CALUMNIATION": "slander [n -S]\n",
  "CALUMNIATIONS": "CALUMNIATION, slander [n]\n",
  "CALUMNIATOR": "a slanderer [n -S]\n",
  "CALUMNIATORS": "CALUMNIATOR, a slanderer [n]\n",
  "CALUMNIATORY": "of the nature of calumny [adj]\n",
  "CALUMNIED": "CALUMNY, to utter false charges calculated to damage another's reputation [v]\n",
  "CALUMNIES": "CALUMNY, to utter false charges calculated to damage another's reputation [v]\n",
  "CALUMNIOUS": "containing or implying calumny; as, calumnious reports [adj CALUMNIOUSLY]\n",
  "CALUMNIOUSLY": "CALUMNIOUS, containing or implying calumny; as, calumnious reports [adv]\n",
  "CALUMNY": "to utter false charges calculated to damage another's reputation [v CALUMNIED, CALUMNYING, CALUMNIES]\n",
  "CALUMNYING": "CALUMNY, to utter false charges calculated to damage another's reputation [v]\n",
  "CALUTRON": "a mass spectrometer used in the separation of isotopes [n -S]\n",
  "CALUTRONS": "CALUTRON, a mass spectrometer used in the separation of isotopes [n]\n",
  "CALVADOS": "(French) a dry apple brandy [n -ES]\n",
  "CALVADOSES": "CALVADOS, (French) a dry apple brandy [n]\n",
  "CALVARIA": "the upper part of the skull enclosing the brain in vertebrates, also CALVARIUM [n CALVARIAE or CALVARIAS]\n",
  "CALVARIAE": "CALVARIA, the upper part of the skull enclosing the brain in vertebrates, also CALVARIUM [n]\n",
  "CALVARIAL": "relating to the calvarium, the upper skull, also CALVARIAN [adj]\n",
  "CALVARIAN": "relating to the calvarium, the upper skull, also CALVARIAL [adj]\n",
  "CALVARIAS": "CALVARIA, the upper part of the skull enclosing the brain in vertebrates, also CALVARIUM [n]\n",
  "CALVARIES": "CALVARY, a place or occasion of severe trial, anguish, or suffering [n]\n",
  "CALVARIUM": "(Latin) the dome of the skull [n CALVARIUMS or CALVARIA]\n",
  "CALVARIUMS": "CALVARIUM, (Latin) the dome of the skull [n]\n",
  "CALVARY": "a place or occasion of severe trial, anguish, or suffering [n CALVARIES]\n",
  "CALVE": "to give birth to a calf [v CALVED, CALVING, CALVES]\n",
  "CALVED": "CALVE, to give birth to a calf [v]\n",
  "CALVER": "to prepare fish while alive or freshly caught [v -ED, -ING, -S]\n",
  "CALVERED": "CALVER, to prepare fish while alive or freshly caught [v]\n",
  "CALVERING": "CALVER, to prepare fish while alive or freshly caught [v]\n",
  "CALVERS": "CALVER, to prepare fish while alive or freshly caught [v]\n",
  "CALVES": "CALVE, to give birth to a calf [v]\n",
  "CALVING": "CALVE, to give birth to a calf [v]\n",
  "CALVITIES": "(Latin) baldness [n CALVITIES]\n",
  "CALX": "(Latin) a mineral residue [n CALXES or CALCES]\n",
  "CALXES": "CALX, (Latin) a mineral residue [n]\n",
  "CALYCANTHEMIES": "CALYCANTHEMY, the condition of having the calyx like a corolla [n]\n",
  "CALYCANTHEMY": "the condition of having the calyx like a corolla [n CALYCANTHEMIES]\n",
  "CALYCANTHUS": "the Carolina allspice or strawberry shrub, a North American shrub [n -ES]\n",
  "CALYCANTHUSES": "CALYCANTHUS, the Carolina allspice or strawberry shrub, a North American shrub [n]\n",
  "CALYCATE": "pertaining to a calyx, also CALYCEAL, CALYCINE [adj]\n",
  "CALYCEAL": "pertaining to a calyx, also CALYCATE, CALYCINE [adj]\n",
  "CALYCES": "CALYX, (Greek) the outer protective covering of a flower [n]\n",
  "CALYCIFORM": "having the form or appearance of a calyx [adj]\n",
  "CALYCINAL": "of or pertaining to a cup or calyx, also CALYCATE, CALYCEAL, CALYCINE [adj]\n",
  "CALYCINE": "of or pertaining to a cup or calyx, also CALYCATE, CALYCEAL, CALYCINAL [adj]\n",
  "CALYCLE": "a row of small bracts, at the base of the calyx, on the outside, also CALICLE, CALYCULE [n -S]\n",
  "CALYCLED": "having a calycle, a row of small bracts, at the base of the calyx, on the outside [adj]\n",
  "CALYCLES": "CALYCLE, a row of small bracts, at the base of the calyx, on the outside, also CALICLE, CALYCULE [n]\n",
  "CALYCOID": "like a calix [adj]\n",
  "CALYCOIDEOUS": "calyx-shaped, also CALYCOID [adj]\n",
  "CALYCULAR": "of or like a calycule, a row of small bracts at the base of the calyx [adj]\n",
  "CALYCULATE": "having a calyculus, a cuplike structure [adj]\n",
  "CALYCULE": "a cuplike structure [n -S]\n",
  "CALYCULES": "CALYCULE, a cuplike structure [n]\n",
  "CALYCULI": "CALYCULUS, a small, cup-shaped structure [n]\n",
  "CALYCULUS": "a small, cup-shaped structure [n CALYCULI]\n",
  "CALYPSO": "a West Indian ballad dealing with topical events [n CALYPSOS or CALYPSOES]\n",
  "CALYPSOES": "CALYPSO, a West Indian ballad dealing with topical events [n]\n",
  "CALYPSONIAN": "a writer or singer of calypsos [n -S]\n",
  "CALYPSONIANS": "CALYPSONIAN, a writer or singer of calypsos [n]\n",
  "CALYPSOS": "CALYPSO, a West Indian ballad dealing with topical events [n]\n",
  "CALYPTER": "a hood or hoodlike structure, esp. that covering the spore capsule of mosses and liverworts, also CALYPTERA, CALYPTRA [n -S]\n",
  "CALYPTERA": "a hood or hoodlike structure, esp. that covering the spore capsule of mosses and liverworts, also CALYPTER, CALYPTRA [n -S]\n",
  "CALYPTERAS": "CALYPTERA, a hood or hoodlike structure, esp. that covering the spore capsule of mosses and liverworts, also CALYPTER, CALYPTRA [n]\n",
  "CALYPTERS": "CALYPTER, a hood or hoodlike structure, esp. that covering the spore capsule of mosses and liverworts, also CALYPTERA, CALYPTRA [n]\n",
  "CALYPTRA": "a hood or hoodlike structure, esp. that covering the spore capsule of mosses and liverworts, also CALYPTER, CALYPTERA [n -S]\n",
  "CALYPTRAS": "CALYPTRA, a hood or hoodlike structure, esp. that covering the spore capsule of mosses and liverworts, also CALYPTER, CALYPTERA [n]\n",
  "CALYPTRATE": "capped or hooded [adj]\n",
  "CALYPTROGEN": "the layer of cells on the growing tip of a root giving rise to the root cap [n -S]\n",
  "CALYPTROGENS": "CALYPTROGEN, the layer of cells on the growing tip of a root giving rise to the root cap [n]\n",
  "CALYX": "(Greek) the outer protective covering of a flower [n CALYXES or CALYCES]\n",
  "CALYXES": "CALYX, (Greek) the outer protective covering of a flower [n]\n",
  "CALZONE": "(Italian) a turnover with a savory filling [n CALZONES or CALZONI]\n",
  "CALZONES": "CALZONE, (Italian) a turnover with a savory filling [n]\n",
  "CALZONI": "CALZONE, (Italian) a turnover with a savory filling [n]\n",
  "CAM": "to whiten with camstone, also CAUM [v CAMMED, CAMMING, CAMS]\n",
  "CAMA": "the hybrid offspring of a camel and a llama [n -S]\n",
  "CAMAIEU": "(French) a cameo [n CAMAIEUX]\n",
  "CAMAIEUX": "CAMAIEU, (French) a cameo [n]\n",
  "CAMAIL": "a neck guard of chain mall, hanging from the bassinet or other headpiece [n -S]\n",
  "CAMAILED": "having a camail [adj]\n",
  "CAMAILS": "CAMAIL, a neck guard of chain mall, hanging from the bassinet or other headpiece [n]\n",
  "CAMAN": "(Gaelic) a club used in the game of shinty [n -S]\n",
  "CAMANACHD": "(Gaelic) the game of shinty [n -S]\n",
  "CAMANACHDS": "CAMANACHD, (Gaelic) the game of shinty [n]\n",
  "CAMANS": "CAMAN, (Gaelic) a club used in the game of shinty [n]\n",
  "CAMARADERIE": "(French) friendship [n -S]\n",
  "CAMARADERIES": "CAMARADERIE, (French) friendship [n]\n",
  "CAMARILLA": "(Spanish) a group of unofficial often secret and scheming advisors; a cabal [n -S]\n",
  "CAMARILLAS": "CAMARILLA, (Spanish) a group of unofficial often secret and scheming advisors; a cabal [n]\n",
  "CAMARON": "(Spanish) a kind of freshwater crustacean similar to a crayfish, also MARON, MARRON [n -S]\n",
  "CAMARONS": "CAMARON, (Spanish) a kind of freshwater crustacean similar to a crayfish, also MARON, MARRON [n]\n",
  "CAMAS": "(Native American) a blue-flowered liliaceous plant of northwestern America, also CAMASH, CAMASS, QUAMASH [n -ES]\n",
  "CAMASES": "CAMAS, (Native American) a blue-flowered liliaceous plant of northwestern America, also CAMASH, CAMASS, QUAMASH [n]\n",
  "CAMASH": "(Native American) a blue-flowered liliaceous plant of northwestern America, also CAMAS, CAMASS, QUAMASH [n -ES]\n",
  "CAMASHES": "CAMASH, (Native American) a blue-flowered liliaceous plant of northwestern America, also CAMAS, CAMASS, QUAMASH [n]\n",
  "CAMASS": "(Native American) a blue-flowered liliaceous plant of northwestern America, also CAMAS, CAMASH, QUAMASH [n -ES]\n",
  "CAMASSES": "CAMASS, (Native American) a blue-flowered liliaceous plant of northwestern America, also CAMAS, CAMASH, QUAMASH [n]\n",
  "CAMBER": "to arch slightly [v -ED, -ING, -S]\n",
  "CAMBERED": "CAMBER, to arch slightly [v]\n",
  "CAMBERING": "a type of rock-folding that forms rounded hills [n -S]\n",
  "CAMBERINGS": "CAMBERING, a type of rock-folding that forms rounded hills [n]\n",
  "CAMBERS": "CAMBER, to arch slightly [v]\n",
  "CAMBIA": "CAMBIUM, a layer of plant tissue [n]\n",
  "CAMBIAL": "of or like cambium, soft tissue found in trees [adj]\n",
  "CAMBIFORM": "shaped like cambium, soft tissue found in trees [adj]\n",
  "CAMBISM": "the theory and practice of exchange in commerce [n -S]\n",
  "CAMBISMS": "CAMBISM, the theory and practice of exchange in commerce [n]\n",
  "CAMBIST": "a dealer in bills of exchange [n -S]\n",
  "CAMBISTRIES": "CAMBISTRY, the science of financial exchange, also CAMBISM [n]\n",
  "CAMBISTRY": "the science of financial exchange, also CAMBISM [n CAMBISTRIES]\n",
  "CAMBISTS": "CAMBIST, a dealer in bills of exchange [n]\n",
  "CAMBIUM": "a layer of plant tissue [n CAMBIUMS or CAMBIA]\n",
  "CAMBIUMS": "CAMBIUM, a layer of plant tissue [n]\n",
  "CAMBOGE": "a yellow gum resin, also CAMBOGIA [n -S]\n",
  "CAMBOGES": "CAMBOGE, a yellow gum resin, also CAMBOGIA [n]\n",
  "CAMBOGIA": "a yellow gum resin, also CAMBOGE [n -S]\n",
  "CAMBOGIAS": "CAMBOGIA, a yellow gum resin, also CAMBOGE [n]\n",
  "CAMBOOSE": "(Canadian) a cabin built as living-quarters for a gang of lumbermen [n -S]\n",
  "CAMBOOSES": "CAMBOOSE, (Canadian) a cabin built as living-quarters for a gang of lumbermen [n]\n",
  "CAMBREL": "the hock of a horse [n -S]\n",
  "CAMBRELS": "CAMBREL, the hock of a horse [n]\n",
  "CAMBRIC": "a fine linen [n -S]\n",
  "CAMBRICS": "CAMBRIC, a fine linen [n]\n",
  "CAMCORD": "to videotape with a portable camcorder [v -ED, -ING, -S]\n",
  "CAMCORDED": "CAMCORD, to videotape with a portable camcorder [v]\n",
  "CAMCORDER": "a portable video camera and sound recorder combined in one unit [n -S]\n",
  "CAMCORDERS": "CAMCORDER, a portable video camera and sound recorder combined in one unit [n]\n",
  "CAMCORDING": "CAMCORD, to videotape with a portable camcorder [v]\n",
  "CAMCORDS": "CAMCORD, to videotape with a portable camcorder [v]\n",
  "CAME": "a lead rod for framing a pane in a leaded or stained glass window [n -S]\n",
  "CAMEL": "a large, humped mammal [n -S]\n",
  "CAMELBACK": "an inferior grade of rubber, used for retreading tyres [n -S]\n",
  "CAMELBACKS": "CAMELBACK, an inferior grade of rubber, used for retreading tyres [n]\n",
  "CAMELEER": "a camel driver [n -S]\n",
  "CAMELEERS": "CAMELEER, a camel driver [n]\n",
  "CAMELEON": "a small African lizard with a prehensile tail and tongue, also CHAMAELEON, CHAMELEON [n -S]\n",
  "CAMELEONS": "CAMELEON, a small African lizard with a prehensile tail and tongue, also CHAMAELEON, CHAMELEON [n]\n",
  "CAMELEOPARD": "(obsolete) a giraffe, also CAMELOPARD [n -S]\n",
  "CAMELEOPARDS": "CAMELEOPARD, (obsolete) a giraffe, also CAMELOPARD [n]\n",
  "CAMELHAIR": "a material made from the hair of the camel [n -S]\n",
  "CAMELHAIRS": "CAMELHAIR, a material made from the hair of the camel [n]\n",
  "CAMELIA": "an evergreen shrub, also CAMELLIA [n -S]\n",
  "CAMELIAS": "CAMELIA, an evergreen shrub, also CAMELLIA [n]\n",
  "CAMELID": "an animal of the camel family [n -S]\n",
  "CAMELIDS": "CAMELID, an animal of the camel family [n]\n",
  "CAMELINE": "a material made from camel hair [n -S]\n",
  "CAMELINES": "CAMELINE, a material made from camel hair [n]\n",
  "CAMELISH": "like a camel [adj]\n",
  "CAMELLIA": "an evergreen shrub, also CAMELIA [n -S]\n",
  "CAMELLIAS": "CAMELLIA, an evergreen shrub, also CAMELIA [n]\n",
  "CAMELLIKE": "like a camel [adj]\n",
  "CAMELOID": "a member of the camel family [n -S]\n",
  "CAMELOIDS": "CAMELOID, a member of the camel family [n]\n",
  "CAMELOPARD": "(obsolete) a giraffe, also CAMELEOPARD [n -S]\n",
  "CAMELOPARDS": "CAMELOPARD, (obsolete) a giraffe, also CAMELEOPARD [n]\n",
  "CAMELOT": "a strong waterproof silk or wool fabric, also CAMLET, CHAMELOT, CHAMLET [n -S]\n",
  "CAMELOTS": "CAMELOT, a strong waterproof silk or wool fabric, also CAMLET, CHAMELOT, CHAMLET [n]\n",
  "CAMELRIES": "CAMELRY, troops mounted on camels [n]\n",
  "CAMELRY": "troops mounted on camels [n CAMELRIES]\n",
  "CAMELS": "CAMEL, a large, humped mammal [n]\n",
  "CAMEO": "to portray in sharp, delicate relief [v -ED, -ING, -S]\n",
  "CAMEOED": "CAMEO, to portray in sharp, delicate relief [v]\n",
  "CAMEOING": "CAMEO, to portray in sharp, delicate relief [v]\n",
  "CAMEOS": "CAMEO, to portray in sharp, delicate relief [v]\n",
  "CAMERA": "an apparatus for taking photographs [n CAMERAS] / a judge's private chamber [n CAMERAE]\n",
  "CAMERAE": "CAMERA, an apparatus for taking photographs [n]\n",
  "CAMERAL": "relating to a camera [adj]\n",
  "CAMERAMAN": "one who works with a camera [n CAMERAMEN]\n",
  "CAMERAMEN": "CAMERAMAN, one who works with a camera [n]\n",
  "CAMERAPERSON": "a male or female cameraman [n -S]\n",
  "CAMERAPERSONS": "CAMERAPERSON, a male or female cameraman [n]\n",
  "CAMERAPHONE": "a combined camera and phone [n -S]\n",
  "CAMERAPHONES": "CAMERAPHONE, a combined camera and phone [n]\n",
  "CAMERAS": "CAMERA, an apparatus for taking photographs [n]\n",
  "CAMERATED": "chambered, vaulted, also CAMERAL [adj]\n",
  "CAMERATION": "a vaulting or arching over [n -S]\n",
  "CAMERATIONS": "CAMERATION, a vaulting or arching over [n]\n",
  "CAMERAWOMAN": "a woman who operates a camera [n CAMERAWOMEN]\n",
  "CAMERAWOMEN": "CAMERAWOMAN, a woman who operates a camera [n]\n",
  "CAMERAWORK": "skilful use of a camera [n -S]\n",
  "CAMERAWORKS": "CAMERAWORK, skilful use of a camera [n]\n",
  "CAMERLENGO": "(Italian) the papal chamberlain; the cardinal who presides over the pope's household, also CAMERLINGO [n -S]\n",
  "CAMERLENGOS": "CAMERLENGO, (Italian) the papal chamberlain; the cardinal who presides over the pope's household, also CAMERLINGO [n]\n",
  "CAMERLINGO": "(Italian) the papal chamberlain; the cardinal who presides over the pope's household, also CAMERLENGO [n -S]\n",
  "CAMERLINGOS": "CAMERLINGO, (Italian) the papal chamberlain; the cardinal who presides over the pope's household, also CAMERLENGO [n]\n",
  "CAMES": "CAME, a lead rod for framing a pane in a leaded or stained glass window [n]\n",
  "CAMESE": "(Arabic) a loose shirt or tunic, as worn by Arabs, also CAMISA, CAMISE, CAMISIA, KAMIS [n -S]\n",
  "CAMESES": "CAMESE, (Arabic) a loose shirt or tunic, as worn by Arabs, also CAMISA, CAMISE, CAMISIA, KAMIS [n]\n",
  "CAMI": "(short for) camisole [n -S]\n",
  "CAMIKNICKERS": "a woman's undergarment combining a camisole and knickers, also CAMIKNICKS [n]\n",
  "CAMIKNICKS": "a woman's undergarment combining a camisole and knickers, also CAMIKNICKERS [n]\n",
  "CAMION": "(French) a flat, low, four-wheeled truck or dray [n -S]\n",
  "CAMIONS": "CAMION, (French) a flat, low, four-wheeled truck or dray [n]\n",
  "CAMIS": "(Spenser) a light, loose dress or robe, also CAMUS [n -ES]\n",
  "CAMISA": "(Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISE, CAMISIA, KAMIS [n -S]\n",
  "CAMISADE": "(Spanish) an attack made at night, also CAMISADO [n -S]\n",
  "CAMISADES": "CAMISADE, (Spanish) an attack made at night, also CAMISADO [n]\n",
  "CAMISADO": "(Spanish) an attack made at night, also CAMISADE [n CAMISADOS or CAMISADOES or CAMISADO]\n",
  "CAMISADOES": "CAMISADO, (Spanish) an attack made at night, also CAMISADE [n]\n",
  "CAMISADOS": "CAMISADO, (Spanish) an attack made at night, also CAMISADE [n]\n",
  "CAMISAS": "CAMISA, (Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISE, CAMISIA, KAMIS [n]\n",
  "CAMISE": "(Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISA, CAMISIA, KAMIS [n -S]\n",
  "CAMISES": "CAMISE, (Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISA, CAMISIA, KAMIS [n]\n",
  "CAMISIA": "(Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISA, CAMISE, KAMIS [n -S]\n",
  "CAMISIAS": "CAMISIA, (Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISA, CAMISE, KAMIS [n]\n",
  "CAMISOLE": "(French) a loose under-bodice with thin shoulder straps instead of sleeves [n -S]\n",
  "CAMISOLES": "CAMISOLE, (French) a loose under-bodice with thin shoulder straps instead of sleeves [n]\n",
  "CAMLET": "a strong waterproof silk or wool fabric, also CAMELOT, CHAMELOT, CHAMLET [n -S]\n",
  "CAMLETS": "CAMLET, a strong waterproof silk or wool fabric, also CAMELOT, CHAMELOT, CHAMLET [n]\n",
  "CAMMED": "CAM, to whiten with camstone, also CAUM [v]\n",
  "CAMMIE": "a webcam award [n -S]\n",
  "CAMMIES": "CAMMIE, a webcam award [n]\n",
  "CAMMING": "CAM, to whiten with camstone, also CAUM [v]\n",
  "CAMO": "(short for) camouflage [n -S]\n",
  "CAMOGIE": "(Irish) an Irish game, a form of hurling, played by women [n -S]\n",
  "CAMOGIES": "CAMOGIE, (Irish) an Irish game, a form of hurling, played by women [n]\n",
  "CAMOMILE": "a creeping aromatic plant of the composite family, with yellow-centred white-rayed flowers, formerly much grown for its fragrance, also CHAMOMILE [n -S]\n",
  "CAMOMILES": "CAMOMILE, a creeping aromatic plant of the composite family, with yellow-centred white-rayed flowers, formerly much grown for its fragrance, also CHAMOMILE [n]\n",
  "CAMOODI": "(Caribbean) an anaconda [n -S]\n",
  "CAMOODIS": "CAMOODI, (Caribbean) an anaconda [n]\n",
  "CAMORRA": "(Italian) any organized body engaged in extortion or other dishonest activities [n -S]\n",
  "CAMORRAS": "CAMORRA, (Italian) any organized body engaged in extortion or other dishonest activities [n]\n",
  "CAMORRIST": "a member of a camorra, also CAMORRISTA [n -S]\n",
  "CAMORRISTA": "a member of a camorra, also CAMORRIST [n CAMORRISTI]\n",
  "CAMORRISTI": "CAMORRISTA, a member of a camorra, also CAMORRIST [n]\n",
  "CAMORRISTS": "CAMORRIST, a member of a camorra, also CAMORRISTA [n]\n",
  "CAMOS": "CAMO, (short for) camouflage [n]\n",
  "CAMOTE": "(Spanish) a type of sweet potato [n -S]\n",
  "CAMOTES": "CAMOTE, (Spanish) a type of sweet potato [n]\n",
  "CAMOUFLAGE": "to conceal or disguise by camouflage [v CAMOUFLAGED, CAMOUFLAGING, CAMOUFLAGES]\n",
  "CAMOUFLAGEABLE": "capable of being camouflaged [adj]\n",
  "CAMOUFLAGED": "CAMOUFLAGE, to conceal or disguise by camouflage [v]\n",
  "CAMOUFLAGES": "CAMOUFLAGE, to conceal or disguise by camouflage [v]\n",
  "CAMOUFLAGIC": "relating to camouflage [adj]\n",
  "CAMOUFLAGING": "CAMOUFLAGE, to conceal or disguise by camouflage [v]\n",
  "CAMOUFLET": "(French) a mine used to destroy an underground enemy emplacement [n -S]\n",
  "CAMOUFLETS": "CAMOUFLET, (French) a mine used to destroy an underground enemy emplacement [n]\n",
  "CAMOUFLEUR": "(French) a person or animal skilled in the art of camouflage [n -S]\n",
  "CAMOUFLEURS": "CAMOUFLEUR, (French) a person or animal skilled in the art of camouflage [n]\n",
  "CAMP": "to live in the open [v -ED, -ING, -S] / theatrical [adj CAMPER, CAMPEST, CAMPLY]\n",
  "CAMPAGNA": "(Italian) an open level tract of country; esp. \"Campagna di Roma\", the extensive undulating plain which surrounds Rome [n CAMPAGNAS or CAMPAGNE]\n",
  "CAMPAGNAS": "CAMPAGNA, (Italian) an open level tract of country; esp. \"Campagna di Roma\", the extensive undulating plain which surrounds Rome [n]\n",
  "CAMPAGNE": "CAMPAGNA, (Italian) an open level tract of country; esp. \"Campagna di Roma\", the extensive undulating plain which surrounds Rome [n]\n",
  "CAMPAIGN": "to conduct an operation to achieve a certain goal [v -ED, -ING, -S]\n",
  "CAMPAIGNED": "CAMPAIGN, to conduct an operation to achieve a certain goal [v]\n",
  "CAMPAIGNER": "one who campaigns [n -S]\n",
  "CAMPAIGNERS": "CAMPAIGNER, one who campaigns [n]\n",
  "CAMPAIGNING": "CAMPAIGN, to conduct an operation to achieve a certain goal [v]\n",
  "CAMPAIGNS": "CAMPAIGN, to conduct an operation to achieve a certain goal [v]\n",
  "CAMPANA": "(Latin) a church bell [n -S]\n",
  "CAMPANAS": "CAMPANA, (Latin) a church bell [n]\n",
  "CAMPANERO": "(Spanish) the bellbird of South America [n -S]\n",
  "CAMPANEROS": "CAMPANERO, (Spanish) the bellbird of South America [n]\n",
  "CAMPANIFORM": "bell-shaped [adj]\n",
  "CAMPANILE": "(Italian) a freestanding bell tower on church property [n CAMPANILI or CAMPANILES]\n",
  "CAMPANILES": "CAMPANILE, (Italian) a freestanding bell tower on church property [n]\n",
  "CAMPANILI": "CAMPANILE, (Italian) a freestanding bell tower on church property [n]\n",
  "CAMPANIST": "a person with an expert knowledge of bells [n -S]\n",
  "CAMPANISTS": "CAMPANIST, a person with an expert knowledge of bells [n]\n",
  "CAMPANOLOGER": "a bell-ringer [n -S]\n",
  "CAMPANOLOGERS": "CAMPANOLOGER, a bell-ringer [n]\n",
  "CAMPANOLOGICAL": "related to campanology [adj]\n",
  "CAMPANOLOGIES": "CAMPANOLOGY, the art of bell ringing [n]\n",
  "CAMPANOLOGIST": "one who practices or is skilled in the art of bell ringing [n -S]\n",
  "CAMPANOLOGISTS": "CAMPANOLOGIST, one who practices or is skilled in the art of bell ringing [n]\n",
  "CAMPANOLOGY": "the art of bell ringing [n CAMPANOLOGIES]\n",
  "CAMPANULA": "(Latin) a member of the bellflower family [n -S]\n",
  "CAMPANULACEOUS": "belonging to the bellflower family [adj]\n",
  "CAMPANULAR": "relating to plants of the Campanula genus [adj]\n",
  "CAMPANULAS": "CAMPANULA, (Latin) a member of the bellflower family [n]\n",
  "CAMPANULATE": "shaped like a bell [adj]\n",
  "CAMPCRAFT": "knowledge of how to camp [n -S]\n",
  "CAMPCRAFTS": "CAMPCRAFT, knowledge of how to camp [n]\n",
  "CAMPEACHY": "as in campeachy wood, a logwood, first exported from Campeachy (Campeche, in SE Mexico) [adj]\n",
  "CAMPEADOR": "(Spanish) a champion, esp. El Cid [n -S]\n",
  "CAMPEADORS": "CAMPEADOR, (Spanish) a champion, esp. El Cid [n]\n",
  "CAMPED": "CAMP, to live in the open [v]\n",
  "CAMPER": "one who lives in the open [n -S]\n",
  "CAMPERIES": "CAMPERY, being camp [n]\n",
  "CAMPERS": "CAMPER, one who lives in the open [n]\n",
  "CAMPERY": "being camp [n CAMPERIES]\n",
  "CAMPESINO": "(Spanish) a Latin American peasant farmer [n -S]\n",
  "CAMPESINOS": "CAMPESINO, (Spanish) a Latin American peasant farmer [n]\n",
  "CAMPEST": "CAMP, theatrical [adj]\n",
  "CAMPESTRAL": "of or pertaining to fields or open country, also CAMPESTRIAN [adj]\n",
  "CAMPESTRIAN": "of or pertaining to fields or open country, also CAMPESTRAL [adj]\n",
  "CAMPFIRE": "a fire to sit round at camp [n -S]\n",
  "CAMPFIRES": "CAMPFIRE, a fire to sit round at camp [n]\n",
  "CAMPGROUND": "the area or place (as a field or grove) used for a camp [n -S]\n",
  "CAMPGROUNDS": "CAMPGROUND, the area or place (as a field or grove) used for a camp [n]\n",
  "CAMPHANE": "a type of hydrocarbon [n -S]\n",
  "CAMPHANES": "CAMPHANE, a type of hydrocarbon [n]\n",
  "CAMPHENE": "an explosive liquid, also CAMPHINE [n -S]\n",
  "CAMPHENES": "CAMPHENE, an explosive liquid, also CAMPHINE [n]\n",
  "CAMPHINE": "an explosive liquid, also CAMPHENE [n -S]\n",
  "CAMPHINES": "CAMPHINE, an explosive liquid, also CAMPHENE [n]\n",
  "CAMPHIRE": "an old spelling of camphor, also CAMPHOL [n -S]\n",
  "CAMPHIRES": "CAMPHIRE, an old spelling of camphor, also CAMPHOL [n]\n",
  "CAMPHOL": "a rare variety of camphor, aka borneol, also CAMPHIRE, CAMPHOR [n -S]\n",
  "CAMPHOLS": "CAMPHOL, a rare variety of camphor, aka borneol, also CAMPHIRE, CAMPHOR [n]\n",
  "CAMPHONE": "a combined camera and mobile phone [n -S]\n",
  "CAMPHONES": "CAMPHONE, a combined camera and mobile phone [n]\n",
  "CAMPHOR": "(Malay) a solid essential oil derived from camphor laurel, also CAMPHIRE, CAMPHOL [n -S]\n",
  "CAMPHORACEOUS": "like camphor [adj]\n",
  "CAMPHORATE": "to impregnate or treat with camphor [v CAMPHORATED, CAMPHORATING, CAMPHORATES]\n",
  "CAMPHORATED": "CAMPHORATE, to impregnate or treat with camphor [v]\n",
  "CAMPHORATES": "CAMPHORATE, to impregnate or treat with camphor [v]\n",
  "CAMPHORATING": "CAMPHORATE, to impregnate or treat with camphor [v]\n",
  "CAMPHORIC": "pertaining to camphor, a solid essential oil derived from camphor laurel [adj]\n",
  "CAMPHORS": "CAMPHOR, (Malay) a solid essential oil derived from camphor laurel, also CAMPHIRE, CAMPHOL [n]\n",
  "CAMPI": "CAMPO, (Spanish) an area of open grassland in South America [n]\n",
  "CAMPIER": "CAMPY, comically exaggerated [adj]\n",
  "CAMPIEST": "CAMPY, comically exaggerated [adj]\n",
  "CAMPILY": "CAMPY, comically exaggerated [adv]\n",
  "CAMPIMETRIES": "CAMPIMETRY, a technique for assessing the central part of the visual field [n]\n",
  "CAMPIMETRY": "a technique for assessing the central part of the visual field [n CAMPIMETRIES]\n",
  "CAMPINESS": "being camp [n -ES]\n",
  "CAMPINESSES": "CAMPINESS, being camp [n]\n",
  "CAMPING": "the act of living outdoors [n -S]\n",
  "CAMPINGS": "CAMPING, the act of living outdoors [n]\n",
  "CAMPION": "any plant of the genera Lychnis and Silene having usually pink or white star- or salver-shaped flowers with notched petals [n -S]\n",
  "CAMPIONS": "CAMPION, any plant of the genera Lychnis and Silene having usually pink or white star- or salver-shaped flowers with notched petals [n]\n",
  "CAMPLE": "to wrangle [v CAMPLED, CAMPLING, CAMPLES]\n",
  "CAMPLED": "CAMPLE, to wrangle [v]\n",
  "CAMPLES": "CAMPLE, to wrangle [v]\n",
  "CAMPLING": "CAMPLE, to wrangle [v]\n",
  "CAMPLY": "CAMP, theatrical [adv]\n",
  "CAMPNESS": "extravagance in manner [n -ES]\n",
  "CAMPNESSES": "CAMPNESS, extravagance in manner [n]\n",
  "CAMPO": "(Spanish) an area of open grassland in South America [n CAMPI or CAMPOS]\n",
  "CAMPODEID": "a primitive wingless insect of the order Diptera [n -S]\n",
  "CAMPODEIDS": "CAMPODEID, a primitive wingless insect of the order Diptera [n]\n",
  "CAMPODEIFORM": "of or resembling the Campodeidae, certain six-legged, hard-bodied active insect larvae [adj]\n",
  "CAMPONG": "(Malay) a Malay village, also KAMPONG [n -S]\n",
  "CAMPONGS": "CAMPONG, (Malay) a Malay village, also KAMPONG [n]\n",
  "CAMPOREE": "a gathering of Boy Scouts [n -S]\n",
  "CAMPOREES": "CAMPOREE, a gathering of Boy Scouts [n]\n",
  "CAMPOS": "CAMPO, (Spanish) an area of open grassland in South America [n]\n",
  "CAMPOUT": "a camping out by a group [n -S]\n",
  "CAMPOUTS": "CAMPOUT, a camping out by a group [n]\n",
  "CAMPS": "CAMP, to live in the open [v]\n",
  "CAMPSHIRT": "a short-sleeved shirt [n -S]\n",
  "CAMPSHIRTS": "CAMPSHIRT, a short-sleeved shirt [n]\n",
  "CAMPSITE": "an area suitable for camping [n -S]\n",
  "CAMPSITES": "CAMPSITE, an area suitable for camping [n]\n",
  "CAMPSTOOL": "a small canvas stool for outdoor use [n -S]\n",
  "CAMPSTOOLS": "CAMPSTOOL, a small canvas stool for outdoor use [n]\n",
  "CAMPUS": "(Latin) to restrict a student to the school ground [v -ED, -ING, -ES]\n",
  "CAMPUSED": "CAMPUS, (Latin) to restrict a student to the school ground [v]\n",
  "CAMPUSES": "CAMPUS, (Latin) to restrict a student to the school ground [v]\n",
  "CAMPUSING": "CAMPUS, (Latin) to restrict a student to the school ground [v]\n",
  "CAMPY": "comically exaggerated [adj CAMPIER, CAMPIEST, CAMPILY]\n",
  "CAMPYLOBACTER": "a bacterium that is a common cause of gastroenteritis in humans, and also of abortion in cattle and sheep [n -S]\n",
  "CAMPYLOBACTERS": "CAMPYLOBACTER, a bacterium that is a common cause of gastroenteritis in humans, and also of abortion in cattle and sheep [n]\n",
  "CAMPYLOTROPOUS": "having the ovule partly inverted and curved [adj]\n",
  "CAMS": "CAM, to whiten with camstone, also CAUM [v]\n",
  "CAMSHAFT": "a shaft fitted with cams [n -S]\n",
  "CAMSHAFTS": "CAMSHAFT, a shaft fitted with cams [n]\n",
  "CAMSHO": "(Scots) crooked or deformed, also CAMSHOCH [adj]\n",
  "CAMSHOCH": "(Scots) crooked or deformed, also CAMSHO [adj]\n",
  "CAMSTAIRY": "(Scots) perverse, unruly, also CAMSTEARY, CAMSTEERIE [adj]\n",
  "CAMSTANE": "(Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CALMSTONE, CAMSTONE, CAUMSTANE, CAUMSTONE [n -S]\n",
  "CAMSTANES": "CAMSTANE, (Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CALMSTONE, CAMSTONE, CAUMSTANE, CAUMSTONE [n]\n",
  "CAMSTEARY": "(Scots) perverse, unruly, also CAMSTAIRY, CAMSTEERIE [adj]\n",
  "CAMSTEERIE": "(Scots) perverse, unruly, also CAMSTAIRY, CAMSTEARY [adj]\n",
  "CAMSTONE": "(Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CALMSTONE, CAMSTANE, CAUMSTANE, CAUMSTONE [n -S]\n",
  "CAMSTONES": "CAMSTONE, (Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CALMSTONE, CAMSTANE, CAUMSTANE, CAUMSTONE [n]\n",
  "CAMUS": "(Spenser) a type of robe, also CAMIS [n -ES]\n",
  "CAMUSES": "CAMUS, (Spenser) a type of robe, also CAMIS [n]\n",
  "CAMWHORE": "to perform sexual or titillating acts in front of a webcam for the gratification of online customers in return for money or gifts [v CAMWHORED, CAMWHORING, CAMWHORES]\n",
  "CAMWHORED": "CAMWHORE, to perform sexual or titillating acts in front of a webcam for the gratification of online customers in return for money or gifts [v]\n",
  "CAMWHORES": "CAMWHORE, to perform sexual or titillating acts in front of a webcam for the gratification of online customers in return for money or gifts [v]\n",
  "CAMWHORING": "CAMWHORE, to perform sexual or titillating acts in front of a webcam for the gratification of online customers in return for money or gifts [v]\n",
  "CAMWOOD": "the wood of a West African tree, used in making a red dye [n -S]\n",
  "CAMWOODS": "CAMWOOD, the wood of a West African tree, used in making a red dye [n]\n",
  "CAN": "to put in a cylindrical container [v CANNED, CANNING, CANS] / to be able [v present sing 2d person CAN or CANST, past sing 2d person COULD, COULDEST, or COULDST]\n",
  "CANADA": "(Spanish) a narrow canyon [n -S]\n",
  "CANADAS": "CANADA, (Spanish) a narrow canyon [n]\n",
  "CANAIGRE": "(Spanish) a large Texan dock, whose root is used in tanning [n -S]\n",
  "CANAIGRES": "CANAIGRE, (Spanish) a large Texan dock, whose root is used in tanning [n]\n",
  "CANAILLE": "(French) riffraff; the proletariat [n -S]\n",
  "CANAILLES": "CANAILLE, (French) riffraff; the proletariat [n]\n",
  "CANAKIN": "a small can or cup, also CANNIKIN, CANIKIN [n -S]\n",
  "CANAKINS": "CANAKIN, a small can or cup, also CANNIKIN, CANIKIN [n]\n",
  "CANAL": "to dig an artificial waterway through [v CANALLED or CANALED, CANALLING or CANALING, CANALS]\n",
  "CANALBOAT": "a boat used on canals [n -S]\n",
  "CANALBOATS": "CANALBOAT, a boat used on canals [n]\n",
  "CANALED": "CANAL, to dig an artificial waterway through [v]\n",
  "CANALICULAR": "like or relating to a canaliculus [adj]\n",
  "CANALICULATE": "grooved or channelled lengthwise, also CANALICULATED [adj]\n",
  "CANALICULATED": "grooved or channelled lengthwise, also CANALICULATE [adj]\n",
  "CANALICULI": "CANALICULUS, a small bodily channel, like a tear duct [n]\n",
  "CANALICULUS": "a small bodily channel, like a tear duct [n CANALICULI]\n",
  "CANALING": "CANAL, to dig an artificial waterway through [v]\n",
  "CANALISATION": "the construction of canals, also CANALIZATION [n -S]\n",
  "CANALISATIONS": "CANALISATION, the construction of canals, also CANALIZATION [n]\n",
  "CANALISE": "to dig an artificial waterway through, also CANALIZE [v CANALISED, CANALISING, CANALISES]\n",
  "CANALISED": "CANALISE, to dig an artificial waterway through, also CANALIZE [v]\n",
  "CANALISES": "CANALISE, to dig an artificial waterway through, also CANALIZE [v]\n",
  "CANALISING": "CANALISE, to dig an artificial waterway through, also CANALIZE [v]\n",
  "CANALIZATION": "the construction of canals, also CANALISATION [n -S]\n",
  "CANALIZATIONS": "CANALIZATION, the construction of canals, also CANALISATION [n]\n",
  "CANALIZE": "to dig an artificial waterway through, also CANALISE [v CANALIZED, CANALIZING, CANALIZES]\n",
  "CANALIZED": "CANALIZE, to dig an artificial waterway through, also CANALISE [v]\n",
  "CANALIZES": "CANALIZE, to dig an artificial waterway through, also CANALISE [v]\n",
  "CANALIZING": "CANALIZE, to dig an artificial waterway through, also CANALISE [v]\n",
  "CANALLED": "CANAL, to dig an artificial waterway through [v]\n",
  "CANALLER": "a freight boat [n -S]\n",
  "CANALLERS": "CANALLER, a freight boat [n]\n",
  "CANALLING": "CANAL, to dig an artificial waterway through [v]\n",
  "CANALS": "CANAL, to dig an artificial waterway through [v]\n",
  "CANAPE": "(French) a small savoury biscuit [n -S]\n",
  "CANAPES": "CANAPE, (French) a small savoury biscuit [n]\n",
  "CANARD": "(French) a false or unfounded report or story [n -S]\n",
  "CANARDS": "CANARD, (French) a false or unfounded report or story [n]\n",
  "CANARIED": "CANARY, to prance about [v]\n",
  "CANARIES": "CANARY, to prance about [v]\n",
  "CANARY": "to prance about [v CANARIED, CANARYING, CANARIES]\n",
  "CANARYING": "CANARY, to prance about [v]\n",
  "CANASTA": "(Spanish) a card game similar to rummy [n -S]\n",
  "CANASTAS": "CANASTA, (Spanish) a card game similar to rummy [n]\n",
  "CANASTER": "(Spanish) a kind of tobacco for smoking, made of the dried leaves, coarsely broken [n -S]\n",
  "CANASTERS": "CANASTER, (Spanish) a kind of tobacco for smoking, made of the dried leaves, coarsely broken [n]\n",
  "CANBANK": "the equivalent of a bottle bank for cans [n -S]\n",
  "CANBANKS": "CANBANK, the equivalent of a bottle bank for cans [n]\n",
  "CANCAN": "(French) a high-kicking dance [n -S]\n",
  "CANCANS": "CANCAN, (French) a high-kicking dance [n]\n",
  "CANCEL": "to cause not to happen [v CANCELED or CANCELLED, CANCELING or CANCELLING, CANCELS]\n",
  "CANCELABLE": "that can be cancelled, also CANCELLABLE [adj]\n",
  "CANCELATION": "the act or an instance of canceling, also CANCELLATION [n -S]\n",
  "CANCELATIONS": "CANCELATION, the act or an instance of canceling, also CANCELLATION [n]\n",
  "CANCELBOT": "a computer program that identifies and deletes unwanted articles sent to an Internet newsgroup [n -S]\n",
  "CANCELBOTS": "CANCELBOT, a computer program that identifies and deletes unwanted articles sent to an Internet newsgroup [n]\n",
  "CANCELED": "CANCEL, to cause not to happen [v]\n",
  "CANCELEER": "(Scott) the turn of a hawk upon the wing to recover herself, when she misses her aim in the stoop [n -S] / to make such a turn, also CANCELIER [v -ED, -ING, -S]\n",
  "CANCELEERED": "CANCELEER, to make such a turn, also CANCELIER [v]\n",
  "CANCELEERING": "CANCELEER, to make such a turn, also CANCELIER [v]\n",
  "CANCELEERS": "CANCELEER, (Scott) the turn of a hawk upon the wing to recover herself, when she misses her aim in the stoop [n]\n",
  "CANCELER": "one who cancels, also CANCELLER [n -S]\n",
  "CANCELERS": "CANCELER, one who cancels, also CANCELLER [n]\n",
  "CANCELIER": "(Scott) the turn of a hawk upon the wing to recover herself, when she misses her aim in the stoop [n -S] / to make such a turn, also CANCELEER [v -ED, -ING, -S]\n",
  "CANCELIERED": "CANCELIER, to make such a turn, also CANCELEER [v]\n",
  "CANCELIERING": "CANCELIER, to make such a turn, also CANCELEER [v]\n",
  "CANCELIERS": "CANCELIER, to make such a turn, also CANCELEER [v]\n",
  "CANCELING": "CANCEL, to cause not to happen [v]\n",
  "CANCELLABLE": "that can be cancelled, also CANCELABLE [adj]\n",
  "CANCELLARIAL": "of or relating to a chancellor, also CANCELLARIAN [adj]\n",
  "CANCELLARIAN": "of or relating to a chancellor, also CANCELLARIAL [adj]\n",
  "CANCELLARIATE": "the office of chancellor [n -S]\n",
  "CANCELLARIATES": "CANCELLARIATE, the office of chancellor [n]\n",
  "CANCELLATE": "consisting of a network of veins, without intermediate parenchyma, as the leaves of certain plants, also CANCELLATED [adj]\n",
  "CANCELLATED": "consisting of a network of veins, without intermediate parenchyma, as the leaves of certain plants, also CANCELLATE [adj]\n",
  "CANCELLATION": "the act or an instance of cancelling, also CANCELATION [n -S]\n",
  "CANCELLATIONS": "CANCELLATION, the act or an instance of cancelling, also CANCELATION [n]\n",
  "CANCELLED": "CANCEL, to cause not to happen [v]\n",
  "CANCELLER": "one who cancels, also CANCELER [n -S]\n",
  "CANCELLERS": "CANCELLER, one who cancels, also CANCELER [n]\n",
  "CANCELLI": "(Latin) the latticework of spongy bone tissue; the mesh of spaces within this [n]\n",
  "CANCELLING": "CANCEL, to cause not to happen [v]\n",
  "CANCELLOUS": "of bone, having a porous structure [adj]\n",
  "CANCELS": "CANCEL, to cause not to happen [v]\n",
  "CANCER": "a malignant growth [n -S]\n",
  "CANCERATE": "to grow into a cancer; to become cancerous [v CANCERATED, CANCERATING, CANCERATES]\n",
  "CANCERATED": "CANCERATE, to grow into a cancer; to become cancerous [v]\n",
  "CANCERATES": "CANCERATE, to grow into a cancer; to become cancerous [v]\n",
  "CANCERATING": "CANCERATE, to grow into a cancer; to become cancerous [v]\n",
  "CANCERATION": "the act of cancerating [n -S]\n",
  "CANCERATIONS": "CANCERATION, the act of cancerating [n]\n",
  "CANCERED": "affected with cancer [adj]\n",
  "CANCEROPHOBIA": "fear of cancer, also CANCERPHOBIA [n -S]\n",
  "CANCEROPHOBIAS": "CANCEROPHOBIA, fear of cancer, also CANCERPHOBIA [n]\n",
  "CANCEROUS": "afflicted with a cancer [adj CANCEROUSLY]\n",
  "CANCEROUSLY": "CANCEROUS, afflicted with a cancer [adv]\n",
  "CANCERPHOBIA": "fear of cancer, also CANCEROPHOBIA [n -S]\n",
  "CANCERPHOBIAS": "CANCERPHOBIA, fear of cancer, also CANCEROPHOBIA [n]\n",
  "CANCERS": "CANCER, a malignant growth [n]\n",
  "CANCHA": "(Spanish) a court for playing the ball game jai alai [n -S]\n",
  "CANCHAS": "CANCHA, (Spanish) a court for playing the ball game jai alai [n]\n",
  "CANCIONERO": "(Spanish) a collection of songs and poems [n -S]\n",
  "CANCIONEROS": "CANCIONERO, (Spanish) a collection of songs and poems [n]\n",
  "CANCRIFORM": "shaped like a crab [adj]\n",
  "CANCRINE": "crabwise; (of verses, etc.) reading both ways, palindromic [adj]\n",
  "CANCRIZANS": "of a canon, having the imitating vocal part repeating the theme backwards [adj]\n",
  "CANCROID": "a type of slow-growing skin cancer [n -S]\n",
  "CANCROIDS": "CANCROID, a type of slow-growing skin cancer [n]\n",
  "CANDELA": "a unit of luminous intensity [n -S]\n",
  "CANDELABRA": "a candleholder [n -S]\n",
  "CANDELABRAS": "CANDELABRA, a candleholder [n]\n",
  "CANDELABRUM": "a candleholder [n CANDELABRUMS or CANDELABRA]\n",
  "CANDELABRUMS": "CANDELABRUM, a candleholder [n]\n",
  "CANDELAS": "CANDELA, a unit of luminous intensity [n]\n",
  "CANDELILLA": "(Spanish) a Mexican wax-yielding spurge [n -S]\n",
  "CANDELILLAS": "CANDELILLA, (Spanish) a Mexican wax-yielding spurge [n]\n",
  "CANDENT": "(archaic) glowing, white-hot, also CANDESCENT [adj]\n",
  "CANDESCENCE": "a candescent state [n -S]\n",
  "CANDESCENCES": "CANDESCENCE, a candescent state [n]\n",
  "CANDESCENT": "glowing, white-hot, also CANDENT [adj CANDESCENTLY]\n",
  "CANDESCENTLY": "CANDESCENT, glowing, white-hot, also CANDENT [adv]\n",
  "CANDID": "an unposed photograph [n -S] / frank and sincere [adj CANDIDER, CANDIDEST, CANDIDLY]\n",
  "CANDIDA": "(Latin) a parasitic, yeastlike fungus, that causes the infection candidiasis [n -S]\n",
  "CANDIDACIES": "CANDIDACY, the state of being a candidate [n]\n",
  "CANDIDACY": "the state of being a candidate [n CANDIDACIES]\n",
  "CANDIDAL": "of or like candida, a parasitic, yeastlike fungus [adj]\n",
  "CANDIDAS": "CANDIDA, (Latin) a parasitic, yeastlike fungus, that causes the infection candidiasis [n]\n",
  "CANDIDATE": "a person who seeks or is nominated for any office or honour [n -S]\n",
  "CANDIDATES": "CANDIDATE, a person who seeks or is nominated for any office or honour [n]\n",
  "CANDIDATESHIP": "the office of candidate [n -S]\n",
  "CANDIDATESHIPS": "CANDIDATESHIP, the office of candidate [n]\n",
  "CANDIDATURE": "the state of being a candidate [n -S]\n",
  "CANDIDATURES": "CANDIDATURE, the state of being a candidate [n]\n",
  "CANDIDER": "CANDID, frank and sincere [adj]\n",
  "CANDIDEST": "CANDID, frank and sincere [adj]\n",
  "CANDIDIASES": "CANDIDIASIS, a thrush-like infection caused by the candida fungus [n]\n",
  "CANDIDIASIS": "a thrush-like infection caused by the candida fungus [n CANDIDIASES]\n",
  "CANDIDLY": "CANDID, frank and sincere [adv]\n",
  "CANDIDNESS": "the state of being candid [n -ES]\n",
  "CANDIDNESSES": "CANDIDNESS, the state of being candid [n]\n",
  "CANDIDS": "CANDID, an unposed photograph [n]\n",
  "CANDIE": "(Tamil) a South Indian weight, approximately 500 lb. Imperial, also CANDY, KANDY [n -S]\n",
  "CANDIED": "CANDY, (Tamil) to coat with sugar [v]\n",
  "CANDIES": "CANDIE, (Tamil) a South Indian weight, approximately 500 lb. Imperial, also CANDY, KANDY [n]\n",
  "CANDIRU": "a tiny S American fish which can swim into a body orifice, where it attaches itself by means of a spine and feeds on blood and body tissue [n -S]\n",
  "CANDIRUS": "CANDIRU, a tiny S American fish which can swim into a body orifice, where it attaches itself by means of a spine and feeds on blood and body tissue [n]\n",
  "CANDLE": "to examine eggs in front of a light [v CANDLED, CANDLING, CANDLES]\n",
  "CANDLEBERRIES": "CANDLEBERRY, a shrub, the wax myrtle [n]\n",
  "CANDLEBERRY": "a shrub, the wax myrtle [n CANDLEBERRIES]\n",
  "CANDLED": "CANDLE, to examine eggs in front of a light [v]\n",
  "CANDLEFISH": "a marine fish, allied to the smelt, found on the north Pacific coast, aka eulachon, so named because it is so oily that, when dried, it may be used as a candle, by drawing a wick through it [n -ES]\n",
  "CANDLEFISHES": "CANDLEFISH, a marine fish, allied to the smelt, found on the north Pacific coast, aka eulachon, so named because it is so oily that, when dried, it may be used as a candle, by drawing a wick through it [n]\n",
  "CANDLEHOLDER": "a holder with a socket for a candle [n -S]\n",
  "CANDLEHOLDERS": "CANDLEHOLDER, a holder with a socket for a candle [n]\n",
  "CANDLELIGHT": "the light of a candle [n -S]\n",
  "CANDLELIGHTED": "illuminated by candles, also CANDLELIT [adj]\n",
  "CANDLELIGHTER": "one who lights the candles for a ceremony [n -S]\n",
  "CANDLELIGHTERS": "CANDLELIGHTER, one who lights the candles for a ceremony [n]\n",
  "CANDLELIGHTS": "CANDLELIGHT, the light of a candle [n]\n",
  "CANDLELIT": "illuminated by candles, also CANDLELIGHTED [adj]\n",
  "CANDLENUT": "the oil-yielding fruit of a tropical tree [n -S]\n",
  "CANDLENUTS": "CANDLENUT, the oil-yielding fruit of a tropical tree [n]\n",
  "CANDLEPIN": "a slender bowling pin [n -S]\n",
  "CANDLEPINS": "CANDLEPIN, a slender bowling pin [n]\n",
  "CANDLEPOWER": "an old unit of luminosity [n -S]\n",
  "CANDLEPOWERS": "CANDLEPOWER, an old unit of luminosity [n]\n",
  "CANDLER": "one whose job it is to candle eggs [n -S]\n",
  "CANDLERS": "CANDLER, one whose job it is to candle eggs [n]\n",
  "CANDLES": "CANDLE, to examine eggs in front of a light [v]\n",
  "CANDLESNUFFER": "an implement for snuffing candles that consists of a small hollow cone attached to a handle [n -S]\n",
  "CANDLESNUFFERS": "CANDLESNUFFER, an implement for snuffing candles that consists of a small hollow cone attached to a handle [n]\n",
  "CANDLESTICK": "a holder with a socket for a candle [n -S]\n",
  "CANDLESTICKS": "CANDLESTICK, a holder with a socket for a candle [n]\n",
  "CANDLEWICK": "a soft cotton tufted material [n -S]\n",
  "CANDLEWICKS": "CANDLEWICK, a soft cotton tufted material [n]\n",
  "CANDLEWOOD": "the wood of various resinous tropical trees [n -S]\n",
  "CANDLEWOODS": "CANDLEWOOD, the wood of various resinous tropical trees [n]\n",
  "CANDLING": "CANDLE, to examine eggs in front of a light [v]\n",
  "CANDOCK": "the yellow water lily [n -S]\n",
  "CANDOCKS": "CANDOCK, the yellow water lily [n]\n",
  "CANDOR": "frankness, sincerity, also CANDOUR [n -S]\n",
  "CANDORS": "CANDOR, frankness, sincerity, also CANDOUR [n]\n",
  "CANDOUR": "frankness, sincerity, also CANDOR [n -S]\n",
  "CANDOURS": "CANDOUR, frankness, sincerity, also CANDOR [n]\n",
  "CANDY": "(Tamil) to coat with sugar [v CANDIED, CANDYING, CANDIES]\n",
  "CANDYFLOSS": "a fluffy ball of spun sugar, coloured and flavoured, sold on the end of a stick [n -ES]\n",
  "CANDYFLOSSES": "CANDYFLOSS, a fluffy ball of spun sugar, coloured and flavoured, sold on the end of a stick [n]\n",
  "CANDYGRAM": "a message accompanied by sweets [n -S]\n",
  "CANDYGRAMS": "CANDYGRAM, a message accompanied by sweets [n]\n",
  "CANDYING": "CANDY, (Tamil) to coat with sugar [v]\n",
  "CANDYMAN": "(US slang) a drug-pusher [n CANDYMEN]\n",
  "CANDYMEN": "CANDYMAN, (US slang) a drug-pusher [n]\n",
  "CANDYTUFT": "a cruciferous plant of the genus Iberis, with flowers in tufts or corymbs, the outer petals larger than the inner [n -S]\n",
  "CANDYTUFTS": "CANDYTUFT, a cruciferous plant of the genus Iberis, with flowers in tufts or corymbs, the outer petals larger than the inner [n]\n",
  "CANE": "to beat with a flexible rod [v CANED, CANING, CANES]\n",
  "CANEBRAKE": "a thicket of canes [n -S]\n",
  "CANEBRAKES": "CANEBRAKE, a thicket of canes [n]\n",
  "CANED": "CANE, to beat with a flexible rod [v]\n",
  "CANEFRUIT": "fruit borne upon canes, such as raspberries [n -S]\n",
  "CANEFRUITS": "CANEFRUIT, fruit borne upon canes, such as raspberries [n]\n",
  "CANEGRUB": "any of various species of beetle native to Australia [n -S]\n",
  "CANEGRUBS": "CANEGRUB, any of various species of beetle native to Australia [n]\n",
  "CANEH": "(Hebrew) a Hebrew measure of length, six cubits [n -S]\n",
  "CANEHS": "CANEH, (Hebrew) a Hebrew measure of length, six cubits [n]\n",
  "CANELLA": "a genus of trees of the order Canellaceae, growing in the West Indies [n -S]\n",
  "CANELLAS": "CANELLA, a genus of trees of the order Canellaceae, growing in the West Indies [n]\n",
  "CANELLINI": "(Italian) the white haricot beans used in French and Italian cooking, also CANNELLINI [n]\n",
  "CANEPHOR": "(Greek) a sculpted figure carrying a basket on the head, also CANEPHORA, CANEPHORE, CANEPHORUS [n -S]\n",
  "CANEPHORA": "(Greek) a sculpted figure carrying a basket on the head, also CANEPHOR, CANEPHORE, CANEPHORUS [n -S]\n",
  "CANEPHORAS": "CANEPHORA, (Greek) a sculpted figure carrying a basket on the head, also CANEPHOR, CANEPHORE, CANEPHORUS [n]\n",
  "CANEPHORE": "(Greek) a sculpted figure carrying a basket on the head, also CANEPHOR, CANEPHORA, CANEPHORUS [n -S]\n",
  "CANEPHORES": "CANEPHORE, (Greek) a sculpted figure carrying a basket on the head, also CANEPHOR, CANEPHORA, CANEPHORUS [n]\n",
  "CANEPHORS": "CANEPHOR, (Greek) a sculpted figure carrying a basket on the head, also CANEPHORA, CANEPHORE, CANEPHORUS [n]\n",
  "CANEPHORUS": "(Greek) a sculpted figure carrying a basket on the head, also CANEPHOR, CANEPHORA, CANEPHORE [n -ES]\n",
  "CANEPHORUSES": "CANEPHORUS, (Greek) a sculpted figure carrying a basket on the head, also CANEPHOR, CANEPHORA, CANEPHORE [n]\n",
  "CANER": "one who canes [n -S]\n",
  "CANERS": "CANER, one who canes [n]\n",
  "CANES": "CANE, to beat with a flexible rod [v]\n",
  "CANESCENCE": "greyness, hoariness [n -S]\n",
  "CANESCENCES": "CANESCENCE, greyness, hoariness [n]\n",
  "CANESCENT": "hoary; tending to become white or grey [adj]\n",
  "CANEWARE": "articles made from cane [n -S]\n",
  "CANEWARES": "CANEWARE, articles made from cane [n]\n",
  "CANFIELD": "a card game adapted from patience [n -S]\n",
  "CANFIELDS": "CANFIELD, a card game adapted from patience [n]\n",
  "CANFUL": "as much as a can hold [n CANFULS or CANSFUL]\n",
  "CANFULS": "CANFUL, as much as a can hold [n]\n",
  "CANG": "(Portuguese) a wooden collar used to punish criminals in China, also CANGUE [n -S]\n",
  "CANGLE": "(Scots) to wrangle [v CANGLED, CANGLING, CANGLES]\n",
  "CANGLED": "CANGLE, (Scots) to wrangle [v]\n",
  "CANGLES": "CANGLE, (Scots) to wrangle [v]\n",
  "CANGLING": "CANGLE, (Scots) to wrangle [v]\n",
  "CANGS": "CANG, (Portuguese) a wooden collar used to punish criminals in China, also CANGUE [n]\n",
  "CANGUE": "(Portuguese) a wooden collar used to punish criminals in China, also CANG [n -S]\n",
  "CANGUES": "CANGUE, (Portuguese) a wooden collar used to punish criminals in China, also CANG [n]\n",
  "CANICULAR": "pertaining to the dog star, or the dog days of summer [adj]\n",
  "CANID": "a member of the dog family [n -S]\n",
  "CANIDS": "CANID, a member of the dog family [n]\n",
  "CANIER": "CANY, like cane, abounding in cane [adj]\n",
  "CANIEST": "CANY, like cane, abounding in cane [adj]\n",
  "CANIKIN": "a small can or cup, also CANNIKIN, CANAKIN [n -S]\n",
  "CANIKINS": "CANIKIN, a small can or cup, also CANNIKIN, CANAKIN [n]\n",
  "CANINE": "a dogtooth [n -S]\n",
  "CANINES": "CANINE, a dogtooth [n]\n",
  "CANING": "a beating with a rod [n -S]\n",
  "CANINGS": "CANING, a beating with a rod [n]\n",
  "CANINITIES": "CANINITY, the state of being a dog [n]\n",
  "CANINITY": "the state of being a dog [n CANINITIES]\n",
  "CANISTEL": "a Caribbean fruit [n -S]\n",
  "CANISTELS": "CANISTEL, a Caribbean fruit [n]\n",
  "CANISTER": "a small container, usually of metal, used for tea, shot, etc., also CANNISTER [n -S] / to put in a canister [v -ED, -ING, -S]\n",
  "CANISTERED": "CANISTER, to put in a canister [v]\n",
  "CANISTERING": "CANISTER, to put in a canister [v]\n",
  "CANISTERISATION": "the process of canisterising, also CANISTERIZATION [n]\n",
  "CANISTERISE": "to put into a canister, also CANISTERIZE [v CANISTERISED, CANISTERISING, CANISTERISES]\n",
  "CANISTERISED": "CANISTERISE, to put into a canister, also CANISTERIZE [v]\n",
  "CANISTERISES": "CANISTERISE, to put into a canister, also CANISTERIZE [v]\n",
  "CANISTERISING": "CANISTERISE, to put into a canister, also CANISTERIZE [v]\n",
  "CANISTERIZATION": "the process of canisterizing, also CANISTERISATION [n]\n",
  "CANISTERIZE": "to put into a canister, also CANISTERISE [v CANISTERIZED, CANISTERIZING, CANISTERIZES]\n",
  "CANISTERIZED": "CANISTERIZE, to put into a canister, also CANISTERISE [v]\n",
  "CANISTERIZES": "CANISTERIZE, to put into a canister, also CANISTERISE [v]\n",
  "CANISTERIZING": "CANISTERIZE, to put into a canister, also CANISTERISE [v]\n",
  "CANISTERS": "CANISTER, to put in a canister [v]\n",
  "CANITIES": "(Latin) the turning grey of the hair [n CANITIES]\n",
  "CANKER": "to affect with ulcerous sores [v -ED, -ING, -S]\n",
  "CANKERED": "CANKER, to affect with ulcerous sores [v]\n",
  "CANKEREDLY": "CANKERED, CANKER, to affect with ulcerous sores [adv]\n",
  "CANKEREDNESS": "the state of being cankered [n -ES]\n",
  "CANKEREDNESSES": "CANKEREDNESS, the state of being cankered [n]\n",
  "CANKERIER": "CANKERY, like a canker; full of canker [adj]\n",
  "CANKERIEST": "CANKERY, like a canker; full of canker [adj]\n",
  "CANKERING": "CANKER, to affect with ulcerous sores [v]\n",
  "CANKEROUS": "afflicted with a canker [adj]\n",
  "CANKERS": "CANKER, to affect with ulcerous sores [v]\n",
  "CANKERWORM": "a larva that feeds on and destroys plants, esp. fruit [n -S]\n",
  "CANKERWORMS": "CANKERWORM, a larva that feeds on and destroys plants, esp. fruit [n]\n",
  "CANKERY": "like a canker; full of canker [adj CANKERIER, CANKERIEST]\n",
  "CANKLE": "(slang) an obese or otherwise swollen ankle that blends into the calf without clear demarcation [n -S]\n",
  "CANKLES": "CANKLE, (slang) an obese or otherwise swollen ankle that blends into the calf without clear demarcation [n]\n",
  "CANN": "to direct steering [v -ED, -ING, -S]\n",
  "CANNA": "(Latin) a tropical lily with showy red or yellow flowers [n -S]\n",
  "CANNABIC": "of or like cannabis [adj]\n",
  "CANNABIN": "a resin extracted from cannabis [n -S]\n",
  "CANNABINOID": "any of various chemical constituents of cannabis or marijuana [n -S]\n",
  "CANNABINOIDS": "CANNABINOID, any of various chemical constituents of cannabis or marijuana [n]\n",
  "CANNABINOL": "a crystalline phenol obtained from cannabin [n -S]\n",
  "CANNABINOLS": "CANNABINOL, a crystalline phenol obtained from cannabin [n]\n",
  "CANNABINS": "CANNABIN, a resin extracted from cannabis [n]\n",
  "CANNABIS": "hemp; a narcotic drug obtained from hemp [n -ES]\n",
  "CANNABISES": "CANNABIS, hemp; a narcotic drug obtained from hemp [n]\n",
  "CANNACH": "(Scots) a cotton-grass [n -S]\n",
  "CANNACHS": "CANNACH, (Scots) a cotton-grass [n]\n",
  "CANNAE": "(Scots) can not [v]\n",
  "CANNAS": "CANNA, (Latin) a tropical lily with showy red or yellow flowers [n]\n",
  "CANNED": "CANN, to direct steering [v]\n",
  "CANNEL": "a type of dull coal that burns with a smoky luminous flame [n -S]\n",
  "CANNELLINI": "(Italian) the white haricot beans used in French and Italian cooking, also CANELLINI [n -S]\n",
  "CANNELLINIS": "CANNELLINI, (Italian) the white haricot beans used in French and Italian cooking, also CANELLINI [n]\n",
  "CANNELLONI": "(Italian) a kind of pasta [n]\n",
  "CANNELON": "(Italian) a stuffed roll [n -S]\n",
  "CANNELONI": "(Italian) pasta in the shape of tubes, which are usually stuffed [n]\n",
  "CANNELONS": "CANNELON, (Italian) a stuffed roll [n]\n",
  "CANNELS": "CANNEL, a type of dull coal that burns with a smoky luminous flame [n]\n",
  "CANNELURE": "(French) a groove or fluting, esp. around a bullet etc. [n -S]\n",
  "CANNELURES": "CANNELURE, (French) a groove or fluting, esp. around a bullet etc. [n]\n",
  "CANNER": "one that cans food [n -S]\n",
  "CANNERIES": "CANNERY, a place where food is canned [n]\n",
  "CANNERS": "CANNER, one that cans food [n]\n",
  "CANNERY": "a place where food is canned [n CANNERIES]\n",
  "CANNIBAL": "practising cannibalism [adj CANNIBALLY] / one who eats his own kind [n -S]\n",
  "CANNIBALISATION": "the act of cannibalising, also CANNIBALIZATION [n]\n",
  "CANNIBALISE": "to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALIZE [v CANNIBALISED, CANNIBALISING, CANNIBALISES]\n",
  "CANNIBALISED": "CANNIBALISE, to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALIZE [v]\n",
  "CANNIBALISES": "CANNIBALISE, to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALIZE [v]\n",
  "CANNIBALISING": "CANNIBALISE, to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALIZE [v]\n",
  "CANNIBALISM": "the usually ritualistic eating of human flesh by a human being [n -S]\n",
  "CANNIBALISMS": "CANNIBALISM, the usually ritualistic eating of human flesh by a human being [n]\n",
  "CANNIBALISTIC": "relating to cannibalism [adj]\n",
  "CANNIBALIZATION": "the act of cannibalizing, also CANNIBALISATION [n]\n",
  "CANNIBALIZE": "to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALISE [v CANNIBALIZED, CANNIBALIZING, CANNIBALIZES]\n",
  "CANNIBALIZED": "CANNIBALIZE, to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALISE [v]\n",
  "CANNIBALIZES": "CANNIBALIZE, to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALISE [v]\n",
  "CANNIBALIZING": "CANNIBALIZE, to take salvageable parts from (as a disabled machine) for use in building or repairing another machine, also CANNIBALISE [v]\n",
  "CANNIBALLY": "(Shakespeare) in the manner of a cannibal [adv]\n",
  "CANNIBALS": "CANNIBAL, one who eats his own kind [n]\n",
  "CANNIE": "prudent, also CANNY [adj CANNIER, CANNIEST]\n",
  "CANNIER": "CANNIE, prudent, also CANNY [adj]\n",
  "CANNIEST": "CANNIE, prudent, also CANNY [adj]\n",
  "CANNIKIN": "a small can or cup, also CANAKIN, CANIKIN [n -S]\n",
  "CANNIKINS": "CANNIKIN, a small can or cup, also CANAKIN, CANIKIN [n]\n",
  "CANNILY": "CANNY, prudent, also CANNIE [adv]\n",
  "CANNINESS": "the state of being canny [n -ES]\n",
  "CANNINESSES": "CANNINESS, the state of being canny [n]\n",
  "CANNING": "the business of preserving food in airtight containers [n -S]\n",
  "CANNINGS": "CANNING, the business of preserving food in airtight containers [n]\n",
  "CANNISTER": "a small container, usually of metal, used for tea, shot, etc., also CANISTER [n -S]\n",
  "CANNISTERS": "CANNISTER, a small container, usually of metal, used for tea, shot, etc., also CANISTER [n]\n",
  "CANNOLI": "(Italian) a tube of pasta filled with cheese [n -S]\n",
  "CANNOLIS": "CANNOLI, (Italian) a tube of pasta filled with cheese [n]\n",
  "CANNON": "to collide with, strike on the rebound [v -ED, -ING, -S]\n",
  "CANNONADE": "an attack with heavy artillery [n -S] / to attack with heavy artillery [v CANNONADED, CANNONADING, CANNONADES]\n",
  "CANNONADED": "CANNONADE, to attack with heavy artillery [v]\n",
  "CANNONADES": "CANNONADE, to attack with heavy artillery [v]\n",
  "CANNONADING": "CANNONADE, to attack with heavy artillery [v]\n",
  "CANNONBALL": "a ball to be shot from a cannon [n -S] / to go like a cannonball [v -ED, -ING, -S]\n",
  "CANNONBALLED": "CANNONBALL, to go like a cannonball [v]\n",
  "CANNONBALLING": "CANNONBALL, to go like a cannonball [v]\n",
  "CANNONBALLS": "CANNONBALL, to go like a cannonball [v]\n",
  "CANNONED": "CANNON, to collide with, strike on the rebound [v]\n",
  "CANNONEER": "a soldier who managed and fired a cannon, also CANNONIER [n -S]\n",
  "CANNONEERS": "CANNONEER, a soldier who managed and fired a cannon, also CANNONIER [n]\n",
  "CANNONIER": "a soldier who managed and fired a cannon, also CANNONEER [n -S]\n",
  "CANNONIERS": "CANNONIER, a soldier who managed and fired a cannon, also CANNONEER [n]\n",
  "CANNONING": "CANNON, to collide with, strike on the rebound [v]\n",
  "CANNONRIES": "CANNONRY, artillery [n]\n",
  "CANNONRY": "artillery [n CANNONRIES]\n",
  "CANNONS": "CANNON, to collide with, strike on the rebound [v]\n",
  "CANNOT": "the negative form of can [v]\n",
  "CANNS": "CANN, to direct steering [v]\n",
  "CANNULA": "(Latin) a tube inserted into a bodily cavity, also CANULA [n CANNULAS or CANNULAE]\n",
  "CANNULAE": "CANNULA, (Latin) a tube inserted into a bodily cavity, also CANULA [n]\n",
  "CANNULAR": "like a cannula, hollow or tube-shaped, also CANULAR [adj]\n",
  "CANNULAS": "CANNULA, (Latin) a tube inserted into a bodily cavity, also CANULA [n]\n",
  "CANNULATE": "to insert a cannula into, also CANULATE [v CANNULATED, CANNULATING, CANNULATES]\n",
  "CANNULATED": "CANNULATE, to insert a cannula into, also CANULATE [v]\n",
  "CANNULATES": "CANNULATE, to insert a cannula into, also CANULATE [v]\n",
  "CANNULATING": "CANNULATE, to insert a cannula into, also CANULATE [v]\n",
  "CANNULATION": "the process of inserting a cannula into, also CANULATION [n -S]\n",
  "CANNULATIONS": "CANNULATION, the process of inserting a cannula into, also CANULATION [n]\n",
  "CANNY": "prudent, also CANNIE [adj CANNIER, CANNIEST]\n",
  "CANOE": "to paddle a small slender boat [v CANOED, CANOEING, CANOES]\n",
  "CANOEABLE": "navigable by canoe [adj]\n",
  "CANOED": "CANOE, to paddle a small slender boat [v]\n",
  "CANOEING": "the act of travelling by canoe [n -S]\n",
  "CANOEINGS": "CANOEING, the act of travelling by canoe [n]\n",
  "CANOEIST": "one who engages in canoeing [n -S]\n",
  "CANOEISTS": "CANOEIST, one who engages in canoeing [n]\n",
  "CANOEMAN": "a canoeist [n CANOEMEN]\n",
  "CANOEMEN": "CANOEMAN, a canoeist [n]\n",
  "CANOER": "one who travels by canoe [n -S]\n",
  "CANOERS": "CANOER, one who travels by canoe [n]\n",
  "CANOES": "CANOE, to paddle a small slender boat [v]\n",
  "CANOEWOOD": "another name for the tulip tree [n -S]\n",
  "CANOEWOODS": "CANOEWOOD, another name for the tulip tree [n]\n",
  "CANOLA": "edible oil from the rape plant [n -S]\n",
  "CANOLAS": "CANOLA, edible oil from the rape plant [n]\n",
  "CANON": "a member of an order of clergy living in a clergy-house or within the precincts of a cathedral etc. in accordance with the canons of the church [n -S]\n",
  "CANONESS": "a woman living in a community under a religious rule [n -ES]\n",
  "CANONESSES": "CANONESS, a woman living in a community under a religious rule [n]\n",
  "CANONIC": "included in the scriptural canon; relating to any (sets of) sacred books regarded as authentic, also CANONICAL [adj CANONICALLY]\n",
  "CANONICAL": "included in a standard set of works, also CANONIC [adj CANONICALLY]\n",
  "CANONICALLY": "CANONICAL, included in a standard set of works, also CANONIC [adv]\n",
  "CANONICALS": "the official dress of the clergy [n]\n",
  "CANONICATE": "the rank or office of a canon [n -S]\n",
  "CANONICATES": "CANONICATE, the rank or office of a canon [n]\n",
  "CANONICITIES": "CANONICITY, the state of being canonical [n]\n",
  "CANONICITY": "the state of being canonical [n CANONICITIES]\n",
  "CANONISATION": "the act of canonising, also CANONIZATION [n -S]\n",
  "CANONISATIONS": "CANONISATION, the act of canonising, also CANONIZATION [n]\n",
  "CANONISE": "to declare to be a saint, also CANONIZE [v CANONISED, CANONISING, CANONISES]\n",
  "CANONISED": "CANONISE, to declare to be a saint, also CANONIZE [v]\n",
  "CANONISER": "one who canonises, also CANONIZER [n -S]\n",
  "CANONISERS": "CANONISER, one who canonises, also CANONIZER [n]\n",
  "CANONISES": "CANONISE, to declare to be a saint, also CANONIZE [v]\n",
  "CANONISING": "CANONISE, to declare to be a saint, also CANONIZE [v]\n",
  "CANONIST": "a specialist in canon law [n -S]\n",
  "CANONISTIC": "of or pertaining to a canonist [adj]\n",
  "CANONISTS": "CANONIST, a specialist in canon law [n]\n",
  "CANONIZATION": "the act of canonizing, also CANONISATION [n -S]\n",
  "CANONIZATIONS": "CANONIZATION, the act of canonizing, also CANONISATION [n]\n",
  "CANONIZE": "to declare to be a saint, also CANONISE [v CANONIZED, CANONIZING, CANONIZES]\n",
  "CANONIZED": "CANONIZE, to declare to be a saint, also CANONISE [v]\n",
  "CANONIZER": "one who canonises, also CANONISER [n -S]\n",
  "CANONIZERS": "CANONIZER, one who canonises, also CANONISER [n]\n",
  "CANONIZES": "CANONIZE, to declare to be a saint, also CANONISE [v]\n",
  "CANONIZING": "CANONIZE, to declare to be a saint, also CANONISE [v]\n",
  "CANONRIES": "CANONRY, the benefice, office, or status of a canon [n]\n",
  "CANONRY": "the benefice, office, or status of a canon [n CANONRIES]\n",
  "CANONS": "CANON, a member of an order of clergy living in a clergy-house or within the precincts of a cathedral etc. in accordance with the canons of the church [n]\n",
  "CANOODLE": "to kiss and cuddle [v CANOODLED, CANOODLING, CANOODLES]\n",
  "CANOODLED": "CANOODLE, to kiss and cuddle [v]\n",
  "CANOODLER": "one who canoodles [n -S]\n",
  "CANOODLERS": "CANOODLER, one who canoodles [n]\n",
  "CANOODLES": "CANOODLE, to kiss and cuddle [v]\n",
  "CANOODLING": "CANOODLE, to kiss and cuddle [v]\n",
  "CANOPHILIA": "the love of dogs, also CYNOPHILIA [n -S]\n",
  "CANOPHILIAS": "CANOPHILIA, the love of dogs, also CYNOPHILIA [n]\n",
  "CANOPHILIST": "a lover of dogs, also CYNOPHILIST [n -S]\n",
  "CANOPHILISTS": "CANOPHILIST, a lover of dogs, also CYNOPHILIST [n]\n",
  "CANOPHOBIA": "a morbid fear of dogs [n -S]\n",
  "CANOPHOBIAS": "CANOPHOBIA, a morbid fear of dogs [n]\n",
  "CANOPIC": "relating to an Egyptian urn used to hold the viscera of an embalmed body [adj]\n",
  "CANOPIED": "CANOPY, to cover from above [v]\n",
  "CANOPIES": "CANOPY, to cover from above [v]\n",
  "CANOPY": "to cover from above [v CANOPIED, CANOPYING, CANOPIES]\n",
  "CANOPYING": "CANOPY, to cover from above [v]\n",
  "CANOROUS": "musical, resonant [adj CANOROUSLY]\n",
  "CANOROUSLY": "CANOROUS, musical, resonant [adv]\n",
  "CANOROUSNESS": "the state of being canorous [n -ES]\n",
  "CANOROUSNESSES": "CANOROUSNESS, the state of being canorous [n]\n",
  "CANS": "CAN, to put in a cylindrical container [v]\n",
  "CANSFUL": "CANFUL, as much as a can hold [n]\n",
  "CANSO": "(Italian) a love song [n -S]\n",
  "CANSOS": "CANSO, (Italian) a love song [n]\n",
  "CANST": "CAN, to put in a cylindrical container [v]\n",
  "CANSTICK": "(Shakespeare) a candlestick [n -S]\n",
  "CANSTICKS": "CANSTICK, (Shakespeare) a candlestick [n]\n",
  "CANT": "to tilt or slant [v -ED, -ING, -S] / affectedly moral or religious [adj CANTER, CANTEST]\n",
  "CANTABANK": "(Italian) a strolling singer [n -S]\n",
  "CANTABANKS": "CANTABANK, (Italian) a strolling singer [n]\n",
  "CANTABILE": "(Italian) in a melodious, flowing style like singing [adj] / a cantabile passage [n -S]\n",
  "CANTABILES": "CANTABILE, a cantabile passage [n]\n",
  "CANTAL": "a hard cheese of France [n -S]\n",
  "CANTALA": "a coarse fibre used in making strong thread or twine [n -S]\n",
  "CANTALAS": "CANTALA, a coarse fibre used in making strong thread or twine [n]\n",
  "CANTALOUP": "(Italian) a small musk melon with a ribbed skin, also CANTALOUPE [n -S]\n",
  "CANTALOUPE": "(Italian) a small musk melon with a ribbed skin, also CANTALOUP [n -S]\n",
  "CANTALOUPES": "CANTALOUPE, (Italian) a small musk melon with a ribbed skin, also CANTALOUP [n]\n",
  "CANTALOUPS": "CANTALOUP, (Italian) a small musk melon with a ribbed skin, also CANTALOUPE [n]\n",
  "CANTALS": "CANTAL, a hard cheese of France [n]\n",
  "CANTANKEROUS": "difficult or irritating to deal with [adj CANTANKEROUSLY]\n",
  "CANTANKEROUSLY": "CANTANKEROUS, difficult or irritating to deal with [adv]\n",
  "CANTAR": "(Arabic) a Turkish unit of weight equal to approximately 100 pounds, also KANTAR [n -S]\n",
  "CANTARS": "CANTAR, (Arabic) a Turkish unit of weight equal to approximately 100 pounds, also KANTAR [n]\n",
  "CANTATA": "(Italian) a kind of vocal composition with instrumental accompaniment [n -S]\n",
  "CANTATAS": "CANTATA, (Italian) a kind of vocal composition with instrumental accompaniment [n]\n",
  "CANTATE": "(Latin) the 98th psalm [n -S]\n",
  "CANTATES": "CANTATE, (Latin) the 98th psalm [n]\n",
  "CANTATRICE": "(Italian) a female singer [n CANTATRICI or CANTATRICES]\n",
  "CANTATRICES": "CANTATRICE, (Italian) a female singer [n]\n",
  "CANTATRICI": "CANTATRICE, (Italian) a female singer [n]\n",
  "CANTDOG": "a metal hook on a long handle used to move logs, aka peavey, also CANTHOOK [n -S]\n",
  "CANTDOGS": "CANTDOG, a metal hook on a long handle used to move logs, aka peavey, also CANTHOOK [n]\n",
  "CANTED": "CANT, to tilt or slant [v]\n",
  "CANTEEN": "a container used for carrying water [n -S]\n",
  "CANTEENS": "CANTEEN, a container used for carrying water [n]\n",
  "CANTER": "to ride a horse at an easy gallop [v -ED, -ING, -S]\n",
  "CANTERBURIES": "CANTERBURY, a stand with divisions for holding books or music [n]\n",
  "CANTERBURY": "a stand with divisions for holding books or music [n CANTERBURIES or CANTERBURYS]\n",
  "CANTERBURYS": "CANTERBURY, a stand with divisions for holding books or music [n]\n",
  "CANTERED": "CANTER, to ride a horse at an easy gallop [v]\n",
  "CANTERING": "CANTER, to ride a horse at an easy gallop [v]\n",
  "CANTERS": "CANTER, to ride a horse at an easy gallop [v]\n",
  "CANTEST": "CANT, affectedly moral or religious [adj]\n",
  "CANTHAL": "relating to the canthus, the fold of the eye [adj]\n",
  "CANTHARI": "CANTHARUS, (Latin) a large two-handled cup [n]\n",
  "CANTHARID": "a beetle with an elongated cylindrical body of a brilliant green color, aka Spanish fly, also CANTHARIS [n -S]\n",
  "CANTHARIDAL": "of or like a cantharid, also CANTHARIDIAN, CANTHARIDIC [adj]\n",
  "CANTHARIDES": "CANTHARIS, a beetle with an elongated cylindrical body of a brilliant green color, aka Spanish fly, also CANTHARID [n]\n",
  "CANTHARIDIAN": "of or like a cantharid, also CANTHARIDAL, CANTHARIDIC [adj]\n",
  "CANTHARIDIC": "of or like a cantharid, also CANTHARIDAL, CANTHARIDIAN [adj]\n",
  "CANTHARIDIN": "a bitter crystalline compound that is the active blister-producing ingredient of cantharides [n -S]\n",
  "CANTHARIDINS": "CANTHARIDIN, a bitter crystalline compound that is the active blister-producing ingredient of cantharides [n]\n",
  "CANTHARIDS": "CANTHARID, a beetle with an elongated cylindrical body of a brilliant green color, aka Spanish fly, also CANTHARIS [n]\n",
  "CANTHARIS": "a beetle with an elongated cylindrical body of a brilliant green color, aka Spanish fly, also CANTHARID [n CANTHARIDES]\n",
  "CANTHARUS": "(Latin) a large two-handled cup [n CANTHARI]\n",
  "CANTHAXANTHIN": "a naturally occurring carotenoid used esp. as a color additive for food, also CANTHAXANTHINE [n -S]\n",
  "CANTHAXANTHINE": "a naturally occurring carotenoid used esp. as a color additive for food, also CANTHAXANTHIN [n -S]\n",
  "CANTHAXANTHINES": "CANTHAXANTHINE, a naturally occurring carotenoid used esp. as a color additive for food, also CANTHAXANTHIN [n]\n",
  "CANTHAXANTHINS": "CANTHAXANTHIN, a naturally occurring carotenoid used esp. as a color additive for food, also CANTHAXANTHINE [n]\n",
  "CANTHI": "CANTHUS, (Latin) a corner of the eye [n]\n",
  "CANTHIC": "relating to the canthus, the corner of the eye [adj]\n",
  "CANTHITIS": "inflammation of the canthus [n -ES]\n",
  "CANTHITISES": "CANTHITIS, inflammation of the canthus [n]\n",
  "CANTHOOK": "a metal hook on a long handle used to move logs, also CANTDOG [n -S]\n",
  "CANTHOOKS": "CANTHOOK, a metal hook on a long handle used to move logs, also CANTDOG [n]\n",
  "CANTHUS": "(Latin) a corner of the eye [n CANTHI]\n",
  "CANTIC": "slanted [adj]\n",
  "CANTICLE": "a nonmetrical hymn, esp. one used in a church service, such as the Magnificat [n -S]\n",
  "CANTICLES": "CANTICLE, a nonmetrical hymn, esp. one used in a church service, such as the Magnificat [n]\n",
  "CANTICO": "(Native American) to dance as an act of worship, also KANTIKOY, CANTICOY [v -ED, -ING, -S]\n",
  "CANTICOED": "CANTICO, (Native American) to dance as an act of worship, also KANTIKOY, CANTICOY [v]\n",
  "CANTICOING": "CANTICO, (Native American) to dance as an act of worship, also KANTIKOY, CANTICOY [v]\n",
  "CANTICOS": "CANTICO, (Native American) to dance as an act of worship, also KANTIKOY, CANTICOY [v]\n",
  "CANTICOY": "(Native American) to dance as an act of worship, also KANTIKOY, CANTICO [v -ED, -ING, -S]\n",
  "CANTICOYED": "CANTICOY, (Native American) to dance as an act of worship, also KANTIKOY, CANTICO [v]\n",
  "CANTICOYING": "CANTICOY, (Native American) to dance as an act of worship, also KANTIKOY, CANTICO [v]\n",
  "CANTICOYS": "CANTICOY, (Native American) to dance as an act of worship, also KANTIKOY, CANTICO [v]\n",
  "CANTICUM": "(Latin) a canticle, a part-song in an ancient play [n -S]\n",
  "CANTICUMS": "CANTICUM, (Latin) a canticle, a part-song in an ancient play [n]\n",
  "CANTIER": "CANTY, (Scots) contented [adj]\n",
  "CANTIEST": "CANTY, (Scots) contented [adj]\n",
  "CANTILENA": "(Italian) a smooth, flowing melody or vocal style [n -S]\n",
  "CANTILENAS": "CANTILENA, (Italian) a smooth, flowing melody or vocal style [n]\n",
  "CANTILEVER": "a kind of bridge [n -S] / to project or support like a cantilever [v -ED, -ING, -S]\n",
  "CANTILEVERED": "CANTILEVER, to project or support like a cantilever [v]\n",
  "CANTILEVERING": "CANTILEVER, to project or support like a cantilever [v]\n",
  "CANTILEVERS": "CANTILEVER, to project or support like a cantilever [v]\n",
  "CANTILLATE": "to chant or intone, esp. Hebrew scriptures in the Jewish liturgical service [v CANTILLATED, CANTILLATING, CANTILLATES]\n",
  "CANTILLATED": "CANTILLATE, to chant or intone, esp. Hebrew scriptures in the Jewish liturgical service [v]\n",
  "CANTILLATES": "CANTILLATE, to chant or intone, esp. Hebrew scriptures in the Jewish liturgical service [v]\n",
  "CANTILLATING": "CANTILLATE, to chant or intone, esp. Hebrew scriptures in the Jewish liturgical service [v]\n",
  "CANTILLATION": "chanting [n -S]\n",
  "CANTILLATIONS": "CANTILLATION, chanting [n]\n",
  "CANTILLATORY": "relating to cantillation, chanting [adj]\n",
  "CANTILY": "CANTY, (Scots) contented [adv]\n",
  "CANTINA": "(Spanish) a bar or saloon; a wineshop [n -S]\n",
  "CANTINAS": "CANTINA, (Spanish) a bar or saloon; a wineshop [n]\n",
  "CANTINESS": "(Scots) cheerfulness, liveliness [n -ES]\n",
  "CANTINESSES": "CANTINESS, (Scots) cheerfulness, liveliness [n]\n",
  "CANTING": "whining, pretending to piety [adj CANTINGLY] / the act of canting [n -S]\n",
  "CANTINGLY": "CANTING, whining, pretending to piety [adv]\n",
  "CANTINGS": "CANTING, the act of canting [n]\n",
  "CANTION": "(Spenser) a song [n -S]\n",
  "CANTIONS": "CANTION, (Spenser) a song [n]\n",
  "CANTLE": "to break a piece from [v CANTLED, CANTLING, CANTLES]\n",
  "CANTLED": "CANTLE, to break a piece from [v]\n",
  "CANTLES": "CANTLE, to break a piece from [v]\n",
  "CANTLET": "a fragment [n -S]\n",
  "CANTLETS": "CANTLET, a fragment [n]\n",
  "CANTLING": "CANTLE, to break a piece from [v]\n",
  "CANTO": "(Italian) a division of a long poem [n -S]\n",
  "CANTON": "to divide into districts [v -ED, -ING, -S]\n",
  "CANTONAL": "pertaining to a canton [adj]\n",
  "CANTONED": "CANTON, to divide into districts [v]\n",
  "CANTONING": "CANTON, to divide into districts [v]\n",
  "CANTONISATION": "the act of dividing into cantons, also CANTONIZATION [n -S]\n",
  "CANTONISATIONS": "CANTONISATION, the act of dividing into cantons, also CANTONIZATION [n]\n",
  "CANTONISE": "to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONIZE [v CANTONISED, CANTONISING, CANTONISES]\n",
  "CANTONISED": "CANTONISE, to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONIZE [v]\n",
  "CANTONISES": "CANTONISE, to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONIZE [v]\n",
  "CANTONISING": "CANTONISE, to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONIZE [v]\n",
  "CANTONIZATION": "the act of dividing into cantons, also CANTONISATION [n -S]\n",
  "CANTONIZATIONS": "CANTONIZATION, the act of dividing into cantons, also CANTONISATION [n]\n",
  "CANTONIZE": "to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONISE [v CANTONIZED, CANTONIZING, CANTONIZES]\n",
  "CANTONIZED": "CANTONIZE, to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONISE [v]\n",
  "CANTONIZES": "CANTONIZE, to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONISE [v]\n",
  "CANTONIZING": "CANTONIZE, to divide (a town etc.) into separate regions according to the religion or ethnic origins of the inhabitants, also CANTONISE [v]\n",
  "CANTONMENT": "a small military town [n -S]\n",
  "CANTONMENTS": "CANTONMENT, a small military town [n]\n",
  "CANTONS": "CANTON, to divide into districts [v]\n",
  "CANTOR": "(Latin) a singer; esp. the leader of a church choir [n -S]\n",
  "CANTORIAL": "located on the north side of the choir in a church [adj]\n",
  "CANTORIS": "(Latin) to be sung on the north side of the choir [adj]\n",
  "CANTORS": "CANTOR, (Latin) a singer; esp. the leader of a church choir [n]\n",
  "CANTOS": "CANTO, (Italian) a division of a long poem [n]\n",
  "CANTRAIP": "(Scots) a charm; an incantation, also CANTRAP, CANTRIP [n -S]\n",
  "CANTRAIPS": "CANTRAIP, (Scots) a charm; an incantation, also CANTRAP, CANTRIP [n]\n",
  "CANTRAP": "(Scots) a magic spell, also CANTRIP, CANTRAIP [n -S]\n",
  "CANTRAPS": "CANTRAP, (Scots) a magic spell, also CANTRIP, CANTRAIP [n]\n",
  "CANTRED": "(Welsh) a district comprising a hundred villages, also CANTREF [n -S]\n",
  "CANTREDS": "CANTRED, (Welsh) a district comprising a hundred villages, also CANTREF [n]\n",
  "CANTREF": "(Welsh) a district comprising a hundred villages, also CANTRED [n -S]\n",
  "CANTREFS": "CANTREF, (Welsh) a district comprising a hundred villages, also CANTRED [n]\n",
  "CANTRIP": "(Scots) a charm; an incantation, also CANTRAIP, CANTRAP [n -S]\n",
  "CANTRIPS": "CANTRIP, (Scots) a charm; an incantation, also CANTRAIP, CANTRAP [n]\n",
  "CANTS": "CANT, to tilt or slant [v]\n",
  "CANTUS": "(Latin) a melody or chant, esp. in mediaeval ecclesiastical music [n -ES]\n",
  "CANTUSES": "CANTUS, (Latin) a melody or chant, esp. in mediaeval ecclesiastical music [n]\n",
  "CANTY": "(Scots) contented [adj CANTIER, CANTIEST, CANTILY]\n",
  "CANULA": "(Latin) a tube inserted into a bodily cavity, also CANNULA [n CANULAS or CANULAE]\n",
  "CANULAE": "CANULA, (Latin) a tube inserted into a bodily cavity, also CANNULA [n]\n",
  "CANULAR": "relating to a canula [adj]\n",
  "CANULAS": "CANULA, (Latin) a tube inserted into a bodily cavity, also CANNULA [n]\n",
  "CANULATE": "to insert a canula into, also CANNULATE [v CANULATED, CANULATING, CANULATES]\n",
  "CANULATED": "CANULATE, to insert a canula into, also CANNULATE [v]\n",
  "CANULATES": "CANULATE, to insert a canula into, also CANNULATE [v]\n",
  "CANULATING": "CANULATE, to insert a canula into, also CANNULATE [v]\n",
  "CANULATION": "the process of inserting a canula into, also CANNULATION [n -S]\n",
  "CANULATIONS": "CANULATION, the process of inserting a canula into, also CANNULATION [n]\n",
  "CANVAS": "to examine thoroughly, also CANVASS [v CANVASED or CANVASSED, CANVASING or CANVASSING, CANVASES or CANVASSES]\n",
  "CANVASBACK": "a species of duck, so named from the markings of the plumage on its back [n -S]\n",
  "CANVASBACKS": "CANVASBACK, a species of duck, so named from the markings of the plumage on its back [n]\n",
  "CANVASED": "CANVAS, to examine thoroughly, also CANVASS [v]\n",
  "CANVASER": "one who goes from door to door raising votes, also CANVASSER [n -S]\n",
  "CANVASERS": "CANVASER, one who goes from door to door raising votes, also CANVASSER [n]\n",
  "CANVASES": "CANVAS, to examine thoroughly, also CANVASS [v]\n",
  "CANVASING": "CANVAS, to examine thoroughly, also CANVASS [v]\n",
  "CANVASLIKE": "like canvas [adj]\n",
  "CANVASS": "to examine thoroughly, also CANVAS [v -ED, -ING, -ES]\n",
  "CANVASSED": "CANVASS, to examine thoroughly, also CANVAS [v]\n",
  "CANVASSER": "one who goes from door to door raising votes, also CANVASER [n -S]\n",
  "CANVASSERS": "CANVASSER, one who goes from door to door raising votes, also CANVASER [n]\n",
  "CANVASSES": "CANVASS, to examine thoroughly, also CANVAS [v]\n",
  "CANVASSING": "the act of going from door to door raising votes [n -S]\n",
  "CANVASSINGS": "CANVASSING, the act of going from door to door raising votes [n]\n",
  "CANY": "like cane, abounding in cane [adj CANIER, CANIEST]\n",
  "CANYON": "(Spanish) a deep gorge or ravine [n -S]\n",
  "CANYONEER": "a canyon explorer [n -S]\n",
  "CANYONEERS": "CANYONEER, a canyon explorer [n]\n",
  "CANYONING": "the sport of going down a canyon river by any of various means [n -S]\n",
  "CANYONINGS": "CANYONING, the sport of going down a canyon river by any of various means [n]\n",
  "CANYONS": "CANYON, (Spanish) a deep gorge or ravine [n]\n",
  "CANZONA": "(Italian) a song resembling a madrigal but less strict, also CANZONE [n -S]\n",
  "CANZONAS": "CANZONA, (Italian) a song resembling a madrigal but less strict, also CANZONE [n]\n",
  "CANZONE": "(Italian) a song resembling a madrigal but less strict, also CANZONA [n CANZONES or CANZONI]\n",
  "CANZONES": "CANZONE, (Italian) a song resembling a madrigal but less strict, also CANZONA [n]\n",
  "CANZONET": "(Italian) a short song [n -S]\n",
  "CANZONETS": "CANZONET, (Italian) a short song [n]\n",
  "CANZONETTA": "(Italian) a short canzone, also CANZONET [n CANZONETTE or CANZONETTAS]\n",
  "CANZONETTAS": "CANZONETTA, (Italian) a short canzone, also CANZONET [n]\n",
  "CANZONETTE": "CANZONETTA, (Italian) a short canzone, also CANZONET [n]\n",
  "CANZONI": "CANZONE, (Italian) a song resembling a madrigal but less strict, also CANZONA [n]\n",
  "CAOUTCHOUC": "(Quechua) un-vulcanized natural rubber [n -S]\n",
  "CAOUTCHOUCS": "CAOUTCHOUC, (Quechua) un-vulcanized natural rubber [n]\n",
  "CAP": "to provide with a type of head covering [v CAPPED, CAPPING, CAPS]\n",
  "CAPA": "(Spanish) a type of cloak [n -S]\n",
  "CAPABILITIES": "CAPABILITY, the state of being capable [n]\n",
  "CAPABILITY": "the state of being capable [n CAPABILITIES]\n",
  "CAPABLE": "competent [adj CAPABLER, CAPABLEST, CAPABLY]\n",
  "CAPABLENESS": "the state of being capable [n -ES]\n",
  "CAPABLENESSES": "CAPABLENESS, the state of being capable [n]\n",
  "CAPABLER": "CAPABLE, competent [adj]\n",
  "CAPABLEST": "CAPABLE, competent [adj]\n",
  "CAPABLY": "CAPABLE, competent [adv]\n",
  "CAPACIOUS": "roomy [adj CAPACIOUSLY]\n",
  "CAPACIOUSLY": "CAPACIOUS, roomy [adv]\n",
  "CAPACIOUSNESS": "the state of being capacious [n -ES]\n",
  "CAPACIOUSNESSES": "CAPACIOUSNESS, the state of being capacious [n]\n",
  "CAPACITANCE": "in electricity, the ability to store an electric charge; measure of such ability [n -S]\n",
  "CAPACITANCES": "CAPACITANCE, in electricity, the ability to store an electric charge; measure of such ability [n]\n",
  "CAPACITATE": "to make or render capable [v CAPACITATED, CAPACITATING, CAPACITATES]\n",
  "CAPACITATED": "CAPACITATE, to make or render capable [v]\n",
  "CAPACITATES": "CAPACITATE, to make or render capable [v]\n",
  "CAPACITATING": "CAPACITATE, to make or render capable [v]\n",
  "CAPACITATION": "the change undergone by sperm in the female reproductive tract that enables them to penetrate and fertilize an egg [n -S]\n",
  "CAPACITATIONS": "CAPACITATION, the change undergone by sperm in the female reproductive tract that enables them to penetrate and fertilize an egg [n]\n",
  "CAPACITIES": "CAPACITY, the ability to receive or contain [n]\n",
  "CAPACITIVE": "relating to capacitance [adj CAPACITIVELY]\n",
  "CAPACITIVELY": "CAPACITIVE, relating to capacitance [adv]\n",
  "CAPACITOR": "an electrical device capable of storing electric charge [n -S]\n",
  "CAPACITORS": "CAPACITOR, an electrical device capable of storing electric charge [n]\n",
  "CAPACITY": "the ability to receive or contain [n CAPACITIES]\n",
  "CAPARISON": "an ornamented covering for a horse, esp. a warhorse [n -S] / to adorn a horse [v -ED, -ING, -S]\n",
  "CAPARISONED": "CAPARISON, to adorn a horse [v]\n",
  "CAPARISONING": "CAPARISON, to adorn a horse [v]\n",
  "CAPARISONS": "CAPARISON, to adorn a horse [v]\n",
  "CAPAS": "CAPA, (Spanish) a type of cloak [n]\n",
  "CAPCOM": "a person who assists a space mission [n -S]\n",
  "CAPCOMS": "CAPCOM, a person who assists a space mission [n]\n",
  "CAPE": "a head or point of land jutting into the sea or a lake [n -S] / to keep a course towards a cape [v CAPED, CAPING, CAPES]\n",
  "CAPED": "CAPE, to keep a course towards a cape [v]\n",
  "CAPEESH": "used to ask if one understands, also CAPICHE, CAPISCE, CAPISH [interj]\n",
  "CAPELAN": "(French) a small marine fish of northern oceans, also CAPELIN, CAPLIN [n -S]\n",
  "CAPELANS": "CAPELAN, (French) a small marine fish of northern oceans, also CAPELIN, CAPLIN [n]\n",
  "CAPELET": "a small cape [n -S]\n",
  "CAPELETS": "CAPELET, a small cape [n]\n",
  "CAPELIKE": "like a cape [adj]\n",
  "CAPELIN": "(French) a small marine fish of northern oceans, also CAPELAN, CAPLIN [n -S]\n",
  "CAPELINE": "a small iron skullcap worn by archers [n -S]\n",
  "CAPELINES": "CAPELINE, a small iron skullcap worn by archers [n]\n",
  "CAPELINS": "CAPELIN, (French) a small marine fish of northern oceans, also CAPELAN, CAPLIN [n]\n",
  "CAPELLET": "(French) a swelling on a horse's hock [n -S]\n",
  "CAPELLETS": "CAPELLET, (French) a swelling on a horse's hock [n]\n",
  "CAPELLINE": "a small iron skullcap worn by archers, also CAPELINE [n -S]\n",
  "CAPELLINES": "CAPELLINE, a small iron skullcap worn by archers, also CAPELINE [n]\n",
  "CAPELLINI": "(Italian) a type of pasta [n -S]\n",
  "CAPELLINIS": "CAPELLINI, (Italian) a type of pasta [n]\n",
  "CAPELLMEISTER": "(German) the director of a choir or orchestra, also KAPELLMEISTER [n -S]\n",
  "CAPELLMEISTERS": "CAPELLMEISTER, (German) the director of a choir or orchestra, also KAPELLMEISTER [n]\n",
  "CAPER": "to leap or skip like a goat [v -ED, -ING, -S]\n",
  "CAPERCAILLIE": "(Gaelic) a large Scottish bird of the grouse family, also CAPERCAILZIE [n -S]\n",
  "CAPERCAILLIES": "CAPERCAILLIE, (Gaelic) a large Scottish bird of the grouse family, also CAPERCAILZIE [n]\n",
  "CAPERCAILZIE": "(Gaelic) a large Scottish bird of the grouse family, also CAPERCAILLIE [n -S]\n",
  "CAPERCAILZIES": "CAPERCAILZIE, (Gaelic) a large Scottish bird of the grouse family, also CAPERCAILLIE [n]\n",
  "CAPERED": "CAPER, to leap or skip like a goat [v]\n",
  "CAPERER": "one who capers [n -S]\n",
  "CAPERERS": "CAPERER, one who capers [n]\n",
  "CAPERING": "CAPER, to leap or skip like a goat [v]\n",
  "CAPERINGLY": "CAPERING, CAPER, to leap or skip like a goat [adv]\n",
  "CAPERNOITED": "slightly intoxicated or tipsy [adj]\n",
  "CAPERNOITIE": "(Scots) the head, noddle, also CAPERNOITY, CAPPERNOITY [n -S]\n",
  "CAPERNOITIES": "CAPERNOITIE, (Scots) the head, noddle, also CAPERNOITY, CAPPERNOITY [n]\n",
  "CAPERNOITY": "(Scots) the head, noddle, also CAPERNOITIE, CAPPERNOITY [n CAPERNOITIES]\n",
  "CAPERS": "CAPER, to leap or skip like a goat [v]\n",
  "CAPES": "CAPE, to keep a course towards a cape [v]\n",
  "CAPESKIN": "a type of soft leather made from the skins of longhaired sheep or lambs [n -S]\n",
  "CAPESKINS": "CAPESKIN, a type of soft leather made from the skins of longhaired sheep or lambs [n]\n",
  "CAPEWORK": "a matador's performance with his cape [n -S]\n",
  "CAPEWORKS": "CAPEWORK, a matador's performance with his cape [n]\n",
  "CAPEX": "(short for) capital expenditure [n -ES]\n",
  "CAPEXES": "CAPEX, (short for) capital expenditure [n]\n",
  "CAPFUL": "as much as a cap can hold [n -S]\n",
  "CAPFULS": "CAPFUL, as much as a cap can hold [n]\n",
  "CAPH": "(Hebrew) the eleventh letter of the Hebrew alphabet, also KAF, KAPH, KHAF, KHAPH [n -S]\n",
  "CAPHS": "CAPH, (Hebrew) the eleventh letter of the Hebrew alphabet, also KAF, KAPH, KHAF, KHAPH [n]\n",
  "CAPI": "CAPO, (Italian) the head of a branch of the Mafia [n]\n",
  "CAPIAS": "(Latin) a writ authorizing the arrest of a person [n -ES]\n",
  "CAPIASES": "CAPIAS, (Latin) a writ authorizing the arrest of a person [n]\n",
  "CAPICHE": "used to ask if one understands, also CAPEESH, CAPISCE, CAPISH [interj]\n",
  "CAPICOLLA": "(Italian) a traditional Italian cold cut of pork, also CAPICOLLO [n -S]\n",
  "CAPICOLLAS": "CAPICOLLA, (Italian) a traditional Italian cold cut of pork, also CAPICOLLO [n]\n",
  "CAPICOLLO": "(Italian) a traditional Italian cold cut of pork, also CAPICOLLA [n -S]\n",
  "CAPICOLLOS": "CAPICOLLO, (Italian) a traditional Italian cold cut of pork, also CAPICOLLA [n]\n",
  "CAPILLACEOUS": "hairlike [adj]\n",
  "CAPILLAIRE": "(French) a syrup, an infusion of maidenhair fern flavoured with orange-flower water [n -S]\n",
  "CAPILLAIRES": "CAPILLAIRE, (French) a syrup, an infusion of maidenhair fern flavoured with orange-flower water [n]\n",
  "CAPILLARIES": "CAPILLARY, any of the extremely narrow blood vessels which form a network between the arterioles and venules [n]\n",
  "CAPILLARITIES": "CAPILLARITY, the property or state of being capillary [n]\n",
  "CAPILLARITY": "the property or state of being capillary [n CAPILLARITIES]\n",
  "CAPILLARY": "any of the extremely narrow blood vessels which form a network between the arterioles and venules [n CAPILLARIES]\n",
  "CAPILLITIA": "CAPILLITIUM, a mass of threads [n]\n",
  "CAPILLITIUM": "a mass of threads [n CAPILLITIA]\n",
  "CAPING": "CAPE, to keep a course towards a cape [v]\n",
  "CAPISCE": "used to ask if one understands, also CAPEESH, CAPICHE, CAPISH [interj]\n",
  "CAPISH": "used to ask if one understands, also CAPEESH, CAPICHE, CAPISCE [interj]\n",
  "CAPITA": "CAPUT, (Latin) the head; also, a knoblike protuberance or capitulum [n]\n",
  "CAPITAL": "excellent [adj CAPITALLY] / the upper part of a column [n -S]\n",
  "CAPITALISATION": "the process of capitalising, also CAPITALIZATION [n -S]\n",
  "CAPITALISATIONS": "CAPITALISATION, the process of capitalising, also CAPITALIZATION [n]\n",
  "CAPITALISE": "to write or print with an initial capital or in capitals, also CAPITALIZE [v CAPITALISED, CAPITALISING, CAPITALISES]\n",
  "CAPITALISED": "CAPITALISE, to write or print with an initial capital or in capitals, also CAPITALIZE [v]\n",
  "CAPITALISES": "CAPITALISE, to write or print with an initial capital or in capitals, also CAPITALIZE [v]\n",
  "CAPITALISING": "CAPITALISE, to write or print with an initial capital or in capitals, also CAPITALIZE [v]\n",
  "CAPITALISM": "the economic system which is driven by the profit motive and depends on the investment of private capital to provide the means of production, distribution and exchange [n -S]\n",
  "CAPITALISMS": "CAPITALISM, the economic system which is driven by the profit motive and depends on the investment of private capital to provide the means of production, distribution and exchange [n]\n",
  "CAPITALIST": "a person who has capital esp. invested in business [n -S]\n",
  "CAPITALISTIC": "relating to capitalism [adj]\n",
  "CAPITALISTS": "CAPITALIST, a person who has capital esp. invested in business [n]\n",
  "CAPITALIZATION": "the act of capitalizing, also CAPITALISATION [n -S]\n",
  "CAPITALIZATIONS": "CAPITALIZATION, the act of capitalizing, also CAPITALISATION [n]\n",
  "CAPITALIZE": "to write or print with an initial capital or in capitals, also CAPITALISE [v CAPITALIZED, CAPITALIZING, CAPITALIZES]\n",
  "CAPITALIZED": "CAPITALIZE, to write or print with an initial capital or in capitals, also CAPITALISE [v]\n",
  "CAPITALIZES": "CAPITALIZE, to write or print with an initial capital or in capitals, also CAPITALISE [v]\n",
  "CAPITALIZING": "CAPITALIZE, to write or print with an initial capital or in capitals, also CAPITALISE [v]\n",
  "CAPITALLY": "CAPITAL, excellent [adv]\n",
  "CAPITALS": "CAPITAL, the upper part of a column [n]\n",
  "CAPITAN": "(historical) the chief admiral of the Turkish fleet [n -S]\n",
  "CAPITANI": "CAPITANO, (Italian) a headman [n]\n",
  "CAPITANO": "(Italian) a headman [n CAPITANI or CAPITANOS]\n",
  "CAPITANOS": "CAPITANO, (Italian) a headman [n]\n",
  "CAPITANS": "CAPITAN, (historical) the chief admiral of the Turkish fleet [n]\n",
  "CAPITATE": "a bone of a primate's wrist [n -S]\n",
  "CAPITATED": "having fixed upper limits [adj]\n",
  "CAPITATES": "CAPITATE, a bone of a primate's wrist [n]\n",
  "CAPITATION": "a uniform tax assessed by the head; a fee extracted from each student [n -S]\n",
  "CAPITATIONS": "CAPITATION, a uniform tax assessed by the head; a fee extracted from each student [n]\n",
  "CAPITATIVE": "relating to capitation [adj]\n",
  "CAPITAYN": "(Spenser) a captain [n -S]\n",
  "CAPITAYNS": "CAPITAYN, (Spenser) a captain [n]\n",
  "CAPITELLA": "CAPITULUM, (Latin) a flower cluster as in a daisy [n]\n",
  "CAPITELLUM": "the capitulum of the humerus, where the humerus plugs into the acetabulum [n CAPITELLA]\n",
  "CAPITOL": "a building occupied by a state legislature [n -S]\n",
  "CAPITOLIAN": "of or pertaining to the Capitol in Rome, also CAPITOLINE [adj]\n",
  "CAPITOLINE": "of or pertaining to the Capitol in Rome, also CAPITOLIAN [adj]\n",
  "CAPITOLS": "CAPITOL, a building occupied by a state legislature [n]\n",
  "CAPITULA": "CAPITULUM, (Latin) a flower cluster as in a daisy [n]\n",
  "CAPITULANT": "a person who capitulates [n -S]\n",
  "CAPITULANTS": "CAPITULANT, a person who capitulates [n]\n",
  "CAPITULAR": "relating or belonging to a chapter in a cathedral [adj CAPITULARLY] / a statute passed in a chapter or ecclesiastical court; a member of a chapter [n -S]\n",
  "CAPITULARIES": "CAPITULARY, a collection of ordinances, esp. of Frankish kings [n]\n",
  "CAPITULARLY": "CAPITULAR, relating or belonging to a chapter in a cathedral [adv]\n",
  "CAPITULARS": "CAPITULAR, a statute passed in a chapter or ecclesiastical court; a member of a chapter [n]\n",
  "CAPITULARY": "a collection of ordinances, esp. of Frankish kings [n CAPITULARIES]\n",
  "CAPITULATE": "to yield, accept terms [v CAPITULATED, CAPITULATING, CAPITULATES]\n",
  "CAPITULATED": "CAPITULATE, to yield, accept terms [v]\n",
  "CAPITULATES": "CAPITULATE, to yield, accept terms [v]\n",
  "CAPITULATING": "CAPITULATE, to yield, accept terms [v]\n",
  "CAPITULATION": "a set of terms or articles constituting an agreement between governments [n -S]\n",
  "CAPITULATIONS": "CAPITULATION, a set of terms or articles constituting an agreement between governments [n]\n",
  "CAPITULATOR": "one who capitulates [n -S]\n",
  "CAPITULATORS": "CAPITULATOR, one who capitulates [n]\n",
  "CAPITULATORY": "of the nature of capitulation [adj]\n",
  "CAPITULUM": "(Latin) a flower cluster as in a daisy [n CAPITULA]\n",
  "CAPIZ": "(Tagalog) the translucent shell of a bivalve mollusc, used in making jewellery [n -ES]\n",
  "CAPIZES": "CAPIZ, (Tagalog) the translucent shell of a bivalve mollusc, used in making jewellery [n]\n",
  "CAPLE": "a horse, also CAPUL [n -S]\n",
  "CAPLES": "CAPLE, a horse, also CAPUL [n]\n",
  "CAPLESS": "without a cap [adj]\n",
  "CAPLET": "(tradename) a kind of medicinal tablet, usually in oval form for easy swallowing [n -S]\n",
  "CAPLETS": "CAPLET, (tradename) a kind of medicinal tablet, usually in oval form for easy swallowing [n]\n",
  "CAPLIKE": "like a cap [adj]\n",
  "CAPLIN": "(French) a small marine fish of northern oceans, also CAPELIN, CAPELAN [n -S]\n",
  "CAPLINS": "CAPLIN, (French) a small marine fish of northern oceans, also CAPELIN, CAPELAN [n]\n",
  "CAPMAKER": "one that makes caps [n -S]\n",
  "CAPMAKERS": "CAPMAKER, one that makes caps [n]\n",
  "CAPNOMANCIES": "CAPNOMANCY, divination by means of smoke [n]\n",
  "CAPNOMANCY": "divination by means of smoke [n CAPNOMANCIES]\n",
  "CAPO": "(Italian) the head of a branch of the Mafia [n CAPOS or CAPI]\n",
  "CAPOCCHIA": "(Shakespeare) a simpleton, also CHIPOCHIA [n -S]\n",
  "CAPOCCHIAS": "CAPOCCHIA, (Shakespeare) a simpleton, also CHIPOCHIA [n]\n",
  "CAPODASTRO": "(Italian) a moveable bridge secured over the fingerboard and strings of a guitar, also CAPOTASTO [n -S]\n",
  "CAPODASTROS": "CAPODASTRO, (Italian) a moveable bridge secured over the fingerboard and strings of a guitar, also CAPOTASTO [n]\n",
  "CAPOEIRA": "(Portuguese) a martial art and dance combination [n -S]\n",
  "CAPOEIRAS": "CAPOEIRA, (Portuguese) a martial art and dance combination [n]\n",
  "CAPON": "a castrated cock [n -S]\n",
  "CAPONATA": "(Italian) a type of Italian fish salad [n -S]\n",
  "CAPONATAS": "CAPONATA, (Italian) a type of Italian fish salad [n]\n",
  "CAPONIER": "(French) a work made across or in the ditch, to protect it from the enemy, or to serve as a covered passageway, also CAPONIERE [n -S]\n",
  "CAPONIERE": "(French) a work made across or in the ditch, to protect it from the enemy, or to serve as a covered passageway, also CAPONIER [n -S]\n",
  "CAPONIERES": "CAPONIERE, (French) a work made across or in the ditch, to protect it from the enemy, or to serve as a covered passageway, also CAPONIER [n]\n",
  "CAPONIERS": "CAPONIER, (French) a work made across or in the ditch, to protect it from the enemy, or to serve as a covered passageway, also CAPONIERE [n]\n",
  "CAPONISE": "to castrate a rooster, also CAPONIZE [v CAPONISED, CAPONISING, CAPONISES]\n",
  "CAPONISED": "CAPONISE, to castrate a rooster, also CAPONIZE [v]\n",
  "CAPONISES": "CAPONISE, to castrate a rooster, also CAPONIZE [v]\n",
  "CAPONISING": "CAPONISE, to castrate a rooster, also CAPONIZE [v]\n",
  "CAPONIZE": "to castrate a rooster, also CAPONISE [v CAPONIZED, CAPONIZING, CAPONIZES]\n",
  "CAPONIZED": "CAPONIZE, to castrate a rooster, also CAPONISE [v]\n",
  "CAPONIZES": "CAPONIZE, to castrate a rooster, also CAPONISE [v]\n",
  "CAPONIZING": "CAPONIZE, to castrate a rooster, also CAPONISE [v]\n",
  "CAPONS": "CAPON, a castrated cock [n]\n",
  "CAPORAL": "(French) a coarse, strong, dark tobacco [n -S]\n",
  "CAPORALS": "CAPORAL, (French) a coarse, strong, dark tobacco [n]\n",
  "CAPOS": "CAPO, (Italian) the head of a branch of the Mafia [n]\n",
  "CAPOT": "to win all the tricks [v CAPOTTED, CAPOTTING, CAPOTS]\n",
  "CAPOTASTO": "(Italian) a moveable bridge secured over the fingerboard and strings of a guitar, also CAPODASTRO [n -S]\n",
  "CAPOTASTOS": "CAPOTASTO, (Italian) a moveable bridge secured over the fingerboard and strings of a guitar, also CAPODASTRO [n]\n",
  "CAPOTE": "(French) a long cloak or overcoat, esp. one with a hood [n -S]\n",
  "CAPOTES": "CAPOTE, (French) a long cloak or overcoat, esp. one with a hood [n]\n",
  "CAPOTS": "CAPOT, to win all the tricks [v]\n",
  "CAPOTTED": "CAPOT, to win all the tricks [v]\n",
  "CAPOTTING": "CAPOT, to win all the tricks [v]\n",
  "CAPOUCH": "a cloak hood, also CAPUCCIO, CAPUCHE [n -ES]\n",
  "CAPOUCHES": "CAPOUCH, a cloak hood, also CAPUCCIO, CAPUCHE [n]\n",
  "CAPPARIDACEOUS": "of the Capparidaceae family of plants, related to the crucifers, and including the caper [adj]\n",
  "CAPPED": "CAP, to provide with a type of head covering [v]\n",
  "CAPPELLETTI": "(Italian) small hat-shaped pasta pieces, filled with meat or cheese [n]\n",
  "CAPPER": "one whose business is to make or sell caps [n -S]\n",
  "CAPPERNOITIES": "CAPPERNOITY, (Scots) the head, noddle, also CAPERNOITIE, CAPERNOITY [n]\n",
  "CAPPERNOITY": "(Scots) the head, noddle, also CAPERNOITIE, CAPERNOITY [n CAPPERNOITIES]\n",
  "CAPPERS": "CAPPER, one whose business is to make or sell caps [n]\n",
  "CAPPING": "a wax covering in a honeycomb [n -S]\n",
  "CAPPINGS": "CAPPING, a wax covering in a honeycomb [n]\n",
  "CAPPUCCINI": "CAPPUCCINO, (Italian) black coffee with a little milk [n]\n",
  "CAPPUCCINO": "(Italian) black coffee with a little milk [n CAPPUCCINI or CAPPUCCINOS]\n",
  "CAPPUCCINOS": "CAPPUCCINO, (Italian) black coffee with a little milk [n]\n",
  "CAPRATE": "a salt of capric acid [n -S]\n",
  "CAPRATES": "CAPRATE, a salt of capric acid [n]\n",
  "CAPREOLATE": "having or resembling tentacles [adj]\n",
  "CAPRESE": "(Italian) a salad containing mozzarella, basil, tomatoes and olive oil [n -S]\n",
  "CAPRESES": "CAPRESE, (Italian) a salad containing mozzarella, basil, tomatoes and olive oil [n]\n",
  "CAPRI": "as in capri pants, women's tapering trousers ending above the ankle [adj]\n",
  "CAPRIC": "pertaining to a goat, also CAPRINE [adj]\n",
  "CAPRICCI": "CAPRICCIO, (Italian) a free form musical composition [n]\n",
  "CAPRICCIO": "(Italian) a free form musical composition [n CAPRICCIOS or CAPRICCI]\n",
  "CAPRICCIOS": "CAPRICCIO, (Italian) a free form musical composition [n]\n",
  "CAPRICCIOSO": "(Italian) in a free and impulsive style [adv]\n",
  "CAPRICE": "a whim, an unpredictable change of behaviour [n -S]\n",
  "CAPRICES": "CAPRICE, a whim, an unpredictable change of behaviour [n]\n",
  "CAPRICIOUS": "subject to whim; impulsive and unpredictable [adj CAPRICIOUSLY]\n",
  "CAPRICIOUSLY": "CAPRICIOUS, subject to whim; impulsive and unpredictable [adv]\n",
  "CAPRICIOUSNESS": "CAPRICIOUS, subject to whim; impulsive and unpredictable [n]\n",
  "CAPRID": "a member of the goat family [n -S]\n",
  "CAPRIDS": "CAPRID, a member of the goat family [n]\n",
  "CAPRIFICATION": "a method of promoting the pollination of figs by hanging branches of caprifig flowers so that parasitic gall-wasps living on the female flowers can carry pollen to the wild fig [n -S]\n",
  "CAPRIFICATIONS": "CAPRIFICATION, a method of promoting the pollination of figs by hanging branches of caprifig flowers so that parasitic gall-wasps living on the female flowers can carry pollen to the wild fig [n]\n",
  "CAPRIFIED": "CAPRIFY, to cultivate the goat-fig [v]\n",
  "CAPRIFIES": "CAPRIFY, to cultivate the goat-fig [v]\n",
  "CAPRIFIG": "the goat-fig, a species of wild fig [n -S]\n",
  "CAPRIFIGS": "CAPRIFIG, the goat-fig, a species of wild fig [n]\n",
  "CAPRIFOIL": "(Spenser) honeysuckle, also CAPRIFOLE [n -S]\n",
  "CAPRIFOILS": "CAPRIFOIL, (Spenser) honeysuckle, also CAPRIFOLE [n]\n",
  "CAPRIFOLE": "honeysuckle, also CAPRIFOIL [n -S]\n",
  "CAPRIFOLES": "CAPRIFOLE, honeysuckle, also CAPRIFOIL [n]\n",
  "CAPRIFOLIACEOUS": "of or pertaining to the honeysuckle plant [adj]\n",
  "CAPRIFORM": "goatlike [adj]\n",
  "CAPRIFY": "to cultivate the goat-fig [v CAPRIFIED, CAPRIFYING, CAPRIFIES]\n",
  "CAPRIFYING": "CAPRIFY, to cultivate the goat-fig [v]\n",
  "CAPRINE": "pertaining to a goat, also CAPRIC [adj]\n",
  "CAPRIOLE": "(French) a leap and kick performed by a trained horse [n -S] / to make such a kick [v CAPRIOLED, CAPRIOLING, CAPRIOLES]\n",
  "CAPRIOLED": "CAPRIOLE, to make such a kick [v]\n",
  "CAPRIOLES": "CAPRIOLE, to make such a kick [v]\n",
  "CAPRIOLING": "CAPRIOLE, to make such a kick [v]\n",
  "CAPRIS": "women's tapering trousers ending above the ankle [n]\n",
  "CAPROATE": "a salt of caproic acid [n -S]\n",
  "CAPROATES": "CAPROATE, a salt of caproic acid [n]\n",
  "CAPROCK": "an overlying rock layer [n -S]\n",
  "CAPROCKS": "CAPROCK, an overlying rock layer [n]\n",
  "CAPROIC": "applied to a type of fatty acid, having a goatlike smell, also CAPRIC, CAPRYLIC [adj]\n",
  "CAPROLACTAM": "a white crystalline cyclic amide used esp. in making one type of nylon [n -S]\n",
  "CAPROLACTAMS": "CAPROLACTAM, a white crystalline cyclic amide used esp. in making one type of nylon [n]\n",
  "CAPRYLATE": "a salt of caprylic acid [n -S]\n",
  "CAPRYLATES": "CAPRYLATE, a salt of caprylic acid [n]\n",
  "CAPRYLIC": "applied to a type of fatty acid, having a goatlike smell, also CAPRIC, CAPROIC [adj]\n",
  "CAPS": "CAP, to provide with a type of head covering [v]\n",
  "CAPSAICIN": "a cyclic amide responsible for the pungency of capsicums [n -S]\n",
  "CAPSAICINS": "CAPSAICIN, a cyclic amide responsible for the pungency of capsicums [n]\n",
  "CAPSICIN": "a liquid used as a flavoring [n -S]\n",
  "CAPSICINS": "CAPSICIN, a liquid used as a flavoring [n]\n",
  "CAPSICUM": "a plant yielding (e.g. red or green) peppers; its fruit [n -S]\n",
  "CAPSICUMS": "CAPSICUM, a plant yielding (e.g. red or green) peppers; its fruit [n]\n",
  "CAPSID": "the outer shell of a virus particle [n -S]\n",
  "CAPSIDAL": "relating to a capsid, the outer shell of a virus particle [adj]\n",
  "CAPSIDS": "CAPSID, the outer shell of a virus particle [n]\n",
  "CAPSIZABLE": "that can be capsized [adj]\n",
  "CAPSIZAL": "the overturning of a boat [n -S]\n",
  "CAPSIZALS": "CAPSIZAL, the overturning of a boat [n]\n",
  "CAPSIZE": "to overturn [v CAPSIZED, CAPSIZING, CAPSIZES]\n",
  "CAPSIZED": "CAPSIZE, to overturn [v]\n",
  "CAPSIZES": "CAPSIZE, to overturn [v]\n",
  "CAPSIZING": "CAPSIZE, to overturn [v]\n",
  "CAPSOMER": "a protein forming a capsid, also CAPSOMERE [n -S]\n",
  "CAPSOMERE": "any of the protein units that together form the capsid of a virus, also CAPSOMER [n -S]\n",
  "CAPSOMERES": "CAPSOMERE, any of the protein units that together form the capsid of a virus, also CAPSOMER [n]\n",
  "CAPSOMERS": "CAPSOMER, a protein forming a capsid, also CAPSOMERE [n]\n",
  "CAPSTAN": "an upright device for winding in heavy ropes or cables [n -S]\n",
  "CAPSTANS": "CAPSTAN, an upright device for winding in heavy ropes or cables [n]\n",
  "CAPSTONE": "the horizontal stone of a dolmen [n -S]\n",
  "CAPSTONES": "CAPSTONE, the horizontal stone of a dolmen [n]\n",
  "CAPSULAR": "of or pertaining to a capsule, also CAPSULARY [adj]\n",
  "CAPSULARY": "of or pertaining to a capsule, also CAPSULAR [adj]\n",
  "CAPSULATE": "contained in or made into a capsule, also CAPSULATED [adj]\n",
  "CAPSULATED": "contained in or made into a capsule, also CAPSULATE [adj]\n",
  "CAPSULATION": "the process of putting into a capsule [n -S]\n",
  "CAPSULATIONS": "CAPSULATION, the process of putting into a capsule [n]\n",
  "CAPSULE": "to condense into a brief form [v CAPSULED, CAPSULING, CAPSULES]\n",
  "CAPSULED": "CAPSULE, to condense into a brief form [v]\n",
  "CAPSULES": "CAPSULE, to condense into a brief form [v]\n",
  "CAPSULING": "CAPSULE, to condense into a brief form [v]\n",
  "CAPSULISE": "to condense, to enclose in a capsule, also CAPSULIZE [v CAPSULISED, CAPSULISING, CAPSULISES]\n",
  "CAPSULISED": "CAPSULISE, to condense, to enclose in a capsule, also CAPSULIZE [v]\n",
  "CAPSULISES": "CAPSULISE, to condense, to enclose in a capsule, also CAPSULIZE [v]\n",
  "CAPSULISING": "CAPSULISE, to condense, to enclose in a capsule, also CAPSULIZE [v]\n",
  "CAPSULIZE": "to condense, to enclose in a capsule, also CAPSULISE [v CAPSULIZED, CAPSULIZING, CAPSULIZES]\n",
  "CAPSULIZED": "CAPSULIZE, to condense, to enclose in a capsule, also CAPSULISE [v]\n",
  "CAPSULIZES": "CAPSULIZE, to condense, to enclose in a capsule, also CAPSULISE [v]\n",
  "CAPSULIZING": "CAPSULIZE, to condense, to enclose in a capsule, also CAPSULISE [v]\n",
  "CAPTAIN": "to lead or command [v -ED, -ING, -S]\n",
  "CAPTAINCIES": "CAPTAINCY, the rank or condition of a captain, also CAPTAINRY [n]\n",
  "CAPTAINCY": "the rank or condition of a captain, also CAPTAINRY [n CAPTAINCIES]\n",
  "CAPTAINED": "CAPTAIN, to lead or command [v]\n",
  "CAPTAINING": "CAPTAIN, to lead or command [v]\n",
  "CAPTAINRIES": "CAPTAINRY, the rank or condition of a captain, also CAPTAINCY [n]\n",
  "CAPTAINRY": "the rank or condition of a captain, also CAPTAINCY [n CAPTAINRIES]\n",
  "CAPTAINS": "CAPTAIN, to lead or command [v]\n",
  "CAPTAINSHIP": "the office of captain [n -S]\n",
  "CAPTAINSHIPS": "CAPTAINSHIP, the office of captain [n]\n",
  "CAPTAN": "a type of agricultural fungicide produced from mercaptan [n -S]\n",
  "CAPTANS": "CAPTAN, a type of agricultural fungicide produced from mercaptan [n]\n",
  "CAPTCHA": "a program to generate tests that humans can pass but computers cannot, such as the ability to recognise a distorted word [n CAPTCHAS]\n",
  "CAPTCHAS": "CAPTCHA, a program to generate tests that humans can pass but computers cannot, such as the ability to recognise a distorted word [n]\n",
  "CAPTION": "a heading, legend or accompanying wording of an article, illustration etc. [n -S] / to provide with a title [v -ED, -ING, -S]\n",
  "CAPTIONED": "CAPTION, to provide with a title [v]\n",
  "CAPTIONING": "CAPTION, to provide with a title [v]\n",
  "CAPTIONLESS": "without a caption [adj]\n",
  "CAPTIONS": "CAPTION, to provide with a title [v]\n",
  "CAPTIOUS": "tending to find fault [adj CAPTIOUSLY]\n",
  "CAPTIOUSLY": "CAPTIOUS, tending to find fault [adv]\n",
  "CAPTIOUSNESS": "the state of being captious [n -ES]\n",
  "CAPTIOUSNESSES": "CAPTIOUSNESS, the state of being captious [n]\n",
  "CAPTIVANCE": "(Spenser) captivity, also CAPTIVAUNCE [n -S]\n",
  "CAPTIVANCES": "CAPTIVANCE, (Spenser) captivity, also CAPTIVAUNCE [n]\n",
  "CAPTIVATE": "to charm, fascinate [v CAPTIVATED, CAPTIVATING, CAPTIVATES]\n",
  "CAPTIVATED": "CAPTIVATE, to charm, fascinate [v]\n",
  "CAPTIVATES": "CAPTIVATE, to charm, fascinate [v]\n",
  "CAPTIVATING": "CAPTIVATE, to charm, fascinate [v]\n",
  "CAPTIVATINGLY": "CAPTIVATING, CAPTIVATE, to charm, fascinate [adv]\n",
  "CAPTIVATION": "the act of captivating [n -S]\n",
  "CAPTIVATIONS": "CAPTIVATION, the act of captivating [n]\n",
  "CAPTIVATOR": "one who captivates [n -S]\n",
  "CAPTIVATORS": "CAPTIVATOR, one who captivates [n]\n",
  "CAPTIVAUNCE": "(Spenser) captivity, also CAPTIVANCE [n -S]\n",
  "CAPTIVAUNCES": "CAPTIVAUNCE, (Spenser) captivity, also CAPTIVANCE [n]\n",
  "CAPTIVE": "to make a prisoner [v CAPTIVED, CAPTIVING, CAPTIVES]\n",
  "CAPTIVED": "CAPTIVE, to make a prisoner [v]\n",
  "CAPTIVES": "CAPTIVE, to make a prisoner [v]\n",
  "CAPTIVING": "CAPTIVE, to make a prisoner [v]\n",
  "CAPTIVITIES": "CAPTIVITY, the state of being captive [n]\n",
  "CAPTIVITY": "the state of being captive [n CAPTIVITIES]\n",
  "CAPTOPRIL": "an antihypertensive drug that is an ace inhibitor [n -S]\n",
  "CAPTOPRILS": "CAPTOPRIL, an antihypertensive drug that is an ace inhibitor [n]\n",
  "CAPTOR": "one who takes or holds a captive [n -S]\n",
  "CAPTORS": "CAPTOR, one who takes or holds a captive [n]\n",
  "CAPTURE": "to take by force or cunning [v CAPTURED, CAPTURING, CAPTURES]\n",
  "CAPTURED": "CAPTURE, to take by force or cunning [v]\n",
  "CAPTURER": "one who captures [n -S]\n",
  "CAPTURERS": "CAPTURER, one who captures [n]\n",
  "CAPTURES": "CAPTURE, to take by force or cunning [v]\n",
  "CAPTURING": "CAPTURE, to take by force or cunning [v]\n",
  "CAPUCCIO": "(Spenser) a cloak hood, also CAPOUCH, CAPUCHE [n -S]\n",
  "CAPUCCIOS": "CAPUCCIO, (Spenser) a cloak hood, also CAPOUCH, CAPUCHE [n]\n",
  "CAPUCHE": "a cloak hood, also CAPOUCH, CAPUCCIO [n -S]\n",
  "CAPUCHED": "having a capuche [adj]\n",
  "CAPUCHES": "CAPUCHE, a cloak hood, also CAPOUCH, CAPUCCIO [n]\n",
  "CAPUCHIN": "a South American monkey with thick hair like a monk's cowl [n -S]\n",
  "CAPUCHINS": "CAPUCHIN, a South American monkey with thick hair like a monk's cowl [n]\n",
  "CAPUERA": "(Portuguese) a martial art and dance combination, also CAPOEIRA [n -S]\n",
  "CAPUERAS": "CAPUERA, (Portuguese) a martial art and dance combination, also CAPOEIRA [n]\n",
  "CAPUL": "a horse, also CAPLE [n -S]\n",
  "CAPULS": "CAPUL, a horse, also CAPLE [n]\n",
  "CAPUT": "(Latin) the head; also, a knoblike protuberance or capitulum [n CAPITA]\n",
  "CAPYBARA": "(Tupi) a large South American rodent [n -S]\n",
  "CAPYBARAS": "CAPYBARA, (Tupi) a large South American rodent [n]\n",
  "CAR": "a self-propelled wheeled vehicle [n -S]\n",
  "CARABAO": "a water buffalo [n -S]\n",
  "CARABAOS": "CARABAO, a water buffalo [n]\n",
  "CARABID": "a black carnivorous beetle [n -S]\n",
  "CARABIDS": "CARABID, a black carnivorous beetle [n]\n",
  "CARABIN": "a rifle with a relatively short barrel, also CARABINE, CARBINE [n -S]\n",
  "CARABINE": "a rifle with a relatively short barrel, also CARABIN, CARBINE [n -S]\n",
  "CARABINEER": "a soldier armed with a carbine, also CARABINIER, CARBINEER, CARBINIER [n -S]\n",
  "CARABINEERS": "CARABINEER, a soldier armed with a carbine, also CARABINIER, CARBINEER, CARBINIER [n]\n",
  "CARABINER": "(German) a steel link with a clip on side used in mountaineering, also KARABINER [n -S]\n",
  "CARABINERO": "a member of the Spanish national police force serving as frontier guards [n -S]\n",
  "CARABINEROS": "CARABINERO, a member of the Spanish national police force serving as frontier guards [n]\n",
  "CARABINERS": "CARABINER, (German) a steel link with a clip on side used in mountaineering, also KARABINER [n]\n",
  "CARABINES": "CARABINE, a rifle with a relatively short barrel, also CARABIN, CARBINE [n]\n",
  "CARABINIER": "a soldier armed with a carbine, also CARABINEER, CARBINEER, CARBINIER [n -S]\n",
  "CARABINIERE": "(Italian) an Italian policeman [n CARABINIERI]\n",
  "CARABINIERI": "CARABINIERE, (Italian) an Italian policeman [n]\n",
  "CARABINIERS": "CARABINIER, a soldier armed with a carbine, also CARABINEER, CARBINEER, CARBINIER [n]\n",
  "CARABINS": "CARABIN, a rifle with a relatively short barrel, also CARABINE, CARBINE [n]\n",
  "CARACAL": "(Turkish) the desert lynx of North Africa and South Asia [n -S]\n",
  "CARACALS": "CARACAL, (Turkish) the desert lynx of North Africa and South Asia [n]\n",
  "CARACARA": "(Spanish) any of several South American carrion-eating birds of prey [n -S]\n",
  "CARACARAS": "CARACARA, (Spanish) any of several South American carrion-eating birds of prey [n]\n",
  "CARACK": "a type of merchant ship, also CARRACK, CARRECT [n -S]\n",
  "CARACKS": "CARACK, a type of merchant ship, also CARRACK, CARRECT [n]\n",
  "CARACOL": "(French) to perform a half turn on a horse, also CARACOLE [v CARACOLLED, CARACOLLING, CARACOLS]\n",
  "CARACOLE": "(French) to perform a half turn on a horse, also CARACOL [v CARACOLED, CARACOLING, CARACOLES]\n",
  "CARACOLED": "CARACOLE, (French) to perform a half turn on a horse, also CARACOL [v]\n",
  "CARACOLER": "one who caracoles [n -S]\n",
  "CARACOLERS": "CARACOLER, one who caracoles [n]\n",
  "CARACOLES": "CARACOLE, (French) to perform a half turn on a horse, also CARACOL [v]\n",
  "CARACOLING": "CARACOLE, (French) to perform a half turn on a horse, also CARACOL [v]\n",
  "CARACOLLED": "CARACOL, (French) to perform a half turn on a horse, also CARACOLE [v]\n",
  "CARACOLLING": "CARACOL, (French) to perform a half turn on a horse, also CARACOLE [v]\n",
  "CARACOLS": "CARACOL, (French) to perform a half turn on a horse, also CARACOLE [v]\n",
  "CARACT": "(Shakespeare) a mark, a sign [n -S]\n",
  "CARACTS": "CARACT, (Shakespeare) a mark, a sign [n]\n",
  "CARACUL": "(Russian) a sheep of Central Asia; the curled black fleece of its lambs, also KARAKUL [n -S]\n",
  "CARACULS": "CARACUL, (Russian) a sheep of Central Asia; the curled black fleece of its lambs, also KARAKUL [n]\n",
  "CARAFE": "(French) a glass bottle for water or wine at a table, in a bedroom, etc. [n -S]\n",
  "CARAFES": "CARAFE, (French) a glass bottle for water or wine at a table, in a bedroom, etc. [n]\n",
  "CARAGANA": "any of a genus of hardy leguminous shrubs grown for their showy golden flowers [n -S]\n",
  "CARAGANAS": "CARAGANA, any of a genus of hardy leguminous shrubs grown for their showy golden flowers [n]\n",
  "CARAGEEN": "(Irish) a kind of dark red, branched seaweed, aka Irish moss, also CARRAGEEN, CARRAGHEEN [n -S]\n",
  "CARAGEENAN": "a colloid prepared from red algae, used in food processing, pharmaceuticals etc., also CARRAGEENAN, CARRAGEENIN, CARRAGHEENAN, CARRAGHEENIN [n -S]\n",
  "CARAGEENANS": "CARAGEENAN, a colloid prepared from red algae, used in food processing, pharmaceuticals etc., also CARRAGEENAN, CARRAGEENIN, CARRAGHEENAN, CARRAGHEENIN [n]\n",
  "CARAGEENS": "CARAGEEN, (Irish) a kind of dark red, branched seaweed, aka Irish moss, also CARRAGEEN, CARRAGHEEN [n]\n",
  "CARAMBA": "(Spanish) used to express dismay or surprise [interj]\n",
  "CARAMBOLA": "(Portuguese) a small East Indian tree of the wood-sorrel family; its acrid yellow pulpy fruit used for making tarts, preserves, etc., aka starfruit [n -S]\n",
  "CARAMBOLAS": "CARAMBOLA, (Portuguese) a small East Indian tree of the wood-sorrel family; its acrid yellow pulpy fruit used for making tarts, preserves, etc., aka starfruit [n]\n",
  "CARAMBOLE": "(French) to make a cannon in billiards, also CAROM, CARROM [v CARAMBOLED, CARAMBOLING, CARAMBOLES]\n",
  "CARAMBOLED": "CARAMBOLE, (French) to make a cannon in billiards, also CAROM, CARROM [v]\n",
  "CARAMBOLES": "CARAMBOLE, (French) to make a cannon in billiards, also CAROM, CARROM [v]\n",
  "CARAMBOLING": "CARAMBOLE, (French) to make a cannon in billiards, also CAROM, CARROM [v]\n",
  "CARAMEL": "a dark brown substance produced by heating sugar, also CAROMEL [n -S] / to coat with caramel [v CARAMELLED, CARAMELLING, CARAMELS]\n",
  "CARAMELISATION": "the process of caramelising, also CARAMELIZATION [n -S]\n",
  "CARAMELISATIONS": "CARAMELISATION, the process of caramelising, also CARAMELIZATION [n]\n",
  "CARAMELISE": "to turn into caramel, also CARAMELIZE [v CARAMELISED, CARAMELISING, CARAMELISES]\n",
  "CARAMELISED": "CARAMELISE, to turn into caramel, also CARAMELIZE [v]\n",
  "CARAMELISES": "CARAMELISE, to turn into caramel, also CARAMELIZE [v]\n",
  "CARAMELISING": "CARAMELISE, to turn into caramel, also CARAMELIZE [v]\n",
  "CARAMELIZATION": "the process of caramelizing, also CARAMELISATION [n -S]\n",
  "CARAMELIZATIONS": "CARAMELIZATION, the process of caramelizing, also CARAMELISATION [n]\n",
  "CARAMELIZE": "to turn into caramel, also CARAMELISE [v CARAMELIZED, CARAMELIZING, CARAMELIZES]\n",
  "CARAMELIZED": "CARAMELIZE, to turn into caramel, also CARAMELISE [v]\n",
  "CARAMELIZES": "CARAMELIZE, to turn into caramel, also CARAMELISE [v]\n",
  "CARAMELIZING": "CARAMELIZE, to turn into caramel, also CARAMELISE [v]\n",
  "CARAMELLED": "CARAMEL, to coat with caramel [v]\n",
  "CARAMELLING": "CARAMEL, to coat with caramel [v]\n",
  "CARAMELS": "CARAMEL, to coat with caramel [v]\n",
  "CARANGID": "a marine fish [n -S]\n",
  "CARANGIDS": "CARANGID, a marine fish [n]\n",
  "CARANGOID": "any spiny-finned marine fish of the genus Caranx, that includes scads, jacks etc., also CARANGID [n -S]\n",
  "CARANGOIDS": "CARANGOID, any spiny-finned marine fish of the genus Caranx, that includes scads, jacks etc., also CARANGID [n]\n",
  "CARANNA": "(Tupi) a resinous substance yielded by various South American trees, also CARAUNA [n -S]\n",
  "CARANNAS": "CARANNA, (Tupi) a resinous substance yielded by various South American trees, also CARAUNA [n]\n",
  "CARAP": "a South American tree of the mahogany family [n -S]\n",
  "CARAPACE": "the shell of an animal such as a turtle or armadillo, also CARAPAX [n -S]\n",
  "CARAPACED": "having a carapace [adj]\n",
  "CARAPACES": "CARAPACE, the shell of an animal such as a turtle or armadillo, also CARAPAX [n]\n",
  "CARAPACIAL": "of or like a carapace [adj]\n",
  "CARAPAX": "a hard, protective outer covering, also CARAPACE [n -ES]\n",
  "CARAPAXES": "CARAPAX, a hard, protective outer covering, also CARAPACE [n]\n",
  "CARAPS": "CARAP, a South American tree of the mahogany family [n]\n",
  "CARASSOW": "a quail-like bird of Curacao, also CURASSOW [n -S]\n",
  "CARASSOWS": "CARASSOW, a quail-like bird of Curacao, also CURASSOW [n]\n",
  "CARAT": "a unit of weight used for gems, also CARRAT, KARAT [n -S]\n",
  "CARATE": "a tropical skin disease, aka pinta [n -S]\n",
  "CARATES": "CARATE, a tropical skin disease, aka pinta [n]\n",
  "CARATS": "CARAT, a unit of weight used for gems, also CARRAT, KARAT [n]\n",
  "CARAUNA": "(Tupi) a resinous substance yielded by various South American trees, also CARANNA [n -S]\n",
  "CARAUNAS": "CARAUNA, (Tupi) a resinous substance yielded by various South American trees, also CARANNA [n]\n",
  "CARAVAN": "to travel in a portable home [v CARAVANED or CARAVANNED, CARAVANING or CARAVANNING, CARAVANS]\n",
  "CARAVANCE": "a kind of pulse, also CALAVANCE [n -S]\n",
  "CARAVANCES": "CARAVANCE, a kind of pulse, also CALAVANCE [n]\n",
  "CARAVANED": "CARAVAN, to travel in a portable home [v]\n",
  "CARAVANEER": "the leader of a caravan, also CARAVANER, CARAVANNER [n -S]\n",
  "CARAVANEERS": "CARAVANEER, the leader of a caravan, also CARAVANER, CARAVANNER [n]\n",
  "CARAVANER": "one who travels by caravan, also CARAVANEER, CARAVANNER [n -S]\n",
  "CARAVANERS": "CARAVANER, one who travels by caravan, also CARAVANEER, CARAVANNER [n]\n",
  "CARAVANETTE": "a small caravan [n -S]\n",
  "CARAVANETTES": "CARAVANETTE, a small caravan [n]\n",
  "CARAVANING": "the act of holidaying by caravan [n -S]\n",
  "CARAVANINGS": "CARAVANING, the act of holidaying by caravan [n]\n",
  "CARAVANNED": "CARAVAN, to travel in a portable home [v]\n",
  "CARAVANNER": "one who travels by caravan, also CARAVANEER, CARAVANER [n -S]\n",
  "CARAVANNERS": "CARAVANNER, one who travels by caravan, also CARAVANEER, CARAVANER [n]\n",
  "CARAVANNING": "holidaying by caravan [n -S]\n",
  "CARAVANNINGS": "CARAVANNING, holidaying by caravan [n]\n",
  "CARAVANS": "CARAVAN, to travel in a portable home [v]\n",
  "CARAVANSARAI": "a kind of unfurnished inn or extensive enclosed courtyard where caravans stop, also CARAVANSARY, CARAVANSERAI [n -S]\n",
  "CARAVANSARAIS": "CARAVANSARAI, a kind of unfurnished inn or extensive enclosed courtyard where caravans stop, also CARAVANSARY, CARAVANSERAI [n]\n",
  "CARAVANSARIES": "CARAVANSARY, a kind of unfurnished inn or extensive enclosed courtyard where caravans stop, also CARAVANSARAI, CARAVANSERAI [n]\n",
  "CARAVANSARY": "a kind of unfurnished inn or extensive enclosed courtyard where caravans stop, also CARAVANSARAI, CARAVANSERAI [n CARAVANSARIES]\n",
  "CARAVANSERAI": "a kind of unfurnished inn or extensive enclosed courtyard where caravans stop, also CARAVANSARAI, CARAVANSARY [n -S]\n",
  "CARAVANSERAIS": "CARAVANSERAI, a kind of unfurnished inn or extensive enclosed courtyard where caravans stop, also CARAVANSARAI, CARAVANSARY [n]\n",
  "CARAVEL": "a small light fast ship, chiefly Spanish or Portuguese, of the 15th to the 17th cents, also CARAVELLE, CARVEL [n -S]\n",
  "CARAVELLE": "a small light fast ship, chiefly Spanish or Portuguese, of the 15th to the 17th cents, also CARAVEL, CARVEL [n -S]\n",
  "CARAVELLES": "CARAVELLE, a small light fast ship, chiefly Spanish or Portuguese, of the 15th to the 17th cents, also CARAVEL, CARVEL [n]\n",
  "CARAVELS": "CARAVEL, a small light fast ship, chiefly Spanish or Portuguese, of the 15th to the 17th cents, also CARAVELLE, CARVEL [n]\n",
  "CARAWAY": "an umbelliferous plant with aromatic seeds used as a tonic and condiment, also CARRAWAY, CARVY [n -S]\n",
  "CARAWAYS": "CARAWAY, an umbelliferous plant with aromatic seeds used as a tonic and condiment, also CARRAWAY, CARVY [n]\n",
  "CARB": "(short for) a carburettor [n -S]\n",
  "CARBACHOL": "a synthetic drug used to disperse fluids, e.g. urine, retained in the body [n -S]\n",
  "CARBACHOLS": "CARBACHOL, a synthetic drug used to disperse fluids, e.g. urine, retained in the body [n]\n",
  "CARBAMATE": "a salt or ester of carbamic acid, esp. as used as a pesticide, also CARBARYL [n -S]\n",
  "CARBAMATES": "CARBAMATE, a salt or ester of carbamic acid, esp. as used as a pesticide, also CARBARYL [n]\n",
  "CARBAMAZEPINE": "an anticonvulsant drug used in the management of epilepsy [n -S]\n",
  "CARBAMAZEPINES": "CARBAMAZEPINE, an anticonvulsant drug used in the management of epilepsy [n]\n",
  "CARBAMIC": "pertaining to a type of acid [adj]\n",
  "CARBAMIDE": "the technical name for urea [n -S]\n",
  "CARBAMIDES": "CARBAMIDE, the technical name for urea [n]\n",
  "CARBAMIDINE": "another name for guanidine [n -S]\n",
  "CARBAMIDINES": "CARBAMIDINE, another name for guanidine [n]\n",
  "CARBAMINO": "relating to any of the carbamic acid derivatives formed by reaction of carbon dioxide with an amino acid or a protein [adj]\n",
  "CARBAMOYL": "a radical derived from carbamic acid, also CARBAMYL [n -S]\n",
  "CARBAMOYLS": "CARBAMOYL, a radical derived from carbamic acid, also CARBAMYL [n]\n",
  "CARBAMYL": "a radical derived from carbamic acid, also CARBAMOYL [n -S]\n",
  "CARBAMYLS": "CARBAMYL, a radical derived from carbamic acid, also CARBAMOYL [n]\n",
  "CARBANION": "an ion carrying a negative electrical charge at the carbon position [n -S]\n",
  "CARBANIONS": "CARBANION, an ion carrying a negative electrical charge at the carbon position [n]\n",
  "CARBARN": "a garage for buses [n -S]\n",
  "CARBARNS": "CARBARN, a garage for buses [n]\n",
  "CARBARYL": "a salt or ester of carbamic acid, esp. as used as a pesticide, also CARBAMATE [n -S]\n",
  "CARBARYLS": "CARBARYL, a salt or ester of carbamic acid, esp. as used as a pesticide, also CARBAMATE [n]\n",
  "CARBAZOLE": "a chemical compound derived from coal and used in making dyes [n -S]\n",
  "CARBAZOLES": "CARBAZOLE, a chemical compound derived from coal and used in making dyes [n]\n",
  "CARBEEN": "(Native Australian) an Australian eucalyptus with drooping branches and grey bark [n -S]\n",
  "CARBEENS": "CARBEEN, (Native Australian) an Australian eucalyptus with drooping branches and grey bark [n]\n",
  "CARBENE": "a neutral divalent free radical [n -S]\n",
  "CARBENES": "CARBENE, a neutral divalent free radical [n]\n",
  "CARBIDE": "a carbon compound [n -S]\n",
  "CARBIDES": "CARBIDE, a carbon compound [n]\n",
  "CARBIDOPA": "a drug given to people with Parkinson's disease in order to inhibit peripheral metabolism of levodopa [n -S]\n",
  "CARBIDOPAS": "CARBIDOPA, a drug given to people with Parkinson's disease in order to inhibit peripheral metabolism of levodopa [n]\n",
  "CARBIES": "CARBY, (Australian) short for carburettor [n]\n",
  "CARBIMAZOLE": "a drug that inhibits the synthesis of the hormone thyroxine, used in the management of hyperthyroidism [n -S]\n",
  "CARBIMAZOLES": "CARBIMAZOLE, a drug that inhibits the synthesis of the hormone thyroxine, used in the management of hyperthyroidism [n]\n",
  "CARBINE": "a rifle with a relatively short barrel, also CARABIN, CARABINE [n -S]\n",
  "CARBINEER": "a soldier armed with a carbine, also CARABINEER, CARABINIER, CARBINIER [n -S]\n",
  "CARBINEERS": "CARBINEER, a soldier armed with a carbine, also CARABINEER, CARABINIER, CARBINIER [n]\n",
  "CARBINES": "CARBINE, a rifle with a relatively short barrel, also CARABIN, CARABINE [n]\n",
  "CARBINIER": "a soldier armed with a carbine, also CARABINEER, CARABINIER, CARBINEER [n -S]\n",
  "CARBINIERS": "CARBINIER, a soldier armed with a carbine, also CARABINEER, CARABINIER, CARBINEER [n]\n",
  "CARBINOL": "a monohydric alcohol; specifically methanol [n -S]\n",
  "CARBINOLS": "CARBINOL, a monohydric alcohol; specifically methanol [n]\n",
  "CARBO": "(short for) carbohydrate [n -S]\n",
  "CARBOCYCLIC": "being or having an organic ring composed of carbon atoms [adj]\n",
  "CARBOHYDRASE": "any of a group of enzymes (as amylase) that promote hydrolysis or synthesis of a carbohydrate (as a disaccharide) [n -S]\n",
  "CARBOHYDRASES": "CARBOHYDRASE, any of a group of enzymes (as amylase) that promote hydrolysis or synthesis of a carbohydrate (as a disaccharide) [n]\n",
  "CARBOHYDRATE": "a compound of carbon, hydrogen and oxygen; extended to similar compounds, the sugars and starches which form the main source of energy in food [n -S]\n",
  "CARBOHYDRATES": "CARBOHYDRATE, a compound of carbon, hydrogen and oxygen; extended to similar compounds, the sugars and starches which form the main source of energy in food [n]\n",
  "CARBOLATED": "containing carbolic acid [adj]\n",
  "CARBOLIC": "an acidic compound [n -S]\n",
  "CARBOLICS": "CARBOLIC, an acidic compound [n]\n",
  "CARBOLISE": "to treat or disinfect with phenol, also CARBOLIZE [v CARBOLISED, CARBOLISING, CARBOLISES]\n",
  "CARBOLISED": "CARBOLISE, to treat or disinfect with phenol, also CARBOLIZE [v]\n",
  "CARBOLISES": "CARBOLISE, to treat or disinfect with phenol, also CARBOLIZE [v]\n",
  "CARBOLISING": "CARBOLISE, to treat or disinfect with phenol, also CARBOLIZE [v]\n",
  "CARBOLIZE": "to treat or disinfect with phenol, also CARBOLISE [v CARBOLIZED, CARBOLIZING, CARBOLIZES]\n",
  "CARBOLIZED": "CARBOLIZE, to treat or disinfect with phenol, also CARBOLISE [v]\n",
  "CARBOLIZES": "CARBOLIZE, to treat or disinfect with phenol, also CARBOLISE [v]\n",
  "CARBOLIZING": "CARBOLIZE, to treat or disinfect with phenol, also CARBOLISE [v]\n",
  "CARBON": "a nonmetallic element [n -S]\n",
  "CARBONACEOUS": "coaly; containing much carbon [adj]\n",
  "CARBONADE": "(Spanish) flesh, fowl, etc., cut across, seasoned, and broiled on coals, also CARBONADO, CARBONNADE [n -S]\n",
  "CARBONADES": "CARBONADE, (Spanish) flesh, fowl, etc., cut across, seasoned, and broiled on coals, also CARBONADO, CARBONNADE [n]\n",
  "CARBONADO": "(Spanish) to broil on coals, also CARBONADE, CARBONNADE [v CARBONADOED, CARBONADOING, CARBONADOS or CARBONADOES]\n",
  "CARBONADOED": "CARBONADO, (Spanish) to broil on coals, also CARBONADE, CARBONNADE [v]\n",
  "CARBONADOES": "CARBONADO, (Spanish) to broil on coals, also CARBONADE, CARBONNADE [v]\n",
  "CARBONADOING": "CARBONADO, (Spanish) to broil on coals, also CARBONADE, CARBONNADE [v]\n",
  "CARBONADOS": "CARBONADO, (Spanish) to broil on coals, also CARBONADE, CARBONNADE [v]\n",
  "CARBONARA": "(Italian) a pasta sauce made with eggs, bacon, cheese and cream [n -S]\n",
  "CARBONARAS": "CARBONARA, (Italian) a pasta sauce made with eggs, bacon, cheese and cream [n]\n",
  "CARBONATE": "a salt of carbonic acid [n -S] / to combine or impregnate with carbon dioxide [v CARBONATED, CARBONATING, CARBONATES]\n",
  "CARBONATED": "CARBONATE, to combine or impregnate with carbon dioxide [v]\n",
  "CARBONATES": "CARBONATE, to combine or impregnate with carbon dioxide [v]\n",
  "CARBONATING": "CARBONATE, to combine or impregnate with carbon dioxide [v]\n",
  "CARBONATION": "impregnation with carbon dioxide [n -S]\n",
  "CARBONATIONS": "CARBONATION, impregnation with carbon dioxide [n]\n",
  "CARBONATITE": "any igneous rock composed chiefly of carbonates rather than silicates [n -S]\n",
  "CARBONATITES": "CARBONATITE, any igneous rock composed chiefly of carbonates rather than silicates [n]\n",
  "CARBONETTE": "(New Zealand) a ball of compressed coal dust used as fuel [n -S]\n",
  "CARBONETTES": "CARBONETTE, (New Zealand) a ball of compressed coal dust used as fuel [n]\n",
  "CARBONIC": "of or relating to carbon, as in carbonic acid [adj]\n",
  "CARBONIFEROUS": "bearing carbon [adj]\n",
  "CARBONISATION": "the act of carbonising, also CARBONIZATION [n -S]\n",
  "CARBONISATIONS": "CARBONISATION, the act of carbonising, also CARBONIZATION [n]\n",
  "CARBONISE": "to turn into carbon, also CARBONIZE [v CARBONISED, CARBONISING, CARBONISES]\n",
  "CARBONISED": "CARBONISE, to turn into carbon, also CARBONIZE [v]\n",
  "CARBONISER": "an agent that carbonises, also CARBONIZER [n -S]\n",
  "CARBONISERS": "CARBONISER, an agent that carbonises, also CARBONIZER [n]\n",
  "CARBONISES": "CARBONISE, to turn into carbon, also CARBONIZE [v]\n",
  "CARBONISING": "CARBONISE, to turn into carbon, also CARBONIZE [v]\n",
  "CARBONIUM": "a type of positively charged organic ion [n -S]\n",
  "CARBONIUMS": "CARBONIUM, a type of positively charged organic ion [n]\n",
  "CARBONIZATION": "the act of carbonizing, also CARBONISATION [n -S]\n",
  "CARBONIZATIONS": "CARBONIZATION, the act of carbonizing, also CARBONISATION [n]\n",
  "CARBONIZE": "to turn into carbon, also CARBONISE [v CARBONIZED, CARBONIZING, CARBONIZES]\n",
  "CARBONIZED": "CARBONIZE, to turn into carbon, also CARBONISE [v]\n",
  "CARBONIZER": "an agent that carbonizes, also CARBONISER [n -S]\n",
  "CARBONIZERS": "CARBONIZER, an agent that carbonizes, also CARBONISER [n]\n",
  "CARBONIZES": "CARBONIZE, to turn into carbon, also CARBONISE [v]\n",
  "CARBONIZING": "CARBONIZE, to turn into carbon, also CARBONISE [v]\n",
  "CARBONLESS": "without carbon [adj]\n",
  "CARBONNADE": "(Spanish) flesh, fowl, etc., cut across, seasoned, and broiled on coals, also CARBONADE, CARBONADO [n -S]\n",
  "CARBONNADES": "CARBONNADE, (Spanish) flesh, fowl, etc., cut across, seasoned, and broiled on coals, also CARBONADE, CARBONADO [n]\n",
  "CARBONOUS": "containing carbon [adj]\n",
  "CARBONS": "CARBON, a nonmetallic element [n]\n",
  "CARBONYL": "the divalent group CO, present in ketones, aldehydes, etc. [n -S]\n",
  "CARBONYLATE": "to introduce the carbonyl group into [v CARBONYLATED, CARBONYLATING, CARBONYLATES]\n",
  "CARBONYLATED": "CARBONYLATE, to introduce the carbonyl group into [v]\n",
  "CARBONYLATES": "CARBONYLATE, to introduce the carbonyl group into [v]\n",
  "CARBONYLATING": "CARBONYLATE, to introduce the carbonyl group into [v]\n",
  "CARBONYLATION": "the synthesis of a carbonyl compound esp. by a reaction involving carbon monoxide [n -S]\n",
  "CARBONYLATIONS": "CARBONYLATION, the synthesis of a carbonyl compound esp. by a reaction involving carbon monoxide [n]\n",
  "CARBONYLIC": "relating to carbonyl [adj]\n",
  "CARBONYLS": "CARBONYL, the divalent group CO, present in ketones, aldehydes, etc. [n]\n",
  "CARBORA": "a koala [n -S]\n",
  "CARBORAS": "CARBORA, a koala [n]\n",
  "CARBOREXIC": "a person who is regarded as being obsessed with reducing their carbon footprint [n -S]\n",
  "CARBOREXICS": "CARBOREXIC, a person who is regarded as being obsessed with reducing their carbon footprint [n]\n",
  "CARBORNE": "travelling by car [adj]\n",
  "CARBOS": "CARBO, (short for) carbohydrate [n]\n",
  "CARBOXYL": "a univalent acid radical [n -S]\n",
  "CARBOXYLASE": "an enzyme that catalyzes decarboxylation or carboxylation [n -S]\n",
  "CARBOXYLASES": "CARBOXYLASE, an enzyme that catalyzes decarboxylation or carboxylation [n]\n",
  "CARBOXYLATE": "to introduce carboxyl or carbon dioxide into (a compound) with formation of a carboxylic acid [v CARBOXYLATED, CARBOXYLATING, CARBOXYLATES]\n",
  "CARBOXYLATED": "CARBOXYLATE, to introduce carboxyl or carbon dioxide into (a compound) with formation of a carboxylic acid [v]\n",
  "CARBOXYLATES": "CARBOXYLATE, to introduce carboxyl or carbon dioxide into (a compound) with formation of a carboxylic acid [v]\n",
  "CARBOXYLATING": "CARBOXYLATE, to introduce carboxyl or carbon dioxide into (a compound) with formation of a carboxylic acid [v]\n",
  "CARBOXYLATION": "the act of carboxylating [n -S]\n",
  "CARBOXYLATIONS": "CARBOXYLATION, the act of carboxylating [n]\n",
  "CARBOXYLIC": "relating to carboxyl [adj]\n",
  "CARBOXYLS": "CARBOXYL, a univalent acid radical [n]\n",
  "CARBOY": "a large green bottle encased in wicker [n -S]\n",
  "CARBOYED": "having a carboy [adj]\n",
  "CARBOYS": "CARBOY, a large green bottle encased in wicker [n]\n",
  "CARBS": "CARB, (short for) a carburettor [n]\n",
  "CARBUNCLE": "a fiery-red precious stone, aka almandine [n -S]\n",
  "CARBUNCLED": "having carbuncles [adj]\n",
  "CARBUNCLES": "CARBUNCLE, a fiery-red precious stone, aka almandine [n]\n",
  "CARBUNCULAR": "like a carbuncle [adj]\n",
  "CARBURATE": "to combine with carbon, also CARBURET [v CARBURATED, CARBURATING, CARBURATES]\n",
  "CARBURATED": "CARBURATE, to combine with carbon, also CARBURET [v]\n",
  "CARBURATES": "CARBURATE, to combine with carbon, also CARBURET [v]\n",
  "CARBURATING": "CARBURATE, to combine with carbon, also CARBURET [v]\n",
  "CARBURATION": "combination with carbon [n -S]\n",
  "CARBURATIONS": "CARBURATION, combination with carbon [n]\n",
  "CARBURET": "to combine with carbon, also CARBURATE [v CARBURETED or CARBURETTED, CARBURETING or CARBURETTING, CARBURETS]\n",
  "CARBURETED": "CARBURET, to combine with carbon, also CARBURATE [v]\n",
  "CARBURETER": "an apparatus for charging a gas with carbon compounds, also CARBURETOR, CARBURETTER, CARBURETTOR [n -S]\n",
  "CARBURETERS": "CARBURETER, an apparatus for charging a gas with carbon compounds, also CARBURETOR, CARBURETTER, CARBURETTOR [n]\n",
  "CARBURETING": "CARBURET, to combine with carbon, also CARBURATE [v]\n",
  "CARBURETION": "the process of carburetting [n -S]\n",
  "CARBURETIONS": "CARBURETION, the process of carburetting [n]\n",
  "CARBURETOR": "an apparatus for charging a gas with carbon compounds, also CARBURETER, CARBURETTER, CARBURETTOR [n -S]\n",
  "CARBURETORS": "CARBURETOR, an apparatus for charging a gas with carbon compounds, also CARBURETER, CARBURETTER, CARBURETTOR [n]\n",
  "CARBURETS": "CARBURET, to combine with carbon, also CARBURATE [v]\n",
  "CARBURETTED": "CARBURET, to combine with carbon, also CARBURATE [v]\n",
  "CARBURETTER": "an apparatus for charging a gas with carbon compounds, also CARBURETER, CARBURETOR, CARBURETTOR [n -S]\n",
  "CARBURETTERS": "CARBURETTER, an apparatus for charging a gas with carbon compounds, also CARBURETER, CARBURETOR, CARBURETTOR [n]\n",
  "CARBURETTING": "CARBURET, to combine with carbon, also CARBURATE [v]\n",
  "CARBURETTOR": "an apparatus for charging a gas with carbon compounds, also CARBURETER, CARBURETOR, CARBURETTER [n -S]\n",
  "CARBURETTORS": "CARBURETTOR, an apparatus for charging a gas with carbon compounds, also CARBURETER, CARBURETOR, CARBURETTER [n]\n",
  "CARBURISATION": "the act of carburising, also CARBURIZATION [n -S]\n",
  "CARBURISATIONS": "CARBURISATION, the act of carburising, also CARBURIZATION [n]\n",
  "CARBURISE": "to combine with carbon, also CARBURIZE [v CARBURISED, CARBURISING, CARBURISES]\n",
  "CARBURISED": "CARBURISE, to combine with carbon, also CARBURIZE [v]\n",
  "CARBURISES": "CARBURISE, to combine with carbon, also CARBURIZE [v]\n",
  "CARBURISING": "CARBURISE, to combine with carbon, also CARBURIZE [v]\n",
  "CARBURIZATION": "the act of carburizing, also CARBURISATION [n -S]\n",
  "CARBURIZATIONS": "CARBURIZATION, the act of carburizing, also CARBURISATION [n]\n",
  "CARBURIZE": "to combine with carbon, also CARBURISE [v CARBURIZED, CARBURIZING, CARBURIZES]\n",
  "CARBURIZED": "CARBURIZE, to combine with carbon, also CARBURISE [v]\n",
  "CARBURIZES": "CARBURIZE, to combine with carbon, also CARBURISE [v]\n",
  "CARBURIZING": "CARBURIZE, to combine with carbon, also CARBURISE [v]\n",
  "CARBY": "(Australian) short for carburettor [n CARBIES]\n",
  "CARBYLAMINE": "another name for isocyanide [n -S]\n",
  "CARBYLAMINES": "CARBYLAMINE, another name for isocyanide [n]\n",
  "CARCAJOU": "a musteline animal, aka glutton or wolverine [n -S]\n",
  "CARCAJOUS": "CARCAJOU, a musteline animal, aka glutton or wolverine [n]\n",
  "CARCAKE": "(Scots) a small cake baked with eggs, eaten on Shrove Tuesday in parts of Scotland [n -S]\n",
  "CARCAKES": "CARCAKE, (Scots) a small cake baked with eggs, eaten on Shrove Tuesday in parts of Scotland [n]\n",
  "CARCANET": "(obsolete) an ornamental necklace, collar or headband [n -S]\n",
  "CARCANETS": "CARCANET, (obsolete) an ornamental necklace, collar or headband [n]\n",
  "CARCASE": "to put a carcase or frame on, also CARCASS [v CARCASED, CARCASING, CARCASES]\n",
  "CARCASED": "CARCASE, to put a carcase or frame on, also CARCASS [v]\n",
  "CARCASES": "CARCASE, to put a carcase or frame on, also CARCASS [v]\n",
  "CARCASING": "CARCASE, to put a carcase or frame on, also CARCASS [v]\n",
  "CARCASS": "to put a framework on, also CARCASE [v -ED, -ING, -ES]\n",
  "CARCASSED": "CARCASS, to put a framework on, also CARCASE [v]\n",
  "CARCASSES": "CARCASS, to put a framework on, also CARCASE [v]\n",
  "CARCASSING": "CARCASS, to put a framework on, also CARCASE [v]\n",
  "CARCEL": "(French) a French mechanical lamp, used in lighthouses [n -S]\n",
  "CARCELS": "CARCEL, (French) a French mechanical lamp, used in lighthouses [n]\n",
  "CARCERAL": "pertaining to prison [adj]\n",
  "CARCINOGEN": "an agent causing cancer [n -S]\n",
  "CARCINOGENESES": "CARCINOGENESIS, the production of cancer [n]\n",
  "CARCINOGENESIS": "the production of cancer [n CARCINOGENESES]\n",
  "CARCINOGENIC": "causing or tending to cause cancer [adj]\n",
  "CARCINOGENICITY": "the state of being carcinogenic [n]\n",
  "CARCINOGENS": "CARCINOGEN, an agent causing cancer [n]\n",
  "CARCINOID": "a benign or malignant tumour arising from the mucosa of the gastrointestinal tract [n -S]\n",
  "CARCINOIDS": "CARCINOID, a benign or malignant tumour arising from the mucosa of the gastrointestinal tract [n]\n",
  "CARCINOLOGICAL": "related to carcinology [adj]\n",
  "CARCINOLOGIES": "CARCINOLOGY, the study of crabs and other crustaceans [n]\n",
  "CARCINOLOGIST": "a specialist in carcinology [n -S]\n",
  "CARCINOLOGISTS": "CARCINOLOGIST, a specialist in carcinology [n]\n",
  "CARCINOLOGY": "the study of crabs and other crustaceans [n CARCINOLOGIES]\n",
  "CARCINOMA": "(Greek) a cancer [n CARCINOMAS or CARCINOMATA]\n",
  "CARCINOMAS": "CARCINOMA, (Greek) a cancer [n]\n",
  "CARCINOMATA": "CARCINOMA, (Greek) a cancer [n]\n",
  "CARCINOMATOID": "having the shape of a carcinoma [adj]\n",
  "CARCINOMATOSES": "CARCINOMATOSIS, a condition in which multiple carcinomas develop simultaneously usually after dissemination from a primary source [n]\n",
  "CARCINOMATOSIS": "a condition in which multiple carcinomas develop simultaneously usually after dissemination from a primary source [n CARCINOMATOSES]\n",
  "CARCINOMATOUS": "relating to carcinoma [adj]\n",
  "CARCINOSARCOMA": "a kind of tumour [n -S]\n",
  "CARCINOSARCOMAS": "CARCINOSARCOMA, a kind of tumour [n]\n",
  "CARCINOSES": "CARCINOSIS, the spread of cancer in the body [n]\n",
  "CARCINOSIS": "the spread of cancer in the body [n CARCINOSES]\n",
  "CARD": "to comb wool [v -ED, -ING, -S]\n",
  "CARDAMINE": "(Greek) a genus of cruciferous plants [n -S]\n",
  "CARDAMINES": "CARDAMINE, (Greek) a genus of cruciferous plants [n]\n",
  "CARDAMOM": "a spice consisting of or made from the seed capsules of various Indo-Malayan plants, also CARDAMON, CARDAMUM [n -S]\n",
  "CARDAMOMS": "CARDAMOM, a spice consisting of or made from the seed capsules of various Indo-Malayan plants, also CARDAMON, CARDAMUM [n]\n",
  "CARDAMON": "a spice consisting of or made from the seed capsules of various Indo-Malayan plants, also CARDAMOM, CARDAMUM [n -S]\n",
  "CARDAMONS": "CARDAMON, a spice consisting of or made from the seed capsules of various Indo-Malayan plants, also CARDAMOM, CARDAMUM [n]\n",
  "CARDAMUM": "a spice consisting of or made from the seed capsules of various Indo-Malayan plants, also CARDAMOM, CARDAMON [n -S]\n",
  "CARDAMUMS": "CARDAMUM, a spice consisting of or made from the seed capsules of various Indo-Malayan plants, also CARDAMOM, CARDAMON [n]\n",
  "CARDAN": "as in cardan joint, a universal joint [adj]\n",
  "CARDBOARD": "a thin, stiff, finely-finished pasteboard [n -S]\n",
  "CARDBOARDIER": "CARDBOARDY, like cardboard [adj]\n",
  "CARDBOARDIEST": "CARDBOARDY, like cardboard [adj]\n",
  "CARDBOARDS": "CARDBOARD, a thin, stiff, finely-finished pasteboard [n]\n",
  "CARDBOARDY": "like cardboard [adj CARDBOARDIER, CARDBOARDIEST]\n",
  "CARDCASE": "a case or wallet for carrying business or credit cards [n -S]\n",
  "CARDCASES": "CARDCASE, a case or wallet for carrying business or credit cards [n]\n",
  "CARDCASTLE": "a tower built with playing cards [n -S]\n",
  "CARDCASTLES": "CARDCASTLE, a tower built with playing cards [n]\n",
  "CARDECU": "(French) an old French coin, also CARDECUE [n -S]\n",
  "CARDECUE": "(French) an old French coin, also CARDECU [n -S]\n",
  "CARDECUES": "CARDECUE, (French) an old French coin, also CARDECU [n]\n",
  "CARDECUS": "CARDECU, (French) an old French coin, also CARDECUE [n]\n",
  "CARDED": "CARD, to comb wool [v]\n",
  "CARDER": "one that does carding [n -S]\n",
  "CARDERS": "CARDER, one that does carding [n]\n",
  "CARDHOLDER": "one who possesses a card and esp. a credit card [n -S]\n",
  "CARDHOLDERS": "CARDHOLDER, one who possesses a card and esp. a credit card [n]\n",
  "CARDI": "(short for) a short form of cardigan, a woollen jacket which buttons in front, also CARDIE, CARDY [n -S]\n",
  "CARDIA": "(Greek) an opening of the esophagus [n CARDIAS or CARDIAE]\n",
  "CARDIAC": "a person with a heart disorder [n -S]\n",
  "CARDIACAL": "related to the heart, also CARDIAC [adj]\n",
  "CARDIACS": "CARDIAC, a person with a heart disorder [n]\n",
  "CARDIAE": "CARDIA, (Greek) an opening of the esophagus [n]\n",
  "CARDIALGIA": "heartburn, also CARDIALGY [n -S]\n",
  "CARDIALGIAS": "CARDIALGIA, heartburn, also CARDIALGY [n]\n",
  "CARDIALGIC": "relating to cardialgia, heartburn [adj]\n",
  "CARDIALGIES": "CARDIALGY, heartburn, also CARDIALGIA [n]\n",
  "CARDIALGY": "heartburn, also CARDIALGIA [n CARDIALGIES]\n",
  "CARDIAS": "CARDIA, (Greek) an opening of the esophagus [n]\n",
  "CARDIE": "(short for) cardigan, a woollen jacket which buttons in front, also CARDI, CARDY [n -S]\n",
  "CARDIES": "CARDY, (short for) a short form of cardigan, a woollen jacket which buttons in front, also CARDI, CARDIE [n]\n",
  "CARDIGAN": "a woollen jacket which buttons in front [n -S]\n",
  "CARDIGANED": "wearing a cardigan [adj]\n",
  "CARDIGANS": "CARDIGAN, a woollen jacket which buttons in front [n]\n",
  "CARDINAL": "of fundamental importance [adj CARDINALLY] / a bright red bird [n -S]\n",
  "CARDINALATE": "the office or dignity of cardinal; the cardinals collectively [n -S]\n",
  "CARDINALATES": "CARDINALATE, the office or dignity of cardinal; the cardinals collectively [n]\n",
  "CARDINALATIAL": "relating to a cardinal or to the office of cardinal, also CARDINALITIAL [adj]\n",
  "CARDINALITIAL": "relating to a cardinal or to the office of cardinal, also CARDINALATIAL [adj]\n",
  "CARDINALITIES": "CARDINALITY, the number of elements in a given mathematical set [n]\n",
  "CARDINALITY": "the number of elements in a given mathematical set [n CARDINALITIES]\n",
  "CARDINALLY": "CARDINAL, of fundamental importance [adv]\n",
  "CARDINALS": "CARDINAL, a bright red bird [n]\n",
  "CARDINALSHIP": "the office of cardinal [n -S]\n",
  "CARDINALSHIPS": "CARDINALSHIP, the office of cardinal [n]\n",
  "CARDING": "the process of combing and cleaning wool or cotton fibers [n -S]\n",
  "CARDINGS": "CARDING, the process of combing and cleaning wool or cotton fibers [n]\n",
  "CARDIO": "(short for) a cardiograph [n -S]\n",
  "CARDIOCENTESES": "CARDIOCENTESIS, surgical puncture of the heart [n]\n",
  "CARDIOCENTESIS": "surgical puncture of the heart [n CARDIOCENTESES]\n",
  "CARDIOGENIC": "originating in the heart [adj]\n",
  "CARDIOGRAM": "a tracing obtained from a cardiograph [n -S]\n",
  "CARDIOGRAMS": "CARDIOGRAM, a tracing obtained from a cardiograph [n]\n",
  "CARDIOGRAPH": "an instrument for recording movements of the heart [n -S]\n",
  "CARDIOGRAPHER": "one who makes cardiographs [n -S]\n",
  "CARDIOGRAPHERS": "CARDIOGRAPHER, one who makes cardiographs [n]\n",
  "CARDIOGRAPHIC": "relating to cardiography, also CARDIOGRAPHICAL [adj]\n",
  "CARDIOGRAPHICAL": "relating to cardiography, also CARDIOGRAPHIC [adj]\n",
  "CARDIOGRAPHIES": "CARDIOGRAPHY, the making of cardiographs [n]\n",
  "CARDIOGRAPHS": "CARDIOGRAPH, an instrument for recording movements of the heart [n]\n",
  "CARDIOGRAPHY": "the making of cardiographs [n CARDIOGRAPHIES]\n",
  "CARDIOID": "a heart-shaped curve [n -S]\n",
  "CARDIOIDS": "CARDIOID, a heart-shaped curve [n]\n",
  "CARDIOLOGICAL": "relating to cardiology [adj]\n",
  "CARDIOLOGIES": "CARDIOLOGY, the study of the heart [n]\n",
  "CARDIOLOGIST": "a practitioner of cardiology [n -S]\n",
  "CARDIOLOGISTS": "CARDIOLOGIST, a practitioner of cardiology [n]\n",
  "CARDIOLOGY": "the study of the heart [n CARDIOLOGIES]\n",
  "CARDIOMEGALIES": "CARDIOMEGALY, another name for megalocardia [n]\n",
  "CARDIOMEGALY": "another name for megalocardia [n CARDIOMEGALIES]\n",
  "CARDIOMOTOR": "relating to the action of the heart [adj]\n",
  "CARDIOMYOPATHY": "any of several structural or functional diseases of heart muscle marked esp. by hypertrophy and obstructive damage to the heart [n]\n",
  "CARDIOPATHIES": "CARDIOPATHY, any disease of the heart [n]\n",
  "CARDIOPATHY": "any disease of the heart [n CARDIOPATHIES]\n",
  "CARDIOPLEGIA": "deliberate arrest of the action of the heart, as by hypothermia or the injection of chemicals, to enable complex heart surgery to be carried out [n -S]\n",
  "CARDIOPLEGIAS": "CARDIOPLEGIA, deliberate arrest of the action of the heart, as by hypothermia or the injection of chemicals, to enable complex heart surgery to be carried out [n]\n",
  "CARDIOPULMONARY": "of or relating to the heart and lungs [adj]\n",
  "CARDIOS": "CARDIO, (short for) a cardiograph [n]\n",
  "CARDIOTHORACIC": "relating to, involving, or specializing in the heart and chest [adj]\n",
  "CARDIOTONIC": "a substance that tends to increase the tonus of heart muscle [n -S]\n",
  "CARDIOTONICS": "CARDIOTONIC, a substance that tends to increase the tonus of heart muscle [n]\n",
  "CARDIOVASCULAR": "of, relating to, or involving the heart and blood vessels [adj]\n",
  "CARDIS": "CARDI, (short for) a short form of cardigan, a woollen jacket which buttons in front, also CARDIE, CARDY [n]\n",
  "CARDITIC": "relating to carditis [adj]\n",
  "CARDITIS": "inflammation of the heart [n -ES]\n",
  "CARDITISES": "CARDITIS, inflammation of the heart [n]\n",
  "CARDON": "a variety of cactus, native to Mexico [n -S]\n",
  "CARDONS": "CARDON, a variety of cactus, native to Mexico [n]\n",
  "CARDOON": "a thistle-like plant [n -S]\n",
  "CARDOONS": "CARDOON, a thistle-like plant [n]\n",
  "CARDOPHAGI": "CARDOPHAGUS, (obsolete) a donkey; something that eats thistles [n]\n",
  "CARDOPHAGUS": "(obsolete) a donkey; something that eats thistles [n CARDOPHAGI]\n",
  "CARDPHONE": "a public telephone from which calls are made using a prepaid plastic card [n -S]\n",
  "CARDPHONES": "CARDPHONE, a public telephone from which calls are made using a prepaid plastic card [n]\n",
  "CARDPLAYER": "one who plays cards [n -S]\n",
  "CARDPLAYERS": "CARDPLAYER, one who plays cards [n]\n",
  "CARDPUNCH": "a machine which perforates cards to record data [n -ES]\n",
  "CARDPUNCHES": "CARDPUNCH, a machine which perforates cards to record data [n]\n",
  "CARDS": "CARD, to comb wool [v]\n",
  "CARDSHARP": "one who engages in sharp practice at cards, also CARDSHARPER [n -S]\n",
  "CARDSHARPER": "one who engages in sharp practice at cards, also CARDSHARP [n -S]\n",
  "CARDSHARPERS": "CARDSHARPER, one who engages in sharp practice at cards, also CARDSHARP [n]\n",
  "CARDSHARPING": "cheating by a professional cardsharp [n -S]\n",
  "CARDSHARPINGS": "CARDSHARPING, cheating by a professional cardsharp [n]\n",
  "CARDSHARPS": "CARDSHARP, one who engages in sharp practice at cards, also CARDSHARPER [n]\n",
  "CARDUACEOUS": "belonging to the thistle family [adj]\n",
  "CARDUUS": "(Shakespeare) a thistle [n -ES]\n",
  "CARDUUSES": "CARDUUS, (Shakespeare) a thistle [n]\n",
  "CARDY": "(short for) a short form of cardigan, a woollen jacket which buttons in front, also CARDI, CARDIE [n CARDIES]\n",
  "CARE": "to be concerned [v CARED, CARING, CARES]\n",
  "CARED": "CARE, to be concerned [v]\n",
  "CAREEN": "to turn (a ship) on its side for repairs [v -ED, -ING, -S]\n",
  "CAREENAGE": "a place where ships are careened [n -S]\n",
  "CAREENAGES": "CAREENAGE, a place where ships are careened [n]\n",
  "CAREENED": "CAREEN, to turn (a ship) on its side for repairs [v]\n",
  "CAREENER": "one who careens [n -S]\n",
  "CAREENERS": "CAREENER, one who careens [n]\n",
  "CAREENING": "CAREEN, to turn (a ship) on its side for repairs [v]\n",
  "CAREENS": "CAREEN, to turn (a ship) on its side for repairs [v]\n",
  "CAREER": "to go at full speed [v -ED, -ING, -S]\n",
  "CAREERED": "CAREER, to go at full speed [v]\n",
  "CAREERER": "one who careers [n -S]\n",
  "CAREERERS": "CAREERER, one who careers [n]\n",
  "CAREERING": "CAREER, to go at full speed [v]\n",
  "CAREERISM": "intentness on one's own advancement [n -S]\n",
  "CAREERISMS": "CAREERISM, intentness on one's own advancement [n]\n",
  "CAREERIST": "one intent on his own advancement [n -S]\n",
  "CAREERISTS": "CAREERIST, one intent on his own advancement [n]\n",
  "CAREERS": "CAREER, to go at full speed [v]\n",
  "CAREFREE": "without worry [adj]\n",
  "CAREFREENESS": "the state of being carefree [n -ES]\n",
  "CAREFREENESSES": "CAREFREENESS, the state of being carefree [n]\n",
  "CAREFUL": "cautious [adj CAREFULLER, CAREFULLEST, CAREFULLY]\n",
  "CAREFULLER": "CAREFUL, cautious [adj]\n",
  "CAREFULLEST": "CAREFUL, cautious [adj]\n",
  "CAREFULLY": "CAREFUL, cautious [adv]\n",
  "CAREFULNESS": "the state of being careful [n -ES]\n",
  "CAREFULNESSES": "CAREFULNESS, the state of being careful [n]\n",
  "CAREGIVER": "one who looks after another [n -S]\n",
  "CAREGIVERS": "CAREGIVER, one who looks after another [n]\n",
  "CAREGIVING": "the act of giving care [n -S]\n",
  "CAREGIVINGS": "CAREGIVING, the act of giving care [n]\n",
  "CARELESS": "inattentive; negligent [adj CARELESSLY]\n",
  "CARELESSLY": "CARELESS, inattentive; negligent [adv]\n",
  "CARELESSNESS": "the state of being careless [n -ES]\n",
  "CARELESSNESSES": "CARELESSNESS, the state of being careless [n]\n",
  "CARELINE": "a telephone service set up by a business to supposedly care for customers [n -S]\n",
  "CARELINES": "CARELINE, a telephone service set up by a business to supposedly care for customers [n]\n",
  "CAREME": "(French) lent [n -S]\n",
  "CAREMES": "CAREME, (French) lent [n]\n",
  "CARER": "one that cares [n -S]\n",
  "CARERS": "CARER, one that cares [n]\n",
  "CARES": "CARE, to be concerned [v]\n",
  "CARESS": "to touch lovingly [v -ED, -ING, -ES]\n",
  "CARESSED": "CARESS, to touch lovingly [v]\n",
  "CARESSER": "one who caresses [n -S]\n",
  "CARESSERS": "CARESSER, one who caresses [n]\n",
  "CARESSES": "CARESS, to touch lovingly [v]\n",
  "CARESSING": "touching lovingly [adj CARESSINGLY] / the act of caressing [n -S]\n",
  "CARESSINGLY": "CARESSING, touching lovingly [adv]\n",
  "CARESSINGS": "CARESSING, the act of caressing [n]\n",
  "CARESSIVE": "of or like a caress [adj CARESSIVELY]\n",
  "CARESSIVELY": "CARESSIVE, of or like a caress [adv]\n",
  "CARET": "a typographical mark (^) used to note an omission [n -S]\n",
  "CARETAKE": "to take care of someone's property [v CARETOOK, CARETAKEN, CARETAKING, CARETAKES]\n",
  "CARETAKEN": "CARETAKE, to take care of someone's property [v]\n",
  "CARETAKER": "someone put in charge of a place, esp. a building [n -S]\n",
  "CARETAKERS": "CARETAKER, someone put in charge of a place, esp. a building [n]\n",
  "CARETAKES": "CARETAKE, to take care of someone's property [v]\n",
  "CARETAKING": "acting as caretaker (for a property, etc.) [n -S]\n",
  "CARETAKINGS": "CARETAKING, acting as caretaker (for a property, etc.) [n]\n",
  "CARETOOK": "CARETAKE, to take care of someone's property [v]\n",
  "CARETS": "CARET, a typographical mark (^) used to note an omission [n]\n",
  "CAREWARE": "computer software that is made available in exchange for making a donation of one's services or money to a charity [n -S]\n",
  "CAREWARES": "CAREWARE, computer software that is made available in exchange for making a donation of one's services or money to a charity [n]\n",
  "CAREWORKER": "one whose job involves looking after other people [n -S]\n",
  "CAREWORKERS": "CAREWORKER, one whose job involves looking after other people [n]\n",
  "CAREWORN": "showing signs of stress [adj]\n",
  "CAREX": "(Latin) a genus of plants, the sedges [n CARICES]\n",
  "CARFARE": "payment for a bus or car ride [n -S]\n",
  "CARFARES": "CARFARE, payment for a bus or car ride [n]\n",
  "CARFAX": "a place where four roads meet, also CARFOX [n -ES]\n",
  "CARFAXES": "CARFAX, a place where four roads meet, also CARFOX [n]\n",
  "CARFOX": "a place where four roads meet, also CARFAX [n -ES]\n",
  "CARFOXES": "CARFOX, a place where four roads meet, also CARFAX [n]\n",
  "CARFUFFLE": "(Scots) to make a commotion, also CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v CARFUFFLED, CARFUFFLING, CARFUFFLES]\n",
  "CARFUFFLED": "CARFUFFLE, (Scots) to make a commotion, also CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "CARFUFFLES": "CARFUFFLE, (Scots) to make a commotion, also CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "CARFUFFLING": "CARFUFFLE, (Scots) to make a commotion, also CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "CARFUL": "as much as a car can hold [n -S]\n",
  "CARFULS": "CARFUL, as much as a car can hold [n]\n",
  "CARGEESE": "CARGOOSE, (Old Norse) the crested grebe [n]\n",
  "CARGO": "a load [n -S] / to load, weigh down [v -ED, -ING, -ES]\n",
  "CARGOED": "CARGO, to load, weigh down [v]\n",
  "CARGOES": "CARGO, to load, weigh down [v]\n",
  "CARGOING": "CARGO, to load, weigh down [v]\n",
  "CARGOOSE": "(Old Norse) the crested grebe [n CARGEESE]\n",
  "CARGOS": "CARGO, a load [n]\n",
  "CARHOP": "a waitress at a drive-in restaurant [n -S] / to work as a carhop [v CARHOPPED, CARHOPPING, CARHOPS]\n",
  "CARHOPPED": "CARHOP, to work as a carhop [v]\n",
  "CARHOPPING": "CARHOP, to work as a carhop [v]\n",
  "CARHOPPINGS": "CARHOPPING [n]\n",
  "CARHOPS": "CARHOP, to work as a carhop [v]\n",
  "CARIACOU": "an American deer, aka white-tailed deer, also CARJACOU [n -S]\n",
  "CARIACOUS": "CARIACOU, an American deer, aka white-tailed deer, also CARJACOU [n]\n",
  "CARIAMA": "(Tupi) a large South American bird related to the cranes, also SERIEMA [n -S]\n",
  "CARIAMAS": "CARIAMA, (Tupi) a large South American bird related to the cranes, also SERIEMA [n]\n",
  "CARIBE": "(Spanish) a South American freshwater fish, remarkable for its voracity, aka piranha [n -S]\n",
  "CARIBES": "CARIBE, (Spanish) a South American freshwater fish, remarkable for its voracity, aka piranha [n]\n",
  "CARIBOO": "(Canadian) a large deer found in Canada, also CARIBOU [n -S]\n",
  "CARIBOOS": "CARIBOO, (Canadian) a large deer found in Canada, also CARIBOU [n]\n",
  "CARIBOU": "(Canadian) a large deer found in Canada, also CARIBOO [n -S]\n",
  "CARIBOUS": "CARIBOU, (Canadian) a large deer found in Canada, also CARIBOO [n]\n",
  "CARICATURA": "(Italian) a caricature [n -S]\n",
  "CARICATURAL": "like a caricature [adj]\n",
  "CARICATURAS": "CARICATURA, (Italian) a caricature [n]\n",
  "CARICATURE": "to make or draw a caricature of [v CARICATURED, CARICATURING, CARICATURES]\n",
  "CARICATURED": "CARICATURE, to make or draw a caricature of [v]\n",
  "CARICATURES": "CARICATURE, to make or draw a caricature of [v]\n",
  "CARICATURING": "CARICATURE, to make or draw a caricature of [v]\n",
  "CARICATURIST": "one who draws caricatures [n -S]\n",
  "CARICATURISTS": "CARICATURIST, one who draws caricatures [n]\n",
  "CARICES": "CAREX, (Latin) a genus of plants, the sedges [n]\n",
  "CARIED": "affected by caries, tooth decay [adj]\n",
  "CARIERE": "(obsolete) career [n -S]\n",
  "CARIERES": "CARIERE, (obsolete) career [n]\n",
  "CARIES": "(Latin) tooth decay [n CARIES]\n",
  "CARILLON": "(French) to play a set of bells [v CARILLONED or CARILLONNED, CARILLONING or CARILLONNING, CARILLONS]\n",
  "CARILLONED": "CARILLON, (French) to play a set of bells [v]\n",
  "CARILLONING": "CARILLON, (French) to play a set of bells [v]\n",
  "CARILLONIST": "one who plays a carillon, also CARILLONNEUR [n -S]\n",
  "CARILLONISTS": "CARILLONIST, one who plays a carillon, also CARILLONNEUR [n]\n",
  "CARILLONNED": "CARILLON, (French) to play a set of bells [v]\n",
  "CARILLONNEUR": "(French) one who plays a carillon, also CARILLONIST [n -S]\n",
  "CARILLONNEURS": "CARILLONNEUR, (French) one who plays a carillon, also CARILLONIST [n]\n",
  "CARILLONNING": "CARILLON, (French) to play a set of bells [v]\n",
  "CARILLONS": "CARILLON, (French) to play a set of bells [v]\n",
  "CARINA": "(Latin) a keel-shaped ridge on a bird's breast [n CARINAS or CARINAE]\n",
  "CARINAE": "CARINA, (Latin) a keel-shaped ridge on a bird's breast [n]\n",
  "CARINAL": "relating to a carina [adj]\n",
  "CARINAS": "CARINA, (Latin) a keel-shaped ridge on a bird's breast [n]\n",
  "CARINATE": "shaped like the keel of a ship [adj]\n",
  "CARINATED": "shaped like the prow or keel of a ship, also CARINATE [adj]\n",
  "CARING": "compassionate [adj CARINGLY] / the act of caring [n -S]\n",
  "CARINGLY": "in the manner of showing concern [adj]\n",
  "CARINGS": "CARING, the act of caring [n]\n",
  "CARIOCA": "(Portuguese) a South American dance [n -S]\n",
  "CARIOCAS": "CARIOCA, (Portuguese) a South American dance [n]\n",
  "CARIOGENIC": "causing dental cavities [adj]\n",
  "CARIOLE": "(French) a small open carriage, also CARRIOLE [n -S]\n",
  "CARIOLES": "CARIOLE, (French) a small open carriage, also CARRIOLE [n]\n",
  "CARIOSE": "of teeth, affected with caries, decayed, also CARIOUS [adj]\n",
  "CARIOSITIES": "CARIOSITY, the state of being cariose [n]\n",
  "CARIOSITY": "the state of being cariose [n CARIOSITIES]\n",
  "CARIOUS": "of teeth, affected with caries, decayed, also CARIOSE [adj]\n",
  "CARIOUSNESS": "the state of being carious [n -ES]\n",
  "CARIOUSNESSES": "CARIOUSNESS, the state of being carious [n]\n",
  "CARITAS": "(Latin) love for all people [n CARITASES or CARITATES]\n",
  "CARITASES": "CARITAS, (Latin) love for all people [n]\n",
  "CARITATES": "CARITAS, (Latin) love for all people [n]\n",
  "CARJACK": "to hijack a car [v -ED, -ING, -S]\n",
  "CARJACKED": "CARJACK, to hijack a car [v]\n",
  "CARJACKER": "one who steals cars by holding up their owners and demanding the keys [n -S]\n",
  "CARJACKERS": "CARJACKER, one who steals cars by holding up their owners and demanding the keys [n]\n",
  "CARJACKING": "the theft of a car at gunpoint [n -S]\n",
  "CARJACKINGS": "CARJACKING, the theft of a car at gunpoint [n]\n",
  "CARJACKS": "CARJACK, to hijack a car [v]\n",
  "CARJACOU": "an American deer, also CARIACOU [n -S]\n",
  "CARJACOUS": "CARJACOU, an American deer, also CARIACOU [n]\n",
  "CARK": "(archaic) to worry [v -ED, -ING, -S]\n",
  "CARKED": "CARK, (archaic) to worry [v]\n",
  "CARKING": "CARK, (archaic) to worry [v]\n",
  "CARKS": "CARK, (archaic) to worry [v]\n",
  "CARL": "a rude, rustic man; a churl, also CARLE, CARLOT [n -S]\n",
  "CARLE": "a rude, rustic man; a churl, also CARL, CARLOT [n -S]\n",
  "CARLES": "CARLE, a rude, rustic man; a churl, also CARL, CARLOT [n]\n",
  "CARLESS": "without a car [adj]\n",
  "CARLIN": "(Scots) an old woman, a witch, also CARLINE [n -S]\n",
  "CARLINE": "(Scots) an old woman, a witch, also CARLIN [n -S]\n",
  "CARLINES": "CARLINE, (Scots) an old woman, a witch, also CARLIN [n]\n",
  "CARLING": "a short timber running lengthwise of a ship, from one transverse desk beam to another [n -S]\n",
  "CARLINGS": "CARLING, a short timber running lengthwise of a ship, from one transverse desk beam to another [n]\n",
  "CARLINS": "CARLIN, (Scots) an old woman, a witch, also CARLINE [n]\n",
  "CARLISH": "(archaic) churlish [adj]\n",
  "CARLOAD": "as much as a car can hold [n -S]\n",
  "CARLOADS": "CARLOAD, as much as a car can hold [n]\n",
  "CARLOCK": "Russian isinglass, made from the air bladder of the sturgeon, and used in clarifying wine [n -S]\n",
  "CARLOCKS": "CARLOCK, Russian isinglass, made from the air bladder of the sturgeon, and used in clarifying wine [n]\n",
  "CARLOT": "(Shakespeare) a peasant, a churl, also CARL, CARLE [n -S]\n",
  "CARLOTS": "CARLOT, (Shakespeare) a peasant, a churl, also CARL, CARLE [n]\n",
  "CARLS": "CARL, a rude, rustic man; a churl, also CARLE, CARLOT [n]\n",
  "CARMAGNOLE": "(French) a popular song and round dance of the French Revolutionary period [n -S]\n",
  "CARMAGNOLES": "CARMAGNOLE, (French) a popular song and round dance of the French Revolutionary period [n]\n",
  "CARMAKER": "an automobile manufacturer [n -S]\n",
  "CARMAKERS": "CARMAKER, an automobile manufacturer [n]\n",
  "CARMAN": "a streetcar driver [n CARMEN]\n",
  "CARMELITE": "a fine woollen fabric of beige or similar colour [n -S]\n",
  "CARMELITES": "CARMELITE, a fine woollen fabric of beige or similar colour [n]\n",
  "CARMEN": "CARMAN, a streetcar driver [n]\n",
  "CARMINATIVE": "able to relieve flatulence [adj] / a drug able to relieve flatulence [n -S]\n",
  "CARMINATIVES": "CARMINATIVE, a drug able to relieve flatulence [n]\n",
  "CARMINE": "a vivid red colour [n -S]\n",
  "CARMINES": "CARMINE, a vivid red colour [n]\n",
  "CARN": "a mound of stones set up as a memorial, also CAIRN [n -S]\n",
  "CARNAGE": "great and bloody slaughter [n -S]\n",
  "CARNAGES": "CARNAGE, great and bloody slaughter [n]\n",
  "CARNAHUBA": "(Portuguese) a Brazilian palm tree yielding a fine yellowish wax, also CARNAUBA [n -S]\n",
  "CARNAHUBAS": "CARNAHUBA, (Portuguese) a Brazilian palm tree yielding a fine yellowish wax, also CARNAUBA [n]\n",
  "CARNAL": "to act carnally [v CARNALLED, CARNALLING, CARNALS] / pertaining to bodily appetites [adj CARNALLY]\n",
  "CARNALISE": "to sensualise, also CARNALIZE [v CARNALISED, CARNALISING, CARNALISES]\n",
  "CARNALISED": "CARNALISE, to sensualise, also CARNALIZE [v]\n",
  "CARNALISES": "CARNALISE, to sensualise, also CARNALIZE [v]\n",
  "CARNALISING": "CARNALISE, to sensualise, also CARNALIZE [v]\n",
  "CARNALISM": "the state of being carnal [n -S]\n",
  "CARNALISMS": "CARNALISM, the state of being carnal [n]\n",
  "CARNALIST": "a sensualist [n -S]\n",
  "CARNALISTS": "CARNALIST, a sensualist [n]\n",
  "CARNALITIES": "CARNALITY, the state of being carnal [n]\n",
  "CARNALITY": "the state of being carnal [n CARNALITIES]\n",
  "CARNALIZE": "to sensualise, also CARNALISE [v CARNALIZED, CARNALIZING, CARNALIZES]\n",
  "CARNALIZED": "CARNALIZE, to sensualise, also CARNALISE [v]\n",
  "CARNALIZES": "CARNALIZE, to sensualise, also CARNALISE [v]\n",
  "CARNALIZING": "CARNALIZE, to sensualise, also CARNALISE [v]\n",
  "CARNALLED": "CARNAL, to act carnally [v]\n",
  "CARNALLING": "CARNAL, to act carnally [v]\n",
  "CARNALLITE": "a hydrous chloride of potassium and magnesium, sometimes found associated with deposits of rock salt [n -S]\n",
  "CARNALLITES": "CARNALLITE, a hydrous chloride of potassium and magnesium, sometimes found associated with deposits of rock salt [n]\n",
  "CARNALLY": "CARNAL, pertaining to bodily appetites [adv]\n",
  "CARNALS": "CARNAL, to act carnally [v]\n",
  "CARNAPTIOUS": "(Scots) bad-tempered; cantankerous, also CURNAPTIOUS [adj]\n",
  "CARNAROLI": "(Italian) a variety of short-grained rice used for risotto [n -S]\n",
  "CARNAROLIS": "CARNAROLI, (Italian) a variety of short-grained rice used for risotto [n]\n",
  "CARNASSIAL": "adapted for tearing [adj] / a tooth adapted for tearing [n -S]\n",
  "CARNASSIALS": "CARNASSIAL, a tooth adapted for tearing [n]\n",
  "CARNATION": "a double-flowering cultivated variety of the clove pink [n -S]\n",
  "CARNATIONED": "ruddy [adj]\n",
  "CARNATIONS": "CARNATION, a double-flowering cultivated variety of the clove pink [n]\n",
  "CARNAUBA": "(Portuguese) a Brazilian palm tree yielding a fine yellowish wax, also CARNAHUBA [n -S]\n",
  "CARNAUBAS": "CARNAUBA, (Portuguese) a Brazilian palm tree yielding a fine yellowish wax, also CARNAHUBA [n]\n",
  "CARNELIAN": "a dull red or reddish-white kind of chalcedony, also CORNELIAN [n -S]\n",
  "CARNELIANS": "CARNELIAN, a dull red or reddish-white kind of chalcedony, also CORNELIAN [n]\n",
  "CARNEOUS": "fleshy; of or like flesh, also CARNOSE [adj]\n",
  "CARNET": "(French) a customs or other permit; a book of coupons [n -S]\n",
  "CARNETS": "CARNET, (French) a customs or other permit; a book of coupons [n]\n",
  "CARNEY": "to coax, also CARNY [v -ED, -ING, -S]\n",
  "CARNEYED": "CARNEY, to coax, also CARNY [v]\n",
  "CARNEYING": "CARNEY, to coax, also CARNY [v]\n",
  "CARNEYS": "CARNEY, to coax, also CARNY [v]\n",
  "CARNIE": "a carnival [n -S]\n",
  "CARNIED": "CARNY, to coax, wheedle, also CARNEY [v]\n",
  "CARNIER": "CARNY, cunning [adj]\n",
  "CARNIES": "CARNY, to coax, wheedle, also CARNEY [v]\n",
  "CARNIEST": "CARNY, cunning [adj]\n",
  "CARNIFEX": "(Latin) an executioner, esp. the public executioner in ancient Rome [n -ES]\n",
  "CARNIFEXES": "CARNIFEX, (Latin) an executioner, esp. the public executioner in ancient Rome [n]\n",
  "CARNIFICATION": "conversion into flesh [n -S]\n",
  "CARNIFICATIONS": "CARNIFICATION, conversion into flesh [n]\n",
  "CARNIFICIAL": "of or pertaining to butchers or executioners [adj]\n",
  "CARNIFIED": "CARNIFY, to form flesh; to become like flesh [v]\n",
  "CARNIFIES": "CARNIFY, to form flesh; to become like flesh [v]\n",
  "CARNIFY": "to form flesh; to become like flesh [v CARNIFIED, CARNIFYING, CARNIFIES]\n",
  "CARNIFYING": "CARNIFY, to form flesh; to become like flesh [v]\n",
  "CARNITINE": "a betaine in meat [n -S]\n",
  "CARNITINES": "CARNITINE, a betaine in meat [n]\n",
  "CARNIVAL": "a travelling amusement show [n -S]\n",
  "CARNIVALESQUE": "characteristic of or appropriate to a carnival [adj]\n",
  "CARNIVALS": "CARNIVAL, a travelling amusement show [n]\n",
  "CARNIVORA": "an order of flesh-eating mammals, including dogs, cats, bears, weasels, etc. [n]\n",
  "CARNIVORE": "an animal or plant that feeds on flesh [n -S]\n",
  "CARNIVORES": "CARNIVORE, an animal or plant that feeds on flesh [n]\n",
  "CARNIVORIES": "CARNIVORY, the state of being a carnivore [n]\n",
  "CARNIVOROUS": "feeding on animal tissues [adj CARNIVOROUSLY]\n",
  "CARNIVOROUSLY": "CARNIVOROUS, feeding on animal tissues [adv]\n",
  "CARNIVOROUSNESS": "the state of being carnivorous [n]\n",
  "CARNIVORY": "the state of being a carnivore [n CARNIVORIES]\n",
  "CARNOSAUR": "a meat-eating dinosaur [n -S]\n",
  "CARNOSAURS": "CARNOSAUR, a meat-eating dinosaur [n]\n",
  "CARNOSE": "fleshy; of or like flesh, also CARNEOUS [adj]\n",
  "CARNOSITIES": "CARNOSITY, a fleshy excrescence; esp. a small excrescence or fungous growth [n]\n",
  "CARNOSITY": "a fleshy excrescence; esp. a small excrescence or fungous growth [n CARNOSITIES]\n",
  "CARNOTITE": "a yellow uranium ore [n -S]\n",
  "CARNOTITES": "CARNOTITE, a yellow uranium ore [n]\n",
  "CARNS": "CARN, a mound of stones set up as a memorial, also CAIRN [n]\n",
  "CARNY": "to coax, wheedle, also CARNEY [v CARNIED, CARNYING, CARNIES] / cunning [adj CARNIER, CARNIEST]\n",
  "CARNYING": "CARNY, to coax, wheedle, also CARNEY [v]\n",
  "CARNYX": "a long war trumpet used by the Celts [n -ES]\n",
  "CARNYXES": "CARNYX, a long war trumpet used by the Celts [n]\n",
  "CAROACH": "a stately carriage, also CAROCHE, CAROCH, CARROCH [n -ES]\n",
  "CAROACHES": "CAROACH, a stately carriage, also CAROCHE, CAROCH, CARROCH [n]\n",
  "CAROB": "(Arabic) the sweet-flavoured seed of an evergreen tree, aka locust bean [n -S]\n",
  "CAROBS": "CAROB, (Arabic) the sweet-flavoured seed of an evergreen tree, aka locust bean [n]\n",
  "CAROCH": "a stately carriage, also CAROCHE, CAROACH, CARROCH [n -ES]\n",
  "CAROCHE": "(French) a stately carriage, also CAROACH, CAROCH, CARROCH [n -S]\n",
  "CAROCHES": "CAROCHE, (French) a stately carriage, also CAROACH, CAROCH, CARROCH [n]\n",
  "CAROL": "to sing joyously [v CAROLED or CAROLLED, CAROLING or CAROLLING, CAROLS]\n",
  "CAROLED": "CAROL, to sing joyously [v]\n",
  "CAROLER": "one who sings joyously, also CAROLLER [n -S]\n",
  "CAROLERS": "CAROLER, one who sings joyously, also CAROLLER [n]\n",
  "CAROLI": "CAROLUS, (Latin) a former English gold coin, first struck in the reign of Charles I [n]\n",
  "CAROLING": "singing carols, also CAROLLING [n -S]\n",
  "CAROLINGS": "CAROLING, singing carols, also CAROLLING [n]\n",
  "CAROLLED": "CAROL, to sing joyously [v]\n",
  "CAROLLER": "one who sings joyously, also CAROLER [n -S]\n",
  "CAROLLERS": "CAROLLER, one who sings joyously, also CAROLER [n]\n",
  "CAROLLING": "singing carols, also CAROLING [n -S]\n",
  "CAROLLINGS": "CAROLLING, singing carols, also CAROLING [n]\n",
  "CAROLS": "CAROL, to sing joyously [v]\n",
  "CAROLUS": "(Latin) a former English gold coin, first struck in the reign of Charles I [n CAROLI or CAROLUSES]\n",
  "CAROLUSES": "CAROLUS, (Latin) a former English gold coin, first struck in the reign of Charles I [n]\n",
  "CAROM": "to collide with and rebound, also CARROM [v -ED, -ING, -S]\n",
  "CAROMED": "CAROM, to collide with and rebound, also CARROM [v]\n",
  "CAROMEL": "a dark brown substance produced by heating sugar, also CARAMEL [n -S] / to coat with caromel [v CAROMELLED, CAROMELLING, CAROMELS]\n",
  "CAROMELLED": "CAROMEL, to coat with caromel [v]\n",
  "CAROMELLING": "CAROMEL, to coat with caromel [v]\n",
  "CAROMELS": "CAROMEL, a dark brown substance produced by heating sugar, also CARAMEL [n]\n",
  "CAROMING": "CAROM, to collide with and rebound, also CARROM [v]\n",
  "CAROMS": "CAROM, to collide with and rebound, also CARROM [v]\n",
  "CARON": "another name for a HACEK, an inverted circumflex [n -S]\n",
  "CARONS": "CARON, another name for a HACEK, an inverted circumflex [n]\n",
  "CAROTENE": "any of a number of reddish-yellow pigments widely distributed in plants that are converted to vitamin A in the body, also CAROTIN, CARROTIN [n -S]\n",
  "CAROTENES": "CAROTENE, any of a number of reddish-yellow pigments widely distributed in plants that are converted to vitamin A in the body, also CAROTIN, CARROTIN [n]\n",
  "CAROTENOID": "any of a group of pigments similar to carotenes, found in plant and some animal tissues, also CAROTINOID [n -S]\n",
  "CAROTENOIDS": "CAROTENOID, any of a group of pigments similar to carotenes, found in plant and some animal tissues, also CAROTINOID [n]\n",
  "CAROTID": "a large artery that supplies blood to the head and neck [n -S]\n",
  "CAROTIDAL": "relating to the carotid artery [adj]\n",
  "CAROTIDS": "CAROTID, a large artery that supplies blood to the head and neck [n]\n",
  "CAROTIN": "any of a number of reddish-yellow pigments widely distributed in plants that are converted to vitamin A in the body, also CAROTENE, CARROTIN [n -S]\n",
  "CAROTINOID": "any of a group of pigments similar to carotenes, found in plant and some animal tissues, also CAROTENOID [n -S]\n",
  "CAROTINOIDS": "CAROTINOID, any of a group of pigments similar to carotenes, found in plant and some animal tissues, also CAROTENOID [n]\n",
  "CAROTINS": "CAROTIN, any of a number of reddish-yellow pigments widely distributed in plants that are converted to vitamin A in the body, also CAROTENE, CARROTIN [n]\n",
  "CAROUSAL": "a boisterous drinking party [n -S]\n",
  "CAROUSALS": "CAROUSAL, a boisterous drinking party [n]\n",
  "CAROUSE": "to engage in a carousal [v CAROUSED, CAROUSING, CAROUSES]\n",
  "CAROUSED": "CAROUSE, to engage in a carousal [v]\n",
  "CAROUSEL": "(French) a merry-go-round; a circular magazine for a slide projector, also CARROUSEL [n -S]\n",
  "CAROUSELS": "CAROUSEL, (French) a merry-go-round; a circular magazine for a slide projector, also CARROUSEL [n]\n",
  "CAROUSER": "one who carouses [n -S]\n",
  "CAROUSERS": "CAROUSER, one who carouses [n]\n",
  "CAROUSES": "CAROUSE, to engage in a carousal [v]\n",
  "CAROUSING": "making merry [adj CAROUSINGLY] / the act of engaging in a carousal [n -S]\n",
  "CAROUSINGLY": "CAROUSING, making merry [adv]\n",
  "CAROUSINGS": "CAROUSING, the act of engaging in a carousal [n]\n",
  "CARP": "to find fault with unreasonably [v -ED, -ING, -S]\n",
  "CARPACCIO": "(Italian) an hors d'oeuvre made of thin strips of raw meat or fish, often eaten with a relish [n -S]\n",
  "CARPACCIOS": "CARPACCIO, (Italian) an hors d'oeuvre made of thin strips of raw meat or fish, often eaten with a relish [n]\n",
  "CARPAL": "a bone in the wrist, also CARPALE [n -S]\n",
  "CARPALE": "(Greek) a bone in the wrist, also CARPAL [n CARPALES or CARPALIA]\n",
  "CARPALES": "CARPALE, (Greek) a bone in the wrist, also CARPAL [n]\n",
  "CARPALIA": "CARPALE, (Greek) a bone in the wrist, also CARPAL [n]\n",
  "CARPALS": "CARPAL, a bone in the wrist, also CARPALE [n]\n",
  "CARPED": "CARP, to find fault with unreasonably [v]\n",
  "CARPEL": "a single female organ of a flower, which contains one or more ovules [n -S]\n",
  "CARPELLARY": "belonging to, forming, or containing carpels [adj]\n",
  "CARPELLATE": "a flower containing carpels [n -S]\n",
  "CARPELLATES": "CARPELLATE, a flower containing carpels [n]\n",
  "CARPELS": "CARPEL, a single female organ of a flower, which contains one or more ovules [n]\n",
  "CARPENTARIA": "an evergreen shrub of the hydrangea family, cultivated for its glossy foliage and yellow-centred white flowers [n -S]\n",
  "CARPENTARIAS": "CARPENTARIA, an evergreen shrub of the hydrangea family, cultivated for its glossy foliage and yellow-centred white flowers [n]\n",
  "CARPENTER": "a person skilled in woodwork as used in building houses, ships, etc. [n -S] / to construct by carpentry [v -ED, -ING, -S]\n",
  "CARPENTERED": "CARPENTER, to construct by carpentry [v]\n",
  "CARPENTERING": "CARPENTER, to construct by carpentry [v]\n",
  "CARPENTERS": "CARPENTER, to construct by carpentry [v]\n",
  "CARPENTRIES": "CARPENTRY, the craft of working with wood [n]\n",
  "CARPENTRY": "the craft of working with wood [n CARPENTRIES]\n",
  "CARPER": "one who carps, criticises [n -S]\n",
  "CARPERS": "CARPER, one who carps, criticises [n]\n",
  "CARPET": "to cover a floor with a heavy woven fabric [v -ED, -ING, -S]\n",
  "CARPETBAG": "a travelling-bag made of carpeting [n -S] / to engage in political chicanery [v CARPETBAGGED, CARPETBAGGING, CARPETBAGS]\n",
  "CARPETBAGGED": "CARPETBAG, to engage in political chicanery [v]\n",
  "CARPETBAGGER": "an opportunistic outsider, especially a political candidate who contests an election in an area while having little connection to it [n -S]\n",
  "CARPETBAGGERIES": "CARPETBAGGERY, the actions of a carpetbagger [n]\n",
  "CARPETBAGGERS": "CARPETBAGGER, an opportunistic outsider, especially a political candidate who contests an election in an area while having little connection to it [n]\n",
  "CARPETBAGGERY": "the actions of a carpetbagger [n CARPETBAGGERIES]\n",
  "CARPETBAGGING": "the act of engaging in political chicanery [n -S]\n",
  "CARPETBAGGINGS": "CARPETBAGGING, the act of engaging in political chicanery [n]\n",
  "CARPETBAGS": "CARPETBAG, a travelling-bag made of carpeting [n]\n",
  "CARPETED": "CARPET, to cover a floor with a heavy woven fabric [v]\n",
  "CARPETING": "a scolding [n -S]\n",
  "CARPETINGS": "CARPETING, a scolding [n]\n",
  "CARPETLIKE": "like a carpet [adj]\n",
  "CARPETMONGER": "(Shakespeare) an effeminate person [n -S]\n",
  "CARPETMONGERS": "CARPETMONGER, (Shakespeare) an effeminate person [n]\n",
  "CARPETS": "CARPET, to cover a floor with a heavy woven fabric [v]\n",
  "CARPETWEED": "a North American mat-forming weed [n -S]\n",
  "CARPETWEEDS": "CARPETWEED, a North American mat-forming weed [n]\n",
  "CARPHOLOGIES": "CARPHOLOGY, fitful plucking movements as in delirium [n]\n",
  "CARPHOLOGY": "fitful plucking movements as in delirium [n CARPHOLOGIES]\n",
  "CARPHONE": "a phone for use in a car [n -S]\n",
  "CARPHONES": "CARPHONE, a phone for use in a car [n]\n",
  "CARPI": "CARPUS, (Latin) the part of the human skeleton between the forearm and the metacarpus [n]\n",
  "CARPING": "complaining [adj CARPINGLY] / the act of carping [n -S]\n",
  "CARPINGLY": "CARPING, complaining [adv]\n",
  "CARPINGS": "CARPING, the act of carping [n]\n",
  "CARPLIKE": "like a carp [adj]\n",
  "CARPOGONIA": "CARPOGONIUM, an egg-bearing vessel in red algae [n]\n",
  "CARPOGONIAL": "of or like a carpogonium, an egg-bearing vessel in red algae [adj]\n",
  "CARPOGONIUM": "an egg-bearing vessel in red algae [n CARPOGONIA]\n",
  "CARPOLOGICAL": "related to carpology [adj]\n",
  "CARPOLOGIES": "CARPOLOGY, the study of fruits and seeds [n]\n",
  "CARPOLOGIST": "a student of carpology, the study of fruits and seeds [n -S]\n",
  "CARPOLOGISTS": "CARPOLOGIST, a student of carpology, the study of fruits and seeds [n]\n",
  "CARPOLOGY": "the study of fruits and seeds [n CARPOLOGIES]\n",
  "CARPOMETACARPI": "CARPOMETACARPUS, in birds, a bone of the wing formed by fusion of some of the carpals with the metacarpals [n]\n",
  "CARPOMETACARPUS": "in birds, a bone of the wing formed by fusion of some of the carpals with the metacarpals [n CARPOMETACARPI]\n",
  "CARPOOL": "to take turns driving a group of commuters [v -ED, -ING, -S]\n",
  "CARPOOLED": "CARPOOL, to take turns driving a group of commuters [v]\n",
  "CARPOOLER": "one who shares a car with others [n -S]\n",
  "CARPOOLERS": "CARPOOLER, one who shares a car with others [n]\n",
  "CARPOOLING": "the sharing of cars [n -S]\n",
  "CARPOOLINGS": "CARPOOLING, the sharing of cars [n]\n",
  "CARPOOLS": "CARPOOL, to take turns driving a group of commuters [v]\n",
  "CARPOPHAGOUS": "fruit-eating [adj]\n",
  "CARPOPHORE": "a slender prolongation of the receptacle as an axis between the carpels, as in Geranium and many umbelliferous plants [n -S]\n",
  "CARPOPHORES": "CARPOPHORE, a slender prolongation of the receptacle as an axis between the carpels, as in Geranium and many umbelliferous plants [n]\n",
  "CARPORT": "a covered parking space, esp. a space under a roof projecting from a building [n -S]\n",
  "CARPORTS": "CARPORT, a covered parking space, esp. a space under a roof projecting from a building [n]\n",
  "CARPOSPORE": "a kind of spore formed in the conceptacles of red algae [n -S]\n",
  "CARPOSPORES": "CARPOSPORE, a kind of spore formed in the conceptacles of red algae [n]\n",
  "CARPS": "CARP, to find fault with unreasonably [v]\n",
  "CARPUS": "(Latin) the part of the human skeleton between the forearm and the metacarpus [n CARPI]\n",
  "CARR": "(Old Norse) an alder wood [n -S]\n",
  "CARRACK": "(historical) a large ship of burden, also CARACK, CARRACT, CARRECT [n -S]\n",
  "CARRACKS": "CARRACK, (historical) a large ship of burden, also CARACK, CARRACT, CARRECT [n]\n",
  "CARRACT": "(historical) a large ship of burden, also CARACK, CARRACK, CARRECT [n -S]\n",
  "CARRACTS": "CARRACT, (historical) a large ship of burden, also CARACK, CARRACK, CARRECT [n]\n",
  "CARRAGEEN": "(Irish) a kind of dark red, branched seaweed, aka Irish moss, also CARAGEEN, CARRAGHEEN [n -S]\n",
  "CARRAGEENAN": "a colloid prepared from red algae, used in food processing, pharmaceuticals etc., also CARAGEENAN, CARRAGEENIN, CARRAGHEENAN, CARRAGHEENIN [n -S]\n",
  "CARRAGEENANS": "CARRAGEENAN, a colloid prepared from red algae, used in food processing, pharmaceuticals etc., also CARAGEENAN, CARRAGEENIN, CARRAGHEENAN, CARRAGHEENIN [n]\n",
  "CARRAGEENIN": "a colloid prepared from red algae, used in food processing, pharmaceuticals, etc., also CARAGEENAN, CARRAGEENAN, CARRAGHEENAN, CARRAGHEENIN [n -S]\n",
  "CARRAGEENINS": "CARRAGEENIN, a colloid prepared from red algae, used in food processing, pharmaceuticals, etc., also CARAGEENAN, CARRAGEENAN, CARRAGHEENAN, CARRAGHEENIN [n]\n",
  "CARRAGEENS": "CARRAGEEN, (Irish) a kind of dark red, branched seaweed, aka Irish moss, also CARAGEEN, CARRAGHEEN [n]\n",
  "CARRAGHEEN": "(Irish) a kind of dark red, branched seaweed, aka Irish moss, also CARAGEEN, CARRAGEEN [n -S]\n",
  "CARRAGHEENAN": "a colloid prepared from red algae, used in food processing, pharmaceuticals, etc., also CARAGEENAN, CARRAGEENAN, CARRAGEENIN, CARRAGHEENIN [n -S]\n",
  "CARRAGHEENANS": "CARRAGHEENAN, a colloid prepared from red algae, used in food processing, pharmaceuticals, etc., also CARAGEENAN, CARRAGEENAN, CARRAGEENIN, CARRAGHEENIN [n]\n",
  "CARRAGHEENIN": "a colloid prepared from red algae, used in food processing, pharmaceuticals, etc., also CARAGEENAN, CARRAGEENAN, CARRAGEENIN, CARRAGHEENAN [n -S]\n",
  "CARRAGHEENINS": "CARRAGHEENIN, a colloid prepared from red algae, used in food processing, pharmaceuticals, etc., also CARAGEENAN, CARRAGEENAN, CARRAGEENIN, CARRAGHEENAN [n]\n",
  "CARRAGHEENS": "CARRAGHEEN, (Irish) a kind of dark red, branched seaweed, aka Irish moss, also CARAGEEN, CARRAGEEN [n]\n",
  "CARRAT": "a unit of weight used for gems, also CARAT, KARAT [n -S]\n",
  "CARRATS": "CARRAT, a unit of weight used for gems, also CARAT, KARAT [n]\n",
  "CARRAWAY": "an umbelliferous plant with aromatic seeds used as a tonic and condiment, also CARAWAY [n -S]\n",
  "CARRAWAYS": "CARRAWAY, an umbelliferous plant with aromatic seeds used as a tonic and condiment, also CARAWAY [n]\n",
  "CARRECT": "(historical) a large ship of burden, also CARACK, CARRACK, CARRACT [n -S]\n",
  "CARRECTS": "CARRECT, (historical) a large ship of burden, also CARACK, CARRACK, CARRACT [n]\n",
  "CARREFOUR": "(French) a crossroads, a plaza [n -S]\n",
  "CARREFOURS": "CARREFOUR, (French) a crossroads, a plaza [n]\n",
  "CARREL": "a desk for private study in a library, also CARRELL [n -S]\n",
  "CARRELL": "a desk for private study in a library, also CARREL [n -S]\n",
  "CARRELLS": "CARRELL, a desk for private study in a library, also CARREL [n]\n",
  "CARRELS": "CARREL, a desk for private study in a library, also CARRELL [n]\n",
  "CARRIAGE": "a wheeled horse-drawn vehicle [n -S]\n",
  "CARRIAGEABLE": "that can be conveyed by carriage [adj]\n",
  "CARRIAGES": "CARRIAGE, a wheeled horse-drawn vehicle [n]\n",
  "CARRIAGEWAY": "the part of a road used by vehicular traffic [n -S]\n",
  "CARRIAGEWAYS": "CARRIAGEWAY, the part of a road used by vehicular traffic [n]\n",
  "CARRICK": "as in carrick bend, a knot for joining cables [adj]\n",
  "CARRIED": "CARRY, to convey from one place to another [v]\n",
  "CARRIER": "one that carries [n -S]\n",
  "CARRIERS": "CARRIER, one that carries [n]\n",
  "CARRIES": "CARRY, to convey from one place to another [v]\n",
  "CARRIOLE": "(French) a small open carriage, also CARIOLE [n -S]\n",
  "CARRIOLES": "CARRIOLE, (French) a small open carriage, also CARIOLE [n]\n",
  "CARRION": "dead and rotting flesh [n -S]\n",
  "CARRIONS": "CARRION, dead and rotting flesh [n]\n",
  "CARRITCH": "(Scots) a catechism [n -ES]\n",
  "CARRITCHES": "CARRITCH, (Scots) a catechism [n]\n",
  "CARRIWITCHET": "(Scots) a teasing quibble; a quip [n -S]\n",
  "CARRIWITCHETS": "CARRIWITCHET, (Scots) a teasing quibble; a quip [n]\n",
  "CARROCH": "a stately carriage, also CAROCHE, CAROACH, CAROCH [n -ES]\n",
  "CARROCHES": "CARROCH, a stately carriage, also CAROCHE, CAROACH, CAROCH [n]\n",
  "CARROM": "to collide with and rebound, also CAROM [v -ED, -ING, -S]\n",
  "CARROMED": "CARROM, to collide with and rebound, also CAROM [v]\n",
  "CARROMING": "CARROM, to collide with and rebound, also CAROM [v]\n",
  "CARROMS": "CARROM, to collide with and rebound, also CAROM [v]\n",
  "CARRON": "as in carron oil, made from linseed oil and turpentine [adj]\n",
  "CARRONADE": "(historical) a short and light maritime cannon of large bore [n -S]\n",
  "CARRONADES": "CARRONADE, (historical) a short and light maritime cannon of large bore [n]\n",
  "CARROT": "a root vegetable [n -S]\n",
  "CARROTIER": "CARROTY, like or tasting of carrot [adj]\n",
  "CARROTIEST": "CARROTY, like or tasting of carrot [adj]\n",
  "CARROTIN": "a plant pigment, also CAROTENE, CAROTIN [n -S]\n",
  "CARROTINS": "CARROTIN, a plant pigment, also CAROTENE, CAROTIN [n]\n",
  "CARROTS": "CARROT, a root vegetable [n]\n",
  "CARROTTOP": "(colloquial) a redhead [n -S]\n",
  "CARROTTOPPED": "having red hair [adj]\n",
  "CARROTTOPS": "CARROTTOP, (colloquial) a redhead [n]\n",
  "CARROTY": "like or tasting of carrot [adj CARROTIER, CARROTIEST]\n",
  "CARROUSEL": "a merry-go-round; a circular magazine for a slide projector, also CAROUSEL [n -S]\n",
  "CARROUSELS": "CARROUSEL, a merry-go-round; a circular magazine for a slide projector, also CAROUSEL [n]\n",
  "CARRS": "CARR, (Old Norse) an alder wood [n]\n",
  "CARRY": "to convey from one place to another [v CARRIED, CARRYING, CARRIES]\n",
  "CARRYALL": "a light four-wheeled one-horse carriage [n -S]\n",
  "CARRYALLS": "CARRYALL, a light four-wheeled one-horse carriage [n]\n",
  "CARRYBACK": "in accounting, a loss set against the previous year's profit, in order to minimise the total tax [n -S]\n",
  "CARRYBACKS": "CARRYBACK, in accounting, a loss set against the previous year's profit, in order to minimise the total tax [n]\n",
  "CARRYCOT": "a cot for carrying a baby in [n -S]\n",
  "CARRYCOTS": "CARRYCOT, a cot for carrying a baby in [n]\n",
  "CARRYFORWARD": "a subtotal carried forward to the next column of figures [n -S]\n",
  "CARRYFORWARDS": "CARRYFORWARD, a subtotal carried forward to the next column of figures [n]\n",
  "CARRYING": "CARRY, to convey from one place to another [v]\n",
  "CARRYON": "a fuss, a commotion [n -S]\n",
  "CARRYONS": "CARRYON, a fuss, a commotion [n]\n",
  "CARRYOUT": "a takeout order of food [n -S]\n",
  "CARRYOUTS": "CARRYOUT, a takeout order of food [n]\n",
  "CARRYOVER": "in accounting, a payment carried over to the next accounting period [n -S]\n",
  "CARRYOVERS": "CARRYOVER, in accounting, a payment carried over to the next accounting period [n]\n",
  "CARRYTALE": "(Shakespeare) a talebearer [n -S]\n",
  "CARRYTALES": "CARRYTALE, (Shakespeare) a talebearer [n]\n",
  "CARS": "CAR, a self-propelled wheeled vehicle [n]\n",
  "CARSE": "(Scots) alluvial lowland beside a river [n -S]\n",
  "CARSES": "CARSE, (Scots) alluvial lowland beside a river [n]\n",
  "CARSEY": "(slang) a lavatory, also KARSEY, KARSY, KARZY, KAZI, KHAZI [n -S]\n",
  "CARSEYS": "CARSEY, (slang) a lavatory, also KARSEY, KARSY, KARZY, KAZI, KHAZI [n]\n",
  "CARSHARE": "to share a car for transport [v CARSHARED, CARSHARING, CARSHARES]\n",
  "CARSHARED": "CARSHARE, to share a car for transport [v]\n",
  "CARSHARES": "CARSHARE, to share a car for transport [v]\n",
  "CARSHARING": "the act of sharing a car for transport [n -S]\n",
  "CARSHARINGS": "CARSHARING, the act of sharing a car for transport [n]\n",
  "CARSICK": "nauseated from riding in a car [adj]\n",
  "CARSICKNESS": "a form of motion sickness caused by cars [n -ES]\n",
  "CARSICKNESSES": "CARSICKNESS, a form of motion sickness caused by cars [n]\n",
  "CARSPIEL": "a curling match in which curlers compete for a car [n -S]\n",
  "CARSPIELS": "CARSPIEL, a curling match in which curlers compete for a car [n]\n",
  "CART": "to convey in a two wheeled vehicle [v -ED, -ING, -S]\n",
  "CARTA": "(Latin) a charter, also CHARTA [n -S]\n",
  "CARTABLE": "able to be carted [adj]\n",
  "CARTAGE": "the act of carrying in a cart [n -S]\n",
  "CARTAGES": "CARTAGE, the act of carrying in a cart [n]\n",
  "CARTAS": "CARTA, (Latin) a charter, also CHARTA [n]\n",
  "CARTE": "(French) a bill of fare [n -S]\n",
  "CARTED": "CART, to convey in a two wheeled vehicle [v]\n",
  "CARTEL": "(French) a manufacturers' agreement or association formed to control marketing arrangements, regulate prices, etc. [n -S]\n",
  "CARTELISATION": "the act of cartelising, also CARTELIZATION [n -S]\n",
  "CARTELISATIONS": "CARTELISATION, the act of cartelising, also CARTELIZATION [n]\n",
  "CARTELISE": "to make into a cartel, also CARTELIZE [v CARTELISED, CARTELISING, CARTELISES]\n",
  "CARTELISED": "CARTELISE, to make into a cartel, also CARTELIZE [v]\n",
  "CARTELISES": "CARTELISE, to make into a cartel, also CARTELIZE [v]\n",
  "CARTELISING": "CARTELISE, to make into a cartel, also CARTELIZE [v]\n",
  "CARTELISM": "the system of having cartels [n -S]\n",
  "CARTELISMS": "CARTELISM, the system of having cartels [n]\n",
  "CARTELIST": "a member of a cartel, a supporter of cartels [n -S]\n",
  "CARTELISTS": "CARTELIST, a member of a cartel, a supporter of cartels [n]\n",
  "CARTELIZATION": "the act of cartelizing, also CARTELISATION [n -S]\n",
  "CARTELIZATIONS": "CARTELIZATION, the act of cartelizing, also CARTELISATION [n]\n",
  "CARTELIZE": "to make into a cartel, also CARTELISE [v CARTELIZED, CARTELIZING, CARTELIZES]\n",
  "CARTELIZED": "CARTELIZE, to make into a cartel, also CARTELISE [v]\n",
  "CARTELIZES": "CARTELIZE, to make into a cartel, also CARTELISE [v]\n",
  "CARTELIZING": "CARTELIZE, to make into a cartel, also CARTELISE [v]\n",
  "CARTELS": "CARTEL, (French) a manufacturers' agreement or association formed to control marketing arrangements, regulate prices, etc. [n]\n",
  "CARTER": "one who drives a cart [n -S]\n",
  "CARTERS": "CARTER, one who drives a cart [n]\n",
  "CARTES": "CARTE, (French) a bill of fare [n]\n",
  "CARTFUL": "the contents of a cart [n -S]\n",
  "CARTFULS": "CARTFUL, the contents of a cart [n]\n",
  "CARTHAMINE": "a dye obtained from safflower [n -S]\n",
  "CARTHAMINES": "CARTHAMINE, a dye obtained from safflower [n]\n",
  "CARTHORSE": "a horse used to draw a cart [n -S]\n",
  "CARTHORSES": "CARTHORSE, a horse used to draw a cart [n]\n",
  "CARTILAGE": "gristle, a firm pearly white substance forming the embryonic skeleton of vertebrates (temporary cartilage) converted into bone in adults [n -S]\n",
  "CARTILAGES": "CARTILAGE, gristle, a firm pearly white substance forming the embryonic skeleton of vertebrates (temporary cartilage) converted into bone in adults [n]\n",
  "CARTILAGINOUS": "hard, tough, like cartilage [adj]\n",
  "CARTING": "CART, to convey in a two wheeled vehicle [v]\n",
  "CARTLOAD": "a much as a cart can hold [n -S]\n",
  "CARTLOADS": "CARTLOAD, a much as a cart can hold [n]\n",
  "CARTOGRAM": "a map with diagrammatic statistical information [n -S]\n",
  "CARTOGRAMS": "CARTOGRAM, a map with diagrammatic statistical information [n]\n",
  "CARTOGRAPHER": "one who makes maps, also CHARTOGRAPHER [n -S]\n",
  "CARTOGRAPHERS": "CARTOGRAPHER, one who makes maps, also CHARTOGRAPHER [n]\n",
  "CARTOGRAPHIC": "relating to cartography, also CARTOGRAPHICAL, CHARTOGRAPHIC, CHARTOGRAPHICAL [adj]\n",
  "CARTOGRAPHICAL": "relating to cartography, also CARTOGRAPHIC, CHARTOGRAPHIC, CHARTOGRAPHICAL [adj]\n",
  "CARTOGRAPHIES": "CARTOGRAPHY, the art and science of making maps, also CHARTOGRAPHY [n]\n",
  "CARTOGRAPHY": "the art and science of making maps, also CHARTOGRAPHY [n CARTOGRAPHIES]\n",
  "CARTOLOGICAL": "related to cartology [adj]\n",
  "CARTOLOGIES": "CARTOLOGY, the science of maps and charts [n]\n",
  "CARTOLOGY": "the science of maps and charts [n CARTOLOGIES]\n",
  "CARTOMANCIES": "CARTOMANCY, divination by the use of playing cards [n]\n",
  "CARTOMANCY": "divination by the use of playing cards [n CARTOMANCIES]\n",
  "CARTON": "to pack in a cardboard box [v -ED, -ING, -S]\n",
  "CARTONAGE": "(French) papyrus or linen soaked in plaster, shaped around a body; used for mummy masks and coffins, also CARTONNAGE [n -S]\n",
  "CARTONAGES": "CARTONAGE, (French) papyrus or linen soaked in plaster, shaped around a body; used for mummy masks and coffins, also CARTONNAGE [n]\n",
  "CARTONED": "CARTON, to pack in a cardboard box [v]\n",
  "CARTONING": "CARTON, to pack in a cardboard box [v]\n",
  "CARTONNAGE": "(French) papyrus or linen soaked in plaster, shaped around a body; used for mummy masks and coffins, also CARTONAGE [n -S]\n",
  "CARTONNAGES": "CARTONNAGE, (French) papyrus or linen soaked in plaster, shaped around a body; used for mummy masks and coffins, also CARTONAGE [n]\n",
  "CARTONS": "CARTON, to pack in a cardboard box [v]\n",
  "CARTOON": "to sketch a humorous representation of [v -ED, -ING, -S]\n",
  "CARTOONED": "CARTOON, to sketch a humorous representation of [v]\n",
  "CARTOONIER": "CARTOONY, resembling a cartoon [adj]\n",
  "CARTOONIEST": "CARTOONY, resembling a cartoon [adj]\n",
  "CARTOONING": "the making of cartoons [n -S]\n",
  "CARTOONINGS": "CARTOONING, the making of cartoons [n]\n",
  "CARTOONISH": "like a cartoon [adj CARTOONISHLY]\n",
  "CARTOONISHLY": "CARTOONISH, like a cartoon [adv]\n",
  "CARTOONIST": "one who draws cartoons [n -S]\n",
  "CARTOONISTS": "CARTOONIST, one who draws cartoons [n]\n",
  "CARTOONLIKE": "like a cartoon [adj]\n",
  "CARTOONS": "CARTOON, to sketch a humorous representation of [v]\n",
  "CARTOONY": "resembling a cartoon [adj CARTOONIER, CARTOONIEST]\n",
  "CARTOP": "able to fit in top of a car [adj]\n",
  "CARTOPHILE": "a lover of maps [n -S]\n",
  "CARTOPHILES": "CARTOPHILE, a lover of maps [n]\n",
  "CARTOPHILIC": "relating to cartophily, the hobby of collecting cigarette cards [adj]\n",
  "CARTOPHILIES": "CARTOPHILY, the hobby of collecting cigarette cards [n]\n",
  "CARTOPHILIST": "one who collects cigarette cards [n -S]\n",
  "CARTOPHILISTS": "CARTOPHILIST, one who collects cigarette cards [n]\n",
  "CARTOPHILY": "the hobby of collecting cigarette cards [n CARTOPHILIES]\n",
  "CARTOPPER": "something suitable for carrying on the top of a car e.g. a fishing craft [n -S]\n",
  "CARTOPPERS": "CARTOPPER, something suitable for carrying on the top of a car e.g. a fishing craft [n]\n",
  "CARTOUCH": "(French) in Egyptian inscriptions, a circle with a horizontal bar at the bottom, elongated into an oval within which king's names are written, also CARTOUCHE [n -ES]\n",
  "CARTOUCHE": "(French) in Egyptian inscriptions, a circle with a horizontal bar at the bottom, elongated into an oval within which royal names are written, also CARTOUCH [n -S]\n",
  "CARTOUCHES": "CARTOUCH, (French) in Egyptian inscriptions, a circle with a horizontal bar at the bottom, elongated into an oval within which king's names are written, also CARTOUCHE [n]\n",
  "CARTRIDGE": "a case containing the charge for a gun [n -S]\n",
  "CARTRIDGES": "CARTRIDGE, a case containing the charge for a gun [n]\n",
  "CARTROAD": "a road used by carts [n -S]\n",
  "CARTROADS": "CARTROAD, a road used by carts [n]\n",
  "CARTS": "CART, to convey in a two wheeled vehicle [v]\n",
  "CARTULARIES": "CARTULARY, a keeper of monastic records [n]\n",
  "CARTULARY": "a keeper of monastic records [n CARTULARIES]\n",
  "CARTWAY": "a way used by carts [n -S]\n",
  "CARTWAYS": "CARTWAY, a way used by carts [n]\n",
  "CARTWHEEL": "a sideways somersault with arms and legs extended [n -S] / to turn a cartwheel [v -ED, -ING, -S]\n",
  "CARTWHEELED": "CARTWHEEL, to turn a cartwheel [v]\n",
  "CARTWHEELER": "one who does cartwheels [n -S]\n",
  "CARTWHEELERS": "CARTWHEELER, one who does cartwheels [n]\n",
  "CARTWHEELING": "CARTWHEEL, to turn a cartwheel [v]\n",
  "CARTWHEELS": "CARTWHEEL, to turn a cartwheel [v]\n",
  "CARTWRIGHT": "a maker of carts [n -S]\n",
  "CARTWRIGHTS": "CARTWRIGHT, a maker of carts [n]\n",
  "CARUCAGE": "a feudal tax levied on each carucate of land, i.e. as much land as may be tilled in a year and a day by one plough [n -S]\n",
  "CARUCAGES": "CARUCAGE, a feudal tax levied on each carucate of land, i.e. as much land as may be tilled in a year and a day by one plough [n]\n",
  "CARUCATE": "(historical) as much land as may be tilled in a year and a day by one plough [n -S]\n",
  "CARUCATES": "CARUCATE, (historical) as much land as may be tilled in a year and a day by one plough [n]\n",
  "CARUNCLE": "any fleshy growth on the body e.g. a rooster's comb [n -S]\n",
  "CARUNCLES": "CARUNCLE, any fleshy growth on the body e.g. a rooster's comb [n]\n",
  "CARUNCULAR": "having a caruncle, also CARUNCULATE, CARUNCULATED, CARUNCULOUS [adj]\n",
  "CARUNCULATE": "having a caruncle, also CARUNCULAR, CARUNCULATED, CARUNCULOUS [adj]\n",
  "CARUNCULATED": "having a caruncle, also CARUNCULAR, CARUNCULATE, CARUNCULOUS [adj]\n",
  "CARUNCULOUS": "having a caruncle, also CARUNCULAR, CARUNCULATE, CARUNCULATED [adj]\n",
  "CARVACROL": "a thick oily liquid of a strong taste and disagreeable odor, obtained from oil of caraway [n -S]\n",
  "CARVACROLS": "CARVACROL, a thick oily liquid of a strong taste and disagreeable odor, obtained from oil of caraway [n]\n",
  "CARVE": "to form by cutting, also KERF, KERVE [v CARVED, CARVING, CARVES]\n",
  "CARVED": "CARVE, to form by cutting, also KERF, KERVE [v]\n",
  "CARVEL": "a small light fast ship, chiefly Spanish or Portuguese, of the 15th to the 17th centuries, also CARAVEL, CARAVELLE [n -S]\n",
  "CARVELS": "CARVEL, a small light fast ship, chiefly Spanish or Portuguese, of the 15th to the 17th centuries, also CARAVEL, CARAVELLE [n]\n",
  "CARVEN": "carved [adj]\n",
  "CARVER": "one that carves [n -S]\n",
  "CARVERIES": "CARVERY, a type of buffet service restaurant where the main course meat is served from the joint on request [n]\n",
  "CARVERS": "CARVER, one that carves [n]\n",
  "CARVERY": "a type of buffet service restaurant where the main course meat is served from the joint on request [n CARVERIES]\n",
  "CARVES": "CARVE, to form by cutting, also KERF, KERVE [v]\n",
  "CARVIES": "CARVY, (Scots) a herb used in cooking, also CARAWAY, CARRAWAY [n]\n",
  "CARVING": "a carved figure or design [n -S]\n",
  "CARVINGS": "CARVING, a carved figure or design [n]\n",
  "CARVY": "(Scots) a herb used in cooking, also CARAWAY, CARRAWAY [n CARVIES]\n",
  "CARWASH": "an establishment equipped to wash cars [n -ES]\n",
  "CARWASHES": "CARWASH, an establishment equipped to wash cars [n]\n",
  "CARYATIC": "of or like a caryatid, a draped female figure supporting an entablature, also CARYATIDAL, CARYATIDEAN, CARYATIDIC [adj]\n",
  "CARYATID": "(Greek) a draped female figure supporting an entablature [n CARYATIDS or CARYATIDES]\n",
  "CARYATIDAL": "of or like a caryatid, a draped female figure supporting an entablature, also CARYATIC, CARYATIDEAN, CARYATIDIC [adj]\n",
  "CARYATIDEAN": "of or like a caryatid, a draped female figure supporting an entablature, also CARYATIC, CARYATIDAL, CARYATIDIC [adj]\n",
  "CARYATIDES": "CARYATID, (Greek) a draped female figure supporting an entablature [n]\n",
  "CARYATIDIC": "of or like a caryatid, a draped female figure supporting an entablature, also CARYATIC, CARYATIDAL, CARYATIDEAN [adj]\n",
  "CARYATIDS": "CARYATID, (Greek) a draped female figure supporting an entablature [n]\n",
  "CARYOPSES": "CARYOPSIS, (Greek) a dry indehiscent fruit characteristic of grasses [n]\n",
  "CARYOPSIDES": "CARYOPSIS, (Greek) a dry indehiscent fruit characteristic of grasses [n]\n",
  "CARYOPSIS": "(Greek) a dry indehiscent fruit characteristic of grasses [n CARYOPSES or CARYOPSIDES]\n",
  "CARYOPTERIS": "any of several deciduous subshrubs of the genus Caryopteris, having small, blue flowers [n -ES]\n",
  "CARYOPTERISES": "CARYOPTERIS, any of several deciduous subshrubs of the genus Caryopteris, having small, blue flowers [n]\n",
  "CARYOTIN": "the nuclear material of a cell [n -S]\n",
  "CARYOTINS": "CARYOTIN, the nuclear material of a cell [n]\n",
  "CASA": "(Italian) a house, a mansion [n -S]\n",
  "CASABA": "a variety of melon, also CASSABA [n -S]\n",
  "CASABAS": "CASABA, a variety of melon, also CASSABA [n]\n",
  "CASAS": "CASA, (Italian) a house, a mansion [n]\n",
  "CASAVA": "a tropical plant whose roots yield a valuable starch, also CASSAVA [n -S]\n",
  "CASAVAS": "CASAVA, a tropical plant whose roots yield a valuable starch, also CASSAVA [n]\n",
  "CASBAH": "(Arabic) the old section of a North African city, also KASBAH [n -S]\n",
  "CASBAHS": "CASBAH, (Arabic) the old section of a North African city, also KASBAH [n]\n",
  "CASCABEL": "(Spanish) the rear part of a cannon, also CASCABLE [n -S]\n",
  "CASCABELS": "CASCABEL, (Spanish) the rear part of a cannon, also CASCABLE [n]\n",
  "CASCABLE": "(Spanish) the rear part of a cannon, also CASCABEL [n -S]\n",
  "CASCABLES": "CASCABLE, (Spanish) the rear part of a cannon, also CASCABEL [n]\n",
  "CASCADE": "to fall like a waterfall [v CASCADED, CASCADING, CASCADES]\n",
  "CASCADED": "CASCADE, to fall like a waterfall [v]\n",
  "CASCADES": "CASCADE, to fall like a waterfall [v]\n",
  "CASCADING": "CASCADE, to fall like a waterfall [v]\n",
  "CASCADURA": "a type of catfish having a scaly armoured skin [n -S]\n",
  "CASCADURAS": "CASCADURA, a type of catfish having a scaly armoured skin [n]\n",
  "CASCARA": "(Spanish) a medicinal tree bark [n -S]\n",
  "CASCARAS": "CASCARA, (Spanish) a medicinal tree bark [n]\n",
  "CASCARILLA": "(Spanish) a euphorbiaceous West Indian shrub; its aromatic bark [n -S]\n",
  "CASCARILLAS": "CASCARILLA, (Spanish) a euphorbiaceous West Indian shrub; its aromatic bark [n]\n",
  "CASCHROM": "(Gaelic) a spade with a bent handle for tilling soil [n -S]\n",
  "CASCHROMS": "CASCHROM, (Gaelic) a spade with a bent handle for tilling soil [n]\n",
  "CASCO": "(Spanish) a Philippine cargo barge [n -S]\n",
  "CASCOS": "CASCO, (Spanish) a Philippine cargo barge [n]\n",
  "CASE": "to put in a container [v CASED, CASING, CASES]\n",
  "CASEASE": "an enzyme decomposing the casein in milk and cheese [n -S]\n",
  "CASEASES": "CASEASE, an enzyme decomposing the casein in milk and cheese [n]\n",
  "CASEATE": "to become cheesy [v CASEATED, CASEATING, CASEATES]\n",
  "CASEATED": "CASEATE, to become cheesy [v]\n",
  "CASEATES": "CASEATE, to become cheesy [v]\n",
  "CASEATING": "CASEATE, to become cheesy [v]\n",
  "CASEATION": "a degeneration of animal tissue into a cheesy or curdy mass [n -S]\n",
  "CASEATIONS": "CASEATION, a degeneration of animal tissue into a cheesy or curdy mass [n]\n",
  "CASEBEARER": "an insect larva that forms a protective coat of silk [n -S]\n",
  "CASEBEARERS": "CASEBEARER, an insect larva that forms a protective coat of silk [n]\n",
  "CASEBOOK": "a law textbook [n -S]\n",
  "CASEBOOKS": "CASEBOOK, a law textbook [n]\n",
  "CASEBOUND": "of a book, bound in stiff covers [adj]\n",
  "CASED": "CASE, to put in a container [v]\n",
  "CASEFIED": "CASEFY, to become or make cheese-like [v]\n",
  "CASEFIES": "CASEFY, to become or make cheese-like [v]\n",
  "CASEFY": "to become or make cheese-like [v CASEFIED, CASEFYING, CASEFIES]\n",
  "CASEFYING": "CASEFY, to become or make cheese-like [v]\n",
  "CASEIC": "of or pertaining to cheese; as, caseic acid [adj]\n",
  "CASEIN": "a milk protein [n -S]\n",
  "CASEINATE": "a compound of casein with a metal (as calcium or sodium) [n -S]\n",
  "CASEINATES": "CASEINATE, a compound of casein with a metal (as calcium or sodium) [n]\n",
  "CASEINOGEN": "the principal protein of milk, converted to casein by rennin [n -S]\n",
  "CASEINOGENS": "CASEINOGEN, the principal protein of milk, converted to casein by rennin [n]\n",
  "CASEINS": "CASEIN, a milk protein [n]\n",
  "CASELAW": "a law established by previous cases [n -S]\n",
  "CASELAWS": "CASELAW, a law established by previous cases [n]\n",
  "CASELOAD": "the number of cases being handled [n -S]\n",
  "CASELOADS": "CASELOAD, the number of cases being handled [n]\n",
  "CASEMAKER": "a person who makes covers for books [n -S]\n",
  "CASEMAKERS": "CASEMAKER, a person who makes covers for books [n]\n",
  "CASEMAN": "a compositor [n CASEMEN]\n",
  "CASEMATE": "a bombproof chamber or armoured compartment [n -S]\n",
  "CASEMATED": "furnished with, protected by, or built like, a casemate [adj]\n",
  "CASEMATES": "CASEMATE, a bombproof chamber or armoured compartment [n]\n",
  "CASEMEN": "CASEMAN, a compositor [n]\n",
  "CASEMENT": "a vertically-hinged frame with glass forming (part of) a window [n -S]\n",
  "CASEMENTED": "having casements [adj]\n",
  "CASEMENTS": "CASEMENT, a vertically-hinged frame with glass forming (part of) a window [n]\n",
  "CASEMIX": "a database system for storing information about medical patients [n -ES]\n",
  "CASEMIXES": "CASEMIX, a database system for storing information about medical patients [n]\n",
  "CASEOSE": "a water-soluble protein [n -S]\n",
  "CASEOSES": "CASEOSE, a water-soluble protein [n]\n",
  "CASEOUS": "cheese-like [adj]\n",
  "CASERN": "a barracks for soldiers, also CASERNE [n -S]\n",
  "CASERNE": "a barracks for soldiers, also CASERN [n -S]\n",
  "CASERNES": "CASERNE, a barracks for soldiers, also CASERN [n]\n",
  "CASERNS": "CASERN, a barracks for soldiers, also CASERNE [n]\n",
  "CASES": "CASE, to put in a container [v]\n",
  "CASETTE": "a small case containing magnetic tape, also CASSETTE [n -S]\n",
  "CASETTES": "CASETTE, a small case containing magnetic tape, also CASSETTE [n]\n",
  "CASEVAC": "to evacuate a battlefield casualty, normally by helicopter [v -ED, -ING, -S]\n",
  "CASEVACED": "CASEVAC, to evacuate a battlefield casualty, normally by helicopter [v]\n",
  "CASEVACING": "CASEVAC, to evacuate a battlefield casualty, normally by helicopter [v]\n",
  "CASEVACS": "CASEVAC, to evacuate a battlefield casualty, normally by helicopter [v]\n",
  "CASEWORK": "a form of social work [n -S]\n",
  "CASEWORKER": "one who works on a particular case [n -S]\n",
  "CASEWORKERS": "CASEWORKER, one who works on a particular case [n]\n",
  "CASEWORKS": "CASEWORK, a form of social work [n]\n",
  "CASEWORM": "a caddisworm [n -S]\n",
  "CASEWORMS": "CASEWORM, a caddisworm [n]\n",
  "CASH": "to convert into ready money [v -ED, -ING, -ES]\n",
  "CASHABLE": "able to be cashed [adj]\n",
  "CASHAW": "(Native American) a variety of squash, also CUSHAW [n -S]\n",
  "CASHAWS": "CASHAW, (Native American) a variety of squash, also CUSHAW [n]\n",
  "CASHBACK": "getting cash back on a credit card [n -S]\n",
  "CASHBACKS": "CASHBACK, getting cash back on a credit card [n]\n",
  "CASHBOOK": "a book of monetary records [n -S]\n",
  "CASHBOOKS": "CASHBOOK, a book of monetary records [n]\n",
  "CASHBOX": "a container for money [n -ES]\n",
  "CASHBOXES": "CASHBOX, a container for money [n]\n",
  "CASHED": "CASH, to convert into ready money [v]\n",
  "CASHES": "CASH, to convert into ready money [v]\n",
  "CASHEW": "(Tupi) a large tree native to tropical America and cultivated for its edible kidney-shaped nuts; the nut itself [n -S]\n",
  "CASHEWS": "CASHEW, (Tupi) a large tree native to tropical America and cultivated for its edible kidney-shaped nuts; the nut itself [n]\n",
  "CASHIER": "to dismiss in disgrace [v -ED, -ING, -S]\n",
  "CASHIERED": "CASHIER, to dismiss in disgrace [v]\n",
  "CASHIERER": "one who cashiers [n -S]\n",
  "CASHIERERS": "CASHIERER, one who cashiers [n]\n",
  "CASHIERING": "the act of dismissing from a position of command or authority [n -S]\n",
  "CASHIERINGS": "CASHIERING, the act of dismissing from a position of command or authority [n]\n",
  "CASHIERMENT": "the act of cashiering [n -S]\n",
  "CASHIERMENTS": "CASHIERMENT, the act of cashiering [n]\n",
  "CASHIERS": "CASHIER, to dismiss in disgrace [v]\n",
  "CASHING": "CASH, to convert into ready money [v]\n",
  "CASHLESS": "without cash [adj]\n",
  "CASHMERE": "a soft twilled fabric made of fine goat's wool, also CASIMERE, CASIMIRE, CASSIMERE, KASHMIR, KERSEYMERE [n -S]\n",
  "CASHMERES": "CASHMERE, a soft twilled fabric made of fine goat's wool, also CASIMERE, CASIMIRE, CASSIMERE, KASHMIR, KERSEYMERE [n]\n",
  "CASHMOBBING": "coordinating people to meet and spend money at a local, independent business at a particular time [n -S]\n",
  "CASHMOBBINGS": "CASHMOBBING, coordinating people to meet and spend money at a local, independent business at a particular time [n]\n",
  "CASHOO": "(Malay) a resin used in tanning, also CATECHU, CACHOU, CUTCH, KUTCH [n -S]\n",
  "CASHOOS": "CASHOO, (Malay) a resin used in tanning, also CATECHU, CACHOU, CUTCH, KUTCH [n]\n",
  "CASHPOINT": "(tradename) a bank terminal at which cash may be obtained [n -S]\n",
  "CASHPOINTS": "CASHPOINT, (tradename) a bank terminal at which cash may be obtained [n]\n",
  "CASHSPIEL": "(Canadian) a bonspiel in which curlers compete for cash prizes [n -S]\n",
  "CASHSPIELS": "CASHSPIEL, (Canadian) a bonspiel in which curlers compete for cash prizes [n]\n",
  "CASIMERE": "a twilled cloth of the finest wool, also CASHMERE, CASIMIRE, CASSIMERE, KASHMIR, KERSEYMERE [n -S]\n",
  "CASIMERES": "CASIMERE, a twilled cloth of the finest wool, also CASHMERE, CASIMIRE, CASSIMERE, KASHMIR, KERSEYMERE [n]\n",
  "CASIMIRE": "a twilled cloth of the finest wool, also CASHMERE, CASIMERE, CASSIMERE, KASHMIR, KERSEYMERE [n -S]\n",
  "CASIMIRES": "CASIMIRE, a twilled cloth of the finest wool, also CASHMERE, CASIMERE, CASSIMERE, KASHMIR, KERSEYMERE [n]\n",
  "CASING": "a protective outer covering [n -S]\n",
  "CASINGHEAD": "in mineral extraction, the part of a well that is above the surface [n -S]\n",
  "CASINGHEADS": "CASINGHEAD, in mineral extraction, the part of a well that is above the surface [n]\n",
  "CASINGS": "CASING, a protective outer covering [n]\n",
  "CASINI": "CASINO, a gambling room [n]\n",
  "CASINO": "a gambling room [n CASINOS or CASINI]\n",
  "CASINOS": "CASINO, a gambling room [n]\n",
  "CASITA": "(Spanish) a small house [n -S]\n",
  "CASITAS": "CASITA, (Spanish) a small house [n]\n",
  "CASK": "to store in a strong barrel [v -ED, -ING, -S]\n",
  "CASKED": "CASK, to store in a strong barrel [v]\n",
  "CASKET": "to place in a burial case [v -ED, -ING, -S]\n",
  "CASKETED": "CASKET, to place in a burial case [v]\n",
  "CASKETING": "CASKET, to place in a burial case [v]\n",
  "CASKETS": "CASKET, to place in a burial case [v]\n",
  "CASKIER": "CASKY, resembling a cask [adj]\n",
  "CASKIEST": "CASKY, resembling a cask [adj]\n",
  "CASKING": "CASK, to store in a strong barrel [v]\n",
  "CASKS": "CASK, to store in a strong barrel [v]\n",
  "CASKSTAND": "a stand for casks [n -S]\n",
  "CASKSTANDS": "CASKSTAND, a stand for casks [n]\n",
  "CASKY": "resembling a cask [adj CASKIER, CASKIEST]\n",
  "CASPASE": "any of a group of enzymes that control apoptosis [n -S]\n",
  "CASPASES": "CASPASE, any of a group of enzymes that control apoptosis [n]\n",
  "CASQUE": "(French) a helmet [n -S]\n",
  "CASQUED": "having a casque [adj]\n",
  "CASQUES": "CASQUE, (French) a helmet [n]\n",
  "CASSABA": "a variety of melon, also CASABA [n -S]\n",
  "CASSABAS": "CASSABA, a variety of melon, also CASABA [n]\n",
  "CASSAREEP": "(Tupi) the juice of the cassava root, made into syrup and used in sauces [n -S]\n",
  "CASSAREEPS": "CASSAREEP, (Tupi) the juice of the cassava root, made into syrup and used in sauces [n]\n",
  "CASSATA": "(Italian) an ice-cream containing candied fruit and nuts [n -S]\n",
  "CASSATAS": "CASSATA, (Italian) an ice-cream containing candied fruit and nuts [n]\n",
  "CASSATION": "annulment; in French law, the quashing of a decision of a court [n -S]\n",
  "CASSATIONS": "CASSATION, annulment; in French law, the quashing of a decision of a court [n]\n",
  "CASSAVA": "a tropical plant whose roots yield a valuable starch, also CASAVA [n -S]\n",
  "CASSAVAS": "CASSAVA, a tropical plant whose roots yield a valuable starch, also CASAVA [n]\n",
  "CASSENA": "an American evergreen tree, also CASSINA, CASSENE, CASSINE [n -S]\n",
  "CASSENAS": "CASSENA, an American evergreen tree, also CASSINA, CASSENE, CASSINE [n]\n",
  "CASSENE": "an American evergreen tree, also CASSENA, CASSINA, CASSINE [n -S]\n",
  "CASSENES": "CASSENE, an American evergreen tree, also CASSENA, CASSINA, CASSINE [n]\n",
  "CASSEROLE": "a stewpan; a covered pot in which food is both cooked and served; the dish of food or stew cooked in this way [n -S] / to make a casserole of [v CASSEROLED, CASSEROLING, CASSEROLES]\n",
  "CASSEROLED": "CASSEROLE, to make a casserole of [v]\n",
  "CASSEROLES": "CASSEROLE, to make a casserole of [v]\n",
  "CASSEROLING": "CASSEROLE, to make a casserole of [v]\n",
  "CASSETTE": "a small case containing magnetic tape, also CASETTE [n -S]\n",
  "CASSETTES": "CASSETTE, a small case containing magnetic tape, also CASETTE [n]\n",
  "CASSIA": "a relative of the cinnamon tree [n -S]\n",
  "CASSIAS": "CASSIA, a relative of the cinnamon tree [n]\n",
  "CASSIE": "a thorny shrub or small tree of tropical or subtropical America, with clusters of fragrant yellow flowers, aka huisache [n -S]\n",
  "CASSIES": "CASSIE, a thorny shrub or small tree of tropical or subtropical America, with clusters of fragrant yellow flowers, aka huisache [n]\n",
  "CASSIMERE": "a twilled cloth of the finest wool, also CASHMERE, CASIMERE, CASIMIRE, KASHMIR, KERSEYMERE [n -S]\n",
  "CASSIMERES": "CASSIMERE, a twilled cloth of the finest wool, also CASHMERE, CASIMERE, CASIMIRE, KASHMIR, KERSEYMERE [n]\n",
  "CASSINA": "an American evergreen tree, also CASSENA, CASSENE, CASSINE [n -S]\n",
  "CASSINAS": "CASSINA, an American evergreen tree, also CASSENA, CASSENE, CASSINE [n]\n",
  "CASSINE": "an American evergreen tree, also CASSENA, CASSENE, CASSINA [n -S]\n",
  "CASSINES": "CASSINE, an American evergreen tree, also CASSENA, CASSENE, CASSINA [n]\n",
  "CASSINGLE": "a prerecorded cassette tape of a single disc [n -S]\n",
  "CASSINGLES": "CASSINGLE, a prerecorded cassette tape of a single disc [n]\n",
  "CASSINO": "a card game, played by two or more persons, usually for twenty-one points [n -S]\n",
  "CASSINOS": "CASSINO, a card game, played by two or more persons, usually for twenty-one points [n]\n",
  "CASSIOPE": "an evergreen shrub [n -S]\n",
  "CASSIOPEIUM": "a former name for lutetium [n -S]\n",
  "CASSIOPEIUMS": "CASSIOPEIUM, a former name for lutetium [n]\n",
  "CASSIOPES": "CASSIOPE, an evergreen shrub [n]\n",
  "CASSIS": "(French) a blackcurrant liqueur [n -ES]\n",
  "CASSISES": "CASSIS, (French) a blackcurrant liqueur [n]\n",
  "CASSITERITE": "native tin dioxide, the major ore of tin, aka tinstone [n -S]\n",
  "CASSITERITES": "CASSITERITE, native tin dioxide, the major ore of tin, aka tinstone [n]\n",
  "CASSOCK": "a close-fitting ankle-length clergyman's garment [n -S]\n",
  "CASSOCKED": "wearing a cassock [adj]\n",
  "CASSOCKS": "CASSOCK, a close-fitting ankle-length clergyman's garment [n]\n",
  "CASSOLETTE": "(French) a perfume-box with perforated lid [n -S]\n",
  "CASSOLETTES": "CASSOLETTE, (French) a perfume-box with perforated lid [n]\n",
  "CASSONADE": "(French) unrefined cane-sugar (imported in casks) [n -S]\n",
  "CASSONADES": "CASSONADE, (French) unrefined cane-sugar (imported in casks) [n]\n",
  "CASSONE": "(Italian) a large chest, carved and painted [n -S]\n",
  "CASSONES": "CASSONE, (Italian) a large chest, carved and painted [n]\n",
  "CASSOULET": "(French) a French stew consisting of haricot beans, onions, herbs etc. [n -S]\n",
  "CASSOULETS": "CASSOULET, (French) a French stew consisting of haricot beans, onions, herbs etc. [n]\n",
  "CASSOWARIES": "CASSOWARY, (Malay) any large flightless bird of the genus Casuarius, related to the emu [n]\n",
  "CASSOWARY": "(Malay) any large flightless bird of the genus Casuarius, related to the emu [n CASSOWARIES]\n",
  "CASSPIR": "(South African) an armoured vehicle [n -S]\n",
  "CASSPIRS": "CASSPIR, (South African) an armoured vehicle [n]\n",
  "CASSUMUNAR": "an aromatic root similar to ginger [n -S]\n",
  "CASSUMUNARS": "CASSUMUNAR, an aromatic root similar to ginger [n]\n",
  "CAST": "to throw with force [v COOST or CAST or CASTED, CASTING, CASTS]\n",
  "CASTABILITIES": "CASTABILITY, the ability to be cast [n]\n",
  "CASTABILITY": "the ability to be cast [n CASTABILITIES]\n",
  "CASTABLE": "able to be cast [adj]\n",
  "CASTANET": "(French) a rhythm instrument [n -S]\n",
  "CASTANETS": "CASTANET, (French) a rhythm instrument [n]\n",
  "CASTANOSPERMINE": "an alkaloid obtained from the seeds of the Moreton Bay chestnut [n]\n",
  "CASTAWAY": "an outcast [n -S]\n",
  "CASTAWAYS": "CASTAWAY, an outcast [n]\n",
  "CASTE": "a system of distinct social classes [n -S]\n",
  "CASTED": "cast off [adj]\n",
  "CASTEISM": "the caste system esp. in India [n -S]\n",
  "CASTEISMS": "CASTEISM, the caste system esp. in India [n]\n",
  "CASTELESS": "without caste [adj]\n",
  "CASTELLA": "CASTELLUM, (Latin) a small Roman fort, a mile-castle [n]\n",
  "CASTELLAN": "the governor of a castle or fortification, also CHATELAIN [n -S]\n",
  "CASTELLANS": "CASTELLAN, the governor of a castle or fortification, also CHATELAIN [n]\n",
  "CASTELLATED": "having battlements or turrets [adj]\n",
  "CASTELLATION": "the state of being castellated, having battlements or turrets [n -S]\n",
  "CASTELLATIONS": "CASTELLATION, the state of being castellated, having battlements or turrets [n]\n",
  "CASTELLUM": "(Latin) a small Roman fort, a mile-castle [n CASTELLA or CASTELLUMS]\n",
  "CASTELLUMS": "CASTELLUM, (Latin) a small Roman fort, a mile-castle [n]\n",
  "CASTER": "a small solid swivelling wheel attached to furniture enabling it to be easily moved, also CASTOR [n -S]\n",
  "CASTERED": "having casters, small swivelling wheels [adj]\n",
  "CASTERS": "CASTER, a small solid swivelling wheel attached to furniture enabling it to be easily moved, also CASTOR [n]\n",
  "CASTES": "CASTE, a system of distinct social classes [n]\n",
  "CASTIGATE": "to scold, reprimand [v CASTIGATED, CASTIGATING, CASTIGATES]\n",
  "CASTIGATED": "CASTIGATE, to scold, reprimand [v]\n",
  "CASTIGATES": "CASTIGATE, to scold, reprimand [v]\n",
  "CASTIGATING": "CASTIGATE, to scold, reprimand [v]\n",
  "CASTIGATION": "the act of castigating [n -S]\n",
  "CASTIGATIONS": "CASTIGATION, the act of castigating [n]\n",
  "CASTIGATOR": "one who castigates or corrects [n -S]\n",
  "CASTIGATORS": "CASTIGATOR, one who castigates or corrects [n]\n",
  "CASTIGATORY": "tending to castigate [adj]\n",
  "CASTING": "something made in a mould [n -S]\n",
  "CASTINGS": "CASTING, something made in a mould [n]\n",
  "CASTLE": "to make a certain move in chess [v CASTLED, CASTLING, CASTLES]\n",
  "CASTLED": "CASTLE, to make a certain move in chess [v]\n",
  "CASTLES": "CASTLE, to make a certain move in chess [v]\n",
  "CASTLING": "a type of move in chess [n -S]\n",
  "CASTLINGS": "CASTLING, a type of move in chess [n]\n",
  "CASTOCK": "(Scots) a cabbage stock, also CUSTOCK [n -S]\n",
  "CASTOCKS": "CASTOCK, (Scots) a cabbage stock, also CUSTOCK [n]\n",
  "CASTOFF": "an item of clothing one no longer wishes to wear, and passes on to another, also OFFCAST [n -S]\n",
  "CASTOFFS": "CASTOFF, an item of clothing one no longer wishes to wear, and passes on to another, also OFFCAST [n]\n",
  "CASTOR": "a small solid swivelling wheel attached to furniture enabling it to be easily moved, also CASTER [n -S]\n",
  "CASTOREUM": "(Latin) the dried perineal sacs of the beaver, or a brown unctuous strong-smelling substance obtained from them, formerly used in medicine and perfumery [n -S]\n",
  "CASTOREUMS": "CASTOREUM, (Latin) the dried perineal sacs of the beaver, or a brown unctuous strong-smelling substance obtained from them, formerly used in medicine and perfumery [n]\n",
  "CASTORIES": "CASTORY, (Spenser) a red or pink colour derived from castoreum [n]\n",
  "CASTORS": "CASTOR, a small solid swivelling wheel attached to furniture enabling it to be easily moved, also CASTER [n]\n",
  "CASTORY": "(Spenser) a red or pink colour derived from castoreum [n CASTORIES]\n",
  "CASTRAL": "(Latin) belonging to the camp [adj]\n",
  "CASTRAMETATION": "the art of laying out a camp [n -S]\n",
  "CASTRAMETATIONS": "CASTRAMETATION, the art of laying out a camp [n]\n",
  "CASTRATE": "to remove the testes of [v CASTRATED, CASTRATING, CASTRATES]\n",
  "CASTRATED": "CASTRATE, to remove the testes of [v]\n",
  "CASTRATER": "a device used in castration, also CASTRATOR [n -S]\n",
  "CASTRATERS": "CASTRATER, a device used in castration, also CASTRATOR [n]\n",
  "CASTRATES": "CASTRATE, to remove the testes of [v]\n",
  "CASTRATI": "CASTRATO, (Italian) a male singer castrated in boyhood to preserve his singing voice [n]\n",
  "CASTRATING": "CASTRATE, to remove the testes of [v]\n",
  "CASTRATION": "the act of castrating [n -S]\n",
  "CASTRATIONS": "CASTRATION, the act of castrating [n]\n",
  "CASTRATO": "(Italian) a male singer castrated in boyhood to preserve his singing voice [n CASTRATI or CASTRATOS]\n",
  "CASTRATOR": "a device used in castration, also CASTRATER [n -S]\n",
  "CASTRATORS": "CASTRATOR, a device used in castration, also CASTRATER [n]\n",
  "CASTRATORY": "relating to castration [adj]\n",
  "CASTRATOS": "CASTRATO, (Italian) a male singer castrated in boyhood to preserve his singing voice [n]\n",
  "CASTS": "CAST, to throw with force [v]\n",
  "CASUAL": "accidental, occasional [adj CASUALLY] / one who works occasionally [n -S]\n",
  "CASUALISATION": "the process of casualising, making regular workers into casual workers, also CASUALIZATION [n -S]\n",
  "CASUALISATIONS": "CASUALISATION, the process of casualising, making regular workers into casual workers, also CASUALIZATION [n]\n",
  "CASUALISE": "to turn (regular workers) into casual workers, also CASUALIZE [v CASUALISED, CASUALISING, CASUALISES]\n",
  "CASUALISED": "CASUALISE, to turn (regular workers) into casual workers, also CASUALIZE [v]\n",
  "CASUALISES": "CASUALISE, to turn (regular workers) into casual workers, also CASUALIZE [v]\n",
  "CASUALISING": "CASUALISE, to turn (regular workers) into casual workers, also CASUALIZE [v]\n",
  "CASUALISM": "the belief that chance governs all things [n -S]\n",
  "CASUALISMS": "CASUALISM, the belief that chance governs all things [n]\n",
  "CASUALIZATION": "the process of casualizing, making regular workers into casual workers, also CASUALISATION [n -S]\n",
  "CASUALIZATIONS": "CASUALIZATION, the process of casualizing, making regular workers into casual workers, also CASUALISATION [n]\n",
  "CASUALIZE": "to turn (regular workers) into casual workers, also CASUALISE [v CASUALIZED, CASUALIZING, CASUALIZES]\n",
  "CASUALIZED": "CASUALIZE, to turn (regular workers) into casual workers, also CASUALISE [v]\n",
  "CASUALIZES": "CASUALIZE, to turn (regular workers) into casual workers, also CASUALISE [v]\n",
  "CASUALIZING": "CASUALIZE, to turn (regular workers) into casual workers, also CASUALISE [v]\n",
  "CASUALLY": "CASUAL, accidental, occasional [adv]\n",
  "CASUALNESS": "the state of being casual [n -ES]\n",
  "CASUALNESSES": "CASUALNESS, the state of being casual [n]\n",
  "CASUALS": "CASUAL, one who works occasionally [n]\n",
  "CASUALTIES": "CASUALTY, a person injured or killed [n]\n",
  "CASUALTY": "a person injured or killed [n CASUALTIES]\n",
  "CASUARINA": "a tree of the genus Casuarina, native to Australia and parts of SE Asia, with jointed branches resembling gigantic horsetail plants [n -S]\n",
  "CASUARINAS": "CASUARINA, a tree of the genus Casuarina, native to Australia and parts of SE Asia, with jointed branches resembling gigantic horsetail plants [n]\n",
  "CASUIST": "a sophist who insists on debating the smallest details [n -S]\n",
  "CASUISTIC": "relating to casuistry, plausible but flawed moral reasoning, also CASUISTICAL [adj CASUISTICALLY]\n",
  "CASUISTICAL": "relating to casuistry, plausible but flawed moral reasoning, also CASUISTIC [adj CASUISTICALLY]\n",
  "CASUISTICALLY": "CASUISTICAL, relating to casuistry, plausible but flawed moral reasoning, also CASUISTIC [adv]\n",
  "CASUISTRIES": "CASUISTRY, plausible but flawed moral reasoning [n]\n",
  "CASUISTRY": "plausible but flawed moral reasoning [n CASUISTRIES]\n",
  "CASUISTS": "CASUIST, a sophist who insists on debating the smallest details [n]\n",
  "CASUS": "(Latin) a legal occurrence [n CASUS]\n",
  "CAT": "to vomit [v CATTED, CATTING, CATS]\n",
  "CATABASES": "CATABASIS, the decline of a disease in a population, also KATABASIS [n]\n",
  "CATABASIS": "the decline of a disease in a population, also KATABASIS [n CATABASES]\n",
  "CATABATIC": "moving downhill, sinking (of winds), also KATABATIC [adj]\n",
  "CATABOLIC": "relating to catabolism, destructive chemical processes in living creatures, also KATABOLIC [adj CATABOLICALLY]\n",
  "CATABOLICALLY": "CATABOLIC, relating to catabolism, destructive chemical processes in living creatures, also KATABOLIC [adv]\n",
  "CATABOLISE": "to subject to catabolism, destructive chemical processes in living creatures, also CATABOLIZE [v CATABOLISED, CATABOLISING, CATABOLISES]\n",
  "CATABOLISED": "CATABOLISE, to subject to catabolism, destructive chemical processes in living creatures, also CATABOLIZE [v]\n",
  "CATABOLISES": "CATABOLISE, to subject to catabolism, destructive chemical processes in living creatures, also CATABOLIZE [v]\n",
  "CATABOLISING": "CATABOLISE, to subject to catabolism, destructive chemical processes in living creatures, also CATABOLIZE [v]\n",
  "CATABOLISM": "destructive chemical processes in living creatures, also KATABOLISM [n -S]\n",
  "CATABOLISMS": "CATABOLISM, destructive chemical processes in living creatures, also KATABOLISM [n]\n",
  "CATABOLITE": "a product of catabolism, destructive chemical processes in living creatures [n -S]\n",
  "CATABOLITES": "CATABOLITE, a product of catabolism, destructive chemical processes in living creatures [n]\n",
  "CATABOLIZE": "to subject to catabolism, destructive chemical processes in living creatures, also CATABOLISE [v CATABOLIZED, CATABOLIZING, CATABOLIZES]\n",
  "CATABOLIZED": "CATABOLIZE, to subject to catabolism, destructive chemical processes in living creatures, also CATABOLISE [v]\n",
  "CATABOLIZES": "CATABOLIZE, to subject to catabolism, destructive chemical processes in living creatures, also CATABOLISE [v]\n",
  "CATABOLIZING": "CATABOLIZE, to subject to catabolism, destructive chemical processes in living creatures, also CATABOLISE [v]\n",
  "CATACAUSTIC": "relating to or denoting a caustic curve or caustic surface formed by reflection [adj] / a catacaustic curve or surface [n -S]\n",
  "CATACAUSTICS": "CATACAUSTIC, a catacaustic curve or surface [n]\n",
  "CATACHRESES": "CATACHRESIS, the misuse of words [n]\n",
  "CATACHRESIS": "the misuse of words [n CATACHRESES]\n",
  "CATACHRESTIC": "relating to catachresis, the misuse of words, also CATACHRESTICAL [adj]\n",
  "CATACHRESTICAL": "relating to catachresis, the misuse of words, also CATACHRESTIC [adj]\n",
  "CATACLASES": "CATACLASIS, the deformation of rocks by crushing and shearing [n]\n",
  "CATACLASIS": "the deformation of rocks by crushing and shearing [n CATACLASES]\n",
  "CATACLASM": "(Greek) disruption; breaking down [n -S]\n",
  "CATACLASMIC": "relating to or of the nature of a cataclasm [adj]\n",
  "CATACLASMS": "CATACLASM, (Greek) disruption; breaking down [n]\n",
  "CATACLASTIC": "of metamorphism, taking place in an environment where intense pressure [adj]\n",
  "CATACLINAL": "of streams, valleys, etc., running in the direction of the dip of the surrounding rock strata [adj]\n",
  "CATACLYSM": "a great flood or other major disaster [n -S]\n",
  "CATACLYSMAL": "relating to cataclysm, also CATACLYSMIC [adj]\n",
  "CATACLYSMIC": "relating to cataclysm, also CATACLYSMAL [adj CATACLYSMICALLY]\n",
  "CATACLYSMICALLY": "CATACLYSMIC, relating to cataclysm, also CATACLYSMAL [adv]\n",
  "CATACLYSMS": "CATACLYSM, a great flood or other major disaster [n]\n",
  "CATACOMB": "an underground cemetery [n -S]\n",
  "CATACOMBS": "CATACOMB, an underground cemetery [n]\n",
  "CATACOUSTICS": "the science of echoes or reflected sounds [n]\n",
  "CATACUMBAL": "relating to a catacomb [adj]\n",
  "CATADIOPTRIC": "relating to or employing both reflection and refraction, as in the construction of some long-focal-length photographic lenses, also CATADIOPTRICAL [adj]\n",
  "CATADIOPTRICAL": "relating to or employing both reflection and refraction, as in the construction of some long-focal-length photographic lenses, also CATADIOPTRIC [adj]\n",
  "CATADROMOUS": "of fishes, descending periodically for spawning to the lower parts of a river or to the sea, also KATADROMOUS [adj]\n",
  "CATAFALCO": "(Italian) a temporary tomb used in funerals and processions, also CATAFALQUE [n CATAFALCOES]\n",
  "CATAFALCOES": "CATAFALCO, (Italian) a temporary tomb used in funerals and processions, also CATAFALQUE [n]\n",
  "CATAFALQUE": "(French) a temporary tomb used in funerals and processions, also CATAFALCO [n -S]\n",
  "CATAFALQUES": "CATAFALQUE, (French) a temporary tomb used in funerals and processions, also CATAFALCO [n]\n",
  "CATAGEN": "The growth phase in the hair growth cycle during which a newly formed hair ceases to grow [n -S]\n",
  "CATAGENS": "CATAGEN, The growth phase in the hair growth cycle during which a newly formed hair ceases to grow [n]\n",
  "CATALASE": "an enzyme that reduces hydrogen peroxide [n -S]\n",
  "CATALASES": "CATALASE, an enzyme that reduces hydrogen peroxide [n]\n",
  "CATALATIC": "of or like catalase, an enzyme that reduces hydrogen peroxide [adj]\n",
  "CATALECTIC": "lacking one syllable in the last foot [adj] / a line of verse lacking one syllable in the last foot [n -S]\n",
  "CATALECTICS": "CATALECTIC, a line of verse lacking one syllable in the last foot [n]\n",
  "CATALEPSIES": "CATALEPSY, a rigid or trancelike fit [n]\n",
  "CATALEPSY": "a rigid or trancelike fit [n CATALEPSIES]\n",
  "CATALEPTIC": "afflicted with catalepsy [adj CATALEPTICALLY] / one afflicted with catalepsy [n -S]\n",
  "CATALEPTICALLY": "CATALEPTIC, afflicted with catalepsy [adv]\n",
  "CATALEPTICS": "CATALEPTIC, one afflicted with catalepsy [n]\n",
  "CATALEXES": "CATALEXIS, the condition of being catalectic, lacking one syllable in the last foot [n]\n",
  "CATALEXIS": "the condition of being catalectic, lacking one syllable in the last foot [n CATALEXES]\n",
  "CATALLACTIC": "pertaining to commercial exchange [adj CATALLACTICALLY]\n",
  "CATALLACTICALLY": "CATALLACTIC, pertaining to commercial exchange [adv]\n",
  "CATALLACTICS": "political economy [n]\n",
  "CATALO": "a cross between a buffalo and a domestic cow, also CATTALO [n CATALOS or CATALOES]\n",
  "CATALOES": "CATALO, a cross between a buffalo and a domestic cow, also CATTALO [n]\n",
  "CATALOG": "to classify information descriptively [v CATALOGED, CATALOGING, CATALOGS]\n",
  "CATALOGED": "CATALOG, to classify information descriptively [v]\n",
  "CATALOGER": "(US) one who catalogs, also CATALOGUER, CATALOGUIST [n -S]\n",
  "CATALOGERS": "CATALOGER, (US) one who catalogs, also CATALOGUER, CATALOGUIST [n]\n",
  "CATALOGIC": "of or like a catalog [adj]\n",
  "CATALOGING": "CATALOG, to classify information descriptively [v]\n",
  "CATALOGISE": "to put in a catalogue, also CATALOGIZE, CATALOGUISE, CATALOGUIZE [v CATALOGISED, CATALOGISING, CATALOGISES]\n",
  "CATALOGISED": "CATALOGISE, to put in a catalogue, also CATALOGIZE, CATALOGUISE, CATALOGUIZE [v]\n",
  "CATALOGISES": "CATALOGISE, to put in a catalogue, also CATALOGIZE, CATALOGUISE, CATALOGUIZE [v]\n",
  "CATALOGISING": "CATALOGISE, to put in a catalogue, also CATALOGIZE, CATALOGUISE, CATALOGUIZE [v]\n",
  "CATALOGIZE": "to put in a catalogue, also CATALOGISE, CATALOGUISE, CATALOGUIZE [v CATALOGIZED, CATALOGIZING, CATALOGIZES]\n",
  "CATALOGIZED": "CATALOGIZE, to put in a catalogue, also CATALOGISE, CATALOGUISE, CATALOGUIZE [v]\n",
  "CATALOGIZES": "CATALOGIZE, to put in a catalogue, also CATALOGISE, CATALOGUISE, CATALOGUIZE [v]\n",
  "CATALOGIZING": "CATALOGIZE, to put in a catalogue, also CATALOGISE, CATALOGUISE, CATALOGUIZE [v]\n",
  "CATALOGNE": "(Canadian) a kind of weaving using rags as the weft and widely spaced threads as the warp [n -S]\n",
  "CATALOGNES": "CATALOGNE, (Canadian) a kind of weaving using rags as the weft and widely spaced threads as the warp [n]\n",
  "CATALOGS": "CATALOG, to classify information descriptively [v]\n",
  "CATALOGUE": "to make a systematic list of names, books, pictures, etc., also CATALOG, CATELOG [v CATALOGUED, CATALOGUING, CATALOGUES]\n",
  "CATALOGUED": "CATALOGUE, to make a systematic list of names, books, pictures, etc., also CATALOG, CATELOG [v]\n",
  "CATALOGUER": "one who catalogues, also CATALOGER, CATALOGUIST [n -S]\n",
  "CATALOGUERS": "CATALOGUER, one who catalogues, also CATALOGER, CATALOGUIST [n]\n",
  "CATALOGUES": "CATALOGUE, to make a systematic list of names, books, pictures, etc., also CATALOG, CATELOG [v]\n",
  "CATALOGUING": "CATALOGUE, to make a systematic list of names, books, pictures, etc., also CATALOG, CATELOG [v]\n",
  "CATALOGUISE": "to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUIZE [v CATALOGUISED, CATALOGUISING, CATALOGUISES]\n",
  "CATALOGUISED": "CATALOGUISE, to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUIZE [v]\n",
  "CATALOGUISES": "CATALOGUISE, to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUIZE [v]\n",
  "CATALOGUISING": "CATALOGUISE, to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUIZE [v]\n",
  "CATALOGUIST": "one who catalogues, also CATALOGER, CATALOGUER [n -S]\n",
  "CATALOGUISTS": "CATALOGUIST, one who catalogues, also CATALOGER, CATALOGUER [n]\n",
  "CATALOGUIZE": "to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUISE [v CATALOGUIZED, CATALOGUIZING, CATALOGUIZES]\n",
  "CATALOGUIZED": "CATALOGUIZE, to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUISE [v]\n",
  "CATALOGUIZES": "CATALOGUIZE, to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUISE [v]\n",
  "CATALOGUIZING": "CATALOGUIZE, to put in a catalogue, also CATALOGISE, CATALOGIZE, CATALOGUISE [v]\n",
  "CATALOS": "CATALO, a cross between a buffalo and a domestic cow, also CATTALO [n]\n",
  "CATALPA": "a tree of the genus Catalpa, of the bignonia family, with heart-shaped leaves, trumpet-shaped flowers, and long pods [n -S]\n",
  "CATALPAS": "CATALPA, a tree of the genus Catalpa, of the bignonia family, with heart-shaped leaves, trumpet-shaped flowers, and long pods [n]\n",
  "CATALYSE": "to act as a catalyst, also CATALYZE [v CATALYSED, CATALYSING, CATALYSES]\n",
  "CATALYSED": "CATALYSE, to act as a catalyst, also CATALYZE [v]\n",
  "CATALYSER": "an agent that catalyzes, also CATALYZER [n -S]\n",
  "CATALYSERS": "CATALYSER, an agent that catalyzes, also CATALYZER [n]\n",
  "CATALYSES": "CATALYSE, to act as a catalyst, also CATALYZE [v]\n",
  "CATALYSING": "CATALYSE, to act as a catalyst, also CATALYZE [v]\n",
  "CATALYSIS": "alteration in speed of chemical reaction due to introduction of a substance which remains unchanged [n CATALYSES]\n",
  "CATALYST": "a substance that speeds a chemical reaction [n -S]\n",
  "CATALYSTS": "CATALYST, a substance that speeds a chemical reaction [n]\n",
  "CATALYTIC": "acting as a catalyst, also CATALYTICAL [adj CATALYTICALLY]\n",
  "CATALYTICAL": "acting as a catalyst, also CATALYTIC [adj CATALYTICALLY]\n",
  "CATALYTICALLY": "CATALYTICAL, acting as a catalyst, also CATALYTIC [adv]\n",
  "CATALYZE": "to act at a catalyst, also CATALYSE [v CATALYZED, CATALYZING, CATALYZES]\n",
  "CATALYZED": "CATALYZE, to act at a catalyst, also CATALYSE [v]\n",
  "CATALYZER": "an agent that catalyzes, also CATALYSER [n -S]\n",
  "CATALYZERS": "CATALYZER, an agent that catalyzes, also CATALYSER [n]\n",
  "CATALYZES": "CATALYZE, to act at a catalyst, also CATALYSE [v]\n",
  "CATALYZING": "CATALYZE, to act at a catalyst, also CATALYSE [v]\n",
  "CATAMARAN": "(Tamil) originally a raft of logs lashed together; now a boat, esp. a sailing boat with two hulls [n -S]\n",
  "CATAMARANS": "CATAMARAN, (Tamil) originally a raft of logs lashed together; now a boat, esp. a sailing boat with two hulls [n]\n",
  "CATAMENIA": "the menstrual discharge or menses [n]\n",
  "CATAMENIAL": "pertaining to the catamenia, or menstrual discharges [adj]\n",
  "CATAMITE": "a boy used in sodomy [n -S]\n",
  "CATAMITES": "CATAMITE, a boy used in sodomy [n]\n",
  "CATAMOUNT": "any of various large wild cats, applied esp. to the leopard, panther or ocelot, also CATAMOUNTAIN [n -S]\n",
  "CATAMOUNTAIN": "any of various large wild cats, applied esp. to the leopard, panther or ocelot, also CATAMOUNT [n -S]\n",
  "CATAMOUNTAINS": "CATAMOUNTAIN, any of various large wild cats, applied esp. to the leopard, panther or ocelot, also CATAMOUNT [n]\n",
  "CATAMOUNTS": "CATAMOUNT, any of various large wild cats, applied esp. to the leopard, panther or ocelot, also CATAMOUNTAIN [n]\n",
  "CATANANCHE": "any plant of the South European genus Catananche, some of which are grown for their blue and white flowers [n -S]\n",
  "CATANANCHES": "CATANANCHE, any plant of the South European genus Catananche, some of which are grown for their blue and white flowers [n]\n",
  "CATAPAN": "(Greek) the governor of Calabria and Apulia for the Byzantine emperor [n -S]\n",
  "CATAPANS": "CATAPAN, (Greek) the governor of Calabria and Apulia for the Byzantine emperor [n]\n",
  "CATAPHONIC": "of or relating to cataphonics, the area of the science of acoustics that deals with echoes or reflected sounds [adj]\n",
  "CATAPHONICS": "the area of the science of acoustics that deals with echoes or reflected sounds [n]\n",
  "CATAPHOR": "(Greek) the use of an expression which refers to or stands for a later word or group of words, also CATAPHORA [n -S]\n",
  "CATAPHORA": "(Greek) the use of an expression which refers to or stands for a later word or group of words, also CATAPHOR [n -S]\n",
  "CATAPHORAS": "CATAPHORA, (Greek) the use of an expression which refers to or stands for a later word or group of words, also CATAPHOR [n]\n",
  "CATAPHORESES": "CATAPHORESIS, the movement, due to application of electricity, of particles through a fluid; injection of drugs electrically [n]\n",
  "CATAPHORESIS": "the movement, due to application of electricity, of particles through a fluid; injection of drugs electrically [n CATAPHORESES]\n",
  "CATAPHORETIC": "relating to cataphoresis, the movement, due to application of electricity, of particles through a fluid [adj]\n",
  "CATAPHORIC": "relating to a cataphora, a rhetorical term [adj CATAPHORICALLY]\n",
  "CATAPHORICALLY": "CATAPHORIC, relating to a cataphora, a rhetorical term [adv]\n",
  "CATAPHORS": "CATAPHOR, (Greek) the use of an expression which refers to or stands for a later word or group of words, also CATAPHORA [n]\n",
  "CATAPHRACT": "a suit of mail; a soldier in full armour [n -S]\n",
  "CATAPHRACTIC": "of or like a cataphract, a suit of mail; a soldier in full armour [adj]\n",
  "CATAPHRACTS": "CATAPHRACT, a suit of mail; a soldier in full armour [n]\n",
  "CATAPHYLL": "a rudimentary or simplified leaf [n -S]\n",
  "CATAPHYLLARY": "of or like a cataphyll, a rudimentary or simplified leaf [adj]\n",
  "CATAPHYLLS": "CATAPHYLL, a rudimentary or simplified leaf [n]\n",
  "CATAPHYSICAL": "unnatural [adj]\n",
  "CATAPLASIA": "the degeneration of cells and tissues to a less highly developed form [n -S]\n",
  "CATAPLASIAS": "CATAPLASIA, the degeneration of cells and tissues to a less highly developed form [n]\n",
  "CATAPLASM": "a plaster or poultice [n -S]\n",
  "CATAPLASMS": "CATAPLASM, a plaster or poultice [n]\n",
  "CATAPLASTIC": "relating to cataplasia [adj]\n",
  "CATAPLECTIC": "relating to cataplexy [adj]\n",
  "CATAPLEXIES": "CATAPLEXY, a condition feigning death, used by some animals to discourage predators [n]\n",
  "CATAPLEXY": "a condition feigning death, used by some animals to discourage predators [n CATAPLEXIES]\n",
  "CATAPULT": "to hurl through the air [v -ED, -ING, -S]\n",
  "CATAPULTED": "CATAPULT, to hurl through the air [v]\n",
  "CATAPULTIC": "of or like a catapult [adj]\n",
  "CATAPULTIER": "one who uses a catapult [n -S]\n",
  "CATAPULTIERS": "CATAPULTIER, one who uses a catapult [n]\n",
  "CATAPULTING": "CATAPULT, to hurl through the air [v]\n",
  "CATAPULTS": "CATAPULT, to hurl through the air [v]\n",
  "CATARACT": "a waterfall [n -S]\n",
  "CATARACTOUS": "of or like a cataract [adj]\n",
  "CATARACTS": "CATARACT, a waterfall [n]\n",
  "CATARHINE": "a member of one of the two divisions of primates, including all the Old World monkeys, having a narrow partition between the nostrils, also CATARRHINE [n -S]\n",
  "CATARHINES": "CATARHINE, a member of one of the two divisions of primates, including all the Old World monkeys, having a narrow partition between the nostrils, also CATARRHINE [n]\n",
  "CATARRH": "inflammation of a mucous membrane [n -S]\n",
  "CATARRHAL": "of or like catarrh, also CATARRHOUS [adj CATARRHALLY]\n",
  "CATARRHALLY": "CATARRHAL, of or like catarrh, also CATARRHOUS [adv]\n",
  "CATARRHINE": "a member one of the two divisions of primates, including all the Old World monkeys, having a narrow partition between the nostrils, also CATARHINE [n -S]\n",
  "CATARRHINES": "CATARRHINE, a member one of the two divisions of primates, including all the Old World monkeys, having a narrow partition between the nostrils, also CATARHINE [n]\n",
  "CATARRHOUS": "of or like catarrh, also CATARRHAL [adj]\n",
  "CATARRHS": "CATARRH, inflammation of a mucous membrane [n]\n",
  "CATASTA": "(Latin) a scaffold or stage for torture or selling slaves [n -S]\n",
  "CATASTAS": "CATASTA, (Latin) a scaffold or stage for torture or selling slaves [n]\n",
  "CATASTASES": "CATASTASIS, the part of drama where action is at its height [n]\n",
  "CATASTASIS": "the part of drama where action is at its height [n CATASTASES]\n",
  "CATASTROPHE": "the final event of the dramatic action esp. of a tragedy [n -S]\n",
  "CATASTROPHES": "CATASTROPHE, the final event of the dramatic action esp. of a tragedy [n]\n",
  "CATASTROPHIC": "of the nature of a catastrophe [adj]\n",
  "CATASTROPHISM": "belief in rapid geological and biological change [n -S]\n",
  "CATASTROPHISMS": "CATASTROPHISM, belief in rapid geological and biological change [n]\n",
  "CATASTROPHIST": "a believer in catastrophism [n -S]\n",
  "CATASTROPHISTS": "CATASTROPHIST, a believer in catastrophism [n]\n",
  "CATATONIA": "a trancelike state, also CATATONY [n -S]\n",
  "CATATONIAS": "CATATONIA, a trancelike state, also CATATONY [n]\n",
  "CATATONIC": "in a trancelike state [adj CATATONICALLY] / one suffering from catatonia [n -S]\n",
  "CATATONICALLY": "CATATONIC, in a trancelike state [adv]\n",
  "CATATONICS": "CATATONIC, one suffering from catatonia [n]\n",
  "CATATONIES": "CATATONY, a state of rigidity experienced periodically by schizophrenics [n]\n",
  "CATATONY": "a state of rigidity experienced periodically by schizophrenics [n CATATONIES]\n",
  "CATAWBA": "a well known light red variety of American grape; a red wine made from it [n -S]\n",
  "CATAWBAS": "CATAWBA, a well known light red variety of American grape; a red wine made from it [n]\n",
  "CATBIRD": "an American bird allied to the mocking bird, whose note resembles at times the mewing of a cat [n -S]\n",
  "CATBIRDS": "CATBIRD, an American bird allied to the mocking bird, whose note resembles at times the mewing of a cat [n]\n",
  "CATBOAT": "a kind of small sailboat [n -S]\n",
  "CATBOATS": "CATBOAT, a kind of small sailboat [n]\n",
  "CATBRIAR": "a thorny shrub, also CATBRIER [n -S]\n",
  "CATBRIARS": "CATBRIAR, a thorny shrub, also CATBRIER [n]\n",
  "CATBRIER": "a thorny vine, also CATBRIAR [n -S]\n",
  "CATBRIERS": "CATBRIER, a thorny vine, also CATBRIAR [n]\n",
  "CATCALL": "to deride by making shrill sounds [v -ED, -ING, -S]\n",
  "CATCALLED": "CATCALL, to deride by making shrill sounds [v]\n",
  "CATCALLER": "one who catcalls [n -S]\n",
  "CATCALLERS": "CATCALLER, one who catcalls [n]\n",
  "CATCALLING": "CATCALL, to deride by making shrill sounds [v]\n",
  "CATCALLS": "CATCALL, to deride by making shrill sounds [v]\n",
  "CATCH": "to capture after pursuit [v CATCHT or CAUGHT or CATCHED, CATCHING, CATCHES]\n",
  "CATCHABLE": "capable of being caught [adj]\n",
  "CATCHALL": "something dealing with a number of instances [n -S]\n",
  "CATCHALLS": "CATCHALL, something dealing with a number of instances [n]\n",
  "CATCHCRIES": "CATCHCRY, (Australian) a phrase commonly used by a particular group [n]\n",
  "CATCHCRY": "(Australian) a phrase commonly used by a particular group [n CATCHCRIES]\n",
  "CATCHED": "CATCH, to capture after pursuit [v]\n",
  "CATCHEN": "(Spenser) to catch (no separate inflections) [v]\n",
  "CATCHER": "one that catches [n -S]\n",
  "CATCHERS": "CATCHER, one that catches [n]\n",
  "CATCHES": "CATCH, to capture after pursuit [v]\n",
  "CATCHFLIES": "CATCHFLY, a name for a species of campion with sticky stems [n]\n",
  "CATCHFLY": "a name for a species of campion with sticky stems [n CATCHFLIES]\n",
  "CATCHIER": "CATCHY, pleasing and easily remembered [adj]\n",
  "CATCHIEST": "CATCHY, pleasing and easily remembered [adj]\n",
  "CATCHILY": "CATCHY, pleasing and easily remembered [adv]\n",
  "CATCHINESS": "the state of being catchy [n -ES]\n",
  "CATCHINESSES": "CATCHINESS, the state of being catchy [n]\n",
  "CATCHING": "the act of catching [n -S]\n",
  "CATCHINGS": "CATCHING, the act of catching [n]\n",
  "CATCHLINE": "a slogan, esp. in advertising or politics [n -S]\n",
  "CATCHLINES": "CATCHLINE, a slogan, esp. in advertising or politics [n]\n",
  "CATCHMENT": "the act of collecting water; the water collected from a river etc. [n -S]\n",
  "CATCHMENTS": "CATCHMENT, the act of collecting water; the water collected from a river etc. [n]\n",
  "CATCHPENNIES": "CATCHPENNY, a worthless thing made only for profit [n]\n",
  "CATCHPENNY": "a worthless thing made only for profit [n CATCHPENNIES]\n",
  "CATCHPHRASE": "a word or expression that is used repeatedly and conveniently to represent or characterize a person, group, idea, or point of view [n -S]\n",
  "CATCHPHRASES": "CATCHPHRASE, a word or expression that is used repeatedly and conveniently to represent or characterize a person, group, idea, or point of view [n]\n",
  "CATCHPOLE": "(historical) a sheriff's officer who made arrests for failure to pay a debt, also CATCHPOLL [n -S]\n",
  "CATCHPOLES": "CATCHPOLE, (historical) a sheriff's officer who made arrests for failure to pay a debt, also CATCHPOLL [n]\n",
  "CATCHPOLL": "(historical) a sheriff's officer who made arrests for failure to pay a debt, also CATCHPOLE [n -S]\n",
  "CATCHPOLLS": "CATCHPOLL, (historical) a sheriff's officer who made arrests for failure to pay a debt, also CATCHPOLE [n]\n",
  "CATCHT": "CATCH, to capture after pursuit [v]\n",
  "CATCHUP": "(Malay) a spicy tomato sauce, also KETCHUP, CATSUP [n -S]\n",
  "CATCHUPS": "CATCHUP, (Malay) a spicy tomato sauce, also KETCHUP, CATSUP [n]\n",
  "CATCHWATER": "a drain or ditch for collecting surface or surplus water [n -S]\n",
  "CATCHWATERS": "CATCHWATER, a drain or ditch for collecting surface or surplus water [n]\n",
  "CATCHWEED": "goosegrass or cleavers [n -S]\n",
  "CATCHWEEDS": "CATCHWEED, goosegrass or cleavers [n]\n",
  "CATCHWEIGHT": "in wrestling, relating to a contest in which normal weight categories have been waived by agreement [adj]\n",
  "CATCHWORD": "among theatrical performers, the last word of the preceding speaker, which reminds one that he is to speak next [n -S]\n",
  "CATCHWORDS": "CATCHWORD, among theatrical performers, the last word of the preceding speaker, which reminds one that he is to speak next [n]\n",
  "CATCHY": "pleasing and easily remembered [adj CATCHIER, CATCHIEST, CATCHILY]\n",
  "CATCLAW": "a type of acacia [n -S]\n",
  "CATCLAWS": "CATCLAW, a type of acacia [n]\n",
  "CATCON": "short for catalytic converter [n -S]\n",
  "CATCONS": "CATCON, short for catalytic converter [n]\n",
  "CATE": "(archaic) a dainty or choice food [n -S]\n",
  "CATECHESES": "CATECHESIS, primary oral instruction, as that given to catechumens [n]\n",
  "CATECHESIS": "primary oral instruction, as that given to catechumens [n CATECHESES or CATECHESISES]\n",
  "CATECHESISES": "CATECHESIS, primary oral instruction, as that given to catechumens [n]\n",
  "CATECHETIC": "relating to catechism, also CATECHETICAL [adj CATECHETICALLY]\n",
  "CATECHETICAL": "relating to catechism, also CATECHETIC [adj CATECHETICALLY]\n",
  "CATECHETICALLY": "CATECHETICAL, relating to catechism, also CATECHETIC [adv]\n",
  "CATECHETICS": "the art or practice of teaching by question and answer; that part of theology which deals with catechesis [n]\n",
  "CATECHIN": "one of the tannic acids, extracted from catechu as a white, crystalline substance [n -S]\n",
  "CATECHINS": "CATECHIN, one of the tannic acids, extracted from catechu as a white, crystalline substance [n]\n",
  "CATECHISATION": "the act of catechising, also CATECHIZATION [n -S]\n",
  "CATECHISATIONS": "CATECHISATION, the act of catechising, also CATECHIZATION [n]\n",
  "CATECHISE": "to instruct in the catechism, also CATECHIZE [v CATECHISED, CATECHISING, CATECHISES]\n",
  "CATECHISED": "CATECHISE, to instruct in the catechism, also CATECHIZE [v]\n",
  "CATECHISER": "one who catechises, also CATECHIZER [n -S]\n",
  "CATECHISERS": "CATECHISER, one who catechises, also CATECHIZER [n]\n",
  "CATECHISES": "CATECHISE, to instruct in the catechism, also CATECHIZE [v]\n",
  "CATECHISING": "the act of instructing in the catechism, also CATECHIZING [n -S]\n",
  "CATECHISINGS": "CATECHISING, the act of instructing in the catechism, also CATECHIZING [n]\n",
  "CATECHISM": "a form of instruction by means of questions and answers [n -S]\n",
  "CATECHISMAL": "relating to catechism [adj]\n",
  "CATECHISMS": "CATECHISM, a form of instruction by means of questions and answers [n]\n",
  "CATECHIST": "one who instructs by question and answer, esp. in religious matters [n -S]\n",
  "CATECHISTIC": "relating to catechism, also CATECHISTICAL [adj CATECHISTICALLY]\n",
  "CATECHISTICAL": "relating to catechism, also CATECHISTIC [adj CATECHISTICALLY]\n",
  "CATECHISTICALLY": "CATECHISTICAL, relating to catechism, also CATECHISTIC [adv]\n",
  "CATECHISTS": "CATECHIST, one who instructs by question and answer, esp. in religious matters [n]\n",
  "CATECHIZATION": "the act of catechizing, also CATECHISATION [n -S]\n",
  "CATECHIZATIONS": "CATECHIZATION, the act of catechizing, also CATECHISATION [n]\n",
  "CATECHIZE": "to instruct in the catechism, also CATECHISE [v CATECHIZED, CATECHIZING, CATECHIZES]\n",
  "CATECHIZED": "CATECHIZE, to instruct in the catechism, also CATECHISE [v]\n",
  "CATECHIZER": "one who catechizes, also CATECHISER [n -S]\n",
  "CATECHIZERS": "CATECHIZER, one who catechizes, also CATECHISER [n]\n",
  "CATECHIZES": "CATECHIZE, to instruct in the catechism, also CATECHISE [v]\n",
  "CATECHIZING": "the act of instructing in the catechism, also CATECHISING [n -S]\n",
  "CATECHIZINGS": "CATECHIZING, the act of instructing in the catechism, also CATECHISING [n]\n",
  "CATECHOL": "a chemical used in photography [n -S]\n",
  "CATECHOLAMINE": "any of various amines, such as epinephrine, norepinephrine, and dopamine, that function as hormones or neurotransmitters or both [n -S]\n",
  "CATECHOLAMINES": "CATECHOLAMINE, any of various amines, such as epinephrine, norepinephrine, and dopamine, that function as hormones or neurotransmitters or both [n]\n",
  "CATECHOLS": "CATECHOL, a chemical used in photography [n]\n",
  "CATECHU": "(Malay) a resin used in tanning, also CACHOU, CASHOO, CUTCH, KUTCH [n -S]\n",
  "CATECHUMEN": "one who is receiving religious instruction in preparation for baptism [n -S]\n",
  "CATECHUMENAL": "of or like a catechumen, also CATECHUMENICAL [adj]\n",
  "CATECHUMENATE": "the state of being a catechumen [n -S]\n",
  "CATECHUMENATES": "CATECHUMENATE, the state of being a catechumen [n]\n",
  "CATECHUMENICAL": "of or like a catechumen, also CATECHUMENAL [adj]\n",
  "CATECHUMENISM": "being a catechumen [n -S]\n",
  "CATECHUMENISMS": "CATECHUMENISM, being a catechumen [n]\n",
  "CATECHUMENS": "CATECHUMEN, one who is receiving religious instruction in preparation for baptism [n]\n",
  "CATECHUMENSHIP": "the office of catechumen [n -S]\n",
  "CATECHUMENSHIPS": "CATECHUMENSHIP, the office of catechumen [n]\n",
  "CATECHUS": "CATECHU, (Malay) a resin used in tanning, also CACHOU, CASHOO, CUTCH, KUTCH [n]\n",
  "CATEGOREMATIC": "capable of being used by itself as a term [adj]\n",
  "CATEGORIAL": "of or relating to a category [adj CATEGORIALLY]\n",
  "CATEGORIALLY": "CATEGORIAL, of or relating to a category [adv]\n",
  "CATEGORIC": "positive; absolute, also CATEGORICAL [adj CATEGORICALLY]\n",
  "CATEGORICAL": "positive; absolute, also CATEGORIC [adj CATEGORICALLY]\n",
  "CATEGORICALLY": "CATEGORICAL, positive; absolute, also CATEGORIC [adv]\n",
  "CATEGORICALNESS": "the state of being categorical [n]\n",
  "CATEGORIES": "CATEGORY, a division in any system of classification [n]\n",
  "CATEGORISATION": "the process of categorising, also CATEGORIZATION [n -S]\n",
  "CATEGORISATIONS": "CATEGORISATION, the process of categorising, also CATEGORIZATION [n]\n",
  "CATEGORISE": "to put into a category, also CATEGORIZE [v CATEGORISED, CATEGORISING, CATEGORISES]\n",
  "CATEGORISED": "CATEGORISE, to put into a category, also CATEGORIZE [v]\n",
  "CATEGORISES": "CATEGORISE, to put into a category, also CATEGORIZE [v]\n",
  "CATEGORISING": "CATEGORISE, to put into a category, also CATEGORIZE [v]\n",
  "CATEGORIST": "one who inserts in a category or list; one who classifies [n -S]\n",
  "CATEGORISTS": "CATEGORIST, one who inserts in a category or list; one who classifies [n]\n",
  "CATEGORIZATION": "the act of categorizing, also CATEGORISATION [n -S]\n",
  "CATEGORIZATIONS": "CATEGORIZATION, the act of categorizing, also CATEGORISATION [n]\n",
  "CATEGORIZE": "to put into a category, also CATEGORISE [v CATEGORIZED, CATEGORIZING, CATEGORIZES]\n",
  "CATEGORIZED": "CATEGORIZE, to put into a category, also CATEGORISE [v]\n",
  "CATEGORIZES": "CATEGORIZE, to put into a category, also CATEGORISE [v]\n",
  "CATEGORIZING": "CATEGORIZE, to put into a category, also CATEGORISE [v]\n",
  "CATEGORY": "a division in any system of classification [n CATEGORIES]\n",
  "CATELOG": "(obsolete) a catalogue, also CATALOG [n -S]\n",
  "CATELOGS": "CATELOG, (obsolete) a catalogue, also CATALOG [n]\n",
  "CATENA": "(Latin) a chain or connected series of things, esp. of the patristic comments on Scripture [n CATENAS or CATENAE]\n",
  "CATENACCIO": "(Italian) a defensive system of play in football [n -S]\n",
  "CATENACCIOS": "CATENACCIO, (Italian) a defensive system of play in football [n]\n",
  "CATENAE": "CATENA, (Latin) a chain or connected series of things, esp. of the patristic comments on Scripture [n]\n",
  "CATENANE": "a chemical compound having molecules linked like a chain [n -S]\n",
  "CATENANES": "CATENANE, a chemical compound having molecules linked like a chain [n]\n",
  "CATENARIAN": "of or pertaining to chains [adj]\n",
  "CATENARIES": "CATENARY, a curve of the kind formed by a uniform chain hanging freely from two points not in the same vertical line [n]\n",
  "CATENARY": "a curve of the kind formed by a uniform chain hanging freely from two points not in the same vertical line [n CATENARIES]\n",
  "CATENAS": "CATENA, (Latin) a chain or connected series of things, esp. of the patristic comments on Scripture [n]\n",
  "CATENATE": "to link together [v CATENATED, CATENATING, CATENATES]\n",
  "CATENATED": "CATENATE, to link together [v]\n",
  "CATENATES": "CATENATE, to link together [v]\n",
  "CATENATING": "CATENATE, to link together [v]\n",
  "CATENATION": "connection of links or union of parts, as in a chain; a regular or connected series [n -S]\n",
  "CATENATIONS": "CATENATION, connection of links or union of parts, as in a chain; a regular or connected series [n]\n",
  "CATENOID": "the surface generated by rotating a catenary about its axis [n -S]\n",
  "CATENOIDS": "CATENOID, the surface generated by rotating a catenary about its axis [n]\n",
  "CATENULATE": "of certain spores, formed in a row or chain [adj]\n",
  "CATER": "to provide food and service [v -ED, -ING, -S]\n",
  "CATERAN": "(Scots) a military irregular or brigand [n -S]\n",
  "CATERANS": "CATERAN, (Scots) a military irregular or brigand [n]\n",
  "CATERCORNER": "in a diagonal or oblique position, on a diagonal or oblique line [adj]\n",
  "CATERCORNERED": "in a diagonal or oblique position, on a diagonal or oblique line [adj]\n",
  "CATERED": "CATER, to provide food and service [v]\n",
  "CATERER": "one that caters [n -S]\n",
  "CATERERS": "CATERER, one that caters [n]\n",
  "CATERESS": "a woman who caters [n -ES]\n",
  "CATERESSES": "CATERESS, a woman who caters [n]\n",
  "CATERING": "the business of catering [n -S]\n",
  "CATERINGS": "CATERING, the business of catering [n]\n",
  "CATERPILLAR": "the elongated wormlike larva of a butterfly or moth [n -S]\n",
  "CATERPILLARS": "CATERPILLAR, the elongated wormlike larva of a butterfly or moth [n]\n",
  "CATERS": "CATER, to provide food and service [v]\n",
  "CATERWAUL": "to make a harsh cry [v -ED, -ING, -S]\n",
  "CATERWAULED": "CATERWAUL, to make a harsh cry [v]\n",
  "CATERWAULER": "one who caterwauls [n -S]\n",
  "CATERWAULERS": "CATERWAULER, one who caterwauls [n]\n",
  "CATERWAULING": "making a harsh cry [n -S]\n",
  "CATERWAULINGS": "CATERWAULING, making a harsh cry [n]\n",
  "CATERWAULS": "CATERWAUL, to make a harsh cry [v]\n",
  "CATES": "CATE, (archaic) a dainty or choice food [n]\n",
  "CATFACE": "a deformity of fruit [n -S]\n",
  "CATFACES": "CATFACE, a deformity of fruit [n]\n",
  "CATFACING": "a deformity of fruit, also CATFACE [n -S]\n",
  "CATFACINGS": "CATFACING, a deformity of fruit, also CATFACE [n]\n",
  "CATFALL": "a rope used in hoisting the anchor to the cathead [n -S]\n",
  "CATFALLS": "CATFALL, a rope used in hoisting the anchor to the cathead [n]\n",
  "CATFIGHT": "a fight between two women [n -S]\n",
  "CATFIGHTS": "CATFIGHT, a fight between two women [n]\n",
  "CATFISH": "to create a false identity on social media in order to lure someone into establishing a relationship [v -ED, -ING, -ES]\n",
  "CATFISHED": "CATFISH, to create a false identity on social media in order to lure someone into establishing a relationship [v]\n",
  "CATFISHES": "CATFISH, to create a false identity on social media in order to lure someone into establishing a relationship [v]\n",
  "CATFISHING": "CATFISH, to create a false identity on social media in order to lure someone into establishing a relationship [v]\n",
  "CATFLAP": "a small opening in a door to let a cat through [n -S]\n",
  "CATFLAPS": "CATFLAP, a small opening in a door to let a cat through [n]\n",
  "CATFOOD": "food for cats [n -S]\n",
  "CATFOODS": "CATFOOD, food for cats [n]\n",
  "CATGUT": "the intestine of a cat, used e.g. for stringing violins [n -S]\n",
  "CATGUTS": "CATGUT, the intestine of a cat, used e.g. for stringing violins [n]\n",
  "CATHARISE": "to render absolutely clean; to purge, also CATHARIZE [v CATHARISED, CATHARISING, CATHARISES]\n",
  "CATHARISED": "CATHARISE, to render absolutely clean; to purge, also CATHARIZE [v]\n",
  "CATHARISES": "CATHARISE, to render absolutely clean; to purge, also CATHARIZE [v]\n",
  "CATHARISING": "CATHARISE, to render absolutely clean; to purge, also CATHARIZE [v]\n",
  "CATHARIZE": "to render absolutely clean; to purge, also CATHARISE [v CATHARIZED, CATHARIZING, CATHARIZES]\n",
  "CATHARIZED": "CATHARIZE, to render absolutely clean; to purge, also CATHARISE [v]\n",
  "CATHARIZES": "CATHARIZE, to render absolutely clean; to purge, also CATHARISE [v]\n",
  "CATHARIZING": "CATHARIZE, to render absolutely clean; to purge, also CATHARISE [v]\n",
  "CATHARSES": "CATHARSIS, (Greek) a natural or artificial purgation of any passage, as of the mouth, bowels, etc., also KATHARSIS [n]\n",
  "CATHARSIS": "(Greek) a natural or artificial purgation of any passage, as of the mouth, bowels, etc., also KATHARSIS [n CATHARSES]\n",
  "CATHARTIC": "cleansing, also CATHARTICAL [adj CATHARTICALLY] / something which is used to clean one's bowels [n -S]\n",
  "CATHARTICAL": "cleansing, purifying, also CATHARTIC [adj CATHARTICALLY]\n",
  "CATHARTICALLY": "CATHARTICAL, cleansing, purifying, also CATHARTIC [adv]\n",
  "CATHARTICS": "CATHARTIC, something which is used to clean one's bowels [n]\n",
  "CATHEAD": "a beam projecting from a ship's bow [n -S]\n",
  "CATHEADS": "CATHEAD, a beam projecting from a ship's bow [n]\n",
  "CATHECT": "to invest with psychic energy [v -ED, -ING, -S]\n",
  "CATHECTED": "CATHECT, to invest with psychic energy [v]\n",
  "CATHECTIC": "invested with mental or emotional energy [adj]\n",
  "CATHECTING": "CATHECT, to invest with psychic energy [v]\n",
  "CATHECTS": "CATHECT, to invest with psychic energy [v]\n",
  "CATHEDRA": "(Latin) a bishop's throne [n CATHEDRAS or CATHEDRAE]\n",
  "CATHEDRAE": "CATHEDRA, (Latin) a bishop's throne [n]\n",
  "CATHEDRAL": "the principal church in a diocese, so called because in it the bishop has his official chair (cathedra) [n -S]\n",
  "CATHEDRALS": "CATHEDRAL, the principal church in a diocese, so called because in it the bishop has his official chair (cathedra) [n]\n",
  "CATHEDRAS": "CATHEDRA, (Latin) a bishop's throne [n]\n",
  "CATHEDRATIC": "promulgated ex cathedra, authoritative [adj]\n",
  "CATHEPSIN": "an intracellular protease of animal tissue [n -S]\n",
  "CATHEPSINS": "CATHEPSIN, an intracellular protease of animal tissue [n]\n",
  "CATHEPTIC": "of or like cathepsin, an intracellular protease of animal tissue [adj]\n",
  "CATHETER": "a tube which can be passed into the bladder or other body cavity or canal to allow the draining of fluid [n -S]\n",
  "CATHETERISATION": "the process of catheterising, also CATHETERIZATION [n]\n",
  "CATHETERISE": "to treat with a catheter, also CATHETERIZE [v CATHETERISED, CATHETERISING, CATHETERISES]\n",
  "CATHETERISED": "CATHETERISE, to treat with a catheter, also CATHETERIZE [v]\n",
  "CATHETERISES": "CATHETERISE, to treat with a catheter, also CATHETERIZE [v]\n",
  "CATHETERISING": "CATHETERISE, to treat with a catheter, also CATHETERIZE [v]\n",
  "CATHETERISM": "use of the catheter [n -S]\n",
  "CATHETERISMS": "CATHETERISM, use of the catheter [n]\n",
  "CATHETERIZATION": "the use of or introduction of a catheter (as in or into the bladder, trachea, or heart), also CATHETERISATION [n]\n",
  "CATHETERIZE": "to fit with a catheter, also CATHETERISE [v CATHETERIZED, CATHETERIZING, CATHETERIZES]\n",
  "CATHETERIZED": "CATHETERIZE, to fit with a catheter, also CATHETERISE [v]\n",
  "CATHETERIZES": "CATHETERIZE, to fit with a catheter, also CATHETERISE [v]\n",
  "CATHETERIZING": "CATHETERIZE, to fit with a catheter, also CATHETERISE [v]\n",
  "CATHETERS": "CATHETER, a tube which can be passed into the bladder or other body cavity or canal to allow the draining of fluid [n]\n",
  "CATHETOMETER": "an instrument for measuring short vertical distances [n -S]\n",
  "CATHETOMETERS": "CATHETOMETER, an instrument for measuring short vertical distances [n]\n",
  "CATHETUS": "(Greek) a straight line perpendicular to another straight line or surface [n -ES]\n",
  "CATHETUSES": "CATHETUS, (Greek) a straight line perpendicular to another straight line or surface [n]\n",
  "CATHEXES": "CATHEXIS, (Greek) the investment of emotional energy in a thought or idea [n]\n",
  "CATHEXIS": "(Greek) the investment of emotional energy in a thought or idea [n CATHEXES]\n",
  "CATHINONE": "an alkaloid stimulant obtained from khat; a similar synthetic compound [n -S]\n",
  "CATHINONES": "CATHINONE, an alkaloid stimulant obtained from khat; a similar synthetic compound [n]\n",
  "CATHIODERMIE": "a beauty treatment for the skin, which involves using electrotherapy [n -S]\n",
  "CATHIODERMIES": "CATHIODERMIE, a beauty treatment for the skin, which involves using electrotherapy [n]\n",
  "CATHISMA": "(Greek) a short hymn used as a response [n -S]\n",
  "CATHISMAS": "CATHISMA, (Greek) a short hymn used as a response [n]\n",
  "CATHODAL": "relating to a cathode, also CATHODIC, CATHODICAL, KATHODAL, KATHODIC [adj CATHODALLY]\n",
  "CATHODALLY": "CATHODAL, relating to a cathode, also CATHODIC, CATHODICAL, KATHODAL, KATHODIC [adv]\n",
  "CATHODE": "a negatively charged electrode, also KATHODE [n -S]\n",
  "CATHODES": "CATHODE, a negatively charged electrode, also KATHODE [n]\n",
  "CATHODIC": "relating to a cathode, also CATHODAL, CATHODICAL, KATHODAL, KATHODIC [adj CATHODICALLY]\n",
  "CATHODICAL": "relating to a cathode, also CATHODAL, CATHODIC, KATHODAL, KATHODIC [adj CATHODICALLY]\n",
  "CATHODICALLY": "CATHODICAL, relating to a cathode, also CATHODAL, CATHODIC, KATHODAL, KATHODIC [adv]\n",
  "CATHODOGRAPH": "a photograph created using X-rays [n -S]\n",
  "CATHODOGRAPHER": "one who takes photographs created using X-rays [n -S]\n",
  "CATHODOGRAPHERS": "CATHODOGRAPHER, one who takes photographs created using X-rays [n]\n",
  "CATHODOGRAPHIES": "CATHODOGRAPHY, the taking of photographs created using X-rays [n]\n",
  "CATHODOGRAPHS": "CATHODOGRAPH, a photograph created using X-rays [n]\n",
  "CATHODOGRAPHY": "the taking of photographs created using X-rays [n CATHODOGRAPHIES]\n",
  "CATHOLE": "one of two holes in the after part of a ship through which hawsers are passed for steadying the ship [n -S]\n",
  "CATHOLES": "CATHOLE, one of two holes in the after part of a ship through which hawsers are passed for steadying the ship [n]\n",
  "CATHOLIC": "universal, general [adj CATHOLICLY or CATHOLICALLY] / a member of the early Christian church [n -S]\n",
  "CATHOLICALLY": "CATHOLIC, universal, general [adv]\n",
  "CATHOLICATE": "the jurisdiction of a catholicos [n -S]\n",
  "CATHOLICATES": "CATHOLICATE, the jurisdiction of a catholicos [n]\n",
  "CATHOLICISATION": "the process of catholicising, also CATHOLICIZATION [n]\n",
  "CATHOLICISE": "to make catholic, also CATHOLICIZE [v CATHOLICISED, CATHOLICISING, CATHOLICISES]\n",
  "CATHOLICISED": "CATHOLICISE, to make catholic, also CATHOLICIZE [v]\n",
  "CATHOLICISES": "CATHOLICISE, to make catholic, also CATHOLICIZE [v]\n",
  "CATHOLICISING": "CATHOLICISE, to make catholic, also CATHOLICIZE [v]\n",
  "CATHOLICISM": "the state of being catholic [n -S]\n",
  "CATHOLICISMS": "CATHOLICISM, the state of being catholic [n]\n",
  "CATHOLICITIES": "CATHOLICITY, broad-mindedness; inclusiveness [n]\n",
  "CATHOLICITY": "broad-mindedness; inclusiveness [n CATHOLICITIES]\n",
  "CATHOLICIZATION": "the process of catholicizing, also CATHOLICISATION [n]\n",
  "CATHOLICIZE": "to make catholic, also CATHOLICISE [v CATHOLICIZED, CATHOLICIZING, CATHOLICIZES]\n",
  "CATHOLICIZED": "CATHOLICIZE, to make catholic, also CATHOLICISE [v]\n",
  "CATHOLICIZES": "CATHOLICIZE, to make catholic, also CATHOLICISE [v]\n",
  "CATHOLICIZING": "CATHOLICIZE, to make catholic, also CATHOLICISE [v]\n",
  "CATHOLICLY": "CATHOLIC, universal, general [adv]\n",
  "CATHOLICOI": "CATHOLICOS, (Greek) the Primate of the Armenian or Nestorian church [n]\n",
  "CATHOLICON": "a cure-all; a panacea [n -S]\n",
  "CATHOLICONS": "CATHOLICON, a cure-all; a panacea [n]\n",
  "CATHOLICOS": "(Greek) the Primate of the Armenian or Nestorian church [n CATHOLICOI or CATHOLICOSES]\n",
  "CATHOLICOSES": "CATHOLICOS, (Greek) the Primate of the Armenian or Nestorian church [n]\n",
  "CATHOLICS": "CATHOLIC, a member of the early Christian church [n]\n",
  "CATHOLYTE": "the part of the electrode that surrounds the cathode in an electrolytic cell, also CATOLYTE [n -S]\n",
  "CATHOLYTES": "CATHOLYTE, the part of the electrode that surrounds the cathode in an electrolytic cell, also CATOLYTE [n]\n",
  "CATHOOD": "the state of being a cat [n -S]\n",
  "CATHOODS": "CATHOOD, the state of being a cat [n]\n",
  "CATHOUSE": "a brothel [n -S]\n",
  "CATHOUSES": "CATHOUSE, a brothel [n]\n",
  "CATION": "a positively charged ion, also KATION [n -S]\n",
  "CATIONIC": "relating to a cation [adj CATIONICALLY]\n",
  "CATIONICALLY": "CATIONIC, relating to a cation [adv]\n",
  "CATIONS": "CATION, a positively charged ion, also KATION [n]\n",
  "CATJANG": "a thickly branched African shrub [n -S]\n",
  "CATJANGS": "CATJANG, a thickly branched African shrub [n]\n",
  "CATKIN": "a crowded spike or tuft of small unisexual flowers, as in the willow, hazel, etc. [n -S]\n",
  "CATKINATE": "like catkin [adj]\n",
  "CATKINS": "CATKIN, a crowded spike or tuft of small unisexual flowers, as in the willow, hazel, etc. [n]\n",
  "CATLIKE": "like a cat [adj]\n",
  "CATLIN": "a surgical knife, also CATLING [n -S]\n",
  "CATLING": "a surgical knife, also CATLIN [n -S]\n",
  "CATLINGS": "CATLING, a surgical knife, also CATLIN [n]\n",
  "CATLINITE": "a red clay of the Upper Missouri region, the sacred pipestone of some indigenous American peoples [n -S]\n",
  "CATLINITES": "CATLINITE, a red clay of the Upper Missouri region, the sacred pipestone of some indigenous American peoples [n]\n",
  "CATLINS": "CATLIN, a surgical knife, also CATLING [n]\n",
  "CATMINT": "an aromatic herb, also CATNIP [n -S]\n",
  "CATMINTS": "CATMINT, an aromatic herb, also CATNIP [n]\n",
  "CATNAP": "to take a short nap [v CATNAPPED, CATNAPPING, CATNAPS]\n",
  "CATNAPER": "one that steals cats, usually to sell them for research, also CATNAPPER [n -S]\n",
  "CATNAPERS": "CATNAPER, one that steals cats, usually to sell them for research, also CATNAPPER [n]\n",
  "CATNAPPED": "CATNAP, to take a short nap [v]\n",
  "CATNAPPER": "one that steals cats, usually to sell them for research, also CATNAPER [n -S]\n",
  "CATNAPPERS": "CATNAPPER, one that steals cats, usually to sell them for research, also CATNAPER [n]\n",
  "CATNAPPING": "CATNAP, to take a short nap [v]\n",
  "CATNAPS": "CATNAP, to take a short nap [v]\n",
  "CATNEP": "a mint-like plant attractive to cats, also CATMINT, CATNIP [n -S]\n",
  "CATNEPS": "CATNEP, a mint-like plant attractive to cats, also CATMINT, CATNIP [n]\n",
  "CATNIP": "a mint-like plant attractive to cats, also CATMINT, CATNEP [n -S]\n",
  "CATNIPS": "CATNIP, a mint-like plant attractive to cats, also CATMINT, CATNEP [n]\n",
  "CATOLYTE": "the electrolyte near the cathode, also CATHOLYTE [n -S]\n",
  "CATOLYTES": "CATOLYTE, the electrolyte near the cathode, also CATHOLYTE [n]\n",
  "CATOPTRIC": "relating to reflection, also CATOPTRICAL [adj]\n",
  "CATOPTRICAL": "relating to reflection, also CATOPTRIC [adj]\n",
  "CATOPTRICS": "the branch of optics which is concerned with reflected light [n]\n",
  "CATRIGGED": "rigged like a catboat, having one great fore-and-aft mainsail spread by a gaff at the head and a boom at the foot [adj]\n",
  "CATS": "CAT, to vomit [v]\n",
  "CATSKIN": "the skin of a cat esp. as used to make e.g. gloves [n -S]\n",
  "CATSKINS": "CATSKIN, the skin of a cat esp. as used to make e.g. gloves [n]\n",
  "CATSPAW": "a light breeze forming ripples on the water's surface [n -S]\n",
  "CATSPAWS": "CATSPAW, a light breeze forming ripples on the water's surface [n]\n",
  "CATSUIT": "a type of one-piece trouser suit [n -S]\n",
  "CATSUITS": "CATSUIT, a type of one-piece trouser suit [n]\n",
  "CATSUP": "(Malay) a spicy tomato sauce, also KETCHUP, CATCHUP [n -S]\n",
  "CATSUPS": "CATSUP, (Malay) a spicy tomato sauce, also KETCHUP, CATCHUP [n]\n",
  "CATTABU": "a cross between domestic cattle and zebu [n -S]\n",
  "CATTABUS": "CATTABU, a cross between domestic cattle and zebu [n]\n",
  "CATTAIL": "any of various plants with long thin parts suggestive of cats' tails, esp. the reed-mace [n -S]\n",
  "CATTAILS": "CATTAIL, any of various plants with long thin parts suggestive of cats' tails, esp. the reed-mace [n]\n",
  "CATTALO": "a cross between a buffalo and a domestic cow, also CATALO [n CATTALOS or CATTALOES]\n",
  "CATTALOES": "CATTALO, a cross between a buffalo and a domestic cow, also CATALO [n]\n",
  "CATTALOS": "CATTALO, a cross between a buffalo and a domestic cow, also CATALO [n]\n",
  "CATTED": "CAT, to vomit [v]\n",
  "CATTERIES": "CATTERY, a breeding place for cats [n]\n",
  "CATTERY": "a breeding place for cats [n CATTERIES]\n",
  "CATTIE": "(Malay) a unit of measure used in S.E. Asia, also KATI, KATTI [n -S]\n",
  "CATTIER": "CATTY, spiteful [adj]\n",
  "CATTIES": "CATTIE, (Malay) a unit of measure used in S.E. Asia, also KATI, KATTI [n]\n",
  "CATTIEST": "CATTY, spiteful [adj]\n",
  "CATTILY": "CATTY, spiteful [adv]\n",
  "CATTINESS": "being catty, spiteful [n -ES]\n",
  "CATTINESSES": "CATTINESS, being catty, spiteful [n]\n",
  "CATTING": "CAT, to vomit [v]\n",
  "CATTISH": "like a cat, spiteful [adj CATTISHLY]\n",
  "CATTISHLY": "CATTISH, like a cat, spiteful [adv]\n",
  "CATTISHNESS": "the quality of being cattish [n -ES]\n",
  "CATTISHNESSES": "CATTISHNESS, the quality of being cattish [n]\n",
  "CATTLE": "domesticated bovines [n]\n",
  "CATTLEMAN": "one who raises cattle [n CATTLEMEN]\n",
  "CATTLEMEN": "CATTLEMAN, one who raises cattle [n]\n",
  "CATTLEYA": "a tropical orchid [n -S]\n",
  "CATTLEYAS": "CATTLEYA, a tropical orchid [n]\n",
  "CATTY": "spiteful [adj CATTIER, CATTIEST, CATTILY] / an Asian unit of weight, also KATI, KATTI [n CATTIES]\n",
  "CATWALK": "a narrow walkway [n -S]\n",
  "CATWALKS": "CATWALK, a narrow walkway [n]\n",
  "CATWORKS": "the assemblage of motors and catheads providing power for secondary activities on drilling platforms [n]\n",
  "CATWORM": "a polychaete worm frequently used as a fishing bait [n -S]\n",
  "CATWORMS": "CATWORM, a polychaete worm frequently used as a fishing bait [n]\n",
  "CAUCHEMAR": "(French) a nightmare [n -S]\n",
  "CAUCHEMARS": "CAUCHEMAR, (French) a nightmare [n]\n",
  "CAUCUS": "to hold a political meeting [v CAUCUSSED or CAUCUSED, CAUCUSSING or CAUCUSING, CAUCUSSES or CAUCUSES]\n",
  "CAUCUSED": "CAUCUS, to hold a political meeting [v]\n",
  "CAUCUSES": "CAUCUS, to hold a political meeting [v]\n",
  "CAUCUSING": "CAUCUS, to hold a political meeting [v]\n",
  "CAUCUSSED": "CAUCUS, to hold a political meeting [v]\n",
  "CAUCUSSES": "CAUCUS, to hold a political meeting [v]\n",
  "CAUCUSSING": "the act of holding a caucus [n -S]\n",
  "CAUCUSSINGS": "CAUCUSSING, the act of holding a caucus [n]\n",
  "CAUDA": "the area behind an animal's anus [n CAUDAE]\n",
  "CAUDAD": "towards the tail [adv]\n",
  "CAUDAE": "CAUDA, the area behind an animal's anus [n]\n",
  "CAUDAL": "of or pertaining to the tail [adj CAUDALLY]\n",
  "CAUDALLY": "CAUDAL, of or pertaining to the tail [adv]\n",
  "CAUDATE": "having a tail, also CAUDATED [adj] / a creature with a tail [n -S]\n",
  "CAUDATED": "having a tail [adj]\n",
  "CAUDATES": "CAUDATE, a creature with a tail [n]\n",
  "CAUDATION": "the state of being caudate, with a tail [n -S]\n",
  "CAUDATIONS": "CAUDATION, the state of being caudate, with a tail [n]\n",
  "CAUDEX": "(Latin) the woody base of some plants [n CAUDEXES or CAUDICES]\n",
  "CAUDEXES": "CAUDEX, (Latin) the woody base of some plants [n]\n",
  "CAUDICES": "CAUDEX, (Latin) the woody base of some plants [n]\n",
  "CAUDICLE": "the stalk of the pollen masses of certain orchids [n -S]\n",
  "CAUDICLES": "CAUDICLE, the stalk of the pollen masses of certain orchids [n]\n",
  "CAUDILLISMO": "the doctrine or practice of a caudillo [n -S]\n",
  "CAUDILLISMOS": "CAUDILLISMO, the doctrine or practice of a caudillo [n]\n",
  "CAUDILLO": "(Spanish) in Spanish-speaking countries, a military or political leader [n -S]\n",
  "CAUDILLOS": "CAUDILLO, (Spanish) in Spanish-speaking countries, a military or political leader [n]\n",
  "CAUDLE": "a drink of warm gruel containing spice, sugar, and wine, for invalids [n -S] / to give a caudle to [v CAUDLED, CAUDLING, CAUDLES]\n",
  "CAUDLED": "CAUDLE, to give a caudle to [v]\n",
  "CAUDLES": "CAUDLE, to give a caudle to [v]\n",
  "CAUDLING": "CAUDLE, to give a caudle to [v]\n",
  "CAUDRON": "(Spenser) a cauldron [n -S]\n",
  "CAUDRONS": "CAUDRON, (Spenser) a cauldron [n]\n",
  "CAUF": "a coalminer's basket, also CORF [n CAUVES]\n",
  "CAUGHT": "CATCH, to capture after pursuit [v]\n",
  "CAUK": "an opaque, compact variety of barite, or heavy spar, also CAWK [n -S]\n",
  "CAUKER": "a big lie, also CAULKER [n -S]\n",
  "CAUKERS": "CAUKER, a big lie, also CAULKER [n]\n",
  "CAUKS": "CAUK, an opaque, compact variety of barite, or heavy spar, also CAWK [n]\n",
  "CAUL": "a foetal membrane covering the head [n -S]\n",
  "CAULD": "(Scots) cold [adj CAULDER, CAULDEST] / cold [n -S]\n",
  "CAULDER": "CAULD, (Scots) cold [adj]\n",
  "CAULDEST": "CAULD, (Scots) cold [adj]\n",
  "CAULDRIFE": "(Scots) apt to feel chilly; lifeless, without vigour [adj]\n",
  "CAULDRON": "a large kettle or boiler, also CALDRON [n -S]\n",
  "CAULDRONS": "CAULDRON, a large kettle or boiler, also CALDRON [n]\n",
  "CAULDS": "CAULD, cold [n]\n",
  "CAULES": "CAULIS, (Latin) a herbaceous or woody stem which bears leaves, and may bear flowers [n]\n",
  "CAULESCENT": "having a leafy stem [adj]\n",
  "CAULICLE": "a short caulis or stem [n -S]\n",
  "CAULICLES": "CAULICLE, a short caulis or stem [n]\n",
  "CAULICOLOUS": "growing on a stem [adj]\n",
  "CAULICULATE": "having a caulicle [adj]\n",
  "CAULICULI": "CAULICULUS, one of the slender stems springing from the caules or main stalks supporting the volutes in the Corinthian capital [n]\n",
  "CAULICULUS": "one of the slender stems springing from the caules or main stalks supporting the volutes in the Corinthian capital [n CAULICULI or CAULICULUSES]\n",
  "CAULICULUSES": "CAULICULUS, one of the slender stems springing from the caules or main stalks supporting the volutes in the Corinthian capital [n]\n",
  "CAULIFLORIES": "CAULIFLORY, the production of flowers on old stems from dormant buds [n]\n",
  "CAULIFLOROUS": "relating to cauliflory, the production of flowers on old stems from dormant buds [adj]\n",
  "CAULIFLORY": "the production of flowers on old stems from dormant buds [n CAULIFLORIES]\n",
  "CAULIFLOWER": "a variety of cabbage with a white, closely-packed, flower-head, eaten as a vegetable [n -S]\n",
  "CAULIFLOWERET": "a bitesize piece of cauliflower [n -S]\n",
  "CAULIFLOWERETS": "CAULIFLOWERET, a bitesize piece of cauliflower [n]\n",
  "CAULIFLOWERS": "CAULIFLOWER, a variety of cabbage with a white, closely-packed, flower-head, eaten as a vegetable [n]\n",
  "CAULIFORM": "shaped like or resembling a stem [adj]\n",
  "CAULIGENOUS": "originating on the stem of a plant [adj]\n",
  "CAULINARY": "belonging to or growing from a stem, also CAULINE [adj]\n",
  "CAULINE": "pertaining to a stem [adj]\n",
  "CAULIS": "(Latin) a herbaceous or woody stem which bears leaves, and may bear flowers [n CAULES]\n",
  "CAULK": "to make the seams of a ship watertight, also CALK [v -ED, -ING, -S]\n",
  "CAULKED": "CAULK, to make the seams of a ship watertight, also CALK [v]\n",
  "CAULKER": "a big lie, also CAUKER [n -S]\n",
  "CAULKERS": "CAULKER, a big lie, also CAUKER [n]\n",
  "CAULKING": "the material used to caulk the seams of a ship [n -S]\n",
  "CAULKINGS": "CAULKING, the material used to caulk the seams of a ship [n]\n",
  "CAULKS": "CAULK, to make the seams of a ship watertight, also CALK [v]\n",
  "CAULOME": "the structure of a plant [n -S]\n",
  "CAULOMES": "CAULOME, the structure of a plant [n]\n",
  "CAULS": "CAUL, a foetal membrane covering the head [n]\n",
  "CAUM": "(Scots) to whiten with camstone, also CAM [v -ED, -ING, -S]\n",
  "CAUMED": "CAUM, (Scots) to whiten with camstone, also CAM [v]\n",
  "CAUMING": "CAUM, (Scots) to whiten with camstone, also CAM [v]\n",
  "CAUMS": "CAUM, (Scots) to whiten with camstone, also CAM [v]\n",
  "CAUMSTANE": "a white argillaceous stone used for whitening hearthstones and doorsteps [n -S]\n",
  "CAUMSTANES": "CAUMSTANE, a white argillaceous stone used for whitening hearthstones and doorsteps [n]\n",
  "CAUMSTONE": "(Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CALMSTONE, CAMSTANE, CAMSTONE, CAUMSTANE [n -S]\n",
  "CAUMSTONES": "CAUMSTONE, (Scots) a white argillaceous stone used for whitening doorsteps, also CALMSTANE, CALMSTONE, CAMSTANE, CAMSTONE, CAUMSTANE [n]\n",
  "CAUP": "(Scots) a two-handed drinking bowl [n -S]\n",
  "CAUPS": "CAUP, (Scots) a two-handed drinking bowl [n]\n",
  "CAURI": "a former monetary unit of Guiana [n -S]\n",
  "CAURIS": "CAURI, a former monetary unit of Guiana [n]\n",
  "CAUSA": "(Latin) a (legal) cause [n CAUSAE]\n",
  "CAUSABILITIES": "CAUSABILITY, the ability to be caused [n]\n",
  "CAUSABILITY": "the ability to be caused [n CAUSABILITIES]\n",
  "CAUSABLE": "able to be caused [adj]\n",
  "CAUSAE": "CAUSA, (Latin) a (legal) cause [n]\n",
  "CAUSAL": "relating to cause [adj CAUSALLY] / a word expressing a cause or reason [n -S]\n",
  "CAUSALGIA": "a constant burning pain resulting from injury to a peripheral nerve [n -S]\n",
  "CAUSALGIAS": "CAUSALGIA, a constant burning pain resulting from injury to a peripheral nerve [n]\n",
  "CAUSALGIC": "relating to causalgia, a constant burning pain resulting from injury to a peripheral nerve [adj]\n",
  "CAUSALITIES": "CAUSALITY, the relationship between cause and effect [n]\n",
  "CAUSALITY": "the relationship between cause and effect [n CAUSALITIES]\n",
  "CAUSALLY": "CAUSAL, relating to cause [adv]\n",
  "CAUSALS": "CAUSAL, a word expressing a cause or reason [n]\n",
  "CAUSATION": "the act of causing [n -S]\n",
  "CAUSATIONAL": "relating to causation [adj]\n",
  "CAUSATIONISM": "the principle of universal causation [n -S]\n",
  "CAUSATIONISMS": "CAUSATIONISM, the principle of universal causation [n]\n",
  "CAUSATIONIST": "a believer in causationism [n -S]\n",
  "CAUSATIONISTS": "CAUSATIONIST, a believer in causationism [n]\n",
  "CAUSATIONS": "CAUSATION, the act of causing [n]\n",
  "CAUSATIVE": "relating to causation [adj CAUSATIVELY] / a form or class of verb expressing causation [n -S]\n",
  "CAUSATIVELY": "CAUSATIVE, relating to causation [adv]\n",
  "CAUSATIVENESS": "CAUSATIVE, relating to causation [n]\n",
  "CAUSATIVENESSES": "CAUSATIVENESS, CAUSATIVE, relating to causation [n]\n",
  "CAUSATIVES": "CAUSATIVE, a form or class of verb expressing causation [n]\n",
  "CAUSE": "to bring about [v CAUSED, CAUSING, CAUSES]\n",
  "CAUSED": "CAUSE, to bring about [v]\n",
  "CAUSELESS": "without a cause [adj CAUSELESSLY]\n",
  "CAUSELESSLY": "CAUSELESS, without a cause [adv]\n",
  "CAUSELESSNESS": "the state of being causeless [n -ES]\n",
  "CAUSELESSNESSES": "CAUSELESSNESS, the state of being causeless [n]\n",
  "CAUSEN": "(Spenser) to cause (no separate inflections) [v]\n",
  "CAUSER": "one who causes [n -S]\n",
  "CAUSERIE": "(French) a light and informal conversation; a brief, conversational essay [n -S]\n",
  "CAUSERIES": "CAUSERIE, (French) a light and informal conversation; a brief, conversational essay [n]\n",
  "CAUSERS": "CAUSER, one who causes [n]\n",
  "CAUSES": "CAUSE, to bring about [v]\n",
  "CAUSEWAY": "to build a raised roadway over [v -ED, -ING, -S]\n",
  "CAUSEWAYED": "CAUSEWAY, to build a raised roadway over [v]\n",
  "CAUSEWAYING": "CAUSEWAY, to build a raised roadway over [v]\n",
  "CAUSEWAYS": "CAUSEWAY, to build a raised roadway over [v]\n",
  "CAUSEY": "a causeway, also CORSEY [n -S]\n",
  "CAUSEYED": "having a paved road [adj]\n",
  "CAUSEYS": "CAUSEY, a causeway, also CORSEY [n]\n",
  "CAUSING": "CAUSE, to bring about [v]\n",
  "CAUSTIC": "burning, also CAUSTICAL [adj CAUSTICALLY] / a caustic substance [n -S]\n",
  "CAUSTICAL": "burning, also CAUSTIC [adj CAUSTICALLY]\n",
  "CAUSTICALLY": "CAUSTICAL, burning, also CAUSTIC [adv]\n",
  "CAUSTICITIES": "CAUSTICITY, the state of being caustic [n]\n",
  "CAUSTICITY": "the state of being caustic [n CAUSTICITIES]\n",
  "CAUSTICNESS": "the quality of being caustic [n -ES]\n",
  "CAUSTICNESSES": "CAUSTICNESS, the quality of being caustic [n]\n",
  "CAUSTICS": "CAUSTIC, a caustic substance [n]\n",
  "CAUTEL": "(Shakespeare) cunning; caution [n -S]\n",
  "CAUTELOUS": "(obsolete) cautious, prudent [adj]\n",
  "CAUTELS": "CAUTEL, (Shakespeare) cunning; caution [n]\n",
  "CAUTER": "a hot iron for searing or cauterizing [n -S]\n",
  "CAUTERANT": "a cauterizing substance [n -S]\n",
  "CAUTERANTS": "CAUTERANT, a cauterizing substance [n]\n",
  "CAUTERIES": "CAUTERY, something used to destroy tissue [n]\n",
  "CAUTERISATION": "the act of cauterising, also CAUTERIZATION [n -S]\n",
  "CAUTERISATIONS": "CAUTERISATION, the act of cauterising, also CAUTERIZATION [n]\n",
  "CAUTERISE": "to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERIZE [v CAUTERISED, CAUTERISING, CAUTERISES]\n",
  "CAUTERISED": "CAUTERISE, to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERIZE [v]\n",
  "CAUTERISES": "CAUTERISE, to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERIZE [v]\n",
  "CAUTERISING": "CAUTERISE, to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERIZE [v]\n",
  "CAUTERISM": "the use or application of a caustic [n -S]\n",
  "CAUTERISMS": "CAUTERISM, the use or application of a caustic [n]\n",
  "CAUTERIZATION": "the act of cauterizing, also CAUTERISATION [n -S]\n",
  "CAUTERIZATIONS": "CAUTERIZATION, the act of cauterizing, also CAUTERISATION [n]\n",
  "CAUTERIZE": "to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERISE [v CAUTERIZED, CAUTERIZING, CAUTERIZES]\n",
  "CAUTERIZED": "CAUTERIZE, to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERISE [v]\n",
  "CAUTERIZES": "CAUTERIZE, to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERISE [v]\n",
  "CAUTERIZING": "CAUTERIZE, to burn or sear with heat or a caustic substance, esp. in surgical operations, also CAUTERISE [v]\n",
  "CAUTERS": "CAUTER, a hot iron for searing or cauterizing [n]\n",
  "CAUTERY": "something used to destroy tissue [n CAUTERIES]\n",
  "CAUTION": "to warn [v -ED, -ING, -S]\n",
  "CAUTIONARY": "relating to caution [adj]\n",
  "CAUTIONED": "CAUTION, to warn [v]\n",
  "CAUTIONER": "one who cautions [n -S]\n",
  "CAUTIONERS": "CAUTIONER, one who cautions [n]\n",
  "CAUTIONING": "CAUTION, to warn [v]\n",
  "CAUTIONRIES": "CAUTIONRY, in Scots law, the act of giving security for another [n]\n",
  "CAUTIONRY": "in Scots law, the act of giving security for another [n CAUTIONRIES]\n",
  "CAUTIONS": "CAUTION, to warn [v]\n",
  "CAUTIOUS": "exercising prudence [adj CAUTIOUSLY]\n",
  "CAUTIOUSLY": "CAUTIOUS, exercising prudence [adv]\n",
  "CAUTIOUSNESS": "the state of being cautious [n -ES]\n",
  "CAUTIOUSNESSES": "CAUTIOUSNESS, the state of being cautious [n]\n",
  "CAUVES": "CAUF, a coalminer's basket, also CORF [n]\n",
  "CAVA": "(Spanish) a special Spanish wine, used for toasts [n -S]\n",
  "CAVALCADE": "a procession of people on horseback or in vehicles [n -S] / to ride in a cavalcade [v CAVALCADED, CAVALCADING, CAVALCADES]\n",
  "CAVALCADED": "CAVALCADE, to ride in a cavalcade [v]\n",
  "CAVALCADES": "CAVALCADE, to ride in a cavalcade [v]\n",
  "CAVALCADING": "CAVALCADE, to ride in a cavalcade [v]\n",
  "CAVALERO": "a horseman, also CABALLERO [n -S]\n",
  "CAVALEROS": "CAVALERO, a horseman, also CABALLERO [n]\n",
  "CAVALETTI": "(Italian) a series of timber jumps, adjustable in height, for schooling horses, also CAVALLETTI [n]\n",
  "CAVALIER": "careless [adj CAVALIERLY] / to behave haughtily [v -ED, -ING, -S]\n",
  "CAVALIERED": "CAVALIER, to behave haughtily [v]\n",
  "CAVALIERING": "CAVALIER, to behave haughtily [v]\n",
  "CAVALIERISH": "like a cavalier [adj]\n",
  "CAVALIERISM": "the state of being a cavalier [n -S]\n",
  "CAVALIERISMS": "CAVALIERISM, the state of being a cavalier [n]\n",
  "CAVALIERLY": "CAVALIER, careless [adv]\n",
  "CAVALIERS": "CAVALIER, to behave haughtily [v]\n",
  "CAVALLA": "(Portuguese) a large food fish, also CAVALLY [n -S]\n",
  "CAVALLAS": "CAVALLA, (Portuguese) a large food fish, also CAVALLY [n]\n",
  "CAVALLETTI": "a series of timber jumps, adjustable in height, for schooling horses, also CAVALETTI [n]\n",
  "CAVALLIES": "CAVALLY, (Portuguese) a large food fish, also CAVALLA [n]\n",
  "CAVALLY": "(Portuguese) a large food fish, also CAVALLA [n CAVALLIES]\n",
  "CAVALRIES": "CAVALRY, a mobile army unit [n]\n",
  "CAVALRY": "a mobile army unit [n CAVALRIES]\n",
  "CAVALRYMAN": "a cavalry soldier [n CAVALRYMEN]\n",
  "CAVALRYMEN": "CAVALRYMAN, a cavalry soldier [n]\n",
  "CAVAS": "CAVA, (Spanish) a special Spanish wine, used for toasts [n]\n",
  "CAVASS": "(Turkish) an armed attendant in Turkey, also KAVASS [n -ES]\n",
  "CAVASSES": "CAVASS, (Turkish) an armed attendant in Turkey, also KAVASS [n]\n",
  "CAVATINA": "(Italian) a short operatic air [n CAVATINE or CAVATINAS]\n",
  "CAVATINAS": "CAVATINA, (Italian) a short operatic air [n]\n",
  "CAVATINE": "CAVATINA, (Italian) a short operatic air [n]\n",
  "CAVE": "to hollow out [v CAVED, CAVING, CAVES]\n",
  "CAVEAT": "(Latin) to enter a type of legal notice [v -ED, -ING, -S]\n",
  "CAVEATED": "CAVEAT, (Latin) to enter a type of legal notice [v]\n",
  "CAVEATING": "CAVEAT, (Latin) to enter a type of legal notice [v]\n",
  "CAVEATOR": "one that files a caveat [n -S]\n",
  "CAVEATORS": "CAVEATOR, one that files a caveat [n]\n",
  "CAVEATS": "CAVEAT, (Latin) to enter a type of legal notice [v]\n",
  "CAVED": "CAVE, to hollow out [v]\n",
  "CAVEFISH": "a fish that lives in a cave, and is often blind [n -ES]\n",
  "CAVEFISHES": "CAVEFISH, a fish that lives in a cave, and is often blind [n]\n",
  "CAVEL": "(New Zealand) a drawing of lots among miners for an easy and profitable place at the coalface, also KEVEL, KEVIL [n -S]\n",
  "CAVELIKE": "like an underground chamber [adj]\n",
  "CAVELS": "CAVEL, (New Zealand) a drawing of lots among miners for an easy and profitable place at the coalface, also KEVEL, KEVIL [n]\n",
  "CAVEMAN": "a cave dweller [n CAVEMEN]\n",
  "CAVEMEN": "CAVEMAN, a cave dweller [n]\n",
  "CAVENDISH": "leaf tobacco softened, sweetened, and pressed into plugs or cakes [n -ES]\n",
  "CAVENDISHES": "CAVENDISH, leaf tobacco softened, sweetened, and pressed into plugs or cakes [n]\n",
  "CAVEOLA": "a tiny pit in a cell membrane [n CAVEOLAE]\n",
  "CAVEOLAE": "CAVEOLA, a tiny pit in a cell membrane [n]\n",
  "CAVEOLAR": "relating to a caveola, a tiny pit in a cell membrane [adj]\n",
  "CAVER": "one who explores caves [n -S]\n",
  "CAVERN": "to hollow out [v -ED, -ING, -S]\n",
  "CAVERNED": "CAVERN, to hollow out [v]\n",
  "CAVERNICOLOUS": "cave-dwelling [adj]\n",
  "CAVERNING": "CAVERN, to hollow out [v]\n",
  "CAVERNOUS": "large and empty, like a cavern [adj CAVERNOUSLY]\n",
  "CAVERNOUSLY": "CAVERNOUS, large and empty, like a cavern [adv]\n",
  "CAVERNS": "CAVERN, to hollow out [v]\n",
  "CAVERNULOUS": "full of small cavities or holes [adj]\n",
  "CAVERS": "CAVER, one who explores caves [n]\n",
  "CAVES": "CAVE, to hollow out [v]\n",
  "CAVESSON": "(French) a noseband for a horse [n -S]\n",
  "CAVESSONS": "CAVESSON, (French) a noseband for a horse [n]\n",
  "CAVETTI": "CAVETTO, (Italian) a concave moulding [n]\n",
  "CAVETTO": "(Italian) a concave moulding [n CAVETTOS or CAVETTI]\n",
  "CAVETTOS": "CAVETTO, (Italian) a concave moulding [n]\n",
  "CAVIAR": "the roe of sturgeon, also CAVIARE, CAVIARIE, CAVIER [n -S]\n",
  "CAVIARE": "the roe of sturgeon, also CAVIAR, CAVIARIE, CAVIER [n -S]\n",
  "CAVIARES": "CAVIARE, the roe of sturgeon, also CAVIAR, CAVIARIE, CAVIER [n]\n",
  "CAVIARIE": "(Shakespeare) caviar, also CAVIAR, CAVIARE, CAVIER [n -S]\n",
  "CAVIARIES": "CAVIARIE, (Shakespeare) caviar, also CAVIAR, CAVIARE, CAVIER [n]\n",
  "CAVIARS": "CAVIAR, the roe of sturgeon, also CAVIARE, CAVIARIE, CAVIER [n]\n",
  "CAVICORN": "hollow-horned [adj] / an animal of the Bovidae [n -S]\n",
  "CAVICORNS": "CAVICORN, an animal of the Bovidae [n]\n",
  "CAVIE": "(Scots) a hencoop or cage, also KEAVIE [n -S]\n",
  "CAVIER": "(obsolete) salted roe of sturgeon, also CAVIAR, CAVIARE, CAVIARIE [n -S]\n",
  "CAVIERS": "CAVIER, (obsolete) salted roe of sturgeon, also CAVIAR, CAVIARE, CAVIARIE [n]\n",
  "CAVIES": "CAVY, a kind of South American rodent [n]\n",
  "CAVIL": "to raise trivial and frivolous objections [v CAVILED or CAVILLED, CAVILING or CAVILLING, CAVILS]\n",
  "CAVILED": "CAVIL, to raise trivial and frivolous objections [v]\n",
  "CAVILER": "one that cavils, also CAVILLER [n -S]\n",
  "CAVILERS": "CAVILER, one that cavils, also CAVILLER [n]\n",
  "CAVILING": "CAVIL, to raise trivial and frivolous objections [v]\n",
  "CAVILLATION": "cavilling, making petty objections [n -S]\n",
  "CAVILLATIONS": "CAVILLATION, cavilling, making petty objections [n]\n",
  "CAVILLED": "CAVIL, to raise trivial and frivolous objections [v]\n",
  "CAVILLER": "one that cavils, also CAVILER [n -S]\n",
  "CAVILLERS": "CAVILLER, one that cavils, also CAVILER [n]\n",
  "CAVILLING": "raising trivial and frivolous objections [n -S]\n",
  "CAVILLINGS": "CAVILLING, raising trivial and frivolous objections [n]\n",
  "CAVILS": "CAVIL, to raise trivial and frivolous objections [v]\n",
  "CAVING": "the sport of exploring caves [n -S]\n",
  "CAVINGS": "CAVING, the sport of exploring caves [n]\n",
  "CAVITARY": "pertaining to the formation of cavities in tissue [adj]\n",
  "CAVITATE": "to form cavities [v CAVITATED, CAVITATING, CAVITATES]\n",
  "CAVITATED": "CAVITATE, to form cavities [v]\n",
  "CAVITATES": "CAVITATE, to form cavities [v]\n",
  "CAVITATING": "CAVITATE, to form cavities [v]\n",
  "CAVITATION": "the formation of cavities in a structure, or of gas bubbles in a liquid [n -S]\n",
  "CAVITATIONS": "CAVITATION, the formation of cavities in a structure, or of gas bubbles in a liquid [n]\n",
  "CAVITIED": "having a cavity [adj]\n",
  "CAVITIES": "CAVITY, an unfilled space within a mass [n]\n",
  "CAVITY": "an unfilled space within a mass [n CAVITIES]\n",
  "CAVORT": "to prance, caper about [v -ED, -ING, -S]\n",
  "CAVORTED": "CAVORT, to prance, caper about [v]\n",
  "CAVORTER": "one who cavorts [n -S]\n",
  "CAVORTERS": "CAVORTER, one who cavorts [n]\n",
  "CAVORTING": "the act of prancing about [n -S]\n",
  "CAVORTINGS": "CAVORTING, the act of prancing about [n]\n",
  "CAVORTS": "CAVORT, to prance, caper about [v]\n",
  "CAVY": "a kind of South American rodent [n CAVIES]\n",
  "CAW": "to cry like a crow, also KAW [v -ED, -ING, -S]\n",
  "CAWED": "CAW, to cry like a crow, also KAW [v]\n",
  "CAWING": "the sound rooks make [n -S]\n",
  "CAWINGS": "CAWING, the sound rooks make [n]\n",
  "CAWK": "an opaque, compact variety of barite, or heavy spar, also CAUK [n -S]\n",
  "CAWKER": "a pointed piece on a horseshoe to prevent slipping, also CALK, CALKER, CALKIN [n -S]\n",
  "CAWKERS": "CAWKER, a pointed piece on a horseshoe to prevent slipping, also CALK, CALKER, CALKIN [n]\n",
  "CAWKS": "CAWK, an opaque, compact variety of barite, or heavy spar, also CAUK [n]\n",
  "CAWS": "CAW, to cry like a crow, also KAW [v]\n",
  "CAXON": "(historical) a kind of wig [n -S]\n",
  "CAXONS": "CAXON, (historical) a kind of wig [n]\n",
  "CAY": "a small low island of coral, sand etc. [n -S]\n",
  "CAYENNE": "a very strong pungent red pepper [n -S]\n",
  "CAYENNED": "containing cayenne [adj]\n",
  "CAYENNES": "CAYENNE, a very strong pungent red pepper [n]\n",
  "CAYMAN": "the South American alligator, also CAIMAN [n -S]\n",
  "CAYMANS": "CAYMAN, the South American alligator, also CAIMAN [n]\n",
  "CAYS": "CAY, a small low island of coral, sand etc. [n]\n",
  "CAYUSE": "(Native American) an Indian pony [n -S]\n",
  "CAYUSES": "CAYUSE, (Native American) an Indian pony [n]\n",
  "CAZ": "(slang) casual, also CAZH [adj]\n",
  "CAZH": "(slang) casual, also CAZ [adj]\n",
  "CAZIQUE": "(Taino) a West Indian or American Indian chief, also CACIQUE [n -S]\n",
  "CAZIQUES": "CAZIQUE, (Taino) a West Indian or American Indian chief, also CACIQUE [n]\n",
  "CEANOTHUS": "(Greek) a shrub with blue flowers [n -ES]\n",
  "CEANOTHUSES": "CEANOTHUS, (Greek) a shrub with blue flowers [n]\n",
  "CEAS": "(Shakespeare) enough said, also CAESE, SESE, SESEY, SESSA [interj]\n",
  "CEASE": "to stop [v CEASED, CEASING, CEASES]\n",
  "CEASED": "CEASE, to stop [v]\n",
  "CEASEFIRE": "a cessation of firing [n -S]\n",
  "CEASEFIRES": "CEASEFIRE, a cessation of firing [n]\n",
  "CEASELESS": "without cease [adj CEASELESSLY]\n",
  "CEASELESSLY": "CEASELESS, without cease [adv]\n",
  "CEASELESSNESS": "CEASELESS, without cease [n]\n",
  "CEASELESSNESSES": "CEASELESSNESS, CEASELESS, without cease [n]\n",
  "CEASES": "CEASE, to stop [v]\n",
  "CEASING": "an order to cease firing [n -S]\n",
  "CEASINGS": "CEASING, an order to cease firing [n]\n",
  "CEAZE": "(obsolete) to seize [v CEAZED, CEAZING, CEAZES]\n",
  "CEAZED": "CEAZE, (obsolete) to seize [v]\n",
  "CEAZES": "CEAZE, (obsolete) to seize [v]\n",
  "CEAZING": "CEAZE, (obsolete) to seize [v]\n",
  "CEBADILLA": "(Spanish) a liliaceous plant, yielding the alkaloid veratrine, also CEVADILLA, SABADILLA [n -S]\n",
  "CEBADILLAS": "CEBADILLA, (Spanish) a liliaceous plant, yielding the alkaloid veratrine, also CEVADILLA, SABADILLA [n]\n",
  "CEBID": "one of a family of monkeys, also CEBOID [n -S]\n",
  "CEBIDS": "CEBID, one of a family of monkeys, also CEBOID [n]\n",
  "CEBOID": "one of a family of monkeys, also CEBID [n -S]\n",
  "CEBOIDS": "CEBOID, one of a family of monkeys, also CEBID [n]\n",
  "CECA": "CECUM, (Latin) a bodily cavity with one opening, also CAECUM [n]\n",
  "CECAL": "pertaining to a cecum, a part of the intestine [adj CECALLY]\n",
  "CECALLY": "CECAL, pertaining to a cecum, a part of the intestine [adv]\n",
  "CECILS": "fried meatballs [n]\n",
  "CECITIES": "CECITY, blindness [n]\n",
  "CECITIS": "a caecum inflammation, also CAECITIS [n -ES]\n",
  "CECITISES": "CECITIS, a caecum inflammation, also CAECITIS [n]\n",
  "CECITY": "blindness [n CECITIES]\n",
  "CECROPIA": "a fast-growing tropical American tree of the mulberry family [n -S]\n",
  "CECROPIAS": "CECROPIA, a fast-growing tropical American tree of the mulberry family [n]\n",
  "CECROPIN": "a peptide with antibacterial properties, originally obtained from the cecropia moth [n -S]\n",
  "CECROPINS": "CECROPIN, a peptide with antibacterial properties, originally obtained from the cecropia moth [n]\n",
  "CECUM": "(Latin) a bodily cavity with one opening, also CAECUM [n CECA]\n",
  "CECUTIENCIES": "CECUTIENCY, a tendency to blindness [n]\n",
  "CECUTIENCY": "a tendency to blindness [n CECUTIENCIES]\n",
  "CEDAR": "a large evergreen coniferous tree [n -S]\n",
  "CEDARBIRD": "the cedar waxwing [n -S]\n",
  "CEDARBIRDS": "CEDARBIRD, the cedar waxwing [n]\n",
  "CEDARED": "covered with cedar [adj]\n",
  "CEDARIER": "CEDARY, of or like cedar [adj]\n",
  "CEDARIEST": "CEDARY, of or like cedar [adj]\n",
  "CEDARN": "of cedar [adj]\n",
  "CEDARS": "CEDAR, a large evergreen coniferous tree [n]\n",
  "CEDARWOOD": "the wood of the cedar [n -S]\n",
  "CEDARWOODS": "CEDARWOOD, the wood of the cedar [n]\n",
  "CEDARY": "of or like cedar [adj CEDARIER, CEDARIEST]\n",
  "CEDE": "to yield [v CEDED, CEDING, CEDES]\n",
  "CEDED": "CEDE, to yield [v]\n",
  "CEDER": "one who cedes [n -S]\n",
  "CEDERS": "CEDER, one who cedes [n]\n",
  "CEDES": "CEDE, to yield [v]\n",
  "CEDI": "a monetary unit of Ghana [n -S]\n",
  "CEDILLA": "(Spanish) a mark placed under the letter c, to show that it is to be sounded like s, as in facade [n -S]\n",
  "CEDILLAS": "CEDILLA, (Spanish) a mark placed under the letter c, to show that it is to be sounded like s, as in facade [n]\n",
  "CEDING": "CEDE, to yield [v]\n",
  "CEDIS": "CEDI, a monetary unit of Ghana [n]\n",
  "CEDRATE": "a variety of citron or lemon [n -S]\n",
  "CEDRATES": "CEDRATE, a variety of citron or lemon [n]\n",
  "CEDRELACEOUS": "belonging to the Cedrela family, a tropical genus allied to mahogany [adj]\n",
  "CEDRINE": "belonging to the cedar-tree [adj]\n",
  "CEDULA": "(Spanish) a South American promissory note or mortgage bond on land [n -S]\n",
  "CEDULAS": "CEDULA, (Spanish) a South American promissory note or mortgage bond on land [n]\n",
  "CEE": "the letter C [n -S]\n",
  "CEES": "CEE, the letter C [n]\n",
  "CEIBA": "(Spanish) a genus of tropical trees, including the silk-cotton tree [n -S]\n",
  "CEIBAS": "CEIBA, (Spanish) a genus of tropical trees, including the silk-cotton tree [n]\n",
  "CEIL": "to furnish with a ceiling [v -ED, -ING, -S]\n",
  "CEILED": "CEIL, to furnish with a ceiling [v]\n",
  "CEILER": "one that ceils [n -S]\n",
  "CEILERS": "CEILER, one that ceils [n]\n",
  "CEILI": "(Gaelic) an informal gathering with music, dancing etc., also CEILIDH [n -S]\n",
  "CEILIDH": "(Gaelic) an informal gathering with music, dancing etc., also CEILI [n -S]\n",
  "CEILIDHS": "CEILIDH, (Gaelic) an informal gathering with music, dancing etc., also CEILI [n]\n",
  "CEILING": "the overhead lining of a room [n -S]\n",
  "CEILINGED": "having a ceiling [adj]\n",
  "CEILINGS": "CEILING, the overhead lining of a room [n]\n",
  "CEILIS": "CEILI, (Gaelic) an informal gathering with music, dancing etc., also CEILIDH [n]\n",
  "CEILOMETER": "an instrument for measuring height of cloud ceiling above earth [n -S]\n",
  "CEILOMETERS": "CEILOMETER, an instrument for measuring height of cloud ceiling above earth [n]\n",
  "CEILS": "CEIL, to furnish with a ceiling [v]\n",
  "CEINTURE": "(French) a belt for the waist [n -S]\n",
  "CEINTURES": "CEINTURE, (French) a belt for the waist [n]\n",
  "CEL": "(short for) celluloid, a celluloid frame of an animated cartoon [n -S]\n",
  "CELADON": "a pale green colour; a kind of pale green glazed pottery [n -S]\n",
  "CELADONS": "CELADON, a pale green colour; a kind of pale green glazed pottery [n]\n",
  "CELANDINE": "either of two plants (greater celandine and lesser celandine) supposed to flower when the swallows came, and to perish when they went [n -S]\n",
  "CELANDINES": "CELANDINE, either of two plants (greater celandine and lesser celandine) supposed to flower when the swallows came, and to perish when they went [n]\n",
  "CELEB": "(short for) a celebrity [n -S]\n",
  "CELEBRANT": "a person who celebrates; the principal person officiating at a rite or ceremony [n -S]\n",
  "CELEBRANTS": "CELEBRANT, a person who celebrates; the principal person officiating at a rite or ceremony [n]\n",
  "CELEBRATE": "to mark by solemn ceremonies [v CELEBRATED, CELEBRATING, CELEBRATES]\n",
  "CELEBRATED": "CELEBRATE, to mark by solemn ceremonies [v]\n",
  "CELEBRATEDNESS": "the state of being celebrated [n]\n",
  "CELEBRATES": "CELEBRATE, to mark by solemn ceremonies [v]\n",
  "CELEBRATING": "CELEBRATE, to mark by solemn ceremonies [v]\n",
  "CELEBRATION": "the act of celebrating [n -S]\n",
  "CELEBRATIONS": "CELEBRATION, the act of celebrating [n]\n",
  "CELEBRATIVE": "relating to celebration [adj]\n",
  "CELEBRATOR": "one who celebrates [n -S]\n",
  "CELEBRATORS": "CELEBRATOR, one who celebrates [n]\n",
  "CELEBRATORY": "serving to celebrate [adj]\n",
  "CELEBREALITIES": "CELEBREALITY, a television genre that is unscripted and involves either the day-to-day documentation of a celebrity's life or competitive challenges that a celebrity or celebrities must perform [n]\n",
  "CELEBREALITY": "a television genre that is unscripted and involves either the day-to-day documentation of a celebrity's life or competitive challenges that a celebrity or celebrities must perform [n CELEBREALITIES]\n",
  "CELEBRITIES": "CELEBRITY, a well-known person [n]\n",
  "CELEBRITY": "a well-known person [n CELEBRITIES]\n",
  "CELEBS": "CELEB, (short for) a celebrity [n]\n",
  "CELEBUTANTE": "a young woman from a wealthy background who becomes a celebrity [n -S]\n",
  "CELEBUTANTES": "CELEBUTANTE, a young woman from a wealthy background who becomes a celebrity [n]\n",
  "CELECOXIB": "a nonsteroidal anti-inflammatory drug used in the treatment of osteoarthritis, rheumatoid arthritis etc. [n -S]\n",
  "CELECOXIBS": "CELECOXIB, a nonsteroidal anti-inflammatory drug used in the treatment of osteoarthritis, rheumatoid arthritis etc. [n]\n",
  "CELERIAC": "a vegetable, celery with a turnip-like root [n -S]\n",
  "CELERIACS": "CELERIAC, a vegetable, celery with a turnip-like root [n]\n",
  "CELERIES": "CELERY, a plant with edible stalks [n]\n",
  "CELERITIES": "CELERITY, swiftness [n]\n",
  "CELERITY": "swiftness [n CELERITIES]\n",
  "CELERY": "a plant with edible stalks [n CELERIES]\n",
  "CELERYLIKE": "like celery [adj]\n",
  "CELESTA": "(French) a keyboard instrument, also CELESTE [n -S]\n",
  "CELESTAS": "CELESTA, (French) a keyboard instrument, also CELESTE [n]\n",
  "CELESTE": "(French) a keyboard instrument, also CELESTA [n -S]\n",
  "CELESTES": "CELESTE, (French) a keyboard instrument, also CELESTA [n]\n",
  "CELESTIAL": "related to the heavens [adj CELESTIALLY] / a celestial being [n -S]\n",
  "CELESTIALLY": "CELESTIAL, related to the heavens [adv]\n",
  "CELESTIALS": "CELESTIAL, a celestial being [n]\n",
  "CELESTINE": "native strontium sulphate, so named from its occasional delicate blue color, also CELESTITE [n -S]\n",
  "CELESTINES": "CELESTINE, native strontium sulphate, so named from its occasional delicate blue color, also CELESTITE [n]\n",
  "CELESTITE": "native strontium sulphate, so named from its occasional delicate blue color, also CELESTINE [n -S]\n",
  "CELESTITES": "CELESTITE, native strontium sulphate, so named from its occasional delicate blue color, also CELESTINE [n]\n",
  "CELIAC": "one that has a chronic nutritional disturbance [n -S]\n",
  "CELIACS": "CELIAC, one that has a chronic nutritional disturbance [n]\n",
  "CELIBACIES": "CELIBACY, abstention from sexual intercourse [n]\n",
  "CELIBACY": "abstention from sexual intercourse [n CELIBACIES]\n",
  "CELIBATARIAN": "a person who lives in celibacy, advocating celibacy [n -S]\n",
  "CELIBATARIANS": "CELIBATARIAN, a person who lives in celibacy, advocating celibacy [n]\n",
  "CELIBATE": "one who lives a life of celibacy [n -S]\n",
  "CELIBATES": "CELIBATE, one who lives a life of celibacy [n]\n",
  "CELIBATIC": "living without a sexual partner, also CELIBATE [adj]\n",
  "CELL": "to store in a honeycomb [v -ED, -ING, -S]\n",
  "CELLA": "(Latin) the inner chamber of a classical temple [n CELLAE]\n",
  "CELLAE": "CELLA, (Latin) the inner chamber of a classical temple [n]\n",
  "CELLAR": "to store in an underground room [v -ED, -ING, -S]\n",
  "CELLARAGE": "the space or storerooms of a cellar [n -S]\n",
  "CELLARAGES": "CELLARAGE, the space or storerooms of a cellar [n]\n",
  "CELLARED": "CELLAR, to store in an underground room [v]\n",
  "CELLARER": "a monastery official in charge of provisions, also CELLARIST [n -S]\n",
  "CELLARERS": "CELLARER, a monastery official in charge of provisions, also CELLARIST [n]\n",
  "CELLARET": "a cabinet for wine bottles [n -S]\n",
  "CELLARETS": "CELLARET, a cabinet for wine bottles [n]\n",
  "CELLARETTE": "a case or drawer for holding wine bottles, also CELLARET [n -S]\n",
  "CELLARETTES": "CELLARETTE, a case or drawer for holding wine bottles, also CELLARET [n]\n",
  "CELLARING": "CELLAR, to store in an underground room [v]\n",
  "CELLARIST": "a monastery official in charge of provisions, also CELLARER [n -S]\n",
  "CELLARISTS": "CELLARIST, a monastery official in charge of provisions, also CELLARER [n]\n",
  "CELLARMAN": "a person responsible for a cellar [n CELLARMEN]\n",
  "CELLARMEN": "CELLARMAN, a person responsible for a cellar [n]\n",
  "CELLAROUS": "(Dickens) belonging to a cellar; sunken, cavernous [adj]\n",
  "CELLARS": "CELLAR, to store in an underground room [v]\n",
  "CELLARWAY": "a way into a cellar [n -S]\n",
  "CELLARWAYS": "CELLARWAY, a way into a cellar [n]\n",
  "CELLBLOCK": "a group of prison cells [n -S]\n",
  "CELLBLOCKS": "CELLBLOCK, a group of prison cells [n]\n",
  "CELLED": "CELL, to store in a honeycomb [v]\n",
  "CELLENTANI": "a type of pasta [n -S]\n",
  "CELLENTANIS": "CELLENTANI, a type of pasta [n]\n",
  "CELLI": "CELLO, a stringed musical instrument [n]\n",
  "CELLIFEROUS": "bearing cells [adj]\n",
  "CELLING": "the act of storing in a honeycomb [n -S]\n",
  "CELLINGS": "CELLING, the act of storing in a honeycomb [n]\n",
  "CELLIST": "one who plays the cello [n -S]\n",
  "CELLISTS": "CELLIST, one who plays the cello [n]\n",
  "CELLMATE": "the person or persons sharing a prison cell [n -S]\n",
  "CELLMATES": "CELLMATE, the person or persons sharing a prison cell [n]\n",
  "CELLO": "a stringed musical instrument [n CELLOS or CELLI]\n",
  "CELLOBIOSE": "a disaccharide obtained by hydrolysis of cellulose, also CELLOSE [n -S]\n",
  "CELLOBIOSES": "CELLOBIOSE, a disaccharide obtained by hydrolysis of cellulose, also CELLOSE [n]\n",
  "CELLOIDIN": "a purified pyroxylin used chiefly in microscopy [n -S]\n",
  "CELLOIDINS": "CELLOIDIN, a purified pyroxylin used chiefly in microscopy [n]\n",
  "CELLOPHANE": "(tradename) a tough transparent wrapping material [n -S]\n",
  "CELLOPHANES": "CELLOPHANE, (tradename) a tough transparent wrapping material [n]\n",
  "CELLOS": "CELLO, a stringed musical instrument [n]\n",
  "CELLOSE": "a disaccharide obtained by hydrolysis of cellulose, also CELLOBIOSE [n -S]\n",
  "CELLOSES": "CELLOSE, a disaccharide obtained by hydrolysis of cellulose, also CELLOBIOSE [n]\n",
  "CELLPHONE": "a portable telephone for use in a cellular radio system [n -S]\n",
  "CELLPHONES": "CELLPHONE, a portable telephone for use in a cellular radio system [n]\n",
  "CELLS": "CELL, to store in a honeycomb [v]\n",
  "CELLULAR": "pertaining to a cell [adj] / a mobile phone [n -S]\n",
  "CELLULARITIES": "CELLULARITY, the state of being cellular [n]\n",
  "CELLULARITY": "the state of being cellular [n CELLULARITIES]\n",
  "CELLULARS": "CELLULAR, a mobile phone [n]\n",
  "CELLULASE": "an enzyme that can split cellulose into glucose, present in organisms in the guts of animals and in the leaf stalks of higher plants [n -S]\n",
  "CELLULASES": "CELLULASE, an enzyme that can split cellulose into glucose, present in organisms in the guts of animals and in the leaf stalks of higher plants [n]\n",
  "CELLULATED": "cellular [adj]\n",
  "CELLULE": "a small cell [n -S]\n",
  "CELLULES": "CELLULE, a small cell [n]\n",
  "CELLULIFEROUS": "bearing little cells [adj]\n",
  "CELLULITE": "fatty tissue below the skin [n -S]\n",
  "CELLULITES": "CELLULITE, fatty tissue below the skin [n]\n",
  "CELLULITIS": "an inflammation of the cellular or areolar tissue, esp. of that lying immediately beneath the skin [n -ES]\n",
  "CELLULITISES": "CELLULITIS, an inflammation of the cellular or areolar tissue, esp. of that lying immediately beneath the skin [n]\n",
  "CELLULOID": "(tradename) a type of thermoplastic [n -S]\n",
  "CELLULOIDS": "CELLULOID, (tradename) a type of thermoplastic [n]\n",
  "CELLULOLYTIC": "hydrolyzing or having the capacity to hydrolyze cellulose [adj]\n",
  "CELLULOSE": "a carbohydrate forming the chief component of cell walls in plants and in wood [n -S]\n",
  "CELLULOSES": "CELLULOSE, a carbohydrate forming the chief component of cell walls in plants and in wood [n]\n",
  "CELLULOSIC": "plastic made from cellulose [n -S]\n",
  "CELLULOSICS": "CELLULOSIC, plastic made from cellulose [n]\n",
  "CELLULOUS": "of or like cellulose [adj]\n",
  "CELOM": "(Greek) a body cavity in some animals, also COELOM, COELOME [n CELOMS or CELOMATA]\n",
  "CELOMATA": "CELOM, (Greek) a body cavity in some animals, also COELOM, COELOME [n]\n",
  "CELOMIC": "relating to a celom, also COELOMIC [adj]\n",
  "CELOMS": "CELOM, (Greek) a body cavity in some animals, also COELOM, COELOME [n]\n",
  "CELOSIA": "an ornamental plant of the amaranth family [n -S]\n",
  "CELOSIAS": "CELOSIA, an ornamental plant of the amaranth family [n]\n",
  "CELOTEX": "a building board that is employed as insulation or paneling [n -ES]\n",
  "CELOTEXES": "CELOTEX, a building board that is employed as insulation or paneling [n]\n",
  "CELS": "CEL, (short for) celluloid, a celluloid frame of an animated cartoon [n]\n",
  "CELSITUDE": "loftiness [n -S]\n",
  "CELSITUDES": "CELSITUDE, loftiness [n]\n",
  "CELT": "a prehistoric stone axehead [n -S]\n",
  "CELTS": "CELT, a prehistoric stone axehead [n]\n",
  "CEMBALI": "CEMBALO, (Italian) a harpsichord [n]\n",
  "CEMBALIST": "a person who plays a cembalo [n -S]\n",
  "CEMBALISTS": "CEMBALIST, a person who plays a cembalo [n]\n",
  "CEMBALO": "(Italian) a harpsichord [n CEMBALOS or CEMBALI]\n",
  "CEMBALOS": "CEMBALO, (Italian) a harpsichord [n]\n",
  "CEMBRA": "the Swiss stone-pine [n -S]\n",
  "CEMBRAS": "CEMBRA, the Swiss stone-pine [n]\n",
  "CEMENT": "to bind firmly [v -ED, -ING, -S]\n",
  "CEMENTA": "CEMENTUM, (Latin) the hard tissue covering the roots of the teeth [n]\n",
  "CEMENTATION": "the act of cementing [n -S]\n",
  "CEMENTATIONS": "CEMENTATION, the act of cementing [n]\n",
  "CEMENTATORY": "having the quality of cementing or uniting firmly, also CEMENTITIOUS [adj]\n",
  "CEMENTED": "CEMENT, to bind firmly [v]\n",
  "CEMENTER": "a person or thing that cements [n -S]\n",
  "CEMENTERS": "CEMENTER, a person or thing that cements [n]\n",
  "CEMENTING": "CEMENT, to bind firmly [v]\n",
  "CEMENTITE": "a compound of iron and carbon found in cast iron [n -S]\n",
  "CEMENTITES": "CEMENTITE, a compound of iron and carbon found in cast iron [n]\n",
  "CEMENTITIOUS": "having the quality of cementing or uniting firmly, also CEMENTATORY [adj]\n",
  "CEMENTS": "CEMENT, to bind firmly [v]\n",
  "CEMENTUM": "(Latin) the hard tissue covering the roots of the teeth [n CEMENTUMS or CEMENTA]\n",
  "CEMENTUMS": "CEMENTUM, (Latin) the hard tissue covering the roots of the teeth [n]\n",
  "CEMETERIES": "CEMETERY, a burial ground [n]\n",
  "CEMETERY": "a burial ground [n CEMETERIES]\n",
  "CEMITARE": "(Spenser) a scimitar, also SCIMETAR, SCIMITAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n -S]\n",
  "CEMITARES": "CEMITARE, (Spenser) a scimitar, also SCIMETAR, SCIMITAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n]\n",
  "CENACLE": "a dining room, also COENACLE [n -S]\n",
  "CENACLES": "CENACLE, a dining room, also COENACLE [n]\n",
  "CENDRE": "(French) ash-blond [adj]\n",
  "CENESTHESES": "CENESTHESIS, general consciousness or awareness of one's body, also CENESTHESIA, COENAESTHESIA, COENAESTHESIS, COENESTHESIA [n]\n",
  "CENESTHESIA": "general consciousness or awareness of one's body, also CENESTHESIS, COENAESTHESIA, COENAESTHESIS, COENESTHESIA [n -S]\n",
  "CENESTHESIAS": "CENESTHESIA, general consciousness or awareness of one's body, also CENESTHESIS, COENAESTHESIA, COENAESTHESIS, COENESTHESIA [n]\n",
  "CENESTHESIS": "general consciousness or awareness of one's body, also CENESTHESIA, COENAESTHESIA, COENAESTHESIS, COENESTHESIA [n CENESTHESES]\n",
  "CENESTHETIC": "relating to cenesthesia [adj]\n",
  "CENOBITE": "a monk who lives in a community, also COENOBITE [n -S]\n",
  "CENOBITES": "CENOBITE, a monk who lives in a community, also COENOBITE [n]\n",
  "CENOBITIC": "of or like a cenobite, also CENOBITICAL, COENOBITIC [adj]\n",
  "CENOBITICAL": "of or like a cenobite, also CENOBITIC, COENOBITIC [adj]\n",
  "CENOGENESES": "CENOGENESIS, the introduction during embryonic development of characters or structure not present in the earlier evolutionary history of the strain or species, also CAENOGENESIS, KAINOGENESIS, KENOGENESIS [n]\n",
  "CENOGENESIS": "the introduction during embryonic development of characters or structure not present in the earlier evolutionary history of the strain or species, also CAENOGENESIS, KAINOGENESIS, KENOGENESIS [n CENOGENESES]\n",
  "CENOGENETIC": "relating to cenogenesis, also CAENOGENETIC, CAINOGENETIC [adj CENOGENETICALLY]\n",
  "CENOGENETICALLY": "CENOGENETIC, relating to cenogenesis, also CAENOGENETIC, CAINOGENETIC [adv]\n",
  "CENOSPECIES": "a species that can interbreed, also COENOSPECIES [n CENOSPECIES]\n",
  "CENOTAPH": "a tomb or monument erected in honor of a person whose body is elsewhere [n -S]\n",
  "CENOTAPHIC": "like a cenotaph [adj]\n",
  "CENOTAPHS": "CENOTAPH, a tomb or monument erected in honor of a person whose body is elsewhere [n]\n",
  "CENOTE": "a deep natural hole in the ground with a pool at the bottom, esp. in the Yucatan peninsula, often used by the Mayas as a place of sacrifice [n -S]\n",
  "CENOTES": "CENOTE, a deep natural hole in the ground with a pool at the bottom, esp. in the Yucatan peninsula, often used by the Mayas as a place of sacrifice [n]\n",
  "CENOZOIC": "relating to the most recent geologic era [adj]\n",
  "CENS": "(French) a nominal annual payment given to the owner of an estate or property in recognition of his or her title [n]\n",
  "CENSE": "to perfume with incense [v CENSED, CENSING, CENSES]\n",
  "CENSED": "CENSE, to perfume with incense [v]\n",
  "CENSER": "a vessel for burning incense [n -S]\n",
  "CENSERS": "CENSER, a vessel for burning incense [n]\n",
  "CENSES": "CENSE, to perfume with incense [v]\n",
  "CENSING": "CENSE, to perfume with incense [v]\n",
  "CENSOR": "to delete a word or passage [v -ED, -ING, -S]\n",
  "CENSORABLE": "able to be censored [adj]\n",
  "CENSORED": "CENSOR, to delete a word or passage [v]\n",
  "CENSORIAL": "pertaining to a censor, or to the correction of public morals, also CENSORIAN [adj]\n",
  "CENSORIAN": "pertaining to a censor, or to the correction of public morals, also CENSORIAL [adj]\n",
  "CENSORING": "CENSOR, to delete a word or passage [v]\n",
  "CENSORIOUS": "given to censure [adj CENSORIOUSLY]\n",
  "CENSORIOUSLY": "CENSORIOUS, given to censure [adv]\n",
  "CENSORIOUSNESS": "CENSORIOUS, given to censure [n]\n",
  "CENSORS": "CENSOR, to delete a word or passage [v]\n",
  "CENSORSHIP": "the institution, system, or practice of censoring [n -S]\n",
  "CENSORSHIPS": "CENSORSHIP, the institution, system, or practice of censoring [n]\n",
  "CENSUAL": "pertaining to a census [adj]\n",
  "CENSURABILITIES": "CENSURABILITY, the ability to be censured [n]\n",
  "CENSURABILITY": "the ability to be censured [n CENSURABILITIES]\n",
  "CENSURABLE": "worthy of censure [adj CENSURABLY]\n",
  "CENSURABLENESS": "CENSURABLE, worthy of censure [n]\n",
  "CENSURABLY": "CENSURABLE, worthy of censure [adv]\n",
  "CENSURE": "to condemn as wrong [v CENSURED, CENSURING, CENSURES]\n",
  "CENSURED": "CENSURE, to condemn as wrong [v]\n",
  "CENSURER": "one who censures [n -S]\n",
  "CENSURERS": "CENSURER, one who censures [n]\n",
  "CENSURES": "CENSURE, to condemn as wrong [v]\n",
  "CENSURING": "CENSURE, to condemn as wrong [v]\n",
  "CENSUS": "(Latin) to take an official count of [v -ED, -ING, -ES]\n",
  "CENSUSED": "CENSUS, (Latin) to take an official count of [v]\n",
  "CENSUSES": "CENSUS, (Latin) to take an official count of [v]\n",
  "CENSUSING": "CENSUS, (Latin) to take an official count of [v]\n",
  "CENT": "a coin worth 1/100th of a dollar [n -S]\n",
  "CENTAGE": "rate by the hundred [n -S]\n",
  "CENTAGES": "CENTAGE, rate by the hundred [n]\n",
  "CENTAI": "CENTAS, a monetary unit of Lithuania [n]\n",
  "CENTAL": "a weight of one hundred pounds avoirdupois [n -S]\n",
  "CENTALS": "CENTAL, a weight of one hundred pounds avoirdupois [n]\n",
  "CENTARE": "a measure of land area, also CENTIARE [n -S]\n",
  "CENTARES": "CENTARE, a measure of land area, also CENTIARE [n]\n",
  "CENTAS": "a monetary unit of Lithuania [n CENTAI]\n",
  "CENTAUR": "(Greek) a mythical creature half-man, half-horse [n -S]\n",
  "CENTAUREA": "a large genus of composite plants, related to the thistles and including the cornflower or bluebottle [n -S]\n",
  "CENTAUREAS": "CENTAUREA, a large genus of composite plants, related to the thistles and including the cornflower or bluebottle [n]\n",
  "CENTAURIAN": "of or like a centaur [adj]\n",
  "CENTAURIC": "integrating mind and body [adj]\n",
  "CENTAURIES": "CENTAURY, a plant of the genus Centaurium, of the gentian family, usually with pink flowers [n]\n",
  "CENTAURS": "CENTAUR, (Greek) a mythical creature half-man, half-horse [n]\n",
  "CENTAURY": "a plant of the genus Centaurium, of the gentian family, usually with pink flowers [n CENTAURIES]\n",
  "CENTAVO": "(Spanish) a Portuguese coin and monetary unit, one hundredth of the standard unit of currency [n -S]\n",
  "CENTAVOS": "CENTAVO, (Spanish) a Portuguese coin and monetary unit, one hundredth of the standard unit of currency [n]\n",
  "CENTENARIAN": "a person who is over one hundred years old [n -S]\n",
  "CENTENARIANISM": "the state of being a centenarian [n -S]\n",
  "CENTENARIANISMS": "CENTENARIANISM, the state of being a centenarian [n]\n",
  "CENTENARIANS": "CENTENARIAN, a person who is over one hundred years old [n]\n",
  "CENTENARIES": "CENTENARY, a hundredth anniversary [n]\n",
  "CENTENARY": "relating to a period of a hundred years [adj] / a hundredth anniversary [n CENTENARIES]\n",
  "CENTENIER": "in Jersey, an honorary part-time police officer with judicial powers [n -S]\n",
  "CENTENIERS": "CENTENIER, in Jersey, an honorary part-time police officer with judicial powers [n]\n",
  "CENTENNIAL": "recurring every hundred years; lasting a hundred years [adj CENTENNIALLY] / a hundredth anniversary [n -S]\n",
  "CENTENNIALLY": "CENTENNIAL, recurring every hundred years; lasting a hundred years [adv]\n",
  "CENTENNIALS": "CENTENNIAL, a hundredth anniversary [n]\n",
  "CENTER": "to place at the middle point [v -ED, -ING, -S]\n",
  "CENTERBOARD": "a retractable keel used esp. in sailboats, also CENTREBOARD [n -S]\n",
  "CENTERBOARDS": "CENTERBOARD, a retractable keel used esp. in sailboats, also CENTREBOARD [n]\n",
  "CENTERED": "CENTER, to place at the middle point [v]\n",
  "CENTEREDNESS": "the state of being centered, also CENTREDNESS [n -ES]\n",
  "CENTEREDNESSES": "CENTEREDNESS, the state of being centered, also CENTREDNESS [n]\n",
  "CENTERFOLD": "the centre pages of a magazine, also CENTREFOLD [n -S]\n",
  "CENTERFOLDS": "CENTERFOLD, the centre pages of a magazine, also CENTREFOLD [n]\n",
  "CENTERING": "a temporary framework for an arch, also CENTRING [n -S]\n",
  "CENTERINGS": "CENTERING, a temporary framework for an arch, also CENTRING [n]\n",
  "CENTERLESS": "without a centre [adj]\n",
  "CENTERLINE": "an often imaginary line that divides a body into two equal halves, also CENTRELINE [n -S]\n",
  "CENTERLINES": "CENTERLINE, an often imaginary line that divides a body into two equal halves, also CENTRELINE [n]\n",
  "CENTERPIECE": "the central feature of a display, also CENTREPIECE [n -S]\n",
  "CENTERPIECES": "CENTERPIECE, the central feature of a display, also CENTREPIECE [n]\n",
  "CENTERS": "CENTER, to place at the middle point [v]\n",
  "CENTESES": "CENTESIS, (Greek) a surgical puncture [n]\n",
  "CENTESIMAL": "counting or counted by hundreds or hundredths [adj CENTESIMALLY] / a hundredth [n -S]\n",
  "CENTESIMALLY": "CENTESIMAL, counting or counted by hundreds or hundredths [adv]\n",
  "CENTESIMALS": "CENTESIMAL, a hundredth [n]\n",
  "CENTESIMI": "CENTESIMO, (Spanish) a copper coin of Italy and Spain equivalent to a centime [n]\n",
  "CENTESIMO": "(Spanish) a copper coin of Italy and Spain equivalent to a centime [n CENTESIMI or CENTESIMOS]\n",
  "CENTESIMOS": "CENTESIMO, (Spanish) a copper coin of Italy and Spain equivalent to a centime [n]\n",
  "CENTESIS": "(Greek) a surgical puncture [n CENTESES]\n",
  "CENTIARE": "a measure of land area, also CENTARE [n -S]\n",
  "CENTIARES": "CENTIARE, a measure of land area, also CENTARE [n]\n",
  "CENTIGRADE": "a temperature scale [n -S]\n",
  "CENTIGRADES": "CENTIGRADE, a temperature scale [n]\n",
  "CENTIGRAM": "1/100th of a gramme, also CENTIGRAMME [n -S]\n",
  "CENTIGRAMME": "1/100th of a gramme, also CENTIGRAM [n -S]\n",
  "CENTIGRAMMES": "CENTIGRAMME, 1/100th of a gramme, also CENTIGRAM [n]\n",
  "CENTIGRAMS": "CENTIGRAM, 1/100th of a gramme, also CENTIGRAMME [n]\n",
  "CENTILE": "a value of a statistical variable [n -S]\n",
  "CENTILES": "CENTILE, a value of a statistical variable [n]\n",
  "CENTILITER": "(US) the hundredth part of a liter, also CENTILITRE [n -S]\n",
  "CENTILITERS": "CENTILITER, (US) the hundredth part of a liter, also CENTILITRE [n]\n",
  "CENTILITRE": "the hundredth part of a liter, also CENTILITER [n -S]\n",
  "CENTILITRES": "CENTILITRE, the hundredth part of a liter, also CENTILITER [n]\n",
  "CENTILLION": "in UK and Germany, the hundredth power of a million, i.e. 1 followed by 600 zeros; in North America and France, the hundred-and-first power of a thousand, i.e. 1 followed by 303 zeros [n -S]\n",
  "CENTILLIONS": "CENTILLION, in UK and Germany, the hundredth power of a million, i.e. 1 followed by 600 zeros; in North America and France, the hundred-and-first power of a thousand, i.e. 1 followed by 303 zeros [n]\n",
  "CENTILLIONTH": "the ordinal of centillion [n -S]\n",
  "CENTILLIONTHS": "CENTILLIONTH, the ordinal of centillion [n]\n",
  "CENTIME": "(French) one hundredth of a franc [n -S]\n",
  "CENTIMES": "CENTIME, (French) one hundredth of a franc [n]\n",
  "CENTIMETER": "one hundredth of a metre, also CENTIMETRE [n -S]\n",
  "CENTIMETERS": "CENTIMETER, one hundredth of a metre, also CENTIMETRE [n]\n",
  "CENTIMETRE": "one hundredth of a metre, also CENTIMETER [n -S]\n",
  "CENTIMETRES": "CENTIMETRE, one hundredth of a metre, also CENTIMETER [n]\n",
  "CENTIMETRIC": "having a wavelength between one and ten centimetres [adj]\n",
  "CENTIMO": "(Spanish) a coin and monetary unit of Spain and South America, one hundredth of the standard unit of currency [n -S]\n",
  "CENTIMORGAN": "one hundredth of a morgan [n -S]\n",
  "CENTIMORGANS": "CENTIMORGAN, one hundredth of a morgan [n]\n",
  "CENTIMOS": "CENTIMO, (Spanish) a coin and monetary unit of Spain and South America, one hundredth of the standard unit of currency [n]\n",
  "CENTINEL": "(obsolete) a sentinel or sentry, also CENTINELL, CENTONEL, CENTONELL, SENTINEL [n -S]\n",
  "CENTINELL": "(obsolete) a sentinel or sentry, also CENTINEL, CENTONEL, CENTONELL, SENTINEL [n -S]\n",
  "CENTINELLS": "CENTINELL, (obsolete) a sentinel or sentry, also CENTINEL, CENTONEL, CENTONELL, SENTINEL [n]\n",
  "CENTINELS": "CENTINEL, (obsolete) a sentinel or sentry, also CENTINELL, CENTONEL, CENTONELL, SENTINEL [n]\n",
  "CENTIPEDE": "any myriapod of the class Chilopoda, carnivorous flattened animals with many segments, each bearing one pair of legs [n -S]\n",
  "CENTIPEDES": "CENTIPEDE, any myriapod of the class Chilopoda, carnivorous flattened animals with many segments, each bearing one pair of legs [n]\n",
  "CENTIPOISE": "one hundredth of a poise, equal to 0.001 newton second per square metre [n -S]\n",
  "CENTIPOISES": "CENTIPOISE, one hundredth of a poise, equal to 0.001 newton second per square metre [n]\n",
  "CENTNER": "(German) an old unit of weight equal to about 110 pounds [n -S]\n",
  "CENTNERS": "CENTNER, (German) an old unit of weight equal to about 110 pounds [n]\n",
  "CENTO": "(Latin) a literary work made up of parts from other works [n CENTOS or CENTONES]\n",
  "CENTOIST": "one who composes centos, poems manufactured by putting together passages of other poems, also CENTONIST [n -S]\n",
  "CENTOISTS": "CENTOIST, one who composes centos, poems manufactured by putting together passages of other poems, also CENTONIST [n]\n",
  "CENTONATE": "a Gregorian chant composed of a patchwork of texts and melodies [n -S]\n",
  "CENTONATES": "CENTONATE, a Gregorian chant composed of a patchwork of texts and melodies [n]\n",
  "CENTONEL": "(Spenser) a sentinel or sentry, also CENTINEL, CENTINELL, CENTONELL, SENTINEL [n -S]\n",
  "CENTONELL": "(Spenser) a sentinel or sentry, also CENTINEL, CENTINELL, CENTONEL, SENTINEL [n -S]\n",
  "CENTONELLS": "CENTONELL, (Spenser) a sentinel or sentry, also CENTINEL, CENTINELL, CENTONEL, SENTINEL [n]\n",
  "CENTONELS": "CENTONEL, (Spenser) a sentinel or sentry, also CENTINEL, CENTINELL, CENTONELL, SENTINEL [n]\n",
  "CENTONES": "CENTO, (Latin) a literary work made up of parts from other works [n]\n",
  "CENTONIST": "one who composes centos, poems manufactured by putting together passages of other poems, also CENTOIST [n -S]\n",
  "CENTONISTS": "CENTONIST, one who composes centos, poems manufactured by putting together passages of other poems, also CENTOIST [n]\n",
  "CENTOS": "CENTO, (Latin) a literary work made up of parts from other works [n]\n",
  "CENTRA": "CENTRUM, (Latin) the body of a vertebra [n]\n",
  "CENTRAL": "a telephone exchange [n -S] / in the middle [adj CENTRALER, CENTRALEST, CENTRALLY]\n",
  "CENTRALER": "CENTRAL, in the middle [adj]\n",
  "CENTRALEST": "CENTRAL, in the middle [adj]\n",
  "CENTRALISATION": "the process of centralising, also CENTRALIZATION [n -S]\n",
  "CENTRALISATIONS": "CENTRALISATION, the process of centralising, also CENTRALIZATION [n]\n",
  "CENTRALISE": "to move to, draw to, or concentrate at a centre, also CENTRALIZE [v CENTRALISED, CENTRALISING, CENTRALISES]\n",
  "CENTRALISED": "CENTRALISE, to move to, draw to, or concentrate at a centre, also CENTRALIZE [v]\n",
  "CENTRALISER": "one who centralises, also CENTRALIZER [n -S]\n",
  "CENTRALISERS": "CENTRALISER, one who centralises, also CENTRALIZER [n]\n",
  "CENTRALISES": "CENTRALISE, to move to, draw to, or concentrate at a centre, also CENTRALIZE [v]\n",
  "CENTRALISING": "CENTRALISE, to move to, draw to, or concentrate at a centre, also CENTRALIZE [v]\n",
  "CENTRALISM": "the tendency or policy of administering by the sovereign or central government matters which would be otherwise under local management [n -S]\n",
  "CENTRALISMS": "CENTRALISM, the tendency or policy of administering by the sovereign or central government matters which would be otherwise under local management [n]\n",
  "CENTRALIST": "an adherent of centralism, the centralization of authority [n -S]\n",
  "CENTRALISTIC": "relating to centralism [adj]\n",
  "CENTRALISTS": "CENTRALIST, an adherent of centralism, the centralization of authority [n]\n",
  "CENTRALITIES": "CENTRALITY, the state of being central [n]\n",
  "CENTRALITY": "the state of being central [n CENTRALITIES]\n",
  "CENTRALIZATION": "the act of centralizing, also CENTRALISATION [n -S]\n",
  "CENTRALIZATIONS": "CENTRALIZATION, the act of centralizing, also CENTRALISATION [n]\n",
  "CENTRALIZE": "to move to, draw to, or concentrate at a centre, also CENTRALISE [v CENTRALIZED, CENTRALIZING, CENTRALIZES]\n",
  "CENTRALIZED": "CENTRALIZE, to move to, draw to, or concentrate at a centre, also CENTRALISE [v]\n",
  "CENTRALIZER": "one who centralizes, also CENTRALISER [n -S]\n",
  "CENTRALIZERS": "CENTRALIZER, one who centralizes, also CENTRALISER [n]\n",
  "CENTRALIZES": "CENTRALIZE, to move to, draw to, or concentrate at a centre, also CENTRALISE [v]\n",
  "CENTRALIZING": "CENTRALIZE, to move to, draw to, or concentrate at a centre, also CENTRALISE [v]\n",
  "CENTRALLY": "CENTRAL, in the middle [adv]\n",
  "CENTRALS": "CENTRAL, a telephone exchange [n]\n",
  "CENTRE": "to make central, also CENTER [v CENTRED, CENTREING, CENTRES]\n",
  "CENTREBOARD": "a retractable keel fitted to small racing yachts and dinghies, also CENTERBOARD [n -S]\n",
  "CENTREBOARDS": "CENTREBOARD, a retractable keel fitted to small racing yachts and dinghies, also CENTERBOARD [n]\n",
  "CENTRED": "CENTRE, to make central, also CENTER [v]\n",
  "CENTREDNESS": "the state of being centred, also CENTEREDNESS [n -ES]\n",
  "CENTREDNESSES": "CENTREDNESS, the state of being centred, also CENTEREDNESS [n]\n",
  "CENTREFOLD": "the centre pages of a magazine, also CENTERFOLD [n -S]\n",
  "CENTREFOLDS": "CENTREFOLD, the centre pages of a magazine, also CENTERFOLD [n]\n",
  "CENTREING": "the framework on which an arch is supported during its construction [n -S]\n",
  "CENTREINGS": "CENTREING, the framework on which an arch is supported during its construction [n]\n",
  "CENTRELESS": "having no centre [adj]\n",
  "CENTRELINE": "an often imaginary line that divides a body into two equal halves, also CENTERLINE [n -S]\n",
  "CENTRELINES": "CENTRELINE, an often imaginary line that divides a body into two equal halves, also CENTERLINE [n]\n",
  "CENTREMAN": "one who plays in the centre position, e.g. in ice hockey [n CENTREMEN]\n",
  "CENTREMEN": "CENTREMAN, one who plays in the centre position, e.g. in ice hockey [n]\n",
  "CENTREPIECE": "a central piece in a display, also CENTERPIECE [n -S]\n",
  "CENTREPIECES": "CENTREPIECE, a central piece in a display, also CENTERPIECE [n]\n",
  "CENTRES": "CENTRE, to make central, also CENTER [v]\n",
  "CENTRIC": "situated at the center [adj CENTRICALLY]\n",
  "CENTRICAL": "placed in the center or middle; central, also CENTRIC [adj CENTRICALLY]\n",
  "CENTRICALLY": "CENTRICAL, placed in the center or middle; central, also CENTRIC [adv]\n",
  "CENTRICALNESS": "CENTRICAL, placed in the center or middle; central, also CENTRIC [n]\n",
  "CENTRICALNESSES": "CENTRICALNESS, CENTRICAL, placed in the center or middle; central, also CENTRIC [n]\n",
  "CENTRICITIES": "CENTRICITY, the state or quality of being centric [n]\n",
  "CENTRICITY": "the state or quality of being centric [n CENTRICITIES]\n",
  "CENTRIES": "CENTRY, (Shakespeare) a centre [n]\n",
  "CENTRIFUGAL": "flying from the centre [adj CENTRIFUGALLY] / a centrifugal machine or a drum in such a machine [n -S]\n",
  "CENTRIFUGALISE": "to subject to centrifugal force, also CENTRIFUGALIZE [v CENTRIFUGALISED, CENTRIFUGALISES]\n",
  "CENTRIFUGALISED": "CENTRIFUGALISE, to subject to centrifugal force, also CENTRIFUGALIZE [v]\n",
  "CENTRIFUGALISES": "CENTRIFUGALISE, to subject to centrifugal force, also CENTRIFUGALIZE [v]\n",
  "CENTRIFUGALIZE": "to subject to centrifugal force, also CENTRIFUGALISE [v CENTRIFUGALIZED, CENTRIFUGALIZES]\n",
  "CENTRIFUGALIZED": "CENTRIFUGALIZE, to subject to centrifugal force, also CENTRIFUGALISE [v]\n",
  "CENTRIFUGALIZES": "CENTRIFUGALIZE, to subject to centrifugal force, also CENTRIFUGALISE [v]\n",
  "CENTRIFUGALLY": "CENTRIFUGAL, flying from the centre [adv]\n",
  "CENTRIFUGALS": "CENTRIFUGAL, a centrifugal machine or a drum in such a machine [n]\n",
  "CENTRIFUGATION": "separation by centrifuge [n -S]\n",
  "CENTRIFUGATIONS": "CENTRIFUGATION, separation by centrifuge [n]\n",
  "CENTRIFUGE": "to subject to centrifugal action esp. in a centrifuge [v CENTRIFUGED, CENTRIFUGING, CENTRIFUGES]\n",
  "CENTRIFUGED": "CENTRIFUGE, to subject to centrifugal action esp. in a centrifuge [v]\n",
  "CENTRIFUGENCE": "centrifugal tendency or force [n -S]\n",
  "CENTRIFUGENCES": "CENTRIFUGENCE, centrifugal tendency or force [n]\n",
  "CENTRIFUGES": "CENTRIFUGE, to subject to centrifugal action esp. in a centrifuge [v]\n",
  "CENTRIFUGING": "CENTRIFUGE, to subject to centrifugal action esp. in a centrifuge [v]\n",
  "CENTRING": "a temporary framework for an arch, also CENTERING [n -S]\n",
  "CENTRINGS": "CENTRING, a temporary framework for an arch, also CENTERING [n]\n",
  "CENTRIOLE": "a rodlike body (usually one of a pair) in animal cells [n -S]\n",
  "CENTRIOLES": "CENTRIOLE, a rodlike body (usually one of a pair) in animal cells [n]\n",
  "CENTRIPETAL": "tending inwards or developing towards the centre from the outside [adj CENTRIPETALLY]\n",
  "CENTRIPETALISM": "the state of being centripetal [n -S]\n",
  "CENTRIPETALISMS": "CENTRIPETALISM, the state of being centripetal [n]\n",
  "CENTRIPETALLY": "CENTRIPETAL, tending inwards or developing towards the centre from the outside [adv]\n",
  "CENTRISM": "a moderate political philosophy [n -S]\n",
  "CENTRISMS": "CENTRISM, a moderate political philosophy [n]\n",
  "CENTRIST": "one who adheres to the tenets of centrism, avoidance of extremes [n -S]\n",
  "CENTRISTS": "CENTRIST, one who adheres to the tenets of centrism, avoidance of extremes [n]\n",
  "CENTROBARIC": "relating to the centre of gravity [adj]\n",
  "CENTROCLINAL": "dipping towards a centre from all directions [adj]\n",
  "CENTRODE": "a type of mathematical locus [n -S]\n",
  "CENTRODES": "CENTRODE, a type of mathematical locus [n]\n",
  "CENTROID": "the centre of mass of an object [n -S]\n",
  "CENTROIDAL": "of or like a centroid [adj]\n",
  "CENTROIDS": "CENTROID, the centre of mass of an object [n]\n",
  "CENTROLECITHAL": "of animal eggs, having a centrally located yolk [adj]\n",
  "CENTROMERE": "the portion of DNA that attaches a chromosome to the spindle during cell division [n -S]\n",
  "CENTROMERES": "CENTROMERE, the portion of DNA that attaches a chromosome to the spindle during cell division [n]\n",
  "CENTROMERIC": "relating to a centromere [adj]\n",
  "CENTROSOME": "a minute, self-duplicating structure near the interphase nucleus, from which the fibres of the spindle radiate at mitosis [n -S]\n",
  "CENTROSOMES": "CENTROSOME, a minute, self-duplicating structure near the interphase nucleus, from which the fibres of the spindle radiate at mitosis [n]\n",
  "CENTROSOMIC": "like a centrosome [adj]\n",
  "CENTROSPHERE": "the central part of the earth below the crust, aka barysphere [n -S]\n",
  "CENTROSPHERES": "CENTROSPHERE, the central part of the earth below the crust, aka barysphere [n]\n",
  "CENTROSYMMETRIC": "symmetric with respect to a central point [adj]\n",
  "CENTRUM": "(Latin) the body of a vertebra [n CENTRUMS or CENTRA]\n",
  "CENTRUMS": "CENTRUM, (Latin) the body of a vertebra [n]\n",
  "CENTRY": "(Shakespeare) a centre [n CENTRIES]\n",
  "CENTS": "CENT, a coin worth 1/100th of a dollar [n]\n",
  "CENTU": "a Lithuanian monetary unit [n CENTU]\n",
  "CENTUM": "(Latin) a hundred [n -S]\n",
  "CENTUMS": "CENTUM, (Latin) a hundred [n]\n",
  "CENTUMVIR": "(Latin) in Rome, one of a court of about one hundred judges chosen to try civil suits [n CENTUMVIRI or CENTUMVIRS]\n",
  "CENTUMVIRATE": "a body of a hundred men [n -S]\n",
  "CENTUMVIRATES": "CENTUMVIRATE, a body of a hundred men [n]\n",
  "CENTUMVIRI": "CENTUMVIR, (Latin) in Rome, one of a court of about one hundred judges chosen to try civil suits [n]\n",
  "CENTUMVIRS": "CENTUMVIR, (Latin) in Rome, one of a court of about one hundred judges chosen to try civil suits [n]\n",
  "CENTUPLE": "to increase a hundredfold [v CENTUPLED, CENTUPLING, CENTUPLES]\n",
  "CENTUPLED": "CENTUPLE, to increase a hundredfold [v]\n",
  "CENTUPLES": "CENTUPLE, to increase a hundredfold [v]\n",
  "CENTUPLICATE": "to centuple [v CENTUPLICATED, CENTUPLICATING, CENTUPLICATES]\n",
  "CENTUPLICATED": "CENTUPLICATE, to centuple [v]\n",
  "CENTUPLICATES": "CENTUPLICATE, to centuple [v]\n",
  "CENTUPLICATING": "CENTUPLICATE, to centuple [v]\n",
  "CENTUPLICATION": "multiplication a hundredfold [n -S]\n",
  "CENTUPLICATIONS": "CENTUPLICATION, multiplication a hundredfold [n]\n",
  "CENTUPLING": "CENTUPLE, to increase a hundredfold [v]\n",
  "CENTURIAL": "of or pertaining to a century [adj]\n",
  "CENTURIATION": "division into hundreds [n -S]\n",
  "CENTURIATIONS": "CENTURIATION, division into hundreds [n]\n",
  "CENTURIATOR": "one of a group of sixteenth century Reformed divines of Magdeburg who compiled a church history in 13 volumes, each volume covering a century [n -S]\n",
  "CENTURIATORS": "CENTURIATOR, one of a group of sixteenth century Reformed divines of Magdeburg who compiled a church history in 13 volumes, each volume covering a century [n]\n",
  "CENTURIES": "CENTURY, a period of a hundred years [n]\n",
  "CENTURION": "(Latin) the leader of a Roman century, one hundred men [n -S]\n",
  "CENTURIONS": "CENTURION, (Latin) the leader of a Roman century, one hundred men [n]\n",
  "CENTURY": "a period of a hundred years [n CENTURIES]\n",
  "CEORL": "(Old English) in Anglo-Saxon England, a freeman of the lowest rank, also CHURL [n -S]\n",
  "CEORLISH": "(Old English) like a ceorl, churlish [adj]\n",
  "CEORLS": "CEORL, (Old English) in Anglo-Saxon England, a freeman of the lowest rank, also CHURL [n]\n",
  "CEP": "a large mushroom, also CEPE [n -S]\n",
  "CEPACEOUS": "smelling or tasting of garlic or onion [adj]\n",
  "CEPAGE": "the grape variety or combination of varieties used to make a particular wine [n -S]\n",
  "CEPAGES": "CEPAGE, the grape variety or combination of varieties used to make a particular wine [n]\n",
  "CEPE": "a large mushroom, also CEP [n -S]\n",
  "CEPES": "CEPE, a large mushroom, also CEP [n]\n",
  "CEPHALAD": "towards the head [adv]\n",
  "CEPHALAGRA": "gout in the head [n -S]\n",
  "CEPHALAGRAS": "CEPHALAGRA, gout in the head [n]\n",
  "CEPHALALGIA": "head pain [n -S]\n",
  "CEPHALALGIAS": "CEPHALALGIA, head pain [n]\n",
  "CEPHALALGIC": "a headache remedy [n -S]\n",
  "CEPHALALGICS": "CEPHALALGIC, a headache remedy [n]\n",
  "CEPHALATE": "having a head [adj]\n",
  "CEPHALEXIN": "a semisynthetic cephalosporin, any of a group of wide-spectrum antibiotics derived from the fungus Cephalosporin [n -S]\n",
  "CEPHALEXINS": "CEPHALEXIN, a semisynthetic cephalosporin, any of a group of wide-spectrum antibiotics derived from the fungus Cephalosporin [n]\n",
  "CEPHALIC": "pertaining to the head [adj CEPHALICALLY] / a headache remedy, also KEPHALIC [n -S]\n",
  "CEPHALICALLY": "CEPHALIC, pertaining to the head [adv]\n",
  "CEPHALICS": "CEPHALIC, a headache remedy, also KEPHALIC [n]\n",
  "CEPHALIN": "a compound of phosphorus found in the brain and nervous tissue, also KEPHALIN [n -S]\n",
  "CEPHALINS": "CEPHALIN, a compound of phosphorus found in the brain and nervous tissue, also KEPHALIN [n]\n",
  "CEPHALISATION": "the gradually increasing concentration of brain in evolution, also CEPHALIZATION [n -S]\n",
  "CEPHALISATIONS": "CEPHALISATION, the gradually increasing concentration of brain in evolution, also CEPHALIZATION [n]\n",
  "CEPHALITIS": "inflammation of the brain, or of the meninges of the brain, aka phrenitis [n -ES]\n",
  "CEPHALITISES": "CEPHALITIS, inflammation of the brain, or of the meninges of the brain, aka phrenitis [n]\n",
  "CEPHALIZATION": "the gradually increasing concentration of brain in evolution, also CEPHALISATION [n -S]\n",
  "CEPHALIZATIONS": "CEPHALIZATION, the gradually increasing concentration of brain in evolution, also CEPHALISATION [n]\n",
  "CEPHALOCELE": "the protrusion of the membranes of the brain through a hole in the skull [n -S]\n",
  "CEPHALOCELES": "CEPHALOCELE, the protrusion of the membranes of the brain through a hole in the skull [n]\n",
  "CEPHALOCHORDATE": "any of a number of chordate fishlike animals (including the lancelets and amphioxus), having a persisting notochord projecting beyond the nerve cord to the end of the snout [n]\n",
  "CEPHALOMETER": "an instrument for positioning the human head for X-ray examination in cephalometry [n -S]\n",
  "CEPHALOMETERS": "CEPHALOMETER, an instrument for positioning the human head for X-ray examination in cephalometry [n]\n",
  "CEPHALOMETRIC": "relating to cephalometry [adj]\n",
  "CEPHALOMETRIES": "CEPHALOMETRY, the science of measuring the head in living individuals [n]\n",
  "CEPHALOMETRY": "the science of measuring the head in living individuals [n CEPHALOMETRIES]\n",
  "CEPHALOPOD": "any marine mollusc of the class Cephalopoda, that includes the octopuses, squids, cuttlefish, and pearly nautilus, also CEPHALOPODAN [n -S]\n",
  "CEPHALOPODAN": "any marine mollusc of the class Cephalopoda, that includes the octopuses, squids, cuttlefish, and pearly nautilus, also CEPHALOPOD [n -S]\n",
  "CEPHALOPODANS": "CEPHALOPODAN, any marine mollusc of the class Cephalopoda, that includes the octopuses, squids, cuttlefish, and pearly nautilus, also CEPHALOPOD [n]\n",
  "CEPHALOPODIC": "of or like a cephalopod, also CEPHALOPODOUS [adj]\n",
  "CEPHALOPODOUS": "of or like a cephalopod, also CEPHALOPODIC [adj]\n",
  "CEPHALOPODS": "CEPHALOPOD, any marine mollusc of the class Cephalopoda, that includes the octopuses, squids, cuttlefish, and pearly nautilus, also CEPHALOPODAN [n]\n",
  "CEPHALORIDINE": "a semisynthetic broad-spectrum antibiotic derived from cephalosporin [n -S]\n",
  "CEPHALORIDINES": "CEPHALORIDINE, a semisynthetic broad-spectrum antibiotic derived from cephalosporin [n]\n",
  "CEPHALOSPORIN": "any of a group of wide-spectrum antibiotics derived from the fungus Cephalosporin [n -S]\n",
  "CEPHALOSPORINS": "CEPHALOSPORIN, any of a group of wide-spectrum antibiotics derived from the fungus Cephalosporin [n]\n",
  "CEPHALOTHIN": "a semisynthetic broad-spectrum antibiotic derived from cephalosporin and used in the form of its sodium salt [n -S]\n",
  "CEPHALOTHINS": "CEPHALOTHIN, a semisynthetic broad-spectrum antibiotic derived from cephalosporin and used in the form of its sodium salt [n]\n",
  "CEPHALOTHORACES": "CEPHALOTHORAX, the body, or head with thorax, of spiders, crustaceans, etc. [n]\n",
  "CEPHALOTHORACIC": "relating to the cephalothorax [adj]\n",
  "CEPHALOTHORAX": "the body, or head with thorax, of spiders, crustaceans, etc. [n CEPHALOTHORACES or CEPHALOTHORAXES]\n",
  "CEPHALOTHORAXES": "CEPHALOTHORAX, the body, or head with thorax, of spiders, crustaceans, etc. [n]\n",
  "CEPHALOTOMIES": "CEPHALOTOMY, the dissection of the head [n]\n",
  "CEPHALOTOMY": "the dissection of the head [n CEPHALOTOMIES]\n",
  "CEPHALOUS": "having a head, also ENCEPHALOUS [adj]\n",
  "CEPHEID": "a star of a type having regular cycles of brightness which can be used to deduce their distances [n -S]\n",
  "CEPHEIDS": "CEPHEID, a star of a type having regular cycles of brightness which can be used to deduce their distances [n]\n",
  "CEPS": "CEP, a large mushroom, also CEPE [n]\n",
  "CERACEOUS": "resembling wax [adj]\n",
  "CERAMAL": "a strong alloy of a metal with a heat-resisting compound, esp. used for turbine blades and similar objects, also CERMET [n -S]\n",
  "CERAMALS": "CERAMAL, a strong alloy of a metal with a heat-resisting compound, esp. used for turbine blades and similar objects, also CERMET [n]\n",
  "CERAMIC": "an item made of baked clay, also KERAMIC [n -S]\n",
  "CERAMICIST": "one who works with ceramics [n -S]\n",
  "CERAMICISTS": "CERAMICIST, one who works with ceramics [n]\n",
  "CERAMICS": "CERAMIC, an item made of baked clay, also KERAMIC [n]\n",
  "CERAMIDE": "any of a family of lipids used in cosmetics [n -S]\n",
  "CERAMIDES": "CERAMIDE, any of a family of lipids used in cosmetics [n]\n",
  "CERAMIST": "one who makes ceramics [n -S]\n",
  "CERAMISTS": "CERAMIST, one who makes ceramics [n]\n",
  "CERAMOGRAPHIES": "CERAMOGRAPHY, the historical description of types of pottery [n]\n",
  "CERAMOGRAPHY": "the historical description of types of pottery [n CERAMOGRAPHIES]\n",
  "CERARGYRITE": "a mineral consisting of silver chloride in crystalline form, aka horn silver [n -S]\n",
  "CERARGYRITES": "CERARGYRITE, a mineral consisting of silver chloride in crystalline form, aka horn silver [n]\n",
  "CERASIN": "the insoluble portion of cherry-tree gum [n -S]\n",
  "CERASINS": "CERASIN, the insoluble portion of cherry-tree gum [n]\n",
  "CERASTES": "(Greek) any venomous viper of the genus Cerastes, esp. the horned viper [n CERASTES]\n",
  "CERASTIUM": "any low ground-covering plant of the genus Cerastium, that includes the alpine mouse-ear chickweed [n -S]\n",
  "CERASTIUMS": "CERASTIUM, any low ground-covering plant of the genus Cerastium, that includes the alpine mouse-ear chickweed [n]\n",
  "CERATE": "a stiff ointment composed of wax, lard, or oil, and other ingredients [n -S]\n",
  "CERATED": "covered with wax [adj]\n",
  "CERATES": "CERATE, a stiff ointment composed of wax, lard, or oil, and other ingredients [n]\n",
  "CERATIN": "a nitrogenous compound, the constituent of horny tissue, also KERATIN [n -S]\n",
  "CERATINS": "CERATIN, a nitrogenous compound, the constituent of horny tissue, also KERATIN [n]\n",
  "CERATITIS": "inflammation of the cornea, also KERATITIS [n -ES]\n",
  "CERATITISES": "CERATITIS, inflammation of the cornea, also KERATITIS [n]\n",
  "CERATODUS": "(Greek) a genus of ganoid fishes, with lungs so well developed that they can leave the water and breathe in air [n -ES]\n",
  "CERATODUSES": "CERATODUS, (Greek) a genus of ganoid fishes, with lungs so well developed that they can leave the water and breathe in air [n]\n",
  "CERATOID": "resembling horn or keratin, also KERATOID [adj]\n",
  "CERATOPSIAN": "a bird-hipped, plant-eating dinosaur of the late Cretaceous [n -S]\n",
  "CERATOPSIANS": "CERATOPSIAN, a bird-hipped, plant-eating dinosaur of the late Cretaceous [n]\n",
  "CERATOPSID": "a bird-hipped, plant-eating dinosaur of the late Cretaceous [n -S]\n",
  "CERATOPSIDS": "CERATOPSID, a bird-hipped, plant-eating dinosaur of the late Cretaceous [n]\n",
  "CERAUNOGRAPH": "an instrument for recording thunderstorms by detecting the radio waves generated, also KERAUNOGRAPH [n -S]\n",
  "CERAUNOGRAPHS": "CERAUNOGRAPH, an instrument for recording thunderstorms by detecting the radio waves generated, also KERAUNOGRAPH [n]\n",
  "CERBEREAN": "of, pertaining to, or resembling, Cerberus, a watchdog, also CERBERIAN [adj]\n",
  "CERBERIAN": "of, pertaining to, or resembling, Cerberus, a watchdog, also CERBEREAN [adj]\n",
  "CERCAL": "pertaining to a tail [adj]\n",
  "CERCARIA": "(Greek) the final larval stage of many trematode worms [n CERCARIAE or CERCARIAS]\n",
  "CERCARIAE": "CERCARIA, (Greek) the final larval stage of many trematode worms [n]\n",
  "CERCARIAL": "relating to a cercaria, the larval form of a trematode worm, also CERCARIAN [adj]\n",
  "CERCARIAN": "relating to a cercaria, the larval form of a trematode worm, also CERCARIAL [adj] / a cercaria [n -S]\n",
  "CERCARIANS": "CERCARIAN, a cercaria [n]\n",
  "CERCARIAS": "CERCARIA, (Greek) the final larval stage of many trematode worms [n]\n",
  "CERCI": "CERCUS, (Greek) a sensory appendage of an insect [n]\n",
  "CERCIS": "any tree or shrub of the leguminous genus Cercis, which includes the redbud and Judas tree [n -ES]\n",
  "CERCISES": "CERCIS, any tree or shrub of the leguminous genus Cercis, which includes the redbud and Judas tree [n]\n",
  "CERCLAGE": "any of several procedures in which the cervix of the womb is closed to prevent miscarriage [n -S]\n",
  "CERCLAGES": "CERCLAGE, any of several procedures in which the cervix of the womb is closed to prevent miscarriage [n]\n",
  "CERCOPID": "any member of the family Cercopidae, spittlebugs [n -S]\n",
  "CERCOPIDS": "CERCOPID, any member of the family Cercopidae, spittlebugs [n]\n",
  "CERCOPITHECID": "any of several Old World long-tailed monkeys of the genus Cercopithecus, including the Diana monkey, vervet, and moustached monkey, also CERCOPITHECOID [n -S]\n",
  "CERCOPITHECIDS": "CERCOPITHECID, any of several Old World long-tailed monkeys of the genus Cercopithecus, including the Diana monkey, vervet, and moustached monkey, also CERCOPITHECOID [n]\n",
  "CERCOPITHECOID": "any of several Old World long-tailed monkeys of the genus Cercopithecus, including the Diana monkey, vervet, and moustached monkey, also CERCOPITHECID [n -S]\n",
  "CERCOPITHECOIDS": "CERCOPITHECOID, any of several Old World long-tailed monkeys of the genus Cercopithecus, including the Diana monkey, vervet, and moustached monkey, also CERCOPITHECID [n]\n",
  "CERCUS": "(Greek) a sensory appendage of an insect [n CERCI]\n",
  "CERE": "to wrap in a waxy cloth [v CERED, CERING, CERES]\n",
  "CEREAL": "food made from grain [n -S]\n",
  "CEREALIST": "one who grows cereals [n -S]\n",
  "CEREALISTS": "CEREALIST, one who grows cereals [n]\n",
  "CEREALS": "CEREAL, food made from grain [n]\n",
  "CEREBELLA": "CEREBELLUM, (Latin) the lower posterior part of the brain, whose function is to coordinate voluntary movements and maintain balance [n]\n",
  "CEREBELLAR": "relating to the cerebellum, also CEREBELLIC, CEREBELLOUS [adj]\n",
  "CEREBELLIC": "relating to the cerebellum, also CEREBELLAR, CEREBELLOUS [adj]\n",
  "CEREBELLOUS": "relating to the cerebellum, also CEREBELLAR, CEREBELLIC [adj]\n",
  "CEREBELLUM": "(Latin) the lower posterior part of the brain, whose function is to coordinate voluntary movements and maintain balance [n CEREBELLA or CEREBELLUMS]\n",
  "CEREBELLUMS": "CEREBELLUM, (Latin) the lower posterior part of the brain, whose function is to coordinate voluntary movements and maintain balance [n]\n",
  "CEREBRA": "CEREBRUM, (Latin) a part of the brain [n]\n",
  "CEREBRAL": "relating to the brain; of a consonant, pronounced with the tongue-tip curled up towards the hard palate [adj CEREBRALLY] / a cerebral consonant [n -S]\n",
  "CEREBRALISM": "the theory that all mental operations originate in the brain [n -S]\n",
  "CEREBRALISMS": "CEREBRALISM, the theory that all mental operations originate in the brain [n]\n",
  "CEREBRALIST": "an adherent of cerebralism [n -S]\n",
  "CEREBRALISTS": "CEREBRALIST, an adherent of cerebralism [n]\n",
  "CEREBRALLY": "CEREBRAL, relating to the brain; of a consonant, pronounced with the tongue-tip curled up towards the hard palate [adv]\n",
  "CEREBRALS": "CEREBRAL, a cerebral consonant [n]\n",
  "CEREBRATE": "to engage in intellectual activity [v CEREBRATED, CEREBRATING, CEREBRATES]\n",
  "CEREBRATED": "CEREBRATE, to engage in intellectual activity [v]\n",
  "CEREBRATES": "CEREBRATE, to engage in intellectual activity [v]\n",
  "CEREBRATING": "CEREBRATE, to engage in intellectual activity [v]\n",
  "CEREBRATION": "the unconscious action of the brain [n -S]\n",
  "CEREBRATIONS": "CEREBRATION, the unconscious action of the brain [n]\n",
  "CEREBRIC": "relating to the cerebrum [adj]\n",
  "CEREBRIFORM": "shaped like the brain [adj]\n",
  "CEREBRITIS": "inflammation of the cerebrum [n -ES]\n",
  "CEREBRITISES": "CEREBRITIS, inflammation of the cerebrum [n]\n",
  "CEREBROID": "like the cerebrum [adj]\n",
  "CEREBROSIDE": "any of various glycolipids found esp. in nerve tissue [n -S]\n",
  "CEREBROSIDES": "CEREBROSIDE, any of various glycolipids found esp. in nerve tissue [n]\n",
  "CEREBROSPINAL": "of or relating to the brain and spinal cord [adj]\n",
  "CEREBROTONIA": "the temperament associated with ectomorphic body type characterized by introversion and hypersensitivity [n -S]\n",
  "CEREBROTONIAS": "CEREBROTONIA, the temperament associated with ectomorphic body type characterized by introversion and hypersensitivity [n]\n",
  "CEREBROTONIC": "someone with a personality characterized by shyness, introspection, and emotional restraint [n -S]\n",
  "CEREBROTONICS": "CEREBROTONIC, someone with a personality characterized by shyness, introspection, and emotional restraint [n]\n",
  "CEREBROVASCULAR": "of or involving the cerebrum and the blood vessels supplying it [adj]\n",
  "CEREBRUM": "(Latin) a part of the brain [n CEREBRUMS or CEREBRA]\n",
  "CEREBRUMS": "CEREBRUM, (Latin) a part of the brain [n]\n",
  "CERECLOTH": "a cloth smeared with melted wax, or with some gummy or glutinous matter [n -S]\n",
  "CERECLOTHS": "CERECLOTH, a cloth smeared with melted wax, or with some gummy or glutinous matter [n]\n",
  "CERED": "CERE, to wrap in a waxy cloth [v]\n",
  "CEREMENT": "a waxed wrapping for the dead [n -S]\n",
  "CEREMENTS": "CEREMENT, a waxed wrapping for the dead [n]\n",
  "CEREMONIAL": "of or like ceremony [adj CEREMONIALLY] / a ceremonial act, action, or system [n -S]\n",
  "CEREMONIALISM": "being ceremonial [n -S]\n",
  "CEREMONIALISMS": "CEREMONIALISM, being ceremonial [n]\n",
  "CEREMONIALIST": "one who engages in ceremony [n -S]\n",
  "CEREMONIALISTS": "CEREMONIALIST, one who engages in ceremony [n]\n",
  "CEREMONIALLY": "CEREMONIAL, of or like ceremony [adv]\n",
  "CEREMONIALS": "CEREMONIAL, a ceremonial act, action, or system [n]\n",
  "CEREMONIES": "CEREMONY, a formal observance [n]\n",
  "CEREMONIOUS": "devoted to forms and ceremony [adj CEREMONIOUSLY]\n",
  "CEREMONIOUSLY": "CEREMONIOUS, devoted to forms and ceremony [adv]\n",
  "CEREMONIOUSNESS": "the state of being ceremonious [n]\n",
  "CEREMONY": "a formal observance [n CEREMONIES]\n",
  "CEREOUS": "waxy [adj]\n",
  "CERES": "CERE, to wrap in a waxy cloth [v]\n",
  "CERESIN": "a kind of hard, whitish wax prepared from ozokerite and used as a substitute for beeswax, also CERESINE [n -S]\n",
  "CERESINE": "a kind of hard, whitish wax prepared from ozokerite and used as a substitute for beeswax, also CERESIN [n -S]\n",
  "CERESINES": "CERESINE, a kind of hard, whitish wax prepared from ozokerite and used as a substitute for beeswax, also CERESIN [n]\n",
  "CERESINS": "CERESIN, a kind of hard, whitish wax prepared from ozokerite and used as a substitute for beeswax, also CERESINE [n]\n",
  "CEREUS": "(Latin) a genus of plants of the Cactus family, native to America [n -ES]\n",
  "CEREUSES": "CEREUS, (Latin) a genus of plants of the Cactus family, native to America [n]\n",
  "CERGE": "a large wax candle burned before the altar, also CIERGE [n -S]\n",
  "CERGES": "CERGE, a large wax candle burned before the altar, also CIERGE [n]\n",
  "CERIA": "cerium oxide [n -S]\n",
  "CERIAS": "CERIA, cerium oxide [n]\n",
  "CERIC": "containing cerium [adj]\n",
  "CERIFEROUS": "producing wax [adj]\n",
  "CERING": "CERE, to wrap in a waxy cloth [v]\n",
  "CERIPH": "a line used to finish off the main stroke of a letter [n -S]\n",
  "CERIPHS": "CERIPH, a line used to finish off the main stroke of a letter [n]\n",
  "CERISE": "(French) a colour, deep to vivid purplish-red [n -S]\n",
  "CERISES": "CERISE, (French) a colour, deep to vivid purplish-red [n]\n",
  "CERITE": "a hydrous silicate of cerium [n -S]\n",
  "CERITES": "CERITE, a hydrous silicate of cerium [n]\n",
  "CERIUM": "a metallic chemical element [n -S]\n",
  "CERIUMS": "CERIUM, a metallic chemical element [n]\n",
  "CERMET": "a strong alloy of a metal with a heat-resisting compound, esp. used for turbine blades and similar objects, also CERAMAL [n -S]\n",
  "CERMETS": "CERMET, a strong alloy of a metal with a heat-resisting compound, esp. used for turbine blades and similar objects, also CERAMAL [n]\n",
  "CERNE": "(Shakespeare) to concern [v CERNED, CERNING, CERNES]\n",
  "CERNED": "CERNE, (Shakespeare) to concern [v]\n",
  "CERNES": "CERNE, (Shakespeare) to concern [v]\n",
  "CERNING": "CERNE, (Shakespeare) to concern [v]\n",
  "CERNUOUS": "of flowers and buds, nodding, bowing down, drooping [adj]\n",
  "CERO": "(Spanish) a large spiny-finned food fish [n -S]\n",
  "CEROC": "a form of dance combining many styles, including jive and salsa [n -S]\n",
  "CEROCS": "CEROC, a form of dance combining many styles, including jive and salsa [n]\n",
  "CEROGRAPH": "a writing on wax [n -S]\n",
  "CEROGRAPHIC": "relating to cerography, writing or printing on plates spread with wax, also CEROGRAPHICAL [adj]\n",
  "CEROGRAPHICAL": "relating to cerography, writing or printing on plates spread with wax, also CEROGRAPHIC [adj]\n",
  "CEROGRAPHIES": "CEROGRAPHY, writing or printing on plates spread with wax [n]\n",
  "CEROGRAPHIST": "a practitioner of cerography [n -S]\n",
  "CEROGRAPHISTS": "CEROGRAPHIST, a practitioner of cerography [n]\n",
  "CEROGRAPHS": "CEROGRAPH, a writing on wax [n]\n",
  "CEROGRAPHY": "writing or printing on plates spread with wax [n CEROGRAPHIES]\n",
  "CEROMANCIES": "CEROMANCY, divination by means of wax drippings [n]\n",
  "CEROMANCY": "divination by means of wax drippings [n CEROMANCIES]\n",
  "CEROON": "a crate or hamper; a bale wrapped in hide, also SERON, SEROON [n -S]\n",
  "CEROONS": "CEROON, a crate or hamper; a bale wrapped in hide, also SERON, SEROON [n]\n",
  "CEROPLASTIC": "relating to wax modelling [adj]\n",
  "CEROPLASTICS": "the craft of wax modelling [n]\n",
  "CEROS": "CERO, (Spanish) a large spiny-finned food fish [n]\n",
  "CEROTIC": "pertaining to, or derived from, beeswax; as, cerotic acid [adj]\n",
  "CEROTYPE": "a process of engraving using wax [n -S]\n",
  "CEROTYPES": "CEROTYPE, a process of engraving using wax [n]\n",
  "CEROUS": "of or like cerium [adj]\n",
  "CERRADO": "an area of wooded savanna in S America [n -S]\n",
  "CERRADOS": "CERRADO, an area of wooded savanna in S America [n]\n",
  "CERRIAL": "of or pertaining to the cerris, a species of turkey oak [adj]\n",
  "CERRIS": "(Latin) a species of oak native to the Orient and southern Europe, aka Turkey oak [n -ES]\n",
  "CERRISES": "CERRIS, (Latin) a species of oak native to the Orient and southern Europe, aka Turkey oak [n]\n",
  "CERT": "(short for) a certainty [n -S]\n",
  "CERTAIN": "absolutely confident [adj CERTAINER, CERTAINEST, CERTAINLY]\n",
  "CERTAINER": "CERTAIN, absolutely confident [adj]\n",
  "CERTAINEST": "CERTAIN, absolutely confident [adj]\n",
  "CERTAINLY": "CERTAIN, absolutely confident [adv]\n",
  "CERTAINTIES": "CERTAINTY, the state of being certain [n]\n",
  "CERTAINTY": "the state of being certain [n CERTAINTIES]\n",
  "CERTES": "(archaic) in truth; certainly [adv]\n",
  "CERTIE": "as in by my certie, Scots for assuredly, also CERTY [n]\n",
  "CERTIFIABLE": "capable of being certified [adj CERTIFIABLY]\n",
  "CERTIFIABLY": "CERTIFIABLE, capable of being certified [adv]\n",
  "CERTIFICATE": "to testify to or authorize by a certificate [v CERTIFICATED, CERTIFICATING, CERTIFICATES]\n",
  "CERTIFICATED": "CERTIFICATE, to testify to or authorize by a certificate [v]\n",
  "CERTIFICATES": "CERTIFICATE, to testify to or authorize by a certificate [v]\n",
  "CERTIFICATING": "CERTIFICATE, to testify to or authorize by a certificate [v]\n",
  "CERTIFICATION": "the act of certifying [n -S]\n",
  "CERTIFICATIONS": "CERTIFICATION, the act of certifying [n]\n",
  "CERTIFICATORIES": "CERTIFICATORY, a certificate [n]\n",
  "CERTIFICATORY": "a certificate [n CERTIFICATORIES]\n",
  "CERTIFIED": "CERTIFY, to declare as true [v]\n",
  "CERTIFIER": "one who certifies [n -S]\n",
  "CERTIFIERS": "CERTIFIER, one who certifies [n]\n",
  "CERTIFIES": "CERTIFY, to declare as true [v]\n",
  "CERTIFY": "to declare as true [v CERTIFIED, CERTIFYING, CERTIFIES]\n",
  "CERTIFYING": "CERTIFY, to declare as true [v]\n",
  "CERTIORARI": "a writ from higher court to lower court requesting a transcript [n -S]\n",
  "CERTIORARIS": "CERTIORARI, a writ from higher court to lower court requesting a transcript [n]\n",
  "CERTITUDE": "the state of being certain [n -S]\n",
  "CERTITUDES": "CERTITUDE, the state of being certain [n]\n",
  "CERTS": "CERT, (short for) a certainty [n]\n",
  "CERTY": "as in by my certy, Scots for assuredly, also CERTIE [n]\n",
  "CERULE": "sky-blue, also CAERULE [adj]\n",
  "CERULEAN": "a sky-blue colour, also CAERULEAN [n -S]\n",
  "CERULEANS": "CERULEAN, a sky-blue colour, also CAERULEAN [n]\n",
  "CERULEIN": "a coal-tar dyestuff, producing fast olive-greens [n -S]\n",
  "CERULEINS": "CERULEIN, a coal-tar dyestuff, producing fast olive-greens [n]\n",
  "CERULEOUS": "sky-blue; dark blue; sea-green, also CAERULEAN, CERULEAN [adj]\n",
  "CERULOPLASMIN": "a blue copper-binding serum oxidase that is deficient in Wilson's disease [n -S]\n",
  "CERULOPLASMINS": "CERULOPLASMIN, a blue copper-binding serum oxidase that is deficient in Wilson's disease [n]\n",
  "CERUMEN": "(Latin) the yellow waxlike substance secreted in the outer ear [n -S]\n",
  "CERUMENS": "CERUMEN, (Latin) the yellow waxlike substance secreted in the outer ear [n]\n",
  "CERUMINOUS": "pertaining to, or secreting, cerumen; as, the ceruminous glands [adj]\n",
  "CERUSE": "white lead, used as a pigment [n -S]\n",
  "CERUSES": "CERUSE, white lead, used as a pigment [n]\n",
  "CERUSITE": "native lead carbonate, also CERUSSITE [n -S]\n",
  "CERUSITES": "CERUSITE, native lead carbonate, also CERUSSITE [n]\n",
  "CERUSSITE": "native lead carbonate, also CERUSITE [n -S]\n",
  "CERUSSITES": "CERUSSITE, native lead carbonate, also CERUSITE [n]\n",
  "CERVELAS": "(French) a type of French sausage, seasoned with garlic, also CERVELAT [n -ES]\n",
  "CERVELASES": "CERVELAS, (French) a type of French sausage, seasoned with garlic, also CERVELAT [n]\n",
  "CERVELAT": "(French) a type of French sausage, seasoned with garlic, also CERVELAS [n -S]\n",
  "CERVELATS": "CERVELAT, (French) a type of French sausage, seasoned with garlic, also CERVELAS [n]\n",
  "CERVEZA": "(Spanish) beer [n -S]\n",
  "CERVEZAS": "CERVEZA, (Spanish) beer [n]\n",
  "CERVICAL": "pertaining to the cervix [adj]\n",
  "CERVICES": "CERVIX, (Latin) a necklike opening, especially the lower part of the uterus [n]\n",
  "CERVICITIS": "inflammation of the cervix [n -ES]\n",
  "CERVICITISES": "CERVICITIS, inflammation of the cervix [n]\n",
  "CERVICOGRAPHIES": "CERVICOGRAPHY, the photographing of the neck of the womb to identify early signs of cancer [n]\n",
  "CERVICOGRAPHY": "the photographing of the neck of the womb to identify early signs of cancer [n CERVICOGRAPHIES]\n",
  "CERVICUM": "the flexible region between the prothorax and head in insects [n -S]\n",
  "CERVICUMS": "CERVICUM, the flexible region between the prothorax and head in insects [n]\n",
  "CERVID": "a member of the deer family [n -S]\n",
  "CERVIDS": "CERVID, a member of the deer family [n]\n",
  "CERVINE": "of, relating to or resembling deer [adj]\n",
  "CERVIX": "(Latin) a necklike opening, especially the lower part of the uterus [n CERVIXES or CERVICES]\n",
  "CERVIXES": "CERVIX, (Latin) a necklike opening, especially the lower part of the uterus [n]\n",
  "CESAREAN": "a method of child delivery, also CESARIAN [n -S]\n",
  "CESAREANS": "CESAREAN, a method of child delivery, also CESARIAN [n]\n",
  "CESAREVICH": "the eldest son of a tsar, heir to the tsardom, also CESAREVITCH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "CESAREVICHES": "CESAREVICH, the eldest son of a tsar, heir to the tsardom, also CESAREVITCH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n]\n",
  "CESAREVITCH": "the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "CESAREVITCHES": "CESAREVITCH, the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n]\n",
  "CESAREVNA": "(Russian) the wife of a tsar's eldest son, also TSESAREVNA [n -S]\n",
  "CESAREVNAS": "CESAREVNA, (Russian) the wife of a tsar's eldest son, also TSESAREVNA [n]\n",
  "CESAREWICH": "the eldest son of a tsar, also CESAREVICH, CESAREVITCH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "CESAREWICHES": "CESAREWICH, the eldest son of a tsar, also CESAREVICH, CESAREVITCH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n]\n",
  "CESAREWITCH": "the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "CESAREWITCHES": "CESAREWITCH, the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n]\n",
  "CESARIAN": "a method of child delivery, also CESAREAN [n -S]\n",
  "CESARIANS": "CESARIAN, a method of child delivery, also CESAREAN [n]\n",
  "CESIOUS": "having a bluish coating, also CAESIOUS [adj]\n",
  "CESIUM": "a metallic element [n -S]\n",
  "CESIUMS": "CESIUM, a metallic element [n]\n",
  "CESPITOSE": "growing in clusters or tufts [adj CESPITOSELY]\n",
  "CESPITOSELY": "CESPITOSE, growing in clusters or tufts [adv]\n",
  "CESS": "to tax or assess [v -ED, -ING, -ES]\n",
  "CESSATION": "a ceasing or stopping [n -S]\n",
  "CESSATIONS": "CESSATION, a ceasing or stopping [n]\n",
  "CESSE": "(Spenser) to cease [v CESSED, CESSING, CESSES]\n",
  "CESSED": "CESSE, (Spenser) to cease [v]\n",
  "CESSER": "a type of legal liability [n -S]\n",
  "CESSERS": "CESSER, a type of legal liability [n]\n",
  "CESSES": "CESSE, (Spenser) to cease [v]\n",
  "CESSING": "CESSE, (Spenser) to cease [v]\n",
  "CESSION": "a yielding to physical force [n -S]\n",
  "CESSIONARIES": "CESSIONARY, someone to which something is ceded [n]\n",
  "CESSIONARY": "someone to which something is ceded [n CESSIONARIES]\n",
  "CESSIONS": "CESSION, a yielding to physical force [n]\n",
  "CESSPIT": "a covered well or pit for sewage, also CESSPOOL, SESSPOOL [n -S]\n",
  "CESSPITS": "CESSPIT, a covered well or pit for sewage, also CESSPOOL, SESSPOOL [n]\n",
  "CESSPOOL": "a covered well or pit for sewage, also CESSPIT, SESSPOOL [n -S]\n",
  "CESSPOOLS": "CESSPOOL, a covered well or pit for sewage, also CESSPIT, SESSPOOL [n]\n",
  "CESTA": "(Spanish) a basket used in the game of jai alai [n -S]\n",
  "CESTAS": "CESTA, (Spanish) a basket used in the game of jai alai [n]\n",
  "CESTI": "CESTUS, (Latin) a hand covering for ancient Roman boxers, also CAESTUS [n]\n",
  "CESTODE": "any parasitic flatworm of the class Cestoda, that includes tapeworms [n -S]\n",
  "CESTODES": "CESTODE, any parasitic flatworm of the class Cestoda, that includes tapeworms [n]\n",
  "CESTOI": "CESTOS, (Greek) a belt or girdle [n]\n",
  "CESTOID": "any parasitic flatworm of the class Cestoda, that includes tapeworms, also CESTODE [n -S]\n",
  "CESTOIDEAN": "of or like a cestode, a tapeworm [adj] / a tapeworm [n -S]\n",
  "CESTOIDEANS": "CESTOIDEAN, a tapeworm [n]\n",
  "CESTOIDS": "CESTOID, any parasitic flatworm of the class Cestoda, that includes tapeworms, also CESTODE [n]\n",
  "CESTOS": "(Greek) a belt or girdle [n CESTOSES or CESTOI]\n",
  "CESTOSES": "CESTOS, (Greek) a belt or girdle [n]\n",
  "CESTUI": "in legal phrases, he, the one [pron -S]\n",
  "CESTUIS": "CESTUI, in legal phrases, he, the one [pron]\n",
  "CESTUS": "(Latin) a hand covering for ancient Roman boxers, also CAESTUS [n CESTUSES or CESTI]\n",
  "CESTUSES": "CESTUS, (Latin) a hand covering for ancient Roman boxers, also CAESTUS [n]\n",
  "CESURA": "(Latin) a pause in a line of verse, also CAESURA [n CESURAS or CESURAE]\n",
  "CESURAE": "CESURA, (Latin) a pause in a line of verse, also CAESURA [n]\n",
  "CESURAL": "of a breathing space in a line of verse [adj]\n",
  "CESURAS": "CESURA, (Latin) a pause in a line of verse, also CAESURA [n]\n",
  "CESURE": "(Spenser) a break, an interruption [n -S]\n",
  "CESURES": "CESURE, (Spenser) a break, an interruption [n]\n",
  "CETACEAN": "a type of aquatic mammal, including whales and dolphins [n -S]\n",
  "CETACEANS": "CETACEAN, a type of aquatic mammal, including whales and dolphins [n]\n",
  "CETACEOUS": "of or pertaining to the order Cetacea of aquatic mammals [adj]\n",
  "CETANE": "a colourless liquid hydrocarbon, used as a diesel fuel [n -S]\n",
  "CETANES": "CETANE, a colourless liquid hydrocarbon, used as a diesel fuel [n]\n",
  "CETE": "a group of badgers [n -S]\n",
  "CETEOSAURUS": "a large Jurassic dinosaur [n -ES]\n",
  "CETEOSAURUSES": "CETEOSAURUS, a large Jurassic dinosaur [n]\n",
  "CETERACH": "a kind of fern [n -S]\n",
  "CETERACHS": "CETERACH, a kind of fern [n]\n",
  "CETES": "CETE, a group of badgers [n]\n",
  "CETOLOGICAL": "relating to cetology, the study of whales and dolphins [adj]\n",
  "CETOLOGIES": "CETOLOGY, the study of whales [n]\n",
  "CETOLOGIST": "one versed in cetology [n -S]\n",
  "CETOLOGISTS": "CETOLOGIST, one versed in cetology [n]\n",
  "CETOLOGY": "the study of whales [n CETOLOGIES]\n",
  "CETRIMIDE": "an ammonium compound used as a detergent [n -S]\n",
  "CETRIMIDES": "CETRIMIDE, an ammonium compound used as a detergent [n]\n",
  "CETUXIMAB": "a chimeric (mouse/human) monoclonal antibody, used in the treatment of various cancers [n -S]\n",
  "CETUXIMABS": "CETUXIMAB, a chimeric (mouse/human) monoclonal antibody, used in the treatment of various cancers [n]\n",
  "CETYL": "a univalent radical found in some waxes [n -S]\n",
  "CETYLS": "CETYL, a univalent radical found in some waxes [n]\n",
  "CETYWALL": "valerian, a plant formerly valued for its restorative qualities, also SETUALE, SETWALL [n -S]\n",
  "CETYWALLS": "CETYWALL, valerian, a plant formerly valued for its restorative qualities, also SETUALE, SETWALL [n]\n",
  "CEVADILLA": "(Spanish) a liliaceous plant, yielding the alkaloid veratrine, also CEBADILLA, SABADILLA [n -S]\n",
  "CEVADILLAS": "CEVADILLA, (Spanish) a liliaceous plant, yielding the alkaloid veratrine, also CEBADILLA, SABADILLA [n]\n",
  "CEVAPCICI": "(Yugoslavian) kebabs of minced beef and pork flavoured with mint and paprika [n]\n",
  "CEVICHE": "(Spanish) in Mexican cookery, raw fish marinated in lime juice and served as an hors d'oeuvre, also SEVICHE [n -S]\n",
  "CEVICHES": "CEVICHE, (Spanish) in Mexican cookery, raw fish marinated in lime juice and served as an hors d'oeuvre, also SEVICHE [n]\n",
  "CEVITAMIC": "as in cevitamic acid, another name for ascorbic acid, vitamin C [adj]\n",
  "CEYLANITE": "a mineral, pleonaste, a dark-green to black variety of spinel, also CEYLONITE [n -S]\n",
  "CEYLANITES": "CEYLANITE, a mineral, pleonaste, a dark-green to black variety of spinel, also CEYLONITE [n]\n",
  "CEYLONITE": "a mineral, pleonaste, a dark-green to black variety of spinel, also CEYLANITE [n -S]\n",
  "CEYLONITES": "CEYLONITE, a mineral, pleonaste, a dark-green to black variety of spinel, also CEYLANITE [n]\n",
  "CEZVE": "a small metal pot, usually of copper, with a long metal handle, used for preparing Turkish, Arabic, or Greek style coffee [n -S]\n",
  "CEZVES": "CEZVE, a small metal pot, usually of copper, with a long metal handle, used for preparing Turkish, Arabic, or Greek style coffee [n]\n",
  "CH": "a dialect form of I, also CHE [pron]\n",
  "CHA": "(colloquial) tea [n -S]\n",
  "CHABAZITE": "a colourless, pink, or yellow zeolite which usually occurs as rhombohedral crystals [n -S]\n",
  "CHABAZITES": "CHABAZITE, a colourless, pink, or yellow zeolite which usually occurs as rhombohedral crystals [n]\n",
  "CHABLIS": "(French) a white wine made near Chablis, a town in France [n CHABLIS]\n",
  "CHABOUK": "(Urdu) a type of horsewhip, also CHABUK [n -S]\n",
  "CHABOUKS": "CHABOUK, (Urdu) a type of horsewhip, also CHABUK [n]\n",
  "CHABUK": "(Urdu) a type of horsewhip, also CHABOUK [n -S]\n",
  "CHABUKS": "CHABUK, (Urdu) a type of horsewhip, also CHABOUK [n]\n",
  "CHACE": "(obsolete) to chase [v CHACED, CHACING, CHACES]\n",
  "CHACED": "CHACE, (obsolete) to chase [v]\n",
  "CHACES": "CHACE, (obsolete) to chase [v]\n",
  "CHACHKA": "(Yiddish) a knickknack, also CHATCHKA, CHATCHKE, TSATSKE, TCHOTCHKE [n -S]\n",
  "CHACHKAS": "CHACHKA, (Yiddish) a knickknack, also CHATCHKA, CHATCHKE, TSATSKE, TCHOTCHKE [n]\n",
  "CHACING": "CHACE, (obsolete) to chase [v]\n",
  "CHACK": "(Scots) to pinch or nip [v -ED, -ING, -S]\n",
  "CHACKED": "CHACK, (Scots) to pinch or nip [v]\n",
  "CHACKING": "CHACK, (Scots) to pinch or nip [v]\n",
  "CHACKS": "CHACK, (Scots) to pinch or nip [v]\n",
  "CHACMA": "(Hottentot) a large species of African baboon, aka ursine baboon [n -S]\n",
  "CHACMAS": "CHACMA, (Hottentot) a large species of African baboon, aka ursine baboon [n]\n",
  "CHACO": "(Hungarian) the hat usually worn by members of a marching band, also SHACKO, SHAKO [n CHACOES or CHACOS]\n",
  "CHACOES": "CHACO, (Hungarian) the hat usually worn by members of a marching band, also SHACKO, SHAKO [n]\n",
  "CHACONINE": "a toxic alkaloid found in potatoes [n -S]\n",
  "CHACONINES": "CHACONINE, a toxic alkaloid found in potatoes [n]\n",
  "CHACONNE": "(French) a Spanish baroque dance in triple time [n -S]\n",
  "CHACONNES": "CHACONNE, (French) a Spanish baroque dance in triple time [n]\n",
  "CHACOS": "CHACO, (Hungarian) the hat usually worn by members of a marching band, also SHACKO, SHAKO [n]\n",
  "CHAD": "a bit of paper punched out of paper tape or cards [n -S]\n",
  "CHADAR": "(Persian) the large veil worn by Muslim women, also CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n -S]\n",
  "CHADARIM": "CHEDER, (Hebrew) a religious lesson, or the place where it is held, also HEDER [n]\n",
  "CHADARS": "CHADAR, (Persian) the large veil worn by Muslim women, also CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n]\n",
  "CHADDAR": "(Persian) the large veil worn by Muslim women, also CHADAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n -S]\n",
  "CHADDARS": "CHADDAR, (Persian) the large veil worn by Muslim women, also CHADAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n]\n",
  "CHADDOR": "(Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n -S]\n",
  "CHADDORS": "CHADDOR, (Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n]\n",
  "CHADLESS": "without a chad [adj]\n",
  "CHADO": "(Japanese) a tea ceremony, also CHANOYO, CHANOYU, SADO [n -S]\n",
  "CHADOR": "(Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHUDDAH, CHUDDAR, CHUDDER [n CHADRI or CHADORS]\n",
  "CHADORS": "CHADOR, (Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHUDDAH, CHUDDAR, CHUDDER [n]\n",
  "CHADOS": "CHADO, (Japanese) a tea ceremony, also CHANOYO, CHANOYU, SADO [n]\n",
  "CHADRI": "CHADAR, (Persian) the large veil worn by Muslim women, also CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR, CHUDDER [n]\n",
  "CHADS": "CHAD, a bit of paper punched out of paper tape or cards [n]\n",
  "CHAEBOL": "(Korean) a group of businesses in Korea owned by one family [n -S]\n",
  "CHAEBOLS": "CHAEBOL, (Korean) a group of businesses in Korea owned by one family [n]\n",
  "CHAENOMELES": "a shrub of the Chaenomeles genus of flowering shrubs, such as the japonica and flowering quince [n -ES]\n",
  "CHAENOMELESES": "CHAENOMELES, a shrub of the Chaenomeles genus of flowering shrubs, such as the japonica and flowering quince [n]\n",
  "CHAETA": "(Greek) a bristle or seta of seaworms [n CHAETAE]\n",
  "CHAETAE": "CHAETA, (Greek) a bristle or seta of seaworms [n]\n",
  "CHAETAL": "relating to a chaeta, a bristle or seta of seaworms [adj]\n",
  "CHAETIFEROUS": "bearing bristles; bristly [adj]\n",
  "CHAETODON": "any fish of the tropical genus Chaetodon, having slender teeth [n -S]\n",
  "CHAETODONS": "CHAETODON, any fish of the tropical genus Chaetodon, having slender teeth [n]\n",
  "CHAETOGNATH": "a kind of marine worm [n -S]\n",
  "CHAETOGNATHS": "CHAETOGNATH, a kind of marine worm [n]\n",
  "CHAETOPOD": "a member of the Chaetopoda, bristle-worms [n -S]\n",
  "CHAETOPODS": "CHAETOPOD, a member of the Chaetopoda, bristle-worms [n]\n",
  "CHAFE": "to warm by rubbing [v CHAFED, CHAFING, CHAFES]\n",
  "CHAFED": "CHAFE, to warm by rubbing [v]\n",
  "CHAFER": "any of several kinds of beetle, esp. of the Scarabeidae [n -S]\n",
  "CHAFERS": "CHAFER, any of several kinds of beetle, esp. of the Scarabeidae [n]\n",
  "CHAFES": "CHAFE, to warm by rubbing [v]\n",
  "CHAFF": "to poke fun at [v -ED, -ING, -S]\n",
  "CHAFFED": "CHAFF, to poke fun at [v]\n",
  "CHAFFER": "to bargain or haggle [v -ED, -ING, -S]\n",
  "CHAFFERED": "CHAFFER, to bargain or haggle [v]\n",
  "CHAFFERER": "a vendor who enjoys talking while making a sale [n -S]\n",
  "CHAFFERERS": "CHAFFERER, a vendor who enjoys talking while making a sale [n]\n",
  "CHAFFERIES": "CHAFFERY, the act of trading [n]\n",
  "CHAFFERING": "CHAFFER, to bargain or haggle [v]\n",
  "CHAFFERS": "CHAFFER, to bargain or haggle [v]\n",
  "CHAFFERY": "the act of trading [n CHAFFERIES]\n",
  "CHAFFIER": "CHAFFY, worthless [adj]\n",
  "CHAFFIEST": "CHAFFY, worthless [adj]\n",
  "CHAFFINCH": "a bird of the finch family [n -ES]\n",
  "CHAFFINCHES": "CHAFFINCH, a bird of the finch family [n]\n",
  "CHAFFING": "the act of teasing [n -S]\n",
  "CHAFFINGLY": "CHAFFING [adv]\n",
  "CHAFFINGS": "CHAFFING, the act of teasing [n]\n",
  "CHAFFRON": "a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAMFRAIN, CHAMFRON, CHANFRON [n -S]\n",
  "CHAFFRONS": "CHAFFRON, a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAMFRAIN, CHAMFRON, CHANFRON [n]\n",
  "CHAFFS": "CHAFF, to poke fun at [v]\n",
  "CHAFFY": "worthless [adj CHAFFIER, CHAFFIEST]\n",
  "CHAFING": "CHAFE, to warm by rubbing [v]\n",
  "CHAFT": "(Scots) the jaw, cheek [n -S]\n",
  "CHAFTS": "CHAFT, (Scots) the jaw, cheek [n]\n",
  "CHAGAN": "(Turkish) an early form of khan, also CHAM, KHAN [n -S]\n",
  "CHAGANS": "CHAGAN, (Turkish) an early form of khan, also CHAM, KHAN [n]\n",
  "CHAGRIN": "(French) to humiliate [v CHAGRINED or CHAGRINNED, CHAGRINING or CHAGRINNING, CHAGRINS]\n",
  "CHAGRINED": "CHAGRIN, (French) to humiliate [v]\n",
  "CHAGRINING": "CHAGRIN, (French) to humiliate [v]\n",
  "CHAGRINNED": "CHAGRIN, (French) to humiliate [v]\n",
  "CHAGRINNING": "CHAGRIN, (French) to humiliate [v]\n",
  "CHAGRINS": "CHAGRIN, (French) to humiliate [v]\n",
  "CHAI": "(Romany) feminine of chal, a fellow, a person [n -S]\n",
  "CHAIN": "to bind with linked rings [v -ED, -ING, -S]\n",
  "CHAINBRAKE": "a cutoff safety device on a chainsaw [n -S]\n",
  "CHAINBRAKES": "CHAINBRAKE, a cutoff safety device on a chainsaw [n]\n",
  "CHAINE": "(French) in ballet, a series of small fast turns used to cross a stage [n -S]\n",
  "CHAINED": "CHAIN, to bind with linked rings [v]\n",
  "CHAINER": "one who chains [n -S]\n",
  "CHAINERS": "CHAINER, one who chains [n]\n",
  "CHAINES": "CHAINE, (French) in ballet, a series of small fast turns used to cross a stage [n]\n",
  "CHAINFALL": "a type of hoist [n -S]\n",
  "CHAINFALLS": "CHAINFALL, a type of hoist [n]\n",
  "CHAINING": "CHAIN, to bind with linked rings [v]\n",
  "CHAINLESS": "without chains [adj]\n",
  "CHAINLET": "a small chain [n -S]\n",
  "CHAINLETS": "CHAINLET, a small chain [n]\n",
  "CHAINMAN": "a surveyor's assistant [n CHAINMEN]\n",
  "CHAINMEN": "CHAINMAN, a surveyor's assistant [n]\n",
  "CHAINPLATE": "a metal plate on the side of a vessel, to which the shrouds are attached [n -S]\n",
  "CHAINPLATES": "CHAINPLATE, a metal plate on the side of a vessel, to which the shrouds are attached [n]\n",
  "CHAINS": "CHAIN, to bind with linked rings [v]\n",
  "CHAINSAW": "to cut with a power saw [v -ED, -ING, -S]\n",
  "CHAINSAWED": "CHAINSAW, to cut with a power saw [v]\n",
  "CHAINSAWING": "CHAINSAW, to cut with a power saw [v]\n",
  "CHAINSAWS": "CHAINSAW, to cut with a power saw [v]\n",
  "CHAINSHOT": "two half or whole cannonballs joined by a chain, for cutting masts etc. [n -S]\n",
  "CHAINSHOTS": "CHAINSHOT, two half or whole cannonballs joined by a chain, for cutting masts etc. [n]\n",
  "CHAINSTITCH": "a stitch in knitting or sewing resembling the links of a chain [n -ES]\n",
  "CHAINSTITCHES": "CHAINSTITCH, a stitch in knitting or sewing resembling the links of a chain [n]\n",
  "CHAINWHEEL": "a toothed wheel, as on a bicycle, which meshes with a chain [n -S]\n",
  "CHAINWHEELS": "CHAINWHEEL, a toothed wheel, as on a bicycle, which meshes with a chain [n]\n",
  "CHAINWORK": "work looped or linked like a chain [n -S]\n",
  "CHAINWORKS": "CHAINWORK, work looped or linked like a chain [n]\n",
  "CHAIR": "to install in office [v -ED, -ING, -S]\n",
  "CHAIRBACK": "the part of a chair that supports the sitter's back [n -S]\n",
  "CHAIRBACKS": "CHAIRBACK, the part of a chair that supports the sitter's back [n]\n",
  "CHAIRBORNE": "carried in a chair [adj]\n",
  "CHAIRBOUND": "confined to a chair [adj]\n",
  "CHAIRDAYS": "(Shakespeare) the evening of life [n]\n",
  "CHAIRED": "CHAIR, to install in office [v]\n",
  "CHAIRING": "CHAIR, to install in office [v]\n",
  "CHAIRLIFT": "a series of chairs on an endless cable for carrying passengers up a mountain etc. [n -S]\n",
  "CHAIRLIFTS": "CHAIRLIFT, a series of chairs on an endless cable for carrying passengers up a mountain etc. [n]\n",
  "CHAIRMAN": "the presiding officer at a meeting [n CHAIRMEN] / to act as chairman of [v CHAIRMANED or CHAIRMANNED, CHAIRMANING or CHAIRMANNING, CHAIRMANS]\n",
  "CHAIRMANED": "CHAIRMAN, to act as chairman of [v]\n",
  "CHAIRMANING": "CHAIRMAN, to act as chairman of [v]\n",
  "CHAIRMANNED": "CHAIRMAN, to act as chairman of [v]\n",
  "CHAIRMANNING": "CHAIRMAN, to act as chairman of [v]\n",
  "CHAIRMANS": "CHAIRMAN, to act as chairman of [v]\n",
  "CHAIRMANSHIP": "the role of chairman [n -S]\n",
  "CHAIRMANSHIPS": "CHAIRMANSHIP, the role of chairman [n]\n",
  "CHAIRMEN": "CHAIRMAN, the presiding officer at a meeting [n]\n",
  "CHAIRPERSON": "a chairman or chairwoman [n -S]\n",
  "CHAIRPERSONS": "CHAIRPERSON, a chairman or chairwoman [n]\n",
  "CHAIRS": "CHAIR, to install in office [v]\n",
  "CHAIRWARMER": "an office holder, committee member, or employee who is inactive and ineffective [n -S]\n",
  "CHAIRWARMERS": "CHAIRWARMER, an office holder, committee member, or employee who is inactive and ineffective [n]\n",
  "CHAIRWOMAN": "a woman who serves as chairman [n CHAIRWOMEN]\n",
  "CHAIRWOMEN": "CHAIRWOMAN, a woman who serves as chairman [n]\n",
  "CHAIS": "CHAI, (Romany) feminine of chal, a fellow, a person [n]\n",
  "CHAISE": "(French) a light open carriage for one or two people [n -S]\n",
  "CHAISELESS": "without a chaise [adj]\n",
  "CHAISES": "CHAISE, (French) a light open carriage for one or two people [n]\n",
  "CHAKALAKA": "(South African) a relish of tomatoes, onions and spices [n -S]\n",
  "CHAKALAKAS": "CHAKALAKA, (South African) a relish of tomatoes, onions and spices [n]\n",
  "CHAKRA": "(Sanskrit) in yoga, one of the seven centres of spiritual power in the body [n -S]\n",
  "CHAKRAS": "CHAKRA, (Sanskrit) in yoga, one of the seven centres of spiritual power in the body [n]\n",
  "CHAL": "(Romany) a fellow, a person [n -S]\n",
  "CHALAH": "(Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALEH, CHALLA, CHALLAH, HALLAH [n CHALOTH or CHALAHS]\n",
  "CHALAHS": "CHALAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALEH, CHALLA, CHALLAH, HALLAH [n]\n",
  "CHALAN": "(Urdu) in India, to cause (an accused person) to appear before a magistrate [v CHALANED or CHALANNED, CHALANING or CHALANNING, CHALANS]\n",
  "CHALANED": "CHALAN, (Urdu) in India, to cause (an accused person) to appear before a magistrate [v]\n",
  "CHALANING": "CHALAN, (Urdu) in India, to cause (an accused person) to appear before a magistrate [v]\n",
  "CHALANNED": "CHALAN, (Urdu) in India, to cause (an accused person) to appear before a magistrate [v]\n",
  "CHALANNING": "CHALAN, (Urdu) in India, to cause (an accused person) to appear before a magistrate [v]\n",
  "CHALANS": "CHALAN, (Urdu) in India, to cause (an accused person) to appear before a magistrate [v]\n",
  "CHALAZA": "(Greek) a band of tissue in an egg [n CHALAZAS or CHALAZAE]\n",
  "CHALAZAE": "CHALAZA, (Greek) a band of tissue in an egg [n]\n",
  "CHALAZAL": "of or pertaining to the chalaza, the base of the ovule [adj]\n",
  "CHALAZAS": "CHALAZA, (Greek) a band of tissue in an egg [n]\n",
  "CHALAZIA": "CHALAZION, (Greek) a swollen, inflamed sebaceous gland in the eyelid [n]\n",
  "CHALAZION": "(Greek) a swollen, inflamed sebaceous gland in the eyelid [n CHALAZIONS or CHALAZIA]\n",
  "CHALAZIONS": "CHALAZION, (Greek) a swollen, inflamed sebaceous gland in the eyelid [n]\n",
  "CHALAZOGAMIC": "relating to chalazogamy, the entry of the pollen tube through the chalaza [adj]\n",
  "CHALAZOGAMIES": "CHALAZOGAMY, the entry of the pollen tube through the chalaza, as opposed to porogamy [n]\n",
  "CHALAZOGAMY": "the entry of the pollen tube through the chalaza, as opposed to porogamy [n CHALAZOGAMIES]\n",
  "CHALCANTHITE": "native hydrated copper sulphate, a blue triclinic mineral usually occurring as tabular crystals [n -S]\n",
  "CHALCANTHITES": "CHALCANTHITE, native hydrated copper sulphate, a blue triclinic mineral usually occurring as tabular crystals [n]\n",
  "CHALCEDONIC": "of or like chalcedony [adj]\n",
  "CHALCEDONIES": "CHALCEDONY, a crystalline form of quartz, microscopically fibrous with waxy luster, also CALCEDONY [n]\n",
  "CHALCEDONY": "a crystalline form of quartz, microscopically fibrous with waxy luster, also CALCEDONY [n CHALCEDONIES]\n",
  "CHALCEDONYX": "an agate of alternating white opaque and greyish transparent chalcedony [n -ES]\n",
  "CHALCEDONYXES": "CHALCEDONYX, an agate of alternating white opaque and greyish transparent chalcedony [n]\n",
  "CHALCID": "any small parasitic insect of the family Chalcididae, that lay their eggs inside the bodies of other insects [n -S]\n",
  "CHALCIDS": "CHALCID, any small parasitic insect of the family Chalcididae, that lay their eggs inside the bodies of other insects [n]\n",
  "CHALCOCITE": "a greyish-black mineral, native copper sulphide [n -S]\n",
  "CHALCOCITES": "CHALCOCITE, a greyish-black mineral, native copper sulphide [n]\n",
  "CHALCOGEN": "an element from group VI(B) of the periodic table, namely sulphur, selenium or tellurium [n -S]\n",
  "CHALCOGENIDE": "a binary compound of a chalcogen with a more electropositive element or radical [n -S]\n",
  "CHALCOGENIDES": "CHALCOGENIDE, a binary compound of a chalcogen with a more electropositive element or radical [n]\n",
  "CHALCOGENS": "CHALCOGEN, an element from group VI(B) of the periodic table, namely sulphur, selenium or tellurium [n]\n",
  "CHALCOGRAPHER": "one who practises chalcography, the art of engraving on copper or brass [n -S]\n",
  "CHALCOGRAPHERS": "CHALCOGRAPHER, one who practises chalcography, the art of engraving on copper or brass [n]\n",
  "CHALCOGRAPHIC": "relating to chalcography, also CHALCOGRAPHICAL [adj]\n",
  "CHALCOGRAPHICAL": "relating to chalcography, also CHALCOGRAPHIC [adj]\n",
  "CHALCOGRAPHIES": "CHALCOGRAPHY, the art of engraving on copper or brass [n]\n",
  "CHALCOGRAPHIST": "one who practises chalcography, the art of engraving on copper or brass [n -S]\n",
  "CHALCOGRAPHISTS": "CHALCOGRAPHIST, one who practises chalcography, the art of engraving on copper or brass [n]\n",
  "CHALCOGRAPHY": "the art of engraving on copper or brass [n CHALCOGRAPHIES]\n",
  "CHALCOLITHIC": "of or relating to a period characterized by the use of both stone and bronze implements [adj]\n",
  "CHALCOPYRITE": "copper pyrites, a yellow double sulphide of copper and iron [n -S]\n",
  "CHALCOPYRITES": "CHALCOPYRITE, copper pyrites, a yellow double sulphide of copper and iron [n]\n",
  "CHALDER": "an old Scottish dry measure [n -S]\n",
  "CHALDERS": "CHALDER, an old Scottish dry measure [n]\n",
  "CHALDRON": "an old unit of capacity, equal to 36 heaped bushels, also CHALDER [n -S]\n",
  "CHALDRONS": "CHALDRON, an old unit of capacity, equal to 36 heaped bushels, also CHALDER [n]\n",
  "CHALEH": "(Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALLA, CHALLAH, HALLAH [n -S]\n",
  "CHALEHS": "CHALEH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALLA, CHALLAH, HALLAH [n]\n",
  "CHALET": "a type of wooden house of Swiss origin, typically low, with wide projecting eaves [n -S]\n",
  "CHALETS": "CHALET, a type of wooden house of Swiss origin, typically low, with wide projecting eaves [n]\n",
  "CHALICE": "a drinking cup [n -S]\n",
  "CHALICED": "of flowers, cuplike [adj]\n",
  "CHALICES": "CHALICE, a drinking cup [n]\n",
  "CHALICOTHERE": "an extinct three-toed ungulate [n -S]\n",
  "CHALICOTHERES": "CHALICOTHERE, an extinct three-toed ungulate [n]\n",
  "CHALK": "to mark with soft limestone [v -ED, -ING, -S]\n",
  "CHALKBOARD": "a blackboard [n -S]\n",
  "CHALKBOARDS": "CHALKBOARD, a blackboard [n]\n",
  "CHALKED": "CHALK, to mark with soft limestone [v]\n",
  "CHALKFACE": "as in the phrase at the chalkface, i.e. in the classroom, as the centre of a teacher's activities [n -S]\n",
  "CHALKFACES": "CHALKFACE, as in the phrase at the chalkface, i.e. in the classroom, as the centre of a teacher's activities [n]\n",
  "CHALKIER": "CHALKY, resembling chalk [adj]\n",
  "CHALKIEST": "CHALKY, resembling chalk [adj]\n",
  "CHALKINESS": "the state of being chalky [n -ES]\n",
  "CHALKINESSES": "CHALKINESS, the state of being chalky [n]\n",
  "CHALKING": "CHALK, to mark with soft limestone [v]\n",
  "CHALKLAND": "land composed of chalk [n -S]\n",
  "CHALKLANDS": "CHALKLAND, land composed of chalk [n]\n",
  "CHALKLIKE": "like chalk [adj]\n",
  "CHALKMARK": "a mark made with chalk (in phrase walk the chalkmark) [n -S]\n",
  "CHALKMARKS": "CHALKMARK, a mark made with chalk (in phrase walk the chalkmark) [n]\n",
  "CHALKPIT": "a quarry of chalk [n -S]\n",
  "CHALKPITS": "CHALKPIT, a quarry of chalk [n]\n",
  "CHALKS": "CHALK, to mark with soft limestone [v]\n",
  "CHALKSTONE": "a mass of chalk; a tophus [n -S]\n",
  "CHALKSTONES": "CHALKSTONE, a mass of chalk; a tophus [n]\n",
  "CHALKSTRIPE": "clothing with a pattern of thin white stripes on a dark background [n -S]\n",
  "CHALKSTRIPES": "CHALKSTRIPE, clothing with a pattern of thin white stripes on a dark background [n]\n",
  "CHALKY": "resembling chalk [adj CHALKIER, CHALKIEST]\n",
  "CHALLA": "(Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLAH, HALLAH [n -S]\n",
  "CHALLAH": "(Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, HALLAH [n CHALLAHS, CHALLOT or CHALLOTH]\n",
  "CHALLAHS": "CHALLAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, HALLAH [n]\n",
  "CHALLAN": "(Urdu) a waybill; a pass, also CHALAN [n -S]\n",
  "CHALLANS": "CHALLAN, (Urdu) a waybill; a pass, also CHALAN [n]\n",
  "CHALLAS": "CHALLA, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLAH, HALLAH [n]\n",
  "CHALLENGE": "an invitation to a contest [n -S] / to summon (someone) to settle a matter by fighting or by any kind of contest [v CHALLENGED, CHALLENGING, CHALLENGES]\n",
  "CHALLENGEABLE": "capable of being challenged [adj]\n",
  "CHALLENGED": "CHALLENGE, to summon (someone) to settle a matter by fighting or by any kind of contest [v]\n",
  "CHALLENGER": "one who challenges [n -S]\n",
  "CHALLENGERS": "CHALLENGER, one who challenges [n]\n",
  "CHALLENGES": "CHALLENGE, to summon (someone) to settle a matter by fighting or by any kind of contest [v]\n",
  "CHALLENGING": "CHALLENGE, to summon (someone) to settle a matter by fighting or by any kind of contest [v]\n",
  "CHALLENGINGLY": "CHALLENGING, CHALLENGE, to summon (someone) to settle a matter by fighting or by any kind of contest [adv]\n",
  "CHALLIE": "a soft lightweight silk, wool or cotton fabric, also CHALLIS, CHALLY, SHALLI [n -S]\n",
  "CHALLIES": "CHALLIE, a soft lightweight silk, wool or cotton fabric, also CHALLIS, CHALLY, SHALLI [n]\n",
  "CHALLIS": "a soft lightweight silk, wool or cotton fabric, also CHALLIE, CHALLY, SHALLI [n -ES]\n",
  "CHALLISES": "CHALLIS, a soft lightweight silk, wool or cotton fabric, also CHALLIE, CHALLY, SHALLI [n]\n",
  "CHALLOT": "CHALLAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, HALLAH [n]\n",
  "CHALLOTH": "CHALLAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, HALLAH [n]\n",
  "CHALLY": "a light fabric, also CHALLIE, CHALLIS [n CHALLIES]\n",
  "CHALONE": "one of a group of chemicals occurring in animal tissue [n -S]\n",
  "CHALONES": "CHALONE, one of a group of chemicals occurring in animal tissue [n]\n",
  "CHALONIC": "relating to a chalone, one of a group of chemicals occurring in animal tissue [adj]\n",
  "CHALOT": "CHALAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALEH, CHALLA, CHALLAH, HALLAH [n]\n",
  "CHALOTH": "CHALAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALEH, CHALLA, CHALLAH, HALLAH [n]\n",
  "CHALS": "CHAL, (Romany) a fellow, a person [n]\n",
  "CHALUMEAU": "(French) an early rustic reed instrument that developed into the clarinet [n CHALUMEAUS or CHALUMEAUX]\n",
  "CHALUMEAUS": "CHALUMEAU, (French) an early rustic reed instrument that developed into the clarinet [n]\n",
  "CHALUMEAUX": "CHALUMEAU, (French) an early rustic reed instrument that developed into the clarinet [n]\n",
  "CHALUPA": "(Spanish) a fried corn tortilla spread with a savory mixture [n -S]\n",
  "CHALUPAS": "CHALUPA, (Spanish) a fried corn tortilla spread with a savory mixture [n]\n",
  "CHALUTZ": "(Hebrew) an Israeli farmer [n CHALUTZES or CHALUTZIM]\n",
  "CHALUTZES": "CHALUTZ, (Hebrew) an Israeli farmer [n]\n",
  "CHALUTZIM": "CHALUTZ, (Hebrew) an Israeli farmer [n]\n",
  "CHALYBEAN": "in metallurgy, tempered [adj]\n",
  "CHALYBEATE": "impregnated with salts of iron [adj] / a water or other liquid, esp. a drug, containing iron salts [n -S]\n",
  "CHALYBEATES": "CHALYBEATE, a water or other liquid, esp. a drug, containing iron salts [n]\n",
  "CHALYBITE": "native iron carbonate, aka siderite [n -S]\n",
  "CHALYBITES": "CHALYBITE, native iron carbonate, aka siderite [n]\n",
  "CHAM": "(obsolete) a prince or chief; a governor, also CHAGAN, KHAN [n -S]\n",
  "CHAMADE": "(historical) a signal made for a parley by beat of a drum [n -S]\n",
  "CHAMADES": "CHAMADE, (historical) a signal made for a parley by beat of a drum [n]\n",
  "CHAMAELEON": "a small African lizard with a prehensile tail and tongue, also CAMELEON, CHAMELEON [n -S]\n",
  "CHAMAELEONS": "CHAMAELEON, a small African lizard with a prehensile tail and tongue, also CAMELEON, CHAMELEON [n]\n",
  "CHAMAEPHYTE": "a winter-flowering plant [n -S]\n",
  "CHAMAEPHYTES": "CHAMAEPHYTE, a winter-flowering plant [n]\n",
  "CHAMBER": "to put in a room [v -ED, -ING, -S]\n",
  "CHAMBERED": "CHAMBER, to put in a room [v]\n",
  "CHAMBERER": "(archaic) a plotter; a lover [n -S]\n",
  "CHAMBERERS": "CHAMBERER, (archaic) a plotter; a lover [n]\n",
  "CHAMBERHAND": "(New Zealand) a worker in the cold storage area of a slaughterhouse [n -S]\n",
  "CHAMBERHANDS": "CHAMBERHAND, (New Zealand) a worker in the cold storage area of a slaughterhouse [n]\n",
  "CHAMBERING": "lewd or wanton behaviour [n -S]\n",
  "CHAMBERINGS": "CHAMBERING, lewd or wanton behaviour [n]\n",
  "CHAMBERLAIN": "an officer appointed by a monarch, nobleman or corporation, to perform domestic and ceremonial duties or to act as factor, steward or treasurer [n -S]\n",
  "CHAMBERLAINS": "CHAMBERLAIN, an officer appointed by a monarch, nobleman or corporation, to perform domestic and ceremonial duties or to act as factor, steward or treasurer [n]\n",
  "CHAMBERLAINSHIP": "the office of chamberlain [n]\n",
  "CHAMBERMAID": "a maid who makes beds and does general cleaning of bedrooms (as in a hotel) [n -S]\n",
  "CHAMBERMAIDS": "CHAMBERMAID, a maid who makes beds and does general cleaning of bedrooms (as in a hotel) [n]\n",
  "CHAMBERPOT": "a container for urine etc. [n -S]\n",
  "CHAMBERPOTS": "CHAMBERPOT, a container for urine etc. [n]\n",
  "CHAMBERS": "CHAMBER, to put in a room [v]\n",
  "CHAMBRANLE": "(French) decoration around a door frame or fireplace [n -S]\n",
  "CHAMBRANLES": "CHAMBRANLE, (French) decoration around a door frame or fireplace [n]\n",
  "CHAMBRAY": "a lightweight fabric with coloured warp and white filling [n -S]\n",
  "CHAMBRAYS": "CHAMBRAY, a lightweight fabric with coloured warp and white filling [n]\n",
  "CHAMBRE": "(French) of wine, at room temperature [adj]\n",
  "CHAMELEON": "a small African lizard with a prehensile tail and tongue, also CAMELEON, CHAMAELEON [n -S]\n",
  "CHAMELEONIC": "of or like a chameleon [adj]\n",
  "CHAMELEONLIKE": "like a chameleon, a lizard-like reptile of the genus Chamaeleo [adj]\n",
  "CHAMELEONS": "CHAMELEON, a small African lizard with a prehensile tail and tongue, also CAMELEON, CHAMAELEON [n]\n",
  "CHAMELOT": "(Spenser) a strong waterproof silk or wool fabric, also CAMELOT, CAMLET, CHAMLET [n -S]\n",
  "CHAMELOTS": "CHAMELOT, (Spenser) a strong waterproof silk or wool fabric, also CAMELOT, CAMLET, CHAMLET [n]\n",
  "CHAMETZ": "(Hebrew) leavened food forbidden during Passover, also CHOMETZ [n -ES]\n",
  "CHAMETZES": "CHAMETZ, (Hebrew) leavened food forbidden during Passover, also CHOMETZ [n]\n",
  "CHAMFER": "to channel or make furrows upon; to bevel [v -ED, -ING, -S]\n",
  "CHAMFERED": "CHAMFER, to channel or make furrows upon; to bevel [v]\n",
  "CHAMFERER": "one who chamfers [n -S]\n",
  "CHAMFERERS": "CHAMFERER, one who chamfers [n]\n",
  "CHAMFERING": "CHAMFER, to channel or make furrows upon; to bevel [v]\n",
  "CHAMFERS": "CHAMFER, to channel or make furrows upon; to bevel [v]\n",
  "CHAMFRAIN": "a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAFFRON, CHAMFRON, CHANFRON [n -S]\n",
  "CHAMFRAINS": "CHAMFRAIN, a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAFFRON, CHAMFRON, CHANFRON [n]\n",
  "CHAMFRON": "a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAFFRON, CHAMFRAIN, CHANFRON [n -S]\n",
  "CHAMFRONS": "CHAMFRON, a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAFFRON, CHAMFRAIN, CHANFRON [n]\n",
  "CHAMISA": "(Spanish) a Californian shrub with white flowers, growing in dense thickets, also CHAMISE, CHAMISO [n -S]\n",
  "CHAMISAL": "(Spanish) a thicket of chamisos [n -S]\n",
  "CHAMISALS": "CHAMISAL, (Spanish) a thicket of chamisos [n]\n",
  "CHAMISAS": "CHAMISA, (Spanish) a Californian shrub with white flowers, growing in dense thickets, also CHAMISE, CHAMISO [n]\n",
  "CHAMISE": "(Spanish) a Californian shrub with white flowers, growing in dense thickets, also CHAMISA, CHAMISO [n -S]\n",
  "CHAMISES": "CHAMISE, (Spanish) a Californian shrub with white flowers, growing in dense thickets, also CHAMISA, CHAMISO [n]\n",
  "CHAMISO": "(Spanish) a Californian shrub with white flowers, growing in dense thickets, also CHAMISA, CHAMISE [n -S]\n",
  "CHAMISOS": "CHAMISO, (Spanish) a Californian shrub with white flowers, growing in dense thickets, also CHAMISA, CHAMISE [n]\n",
  "CHAMLET": "a strong waterproof silk or wool fabric, also CAMELOT, CAMLET, CHAMELOT [n -S]\n",
  "CHAMLETS": "CHAMLET, a strong waterproof silk or wool fabric, also CAMELOT, CAMLET, CHAMELOT [n]\n",
  "CHAMMIED": "CHAMMY, to clean with a chamois [v]\n",
  "CHAMMIES": "CHAMMY, to clean with a chamois [v]\n",
  "CHAMMY": "to clean with a chamois [v CHAMMIED, CHAMMYING, CHAMMIES]\n",
  "CHAMMYING": "CHAMMY, to clean with a chamois [v]\n",
  "CHAMOIS": "(French) a soft leather, also CHAMOIX, SHAMMY [n CHAMOISES or CHAMOIS] / to prepare leather like chamois, also SHAMMY [v -ED, -ING, -ES]\n",
  "CHAMOISED": "CHAMOIS, to prepare leather like chamois, also SHAMMY [v]\n",
  "CHAMOISES": "CHAMOIS, to prepare leather like chamois, also SHAMMY [v]\n",
  "CHAMOISING": "CHAMOIS, to prepare leather like chamois, also SHAMMY [v]\n",
  "CHAMOIX": "a soft leather, also CHAMOIS [n CHAMOIX]\n",
  "CHAMOMILE": "a creeping aromatic plant of the composite family, with yellow-centred white-rayed flowers, formerly much grown for its fragrance, also CAMOMILE [n -S]\n",
  "CHAMOMILES": "CHAMOMILE, a creeping aromatic plant of the composite family, with yellow-centred white-rayed flowers, formerly much grown for its fragrance, also CAMOMILE [n]\n",
  "CHAMP": "to chew noisily [v -ED, -ING, -S]\n",
  "CHAMPAC": "(Hindi) an East Indian tree of the magnolia family, sacred to Hindus, also CHAMPACA, CHAMPAK [n -S]\n",
  "CHAMPACA": "(Hindi) an East Indian tree of the magnolia family, sacred to Hindus, also CHAMPAC, CHAMPAK [n -S]\n",
  "CHAMPACAS": "CHAMPACA, (Hindi) an East Indian tree of the magnolia family, sacred to Hindus, also CHAMPAC, CHAMPAK [n]\n",
  "CHAMPACS": "CHAMPAC, (Hindi) an East Indian tree of the magnolia family, sacred to Hindus, also CHAMPACA, CHAMPAK [n]\n",
  "CHAMPAGNE": "a posh sort of wine [n -S]\n",
  "CHAMPAGNES": "CHAMPAGNE, a posh sort of wine [n]\n",
  "CHAMPAIGN": "an expanse of level, open country, a plain [n -S]\n",
  "CHAMPAIGNS": "CHAMPAIGN, an expanse of level, open country, a plain [n]\n",
  "CHAMPAK": "(Hindi) an East Indian tree of the magnolia family, sacred to Hindus, also CHAMPAC, CHAMPACA [n -S]\n",
  "CHAMPAKS": "CHAMPAK, (Hindi) an East Indian tree of the magnolia family, sacred to Hindus, also CHAMPAC, CHAMPACA [n]\n",
  "CHAMPART": "the division of the produce of land, the right of the feudal lord [n -S]\n",
  "CHAMPARTS": "CHAMPART, the division of the produce of land, the right of the feudal lord [n]\n",
  "CHAMPAS": "(colloq.) champagne [n]\n",
  "CHAMPED": "CHAMP, to chew noisily [v]\n",
  "CHAMPER": "one who champs, or bites [n -S]\n",
  "CHAMPERS": "CHAMPER, one who champs, or bites [n]\n",
  "CHAMPERTIES": "CHAMPERTY, an illegal contract to finance a lawsuit for a percentage fee [n]\n",
  "CHAMPERTOUS": "relating to champerty, an illegal contract to finance a lawsuit for a percentage fee [adj]\n",
  "CHAMPERTY": "an illegal contract to finance a lawsuit for a percentage fee [n CHAMPERTIES]\n",
  "CHAMPIER": "CHAMPY, broken up by the trampling of beasts [adj]\n",
  "CHAMPIEST": "CHAMPY, broken up by the trampling of beasts [adj]\n",
  "CHAMPIGNON": "(French) an edible species of mushroom [n -S]\n",
  "CHAMPIGNONS": "CHAMPIGNON, (French) an edible species of mushroom [n]\n",
  "CHAMPING": "CHAMP, to chew noisily [v]\n",
  "CHAMPION": "to defend or support [v -ED, -ING, -S]\n",
  "CHAMPIONED": "CHAMPION, to defend or support [v]\n",
  "CHAMPIONESS": "a female champion [n -ES]\n",
  "CHAMPIONESSES": "CHAMPIONESS, a female champion [n]\n",
  "CHAMPIONING": "CHAMPION, to defend or support [v]\n",
  "CHAMPIONS": "CHAMPION, to defend or support [v]\n",
  "CHAMPIONSHIP": "the position of honour gained by being champion [n -S]\n",
  "CHAMPIONSHIPS": "CHAMPIONSHIP, the position of honour gained by being champion [n]\n",
  "CHAMPLEVE": "(French) a type of enamel work in which vitreous powders are laid in channels cut in a metal base [n -S]\n",
  "CHAMPLEVES": "CHAMPLEVE, (French) a type of enamel work in which vitreous powders are laid in channels cut in a metal base [n]\n",
  "CHAMPS": "CHAMP, to chew noisily [v]\n",
  "CHAMPY": "broken up by the trampling of beasts [adj CHAMPIER, CHAMPIEST]\n",
  "CHAMS": "CHAM, (obsolete) a prince or chief; a governor, also CHAGAN, KHAN [n]\n",
  "CHANA": "in Indian cookery, the chickpea [n -S]\n",
  "CHANAS": "CHANA, in Indian cookery, the chickpea [n]\n",
  "CHANCE": "to risk [v CHANCED, CHANCING, CHANCES]\n",
  "CHANCED": "CHANCE, to risk [v]\n",
  "CHANCEFUL": "hazardous [adj]\n",
  "CHANCEL": "the part of a church containing the altar and seats for choir [n -S]\n",
  "CHANCELESS": "without chances [adj]\n",
  "CHANCELLERIES": "CHANCELLERY, the position, court, or department of a chancellor, also CHANCELLORY [n]\n",
  "CHANCELLERY": "the position, court, or department of a chancellor, also CHANCELLORY [n CHANCELLERIES]\n",
  "CHANCELLOR": "the secretary of a nobleman, prince, or king [n -S]\n",
  "CHANCELLORIES": "CHANCELLORY, the position, court, or department of a chancellor, also CHANCELLERY [n]\n",
  "CHANCELLORS": "CHANCELLOR, the secretary of a nobleman, prince, or king [n]\n",
  "CHANCELLORSHIP": "the office of chancellor [n -S]\n",
  "CHANCELLORSHIPS": "CHANCELLORSHIP, the office of chancellor [n]\n",
  "CHANCELLORY": "the position, court, or department of a chancellor, also CHANCELLERY [n CHANCELLORIES]\n",
  "CHANCELS": "CHANCEL, the part of a church containing the altar and seats for choir [n]\n",
  "CHANCER": "an opportunist [n -S]\n",
  "CHANCERIES": "CHANCERY, a court of public record [n]\n",
  "CHANCERS": "CHANCER, an opportunist [n]\n",
  "CHANCERY": "a court of public record [n CHANCERIES]\n",
  "CHANCES": "CHANCE, to risk [v]\n",
  "CHANCEY": "risky, also CHANCY [adj CHANCIER, CHANCIEST]\n",
  "CHANCIER": "CHANCY, risky, also CHANCEY [adj]\n",
  "CHANCIEST": "CHANCY, risky, also CHANCEY [adj]\n",
  "CHANCILY": "CHANCY, risky, also CHANCEY [adv]\n",
  "CHANCINESS": "the state of being chancy [n -ES]\n",
  "CHANCINESSES": "CHANCINESS, the state of being chancy [n]\n",
  "CHANCING": "CHANCE, to risk [v]\n",
  "CHANCRE": "(French) a hard nodular swelling, esp. one that develops in the primary stage of syphilis [n -S]\n",
  "CHANCRES": "CHANCRE, (French) a hard nodular swelling, esp. one that develops in the primary stage of syphilis [n]\n",
  "CHANCROID": "a type of venereal sore [n -S]\n",
  "CHANCROIDAL": "of or like a chancroid, a type of venereal sore [adj]\n",
  "CHANCROIDS": "CHANCROID, a type of venereal sore [n]\n",
  "CHANCROUS": "of the nature of a chancre, a type of venereal sore [adj]\n",
  "CHANCY": "risky, also CHANCEY [adj CHANCIER, CHANCIEST]\n",
  "CHANDELIER": "a branched hanging support for several lights, originally candles [n -S]\n",
  "CHANDELIERED": "having a chandelier [adj]\n",
  "CHANDELIERS": "CHANDELIER, a branched hanging support for several lights, originally candles [n]\n",
  "CHANDELLE": "(French) an abrupt, climbing turn of an airplane [n -S] / to perform an abrupt climbing turn [v CHANDELLED, CHANDELLING, CHANDELLES]\n",
  "CHANDELLED": "CHANDELLE, to perform an abrupt climbing turn [v]\n",
  "CHANDELLES": "CHANDELLE, to perform an abrupt climbing turn [v]\n",
  "CHANDELLING": "CHANDELLE, to perform an abrupt climbing turn [v]\n",
  "CHANDLER": "a dealer in provisions [n -S]\n",
  "CHANDLERIES": "CHANDLERY, the business of, premises of, or goods sold by a chandler [n]\n",
  "CHANDLERING": "the profession of chandler [n -S]\n",
  "CHANDLERINGS": "CHANDLERING, the profession of chandler [n]\n",
  "CHANDLERLY": "like a chandler, petty [adj]\n",
  "CHANDLERS": "CHANDLER, a dealer in provisions [n]\n",
  "CHANDLERY": "the business of, premises of, or goods sold by a chandler [n CHANDLERIES]\n",
  "CHANFRON": "a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAFFRON, CHAMFRAIN, CHAMFRON [n -S]\n",
  "CHANFRONS": "CHANFRON, a piece of leather, or plate of steel, to protect the head of a horse in battle, also CHAFFRON, CHAMFRAIN, CHAMFRON [n]\n",
  "CHANG": "a kind of cattle [n -S]\n",
  "CHANGA": "(Hinglish) an expression of approval or agreement [interj]\n",
  "CHANGE": "to make or become different [v CHANGED, CHANGING, CHANGES]\n",
  "CHANGEABILITIES": "CHANGEABILITY, the quality of being changeable [n]\n",
  "CHANGEABILITY": "the quality of being changeable [n CHANGEABILITIES]\n",
  "CHANGEABLE": "given to change [adj CHANGEABLY]\n",
  "CHANGEABLENESS": "the state of being changeable [n]\n",
  "CHANGEABLY": "CHANGEABLE, given to change [adv]\n",
  "CHANGEAROUND": "the act of changing to a different position, also CHANGEROUND [n -S]\n",
  "CHANGEAROUNDS": "CHANGEAROUND, the act of changing to a different position, also CHANGEROUND [n]\n",
  "CHANGED": "CHANGE, to make or become different [v]\n",
  "CHANGEFUL": "full of change [adj CHANGEFULLY]\n",
  "CHANGEFULLY": "CHANGEFUL, full of change [adv]\n",
  "CHANGEFULNESS": "CHANGEFUL, full of change [n]\n",
  "CHANGEFULNESSES": "CHANGEFULNESS, CHANGEFUL, full of change [n]\n",
  "CHANGELESS": "never changing [adj CHANGELESSLY]\n",
  "CHANGELESSLY": "CHANGELESS, never changing [adv]\n",
  "CHANGELESSNESS": "CHANGELESS, never changing [n]\n",
  "CHANGELING": "a child substituted for another, esp. one supposed to be left by the fairies [n -S]\n",
  "CHANGELINGS": "CHANGELING, a child substituted for another, esp. one supposed to be left by the fairies [n]\n",
  "CHANGEOVER": "a conversion, transition [n -S]\n",
  "CHANGEOVERS": "CHANGEOVER, a conversion, transition [n]\n",
  "CHANGER": "one that changes [n -S]\n",
  "CHANGEROUND": "a change of roles, also CHANGEAROUND [n -S]\n",
  "CHANGEROUNDS": "CHANGEROUND, a change of roles, also CHANGEAROUND [n]\n",
  "CHANGERS": "CHANGER, one that changes [n]\n",
  "CHANGES": "CHANGE, to make or become different [v]\n",
  "CHANGEUP": "a type of baseball pitch, a slow pitch thrown like a fastball [n -S]\n",
  "CHANGEUPS": "CHANGEUP, a type of baseball pitch, a slow pitch thrown like a fastball [n]\n",
  "CHANGING": "CHANGE, to make or become different [v]\n",
  "CHANGS": "CHANG, a kind of cattle [n]\n",
  "CHANK": "(Hindi) the shell of several species of sea conch, used to make bangles [n -S]\n",
  "CHANKS": "CHANK, (Hindi) the shell of several species of sea conch, used to make bangles [n]\n",
  "CHANNEL": "to direct along a course [v CHANNELED or CHANNELLED, CHANNELING or CHANNELLING, CHANNELS]\n",
  "CHANNELED": "CHANNEL, to direct along a course [v]\n",
  "CHANNELER": "one who channels, a spirit medium, also CHANNELLER [n -S]\n",
  "CHANNELERS": "CHANNELER, one who channels, a spirit medium, also CHANNELLER [n]\n",
  "CHANNELING": "CHANNEL, to direct along a course [v]\n",
  "CHANNELISATION": "the process of channelising, also CHANNELIZATION [n -S]\n",
  "CHANNELISATIONS": "CHANNELISATION, the process of channelising, also CHANNELIZATION [n]\n",
  "CHANNELISE": "to create or provide a channel for, also CHANNELIZE [v CHANNELISED, CHANNELISING, CHANNELISES]\n",
  "CHANNELISED": "CHANNELISE, to create or provide a channel for, also CHANNELIZE [v]\n",
  "CHANNELISES": "CHANNELISE, to create or provide a channel for, also CHANNELIZE [v]\n",
  "CHANNELISING": "CHANNELISE, to create or provide a channel for, also CHANNELIZE [v]\n",
  "CHANNELIZATION": "the act of channelizing, also CHANNELISATION [n -S]\n",
  "CHANNELIZATIONS": "CHANNELIZATION, the act of channelizing, also CHANNELISATION [n]\n",
  "CHANNELIZE": "to create or provide a channel for, also CHANNELISE [v CHANNELIZED, CHANNELIZING, CHANNELIZES]\n",
  "CHANNELIZED": "CHANNELIZE, to create or provide a channel for, also CHANNELISE [v]\n",
  "CHANNELIZES": "CHANNELIZE, to create or provide a channel for, also CHANNELISE [v]\n",
  "CHANNELIZING": "CHANNELIZE, to create or provide a channel for, also CHANNELISE [v]\n",
  "CHANNELLED": "CHANNEL, to direct along a course [v]\n",
  "CHANNELLER": "one who channels, a spirit medium, also CHANNELER [n -S]\n",
  "CHANNELLERS": "CHANNELLER, one who channels, a spirit medium, also CHANNELER [n]\n",
  "CHANNELLING": "CHANNEL, to direct along a course [v]\n",
  "CHANNELS": "CHANNEL, to direct along a course [v]\n",
  "CHANNER": "(Scots) gravel, shingle [n -S]\n",
  "CHANNERS": "CHANNER, (Scots) gravel, shingle [n]\n",
  "CHANOYO": "(Japanese) a Japanese tea ceremony, also CHADO, SADO, CHANOYU [n -S]\n",
  "CHANOYOS": "CHANOYO, (Japanese) a Japanese tea ceremony, also CHADO, SADO, CHANOYU [n]\n",
  "CHANOYU": "(Japanese) a tea ceremony, also CHADO, CHANOYO, SADO [n -S]\n",
  "CHANOYUS": "CHANOYU, (Japanese) a tea ceremony, also CHADO, CHANOYO, SADO [n]\n",
  "CHANSON": "(French) a song [n -S]\n",
  "CHANSONETTE": "(French) a little song, a ditty [n -S]\n",
  "CHANSONETTES": "CHANSONETTE, (French) a little song, a ditty [n]\n",
  "CHANSONNIER": "a cabaret performer of, esp. satirical, songs [n -S]\n",
  "CHANSONNIERS": "CHANSONNIER, a cabaret performer of, esp. satirical, songs [n]\n",
  "CHANSONS": "CHANSON, (French) a song [n]\n",
  "CHANT": "to recite in a singing manner [v -ED, -ING, -S]\n",
  "CHANTABLE": "that can be chanted [adj]\n",
  "CHANTAGE": "(French) blackmail to prevent exposure of scandalous facts [n -S]\n",
  "CHANTAGES": "CHANTAGE, (French) blackmail to prevent exposure of scandalous facts [n]\n",
  "CHANTARELLE": "(French) a kind of fungus, also CHANTERELLE [n -S]\n",
  "CHANTARELLES": "CHANTARELLE, (French) a kind of fungus, also CHANTERELLE [n]\n",
  "CHANTECLER": "a rooster, also CHANTICLEER [n -S]\n",
  "CHANTECLERS": "CHANTECLER, a rooster, also CHANTICLEER [n]\n",
  "CHANTED": "CHANT, to recite in a singing manner [v]\n",
  "CHANTER": "one who chants, also CHANTOR [n -S]\n",
  "CHANTERELLE": "(French) a kind of fungus, also CHANTARELLE [n -S]\n",
  "CHANTERELLES": "CHANTERELLE, (French) a kind of fungus, also CHANTARELLE [n]\n",
  "CHANTERS": "CHANTER, one who chants, also CHANTOR [n]\n",
  "CHANTEUSE": "(French) a female nightclub singer [n -S]\n",
  "CHANTEUSES": "CHANTEUSE, (French) a female nightclub singer [n]\n",
  "CHANTEY": "a song sung by sailors as they worked, also CHANTIE, CHANTY, SHANTEY, SHANTY [n -S]\n",
  "CHANTEYS": "CHANTEY, a song sung by sailors as they worked, also CHANTIE, CHANTY, SHANTEY, SHANTY [n]\n",
  "CHANTICLEER": "a rooster, also CHANTECLER [n -S]\n",
  "CHANTICLEERS": "CHANTICLEER, a rooster, also CHANTECLER [n]\n",
  "CHANTIE": "a song sung by sailors as they worked, also CHANTEY, CHANTY, SHANTEY, SHANTY [n -S]\n",
  "CHANTIES": "CHANTIE, a song sung by sailors as they worked, also CHANTEY, CHANTY, SHANTEY, SHANTY [n]\n",
  "CHANTILLY": "(French) as in chantilly lace, a type of ornamental lace [adj]\n",
  "CHANTING": "singing [adj CHANTINGLY] / the act of reciting in a singing manner [n -S]\n",
  "CHANTINGLY": "CHANTING, singing [adv]\n",
  "CHANTINGS": "CHANTING, the act of reciting in a singing manner [n]\n",
  "CHANTOR": "one who chants, also CHANTER [n -S]\n",
  "CHANTORS": "CHANTOR, one who chants, also CHANTER [n]\n",
  "CHANTRESS": "a female chanter or singer, also CHAUNTRESS [n -ES]\n",
  "CHANTRESSES": "CHANTRESS, a female chanter or singer, also CHAUNTRESS [n]\n",
  "CHANTRIES": "CHANTRY, a chapel or altar built for prayers for its benefactor's soul, also CHAUNTRY [n]\n",
  "CHANTRY": "a chapel or altar built for prayers for its benefactor's soul, also CHAUNTRY [n CHANTRIES]\n",
  "CHANTS": "CHANT, to recite in a singing manner [v]\n",
  "CHANTY": "a song sung by sailors as they worked, also CHANTEY, CHANTIE, SHANTEY, SHANTY [n CHANTIES]\n",
  "CHANUKIAH": "(Hebrew) a candelabrum having nine branches that is lit during the festival of Hanukkah, also HANUKIAH [n -S]\n",
  "CHANUKIAHS": "CHANUKIAH, (Hebrew) a candelabrum having nine branches that is lit during the festival of Hanukkah, also HANUKIAH [n]\n",
  "CHAO": "(Vietnamese) a monetary unit of Vietnam, also HAO [n -S]\n",
  "CHAOLOGIES": "CHAOLOGY, the study of chaos [n]\n",
  "CHAOLOGIST": "a student of chaology, the study of chaos or chaos theory [n -S]\n",
  "CHAOLOGISTS": "CHAOLOGIST, a student of chaology, the study of chaos or chaos theory [n]\n",
  "CHAOLOGY": "the study of chaos [n CHAOLOGIES]\n",
  "CHAORDIC": "having both chaos and order [adj]\n",
  "CHAOS": "(Greek) a state of total disorder [n -ES]\n",
  "CHAOSES": "CHAOS, (Greek) a state of total disorder [n]\n",
  "CHAOTIC": "confused [adj CHAOTICALLY]\n",
  "CHAOTICALLY": "CHAOTIC, confused [adv]\n",
  "CHAP": "to cause to crack [v CHAPPED, CHAPT, CHAPPING, CHAPS]\n",
  "CHAPARAJOS": "a cowboy's leather riding leggings, also CHAPAREJOS [n]\n",
  "CHAPAREJOS": "a cowboy's leather riding leggings, also CHAPARAJOS [n]\n",
  "CHAPARRAL": "(Spanish) a thicket of low evergreen oaks [n -S]\n",
  "CHAPARRALS": "CHAPARRAL, (Spanish) a thicket of low evergreen oaks [n]\n",
  "CHAPATI": "(Hindi) a thin piece of unleavened bread, also CHAPATTI, CHAPPATI [n CHAPATIS or CHAPATIES]\n",
  "CHAPATIES": "CHAPATI, (Hindi) a thin piece of unleavened bread, also CHAPATTI, CHAPPATI [n]\n",
  "CHAPATIS": "CHAPATI, (Hindi) a thin piece of unleavened bread, also CHAPATTI, CHAPPATI [n]\n",
  "CHAPATTI": "(Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPPATI, CHUPATI, CHUPATTI, CHUPATTY [n CHAPATTIS or CHAPATTIES]\n",
  "CHAPATTIES": "CHAPATTI, (Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPPATI, CHUPATI, CHUPATTI, CHUPATTY [n]\n",
  "CHAPATTIS": "CHAPATTI, (Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPPATI, CHUPATI, CHUPATTI, CHUPATTY [n]\n",
  "CHAPBOOK": "a small book or pamphlet containing stories, poems, or religious tracts [n -S]\n",
  "CHAPBOOKS": "CHAPBOOK, a small book or pamphlet containing stories, poems, or religious tracts [n]\n",
  "CHAPE": "the plate of metal at the point of a scabbard [n -S]\n",
  "CHAPEAU": "(French) a hat [n CHAPEAUS or CHAPEAUX]\n",
  "CHAPEAUS": "CHAPEAU, (French) a hat [n]\n",
  "CHAPEAUX": "CHAPEAU, (French) a hat [n]\n",
  "CHAPEL": "a place of Christian worship in a larger building, esp. a place set apart, with a separate altar, in a church or cathedral [n -S]\n",
  "CHAPELESS": "without a chape, the plate of metal at the point of a scabbard [adj]\n",
  "CHAPELRIES": "CHAPELRY, the jurisdiction of a chapel [n]\n",
  "CHAPELRY": "the jurisdiction of a chapel [n CHAPELRIES]\n",
  "CHAPELS": "CHAPEL, a place of Christian worship in a larger building, esp. a place set apart, with a separate altar, in a church or cathedral [n]\n",
  "CHAPERON": "(French) to accompany and supervise [v -ED, -ING, -S]\n",
  "CHAPERONAGE": "the act of chaperoning [n -S]\n",
  "CHAPERONAGES": "CHAPERONAGE, the act of chaperoning [n]\n",
  "CHAPERONE": "(French) a person who ensures propriety, esp. a married or older woman accompanying a young unmarried woman on social occasions [n -S] / to act as a chaperone, also CHAPERON [v CHAPERONED, CHAPERONING, CHAPERONES]\n",
  "CHAPERONED": "CHAPERON, (French) to accompany and supervise [v]\n",
  "CHAPERONES": "CHAPERONE, to act as a chaperone, also CHAPERON [v]\n",
  "CHAPERONING": "CHAPERON, (French) to accompany and supervise [v]\n",
  "CHAPERONS": "CHAPERON, (French) to accompany and supervise [v]\n",
  "CHAPES": "CHAPE, the plate of metal at the point of a scabbard [n]\n",
  "CHAPESS": "a female chap, also CHAPPESS [n -ES]\n",
  "CHAPESSES": "CHAPESS, a female chap, also CHAPPESS [n]\n",
  "CHAPFALLEN": "dejected, dispirited, also CHOPFALLEN [adj]\n",
  "CHAPITER": "(French) the capital of a column [n -S]\n",
  "CHAPITERS": "CHAPITER, (French) the capital of a column [n]\n",
  "CHAPKA": "(Polish) a Polish military cap, adapted from the traditional peasant cap, worn by lancers, also CZAPKA, SCHAPSKA [n -S]\n",
  "CHAPKAS": "CHAPKA, (Polish) a Polish military cap, adapted from the traditional peasant cap, worn by lancers, also CZAPKA, SCHAPSKA [n]\n",
  "CHAPLAIN": "a Christian clergyman attached to an institution, establishment, organization or family [n -S]\n",
  "CHAPLAINCIES": "CHAPLAINCY, the office of chaplain, also CHAPLAINRY [n]\n",
  "CHAPLAINCY": "the office of chaplain, also CHAPLAINRY [n CHAPLAINCIES]\n",
  "CHAPLAINRIES": "CHAPLAINRY, the office of chaplain, also CHAPLAINCY [n]\n",
  "CHAPLAINRY": "the office of chaplain, also CHAPLAINCY [n CHAPLAINRIES]\n",
  "CHAPLAINS": "CHAPLAIN, a Christian clergyman attached to an institution, establishment, organization or family [n]\n",
  "CHAPLAINSHIP": "the office of chaplain [n -S]\n",
  "CHAPLAINSHIPS": "CHAPLAINSHIP, the office of chaplain [n]\n",
  "CHAPLESS": "having no lower jaw; hence, fleshless [adj]\n",
  "CHAPLET": "a wreath for the head [n -S]\n",
  "CHAPLETED": "having a chaplet, a circlet or wreath for the head [adj]\n",
  "CHAPLETS": "CHAPLET, a wreath for the head [n]\n",
  "CHAPMAN": "a peddler [n CHAPMEN]\n",
  "CHAPMANSHIP": "the profession of chapman [n -S]\n",
  "CHAPMANSHIPS": "CHAPMANSHIP, the profession of chapman [n]\n",
  "CHAPMEN": "CHAPMAN, a peddler [n]\n",
  "CHAPPAL": "(Hindi) a type of open sandal worn in India [n -S]\n",
  "CHAPPALS": "CHAPPAL, (Hindi) a type of open sandal worn in India [n]\n",
  "CHAPPATI": "(Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHUPATI, CHUPATTI, CHUPATTY [n -S]\n",
  "CHAPPATIS": "CHAPPATI, (Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHUPATI, CHUPATTI, CHUPATTY [n]\n",
  "CHAPPED": "CHAP, to cause to crack [v]\n",
  "CHAPPESS": "a female chap, also CHAPESS [n -ES]\n",
  "CHAPPESSES": "CHAPPESS, a female chap, also CHAPESS [n]\n",
  "CHAPPIE": "a familiar diminutive of chap [n -S]\n",
  "CHAPPIER": "CHAPPY, cracked [adj]\n",
  "CHAPPIES": "CHAPPIE, a familiar diminutive of chap [n]\n",
  "CHAPPIEST": "CHAPPY, cracked [adj]\n",
  "CHAPPING": "CHAP, to cause to crack [v]\n",
  "CHAPPY": "cracked [adj CHAPPIER, CHAPPIEST]\n",
  "CHAPRASSI": "(Urdu) an office messenger, a household attendant, also CHUPRASSY [n CHAPRASSIS or CHAPRASSIES]\n",
  "CHAPRASSIES": "CHAPRASSI, (Urdu) an office messenger, a household attendant, also CHUPRASSY [n]\n",
  "CHAPRASSIS": "CHAPRASSI, (Urdu) an office messenger, a household attendant, also CHUPRASSY [n]\n",
  "CHAPS": "CHAP, to cause to crack [v]\n",
  "CHAPSTICK": "a small stick of a substance for soothing chapped lips [n -S]\n",
  "CHAPSTICKS": "CHAPSTICK, a small stick of a substance for soothing chapped lips [n]\n",
  "CHAPT": "CHAP, to cause to crack [v]\n",
  "CHAPTALISATION": "the process of chaptalising, also CHAPTALIZATION [n -S]\n",
  "CHAPTALISATIONS": "CHAPTALISATION, the process of chaptalising, also CHAPTALIZATION [n]\n",
  "CHAPTALISE": "to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALIZE [v CHAPTALISED, CHAPTALISING, CHAPTALISES]\n",
  "CHAPTALISED": "CHAPTALISE, to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALIZE [v]\n",
  "CHAPTALISES": "CHAPTALISE, to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALIZE [v]\n",
  "CHAPTALISING": "CHAPTALISE, to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALIZE [v]\n",
  "CHAPTALIZATION": "the process of chaptalizing, also CHAPTALISATION [n -S]\n",
  "CHAPTALIZATIONS": "CHAPTALIZATION, the process of chaptalizing, also CHAPTALISATION [n]\n",
  "CHAPTALIZE": "to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALISE [v CHAPTALIZED, CHAPTALIZING, CHAPTALIZES]\n",
  "CHAPTALIZED": "CHAPTALIZE, to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALISE [v]\n",
  "CHAPTALIZES": "CHAPTALIZE, to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALISE [v]\n",
  "CHAPTALIZING": "CHAPTALIZE, to add extra sugar to wine during its fermentation to increase its alcohol content, also CHAPTALISE [v]\n",
  "CHAPTER": "to divide a book into main sections [v -ED, -ING, -S]\n",
  "CHAPTERAL": "of or like a chapter [adj]\n",
  "CHAPTERED": "CHAPTER, to divide a book into main sections [v]\n",
  "CHAPTERHOUSE": "the building attached to a cathedral, collegiate church, or religious house in which the chapter meets [n -S]\n",
  "CHAPTERHOUSES": "CHAPTERHOUSE, the building attached to a cathedral, collegiate church, or religious house in which the chapter meets [n]\n",
  "CHAPTERING": "CHAPTER, to divide a book into main sections [v]\n",
  "CHAPTERS": "CHAPTER, to divide a book into main sections [v]\n",
  "CHAPTREL": "the capital of a pillar which supports an arch [n -S]\n",
  "CHAPTRELS": "CHAPTREL, the capital of a pillar which supports an arch [n]\n",
  "CHAQUETA": "(Spanish) a jacket worn by cowboys [n -S]\n",
  "CHAQUETAS": "CHAQUETA, (Spanish) a jacket worn by cowboys [n]\n",
  "CHAR": "to burn slightly, scorch [v CHARRED, CHARRING, CHARS]\n",
  "CHARA": "(Latin) a genus of plantlike algae, having articulated stems and whorled branches, stoneworts etc [n -S]\n",
  "CHARABANC": "(French) a sightseeing motor coach [n -S]\n",
  "CHARABANCS": "CHARABANC, (French) a sightseeing motor coach [n]\n",
  "CHARACID": "any carnivorous freshwater fish of the family Characidae, which includes the pirana, also CHARACIN [n -S]\n",
  "CHARACIDS": "CHARACID, any carnivorous freshwater fish of the family Characidae, which includes the pirana, also CHARACIN [n]\n",
  "CHARACIN": "any carnivorous freshwater fish of the family Characidae, which includes the pirana, also CHARACID [n -S]\n",
  "CHARACINOID": "of or like a characin [adj]\n",
  "CHARACINS": "CHARACIN, any carnivorous freshwater fish of the family Characidae, which includes the pirana, also CHARACID [n]\n",
  "CHARACT": "(obsolete) a letter or symbol impressed on something [n -S]\n",
  "CHARACTER": "a symbol [n -S] / (archaic) to engrave, inscribe [v -ED, -ING, -S]\n",
  "CHARACTERED": "CHARACTER, (archaic) to engrave, inscribe [v]\n",
  "CHARACTERFUL": "full of character [adj]\n",
  "CHARACTERIES": "CHARACTERY, writing; a system of symbols or letters used to express thoughts [n]\n",
  "CHARACTERING": "CHARACTER, (archaic) to engrave, inscribe [v]\n",
  "CHARACTERISABLE": "able to be characterised, also CHARACTERIZABLE [adj]\n",
  "CHARACTERISE": "to give a character to, also CHARACTERIZE [v CHARACTERISED, CHARACTERISING, CHARACTERISES]\n",
  "CHARACTERISED": "CHARACTERISE, to give a character to, also CHARACTERIZE [v]\n",
  "CHARACTERISER": "one who characterises, also CHARACTERIZER [n -S]\n",
  "CHARACTERISERS": "CHARACTERISER, one who characterises, also CHARACTERIZER [n]\n",
  "CHARACTERISES": "CHARACTERISE, to give a character to, also CHARACTERIZE [v]\n",
  "CHARACTERISING": "CHARACTERISE, to give a character to, also CHARACTERIZE [v]\n",
  "CHARACTERISM": "a characteristic [n -S]\n",
  "CHARACTERISMS": "CHARACTERISM, a characteristic [n]\n",
  "CHARACTERISTIC": "a distinguishing trait, quality, or property [n -S]\n",
  "CHARACTERISTICS": "CHARACTERISTIC, a distinguishing trait, quality, or property [n]\n",
  "CHARACTERIZABLE": "able to be characterized, also CHARACTERISABLE [adj]\n",
  "CHARACTERIZE": "to describe the character or quality of, also CHARACTERISE [v CHARACTERIZED, CHARACTERIZING, CHARACTERIZES]\n",
  "CHARACTERIZED": "CHARACTERIZE, to describe the character or quality of, also CHARACTERISE [v]\n",
  "CHARACTERIZER": "one who characterizes, also CHARACTERISER [n -S]\n",
  "CHARACTERIZERS": "CHARACTERIZER, one who characterizes, also CHARACTERISER [n]\n",
  "CHARACTERIZES": "CHARACTERIZE, to describe the character or quality of, also CHARACTERISE [v]\n",
  "CHARACTERIZING": "CHARACTERIZE, to describe the character or quality of, also CHARACTERISE [v]\n",
  "CHARACTERLESS": "without a character [adj]\n",
  "CHARACTEROLOGY": "the study of the development of character [n]\n",
  "CHARACTERS": "CHARACTER, (archaic) to engrave, inscribe [v]\n",
  "CHARACTERY": "writing; a system of symbols or letters used to express thoughts [n CHARACTERIES]\n",
  "CHARACTS": "CHARACT, (obsolete) a letter or symbol impressed on something [n]\n",
  "CHARADE": "(French) a written or (now usually) acted clue from which a syllable of a word or a complete word is to be guessed [n -S]\n",
  "CHARADES": "CHARADE, (French) a written or (now usually) acted clue from which a syllable of a word or a complete word is to be guessed [n]\n",
  "CHARANGA": "(Spanish) a type of orchestra used to perform Cuban music [n -S]\n",
  "CHARANGAS": "CHARANGA, (Spanish) a type of orchestra used to perform Cuban music [n]\n",
  "CHARANGO": "a small South American ten-stringed instrument, made from the shell of an armadillo [n -S]\n",
  "CHARANGOS": "CHARANGO, a small South American ten-stringed instrument, made from the shell of an armadillo [n]\n",
  "CHARAS": "(Hindi) the resinous exudation of hashish, a narcotic and intoxicant, also CHURRUS [n -ES]\n",
  "CHARASES": "CHARAS, (Hindi) the resinous exudation of hashish, a narcotic and intoxicant, also CHURRUS [n]\n",
  "CHARBROIL": "to broil over charcoal [v -ED, -ING, -S]\n",
  "CHARBROILED": "CHARBROIL, to broil over charcoal [v]\n",
  "CHARBROILER": "an apparatus for charbroiling [n -S]\n",
  "CHARBROILERS": "CHARBROILER, an apparatus for charbroiling [n]\n",
  "CHARBROILING": "CHARBROIL, to broil over charcoal [v]\n",
  "CHARBROILS": "CHARBROIL, to broil over charcoal [v]\n",
  "CHARCOAL": "to draw or blacken with charcoal [v -ED, -ING, -S]\n",
  "CHARCOALED": "CHARCOAL, to draw or blacken with charcoal [v]\n",
  "CHARCOALIER": "CHARCOALY, like charcoal [adj]\n",
  "CHARCOALIEST": "CHARCOALY, like charcoal [adj]\n",
  "CHARCOALING": "CHARCOAL, to draw or blacken with charcoal [v]\n",
  "CHARCOALS": "CHARCOAL, to draw or blacken with charcoal [v]\n",
  "CHARCOALY": "like charcoal [adj CHARCOALIER, CHARCOALIEST]\n",
  "CHARCUTERIE": "(French) cold meats made from pork; a shop selling this [n -S]\n",
  "CHARCUTERIES": "CHARCUTERIE, (French) cold meats made from pork; a shop selling this [n]\n",
  "CHARD": "the edible leafstalk of a variety of white beet [n -S]\n",
  "CHARDONNAY": "a type of grape, originally from the Burgundy region of France [n -S]\n",
  "CHARDONNAYS": "CHARDONNAY, a type of grape, originally from the Burgundy region of France [n]\n",
  "CHARDS": "CHARD, the edible leafstalk of a variety of white beet [n]\n",
  "CHARE": "to do odd jobs of work, to do housecleaning, also CHORE [v CHARED, CHARING, CHARES]\n",
  "CHARED": "CHARE, to do odd jobs of work, to do housecleaning, also CHORE [v]\n",
  "CHARES": "CHARE, to do odd jobs of work, to do housecleaning, also CHORE [v]\n",
  "CHARET": "(Spenser) a chariot [n -S]\n",
  "CHARETS": "CHARET, (Spenser) a chariot [n]\n",
  "CHARETTE": "a meeting for brainstorming [n -S]\n",
  "CHARETTES": "CHARETTE, a meeting for brainstorming [n]\n",
  "CHARGE": "to make an attack [v CHARGED, CHARGING, CHARGES]\n",
  "CHARGEABILITIES": "CHARGEABILITY, the quality of being chargeable [n]\n",
  "CHARGEABILITY": "the quality of being chargeable [n CHARGEABILITIES]\n",
  "CHARGEABLE": "that can be charged [adj CHARGEABLY]\n",
  "CHARGEABLENESS": "the state of being chargeable [n]\n",
  "CHARGEABLY": "CHARGEABLE, that can be charged [adv]\n",
  "CHARGEBACK": "the charge a credit card merchant pays to a customer after the customer successfully disputes an item on his or her credit card statement [n -S]\n",
  "CHARGEBACKS": "CHARGEBACK, the charge a credit card merchant pays to a customer after the customer successfully disputes an item on his or her credit card statement [n]\n",
  "CHARGED": "CHARGE, to make an attack [v]\n",
  "CHARGEFUL": "(archaic) costly; expensive [adj]\n",
  "CHARGEHAND": "a foreman [n -S]\n",
  "CHARGEHANDS": "CHARGEHAND, a foreman [n]\n",
  "CHARGELESS": "free from, or with little, charge [adj]\n",
  "CHARGER": "a flat dish; a warhorse [n -S]\n",
  "CHARGERS": "CHARGER, a flat dish; a warhorse [n]\n",
  "CHARGES": "CHARGE, to make an attack [v]\n",
  "CHARGESHEET": "a police document listing details of an accused person and the charges against him or her [n -S]\n",
  "CHARGESHEETS": "CHARGESHEET, a police document listing details of an accused person and the charges against him or her [n]\n",
  "CHARGING": "the act of making a charge [n -S]\n",
  "CHARGINGS": "CHARGING, the act of making a charge [n]\n",
  "CHARGRILL": "to grill over charcoal [v -ED, -ING, -S]\n",
  "CHARGRILLED": "CHARGRILL, to grill over charcoal [v]\n",
  "CHARGRILLING": "CHARGRILL, to grill over charcoal [v]\n",
  "CHARGRILLS": "CHARGRILL, to grill over charcoal [v]\n",
  "CHARIDEE": "a jocular word for charity, also CHARITY [n -S]\n",
  "CHARIDEES": "CHARIDEE, a jocular word for charity, also CHARITY [n]\n",
  "CHARIER": "CHARY, discreetly cautious or sparing [adj]\n",
  "CHARIEST": "CHARY, discreetly cautious or sparing [adj]\n",
  "CHARILY": "CHARY, discreetly cautious or sparing [adv]\n",
  "CHARINESS": "caution, wariness [n -ES]\n",
  "CHARINESSES": "CHARINESS, caution, wariness [n]\n",
  "CHARING": "CHARE, to do odd jobs of work, to do housecleaning, also CHORE [v]\n",
  "CHARIOT": "to ride in a two-wheeled, horse-drawn vehicle [v -ED, -ING, -S]\n",
  "CHARIOTED": "CHARIOT, to ride in a two-wheeled, horse-drawn vehicle [v]\n",
  "CHARIOTEER": "one who drives a chariot [n -S] / to drive in a chariot [v -ED, -ING, -S]\n",
  "CHARIOTEERED": "CHARIOTEER, to drive in a chariot [v]\n",
  "CHARIOTEERING": "CHARIOTEER, to drive in a chariot [v]\n",
  "CHARIOTEERS": "CHARIOTEER, one who drives a chariot [n]\n",
  "CHARIOTING": "CHARIOT, to ride in a two-wheeled, horse-drawn vehicle [v]\n",
  "CHARIOTS": "CHARIOT, to ride in a two-wheeled, horse-drawn vehicle [v]\n",
  "CHARISM": "(Greek) a special magnetic appeal, also CHARISMA [n -S]\n",
  "CHARISMA": "(Greek) a special magnetic appeal, also CHARISM [n CHARISMAS or CHARISMATA]\n",
  "CHARISMAS": "CHARISMA, (Greek) a special magnetic appeal, also CHARISM [n]\n",
  "CHARISMATA": "CHARISMA, (Greek) a special magnetic appeal, also CHARISM [n]\n",
  "CHARISMATIC": "having charisma [adj] / a member of a religious group or movement that stresses the seeking of direct divine inspiration and charisms (as glossolalia or healing) [n -S]\n",
  "CHARISMATICS": "CHARISMATIC, a member of a religious group or movement that stresses the seeking of direct divine inspiration and charisms (as glossolalia or healing) [n]\n",
  "CHARISMS": "CHARISM, (Greek) a special magnetic appeal, also CHARISMA [n]\n",
  "CHARITABLE": "inclined to charity [adj CHARITABLY]\n",
  "CHARITABLENESS": "the state of being charitable [n]\n",
  "CHARITABLY": "CHARITABLE, inclined to charity [adv]\n",
  "CHARITIES": "CHARITY, universal love [n]\n",
  "CHARITY": "universal love [n CHARITIES]\n",
  "CHARIVARI": "(French) a cacophonous mock-serenade performed for a wedding [n -S] / to perform such a serenade, also CHIVAREE, CHIVARI [v -ED, -ING, -S]\n",
  "CHARIVARIED": "CHARIVARI, to perform such a serenade, also CHIVAREE, CHIVARI [v]\n",
  "CHARIVARIING": "CHARIVARI, to perform such a serenade, also CHIVAREE, CHIVARI [v]\n",
  "CHARIVARIS": "CHARIVARI, (French) a cacophonous mock-serenade performed for a wedding [n]\n",
  "CHARK": "to burn wood etc. to charcoal [v -ED, -ING, -S]\n",
  "CHARKA": "(Urdu) a spinning wheel, also CHARKHA [n -S]\n",
  "CHARKAS": "CHARKA, (Urdu) a spinning wheel, also CHARKHA [n]\n",
  "CHARKED": "CHARK, to burn wood etc. to charcoal [v]\n",
  "CHARKHA": "(Urdu) a spinning wheel, also CHARKA [n -S]\n",
  "CHARKHAS": "CHARKHA, (Urdu) a spinning wheel, also CHARKA [n]\n",
  "CHARKING": "CHARK, to burn wood etc. to charcoal [v]\n",
  "CHARKS": "CHARK, to burn wood etc. to charcoal [v]\n",
  "CHARLADIES": "CHARLADY, a cleaning woman [n]\n",
  "CHARLADY": "a cleaning woman [n CHARLADIES]\n",
  "CHARLATAN": "someone who pretends to have special knowledge or ability, esp. one who claims to have medical knowledge [n -S]\n",
  "CHARLATANIC": "of or like a charlatan, also CHARLATANICAL, CHARLATANISTIC [adj]\n",
  "CHARLATANICAL": "of or like a charlatan, also CHARLATANIC, CHARLATANISTIC [adj]\n",
  "CHARLATANISM": "the state of being a charlatan [n -S]\n",
  "CHARLATANISMS": "CHARLATANISM, the state of being a charlatan [n]\n",
  "CHARLATANISTIC": "of or like a charlatan [adj]\n",
  "CHARLATANRIES": "CHARLATANRY, the practice of a charlatan [n]\n",
  "CHARLATANRY": "the practice of a charlatan [n CHARLATANRIES]\n",
  "CHARLATANS": "CHARLATAN, someone who pretends to have special knowledge or ability, esp. one who claims to have medical knowledge [n]\n",
  "CHARLESTON": "a lively dance that involves kicking [n -S] / to dance the charleston [v -ED, -ING, -S]\n",
  "CHARLESTONED": "CHARLESTON, to dance the charleston [v]\n",
  "CHARLESTONING": "CHARLESTON, to dance the charleston [v]\n",
  "CHARLESTONS": "CHARLESTON, a lively dance that involves kicking [n]\n",
  "CHARLEY": "a fool, also CHARLIE [n -S]\n",
  "CHARLEYS": "CHARLEY, a fool, also CHARLIE [n]\n",
  "CHARLIE": "a fool, also CHARLEY [n -S]\n",
  "CHARLIER": "as in charlier shoe, a light horseshoe [adj]\n",
  "CHARLIES": "CHARLIE, a fool, also CHARLEY [n]\n",
  "CHARLOCK": "a weedy plant with yellow flowers [n -S]\n",
  "CHARLOCKS": "CHARLOCK, a weedy plant with yellow flowers [n]\n",
  "CHARLOTTE": "(French) a kind of pie or pudding made by lining a dish with slices of bread, and filling it with bread soaked in milk, and baked [n -S]\n",
  "CHARLOTTES": "CHARLOTTE, (French) a kind of pie or pudding made by lining a dish with slices of bread, and filling it with bread soaked in milk, and baked [n]\n",
  "CHARM": "to enchant [v -ED, -ING, -S]\n",
  "CHARMED": "CHARM, to enchant [v]\n",
  "CHARMER": "one that charms [n -S]\n",
  "CHARMERS": "CHARMER, one that charms [n]\n",
  "CHARMEUSE": "(French) a soft satiny material [n -S]\n",
  "CHARMEUSES": "CHARMEUSE, (French) a soft satiny material [n]\n",
  "CHARMFUL": "full of charm [adj]\n",
  "CHARMING": "having charm [adj CHARMINGER, CHARMINGEST, CHARMINGLY]\n",
  "CHARMINGER": "CHARMING, having charm [adj]\n",
  "CHARMINGEST": "CHARMING, having charm [adj]\n",
  "CHARMINGLY": "CHARMING, having charm [adv]\n",
  "CHARMLESS": "without charm [adj CHARMLESSLY]\n",
  "CHARMLESSLY": "CHARMLESS, without charm [adv]\n",
  "CHARMONIA": "CHARMONIUM, any of various elementary particles consisting of a charm quark and an antiquark [n]\n",
  "CHARMONIUM": "any of various elementary particles consisting of a charm quark and an antiquark [n CHARMONIA]\n",
  "CHARMS": "CHARM, to enchant [v]\n",
  "CHARNECO": "(Shakespeare) a kind of sweet wine [n -S]\n",
  "CHARNECOS": "CHARNECO, (Shakespeare) a kind of sweet wine [n]\n",
  "CHARNEL": "a room where corpses are placed [n -S]\n",
  "CHARNELS": "CHARNEL, a room where corpses are placed [n]\n",
  "CHAROSET": "(Hebrew) a condiment of chopped apples, walnuts, and wine, also CHAROSETH, HAROSET, HAROSETH [n -S]\n",
  "CHAROSETH": "(Hebrew) a condiment of chopped apples, walnuts, and wine, also CHAROSET, HAROSET, HAROSETH [n -S]\n",
  "CHAROSETHS": "CHAROSETH, (Hebrew) a condiment of chopped apples, walnuts, and wine, also CHAROSET, HAROSET, HAROSETH [n]\n",
  "CHAROSETS": "CHAROSET, (Hebrew) a condiment of chopped apples, walnuts, and wine, also CHAROSETH, HAROSET, HAROSETH [n]\n",
  "CHARPAI": "(Urdu) a string framed bed, also CHARPOY [n -S]\n",
  "CHARPAIS": "CHARPAI, (Urdu) a string framed bed, also CHARPOY [n]\n",
  "CHARPIE": "(French) shredded lint used to dress wounds [n -S]\n",
  "CHARPIES": "CHARPIE, (French) shredded lint used to dress wounds [n]\n",
  "CHARPOY": "(Urdu) a string framed bed, also CHARPAI [n -S]\n",
  "CHARPOYS": "CHARPOY, (Urdu) a string framed bed, also CHARPAI [n]\n",
  "CHARQUI": "jerked beef [n -S]\n",
  "CHARQUID": "made into charqui, jerked [adj]\n",
  "CHARQUIS": "CHARQUI, jerked beef [n]\n",
  "CHARR": "a small fish of the salmon family [n -S]\n",
  "CHARREADA": "(Spanish) a Mexican entertainment involving competitive riding and herding events [n -S]\n",
  "CHARREADAS": "CHARREADA, (Spanish) a Mexican entertainment involving competitive riding and herding events [n]\n",
  "CHARRED": "CHAR, to burn slightly, scorch [v]\n",
  "CHARRIER": "CHARRY, resembling charcoal [adj]\n",
  "CHARRIEST": "CHARRY, resembling charcoal [adj]\n",
  "CHARRING": "CHAR, to burn slightly, scorch [v]\n",
  "CHARRO": "(Spanish) a Mexican cowboy, esp. one elaborately dressed [n -S]\n",
  "CHARROS": "CHARRO, (Spanish) a Mexican cowboy, esp. one elaborately dressed [n]\n",
  "CHARRS": "CHARR, a small fish of the salmon family [n]\n",
  "CHARRY": "resembling charcoal [adj CHARRIER, CHARRIEST]\n",
  "CHARS": "CHAR, to burn slightly, scorch [v]\n",
  "CHART": "to map out [v -ED, -ING, -S]\n",
  "CHARTA": "(Latin) a charter, also CARTA [n -S]\n",
  "CHARTABLE": "that can be charted [adj]\n",
  "CHARTACEOUS": "papery [adj]\n",
  "CHARTAS": "CHARTA, (Latin) a charter, also CARTA [n]\n",
  "CHARTED": "CHART, to map out [v]\n",
  "CHARTER": "to lease or hire (a ship, aircraft etc.) [v -ED, -ING, -S]\n",
  "CHARTERED": "CHARTER, to lease or hire (a ship, aircraft etc.) [v]\n",
  "CHARTERER": "one who charters; esp. one who hires a ship for a voyage [n -S]\n",
  "CHARTERERS": "CHARTERER, one who charters; esp. one who hires a ship for a voyage [n]\n",
  "CHARTERING": "CHARTER, to lease or hire (a ship, aircraft etc.) [v]\n",
  "CHARTERPARTIES": "CHARTERPARTY, the common written form in which a contract of affreightment is expressed [n]\n",
  "CHARTERPARTY": "the common written form in which a contract of affreightment is expressed [n CHARTERPARTIES]\n",
  "CHARTERS": "CHARTER, to lease or hire (a ship, aircraft etc.) [v]\n",
  "CHARTHOUSE": "a room in a ship where charts are kept [n -S]\n",
  "CHARTHOUSES": "CHARTHOUSE, a room in a ship where charts are kept [n]\n",
  "CHARTING": "CHART, to map out [v]\n",
  "CHARTISM": "the use of charts in the study of future trends [n -S]\n",
  "CHARTISMS": "CHARTISM, the use of charts in the study of future trends [n]\n",
  "CHARTIST": "one who uses charts to predict stock market trends [n -S]\n",
  "CHARTISTS": "CHARTIST, one who uses charts to predict stock market trends [n]\n",
  "CHARTLESS": "without a chart; having no guide [adj]\n",
  "CHARTOGRAPHER": "one who draws maps, also CARTOGRAPHER [n -S]\n",
  "CHARTOGRAPHERS": "CHARTOGRAPHER, one who draws maps, also CARTOGRAPHER [n]\n",
  "CHARTOGRAPHIC": "relating to the drawing of maps, also CARTOGRAPHIC, CARTOGRAPHICAL, CHARTOGRAPHICAL [adj]\n",
  "CHARTOGRAPHICAL": "relating to the drawing of maps, also CARTOGRAPHIC, CARTOGRAPHICAL, CHARTOGRAPHIC [adj]\n",
  "CHARTOGRAPHIES": "CHARTOGRAPHY, the drawing of maps, also CARTOGRAPHY [n]\n",
  "CHARTOGRAPHY": "the drawing of maps, also CARTOGRAPHY [n CHARTOGRAPHIES]\n",
  "CHARTREUSE": "(French) a light, yellowish green [n -S]\n",
  "CHARTREUSES": "CHARTREUSE, (French) a light, yellowish green [n]\n",
  "CHARTS": "CHART, to map out [v]\n",
  "CHARTULARIES": "CHARTULARY, a collection of deeds and titles to estate or monastery [n]\n",
  "CHARTULARY": "a collection of deeds and titles to estate or monastery [n CHARTULARIES]\n",
  "CHARVER": "(dialect) a young woman [n -S]\n",
  "CHARVERS": "CHARVER, (dialect) a young woman [n]\n",
  "CHARWOMAN": "a woman hired by the hour or day or week to clean rooms in offices or houses, also CHARLADY [n CHARWOMEN]\n",
  "CHARWOMEN": "CHARWOMAN, a woman hired by the hour or day or week to clean rooms in offices or houses, also CHARLADY [n]\n",
  "CHARY": "discreetly cautious or sparing [adj CHARIER, CHARIEST, CHARILY]\n",
  "CHAS": "CHA, (colloquial) tea [n]\n",
  "CHASE": "to pursue [v CHASED, CHASING, CHASES]\n",
  "CHASEABLE": "that can be chased [adj]\n",
  "CHASED": "CHASE, to pursue [v]\n",
  "CHASEPORT": "the porthole at the bow or stern of a naval ship [n -S]\n",
  "CHASEPORTS": "CHASEPORT, the porthole at the bow or stern of a naval ship [n]\n",
  "CHASER": "one that chases [n -S]\n",
  "CHASERS": "CHASER, one that chases [n]\n",
  "CHASES": "CHASE, to pursue [v]\n",
  "CHASING": "a design engraved on metal [n -S]\n",
  "CHASINGS": "CHASING, a design engraved on metal [n]\n",
  "CHASM": "a deep cleft in the earth [n -S]\n",
  "CHASMAL": "of or like a chasm, also CHASMIC [adj]\n",
  "CHASMED": "having a chasm [adj]\n",
  "CHASMIC": "of or like a chasm, also CHASMAL [adj]\n",
  "CHASMIER": "CHASMY, full of chasms [adj]\n",
  "CHASMIEST": "CHASMY, full of chasms [adj]\n",
  "CHASMOGAMIC": "related to chasmogamy, the opening of a flower in order to be fertilized, also CHASMOGAMOUS [adj]\n",
  "CHASMOGAMIES": "CHASMOGAMY, the opening of a flower in order to be fertilized [n]\n",
  "CHASMOGAMOUS": "relating to chasmogamy, the opening of a flower in order to be fertilized, also CHASMOGAMIC [adj]\n",
  "CHASMOGAMY": "the opening of a flower in order to be fertilized [n CHASMOGAMIES]\n",
  "CHASMS": "CHASM, a deep cleft in the earth [n]\n",
  "CHASMY": "full of chasms [adj CHASMIER, CHASMIEST]\n",
  "CHASSE": "(French) to perform a dance movement [v CHASSEED or CHASSED, CHASSEING, CHASSES]\n",
  "CHASSED": "CHASSE, (French) to perform a dance movement [v]\n",
  "CHASSEED": "CHASSE, (French) to perform a dance movement [v]\n",
  "CHASSEING": "CHASSE, (French) to perform a dance movement [v]\n",
  "CHASSEPOT": "(French) a kind of breech-loading, center-fire rifle, or improved needle gun [n -S]\n",
  "CHASSEPOTS": "CHASSEPOT, (French) a kind of breech-loading, center-fire rifle, or improved needle gun [n]\n",
  "CHASSES": "CHASSE, (French) to perform a dance movement [v]\n",
  "CHASSEUR": "(French) a cavalry soldier [n -S]\n",
  "CHASSEURS": "CHASSEUR, (French) a cavalry soldier [n]\n",
  "CHASSIS": "(French) the structural framework of a motor car to which the movable working parts and body may be attached [n CHASSIS]\n",
  "CHASTE": "sexually virtuous [adj CHASTER, CHASTEST, CHASTELY]\n",
  "CHASTELY": "CHASTE, sexually virtuous [adv]\n",
  "CHASTEN": "to chastise [v -ED, -ING, -S]\n",
  "CHASTENED": "CHASTEN, to chastise [v]\n",
  "CHASTENER": "one who chastens [n -S]\n",
  "CHASTENERS": "CHASTENER, one who chastens [n]\n",
  "CHASTENESS": "the state of being chaste [n -ES]\n",
  "CHASTENESSES": "CHASTENESS, the state of being chaste [n]\n",
  "CHASTENING": "CHASTEN, to chastise [v]\n",
  "CHASTENINGLY": "CHASTENING, CHASTEN, to chastise [adv]\n",
  "CHASTENMENT": "the state of being chastened [n -S]\n",
  "CHASTENMENTS": "CHASTENMENT, the state of being chastened [n]\n",
  "CHASTENS": "CHASTEN, to chastise [v]\n",
  "CHASTER": "CHASTE, sexually virtuous [adj]\n",
  "CHASTEST": "CHASTE, sexually virtuous [adj]\n",
  "CHASTISABLE": "capable of being chastised [adj]\n",
  "CHASTISE": "to discipline by punishment [v CHASTISED, CHASTISING, CHASTISES]\n",
  "CHASTISED": "CHASTISE, to discipline by punishment [v]\n",
  "CHASTISEMENT": "the act of chastising [n -S]\n",
  "CHASTISEMENTS": "CHASTISEMENT, the act of chastising [n]\n",
  "CHASTISER": "one who chastises [n -S]\n",
  "CHASTISERS": "CHASTISER, one who chastises [n]\n",
  "CHASTISES": "CHASTISE, to discipline by punishment [v]\n",
  "CHASTISING": "CHASTISE, to discipline by punishment [v]\n",
  "CHASTITIES": "CHASTITY, moral purity [n]\n",
  "CHASTITY": "moral purity [n CHASTITIES]\n",
  "CHASUBLE": "a sleeveless ecclesiastical garment [n -S]\n",
  "CHASUBLES": "CHASUBLE, a sleeveless ecclesiastical garment [n]\n",
  "CHAT": "to talk informally [v CHATTED, CHATTING, CHATS]\n",
  "CHATBOT": "a program which gives an automated reply to email [n -S]\n",
  "CHATBOTS": "CHATBOT, a program which gives an automated reply to email [n]\n",
  "CHATCHKA": "(Yiddish) a knickknack, also CHACHKA, CHATCHKE, TSATSKE, TCHOTCHKE [n -S]\n",
  "CHATCHKAS": "CHATCHKA, (Yiddish) a knickknack, also CHACHKA, CHATCHKE, TSATSKE, TCHOTCHKE [n]\n",
  "CHATCHKE": "(Yiddish) a knicknack, also CHACHKA, CHATCHKA, TSATSKE, TCHOTCHKE [n -S]\n",
  "CHATCHKES": "CHATCHKE, (Yiddish) a knicknack, also CHACHKA, CHATCHKA, TSATSKE, TCHOTCHKE [n]\n",
  "CHATEAU": "(French) a large country house [n CHATEAUS or CHATEAUX]\n",
  "CHATEAUBRIAND": "a large tenderloin steak usually grilled or broiled and served with a sauce [n -S]\n",
  "CHATEAUBRIANDS": "CHATEAUBRIAND, a large tenderloin steak usually grilled or broiled and served with a sauce [n]\n",
  "CHATEAUS": "CHATEAU, (French) a large country house [n]\n",
  "CHATEAUX": "CHATEAU, (French) a large country house [n]\n",
  "CHATELAIN": "(French) the governor of a castle or fortification, also CASTELLAN [n -S]\n",
  "CHATELAINE": "the governess of a castle [n -S]\n",
  "CHATELAINES": "CHATELAINE, the governess of a castle [n]\n",
  "CHATELAINS": "CHATELAIN, (French) the governor of a castle or fortification, also CASTELLAN [n]\n",
  "CHATLINE": "a television service in which callers contact each other through a monitored central switchboard [n -S]\n",
  "CHATLINES": "CHATLINE, a television service in which callers contact each other through a monitored central switchboard [n]\n",
  "CHATON": "(French) the setting or stone of a finger-ring [n -S]\n",
  "CHATONS": "CHATON, (French) the setting or stone of a finger-ring [n]\n",
  "CHATOYANCE": "the quality of being chatoyant, having a changing lustre, also CHATOYANCY [n -S]\n",
  "CHATOYANCES": "CHATOYANCE, the quality of being chatoyant, having a changing lustre, also CHATOYANCY [n]\n",
  "CHATOYANCIES": "CHATOYANCY, the quality of being chatoyant, having a changing lustre, also CHATOYANCE [n]\n",
  "CHATOYANCY": "the quality of being chatoyant, having a changing lustre, also CHATOYANCE [n CHATOYANCIES]\n",
  "CHATOYANT": "(French) having a changeable luster like that of a cat's eye at night [adj] / a chatoyant gemstone, such as a cat's eye [n -S]\n",
  "CHATOYANTS": "CHATOYANT, a chatoyant gemstone, such as a cat's eye [n]\n",
  "CHATROOM": "a virtual room for computer conversation [n -S]\n",
  "CHATROOMS": "CHATROOM, a virtual room for computer conversation [n]\n",
  "CHATS": "CHAT, to talk informally [v]\n",
  "CHATTA": "(Hindi) an umbrella [n -S]\n",
  "CHATTAS": "CHATTA, (Hindi) an umbrella [n]\n",
  "CHATTED": "CHAT, to talk informally [v]\n",
  "CHATTEL": "any kind of property which is not freehold [n -S]\n",
  "CHATTELS": "CHATTEL, any kind of property which is not freehold [n]\n",
  "CHATTER": "to talk idly [v -ED, -ING, -S]\n",
  "CHATTERATI": "(colloquial) the chattering classes [n]\n",
  "CHATTERBOX": "a talkative person [n -ES]\n",
  "CHATTERBOXES": "CHATTERBOX, a talkative person [n]\n",
  "CHATTERED": "CHATTER, to talk idly [v]\n",
  "CHATTERER": "one who chatters [n -S]\n",
  "CHATTERERS": "CHATTERER, one who chatters [n]\n",
  "CHATTERIER": "CHATTERY, full of chatter [adj]\n",
  "CHATTERIEST": "CHATTERY, full of chatter [adj]\n",
  "CHATTERING": "talking rapidly and trivially [n -S]\n",
  "CHATTERINGS": "CHATTERING, talking rapidly and trivially [n]\n",
  "CHATTERS": "CHATTER, to talk idly [v]\n",
  "CHATTERY": "full of chatter [adj CHATTERIER, CHATTERIEST]\n",
  "CHATTI": "(Hindi) an earthenware water pot, also CHATTY [n -S]\n",
  "CHATTIER": "CHATTY, talkative [adj]\n",
  "CHATTIES": "CHATTY, a type of water-pot [n]\n",
  "CHATTIEST": "CHATTY, talkative [adj]\n",
  "CHATTILY": "CHATTY, talkative [adv]\n",
  "CHATTINESS": "the state of being chatty [n -ES]\n",
  "CHATTINESSES": "CHATTINESS, the state of being chatty [n]\n",
  "CHATTING": "CHAT, to talk informally [v]\n",
  "CHATTIS": "CHATTI, (Hindi) an earthenware water pot, also CHATTY [n]\n",
  "CHATTY": "a type of water-pot [n CHATTIES] / talkative [adj CHATTIER, CHATTIEST, CHATTILY]\n",
  "CHAUDFROID": "a jellied sauce, or a dish, e.g. of chicken, including it [n -S]\n",
  "CHAUDFROIDS": "CHAUDFROID, a jellied sauce, or a dish, e.g. of chicken, including it [n]\n",
  "CHAUFE": "(Spenser) to chafe [v CHAUFED, CHAUFING, CHAUFES]\n",
  "CHAUFED": "CHAUFE, (Spenser) to chafe [v]\n",
  "CHAUFER": "a metal box for holding fire, also CHAUFFER [n -S]\n",
  "CHAUFERS": "CHAUFER, a metal box for holding fire, also CHAUFFER [n]\n",
  "CHAUFES": "CHAUFE, (Spenser) to chafe [v]\n",
  "CHAUFF": "(Spenser) to chafe, also CHAUFE [v -ED, -ING, -S]\n",
  "CHAUFFED": "CHAUFF, (Spenser) to chafe, also CHAUFE [v]\n",
  "CHAUFFER": "a metal box for holding fire, also CHAUFER [n -S]\n",
  "CHAUFFERS": "CHAUFFER, a metal box for holding fire, also CHAUFER [n]\n",
  "CHAUFFEUR": "(French) one who drives car for another [n -S] / to drive a car for another [v -ED, -ING, -S]\n",
  "CHAUFFEURED": "CHAUFFEUR, to drive a car for another [v]\n",
  "CHAUFFEURING": "CHAUFFEUR, to drive a car for another [v]\n",
  "CHAUFFEURS": "CHAUFFEUR, to drive a car for another [v]\n",
  "CHAUFFEUSE": "(French) a female chauffeur [n -S] / to act as a chauffeuse [v CHAUFFEUSED, CHAUFFEUSING, CHAUFFEUSES]\n",
  "CHAUFFEUSED": "CHAUFFEUSE, to act as a chauffeuse [v]\n",
  "CHAUFFEUSES": "CHAUFFEUSE, (French) a female chauffeur [n]\n",
  "CHAUFFEUSING": "CHAUFFEUSE, to act as a chauffeuse [v]\n",
  "CHAUFFING": "CHAUFF, (Spenser) to chafe, also CHAUFE [v]\n",
  "CHAUFFS": "CHAUFF, (Spenser) to chafe, also CHAUFE [v]\n",
  "CHAUFING": "CHAUFE, (Spenser) to chafe [v]\n",
  "CHAULMOOGRA": "a kind of Asian tree, yielding an oil used in the treatment of leprosy, also CHAULMUGRA [n -S]\n",
  "CHAULMOOGRAS": "CHAULMOOGRA, a kind of Asian tree, yielding an oil used in the treatment of leprosy, also CHAULMUGRA [n]\n",
  "CHAULMUGRA": "a kind of Asian tree, yielding an oil used in the treatment of leprosy, also CHAULMOOGRA [n -S]\n",
  "CHAULMUGRAS": "CHAULMUGRA, a kind of Asian tree, yielding an oil used in the treatment of leprosy, also CHAULMOOGRA [n]\n",
  "CHAUMER": "(Scots) a room or building in which male farmworkers sleep [n -S]\n",
  "CHAUMERS": "CHAUMER, (Scots) a room or building in which male farmworkers sleep [n]\n",
  "CHAUNCE": "(obsolete) to chance [v CHAUNCED, CHAUNCING, CHAUNCES]\n",
  "CHAUNCED": "CHAUNCE, (obsolete) to chance [v]\n",
  "CHAUNCES": "CHAUNCE, (obsolete) to chance [v]\n",
  "CHAUNCING": "CHAUNCE, (obsolete) to chance [v]\n",
  "CHAUNGE": "(obsolete) to change [v CHAUNGED, CHAUNGING, CHAUNGES]\n",
  "CHAUNGED": "CHAUNGE, (obsolete) to change [v]\n",
  "CHAUNGES": "CHAUNGE, (obsolete) to change [v]\n",
  "CHAUNGING": "CHAUNGE, (obsolete) to change [v]\n",
  "CHAUNT": "to sing, also CHANT [v -ED, -ING, -S]\n",
  "CHAUNTED": "CHAUNT, to sing, also CHANT [v]\n",
  "CHAUNTER": "a singer; a precentor, also CHANTER, CHANTOR [n -S]\n",
  "CHAUNTERS": "CHAUNTER, a singer; a precentor, also CHANTER, CHANTOR [n]\n",
  "CHAUNTING": "CHAUNT, to sing, also CHANT [v]\n",
  "CHAUNTRESS": "a female chanter or singer, also CHANTRESS [n -ES]\n",
  "CHAUNTRESSES": "CHAUNTRESS, a female chanter or singer, also CHANTRESS [n]\n",
  "CHAUNTRIES": "CHAUNTRY, a chapel or altar built for prayers for its benefactor's soul, also CHANTRY [n]\n",
  "CHAUNTRY": "a chapel or altar built for prayers for its benefactor's soul, also CHANTRY [n CHAUNTRIES]\n",
  "CHAUNTS": "CHAUNT, to sing, also CHANT [v]\n",
  "CHAUSSES": "pantaloons or tight coverings for the legs and feet, esp. of mail [n]\n",
  "CHAUSSURE": "(French) a foot covering of any kind [n -S]\n",
  "CHAUSSURES": "CHAUSSURE, (French) a foot covering of any kind [n]\n",
  "CHAUTAUQUA": "an outdoor meeting of an educational type popular in the US in the nineteenth century [n -S]\n",
  "CHAUTAUQUAS": "CHAUTAUQUA, an outdoor meeting of an educational type popular in the US in the nineteenth century [n]\n",
  "CHAUVIN": "(French) one with excessive pride in his own country [n -S]\n",
  "CHAUVINISM": "excessive or blind patriotism [n -S]\n",
  "CHAUVINISMS": "CHAUVINISM, excessive or blind patriotism [n]\n",
  "CHAUVINIST": "one who is blindly patriotic [n -S]\n",
  "CHAUVINISTIC": "relating to chauvinism [adj]\n",
  "CHAUVINISTS": "CHAUVINIST, one who is blindly patriotic [n]\n",
  "CHAUVINS": "CHAUVIN, (French) one with excessive pride in his own country [n]\n",
  "CHAV": "(colloquial) a young working class person who wears casual sports clothes [n -S]\n",
  "CHAVE": "(dialect) I have [v]\n",
  "CHAVENDER": "another name for the chub, a fish [n -S]\n",
  "CHAVENDERS": "CHAVENDER, another name for the chub, a fish [n]\n",
  "CHAVETTE": "a female chav [n -S]\n",
  "CHAVETTES": "CHAVETTE, a female chav [n]\n",
  "CHAVISH": "like a chav [adj]\n",
  "CHAVS": "CHAV, (colloquial) a young working class person who wears casual sports clothes [n]\n",
  "CHAVTASTIC": "suitable for use by a chav [adj]\n",
  "CHAVVIER": "CHAVVY, like a chav [adj]\n",
  "CHAVVIEST": "CHAVVY, like a chav [adj]\n",
  "CHAVVY": "like a chav [adj CHAVVIER, CHAVVIEST]\n",
  "CHAW": "to chew esp. tobacco [v -ED, -ING, -S]\n",
  "CHAWBACON": "a bumpkin, a hick [n -S]\n",
  "CHAWBACONS": "CHAWBACON, a bumpkin, a hick [n]\n",
  "CHAWDRON": "(Shakespeare) the entrails of an animal [n -S]\n",
  "CHAWDRONS": "CHAWDRON, (Shakespeare) the entrails of an animal [n]\n",
  "CHAWED": "CHAW, to chew esp. tobacco [v]\n",
  "CHAWER": "one who chaws, also CHEWER [n -S]\n",
  "CHAWERS": "CHAWER, one who chaws, also CHEWER [n]\n",
  "CHAWING": "CHAW, to chew esp. tobacco [v]\n",
  "CHAWK": "(Cornish dialect) a jackdaw [n -S]\n",
  "CHAWKS": "CHAWK, (Cornish dialect) a jackdaw [n]\n",
  "CHAWS": "CHAW, to chew esp. tobacco [v]\n",
  "CHAY": "(Tamil) an Indian plant of the madder family whose root chayroot yields a red dye, also CHAYA, SHAYA [n -S]\n",
  "CHAYA": "(Tamil) an Indian plant of the madder family whose root chayroot yields a red dye, also CHAY, SHAYA [n -S]\n",
  "CHAYAS": "CHAYA, (Tamil) an Indian plant of the madder family whose root chayroot yields a red dye, also CHAY, SHAYA [n]\n",
  "CHAYOTE": "(Nahuatl) a tropical American vine, aka choko or chocho; its edible fruit eaten as a vegetable [n -S]\n",
  "CHAYOTES": "CHAYOTE, (Nahuatl) a tropical American vine, aka choko or chocho; its edible fruit eaten as a vegetable [n]\n",
  "CHAYROOT": "the root of the chay, an Indian plant of the madder family [n -S]\n",
  "CHAYROOTS": "CHAYROOT, the root of the chay, an Indian plant of the madder family [n]\n",
  "CHAYS": "CHAY, (Tamil) an Indian plant of the madder family whose root chayroot yields a red dye, also CHAYA, SHAYA [n]\n",
  "CHAZAN": "(Hebrew) a cantor in a synagogue, also CHAZZAN, CHAZZEN, HAZAN, HAZZAN, KHAZEN [n CHAZANIM or CHAZANS]\n",
  "CHAZANIM": "CHAZAN, (Hebrew) a cantor in a synagogue, also CHAZZAN, CHAZZEN, HAZAN, HAZZAN, KHAZEN [n]\n",
  "CHAZANS": "CHAZAN, (Hebrew) a cantor in a synagogue, also CHAZZAN, CHAZZEN, HAZAN, HAZZAN, KHAZEN [n]\n",
  "CHAZZAN": "(Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZEN, HAZAN, HAZZAN, KHAZEN [n CHAZZANS or CHAZZANIM]\n",
  "CHAZZANIM": "CHAZZAN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZEN, HAZAN, HAZZAN, KHAZEN [n]\n",
  "CHAZZANS": "CHAZZAN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZEN, HAZAN, HAZZAN, KHAZEN [n]\n",
  "CHAZZEN": "(Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, HAZAN, HAZZAN, KHAZEN [n CHAZZENS or CHAZZENIM]\n",
  "CHAZZENIM": "CHAZZEN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, HAZAN, HAZZAN, KHAZEN [n]\n",
  "CHAZZENS": "CHAZZEN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, HAZAN, HAZZAN, KHAZEN [n]\n",
  "CHE": "(dialect) I, also CH [pron]\n",
  "CHEAP": "inexpensive [adj CHEAPER, CHEAPEST, CHEAPLY] / to take a cheap option [v -ED, -ING, -S]\n",
  "CHEAPED": "CHEAP, to take a cheap option [v]\n",
  "CHEAPEN": "to lower the value of [v -ED, -ING, -S]\n",
  "CHEAPENED": "CHEAPEN, to lower the value of [v]\n",
  "CHEAPENER": "one who makes cheap [n -S]\n",
  "CHEAPENERS": "CHEAPENER, one who makes cheap [n]\n",
  "CHEAPENING": "CHEAPEN, to lower the value of [v]\n",
  "CHEAPENS": "CHEAPEN, to lower the value of [v]\n",
  "CHEAPER": "CHEAP, inexpensive [adj]\n",
  "CHEAPEST": "CHEAP, inexpensive [adj]\n",
  "CHEAPIE": "(colloquial) something cheap, also CHEAPO, CHEAPY [n -S]\n",
  "CHEAPIES": "CHEAPIE, (colloquial) something cheap, also CHEAPO, CHEAPY [n]\n",
  "CHEAPING": "CHEAP, to take a cheap option [v]\n",
  "CHEAPISH": "somewhat cheap [adj CHEAPISHLY]\n",
  "CHEAPISHLY": "CHEAPISH, somewhat cheap [adv]\n",
  "CHEAPJACK": "a travelling hawker who professes to give a great bargain [n -S]\n",
  "CHEAPJACKS": "CHEAPJACK, a travelling hawker who professes to give a great bargain [n]\n",
  "CHEAPLY": "CHEAP, inexpensive [adv]\n",
  "CHEAPNESS": "the state of being cheap [n -ES]\n",
  "CHEAPNESSES": "CHEAPNESS, the state of being cheap [n]\n",
  "CHEAPO": "(colloquial) something cheap, also CHEAPIE, CHEAPY [n -S]\n",
  "CHEAPOS": "CHEAPO, (colloquial) something cheap, also CHEAPIE, CHEAPY [n]\n",
  "CHEAPS": "CHEAP, to take a cheap option [v]\n",
  "CHEAPSHOT": "an abusive remark [n -S]\n",
  "CHEAPSHOTS": "CHEAPSHOT, an abusive remark [n]\n",
  "CHEAPSKATE": "a miserly or stingy person [n -S]\n",
  "CHEAPSKATES": "CHEAPSKATE, a miserly or stingy person [n]\n",
  "CHEAPY": "(colloquial) something cheap, also CHEAPIE, CHEAPO [n CHEAPIES]\n",
  "CHEAT": "to defraud [v -ED, -ING, -S]\n",
  "CHEATABLE": "that can be cheated [adj]\n",
  "CHEATED": "CHEAT, to defraud [v]\n",
  "CHEATER": "one that cheats [n -S]\n",
  "CHEATERIES": "CHEATERY, a cheating [n]\n",
  "CHEATERS": "CHEATER, one that cheats [n]\n",
  "CHEATERY": "a cheating [n CHEATERIES]\n",
  "CHEATING": "deceiving [adj CHEATINGLY] / the act of cheating [n -S]\n",
  "CHEATINGLY": "CHEATING, deceiving [adv]\n",
  "CHEATINGS": "CHEATING, the act of cheating [n]\n",
  "CHEATS": "CHEAT, to defraud [v]\n",
  "CHEBEC": "a small American bird, the least flycatcher [n -S]\n",
  "CHEBECS": "CHEBEC, a small American bird, the least flycatcher [n]\n",
  "CHECHAKO": "(Native American) a tenderfoot, also CHECHAQUO, CHEECHAKO, CHEECHALKO [n CHECHAKOES or CHECHAKOS]\n",
  "CHECHAKOES": "CHECHAKO, (Native American) a tenderfoot, also CHECHAQUO, CHEECHAKO, CHEECHALKO [n]\n",
  "CHECHAKOS": "CHECHAKO, (Native American) a tenderfoot, also CHECHAQUO, CHEECHAKO, CHEECHALKO [n]\n",
  "CHECHAQUO": "(Native American) a tenderfoot, also CHECHAKO, CHEECHAKO, CHEECHALKO [n -S]\n",
  "CHECHAQUOS": "CHECHAQUO, (Native American) a tenderfoot, also CHECHAKO, CHEECHAKO, CHEECHALKO [n]\n",
  "CHECHIA": "(French) a cylindrical skullcap, worn by Arabs and adopted by French troops in North Africa [n -S]\n",
  "CHECHIAS": "CHECHIA, (French) a cylindrical skullcap, worn by Arabs and adopted by French troops in North Africa [n]\n",
  "CHECK": "to inspect [v -ED, -ING, -S]\n",
  "CHECKABLE": "capable of being checked [adj]\n",
  "CHECKBOOK": "(US) a chequebook [n -S]\n",
  "CHECKBOOKS": "CHECKBOOK, (US) a chequebook [n]\n",
  "CHECKBOX": "a small box on a computer screen to be clicked to select an option [n -ES]\n",
  "CHECKBOXES": "CHECKBOX, a small box on a computer screen to be clicked to select an option [n]\n",
  "CHECKCLERK": "a clerk who checks accounts [n -S]\n",
  "CHECKCLERKS": "CHECKCLERK, a clerk who checks accounts [n]\n",
  "CHECKED": "CHECK, to inspect [v]\n",
  "CHECKER": "to divide into or mark with squares, esp. of alternate colours [v -ED, -ING, -S]\n",
  "CHECKERBERRIES": "CHECKERBERRY, the fruit of various American plants, esp. the wintergreen [n]\n",
  "CHECKERBERRY": "the fruit of various American plants, esp. the wintergreen [n CHECKERBERRIES]\n",
  "CHECKERBLOOM": "a Californian malvaceous plant with pink or purple flowers [n -S]\n",
  "CHECKERBLOOMS": "CHECKERBLOOM, a Californian malvaceous plant with pink or purple flowers [n]\n",
  "CHECKERBOARD": "a board used in various games (as checkers) with usually 64 squares in 2 alternating colors [n -S]\n",
  "CHECKERBOARDS": "CHECKERBOARD, a board used in various games (as checkers) with usually 64 squares in 2 alternating colors [n]\n",
  "CHECKERED": "CHECKER, to divide into or mark with squares, esp. of alternate colours [v]\n",
  "CHECKERING": "CHECKER, to divide into or mark with squares, esp. of alternate colours [v]\n",
  "CHECKERS": "CHECKER, to divide into or mark with squares, esp. of alternate colours [v]\n",
  "CHECKIER": "CHECKY, chequered [adj]\n",
  "CHECKIEST": "CHECKY, chequered [adj]\n",
  "CHECKING": "the act of making a check [n -S]\n",
  "CHECKINGS": "CHECKING, the act of making a check [n]\n",
  "CHECKLATON": "(Spenser) a kind of gilt leather, also SCHECKLATON, SHECKLATON [n -S]\n",
  "CHECKLATONS": "CHECKLATON, (Spenser) a kind of gilt leather, also SCHECKLATON, SHECKLATON [n]\n",
  "CHECKLESS": "that can not be checked or restrained [adj]\n",
  "CHECKLIST": "a list of tasks to do [n -S] / to make list of things to do [v -ED, -ING, -S]\n",
  "CHECKLISTED": "CHECKLIST, to make list of things to do [v]\n",
  "CHECKLISTING": "CHECKLIST, to make list of things to do [v]\n",
  "CHECKLISTS": "CHECKLIST, a list of tasks to do [n]\n",
  "CHECKMARK": "to mark items on a list with a checkmark [v -ED, -ING, -S]\n",
  "CHECKMARKED": "CHECKMARK, to mark items on a list with a checkmark [v]\n",
  "CHECKMARKING": "CHECKMARK, to mark items on a list with a checkmark [v]\n",
  "CHECKMARKS": "CHECKMARK, to mark items on a list with a checkmark [v]\n",
  "CHECKMATE": "in chess, to put (a player's king) in checkmate; to defeat or render incapable of counterattack [v CHECKMATED, CHECKMATING, CHECKMATES]\n",
  "CHECKMATED": "CHECKMATE, in chess, to put (a player's king) in checkmate; to defeat or render incapable of counterattack [v]\n",
  "CHECKMATES": "CHECKMATE, in chess, to put (a player's king) in checkmate; to defeat or render incapable of counterattack [v]\n",
  "CHECKMATING": "CHECKMATE, in chess, to put (a player's king) in checkmate; to defeat or render incapable of counterattack [v]\n",
  "CHECKOFF": "a marking off on a list [n -S]\n",
  "CHECKOFFS": "CHECKOFF, a marking off on a list [n]\n",
  "CHECKOUT": "the cash desk at a supermarket [n -S]\n",
  "CHECKOUTS": "CHECKOUT, the cash desk at a supermarket [n]\n",
  "CHECKPOINT": "a point at which a check is performed [n -S]\n",
  "CHECKPOINTS": "CHECKPOINT, a point at which a check is performed [n]\n",
  "CHECKRAIL": "an inner rail on a railway track, aka guardrail [n -S]\n",
  "CHECKRAILS": "CHECKRAIL, an inner rail on a railway track, aka guardrail [n]\n",
  "CHECKREIN": "a short rein looped over the check hook to prevent a horse from lowering his head, aka a bearing rein [n -S]\n",
  "CHECKREINS": "CHECKREIN, a short rein looped over the check hook to prevent a horse from lowering his head, aka a bearing rein [n]\n",
  "CHECKROOM": "(US) a cloakroom, a luggage room [n -S]\n",
  "CHECKROOMS": "CHECKROOM, (US) a cloakroom, a luggage room [n]\n",
  "CHECKROW": "to plant in rows that divides the land into squares [v -ED, -ING, -S]\n",
  "CHECKROWED": "CHECKROW, to plant in rows that divides the land into squares [v]\n",
  "CHECKROWING": "CHECKROW, to plant in rows that divides the land into squares [v]\n",
  "CHECKROWS": "CHECKROW, to plant in rows that divides the land into squares [v]\n",
  "CHECKS": "CHECK, to inspect [v]\n",
  "CHECKSTOP": "(Canadian) a roadside checkpoint where drivers are randomly tested with a Breathalyzer [n -S]\n",
  "CHECKSTOPS": "CHECKSTOP, (Canadian) a roadside checkpoint where drivers are randomly tested with a Breathalyzer [n]\n",
  "CHECKSUM": "a numerical summary used to detect errors in data [n -S]\n",
  "CHECKSUMS": "CHECKSUM, a numerical summary used to detect errors in data [n]\n",
  "CHECKUP": "an examination [n -S]\n",
  "CHECKUPS": "CHECKUP, an examination [n]\n",
  "CHECKWEIGHER": "a colliery worker who, on behalf of the miners, checks the weight of coal sent up to the pit-mouth [n -S]\n",
  "CHECKWEIGHERS": "CHECKWEIGHER, a colliery worker who, on behalf of the miners, checks the weight of coal sent up to the pit-mouth [n]\n",
  "CHECKY": "chequered [adj CHECKIER, CHECKIEST]\n",
  "CHEDARIM": "CHEDER, (Hebrew) a religious lesson, or the place where it is held, also HEDER [n]\n",
  "CHEDDAR": "any of several types of smooth hard yellow or whitish cheese [n -S]\n",
  "CHEDDARIER": "CHEDDARY, like cheddar, any of several types of smooth hard yellow or whitish cheese [adj]\n",
  "CHEDDARIEST": "CHEDDARY, like cheddar, any of several types of smooth hard yellow or whitish cheese [adj]\n",
  "CHEDDARS": "CHEDDAR, any of several types of smooth hard yellow or whitish cheese [n]\n",
  "CHEDDARY": "like cheddar, any of several types of smooth hard yellow or whitish cheese [adj CHEDDARIER, CHEDDARIEST]\n",
  "CHEDDITE": "a mixture of castor oil, ammonium perchlorate and a solvent, used as an explosive, also CHEDITE [n -S]\n",
  "CHEDDITES": "CHEDDITE, a mixture of castor oil, ammonium perchlorate and a solvent, used as an explosive, also CHEDITE [n]\n",
  "CHEDER": "(Hebrew) a religious lesson, or the place where it is held, also HEDER [n CHEDERS, CHADARIM or CHEDARIM]\n",
  "CHEDERS": "CHEDER, (Hebrew) a religious lesson, or the place where it is held, also HEDER [n]\n",
  "CHEDITE": "a mixture of castor oil, ammonium perchlorate and a solvent, used as an explosive, also CHEDDITE [n -S]\n",
  "CHEDITES": "CHEDITE, a mixture of castor oil, ammonium perchlorate and a solvent, used as an explosive, also CHEDDITE [n]\n",
  "CHEECHAKO": "(Native American) a tenderfoot, also CHECHAKO, CHECHAQUO, CHEECHALKO [n CHEECHAKOES or CHEECHAKOS]\n",
  "CHEECHAKOES": "CHEECHAKO, (Native American) a tenderfoot, also CHECHAKO, CHECHAQUO, CHEECHALKO [n]\n",
  "CHEECHAKOS": "CHEECHAKO, (Native American) a tenderfoot, also CHECHAKO, CHECHAQUO, CHEECHALKO [n]\n",
  "CHEECHALKO": "(Native American) a tenderfoot, also CHECHAKO, CHECHAQUO, CHEECHAKO [n CHEECHALKOES or CHEECHALKOS]\n",
  "CHEECHALKOES": "CHEECHALKO, (Native American) a tenderfoot, also CHECHAKO, CHECHAQUO, CHEECHAKO [n]\n",
  "CHEECHALKOS": "CHEECHALKO, (Native American) a tenderfoot, also CHECHAKO, CHECHAQUO, CHEECHAKO [n]\n",
  "CHEEK": "to speak impudently to [v -ED, -ING, -S]\n",
  "CHEEKBONE": "the bone of the cheek [n -S]\n",
  "CHEEKBONES": "CHEEKBONE, the bone of the cheek [n]\n",
  "CHEEKED": "CHEEK, to speak impudently to [v]\n",
  "CHEEKFUL": "as much as a cheek can hold [n -S]\n",
  "CHEEKFULS": "CHEEKFUL, as much as a cheek can hold [n]\n",
  "CHEEKIER": "CHEEKY, impudent [adj]\n",
  "CHEEKIEST": "CHEEKY, impudent [adj]\n",
  "CHEEKILY": "CHEEKY, impudent [adv]\n",
  "CHEEKINESS": "the state of being cheeky [n -ES]\n",
  "CHEEKINESSES": "CHEEKINESS, the state of being cheeky [n]\n",
  "CHEEKING": "CHEEK, to speak impudently to [v]\n",
  "CHEEKLESS": "without cheeks [adj]\n",
  "CHEEKPIECE": "the part of a helmet, bridle etc. covering the cheek [n -S]\n",
  "CHEEKPIECES": "CHEEKPIECE, the part of a helmet, bridle etc. covering the cheek [n]\n",
  "CHEEKPOUCH": "a dilatation of the cheek forming a bag, e.g. as in a chipmunk [n -ES]\n",
  "CHEEKPOUCHES": "CHEEKPOUCH, a dilatation of the cheek forming a bag, e.g. as in a chipmunk [n]\n",
  "CHEEKS": "CHEEK, to speak impudently to [v]\n",
  "CHEEKTEETH": "CHEEKTOOTH, a molar tooth [n]\n",
  "CHEEKTOOTH": "a molar tooth [n CHEEKTEETH]\n",
  "CHEEKY": "impudent [adj CHEEKIER, CHEEKIEST, CHEEKILY]\n",
  "CHEEP": "to chirp [v -ED, -ING, -S]\n",
  "CHEEPED": "CHEEP, to chirp [v]\n",
  "CHEEPER": "a young bird, esp. a game-bird [n -S]\n",
  "CHEEPERS": "CHEEPER, a young bird, esp. a game-bird [n]\n",
  "CHEEPING": "CHEEP, to chirp [v]\n",
  "CHEEPS": "CHEEP, to chirp [v]\n",
  "CHEER": "to applaud with shouts of approval [v -ED, -ING, -S]\n",
  "CHEERED": "CHEER, to applaud with shouts of approval [v]\n",
  "CHEERER": "one who cheers [n -S]\n",
  "CHEERERS": "CHEERER, one who cheers [n]\n",
  "CHEERFUL": "in good spirits [adj CHEERFULLER, CHEERFULLEST, CHEERFULLY]\n",
  "CHEERFULLER": "CHEERFUL, in good spirits [adj]\n",
  "CHEERFULLEST": "CHEERFUL, in good spirits [adj]\n",
  "CHEERFULLY": "CHEERFUL, in good spirits [adv]\n",
  "CHEERFULNESS": "the state of being cheerful [n -ES]\n",
  "CHEERFULNESSES": "CHEERFULNESS, the state of being cheerful [n]\n",
  "CHEERIER": "CHEERY, cheerful [adj]\n",
  "CHEERIEST": "CHEERY, cheerful [adj]\n",
  "CHEERILY": "CHEERY, cheerful [adv]\n",
  "CHEERINESS": "the state of being cheery [n -ES]\n",
  "CHEERINESSES": "CHEERINESS, the state of being cheery [n]\n",
  "CHEERING": "the act of encouraging [n -S]\n",
  "CHEERINGLY": "CHEERING [adv]\n",
  "CHEERINGS": "CHEERING, the act of encouraging [n]\n",
  "CHEERIO": "goodbye, also CHEERO [n -S]\n",
  "CHEERIOS": "CHEERIO, goodbye, also CHEERO [n]\n",
  "CHEERISHNESS": "(obsolete) cheerfulness [n -ES]\n",
  "CHEERISHNESSES": "CHEERISHNESS, (obsolete) cheerfulness [n]\n",
  "CHEERLEAD": "to lead in cheering [v CHEERLED, CHEERLEADING, CHEERLEADS]\n",
  "CHEERLEADER": "one that calls for and directs organized cheering (as at a football game) [n -S]\n",
  "CHEERLEADERS": "CHEERLEADER, one that calls for and directs organized cheering (as at a football game) [n]\n",
  "CHEERLEADING": "CHEERLEAD, to lead in cheering [v]\n",
  "CHEERLEADS": "CHEERLEAD, to lead in cheering [v]\n",
  "CHEERLED": "CHEERLEAD, to lead in cheering [v]\n",
  "CHEERLESS": "without cheer, gloomy [adj CHEERLESSLY]\n",
  "CHEERLESSLY": "CHEERLESS, without cheer, gloomy [adv]\n",
  "CHEERLESSNESS": "CHEERLESS, without cheer, gloomy [n]\n",
  "CHEERLESSNESSES": "CHEERLESSNESS, CHEERLESS, without cheer, gloomy [n]\n",
  "CHEERLY": "(archaic) cheerful [adj]\n",
  "CHEERO": "goodbye, also CHEERIO [n -S]\n",
  "CHEEROS": "CHEERO, goodbye, also CHEERIO [n]\n",
  "CHEERS": "CHEER, to applaud with shouts of approval [v]\n",
  "CHEERY": "cheerful [adj CHEERIER, CHEERIEST, CHEERILY]\n",
  "CHEESE": "to stop it [v CHEESED, CHEESING, CHEESES]\n",
  "CHEESEBOARD": "a board on which cheese is served [n -S]\n",
  "CHEESEBOARDS": "CHEESEBOARD, a board on which cheese is served [n]\n",
  "CHEESEBURGER": "a hamburger topped with a slice of cheese [n -S]\n",
  "CHEESEBURGERS": "CHEESEBURGER, a hamburger topped with a slice of cheese [n]\n",
  "CHEESECAKE": "a kind of cake having a base of pastry or biscuit crumbs, with a filling of cream cheese, sugar, eggs, flavouring [n -S]\n",
  "CHEESECAKES": "CHEESECAKE, a kind of cake having a base of pastry or biscuit crumbs, with a filling of cream cheese, sugar, eggs, flavouring [n]\n",
  "CHEESECLOTH": "a very lightweight unsized cotton gauze [n -S]\n",
  "CHEESECLOTHS": "CHEESECLOTH, a very lightweight unsized cotton gauze [n]\n",
  "CHEESECUTTER": "a movable keel that may be drawn up inside a boat; a square-peaked cap [n -S]\n",
  "CHEESECUTTERS": "CHEESECUTTER, a movable keel that may be drawn up inside a boat; a square-peaked cap [n]\n",
  "CHEESED": "CHEESE, to stop it [v]\n",
  "CHEESEHOPPER": "a small fly whose larvae feed on cheese and move by jumping [n -S]\n",
  "CHEESEHOPPERS": "CHEESEHOPPER, a small fly whose larvae feed on cheese and move by jumping [n]\n",
  "CHEESELIKE": "like cheese [adj]\n",
  "CHEESEMITE": "a very small arachnid that breeds in cheese [n -S]\n",
  "CHEESEMITES": "CHEESEMITE, a very small arachnid that breeds in cheese [n]\n",
  "CHEESEMONGER": "one who sells cheeses [n -S]\n",
  "CHEESEMONGERS": "CHEESEMONGER, one who sells cheeses [n]\n",
  "CHEESEPARER": "a mean or stingy person [n -S]\n",
  "CHEESEPARERS": "CHEESEPARER, a mean or stingy person [n]\n",
  "CHEESEPARING": "stingy [adj] / the act of being stingy [n -S]\n",
  "CHEESEPARINGS": "CHEESEPARING, the act of being stingy [n]\n",
  "CHEESEPRESS": "a machine or device in which curds for cheese are pressed [n -ES]\n",
  "CHEESEPRESSES": "CHEESEPRESS, a machine or device in which curds for cheese are pressed [n]\n",
  "CHEESES": "CHEESE, to stop it [v]\n",
  "CHEESESTEAK": "a sandwich filled with grilled beef and cheese [n -S]\n",
  "CHEESESTEAKS": "CHEESESTEAK, a sandwich filled with grilled beef and cheese [n]\n",
  "CHEESETASTER": "a long hollow tool for taking a sample from the inside of a cheese [n -S]\n",
  "CHEESETASTERS": "CHEESETASTER, a long hollow tool for taking a sample from the inside of a cheese [n]\n",
  "CHEESEVAT": "a vat or wooden case in which curds are separated and pressed into cheese [n -S]\n",
  "CHEESEVATS": "CHEESEVAT, a vat or wooden case in which curds are separated and pressed into cheese [n]\n",
  "CHEESEWIRE": "a thin wire used for cutting cheese [n -S]\n",
  "CHEESEWIRES": "CHEESEWIRE, a thin wire used for cutting cheese [n]\n",
  "CHEESEWOOD": "the yellow wood of various Australian trees [n -S]\n",
  "CHEESEWOODS": "CHEESEWOOD, the yellow wood of various Australian trees [n]\n",
  "CHEESEWRING": "a cheesepress [n -S]\n",
  "CHEESEWRINGS": "CHEESEWRING, a cheesepress [n]\n",
  "CHEESIER": "CHEESY, resembling a food made from milk curds [adj]\n",
  "CHEESIEST": "CHEESY, resembling a food made from milk curds [adj]\n",
  "CHEESILY": "CHEESY, resembling a food made from milk curds [adv]\n",
  "CHEESINESS": "the quality of being cheesy [n -ES]\n",
  "CHEESINESSES": "CHEESINESS, the quality of being cheesy [n]\n",
  "CHEESING": "CHEESE, to stop it [v]\n",
  "CHEESY": "resembling a food made from milk curds [adj CHEESIER, CHEESIEST, CHEESILY]\n",
  "CHEETAH": "(Hindi) a hunting cat of Africa, also CHETAH [n -S]\n",
  "CHEETAHS": "CHEETAH, (Hindi) a hunting cat of Africa, also CHETAH [n]\n",
  "CHEEWINK": "an American bird of the finch family, so called from its note, also CHEWINK [n -S]\n",
  "CHEEWINKS": "CHEEWINK, an American bird of the finch family, so called from its note, also CHEWINK [n]\n",
  "CHEF": "to work as a chef [v CHEFED or CHEFFED, CHEFING or CHEFFING, CHEFS]\n",
  "CHEFDOM": "the status of a chef [n -S]\n",
  "CHEFDOMS": "CHEFDOM, the status of a chef [n]\n",
  "CHEFED": "CHEF, to work as a chef [v]\n",
  "CHEFFED": "CHEF, to work as a chef [v]\n",
  "CHEFFIER": "CHEFFY, relating to or characteristic of chefs [adj]\n",
  "CHEFFIEST": "CHEFFY, relating to or characteristic of chefs [adj]\n",
  "CHEFFING": "CHEF, to work as a chef [v]\n",
  "CHEFFY": "relating to or characteristic of chefs [adj CHEFFIER, CHEFFIEST]\n",
  "CHEFING": "CHEF, to work as a chef [v]\n",
  "CHEFS": "CHEF, to work as a chef [v]\n",
  "CHEGOE": "a small tropical flea, also CHIGGER, CHIGOE, CHIGRE [n -S]\n",
  "CHEGOES": "CHEGOE, a small tropical flea, also CHIGGER, CHIGOE, CHIGRE [n]\n",
  "CHEILITIS": "an inflammation, dryness and cracking of the lips [n -ES]\n",
  "CHEILITISES": "CHEILITIS, an inflammation, dryness and cracking of the lips [n]\n",
  "CHEIROMANCER": "one who claims to divine by means of palmistry, also CHIROMANCER [n -S]\n",
  "CHEIROMANCERS": "CHEIROMANCER, one who claims to divine by means of palmistry, also CHIROMANCER [n]\n",
  "CHEIROMANCIES": "CHEIROMANCY, divination by means of palmistry, also CHIROMANCY [n]\n",
  "CHEIROMANCY": "divination by means of palmistry, also CHIROMANCY [n CHEIROMANCIES]\n",
  "CHEKA": "(Russian) the Russian secret police [n -S]\n",
  "CHEKAS": "CHEKA, (Russian) the Russian secret police [n]\n",
  "CHEKIST": "(Russian) a member of the cheka, the Russian secret police [n -S]\n",
  "CHEKISTS": "CHEKIST, (Russian) a member of the cheka, the Russian secret police [n]\n",
  "CHELA": "(Greek) a pincerlike claw [n CHELAE] / the pupil of a guru [n -S]\n",
  "CHELAE": "CHELA, (Greek) a pincerlike claw [n]\n",
  "CHELAS": "CHELA, (Greek) a pincerlike claw [n]\n",
  "CHELASHIP": "discipleship [n -S]\n",
  "CHELASHIPS": "CHELASHIP, discipleship [n]\n",
  "CHELATABLE": "that can be chelated [adj]\n",
  "CHELATE": "to combine a metal ion with a compound [v CHELATED, CHELATING, CHELATES]\n",
  "CHELATED": "CHELATE, to combine a metal ion with a compound [v]\n",
  "CHELATES": "CHELATE, to combine a metal ion with a compound [v]\n",
  "CHELATING": "CHELATE, to combine a metal ion with a compound [v]\n",
  "CHELATION": "the action of forming a chelate [n -S]\n",
  "CHELATIONS": "CHELATION, the action of forming a chelate [n]\n",
  "CHELATOR": "an agent causing chelation [n -S]\n",
  "CHELATORS": "CHELATOR, an agent causing chelation [n]\n",
  "CHELICERA": "the first pair of appendages of a chelicerate arthropod [n CHELICERAE]\n",
  "CHELICERAE": "CHELICERA, the first pair of appendages of a chelicerate arthropod [n]\n",
  "CHELICERAL": "relating to the chelicerae [adj]\n",
  "CHELICERATE": "an arthropod of the group Chelicera, arachnids and horseshoe-crabs [n -S]\n",
  "CHELICERATES": "CHELICERATE, an arthropod of the group Chelicera, arachnids and horseshoe-crabs [n]\n",
  "CHELIFEROUS": "bearing pincers or claws [adj]\n",
  "CHELIFORM": "shaped like a chela or pincer [adj]\n",
  "CHELIPED": "one of the pair of legs carrying the chelae (claws) in arthropods [n -S]\n",
  "CHELIPEDS": "CHELIPED, one of the pair of legs carrying the chelae (claws) in arthropods [n]\n",
  "CHELLUP": "(dialect) noise [n -S]\n",
  "CHELLUPS": "CHELLUP, (dialect) noise [n]\n",
  "CHELOID": "a hard growth of scar tissue, also KELOID [n -S]\n",
  "CHELOIDAL": "relating to a cheloid, a hard growth of scar tissue [adj]\n",
  "CHELOIDS": "CHELOID, a hard growth of scar tissue, also KELOID [n]\n",
  "CHELONE": "a genus of hardy perennial flowering plants, natives of North America [n -S]\n",
  "CHELONES": "CHELONE, a genus of hardy perennial flowering plants, natives of North America [n]\n",
  "CHELONIAN": "any member of the turtle or tortoise family [n -S]\n",
  "CHELONIANS": "CHELONIAN, any member of the turtle or tortoise family [n]\n",
  "CHELP": "(Northern English dialect) to speak out of turn, to twitter [v -ED, -ING, -S]\n",
  "CHELPED": "CHELP, (Northern English dialect) to speak out of turn, to twitter [v]\n",
  "CHELPING": "CHELP, (Northern English dialect) to speak out of turn, to twitter [v]\n",
  "CHELPS": "CHELP, (Northern English dialect) to speak out of turn, to twitter [v]\n",
  "CHELUVIATION": "the leaching of iron and aluminium oxides from soils, esp. those planted with conifers and heaths [n -S]\n",
  "CHELUVIATIONS": "CHELUVIATION, the leaching of iron and aluminium oxides from soils, esp. those planted with conifers and heaths [n]\n",
  "CHEM": "(short for) a chemistry class or course [n -S]\n",
  "CHEMAUTOTROPH": "an organism, such as a bacterium, that obtains its energy from inorganic reactions using simple compounds, such as ammonia or carbon dioxide [n -S]\n",
  "CHEMAUTOTROPHIC": "of or like a chemautotroph [adj]\n",
  "CHEMAUTOTROPHS": "CHEMAUTOTROPH, an organism, such as a bacterium, that obtains its energy from inorganic reactions using simple compounds, such as ammonia or carbon dioxide [n]\n",
  "CHEMIATRIC": "healing by the use of chemicals [adj]\n",
  "CHEMIC": "relating to chemistry [adj CHEMICALLY] / to treat with bleaching powder [v CHEMICKED, CHEMICKING, CHEMICS]\n",
  "CHEMICAL": "related to chemistry [adj CHEMICALLY] / a substance obtained by a process of chemistry [n -S]\n",
  "CHEMICALLY": "CHEMICAL, related to chemistry [adv]\n",
  "CHEMICALS": "CHEMICAL, a substance obtained by a process of chemistry [n]\n",
  "CHEMICKED": "CHEMIC, to treat with bleaching powder [v]\n",
  "CHEMICKING": "the act of treating with bleaching powder [n -S]\n",
  "CHEMICKINGS": "CHEMICKING, the act of treating with bleaching powder [n]\n",
  "CHEMICOPHYSICAL": "involving the processes of both chemistry and physics [adj]\n",
  "CHEMICS": "CHEMIC, to treat with bleaching powder [v]\n",
  "CHEMIOSMOSES": "CHEMIOSMOSIS, the mechanism by which the synthesis and utilization of the biochemical energy source ATP is regulated [n]\n",
  "CHEMIOSMOSIS": "the mechanism by which the synthesis and utilization of the biochemical energy source ATP is regulated [n CHEMIOSMOSES]\n",
  "CHEMIOSMOTIC": "relating to a hypothesis to explain ATP formation [adj]\n",
  "CHEMISE": "(French) a woman's shirt-like undergarment [n -S]\n",
  "CHEMISES": "CHEMISE, (French) a woman's shirt-like undergarment [n]\n",
  "CHEMISETTE": "(French) an undergarment, worn by women, usually covering the neck, shoulders, and breast [n -S]\n",
  "CHEMISETTES": "CHEMISETTE, (French) an undergarment, worn by women, usually covering the neck, shoulders, and breast [n]\n",
  "CHEMISM": "chemical action, activity, or force [n -S]\n",
  "CHEMISMS": "CHEMISM, chemical action, activity, or force [n]\n",
  "CHEMISORB": "to adsorb by chemical action, also CHEMOSORB [v -ED, -ING, -S]\n",
  "CHEMISORBED": "CHEMISORB, to adsorb by chemical action, also CHEMOSORB [v]\n",
  "CHEMISORBING": "CHEMISORB, to adsorb by chemical action, also CHEMOSORB [v]\n",
  "CHEMISORBS": "CHEMISORB, to adsorb by chemical action, also CHEMOSORB [v]\n",
  "CHEMISORPTION": "the act of chemisorbing [n -S]\n",
  "CHEMISORPTIONS": "CHEMISORPTION, the act of chemisorbing [n]\n",
  "CHEMIST": "one versed in chemistry [n -S]\n",
  "CHEMISTRIES": "CHEMISTRY, the physical science of the properties of elementary and compound substances, also CHYMISTRY [n]\n",
  "CHEMISTRY": "the physical science of the properties of elementary and compound substances, also CHYMISTRY [n CHEMISTRIES]\n",
  "CHEMISTS": "CHEMIST, one versed in chemistry [n]\n",
  "CHEMITYPE": "any chemical process for obtaining impressions from an engraving [n -S]\n",
  "CHEMITYPES": "CHEMITYPE, any chemical process for obtaining impressions from an engraving [n]\n",
  "CHEMITYPIES": "CHEMITYPY, printing by chemitype, any chemical process for obtaining impressions from an engraving [n]\n",
  "CHEMITYPY": "printing by chemitype, any chemical process for obtaining impressions from an engraving [n CHEMITYPIES]\n",
  "CHEMMIES": "CHEMMY, a card game, chemin de fer [n]\n",
  "CHEMMY": "a card game, chemin de fer [n CHEMMIES]\n",
  "CHEMO": "(short for) chemotherapy [n -S]\n",
  "CHEMOATTRACTANT": "a chemical which provokes a chemotactic movement of e.g. cells or bacteria towards its area of highest concentration [n]\n",
  "CHEMOAUTOTROPH": "any organism, e.g. bacteria, that produces energy by the oxidation of inorganic compounds, such as iron, ammonia and hydrogen sulphide, also CHEMOAUTROPH [n -S]\n",
  "CHEMOAUTOTROPHS": "CHEMOAUTOTROPH, any organism, e.g. bacteria, that produces energy by the oxidation of inorganic compounds, such as iron, ammonia and hydrogen sulphide, also CHEMOAUTROPH [n]\n",
  "CHEMOAUTOTROPHY": "the production of energy by the oxidation of inorganic compounds, such as iron, ammonia and hydrogen sulphide [n]\n",
  "CHEMOAUTROPH": "any organism, e.g. bacteria, that produces energy by the oxidation of inorganic compounds, such as iron, ammonia and hydrogen sulphide, also CHEMOAUTOTROPH [n -S]\n",
  "CHEMOAUTROPHS": "CHEMOAUTROPH, any organism, e.g. bacteria, that produces energy by the oxidation of inorganic compounds, such as iron, ammonia and hydrogen sulphide, also CHEMOAUTOTROPH [n]\n",
  "CHEMOCEPTOR": "a sensory receptor in a biological cell membrane to which an external molecule binds to generate a smell or taste sensation [n -S]\n",
  "CHEMOCEPTORS": "CHEMOCEPTOR, a sensory receptor in a biological cell membrane to which an external molecule binds to generate a smell or taste sensation [n]\n",
  "CHEMOKINE": "a type of protein [n -S]\n",
  "CHEMOKINES": "CHEMOKINE, a type of protein [n]\n",
  "CHEMOKINESES": "CHEMOKINESIS, the random movement of cells, such as leucocytes, stimulated by substances in their environment [n]\n",
  "CHEMOKINESIS": "the random movement of cells, such as leucocytes, stimulated by substances in their environment [n CHEMOKINESES]\n",
  "CHEMOLITHOTROPH": "a bacterium that obtains its energy from inorganic compounds containing iron, nitrogen, or sulfur, and not from living on decaying organisms [n]\n",
  "CHEMONASTIES": "CHEMONASTY, plant movement provoked but not orientated by a chemical action [n]\n",
  "CHEMONASTY": "plant movement provoked but not orientated by a chemical action [n CHEMONASTIES]\n",
  "CHEMOPREVENTION": "the use of chemical agents to prevent or slow the development of cancer [n]\n",
  "CHEMOPSYCHIATRY": "treatment of mental illness by drugs [n]\n",
  "CHEMORECEPTION": "the physiological reception of chemical stimuli [n -S]\n",
  "CHEMORECEPTIONS": "CHEMORECEPTION, the physiological reception of chemical stimuli [n]\n",
  "CHEMORECEPTIVE": "relating to chemoreception [adj]\n",
  "CHEMORECEPTOR": "a sense organ (as a taste bud) responding to chemical stimuli [n -S]\n",
  "CHEMORECEPTORS": "CHEMORECEPTOR, a sense organ (as a taste bud) responding to chemical stimuli [n]\n",
  "CHEMOS": "CHEMO, (short for) chemotherapy [n]\n",
  "CHEMOSMOSES": "CHEMOSMOSIS, a chemical reaction between two compounds after osmosis through an intervening semipermeable membrane [n]\n",
  "CHEMOSMOSIS": "a chemical reaction between two compounds after osmosis through an intervening semipermeable membrane [n CHEMOSMOSES]\n",
  "CHEMOSMOTIC": "relating to chemosmosis [adj]\n",
  "CHEMOSORB": "to adsorb by chemical action, also CHEMISORB [v -ED, -ING, -S]\n",
  "CHEMOSORBED": "CHEMOSORB, to adsorb by chemical action, also CHEMISORB [v]\n",
  "CHEMOSORBING": "CHEMOSORB, to adsorb by chemical action, also CHEMISORB [v]\n",
  "CHEMOSORBS": "CHEMOSORB, to adsorb by chemical action, also CHEMISORB [v]\n",
  "CHEMOSPHERE": "the thermosphere, the outermost layer of the atmosphere [n -S]\n",
  "CHEMOSPHERES": "CHEMOSPHERE, the thermosphere, the outermost layer of the atmosphere [n]\n",
  "CHEMOSPHERIC": "relating to the chemosphere, the outermost layer of the atmosphere [adj]\n",
  "CHEMOSTAT": "an apparatus for growing cultures of bacteria etc. [n -S]\n",
  "CHEMOSTATS": "CHEMOSTAT, an apparatus for growing cultures of bacteria etc. [n]\n",
  "CHEMOSURGERIES": "CHEMOSURGERY, the chemical removal of diseased or unwanted tissue [n]\n",
  "CHEMOSURGERY": "the chemical removal of diseased or unwanted tissue [n CHEMOSURGERIES]\n",
  "CHEMOSURGICAL": "relating to chemosurgery [adj]\n",
  "CHEMOSYNTHESES": "CHEMOSYNTHESIS, synthesis of organic compounds (as in living cells) by energy derived from inorganic chemical reactions [n]\n",
  "CHEMOSYNTHESIS": "synthesis of organic compounds (as in living cells) by energy derived from inorganic chemical reactions [n CHEMOSYNTHESES]\n",
  "CHEMOSYNTHETIC": "relating to chemosynthesis [adj]\n",
  "CHEMOTACTIC": "exhibiting chemotaxis [adj CHEMOTACTICALLY]\n",
  "CHEMOTACTICALLY": "CHEMOTACTIC, exhibiting chemotaxis [adv]\n",
  "CHEMOTAXES": "CHEMOTAXIS, orientation of an animalcule relative to a chemical substance [n]\n",
  "CHEMOTAXIS": "orientation of an animalcule relative to a chemical substance [n CHEMOTAXES or CHEMOTAXISES]\n",
  "CHEMOTAXISES": "CHEMOTAXIS, orientation of an animalcule relative to a chemical substance [n]\n",
  "CHEMOTAXONOMIC": "relating to chemotaxonomy [adj]\n",
  "CHEMOTAXONOMIES": "CHEMOTAXONOMY, the classification of plants and animals based on similarities and differences in biochemical composition [n]\n",
  "CHEMOTAXONOMIST": "one who practises chemotaxonomy [n]\n",
  "CHEMOTAXONOMY": "the classification of plants and animals based on similarities and differences in biochemical composition [n CHEMOTAXONOMIES]\n",
  "CHEMOTHERAPIES": "CHEMOTHERAPY, therapy involving the use of chemicals [n]\n",
  "CHEMOTHERAPIST": "one who practises chemotherapy [n -S]\n",
  "CHEMOTHERAPISTS": "CHEMOTHERAPIST, one who practises chemotherapy [n]\n",
  "CHEMOTHERAPY": "therapy involving the use of chemicals [n CHEMOTHERAPIES]\n",
  "CHEMOTROPIC": "exhibiting chemotropism, i.e. plant growth in the direction of a particular chemical [adj CHEMOTROPICALLY]\n",
  "CHEMOTROPICALLY": "CHEMOTROPIC, exhibiting chemotropism, i.e. plant growth in the direction of a particular chemical [adv]\n",
  "CHEMOTROPISM": "plant growth in the direction of a particular chemical [n -S]\n",
  "CHEMOTROPISMS": "CHEMOTROPISM, plant growth in the direction of a particular chemical [n]\n",
  "CHEMPADUK": "(Malay) an evergreen moraceous tree of Malaysia [n -S]\n",
  "CHEMPADUKS": "CHEMPADUK, (Malay) an evergreen moraceous tree of Malaysia [n]\n",
  "CHEMS": "CHEM, (short for) a chemistry class or course [n]\n",
  "CHEMSEX": "sexual activity performed while under the influence of psychoactive drugs [n -ES]\n",
  "CHEMSEXES": "CHEMSEX, sexual activity performed while under the influence of psychoactive drugs [n]\n",
  "CHEMTRAIL": "a vapour trail believed to contain toxic chemicals [n -S]\n",
  "CHEMTRAILS": "CHEMTRAIL, a vapour trail believed to contain toxic chemicals [n]\n",
  "CHEMURGIC": "relating to chemurgy, industrial organic chemistry, also CHEMURGICAL [adj]\n",
  "CHEMURGICAL": "relating to chemurgy, industrial organic chemistry, also CHEMURGIC [adj]\n",
  "CHEMURGIES": "CHEMURGY, a branch of applied chemistry [n]\n",
  "CHEMURGY": "a branch of applied chemistry [n CHEMURGIES]\n",
  "CHENAR": "(Persian) the oriental plane tree, also CHINAR [n -S]\n",
  "CHENARS": "CHENAR, (Persian) the oriental plane tree, also CHINAR [n]\n",
  "CHENET": "(French) an andiron, an iron bar which supports logs in a fireplace [n -S]\n",
  "CHENETS": "CHENET, (French) an andiron, an iron bar which supports logs in a fireplace [n]\n",
  "CHENILLE": "(French) a velvety silk, wool or cotton fabric with protruding pile [n -S]\n",
  "CHENILLES": "CHENILLE, (French) a velvety silk, wool or cotton fabric with protruding pile [n]\n",
  "CHENIX": "(Greek) an ancient Greek dry measure [n -ES]\n",
  "CHENIXES": "CHENIX, (Greek) an ancient Greek dry measure [n]\n",
  "CHENOPOD": "any flowering plant of the family Chenopodiaceae, the goosefoots [n -S]\n",
  "CHENOPODIACEOUS": "belonging to the goosefoot family [adj]\n",
  "CHENOPODS": "CHENOPOD, any flowering plant of the family Chenopodiaceae, the goosefoots [n]\n",
  "CHEONGSAM": "(Chinese) an oriental dress with a slit skirt and a mandarin collar [n -S]\n",
  "CHEONGSAMS": "CHEONGSAM, (Chinese) an oriental dress with a slit skirt and a mandarin collar [n]\n",
  "CHEQUE": "a written order directing a bank to pay money [n -S]\n",
  "CHEQUEBOOK": "a book containing cheques [n -S]\n",
  "CHEQUEBOOKS": "CHEQUEBOOK, a book containing cheques [n]\n",
  "CHEQUER": "to divide into or mark with squares, esp. of alternate colours, also CHECKER [v -ED, -ING, -S]\n",
  "CHEQUERBOARD": "a board for playing chequers [n -S]\n",
  "CHEQUERBOARDS": "CHEQUERBOARD, a board for playing chequers [n]\n",
  "CHEQUERED": "CHEQUER, to divide into or mark with squares, esp. of alternate colours, also CHECKER [v]\n",
  "CHEQUERING": "CHEQUER, to divide into or mark with squares, esp. of alternate colours, also CHECKER [v]\n",
  "CHEQUERS": "CHEQUER, to divide into or mark with squares, esp. of alternate colours, also CHECKER [v]\n",
  "CHEQUERWISE": "in chequered fashion [adv]\n",
  "CHEQUERWORK": "any pattern having alternating squares of different colours [n -S]\n",
  "CHEQUERWORKS": "CHEQUERWORK, any pattern having alternating squares of different colours [n]\n",
  "CHEQUES": "CHEQUE, a written order directing a bank to pay money [n]\n",
  "CHEQUIER": "CHEQUY, checkered, also CHECKY [adj]\n",
  "CHEQUIEST": "CHEQUY, checkered, also CHECKY [adj]\n",
  "CHEQUING": "as in chequing account, an account at a bank or building society against which cheques may be drawn [adj]\n",
  "CHEQUY": "checkered, also CHECKY [adj CHEQUIER, CHEQUIEST]\n",
  "CHER": "(French) dear [adj]\n",
  "CHERALITE": "a radioactive mineral rich in thorium and uranium [n -S]\n",
  "CHERALITES": "CHERALITE, a radioactive mineral rich in thorium and uranium [n]\n",
  "CHERE": "(French) dear (feminine) [adj]\n",
  "CHERIMOYA": "(Quechua) a Peruvian fruit resembling the custard apple, also CHERIMOYER, CHIRIMOYA [n -S]\n",
  "CHERIMOYAS": "CHERIMOYA, (Quechua) a Peruvian fruit resembling the custard apple, also CHERIMOYER, CHIRIMOYA [n]\n",
  "CHERIMOYER": "(Quechua) a Peruvian fruit resembling the custard apple, also CHERIMOYA, CHIRIMOYA [n -S]\n",
  "CHERIMOYERS": "CHERIMOYER, (Quechua) a Peruvian fruit resembling the custard apple, also CHERIMOYA, CHIRIMOYA [n]\n",
  "CHERISH": "to hold dear [v -ED, -ING, -ES]\n",
  "CHERISHABLE": "that can be cherished [adj]\n",
  "CHERISHED": "CHERISH, to hold dear [v]\n",
  "CHERISHER": "one who cherishes [n -S]\n",
  "CHERISHERS": "CHERISHER, one who cherishes [n]\n",
  "CHERISHES": "CHERISH, to hold dear [v]\n",
  "CHERISHING": "CHERISH, to hold dear [v]\n",
  "CHERISHINGLY": "CHERISHING, CHERISH, to hold dear [adv]\n",
  "CHERISHMENT": "the act of cherishing [n -S]\n",
  "CHERISHMENTS": "CHERISHMENT, the act of cherishing [n]\n",
  "CHERMOULA": "(Arabic) a marinade containing onion, coriander, and parsley, used in North African cookery [n -S]\n",
  "CHERMOULAS": "CHERMOULA, (Arabic) a marinade containing onion, coriander, and parsley, used in North African cookery [n]\n",
  "CHERNOZEM": "(Russian) a very fertile soil of subhumid steppe, also TSCHERNOSEM [n -S]\n",
  "CHERNOZEMIC": "of or like chernozem [adj]\n",
  "CHERNOZEMS": "CHERNOZEM, (Russian) a very fertile soil of subhumid steppe, also TSCHERNOSEM [n]\n",
  "CHEROOT": "(Tamil) a square-cut cigar, also SHEROOT [n -S]\n",
  "CHEROOTS": "CHEROOT, (Tamil) a square-cut cigar, also SHEROOT [n]\n",
  "CHERRIED": "CHERRY, to cheer [v]\n",
  "CHERRIER": "CHERRY, ruddy [adj]\n",
  "CHERRIES": "CHERRY, to cheer [v]\n",
  "CHERRIEST": "CHERRY, ruddy [adj]\n",
  "CHERRY": "a fruit [n CHERRIES] / ruddy [adj CHERRIER, CHERRIEST] / to cheer [v CHERRIED, CHERRYING, CHERRIES]\n",
  "CHERRYING": "CHERRY, to cheer [v]\n",
  "CHERRYLIKE": "like a cherry [adj]\n",
  "CHERRYSTONE": "a medium-sized quahog [n -S]\n",
  "CHERRYSTONES": "CHERRYSTONE, a medium-sized quahog [n]\n",
  "CHERSONESE": "a peninsula [n -S]\n",
  "CHERSONESES": "CHERSONESE, a peninsula [n]\n",
  "CHERT": "a microcrystalline form of silica, occurring as several varieties, aka hornstone [n -S]\n",
  "CHERTIER": "CHERTY, resembling chert [adj]\n",
  "CHERTIEST": "CHERTY, resembling chert [adj]\n",
  "CHERTS": "CHERT, a microcrystalline form of silica, occurring as several varieties, aka hornstone [n]\n",
  "CHERTY": "resembling chert [adj CHERTIER, CHERTIEST]\n",
  "CHERUB": "(Hebrew) an angel [n CHERUBS or CHERUBIM]\n",
  "CHERUBIC": "like a cherub, also CHERUBICAL [adj CHERUBICALLY]\n",
  "CHERUBICAL": "like a cherub, also CHERUBIC [adj CHERUBICALLY]\n",
  "CHERUBICALLY": "CHERUBICAL, like a cherub, also CHERUBIC [adv]\n",
  "CHERUBIM": "CHERUB, (Hebrew) an angel [n]\n",
  "CHERUBIMIC": "like a cherub [adj]\n",
  "CHERUBIMS": "CHERUB, (Hebrew) an angel [n]\n",
  "CHERUBIN": "(Shakespeare) a cherub [n -S]\n",
  "CHERUBINS": "CHERUBIN, (Shakespeare) a cherub [n]\n",
  "CHERUBLIKE": "like a cherub [adj]\n",
  "CHERUBS": "CHERUB, (Hebrew) an angel [n]\n",
  "CHERUP": "to chirp, also CHIRRUP [v -ED, -ING, -S]\n",
  "CHERUPED": "CHERUP, to chirp, also CHIRRUP [v]\n",
  "CHERUPING": "CHERUP, to chirp, also CHIRRUP [v]\n",
  "CHERUPS": "CHERUP, to chirp, also CHIRRUP [v]\n",
  "CHERVIL": "an aromatic umbelliferous herb [n -S]\n",
  "CHERVILS": "CHERVIL, an aromatic umbelliferous herb [n]\n",
  "CHERVONETS": "a former Soviet monetary unit or gold coin, worth ten roubles [n CHERVONETS]\n",
  "CHESHIRE": "a hard English cheese [n -S]\n",
  "CHESHIRES": "CHESHIRE, a hard English cheese [n]\n",
  "CHESIL": "shingle, gravel [n -S]\n",
  "CHESILS": "CHESIL, shingle, gravel [n]\n",
  "CHESNUT": "a chestnut [n -S]\n",
  "CHESNUTS": "CHESNUT, a chestnut [n]\n",
  "CHESS": "a game of skill for two players, in which figures or men of different kinds are moved on a chequered board [n -ES]\n",
  "CHESSBOARD": "a checkerboard used in the game of chess [n -S]\n",
  "CHESSBOARDS": "CHESSBOARD, a checkerboard used in the game of chess [n]\n",
  "CHESSBOXING": "a hybrid sport which combines the sport of boxing with games of chess in alternating rounds [n -S]\n",
  "CHESSBOXINGS": "CHESSBOXING, a hybrid sport which combines the sport of boxing with games of chess in alternating rounds [n]\n",
  "CHESSEL": "a cheese-mould [n -S]\n",
  "CHESSELS": "CHESSEL, a cheese-mould [n]\n",
  "CHESSES": "CHESS, a game of skill for two players, in which figures or men of different kinds are moved on a chequered board [n]\n",
  "CHESSMAN": "a piece for a board game [n CHESSMEN]\n",
  "CHESSMEN": "CHESSMAN, a piece for a board game [n]\n",
  "CHESSPIECE": "a piece used in playing chess [n -S]\n",
  "CHESSPIECES": "CHESSPIECE, a piece used in playing chess [n]\n",
  "CHESSPLAYER": "one who plays chess [n -S]\n",
  "CHESSPLAYERS": "CHESSPLAYER, one who plays chess [n]\n",
  "CHESSYLITE": "a basic carbonate of copper, vivid blue in colour [n -S]\n",
  "CHESSYLITES": "CHESSYLITE, a basic carbonate of copper, vivid blue in colour [n]\n",
  "CHEST": "to hit a ball with the upper part of the body [v -ED, -ING, -S]\n",
  "CHESTED": "CHEST, to hit a ball with the upper part of the body [v]\n",
  "CHESTERFIELD": "a sofa [n -S]\n",
  "CHESTERFIELDS": "CHESTERFIELD, a sofa [n]\n",
  "CHESTFUL": "as much as a chest can hold, also KISTFUL [n -S]\n",
  "CHESTFULS": "CHESTFUL, as much as a chest can hold, also KISTFUL [n]\n",
  "CHESTIER": "CHESTY, suffering from a cough on the chest [adj]\n",
  "CHESTIEST": "CHESTY, suffering from a cough on the chest [adj]\n",
  "CHESTILY": "CHESTY, suffering from a cough on the chest [adv]\n",
  "CHESTINESS": "the state of being chesty [n -ES]\n",
  "CHESTINESSES": "CHESTINESS, the state of being chesty [n]\n",
  "CHESTING": "CHEST, to hit a ball with the upper part of the body [v]\n",
  "CHESTNUT": "a tree of genus Castanea, esp. the Spanish or sweet chestnut; its edible nut, also CHESNUT [n -S]\n",
  "CHESTNUTS": "CHESTNUT, a tree of genus Castanea, esp. the Spanish or sweet chestnut; its edible nut, also CHESNUT [n]\n",
  "CHESTS": "CHEST, to hit a ball with the upper part of the body [v]\n",
  "CHESTY": "suffering from a cough on the chest [adj CHESTIER, CHESTIEST, CHESTILY]\n",
  "CHETAH": "(Hindi) a swift-running wildcat, also CHEETAH [n -S]\n",
  "CHETAHS": "CHETAH, (Hindi) a swift-running wildcat, also CHEETAH [n]\n",
  "CHETH": "(Hebrew) the eighth letter of the Hebrew alphabet, also HETH, KHET, KHETH [n -S]\n",
  "CHETHS": "CHETH, (Hebrew) the eighth letter of the Hebrew alphabet, also HETH, KHET, KHETH [n]\n",
  "CHETNIK": "(Serbo-Croat) a Serbian resistance fighter involved in guerrilla warfare against Turkish rule in the 19th century [n -S]\n",
  "CHETNIKS": "CHETNIK, (Serbo-Croat) a Serbian resistance fighter involved in guerrilla warfare against Turkish rule in the 19th century [n]\n",
  "CHETRUM": "(Tibetan) a monetary unit of Bhutan [n CHETRUMS or CHHERTUM]\n",
  "CHETRUMS": "CHETRUM, (Tibetan) a monetary unit of Bhutan [n]\n",
  "CHEVAL": "as in cheval glass, a full-length mirror that can be swivelled [adj]\n",
  "CHEVALET": "(French) the bridge of a stringed instrument [n -S]\n",
  "CHEVALETS": "CHEVALET, (French) the bridge of a stringed instrument [n]\n",
  "CHEVALIER": "(French) a cavalier, a knight [n -S]\n",
  "CHEVALIERS": "CHEVALIER, (French) a cavalier, a knight [n]\n",
  "CHEVELURE": "a head of hair or arrangement of the hair [n -S]\n",
  "CHEVELURES": "CHEVELURE, a head of hair or arrangement of the hair [n]\n",
  "CHEVEN": "a fish, the chub, also CHEVIN [n -S]\n",
  "CHEVENS": "CHEVEN, a fish, the chub, also CHEVIN [n]\n",
  "CHEVEREL": "soft, flexible, kidskin leather, also CHEVERIL [n -S]\n",
  "CHEVERELS": "CHEVEREL, soft, flexible, kidskin leather, also CHEVERIL [n]\n",
  "CHEVERIL": "soft, flexible, kidskin leather, also CHEVEREL [n -S]\n",
  "CHEVERILS": "CHEVERIL, soft, flexible, kidskin leather, also CHEVEREL [n]\n",
  "CHEVERON": "a kid glove [n -S]\n",
  "CHEVERONS": "CHEVERON, a kid glove [n]\n",
  "CHEVERYE": "(Spenser) an Irish chieftaincy, also CHIEFERY, CHIEFRY [n -S]\n",
  "CHEVERYES": "CHEVERYE, (Spenser) an Irish chieftaincy, also CHIEFERY, CHIEFRY [n]\n",
  "CHEVESAILE": "an ornamental collar of a coat [n -S]\n",
  "CHEVESAILES": "CHEVESAILE, an ornamental collar of a coat [n]\n",
  "CHEVET": "(French) the east end of (especially French Gothic) church or chancel [n -S]\n",
  "CHEVETS": "CHEVET, (French) the east end of (especially French Gothic) church or chancel [n]\n",
  "CHEVIED": "CHEVY, to chase about, also CHIVVY, CHIVY [v]\n",
  "CHEVIES": "CHEVY, to chase about, also CHIVVY, CHIVY [v]\n",
  "CHEVILLE": "(French) the peg of a stringed instrument [n -S]\n",
  "CHEVILLES": "CHEVILLE, (French) the peg of a stringed instrument [n]\n",
  "CHEVIN": "a fish, the chub, also CHEVEN [n -S]\n",
  "CHEVINS": "CHEVIN, a fish, the chub, also CHEVEN [n]\n",
  "CHEVIOT": "a coarse heavy plain or twilled wool or worsted [n -S]\n",
  "CHEVIOTS": "CHEVIOT, a coarse heavy plain or twilled wool or worsted [n]\n",
  "CHEVISANCE": "(obsolete) resource; achievement; gain [n -S]\n",
  "CHEVISANCES": "CHEVISANCE, (obsolete) resource; achievement; gain [n]\n",
  "CHEVRE": "(French) a cheese made from goat's milk, also CHEVRET [n -S]\n",
  "CHEVRES": "CHEVRE, (French) a cheese made from goat's milk, also CHEVRET [n]\n",
  "CHEVRET": "(French) a cheese made from goat's milk, also CHEVRE [n -S]\n",
  "CHEVRETS": "CHEVRET, (French) a cheese made from goat's milk, also CHEVRE [n]\n",
  "CHEVRETTE": "(French) a kind of thin kid leather [n -S]\n",
  "CHEVRETTES": "CHEVRETTE, (French) a kind of thin kid leather [n]\n",
  "CHEVRON": "(French) a pattern consisting of a line of horizontal black and white V-shapes [n -S]\n",
  "CHEVRONED": "marked with chevrons [adj]\n",
  "CHEVRONS": "CHEVRON, (French) a pattern consisting of a line of horizontal black and white V-shapes [n]\n",
  "CHEVRONY": "adorned with chevrons [adj]\n",
  "CHEVROTAIN": "(French) a small deerlike mammal [n -S]\n",
  "CHEVROTAINS": "CHEVROTAIN, (French) a small deerlike mammal [n]\n",
  "CHEVROTIN": "(French) a kind of soft French cheese made from goat's milk [n -S]\n",
  "CHEVROTINS": "CHEVROTIN, (French) a kind of soft French cheese made from goat's milk [n]\n",
  "CHEVY": "to chase about, also CHIVVY, CHIVY [v CHEVIED, CHEVYING, CHEVIES]\n",
  "CHEVYING": "CHEVY, to chase about, also CHIVVY, CHIVY [v]\n",
  "CHEW": "to grind with the teeth [v -ED, -ING, -S]\n",
  "CHEWABLE": "able to be chewed [adj]\n",
  "CHEWED": "CHEW, to grind with the teeth [v]\n",
  "CHEWER": "one who chews, also CHAWER [n -S]\n",
  "CHEWERS": "CHEWER, one who chews, also CHAWER [n]\n",
  "CHEWET": "(obsolete) a kind of meat pie [n -S]\n",
  "CHEWETS": "CHEWET, (obsolete) a kind of meat pie [n]\n",
  "CHEWIE": "(Australian slang) chewing-gum, also CHUDDY [n -S]\n",
  "CHEWIER": "CHEWY, not easily chewed [adj]\n",
  "CHEWIES": "CHEWIE, (Australian slang) chewing-gum, also CHUDDY [n]\n",
  "CHEWIEST": "CHEWY, not easily chewed [adj]\n",
  "CHEWINESS": "the state of being chewy [n -ES]\n",
  "CHEWINESSES": "CHEWINESS, the state of being chewy [n]\n",
  "CHEWING": "CHEW, to grind with the teeth [v]\n",
  "CHEWINK": "an American bird of the Finch family, so called from its note, also CHEEWINK [n -S]\n",
  "CHEWINKS": "CHEWINK, an American bird of the Finch family, so called from its note, also CHEEWINK [n]\n",
  "CHEWS": "CHEW, to grind with the teeth [v]\n",
  "CHEWY": "not easily chewed [adj CHEWIER, CHEWIEST]\n",
  "CHEZ": "(French) at the home of [prep]\n",
  "CHHERTUM": "CHETRUM, (Tibetan) a monetary unit of Bhutan [n]\n",
  "CHI": "the twenty-second letter of the Greek alphabet, also KHI [n -S]\n",
  "CHIA": "a Mexican herb with edible seeds [n -S]\n",
  "CHIACK": "(Australian slang) to tease, deride, also CHYACK [v -ED, -ING, -S]\n",
  "CHIACKED": "CHIACK, (Australian slang) to tease, deride, also CHYACK [v]\n",
  "CHIACKING": "the act of teasing, deriding [n -S]\n",
  "CHIACKINGS": "CHIACKING, the act of teasing, deriding [n]\n",
  "CHIACKS": "CHIACK, (Australian slang) to tease, deride, also CHYACK [v]\n",
  "CHIANTI": "(Italian) a dry red Italian wine [n -S]\n",
  "CHIANTIS": "CHIANTI, (Italian) a dry red Italian wine [n]\n",
  "CHIAO": "(Chinese) a Chinese monetary unit, one tenth of a yuan, also JIAO [n -S]\n",
  "CHIAOS": "CHIAO, (Chinese) a Chinese monetary unit, one tenth of a yuan, also JIAO [n]\n",
  "CHIAREZZA": "(Italian) purity, clarity [n CHIAREZZE or CHIAREZZAS]\n",
  "CHIAREZZAS": "CHIAREZZA, (Italian) purity, clarity [n]\n",
  "CHIAREZZE": "CHIAREZZA, (Italian) purity, clarity [n]\n",
  "CHIAROSCURISM": "the practice of chiaroscuro [n -S]\n",
  "CHIAROSCURISMS": "CHIAROSCURISM, the practice of chiaroscuro [n]\n",
  "CHIAROSCURIST": "an artist who specializes in chiaroscuro [n -S]\n",
  "CHIAROSCURISTS": "CHIAROSCURIST, an artist who specializes in chiaroscuro [n]\n",
  "CHIAROSCURO": "(Italian) the quality of being veiled or partly in shadow [n -S]\n",
  "CHIAROSCUROS": "CHIAROSCURO, (Italian) the quality of being veiled or partly in shadow [n]\n",
  "CHIAS": "CHIA, a Mexican herb with edible seeds [n]\n",
  "CHIASM": "(Greek) a commissure; esp. the optic commissure, or crucial union of the optic nerves, also CHIASMA [n -S]\n",
  "CHIASMA": "(Greek) a connection formed during meiosis, also CHIASM [n CHIASMAS or CHIASMATA]\n",
  "CHIASMAL": "pertaining to a chiasm [adj]\n",
  "CHIASMAS": "CHIASMA, (Greek) a connection formed during meiosis, also CHIASM [n]\n",
  "CHIASMATA": "CHIASMA, (Greek) a connection formed during meiosis, also CHIASM [n]\n",
  "CHIASMATIC": "relating to chiasma [adj]\n",
  "CHIASMI": "CHIASMUS, (Greek) the inversion of the order of corresponding elements of two parallel phrases, as 'do not live to eat but eat to live' [n]\n",
  "CHIASMIC": "relating to chiasmus, the inversion of order of corresponding elements of two parallel phrases, also CHIASTIC [adj]\n",
  "CHIASMS": "CHIASM, (Greek) a commissure; esp. the optic commissure, or crucial union of the optic nerves, also CHIASMA [n]\n",
  "CHIASMUS": "(Greek) the inversion of the order of corresponding elements of two parallel phrases, as 'do not live to eat but eat to live' [n CHIASMI]\n",
  "CHIASTIC": "relating to chiasmus, the inversion of order of corresponding elements of two parallel phrases, also CHIASMIC [adj]\n",
  "CHIASTOLITE": "a form of andalusite, a silicate of aluminium [n -S]\n",
  "CHIASTOLITES": "CHIASTOLITE, a form of andalusite, a silicate of aluminium [n]\n",
  "CHIAUS": "to cheat, swindle [v -ED, -ING, -ES]\n",
  "CHIAUSED": "CHIAUS, to cheat, swindle [v]\n",
  "CHIAUSES": "CHIAUS, to cheat, swindle [v]\n",
  "CHIAUSING": "CHIAUS, to cheat, swindle [v]\n",
  "CHIB": "(Scots) to slash with a sharp weapon [v CHIBBED, CHIBBING, CHIBS]\n",
  "CHIBBED": "CHIB, (Scots) to slash with a sharp weapon [v]\n",
  "CHIBBING": "CHIB, (Scots) to slash with a sharp weapon [v]\n",
  "CHIBOL": "a variety of onion, aka spring onion, also CIBOL, CIBOULE, SYBO, SYBOE, SYBOW [n -S]\n",
  "CHIBOLS": "CHIBOL, a variety of onion, aka spring onion, also CIBOL, CIBOULE, SYBO, SYBOE, SYBOW [n]\n",
  "CHIBOUK": "(Turkish) a long straight-stemmed Turkish tobacco pipe, also CHIBOUQUE [n -S]\n",
  "CHIBOUKS": "CHIBOUK, (Turkish) a long straight-stemmed Turkish tobacco pipe, also CHIBOUQUE [n]\n",
  "CHIBOUQUE": "(Turkish) a long straight-stemmed Turkish tobacco pipe, also CHIBOUK [n -S]\n",
  "CHIBOUQUES": "CHIBOUQUE, (Turkish) a long straight-stemmed Turkish tobacco pipe, also CHIBOUK [n]\n",
  "CHIBS": "CHIB, (Scots) to slash with a sharp weapon [v]\n",
  "CHIC": "elegance [n -S] / smartly elegant [adj CHICER, CHICEST, CHICLY]\n",
  "CHICA": "an orange-red dyestuff used by South American Indians, also CHICHA, CHICO [n -S]\n",
  "CHICALOTE": "(Nahuatl) a prickly poppy of the SW US [n -S]\n",
  "CHICALOTES": "CHICALOTE, (Nahuatl) a prickly poppy of the SW US [n]\n",
  "CHICANA": "(US derogatory) a (female) American of Mexican descent [n -S]\n",
  "CHICANAS": "CHICANA, (US derogatory) a (female) American of Mexican descent [n]\n",
  "CHICANE": "to quibble [v CHICANED, CHICANING, CHICANES]\n",
  "CHICANED": "CHICANE, to quibble [v]\n",
  "CHICANER": "a person who chicanes, a quibbler [n -S]\n",
  "CHICANERIES": "CHICANERY, deception by trickery or sophistry [n]\n",
  "CHICANERS": "CHICANER, a person who chicanes, a quibbler [n]\n",
  "CHICANERY": "deception by trickery or sophistry [n CHICANERIES]\n",
  "CHICANES": "CHICANE, to quibble [v]\n",
  "CHICANING": "quibbling, using tricks and artifices [n -S]\n",
  "CHICANINGS": "CHICANING, quibbling, using tricks and artifices [n]\n",
  "CHICANO": "(Spanish) an American of Mexican descent [n -S]\n",
  "CHICANOS": "CHICANO, (Spanish) an American of Mexican descent [n]\n",
  "CHICAS": "CHICA, an orange-red dyestuff used by South American Indians, also CHICHA, CHICO [n]\n",
  "CHICCORIES": "CHICCORY, succory, a blue-flowered composite plant, also CHICKORY, CHICORY [n]\n",
  "CHICCORY": "succory, a blue-flowered composite plant, also CHICKORY, CHICORY [n CHICCORIES]\n",
  "CHICER": "CHIC, smartly elegant [adj]\n",
  "CHICEST": "CHIC, smartly elegant [adj]\n",
  "CHICH": "the chickpea [n -ES]\n",
  "CHICHA": "an orange-red dyestuff used by South American Indians, also CHICA, CHICO [n -S]\n",
  "CHICHAS": "CHICHA, an orange-red dyestuff used by South American Indians, also CHICA, CHICO [n]\n",
  "CHICHES": "CHICH, the chickpea [n]\n",
  "CHICHI": "elaborate ornamentation [n -S] / elaborately ornamented [adj CHICHIER, CHICHIEST]\n",
  "CHICHIER": "CHICHI, elaborately ornamented [adj]\n",
  "CHICHIEST": "CHICHI, elaborately ornamented [adj]\n",
  "CHICHIS": "CHICHI, elaborate ornamentation [n]\n",
  "CHICK": "a young bird [n -S]\n",
  "CHICKABIDDIES": "CHICKABIDDY, a term of endearment [n]\n",
  "CHICKABIDDY": "a term of endearment [n CHICKABIDDIES]\n",
  "CHICKADEE": "a North American bird of the titmouse family [n -S]\n",
  "CHICKADEES": "CHICKADEE, a North American bird of the titmouse family [n]\n",
  "CHICKAREE": "the American red squirrel, so called from its cry [n -S]\n",
  "CHICKAREES": "CHICKAREE, the American red squirrel, so called from its cry [n]\n",
  "CHICKEE": "a stilt house of the Seminole Indians [n -S]\n",
  "CHICKEES": "CHICKEE, a stilt house of the Seminole Indians [n]\n",
  "CHICKEN": "to loose one's nerve [v -ED, -ING, -S]\n",
  "CHICKENED": "CHICKEN, to loose one's nerve [v]\n",
  "CHICKENHEARTED": "timid, cowardly [adj]\n",
  "CHICKENING": "CHICKEN, to loose one's nerve [v]\n",
  "CHICKENPOX": "a contagious febrile disease, chiefly affecting children, not unlike a mild form of smallpox [n -ES]\n",
  "CHICKENPOXES": "CHICKENPOX, a contagious febrile disease, chiefly affecting children, not unlike a mild form of smallpox [n]\n",
  "CHICKENS": "CHICKEN, to loose one's nerve [v]\n",
  "CHICKENSHIT": "petty; lacking courage [adj] / the petty details of a duty or discipline [n -S]\n",
  "CHICKENSHITS": "CHICKENSHIT, the petty details of a duty or discipline [n]\n",
  "CHICKLING": "a small chick or chicken [n -S]\n",
  "CHICKLINGS": "CHICKLING, a small chick or chicken [n]\n",
  "CHICKORIES": "CHICKORY, a perennial herb, also CHICORY, CHICCORY [n]\n",
  "CHICKORY": "a perennial herb, also CHICORY, CHICCORY [n CHICKORIES]\n",
  "CHICKPEA": "a dwarf pea grown for food esp. in Asia [n -S]\n",
  "CHICKPEAS": "CHICKPEA, a dwarf pea grown for food esp. in Asia [n]\n",
  "CHICKS": "CHICK, a young bird [n]\n",
  "CHICKWEED": "any plant of the genus Stellaria [n -S]\n",
  "CHICKWEEDS": "CHICKWEED, any plant of the genus Stellaria [n]\n",
  "CHICLE": "(Nahuatl) the coagulated latex of the sapodilla, which forms the basis of chewing-gum [n -S]\n",
  "CHICLES": "CHICLE, (Nahuatl) the coagulated latex of the sapodilla, which forms the basis of chewing-gum [n]\n",
  "CHICLY": "CHIC, smartly elegant [adv]\n",
  "CHICNESS": "being chic [n -ES]\n",
  "CHICNESSES": "CHICNESS, being chic [n]\n",
  "CHICO": "an orange-red dyestuff used by South American Indians, also CHICA, CHICHA [n -S]\n",
  "CHICON": "the shoot of the chicory plant, eaten like lettuce [n -S]\n",
  "CHICONS": "CHICON, the shoot of the chicory plant, eaten like lettuce [n]\n",
  "CHICORIES": "CHICORY, succory, a blue-flowered composite plant, also CHICCORY, CHICKORY [n]\n",
  "CHICORY": "succory, a blue-flowered composite plant, also CHICCORY, CHICKORY [n CHICORIES]\n",
  "CHICOS": "CHICO, an orange-red dyestuff used by South American Indians, also CHICA, CHICHA [n]\n",
  "CHICOT": "a handsome tree of central and eastern North America having large woody brown pods whose seeds are used as a coffee substitute [n -S]\n",
  "CHICOTS": "CHICOT, a handsome tree of central and eastern North America having large woody brown pods whose seeds are used as a coffee substitute [n]\n",
  "CHICS": "CHIC, elegance [n]\n",
  "CHID": "CHIDE, to scold [v]\n",
  "CHIDDEN": "CHIDE, to scold [v]\n",
  "CHIDE": "to scold [v CHID or CHODE or CHIDED, CHIDDEN, CHIDING, CHIDES]\n",
  "CHIDED": "CHIDE, to scold [v]\n",
  "CHIDER": "(Shakespeare) a quarrelsome person [n -S]\n",
  "CHIDERS": "CHIDER, (Shakespeare) a quarrelsome person [n]\n",
  "CHIDES": "CHIDE, to scold [v]\n",
  "CHIDING": "scolding [adj CHIDINGLY] / a scolding [n -S]\n",
  "CHIDINGLY": "CHIDING, scolding [adv]\n",
  "CHIDINGS": "CHIDING, a scolding [n]\n",
  "CHIDLINGS": "part of the small intestine of swine, also CHITLINGS [n]\n",
  "CHIEF": "the highest in authority [n -S] / important [adj CHIEFER, CHIEFEST]\n",
  "CHIEFDOM": "the domain of a chief [n -S]\n",
  "CHIEFDOMS": "CHIEFDOM, the domain of a chief [n]\n",
  "CHIEFER": "CHIEF, important [adj]\n",
  "CHIEFERIES": "CHIEFERY, an Irish chieftaincy [n]\n",
  "CHIEFERY": "an Irish chieftaincy [n CHIEFERIES]\n",
  "CHIEFESS": "a female chief [n -ES]\n",
  "CHIEFESSES": "CHIEFESS, a female chief [n]\n",
  "CHIEFEST": "CHIEF, important [adj]\n",
  "CHIEFLESS": "without a chief or leader [adj]\n",
  "CHIEFLING": "a minor chief [n -S]\n",
  "CHIEFLINGS": "CHIEFLING, a minor chief [n]\n",
  "CHIEFLY": "CHIEF, important [adv]\n",
  "CHIEFRIES": "CHIEFRY, an Irish chieftaincy [n]\n",
  "CHIEFRY": "an Irish chieftaincy [n CHIEFRIES]\n",
  "CHIEFS": "CHIEF, the highest in authority [n]\n",
  "CHIEFSHIP": "the office of chief [n -S]\n",
  "CHIEFSHIPS": "CHIEFSHIP, the office of chief [n]\n",
  "CHIEFTAIN": "the head of a clan; a leader or commander [n -S]\n",
  "CHIEFTAINCIES": "CHIEFTAINCY, the office of a chieftain [n]\n",
  "CHIEFTAINCY": "the office of a chieftain [n CHIEFTAINCIES]\n",
  "CHIEFTAINESS": "a female chieftain [n -ES]\n",
  "CHIEFTAINESSES": "CHIEFTAINESS, a female chieftain [n]\n",
  "CHIEFTAINRIES": "CHIEFTAINRY, the office of chieftain [n]\n",
  "CHIEFTAINRY": "the office of chieftain [n CHIEFTAINRIES]\n",
  "CHIEFTAINS": "CHIEFTAIN, the head of a clan; a leader or commander [n]\n",
  "CHIEFTAINSHIP": "the rank of chieftain [n -S]\n",
  "CHIEFTAINSHIPS": "CHIEFTAINSHIP, the rank of chieftain [n]\n",
  "CHIEL": "(Scots) a man, a lad, also CHIELD [n -S]\n",
  "CHIELD": "(Scots) a man, a lad, also CHIEL [n -S]\n",
  "CHIELDS": "CHIELD, (Scots) a man, a lad, also CHIEL [n]\n",
  "CHIELS": "CHIEL, (Scots) a man, a lad, also CHIELD [n]\n",
  "CHIFFCHAFF": "a small grayish European warbler [n -S]\n",
  "CHIFFCHAFFS": "CHIFFCHAFF, a small grayish European warbler [n]\n",
  "CHIFFON": "(French) a sheer fabric [n -S]\n",
  "CHIFFONADE": "(French) green plants cooked in butter, esp. a mixture of lettuce and sorrel [n -S]\n",
  "CHIFFONADES": "CHIFFONADE, (French) green plants cooked in butter, esp. a mixture of lettuce and sorrel [n]\n",
  "CHIFFONIER": "(French) a chest of drawers, also CHIFFONNIER [n -S]\n",
  "CHIFFONIERS": "CHIFFONIER, (French) a chest of drawers, also CHIFFONNIER [n]\n",
  "CHIFFONNIER": "(French) a chest of drawers, also CHIFFONIER [n -S]\n",
  "CHIFFONNIERS": "CHIFFONNIER, (French) a chest of drawers, also CHIFFONIER [n]\n",
  "CHIFFONNIEST": "CHIFFONY, like chiffon, a sheer silk fabric [adj]\n",
  "CHIFFONS": "CHIFFON, (French) a sheer fabric [n]\n",
  "CHIFFONY": "like chiffon, a sheer silk fabric [adj CHIFFONNIER, CHIFFONNIEST]\n",
  "CHIFFOROBE": "a combination of wardrobe and chest of drawers [n -S]\n",
  "CHIFFOROBES": "CHIFFOROBE, a combination of wardrobe and chest of drawers [n]\n",
  "CHIGETAI": "(Mongolian) a wild ass native to the Tibetan plateau, aka kiang or kyang, also DZIGGETAI [n -S]\n",
  "CHIGETAIS": "CHIGETAI, (Mongolian) a wild ass native to the Tibetan plateau, aka kiang or kyang, also DZIGGETAI [n]\n",
  "CHIGGA": "(offensive Australian slang) a derogatory term for a young working-class person from Hobart, Tasmania [n -S]\n",
  "CHIGGAS": "CHIGGA, (offensive Australian slang) a derogatory term for a young working-class person from Hobart, Tasmania [n]\n",
  "CHIGGER": "a parasitic mite, also REDBUG [n -S]\n",
  "CHIGGERS": "CHIGGER, a parasitic mite, also REDBUG [n]\n",
  "CHIGNON": "(French) a knot or roll of hair worn at the back of the head [n -S]\n",
  "CHIGNONED": "wearing a chignon, a knot or roll of hair worn at the back of the head [adj]\n",
  "CHIGNONS": "CHIGNON, (French) a knot or roll of hair worn at the back of the head [n]\n",
  "CHIGOE": "a small tropical flea, also CHEGOE, CHIGGER, CHIGRE [n -S]\n",
  "CHIGOES": "CHIGOE, a small tropical flea, also CHEGOE, CHIGGER, CHIGRE [n]\n",
  "CHIGRE": "a small tropical flea, also CHEGOE, CHIGGER, CHIGOE [n -S]\n",
  "CHIGRES": "CHIGRE, a small tropical flea, also CHEGOE, CHIGGER, CHIGOE [n]\n",
  "CHIHUAHUA": "a breed of small dog from Mexico [n -S]\n",
  "CHIHUAHUAS": "CHIHUAHUA, a breed of small dog from Mexico [n]\n",
  "CHIK": "(Hindi) a slatted blind [n -S]\n",
  "CHIKARA": "(Hindi) a four-horned Indian antelope, also CHINKARA [n -S]\n",
  "CHIKARAS": "CHIKARA, (Hindi) a four-horned Indian antelope, also CHINKARA [n]\n",
  "CHIKHOR": "(Hindi) an Indian partridge, also CHIKOR, CHUKAR, CHUKOR [n -S]\n",
  "CHIKHORS": "CHIKHOR, (Hindi) an Indian partridge, also CHIKOR, CHUKAR, CHUKOR [n]\n",
  "CHIKOR": "(Hindi) an Indian partridge, also CHIKHOR, CHUKAR, CHUKOR [n -S]\n",
  "CHIKORS": "CHIKOR, (Hindi) an Indian partridge, also CHIKHOR, CHUKAR, CHUKOR [n]\n",
  "CHIKS": "CHIK, (Hindi) a slatted blind [n]\n",
  "CHILBLAIN": "a painful red swelling, esp. on hands and feet, caused by constriction of small blood vessels in cold weather [n -S]\n",
  "CHILBLAINED": "having chilblains [adj]\n",
  "CHILBLAINS": "CHILBLAIN, a painful red swelling, esp. on hands and feet, caused by constriction of small blood vessels in cold weather [n]\n",
  "CHILD": "to bring forth [v -ED, -ING, -S] / a young person [n CHILDS or CHILDER or CHILDREN]\n",
  "CHILDBEARING": "the process of conceiving, being pregnant with, and giving birth to children [n -S]\n",
  "CHILDBEARINGS": "CHILDBEARING, the process of conceiving, being pregnant with, and giving birth to children [n]\n",
  "CHILDBED": "the condition of a woman giving birth [n -S]\n",
  "CHILDBEDS": "CHILDBED, the condition of a woman giving birth [n]\n",
  "CHILDBIRTH": "the act of giving birth [n -S]\n",
  "CHILDBIRTHS": "CHILDBIRTH, the act of giving birth [n]\n",
  "CHILDCARE": "care of children, esp. as professionally provided [n -S]\n",
  "CHILDCARES": "CHILDCARE, care of children, esp. as professionally provided [n]\n",
  "CHILDCROWING": "a nervous affection with spasm of the muscles closing the glottis [n -S]\n",
  "CHILDCROWINGS": "CHILDCROWING, a nervous affection with spasm of the muscles closing the glottis [n]\n",
  "CHILDE": "a youth of gentle birth, esp. in ballads, also CHYLDE [n -S]\n",
  "CHILDED": "CHILD, to bring forth [v]\n",
  "CHILDER": "(dialect) children, also CHIRREN [n]\n",
  "CHILDERMAS": "a church festival held on December 28, Holy Innocents' Day [n -ES]\n",
  "CHILDERMASES": "CHILDERMAS, a church festival held on December 28, Holy Innocents' Day [n]\n",
  "CHILDES": "CHILDE, a youth of gentle birth, esp. in ballads, also CHYLDE [n]\n",
  "CHILDHOOD": "the state of being a child [n -S]\n",
  "CHILDHOODS": "CHILDHOOD, the state of being a child [n]\n",
  "CHILDING": "CHILD, to bring forth [v]\n",
  "CHILDISH": "like a child [adj CHILDISHLY]\n",
  "CHILDISHLY": "CHILDISH, like a child [adv]\n",
  "CHILDISHNESS": "the state of being childish [n -ES]\n",
  "CHILDISHNESSES": "CHILDISHNESS, the state of being childish [n]\n",
  "CHILDLESS": "having no children [adj]\n",
  "CHILDLESSNESS": "the state of being childless [n -ES]\n",
  "CHILDLESSNESSES": "CHILDLESSNESS, the state of being childless [n]\n",
  "CHILDLIER": "CHILDLY, (archaic) having the character of a child [adj]\n",
  "CHILDLIEST": "CHILDLY, (archaic) having the character of a child [adj]\n",
  "CHILDLIKE": "like a child [adj]\n",
  "CHILDLIKENESS": "CHILDLIKE, like a child [n]\n",
  "CHILDLIKENESSES": "CHILDLIKENESS, CHILDLIKE, like a child [n]\n",
  "CHILDLY": "(archaic) having the character of a child [adj CHILDLIER, CHILDLIEST]\n",
  "CHILDMINDER": "one who looks after other people's children for money [n -S]\n",
  "CHILDMINDERS": "CHILDMINDER, one who looks after other people's children for money [n]\n",
  "CHILDMINDING": "the activity or profession of looking after other people's children [n -S]\n",
  "CHILDMINDINGS": "CHILDMINDING, the activity or profession of looking after other people's children [n]\n",
  "CHILDNESS": "(Shakespeare) the manner characteristic of a child [n -ES]\n",
  "CHILDNESSES": "CHILDNESS, (Shakespeare) the manner characteristic of a child [n]\n",
  "CHILDPROOF": "to make an environment safe for a child, or safe from a child [v -ED, -ING, -S]\n",
  "CHILDPROOFED": "CHILDPROOF, to make an environment safe for a child, or safe from a child [v]\n",
  "CHILDPROOFING": "CHILDPROOF, to make an environment safe for a child, or safe from a child [v]\n",
  "CHILDPROOFS": "CHILDPROOF, to make an environment safe for a child, or safe from a child [v]\n",
  "CHILDREN": "CHILD, a young person [n]\n",
  "CHILDRENSWEAR": "clothes suitable for children [n -S]\n",
  "CHILDRENSWEARS": "CHILDRENSWEAR, clothes suitable for children [n]\n",
  "CHILDS": "CHILD, to bring forth [v]\n",
  "CHILE": "(Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., and made into a hot cayenne, also CHILI, CHILLI [n -S]\n",
  "CHILES": "CHILE, (Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., and made into a hot cayenne, also CHILI, CHILLI [n]\n",
  "CHILI": "(Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., also CHILE, CHILLI [n CHILIS or CHILIES]\n",
  "CHILIAD": "(Greek) a group of one thousand [n -S]\n",
  "CHILIADAL": "relating to a chiliad, also CHILIADIC [adj]\n",
  "CHILIADIC": "relating to a chiliad, also CHILIADAL [adj]\n",
  "CHILIADS": "CHILIAD, (Greek) a group of one thousand [n]\n",
  "CHILIAGON": "(Greek) a plane figure of a thousand angles and sides [n -S]\n",
  "CHILIAGONS": "CHILIAGON, (Greek) a plane figure of a thousand angles and sides [n]\n",
  "CHILIAHEDRA": "CHILIAHEDRON, (Greek) a one-thousand sided solid figure [n]\n",
  "CHILIAHEDRON": "(Greek) a one-thousand sided solid figure [n CHILIAHEDRA or CHILIAHEDRONS]\n",
  "CHILIAHEDRONS": "CHILIAHEDRON, (Greek) a one-thousand sided solid figure [n]\n",
  "CHILIARCH": "(Greek) the commander or chief of a thousand men [n -S]\n",
  "CHILIARCHIES": "CHILIARCHY, a body consisting of a thousand men [n]\n",
  "CHILIARCHS": "CHILIARCH, (Greek) the commander or chief of a thousand men [n]\n",
  "CHILIARCHY": "a body consisting of a thousand men [n CHILIARCHIES]\n",
  "CHILIASM": "(Greek) the doctrine that Christ will return and reign for a thousand years [n -S]\n",
  "CHILIASMS": "CHILIASM, (Greek) the doctrine that Christ will return and reign for a thousand years [n]\n",
  "CHILIAST": "one who believes in the second coming of Christ to reign on earth a thousand years [n -S]\n",
  "CHILIASTIC": "of or relating to a thousand years [adj]\n",
  "CHILIASTS": "CHILIAST, one who believes in the second coming of Christ to reign on earth a thousand years [n]\n",
  "CHILIDOG": "a hot dog topped with chili [n -S]\n",
  "CHILIDOGS": "CHILIDOG, a hot dog topped with chili [n]\n",
  "CHILIES": "CHILI, (Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., also CHILE, CHILLI [n]\n",
  "CHILIS": "CHILI, (Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., also CHILE, CHILLI [n]\n",
  "CHILL": "to make cold [v -ED, -ING, -S] / cool [adj CHILLER, CHILLEST]\n",
  "CHILLADA": "(Spanish) in Mexican cookery, a spiced fried cake made from pureed vegetables [n -S]\n",
  "CHILLADAS": "CHILLADA, (Spanish) in Mexican cookery, a spiced fried cake made from pureed vegetables [n]\n",
  "CHILLAX": "to relax completely [v -ED, -ING, -ES]\n",
  "CHILLAXED": "CHILLAX, to relax completely [v]\n",
  "CHILLAXES": "CHILLAX, to relax completely [v]\n",
  "CHILLAXING": "CHILLAX, to relax completely [v]\n",
  "CHILLED": "CHILL, to make cold [v]\n",
  "CHILLER": "a frightening film [n -S]\n",
  "CHILLERS": "CHILLER, a frightening film [n]\n",
  "CHILLEST": "CHILL, cool [adj]\n",
  "CHILLI": "(Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., also CHILE, CHILI [n CHILLIS or CHILLIES]\n",
  "CHILLIER": "CHILLY, cool [adj]\n",
  "CHILLIES": "CHILLI, (Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., also CHILE, CHILI [n]\n",
  "CHILLIEST": "CHILLY, cool [adj]\n",
  "CHILLILY": "CHILLY, cool [adv]\n",
  "CHILLINESS": "the quality of being chilly [n -ES]\n",
  "CHILLINESSES": "CHILLINESS, the quality of being chilly [n]\n",
  "CHILLING": "causing a chill [adj CHILLINGLY] / the act of making chill [n -S]\n",
  "CHILLINGLY": "CHILLING, causing a chill [adv]\n",
  "CHILLINGS": "CHILLING, the act of making chill [n]\n",
  "CHILLIS": "CHILLI, (Nahuatl) the (dried) red pod of a Capsicum pepper used in sauces, relishes, etc., also CHILE, CHILI [n]\n",
  "CHILLNESS": "coolness; a chill [n -ES]\n",
  "CHILLNESSES": "CHILLNESS, coolness; a chill [n]\n",
  "CHILLS": "CHILL, to make cold [v]\n",
  "CHILLUM": "(Hindi) the part of a hookah water-pipe containing the bowl and tobacco-balls [n -S]\n",
  "CHILLUMS": "CHILLUM, (Hindi) the part of a hookah water-pipe containing the bowl and tobacco-balls [n]\n",
  "CHILLY": "cool [adj CHILLIER, CHILLIEST, CHILLILY]\n",
  "CHILOPOD": "a member of the order Chilopoda, which contains the centipedes, also CHILOPODAN [n -S]\n",
  "CHILOPODAN": "a member of the order Chilopoda, which contains the centipedes, also CHILOPOD [n -S]\n",
  "CHILOPODANS": "CHILOPODAN, a member of the order Chilopoda, which contains the centipedes, also CHILOPOD [n]\n",
  "CHILOPODOUS": "like a chilopod [adj]\n",
  "CHILOPODS": "CHILOPOD, a member of the order Chilopoda, which contains the centipedes, also CHILOPODAN [n]\n",
  "CHILTEPIN": "a variety of chili pepper [n -S]\n",
  "CHILTEPINS": "CHILTEPIN, a variety of chili pepper [n]\n",
  "CHIMAERA": "(Greek) a mythical or genetic hybrid, also CHIMERA [n -S]\n",
  "CHIMAERAS": "CHIMAERA, (Greek) a mythical or genetic hybrid, also CHIMERA [n]\n",
  "CHIMAERIC": "of the nature of a chimaera; imaginary, fanciful, visionary, also CHIMERIC, CHIMERICAL [adj]\n",
  "CHIMAERISM": "the state of being or creating a genetic chimaera, also CHIMERISM [n -S]\n",
  "CHIMAERISMS": "CHIMAERISM, the state of being or creating a genetic chimaera, also CHIMERISM [n]\n",
  "CHIMAR": "a loose sleeveless robe worn by Anglican bishops, also CHIMER, CHIMERE [n -S]\n",
  "CHIMARS": "CHIMAR, a loose sleeveless robe worn by Anglican bishops, also CHIMER, CHIMERE [n]\n",
  "CHIMB": "the rim at the ends of a cask, formed by the ends of the staves [n -S]\n",
  "CHIMBLEY": "a chimney, also CHIMBLY, CHIMLA, CHIMLEY [n -S]\n",
  "CHIMBLEYS": "CHIMBLEY, a chimney, also CHIMBLY, CHIMLA, CHIMLEY [n]\n",
  "CHIMBLIES": "CHIMBLY, a chimney, also CHIMBLEY, CHIMLA, CHIMLEY [n]\n",
  "CHIMBLY": "a chimney, also CHIMBLEY, CHIMLA, CHIMLEY [n CHIMBLIES]\n",
  "CHIMBS": "CHIMB, the rim at the ends of a cask, formed by the ends of the staves [n]\n",
  "CHIME": "to ring in harmony [v CHIMED, CHIMING, CHIMES]\n",
  "CHIMED": "CHIME, to ring in harmony [v]\n",
  "CHIMENEA": "a freestanding fireplace for outdoor use [n -S]\n",
  "CHIMENEAS": "CHIMENEA, a freestanding fireplace for outdoor use [n]\n",
  "CHIMER": "a loose sleeveless robe worn by Anglican bishops, also CHIMAR, CHIMERE [n -S]\n",
  "CHIMERA": "(Greek) a mythical or genetic hybrid, also CHIMAERA [n -S]\n",
  "CHIMERAS": "CHIMERA, (Greek) a mythical or genetic hybrid, also CHIMAERA [n]\n",
  "CHIMERE": "(French) a loose sleeveless robe worn by Anglican bishops, also CHIMAR, CHIMER [n -S]\n",
  "CHIMERES": "CHIMERE, (French) a loose sleeveless robe worn by Anglican bishops, also CHIMAR, CHIMER [n]\n",
  "CHIMERIC": "of the nature of a chimera; imaginary, fanciful, visionary, also CHIMAERIC, CHIMERICAL [adj CHIMERICALLY]\n",
  "CHIMERICAL": "of the nature of a chimaera; imaginary, fanciful, visionary, also CHIMAERIC, CHIMERIC [adj CHIMERICALLY]\n",
  "CHIMERICALLY": "CHIMERICAL, of the nature of a chimaera; imaginary, fanciful, visionary, also CHIMAERIC, CHIMERIC [adv]\n",
  "CHIMERICALNESS": "CHIMERICAL, of the nature of a chimaera; imaginary, fanciful, visionary, also CHIMAERIC, CHIMERIC [n]\n",
  "CHIMERID": "a fish of the genus Chimaera [n -S]\n",
  "CHIMERIDS": "CHIMERID, a fish of the genus Chimaera [n]\n",
  "CHIMERISM": "the state of being or creating a genetic chimaera, also CHIMAERISM [n -S]\n",
  "CHIMERISMS": "CHIMERISM, the state of being or creating a genetic chimaera, also CHIMAERISM [n]\n",
  "CHIMERS": "CHIMER, a loose sleeveless robe worn by Anglican bishops, also CHIMAR, CHIMERE [n]\n",
  "CHIMES": "CHIME, to ring in harmony [v]\n",
  "CHIMICHANGA": "(Spanish) a tortilla wrapped round a filling, as of meat, and deep fried [n -S]\n",
  "CHIMICHANGAS": "CHIMICHANGA, (Spanish) a tortilla wrapped round a filling, as of meat, and deep fried [n]\n",
  "CHIMINEA": "a freestanding fireplace for outdoor use [n -S]\n",
  "CHIMINEAS": "CHIMINEA, a freestanding fireplace for outdoor use [n]\n",
  "CHIMING": "CHIME, to ring in harmony [v]\n",
  "CHIMLA": "a chimney, also CHIMBLEY, CHIMBLY, CHIMLEY [n -S]\n",
  "CHIMLAS": "CHIMLA, a chimney, also CHIMBLEY, CHIMBLY, CHIMLEY [n]\n",
  "CHIMLEY": "a chimney, also CHIMBLEY, CHIMBLY, CHIMLA [n -S]\n",
  "CHIMLEYS": "CHIMLEY, a chimney, also CHIMBLEY, CHIMBLY, CHIMLA [n]\n",
  "CHIMNEY": "to proceed up a rock fissure in a certain fashion [v -ED, -ING, -S]\n",
  "CHIMNEYBOARD": "a board blocking up a fireplace [n -S]\n",
  "CHIMNEYBOARDS": "CHIMNEYBOARD, a board blocking up a fireplace [n]\n",
  "CHIMNEYBREAST": "the part of a wall that projects into a room and contains the fireplace and chimney [n -S]\n",
  "CHIMNEYBREASTS": "CHIMNEYBREAST, the part of a wall that projects into a room and contains the fireplace and chimney [n]\n",
  "CHIMNEYED": "CHIMNEY, to proceed up a rock fissure in a certain fashion [v]\n",
  "CHIMNEYING": "CHIMNEY, to proceed up a rock fissure in a certain fashion [v]\n",
  "CHIMNEYLIKE": "like a chimney [adj]\n",
  "CHIMNEYPIECE": "an ornamental construction over and around a fireplace that includes the mantel [n -S]\n",
  "CHIMNEYPIECES": "CHIMNEYPIECE, an ornamental construction over and around a fireplace that includes the mantel [n]\n",
  "CHIMNEYPOT": "the pot on a chimney [n -S]\n",
  "CHIMNEYPOTS": "CHIMNEYPOT, the pot on a chimney [n]\n",
  "CHIMNEYS": "CHIMNEY, to proceed up a rock fissure in a certain fashion [v]\n",
  "CHIMO": "(Canadian) an Eskimo word used as greeting [interj]\n",
  "CHIMP": "(short for) a chimpanzee [n -S]\n",
  "CHIMPANZEE": "an anthropoid ape of equatorial Africa that is smaller and more arboreal than the gorilla [n -S]\n",
  "CHIMPANZEES": "CHIMPANZEE, an anthropoid ape of equatorial Africa that is smaller and more arboreal than the gorilla [n]\n",
  "CHIMPS": "CHIMP, (short for) a chimpanzee [n]\n",
  "CHIN": "to hold with the lower part of the face [v CHINNED, CHINNING, CHINS]\n",
  "CHINA": "fine porcelain ware [n -S]\n",
  "CHINABERRIES": "CHINABERRY, a small Asian tree of the mahogany family [n]\n",
  "CHINABERRY": "a small Asian tree of the mahogany family [n CHINABERRIES]\n",
  "CHINACHINA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CINCHONA, KINA, KINAKINA, QUINA, QUINAQUINA, QUINQUINA [n -S]\n",
  "CHINACHINAS": "CHINACHINA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CINCHONA, KINA, KINAKINA, QUINA, QUINAQUINA, QUINQUINA [n]\n",
  "CHINAMAN": "a tricky ball bowled by a left handed bowler [n CHINAMEN]\n",
  "CHINAMEN": "CHINAMAN, a tricky ball bowled by a left handed bowler [n]\n",
  "CHINAMPA": "(Nahuatl) a floating garden of earth piled on rafts of twigs [n -S]\n",
  "CHINAMPAS": "CHINAMPA, (Nahuatl) a floating garden of earth piled on rafts of twigs [n]\n",
  "CHINAR": "(Persian) the oriental plane tree, also CHENAR [n -S]\n",
  "CHINAROOT": "the rootstock of Smilax china [n -S]\n",
  "CHINAROOTS": "CHINAROOT, the rootstock of Smilax china [n]\n",
  "CHINARS": "CHINAR, (Persian) the oriental plane tree, also CHENAR [n]\n",
  "CHINAS": "CHINA, fine porcelain ware [n]\n",
  "CHINAWARE": "goods made from china [n -S]\n",
  "CHINAWARES": "CHINAWARE, goods made from china [n]\n",
  "CHINBONE": "the lower jaw [n -S]\n",
  "CHINBONES": "CHINBONE, the lower jaw [n]\n",
  "CHINCAPIN": "(Native American) the dwarf chestnut of the US, also CHINKAPIN, CHINQUAPIN [n -S]\n",
  "CHINCAPINS": "CHINCAPIN, (Native American) the dwarf chestnut of the US, also CHINKAPIN, CHINQUAPIN [n]\n",
  "CHINCH": "to fill in the seams of a boat [v -ED, -ING, -ES]\n",
  "CHINCHED": "CHINCH, to fill in the seams of a boat [v]\n",
  "CHINCHERINCHEE": "a kind of African flower, also CHINKERINCHEE [n -S]\n",
  "CHINCHERINCHEES": "CHINCHERINCHEE, a kind of African flower, also CHINKERINCHEE [n]\n",
  "CHINCHES": "CHINCH, to fill in the seams of a boat [v]\n",
  "CHINCHIER": "CHINCHY, stingy [adj]\n",
  "CHINCHIEST": "CHINCHY, stingy [adj]\n",
  "CHINCHILLA": "(Quechua) a South American rodent of the genus Chinchilla, with very soft grey fur [n -S]\n",
  "CHINCHILLAS": "CHINCHILLA, (Quechua) a South American rodent of the genus Chinchilla, with very soft grey fur [n]\n",
  "CHINCHING": "CHINCH, to fill in the seams of a boat [v]\n",
  "CHINCHY": "stingy [adj CHINCHIER, CHINCHIEST]\n",
  "CHINCOUGH": "whooping cough [n -S]\n",
  "CHINCOUGHS": "CHINCOUGH, whooping cough [n]\n",
  "CHINDIT": "(Burmese) an Allied fighter behind the Japanese lines in Burma [n -S]\n",
  "CHINDITS": "CHINDIT, (Burmese) an Allied fighter behind the Japanese lines in Burma [n]\n",
  "CHINE": "to break the back of [v CHINED or (Spenser) CHYND, CHINING, CHINES]\n",
  "CHINED": "CHINE, to break the back of [v]\n",
  "CHINES": "CHINE, to break the back of [v]\n",
  "CHINESE": "(colloquial) a Chinese meal [n]\n",
  "CHING": "a high-pitched ringing sound [n -S]\n",
  "CHINGS": "CHING, a high-pitched ringing sound [n]\n",
  "CHINING": "CHINE, to break the back of [v]\n",
  "CHINK": "to fill up cracks [v -ED, -ING, -S]\n",
  "CHINKAPIN": "(Native American) the dwarf chestnut of the US, also CHINCAPIN, CHINQUAPIN [n -S]\n",
  "CHINKAPINS": "CHINKAPIN, (Native American) the dwarf chestnut of the US, also CHINCAPIN, CHINQUAPIN [n]\n",
  "CHINKARA": "(Hindi) a four-horned Indian antelope, also CHIKARA [n -S]\n",
  "CHINKARAS": "CHINKARA, (Hindi) a four-horned Indian antelope, also CHIKARA [n]\n",
  "CHINKED": "CHINK, to fill up cracks [v]\n",
  "CHINKERINCHEE": "a kind of African flower, also CHINCHERINCHEE [n -S]\n",
  "CHINKERINCHEES": "CHINKERINCHEE, a kind of African flower, also CHINCHERINCHEE [n]\n",
  "CHINKIE": "(colloquial) a meal of Chinese food [n -S]\n",
  "CHINKIER": "CHINKY, full of cracks [adj]\n",
  "CHINKIES": "CHINKIE, (colloquial) a meal of Chinese food [n]\n",
  "CHINKIEST": "CHINKY, full of cracks [adj]\n",
  "CHINKING": "CHINK, to fill up cracks [v]\n",
  "CHINKS": "CHINK, to fill up cracks [v]\n",
  "CHINKY": "full of cracks [adj CHINKIER, CHINKIEST]\n",
  "CHINLESS": "without a chin [adj]\n",
  "CHINNED": "CHIN, to hold with the lower part of the face [v]\n",
  "CHINNING": "CHIN, to hold with the lower part of the face [v]\n",
  "CHINO": "(Spanish) a strong twilled cotton cloth, usually khaki-coloured [n -S]\n",
  "CHINOIS": "(French) a cone-shaped sieve [n -ES]\n",
  "CHINOISERIE": "(French) decoration, furniture etc. imitating Chinese design [n -S]\n",
  "CHINOISERIES": "CHINOISERIE, (French) decoration, furniture etc. imitating Chinese design [n]\n",
  "CHINOISES": "CHINOIS, (French) a cone-shaped sieve [n]\n",
  "CHINONE": "a golden-yellow crystalline compound usually prepared by oxidizing aniline, also KINONE, QUINONE [n -S]\n",
  "CHINONES": "CHINONE, a golden-yellow crystalline compound usually prepared by oxidizing aniline, also KINONE, QUINONE [n]\n",
  "CHINOOK": "(Native American) a warm dry wind that descends the eastern slopes of the Rocky Mountains [n -S]\n",
  "CHINOOKS": "CHINOOK, (Native American) a warm dry wind that descends the eastern slopes of the Rocky Mountains [n]\n",
  "CHINOS": "CHINO, (Spanish) a strong twilled cotton cloth, usually khaki-coloured [n]\n",
  "CHINOVNIK": "(Russian) a high official in the Russian civil service [n -S]\n",
  "CHINOVNIKS": "CHINOVNIK, (Russian) a high official in the Russian civil service [n]\n",
  "CHINQUAPIN": "(Native American) the dwarf chestnut of the US, also CHINCAPIN, CHINKAPIN [n -S]\n",
  "CHINQUAPINS": "CHINQUAPIN, (Native American) the dwarf chestnut of the US, also CHINCAPIN, CHINKAPIN [n]\n",
  "CHINS": "CHIN, to hold with the lower part of the face [v]\n",
  "CHINSE": "to fill in the seams of a boat, also CHINCH [v CHINSED, CHINSING, CHINSES]\n",
  "CHINSED": "CHINSE, to fill in the seams of a boat, also CHINCH [v]\n",
  "CHINSES": "CHINSE, to fill in the seams of a boat, also CHINCH [v]\n",
  "CHINSING": "CHINSE, to fill in the seams of a boat, also CHINCH [v]\n",
  "CHINSTRAP": "the strap on a helmet, that goes under the chin [n -S]\n",
  "CHINSTRAPS": "CHINSTRAP, the strap on a helmet, that goes under the chin [n]\n",
  "CHINTS": "a glazed printed cotton fabric, also CHINTZ [n -ES]\n",
  "CHINTSES": "CHINTS, a glazed printed cotton fabric, also CHINTZ [n]\n",
  "CHINTZ": "a glazed printed cotton fabric, also CHINTS [n -ES]\n",
  "CHINTZES": "CHINTZ, a glazed printed cotton fabric, also CHINTS [n]\n",
  "CHINTZIER": "CHINTZY, like chintz; cheap, gaudy [adj]\n",
  "CHINTZIEST": "CHINTZY, like chintz; cheap, gaudy [adj]\n",
  "CHINTZILY": "CHINTZY, like chintz; cheap, gaudy [adv]\n",
  "CHINTZY": "like chintz; cheap, gaudy [adj CHINTZIER, CHINTZIEST; CHINTZILY]\n",
  "CHINWAG": "to chat [v CHINWAGGED, CHINWAGGING, CHINWAGS]\n",
  "CHINWAGGED": "CHINWAG, to chat [v]\n",
  "CHINWAGGING": "CHINWAG, to chat [v]\n",
  "CHINWAGS": "CHINWAG, to chat [v]\n",
  "CHIONODOXA": "a liliaceous plant, glory-of-the-snow [n -S]\n",
  "CHIONODOXAS": "CHIONODOXA, a liliaceous plant, glory-of-the-snow [n]\n",
  "CHIP": "to break a small piece from [v CHIPPED, CHIPPING, CHIPS]\n",
  "CHIPBOARD": "reconstructed wood made from compressed chippings [n -S]\n",
  "CHIPBOARDS": "CHIPBOARD, reconstructed wood made from compressed chippings [n]\n",
  "CHIPMAKER": "a manufacturer of microchips [n -S]\n",
  "CHIPMAKERS": "CHIPMAKER, a manufacturer of microchips [n]\n",
  "CHIPMUCK": "a small rodent, also CHIPMUNK [n -S]\n",
  "CHIPMUCKS": "CHIPMUCK, a small rodent, also CHIPMUNK [n]\n",
  "CHIPMUNK": "a small rodent, also CHIPMUCK [n -S]\n",
  "CHIPMUNKS": "CHIPMUNK, a small rodent, also CHIPMUCK [n]\n",
  "CHIPOCHIA": "(Shakespeare) a simpleton, also CAPOCCHIA [n -S]\n",
  "CHIPOCHIAS": "CHIPOCHIA, (Shakespeare) a simpleton, also CAPOCCHIA [n]\n",
  "CHIPOLATA": "a small, often spicy sausage [n -S]\n",
  "CHIPOLATAS": "CHIPOLATA, a small, often spicy sausage [n]\n",
  "CHIPOTLE": "(Spanish) a smoked and dried jalapeno pepper [n -S]\n",
  "CHIPOTLES": "CHIPOTLE, (Spanish) a smoked and dried jalapeno pepper [n]\n",
  "CHIPPABLE": "capable of being chipped [adj]\n",
  "CHIPPED": "CHIP, to break a small piece from [v]\n",
  "CHIPPER": "cheerful [adj CHIPPERER, CHIPPEREST] / to twitter, chatter [v -ED, -ING, -S]\n",
  "CHIPPERED": "CHIPPER, to twitter, chatter [v]\n",
  "CHIPPERER": "CHIPPER, cheerful [adj]\n",
  "CHIPPEREST": "CHIPPER, cheerful [adj]\n",
  "CHIPPERING": "CHIPPER, to twitter, chatter [v]\n",
  "CHIPPERS": "CHIPPER, to twitter, chatter [v]\n",
  "CHIPPIE": "(colloquial) a carpenter [n -S]\n",
  "CHIPPIER": "CHIPPY, belligerent [adj]\n",
  "CHIPPIES": "CHIPPIE, (colloquial) a carpenter [n]\n",
  "CHIPPIEST": "CHIPPY, belligerent [adj]\n",
  "CHIPPINESS": "the state of being chippy, irritable [n -ES]\n",
  "CHIPPINESSES": "CHIPPINESS, the state of being chippy, irritable [n]\n",
  "CHIPPING": "a small piece of wood, stone etc. pared off [n -S]\n",
  "CHIPPINGS": "CHIPPING, a small piece of wood, stone etc. pared off [n]\n",
  "CHIPPY": "belligerent [adj CHIPPIER, CHIPPIEST] / a carpenter [n CHIPPIES]\n",
  "CHIPS": "CHIP, to break a small piece from [v]\n",
  "CHIPSET": "a functional group of computer microchips [n -S]\n",
  "CHIPSETS": "CHIPSET, a functional group of computer microchips [n]\n",
  "CHIQUICHIQUI": "(Tupi) a piassava palm tree of South America [n -S]\n",
  "CHIQUICHIQUIS": "CHIQUICHIQUI, (Tupi) a piassava palm tree of South America [n]\n",
  "CHIRAGRA": "(Greek) gout in the hand [n -S]\n",
  "CHIRAGRAS": "CHIRAGRA, (Greek) gout in the hand [n]\n",
  "CHIRAGRIC": "relating to chiragra, gout in the hand, also CHIRAGRICAL [adj]\n",
  "CHIRAGRICAL": "relating to chiragra, gout in the hand, also CHIRAGRIC [adj]\n",
  "CHIRAL": "of a molecule, having an asymmetry which gives it a handedness property [adj]\n",
  "CHIRALITIES": "CHIRALITY, the chemical property of structural handedness [n]\n",
  "CHIRALITY": "the chemical property of structural handedness [n CHIRALITIES]\n",
  "CHIRIMOYA": "(Quechua) a Peruvian fruit resembling the custard apple, also CHERIMOYA, CHERIMOYER [n -S]\n",
  "CHIRIMOYAS": "CHIRIMOYA, (Quechua) a Peruvian fruit resembling the custard apple, also CHERIMOYA, CHERIMOYER [n]\n",
  "CHIRK": "(Scots) to squeak [v -ED, -ING, -S] / cheerful [adj CHIRKER, CHIRKEST]\n",
  "CHIRKED": "CHIRK, (Scots) to squeak [v]\n",
  "CHIRKER": "CHIRK, cheerful [adj]\n",
  "CHIRKEST": "CHIRK, cheerful [adj]\n",
  "CHIRKING": "CHIRK, (Scots) to squeak [v]\n",
  "CHIRKS": "CHIRK, (Scots) to squeak [v]\n",
  "CHIRL": "(Scots) to emit a low sound, to warble [v -ED, -ING, -S]\n",
  "CHIRLED": "CHIRL, (Scots) to emit a low sound, to warble [v]\n",
  "CHIRLING": "CHIRL, (Scots) to emit a low sound, to warble [v]\n",
  "CHIRLS": "CHIRL, (Scots) to emit a low sound, to warble [v]\n",
  "CHIRM": "to cry out, chirp [v -ED, -ING, -S]\n",
  "CHIRMED": "CHIRM, to cry out, chirp [v]\n",
  "CHIRMING": "CHIRM, to cry out, chirp [v]\n",
  "CHIRMS": "CHIRM, to cry out, chirp [v]\n",
  "CHIRO": "(short for) chiropractor [n -S]\n",
  "CHIROGNOMIES": "CHIROGNOMY, palmistry [n]\n",
  "CHIROGNOMIST": "someone who studies chirognomy [n -S]\n",
  "CHIROGNOMISTS": "CHIROGNOMIST, someone who studies chirognomy [n]\n",
  "CHIROGNOMY": "palmistry [n CHIROGNOMIES]\n",
  "CHIROGRAPH": "a written or signed document [n -S]\n",
  "CHIROGRAPHER": "(obsolete) an official of the Court of Common Pleas [n -S]\n",
  "CHIROGRAPHERS": "CHIROGRAPHER, (obsolete) an official of the Court of Common Pleas [n]\n",
  "CHIROGRAPHIC": "relating to handwriting, also CHIROGRAPHICAL [adj]\n",
  "CHIROGRAPHICAL": "relating to handwriting, also CHIROGRAPHIC [adj]\n",
  "CHIROGRAPHIES": "CHIROGRAPHY, the study of handwriting or penmanship [n]\n",
  "CHIROGRAPHIST": "an expert in handwriting [n -S]\n",
  "CHIROGRAPHISTS": "CHIROGRAPHIST, an expert in handwriting [n]\n",
  "CHIROGRAPHS": "CHIROGRAPH, a written or signed document [n]\n",
  "CHIROGRAPHY": "the study of handwriting or penmanship [n CHIROGRAPHIES]\n",
  "CHIROLOGIES": "CHIROLOGY, the language of gesture; the study of the hands [n]\n",
  "CHIROLOGIST": "one who claims to be able to detect character from handwriting [n -S]\n",
  "CHIROLOGISTS": "CHIROLOGIST, one who claims to be able to detect character from handwriting [n]\n",
  "CHIROLOGY": "the language of gesture; the study of the hands [n CHIROLOGIES]\n",
  "CHIROMANCER": "a palm-reader, also CHEIROMANCER [n -S]\n",
  "CHIROMANCERS": "CHIROMANCER, a palm-reader, also CHEIROMANCER [n]\n",
  "CHIROMANCIES": "CHIROMANCY, divination by means of palmistry, also CHEIROMANCY [n]\n",
  "CHIROMANCY": "divination by means of palmistry, also CHEIROMANCY [n CHIROMANCIES]\n",
  "CHIROMANTIC": "relating to chiromancy, also CHIROMANTICAL [adj]\n",
  "CHIROMANTICAL": "relating to chiromancy, also CHIROMANTIC [adj]\n",
  "CHIRONOMER": "a gesticulator [n -S]\n",
  "CHIRONOMERS": "CHIRONOMER, a gesticulator [n]\n",
  "CHIRONOMIC": "relating to gesticulation [adj]\n",
  "CHIRONOMID": "a member of a large genus of common midges [n -S]\n",
  "CHIRONOMIDS": "CHIRONOMID, a member of a large genus of common midges [n]\n",
  "CHIRONOMIES": "CHIRONOMY, the art of gesticulation or mime [n]\n",
  "CHIRONOMY": "the art of gesticulation or mime [n CHIRONOMIES]\n",
  "CHIROPODIAL": "relating to chiropody [adj]\n",
  "CHIROPODIES": "CHIROPODY, the treatment of ailments of the feet [n]\n",
  "CHIROPODIST": "one who treats ailments of the feet [n -S]\n",
  "CHIROPODISTS": "CHIROPODIST, one who treats ailments of the feet [n]\n",
  "CHIROPODY": "the treatment of ailments of the feet [n CHIROPODIES]\n",
  "CHIROPRACTIC": "the diagnosis and manipulative treatment of mechanical disorders of the joints, esp. of the spine [n -S]\n",
  "CHIROPRACTICS": "CHIROPRACTIC, the diagnosis and manipulative treatment of mechanical disorders of the joints, esp. of the spine [n]\n",
  "CHIROPRACTOR": "a person who practises chiropractic [n -S]\n",
  "CHIROPRACTORS": "CHIROPRACTOR, a person who practises chiropractic [n]\n",
  "CHIROPTER": "a type of bat [n -S]\n",
  "CHIROPTERAN": "a member of the Chiroptera, an order of mammals comprising the bats [n -S]\n",
  "CHIROPTERANS": "CHIROPTERAN, a member of the Chiroptera, an order of mammals comprising the bats [n]\n",
  "CHIROPTEROUS": "relating to the Chiroptera, bats [adj]\n",
  "CHIROPTERS": "CHIROPTER, a type of bat [n]\n",
  "CHIROS": "CHIRO, (short for) chiropractor [n]\n",
  "CHIRP": "to utter a short, shrill sound [v -ED, -ING, -S]\n",
  "CHIRPED": "CHIRP, to utter a short, shrill sound [v]\n",
  "CHIRPER": "a little bird [n -S]\n",
  "CHIRPERS": "CHIRPER, a little bird [n]\n",
  "CHIRPIER": "CHIRPY, cheerful [adj]\n",
  "CHIRPIEST": "CHIRPY, cheerful [adj]\n",
  "CHIRPILY": "CHIRPY, cheerful [adv]\n",
  "CHIRPINESS": "the state of being chirpy [n -ES]\n",
  "CHIRPINESSES": "CHIRPINESS, the state of being chirpy [n]\n",
  "CHIRPING": "a sound made by birds [n -S]\n",
  "CHIRPINGS": "CHIRPING, a sound made by birds [n]\n",
  "CHIRPS": "CHIRP, to utter a short, shrill sound [v]\n",
  "CHIRPY": "cheerful [adj CHIRPIER, CHIRPIEST, CHIRPILY]\n",
  "CHIRR": "to chirp like a cricket, also CHIRRE [v -ED, -ING, -S]\n",
  "CHIRRE": "to chirp like a cricket, also CHIRR [v CHIRRED, CHIRRING, CHIRRES]\n",
  "CHIRRED": "CHIRRE, to chirp like a cricket, also CHIRR [v]\n",
  "CHIRREN": "(Southern US dialect) children [n]\n",
  "CHIRRES": "CHIRRE, to chirp like a cricket, also CHIRR [v]\n",
  "CHIRRING": "CHIRRE, to chirp like a cricket, also CHIRR [v]\n",
  "CHIRRS": "CHIRR, to chirp like a cricket, also CHIRRE [v]\n",
  "CHIRRUP": "to chirp repeatedly [v -ED, -ING, -S]\n",
  "CHIRRUPED": "CHIRRUP, to chirp repeatedly [v]\n",
  "CHIRRUPER": "one who chirrups [n -S]\n",
  "CHIRRUPERS": "CHIRRUPER, one who chirrups [n]\n",
  "CHIRRUPIER": "CHIRRUPY, cheerful [adj]\n",
  "CHIRRUPIEST": "CHIRRUPY, cheerful [adj]\n",
  "CHIRRUPING": "CHIRRUP, to chirp repeatedly [v]\n",
  "CHIRRUPS": "CHIRRUP, to chirp repeatedly [v]\n",
  "CHIRRUPY": "cheerful [adj CHIRRUPIER, CHIRRUPIEST]\n",
  "CHIRT": "to squeeze, squirt [v -ED, -ING, -S]\n",
  "CHIRTED": "CHIRT, to squeeze, squirt [v]\n",
  "CHIRTING": "CHIRT, to squeeze, squirt [v]\n",
  "CHIRTS": "CHIRT, to squeeze, squirt [v]\n",
  "CHIRU": "(Tibetan) a Tibetan antelope, having a dense woolly pinkish-brown fleece [n -S]\n",
  "CHIRURGEON": "a surgeon [n -S]\n",
  "CHIRURGEONLY": "(obsolete) in the manner becoming a chirurgeon, a surgeon [adj]\n",
  "CHIRURGEONS": "CHIRURGEON, a surgeon [n]\n",
  "CHIRURGERIES": "CHIRURGERY, surgery [n]\n",
  "CHIRURGERY": "surgery [n CHIRURGERIES]\n",
  "CHIRURGICAL": "relating to chirurgery, surgery [adj]\n",
  "CHIRUS": "CHIRU, (Tibetan) a Tibetan antelope, having a dense woolly pinkish-brown fleece [n]\n",
  "CHIS": "CHI, the twenty-second letter of the Greek alphabet, also KHI [n]\n",
  "CHISEL": "to use a cutting tool [v CHISELED or CHISELLED, CHISELING or CHISELLING, CHISELS]\n",
  "CHISELED": "CHISEL, to use a cutting tool [v]\n",
  "CHISELER": "one who chisels; a swindler, also CHISELLER [n -S]\n",
  "CHISELERS": "CHISELER, one who chisels; a swindler, also CHISELLER [n]\n",
  "CHISELING": "CHISEL, to use a cutting tool [v]\n",
  "CHISELLED": "CHISEL, to use a cutting tool [v]\n",
  "CHISELLER": "one who chisels; a swindler, also CHISELER [n -S]\n",
  "CHISELLERS": "CHISELLER, one who chisels; a swindler, also CHISELER [n]\n",
  "CHISELLING": "the act of shaping with a chisel [n -S]\n",
  "CHISELLINGS": "CHISELLING, the act of shaping with a chisel [n]\n",
  "CHISELS": "CHISEL, to use a cutting tool [v]\n",
  "CHIT": "(dialect) to sprout [v CHITTED, CHITTING, CHITS]\n",
  "CHITAL": "(Hindi) a kind of Indian deer, aka axis deer [n -S]\n",
  "CHITALS": "CHITAL, (Hindi) a kind of Indian deer, aka axis deer [n]\n",
  "CHITARRONE": "(Italian) a large lute-like instrument with a long neck, aka theorbo [n CHITARRONI]\n",
  "CHITARRONI": "CHITARRONE, (Italian) a large lute-like instrument with a long neck, aka theorbo [n]\n",
  "CHITCHAT": "to indulge in small talk [v CHITCHATTED, CHITCHATTING, CHITCHATS]\n",
  "CHITCHATS": "CHITCHAT, to indulge in small talk [v]\n",
  "CHITCHATTED": "CHITCHAT, to indulge in small talk [v]\n",
  "CHITCHATTING": "CHITCHAT, to indulge in small talk [v]\n",
  "CHITIN": "the main component of insect shells [n -S]\n",
  "CHITINOID": "of or like chitin, also CHITINOUS [adj]\n",
  "CHITINOUS": "of or like chitin, also CHITINOID [adj]\n",
  "CHITINS": "CHITIN, the main component of insect shells [n]\n",
  "CHITLIN": "part of the small intestine of swine, also CHITLING, CHITTERLING [n -S]\n",
  "CHITLING": "part of the small intestine of swine, also CHITLIN, CHITTERLING [n -S]\n",
  "CHITLINGS": "CHITLING, part of the small intestine of swine, also CHITLIN, CHITTERLING [n]\n",
  "CHITLINS": "CHITLIN, part of the small intestine of swine, also CHITLING, CHITTERLING [n]\n",
  "CHITON": "(Greek) a tunic worn in ancient Greece [n -S]\n",
  "CHITONS": "CHITON, (Greek) a tunic worn in ancient Greece [n]\n",
  "CHITOSAN": "a compound derived from chitin [n -S]\n",
  "CHITOSANS": "CHITOSAN, a compound derived from chitin [n]\n",
  "CHITS": "CHIT, (dialect) to sprout [v]\n",
  "CHITTAGONG": "an Indian variety of domestic fowl [n -S]\n",
  "CHITTAGONGS": "CHITTAGONG, an Indian variety of domestic fowl [n]\n",
  "CHITTED": "CHIT, (dialect) to sprout [v]\n",
  "CHITTER": "to shiver or (of the teeth) to chatter [v -ED, -ING, -S]\n",
  "CHITTERED": "CHITTER, to shiver or (of the teeth) to chatter [v]\n",
  "CHITTERING": "the act of chittering [n -S]\n",
  "CHITTERINGS": "CHITTERING, the act of chittering [n]\n",
  "CHITTERLING": "part of the small intestine of swine, also CHITLIN, CHITLING [n -S]\n",
  "CHITTERLINGS": "CHITTERLING, part of the small intestine of swine, also CHITLIN, CHITLING [n]\n",
  "CHITTERS": "CHITTER, to shiver or (of the teeth) to chatter [v]\n",
  "CHITTIER": "CHITTY, of a face, pinched, babylike [adj]\n",
  "CHITTIES": "CHITTY, a short letter [n]\n",
  "CHITTIEST": "CHITTY, of a face, pinched, babylike [adj]\n",
  "CHITTING": "CHIT, (dialect) to sprout [v]\n",
  "CHITTY": "a short letter [n CHITTIES] / of a face, pinched, babylike [adj CHITTIER, CHITTIEST]\n",
  "CHIV": "to cur with a kind of knife, also CHIVE, SHIV [v CHIVVED, CHIVVING, CHIVS]\n",
  "CHIVALRESQUE": "relating to or connected with chivalry [adj]\n",
  "CHIVALRIC": "relating to chivalry, knightly behavior and skill [adj]\n",
  "CHIVALRIES": "CHIVALRY, knightly behaviour, bravery and courtesy [n]\n",
  "CHIVALROUS": "gentlemanly, valiant [adj CHIVALROUSLY]\n",
  "CHIVALROUSLY": "CHIVALROUS, gentlemanly, valiant [adv]\n",
  "CHIVALROUSNESS": "CHIVALROUS, gentlemanly, valiant [n]\n",
  "CHIVALRY": "knightly behaviour, bravery and courtesy [n CHIVALRIES]\n",
  "CHIVAREE": "to perform a mock serenade, also CHIVARI, SHIVAREE [v CHIVAREED, CHIVAREEING, CHIVAREES]\n",
  "CHIVAREED": "CHIVAREE, to perform a mock serenade, also CHIVARI, SHIVAREE [v]\n",
  "CHIVAREEING": "CHIVAREE, to perform a mock serenade, also CHIVARI, SHIVAREE [v]\n",
  "CHIVAREES": "CHIVAREE, to perform a mock serenade, also CHIVARI, SHIVAREE [v]\n",
  "CHIVARI": "to perform a mock serenade, also CHIVAREE, SHIVAREE [v CHIVARIED, CHIVARIING, CHIVARIES]\n",
  "CHIVARIED": "CHIVARI, to perform a mock serenade, also CHIVAREE, SHIVAREE [v]\n",
  "CHIVARIES": "CHIVARI, to perform a mock serenade, also CHIVAREE, SHIVAREE [v]\n",
  "CHIVARIING": "CHIVARI, to perform a mock serenade, also CHIVAREE, SHIVAREE [v]\n",
  "CHIVE": "to cut with a kind of knife, also CHIV, SHIV [v CHIVED, CHIVING, CHIVES]\n",
  "CHIVED": "CHIVE, to cut with a kind of knife, also CHIV, SHIV [v]\n",
  "CHIVES": "CHIVE, to cut with a kind of knife, also CHIV, SHIV [v]\n",
  "CHIVIED": "CHIVY, to chase about, also CHEVY, CHIVVY [v]\n",
  "CHIVIES": "CHIVY, to chase about, also CHEVY, CHIVVY [v]\n",
  "CHIVING": "CHIVE, to cut with a kind of knife, also CHIV, SHIV [v]\n",
  "CHIVS": "CHIV, to cur with a kind of knife, also CHIVE, SHIV [v]\n",
  "CHIVVED": "CHIV, to cur with a kind of knife, also CHIVE, SHIV [v]\n",
  "CHIVVIED": "CHIVVY, to chase about, also CHEVY, CHIVY [v]\n",
  "CHIVVIES": "CHIVVY, to chase about, also CHEVY, CHIVY [v]\n",
  "CHIVVING": "CHIV, to cur with a kind of knife, also CHIVE, SHIV [v]\n",
  "CHIVVY": "to chase about, also CHEVY, CHIVY [v CHIVVIED, CHIVVYING, CHIVVIES]\n",
  "CHIVVYING": "CHIVVY, to chase about, also CHEVY, CHIVY [v]\n",
  "CHIVY": "to chase about, also CHEVY, CHIVVY [v CHIVIED, CHIVYING, CHIVIES]\n",
  "CHIVYING": "CHIVY, to chase about, also CHEVY, CHIVVY [v]\n",
  "CHIWEENIE": "a cross between a chihuahua and a dachshund [n -S]\n",
  "CHIWEENIES": "CHIWEENIE, a cross between a chihuahua and a dachshund [n]\n",
  "CHIYOGAMI": "(Japanese) a kind of hand-printed patterned paper [n -S]\n",
  "CHIYOGAMIS": "CHIYOGAMI, (Japanese) a kind of hand-printed patterned paper [n]\n",
  "CHIZ": "to swindle, also CHIZZ [v CHIZZED, CHIZZING, CHIZZES]\n",
  "CHIZZ": "to swindle, also CHIZ [v CHIZZED, CHIZZING, CHIZZES]\n",
  "CHIZZED": "CHIZZ, to swindle, also CHIZ [v]\n",
  "CHIZZES": "CHIZZ, to swindle, also CHIZ [v]\n",
  "CHIZZING": "CHIZZ, to swindle, also CHIZ [v]\n",
  "CHLAMYDATE": "of molluscs, having a mantle [adj]\n",
  "CHLAMYDEOUS": "having a perianth [adj]\n",
  "CHLAMYDES": "CHLAMYS, (Greek) a horseman's loose cloak [n]\n",
  "CHLAMYDIA": "any microorganisms of the genus Chlamydia, resembling bacteria and viruses [n CHLAMYDIAE or CHLAMYDIAS]\n",
  "CHLAMYDIAE": "CHLAMYDIA, any microorganisms of the genus Chlamydia, resembling bacteria and viruses [n]\n",
  "CHLAMYDIAL": "relating to chlamydia, any microorganisms of the genus Chlamydia, resembling bacteria and viruses [adj]\n",
  "CHLAMYDIAS": "CHLAMYDIA, any microorganisms of the genus Chlamydia, resembling bacteria and viruses [n]\n",
  "CHLAMYDOMONADES": "CHLAMYDOMONAS, a member of the genus Chlamydomonas of (mainly freshwater) green algae [n]\n",
  "CHLAMYDOMONAS": "a member of the genus Chlamydomonas of (mainly freshwater) green algae [n CHLAMYDOMONADES]\n",
  "CHLAMYDOSPORE": "a thick-walled usually resting fungal spore [n -S]\n",
  "CHLAMYDOSPORES": "CHLAMYDOSPORE, a thick-walled usually resting fungal spore [n]\n",
  "CHLAMYS": "(Greek) a horseman's loose cloak [n CHLAMYSES or CHLAMYDES]\n",
  "CHLAMYSES": "CHLAMYS, (Greek) a horseman's loose cloak [n]\n",
  "CHLOANTHITE": "a nickel-rich variety of skutterudite, aka white nickel [n -S]\n",
  "CHLOANTHITES": "CHLOANTHITE, a nickel-rich variety of skutterudite, aka white nickel [n]\n",
  "CHLOASMA": "(Greek) a skin discoloration [n CHLOASMAS or CHLOASMATA]\n",
  "CHLOASMAS": "CHLOASMA, (Greek) a skin discoloration [n]\n",
  "CHLOASMATA": "CHLOASMA, (Greek) a skin discoloration [n]\n",
  "CHLORACETIC": "an acid made by chlorinating acetic acid, also CHLOROACETIC [adj]\n",
  "CHLORACNE": "a type of disfiguring skin disease, caused by contact with chlorinated hydrocarbon [n -S]\n",
  "CHLORACNES": "CHLORACNE, a type of disfiguring skin disease, caused by contact with chlorinated hydrocarbon [n]\n",
  "CHLORAL": "a white crystalline substance used as a hypnotic and sedative [n -S]\n",
  "CHLORALISM": "a morbid condition of the system resulting from excessive use of chloral [n -S]\n",
  "CHLORALISMS": "CHLORALISM, a morbid condition of the system resulting from excessive use of chloral [n]\n",
  "CHLORALOSE": "a hypnotic drug used for anaesthetising animals in laboratory experiments [n -S]\n",
  "CHLORALOSED": "anaesthetised with chloralose [adj]\n",
  "CHLORALOSES": "CHLORALOSE, a hypnotic drug used for anaesthetising animals in laboratory experiments [n]\n",
  "CHLORALS": "CHLORAL, a white crystalline substance used as a hypnotic and sedative [n]\n",
  "CHLORAMBUCIL": "an oral drug used to treat some cancers, e.g. cancer of the ovary and leukaemia [n -S]\n",
  "CHLORAMBUCILS": "CHLORAMBUCIL, an oral drug used to treat some cancers, e.g. cancer of the ovary and leukaemia [n]\n",
  "CHLORAMINE": "any of various compounds containing nitrogen and chlorine [n -S]\n",
  "CHLORAMINES": "CHLORAMINE, any of various compounds containing nitrogen and chlorine [n]\n",
  "CHLORAMPHENICOL": "an antibiotic drug originally isolated from a soil microorganism, effective against various bacterial and viral diseases [n]\n",
  "CHLORARGYRITE": "horn silver, also CHLOROARGYRITE [n -S]\n",
  "CHLORARGYRITES": "CHLORARGYRITE, horn silver, also CHLOROARGYRITE [n]\n",
  "CHLORATE": "a chlorine compound [n -S]\n",
  "CHLORATES": "CHLORATE, a chlorine compound [n]\n",
  "CHLORDAN": "a toxic compound of chlorine, used as an insecticide [n -S]\n",
  "CHLORDANE": "a highly poisonous liquid insecticide, also CHLORDAN [n -S]\n",
  "CHLORDANES": "CHLORDANE, a highly poisonous liquid insecticide, also CHLORDAN [n]\n",
  "CHLORDANS": "CHLORDAN, a toxic compound of chlorine, used as an insecticide [n]\n",
  "CHLORELLA": "a member of the genus Chlorella of green freshwater algae [n -S]\n",
  "CHLORELLAS": "CHLORELLA, a member of the genus Chlorella of green freshwater algae [n]\n",
  "CHLORENCHYMA": "plant stem tissue containing chlorophyll [n -S]\n",
  "CHLORENCHYMAS": "CHLORENCHYMA, plant stem tissue containing chlorophyll [n]\n",
  "CHLORHEXIDINE": "an antiseptic compound used in skin cleansers, mouthwashes, etc. [n -S]\n",
  "CHLORHEXIDINES": "CHLORHEXIDINE, an antiseptic compound used in skin cleansers, mouthwashes, etc. [n]\n",
  "CHLORIC": "of, containing or derived from chlorine [adj]\n",
  "CHLORID": "a compound of chlorine with another element or radical, also CHLORIDE [n -S]\n",
  "CHLORIDATE": "to treat or prepare with a chloride, as a plate with chloride of silver, for the purposes of photography [v CHLORIDATED, CHLORIDATING, CHLORIDATES]\n",
  "CHLORIDATED": "CHLORIDATE, to treat or prepare with a chloride, as a plate with chloride of silver, for the purposes of photography [v]\n",
  "CHLORIDATES": "CHLORIDATE, to treat or prepare with a chloride, as a plate with chloride of silver, for the purposes of photography [v]\n",
  "CHLORIDATING": "CHLORIDATE, to treat or prepare with a chloride, as a plate with chloride of silver, for the purposes of photography [v]\n",
  "CHLORIDE": "a compound of chlorine with another element or radical, also CHLORID [n -S]\n",
  "CHLORIDES": "CHLORIDE, a compound of chlorine with another element or radical, also CHLORID [n]\n",
  "CHLORIDIC": "of or like a chloride [adj]\n",
  "CHLORIDISE": "to convert into a chloride, also CHLORIDIZE [v CHLORIDISED, CHLORIDISING, CHLORIDISES]\n",
  "CHLORIDISED": "CHLORIDISE, to convert into a chloride, also CHLORIDIZE [v]\n",
  "CHLORIDISES": "CHLORIDISE, to convert into a chloride, also CHLORIDIZE [v]\n",
  "CHLORIDISING": "CHLORIDISE, to convert into a chloride, also CHLORIDIZE [v]\n",
  "CHLORIDIZE": "to convert into a chloride, also CHLORIDISE [v CHLORIDIZED, CHLORIDIZING, CHLORIDIZES]\n",
  "CHLORIDIZED": "CHLORIDIZE, to convert into a chloride, also CHLORIDISE [v]\n",
  "CHLORIDIZES": "CHLORIDIZE, to convert into a chloride, also CHLORIDISE [v]\n",
  "CHLORIDIZING": "CHLORIDIZE, to convert into a chloride, also CHLORIDISE [v]\n",
  "CHLORIDS": "CHLORID, a compound of chlorine with another element or radical, also CHLORIDE [n]\n",
  "CHLORIMETER": "an apparatus for measuring available chlorine in bleaching powder, etc. [n -S]\n",
  "CHLORIMETERS": "CHLORIMETER, an apparatus for measuring available chlorine in bleaching powder, etc. [n]\n",
  "CHLORIMETRIC": "relating to chlorimetry [adj]\n",
  "CHLORIMETRIES": "CHLORIMETRY, measurement by chlorimeter [n]\n",
  "CHLORIMETRY": "measurement by chlorimeter [n CHLORIMETRIES]\n",
  "CHLORIN": "a yellowish-green halogen gaseous element, also CHLORINE [n -S]\n",
  "CHLORINATE": "to treat or combine with chlorine or a chlorine compound [v CHLORINATED, CHLORINATING, CHLORINATES]\n",
  "CHLORINATED": "CHLORINATE, to treat or combine with chlorine or a chlorine compound [v]\n",
  "CHLORINATES": "CHLORINATE, to treat or combine with chlorine or a chlorine compound [v]\n",
  "CHLORINATING": "CHLORINATE, to treat or combine with chlorine or a chlorine compound [v]\n",
  "CHLORINATION": "the act of chlorinating [n -S]\n",
  "CHLORINATIONS": "CHLORINATION, the act of chlorinating [n]\n",
  "CHLORINATOR": "a machine for chlorinating [n -S]\n",
  "CHLORINATORS": "CHLORINATOR, a machine for chlorinating [n]\n",
  "CHLORINE": "a yellowish-green halogen gaseous element, also CHLORIN [n -S]\n",
  "CHLORINES": "CHLORINE, a yellowish-green halogen gaseous element, also CHLORIN [n]\n",
  "CHLORINISE": "to chlorinate, also CHLORINIZE [v CHLORINISED, CHLORINISING, CHLORINISES]\n",
  "CHLORINISED": "CHLORINISE, to chlorinate, also CHLORINIZE [v]\n",
  "CHLORINISES": "CHLORINISE, to chlorinate, also CHLORINIZE [v]\n",
  "CHLORINISING": "CHLORINISE, to chlorinate, also CHLORINIZE [v]\n",
  "CHLORINITIES": "CHLORINITY, in seawater, a measure of the amounts of chlorine, iodine, bromine and fluorine present [n]\n",
  "CHLORINITY": "in seawater, a measure of the amounts of chlorine, iodine, bromine and fluorine present [n CHLORINITIES]\n",
  "CHLORINIZE": "to chlorinate, also CHLORINISE [v CHLORINIZED, CHLORINIZING, CHLORINIZES]\n",
  "CHLORINIZED": "CHLORINIZE, to chlorinate, also CHLORINISE [v]\n",
  "CHLORINIZES": "CHLORINIZE, to chlorinate, also CHLORINISE [v]\n",
  "CHLORINIZING": "CHLORINIZE, to chlorinate, also CHLORINISE [v]\n",
  "CHLORINS": "CHLORIN, a yellowish-green halogen gaseous element, also CHLORINE [n]\n",
  "CHLORITE": "a chlorine compound [n -S]\n",
  "CHLORITES": "CHLORITE, a chlorine compound [n]\n",
  "CHLORITIC": "pertaining to, or containing, chlorite [adj]\n",
  "CHLORITISATION": "the alteration of ferromagnesian minerals into chlorite or similar material, also CHLORITIZATION [n -S]\n",
  "CHLORITISATIONS": "CHLORITISATION, the alteration of ferromagnesian minerals into chlorite or similar material, also CHLORITIZATION [n]\n",
  "CHLORITIZATION": "the alteration of ferromagnesian minerals into chlorite or similar material, also CHLORITISATION [n -S]\n",
  "CHLORITIZATIONS": "CHLORITIZATION, the alteration of ferromagnesian minerals into chlorite or similar material, also CHLORITISATION [n]\n",
  "CHLOROACETIC": "an acid made by chlorinating acetic acid, also CHLORACETIC [adj]\n",
  "CHLOROARGYRITE": "the mineral form of silver chloride, also CHLORARGYRITE [n]\n",
  "CHLOROBENZENE": "a colorless flammable volatile toxic liquid used in organic synthesis (as of DDT) and as a solvent [n -S]\n",
  "CHLOROBENZENES": "CHLOROBENZENE, a colorless flammable volatile toxic liquid used in organic synthesis (as of DDT) and as a solvent [n]\n",
  "CHLOROBROMIDE": "a compound of chlorine and bromine with a metal or organic radical [n -S]\n",
  "CHLOROBROMIDES": "CHLOROBROMIDE, a compound of chlorine and bromine with a metal or organic radical [n]\n",
  "CHLOROCALCITE": "a white mineral consisting of potassium and calcium [n -S]\n",
  "CHLOROCALCITES": "CHLOROCALCITE, a white mineral consisting of potassium and calcium [n]\n",
  "CHLOROCRUORIN": "a green respiratory pigment found in some Polychaeta [n -S]\n",
  "CHLOROCRUORINS": "CHLOROCRUORIN, a green respiratory pigment found in some Polychaeta [n]\n",
  "CHLORODYNE": "a patent anodyne medicine, containing opium, chloroform, Indian hemp, etc. [n -S]\n",
  "CHLORODYNES": "CHLORODYNE, a patent anodyne medicine, containing opium, chloroform, Indian hemp, etc. [n]\n",
  "CHLOROETHENE": "ethyl chloride [n -S]\n",
  "CHLOROETHENES": "CHLOROETHENE, ethyl chloride [n]\n",
  "CHLOROETHYLENE": "vinyl chloride [n -S]\n",
  "CHLOROETHYLENES": "CHLOROETHYLENE, vinyl chloride [n]\n",
  "CHLOROFORM": "to treat with or as if with the colourless volatile liquid chloroform esp. so as to produce anesthesia [v -ED, -ING, -S]\n",
  "CHLOROFORMED": "CHLOROFORM, to treat with or as if with the colourless volatile liquid chloroform esp. so as to produce anesthesia [v]\n",
  "CHLOROFORMER": "one who administers chloroform [n -S]\n",
  "CHLOROFORMERS": "CHLOROFORMER, one who administers chloroform [n]\n",
  "CHLOROFORMING": "CHLOROFORM, to treat with or as if with the colourless volatile liquid chloroform esp. so as to produce anesthesia [v]\n",
  "CHLOROFORMIST": "one who administers chloroform [n -S]\n",
  "CHLOROFORMISTS": "CHLOROFORMIST, one who administers chloroform [n]\n",
  "CHLOROFORMS": "CHLOROFORM, to treat with or as if with the colourless volatile liquid chloroform esp. so as to produce anesthesia [v]\n",
  "CHLOROHYDRIN": "any of various organic compounds derived from diols or polyhydroxy alcohols by substitution of chlorine for part of the hydroxyl groups [n -S]\n",
  "CHLOROHYDRINS": "CHLOROHYDRIN, any of various organic compounds derived from diols or polyhydroxy alcohols by substitution of chlorine for part of the hydroxyl groups [n]\n",
  "CHLOROMETER": "instrument for measuring amount of chlorine in a solution [n -S]\n",
  "CHLOROMETERS": "CHLOROMETER, instrument for measuring amount of chlorine in a solution [n]\n",
  "CHLOROMETHANE": "an organic compound, methyl chloride [n -S]\n",
  "CHLOROMETHANES": "CHLOROMETHANE, an organic compound, methyl chloride [n]\n",
  "CHLOROMETRIC": "relating to chlorometry [adj]\n",
  "CHLOROMETRIES": "CHLOROMETRY, measurement by chlorometer [n]\n",
  "CHLOROMETRY": "measurement by chlorometer [n CHLOROMETRIES]\n",
  "CHLOROPHYL": "the green colouring in plants concerned with the production of sugars, also CHLOROPHYLL [n -S]\n",
  "CHLOROPHYLL": "the green colouring in plants concerned with the production of sugars, also CHLOROPHYL [n -S]\n",
  "CHLOROPHYLLOID": "of or like chlorophyll, also CHLOROPHYLLOUS [adj]\n",
  "CHLOROPHYLLOUS": "of or like chlorophyll, also CHLOROPHYLLOID [adj]\n",
  "CHLOROPHYLLS": "CHLOROPHYLL, the green colouring in plants concerned with the production of sugars, also CHLOROPHYL [n]\n",
  "CHLOROPHYLS": "CHLOROPHYL, the green colouring in plants concerned with the production of sugars, also CHLOROPHYLL [n]\n",
  "CHLOROPHYTUM": "any plant of the genus Chlorophytum, grown as pot plants for their long narrow leaves [n -S]\n",
  "CHLOROPHYTUMS": "CHLOROPHYTUM, any plant of the genus Chlorophytum, grown as pot plants for their long narrow leaves [n]\n",
  "CHLOROPICRIN": "a colorless liquid that causes tears and vomiting and is used esp. as a soil fumigant, also CHLORPICRIN [n -S]\n",
  "CHLOROPICRINS": "CHLOROPICRIN, a colorless liquid that causes tears and vomiting and is used esp. as a soil fumigant, also CHLORPICRIN [n]\n",
  "CHLOROPLAST": "a plastid that contains chlorophyll and is the site of photosynthesis [n -S]\n",
  "CHLOROPLASTAL": "of or like a chloroplast, also CHLOROPLASTIC [adj]\n",
  "CHLOROPLASTIC": "of or like a chloroplast, also CHLOROPLASTAL [adj]\n",
  "CHLOROPLASTS": "CHLOROPLAST, a plastid that contains chlorophyll and is the site of photosynthesis [n]\n",
  "CHLOROPRENE": "a colorless liquid used esp. in making neoprene by polymerization [n -S]\n",
  "CHLOROPRENES": "CHLOROPRENE, a colorless liquid used esp. in making neoprene by polymerization [n]\n",
  "CHLOROQUIN": "a drug used to suppress malaria, also CHLOROQUINE [n -S]\n",
  "CHLOROQUINE": "a drug used to suppress malaria, also CHLOROQUIN [n -S]\n",
  "CHLOROQUINES": "CHLOROQUINE, a drug used to suppress malaria, also CHLOROQUIN [n]\n",
  "CHLOROQUINS": "CHLOROQUIN, a drug used to suppress malaria, also CHLOROQUINE [n]\n",
  "CHLOROSES": "CHLOROSIS, a wasting disease (green sickness) typically affecting young women, characterized by anaemia, extreme lassitude and a greenish tinge of the skin [n]\n",
  "CHLOROSIS": "a wasting disease (green sickness) typically affecting young women, characterized by anaemia, extreme lassitude and a greenish tinge of the skin [n CHLOROSES or CHLOROSISES]\n",
  "CHLOROSISES": "CHLOROSIS, a wasting disease (green sickness) typically affecting young women, characterized by anaemia, extreme lassitude and a greenish tinge of the skin [n]\n",
  "CHLOROTHIAZIDE": "a thiazide diuretic used esp. in the treatment of edema and hypertension [n -S]\n",
  "CHLOROTHIAZIDES": "CHLOROTHIAZIDE, a thiazide diuretic used esp. in the treatment of edema and hypertension [n]\n",
  "CHLOROTIC": "pertaining to, or affected by, chlorosis [adj]\n",
  "CHLOROUS": "of chlorine; as, chlorous acid [adj]\n",
  "CHLORPICRIN": "a colorless liquid that causes tears and vomiting and is used esp. as a soil fumigant, also CHLOROPICRIN [n -S]\n",
  "CHLORPICRINS": "CHLORPICRIN, a colorless liquid that causes tears and vomiting and is used esp. as a soil fumigant, also CHLOROPICRIN [n]\n",
  "CHLORPROMAZINE": "a phenothiazine used chiefly as a tranquilizer esp. in the form of its hydrochloride to control the symptoms of psychotic disorders [n -S]\n",
  "CHLORPROMAZINES": "CHLORPROMAZINE, a phenothiazine used chiefly as a tranquilizer esp. in the form of its hydrochloride to control the symptoms of psychotic disorders [n]\n",
  "CHLORPROPAMIDE": "a sulfonylurea drug used orally to reduce blood sugar in the treatment of mild diabetes [n -S]\n",
  "CHLORPROPAMIDES": "CHLORPROPAMIDE, a sulfonylurea drug used orally to reduce blood sugar in the treatment of mild diabetes [n]\n",
  "CHLORTHALIDONE": "a diuretic used in the treatment of oedema, hypertension, and diabetes insipidus [n -S]\n",
  "CHLORTHALIDONES": "CHLORTHALIDONE, a diuretic used in the treatment of oedema, hypertension, and diabetes insipidus [n]\n",
  "CHOANA": "(Greek) a funnel-shaped opening, esp. either of those connecting the nasal cavities to the pharynx [n CHOANAE]\n",
  "CHOANAE": "CHOANA, (Greek) a funnel-shaped opening, esp. either of those connecting the nasal cavities to the pharynx [n]\n",
  "CHOANOCYTE": "a cell in which the flagellum is surrounded by a sheath of protoplasm [n -S]\n",
  "CHOANOCYTES": "CHOANOCYTE, a cell in which the flagellum is surrounded by a sheath of protoplasm [n]\n",
  "CHOBDAR": "(Urdu) in the Indian subcontinent, an usher bearing a staff, attending on a dignitary [n -S]\n",
  "CHOBDARS": "CHOBDAR, (Urdu) in the Indian subcontinent, an usher bearing a staff, attending on a dignitary [n]\n",
  "CHOC": "(colloquial) a chocolate [n -S]\n",
  "CHOCAHOLIC": "one addicted to chocolate, also CHOCOHOLIC [n -S]\n",
  "CHOCAHOLICS": "CHOCAHOLIC, one addicted to chocolate, also CHOCOHOLIC [n]\n",
  "CHOCCIER": "CHOCCY, having the taste or smell of chocolate [adj]\n",
  "CHOCCIES": "CHOCCY, chocolate [n]\n",
  "CHOCCIEST": "CHOCCY, having the taste or smell of chocolate [adj]\n",
  "CHOCCY": "chocolate [n CHOCCIES] / having the taste or smell of chocolate [adj CHOCCIER, CHOCCIEST]\n",
  "CHOCHO": "the fruit of a tropical vine, similar to cucumber, aka chayote, also CHOKO [n -S]\n",
  "CHOCHOS": "CHOCHO, the fruit of a tropical vine, similar to cucumber, aka chayote, also CHOKO [n]\n",
  "CHOCK": "to secure with a block or wedge [v -ED, -ING, -S]\n",
  "CHOCKABLOCK": "very full [adj]\n",
  "CHOCKED": "CHOCK, to secure with a block or wedge [v]\n",
  "CHOCKER": "(Australian slang) full up; fed up, also CHOCKERS [adj]\n",
  "CHOCKERS": "(Australian slang) full up, packed, also CHOCKER [adj]\n",
  "CHOCKFUL": "full to the limit [adj]\n",
  "CHOCKFULL": "completely full, also CHOCKFUL [adj]\n",
  "CHOCKIE": "(colloq.) chocolate, also CHOCKY [n -S]; like chocolate [adj CHOCKIER, CHOCKIEST].\n",
  "CHOCKIER": "CHOCKY, like chocolate [adj]\n",
  "CHOCKIES": "CHOCKY, (colloq.) chocolate, also CHOCKIE [n]\n",
  "CHOCKIEST": "CHOCKY, like chocolate [adj]\n",
  "CHOCKING": "CHOCK, to secure with a block or wedge [v]\n",
  "CHOCKO": "(Australian slang) in World War II, a conscript, also CHOCO [n -S]\n",
  "CHOCKOS": "CHOCKO, (Australian slang) in World War II, a conscript, also CHOCO [n]\n",
  "CHOCKS": "CHOCK, to secure with a block or wedge [v]\n",
  "CHOCKSTONE": "in mountaineering, a stone jammed in a crack [n -S]\n",
  "CHOCKSTONES": "CHOCKSTONE, in mountaineering, a stone jammed in a crack [n]\n",
  "CHOCKY": "(colloq.) chocolate, also CHOCKIE [n CHOCKIES] / like chocolate [adj CHOCKIER, CHOCKIEST]\n",
  "CHOCO": "(Australian slang) in World War II, a conscript, also CHOCKO [n -S]\n",
  "CHOCOHOLIC": "one addicted to chocolate, also CHOCAHOLIC [n -S]\n",
  "CHOCOHOLICS": "CHOCOHOLIC, one addicted to chocolate, also CHOCAHOLIC [n]\n",
  "CHOCOLATE": "a paste made of the ground seeds of the cocoa plant, with sugar and flour or similar material, usually hardened into slabs [n -S]\n",
  "CHOCOLATES": "CHOCOLATE, a paste made of the ground seeds of the cocoa plant, with sugar and flour or similar material, usually hardened into slabs [n]\n",
  "CHOCOLATEY": "of or like chocolate, also CHOCOLATY [adj CHOCOLATIER, CHOCOLATIEST]\n",
  "CHOCOLATIER": "one who sells chocolate [n -S]\n",
  "CHOCOLATIERS": "CHOCOLATIER, one who sells chocolate [n]\n",
  "CHOCOLATIEST": "CHOCOLATY, of or like chocolate, also CHOCOLATEY [adj]\n",
  "CHOCOLATY": "of or like chocolate, also CHOCOLATEY [adj CHOCOLATIER, CHOCOLATIEST]\n",
  "CHOCOS": "CHOCO, (Australian slang) in World War II, a conscript, also CHOCKO [n]\n",
  "CHOCS": "CHOC, (colloquial) a chocolate [n]\n",
  "CHOCTAW": "(Native American) a type of skating movement [n -S]\n",
  "CHOCTAWS": "CHOCTAW, (Native American) a type of skating movement [n]\n",
  "CHODE": "CHIDE, to scold [v]\n",
  "CHOENIX": "(Greek) an ancient Greek measurement [n -ES]\n",
  "CHOENIXES": "CHOENIX, (Greek) an ancient Greek measurement [n]\n",
  "CHOG": "(dialect) the core of a piece of fruit [n -S]\n",
  "CHOGS": "CHOG, (dialect) the core of a piece of fruit [n]\n",
  "CHOICE": "the thing chosen [n -S] / of fine quality [adj CHOICER, CHOICEST, CHOICELY]\n",
  "CHOICEFUL": "(archaic) making choices, fickle [adj]\n",
  "CHOICELY": "CHOICE, of fine quality [adv]\n",
  "CHOICENESS": "the quality of being of particular value or worth [n -ES]\n",
  "CHOICENESSES": "CHOICENESS, the quality of being of particular value or worth [n]\n",
  "CHOICER": "CHOICE, of fine quality [adj]\n",
  "CHOICES": "CHOICE, the thing chosen [n]\n",
  "CHOICEST": "CHOICE, of fine quality [adj]\n",
  "CHOIL": "the end of a knife blade nearer the handle [n -S]\n",
  "CHOILS": "CHOIL, the end of a knife blade nearer the handle [n]\n",
  "CHOIR": "to sing in chorus [v -ED, -ING, -S]\n",
  "CHOIRBOY": "a boy who sings in a church choir [n -S]\n",
  "CHOIRBOYS": "CHOIRBOY, a boy who sings in a church choir [n]\n",
  "CHOIRED": "CHOIR, to sing in chorus [v]\n",
  "CHOIRGIRL": "a female member of a choir [n -S]\n",
  "CHOIRGIRLS": "CHOIRGIRL, a female member of a choir [n]\n",
  "CHOIRING": "CHOIR, to sing in chorus [v]\n",
  "CHOIRLIKE": "like a choir [adj]\n",
  "CHOIRMAN": "a male chorister [n CHOIRMEN]\n",
  "CHOIRMASTER": "the leader of a choir [n -S]\n",
  "CHOIRMASTERS": "CHOIRMASTER, the leader of a choir [n]\n",
  "CHOIRMEN": "CHOIRMAN, a male chorister [n]\n",
  "CHOIRS": "CHOIR, to sing in chorus [v]\n",
  "CHOIRSCREEN": "a screen of latticework, separating the choir from the nave [n -S]\n",
  "CHOIRSCREENS": "CHOIRSCREEN, a screen of latticework, separating the choir from the nave [n]\n",
  "CHOIRSTALL": "one of the benches for the choir of a church, cathedral, etc. [n -S]\n",
  "CHOIRSTALLS": "CHOIRSTALL, one of the benches for the choir of a church, cathedral, etc. [n]\n",
  "CHOKE": "to impede the breathing of [v CHOKED, CHOKING, CHOKES]\n",
  "CHOKEABLE": "that can be choked [adj]\n",
  "CHOKEBERRIES": "CHOKEBERRY, a small astringent fruit of various North American shrubs related to the apple [n]\n",
  "CHOKEBERRY": "a small astringent fruit of various North American shrubs related to the apple [n CHOKEBERRIES]\n",
  "CHOKEBORE": "a gun that narrows toward the muzzle [n -S]\n",
  "CHOKEBORES": "CHOKEBORE, a gun that narrows toward the muzzle [n]\n",
  "CHOKECHERRIES": "CHOKECHERRY, an astringent American cherry [n]\n",
  "CHOKECHERRY": "an astringent American cherry [n CHOKECHERRIES]\n",
  "CHOKECOIL": "a choking coil [n -S]\n",
  "CHOKECOILS": "CHOKECOIL, a choking coil [n]\n",
  "CHOKED": "CHOKE, to impede the breathing of [v]\n",
  "CHOKEDAMP": "an asphyxiating gas, mainly carbon dioxide, found in mines [n -S]\n",
  "CHOKEDAMPS": "CHOKEDAMP, an asphyxiating gas, mainly carbon dioxide, found in mines [n]\n",
  "CHOKEHOLD": "the act of holding a person's neck across the windpipe, esp. from behind [n -S]\n",
  "CHOKEHOLDS": "CHOKEHOLD, the act of holding a person's neck across the windpipe, esp. from behind [n]\n",
  "CHOKER": "a close-fitting necklace [n -S]\n",
  "CHOKERMAN": "(Canadian) a person responsible for attaching chokers to logs [n CHOKERMEN]\n",
  "CHOKERMEN": "CHOKERMAN, (Canadian) a person responsible for attaching chokers to logs [n]\n",
  "CHOKERS": "CHOKER, a close-fitting necklace [n]\n",
  "CHOKES": "CHOKE, to impede the breathing of [v]\n",
  "CHOKEY": "(slang) prison, also CHOKY [n -S]\n",
  "CHOKEYS": "CHOKEY, (slang) prison, also CHOKY [n]\n",
  "CHOKIDAR": "(Urdu) a watchman, also CHOWKIDAR [n -S]\n",
  "CHOKIDARS": "CHOKIDAR, (Urdu) a watchman, also CHOWKIDAR [n]\n",
  "CHOKIER": "CHOKY, tending to cause choking [adj]\n",
  "CHOKIES": "CHOKY, a prison [n]\n",
  "CHOKIEST": "CHOKY, tending to cause choking [adj]\n",
  "CHOKING": "CHOKE, to impede the breathing of [v]\n",
  "CHOKINGLY": "CHOKING, CHOKE, to impede the breathing of [adv]\n",
  "CHOKO": "the fruit of a tropical vine, similar to cucumber, aka chayote, also CHOCHO [n -S]\n",
  "CHOKOS": "CHOKO, the fruit of a tropical vine, similar to cucumber, aka chayote, also CHOCHO [n]\n",
  "CHOKRA": "(Hindi) a boy; a household or regimental servant [n -S]\n",
  "CHOKRAS": "CHOKRA, (Hindi) a boy; a household or regimental servant [n]\n",
  "CHOKRI": "(Hindi) a girl; a female household or regimental servant [n -S]\n",
  "CHOKRIS": "CHOKRI, (Hindi) a girl; a female household or regimental servant [n]\n",
  "CHOKY": "a prison [n CHOKIES] / tending to cause choking [adj CHOKIER, CHOKIEST]\n",
  "CHOLA": "(Spanish) a Mexican-American girl [n -S]\n",
  "CHOLAEMIA": "an accumulation of bile pigments in the blood, also CHOLEMIA [n -S]\n",
  "CHOLAEMIAS": "CHOLAEMIA, an accumulation of bile pigments in the blood, also CHOLEMIA [n]\n",
  "CHOLAEMIC": "relating to cholaemia, an accumulation of bile pigments in the blood [adj]\n",
  "CHOLAGOGIC": "of or like a cholagogue [adj]\n",
  "CHOLAGOGUE": "an agent which increases the flow of bile and promotes its ejection [n -S]\n",
  "CHOLAGOGUES": "CHOLAGOGUE, an agent which increases the flow of bile and promotes its ejection [n]\n",
  "CHOLANGIOGRAM": "a record produced by cholangiography, bile duct X-rays [n -S]\n",
  "CHOLANGIOGRAMS": "CHOLANGIOGRAM, a record produced by cholangiography, bile duct X-rays [n]\n",
  "CHOLANGIOGRAPHY": "the examination by X-ray of the bile duct [n]\n",
  "CHOLAS": "CHOLA, (Spanish) a Mexican-American girl [n]\n",
  "CHOLATE": "a salt of cholic acid; as, sodium cholate [n -S]\n",
  "CHOLATES": "CHOLATE, a salt of cholic acid; as, sodium cholate [n]\n",
  "CHOLECALCIFEROL": "a natural form of vitamin D found esp. in fish, egg yolks, and fish-liver oils [n]\n",
  "CHOLECYST": "the gall bladder [n -S]\n",
  "CHOLECYSTECTOMY": "a surgical operation to remove the gall bladder [n]\n",
  "CHOLECYSTITIDES": "CHOLECYSTITIS, inflammation of the gall bladder [n]\n",
  "CHOLECYSTITIS": "inflammation of the gall bladder [n CHOLECYSTITIDES or CHOLECYSTITISES]\n",
  "CHOLECYSTITISES": "CHOLECYSTITIS, inflammation of the gall bladder [n]\n",
  "CHOLECYSTOKININ": "a hormone secreted esp. by the duodenal mucosa that regulates the emptying of the gallbladder and secretion of enzymes by the pancreas and that has been found in the brain [n]\n",
  "CHOLECYSTOSTOMY": "the surgical formation of an opening in the wall of the gall bladder, also CHOLECYSTOTOMY [n]\n",
  "CHOLECYSTOTOMY": "the surgical formation of an opening in the wall of the gall bladder, also CHOLECYSTOSTOMY [n]\n",
  "CHOLECYSTS": "CHOLECYST, the gall bladder [n]\n",
  "CHOLELITH": "a gallstone [n -S]\n",
  "CHOLELITHIASES": "CHOLELITHIASIS, the production of gall stones [n]\n",
  "CHOLELITHIASIS": "the production of gall stones [n CHOLELITHIASES]\n",
  "CHOLELITHS": "CHOLELITH, a gallstone [n]\n",
  "CHOLEMIA": "an accumulation of bile pigments in the blood, also CHOLAEMIA [n -S]\n",
  "CHOLEMIAS": "CHOLEMIA, an accumulation of bile pigments in the blood, also CHOLAEMIA [n]\n",
  "CHOLENT": "(Yiddish) a stew of boiling fowl, rice and vegetables [n -S]\n",
  "CHOLENTS": "CHOLENT, (Yiddish) a stew of boiling fowl, rice and vegetables [n]\n",
  "CHOLER": "anger, irascibility [n -S]\n",
  "CHOLERA": "(Greek) an acute and frequently fatal infection of the small intestine [n -S]\n",
  "CHOLERAIC": "relating to cholera [adj]\n",
  "CHOLERAS": "CHOLERA, (Greek) an acute and frequently fatal infection of the small intestine [n]\n",
  "CHOLERIC": "bad-tempered [adj CHOLERICLY or CHOLERICALLY]\n",
  "CHOLERICALLY": "CHOLERIC, bad-tempered [adv]\n",
  "CHOLERICLY": "CHOLERIC, bad-tempered [adv]\n",
  "CHOLEROID": "like cholera [adj]\n",
  "CHOLERS": "CHOLER, anger, irascibility [n]\n",
  "CHOLESTASES": "CHOLESTASIS, a checking or failure of bile flow [n]\n",
  "CHOLESTASIS": "a checking or failure of bile flow [n CHOLESTASES]\n",
  "CHOLESTATIC": "relating to cholestasis [adj]\n",
  "CHOLESTERATE": "a salt of cholesteric acid [n -S]\n",
  "CHOLESTERATES": "CHOLESTERATE, a salt of cholesteric acid [n]\n",
  "CHOLESTERIC": "relating to cholesterol [adj]\n",
  "CHOLESTERIN": "a former name for arteriosclerosis [n -S]\n",
  "CHOLESTERINS": "CHOLESTERIN, a former name for arteriosclerosis [n]\n",
  "CHOLESTEROL": "a sterol occurring in all body cells and involved in the transport of fats through the bloodstream [n -S]\n",
  "CHOLESTEROLEMIA": "the presence of abnormally high levels of cholesterol in the blood [n]\n",
  "CHOLESTEROLS": "CHOLESTEROL, a sterol occurring in all body cells and involved in the transport of fats through the bloodstream [n]\n",
  "CHOLESTYRAMINE": "a strongly basic synthetic resin that forms insoluble complexes with bile acids and has been used to lower cholesterol levels in hypercholesterolemic patients [n -S]\n",
  "CHOLESTYRAMINES": "CHOLESTYRAMINE, a strongly basic synthetic resin that forms insoluble complexes with bile acids and has been used to lower cholesterol levels in hypercholesterolemic patients [n]\n",
  "CHOLI": "(Hindi) a short, close-fitting blouse worn under a sari [n -S]\n",
  "CHOLIAMB": "(Greek) a verse having an iambus in the fifth place, and a spondee in the sixth or last, also CHOLIAMBIC [n -S]\n",
  "CHOLIAMBIC": "a verse having an iambus in the fifth place, and a spondee in the sixth or last, also CHOLIAMB [n -S]\n",
  "CHOLIAMBICS": "CHOLIAMBIC, a verse having an iambus in the fifth place, and a spondee in the sixth or last, also CHOLIAMB [n]\n",
  "CHOLIAMBS": "CHOLIAMB, (Greek) a verse having an iambus in the fifth place, and a spondee in the sixth or last, also CHOLIAMBIC [n]\n",
  "CHOLIC": "relating to bile, as in cholic acid [adj]\n",
  "CHOLINE": "an alcohol found in bile [n -S]\n",
  "CHOLINERGIC": "acting like acetylcholine [adj CHOLINERGICALLY]\n",
  "CHOLINERGICALLY": "CHOLINERGIC, acting like acetylcholine [adv]\n",
  "CHOLINES": "CHOLINE, an alcohol found in bile [n]\n",
  "CHOLINESTERASE": "an enzyme which breaks down a choline ester into choline and an acid, esp. acetylcholine into choline and acetic acid [n -S]\n",
  "CHOLINESTERASES": "CHOLINESTERASE, an enzyme which breaks down a choline ester into choline and an acid, esp. acetylcholine into choline and acetic acid [n]\n",
  "CHOLIS": "CHOLI, (Hindi) a short, close-fitting blouse worn under a sari [n]\n",
  "CHOLLA": "(Spanish) a treelike cactus [n -S]\n",
  "CHOLLAS": "CHOLLA, (Spanish) a treelike cactus [n]\n",
  "CHOLLERS": "(English dialect) cheeks, jowls [n]\n",
  "CHOLO": "(Spanish) a flashy Mexican-American youth [n -S]\n",
  "CHOLOS": "CHOLO, (Spanish) a flashy Mexican-American youth [n]\n",
  "CHOLTRIES": "CHOLTRY, (Malayalam) a shed used for assembly, also CHOULTRY [n]\n",
  "CHOLTRY": "(Malayalam) a shed used for assembly, also CHOULTRY [n CHOLTRIES]\n",
  "CHOMETZ": "(Hebrew) leavened food forbidden during Passover, also CHAMETZ [n -ES]\n",
  "CHOMETZES": "CHOMETZ, (Hebrew) leavened food forbidden during Passover, also CHAMETZ [n]\n",
  "CHOMMIE": "(South African) a friend [n -S]\n",
  "CHOMMIES": "CHOMMIE, (South African) a friend [n]\n",
  "CHOMOPHYTE": "a plant growing on rocky ledges [n -S]\n",
  "CHOMOPHYTES": "CHOMOPHYTE, a plant growing on rocky ledges [n]\n",
  "CHOMP": "to chew vigorously [v -ED, -ING, -S]\n",
  "CHOMPED": "CHOMP, to chew vigorously [v]\n",
  "CHOMPER": "one who chomps [n -S]\n",
  "CHOMPERS": "CHOMPER, one who chomps [n]\n",
  "CHOMPING": "CHOMP, to chew vigorously [v]\n",
  "CHOMPS": "CHOMP, to chew vigorously [v]\n",
  "CHON": "(Korean) a Korean monetary unit, also JEON [n -S]\n",
  "CHONDRAL": "relating to a chondrus, a cartilage [adj]\n",
  "CHONDRE": "(Greek) a spheroidal mineral grain embedded in a meteorite, also CHONDRULE [n -S]\n",
  "CHONDRES": "CHONDRE, (Greek) a spheroidal mineral grain embedded in a meteorite, also CHONDRULE [n]\n",
  "CHONDRI": "CHONDRUS, (Greek) a cartilage [n]\n",
  "CHONDRICHTHYAN": "a technical name for a cartilaginous fish [n -S]\n",
  "CHONDRICHTHYANS": "CHONDRICHTHYAN, a technical name for a cartilaginous fish [n]\n",
  "CHONDRIFICATION": "the process of chondrifying, converting into cartilage [n]\n",
  "CHONDRIFIED": "CHONDRIFY, to convert, or be converted, into cartilage [v]\n",
  "CHONDRIFIES": "CHONDRIFY, to convert, or be converted, into cartilage [v]\n",
  "CHONDRIFY": "to convert, or be converted, into cartilage [v CHONDRIFIED, CHONDRIFYING, CHONDRIFIES]\n",
  "CHONDRIFYING": "CHONDRIFY, to convert, or be converted, into cartilage [v]\n",
  "CHONDRIN": "an elastic, gelatinous substance, the matrix of cartilage [n -S]\n",
  "CHONDRINS": "CHONDRIN, an elastic, gelatinous substance, the matrix of cartilage [n]\n",
  "CHONDRIOSOMAL": "of or like a chondriosome, a mitochondrion [adj]\n",
  "CHONDRIOSOME": "an old name for a mitochondrion, a minute body generating ATP in the cytoplasm of a cell [n -S]\n",
  "CHONDRIOSOMES": "CHONDRIOSOME, an old name for a mitochondrion, a minute body generating ATP in the cytoplasm of a cell [n]\n",
  "CHONDRITE": "a meteoric stone characterized by the presence of chondrules [n -S]\n",
  "CHONDRITES": "CHONDRITE, a meteoric stone characterized by the presence of chondrules [n]\n",
  "CHONDRITIC": "granular; having the granular structure characteristic of the class of meteorites called chondrites [adj]\n",
  "CHONDRITIS": "an inflammation of cartilage [n -ES]\n",
  "CHONDRITISES": "CHONDRITIS, an inflammation of cartilage [n]\n",
  "CHONDROBLAST": "a cell that forms cartilage [n -S]\n",
  "CHONDROBLASTS": "CHONDROBLAST, a cell that forms cartilage [n]\n",
  "CHONDROCRANIA": "CHONDROCRANIUM, the cartilaginous parts of an embryonic cranium [n]\n",
  "CHONDROCRANIUM": "the cartilaginous parts of an embryonic cranium [n CHONDROCRANIA or CHONDROCRANIUMS]\n",
  "CHONDROCRANIUMS": "CHONDROCRANIUM, the cartilaginous parts of an embryonic cranium [n]\n",
  "CHONDROCYTE": "a cartilage cell [n -S]\n",
  "CHONDROCYTES": "CHONDROCYTE, a cartilage cell [n]\n",
  "CHONDROGENESES": "CHONDROGENESIS, the production of cartilage [n]\n",
  "CHONDROGENESIS": "the production of cartilage [n CHONDROGENESES]\n",
  "CHONDROID": "like or resembling cartilage [adj]\n",
  "CHONDROITIN": "any of several glycosaminoglycans occurring in sulfated form in various animal tissues such as cartilage [n -S]\n",
  "CHONDROITINS": "CHONDROITIN, any of several glycosaminoglycans occurring in sulfated form in various animal tissues such as cartilage [n]\n",
  "CHONDROMA": "a benign cartilaginous growth [n CHONDROMAS or CHONDROMATA]\n",
  "CHONDROMAS": "CHONDROMA, a benign cartilaginous growth [n]\n",
  "CHONDROMATA": "CHONDROMA, a benign cartilaginous growth [n]\n",
  "CHONDROMATOSES": "CHONDROMATOSIS, a condition in which benign tumours made up of cartilage cells form in the bones [n]\n",
  "CHONDROMATOSIS": "a condition in which benign tumours made up of cartilage cells form in the bones [n CHONDROMATOSES]\n",
  "CHONDROMATOUS": "of or like a chondriosome, a mitochondrion [adj]\n",
  "CHONDROPHORE": "a medusoid hydrozoan that resembles a jellyfish [n -S]\n",
  "CHONDROPHORES": "CHONDROPHORE, a medusoid hydrozoan that resembles a jellyfish [n]\n",
  "CHONDROPHORINE": "a member of the Chondrophora, a suborder of hydrozoans similar to medusae but with a different internal structure [n -S]\n",
  "CHONDROPHORINES": "CHONDROPHORINE, a member of the Chondrophora, a suborder of hydrozoans similar to medusae but with a different internal structure [n]\n",
  "CHONDROSAMINE": "an amino-sugar, the basis of chondroitin [n -S]\n",
  "CHONDROSAMINES": "CHONDROSAMINE, an amino-sugar, the basis of chondroitin [n]\n",
  "CHONDROSKELETON": "the cartilaginous part of the skeleton of vertebrates [n]\n",
  "CHONDROSTIAN": "a member of the Chondrostei, an order of bony fishes including the sturgeon and bichir [n -S]\n",
  "CHONDROSTIANS": "CHONDROSTIAN, a member of the Chondrostei, an order of bony fishes including the sturgeon and bichir [n]\n",
  "CHONDRULE": "a spheroidal mineral grain embedded in a meteorite, also CHONDRE [n -S]\n",
  "CHONDRULES": "CHONDRULE, a spheroidal mineral grain embedded in a meteorite, also CHONDRE [n]\n",
  "CHONDRUS": "(Greek) a cartilage [n CHONDRI]\n",
  "CHONS": "CHON, (Korean) a Korean monetary unit, also JEON [n]\n",
  "CHOOF": "(Australian slang) to go, vamoose [v -ED, -ING, -S]\n",
  "CHOOFED": "CHOOF, (Australian slang) to go, vamoose [v]\n",
  "CHOOFING": "CHOOF, (Australian slang) to go, vamoose [v]\n",
  "CHOOFS": "CHOOF, (Australian slang) to go, vamoose [v]\n",
  "CHOOK": "a chicken [n -S] / to make a sound like a chicken [v -ED, -ING, -S]\n",
  "CHOOKED": "CHOOK, to make a sound like a chicken [v]\n",
  "CHOOKIE": "(Australian) a chicken, also CHOOK, CHUCKIE, CHUCKY [n -S]\n",
  "CHOOKIES": "CHOOKIE, (Australian) a chicken, also CHOOK, CHUCKIE, CHUCKY [n]\n",
  "CHOOKING": "CHOOK, to make a sound like a chicken [v]\n",
  "CHOOKS": "CHOOK, to make a sound like a chicken [v]\n",
  "CHOOM": "(Australian slang) an Englishman [n -S]\n",
  "CHOOMS": "CHOOM, (Australian slang) an Englishman [n]\n",
  "CHOON": "a piece of recorded music that one likes [n -S]\n",
  "CHOONS": "CHOON, a piece of recorded music that one likes [n]\n",
  "CHOOSE": "to select by preference [v CHOSE, CHOSEN, CHOOSING, CHOOSES]\n",
  "CHOOSER": "one who chooses [n -S]\n",
  "CHOOSERS": "CHOOSER, one who chooses [n]\n",
  "CHOOSES": "CHOOSE, to select by preference [v]\n",
  "CHOOSEY": "difficult to please, fastidious, also CHOOSY [adj CHOOSIER, CHOOSIEST, CHOOSILY]\n",
  "CHOOSIER": "CHOOSY, difficult to please, fastidious, also CHOOSEY [adj]\n",
  "CHOOSIEST": "CHOOSY, difficult to please, fastidious, also CHOOSEY [adj]\n",
  "CHOOSILY": "CHOOSY, difficult to please, fastidious, also CHOOSEY [adv]\n",
  "CHOOSING": "CHOOSE, to select by preference [v]\n",
  "CHOOSY": "difficult to please, fastidious, also CHOOSEY [adj CHOOSIER, CHOOSIEST, CHOOSILY]\n",
  "CHOP": "to sever with a sharp tool [v CHOPPED, CHOPPING, CHOPS]\n",
  "CHOPFALLEN": "dejected, dispirited, also CHAPFALLEN [adj]\n",
  "CHOPHOUSE": "in China, a customs house [n -S]\n",
  "CHOPHOUSES": "CHOPHOUSE, in China, a customs house [n]\n",
  "CHOPIN": "a high clog or patten introduced into England from Venice during the reign of Elizabeth I, also CHOPINE [n -S]\n",
  "CHOPINE": "a high clog or patten introduced into England from Venice during the reign of Elizabeth I, also CHOPIN [n -S]\n",
  "CHOPINES": "CHOPINE, a high clog or patten introduced into England from Venice during the reign of Elizabeth I, also CHOPIN [n]\n",
  "CHOPINS": "CHOPIN, a high clog or patten introduced into England from Venice during the reign of Elizabeth I, also CHOPINE [n]\n",
  "CHOPLOGIC": "false reasoning, sophistry [n -S]\n",
  "CHOPLOGICS": "CHOPLOGIC, false reasoning, sophistry [n]\n",
  "CHOPPED": "CHOP, to sever with a sharp tool [v]\n",
  "CHOPPER": "to travel by helicopter [v -ED, -ING, -S]\n",
  "CHOPPERED": "CHOPPER, to travel by helicopter [v]\n",
  "CHOPPERING": "CHOPPER, to travel by helicopter [v]\n",
  "CHOPPERS": "CHOPPER, to travel by helicopter [v]\n",
  "CHOPPIER": "CHOPPY, full of irregular waves [adj]\n",
  "CHOPPIEST": "CHOPPY, full of irregular waves [adj]\n",
  "CHOPPILY": "CHOPPY, full of irregular waves [adv]\n",
  "CHOPPINESS": "the state of being choppy [n -ES]\n",
  "CHOPPINESSES": "CHOPPINESS, the state of being choppy [n]\n",
  "CHOPPING": "the act of chopping [n -S]\n",
  "CHOPPINGS": "CHOPPING, the act of chopping [n]\n",
  "CHOPPY": "full of irregular waves [adj CHOPPIER, CHOPPIEST, CHOPPILY]\n",
  "CHOPS": "CHOP, to sever with a sharp tool [v]\n",
  "CHOPSOCKIES": "CHOPSOCKY, a genre of martial arts films [n]\n",
  "CHOPSOCKY": "a genre of martial arts films [n CHOPSOCKIES]\n",
  "CHOPSTICK": "either of two small sticks used instead of a fork for eating, esp. in Oriental countries [n -S]\n",
  "CHOPSTICKS": "CHOPSTICK, either of two small sticks used instead of a fork for eating, esp. in Oriental countries [n]\n",
  "CHORAGI": "CHORAGUS, (Latin) a leader of a choir, also CHOREGUS [n]\n",
  "CHORAGIC": "relating to a choragus [adj]\n",
  "CHORAGUS": "(Latin) a leader of a choir, also CHOREGUS [n CHORAGUSES or CHORAGI]\n",
  "CHORAGUSES": "CHORAGUS, (Latin) a leader of a choir, also CHOREGUS [n]\n",
  "CHORAL": "relating to a choir [adj CHORALLY] / a simple harmonized composition with slow rhythm; a psalm or hymn tune, also CHORALE [n -S]\n",
  "CHORALE": "a simple harmonized composition with slow rhythm; a psalm or hymn tune, also CHORAL [n -S]\n",
  "CHORALES": "CHORALE, a simple harmonized composition with slow rhythm; a psalm or hymn tune, also CHORAL [n]\n",
  "CHORALIST": "a member of a choir, also CHORIST, CHORISTER, QUIRISTER [n -S]\n",
  "CHORALISTS": "CHORALIST, a member of a choir, also CHORIST, CHORISTER, QUIRISTER [n]\n",
  "CHORALLY": "CHORAL, relating to a choir [adv]\n",
  "CHORALS": "CHORAL, a simple harmonized composition with slow rhythm; a psalm or hymn tune, also CHORALE [n]\n",
  "CHORD": "to play a combination of three or more musical notes [v -ED, -ING, -S]\n",
  "CHORDA": "(Latin) a primitive sort of spinal column [n CHORDAE]\n",
  "CHORDAE": "CHORDA, (Latin) a primitive sort of spinal column [n]\n",
  "CHORDAL": "pertaining to a chord [adj]\n",
  "CHORDAMESODERM": "the layer of specialized cells in the middle of a developing embryo which forms the notochord and structures of the central nervous system [n -S]\n",
  "CHORDAMESODERMS": "CHORDAMESODERM, the layer of specialized cells in the middle of a developing embryo which forms the notochord and structures of the central nervous system [n]\n",
  "CHORDATE": "an animal having a backbone [n -S]\n",
  "CHORDATES": "CHORDATE, an animal having a backbone [n]\n",
  "CHORDED": "CHORD, to play a combination of three or more musical notes [v]\n",
  "CHORDEE": "a painful erection of the penis, usually with downward curvature, occurring in gonorrhea [n -S]\n",
  "CHORDEES": "CHORDEE, a painful erection of the penis, usually with downward curvature, occurring in gonorrhea [n]\n",
  "CHORDING": "the playing, singing, or arrangement of chords [n -S]\n",
  "CHORDINGS": "CHORDING, the playing, singing, or arrangement of chords [n]\n",
  "CHORDLIKE": "like a chord [adj]\n",
  "CHORDOPHONE": "any instrument in which a string vibrates to produce a sound, including the zither, piano, lute, lyre and harp [n -S]\n",
  "CHORDOPHONES": "CHORDOPHONE, any instrument in which a string vibrates to produce a sound, including the zither, piano, lute, lyre and harp [n]\n",
  "CHORDOPHONIC": "of or like a chordophone [adj]\n",
  "CHORDOTOMIES": "CHORDOTOMY, the surgical division of a bundle of nerve fibres in the spinal cord, also CORDOTOMY [n]\n",
  "CHORDOTOMY": "the surgical division of a bundle of nerve fibres in the spinal cord, also CORDOTOMY [n CHORDOTOMIES]\n",
  "CHORDS": "CHORD, to play a combination of three or more musical notes [v]\n",
  "CHORDWISE": "in the direction of an aerofoil chord [adv]\n",
  "CHORE": "to do small jobs [v CHORED, CHORING, CHORES]\n",
  "CHOREA": "(Greek) St Vitus's dance; a disease attended with convulsive twitchings and other involuntary movements of the muscles or limbs [n -S]\n",
  "CHOREAL": "relating to chorea [adj]\n",
  "CHOREAS": "CHOREA, (Greek) St Vitus's dance; a disease attended with convulsive twitchings and other involuntary movements of the muscles or limbs [n]\n",
  "CHOREATIC": "of or like chorea [adj]\n",
  "CHOREBOY": "a boy used to do odd jobs [n -S]\n",
  "CHOREBOYS": "CHOREBOY, a boy used to do odd jobs [n]\n",
  "CHORED": "CHORE, to do small jobs [v]\n",
  "CHOREE": "(Greek) a trochee, also CHOREUS [n -S]\n",
  "CHOREES": "CHOREE, (Greek) a trochee, also CHOREUS [n]\n",
  "CHOREGI": "CHOREGUS, (Latin) a leader of a choir, also CHORAGUS [n]\n",
  "CHOREGIC": "relating to a choregus, the financial backer in ancient Greece, usually of a play, also CHORAGIC [adj]\n",
  "CHOREGRAPH": "to arrange or compose (a dance, dances, etc.), also CHOREOGRAPH [v -ED, -ING, -S]\n",
  "CHOREGRAPHED": "CHOREGRAPH, to arrange or compose (a dance, dances, etc.), also CHOREOGRAPH [v]\n",
  "CHOREGRAPHER": "one who choregraphs, also CHOREOGRAPHER [n -S]\n",
  "CHOREGRAPHERS": "CHOREGRAPHER, one who choregraphs, also CHOREOGRAPHER [n]\n",
  "CHOREGRAPHIC": "relating to choregraphy, also CHOREOGRAPHIC [adj]\n",
  "CHOREGRAPHIES": "CHOREGRAPHY, the art of symbolically representing dancing, also CHOREOGRAPHY [n]\n",
  "CHOREGRAPHING": "CHOREGRAPH, to arrange or compose (a dance, dances, etc.), also CHOREOGRAPH [v]\n",
  "CHOREGRAPHS": "CHOREGRAPH, to arrange or compose (a dance, dances, etc.), also CHOREOGRAPH [v]\n",
  "CHOREGRAPHY": "the art of symbolically representing dancing, also CHOREOGRAPHY [n CHOREGRAPHIES]\n",
  "CHOREGUS": "(Latin) a leader of a choir, also CHORAGUS [n CHOREGUSES or CHOREGI]\n",
  "CHOREGUSES": "CHOREGUS, (Latin) a leader of a choir, also CHORAGUS [n]\n",
  "CHOREIC": "relating to chorea [adj]\n",
  "CHOREIFORM": "resembling chorea [adj]\n",
  "CHOREMAN": "a menial worker [n CHOREMEN]\n",
  "CHOREMEN": "CHOREMAN, a menial worker [n]\n",
  "CHOREODRAMA": "dance drama performed by a group [n -S]\n",
  "CHOREODRAMAS": "CHOREODRAMA, dance drama performed by a group [n]\n",
  "CHOREOGRAPH": "to compose the choreography of, also CHOREGRAPH [v -ED, -ING, -S]\n",
  "CHOREOGRAPHED": "CHOREOGRAPH, to compose the choreography of, also CHOREGRAPH [v]\n",
  "CHOREOGRAPHER": "one who choreographs, also CHOREGRAPHER [n -S]\n",
  "CHOREOGRAPHERS": "CHOREOGRAPHER, one who choreographs, also CHOREGRAPHER [n]\n",
  "CHOREOGRAPHIC": "relating to choreography, also CHOREGRAPHIC [adj]\n",
  "CHOREOGRAPHIES": "CHOREOGRAPHY, the art of symbolically representing dancing, also CHOREGRAPHY [n]\n",
  "CHOREOGRAPHING": "CHOREOGRAPH, to compose the choreography of, also CHOREGRAPH [v]\n",
  "CHOREOGRAPHS": "CHOREOGRAPH, to compose the choreography of, also CHOREGRAPH [v]\n",
  "CHOREOGRAPHY": "the art of symbolically representing dancing, also CHOREGRAPHY [n CHOREOGRAPHIES]\n",
  "CHOREOID": "relating to the chorion, the dark brown vascular coat of the eye, also CHORIOID, CHOROID [adj]\n",
  "CHOREOLOGIES": "CHOREOLOGY, the study of ballets and their history [n]\n",
  "CHOREOLOGIST": "a student of choreology [n -S]\n",
  "CHOREOLOGISTS": "CHOREOLOGIST, a student of choreology [n]\n",
  "CHOREOLOGY": "the study of ballets and their history [n CHOREOLOGIES]\n",
  "CHOREPISCOPAL": "pertaining to a local or suffragan bishop of the early Church [adj]\n",
  "CHORES": "CHORE, to do small jobs [v]\n",
  "CHOREUS": "(Greek) a trochee, also CHOREE [n -ES]\n",
  "CHOREUSES": "CHOREUS, (Greek) a trochee, also CHOREE [n]\n",
  "CHORIA": "CHORION, (Greek) the outer foetal envelope [n]\n",
  "CHORIAL": "pertaining to an embryonic membrane [adj]\n",
  "CHORIAMB": "(Greek) a metrical foot comprising a trochee and an iambus, also CHORIAMBIC, CHORIAMBUS [n -S]\n",
  "CHORIAMBI": "CHORIAMBUS, a metrical foot comprising a trochee and an iambus, also CHORIAMB, CHORIAMBIC [n]\n",
  "CHORIAMBIC": "a metrical foot comprising a trochee and an iambus, also CHORIAMB, CHORIAMBUS [n -S]\n",
  "CHORIAMBICS": "CHORIAMBIC, a metrical foot comprising a trochee and an iambus, also CHORIAMB, CHORIAMBUS [n]\n",
  "CHORIAMBS": "CHORIAMB, (Greek) a metrical foot comprising a trochee and an iambus, also CHORIAMBIC, CHORIAMBUS [n]\n",
  "CHORIAMBUS": "a metrical foot comprising a trochee and an iambus, also CHORIAMB, CHORIAMBIC [n CHORIAMBI or CHORIAMBUSES]\n",
  "CHORIAMBUSES": "CHORIAMBUS, a metrical foot comprising a trochee and an iambus, also CHORIAMB, CHORIAMBIC [n]\n",
  "CHORIC": "pertaining to the chorus in ancient Greek tragedy [adj]\n",
  "CHORINE": "(US slang) a chorus girl [n -S]\n",
  "CHORINES": "CHORINE, (US slang) a chorus girl [n]\n",
  "CHORING": "CHORE, to do small jobs [v]\n",
  "CHORIOALLANTOIC": "of or like a chorioallantois, a highly vascularized fetal membrane [adj]\n",
  "CHORIOALLANTOIS": "a highly vascularized fetal membrane [n]\n",
  "CHORIOCARCINOMA": "a malignant tumor typically developing in the uterus from the trophoblast [n]\n",
  "CHORIOID": "of or resembling a chorion [adj] / the dark brown vascular coat of the eye, also CHOREOID, CHOROID [n -S]\n",
  "CHORIOIDS": "CHORIOID, the dark brown vascular coat of the eye, also CHOREOID, CHOROID [n]\n",
  "CHORION": "(Greek) the outer foetal envelope [n CHORIONS or CHORIA]\n",
  "CHORIONIC": "relating to the chorion, the outer foetal envelope [adj]\n",
  "CHORIONS": "CHORION, (Greek) the outer foetal envelope [n]\n",
  "CHORISATION": "the multiplication of parts etc. by splitting, also CHORIZATION [n -S]\n",
  "CHORISATIONS": "CHORISATION, the multiplication of parts etc. by splitting, also CHORIZATION [n]\n",
  "CHORISES": "CHORISIS, (Greek) the multiplication of organs by splitting, also CHORISM [n]\n",
  "CHORISIS": "(Greek) the multiplication of organs by splitting, also CHORISM [n CHORISES]\n",
  "CHORISM": "the multiplication of organs by splitting, also CHORISIS [n -S]\n",
  "CHORISMS": "CHORISM, the multiplication of organs by splitting, also CHORISIS [n]\n",
  "CHORIST": "a member of a choir [n -S]\n",
  "CHORISTER": "a member of a choir, also CHORALIST, CHORIST, QUIRISTER [n -S]\n",
  "CHORISTERS": "CHORISTER, a member of a choir, also CHORALIST, CHORIST, QUIRISTER [n]\n",
  "CHORISTS": "CHORIST, a member of a choir [n]\n",
  "CHORIZATION": "the multiplication of parts etc. by splitting, also CHORISATION [n -S]\n",
  "CHORIZATIONS": "CHORIZATION, the multiplication of parts etc. by splitting, also CHORISATION [n]\n",
  "CHORIZO": "(Spanish) a highly spiced sausage used in Spanish cooking [n -S]\n",
  "CHORIZONT": "a person who disputes identity of authorship, esp. one who ascribes the Iliad and Odyssey to different authors, also CHORIZONTIST [n -S]\n",
  "CHORIZONTIST": "a person who disputes identity of authorship, esp. one who ascribes the Iliad and Odyssey to different authors, also CHORIZONT [n -S]\n",
  "CHORIZONTISTS": "CHORIZONTIST, a person who disputes identity of authorship, esp. one who ascribes the Iliad and Odyssey to different authors, also CHORIZONT [n]\n",
  "CHORIZONTS": "CHORIZONT, a person who disputes identity of authorship, esp. one who ascribes the Iliad and Odyssey to different authors, also CHORIZONTIST [n]\n",
  "CHORIZOS": "CHORIZO, (Spanish) a highly spiced sausage used in Spanish cooking [n]\n",
  "CHOROGRAPHER": "one who maps or describes a region [n -S]\n",
  "CHOROGRAPHERS": "CHOROGRAPHER, one who maps or describes a region [n]\n",
  "CHOROGRAPHIC": "relating to chorography, the description and mapping of particular regions or districts, also CHOROGRAPHICAL [adj]\n",
  "CHOROGRAPHICAL": "relating to chorography, the description and mapping of particular regions or districts, also CHOROGRAPHIC [adj]\n",
  "CHOROGRAPHIES": "CHOROGRAPHY, the art of describing or mapping a region or district [n]\n",
  "CHOROGRAPHY": "the art of describing or mapping a region or district [n CHOROGRAPHIES]\n",
  "CHOROID": "the dark brown vascular coat of the eye, also CHOREOID, CHORIOID [n -S]\n",
  "CHOROIDAL": "pertaining to the choroid coat [adj]\n",
  "CHOROIDITIS": "inflammation of the choroid [n -ES]\n",
  "CHOROIDITISES": "CHOROIDITIS, inflammation of the choroid [n]\n",
  "CHOROIDS": "CHOROID, the dark brown vascular coat of the eye, also CHOREOID, CHORIOID [n]\n",
  "CHOROLOGICAL": "related to chorology [adj]\n",
  "CHOROLOGIES": "CHOROLOGY, the science or study of the geographical distribution of anything [n]\n",
  "CHOROLOGIST": "a student of chorology [n -S]\n",
  "CHOROLOGISTS": "CHOROLOGIST, a student of chorology [n]\n",
  "CHOROLOGY": "the science or study of the geographical distribution of anything [n CHOROLOGIES]\n",
  "CHOROPLETH": "a map using symbols (often a series of shadings) on geographic subdivisions to represent each subdivision's level in a range of values [n -S]\n",
  "CHOROPLETHS": "CHOROPLETH, a map using symbols (often a series of shadings) on geographic subdivisions to represent each subdivision's level in a range of values [n]\n",
  "CHORRIE": "(South African) a crock, a dilapidated car [n -S]\n",
  "CHORRIES": "CHORRIE, (South African) a crock, a dilapidated car [n]\n",
  "CHORTEN": "a Tibetan shrine [n -S]\n",
  "CHORTENS": "CHORTEN, a Tibetan shrine [n]\n",
  "CHORTLE": "to chuckle with glee [v CHORTLED, CHORTLING, CHORTLES]\n",
  "CHORTLED": "CHORTLE, to chuckle with glee [v]\n",
  "CHORTLER": "one who chortles [n -S]\n",
  "CHORTLERS": "CHORTLER, one who chortles [n]\n",
  "CHORTLES": "CHORTLE, to chuckle with glee [v]\n",
  "CHORTLING": "CHORTLE, to chuckle with glee [v]\n",
  "CHORUS": "to sing in unison [v CHORUSSED or CHORUSED, CHORUSSING or CHORUSING, CHORUSSES or CHORUSES]\n",
  "CHORUSED": "CHORUS, to sing in unison [v]\n",
  "CHORUSES": "CHORUS, to sing in unison [v]\n",
  "CHORUSING": "CHORUS, to sing in unison [v]\n",
  "CHORUSMASTER": "the conductor of a choir [n -S]\n",
  "CHORUSMASTERS": "CHORUSMASTER, the conductor of a choir [n]\n",
  "CHORUSSED": "CHORUS, to sing in unison [v]\n",
  "CHORUSSES": "CHORUS, to sing in unison [v]\n",
  "CHORUSSING": "CHORUS, to sing in unison [v]\n",
  "CHOSE": "(French) in law, a thing; a piece of personal property, a chattel [n -S]\n",
  "CHOSEN": "CHOOSE, to select by preference [v]\n",
  "CHOSES": "CHOSE, (French) in law, a thing; a piece of personal property, a chattel [n]\n",
  "CHOTA": "(Hindi) little, as in chota peg, a little drink [adj]\n",
  "CHOTT": "(Arabic) a shallow saline lake of northern Africa; the dried bed of such a lake, also SHOTT [n -S]\n",
  "CHOTTS": "CHOTT, (Arabic) a shallow saline lake of northern Africa; the dried bed of such a lake, also SHOTT [n]\n",
  "CHOU": "(French) a cabbage; an ornamental soft rosette; a cream bun [n CHOUX]\n",
  "CHOUCROUTE": "(French) pickled cabbage [n -S]\n",
  "CHOUCROUTES": "CHOUCROUTE, (French) pickled cabbage [n]\n",
  "CHOUGH": "a kind of jackdaw found in rocky places on the seacoast [n -S]\n",
  "CHOUGHS": "CHOUGH, a kind of jackdaw found in rocky places on the seacoast [n]\n",
  "CHOULTRIES": "CHOULTRY, (Malayalam) a shed used for assembly, also CHOLTRY [n]\n",
  "CHOULTRY": "(Malayalam) a shed used for assembly, also CHOLTRY [n CHOULTRIES]\n",
  "CHOUNTER": "to mutter, grumble, also CHUNNER, CHUNTER [v -ED, -ING, -S]\n",
  "CHOUNTERED": "CHOUNTER, to mutter, grumble, also CHUNNER, CHUNTER [v]\n",
  "CHOUNTERING": "CHOUNTER, to mutter, grumble, also CHUNNER, CHUNTER [v]\n",
  "CHOUNTERS": "CHOUNTER, to mutter, grumble, also CHUNNER, CHUNTER [v]\n",
  "CHOUSE": "to swindle, also CHOWSE [v CHOUSED, CHOUSING, CHOUSES]\n",
  "CHOUSED": "CHOUSE, to swindle, also CHOWSE [v]\n",
  "CHOUSER": "a swindler [n -S]\n",
  "CHOUSERS": "CHOUSER, a swindler [n]\n",
  "CHOUSES": "CHOUSE, to swindle, also CHOWSE [v]\n",
  "CHOUSH": "a cheat, a swindler, also CHIAUS, CHOUSE, CHOWSE [n -ES]\n",
  "CHOUSHES": "CHOUSH, a cheat, a swindler, also CHIAUS, CHOUSE, CHOWSE [n]\n",
  "CHOUSING": "CHOUSE, to swindle, also CHOWSE [v]\n",
  "CHOUT": "(Hindi) in India, an assessment equal to a fourth part of the revenue, extracted by the Mahrattas as blackmail [n -S]\n",
  "CHOUTS": "CHOUT, (Hindi) in India, an assessment equal to a fourth part of the revenue, extracted by the Mahrattas as blackmail [n]\n",
  "CHOUX": "CHOU, (French) a cabbage; an ornamental soft rosette; a cream bun [n]\n",
  "CHOW": "to eat [v -ED, -ING, -S]\n",
  "CHOWCHOW": "a relish of mixed pickles in mustard [n -S]\n",
  "CHOWCHOWS": "CHOWCHOW, a relish of mixed pickles in mustard [n]\n",
  "CHOWDER": "to make a thick soup [v -ED, -ING, -S]\n",
  "CHOWDERED": "CHOWDER, to make a thick soup [v]\n",
  "CHOWDERHEAD": "a foolish person [n -S]\n",
  "CHOWDERHEADED": "like a chowderhead, foolish, simple [adj]\n",
  "CHOWDERHEADS": "CHOWDERHEAD, a foolish person [n]\n",
  "CHOWDERING": "CHOWDER, to make a thick soup [v]\n",
  "CHOWDERS": "CHOWDER, to make a thick soup [v]\n",
  "CHOWDOWN": "the act of eating a large quantity of food, esp. for competitive purposes [n -S]\n",
  "CHOWDOWNS": "CHOWDOWN, the act of eating a large quantity of food, esp. for competitive purposes [n]\n",
  "CHOWED": "CHOW, to eat [v]\n",
  "CHOWHOUND": "one fond of eating [n -S]\n",
  "CHOWHOUNDS": "CHOWHOUND, one fond of eating [n]\n",
  "CHOWING": "CHOW, to eat [v]\n",
  "CHOWK": "(Hindi) a marketplace [n -S]\n",
  "CHOWKIDAR": "(Urdu) a watchman, also CHOKIDAR [n -S]\n",
  "CHOWKIDARS": "CHOWKIDAR, (Urdu) a watchman, also CHOKIDAR [n]\n",
  "CHOWKS": "CHOWK, (Hindi) a marketplace [n]\n",
  "CHOWRI": "(Hindi) a whisk to keep off flies, used in the East Indies, also CHOWRY [n -S]\n",
  "CHOWRIES": "CHOWRY, (Hindi) a whisk to keep off flies, used in the East Indies, also CHOWRI [n]\n",
  "CHOWRIS": "CHOWRI, (Hindi) a whisk to keep off flies, used in the East Indies, also CHOWRY [n]\n",
  "CHOWRY": "(Hindi) a whisk to keep off flies, used in the East Indies, also CHOWRI [n CHOWRIES]\n",
  "CHOWS": "CHOW, to eat [v]\n",
  "CHOWSE": "to swindle, also CHOUSE [v CHOWSED, CHOWSING, CHOWSES]\n",
  "CHOWSED": "CHOWSE, to swindle, also CHOUSE [v]\n",
  "CHOWSES": "CHOWSE, to swindle, also CHOUSE [v]\n",
  "CHOWSING": "CHOWSE, to swindle, also CHOUSE [v]\n",
  "CHOWTIME": "mealtime [n -S]\n",
  "CHOWTIMES": "CHOWTIME, mealtime [n]\n",
  "CHREMATIST": "a political economist [n -S]\n",
  "CHREMATISTIC": "pertaining to business or the pursuit of wealth [adj]\n",
  "CHREMATISTICS": "the study of wealth; the science of political economy [n]\n",
  "CHREMATISTS": "CHREMATIST, a political economist [n]\n",
  "CHRESARD": "the total quantity of water in the soil available to plants [n -S]\n",
  "CHRESARDS": "CHRESARD, the total quantity of water in the soil available to plants [n]\n",
  "CHRESTOMATHIC": "of or like a chrestomathy, a selection of passages compiled as an aid to learning a language, also CHRESTOMATHICAL [adj]\n",
  "CHRESTOMATHICAL": "of or like a chrestomathy, a selection of passages compiled as an aid to learning a language, also CHRESTOMATHIC [adj]\n",
  "CHRESTOMATHIES": "CHRESTOMATHY, a selection of passages compiled as an aid to learning a language; a volume of selected passages or stories of an author [n]\n",
  "CHRESTOMATHY": "a selection of passages compiled as an aid to learning a language; a volume of selected passages or stories of an author [n CHRESTOMATHIES]\n",
  "CHRISM": "a consecrated oil, also CHRISOM [n -S]\n",
  "CHRISMA": "CHRISMON, (Greek) a Christian monogram [n]\n",
  "CHRISMAL": "a veil used in christening; a vessel for holding the chrism [n -S]\n",
  "CHRISMALS": "CHRISMAL, a veil used in christening; a vessel for holding the chrism [n]\n",
  "CHRISMATION": "the sacrament of baptism in Eastern churches [n -S]\n",
  "CHRISMATIONS": "CHRISMATION, the sacrament of baptism in Eastern churches [n]\n",
  "CHRISMATORIES": "CHRISMATORY, a vessel for holding holy oil [n]\n",
  "CHRISMATORY": "a vessel for holding holy oil [n CHRISMATORIES]\n",
  "CHRISMON": "(Greek) a Christian monogram [n CHRISMONS or CHRISMA]\n",
  "CHRISMONS": "CHRISMON, (Greek) a Christian monogram [n]\n",
  "CHRISMS": "CHRISM, a consecrated oil, also CHRISOM [n]\n",
  "CHRISOM": "a white robe put on a newly baptised child, also CHRISTOM [n -S]\n",
  "CHRISOMS": "CHRISOM, a white robe put on a newly baptised child, also CHRISTOM [n]\n",
  "CHRISTCROSS": "the mark of a cross formerly placed in front of the alphabet in hornbooks; a cross used in place of a signature by someone unable to sign his name [n -ES]\n",
  "CHRISTCROSSES": "CHRISTCROSS, the mark of a cross formerly placed in front of the alphabet in hornbooks; a cross used in place of a signature by someone unable to sign his name [n]\n",
  "CHRISTEN": "to baptise [v -ED, -ING, -S]\n",
  "CHRISTENED": "CHRISTEN, to baptise [v]\n",
  "CHRISTENER": "one who christens [n -S]\n",
  "CHRISTENERS": "CHRISTENER, one who christens [n]\n",
  "CHRISTENING": "a baptism [n -S]\n",
  "CHRISTENINGS": "CHRISTENING, a baptism [n]\n",
  "CHRISTENS": "CHRISTEN, to baptise [v]\n",
  "CHRISTIAN": "exhibiting kindness or goodness [adj]\n",
  "CHRISTIANIA": "a kind of turn in skiing, also CHRISTIE, CHRISTY [n -S]\n",
  "CHRISTIANIAS": "CHRISTIANIA, a kind of turn in skiing, also CHRISTIE, CHRISTY [n]\n",
  "CHRISTIE": "a kind of turn in skiing, also CHRISTIANIA, CHRISTY [n -S]\n",
  "CHRISTIES": "CHRISTY, a kind of turn in skiing, also CHRISTIANIA, CHRISTIE [n]\n",
  "CHRISTOM": "a white robe put on a newly baptised child, also CHRISOM [n -S]\n",
  "CHRISTOMS": "CHRISTOM, a white robe put on a newly baptised child, also CHRISOM [n]\n",
  "CHRISTOPHANIES": "CHRISTOPHANY, an appearance of Christ to men [n]\n",
  "CHRISTOPHANY": "an appearance of Christ to men [n CHRISTOPHANIES]\n",
  "CHRISTY": "a kind of turn in skiing, also CHRISTIANIA, CHRISTIE [n CHRISTIES]\n",
  "CHROMA": "(Greek) quality of colour [n -S]\n",
  "CHROMAFFIN": "staining deeply with chromium salts [adj]\n",
  "CHROMAKEY": "a special television effect by which a coloured background can be removed from a picture and a different one substituted [n -S]\n",
  "CHROMAKEYS": "CHROMAKEY, a special television effect by which a coloured background can be removed from a picture and a different one substituted [n]\n",
  "CHROMAS": "CHROMA, (Greek) quality of colour [n]\n",
  "CHROMATE": "a compound of chromium [n -S]\n",
  "CHROMATES": "CHROMATE, a compound of chromium [n]\n",
  "CHROMATIC": "relating to colour [adj CHROMATICALLY] / a chromatic note [n -S]\n",
  "CHROMATICALLY": "CHROMATIC, relating to colour [adv]\n",
  "CHROMATICISM": "the state of being chromatic; the use of chromatic tones [n -S]\n",
  "CHROMATICISMS": "CHROMATICISM, the state of being chromatic; the use of chromatic tones [n]\n",
  "CHROMATICITIES": "CHROMATICITY, the quality of color characterized by its dominant or complementary wavelength and purity taken together [n]\n",
  "CHROMATICITY": "the quality of color characterized by its dominant or complementary wavelength and purity taken together [n CHROMATICITIES]\n",
  "CHROMATICNESS": "the state of being chromatic [n -ES]\n",
  "CHROMATICNESSES": "CHROMATICNESS, the state of being chromatic [n]\n",
  "CHROMATICS": "the science of colors; that part of optics which treats of the properties of colors [n]\n",
  "CHROMATID": "one of the two threadlike structures formed by the longitudinal division of a chromosome [n -S]\n",
  "CHROMATIDS": "CHROMATID, one of the two threadlike structures formed by the longitudinal division of a chromosome [n]\n",
  "CHROMATIN": "a protein/DNA complex making the chromosome [n -S]\n",
  "CHROMATINIC": "relating to chromatin [adj]\n",
  "CHROMATINS": "CHROMATIN, a protein/DNA complex making the chromosome [n]\n",
  "CHROMATIST": "one who studies chromatics, the science of color [n -S]\n",
  "CHROMATISTS": "CHROMATIST, one who studies chromatics, the science of color [n]\n",
  "CHROMATOGRAM": "a visible record of the result of a chromatographic separation [n -S]\n",
  "CHROMATOGRAMS": "CHROMATOGRAM, a visible record of the result of a chromatographic separation [n]\n",
  "CHROMATOGRAPH": "an instrument for performing chromatographic separations [n -S] / to do by chromatograph [v -ED, -S]\n",
  "CHROMATOGRAPHED": "CHROMATOGRAPH, to do by chromatograph [v]\n",
  "CHROMATOGRAPHER": "one who uses a chromatograph [n]\n",
  "CHROMATOGRAPHIC": "relating to chromatography [adj]\n",
  "CHROMATOGRAPHS": "CHROMATOGRAPH, to do by chromatograph [v]\n",
  "CHROMATOGRAPHY": "a process in which a chemical mixture carried by a liquid or gas is separated into components as a result of differential distribution of the solutes as they flow around or over a stationary liquid or solid phase [n]\n",
  "CHROMATOID": "relating to chromatin, a protein/DNA complex making the chromosome [adj]\n",
  "CHROMATOLOGIES": "CHROMATOLOGY, the science of colour [n]\n",
  "CHROMATOLOGIST": "a specialist in chromatology [n -S]\n",
  "CHROMATOLOGISTS": "CHROMATOLOGIST, a specialist in chromatology [n]\n",
  "CHROMATOLOGY": "the science of colour [n CHROMATOLOGIES]\n",
  "CHROMATOLYSES": "CHROMATOLYSIS, the dissolution and breaking up of chromophil material (as chromatin) of a cell and esp. a nerve cell [n]\n",
  "CHROMATOLYSIS": "the dissolution and breaking up of chromophil material (as chromatin) of a cell and esp. a nerve cell [n CHROMATOLYSES]\n",
  "CHROMATOLYTIC": "relating to chromatolysis [adj]\n",
  "CHROMATOPHORE": "a pigment-bearing cell [n -S]\n",
  "CHROMATOPHORES": "CHROMATOPHORE, a pigment-bearing cell [n]\n",
  "CHROMATOPHORIC": "of or like a chromatophore, a pigment-bearing cell [adj]\n",
  "CHROMATOPHOROUS": "of or like a chromatophore, a pigment-bearing cell [adj]\n",
  "CHROMATOPSIA": "coloured vision [n -S]\n",
  "CHROMATOPSIAS": "CHROMATOPSIA, coloured vision [n]\n",
  "CHROMATOSPHERE": "a layer of incandescent gas surrounding the sun through which the light of the photosphere passes [n -S]\n",
  "CHROMATOSPHERES": "CHROMATOSPHERE, a layer of incandescent gas surrounding the sun through which the light of the photosphere passes [n]\n",
  "CHROMATYPE": "a colored photographic picture taken upon paper made sensitive with potassium bichromate or some other salt of chromium [n -S]\n",
  "CHROMATYPES": "CHROMATYPE, a colored photographic picture taken upon paper made sensitive with potassium bichromate or some other salt of chromium [n]\n",
  "CHROME": "to plate with chromium [v CHROMED, CHROMING, CHROMES]\n",
  "CHROMED": "CHROME, to plate with chromium [v]\n",
  "CHROMEL": "an alloy of nickel and chromium [n -S]\n",
  "CHROMELS": "CHROMEL, an alloy of nickel and chromium [n]\n",
  "CHROMENE": "a chemical compound produced by certain plants that acts as an insecticide [n -S]\n",
  "CHROMENES": "CHROMENE, a chemical compound produced by certain plants that acts as an insecticide [n]\n",
  "CHROMES": "CHROME, to plate with chromium [v]\n",
  "CHROMIC": "pertaining to, or obtained from, chromium [adj]\n",
  "CHROMIDE": "a tropical freshwater fish of South India [n -S]\n",
  "CHROMIDES": "CHROMIDE, a tropical freshwater fish of South India [n]\n",
  "CHROMIDIA": "CHROMIDIUM, an algal cell in a lichen [n]\n",
  "CHROMIDIUM": "an algal cell in a lichen [n CHROMIDIA]\n",
  "CHROMIER": "CHROMY, decorated with chrome [adj]\n",
  "CHROMIEST": "CHROMY, decorated with chrome [adj]\n",
  "CHROMINANCE": "the difference between a color and a chosen reference color of the same luminous intensity in color television [n -S]\n",
  "CHROMINANCES": "CHROMINANCE, the difference between a color and a chosen reference color of the same luminous intensity in color television [n]\n",
  "CHROMING": "the act of plating with chromium [n -S]\n",
  "CHROMINGS": "CHROMING, the act of plating with chromium [n]\n",
  "CHROMISE": "to chrome, also CHROMIZE [v CHROMISED, CHROMISING, CHROMISES]\n",
  "CHROMISED": "CHROMISE, to chrome, also CHROMIZE [v]\n",
  "CHROMISES": "CHROMISE, to chrome, also CHROMIZE [v]\n",
  "CHROMISING": "CHROMISE, to chrome, also CHROMIZE [v]\n",
  "CHROMITE": "a black sub-metallic mineral consisting of oxide of chromium and iron [n -S]\n",
  "CHROMITES": "CHROMITE, a black sub-metallic mineral consisting of oxide of chromium and iron [n]\n",
  "CHROMIUM": "a metallic element [n -S]\n",
  "CHROMIUMS": "CHROMIUM, a metallic element [n]\n",
  "CHROMIZE": "to chrome, also CHROMISE [v CHROMIZED, CHROMIZING, CHROMIZES]\n",
  "CHROMIZED": "CHROMIZE, to chrome, also CHROMISE [v]\n",
  "CHROMIZES": "CHROMIZE, to chrome, also CHROMISE [v]\n",
  "CHROMIZING": "CHROMIZE, to chrome, also CHROMISE [v]\n",
  "CHROMO": "(short for) a chromolithograph [n -S]\n",
  "CHROMOCENTER": "a densely staining aggregation of heterochromatic regions in the nucleus of some cells, also CHROMOCENTRE [n -S]\n",
  "CHROMOCENTERS": "CHROMOCENTER, a densely staining aggregation of heterochromatic regions in the nucleus of some cells, also CHROMOCENTRE [n]\n",
  "CHROMOCENTRE": "a densely staining aggregation of heterochromatic regions in the nucleus of some cells, also CHROMOCENTER [n -S]\n",
  "CHROMOCENTRES": "CHROMOCENTRE, a densely staining aggregation of heterochromatic regions in the nucleus of some cells, also CHROMOCENTER [n]\n",
  "CHROMODYNAMICS": "strong interaction, color, and exchange of gluons [n]\n",
  "CHROMOGEN": "a substance which can be converted to a dyestuff by the introduction of a polar group [n -S]\n",
  "CHROMOGENIC": "of or relating to a chromogen [adj]\n",
  "CHROMOGENS": "CHROMOGEN, a substance which can be converted to a dyestuff by the introduction of a polar group [n]\n",
  "CHROMOGRAM": "a combination of photographs in different colours [n -S]\n",
  "CHROMOGRAMS": "CHROMOGRAM, a combination of photographs in different colours [n]\n",
  "CHROMOLIES": "CHROMOLY, a steel alloy of chromium and molybdenum [n]\n",
  "CHROMOLY": "a steel alloy of chromium and molybdenum [n CHROMOLIES or CHROMOLYS]\n",
  "CHROMOLYS": "CHROMOLY, a steel alloy of chromium and molybdenum [n]\n",
  "CHROMOMERE": "one of the characteristic granules of chromatin that appear on a chromosome during meiosis [n -S]\n",
  "CHROMOMERES": "CHROMOMERE, one of the characteristic granules of chromatin that appear on a chromosome during meiosis [n]\n",
  "CHROMOMERIC": "relating to a chromomere [adj]\n",
  "CHROMONEMA": "the coiled filamentous core of a chromatid [n CHROMONEMATA]\n",
  "CHROMONEMAL": "relating to a chromonema, also CHROMONEMIC [adj]\n",
  "CHROMONEMATA": "CHROMONEMA, the coiled filamentous core of a chromatid [n]\n",
  "CHROMONEMATIC": "of or like a chromonema [adj]\n",
  "CHROMONEMIC": "relating to a chromonema, also CHROMONEMAL [adj]\n",
  "CHROMOPHIL": "a cell that takes a stain easily, also CHROMOPHILIC [n -S]\n",
  "CHROMOPHILIC": "staining heavily in certain microscopic techniques, also CHROMOPHIL [adj]\n",
  "CHROMOPHILS": "CHROMOPHIL, a cell that takes a stain easily, also CHROMOPHILIC [n]\n",
  "CHROMOPHOBE": "a cell that does not take a stain easily [n -S]\n",
  "CHROMOPHOBES": "CHROMOPHOBE, a cell that does not take a stain easily [n]\n",
  "CHROMOPHORE": "the group of atoms in a chemical compound responsible for its colour [n -S]\n",
  "CHROMOPHORES": "CHROMOPHORE, the group of atoms in a chemical compound responsible for its colour [n]\n",
  "CHROMOPHORIC": "of or like a chromophore, the group of atoms in a chemical compound responsible for its colour, also CHROMOPHOROUS [adj]\n",
  "CHROMOPHOROUS": "of or like a chromophore, the group of atoms in a chemical compound responsible for its colour, also CHROMOPHORIC [adj]\n",
  "CHROMOPLAST": "a colored plastid usually containing red or yellow pigment, such as carotene [n -S]\n",
  "CHROMOPLASTS": "CHROMOPLAST, a colored plastid usually containing red or yellow pigment, such as carotene [n]\n",
  "CHROMOPROTEIN": "any of various proteins (as hemoglobins, carotenoids, or flavoproteins) having a pigment as a prosthetic group [n -S]\n",
  "CHROMOPROTEINS": "CHROMOPROTEIN, any of various proteins (as hemoglobins, carotenoids, or flavoproteins) having a pigment as a prosthetic group [n]\n",
  "CHROMOS": "CHROMO, (short for) a chromolithograph [n]\n",
  "CHROMOSCOPE": "an apparatus for combining coloured images [n -S]\n",
  "CHROMOSCOPES": "CHROMOSCOPE, an apparatus for combining coloured images [n]\n",
  "CHROMOSOMAL": "relating to a chromosome [adj CHROMOSOMALLY]\n",
  "CHROMOSOMALLY": "CHROMOSOMAL, relating to a chromosome [adv]\n",
  "CHROMOSOME": "a threadlike body containing the genetic material in the cell nucleus [n -S]\n",
  "CHROMOSOMES": "CHROMOSOME, a threadlike body containing the genetic material in the cell nucleus [n]\n",
  "CHROMOSPHERE": "the region of the atmosphere of a star between the star's photosphere and its corona [n -S]\n",
  "CHROMOSPHERES": "CHROMOSPHERE, the region of the atmosphere of a star between the star's photosphere and its corona [n]\n",
  "CHROMOSPHERIC": "relating to the chromosphere [adj]\n",
  "CHROMOTHERAPIES": "CHROMOTHERAPY, colour therapy using red, green and violet as three primary colours [n]\n",
  "CHROMOTHERAPY": "colour therapy using red, green and violet as three primary colours [n CHROMOTHERAPIES]\n",
  "CHROMOTYPE": "a sheet printed in colors by any process, as a chromolithograph [n -S]\n",
  "CHROMOTYPES": "CHROMOTYPE, a sheet printed in colors by any process, as a chromolithograph [n]\n",
  "CHROMOUS": "of chromium in lower valence [adj]\n",
  "CHROMOXYLOGRAPH": "a picture printed in colours from wooden blocks [n]\n",
  "CHROMY": "decorated with chrome [adj CHROMIER, CHROMIEST]\n",
  "CHROMYL": "a bivalent radical [n -S]\n",
  "CHROMYLS": "CHROMYL, a bivalent radical [n]\n",
  "CHRONAXIE": "a time constant in the excitation of a nerve or muscle, also CHRONAXY [n -S]\n",
  "CHRONAXIES": "CHRONAXY, a time constant in the excitation of a nerve or muscle, also CHRONAXIE [n]\n",
  "CHRONAXY": "a time constant in the excitation of a nerve or muscle, also CHRONAXIE [n CHRONAXIES]\n",
  "CHRONIC": "long-lasting [adj CHRONICALLY] / a chronic invalid [n -S]\n",
  "CHRONICAL": "chronic, long-lasting [adj CHRONICALLY]\n",
  "CHRONICALLY": "CHRONICAL, chronic, long-lasting [adv]\n",
  "CHRONICITIES": "CHRONICITY, the quality of being chronic [n]\n",
  "CHRONICITY": "the quality of being chronic [n CHRONICITIES]\n",
  "CHRONICLE": "a record of events [n -S] / to record as a chronicle [v CHRONICLED, CHRONICLING, CHRONICLES]\n",
  "CHRONICLED": "CHRONICLE, to record as a chronicle [v]\n",
  "CHRONICLER": "one who composes a chronicle [n -S]\n",
  "CHRONICLERS": "CHRONICLER, one who composes a chronicle [n]\n",
  "CHRONICLES": "CHRONICLE, to record as a chronicle [v]\n",
  "CHRONICLING": "CHRONICLE, to record as a chronicle [v]\n",
  "CHRONICS": "CHRONIC, a chronic invalid [n]\n",
  "CHRONOBIOLOGIC": "relating to chronobiology [adj]\n",
  "CHRONOBIOLOGIES": "CHRONOBIOLOGY, the study of biological rhythms [n]\n",
  "CHRONOBIOLOGIST": "a student of chronobiology [n]\n",
  "CHRONOBIOLOGY": "the study of biological rhythms [n CHRONOBIOLOGIES]\n",
  "CHRONOGRAM": "an inscription whose letters form a Roman numeral date [n -S]\n",
  "CHRONOGRAMMATIC": "of or like a chronogram, an inscription whose letters form a Roman numeral date [adj]\n",
  "CHRONOGRAMS": "CHRONOGRAM, an inscription whose letters form a Roman numeral date [n]\n",
  "CHRONOGRAPH": "an instrument for recording the moment of an event [n -S]\n",
  "CHRONOGRAPHER": "a chronicler [n -S]\n",
  "CHRONOGRAPHERS": "CHRONOGRAPHER, a chronicler [n]\n",
  "CHRONOGRAPHIC": "relating to a chronograph, an instrument for recording the moment of an event [adj]\n",
  "CHRONOGRAPHIES": "CHRONOGRAPHY, chronology [n]\n",
  "CHRONOGRAPHS": "CHRONOGRAPH, an instrument for recording the moment of an event [n]\n",
  "CHRONOGRAPHY": "chronology [n CHRONOGRAPHIES]\n",
  "CHRONOLOGER": "an expert in chronology, also CHRONOLOGIST [n -S]\n",
  "CHRONOLOGERS": "CHRONOLOGER, an expert in chronology, also CHRONOLOGIST [n]\n",
  "CHRONOLOGIC": "arranged in order of time, also CHRONOLOGICAL [adj CHRONOLOGICALLY]\n",
  "CHRONOLOGICAL": "arranged in order of time, also CHRONOLOGIC [adj CHRONOLOGICALLY]\n",
  "CHRONOLOGICALLY": "CHRONOLOGICAL, arranged in order of time, also CHRONOLOGIC [adv]\n",
  "CHRONOLOGIES": "CHRONOLOGY, the science that deals with measuring time by regular divisions and that assigns to events their proper dates [n]\n",
  "CHRONOLOGISE": "to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGIZE [v CHRONOLOGISED, CHRONOLOGISING, CHRONOLOGISES]\n",
  "CHRONOLOGISED": "CHRONOLOGISE, to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGIZE [v]\n",
  "CHRONOLOGISES": "CHRONOLOGISE, to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGIZE [v]\n",
  "CHRONOLOGISING": "CHRONOLOGISE, to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGIZE [v]\n",
  "CHRONOLOGIST": "an expert in chronology, also CHRONOLOGER [n -S]\n",
  "CHRONOLOGISTS": "CHRONOLOGIST, an expert in chronology, also CHRONOLOGER [n]\n",
  "CHRONOLOGIZE": "to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGISE [v CHRONOLOGIZED, CHRONOLOGIZING, CHRONOLOGIZES]\n",
  "CHRONOLOGIZED": "CHRONOLOGIZE, to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGISE [v]\n",
  "CHRONOLOGIZES": "CHRONOLOGIZE, to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGISE [v]\n",
  "CHRONOLOGIZING": "CHRONOLOGIZE, to arrange in chronological order or establish the order in time of events, etc., also CHRONOLOGISE [v]\n",
  "CHRONOLOGY": "the science that deals with measuring time by regular divisions and that assigns to events their proper dates [n CHRONOLOGIES]\n",
  "CHRONOMETER": "an instrument for measuring time [n -S]\n",
  "CHRONOMETERS": "CHRONOMETER, an instrument for measuring time [n]\n",
  "CHRONOMETRIC": "relating to chronometry, also CHRONOMETRICAL [adj]\n",
  "CHRONOMETRICAL": "relating to chronometry, also CHRONOMETRIC [adj]\n",
  "CHRONOMETRIES": "CHRONOMETRY, the measuring of time [n]\n",
  "CHRONOMETRY": "the measuring of time [n CHRONOMETRIES]\n",
  "CHRONON": "a unit of time, that required for a photon to travel the diameter of an electron [n -S]\n",
  "CHRONONS": "CHRONON, a unit of time, that required for a photon to travel the diameter of an electron [n]\n",
  "CHRONOSCOPE": "an instrument for measuring very short time intervals [n -S]\n",
  "CHRONOSCOPES": "CHRONOSCOPE, an instrument for measuring very short time intervals [n]\n",
  "CHRONOSCOPIC": "of or like a chronoscope, an instrument for measuring very short time intervals [adj]\n",
  "CHRONOTHERAPIES": "CHRONOTHERAPY, a treatment that work in harmony with the body's natural time rhythms [n]\n",
  "CHRONOTHERAPY": "a treatment that work in harmony with the body's natural time rhythms [n CHRONOTHERAPIES]\n",
  "CHRONOTRON": "a device for measuring very small time intervals [n -S]\n",
  "CHRONOTRONS": "CHRONOTRON, a device for measuring very small time intervals [n]\n",
  "CHRYSALID": "a pupa, esp. of a moth or butterfly, enclosed in a firm case or cocoon, also CHRYSALIS [n -S]\n",
  "CHRYSALIDAL": "like a chrysalid [adj]\n",
  "CHRYSALIDES": "CHRYSALIS, a pupa, esp. of a moth or butterfly, enclosed in a firm case or cocoon, also CHRYSALID [n]\n",
  "CHRYSALIDS": "CHRYSALID, a pupa, esp. of a moth or butterfly, enclosed in a firm case or cocoon, also CHRYSALIS [n]\n",
  "CHRYSALIS": "a pupa, esp. of a moth or butterfly, enclosed in a firm case or cocoon, also CHRYSALID [n CHRYSALISES or CHRYSALIDES]\n",
  "CHRYSALISES": "CHRYSALIS, a pupa, esp. of a moth or butterfly, enclosed in a firm case or cocoon, also CHRYSALID [n]\n",
  "CHRYSANTH": "(colloquial) a chrysanthemum [n -S]\n",
  "CHRYSANTHEMUM": "any of several cultivated plants of the Chrysanthemum genus, with colourful double flower-heads [n -S]\n",
  "CHRYSANTHEMUMS": "CHRYSANTHEMUM, any of several cultivated plants of the Chrysanthemum genus, with colourful double flower-heads [n]\n",
  "CHRYSANTHS": "CHRYSANTH, (colloquial) a chrysanthemum [n]\n",
  "CHRYSAROBIN": "goa powder, a bitter yellow powder obtained from a Brazilian tree, used as a purgative and in the treatment of skin disease [n -S]\n",
  "CHRYSAROBINS": "CHRYSAROBIN, goa powder, a bitter yellow powder obtained from a Brazilian tree, used as a purgative and in the treatment of skin disease [n]\n",
  "CHRYSOBERYL": "a mineral, beryllium aluminate, of a greenish-yellow or gold colour [n -S]\n",
  "CHRYSOBERYLS": "CHRYSOBERYL, a mineral, beryllium aluminate, of a greenish-yellow or gold colour [n]\n",
  "CHRYSOCOLLA": "a hydrated silicate of copper usually occurring as green opaline crusts and masses [n -S]\n",
  "CHRYSOCOLLAS": "CHRYSOCOLLA, a hydrated silicate of copper usually occurring as green opaline crusts and masses [n]\n",
  "CHRYSOCRACIES": "CHRYSOCRACY, the rule of wealth; plutocracy [n]\n",
  "CHRYSOCRACY": "the rule of wealth; plutocracy [n CHRYSOCRACIES]\n",
  "CHRYSOLITE": "a yellow variety of olivine [n -S]\n",
  "CHRYSOLITES": "CHRYSOLITE, a yellow variety of olivine [n]\n",
  "CHRYSOLITIC": "like chrysolite [adj]\n",
  "CHRYSOMELID": "a member of the leaf-beetle family [n -S]\n",
  "CHRYSOMELIDS": "CHRYSOMELID, a member of the leaf-beetle family [n]\n",
  "CHRYSOPHAN": "an old name for chrysarobin [n -S]\n",
  "CHRYSOPHANS": "CHRYSOPHAN, an old name for chrysarobin [n]\n",
  "CHRYSOPHILITE": "a lover of gold [n -S]\n",
  "CHRYSOPHILITES": "CHRYSOPHILITE, a lover of gold [n]\n",
  "CHRYSOPHYTE": "a type of golden-brown alga [n -S]\n",
  "CHRYSOPHYTES": "CHRYSOPHYTE, a type of golden-brown alga [n]\n",
  "CHRYSOPRASE": "a green variety of chalcedony used as a gem [n -S]\n",
  "CHRYSOPRASES": "CHRYSOPRASE, a green variety of chalcedony used as a gem [n]\n",
  "CHRYSOTILE": "an asbestiform variety of serpentine [n -S]\n",
  "CHRYSOTILES": "CHRYSOTILE, an asbestiform variety of serpentine [n]\n",
  "CHTHONIAN": "pertaining to the earth or the underworld, also CHTHONIC [adj]\n",
  "CHTHONIC": "(Greek) pertaining to the earth or the underworld, also CHTHONIAN [adj]\n",
  "CHUB": "a species of freshwater fish of the Cyprinidae or Carp family, aka cheven [n -S]\n",
  "CHUBASCO": "a violent thunderstorm [n -S]\n",
  "CHUBASCOS": "CHUBASCO, a violent thunderstorm [n]\n",
  "CHUBBIER": "CHUBBY, plump, short, and thick [adj]\n",
  "CHUBBIEST": "CHUBBY, plump, short, and thick [adj]\n",
  "CHUBBILY": "CHUBBY, plump, short, and thick [adv]\n",
  "CHUBBINESS": "the state of being chubby [n -ES]\n",
  "CHUBBINESSES": "CHUBBINESS, the state of being chubby [n]\n",
  "CHUBBY": "plump, short, and thick [adj CHUBBIER, CHUBBIEST, CHUBBILY]\n",
  "CHUBS": "CHUB, a species of freshwater fish of the Cyprinidae or Carp family, aka cheven [n]\n",
  "CHUCK": "to throw [v -ED, -ING, -S]\n",
  "CHUCKAWALLA": "(Spanish) an iguanid lizard of Mexico and the southwestern US, also CHUCKWALLA [n -S]\n",
  "CHUCKAWALLAS": "CHUCKAWALLA, (Spanish) an iguanid lizard of Mexico and the southwestern US, also CHUCKWALLA [n]\n",
  "CHUCKED": "CHUCK, to throw [v]\n",
  "CHUCKER": "a bowler whose arm action is illegal [n -S]\n",
  "CHUCKERS": "CHUCKER, a bowler whose arm action is illegal [n]\n",
  "CHUCKHOLE": "(US) a hole or rut in the road [n -S]\n",
  "CHUCKHOLES": "CHUCKHOLE, (US) a hole or rut in the road [n]\n",
  "CHUCKIE": "a chicken, also CHOOK, CHOOKIE, CHUCKY [n -S]\n",
  "CHUCKIES": "CHUCKIE, a chicken, also CHOOK, CHOOKIE, CHUCKY [n]\n",
  "CHUCKING": "CHUCK, to throw [v]\n",
  "CHUCKLE": "to laugh quietly [v CHUCKLED, CHUCKLING, CHUCKLES]\n",
  "CHUCKLED": "CHUCKLE, to laugh quietly [v]\n",
  "CHUCKLEHEAD": "a foolish person [n -S]\n",
  "CHUCKLEHEADED": "of or like a chucklehead, foolish [adj]\n",
  "CHUCKLEHEADS": "CHUCKLEHEAD, a foolish person [n]\n",
  "CHUCKLER": "one who chuckles [n -S]\n",
  "CHUCKLERS": "CHUCKLER, one who chuckles [n]\n",
  "CHUCKLES": "CHUCKLE, to laugh quietly [v]\n",
  "CHUCKLESOME": "full of chuckles [adj]\n",
  "CHUCKLING": "laughing quietly [adj CHUCKLINGLY] / the act of chuckling [n -S]\n",
  "CHUCKLINGLY": "CHUCKLING, laughing quietly [adv]\n",
  "CHUCKLINGS": "CHUCKLING, the act of chuckling [n]\n",
  "CHUCKS": "CHUCK, to throw [v]\n",
  "CHUCKWALLA": "(Spanish) an iguanid lizard of Mexico and the southwestern US, also CHUCKAWALLA [n -S]\n",
  "CHUCKWALLAS": "CHUCKWALLA, (Spanish) an iguanid lizard of Mexico and the southwestern US, also CHUCKAWALLA [n]\n",
  "CHUCKY": "a chicken, also CHOOK, CHOOKIE, CHUCKIE [n CHUCKIES]\n",
  "CHUDDAH": "(Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHADOR, CHUDDAR, CHUDDER [n -S]\n",
  "CHUDDAHS": "CHUDDAH, (Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHADOR, CHUDDAR, CHUDDER [n]\n",
  "CHUDDAR": "(Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDER [n -S]\n",
  "CHUDDARS": "CHUDDAR, (Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDER [n]\n",
  "CHUDDER": "(Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR [n -S]\n",
  "CHUDDERS": "CHUDDER, (Persian) the large veil worn by Muslim women, also CHADAR, CHADDAR, CHADDOR, CHADOR, CHUDDAH, CHUDDAR [n]\n",
  "CHUDDIES": "CHUDDY, (Australian slang) chewing-gum, also CHEWIE [n]\n",
  "CHUDDY": "(Australian slang) chewing-gum, also CHEWIE [n CHUDDIES]\n",
  "CHUFA": "(Spanish) a sedge-like plant producing edible tubers, native about the Mediterranean [n -S]\n",
  "CHUFAS": "CHUFA, (Spanish) a sedge-like plant producing edible tubers, native about the Mediterranean [n]\n",
  "CHUFF": "gruff [adj CHUFFER, CHUFFEST] / to make a series of puffing sounds [v -ED, -ING, -S]\n",
  "CHUFFED": "CHUFF, to make a series of puffing sounds [v]\n",
  "CHUFFER": "CHUFF, gruff [adj]\n",
  "CHUFFEST": "CHUFF, gruff [adj]\n",
  "CHUFFIER": "CHUFFY, fat or puffed out in the cheeks [adj]\n",
  "CHUFFIEST": "CHUFFY, fat or puffed out in the cheeks [adj]\n",
  "CHUFFINESS": "the quality of being chuffy [n -ES]\n",
  "CHUFFINESSES": "CHUFFINESS, the quality of being chuffy [n]\n",
  "CHUFFING": "CHUFF, to make a series of puffing sounds [v]\n",
  "CHUFFS": "CHUFF, to make a series of puffing sounds [v]\n",
  "CHUFFY": "fat or puffed out in the cheeks [adj CHUFFIER, CHUFFIEST]\n",
  "CHUG": "to move with a dull explosive sound [v CHUGGED, CHUGGING, CHUGS]\n",
  "CHUGALUG": "to drink without pause [v CHUGALUGGED, CHUGALUGGING, CHUGALUGS]\n",
  "CHUGALUGGED": "CHUGALUG, to drink without pause [v]\n",
  "CHUGALUGGING": "CHUGALUG, to drink without pause [v]\n",
  "CHUGALUGS": "CHUGALUG, to drink without pause [v]\n",
  "CHUGGED": "CHUG, to move with a dull explosive sound [v]\n",
  "CHUGGER": "a charity worker who approaches people in the street to solicit them for regular donations [n -S]\n",
  "CHUGGERS": "CHUGGER, a charity worker who approaches people in the street to solicit them for regular donations [n]\n",
  "CHUGGING": "the act of soliciting for charity in the street [n -S]\n",
  "CHUGGINGS": "CHUGGING, the act of soliciting for charity in the street [n]\n",
  "CHUGS": "CHUG, to move with a dull explosive sound [v]\n",
  "CHUKAR": "(Hindi) an Indian partridge, also CHIKHOR, CHIKOR, CHUKOR [n -S]\n",
  "CHUKARS": "CHUKAR, (Hindi) an Indian partridge, also CHIKHOR, CHIKOR, CHUKOR [n]\n",
  "CHUKKA": "(Hindi) a period of play in polo, also CHUKKAR, CHUKKER [n -S]\n",
  "CHUKKAR": "(Hindi) a period of play in polo, also CHUKKA, CHUKKER [n -S]\n",
  "CHUKKARS": "CHUKKAR, (Hindi) a period of play in polo, also CHUKKA, CHUKKER [n]\n",
  "CHUKKAS": "CHUKKA, (Hindi) a period of play in polo, also CHUKKAR, CHUKKER [n]\n",
  "CHUKKER": "(Hindi) a period of play in polo, also CHUKKA, CHUKKAR [n -S]\n",
  "CHUKKERS": "CHUKKER, (Hindi) a period of play in polo, also CHUKKA, CHUKKAR [n]\n",
  "CHUKOR": "(Hindi) an Indian partridge, also CHIKHOR, CHIKOR, CHUKAR [n -S]\n",
  "CHUKORS": "CHUKOR, (Hindi) an Indian partridge, also CHIKHOR, CHIKOR, CHUKAR [n]\n",
  "CHUM": "to be close friends with someone [v CHUMMED, CHUMMING, CHUMS]\n",
  "CHUMASH": "(Hebrew) a printed book containing one of the Five Books of Moses [n CHUMASHES or CHUMASHIM]\n",
  "CHUMASHES": "CHUMASH, (Hebrew) a printed book containing one of the Five Books of Moses [n]\n",
  "CHUMASHIM": "CHUMASH, (Hebrew) a printed book containing one of the Five Books of Moses [n]\n",
  "CHUMLEY": "a chimney, also CHIMBLEY, CHIMBLY, CHIMLA, CHIMLEY, CHIMNEY [n -S]\n",
  "CHUMLEYS": "CHUMLEY, a chimney, also CHIMBLEY, CHIMBLY, CHIMLA, CHIMLEY, CHIMNEY [n]\n",
  "CHUMMAGE": "a fee paid by a prisoner for sole use of a cell [n -S]\n",
  "CHUMMAGES": "CHUMMAGE, a fee paid by a prisoner for sole use of a cell [n]\n",
  "CHUMMED": "CHUM, to be close friends with someone [v]\n",
  "CHUMMIER": "CHUMMY, friendly [adj]\n",
  "CHUMMIES": "CHUMMY, a chum, a criminal [n]\n",
  "CHUMMIEST": "CHUMMY, friendly [adj]\n",
  "CHUMMILY": "CHUMMY, friendly [adv]\n",
  "CHUMMINESS": "the state of being chummy [n -ES]\n",
  "CHUMMINESSES": "CHUMMINESS, the state of being chummy [n]\n",
  "CHUMMING": "CHUM, to be close friends with someone [v]\n",
  "CHUMMY": "friendly [adj CHUMMIER, CHUMMIEST, CHUMMILY] / a chum, a criminal [n CHUMMIES]\n",
  "CHUMP": "to munch [v -ED, -ING, -S]\n",
  "CHUMPED": "CHUMP, to munch [v]\n",
  "CHUMPING": "the practice of collecting wood for the Nov 5th bonfire [n -S]\n",
  "CHUMPINGS": "CHUMPING, the practice of collecting wood for the Nov 5th bonfire [n]\n",
  "CHUMPS": "CHUMP, to munch [v]\n",
  "CHUMS": "CHUM, to be close friends with someone [v]\n",
  "CHUMSHIP": "friendship [n -S]\n",
  "CHUMSHIPS": "CHUMSHIP, friendship [n]\n",
  "CHUNDER": "(Australian slang) to vomit [v -ED, -ING, -S]\n",
  "CHUNDERED": "CHUNDER, (Australian slang) to vomit [v]\n",
  "CHUNDERING": "CHUNDER, (Australian slang) to vomit [v]\n",
  "CHUNDEROUS": "nauseating [adj]\n",
  "CHUNDERS": "CHUNDER, (Australian slang) to vomit [v]\n",
  "CHUNK": "to make a dull explosive sound [v -ED, -ING, -S]\n",
  "CHUNKED": "CHUNK, to make a dull explosive sound [v]\n",
  "CHUNKIER": "CHUNKY, in chunks, solidly built [adj]\n",
  "CHUNKIEST": "CHUNKY, in chunks, solidly built [adj]\n",
  "CHUNKILY": "CHUNKY, in chunks, solidly built [adv]\n",
  "CHUNKINESS": "the state of being chunky [n -ES]\n",
  "CHUNKINESSES": "CHUNKINESS, the state of being chunky [n]\n",
  "CHUNKING": "the act of grouping objects mentally [n -S]\n",
  "CHUNKINGS": "CHUNKING, the act of grouping objects mentally [n]\n",
  "CHUNKS": "CHUNK, to make a dull explosive sound [v]\n",
  "CHUNKY": "in chunks, solidly built [adj CHUNKIER, CHUNKIEST, CHUNKILY]\n",
  "CHUNNEL": "the tunnel underneath the English Channel [n -S]\n",
  "CHUNNELS": "CHUNNEL, the tunnel underneath the English Channel [n]\n",
  "CHUNNER": "to mutter, grumble, also CHOUNTER, CHUNTER [v -ED, -ING, -S]\n",
  "CHUNNERED": "CHUNNER, to mutter, grumble, also CHOUNTER, CHUNTER [v]\n",
  "CHUNNERING": "CHUNNER, to mutter, grumble, also CHOUNTER, CHUNTER [v]\n",
  "CHUNNERS": "CHUNNER, to mutter, grumble, also CHOUNTER, CHUNTER [v]\n",
  "CHUNTER": "to mutter, grumble, also CHOUNTER, CHUNNER [v -ED, -ING, -S]\n",
  "CHUNTERED": "CHUNTER, to mutter, grumble, also CHOUNTER, CHUNNER [v]\n",
  "CHUNTERING": "CHUNTER, to mutter, grumble, also CHOUNTER, CHUNNER [v]\n",
  "CHUNTERS": "CHUNTER, to mutter, grumble, also CHOUNTER, CHUNNER [v]\n",
  "CHUPATI": "(Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHAPPATI, CHUPATTI, CHUPATTY [n -S]\n",
  "CHUPATIS": "CHUPATI, (Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHAPPATI, CHUPATTI, CHUPATTY [n]\n",
  "CHUPATTI": "(Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHAPPATI, CHUPATI, CHUPATTY [n -S]\n",
  "CHUPATTIES": "CHUPATTY, (Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHAPPATI, CHUPATI, CHUPATTI [n]\n",
  "CHUPATTIS": "CHUPATTI, (Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHAPPATI, CHUPATI, CHUPATTY [n]\n",
  "CHUPATTY": "(Hindi) a thin flat piece of unleavened bread, also CHAPATI, CHAPATTI, CHAPPATI, CHUPATI, CHUPATTI [n CHUPATTIES]\n",
  "CHUPPA": "(Hebrew) a Jewish wedding ceremony, also CHUPPAH, HUPPAH [n -S]\n",
  "CHUPPAH": "(Hebrew) a Jewish wedding canopy [n CHUPPAHS or CHUPPOTH or CHUPPOT]\n",
  "CHUPPAHS": "CHUPPAH, (Hebrew) a Jewish wedding canopy [n]\n",
  "CHUPPAS": "CHUPPA, (Hebrew) a Jewish wedding ceremony, also CHUPPAH, HUPPAH [n]\n",
  "CHUPPOT": "CHUPPAH, (Hebrew) a Jewish wedding canopy [n]\n",
  "CHUPPOTH": "CHUPPAH, (Hebrew) a Jewish wedding canopy [n]\n",
  "CHUPRASSIES": "CHUPRASSY, (Urdu) an office messenger, a household attendant, also CHAPRASSI [n]\n",
  "CHUPRASSY": "(Urdu) an office messenger, a household attendant, also CHAPRASSI [n CHUPRASSIES]\n",
  "CHUR": "(New Zealand) an informal expression of agreement [interj]\n",
  "CHURCH": "to bring to a building for Christian worship [v -ED, -ING, -ES]\n",
  "CHURCHED": "CHURCH, to bring to a building for Christian worship [v]\n",
  "CHURCHES": "CHURCH, to bring to a building for Christian worship [v]\n",
  "CHURCHGOER": "one who habitually attends church [n -S]\n",
  "CHURCHGOERS": "CHURCHGOER, one who habitually attends church [n]\n",
  "CHURCHGOING": "attending church [n -S]\n",
  "CHURCHGOINGS": "CHURCHGOING, attending church [n]\n",
  "CHURCHIANITIES": "CHURCHIANITY, a usually excessive or narrowly sectarian attachment to the practices and interests of a particular church [n]\n",
  "CHURCHIANITY": "a usually excessive or narrowly sectarian attachment to the practices and interests of a particular church [n CHURCHIANITIES]\n",
  "CHURCHIER": "CHURCHY, associated with or reminiscent of churches [adj]\n",
  "CHURCHIEST": "CHURCHY, associated with or reminiscent of churches [adj]\n",
  "CHURCHING": "a church ceremony given to women after childbirth [n -S]\n",
  "CHURCHINGS": "CHURCHING, a church ceremony given to women after childbirth [n]\n",
  "CHURCHISM": "devotion to church rules over religious precepts [n -S]\n",
  "CHURCHISMS": "CHURCHISM, devotion to church rules over religious precepts [n]\n",
  "CHURCHLESS": "without a church [adj]\n",
  "CHURCHLIER": "CHURCHLY, pertaining to a church [adj]\n",
  "CHURCHLIEST": "CHURCHLY, pertaining to a church [adj]\n",
  "CHURCHLINESS": "the state of being churchly, resembling a church [n -ES]\n",
  "CHURCHLINESSES": "CHURCHLINESS, the state of being churchly, resembling a church [n]\n",
  "CHURCHLY": "pertaining to a church [adj CHURCHLIER, CHURCHLIEST]\n",
  "CHURCHMAN": "a clergyman or ecclesiastic [n CHURCHMEN]\n",
  "CHURCHMANLIER": "CHURCHMANLY, in the manner of a churchman [adj]\n",
  "CHURCHMANLIEST": "CHURCHMANLY, in the manner of a churchman [adj]\n",
  "CHURCHMANLY": "in the manner of a churchman [adj CHURCHMANLIER, CHURCHMANLIEST]\n",
  "CHURCHMANSHIP": "the attitude, belief, or practice of a churchman [n -S]\n",
  "CHURCHMANSHIPS": "CHURCHMANSHIP, the attitude, belief, or practice of a churchman [n]\n",
  "CHURCHMEN": "CHURCHMAN, a clergyman or ecclesiastic [n]\n",
  "CHURCHPEOPLE": "people who attend church [n]\n",
  "CHURCHWARD": "in the direction of the church, also CHURCHWARDS [adv]\n",
  "CHURCHWARDEN": "one of two lay parish officers in Anglican churches with responsibility esp. for parish property and alms [n -S]\n",
  "CHURCHWARDENS": "CHURCHWARDEN, one of two lay parish officers in Anglican churches with responsibility esp. for parish property and alms [n]\n",
  "CHURCHWARDS": "in the direction of the church, also CHURCHWARD [adv]\n",
  "CHURCHWAY": "the public way or road that leads up to the church [n -S]\n",
  "CHURCHWAYS": "CHURCHWAY, the public way or road that leads up to the church [n]\n",
  "CHURCHWOMAN": "a woman who is a member of a church [n CHURCHWOMEN]\n",
  "CHURCHWOMEN": "CHURCHWOMAN, a woman who is a member of a church [n]\n",
  "CHURCHY": "associated with or reminiscent of churches [adj CHURCHIER, CHURCHIEST]\n",
  "CHURCHYARD": "a yard that belongs to a church and is often used as a burial ground [n -S]\n",
  "CHURCHYARDS": "CHURCHYARD, a yard that belongs to a church and is often used as a burial ground [n]\n",
  "CHURIDAR": "(Hindi) as in churidar pyjamas, long tight-fitting trousers worn by Indian men and women [n -S]\n",
  "CHURIDARS": "(Hindi) tight-fitting trousers worn by Indian men and women [n]\n",
  "CHURINGA": "(Native Australian) a sacred amulet of the Australian aborigines [n -S]\n",
  "CHURINGAS": "CHURINGA, (Native Australian) a sacred amulet of the Australian aborigines [n]\n",
  "CHURL": "(Old English) in Anglo-Saxon England, a freeman of the lowest rank, also CEORL [n -S]\n",
  "CHURLISH": "like a churl, vulgar, incivil [adj CHURLISHLY]\n",
  "CHURLISHLY": "CHURLISH, like a churl, vulgar, incivil [adv]\n",
  "CHURLISHNESS": "the state of being churlish [n -ES]\n",
  "CHURLISHNESSES": "CHURLISHNESS, the state of being churlish [n]\n",
  "CHURLS": "CHURL, (Old English) in Anglo-Saxon England, a freeman of the lowest rank, also CEORL [n]\n",
  "CHURN": "to agitate to make butter [v -ED, -ING, -S]\n",
  "CHURNALISM": "a type of journalism that relies on reusing existing material such as press releases and wire service reports instead of original research [n -S]\n",
  "CHURNALISMS": "CHURNALISM, a type of journalism that relies on reusing existing material such as press releases and wire service reports instead of original research [n]\n",
  "CHURNED": "CHURN, to agitate to make butter [v]\n",
  "CHURNER": "a person who or machine which churns [n -S]\n",
  "CHURNERS": "CHURNER, a person who or machine which churns [n]\n",
  "CHURNING": "the butter churned at one time [n -S]\n",
  "CHURNINGS": "CHURNING, the butter churned at one time [n]\n",
  "CHURNMILK": "buttermilk [n -S]\n",
  "CHURNMILKS": "CHURNMILK, buttermilk [n]\n",
  "CHURNS": "CHURN, to agitate to make butter [v]\n",
  "CHURR": "to make a vibrant sound [v -ED, -ING, -S]\n",
  "CHURRED": "CHURR, to make a vibrant sound [v]\n",
  "CHURRIGUERESCO": "(Spanish) of or relating to a Spanish baroque architectural style characterized by elaborate surface decoration, also CHURRIGUERESQUE [adj]\n",
  "CHURRIGUERESQUE": "of or relating to a Spanish baroque architectural style characterized by elaborate surface decoration, also CHURRIGUERESCO [adj]\n",
  "CHURRING": "CHURR, to make a vibrant sound [v]\n",
  "CHURRO": "(Spanish) a Spanish dough stick [n -S]\n",
  "CHURROS": "CHURRO, (Spanish) a Spanish dough stick [n]\n",
  "CHURRS": "CHURR, to make a vibrant sound [v]\n",
  "CHURRUS": "(Hindi) the resinous exudation of hashish, a narcotic and intoxicant, also CHARAS [n -ES]\n",
  "CHURRUSES": "CHURRUS, (Hindi) the resinous exudation of hashish, a narcotic and intoxicant, also CHARAS [n]\n",
  "CHUSE": "(obsolete) to choose [v CHUSED, CHOSEN, CHUSING, CHUSES]\n",
  "CHUSED": "CHUSE, (obsolete) to choose [v]\n",
  "CHUSES": "CHUSE, (obsolete) to choose [v]\n",
  "CHUSING": "CHUSE, (obsolete) to choose [v]\n",
  "CHUT": "(French) to utter an expression of impatience [v -ED, -ING, -S]\n",
  "CHUTE": "to convey by a vertical passage, also SHUTE [v CHUTED, CHUTING, CHUTES]\n",
  "CHUTED": "CHUTE, to convey by a vertical passage, also SHUTE [v]\n",
  "CHUTES": "CHUTE, to convey by a vertical passage, also SHUTE [v]\n",
  "CHUTING": "CHUTE, to convey by a vertical passage, also SHUTE [v]\n",
  "CHUTIST": "a parachutist [n -S]\n",
  "CHUTISTS": "CHUTIST, a parachutist [n]\n",
  "CHUTNEE": "(Hindi) a warm or spicy condiment or pickle made in India, compounded of various vegetable substances, sweets, acids, etc., also CHUTNEY [n -S]\n",
  "CHUTNEES": "CHUTNEE, (Hindi) a warm or spicy condiment or pickle made in India, compounded of various vegetable substances, sweets, acids, etc., also CHUTNEY [n]\n",
  "CHUTNEY": "(Hindi) a warm or spicy condiment or pickle made in India, compounded of various vegetable substances, sweets, acids, etc., also CHUTNEE [n -S]\n",
  "CHUTNEYS": "CHUTNEY, (Hindi) a warm or spicy condiment or pickle made in India, compounded of various vegetable substances, sweets, acids, etc., also CHUTNEE [n]\n",
  "CHUTS": "CHUT, (French) to utter an expression of impatience [v]\n",
  "CHUTZPA": "(Yiddish) supreme self-confidence, also CHUTZPAH [n -S]\n",
  "CHUTZPAH": "(Yiddish) supreme self-confidence, also CHUTZPA [n -S]\n",
  "CHUTZPAHS": "CHUTZPAH, (Yiddish) supreme self-confidence, also CHUTZPA [n]\n",
  "CHUTZPAS": "CHUTZPA, (Yiddish) supreme self-confidence, also CHUTZPAH [n]\n",
  "CHYACK": "(Australian slang) to tease, deride, also CHIACK [v -ED, -ING, -S]\n",
  "CHYACKED": "CHYACK, (Australian slang) to tease, deride, also CHIACK [v]\n",
  "CHYACKING": "CHYACK, (Australian slang) to tease, deride, also CHIACK [v]\n",
  "CHYACKS": "CHYACK, (Australian slang) to tease, deride, also CHIACK [v]\n",
  "CHYLACEOUS": "possessed of the properties of chyle [adj]\n",
  "CHYLDE": "designating a youth of gentle birth, esp. in ballads, also CHILDE [adj]\n",
  "CHYLE": "a milky fluid secreted into the blood by the small intestine [n -S]\n",
  "CHYLES": "CHYLE, a milky fluid secreted into the blood by the small intestine [n]\n",
  "CHYLIFEROUS": "containing chyle [adj]\n",
  "CHYLIFICATION": "the process of chylifying [n -S]\n",
  "CHYLIFICATIONS": "CHYLIFICATION, the process of chylifying [n]\n",
  "CHYLIFIED": "CHYLIFY, to produce chyle [v]\n",
  "CHYLIFIES": "CHYLIFY, to produce chyle [v]\n",
  "CHYLIFY": "to produce chyle [v CHYLIFIED, CHYLIFYING, CHYLIFIES]\n",
  "CHYLIFYING": "CHYLIFY, to produce chyle [v]\n",
  "CHYLOMICRON": "a tiny globule of fat, the form in which fat is carried in blood and chyle [n -S]\n",
  "CHYLOMICRONS": "CHYLOMICRON, a tiny globule of fat, the form in which fat is carried in blood and chyle [n]\n",
  "CHYLOUS": "consisting of, or similar to, chyle [adj]\n",
  "CHYLURIA": "a morbid condition in which the urine contains chyle or fatty matter, giving it a milky appearance [n -S]\n",
  "CHYLURIAS": "CHYLURIA, a morbid condition in which the urine contains chyle or fatty matter, giving it a milky appearance [n]\n",
  "CHYME": "semiliquid, partly digested food leaving stomach [n -S]\n",
  "CHYMES": "CHYME, semiliquid, partly digested food leaving stomach [n]\n",
  "CHYMIC": "(obsolete) a chemist, also CHEMIC [n -S]\n",
  "CHYMICS": "CHYMIC, (obsolete) a chemist, also CHEMIC [n]\n",
  "CHYMIFEROUS": "containing chyme [adj]\n",
  "CHYMIFICATION": "the process of chymifying [n -S]\n",
  "CHYMIFICATIONS": "CHYMIFICATION, the process of chymifying [n]\n",
  "CHYMIFIED": "CHYMIFY, to form into chyme [v]\n",
  "CHYMIFIES": "CHYMIFY, to form into chyme [v]\n",
  "CHYMIFY": "to form into chyme [v CHYMIFIED, CHYMIFYING, CHYMIFIES]\n",
  "CHYMIFYING": "CHYMIFY, to form into chyme [v]\n",
  "CHYMIST": "(archaic) a chemist, also CHYMIC [n -S]\n",
  "CHYMISTRIES": "CHYMISTRY, (archaic) chemistry [n]\n",
  "CHYMISTRY": "(archaic) chemistry [n CHYMISTRIES]\n",
  "CHYMISTS": "CHYMIST, (archaic) a chemist, also CHYMIC [n]\n",
  "CHYMOSIN": "rennin [n -S]\n",
  "CHYMOSINS": "CHYMOSIN, rennin [n]\n",
  "CHYMOTRYPSIN": "rennin [n -S]\n",
  "CHYMOTRYPSINS": "CHYMOTRYPSIN, rennin [n]\n",
  "CHYMOTRYPTIC": "relating to chymotrypsin [adj]\n",
  "CHYMOUS": "of or pertaining to chyme, semiliquid, partly digested food leaving stomach [adj]\n",
  "CHYND": "(archaic) cut into chines [adj]\n",
  "CHYPRE": "(French) a mixture of resins used in making perfume [n -S]\n",
  "CHYPRES": "CHYPRE, (French) a mixture of resins used in making perfume [n]\n",
  "CHYRON": "a group of words that appears on a television screen [n -S]\n",
  "CHYRONS": "CHYRON, a group of words that appears on a television screen [n]\n",
  "CHYTRID": "a primitive variety of fungus [n -S]\n",
  "CHYTRIDS": "CHYTRID, a primitive variety of fungus [n]\n",
  "CIABATTA": "(Italian) a kind of bread made with olive oil [n CIABATTE or CIABATTAS]\n",
  "CIABATTAS": "CIABATTA, (Italian) a kind of bread made with olive oil [n]\n",
  "CIABATTE": "CIABATTA, (Italian) a kind of bread made with olive oil [n]\n",
  "CIAO": "(Italian) an informal greeting or farewell [interj]\n",
  "CIBACHROME": "a type of colour print made directly form a colour transparency [n -S]\n",
  "CIBACHROMES": "CIBACHROME, a type of colour print made directly form a colour transparency [n]\n",
  "CIBATION": "a process used by alchemists [n -S]\n",
  "CIBATIONS": "CIBATION, a process used by alchemists [n]\n",
  "CIBOL": "a variety of onion, aka spring onion, also CHIBOL, CIBOULE, SYBO, SYBOE, SYBOW [n -S]\n",
  "CIBOLS": "CIBOL, a variety of onion, aka spring onion, also CHIBOL, CIBOULE, SYBO, SYBOE, SYBOW [n]\n",
  "CIBORIA": "CIBORIUM, (Latin) a vessel for holding eucharistic bread [n]\n",
  "CIBORIUM": "(Latin) a vessel for holding eucharistic bread [n CIBORIA or CIBORIUMS]\n",
  "CIBORIUMS": "CIBORIUM, (Latin) a vessel for holding eucharistic bread [n]\n",
  "CIBOULE": "a variety of onion, aka spring onion, also CHIBOL, CIBOL, SYBO, SYBOE, SYBOW [n -S]\n",
  "CIBOULES": "CIBOULE, a variety of onion, aka spring onion, also CHIBOL, CIBOL, SYBO, SYBOE, SYBOW [n]\n",
  "CICADA": "(Latin) a winged insect, also CICALA [n CICADAS or CICADAE]\n",
  "CICADAE": "CICADA, (Latin) a winged insect, also CICALA [n]\n",
  "CICADAS": "CICADA, (Latin) a winged insect, also CICALA [n]\n",
  "CICADELLID": "any of a genus of insects including leafhoppers [n -S]\n",
  "CICADELLIDS": "CICADELLID, any of a genus of insects including leafhoppers [n]\n",
  "CICALA": "(Italian) a winged insect, also CICADA [n CICALAS or CICALE]\n",
  "CICALAS": "CICALA, (Italian) a winged insect, also CICADA [n]\n",
  "CICALE": "CICALA, (Italian) a winged insect, also CICADA [n]\n",
  "CICATRICE": "the scar of a healed wound, burn, etc., also CICATRIX [n -S]\n",
  "CICATRICES": "CICATRIX, (Latin) the scar of a healed wound, burn, etc., also CICATRICE [n]\n",
  "CICATRICHULE": "a white spot, the germinating point in the yolk of an egg, also CICATRICLE, CICATRICULA [n -S]\n",
  "CICATRICHULES": "CICATRICHULE, a white spot, the germinating point in the yolk of an egg, also CICATRICLE, CICATRICULA [n]\n",
  "CICATRICIAL": "of or like a cicatrice [adj]\n",
  "CICATRICLE": "a white spot, the germinating point in the yolk of an egg, also CICATRICHULE, CICATRICULA [n -S]\n",
  "CICATRICLES": "CICATRICLE, a white spot, the germinating point in the yolk of an egg, also CICATRICHULE, CICATRICULA [n]\n",
  "CICATRICOSE": "like a cicatrix [adj]\n",
  "CICATRICULA": "a white spot, the germinating point in the yolk of an egg, also CICATRICHULE, CICATRICLE [n -S]\n",
  "CICATRICULAS": "CICATRICULA, a white spot, the germinating point in the yolk of an egg, also CICATRICHULE, CICATRICLE [n]\n",
  "CICATRISANT": "forming a cicatrice, also CICATRIZANT [adj]\n",
  "CICATRISATION": "the process of cicatrising, also CICATRIZATION [n -S]\n",
  "CICATRISATIONS": "CICATRISATION, the process of cicatrising, also CICATRIZATION [n]\n",
  "CICATRISE": "to form a scar, also CICATRIZE [v CICATRISED, CICATRISING, CICATRISES]\n",
  "CICATRISED": "CICATRISE, to form a scar, also CICATRIZE [v]\n",
  "CICATRISER": "an agent that cicatrises, also CICATRIZER [n -S]\n",
  "CICATRISERS": "CICATRISER, an agent that cicatrises, also CICATRIZER [n]\n",
  "CICATRISES": "CICATRISE, to form a scar, also CICATRIZE [v]\n",
  "CICATRISING": "CICATRISE, to form a scar, also CICATRIZE [v]\n",
  "CICATRIX": "(Latin) the scar of a healed wound, burn, etc., also CICATRICE [n CICATRICES]\n",
  "CICATRIXES": "CICATRIX, (Latin) the scar of a healed wound, burn, etc., also CICATRICE [n]\n",
  "CICATRIZANT": "forming a cicatrice, also CICATRISANT [adj]\n",
  "CICATRIZATION": "the process of cicatrising, also CICATRISATION [n -S]\n",
  "CICATRIZATIONS": "CICATRIZATION, the process of cicatrising, also CICATRISATION [n]\n",
  "CICATRIZE": "to form a scar, also CICATRISE [v CICATRIZED, CICATRIZING, CICATRIZES]\n",
  "CICATRIZED": "CICATRIZE, to form a scar, also CICATRISE [v]\n",
  "CICATRIZER": "an agent that cicatrizes, also CICATRISER [n -S]\n",
  "CICATRIZERS": "CICATRIZER, an agent that cicatrizes, also CICATRISER [n]\n",
  "CICATRIZES": "CICATRIZE, to form a scar, also CICATRISE [v]\n",
  "CICATRIZING": "CICATRIZE, to form a scar, also CICATRISE [v]\n",
  "CICELIES": "CICELY, a fragrant herb [n]\n",
  "CICELY": "a fragrant herb [n CICELIES]\n",
  "CICERO": "a printing measure [n -S]\n",
  "CICERONE": "(Italian) a guide escorting tourists, sightseers [n CICERONI] / to act as a guide [v CICERONED, CICERONEING, CICERONES]\n",
  "CICERONED": "CICERONE, to act as a guide [v]\n",
  "CICERONEING": "CICERONE, to act as a guide [v]\n",
  "CICERONES": "CICERONE, to act as a guide [v]\n",
  "CICERONI": "CICERONE, (Italian) a guide escorting tourists, sightseers [n]\n",
  "CICEROS": "CICERO, a printing measure [n]\n",
  "CICHLID": "any teleost fish of the family Cichlidae [n -S]\n",
  "CICHLIDAE": "the cichlid family of fish [n]\n",
  "CICHLIDS": "CICHLID, any teleost fish of the family Cichlidae [n]\n",
  "CICHLOID": "like a cichlid, any teleost fish of the family Cichlidae [adj]\n",
  "CICHORACEOUS": "of or belonging to the Cichoraceae, a suborder of plants including the chicory, endive, dandelion, etc. [adj]\n",
  "CICINNUS": "(Greek) a way in which flower stems form [n -ES]\n",
  "CICINNUSES": "CICINNUS, (Greek) a way in which flower stems form [n]\n",
  "CICISBEI": "CICISBEO, (Italian) a lover of a married woman [n]\n",
  "CICISBEISM": "the state or conduct of a cicisbeo [n -S]\n",
  "CICISBEISMS": "CICISBEISM, the state or conduct of a cicisbeo [n]\n",
  "CICISBEO": "(Italian) a lover of a married woman [n CICISBEOS or CICISBEI]\n",
  "CICISBEOS": "CICISBEO, (Italian) a lover of a married woman [n]\n",
  "CICLATON": "(obsolete) a costly cloth, of uncertain material, used in the Middle Ages, also CICLATOUN [n -S]\n",
  "CICLATONS": "CICLATON, (obsolete) a costly cloth, of uncertain material, used in the Middle Ages, also CICLATOUN [n]\n",
  "CICLATOUN": "(obsolete) a costly cloth, of uncertain material, used in the Middle Ages, also CICLATON [n -S]\n",
  "CICLATOUNS": "CICLATOUN, (obsolete) a costly cloth, of uncertain material, used in the Middle Ages, also CICLATON [n]\n",
  "CICLOSPORIN": "an immunosuppressive polypeptide drug [n -S]\n",
  "CICLOSPORINS": "CICLOSPORIN, an immunosuppressive polypeptide drug [n]\n",
  "CICOREE": "a perennial herb [n -S]\n",
  "CICOREES": "CICOREE, a perennial herb [n]\n",
  "CICUTA": "(Latin) the hemlock plant [n -S]\n",
  "CICUTAS": "CICUTA, (Latin) the hemlock plant [n]\n",
  "CICUTINE": "a poisonous alkaloid, also CONIINE, CONIN, CONINE, CONICINE [n -S]\n",
  "CICUTINES": "CICUTINE, a poisonous alkaloid, also CONIINE, CONIN, CONINE, CONICINE [n]\n",
  "CID": "a chief, captain or hero [n -S]\n",
  "CIDARIS": "(Latin) the royal tiara or cap of state of the ancient Persians [n -ES]\n",
  "CIDARISES": "CIDARIS, (Latin) the royal tiara or cap of state of the ancient Persians [n]\n",
  "CIDE": "(Shakespeare) to decide [v CIDED, CIDING, CIDES]\n",
  "CIDED": "CIDE, (Shakespeare) to decide [v]\n",
  "CIDER": "an alcoholic drink made from the fermented juice of apples, also CYDER [n -S]\n",
  "CIDERIER": "CIDERY, having a taste like cider [adj]\n",
  "CIDERIEST": "CIDERY, having a taste like cider [adj]\n",
  "CIDERKIN": "a type of weak cider [n -S]\n",
  "CIDERKINS": "CIDERKIN, a type of weak cider [n]\n",
  "CIDERS": "CIDER, an alcoholic drink made from the fermented juice of apples, also CYDER [n]\n",
  "CIDERY": "having a taste like cider [adj CIDERIER, CIDERIEST]\n",
  "CIDES": "CIDE, (Shakespeare) to decide [v]\n",
  "CIDING": "CIDE, (Shakespeare) to decide [v]\n",
  "CIDS": "CID, a chief, captain or hero [n]\n",
  "CIEL": "to provide with a ceiling, also CEIL [v -ED, -ING, -S]\n",
  "CIELED": "CIEL, to provide with a ceiling, also CEIL [v]\n",
  "CIELING": "a ceiling [n -S]\n",
  "CIELINGS": "CIELING, a ceiling [n]\n",
  "CIELS": "CIEL, to provide with a ceiling, also CEIL [v]\n",
  "CIERGE": "a large wax candle used in religious rites, also CERGE [n -S]\n",
  "CIERGES": "CIERGE, a large wax candle used in religious rites, also CERGE [n]\n",
  "CIG": "(short for) cigarette, also CIGGIE, CIGGY [n -S]\n",
  "CIGAR": "a roll of tobacco leaves for smoking [n -S]\n",
  "CIGARET": "finely-cut tobacco rolled in thin paper, also CIGARETTE [n -S]\n",
  "CIGARETS": "CIGARET, finely-cut tobacco rolled in thin paper, also CIGARETTE [n]\n",
  "CIGARETTE": "finely-cut tobacco rolled in thin paper, also CIGARET [n -S]\n",
  "CIGARETTES": "CIGARETTE, finely-cut tobacco rolled in thin paper, also CIGARET [n]\n",
  "CIGARILLO": "(Spanish) a small cigar [n -S]\n",
  "CIGARILLOS": "CIGARILLO, (Spanish) a small cigar [n]\n",
  "CIGARLIKE": "like a cigar [adj]\n",
  "CIGARS": "CIGAR, a roll of tobacco leaves for smoking [n]\n",
  "CIGGIE": "(slang) cigarette, also CIG, CIGGY [n -S]\n",
  "CIGGIES": "CIGGIE, (slang) cigarette, also CIG, CIGGY [n]\n",
  "CIGGY": "(slang) cigarette, also CIG, CIGGIE [n CIGGIES]\n",
  "CIGS": "CIG, (short for) cigarette, also CIGGIE, CIGGY [n]\n",
  "CIGUATERA": "(Spanish) poisoning caused by the ingestion of various normally edible tropical fish in whose flesh a toxin has accumulated [n -S]\n",
  "CIGUATERAS": "CIGUATERA, (Spanish) poisoning caused by the ingestion of various normally edible tropical fish in whose flesh a toxin has accumulated [n]\n",
  "CIGUATOXIN": "a toxin found in seafood [n -S]\n",
  "CIGUATOXINS": "CIGUATOXIN, a toxin found in seafood [n]\n",
  "CILANTRO": "(Spanish) a herb used in cooking, coriander [n -S]\n",
  "CILANTROS": "CILANTRO, (Spanish) a herb used in cooking, coriander [n]\n",
  "CILIA": "CILIUM, (Latin) a short hairlike projection borne by a cell [n]\n",
  "CILIARY": "pertaining to the cilia, or eyelashes [adj]\n",
  "CILIATE": "possessing cilia, also CILIATED [adj CILIATELY] / a member of the Ciliata, a subclass of Protozoa [n -S]\n",
  "CILIATED": "having cilia, fine hairlike structures on the surface of a cell [adj]\n",
  "CILIATELY": "CILIATE, possessing cilia, also CILIATED [adv]\n",
  "CILIATES": "CILIATE, a member of the Ciliata, a subclass of Protozoa [n]\n",
  "CILIATION": "the state of having cilia, hairlike lashes borne by a cell [n -S]\n",
  "CILIATIONS": "CILIATION, the state of having cilia, hairlike lashes borne by a cell [n]\n",
  "CILICE": "(Greek) a haircloth shirt worn as penance [n -S]\n",
  "CILICES": "CILICE, (Greek) a haircloth shirt worn as penance [n]\n",
  "CILICIOUS": "made, or consisting, of hair [adj]\n",
  "CILIOLATE": "fringed with very short fine hairs [adj]\n",
  "CILIUM": "(Latin) a short hairlike projection borne by a cell [n CILIA]\n",
  "CILL": "a sill [n -S]\n",
  "CILLS": "CILL, a sill [n]\n",
  "CIMAR": "(French) a loose coat, an undergarment formerly worn by women, also CYMAR, SIMAR, SIMARRE, SYMAR [n -S]\n",
  "CIMARS": "CIMAR, (French) a loose coat, an undergarment formerly worn by women, also CYMAR, SIMAR, SIMARRE, SYMAR [n]\n",
  "CIMBALOM": "a kind of Hungarian dulcimer, also CYMBALOM [n -S]\n",
  "CIMBALOMS": "CIMBALOM, a kind of Hungarian dulcimer, also CYMBALOM [n]\n",
  "CIMELIA": "(Latin) treasures in storage [n]\n",
  "CIMETIDINE": "a drug that reduces the secretion of hydrochloric acid in the stomach [n -S]\n",
  "CIMETIDINES": "CIMETIDINE, a drug that reduces the secretion of hydrochloric acid in the stomach [n]\n",
  "CIMEX": "(Latin) a bedbug [n CIMICES]\n",
  "CIMICES": "CIMEX, (Latin) a bedbug [n]\n",
  "CIMIER": "(French) the crest of a helmet; a removable heraldic device or favour of courtly love [n -S]\n",
  "CIMIERS": "CIMIER, (French) the crest of a helmet; a removable heraldic device or favour of courtly love [n]\n",
  "CIMINITE": "a rock containing olivine [n -S]\n",
  "CIMINITES": "CIMINITE, a rock containing olivine [n]\n",
  "CIMMERIAN": "very dark or gloomy [adj]\n",
  "CIMOLITE": "a type of clay, or hydrous silicate of aluminium, similar to fuller's earth [n -S]\n",
  "CIMOLITES": "CIMOLITE, a type of clay, or hydrous silicate of aluminium, similar to fuller's earth [n]\n",
  "CINCH": "to bind firmly with a belt [v -ED, -ING, -ES]\n",
  "CINCHED": "CINCH, to bind firmly with a belt [v]\n",
  "CINCHES": "CINCH, to bind firmly with a belt [v]\n",
  "CINCHING": "fastening with a cinch, a saddle-girth [n -S]\n",
  "CINCHINGS": "CINCHING, fastening with a cinch, a saddle-girth [n]\n",
  "CINCHONA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, KINA, KINAKINA, QUINA, QUINAQUINA, QUINQUINA [n -S]\n",
  "CINCHONACEOUS": "belonging to the Cinchona genus of trees, that yield quinine [adj]\n",
  "CINCHONAS": "CINCHONA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, KINA, KINAKINA, QUINA, QUINAQUINA, QUINQUINA [n]\n",
  "CINCHONIC": "belonging to, or obtained from, cinchona [adj]\n",
  "CINCHONIDINE": "an alkaloid that is a stereoisomer of cinchonine, with similar properties and uses [n -S]\n",
  "CINCHONIDINES": "CINCHONIDINE, an alkaloid that is a stereoisomer of cinchonine, with similar properties and uses [n]\n",
  "CINCHONINE": "an alkaloid obtained from cinchona bark and used as a substitute for quinine [n -S]\n",
  "CINCHONINES": "CINCHONINE, an alkaloid obtained from cinchona bark and used as a substitute for quinine [n]\n",
  "CINCHONINIC": "of or like cinchonine [adj]\n",
  "CINCHONISATION": "the process of cinchonising, also CINCHONIZATION [n -S]\n",
  "CINCHONISATIONS": "CINCHONISATION, the process of cinchonising, also CINCHONIZATION [n]\n",
  "CINCHONISE": "to treat with cinchona or quinine, also CINCHONIZE [v CINCHONISED, CINCHONISING, CINCHONISES]\n",
  "CINCHONISED": "CINCHONISE, to treat with cinchona or quinine, also CINCHONIZE [v]\n",
  "CINCHONISES": "CINCHONISE, to treat with cinchona or quinine, also CINCHONIZE [v]\n",
  "CINCHONISING": "CINCHONISE, to treat with cinchona or quinine, also CINCHONIZE [v]\n",
  "CINCHONISM": "a condition produced by the excessive or long-continued use of quinine [n -S]\n",
  "CINCHONISMS": "CINCHONISM, a condition produced by the excessive or long-continued use of quinine [n]\n",
  "CINCHONIZATION": "the process of cinchonizing, also CINCHONISATION [n -S]\n",
  "CINCHONIZATIONS": "CINCHONIZATION, the process of cinchonizing, also CINCHONISATION [n]\n",
  "CINCHONIZE": "to treat with cinchona or quinine, also CINCHONISE [v CINCHONIZED, CINCHONIZING, CINCHONIZES]\n",
  "CINCHONIZED": "CINCHONIZE, to treat with cinchona or quinine, also CINCHONISE [v]\n",
  "CINCHONIZES": "CINCHONIZE, to treat with cinchona or quinine, also CINCHONISE [v]\n",
  "CINCHONIZING": "CINCHONIZE, to treat with cinchona or quinine, also CINCHONISE [v]\n",
  "CINCINNATE": "relating to a cincinnus, a type of inflorescence [adj]\n",
  "CINCINNUS": "(Greek) a type of inflorescence, also CICINNUS [n -ES]\n",
  "CINCINNUSES": "CINCINNUS, (Greek) a type of inflorescence, also CICINNUS [n]\n",
  "CINCT": "surrounded, encircled [adj]\n",
  "CINCTURE": "to gird or surround [v CINCTURED, CINCTURING, CINCTURES]\n",
  "CINCTURED": "CINCTURE, to gird or surround [v]\n",
  "CINCTURES": "CINCTURE, to gird or surround [v]\n",
  "CINCTURING": "CINCTURE, to gird or surround [v]\n",
  "CINDER": "to reduce to ashes [v -ED, -ING, -S]\n",
  "CINDERED": "CINDER, to reduce to ashes [v]\n",
  "CINDERIER": "CINDERY, having the nature of cinders [adj]\n",
  "CINDERIEST": "CINDERY, having the nature of cinders [adj]\n",
  "CINDERING": "CINDER, to reduce to ashes [v]\n",
  "CINDEROUS": "having the nature of cinders [adj]\n",
  "CINDERS": "CINDER, to reduce to ashes [v]\n",
  "CINDERY": "having the nature of cinders [adj CINDERIER, CINDERIEST]\n",
  "CINE": "a motion picture [n -S]\n",
  "CINEANGIOGRAPHY": "the recording of the movement of blood in the blood vessels by photographing a series of X-ray images to create a moving picture [n]\n",
  "CINEAST": "(French) a devotee of motion pictures, also CINEASTE [n -S]\n",
  "CINEASTE": "(French) a devotee of motion pictures, also CINEAST [n -S]\n",
  "CINEASTES": "CINEASTE, (French) a devotee of motion pictures, also CINEAST [n]\n",
  "CINEASTS": "CINEAST, (French) a devotee of motion pictures, also CINEASTE [n]\n",
  "CINEMA": "a motion-picture theatre, also KINEMA [n -S]\n",
  "CINEMAGOER": "one who attends the cinema [n -S]\n",
  "CINEMAGOERS": "CINEMAGOER, one who attends the cinema [n]\n",
  "CINEMAS": "CINEMA, a motion-picture theatre, also KINEMA [n]\n",
  "CINEMATHEQUE": "a small movie theater showing classic or avant-garde films [n -S]\n",
  "CINEMATHEQUES": "CINEMATHEQUE, a small movie theater showing classic or avant-garde films [n]\n",
  "CINEMATIC": "relating to the cinema [adj CINEMATICALLY]\n",
  "CINEMATICALLY": "CINEMATIC, relating to the cinema [adv]\n",
  "CINEMATISE": "to produce for the cinema, also CINEMATIZE [v CINEMATISED, CINEMATISING, CINEMATISES]\n",
  "CINEMATISED": "CINEMATISE, to produce for the cinema, also CINEMATIZE [v]\n",
  "CINEMATISES": "CINEMATISE, to produce for the cinema, also CINEMATIZE [v]\n",
  "CINEMATISING": "CINEMATISE, to produce for the cinema, also CINEMATIZE [v]\n",
  "CINEMATIZE": "to produce for the cinema, also CINEMATISE [v CINEMATIZED, CINEMATIZING, CINEMATIZES]\n",
  "CINEMATIZED": "CINEMATIZE, to produce for the cinema, also CINEMATISE [v]\n",
  "CINEMATIZES": "CINEMATIZE, to produce for the cinema, also CINEMATISE [v]\n",
  "CINEMATIZING": "CINEMATIZE, to produce for the cinema, also CINEMATISE [v]\n",
  "CINEMATOGRAPH": "to record by movie projector [v -ED, -S]\n",
  "CINEMATOGRAPHED": "CINEMATOGRAPH, to record by movie projector [v]\n",
  "CINEMATOGRAPHER": "a specialist in cinematography [n]\n",
  "CINEMATOGRAPHIC": "relating to cinematography [adj]\n",
  "CINEMATOGRAPHS": "CINEMATOGRAPH, to record by movie projector [v]\n",
  "CINEMATOGRAPHY": "the art or science of motion-picture photography [n]\n",
  "CINEMICROGRAPHY": "cinematographic recording of changes under the microscope [n]\n",
  "CINEOL": "a liquid used as an antiseptic, also CINEOLE [n -S]\n",
  "CINEOLE": "a liquid used as an antiseptic, also CINEOL [n -S]\n",
  "CINEOLES": "CINEOLE, a liquid used as an antiseptic, also CINEOL [n]\n",
  "CINEOLS": "CINEOL, a liquid used as an antiseptic, also CINEOLE [n]\n",
  "CINEPHILE": "a lover of the cinema [n -S]\n",
  "CINEPHILES": "CINEPHILE, a lover of the cinema [n]\n",
  "CINEPLEX": "a multiple cinema complex [n -ES]\n",
  "CINEPLEXES": "CINEPLEX, a multiple cinema complex [n]\n",
  "CINERAMIC": "relating to Cinerama, a method of film projection used in the cinema [adj]\n",
  "CINERARIA": "any of various garden hybrids with ashy down on the leaves [n -S]\n",
  "CINERARIAS": "CINERARIA, any of various garden hybrids with ashy down on the leaves [n]\n",
  "CINERARIUM": "(Latin) a place to receive the ashes of the cremated dead [n CINERARIA or CINERARIUMS]\n",
  "CINERARIUMS": "CINERARIUM, (Latin) a place to receive the ashes of the cremated dead [n]\n",
  "CINERARY": "pertaining to ashes, esp. of a cremated body [adj]\n",
  "CINERATION": "the reducing of anything to ashes by combustion [n -S]\n",
  "CINERATIONS": "CINERATION, the reducing of anything to ashes by combustion [n]\n",
  "CINERATOR": "an incinerator at a crematorium [n -S]\n",
  "CINERATORS": "CINERATOR, an incinerator at a crematorium [n]\n",
  "CINEREA": "the grey matter of the brain [n -S]\n",
  "CINEREAL": "relating to cinerea, the grey matter of the brain [adj]\n",
  "CINEREAS": "CINEREA, the grey matter of the brain [n]\n",
  "CINEREOUS": "related to ashes [adj]\n",
  "CINERIN": "a pyrethrum compound used as an insecticide [n -S]\n",
  "CINERINS": "CINERIN, a pyrethrum compound used as an insecticide [n]\n",
  "CINERITIOUS": "ashy-grey; relating to the grey matter of the brain [adj]\n",
  "CINES": "CINE, a motion picture [n]\n",
  "CINGULA": "CINGULUM, (Latin) a girdle-like structure [n]\n",
  "CINGULAR": "ring-shaped, encircling, also CINGULATE, CINGULATED [adj]\n",
  "CINGULATE": "having a girdle, also CINGULATED [adj]\n",
  "CINGULATED": "having a girdle, also CINGULATE [adj]\n",
  "CINGULUM": "(Latin) a girdle-like structure [n CINGULA]\n",
  "CINNABAR": "the principal ore of mercury [n -S]\n",
  "CINNABARIC": "of or like cinnabar, an ore of mercury [adj]\n",
  "CINNABARINE": "of or like cinnabar, an ore of mercury [adj]\n",
  "CINNABARS": "CINNABAR, the principal ore of mercury [n]\n",
  "CINNAMIC": "pertaining to, or obtained from, cinnamon, also CINNAMONIC [adj]\n",
  "CINNAMON": "the spicy bark of a lauraceous tree of Sri Lanka [n -S]\n",
  "CINNAMONIC": "pertaining to, or obtained from, cinnamon, also CINNAMIC [adj]\n",
  "CINNAMONIER": "CINNAMONY, like cinnamon [adj]\n",
  "CINNAMONIEST": "CINNAMONY, like cinnamon [adj]\n",
  "CINNAMONS": "CINNAMON, the spicy bark of a lauraceous tree of Sri Lanka [n]\n",
  "CINNAMONY": "like cinnamon [adj CINNAMONIER, CINNAMONIEST]\n",
  "CINNAMYL": "a radical found in cinnamic compounds [n -S]\n",
  "CINNAMYLS": "CINNAMYL, a radical found in cinnamic compounds [n]\n",
  "CINNARIZINE": "a generic antihistamine drug used to relieve nausea and travel sickness [n -S]\n",
  "CINNARIZINES": "CINNARIZINE, a generic antihistamine drug used to relieve nausea and travel sickness [n]\n",
  "CINQ": "(French) the number five, also CINQUE [n -S]\n",
  "CINQS": "CINQ, (French) the number five, also CINQUE [n]\n",
  "CINQUAIN": "(French) a stanza of five lines [n -S]\n",
  "CINQUAINS": "CINQUAIN, (French) a stanza of five lines [n]\n",
  "CINQUE": "(French) the number five, also CINQ [n -S]\n",
  "CINQUECENTIST": "an Italian of the cinquecento [n -S]\n",
  "CINQUECENTISTS": "CINQUECENTIST, an Italian of the cinquecento [n]\n",
  "CINQUECENTO": "(Italian) the 16th century, esp. in reference to Italian art and architecture [n -S]\n",
  "CINQUECENTOS": "CINQUECENTO, (Italian) the 16th century, esp. in reference to Italian art and architecture [n]\n",
  "CINQUEFOIL": "a wildflower, aka rockrose [n -S]\n",
  "CINQUEFOILS": "CINQUEFOIL, a wildflower, aka rockrose [n]\n",
  "CINQUES": "CINQUE, (French) the number five, also CINQ [n]\n",
  "CION": "a cutting from a plant or tree [n -S]\n",
  "CIONS": "CION, a cutting from a plant or tree [n]\n",
  "CIOPPINO": "(Italian) a spicy fish stew [n -S]\n",
  "CIOPPINOS": "CIOPPINO, (Italian) a spicy fish stew [n]\n",
  "CIPAILLE": "(French) a pie with layers of meat and pastry, a traditional Quebec dish [n -S]\n",
  "CIPAILLES": "CIPAILLE, (French) a pie with layers of meat and pastry, a traditional Quebec dish [n]\n",
  "CIPHER": "to work at arithmetic, also CYPHER [v -ED, -ING, -S]\n",
  "CIPHERED": "CIPHER, to work at arithmetic, also CYPHER [v]\n",
  "CIPHERER": "one who ciphers [n -S]\n",
  "CIPHERERS": "CIPHERER, one who ciphers [n]\n",
  "CIPHERING": "the act of enciphering [n -S]\n",
  "CIPHERINGS": "CIPHERING, the act of enciphering [n]\n",
  "CIPHERS": "CIPHER, to work at arithmetic, also CYPHER [v]\n",
  "CIPHERTEXT": "enciphered text [n -S]\n",
  "CIPHERTEXTS": "CIPHERTEXT, enciphered text [n]\n",
  "CIPHONIES": "CIPHONY, the electronic mixing of voice transmissions [n]\n",
  "CIPHONY": "the electronic mixing of voice transmissions [n CIPHONIES]\n",
  "CIPOLIN": "(Italian) a kind of white marble streaked with green, also CIPOLLINO [n -S]\n",
  "CIPOLINS": "CIPOLIN, (Italian) a kind of white marble streaked with green, also CIPOLLINO [n]\n",
  "CIPOLLINO": "(Italian) a kind of white marble streaked with green, also CIPOLIN [n -S]\n",
  "CIPOLLINOS": "CIPOLLINO, (Italian) a kind of white marble streaked with green, also CIPOLIN [n]\n",
  "CIPPI": "CIPPUS, (Latin) a small column marking a burial-place or landmark [n]\n",
  "CIPPUS": "(Latin) a small column marking a burial-place or landmark [n CIPPI]\n",
  "CIPROFLOXACIN": "an antibiotic used against anthrax [n -S]\n",
  "CIPROFLOXACINS": "CIPROFLOXACIN, an antibiotic used against anthrax [n]\n",
  "CIRCA": "(Latin) approximately [adv]\n",
  "CIRCADIAN": "occurring every twenty-four hours [adj]\n",
  "CIRCAR": "(Urdu) the state or government; the authorities, also SIRCAR, SIRKAR [n -S]\n",
  "CIRCARS": "CIRCAR, (Urdu) the state or government; the authorities, also SIRCAR, SIRKAR [n]\n",
  "CIRCASSIAN": "a kind of light cashmere, also CIRCASSIENNE [n -S]\n",
  "CIRCASSIANS": "CIRCASSIAN, a kind of light cashmere, also CIRCASSIENNE [n]\n",
  "CIRCASSIENNE": "a kind of light cashmere, also CIRCASSIAN [n -S]\n",
  "CIRCASSIENNES": "CIRCASSIENNE, a kind of light cashmere, also CIRCASSIAN [n]\n",
  "CIRCENSIAL": "(obsolete) of or pertaining to, or held in, the Circus, in Rome, also CIRCENSIAN [adj]\n",
  "CIRCENSIAN": "of or pertaining to, or held in, the Circus, in Rome, also CIRCENSIAL [adj]\n",
  "CIRCINATE": "rolled up with its apex in the centre, like a young fern [adj CIRCINATELY]\n",
  "CIRCINATELY": "CIRCINATE, rolled up with its apex in the centre, like a young fern [adv]\n",
  "CIRCITER": "(Latin) formerly used with dates, about; around [prep]\n",
  "CIRCLE": "to revolve around [v CIRCLED, CIRCLING, CIRCLES]\n",
  "CIRCLED": "CIRCLE, to revolve around [v]\n",
  "CIRCLER": "one who encircles [n -S]\n",
  "CIRCLERS": "CIRCLER, one who encircles [n]\n",
  "CIRCLES": "CIRCLE, to revolve around [v]\n",
  "CIRCLET": "a ring-shaped object [n -S]\n",
  "CIRCLETS": "CIRCLET, a ring-shaped object [n]\n",
  "CIRCLING": "the act of circling [n -S]\n",
  "CIRCLINGS": "CIRCLING, the act of circling [n]\n",
  "CIRCLIP": "a spring washer in the form of an incomplete circle, used as a retaining ring [n -S]\n",
  "CIRCLIPS": "CIRCLIP, a spring washer in the form of an incomplete circle, used as a retaining ring [n]\n",
  "CIRCS": "(colloquial) circumstances [n]\n",
  "CIRCUIT": "to move around [v -ED, -ING, -S]\n",
  "CIRCUITAL": "relating to a circuit [adj]\n",
  "CIRCUITED": "CIRCUIT, to move around [v]\n",
  "CIRCUITEER": "of a judge, to go on circuit [v -ED, -ING, -S]\n",
  "CIRCUITEERED": "CIRCUITEER, of a judge, to go on circuit [v]\n",
  "CIRCUITEERING": "CIRCUITEER, of a judge, to go on circuit [v]\n",
  "CIRCUITEERS": "CIRCUITEER, of a judge, to go on circuit [v]\n",
  "CIRCUITIES": "CIRCUITY, a roundabout course [n]\n",
  "CIRCUITING": "CIRCUIT, to move around [v]\n",
  "CIRCUITOUS": "having a circular or winding course [adj]\n",
  "CIRCUITOUSLY": "CIRCUITOUS, having a circular or winding course [adv]\n",
  "CIRCUITOUSNESS": "CIRCUITOUS, having a circular or winding course [n]\n",
  "CIRCUITRIES": "CIRCUITRY, an assemblage of circuits [n]\n",
  "CIRCUITRY": "an assemblage of circuits [n CIRCUITRIES]\n",
  "CIRCUITS": "CIRCUIT, to move around [v]\n",
  "CIRCUITY": "a roundabout course [n CIRCUITIES]\n",
  "CIRCULABLE": "capable of being circulated, also CIRCULATABLE [adj]\n",
  "CIRCULAR": "in the shape of a circle [adj CIRCULARLY] / a leaflet intended for wide distribution [n -S]\n",
  "CIRCULARISATION": "the process of circularising, also CIRCULARIZATION [n]\n",
  "CIRCULARISE": "to include on the list for a circular, also CIRCULARIZE [v CIRCULARISED, CIRCULARISING, CIRCULARISES]\n",
  "CIRCULARISED": "CIRCULARISE, to include on the list for a circular, also CIRCULARIZE [v]\n",
  "CIRCULARISER": "one who circularises, also CIRCULARIZER [n -S]\n",
  "CIRCULARISERS": "CIRCULARISER, one who circularises, also CIRCULARIZER [n]\n",
  "CIRCULARISES": "CIRCULARISE, to include on the list for a circular, also CIRCULARIZE [v]\n",
  "CIRCULARISING": "CIRCULARISE, to include on the list for a circular, also CIRCULARIZE [v]\n",
  "CIRCULARITIES": "CIRCULARITY, the state of being circular [n]\n",
  "CIRCULARITY": "the state of being circular [n CIRCULARITIES]\n",
  "CIRCULARIZATION": "the process of circularizing, also CIRCULARISATION [n]\n",
  "CIRCULARIZE": "to send circulars to, also CIRCULARISE [v CIRCULARIZED, CIRCULARIZING, CIRCULARIZES]\n",
  "CIRCULARIZED": "CIRCULARIZE, to send circulars to, also CIRCULARISE [v]\n",
  "CIRCULARIZER": "one who circularizes, also CIRCULARISER [n -S]\n",
  "CIRCULARIZERS": "CIRCULARIZER, one who circularizes, also CIRCULARISER [n]\n",
  "CIRCULARIZES": "CIRCULARIZE, to send circulars to, also CIRCULARISE [v]\n",
  "CIRCULARIZING": "CIRCULARIZE, to send circulars to, also CIRCULARISE [v]\n",
  "CIRCULARLY": "CIRCULAR, in the shape of a circle [adv]\n",
  "CIRCULARNESS": "the state of being circular [n -ES]\n",
  "CIRCULARNESSES": "CIRCULARNESS, the state of being circular [n]\n",
  "CIRCULARS": "CIRCULAR, a leaflet intended for wide distribution [n]\n",
  "CIRCULATABLE": "capable of being circulated, also CIRCULABLE [adj]\n",
  "CIRCULATE": "to go round [v CIRCULATED, CIRCULATING, CIRCULATES]\n",
  "CIRCULATED": "CIRCULATE, to go round [v]\n",
  "CIRCULATES": "CIRCULATE, to go round [v]\n",
  "CIRCULATING": "the act of distributing e.g. a magazine [n -S]\n",
  "CIRCULATINGS": "CIRCULATING, the act of distributing e.g. a magazine [n]\n",
  "CIRCULATION": "the movement of the blood round the body [n -S]\n",
  "CIRCULATIONS": "CIRCULATION, the movement of the blood round the body [n]\n",
  "CIRCULATIVE": "circulating, also CIRCULATORY [adj]\n",
  "CIRCULATOR": "one who circulates [n -S]\n",
  "CIRCULATORS": "CIRCULATOR, one who circulates [n]\n",
  "CIRCULATORY": "circulating, also CIRCULATIVE [adj]\n",
  "CIRCUMAMBAGES": "roundabout methods of speech [n]\n",
  "CIRCUMAMBAGIOUS": "roundabout in speech [adj]\n",
  "CIRCUMAMBIENCE": "the act of going round, encompassing, also CIRCUMAMBIENCY [n -S]\n",
  "CIRCUMAMBIENCES": "CIRCUMAMBIENCE, the act of going round, encompassing, also CIRCUMAMBIENCY [n]\n",
  "CIRCUMAMBIENCY": "the act of going round, encompassing, also CIRCUMAMBIENCE [n]\n",
  "CIRCUMAMBIENT": "going round about; encompassing [adj CIRCUMAMBIENTLY]\n",
  "CIRCUMAMBIENTLY": "CIRCUMAMBIENT, going round about; encompassing [adv]\n",
  "CIRCUMAMBULATE": "to circle on foot esp. ritualistically [v CIRCUMAMBULATED, CIRCUMAMBULATES]\n",
  "CIRCUMAMBULATED": "CIRCUMAMBULATE, to circle on foot esp. ritualistically [v]\n",
  "CIRCUMAMBULATES": "CIRCUMAMBULATE, to circle on foot esp. ritualistically [v]\n",
  "CIRCUMAMBULATOR": "one who circumambulates [n]\n",
  "CIRCUMBENDIBUS": "an indirect or roundabout course, esp. in speaking or writing, circumlocution [n]\n",
  "CIRCUMCENTER": "the point at which the perpendicular bisectors of the sides of a triangle intersect and which is equidistant from the three vertices, also CIRCUMCENTRE [n -S]\n",
  "CIRCUMCENTERS": "CIRCUMCENTER, the point at which the perpendicular bisectors of the sides of a triangle intersect and which is equidistant from the three vertices, also CIRCUMCENTRE [n]\n",
  "CIRCUMCENTRE": "the point at which the perpendicular bisectors of the sides of a triangle intersect and which is equidistant from the three vertices, also CIRCUMCENTER [n -S]\n",
  "CIRCUMCENTRES": "CIRCUMCENTRE, the point at which the perpendicular bisectors of the sides of a triangle intersect and which is equidistant from the three vertices, also CIRCUMCENTER [n]\n",
  "CIRCUMCIRCLE": "a circle which passes through all the vertices of a polygon, such as a triangle [n -S]\n",
  "CIRCUMCIRCLES": "CIRCUMCIRCLE, a circle which passes through all the vertices of a polygon, such as a triangle [n]\n",
  "CIRCUMCISE": "to cut off the foreskin of (a male) or the clitoris of (a female) [v CIRCUMCISED, CIRCUMCISING, CIRCUMCISES]\n",
  "CIRCUMCISED": "CIRCUMCISE, to cut off the foreskin of (a male) or the clitoris of (a female) [v]\n",
  "CIRCUMCISER": "one who circumcises [n -S]\n",
  "CIRCUMCISERS": "CIRCUMCISER, one who circumcises [n]\n",
  "CIRCUMCISES": "CIRCUMCISE, to cut off the foreskin of (a male) or the clitoris of (a female) [v]\n",
  "CIRCUMCISING": "CIRCUMCISE, to cut off the foreskin of (a male) or the clitoris of (a female) [v]\n",
  "CIRCUMCISION": "the act of circumcising [n -S]\n",
  "CIRCUMCISIONS": "CIRCUMCISION, the act of circumcising [n]\n",
  "CIRCUMDUCE": "(Scots) to declare elapsed, as the time allowed for introducing evidence [v CIRCUMDUCED, CIRCUMDUCING, CIRCUMDUCES]\n",
  "CIRCUMDUCED": "CIRCUMDUCE, (Scots) to declare elapsed, as the time allowed for introducing evidence [v]\n",
  "CIRCUMDUCES": "CIRCUMDUCE, (Scots) to declare elapsed, as the time allowed for introducing evidence [v]\n",
  "CIRCUMDUCING": "CIRCUMDUCE, (Scots) to declare elapsed, as the time allowed for introducing evidence [v]\n",
  "CIRCUMDUCT": "to cause to revolve around an imaginary axis [v -ED, -ING, -S]\n",
  "CIRCUMDUCTED": "CIRCUMDUCT, to cause to revolve around an imaginary axis [v]\n",
  "CIRCUMDUCTING": "CIRCUMDUCT, to cause to revolve around an imaginary axis [v]\n",
  "CIRCUMDUCTION": "the act of circumducing [n -S]\n",
  "CIRCUMDUCTIONS": "CIRCUMDUCTION, the act of circumducing [n]\n",
  "CIRCUMDUCTORY": "relating to circumduction [adj]\n",
  "CIRCUMDUCTS": "CIRCUMDUCT, to cause to revolve around an imaginary axis [v]\n",
  "CIRCUMFERENCE": "the perimeter of a circle [n -S]\n",
  "CIRCUMFERENCES": "CIRCUMFERENCE, the perimeter of a circle [n]\n",
  "CIRCUMFERENTIAL": "relating to circumference [adj]\n",
  "CIRCUMFERENTOR": "a surveyor's angle-measuring compass instrument [n -S]\n",
  "CIRCUMFERENTORS": "CIRCUMFERENTOR, a surveyor's angle-measuring compass instrument [n]\n",
  "CIRCUMFLECT": "to bend round; to mark with a circumflex [v -ED, -ING, -S]\n",
  "CIRCUMFLECTED": "CIRCUMFLECT, to bend round; to mark with a circumflex [v]\n",
  "CIRCUMFLECTING": "CIRCUMFLECT, to bend round; to mark with a circumflex [v]\n",
  "CIRCUMFLECTS": "CIRCUMFLECT, to bend round; to mark with a circumflex [v]\n",
  "CIRCUMFLEX": "a mark used over a vowel in certain languages or in phonetic keys to indicate quality of pronunciation [n -ES]\n",
  "CIRCUMFLEXES": "CIRCUMFLEX, a mark used over a vowel in certain languages or in phonetic keys to indicate quality of pronunciation [n]\n",
  "CIRCUMFLEXION": "a bending round [n -S]\n",
  "CIRCUMFLEXIONS": "CIRCUMFLEXION, a bending round [n]\n",
  "CIRCUMFLUENCE": "a flowing round [n -S]\n",
  "CIRCUMFLUENCES": "CIRCUMFLUENCE, a flowing round [n]\n",
  "CIRCUMFLUENT": "flowing round, also CIRCUMFLUOUS [adj]\n",
  "CIRCUMFLUOUS": "flowing around, also CIRCUMFLUENT [adj]\n",
  "CIRCUMFORANEAN": "wandering about as from market to market, vagrant, also CIRCUMFORANEOUS [adj]\n",
  "CIRCUMFORANEOUS": "wandering about as from market to market, vagrant, also CIRCUMFORANEAN [adj]\n",
  "CIRCUMFUSE": "to pour around or about [v CIRCUMFUSED, CIRCUMFUSING, CIRCUMFUSES]\n",
  "CIRCUMFUSED": "CIRCUMFUSE, to pour around or about [v]\n",
  "CIRCUMFUSES": "CIRCUMFUSE, to pour around or about [v]\n",
  "CIRCUMFUSILE": "molten; poured around or about [adj]\n",
  "CIRCUMFUSING": "CIRCUMFUSE, to pour around or about [v]\n",
  "CIRCUMFUSION": "the act of circumfusing, pouring around [n -S]\n",
  "CIRCUMFUSIONS": "CIRCUMFUSION, the act of circumfusing, pouring around [n]\n",
  "CIRCUMGYRATE": "to whirl or roll round [v CIRCUMGYRATED, CIRCUMGYRATING, CIRCUMGYRATES]\n",
  "CIRCUMGYRATED": "CIRCUMGYRATE, to whirl or roll round [v]\n",
  "CIRCUMGYRATES": "CIRCUMGYRATE, to whirl or roll round [v]\n",
  "CIRCUMGYRATING": "CIRCUMGYRATE, to whirl or roll round [v]\n",
  "CIRCUMGYRATION": "a whirling around [n -S]\n",
  "CIRCUMGYRATIONS": "CIRCUMGYRATION, a whirling around [n]\n",
  "CIRCUMGYRATORY": "whirling around [adj]\n",
  "CIRCUMINCESSION": "the reciprocal existence of three parts of the Trinity in each other, also CIRCUMINSESSION [n]\n",
  "CIRCUMINSESSION": "the reciprocal existence of three parts of the Trinity in each other, also CIRCUMINCESSION [n]\n",
  "CIRCUMJACENCIES": "CIRCUMJACENCY, the state of being circumjacent, lying around [n]\n",
  "CIRCUMJACENCY": "the state of being circumjacent, lying around [n CIRCUMJACENCIES]\n",
  "CIRCUMJACENT": "bordering on every side [adj]\n",
  "CIRCUMLITTORAL": "around or near the shore [adj]\n",
  "CIRCUMLOCUTE": "to use circumlocution [v CIRCUMLOCUTED, CIRCUMLOCUTING, CIRCUMLOCUTES]\n",
  "CIRCUMLOCUTED": "CIRCUMLOCUTE, to use circumlocution [v]\n",
  "CIRCUMLOCUTES": "CIRCUMLOCUTE, to use circumlocution [v]\n",
  "CIRCUMLOCUTING": "CIRCUMLOCUTE, to use circumlocution [v]\n",
  "CIRCUMLOCUTION": "an overly complicated means of expression [n -S]\n",
  "CIRCUMLOCUTIONS": "CIRCUMLOCUTION, an overly complicated means of expression [n]\n",
  "CIRCUMLOCUTORY": "relating to circumlocution [adj]\n",
  "CIRCUMLUNAR": "situated or moving round the moon [adj]\n",
  "CIRCUMMURE": "(Shakespeare) to wall round [v CIRCUMMURED, CIRCUMMURING, CIRCUMMURES]\n",
  "CIRCUMMURED": "CIRCUMMURE, (Shakespeare) to wall round [v]\n",
  "CIRCUMMURES": "CIRCUMMURE, (Shakespeare) to wall round [v]\n",
  "CIRCUMMURING": "CIRCUMMURE, (Shakespeare) to wall round [v]\n",
  "CIRCUMNAVIGABLE": "able to be circumnavigated [adj]\n",
  "CIRCUMNAVIGATE": "to go completely around, as the earth, esp. by water [v CIRCUMNAVIGATED, CIRCUMNAVIGATES]\n",
  "CIRCUMNAVIGATED": "CIRCUMNAVIGATE, to go completely around, as the earth, esp. by water [v]\n",
  "CIRCUMNAVIGATES": "CIRCUMNAVIGATE, to go completely around, as the earth, esp. by water [v]\n",
  "CIRCUMNAVIGATOR": "one who circumnavigates [n]\n",
  "CIRCUMNUTATE": "to proceed with a spiral motion [v CIRCUMNUTATED, CIRCUMNUTATING, CIRCUMNUTATES]\n",
  "CIRCUMNUTATED": "CIRCUMNUTATE, to proceed with a spiral motion [v]\n",
  "CIRCUMNUTATES": "CIRCUMNUTATE, to proceed with a spiral motion [v]\n",
  "CIRCUMNUTATING": "CIRCUMNUTATE, to proceed with a spiral motion [v]\n",
  "CIRCUMNUTATION": "rotation in a nodding position, as the helical path described by the growing point of a plant [n -S]\n",
  "CIRCUMNUTATIONS": "CIRCUMNUTATION, rotation in a nodding position, as the helical path described by the growing point of a plant [n]\n",
  "CIRCUMNUTATORY": "showing circumnutation [adj]\n",
  "CIRCUMPOLAR": "continually visible above the horizon [adj]\n",
  "CIRCUMPOSE": "to place around [v CIRCUMPOSED, CIRCUMPOSING, CIRCUMPOSES]\n",
  "CIRCUMPOSED": "CIRCUMPOSE, to place around [v]\n",
  "CIRCUMPOSES": "CIRCUMPOSE, to place around [v]\n",
  "CIRCUMPOSING": "CIRCUMPOSE, to place around [v]\n",
  "CIRCUMPOSITION": "the act of placing round [n -S]\n",
  "CIRCUMPOSITIONS": "CIRCUMPOSITION, the act of placing round [n]\n",
  "CIRCUMROTATE": "to rotate as a wheel [v CIRCUMROTATED, CIRCUMROTATING, CIRCUMROTATES]\n",
  "CIRCUMROTATED": "CIRCUMROTATE, to rotate as a wheel [v]\n",
  "CIRCUMROTATES": "CIRCUMROTATE, to rotate as a wheel [v]\n",
  "CIRCUMROTATING": "CIRCUMROTATE, to rotate as a wheel [v]\n",
  "CIRCUMSCISSILE": "splitting completely around the centre, the top valve coming off like a lid [adj]\n",
  "CIRCUMSCRIBABLE": "able to be circumscribed [adj]\n",
  "CIRCUMSCRIBE": "to draw a line around, to surround by or as if by a boundary [v CIRCUMSCRIBED, CIRCUMSCRIBING, CIRCUMSCRIBES]\n",
  "CIRCUMSCRIBED": "CIRCUMSCRIBE, to draw a line around, to surround by or as if by a boundary [v]\n",
  "CIRCUMSCRIBER": "one who circumscribes [n -S]\n",
  "CIRCUMSCRIBERS": "CIRCUMSCRIBER, one who circumscribes [n]\n",
  "CIRCUMSCRIBES": "CIRCUMSCRIBE, to draw a line around, to surround by or as if by a boundary [v]\n",
  "CIRCUMSCRIBING": "CIRCUMSCRIBE, to draw a line around, to surround by or as if by a boundary [v]\n",
  "CIRCUMSCRIPTION": "the act of circumscribing, drawing a line around [n]\n",
  "CIRCUMSCRIPTIVE": "marking the external form or outline [adj]\n",
  "CIRCUMSOLAR": "situated or moving round the sun [adj]\n",
  "CIRCUMSPECT": "careful to consider all circumstances and possible consequences [adj CIRCUMSPECTLY]\n",
  "CIRCUMSPECTION": "the state of being circumspect [n -S]\n",
  "CIRCUMSPECTIONS": "CIRCUMSPECTION, the state of being circumspect [n]\n",
  "CIRCUMSPECTIVE": "looking around; wary [adj]\n",
  "CIRCUMSPECTLY": "CIRCUMSPECT, careful to consider all circumstances and possible consequences [adv]\n",
  "CIRCUMSPECTNESS": "the state of being circumspect [n]\n",
  "CIRCUMSTANCE": "a condition, fact, or event accompanying, conditioning, or determining another [n -S] / to place in particular circumstances [v CIRCUMSTANCED, CIRCUMSTANCING, CIRCUMSTANCES]\n",
  "CIRCUMSTANCED": "CIRCUMSTANCE, to place in particular circumstances [v]\n",
  "CIRCUMSTANCES": "CIRCUMSTANCE, to place in particular circumstances [v]\n",
  "CIRCUMSTANCING": "CIRCUMSTANCE, to place in particular circumstances [v]\n",
  "CIRCUMSTANTIAL": "belonging to, consisting in, or dependent on circumstances [n -S]\n",
  "CIRCUMSTANTIALS": "CIRCUMSTANTIAL, belonging to, consisting in, or dependent on circumstances [n]\n",
  "CIRCUMSTANTIATE": "to supply with circumstantial evidence or support [v]\n",
  "CIRCUMSTELLAR": "surrounding or occurring in the vicinity of a star [adj]\n",
  "CIRCUMVALLATE": "to surround with a rampart or fortification [v CIRCUMVALLATED, CIRCUMVALLATING, CIRCUMVALLATES]\n",
  "CIRCUMVALLATED": "CIRCUMVALLATE, to surround with a rampart or fortification [v]\n",
  "CIRCUMVALLATES": "CIRCUMVALLATE, to surround with a rampart or fortification [v]\n",
  "CIRCUMVALLATING": "CIRCUMVALLATE, to surround with a rampart or fortification [v]\n",
  "CIRCUMVALLATION": "a surrounding with a wall [n]\n",
  "CIRCUMVENT": "to go round, to get round [v -ED, -ING, -S]\n",
  "CIRCUMVENTED": "CIRCUMVENT, to go round, to get round [v]\n",
  "CIRCUMVENTER": "one who circumvents, also CIRCUMVENTOR [n -S]\n",
  "CIRCUMVENTERS": "CIRCUMVENTER, one who circumvents, also CIRCUMVENTOR [n]\n",
  "CIRCUMVENTING": "CIRCUMVENT, to go round, to get round [v]\n",
  "CIRCUMVENTION": "the act of circumventing [n -S]\n",
  "CIRCUMVENTIONS": "CIRCUMVENTION, the act of circumventing [n]\n",
  "CIRCUMVENTIVE": "deceiving by artifices [adj]\n",
  "CIRCUMVENTOR": "one who circumvents, also CIRCUMVENTER [n -S]\n",
  "CIRCUMVENTORS": "CIRCUMVENTOR, one who circumvents, also CIRCUMVENTER [n]\n",
  "CIRCUMVENTS": "CIRCUMVENT, to go round, to get round [v]\n",
  "CIRCUMVOLUTION": "anything winding or sinuous [n -S]\n",
  "CIRCUMVOLUTIONS": "CIRCUMVOLUTION, anything winding or sinuous [n]\n",
  "CIRCUMVOLUTORY": "winding around [adj]\n",
  "CIRCUMVOLVE": "to roll round [v CIRCUMVOLVED, CIRCUMVOLVING, CIRCUMVOLVES]\n",
  "CIRCUMVOLVED": "CIRCUMVOLVE, to roll round [v]\n",
  "CIRCUMVOLVES": "CIRCUMVOLVE, to roll round [v]\n",
  "CIRCUMVOLVING": "CIRCUMVOLVE, to roll round [v]\n",
  "CIRCUS": "a public entertainment [n -ES]\n",
  "CIRCUSES": "CIRCUS, a public entertainment [n]\n",
  "CIRCUSIER": "CIRCUSY, of or like a circus, also CIRCUSSY [adj]\n",
  "CIRCUSIEST": "CIRCUSY, of or like a circus, also CIRCUSSY [adj]\n",
  "CIRCUSSIER": "CIRCUSSY, of or like a circus, also CIRCUSY [adj]\n",
  "CIRCUSSIEST": "CIRCUSSY, of or like a circus, also CIRCUSY [adj]\n",
  "CIRCUSSY": "of or like a circus, also CIRCUSY [adj CIRCUSSIER, CIRCUSSIEST]\n",
  "CIRCUSY": "of or like a circus, also CIRCUSSY [adj CIRCUSIER, CIRCUSIEST]\n",
  "CIRE": "(French) a fabric with a waxed finish [n -S]\n",
  "CIRES": "CIRE, (French) a fabric with a waxed finish [n]\n",
  "CIRL": "a species of bunting [n -S]\n",
  "CIRLS": "CIRL, a species of bunting [n]\n",
  "CIRQUE": "(French) a bowl-shaped depression on a mountain that is carved out by an Alpine glacier [n -S]\n",
  "CIRQUES": "CIRQUE, (French) a bowl-shaped depression on a mountain that is carved out by an Alpine glacier [n]\n",
  "CIRRATE": "like a cirrus, also CIRROSE [adj]\n",
  "CIRRHIPEDE": "an erroneous form of cirripede, a subclass of marine crustacea, also CIRRIPED, CIRRIPEDE [n -S]\n",
  "CIRRHIPEDES": "CIRRHIPEDE, an erroneous form of cirripede, a subclass of marine crustacea, also CIRRIPED, CIRRIPEDE [n]\n",
  "CIRRHOSED": "affected by cirrhosis, a disease of the liver caused by alcoholism [adj]\n",
  "CIRRHOSES": "CIRRHOSIS, a disease of the liver caused by alcoholism [n]\n",
  "CIRRHOSIS": "a disease of the liver caused by alcoholism [n CIRRHOSES]\n",
  "CIRRHOTIC": "pertaining to, caused by, or affected with, cirrhosis [adj] / a sufferer from cirrhosis [n -S]\n",
  "CIRRHOTICS": "CIRRHOTIC, a sufferer from cirrhosis [n]\n",
  "CIRRI": "CIRRUS, (Latin) a type of cloud [n]\n",
  "CIRRIFORM": "formed like a cirrus or tendril [adj]\n",
  "CIRRIGRADE": "moving or moved by cirri, or hairlike appendages [adj]\n",
  "CIRRIPED": "a barnacle or other parasitic marine crustacean, also CIRRHIPEDE, CIRRIPEDE [n -S]\n",
  "CIRRIPEDE": "a barnacle or other parasitic marine crustacean, also CIRRHIPEDE, CIRRIPED [n -S]\n",
  "CIRRIPEDES": "CIRRIPEDE, a barnacle or other parasitic marine crustacean, also CIRRHIPEDE, CIRRIPED [n]\n",
  "CIRRIPEDS": "CIRRIPED, a barnacle or other parasitic marine crustacean, also CIRRHIPEDE, CIRRIPEDE [n]\n",
  "CIRROCUMULI": "CIRROCUMULUS, (Latin) a type of cloud [n]\n",
  "CIRROCUMULUS": "(Latin) a type of cloud [n CIRROCUMULI]\n",
  "CIRROSE": "like a cirrus, also CIRRATE [adj]\n",
  "CIRROSTRATI": "CIRROSTRATUS, (Latin) a type of cloud [n]\n",
  "CIRROSTRATIVE": "of or like cirrostratus [adj]\n",
  "CIRROSTRATUS": "(Latin) a type of cloud [n CIRROSTRATI]\n",
  "CIRROUS": "having a cirrus [adj]\n",
  "CIRRUS": "(Latin) a type of cloud [n CIRRI or CIRRUSES]\n",
  "CIRRUSES": "CIRRUS, (Latin) a type of cloud [n]\n",
  "CIRSOID": "having the appearance of a varicose vein [adj]\n",
  "CIS": "having atoms on the same side of the molecule [adj]\n",
  "CISALPINE": "on the hither side of the Alps with reference to Rome, that is, on the south side of the Alps [adj]\n",
  "CISCO": "a North American lake fish [n CISCOS or CISCOES]\n",
  "CISCOES": "CISCO, a North American lake fish [n]\n",
  "CISCOS": "CISCO, a North American lake fish [n]\n",
  "CISELEUR": "(French) a chaser (of metal) [n -S]\n",
  "CISELEURS": "CISELEUR, (French) a chaser (of metal) [n]\n",
  "CISELURE": "(French) the art of chasing metal [n -S]\n",
  "CISELURES": "CISELURE, (French) the art of chasing metal [n]\n",
  "CISGENDER": "of or relating to a person whose gender identity corresponds to the assumed gender assigned to them at birth, also CISGENDERED [adj]\n",
  "CISGENDERED": "of or relating to a person whose gender identity corresponds to the assumed gender assigned to them at birth, also CISGENDER [adj]\n",
  "CISLUNAR": "situated between the earth and moon [adj]\n",
  "CISMONTANE": "on this or the near side of the mountains [adj]\n",
  "CISPADANE": "on the hither side of the river Po with reference to Rome; that is, on the south side [adj]\n",
  "CISPLATIN": "a platinum-containing neoplastic drug used esp. in the treatment of ovarian and testicular tumours [n -S]\n",
  "CISPLATINS": "CISPLATIN, a platinum-containing neoplastic drug used esp. in the treatment of ovarian and testicular tumours [n]\n",
  "CISPONTINE": "on this side of the bridges, i.e. in London, north of the Thames [adj]\n",
  "CISSIER": "CISSY, timid, also SISSY [adj]\n",
  "CISSIES": "CISSY, an effeminate boy [n]\n",
  "CISSIEST": "CISSY, timid, also SISSY [adj]\n",
  "CISSIFIED": "like a cissy, also SISSIFIED [adj]\n",
  "CISSING": "the appearance of pinholes in paintwork due to poor adhesion to the surface [n -S]\n",
  "CISSINGS": "CISSING, the appearance of pinholes in paintwork due to poor adhesion to the surface [n]\n",
  "CISSOID": "a type of geometric curve [n -S]\n",
  "CISSOIDS": "CISSOID, a type of geometric curve [n]\n",
  "CISSUS": "a genus of tropical climbing plants, that includes the kangaroo vine [n -ES]\n",
  "CISSUSES": "CISSUS, a genus of tropical climbing plants, that includes the kangaroo vine [n]\n",
  "CISSY": "an effeminate boy [n CISSIES] / timid, also SISSY [adj CISSIER, CISSIEST]\n",
  "CIST": "a tomb consisting of a stone chest covered with stone slabs [n -S]\n",
  "CISTACEOUS": "of or like a Cistus, the rockrose genus [adj]\n",
  "CISTED": "containing cists [adj]\n",
  "CISTERN": "an artificial reservoir for storing water, esp. one in the roof-space of a house etc. [n -S]\n",
  "CISTERNA": "(Latin) a fluid-containing sac [n CISTERNAE]\n",
  "CISTERNAE": "CISTERNA, (Latin) a fluid-containing sac [n]\n",
  "CISTERNAL": "relating to a cisterna, a sac or space containing e.g. cerebrospinal fluid [adj]\n",
  "CISTERNS": "CISTERN, an artificial reservoir for storing water, esp. one in the roof-space of a house etc. [n]\n",
  "CISTIC": "like a cist [adj]\n",
  "CISTRON": "a section of a chromosome which controls a single function [n -S]\n",
  "CISTRONIC": "relating to a cistron, a section of a chromosome which controls a single function [adj]\n",
  "CISTRONS": "CISTRON, a section of a chromosome which controls a single function [n]\n",
  "CISTS": "CIST, a tomb consisting of a stone chest covered with stone slabs [n]\n",
  "CISTUS": "(Greek) any plant of the rockrose genus [n -ES]\n",
  "CISTUSES": "CISTUS, (Greek) any plant of the rockrose genus [n]\n",
  "CISTVAEN": "(Welsh) a tomb covered with stone slabs, also KISTVAEN [n -S]\n",
  "CISTVAENS": "CISTVAEN, (Welsh) a tomb covered with stone slabs, also KISTVAEN [n]\n",
  "CIT": "(archaic) a contemptuous term for one who is not a gentleman [n -S]\n",
  "CITABLE": "suitable for citation, also CITEABLE [adj]\n",
  "CITADEL": "a fortress in or near a city [n -S]\n",
  "CITADELS": "CITADEL, a fortress in or near a city [n]\n",
  "CITAL": "a summons to appear, as before a judge [n -S]\n",
  "CITALS": "CITAL, a summons to appear, as before a judge [n]\n",
  "CITATION": "an official summons to appear [n -S]\n",
  "CITATIONAL": "relating to a citation [adj]\n",
  "CITATIONS": "CITATION, an official summons to appear [n]\n",
  "CITATOR": "one who cites [n -S]\n",
  "CITATORS": "CITATOR, one who cites [n]\n",
  "CITATORY": "relating to a citation [adj]\n",
  "CITE": "to quote as an authority or example [v CITED, CITING, CITES]\n",
  "CITEABLE": "suitable for citation, also CITABLE [adj]\n",
  "CITED": "CITE, to quote as an authority or example [v]\n",
  "CITER": "one who cites [n -S]\n",
  "CITERS": "CITER, one who cites [n]\n",
  "CITES": "CITE, to quote as an authority or example [v]\n",
  "CITESS": "(archaic) one who is not a gentlewoman [n -ES]\n",
  "CITESSES": "CITESS, (archaic) one who is not a gentlewoman [n]\n",
  "CITHARA": "(Greek) an ancient musical instrument like a lyre, also KITHARA [n -S]\n",
  "CITHARAS": "CITHARA, (Greek) an ancient musical instrument like a lyre, also KITHARA [n]\n",
  "CITHARIST": "a player of the cithara, an ancient Greek musical instrument like a lyre [n -S]\n",
  "CITHARISTIC": "relating to the playing of the cithara [adj]\n",
  "CITHARISTS": "CITHARIST, a player of the cithara, an ancient Greek musical instrument like a lyre [n]\n",
  "CITHER": "a pear-shaped guitar, also CITHERN, CITHREN, CITOLA, CITOLE, CITTERN [n -S]\n",
  "CITHERN": "a pear-shaped guitar, also CITHER, CITHREN, CITOLA, CITOLE, CITTERN [n -S]\n",
  "CITHERNS": "CITHERN, a pear-shaped guitar, also CITHER, CITHREN, CITOLA, CITOLE, CITTERN [n]\n",
  "CITHERS": "CITHER, a pear-shaped guitar, also CITHERN, CITHREN, CITOLA, CITOLE, CITTERN [n]\n",
  "CITHREN": "a pear-shaped guitar, also CITHER, CITHERN, CITOLA, CITOLE, CITTERN [n -S]\n",
  "CITHRENS": "CITHREN, a pear-shaped guitar, also CITHER, CITHERN, CITOLA, CITOLE, CITTERN [n]\n",
  "CITIED": "having cities [adj]\n",
  "CITIES": "CITY, a large town [n]\n",
  "CITIFICATION": "the act of citifying, also CITYFICATION [n -S]\n",
  "CITIFICATIONS": "CITIFICATION, the act of citifying, also CITYFICATION [n]\n",
  "CITIFIED": "CITIFY, to adapt to the city, also CITYFY [v]\n",
  "CITIFIES": "CITIFY, to adapt to the city, also CITYFY [v]\n",
  "CITIFY": "to adapt to the city, also CITYFY [v CITIFIED, CITIFYING, CITIFIES]\n",
  "CITIFYING": "CITIFY, to adapt to the city, also CITYFY [v]\n",
  "CITIGRADE": "moving quickly, applied specifically to the Lycosidae or wolf-spiders that run down their prey [adj]\n",
  "CITING": "CITE, to quote as an authority or example [v]\n",
  "CITIZEN": "a resident of a city [n -S]\n",
  "CITIZENESS": "a female citizen [n -ES]\n",
  "CITIZENESSES": "CITIZENESS, a female citizen [n]\n",
  "CITIZENISE": "to make a citizen of, also CITIZENIZE [v CITIZENISED, CITIZENISING, CITIZENISES]\n",
  "CITIZENISED": "CITIZENISE, to make a citizen of, also CITIZENIZE [v]\n",
  "CITIZENISES": "CITIZENISE, to make a citizen of, also CITIZENIZE [v]\n",
  "CITIZENISING": "CITIZENISE, to make a citizen of, also CITIZENIZE [v]\n",
  "CITIZENIZE": "to make a citizen of, also CITIZENISE [v CITIZENIZED, CITIZENIZING, CITIZENIZES]\n",
  "CITIZENIZED": "CITIZENIZE, to make a citizen of, also CITIZENISE [v]\n",
  "CITIZENIZES": "CITIZENIZE, to make a citizen of, also CITIZENISE [v]\n",
  "CITIZENIZING": "CITIZENIZE, to make a citizen of, also CITIZENISE [v]\n",
  "CITIZENLIER": "CITIZENLY, like a citizen [adj]\n",
  "CITIZENLIEST": "CITIZENLY, like a citizen [adj]\n",
  "CITIZENLY": "like a citizen [adj CITIZENLIER, CITIZENLIEST]\n",
  "CITIZENRIES": "CITIZENRY, a whole body of citizens [n]\n",
  "CITIZENRY": "a whole body of citizens [n CITIZENRIES]\n",
  "CITIZENS": "CITIZEN, a resident of a city [n]\n",
  "CITIZENSHIP": "the status of being a citizen [n -S]\n",
  "CITIZENSHIPS": "CITIZENSHIP, the status of being a citizen [n]\n",
  "CITO": "(Latin) quickly [adv]\n",
  "CITOLA": "a pear-shaped guitar, also CITHER, CITHERN, CITHREN, CITOLE, CITTERN [n -S]\n",
  "CITOLAS": "CITOLA, a pear-shaped guitar, also CITHER, CITHERN, CITHREN, CITOLE, CITTERN [n]\n",
  "CITOLE": "a pear-shaped guitar, also CITHER, CITHERN, CITHREN, CITOLA, CITTERN [n -S]\n",
  "CITOLES": "CITOLE, a pear-shaped guitar, also CITHER, CITHERN, CITHREN, CITOLA, CITTERN [n]\n",
  "CITRAL": "a lemon flavouring [n -S]\n",
  "CITRALS": "CITRAL, a lemon flavouring [n]\n",
  "CITRANGE": "a hybrid between citron and orange [n -S]\n",
  "CITRANGES": "CITRANGE, a hybrid between citron and orange [n]\n",
  "CITRATE": "a salt of citric acid [n -S]\n",
  "CITRATED": "combined with a citrate, a salt or ester of citric acid [adj]\n",
  "CITRATES": "CITRATE, a salt of citric acid [n]\n",
  "CITREOUS": "having a lemonlike colour [adj]\n",
  "CITRIC": "derived from citrus fruit [adj]\n",
  "CITRICULTURE": "the cultivation of citrus fruits [n -S]\n",
  "CITRICULTURES": "CITRICULTURE, the cultivation of citrus fruits [n]\n",
  "CITRICULTURIST": "one who practises citriculture, the cultivation of citrus fruits [n -S]\n",
  "CITRICULTURISTS": "CITRICULTURIST, one who practises citriculture, the cultivation of citrus fruits [n]\n",
  "CITRIN": "the water-soluble vitamin P, found in citrus fruits [n -S]\n",
  "CITRINE": "a variety of quartz [n -S]\n",
  "CITRINES": "CITRINE, a variety of quartz [n]\n",
  "CITRININ": "an antibiotic [n -S]\n",
  "CITRININS": "CITRININ, an antibiotic [n]\n",
  "CITRINS": "CITRIN, the water-soluble vitamin P, found in citrus fruits [n]\n",
  "CITRON": "the fruit of the citron tree, resembling a lemon [n -S]\n",
  "CITRONELLA": "a colourless aldehyde with a lemon scent [n -S]\n",
  "CITRONELLAL": "a colourless aldehyde with a lemon scent, present in citronella and other essential oils [n -S]\n",
  "CITRONELLALS": "CITRONELLAL, a colourless aldehyde with a lemon scent, present in citronella and other essential oils [n]\n",
  "CITRONELLAS": "CITRONELLA, a colourless aldehyde with a lemon scent [n]\n",
  "CITRONELLOL": "an unsaturated liquid alcohol with a roselike odor, used in perfumery and soaps [n -S]\n",
  "CITRONELLOLS": "CITRONELLOL, an unsaturated liquid alcohol with a roselike odor, used in perfumery and soaps [n]\n",
  "CITRONS": "CITRON, the fruit of the citron tree, resembling a lemon [n]\n",
  "CITROUS": "pertaining to a citrus tree [adj]\n",
  "CITRULLINE": "an amino acid formed in the production of urea [n -S]\n",
  "CITRULLINES": "CITRULLINE, an amino acid formed in the production of urea [n]\n",
  "CITRUS": "a citron tree [n -ES]\n",
  "CITRUSES": "CITRUS, a citron tree [n]\n",
  "CITRUSIER": "CITRUSY, pertaining to citrus, also CITRUSSY [adj]\n",
  "CITRUSIEST": "CITRUSY, pertaining to citrus, also CITRUSSY [adj]\n",
  "CITRUSSIER": "CITRUSSY, of or like citrus fruit, also CITRUSY [adj]\n",
  "CITRUSSIEST": "CITRUSSY, of or like citrus fruit, also CITRUSY [adj]\n",
  "CITRUSSY": "of or like citrus fruit, also CITRUSY [adj CITRUSSIER, CITRUSSIEST]\n",
  "CITRUSY": "pertaining to citrus, also CITRUSSY [adj CITRUSIER, CITRUSIEST]\n",
  "CITS": "CIT, (archaic) a contemptuous term for one who is not a gentleman [n]\n",
  "CITTERN": "a pear-shaped guitar, also CITHER, CITHERN, CITHREN, CITOLA, CITOLE [n -S]\n",
  "CITTERNS": "CITTERN, a pear-shaped guitar, also CITHER, CITHERN, CITHREN, CITOLA, CITOLE [n]\n",
  "CITY": "a large town [n CITIES]\n",
  "CITYFICATION": "the act of cityfying, also CITIFICATION [n -S]\n",
  "CITYFICATIONS": "CITYFICATION, the act of cityfying, also CITIFICATION [n]\n",
  "CITYFIED": "CITYFY, to adapt to the city, also CITIFY [v]\n",
  "CITYFIES": "CITYFY, to adapt to the city, also CITIFY [v]\n",
  "CITYFY": "to adapt to the city, also CITIFY [v CITYFIED, CITYFYING, CITYFIES]\n",
  "CITYFYING": "CITYFY, to adapt to the city, also CITIFY [v]\n",
  "CITYSCAPE": "a view of a city [n -S]\n",
  "CITYSCAPES": "CITYSCAPE, a view of a city [n]\n",
  "CITYWARD": "towards the city [adv]\n",
  "CITYWIDE": "including all parts of a city [adj]\n",
  "CIVE": "a herb of the onion family, also CHIVE [n -S]\n",
  "CIVES": "CIVE, a herb of the onion family, also CHIVE [n]\n",
  "CIVET": "any of several carnivorous mammals of the Asian and African family Viverridae, which also includes the genets and mongooses [n -S]\n",
  "CIVETLIKE": "like a civet [adj]\n",
  "CIVETS": "CIVET, any of several carnivorous mammals of the Asian and African family Viverridae, which also includes the genets and mongooses [n]\n",
  "CIVIC": "pertaining to a city [adj CIVICALLY]\n",
  "CIVICALLY": "CIVIC, pertaining to a city [adv]\n",
  "CIVICISM": "a system of government based on individual rights [n -S]\n",
  "CIVICISMS": "CIVICISM, a system of government based on individual rights [n]\n",
  "CIVICS": "the science of civic affairs [n]\n",
  "CIVIE": "(short for) a civilian, also CIVVY [n -S]\n",
  "CIVIES": "CIVIE, (short for) a civilian, also CIVVY [n]\n",
  "CIVIL": "pertaining to citizens; polite [adj CIVILLY] / esp. in the name of companies, civil engineering [n -S]\n",
  "CIVILIAN": "a nonmilitary person [n -S]\n",
  "CIVILIANISATION": "the act of civilianising, also CIVILIANIZATION [n]\n",
  "CIVILIANISE": "to convert from military to civilian use, also CIVILIANIZE [v CIVILIANISED, CIVILIANISING, CIVILIANISES]\n",
  "CIVILIANISED": "CIVILIANISE, to convert from military to civilian use, also CIVILIANIZE [v]\n",
  "CIVILIANISES": "CIVILIANISE, to convert from military to civilian use, also CIVILIANIZE [v]\n",
  "CIVILIANISING": "CIVILIANISE, to convert from military to civilian use, also CIVILIANIZE [v]\n",
  "CIVILIANIZATION": "the act of civilianizing, also CIVILIANISATION [n]\n",
  "CIVILIANIZE": "to convert from military to civilian use, also CIVILIANISE [v CIVILIANIZED, CIVILIANIZING, CIVILIANIZES]\n",
  "CIVILIANIZED": "CIVILIANIZE, to convert from military to civilian use, also CIVILIANISE [v]\n",
  "CIVILIANIZES": "CIVILIANIZE, to convert from military to civilian use, also CIVILIANISE [v]\n",
  "CIVILIANIZING": "CIVILIANIZE, to convert from military to civilian use, also CIVILIANISE [v]\n",
  "CIVILIANS": "CIVILIAN, a nonmilitary person [n]\n",
  "CIVILISABLE": "capable of being civilised, also CIVILIZABLE [adj]\n",
  "CIVILISATION": "the state of being civilised, also CIVILIZATION [n -S]\n",
  "CIVILISATIONAL": "relating to civilisation, also CIVILIZATIONAL [adj]\n",
  "CIVILISATIONS": "CIVILISATION, the state of being civilised, also CIVILIZATION [n]\n",
  "CIVILISE": "to instruct in refinements, also CIVILIZE [v CIVILISED, CIVILISING, CIVILISES]\n",
  "CIVILISED": "CIVILISE, to instruct in refinements, also CIVILIZE [v]\n",
  "CIVILISER": "one who civilises, also CIVILIZER [n -S]\n",
  "CIVILISERS": "CIVILISER, one who civilises, also CIVILIZER [n]\n",
  "CIVILISES": "CIVILISE, to instruct in refinements, also CIVILIZE [v]\n",
  "CIVILISING": "CIVILISE, to instruct in refinements, also CIVILIZE [v]\n",
  "CIVILIST": "a person versed in civil law [n -S]\n",
  "CIVILISTS": "CIVILIST, a person versed in civil law [n]\n",
  "CIVILITIES": "CIVILITY, politeness [n]\n",
  "CIVILITY": "politeness [n CIVILITIES]\n",
  "CIVILIZABLE": "capable of being civilized, also CIVILISABLE [adj]\n",
  "CIVILIZATION": "the state of being civilized, also CIVILISATION [n -S]\n",
  "CIVILIZATIONAL": "relating to civilisation, also CIVILISATIONAL [adj]\n",
  "CIVILIZATIONS": "CIVILIZATION, the state of being civilized, also CIVILISATION [n]\n",
  "CIVILIZE": "to instruct in refinements, also CIVILISE [v CIVILIZED, CIVILIZING, CIVILIZES]\n",
  "CIVILIZED": "CIVILIZE, to instruct in refinements, also CIVILISE [v]\n",
  "CIVILIZER": "one who civilizes, also CIVILISER [n -S]\n",
  "CIVILIZERS": "CIVILIZER, one who civilizes, also CIVILISER [n]\n",
  "CIVILIZES": "CIVILIZE, to instruct in refinements, also CIVILISE [v]\n",
  "CIVILIZING": "CIVILIZE, to instruct in refinements, also CIVILISE [v]\n",
  "CIVILLY": "CIVIL, pertaining to citizens; polite [adv]\n",
  "CIVILNESS": "civility [n -ES]\n",
  "CIVILNESSES": "CIVILNESS, civility [n]\n",
  "CIVILS": "CIVIL, esp. in the name of companies, civil engineering [n]\n",
  "CIVISM": "good citizenship [n -S]\n",
  "CIVISMS": "CIVISM, good citizenship [n]\n",
  "CIVVIES": "CIVVY, (short for) a civilian, also CIVIE [n]\n",
  "CIVVY": "(short for) a civilian, also CIVIE [n CIVVIES]\n",
  "CIZERS": "(Shakespeare) scissors [n]\n",
  "CLABBER": "to curdle, turn sour [v -ED, -ING, -S]\n",
  "CLABBERED": "CLABBER, to curdle, turn sour [v]\n",
  "CLABBERING": "CLABBER, to curdle, turn sour [v]\n",
  "CLABBERS": "CLABBER, to curdle, turn sour [v]\n",
  "CLACH": "(Gaelic) to kill by stoning [v -ED, -ING, -S]\n",
  "CLACHAN": "(Gaelic) a small village, also CLACH [n -S]\n",
  "CLACHANS": "CLACHAN, (Gaelic) a small village, also CLACH [n]\n",
  "CLACHED": "CLACH, (Gaelic) to kill by stoning [v]\n",
  "CLACHES": "CLACH, (Gaelic) to kill by stoning [v]\n",
  "CLACHING": "CLACH, (Gaelic) to kill by stoning [v]\n",
  "CLACHS": "CLACH, (Gaelic) to kill by stoning [v]\n",
  "CLACK": "to make a noise of a hard flat thing flapping [v -ED, -ING, -S]\n",
  "CLACKBOX": "a part of an engine [n -ES]\n",
  "CLACKBOXES": "CLACKBOX, a part of an engine [n]\n",
  "CLACKDISH": "(archaic) a wooden dish carried by beggars, with a moveable lid which they clacked to attract attention, also CLAPDISH [n -ES]\n",
  "CLACKDISHES": "CLACKDISH, (archaic) a wooden dish carried by beggars, with a moveable lid which they clacked to attract attention, also CLAPDISH [n]\n",
  "CLACKED": "CLACK, to make a noise of a hard flat thing flapping [v]\n",
  "CLACKER": "that which clacks; esp. the clapper of a mill [n -S]\n",
  "CLACKERS": "CLACKER, that which clacks; esp. the clapper of a mill [n]\n",
  "CLACKING": "CLACK, to make a noise of a hard flat thing flapping [v]\n",
  "CLACKS": "CLACK, to make a noise of a hard flat thing flapping [v]\n",
  "CLAD": "to cover one material with another [v CLADDED, CLADDING, CLADS]\n",
  "CLADDAGH": "(Irish) an Irish ring with two hands clasping, traditionally given as a token of affection [n -S]\n",
  "CLADDAGHS": "CLADDAGH, (Irish) an Irish ring with two hands clasping, traditionally given as a token of affection [n]\n",
  "CLADDED": "CLAD, to cover one material with another [v]\n",
  "CLADDER": "one who clads [n -S]\n",
  "CLADDERS": "CLADDER, one who clads [n]\n",
  "CLADDIE": "a native New Zealand flax plant, aka korari [n -S]\n",
  "CLADDIES": "CLADDIE, a native New Zealand flax plant, aka korari [n]\n",
  "CLADDING": "a material covering another [n -S]\n",
  "CLADDINGS": "CLADDING, a material covering another [n]\n",
  "CLADE": "a group of organisms that have evolved from a common ancestor [n -S]\n",
  "CLADES": "CLADE, a group of organisms that have evolved from a common ancestor [n]\n",
  "CLADISM": "classification by clades [n -S]\n",
  "CLADISMS": "CLADISM, classification by clades [n]\n",
  "CLADIST": "one who classifies by clades [n -S]\n",
  "CLADISTIC": "relating to cladism, a method of taxonomy [adj CLADISTICALLY]\n",
  "CLADISTICALLY": "CLADISTIC, relating to cladism, a method of taxonomy [adv]\n",
  "CLADISTICS": "taxonomic theory distinguishing by common ancestor [n]\n",
  "CLADISTS": "CLADIST, one who classifies by clades [n]\n",
  "CLADOCERAN": "a small crustacean, aka water flea [n -S]\n",
  "CLADOCERANS": "CLADOCERAN, a small crustacean, aka water flea [n]\n",
  "CLADODE": "a branch or stem with the appearance or function of a leaf [n -S]\n",
  "CLADODES": "CLADODE, a branch or stem with the appearance or function of a leaf [n]\n",
  "CLADODIAL": "like a cladode, a branch or stem with the appearance or function of a leaf [adj]\n",
  "CLADOGENESES": "CLADOGENESIS, the evolutionary change and diversification resulting from the branching off of new species from common ancestral lineages [n]\n",
  "CLADOGENESIS": "the evolutionary change and diversification resulting from the branching off of new species from common ancestral lineages [n CLADOGENESES]\n",
  "CLADOGENETIC": "relating to cladogenesis [adj]\n",
  "CLADOGRAM": "a branching diagram showing the development of a clade [n -S]\n",
  "CLADOGRAMS": "CLADOGRAM, a branching diagram showing the development of a clade [n]\n",
  "CLADOPHYLL": "a special branch, resembling a leaf, as in the apparent foliage of the broom [n -S]\n",
  "CLADOPHYLLS": "CLADOPHYLL, a special branch, resembling a leaf, as in the apparent foliage of the broom [n]\n",
  "CLADOSPORIA": "CLADOSPORIUM, a type of fungus [n]\n",
  "CLADOSPORIUM": "a type of fungus [n CLADOSPORIA]\n",
  "CLADS": "CLAD, to cover one material with another [v]\n",
  "CLAES": "(Scots) clothes [n]\n",
  "CLAFOUTI": "(French) a dessert consisting of a layer of fruit topped with batter and baked [n -S]\n",
  "CLAFOUTIS": "(French) a French baked pudding, also CLAFOUTI [n CLAFOUTIS]\n",
  "CLAG": "to stick [v CLAGGED, CLAGGING, CLAGS]\n",
  "CLAGGED": "CLAG, to stick [v]\n",
  "CLAGGIER": "CLAGGY, sticky [adj]\n",
  "CLAGGIEST": "CLAGGY, sticky [adj]\n",
  "CLAGGING": "CLAG, to stick [v]\n",
  "CLAGGY": "sticky [adj CLAGGIER, CLAGGIEST]\n",
  "CLAGS": "CLAG, to stick [v]\n",
  "CLAIM": "to demand as one's due [v -ED, -ING, -S]\n",
  "CLAIMABLE": "capable of being claimed [adj]\n",
  "CLAIMANT": "one who makes a claim, also CLAIMER [n -S]\n",
  "CLAIMANTS": "CLAIMANT, one who makes a claim, also CLAIMER [n]\n",
  "CLAIMED": "CLAIM, to demand as one's due [v]\n",
  "CLAIMER": "one who makes a claim, also CLAIMANT [n -S]\n",
  "CLAIMERS": "CLAIMER, one who makes a claim, also CLAIMANT [n]\n",
  "CLAIMING": "CLAIM, to demand as one's due [v]\n",
  "CLAIMS": "CLAIM, to demand as one's due [v]\n",
  "CLAIRAUDIENCE": "the ability to hear sounds not actually present, as spirit communications, etc. [n -S]\n",
  "CLAIRAUDIENCES": "CLAIRAUDIENCE, the ability to hear sounds not actually present, as spirit communications, etc. [n]\n",
  "CLAIRAUDIENT": "able to hear sounds not actually present, as spirit communications, etc. [adj CLAIRAUDIENTLY] / a person claiming clairaudient powers [n -S]\n",
  "CLAIRAUDIENTLY": "CLAIRAUDIENT, able to hear sounds not actually present, as spirit communications, etc. [adv]\n",
  "CLAIRAUDIENTS": "CLAIRAUDIENT, a person claiming clairaudient powers [n]\n",
  "CLAIRCOLLE": "a priming coat consisting of size or glue with whiting, also CLEARCOLE [n -S]\n",
  "CLAIRCOLLES": "CLAIRCOLLE, a priming coat consisting of size or glue with whiting, also CLEARCOLE [n]\n",
  "CLAIRSCHACH": "(Gaelic) a Scottish folk harp, also CLARSACH [n -S]\n",
  "CLAIRSCHACHS": "CLAIRSCHACH, (Gaelic) a Scottish folk harp, also CLARSACH [n]\n",
  "CLAIRVOYANCE": "the power of seeing things removed in time or space, also CLAIRVOYANCY [n -S]\n",
  "CLAIRVOYANCES": "CLAIRVOYANCE, the power of seeing things removed in time or space, also CLAIRVOYANCY [n]\n",
  "CLAIRVOYANCIES": "CLAIRVOYANCY, the power of seeing things removed in time or space, also CLAIRVOYANCE [n]\n",
  "CLAIRVOYANCY": "the power of seeing things removed in time or space, also CLAIRVOYANCE [n CLAIRVOYANCIES]\n",
  "CLAIRVOYANT": "(French) having or exercising the faculty of clairvoyance [adj CLAIRVOYANTLY] / one who is clairvoyant [n -S]\n",
  "CLAIRVOYANTLY": "CLAIRVOYANT, (French) having or exercising the faculty of clairvoyance [adv]\n",
  "CLAIRVOYANTS": "CLAIRVOYANT, one who is clairvoyant [n]\n",
  "CLAM": "to dig for the edible shellfish clams [v CLAMMED, CLAMMING, CLAMS]\n",
  "CLAMANCIES": "CLAMANCY, urgency [n]\n",
  "CLAMANCY": "urgency [n CLAMANCIES]\n",
  "CLAMANT": "calling aloud or earnestly [adj CLAMANTLY]\n",
  "CLAMANTLY": "CLAMANT, calling aloud or earnestly [adv]\n",
  "CLAMATORIAL": "relating to the flycatcher family of birds [adj]\n",
  "CLAMBAKE": "the baking or steaming of clams on heated stones, between layers of seaweed [n -S]\n",
  "CLAMBAKES": "CLAMBAKE, the baking or steaming of clams on heated stones, between layers of seaweed [n]\n",
  "CLAMBE": "CLIMB, to ascend [v]\n",
  "CLAMBER": "to climb awkwardly [v -ED, -ING, -S]\n",
  "CLAMBERED": "CLAMBER, to climb awkwardly [v]\n",
  "CLAMBERER": "one who clambers [n -S]\n",
  "CLAMBERERS": "CLAMBERER, one who clambers [n]\n",
  "CLAMBERING": "CLAMBER, to climb awkwardly [v]\n",
  "CLAMBERS": "CLAMBER, to climb awkwardly [v]\n",
  "CLAME": "(Spenser) a call, shout [n -S]\n",
  "CLAMES": "CLAME, (Spenser) a call, shout [n]\n",
  "CLAMJAMFRIES": "CLAMJAMFRY, (Scots) rubbish, nonsense, also CLAMJAMPHRIE, CLANJAMFRAY [n]\n",
  "CLAMJAMFRY": "(Scots) rubbish, nonsense, also CLAMJAMPHRIE, CLANJAMFRAY [n CLAMJAMFRIES]\n",
  "CLAMJAMPHRIE": "(Scots) rubbish, nonsense, also CLAMJAMFRY, CLANJAMFRAY [n -S]\n",
  "CLAMJAMPHRIES": "CLAMJAMPHRIE, (Scots) rubbish, nonsense, also CLAMJAMFRY, CLANJAMFRAY [n]\n",
  "CLAMLIKE": "like a clam [adj]\n",
  "CLAMMED": "CLAM, to dig for the edible shellfish clams [v]\n",
  "CLAMMER": "one who gathers clams esp. by digging [n -S]\n",
  "CLAMMERS": "CLAMMER, one who gathers clams esp. by digging [n]\n",
  "CLAMMIER": "CLAMMY, unpleasantly damp [adj]\n",
  "CLAMMIEST": "CLAMMY, unpleasantly damp [adj]\n",
  "CLAMMILY": "CLAMMY, unpleasantly damp [adv]\n",
  "CLAMMINESS": "the state of being clammy [n -ES]\n",
  "CLAMMINESSES": "CLAMMINESS, the state of being clammy [n]\n",
  "CLAMMING": "CLAM, to dig for the edible shellfish clams [v]\n",
  "CLAMMY": "unpleasantly damp [adj CLAMMIER, CLAMMIEST, CLAMMILY]\n",
  "CLAMOR": "to make a loud outcry, also CLAMOUR [v -ED, -ING, -S]\n",
  "CLAMORED": "CLAMOR, to make a loud outcry, also CLAMOUR [v]\n",
  "CLAMORER": "one who makes a clamor, also CLAMOURER [n -S]\n",
  "CLAMORERS": "CLAMORER, one who makes a clamor, also CLAMOURER [n]\n",
  "CLAMORING": "CLAMOR, to make a loud outcry, also CLAMOUR [v]\n",
  "CLAMOROUS": "loud, full of clamour [adj CLAMOROUSLY]\n",
  "CLAMOROUSLY": "CLAMOROUS, loud, full of clamour [adv]\n",
  "CLAMOROUSNESS": "CLAMOROUS, loud, full of clamour [n]\n",
  "CLAMOROUSNESSES": "CLAMOROUSNESS, CLAMOROUS, loud, full of clamour [n]\n",
  "CLAMORS": "CLAMOR, to make a loud outcry, also CLAMOUR [v]\n",
  "CLAMOUR": "to make a loud outcry, also CLAMOR [v -ED, -ING, -S]\n",
  "CLAMOURED": "CLAMOUR, to make a loud outcry, also CLAMOR [v]\n",
  "CLAMOURER": "one who makes a clamour, also CLAMORER [n -S]\n",
  "CLAMOURERS": "CLAMOURER, one who makes a clamour, also CLAMORER [n]\n",
  "CLAMOURING": "CLAMOUR, to make a loud outcry, also CLAMOR [v]\n",
  "CLAMOURS": "CLAMOUR, to make a loud outcry, also CLAMOR [v]\n",
  "CLAMP": "to fasten with a device [v -ED, -ING, -S]\n",
  "CLAMPDOWN": "a tightening e.g. of regulations [n -S]\n",
  "CLAMPDOWNS": "CLAMPDOWN, a tightening e.g. of regulations [n]\n",
  "CLAMPED": "CLAMP, to fasten with a device [v]\n",
  "CLAMPER": "to botch up [v -ED, -ING, -S]\n",
  "CLAMPERED": "CLAMPER, to botch up [v]\n",
  "CLAMPERING": "CLAMPER, to botch up [v]\n",
  "CLAMPERS": "CLAMPER, to botch up [v]\n",
  "CLAMPING": "the act of applying a clamp [n -S]\n",
  "CLAMPINGS": "CLAMPING, the act of applying a clamp [n]\n",
  "CLAMPS": "CLAMP, to fasten with a device [v]\n",
  "CLAMS": "CLAM, to dig for the edible shellfish clams [v]\n",
  "CLAMSHELL": "the shell of a clam; a bucket, as in a dredge, having two hinged jaws [n -S]\n",
  "CLAMSHELLS": "CLAMSHELL, the shell of a clam; a bucket, as in a dredge, having two hinged jaws [n]\n",
  "CLAMWORM": "a marine worm [n -S]\n",
  "CLAMWORMS": "CLAMWORM, a marine worm [n]\n",
  "CLAN": "a united group of families [n -S]\n",
  "CLANDESTINE": "marked by, held in, or conducted with secrecy [adj]\n",
  "CLANDESTINELY": "CLANDESTINE, marked by, held in, or conducted with secrecy [adv]\n",
  "CLANDESTINENESS": "the state of being clandestine [n]\n",
  "CLANDESTINITIES": "CLANDESTINITY, the quality of being clandestine [n]\n",
  "CLANDESTINITY": "the quality of being clandestine [n CLANDESTINITIES]\n",
  "CLANG": "to ring loudly [v -ED, -ING, -S]\n",
  "CLANGBOX": "a deflector fitted to a jet engine to divert gas flow [n -ES]\n",
  "CLANGBOXES": "CLANGBOX, a deflector fitted to a jet engine to divert gas flow [n]\n",
  "CLANGED": "CLANG, to ring loudly [v]\n",
  "CLANGER": "(colloquial) a mistake [n -S]\n",
  "CLANGERS": "CLANGER, (colloquial) a mistake [n]\n",
  "CLANGING": "the noise of a clang [n -S]\n",
  "CLANGINGS": "CLANGING, the noise of a clang [n]\n",
  "CLANGOR": "to clang loudly, also CLANGOUR [v -ED, -ING, -S]\n",
  "CLANGORED": "CLANGOR, to clang loudly, also CLANGOUR [v]\n",
  "CLANGORING": "CLANGOR, to clang loudly, also CLANGOUR [v]\n",
  "CLANGOROUS": "full of clangour [adj CLANGOROUSLY]\n",
  "CLANGOROUSLY": "CLANGOROUS, full of clangour [adv]\n",
  "CLANGORS": "CLANGOR, to clang loudly, also CLANGOUR [v]\n",
  "CLANGOUR": "to clang loudly, also CLANGOR [v -ED, -ING, -S]\n",
  "CLANGOURED": "CLANGOUR, to clang loudly, also CLANGOR [v]\n",
  "CLANGOURING": "CLANGOUR, to clang loudly, also CLANGOR [v]\n",
  "CLANGOURS": "CLANGOUR, to clang loudly, also CLANGOR [v]\n",
  "CLANGS": "CLANG, to ring loudly [v]\n",
  "CLANJAMFRAY": "(Scots) rubbish, nonsense, also CLAMJAMFRY, CLAMJAMPHRIE [n -S]\n",
  "CLANJAMFRAYS": "CLANJAMFRAY, (Scots) rubbish, nonsense, also CLAMJAMFRY, CLAMJAMPHRIE [n]\n",
  "CLANK": "to rattle as of chains [v -ED, -ING, -S]\n",
  "CLANKED": "CLANK, to rattle as of chains [v]\n",
  "CLANKIER": "CLANKY, making a sharp, metallic sound [adj]\n",
  "CLANKIEST": "CLANKY, making a sharp, metallic sound [adj]\n",
  "CLANKING": "the sound of a clank [n -S]\n",
  "CLANKINGLY": "CLANKING [adv]\n",
  "CLANKINGS": "CLANKING, the sound of a clank [n]\n",
  "CLANKS": "CLANK, to rattle as of chains [v]\n",
  "CLANKY": "making a sharp, metallic sound [adj CLANKIER, CLANKIEST]\n",
  "CLANNISH": "like a clan [adj CLANNISHLY]\n",
  "CLANNISHLY": "CLANNISH, like a clan [adv]\n",
  "CLANNISHNESS": "the state of being clannish [n -ES]\n",
  "CLANNISHNESSES": "CLANNISHNESS, the state of being clannish [n]\n",
  "CLANS": "CLAN, a united group of families [n]\n",
  "CLANSHIP": "a feeling of loyalty to a clan [n -S]\n",
  "CLANSHIPS": "CLANSHIP, a feeling of loyalty to a clan [n]\n",
  "CLANSMAN": "a member of a clan [n CLANSMEN]\n",
  "CLANSMEN": "CLANSMAN, a member of a clan [n]\n",
  "CLANSWOMAN": "a female member of a clan [n CLANSWOMEN]\n",
  "CLANSWOMEN": "CLANSWOMAN, a female member of a clan [n]\n",
  "CLAP": "the noise of striking two things together [v CLAPPED, CLAPT, CLAPPING, CLAPS]\n",
  "CLAPBOARD": "a narrow board, thicker at one edge than at the other, used for weatherboarding the outside of houses [n -S] / to cover with clapboard [v -ED, -ING, -S]\n",
  "CLAPBOARDED": "CLAPBOARD, to cover with clapboard [v]\n",
  "CLAPBOARDING": "CLAPBOARD, to cover with clapboard [v]\n",
  "CLAPBOARDS": "CLAPBOARD, to cover with clapboard [v]\n",
  "CLAPBREAD": "a kind of hard-baked oatmeal cake [n -S]\n",
  "CLAPBREADS": "CLAPBREAD, a kind of hard-baked oatmeal cake [n]\n",
  "CLAPDISH": "(archaic) a wooden dish carried by beggars, with a moveable lid which they clacked to attract attention, also CLACKDISH [n -ES]\n",
  "CLAPDISHES": "CLAPDISH, (archaic) a wooden dish carried by beggars, with a moveable lid which they clacked to attract attention, also CLACKDISH [n]\n",
  "CLAPNET": "a net made to clap together suddenly by pulling a string [n -S]\n",
  "CLAPNETS": "CLAPNET, a net made to clap together suddenly by pulling a string [n]\n",
  "CLAPOMETER": "a device for registering applause [n -S]\n",
  "CLAPOMETERS": "CLAPOMETER, a device for registering applause [n]\n",
  "CLAPPED": "CLAP, the noise of striking two things together [v]\n",
  "CLAPPER": "a thing that claps, e.g. the tongue of a bell [n -S] / to make a noise like a clapper [v -ED, -ING, -S]\n",
  "CLAPPERBOARD": "a hinged board (or a set of hinged boards) clapped together in front of the camera before or after shooting a piece of film, to help synchronize sound and vision [n -S]\n",
  "CLAPPERBOARDS": "CLAPPERBOARD, a hinged board (or a set of hinged boards) clapped together in front of the camera before or after shooting a piece of film, to help synchronize sound and vision [n]\n",
  "CLAPPERBOY": "the person who works the clapperboards [n -S]\n",
  "CLAPPERBOYS": "CLAPPERBOY, the person who works the clapperboards [n]\n",
  "CLAPPERCLAW": "(archaic) to claw or scratch [v -ED, -ING, -S]\n",
  "CLAPPERCLAWED": "CLAPPERCLAW, (archaic) to claw or scratch [v]\n",
  "CLAPPERCLAWER": "one who scolds, abuses [n -S]\n",
  "CLAPPERCLAWERS": "CLAPPERCLAWER, one who scolds, abuses [n]\n",
  "CLAPPERCLAWING": "CLAPPERCLAW, (archaic) to claw or scratch [v]\n",
  "CLAPPERCLAWS": "CLAPPERCLAW, (archaic) to claw or scratch [v]\n",
  "CLAPPERED": "CLAPPER, to make a noise like a clapper [v]\n",
  "CLAPPERING": "the sound made by using a clapper [n -S]\n",
  "CLAPPERINGS": "CLAPPERING, the sound made by using a clapper [n]\n",
  "CLAPPERS": "CLAPPER, to make a noise like a clapper [v]\n",
  "CLAPPING": "the act of clapping [n -S]\n",
  "CLAPPINGS": "CLAPPING, the act of clapping [n]\n",
  "CLAPS": "CLAP, the noise of striking two things together [v]\n",
  "CLAPT": "CLAP, the noise of striking two things together [v]\n",
  "CLAPTRAP": "flashy, empty words [n -S]\n",
  "CLAPTRAPPERIES": "CLAPTRAPPERY, nonsense, claptrap [n]\n",
  "CLAPTRAPPERY": "nonsense, claptrap [n CLAPTRAPPERIES]\n",
  "CLAPTRAPS": "CLAPTRAP, flashy, empty words [n]\n",
  "CLAQUE": "(French) a group of hired applauders [n -S]\n",
  "CLAQUER": "a member of a claque, also CLAQUEUR [n -S]\n",
  "CLAQUERS": "CLAQUER, a member of a claque, also CLAQUEUR [n]\n",
  "CLAQUES": "CLAQUE, (French) a group of hired applauders [n]\n",
  "CLAQUEUR": "(French) a member of a claque, also CLAQUER [n -S]\n",
  "CLAQUEURS": "CLAQUEUR, (French) a member of a claque, also CLAQUER [n]\n",
  "CLARABELLA": "an organ stop having a sweet fluty tone, also CLARIBELLA [n -S]\n",
  "CLARABELLAS": "CLARABELLA, an organ stop having a sweet fluty tone, also CLARIBELLA [n]\n",
  "CLARAIN": "lustrous bands in coal [n -S]\n",
  "CLARAINS": "CLARAIN, lustrous bands in coal [n]\n",
  "CLARENCE": "a kind of closed carriage [n -S]\n",
  "CLARENCES": "CLARENCE, a kind of closed carriage [n]\n",
  "CLARENDON": "a form of condensed roman type having a heavy face [n -S]\n",
  "CLARENDONS": "CLARENDON, a form of condensed roman type having a heavy face [n]\n",
  "CLARET": "to drink a red dry wine [v -ED, -ING, -S]\n",
  "CLARETED": "CLARET, to drink a red dry wine [v]\n",
  "CLARETING": "CLARET, to drink a red dry wine [v]\n",
  "CLARETS": "CLARET, to drink a red dry wine [v]\n",
  "CLARIBELLA": "an organ stop having a sweet fluty tone, also CLARABELLA [n -S]\n",
  "CLARIBELLAS": "CLARIBELLA, an organ stop having a sweet fluty tone, also CLARABELLA [n]\n",
  "CLARICHORD": "an old keyboard stringed instrument in which the tangent striking the string and producing the sound also determines the vibrating length, also CLAVICHORD [n -S]\n",
  "CLARICHORDS": "CLARICHORD, an old keyboard stringed instrument in which the tangent striking the string and producing the sound also determines the vibrating length, also CLAVICHORD [n]\n",
  "CLARIES": "CLARY, any plant of the genus Salvia sclarea, sometimes used as a culinary herb [n]\n",
  "CLARIFICATION": "the act of clarifying [n -S]\n",
  "CLARIFICATIONS": "CLARIFICATION, the act of clarifying [n]\n",
  "CLARIFIED": "CLARIFY, to make clear [v]\n",
  "CLARIFIER": "an agent that clarifies (wine) [n -S]\n",
  "CLARIFIERS": "CLARIFIER, an agent that clarifies (wine) [n]\n",
  "CLARIFIES": "CLARIFY, to make clear [v]\n",
  "CLARIFY": "to make clear [v CLARIFIED, CLARIFYING, CLARIFIES]\n",
  "CLARIFYING": "CLARIFY, to make clear [v]\n",
  "CLARINET": "a woodwind instrument, blown by a single reed, also CLARIONET [n -S]\n",
  "CLARINETIST": "one who plays the clarinet, also CLARINETTIST [n -S]\n",
  "CLARINETISTS": "CLARINETIST, one who plays the clarinet, also CLARINETTIST [n]\n",
  "CLARINETS": "CLARINET, a woodwind instrument, blown by a single reed, also CLARIONET [n]\n",
  "CLARINETTIST": "one who plays the clarinet, also CLARINETIST [n -S]\n",
  "CLARINETTISTS": "CLARINETTIST, one who plays the clarinet, also CLARINETIST [n]\n",
  "CLARINI": "CLARINO, (Italian) the highest register of a trumpet in baroque music [n]\n",
  "CLARINO": "(Italian) the highest register of a trumpet in baroque music [n CLARINOS or CLARINI]\n",
  "CLARINOS": "CLARINO, (Italian) the highest register of a trumpet in baroque music [n]\n",
  "CLARION": "to sound a shrill clear trumpet [v -ED, -ING, -S]\n",
  "CLARIONED": "CLARION, to sound a shrill clear trumpet [v]\n",
  "CLARIONET": "(archaic) a clarinet, also CLARINET [n -S]\n",
  "CLARIONETS": "CLARIONET, (archaic) a clarinet, also CLARINET [n]\n",
  "CLARIONING": "CLARION, to sound a shrill clear trumpet [v]\n",
  "CLARIONS": "CLARION, to sound a shrill clear trumpet [v]\n",
  "CLARITIES": "CLARITY, the state of being clear [n]\n",
  "CLARITY": "the state of being clear [n CLARITIES]\n",
  "CLARKIA": "any plant of the North American genus Clarkia, a favourite border plant [n -S]\n",
  "CLARKIAS": "CLARKIA, any plant of the North American genus Clarkia, a favourite border plant [n]\n",
  "CLARO": "(Spanish) a light-coloured, mild cigar [n -S or -ES]\n",
  "CLAROES": "CLARO, (Spanish) a light-coloured, mild cigar [n]\n",
  "CLAROS": "CLARO, (Spanish) a light-coloured, mild cigar [n]\n",
  "CLARSACH": "(Gaelic) a Scottish folk harp, also CLAIRSCHACH [n -S]\n",
  "CLARSACHS": "CLARSACH, (Gaelic) a Scottish folk harp, also CLAIRSCHACH [n]\n",
  "CLART": "to dirty [v -ED, -ING, -S]\n",
  "CLARTED": "CLART, to dirty [v]\n",
  "CLARTHEAD": "a slow-witted person [n -S]\n",
  "CLARTHEADS": "CLARTHEAD, a slow-witted person [n]\n",
  "CLARTIER": "CLARTY, sticky and dirty [adj]\n",
  "CLARTIEST": "CLARTY, sticky and dirty [adj]\n",
  "CLARTING": "CLART, to dirty [v]\n",
  "CLARTS": "CLART, to dirty [v]\n",
  "CLARTY": "sticky and dirty [adj CLARTIER, CLARTIEST]\n",
  "CLARY": "any plant of the genus Salvia sclarea, sometimes used as a culinary herb [n CLARIES]\n",
  "CLASH": "to meet in opposition [v -ED, -ING, -ES]\n",
  "CLASHED": "CLASH, to meet in opposition [v]\n",
  "CLASHER": "one who clashes [n -S]\n",
  "CLASHERS": "CLASHER, one who clashes [n]\n",
  "CLASHES": "CLASH, to meet in opposition [v]\n",
  "CLASHING": "a striking against; opposition, conflict, disagreement [n -S]\n",
  "CLASHINGLY": "CLASHING [adv]\n",
  "CLASHINGS": "CLASHING, a striking against; opposition, conflict, disagreement [n]\n",
  "CLASP": "to embrace tightly [v CLASPED or CLASPT, CLASPING, CLASPS]\n",
  "CLASPED": "CLASP, to embrace tightly [v]\n",
  "CLASPER": "a clasping organ [n -S]\n",
  "CLASPERS": "CLASPER, a clasping organ [n]\n",
  "CLASPING": "the act of taking hold with the hands [n -S]\n",
  "CLASPINGS": "CLASPING, the act of taking hold with the hands [n]\n",
  "CLASPS": "CLASP, to embrace tightly [v]\n",
  "CLASPT": "CLASP, to embrace tightly [v]\n",
  "CLASS": "to classify [v -ED, -ING, -ES]\n",
  "CLASSABLE": "capable of being put into a class, also CLASSIBLE [adj]\n",
  "CLASSED": "CLASS, to classify [v]\n",
  "CLASSER": "one that classes [n -S]\n",
  "CLASSERS": "CLASSER, one that classes [n]\n",
  "CLASSES": "CLASS, to classify [v]\n",
  "CLASSIBLE": "capable of being put into a class, also CLASSABLE [adj]\n",
  "CLASSIC": "setting a standard [adj CLASSICALLY] / a work of enduring excellence [n -S]\n",
  "CLASSICAL": "resembling or in the style of the authors of Greece and Rome or the old masters in music [adj CLASSICALLY] / a work in classical style [n -S]\n",
  "CLASSICALISM": "in literature, music, etc., a principle, character or tendency such as is seen in Greek classical literature, marked by beauty of form, good taste, restraint and clarity [n -S]\n",
  "CLASSICALISMS": "CLASSICALISM, in literature, music, etc., a principle, character or tendency such as is seen in Greek classical literature, marked by beauty of form, good taste, restraint and clarity [n]\n",
  "CLASSICALIST": "an adherent of classicalism [n -S]\n",
  "CLASSICALISTS": "CLASSICALIST, an adherent of classicalism [n]\n",
  "CLASSICALITIES": "CLASSICALITY, the state of being classical [n]\n",
  "CLASSICALITY": "the state of being classical [n CLASSICALITIES]\n",
  "CLASSICALLY": "CLASSICAL, resembling or in the style of the authors of Greece and Rome or the old masters in music [adv]\n",
  "CLASSICALNESS": "CLASSICAL, resembling or in the style of the authors of Greece and Rome or the old masters in music [n]\n",
  "CLASSICALNESSES": "CLASSICALNESS, CLASSICAL, resembling or in the style of the authors of Greece and Rome or the old masters in music [n]\n",
  "CLASSICALS": "CLASSICAL, a work in classical style [n]\n",
  "CLASSICISE": "to make classical, also CLASSICIZE [v CLASSICISED, CLASSICISING, CLASSICISES]\n",
  "CLASSICISED": "CLASSICISE, to make classical, also CLASSICIZE [v]\n",
  "CLASSICISES": "CLASSICISE, to make classical, also CLASSICIZE [v]\n",
  "CLASSICISING": "CLASSICISE, to make classical, also CLASSICIZE [v]\n",
  "CLASSICISM": "the principles or style embodied in the literature, art, or architecture of ancient Greece and Rome [n -S]\n",
  "CLASSICISMS": "CLASSICISM, the principles or style embodied in the literature, art, or architecture of ancient Greece and Rome [n]\n",
  "CLASSICIST": "an advocate or follower of classicism [n -S]\n",
  "CLASSICISTIC": "relating to classicism [adj]\n",
  "CLASSICISTS": "CLASSICIST, an advocate or follower of classicism [n]\n",
  "CLASSICIZE": "to make classical, also CLASSICISE [v CLASSICIZED, CLASSICIZING, CLASSICIZES]\n",
  "CLASSICIZED": "CLASSICIZE, to make classical, also CLASSICISE [v]\n",
  "CLASSICIZES": "CLASSICIZE, to make classical, also CLASSICISE [v]\n",
  "CLASSICIZING": "CLASSICIZE, to make classical, also CLASSICISE [v]\n",
  "CLASSICO": "made from grapes grown in a certain part of Italy [adj]\n",
  "CLASSICS": "CLASSIC, a work of enduring excellence [n]\n",
  "CLASSIER": "CLASSY, having class, stylish [adj]\n",
  "CLASSIEST": "CLASSY, having class, stylish [adj]\n",
  "CLASSIFIABLE": "capable of being classified [adj]\n",
  "CLASSIFIC": "denoting classes [adj]\n",
  "CLASSIFICATION": "the act of classifying [n -S]\n",
  "CLASSIFICATIONS": "CLASSIFICATION, the act of classifying [n]\n",
  "CLASSIFICATORY": "relating to classification [adj]\n",
  "CLASSIFIED": "a section of a newspaper containing ads [n -S]\n",
  "CLASSIFIEDS": "a section of classified advertising in a publication [n]\n",
  "CLASSIFIER": "one who classifies [n -S]\n",
  "CLASSIFIERS": "CLASSIFIER, one who classifies [n]\n",
  "CLASSIFIES": "CLASSIFY, to arrange in categories [v]\n",
  "CLASSIFY": "to arrange in categories [v CLASSIFIED, CLASSIFYING, CLASSIFIES]\n",
  "CLASSIFYING": "CLASSIFY, to arrange in categories [v]\n",
  "CLASSILY": "CLASSY, having class, stylish [adv]\n",
  "CLASSINESS": "the state of being classy [n -ES]\n",
  "CLASSINESSES": "CLASSINESS, the state of being classy [n]\n",
  "CLASSING": "putting into classes [n -S]\n",
  "CLASSINGS": "CLASSING, putting into classes [n]\n",
  "CLASSIS": "(Latin) a division according to rank; a class [n CLASSES]\n",
  "CLASSISM": "discrimination based on social class [n -S]\n",
  "CLASSISMS": "CLASSISM, discrimination based on social class [n]\n",
  "CLASSIST": "one who discriminates on grounds of social class [n -S]\n",
  "CLASSISTS": "CLASSIST, one who discriminates on grounds of social class [n]\n",
  "CLASSLESS": "without a (social) class [adj]\n",
  "CLASSLESSNESS": "CLASSLESS, without a (social) class [n]\n",
  "CLASSLESSNESSES": "CLASSLESSNESS, CLASSLESS, without a (social) class [n]\n",
  "CLASSMAN": "a person who has gained honours at Oxford [n CLASSMEN]\n",
  "CLASSMATE": "one in the same class [n -S]\n",
  "CLASSMATES": "CLASSMATE, one in the same class [n]\n",
  "CLASSMEN": "CLASSMAN, a person who has gained honours at Oxford [n]\n",
  "CLASSON": "an elementary atomic particle [n -S]\n",
  "CLASSONS": "CLASSON, an elementary atomic particle [n]\n",
  "CLASSROOM": "a room in which children are confined, nominally for purposes of instruction [n -S]\n",
  "CLASSROOMS": "CLASSROOM, a room in which children are confined, nominally for purposes of instruction [n]\n",
  "CLASSWORK": "work done in class [n -S]\n",
  "CLASSWORKS": "CLASSWORK, work done in class [n]\n",
  "CLASSY": "having class, stylish [adj CLASSIER, CLASSIEST, CLASSILY]\n",
  "CLAST": "an individual grain or constituent of a rock [n -S]\n",
  "CLASTIC": "a rock composed of other rocks [n -S]\n",
  "CLASTICS": "CLASTIC, a rock composed of other rocks [n]\n",
  "CLASTS": "CLAST, an individual grain or constituent of a rock [n]\n",
  "CLAT": "(Scots) to scratch, scrape [v CLATTED, CLATTING, CLATS]\n",
  "CLATCH": "(Scots) to dabble or work into a miry matter [v -ED, -ING, -ES]\n",
  "CLATCHED": "CLATCH, (Scots) to dabble or work into a miry matter [v]\n",
  "CLATCHES": "CLATCH, (Scots) to dabble or work into a miry matter [v]\n",
  "CLATCHING": "CLATCH, (Scots) to dabble or work into a miry matter [v]\n",
  "CLATHRATE": "shaped like a net or lattice [adj] / a lattice-shaped structure [n -S]\n",
  "CLATHRATES": "CLATHRATE, a lattice-shaped structure [n]\n",
  "CLATS": "CLAT, (Scots) to scratch, scrape [v]\n",
  "CLATTED": "CLAT, (Scots) to scratch, scrape [v]\n",
  "CLATTER": "to make a rattling sound [v -ED, -ING, -S]\n",
  "CLATTERED": "CLATTER, to make a rattling sound [v]\n",
  "CLATTERER": "one who clatters [n -S]\n",
  "CLATTERERS": "CLATTERER, one who clatters [n]\n",
  "CLATTERIER": "CLATTERY, making a clatter [adj]\n",
  "CLATTERIEST": "CLATTERY, making a clatter [adj]\n",
  "CLATTERING": "CLATTER, to make a rattling sound [v]\n",
  "CLATTERINGLY": "CLATTERING, CLATTER, to make a rattling sound [adv]\n",
  "CLATTERS": "CLATTER, to make a rattling sound [v]\n",
  "CLATTERY": "making a clatter [adj CLATTERIER, CLATTERIEST]\n",
  "CLATTING": "CLAT, (Scots) to scratch, scrape [v]\n",
  "CLAUCHT": "(Scots) to snatch, also CLAUGHT [v -ED, -ING, -S]\n",
  "CLAUCHTED": "CLAUCHT, (Scots) to snatch, also CLAUGHT [v]\n",
  "CLAUCHTING": "CLAUCHT, (Scots) to snatch, also CLAUGHT [v]\n",
  "CLAUCHTS": "CLAUCHT, (Scots) to snatch, also CLAUGHT [v]\n",
  "CLAUDICATION": "the state of being lame [n -S]\n",
  "CLAUDICATIONS": "CLAUDICATION, the state of being lame [n]\n",
  "CLAUGHT": "(Scots) to snatch, also CLAUCHT [v -ED, -ING, -S]\n",
  "CLAUGHTED": "CLAUGHT, (Scots) to snatch, also CLAUCHT [v]\n",
  "CLAUGHTING": "CLAUGHT, (Scots) to snatch, also CLAUCHT [v]\n",
  "CLAUGHTS": "CLAUGHT, (Scots) to snatch, also CLAUCHT [v]\n",
  "CLAUSAL": "relating to a clause [adj]\n",
  "CLAUSE": "a part of a document [n -S]\n",
  "CLAUSES": "CLAUSE, a part of a document [n]\n",
  "CLAUSTRA": "CLAUSTRUM, (Latin) a thin lamina of gray matter in each cerebral hemisphere of the brain of man [n]\n",
  "CLAUSTRAL": "of, like, or characteristic of a cloister, also CLOISTRAL [adj]\n",
  "CLAUSTRATION": "the act of shutting in a cloister [n -S]\n",
  "CLAUSTRATIONS": "CLAUSTRATION, the act of shutting in a cloister [n]\n",
  "CLAUSTROPHILIA": "abnormal pleasure derived from being in a confined space [n -S]\n",
  "CLAUSTROPHILIAS": "CLAUSTROPHILIA, abnormal pleasure derived from being in a confined space [n]\n",
  "CLAUSTROPHOBE": "one with a fear of confined spaces [n -S]\n",
  "CLAUSTROPHOBES": "CLAUSTROPHOBE, one with a fear of confined spaces [n]\n",
  "CLAUSTROPHOBIA": "fear of closed spaces [n -S]\n",
  "CLAUSTROPHOBIAS": "CLAUSTROPHOBIA, fear of closed spaces [n]\n",
  "CLAUSTROPHOBIC": "affected with or inclined to claustrophobia [adj]\n",
  "CLAUSTRUM": "(Latin) a thin lamina of gray matter in each cerebral hemisphere of the brain of man [n CLAUSTRA]\n",
  "CLAUSULA": "(Latin) a short clause ending a period in Latin prose [n CLAUSULAE]\n",
  "CLAUSULAE": "CLAUSULA, (Latin) a short clause ending a period in Latin prose [n]\n",
  "CLAUSULAR": "consisting of, or having, clauses [adj]\n",
  "CLAUT": "(Scots) to scratch, scrape, also CLAT [v -ED, -ING, -S]\n",
  "CLAUTED": "CLAUT, (Scots) to scratch, scrape, also CLAT [v]\n",
  "CLAUTING": "CLAUT, (Scots) to scratch, scrape, also CLAT [v]\n",
  "CLAUTS": "CLAUT, (Scots) to scratch, scrape, also CLAT [v]\n",
  "CLAVATE": "club-shaped; growing gradually thicker toward the top, also CLAVATED [adj CLAVATELY]\n",
  "CLAVATED": "shaped like a club, also CLAVATE [adj]\n",
  "CLAVATELY": "CLAVATE, club-shaped; growing gradually thicker toward the top, also CLAVATED [adv]\n",
  "CLAVATION": "an articulation in a socket [n -S]\n",
  "CLAVATIONS": "CLAVATION, an articulation in a socket [n]\n",
  "CLAVE": "in plants, a gradual swelling at the distal end of a structure, resembling a club [n -S]\n",
  "CLAVECIN": "(French) a harpsichord [n -S]\n",
  "CLAVECINIST": "one who plays the clavecin [n -S]\n",
  "CLAVECINISTS": "CLAVECINIST, one who plays the clavecin [n]\n",
  "CLAVECINS": "CLAVECIN, (French) a harpsichord [n]\n",
  "CLAVER": "(Scots) to gossip [v -ED, -ING, -S]\n",
  "CLAVERED": "CLAVER, (Scots) to gossip [v]\n",
  "CLAVERING": "CLAVER, (Scots) to gossip [v]\n",
  "CLAVERS": "CLAVER, (Scots) to gossip [v]\n",
  "CLAVES": "CLAVE, in plants, a gradual swelling at the distal end of a structure, resembling a club [n]\n",
  "CLAVI": "CLAVUS, (Latin) a horny thickening of the skin [n]\n",
  "CLAVICEMBALO": "(Italian) a harpsichord [n -S]\n",
  "CLAVICEMBALOS": "CLAVICEMBALO, (Italian) a harpsichord [n]\n",
  "CLAVICHORD": "an old keyboard stringed instrument, also CLARICHORD [n -S]\n",
  "CLAVICHORDIST": "one who plays the clavichord [n -S]\n",
  "CLAVICHORDISTS": "CLAVICHORDIST, one who plays the clavichord [n]\n",
  "CLAVICHORDS": "CLAVICHORD, an old keyboard stringed instrument, also CLARICHORD [n]\n",
  "CLAVICLE": "a shoulder bone [n -S]\n",
  "CLAVICLES": "CLAVICLE, a shoulder bone [n]\n",
  "CLAVICORN": "a beetle having club-shaped antennae [n -S]\n",
  "CLAVICORNS": "CLAVICORN, a beetle having club-shaped antennae [n]\n",
  "CLAVICULA": "(Latin) the collarbone, also CLAVICLE [n CLAVICULAE]\n",
  "CLAVICULAE": "CLAVICULA, (Latin) the collarbone, also CLAVICLE [n]\n",
  "CLAVICULAR": "of or pertaining to the clavicle [adj]\n",
  "CLAVICULATE": "shaped like a clavicula, the collarbone [adj]\n",
  "CLAVICYTHERIA": "CLAVICYTHERIUM, a harpsichord-like musical instrument [n]\n",
  "CLAVICYTHERIUM": "a harpsichord-like musical instrument [n CLAVICYTHERIA]\n",
  "CLAVIE": "a tar barrel burnt for luck at Hogmanay [n -S]\n",
  "CLAVIER": "(German) an early keyboard instrument, also KLAVIER [n -S]\n",
  "CLAVIERIST": "one who plays the pianoforte [n -S]\n",
  "CLAVIERISTIC": "relating to a clavierist, one who plays the pianoforte [adj]\n",
  "CLAVIERISTS": "CLAVIERIST, one who plays the pianoforte [n]\n",
  "CLAVIERS": "CLAVIER, (German) an early keyboard instrument, also KLAVIER [n]\n",
  "CLAVIES": "CLAVIE, a tar barrel burnt for luck at Hogmanay [n]\n",
  "CLAVIFORM": "in the shape of a club [adj]\n",
  "CLAVIGER": "(Latin) one who carries the keys of any place [n -S]\n",
  "CLAVIGEROUS": "club-bearing [adj]\n",
  "CLAVIGERS": "CLAVIGER, (Latin) one who carries the keys of any place [n]\n",
  "CLAVIS": "(Latin) a key; hence a clue or aid in solving problems [n CLAVES]\n",
  "CLAVULATE": "club-shaped, also CLAVATE, CLAVATED [adj]\n",
  "CLAVUS": "(Latin) a horny thickening of the skin [n CLAVI]\n",
  "CLAW": "to scratch with sharp, curved toenails [v -ED, -ING, -S]\n",
  "CLAWBACK": "taking by taxation what has been given as benefit [n -S]\n",
  "CLAWBACKS": "CLAWBACK, taking by taxation what has been given as benefit [n]\n",
  "CLAWED": "CLAW, to scratch with sharp, curved toenails [v]\n",
  "CLAWER": "one who claws [n -S]\n",
  "CLAWERS": "CLAWER, one who claws [n]\n",
  "CLAWHAMMER": "a kind of hammer with a claw [n -S]\n",
  "CLAWHAMMERS": "CLAWHAMMER, a kind of hammer with a claw [n]\n",
  "CLAWING": "CLAW, to scratch with sharp, curved toenails [v]\n",
  "CLAWLESS": "without claws [adj]\n",
  "CLAWLIKE": "like a claw [adj]\n",
  "CLAWS": "CLAW, to scratch with sharp, curved toenails [v]\n",
  "CLAXON": "a low-pitched horn [n -S]\n",
  "CLAXONS": "CLAXON, a low-pitched horn [n]\n",
  "CLAY": "to purify (e.g. sugar) with clay [v -ED, -ING, -S]\n",
  "CLAYBANK": "a horse of a yellow-brown colour [n -S]\n",
  "CLAYBANKS": "CLAYBANK, a horse of a yellow-brown colour [n]\n",
  "CLAYED": "CLAY, to purify (e.g. sugar) with clay [v]\n",
  "CLAYEY": "resembling clay [adj CLAYIER, CLAYIEST]\n",
  "CLAYIER": "CLAYEY, resembling clay [adj]\n",
  "CLAYIEST": "CLAYEY, resembling clay [adj]\n",
  "CLAYING": "CLAY, to purify (e.g. sugar) with clay [v]\n",
  "CLAYISH": "resembling clay [adj]\n",
  "CLAYLIKE": "like clay [adj]\n",
  "CLAYMATION": "(tradename) the animation of clay or Plasticene figures [n -S]\n",
  "CLAYMATIONS": "CLAYMATION, (tradename) the animation of clay or Plasticene figures [n]\n",
  "CLAYMORE": "(Gaelic) a kind of large sword [n -S]\n",
  "CLAYMORES": "CLAYMORE, (Gaelic) a kind of large sword [n]\n",
  "CLAYPAN": "a compacted layer of subsoil that retains water [n -S]\n",
  "CLAYPANS": "CLAYPAN, a compacted layer of subsoil that retains water [n]\n",
  "CLAYS": "CLAY, to purify (e.g. sugar) with clay [v]\n",
  "CLAYSTONE": "a compact very fine-grained rock consisting of consolidated clay particles [n -S]\n",
  "CLAYSTONES": "CLAYSTONE, a compact very fine-grained rock consisting of consolidated clay particles [n]\n",
  "CLAYTONIA": "an American genus of perennial herbs with delicate blossoms, aka spring beauty [n -S]\n",
  "CLAYTONIAS": "CLAYTONIA, an American genus of perennial herbs with delicate blossoms, aka spring beauty [n]\n",
  "CLAYWARE": "goods made of clay [n -S]\n",
  "CLAYWARES": "CLAYWARE, goods made of clay [n]\n",
  "CLEAN": "to rid of stain [v -ED, -ING, -S] / free from stain [adj CLEANER, CLEANEST, CLEANLY]\n",
  "CLEANABILITIES": "CLEANABILITY, the quality of being cleanable [n]\n",
  "CLEANABILITY": "the quality of being cleanable [n CLEANABILITIES]\n",
  "CLEANABLE": "able to be cleaned [adj]\n",
  "CLEANED": "CLEAN, to rid of stain [v]\n",
  "CLEANER": "one that cleans [n -S]\n",
  "CLEANERS": "CLEANER, one that cleans [n]\n",
  "CLEANEST": "CLEAN, free from stain [adj]\n",
  "CLEANHANDED": "with clean hands [adj]\n",
  "CLEANING": "the act of making clean [n -S]\n",
  "CLEANINGS": "CLEANING, the act of making clean [n]\n",
  "CLEANISH": "somewhat clean [adj]\n",
  "CLEANLIER": "CLEANLY, clean in habits [adj]\n",
  "CLEANLIEST": "CLEANLY, clean in habits [adj]\n",
  "CLEANLILY": "CLEANLY, clean in habits [adv]\n",
  "CLEANLINESS": "the state of being cleanly [n -ES]\n",
  "CLEANLINESSES": "CLEANLINESS, the state of being cleanly [n]\n",
  "CLEANLY": "clean in habits [adj CLEANLIER, CLEANLIEST, CLEANLILY]\n",
  "CLEANNESS": "the state of being clean [n -ES]\n",
  "CLEANNESSES": "CLEANNESS, the state of being clean [n]\n",
  "CLEANOUT": "the act of cleaning something out [n -S]\n",
  "CLEANOUTS": "CLEANOUT, the act of cleaning something out [n]\n",
  "CLEANS": "CLEAN, to rid of stain [v]\n",
  "CLEANSABLE": "capable of being cleansed [adj]\n",
  "CLEANSE": "to clean [v CLEANSED, CLEANSING, CLEANSES]\n",
  "CLEANSED": "CLEANSE, to clean [v]\n",
  "CLEANSER": "that which cleanses [n -S]\n",
  "CLEANSERS": "CLEANSER, that which cleanses [n]\n",
  "CLEANSES": "CLEANSE, to clean [v]\n",
  "CLEANSING": "the act of cleansing [n -S]\n",
  "CLEANSINGS": "CLEANSING, the act of cleansing [n]\n",
  "CLEANSKIN": "(Australian) an unbranded animal, also CLEARSKIN [n -S]\n",
  "CLEANSKINS": "CLEANSKIN, (Australian) an unbranded animal, also CLEARSKIN [n]\n",
  "CLEANTECH": "short for clean technology, technology that reduces negative environmental impacts through significant energy efficiency improvements, the sustainable use of resources, or environmental protection activitity [n -S]\n",
  "CLEANTECHS": "CLEANTECH, short for clean technology, technology that reduces negative environmental impacts through significant energy efficiency improvements, the sustainable use of resources, or environmental protection activitity [n]\n",
  "CLEANUP": "a large profit; a cleanup operation [n -S]\n",
  "CLEANUPS": "CLEANUP, a large profit; a cleanup operation [n]\n",
  "CLEAR": "to remove obstruction [v -ED, -ING, -S] / easy to see [adj CLEARER, CLEAREST, CLEARLY]\n",
  "CLEARABLE": "that can be cleared [adj]\n",
  "CLEARAGE": "a piece of land cleared [n -S]\n",
  "CLEARAGES": "CLEARAGE, a piece of land cleared [n]\n",
  "CLEARANCE": "the act of clearing [n -S]\n",
  "CLEARANCES": "CLEARANCE, the act of clearing [n]\n",
  "CLEARCOLE": "a priming coat consisting of size or glue with whiting [n -S] / to coat with this, also CLAIRCOLLE [v CLEARCOLED, CLEARCOLING, CLEARCOLES]\n",
  "CLEARCOLED": "CLEARCOLE, to coat with this, also CLAIRCOLLE [v]\n",
  "CLEARCOLES": "CLEARCOLE, a priming coat consisting of size or glue with whiting [n]\n",
  "CLEARCOLING": "CLEARCOLE, to coat with this, also CLAIRCOLLE [v]\n",
  "CLEARCUT": "to cut a forest completely [v CLEARCUT, CLEARCUTTING, CLEARCUTS]\n",
  "CLEARCUTS": "CLEARCUT, to cut a forest completely [v]\n",
  "CLEARCUTTING": "the act of felling timber over a given area [n -S]\n",
  "CLEARCUTTINGS": "CLEARCUTTING, the act of felling timber over a given area [n]\n",
  "CLEARED": "CLEAR, to remove obstruction [v]\n",
  "CLEARER": "one that clears [n -S]\n",
  "CLEARERS": "CLEARER, one that clears [n]\n",
  "CLEAREST": "CLEAR, easy to see [adj]\n",
  "CLEAREYED": "having good judgment [adj]\n",
  "CLEARHEADED": "having or showing a clear understanding [adj CLEARHEADEDLY]\n",
  "CLEARHEADEDLY": "CLEARHEADED, having or showing a clear understanding [adv]\n",
  "CLEARHEADEDNESS": "CLEARHEADED, having or showing a clear understanding [n]\n",
  "CLEARING": "an open space [n -S]\n",
  "CLEARINGHOUSE": "an establishment maintained by banks for settling mutual claims and accounts [n -S]\n",
  "CLEARINGHOUSES": "CLEARINGHOUSE, an establishment maintained by banks for settling mutual claims and accounts [n]\n",
  "CLEARINGS": "CLEARING, an open space [n]\n",
  "CLEARLY": "CLEAR, easy to see [adv]\n",
  "CLEARNESS": "the state of being clear [n -ES]\n",
  "CLEARNESSES": "CLEARNESS, the state of being clear [n]\n",
  "CLEAROUT": "the action of removing unwanted material from a place [n -S]\n",
  "CLEAROUTS": "CLEAROUT, the action of removing unwanted material from a place [n]\n",
  "CLEARS": "CLEAR, to remove obstruction [v]\n",
  "CLEARSKIN": "(Australian) an unbranded animal, also CLEANSKIN [n -S]\n",
  "CLEARSKINS": "CLEARSKIN, (Australian) an unbranded animal, also CLEANSKIN [n]\n",
  "CLEARSTORIED": "having a clearstory [adj]\n",
  "CLEARSTORIES": "CLEARSTORY, the upper storey of a church; windows near the roof of a building, also CLERESTORY [n]\n",
  "CLEARSTORY": "the upper storey of a church; windows near the roof of a building, also CLERESTORY [n CLEARSTORIES]\n",
  "CLEARWAY": "a non-stopping zone of a road [n -S]\n",
  "CLEARWAYS": "CLEARWAY, a non-stopping zone of a road [n]\n",
  "CLEARWEED": "a nettlelike plant [n -S]\n",
  "CLEARWEEDS": "CLEARWEED, a nettlelike plant [n]\n",
  "CLEARWING": "a transparent-winged moth of the family Sesiidae, often resembling wasps [n -S]\n",
  "CLEARWINGS": "CLEARWING, a transparent-winged moth of the family Sesiidae, often resembling wasps [n]\n",
  "CLEAT": "a strip attached to the sole of a shoe to strengthen it [n -S] / to strengthen with a cleat [v -ED, -ING, -S]\n",
  "CLEATED": "CLEAT, to strengthen with a cleat [v]\n",
  "CLEATING": "CLEAT, to strengthen with a cleat [v]\n",
  "CLEATS": "CLEAT, to strengthen with a cleat [v]\n",
  "CLEAVABILITIES": "CLEAVABILITY, the quality of being cleavable [n]\n",
  "CLEAVABILITY": "the quality of being cleavable [n CLEAVABILITIES]\n",
  "CLEAVABLE": "capable of cleaving or being divided [adj]\n",
  "CLEAVABLENESS": "CLEAVABLE, capable of cleaving or being divided [n]\n",
  "CLEAVABLENESSES": "CLEAVABLENESS, CLEAVABLE, capable of cleaving or being divided [n]\n",
  "CLEAVAGE": "a split; a tendency to split, esp. in rocks and minerals [n -S]\n",
  "CLEAVAGES": "CLEAVAGE, a split; a tendency to split, esp. in rocks and minerals [n]\n",
  "CLEAVE": "to split [v CLOVE, CLEFT, CLOVEN, CLEAVING, CLEAVES] / to adhere to [v CLAVE or CLEAVED, CLEAVING, CLEAVES]\n",
  "CLEAVED": "CLEAVE, to split [v]\n",
  "CLEAVER": "a heavy knife [n -S]\n",
  "CLEAVERS": "CLEAVER, a heavy knife [n]\n",
  "CLEAVES": "CLEAVE, to split [v]\n",
  "CLEAVING": "the act of splitting in two [n -S]\n",
  "CLEAVINGS": "CLEAVING, the act of splitting in two [n]\n",
  "CLECHE": "in heraldry, voided or hollowed, showing only a narrow border [adj]\n",
  "CLECK": "(Scots) to hatch [v CLECKED, CLECKING, CLECKS]\n",
  "CLECKED": "CLECK, (Scots) to hatch [v]\n",
  "CLECKIER": "CLECKY, broody [adj]\n",
  "CLECKIEST": "CLECKY, broody [adj]\n",
  "CLECKING": "a brood [n -S]\n",
  "CLECKINGS": "CLECKING, a brood [n]\n",
  "CLECKS": "CLECK, (Scots) to hatch [v]\n",
  "CLECKY": "broody [adj CLECKIER, CLECKIEST]\n",
  "CLEEK": "(Scots) to seize, hook [v CLEEKIT or CLEEKED, CLEEKING, CLEEKS]\n",
  "CLEEKED": "CLEEK, (Scots) to seize, hook [v]\n",
  "CLEEKING": "CLEEK, (Scots) to seize, hook [v]\n",
  "CLEEKIT": "CLEEK, (Scots) to seize, hook [v]\n",
  "CLEEKS": "CLEEK, (Scots) to seize, hook [v]\n",
  "CLEEP": "(archaic) to call, name, also CLEPE [v -ED, -ING, -S]\n",
  "CLEEPED": "CLEEP, (archaic) to call, name, also CLEPE [v]\n",
  "CLEEPING": "CLEEP, (archaic) to call, name, also CLEPE [v]\n",
  "CLEEPS": "CLEEP, (archaic) to call, name, also CLEPE [v]\n",
  "CLEEVE": "(dialect) a cliff, a hillside, also CLEVE [n -S]\n",
  "CLEEVES": "CLEEVE, (dialect) a cliff, a hillside, also CLEVE [n]\n",
  "CLEF": "a character placed on the stave by which the absolute pitch of the following notes is fixed [n -S]\n",
  "CLEFS": "CLEF, a character placed on the stave by which the absolute pitch of the following notes is fixed [n]\n",
  "CLEFT": "to insert a scion into the stock of a plant [v -ED, -ING, -S]\n",
  "CLEFTED": "CLEFT, to insert a scion into the stock of a plant [v]\n",
  "CLEFTING": "CLEFT, to insert a scion into the stock of a plant [v]\n",
  "CLEFTS": "CLEFT, to insert a scion into the stock of a plant [v]\n",
  "CLEG": "a horsefly [n -S]\n",
  "CLEGS": "CLEG, a horsefly [n]\n",
  "CLEIDOIC": "of a bird's or insect's egg, enclosed in a more or less impervious shell [adj]\n",
  "CLEIK": "a kind of golf club [n -S]\n",
  "CLEIKS": "CLEIK, a kind of golf club [n]\n",
  "CLEISTOGAMIC": "relating to cleistogamy, the production of small inconspicuous closed self-pollinating flowers additional to and often more fruitful than showier ones on the same plant, also CLEISTOGAMOUS [adj]\n",
  "CLEISTOGAMIES": "CLEISTOGAMY, the production of small flowers which do not open and in which self-pollination occurs, also CLISTOGAMY [n]\n",
  "CLEISTOGAMOUS": "relating to cleistogamy, the production of small inconspicuous closed self-pollinating flowers additional to and often more fruitful than showier ones on the same plant, also CLEISTOGAMIC [adj CLEISTOGAMOUSLY]\n",
  "CLEISTOGAMOUSLY": "CLEISTOGAMOUS, relating to cleistogamy, the production of small inconspicuous closed self-pollinating flowers additional to and often more fruitful than showier ones on the same plant, also CLEISTOGAMIC [adv]\n",
  "CLEISTOGAMY": "the production of small flowers which do not open and in which self-pollination occurs, also CLISTOGAMY [n CLEISTOGAMIES]\n",
  "CLEITHRAL": "completely roofed over, also CLITHRAL [adj]\n",
  "CLEM": "to starve [v CLEMMED, CLEMMING, CLEMS]\n",
  "CLEMATIS": "(Latin) a climbing plant with showy flowers [n -ES]\n",
  "CLEMATISES": "CLEMATIS, (Latin) a climbing plant with showy flowers [n]\n",
  "CLEMENCIES": "CLEMENCY, mercy [n]\n",
  "CLEMENCY": "mercy [n CLEMENCIES]\n",
  "CLEMENT": "merciful [adj CLEMENTLY]\n",
  "CLEMENTINE": "(French) a hybrid of orange and tangerine [n -S]\n",
  "CLEMENTINES": "CLEMENTINE, (French) a hybrid of orange and tangerine [n]\n",
  "CLEMENTLY": "CLEMENT, merciful [adv]\n",
  "CLEMMED": "CLEM, to starve [v]\n",
  "CLEMMING": "CLEM, to starve [v]\n",
  "CLEMS": "CLEM, to starve [v]\n",
  "CLENBUTEROL": "a drug used in the treatment of asthma, sometimes used illegally to enhance sporting performance [n -S]\n",
  "CLENBUTEROLS": "CLENBUTEROL, a drug used in the treatment of asthma, sometimes used illegally to enhance sporting performance [n]\n",
  "CLENCH": "to grasp firmly [v -ED, -ING, -ES]\n",
  "CLENCHED": "CLENCH, to grasp firmly [v]\n",
  "CLENCHER": "a tool for clenching [n -S]\n",
  "CLENCHERS": "CLENCHER, a tool for clenching [n]\n",
  "CLENCHES": "CLENCH, to grasp firmly [v]\n",
  "CLENCHING": "CLENCH, to grasp firmly [v]\n",
  "CLEOME": "(Latin) an aromatic plant with white or purplish flowers [n -S]\n",
  "CLEOMES": "CLEOME, (Latin) an aromatic plant with white or purplish flowers [n]\n",
  "CLEOPATRA": "a yellow European butterfly [n -S]\n",
  "CLEOPATRAS": "CLEOPATRA, a yellow European butterfly [n]\n",
  "CLEPE": "(archaic) to call, name, also CLEEP [v CLEPED or (US) CLEPT or (obsolete) YCLEPED or YCLEPT, CLEPING, CLEPES]\n",
  "CLEPED": "CLEPE, (archaic) to call, name, also CLEEP [v]\n",
  "CLEPES": "CLEPE, (archaic) to call, name, also CLEEP [v]\n",
  "CLEPING": "CLEPE, (archaic) to call, name, also CLEEP [v]\n",
  "CLEPSYDRA": "(Greek) an instrument which measures time by trickling water [n CLEPSYDRAE or CLEPSYDRAS]\n",
  "CLEPSYDRAE": "CLEPSYDRA, (Greek) an instrument which measures time by trickling water [n]\n",
  "CLEPSYDRAS": "CLEPSYDRA, (Greek) an instrument which measures time by trickling water [n]\n",
  "CLEPT": "CLEPE, (archaic) to call, name, also CLEEP [v]\n",
  "CLEPTOCRACIES": "CLEPTOCRACY, rule by thieves, also KLEPTOCRACY [n]\n",
  "CLEPTOCRACY": "rule by thieves, also KLEPTOCRACY [n CLEPTOCRACIES]\n",
  "CLEPTOMANIA": "an obsessive urge to steal, driven by emotional disturbance rather than material need, also KLEPTOMANIA [n -S]\n",
  "CLEPTOMANIAC": "a person having an obsessive urge to steal, also KLEPTO, KLEPTOMANIAC [n -S]\n",
  "CLEPTOMANIACS": "CLEPTOMANIAC, a person having an obsessive urge to steal, also KLEPTO, KLEPTOMANIAC [n]\n",
  "CLEPTOMANIAS": "CLEPTOMANIA, an obsessive urge to steal, driven by emotional disturbance rather than material need, also KLEPTOMANIA [n]\n",
  "CLERESTORIED": "having a clerestory [adj]\n",
  "CLERESTORIES": "CLERESTORY, the upper storey of a church; windows near the roof of a building, also CLEARSTORY [n]\n",
  "CLERESTORY": "the upper storey of a church; windows near the roof of a building, also CLEARSTORY [n CLERESTORIES]\n",
  "CLERGIABLE": "entitled to, or admitting, the benefit of clergy; as, a clergiable felony, also CLERGYABLE [adj]\n",
  "CLERGIES": "CLERGY, the body of persons ordained for religious service [n]\n",
  "CLERGY": "the body of persons ordained for religious service [n CLERGIES]\n",
  "CLERGYABLE": "entitled to, or admitting, the benefit of clergy; as, a clergyable felony, also CLERGIABLE [adj]\n",
  "CLERGYMAN": "one who works for the church [n CLERGYMEN]\n",
  "CLERGYMEN": "CLERGYMAN, one who works for the church [n]\n",
  "CLERGYWOMAN": "a woman who is a member of the clergy [n CLERGYWOMEN]\n",
  "CLERGYWOMEN": "CLERGYWOMAN, a woman who is a member of the clergy [n]\n",
  "CLERIC": "a member of the clergy, also CLERICAL [n -S]\n",
  "CLERICAL": "like a cleric [adj CLERICALLY] / a member of the clergy, also CLERIC [n -S]\n",
  "CLERICALISM": "a policy of maintaining or increasing the power of a religious hierarchy [n -S]\n",
  "CLERICALISMS": "CLERICALISM, a policy of maintaining or increasing the power of a religious hierarchy [n]\n",
  "CLERICALIST": "one who favors maintained or increased ecclesiastical power and influence [n -S]\n",
  "CLERICALISTS": "CLERICALIST, one who favors maintained or increased ecclesiastical power and influence [n]\n",
  "CLERICALLY": "CLERICAL, like a cleric [adv]\n",
  "CLERICALS": "CLERICAL, a member of the clergy, also CLERIC [n]\n",
  "CLERICATE": "the position of a clergyman [n -S]\n",
  "CLERICATES": "CLERICATE, the position of a clergyman [n]\n",
  "CLERICITIES": "CLERICITY, the state of being a clergyman [n]\n",
  "CLERICITY": "the state of being a clergyman [n CLERICITIES]\n",
  "CLERICS": "CLERIC, a member of the clergy, also CLERICAL [n]\n",
  "CLERID": "a predatory beetle [n -S]\n",
  "CLERIDS": "CLERID, a predatory beetle [n]\n",
  "CLERIHEW": "a light verse quatrain rhyming AABB and usually dealing with a person named in the initial rhyme [n -S]\n",
  "CLERIHEWS": "CLERIHEW, a light verse quatrain rhyming AABB and usually dealing with a person named in the initial rhyme [n]\n",
  "CLERISIES": "CLERISY, scholars and educated people as a class [n]\n",
  "CLERISY": "scholars and educated people as a class [n CLERISIES]\n",
  "CLERK": "to serve as an office worker [v -ED, -ING, -S]\n",
  "CLERKDOM": "the status of a clerk [n -S]\n",
  "CLERKDOMS": "CLERKDOM, the status of a clerk [n]\n",
  "CLERKED": "CLERK, to serve as an office worker [v]\n",
  "CLERKESS": "a female clerk [n -ES]\n",
  "CLERKESSES": "CLERKESS, a female clerk [n]\n",
  "CLERKING": "CLERK, to serve as an office worker [v]\n",
  "CLERKISH": "resembling a clerk [adj]\n",
  "CLERKLIER": "CLERKLY, pertaining to a clerk [adj]\n",
  "CLERKLIEST": "CLERKLY, pertaining to a clerk [adj]\n",
  "CLERKLIKE": "like a clerk [adj]\n",
  "CLERKLINESS": "the state of being clerkly [n -ES]\n",
  "CLERKLINESSES": "CLERKLINESS, the state of being clerkly [n]\n",
  "CLERKLING": "a small clerk [n -S]\n",
  "CLERKLINGS": "CLERKLING, a small clerk [n]\n",
  "CLERKLY": "pertaining to a clerk [adj CLERKLIER, CLERKLIEST]\n",
  "CLERKS": "CLERK, to serve as an office worker [v]\n",
  "CLERKSHIP": "the state, quality, or business of a clerk [n -S]\n",
  "CLERKSHIPS": "CLERKSHIP, the state, quality, or business of a clerk [n]\n",
  "CLEROMANCIES": "CLEROMANCY, divination using dice [n]\n",
  "CLEROMANCY": "divination using dice [n CLEROMANCIES]\n",
  "CLERUCH": "a citizen of Athens having land in another country, also CLERUCHY [n -S]\n",
  "CLERUCHIA": "an allotment of land in a foreign territory made to a citizen of Athens, also CLERUCHY [n -S]\n",
  "CLERUCHIAL": "of or like a cleruchy [adj]\n",
  "CLERUCHIAS": "CLERUCHIA, an allotment of land in a foreign territory made to a citizen of Athens, also CLERUCHY [n]\n",
  "CLERUCHIES": "CLERUCHY, (Greek) an allotment of land in a foreign territory made to a citizen of Athens, also CLERUCHIA [n]\n",
  "CLERUCHS": "CLERUCH, a citizen of Athens having land in another country, also CLERUCHY [n]\n",
  "CLERUCHY": "(Greek) an allotment of land in a foreign territory made to a citizen of Athens, also CLERUCHIA [n CLERUCHIES]\n",
  "CLEUCH": "(Scots) a ravine, a gully, also CLEUGH, CLOUGH [n -S]\n",
  "CLEUCHS": "CLEUCH, (Scots) a ravine, a gully, also CLEUGH, CLOUGH [n]\n",
  "CLEUGH": "(Scots) a ravine, a gully, also CLEUCH, CLOUGH [n -S]\n",
  "CLEUGHS": "CLEUGH, (Scots) a ravine, a gully, also CLEUCH, CLOUGH [n]\n",
  "CLEVE": "(dialect) a cliff, a hillside, also CLEEVE [n -S]\n",
  "CLEVEITE": "a radioactive mineral [n -S]\n",
  "CLEVEITES": "CLEVEITE, a radioactive mineral [n]\n",
  "CLEVER": "intelligent, dexterous [adj CLEVERER, CLEVEREST, CLEVERLY]\n",
  "CLEVERALITIES": "CLEVERALITY, (Scots) cleverness [n]\n",
  "CLEVERALITY": "(Scots) cleverness [n CLEVERALITIES]\n",
  "CLEVERDICK": "an annoyingly clever person [n -S]\n",
  "CLEVERDICKS": "CLEVERDICK, an annoyingly clever person [n]\n",
  "CLEVERER": "CLEVER, intelligent, dexterous [adj]\n",
  "CLEVEREST": "CLEVER, intelligent, dexterous [adj]\n",
  "CLEVERISH": "somewhat clever [adj]\n",
  "CLEVERLY": "CLEVER, intelligent, dexterous [adv]\n",
  "CLEVERNESS": "the quality of being clever [n -ES]\n",
  "CLEVERNESSES": "CLEVERNESS, the quality of being clever [n]\n",
  "CLEVES": "CLEVE, (dialect) a cliff, a hillside, also CLEEVE [n]\n",
  "CLEVIS": "a U-shaped fastener with pin used to close the open end [n -ES]\n",
  "CLEVISES": "CLEVIS, a U-shaped fastener with pin used to close the open end [n]\n",
  "CLEW": "a corner of a sail with a hole to attach ropes [n -S] / to attach a rope to the corner of a sail [v -ED, -ING, -S]\n",
  "CLEWED": "CLEW, to attach a rope to the corner of a sail [v]\n",
  "CLEWING": "CLEW, to attach a rope to the corner of a sail [v]\n",
  "CLEWS": "CLEW, to attach a rope to the corner of a sail [v]\n",
  "CLIANTHUS": "(Latin) any climbing shrub of the genus Clianthus [n -ES]\n",
  "CLIANTHUSES": "CLIANTHUS, (Latin) any climbing shrub of the genus Clianthus [n]\n",
  "CLICHE": "(French) a stereotyped phrase [n -S]\n",
  "CLICHED": "full of cliches, also CLICHEED [adj]\n",
  "CLICHEED": "full of cliches, also CLICHED [adj]\n",
  "CLICHES": "CLICHE, (French) a stereotyped phrase [n]\n",
  "CLICK": "to make a short sharp sound [v -ED, -ING, -S]\n",
  "CLICKABLE": "that can be clicked, e.g. a computer icon [adj]\n",
  "CLICKBAIT": "intriguing or sensational hyperlinks that encourage readers to click through to another website [n -S]\n",
  "CLICKBAITS": "CLICKBAIT, intriguing or sensational hyperlinks that encourage readers to click through to another website [n]\n",
  "CLICKED": "CLICK, to make a short sharp sound [v]\n",
  "CLICKER": "the compositor who distributes the copy among a companionship of printers [n -S]\n",
  "CLICKERS": "CLICKER, the compositor who distributes the copy among a companionship of printers [n]\n",
  "CLICKET": "to make a clicking sound [v -ED, -ING, -S]\n",
  "CLICKETED": "CLICKET, to make a clicking sound [v]\n",
  "CLICKETING": "CLICKET, to make a clicking sound [v]\n",
  "CLICKETS": "CLICKET, to make a clicking sound [v]\n",
  "CLICKING": "a series of clicks [n -S]\n",
  "CLICKINGS": "CLICKING, a series of clicks [n]\n",
  "CLICKJACKING": "the practice of using a disguised hyperlink to direct an internet user to a website he or she does not wish to visit [n -S]\n",
  "CLICKJACKINGS": "CLICKJACKING, the practice of using a disguised hyperlink to direct an internet user to a website he or she does not wish to visit [n]\n",
  "CLICKLESS": "without a click [adj]\n",
  "CLICKS": "CLICK, to make a short sharp sound [v]\n",
  "CLICKSTREAM": "a path used in navigating cyberspace [n -S]\n",
  "CLICKSTREAMS": "CLICKSTREAM, a path used in navigating cyberspace [n]\n",
  "CLICKTIVISM": "a policy of using the internet to take direct and often militant action to achieve a political or social aim [n -S]\n",
  "CLICKTIVISMS": "CLICKTIVISM, a policy of using the internet to take direct and often militant action to achieve a political or social aim [n]\n",
  "CLICKWRAP": "an agreement by a computer user through clicking on a particular button onscreen [n -S]\n",
  "CLICKWRAPS": "CLICKWRAP, an agreement by a computer user through clicking on a particular button onscreen [n]\n",
  "CLIED": "CLY, to seize or steal [v]\n",
  "CLIENT": "a customer [n -S]\n",
  "CLIENTAGE": "clients collectively [n -S]\n",
  "CLIENTAGES": "CLIENTAGE, clients collectively [n]\n",
  "CLIENTAL": "of or pertaining to a client [adj]\n",
  "CLIENTELE": "(French) a body of clients, a following [n -S]\n",
  "CLIENTELES": "CLIENTELE, (French) a body of clients, a following [n]\n",
  "CLIENTLESS": "without clients [adj]\n",
  "CLIENTS": "CLIENT, a customer [n]\n",
  "CLIENTSHIP": "the state of being a client [n -S]\n",
  "CLIENTSHIPS": "CLIENTSHIP, the state of being a client [n]\n",
  "CLIES": "CLY, to seize or steal [v]\n",
  "CLIFF": "a high, steep face of rock [n -S]\n",
  "CLIFFED": "having cliffs, also CLIFTED, CLIFTY [adj]\n",
  "CLIFFHANG": "to keep a reader in suspense [v CLIFFHUNG, CLIFFHANGING, CLIFFHANGS]\n",
  "CLIFFHANGER": "a narrative that ends each section on a suspenseful note [n -S]\n",
  "CLIFFHANGERS": "CLIFFHANGER, a narrative that ends each section on a suspenseful note [n]\n",
  "CLIFFHANGING": "the act of keeping a reader in suspense [n -S]\n",
  "CLIFFHANGINGS": "CLIFFHANGING, the act of keeping a reader in suspense [n]\n",
  "CLIFFHANGS": "CLIFFHANG, to keep a reader in suspense [v]\n",
  "CLIFFHUNG": "CLIFFHANG, to keep a reader in suspense [v]\n",
  "CLIFFIER": "CLIFFY, abounding in cliffs [adj]\n",
  "CLIFFIEST": "CLIFFY, abounding in cliffs [adj]\n",
  "CLIFFLIKE": "like a cliff [adj]\n",
  "CLIFFS": "CLIFF, a high, steep face of rock [n]\n",
  "CLIFFSIDE": "the side of a cliff [n -S]\n",
  "CLIFFSIDES": "CLIFFSIDE, the side of a cliff [n]\n",
  "CLIFFTOP": "the top of a cliff [n -S]\n",
  "CLIFFTOPS": "CLIFFTOP, the top of a cliff [n]\n",
  "CLIFFY": "abounding in cliffs [adj CLIFFIER, CLIFFIEST]\n",
  "CLIFT": "a cliff [n -S]\n",
  "CLIFTED": "broken into cliffs [adj]\n",
  "CLIFTIER": "CLIFTY, broken into cliffs [adj]\n",
  "CLIFTIEST": "CLIFTY, broken into cliffs [adj]\n",
  "CLIFTS": "CLIFT, a cliff [n]\n",
  "CLIFTY": "broken into cliffs [adj CLIFTIER, CLIFTIEST]\n",
  "CLIMACTERIC": "a supposedly critical stage in human life, esp. occurring at ages that are multiples of seven years [n -S]\n",
  "CLIMACTERICAL": "relating to a climacteric [adj CLIMACTERICALLY]\n",
  "CLIMACTERICALLY": "CLIMACTERICAL, relating to a climacteric [adv]\n",
  "CLIMACTERICS": "CLIMACTERIC, a supposedly critical stage in human life, esp. occurring at ages that are multiples of seven years [n]\n",
  "CLIMACTIC": "relating to a climax, also CLIMACTICAL [adj CLIMACTICALLY]\n",
  "CLIMACTICAL": "relating to a climax, also CLIMACTIC [adj CLIMACTICALLY]\n",
  "CLIMACTICALLY": "CLIMACTICAL, relating to a climax, also CLIMACTIC [adv]\n",
  "CLIMATAL": "pertaining to climate [adj]\n",
  "CLIMATE": "to remain in a certain place [v CLIMATED, CLIMATING, CLIMATES]\n",
  "CLIMATED": "CLIMATE, to remain in a certain place [v]\n",
  "CLIMATES": "CLIMATE, to remain in a certain place [v]\n",
  "CLIMATIC": "pertaining to climate [adj CLIMATICALLY]\n",
  "CLIMATICAL": "relating to climate, also CLIMATIC [adj CLIMATICALLY]\n",
  "CLIMATICALLY": "CLIMATICAL, relating to climate, also CLIMATIC [adv]\n",
  "CLIMATING": "CLIMATE, to remain in a certain place [v]\n",
  "CLIMATISE": "to acclimatise, also CLIMATIZE [v CLIMATISED, CLIMATISING, CLIMATISES]\n",
  "CLIMATISED": "CLIMATISE, to acclimatise, also CLIMATIZE [v]\n",
  "CLIMATISES": "CLIMATISE, to acclimatise, also CLIMATIZE [v]\n",
  "CLIMATISING": "CLIMATISE, to acclimatise, also CLIMATIZE [v]\n",
  "CLIMATIZE": "to acclimatize, also CLIMATISE [v CLIMATIZED, CLIMATIZING, CLIMATIZES]\n",
  "CLIMATIZED": "CLIMATIZE, to acclimatize, also CLIMATISE [v]\n",
  "CLIMATIZES": "CLIMATIZE, to acclimatize, also CLIMATISE [v]\n",
  "CLIMATIZING": "CLIMATIZE, to acclimatize, also CLIMATISE [v]\n",
  "CLIMATOGRAPHIES": "CLIMATOGRAPHY, a description of climates [n]\n",
  "CLIMATOGRAPHY": "a description of climates [n CLIMATOGRAPHIES]\n",
  "CLIMATOLOGIC": "relating to climatology, also CLIMATOLOGICAL [adj]\n",
  "CLIMATOLOGICAL": "relating to climatology, also CLIMATOLOGIC [adj]\n",
  "CLIMATOLOGIES": "CLIMATOLOGY, the study of the climates of the earth [n]\n",
  "CLIMATOLOGIST": "one who studies climatology [n -S]\n",
  "CLIMATOLOGISTS": "CLIMATOLOGIST, one who studies climatology [n]\n",
  "CLIMATOLOGY": "the study of the climates of the earth [n CLIMATOLOGIES]\n",
  "CLIMATURE": "(Shakespeare) a region [n -S]\n",
  "CLIMATURES": "CLIMATURE, (Shakespeare) a region [n]\n",
  "CLIMAX": "to reach a high point [v -ED, -ING, -ES]\n",
  "CLIMAXED": "CLIMAX, to reach a high point [v]\n",
  "CLIMAXES": "CLIMAX, to reach a high point [v]\n",
  "CLIMAXING": "CLIMAX, to reach a high point [v]\n",
  "CLIMAXLESS": "without a climax [adj]\n",
  "CLIMB": "to ascend [v CLAMBE or CLOMB or CLIMBED, CLIMBING, CLIMBS]\n",
  "CLIMBABLE": "that can be climbed [adj]\n",
  "CLIMBDOWN": "a retreat from a previously held position [n -S]\n",
  "CLIMBDOWNS": "CLIMBDOWN, a retreat from a previously held position [n]\n",
  "CLIMBED": "CLIMB, to ascend [v]\n",
  "CLIMBER": "one that climbs [n -S]\n",
  "CLIMBERS": "CLIMBER, one that climbs [n]\n",
  "CLIMBING": "the act of climbing [n -S]\n",
  "CLIMBINGS": "CLIMBING, the act of climbing [n]\n",
  "CLIMBS": "CLIMB, to ascend [v]\n",
  "CLIME": "the atmosphere of an area [n -S]\n",
  "CLIMES": "CLIME, the atmosphere of an area [n]\n",
  "CLINAL": "pertaining to a cline, a gradual geographical change in the colour or morphology of a species [adj CLINALLY]\n",
  "CLINALLY": "CLINAL, pertaining to a cline, a gradual geographical change in the colour or morphology of a species [adv]\n",
  "CLINAMEN": "(Latin) a bias, an inclination [n -S]\n",
  "CLINAMENS": "CLINAMEN, (Latin) a bias, an inclination [n]\n",
  "CLINANDRIA": "CLINANDRIUM, a cavity in the upper part of the column of an orchid flower that contains the anthers [n]\n",
  "CLINANDRIUM": "a cavity in the upper part of the column of an orchid flower that contains the anthers [n CLINANDRIA]\n",
  "CLINCH": "to settle a matter decisively [v -ED, -ING, -ES]\n",
  "CLINCHED": "CLINCH, to settle a matter decisively [v]\n",
  "CLINCHER": "a decisive remark [n -S]\n",
  "CLINCHERS": "CLINCHER, a decisive remark [n]\n",
  "CLINCHES": "CLINCH, to settle a matter decisively [v]\n",
  "CLINCHING": "CLINCH, to settle a matter decisively [v]\n",
  "CLINCHINGLY": "CLINCHING, CLINCH, to settle a matter decisively [adv]\n",
  "CLINDAMYCIN": "an antibiotic drug used for serious infections that do not respond to other antibiotics [n -S]\n",
  "CLINDAMYCINS": "CLINDAMYCIN, an antibiotic drug used for serious infections that do not respond to other antibiotics [n]\n",
  "CLINE": "a gradual geographical change in color or morphology of a species [n -S]\n",
  "CLINES": "CLINE, a gradual geographical change in color or morphology of a species [n]\n",
  "CLING": "to adhere to [v CLUNG or CLINGED, CLINGING, CLINGS]\n",
  "CLINGED": "CLING, to adhere to [v]\n",
  "CLINGER": "something or someone that clings [n -S]\n",
  "CLINGERS": "CLINGER, something or someone that clings [n]\n",
  "CLINGFILM": "thin plastic film that adheres to surfaces, used esp. for wrapping and covering foods [n -S]\n",
  "CLINGFILMS": "CLINGFILM, thin plastic film that adheres to surfaces, used esp. for wrapping and covering foods [n]\n",
  "CLINGFISH": "any small marine teleost fish of the family Gobiesocidae [n -ES]\n",
  "CLINGFISHES": "CLINGFISH, any small marine teleost fish of the family Gobiesocidae [n]\n",
  "CLINGIER": "CLINGY, adhesive [adj]\n",
  "CLINGIEST": "CLINGY, adhesive [adj]\n",
  "CLINGINESS": "the state of being clingy [n -ES]\n",
  "CLINGINESSES": "CLINGINESS, the state of being clingy [n]\n",
  "CLINGING": "CLING, to adhere to [v]\n",
  "CLINGINGLY": "CLINGING, CLING, to adhere to [adv]\n",
  "CLINGINGNESS": "emotional dependency [n -ES]\n",
  "CLINGINGNESSES": "CLINGINGNESS, emotional dependency [n]\n",
  "CLINGS": "CLING, to adhere to [v]\n",
  "CLINGSTONE": "having the flesh attached closely to the stone [adj] / a fruit, e.g. a peach, having the flesh attached closely to the stone [n -S]\n",
  "CLINGSTONES": "CLINGSTONE, a fruit, e.g. a peach, having the flesh attached closely to the stone [n]\n",
  "CLINGWRAP": "a thin polythene material that clings closely to any surface around which it is placed: used for wrapping food [n -S]\n",
  "CLINGWRAPS": "CLINGWRAP, a thin polythene material that clings closely to any surface around which it is placed: used for wrapping food [n]\n",
  "CLINGY": "adhesive [adj CLINGIER, CLINGIEST]\n",
  "CLINIC": "a medical facility [n -S]\n",
  "CLINICAL": "relating to a clinic [adj CLINICALLY]\n",
  "CLINICALLY": "CLINICAL, relating to a clinic [adv]\n",
  "CLINICALNESS": "the state of being clinical [n -ES]\n",
  "CLINICALNESSES": "CLINICALNESS, the state of being clinical [n]\n",
  "CLINICIAN": "a doctor having direct contact with and responsibility for patients [n -S]\n",
  "CLINICIANS": "CLINICIAN, a doctor having direct contact with and responsibility for patients [n]\n",
  "CLINICS": "CLINIC, a medical facility [n]\n",
  "CLINIQUE": "(French) a clinic [n -S]\n",
  "CLINIQUES": "CLINIQUE, (French) a clinic [n]\n",
  "CLINK": "to make a short soft ringing sound [v -ED, -ING, -S]\n",
  "CLINKED": "CLINK, to make a short soft ringing sound [v]\n",
  "CLINKER": "to make furnace slag [v -ED, -ING, -S]\n",
  "CLINKERED": "CLINKER, to make furnace slag [v]\n",
  "CLINKERING": "CLINKER, to make furnace slag [v]\n",
  "CLINKERS": "CLINKER, to make furnace slag [v]\n",
  "CLINKING": "CLINK, to make a short soft ringing sound [v]\n",
  "CLINKS": "CLINK, to make a short soft ringing sound [v]\n",
  "CLINKSTONE": "a fine-grained intermediate igneous rock, aka phonolite, that rings when struck by a hammer [n -S]\n",
  "CLINKSTONES": "CLINKSTONE, a fine-grained intermediate igneous rock, aka phonolite, that rings when struck by a hammer [n]\n",
  "CLINOAXES": "CLINOAXIS, in crystallography, the clinodiagonal [n]\n",
  "CLINOAXIS": "in crystallography, the clinodiagonal [n CLINOAXES]\n",
  "CLINOCHLORE": "a hexagonal variety of chlorite rich in magnesium and aluminium and usually poor in iron, aka ripidolite [n -S]\n",
  "CLINOCHLORES": "CLINOCHLORE, a hexagonal variety of chlorite rich in magnesium and aluminium and usually poor in iron, aka ripidolite [n]\n",
  "CLINODIAGONAL": "in a monoclinic crystal, that lateral axis which is not perpendicular to the vertical axis [n -S]\n",
  "CLINODIAGONALS": "CLINODIAGONAL, in a monoclinic crystal, that lateral axis which is not perpendicular to the vertical axis [n]\n",
  "CLINOMETER": "an instrument for measuring the incline (slope) of a surface [n -S]\n",
  "CLINOMETERS": "CLINOMETER, an instrument for measuring the incline (slope) of a surface [n]\n",
  "CLINOMETRIC": "relating to clinometry, the art or operation of measuring the inclination of strata, also CLINOMETRICAL [adj]\n",
  "CLINOMETRICAL": "relating to clinometry, the art or operation of measuring the inclination of strata, also CLINOMETRIC [adj]\n",
  "CLINOMETRIES": "CLINOMETRY, the art or operation of measuring the inclination of strata [n]\n",
  "CLINOMETRY": "the art or operation of measuring the inclination of strata [n CLINOMETRIES]\n",
  "CLINOPINACOID": "a form consisting of two faces parallel to the clinoaxis and the vertical axis, also CLINOPINAKOID [n -S]\n",
  "CLINOPINACOIDS": "CLINOPINACOID, a form consisting of two faces parallel to the clinoaxis and the vertical axis, also CLINOPINAKOID [n]\n",
  "CLINOPINAKOID": "a form consisting of two faces parallel to the clinoaxis and the vertical axis, also CLINOPINACOID [n -S]\n",
  "CLINOPINAKOIDS": "CLINOPINAKOID, a form consisting of two faces parallel to the clinoaxis and the vertical axis, also CLINOPINACOID [n]\n",
  "CLINOPYROXENE": "a member of the pyroxene group of minerals having a monoclinic crystal structure, such as augite, diopside, or jadeite [n -S]\n",
  "CLINOPYROXENES": "CLINOPYROXENE, a member of the pyroxene group of minerals having a monoclinic crystal structure, such as augite, diopside, or jadeite [n]\n",
  "CLINOSTAT": "an apparatus for studying tropisms in plants [n -S]\n",
  "CLINOSTATS": "CLINOSTAT, an apparatus for studying tropisms in plants [n]\n",
  "CLINQUANT": "(French) glittering, esp. with gold or tinsel [adj] / tinsel, glitter [n -S]\n",
  "CLINQUANTS": "CLINQUANT, tinsel, glitter [n]\n",
  "CLINT": "a block in a limestone pavement [n -S]\n",
  "CLINTONIA": "any temperate liliaceous plant of the genus Clintonia having broad basal leaves and white or yellowish or purplish flowers followed by blue or black berries [n -S]\n",
  "CLINTONIAS": "CLINTONIA, any temperate liliaceous plant of the genus Clintonia having broad basal leaves and white or yellowish or purplish flowers followed by blue or black berries [n]\n",
  "CLINTS": "CLINT, a block in a limestone pavement [n]\n",
  "CLIOMETRIC": "relating to cliometrics, the application of methods developed in other fields (as economics, statistics, and data processing) to the study of history, also CLIOMETRICAL [adj]\n",
  "CLIOMETRICAL": "relating to cliometrics, the application of methods developed in other fields (as economics, statistics, and data processing) to the study of history, also CLIOMETRIC [adj]\n",
  "CLIOMETRICIAN": "one who uses mathematics/computers to analyze historical data [n -S]\n",
  "CLIOMETRICIANS": "CLIOMETRICIAN, one who uses mathematics/computers to analyze historical data [n]\n",
  "CLIOMETRICS": "the application of statistical analysis of data in economic history [n]\n",
  "CLIOMETRIES": "CLIOMETRY, the systematic application of economic theory, econometric techniques, and other formal or mathematical methods to the study of history [n]\n",
  "CLIOMETRY": "the systematic application of economic theory, econometric techniques, and other formal or mathematical methods to the study of history [n CLIOMETRIES]\n",
  "CLIP": "to trim by cutting [v CLIPT or CLIPPED, CLIPPING, CLIPS]\n",
  "CLIPART": "graphical pieces that can be pasted into documents electronically [n -S]\n",
  "CLIPARTS": "CLIPART, graphical pieces that can be pasted into documents electronically [n]\n",
  "CLIPBOARD": "a portable board with a spring clip for holding papers [n -S]\n",
  "CLIPBOARDS": "CLIPBOARD, a portable board with a spring clip for holding papers [n]\n",
  "CLIPE": "to tell tales, also CLYPE [v CLIPED, CLIPING, CLIPES]\n",
  "CLIPED": "CLIPE, to tell tales, also CLYPE [v]\n",
  "CLIPES": "CLIPE, to tell tales, also CLYPE [v]\n",
  "CLIPING": "CLIPE, to tell tales, also CLYPE [v]\n",
  "CLIPPABLE": "that can be clipped [adj]\n",
  "CLIPPED": "CLIP, to trim by cutting [v]\n",
  "CLIPPER": "a kind of sailing ship [n -S]\n",
  "CLIPPERS": "CLIPPER, a kind of sailing ship [n]\n",
  "CLIPPIE": "(colloquial) a woman tram or bus conductor [n -S]\n",
  "CLIPPIES": "CLIPPIE, (colloquial) a woman tram or bus conductor [n]\n",
  "CLIPPING": "something that is clipped off [n -S]\n",
  "CLIPPINGS": "CLIPPING, something that is clipped off [n]\n",
  "CLIPS": "CLIP, to trim by cutting [v]\n",
  "CLIPSHEAR": "(Scots) an earwig [n -S]\n",
  "CLIPSHEARS": "CLIPSHEAR, (Scots) an earwig [n]\n",
  "CLIPSHEET": "a sheet clipped on to a clipboard [n -S]\n",
  "CLIPSHEETS": "CLIPSHEET, a sheet clipped on to a clipboard [n]\n",
  "CLIPT": "CLIP, to trim by cutting [v]\n",
  "CLIQUE": "to form an exclusive group [v CLIQUED, CLIQUING, CLIQUES]\n",
  "CLIQUED": "CLIQUE, to form an exclusive group [v]\n",
  "CLIQUES": "CLIQUE, to form an exclusive group [v]\n",
  "CLIQUEY": "inclined to form cliques [adj CLIQUIER, CLIQUIEST]\n",
  "CLIQUIER": "CLIQUEY, inclined to form cliques [adj]\n",
  "CLIQUIEST": "CLIQUEY, inclined to form cliques [adj]\n",
  "CLIQUINESS": "the state of being cliquey [n -ES]\n",
  "CLIQUINESSES": "CLIQUINESS, the state of being cliquey [n]\n",
  "CLIQUING": "CLIQUE, to form an exclusive group [v]\n",
  "CLIQUISH": "relating to a clique, exclusive, also CLIQUEY, CLIQUY [adj CLIQUISHLY]\n",
  "CLIQUISHLY": "CLIQUISH, relating to a clique, exclusive, also CLIQUEY, CLIQUY [adv]\n",
  "CLIQUISHNESS": "the state of being cliquish [n -ES]\n",
  "CLIQUISHNESSES": "CLIQUISHNESS, the state of being cliquish [n]\n",
  "CLIQUISM": "the tendency to form cliques [n -S]\n",
  "CLIQUISMS": "CLIQUISM, the tendency to form cliques [n]\n",
  "CLIQUY": "relating to a clique, exclusive, also CLIQUEY, CLIQUISH [adj CLIQUIER, CLIQUIEST]\n",
  "CLISHMACLAVER": "(Scots) gossip [n -S]\n",
  "CLISHMACLAVERS": "CLISHMACLAVER, (Scots) gossip [n]\n",
  "CLISTOGAMIES": "CLISTOGAMY, the production of small flowers which do not open and in which self-pollination occurs, also CLEISTOGAMY [n]\n",
  "CLISTOGAMY": "the production of small flowers which do not open and in which self-pollination occurs, also CLEISTOGAMY [n CLISTOGAMIES]\n",
  "CLIT": "(vulgar slang) the clitoris [n -S]\n",
  "CLITELLA": "CLITELLUM, (Latin) a region in the body walls of certain annelid worms [n]\n",
  "CLITELLAR": "relating to the clitellum [adj]\n",
  "CLITELLUM": "(Latin) a region in the body walls of certain annelid worms [n CLITELLA]\n",
  "CLITHRAL": "completely roofed over, also CLEITHRAL [adj]\n",
  "CLITIC": "a word whose pronunciation depends on the adjacent word [n -S]\n",
  "CLITICISE": "to pronounce as part of following or preceding word, also CLITICIZE [v CLITICISED, CLITICISING, CLITICISES]\n",
  "CLITICISED": "CLITICISE, to pronounce as part of following or preceding word, also CLITICIZE [v]\n",
  "CLITICISES": "CLITICISE, to pronounce as part of following or preceding word, also CLITICIZE [v]\n",
  "CLITICISING": "CLITICISE, to pronounce as part of following or preceding word, also CLITICIZE [v]\n",
  "CLITICIZE": "to pronounce as part of following or preceding word, also CLITICISE [v CLITICIZED, CLITICIZING, CLITICIZES]\n",
  "CLITICIZED": "CLITICIZE, to pronounce as part of following or preceding word, also CLITICISE [v]\n",
  "CLITICIZES": "CLITICIZE, to pronounce as part of following or preceding word, also CLITICISE [v]\n",
  "CLITICIZING": "CLITICIZE, to pronounce as part of following or preceding word, also CLITICISE [v]\n",
  "CLITICS": "CLITIC, a word whose pronunciation depends on the adjacent word [n]\n",
  "CLITORAL": "relating to the clitoris [adj]\n",
  "CLITORECTOMIES": "CLITORECTOMY, the surgical removal of the clitoris [n]\n",
  "CLITORECTOMY": "the surgical removal of the clitoris [n CLITORECTOMIES]\n",
  "CLITORIC": "pertaining to the clitoris [adj]\n",
  "CLITORIDECTOMY": "surgical removal of the clitoris [n]\n",
  "CLITORIDES": "CLITORIS, a small erectile part of the female genitals in mammals and some other vertebrates [n]\n",
  "CLITORIS": "a small erectile part of the female genitals in mammals and some other vertebrates [n CLITORIDES or CLITORISES]\n",
  "CLITORISES": "CLITORIS, a small erectile part of the female genitals in mammals and some other vertebrates [n]\n",
  "CLITS": "CLIT, (vulgar slang) the clitoris [n]\n",
  "CLITTER": "to make a shrill rattling noise [v -ED, -ING, -S]\n",
  "CLITTERED": "CLITTER, to make a shrill rattling noise [v]\n",
  "CLITTERING": "CLITTER, to make a shrill rattling noise [v]\n",
  "CLITTERS": "CLITTER, to make a shrill rattling noise [v]\n",
  "CLIVERS": "an annual herb, goosegrass [n CLIVERS]\n",
  "CLIVIA": "a leek-like South African plant [n -S]\n",
  "CLIVIAS": "CLIVIA, a leek-like South African plant [n]\n",
  "CLOACA": "(Latin) the terminal part of the gut in birds [n CLOACAE or CLOACAS]\n",
  "CLOACAE": "CLOACA, (Latin) the terminal part of the gut in birds [n]\n",
  "CLOACAL": "relating to a cloaca [adj]\n",
  "CLOACALINE": "relating to the cloaca, also CLOACAL, CLOACINAL [adj]\n",
  "CLOACAS": "CLOACA, (Latin) the terminal part of the gut in birds [n]\n",
  "CLOACINAL": "relating to the cloaca, also CLOACAL, CLOACALINE [adj]\n",
  "CLOACITIS": "inflammation of the cloaca in birds [n -ES]\n",
  "CLOACITISES": "CLOACITIS, inflammation of the cloaca in birds [n]\n",
  "CLOAK": "to clothe with a cloak, to conceal, also CLOKE [v -ED, -ING, -S]\n",
  "CLOAKED": "CLOAK, to clothe with a cloak, to conceal, also CLOKE [v]\n",
  "CLOAKING": "CLOAK, to clothe with a cloak, to conceal, also CLOKE [v]\n",
  "CLOAKROOM": "a room in which coats etc. are stored [n -S]\n",
  "CLOAKROOMS": "CLOAKROOM, a room in which coats etc. are stored [n]\n",
  "CLOAKS": "CLOAK, to clothe with a cloak, to conceal, also CLOKE [v]\n",
  "CLOAM": "earthenware or clay [n -S]\n",
  "CLOAMS": "CLOAM, earthenware or clay [n]\n",
  "CLOBBER": "to strike very hard [v -ED, -ING, -S]\n",
  "CLOBBERED": "CLOBBER, to strike very hard [v]\n",
  "CLOBBERING": "CLOBBER, to strike very hard [v]\n",
  "CLOBBERS": "CLOBBER, to strike very hard [v]\n",
  "CLOCHARD": "(French) a beggar; a vagrant [n -S]\n",
  "CLOCHARDS": "CLOCHARD, (French) a beggar; a vagrant [n]\n",
  "CLOCHE": "(French) a lady's close-fitting bell-shaped hat [n -S]\n",
  "CLOCHES": "CLOCHE, (French) a lady's close-fitting bell-shaped hat [n]\n",
  "CLOCK": "to time with a stopwatch [v -ED, -ING, -S]\n",
  "CLOCKED": "CLOCK, to time with a stopwatch [v]\n",
  "CLOCKER": "a 24-hour dealer in drugs [n -S]\n",
  "CLOCKERS": "CLOCKER, a 24-hour dealer in drugs [n]\n",
  "CLOCKFACE": "the face of a clock [n -S]\n",
  "CLOCKFACES": "CLOCKFACE, the face of a clock [n]\n",
  "CLOCKING": "the illegal practice of turning back the mileometer of (a car, etc.), so that it registers a lower figure than the actual mileage [n -S]\n",
  "CLOCKINGS": "CLOCKING, the illegal practice of turning back the mileometer of (a car, etc.), so that it registers a lower figure than the actual mileage [n]\n",
  "CLOCKLIKE": "like a clock or like clockwork; mechanical [adj]\n",
  "CLOCKMAKER": "one who makes clocks [n -S]\n",
  "CLOCKMAKERS": "CLOCKMAKER, one who makes clocks [n]\n",
  "CLOCKS": "CLOCK, to time with a stopwatch [v]\n",
  "CLOCKWISE": "moving in the direction of a clock's hands [adv]\n",
  "CLOCKWORK": "the works or machinery of a clock [n -S]\n",
  "CLOCKWORKS": "CLOCKWORK, the works or machinery of a clock [n]\n",
  "CLOD": "to pelt with clods [v CLODDED, CLODDING, CLODS]\n",
  "CLODDED": "CLOD, to pelt with clods [v]\n",
  "CLODDIER": "CLODDY, earthy [adj]\n",
  "CLODDIEST": "CLODDY, earthy [adj]\n",
  "CLODDING": "CLOD, to pelt with clods [v]\n",
  "CLODDISH": "like a clod, gross [adj CLODDISHLY]\n",
  "CLODDISHLY": "CLODDISH, like a clod, gross [adv]\n",
  "CLODDISHNESS": "the state of being cloddish [n -ES]\n",
  "CLODDISHNESSES": "CLODDISHNESS, the state of being cloddish [n]\n",
  "CLODDY": "earthy [adj CLODDIER, CLODDIEST]\n",
  "CLODHOPPER": "a clumsy, awkward fellow; a strong, heavy work shoe [n -S]\n",
  "CLODHOPPERS": "CLODHOPPER, a clumsy, awkward fellow; a strong, heavy work shoe [n]\n",
  "CLODHOPPING": "clumsy of gait [adj]\n",
  "CLODLY": "in a stupid fashion [adv]\n",
  "CLODPATE": "a stupid person, also CLODPOLE, CLODPOLL, CLOTPOLL [n -S]\n",
  "CLODPATED": "stupid, doltish [adj]\n",
  "CLODPATES": "CLODPATE, a stupid person, also CLODPOLE, CLODPOLL, CLOTPOLL [n]\n",
  "CLODPOLE": "a stupid person, also CLODPATE, CLODPOLL, CLOTPOLL [n -S]\n",
  "CLODPOLES": "CLODPOLE, a stupid person, also CLODPATE, CLODPOLL, CLOTPOLL [n]\n",
  "CLODPOLL": "a stupid person, also CLODPATE, CLODPOLE, CLOTPOLL [n -S]\n",
  "CLODPOLLS": "CLODPOLL, a stupid person, also CLODPATE, CLODPOLE, CLOTPOLL [n]\n",
  "CLODS": "CLOD, to pelt with clods [v]\n",
  "CLOFF": "(Scots) a cleft [n -S]\n",
  "CLOFFS": "CLOFF, (Scots) a cleft [n]\n",
  "CLOFIBRATE": "a lipid-lowering drug that is used to reduce high levels of fat and cholesterol [n -S]\n",
  "CLOFIBRATES": "CLOFIBRATE, a lipid-lowering drug that is used to reduce high levels of fat and cholesterol [n]\n",
  "CLOG": "to block up [v CLOGGED, CLOGGING, CLOGS]\n",
  "CLOGDANCE": "a dance performed with clogs, the clatter keeping time to the music [n -S]\n",
  "CLOGDANCES": "CLOGDANCE, a dance performed with clogs, the clatter keeping time to the music [n]\n",
  "CLOGGED": "CLOG, to block up [v]\n",
  "CLOGGER": "a maker of clogs [n -S]\n",
  "CLOGGERS": "CLOGGER, a maker of clogs [n]\n",
  "CLOGGIER": "CLOGGY, lumpy, sticky [adj]\n",
  "CLOGGIEST": "CLOGGY, lumpy, sticky [adj]\n",
  "CLOGGILY": "CLOGGY, lumpy, sticky [adv]\n",
  "CLOGGINESS": "the state of being clogged [n -ES]\n",
  "CLOGGINESSES": "CLOGGINESS, the state of being clogged [n]\n",
  "CLOGGING": "the act of clogging [n -S]\n",
  "CLOGGINGS": "CLOGGING, the act of clogging [n]\n",
  "CLOGGY": "lumpy, sticky [adj CLOGGIER, CLOGGIEST, CLOGGILY]\n",
  "CLOGMAKER": "a maker of clogs [n -S]\n",
  "CLOGMAKERS": "CLOGMAKER, a maker of clogs [n]\n",
  "CLOGS": "CLOG, to block up [v]\n",
  "CLOISON": "(French) a partition; a dividing band [n -S]\n",
  "CLOISONNAGE": "cloisonne work or process [n -S]\n",
  "CLOISONNAGES": "CLOISONNAGE, cloisonne work or process [n]\n",
  "CLOISONNE": "(French) decorative work formed of enamel inlaid in compartments formed by small fillets of metal [n -S]\n",
  "CLOISONNES": "CLOISONNE, (French) decorative work formed of enamel inlaid in compartments formed by small fillets of metal [n]\n",
  "CLOISONS": "CLOISON, (French) a partition; a dividing band [n]\n",
  "CLOISTER": "to seclude [v -ED, -ING, -S]\n",
  "CLOISTERED": "CLOISTER, to seclude [v]\n",
  "CLOISTERER": "one belonging to, or living in, a cloister [n -S]\n",
  "CLOISTERERS": "CLOISTERER, one belonging to, or living in, a cloister [n]\n",
  "CLOISTERING": "CLOISTER, to seclude [v]\n",
  "CLOISTERS": "CLOISTER, to seclude [v]\n",
  "CLOISTRAL": "of, like, or characteristic of a cloister, also CLAUSTRAL [adj]\n",
  "CLOISTRESS": "(Shakespeare) a nun [n -ES]\n",
  "CLOISTRESSES": "CLOISTRESS, (Shakespeare) a nun [n]\n",
  "CLOKE": "to clothe with a cloak, conceal [v CLOKED, CLOKING, CLOKES]\n",
  "CLOKED": "CLOKE, to clothe with a cloak, conceal [v]\n",
  "CLOKES": "CLOKE, to clothe with a cloak, conceal [v]\n",
  "CLOKING": "CLOKE, to clothe with a cloak, conceal [v]\n",
  "CLOMB": "CLIMB, to ascend [v]\n",
  "CLOMIPHENE": "a synthetic drug used to stimulate ovulation [n -S]\n",
  "CLOMIPHENES": "CLOMIPHENE, a synthetic drug used to stimulate ovulation [n]\n",
  "CLOMP": "to walk heavily [v -ED, -ING, -S]\n",
  "CLOMPED": "CLOMP, to walk heavily [v]\n",
  "CLOMPING": "CLOMP, to walk heavily [v]\n",
  "CLOMPS": "CLOMP, to walk heavily [v]\n",
  "CLON": "a group of asexually derived organisms [n -S]\n",
  "CLONAL": "relating to a clone [adj CLONALLY]\n",
  "CLONALLY": "CLONAL, relating to a clone [adv]\n",
  "CLONAZEPAM": "a sedative drug used in the treatment of epilepsy [n -S]\n",
  "CLONAZEPAMS": "CLONAZEPAM, a sedative drug used in the treatment of epilepsy [n]\n",
  "CLONE": "to reproduce by asexual means [v CLONED, CLONING, CLONES]\n",
  "CLONED": "CLONE, to reproduce by asexual means [v]\n",
  "CLONER": "one who clones [n -S]\n",
  "CLONERS": "CLONER, one who clones [n]\n",
  "CLONES": "CLONE, to reproduce by asexual means [v]\n",
  "CLONIC": "of or like a clonus, a type of muscle spasm [adj]\n",
  "CLONICITIES": "CLONICITY, the state of being clonic, spasmodic [n]\n",
  "CLONICITY": "the state of being clonic, spasmodic [n CLONICITIES]\n",
  "CLONIDINE": "an antihypertensive drug [n -S]\n",
  "CLONIDINES": "CLONIDINE, an antihypertensive drug [n]\n",
  "CLONING": "reproduction by asexual means [n -S]\n",
  "CLONINGS": "CLONING, reproduction by asexual means [n]\n",
  "CLONISM": "the condition of having clonus [n -S]\n",
  "CLONISMS": "CLONISM, the condition of having clonus [n]\n",
  "CLONK": "to make a dull thumping sound [v -ED, -ING, -S]\n",
  "CLONKED": "CLONK, to make a dull thumping sound [v]\n",
  "CLONKIER": "CLONKY, making a dull thumping sound [adj]\n",
  "CLONKIEST": "CLONKY, making a dull thumping sound [adj]\n",
  "CLONKING": "CLONK, to make a dull thumping sound [v]\n",
  "CLONKS": "CLONK, to make a dull thumping sound [v]\n",
  "CLONKY": "making a dull thumping sound [adj CLONKIER, CLONKIEST]\n",
  "CLONS": "CLON, a group of asexually derived organisms [n]\n",
  "CLONUS": "(Greek) a form of muscular spasm [n -ES]\n",
  "CLONUSES": "CLONUS, (Greek) a form of muscular spasm [n]\n",
  "CLOOP": "the sound of a cork leaving a bottle [n -S]\n",
  "CLOOPS": "CLOOP, the sound of a cork leaving a bottle [n]\n",
  "CLOOT": "(Scots) a cloven hoof [n -S]\n",
  "CLOOTIE": "as in clootie dumpling, a suet pudding, containing currants, raisins, etc., steamed or boiled in a cloth [adj]\n",
  "CLOOTS": "CLOOT, (Scots) a cloven hoof [n]\n",
  "CLOP": "to make the sound of a striking hoof [v CLOPPED, CLOPPING, CLOPS]\n",
  "CLOPPED": "CLOP, to make the sound of a striking hoof [v]\n",
  "CLOPPING": "CLOP, to make the sound of a striking hoof [v]\n",
  "CLOPS": "CLOP, to make the sound of a striking hoof [v]\n",
  "CLOQUE": "(French) a fabric with an embossed design [n -S]\n",
  "CLOQUES": "CLOQUE, (French) a fabric with an embossed design [n]\n",
  "CLOSABLE": "able to be closed, also CLOSEABLE [adj]\n",
  "CLOSE": "to make impassable [v CLOSED, CLOSING, CLOSES] / near [adj CLOSER, CLOSEST, CLOSELY]\n",
  "CLOSEABLE": "that can be closed, also CLOSABLE [adj]\n",
  "CLOSED": "CLOSE, to make impassable [v]\n",
  "CLOSEDOWN": "an instance of suspending or stopping operations [n -S]\n",
  "CLOSEDOWNS": "CLOSEDOWN, an instance of suspending or stopping operations [n]\n",
  "CLOSEFISTED": "tight, stingy [adj]\n",
  "CLOSEHEAD": "(Scots) the entrance to a close, or the gossips that congregate there [n -S]\n",
  "CLOSEHEADS": "CLOSEHEAD, (Scots) the entrance to a close, or the gossips that congregate there [n]\n",
  "CLOSELY": "CLOSE, near [adv]\n",
  "CLOSEMOUTHED": "cautious in speaking [adj]\n",
  "CLOSENESS": "the state of being close [n -ES]\n",
  "CLOSENESSES": "CLOSENESS, the state of being close [n]\n",
  "CLOSEOUT": "a clearance sale [n -S]\n",
  "CLOSEOUTS": "CLOSEOUT, a clearance sale [n]\n",
  "CLOSER": "one who, or that which, closes [n -S]\n",
  "CLOSERS": "CLOSER, one who, or that which, closes [n]\n",
  "CLOSES": "CLOSE, to make impassable [v]\n",
  "CLOSEST": "CLOSE, near [adj]\n",
  "CLOSESTOOL": "a stool holding a chamberpot [n -S]\n",
  "CLOSESTOOLS": "CLOSESTOOL, a stool holding a chamberpot [n]\n",
  "CLOSET": "to enclose in a closet [v -ED, -ING, -S]\n",
  "CLOSETED": "CLOSET, to enclose in a closet [v]\n",
  "CLOSETFUL": "the contents of a closet [n -S]\n",
  "CLOSETFULS": "CLOSETFUL, the contents of a closet [n]\n",
  "CLOSETING": "CLOSET, to enclose in a closet [v]\n",
  "CLOSETS": "CLOSET, to enclose in a closet [v]\n",
  "CLOSEUP": "a photograph taken at close range [n -S]\n",
  "CLOSEUPS": "CLOSEUP, a photograph taken at close range [n]\n",
  "CLOSING": "a concluding part [n -S]\n",
  "CLOSINGS": "CLOSING, a concluding part [n]\n",
  "CLOSTRIDIA": "CLOSTRIDIUM, any of a genus of spore-forming mostly anaerobic soil or intestinal bacteria [n]\n",
  "CLOSTRIDIAL": "relating to clostridia, also CLOSTRIDIAN [adj]\n",
  "CLOSTRIDIAN": "relating to clostridia, also CLOSTRIDIAL [adj]\n",
  "CLOSTRIDIUM": "any of a genus of spore-forming mostly anaerobic soil or intestinal bacteria [n CLOSTRIDIA or CLOSTRIDIUMS]\n",
  "CLOSTRIDIUMS": "CLOSTRIDIUM, any of a genus of spore-forming mostly anaerobic soil or intestinal bacteria [n]\n",
  "CLOSURE": "to end a debate by calling for a vote, also CLOTURE [v CLOSURED, CLOSURING, CLOSURES]\n",
  "CLOSURED": "CLOSURE, to end a debate by calling for a vote, also CLOTURE [v]\n",
  "CLOSURES": "CLOSURE, to end a debate by calling for a vote, also CLOTURE [v]\n",
  "CLOSURING": "CLOSURE, to end a debate by calling for a vote, also CLOTURE [v]\n",
  "CLOT": "to form into a thick mass [v CLOTTED, CLOTTING, CLOTS]\n",
  "CLOTBUR": "the burdock, also COCKLEBUR [n -S]\n",
  "CLOTBURS": "CLOTBUR, the burdock, also COCKLEBUR [n]\n",
  "CLOTE": "the common burdock, aka clotbur [n -S]\n",
  "CLOTES": "CLOTE, the common burdock, aka clotbur [n]\n",
  "CLOTH": "fabric [n -S]\n",
  "CLOTHBOUND": "bound with cloth e.g. of a book [adj]\n",
  "CLOTHE": "to provide with clothing [v CLOTHED, YCLAD or YCLED, CLOTHING, CLOTHES]\n",
  "CLOTHED": "CLOTHE, to provide with clothing [v]\n",
  "CLOTHES": "CLOTHE, to provide with clothing [v]\n",
  "CLOTHESHORSE": "a frame on which to hang clothes [n -S]\n",
  "CLOTHESHORSES": "CLOTHESHORSE, a frame on which to hang clothes [n]\n",
  "CLOTHESLINE": "to knock (a person) down with a blow to the neck (or sometimes head), esp. by placing an outstretched arm in his or her path [v CLOTHESLINED, CLOTHESLINING, CLOTHESLINES]\n",
  "CLOTHESLINED": "CLOTHESLINE, to knock (a person) down with a blow to the neck (or sometimes head), esp. by placing an outstretched arm in his or her path [v]\n",
  "CLOTHESLINES": "CLOTHESLINE, to knock (a person) down with a blow to the neck (or sometimes head), esp. by placing an outstretched arm in his or her path [v]\n",
  "CLOTHESLINING": "CLOTHESLINE, to knock (a person) down with a blow to the neck (or sometimes head), esp. by placing an outstretched arm in his or her path [v]\n",
  "CLOTHESPIN": "a forked piece of wood, or a small spring clamp, used for fastening clothes on a line [n -S]\n",
  "CLOTHESPINS": "CLOTHESPIN, a forked piece of wood, or a small spring clamp, used for fastening clothes on a line [n]\n",
  "CLOTHESPRESS": "a receptacle for clothes [n -ES]\n",
  "CLOTHESPRESSES": "CLOTHESPRESS, a receptacle for clothes [n]\n",
  "CLOTHIER": "one who deals in clothing [n -S]\n",
  "CLOTHIERS": "CLOTHIER, one who deals in clothing [n]\n",
  "CLOTHING": "clothes, garments [n -S]\n",
  "CLOTHINGS": "CLOTHING, clothes, garments [n]\n",
  "CLOTHLIKE": "like a cloth [adj]\n",
  "CLOTHS": "CLOTH, fabric [n]\n",
  "CLOTPOLL": "(Shakespeare) a fool, also CLODPOLE, CLODPOLL [n -S]\n",
  "CLOTPOLLS": "CLOTPOLL, (Shakespeare) a fool, also CLODPOLE, CLODPOLL [n]\n",
  "CLOTS": "CLOT, to form into a thick mass [v]\n",
  "CLOTTED": "CLOT, to form into a thick mass [v]\n",
  "CLOTTER": "to coagulate [v -ED, -ING, -S]\n",
  "CLOTTERED": "CLOTTER, to coagulate [v]\n",
  "CLOTTERING": "CLOTTER, to coagulate [v]\n",
  "CLOTTERS": "CLOTTER, to coagulate [v]\n",
  "CLOTTIER": "CLOTTY, tending to clot [adj]\n",
  "CLOTTIEST": "CLOTTY, tending to clot [adj]\n",
  "CLOTTINESS": "the state of being clotty [n -ES]\n",
  "CLOTTINESSES": "CLOTTINESS, the state of being clotty [n]\n",
  "CLOTTING": "the act of coagulating [n -S]\n",
  "CLOTTINGS": "CLOTTING, the act of coagulating [n]\n",
  "CLOTTISH": "having clots [adj]\n",
  "CLOTTY": "tending to clot [adj CLOTTIER, CLOTTIEST]\n",
  "CLOTURE": "(French) to end a debate by calling for a vote, also CLOSURE [v CLOTURED, CLOTURING, CLOTURES]\n",
  "CLOTURED": "CLOTURE, (French) to end a debate by calling for a vote, also CLOSURE [v]\n",
  "CLOTURES": "CLOTURE, (French) to end a debate by calling for a vote, also CLOSURE [v]\n",
  "CLOTURING": "CLOTURE, (French) to end a debate by calling for a vote, also CLOSURE [v]\n",
  "CLOU": "(French) the main point of interest; a dominant idea [n -S]\n",
  "CLOUD": "to make obscure [v -ED, -ING, -S]\n",
  "CLOUDAGE": "the amount of clouds [n -S]\n",
  "CLOUDAGES": "CLOUDAGE, the amount of clouds [n]\n",
  "CLOUDBERRIES": "CLOUDBERRY, a low plant of North America and North Europe, related to the bramble, with an orange-red sweet-flavoured berry known as bakeapple [n]\n",
  "CLOUDBERRY": "a low plant of North America and North Europe, related to the bramble, with an orange-red sweet-flavoured berry known as bakeapple [n CLOUDBERRIES]\n",
  "CLOUDBURST": "a heavy downpour of rain [n -S]\n",
  "CLOUDBURSTS": "CLOUDBURST, a heavy downpour of rain [n]\n",
  "CLOUDED": "CLOUD, to make obscure [v]\n",
  "CLOUDIER": "CLOUDY, overcast with clouds [adj]\n",
  "CLOUDIEST": "CLOUDY, overcast with clouds [adj]\n",
  "CLOUDILY": "CLOUDY, overcast with clouds [adv]\n",
  "CLOUDINESS": "the state of being cloudy [n -ES]\n",
  "CLOUDINESSES": "CLOUDINESS, the state of being cloudy [n]\n",
  "CLOUDING": "clouds collectively [n -S]\n",
  "CLOUDINGS": "CLOUDING, clouds collectively [n]\n",
  "CLOUDLAND": "an imaginary situation or land, esp. as the result of wishful thinking, also CLOUDTOWN [n -S]\n",
  "CLOUDLANDS": "CLOUDLAND, an imaginary situation or land, esp. as the result of wishful thinking, also CLOUDTOWN [n]\n",
  "CLOUDLESS": "without cloud [adj CLOUDLESSLY]\n",
  "CLOUDLESSLY": "CLOUDLESS, without cloud [adv]\n",
  "CLOUDLESSNESS": "CLOUDLESS, without cloud [n]\n",
  "CLOUDLESSNESSES": "CLOUDLESSNESS, CLOUDLESS, without cloud [n]\n",
  "CLOUDLET": "a small cloud [n -S]\n",
  "CLOUDLETS": "CLOUDLET, a small cloud [n]\n",
  "CLOUDLIKE": "like a cloud [adj]\n",
  "CLOUDS": "CLOUD, to make obscure [v]\n",
  "CLOUDSCAPE": "a view or pictorial representation of a cloud formation [n -S]\n",
  "CLOUDSCAPES": "CLOUDSCAPE, a view or pictorial representation of a cloud formation [n]\n",
  "CLOUDTOWN": "an imaginary situation or land, esp. as the result of wishful thinking, also CLOUDLAND [n -S]\n",
  "CLOUDTOWNS": "CLOUDTOWN, an imaginary situation or land, esp. as the result of wishful thinking, also CLOUDLAND [n]\n",
  "CLOUDY": "overcast with clouds [adj CLOUDIER, CLOUDIEST, CLOUDILY]\n",
  "CLOUGH": "a ravine, also CLEUCH, CLEUGH [n -S]\n",
  "CLOUGHS": "CLOUGH, a ravine, also CLEUCH, CLEUGH [n]\n",
  "CLOUR": "(Scots) to knock or bump [v -ED, -ING, -S]\n",
  "CLOURED": "CLOUR, (Scots) to knock or bump [v]\n",
  "CLOURING": "CLOUR, (Scots) to knock or bump [v]\n",
  "CLOURS": "CLOUR, (Scots) to knock or bump [v]\n",
  "CLOUS": "CLOU, (French) the main point of interest; a dominant idea [n]\n",
  "CLOUT": "to hit with the hand [v -ED, -ING, -S]\n",
  "CLOUTED": "CLOUT, to hit with the hand [v]\n",
  "CLOUTER": "one who clouts, mends and botches [n -S]\n",
  "CLOUTERLY": "like a clouter, clownish [adj]\n",
  "CLOUTERS": "CLOUTER, one who clouts, mends and botches [n]\n",
  "CLOUTING": "CLOUT, to hit with the hand [v]\n",
  "CLOUTS": "CLOUT, to hit with the hand [v]\n",
  "CLOVE": "the flower-bud of the clove-tree, dried as a spice, also CLOW [n -S]\n",
  "CLOVEN": "split [adj]\n",
  "CLOVER": "any papilionaceous plant of the genus Trifolium [n -S]\n",
  "CLOVERED": "covered with clover [adj]\n",
  "CLOVERGRASS": "clover as pasturage [n -ES]\n",
  "CLOVERGRASSES": "CLOVERGRASS, clover as pasturage [n]\n",
  "CLOVERIER": "CLOVERY, like clover [adj]\n",
  "CLOVERIEST": "CLOVERY, like clover [adj]\n",
  "CLOVERLEAF": "the pattern made by a leaf of clover [n CLOVERLEAFS or CLOVERLEAVES]\n",
  "CLOVERLEAFS": "CLOVERLEAF, the pattern made by a leaf of clover [n]\n",
  "CLOVERLEAVES": "CLOVERLEAF, the pattern made by a leaf of clover [n]\n",
  "CLOVERLIKE": "like clover [adj]\n",
  "CLOVERS": "CLOVER, any papilionaceous plant of the genus Trifolium [n]\n",
  "CLOVERY": "like clover [adj CLOVERIER, CLOVERIEST]\n",
  "CLOVES": "CLOVE, the flower-bud of the clove-tree, dried as a spice, also CLOW [n]\n",
  "CLOVIS": "as in clovis point, a stone age fluted point on stone tools [adj]\n",
  "CLOW": "(Scots) to rake dung [v -ED, -ING, -S]\n",
  "CLOWDER": "a collective name for a number of cats [n -S]\n",
  "CLOWDERS": "CLOWDER, a collective name for a number of cats [n]\n",
  "CLOWED": "CLOW, (Scots) to rake dung [v]\n",
  "CLOWING": "CLOW, (Scots) to rake dung [v]\n",
  "CLOWN": "to act like a comic entertainer [v -ED, -ING, -S]\n",
  "CLOWNED": "CLOWN, to act like a comic entertainer [v]\n",
  "CLOWNERIES": "CLOWNERY, clownish behaviour [n]\n",
  "CLOWNERY": "clownish behaviour [n CLOWNERIES]\n",
  "CLOWNFISH": "any of various brightly coloured fish whose markings resemble a clown's makeup [n -ES]\n",
  "CLOWNFISHES": "CLOWNFISH, any of various brightly coloured fish whose markings resemble a clown's makeup [n]\n",
  "CLOWNING": "acting the clown [n -S]\n",
  "CLOWNINGS": "CLOWNING, acting the clown [n]\n",
  "CLOWNISH": "resembling a clown [adj CLOWNISHLY]\n",
  "CLOWNISHLY": "CLOWNISH, resembling a clown [adv]\n",
  "CLOWNISHNESS": "the state of being clownish [n -ES]\n",
  "CLOWNISHNESSES": "CLOWNISHNESS, the state of being clownish [n]\n",
  "CLOWNS": "CLOWN, to act like a comic entertainer [v]\n",
  "CLOWS": "CLOW, (Scots) to rake dung [v]\n",
  "CLOXACILLIN": "a penicillin-type antibiotic used to treat infections by staphylococcal bacteria [n -S]\n",
  "CLOXACILLINS": "CLOXACILLIN, a penicillin-type antibiotic used to treat infections by staphylococcal bacteria [n]\n",
  "CLOY": "to gratify beyond desire [v -ED, -ING, -S]\n",
  "CLOYE": "(Shakespeare) to claw [v CLOYED, CLOYING, CLOYES]\n",
  "CLOYED": "CLOY, to gratify beyond desire [v]\n",
  "CLOYES": "CLOYE, (Shakespeare) to claw [v]\n",
  "CLOYING": "CLOY, to gratify beyond desire [v]\n",
  "CLOYINGLY": "CLOYING, CLOY, to gratify beyond desire [adv]\n",
  "CLOYLESS": "(Shakespeare) that cannot cloy [adj]\n",
  "CLOYMENT": "surfeit [n -S]\n",
  "CLOYMENTS": "CLOYMENT, surfeit [n]\n",
  "CLOYS": "CLOY, to gratify beyond desire [v]\n",
  "CLOYSOME": "satiating [adj]\n",
  "CLOZAPINE": "a neuroleptic drug used as a sedative and to treat schizophrenia [n -S]\n",
  "CLOZAPINES": "CLOZAPINE, a neuroleptic drug used as a sedative and to treat schizophrenia [n]\n",
  "CLOZE": "a type of educational exercise in which a reader is required to supply words that have been deleted from a text [n -S]\n",
  "CLOZES": "CLOZE, a type of educational exercise in which a reader is required to supply words that have been deleted from a text [n]\n",
  "CLUB": "to form an organised group of people [v CLUBBED, CLUBBING, CLUBS]\n",
  "CLUBABILITIES": "CLUBABILITY, sociability, also CLUBBABILITY [n]\n",
  "CLUBABILITY": "sociability, also CLUBBABILITY [n CLUBABILITIES]\n",
  "CLUBABLE": "sociable [adj]\n",
  "CLUBBABILITIES": "CLUBBABILITY, sociability, also CLUBABILITY [n]\n",
  "CLUBBABILITY": "sociability, also CLUBABILITY [n CLUBBABILITIES]\n",
  "CLUBBABLE": "sociable, also CLUBABLE [adj]\n",
  "CLUBBED": "CLUB, to form an organised group of people [v]\n",
  "CLUBBER": "a person who frequents nightclubs [n -S]\n",
  "CLUBBERS": "CLUBBER, a person who frequents nightclubs [n]\n",
  "CLUBBIER": "CLUBBY, characteristic of a club [adj]\n",
  "CLUBBIEST": "CLUBBY, characteristic of a club [adj]\n",
  "CLUBBILY": "CLUBBY, characteristic of a club [adv]\n",
  "CLUBBINESS": "the state of being clubby, sociable [n -ES]\n",
  "CLUBBINESSES": "CLUBBINESS, the state of being clubby, sociable [n]\n",
  "CLUBBING": "visiting nightclubs [n -S]\n",
  "CLUBBINGS": "CLUBBING, visiting nightclubs [n]\n",
  "CLUBBISH": "given to clubs [adj]\n",
  "CLUBBISM": "the club system [n -S]\n",
  "CLUBBISMS": "CLUBBISM, the club system [n]\n",
  "CLUBBIST": "a member of a club [n -S]\n",
  "CLUBBISTS": "CLUBBIST, a member of a club [n]\n",
  "CLUBBY": "characteristic of a club [adj CLUBBIER, CLUBBIEST, CLUBBILY]\n",
  "CLUBFACE": "the striking surface of a clubhead [n -S]\n",
  "CLUBFACES": "CLUBFACE, the striking surface of a clubhead [n]\n",
  "CLUBFEET": "CLUBFOOT, a deformed foot [n]\n",
  "CLUBFOOT": "a deformed foot [n CLUBFEET]\n",
  "CLUBFOOTED": "having a clubfoot [adj]\n",
  "CLUBHAND": "a deformed hand [n -S]\n",
  "CLUBHANDS": "CLUBHAND, a deformed hand [n]\n",
  "CLUBHAUL": "to force a sailing vessel onto a new tack [v -ED, -ING, -S]\n",
  "CLUBHAULED": "CLUBHAUL, to force a sailing vessel onto a new tack [v]\n",
  "CLUBHAULING": "CLUBHAUL, to force a sailing vessel onto a new tack [v]\n",
  "CLUBHAULS": "CLUBHAUL, to force a sailing vessel onto a new tack [v]\n",
  "CLUBHEAD": "the part of a golf club that strikes the ball [n -S]\n",
  "CLUBHEADS": "CLUBHEAD, the part of a golf club that strikes the ball [n]\n",
  "CLUBHOUSE": "the premises of a sports or other club, esp. a golf club [n -S]\n",
  "CLUBHOUSES": "CLUBHOUSE, the premises of a sports or other club, esp. a golf club [n]\n",
  "CLUBLAND": "an area containing many nightclubs [n -S]\n",
  "CLUBLANDS": "CLUBLAND, an area containing many nightclubs [n]\n",
  "CLUBLIKE": "like a club [adj]\n",
  "CLUBMAN": "a member of a club [n CLUBMEN]\n",
  "CLUBMANSHIP": "the state of being a clubman [n -S]\n",
  "CLUBMANSHIPS": "CLUBMANSHIP, the state of being a clubman [n]\n",
  "CLUBMASTER": "the manager of a club [n -S]\n",
  "CLUBMASTERS": "CLUBMASTER, the manager of a club [n]\n",
  "CLUBMATE": "a fellow member of a club [n -S]\n",
  "CLUBMATES": "CLUBMATE, a fellow member of a club [n]\n",
  "CLUBMEN": "CLUBMAN, a member of a club [n]\n",
  "CLUBMOSS": "a green plant resembling a large moss [n -ES]\n",
  "CLUBMOSSES": "CLUBMOSS, a green plant resembling a large moss [n]\n",
  "CLUBROOM": "a room in a club [n -S]\n",
  "CLUBROOMS": "CLUBROOM, a room in a club [n]\n",
  "CLUBROOT": "a plant disease [n -S]\n",
  "CLUBROOTS": "CLUBROOT, a plant disease [n]\n",
  "CLUBRUSH": "any sedge of the genus Scirpus [n -ES]\n",
  "CLUBRUSHES": "CLUBRUSH, any sedge of the genus Scirpus [n]\n",
  "CLUBS": "CLUB, to form an organised group of people [v]\n",
  "CLUBWOMAN": "a female member of a club [n CLUBWOMEN]\n",
  "CLUBWOMEN": "CLUBWOMAN, a female member of a club [n]\n",
  "CLUCK": "to make the sound of a hen [v -ED, -ING, -S]\n",
  "CLUCKED": "CLUCK, to make the sound of a hen [v]\n",
  "CLUCKER": "a chicken [n CLUCKERS]\n",
  "CLUCKERS": "CLUCKER, a chicken [n]\n",
  "CLUCKIER": "CLUCKY, (Australian slang) obsessed with babies, broody [adj]\n",
  "CLUCKIEST": "CLUCKY, (Australian slang) obsessed with babies, broody [adj]\n",
  "CLUCKING": "CLUCK, to make the sound of a hen [v]\n",
  "CLUCKS": "CLUCK, to make the sound of a hen [v]\n",
  "CLUCKY": "(Australian slang) obsessed with babies, broody [adj CLUCKIER, CLUCKIEST]\n",
  "CLUDGIE": "(Scots) a lavatory [n -S]\n",
  "CLUDGIES": "CLUDGIE, (Scots) a lavatory [n]\n",
  "CLUE": "to obtain guiding information [v CLUED, CLUEING or CLUING, CLUES]\n",
  "CLUED": "CLUE, to obtain guiding information [v]\n",
  "CLUEING": "CLUE, to obtain guiding information [v]\n",
  "CLUELESS": "hopelessly confused or ignorant [adj]\n",
  "CLUES": "CLUE, to obtain guiding information [v]\n",
  "CLUEY": "(Australian slang) well-informed and adroit [adj CLUIER, CLUIEST]\n",
  "CLUIER": "CLUEY, (Australian slang) well-informed and adroit [adj]\n",
  "CLUIEST": "CLUEY, (Australian slang) well-informed and adroit [adj]\n",
  "CLUING": "CLUE, to obtain guiding information [v]\n",
  "CLUMBER": "a stocky spaniel [n -S]\n",
  "CLUMBERS": "CLUMBER, a stocky spaniel [n]\n",
  "CLUMP": "to form into a thick mass [v -ED, -ING, -S]\n",
  "CLUMPED": "CLUMP, to form into a thick mass [v]\n",
  "CLUMPER": "to walk heavily [v -ED, -ING, -S]\n",
  "CLUMPERED": "CLUMPER, to walk heavily [v]\n",
  "CLUMPERING": "CLUMPER, to walk heavily [v]\n",
  "CLUMPERS": "CLUMPER, to walk heavily [v]\n",
  "CLUMPET": "a large floating chunk of ice [n -S]\n",
  "CLUMPETS": "CLUMPET, a large floating chunk of ice [n]\n",
  "CLUMPIER": "CLUMPY, in clumps [adj]\n",
  "CLUMPIEST": "CLUMPY, in clumps [adj]\n",
  "CLUMPINESS": "the state of being clumpy [n -ES]\n",
  "CLUMPINESSES": "CLUMPINESS, the state of being clumpy [n]\n",
  "CLUMPING": "CLUMP, to form into a thick mass [v]\n",
  "CLUMPISH": "resembling a thick mass [adj]\n",
  "CLUMPLIKE": "like a clump [adj]\n",
  "CLUMPS": "CLUMP, to form into a thick mass [v]\n",
  "CLUMPY": "in clumps [adj CLUMPIER, CLUMPIEST]\n",
  "CLUMSIER": "CLUMSY, not dexterous [adj]\n",
  "CLUMSIEST": "CLUMSY, not dexterous [adj]\n",
  "CLUMSILY": "CLUMSY, not dexterous [adv]\n",
  "CLUMSINESS": "the quality of being clumsy [n -ES]\n",
  "CLUMSINESSES": "CLUMSINESS, the quality of being clumsy [n]\n",
  "CLUMSY": "not dexterous [adj CLUMSIER, CLUMSIEST, CLUMSILY]\n",
  "CLUNCH": "a tough clay [n -ES]\n",
  "CLUNCHES": "CLUNCH, a tough clay [n]\n",
  "CLUNG": "CLING, to adhere to [v]\n",
  "CLUNK": "to make a dull metallic noise [v -ED, -ING, -S]\n",
  "CLUNKED": "CLUNK, to make a dull metallic noise [v]\n",
  "CLUNKER": "a dilapidated old car [n -S]\n",
  "CLUNKERS": "CLUNKER, a dilapidated old car [n]\n",
  "CLUNKIER": "CLUNKY, clumsy in style [adj]\n",
  "CLUNKIEST": "CLUNKY, clumsy in style [adj]\n",
  "CLUNKING": "CLUNK, to make a dull metallic noise [v]\n",
  "CLUNKS": "CLUNK, to make a dull metallic noise [v]\n",
  "CLUNKY": "clumsy in style [adj CLUNKIER, CLUNKIEST]\n",
  "CLUPEID": "a fish of the herring family, also CLUPEOID [n -S]\n",
  "CLUPEIDS": "CLUPEID, a fish of the herring family, also CLUPEOID [n]\n",
  "CLUPEOID": "a fish of the herring family, also CLUPEID [n -S]\n",
  "CLUPEOIDS": "CLUPEOID, a fish of the herring family, also CLUPEID [n]\n",
  "CLUSIA": "any member of the genus Clusia of evergreen climbing plants [n -S]\n",
  "CLUSIAS": "CLUSIA, any member of the genus Clusia of evergreen climbing plants [n]\n",
  "CLUSTER": "to form into groups [v -ED, -ING, -S]\n",
  "CLUSTERED": "CLUSTER, to form into groups [v]\n",
  "CLUSTERIER": "CLUSTERY, growing in, or full of, clusters [adj]\n",
  "CLUSTERIEST": "CLUSTERY, growing in, or full of, clusters [adj]\n",
  "CLUSTERING": "CLUSTER, to form into groups [v]\n",
  "CLUSTERINGLY": "CLUSTERING, CLUSTER, to form into groups [adv]\n",
  "CLUSTERS": "CLUSTER, to form into groups [v]\n",
  "CLUSTERY": "growing in, or full of, clusters [adj CLUSTERIER, CLUSTERIEST]\n",
  "CLUTCH": "to grasp and hold tightly [v -ED, -ING, -ES]\n",
  "CLUTCHED": "CLUTCH, to grasp and hold tightly [v]\n",
  "CLUTCHES": "CLUTCH, to grasp and hold tightly [v]\n",
  "CLUTCHIER": "CLUTCHY, tending to clutch [adj]\n",
  "CLUTCHIEST": "CLUTCHY, tending to clutch [adj]\n",
  "CLUTCHING": "CLUTCH, to grasp and hold tightly [v]\n",
  "CLUTCHY": "tending to clutch [adj CLUTCHIER, CLUTCHIEST]\n",
  "CLUTTER": "to pile in a disorderly state [v -ED, -ING, -S]\n",
  "CLUTTERED": "CLUTTER, to pile in a disorderly state [v]\n",
  "CLUTTERIER": "CLUTTERY, full of clutter [adj]\n",
  "CLUTTERIEST": "CLUTTERY, full of clutter [adj]\n",
  "CLUTTERING": "CLUTTER, to pile in a disorderly state [v]\n",
  "CLUTTERS": "CLUTTER, to pile in a disorderly state [v]\n",
  "CLUTTERY": "full of clutter [adj CLUTTERIER, CLUTTERIEST]\n",
  "CLY": "to seize or steal [v CLIED, CLYING, CLIES]\n",
  "CLYING": "CLY, to seize or steal [v]\n",
  "CLYPE": "to tell tales, also CLIPE [v CLYPED, CLYPING, CLYPES]\n",
  "CLYPEAL": "relating to the clypeus, the frontal plate of the head of an insect [adj]\n",
  "CLYPEATE": "shaped like a buckler, a round shield, also CLYPEIFORM [adj]\n",
  "CLYPED": "CLYPE, to tell tales, also CLIPE [v]\n",
  "CLYPEI": "CLYPEUS, (Latin) the frontal plate of the head of an insect [n]\n",
  "CLYPEIFORM": "shaped like a buckler, a round shield, also CLYPEATE [adj]\n",
  "CLYPES": "CLYPE, to tell tales, also CLIPE [v]\n",
  "CLYPEUS": "(Latin) the frontal plate of the head of an insect [n CLYPEI]\n",
  "CLYPING": "CLYPE, to tell tales, also CLIPE [v]\n",
  "CLYSTER": "(archaic) an enema [n -S]\n",
  "CLYSTERS": "CLYSTER, (archaic) an enema [n]\n",
  "CNEMIAL": "relating to the shin [adj]\n",
  "CNEMIDES": "CNEMIS, the shin or tibia [n]\n",
  "CNEMIS": "the shin or tibia [n CNEMIDES]\n",
  "CNIDA": "(Greek) a nematocyst, a stinging cell in jellyfish [n CNIDAE]\n",
  "CNIDAE": "CNIDA, (Greek) a nematocyst, a stinging cell in jellyfish [n]\n",
  "CNIDARIAN": "a coelenterate, that includes sea anemones, hydra, jellyfish, and coral [n -S]\n",
  "CNIDARIANS": "CNIDARIAN, a coelenterate, that includes sea anemones, hydra, jellyfish, and coral [n]\n",
  "CNIDOBLAST": "a stinging thread cell containing a nematocyst [n -S]\n",
  "CNIDOBLASTS": "CNIDOBLAST, a stinging thread cell containing a nematocyst [n]\n",
  "COACERVATE": "to heap; to cause to mass together [v COACERVATED, COACERVATING, COACERVATES]\n",
  "COACERVATED": "COACERVATE, to heap; to cause to mass together [v]\n",
  "COACERVATES": "COACERVATE, to heap; to cause to mass together [v]\n",
  "COACERVATING": "COACERVATE, to heap; to cause to mass together [v]\n",
  "COACERVATION": "an aggregation of particles of an emulsoid into liquid droplets before flocculation [n -S]\n",
  "COACERVATIONS": "COACERVATION, an aggregation of particles of an emulsoid into liquid droplets before flocculation [n]\n",
  "COACH": "to tutor or train [v -ED, -ING, -ES]\n",
  "COACHABLE": "that can be coached [adj]\n",
  "COACHBUILDER": "a craftsman who builds the bodies of cars, lorries, railway carriages, etc. [n -S]\n",
  "COACHBUILDERS": "COACHBUILDER, a craftsman who builds the bodies of cars, lorries, railway carriages, etc. [n]\n",
  "COACHBUILDING": "the craft of building coaches [n -S]\n",
  "COACHBUILDINGS": "COACHBUILDING, the craft of building coaches [n]\n",
  "COACHBUILT": "of a vehicle body, built to individula specifications by coachbuilders [adj]\n",
  "COACHDOG": "a spotted dog, formerly kept as an attendant on carriages, a Dalmatian dog [n -S]\n",
  "COACHDOGS": "COACHDOG, a spotted dog, formerly kept as an attendant on carriages, a Dalmatian dog [n]\n",
  "COACHED": "COACH, to tutor or train [v]\n",
  "COACHEE": "(colloquial) a coachman, also COACHY [n -S]\n",
  "COACHEES": "COACHEE, (colloquial) a coachman, also COACHY [n]\n",
  "COACHER": "a person who coaches; a coach-horse [n -S]\n",
  "COACHERS": "COACHER, a person who coaches; a coach-horse [n]\n",
  "COACHES": "COACH, to tutor or train [v]\n",
  "COACHIER": "COACHY, relating to a coach [adj]\n",
  "COACHIES": "COACHY, a coachman [n]\n",
  "COACHIEST": "COACHY, relating to a coach [adj]\n",
  "COACHING": "the act of tutoring [n -S]\n",
  "COACHINGS": "COACHING, the act of tutoring [n]\n",
  "COACHLINE": "a decorative line along the body of a motor vehicle [n -S]\n",
  "COACHLINES": "COACHLINE, a decorative line along the body of a motor vehicle [n]\n",
  "COACHLOAD": "the passengers of a coach taken collectively [n -S]\n",
  "COACHLOADS": "COACHLOAD, the passengers of a coach taken collectively [n]\n",
  "COACHMAN": "one who drives a coach [n COACHMEN]\n",
  "COACHMEN": "COACHMAN, one who drives a coach [n]\n",
  "COACHROOF": "(Canadian) a raised part of the cabin roof of a yacht [n -S]\n",
  "COACHROOFS": "COACHROOF, (Canadian) a raised part of the cabin roof of a yacht [n]\n",
  "COACHWHIP": "a large, slender, harmless snake of the southern United States [n -S]\n",
  "COACHWHIPS": "COACHWHIP, a large, slender, harmless snake of the southern United States [n]\n",
  "COACHWOOD": "an Australian tree yielding a light-grained wood formerly used in coach-making [n -S]\n",
  "COACHWOODS": "COACHWOOD, an Australian tree yielding a light-grained wood formerly used in coach-making [n]\n",
  "COACHWORK": "vehicle bodywork [n -S]\n",
  "COACHWORKS": "COACHWORK, vehicle bodywork [n]\n",
  "COACHY": "a coachman [n COACHIES] / relating to a coach [adj COACHIER, COACHIEST]\n",
  "COACT": "to act together [v -ED, -ING, -S]\n",
  "COACTED": "COACT, to act together [v]\n",
  "COACTING": "COACT, to act together [v]\n",
  "COACTION": "joint action [n -S]\n",
  "COACTIONS": "COACTION, joint action [n]\n",
  "COACTIVE": "mutually active [adj COACTIVELY]\n",
  "COACTIVELY": "COACTIVE, mutually active [adv]\n",
  "COACTIVITIES": "COACTIVITY, unity of action [n]\n",
  "COACTIVITY": "unity of action [n COACTIVITIES]\n",
  "COACTOR": "one who acts together with another [n -S]\n",
  "COACTORS": "COACTOR, one who acts together with another [n]\n",
  "COACTS": "COACT, to act together [v]\n",
  "COADAPTATION": "the state of being mutually adapted [n -S]\n",
  "COADAPTATIONS": "COADAPTATION, the state of being mutually adapted [n]\n",
  "COADAPTED": "mutually adapted [adj]\n",
  "COADIES": "COADY, a sauce made from molasses [n]\n",
  "COADJACENCIES": "COADJACENCY, the state of being coadjacent [n]\n",
  "COADJACENCY": "the state of being coadjacent [n COADJACENCIES]\n",
  "COADJACENT": "something that is adjacent to another thing in experience or thought [n -S]\n",
  "COADJACENTS": "COADJACENT, something that is adjacent to another thing in experience or thought [n]\n",
  "COADJUTANT": "mutually assisting or operating; helping [adj] / one who assists mutually [n -S]\n",
  "COADJUTANTS": "COADJUTANT, one who assists mutually [n]\n",
  "COADJUTOR": "a bishop assisting a diocesan bishop and having the right of succession [n -S]\n",
  "COADJUTORS": "COADJUTOR, a bishop assisting a diocesan bishop and having the right of succession [n]\n",
  "COADJUTORSHIP": "the office of coadjutor [n -S]\n",
  "COADJUTORSHIPS": "COADJUTORSHIP, the office of coadjutor [n]\n",
  "COADJUTRESS": "a female coadjutor, also COADJUTRIX [n -ES]\n",
  "COADJUTRESSES": "COADJUTRESS, a female coadjutor, also COADJUTRIX [n]\n",
  "COADJUTRICES": "COADJUTRIX, a female coadjutor or assistant, also COADJUTRESS [n]\n",
  "COADJUTRIX": "a female coadjutor or assistant, also COADJUTRESS [n COADJUTRIXES]\n",
  "COADJUTRIXES": "COADJUTRIX, a female coadjutor or assistant, also COADJUTRESS [n]\n",
  "COADMIRE": "to admire together [v COADMIRED, COADMIRING, COADMIRES]\n",
  "COADMIRED": "COADMIRE, to admire together [v]\n",
  "COADMIRES": "COADMIRE, to admire together [v]\n",
  "COADMIRING": "COADMIRE, to admire together [v]\n",
  "COADMIT": "to admit several things equally [v COADMITTED, COADMITTING, COADMITS]\n",
  "COADMITS": "COADMIT, to admit several things equally [v]\n",
  "COADMITTED": "COADMIT, to admit several things equally [v]\n",
  "COADMITTING": "COADMIT, to admit several things equally [v]\n",
  "COADUNATE": "to unite, to combine [v COADUNATED, COADUNATING, COADUNATES]\n",
  "COADUNATED": "COADUNATE, to unite, to combine [v]\n",
  "COADUNATES": "COADUNATE, to unite, to combine [v]\n",
  "COADUNATING": "COADUNATE, to unite, to combine [v]\n",
  "COADUNATION": "the act of coadunating [n -S]\n",
  "COADUNATIONS": "COADUNATION, the act of coadunating [n]\n",
  "COADUNATIVE": "serving to coadunate [adj]\n",
  "COADY": "a sauce made from molasses [n COADIES]\n",
  "COAEVAL": "one of the same era as another [n -S]\n",
  "COAEVALS": "COAEVAL, one of the same era as another [n]\n",
  "COAGENCIES": "COAGENCY, a joint agency [n]\n",
  "COAGENCY": "a joint agency [n COAGENCIES]\n",
  "COAGENT": "someone working together with another [n -S]\n",
  "COAGENTS": "COAGENT, someone working together with another [n]\n",
  "COAGULA": "COAGULUM, (Latin) a clot [n]\n",
  "COAGULABILITIES": "COAGULABILITY, the quality of being coagulable [n]\n",
  "COAGULABILITY": "the quality of being coagulable [n COAGULABILITIES]\n",
  "COAGULABLE": "capable of being coagulated [adj]\n",
  "COAGULANT": "that which produces coagulation [n -S]\n",
  "COAGULANTS": "COAGULANT, that which produces coagulation [n]\n",
  "COAGULASE": "any of several enzymes that cause coagulation, as of the blood [n -S]\n",
  "COAGULASES": "COAGULASE, any of several enzymes that cause coagulation, as of the blood [n]\n",
  "COAGULATE": "to curdle, clot, or thicken into a semisolid mass [v COAGULATED, COAGULATING, COAGULATES]\n",
  "COAGULATED": "COAGULATE, to curdle, clot, or thicken into a semisolid mass [v]\n",
  "COAGULATES": "COAGULATE, to curdle, clot, or thicken into a semisolid mass [v]\n",
  "COAGULATING": "COAGULATE, to curdle, clot, or thicken into a semisolid mass [v]\n",
  "COAGULATION": "the act of coagulating [n -S]\n",
  "COAGULATIONS": "COAGULATION, the act of coagulating [n]\n",
  "COAGULATIVE": "serving to coagulate [adj]\n",
  "COAGULATOR": "that which causes coagulation [n -S]\n",
  "COAGULATORS": "COAGULATOR, that which causes coagulation [n]\n",
  "COAGULATORY": "tending to cause coagulation [adj]\n",
  "COAGULUM": "(Latin) a clot [n COAGULUMS or COAGULA]\n",
  "COAGULUMS": "COAGULUM, (Latin) a clot [n]\n",
  "COAITA": "(Tupi) a type of spider monkey [n -S]\n",
  "COAITAS": "COAITA, (Tupi) a type of spider monkey [n]\n",
  "COAL": "to supply with a carbon fuel [v -ED, -ING, -S]\n",
  "COALA": "(Native Australian) an Australian mammal, also KOALA, KOOLAH [n -S]\n",
  "COALAS": "COALA, (Native Australian) an Australian mammal, also KOALA, KOOLAH [n]\n",
  "COALBALL": "a calcareous nodule found in coal [n -S]\n",
  "COALBALLS": "COALBALL, a calcareous nodule found in coal [n]\n",
  "COALBIN": "a bin for storing coal [n -S]\n",
  "COALBINS": "COALBIN, a bin for storing coal [n]\n",
  "COALBOX": "a box for storing coal [n -ES]\n",
  "COALBOXES": "COALBOX, a box for storing coal [n]\n",
  "COALDUST": "the dust from coal [n -S]\n",
  "COALDUSTS": "COALDUST, the dust from coal [n]\n",
  "COALED": "COAL, to supply with a carbon fuel [v]\n",
  "COALER": "a ship that carries coal [n -S]\n",
  "COALERS": "COALER, a ship that carries coal [n]\n",
  "COALESCE": "to blend [v COALESCED, COALESCING, COALESCES]\n",
  "COALESCED": "COALESCE, to blend [v]\n",
  "COALESCENCE": "the act of coalescing [n -S]\n",
  "COALESCENCES": "COALESCENCE, the act of coalescing [n]\n",
  "COALESCENT": "growing together, cohering [adj]\n",
  "COALESCES": "COALESCE, to blend [v]\n",
  "COALESCING": "COALESCE, to blend [v]\n",
  "COALFACE": "exposed coal in a mine [n -S]\n",
  "COALFACES": "COALFACE, exposed coal in a mine [n]\n",
  "COALFIELD": "a district or area containing coal strata [n -S]\n",
  "COALFIELDS": "COALFIELD, a district or area containing coal strata [n]\n",
  "COALFISH": "a dusky fish [n -ES]\n",
  "COALFISHES": "COALFISH, a dusky fish [n]\n",
  "COALHOLE": "a compartment for storing coal [n -S]\n",
  "COALHOLES": "COALHOLE, a compartment for storing coal [n]\n",
  "COALHOUSE": "a place where coal is kept [n -S]\n",
  "COALHOUSES": "COALHOUSE, a place where coal is kept [n]\n",
  "COALIER": "COALY, containing coal [adj]\n",
  "COALIEST": "COALY, containing coal [adj]\n",
  "COALIFICATION": "a process in which vegetable matter becomes converted into coal of increasingly higher rank with anthracite as the final product [n -S]\n",
  "COALIFICATIONS": "COALIFICATION, a process in which vegetable matter becomes converted into coal of increasingly higher rank with anthracite as the final product [n]\n",
  "COALIFIED": "COALIFY, to convert into coal [v]\n",
  "COALIFIES": "COALIFY, to convert into coal [v]\n",
  "COALIFY": "to convert into coal [v COALIFIED, COALIFYING, COALIFIES]\n",
  "COALIFYING": "COALIFY, to convert into coal [v]\n",
  "COALING": "COAL, to supply with a carbon fuel [v]\n",
  "COALISE": "to bring into coalition, also COALIZE [v COALISED, COALISING, COALISES]\n",
  "COALISED": "COALISE, to bring into coalition, also COALIZE [v]\n",
  "COALISES": "COALISE, to bring into coalition, also COALIZE [v]\n",
  "COALISING": "COALISE, to bring into coalition, also COALIZE [v]\n",
  "COALITION": "the act of merging into one mass or body [n -S]\n",
  "COALITIONAL": "relating to coalition [adj]\n",
  "COALITIONER": "a supporter of coalition [n -S]\n",
  "COALITIONERS": "COALITIONER, a supporter of coalition [n]\n",
  "COALITIONISM": "the forming of a coalition [n -S]\n",
  "COALITIONISMS": "COALITIONISM, the forming of a coalition [n]\n",
  "COALITIONIST": "a supporter of coalitionism [n -S]\n",
  "COALITIONISTS": "COALITIONIST, a supporter of coalitionism [n]\n",
  "COALITIONS": "COALITION, the act of merging into one mass or body [n]\n",
  "COALIZE": "to bring into coalition, also COALISE [v COALIZED, COALIZING, COALIZES]\n",
  "COALIZED": "COALIZE, to bring into coalition, also COALISE [v]\n",
  "COALIZES": "COALIZE, to bring into coalition, also COALISE [v]\n",
  "COALIZING": "COALIZE, to bring into coalition, also COALISE [v]\n",
  "COALLESS": "without coal [adj]\n",
  "COALMAN": "a coal merchant [n COALMEN]\n",
  "COALMASTER": "the owner or lessee of a coalfield [n -S]\n",
  "COALMASTERS": "COALMASTER, the owner or lessee of a coalfield [n]\n",
  "COALMEN": "COALMAN, a coal merchant [n]\n",
  "COALMINE": "a mine at which coal is dug [n -S]\n",
  "COALMINER": "one who digs coal [n -S]\n",
  "COALMINERS": "COALMINER, one who digs coal [n]\n",
  "COALMINES": "COALMINE, a mine at which coal is dug [n]\n",
  "COALPIT": "a pit from which coal is obtained [n -S]\n",
  "COALPITS": "COALPIT, a pit from which coal is obtained [n]\n",
  "COALS": "COAL, to supply with a carbon fuel [v]\n",
  "COALSACK": "a sack for carrying coal [n -S]\n",
  "COALSACKS": "COALSACK, a sack for carrying coal [n]\n",
  "COALSHED": "a shed for storing coal [n -S]\n",
  "COALSHEDS": "COALSHED, a shed for storing coal [n]\n",
  "COALY": "containing coal [adj COALIER, COALIEST]\n",
  "COALYARD": "a yard for storing coal [n -S]\n",
  "COALYARDS": "COALYARD, a yard for storing coal [n]\n",
  "COAMING": "a raised border [n -S]\n",
  "COAMINGS": "COAMING, a raised border [n]\n",
  "COANCHOR": "to present televised news reports jointly [v -ED, -ING, -S]\n",
  "COANCHORED": "COANCHOR, to present televised news reports jointly [v]\n",
  "COANCHORING": "COANCHOR, to present televised news reports jointly [v]\n",
  "COANCHORS": "COANCHOR, to present televised news reports jointly [v]\n",
  "COANNEX": "to annex jointly [v -ED, -ING, -ES]\n",
  "COANNEXED": "COANNEX, to annex jointly [v]\n",
  "COANNEXES": "COANNEX, to annex jointly [v]\n",
  "COANNEXING": "COANNEX, to annex jointly [v]\n",
  "COAPPEAR": "to appear together at the same time [v -ED, -ING, -S]\n",
  "COAPPEARED": "COAPPEAR, to appear together at the same time [v]\n",
  "COAPPEARING": "COAPPEAR, to appear together at the same time [v]\n",
  "COAPPEARS": "COAPPEAR, to appear together at the same time [v]\n",
  "COAPT": "to fit together and make fast [v -ED, -ING, -S]\n",
  "COAPTATION": "joining or fitting together [n -S]\n",
  "COAPTATIONS": "COAPTATION, joining or fitting together [n]\n",
  "COAPTED": "COAPT, to fit together and make fast [v]\n",
  "COAPTING": "COAPT, to fit together and make fast [v]\n",
  "COAPTS": "COAPT, to fit together and make fast [v]\n",
  "COARB": "(historical) the head of a family in an Irish sept; an ecclesiastical successor, also COMARB [n -S]\n",
  "COARBS": "COARB, (historical) the head of a family in an Irish sept; an ecclesiastical successor, also COMARB [n]\n",
  "COARCTATE": "to press together; to crowd [v COARCTATED, COARCTATING, COARCTATES]\n",
  "COARCTATED": "COARCTATE, to press together; to crowd [v]\n",
  "COARCTATES": "COARCTATE, to press together; to crowd [v]\n",
  "COARCTATING": "COARCTATE, to press together; to crowd [v]\n",
  "COARCTATION": "the action of compressing tightly; the state of being tightly compressed [n -S]\n",
  "COARCTATIONS": "COARCTATION, the action of compressing tightly; the state of being tightly compressed [n]\n",
  "COARSE": "rough, crude [adj COARSER, COARSEST, COARSELY]\n",
  "COARSELY": "COARSE, rough, crude [adv]\n",
  "COARSEN": "to make coarse [v -ED, -ING, -S]\n",
  "COARSENED": "COARSEN, to make coarse [v]\n",
  "COARSENESS": "the state of being coarse [n -ES]\n",
  "COARSENESSES": "COARSENESS, the state of being coarse [n]\n",
  "COARSENING": "COARSEN, to make coarse [v]\n",
  "COARSENS": "COARSEN, to make coarse [v]\n",
  "COARSER": "COARSE, rough, crude [adj]\n",
  "COARSEST": "COARSE, rough, crude [adj]\n",
  "COARSISH": "somewhat coarse [adj]\n",
  "COASSIST": "to assist jointly [v -ED, -ING, -S]\n",
  "COASSISTED": "COASSIST, to assist jointly [v]\n",
  "COASSISTING": "COASSIST, to assist jointly [v]\n",
  "COASSISTS": "COASSIST, to assist jointly [v]\n",
  "COASSUME": "to assume together [v COASSUMED, COASSUMING, COASSUMES]\n",
  "COASSUMED": "COASSUME, to assume together [v]\n",
  "COASSUMES": "COASSUME, to assume together [v]\n",
  "COASSUMING": "COASSUME, to assume together [v]\n",
  "COAST": "to cycle without pedalling [v -ED, -ING, -S]\n",
  "COASTAL": "pertaining to the seashore [adj COASTALLY]\n",
  "COASTALLY": "COASTAL, pertaining to the seashore [adv]\n",
  "COASTED": "COAST, to cycle without pedalling [v]\n",
  "COASTEERING": "an adventure sport involving travelling along cliffs before jumping down from them into the sea [n -S]\n",
  "COASTEERINGS": "COASTEERING, an adventure sport involving travelling along cliffs before jumping down from them into the sea [n]\n",
  "COASTER": "a vessel that plies its trade along the coast [n -S]\n",
  "COASTERS": "COASTER, a vessel that plies its trade along the coast [n]\n",
  "COASTGUARD": "an organization with responsibility for watching coastal waters to prevent smuggling and illegal fishing, to assist shipping, and for lifesaving [n -S]\n",
  "COASTGUARDMAN": "a member of a coast guard, also COASTGUARDSMAN [n COASTGUARDMEN]\n",
  "COASTGUARDMEN": "COASTGUARDMAN, a member of a coast guard, also COASTGUARDSMAN [n]\n",
  "COASTGUARDS": "COASTGUARD, an organization with responsibility for watching coastal waters to prevent smuggling and illegal fishing, to assist shipping, and for lifesaving [n]\n",
  "COASTGUARDSMAN": "a member of a coast guard, also COASTGUARDMAN [n COASTGUARDSMEN]\n",
  "COASTGUARDSMEN": "COASTGUARDSMAN, a member of a coast guard, also COASTGUARDMAN [n]\n",
  "COASTING": "coastal trade [n -S]\n",
  "COASTINGS": "COASTING, coastal trade [n]\n",
  "COASTLAND": "land along the coast [n -S]\n",
  "COASTLANDS": "COASTLAND, land along the coast [n]\n",
  "COASTLINE": "the line or boundary of a coast [n -S]\n",
  "COASTLINES": "COASTLINE, the line or boundary of a coast [n]\n",
  "COASTS": "COAST, to cycle without pedalling [v]\n",
  "COASTWARD": "in the direction of the coast, also COASTWARDS [adv]\n",
  "COASTWARDS": "in the direction of the coast, also COASTWARD [adv]\n",
  "COASTWISE": "along the coast [adv]\n",
  "COAT": "to cover with an outer garment [v -ED, -ING, -S]\n",
  "COATDRESS": "a dress styled like a coat, usually with a line of buttons from neckline to hemline [n -ES]\n",
  "COATDRESSES": "COATDRESS, a dress styled like a coat, usually with a line of buttons from neckline to hemline [n]\n",
  "COATE": "(Shakespeare) to cite as evidence [v COATED, COATING, COATES]\n",
  "COATED": "COAT, to cover with an outer garment [v]\n",
  "COATEE": "a small coat [n -S]\n",
  "COATEES": "COATEE, a small coat [n]\n",
  "COATER": "a worker, machine etc. that applies a coating [n -S]\n",
  "COATERS": "COATER, a worker, machine etc. that applies a coating [n]\n",
  "COATES": "COATE, (Shakespeare) to cite as evidence [v]\n",
  "COATI": "(Tupi) a tropical American carnivorous mammal related to the raccoon, also COATIMUNDI [n -S]\n",
  "COATIMUNDI": "(Tupi) a tropical American plantigrade carnivorous mammal, also COATI [n -S]\n",
  "COATIMUNDIS": "COATIMUNDI, (Tupi) a tropical American plantigrade carnivorous mammal, also COATI [n]\n",
  "COATING": "a covering layer [n -S]\n",
  "COATINGS": "COATING, a covering layer [n]\n",
  "COATIS": "COATI, (Tupi) a tropical American carnivorous mammal related to the raccoon, also COATIMUNDI [n]\n",
  "COATLESS": "without a coat [adj]\n",
  "COATLIKE": "like a coat [adj]\n",
  "COATRACK": "a rack for coats [n -S]\n",
  "COATRACKS": "COATRACK, a rack for coats [n]\n",
  "COATROOM": "a room for storing coats [n -S]\n",
  "COATROOMS": "COATROOM, a room for storing coats [n]\n",
  "COATS": "COAT, to cover with an outer garment [v]\n",
  "COATSTAND": "a stand for hanging coats on [n -S]\n",
  "COATSTANDS": "COATSTAND, a stand for hanging coats on [n]\n",
  "COATTAIL": "the back lower part of a coat [n -S]\n",
  "COATTAILS": "COATTAIL, the back lower part of a coat [n]\n",
  "COATTEND": "to attend together [v -ED, -ING, -S]\n",
  "COATTENDED": "COATTEND, to attend together [v]\n",
  "COATTENDING": "COATTEND, to attend together [v]\n",
  "COATTENDS": "COATTEND, to attend together [v]\n",
  "COATTEST": "to attest jointly [v -ED, -ING, -S]\n",
  "COATTESTED": "COATTEST, to attest jointly [v]\n",
  "COATTESTING": "COATTEST, to attest jointly [v]\n",
  "COATTESTS": "COATTEST, to attest jointly [v]\n",
  "COAUTHOR": "to write together [v -ED, -ING, -S]\n",
  "COAUTHORED": "COAUTHOR, to write together [v]\n",
  "COAUTHORING": "COAUTHOR, to write together [v]\n",
  "COAUTHORS": "COAUTHOR, to write together [v]\n",
  "COAUTHORSHIP": "the role of coauthor [n -S]\n",
  "COAUTHORSHIPS": "COAUTHORSHIP, the role of coauthor [n]\n",
  "COAX": "to cajole [v COAXED, COAXING, COAXES]\n",
  "COAXAL": "having a common axis, also COAXIAL [adj]\n",
  "COAXED": "COAX, to cajole [v]\n",
  "COAXER": "one who coaxes [n -S]\n",
  "COAXERS": "COAXER, one who coaxes [n]\n",
  "COAXES": "COAX, to cajole [v]\n",
  "COAXIAL": "having a common axis, also COAXAL [adj COAXIALLY]\n",
  "COAXIALLY": "COAXIAL, having a common axis, also COAXAL [adv]\n",
  "COAXING": "the act of persuading [n -S]\n",
  "COAXINGLY": "COAXING [adv]\n",
  "COAXINGS": "COAXING, the act of persuading [n]\n",
  "COB": "to strike [v COBBED, COBBING, COBS]\n",
  "COBAEA": "one of a family of South American shrubs [n -S]\n",
  "COBAEAS": "COBAEA, one of a family of South American shrubs [n]\n",
  "COBALAMIN": "a complex molecule containing cobalt that is a constituent of vitamin B12 [n -S]\n",
  "COBALAMINS": "COBALAMIN, a complex molecule containing cobalt that is a constituent of vitamin B12 [n]\n",
  "COBALT": "a metallic element [n -S]\n",
  "COBALTIC": "relating to a cobalt [adj]\n",
  "COBALTIFEROUS": "bearing cobalt [adj]\n",
  "COBALTINE": "a mineral of a nearly silver-white color, composed of arsenic, sulphur, and cobalt, also COBALTITE [n -S]\n",
  "COBALTINES": "COBALTINE, a mineral of a nearly silver-white color, composed of arsenic, sulphur, and cobalt, also COBALTITE [n]\n",
  "COBALTITE": "a mineral of a nearly silver-white color, composed of arsenic, sulphur, and cobalt, also COBALTINE [n -S]\n",
  "COBALTITES": "COBALTITE, a mineral of a nearly silver-white color, composed of arsenic, sulphur, and cobalt, also COBALTINE [n]\n",
  "COBALTOUS": "containing cobalt in lower valence [adj]\n",
  "COBALTS": "COBALT, a metallic element [n]\n",
  "COBB": "(archaic) a gull, esp. the great black-backed gull [n -S]\n",
  "COBBED": "COB, to strike [v]\n",
  "COBBER": "(Australian slang) friend, mate [n -S]\n",
  "COBBERS": "COBBER, (Australian slang) friend, mate [n]\n",
  "COBBIER": "COBBY, stout, obstinate [adj]\n",
  "COBBIEST": "COBBY, stout, obstinate [adj]\n",
  "COBBING": "COB, to strike [v]\n",
  "COBBLE": "to mend [v COBBLED, COBBLING, COBBLES]\n",
  "COBBLED": "COBBLE, to mend [v]\n",
  "COBBLER": "a mender of shoes [n -S]\n",
  "COBBLERIES": "COBBLERY, the mending of shoes [n]\n",
  "COBBLERS": "COBBLER, a mender of shoes [n]\n",
  "COBBLERY": "the mending of shoes [n COBBLERIES]\n",
  "COBBLES": "COBBLE, to mend [v]\n",
  "COBBLESTONE": "a large paving stone [n -S] / to pave with cobblestones [v COBBLESTONED, COBBLESTONING, COBBLESTONES]\n",
  "COBBLESTONED": "COBBLESTONE, to pave with cobblestones [v]\n",
  "COBBLESTONES": "COBBLESTONE, to pave with cobblestones [v]\n",
  "COBBLESTONING": "COBBLESTONE, to pave with cobblestones [v]\n",
  "COBBLING": "mending shoes [n -S]\n",
  "COBBLINGS": "COBBLING, mending shoes [n]\n",
  "COBBS": "COBB, (archaic) a gull, esp. the great black-backed gull [n]\n",
  "COBBY": "stout, obstinate [adj COBBIER, COBBIEST]\n",
  "COBELLIGERENT": "a country fighting with another power against a common enemy [n -S]\n",
  "COBELLIGERENTS": "COBELLIGERENT, a country fighting with another power against a common enemy [n]\n",
  "COBIA": "a large game fish [n -S]\n",
  "COBIAS": "COBIA, a large game fish [n]\n",
  "COBLE": "(Welsh) a short, flat-bottomed boat for use on rivers and estuaries [n -S]\n",
  "COBLES": "COBLE, (Welsh) a short, flat-bottomed boat for use on rivers and estuaries [n]\n",
  "COBLOAF": "a rounded loaf [n COBLOAVES]\n",
  "COBLOAVES": "COBLOAF, a rounded loaf [n]\n",
  "COBNUT": "a large roundish variety of the cultivated hazelnut [n -S]\n",
  "COBNUTS": "COBNUT, a large roundish variety of the cultivated hazelnut [n]\n",
  "COBRA": "(Portuguese) a venomous snake of India and Africa [n -S]\n",
  "COBRAS": "COBRA, (Portuguese) a venomous snake of India and Africa [n]\n",
  "COBRIC": "of a cobra [adj]\n",
  "COBRIFORM": "like or related to the cobra [adj]\n",
  "COBS": "COB, to strike [v]\n",
  "COBURG": "(German) a thin single-twilled worsted fabric with cotton or silk [n -S]\n",
  "COBURGS": "COBURG, (German) a thin single-twilled worsted fabric with cotton or silk [n]\n",
  "COBWEB": "to cover with spider webs [v COBWEBBED, COBWEBBING, COBWEBS]\n",
  "COBWEBBED": "COBWEB, to cover with spider webs [v]\n",
  "COBWEBBERIES": "COBWEBBERY, cobwebs collectively [n]\n",
  "COBWEBBERY": "cobwebs collectively [n COBWEBBERIES]\n",
  "COBWEBBIER": "COBWEBBY, covered with cobwebs [adj]\n",
  "COBWEBBIEST": "COBWEBBY, covered with cobwebs [adj]\n",
  "COBWEBBING": "COBWEB, to cover with spider webs [v]\n",
  "COBWEBBY": "covered with cobwebs [adj COBWEBBIER, COBWEBBIEST]\n",
  "COBWEBS": "COBWEB, to cover with spider webs [v]\n",
  "COBZA": "(Romanian) a folk instrument [n -S]\n",
  "COBZAS": "COBZA, (Romanian) a folk instrument [n]\n",
  "COCA": "(Quechua) the dried leaf of a South American shrub [n -S]\n",
  "COCAIN": "a narcotic, also COCAINE [n -S]\n",
  "COCAINE": "a narcotic, also COCAIN [n -S]\n",
  "COCAINES": "COCAINE, a narcotic, also COCAIN [n]\n",
  "COCAINISATION": "the process of cocainising, also COCAINIZATION [n -S]\n",
  "COCAINISATIONS": "COCAINISATION, the process of cocainising, also COCAINIZATION [n]\n",
  "COCAINISE": "to anaesthetise with cocaine, also COCAINIZE [v COCAINISED, COCAINISING, COCAINISES]\n",
  "COCAINISED": "COCAINISE, to anaesthetise with cocaine, also COCAINIZE [v]\n",
  "COCAINISES": "COCAINISE, to anaesthetise with cocaine, also COCAINIZE [v]\n",
  "COCAINISING": "COCAINISE, to anaesthetise with cocaine, also COCAINIZE [v]\n",
  "COCAINISM": "a morbid condition caused by addiction to cocaine [n -S]\n",
  "COCAINISMS": "COCAINISM, a morbid condition caused by addiction to cocaine [n]\n",
  "COCAINIST": "one suffering from cocainism, a morbid condition caused by addiction to cocaine [n -S]\n",
  "COCAINISTS": "COCAINIST, one suffering from cocainism, a morbid condition caused by addiction to cocaine [n]\n",
  "COCAINIZATION": "the process of cocainizing, also COCAINISATION [n -S]\n",
  "COCAINIZATIONS": "COCAINIZATION, the process of cocainizing, also COCAINISATION [n]\n",
  "COCAINIZE": "to anaesthetise with cocaine, also COCAINISE [v COCAINIZED, COCAINIZING, COCAINIZES]\n",
  "COCAINIZED": "COCAINIZE, to anaesthetise with cocaine, also COCAINISE [v]\n",
  "COCAINIZES": "COCAINIZE, to anaesthetise with cocaine, also COCAINISE [v]\n",
  "COCAINIZING": "COCAINIZE, to anaesthetise with cocaine, also COCAINISE [v]\n",
  "COCAINS": "COCAIN, a narcotic, also COCAINE [n]\n",
  "COCAPTAIN": "a joint captain [n -S] / to captain jointly [v -ED, -ING, -S]\n",
  "COCAPTAINED": "COCAPTAIN, to captain jointly [v]\n",
  "COCAPTAINING": "COCAPTAIN, to captain jointly [v]\n",
  "COCAPTAINS": "COCAPTAIN, to captain jointly [v]\n",
  "COCARBOXYLASE": "a coenzyme that is a pyrophosphate of thiamine and is important in metabolic reactions [n -S]\n",
  "COCARBOXYLASES": "COCARBOXYLASE, a coenzyme that is a pyrophosphate of thiamine and is important in metabolic reactions [n]\n",
  "COCARCINOGEN": "an agent that aggravates the carcinogenic effects of another substance [n -S]\n",
  "COCARCINOGENIC": "of or like a cocarcinogen, an agent that aggravates the carcinogenic effects of another substance [adj]\n",
  "COCARCINOGENS": "COCARCINOGEN, an agent that aggravates the carcinogenic effects of another substance [n]\n",
  "COCAS": "COCA, (Quechua) the dried leaf of a South American shrub [n]\n",
  "COCATALYST": "a substance that acts in tandem with another as a catalyst [n -S]\n",
  "COCATALYSTS": "COCATALYST, a substance that acts in tandem with another as a catalyst [n]\n",
  "COCCAL": "pertaining to a coccus, also COCCIC [adj]\n",
  "COCCI": "COCCUS, (Greek) one of the separable carpels of a dry fruit [n]\n",
  "COCCIC": "pertaining to a coccus, also COCCAL [adj]\n",
  "COCCID": "a kind of insect, the scale insects and mealy bugs [n -S]\n",
  "COCCIDIA": "COCCIDIUM, a parasitic protozoan [n]\n",
  "COCCIDIAN": "any of a group of parasitic protozoa [n -S]\n",
  "COCCIDIANS": "COCCIDIAN, any of a group of parasitic protozoa [n]\n",
  "COCCIDIOSES": "COCCIDIOSIS, infestation with or disease caused by coccidia [n]\n",
  "COCCIDIOSIS": "infestation with or disease caused by coccidia [n COCCIDIOSES]\n",
  "COCCIDIOSTAT": "an agent which builds up a resistance by the host to coccidia by retarding the latter's life-cycle, etc. [n -S]\n",
  "COCCIDIOSTATS": "COCCIDIOSTAT, an agent which builds up a resistance by the host to coccidia by retarding the latter's life-cycle, etc. [n]\n",
  "COCCIDIUM": "a parasitic protozoan [n COCCIDIA]\n",
  "COCCIDS": "COCCID, a kind of insect, the scale insects and mealy bugs [n]\n",
  "COCCIFEROUS": "of plants, supporting the cochineal insect [adj]\n",
  "COCCINEOUS": "(obsolete) bright red [adj]\n",
  "COCCO": "the taro or other edible araceous tuber, also COCO [n -S]\n",
  "COCCOID": "a spherical cell [n -S]\n",
  "COCCOIDAL": "like a coccoid, a spherical cell or body [adj]\n",
  "COCCOIDS": "COCCOID, a spherical cell [n]\n",
  "COCCOLITE": "a small rounded body found in chalk formations, consisting of microscopic plates secreted by extinct algal plankton, also COCCOLITH [n -S]\n",
  "COCCOLITES": "COCCOLITE, a small rounded body found in chalk formations, consisting of microscopic plates secreted by extinct algal plankton, also COCCOLITH [n]\n",
  "COCCOLITH": "a small rounded body found in chalk formations, consisting of microscopic plates secreted by extinct algal plankton, also COCCOLITE [n -S]\n",
  "COCCOLITHS": "COCCOLITH, a small rounded body found in chalk formations, consisting of microscopic plates secreted by extinct algal plankton, also COCCOLITE [n]\n",
  "COCCOS": "COCCO, the taro or other edible araceous tuber, also COCO [n]\n",
  "COCCOUS": "relating to a coccus [adj]\n",
  "COCCUS": "(Greek) one of the separable carpels of a dry fruit [n COCCI]\n",
  "COCCYGEAL": "pertaining to the coccyx, the tailbone, also COCCYGIAN [adj]\n",
  "COCCYGES": "COCCYX, (Greek) a bone of the spine [n]\n",
  "COCCYGIAN": "relating to the coccyx, the tailbone, also COCCYGEAL [adj]\n",
  "COCCYX": "(Greek) a bone of the spine [n COCCYXES or COCCYGES]\n",
  "COCCYXES": "COCCYX, (Greek) a bone of the spine [n]\n",
  "COCH": "(Spenser) a coach [n -ES]\n",
  "COCHAIR": "to serve jointly as chairman [v -ED, -ING, -S]\n",
  "COCHAIRED": "COCHAIR, to serve jointly as chairman [v]\n",
  "COCHAIRING": "COCHAIR, to serve jointly as chairman [v]\n",
  "COCHAIRMAN": "one who shares a chairmanship [n COCHAIRMEN]\n",
  "COCHAIRMANSHIP": "joint chairmanship [n -S]\n",
  "COCHAIRMANSHIPS": "COCHAIRMANSHIP, joint chairmanship [n]\n",
  "COCHAIRMEN": "COCHAIRMAN, one who shares a chairmanship [n]\n",
  "COCHAIRPERSON": "a joint chairmen or chairwoman [n -S]\n",
  "COCHAIRPERSONS": "COCHAIRPERSON, a joint chairmen or chairwoman [n]\n",
  "COCHAIRS": "COCHAIR, to serve jointly as chairman [v]\n",
  "COCHAIRWOMAN": "a female cochairman [n COCHAIRWOMEN]\n",
  "COCHAIRWOMEN": "COCHAIRWOMAN, a female cochairman [n]\n",
  "COCHAMPION": "a joint champion [n -S]\n",
  "COCHAMPIONS": "COCHAMPION, a joint champion [n]\n",
  "COCHES": "COCH, (Spenser) a coach [n]\n",
  "COCHIN": "(Chinese) a large variety of the domestic fowl, originally from Cochin China [n -S]\n",
  "COCHINEAL": "a dyestuff consisting of the dried bodies of females of the Coccus cacti, an insect native in Mexico, Central America, etc. [n -S]\n",
  "COCHINEALS": "COCHINEAL, a dyestuff consisting of the dried bodies of females of the Coccus cacti, an insect native in Mexico, Central America, etc. [n]\n",
  "COCHINS": "COCHIN, (Chinese) a large variety of the domestic fowl, originally from Cochin China [n]\n",
  "COCHLEA": "(Latin) a part of the ear [n COCHLEAS or COCHLEAE]\n",
  "COCHLEAE": "COCHLEA, (Latin) a part of the ear [n]\n",
  "COCHLEAR": "(Latin) a kind of spoon, also COCHLEARE [n -S]\n",
  "COCHLEARE": "(Latin) a kind of spoon, also COCHLEAR [n -S]\n",
  "COCHLEARES": "COCHLEARE, (Latin) a kind of spoon, also COCHLEAR [n]\n",
  "COCHLEARIFORM": "spoon-shaped [adj]\n",
  "COCHLEARS": "COCHLEAR, (Latin) a kind of spoon, also COCHLEARE [n]\n",
  "COCHLEAS": "COCHLEA, (Latin) a part of the ear [n]\n",
  "COCHLEATE": "having the form of a snail shell, also COCHLEATED [adj]\n",
  "COCHLEATED": "having the form of a snail shell, also COCHLEATE [adj]\n",
  "COCINERA": "(Spanish) a cook [n -S]\n",
  "COCINERAS": "COCINERA, (Spanish) a cook [n]\n",
  "COCK": "to tilt to one side [v -ED, -ING, -S]\n",
  "COCKABULLIES": "COCKABULLY, (Maori) any of various small freshwater fishes of New Zealand [n]\n",
  "COCKABULLY": "(Maori) any of various small freshwater fishes of New Zealand [n COCKABULLIES]\n",
  "COCKADE": "a rosette worn on a hat [n -S]\n",
  "COCKADED": "having a cockade [adj]\n",
  "COCKADES": "COCKADE, a rosette worn on a hat [n]\n",
  "COCKALEEKIE": "(Scots) soup made from a fowl and leeks, also COCKIELEEKIE, COCKYLEEKY [n -S]\n",
  "COCKALEEKIES": "COCKALEEKIE, (Scots) soup made from a fowl and leeks, also COCKIELEEKIE, COCKYLEEKY [n]\n",
  "COCKALORUM": "boastful talk; a boastful and self-important person [n -S]\n",
  "COCKALORUMS": "COCKALORUM, boastful talk; a boastful and self-important person [n]\n",
  "COCKAMAMIE": "ridiculous, incredible, also COCKAMAMY [adj COCKAMAMIER, COCKAMAMIEST]\n",
  "COCKAMAMIER": "COCKAMAMY, ridiculous, incredible, also COCKAMAMIE [adj]\n",
  "COCKAMAMIEST": "COCKAMAMY, ridiculous, incredible, also COCKAMAMIE [adj]\n",
  "COCKAMAMY": "ridiculous, incredible, also COCKAMAMIE [adj COCKAMAMIER, COCKAMAMIEST]\n",
  "COCKAPOO": "a cross between a spaniel and a poodle [n -S]\n",
  "COCKAPOOS": "COCKAPOO, a cross between a spaniel and a poodle [n]\n",
  "COCKATEEL": "(Dutch) a small crested parrot of Australia, also COCKATIEL [n -S]\n",
  "COCKATEELS": "COCKATEEL, (Dutch) a small crested parrot of Australia, also COCKATIEL [n]\n",
  "COCKATIEL": "(Dutch) a small crested parrot of Australia, also COCKATEEL [n -S]\n",
  "COCKATIELS": "COCKATIEL, (Dutch) a small crested parrot of Australia, also COCKATEEL [n]\n",
  "COCKATOO": "(Malay) a bird of the parrot family [n -S]\n",
  "COCKATOOS": "COCKATOO, (Malay) a bird of the parrot family [n]\n",
  "COCKATRICE": "a fabulous serpent whose breath and look were said to be fatal [n -S]\n",
  "COCKATRICES": "COCKATRICE, a fabulous serpent whose breath and look were said to be fatal [n]\n",
  "COCKBILL": "to raise the yardarm on a ship [v -ED, -ING, -S]\n",
  "COCKBILLED": "COCKBILL, to raise the yardarm on a ship [v]\n",
  "COCKBILLING": "COCKBILL, to raise the yardarm on a ship [v]\n",
  "COCKBILLS": "COCKBILL, to raise the yardarm on a ship [v]\n",
  "COCKBIRD": "a male bird [n -S]\n",
  "COCKBIRDS": "COCKBIRD, a male bird [n]\n",
  "COCKBOAT": "a small boat [n -S]\n",
  "COCKBOATS": "COCKBOAT, a small boat [n]\n",
  "COCKCHAFER": "any of several kinds of beetle, esp. of the Scarabeidae [n -S]\n",
  "COCKCHAFERS": "COCKCHAFER, any of several kinds of beetle, esp. of the Scarabeidae [n]\n",
  "COCKCROW": "early dawn, the time when the cock crows to greet the sun [n -S]\n",
  "COCKCROWING": "the crowing of a cock [n -S]\n",
  "COCKCROWINGS": "COCKCROWING, the crowing of a cock [n]\n",
  "COCKCROWS": "COCKCROW, early dawn, the time when the cock crows to greet the sun [n]\n",
  "COCKED": "COCK, to tilt to one side [v]\n",
  "COCKER": "to pamper; to indulge [v -ED, -ING, -S]\n",
  "COCKERED": "COCKER, to pamper; to indulge [v]\n",
  "COCKEREL": "a young rooster [n -S]\n",
  "COCKERELS": "COCKEREL, a young rooster [n]\n",
  "COCKERING": "COCKER, to pamper; to indulge [v]\n",
  "COCKERNONIES": "COCKERNONY, (Scots) the gathering of hair in a fillet [n]\n",
  "COCKERNONY": "(Scots) the gathering of hair in a fillet [n COCKERNONIES]\n",
  "COCKERS": "COCKER, to pamper; to indulge [v]\n",
  "COCKET": "an official shipping seal; a customs clearance form [n -S]\n",
  "COCKETS": "COCKET, an official shipping seal; a customs clearance form [n]\n",
  "COCKEYE": "a squinting eye [n -S]\n",
  "COCKEYED": "having a cockeye [adj COCKEYEDLY]\n",
  "COCKEYEDLY": "COCKEYED, having a cockeye [adv]\n",
  "COCKEYEDNESS": "the state of being cockeyed [n -ES]\n",
  "COCKEYEDNESSES": "COCKEYEDNESS, the state of being cockeyed [n]\n",
  "COCKEYES": "COCKEYE, a squinting eye [n]\n",
  "COCKFIGHT": "a fight between cocks [n -S]\n",
  "COCKFIGHTING": "the sport of fighting with cocks [n -S]\n",
  "COCKFIGHTINGS": "COCKFIGHTING, the sport of fighting with cocks [n]\n",
  "COCKFIGHTS": "COCKFIGHT, a fight between cocks [n]\n",
  "COCKHORSE": "a child's rocking-horse [n -S]\n",
  "COCKHORSES": "COCKHORSE, a child's rocking-horse [n]\n",
  "COCKIELEEKIE": "(Scots) soup made from a fowl and leeks, also COCKALEEKIE, COCKYLEEKY [n -S]\n",
  "COCKIELEEKIES": "COCKIELEEKIE, (Scots) soup made from a fowl and leeks, also COCKALEEKIE, COCKYLEEKY [n]\n",
  "COCKIER": "COCKY, arrogantly self-confident [adj]\n",
  "COCKIES": "COCKY, an Australian farmer [n]\n",
  "COCKIEST": "COCKY, arrogantly self-confident [adj]\n",
  "COCKILY": "COCKY, arrogantly self-confident [adv]\n",
  "COCKINESS": "the state of being cocky [n -ES]\n",
  "COCKINESSES": "COCKINESS, the state of being cocky [n]\n",
  "COCKING": "COCK, to tilt to one side [v]\n",
  "COCKISH": "of or like a cock [adj]\n",
  "COCKLE": "a shellfish [n -S] / to wrinkle [v COCKLED, COCKLING, COCKLES]\n",
  "COCKLEBOAT": "a small boat, esp. one used on rivers, also COCKBOAT [n -S]\n",
  "COCKLEBOATS": "COCKLEBOAT, a small boat, esp. one used on rivers, also COCKBOAT [n]\n",
  "COCKLEBUR": "the burdock, also CLOTBUR [n -S]\n",
  "COCKLEBURS": "COCKLEBUR, the burdock, also CLOTBUR [n]\n",
  "COCKLED": "COCKLE, to wrinkle [v]\n",
  "COCKLEERT": "(dialect) cockcrow [n -S]\n",
  "COCKLEERTS": "COCKLEERT, (dialect) cockcrow [n]\n",
  "COCKLEMAN": "a cockle fisherman [n COCKLEMEN]\n",
  "COCKLEMEN": "COCKLEMAN, a cockle fisherman [n]\n",
  "COCKLER": "someone who collects cockles [n -S]\n",
  "COCKLERS": "COCKLER [v]\n",
  "COCKLES": "COCKLE, to wrinkle [v]\n",
  "COCKLESHELL": "a small, light boat [n -S]\n",
  "COCKLESHELLS": "COCKLESHELL, a small, light boat [n]\n",
  "COCKLIKE": "like a rooster [adj]\n",
  "COCKLING": "the act of gathering cockles [n -S]\n",
  "COCKLINGS": "COCKLING, the act of gathering cockles [n]\n",
  "COCKLOFT": "a small room just under the roof [n -S]\n",
  "COCKLOFTS": "COCKLOFT, a small room just under the roof [n]\n",
  "COCKMATCH": "a cockfight [n -ES]\n",
  "COCKMATCHES": "COCKMATCH, a cockfight [n]\n",
  "COCKNEY": "a resident of London's East End [n -S]\n",
  "COCKNEYDOM": "the region or home of cockneys; cockneys, collectively [n -S]\n",
  "COCKNEYDOMS": "COCKNEYDOM, the region or home of cockneys; cockneys, collectively [n]\n",
  "COCKNEYFICATION": "the process of cockneyfying [n]\n",
  "COCKNEYFIED": "COCKNEYFY, to make (an accent) cockney, also COCKNIFY [v]\n",
  "COCKNEYFIES": "COCKNEYFY, to make (an accent) cockney, also COCKNIFY [v]\n",
  "COCKNEYFY": "to make (an accent) cockney, also COCKNIFY [v COCKNEYFIED, COCKNEYFYING, COCKNEYFIES]\n",
  "COCKNEYFYING": "COCKNEYFY, to make (an accent) cockney, also COCKNIFY [v]\n",
  "COCKNEYISH": "characteristic of, or resembling, cockneys [adj]\n",
  "COCKNEYISM": "a Cockney idiom or characteristic [n -S]\n",
  "COCKNEYISMS": "COCKNEYISM, a Cockney idiom or characteristic [n]\n",
  "COCKNEYS": "COCKNEY, a resident of London's East End [n]\n",
  "COCKNIFICATION": "the process of cocknifying [n -S]\n",
  "COCKNIFICATIONS": "COCKNIFICATION, the process of cocknifying [n]\n",
  "COCKNIFIED": "COCKNIFY, to make (an accent) cockney, also COCKNEYFY [v]\n",
  "COCKNIFIES": "COCKNIFY, to make (an accent) cockney, also COCKNEYFY [v]\n",
  "COCKNIFY": "to make (an accent) cockney, also COCKNEYFY [v COCKNIFIED, COCKNIFYING, COCKNIFIES]\n",
  "COCKNIFYING": "COCKNIFY, to make (an accent) cockney, also COCKNEYFY [v]\n",
  "COCKPIT": "the area for the pilot or driver [n -S]\n",
  "COCKPITS": "COCKPIT, the area for the pilot or driver [n]\n",
  "COCKROACH": "an orthopterous insect, the so-called black beetle [n -ES]\n",
  "COCKROACHES": "COCKROACH, an orthopterous insect, the so-called black beetle [n]\n",
  "COCKS": "COCK, to tilt to one side [v]\n",
  "COCKSCOMB": "a jester's cap, resembling a cock's comb [n -S]\n",
  "COCKSCOMBS": "COCKSCOMB, a jester's cap, resembling a cock's comb [n]\n",
  "COCKSFOOT": "a type of grass [n -S]\n",
  "COCKSFOOTS": "COCKSFOOT, a type of grass [n]\n",
  "COCKSHIES": "COCKSHY, a target in a throwing contest, also COCKSHOT [n]\n",
  "COCKSHOT": "a target in a throwing contest, also COCKSHY [n -S]\n",
  "COCKSHOTS": "COCKSHOT, a target in a throwing contest, also COCKSHY [n]\n",
  "COCKSHUT": "twilight, probably referring to a time when poultry are shut up for the night [n -S]\n",
  "COCKSHUTS": "COCKSHUT, twilight, probably referring to a time when poultry are shut up for the night [n]\n",
  "COCKSHY": "a target in a throwing contest, also COCKSHOT [n COCKSHIES]\n",
  "COCKSIER": "COCKSY, self-important, also COXY [adj]\n",
  "COCKSIEST": "COCKSY, self-important, also COXY [adj]\n",
  "COCKSINESS": "the state of being cocksy, bumptious [n -ES]\n",
  "COCKSINESSES": "COCKSINESS, the state of being cocksy, bumptious [n]\n",
  "COCKSMAN": "a man reputed to be extremely virile or sexually accomplished [n COCKSMEN]\n",
  "COCKSMEN": "COCKSMAN, a man reputed to be extremely virile or sexually accomplished [n]\n",
  "COCKSPUR": "a variety of hawthorn with long, straight thorns [n -S]\n",
  "COCKSPURS": "COCKSPUR, a variety of hawthorn with long, straight thorns [n]\n",
  "COCKSUCKER": "(offensive slang) a contemptible person who attempts to ingratiate himself with his superiors [n -S]\n",
  "COCKSUCKERS": "COCKSUCKER, (offensive slang) a contemptible person who attempts to ingratiate himself with his superiors [n]\n",
  "COCKSURE": "perfectly confident [adj COCKSURELY]\n",
  "COCKSURELY": "COCKSURE, perfectly confident [adv]\n",
  "COCKSURENESS": "the state of being cocksure [n -ES]\n",
  "COCKSURENESSES": "COCKSURENESS, the state of being cocksure [n]\n",
  "COCKSWAIN": "the steersman of a boat; a petty officer who has charge of a boat and its crew [n -S] / to take charge of a boat and crew, also COXSWAIN [v -ED, -ING, -S]\n",
  "COCKSWAINED": "COCKSWAIN, to take charge of a boat and crew, also COXSWAIN [v]\n",
  "COCKSWAINING": "COCKSWAIN, to take charge of a boat and crew, also COXSWAIN [v]\n",
  "COCKSWAINS": "COCKSWAIN, the steersman of a boat; a petty officer who has charge of a boat and its crew [n]\n",
  "COCKSY": "self-important, also COXY [adj COCKSIER, COCKSIEST]\n",
  "COCKTAIL": "to dock a horse's tail [v -ED, -ING, -S]\n",
  "COCKTAILED": "COCKTAIL, to dock a horse's tail [v]\n",
  "COCKTAILING": "COCKTAIL, to dock a horse's tail [v]\n",
  "COCKTAILS": "COCKTAIL, to dock a horse's tail [v]\n",
  "COCKTEASER": "(offensive) a woman who deliberately provokes a man's sexual arousal, then refuses sexual intercourse [n -S]\n",
  "COCKTEASERS": "COCKTEASER, (offensive) a woman who deliberately provokes a man's sexual arousal, then refuses sexual intercourse [n]\n",
  "COCKTHROWING": "the old sport of throwing sticks at a cock [n -S]\n",
  "COCKTHROWINGS": "COCKTHROWING, the old sport of throwing sticks at a cock [n]\n",
  "COCKUP": "a turned-up part of something [n -S]\n",
  "COCKUPS": "COCKUP, a turned-up part of something [n]\n",
  "COCKY": "an Australian farmer [n COCKIES] / arrogantly self-confident [adj COCKIER, COCKIEST, COCKILY]\n",
  "COCKYLEEKIES": "COCKYLEEKY, (Scots) soup made from a fowl and leeks, also COCKALEEKIE, COCKIELEEKIE [n]\n",
  "COCKYLEEKY": "(Scots) soup made from a fowl and leeks, also COCKALEEKIE, COCKIELEEKIE [n COCKYLEEKIES]\n",
  "COCO": "the taro or other edible araceous tuber, also COCCO [n -S]\n",
  "COCOA": "the seed of the cacao or chocolate tree [n -S]\n",
  "COCOANUT": "the large, hard-shelled nut of the cocoa palm, also COCONUT, COKERNUT [n -S]\n",
  "COCOANUTS": "COCOANUT, the large, hard-shelled nut of the cocoa palm, also COCONUT, COKERNUT [n]\n",
  "COCOAS": "COCOA, the seed of the cacao or chocolate tree [n]\n",
  "COCOBOLA": "(Spanish) a dark wood used in cabinetry, also COCOBOLO [n -S]\n",
  "COCOBOLAS": "COCOBOLA, (Spanish) a dark wood used in cabinetry, also COCOBOLO [n]\n",
  "COCOBOLO": "(Spanish) a tropical tree, also COCOBOLA [n -S]\n",
  "COCOBOLOS": "COCOBOLO, (Spanish) a tropical tree, also COCOBOLA [n]\n",
  "COCOMAT": "matting made from coir [n -S]\n",
  "COCOMATS": "COCOMAT, matting made from coir [n]\n",
  "COCOMPOSER": "a joint composer [n -S]\n",
  "COCOMPOSERS": "COCOMPOSER, a joint composer [n]\n",
  "COCONSCIOUS": "aware of the same things, or various things within the same consciousness [adj] / mental processes in a subsidiary stream, apart from the main stream of consciousness [n -ES]\n",
  "COCONSCIOUSES": "COCONSCIOUS, mental processes in a subsidiary stream, apart from the main stream of consciousness [n]\n",
  "COCONSCIOUSNESS": "COCONSCIOUS, aware of the same things, or various things within the same consciousness [n]\n",
  "COCONSPIRATOR": "a joint conspirator [n -S]\n",
  "COCONSPIRATORS": "COCONSPIRATOR, a joint conspirator [n]\n",
  "COCONUT": "the large, hard-shelled nut of the cocoa palm, also COCOANUT, COKERNUT [n -S]\n",
  "COCONUTS": "COCONUT, the large, hard-shelled nut of the cocoa palm, also COCOANUT, COKERNUT [n]\n",
  "COCONUTTIER": "COCONUTTY, tasting of coconut [adj]\n",
  "COCONUTTIEST": "COCONUTTY, tasting of coconut [adj]\n",
  "COCONUTTY": "tasting of coconut [adj COCONUTTIER, COCONUTTIEST]\n",
  "COCOON": "to wrap tightly [v -ED, -ING, -S]\n",
  "COCOONED": "COCOON, to wrap tightly [v]\n",
  "COCOONER": "one who retreats to the private world of the family [n -S]\n",
  "COCOONERIES": "COCOONERY, a building or apartment for silkworms, when feeding and forming cocoons [n]\n",
  "COCOONERS": "COCOONER, one who retreats to the private world of the family [n]\n",
  "COCOONERY": "a building or apartment for silkworms, when feeding and forming cocoons [n COCOONERIES]\n",
  "COCOONING": "the practice of spending leisure time at home in preference to going out [n -S]\n",
  "COCOONINGS": "COCOONING, the practice of spending leisure time at home in preference to going out [n]\n",
  "COCOONS": "COCOON, to wrap tightly [v]\n",
  "COCOPAN": "(Zulu) in South Africa, a wagon on a narrow gauge railway serving a mine [n -S]\n",
  "COCOPANS": "COCOPAN, (Zulu) in South Africa, a wagon on a narrow gauge railway serving a mine [n]\n",
  "COCOPLUM": "a West Indian rosaceous tree; its edible fruit [n -S]\n",
  "COCOPLUMS": "COCOPLUM, a West Indian rosaceous tree; its edible fruit [n]\n",
  "COCOS": "COCO, the taro or other edible araceous tuber, also COCCO [n]\n",
  "COCOTTE": "(French) a prostitute; a flirt or tease [n -S]\n",
  "COCOTTES": "COCOTTE, (French) a prostitute; a flirt or tease [n]\n",
  "COCOUNSEL": "a joint counsel [n -S] / to counsel jointly [v COCOUNSELED or COCOUNSELLED, COCOUNSELING or COCOUNSELLING, COCOUNSELS]\n",
  "COCOUNSELED": "COCOUNSEL, to counsel jointly [v]\n",
  "COCOUNSELING": "COCOUNSEL, to counsel jointly [v]\n",
  "COCOUNSELLED": "COCOUNSEL, to counsel jointly [v]\n",
  "COCOUNSELLING": "COCOUNSEL, to counsel jointly [v]\n",
  "COCOUNSELS": "COCOUNSEL, a joint counsel [n]\n",
  "COCOYAM": "a tropical tuber [n -S]\n",
  "COCOYAMS": "COCOYAM, a tropical tuber [n]\n",
  "COCOZELLE": "a variety of squash [n -S]\n",
  "COCOZELLES": "COCOZELLE, a variety of squash [n]\n",
  "COCREATE": "to create together [v COCREATED, COCREATING, COCREATES]\n",
  "COCREATED": "COCREATE, to create together [v]\n",
  "COCREATES": "COCREATE, to create together [v]\n",
  "COCREATING": "COCREATE, to create together [v]\n",
  "COCREATOR": "one who creates something in collaboration with another [n -S]\n",
  "COCREATORS": "COCREATOR, one who creates something in collaboration with another [n]\n",
  "COCTILE": "baked, hardened by fire [adj]\n",
  "COCTION": "the act of boiling [n -S]\n",
  "COCTIONS": "COCTION, the act of boiling [n]\n",
  "COCULTIVATE": "to cultivate together [v COCULTIVATED, COCULTIVATING, COCULTIVATES]\n",
  "COCULTIVATED": "COCULTIVATE, to cultivate together [v]\n",
  "COCULTIVATES": "COCULTIVATE, to cultivate together [v]\n",
  "COCULTIVATING": "COCULTIVATE, to cultivate together [v]\n",
  "COCULTIVATION": "the act of cocultivating [n -S]\n",
  "COCULTIVATIONS": "COCULTIVATION, the act of cocultivating [n]\n",
  "COCULTURE": "to grow (two or more organisms) in the same growing medium or culture [v COCULTURED, COCULTURING, COCULTURES]\n",
  "COCULTURED": "COCULTURE, to grow (two or more organisms) in the same growing medium or culture [v]\n",
  "COCULTURES": "COCULTURE, to grow (two or more organisms) in the same growing medium or culture [v]\n",
  "COCULTURING": "COCULTURE, to grow (two or more organisms) in the same growing medium or culture [v]\n",
  "COCURATE": "to curate jointly [v COCURATED, COCURATING, COCURATES]\n",
  "COCURATED": "COCURATE, to curate jointly [v]\n",
  "COCURATES": "COCURATE, to curate jointly [v]\n",
  "COCURATING": "COCURATE, to curate jointly [v]\n",
  "COCURATOR": "one who shares a curatorship [n -S]\n",
  "COCURATORS": "COCURATOR, one who shares a curatorship [n]\n",
  "COCURRICULAR": "being outside of but usually complementing the regular curriculum [adj]\n",
  "COCUSWOOD": "the so-called Jamaica ebony, a tradename for the wood of the kokra [n -S]\n",
  "COCUSWOODS": "COCUSWOOD, the so-called Jamaica ebony, a tradename for the wood of the kokra [n]\n",
  "COD": "to hoax or make fun of [v CODDED, CODDING, CODS]\n",
  "CODA": "(Italian) a passage at the end of a musical composition [n -S]\n",
  "CODABLE": "able to be coded [adj]\n",
  "CODAS": "CODA, (Italian) a passage at the end of a musical composition [n]\n",
  "CODDED": "COD, to hoax or make fun of [v]\n",
  "CODDER": "a cod fisherman [n -S]\n",
  "CODDERS": "CODDER, a cod fisherman [n]\n",
  "CODDING": "COD, to hoax or make fun of [v]\n",
  "CODDLE": "to pamper [v CODDLED, CODDLING, CODDLES]\n",
  "CODDLED": "CODDLE, to pamper [v]\n",
  "CODDLER": "one who coddles [n -S]\n",
  "CODDLERS": "CODDLER, one who coddles [n]\n",
  "CODDLES": "CODDLE, to pamper [v]\n",
  "CODDLING": "CODDLE, to pamper [v]\n",
  "CODE": "to convert into symbols [v CODED, CODING, CODES]\n",
  "CODEBOOK": "a book containing code words and symbols [n -S]\n",
  "CODEBOOKS": "CODEBOOK, a book containing code words and symbols [n]\n",
  "CODEBREAKER": "one who job it is to break codes [n -S]\n",
  "CODEBREAKERS": "CODEBREAKER, one who job it is to break codes [n]\n",
  "CODEBTOR": "one who shares a debt [n -S]\n",
  "CODEBTORS": "CODEBTOR, one who shares a debt [n]\n",
  "CODEC": "a piece of software for coding an analogue signal to digital and decoding it back at the other end [n -S]\n",
  "CODECLINATION": "polar distance [n -S]\n",
  "CODECLINATIONS": "CODECLINATION, polar distance [n]\n",
  "CODECS": "CODEC, a piece of software for coding an analogue signal to digital and decoding it back at the other end [n]\n",
  "CODED": "CODE, to convert into symbols [v]\n",
  "CODEFENDANT": "a joint defendant [n -S]\n",
  "CODEFENDANTS": "CODEFENDANT, a joint defendant [n]\n",
  "CODEIA": "a narcotic alkaloid, also CODEIN, CODEINA, CODEINE [n -S]\n",
  "CODEIAS": "CODEIA, a narcotic alkaloid, also CODEIN, CODEINA, CODEINE [n]\n",
  "CODEIN": "a narcotic alkaloid, also CODEIA, CODEINA, CODEINE [n -S]\n",
  "CODEINA": "a narcotic alkaloid, also CODEIA, CODEIN, CODEINE [n -S]\n",
  "CODEINAS": "CODEINA, a narcotic alkaloid, also CODEIA, CODEIN, CODEINE [n]\n",
  "CODEINE": "a narcotic alkaloid, also CODEIA, CODEIN, CODEINA [n -S]\n",
  "CODEINES": "CODEINE, a narcotic alkaloid, also CODEIA, CODEIN, CODEINA [n]\n",
  "CODEINS": "CODEIN, a narcotic alkaloid, also CODEIA, CODEINA, CODEINE [n]\n",
  "CODELESS": "being without a set of laws [adj]\n",
  "CODEN": "a coding classification [n -S]\n",
  "CODENAME": "a name used to conceal the identity of a plan or a person, also CODEWORD [n -S]\n",
  "CODENAMES": "CODENAME, a name used to conceal the identity of a plan or a person, also CODEWORD [n]\n",
  "CODENS": "CODEN, a coding classification [n]\n",
  "CODEPENDENCE": "joint dependence of two or more entities, esp. factors or mathematical objects, on each other, also CODEPENDENCY [n -S]\n",
  "CODEPENDENCES": "CODEPENDENCE, joint dependence of two or more entities, esp. factors or mathematical objects, on each other, also CODEPENDENCY [n]\n",
  "CODEPENDENCIES": "CODEPENDENCY, joint dependence of two or more entities, esp. factors or mathematical objects, on each other, also CODEPENDENCE [n]\n",
  "CODEPENDENCY": "joint dependence of two or more entities, esp. factors or mathematical objects, on each other, also CODEPENDENCE [n CODEPENDENCIES]\n",
  "CODEPENDENT": "one participating in or exhibiting codependency [n -S]\n",
  "CODEPENDENTS": "CODEPENDENT, one participating in or exhibiting codependency [n]\n",
  "CODER": "one who writes code [n -S]\n",
  "CODERIVE": "to derive jointly [v CODERIVED, CODERIVING, CODERIVES]\n",
  "CODERIVED": "CODERIVE, to derive jointly [v]\n",
  "CODERIVES": "CODERIVE, to derive jointly [v]\n",
  "CODERIVING": "CODERIVE, to derive jointly [v]\n",
  "CODERS": "CODER, one who writes code [n]\n",
  "CODES": "CODE, to convert into symbols [v]\n",
  "CODESIGN": "to design jointly [v -ED, -ING, -S]\n",
  "CODESIGNED": "CODESIGN, to design jointly [v]\n",
  "CODESIGNING": "CODESIGN, to design jointly [v]\n",
  "CODESIGNS": "CODESIGN, to design jointly [v]\n",
  "CODETERMINATION": "the participation of labor with management in determining business policy [n]\n",
  "CODETTA": "(Italian) a short passage connecting two sections, but not forming part of either [n -S]\n",
  "CODETTAS": "CODETTA, (Italian) a short passage connecting two sections, but not forming part of either [n]\n",
  "CODEVELOP": "to develop jointly [v -ED, -ING, -S]\n",
  "CODEVELOPED": "CODEVELOP, to develop jointly [v]\n",
  "CODEVELOPER": "one who develops something in partnership with somebody else [n -S]\n",
  "CODEVELOPERS": "CODEVELOPER, one who develops something in partnership with somebody else [n]\n",
  "CODEVELOPING": "CODEVELOP, to develop jointly [v]\n",
  "CODEVELOPS": "CODEVELOP, to develop jointly [v]\n",
  "CODEWORD": "a name used to conceal the identity of a plan or a person, also CODENAME [n -S]\n",
  "CODEWORDS": "CODEWORD, a name used to conceal the identity of a plan or a person, also CODENAME [n]\n",
  "CODEX": "(Latin) a book; a manuscript [n CODICES or CODEXES]\n",
  "CODEXES": "CODEX, (Latin) a book; a manuscript [n]\n",
  "CODFISH": "a marine food-fish [n -ES]\n",
  "CODFISHES": "CODFISH, a marine food-fish [n]\n",
  "CODGER": "an old man [n -S]\n",
  "CODGERS": "CODGER, an old man [n]\n",
  "CODICES": "CODEX, (Latin) a book; a manuscript [n]\n",
  "CODICIL": "(Latin) a supplement to a will [n -S]\n",
  "CODICILLARY": "relating to a codicil [adj]\n",
  "CODICILS": "CODICIL, (Latin) a supplement to a will [n]\n",
  "CODICOLOGICAL": "relating to codicology, the study of manuscripts [adj]\n",
  "CODICOLOGIES": "CODICOLOGY, the study of manuscripts [n]\n",
  "CODICOLOGY": "the study of manuscripts [n CODICOLOGIES]\n",
  "CODIFIABILITIES": "CODIFIABILITY, the quality of being codifiable [n]\n",
  "CODIFIABILITY": "the quality of being codifiable [n CODIFIABILITIES]\n",
  "CODIFIABLE": "capable of being codified [adj]\n",
  "CODIFICATION": "the act of codifying [n -S]\n",
  "CODIFICATIONS": "CODIFICATION, the act of codifying [n]\n",
  "CODIFIED": "CODIFY, to put into the form of a code [v]\n",
  "CODIFIER": "one who codifies [n -S]\n",
  "CODIFIERS": "CODIFIER, one who codifies [n]\n",
  "CODIFIES": "CODIFY, to put into the form of a code [v]\n",
  "CODIFY": "to put into the form of a code [v CODIFIED, CODIFYING, CODIFIES]\n",
  "CODIFYING": "CODIFY, to put into the form of a code [v]\n",
  "CODILLA": "(Italian) the coarse tow of flax and hemp [n -S]\n",
  "CODILLAS": "CODILLA, (Italian) the coarse tow of flax and hemp [n]\n",
  "CODILLE": "(French) a term at the card game omber, signifying that the game is won [n -S]\n",
  "CODILLES": "CODILLE, (French) a term at the card game omber, signifying that the game is won [n]\n",
  "CODING": "the act of coding [n -S]\n",
  "CODINGS": "CODING, the act of coding [n]\n",
  "CODIRECT": "to direct jointly [v -ED, -ING, -S]\n",
  "CODIRECTED": "CODIRECT, to direct jointly [v]\n",
  "CODIRECTING": "CODIRECT, to direct jointly [v]\n",
  "CODIRECTION": "the act of directing together [n -S]\n",
  "CODIRECTIONS": "CODIRECTION, the act of directing together [n]\n",
  "CODIRECTOR": "a joint director [n -S]\n",
  "CODIRECTORS": "CODIRECTOR, a joint director [n]\n",
  "CODIRECTS": "CODIRECT, to direct jointly [v]\n",
  "CODISCOVER": "to discover jointly with another [v -ED, -ING, -S]\n",
  "CODISCOVERED": "CODISCOVER, to discover jointly with another [v]\n",
  "CODISCOVERER": "a joint discoverer [n -S]\n",
  "CODISCOVERERS": "CODISCOVERER, a joint discoverer [n]\n",
  "CODISCOVERING": "CODISCOVER, to discover jointly with another [v]\n",
  "CODISCOVERS": "CODISCOVER, to discover jointly with another [v]\n",
  "CODIST": "a codifier; a maker of codes [n -S]\n",
  "CODISTS": "CODIST, a codifier; a maker of codes [n]\n",
  "CODLIN": "an unripe apple, also CODLING, QUODLIN [n -S]\n",
  "CODLING": "an unripe apple, also CODLIN, QUODLIN [n -S]\n",
  "CODLINGS": "CODLING, an unripe apple, also CODLIN, QUODLIN [n]\n",
  "CODLINS": "CODLIN, an unripe apple, also CODLING, QUODLIN [n]\n",
  "CODOLOGIES": "CODOLOGY, the art or practice of bluffing or deception [n]\n",
  "CODOLOGY": "the art or practice of bluffing or deception [n CODOLOGIES]\n",
  "CODOMAIN": "in mathematics, the range, the set of output values of a function (the domain is the set of inputs) [n -S]\n",
  "CODOMAINS": "CODOMAIN, in mathematics, the range, the set of output values of a function (the domain is the set of inputs) [n]\n",
  "CODOMINANCE": "the state of having both alleles expressed equally in the phenotype of the organism [n -S]\n",
  "CODOMINANCES": "CODOMINANCE, the state of having both alleles expressed equally in the phenotype of the organism [n]\n",
  "CODOMINANT": "sharing domination of an area [adj] / one of two or more species sharing domination of an area [n -S]\n",
  "CODOMINANTS": "CODOMINANT, one of two or more species sharing domination of an area [n]\n",
  "CODON": "a triplet of bases in the messenger-RNA molecule, which determines a particular amino-acid in protein synthesis [n -S]\n",
  "CODONS": "CODON, a triplet of bases in the messenger-RNA molecule, which determines a particular amino-acid in protein synthesis [n]\n",
  "CODPIECE": "a cover for the crotch in men's breeches [n -S]\n",
  "CODPIECES": "CODPIECE, a cover for the crotch in men's breeches [n]\n",
  "CODRIVE": "to work as a codriver [v CODROVE, CODRIVEN, CODRIVING, CODRIVES]\n",
  "CODRIVEN": "CODRIVE, to work as a codriver [v]\n",
  "CODRIVER": "one who codrives [n -S]\n",
  "CODRIVERS": "CODRIVER, one who codrives [n]\n",
  "CODRIVES": "CODRIVE, to work as a codriver [v]\n",
  "CODRIVING": "CODRIVE, to work as a codriver [v]\n",
  "CODROVE": "CODRIVE, to work as a codriver [v]\n",
  "CODS": "COD, to hoax or make fun of [v]\n",
  "CODSWALLOP": "something utterly senseless; nonsense [n -S]\n",
  "CODSWALLOPS": "CODSWALLOP, something utterly senseless; nonsense [n]\n",
  "COECILIAN": "a burrowing worm-like amphibian, also CAECILIAN [n -S]\n",
  "COECILIANS": "COECILIAN, a burrowing worm-like amphibian, also CAECILIAN [n]\n",
  "COED": "a girl student at a coeducational institution [n -S]\n",
  "COEDIT": "to edit together [v -ED, -ING, -S]\n",
  "COEDITED": "COEDIT, to edit together [v]\n",
  "COEDITING": "COEDIT, to edit together [v]\n",
  "COEDITOR": "a joint editor [n -S]\n",
  "COEDITORS": "COEDITOR, a joint editor [n]\n",
  "COEDITS": "COEDIT, to edit together [v]\n",
  "COEDS": "COED, a girl student at a coeducational institution [n]\n",
  "COEDUCATION": "the education of students of both sexes at the same institution [n -S]\n",
  "COEDUCATIONAL": "relating to coeducation [adj COEDUCATIONALLY]\n",
  "COEDUCATIONALLY": "COEDUCATIONAL, relating to coeducation [adv]\n",
  "COEDUCATIONS": "COEDUCATION, the education of students of both sexes at the same institution [n]\n",
  "COEFFECT": "an accompanying effect [n -S]\n",
  "COEFFECTS": "COEFFECT, an accompanying effect [n]\n",
  "COEFFICIENT": "any of the factors of a product considered in relation to a specific factor [n -S]\n",
  "COEFFICIENTS": "COEFFICIENT, any of the factors of a product considered in relation to a specific factor [n]\n",
  "COEHORN": "(Dutch) a small mortar for throwing grenades, also COHORN [n -S]\n",
  "COEHORNS": "COEHORN, (Dutch) a small mortar for throwing grenades, also COHORN [n]\n",
  "COELACANTH": "any of a group of primitive crossopterygian fishes [n -S]\n",
  "COELACANTHIC": "(jocular) old but worth keeping [adj]\n",
  "COELACANTHS": "COELACANTH, any of a group of primitive crossopterygian fishes [n]\n",
  "COELANAGLYPHIC": "in cavo-rilievo (hollow relief) [adj]\n",
  "COELENTERA": "COELENTERON, a coelenterate's saclike body cavity [n]\n",
  "COELENTERATE": "a classification of animals that includes sea anemones, hydra, jellyfish, and coral [n -S]\n",
  "COELENTERATES": "COELENTERATE, a classification of animals that includes sea anemones, hydra, jellyfish, and coral [n]\n",
  "COELENTERIC": "relating to coelenterates [adj]\n",
  "COELENTERON": "a coelenterate's saclike body cavity [n COELENTERA or COELENTERONS]\n",
  "COELENTERONS": "COELENTERON, a coelenterate's saclike body cavity [n]\n",
  "COELIAC": "a person suffering an abdominal disease [n -S]\n",
  "COELIACS": "COELIAC, a person suffering an abdominal disease [n]\n",
  "COELIOSCOPIES": "COELIOSCOPY, a medical procedure for examining the abdomen [n]\n",
  "COELIOSCOPY": "a medical procedure for examining the abdomen [n COELIOSCOPIES]\n",
  "COELOM": "(Greek) a body cavity in some animals, also CELOM, COELOME [n COELOMS or COELOMATA]\n",
  "COELOMATA": "COELOM, (Greek) a body cavity in some animals, also CELOM, COELOME [n]\n",
  "COELOMATE": "having a coelom [adj] / an animal having a coelom [n -S]\n",
  "COELOMATES": "COELOMATE, an animal having a coelom [n]\n",
  "COELOMATIC": "of or like a coelom, a fluid-filled cavity within the body of an animal [adj]\n",
  "COELOME": "(Greek) a body cavity in some animals, also COELOM, CELOM [n -S]\n",
  "COELOMES": "COELOME, (Greek) a body cavity in some animals, also COELOM, CELOM [n]\n",
  "COELOMIC": "relating to a coelom, also CELOMIC [adj]\n",
  "COELOMS": "COELOM, (Greek) a body cavity in some animals, also CELOM, COELOME [n]\n",
  "COELOSTAT": "an astronomical instrument used to reflect light on to a telescope [n -S]\n",
  "COELOSTATS": "COELOSTAT, an astronomical instrument used to reflect light on to a telescope [n]\n",
  "COELUROSAUR": "a bipedal carnivorous dinosaur of the Triassic and Cretaceous periods [n -S]\n",
  "COELUROSAURS": "COELUROSAUR, a bipedal carnivorous dinosaur of the Triassic and Cretaceous periods [n]\n",
  "COEMBODIED": "COEMBODY, to embody jointly [v]\n",
  "COEMBODIES": "COEMBODY, to embody jointly [v]\n",
  "COEMBODY": "to embody jointly [v COEMBODIED, COEMBODYING, COEMBODIES]\n",
  "COEMBODYING": "COEMBODY, to embody jointly [v]\n",
  "COEMPLOY": "to employ together [v -ED, -ING, -S]\n",
  "COEMPLOYED": "COEMPLOY, to employ together [v]\n",
  "COEMPLOYING": "COEMPLOY, to employ together [v]\n",
  "COEMPLOYS": "COEMPLOY, to employ together [v]\n",
  "COEMPT": "to buy up the entire supply of a product [v -ED, -ING, -S]\n",
  "COEMPTED": "COEMPT, to buy up the entire supply of a product [v]\n",
  "COEMPTING": "COEMPT, to buy up the entire supply of a product [v]\n",
  "COEMPTION": "the purchase of the entire supply of a commodity [n -S]\n",
  "COEMPTIONS": "COEMPTION, the purchase of the entire supply of a commodity [n]\n",
  "COEMPTS": "COEMPT, to buy up the entire supply of a product [v]\n",
  "COENACLE": "a dining room, also CENACLE [n -S]\n",
  "COENACLES": "COENACLE, a dining room, also CENACLE [n]\n",
  "COENACT": "to enact together [v -ED, -ING, -S]\n",
  "COENACTED": "COENACT, to enact together [v]\n",
  "COENACTING": "COENACT, to enact together [v]\n",
  "COENACTS": "COENACT, to enact together [v]\n",
  "COENAESTHESES": "COENAESTHESIS, general consciousness or awareness of one's body, also CENESTHESIA, CENESTHESIS, COENAESTHESIA, COENESTHESIA [n]\n",
  "COENAESTHESIA": "general consciousness or awareness of one's body, also CENESTHESIA, CENESTHESIS, COENAESTHESIS, COENESTHESIA [n -S]\n",
  "COENAESTHESIAS": "COENAESTHESIA, general consciousness or awareness of one's body, also CENESTHESIA, CENESTHESIS, COENAESTHESIS, COENESTHESIA [n]\n",
  "COENAESTHESIS": "general consciousness or awareness of one's body, also CENESTHESIA, CENESTHESIS, COENAESTHESIA, COENESTHESIA [n COENAESTHESES]\n",
  "COENAMOR": "to inflame with mutual love, also COENAMOUR [v -ED, -ING, -S]\n",
  "COENAMORED": "COENAMOR, to inflame with mutual love, also COENAMOUR [v]\n",
  "COENAMORING": "COENAMOR, to inflame with mutual love, also COENAMOUR [v]\n",
  "COENAMORS": "COENAMOR, to inflame with mutual love, also COENAMOUR [v]\n",
  "COENAMOUR": "to enamour jointly, also COENAMOR [v COENAMOURED, COENAMOURING, COENAMOURS]\n",
  "COENAMOURED": "COENAMOUR, to enamour jointly, also COENAMOR [v]\n",
  "COENAMOURING": "COENAMOUR, to enamour jointly, also COENAMOR [v]\n",
  "COENAMOURS": "COENAMOUR, to enamour jointly, also COENAMOR [v]\n",
  "COENDURE": "to endure together [v COENDURED, COENDURING, COENDURES]\n",
  "COENDURED": "COENDURE, to endure together [v]\n",
  "COENDURES": "COENDURE, to endure together [v]\n",
  "COENDURING": "COENDURE, to endure together [v]\n",
  "COENENCHYMA": "gelatinous material uniting the polyps of an anthozoan colony [n COENENCHYMAS or COENENCHYMATA]\n",
  "COENENCHYMAS": "COENENCHYMA, gelatinous material uniting the polyps of an anthozoan colony [n]\n",
  "COENENCHYMATA": "COENENCHYMA, gelatinous material uniting the polyps of an anthozoan colony [n]\n",
  "COENENCHYME": "the gelatinous framework between polyps of an anthozoan colony [n -S]\n",
  "COENENCHYMES": "COENENCHYME, the gelatinous framework between polyps of an anthozoan colony [n]\n",
  "COENESTHESES": "COENESTHESIS, general awareness of one's own body [n]\n",
  "COENESTHESIA": "general awareness of one's own body, also CENESTHESIA, CENESTHESIS, COENAESTHESIA, COENAESTHESIS [n -S]\n",
  "COENESTHESIAS": "COENESTHESIA, general awareness of one's own body, also CENESTHESIA, CENESTHESIS, COENAESTHESIA, COENAESTHESIS [n]\n",
  "COENESTHESIS": "general awareness of one's own body [n COENESTHESES]\n",
  "COENESTHETIC": "relating to coenesthesia [adj]\n",
  "COENOBIA": "COENOBIUM, a colony of unicellular organisms having a definite number and specific arrangement of cells [n]\n",
  "COENOBITE": "a monk who lives in a community, also CENOBITE [n -S]\n",
  "COENOBITES": "COENOBITE, a monk who lives in a community, also CENOBITE [n]\n",
  "COENOBITIC": "of or like a coenobite, also CENOBITIC, CENOBITICAL [adj]\n",
  "COENOBITICAL": "of or like a coenobite [adj]\n",
  "COENOBITISM": "the state of being a coenobite [n -S]\n",
  "COENOBITISMS": "COENOBITISM, the state of being a coenobite [n]\n",
  "COENOBIUM": "a colony of unicellular organisms having a definite number and specific arrangement of cells [n COENOBIA]\n",
  "COENOCYTE": "a multinucleate unicellular organism in slime molds, fungi and algae [n -S]\n",
  "COENOCYTES": "COENOCYTE, a multinucleate unicellular organism in slime molds, fungi and algae [n]\n",
  "COENOCYTIC": "of or like a coenocyte, a multinucleate unicellular organism in slime molds, fungi and algae [adj]\n",
  "COENOSARC": "the common soft tissue which unites the polyps of a compound hydroid [n -S]\n",
  "COENOSARCS": "COENOSARC, the common soft tissue which unites the polyps of a compound hydroid [n]\n",
  "COENOSPECIES": "a species that can interbreed, also CENOSPECIES [n COENOSPECIES]\n",
  "COENOSTEUM": "the calcareous skeleton of a coral colony [n -S]\n",
  "COENOSTEUMS": "COENOSTEUM, the calcareous skeleton of a coral colony [n]\n",
  "COENURE": "a tapeworm larva, also COENURUS [n -S]\n",
  "COENURES": "COENURE, a tapeworm larva, also COENURUS [n]\n",
  "COENURI": "COENURUS, (Greek) a tapeworm larva, also COENURE [n]\n",
  "COENURUS": "(Greek) a tapeworm larva, also COENURE [n COENURI]\n",
  "COENZYMATIC": "relating to a coenzyme [adj COENZYMATICALLY]\n",
  "COENZYMATICALLY": "COENZYMATIC, relating to a coenzyme [adv]\n",
  "COENZYME": "a nonprotein organic molecule that bonds with a specific enzyme [n -S]\n",
  "COENZYMES": "COENZYME, a nonprotein organic molecule that bonds with a specific enzyme [n]\n",
  "COEQUAL": "equal in rank or power [adj COEQUALLY] / one who is equal in rank or power [n -S]\n",
  "COEQUALITIES": "COEQUALITY, the state of being on an equality, as in rank or power [n]\n",
  "COEQUALITY": "the state of being on an equality, as in rank or power [n COEQUALITIES]\n",
  "COEQUALLY": "COEQUAL, equal in rank or power [adv]\n",
  "COEQUALNESS": "the state of being coequal [n -ES]\n",
  "COEQUALNESSES": "COEQUALNESS, the state of being coequal [n]\n",
  "COEQUALS": "COEQUAL, one who is equal in rank or power [n]\n",
  "COEQUATE": "to equate with something else [v COEQUATED, COEQUATING, COEQUATES]\n",
  "COEQUATED": "COEQUATE, to equate with something else [v]\n",
  "COEQUATES": "COEQUATE, to equate with something else [v]\n",
  "COEQUATING": "COEQUATE, to equate with something else [v]\n",
  "COERCE": "to compel by force or threat [v COERCED, COERCING, COERCES]\n",
  "COERCED": "COERCE, to compel by force or threat [v]\n",
  "COERCER": "one who coerces [n -S]\n",
  "COERCERS": "COERCER, one who coerces [n]\n",
  "COERCES": "COERCE, to compel by force or threat [v]\n",
  "COERCIBLE": "capable of being coerced [adj COERCIBLY]\n",
  "COERCIBLY": "COERCIBLE, capable of being coerced [adv]\n",
  "COERCIMETER": "an instrument for measuring coercive force [n -S]\n",
  "COERCIMETERS": "COERCIMETER, an instrument for measuring coercive force [n]\n",
  "COERCING": "COERCE, to compel by force or threat [v]\n",
  "COERCION": "the act of coercing [n -S]\n",
  "COERCIONIST": "one who believe in government by force [n -S]\n",
  "COERCIONISTS": "COERCIONIST, one who believe in government by force [n]\n",
  "COERCIONS": "COERCION, the act of coercing [n]\n",
  "COERCIVE": "serving or intended to coerce [adj COERCIVELY]\n",
  "COERCIVELY": "COERCIVE, serving or intended to coerce [adv]\n",
  "COERCIVENESS": "the state of being coercive [n -ES]\n",
  "COERCIVENESSES": "COERCIVENESS, the state of being coercive [n]\n",
  "COERCIVITIES": "COERCIVITY, the quality of being coercive [n]\n",
  "COERCIVITY": "the quality of being coercive [n COERCIVITIES]\n",
  "COERECT": "to erect together [v -ED, -ING, -S]\n",
  "COERECTED": "COERECT, to erect together [v]\n",
  "COERECTING": "COERECT, to erect together [v]\n",
  "COERECTS": "COERECT, to erect together [v]\n",
  "COESITE": "a type of silica [n -S]\n",
  "COESITES": "COESITE, a type of silica [n]\n",
  "COESSENTIAL": "religion, formed from same substance [adj COESSENTIALLY]\n",
  "COESSENTIALITY": "the state of being coessential [n]\n",
  "COESSENTIALLY": "COESSENTIAL, religion, formed from same substance [adv]\n",
  "COESSENTIALNESS": "COESSENTIAL, religion, formed from same substance [n]\n",
  "COETANEOUS": "having the same age; coeval [adj COETANEOUSLY]\n",
  "COETANEOUSLY": "COETANEOUS, having the same age; coeval [adv]\n",
  "COETANEOUSNESS": "COETANEOUS, having the same age; coeval [n]\n",
  "COETERNAL": "equally eternal, jointly eternal [adj COETERNALLY]\n",
  "COETERNALLY": "COETERNAL, equally eternal, jointly eternal [adv]\n",
  "COETERNITIES": "COETERNITY, existence from eternity equally with another eternal being [n]\n",
  "COETERNITY": "existence from eternity equally with another eternal being [n COETERNITIES]\n",
  "COEVAL": "belonging to the same period, also COAEVAL [adj COEVALLY] / a person of the same age [n -S]\n",
  "COEVALITIES": "COEVALITY, the state of being coeval, belonging to the same period [n]\n",
  "COEVALITY": "the state of being coeval, belonging to the same period [n COEVALITIES]\n",
  "COEVALLY": "COEVAL, belonging to the same period, also COAEVAL [adv]\n",
  "COEVALS": "COEVAL, a person of the same age [n]\n",
  "COEVOLUTION": "the parallel evolution of two kinds of organisms that are interdependent, like flowers and their pollinators, and where any change in one will result in an adaptive response in the other [n -S]\n",
  "COEVOLUTIONARY": "relating to coevolution [adj]\n",
  "COEVOLUTIONS": "COEVOLUTION, the parallel evolution of two kinds of organisms that are interdependent, like flowers and their pollinators, and where any change in one will result in an adaptive response in the other [n]\n",
  "COEVOLVE": "to evolve together [v COEVOLVED, COEVOLVING, COEVOLVES]\n",
  "COEVOLVED": "COEVOLVE, to evolve together [v]\n",
  "COEVOLVES": "COEVOLVE, to evolve together [v]\n",
  "COEVOLVING": "COEVOLVE, to evolve together [v]\n",
  "COEXECUTOR": "a joint executor [n -S]\n",
  "COEXECUTORS": "COEXECUTOR, a joint executor [n]\n",
  "COEXECUTRICES": "COEXECUTRIX, a joint executrix [n]\n",
  "COEXECUTRIX": "a joint executrix [n COEXECUTRIXES or COEXECUTRICES]\n",
  "COEXECUTRIXES": "COEXECUTRIX, a joint executrix [n]\n",
  "COEXERT": "to exert jointly [v -ED, -ING, -S]\n",
  "COEXERTED": "COEXERT, to exert jointly [v]\n",
  "COEXERTING": "COEXERT, to exert jointly [v]\n",
  "COEXERTS": "COEXERT, to exert jointly [v]\n",
  "COEXIST": "to exist together [v -ED, -ING, -S]\n",
  "COEXISTED": "COEXIST, to exist together [v]\n",
  "COEXISTENCE": "existence together [n -S]\n",
  "COEXISTENCES": "COEXISTENCE, existence together [n]\n",
  "COEXISTENT": "existing at the same time [adj]\n",
  "COEXISTING": "COEXIST, to exist together [v]\n",
  "COEXISTS": "COEXIST, to exist together [v]\n",
  "COEXTEND": "to extend equally in space or time [v -ED, -ING, -S]\n",
  "COEXTENDED": "COEXTEND, to extend equally in space or time [v]\n",
  "COEXTENDING": "COEXTEND, to extend equally in space or time [v]\n",
  "COEXTENDS": "COEXTEND, to extend equally in space or time [v]\n",
  "COEXTENSION": "the act of coextending [n -S]\n",
  "COEXTENSIONS": "COEXTENSION, the act of coextending [n]\n",
  "COEXTENSIVE": "having the same spatial or temporal scope or boundaries [adj COEXTENSIVELY]\n",
  "COEXTENSIVELY": "COEXTENSIVE, having the same spatial or temporal scope or boundaries [adv]\n",
  "COFACTOR": "a molecule or ion which works with an enzyme [n -S]\n",
  "COFACTORS": "COFACTOR, a molecule or ion which works with an enzyme [n]\n",
  "COFAVORITE": "a joint favourite [n -S]\n",
  "COFAVORITES": "COFAVORITE, a joint favourite [n]\n",
  "COFEATURE": "to feature jointly [v COFEATURED, COFEATURING, COFEATURES]\n",
  "COFEATURED": "COFEATURE, to feature jointly [v]\n",
  "COFEATURES": "COFEATURE, to feature jointly [v]\n",
  "COFEATURING": "COFEATURE, to feature jointly [v]\n",
  "COFF": "(Scots) to buy [v COFFED or COFT, COFT, COFFING, COFFS]\n",
  "COFFED": "COFF, (Scots) to buy [v]\n",
  "COFFEE": "a powder made from the seeds of a tree of the madder family; a drink made from this [n -S]\n",
  "COFFEEHOUSE": "an establishment that sells coffee and usually other refreshments and that commonly serves as an informal club for its regular customers [n -S]\n",
  "COFFEEHOUSES": "COFFEEHOUSE, an establishment that sells coffee and usually other refreshments and that commonly serves as an informal club for its regular customers [n]\n",
  "COFFEEMAKER": "a utensil or appliance in which coffee is brewed [n -S]\n",
  "COFFEEMAKERS": "COFFEEMAKER, a utensil or appliance in which coffee is brewed [n]\n",
  "COFFEEPOT": "a pot for coffee [n -S]\n",
  "COFFEEPOTS": "COFFEEPOT, a pot for coffee [n]\n",
  "COFFEES": "COFFEE, a powder made from the seeds of a tree of the madder family; a drink made from this [n]\n",
  "COFFER": "to put in a strongbox [v -ED, -ING, -S]\n",
  "COFFERDAM": "a narrow vacant space between two bulkheads of a ship [n -S]\n",
  "COFFERDAMS": "COFFERDAM, a narrow vacant space between two bulkheads of a ship [n]\n",
  "COFFERED": "COFFER, to put in a strongbox [v]\n",
  "COFFERING": "COFFER, to put in a strongbox [v]\n",
  "COFFERS": "COFFER, to put in a strongbox [v]\n",
  "COFFIN": "to put in a burial box [v -ED, -ING, -S]\n",
  "COFFINED": "COFFIN, to put in a burial box [v]\n",
  "COFFING": "COFF, (Scots) to buy [v]\n",
  "COFFINING": "COFFIN, to put in a burial box [v]\n",
  "COFFINITE": "a uranium-yielding ore [n -S]\n",
  "COFFINITES": "COFFINITE, a uranium-yielding ore [n]\n",
  "COFFINS": "COFFIN, to put in a burial box [v]\n",
  "COFFLE": "(Arabic) to chain slaves together [v COFFLED, COFFLING, COFFLES]\n",
  "COFFLED": "COFFLE, (Arabic) to chain slaves together [v]\n",
  "COFFLES": "COFFLE, (Arabic) to chain slaves together [v]\n",
  "COFFLING": "COFFLE, (Arabic) to chain slaves together [v]\n",
  "COFFRET": "(French) a small strongbox [n -S]\n",
  "COFFRETS": "COFFRET, (French) a small strongbox [n]\n",
  "COFFS": "COFF, (Scots) to buy [v]\n",
  "COFINANCE": "to finance in collaboration with another [v COFINANCED, COFINANCING, COFINANCES]\n",
  "COFINANCED": "COFINANCE, to finance in collaboration with another [v]\n",
  "COFINANCES": "COFINANCE, to finance in collaboration with another [v]\n",
  "COFINANCING": "COFINANCE, to finance in collaboration with another [v]\n",
  "COFIRING": "the combustion of two different types of materials at the same time [n -S]\n",
  "COFIRINGS": "COFIRING, the combustion of two different types of materials at the same time [n]\n",
  "COFOUND": "to found jointly [v -ED, -ING, -S]\n",
  "COFOUNDED": "COFOUND, to found jointly [v]\n",
  "COFOUNDER": "one who founds something in collaboration with another [n -S]\n",
  "COFOUNDERS": "COFOUNDER, one who founds something in collaboration with another [n]\n",
  "COFOUNDING": "COFOUND, to found jointly [v]\n",
  "COFOUNDS": "COFOUND, to found jointly [v]\n",
  "COFT": "COFF, (Scots) to buy [v]\n",
  "COFUNCTION": "a kind of trigonometric function [n -S]\n",
  "COFUNCTIONS": "COFUNCTION, a kind of trigonometric function [n]\n",
  "COG": "to cheat at dice [v COGGED, COGGING, COGS]\n",
  "COGENCE": "the state of being cogent, also COGENCY [n -S]\n",
  "COGENCES": "COGENCE, the state of being cogent, also COGENCY [n]\n",
  "COGENCIES": "COGENCY, the state of being cogent, also COGENCE [n]\n",
  "COGENCY": "the state of being cogent, also COGENCE [n COGENCIES]\n",
  "COGENER": "something of the same nature [n -S]\n",
  "COGENERATION": "the production of electricity from waste heat [n -S]\n",
  "COGENERATIONS": "COGENERATION, the production of electricity from waste heat [n]\n",
  "COGENERATOR": "a device for cogeneration, the production of electricity from waste heat [n -S]\n",
  "COGENERATORS": "COGENERATOR, a device for cogeneration, the production of electricity from waste heat [n]\n",
  "COGENERS": "COGENER, something of the same nature [n]\n",
  "COGENT": "convincing [adj COGENTLY]\n",
  "COGENTLY": "COGENT, convincing [adv]\n",
  "COGGED": "COG, to cheat at dice [v]\n",
  "COGGER": "a flatterer or deceiver [n -S]\n",
  "COGGERS": "COGGER, a flatterer or deceiver [n]\n",
  "COGGIE": "(Scots) a small wooden bowl, also COGIE, COGUE [n -S]\n",
  "COGGIES": "COGGIE, (Scots) a small wooden bowl, also COGIE, COGUE [n]\n",
  "COGGING": "a type of joint for two wooden beams [n -S]\n",
  "COGGINGS": "COGGING, a type of joint for two wooden beams [n]\n",
  "COGGLE": "to wobble [v COGGLED, COGGLING, COGGLES]\n",
  "COGGLED": "COGGLE, to wobble [v]\n",
  "COGGLES": "COGGLE, to wobble [v]\n",
  "COGGLIER": "COGGLY, shaky [adj]\n",
  "COGGLIEST": "COGGLY, shaky [adj]\n",
  "COGGLING": "COGGLE, to wobble [v]\n",
  "COGGLY": "shaky [adj COGGLIER, COGGLIEST]\n",
  "COGIE": "(Scots) a small wooden bowl, also COGGIE, COGUE [n -S]\n",
  "COGIES": "COGIE, (Scots) a small wooden bowl, also COGGIE, COGUE [n]\n",
  "COGITABLE": "capable of being thought, conceivable [adj]\n",
  "COGITATE": "to ponder [v COGITATED, COGITATING, COGITATES]\n",
  "COGITATED": "COGITATE, to ponder [v]\n",
  "COGITATES": "COGITATE, to ponder [v]\n",
  "COGITATING": "COGITATE, to ponder [v]\n",
  "COGITATINGLY": "COGITATING, COGITATE, to ponder [adv]\n",
  "COGITATION": "the act of cogitating [n -S]\n",
  "COGITATIONS": "COGITATION, the act of cogitating [n]\n",
  "COGITATIVE": "having the power of thinking; given to cogitating [adj COGITATIVELY]\n",
  "COGITATIVELY": "COGITATIVE, having the power of thinking; given to cogitating [adv]\n",
  "COGITATIVENESS": "COGITATIVE, having the power of thinking; given to cogitating [n]\n",
  "COGITATOR": "one who cogitates [n -S]\n",
  "COGITATORS": "COGITATOR, one who cogitates [n]\n",
  "COGITO": "(Latin) a philosophical principle [n -S]\n",
  "COGITOS": "COGITO, (Latin) a philosophical principle [n]\n",
  "COGNAC": "(French) a kind of brandy [n -S]\n",
  "COGNACS": "COGNAC, (French) a kind of brandy [n]\n",
  "COGNATE": "related by birth [adj COGNATELY] / someone or something descended from a common ancestor [n -S]\n",
  "COGNATELY": "COGNATE, related by birth [adv]\n",
  "COGNATENESS": "the state of being cognate [n -ES]\n",
  "COGNATENESSES": "COGNATENESS, the state of being cognate [n]\n",
  "COGNATES": "COGNATE, someone or something descended from a common ancestor [n]\n",
  "COGNATION": "relationship by blood; descent from the same original [n -S]\n",
  "COGNATIONS": "COGNATION, relationship by blood; descent from the same original [n]\n",
  "COGNISABLE": "that can be cognised, also COGNIZABLE [adj COGNISABLY]\n",
  "COGNISABLY": "COGNISABLE, that can be cognised, also COGNIZABLE [adv]\n",
  "COGNISANCE": "knowledge or notice, judicial or private, also COGNIZANCE [n -S]\n",
  "COGNISANCES": "COGNISANCE, knowledge or notice, judicial or private, also COGNIZANCE [n]\n",
  "COGNISANT": "aware, conscious of, also COGNIZANT [adj]\n",
  "COGNISE": "to become aware, also COGNIZE [v COGNISED, COGNISING, COGNISES]\n",
  "COGNISED": "COGNISE, to become aware, also COGNIZE [v]\n",
  "COGNISER": "one that cognizes, also COGNIZER [n -S]\n",
  "COGNISERS": "COGNISER, one that cognizes, also COGNIZER [n]\n",
  "COGNISES": "COGNISE, to become aware, also COGNIZE [v]\n",
  "COGNISING": "COGNISE, to become aware, also COGNIZE [v]\n",
  "COGNITION": "the process of knowing, including sensation, perception, etc., distinguished from emotion and conation [n -S]\n",
  "COGNITIONAL": "relating to cognition [adj]\n",
  "COGNITIONS": "COGNITION, the process of knowing, including sensation, perception, etc., distinguished from emotion and conation [n]\n",
  "COGNITIVE": "capable of, or pertaining to, cognition [adj COGNITIVELY]\n",
  "COGNITIVELY": "COGNITIVE, capable of, or pertaining to, cognition [adv]\n",
  "COGNITIVISM": "the metaethical thesis that moral judgments state facts and so are either true or false [n -S]\n",
  "COGNITIVISMS": "COGNITIVISM, the metaethical thesis that moral judgments state facts and so are either true or false [n]\n",
  "COGNITIVITIES": "COGNITIVITY, the state of being cognitive [n]\n",
  "COGNITIVITY": "the state of being cognitive [n COGNITIVITIES]\n",
  "COGNIZABLE": "that can be cognized, also COGNISABLE [adj COGNIZABLY]\n",
  "COGNIZABLY": "COGNIZABLE, that can be cognized, also COGNISABLE [adv]\n",
  "COGNIZANCE": "knowledge or notice, judicial or private, also COGNISANCE [n -S]\n",
  "COGNIZANCES": "COGNIZANCE, knowledge or notice, judicial or private, also COGNISANCE [n]\n",
  "COGNIZANT": "having cognizance or knowledge, also COGNISANT [adj]\n",
  "COGNIZE": "to become aware, also COGNISE [v COGNIZED, COGNIZING, COGNIZES]\n",
  "COGNIZED": "COGNIZE, to become aware, also COGNISE [v]\n",
  "COGNIZER": "one that cognizes, also COGNISER [n -S]\n",
  "COGNIZERS": "COGNIZER, one that cognizes, also COGNISER [n]\n",
  "COGNIZES": "COGNIZE, to become aware, also COGNISE [v]\n",
  "COGNIZING": "COGNIZE, to become aware, also COGNISE [v]\n",
  "COGNOMEN": "(Latin) a family name [n COGNOMENS or COGNOMINA]\n",
  "COGNOMENS": "COGNOMEN, (Latin) a family name [n]\n",
  "COGNOMINA": "COGNOMEN, (Latin) a family name [n]\n",
  "COGNOMINAL": "of or pertaining to a cognomen; of the nature of a surname [adj COGNOMINALLY]\n",
  "COGNOMINALLY": "COGNOMINAL, of or pertaining to a cognomen; of the nature of a surname [adv]\n",
  "COGNOMINATE": "to name [v COGNOMINATED, COGNOMINATING, COGNOMINATES]\n",
  "COGNOMINATED": "COGNOMINATE, to name [v]\n",
  "COGNOMINATES": "COGNOMINATE, to name [v]\n",
  "COGNOMINATING": "COGNOMINATE, to name [v]\n",
  "COGNOMINATION": "the act of cognominating, naming [n -S]\n",
  "COGNOMINATIONS": "COGNOMINATION, the act of cognominating, naming [n]\n",
  "COGNOSCE": "in Scots law, to examine; to give judgment on [v COGNOSCED, COGNOSCING, COGNOSCES]\n",
  "COGNOSCED": "COGNOSCE, in Scots law, to examine; to give judgment on [v]\n",
  "COGNOSCENTE": "(Italian) a person who has expert knowledge in a subject, a connoisseur, also CONOSCENTE [n COGNOSCENTI]\n",
  "COGNOSCENTI": "COGNOSCENTE, (Italian) a person who has expert knowledge in a subject, a connoisseur, also CONOSCENTE [n]\n",
  "COGNOSCES": "COGNOSCE, in Scots law, to examine; to give judgment on [v]\n",
  "COGNOSCIBLE": "cognizable, knowable [adj]\n",
  "COGNOSCING": "COGNOSCE, in Scots law, to examine; to give judgment on [v]\n",
  "COGNOVIT": "(Latin) in law, an acknowledgement by a defendant that the plaintiff's cause is just [n -S]\n",
  "COGNOVITS": "COGNOVIT, (Latin) in law, an acknowledgement by a defendant that the plaintiff's cause is just [n]\n",
  "COGON": "a kind of fast-growing Asian grass [n -S]\n",
  "COGONS": "COGON, a kind of fast-growing Asian grass [n]\n",
  "COGS": "COG, to cheat at dice [v]\n",
  "COGUE": "(Scots) a small wooden bowl, also COGGIE, COGIE [n -S]\n",
  "COGUES": "COGUE, (Scots) a small wooden bowl, also COGGIE, COGIE [n]\n",
  "COGWAY": "a railway operating on steep slopes [n -S]\n",
  "COGWAYS": "COGWAY, a railway operating on steep slopes [n]\n",
  "COGWHEEL": "a toothed wheel [n -S]\n",
  "COGWHEELS": "COGWHEEL, a toothed wheel [n]\n",
  "COHAB": "(short for) a cohabitor, one who cohabits [n -S]\n",
  "COHABIT": "to dwell together as husband and wife [v -ED, -ING, -S]\n",
  "COHABITANT": "one who dwells with another, or in the same place or country [n -S]\n",
  "COHABITANTS": "COHABITANT, one who dwells with another, or in the same place or country [n]\n",
  "COHABITATION": "the act of cohabiting [n -S]\n",
  "COHABITATIONS": "COHABITATION, the act of cohabiting [n]\n",
  "COHABITED": "COHABIT, to dwell together as husband and wife [v]\n",
  "COHABITEE": "one who is cohabited with [n -S]\n",
  "COHABITEES": "COHABITEE, one who is cohabited with [n]\n",
  "COHABITER": "one who cohabits, also COHABITOR [n -S]\n",
  "COHABITERS": "COHABITER, one who cohabits, also COHABITOR [n]\n",
  "COHABITING": "COHABIT, to dwell together as husband and wife [v]\n",
  "COHABITOR": "one who cohabits, also COHABITER [n -S]\n",
  "COHABITORS": "COHABITOR, one who cohabits, also COHABITER [n]\n",
  "COHABITS": "COHABIT, to dwell together as husband and wife [v]\n",
  "COHABS": "COHAB, (short for) a cohabitor, one who cohabits [n]\n",
  "COHEAD": "to head jointly [v -ED, -ING, -S]\n",
  "COHEADED": "COHEAD, to head jointly [v]\n",
  "COHEADING": "COHEAD, to head jointly [v]\n",
  "COHEADS": "COHEAD, to head jointly [v]\n",
  "COHEIR": "a joint heir [n -S]\n",
  "COHEIRESS": "a joint heiress [n -ES]\n",
  "COHEIRESSES": "COHEIRESS, a joint heiress [n]\n",
  "COHEIRS": "COHEIR, a joint heir [n]\n",
  "COHEN": "a member of the Jewish priestly class, descended from Aaron, having certain privileges and obligations in the synagogue, also KOHEN [n -S]\n",
  "COHENS": "COHEN, a member of the Jewish priestly class, descended from Aaron, having certain privileges and obligations in the synagogue, also KOHEN [n]\n",
  "COHERE": "to stick together [v COHERED, COHERING, COHERES]\n",
  "COHERED": "COHERE, to stick together [v]\n",
  "COHERENCE": "a tendency to cohere, also COHERENCY [n -S]\n",
  "COHERENCES": "COHERENCE, a tendency to cohere, also COHERENCY [n]\n",
  "COHERENCIES": "COHERENCY, a tendency to cohere; a sticking together, also COHERENCE [n]\n",
  "COHERENCY": "a tendency to cohere; a sticking together, also COHERENCE [n COHERENCIES]\n",
  "COHERENT": "sticking together [adj COHERENTLY]\n",
  "COHERENTLY": "COHERENT, sticking together [adv]\n",
  "COHERER": "a device used to detect radio waves [n -S]\n",
  "COHERERS": "COHERER, a device used to detect radio waves [n]\n",
  "COHERES": "COHERE, to stick together [v]\n",
  "COHERING": "COHERE, to stick together [v]\n",
  "COHERITOR": "a joint heir, also COHEIR [n -S]\n",
  "COHERITORS": "COHERITOR, a joint heir, also COHEIR [n]\n",
  "COHESIBILITIES": "COHESIBILITY, the quality of being cohesible [n]\n",
  "COHESIBILITY": "the quality of being cohesible [n COHESIBILITIES]\n",
  "COHESIBLE": "capable of cohesion [adj]\n",
  "COHESION": "the act of sticking together [n -S]\n",
  "COHESIONLESS": "without cohesion [adj]\n",
  "COHESIONS": "COHESION, the act of sticking together [n]\n",
  "COHESIVE": "having the power of cohering [adj]\n",
  "COHESIVELY": "COHESIVE, having the power of cohering [adv]\n",
  "COHESIVENESS": "the state of being cohesive [n -ES]\n",
  "COHESIVENESSES": "COHESIVENESS, the state of being cohesive [n]\n",
  "COHIBIT": "to restrain [v -ED, -ING, -S]\n",
  "COHIBITED": "COHIBIT, to restrain [v]\n",
  "COHIBITING": "COHIBIT, to restrain [v]\n",
  "COHIBITION": "hindrance; restraint [n -S]\n",
  "COHIBITIONS": "COHIBITION, hindrance; restraint [n]\n",
  "COHIBITIVE": "restraining [adj]\n",
  "COHIBITS": "COHIBIT, to restrain [v]\n",
  "COHO": "a Pacific salmon, also COHOE [n -S]\n",
  "COHOBATE": "to distill again [v COHOBATED, COHOBATING, COHOBATES]\n",
  "COHOBATED": "COHOBATE, to distill again [v]\n",
  "COHOBATES": "COHOBATE, to distill again [v]\n",
  "COHOBATING": "COHOBATE, to distill again [v]\n",
  "COHOE": "a Pacific salmon, also COHO [n -S]\n",
  "COHOES": "COHOE, a Pacific salmon, also COHO [n]\n",
  "COHOG": "(Native American) a kind of clam, also QUAHAUG, QUAHOG, QUOHOG [n -S]\n",
  "COHOGS": "COHOG, (Native American) a kind of clam, also QUAHAUG, QUAHOG, QUOHOG [n]\n",
  "COHOLDER": "an athlete who shares a record [n -S]\n",
  "COHOLDERS": "COHOLDER, an athlete who shares a record [n]\n",
  "COHOMOLOGICAL": "relating to cohomology [adj]\n",
  "COHOMOLOGIES": "COHOMOLOGY, a theory in topology which uses groups to study the properties of topological spaces [n]\n",
  "COHOMOLOGY": "a theory in topology which uses groups to study the properties of topological spaces [n COHOMOLOGIES]\n",
  "COHORN": "(Dutch) a small mortar for throwing grenades, also COEHORN [n -S]\n",
  "COHORNS": "COHORN, (Dutch) a small mortar for throwing grenades, also COEHORN [n]\n",
  "COHORT": "one of ten divisions of an ancient Roman legion [n -S]\n",
  "COHORTATIVE": "in Hebrew grammar, a lengthened form of the imperfect [n -S]\n",
  "COHORTATIVES": "COHORTATIVE, in Hebrew grammar, a lengthened form of the imperfect [n]\n",
  "COHORTS": "COHORT, one of ten divisions of an ancient Roman legion [n]\n",
  "COHOS": "COHO, a Pacific salmon, also COHOE [n]\n",
  "COHOSH": "a perennial American herb whose rootstock is used in medicine [n -ES]\n",
  "COHOSHES": "COHOSH, a perennial American herb whose rootstock is used in medicine [n]\n",
  "COHOST": "to host jointly [v -ED, -ING, -S]\n",
  "COHOSTED": "COHOST, to host jointly [v]\n",
  "COHOSTESS": "a joint hostess [n -ES] / to act as a joint hostess [v -ED, -ING, -ES]\n",
  "COHOSTESSED": "COHOSTESS, to act as a joint hostess [v]\n",
  "COHOSTESSES": "COHOSTESS, a joint hostess [n]\n",
  "COHOSTESSING": "COHOSTESS, to act as a joint hostess [v]\n",
  "COHOSTING": "COHOST, to host jointly [v]\n",
  "COHOSTS": "COHOST, to host jointly [v]\n",
  "COHOUSING": "a type of housing with some shared facilities [n -S]\n",
  "COHOUSINGS": "COHOUSING, a type of housing with some shared facilities [n]\n",
  "COHUNE": "(Spanish) a kind of South American palm tree, also CAHOUN [n -S]\n",
  "COHUNES": "COHUNE, (Spanish) a kind of South American palm tree, also CAHOUN [n]\n",
  "COHYPONYM": "a word which is one of two or more hyponyms of another word [n -S]\n",
  "COHYPONYMS": "COHYPONYM, a word which is one of two or more hyponyms of another word [n]\n",
  "COIF": "a covering for the head, especially the close-fitting cap of white lawn or silk originally worn by serjeants-at-law [n -S] / to put the hair into a coif, also QUOIF [v -ED, -ING, -S]\n",
  "COIFED": "COIF, to put the hair into a coif, also QUOIF [v]\n",
  "COIFFE": "to put the hair in a coif, also COIF, COIFFURE [v COIFFED, COIFFING, COIFFES]\n",
  "COIFFED": "COIFFE, to put the hair in a coif, also COIF, COIFFURE [v]\n",
  "COIFFES": "COIFFE, to put the hair in a coif, also COIF, COIFFURE [v]\n",
  "COIFFEUR": "(French) a male hairdresser [n -S]\n",
  "COIFFEURS": "COIFFEUR, (French) a male hairdresser [n]\n",
  "COIFFEUSE": "(French) a (female) hairdresser [n -S]\n",
  "COIFFEUSES": "COIFFEUSE, (French) a (female) hairdresser [n]\n",
  "COIFFING": "COIFFE, to put the hair in a coif, also COIF, COIFFURE [v]\n",
  "COIFFURE": "(French) to style the hair, also COIF, COIFFE [v COIFFURED, COIFFURING, COIFFURES]\n",
  "COIFFURED": "COIFFURE, (French) to style the hair, also COIF, COIFFE [v]\n",
  "COIFFURES": "COIFFURE, (French) to style the hair, also COIF, COIFFE [v]\n",
  "COIFFURING": "COIFFURE, (French) to style the hair, also COIF, COIFFE [v]\n",
  "COIFING": "COIF, to put the hair into a coif, also QUOIF [v]\n",
  "COIFS": "COIF, to put the hair into a coif, also QUOIF [v]\n",
  "COIGN": "to secure with a type of wedge, also COIGNE [v -ED, -ING, -S]\n",
  "COIGNE": "to secure with a type of wedge, also COIGN [v COIGNED, COIGNING, COIGNES]\n",
  "COIGNED": "COIGNE, to secure with a type of wedge, also COIGN [v]\n",
  "COIGNES": "COIGNE, to secure with a type of wedge, also COIGN [v]\n",
  "COIGNING": "COIGNE, to secure with a type of wedge, also COIGN [v]\n",
  "COIGNS": "COIGN, to secure with a type of wedge, also COIGNE [v]\n",
  "COIL": "to wind in even rings [v -ED, -ING, -S]\n",
  "COILABILITIES": "COILABILITY, the ability to form coils [n]\n",
  "COILABILITY": "the ability to form coils [n COILABILITIES]\n",
  "COILED": "COIL, to wind in even rings [v]\n",
  "COILER": "one who coils [n -S]\n",
  "COILERS": "COILER, one who coils [n]\n",
  "COILING": "COIL, to wind in even rings [v]\n",
  "COILS": "COIL, to wind in even rings [v]\n",
  "COIN": "to make metal currency [v -ED, -ING, -S]\n",
  "COINABLE": "able to be coined [adj]\n",
  "COINAGE": "the act of making coins [n -S]\n",
  "COINAGES": "COINAGE, the act of making coins [n]\n",
  "COINCIDE": "to be identical [v COINCIDED, COINCIDING, COINCIDES]\n",
  "COINCIDED": "COINCIDE, to be identical [v]\n",
  "COINCIDENCE": "the act or condition of coinciding, also COINCIDENCY [n -S]\n",
  "COINCIDENCES": "COINCIDENCE, the act or condition of coinciding, also COINCIDENCY [n]\n",
  "COINCIDENCIES": "COINCIDENCY, the act or condition of coinciding, also COINCIDENCE [n]\n",
  "COINCIDENCY": "the act or condition of coinciding, also COINCIDENCE [n COINCIDENCIES]\n",
  "COINCIDENT": "of similar nature [adj COINCIDENTLY]\n",
  "COINCIDENTAL": "resulting from a coincidence [adj COINCIDENTALLY]\n",
  "COINCIDENTALLY": "COINCIDENTAL, resulting from a coincidence [adv]\n",
  "COINCIDENTLY": "COINCIDENT, of similar nature [adv]\n",
  "COINCIDES": "COINCIDE, to be identical [v]\n",
  "COINCIDING": "COINCIDE, to be identical [v]\n",
  "COINED": "COIN, to make metal currency [v]\n",
  "COINER": "one who coins [n -S]\n",
  "COINERS": "COINER, one who coins [n]\n",
  "COINFECT": "to infect at the same time as another infection [v -ED, -ING, -S]\n",
  "COINFECTED": "COINFECT, to infect at the same time as another infection [v]\n",
  "COINFECTING": "COINFECT, to infect at the same time as another infection [v]\n",
  "COINFECTS": "COINFECT, to infect at the same time as another infection [v]\n",
  "COINFER": "to infer jointly [v COINFERRED, COINFERRING, COINFERS]\n",
  "COINFERRED": "COINFER, to infer jointly [v]\n",
  "COINFERRING": "COINFER, to infer jointly [v]\n",
  "COINFERS": "COINFER, to infer jointly [v]\n",
  "COINHERE": "to inhere jointly [v COINHERED, COINHERING, COINHERES]\n",
  "COINHERED": "COINHERE, to inhere jointly [v]\n",
  "COINHERENCE": "the act of coinhering [n -S]\n",
  "COINHERENCES": "COINHERENCE, the act of coinhering [n]\n",
  "COINHERES": "COINHERE, to inhere jointly [v]\n",
  "COINHERING": "COINHERE, to inhere jointly [v]\n",
  "COINHERITANCE": "a shared inheritance [n -S]\n",
  "COINHERITANCES": "COINHERITANCE, a shared inheritance [n]\n",
  "COINHERITOR": "a joint inheritor [n -S]\n",
  "COINHERITORS": "COINHERITOR, a joint inheritor [n]\n",
  "COINING": "a minting [n -S]\n",
  "COININGS": "COINING, a minting [n]\n",
  "COINMATE": "a fellow inmate [n -S]\n",
  "COINMATES": "COINMATE, a fellow inmate [n]\n",
  "COINOP": "operated by coin [adj]\n",
  "COINS": "COIN, to make metal currency [v]\n",
  "COINSTANTANEITY": "the state of being coinstantaneous [n]\n",
  "COINSTANTANEOUS": "simultaneous; at the same time [adj]\n",
  "COINSURANCE": "joint assumption of risk (as by two underwriters) with another [n -S]\n",
  "COINSURANCES": "COINSURANCE, joint assumption of risk (as by two underwriters) with another [n]\n",
  "COINSURE": "to insure with another [v COINSURED, COINSURING, COINSURES]\n",
  "COINSURED": "COINSURE, to insure with another [v]\n",
  "COINSURER": "one who insures jointly [n -S]\n",
  "COINSURERS": "COINSURER, one who insures jointly [n]\n",
  "COINSURES": "COINSURE, to insure with another [v]\n",
  "COINSURING": "COINSURE, to insure with another [v]\n",
  "COINTER": "to bury together [v COINTERRED, COINTERRING, COINTERS]\n",
  "COINTERRED": "COINTER, to bury together [v]\n",
  "COINTERRING": "COINTER, to bury together [v]\n",
  "COINTERS": "COINTER, to bury together [v]\n",
  "COINTREAU": "(tradename) a colourless liqueur with orange flavouring [n -S]\n",
  "COINTREAUS": "COINTREAU, (tradename) a colourless liqueur with orange flavouring [n]\n",
  "COINVENT": "to invent together [v -ED, -ING, -S]\n",
  "COINVENTED": "COINVENT, to invent together [v]\n",
  "COINVENTING": "COINVENT, to invent together [v]\n",
  "COINVENTOR": "a joint inventor [n -S]\n",
  "COINVENTORS": "COINVENTOR, a joint inventor [n]\n",
  "COINVENTS": "COINVENT, to invent together [v]\n",
  "COINVEST": "to invest jointly [v -ED, -ING, -S]\n",
  "COINVESTED": "COINVEST, to invest jointly [v]\n",
  "COINVESTIGATOR": "a joint investigator [n -S]\n",
  "COINVESTIGATORS": "COINVESTIGATOR, a joint investigator [n]\n",
  "COINVESTING": "COINVEST, to invest jointly [v]\n",
  "COINVESTOR": "a joint investor [n -S]\n",
  "COINVESTORS": "COINVESTOR, a joint investor [n]\n",
  "COINVESTS": "COINVEST, to invest jointly [v]\n",
  "COIR": "a fibre obtained from coconut husks, also KYAR [n -S]\n",
  "COIRS": "COIR, a fibre obtained from coconut husks, also KYAR [n]\n",
  "COISTREL": "(obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTRIL, COYSTREL, COYSTRIL, CUSTREL [n -S]\n",
  "COISTRELS": "COISTREL, (obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTRIL, COYSTREL, COYSTRIL, CUSTREL [n]\n",
  "COISTRIL": "(obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COYSTREL, COYSTRIL, CUSTREL [n -S]\n",
  "COISTRILS": "COISTRIL, (obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COYSTREL, COYSTRIL, CUSTREL [n]\n",
  "COIT": "(Australian slang) the buttocks, the backside [n -S]\n",
  "COITAL": "relating to coitus, also COITIONAL [adj COITALLY]\n",
  "COITALLY": "COITAL, relating to coitus, also COITIONAL [adv]\n",
  "COITION": "sexual intercourse, also COITUS [n -S]\n",
  "COITIONAL": "relating to coition, also COITAL [adj]\n",
  "COITIONS": "COITION, sexual intercourse, also COITUS [n]\n",
  "COITS": "COIT, (Australian slang) the buttocks, the backside [n]\n",
  "COITUS": "(Latin) sexual intercourse, also COITION [n -ES]\n",
  "COITUSES": "COITUS, (Latin) sexual intercourse, also COITION [n]\n",
  "COJOIN": "(Shakespeare) to conjoin [v -ED, -ING, -S]\n",
  "COJOINED": "COJOIN, (Shakespeare) to conjoin [v]\n",
  "COJOINING": "COJOIN, (Shakespeare) to conjoin [v]\n",
  "COJOINS": "COJOIN, (Shakespeare) to conjoin [v]\n",
  "COJONES": "(Spanish) bull's testicles; (figurative) courage, balls [n]\n",
  "COKE": "to change into a carbon fuel [v COKED, COKING, COKES]\n",
  "COKED": "COKE, to change into a carbon fuel [v]\n",
  "COKEHEAD": "a cocaine addict [n -S]\n",
  "COKEHEADS": "COKEHEAD, a cocaine addict [n]\n",
  "COKELIKE": "like coke [adj]\n",
  "COKERNUT": "the large, hard-shelled nut of the cocoa palm, also COCOANUT, COCONUT [n -S]\n",
  "COKERNUTS": "COKERNUT, the large, hard-shelled nut of the cocoa palm, also COCOANUT, COCONUT [n]\n",
  "COKES": "a simpleton [n -ES]\n",
  "COKESES": "COKES, a simpleton [n]\n",
  "COKIER": "COKY, like coke [adj]\n",
  "COKIEST": "COKY, like coke [adj]\n",
  "COKING": "the act of making into coke [n -S]\n",
  "COKINGS": "COKING, the act of making into coke [n]\n",
  "COKULORIS": "a palette with irregular holes, placed between lighting and camera to prevent glare [n -ES]\n",
  "COKULORISES": "COKULORIS, a palette with irregular holes, placed between lighting and camera to prevent glare [n]\n",
  "COKY": "like coke [adj COKIER, COKIEST]\n",
  "COL": "a pass in a mountain range [n -S]\n",
  "COLA": "a genus of West African trees producing nuts used in drugs and for flavouring soft drinks, also KOLA [n -S]\n",
  "COLANDER": "a perforated vessel used as a strainer in cookery, also CULLENDER [n -S]\n",
  "COLANDERS": "COLANDER, a perforated vessel used as a strainer in cookery, also CULLENDER [n]\n",
  "COLAS": "COLA, a genus of West African trees producing nuts used in drugs and for flavouring soft drinks, also KOLA [n]\n",
  "COLATITUDE": "the complement of the latitude, or the difference between any latitude and ninety degrees [n -S]\n",
  "COLATITUDES": "COLATITUDE, the complement of the latitude, or the difference between any latitude and ninety degrees [n]\n",
  "COLBIES": "COLBY, a type of mild-tasting hard cheese [n]\n",
  "COLBY": "a type of mild-tasting hard cheese [n COLBYS or COLBIES]\n",
  "COLBYS": "COLBY, a type of mild-tasting hard cheese [n]\n",
  "COLCANNON": "(Irish) an Irish country dish of potatoes and cabbage [n -S]\n",
  "COLCANNONS": "COLCANNON, (Irish) an Irish country dish of potatoes and cabbage [n]\n",
  "COLCHICA": "COLCHICUM, a flowering plant [n]\n",
  "COLCHICINE": "a toxic yellow alkaloid, present esp. in colchicum corms, which is used to treat gout [n -S]\n",
  "COLCHICINES": "COLCHICINE, a toxic yellow alkaloid, present esp. in colchicum corms, which is used to treat gout [n]\n",
  "COLCHICUM": "a flowering plant [n COLCHICUMS or COLCHICA]\n",
  "COLCHICUMS": "COLCHICUM, a flowering plant [n]\n",
  "COLCOTHAR": "(Arabic) a reddish brown oxide of iron, used in polishing glass [n -S]\n",
  "COLCOTHARS": "COLCOTHAR, (Arabic) a reddish brown oxide of iron, used in polishing glass [n]\n",
  "COLD": "a respiratory infection [n -S] / having no warmth [adj COLDER, COLDEST, COLDLY]\n",
  "COLDBLOOD": "a horse belonging to the heavy draught breeds [n -S]\n",
  "COLDBLOODS": "COLDBLOOD, a horse belonging to the heavy draught breeds [n]\n",
  "COLDCOCK": "to knock unconscious [v -ED, -ING, -S]\n",
  "COLDCOCKED": "COLDCOCK, to knock unconscious [v]\n",
  "COLDCOCKING": "COLDCOCK, to knock unconscious [v]\n",
  "COLDCOCKS": "COLDCOCK, to knock unconscious [v]\n",
  "COLDER": "COLD, having no warmth [adj]\n",
  "COLDEST": "COLD, having no warmth [adj]\n",
  "COLDHEARTED": "marked by lack of sympathy, interest, or sensitivity [adj COLDHEARTEDLY]\n",
  "COLDHEARTEDLY": "COLDHEARTED, marked by lack of sympathy, interest, or sensitivity [adv]\n",
  "COLDHEARTEDNESS": "COLDHEARTED, marked by lack of sympathy, interest, or sensitivity [n]\n",
  "COLDHOUSE": "a plant frame or greenhouse without artificial heat [n -S]\n",
  "COLDHOUSES": "COLDHOUSE, a plant frame or greenhouse without artificial heat [n]\n",
  "COLDIE": "(colloquial) a cold can or bottle of beer [n -S]\n",
  "COLDIES": "COLDIE, (colloquial) a cold can or bottle of beer [n]\n",
  "COLDISH": "somewhat cold [adj]\n",
  "COLDLY": "COLD, having no warmth [adv]\n",
  "COLDNESS": "the state of being cold [n -ES]\n",
  "COLDNESSES": "COLDNESS, the state of being cold [n]\n",
  "COLDS": "COLD, a respiratory infection [n]\n",
  "COLE": "a plant of the cabbage family, also COLESEED, COLEWORT [n -S]\n",
  "COLEAD": "to lead jointly [v COLED, COLEADING, COLEADS]\n",
  "COLEADER": "one who leads together with someone else [n -S]\n",
  "COLEADERS": "COLEADER, one who leads together with someone else [n]\n",
  "COLEADING": "COLEAD, to lead jointly [v]\n",
  "COLEADS": "COLEAD, to lead jointly [v]\n",
  "COLECTOMIES": "COLECTOMY, the surgical removal of the colon [n]\n",
  "COLECTOMY": "the surgical removal of the colon [n COLECTOMIES]\n",
  "COLED": "COLEAD, to lead jointly [v]\n",
  "COLEMANITE": "a hydrous borate of lime occurring in transparent colorless or white crystals [n -S]\n",
  "COLEMANITES": "COLEMANITE, a hydrous borate of lime occurring in transparent colorless or white crystals [n]\n",
  "COLEOPTER": "an aircraft that has an annular wing with the fuselage and engine on the centre line [n -S]\n",
  "COLEOPTERA": "COLEOPTERON, a large order of insects having the front wings modified as hard wing-cases, and comprising the beetles and weevils, also COLEOPTERAN [n]\n",
  "COLEOPTERAL": "of or like any member of the insect order Coleoptera [adj]\n",
  "COLEOPTERAN": "a large order of insects having the front wings modified as hard wing-cases, and comprising the beetles and weevils, also COLEOPTERON [n -S]\n",
  "COLEOPTERANS": "COLEOPTERAN, a large order of insects having the front wings modified as hard wing-cases, and comprising the beetles and weevils, also COLEOPTERON [n]\n",
  "COLEOPTERIST": "one who studies beetles [n -S]\n",
  "COLEOPTERISTS": "COLEOPTERIST, one who studies beetles [n]\n",
  "COLEOPTERON": "a large order of insects having the front wings modified as hard wing-cases, and comprising the beetles and weevils, also COLEOPTERAN [n COLEOPTERA or COLEOPTERONS]\n",
  "COLEOPTERONS": "COLEOPTERON, a large order of insects having the front wings modified as hard wing-cases, and comprising the beetles and weevils, also COLEOPTERAN [n]\n",
  "COLEOPTEROUS": "pertaining to beetles and weevils; having hard anterior wings [adj]\n",
  "COLEOPTERS": "COLEOPTER, an aircraft that has an annular wing with the fuselage and engine on the centre line [n]\n",
  "COLEOPTILE": "the first leaf in grasses and monocotyledons, a protecting plumule [n -S]\n",
  "COLEOPTILES": "COLEOPTILE, the first leaf in grasses and monocotyledons, a protecting plumule [n]\n",
  "COLEORHIZA": "a sheath in the embryo of grasses, inclosing the caulicle, also COLEORRHIZA [n COLEORHIZAE]\n",
  "COLEORHIZAE": "COLEORHIZA, a sheath in the embryo of grasses, inclosing the caulicle, also COLEORRHIZA [n]\n",
  "COLEORRHIZA": "a sheath in the embryo of grasses, inclosing the caulicle, also COLEORHIZA [n COLEORRHIZAE]\n",
  "COLEORRHIZAE": "COLEORRHIZA, a sheath in the embryo of grasses, inclosing the caulicle, also COLEORHIZA [n]\n",
  "COLES": "COLE, a plant of the cabbage family, also COLESEED, COLEWORT [n]\n",
  "COLESEED": "a plant of the cabbage family, also COLE, COLEWORT [n -S]\n",
  "COLESEEDS": "COLESEED, a plant of the cabbage family, also COLE, COLEWORT [n]\n",
  "COLESLAW": "(Dutch) a salad made of sliced cabbage [n -S]\n",
  "COLESLAWS": "COLESLAW, (Dutch) a salad made of sliced cabbage [n]\n",
  "COLESSEE": "a joint lessee [n -S]\n",
  "COLESSEES": "COLESSEE, a joint lessee [n]\n",
  "COLESSOR": "a joint lessor [n -S]\n",
  "COLESSORS": "COLESSOR, a joint lessor [n]\n",
  "COLESTIPOL": "a drug that reduces the level of cholesterol in the blood [n -S]\n",
  "COLESTIPOLS": "COLESTIPOL, a drug that reduces the level of cholesterol in the blood [n]\n",
  "COLETIT": "a bird of the tit family [n -S]\n",
  "COLETITS": "COLETIT, a bird of the tit family [n]\n",
  "COLEUS": "(Greek) a plant of the Mint family, cultivated for its bright-colored or variegated leaves [n -ES]\n",
  "COLEUSES": "COLEUS, (Greek) a plant of the Mint family, cultivated for its bright-colored or variegated leaves [n]\n",
  "COLEWORT": "a plant of the cabbage family, also COLE, COLESEED [n -S]\n",
  "COLEWORTS": "COLEWORT, a plant of the cabbage family, also COLE, COLESEED [n]\n",
  "COLEY": "an edible fish of the cod family [n -S]\n",
  "COLEYS": "COLEY, an edible fish of the cod family [n]\n",
  "COLIBRI": "(Spanish) a type of hummingbird [n -S]\n",
  "COLIBRIS": "COLIBRI, (Spanish) a type of hummingbird [n]\n",
  "COLIC": "severe abdominal pain [n -S]\n",
  "COLICIN": "an antibacterial substance, also COLICINE [n -S]\n",
  "COLICINE": "an antibacterial substance, also COLICIN [n -S]\n",
  "COLICINES": "COLICINE, an antibacterial substance, also COLICIN [n]\n",
  "COLICINS": "COLICIN, an antibacterial substance, also COLICINE [n]\n",
  "COLICKIER": "COLICKY, pertaining to, or troubled with, colic [adj]\n",
  "COLICKIEST": "COLICKY, pertaining to, or troubled with, colic [adj]\n",
  "COLICKY": "pertaining to, or troubled with, colic [adj COLICKIER, COLICKIEST]\n",
  "COLICROOT": "a herb of the bloodwort family, with small yellow or white flowers in a long spike [n -S]\n",
  "COLICROOTS": "COLICROOT, a herb of the bloodwort family, with small yellow or white flowers in a long spike [n]\n",
  "COLICS": "COLIC, severe abdominal pain [n]\n",
  "COLICWEED": "any of several weeds of genus Corydalis [n -S]\n",
  "COLICWEEDS": "COLICWEED, any of several weeds of genus Corydalis [n]\n",
  "COLIES": "COLY, an African bird [n]\n",
  "COLIFORM": "any of a group of rod-shaped bacteria typified by Escherichia coli [n -S]\n",
  "COLIFORMS": "COLIFORM, any of a group of rod-shaped bacteria typified by Escherichia coli [n]\n",
  "COLIN": "(Nahuatl) the American quail or bobwhite [n -S]\n",
  "COLINEAR": "lying in the same straight line [adj]\n",
  "COLINEARITIES": "COLINEARITY, the state of being colinear [n]\n",
  "COLINEARITY": "the state of being colinear [n COLINEARITIES]\n",
  "COLINS": "COLIN, (Nahuatl) the American quail or bobwhite [n]\n",
  "COLIPHAGE": "any bacteriophage active against E. coli [n -S]\n",
  "COLIPHAGES": "COLIPHAGE, any bacteriophage active against E. coli [n]\n",
  "COLISEUM": "(Latin) a large structure for public entertainment [n -S]\n",
  "COLISEUMS": "COLISEUM, (Latin) a large structure for public entertainment [n]\n",
  "COLISTIN": "a type of antibiotic [n -S]\n",
  "COLISTINS": "COLISTIN, a type of antibiotic [n]\n",
  "COLITIC": "of or like colitis, an inflammation of the large intestine [adj]\n",
  "COLITIS": "inflammation of the colon [n -ES]\n",
  "COLITISES": "COLITIS, inflammation of the colon [n]\n",
  "COLL": "(obsolete) to embrace, hug [v -ED, -ING, -S]\n",
  "COLLAB": "(short for) collaboration [n -S]\n",
  "COLLABORATE": "to work jointly with others or together esp. in an intellectual endeavor [v COLLABORATED, COLLABORATING, COLLABORATES]\n",
  "COLLABORATED": "COLLABORATE, to work jointly with others or together esp. in an intellectual endeavor [v]\n",
  "COLLABORATES": "COLLABORATE, to work jointly with others or together esp. in an intellectual endeavor [v]\n",
  "COLLABORATING": "COLLABORATE, to work jointly with others or together esp. in an intellectual endeavor [v]\n",
  "COLLABORATION": "the act of collaborating [n -S]\n",
  "COLLABORATIONS": "COLLABORATION, the act of collaborating [n]\n",
  "COLLABORATIVE": "of the nature of collaboration [adj COLLABORATIVELY] / a group of collaborators [n -S]\n",
  "COLLABORATIVELY": "COLLABORATIVE, of the nature of collaboration [adv]\n",
  "COLLABORATIVES": "COLLABORATIVE, a group of collaborators [n]\n",
  "COLLABORATOR": "one who collaborates [n -S]\n",
  "COLLABORATORS": "COLLABORATOR, one who collaborates [n]\n",
  "COLLABS": "COLLAB, (short for) collaboration [n]\n",
  "COLLAGE": "(French) to arrange materials in an artistic way [v COLLAGED, COLLAGING, COLLAGES]\n",
  "COLLAGED": "COLLAGE, (French) to arrange materials in an artistic way [v]\n",
  "COLLAGEN": "a fibrous protein that is the chief constituent of connective tissue and yields gelatin on boiling [n -S]\n",
  "COLLAGENASE": "any of a group of proteolytic enzymes that decompose collagen and gelatin [n -S]\n",
  "COLLAGENASES": "COLLAGENASE, any of a group of proteolytic enzymes that decompose collagen and gelatin [n]\n",
  "COLLAGENIC": "relating to collagen, also COLLAGENOUS [adj]\n",
  "COLLAGENOUS": "relating to collagen, also COLLAGENIC [adj]\n",
  "COLLAGENS": "COLLAGEN, a fibrous protein that is the chief constituent of connective tissue and yields gelatin on boiling [n]\n",
  "COLLAGES": "COLLAGE, (French) to arrange materials in an artistic way [v]\n",
  "COLLAGING": "COLLAGE, (French) to arrange materials in an artistic way [v]\n",
  "COLLAGIST": "one who makes collages [n -S]\n",
  "COLLAGISTS": "COLLAGIST, one who makes collages [n]\n",
  "COLLAPSABILITY": "the quality of being collapsable, also COLLAPSIBILITY [n]\n",
  "COLLAPSABLE": "that can be collapsed, also COLLAPSIBLE [adj]\n",
  "COLLAPSAR": "a black hole [n -S]\n",
  "COLLAPSARS": "COLLAPSAR, a black hole [n]\n",
  "COLLAPSE": "to crumble suddenly [v COLLAPSED, COLLAPSING, COLLAPSES]\n",
  "COLLAPSED": "COLLAPSE, to crumble suddenly [v]\n",
  "COLLAPSES": "COLLAPSE, to crumble suddenly [v]\n",
  "COLLAPSIBILITY": "the state of being collapsible, also COLLAPSABILITY [n]\n",
  "COLLAPSIBLE": "that can be collapsed, also COLLAPSABLE [adj]\n",
  "COLLAPSING": "COLLAPSE, to crumble suddenly [v]\n",
  "COLLAR": "to provide with a neckband [v -ED, -ING, -S]\n",
  "COLLARBONE": "the clavicle [n -S]\n",
  "COLLARBONES": "COLLARBONE, the clavicle [n]\n",
  "COLLARD": "pickled or salted meat rolled and cooked with herbs and spices [n -S]\n",
  "COLLARDS": "COLLARD, pickled or salted meat rolled and cooked with herbs and spices [n]\n",
  "COLLARED": "COLLAR, to provide with a neckband [v]\n",
  "COLLARET": "a small collar [n -S]\n",
  "COLLARETS": "COLLARET, a small collar [n]\n",
  "COLLARETTE": "(French) a small collar [n -S]\n",
  "COLLARETTES": "COLLARETTE, (French) a small collar [n]\n",
  "COLLARING": "COLLAR, to provide with a neckband [v]\n",
  "COLLARLESS": "without a collar [adj]\n",
  "COLLARS": "COLLAR, to provide with a neckband [v]\n",
  "COLLARSTUD": "a stud for fastening a collar [n -S]\n",
  "COLLARSTUDS": "COLLARSTUD, a stud for fastening a collar [n]\n",
  "COLLATABLE": "capable of being collated [adj]\n",
  "COLLATE": "to examine and compare [v COLLATED, COLLATING, COLLATES]\n",
  "COLLATED": "COLLATE, to examine and compare [v]\n",
  "COLLATERAL": "side by side [adj COLLATERALLY] / an asset providing collateral security [n -S]\n",
  "COLLATERALISE": "to make (a loan) secure with collateral, also COLLATERALIZE [v COLLATERALISED, COLLATERALISING, COLLATERALISES]\n",
  "COLLATERALISED": "COLLATERALISE, to make (a loan) secure with collateral, also COLLATERALIZE [v]\n",
  "COLLATERALISES": "COLLATERALISE, to make (a loan) secure with collateral, also COLLATERALIZE [v]\n",
  "COLLATERALISING": "COLLATERALISE, to make (a loan) secure with collateral, also COLLATERALIZE [v]\n",
  "COLLATERALITIES": "COLLATERALITY, the quality of being collateral [n]\n",
  "COLLATERALITY": "the quality of being collateral [n COLLATERALITIES]\n",
  "COLLATERALIZE": "to make (a loan) secure with collateral, also COLLATERALISE [v COLLATERALIZED, COLLATERALIZING, COLLATERALIZES]\n",
  "COLLATERALIZED": "COLLATERALIZE, to make (a loan) secure with collateral, also COLLATERALISE [v]\n",
  "COLLATERALIZES": "COLLATERALIZE, to make (a loan) secure with collateral, also COLLATERALISE [v]\n",
  "COLLATERALIZING": "COLLATERALIZE, to make (a loan) secure with collateral, also COLLATERALISE [v]\n",
  "COLLATERALLY": "COLLATERAL, side by side [adv]\n",
  "COLLATERALS": "COLLATERAL, an asset providing collateral security [n]\n",
  "COLLATES": "COLLATE, to examine and compare [v]\n",
  "COLLATING": "COLLATE, to examine and compare [v]\n",
  "COLLATION": "a light meal [n -S]\n",
  "COLLATIONS": "COLLATION, a light meal [n]\n",
  "COLLATIVE": "having the power of conferring; of livings where the bishop and patron are one and the same person [adj]\n",
  "COLLATOR": "one who collates manuscripts, books, etc. [n -S]\n",
  "COLLATORS": "COLLATOR, one who collates manuscripts, books, etc. [n]\n",
  "COLLEAGUE": "a fellow-worker [n -S] / (obsolete) to join in alliance, associate [v COLLEAGUED, COLLEAGUING, COLLEAGUES]\n",
  "COLLEAGUED": "COLLEAGUE, (obsolete) to join in alliance, associate [v]\n",
  "COLLEAGUES": "COLLEAGUE, (obsolete) to join in alliance, associate [v]\n",
  "COLLEAGUESHIP": "the state of being a colleague [n -S]\n",
  "COLLEAGUESHIPS": "COLLEAGUESHIP, the state of being a colleague [n]\n",
  "COLLEAGUING": "COLLEAGUE, (obsolete) to join in alliance, associate [v]\n",
  "COLLECT": "to bring together in a group [v -ED, -ING, -S]\n",
  "COLLECTABLE": "capable of being collected [adj] / something worth collecting, also COLLECTIBLE [n -S]\n",
  "COLLECTABLES": "COLLECTABLE, something worth collecting, also COLLECTIBLE [n]\n",
  "COLLECTANEA": "a collection of passages, a miscellany [n]\n",
  "COLLECTED": "COLLECT, to bring together in a group [v]\n",
  "COLLECTEDLY": "COLLECTED, COLLECT, to bring together in a group [adv]\n",
  "COLLECTEDNESS": "the state of being collected [n -ES]\n",
  "COLLECTEDNESSES": "COLLECTEDNESS, the state of being collected [n]\n",
  "COLLECTIBLE": "capable of being collected [adj] / something worth collecting, also COLLECTABLE [n -S]\n",
  "COLLECTIBLES": "COLLECTIBLE, something worth collecting, also COLLECTABLE [n]\n",
  "COLLECTING": "the act of making a collection [n -S]\n",
  "COLLECTINGS": "COLLECTING, the act of making a collection [n]\n",
  "COLLECTION": "the act of collecting [n -S]\n",
  "COLLECTIONS": "COLLECTION, the act of collecting [n]\n",
  "COLLECTIVE": "of the nature of a collection [adj COLLECTIVELY] / a collective body [n -S]\n",
  "COLLECTIVELY": "COLLECTIVE, of the nature of a collection [adv]\n",
  "COLLECTIVENESS": "the state of being collective [n]\n",
  "COLLECTIVES": "COLLECTIVE, a collective body [n]\n",
  "COLLECTIVISE": "to give a collectivist organization to, also COLLECTIVIZE [v COLLECTIVISED, COLLECTIVISING, COLLECTIVISES]\n",
  "COLLECTIVISED": "COLLECTIVISE, to give a collectivist organization to, also COLLECTIVIZE [v]\n",
  "COLLECTIVISES": "COLLECTIVISE, to give a collectivist organization to, also COLLECTIVIZE [v]\n",
  "COLLECTIVISING": "COLLECTIVISE, to give a collectivist organization to, also COLLECTIVIZE [v]\n",
  "COLLECTIVISM": "the doctrine of communal control of means of production [n -S]\n",
  "COLLECTIVISMS": "COLLECTIVISM, the doctrine of communal control of means of production [n]\n",
  "COLLECTIVIST": "a supporter of collectivism [n -S]\n",
  "COLLECTIVISTIC": "relating to collectivism [adj]\n",
  "COLLECTIVISTS": "COLLECTIVIST, a supporter of collectivism [n]\n",
  "COLLECTIVITIES": "COLLECTIVITY, the state of being collective [n]\n",
  "COLLECTIVITY": "the state of being collective [n COLLECTIVITIES]\n",
  "COLLECTIVIZE": "to give a collectivist organization to, also COLLECTIVISE [v COLLECTIVIZED, COLLECTIVIZING, COLLECTIVIZES]\n",
  "COLLECTIVIZED": "COLLECTIVIZE, to give a collectivist organization to, also COLLECTIVISE [v]\n",
  "COLLECTIVIZES": "COLLECTIVIZE, to give a collectivist organization to, also COLLECTIVISE [v]\n",
  "COLLECTIVIZING": "COLLECTIVIZE, to give a collectivist organization to, also COLLECTIVISE [v]\n",
  "COLLECTOR": "one who collects [n -S]\n",
  "COLLECTORATE": "the office of collector [n -S]\n",
  "COLLECTORATES": "COLLECTORATE, the office of collector [n]\n",
  "COLLECTORS": "COLLECTOR, one who collects [n]\n",
  "COLLECTORSHIP": "the office of collector [n -S]\n",
  "COLLECTORSHIPS": "COLLECTORSHIP, the office of collector [n]\n",
  "COLLECTS": "COLLECT, to bring together in a group [v]\n",
  "COLLED": "COLL, (obsolete) to embrace, hug [v]\n",
  "COLLEEN": "(Irish) an Irish girl [n -S]\n",
  "COLLEENS": "COLLEEN, (Irish) an Irish girl [n]\n",
  "COLLEGE": "a school of higher learning [n -S]\n",
  "COLLEGER": "a student supported by funds from his college [n -S]\n",
  "COLLEGERS": "COLLEGER, a student supported by funds from his college [n]\n",
  "COLLEGES": "COLLEGE, a school of higher learning [n]\n",
  "COLLEGIA": "COLLEGIUM, (Latin) a Soviet executive council [n]\n",
  "COLLEGIAL": "of or relating to a college [adj COLLEGIALLY]\n",
  "COLLEGIALISM": "the theory that the church is independent from the state [n -S]\n",
  "COLLEGIALISMS": "COLLEGIALISM, the theory that the church is independent from the state [n]\n",
  "COLLEGIALITIES": "COLLEGIALITY, the process of making decisions, taking actions etc. shared by all the bishops of a church [n]\n",
  "COLLEGIALITY": "the process of making decisions, taking actions etc. shared by all the bishops of a church [n COLLEGIALITIES]\n",
  "COLLEGIALLY": "COLLEGIAL, of or relating to a college [adv]\n",
  "COLLEGIAN": "a member or inhabitant of a college, also COLLEGIANER [n -S]\n",
  "COLLEGIANER": "a member or inhabitant of a college, also COLLEGIAN [n -S]\n",
  "COLLEGIANERS": "COLLEGIANER, a member or inhabitant of a college, also COLLEGIAN [n]\n",
  "COLLEGIANS": "COLLEGIAN, a member or inhabitant of a college, also COLLEGIANER [n]\n",
  "COLLEGIATE": "relating to a college [adj COLLEGIATELY] / an inmate of a prison [n -S]\n",
  "COLLEGIATELY": "COLLEGIATE, relating to a college [adv]\n",
  "COLLEGIATES": "COLLEGIATE, an inmate of a prison [n]\n",
  "COLLEGIUM": "(Latin) a Soviet executive council [n COLLEGIUMS or COLLEGIA]\n",
  "COLLEGIUMS": "COLLEGIUM, (Latin) a Soviet executive council [n]\n",
  "COLLEMBOLAN": "a springtail, any one of numerous species of small apterous insects belonging to the order Thysanura [n -S]\n",
  "COLLEMBOLANS": "COLLEMBOLAN, a springtail, any one of numerous species of small apterous insects belonging to the order Thysanura [n]\n",
  "COLLEMBOLOUS": "of or like a collembolan, a springtail [adj]\n",
  "COLLENCHYMA": "the supportive tissue of plants [n COLLENCHYMAS or COLLENCHYMATA]\n",
  "COLLENCHYMAS": "COLLENCHYMA, the supportive tissue of plants [n]\n",
  "COLLENCHYMATA": "COLLENCHYMA, the supportive tissue of plants [n]\n",
  "COLLENCHYMATOUS": "relating to collenchyma [adj]\n",
  "COLLET": "a circular flange or collar; the part of a ring that contains the stone [n -S] / to set a gem in a ring [v -ED, -ING, -S]\n",
  "COLLETED": "COLLET, to set a gem in a ring [v]\n",
  "COLLETERIAL": "as in colleterial gland, a glue-secreting organ found in insects [adj]\n",
  "COLLETING": "COLLET, to set a gem in a ring [v]\n",
  "COLLETS": "COLLET, to set a gem in a ring [v]\n",
  "COLLICULI": "COLLICULUS, a small elevation, as on the surface of the optic lobe of the brain [n]\n",
  "COLLICULUS": "a small elevation, as on the surface of the optic lobe of the brain [n COLLICULI]\n",
  "COLLIDE": "to clash together [v COLLIDED, COLLIDING, COLLIDES]\n",
  "COLLIDED": "COLLIDE, to clash together [v]\n",
  "COLLIDER": "a type of accelerator which causes subatomic particles to collide or be smashed together using electromagnets [n -S]\n",
  "COLLIDERS": "COLLIDER, a type of accelerator which causes subatomic particles to collide or be smashed together using electromagnets [n]\n",
  "COLLIDES": "COLLIDE, to clash together [v]\n",
  "COLLIDING": "COLLIDE, to clash together [v]\n",
  "COLLIE": "any of several breeds of dog developed for herding sheep and cattle [n -S]\n",
  "COLLIED": "COLLY, to blacken with coal dust [v]\n",
  "COLLIER": "a coal miner [n -S]\n",
  "COLLIERIES": "COLLIERY, the place where coal is dug; a coal mine, and the buildings, etc., belonging to it [n]\n",
  "COLLIERS": "COLLIER, a coal miner [n]\n",
  "COLLIERY": "the place where coal is dug; a coal mine, and the buildings, etc., belonging to it [n COLLIERIES]\n",
  "COLLIES": "COLLIE, any of several breeds of dog developed for herding sheep and cattle [n]\n",
  "COLLIESHANGIE": "(Scots) a squabble, brawl [n -S]\n",
  "COLLIESHANGIES": "COLLIESHANGIE, (Scots) a squabble, brawl [n]\n",
  "COLLIGATE": "to tie or bind together [v COLLIGATED, COLLIGATING, COLLIGATES]\n",
  "COLLIGATED": "COLLIGATE, to tie or bind together [v]\n",
  "COLLIGATES": "COLLIGATE, to tie or bind together [v]\n",
  "COLLIGATING": "COLLIGATE, to tie or bind together [v]\n",
  "COLLIGATION": "a bringing or binding together [n -S]\n",
  "COLLIGATIONS": "COLLIGATION, a bringing or binding together [n]\n",
  "COLLIGATIVE": "depending on the number of particles (as molecules) and not on the nature of the particles [adj]\n",
  "COLLIMATE": "to make parallel; to adjust accurately the line of sight of (an optical instrument, such as a surveying telescope) [v COLLIMATED, COLLIMATING, COLLIMATES]\n",
  "COLLIMATED": "COLLIMATE, to make parallel; to adjust accurately the line of sight of (an optical instrument, such as a surveying telescope) [v]\n",
  "COLLIMATES": "COLLIMATE, to make parallel; to adjust accurately the line of sight of (an optical instrument, such as a surveying telescope) [v]\n",
  "COLLIMATING": "COLLIMATE, to make parallel; to adjust accurately the line of sight of (an optical instrument, such as a surveying telescope) [v]\n",
  "COLLIMATION": "the act of making parallel [n -S]\n",
  "COLLIMATIONS": "COLLIMATION, the act of making parallel [n]\n",
  "COLLIMATOR": "a telescope arranged and used to determine errors of collimation, both vertical and horizontal [n -S]\n",
  "COLLIMATORS": "COLLIMATOR, a telescope arranged and used to determine errors of collimation, both vertical and horizontal [n]\n",
  "COLLINEAR": "in the same straight line, also COLINEAR [adj COLLINEARLY]\n",
  "COLLINEARITIES": "COLLINEARITY, the quality of being collinear [n]\n",
  "COLLINEARITY": "the quality of being collinear [n COLLINEARITIES]\n",
  "COLLINEARLY": "COLLINEAR, in the same straight line, also COLINEAR [adv]\n",
  "COLLING": "embracing [n -S]\n",
  "COLLINGS": "COLLING, embracing [n]\n",
  "COLLINS": "an alcoholic beverage [n -ES]\n",
  "COLLINSES": "COLLINS, an alcoholic beverage [n]\n",
  "COLLINSIA": "a North American plant of the scrophulariaceous genus Collinsia, having blue, white, or purple flowers [n -S]\n",
  "COLLINSIAS": "COLLINSIA, a North American plant of the scrophulariaceous genus Collinsia, having blue, white, or purple flowers [n]\n",
  "COLLIQUABLE": "(obsolete) melting, wasting, also COLLIQUANT [adj]\n",
  "COLLIQUANT": "(obsolete) melting, wasting, also COLLIQUABLE [adj]\n",
  "COLLIQUATE": "(obsolete) to melt, fuse [v COLLIQUATED, COLLIQUATING, COLLIQUATES]\n",
  "COLLIQUATED": "COLLIQUATE, (obsolete) to melt, fuse [v]\n",
  "COLLIQUATES": "COLLIQUATE, (obsolete) to melt, fuse [v]\n",
  "COLLIQUATING": "COLLIQUATE, (obsolete) to melt, fuse [v]\n",
  "COLLIQUATION": "the process of melting or wasting away [n -S]\n",
  "COLLIQUATIONS": "COLLIQUATION, the process of melting or wasting away [n]\n",
  "COLLIQUATIVE": "profuse in flow; wasting [adj]\n",
  "COLLIQUESCENCE": "readiness to liquefy [n -S]\n",
  "COLLIQUESCENCES": "COLLIQUESCENCE, readiness to liquefy [n]\n",
  "COLLISION": "the state of being struck together [n -S]\n",
  "COLLISIONAL": "relating to a collision [adj COLLISIONALLY]\n",
  "COLLISIONALLY": "COLLISIONAL, relating to a collision [adv]\n",
  "COLLISIONS": "COLLISION, the state of being struck together [n]\n",
  "COLLOCATE": "to place together [v COLLOCATED, COLLOCATING, COLLOCATES]\n",
  "COLLOCATED": "COLLOCATE, to place together [v]\n",
  "COLLOCATES": "COLLOCATE, to place together [v]\n",
  "COLLOCATING": "COLLOCATE, to place together [v]\n",
  "COLLOCATION": "the placing of things together [n -S]\n",
  "COLLOCATIONAL": "relating to collocation [adj]\n",
  "COLLOCATIONS": "COLLOCATION, the placing of things together [n]\n",
  "COLLOCUTOR": "one of the speakers in a dialogue [n -S]\n",
  "COLLOCUTORS": "COLLOCUTOR, one of the speakers in a dialogue [n]\n",
  "COLLOCUTORY": "of the nature of conversation or dialogue [adj]\n",
  "COLLODION": "a solution of pyroxylin in ether, used to apply a thin gummy film in photography and surgery, also COLLODIUM [n -S]\n",
  "COLLODIONS": "COLLODION, a solution of pyroxylin in ether, used to apply a thin gummy film in photography and surgery, also COLLODIUM [n]\n",
  "COLLODIUM": "a solution of pyroxylin in ether, used to apply a thin gummy film in photography and surgery, also COLLODION [n -S]\n",
  "COLLODIUMS": "COLLODIUM, a solution of pyroxylin in ether, used to apply a thin gummy film in photography and surgery, also COLLODION [n]\n",
  "COLLOGUE": "to converse confidentially; to conspire with [v COLLOGUED, COLLOGUING, COLLOGUES]\n",
  "COLLOGUED": "COLLOGUE, to converse confidentially; to conspire with [v]\n",
  "COLLOGUES": "COLLOGUE, to converse confidentially; to conspire with [v]\n",
  "COLLOGUING": "COLLOGUE, to converse confidentially; to conspire with [v]\n",
  "COLLOID": "a mixture between a solution and a fine suspension; a jellylike substance [n -S]\n",
  "COLLOIDAL": "pertaining to, or of the nature of, colloids [adj COLLOIDALLY]\n",
  "COLLOIDALITIES": "COLLOIDALITY, the state of being a colloid [n]\n",
  "COLLOIDALITY": "the state of being a colloid [n COLLOIDALITIES]\n",
  "COLLOIDALLY": "COLLOIDAL, pertaining to, or of the nature of, colloids [adv]\n",
  "COLLOIDS": "COLLOID, a mixture between a solution and a fine suspension; a jellylike substance [n]\n",
  "COLLOP": "a small portion of meat [n -S]\n",
  "COLLOPS": "COLLOP, a small portion of meat [n]\n",
  "COLLOQUE": "(French) to hold a colloquy [v COLLOQUED, COLLOQUING, COLLOQUES]\n",
  "COLLOQUED": "COLLOQUE, (French) to hold a colloquy [v]\n",
  "COLLOQUES": "COLLOQUE, (French) to hold a colloquy [v]\n",
  "COLLOQUIA": "COLLOQUIUM, (Latin) a conference, a seminar [n]\n",
  "COLLOQUIAL": "of or relating to conversation [adj COLLOQUIALLY] / a conversation [n -S]\n",
  "COLLOQUIALISM": "a colloquial expression [n -S]\n",
  "COLLOQUIALISMS": "COLLOQUIALISM, a colloquial expression [n]\n",
  "COLLOQUIALIST": "one who uses colloquialisms [n -S]\n",
  "COLLOQUIALISTS": "COLLOQUIALIST, one who uses colloquialisms [n]\n",
  "COLLOQUIALITIES": "COLLOQUIALITY, the quality of being colloquial [n]\n",
  "COLLOQUIALITY": "the quality of being colloquial [n COLLOQUIALITIES]\n",
  "COLLOQUIALLY": "COLLOQUIAL, of or relating to conversation [adv]\n",
  "COLLOQUIALNESS": "the quality of being colloquial [n]\n",
  "COLLOQUIALS": "COLLOQUIAL, a conversation [n]\n",
  "COLLOQUIED": "COLLOQUY, to hold a colloquy [v]\n",
  "COLLOQUIES": "COLLOQUY, to hold a colloquy [v]\n",
  "COLLOQUING": "COLLOQUE, (French) to hold a colloquy [v]\n",
  "COLLOQUISE": "to converse, also COLLOQUIZE [v COLLOQUISED, COLLOQUISING, COLLOQUISES]\n",
  "COLLOQUISED": "COLLOQUISE, to converse, also COLLOQUIZE [v]\n",
  "COLLOQUISES": "COLLOQUISE, to converse, also COLLOQUIZE [v]\n",
  "COLLOQUISING": "COLLOQUISE, to converse, also COLLOQUIZE [v]\n",
  "COLLOQUIST": "a speaker in a colloquy or dialogue [n -S]\n",
  "COLLOQUISTS": "COLLOQUIST, a speaker in a colloquy or dialogue [n]\n",
  "COLLOQUIUM": "(Latin) a conference, a seminar [n COLLOQUIA or COLLOQUIUMS]\n",
  "COLLOQUIUMS": "COLLOQUIUM, (Latin) a conference, a seminar [n]\n",
  "COLLOQUIZE": "to converse, also COLLOQUISE [v COLLOQUIZED, COLLOQUIZING, COLLOQUIZES]\n",
  "COLLOQUIZED": "COLLOQUIZE, to converse, also COLLOQUISE [v]\n",
  "COLLOQUIZES": "COLLOQUIZE, to converse, also COLLOQUISE [v]\n",
  "COLLOQUIZING": "COLLOQUIZE, to converse, also COLLOQUISE [v]\n",
  "COLLOQUY": "speaking together; mutual discourse [n COLLOQUIES] / to hold a colloquy [v COLLOQUIED, COLLOQUYING, COLLOQUIES]\n",
  "COLLOQUYING": "COLLOQUY, to hold a colloquy [v]\n",
  "COLLOTYPE": "a method of printing illustrations from hardened gelatin film [n -S]\n",
  "COLLOTYPES": "COLLOTYPE, a method of printing illustrations from hardened gelatin film [n]\n",
  "COLLOTYPIC": "relating to collotypy, a method of printing illustrations from hardened gelatin film [adj]\n",
  "COLLOTYPIES": "COLLOTYPY, printing by collotype, a method of printing illustrations from hardened gelatin film [n]\n",
  "COLLOTYPY": "printing by collotype, a method of printing illustrations from hardened gelatin film [n COLLOTYPIES]\n",
  "COLLS": "COLL, (obsolete) to embrace, hug [v]\n",
  "COLLUCTATION": "(archaic) strife, conflict [n -S]\n",
  "COLLUCTATIONS": "COLLUCTATION, (archaic) strife, conflict [n]\n",
  "COLLUDE": "to conspire [v COLLUDED, COLLUDING, COLLUDES]\n",
  "COLLUDED": "COLLUDE, to conspire [v]\n",
  "COLLUDER": "one who conspires in a fraud [n -S]\n",
  "COLLUDERS": "COLLUDER, one who conspires in a fraud [n]\n",
  "COLLUDES": "COLLUDE, to conspire [v]\n",
  "COLLUDING": "COLLUDE, to conspire [v]\n",
  "COLLUSION": "a secret agreement to deceive, e.g. one made between the opposing parties in a lawsuit [n -S]\n",
  "COLLUSIONS": "COLLUSION, a secret agreement to deceive, e.g. one made between the opposing parties in a lawsuit [n]\n",
  "COLLUSIVE": "characterized by collusion [adj COLLUSIVELY]\n",
  "COLLUSIVELY": "COLLUSIVE, characterized by collusion [adv]\n",
  "COLLUVIA": "COLLUVIUM, (Latin) material which accumulates at the foot of a steep slope [n]\n",
  "COLLUVIAL": "pertaining to a colluvies, mass of filth [adj]\n",
  "COLLUVIES": "(Latin) accumulated filth; foul discharge [n COLLUVIES]\n",
  "COLLUVIUM": "(Latin) material which accumulates at the foot of a steep slope [n COLLUVIA or COLLUVIUMS]\n",
  "COLLUVIUMS": "COLLUVIUM, (Latin) material which accumulates at the foot of a steep slope [n]\n",
  "COLLY": "to blacken with coal dust [v COLLIED, COLLYING, COLLIES]\n",
  "COLLYING": "COLLY, to blacken with coal dust [v]\n",
  "COLLYRIA": "COLLYRIUM, (Greek) an eye lotion [n]\n",
  "COLLYRIUM": "(Greek) an eye lotion [n COLLYRIUMS or COLLYRIA]\n",
  "COLLYRIUMS": "COLLYRIUM, (Greek) an eye lotion [n]\n",
  "COLLYWOBBLES": "bellyache [n]\n",
  "COLOBI": "COLOBUS, (Greek) a long-tailed monkey [n]\n",
  "COLOBID": "the colobus monkey [n -S]\n",
  "COLOBIDS": "COLOBID, the colobus monkey [n]\n",
  "COLOBOMA": "a lesion of the eye [n COLOBOMAS or COLOBOMATA]\n",
  "COLOBOMAS": "COLOBOMA, a lesion of the eye [n]\n",
  "COLOBOMATA": "COLOBOMA, a lesion of the eye [n]\n",
  "COLOBUS": "(Greek) a long-tailed monkey [n COLOBUSES or COLOBI]\n",
  "COLOBUSES": "COLOBUS, (Greek) a long-tailed monkey [n]\n",
  "COLOCATE": "to group housing units together [v COLOCATED, COLOCATING, COLOCATES]\n",
  "COLOCATED": "COLOCATE, to group housing units together [v]\n",
  "COLOCATES": "COLOCATE, to group housing units together [v]\n",
  "COLOCATING": "COLOCATE, to group housing units together [v]\n",
  "COLOCYNTH": "(Greek) a cucurbitaceous plant with bitter-tasting gourds, also COLOQUINTIDA [n -S]\n",
  "COLOCYNTHS": "COLOCYNTH, (Greek) a cucurbitaceous plant with bitter-tasting gourds, also COLOQUINTIDA [n]\n",
  "COLOG": "(short for) cologarithm, the logarithm of the reciprocal of a number [n -S]\n",
  "COLOGARITHM": "the logarithm of the reciprocal of a number [n -S]\n",
  "COLOGARITHMS": "COLOGARITHM, the logarithm of the reciprocal of a number [n]\n",
  "COLOGNE": "(French) a perfumed mixture of alcohol and essential oils, first made at Cologne [n -S]\n",
  "COLOGNED": "perfumed with cologne [adj]\n",
  "COLOGNES": "COLOGNE, (French) a perfumed mixture of alcohol and essential oils, first made at Cologne [n]\n",
  "COLOGS": "COLOG, (short for) cologarithm, the logarithm of the reciprocal of a number [n]\n",
  "COLOMBARD": "a kind of grape used to make wine [n -S]\n",
  "COLOMBARDS": "COLOMBARD, a kind of grape used to make wine [n]\n",
  "COLON": "a section of the large intestine [n -S] / a monetary unit of Costa Rica [n COLONS or COLONES]\n",
  "COLONE": "(Spanish) a monetary unit of Costa Rica, also COLON [n -S]\n",
  "COLONEL": "a military officer [n -S]\n",
  "COLONELCIES": "COLONELCY, the office, rank, or commission of a colonel [n]\n",
  "COLONELCY": "the office, rank, or commission of a colonel [n COLONELCIES]\n",
  "COLONELLING": "(archaic) playing the colonel [n -S]\n",
  "COLONELLINGS": "COLONELLING, (archaic) playing the colonel [n]\n",
  "COLONELS": "COLONEL, a military officer [n]\n",
  "COLONELSHIP": "the office of colonel [n -S]\n",
  "COLONELSHIPS": "COLONELSHIP, the office of colonel [n]\n",
  "COLONES": "COLONE, (Spanish) a monetary unit of Costa Rica, also COLON [n]\n",
  "COLONI": "COLONUS, (Latin) a freeborn serf [n]\n",
  "COLONIAL": "belong to a colony [adj COLONIALLY] / a member of a colony [n -S]\n",
  "COLONIALISE": "to make colonial, also COLONIALIZE [v COLONIALISED, COLONIALISING, COLONIALISES]\n",
  "COLONIALISED": "COLONIALISE, to make colonial, also COLONIALIZE [v]\n",
  "COLONIALISES": "COLONIALISE, to make colonial, also COLONIALIZE [v]\n",
  "COLONIALISING": "COLONIALISE, to make colonial, also COLONIALIZE [v]\n",
  "COLONIALISM": "the system by which one country controls and dominates a subordinate territory politically and economically [n -S]\n",
  "COLONIALISMS": "COLONIALISM, the system by which one country controls and dominates a subordinate territory politically and economically [n]\n",
  "COLONIALIST": "an adherent of colonialism [n -S]\n",
  "COLONIALISTIC": "relating to colonialism [adj]\n",
  "COLONIALISTS": "COLONIALIST, an adherent of colonialism [n]\n",
  "COLONIALIZE": "to make colonial, also COLONIALISE [v COLONIALIZED, COLONIALIZING, COLONIALIZES]\n",
  "COLONIALIZED": "COLONIALIZE, to make colonial, also COLONIALISE [v]\n",
  "COLONIALIZES": "COLONIALIZE, to make colonial, also COLONIALISE [v]\n",
  "COLONIALIZING": "COLONIALIZE, to make colonial, also COLONIALISE [v]\n",
  "COLONIALLY": "COLONIAL, belong to a colony [adv]\n",
  "COLONIALNESS": "the state of being colonial [n -ES]\n",
  "COLONIALNESSES": "COLONIALNESS, the state of being colonial [n]\n",
  "COLONIALS": "COLONIAL, a member of a colony [n]\n",
  "COLONIC": "irrigation of the colon [n -S]\n",
  "COLONICS": "COLONIC, irrigation of the colon [n]\n",
  "COLONIES": "COLONY, a settlement of emigrants in a new land [n]\n",
  "COLONISABLE": "able to be colonised, also COLONIZABLE [adj]\n",
  "COLONISATION": "the act of colonising, also COLONIZATION [n -S]\n",
  "COLONISATIONIST": "an advocate of colonization, also COLONIZATIONIST [n]\n",
  "COLONISATIONS": "COLONISATION, the act of colonising, also COLONIZATION [n]\n",
  "COLONISE": "to establish a colony, also COLONIZE [v COLONISED, COLONISING, COLONISES]\n",
  "COLONISED": "COLONISE, to establish a colony, also COLONIZE [v]\n",
  "COLONISER": "one who colonises, also COLONIZER [n -S]\n",
  "COLONISERS": "COLONISER, one who colonises, also COLONIZER [n]\n",
  "COLONISES": "COLONISE, to establish a colony, also COLONIZE [v]\n",
  "COLONISING": "COLONISE, to establish a colony, also COLONIZE [v]\n",
  "COLONIST": "one who settles a colony [n -S]\n",
  "COLONISTS": "COLONIST, one who settles a colony [n]\n",
  "COLONITIS": "an inflammation of the large intestine, esp. of its mucous membrane, also COLITIS [n -ES]\n",
  "COLONITISES": "COLONITIS, an inflammation of the large intestine, esp. of its mucous membrane, also COLITIS [n]\n",
  "COLONIZABLE": "able to be colonised, also COLONISABLE [adj]\n",
  "COLONIZATION": "the act of colonizing, also COLONISATION [n -S]\n",
  "COLONIZATIONIST": "an advocate of colonization, also COLONISATIONIST [n]\n",
  "COLONIZATIONS": "COLONIZATION, the act of colonizing, also COLONISATION [n]\n",
  "COLONIZE": "to establish a colony, also COLONISE [v COLONIZED, COLONIZING, COLONIZES]\n",
  "COLONIZED": "COLONIZE, to establish a colony, also COLONISE [v]\n",
  "COLONIZER": "one who colonizes, also COLONISER [n -S]\n",
  "COLONIZERS": "COLONIZER, one who colonizes, also COLONISER [n]\n",
  "COLONIZES": "COLONIZE, to establish a colony, also COLONISE [v]\n",
  "COLONIZING": "COLONIZE, to establish a colony, also COLONISE [v]\n",
  "COLONNADE": "a row of evenly spaced column or trees [n -S]\n",
  "COLONNADED": "having a colonnade [adj]\n",
  "COLONNADES": "COLONNADE, a row of evenly spaced column or trees [n]\n",
  "COLONOSCOPE": "a flexible viewing instrument passed into the colon through the anus [n -S]\n",
  "COLONOSCOPES": "COLONOSCOPE, a flexible viewing instrument passed into the colon through the anus [n]\n",
  "COLONOSCOPIES": "COLONOSCOPY, examination of the inside of the colon using a colonoscope, a flexible viewing instrument passed into the colon through the anus [n]\n",
  "COLONOSCOPY": "examination of the inside of the colon using a colonoscope, a flexible viewing instrument passed into the colon through the anus [n COLONOSCOPIES]\n",
  "COLONS": "COLON, a section of the large intestine [n]\n",
  "COLONUS": "(Latin) a freeborn serf [n COLONI]\n",
  "COLONY": "a settlement of emigrants in a new land [n COLONIES]\n",
  "COLOPHON": "an inscription placed at the end of book giving details of publication, or a publisher's logo [n -S]\n",
  "COLOPHONIES": "COLOPHONY, rosin [n]\n",
  "COLOPHONS": "COLOPHON, an inscription placed at the end of book giving details of publication, or a publisher's logo [n]\n",
  "COLOPHONY": "rosin [n COLOPHONIES]\n",
  "COLOQUINTIDA": "(Greek) a cucurbitaceous plant with bitter-tasting gourds, also COLOCYNTH [n -S]\n",
  "COLOQUINTIDAS": "COLOQUINTIDA, (Greek) a cucurbitaceous plant with bitter-tasting gourds, also COLOCYNTH [n]\n",
  "COLOR": "(US) to paint, also COLOUR [v -ED, -ING, -S]\n",
  "COLORABILITIES": "COLORABILITY, the quality of being colorable, also COLOURABILITY [n]\n",
  "COLORABILITY": "the quality of being colorable, also COLOURABILITY [n COLORABILITIES]\n",
  "COLORABLE": "that can be coloured, also COLOURABLE [adj COLORABLY]\n",
  "COLORABLENESS": "the state of being colourable, also COLOURABLENESS [n -ES]\n",
  "COLORABLENESSES": "COLORABLENESS, the state of being colourable, also COLOURABLENESS [n]\n",
  "COLORABLY": "COLORABLE, that can be coloured, also COLOURABLE [adv]\n",
  "COLORADO": "referring to a medium strength of cigar [adj]\n",
  "COLORANT": "a pigment or dye [n -S]\n",
  "COLORANTS": "COLORANT, a pigment or dye [n]\n",
  "COLORATION": "the act of coloring; the state of being colored, also COLOURATION [n -S]\n",
  "COLORATIONS": "COLORATION, the act of coloring; the state of being colored, also COLOURATION [n]\n",
  "COLORATURA": "(Italian) a highly ornamented, virtuoso (musical passage); a singer, esp. soprano, of such music, also COLORATURE [n -S]\n",
  "COLORATURAS": "COLORATURA, (Italian) a highly ornamented, virtuoso (musical passage); a singer, esp. soprano, of such music, also COLORATURE [n]\n",
  "COLORATURE": "a highly ornamented, virtuoso (musical passage); a singer, esp. soprano, of such music, also COLORATURA [n -S]\n",
  "COLORATURES": "COLORATURE, a highly ornamented, virtuoso (musical passage); a singer, esp. soprano, of such music, also COLORATURA [n]\n",
  "COLORBRED": "selectively bred for the development of certain colours [adj]\n",
  "COLORBREED": "to breed plants or animals selectively for the production of new varieties having a specific color or shade, also COLOURBREED [v COLORBRED, COLORBREEDING, COLORBREEDS]\n",
  "COLORBREEDING": "COLORBREED, to breed plants or animals selectively for the production of new varieties having a specific color or shade, also COLOURBREED [v]\n",
  "COLORBREEDS": "COLORBREED, to breed plants or animals selectively for the production of new varieties having a specific color or shade, also COLOURBREED [v]\n",
  "COLORCAST": "to broadcast in colour, also COLOURCAST [v COLORCAST, COLORCASTING, COLORCASTS]\n",
  "COLORCASTED": "COLORCAST, to broadcast in colour, also COLOURCAST [v]\n",
  "COLORCASTING": "COLORCAST, to broadcast in colour, also COLOURCAST [v]\n",
  "COLORCASTS": "COLORCAST, to broadcast in colour, also COLOURCAST [v]\n",
  "COLORECTAL": "relating to the colon and rectum [adj]\n",
  "COLORED": "a colored person [n -S]\n",
  "COLOREDS": "COLORED, a colored person [n]\n",
  "COLORER": "one that colors, also COLOURER [n -S]\n",
  "COLORERS": "COLORER, one that colors, also COLOURER [n]\n",
  "COLORFAST": "having colours that retain their original hue without running or fading, also COLOURFAST [adj]\n",
  "COLORFASTNESS": "COLORFAST, having colours that retain their original hue without running or fading, also COLOURFAST [n]\n",
  "COLORFASTNESSES": "COLORFASTNESS, COLORFAST, having colours that retain their original hue without running or fading, also COLOURFAST [n]\n",
  "COLORFUL": "full of color, also COLOURFUL [adj]\n",
  "COLORFULLY": "COLORFUL, full of color, also COLOURFUL [adv]\n",
  "COLORFULNESS": "the state of being colorful [n -ES]\n",
  "COLORFULNESSES": "COLORFULNESS, the state of being colorful [n]\n",
  "COLORIER": "COLORY, full of color, also COLOURY [adj]\n",
  "COLORIEST": "COLORY, full of color, also COLOURY [adj]\n",
  "COLORIFIC": "producing colours [adj]\n",
  "COLORIMETER": "an instrument for measuring and determining color [n -S]\n",
  "COLORIMETERS": "COLORIMETER, an instrument for measuring and determining color [n]\n",
  "COLORIMETRIC": "relating to colorimetry, also COLORIMETRICAL [adj]\n",
  "COLORIMETRICAL": "relating to colorimetry, also COLORIMETRIC [adj]\n",
  "COLORIMETRIES": "COLORIMETRY, measurement by colorimeter [n]\n",
  "COLORIMETRY": "measurement by colorimeter [n COLORIMETRIES]\n",
  "COLORING": "appearance in regard to color [n -S]\n",
  "COLORINGS": "COLORING, appearance in regard to color [n]\n",
  "COLORISATION": "the act of colorising, also COLORIZATION, COLOURISATION, COLOURIZATION [n -S]\n",
  "COLORISATIONS": "COLORISATION, the act of colorising, also COLORIZATION, COLOURISATION, COLOURIZATION [n]\n",
  "COLORISE": "to add colour with a computer, also COLORIZE, COLOURISE, COLOURIZE [v COLORISED, COLORISING, COLORISES]\n",
  "COLORISED": "COLORISE, to add colour with a computer, also COLORIZE, COLOURISE, COLOURIZE [v]\n",
  "COLORISER": "one who colorises, also COLORIZER, COLOURISER, COLOURIZER [n -S]\n",
  "COLORISERS": "COLORISER, one who colorises, also COLORIZER, COLOURISER, COLOURIZER [n]\n",
  "COLORISES": "COLORISE, to add colour with a computer, also COLORIZE, COLOURISE, COLOURIZE [v]\n",
  "COLORISING": "COLORISE, to add colour with a computer, also COLORIZE, COLOURISE, COLOURIZE [v]\n",
  "COLORISM": "coloring, also COLOURISM [n -S]\n",
  "COLORISMS": "COLORISM, coloring, also COLOURISM [n]\n",
  "COLORIST": "a person skilled in the use of color [n -S]\n",
  "COLORISTIC": "relating to a colorist, one who deals with color [adj COLORISTICALLY]\n",
  "COLORISTICALLY": "COLORISTIC, relating to a colorist, one who deals with color [adv]\n",
  "COLORISTS": "COLORIST, a person skilled in the use of color [n]\n",
  "COLORIZATION": "the act of colorizing, also COLORISATION, COLOURISATION, COLOURIZATION [n -S]\n",
  "COLORIZATIONS": "COLORIZATION, the act of colorizing, also COLORISATION, COLOURISATION, COLOURIZATION [n]\n",
  "COLORIZE": "to add colour with a computer, also COLORISE, COLOURISE, COLOURIZE [v COLORIZED, COLORIZING, COLORIZES]\n",
  "COLORIZED": "COLORIZE, to add colour with a computer, also COLORISE, COLOURISE, COLOURIZE [v]\n",
  "COLORIZER": "one who colorises, also COLORISER, COLOURISER, COLOURIZER [n -S]\n",
  "COLORIZERS": "COLORIZER, one who colorises, also COLORISER, COLOURISER, COLOURIZER [n]\n",
  "COLORIZES": "COLORIZE, to add colour with a computer, also COLORISE, COLOURISE, COLOURIZE [v]\n",
  "COLORIZING": "COLORIZE, to add colour with a computer, also COLORISE, COLOURISE, COLOURIZE [v]\n",
  "COLORLESS": "(US) without color, also COLOURLESS [adj COLORLESSLY]\n",
  "COLORLESSLY": "COLORLESS, (US) without color, also COLOURLESS [adv]\n",
  "COLORLESSNESS": "COLORLESS, (US) without color, also COLOURLESS [n]\n",
  "COLORLESSNESSES": "COLORLESSNESS, COLORLESS, (US) without color, also COLOURLESS [n]\n",
  "COLORMAN": "a sportscaster who comments during the game [n COLORMEN]\n",
  "COLORMEN": "COLORMAN, a sportscaster who comments during the game [n]\n",
  "COLORPOINT": "a breed of domestic cat, also COLOURPOINT [n -S]\n",
  "COLORPOINTS": "COLORPOINT, a breed of domestic cat, also COLOURPOINT [n]\n",
  "COLORS": "COLOR, (US) to paint, also COLOUR [v]\n",
  "COLORWASH": "a cheap form of distemper [n -ES] / to paint with this, also COLOURWASH [v -ED, -ING, -ES]\n",
  "COLORWASHED": "COLORWASH, to paint with this, also COLOURWASH [v]\n",
  "COLORWASHES": "COLORWASH, to paint with this, also COLOURWASH [v]\n",
  "COLORWASHING": "COLORWASH, to paint with this, also COLOURWASH [v]\n",
  "COLORWAY": "an arrangement of colors [n -S]\n",
  "COLORWAYS": "COLORWAY, an arrangement of colors [n]\n",
  "COLORY": "full of color, also COLOURY [adj COLORIER, COLORIEST]\n",
  "COLOSSAL": "of enormous size [adj COLOSSALLY]\n",
  "COLOSSALLY": "COLOSSAL, of enormous size [adv]\n",
  "COLOSSEUM": "a large building or stadium used as a place of entertainment, also COLISEUM [n -S]\n",
  "COLOSSEUMS": "COLOSSEUM, a large building or stadium used as a place of entertainment, also COLISEUM [n]\n",
  "COLOSSI": "COLOSSUS, (Latin) a person or organization of gigantic power and influence [n]\n",
  "COLOSSUS": "(Latin) a person or organization of gigantic power and influence [n COLOSSUSES or COLOSSI]\n",
  "COLOSSUSES": "COLOSSUS, (Latin) a person or organization of gigantic power and influence [n]\n",
  "COLOSTOMIES": "COLOSTOMY, a surgical incision in the colon to provide an artificial anus through the abdominal wall in cases of stricture etc. [n]\n",
  "COLOSTOMY": "a surgical incision in the colon to provide an artificial anus through the abdominal wall in cases of stricture etc. [n COLOSTOMIES]\n",
  "COLOSTRAL": "relating to colostrum, also COLOSTRIC, COLOSTROUS [adj]\n",
  "COLOSTRIC": "relating to colostrum, also COLOSTRAL, COLOSTROUS [adj]\n",
  "COLOSTROUS": "relating to colostrum, also COLOSTRAL, COLOSTRIC [adj]\n",
  "COLOSTRUM": "(Latin) milk secreted for a few days after parturition, characterised by high protein and antibody content [n -S]\n",
  "COLOSTRUMS": "COLOSTRUM, (Latin) milk secreted for a few days after parturition, characterised by high protein and antibody content [n]\n",
  "COLOTOMIES": "COLOTOMY, a surgical incision of the colon [n]\n",
  "COLOTOMY": "a surgical incision of the colon [n COLOTOMIES]\n",
  "COLOUR": "to paint, also COLOR [v -ED, -ING, -S]\n",
  "COLOURABILITIES": "COLOURABILITY, the quality of being colourable, also COLORABILITY [n]\n",
  "COLOURABILITY": "the quality of being colourable, also COLORABILITY [n COLOURABILITIES]\n",
  "COLOURABLE": "that can be coloured, also COLORABLE [adj COLOURABLY]\n",
  "COLOURABLENESS": "COLOURABLE, that can be coloured, also COLORABLE [n]\n",
  "COLOURABLY": "COLOURABLE, that can be coloured, also COLORABLE [adv]\n",
  "COLOURANT": "a substance used for colouring, also COLORANT [n -S]\n",
  "COLOURANTS": "COLOURANT, a substance used for colouring, also COLORANT [n]\n",
  "COLOURATION": "the act of colouring; the state of being coloured, also COLORATION [n -S]\n",
  "COLOURATIONS": "COLOURATION, the act of colouring; the state of being coloured, also COLORATION [n]\n",
  "COLOURBRED": "COLOURBREED, to breed (animals or plants) to be a particular colour, also COLORBREED [v]\n",
  "COLOURBREED": "to breed (animals or plants) to be a particular colour, also COLORBREED [v COLOURBRED, COLOURBREEDING, COLOURBREEDS]\n",
  "COLOURBREEDING": "COLOURBREED, to breed (animals or plants) to be a particular colour, also COLORBREED [v]\n",
  "COLOURBREEDS": "COLOURBREED, to breed (animals or plants) to be a particular colour, also COLORBREED [v]\n",
  "COLOURCAST": "to broadcast (a television programme) in colour, also COLORCAST [v -ED, -ING, -S]\n",
  "COLOURCASTED": "COLOURCAST, to broadcast (a television programme) in colour, also COLORCAST [v]\n",
  "COLOURCASTING": "COLOURCAST, to broadcast (a television programme) in colour, also COLORCAST [v]\n",
  "COLOURCASTS": "COLOURCAST, to broadcast (a television programme) in colour, also COLORCAST [v]\n",
  "COLOURED": "a coloured person, also COLORED [n -S]\n",
  "COLOUREDS": "COLOURED, a coloured person, also COLORED [n]\n",
  "COLOURER": "one that colors, also COLORER [n -S]\n",
  "COLOURERS": "COLOURER, one that colors, also COLORER [n]\n",
  "COLOURFAST": "having colours that retain their original hue without running or fading, also COLORFAST [adj]\n",
  "COLOURFASTNESS": "COLOURFAST, having colours that retain their original hue without running or fading, also COLORFAST [n]\n",
  "COLOURFUL": "full of colour, also COLORFUL [adj COLOURFULLY]\n",
  "COLOURFULLY": "COLOURFUL, full of colour, also COLORFUL [adv]\n",
  "COLOURFULNESS": "the state of being colourful [n -ES]\n",
  "COLOURFULNESSES": "COLOURFULNESS, the state of being colourful [n]\n",
  "COLOURIER": "COLOURY, full of colour, also COLORY [adj]\n",
  "COLOURIEST": "COLOURY, full of colour, also COLORY [adj]\n",
  "COLOURING": "colour [n -S]\n",
  "COLOURINGS": "COLOURING, colour [n]\n",
  "COLOURISATION": "the act of colourising, also COLORISATION, COLORIZATION, COLOURIZATION [n -S]\n",
  "COLOURISATIONS": "COLOURISATION, the act of colourising, also COLORISATION, COLORIZATION, COLOURIZATION [n]\n",
  "COLOURISE": "to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURIZE [v COLOURISED, COLOURISING, COLOURISES]\n",
  "COLOURISED": "COLOURISE, to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURIZE [v]\n",
  "COLOURISER": "a person or thing that colourizes, also COLORISER, COLORIZER, COLOURIZER [n -S]\n",
  "COLOURISERS": "COLOURISER, a person or thing that colourizes, also COLORISER, COLORIZER, COLOURIZER [n]\n",
  "COLOURISES": "COLOURISE, to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURIZE [v]\n",
  "COLOURISING": "COLOURISE, to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURIZE [v]\n",
  "COLOURISM": "discrimination in which people are judged on the basis of their skin colour, also COLORISM [n -S]\n",
  "COLOURISMS": "COLOURISM, discrimination in which people are judged on the basis of their skin colour, also COLORISM [n]\n",
  "COLOURIST": "a person who colours or paints; an artist who excels in the use of colour, also COLORIST [n -S]\n",
  "COLOURISTIC": "relating to a colourist [adj]\n",
  "COLOURISTICALLY": "COLOURISTIC, relating to a colourist [adv]\n",
  "COLOURISTS": "COLOURIST, a person who colours or paints; an artist who excels in the use of colour, also COLORIST [n]\n",
  "COLOURIZATION": "the act of colourizing, also COLORISATION, COLORIZATION, COLOURISATION [n -S]\n",
  "COLOURIZATIONS": "COLOURIZATION, the act of colourizing, also COLORISATION, COLORIZATION, COLOURISATION [n]\n",
  "COLOURIZE": "to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURISE [v COLOURIZED, COLOURIZING, COLOURIZES]\n",
  "COLOURIZED": "COLOURIZE, to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURISE [v]\n",
  "COLOURIZER": "a person or thing that colourizes, also COLORISER, COLORIZER, COLOURISER [n -S]\n",
  "COLOURIZERS": "COLOURIZER, a person or thing that colourizes, also COLORISER, COLORIZER, COLOURISER [n]\n",
  "COLOURIZES": "COLOURIZE, to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURISE [v]\n",
  "COLOURIZING": "COLOURIZE, to add colour to (a film made in black and white), also COLORISE, COLORIZE, COLOURISE [v]\n",
  "COLOURLESS": "without colour, also COLORLESS [adj COLOURLESSLY]\n",
  "COLOURLESSLY": "COLOURLESS, without colour, also COLORLESS [adv]\n",
  "COLOURLESSNESS": "COLOURLESS, without colour, also COLORLESS [n]\n",
  "COLOURMAN": "a person who prepares or sells paints [n COLOURMEN]\n",
  "COLOURMEN": "COLOURMAN, a person who prepares or sells paints [n]\n",
  "COLOURPOINT": "a breed of domestic cat, also COLORPOINT [n -S]\n",
  "COLOURPOINTS": "COLOURPOINT, a breed of domestic cat, also COLORPOINT [n]\n",
  "COLOURS": "COLOUR, to paint, also COLOR [v]\n",
  "COLOURWASH": "a cheap form of distemper, also COLORWASH [n -ES] / to paint with this [v -ED, -ING, -ES]\n",
  "COLOURWASHED": "COLOURWASH, to paint with this [v]\n",
  "COLOURWASHES": "COLOURWASH, to paint with this [v]\n",
  "COLOURWASHING": "COLOURWASH, to paint with this [v]\n",
  "COLOURWAY": "one of several combinations of colours in which e.g. a patterned fabric is available, also COLORWAY [n -S]\n",
  "COLOURWAYS": "COLOURWAY, one of several combinations of colours in which e.g. a patterned fabric is available, also COLORWAY [n]\n",
  "COLOURY": "full of colour, also COLORY [adj COLOURIER, COLOURIEST]\n",
  "COLPITIS": "a vaginal inflammation [n -ES]\n",
  "COLPITISES": "COLPITIS, a vaginal inflammation [n]\n",
  "COLPORTAGE": "(French) the distribution of religious books, tracts, etc., by colporteurs [n -S]\n",
  "COLPORTAGES": "COLPORTAGE, (French) the distribution of religious books, tracts, etc., by colporteurs [n]\n",
  "COLPORTEUR": "(French) a peddler of religious books [n -S]\n",
  "COLPORTEURS": "COLPORTEUR, (French) a peddler of religious books [n]\n",
  "COLPOSCOPE": "an instrument for viewing the neck of the uterus [n -S]\n",
  "COLPOSCOPES": "COLPOSCOPE, an instrument for viewing the neck of the uterus [n]\n",
  "COLPOSCOPICAL": "relating to colposcopy [adj COLPOSCOPICALLY]\n",
  "COLPOSCOPICALLY": "COLPOSCOPICAL, relating to colposcopy [adv]\n",
  "COLPOSCOPIES": "COLPOSCOPY, an examination using a colposcope, an instrument for viewing the neck of the uterus [n]\n",
  "COLPOSCOPY": "an examination using a colposcope, an instrument for viewing the neck of the uterus [n COLPOSCOPIES]\n",
  "COLPOTOMIES": "COLPOTOMY, surgical incision into the wall of the vagina [n]\n",
  "COLPOTOMY": "surgical incision into the wall of the vagina [n COLPOTOMIES]\n",
  "COLS": "COL, a pass in a mountain range [n]\n",
  "COLT": "to cheat, defraud [v -ED, -ING, -S]\n",
  "COLTAN": "a metallic ore of columbite and tantalite, found in the Congo [n -S]\n",
  "COLTANS": "COLTAN, a metallic ore of columbite and tantalite, found in the Congo [n]\n",
  "COLTED": "COLT, to cheat, defraud [v]\n",
  "COLTER": "a blade on a plow, also COULTER [n -S]\n",
  "COLTERS": "COLTER, a blade on a plow, also COULTER [n]\n",
  "COLTHOOD": "the state or time of being a colt [n -S]\n",
  "COLTHOODS": "COLTHOOD, the state or time of being a colt [n]\n",
  "COLTING": "COLT, to cheat, defraud [v]\n",
  "COLTISH": "like a colt [adj COLTISHLY]\n",
  "COLTISHLY": "COLTISH, like a colt [adv]\n",
  "COLTISHNESS": "the state of being coltish [n -ES]\n",
  "COLTISHNESSES": "COLTISHNESS, the state of being coltish [n]\n",
  "COLTS": "COLT, to cheat, defraud [v]\n",
  "COLTSFOOT": "a composite plant with a shaggy stalk and large soft leaves [n -S]\n",
  "COLTSFOOTS": "COLTSFOOT, a composite plant with a shaggy stalk and large soft leaves [n]\n",
  "COLTWOOD": "(Spenser) an unidentified plant, perhaps coltsfoot [n -S]\n",
  "COLTWOODS": "COLTWOOD, (Spenser) an unidentified plant, perhaps coltsfoot [n]\n",
  "COLUBRIAD": "(Cowper) the epic of a snake [n -S]\n",
  "COLUBRIADS": "COLUBRIAD, (Cowper) the epic of a snake [n]\n",
  "COLUBRID": "any of a large family of snakes including the garter and king snake [n -S]\n",
  "COLUBRIDS": "COLUBRID, any of a large family of snakes including the garter and king snake [n]\n",
  "COLUBRIFORM": "shaped like a snake [adj]\n",
  "COLUBRINE": "like a snake; cunning [adj]\n",
  "COLUGO": "(Malay) a flying lemur [n -S]\n",
  "COLUGOS": "COLUGO, (Malay) a flying lemur [n]\n",
  "COLUMBARIA": "COLUMBARIUM, (Latin) a vault with niches for storing urns; a dovecote or pigeon house [n]\n",
  "COLUMBARIES": "COLUMBARY, a dovecote; a pigeon house [n]\n",
  "COLUMBARIUM": "(Latin) a vault with niches for storing urns; a dovecote or pigeon house [n COLUMBARIA]\n",
  "COLUMBARY": "a dovecote; a pigeon house [n COLUMBARIES]\n",
  "COLUMBATE": "a salt of columbic acid; a niobate [n -S]\n",
  "COLUMBATES": "COLUMBATE, a salt of columbic acid; a niobate [n]\n",
  "COLUMBIC": "pertaining to, or containing, columbium or niobium [adj]\n",
  "COLUMBINE": "a flower, aka aquilegia [n -S]\n",
  "COLUMBINES": "COLUMBINE, a flower, aka aquilegia [n]\n",
  "COLUMBITE": "a mineral, niobate and tantalate of iron and manganese, aka niobite [n -S]\n",
  "COLUMBITES": "COLUMBITE, a mineral, niobate and tantalate of iron and manganese, aka niobite [n]\n",
  "COLUMBIUM": "a rare element of the vanadium group, now more commonly called niobium [n -S]\n",
  "COLUMBIUMS": "COLUMBIUM, a rare element of the vanadium group, now more commonly called niobium [n]\n",
  "COLUMBOUS": "of or like niobium, a later name of columbium [adj]\n",
  "COLUMEL": "a small column-like anatomical part [n -S]\n",
  "COLUMELLA": "(Latin) the uvula [n COLUMELLAE]\n",
  "COLUMELLAE": "COLUMELLA, (Latin) the uvula [n]\n",
  "COLUMELLAR": "relating to a columella, the central axis of a spiral univalve [adj]\n",
  "COLUMELS": "COLUMEL, a small column-like anatomical part [n]\n",
  "COLUMN": "a vertical cylindrical support [n -S]\n",
  "COLUMNAL": "a circular disklike section of the stem of a crinoid [n -S]\n",
  "COLUMNALS": "COLUMNAL, a circular disklike section of the stem of a crinoid [n]\n",
  "COLUMNAR": "in the form of a column [adj]\n",
  "COLUMNARITIES": "COLUMNARITY, the state of being columnar [n]\n",
  "COLUMNARITY": "the state of being columnar [n COLUMNARITIES]\n",
  "COLUMNATED": "having columns, also COLUMNIATED [adj]\n",
  "COLUMNEA": "a bushy tropical plant [n -S]\n",
  "COLUMNEAS": "COLUMNEA, a bushy tropical plant [n]\n",
  "COLUMNED": "having a column [adj]\n",
  "COLUMNIATED": "having columns, also COLUMNATED [adj]\n",
  "COLUMNIATION": "the use or arrangement of columns in a structure [n -S]\n",
  "COLUMNIATIONS": "COLUMNIATION, the use or arrangement of columns in a structure [n]\n",
  "COLUMNIST": "one who writes a newspaper column [n -S]\n",
  "COLUMNISTIC": "in columns [adj]\n",
  "COLUMNISTS": "COLUMNIST, one who writes a newspaper column [n]\n",
  "COLUMNS": "COLUMN, a vertical cylindrical support [n]\n",
  "COLURE": "a celestial circle that intersects another at the poles [n -S]\n",
  "COLURES": "COLURE, a celestial circle that intersects another at the poles [n]\n",
  "COLY": "an African bird [n COLIES]\n",
  "COLZA": "(Dutch) a variety of cabbage cultivated for its seeds, which yield an oil valued for illuminating and lubricating purposes [n -S]\n",
  "COLZAS": "COLZA, (Dutch) a variety of cabbage cultivated for its seeds, which yield an oil valued for illuminating and lubricating purposes [n]\n",
  "COMA": "(Latin) a spherical cloud of material surrounding the head of a comet [n COMAE or COMAS]\n",
  "COMADE": "COMAKE, to serve as a comaker for another's loan [v]\n",
  "COMAE": "COMA, (Latin) a spherical cloud of material surrounding the head of a comet [n]\n",
  "COMAKE": "to serve as a comaker for another's loan [v COMADE, COMAKING, COMAKES]\n",
  "COMAKER": "one who stands as a guarantor [n -S]\n",
  "COMAKERS": "COMAKER, one who stands as a guarantor [n]\n",
  "COMAKES": "COMAKE, to serve as a comaker for another's loan [v]\n",
  "COMAKING": "COMAKE, to serve as a comaker for another's loan [v]\n",
  "COMAL": "bearing a tuft of silky hairs [adj]\n",
  "COMANAGE": "to manage jointly [v COMANAGED, COMANAGING, COMANAGES]\n",
  "COMANAGED": "COMANAGE, to manage jointly [v]\n",
  "COMANAGEMENT": "joint management [n -S]\n",
  "COMANAGEMENTS": "COMANAGEMENT, joint management [n]\n",
  "COMANAGER": "one who shares a managerial role with another [n -S]\n",
  "COMANAGERS": "COMANAGER, one who shares a managerial role with another [n]\n",
  "COMANAGES": "COMANAGE, to manage jointly [v]\n",
  "COMANAGING": "COMANAGE, to manage jointly [v]\n",
  "COMANCHERO": "(Spanish) in the 19th century, a person who traded with the Plains Indians [n -S]\n",
  "COMANCHEROS": "COMANCHERO, (Spanish) in the 19th century, a person who traded with the Plains Indians [n]\n",
  "COMARB": "(historical) the head of a family in an Irish sept; an ecclesiastical successor, also COARB [n -S]\n",
  "COMARBS": "COMARB, (historical) the head of a family in an Irish sept; an ecclesiastical successor, also COARB [n]\n",
  "COMART": "(Shakespeare) an agreement [n -S]\n",
  "COMARTS": "COMART, (Shakespeare) an agreement [n]\n",
  "COMAS": "COMA, (Latin) a spherical cloud of material surrounding the head of a comet [n]\n",
  "COMATE": "(Shakespeare) a mate or companion [n -S]\n",
  "COMATES": "COMATE, (Shakespeare) a mate or companion [n]\n",
  "COMATIC": "having blurred vision as a result of a coma [adj]\n",
  "COMATIK": "(Inuit) a sled with wooden runners, also KAMOTIK, KAMOTIQ, KOMATIK, QAMUTIK [n -S]\n",
  "COMATIKS": "COMATIK, (Inuit) a sled with wooden runners, also KAMOTIK, KAMOTIQ, KOMATIK, QAMUTIK [n]\n",
  "COMATOSE": "relating to, or resembling, coma [adj COMATOSELY]\n",
  "COMATOSELY": "COMATOSE, relating to, or resembling, coma [adv]\n",
  "COMATULA": "(Latin) a type of crinoid, aka feather star, also COMATULID [n COMATULAE]\n",
  "COMATULAE": "COMATULA, (Latin) a type of crinoid, aka feather star, also COMATULID [n]\n",
  "COMATULID": "a type of crinoid, aka feather star, also COMATULA [n -S]\n",
  "COMATULIDS": "COMATULID, a type of crinoid, aka feather star, also COMATULA [n]\n",
  "COMB": "to separate with a toothed instrument [v -ED, -ING, -S]\n",
  "COMBAT": "to fight against [v COMBATED or COMBATTED, COMBATING or COMBATTING, COMBATS]\n",
  "COMBATABLE": "able to be combated [adj]\n",
  "COMBATANT": "one engaged in combat [n -S]\n",
  "COMBATANTS": "COMBATANT, one engaged in combat [n]\n",
  "COMBATED": "COMBAT, to fight against [v]\n",
  "COMBATER": "one who fights against [n -S]\n",
  "COMBATERS": "COMBATER, one who fights against [n]\n",
  "COMBATING": "COMBAT, to fight against [v]\n",
  "COMBATIVE": "inclined to combat [adj COMBATIVELY]\n",
  "COMBATIVELY": "COMBATIVE, inclined to combat [adv]\n",
  "COMBATIVENESS": "the state of being combative [n -ES]\n",
  "COMBATIVENESSES": "COMBATIVENESS, the state of being combative [n]\n",
  "COMBATS": "COMBAT, to fight against [v]\n",
  "COMBATTED": "COMBAT, to fight against [v]\n",
  "COMBATTING": "COMBAT, to fight against [v]\n",
  "COMBE": "a narrow valley, also COOMB, COOMBE [n -S]\n",
  "COMBED": "COMB, to separate with a toothed instrument [v]\n",
  "COMBER": "one that combs [n -S]\n",
  "COMBERS": "COMBER, one that combs [n]\n",
  "COMBES": "COMBE, a narrow valley, also COOMB, COOMBE [n]\n",
  "COMBI": "a vessel or vehicle which can carry passengers or cargo [n COMBIS or COMBIES]\n",
  "COMBIER": "COMBY, full of holes like a honeycomb [adj]\n",
  "COMBIES": "COMBI, a vessel or vehicle which can carry passengers or cargo [n]\n",
  "COMBIEST": "COMBY, full of holes like a honeycomb [adj]\n",
  "COMBINABILITIES": "COMBINABILITY, the quality of being combinable [n]\n",
  "COMBINABILITY": "the quality of being combinable [n COMBINABILITIES]\n",
  "COMBINABLE": "able to be combined [adj]\n",
  "COMBINATE": "combined; betrothed [adj]\n",
  "COMBINATION": "the act of combining [n -S]\n",
  "COMBINATIONAL": "relating to combination [adj]\n",
  "COMBINATIONS": "COMBINATION, the act of combining [n]\n",
  "COMBINATIVE": "tending or able to combine [adj]\n",
  "COMBINATORIAL": "of, relating to, or involving combinations [adj COMBINATORIALLY]\n",
  "COMBINATORIALLY": "COMBINATORIAL, of, relating to, or involving combinations [adv]\n",
  "COMBINATORICS": "combinatorial mathematics [n]\n",
  "COMBINATORY": "relating to combination [adj]\n",
  "COMBINE": "to join, mix [v COMBINED, COMBINING, COMBINES]\n",
  "COMBINED": "a skiing competition combining two events [n -S]\n",
  "COMBINEDS": "COMBINED, a skiing competition combining two events [n]\n",
  "COMBINER": "one who, or that which, combines [n -S]\n",
  "COMBINERS": "COMBINER, one who, or that which, combines [n]\n",
  "COMBINES": "COMBINE, to join, mix [v]\n",
  "COMBING": "a hair or wool fibre combed off [n -S]\n",
  "COMBINGS": "COMBING, a hair or wool fibre combed off [n]\n",
  "COMBINING": "the act of combining [n -S]\n",
  "COMBININGS": "COMBINING, the act of combining [n]\n",
  "COMBIS": "COMBI, a vessel or vehicle which can carry passengers or cargo [n]\n",
  "COMBLE": "(French) the acme [n -S]\n",
  "COMBLES": "COMBLE, (French) the acme [n]\n",
  "COMBLESS": "without a comb [adj]\n",
  "COMBLIKE": "like a comb [adj]\n",
  "COMBO": "a small jazz band [n -S]\n",
  "COMBOS": "COMBO, a small jazz band [n]\n",
  "COMBOVER": "a vain attempt to make the most of one's dwindling resources of hair [n -S]\n",
  "COMBOVERS": "COMBOVER, a vain attempt to make the most of one's dwindling resources of hair [n]\n",
  "COMBRETUM": "(Latin) a member of a genus of tropical trees known for the beauty of their flowers [n -S]\n",
  "COMBRETUMS": "COMBRETUM, (Latin) a member of a genus of tropical trees known for the beauty of their flowers [n]\n",
  "COMBS": "COMB, to separate with a toothed instrument [v]\n",
  "COMBURGESS": "a fellow-burgess [n -ES]\n",
  "COMBURGESSES": "COMBURGESS, a fellow-burgess [n]\n",
  "COMBUST": "to burn [v -ED, -ING, -S]\n",
  "COMBUSTED": "COMBUST, to burn [v]\n",
  "COMBUSTIBILITY": "the state of being combustible [n]\n",
  "COMBUSTIBLE": "able to be burned [adj COMBUSTIBLY] / something able to be burned [n -S]\n",
  "COMBUSTIBLENESS": "the state of being combustible [n]\n",
  "COMBUSTIBLES": "COMBUSTIBLE, something able to be burned [n]\n",
  "COMBUSTIBLY": "COMBUSTIBLE, able to be burned [adv]\n",
  "COMBUSTING": "COMBUST, to burn [v]\n",
  "COMBUSTION": "an act or instance of burning [n -S]\n",
  "COMBUSTIONS": "COMBUSTION, an act or instance of burning [n]\n",
  "COMBUSTIOUS": "(Shakespeare) combustible [adj]\n",
  "COMBUSTIVE": "capable of catching fire [adj] / something capable of catching fire [n -S]\n",
  "COMBUSTIVES": "COMBUSTIVE, something capable of catching fire [n]\n",
  "COMBUSTOR": "the system in a jet engine by which combustion takes place [n -S]\n",
  "COMBUSTORS": "COMBUSTOR, the system in a jet engine by which combustion takes place [n]\n",
  "COMBUSTS": "COMBUST, to burn [v]\n",
  "COMBWISE": "in the way of a comb [adv]\n",
  "COMBY": "full of holes like a honeycomb [adj COMBIER, COMBIEST]\n",
  "COME": "to move toward someone or something [v CAME, COMING, COMES or COMETH]\n",
  "COMEBACK": "a return to former glory [n -S]\n",
  "COMEBACKS": "COMEBACK, a return to former glory [n]\n",
  "COMEDDLE": "(obsolete) to mix, to temper [v COMEDDLED, COMEDDLING, COMEDDLES]\n",
  "COMEDDLED": "COMEDDLE, (obsolete) to mix, to temper [v]\n",
  "COMEDDLES": "COMEDDLE, (obsolete) to mix, to temper [v]\n",
  "COMEDDLING": "COMEDDLE, (obsolete) to mix, to temper [v]\n",
  "COMEDIAN": "a humorous entertainer [n -S]\n",
  "COMEDIANS": "COMEDIAN, a humorous entertainer [n]\n",
  "COMEDIC": "of or relating to comedy [adj COMEDICALLY]\n",
  "COMEDICALLY": "COMEDIC, of or relating to comedy [adv]\n",
  "COMEDIENNE": "a women who plays in comedy [n -S]\n",
  "COMEDIENNES": "COMEDIENNE, a women who plays in comedy [n]\n",
  "COMEDIES": "COMEDY, a humorous work [n]\n",
  "COMEDIETTA": "(Italian) a dramatic sketch; a brief comedy [n -S]\n",
  "COMEDIETTAS": "COMEDIETTA, (Italian) a dramatic sketch; a brief comedy [n]\n",
  "COMEDIST": "a writer of comedies [n -S]\n",
  "COMEDISTS": "COMEDIST, a writer of comedies [n]\n",
  "COMEDO": "(Latin) a skin blemish, a blackhead [n COMEDOS or COMEDONES]\n",
  "COMEDOGENIC": "causing or aggravating acne [adj]\n",
  "COMEDONES": "COMEDO, (Latin) a skin blemish, a blackhead [n]\n",
  "COMEDOS": "COMEDO, (Latin) a skin blemish, a blackhead [n]\n",
  "COMEDOWN": "a drop in status [n -S]\n",
  "COMEDOWNS": "COMEDOWN, a drop in status [n]\n",
  "COMEDY": "a humorous work [n COMEDIES]\n",
  "COMELIER": "COMELY, pleasing to look at [adj]\n",
  "COMELIEST": "COMELY, pleasing to look at [adj]\n",
  "COMELILY": "COMELY, pleasing to look at [adv]\n",
  "COMELINESS": "the state of being comely [n -ES]\n",
  "COMELINESSES": "COMELINESS, the state of being comely [n]\n",
  "COMELY": "pleasing to look at [adj COMELIER, COMELIEST, COMELILY]\n",
  "COMEMBER": "a joint member [n -S]\n",
  "COMEMBERS": "COMEMBER, a joint member [n]\n",
  "COMEOVER": "a person who has come from Britain to the Isle of Man to settle [n -S]\n",
  "COMEOVERS": "COMEOVER, a person who has come from Britain to the Isle of Man to settle [n]\n",
  "COMER": "one showing great promise [n -S]\n",
  "COMERS": "COMER, one showing great promise [n]\n",
  "COMES": "COME, to move toward someone or something [v]\n",
  "COMESTIBLE": "edible [adj] / something edible [n -S]\n",
  "COMESTIBLES": "COMESTIBLE, something edible [n]\n",
  "COMET": "a celestial body [n -S]\n",
  "COMETARY": "pertaining to, or resembling, a comet, also COMETIC [adj]\n",
  "COMETH": "COME, to move toward someone or something [v]\n",
  "COMETHER": "(dialect) wheedling, charm [n -S]\n",
  "COMETHERS": "COMETHER, (dialect) wheedling, charm [n]\n",
  "COMETIC": "relating to a comet, also COMETARY [adj]\n",
  "COMETOGRAPHIES": "COMETOGRAPHY, the description of comets [n]\n",
  "COMETOGRAPHY": "the description of comets [n COMETOGRAPHIES]\n",
  "COMETOLOGIES": "COMETOLOGY, the study of comets [n]\n",
  "COMETOLOGY": "the study of comets [n COMETOLOGIES]\n",
  "COMETS": "COMET, a celestial body [n]\n",
  "COMEUPPANCE": "a deserved rebuke or penalty [n -S]\n",
  "COMEUPPANCES": "COMEUPPANCE, a deserved rebuke or penalty [n]\n",
  "COMFIER": "COMFY, (colloquial) comfortable [adj]\n",
  "COMFIEST": "COMFY, (colloquial) comfortable [adj]\n",
  "COMFILY": "COMFY, (colloquial) comfortable [adv]\n",
  "COMFINESS": "the state of being comfy [n -ES]\n",
  "COMFINESSES": "COMFINESS, the state of being comfy [n]\n",
  "COMFIT": "a sweet; a sugarcoated seed or almond, also CONFIT [n -S]\n",
  "COMFITS": "COMFIT, a sweet; a sugarcoated seed or almond, also CONFIT [n]\n",
  "COMFITURE": "(obsolete) conserve, preserved fruit, also CONFITURE [n -S]\n",
  "COMFITURES": "COMFITURE, (obsolete) conserve, preserved fruit, also CONFITURE [n]\n",
  "COMFORT": "to console [v -ED, -ING, -S]\n",
  "COMFORTABLE": "affording comfort [adj COMFORTABLY]\n",
  "COMFORTABLENESS": "the state of being comfortable [n]\n",
  "COMFORTABLY": "COMFORTABLE, affording comfort [adv]\n",
  "COMFORTED": "COMFORT, to console [v]\n",
  "COMFORTER": "one who comforts [n -S]\n",
  "COMFORTERS": "COMFORTER, one who comforts [n]\n",
  "COMFORTING": "COMFORT, to console [v]\n",
  "COMFORTINGLY": "COMFORTING, COMFORT, to console [adv]\n",
  "COMFORTLESS": "without comfort [adj COMFORTLESSLY]\n",
  "COMFORTLESSLY": "COMFORTLESS, without comfort [adv]\n",
  "COMFORTLESSNESS": "COMFORTLESS, without comfort [n]\n",
  "COMFORTS": "COMFORT, to console [v]\n",
  "COMFREY": "a boraginaceous plant, having hairy leaves often used in herbal medicine [n -S]\n",
  "COMFREYS": "COMFREY, a boraginaceous plant, having hairy leaves often used in herbal medicine [n]\n",
  "COMFY": "(colloquial) comfortable [adj COMFIER, COMFIEST, COMFILY]\n",
  "COMIC": "amusing, also COMICAL [adj COMICALLY] / a comedian [n -S]\n",
  "COMICAL": "amusing, also COMIC [adj COMICALLY]\n",
  "COMICALITIES": "COMICALITY, the quality of being comical [n]\n",
  "COMICALITY": "the quality of being comical [n COMICALITIES]\n",
  "COMICALLY": "COMICAL, amusing, also COMIC [adv]\n",
  "COMICALNESS": "the state of being comical [n -ES]\n",
  "COMICALNESSES": "COMICALNESS, the state of being comical [n]\n",
  "COMICE": "(French) a variety of pear [n -S]\n",
  "COMICES": "COMICE, (French) a variety of pear [n]\n",
  "COMICS": "COMIC, a comedian [n]\n",
  "COMING": "arrival or approach [n -S]\n",
  "COMINGLE": "to blend thoroughly [v COMINGLED, COMINGLING, COMINGLES]\n",
  "COMINGLED": "COMINGLE, to blend thoroughly [v]\n",
  "COMINGLES": "COMINGLE, to blend thoroughly [v]\n",
  "COMINGLING": "COMINGLE, to blend thoroughly [v]\n",
  "COMINGS": "COMING, arrival or approach [n]\n",
  "COMIQUE": "(French) a comic actor or singer [n -S]\n",
  "COMIQUES": "COMIQUE, (French) a comic actor or singer [n]\n",
  "COMITADJI": "(Turkish) a member of the Bulgarian Revolutionary Committee in Macedonia; any Balkan guerilla, also KOMITAJI [n -S]\n",
  "COMITADJIS": "COMITADJI, (Turkish) a member of the Bulgarian Revolutionary Committee in Macedonia; any Balkan guerilla, also KOMITAJI [n]\n",
  "COMITAL": "relating to a count, earl or county [adj]\n",
  "COMITATIVE": "of a grammatical case, expressing accompaniment [adj] / a comitative case [n -S]\n",
  "COMITATIVES": "COMITATIVE, a comitative case [n]\n",
  "COMITATUS": "(Latin) a band of warriors who escort a prince [n -ES]\n",
  "COMITATUSES": "COMITATUS, (Latin) a band of warriors who escort a prince [n]\n",
  "COMITIA": "(Latin) a public assembly of the Roman people for electing officers or passing laws [n -S]\n",
  "COMITIAL": "relating to a comitia [adj]\n",
  "COMITIAS": "COMITIA, (Latin) a public assembly of the Roman people for electing officers or passing laws [n]\n",
  "COMITIES": "COMITY, courteousness; civility [n]\n",
  "COMITY": "courteousness; civility [n COMITIES]\n",
  "COMIX": "(slang) comic books [adj]\n",
  "COMM": "as in comm badge, a small wearable badge-shaped radio transmitter [n -S]\n",
  "COMMA": "(Greek) a fragment of a few words or feet in ancient prosody [n COMMAS or COMMATA]\n",
  "COMMAND": "to direct with authority [v -ED, -ING, -S]\n",
  "COMMANDABLE": "able to be commanded [adj]\n",
  "COMMANDANT": "a commanding officer [n -S]\n",
  "COMMANDANTS": "COMMANDANT, a commanding officer [n]\n",
  "COMMANDANTSHIP": "the office of commandant [n -S]\n",
  "COMMANDANTSHIPS": "COMMANDANTSHIP, the office of commandant [n]\n",
  "COMMANDED": "COMMAND, to direct with authority [v]\n",
  "COMMANDEER": "to compel to perform military service [v -ED, -ING, -S]\n",
  "COMMANDEERED": "COMMANDEER, to compel to perform military service [v]\n",
  "COMMANDEERING": "COMMANDEER, to compel to perform military service [v]\n",
  "COMMANDEERS": "COMMANDEER, to compel to perform military service [v]\n",
  "COMMANDER": "one who commands [n -S]\n",
  "COMMANDERIES": "COMMANDERY, the office or rank of a commander [n]\n",
  "COMMANDERS": "COMMANDER, one who commands [n]\n",
  "COMMANDERSHIP": "the office of commander [n -S]\n",
  "COMMANDERSHIPS": "COMMANDERSHIP, the office of commander [n]\n",
  "COMMANDERY": "the office or rank of a commander [n COMMANDERIES]\n",
  "COMMANDING": "COMMAND, to direct with authority [v]\n",
  "COMMANDINGLY": "COMMANDING, COMMAND, to direct with authority [adv]\n",
  "COMMANDMENT": "the act or power of commanding [n -S]\n",
  "COMMANDMENTS": "COMMANDMENT, the act or power of commanding [n]\n",
  "COMMANDO": "a specialist assault soldier [n COMMANDOS or COMMANDOES]\n",
  "COMMANDOES": "COMMANDO, a specialist assault soldier [n]\n",
  "COMMANDOS": "COMMANDO, a specialist assault soldier [n]\n",
  "COMMANDS": "COMMAND, to direct with authority [v]\n",
  "COMMAS": "COMMA, (Greek) a fragment of a few words or feet in ancient prosody [n]\n",
  "COMMATA": "COMMA, (Greek) a fragment of a few words or feet in ancient prosody [n]\n",
  "COMMEASURABLE": "able to be commeasured [adj]\n",
  "COMMEASURE": "to be commensurate with; to equal [v COMMEASURED, COMMEASURING, COMMEASURES]\n",
  "COMMEASURED": "COMMEASURE, to be commensurate with; to equal [v]\n",
  "COMMEASURES": "COMMEASURE, to be commensurate with; to equal [v]\n",
  "COMMEASURING": "COMMEASURE, to be commensurate with; to equal [v]\n",
  "COMMEMORABLE": "able to be commemorated [adj]\n",
  "COMMEMORATE": "to call to remembrance [v COMMEMORATED, COMMEMORATING, COMMEMORATES]\n",
  "COMMEMORATED": "COMMEMORATE, to call to remembrance [v]\n",
  "COMMEMORATES": "COMMEMORATE, to call to remembrance [v]\n",
  "COMMEMORATING": "COMMEMORATE, to call to remembrance [v]\n",
  "COMMEMORATION": "the act of commemorating [n -S]\n",
  "COMMEMORATIONAL": "serving to commemorate [adj]\n",
  "COMMEMORATIONS": "COMMEMORATION, the act of commemorating [n]\n",
  "COMMEMORATIVE": "intended as a commemoration [adj COMMEMORATIVELY] / something intended as a commemoration [n -S]\n",
  "COMMEMORATIVELY": "COMMEMORATIVE, intended as a commemoration [adv]\n",
  "COMMEMORATIVES": "COMMEMORATIVE, something intended as a commemoration [n]\n",
  "COMMEMORATOR": "one who commemorates [n -S]\n",
  "COMMEMORATORS": "COMMEMORATOR, one who commemorates [n]\n",
  "COMMEMORATORY": "serving to commemorate [adj]\n",
  "COMMENCE": "to begin [v COMMENCED, COMMENCING, COMMENCES]\n",
  "COMMENCED": "COMMENCE, to begin [v]\n",
  "COMMENCEMENT": "an act, instance, or time of commencing [n -S]\n",
  "COMMENCEMENTS": "COMMENCEMENT, an act, instance, or time of commencing [n]\n",
  "COMMENCER": "one who commences [n -S]\n",
  "COMMENCERS": "COMMENCER, one who commences [n]\n",
  "COMMENCES": "COMMENCE, to begin [v]\n",
  "COMMENCING": "COMMENCE, to begin [v]\n",
  "COMMEND": "to praise [v -ED, -ING, -S]\n",
  "COMMENDABLE": "that can be commended [adj COMMENDABLY]\n",
  "COMMENDABLENESS": "COMMENDABLE, that can be commended [n]\n",
  "COMMENDABLY": "COMMENDABLE, that can be commended [adv]\n",
  "COMMENDAM": "(Latin) a vacant living or benefice commended to a cleric (usually a bishop) who enjoyed the revenue until a pastor was provided [n -S]\n",
  "COMMENDAMS": "COMMENDAM, (Latin) a vacant living or benefice commended to a cleric (usually a bishop) who enjoyed the revenue until a pastor was provided [n]\n",
  "COMMENDATION": "an act of commending [n -S]\n",
  "COMMENDATIONS": "COMMENDATION, an act of commending [n]\n",
  "COMMENDATOR": "a person who holds a benefice in commendam; a titular abbot, etc. [n -S]\n",
  "COMMENDATORS": "COMMENDATOR, a person who holds a benefice in commendam; a titular abbot, etc. [n]\n",
  "COMMENDATORY": "serving to commend [adj]\n",
  "COMMENDED": "COMMEND, to praise [v]\n",
  "COMMENDER": "one who commends [n -S]\n",
  "COMMENDERS": "COMMENDER, one who commends [n]\n",
  "COMMENDING": "COMMEND, to praise [v]\n",
  "COMMENDS": "COMMEND, to praise [v]\n",
  "COMMENSAL": "eating at the same table [adj COMMENSALLY] / one who eats at the same table [n -S]\n",
  "COMMENSALISM": "a relation between two kinds of organisms in which one obtains food or other benefits from the other without damaging or benefiting it [n -S]\n",
  "COMMENSALISMS": "COMMENSALISM, a relation between two kinds of organisms in which one obtains food or other benefits from the other without damaging or benefiting it [n]\n",
  "COMMENSALITIES": "COMMENSALITY, dining as a group [n]\n",
  "COMMENSALITY": "dining as a group [n COMMENSALITIES]\n",
  "COMMENSALLY": "COMMENSAL, eating at the same table [adv]\n",
  "COMMENSALS": "COMMENSAL, one who eats at the same table [n]\n",
  "COMMENSURABLE": "measurable by the same standard; proportionate [adj COMMENSURABLY]\n",
  "COMMENSURABLY": "COMMENSURABLE, measurable by the same standard; proportionate [adv]\n",
  "COMMENSURATE": "corresponding in size, extent, amount, or degree, proportionate [adj COMMENSURATELY]\n",
  "COMMENSURATELY": "COMMENSURATE, corresponding in size, extent, amount, or degree, proportionate [adv]\n",
  "COMMENSURATION": "measurement by the same standard [n -S]\n",
  "COMMENSURATIONS": "COMMENSURATION, measurement by the same standard [n]\n",
  "COMMENT": "to remark [v -ED, -ING, -S]\n",
  "COMMENTARIAL": "of or like a commentary [adj]\n",
  "COMMENTARIAT": "the group of people who provide opinion and analysis of events in the news [n -S]\n",
  "COMMENTARIATS": "COMMENTARIAT, the group of people who provide opinion and analysis of events in the news [n]\n",
  "COMMENTARIES": "COMMENTARY, an explanatory treatise [n]\n",
  "COMMENTARY": "an explanatory treatise [n COMMENTARIES]\n",
  "COMMENTATE": "to give a commentary on [v COMMENTATED, COMMENTATING, COMMENTATES]\n",
  "COMMENTATED": "COMMENTATE, to give a commentary on [v]\n",
  "COMMENTATES": "COMMENTATE, to give a commentary on [v]\n",
  "COMMENTATING": "COMMENTATE, to give a commentary on [v]\n",
  "COMMENTATION": "annotation [n -S]\n",
  "COMMENTATIONS": "COMMENTATION, annotation [n]\n",
  "COMMENTATOR": "one who gives a commentary [n -S]\n",
  "COMMENTATORIAL": "relating to the making of commentaries [adj]\n",
  "COMMENTATORS": "COMMENTATOR, one who gives a commentary [n]\n",
  "COMMENTED": "COMMENT, to remark [v]\n",
  "COMMENTER": "one who comments, also COMMENTOR [n -S]\n",
  "COMMENTERS": "COMMENTER, one who comments, also COMMENTOR [n]\n",
  "COMMENTING": "COMMENT, to remark [v]\n",
  "COMMENTOR": "one who comments, also COMMENTER [n -S]\n",
  "COMMENTORS": "COMMENTOR, one who comments, also COMMENTER [n]\n",
  "COMMENTS": "COMMENT, to remark [v]\n",
  "COMMER": "(archaic) a comer [n -S]\n",
  "COMMERCE": "to engage in trade [v COMMERCED, COMMERCING, COMMERCES]\n",
  "COMMERCED": "COMMERCE, to engage in trade [v]\n",
  "COMMERCES": "COMMERCE, to engage in trade [v]\n",
  "COMMERCIAL": "related to commerce [adj COMMERCIALLY] / an advertisement broadcast on radio or television [n -S]\n",
  "COMMERCIALESE": "the jargon of commerce [n -S]\n",
  "COMMERCIALESES": "COMMERCIALESE, the jargon of commerce [n]\n",
  "COMMERCIALISE": "to make commercial, also COMMERCIALIZE [v COMMERCIALISED, COMMERCIALISING, COMMERCIALISES]\n",
  "COMMERCIALISED": "COMMERCIALISE, to make commercial, also COMMERCIALIZE [v]\n",
  "COMMERCIALISES": "COMMERCIALISE, to make commercial, also COMMERCIALIZE [v]\n",
  "COMMERCIALISING": "COMMERCIALISE, to make commercial, also COMMERCIALIZE [v]\n",
  "COMMERCIALISM": "commercial spirit, institutions, or methods [n -S]\n",
  "COMMERCIALISMS": "COMMERCIALISM, commercial spirit, institutions, or methods [n]\n",
  "COMMERCIALIST": "an advocate of commercialism [n -S]\n",
  "COMMERCIALISTIC": "relating to commercialism [adj]\n",
  "COMMERCIALISTS": "COMMERCIALIST, an advocate of commercialism [n]\n",
  "COMMERCIALITIES": "COMMERCIALITY, the quality of being commercial [n]\n",
  "COMMERCIALITY": "the quality of being commercial [n COMMERCIALITIES]\n",
  "COMMERCIALIZE": "to manage on a business basis for profit, also COMMERCIALISE [v COMMERCIALIZED, COMMERCIALIZING, COMMERCIALIZES]\n",
  "COMMERCIALIZED": "COMMERCIALIZE, to manage on a business basis for profit, also COMMERCIALISE [v]\n",
  "COMMERCIALIZES": "COMMERCIALIZE, to manage on a business basis for profit, also COMMERCIALISE [v]\n",
  "COMMERCIALIZING": "COMMERCIALIZE, to manage on a business basis for profit, also COMMERCIALISE [v]\n",
  "COMMERCIALLY": "COMMERCIAL, related to commerce [adv]\n",
  "COMMERCIALS": "COMMERCIAL, an advertisement broadcast on radio or television [n]\n",
  "COMMERCING": "COMMERCE, to engage in trade [v]\n",
  "COMMERE": "(French) a female compere [n -S]\n",
  "COMMERES": "COMMERE, (French) a female compere [n]\n",
  "COMMERGE": "to merge together [v COMMERGED, COMMERGING, COMMERGES]\n",
  "COMMERGED": "COMMERGE, to merge together [v]\n",
  "COMMERGES": "COMMERGE, to merge together [v]\n",
  "COMMERGING": "COMMERGE, to merge together [v]\n",
  "COMMERS": "COMMER, (archaic) a comer [n]\n",
  "COMMIE": "(colloquial) a communist, also COMMO, COMMY [n -S]\n",
  "COMMIES": "COMMIE, (colloquial) a communist, also COMMO, COMMY [n]\n",
  "COMMINATE": "to threaten; to denounce [v COMMINATED, COMMINATING, COMMINATES]\n",
  "COMMINATED": "COMMINATE, to threaten; to denounce [v]\n",
  "COMMINATES": "COMMINATE, to threaten; to denounce [v]\n",
  "COMMINATING": "COMMINATE, to threaten; to denounce [v]\n",
  "COMMINATION": "the threatening of divine vengeance [n -S]\n",
  "COMMINATIONS": "COMMINATION, the threatening of divine vengeance [n]\n",
  "COMMINATIVE": "threatening punishment, also COMMINATORY [adj]\n",
  "COMMINATORY": "threatening punishment, also COMMINATIVE [adj]\n",
  "COMMINGLE": "to mix together, also COMINGLE [v COMMINGLED, COMMINGLING, COMMINGLES]\n",
  "COMMINGLED": "COMMINGLE, to mix together, also COMINGLE [v]\n",
  "COMMINGLES": "COMMINGLE, to mix together, also COMINGLE [v]\n",
  "COMMINGLING": "COMMINGLE, to mix together, also COMINGLE [v]\n",
  "COMMINUTE": "to crush, pulverize [v COMMINUTED, COMMINUTING, COMMINUTES]\n",
  "COMMINUTED": "COMMINUTE, to crush, pulverize [v]\n",
  "COMMINUTES": "COMMINUTE, to crush, pulverize [v]\n",
  "COMMINUTING": "COMMINUTE, to crush, pulverize [v]\n",
  "COMMINUTION": "the act of comminuting [n -S]\n",
  "COMMINUTIONS": "COMMINUTION, the act of comminuting [n]\n",
  "COMMIS": "(French) a deputy, a clerk; a junior waiter or chef [n COMMIS]\n",
  "COMMISERABLE": "able to be commiserated with [adj]\n",
  "COMMISERATE": "to feel or express sympathy [v COMMISERATED, COMMISERATING, COMMISERATES]\n",
  "COMMISERATED": "COMMISERATE, to feel or express sympathy [v]\n",
  "COMMISERATES": "COMMISERATE, to feel or express sympathy [v]\n",
  "COMMISERATING": "COMMISERATE, to feel or express sympathy [v]\n",
  "COMMISERATINGLY": "COMMISERATING, COMMISERATE, to feel or express sympathy [adv]\n",
  "COMMISERATION": "the act of commiserating [n -S]\n",
  "COMMISERATIONS": "COMMISERATION, the act of commiserating [n]\n",
  "COMMISERATIVE": "showing commiseration [adj COMMISERATIVELY]\n",
  "COMMISERATIVELY": "COMMISERATIVE, showing commiseration [adv]\n",
  "COMMISERATOR": "one who commiserates [n -S]\n",
  "COMMISERATORS": "COMMISERATOR, one who commiserates [n]\n",
  "COMMISH": "(short for) commissioner [n -ES]\n",
  "COMMISHES": "COMMISH, (short for) commissioner [n]\n",
  "COMMISSAIRE": "in professional cycle racing, a referee who travels in an open-topped car with the riders to witness any infringement of the rules [n -S]\n",
  "COMMISSAIRES": "COMMISSAIRE, in professional cycle racing, a referee who travels in an open-topped car with the riders to witness any infringement of the rules [n]\n",
  "COMMISSAR": "the head of a government department in the USSR [n -S]\n",
  "COMMISSARIAL": "of or like a commissar [adj]\n",
  "COMMISSARIAT": "a department, esp. military, for the supply of food etc.; food supplied; a government department in the USSR [n -S]\n",
  "COMMISSARIATS": "COMMISSARIAT, a department, esp. military, for the supply of food etc.; food supplied; a government department in the USSR [n]\n",
  "COMMISSARIES": "COMMISSARY, one to whom is committed some charge, duty, or office, by a superior power [n]\n",
  "COMMISSARS": "COMMISSAR, the head of a government department in the USSR [n]\n",
  "COMMISSARY": "one to whom is committed some charge, duty, or office, by a superior power [n COMMISSARIES]\n",
  "COMMISSARYSHIP": "the office of commissary [n -S]\n",
  "COMMISSARYSHIPS": "COMMISSARYSHIP, the office of commissary [n]\n",
  "COMMISSION": "an order for a piece of work [n -S] / to empower, to appoint [v -ED, -ING, -S]\n",
  "COMMISSIONAIRE": "a uniformed attendant [n -S]\n",
  "COMMISSIONAIRES": "COMMISSIONAIRE, a uniformed attendant [n]\n",
  "COMMISSIONAL": "of or like a commission, also COMMISSIONARY [adj]\n",
  "COMMISSIONARY": "of or like a commission, also COMMISSIONAL [adj]\n",
  "COMMISSIONED": "COMMISSION, to empower, to appoint [v]\n",
  "COMMISSIONER": "a person who holds a commission [n -S]\n",
  "COMMISSIONERS": "COMMISSIONER, a person who holds a commission [n]\n",
  "COMMISSIONING": "COMMISSION, to empower, to appoint [v]\n",
  "COMMISSIONS": "COMMISSION, to empower, to appoint [v]\n",
  "COMMISSURAL": "like a commissure, a joint, a joining surface [adj]\n",
  "COMMISSURE": "a joint, a joining surface [n -S]\n",
  "COMMISSURES": "COMMISSURE, a joint, a joining surface [n]\n",
  "COMMIT": "to perpetrate [v COMMITTED, COMMITTING, COMMITS]\n",
  "COMMITMENT": "the state of being committed [n -S]\n",
  "COMMITMENTS": "COMMITMENT, the state of being committed [n]\n",
  "COMMITS": "COMMIT, to perpetrate [v]\n",
  "COMMITTABLE": "that can be committed [adj]\n",
  "COMMITTAL": "the act of committing e.g. to trial [n -S]\n",
  "COMMITTALS": "COMMITTAL, the act of committing e.g. to trial [n]\n",
  "COMMITTED": "COMMIT, to perpetrate [v]\n",
  "COMMITTEE": "a group selected from a more numerous body (or the whole body) to which some special business is committed [n -S]\n",
  "COMMITTEEMAN": "a member of a committee [n COMMITTEEMEN]\n",
  "COMMITTEEMEN": "COMMITTEEMAN, a member of a committee [n]\n",
  "COMMITTEES": "COMMITTEE, a group selected from a more numerous body (or the whole body) to which some special business is committed [n]\n",
  "COMMITTEESHIP": "the office of committee [n -S]\n",
  "COMMITTEESHIPS": "COMMITTEESHIP, the office of committee [n]\n",
  "COMMITTEEWOMAN": "a woman who is a member of a committee [n COMMITTEEWOMEN]\n",
  "COMMITTEEWOMEN": "COMMITTEEWOMAN, a woman who is a member of a committee [n]\n",
  "COMMITTER": "one who commits [n -S]\n",
  "COMMITTERS": "COMMITTER, one who commits [n]\n",
  "COMMITTING": "COMMIT, to perpetrate [v]\n",
  "COMMIX": "to mix together [v COMMIXT or COMMIXED, COMMIXING, COMMIXES]\n",
  "COMMIXED": "COMMIX, to mix together [v]\n",
  "COMMIXES": "COMMIX, to mix together [v]\n",
  "COMMIXING": "COMMIX, to mix together [v]\n",
  "COMMIXT": "COMMIX, to mix together [v]\n",
  "COMMIXTION": "commixture; mingling [n -S]\n",
  "COMMIXTIONS": "COMMIXTION, commixture; mingling [n]\n",
  "COMMIXTURE": "the act of mixing [n -S]\n",
  "COMMIXTURES": "COMMIXTURE, the act of mixing [n]\n",
  "COMMO": "(Australian colloquial) a communist, also COMMIE, COMMY [n -S]\n",
  "COMMODE": "(French) a chamberpot enclosed in a chair or box with a cover [n -S]\n",
  "COMMODES": "COMMODE, (French) a chamberpot enclosed in a chair or box with a cover [n]\n",
  "COMMODIFICATION": "the act of commodifying [n]\n",
  "COMMODIFIED": "COMMODIFY, to make a commodity of something [v]\n",
  "COMMODIFIES": "COMMODIFY, to make a commodity of something [v]\n",
  "COMMODIFY": "to make a commodity of something [v COMMODIFIED, COMMODIFYING, COMMODIFIES]\n",
  "COMMODIFYING": "COMMODIFY, to make a commodity of something [v]\n",
  "COMMODIOUS": "roomy, capacious [adj COMMODIOUSLY]\n",
  "COMMODIOUSLY": "COMMODIOUS, roomy, capacious [adv]\n",
  "COMMODIOUSNESS": "the state of being commodious [n]\n",
  "COMMODITIES": "COMMODITY, an article of trade [n]\n",
  "COMMODITISE": "to make into a commodity, also COMMODITIZE [v COMMODITISED, COMMODITISING, COMMODITISES]\n",
  "COMMODITISED": "COMMODITISE, to make into a commodity, also COMMODITIZE [v]\n",
  "COMMODITISES": "COMMODITISE, to make into a commodity, also COMMODITIZE [v]\n",
  "COMMODITISING": "COMMODITISE, to make into a commodity, also COMMODITIZE [v]\n",
  "COMMODITIZE": "to make into a commodity, also COMMODITISE [v COMMODITIZED, COMMODITIZING, COMMODITIZES]\n",
  "COMMODITIZED": "COMMODITIZE, to make into a commodity, also COMMODITISE [v]\n",
  "COMMODITIZES": "COMMODITIZE, to make into a commodity, also COMMODITISE [v]\n",
  "COMMODITIZING": "COMMODITIZE, to make into a commodity, also COMMODITISE [v]\n",
  "COMMODITY": "an article of trade [n COMMODITIES]\n",
  "COMMODO": "(Italian) of music, to be played in a relaxed style, also COMODO [adj]\n",
  "COMMODORE": "an officer of a rank between an admiral and a captain; the senior captain in a fleet of merchant ships [n -S]\n",
  "COMMODORES": "COMMODORE, an officer of a rank between an admiral and a captain; the senior captain in a fleet of merchant ships [n]\n",
  "COMMON": "to share [v -ED, -ING, -S] / ordinary [adj COMMONER, COMMONEST, COMMONLY]\n",
  "COMMONABLE": "held in common, mutual [adj]\n",
  "COMMONAGE": "the right of pasturing on a common [n -S]\n",
  "COMMONAGES": "COMMONAGE, the right of pasturing on a common [n]\n",
  "COMMONALITIES": "COMMONALITY, the common people [n]\n",
  "COMMONALITY": "the common people [n COMMONALITIES]\n",
  "COMMONALTIES": "COMMONALTY, common people; the general populace [n]\n",
  "COMMONALTY": "common people; the general populace [n COMMONALTIES]\n",
  "COMMONED": "COMMON, to share [v]\n",
  "COMMONER": "one of the common people [n -S]\n",
  "COMMONERS": "COMMONER, one of the common people [n]\n",
  "COMMONEST": "COMMON, ordinary [adj]\n",
  "COMMONEY": "an ordinary playing marble [n -S]\n",
  "COMMONEYS": "COMMONEY, an ordinary playing marble [n]\n",
  "COMMONHOLD": "a freehold held in common by a number of owners [n -S]\n",
  "COMMONHOLDS": "COMMONHOLD, a freehold held in common by a number of owners [n]\n",
  "COMMONING": "the conversion of land to common [n -S]\n",
  "COMMONINGS": "COMMONING, the conversion of land to common [n]\n",
  "COMMONLY": "COMMON, ordinary [adv]\n",
  "COMMONNESS": "the state of being common [n -ES]\n",
  "COMMONNESSES": "COMMONNESS, the state of being common [n]\n",
  "COMMONPLACE": "ordinary [adj] / to put in a commonplace book, a book of truisms [v COMMONPLACED, COMMONPLACING, COMMONPLACES]\n",
  "COMMONPLACED": "COMMONPLACE, to put in a commonplace book, a book of truisms [v]\n",
  "COMMONPLACENESS": "the state of being commonplace (ordinary) [n]\n",
  "COMMONPLACES": "COMMONPLACE, to put in a commonplace book, a book of truisms [v]\n",
  "COMMONPLACING": "COMMONPLACE, to put in a commonplace book, a book of truisms [v]\n",
  "COMMONS": "COMMON, to share [v]\n",
  "COMMONSENSE": "relating to practical wisdom [adj]\n",
  "COMMONSENSIBLE": "showing common sense, also COMMONSENSICAL [adj]\n",
  "COMMONSENSICAL": "showing common sense, also COMMONSENSIBLE [adj]\n",
  "COMMONWEAL": "(archaic) the general welfare [n -S]\n",
  "COMMONWEALS": "COMMONWEAL, (archaic) the general welfare [n]\n",
  "COMMONWEALTH": "the public or whole body of the people [n -S]\n",
  "COMMONWEALTHS": "COMMONWEALTH, the public or whole body of the people [n]\n",
  "COMMORANT": "a resident, esp. at a university [n -S]\n",
  "COMMORANTS": "COMMORANT, a resident, esp. at a university [n]\n",
  "COMMORIENTES": "persons who die together on the same occasion, where it cannot be determined which died first, and death is assumed to have taken place in order of seniority by age [n]\n",
  "COMMOS": "COMMO, (Australian colloquial) a communist, also COMMIE, COMMY [n]\n",
  "COMMOT": "an early English land division, also COMMOTE [n -S]\n",
  "COMMOTE": "an early English land division, also COMMOT [n -S]\n",
  "COMMOTES": "COMMOTE, an early English land division, also COMMOT [n]\n",
  "COMMOTION": "a violent motion or moving [n -S]\n",
  "COMMOTIONAL": "relating to commotion [adj]\n",
  "COMMOTIONS": "COMMOTION, a violent motion or moving [n]\n",
  "COMMOTS": "COMMOT, an early English land division, also COMMOTE [n]\n",
  "COMMOVE": "to move violently [v COMMOVED, COMMOVING, COMMOVES]\n",
  "COMMOVED": "COMMOVE, to move violently [v]\n",
  "COMMOVES": "COMMOVE, to move violently [v]\n",
  "COMMOVING": "COMMOVE, to move violently [v]\n",
  "COMMS": "(short for) communications [n]\n",
  "COMMUNAL": "belonging to the community [adj]\n",
  "COMMUNALISATION": "the process of communalising, also COMMUNALIZATION [n]\n",
  "COMMUNALISE": "to make communal, also COMMUNALIZE [v COMMUNALISED, COMMUNALISING, COMMUNALISES]\n",
  "COMMUNALISED": "COMMUNALISE, to make communal, also COMMUNALIZE [v]\n",
  "COMMUNALISER": "one who communalises, also COMMUNALIZER [n -S]\n",
  "COMMUNALISERS": "COMMUNALISER, one who communalises, also COMMUNALIZER [n]\n",
  "COMMUNALISES": "COMMUNALISE, to make communal, also COMMUNALIZE [v]\n",
  "COMMUNALISING": "COMMUNALISE, to make communal, also COMMUNALIZE [v]\n",
  "COMMUNALISM": "social organization on a communal basis [n -S]\n",
  "COMMUNALISMS": "COMMUNALISM, social organization on a communal basis [n]\n",
  "COMMUNALIST": "an adherent of communalism [n -S]\n",
  "COMMUNALISTIC": "relating to communalism, social organization on a communal basis [adj]\n",
  "COMMUNALISTS": "COMMUNALIST, an adherent of communalism [n]\n",
  "COMMUNALITIES": "COMMUNALITY, the state of being communal [n]\n",
  "COMMUNALITY": "the state of being communal [n COMMUNALITIES]\n",
  "COMMUNALIZATION": "the process of communalizing, also COMMUNALISATION [n]\n",
  "COMMUNALIZE": "to make communal, also COMMUNALISE [v COMMUNALIZED, COMMUNALIZING, COMMUNALIZES]\n",
  "COMMUNALIZED": "COMMUNALIZE, to make communal, also COMMUNALISE [v]\n",
  "COMMUNALIZER": "one who communalizes, also COMMUNALISER [n -S]\n",
  "COMMUNALIZERS": "COMMUNALIZER, one who communalizes, also COMMUNALISER [n]\n",
  "COMMUNALIZES": "COMMUNALIZE, to make communal, also COMMUNALISE [v]\n",
  "COMMUNALIZING": "COMMUNALIZE, to make communal, also COMMUNALISE [v]\n",
  "COMMUNALLY": "COMMUNAL, belonging to the community [adv]\n",
  "COMMUNARD": "(French) a member of a commune; a communist [n -S]\n",
  "COMMUNARDS": "COMMUNARD, (French) a member of a commune; a communist [n]\n",
  "COMMUNAUTAIRE": "a spirit or attitude in keeping with or appropriate to the aims and principles of the European Union [n -S]\n",
  "COMMUNAUTAIRES": "COMMUNAUTAIRE, a spirit or attitude in keeping with or appropriate to the aims and principles of the European Union [n]\n",
  "COMMUNE": "to converse intimately [v COMMUNED, COMMUNING, COMMUNES]\n",
  "COMMUNED": "COMMUNE, to converse intimately [v]\n",
  "COMMUNER": "one who communes [n -S]\n",
  "COMMUNERS": "COMMUNER, one who communes [n]\n",
  "COMMUNES": "COMMUNE, to converse intimately [v]\n",
  "COMMUNICABILITY": "the state of being communicable [n]\n",
  "COMMUNICABLE": "capable of being communicated [adj COMMUNICABLY]\n",
  "COMMUNICABLY": "COMMUNICABLE, capable of being communicated [adv]\n",
  "COMMUNICANT": "one taking part in communion [n -S]\n",
  "COMMUNICANTS": "COMMUNICANT, one taking part in communion [n]\n",
  "COMMUNICATE": "to exchange information [v COMMUNICATED, COMMUNICATING, COMMUNICATES]\n",
  "COMMUNICATED": "COMMUNICATE, to exchange information [v]\n",
  "COMMUNICATEE": "one who is communicated with [n -S]\n",
  "COMMUNICATEES": "COMMUNICATEE, one who is communicated with [n]\n",
  "COMMUNICATES": "COMMUNICATE, to exchange information [v]\n",
  "COMMUNICATING": "COMMUNICATE, to exchange information [v]\n",
  "COMMUNICATION": "an act or instance of transmitting [n -S]\n",
  "COMMUNICATIONAL": "relating to communication [adj]\n",
  "COMMUNICATIONS": "COMMUNICATION, an act or instance of transmitting [n]\n",
  "COMMUNICATIVE": "tending to communicate [adj COMMUNICATIVELY]\n",
  "COMMUNICATIVELY": "COMMUNICATIVE, tending to communicate [adv]\n",
  "COMMUNICATOR": "one who communicates [n -S]\n",
  "COMMUNICATORS": "COMMUNICATOR, one who communicates [n]\n",
  "COMMUNICATORY": "designed to communicate information [adj]\n",
  "COMMUNING": "the act of communing [n -S]\n",
  "COMMUNINGS": "COMMUNING, the act of communing [n]\n",
  "COMMUNION": "the act of communing [n -S]\n",
  "COMMUNIONAL": "related to communion [adj COMMUNIONALLY]\n",
  "COMMUNIONALLY": "COMMUNIONAL, related to communion [adv]\n",
  "COMMUNIONS": "COMMUNION, the act of communing [n]\n",
  "COMMUNIQUE": "(French) an official communication; esp. an official statement reporting on a meeting, conference etc. [n -S]\n",
  "COMMUNIQUES": "COMMUNIQUE, (French) an official communication; esp. an official statement reporting on a meeting, conference etc. [n]\n",
  "COMMUNISATION": "the act of communising, also COMMUNIZATION [n -S]\n",
  "COMMUNISATIONS": "COMMUNISATION, the act of communising, also COMMUNIZATION [n]\n",
  "COMMUNISE": "to make common property; to make communist, also COMMUNIZE [v COMMUNISED, COMMUNISING, COMMUNISES]\n",
  "COMMUNISED": "COMMUNISE, to make common property; to make communist, also COMMUNIZE [v]\n",
  "COMMUNISES": "COMMUNISE, to make common property; to make communist, also COMMUNIZE [v]\n",
  "COMMUNISING": "COMMUNISE, to make common property; to make communist, also COMMUNIZE [v]\n",
  "COMMUNISM": "a social theory according to which society should be classless, private property should be abolished, and land, factories, etc. collectively owned and controlled [n -S]\n",
  "COMMUNISMS": "COMMUNISM, a social theory according to which society should be classless, private property should be abolished, and land, factories, etc. collectively owned and controlled [n]\n",
  "COMMUNIST": "one who believes in communism [n -S]\n",
  "COMMUNISTIC": "inclined to communism [adj COMMUNISTICALLY]\n",
  "COMMUNISTICALLY": "COMMUNISTIC, inclined to communism [adv]\n",
  "COMMUNISTS": "COMMUNIST, one who believes in communism [n]\n",
  "COMMUNITAIRE": "one with a spirit or attitude in keeping with or appropriate to the aims and principles of the European Union [n -S]\n",
  "COMMUNITAIRES": "COMMUNITAIRE, one with a spirit or attitude in keeping with or appropriate to the aims and principles of the European Union [n]\n",
  "COMMUNITARIAN": "a member of a community; an advocate of living in communities [n -S]\n",
  "COMMUNITARIANS": "COMMUNITARIAN, a member of a community; an advocate of living in communities [n]\n",
  "COMMUNITIES": "COMMUNITY, a body of people in the same locality [n]\n",
  "COMMUNITY": "a body of people in the same locality [n COMMUNITIES]\n",
  "COMMUNIZATION": "the act of communizing, also COMMUNISATION [n -S]\n",
  "COMMUNIZATIONS": "COMMUNIZATION, the act of communizing, also COMMUNISATION [n]\n",
  "COMMUNIZE": "to make common property; to make communist, also COMMUNISE [v COMMUNIZED, COMMUNIZING, COMMUNIZES]\n",
  "COMMUNIZED": "COMMUNIZE, to make common property; to make communist, also COMMUNISE [v]\n",
  "COMMUNIZES": "COMMUNIZE, to make common property; to make communist, also COMMUNISE [v]\n",
  "COMMUNIZING": "COMMUNIZE, to make common property; to make communist, also COMMUNISE [v]\n",
  "COMMUTABILITIES": "COMMUTABILITY, the quality of being commutable [n]\n",
  "COMMUTABILITY": "the quality of being commutable [n COMMUTABILITIES]\n",
  "COMMUTABLE": "able to be commuted [adj]\n",
  "COMMUTABLENESS": "the state of being commutable [n]\n",
  "COMMUTATE": "to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTE [v COMMUTATED, COMMUTATING, COMMUTATES]\n",
  "COMMUTATED": "COMMUTATE, to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTE [v]\n",
  "COMMUTATES": "COMMUTATE, to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTE [v]\n",
  "COMMUTATING": "COMMUTATE, to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTE [v]\n",
  "COMMUTATION": "the exchange of the death sentence for a less severe punishment [n -S]\n",
  "COMMUTATIONS": "COMMUTATION, the exchange of the death sentence for a less severe punishment [n]\n",
  "COMMUTATIVE": "of, relating to, or showing commutation [adj COMMUTATIVELY]\n",
  "COMMUTATIVELY": "COMMUTATIVE, of, relating to, or showing commutation [adv]\n",
  "COMMUTATIVITIES": "COMMUTATIVITY, the property of being commutative [n]\n",
  "COMMUTATIVITY": "the property of being commutative [n COMMUTATIVITIES]\n",
  "COMMUTATOR": "a thing which commutes; specifically a device for commutating an electric current [n -S]\n",
  "COMMUTATORS": "COMMUTATOR, a thing which commutes; specifically a device for commutating an electric current [n]\n",
  "COMMUTE": "to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTATE [v COMMUTED, COMMUTING, COMMUTES]\n",
  "COMMUTED": "COMMUTE, to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTATE [v]\n",
  "COMMUTER": "one who commutes; esp. one who commutes in traveling [n -S]\n",
  "COMMUTERS": "COMMUTER, one who commutes; esp. one who commutes in traveling [n]\n",
  "COMMUTES": "COMMUTE, to change a sentence, esp. the death sentence, for a less severe punishment, also COMMUTATE [v]\n",
  "COMMUTING": "travelling to work [n -S]\n",
  "COMMUTINGS": "COMMUTING, travelling to work [n]\n",
  "COMMUTUAL": "mutual, reciprocal [adj]\n",
  "COMMY": "a Communist, also COMMIE [n COMMIES]\n",
  "COMODO": "(Italian) musically in a relaxed style, also COMMODO [adj]\n",
  "COMONOMER": "one of the constituents of a copolymer [n -S]\n",
  "COMONOMERS": "COMONOMER, one of the constituents of a copolymer [n]\n",
  "COMORBID": "pertaining to two diseases which occur together [adj]\n",
  "COMORBIDITIES": "COMORBIDITY, the state of being comorbid, of illness, occurring at the same time as other illnesses [n]\n",
  "COMORBIDITY": "the state of being comorbid, of illness, occurring at the same time as other illnesses [n COMORBIDITIES]\n",
  "COMOSE": "bearing a tuft of silky hairs, also COMOUS [adj]\n",
  "COMOUS": "bearing a tuft of silky hairs, also COMOSE [adj]\n",
  "COMP": "to work as a compositor [v -ED, -ING, -S]\n",
  "COMPACT": "to pack closely together [v -ED, -ING, -S] / closely fitted together [adj COMPACTER, COMPACTEST, COMPACTLY]\n",
  "COMPACTED": "COMPACT, to pack closely together [v]\n",
  "COMPACTEDLY": "COMPACTED, COMPACT, to pack closely together [adv]\n",
  "COMPACTEDNESS": "the state of being compacted [n -ES]\n",
  "COMPACTEDNESSES": "COMPACTEDNESS, the state of being compacted [n]\n",
  "COMPACTER": "one who compacts, also COMPACTOR [n -S]\n",
  "COMPACTERS": "COMPACTER, one who compacts, also COMPACTOR [n]\n",
  "COMPACTEST": "COMPACT, closely fitted together [adj]\n",
  "COMPACTIBLE": "that can be compacted [adj]\n",
  "COMPACTIFIED": "COMPACTIFY, to render compact [v]\n",
  "COMPACTIFIES": "COMPACTIFY, to render compact [v]\n",
  "COMPACTIFY": "to render compact [v COMPACTIFIED, COMPACTIFYING, COMPACTIFIES]\n",
  "COMPACTIFYING": "COMPACTIFY, to render compact [v]\n",
  "COMPACTING": "COMPACT, to pack closely together [v]\n",
  "COMPACTION": "the act of compacting [n -S]\n",
  "COMPACTIONS": "COMPACTION, the act of compacting [n]\n",
  "COMPACTLY": "COMPACT, closely fitted together [adv]\n",
  "COMPACTNESS": "the state of being compact [n -ES]\n",
  "COMPACTNESSES": "COMPACTNESS, the state of being compact [n]\n",
  "COMPACTOR": "one who compacts, also COMPACTER [n -S]\n",
  "COMPACTORS": "COMPACTOR, one who compacts, also COMPACTER [n]\n",
  "COMPACTS": "COMPACT, to pack closely together [v]\n",
  "COMPACTURE": "(Spenser) close union or knitting together [n -S]\n",
  "COMPACTURES": "COMPACTURE, (Spenser) close union or knitting together [n]\n",
  "COMPADRE": "(Spanish) a close friend [n -S]\n",
  "COMPADRES": "COMPADRE, (Spanish) a close friend [n]\n",
  "COMPAGE": "(obsolete) a system or structure of many parts united [n -S]\n",
  "COMPAGES": "COMPAGE, (obsolete) a system or structure of many parts united [n]\n",
  "COMPAGINATE": "to join; to connect [v COMPAGINATED, COMPAGINATING, COMPAGINATES]\n",
  "COMPAGINATED": "COMPAGINATE, to join; to connect [v]\n",
  "COMPAGINATES": "COMPAGINATE, to join; to connect [v]\n",
  "COMPAGINATING": "COMPAGINATE, to join; to connect [v]\n",
  "COMPAGINATION": "the act of compaginating [n -S]\n",
  "COMPAGINATIONS": "COMPAGINATION, the act of compaginating [n]\n",
  "COMPAND": "to put a signal through a compander (a system of clarifying sound) [v -ED, -ING, -S]\n",
  "COMPANDED": "COMPAND, to put a signal through a compander (a system of clarifying sound) [v]\n",
  "COMPANDER": "a system of transmitting or reproducing sound by compressing and then re-expanding the volume-range, also COMPANDOR [n -S]\n",
  "COMPANDERS": "COMPANDER, a system of transmitting or reproducing sound by compressing and then re-expanding the volume-range, also COMPANDOR [n]\n",
  "COMPANDING": "COMPAND, to put a signal through a compander (a system of clarifying sound) [v]\n",
  "COMPANDOR": "a system of transmitting or reproducing sound by compressing and then re-expanding the volume-range, also COMPANDER [n -S]\n",
  "COMPANDORS": "COMPANDOR, a system of transmitting or reproducing sound by compressing and then re-expanding the volume-range, also COMPANDER [n]\n",
  "COMPANDS": "COMPAND, to put a signal through a compander (a system of clarifying sound) [v]\n",
  "COMPANIABLE": "sociable, also COMPANIONABLE [adj]\n",
  "COMPANIED": "COMPANY, to associate with [v]\n",
  "COMPANIES": "COMPANY, to associate with [v]\n",
  "COMPANING": "(Spenser) accompanying [adj]\n",
  "COMPANION": "to keep someone company [v -ED, -ING, -S]\n",
  "COMPANIONABLE": "sociable, also COMPANIABLE [adj COMPANIONABLY]\n",
  "COMPANIONABLY": "COMPANIONABLE, sociable, also COMPANIABLE [adv]\n",
  "COMPANIONATE": "relating to or having the manner of companions [adj]\n",
  "COMPANIONED": "COMPANION, to keep someone company [v]\n",
  "COMPANIONHOOD": "the state of being a companion [n -S]\n",
  "COMPANIONHOODS": "COMPANIONHOOD, the state of being a companion [n]\n",
  "COMPANIONING": "COMPANION, to keep someone company [v]\n",
  "COMPANIONLESS": "without a companion [adj]\n",
  "COMPANIONS": "COMPANION, to keep someone company [v]\n",
  "COMPANIONSHIP": "the fellowship existing among companions [n -S]\n",
  "COMPANIONSHIPS": "COMPANIONSHIP, the fellowship existing among companions [n]\n",
  "COMPANIONWAY": "the stairs from upper deck of ship to lower deck [n -S]\n",
  "COMPANIONWAYS": "COMPANIONWAY, the stairs from upper deck of ship to lower deck [n]\n",
  "COMPANY": "to associate with [v COMPANIED, COMPANYING, COMPANIES]\n",
  "COMPANYING": "COMPANY, to associate with [v]\n",
  "COMPARABILITIES": "COMPARABILITY, the state of being comparable [n]\n",
  "COMPARABILITY": "the state of being comparable [n COMPARABILITIES]\n",
  "COMPARABLE": "that can be compared [adj COMPARABLY]\n",
  "COMPARABLENESS": "COMPARABLE, that can be compared [n]\n",
  "COMPARABLY": "COMPARABLE, that can be compared [adv]\n",
  "COMPARATIST": "one that uses a comparative method (as in the study of literature) [n -S]\n",
  "COMPARATISTS": "COMPARATIST, one that uses a comparative method (as in the study of literature) [n]\n",
  "COMPARATIVE": "of the nature of comparison [adj COMPARATIVELY] / one that compares with another esp. on equal footing [n -S]\n",
  "COMPARATIVELY": "COMPARATIVE, of the nature of comparison [adv]\n",
  "COMPARATIVENESS": "COMPARATIVE, of the nature of comparison [n]\n",
  "COMPARATIVES": "COMPARATIVE, one that compares with another esp. on equal footing [n]\n",
  "COMPARATIVIST": "one who conducts a comparative study [n -S]\n",
  "COMPARATIVISTS": "COMPARATIVIST, one who conducts a comparative study [n]\n",
  "COMPARATOR": "any device for comparing accurately, so as e.g. to detect deviations from a standard or to confirm identity [n -S]\n",
  "COMPARATORS": "COMPARATOR, any device for comparing accurately, so as e.g. to detect deviations from a standard or to confirm identity [n]\n",
  "COMPARE": "to scrutinise for similarities [v COMPARED, COMPARING, COMPARES]\n",
  "COMPARED": "COMPARE, to scrutinise for similarities [v]\n",
  "COMPARER": "one who compares [n -S]\n",
  "COMPARERS": "COMPARER, one who compares [n]\n",
  "COMPARES": "COMPARE, to scrutinise for similarities [v]\n",
  "COMPARING": "COMPARE, to scrutinise for similarities [v]\n",
  "COMPARISON": "the representing of one thing or person as like another [n -S]\n",
  "COMPARISONS": "COMPARISON, the representing of one thing or person as like another [n]\n",
  "COMPART": "to divide into parts [v -ED, -ING, -S]\n",
  "COMPARTED": "COMPART, to divide into parts [v]\n",
  "COMPARTING": "COMPART, to divide into parts [v]\n",
  "COMPARTMENT": "to put into compartments [v -ED, -ING, -S]\n",
  "COMPARTMENTAL": "relating to compartments [adj COMPARTMENTALLY]\n",
  "COMPARTMENTALLY": "COMPARTMENTAL, relating to compartments [adv]\n",
  "COMPARTMENTED": "COMPARTMENT, to put into compartments [v]\n",
  "COMPARTMENTING": "COMPARTMENT, to put into compartments [v]\n",
  "COMPARTMENTS": "COMPARTMENT, to put into compartments [v]\n",
  "COMPARTS": "COMPART, to divide into parts [v]\n",
  "COMPAS": "a popular music of Haiti [n COMPAS]\n",
  "COMPASS": "to surround or enclose [v -ED, -ING, -ES]\n",
  "COMPASSABLE": "that can be compassed [adj]\n",
  "COMPASSED": "COMPASS, to surround or enclose [v]\n",
  "COMPASSES": "COMPASS, to surround or enclose [v]\n",
  "COMPASSING": "contrivance, design [n -S]\n",
  "COMPASSINGS": "COMPASSING, contrivance, design [n]\n",
  "COMPASSION": "sympathetic consciousness of others' distress together with a desire to alleviate it [n -S] / (archaic) to pity [v -ED, -ING, -S]\n",
  "COMPASSIONABLE": "worthy of compassion [adj]\n",
  "COMPASSIONATE": "sympathetic [adj COMPASSIONATELY] / to show compassion [v COMPASSIONATED, COMPASSIONATING, COMPASSIONATES]\n",
  "COMPASSIONATED": "COMPASSIONATE, to show compassion [v]\n",
  "COMPASSIONATELY": "COMPASSIONATE, sympathetic [adv]\n",
  "COMPASSIONATES": "COMPASSIONATE, to show compassion [v]\n",
  "COMPASSIONATING": "COMPASSIONATE, to show compassion [v]\n",
  "COMPASSIONED": "COMPASSION, (archaic) to pity [v]\n",
  "COMPASSIONING": "COMPASSION, (archaic) to pity [v]\n",
  "COMPASSIONLESS": "without compassion [adj]\n",
  "COMPASSIONS": "COMPASSION, (archaic) to pity [v]\n",
  "COMPAST": "(archaic) rounded [adj]\n",
  "COMPATIBILITIES": "COMPATIBILITY, the quality of being compatible [n]\n",
  "COMPATIBILITY": "the quality of being compatible [n COMPATIBILITIES]\n",
  "COMPATIBLE": "consistent with [adj COMPATIBLY] / something compatible [n -S]\n",
  "COMPATIBLENESS": "the state of being compatible [n]\n",
  "COMPATIBLES": "COMPATIBLE, something compatible [n]\n",
  "COMPATIBLY": "COMPATIBLE, consistent with [adv]\n",
  "COMPATRIOT": "a person born, residing, or holding citizenship in the same country as another, also COPATRIOT [n -S]\n",
  "COMPATRIOTIC": "of or like a compatriot [adj]\n",
  "COMPATRIOTISM": "the state of being a compatriot, a person born, residing, or holding citizenship in the same country as another [n -S]\n",
  "COMPATRIOTISMS": "COMPATRIOTISM, the state of being a compatriot, a person born, residing, or holding citizenship in the same country as another [n]\n",
  "COMPATRIOTS": "COMPATRIOT, a person born, residing, or holding citizenship in the same country as another, also COPATRIOT [n]\n",
  "COMPEAR": "to appear in court [v -ED, -ING, -S]\n",
  "COMPEARANCE": "the state of being a compearant [n -S]\n",
  "COMPEARANCES": "COMPEARANCE, the state of being a compearant [n]\n",
  "COMPEARANT": "(Scots) one who compears, appears in court [n -S]\n",
  "COMPEARANTS": "COMPEARANT, (Scots) one who compears, appears in court [n]\n",
  "COMPEARED": "COMPEAR, to appear in court [v]\n",
  "COMPEARING": "COMPEAR, to appear in court [v]\n",
  "COMPEARS": "COMPEAR, to appear in court [v]\n",
  "COMPED": "COMP, to work as a compositor [v]\n",
  "COMPEER": "to be the equal of [v -ED, -ING, -S]\n",
  "COMPEERED": "COMPEER, to be the equal of [v]\n",
  "COMPEERING": "COMPEER, to be the equal of [v]\n",
  "COMPEERS": "COMPEER, to be the equal of [v]\n",
  "COMPEL": "to force [v COMPELLED, COMPELLING, COMPELS]\n",
  "COMPELLABLE": "that can be compelled [adj COMPELLABLY]\n",
  "COMPELLABLY": "COMPELLABLE, that can be compelled [adv]\n",
  "COMPELLATION": "the act of addressing someone by name [n -S]\n",
  "COMPELLATIONS": "COMPELLATION, the act of addressing someone by name [n]\n",
  "COMPELLATIVE": "compellation [n -S]\n",
  "COMPELLATIVES": "COMPELLATIVE, compellation [n]\n",
  "COMPELLED": "COMPEL, to force [v]\n",
  "COMPELLER": "one who compels [n -S]\n",
  "COMPELLERS": "COMPELLER, one who compels [n]\n",
  "COMPELLING": "COMPEL, to force [v]\n",
  "COMPELLINGLY": "COMPELLING, COMPEL, to force [adv]\n",
  "COMPELS": "COMPEL, to force [v]\n",
  "COMPEND": "a brief summary [n -S]\n",
  "COMPENDIA": "COMPENDIUM, (Latin) an assortment, a varied collection [n]\n",
  "COMPENDIOUS": "concise but comprehensive [adj COMPENDIOUSLY]\n",
  "COMPENDIOUSLY": "COMPENDIOUS, concise but comprehensive [adv]\n",
  "COMPENDIOUSNESS": "the state of being compendious [n]\n",
  "COMPENDIUM": "(Latin) an assortment, a varied collection [n COMPENDIA or COMPENDIUMS]\n",
  "COMPENDIUMS": "COMPENDIUM, (Latin) an assortment, a varied collection [n]\n",
  "COMPENDS": "COMPEND, a brief summary [n]\n",
  "COMPENSABILITY": "the state of being compensable [n]\n",
  "COMPENSABLE": "that is to be or can be compensated [adj]\n",
  "COMPENSATE": "to be equivalent to [v COMPENSATED, COMPENSATING, COMPENSATES]\n",
  "COMPENSATED": "COMPENSATE, to be equivalent to [v]\n",
  "COMPENSATES": "COMPENSATE, to be equivalent to [v]\n",
  "COMPENSATING": "COMPENSATE, to be equivalent to [v]\n",
  "COMPENSATION": "the act of compensating [n -S]\n",
  "COMPENSATIONAL": "relating to compensation, also COMPENSATIVE [adj]\n",
  "COMPENSATIONS": "COMPENSATION, the act of compensating [n]\n",
  "COMPENSATIVE": "relating to compensation, also COMPENSATIONAL [adj]\n",
  "COMPENSATOR": "one who compensates [n -S]\n",
  "COMPENSATORS": "COMPENSATOR, one who compensates [n]\n",
  "COMPENSATORY": "relating to compensate [adj]\n",
  "COMPER": "a person who enters competitions [n -S]\n",
  "COMPERE": "(French) to act as master of ceremonies [v COMPERED, COMPERING, COMPERES]\n",
  "COMPERED": "COMPERE, (French) to act as master of ceremonies [v]\n",
  "COMPERES": "COMPERE, (French) to act as master of ceremonies [v]\n",
  "COMPERING": "COMPERE, (French) to act as master of ceremonies [v]\n",
  "COMPERS": "COMPER, a person who enters competitions [n]\n",
  "COMPESCE": "(archaic) to restrain [v COMPESCED, COMPESCING, COMPESCES]\n",
  "COMPESCED": "COMPESCE, (archaic) to restrain [v]\n",
  "COMPESCES": "COMPESCE, (archaic) to restrain [v]\n",
  "COMPESCING": "COMPESCE, (archaic) to restrain [v]\n",
  "COMPETE": "to contend for a prize [v COMPETED, COMPETING, COMPETES]\n",
  "COMPETED": "COMPETE, to contend for a prize [v]\n",
  "COMPETENCE": "the quality of being competent, also COMPETENCY [n -S]\n",
  "COMPETENCES": "COMPETENCE, the quality of being competent, also COMPETENCY [n]\n",
  "COMPETENCIES": "COMPETENCY, the quality of being competent, also COMPETENCE [n]\n",
  "COMPETENCY": "the quality of being competent, also COMPETENCE [n COMPETENCIES]\n",
  "COMPETENT": "able [adj COMPETENTLY]\n",
  "COMPETENTLY": "COMPETENT, able [adv]\n",
  "COMPETENTNESS": "COMPETENT, able [n]\n",
  "COMPETENTNESSES": "COMPETENTNESS, COMPETENT, able [n]\n",
  "COMPETES": "COMPETE, to contend for a prize [v]\n",
  "COMPETING": "COMPETE, to contend for a prize [v]\n",
  "COMPETITION": "the act of competing [n -S]\n",
  "COMPETITIONS": "COMPETITION, the act of competing [n]\n",
  "COMPETITIVE": "relating to competition [adj COMPETITIVELY]\n",
  "COMPETITIVELY": "COMPETITIVE, relating to competition [adv]\n",
  "COMPETITIVENESS": "COMPETITIVE, relating to competition [n]\n",
  "COMPETITOR": "one that competes [n -S]\n",
  "COMPETITORS": "COMPETITOR, one that competes [n]\n",
  "COMPILATION": "the act of compiling [n -S]\n",
  "COMPILATIONS": "COMPILATION, the act of compiling [n]\n",
  "COMPILATOR": "a compiler [n -S]\n",
  "COMPILATORS": "COMPILATOR, a compiler [n]\n",
  "COMPILATORY": "relating to a compilation [adj]\n",
  "COMPILE": "to collect into a volume [v COMPILED, COMPILING, COMPILES]\n",
  "COMPILED": "COMPILE, to collect into a volume [v]\n",
  "COMPILEMENT": "the act of compiling [n -S]\n",
  "COMPILEMENTS": "COMPILEMENT, the act of compiling [n]\n",
  "COMPILER": "one who compiles, esp. one who makes books by compilation [n -S]\n",
  "COMPILERS": "COMPILER, one who compiles, esp. one who makes books by compilation [n]\n",
  "COMPILES": "COMPILE, to collect into a volume [v]\n",
  "COMPILING": "COMPILE, to collect into a volume [v]\n",
  "COMPING": "the act of entering competitions [n -S]\n",
  "COMPINGS": "COMPING, the act of entering competitions [n]\n",
  "COMPITAL": "relating to crossroads, or to the intersection of leaf-veins [adj]\n",
  "COMPLACENCE": "self-satisfaction esp. when accompanied by unawareness of actual dangers or deficiencies, also COMPLACENCY [n -S]\n",
  "COMPLACENCES": "COMPLACENCE, self-satisfaction esp. when accompanied by unawareness of actual dangers or deficiencies, also COMPLACENCY [n]\n",
  "COMPLACENCIES": "COMPLACENCY, self-satisfaction esp. when accompanied by unawareness of actual dangers or deficiencies, also COMPLACENCE [n]\n",
  "COMPLACENCY": "self-satisfaction esp. when accompanied by unawareness of actual dangers or deficiencies, also COMPLACENCE [n COMPLACENCIES]\n",
  "COMPLACENT": "marked by complacency [adj COMPLACENTLY]\n",
  "COMPLACENTLY": "COMPLACENT, marked by complacency [adv]\n",
  "COMPLAIN": "to express discontent [v -ED, -ING, -S]\n",
  "COMPLAINANT": "one who complains [n -S]\n",
  "COMPLAINANTS": "COMPLAINANT, one who complains [n]\n",
  "COMPLAINED": "COMPLAIN, to express discontent [v]\n",
  "COMPLAINER": "one who complains [n -S]\n",
  "COMPLAINERS": "COMPLAINER, one who complains [n]\n",
  "COMPLAINING": "express discontent [adj COMPLAININGLY] / the act of complaining [n -S]\n",
  "COMPLAININGLY": "COMPLAINING, express discontent [adv]\n",
  "COMPLAININGS": "COMPLAINING, the act of complaining [n]\n",
  "COMPLAINS": "COMPLAIN, to express discontent [v]\n",
  "COMPLAINT": "an instance or the act of complaining [n -S]\n",
  "COMPLAINTS": "COMPLAINT, an instance or the act of complaining [n]\n",
  "COMPLAISANCE": "wishing to please or tending to comply with the wishes of others [n -S]\n",
  "COMPLAISANCES": "COMPLAISANCE, wishing to please or tending to comply with the wishes of others [n]\n",
  "COMPLAISANT": "wishing to please others; obliging [adj COMPLAISANTLY]\n",
  "COMPLAISANTLY": "COMPLAISANT, wishing to please others; obliging [adv]\n",
  "COMPLANATE": "flattened [adj]\n",
  "COMPLANATION": "the state of being flattened [n -S]\n",
  "COMPLANATIONS": "COMPLANATION, the state of being flattened [n]\n",
  "COMPLEAT": "(archaic) to complete [v -ED, -ING, -S]\n",
  "COMPLEATED": "COMPLEAT, (archaic) to complete [v]\n",
  "COMPLEATING": "COMPLEAT, (archaic) to complete [v]\n",
  "COMPLEATS": "COMPLEAT, (archaic) to complete [v]\n",
  "COMPLECT": "to weave together [v -ED, -ING, -S]\n",
  "COMPLECTED": "COMPLECT, to weave together [v]\n",
  "COMPLECTING": "COMPLECT, to weave together [v]\n",
  "COMPLECTS": "COMPLECT, to weave together [v]\n",
  "COMPLEMENT": "to be complementary to [v -ED, -ING, -S]\n",
  "COMPLEMENTAL": "relating to or being a complement [adj COMPLEMENTALLY]\n",
  "COMPLEMENTALLY": "COMPLEMENTAL, relating to or being a complement [adv]\n",
  "COMPLEMENTARIES": "COMPLEMENTARY, a complement [n]\n",
  "COMPLEMENTARILY": "COMPLEMENTARY, serving to complement [adv]\n",
  "COMPLEMENTARITY": "the state of being complementary [n]\n",
  "COMPLEMENTARY": "serving to complement [adj COMPLEMENTARILY] / a complement [n COMPLEMENTARIES]\n",
  "COMPLEMENTATION": "the operation of determining the complement of a mathematical set [n]\n",
  "COMPLEMENTED": "COMPLEMENT, to be complementary to [v]\n",
  "COMPLEMENTING": "COMPLEMENT, to be complementary to [v]\n",
  "COMPLEMENTISER": "a word or morpheme that serves to introduce a complement clause, also COMPLEMENTIZER [n -S]\n",
  "COMPLEMENTISERS": "COMPLEMENTISER, a word or morpheme that serves to introduce a complement clause, also COMPLEMENTIZER [n]\n",
  "COMPLEMENTIZER": "a word or morpheme that serves to introduce a complement clause, also COMPLEMENTISER [n -S]\n",
  "COMPLEMENTIZERS": "COMPLEMENTIZER, a word or morpheme that serves to introduce a complement clause, also COMPLEMENTISER [n]\n",
  "COMPLEMENTS": "COMPLEMENT, to be complementary to [v]\n",
  "COMPLETABLE": "that can be completed [adj]\n",
  "COMPLETE": "to bring to an end [v COMPLETED, COMPLETING, COMPLETES] / having all necessary parts [adj COMPLETER, COMPLETEST, COMPLETELY]\n",
  "COMPLETED": "COMPLETE, to bring to an end [v]\n",
  "COMPLETEDNESS": "the state of being completed [n -ES]\n",
  "COMPLETEDNESSES": "COMPLETEDNESS, the state of being completed [n]\n",
  "COMPLETELY": "COMPLETE, having all necessary parts [adv]\n",
  "COMPLETENESS": "the state of being complete [n -ES]\n",
  "COMPLETENESSES": "COMPLETENESS, the state of being complete [n]\n",
  "COMPLETER": "one who completes [n -S]\n",
  "COMPLETERS": "COMPLETER, one who completes [n]\n",
  "COMPLETES": "COMPLETE, to bring to an end [v]\n",
  "COMPLETEST": "COMPLETE, having all necessary parts [adj]\n",
  "COMPLETING": "COMPLETE, to bring to an end [v]\n",
  "COMPLETION": "the act of completing [n -S]\n",
  "COMPLETIONS": "COMPLETION, the act of completing [n]\n",
  "COMPLETIST": "a person who wants all of something (esp. a collection of items) [n -S]\n",
  "COMPLETISTS": "COMPLETIST, a person who wants all of something (esp. a collection of items) [n]\n",
  "COMPLETIVE": "making complete, also COMPLETORY [adj]\n",
  "COMPLETORIES": "COMPLETORY, in the Christian liturgy, the seventh and last service of the day, at 9 p.m., completing the set hours for prayer [n]\n",
  "COMPLETORY": "in the Christian liturgy, the seventh and last service of the day, at 9 p.m., completing the set hours for prayer [n COMPLETORIES]\n",
  "COMPLEX": "to make complicated [v -ED, -ING, -ES] / complicated [adj COMPLEXER, COMPLEXEST, COMPLEXLY]\n",
  "COMPLEXATION": "a complex [n -S]\n",
  "COMPLEXATIONS": "COMPLEXATION, a complex [n]\n",
  "COMPLEXED": "COMPLEX, to make complicated [v]\n",
  "COMPLEXEDNESS": "the state of being complex [n -ES]\n",
  "COMPLEXEDNESSES": "COMPLEXEDNESS, the state of being complex [n]\n",
  "COMPLEXER": "COMPLEX, complicated [adj]\n",
  "COMPLEXES": "COMPLEX, to make complicated [v]\n",
  "COMPLEXEST": "COMPLEX, complicated [adj]\n",
  "COMPLEXIFIED": "COMPLEXIFY, to render complex [v]\n",
  "COMPLEXIFIES": "COMPLEXIFY, to render complex [v]\n",
  "COMPLEXIFY": "to render complex [v COMPLEXIFIED, COMPLEXIFYING, COMPLEXIFIES]\n",
  "COMPLEXIFYING": "COMPLEXIFY, to render complex [v]\n",
  "COMPLEXING": "COMPLEX, to make complicated [v]\n",
  "COMPLEXION": "the colour or look of the skin [n -S]\n",
  "COMPLEXIONAL": "relating to complexion [adj]\n",
  "COMPLEXIONED": "having a particular complexion [adj]\n",
  "COMPLEXIONLESS": "without a complexion [adj]\n",
  "COMPLEXIONS": "COMPLEXION, the colour or look of the skin [n]\n",
  "COMPLEXITIES": "COMPLEXITY, the state of being complex [n]\n",
  "COMPLEXITY": "the state of being complex [n COMPLEXITIES]\n",
  "COMPLEXLY": "COMPLEX, complicated [adv]\n",
  "COMPLEXNESS": "the state of being complex [n -ES]\n",
  "COMPLEXNESSES": "COMPLEXNESS, the state of being complex [n]\n",
  "COMPLEXOMETRIC": "as in complexometric indicator, a dye that undergoes a definite color change in presence of specific metal ions [adj]\n",
  "COMPLEXONE": "any chelating agent, such as EDTA, used for the analytical determination of metals [n -S]\n",
  "COMPLEXONES": "COMPLEXONE, any chelating agent, such as EDTA, used for the analytical determination of metals [n]\n",
  "COMPLEXUS": "an aggregation of parts [n -ES]\n",
  "COMPLEXUSES": "COMPLEXUS, an aggregation of parts [n]\n",
  "COMPLIABLE": "capable of bending or yielding; compliant [adj COMPLIABLY]\n",
  "COMPLIABLENESS": "COMPLIABLE, capable of bending or yielding; compliant [n]\n",
  "COMPLIABLY": "COMPLIABLE, capable of bending or yielding; compliant [adv]\n",
  "COMPLIANCE": "the act of complying, also COMPLIANCY [n -S]\n",
  "COMPLIANCES": "COMPLIANCE, the act of complying, also COMPLIANCY [n]\n",
  "COMPLIANCIES": "COMPLIANCY, the state of being compliant, also COMPLIANCE [n]\n",
  "COMPLIANCY": "the state of being compliant, also COMPLIANCE [n COMPLIANCIES]\n",
  "COMPLIANT": "yielding [adj COMPLIANTLY]\n",
  "COMPLIANTLY": "COMPLIANT, yielding [adv]\n",
  "COMPLIANTNESS": "COMPLIANT, yielding [n]\n",
  "COMPLIANTNESSES": "COMPLIANTNESS, COMPLIANT, yielding [n]\n",
  "COMPLICACIES": "COMPLICACY, a state of being complicate or intricate [n]\n",
  "COMPLICACY": "a state of being complicate or intricate [n COMPLICACIES]\n",
  "COMPLICANT": "overlapping [adj]\n",
  "COMPLICATE": "to combine esp. in an involved manner [v COMPLICATED, COMPLICATING, COMPLICATES]\n",
  "COMPLICATED": "COMPLICATE, to combine esp. in an involved manner [v]\n",
  "COMPLICATEDLY": "COMPLICATED [adv]\n",
  "COMPLICATEDNESS": "the state of being complicated [n]\n",
  "COMPLICATES": "COMPLICATE, to combine esp. in an involved manner [v]\n",
  "COMPLICATING": "COMPLICATE, to combine esp. in an involved manner [v]\n",
  "COMPLICATION": "complexity, intricacy [n -S]\n",
  "COMPLICATIONS": "COMPLICATION, complexity, intricacy [n]\n",
  "COMPLICATIVE": "tending to complicate [adj]\n",
  "COMPLICE": "(obsolete) an accomplice [n -S]\n",
  "COMPLICES": "COMPLICE, (obsolete) an accomplice [n]\n",
  "COMPLICIT": "having or showing complicity, that is a party to or involved in wrongdoing, also COMPLICITOUS [adj COMPLICITLY]\n",
  "COMPLICITIES": "COMPLICITY, association or participation in or as if in a wrongful act [n]\n",
  "COMPLICITLY": "COMPLICIT, having or showing complicity, that is a party to or involved in wrongdoing, also COMPLICITOUS [adv]\n",
  "COMPLICITOUS": "having or showing complicity, that is a party to or involved in wrongdoing, also COMPLICIT [adj]\n",
  "COMPLICITY": "association or participation in or as if in a wrongful act [n COMPLICITIES]\n",
  "COMPLIED": "COMPLY, to obey [v]\n",
  "COMPLIER": "one who complies [n -S]\n",
  "COMPLIERS": "COMPLIER, one who complies [n]\n",
  "COMPLIES": "COMPLY, to obey [v]\n",
  "COMPLIMENT": "to express admiration for [v -ED, -ING, -S]\n",
  "COMPLIMENTAL": "expressing or implying compliment [adj]\n",
  "COMPLIMENTARILY": "COMPLIMENTARY, by way of compliment [adv]\n",
  "COMPLIMENTARY": "by way of compliment [adj COMPLIMENTARILY]\n",
  "COMPLIMENTED": "COMPLIMENT, to express admiration for [v]\n",
  "COMPLIMENTER": "one who pays compliments [n -S]\n",
  "COMPLIMENTERS": "COMPLIMENTER, one who pays compliments [n]\n",
  "COMPLIMENTING": "COMPLIMENT, to express admiration for [v]\n",
  "COMPLIMENTS": "COMPLIMENT, to express admiration for [v]\n",
  "COMPLIN": "in the Christian liturgy, the seventh and last service of the day, at 9 p.m., completing the set hours for prayer, also COMPLINE [n -S]\n",
  "COMPLINE": "in the Christian liturgy, the seventh and last service of the day, at 9 p.m., completing the set hours for prayer, also COMPLIN [n -S]\n",
  "COMPLINES": "COMPLINE, in the Christian liturgy, the seventh and last service of the day, at 9 p.m., completing the set hours for prayer, also COMPLIN [n]\n",
  "COMPLINS": "COMPLIN, in the Christian liturgy, the seventh and last service of the day, at 9 p.m., completing the set hours for prayer, also COMPLINE [n]\n",
  "COMPLISH": "to accomplish [v -ED, -ING, -ES]\n",
  "COMPLISHED": "COMPLISH, to accomplish [v]\n",
  "COMPLISHES": "COMPLISH, to accomplish [v]\n",
  "COMPLISHING": "COMPLISH, to accomplish [v]\n",
  "COMPLOT": "to conspire [v COMPLOTTED, COMPLOTTING, COMPLOTS]\n",
  "COMPLOTS": "COMPLOT, to conspire [v]\n",
  "COMPLOTTED": "COMPLOT, to conspire [v]\n",
  "COMPLOTTER": "one who complots [n -S]\n",
  "COMPLOTTERS": "COMPLOTTER, one who complots [n]\n",
  "COMPLOTTING": "COMPLOT, to conspire [v]\n",
  "COMPLUVIA": "COMPLUVIUM, (Latin) a space left unroofed over the court of a Roman dwelling, through which the rain fell into the impluvium or cistern [n]\n",
  "COMPLUVIUM": "(Latin) a space left unroofed over the court of a Roman dwelling, through which the rain fell into the impluvium or cistern [n COMPLUVIUMS or COMPLUVIA]\n",
  "COMPLUVIUMS": "COMPLUVIUM, (Latin) a space left unroofed over the court of a Roman dwelling, through which the rain fell into the impluvium or cistern [n]\n",
  "COMPLY": "to obey [v COMPLIED, COMPLYING, COMPLIES]\n",
  "COMPLYING": "COMPLY, to obey [v]\n",
  "COMPO": "a mortar of cement; a mixture of whiting, resin and glue for ornamenting walls and cornices [n -S]\n",
  "COMPONE": "composed of squares of alternating colours, also COMPONY [adj]\n",
  "COMPONENCIES": "COMPONENCY, the state of being a component [n]\n",
  "COMPONENCY": "the state of being a component [n COMPONENCIES]\n",
  "COMPONENT": "one of the parts or elements of which anything is made up [n -S]\n",
  "COMPONENTAL": "relating to a component, also COMPONENTIAL [adj]\n",
  "COMPONENTIAL": "relating to a component, also COMPONENTAL [adj]\n",
  "COMPONENTS": "COMPONENT, one of the parts or elements of which anything is made up [n]\n",
  "COMPONY": "composed of squares of alternating colours, also COMPONE [adj]\n",
  "COMPORT": "to conduct oneself in a certain way [v -ED, -ING, -S]\n",
  "COMPORTANCE": "(Spenser) comportment [n -S]\n",
  "COMPORTANCES": "COMPORTANCE, (Spenser) comportment [n]\n",
  "COMPORTED": "COMPORT, to conduct oneself in a certain way [v]\n",
  "COMPORTING": "COMPORT, to conduct oneself in a certain way [v]\n",
  "COMPORTMENT": "behaviour, bearing [n -S]\n",
  "COMPORTMENTS": "COMPORTMENT, behaviour, bearing [n]\n",
  "COMPORTS": "COMPORT, to conduct oneself in a certain way [v]\n",
  "COMPOS": "COMPO, a mortar of cement; a mixture of whiting, resin and glue for ornamenting walls and cornices [n]\n",
  "COMPOSE": "to settle or soothe [v COMPOSED, COMPOSING, COMPOSES]\n",
  "COMPOSED": "COMPOSE, to settle or soothe [v]\n",
  "COMPOSEDLY": "COMPOSED, COMPOSE, to settle or soothe [adv]\n",
  "COMPOSEDNESS": "the state of being composed [n -ES]\n",
  "COMPOSEDNESSES": "COMPOSEDNESS, the state of being composed [n]\n",
  "COMPOSER": "one who writes music [n -S]\n",
  "COMPOSERS": "COMPOSER, one who writes music [n]\n",
  "COMPOSES": "COMPOSE, to settle or soothe [v]\n",
  "COMPOSING": "COMPOSE, to settle or soothe [v]\n",
  "COMPOSITE": "made of distinct things [adj COMPOSITELY] / to complete from diverse elements [v COMPOSITED, COMPOSITING, COMPOSITES]\n",
  "COMPOSITED": "COMPOSITE, to complete from diverse elements [v]\n",
  "COMPOSITELY": "COMPOSITE, made of distinct things [adv]\n",
  "COMPOSITENESS": "COMPOSITE, made of distinct things [n]\n",
  "COMPOSITENESSES": "COMPOSITENESS, COMPOSITE, made of distinct things [n]\n",
  "COMPOSITES": "COMPOSITE, to complete from diverse elements [v]\n",
  "COMPOSITING": "COMPOSITE, to complete from diverse elements [v]\n",
  "COMPOSITION": "a piece of writing [n -S]\n",
  "COMPOSITIONAL": "relating to composition [adj COMPOSITIONALLY]\n",
  "COMPOSITIONALLY": "COMPOSITIONAL, relating to composition [adv]\n",
  "COMPOSITIONS": "COMPOSITION, a piece of writing [n]\n",
  "COMPOSITIVE": "relating to a composite [adj]\n",
  "COMPOSITOR": "one who sets type [n -S]\n",
  "COMPOSITORIAL": "relating to the composition of type [adj]\n",
  "COMPOSITORS": "COMPOSITOR, one who sets type [n]\n",
  "COMPOSITOUS": "composite [adj]\n",
  "COMPOSSIBILITY": "the state of being compossible, possible along with something else [n]\n",
  "COMPOSSIBLE": "compatible; possible along with something else [adj]\n",
  "COMPOST": "to make into fertilizer [v -ED, -ING, -S]\n",
  "COMPOSTABLE": "that can be composted [adj]\n",
  "COMPOSTED": "COMPOST, to make into fertilizer [v]\n",
  "COMPOSTER": "an apparatus for converting garden waste into compost [n -S]\n",
  "COMPOSTERS": "COMPOSTER, an apparatus for converting garden waste into compost [n]\n",
  "COMPOSTING": "the act of making into compost [n -S]\n",
  "COMPOSTINGS": "COMPOSTING, the act of making into compost [n]\n",
  "COMPOSTS": "COMPOST, to make into fertilizer [v]\n",
  "COMPOSTURE": "manure; compost [n -S] / to treat with compost [v COMPOSTURED, COMPOSTURING, COMPOSTURES]\n",
  "COMPOSTURED": "COMPOSTURE, to treat with compost [v]\n",
  "COMPOSTURES": "COMPOSTURE, manure; compost [n]\n",
  "COMPOSTURING": "COMPOSTURE, to treat with compost [v]\n",
  "COMPOSURE": "calmness, self-possession [n -S]\n",
  "COMPOSURES": "COMPOSURE, calmness, self-possession [n]\n",
  "COMPOT": "(French) fruit stewed in sugar or syrup, also COMPOTE [n -S]\n",
  "COMPOTATION": "an act of carousing in company [n -S]\n",
  "COMPOTATIONS": "COMPOTATION, an act of carousing in company [n]\n",
  "COMPOTATIONSHIP": "being a drinking companion [n]\n",
  "COMPOTATOR": "one who drinks with another [n -S]\n",
  "COMPOTATORS": "COMPOTATOR, one who drinks with another [n]\n",
  "COMPOTATORY": "sharing in a compotation, carousing in company [adj]\n",
  "COMPOTE": "(French) fruit stewed in sugar or syrup, also COMPOT [n -S]\n",
  "COMPOTES": "COMPOTE, (French) fruit stewed in sugar or syrup, also COMPOT [n]\n",
  "COMPOTIER": "(French) a dish, usually with a stemmed base, for serving dessert [n -S]\n",
  "COMPOTIERS": "COMPOTIER, (French) a dish, usually with a stemmed base, for serving dessert [n]\n",
  "COMPOTS": "COMPOT, (French) fruit stewed in sugar or syrup, also COMPOTE [n]\n",
  "COMPOUND": "to add to [v -ED, -ING, -S]\n",
  "COMPOUNDABLE": "that can be compounded [adj]\n",
  "COMPOUNDED": "COMPOUND, to add to [v]\n",
  "COMPOUNDER": "one who compounds [n -S]\n",
  "COMPOUNDERS": "COMPOUNDER, one who compounds [n]\n",
  "COMPOUNDING": "the act of adding to as a compound [n -S]\n",
  "COMPOUNDINGS": "COMPOUNDING, the act of adding to as a compound [n]\n",
  "COMPOUNDS": "COMPOUND, to add to [v]\n",
  "COMPRADOR": "(Portuguese) a native agent or intermediary through whom a foreign power trades, also COMPRADORE [n -S]\n",
  "COMPRADORE": "(Portuguese) a native agent or intermediary through whom a foreign power trades, also COMPRADOR [n -S]\n",
  "COMPRADORES": "COMPRADORE, (Portuguese) a native agent or intermediary through whom a foreign power trades, also COMPRADOR [n]\n",
  "COMPRADORS": "COMPRADOR, (Portuguese) a native agent or intermediary through whom a foreign power trades, also COMPRADORE [n]\n",
  "COMPREHEND": "to grasp the meaning of [v -ED, -ING, -S]\n",
  "COMPREHENDED": "COMPREHEND, to grasp the meaning of [v]\n",
  "COMPREHENDIBLE": "that can be comprehended, also COMPREHENSIBLE [adj]\n",
  "COMPREHENDING": "COMPREHEND, to grasp the meaning of [v]\n",
  "COMPREHENDS": "COMPREHEND, to grasp the meaning of [v]\n",
  "COMPREHENSIBLE": "capable of being comprehended, also COMPREHENDIBLE [adj COMPREHENSIBLY]\n",
  "COMPREHENSIBLY": "COMPREHENSIBLE, capable of being comprehended, also COMPREHENDIBLE [adv]\n",
  "COMPREHENSION": "the act or action of grasping with the intellect [n -S]\n",
  "COMPREHENSIONS": "COMPREHENSION, the act or action of grasping with the intellect [n]\n",
  "COMPREHENSIVE": "covering completely or broadly [adj COMPREHENSIVELY] / a comprehensive school [n -S]\n",
  "COMPREHENSIVELY": "COMPREHENSIVE, covering completely or broadly [adv]\n",
  "COMPREHENSIVES": "COMPREHENSIVE, a comprehensive school [n]\n",
  "COMPREHENSIVISE": "to make comprehensive, also COMPREHENSIVIZE [v]\n",
  "COMPREHENSIVIZE": "to make comprehensive, also COMPREHENSIVISE [v]\n",
  "COMPRESS": "to compact [v -ED, -ING, -ES]\n",
  "COMPRESSED": "COMPRESS, to compact [v]\n",
  "COMPRESSEDLY": "COMPRESSED, COMPRESS, to compact [adv]\n",
  "COMPRESSES": "COMPRESS, to compact [v]\n",
  "COMPRESSIBILITY": "the state of being compressible [n]\n",
  "COMPRESSIBLE": "capable of being compressed [adj COMPRESSIBLY]\n",
  "COMPRESSIBLY": "COMPRESSIBLE, capable of being compressed [adv]\n",
  "COMPRESSING": "COMPRESS, to compact [v]\n",
  "COMPRESSION": "the act of compressing [n -S]\n",
  "COMPRESSIONAL": "relating to compression [adj]\n",
  "COMPRESSIONS": "COMPRESSION, the act of compressing [n]\n",
  "COMPRESSIVE": "of or relating to compression [adj COMPRESSIVELY]\n",
  "COMPRESSIVELY": "COMPRESSIVE, of or relating to compression [adv]\n",
  "COMPRESSOR": "one that compresses [n -S]\n",
  "COMPRESSORS": "COMPRESSOR, one that compresses [n]\n",
  "COMPRESSURE": "the act of compressing [n -S]\n",
  "COMPRESSURES": "COMPRESSURE, the act of compressing [n]\n",
  "COMPRIMARIO": "in opera or ballet, a role of secondary importance; a singer or dancer playing such a role [n -S]\n",
  "COMPRIMARIOS": "COMPRIMARIO, in opera or ballet, a role of secondary importance; a singer or dancer playing such a role [n]\n",
  "COMPRINT": "to share in printing [v -ED, -ING, -S]\n",
  "COMPRINTED": "COMPRINT, to share in printing [v]\n",
  "COMPRINTING": "COMPRINT, to share in printing [v]\n",
  "COMPRINTS": "COMPRINT, to share in printing [v]\n",
  "COMPRISABLE": "that can be comprised [adj]\n",
  "COMPRISAL": "the act, condition or fact of comprising [n -S]\n",
  "COMPRISALS": "COMPRISAL, the act, condition or fact of comprising [n]\n",
  "COMPRISE": "to include or contain, also COMPRIZE [v COMPRISED, COMPRISING, COMPRISES]\n",
  "COMPRISED": "COMPRISE, to include or contain, also COMPRIZE [v]\n",
  "COMPRISES": "COMPRISE, to include or contain, also COMPRIZE [v]\n",
  "COMPRISING": "COMPRISE, to include or contain, also COMPRIZE [v]\n",
  "COMPRIZE": "to include or contain, also COMPRISE [v COMPRIZED, COMPRIZING, COMPRIZES]\n",
  "COMPRIZED": "COMPRIZE, to include or contain, also COMPRISE [v]\n",
  "COMPRIZES": "COMPRIZE, to include or contain, also COMPRISE [v]\n",
  "COMPRIZING": "COMPRIZE, to include or contain, also COMPRISE [v]\n",
  "COMPROMISE": "to adjust or settle by mutual concessions [v COMPROMISED, COMPROMISING, COMPROMISES]\n",
  "COMPROMISED": "COMPROMISE, to adjust or settle by mutual concessions [v]\n",
  "COMPROMISER": "one who compromises [n -S]\n",
  "COMPROMISERS": "COMPROMISER, one who compromises [n]\n",
  "COMPROMISES": "COMPROMISE, to adjust or settle by mutual concessions [v]\n",
  "COMPROMISING": "exposing to the risk of scandal [adj COMPROMISINGLY]\n",
  "COMPROMISINGLY": "COMPROMISING, exposing to the risk of scandal [adv]\n",
  "COMPROVINCIAL": "belonging to the same province [adj]\n",
  "COMPS": "COMP, to work as a compositor [v]\n",
  "COMPT": "(obsolete) to count [v -ED, -ING, -S]\n",
  "COMPTABLE": "(obsolete) countable, also COMPTIBLE, COUNTABLE [adj]\n",
  "COMPTED": "COMPT, (obsolete) to count [v]\n",
  "COMPTER": "(obsolete) a counter [n -S]\n",
  "COMPTERS": "COMPTER, (obsolete) a counter [n]\n",
  "COMPTIBLE": "(obsolete) countable, also COMPTABLE [adj]\n",
  "COMPTING": "COMPT, (obsolete) to count [v]\n",
  "COMPTROLL": "(obsolete) to control, esp. in a financial sense, also CONTROL, CONTROUL, COUNTROL [v -ED, -ING, -S]\n",
  "COMPTROLLED": "COMPTROLL, (obsolete) to control, esp. in a financial sense, also CONTROL, CONTROUL, COUNTROL [v]\n",
  "COMPTROLLER": "a royal household official who examines and supervises expenditures [n -S]\n",
  "COMPTROLLERS": "COMPTROLLER, a royal household official who examines and supervises expenditures [n]\n",
  "COMPTROLLERSHIP": "the office of comptroller [n]\n",
  "COMPTROLLING": "COMPTROLL, (obsolete) to control, esp. in a financial sense, also CONTROL, CONTROUL, COUNTROL [v]\n",
  "COMPTROLLS": "COMPTROLL, (obsolete) to control, esp. in a financial sense, also CONTROL, CONTROUL, COUNTROL [v]\n",
  "COMPTS": "COMPT, (obsolete) to count [v]\n",
  "COMPULSATIVE": "(Shakespeare) compulsory, also COMPULSATORY [adj]\n",
  "COMPULSATORY": "(Shakespeare) compulsory, also COMPULSATIVE [adj]\n",
  "COMPULSE": "(obsolete) to compel [v COMPULSED, COMPULSING, COMPULSES]\n",
  "COMPULSED": "COMPULSE, (obsolete) to compel [v]\n",
  "COMPULSES": "COMPULSE, (obsolete) to compel [v]\n",
  "COMPULSING": "COMPULSE, (obsolete) to compel [v]\n",
  "COMPULSION": "an act of compelling [n -S]\n",
  "COMPULSIONIST": "a believer in compulsion [n -S]\n",
  "COMPULSIONISTS": "COMPULSIONIST, a believer in compulsion [n]\n",
  "COMPULSIONS": "COMPULSION, an act of compelling [n]\n",
  "COMPULSITOR": "in Scots law, a means of compelling [n -S]\n",
  "COMPULSITORS": "COMPULSITOR, in Scots law, a means of compelling [n]\n",
  "COMPULSIVE": "driven by an ungovernable impulse [adj COMPULSIVELY] / one driven by an ungovernable impulse [n -S]\n",
  "COMPULSIVELY": "COMPULSIVE, driven by an ungovernable impulse [adv]\n",
  "COMPULSIVENESS": "COMPULSIVE, driven by an ungovernable impulse [n]\n",
  "COMPULSIVES": "COMPULSIVE, one driven by an ungovernable impulse [n]\n",
  "COMPULSIVITIES": "COMPULSIVITY, the quality of being compulsive [n]\n",
  "COMPULSIVITY": "the quality of being compulsive [n COMPULSIVITIES]\n",
  "COMPULSORIES": "COMPULSORY, an exercise comprising specified compulsory figures, movements or dances, e.g. in ice-skating [n]\n",
  "COMPULSORILY": "COMPULSORY, obligatory [adv]\n",
  "COMPULSORINESS": "the state of being compulsory [n]\n",
  "COMPULSORY": "obligatory [adj COMPULSORILY] / an exercise comprising specified compulsory figures, movements or dances, e.g. in ice-skating [n COMPULSORIES]\n",
  "COMPUNCTION": "regret, remorse [n -S]\n",
  "COMPUNCTIONS": "COMPUNCTION, regret, remorse [n]\n",
  "COMPUNCTIOUS": "arising from remorse or regret [adj COMPUNCTIOUSLY]\n",
  "COMPUNCTIOUSLY": "COMPUNCTIOUS, arising from remorse or regret [adv]\n",
  "COMPURGATION": "the exoneration of an accused person on the basis of oaths sworn by other persons [n -S]\n",
  "COMPURGATIONS": "COMPURGATION, the exoneration of an accused person on the basis of oaths sworn by other persons [n]\n",
  "COMPURGATOR": "one who under oath vouches for the character or conduct of an accused person [n -S]\n",
  "COMPURGATORIAL": "relating to compurgation, the clearing of an accused person by means of oaths [adj]\n",
  "COMPURGATORS": "COMPURGATOR, one who under oath vouches for the character or conduct of an accused person [n]\n",
  "COMPURGATORY": "relating to compurgation, the clearing of an accused person by means of oaths [adj]\n",
  "COMPURSION": "(Sterne) a pursing together [n -S]\n",
  "COMPURSIONS": "COMPURSION, (Sterne) a pursing together [n]\n",
  "COMPUTABILITIES": "COMPUTABILITY, the quality of being computable [n]\n",
  "COMPUTABILITY": "the quality of being computable [n COMPUTABILITIES]\n",
  "COMPUTABLE": "capable of being computed [adj]\n",
  "COMPUTANT": "a person who calculates [n -S]\n",
  "COMPUTANTS": "COMPUTANT, a person who calculates [n]\n",
  "COMPUTATION": "the act or action of computing [n -S]\n",
  "COMPUTATIONAL": "relating to computation [adj COMPUTATIONALLY]\n",
  "COMPUTATIONALLY": "COMPUTATIONAL, relating to computation [adv]\n",
  "COMPUTATIONS": "COMPUTATION, the act or action of computing [n]\n",
  "COMPUTATIVE": "of or relating to computation [adj]\n",
  "COMPUTATOR": "a person who calculates [n -S]\n",
  "COMPUTATORS": "COMPUTATOR, a person who calculates [n]\n",
  "COMPUTE": "to calculate [v COMPUTED, COMPUTING, COMPUTES]\n",
  "COMPUTED": "COMPUTE, to calculate [v]\n",
  "COMPUTER": "a machine that computes automatically [n -S]\n",
  "COMPUTERATE": "computer literate [adj]\n",
  "COMPUTERDOM": "the world of computers [n -S]\n",
  "COMPUTERDOMS": "COMPUTERDOM, the world of computers [n]\n",
  "COMPUTERESE": "the jargon used by people who deal with computers [n -S]\n",
  "COMPUTERESES": "COMPUTERESE, the jargon used by people who deal with computers [n]\n",
  "COMPUTERISABLE": "that can be computerised, also COMPUTERIZABLE [adj]\n",
  "COMPUTERISATION": "the process of computerising, also COMPUTERIZATION [n]\n",
  "COMPUTERISE": "to render suitable for a computer, also COMPUTERIZE [v COMPUTERISED, COMPUTERISING, COMPUTERISES]\n",
  "COMPUTERISED": "COMPUTERISE, to render suitable for a computer, also COMPUTERIZE [v]\n",
  "COMPUTERISES": "COMPUTERISE, to render suitable for a computer, also COMPUTERIZE [v]\n",
  "COMPUTERISING": "COMPUTERISE, to render suitable for a computer, also COMPUTERIZE [v]\n",
  "COMPUTERIST": "a person who uses or operates a computer [n -S]\n",
  "COMPUTERISTS": "COMPUTERIST, a person who uses or operates a computer [n]\n",
  "COMPUTERITIS": "the excessive use of computers; the fact of being detrimentally influenced by computers [n -ES]\n",
  "COMPUTERITISES": "COMPUTERITIS, the excessive use of computers; the fact of being detrimentally influenced by computers [n]\n",
  "COMPUTERIZABLE": "that can be computerized, also COMPUTERISABLE [adj]\n",
  "COMPUTERIZATION": "the act of computerizing, also COMPUTERISATION [n]\n",
  "COMPUTERIZE": "to carry out, control, or produce by means of a computer, also COMPUTERISE [v COMPUTERIZED, COMPUTERIZING, COMPUTERIZES]\n",
  "COMPUTERIZED": "COMPUTERIZE, to carry out, control, or produce by means of a computer, also COMPUTERISE [v]\n",
  "COMPUTERIZES": "COMPUTERIZE, to carry out, control, or produce by means of a computer, also COMPUTERISE [v]\n",
  "COMPUTERIZING": "COMPUTERIZE, to carry out, control, or produce by means of a computer, also COMPUTERISE [v]\n",
  "COMPUTERLESS": "without a computer [adj]\n",
  "COMPUTERLIKE": "like a computer [adj]\n",
  "COMPUTERNIK": "a computer enthusiast [n -S]\n",
  "COMPUTERNIKS": "COMPUTERNIK, a computer enthusiast [n]\n",
  "COMPUTERPHOBE": "one with a fear of computers [n -S]\n",
  "COMPUTERPHOBES": "COMPUTERPHOBE, one with a fear of computers [n]\n",
  "COMPUTERPHOBIA": "a morbid fear of computers [n -S]\n",
  "COMPUTERPHOBIAS": "COMPUTERPHOBIA, a morbid fear of computers [n]\n",
  "COMPUTERPHOBIC": "someone having an irrational fear of computers [n -S]\n",
  "COMPUTERPHOBICS": "COMPUTERPHOBIC, someone having an irrational fear of computers [n]\n",
  "COMPUTERS": "COMPUTER, a machine that computes automatically [n]\n",
  "COMPUTES": "COMPUTE, to calculate [v]\n",
  "COMPUTING": "the act of calculating [n -S]\n",
  "COMPUTINGS": "COMPUTING, the act of calculating [n]\n",
  "COMPUTIST": "a computer [n -S]\n",
  "COMPUTISTS": "COMPUTIST, a computer [n]\n",
  "COMRADE": "a close friend [n -S]\n",
  "COMRADELIER": "COMRADELY, like a comrade [adj]\n",
  "COMRADELIEST": "COMRADELY, like a comrade [adj]\n",
  "COMRADELINESS": "the state of being comradely [n -ES]\n",
  "COMRADELINESSES": "COMRADELINESS, the state of being comradely [n]\n",
  "COMRADELY": "like a comrade [adj COMRADELIER, COMRADELIEST]\n",
  "COMRADERIES": "COMRADERY, the spirit of comradeship [n]\n",
  "COMRADERY": "the spirit of comradeship [n COMRADERIES]\n",
  "COMRADES": "COMRADE, a close friend [n]\n",
  "COMRADESHIP": "the state of being a comrade [n -S]\n",
  "COMRADESHIPS": "COMRADESHIP, the state of being a comrade [n]\n",
  "COMS": "short for combinations [n]\n",
  "COMSAT": "(short for) communications satellite [n -S]\n",
  "COMSATS": "COMSAT, (short for) communications satellite [n]\n",
  "COMSTOCKER": "one who engages in comstockery, self-righteous, moralizing censorship [n -S]\n",
  "COMSTOCKERIES": "COMSTOCKERY, overzealous censorship of material considered obscene, also COMSTOCKISM [n]\n",
  "COMSTOCKERS": "COMSTOCKER, one who engages in comstockery, self-righteous, moralizing censorship [n]\n",
  "COMSTOCKERY": "overzealous censorship of material considered obscene, also COMSTOCKISM [n COMSTOCKERIES]\n",
  "COMSTOCKISM": "overzealous censorship of material considered obscene, also COMSTOCKERY [n -S]\n",
  "COMSTOCKISMS": "COMSTOCKISM, overzealous censorship of material considered obscene, also COMSTOCKERY [n]\n",
  "COMSYMP": "(offensive) one that sympathizes with communist causes [n -S]\n",
  "COMSYMPS": "COMSYMP, (offensive) one that sympathizes with communist causes [n]\n",
  "COMTE": "(French) a French nobleman [n -S]\n",
  "COMTES": "COMTE, (French) a French nobleman [n]\n",
  "COMUS": "(Latin) a revel [n -ES]\n",
  "COMUSES": "COMUS, (Latin) a revel [n]\n",
  "CON": "to study carefully [v COND or YCOND or CONNED, CONNING, CONS]\n",
  "CONACRE": "of a tenant, to let small portions of land prepared for crop or grazing, also CORNACRE [v CONACRED, CONACRING, CONACRES]\n",
  "CONACRED": "CONACRE, of a tenant, to let small portions of land prepared for crop or grazing, also CORNACRE [v]\n",
  "CONACREISM": "the system of conacre, subletting a portion of a farm, for a single crop [n -S]\n",
  "CONACREISMS": "CONACREISM, the system of conacre, subletting a portion of a farm, for a single crop [n]\n",
  "CONACRES": "CONACRE, of a tenant, to let small portions of land prepared for crop or grazing, also CORNACRE [v]\n",
  "CONACRING": "CONACRE, of a tenant, to let small portions of land prepared for crop or grazing, also CORNACRE [v]\n",
  "CONARIA": "CONARIUM, (Greek) the pineal gland [n]\n",
  "CONARIAL": "relating to the pineal gland [adj]\n",
  "CONARIUM": "(Greek) the pineal gland [n CONARIA]\n",
  "CONATION": "the inclination to act purposefully [n -S]\n",
  "CONATIONAL": "relating to conation, mental effort towards a goal [adj]\n",
  "CONATIONS": "CONATION, the inclination to act purposefully [n]\n",
  "CONATIVE": "inclined to conation [adj]\n",
  "CONATUS": "(Latin) a natural impulse or tendency [n CONATUS]\n",
  "CONCANAVALIN": "a protein that occurs in the jack bean and is a mitogen and hemagglutinin [n -S]\n",
  "CONCANAVALINS": "CONCANAVALIN, a protein that occurs in the jack bean and is a mitogen and hemagglutinin [n]\n",
  "CONCATENATE": "to link together in a series or chain [v CONCATENATED, CONCATENATING, CONCATENATES]\n",
  "CONCATENATED": "CONCATENATE, to link together in a series or chain [v]\n",
  "CONCATENATES": "CONCATENATE, to link together in a series or chain [v]\n",
  "CONCATENATING": "CONCATENATE, to link together in a series or chain [v]\n",
  "CONCATENATION": "the act of concatenating [n -S]\n",
  "CONCATENATIONS": "CONCATENATION, the act of concatenating [n]\n",
  "CONCAUSE": "a cooperating cause [n -S]\n",
  "CONCAUSES": "CONCAUSE, a cooperating cause [n]\n",
  "CONCAVE": "curved inward [adj CONCAVELY] / to curve inward [v CONCAVED, CONCAVING, CONCAVES]\n",
  "CONCAVED": "CONCAVE, to curve inward [v]\n",
  "CONCAVELY": "CONCAVE, curved inward [adv]\n",
  "CONCAVENESS": "the state of being concave [n -ES]\n",
  "CONCAVENESSES": "CONCAVENESS, the state of being concave [n]\n",
  "CONCAVES": "CONCAVE, to curve inward [v]\n",
  "CONCAVING": "CONCAVE, to curve inward [v]\n",
  "CONCAVITIES": "CONCAVITY, the state of being concave [n]\n",
  "CONCAVITY": "the state of being concave [n CONCAVITIES]\n",
  "CONCEAL": "to hide [v -ED, -ING, -S]\n",
  "CONCEALABLE": "that can be concealed [adj]\n",
  "CONCEALED": "CONCEAL, to hide [v]\n",
  "CONCEALER": "one who conceals [n -S]\n",
  "CONCEALERS": "CONCEALER, one who conceals [n]\n",
  "CONCEALING": "CONCEAL, to hide [v]\n",
  "CONCEALINGLY": "CONCEALING, CONCEAL, to hide [adv]\n",
  "CONCEALMENT": "the act of concealing [n -S]\n",
  "CONCEALMENTS": "CONCEALMENT, the act of concealing [n]\n",
  "CONCEALS": "CONCEAL, to hide [v]\n",
  "CONCEDE": "to acknowledge as true [v CONCEDED, CONCEDING, CONCEDES]\n",
  "CONCEDED": "CONCEDE, to acknowledge as true [v]\n",
  "CONCEDEDLY": "CONCEDED, CONCEDE, to acknowledge as true [adv]\n",
  "CONCEDER": "one who concedes [n -S]\n",
  "CONCEDERS": "CONCEDER, one who concedes [n]\n",
  "CONCEDES": "CONCEDE, to acknowledge as true [v]\n",
  "CONCEDING": "CONCEDE, to acknowledge as true [v]\n",
  "CONCEDO": "(Latin) in logic, I admit, I yield [v]\n",
  "CONCEIT": "to form a conception of [v -ED, -ING, -S]\n",
  "CONCEITED": "having a good opinion of oneself [adj CONCEITEDLY]\n",
  "CONCEITEDLY": "CONCEITED, having a good opinion of oneself [adv]\n",
  "CONCEITEDNESS": "the state of being conceited [n -ES]\n",
  "CONCEITEDNESSES": "CONCEITEDNESS, the state of being conceited [n]\n",
  "CONCEITFUL": "(Spenser) thoughtful [adj]\n",
  "CONCEITING": "CONCEIT, to form a conception of [v]\n",
  "CONCEITLESS": "(Shakespeare) without conceit, stupid [adj]\n",
  "CONCEITS": "CONCEIT, to form a conception of [v]\n",
  "CONCEITY": "(dialect) characterized by conceit [adj]\n",
  "CONCEIVABILITY": "the state of being conceivable [n]\n",
  "CONCEIVABLE": "that can be conceived of [adj CONCEIVABLY]\n",
  "CONCEIVABLENESS": "CONCEIVABLE, that can be conceived of [n]\n",
  "CONCEIVABLY": "CONCEIVABLE, that can be conceived of [adv]\n",
  "CONCEIVE": "to understand [v CONCEIVED, CONCEIVING, CONCEIVES]\n",
  "CONCEIVED": "CONCEIVE, to understand [v]\n",
  "CONCEIVER": "one who conceives [n -S]\n",
  "CONCEIVERS": "CONCEIVER, one who conceives [n]\n",
  "CONCEIVES": "CONCEIVE, to understand [v]\n",
  "CONCEIVING": "CONCEIVE, to understand [v]\n",
  "CONCELEBRANT": "one that concelebrates a Eucharist or Mass [n -S]\n",
  "CONCELEBRANTS": "CONCELEBRANT, one that concelebrates a Eucharist or Mass [n]\n",
  "CONCELEBRATE": "to jointly recite the canon of the Eucharist in unison with others [v CONCELEBRATED, CONCELEBRATING, CONCELEBRATES]\n",
  "CONCELEBRATED": "CONCELEBRATE, to jointly recite the canon of the Eucharist in unison with others [v]\n",
  "CONCELEBRATES": "CONCELEBRATE, to jointly recite the canon of the Eucharist in unison with others [v]\n",
  "CONCELEBRATING": "CONCELEBRATE, to jointly recite the canon of the Eucharist in unison with others [v]\n",
  "CONCELEBRATION": "celebration of Eucharist by two or more ministers [n -S]\n",
  "CONCELEBRATIONS": "CONCELEBRATION, celebration of Eucharist by two or more ministers [n]\n",
  "CONCENT": "(archaic) a harmony or concord of sounds or voices, also CONCENTUS [n -S]\n",
  "CONCENTER": "(US) to have a common center, also CONCENTRE [v -ED, -ING, -S]\n",
  "CONCENTERED": "CONCENTER, (US) to have a common center, also CONCENTRE [v]\n",
  "CONCENTERING": "CONCENTER, (US) to have a common center, also CONCENTRE [v]\n",
  "CONCENTERS": "CONCENTER, (US) to have a common center, also CONCENTRE [v]\n",
  "CONCENTRATE": "to bring or direct toward a common center or objective [v CONCENTRATED, CONCENTRATING, CONCENTRATES]\n",
  "CONCENTRATED": "CONCENTRATE, to bring or direct toward a common center or objective [v]\n",
  "CONCENTRATEDLY": "CONCENTRATED, CONCENTRATE, to bring or direct toward a common center or objective [adv]\n",
  "CONCENTRATES": "CONCENTRATE, to bring or direct toward a common center or objective [v]\n",
  "CONCENTRATING": "CONCENTRATE, to bring or direct toward a common center or objective [v]\n",
  "CONCENTRATION": "the act of concentrating [n -S]\n",
  "CONCENTRATIONS": "CONCENTRATION, the act of concentrating [n]\n",
  "CONCENTRATIVE": "tending to concentrate [adj CONCENTRATIVELY]\n",
  "CONCENTRATIVELY": "CONCENTRATIVE, tending to concentrate [adv]\n",
  "CONCENTRATOR": "an apparatus for concentrating solutions or for obtaining minerals from ores by physical means [n -S]\n",
  "CONCENTRATORS": "CONCENTRATOR, an apparatus for concentrating solutions or for obtaining minerals from ores by physical means [n]\n",
  "CONCENTRE": "to have a common center, also CONCENTER [v CONCENTRED, CONCENTRING, CONCENTRES]\n",
  "CONCENTRED": "CONCENTRE, to have a common center, also CONCENTER [v]\n",
  "CONCENTRES": "CONCENTRE, to have a common center, also CONCENTER [v]\n",
  "CONCENTRIC": "having a common center, also CONCENTRICAL [adj CONCENTRICALLY]\n",
  "CONCENTRICAL": "having a common center, also CONCENTRIC [adj CONCENTRICALLY]\n",
  "CONCENTRICALLY": "CONCENTRICAL, having a common center, also CONCENTRIC [adv]\n",
  "CONCENTRICITIES": "CONCENTRICITY, the quality of being concentric [n]\n",
  "CONCENTRICITY": "the quality of being concentric [n CONCENTRICITIES]\n",
  "CONCENTRING": "CONCENTRE, to have a common center, also CONCENTER [v]\n",
  "CONCENTS": "CONCENT, (archaic) a harmony or concord of sounds or voices, also CONCENTUS [n]\n",
  "CONCENTUS": "(archaic) a harmony or concord of sounds or voices, also CONCENT [n CONCENTUS]\n",
  "CONCEPT": "a general idea [n -S]\n",
  "CONCEPTACLE": "(obsolete) a receptacle, a reproductive cavity [n -S]\n",
  "CONCEPTACLES": "CONCEPTACLE, (obsolete) a receptacle, a reproductive cavity [n]\n",
  "CONCEPTI": "CONCEPTUS, (Latin) the products of conception [n]\n",
  "CONCEPTION": "the process of becoming pregnant involving fertilization or implantation or both [n -S]\n",
  "CONCEPTIONAL": "capable of conceiving, also CONCEPTIVE [adj]\n",
  "CONCEPTIONS": "CONCEPTION, the process of becoming pregnant involving fertilization or implantation or both [n]\n",
  "CONCEPTIOUS": "(Shakespeare) fruitful [adj]\n",
  "CONCEPTIVE": "capable of conceiving, also CONCEPTIONAL [adj]\n",
  "CONCEPTS": "CONCEPT, a general idea [n]\n",
  "CONCEPTUAL": "relating to concepts [adj CONCEPTUALLY]\n",
  "CONCEPTUALISE": "to form a concept of, also CONCEPTUALIZE [v CONCEPTUALISED, CONCEPTUALISING, CONCEPTUALISES]\n",
  "CONCEPTUALISED": "CONCEPTUALISE, to form a concept of, also CONCEPTUALIZE [v]\n",
  "CONCEPTUALISER": "one who conceptualises, also CONCEPTUALIZER [n -S]\n",
  "CONCEPTUALISERS": "CONCEPTUALISER, one who conceptualises, also CONCEPTUALIZER [n]\n",
  "CONCEPTUALISES": "CONCEPTUALISE, to form a concept of, also CONCEPTUALIZE [v]\n",
  "CONCEPTUALISING": "CONCEPTUALISE, to form a concept of, also CONCEPTUALIZE [v]\n",
  "CONCEPTUALISM": "the doctrine in philosophy that universals exist only in the mind [n -S]\n",
  "CONCEPTUALISMS": "CONCEPTUALISM, the doctrine in philosophy that universals exist only in the mind [n]\n",
  "CONCEPTUALIST": "an adherent to the tenets of conceptualism or of conceptual art [n -S]\n",
  "CONCEPTUALISTIC": "relating to conceptualism [adj]\n",
  "CONCEPTUALISTS": "CONCEPTUALIST, an adherent to the tenets of conceptualism or of conceptual art [n]\n",
  "CONCEPTUALITIES": "CONCEPTUALITY, the quality of being conceptual [n]\n",
  "CONCEPTUALITY": "the quality of being conceptual [n CONCEPTUALITIES]\n",
  "CONCEPTUALIZE": "to form a concept of, also CONCEPTUALISE [v CONCEPTUALIZED, CONCEPTUALIZING, CONCEPTUALIZES]\n",
  "CONCEPTUALIZED": "CONCEPTUALIZE, to form a concept of, also CONCEPTUALISE [v]\n",
  "CONCEPTUALIZER": "one who conceptualizes, also CONCEPTUALISER [n -S]\n",
  "CONCEPTUALIZERS": "CONCEPTUALIZER, one who conceptualizes, also CONCEPTUALISER [n]\n",
  "CONCEPTUALIZES": "CONCEPTUALIZE, to form a concept of, also CONCEPTUALISE [v]\n",
  "CONCEPTUALIZING": "CONCEPTUALIZE, to form a concept of, also CONCEPTUALISE [v]\n",
  "CONCEPTUALLY": "CONCEPTUAL, relating to concepts [adv]\n",
  "CONCEPTUS": "(Latin) the products of conception [n CONCEPTUSES or CONCEPTI]\n",
  "CONCEPTUSES": "CONCEPTUS, (Latin) the products of conception [n]\n",
  "CONCERN": "to be of interest to [v -ED, -ING, -S]\n",
  "CONCERNANCIES": "CONCERNANCY, (Shakespeare) bearing, relevancy [n]\n",
  "CONCERNANCY": "(Shakespeare) bearing, relevancy [n CONCERNANCIES]\n",
  "CONCERNED": "CONCERN, to be of interest to [v]\n",
  "CONCERNEDLY": "CONCERNED, CONCERN, to be of interest to [adv]\n",
  "CONCERNEDNESS": "the state of being concerned [n -ES]\n",
  "CONCERNEDNESSES": "CONCERNEDNESS, the state of being concerned [n]\n",
  "CONCERNING": "CONCERN, to be of interest to [v]\n",
  "CONCERNMENT": "something in which one is concerned [n -S]\n",
  "CONCERNMENTS": "CONCERNMENT, something in which one is concerned [n]\n",
  "CONCERNS": "CONCERN, to be of interest to [v]\n",
  "CONCERT": "to construct or devise together [v -ED, -ING, -S]\n",
  "CONCERTANTE": "(Italian) exhibiting or needing great skill and brilliancy [adj] / a composition alternating tutti passages and passages for a group of soloists [n CONCERTANTES or CONCERTANTI]\n",
  "CONCERTANTES": "CONCERTANTE, a composition alternating tutti passages and passages for a group of soloists [n]\n",
  "CONCERTANTI": "CONCERTANTE, a composition alternating tutti passages and passages for a group of soloists [n]\n",
  "CONCERTED": "CONCERT, to construct or devise together [v]\n",
  "CONCERTEDLY": "CONCERTED, CONCERT, to construct or devise together [adv]\n",
  "CONCERTEDNESS": "the state of being concerted [n -ES]\n",
  "CONCERTEDNESSES": "CONCERTEDNESS, the state of being concerted [n]\n",
  "CONCERTGOER": "one who frequently attends concerts [n -S]\n",
  "CONCERTGOERS": "CONCERTGOER, one who frequently attends concerts [n]\n",
  "CONCERTGOING": "the act of attending concerts [n -S]\n",
  "CONCERTGOINGS": "CONCERTGOING, the act of attending concerts [n]\n",
  "CONCERTI": "CONCERTO, (Italian) a musical composition [n]\n",
  "CONCERTINA": "to fold up like a pair of bellows [v -ED, -ING, -S]\n",
  "CONCERTINAED": "CONCERTINA, to fold up like a pair of bellows [v]\n",
  "CONCERTINAING": "CONCERTINA, to fold up like a pair of bellows [v]\n",
  "CONCERTINAS": "CONCERTINA, to fold up like a pair of bellows [v]\n",
  "CONCERTING": "CONCERT, to construct or devise together [v]\n",
  "CONCERTINI": "CONCERTINO, (Italian) a short concerto [n]\n",
  "CONCERTINIST": "one who plays the concertina [n -S]\n",
  "CONCERTINISTS": "CONCERTINIST, one who plays the concertina [n]\n",
  "CONCERTINO": "(Italian) a short concerto [n CONCERTINOS or CONCERTINI]\n",
  "CONCERTINOS": "CONCERTINO, (Italian) a short concerto [n]\n",
  "CONCERTISE": "to perform professionally in concerts, also CONCERTIZE [v CONCERTISED, CONCERTISING, CONCERTISES]\n",
  "CONCERTISED": "CONCERTISE, to perform professionally in concerts, also CONCERTIZE [v]\n",
  "CONCERTISES": "CONCERTISE, to perform professionally in concerts, also CONCERTIZE [v]\n",
  "CONCERTISING": "CONCERTISE, to perform professionally in concerts, also CONCERTIZE [v]\n",
  "CONCERTIZE": "to perform professionally in concerts, also CONCERTISE [v CONCERTIZED, CONCERTIZING, CONCERTIZES]\n",
  "CONCERTIZED": "CONCERTIZE, to perform professionally in concerts, also CONCERTISE [v]\n",
  "CONCERTIZES": "CONCERTIZE, to perform professionally in concerts, also CONCERTISE [v]\n",
  "CONCERTIZING": "CONCERTIZE, to perform professionally in concerts, also CONCERTISE [v]\n",
  "CONCERTMASTER": "the leader of the first violins of an orchestra and by custom usually the assistant to the conductor, also CONCERTMEISTER [n -S]\n",
  "CONCERTMASTERS": "CONCERTMASTER, the leader of the first violins of an orchestra and by custom usually the assistant to the conductor, also CONCERTMEISTER [n]\n",
  "CONCERTMEISTER": "the leader of the first violins of an orchestra and by custom usually the assistant to the conductor, also CONCERTMASTER [n -S]\n",
  "CONCERTMEISTERS": "CONCERTMEISTER, the leader of the first violins of an orchestra and by custom usually the assistant to the conductor, also CONCERTMASTER [n]\n",
  "CONCERTMISTRESS": "the first violinist in an orchestra [n]\n",
  "CONCERTO": "(Italian) a musical composition [n CONCERTOS or CONCERTI]\n",
  "CONCERTOS": "CONCERTO, (Italian) a musical composition [n]\n",
  "CONCERTS": "CONCERT, to construct or devise together [v]\n",
  "CONCERTSTUCK": "a composition in concerto style but shorter than a full concerto [n -S]\n",
  "CONCERTSTUCKS": "CONCERTSTUCK, a composition in concerto style but shorter than a full concerto [n]\n",
  "CONCESSIBLE": "that can be conceded [adj]\n",
  "CONCESSION": "the act of conceding [n -S]\n",
  "CONCESSIONAIRE": "the owner or operator of a concession, also CONCESSIONNAIRE [n -S]\n",
  "CONCESSIONAIRES": "CONCESSIONAIRE, the owner or operator of a concession, also CONCESSIONNAIRE [n]\n",
  "CONCESSIONAL": "in the nature of a concession [adj]\n",
  "CONCESSIONARIES": "CONCESSIONARY, one to whom a concession is granted [n]\n",
  "CONCESSIONARY": "of the nature of a concession [adj] / one to whom a concession is granted [n CONCESSIONARIES]\n",
  "CONCESSIONER": "one receiving a concession [n -S]\n",
  "CONCESSIONERS": "CONCESSIONER, one receiving a concession [n]\n",
  "CONCESSIONIST": "one who believes in making concessions [n -S]\n",
  "CONCESSIONISTS": "CONCESSIONIST, one who believes in making concessions [n]\n",
  "CONCESSIONNAIRE": "the owner or operator of a concession, also CONCESSIONAIRE [n]\n",
  "CONCESSIONS": "CONCESSION, the act of conceding [n]\n",
  "CONCESSIVE": "implying concession; as, a concessive conjunction [adj CONCESSIVELY]\n",
  "CONCESSIVELY": "CONCESSIVE, implying concession; as, a concessive conjunction [adv]\n",
  "CONCETTI": "CONCETTO, (Italian) an ingenious expression, a witticism [n]\n",
  "CONCETTISM": "the use of concetti or affected conceits [n -S]\n",
  "CONCETTISMS": "CONCETTISM, the use of concetti or affected conceits [n]\n",
  "CONCETTIST": "one adept in concetti, conceits, ingenious turns of phrase [n -S]\n",
  "CONCETTISTS": "CONCETTIST, one adept in concetti, conceits, ingenious turns of phrase [n]\n",
  "CONCETTO": "(Italian) an ingenious expression, a witticism [n CONCETTI]\n",
  "CONCH": "a marine mollusk [n CONCHS or CONCHES]\n",
  "CONCHA": "(Latin) the outer ear cavity [n CONCHAS or CONCHAE]\n",
  "CONCHAE": "CONCHA, (Latin) the outer ear cavity [n]\n",
  "CONCHAL": "pertaining to the concha, or external ear [adj]\n",
  "CONCHAS": "CONCHA, (Latin) the outer ear cavity [n]\n",
  "CONCHATE": "shaped like a shell [adj]\n",
  "CONCHE": "to knead and mix chocolate [v CONCHED, CONCHING, CONCHES]\n",
  "CONCHED": "CONCHE, to knead and mix chocolate [v]\n",
  "CONCHES": "CONCHE, to knead and mix chocolate [v]\n",
  "CONCHIE": "a conscientious objector, also CONCHY [n -S]\n",
  "CONCHIES": "CONCHY, a conscientious objector, also CONCHIE [n]\n",
  "CONCHIFEROUS": "bearing a shell [adj]\n",
  "CONCHIFORM": "shaped like a shell [adj]\n",
  "CONCHIGLIE": "(Italian) shell-shaped pasta [n]\n",
  "CONCHING": "CONCHE, to knead and mix chocolate [v]\n",
  "CONCHIOLIN": "a fibrous protein substance that forms the basic structure of the shell of molluscs [n -S]\n",
  "CONCHIOLINS": "CONCHIOLIN, a fibrous protein substance that forms the basic structure of the shell of molluscs [n]\n",
  "CONCHITIS": "inflammation of the concha [n -ES]\n",
  "CONCHITISES": "CONCHITIS, inflammation of the concha [n]\n",
  "CONCHO": "an ornamental disk (as on clothing or tack) of American Indian origin featuring a shell or flower design [n -S]\n",
  "CONCHOID": "a type of geometric curve [n -S]\n",
  "CONCHOIDAL": "shell-like, as applied to fractures in glass and quartz [adj CONCHOIDALLY]\n",
  "CONCHOIDALLY": "CONCHOIDAL, shell-like, as applied to fractures in glass and quartz [adv]\n",
  "CONCHOIDS": "CONCHOID, a type of geometric curve [n]\n",
  "CONCHOLOGICAL": "relating to conchology, the study of shells [adj]\n",
  "CONCHOLOGIES": "CONCHOLOGY, the study of shells [n]\n",
  "CONCHOLOGIST": "a collector or student of shells [n -S]\n",
  "CONCHOLOGISTS": "CONCHOLOGIST, a collector or student of shells [n]\n",
  "CONCHOLOGY": "the study of shells [n CONCHOLOGIES]\n",
  "CONCHOS": "CONCHO, an ornamental disk (as on clothing or tack) of American Indian origin featuring a shell or flower design [n]\n",
  "CONCHS": "CONCH, a marine mollusk [n]\n",
  "CONCHY": "a conscientious objector, also CONCHIE [n CONCHIES]\n",
  "CONCIERGE": "(French) one who keeps the entrance to an edifice, public or private [n -S]\n",
  "CONCIERGES": "CONCIERGE, (French) one who keeps the entrance to an edifice, public or private [n]\n",
  "CONCILIABLE": "(obsolete) that can be conciliated [adj]\n",
  "CONCILIAR": "of or pertaining to (esp. ecclesiastical) councils, also CONCILIARY [adj CONCILIARLY]\n",
  "CONCILIARLY": "CONCILIAR, of or pertaining to (esp. ecclesiastical) councils, also CONCILIARY [adv]\n",
  "CONCILIARY": "of or pertaining to (esp. ecclesiastical) councils, also CONCILIAR [adj]\n",
  "CONCILIATE": "to gain (as goodwill) by pleasing acts [v CONCILIATED, CONCILIATING, CONCILIATES]\n",
  "CONCILIATED": "CONCILIATE, to gain (as goodwill) by pleasing acts [v]\n",
  "CONCILIATES": "CONCILIATE, to gain (as goodwill) by pleasing acts [v]\n",
  "CONCILIATING": "CONCILIATE, to gain (as goodwill) by pleasing acts [v]\n",
  "CONCILIATION": "the act of conciliating [n -S]\n",
  "CONCILIATIONS": "CONCILIATION, the act of conciliating [n]\n",
  "CONCILIATIVE": "serving to conciliate [adj]\n",
  "CONCILIATOR": "one who conciliates [n -S]\n",
  "CONCILIATORILY": "CONCILIATORY, tending to win over from a state of hostility or distrust [adv]\n",
  "CONCILIATORS": "CONCILIATOR, one who conciliates [n]\n",
  "CONCILIATORY": "tending to win over from a state of hostility or distrust [adj CONCILIATORILY]\n",
  "CONCINNITIES": "CONCINNITY, harmony or elegance of design, esp. of literary style in adaptation of parts to a whole or to each other [n]\n",
  "CONCINNITY": "harmony or elegance of design, esp. of literary style in adaptation of parts to a whole or to each other [n CONCINNITIES]\n",
  "CONCINNOUS": "characterized by concinnity; neat; elegant [adj]\n",
  "CONCIPIENCIES": "CONCIPIENCY, the state of being concipient [n]\n",
  "CONCIPIENCY": "the state of being concipient [n CONCIPIENCIES]\n",
  "CONCIPIENT": "conceiving [adj]\n",
  "CONCISE": "succinct [adj CONCISER, CONCISEST, CONCISELY] / (Milton) to mutilate [v CONCISED, CONCISING, CONCISES]\n",
  "CONCISED": "CONCISE, (Milton) to mutilate [v]\n",
  "CONCISELY": "CONCISE, succinct [adv]\n",
  "CONCISENESS": "the state of being concise [n -ES]\n",
  "CONCISENESSES": "CONCISENESS, the state of being concise [n]\n",
  "CONCISER": "CONCISE, succinct [adj]\n",
  "CONCISES": "CONCISE, (Milton) to mutilate [v]\n",
  "CONCISEST": "CONCISE, succinct [adj]\n",
  "CONCISING": "CONCISE, (Milton) to mutilate [v]\n",
  "CONCISION": "schism; separation [n -S]\n",
  "CONCISIONS": "CONCISION, schism; separation [n]\n",
  "CONCLAMATION": "a shout of many voices together [n -S]\n",
  "CONCLAMATIONS": "CONCLAMATION, a shout of many voices together [n]\n",
  "CONCLAVE": "the room in which cardinals meet to elect a pope; any secret assembly [n -S]\n",
  "CONCLAVES": "CONCLAVE, the room in which cardinals meet to elect a pope; any secret assembly [n]\n",
  "CONCLAVISM": "a minority movement that rejects the authority of the established pope and instead supports an alternative pope [n -S]\n",
  "CONCLAVISMS": "CONCLAVISM, a minority movement that rejects the authority of the established pope and instead supports an alternative pope [n]\n",
  "CONCLAVIST": "one of the two ecclesiastics allowed to attend a cardinal in the conclave [n -S]\n",
  "CONCLAVISTS": "CONCLAVIST, one of the two ecclesiastics allowed to attend a cardinal in the conclave [n]\n",
  "CONCLUDE": "to finish [v CONCLUDED, CONCLUDING, CONCLUDES]\n",
  "CONCLUDED": "CONCLUDE, to finish [v]\n",
  "CONCLUDER": "one who concludes [n -S]\n",
  "CONCLUDERS": "CONCLUDER, one who concludes [n]\n",
  "CONCLUDES": "CONCLUDE, to finish [v]\n",
  "CONCLUDING": "CONCLUDE, to finish [v]\n",
  "CONCLUSION": "a result, outcome [n -S]\n",
  "CONCLUSIONARY": "relating to a conclusion [adj]\n",
  "CONCLUSIONS": "CONCLUSION, a result, outcome [n]\n",
  "CONCLUSIVE": "relating to a conclusion [adj CONCLUSIVELY]\n",
  "CONCLUSIVELY": "CONCLUSIVE, relating to a conclusion [adv]\n",
  "CONCLUSIVENESS": "the state of being conclusive [n]\n",
  "CONCLUSORY": "conclusive [adj]\n",
  "CONCOCT": "to fabricate [v -ED, -ING, -S]\n",
  "CONCOCTED": "CONCOCT, to fabricate [v]\n",
  "CONCOCTER": "one who concocts, also CONCOCTOR [n -S]\n",
  "CONCOCTERS": "CONCOCTER, one who concocts, also CONCOCTOR [n]\n",
  "CONCOCTING": "CONCOCT, to fabricate [v]\n",
  "CONCOCTION": "the act of concocting; something concocted [n -S]\n",
  "CONCOCTIONS": "CONCOCTION, the act of concocting; something concocted [n]\n",
  "CONCOCTIVE": "having the power of digesting or ripening; digestive [adj]\n",
  "CONCOCTOR": "one who concocts, also CONCOCTER [n -S]\n",
  "CONCOCTORS": "CONCOCTOR, one who concocts, also CONCOCTER [n]\n",
  "CONCOCTS": "CONCOCT, to fabricate [v]\n",
  "CONCOLOR": "of uniform color, also CONCOLORATE, CONCOLOROUS [adj]\n",
  "CONCOLORATE": "of uniform color, also CONCOLOR, CONCOLOROUS [adj]\n",
  "CONCOLOROUS": "of uniform color, also CONCOLOR, CONCOLORATE [adj]\n",
  "CONCOMITANCE": "accompaniment [n -S]\n",
  "CONCOMITANCES": "CONCOMITANCE, accompaniment [n]\n",
  "CONCOMITANCIES": "CONCOMITANCY, the state of being concomitant [n]\n",
  "CONCOMITANCY": "the state of being concomitant [n CONCOMITANCIES]\n",
  "CONCOMITANT": "accompanying esp. in a subordinate or incidental way [adj CONCOMITANTLY] / something accompanying [n -S]\n",
  "CONCOMITANTLY": "CONCOMITANT, accompanying esp. in a subordinate or incidental way [adv]\n",
  "CONCOMITANTS": "CONCOMITANT, something accompanying [n]\n",
  "CONCORD": "to be in or come into agreement or harmony [v -ED, -ING, -S]\n",
  "CONCORDAL": "relating to a concord [adj]\n",
  "CONCORDANCE": "an alphabetical index of the principal words in a book or the works of an author with their immediate contexts [n -S]\n",
  "CONCORDANCES": "CONCORDANCE, an alphabetical index of the principal words in a book or the works of an author with their immediate contexts [n]\n",
  "CONCORDANT": "harmonious, united [adj CONCORDANTLY]\n",
  "CONCORDANTLY": "CONCORDANT, harmonious, united [adv]\n",
  "CONCORDAT": "(French) an agreement between the pope and a secular government [n -S]\n",
  "CONCORDATS": "CONCORDAT, (French) an agreement between the pope and a secular government [n]\n",
  "CONCORDED": "CONCORD, to be in or come into agreement or harmony [v]\n",
  "CONCORDIAL": "harmonious [adj]\n",
  "CONCORDING": "CONCORD, to be in or come into agreement or harmony [v]\n",
  "CONCORDS": "CONCORD, to be in or come into agreement or harmony [v]\n",
  "CONCORPORATE": "(archaic) to unite in one body [v CONCORPORATED, CONCORPORATING, CONCORPORATES]\n",
  "CONCORPORATED": "CONCORPORATE, (archaic) to unite in one body [v]\n",
  "CONCORPORATES": "CONCORPORATE, (archaic) to unite in one body [v]\n",
  "CONCORPORATING": "CONCORPORATE, (archaic) to unite in one body [v]\n",
  "CONCOURS": "(French) a competition, a contest [n]\n",
  "CONCOURSE": "an assembly of people for some event [n -S]\n",
  "CONCOURSES": "CONCOURS, (French) a competition, a contest [n]\n",
  "CONCREATE": "(archaic) to create at the same time [v CONCREATED, CONCREATING, CONCREATES]\n",
  "CONCREATED": "CONCREATE, (archaic) to create at the same time [v]\n",
  "CONCREATES": "CONCREATE, (archaic) to create at the same time [v]\n",
  "CONCREATING": "CONCREATE, (archaic) to create at the same time [v]\n",
  "CONCREMATION": "complete burning [n -S]\n",
  "CONCREMATIONS": "CONCREMATION, complete burning [n]\n",
  "CONCRESCENCE": "a growing together [n -S]\n",
  "CONCRESCENCES": "CONCRESCENCE, a growing together [n]\n",
  "CONCRESCENT": "growing together [adj]\n",
  "CONCRETE": "real, graspable [adj CONCRETELY] / a mixture of sand, gravel and cement used in building [n -S] / to solidify [v CONCRETED, CONCRETING, CONCRETES]\n",
  "CONCRETED": "CONCRETE, to solidify [v]\n",
  "CONCRETELY": "CONCRETE, real, graspable [adv]\n",
  "CONCRETENESS": "the state of being concrete [n -ES]\n",
  "CONCRETENESSES": "CONCRETENESS, the state of being concrete [n]\n",
  "CONCRETES": "CONCRETE, to solidify [v]\n",
  "CONCRETING": "CONCRETE, to solidify [v]\n",
  "CONCRETION": "a concreted mass [n -S]\n",
  "CONCRETIONARY": "of or like a concretion [adj]\n",
  "CONCRETIONS": "CONCRETION, a concreted mass [n]\n",
  "CONCRETISATION": "the act of concretising, also CONCRETIZATION [n -S]\n",
  "CONCRETISATIONS": "CONCRETISATION, the act of concretising, also CONCRETIZATION [n]\n",
  "CONCRETISE": "to render concrete, realize, also CONCRETIZE [v CONCRETISED, CONCRETISING, CONCRETISES]\n",
  "CONCRETISED": "CONCRETISE, to render concrete, realize, also CONCRETIZE [v]\n",
  "CONCRETISES": "CONCRETISE, to render concrete, realize, also CONCRETIZE [v]\n",
  "CONCRETISING": "CONCRETISE, to render concrete, realize, also CONCRETIZE [v]\n",
  "CONCRETISM": "reification [n -S]\n",
  "CONCRETISMS": "CONCRETISM, reification [n]\n",
  "CONCRETIST": "one who regards or represents abstract things as concrete [n -S]\n",
  "CONCRETISTS": "CONCRETIST, one who regards or represents abstract things as concrete [n]\n",
  "CONCRETIVE": "promoting concretion [adj CONCRETIVELY]\n",
  "CONCRETIVELY": "CONCRETIVE, promoting concretion [adv]\n",
  "CONCRETIZATION": "the act of concretizing, also CONCRETISATION [n -S]\n",
  "CONCRETIZATIONS": "CONCRETIZATION, the act of concretizing, also CONCRETISATION [n]\n",
  "CONCRETIZE": "to render concrete, realize, also CONCRETISE [v CONCRETIZED, CONCRETIZING, CONCRETIZES]\n",
  "CONCRETIZED": "CONCRETIZE, to render concrete, realize, also CONCRETISE [v]\n",
  "CONCRETIZES": "CONCRETIZE, to render concrete, realize, also CONCRETISE [v]\n",
  "CONCRETIZING": "CONCRETIZE, to render concrete, realize, also CONCRETISE [v]\n",
  "CONCREW": "(archaic) to grow together [v -ED, -ING, -S]\n",
  "CONCREWED": "CONCREW, (archaic) to grow together [v]\n",
  "CONCREWING": "CONCREW, (archaic) to grow together [v]\n",
  "CONCREWS": "CONCREW, (archaic) to grow together [v]\n",
  "CONCUBINAGE": "the cohabitation of persons not legally married [n -S]\n",
  "CONCUBINAGES": "CONCUBINAGE, the cohabitation of persons not legally married [n]\n",
  "CONCUBINARIES": "CONCUBINARY, a concubine [n]\n",
  "CONCUBINARY": "relating to a concubine [adj] / a concubine [n CONCUBINARIES]\n",
  "CONCUBINE": "a woman who cohabits with a man without being married; a kept mistress, also CONCUPY [n -S]\n",
  "CONCUBINES": "CONCUBINE, a woman who cohabits with a man without being married; a kept mistress, also CONCUPY [n]\n",
  "CONCUBITANCIES": "CONCUBITANCY, a custom by which marriage between certain persons is obligatory [n]\n",
  "CONCUBITANCY": "a custom by which marriage between certain persons is obligatory [n CONCUBITANCIES]\n",
  "CONCUBITANT": "someone of a suitable age for marriage [n -S]\n",
  "CONCUBITANTS": "CONCUBITANT, someone of a suitable age for marriage [n]\n",
  "CONCUPIES": "CONCUPY, (Shakespeare) a concubine [n]\n",
  "CONCUPISCENCE": "strong desire, appetite or lust [n -S]\n",
  "CONCUPISCENCES": "CONCUPISCENCE, strong desire, appetite or lust [n]\n",
  "CONCUPISCENT": "having strong sexual desires [adj]\n",
  "CONCUPISCIBLE": "lustful, desirous [adj]\n",
  "CONCUPY": "(Shakespeare) a concubine [n CONCUPIES]\n",
  "CONCUR": "to concur [v CONCURRED, CONCURRING, CONCURS]\n",
  "CONCURRED": "CONCUR, to concur [v]\n",
  "CONCURRENCE": "the state of being concurrent, also CONCURRENCY [n -S]\n",
  "CONCURRENCES": "CONCURRENCE, the state of being concurrent, also CONCURRENCY [n]\n",
  "CONCURRENCIES": "CONCURRENCY, the state of being concurrent, also CONCURRENCE [n]\n",
  "CONCURRENCY": "the state of being concurrent, also CONCURRENCE [n CONCURRENCIES]\n",
  "CONCURRENT": "operating or occurring at the same time [adj CONCURRENTLY] / a person or thing who concurs [n -S]\n",
  "CONCURRENTLY": "CONCURRENT, operating or occurring at the same time [adv]\n",
  "CONCURRENTS": "CONCURRENT, a person or thing who concurs [n]\n",
  "CONCURRING": "CONCUR, to concur [v]\n",
  "CONCURRINGLY": "CONCURRING, CONCUR, to concur [adv]\n",
  "CONCURS": "CONCUR, to concur [v]\n",
  "CONCUSS": "to injure the brain by a violent blow [v -ED, -ING, -ES]\n",
  "CONCUSSED": "CONCUSS, to injure the brain by a violent blow [v]\n",
  "CONCUSSES": "CONCUSS, to injure the brain by a violent blow [v]\n",
  "CONCUSSING": "CONCUSS, to injure the brain by a violent blow [v]\n",
  "CONCUSSION": "a stunning effect from a hard blow [n -S]\n",
  "CONCUSSIONS": "CONCUSSION, a stunning effect from a hard blow [n]\n",
  "CONCUSSIVE": "having the power of concussion [adj]\n",
  "CONCYCLIC": "lying or situated on the circumference of the same circle [adj]\n",
  "CONCYCLICALLY": "CONCYCLIC, lying or situated on the circumference of the same circle [adv]\n",
  "COND": "CON, to study carefully [v]\n",
  "CONDEMN": "to judge unfavourably [v -ED, -ING, -S]\n",
  "CONDEMNABLE": "able to be condemned [adj CONDEMNABLY]\n",
  "CONDEMNABLY": "CONDEMNABLE, able to be condemned [adv]\n",
  "CONDEMNATION": "the act of condemning [n -S]\n",
  "CONDEMNATIONS": "CONDEMNATION, the act of condemning [n]\n",
  "CONDEMNATORY": "serving to condemn [adj]\n",
  "CONDEMNED": "CONDEMN, to judge unfavourably [v]\n",
  "CONDEMNER": "one who condemns, also CONDEMNOR [n -S]\n",
  "CONDEMNERS": "CONDEMNER, one who condemns, also CONDEMNOR [n]\n",
  "CONDEMNING": "CONDEMN, to judge unfavourably [v]\n",
  "CONDEMNINGLY": "CONDEMNING, CONDEMN, to judge unfavourably [adv]\n",
  "CONDEMNOR": "one who condemns, also CONDEMNER [n -S]\n",
  "CONDEMNORS": "CONDEMNOR, one who condemns, also CONDEMNER [n]\n",
  "CONDEMNS": "CONDEMN, to judge unfavourably [v]\n",
  "CONDENSABILITY": "the quality of being condensable [n]\n",
  "CONDENSABLE": "capable of being condensed, also CONDENSIBLE [adj]\n",
  "CONDENSATE": "to condense [v CONDENSATED, CONDENSATING, CONDENSATES]\n",
  "CONDENSATED": "CONDENSATE, to condense [v]\n",
  "CONDENSATES": "CONDENSATE, to condense [v]\n",
  "CONDENSATING": "CONDENSATE, to condense [v]\n",
  "CONDENSATION": "the act of condensing [n -S]\n",
  "CONDENSATIONAL": "relating to condensation [adj]\n",
  "CONDENSATIONS": "CONDENSATION, the act of condensing [n]\n",
  "CONDENSE": "to compress [v CONDENSED, CONDENSING, CONDENSES]\n",
  "CONDENSED": "CONDENSE, to compress [v]\n",
  "CONDENSER": "an apparatus for reducing vapours to a liquid form [n -S]\n",
  "CONDENSERIES": "CONDENSERY, a condensed milk-factory [n]\n",
  "CONDENSERS": "CONDENSER, an apparatus for reducing vapours to a liquid form [n]\n",
  "CONDENSERY": "a condensed milk-factory [n CONDENSERIES]\n",
  "CONDENSES": "CONDENSE, to compress [v]\n",
  "CONDENSIBILITY": "the state of being condensible [n]\n",
  "CONDENSIBLE": "capable of being condensed, also CONDENSABLE [adj]\n",
  "CONDENSING": "CONDENSE, to compress [v]\n",
  "CONDER": "a person who, stationed on high ground, signals the direction taken by shoals of herring etc. to a fishing boat [n -S]\n",
  "CONDERS": "CONDER, a person who, stationed on high ground, signals the direction taken by shoals of herring etc. to a fishing boat [n]\n",
  "CONDESCEND": "to descend to a less formal or dignified level [v -ED, -ING, -S]\n",
  "CONDESCENDED": "CONDESCEND, to descend to a less formal or dignified level [v]\n",
  "CONDESCENDENCE": "voluntary descent from one's rank or dignity in relations with an inferior [n -S]\n",
  "CONDESCENDENCES": "CONDESCENDENCE, voluntary descent from one's rank or dignity in relations with an inferior [n]\n",
  "CONDESCENDING": "CONDESCEND, to descend to a less formal or dignified level [v]\n",
  "CONDESCENDINGLY": "CONDESCENDING, CONDESCEND, to descend to a less formal or dignified level [adv]\n",
  "CONDESCENDS": "CONDESCEND, to descend to a less formal or dignified level [v]\n",
  "CONDESCENSION": "voluntary descent from one's rank or dignity in relations with an inferior [n -S]\n",
  "CONDESCENSIONS": "CONDESCENSION, voluntary descent from one's rank or dignity in relations with an inferior [n]\n",
  "CONDIDDLE": "(Scott) to steal [v CONDIDDLED, CONDIDDLING, CONDIDDLES]\n",
  "CONDIDDLED": "CONDIDDLE, (Scott) to steal [v]\n",
  "CONDIDDLES": "CONDIDDLE, (Scott) to steal [v]\n",
  "CONDIDDLING": "CONDIDDLE, (Scott) to steal [v]\n",
  "CONDIE": "a covered drain, also CUNDY [n -S]\n",
  "CONDIES": "CONDIE, a covered drain, also CUNDY [n]\n",
  "CONDIGN": "deserved, appropriate [adj CONDIGNLY]\n",
  "CONDIGNLY": "CONDIGN, deserved, appropriate [adv]\n",
  "CONDIGNNESS": "the state of being condign [n -ES]\n",
  "CONDIGNNESSES": "CONDIGNNESS, the state of being condign [n]\n",
  "CONDIMENT": "a seasoning e.g. salt or pepper [n -S] / to season with a condiment [v -ED, -ING, -S]\n",
  "CONDIMENTAL": "relating to condiments [adj]\n",
  "CONDIMENTED": "CONDIMENT, to season with a condiment [v]\n",
  "CONDIMENTING": "CONDIMENT, to season with a condiment [v]\n",
  "CONDIMENTS": "CONDIMENT, to season with a condiment [v]\n",
  "CONDISCIPLE": "a fellow disciple [n -S]\n",
  "CONDISCIPLES": "CONDISCIPLE, a fellow disciple [n]\n",
  "CONDITION": "to treat hair with conditioner [v -ED, -ING, -S]\n",
  "CONDITIONABLE": "capable of being conditioned [adj]\n",
  "CONDITIONAL": "dependent on a condition [adj CONDITIONALLY] / a conditional word, clause, verb form, or morpheme [n -S]\n",
  "CONDITIONALITY": "the state of being conditional [n]\n",
  "CONDITIONALLY": "CONDITIONAL, dependent on a condition [adv]\n",
  "CONDITIONALS": "CONDITIONAL, a conditional word, clause, verb form, or morpheme [n]\n",
  "CONDITIONATE": "(obsolete) to act as a condition [v CONDITIONATED, CONDITIONATING, CONDITIONATES]\n",
  "CONDITIONATED": "CONDITIONATE, (obsolete) to act as a condition [v]\n",
  "CONDITIONATES": "CONDITIONATE, (obsolete) to act as a condition [v]\n",
  "CONDITIONATING": "CONDITIONATE, (obsolete) to act as a condition [v]\n",
  "CONDITIONED": "CONDITION, to treat hair with conditioner [v]\n",
  "CONDITIONER": "something that conditions [n -S]\n",
  "CONDITIONERS": "CONDITIONER, something that conditions [n]\n",
  "CONDITIONING": "the act of conditioning [n -S]\n",
  "CONDITIONINGS": "CONDITIONING, the act of conditioning [n]\n",
  "CONDITIONS": "CONDITION, to treat hair with conditioner [v]\n",
  "CONDO": "(short for) a condominium, a set of flats, group of cottages, etc. rented or bought by a group of people [n CONDOS or CONDOES]\n",
  "CONDOES": "CONDO, (short for) a condominium, a set of flats, group of cottages, etc. rented or bought by a group of people [n]\n",
  "CONDOLATORY": "serving to condole [adj]\n",
  "CONDOLE": "to express sympathetic sorrow; to grieve in sympathy [v CONDOLED, CONDOLING, CONDOLES]\n",
  "CONDOLED": "CONDOLE, to express sympathetic sorrow; to grieve in sympathy [v]\n",
  "CONDOLEMENT": "(Shakespeare) the act of condoling [n -S]\n",
  "CONDOLEMENTS": "CONDOLEMENT, (Shakespeare) the act of condoling [n]\n",
  "CONDOLENCE": "sympathy with another in sorrow [n -S]\n",
  "CONDOLENCES": "CONDOLENCE, sympathy with another in sorrow [n]\n",
  "CONDOLENT": "expressing sympathy [adj]\n",
  "CONDOLER": "one who condoles [n -S]\n",
  "CONDOLERS": "CONDOLER, one who condoles [n]\n",
  "CONDOLES": "CONDOLE, to express sympathetic sorrow; to grieve in sympathy [v]\n",
  "CONDOLING": "CONDOLE, to express sympathetic sorrow; to grieve in sympathy [v]\n",
  "CONDOLINGLY": "CONDOLING, CONDOLE, to express sympathetic sorrow; to grieve in sympathy [adv]\n",
  "CONDOM": "a prophylactic [n -S]\n",
  "CONDOMINIA": "CONDOMINIUM, (US) a block of apartments in which each apartment is separately owned [n]\n",
  "CONDOMINIUM": "(US) a block of apartments in which each apartment is separately owned [n CONDOMINIA or CONDOMINIUMS]\n",
  "CONDOMINIUMS": "CONDOMINIUM, (US) a block of apartments in which each apartment is separately owned [n]\n",
  "CONDOMS": "CONDOM, a prophylactic [n]\n",
  "CONDONABLE": "that can be condoned [adj]\n",
  "CONDONATION": "implied pardon of an offense by treating the offender as if it had not been committed [n -S]\n",
  "CONDONATIONS": "CONDONATION, implied pardon of an offense by treating the offender as if it had not been committed [n]\n",
  "CONDONE": "to forgive or overlook [v CONDONED, CONDONING, CONDONES]\n",
  "CONDONED": "CONDONE, to forgive or overlook [v]\n",
  "CONDONER": "one who condones [n -S]\n",
  "CONDONERS": "CONDONER, one who condones [n]\n",
  "CONDONES": "CONDONE, to forgive or overlook [v]\n",
  "CONDONING": "CONDONE, to forgive or overlook [v]\n",
  "CONDOR": "(Quechua) a coin of Chile [n CONDORS or CONDORES]\n",
  "CONDORES": "CONDOR, (Quechua) a coin of Chile [n]\n",
  "CONDORS": "CONDOR, (Quechua) a coin of Chile [n]\n",
  "CONDOS": "CONDO, (short for) a condominium, a set of flats, group of cottages, etc. rented or bought by a group of people [n]\n",
  "CONDOTTIERE": "(Italian) a hired soldier; a mercenary [n CONDOTTIERI]\n",
  "CONDOTTIERI": "CONDOTTIERE, (Italian) a hired soldier; a mercenary [n]\n",
  "CONDUCE": "to contribute to a result [v CONDUCED, CONDUCING, CONDUCES]\n",
  "CONDUCED": "CONDUCE, to contribute to a result [v]\n",
  "CONDUCEMENT": "(Milton) the act of conducing [n -S]\n",
  "CONDUCEMENTS": "CONDUCEMENT, (Milton) the act of conducing [n]\n",
  "CONDUCER": "one that conduces [n -S]\n",
  "CONDUCERS": "CONDUCER, one that conduces [n]\n",
  "CONDUCES": "CONDUCE, to contribute to a result [v]\n",
  "CONDUCIBLE": "conducive; tending; contributing [adj]\n",
  "CONDUCING": "CONDUCE, to contribute to a result [v]\n",
  "CONDUCINGLY": "CONDUCING, CONDUCE, to contribute to a result [adv]\n",
  "CONDUCIVE": "favourable to or helping towards something [adj]\n",
  "CONDUCIVENESS": "the state of being conducive [n -ES]\n",
  "CONDUCIVENESSES": "CONDUCIVENESS, the state of being conducive [n]\n",
  "CONDUCT": "to lead or guide [v -ED, -ING, -S]\n",
  "CONDUCTANCE": "a conductor's power of conducting electricity, the reciprocal of the resistance [n -S]\n",
  "CONDUCTANCES": "CONDUCTANCE, a conductor's power of conducting electricity, the reciprocal of the resistance [n]\n",
  "CONDUCTED": "CONDUCT, to lead or guide [v]\n",
  "CONDUCTI": "CONDUCTUS, (Latin) a style of metrical Latin song [n]\n",
  "CONDUCTIBILITY": "the state of being conductible [n]\n",
  "CONDUCTIBLE": "that can be conducted [adj]\n",
  "CONDUCTIMETRIC": "of or relating to the measurement of conductivity, also CONDUCTIOMETRIC, CONDUCTOMETRIC [adj]\n",
  "CONDUCTING": "CONDUCT, to lead or guide [v]\n",
  "CONDUCTIOMETRIC": "of or relating to the measurement of conductivity, also CONDUCTIMETRIC, CONDUCTOMETRIC [adj]\n",
  "CONDUCTION": "heat transport by direct transfer of energy from one particle to another, without moving the particle to a new location [n -S]\n",
  "CONDUCTIONAL": "relating to conduction [adj]\n",
  "CONDUCTIONS": "CONDUCTION, heat transport by direct transfer of energy from one particle to another, without moving the particle to a new location [n]\n",
  "CONDUCTIVE": "having the power of conducting [adj CONDUCTIVELY]\n",
  "CONDUCTIVELY": "CONDUCTIVE, having the power of conducting [adv]\n",
  "CONDUCTIVITIES": "CONDUCTIVITY, the power of conducting or transmitting [n]\n",
  "CONDUCTIVITY": "the power of conducting or transmitting [n CONDUCTIVITIES]\n",
  "CONDUCTOMETRIC": "of or relating to the measurement of conductivity, also CONDUCTIMETRIC, CONDUCTIOMETRIC [adj]\n",
  "CONDUCTOR": "a person or thing that conducts [n -S]\n",
  "CONDUCTORIAL": "of or like a conductor [adj]\n",
  "CONDUCTORS": "CONDUCTOR, a person or thing that conducts [n]\n",
  "CONDUCTORSHIP": "the office of conductor [n -S]\n",
  "CONDUCTORSHIPS": "CONDUCTORSHIP, the office of conductor [n]\n",
  "CONDUCTRESS": "a woman who is a conductor [n -ES]\n",
  "CONDUCTRESSES": "CONDUCTRESS, a woman who is a conductor [n]\n",
  "CONDUCTS": "CONDUCT, to lead or guide [v]\n",
  "CONDUCTUS": "(Latin) a style of metrical Latin song [n CONDUCTI]\n",
  "CONDUIT": "a channel or pipe for conveying fluids [n -S]\n",
  "CONDUITS": "CONDUIT, a channel or pipe for conveying fluids [n]\n",
  "CONDUPLICATE": "folded lengthwise with the upper surface inwards, e.g. on a leaf folded along the midrib [adj]\n",
  "CONDUPLICATION": "the state of being conduplicate [n -S]\n",
  "CONDUPLICATIONS": "CONDUPLICATION, the state of being conduplicate [n]\n",
  "CONDYLAR": "of or pertaining to a condyle, a bony prominence [adj]\n",
  "CONDYLE": "a protuberance on a bone [n -S]\n",
  "CONDYLES": "CONDYLE, a protuberance on a bone [n]\n",
  "CONDYLOID": "shaped like or pertaining to a condyle, a rounded protuberance at the end of a bone for articulation with another bone [adj]\n",
  "CONDYLOMA": "a wartlike growth in private parts [n CONDYLOMAS or CONDYLOMATA]\n",
  "CONDYLOMAS": "CONDYLOMA, a wartlike growth in private parts [n]\n",
  "CONDYLOMATA": "CONDYLOMA, a wartlike growth in private parts [n]\n",
  "CONDYLOMATOUS": "of or like a condyloma [adj]\n",
  "CONE": "to bear cones [v CONED, CONING, CONES]\n",
  "CONED": "CONE, to bear cones [v]\n",
  "CONEFLOWER": "any of several genera of showy plants of the family Compositae [n -S]\n",
  "CONEFLOWERS": "CONEFLOWER, any of several genera of showy plants of the family Compositae [n]\n",
  "CONELESS": "not bearing cones [adj]\n",
  "CONELIKE": "like a cone [adj]\n",
  "CONELRAD": "a system of defense against air attack [n -S]\n",
  "CONELRADS": "CONELRAD, a system of defense against air attack [n]\n",
  "CONENOSE": "a bloodsucking insect [n -S]\n",
  "CONENOSES": "CONENOSE, a bloodsucking insect [n]\n",
  "CONEPATE": "a skunk, also CONEPATL [n -S]\n",
  "CONEPATES": "CONEPATE, a skunk, also CONEPATL [n]\n",
  "CONEPATL": "a skunk, also CONEPATE [n -S]\n",
  "CONEPATLS": "CONEPATL, a skunk, also CONEPATE [n]\n",
  "CONES": "CONE, to bear cones [v]\n",
  "CONEY": "a rabbit, also CONY [n -S]\n",
  "CONEYS": "CONEY, a rabbit, also CONY [n]\n",
  "CONF": "an online conference [n -S]\n",
  "CONFAB": "to converse, gossip [v CONFABBED, CONFABBING, CONFABS]\n",
  "CONFABBED": "CONFAB, to converse, gossip [v]\n",
  "CONFABBING": "CONFAB, to converse, gossip [v]\n",
  "CONFABS": "CONFAB, to converse, gossip [v]\n",
  "CONFABULAR": "relating to confabulation, the fabrication of past experiences, either consciously or unconsciously to make up for loss of memory [adj]\n",
  "CONFABULATE": "to chat; to invent past experiences [v CONFABULATED, CONFABULATING, CONFABULATES]\n",
  "CONFABULATED": "CONFABULATE, to chat; to invent past experiences [v]\n",
  "CONFABULATES": "CONFABULATE, to chat; to invent past experiences [v]\n",
  "CONFABULATING": "CONFABULATE, to chat; to invent past experiences [v]\n",
  "CONFABULATION": "the fabrication of past experiences, either consciously or unconsciously to make up for loss of memory [n -S]\n",
  "CONFABULATIONS": "CONFABULATION, the fabrication of past experiences, either consciously or unconsciously to make up for loss of memory [n]\n",
  "CONFABULATOR": "one who confabulates [n -S]\n",
  "CONFABULATORS": "CONFABULATOR, one who confabulates [n]\n",
  "CONFABULATORY": "relating to confabulation [adj]\n",
  "CONFARREATE": "relating to confarreation [adj]\n",
  "CONFARREATION": "a Roman patrician mode of marriage, in which a spelt cake was offered up [n -S]\n",
  "CONFARREATIONS": "CONFARREATION, a Roman patrician mode of marriage, in which a spelt cake was offered up [n]\n",
  "CONFECT": "to prepare by combining ingredients [v -ED, -ING, -S]\n",
  "CONFECTED": "CONFECT, to prepare by combining ingredients [v]\n",
  "CONFECTING": "CONFECT, to prepare by combining ingredients [v]\n",
  "CONFECTION": "a fancy dish or sweetmeat [n -S]\n",
  "CONFECTIONARIES": "CONFECTIONARY, a place where sweets are made [n]\n",
  "CONFECTIONARY": "a place where sweets are made [n CONFECTIONARIES]\n",
  "CONFECTIONER": "a manufacturer of or dealer in confections [n -S]\n",
  "CONFECTIONERIES": "CONFECTIONERY, the confectioner's art or business [n]\n",
  "CONFECTIONERS": "CONFECTIONER, a manufacturer of or dealer in confections [n]\n",
  "CONFECTIONERY": "the confectioner's art or business [n CONFECTIONERIES]\n",
  "CONFECTIONS": "CONFECTION, a fancy dish or sweetmeat [n]\n",
  "CONFECTS": "CONFECT, to prepare by combining ingredients [v]\n",
  "CONFEDERACIES": "CONFEDERACY, a league or compact for mutual support or common action [n]\n",
  "CONFEDERACY": "a league or compact for mutual support or common action [n CONFEDERACIES]\n",
  "CONFEDERAL": "belonging to or relating to a confederation [adj]\n",
  "CONFEDERATE": "an ally, an accomplice [n -S] / to unite in a confederacy [v CONFEDERATED, CONFEDERATING, CONFEDERATES]\n",
  "CONFEDERATED": "CONFEDERATE, to unite in a confederacy [v]\n",
  "CONFEDERATES": "CONFEDERATE, to unite in a confederacy [v]\n",
  "CONFEDERATING": "CONFEDERATE, to unite in a confederacy [v]\n",
  "CONFEDERATION": "an act of confederating [n -S]\n",
  "CONFEDERATIONS": "CONFEDERATION, an act of confederating [n]\n",
  "CONFEDERATIVE": "of or like a confederation [adj]\n",
  "CONFER": "to bestow [v CONFERRED, CONFERRING, CONFERS]\n",
  "CONFEREE": "one on whom something is bestowed [n -S]\n",
  "CONFEREES": "CONFEREE, one on whom something is bestowed [n]\n",
  "CONFERENCE": "the act of conferring [n -S]\n",
  "CONFERENCES": "CONFERENCE, the act of conferring [n]\n",
  "CONFERENCIER": "(French) a lecturer [n -S]\n",
  "CONFERENCIERS": "CONFERENCIER, (French) a lecturer [n]\n",
  "CONFERENCING": "the practice of holding a conference in which the participants are linked by telephone, by telephone and video equipment, or by computer [n -S]\n",
  "CONFERENCINGS": "CONFERENCING, the practice of holding a conference in which the participants are linked by telephone, by telephone and video equipment, or by computer [n]\n",
  "CONFERENTIAL": "of or like a conference [adj]\n",
  "CONFERMENT": "bestowal, a thing bestowed [n -S]\n",
  "CONFERMENTS": "CONFERMENT, bestowal, a thing bestowed [n]\n",
  "CONFERRABLE": "that can be conferred [adj]\n",
  "CONFERRAL": "the act of conferring [n -S]\n",
  "CONFERRALS": "CONFERRAL, the act of conferring [n]\n",
  "CONFERRED": "CONFER, to bestow [v]\n",
  "CONFERREE": "one who takes part in a conference [n -S]\n",
  "CONFERREES": "CONFERREE, one who takes part in a conference [n]\n",
  "CONFERRENCE": "the act of conferring [n -S]\n",
  "CONFERRENCES": "CONFERRENCE, the act of conferring [n]\n",
  "CONFERRER": "one who confers [n -S]\n",
  "CONFERRERS": "CONFERRER, one who confers [n]\n",
  "CONFERRING": "CONFER, to bestow [v]\n",
  "CONFERS": "CONFER, to bestow [v]\n",
  "CONFERVA": "(Latin) a freshwater alga [n CONFERVAS or CONFERVAE]\n",
  "CONFERVAE": "CONFERVA, (Latin) a freshwater alga [n]\n",
  "CONFERVAL": "relating to a conferva, any of a large group of filamentous cryptogams [adj]\n",
  "CONFERVAS": "CONFERVA, (Latin) a freshwater alga [n]\n",
  "CONFERVOID": "relating the confervae, freshwater algae [adj] / a freshwater alga [n -S]\n",
  "CONFERVOIDS": "CONFERVOID, a freshwater alga [n]\n",
  "CONFESS": "to admit or disclose [v CONFESSED or CONFEST, CONFESSING, CONFESSES]\n",
  "CONFESSABLE": "that can be confessed [adj]\n",
  "CONFESSANT": "one who confesses to a priest [n -S]\n",
  "CONFESSANTS": "CONFESSANT, one who confesses to a priest [n]\n",
  "CONFESSED": "CONFESS, to admit or disclose [v]\n",
  "CONFESSEDLY": "CONFESSED, CONFESS, to admit or disclose [adv]\n",
  "CONFESSES": "CONFESS, to admit or disclose [v]\n",
  "CONFESSING": "CONFESS, to admit or disclose [v]\n",
  "CONFESSION": "a written or oral acknowledgment of guilt by a party accused of an offense [n -S]\n",
  "CONFESSIONAL": "relating to confession [adj CONFESSIONALLY] / the practice of confession [n -S]\n",
  "CONFESSIONALISM": "the practice of the confessional [n]\n",
  "CONFESSIONALIST": "one who takes the confessional [n]\n",
  "CONFESSIONALLY": "CONFESSIONAL, relating to confession [adv]\n",
  "CONFESSIONALS": "CONFESSIONAL, the practice of confession [n]\n",
  "CONFESSIONARIES": "CONFESSIONARY, a confession [n]\n",
  "CONFESSIONARY": "a confession [n CONFESSIONARIES]\n",
  "CONFESSIONS": "CONFESSION, a written or oral acknowledgment of guilt by a party accused of an offense [n]\n",
  "CONFESSOR": "one who hears confession [n -S]\n",
  "CONFESSORESS": "a female confessor [n -ES]\n",
  "CONFESSORESSES": "CONFESSORESS, a female confessor [n]\n",
  "CONFESSORS": "CONFESSOR, one who hears confession [n]\n",
  "CONFESSORSHIP": "the office of confessor [n -S]\n",
  "CONFESSORSHIPS": "CONFESSORSHIP, the office of confessor [n]\n",
  "CONFEST": "CONFESS, to admit or disclose [v]\n",
  "CONFESTLY": "CONFEST, CONFESS, to admit or disclose [adv]\n",
  "CONFETTI": "CONFETTO, (Italian) a small piece of paper thrown at a wedding [n]\n",
  "CONFETTO": "(Italian) a small piece of paper thrown at a wedding [n CONFETTI]\n",
  "CONFIDANT": "(French) a (male) person confided in or entrusted with secrets, esp. in love affairs, also CONFIDENT [n -S]\n",
  "CONFIDANTE": "(French) a (female) person confided in or entrusted with secrets, esp. in love affairs [n -S]\n",
  "CONFIDANTES": "CONFIDANTE, (French) a (female) person confided in or entrusted with secrets, esp. in love affairs [n]\n",
  "CONFIDANTS": "CONFIDANT, (French) a (male) person confided in or entrusted with secrets, esp. in love affairs, also CONFIDENT [n]\n",
  "CONFIDE": "to impart secrets in confidence [v CONFIDED, CONFIDING, CONFIDES]\n",
  "CONFIDED": "CONFIDE, to impart secrets in confidence [v]\n",
  "CONFIDENCE": "a feeling or consciousness of one's powers or of reliance on one's circumstances, also CONFIDENCY [n -S]\n",
  "CONFIDENCES": "CONFIDENCE, a feeling or consciousness of one's powers or of reliance on one's circumstances, also CONFIDENCY [n]\n",
  "CONFIDENCIES": "CONFIDENCY, a feeling or consciousness of one's powers or of reliance on one's circumstances, also CONFIDENCE [n]\n",
  "CONFIDENCY": "a feeling or consciousness of one's powers or of reliance on one's circumstances, also CONFIDENCE [n CONFIDENCIES]\n",
  "CONFIDENT": "self-assured [adj CONFIDENTLY] / a person in whom another confides, also CONFIDANT [n -S]\n",
  "CONFIDENTIAL": "marked by intimacy or willingness to confide [adj CONFIDENTIALLY]\n",
  "CONFIDENTIALITY": "the state of being confidential [n]\n",
  "CONFIDENTIALLY": "CONFIDENTIAL, marked by intimacy or willingness to confide [adv]\n",
  "CONFIDENTLY": "CONFIDENT, self-assured [adv]\n",
  "CONFIDENTS": "CONFIDENT, a person in whom another confides, also CONFIDANT [n]\n",
  "CONFIDER": "one who confides [n -S]\n",
  "CONFIDERS": "CONFIDER, one who confides [n]\n",
  "CONFIDES": "CONFIDE, to impart secrets in confidence [v]\n",
  "CONFIDING": "CONFIDE, to impart secrets in confidence [v]\n",
  "CONFIDINGLY": "CONFIDING, CONFIDE, to impart secrets in confidence [adv]\n",
  "CONFIDINGNESS": "the state of being confiding [n -ES]\n",
  "CONFIDINGNESSES": "CONFIDINGNESS, the state of being confiding [n]\n",
  "CONFIGURATE": "to shape, arrange [v CONFIGURATED, CONFIGURATING, CONFIGURATES]\n",
  "CONFIGURATED": "CONFIGURATE, to shape, arrange [v]\n",
  "CONFIGURATES": "CONFIGURATE, to shape, arrange [v]\n",
  "CONFIGURATING": "CONFIGURATE, to shape, arrange [v]\n",
  "CONFIGURATION": "external figure, shape or arrangement [n -S]\n",
  "CONFIGURATIONAL": "relating to configuration [adj]\n",
  "CONFIGURATIONS": "CONFIGURATION, external figure, shape or arrangement [n]\n",
  "CONFIGURATIVE": "relating to configuration [adj]\n",
  "CONFIGURATOR": "an item of software that enables or assists in the configuration of a product [n -S]\n",
  "CONFIGURATORS": "CONFIGURATOR, an item of software that enables or assists in the configuration of a product [n]\n",
  "CONFIGURE": "to set up (a computer system) [v CONFIGURED, CONFIGURING, CONFIGURES]\n",
  "CONFIGURED": "CONFIGURE, to set up (a computer system) [v]\n",
  "CONFIGURES": "CONFIGURE, to set up (a computer system) [v]\n",
  "CONFIGURING": "CONFIGURE, to set up (a computer system) [v]\n",
  "CONFINABLE": "capable of being confined, also CONFINEABLE [adj]\n",
  "CONFINE": "to shut within an enclosure [v CONFINED, CONFINING, CONFINES]\n",
  "CONFINEABLE": "capable of being confined, also CONFINABLE [adj]\n",
  "CONFINED": "CONFINE, to shut within an enclosure [v]\n",
  "CONFINEDLY": "CONFINED, CONFINE, to shut within an enclosure [adv]\n",
  "CONFINEDNESS": "the state of being confined [n -ES]\n",
  "CONFINEDNESSES": "CONFINEDNESS, the state of being confined [n]\n",
  "CONFINELESS": "(Shakespeare) without bound [adj]\n",
  "CONFINEMENT": "an act of confining [n -S]\n",
  "CONFINEMENTS": "CONFINEMENT, an act of confining [n]\n",
  "CONFINER": "one who, or that which, limits or restrains [n -S]\n",
  "CONFINERS": "CONFINER, one who, or that which, limits or restrains [n]\n",
  "CONFINES": "CONFINE, to shut within an enclosure [v]\n",
  "CONFINING": "CONFINE, to shut within an enclosure [v]\n",
  "CONFIRM": "to assure the validity of [v -ED, -ING, -S]\n",
  "CONFIRMABILITY": "the state of being confirmable [n]\n",
  "CONFIRMABLE": "that can be confirmed [adj]\n",
  "CONFIRMAND": "a candidate for religious confirmation [n -S]\n",
  "CONFIRMANDS": "CONFIRMAND, a candidate for religious confirmation [n]\n",
  "CONFIRMATION": "the act of confirming [n -S]\n",
  "CONFIRMATIONAL": "relating to confirmation [adj]\n",
  "CONFIRMATIONS": "CONFIRMATION, the act of confirming [n]\n",
  "CONFIRMATIVE": "tending to confirm [adj]\n",
  "CONFIRMATOR": "one who confirms [n -S]\n",
  "CONFIRMATORS": "CONFIRMATOR, one who confirms [n]\n",
  "CONFIRMATORY": "serving to confirm [adj]\n",
  "CONFIRMED": "CONFIRM, to assure the validity of [v]\n",
  "CONFIRMEDLY": "CONFIRMED, CONFIRM, to assure the validity of [adv]\n",
  "CONFIRMEDNESS": "the state of being confirmed [n -ES]\n",
  "CONFIRMEDNESSES": "CONFIRMEDNESS, the state of being confirmed [n]\n",
  "CONFIRMEE": "one to whom anything is confirmed [n -S]\n",
  "CONFIRMEES": "CONFIRMEE, one to whom anything is confirmed [n]\n",
  "CONFIRMER": "one who confirms, also CONFIRMOR [n -S]\n",
  "CONFIRMERS": "CONFIRMER, one who confirms, also CONFIRMOR [n]\n",
  "CONFIRMING": "the act of confirming [n -S]\n",
  "CONFIRMINGS": "CONFIRMING, the act of confirming [n]\n",
  "CONFIRMOR": "one who confirms, also CONFIRMER [n -S]\n",
  "CONFIRMORS": "CONFIRMOR, one who confirms, also CONFIRMER [n]\n",
  "CONFIRMS": "CONFIRM, to assure the validity of [v]\n",
  "CONFISCABLE": "capable of being confiscated, also CONFISCATABLE [adj]\n",
  "CONFISCATABLE": "capable of being confiscated, also CONFISCABLE [adj]\n",
  "CONFISCATE": "to seize as forfeited to the public treasury [v CONFISCATED, CONFISCATING, CONFISCATES]\n",
  "CONFISCATED": "CONFISCATE, to seize as forfeited to the public treasury [v]\n",
  "CONFISCATES": "CONFISCATE, to seize as forfeited to the public treasury [v]\n",
  "CONFISCATING": "CONFISCATE, to seize as forfeited to the public treasury [v]\n",
  "CONFISCATION": "the act of confiscating [n -S]\n",
  "CONFISCATIONS": "CONFISCATION, the act of confiscating [n]\n",
  "CONFISCATOR": "one who confiscates [n -S]\n",
  "CONFISCATORS": "CONFISCATOR, one who confiscates [n]\n",
  "CONFISCATORY": "serving to confiscate [adj]\n",
  "CONFISERIE": "(French) a confectionery [n -S]\n",
  "CONFISERIES": "CONFISERIE, (French) a confectionery [n]\n",
  "CONFISEUR": "(French) a confectioner [n -S]\n",
  "CONFISEURS": "CONFISEUR, (French) a confectioner [n]\n",
  "CONFIT": "a sweet; a sugarcoated seed or almond, also COMFIT [n -S]\n",
  "CONFITEOR": "(Latin) a prayer of confession of sins [n -S]\n",
  "CONFITEORS": "CONFITEOR, (Latin) a prayer of confession of sins [n]\n",
  "CONFITS": "CONFIT, a sweet; a sugarcoated seed or almond, also COMFIT [n]\n",
  "CONFITURE": "(obsolete) conserve, preserved fruit, also COMFITURE [n -S]\n",
  "CONFITURES": "CONFITURE, (obsolete) conserve, preserved fruit, also COMFITURE [n]\n",
  "CONFIX": "(Shakespeare) to fix firmly [v -ED, -ING, -ES]\n",
  "CONFIXED": "CONFIX, (Shakespeare) to fix firmly [v]\n",
  "CONFIXES": "CONFIX, (Shakespeare) to fix firmly [v]\n",
  "CONFIXING": "CONFIX, (Shakespeare) to fix firmly [v]\n",
  "CONFLAGRANT": "burning [adj]\n",
  "CONFLAGRATE": "to burn [v CONFLAGRATED, CONFLAGRATING, CONFLAGRATES]\n",
  "CONFLAGRATED": "CONFLAGRATE, to burn [v]\n",
  "CONFLAGRATES": "CONFLAGRATE, to burn [v]\n",
  "CONFLAGRATING": "CONFLAGRATE, to burn [v]\n",
  "CONFLAGRATION": "a large fire [n -S]\n",
  "CONFLAGRATIONS": "CONFLAGRATION, a large fire [n]\n",
  "CONFLAGRATIVE": "of or like a conflagration [adj]\n",
  "CONFLATE": "to combine (as two readings of a text) [v CONFLATED, CONFLATING, CONFLATES]\n",
  "CONFLATED": "CONFLATE, to combine (as two readings of a text) [v]\n",
  "CONFLATES": "CONFLATE, to combine (as two readings of a text) [v]\n",
  "CONFLATING": "CONFLATE, to combine (as two readings of a text) [v]\n",
  "CONFLATION": "a combining or blending of two or more versions of a text [n -S]\n",
  "CONFLATIONS": "CONFLATION, a combining or blending of two or more versions of a text [n]\n",
  "CONFLICT": "to be in opposition [v -ED, -ING, -S]\n",
  "CONFLICTED": "CONFLICT, to be in opposition [v]\n",
  "CONFLICTFUL": "full of conflict [adj]\n",
  "CONFLICTING": "CONFLICT, to be in opposition [v]\n",
  "CONFLICTINGLY": "CONFLICTING, CONFLICT, to be in opposition [adv]\n",
  "CONFLICTION": "conflict [n -S]\n",
  "CONFLICTIONS": "CONFLICTION, conflict [n]\n",
  "CONFLICTIVE": "tending to conflict [adj]\n",
  "CONFLICTORY": "relating to conflict [adj]\n",
  "CONFLICTS": "CONFLICT, to be in opposition [v]\n",
  "CONFLICTUAL": "having the nature of conflict [adj]\n",
  "CONFLUENCE": "a coming or flowing together [n -S]\n",
  "CONFLUENCES": "CONFLUENCE, a coming or flowing together [n]\n",
  "CONFLUENT": "flowing together; meeting in their course [adj CONFLUENTLY] / a stream uniting and flowing with another [n -S]\n",
  "CONFLUENTLY": "CONFLUENT, flowing together; meeting in their course [adv]\n",
  "CONFLUENTS": "CONFLUENT, a stream uniting and flowing with another [n]\n",
  "CONFLUX": "a flowing together of streams [n -ES]\n",
  "CONFLUXES": "CONFLUX, a flowing together of streams [n]\n",
  "CONFOCAL": "of a type of microscope, having the same focus [adj CONFOCALLY]\n",
  "CONFOCALLY": "CONFOCAL, of a type of microscope, having the same focus [adv]\n",
  "CONFORM": "to become the same or similar [v -ED, -ING, -S]\n",
  "CONFORMABILITY": "the quality of being conformable [n]\n",
  "CONFORMABLE": "compliant [adj CONFORMABLY]\n",
  "CONFORMABLENESS": "CONFORMABLE, compliant [n]\n",
  "CONFORMABLY": "CONFORMABLE, compliant [adv]\n",
  "CONFORMAL": "of a map, representing small areas in their true shape [adj]\n",
  "CONFORMANCE": "the act of conforming [n -S]\n",
  "CONFORMANCES": "CONFORMANCE, the act of conforming [n]\n",
  "CONFORMATION": "the manner in which a thing is formed; structure, organization [n -S]\n",
  "CONFORMATIONAL": "relating to conformation [adj]\n",
  "CONFORMATIONS": "CONFORMATION, the manner in which a thing is formed; structure, organization [n]\n",
  "CONFORMED": "CONFORM, to become the same or similar [v]\n",
  "CONFORMER": "one who conforms [n -S]\n",
  "CONFORMERS": "CONFORMER, one who conforms [n]\n",
  "CONFORMING": "CONFORM, to become the same or similar [v]\n",
  "CONFORMINGLY": "CONFORMING, CONFORM, to become the same or similar [adv]\n",
  "CONFORMISM": "compliance with established practice [n -S]\n",
  "CONFORMISMS": "CONFORMISM, compliance with established practice [n]\n",
  "CONFORMIST": "one who conforms [n -S]\n",
  "CONFORMISTS": "CONFORMIST, one who conforms [n]\n",
  "CONFORMITIES": "CONFORMITY, correspondence in form, manner, or character [n]\n",
  "CONFORMITY": "correspondence in form, manner, or character [n CONFORMITIES]\n",
  "CONFORMS": "CONFORM, to become the same or similar [v]\n",
  "CONFOUND": "to confuse, frustrate [v -ED, -ING, -S]\n",
  "CONFOUNDABLE": "capable of being confounded [adj]\n",
  "CONFOUNDED": "CONFOUND, to confuse, frustrate [v]\n",
  "CONFOUNDEDLY": "CONFOUNDED, CONFOUND, to confuse, frustrate [adv]\n",
  "CONFOUNDEDNESS": "the state of being confounded [n]\n",
  "CONFOUNDER": "one who confounds [n -S]\n",
  "CONFOUNDERS": "CONFOUNDER, one who confounds [n]\n",
  "CONFOUNDING": "CONFOUND, to confuse, frustrate [v]\n",
  "CONFOUNDINGLY": "CONFOUNDING, CONFOUND, to confuse, frustrate [adv]\n",
  "CONFOUNDS": "CONFOUND, to confuse, frustrate [v]\n",
  "CONFRATERNAL": "like a confraternity, a society devoted esp. to a religious or charitable cause [adj]\n",
  "CONFRATERNITIES": "CONFRATERNITY, a society devoted esp. to a religious or charitable cause [n]\n",
  "CONFRATERNITY": "a society devoted esp. to a religious or charitable cause [n CONFRATERNITIES]\n",
  "CONFRERE": "(French) a fellow member of a fraternity; an intimate associate [n -S]\n",
  "CONFRERES": "CONFRERE, (French) a fellow member of a fraternity; an intimate associate [n]\n",
  "CONFRERIE": "(French) a brotherhood [n -S]\n",
  "CONFRERIES": "CONFRERIE, (French) a brotherhood [n]\n",
  "CONFRONT": "to face defiantly [v -ED, -ING, -S]\n",
  "CONFRONTAL": "a confrontation [n -S]\n",
  "CONFRONTALS": "CONFRONTAL, a confrontation [n]\n",
  "CONFRONTATION": "the act of confronting [n -S]\n",
  "CONFRONTATIONAL": "relating to confrontation [adj]\n",
  "CONFRONTATIONS": "CONFRONTATION, the act of confronting [n]\n",
  "CONFRONTE": "in heraldry, face to face [adj]\n",
  "CONFRONTED": "CONFRONT, to face defiantly [v]\n",
  "CONFRONTER": "one who confronts [n -S]\n",
  "CONFRONTERS": "CONFRONTER, one who confronts [n]\n",
  "CONFRONTING": "CONFRONT, to face defiantly [v]\n",
  "CONFRONTMENT": "(archaic) confrontation [n -S]\n",
  "CONFRONTMENTS": "CONFRONTMENT, (archaic) confrontation [n]\n",
  "CONFRONTS": "CONFRONT, to face defiantly [v]\n",
  "CONFS": "CONF, an online conference [n]\n",
  "CONFUSABILITIES": "CONFUSABILITY, the quality of being confusable [n]\n",
  "CONFUSABILITY": "the quality of being confusable [n CONFUSABILITIES]\n",
  "CONFUSABLE": "liable to be confused [adj] / something liable to be confused, also CONFUSIBLE [n -S]\n",
  "CONFUSABLES": "CONFUSABLE, something liable to be confused, also CONFUSIBLE [n]\n",
  "CONFUSE": "to mix up mentally [v CONFUSED, CONFUSING, CONFUSES]\n",
  "CONFUSED": "CONFUSE, to mix up mentally [v]\n",
  "CONFUSEDLY": "CONFUSED, CONFUSE, to mix up mentally [adv]\n",
  "CONFUSEDNESS": "the state of being confused [n -ES]\n",
  "CONFUSEDNESSES": "CONFUSEDNESS, the state of being confused [n]\n",
  "CONFUSES": "CONFUSE, to mix up mentally [v]\n",
  "CONFUSIBLE": "something liable to be confused [n -S]\n",
  "CONFUSIBLES": "CONFUSIBLE, something liable to be confused [n]\n",
  "CONFUSING": "CONFUSE, to mix up mentally [v]\n",
  "CONFUSINGLY": "CONFUSING, CONFUSE, to mix up mentally [adv]\n",
  "CONFUSION": "the state of being confused [n -S]\n",
  "CONFUSIONAL": "relating to confusion [adj]\n",
  "CONFUSIONS": "CONFUSION, the state of being confused [n]\n",
  "CONFUTABLE": "that may be confuted [adj]\n",
  "CONFUTATION": "the act of confuting [n -S]\n",
  "CONFUTATIONS": "CONFUTATION, the act of confuting [n]\n",
  "CONFUTATIVE": "tending to confute [adj]\n",
  "CONFUTE": "to disprove or overcome through argument [v CONFUTED, CONFUTING, CONFUTES]\n",
  "CONFUTED": "CONFUTE, to disprove or overcome through argument [v]\n",
  "CONFUTEMENT": "the act of confuting [n -S]\n",
  "CONFUTEMENTS": "CONFUTEMENT, the act of confuting [n]\n",
  "CONFUTER": "one who confutes or disproves [n -S]\n",
  "CONFUTERS": "CONFUTER, one who confutes or disproves [n]\n",
  "CONFUTES": "CONFUTE, to disprove or overcome through argument [v]\n",
  "CONFUTING": "CONFUTE, to disprove or overcome through argument [v]\n",
  "CONGA": "(Spanish) a Latin American dance in which dancers are linked in a single file [n -S] / to dance the conga [v -ED, -ING, -S]\n",
  "CONGAED": "CONGA, to dance the conga [v]\n",
  "CONGAING": "CONGA, to dance the conga [v]\n",
  "CONGAS": "CONGA, to dance the conga [v]\n",
  "CONGE": "(French) to take leave [v CONGED, CONGEING, CONGES]\n",
  "CONGEAL": "to change from a fluid to a solid [v -ED, -ING, -S]\n",
  "CONGEALABLE": "that can be congealed [adj]\n",
  "CONGEALABLENESS": "CONGEALABLE, that can be congealed [n]\n",
  "CONGEALED": "CONGEAL, to change from a fluid to a solid [v]\n",
  "CONGEALER": "one who congeals [n -S]\n",
  "CONGEALERS": "CONGEALER, one who congeals [n]\n",
  "CONGEALING": "CONGEAL, to change from a fluid to a solid [v]\n",
  "CONGEALMENT": "the state of being congealed [n -S]\n",
  "CONGEALMENTS": "CONGEALMENT, the state of being congealed [n]\n",
  "CONGEALS": "CONGEAL, to change from a fluid to a solid [v]\n",
  "CONGED": "CONGE, (French) to take leave [v]\n",
  "CONGEE": "(Tamil) water in which rice has been boiled; rice or millet gruel [n -S] / to starch with congee, also CONJEE [v CONGEED, CONGEEING, CONGEES]\n",
  "CONGEED": "CONGEE, to starch with congee, also CONJEE [v]\n",
  "CONGEEING": "CONGEE, to starch with congee, also CONJEE [v]\n",
  "CONGEES": "CONGEE, to starch with congee, also CONJEE [v]\n",
  "CONGEING": "CONGE, (French) to take leave [v]\n",
  "CONGELATION": "the act of freezing something into a solid state [n -S]\n",
  "CONGELATIONS": "CONGELATION, the act of freezing something into a solid state [n]\n",
  "CONGENER": "something of the same kind or nature, also COGENER [n -S]\n",
  "CONGENERIC": "of the same genus, origin or nature, also CONGENERICAL, CONGENEROUS [adj] / something of the same genus [n -S]\n",
  "CONGENERICAL": "of the same genus, origin or nature, also CONGENERIC, CONGENEROUS [adj]\n",
  "CONGENERICS": "CONGENERIC, something of the same genus [n]\n",
  "CONGENEROUS": "of the same genus, origin or nature, also CONGENERIC, CONGENERICAL [adj]\n",
  "CONGENERS": "CONGENER, something of the same kind or nature, also COGENER [n]\n",
  "CONGENETIC": "having common origin [adj]\n",
  "CONGENIAL": "pleasant, friendly or agreeable [adj CONGENIALLY]\n",
  "CONGENIALITIES": "CONGENIALITY, the quality of being congenial [n]\n",
  "CONGENIALITY": "the quality of being congenial [n CONGENIALITIES]\n",
  "CONGENIALLY": "CONGENIAL, pleasant, friendly or agreeable [adv]\n",
  "CONGENIALNESS": "the state of being congenial [n -ES]\n",
  "CONGENIALNESSES": "CONGENIALNESS, the state of being congenial [n]\n",
  "CONGENIC": "of animal cells, bred to be genetically identical except for a single gene locus [adj]\n",
  "CONGENITAL": "existing at or dating from birth [adj CONGENITALLY]\n",
  "CONGENITALLY": "CONGENITAL, existing at or dating from birth [adv]\n",
  "CONGENITALNESS": "the state of being congenital [n]\n",
  "CONGER": "a kind of marine eel [n -S]\n",
  "CONGERIES": "a collection of miscellaneous things [n CONGERIES]\n",
  "CONGERS": "CONGER, a kind of marine eel [n]\n",
  "CONGES": "CONGE, (French) to take leave [v]\n",
  "CONGEST": "to fill to excess [v -ED, -ING, -S]\n",
  "CONGESTED": "CONGEST, to fill to excess [v]\n",
  "CONGESTIBLE": "able to be congested [adj]\n",
  "CONGESTING": "CONGEST, to fill to excess [v]\n",
  "CONGESTION": "the state of being congested [n -S]\n",
  "CONGESTIONS": "CONGESTION, the state of being congested [n]\n",
  "CONGESTIVE": "indicating congestion or tending to become congested [adj]\n",
  "CONGESTS": "CONGEST, to fill to excess [v]\n",
  "CONGIARIES": "CONGIARY, in Roman history, a quantity of oil, wine, etc., or money given for distribution as a gift among the people or the soldiers [n]\n",
  "CONGIARY": "in Roman history, a quantity of oil, wine, etc., or money given for distribution as a gift among the people or the soldiers [n CONGIARIES]\n",
  "CONGII": "CONGIUS, (Latin) an ancient unit of liquid measure [n]\n",
  "CONGIUS": "(Latin) an ancient unit of liquid measure [n CONGII]\n",
  "CONGLOBATE": "to gather in a globe [v CONGLOBATED, CONGLOBATING, CONGLOBATES]\n",
  "CONGLOBATED": "CONGLOBATE, to gather in a globe [v]\n",
  "CONGLOBATES": "CONGLOBATE, to gather in a globe [v]\n",
  "CONGLOBATING": "CONGLOBATE, to gather in a globe [v]\n",
  "CONGLOBATION": "the act of conglobating [n -S]\n",
  "CONGLOBATIONS": "CONGLOBATION, the act of conglobating [n]\n",
  "CONGLOBE": "to become a globule [v CONGLOBED, CONGLOBING, CONGLOBES]\n",
  "CONGLOBED": "CONGLOBE, to become a globule [v]\n",
  "CONGLOBES": "CONGLOBE, to become a globule [v]\n",
  "CONGLOBING": "CONGLOBE, to become a globule [v]\n",
  "CONGLOBULATE": "to form into a ball [v CONGLOBULATED, CONGLOBULATING, CONGLOBULATES]\n",
  "CONGLOBULATED": "CONGLOBULATE, to form into a ball [v]\n",
  "CONGLOBULATES": "CONGLOBULATE, to form into a ball [v]\n",
  "CONGLOBULATING": "CONGLOBULATE, to form into a ball [v]\n",
  "CONGLOBULATION": "the act of conglobulating, forming into a ball [n -S]\n",
  "CONGLOBULATIONS": "CONGLOBULATION, the act of conglobulating, forming into a ball [n]\n",
  "CONGLOMERATE": "to gather into a ball [v CONGLOMERATED, CONGLOMERATING, CONGLOMERATES]\n",
  "CONGLOMERATED": "CONGLOMERATE, to gather into a ball [v]\n",
  "CONGLOMERATES": "CONGLOMERATE, to gather into a ball [v]\n",
  "CONGLOMERATEUR": "a person who forms or heads a conglomerate [n -S]\n",
  "CONGLOMERATEURS": "CONGLOMERATEUR, a person who forms or heads a conglomerate [n]\n",
  "CONGLOMERATIC": "relating to conglomerate [adj]\n",
  "CONGLOMERATING": "CONGLOMERATE, to gather into a ball [v]\n",
  "CONGLOMERATION": "the act of conglomerating [n -S]\n",
  "CONGLOMERATIONS": "CONGLOMERATION, the act of conglomerating [n]\n",
  "CONGLOMERATIVE": "tending to conglomerate [adj]\n",
  "CONGLOMERATOR": "one who conglomerates [n -S]\n",
  "CONGLOMERATORS": "CONGLOMERATOR, one who conglomerates [n]\n",
  "CONGLUTINANT": "joining by means of a sticky substance [adj]\n",
  "CONGLUTINATE": "to glue or join together [v CONGLUTINATED, CONGLUTINATING, CONGLUTINATES]\n",
  "CONGLUTINATED": "CONGLUTINATE, to glue or join together [v]\n",
  "CONGLUTINATES": "CONGLUTINATE, to glue or join together [v]\n",
  "CONGLUTINATING": "CONGLUTINATE, to glue or join together [v]\n",
  "CONGLUTINATION": "the act of conglutinating [n -S]\n",
  "CONGLUTINATIONS": "CONGLUTINATION, the act of conglutinating [n]\n",
  "CONGLUTINATIVE": "having power to conglutinate [adj]\n",
  "CONGLUTINATOR": "an agent that conglutinates [n -S]\n",
  "CONGLUTINATORS": "CONGLUTINATOR, an agent that conglutinates [n]\n",
  "CONGO": "(Chinese) a kind of black Chinese tea, also CONGOU [n CONGOS or CONGOES]\n",
  "CONGOES": "CONGO, (Chinese) a kind of black Chinese tea, also CONGOU [n]\n",
  "CONGOS": "CONGO, (Chinese) a kind of black Chinese tea, also CONGOU [n]\n",
  "CONGOU": "(Chinese) a kind of black Chinese tea, also CONGO [n -S]\n",
  "CONGOUS": "CONGOU, (Chinese) a kind of black Chinese tea, also CONGO [n]\n",
  "CONGRATS": "(short for) congratulations [interj]\n",
  "CONGRATTERS": "(colloquial) congratulations [n]\n",
  "CONGRATULABLE": "worthy of congratulation [adj]\n",
  "CONGRATULANT": "a congratulator [n -S]\n",
  "CONGRATULANTS": "CONGRATULANT, a congratulator [n]\n",
  "CONGRATULATE": "to express pleasure in sympathy with [v CONGRATULATED, CONGRATULATING, CONGRATULATES]\n",
  "CONGRATULATED": "CONGRATULATE, to express pleasure in sympathy with [v]\n",
  "CONGRATULATES": "CONGRATULATE, to express pleasure in sympathy with [v]\n",
  "CONGRATULATING": "CONGRATULATE, to express pleasure in sympathy with [v]\n",
  "CONGRATULATION": "the act of congratulating [n -S]\n",
  "CONGRATULATIONS": "CONGRATULATION, the act of congratulating [n]\n",
  "CONGRATULATIVE": "expressing congratulation, also CONGRATULATORY [adj]\n",
  "CONGRATULATOR": "one who congratulates [n -S]\n",
  "CONGRATULATORS": "CONGRATULATOR, one who congratulates [n]\n",
  "CONGRATULATORY": "expressing congratulation, also CONGRATULATIVE [adj]\n",
  "CONGREE": "(archaic) to agree [v CONGREED, CONGREEING, CONGREES]\n",
  "CONGREED": "CONGREE, (archaic) to agree [v]\n",
  "CONGREEING": "CONGREE, (archaic) to agree [v]\n",
  "CONGREES": "CONGREE, (archaic) to agree [v]\n",
  "CONGREET": "(archaic) to salute mutually [v -ED, -ING, -S]\n",
  "CONGREETED": "CONGREET, (archaic) to salute mutually [v]\n",
  "CONGREETING": "CONGREET, (archaic) to salute mutually [v]\n",
  "CONGREETS": "CONGREET, (archaic) to salute mutually [v]\n",
  "CONGREGANT": "a member of a congregation, esp. a Jewish one [n -S]\n",
  "CONGREGANTS": "CONGREGANT, a member of a congregation, esp. a Jewish one [n]\n",
  "CONGREGATE": "to collect into a group or crowd [v CONGREGATED, CONGREGATING, CONGREGATES]\n",
  "CONGREGATED": "CONGREGATE, to collect into a group or crowd [v]\n",
  "CONGREGATES": "CONGREGATE, to collect into a group or crowd [v]\n",
  "CONGREGATING": "CONGREGATE, to collect into a group or crowd [v]\n",
  "CONGREGATION": "an organized body of believers in a particular locality [n -S]\n",
  "CONGREGATIONAL": "of or relating to a congregation [adj]\n",
  "CONGREGATIONS": "CONGREGATION, an organized body of believers in a particular locality [n]\n",
  "CONGREGATIVE": "collecting together [adj]\n",
  "CONGREGATOR": "one who congregates [n -S]\n",
  "CONGREGATORS": "CONGREGATOR, one who congregates [n]\n",
  "CONGRESS": "to assemble together [v -ED, -ING, -ES]\n",
  "CONGRESSED": "CONGRESS, to assemble together [v]\n",
  "CONGRESSES": "CONGRESS, to assemble together [v]\n",
  "CONGRESSING": "CONGRESS, to assemble together [v]\n",
  "CONGRESSIONAL": "relating to congress [adj CONGRESSIONALLY]\n",
  "CONGRESSIONALLY": "CONGRESSIONAL, relating to congress [adv]\n",
  "CONGRESSMAN": "a member of a congress [n CONGRESSMEN]\n",
  "CONGRESSMEN": "CONGRESSMAN, a member of a congress [n]\n",
  "CONGRESSPEOPLE": "congressmen or congresswomen [n]\n",
  "CONGRESSPERSON": "a congressman or congresswoman [n -S]\n",
  "CONGRESSPERSONS": "CONGRESSPERSON, a congressman or congresswoman [n]\n",
  "CONGRESSWOMAN": "a woman who is a member of a congress [n CONGRESSWOMEN]\n",
  "CONGRESSWOMEN": "CONGRESSWOMAN, a woman who is a member of a congress [n]\n",
  "CONGRUE": "(Shakespeare) to agree [v CONGRUED, CONGRUING, CONGRUES]\n",
  "CONGRUED": "CONGRUE, (Shakespeare) to agree [v]\n",
  "CONGRUENCE": "the state of being congruent, also CONGRUENCY [n -S]\n",
  "CONGRUENCES": "CONGRUENCE, the state of being congruent, also CONGRUENCY [n]\n",
  "CONGRUENCIES": "CONGRUENCY, the state of being congruent, also CONGRUENCE [n]\n",
  "CONGRUENCY": "the state of being congruent, also CONGRUENCE [n CONGRUENCIES]\n",
  "CONGRUENT": "suitable; agreeing or corresponding [adj CONGRUENTLY]\n",
  "CONGRUENTLY": "CONGRUENT, suitable; agreeing or corresponding [adv]\n",
  "CONGRUES": "CONGRUE, (Shakespeare) to agree [v]\n",
  "CONGRUING": "CONGRUE, (Shakespeare) to agree [v]\n",
  "CONGRUITIES": "CONGRUITY, agreement between things [n]\n",
  "CONGRUITY": "agreement between things [n CONGRUITIES]\n",
  "CONGRUOUS": "harmonious, concordant [adj CONGRUOUSLY]\n",
  "CONGRUOUSLY": "CONGRUOUS, harmonious, concordant [adv]\n",
  "CONGRUOUSNESS": "CONGRUOUS, harmonious, concordant [n]\n",
  "CONGRUOUSNESSES": "CONGRUOUSNESS, CONGRUOUS, harmonious, concordant [n]\n",
  "CONI": "CONUS, (Latin) a structure or organ resembling a cone [n]\n",
  "CONIA": "a liquid, highly poisonous alkaloid found in hemlock, also CONICINE, CONIINE, CONIN, CONINE [n -S]\n",
  "CONIAS": "CONIA, a liquid, highly poisonous alkaloid found in hemlock, also CONICINE, CONIINE, CONIN, CONINE [n]\n",
  "CONIC": "cone-shaped, conical [adj CONICALLY] / a conic section [n -S]\n",
  "CONICAL": "shaped like a cone [adj CONICALLY]\n",
  "CONICALLY": "CONICAL, shaped like a cone [adv]\n",
  "CONICINE": "a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONIINE, CONIN, CONINE [n -S]\n",
  "CONICINES": "CONICINE, a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONIINE, CONIN, CONINE [n]\n",
  "CONICITIES": "CONICITY, the state of being conical [n]\n",
  "CONICITY": "the state of being conical [n CONICITIES]\n",
  "CONICS": "CONIC, a conic section [n]\n",
  "CONIDIA": "CONIDIUM, (Greek) a kind of reproductive cell found in certain fungi, and often containing zoospores [n]\n",
  "CONIDIAL": "relating to a conidium, a kind of reproductive cell found in certain fungi, also CONIDIAN [adj]\n",
  "CONIDIAN": "relating to a conidium, a kind of reproductive cell found in certain fungi, also CONIDIAL [adj]\n",
  "CONIDIOPHORE": "a hypha that produces conidia [n -S]\n",
  "CONIDIOPHORES": "CONIDIOPHORE, a hypha that produces conidia [n]\n",
  "CONIDIOPHOROUS": "of or like a conidiophore, a hypha that produces conidia [adj]\n",
  "CONIDIOSPORE": "a conidium [n -S]\n",
  "CONIDIOSPORES": "CONIDIOSPORE, a conidium [n]\n",
  "CONIDIUM": "(Greek) a kind of reproductive cell found in certain fungi, and often containing zoospores [n CONIDIA]\n",
  "CONIES": "CONY, a rabbit, also CONEY [n]\n",
  "CONIFER": "any tree or shrub of the group Coniferae, including yews, pines, firs, etc., which typically bear cones [n -S]\n",
  "CONIFEROUS": "bearing cones [adj]\n",
  "CONIFERS": "CONIFER, any tree or shrub of the group Coniferae, including yews, pines, firs, etc., which typically bear cones [n]\n",
  "CONIFORM": "in the shape of a cone [adj]\n",
  "CONIINE": "a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONICINE, CONIN, CONINE [n -S]\n",
  "CONIINES": "CONIINE, a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONICINE, CONIN, CONINE [n]\n",
  "CONIMA": "(Caribbean) the fragrant resin of a tropical American tree [n -S]\n",
  "CONIMAS": "CONIMA, (Caribbean) the fragrant resin of a tropical American tree [n]\n",
  "CONIN": "a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONICINE, CONIINE, CONINE [n -S]\n",
  "CONINE": "a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONICINE, CONIINE, CONIN [n -S]\n",
  "CONINES": "CONINE, a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONICINE, CONIINE, CONIN [n]\n",
  "CONING": "CONE, to bear cones [v]\n",
  "CONINS": "CONIN, a liquid, highly poisonous alkaloid found in hemlock, also CONIA, CONICINE, CONIINE, CONINE [n]\n",
  "CONIOLOGIES": "CONIOLOGY, the study of atmospheric pollutants and dust, also KONIOLOGY [n]\n",
  "CONIOLOGY": "the study of atmospheric pollutants and dust, also KONIOLOGY [n CONIOLOGIES]\n",
  "CONIOSES": "CONIOSIS, an infection caused by dust [n]\n",
  "CONIOSIS": "an infection caused by dust [n CONIOSES]\n",
  "CONIROSTRAL": "having a strong conical beak, like e.g. most finches [adj]\n",
  "CONIUM": "(Latin) a genus of biennial, poisonous, white-flowered, umbelliferous plants, bearing ribbed fruit and decompound leaves [n -S]\n",
  "CONIUMS": "CONIUM, (Latin) a genus of biennial, poisonous, white-flowered, umbelliferous plants, bearing ribbed fruit and decompound leaves [n]\n",
  "CONJECT": "to conjecture [v -ED, -ING, -S]\n",
  "CONJECTED": "CONJECT, to conjecture [v]\n",
  "CONJECTING": "CONJECT, to conjecture [v]\n",
  "CONJECTS": "CONJECT, to conjecture [v]\n",
  "CONJECTURABLE": "susceptible to conjecture [adj CONJECTURABLY]\n",
  "CONJECTURABLY": "CONJECTURABLE, susceptible to conjecture [adv]\n",
  "CONJECTURAL": "of the nature of or involving or based on conjecture [adj CONJECTURALLY]\n",
  "CONJECTURALLY": "CONJECTURAL, of the nature of or involving or based on conjecture [adv]\n",
  "CONJECTURE": "to arrive at or deduce by conjecture [v CONJECTURED, CONJECTURING, CONJECTURES]\n",
  "CONJECTURED": "CONJECTURE, to arrive at or deduce by conjecture [v]\n",
  "CONJECTURER": "one who conjectures [n -S]\n",
  "CONJECTURERS": "CONJECTURER, one who conjectures [n]\n",
  "CONJECTURES": "CONJECTURE, to arrive at or deduce by conjecture [v]\n",
  "CONJECTURING": "CONJECTURE, to arrive at or deduce by conjecture [v]\n",
  "CONJEE": "(Tamil) water in which rice has been boiled; rice or millet gruel [n -S] / to starch with conjee, also CONGEE [v CONJEED, CONJEEING, CONJEES]\n",
  "CONJEED": "CONJEE, to starch with conjee, also CONGEE [v]\n",
  "CONJEEING": "CONJEE, to starch with conjee, also CONGEE [v]\n",
  "CONJEES": "CONJEE, to starch with conjee, also CONGEE [v]\n",
  "CONJOIN": "to join together [v -ED, -ING, -S]\n",
  "CONJOINED": "CONJOIN, to join together [v]\n",
  "CONJOINER": "one who conjoins [n -S]\n",
  "CONJOINERS": "CONJOINER, one who conjoins [n]\n",
  "CONJOINING": "CONJOIN, to join together [v]\n",
  "CONJOINS": "CONJOIN, to join together [v]\n",
  "CONJOINT": "united [adj CONJOINTLY]\n",
  "CONJOINTLY": "CONJOINT, united [adv]\n",
  "CONJUGABLE": "that can be conjugated [adj]\n",
  "CONJUGAL": "pertaining to marriage [adj CONJUGALLY]\n",
  "CONJUGALITIES": "CONJUGALITY, the state of being conjugal [n]\n",
  "CONJUGALITY": "the state of being conjugal [n CONJUGALITIES]\n",
  "CONJUGALLY": "CONJUGAL, pertaining to marriage [adv]\n",
  "CONJUGANT": "one of a pair of cells undergoing conjugation [n -S]\n",
  "CONJUGANTS": "CONJUGANT, one of a pair of cells undergoing conjugation [n]\n",
  "CONJUGATE": "joined, connected [adj CONJUGATELY] / to give the various inflections or parts of (a verb) [v CONJUGATED, CONJUGATING, CONJUGATES]\n",
  "CONJUGATED": "CONJUGATE, to give the various inflections or parts of (a verb) [v]\n",
  "CONJUGATELY": "CONJUGATE, joined, connected [adv]\n",
  "CONJUGATENESS": "CONJUGATE, joined, connected [n]\n",
  "CONJUGATENESSES": "CONJUGATENESS, CONJUGATE, joined, connected [n]\n",
  "CONJUGATES": "CONJUGATE, to give the various inflections or parts of (a verb) [v]\n",
  "CONJUGATING": "the act of conjugation [n -S]\n",
  "CONJUGATINGS": "CONJUGATING, the act of conjugation [n]\n",
  "CONJUGATION": "a schematic arrangement of the inflectional forms of a verb [n -S]\n",
  "CONJUGATIONAL": "conjugate [adj CONJUGATIONALLY]\n",
  "CONJUGATIONALLY": "CONJUGATIONAL, conjugate [adv]\n",
  "CONJUGATIONS": "CONJUGATION, a schematic arrangement of the inflectional forms of a verb [n]\n",
  "CONJUGATIVE": "conjugate [adj]\n",
  "CONJUGATOR": "one who conjugates [n -S]\n",
  "CONJUGATORS": "CONJUGATOR, one who conjugates [n]\n",
  "CONJUNCT": "joined together, united, also CONJOINT [adj CONJUNCTLY] / a joining, a union [n -S]\n",
  "CONJUNCTION": "the act or an instance of conjoining [n -S]\n",
  "CONJUNCTIONAL": "relating to conjunction [adj CONJUNCTIONALLY]\n",
  "CONJUNCTIONALLY": "CONJUNCTIONAL, relating to conjunction [adv]\n",
  "CONJUNCTIONS": "CONJUNCTION, the act or an instance of conjoining [n]\n",
  "CONJUNCTIVA": "(Latin) the membrane lining the eyelid and joining it with the eyeball [n CONJUNCTIVAE or CONJUNCTIVAS]\n",
  "CONJUNCTIVAE": "CONJUNCTIVA, (Latin) the membrane lining the eyelid and joining it with the eyeball [n]\n",
  "CONJUNCTIVAL": "relating to the conjunctiva, the membrane lining the eyelid and joining it with the eyeball [adj]\n",
  "CONJUNCTIVAS": "CONJUNCTIVA, (Latin) the membrane lining the eyelid and joining it with the eyeball [n]\n",
  "CONJUNCTIVE": "joining [adj CONJUNCTIVELY] / something serving to join, connect [n -S]\n",
  "CONJUNCTIVELY": "CONJUNCTIVE, joining [adv]\n",
  "CONJUNCTIVENESS": "the state of being conjunctive [n]\n",
  "CONJUNCTIVES": "CONJUNCTIVE, something serving to join, connect [n]\n",
  "CONJUNCTIVITIS": "inflammation of the conjunctiva [n]\n",
  "CONJUNCTLY": "CONJUNCT, joined together, united, also CONJOINT [adv]\n",
  "CONJUNCTS": "CONJUNCT, a joining, a union [n]\n",
  "CONJUNCTURAL": "relating to conjuncture [adj]\n",
  "CONJUNCTURE": "a juncture [n -S]\n",
  "CONJUNCTURES": "CONJUNCTURE, a juncture [n]\n",
  "CONJUNTO": "a style of dance music along the Mexican border [n -S]\n",
  "CONJUNTOS": "CONJUNTO, a style of dance music along the Mexican border [n]\n",
  "CONJURATION": "the act of conjuring [n -S]\n",
  "CONJURATIONS": "CONJURATION, the act of conjuring [n]\n",
  "CONJURATOR": "one who swears or is sworn with others [n -S]\n",
  "CONJURATORS": "CONJURATOR, one who swears or is sworn with others [n]\n",
  "CONJURE": "to practise magic tricks [v CONJURED, CONJURING, CONJURES]\n",
  "CONJURED": "CONJURE, to practise magic tricks [v]\n",
  "CONJUREMENT": "the act of conjuring [n -S]\n",
  "CONJUREMENTS": "CONJUREMENT, the act of conjuring [n]\n",
  "CONJURER": "a person who performs magic tricks, also CONJUROR [n -S]\n",
  "CONJURERS": "CONJURER, a person who performs magic tricks, also CONJUROR [n]\n",
  "CONJURES": "CONJURE, to practise magic tricks [v]\n",
  "CONJURIES": "CONJURY, conjurors' tricks, magic [n]\n",
  "CONJURING": "the act of conjuring [n -S]\n",
  "CONJURINGS": "CONJURING, the act of conjuring [n]\n",
  "CONJUROR": "a person who performs magic tricks, also CONJURER [n -S]\n",
  "CONJURORS": "CONJUROR, a person who performs magic tricks, also CONJURER [n]\n",
  "CONJURY": "conjurors' tricks, magic [n CONJURIES]\n",
  "CONK": "to hit on the head, also KONK [v -ED, -ING, -S]\n",
  "CONKED": "CONK, to hit on the head, also KONK [v]\n",
  "CONKER": "a horse-chestnut used in a British game [n -S]\n",
  "CONKERS": "CONKER, a horse-chestnut used in a British game [n]\n",
  "CONKIER": "CONKY, full of a tree fungus [adj]\n",
  "CONKIEST": "CONKY, full of a tree fungus [adj]\n",
  "CONKING": "CONK, to hit on the head, also KONK [v]\n",
  "CONKOUT": "(US) a situation where a car, machine, computer etc. ceases to work [n -S]\n",
  "CONKOUTS": "CONKOUT, (US) a situation where a car, machine, computer etc. ceases to work [n]\n",
  "CONKS": "CONK, to hit on the head, also KONK [v]\n",
  "CONKY": "full of a tree fungus [adj CONKIER, CONKIEST]\n",
  "CONLANG": "an invented language [n -S]\n",
  "CONLANGER": "a person who creates an artificial language [n -S]\n",
  "CONLANGERS": "CONLANGER, a person who creates an artificial language [n]\n",
  "CONLANGS": "CONLANG, an invented language [n]\n",
  "CONMAN": "a (male) confidence trickster [n CONMEN]\n",
  "CONMEN": "CONMAN, a (male) confidence trickster [n]\n",
  "CONN": "to direct the steering of a ship [v -ED, -ING, -S]\n",
  "CONNASCENCE": "the state of being connascent, also CONNASCENCY [n -S]\n",
  "CONNASCENCES": "CONNASCENCE, the state of being connascent, also CONNASCENCY [n]\n",
  "CONNASCENCIES": "CONNASCENCY, the state of being connascent, also CONNASCENCE [n]\n",
  "CONNASCENCY": "the state of being connascent, also CONNASCENCE [n CONNASCENCIES]\n",
  "CONNASCENT": "born together; produced at the same time [adj]\n",
  "CONNATE": "congenitally or firmly united [adj CONNATELY]\n",
  "CONNATELY": "CONNATE, congenitally or firmly united [adv]\n",
  "CONNATENESS": "the state of being connate [n -ES]\n",
  "CONNATENESSES": "CONNATENESS, the state of being connate [n]\n",
  "CONNATION": "union, esp. of similar parts or organs [n -S]\n",
  "CONNATIONS": "CONNATION, union, esp. of similar parts or organs [n]\n",
  "CONNATURAL": "connected by nature; inborn [adj CONNATURALLY]\n",
  "CONNATURALISE": "to make of the same nature, also CONNATURALIZE [v CONNATURALISED, CONNATURALISING, CONNATURALISES]\n",
  "CONNATURALISED": "CONNATURALISE, to make of the same nature, also CONNATURALIZE [v]\n",
  "CONNATURALISES": "CONNATURALISE, to make of the same nature, also CONNATURALIZE [v]\n",
  "CONNATURALISING": "CONNATURALISE, to make of the same nature, also CONNATURALIZE [v]\n",
  "CONNATURALITIES": "CONNATURALITY, the state of being connatural [n]\n",
  "CONNATURALITY": "the state of being connatural [n CONNATURALITIES]\n",
  "CONNATURALIZE": "to make of the same nature, also CONNATURALISE [v CONNATURALIZED, CONNATURALIZING, CONNATURALIZES]\n",
  "CONNATURALIZED": "CONNATURALIZE, to make of the same nature, also CONNATURALISE [v]\n",
  "CONNATURALIZES": "CONNATURALIZE, to make of the same nature, also CONNATURALISE [v]\n",
  "CONNATURALIZING": "CONNATURALIZE, to make of the same nature, also CONNATURALISE [v]\n",
  "CONNATURALLY": "CONNATURAL, connected by nature; inborn [adv]\n",
  "CONNATURALNESS": "the state of being connatural [n]\n",
  "CONNATURE": "participation in a common nature or character [n -S]\n",
  "CONNATURES": "CONNATURE, participation in a common nature or character [n]\n",
  "CONNE": "(Spenser) to know, also CON, KON [v COND, CONNING, CONNES]\n",
  "CONNECT": "to join together [v -ED, -ING, -S]\n",
  "CONNECTABLE": "that can be connected, also CONNECTIBLE [adj]\n",
  "CONNECTED": "CONNECT, to join together [v]\n",
  "CONNECTEDLY": "CONNECTED, CONNECT, to join together [adv]\n",
  "CONNECTEDNESS": "the state of being connected [n -ES]\n",
  "CONNECTEDNESSES": "CONNECTEDNESS, the state of being connected [n]\n",
  "CONNECTER": "something that connects, also CONNECTOR [n -S]\n",
  "CONNECTERS": "CONNECTER, something that connects, also CONNECTOR [n]\n",
  "CONNECTIBLE": "that can be connected, also CONNECTABLE [adj]\n",
  "CONNECTING": "CONNECT, to join together [v]\n",
  "CONNECTION": "the act of connecting, also CONNEXION [n -S]\n",
  "CONNECTIONAL": "relating to connection [adj]\n",
  "CONNECTIONISM": "the theory that connections between neurons govern behaviour and thought [n -S]\n",
  "CONNECTIONISMS": "CONNECTIONISM, the theory that connections between neurons govern behaviour and thought [n]\n",
  "CONNECTIONS": "CONNECTION, the act of connecting, also CONNEXION [n]\n",
  "CONNECTIVE": "serving to connect, also CONNEXIVE [adj CONNECTIVELY] / something that connects [n -S]\n",
  "CONNECTIVELY": "CONNECTIVE, serving to connect, also CONNEXIVE [adv]\n",
  "CONNECTIVES": "CONNECTIVE, something that connects [n]\n",
  "CONNECTIVITIES": "CONNECTIVITY, the quality of being connective or connected [n]\n",
  "CONNECTIVITY": "the quality of being connective or connected [n CONNECTIVITIES]\n",
  "CONNECTOR": "something that connects, also CONNECTER [n -S]\n",
  "CONNECTORS": "CONNECTOR, something that connects, also CONNECTER [n]\n",
  "CONNECTS": "CONNECT, to join together [v]\n",
  "CONNED": "CONNE, (Spenser) to know, also CON, KON [v]\n",
  "CONNER": "a kind of wrasse, aka goldsinny, also CONNOR, CUNNER [n -S]\n",
  "CONNERS": "CONNER, a kind of wrasse, aka goldsinny, also CONNOR, CUNNER [n]\n",
  "CONNES": "CONNE, (Spenser) to know, also CON, KON [v]\n",
  "CONNEXION": "the act of connecting, also CONNECTION [n -S]\n",
  "CONNEXIONAL": "relating to connexion [adj]\n",
  "CONNEXIONS": "CONNEXION, the act of connecting, also CONNECTION [n]\n",
  "CONNEXIVE": "(obsolete) connective, also CONNECTIVE [adj]\n",
  "CONNIE": "a tram or bus conductor [n -S]\n",
  "CONNIES": "CONNIE, a tram or bus conductor [n]\n",
  "CONNING": "the act of directing, steering [n -S]\n",
  "CONNINGS": "CONNING, the act of directing, steering [n]\n",
  "CONNIPTION": "(US slang) a fit of rage or hysteria; a tantrum [n -S]\n",
  "CONNIPTIONS": "CONNIPTION, (US slang) a fit of rage or hysteria; a tantrum [n]\n",
  "CONNIVANCE": "the act of conniving, also CONNIVANCY [n -S]\n",
  "CONNIVANCES": "CONNIVANCE, the act of conniving, also CONNIVANCY [n]\n",
  "CONNIVANCIES": "CONNIVANCY, the act of conniving, also CONNIVANCE [n]\n",
  "CONNIVANCY": "the act of conniving, also CONNIVANCE [n CONNIVANCIES]\n",
  "CONNIVE": "to plot or conspire [v CONNIVED, CONNIVING, CONNIVES]\n",
  "CONNIVED": "CONNIVE, to plot or conspire [v]\n",
  "CONNIVENCE": "the state of being connivent, also CONNIVENCY [n -S]\n",
  "CONNIVENCES": "CONNIVENCE, the state of being connivent, also CONNIVENCY [n]\n",
  "CONNIVENCIES": "CONNIVENCY, the state of being connivent, also CONNIVENCE [n]\n",
  "CONNIVENCY": "the state of being connivent, also CONNIVENCE [n CONNIVENCIES]\n",
  "CONNIVENT": "of insect or plant parts, converging and touching, but not united or fused [adj CONNIVENTLY]\n",
  "CONNIVENTLY": "CONNIVENT, of insect or plant parts, converging and touching, but not united or fused [adv]\n",
  "CONNIVER": "one who connives [n -S]\n",
  "CONNIVERIES": "CONNIVERY, an act of conniving [n]\n",
  "CONNIVERS": "CONNIVER, one who connives [n]\n",
  "CONNIVERY": "an act of conniving [n CONNIVERIES]\n",
  "CONNIVES": "CONNIVE, to plot or conspire [v]\n",
  "CONNIVING": "the act of feigning ignorance of wrongdoing [n -S]\n",
  "CONNIVINGLY": "CONNIVING [adv]\n",
  "CONNIVINGS": "CONNIVING, the act of feigning ignorance of wrongdoing [n]\n",
  "CONNOISSEUR": "(French) one who appreciates fine things e.g. wines, the arts [n -S]\n",
  "CONNOISSEURS": "CONNOISSEUR, (French) one who appreciates fine things e.g. wines, the arts [n]\n",
  "CONNOISSEURSHIP": "the state of being a connoisseur [n]\n",
  "CONNOR": "a kind of wrasse, aka goldsinny, also CONNER, CUNNER [n -S]\n",
  "CONNORS": "CONNOR, a kind of wrasse, aka goldsinny, also CONNER, CUNNER [n]\n",
  "CONNOTATE": "to connote; to suggest or designate (something) as additional [v CONNOTATED, CONNOTATING, CONNOTATES]\n",
  "CONNOTATED": "CONNOTATE, to connote; to suggest or designate (something) as additional [v]\n",
  "CONNOTATES": "CONNOTATE, to connote; to suggest or designate (something) as additional [v]\n",
  "CONNOTATING": "CONNOTATE, to connote; to suggest or designate (something) as additional [v]\n",
  "CONNOTATION": "the act of connoting [n -S]\n",
  "CONNOTATIONAL": "relating to connotation [adj]\n",
  "CONNOTATIONS": "CONNOTATION, the act of connoting [n]\n",
  "CONNOTATIVE": "signifying or suggesting ideas, also CONNOTIVE [adj CONNOTATIVELY]\n",
  "CONNOTATIVELY": "CONNOTATIVE, signifying or suggesting ideas, also CONNOTIVE [adv]\n",
  "CONNOTE": "to imply another meaning other than the literal one [v CONNOTED, CONNOTING, CONNOTES]\n",
  "CONNOTED": "CONNOTE, to imply another meaning other than the literal one [v]\n",
  "CONNOTES": "CONNOTE, to imply another meaning other than the literal one [v]\n",
  "CONNOTING": "CONNOTE, to imply another meaning other than the literal one [v]\n",
  "CONNOTIVE": "signifying or suggesting ideas, also CONNOTATIVE [adj CONNOTIVELY]\n",
  "CONNOTIVELY": "CONNOTIVE, signifying or suggesting ideas, also CONNOTATIVE [adv]\n",
  "CONNS": "CONN, to direct the steering of a ship [v]\n",
  "CONNUBIAL": "of or relating to marriage [adj CONNUBIALLY]\n",
  "CONNUBIALISM": "the state of being connubial [n -S]\n",
  "CONNUBIALISMS": "CONNUBIALISM, the state of being connubial [n]\n",
  "CONNUBIALITIES": "CONNUBIALITY, the state of being connubial [n]\n",
  "CONNUBIALITY": "the state of being connubial [n CONNUBIALITIES]\n",
  "CONNUBIALLY": "CONNUBIAL, of or relating to marriage [adv]\n",
  "CONNUMERATE": "to count together [v CONNUMERATED, CONNUMERATING, CONNUMERATES]\n",
  "CONNUMERATED": "CONNUMERATE, to count together [v]\n",
  "CONNUMERATES": "CONNUMERATE, to count together [v]\n",
  "CONNUMERATING": "CONNUMERATE, to count together [v]\n",
  "CONNUMERATION": "the act of connumerating [n -S]\n",
  "CONNUMERATIONS": "CONNUMERATION, the act of connumerating [n]\n",
  "CONODONT": "any of various Palaeozoic toothlike fossils [n -S]\n",
  "CONODONTS": "CONODONT, any of various Palaeozoic toothlike fossils [n]\n",
  "CONOID": "anything like a cone in form [n -S]\n",
  "CONOIDAL": "nearly, but not exactly, conical, also CONOIDIC, CONOIDICAL [adj CONOIDALLY]\n",
  "CONOIDALLY": "CONOIDAL, nearly, but not exactly, conical, also CONOIDIC, CONOIDICAL [adv]\n",
  "CONOIDIC": "nearly, but not exactly, conical, also CONOIDAL, CONOIDICAL [adj]\n",
  "CONOIDICAL": "nearly, but not exactly, conical, also CONOIDAL, CONOIDIC [adj]\n",
  "CONOIDS": "CONOID, anything like a cone in form [n]\n",
  "CONOMINEE": "one nominated in conjunction with another; a joint nominee [n -S]\n",
  "CONOMINEES": "CONOMINEE, one nominated in conjunction with another; a joint nominee [n]\n",
  "CONOSCENTE": "(Italian) a person who has expert knowledge in a subject, a connoisseur, also COGNOSCENTE [n CONOSCENTI]\n",
  "CONOSCENTI": "CONOSCENTE, (Italian) a person who has expert knowledge in a subject, a connoisseur, also COGNOSCENTE [n]\n",
  "CONQUER": "to overcome by force [v -ED, -ING, -S]\n",
  "CONQUERABILITY": "the capacity for being conquered [n]\n",
  "CONQUERABLE": "that can be conquered [adj]\n",
  "CONQUERABLENESS": "CONQUERABLE, that can be conquered [n]\n",
  "CONQUERED": "CONQUER, to overcome by force [v]\n",
  "CONQUERER": "one who conquers, also CONQUEROR [n -S]\n",
  "CONQUERERS": "CONQUERER, one who conquers, also CONQUEROR [n]\n",
  "CONQUERESS": "a woman who conquers [n -ES]\n",
  "CONQUERESSES": "CONQUERESS, a woman who conquers [n]\n",
  "CONQUERING": "CONQUER, to overcome by force [v]\n",
  "CONQUERINGLY": "CONQUERING, CONQUER, to overcome by force [adv]\n",
  "CONQUEROR": "one who conquers, also CONQUERER [n -S]\n",
  "CONQUERORS": "CONQUEROR, one who conquers, also CONQUERER [n]\n",
  "CONQUERS": "CONQUER, to overcome by force [v]\n",
  "CONQUEST": "the act of conquering [n -S]\n",
  "CONQUESTS": "CONQUEST, the act of conquering [n]\n",
  "CONQUIAN": "a card game resembling rummy, also COONCAN [n -S]\n",
  "CONQUIANS": "CONQUIAN, a card game resembling rummy, also COONCAN [n]\n",
  "CONQUISTADOR": "(Spanish) a conqueror; specifically any of the Spanish conquerors of Mexico and Peru in the 16th cent [n CONQUISTADORS or CONQUISTADORES]\n",
  "CONQUISTADORES": "CONQUISTADOR, (Spanish) a conqueror; specifically any of the Spanish conquerors of Mexico and Peru in the 16th cent [n]\n",
  "CONQUISTADORS": "CONQUISTADOR, (Spanish) a conqueror; specifically any of the Spanish conquerors of Mexico and Peru in the 16th cent [n]\n",
  "CONS": "CON, to study carefully [v]\n",
  "CONSANGUINE": "of the same blood or origin; specifically, descended from the same ancestor, also CONSANGUINEOUS [adj]\n",
  "CONSANGUINEOUS": "of the same blood or origin; specifically, descended from the same ancestor, also CONSANGUINE [adj]\n",
  "CONSANGUINITIES": "CONSANGUINITY, relationship by blood [n]\n",
  "CONSANGUINITY": "relationship by blood [n CONSANGUINITIES]\n",
  "CONSCIENCE": "the sense of moral correctness that governs or influences a person's actions or thoughts [n -S]\n",
  "CONSCIENCELESS": "without a conscience [adj]\n",
  "CONSCIENCES": "CONSCIENCE, the sense of moral correctness that governs or influences a person's actions or thoughts [n]\n",
  "CONSCIENT": "conscious [adj]\n",
  "CONSCIENTIOUS": "governed by or conforming to the dictates of conscience [adj CONSCIENTIOUSLY]\n",
  "CONSCIENTIOUSLY": "CONSCIENTIOUS, governed by or conforming to the dictates of conscience [adv]\n",
  "CONSCIENTISE": "to make (someone) aware of political and social rights, also CONSCIENTIZE [v CONSCIENTISED, CONSCIENTISING, CONSCIENTISES]\n",
  "CONSCIENTISED": "CONSCIENTISE, to make (someone) aware of political and social rights, also CONSCIENTIZE [v]\n",
  "CONSCIENTISES": "CONSCIENTISE, to make (someone) aware of political and social rights, also CONSCIENTIZE [v]\n",
  "CONSCIENTISING": "CONSCIENTISE, to make (someone) aware of political and social rights, also CONSCIENTIZE [v]\n",
  "CONSCIENTIZE": "to make (someone) aware of political and social rights, also CONSCIENTISE [v CONSCIENTIZED, CONSCIENTIZING, CONSCIENTIZES]\n",
  "CONSCIENTIZED": "CONSCIENTIZE, to make (someone) aware of political and social rights, also CONSCIENTISE [v]\n",
  "CONSCIENTIZES": "CONSCIENTIZE, to make (someone) aware of political and social rights, also CONSCIENTISE [v]\n",
  "CONSCIENTIZING": "CONSCIENTIZE, to make (someone) aware of political and social rights, also CONSCIENTISE [v]\n",
  "CONSCIONABILITY": "the state of being conscionable [n]\n",
  "CONSCIONABLE": "(obsolete) governed by conscience [adj CONSCIONABLY]\n",
  "CONSCIONABLY": "CONSCIONABLE, (obsolete) governed by conscience [adv]\n",
  "CONSCIOUS": "having the feeling or knowledge of something [adj CONSCIOUSLY] / the conscious mind [n -ES]\n",
  "CONSCIOUSES": "CONSCIOUS, the conscious mind [n]\n",
  "CONSCIOUSLY": "CONSCIOUS, having the feeling or knowledge of something [adv]\n",
  "CONSCIOUSNESS": "the state of being conscious [n -ES]\n",
  "CONSCIOUSNESSES": "CONSCIOUSNESS, the state of being conscious [n]\n",
  "CONSCRIBE": "to enroll; to enlist [v CONSCRIBED, CONSCRIBING, CONSCRIBES]\n",
  "CONSCRIBED": "CONSCRIBE, to enroll; to enlist [v]\n",
  "CONSCRIBES": "CONSCRIBE, to enroll; to enlist [v]\n",
  "CONSCRIBING": "CONSCRIBE, to enroll; to enlist [v]\n",
  "CONSCRIPT": "someone enrolled and liable to serve compulsorily [n -S] / to enlist compulsorily [v -ED, -ING, -S]\n",
  "CONSCRIPTED": "CONSCRIPT, to enlist compulsorily [v]\n",
  "CONSCRIPTING": "CONSCRIPT, to enlist compulsorily [v]\n",
  "CONSCRIPTION": "compulsory enrollment of persons esp. for military service [n -S]\n",
  "CONSCRIPTIONAL": "relating to conscription [adj]\n",
  "CONSCRIPTIONIST": "one who believes in conscription [n]\n",
  "CONSCRIPTIONS": "CONSCRIPTION, compulsory enrollment of persons esp. for military service [n]\n",
  "CONSCRIPTS": "CONSCRIPT, to enlist compulsorily [v]\n",
  "CONSECRATE": "to induct (a person) into a permanent office with a religious rite [v CONSECRATED, CONSECRATING, CONSECRATES]\n",
  "CONSECRATED": "CONSECRATE, to induct (a person) into a permanent office with a religious rite [v]\n",
  "CONSECRATEDNESS": "the state of being consecrated [n]\n",
  "CONSECRATES": "CONSECRATE, to induct (a person) into a permanent office with a religious rite [v]\n",
  "CONSECRATING": "CONSECRATE, to induct (a person) into a permanent office with a religious rite [v]\n",
  "CONSECRATION": "the act or ceremony of consecrating [n -S]\n",
  "CONSECRATIONS": "CONSECRATION, the act or ceremony of consecrating [n]\n",
  "CONSECRATIVE": "serving to consecrate, also CONSECRATORY [adj]\n",
  "CONSECRATOR": "one who consecrates [n -S]\n",
  "CONSECRATORS": "CONSECRATOR, one who consecrates [n]\n",
  "CONSECRATORY": "serving to consecrate, also CONSECRATIVE [adj]\n",
  "CONSECTANEOUS": "following by logical consequence [adj]\n",
  "CONSECTARIES": "CONSECTARY, (archaic) a deduction; conclusion or corollary [n]\n",
  "CONSECTARY": "(archaic) a deduction; conclusion or corollary [n CONSECTARIES]\n",
  "CONSECUTION": "the logical sequence or progression of an argument [n -S]\n",
  "CONSECUTIONS": "CONSECUTION, the logical sequence or progression of an argument [n]\n",
  "CONSECUTIVE": "following one after the other in order [adj CONSECUTIVELY]\n",
  "CONSECUTIVELY": "CONSECUTIVE, following one after the other in order [adv]\n",
  "CONSECUTIVENESS": "the state of being consecutive [n]\n",
  "CONSEIL": "(French) advice, council [n -S]\n",
  "CONSEILS": "CONSEIL, (French) advice, council [n]\n",
  "CONSENESCENCE": "a state of general decay, also CONSENESCENCY [n -S]\n",
  "CONSENESCENCES": "CONSENESCENCE, a state of general decay, also CONSENESCENCY [n]\n",
  "CONSENESCENCIES": "CONSENESCENCY, a state of general decay, also CONSENESCENCE [n]\n",
  "CONSENESCENCY": "a state of general decay, also CONSENESCENCE [n CONSENESCENCIES]\n",
  "CONSENSION": "agreement; accord [n -S]\n",
  "CONSENSIONS": "CONSENSION, agreement; accord [n]\n",
  "CONSENSUAL": "relating to consent [adj CONSENSUALLY]\n",
  "CONSENSUALLY": "CONSENSUAL, relating to consent [adv]\n",
  "CONSENSUS": "(Latin) agreement [n -ES]\n",
  "CONSENSUSES": "CONSENSUS, (Latin) agreement [n]\n",
  "CONSENT": "to give approval [v -ED, -ING, -S]\n",
  "CONSENTANEITIES": "CONSENTANEITY, the quality of being consentaneous, agreeable [n]\n",
  "CONSENTANEITY": "the quality of being consentaneous, agreeable [n CONSENTANEITIES]\n",
  "CONSENTANEOUS": "accordant or agreeable; consistent [adj CONSENTANEOUSLY]\n",
  "CONSENTANEOUSLY": "CONSENTANEOUS, accordant or agreeable; consistent [adv]\n",
  "CONSENTED": "CONSENT, to give approval [v]\n",
  "CONSENTER": "one who consents [n -S]\n",
  "CONSENTERS": "CONSENTER, one who consents [n]\n",
  "CONSENTIENCE": "agreement [n -S]\n",
  "CONSENTIENCES": "CONSENTIENCE, agreement [n]\n",
  "CONSENTIENT": "unanimous; of one accord [adj]\n",
  "CONSENTING": "CONSENT, to give approval [v]\n",
  "CONSENTINGLY": "CONSENTING, CONSENT, to give approval [adv]\n",
  "CONSENTS": "CONSENT, to give approval [v]\n",
  "CONSEQUENCE": "a conclusion derived through logic [n -S] / (archaic) to draw a consequence from [v CONSEQUENCED, CONSEQUENCING, CONSEQUENCES]\n",
  "CONSEQUENCED": "CONSEQUENCE, (archaic) to draw a consequence from [v]\n",
  "CONSEQUENCES": "CONSEQUENCE, (archaic) to draw a consequence from [v]\n",
  "CONSEQUENCING": "CONSEQUENCE, (archaic) to draw a consequence from [v]\n",
  "CONSEQUENT": "following [adj CONSEQUENTLY] / the natural effect of a cause [n -S]\n",
  "CONSEQUENTIAL": "of the nature of a secondary result [adj CONSEQUENTIALLY]\n",
  "CONSEQUENTIALLY": "CONSEQUENTIAL, of the nature of a secondary result [adv]\n",
  "CONSEQUENTLY": "CONSEQUENT, following [adv]\n",
  "CONSEQUENTS": "CONSEQUENT, the natural effect of a cause [n]\n",
  "CONSERVABLE": "that can be conserved [adj]\n",
  "CONSERVANCIES": "CONSERVANCY, a board regulating fisheries and navigation in a river or port [n]\n",
  "CONSERVANCY": "a board regulating fisheries and navigation in a river or port [n CONSERVANCIES]\n",
  "CONSERVANT": "having the power of conservation [adj]\n",
  "CONSERVATION": "a careful preservation and protection of something [n -S]\n",
  "CONSERVATIONAL": "relating to conservation [adj]\n",
  "CONSERVATIONIST": "a person who advocates conservation esp. of natural resources [n]\n",
  "CONSERVATIONS": "CONSERVATION, a careful preservation and protection of something [n]\n",
  "CONSERVATISE": "to grow conservative, also CONSERVATIZE [v CONSERVATISED, CONSERVATISING, CONSERVATISES]\n",
  "CONSERVATISED": "CONSERVATISE, to grow conservative, also CONSERVATIZE [v]\n",
  "CONSERVATISES": "CONSERVATISE, to grow conservative, also CONSERVATIZE [v]\n",
  "CONSERVATISING": "CONSERVATISE, to grow conservative, also CONSERVATIZE [v]\n",
  "CONSERVATISM": "the principles and policies of a Conservative party [n -S]\n",
  "CONSERVATISMS": "CONSERVATISM, the principles and policies of a Conservative party [n]\n",
  "CONSERVATIVE": "tending to conserve [adj CONSERVATIVELY] / an adherent or advocate of political conservatism [n -S]\n",
  "CONSERVATIVELY": "CONSERVATIVE, tending to conserve [adv]\n",
  "CONSERVATIVES": "CONSERVATIVE, an adherent or advocate of political conservatism [n]\n",
  "CONSERVATIZE": "to grow conservative, also CONSERVATISE [v CONSERVATIZED, CONSERVATIZING, CONSERVATIZES]\n",
  "CONSERVATIZED": "CONSERVATIZE, to grow conservative, also CONSERVATISE [v]\n",
  "CONSERVATIZES": "CONSERVATIZE, to grow conservative, also CONSERVATISE [v]\n",
  "CONSERVATIZING": "CONSERVATIZE, to grow conservative, also CONSERVATISE [v]\n",
  "CONSERVATOIRE": "(French) a public place of instruction in any special branch, esp. music and the arts [n -S]\n",
  "CONSERVATOIRES": "CONSERVATOIRE, (French) a public place of instruction in any special branch, esp. music and the arts [n]\n",
  "CONSERVATOR": "one that preserves from injury or violation [n -S]\n",
  "CONSERVATORIA": "CONSERVATORIUM, (Latin) a school of music, also CONSERVATOIRE [n]\n",
  "CONSERVATORIAL": "of or like a conservator [adj]\n",
  "CONSERVATORIES": "CONSERVATORY, a greenhouse for growing or displaying plants [n]\n",
  "CONSERVATORIUM": "(Latin) a school of music, also CONSERVATOIRE [n CONSERVATORIA or CONSERVATORIUMS]\n",
  "CONSERVATORIUMS": "CONSERVATORIUM, (Latin) a school of music, also CONSERVATOIRE [n]\n",
  "CONSERVATORS": "CONSERVATOR, one that preserves from injury or violation [n]\n",
  "CONSERVATORSHIP": "the office of conservator [n]\n",
  "CONSERVATORY": "a greenhouse for growing or displaying plants [n CONSERVATORIES]\n",
  "CONSERVATRICES": "CONSERVATRIX, a female conservator [n]\n",
  "CONSERVATRIX": "a female conservator [n CONSERVATRICES or CONSERVATRIXES]\n",
  "CONSERVATRIXES": "CONSERVATRIX, a female conservator [n]\n",
  "CONSERVE": "to keep, preserve [v CONSERVED, CONSERVING, CONSERVES]\n",
  "CONSERVED": "CONSERVE, to keep, preserve [v]\n",
  "CONSERVER": "one who conserves [n -S]\n",
  "CONSERVERS": "CONSERVER, one who conserves [n]\n",
  "CONSERVES": "CONSERVE, to keep, preserve [v]\n",
  "CONSERVING": "CONSERVE, to keep, preserve [v]\n",
  "CONSIDER": "to think about [v -ED, -ING, -S]\n",
  "CONSIDERABLE": "to a high degree [adj CONSIDERABLY] / something worth considering [n -S]\n",
  "CONSIDERABLES": "CONSIDERABLE, something worth considering [n]\n",
  "CONSIDERABLY": "CONSIDERABLE, to a high degree [adv]\n",
  "CONSIDERANCE": "(archaic) consideration [n -S]\n",
  "CONSIDERANCES": "CONSIDERANCE, (archaic) consideration [n]\n",
  "CONSIDERATE": "marked by or given to careful consideration [adj CONSIDERATELY]\n",
  "CONSIDERATELY": "CONSIDERATE, marked by or given to careful consideration [adv]\n",
  "CONSIDERATENESS": "CONSIDERATE, marked by or given to careful consideration [n]\n",
  "CONSIDERATION": "continuous and careful thought [n -S]\n",
  "CONSIDERATIONS": "CONSIDERATION, continuous and careful thought [n]\n",
  "CONSIDERATIVE": "thoughtful; prudent; considerate [adj CONSIDERATIVELY]\n",
  "CONSIDERATIVELY": "CONSIDERATIVE, thoughtful; prudent; considerate [adv]\n",
  "CONSIDERED": "CONSIDER, to think about [v]\n",
  "CONSIDERER": "one who considers [n -S]\n",
  "CONSIDERERS": "CONSIDERER, one who considers [n]\n",
  "CONSIDERING": "CONSIDER, to think about [v]\n",
  "CONSIDERINGLY": "with consideration [adv]\n",
  "CONSIDERS": "CONSIDER, to think about [v]\n",
  "CONSIGLIERE": "in Italy, a member of a council; a member of a Mafia family who serves as an adviser or aide to the leader or to other members [n CONSIGLIERI or CONSIGLIERES]\n",
  "CONSIGLIERES": "CONSIGLIERE, in Italy, a member of a council; a member of a Mafia family who serves as an adviser or aide to the leader or to other members [n]\n",
  "CONSIGLIERI": "CONSIGLIERE, in Italy, a member of a council; a member of a Mafia family who serves as an adviser or aide to the leader or to other members [n]\n",
  "CONSIGN": "to give over to another's care [v -ED, -ING, -S]\n",
  "CONSIGNABLE": "that can be consigned [adj]\n",
  "CONSIGNATION": "the act of consigning [n -S]\n",
  "CONSIGNATIONS": "CONSIGNATION, the act of consigning [n]\n",
  "CONSIGNATORIES": "CONSIGNATORY, a cosignatory, also COSIGNATORY [n]\n",
  "CONSIGNATORY": "a cosignatory, also COSIGNATORY [n CONSIGNATORIES]\n",
  "CONSIGNED": "CONSIGN, to give over to another's care [v]\n",
  "CONSIGNEE": "the person to whom cargo is consigned as stated on the bills of lading [n -S]\n",
  "CONSIGNEES": "CONSIGNEE, the person to whom cargo is consigned as stated on the bills of lading [n]\n",
  "CONSIGNER": "the person named in the bill of lading as the one from whom the goods have been received for shipment, also CONSIGNOR [n -S]\n",
  "CONSIGNERS": "CONSIGNER, the person named in the bill of lading as the one from whom the goods have been received for shipment, also CONSIGNOR [n]\n",
  "CONSIGNIFIED": "CONSIGNIFY, to signify or denote in combination with something else [v]\n",
  "CONSIGNIFIES": "CONSIGNIFY, to signify or denote in combination with something else [v]\n",
  "CONSIGNIFY": "to signify or denote in combination with something else [v CONSIGNIFIED, CONSIGNIFYING, CONSIGNIFIES]\n",
  "CONSIGNIFYING": "CONSIGNIFY, to signify or denote in combination with something else [v]\n",
  "CONSIGNING": "CONSIGN, to give over to another's care [v]\n",
  "CONSIGNMENT": "the act of consigning [n -S]\n",
  "CONSIGNMENTS": "CONSIGNMENT, the act of consigning [n]\n",
  "CONSIGNOR": "the person named in the bill of lading as the one from whom the goods have been received for shipment, also CONSIGNER [n -S]\n",
  "CONSIGNORS": "CONSIGNOR, the person named in the bill of lading as the one from whom the goods have been received for shipment, also CONSIGNER [n]\n",
  "CONSIGNS": "CONSIGN, to give over to another's care [v]\n",
  "CONSILIENCE": "concurrence, coincidence [n -S]\n",
  "CONSILIENCES": "CONSILIENCE, concurrence, coincidence [n]\n",
  "CONSILIENT": "agreeing [adj]\n",
  "CONSIMILAR": "like each other [adj]\n",
  "CONSIMILARITIES": "CONSIMILARITY, the quality of being consimilar [n]\n",
  "CONSIMILARITY": "the quality of being consimilar [n CONSIMILARITIES]\n",
  "CONSIMILITIES": "CONSIMILITY, the state of being consimilar [n]\n",
  "CONSIMILITUDE": "likeness [n -S]\n",
  "CONSIMILITUDES": "CONSIMILITUDE, likeness [n]\n",
  "CONSIMILITY": "the state of being consimilar [n CONSIMILITIES]\n",
  "CONSIST": "to be composed of [v -ED, -ING, -S]\n",
  "CONSISTED": "CONSIST, to be composed of [v]\n",
  "CONSISTENCE": "firmness of constitution or character, also CONSISTENCY [n -S]\n",
  "CONSISTENCES": "CONSISTENCE, firmness of constitution or character, also CONSISTENCY [n]\n",
  "CONSISTENCIES": "CONSISTENCY, firmness of constitution or character, also CONSISTENCE [n]\n",
  "CONSISTENCY": "firmness of constitution or character, also CONSISTENCE [n CONSISTENCIES]\n",
  "CONSISTENT": "marked by harmony, regularity, or steady continuity [adj CONSISTENTLY]\n",
  "CONSISTENTLY": "CONSISTENT, marked by harmony, regularity, or steady continuity [adv]\n",
  "CONSISTING": "CONSIST, to be composed of [v]\n",
  "CONSISTORIAL": "relating to a consistory, a solemn assembly or council, also CONSISTORIAN [adj]\n",
  "CONSISTORIAN": "relating to a consistory, a solemn assembly or council, also CONSISTORIAL [adj]\n",
  "CONSISTORIES": "CONSISTORY, a solemn assembly or council; a church tribunal [n]\n",
  "CONSISTORY": "a solemn assembly or council; a church tribunal [n CONSISTORIES]\n",
  "CONSISTS": "CONSIST, to be composed of [v]\n",
  "CONSOCIATE": "to ally or associate [v CONSOCIATED, CONSOCIATING, CONSOCIATES]\n",
  "CONSOCIATED": "CONSOCIATE, to ally or associate [v]\n",
  "CONSOCIATES": "CONSOCIATE, to ally or associate [v]\n",
  "CONSOCIATING": "CONSOCIATE, to ally or associate [v]\n",
  "CONSOCIATION": "association in fellowship or alliance [n -S]\n",
  "CONSOCIATIONAL": "relating to consociation, association in fellowship or alliance [adj]\n",
  "CONSOCIATIONS": "CONSOCIATION, association in fellowship or alliance [n]\n",
  "CONSOCIES": "a community in nature with a single dominant species [n CONSOCIES]\n",
  "CONSOL": "a government bond [n -S]\n",
  "CONSOLABLE": "capable of receiving consolation [adj]\n",
  "CONSOLATE": "(Shakespeare) to console [v CONSOLATED, CONSOLATING, CONSOLATES]\n",
  "CONSOLATED": "CONSOLATE, (Shakespeare) to console [v]\n",
  "CONSOLATES": "CONSOLATE, (Shakespeare) to console [v]\n",
  "CONSOLATING": "CONSOLATE, (Shakespeare) to console [v]\n",
  "CONSOLATION": "the act or an instance of consoling [n -S]\n",
  "CONSOLATIONS": "CONSOLATION, the act or an instance of consoling [n]\n",
  "CONSOLATORIES": "CONSOLATORY, (Milton) a message of comfort [n]\n",
  "CONSOLATORY": "comforting [adj] / (Milton) a message of comfort [n CONSOLATORIES]\n",
  "CONSOLATRICES": "CONSOLATRIX, a woman who consoles [n]\n",
  "CONSOLATRIX": "a woman who consoles [n CONSOLATRICES or CONSOLATRIXES]\n",
  "CONSOLATRIXES": "CONSOLATRIX, a woman who consoles [n]\n",
  "CONSOLE": "to comfort [v CONSOLED, CONSOLING, CONSOLES]\n",
  "CONSOLED": "CONSOLE, to comfort [v]\n",
  "CONSOLEMENT": "the act of consoling [n -S]\n",
  "CONSOLEMENTS": "CONSOLEMENT, the act of consoling [n]\n",
  "CONSOLER": "one who gives consolation [n -S]\n",
  "CONSOLERS": "CONSOLER, one who gives consolation [n]\n",
  "CONSOLES": "CONSOLE, to comfort [v]\n",
  "CONSOLIDATE": "to join together into one whole [v CONSOLIDATED, CONSOLIDATING, CONSOLIDATES]\n",
  "CONSOLIDATED": "CONSOLIDATE, to join together into one whole [v]\n",
  "CONSOLIDATES": "CONSOLIDATE, to join together into one whole [v]\n",
  "CONSOLIDATING": "CONSOLIDATE, to join together into one whole [v]\n",
  "CONSOLIDATION": "the act of consolidating [n -S]\n",
  "CONSOLIDATIONS": "CONSOLIDATION, the act of consolidating [n]\n",
  "CONSOLIDATIVE": "serving to consolidate [adj]\n",
  "CONSOLIDATOR": "one who consolidates [n -S]\n",
  "CONSOLIDATORS": "CONSOLIDATOR, one who consolidates [n]\n",
  "CONSOLING": "CONSOLE, to comfort [v]\n",
  "CONSOLINGLY": "CONSOLING, CONSOLE, to comfort [adv]\n",
  "CONSOLS": "CONSOL, a government bond [n]\n",
  "CONSOLUTE": "completely miscible [adj]\n",
  "CONSOMME": "(French) a clear soup or bouillon boiled down so as to be very rich [n -S]\n",
  "CONSOMMES": "CONSOMME, (French) a clear soup or bouillon boiled down so as to be very rich [n]\n",
  "CONSONANCE": "a state of accord or agreement, also CONSONANCY [n -S]\n",
  "CONSONANCES": "CONSONANCE, a state of accord or agreement, also CONSONANCY [n]\n",
  "CONSONANCIES": "CONSONANCY, a state of accord or agreement, also CONSONANCE [n]\n",
  "CONSONANCY": "a state of accord or agreement, also CONSONANCE [n CONSONANCIES]\n",
  "CONSONANT": "consistent with [adj CONSONANTLY] / any speech sound other than a vowel [n -S]\n",
  "CONSONANTAL": "relating to, being, or marked by a consonant or group of consonants [adj CONSONANTALLY]\n",
  "CONSONANTALLY": "CONSONANTAL, relating to, being, or marked by a consonant or group of consonants [adv]\n",
  "CONSONANTLY": "CONSONANT, consistent with [adv]\n",
  "CONSONANTS": "CONSONANT, any speech sound other than a vowel [n]\n",
  "CONSONOUS": "harmonious [adj]\n",
  "CONSORT": "to keep company [v -ED, -ING, -S]\n",
  "CONSORTABLE": "able to be consorted with [adj]\n",
  "CONSORTED": "CONSORT, to keep company [v]\n",
  "CONSORTER": "one who consorts [n -S]\n",
  "CONSORTERS": "CONSORTER, one who consorts [n]\n",
  "CONSORTIA": "CONSORTIUM, (Latin) an association of organizations or States formed for commercial or financial purposes [n]\n",
  "CONSORTIAL": "relating to a consortium [adj]\n",
  "CONSORTING": "CONSORT, to keep company [v]\n",
  "CONSORTISM": "symbiosis [n -S]\n",
  "CONSORTISMS": "CONSORTISM, symbiosis [n]\n",
  "CONSORTIUM": "(Latin) an association of organizations or States formed for commercial or financial purposes [n CONSORTIA or CONSORTIUMS]\n",
  "CONSORTIUMS": "CONSORTIUM, (Latin) an association of organizations or States formed for commercial or financial purposes [n]\n",
  "CONSORTS": "CONSORT, to keep company [v]\n",
  "CONSPECIFIC": "a plant or animal of the same species [n -S]\n",
  "CONSPECIFICS": "CONSPECIFIC, a plant or animal of the same species [n]\n",
  "CONSPECTUITIES": "CONSPECTUITY, (Shakespeare) sight [n]\n",
  "CONSPECTUITY": "(Shakespeare) sight [n CONSPECTUITIES]\n",
  "CONSPECTUS": "a general survey, synopsis, outline, or digest of something [n -ES]\n",
  "CONSPECTUSES": "CONSPECTUS, a general survey, synopsis, outline, or digest of something [n]\n",
  "CONSPICUITIES": "CONSPICUITY, the state of being conspicuous [n]\n",
  "CONSPICUITY": "the state of being conspicuous [n CONSPICUITIES]\n",
  "CONSPICUOUS": "obvious to the eye or mind [adj CONSPICUOUSLY]\n",
  "CONSPICUOUSLY": "CONSPICUOUS, obvious to the eye or mind [adv]\n",
  "CONSPICUOUSNESS": "CONSPICUOUS, obvious to the eye or mind [n]\n",
  "CONSPIRACIES": "CONSPIRACY, the act of conspiring together [n]\n",
  "CONSPIRACY": "the act of conspiring together [n CONSPIRACIES]\n",
  "CONSPIRANT": "a conspirator [n -S]\n",
  "CONSPIRANTS": "CONSPIRANT, a conspirator [n]\n",
  "CONSPIRATION": "the act or action of plotting or secretly combining [n -S]\n",
  "CONSPIRATIONAL": "relating to conspiration [adj]\n",
  "CONSPIRATIONS": "CONSPIRATION, the act or action of plotting or secretly combining [n]\n",
  "CONSPIRATOR": "one who conspires [n -S]\n",
  "CONSPIRATORIAL": "relating to conspiracy, also CONSPIRATORY [adj]\n",
  "CONSPIRATORS": "CONSPIRATOR, one who conspires [n]\n",
  "CONSPIRATORY": "relating to conspiracy, also CONSPIRATORIAL [adj]\n",
  "CONSPIRATRESS": "a female conspirator [n -ES]\n",
  "CONSPIRATRESSES": "CONSPIRATRESS, a female conspirator [n]\n",
  "CONSPIRE": "to plot together [v CONSPIRED, CONSPIRING, CONSPIRES]\n",
  "CONSPIRED": "CONSPIRE, to plot together [v]\n",
  "CONSPIRER": "one who conspires [n -S]\n",
  "CONSPIRERS": "CONSPIRER, one who conspires [n]\n",
  "CONSPIRES": "CONSPIRE, to plot together [v]\n",
  "CONSPIRING": "CONSPIRE, to plot together [v]\n",
  "CONSPIRINGLY": "CONSPIRING, CONSPIRE, to plot together [adv]\n",
  "CONSPUE": "to spit upon, to despise [v CONSPUED, CONSPUING, CONSPUES]\n",
  "CONSPUED": "CONSPUE, to spit upon, to despise [v]\n",
  "CONSPUES": "CONSPUE, to spit upon, to despise [v]\n",
  "CONSPUING": "CONSPUE, to spit upon, to despise [v]\n",
  "CONSPURCATION": "(obsolete) defilement [n -S]\n",
  "CONSPURCATIONS": "CONSPURCATION, (obsolete) defilement [n]\n",
  "CONSTABLE": "a policeman or policewoman of the lowest rank [n -S]\n",
  "CONSTABLES": "CONSTABLE, a policeman or policewoman of the lowest rank [n]\n",
  "CONSTABLESHIP": "the office of constable [n -S]\n",
  "CONSTABLESHIPS": "CONSTABLESHIP, the office of constable [n]\n",
  "CONSTABLEWICK": "(historical) the district of a constable [n -S]\n",
  "CONSTABLEWICKS": "CONSTABLEWICK, (historical) the district of a constable [n]\n",
  "CONSTABULARIES": "CONSTABULARY, the organized body of constables of a particular district or country [n]\n",
  "CONSTABULARY": "the organized body of constables of a particular district or country [n CONSTABULARIES]\n",
  "CONSTANCIES": "CONSTANCY, the state of being constant [n]\n",
  "CONSTANCY": "the state of being constant [n CONSTANCIES]\n",
  "CONSTANT": "not varying [adj CONSTANTLY] / something that does not vary [n -S]\n",
  "CONSTANTAN": "an alloy of nickel and copper, having a high and constant resistance to flow of electricity or heat [n -S]\n",
  "CONSTANTANS": "CONSTANTAN, an alloy of nickel and copper, having a high and constant resistance to flow of electricity or heat [n]\n",
  "CONSTANTLY": "CONSTANT, not varying [adv]\n",
  "CONSTANTS": "CONSTANT, something that does not vary [n]\n",
  "CONSTATATION": "a statement, assertion [n -S]\n",
  "CONSTATATIONS": "CONSTATATION, a statement, assertion [n]\n",
  "CONSTATE": "to assert [v CONSTATED, CONSTATING, CONSTATES]\n",
  "CONSTATED": "CONSTATE, to assert [v]\n",
  "CONSTATES": "CONSTATE, to assert [v]\n",
  "CONSTATING": "CONSTATE, to assert [v]\n",
  "CONSTATIVE": "that can be true or false [adj] / a statement that can be true or false [n -S]\n",
  "CONSTATIVES": "CONSTATIVE, a statement that can be true or false [n]\n",
  "CONSTELLATE": "to cluster; to compel by stellar influence [v CONSTELLATED, CONSTELLATING, CONSTELLATES]\n",
  "CONSTELLATED": "CONSTELLATE, to cluster; to compel by stellar influence [v]\n",
  "CONSTELLATES": "CONSTELLATE, to cluster; to compel by stellar influence [v]\n",
  "CONSTELLATING": "CONSTELLATE, to cluster; to compel by stellar influence [v]\n",
  "CONSTELLATION": "the configuration of stars esp. at one's birth [n -S]\n",
  "CONSTELLATIONAL": "of or like a constellation [adj]\n",
  "CONSTELLATIONS": "CONSTELLATION, the configuration of stars esp. at one's birth [n]\n",
  "CONSTELLATORY": "of or like a constellation [adj]\n",
  "CONSTER": "(archaic) to construe [v -ED, -ING, -S]\n",
  "CONSTERED": "CONSTER, (archaic) to construe [v]\n",
  "CONSTERING": "CONSTER, (archaic) to construe [v]\n",
  "CONSTERNATE": "to fill with consternation [v CONSTERNATED, CONSTERNATING, CONSTERNATES]\n",
  "CONSTERNATED": "CONSTERNATE, to fill with consternation [v]\n",
  "CONSTERNATES": "CONSTERNATE, to fill with consternation [v]\n",
  "CONSTERNATING": "CONSTERNATE, to fill with consternation [v]\n",
  "CONSTERNATION": "amazement or dismay that hinders or throws into confusion [n -S]\n",
  "CONSTERNATIONS": "CONSTERNATION, amazement or dismay that hinders or throws into confusion [n]\n",
  "CONSTERS": "CONSTER, (archaic) to construe [v]\n",
  "CONSTIPATE": "to cause constipation in [v CONSTIPATED, CONSTIPATING, CONSTIPATES]\n",
  "CONSTIPATED": "CONSTIPATE, to cause constipation in [v]\n",
  "CONSTIPATES": "CONSTIPATE, to cause constipation in [v]\n",
  "CONSTIPATING": "CONSTIPATE, to cause constipation in [v]\n",
  "CONSTIPATION": "abnormally delayed or infrequent passage of usually dry hardened feces [n -S]\n",
  "CONSTIPATIONS": "CONSTIPATION, abnormally delayed or infrequent passage of usually dry hardened feces [n]\n",
  "CONSTITUENCIES": "CONSTITUENCY, a body of citizens entitled to elect a representative (as to a legislative or executive position) [n]\n",
  "CONSTITUENCY": "a body of citizens entitled to elect a representative (as to a legislative or executive position) [n CONSTITUENCIES]\n",
  "CONSTITUENT": "forming part of [adj CONSTITUENTLY] / an inhabitant of the constituency of a member of parliament [n -S]\n",
  "CONSTITUENTLY": "CONSTITUENT, forming part of [adv]\n",
  "CONSTITUENTS": "CONSTITUENT, an inhabitant of the constituency of a member of parliament [n]\n",
  "CONSTITUTE": "to form [v CONSTITUTED, CONSTITUTING, CONSTITUTES]\n",
  "CONSTITUTED": "CONSTITUTE, to form [v]\n",
  "CONSTITUTER": "one who constitutes [n -S]\n",
  "CONSTITUTERS": "CONSTITUTER, one who constitutes [n]\n",
  "CONSTITUTES": "CONSTITUTE, to form [v]\n",
  "CONSTITUTING": "CONSTITUTE, to form [v]\n",
  "CONSTITUTION": "an established law or custom [n -S]\n",
  "CONSTITUTIONAL": "a walk taken for one's health [n -S]\n",
  "CONSTITUTIONALS": "CONSTITUTIONAL, a walk taken for one's health [n]\n",
  "CONSTITUTIONIST": "a believer in the Constitution [n]\n",
  "CONSTITUTIONS": "CONSTITUTION, an established law or custom [n]\n",
  "CONSTITUTIVE": "having the power to enact or establish [adj CONSTITUTIVELY]\n",
  "CONSTITUTIVELY": "CONSTITUTIVE, having the power to enact or establish [adv]\n",
  "CONSTITUTOR": "someone or something that constitutes; a person who makes a constitution [n -S]\n",
  "CONSTITUTORS": "CONSTITUTOR, someone or something that constitutes; a person who makes a constitution [n]\n",
  "CONSTRAIN": "to force, compel [v -ED, -ING, -S]\n",
  "CONSTRAINABLE": "able to be constrained [adj]\n",
  "CONSTRAINED": "CONSTRAIN, to force, compel [v]\n",
  "CONSTRAINEDLY": "CONSTRAINED, CONSTRAIN, to force, compel [adv]\n",
  "CONSTRAINER": "something or someone that constrains [n -S]\n",
  "CONSTRAINERS": "CONSTRAINER, something or someone that constrains [n]\n",
  "CONSTRAINING": "CONSTRAIN, to force, compel [v]\n",
  "CONSTRAINS": "CONSTRAIN, to force, compel [v]\n",
  "CONSTRAINT": "the act of constraining [n -S]\n",
  "CONSTRAINTS": "CONSTRAINT, the act of constraining [n]\n",
  "CONSTRICT": "to draw together; to render narrower or smaller [v -ED, -ING, -S]\n",
  "CONSTRICTED": "CONSTRICT, to draw together; to render narrower or smaller [v]\n",
  "CONSTRICTING": "CONSTRICT, to draw together; to render narrower or smaller [v]\n",
  "CONSTRICTION": "an act or product of constricting [n -S]\n",
  "CONSTRICTIONS": "CONSTRICTION, an act or product of constricting [n]\n",
  "CONSTRICTIVE": "serving to constrict [adj CONSTRICTIVELY]\n",
  "CONSTRICTIVELY": "CONSTRICTIVE, serving to constrict [adv]\n",
  "CONSTRICTOR": "a muscle that contracts a cavity or orifice or compresses an organ [n -S]\n",
  "CONSTRICTORS": "CONSTRICTOR, a muscle that contracts a cavity or orifice or compresses an organ [n]\n",
  "CONSTRICTS": "CONSTRICT, to draw together; to render narrower or smaller [v]\n",
  "CONSTRINGE": "to draw together; to cause to contract or shrink [v CONSTRINGED, CONSTRINGING, CONSTRINGES]\n",
  "CONSTRINGED": "CONSTRINGE, to draw together; to cause to contract or shrink [v]\n",
  "CONSTRINGENCE": "the inverse of the dispersive power of a medium, also CONSTRINGENCY [n -S]\n",
  "CONSTRINGENCES": "CONSTRINGENCE, the inverse of the dispersive power of a medium, also CONSTRINGENCY [n]\n",
  "CONSTRINGENCIES": "CONSTRINGENCY, the inverse of the dispersive power of a medium, also CONSTRINGENCE [n]\n",
  "CONSTRINGENCY": "the inverse of the dispersive power of a medium, also CONSTRINGENCE [n CONSTRINGENCIES]\n",
  "CONSTRINGENT": "tending to constringe [adj]\n",
  "CONSTRINGES": "CONSTRINGE, to draw together; to cause to contract or shrink [v]\n",
  "CONSTRINGING": "CONSTRINGE, to draw together; to cause to contract or shrink [v]\n",
  "CONSTRUABILITY": "the quality of being construable [n]\n",
  "CONSTRUABLE": "that can be construed [adj]\n",
  "CONSTRUAL": "an act of construing [n -S]\n",
  "CONSTRUALS": "CONSTRUAL, an act of construing [n]\n",
  "CONSTRUCT": "to build [v -ED, -ING, -S]\n",
  "CONSTRUCTABLE": "capable of being constructed, also CONSTRUCTIBLE [adj]\n",
  "CONSTRUCTED": "CONSTRUCT, to build [v]\n",
  "CONSTRUCTER": "one who constructs, also CONSTRUCTOR [n -S]\n",
  "CONSTRUCTERS": "CONSTRUCTER, one who constructs, also CONSTRUCTOR [n]\n",
  "CONSTRUCTIBLE": "capable of being constructed, also CONSTRUCTABLE [adj]\n",
  "CONSTRUCTING": "CONSTRUCT, to build [v]\n",
  "CONSTRUCTION": "the act of constructing [n -S]\n",
  "CONSTRUCTIONAL": "relating to construction [adj]\n",
  "CONSTRUCTIONISM": "the interpretation of law in a particular way [n]\n",
  "CONSTRUCTIONIST": "one who construes a legal document (as the United States Constitution) in a specific way [n]\n",
  "CONSTRUCTIONS": "CONSTRUCTION, the act of constructing [n]\n",
  "CONSTRUCTIVE": "serving to construct [adj CONSTRUCTIVELY]\n",
  "CONSTRUCTIVELY": "CONSTRUCTIVE, serving to construct [adv]\n",
  "CONSTRUCTIVISM": "a nonobjective art movement originating in Russia and concerned with formal organization of planes and expression of volume in terms of modern industrial materials such as glass and plastic [n -S]\n",
  "CONSTRUCTIVISMS": "CONSTRUCTIVISM, a nonobjective art movement originating in Russia and concerned with formal organization of planes and expression of volume in terms of modern industrial materials such as glass and plastic [n]\n",
  "CONSTRUCTIVIST": "an upholder of constructivism [n -S]\n",
  "CONSTRUCTIVISTS": "CONSTRUCTIVIST, an upholder of constructivism [n]\n",
  "CONSTRUCTOR": "one who constructs, also CONSTRUCTER [n -S]\n",
  "CONSTRUCTORS": "CONSTRUCTOR, one who constructs, also CONSTRUCTER [n]\n",
  "CONSTRUCTS": "CONSTRUCT, to build [v]\n",
  "CONSTRUCTURE": "a construction [n -S]\n",
  "CONSTRUCTURES": "CONSTRUCTURE, a construction [n]\n",
  "CONSTRUE": "to analyse the grammatical construction of (a sentence) [v CONSTRUED, CONSTRUING, CONSTRUES]\n",
  "CONSTRUED": "CONSTRUE, to analyse the grammatical construction of (a sentence) [v]\n",
  "CONSTRUER": "one who construes [n -S]\n",
  "CONSTRUERS": "CONSTRUER, one who construes [n]\n",
  "CONSTRUES": "CONSTRUE, to analyse the grammatical construction of (a sentence) [v]\n",
  "CONSTRUING": "CONSTRUE, to analyse the grammatical construction of (a sentence) [v]\n",
  "CONSTUPRATE": "(obsolete) to ravish [v CONSTUPRATED, CONSTUPRATING, CONSTUPRATES]\n",
  "CONSTUPRATED": "CONSTUPRATE, (obsolete) to ravish [v]\n",
  "CONSTUPRATES": "CONSTUPRATE, (obsolete) to ravish [v]\n",
  "CONSTUPRATING": "CONSTUPRATE, (obsolete) to ravish [v]\n",
  "CONSTUPRATION": "the act of constuprating, ravishing [n -S]\n",
  "CONSTUPRATIONS": "CONSTUPRATION, the act of constuprating, ravishing [n]\n",
  "CONSUBSIST": "to subsist together [v -ED, -ING, -S]\n",
  "CONSUBSISTED": "CONSUBSIST, to subsist together [v]\n",
  "CONSUBSISTING": "CONSUBSIST, to subsist together [v]\n",
  "CONSUBSISTS": "CONSUBSIST, to subsist together [v]\n",
  "CONSUBSTANTIAL": "of the same substance [adj]\n",
  "CONSUBSTANTIATE": "to unite in one common substance or nature, esp. bread and wine and the body of Christ [v]\n",
  "CONSUETUDE": "custom; familiarity [n -S]\n",
  "CONSUETUDES": "CONSUETUDE, custom; familiarity [n]\n",
  "CONSUETUDINARY": "customary [adj]\n",
  "CONSUL": "(Latin) either of two annually elected magistrates who jointly exercised supreme authority in the Roman Republic [n -S]\n",
  "CONSULAGE": "(historical) a duty or tax paid by merchants for the protection of their commerce by means of a consul in a foreign place [n -S]\n",
  "CONSULAGES": "CONSULAGE, (historical) a duty or tax paid by merchants for the protection of their commerce by means of a consul in a foreign place [n]\n",
  "CONSULAR": "a person holding the rank of consul [n -S]\n",
  "CONSULARS": "CONSULAR, a person holding the rank of consul [n]\n",
  "CONSULATE": "the post or establishment of a (modern) consul [n -S]\n",
  "CONSULATES": "CONSULATE, the post or establishment of a (modern) consul [n]\n",
  "CONSULS": "CONSUL, (Latin) either of two annually elected magistrates who jointly exercised supreme authority in the Roman Republic [n]\n",
  "CONSULSHIP": "the office of consul [n -S]\n",
  "CONSULSHIPS": "CONSULSHIP, the office of consul [n]\n",
  "CONSULT": "to ask advice of [v -ED, -ING, -S]\n",
  "CONSULTA": "(Italian) a meeting of council [n -S]\n",
  "CONSULTABLE": "that can be consulted [adj]\n",
  "CONSULTANCIES": "CONSULTANCY, an agency which provides professional advice; the post or work of a consultant [n]\n",
  "CONSULTANCY": "an agency which provides professional advice; the post or work of a consultant [n CONSULTANCIES]\n",
  "CONSULTANT": "one who consults another [n -S]\n",
  "CONSULTANTS": "CONSULTANT, one who consults another [n]\n",
  "CONSULTANTSHIP": "the state of being a consultant [n -S]\n",
  "CONSULTANTSHIPS": "CONSULTANTSHIP, the state of being a consultant [n]\n",
  "CONSULTAS": "CONSULTA, (Italian) a meeting of council [n]\n",
  "CONSULTATION": "the act of consulting [n -S]\n",
  "CONSULTATIONS": "CONSULTATION, the act of consulting [n]\n",
  "CONSULTATIVE": "relating to consultation, also CONSULTIVE [adj CONSULTATIVELY]\n",
  "CONSULTATIVELY": "CONSULTATIVE, relating to consultation, also CONSULTIVE [adv]\n",
  "CONSULTATORY": "of the nature of consultation [adj]\n",
  "CONSULTED": "CONSULT, to ask advice of [v]\n",
  "CONSULTEE": "one who is consulted [n -S]\n",
  "CONSULTEES": "CONSULTEE, one who is consulted [n]\n",
  "CONSULTER": "one who consults, or asks counsel or information [n -S]\n",
  "CONSULTERS": "CONSULTER, one who consults, or asks counsel or information [n]\n",
  "CONSULTING": "the act of asking an opinion [n -S]\n",
  "CONSULTINGS": "CONSULTING, the act of asking an opinion [n]\n",
  "CONSULTIVE": "relating to consultation, also CONSULTATIVE [adj]\n",
  "CONSULTOR": "an advisor to a Catholic bishop [n -S]\n",
  "CONSULTORS": "CONSULTOR, an advisor to a Catholic bishop [n]\n",
  "CONSULTORY": "relating to consultation [adj]\n",
  "CONSULTS": "CONSULT, to ask advice of [v]\n",
  "CONSUMABLE": "that can be consumed [adj] / something (as food or fuel) that can be consumed [n -S]\n",
  "CONSUMABLES": "CONSUMABLE, something (as food or fuel) that can be consumed [n]\n",
  "CONSUME": "to use up [v CONSUMED, CONSUMING, CONSUMES]\n",
  "CONSUMED": "CONSUME, to use up [v]\n",
  "CONSUMEDLY": "(archaic) exceedingly [adv]\n",
  "CONSUMER": "one who, or that which, consumes [n -S]\n",
  "CONSUMERISM": "the promotion of the consumer's interests [n -S]\n",
  "CONSUMERISMS": "CONSUMERISM, the promotion of the consumer's interests [n]\n",
  "CONSUMERIST": "an adherent of consumerism [n -S]\n",
  "CONSUMERISTIC": "relating to consumerism [adj]\n",
  "CONSUMERISTS": "CONSUMERIST, an adherent of consumerism [n]\n",
  "CONSUMERS": "CONSUMER, one who, or that which, consumes [n]\n",
  "CONSUMERSHIP": "the state of being a consumer [n -S]\n",
  "CONSUMERSHIPS": "CONSUMERSHIP, the state of being a consumer [n]\n",
  "CONSUMES": "CONSUME, to use up [v]\n",
  "CONSUMING": "wasting or destroying [adj CONSUMINGLY] / the act of consuming [n -S]\n",
  "CONSUMINGLY": "CONSUMING, wasting or destroying [adv]\n",
  "CONSUMINGS": "CONSUMING, the act of consuming [n]\n",
  "CONSUMMATE": "finished, complete [adj CONSUMMATELY] / to finish, complete [v CONSUMMATED, CONSUMMATING, CONSUMMATES]\n",
  "CONSUMMATED": "CONSUMMATE, to finish, complete [v]\n",
  "CONSUMMATELY": "CONSUMMATE, finished, complete [adv]\n",
  "CONSUMMATES": "CONSUMMATE, to finish, complete [v]\n",
  "CONSUMMATING": "CONSUMMATE, to finish, complete [v]\n",
  "CONSUMMATION": "the act of consummating [n -S]\n",
  "CONSUMMATIONS": "CONSUMMATION, the act of consummating [n]\n",
  "CONSUMMATIVE": "serving to consummate [adj]\n",
  "CONSUMMATOR": "one who consummates [n -S]\n",
  "CONSUMMATORS": "CONSUMMATOR, one who consummates [n]\n",
  "CONSUMMATORY": "of or relating to consummation [adj]\n",
  "CONSUMPT": "(Scots) consumption [n -S]\n",
  "CONSUMPTION": "a progressive wasting away of the body esp. from pulmonary tuberculosis [n -S]\n",
  "CONSUMPTIONS": "CONSUMPTION, a progressive wasting away of the body esp. from pulmonary tuberculosis [n]\n",
  "CONSUMPTIVE": "tending to consume [adj CONSUMPTIVELY] / a person affected with consumption [n -S]\n",
  "CONSUMPTIVELY": "CONSUMPTIVE, tending to consume [adv]\n",
  "CONSUMPTIVENESS": "the state of being consumptive [n]\n",
  "CONSUMPTIVES": "CONSUMPTIVE, a person affected with consumption [n]\n",
  "CONSUMPTIVITIES": "CONSUMPTIVITY, the state of being consumptive [n]\n",
  "CONSUMPTIVITY": "the state of being consumptive [n CONSUMPTIVITIES]\n",
  "CONSUMPTS": "CONSUMPT, (Scots) consumption [n]\n",
  "CONTABESCENCE": "the state of being contabescent, wasting away [n -S]\n",
  "CONTABESCENCES": "CONTABESCENCE, the state of being contabescent, wasting away [n]\n",
  "CONTABESCENT": "wasting away; atrophied [adj]\n",
  "CONTACT": "to communicate with [v -ED, -ING, -S]\n",
  "CONTACTABLE": "that can be contacted [adj]\n",
  "CONTACTED": "CONTACT, to communicate with [v]\n",
  "CONTACTEE": "a person contacted by aliens [n -S]\n",
  "CONTACTEES": "CONTACTEE, a person contacted by aliens [n]\n",
  "CONTACTING": "CONTACT, to communicate with [v]\n",
  "CONTACTLESS": "without contacts [adj]\n",
  "CONTACTOR": "a device for repeatedly making or breaking an electric circuit [n -S]\n",
  "CONTACTORS": "CONTACTOR, a device for repeatedly making or breaking an electric circuit [n]\n",
  "CONTACTS": "CONTACT, to communicate with [v]\n",
  "CONTACTUAL": "relating to contact [adj CONTACTUALLY]\n",
  "CONTACTUALLY": "CONTACTUAL, relating to contact [adv]\n",
  "CONTADINA": "(Italian) a (female) Italian peasant [n CONTADINE or CONTADINAS]\n",
  "CONTADINAS": "CONTADINA, (Italian) a (female) Italian peasant [n]\n",
  "CONTADINE": "CONTADINA, (Italian) a (female) Italian peasant [n]\n",
  "CONTADINI": "CONTADINO, (Italian) a (male) Italian peasant [n]\n",
  "CONTADINO": "(Italian) a (male) Italian peasant [n CONTADINI or CONTADINOS]\n",
  "CONTADINOS": "CONTADINO, (Italian) a (male) Italian peasant [n]\n",
  "CONTAGIA": "CONTAGIUM, (Latin) a causative agent of infectious diseases [n]\n",
  "CONTAGION": "transmission of a disease by direct contact with an infected person or object [n -S]\n",
  "CONTAGIONIST": "(obsolete) a person who believes in the contagiousness of diseases [n -S]\n",
  "CONTAGIONISTS": "CONTAGIONIST, (obsolete) a person who believes in the contagiousness of diseases [n]\n",
  "CONTAGIONS": "CONTAGION, transmission of a disease by direct contact with an infected person or object [n]\n",
  "CONTAGIOUS": "communicable by contact [adj CONTAGIOUSLY]\n",
  "CONTAGIOUSLY": "CONTAGIOUS, communicable by contact [adv]\n",
  "CONTAGIOUSNESS": "the state of being contagious [n]\n",
  "CONTAGIUM": "(Latin) a causative agent of infectious diseases [n CONTAGIA]\n",
  "CONTAIN": "to hold within [v -ED, -ING, -S]\n",
  "CONTAINABLE": "that can be contained [adj]\n",
  "CONTAINED": "CONTAIN, to hold within [v]\n",
  "CONTAINER": "something that contains [n -S]\n",
  "CONTAINERBOARD": "corrugated or solid cardboard used for making containers [n -S]\n",
  "CONTAINERBOARDS": "CONTAINERBOARD, corrugated or solid cardboard used for making containers [n]\n",
  "CONTAINERISE": "to ship by containerisation, also CONTAINERIZE [v CONTAINERISED, CONTAINERISING, CONTAINERISES]\n",
  "CONTAINERISED": "CONTAINERISE, to ship by containerisation, also CONTAINERIZE [v]\n",
  "CONTAINERISES": "CONTAINERISE, to ship by containerisation, also CONTAINERIZE [v]\n",
  "CONTAINERISING": "CONTAINERISE, to ship by containerisation, also CONTAINERIZE [v]\n",
  "CONTAINERIZE": "to ship by containerization, also CONTAINERISE [v CONTAINERIZED, CONTAINERIZING, CONTAINERIZES]\n",
  "CONTAINERIZED": "CONTAINERIZE, to ship by containerization, also CONTAINERISE [v]\n",
  "CONTAINERIZES": "CONTAINERIZE, to ship by containerization, also CONTAINERISE [v]\n",
  "CONTAINERIZING": "CONTAINERIZE, to ship by containerization, also CONTAINERISE [v]\n",
  "CONTAINERLESS": "without a container [adj]\n",
  "CONTAINERPORT": "a shipping port specially equipped to handle containerized cargo [n -S]\n",
  "CONTAINERPORTS": "CONTAINERPORT, a shipping port specially equipped to handle containerized cargo [n]\n",
  "CONTAINERS": "CONTAINER, something that contains [n]\n",
  "CONTAINERSHIP": "a ship specially designed or equipped for carrying containerized cargo [n -S]\n",
  "CONTAINERSHIPS": "CONTAINERSHIP, a ship specially designed or equipped for carrying containerized cargo [n]\n",
  "CONTAINING": "CONTAIN, to hold within [v]\n",
  "CONTAINMENT": "the act of containing [n -S]\n",
  "CONTAINMENTS": "CONTAINMENT, the act of containing [n]\n",
  "CONTAINS": "CONTAIN, to hold within [v]\n",
  "CONTAMINABLE": "able to be contaminated [adj]\n",
  "CONTAMINANT": "something that contaminates [n -S]\n",
  "CONTAMINANTS": "CONTAMINANT, something that contaminates [n]\n",
  "CONTAMINATE": "to pollute by contact or association [v CONTAMINATED, CONTAMINATING, CONTAMINATES]\n",
  "CONTAMINATED": "CONTAMINATE, to pollute by contact or association [v]\n",
  "CONTAMINATES": "CONTAMINATE, to pollute by contact or association [v]\n",
  "CONTAMINATING": "CONTAMINATE, to pollute by contact or association [v]\n",
  "CONTAMINATION": "a process of contaminating [n -S]\n",
  "CONTAMINATIONS": "CONTAMINATION, a process of contaminating [n]\n",
  "CONTAMINATIVE": "tending to contaminate [adj]\n",
  "CONTAMINATOR": "one who contaminates [n -S]\n",
  "CONTAMINATORS": "CONTAMINATOR, one who contaminates [n]\n",
  "CONTANGO": "the premium or interest paid by a buyer of stock to the seller, to be allowed to defer payment [n CONTANGOS or CONTANGOES] / to exercise the right of contango [v -ED, -ING, -ES]\n",
  "CONTANGOED": "CONTANGO, to exercise the right of contango [v]\n",
  "CONTANGOES": "CONTANGO, to exercise the right of contango [v]\n",
  "CONTANGOING": "CONTANGO, to exercise the right of contango [v]\n",
  "CONTANGOS": "CONTANGO, the premium or interest paid by a buyer of stock to the seller, to be allowed to defer payment [n]\n",
  "CONTE": "(French) a short story (as a literary genre) [n -S]\n",
  "CONTECK": "(archaic) strife, discord [n -S]\n",
  "CONTECKS": "CONTECK, (archaic) strife, discord [n]\n",
  "CONTEMN": "to despise or scorn [v -ED, -ING, -S]\n",
  "CONTEMNED": "CONTEMN, to despise or scorn [v]\n",
  "CONTEMNER": "a person who contemns; a person who has been found guilty of contempt of court, also CONTEMNOR [n -S]\n",
  "CONTEMNERS": "CONTEMNER, a person who contemns; a person who has been found guilty of contempt of court, also CONTEMNOR [n]\n",
  "CONTEMNIBLE": "worthy of being contemned [adj CONTEMNIBLY]\n",
  "CONTEMNIBLY": "CONTEMNIBLE, worthy of being contemned [adv]\n",
  "CONTEMNING": "CONTEMN, to despise or scorn [v]\n",
  "CONTEMNOR": "a person who contemns; a person who has been found guilty of contempt of court, also CONTEMNER [n -S]\n",
  "CONTEMNORS": "CONTEMNOR, a person who contemns; a person who has been found guilty of contempt of court, also CONTEMNER [n]\n",
  "CONTEMNS": "CONTEMN, to despise or scorn [v]\n",
  "CONTEMPER": "to blend together; to adapt [v -ED, -ING, -S]\n",
  "CONTEMPERATION": "(obsolete) the act of contempering, blending together [n -S]\n",
  "CONTEMPERATIONS": "CONTEMPERATION, (obsolete) the act of contempering, blending together [n]\n",
  "CONTEMPERATURE": "the state of being contempered, blended together [n -S]\n",
  "CONTEMPERATURES": "CONTEMPERATURE, the state of being contempered, blended together [n]\n",
  "CONTEMPERED": "CONTEMPER, to blend together; to adapt [v]\n",
  "CONTEMPERING": "CONTEMPER, to blend together; to adapt [v]\n",
  "CONTEMPERS": "CONTEMPER, to blend together; to adapt [v]\n",
  "CONTEMPLABLE": "able to be contemplated [adj]\n",
  "CONTEMPLANT": "one who contemplates [n -S]\n",
  "CONTEMPLANTS": "CONTEMPLANT, one who contemplates [n]\n",
  "CONTEMPLATE": "to view or consider with continued attention [v CONTEMPLATED, CONTEMPLATING, CONTEMPLATES]\n",
  "CONTEMPLATED": "CONTEMPLATE, to view or consider with continued attention [v]\n",
  "CONTEMPLATES": "CONTEMPLATE, to view or consider with continued attention [v]\n",
  "CONTEMPLATING": "CONTEMPLATE, to view or consider with continued attention [v]\n",
  "CONTEMPLATION": "concentration on spiritual things as a form of private devotion [n -S]\n",
  "CONTEMPLATIONS": "CONTEMPLATION, concentration on spiritual things as a form of private devotion [n]\n",
  "CONTEMPLATIST": "one who believes in contemplation [n -S]\n",
  "CONTEMPLATISTS": "CONTEMPLATIST, one who believes in contemplation [n]\n",
  "CONTEMPLATIVE": "related to contemplation [adj CONTEMPLATIVELY] / a person who practices contemplation [n -S]\n",
  "CONTEMPLATIVELY": "CONTEMPLATIVE, related to contemplation [adv]\n",
  "CONTEMPLATIVES": "CONTEMPLATIVE, a person who practices contemplation [n]\n",
  "CONTEMPLATOR": "one who contemplates [n -S]\n",
  "CONTEMPLATORS": "CONTEMPLATOR, one who contemplates [n]\n",
  "CONTEMPO": "contemporary [adj]\n",
  "CONTEMPORANEAN": "a contemporary [n -S]\n",
  "CONTEMPORANEANS": "CONTEMPORANEAN, a contemporary [n]\n",
  "CONTEMPORANEITY": "the state of being contemporaneous [n]\n",
  "CONTEMPORANEOUS": "existing, occurring, or originating during the same time, also COTEMPORANEOUS [adj]\n",
  "CONTEMPORARIES": "CONTEMPORARY, one belonging to the same time as another [n]\n",
  "CONTEMPORARILY": "CONTEMPORARY, belonging to the present time, also COTEMPORARY [adv]\n",
  "CONTEMPORARY": "belonging to the present time, also COTEMPORARY [adj CONTEMPORARILY] / one belonging to the same time as another [n CONTEMPORARIES]\n",
  "CONTEMPORISE": "to make contemporary, also CONTEMPORIZE [v CONTEMPORISED, CONTEMPORISING, CONTEMPORISES]\n",
  "CONTEMPORISED": "CONTEMPORISE, to make contemporary, also CONTEMPORIZE [v]\n",
  "CONTEMPORISES": "CONTEMPORISE, to make contemporary, also CONTEMPORIZE [v]\n",
  "CONTEMPORISING": "CONTEMPORISE, to make contemporary, also CONTEMPORIZE [v]\n",
  "CONTEMPORIZE": "to make contemporary, also CONTEMPORISE [v CONTEMPORIZED, CONTEMPORIZING, CONTEMPORIZES]\n",
  "CONTEMPORIZED": "CONTEMPORIZE, to make contemporary, also CONTEMPORISE [v]\n",
  "CONTEMPORIZES": "CONTEMPORIZE, to make contemporary, also CONTEMPORISE [v]\n",
  "CONTEMPORIZING": "CONTEMPORIZE, to make contemporary, also CONTEMPORISE [v]\n",
  "CONTEMPT": "scorn [n -S]\n",
  "CONTEMPTIBILITY": "the state of being contemptible [n]\n",
  "CONTEMPTIBLE": "worthy of contempt [adj CONTEMPTIBLY]\n",
  "CONTEMPTIBLY": "CONTEMPTIBLE, worthy of contempt [adv]\n",
  "CONTEMPTS": "CONTEMPT, scorn [n]\n",
  "CONTEMPTUOUS": "manifesting contempt [adj CONTEMPTUOUSLY]\n",
  "CONTEMPTUOUSLY": "CONTEMPTUOUS, manifesting contempt [adv]\n",
  "CONTEND": "to vie [v -ED, -ING, -S]\n",
  "CONTENDED": "CONTEND, to vie [v]\n",
  "CONTENDENT": "an antagonist; a contestant [n -S]\n",
  "CONTENDENTS": "CONTENDENT, an antagonist; a contestant [n]\n",
  "CONTENDER": "one who contends [n -S]\n",
  "CONTENDERS": "CONTENDER, one who contends [n]\n",
  "CONTENDING": "striving [adj CONTENDINGLY] / striving [n -S]\n",
  "CONTENDINGLY": "CONTENDING, striving [adv]\n",
  "CONTENDINGS": "CONTENDING, striving [n]\n",
  "CONTENDS": "CONTEND, to vie [v]\n",
  "CONTENEMENT": "(obsolete) property necessary to maintain one's station [n -S]\n",
  "CONTENEMENTS": "CONTENEMENT, (obsolete) property necessary to maintain one's station [n]\n",
  "CONTENT": "happy with one's lot [adj CONTENTLY] / to satisfy [v -ED, -ING, -S]\n",
  "CONTENTATION": "(obsolete) being content [n -S]\n",
  "CONTENTATIONS": "CONTENTATION, (obsolete) being content [n]\n",
  "CONTENTED": "CONTENT, to satisfy [v]\n",
  "CONTENTEDLY": "CONTENTED, CONTENT, to satisfy [adv]\n",
  "CONTENTEDNESS": "the state of being contented [n -ES]\n",
  "CONTENTEDNESSES": "CONTENTEDNESS, the state of being contented [n]\n",
  "CONTENTING": "CONTENT, to satisfy [v]\n",
  "CONTENTION": "an act or instance of contending [n -S]\n",
  "CONTENTIONS": "CONTENTION, an act or instance of contending [n]\n",
  "CONTENTIOUS": "likely to cause contention [adj CONTENTIOUSLY]\n",
  "CONTENTIOUSLY": "CONTENTIOUS, likely to cause contention [adv]\n",
  "CONTENTIOUSNESS": "CONTENTIOUS, likely to cause contention [n]\n",
  "CONTENTLESS": "without content [adj]\n",
  "CONTENTLY": "CONTENT, happy with one's lot [adv]\n",
  "CONTENTMENT": "the state of being contented [n -S]\n",
  "CONTENTMENTS": "CONTENTMENT, the state of being contented [n]\n",
  "CONTENTS": "CONTENT, to satisfy [v]\n",
  "CONTERMINAL": "adjacent, end to end, also CONTERMINANT, CONTERMINATE, CONTERMINOUS, COTERMINOUS [adj CONTERMINALLY]\n",
  "CONTERMINALLY": "CONTERMINAL, adjacent, end to end, also CONTERMINANT, CONTERMINATE, CONTERMINOUS, COTERMINOUS [adv]\n",
  "CONTERMINANT": "adjacent, end to end, also CONTERMINAL, CONTERMINATE, CONTERMINOUS, COTERMINOUS [adj]\n",
  "CONTERMINATE": "adjacent, end to end, also CONTERMINAL, CONTERMINANT, CONTERMINOUS, COTERMINOUS [adj]\n",
  "CONTERMINOUS": "sharing the same end; confined within a common boundary, also CONTERMINAL, CONTERMINANT, CONTERMINATE, COTERMINOUS [adj CONTERMINOUSLY]\n",
  "CONTERMINOUSLY": "CONTERMINOUS, sharing the same end; confined within a common boundary, also CONTERMINAL, CONTERMINANT, CONTERMINATE, COTERMINOUS [adv]\n",
  "CONTES": "CONTE, (French) a short story (as a literary genre) [n]\n",
  "CONTESSA": "(Italian) an Italian countess [n -S]\n",
  "CONTESSAS": "CONTESSA, (Italian) an Italian countess [n]\n",
  "CONTESSERATION": "a harmonious union [n -S]\n",
  "CONTESSERATIONS": "CONTESSERATION, a harmonious union [n]\n",
  "CONTEST": "to compete for [v -ED, -ING, -S]\n",
  "CONTESTABILITY": "the ability to be contested [n]\n",
  "CONTESTABLE": "able to be contested [adj CONTESTABLY]\n",
  "CONTESTABLENESS": "CONTESTABLE, able to be contested [n]\n",
  "CONTESTABLY": "CONTESTABLE, able to be contested [adv]\n",
  "CONTESTANT": "one that participates in a contest [n -S]\n",
  "CONTESTANTS": "CONTESTANT, one that participates in a contest [n]\n",
  "CONTESTATION": "controversy, debate [n -S]\n",
  "CONTESTATIONS": "CONTESTATION, controversy, debate [n]\n",
  "CONTESTED": "CONTEST, to compete for [v]\n",
  "CONTESTER": "one who contests [n -S]\n",
  "CONTESTERS": "CONTESTER, one who contests [n]\n",
  "CONTESTING": "CONTEST, to compete for [v]\n",
  "CONTESTINGLY": "CONTESTING, CONTEST, to compete for [adv]\n",
  "CONTESTS": "CONTEST, to compete for [v]\n",
  "CONTEXT": "a passage or words which explain the true meaning [n -S]\n",
  "CONTEXTLESS": "without context [adj]\n",
  "CONTEXTS": "CONTEXT, a passage or words which explain the true meaning [n]\n",
  "CONTEXTUAL": "relating to context [adj CONTEXTUALLY]\n",
  "CONTEXTUALISE": "to put into a context, also CONTEXTUALIZE [v CONTEXTUALISED, CONTEXTUALISING, CONTEXTUALISES]\n",
  "CONTEXTUALISED": "CONTEXTUALISE, to put into a context, also CONTEXTUALIZE [v]\n",
  "CONTEXTUALISES": "CONTEXTUALISE, to put into a context, also CONTEXTUALIZE [v]\n",
  "CONTEXTUALISING": "CONTEXTUALISE, to put into a context, also CONTEXTUALIZE [v]\n",
  "CONTEXTUALIZE": "to place in a context, also CONTEXTUALISE [v CONTEXTUALIZED, CONTEXTUALIZING, CONTEXTUALIZES]\n",
  "CONTEXTUALIZED": "CONTEXTUALIZE, to place in a context, also CONTEXTUALISE [v]\n",
  "CONTEXTUALIZES": "CONTEXTUALIZE, to place in a context, also CONTEXTUALISE [v]\n",
  "CONTEXTUALIZING": "CONTEXTUALIZE, to place in a context, also CONTEXTUALISE [v]\n",
  "CONTEXTUALLY": "CONTEXTUAL, relating to context [adv]\n",
  "CONTEXTURAL": "relating to contexture, weaving together [adj]\n",
  "CONTEXTURE": "the process or manner of weaving together [n -S]\n",
  "CONTEXTURES": "CONTEXTURE, the process or manner of weaving together [n]\n",
  "CONTICENT": "silent [adj]\n",
  "CONTIGNATION": "(archaic) joining together of timber [n -S]\n",
  "CONTIGNATIONS": "CONTIGNATION, (archaic) joining together of timber [n]\n",
  "CONTIGUITIES": "CONTIGUITY, the state of being contiguous [n]\n",
  "CONTIGUITY": "the state of being contiguous [n CONTIGUITIES]\n",
  "CONTIGUOUS": "being in actual contact [adj CONTIGUOUSLY]\n",
  "CONTIGUOUSLY": "CONTIGUOUS, being in actual contact [adv]\n",
  "CONTIGUOUSNESS": "CONTIGUOUS, being in actual contact [n]\n",
  "CONTINENCE": "self-restraint, also CONTINENCY [n -S]\n",
  "CONTINENCES": "CONTINENCE, self-restraint, also CONTINENCY [n]\n",
  "CONTINENCIES": "CONTINENCY, self-restraint, also CONTINENCE [n]\n",
  "CONTINENCY": "self-restraint, also CONTINENCE [n CONTINENCIES]\n",
  "CONTINENT": "temperate, able to restrain [adj CONTINENTLY] / a vast landmass not broken up by seas [n -S]\n",
  "CONTINENTAL": "relating to a continent [adj CONTINENTALLY] / an American soldier of the Revolution in the Continental army [n -S]\n",
  "CONTINENTALISM": "anything peculiar to the usage of a continent, esp. Europe [n -S]\n",
  "CONTINENTALISMS": "CONTINENTALISM, anything peculiar to the usage of a continent, esp. Europe [n]\n",
  "CONTINENTALIST": "one who uses continentalisms [n -S]\n",
  "CONTINENTALISTS": "CONTINENTALIST, one who uses continentalisms [n]\n",
  "CONTINENTALLY": "CONTINENTAL, relating to a continent [adv]\n",
  "CONTINENTALS": "CONTINENTAL, an American soldier of the Revolution in the Continental army [n]\n",
  "CONTINENTLY": "CONTINENT, temperate, able to restrain [adv]\n",
  "CONTINENTS": "CONTINENT, a vast landmass not broken up by seas [n]\n",
  "CONTINGENCE": "an event (as an emergency) that may but is not certain to occur, also CONTINGENCY [n -S]\n",
  "CONTINGENCES": "CONTINGENCE, an event (as an emergency) that may but is not certain to occur, also CONTINGENCY [n]\n",
  "CONTINGENCIES": "CONTINGENCY, an event (as an emergency) that may but is not certain to occur, also CONTINGENCE [n]\n",
  "CONTINGENCY": "an event (as an emergency) that may but is not certain to occur, also CONTINGENCE [n CONTINGENCIES]\n",
  "CONTINGENT": "touching, dependent [adj CONTINGENTLY] / something contingent [n -S]\n",
  "CONTINGENTLY": "CONTINGENT, touching, dependent [adv]\n",
  "CONTINGENTS": "CONTINGENT, something contingent [n]\n",
  "CONTINUA": "CONTINUUM, (Latin) a continuous range [n]\n",
  "CONTINUABLE": "that can be continued [adj]\n",
  "CONTINUAL": "constantly happening or done [adj CONTINUALLY]\n",
  "CONTINUALITIES": "CONTINUALITY, the quality of being continual [n]\n",
  "CONTINUALITY": "the quality of being continual [n CONTINUALITIES]\n",
  "CONTINUALLY": "CONTINUAL, constantly happening or done [adv]\n",
  "CONTINUALNESS": "CONTINUAL, constantly happening or done [n]\n",
  "CONTINUALNESSES": "CONTINUALNESS, CONTINUAL, constantly happening or done [n]\n",
  "CONTINUANCE": "the state of continuing, remaining in the same place, action, etc. [n -S]\n",
  "CONTINUANCES": "CONTINUANCE, the state of continuing, remaining in the same place, action, etc. [n]\n",
  "CONTINUANT": "continuing; prolonged [adj] / a continuant sound [n -S]\n",
  "CONTINUANTS": "CONTINUANT, a continuant sound [n]\n",
  "CONTINUATE": "(obsolete) closely united [adj]\n",
  "CONTINUATION": "the act of continuing [n -S]\n",
  "CONTINUATIONS": "CONTINUATION, the act of continuing [n]\n",
  "CONTINUATIVE": "continuing [adj CONTINUATIVELY] / a continuous word or phrase [n -S]\n",
  "CONTINUATIVELY": "CONTINUATIVE, continuing [adv]\n",
  "CONTINUATIVES": "CONTINUATIVE, a continuous word or phrase [n]\n",
  "CONTINUATOR": "one that continues [n -S]\n",
  "CONTINUATORS": "CONTINUATOR, one that continues [n]\n",
  "CONTINUE": "to go on with [v CONTINUED, CONTINUING, CONTINUES]\n",
  "CONTINUED": "CONTINUE, to go on with [v]\n",
  "CONTINUEDLY": "CONTINUED [adv]\n",
  "CONTINUEDNESS": "the state of being continued [n -ES]\n",
  "CONTINUEDNESSES": "CONTINUEDNESS, the state of being continued [n]\n",
  "CONTINUER": "one who continues [n -S]\n",
  "CONTINUERS": "CONTINUER, one who continues [n]\n",
  "CONTINUES": "CONTINUE, to go on with [v]\n",
  "CONTINUING": "CONTINUE, to go on with [v]\n",
  "CONTINUINGLY": "CONTINUING, CONTINUE, to go on with [adv]\n",
  "CONTINUITIES": "CONTINUITY, a script or scenario in the performing arts [n]\n",
  "CONTINUITY": "a script or scenario in the performing arts [n CONTINUITIES]\n",
  "CONTINUO": "(Italian) the bass part as written for a keyboard instrument [n -S]\n",
  "CONTINUOS": "CONTINUO, (Italian) the bass part as written for a keyboard instrument [n]\n",
  "CONTINUOUS": "marked by uninterrupted extension in space, time, or sequence [adj CONTINUOUSLY]\n",
  "CONTINUOUSLY": "CONTINUOUS, marked by uninterrupted extension in space, time, or sequence [adv]\n",
  "CONTINUOUSNESS": "CONTINUOUS, marked by uninterrupted extension in space, time, or sequence [n]\n",
  "CONTINUUM": "(Latin) a continuous range [n CONTINUUMS or CONTINUA]\n",
  "CONTINUUMS": "CONTINUUM, (Latin) a continuous range [n]\n",
  "CONTLINE": "the space between stowed casks [n -S]\n",
  "CONTLINES": "CONTLINE, the space between stowed casks [n]\n",
  "CONTO": "(Portuguese) a Portuguese money of account [n -S]\n",
  "CONTORNI": "CONTORNO, (Italian) a contour, an outline of a figure [n]\n",
  "CONTORNIATE": "a coin or medal with a deep groove round the disc [n -S]\n",
  "CONTORNIATES": "CONTORNIATE, a coin or medal with a deep groove round the disc [n]\n",
  "CONTORNO": "(Italian) a contour, an outline of a figure [n CONTORNOS or CONTORNI]\n",
  "CONTORNOS": "CONTORNO, (Italian) a contour, an outline of a figure [n]\n",
  "CONTORT": "to twist out of shape [v -ED, -ING, -S]\n",
  "CONTORTED": "CONTORT, to twist out of shape [v]\n",
  "CONTORTEDLY": "CONTORTED [adv]\n",
  "CONTORTEDNESS": "the state of being contorted [n -ES]\n",
  "CONTORTEDNESSES": "CONTORTEDNESS, the state of being contorted [n]\n",
  "CONTORTING": "CONTORT, to twist out of shape [v]\n",
  "CONTORTION": "the state of being contorted [n -S]\n",
  "CONTORTIONAL": "relating to contortion, also CONTORTIONATE [adj]\n",
  "CONTORTIONATE": "relating to contortion, also CONTORTIONAL [adj]\n",
  "CONTORTIONED": "in a contorted state [adj]\n",
  "CONTORTIONISM": "the art of the contortionist [n -S]\n",
  "CONTORTIONISMS": "CONTORTIONISM, the art of the contortionist [n]\n",
  "CONTORTIONIST": "one who contorts [n -S]\n",
  "CONTORTIONISTIC": "relating to contortionism, the art of the contortionist [adj]\n",
  "CONTORTIONISTS": "CONTORTIONIST, one who contorts [n]\n",
  "CONTORTIONS": "CONTORTION, the state of being contorted [n]\n",
  "CONTORTIVE": "expressing contortion [adj]\n",
  "CONTORTS": "CONTORT, to twist out of shape [v]\n",
  "CONTOS": "CONTO, (Portuguese) a Portuguese money of account [n]\n",
  "CONTOUR": "to make the outline of [v -ED, -ING, -S]\n",
  "CONTOURED": "CONTOUR, to make the outline of [v]\n",
  "CONTOURING": "CONTOUR, to make the outline of [v]\n",
  "CONTOURS": "CONTOUR, to make the outline of [v]\n",
  "CONTRA": "(Latin) a Nicaraguan revolutionary [n -S]\n",
  "CONTRABAND": "illegal or prohibited traffic in goods [n -S]\n",
  "CONTRABANDISM": "trading in contraband goods [n -S]\n",
  "CONTRABANDISMS": "CONTRABANDISM, trading in contraband goods [n]\n",
  "CONTRABANDIST": "a smuggler [n -S]\n",
  "CONTRABANDISTS": "CONTRABANDIST, a smuggler [n]\n",
  "CONTRABANDS": "CONTRABAND, illegal or prohibited traffic in goods [n]\n",
  "CONTRABASS": "the double bass, also CONTRABASSO, CONTRABBASSO, COUNTERBASE [n -ES]\n",
  "CONTRABASSES": "CONTRABASS, the double bass, also CONTRABASSO, CONTRABBASSO, COUNTERBASE [n]\n",
  "CONTRABASSI": "CONTRABASSO, (Italian) the double bass, also CONTRABASS, CONTRABBASSO, COUNTERBASE [n]\n",
  "CONTRABASSIST": "one who plays a contrabass [n -S]\n",
  "CONTRABASSISTS": "CONTRABASSIST, one who plays a contrabass [n]\n",
  "CONTRABASSO": "(Italian) the double bass, also CONTRABASS, CONTRABBASSO, COUNTERBASE [n CONTRABASSI or CONTRABASSOS]\n",
  "CONTRABASSOON": "a musical instrument playing an octave below the bassoon [n -S]\n",
  "CONTRABASSOONS": "CONTRABASSOON, a musical instrument playing an octave below the bassoon [n]\n",
  "CONTRABASSOS": "CONTRABASSO, (Italian) the double bass, also CONTRABASS, CONTRABBASSO, COUNTERBASE [n]\n",
  "CONTRABBASSI": "CONTRABBASSO, (Italian) the double bass, also CONTRABASS, CONTRABASSO, COUNTERBASE [n]\n",
  "CONTRABBASSO": "(Italian) the double bass, also CONTRABASS, CONTRABASSO, COUNTERBASE [n CONTRABBASSI or CONTRABBASSOS]\n",
  "CONTRABBASSOS": "CONTRABBASSO, (Italian) the double bass, also CONTRABASS, CONTRABASSO, COUNTERBASE [n]\n",
  "CONTRACEPTION": "deliberate prevention of conception or impregnation [n -S]\n",
  "CONTRACEPTIONS": "CONTRACEPTION, deliberate prevention of conception or impregnation [n]\n",
  "CONTRACEPTIVE": "something intended to prevent conception [n -S]\n",
  "CONTRACEPTIVES": "CONTRACEPTIVE, something intended to prevent conception [n]\n",
  "CONTRACLOCKWISE": "anticlockwise [adv]\n",
  "CONTRACT": "to decrease in size [v -ED, -ING, -S]\n",
  "CONTRACTABILITY": "the quality of being contractable [n]\n",
  "CONTRACTABLE": "that can be contracted, also CONTRACTIBLE [adj CONTRACTABLY]\n",
  "CONTRACTABLY": "CONTRACTABLE, that can be contracted, also CONTRACTIBLE [adv]\n",
  "CONTRACTED": "CONTRACT, to decrease in size [v]\n",
  "CONTRACTEDLY": "CONTRACTED, CONTRACT, to decrease in size [adv]\n",
  "CONTRACTEDNESS": "the state of being contracted [n]\n",
  "CONTRACTIBILITY": "the state of being contractible [n]\n",
  "CONTRACTIBLE": "that can be contracted, also CONTRACTABLE [adj CONTRACTIBLY]\n",
  "CONTRACTIBLY": "CONTRACTIBLE, that can be contracted, also CONTRACTABLE [adv]\n",
  "CONTRACTILE": "having the power or property of contracting [adj]\n",
  "CONTRACTILITIES": "CONTRACTILITY, the quality of being contractile [n]\n",
  "CONTRACTILITY": "the quality of being contractile [n CONTRACTILITIES]\n",
  "CONTRACTING": "CONTRACT, to decrease in size [v]\n",
  "CONTRACTION": "the act of contracting [n -S]\n",
  "CONTRACTIONAL": "relating to contraction, also CONTRACTIONARY [adj]\n",
  "CONTRACTIONARY": "relating to contraction, also CONTRACTIONAL [adj]\n",
  "CONTRACTIONS": "CONTRACTION, the act of contracting [n]\n",
  "CONTRACTIVE": "tending to contract [adj CONTRACTIVELY]\n",
  "CONTRACTIVELY": "CONTRACTIVE, tending to contract [adv]\n",
  "CONTRACTIVENESS": "CONTRACTIVE, tending to contract [n]\n",
  "CONTRACTOR": "one that contracts to perform work or provide supplies [n -S]\n",
  "CONTRACTORS": "CONTRACTOR, one that contracts to perform work or provide supplies [n]\n",
  "CONTRACTS": "CONTRACT, to decrease in size [v]\n",
  "CONTRACTUAL": "of, relating to, or constituting a contract [adj CONTRACTUALLY]\n",
  "CONTRACTUALLY": "CONTRACTUAL, of, relating to, or constituting a contract [adv]\n",
  "CONTRACTURAL": "relating to contracture, a permanent shortening of a muscle or tendon [adj]\n",
  "CONTRACTURE": "a permanent shortening (as of muscle, tendon, or scar tissue) producing deformity or distortion [n -S]\n",
  "CONTRACTURES": "CONTRACTURE, a permanent shortening (as of muscle, tendon, or scar tissue) producing deformity or distortion [n]\n",
  "CONTRACYCLICAL": "of an economic policy, offsetting fluctuation cycles in the economy by reducing taxes during a recession and raising them during a boom [adj]\n",
  "CONTRADANCE": "a country dance, esp. a French version of the English country dance, also CONTREDANCE, CONTREDANSE [n -S]\n",
  "CONTRADANCES": "CONTRADANCE, a country dance, esp. a French version of the English country dance, also CONTREDANCE, CONTREDANSE [n]\n",
  "CONTRADICT": "to assert the contrary of [v -ED, -ING, -S]\n",
  "CONTRADICTABLE": "capable of being contradicted [adj]\n",
  "CONTRADICTED": "CONTRADICT, to assert the contrary of [v]\n",
  "CONTRADICTER": "one who contradicts, also CONTRADICTOR [n -S]\n",
  "CONTRADICTERS": "CONTRADICTER, one who contradicts, also CONTRADICTOR [n]\n",
  "CONTRADICTING": "CONTRADICT, to assert the contrary of [v]\n",
  "CONTRADICTION": "an act or an instance of contradicting [n -S]\n",
  "CONTRADICTIONS": "CONTRADICTION, an act or an instance of contradicting [n]\n",
  "CONTRADICTIOUS": "contradictory, opposite [adj]\n",
  "CONTRADICTIVE": "contradicting or tending to contradict [adj CONTRADICTIVELY]\n",
  "CONTRADICTIVELY": "CONTRADICTIVE, contradicting or tending to contradict [adv]\n",
  "CONTRADICTOR": "one who contradicts, also CONTRADICTER [n -S]\n",
  "CONTRADICTORIES": "CONTRADICTORY, a word or principle that contradicts another [n]\n",
  "CONTRADICTORILY": "CONTRADICTORY, serving to contradict [adv]\n",
  "CONTRADICTORS": "CONTRADICTOR, one who contradicts, also CONTRADICTER [n]\n",
  "CONTRADICTORY": "serving to contradict [adj CONTRADICTORILY] / a word or principle that contradicts another [n CONTRADICTORIES]\n",
  "CONTRADICTS": "CONTRADICT, to assert the contrary of [v]\n",
  "CONTRAFAGOTTI": "CONTRAFAGOTTO, (Italian) a musical instrument like a bassoon [n]\n",
  "CONTRAFAGOTTO": "(Italian) a musical instrument like a bassoon [n CONTRAFAGOTTOS or CONTRAFAGOTTI]\n",
  "CONTRAFAGOTTOS": "CONTRAFAGOTTO, (Italian) a musical instrument like a bassoon [n]\n",
  "CONTRAFLOW": "a system of traffic regulation on motorways, when one carriageway is closed and the other is arranged for two-way traffic [n -S]\n",
  "CONTRAFLOWS": "CONTRAFLOW, a system of traffic regulation on motorways, when one carriageway is closed and the other is arranged for two-way traffic [n]\n",
  "CONTRAGESTION": "a form of birth control that is effective after fertilization of the ovum has taken place [n -S]\n",
  "CONTRAGESTIONS": "CONTRAGESTION, a form of birth control that is effective after fertilization of the ovum has taken place [n]\n",
  "CONTRAGESTIVE": "relating to contragestion, a form of birth control that is effective after fertilization of the ovum has taken place [adj] / such a form of birth control [n -S]\n",
  "CONTRAGESTIVES": "CONTRAGESTIVE, such a form of birth control [n]\n",
  "CONTRAHENT": "(historical) a contracting party [n -S]\n",
  "CONTRAHENTS": "CONTRAHENT, (historical) a contracting party [n]\n",
  "CONTRAIL": "a trail of water vapor from an aircraft [n -S]\n",
  "CONTRAILS": "CONTRAIL, a trail of water vapor from an aircraft [n]\n",
  "CONTRAINDICANT": "something that contraindicates [n -S]\n",
  "CONTRAINDICANTS": "CONTRAINDICANT, something that contraindicates [n]\n",
  "CONTRAINDICATE": "to indicate against (an otherwise suitable medical treatment) due to a condition or circumstance [v CONTRAINDICATED, CONTRAINDICATES]\n",
  "CONTRAINDICATED": "CONTRAINDICATE, to indicate against (an otherwise suitable medical treatment) due to a condition or circumstance [v]\n",
  "CONTRAINDICATES": "CONTRAINDICATE, to indicate against (an otherwise suitable medical treatment) due to a condition or circumstance [v]\n",
  "CONTRAIR": "contrary [adj]\n",
  "CONTRALATERAL": "occurring on or acting in conjunction with a part on the opposite side of the body [adj]\n",
  "CONTRALTI": "CONTRALTO, (Italian) the part sung by the highest male or lowest female voices [n]\n",
  "CONTRALTO": "(Italian) the part sung by the highest male or lowest female voices [n CONTRALTI or CONTRALTOS]\n",
  "CONTRALTOS": "CONTRALTO, (Italian) the part sung by the highest male or lowest female voices [n]\n",
  "CONTRANATANT": "swimming upstream [adj]\n",
  "CONTRAOCTAVE": "the musical octave that begins on the third C below middle C [n -S]\n",
  "CONTRAOCTAVES": "CONTRAOCTAVE, the musical octave that begins on the third C below middle C [n]\n",
  "CONTRAPLEX": "having messages passing both ways simultaneously [adj]\n",
  "CONTRAPOSITION": "opposition; contrast [n -S]\n",
  "CONTRAPOSITIONS": "CONTRAPOSITION, opposition; contrast [n]\n",
  "CONTRAPOSITIVE": "an immediate inference, which consists in denying the original subject of the contradictory of the original predicate [n -S]\n",
  "CONTRAPOSITIVES": "CONTRAPOSITIVE, an immediate inference, which consists in denying the original subject of the contradictory of the original predicate [n]\n",
  "CONTRAPPOSTO": "a pose of the human body with hips, shoulders and head in different planes [n -S]\n",
  "CONTRAPPOSTOS": "CONTRAPPOSTO, a pose of the human body with hips, shoulders and head in different planes [n]\n",
  "CONTRAPROP": "a contra-rotating propeller [n -S]\n",
  "CONTRAPROPELLER": "one of a pair of propellers rotating in opposite directions [n]\n",
  "CONTRAPROPS": "CONTRAPROP, a contra-rotating propeller [n]\n",
  "CONTRAPTION": "a device, a gadget [n -S]\n",
  "CONTRAPTIONS": "CONTRAPTION, a device, a gadget [n]\n",
  "CONTRAPUNTAL": "pertaining to counterpoint [adj CONTRAPUNTALLY]\n",
  "CONTRAPUNTALIST": "one who uses counterpoint in composition [n]\n",
  "CONTRAPUNTALLY": "CONTRAPUNTAL, pertaining to counterpoint [adv]\n",
  "CONTRAPUNTIST": "one who writes counterpoint [n -S]\n",
  "CONTRAPUNTISTS": "CONTRAPUNTIST, one who writes counterpoint [n]\n",
  "CONTRARIAN": "a person who takes a contrary view, esp. in journalism or politics [n -S]\n",
  "CONTRARIANS": "CONTRARIAN, a person who takes a contrary view, esp. in journalism or politics [n]\n",
  "CONTRARIED": "CONTRARY, to oppose, contradict [v]\n",
  "CONTRARIES": "CONTRARY, to oppose, contradict [v]\n",
  "CONTRARIETIES": "CONTRARIETY, the state of being contrary [n]\n",
  "CONTRARIETY": "the state of being contrary [n CONTRARIETIES]\n",
  "CONTRARILY": "CONTRARY, opposite; in an opposite direction, also CONTRAIR, CONTRARIOUS [adv]\n",
  "CONTRARINESS": "the state of being contrary [n -ES]\n",
  "CONTRARINESSES": "CONTRARINESS, the state of being contrary [n]\n",
  "CONTRARIOUS": "(archaic) contrary, perverse, also CONTRAIR, CONTRARY [adj CONTRARIOUSLY]\n",
  "CONTRARIOUSLY": "CONTRARIOUS, (archaic) contrary, perverse, also CONTRAIR, CONTRARY [adv]\n",
  "CONTRARIOUSNESS": "CONTRARIOUS, (archaic) contrary, perverse, also CONTRAIR, CONTRARY [n]\n",
  "CONTRARIWISE": "on the contrary [adj]\n",
  "CONTRARY": "opposite; in an opposite direction, also CONTRAIR, CONTRARIOUS [adj CONTRARILY] / to oppose, contradict [v CONTRARIED, CONTRARYING, CONTRARIES]\n",
  "CONTRARYING": "CONTRARY, to oppose, contradict [v]\n",
  "CONTRAS": "CONTRA, (Latin) a Nicaraguan revolutionary [n]\n",
  "CONTRASEXUAL": "one who represses the personality traits that most people repress because they are characteristic of the opposite sex [n -S]\n",
  "CONTRASEXUALS": "CONTRASEXUAL, one who represses the personality traits that most people repress because they are characteristic of the opposite sex [n]\n",
  "CONTRAST": "to place in opposition to display differences [v -ED, -ING, -S]\n",
  "CONTRASTABLE": "able to be contrasted [adj]\n",
  "CONTRASTABLY": "CONTRASTABLE, able to be contrasted [adv]\n",
  "CONTRASTED": "CONTRAST, to place in opposition to display differences [v]\n",
  "CONTRASTIER": "CONTRASTY, of eg a photograph, showing strong contrasts [adj]\n",
  "CONTRASTIEST": "CONTRASTY, of eg a photograph, showing strong contrasts [adj]\n",
  "CONTRASTING": "CONTRAST, to place in opposition to display differences [v]\n",
  "CONTRASTINGLY": "in a contrasting manner [adv]\n",
  "CONTRASTIVE": "forming or consisting of a contrast [adj CONTRASTIVELY]\n",
  "CONTRASTIVELY": "CONTRASTIVE, forming or consisting of a contrast [adv]\n",
  "CONTRASTS": "CONTRAST, to place in opposition to display differences [v]\n",
  "CONTRASTY": "of eg a photograph, showing strong contrasts [adj CONTRASTIER, CONTRASTIEST]\n",
  "CONTRAT": "(French) a contract, an agreement [n -S]\n",
  "CONTRATE": "of wheels [adj]\n",
  "CONTRATERRENE": "opposite in character to earthly or terrestrial [adj]\n",
  "CONTRATS": "CONTRAT, (French) a contract, an agreement [n]\n",
  "CONTRAVALLATION": "a fortification built around besieged place [n]\n",
  "CONTRAVENE": "to act counter to [v CONTRAVENED, CONTRAVENING, CONTRAVENES]\n",
  "CONTRAVENED": "CONTRAVENE, to act counter to [v]\n",
  "CONTRAVENER": "one who contravenes [n -S]\n",
  "CONTRAVENERS": "CONTRAVENER, one who contravenes [n]\n",
  "CONTRAVENES": "CONTRAVENE, to act counter to [v]\n",
  "CONTRAVENING": "CONTRAVENE, to act counter to [v]\n",
  "CONTRAVENTION": "the act of contravening [n -S]\n",
  "CONTRAVENTIONS": "CONTRAVENTION, the act of contravening [n]\n",
  "CONTRAYERVA": "a tropical American plant of the mulberry family, once believed to be an antidote to poisons [n -S]\n",
  "CONTRAYERVAS": "CONTRAYERVA, a tropical American plant of the mulberry family, once believed to be an antidote to poisons [n]\n",
  "CONTRECOUP": "(French) an injury, esp. to the brain within the skull, resulting from a blow on the side opposite to it [n -S]\n",
  "CONTRECOUPS": "CONTRECOUP, (French) an injury, esp. to the brain within the skull, resulting from a blow on the side opposite to it [n]\n",
  "CONTREDANCE": "a country dance, esp. a French version of the English country dance, also CONTRADANCE, CONTREDANSE [n -S]\n",
  "CONTREDANCES": "CONTREDANCE, a country dance, esp. a French version of the English country dance, also CONTRADANCE, CONTREDANSE [n]\n",
  "CONTREDANSE": "(French) a folk dance in which two lines of couples face each other, also CONTRADANCE, CONTREDANCE [n -S]\n",
  "CONTREDANSES": "CONTREDANSE, (French) a folk dance in which two lines of couples face each other, also CONTRADANCE, CONTREDANCE [n]\n",
  "CONTRETEMPS": "(French) an embarrassing occurrence; a mishap [n]\n",
  "CONTRIBUTABLE": "able to be contributed [adj]\n",
  "CONTRIBUTARIES": "CONTRIBUTARY, (obsolete) a person or thing that contributes, also CONTRIBUTORY [n]\n",
  "CONTRIBUTARY": "(obsolete) a person or thing that contributes, also CONTRIBUTORY [n CONTRIBUTARIES]\n",
  "CONTRIBUTE": "to give or supply in common with others [v CONTRIBUTED, CONTRIBUTING, CONTRIBUTES]\n",
  "CONTRIBUTED": "CONTRIBUTE, to give or supply in common with others [v]\n",
  "CONTRIBUTES": "CONTRIBUTE, to give or supply in common with others [v]\n",
  "CONTRIBUTING": "CONTRIBUTE, to give or supply in common with others [v]\n",
  "CONTRIBUTION": "the act of contributing [n -S]\n",
  "CONTRIBUTIONS": "CONTRIBUTION, the act of contributing [n]\n",
  "CONTRIBUTIVE": "relating to contribution [adj CONTRIBUTIVELY]\n",
  "CONTRIBUTIVELY": "CONTRIBUTIVE, relating to contribution [adv]\n",
  "CONTRIBUTOR": "one who contributes [n -S]\n",
  "CONTRIBUTORIES": "CONTRIBUTORY, (obsolete) a person or thing that contributes, also CONTRIBUTARY [n]\n",
  "CONTRIBUTORS": "CONTRIBUTOR, one who contributes [n]\n",
  "CONTRIBUTORY": "(obsolete) a person or thing that contributes, also CONTRIBUTARY [n CONTRIBUTORIES]\n",
  "CONTRIST": "(obsolete) to sadden [v -ED, -ING, -S]\n",
  "CONTRISTATION": "the act of contristing, saddening [n -S]\n",
  "CONTRISTATIONS": "CONTRISTATION, the act of contristing, saddening [n]\n",
  "CONTRISTED": "CONTRIST, (obsolete) to sadden [v]\n",
  "CONTRISTING": "CONTRIST, (obsolete) to sadden [v]\n",
  "CONTRISTS": "CONTRIST, (obsolete) to sadden [v]\n",
  "CONTRITE": "deeply sorry [adj CONTRITELY]\n",
  "CONTRITELY": "CONTRITE, deeply sorry [adv]\n",
  "CONTRITENESS": "the state of being contrite [n -ES]\n",
  "CONTRITENESSES": "CONTRITENESS, the state of being contrite [n]\n",
  "CONTRITION": "the state of being contrite [n -S]\n",
  "CONTRITIONS": "CONTRITION, the state of being contrite [n]\n",
  "CONTRITURATE": "to pulverize [v CONTRITURATED, CONTRITURATING, CONTRITURATES]\n",
  "CONTRITURATED": "CONTRITURATE, to pulverize [v]\n",
  "CONTRITURATES": "CONTRITURATE, to pulverize [v]\n",
  "CONTRITURATING": "CONTRITURATE, to pulverize [v]\n",
  "CONTRIVABLE": "that can be contrived [adj]\n",
  "CONTRIVANCE": "a thing contrived [n -S]\n",
  "CONTRIVANCES": "CONTRIVANCE, a thing contrived [n]\n",
  "CONTRIVE": "to devise [v CONTRIVED, CONTRIVING, CONTRIVES]\n",
  "CONTRIVED": "CONTRIVE, to devise [v]\n",
  "CONTRIVEMENT": "the act of contriving [n -S]\n",
  "CONTRIVEMENTS": "CONTRIVEMENT, the act of contriving [n]\n",
  "CONTRIVER": "one who contrives [n -S]\n",
  "CONTRIVERS": "CONTRIVER, one who contrives [n]\n",
  "CONTRIVES": "CONTRIVE, to devise [v]\n",
  "CONTRIVING": "CONTRIVE, to devise [v]\n",
  "CONTROL": "to exercise authority over, also CONTROUL [v CONTROLLED, CONTROLLING, CONTROLS]\n",
  "CONTROLE": "(French) registered, hallmarked [adj]\n",
  "CONTROLLABILITY": "the state of being controllable [n]\n",
  "CONTROLLABLE": "able to be controlled [adj CONTROLLABLY]\n",
  "CONTROLLABLY": "CONTROLLABLE, able to be controlled [adv]\n",
  "CONTROLLED": "CONTROL, to exercise authority over, also CONTROUL [v]\n",
  "CONTROLLER": "one who controls [n -S]\n",
  "CONTROLLERS": "CONTROLLER, one who controls [n]\n",
  "CONTROLLERSHIP": "the office of controller [n -S]\n",
  "CONTROLLERSHIPS": "CONTROLLERSHIP, the office of controller [n]\n",
  "CONTROLLING": "CONTROL, to exercise authority over, also CONTROUL [v]\n",
  "CONTROLMENT": "the act or power of controlling [n -S]\n",
  "CONTROLMENTS": "CONTROLMENT, the act or power of controlling [n]\n",
  "CONTROLS": "CONTROL, to exercise authority over, also CONTROUL [v]\n",
  "CONTROUL": "to exercise authority over, also CONTROL [v -ED, -ING, -S]\n",
  "CONTROULED": "CONTROUL, to exercise authority over, also CONTROL [v]\n",
  "CONTROULING": "CONTROUL, to exercise authority over, also CONTROL [v]\n",
  "CONTROULS": "CONTROUL, to exercise authority over, also CONTROL [v]\n",
  "CONTROVERSE": "(archaic) a dispute [n -S]\n",
  "CONTROVERSES": "CONTROVERSE, (archaic) a dispute [n]\n",
  "CONTROVERSIAL": "of, relating to, or arousing controversy [adj CONTROVERSIALLY]\n",
  "CONTROVERSIALLY": "CONTROVERSIAL, of, relating to, or arousing controversy [adv]\n",
  "CONTROVERSIES": "CONTROVERSY, the action of disputing or contending one with another [n]\n",
  "CONTROVERSY": "the action of disputing or contending one with another [n CONTROVERSIES]\n",
  "CONTROVERT": "to oppose; to argue against; to dispute [v -ED, -ING, -S]\n",
  "CONTROVERTED": "CONTROVERT, to oppose; to argue against; to dispute [v]\n",
  "CONTROVERTER": "one who controverts [n -S]\n",
  "CONTROVERTERS": "CONTROVERTER, one who controverts [n]\n",
  "CONTROVERTIBLE": "open to question, disputable [adj CONTROVERTIBLY]\n",
  "CONTROVERTIBLY": "CONTROVERTIBLE, open to question, disputable [adv]\n",
  "CONTROVERTING": "CONTROVERT, to oppose; to argue against; to dispute [v]\n",
  "CONTROVERTIST": "one who engages in controversy [n -S]\n",
  "CONTROVERTISTS": "CONTROVERTIST, one who engages in controversy [n]\n",
  "CONTROVERTS": "CONTROVERT, to oppose; to argue against; to dispute [v]\n",
  "CONTUBERNAL": "living or messing together; intimate, also CONTUBERNYAL [adj]\n",
  "CONTUBERNYAL": "(archaic) living or messing together; intimate, also CONTUBERNAL [adj]\n",
  "CONTUMACIES": "CONTUMACY, stubborn perverseness [n]\n",
  "CONTUMACIOUS": "stubbornly disobedient, rebellious [adj CONTUMACIOUSLY]\n",
  "CONTUMACIOUSLY": "CONTUMACIOUS, stubbornly disobedient, rebellious [adv]\n",
  "CONTUMACITIES": "CONTUMACITY, stubborn disobedience [n]\n",
  "CONTUMACITY": "stubborn disobedience [n CONTUMACITIES]\n",
  "CONTUMACY": "stubborn perverseness [n CONTUMACIES]\n",
  "CONTUMELIES": "CONTUMELY, contemptuous or insulting treatment arising from arrogance [n]\n",
  "CONTUMELIOUS": "haughtily insolent [adj CONTUMELIOUSLY]\n",
  "CONTUMELIOUSLY": "CONTUMELIOUS, haughtily insolent [adv]\n",
  "CONTUMELY": "contemptuous or insulting treatment arising from arrogance [n CONTUMELIES]\n",
  "CONTUND": "(archaic) to bruise or pound [v -ED, -ING, -S]\n",
  "CONTUNDED": "CONTUND, (archaic) to bruise or pound [v]\n",
  "CONTUNDING": "CONTUND, (archaic) to bruise or pound [v]\n",
  "CONTUNDS": "CONTUND, (archaic) to bruise or pound [v]\n",
  "CONTUSE": "to bruise [v CONTUSED, CONTUSING, CONTUSES]\n",
  "CONTUSED": "CONTUSE, to bruise [v]\n",
  "CONTUSES": "CONTUSE, to bruise [v]\n",
  "CONTUSING": "CONTUSE, to bruise [v]\n",
  "CONTUSION": "a bruise [n -S]\n",
  "CONTUSIONED": "having a contusion [adj]\n",
  "CONTUSIONS": "CONTUSION, a bruise [n]\n",
  "CONTUSIVE": "tending to bruise [adj]\n",
  "CONUNDRUM": "a riddle, esp. one whose answer is a play on words [n -S]\n",
  "CONUNDRUMS": "CONUNDRUM, a riddle, esp. one whose answer is a play on words [n]\n",
  "CONURBAN": "relating to a conurbation [adj]\n",
  "CONURBATION": "an aggregation or continuous network of urban communities [n -S]\n",
  "CONURBATIONS": "CONURBATION, an aggregation or continuous network of urban communities [n]\n",
  "CONURBIA": "conurbations considered as a class [n -S]\n",
  "CONURBIAS": "CONURBIA, conurbations considered as a class [n]\n",
  "CONURE": "a tropical finch [n -S]\n",
  "CONURES": "CONURE, a tropical finch [n]\n",
  "CONUS": "(Latin) a structure or organ resembling a cone [n CONI]\n",
  "CONVALESCE": "to recover health and strength gradually after sickness or weakness [v CONVALESCED, CONVALESCING, CONVALESCES]\n",
  "CONVALESCED": "CONVALESCE, to recover health and strength gradually after sickness or weakness [v]\n",
  "CONVALESCENCE": "recovery from illness, also CONVALESCENCY [n -S]\n",
  "CONVALESCENCES": "CONVALESCENCE, recovery from illness, also CONVALESCENCY [n]\n",
  "CONVALESCENCIES": "CONVALESCENCY, recovery from illness, also CONVALESCENCE [n]\n",
  "CONVALESCENCY": "recovery from illness, also CONVALESCENCE [n CONVALESCENCIES]\n",
  "CONVALESCENT": "recovering [adj CONVALESCENTLY] / one who is recovering [n -S]\n",
  "CONVALESCENTLY": "CONVALESCENT, recovering [adv]\n",
  "CONVALESCENTS": "CONVALESCENT, one who is recovering [n]\n",
  "CONVALESCES": "CONVALESCE, to recover health and strength gradually after sickness or weakness [v]\n",
  "CONVALESCING": "CONVALESCE, to recover health and strength gradually after sickness or weakness [v]\n",
  "CONVECT": "to transfer heat by circulation [v -ED, -ING, -S]\n",
  "CONVECTED": "CONVECT, to transfer heat by circulation [v]\n",
  "CONVECTING": "CONVECT, to transfer heat by circulation [v]\n",
  "CONVECTION": "the act of conveying [n -S]\n",
  "CONVECTIONAL": "relating to convection, also CONVECTIVE [adj]\n",
  "CONVECTIONS": "CONVECTION, the act of conveying [n]\n",
  "CONVECTIVE": "relating to convection, also CONVECTIONAL [adj]\n",
  "CONVECTOR": "an apparatus for heating by convection [n -S]\n",
  "CONVECTORS": "CONVECTOR, an apparatus for heating by convection [n]\n",
  "CONVECTS": "CONVECT, to transfer heat by circulation [v]\n",
  "CONVENABLE": "capable of being convened or assembled [adj]\n",
  "CONVENANCE": "(French) that which is suitable, agreeable, or convenient [n -S]\n",
  "CONVENANCES": "CONVENANCE, (French) that which is suitable, agreeable, or convenient [n]\n",
  "CONVENE": "to assemble, also CONVENT [v CONVENED, CONVENING, CONVENES]\n",
  "CONVENED": "CONVENE, to assemble, also CONVENT [v]\n",
  "CONVENER": "one who convenes, also CONVENOR [n -S]\n",
  "CONVENERS": "CONVENER, one who convenes, also CONVENOR [n]\n",
  "CONVENERSHIP": "the office of convener [n -S]\n",
  "CONVENERSHIPS": "CONVENERSHIP, the office of convener [n]\n",
  "CONVENES": "CONVENE, to assemble, also CONVENT [v]\n",
  "CONVENIENCE": "fitness for performing an action or fulfilling a requirement, also CONVENIENCY [n -S]\n",
  "CONVENIENCES": "CONVENIENCE, fitness for performing an action or fulfilling a requirement, also CONVENIENCY [n]\n",
  "CONVENIENCIES": "CONVENIENCY, fitness for performing an action or fulfilling a requirement, also CONVENIENCE [n]\n",
  "CONVENIENCY": "fitness for performing an action or fulfilling a requirement, also CONVENIENCE [n CONVENIENCIES]\n",
  "CONVENIENT": "suited to personal comfort or to easy performance [adj CONVENIENTLY]\n",
  "CONVENIENTLY": "CONVENIENT, suited to personal comfort or to easy performance [adv]\n",
  "CONVENING": "the act of calling together [n -S]\n",
  "CONVENINGS": "CONVENING, the act of calling together [n]\n",
  "CONVENOR": "one who convenes, also CONVENER [n -S]\n",
  "CONVENORS": "CONVENOR, one who convenes, also CONVENER [n]\n",
  "CONVENORSHIP": "the office of convenor [n -S]\n",
  "CONVENORSHIPS": "CONVENORSHIP, the office of convenor [n]\n",
  "CONVENT": "to assemble, also CONVENE [v -ED, -ING, -S]\n",
  "CONVENTED": "CONVENT, to assemble, also CONVENE [v]\n",
  "CONVENTICLE": "an assembly for religious worship, esp. a secret meeting for worship not sanctioned by law [n -S] / to hold such an assembly [v CONVENTICLED, CONVENTICLING, CONVENTICLES]\n",
  "CONVENTICLED": "CONVENTICLE, to hold such an assembly [v]\n",
  "CONVENTICLER": "a member of a conventicle [n -S]\n",
  "CONVENTICLERS": "CONVENTICLER, a member of a conventicle [n]\n",
  "CONVENTICLES": "CONVENTICLE, an assembly for religious worship, esp. a secret meeting for worship not sanctioned by law [n]\n",
  "CONVENTICLING": "CONVENTICLE, to hold such an assembly [v]\n",
  "CONVENTING": "CONVENT, to assemble, also CONVENE [v]\n",
  "CONVENTION": "an established usage [n -S]\n",
  "CONVENTIONAL": "formed by agreement or compact [adj CONVENTIONALLY] / in bridge, a convention, an agreed method of bidding [n -S]\n",
  "CONVENTIONALISE": "to make conventional, also CONVENTIONALIZE [v]\n",
  "CONVENTIONALISM": "the state of being conventional [n]\n",
  "CONVENTIONALIST": "one who is conventional [n]\n",
  "CONVENTIONALITY": "a conventional usage, practice, or thing [n]\n",
  "CONVENTIONALIZE": "to make conventional, also CONVENTIONALISE [v]\n",
  "CONVENTIONALLY": "CONVENTIONAL, formed by agreement or compact [adv]\n",
  "CONVENTIONALS": "CONVENTIONAL, in bridge, a convention, an agreed method of bidding [n]\n",
  "CONVENTIONARY": "acting under contract [adj]\n",
  "CONVENTIONEER": "a person attending a convention, also CONVENTIONER [n -S]\n",
  "CONVENTIONEERS": "CONVENTIONEER, a person attending a convention, also CONVENTIONER [n]\n",
  "CONVENTIONER": "a person who attends a convention, also CONVENTIONEER [n -S]\n",
  "CONVENTIONERS": "CONVENTIONER, a person who attends a convention, also CONVENTIONEER [n]\n",
  "CONVENTIONIST": "one who attends a convention [n -S]\n",
  "CONVENTIONISTS": "CONVENTIONIST, one who attends a convention [n]\n",
  "CONVENTIONS": "CONVENTION, an established usage [n]\n",
  "CONVENTS": "CONVENT, to assemble, also CONVENE [v]\n",
  "CONVENTUAL": "of or pertaining to a convent [adj CONVENTUALLY] / a monk or nun [n -S]\n",
  "CONVENTUALLY": "CONVENTUAL, of or pertaining to a convent [adv]\n",
  "CONVENTUALS": "CONVENTUAL, a monk or nun [n]\n",
  "CONVERGE": "to come together [v CONVERGED, CONVERGING, CONVERGES]\n",
  "CONVERGED": "CONVERGE, to come together [v]\n",
  "CONVERGENCE": "the state of being convergent, also CONVERGENCY [n -S]\n",
  "CONVERGENCES": "CONVERGENCE, the state of being convergent, also CONVERGENCY [n]\n",
  "CONVERGENCIES": "CONVERGENCY, the state of being convergent, also CONVERGENCE [n]\n",
  "CONVERGENCY": "the state of being convergent, also CONVERGENCE [n CONVERGENCIES]\n",
  "CONVERGENT": "tending to move toward one point or to approach each other [adj]\n",
  "CONVERGES": "CONVERGE, to come together [v]\n",
  "CONVERGING": "CONVERGE, to come together [v]\n",
  "CONVERSABLE": "able to be conversed with [adj CONVERSABLY]\n",
  "CONVERSABLENESS": "the state of being conversable [n]\n",
  "CONVERSABLY": "CONVERSABLE, able to be conversed with [adv]\n",
  "CONVERSANCE": "the state of being conversant, also CONVERSANCY [n -S]\n",
  "CONVERSANCES": "CONVERSANCE, the state of being conversant, also CONVERSANCY [n]\n",
  "CONVERSANCIES": "CONVERSANCY, the state of being conversant, also CONVERSANCE [n]\n",
  "CONVERSANCY": "the state of being conversant, also CONVERSANCE [n CONVERSANCIES]\n",
  "CONVERSANT": "having knowledge or experience [adj CONVERSANTLY]\n",
  "CONVERSANTLY": "CONVERSANT, having knowledge or experience [adv]\n",
  "CONVERSATION": "communication by talking [n -S]\n",
  "CONVERSATIONAL": "relating to conversation [adj]\n",
  "CONVERSATIONISM": "a colloquialism [n]\n",
  "CONVERSATIONIST": "a person who enjoys or excels in conversation [n]\n",
  "CONVERSATIONS": "CONVERSATION, communication by talking [n]\n",
  "CONVERSATIVE": "ready to talk [adj]\n",
  "CONVERSAZIONE": "(Italian) a meeting for conversation esp. about art, literature, or science [n CONVERSAZIONI or CONVERSAZIONES]\n",
  "CONVERSAZIONES": "CONVERSAZIONE, (Italian) a meeting for conversation esp. about art, literature, or science [n]\n",
  "CONVERSAZIONI": "CONVERSAZIONE, (Italian) a meeting for conversation esp. about art, literature, or science [n]\n",
  "CONVERSE": "reversed, opposite [adj CONVERSELY] / to speak together [v CONVERSED, CONVERSING, CONVERSES]\n",
  "CONVERSED": "CONVERSE, to speak together [v]\n",
  "CONVERSELY": "CONVERSE, reversed, opposite [adv]\n",
  "CONVERSER": "one who engages in conversation [n -S]\n",
  "CONVERSERS": "CONVERSER, one who engages in conversation [n]\n",
  "CONVERSES": "CONVERSE, to speak together [v]\n",
  "CONVERSING": "CONVERSE, to speak together [v]\n",
  "CONVERSION": "the act of converting [n -S]\n",
  "CONVERSIONAL": "relating to conversion, also CONVERSIONARY [adj]\n",
  "CONVERSIONARY": "relating to conversion, also CONVERSIONAL [adj]\n",
  "CONVERSIONS": "CONVERSION, the act of converting [n]\n",
  "CONVERSO": "(Spanish) a mediaeval Spanish Jew converting to Catholicism [n -S]\n",
  "CONVERSOS": "CONVERSO, (Spanish) a mediaeval Spanish Jew converting to Catholicism [n]\n",
  "CONVERT": "to change into another form [v -ED, -ING, -S]\n",
  "CONVERTAPLANE": "an aircraft that can land and take off vertically by temporarily directing its propulsive thrust downwards, also CONVERTIPLANE, CONVERTOPLANE [n -S]\n",
  "CONVERTAPLANES": "CONVERTAPLANE, an aircraft that can land and take off vertically by temporarily directing its propulsive thrust downwards, also CONVERTIPLANE, CONVERTOPLANE [n]\n",
  "CONVERTED": "CONVERT, to change into another form [v]\n",
  "CONVERTEND": "in logic, the proposition as it stands before conversion [n -S]\n",
  "CONVERTENDS": "CONVERTEND, in logic, the proposition as it stands before conversion [n]\n",
  "CONVERTER": "something or someone that converts, also CONVERTOR [n -S]\n",
  "CONVERTERS": "CONVERTER, something or someone that converts, also CONVERTOR [n]\n",
  "CONVERTIBILITY": "the state of being convertible [n]\n",
  "CONVERTIBLE": "that can be converted [adj CONVERTIBLY] / a car with a folding top [n -S]\n",
  "CONVERTIBLENESS": "the state of being convertible [n]\n",
  "CONVERTIBLES": "CONVERTIBLE, a car with a folding top [n]\n",
  "CONVERTIBLY": "CONVERTIBLE, that can be converted [adv]\n",
  "CONVERTING": "CONVERT, to change into another form [v]\n",
  "CONVERTIPLANE": "an aircraft that can land and take off vertically by temporarily directing its propulsive thrust downwards, also CONVERTAPLANE, CONVERTOPLANE [n -S]\n",
  "CONVERTIPLANES": "CONVERTIPLANE, an aircraft that can land and take off vertically by temporarily directing its propulsive thrust downwards, also CONVERTAPLANE, CONVERTOPLANE [n]\n",
  "CONVERTITE": "(archaic) a convert; a reformed prostitute [n -S]\n",
  "CONVERTITES": "CONVERTITE, (archaic) a convert; a reformed prostitute [n]\n",
  "CONVERTIVE": "relating to conversion [adj]\n",
  "CONVERTOPLANE": "an aircraft that can land and take off vertically by temporarily directing its propulsive thrust downwards, also CONVERTAPLANE, CONVERTIPLANE [n -S]\n",
  "CONVERTOPLANES": "CONVERTOPLANE, an aircraft that can land and take off vertically by temporarily directing its propulsive thrust downwards, also CONVERTAPLANE, CONVERTIPLANE [n]\n",
  "CONVERTOR": "something or someone that converts, also CONVERTER [n -S]\n",
  "CONVERTORS": "CONVERTOR, something or someone that converts, also CONVERTER [n]\n",
  "CONVERTS": "CONVERT, to change into another form [v]\n",
  "CONVEX": "having an outline or surface curved like the exterior of a circle or sphere [adj CONVEXLY] / to make convex [v -ED, -ING, -ES]\n",
  "CONVEXED": "CONVEX, to make convex [v]\n",
  "CONVEXEDLY": "CONVEXED, CONVEX, to make convex [adv]\n",
  "CONVEXES": "CONVEX, to make convex [v]\n",
  "CONVEXING": "CONVEX, to make convex [v]\n",
  "CONVEXITIES": "CONVEXITY, the state of being convex [n]\n",
  "CONVEXITY": "the state of being convex [n CONVEXITIES]\n",
  "CONVEXLY": "CONVEX, having an outline or surface curved like the exterior of a circle or sphere [adv]\n",
  "CONVEXNESS": "the state of being convex [n -ES]\n",
  "CONVEXNESSES": "CONVEXNESS, the state of being convex [n]\n",
  "CONVEY": "to transport [v -ED, -ING, -S]\n",
  "CONVEYABLE": "capable of being conveyed or transferred [adj]\n",
  "CONVEYAL": "a transmission [n -S]\n",
  "CONVEYALS": "CONVEYAL, a transmission [n]\n",
  "CONVEYANCE": "an instrument by which title to property is conveyed [n -S]\n",
  "CONVEYANCER": "one whose business is conveyancing [n -S]\n",
  "CONVEYANCERS": "CONVEYANCER, one whose business is conveyancing [n]\n",
  "CONVEYANCES": "CONVEYANCE, an instrument by which title to property is conveyed [n]\n",
  "CONVEYANCING": "the act or business of drawing deeds [n -S]\n",
  "CONVEYANCINGS": "CONVEYANCING, the act or business of drawing deeds [n]\n",
  "CONVEYED": "CONVEY, to transport [v]\n",
  "CONVEYER": "one that conveys, also CONVEYOR [n -S]\n",
  "CONVEYERS": "CONVEYER, one that conveys, also CONVEYOR [n]\n",
  "CONVEYING": "CONVEY, to transport [v]\n",
  "CONVEYOR": "one that conveys, also CONVEYER [n -S]\n",
  "CONVEYORISATION": "the process of conveyorising, also CONVEYORIZATION [n]\n",
  "CONVEYORISE": "to equip with a conveyor, also CONVEYORIZE [v CONVEYORISED, CONVEYORISING, CONVEYORISES]\n",
  "CONVEYORISED": "CONVEYORISE, to equip with a conveyor, also CONVEYORIZE [v]\n",
  "CONVEYORISES": "CONVEYORISE, to equip with a conveyor, also CONVEYORIZE [v]\n",
  "CONVEYORISING": "CONVEYORISE, to equip with a conveyor, also CONVEYORIZE [v]\n",
  "CONVEYORIZATION": "the process of conveyorizing, also CONVEYORISATION [n]\n",
  "CONVEYORIZE": "to equip with a conveyor, also CONVEYORISE [v CONVEYORIZED, CONVEYORIZING, CONVEYORIZES]\n",
  "CONVEYORIZED": "CONVEYORIZE, to equip with a conveyor, also CONVEYORISE [v]\n",
  "CONVEYORIZES": "CONVEYORIZE, to equip with a conveyor, also CONVEYORISE [v]\n",
  "CONVEYORIZING": "CONVEYORIZE, to equip with a conveyor, also CONVEYORISE [v]\n",
  "CONVEYORS": "CONVEYOR, one that conveys, also CONVEYER [n]\n",
  "CONVEYS": "CONVEY, to transport [v]\n",
  "CONVICINITIES": "CONVICINITY, a neighbourhood [n]\n",
  "CONVICINITY": "a neighbourhood [n CONVICINITIES]\n",
  "CONVICT": "to prove guilty [v -ED, -ING, -S]\n",
  "CONVICTABLE": "that can be convicted, also CONVICTIBLE [adj]\n",
  "CONVICTED": "CONVICT, to prove guilty [v]\n",
  "CONVICTIBLE": "that can be convicted, also CONVICTABLE [adj]\n",
  "CONVICTING": "CONVICT, to prove guilty [v]\n",
  "CONVICTION": "the act of convicting of a crime esp. in a court of law [n -S]\n",
  "CONVICTIONAL": "relating to conviction [adj]\n",
  "CONVICTIONS": "CONVICTION, the act of convicting of a crime esp. in a court of law [n]\n",
  "CONVICTISM": "the policy or practice of transporting convicts to penal settlements [n -S]\n",
  "CONVICTISMS": "CONVICTISM, the policy or practice of transporting convicts to penal settlements [n]\n",
  "CONVICTIVE": "convincing [adj CONVICTIVELY]\n",
  "CONVICTIVELY": "CONVICTIVE, convincing [adv]\n",
  "CONVICTS": "CONVICT, to prove guilty [v]\n",
  "CONVINCE": "to satisfy as to truth or error [v CONVINCED, CONVINCING, CONVINCES]\n",
  "CONVINCED": "CONVINCE, to satisfy as to truth or error [v]\n",
  "CONVINCEMENT": "(obsolete) conviction [n -S]\n",
  "CONVINCEMENTS": "CONVINCEMENT, (obsolete) conviction [n]\n",
  "CONVINCER": "one who, or that which, convinces [n -S]\n",
  "CONVINCERS": "CONVINCER, one who, or that which, convinces [n]\n",
  "CONVINCES": "CONVINCE, to satisfy as to truth or error [v]\n",
  "CONVINCIBLE": "that can be convinced [adj]\n",
  "CONVINCING": "CONVINCE, to satisfy as to truth or error [v]\n",
  "CONVINCINGLY": "CONVINCING, CONVINCE, to satisfy as to truth or error [adv]\n",
  "CONVINCINGNESS": "the state of being convincing [n]\n",
  "CONVIVE": "to feast together [v CONVIVED, CONVIVING, CONVIVES]\n",
  "CONVIVED": "CONVIVE, to feast together [v]\n",
  "CONVIVES": "CONVIVE, to feast together [v]\n",
  "CONVIVIAL": "relating to or fond of feasting, drinking, and good company [adj CONVIVIALLY]\n",
  "CONVIVIALIST": "one who likes to be convivial [n -S]\n",
  "CONVIVIALISTS": "CONVIVIALIST, one who likes to be convivial [n]\n",
  "CONVIVIALITIES": "CONVIVIALITY, the state of being convivial [n]\n",
  "CONVIVIALITY": "the state of being convivial [n CONVIVIALITIES]\n",
  "CONVIVIALLY": "CONVIVIAL, relating to or fond of feasting, drinking, and good company [adv]\n",
  "CONVIVING": "CONVIVE, to feast together [v]\n",
  "CONVO": "(Australian colloquial) a conversation [n -S]\n",
  "CONVOCATE": "to convoke; to call together [v CONVOCATED, CONVOCATING, CONVOCATES]\n",
  "CONVOCATED": "CONVOCATE, to convoke; to call together [v]\n",
  "CONVOCATES": "CONVOCATE, to convoke; to call together [v]\n",
  "CONVOCATING": "CONVOCATE, to convoke; to call together [v]\n",
  "CONVOCATION": "an assembly of persons convoked [n -S]\n",
  "CONVOCATIONAL": "relating to convocation [adj]\n",
  "CONVOCATIONIST": "one who takes part in a convocation [n -S]\n",
  "CONVOCATIONISTS": "CONVOCATIONIST, one who takes part in a convocation [n]\n",
  "CONVOCATIONS": "CONVOCATION, an assembly of persons convoked [n]\n",
  "CONVOCATIVE": "relating to convocation [adj]\n",
  "CONVOCATOR": "one who holds a convocation [n -S]\n",
  "CONVOCATORS": "CONVOCATOR, one who holds a convocation [n]\n",
  "CONVOKE": "to cause to assemble [v CONVOKED, CONVOKING, CONVOKES]\n",
  "CONVOKED": "CONVOKE, to cause to assemble [v]\n",
  "CONVOKER": "one who convokes [n -S]\n",
  "CONVOKERS": "CONVOKER, one who convokes [n]\n",
  "CONVOKES": "CONVOKE, to cause to assemble [v]\n",
  "CONVOKING": "CONVOKE, to cause to assemble [v]\n",
  "CONVOLUTE": "rolled together, coiled [adj CONVOLUTELY] / to twist, coil [v CONVOLUTED, CONVOLUTING, CONVOLUTES]\n",
  "CONVOLUTED": "CONVOLUTE, to twist, coil [v]\n",
  "CONVOLUTEDLY": "CONVOLUTED, CONVOLUTE, to twist, coil [adv]\n",
  "CONVOLUTEDNESS": "the state of being convoluted [n]\n",
  "CONVOLUTELY": "CONVOLUTE, rolled together, coiled [adv]\n",
  "CONVOLUTES": "CONVOLUTE, to twist, coil [v]\n",
  "CONVOLUTING": "CONVOLUTE, to twist, coil [v]\n",
  "CONVOLUTION": "a form or shape that is folded in curved or tortuous windings [n -S]\n",
  "CONVOLUTIONAL": "of or like convolution [adj]\n",
  "CONVOLUTIONARY": "of or like convolution [adj]\n",
  "CONVOLUTIONS": "CONVOLUTION, a form or shape that is folded in curved or tortuous windings [n]\n",
  "CONVOLVE": "to roll together [v CONVOLVED, CONVOLVING, CONVOLVES]\n",
  "CONVOLVED": "CONVOLVE, to roll together [v]\n",
  "CONVOLVES": "CONVOLVE, to roll together [v]\n",
  "CONVOLVING": "CONVOLVE, to roll together [v]\n",
  "CONVOLVULACEOUS": "belonging to the genus Convulvulaceae, that includes bindweed [adj]\n",
  "CONVOLVULI": "CONVOLVULUS, (Latin) a genus of climbing plants [n]\n",
  "CONVOLVULUS": "(Latin) a genus of climbing plants [n CONVOLVULUSES or CONVOLVULI]\n",
  "CONVOLVULUSES": "CONVOLVULUS, (Latin) a genus of climbing plants [n]\n",
  "CONVOS": "CONVO, (Australian colloquial) a conversation [n]\n",
  "CONVOY": "to accompany (ships etc.); to escort [v -ED, -ING, -S]\n",
  "CONVOYED": "CONVOY, to accompany (ships etc.); to escort [v]\n",
  "CONVOYING": "CONVOY, to accompany (ships etc.); to escort [v]\n",
  "CONVOYS": "CONVOY, to accompany (ships etc.); to escort [v]\n",
  "CONVULSANT": "an agent, esp. a drug, that causes convulsions [n -S]\n",
  "CONVULSANTS": "CONVULSANT, an agent, esp. a drug, that causes convulsions [n]\n",
  "CONVULSE": "to shake violently [v CONVULSED, CONVULSING, CONVULSES]\n",
  "CONVULSED": "CONVULSE, to shake violently [v]\n",
  "CONVULSES": "CONVULSE, to shake violently [v]\n",
  "CONVULSIBLE": "subject to convulsion [adj]\n",
  "CONVULSING": "CONVULSE, to shake violently [v]\n",
  "CONVULSION": "an abnormal violent and involuntary contraction or series of contractions of the muscles [n -S]\n",
  "CONVULSIONAL": "of or like convulsion [adj]\n",
  "CONVULSIONARIES": "CONVULSIONARY, a person who has convulsions, esp. one of a fanatical sect of Jansenists in eighteenth century France [n]\n",
  "CONVULSIONARY": "a person who has convulsions, esp. one of a fanatical sect of Jansenists in eighteenth century France [n CONVULSIONARIES]\n",
  "CONVULSIONIST": "a religious convulsionary; a believer in the importance of convulsions in geological history [n -S]\n",
  "CONVULSIONISTS": "CONVULSIONIST, a religious convulsionary; a believer in the importance of convulsions in geological history [n]\n",
  "CONVULSIONS": "CONVULSION, an abnormal violent and involuntary contraction or series of contractions of the muscles [n]\n",
  "CONVULSIVE": "constituting or producing a convulsion [adj CONVULSIVELY]\n",
  "CONVULSIVELY": "CONVULSIVE, constituting or producing a convulsion [adv]\n",
  "CONVULSIVENESS": "CONVULSIVE, constituting or producing a convulsion [n]\n",
  "CONWOMAN": "a (female) confidence trickster [n CONWOMEN]\n",
  "CONWOMEN": "CONWOMAN, a (female) confidence trickster [n]\n",
  "CONY": "a rabbit, also CONEY [n CONIES]\n",
  "COO": "to make the sound of a dove [v -ED, -ING, -S]\n",
  "COOCH": "a sinuous dance [n -ES]\n",
  "COOCHES": "COOCH, a sinuous dance [n]\n",
  "COOCOO": "(colloquial) crazy [adj]\n",
  "COOED": "COO, to make the sound of a dove [v]\n",
  "COOEE": "to cry out shrilly, also COOEY [v COOEED, COOEEING, COOEES]\n",
  "COOEED": "COOEE, to cry out shrilly, also COOEY [v]\n",
  "COOEEING": "COOEE, to cry out shrilly, also COOEY [v]\n",
  "COOEES": "COOEE, to cry out shrilly, also COOEY [v]\n",
  "COOER": "one that coos [n -S]\n",
  "COOERS": "COOER, one that coos [n]\n",
  "COOEY": "to cry out shrilly, also COOEE [v -ED, -ING, -S]\n",
  "COOEYED": "COOEY, to cry out shrilly, also COOEE [v]\n",
  "COOEYING": "COOEY, to cry out shrilly, also COOEE [v]\n",
  "COOEYS": "COOEY, to cry out shrilly, also COOEE [v]\n",
  "COOF": "(Scots) a dolt, also CUIF [n -S]\n",
  "COOFS": "COOF, (Scots) a dolt, also CUIF [n]\n",
  "COOING": "making a cooing noise [adj COOINGLY] / a cooing noise [n -S]\n",
  "COOINGLY": "affectionately [adv]\n",
  "COOINGS": "COOING, a cooing noise [n]\n",
  "COOK": "to prepare food by heating [v -ED, -ING, -S]\n",
  "COOKABLE": "something that can be cooked [n -S]\n",
  "COOKABLES": "COOKABLE, something that can be cooked [n]\n",
  "COOKBOOK": "a book of recipes [n -S]\n",
  "COOKBOOKS": "COOKBOOK, a book of recipes [n]\n",
  "COOKED": "COOK, to prepare food by heating [v]\n",
  "COOKER": "one that cooks [n -S]\n",
  "COOKERIES": "COOKERY, the art of cooking [n]\n",
  "COOKERS": "COOKER, one that cooks [n]\n",
  "COOKERY": "the art of cooking [n COOKERIES]\n",
  "COOKEY": "a small flat cake, also COOKIE, COOKY [n -S]\n",
  "COOKEYS": "COOKEY, a small flat cake, also COOKIE, COOKY [n]\n",
  "COOKHOUSE": "a place where cooking is carried out [n -S]\n",
  "COOKHOUSES": "COOKHOUSE, a place where cooking is carried out [n]\n",
  "COOKIE": "a small flat cake, also COOKEY, COOKY [n -S]\n",
  "COOKIES": "COOKIE, a small flat cake, also COOKEY, COOKY [n]\n",
  "COOKING": "the act of one that cooks [n -S]\n",
  "COOKINGS": "COOKING, the act of one that cooks [n]\n",
  "COOKLESS": "without a cook [adj]\n",
  "COOKMAID": "a maid who cooks [n -S]\n",
  "COOKMAIDS": "COOKMAID, a maid who cooks [n]\n",
  "COOKOFF": "a cooking contest [n -S]\n",
  "COOKOFFS": "COOKOFF, a cooking contest [n]\n",
  "COOKOUT": "a meal eaten and prepared outdoors [n -S]\n",
  "COOKOUTS": "COOKOUT, a meal eaten and prepared outdoors [n]\n",
  "COOKROOM": "a room used for cooking [n -S]\n",
  "COOKROOMS": "COOKROOM, a room used for cooking [n]\n",
  "COOKS": "COOK, to prepare food by heating [v]\n",
  "COOKSHACK": "a shack used for cooking [n -S]\n",
  "COOKSHACKS": "COOKSHACK, a shack used for cooking [n]\n",
  "COOKSHOP": "a shop that sells cooked food [n -S]\n",
  "COOKSHOPS": "COOKSHOP, a shop that sells cooked food [n]\n",
  "COOKSTOVE": "a stove used for cooking [n -S]\n",
  "COOKSTOVES": "COOKSTOVE, a stove used for cooking [n]\n",
  "COOKTOP": "a type of cooking apparatus [n -S]\n",
  "COOKTOPS": "COOKTOP, a type of cooking apparatus [n]\n",
  "COOKWARE": "utensils used in cooking [n -S]\n",
  "COOKWARES": "COOKWARE, utensils used in cooking [n]\n",
  "COOKY": "a small flat cake, also COOKIE, COOKEY [n COOKIES]\n",
  "COOL": "to lower the temperature of [v -ED, -ING, -S] / moderately cold [adj COOLER, COOLEST, COOLLY]\n",
  "COOLABAH": "(Native Australian) a type of tree, also COOLIBAH, COOLIBAR [n -S]\n",
  "COOLABAHS": "COOLABAH, (Native Australian) a type of tree, also COOLIBAH, COOLIBAR [n]\n",
  "COOLAMON": "(Native Australian) a shallow vessel made of wood or bark used by Australian aborigines to hold water etc. [n -S]\n",
  "COOLAMONS": "COOLAMON, (Native Australian) a shallow vessel made of wood or bark used by Australian aborigines to hold water etc. [n]\n",
  "COOLANT": "a cooling agent; a fluid used to cool e.g. a car engine [n -S]\n",
  "COOLANTS": "COOLANT, a cooling agent; a fluid used to cool e.g. a car engine [n]\n",
  "COOLDOWN": "a period after exertion to resume normal heartbeat [n -S]\n",
  "COOLDOWNS": "COOLDOWN, a period after exertion to resume normal heartbeat [n]\n",
  "COOLED": "COOL, to lower the temperature of [v]\n",
  "COOLER": "(colloquial) a prison [n -S]\n",
  "COOLERS": "COOLER, (colloquial) a prison [n]\n",
  "COOLEST": "COOL, moderately cold [adj]\n",
  "COOLHEADED": "not easily excited [adj]\n",
  "COOLHOUSE": "a greenhouse kept at a cool temperature [n -S]\n",
  "COOLHOUSES": "COOLHOUSE, a greenhouse kept at a cool temperature [n]\n",
  "COOLIBAH": "(Native Australian) a species of Australian eucalyptus tree, also COOLABAH, COOLIBAR [n -S]\n",
  "COOLIBAHS": "COOLIBAH, (Native Australian) a species of Australian eucalyptus tree, also COOLABAH, COOLIBAR [n]\n",
  "COOLIBAR": "(Native Australian) a species of Australian eucalyptus tree, also COOLABAH, COOLIBAH [n -S]\n",
  "COOLIBARS": "COOLIBAR, (Native Australian) a species of Australian eucalyptus tree, also COOLABAH, COOLIBAH [n]\n",
  "COOLIE": "(historical) a (non-European) hired labourer or burden-carrier in India, China, and elsewhere, also COOLY [n -S]\n",
  "COOLIES": "COOLIE, (historical) a (non-European) hired labourer or burden-carrier in India, China, and elsewhere, also COOLY [n]\n",
  "COOLING": "serving to cool [adj COOLINGLY] / the act of cooling [n -S]\n",
  "COOLINGLY": "COOLING, serving to cool [adv]\n",
  "COOLINGNESS": "the state of being cooling [n -ES]\n",
  "COOLINGNESSES": "COOLINGNESS, the state of being cooling [n]\n",
  "COOLINGS": "COOLING, the act of cooling [n]\n",
  "COOLISH": "somewhat cool [adj]\n",
  "COOLIST": "a person, esp. a scientist, who does not believe in global warming and the greenhouse effect [n -S]\n",
  "COOLISTS": "COOLIST, a person, esp. a scientist, who does not believe in global warming and the greenhouse effect [n]\n",
  "COOLLY": "COOL, moderately cold [adv]\n",
  "COOLNESS": "the state of being cool [n -ES]\n",
  "COOLNESSES": "COOLNESS, the state of being cool [n]\n",
  "COOLS": "COOL, to lower the temperature of [v]\n",
  "COOLTH": "the state of being cool [n -S]\n",
  "COOLTHS": "COOLTH, the state of being cool [n]\n",
  "COOLY": "(historical) a (non-European) hired labourer or burden-carrier in India, China, and elsewhere, also COOLIE [n COOLIES]\n",
  "COOM": "to begrime with coaldust [v -ED, -ING, -S]\n",
  "COOMB": "a short deep valley, also COMBE, COOMBE [n -S]\n",
  "COOMBE": "a short deep valley, also COMBE, COOMB [n -S]\n",
  "COOMBES": "COOMBE, a short deep valley, also COMBE, COOMB [n]\n",
  "COOMBS": "COOMB, a short deep valley, also COMBE, COOMBE [n]\n",
  "COOMCEILED": "said of an attic room with the inside ceiling sloping from the wall [adj]\n",
  "COOMED": "COOM, to begrime with coaldust [v]\n",
  "COOMIER": "COOMY, full of coom, soot; coal dust [adj]\n",
  "COOMIEST": "COOMY, full of coom, soot; coal dust [adj]\n",
  "COOMING": "COOM, to begrime with coaldust [v]\n",
  "COOMS": "COOM, to begrime with coaldust [v]\n",
  "COOMY": "full of coom, soot; coal dust [adj COOMIER, COOMIEST]\n",
  "COON": "a raccoon [n -S]\n",
  "COONCAN": "a card game, also CONQUIAN [n -S]\n",
  "COONCANS": "COONCAN, a card game, also CONQUIAN [n]\n",
  "COONDOG": "a dog trained to hunt raccoons, also COONHOUND [n -S]\n",
  "COONDOGS": "COONDOG, a dog trained to hunt raccoons, also COONHOUND [n]\n",
  "COONHOUND": "a dog trained to hunt raccoons, also COONDOG [n -S]\n",
  "COONHOUNDS": "COONHOUND, a dog trained to hunt raccoons, also COONDOG [n]\n",
  "COONS": "COON, a raccoon [n]\n",
  "COONSHIT": "(offensive) a malodorous black person [n -S]\n",
  "COONSHITS": "COONSHIT, (offensive) a malodorous black person [n]\n",
  "COONSKIN": "the skin of a raccoon, esp. as used to make a cap [n -S]\n",
  "COONSKINS": "COONSKIN, the skin of a raccoon, esp. as used to make a cap [n]\n",
  "COONTIE": "(Native American) an American plant related to the cycads, also COONTY [n -S]\n",
  "COONTIES": "COONTIE, (Native American) an American plant related to the cycads, also COONTY [n]\n",
  "COONTY": "(Native American) an American plant related to the cycads, also COONTIE [n COONTIES]\n",
  "COOP": "to confine [v -ED, -ING, -S]\n",
  "COOPED": "COOP, to confine [v]\n",
  "COOPER": "to make barrels [v -ED, -ING, -S]\n",
  "COOPERAGE": "work done by a cooper [n -S]\n",
  "COOPERAGES": "COOPERAGE, work done by a cooper [n]\n",
  "COOPERATE": "to work together [v COOPERATED, COOPERATING, COOPERATES]\n",
  "COOPERATED": "COOPERATE, to work together [v]\n",
  "COOPERATES": "COOPERATE, to work together [v]\n",
  "COOPERATING": "COOPERATE, to work together [v]\n",
  "COOPERATION": "the action of cooperating [n -S]\n",
  "COOPERATIONIST": "one who believes in cooperation [n -S]\n",
  "COOPERATIONISTS": "COOPERATIONIST, one who believes in cooperation [n]\n",
  "COOPERATIONS": "COOPERATION, the action of cooperating [n]\n",
  "COOPERATIVE": "working together [adj COOPERATIVELY] / an enterprise or organization owned by and operated for the benefit of those using its services [n -S]\n",
  "COOPERATIVELY": "COOPERATIVE, working together [adv]\n",
  "COOPERATIVENESS": "COOPERATIVE, working together [n]\n",
  "COOPERATIVES": "COOPERATIVE, an enterprise or organization owned by and operated for the benefit of those using its services [n]\n",
  "COOPERATIVITIES": "COOPERATIVITY, the state of being cooperative [n]\n",
  "COOPERATIVITY": "the state of being cooperative [n COOPERATIVITIES]\n",
  "COOPERATOR": "one who cooperates [n -S]\n",
  "COOPERATORS": "COOPERATOR, one who cooperates [n]\n",
  "COOPERED": "COOPER, to make barrels [v]\n",
  "COOPERIES": "COOPERY, the trade of coopering [n]\n",
  "COOPERING": "the making of barrels [n -S]\n",
  "COOPERINGS": "COOPERING, the making of barrels [n]\n",
  "COOPERS": "COOPER, to make barrels [v]\n",
  "COOPERY": "the trade of coopering [n COOPERIES]\n",
  "COOPING": "COOP, to confine [v]\n",
  "COOPS": "COOP, to confine [v]\n",
  "COOPT": "to recruit e.g. to a committee [v -ED, -ING, -S]\n",
  "COOPTATION": "the act of coopting, also COOPTION [n -S]\n",
  "COOPTATIONS": "COOPTATION, the act of coopting, also COOPTION [n]\n",
  "COOPTATIVE": "relating to cooptation [adj]\n",
  "COOPTED": "COOPT, to recruit e.g. to a committee [v]\n",
  "COOPTING": "COOPT, to recruit e.g. to a committee [v]\n",
  "COOPTION": "the act of coopting, also COOPTATION [n -S]\n",
  "COOPTIONS": "COOPTION, the act of coopting, also COOPTATION [n]\n",
  "COOPTS": "COOPT, to recruit e.g. to a committee [v]\n",
  "COORDINAL": "of plants and animals, belonging to the same order [adj]\n",
  "COORDINANCE": "a joint ordinance [n -S]\n",
  "COORDINANCES": "COORDINANCE, a joint ordinance [n]\n",
  "COORDINATE": "of the same order or rank [adj COORDINATELY] / to organise [v COORDINATED, COORDINATING, COORDINATES]\n",
  "COORDINATED": "COORDINATE, to organise [v]\n",
  "COORDINATELY": "COORDINATE, of the same order or rank [adv]\n",
  "COORDINATENESS": "COORDINATE, of the same order or rank [n]\n",
  "COORDINATES": "COORDINATE, to organise [v]\n",
  "COORDINATING": "COORDINATE, to organise [v]\n",
  "COORDINATION": "the act of coordinating [n -S]\n",
  "COORDINATIONS": "COORDINATION, the act of coordinating [n]\n",
  "COORDINATIVE": "serving to coordinate [adj]\n",
  "COORDINATOR": "one who coordinates [n -S]\n",
  "COORDINATORS": "COORDINATOR, one who coordinates [n]\n",
  "COORIE": "(Scots) to nestle or snuggle, also COURIE [v COORIED, COORIEING, COORIES]\n",
  "COORIED": "COORIE, (Scots) to nestle or snuggle, also COURIE [v]\n",
  "COORIEING": "COORIE, (Scots) to nestle or snuggle, also COURIE [v]\n",
  "COORIES": "COORIE, (Scots) to nestle or snuggle, also COURIE [v]\n",
  "COOS": "COO, to make the sound of a dove [v]\n",
  "COOSEN": "to cheat, also COZEN, COOSIN [v -ED, -ING, -S]\n",
  "COOSENED": "COOSEN, to cheat, also COZEN, COOSIN [v]\n",
  "COOSENING": "COOSEN, to cheat, also COZEN, COOSIN [v]\n",
  "COOSENS": "COOSEN, to cheat, also COZEN, COOSIN [v]\n",
  "COOSER": "(Scots) a stallion, also CUSSER, CUISSER [n -S]\n",
  "COOSERS": "COOSER, (Scots) a stallion, also CUSSER, CUISSER [n]\n",
  "COOSIN": "to cheat, also COOSEN, COZEN [v -ED, -ING, -S]\n",
  "COOSINED": "COOSIN, to cheat, also COOSEN, COZEN [v]\n",
  "COOSINING": "COOSIN, to cheat, also COOSEN, COZEN [v]\n",
  "COOSINS": "COOSIN, to cheat, also COOSEN, COZEN [v]\n",
  "COOST": "CAST, to throw with force [v]\n",
  "COOT": "a water bird, black with a white frontal shield [n -S]\n",
  "COOTCH": "(Welsh) to hide, to cuddle up, also CWTCH [v -ED, -ING, -ES]\n",
  "COOTCHED": "COOTCH, (Welsh) to hide, to cuddle up, also CWTCH [v]\n",
  "COOTCHES": "COOTCH, (Welsh) to hide, to cuddle up, also CWTCH [v]\n",
  "COOTCHING": "COOTCH, (Welsh) to hide, to cuddle up, also CWTCH [v]\n",
  "COOTER": "a kind of turtle [n -S]\n",
  "COOTERS": "COOTER, a kind of turtle [n]\n",
  "COOTIE": "(US slang) a body louse [n -S]\n",
  "COOTIES": "COOTIE, (US slang) a body louse [n]\n",
  "COOTIKIN": "(Scots) a gaiter, also CUITIKIN, CUTIKIN [n -S]\n",
  "COOTIKINS": "COOTIKIN, (Scots) a gaiter, also CUITIKIN, CUTIKIN [n]\n",
  "COOTS": "COOT, a water bird, black with a white frontal shield [n]\n",
  "COOZE": "(offensive colloquial) US and Canadian taboo slang word for the female genitals [n -S]\n",
  "COOZES": "COOZE, (offensive colloquial) US and Canadian taboo slang word for the female genitals [n]\n",
  "COP": "to capture [v COPPED, COPPING, COPS]\n",
  "COPACETIC": "(US colloquial) sound, adequate, excellent, also COPASETIC, COPESETIC, COPESETTIC, KOPASETIC [adj]\n",
  "COPAIBA": "(Tupi) a transparent resin obtained from certain South American trees, also COPAIVA [n -S]\n",
  "COPAIBAS": "COPAIBA, (Tupi) a transparent resin obtained from certain South American trees, also COPAIVA [n]\n",
  "COPAIVA": "(Tupi) a transparent resin obtained from certain South American trees, also COPAIBA [n -S]\n",
  "COPAIVAS": "COPAIVA, (Tupi) a transparent resin obtained from certain South American trees, also COPAIBA [n]\n",
  "COPAL": "(Nahuatl) a hard resin got from tropical trees [n -S]\n",
  "COPALM": "a hardwood tree of the Americas, aka liquidambar [n -S]\n",
  "COPALMS": "COPALM, a hardwood tree of the Americas, aka liquidambar [n]\n",
  "COPALS": "COPAL, (Nahuatl) a hard resin got from tropical trees [n]\n",
  "COPARCENARIES": "COPARCENARY, joint heirship or ownership, also COPARCENERY [n]\n",
  "COPARCENARY": "joint heirship or ownership, also COPARCENERY [n COPARCENARIES]\n",
  "COPARCENER": "one who has an equal portion with others of an inheritance [n -S]\n",
  "COPARCENERIES": "COPARCENERY, joint heirship or ownership, also COPARCENARY [n]\n",
  "COPARCENERS": "COPARCENER, one who has an equal portion with others of an inheritance [n]\n",
  "COPARCENERY": "joint heirship or ownership, also COPARCENARY [n COPARCENERIES]\n",
  "COPARCENIES": "COPARCENY, a form of joint ownership of property [n]\n",
  "COPARCENY": "a form of joint ownership of property [n COPARCENIES]\n",
  "COPARENT": "to share the parenting of [v -ED, -ING, -S]\n",
  "COPARENTED": "COPARENT, to share the parenting of [v]\n",
  "COPARENTING": "COPARENT, to share the parenting of [v]\n",
  "COPARENTS": "COPARENT, to share the parenting of [v]\n",
  "COPARTNER": "one who is jointly concerned with one or more persons in business [n -S] / to act as a copartner [v -ED, -ING, -S]\n",
  "COPARTNERED": "COPARTNER, to act as a copartner [v]\n",
  "COPARTNERIES": "COPARTNERY, the state of being copartners in any undertaking [n]\n",
  "COPARTNERING": "COPARTNER, to act as a copartner [v]\n",
  "COPARTNERS": "COPARTNER, to act as a copartner [v]\n",
  "COPARTNERSHIP": "the state of being a copartner [n -S]\n",
  "COPARTNERSHIPS": "COPARTNERSHIP, the state of being a copartner [n]\n",
  "COPARTNERY": "the state of being copartners in any undertaking [n COPARTNERIES]\n",
  "COPASETIC": "(US colloquial) sound, adequate, excellent, also COPACETIC, COPESETIC, COPESETTIC, KOPASETIC [adj]\n",
  "COPASTOR": "one that shares the duties of a pastor [n -S]\n",
  "COPASTORS": "COPASTOR, one that shares the duties of a pastor [n]\n",
  "COPATAINE": "of a hat, high-crowned like a sugar loaf [adj]\n",
  "COPATRIOT": "a person born, residing, or holding citizenship in the same country as another, also COMPATRIOT [n -S]\n",
  "COPATRIOTS": "COPATRIOT, a person born, residing, or holding citizenship in the same country as another, also COMPATRIOT [n]\n",
  "COPATRON": "a fellow patron [n -S]\n",
  "COPATRONS": "COPATRON, a fellow patron [n]\n",
  "COPAY": "an amount payable by a person with medical insurance [n -S]\n",
  "COPAYMENT": "a joint payment [n -S]\n",
  "COPAYMENTS": "COPAYMENT, a joint payment [n]\n",
  "COPAYS": "COPAY, an amount payable by a person with medical insurance [n]\n",
  "COPE": "to deal with [v COPED, COPING, COPES]\n",
  "COPECK": "(Russian) a Russian monetary unit, the hundredth part of a rouble, also KOPECK, KOPEK [n -S]\n",
  "COPECKS": "COPECK, (Russian) a Russian monetary unit, the hundredth part of a rouble, also KOPECK, KOPEK [n]\n",
  "COPED": "COPE, to deal with [v]\n",
  "COPEMATE": "(obsolete) a companion, an accomplice [n -S]\n",
  "COPEMATES": "COPEMATE, (obsolete) a companion, an accomplice [n]\n",
  "COPEN": "a strong light blue colour [n -S]\n",
  "COPENS": "COPEN, a strong light blue colour [n]\n",
  "COPEPOD": "a shrimplike crustacean [n -S]\n",
  "COPEPODS": "COPEPOD, a shrimplike crustacean [n]\n",
  "COPER": "a ship for supplying alcoholic liquor clandestinely to deep-sea fishermen [n -S] / to supply a ship with alcoholic liquor [v -ED, -ING, -S]\n",
  "COPERED": "COPER, to supply a ship with alcoholic liquor [v]\n",
  "COPERING": "COPER, to supply a ship with alcoholic liquor [v]\n",
  "COPERNICIUM": "a short-lived artificially produced radioactive element that has 112 protons [n -S]\n",
  "COPERNICIUMS": "COPERNICIUM, a short-lived artificially produced radioactive element that has 112 protons [n]\n",
  "COPERS": "COPER, to supply a ship with alcoholic liquor [v]\n",
  "COPES": "COPE, to deal with [v]\n",
  "COPESETIC": "(US colloquial) sound, adequate, excellent, also COPACETIC, COPASETIC, COPESETTIC, KOPASETIC [adj]\n",
  "COPESETTIC": "(US) excellent, also COPACETIC, COPASETIC, COPESETIC, KOPASETIC [adj]\n",
  "COPESTONE": "a stone that tops or forms part of the top of a wall, also COPINGSTONE [n -S]\n",
  "COPESTONES": "COPESTONE, a stone that tops or forms part of the top of a wall, also COPINGSTONE [n]\n",
  "COPIABLE": "capable of being copied, also COPYABLE [adj]\n",
  "COPIED": "COPY, to imitate [v]\n",
  "COPIER": "one that copies [n -S]\n",
  "COPIERS": "COPIER, one that copies [n]\n",
  "COPIES": "COPY, to imitate [v]\n",
  "COPIHUE": "a climbing vine [n -S]\n",
  "COPIHUES": "COPIHUE, a climbing vine [n]\n",
  "COPILOT": "to pilot jointly [v -ED, -ING, -S]\n",
  "COPILOTED": "COPILOT, to pilot jointly [v]\n",
  "COPILOTING": "COPILOT, to pilot jointly [v]\n",
  "COPILOTS": "COPILOT, to pilot jointly [v]\n",
  "COPING": "the covering course of the masonry of a wall [n -S]\n",
  "COPINGS": "COPING, the covering course of the masonry of a wall [n]\n",
  "COPINGSTONE": "a stone that tops or forms part of the top of a wall, also COPESTONE [n -S]\n",
  "COPINGSTONES": "COPINGSTONE, a stone that tops or forms part of the top of a wall, also COPESTONE [n]\n",
  "COPIOUS": "abundant [adj COPIOUSLY]\n",
  "COPIOUSLY": "COPIOUS, abundant [adv]\n",
  "COPIOUSNESS": "the state of being copious [n -ES]\n",
  "COPIOUSNESSES": "COPIOUSNESS, the state of being copious [n]\n",
  "COPITA": "(Spanish) a tulip-shaped sherry glass [n -S]\n",
  "COPITAS": "COPITA, (Spanish) a tulip-shaped sherry glass [n]\n",
  "COPLAINTIFF": "a joint plaintiff [n -S]\n",
  "COPLAINTIFFS": "COPLAINTIFF, a joint plaintiff [n]\n",
  "COPLANAR": "on the same plane [adj]\n",
  "COPLANARITIES": "COPLANARITY, the state of being coplanar [n]\n",
  "COPLANARITY": "the state of being coplanar [n COPLANARITIES]\n",
  "COPLOT": "to plot together [v COPLOTTED, COPLOTTING, COPLOTS]\n",
  "COPLOTS": "COPLOT, to plot together [v]\n",
  "COPLOTTED": "COPLOT, to plot together [v]\n",
  "COPLOTTING": "the act of plotting together with [n -S]\n",
  "COPLOTTINGS": "COPLOTTING, the act of plotting together with [n]\n",
  "COPOLYMER": "a compound of high molecular weight produced by polymerizing two or more different monomers [n -S]\n",
  "COPOLYMERIC": "like a copolymer [adj]\n",
  "COPOLYMERISE": "to make into a copolymer, also COPOLYMERIZE [v COPOLYMERISED, COPOLYMERISING, COPOLYMERISES]\n",
  "COPOLYMERISED": "COPOLYMERISE, to make into a copolymer, also COPOLYMERIZE [v]\n",
  "COPOLYMERISES": "COPOLYMERISE, to make into a copolymer, also COPOLYMERIZE [v]\n",
  "COPOLYMERISING": "COPOLYMERISE, to make into a copolymer, also COPOLYMERIZE [v]\n",
  "COPOLYMERIZE": "to make into a copolymer, also COPOLYMERISE [v COPOLYMERIZED, COPOLYMERIZING, COPOLYMERIZES]\n",
  "COPOLYMERIZED": "COPOLYMERIZE, to make into a copolymer, also COPOLYMERISE [v]\n",
  "COPOLYMERIZES": "COPOLYMERIZE, to make into a copolymer, also COPOLYMERISE [v]\n",
  "COPOLYMERIZING": "COPOLYMERIZE, to make into a copolymer, also COPOLYMERISE [v]\n",
  "COPOLYMERS": "COPOLYMER, a compound of high molecular weight produced by polymerizing two or more different monomers [n]\n",
  "COPOUT": "a backing out of a responsibility [n -S]\n",
  "COPOUTS": "COPOUT, a backing out of a responsibility [n]\n",
  "COPPED": "COP, to capture [v]\n",
  "COPPER": "to cover with a metallic element [v -ED, -ING, -S]\n",
  "COPPERAH": "(Malay) dried coconut meat, also COPRA, COPPRA, COPRAH [n -S]\n",
  "COPPERAHS": "COPPERAH, (Malay) dried coconut meat, also COPRA, COPPRA, COPRAH [n]\n",
  "COPPERAS": "a compound used in making inks [n -ES]\n",
  "COPPERASES": "COPPERAS, a compound used in making inks [n]\n",
  "COPPERED": "COPPER, to cover with a metallic element [v]\n",
  "COPPERHEAD": "a venomous American serpent, closely allied to the rattlesnake, but without rattles [n -S]\n",
  "COPPERHEADS": "COPPERHEAD, a venomous American serpent, closely allied to the rattlesnake, but without rattles [n]\n",
  "COPPERIER": "COPPERY, containing copper, or made of copper [adj]\n",
  "COPPERIEST": "COPPERY, containing copper, or made of copper [adj]\n",
  "COPPERING": "the act of sheathing with copper [n -S]\n",
  "COPPERINGS": "COPPERING, the act of sheathing with copper [n]\n",
  "COPPERISH": "somewhat like copper [adj]\n",
  "COPPERPLATE": "an engraved or etched copper printing plate [n -S]\n",
  "COPPERPLATES": "COPPERPLATE, an engraved or etched copper printing plate [n]\n",
  "COPPERS": "COPPER, to cover with a metallic element [v]\n",
  "COPPERSKIN": "(archaic) a Native American [n -S]\n",
  "COPPERSKINS": "COPPERSKIN, (archaic) a Native American [n]\n",
  "COPPERSMITH": "a worker in copper [n -S]\n",
  "COPPERSMITHS": "COPPERSMITH, a worker in copper [n]\n",
  "COPPERWORK": "craftwork in copper [n -S]\n",
  "COPPERWORKS": "COPPERWORK, craftwork in copper [n]\n",
  "COPPERWORM": "the shipworm [n -S]\n",
  "COPPERWORMS": "COPPERWORM, the shipworm [n]\n",
  "COPPERY": "containing copper, or made of copper [adj COPPERIER, COPPERIEST]\n",
  "COPPICE": "to grow in a dense thicket [v COPPICED, COPPICING, COPPICES]\n",
  "COPPICED": "COPPICE, to grow in a dense thicket [v]\n",
  "COPPICES": "COPPICE, to grow in a dense thicket [v]\n",
  "COPPICING": "the act of coppicing [n -S]\n",
  "COPPICINGS": "COPPICING, the act of coppicing [n]\n",
  "COPPIES": "COPPY, (dialect) a small stool [n]\n",
  "COPPIN": "a cop of thread [n -S]\n",
  "COPPING": "COP, to capture [v]\n",
  "COPPINS": "COPPIN, a cop of thread [n]\n",
  "COPPLE": "(obsolete) a bird's crest [n -S]\n",
  "COPPLES": "COPPLE, (obsolete) a bird's crest [n]\n",
  "COPPRA": "(Malay) dried coconut meat, also COPRA, COPPERAH, COPRAH [n -S]\n",
  "COPPRAS": "COPPRA, (Malay) dried coconut meat, also COPRA, COPPERAH, COPRAH [n]\n",
  "COPPY": "(dialect) a small stool [n COPPIES]\n",
  "COPRA": "(Malay) dried coconut meat, also COPPERAH, COPPRA, COPRAH [n -S]\n",
  "COPRAEMIA": "blood poisoning resulting from chronic constipation, also COPREMIA [n -S]\n",
  "COPRAEMIAS": "COPRAEMIA, blood poisoning resulting from chronic constipation, also COPREMIA [n]\n",
  "COPRAEMIC": "relating to copraemia, a form of blood poisoning, also COPREMIC [adj]\n",
  "COPRAH": "(Malay) dried coconut meat, also COPRA, COPPERAH, COPPRA [n -S]\n",
  "COPRAHS": "COPRAH, (Malay) dried coconut meat, also COPRA, COPPERAH, COPPRA [n]\n",
  "COPRAS": "COPRA, (Malay) dried coconut meat, also COPPERAH, COPPRA, COPRAH [n]\n",
  "COPREMIA": "blood poisoning resulting from chronic constipation, also COPRAEMIA [n -S]\n",
  "COPREMIAS": "COPREMIA, blood poisoning resulting from chronic constipation, also COPRAEMIA [n]\n",
  "COPREMIC": "relating to copremia, a form of blood poisoning caused by chronic constipation, also COPRAEMIC [adj]\n",
  "COPRESENCE": "presence together [n -S]\n",
  "COPRESENCES": "COPRESENCE, presence together [n]\n",
  "COPRESENT": "to present jointly with another [v -ED, -ING, -S]\n",
  "COPRESENTED": "COPRESENT, to present jointly with another [v]\n",
  "COPRESENTING": "COPRESENT, to present jointly with another [v]\n",
  "COPRESENTS": "COPRESENT, to present jointly with another [v]\n",
  "COPRESIDENT": "a joint president [n -S]\n",
  "COPRESIDENTS": "COPRESIDENT, a joint president [n]\n",
  "COPRINCE": "one of two princes ruling jointly [n -S]\n",
  "COPRINCES": "COPRINCE, one of two princes ruling jointly [n]\n",
  "COPRINCIPAL": "a joint principal [n -S]\n",
  "COPRINCIPALS": "COPRINCIPAL, a joint principal [n]\n",
  "COPRISONER": "a fellow-prisoner [n -S]\n",
  "COPRISONERS": "COPRISONER, a fellow-prisoner [n]\n",
  "COPROCESSING": "the act of processing by means of a coprocessor [n -S]\n",
  "COPROCESSINGS": "COPROCESSING, the act of processing by means of a coprocessor [n]\n",
  "COPROCESSOR": "a microprocessor supplementing the functions of a main processor [n -S]\n",
  "COPROCESSORS": "COPROCESSOR, a microprocessor supplementing the functions of a main processor [n]\n",
  "COPRODUCE": "to produce in consort with [v COPRODUCED, COPRODUCING, COPRODUCES]\n",
  "COPRODUCED": "COPRODUCE, to produce in consort with [v]\n",
  "COPRODUCER": "one who coproduces [n -S]\n",
  "COPRODUCERS": "COPRODUCER, one who coproduces [n]\n",
  "COPRODUCES": "COPRODUCE, to produce in consort with [v]\n",
  "COPRODUCING": "COPRODUCE, to produce in consort with [v]\n",
  "COPRODUCT": "a byproduct [n -S]\n",
  "COPRODUCTION": "a joint production [n -S]\n",
  "COPRODUCTIONS": "COPRODUCTION, a joint production [n]\n",
  "COPRODUCTS": "COPRODUCT, a byproduct [n]\n",
  "COPROLALIA": "an uncontrollable or obsessive use of obscene language [n -S]\n",
  "COPROLALIAC": "relating to coprolalia, the uncontrolled, often excessive use of obscene or scatological language that may accompany certain mental disorders [adj]\n",
  "COPROLALIAS": "COPROLALIA, an uncontrollable or obsessive use of obscene language [n]\n",
  "COPROLITE": "fossilized excrement, also COPROLITH [n -S]\n",
  "COPROLITES": "COPROLITE, fossilized excrement, also COPROLITH [n]\n",
  "COPROLITH": "fossilized excrement, also COPROLITE [n -S]\n",
  "COPROLITHS": "COPROLITH, fossilized excrement, also COPROLITE [n]\n",
  "COPROLITIC": "containing, pertaining to, or of the nature of, coprolites [adj]\n",
  "COPROLOGIES": "COPROLOGY, the study of pornography [n]\n",
  "COPROLOGY": "the study of pornography [n COPROLOGIES]\n",
  "COPROMOTER": "a joint promoter [n -S]\n",
  "COPROMOTERS": "COPROMOTER, a joint promoter [n]\n",
  "COPROPHAGAN": "a beetle that lives in dung [n -S]\n",
  "COPROPHAGANS": "COPROPHAGAN, a beetle that lives in dung [n]\n",
  "COPROPHAGIC": "eating dung, also COPROPHAGOUS [adj]\n",
  "COPROPHAGIES": "COPROPHAGY, feeding on dung [n]\n",
  "COPROPHAGIST": "an eater of dung [n -S]\n",
  "COPROPHAGISTS": "COPROPHAGIST, an eater of dung [n]\n",
  "COPROPHAGOUS": "eating dung, also COPROPHAGIC [adj]\n",
  "COPROPHAGY": "feeding on dung [n COPROPHAGIES]\n",
  "COPROPHILIA": "an abnormal liking for excrement [n -S]\n",
  "COPROPHILIAC": "one suffering from coprophilia [n -S]\n",
  "COPROPHILIACS": "COPROPHILIAC, one suffering from coprophilia [n]\n",
  "COPROPHILIAS": "COPROPHILIA, an abnormal liking for excrement [n]\n",
  "COPROPHILIC": "relating to coprophilia, an abnormal liking for excrement [adj]\n",
  "COPROPHILOUS": "growing or living on dung [adj]\n",
  "COPROPRIETOR": "a joint proprietor [n -S]\n",
  "COPROPRIETORS": "COPROPRIETOR, a joint proprietor [n]\n",
  "COPROSMA": "an Australian evergreen shrub or small tree with glossy, leathery leaves and egg-shaped white or orange berries [n -S]\n",
  "COPROSMAS": "COPROSMA, an Australian evergreen shrub or small tree with glossy, leathery leaves and egg-shaped white or orange berries [n]\n",
  "COPROSPERITIES": "COPROSPERITY, shared prosperity [n]\n",
  "COPROSPERITY": "shared prosperity [n COPROSPERITIES]\n",
  "COPROSTEROL": "a compound formed from cholesterol in the intestine [n -S]\n",
  "COPROSTEROLS": "COPROSTEROL, a compound formed from cholesterol in the intestine [n]\n",
  "COPROZOIC": "living in dung [adj]\n",
  "COPS": "COP, to capture [v]\n",
  "COPSE": "to cut back trees [v COPSED, COPSING, COPSES]\n",
  "COPSED": "COPSE, to cut back trees [v]\n",
  "COPSES": "COPSE, to cut back trees [v]\n",
  "COPSEWOOD": "brushwood; coppice [n -S]\n",
  "COPSEWOODS": "COPSEWOOD, brushwood; coppice [n]\n",
  "COPSHOP": "(slang) a police-station [n -S]\n",
  "COPSHOPS": "COPSHOP, (slang) a police-station [n]\n",
  "COPSIER": "COPSY, like a coppice [adj]\n",
  "COPSIEST": "COPSY, like a coppice [adj]\n",
  "COPSING": "COPSE, to cut back trees [v]\n",
  "COPSY": "like a coppice [adj COPSIER, COPSIEST]\n",
  "COPTER": "(short for) a helicopter [n -S]\n",
  "COPTERS": "COPTER, (short for) a helicopter [n]\n",
  "COPUBLISH": "to publish in collaboration with someone else [v -ED, -ING, -ES]\n",
  "COPUBLISHED": "COPUBLISH, to publish in collaboration with someone else [v]\n",
  "COPUBLISHER": "a joint publisher [n -S]\n",
  "COPUBLISHERS": "COPUBLISHER, a joint publisher [n]\n",
  "COPUBLISHES": "COPUBLISH, to publish in collaboration with someone else [v]\n",
  "COPUBLISHING": "COPUBLISH, to publish in collaboration with someone else [v]\n",
  "COPULA": "(Latin) something which joins together [n COPULAS or COPULAE]\n",
  "COPULAE": "COPULA, (Latin) something which joins together [n]\n",
  "COPULAR": "relating to a copula [adj]\n",
  "COPULAS": "COPULA, (Latin) something which joins together [n]\n",
  "COPULATE": "to have sexual intercourse with [v COPULATED, COPULATING, COPULATES]\n",
  "COPULATED": "COPULATE, to have sexual intercourse with [v]\n",
  "COPULATES": "COPULATE, to have sexual intercourse with [v]\n",
  "COPULATING": "COPULATE, to have sexual intercourse with [v]\n",
  "COPULATION": "the act of copulating [n -S]\n",
  "COPULATIONS": "COPULATION, the act of copulating [n]\n",
  "COPULATIVE": "uniting [adj COPULATIVELY] / a conjunction that indicates combination e.g. 'and' [n -S]\n",
  "COPULATIVELY": "COPULATIVE, uniting [adv]\n",
  "COPULATIVES": "COPULATIVE, a conjunction that indicates combination e.g. 'and' [n]\n",
  "COPULATORY": "relating to copulation [adj]\n",
  "COPURIFIED": "COPURIFY, to become purified with another substance [v]\n",
  "COPURIFIES": "COPURIFY, to become purified with another substance [v]\n",
  "COPURIFY": "to become purified with another substance [v COPURIFIED, COPURIFYING, COPURIFIES]\n",
  "COPURIFYING": "COPURIFY, to become purified with another substance [v]\n",
  "COPY": "to imitate [v COPIED, COPYING, COPIES]\n",
  "COPYABLE": "that can be copied, also COPIABLE [adj]\n",
  "COPYBOOK": "a book used in teaching penmanship [n -S]\n",
  "COPYBOOKS": "COPYBOOK, a book used in teaching penmanship [n]\n",
  "COPYBOY": "an office boy [n -S]\n",
  "COPYBOYS": "COPYBOY, an office boy [n]\n",
  "COPYCAT": "to imitate [v COPYCATTED, COPYCATTING, COPYCATS]\n",
  "COPYCATS": "COPYCAT, to imitate [v]\n",
  "COPYCATTED": "COPYCAT, to imitate [v]\n",
  "COPYCATTING": "COPYCAT, to imitate [v]\n",
  "COPYDESK": "an editor's desk in a printing office [n -S]\n",
  "COPYDESKS": "COPYDESK, an editor's desk in a printing office [n]\n",
  "COPYEDIT": "to prepare copy for the printer [v -ED, -ING, -S]\n",
  "COPYEDITED": "COPYEDIT, to prepare copy for the printer [v]\n",
  "COPYEDITING": "COPYEDIT, to prepare copy for the printer [v]\n",
  "COPYEDITS": "COPYEDIT, to prepare copy for the printer [v]\n",
  "COPYFIGHT": "the conflict between copyright holders and other individuals over the use, distribution and replication of copyright materials [n -S]\n",
  "COPYFIGHTS": "COPYFIGHT, the conflict between copyright holders and other individuals over the use, distribution and replication of copyright materials [n]\n",
  "COPYGIRL": "a girl who runs errands in a newspaper office [n -S]\n",
  "COPYGIRLS": "COPYGIRL, a girl who runs errands in a newspaper office [n]\n",
  "COPYGRAPH": "a process for copying type [n -S]\n",
  "COPYGRAPHS": "COPYGRAPH, a process for copying type [n]\n",
  "COPYHOLD": "land tenure dependent on will of the lord of the manor [n -S]\n",
  "COPYHOLDER": "one possessed of land in copyhold [n -S]\n",
  "COPYHOLDERS": "COPYHOLDER, one possessed of land in copyhold [n]\n",
  "COPYHOLDS": "COPYHOLD, land tenure dependent on will of the lord of the manor [n]\n",
  "COPYING": "the act of making a copy [n -S]\n",
  "COPYINGS": "COPYING, the act of making a copy [n]\n",
  "COPYISM": "plagiaristic copying [n -S]\n",
  "COPYISMS": "COPYISM, plagiaristic copying [n]\n",
  "COPYIST": "one who makes copies [n -S]\n",
  "COPYISTS": "COPYIST, one who makes copies [n]\n",
  "COPYLEFT": "to publish (intellectual property) under a license that allows free use and modification [v -ED, -ING, -S]\n",
  "COPYLEFTED": "COPYLEFT, to publish (intellectual property) under a license that allows free use and modification [v]\n",
  "COPYLEFTING": "COPYLEFT, to publish (intellectual property) under a license that allows free use and modification [v]\n",
  "COPYLEFTS": "COPYLEFT, to publish (intellectual property) under a license that allows free use and modification [v]\n",
  "COPYREAD": "(US) to subedit [v COPYREAD, COPYREADING, COPYREADS]\n",
  "COPYREADER": "a subeditor [n -S]\n",
  "COPYREADERS": "COPYREADER, a subeditor [n]\n",
  "COPYREADING": "the act of copyreading [n -S]\n",
  "COPYREADINGS": "COPYREADING, the act of copyreading [n]\n",
  "COPYREADS": "COPYREAD, (US) to subedit [v]\n",
  "COPYRIGHT": "to secure the sole right to reproduce a literary, dramatic, musical or artistic work of [v -ED, -ING, -S]\n",
  "COPYRIGHTABLE": "that can be copyrighted [adj]\n",
  "COPYRIGHTED": "COPYRIGHT, to secure the sole right to reproduce a literary, dramatic, musical or artistic work of [v]\n",
  "COPYRIGHTER": "one who copyrights [n -S]\n",
  "COPYRIGHTERS": "COPYRIGHTER, one who copyrights [n]\n",
  "COPYRIGHTING": "COPYRIGHT, to secure the sole right to reproduce a literary, dramatic, musical or artistic work of [v]\n",
  "COPYRIGHTS": "COPYRIGHT, to secure the sole right to reproduce a literary, dramatic, musical or artistic work of [v]\n",
  "COPYTAKER": "a person employed to type reports as journalists dictate them over the telephone [n -S]\n",
  "COPYTAKERS": "COPYTAKER, a person employed to type reports as journalists dictate them over the telephone [n]\n",
  "COPYWRITER": "a writer of advertising or publicity copy [n -S]\n",
  "COPYWRITERS": "COPYWRITER, a writer of advertising or publicity copy [n]\n",
  "COPYWRITING": "writing advertising copy [n -S]\n",
  "COPYWRITINGS": "COPYWRITING, writing advertising copy [n]\n",
  "COQUELICOT": "(French) a brilliant red, poppy red [n -S]\n",
  "COQUELICOTS": "COQUELICOT, (French) a brilliant red, poppy red [n]\n",
  "COQUET": "(French) to flirt, also COQUETTE [v COQUETTED, COQUETTING, COQUETS]\n",
  "COQUETRIES": "COQUETRY, flirtatious behaviour [n]\n",
  "COQUETRY": "flirtatious behaviour [n COQUETRIES]\n",
  "COQUETS": "COQUET, (French) to flirt, also COQUETTE [v]\n",
  "COQUETTE": "(French) to flirt, also COQUET [v COQUETTED, COQUETTING, COQUETTES]\n",
  "COQUETTED": "COQUET, (French) to flirt, also COQUETTE [v]\n",
  "COQUETTES": "COQUETTE, (French) to flirt, also COQUET [v]\n",
  "COQUETTING": "COQUET, (French) to flirt, also COQUETTE [v]\n",
  "COQUETTISH": "practicing or exhibiting coquetry; alluring [adj COQUETTISHLY]\n",
  "COQUETTISHLY": "COQUETTISH, practicing or exhibiting coquetry; alluring [adv]\n",
  "COQUETTISHNESS": "COQUETTISH, practicing or exhibiting coquetry; alluring [n]\n",
  "COQUI": "a small arboreal frog [n -S]\n",
  "COQUILLA": "(Spanish) the nut of the piassava palm, whose mottled dark brown endosperm is used by button-makers and turners [n -S]\n",
  "COQUILLAS": "COQUILLA, (Spanish) the nut of the piassava palm, whose mottled dark brown endosperm is used by button-makers and turners [n]\n",
  "COQUILLE": "(French) a scallop or other seafood served in a scallop shell [n -S]\n",
  "COQUILLES": "COQUILLE, (French) a scallop or other seafood served in a scallop shell [n]\n",
  "COQUIMBITE": "a yellowish hydrous sulphate of iron found in certain volcanic rocks [n -S]\n",
  "COQUIMBITES": "COQUIMBITE, a yellowish hydrous sulphate of iron found in certain volcanic rocks [n]\n",
  "COQUINA": "(Spanish) a coarse-grained, porous variety of clastic limestone made up chiefly of shells and shell fragments [n -S]\n",
  "COQUINAS": "COQUINA, (Spanish) a coarse-grained, porous variety of clastic limestone made up chiefly of shells and shell fragments [n]\n",
  "COQUIS": "COQUI, a small arboreal frog [n]\n",
  "COQUITO": "(Spanish) a Chilean palm tree [n -S]\n",
  "COQUITOS": "COQUITO, (Spanish) a Chilean palm tree [n]\n",
  "COR": "a Hebrew measure [n -S]\n",
  "CORACIIFORM": "of, belonging to or related to the Coraciiformes, an order of birds including the kingfishers, hornbills, bee-eaters and rollers [adj]\n",
  "CORACLE": "(Welsh) a small boat made of wickerwork covered with watertight material, also CURAGH, CURRACH, CURRAGH [n -S]\n",
  "CORACLES": "CORACLE, (Welsh) a small boat made of wickerwork covered with watertight material, also CURAGH, CURRACH, CURRAGH [n]\n",
  "CORACOID": "a bone of the shoulder girdle [n -S]\n",
  "CORACOIDS": "CORACOID, a bone of the shoulder girdle [n]\n",
  "CORADICATE": "of the same root [adj]\n",
  "CORAGGIO": "(Italian) an interjection, courage [interj]\n",
  "CORAL": "a mass of marine animal skeletons [n -S]\n",
  "CORALBELLS": "a perennnial alumroot widely cultivate for its feathery spikes of tiny bright red campanulate flowers [n]\n",
  "CORALBERRIES": "CORALBERRY, an American shrub of the snowberry genus [n]\n",
  "CORALBERRY": "an American shrub of the snowberry genus [n CORALBERRIES]\n",
  "CORALLA": "CORALLUM, (Latin) the skeleton of a coral colony [n]\n",
  "CORALLACEOUS": "like, or having the qualities of, coral [adj]\n",
  "CORALLIFEROUS": "bearing coral [adj]\n",
  "CORALLIFORM": "having the form of coral [adj]\n",
  "CORALLIGENOUS": "producing coral [adj]\n",
  "CORALLINE": "a marine animal, esp. a bryozoan, which lives in colonies resembling coral [n -S]\n",
  "CORALLINES": "CORALLINE, a marine animal, esp. a bryozoan, which lives in colonies resembling coral [n]\n",
  "CORALLITE": "a mineral substance or petrifaction, in the form of coral [n -S]\n",
  "CORALLITES": "CORALLITE, a mineral substance or petrifaction, in the form of coral [n]\n",
  "CORALLOID": "an organism having the form of coral, branching like coral [n -S]\n",
  "CORALLOIDAL": "having the form of coral [adj]\n",
  "CORALLOIDS": "CORALLOID, an organism having the form of coral, branching like coral [n]\n",
  "CORALLUM": "(Latin) the skeleton of a coral colony [n CORALLA]\n",
  "CORALROOT": "a kind of orchid [n -S]\n",
  "CORALROOTS": "CORALROOT, a kind of orchid [n]\n",
  "CORALS": "CORAL, a mass of marine animal skeletons [n]\n",
  "CORALWORT": "a cruciferous herb of certain species of Dentaria, aka toothwort [n -S]\n",
  "CORALWORTS": "CORALWORT, a cruciferous herb of certain species of Dentaria, aka toothwort [n]\n",
  "CORAM": "(Latin) in the presence of; before [prep]\n",
  "CORAMINE": "a circulatory stimulant banned by the World Anti-Doping Agency, hence preventing its use by athletes [n -S]\n",
  "CORAMINES": "CORAMINE, a circulatory stimulant banned by the World Anti-Doping Agency, hence preventing its use by athletes [n]\n",
  "CORANACH": "(Gaelic) a lamentation for the dead; a dirge, also CORONACH [n -S]\n",
  "CORANACHS": "CORANACH, (Gaelic) a lamentation for the dead; a dirge, also CORONACH [n]\n",
  "CORANTO": "(Italian) a rapid and lively dance [n CORANTOS or CORANTOES]\n",
  "CORANTOES": "CORANTO, (Italian) a rapid and lively dance [n]\n",
  "CORANTOS": "CORANTO, (Italian) a rapid and lively dance [n]\n",
  "CORBAN": "(Hebrew) anything offered to God in fulfilment of a vow [n -S]\n",
  "CORBANS": "CORBAN, (Hebrew) anything offered to God in fulfilment of a vow [n]\n",
  "CORBE": "(Spenser) a projection of stone or wood from the face of a wall, used for supporting pillars or other weights, also CORBEL [n -S]\n",
  "CORBEAU": "(French) a blackish green colour [n -S]\n",
  "CORBEAUS": "CORBEAU, (French) a blackish green colour [n]\n",
  "CORBEIL": "(French) a basket filled with earth used as a missile [n -S]\n",
  "CORBEILLE": "(French) a basket of flowers [n -S]\n",
  "CORBEILLES": "CORBEILLE, (French) a basket of flowers [n]\n",
  "CORBEILS": "CORBEIL, (French) a basket filled with earth used as a missile [n]\n",
  "CORBEL": "to provide a wall bracket [v CORBELED or CORBELLED, CORBELING or CORBELLING, CORBELS]\n",
  "CORBELED": "CORBEL, to provide a wall bracket [v]\n",
  "CORBELING": "(US) corbels taken collectively [n -S]\n",
  "CORBELINGS": "CORBELING, (US) corbels taken collectively [n]\n",
  "CORBELLED": "CORBEL, to provide a wall bracket [v]\n",
  "CORBELLING": "corbels taken collectively [n -S]\n",
  "CORBELLINGS": "CORBELLING, corbels taken collectively [n]\n",
  "CORBELS": "CORBEL, to provide a wall bracket [v]\n",
  "CORBES": "CORBE, (Spenser) a projection of stone or wood from the face of a wall, used for supporting pillars or other weights, also CORBEL [n]\n",
  "CORBICULA": "(Latin) the pollen basket of bees, consisting of the dilated posterior tibia with its fringe of long hairs [n CORBICULAE]\n",
  "CORBICULAE": "CORBICULA, (Latin) the pollen basket of bees, consisting of the dilated posterior tibia with its fringe of long hairs [n]\n",
  "CORBICULATE": "like a small basket [adj]\n",
  "CORBIE": "(Scots) a raven, a crow, also CORBY [n -S]\n",
  "CORBIES": "CORBY, (Scots) a raven, a crow, also CORBIE [n]\n",
  "CORBINA": "(Spanish) a bluish-grey whiting of the California coast, also CORVINA [n -S]\n",
  "CORBINAS": "CORBINA, (Spanish) a bluish-grey whiting of the California coast, also CORVINA [n]\n",
  "CORBY": "(Scots) a raven, a crow, also CORBIE [n CORBIES]\n",
  "CORCASS": "(Irish) in Ireland, a salt-marsh, or land susceptible to flooding by a river [n -ES]\n",
  "CORCASSES": "CORCASS, (Irish) in Ireland, a salt-marsh, or land susceptible to flooding by a river [n]\n",
  "CORD": "to fasten with a thin rope [v -ED, -ING, -S]\n",
  "CORDAGE": "ropes in the rigging of a ship [n -S]\n",
  "CORDAGES": "CORDAGE, ropes in the rigging of a ship [n]\n",
  "CORDATE": "heart-shaped [adj CORDATELY]\n",
  "CORDATELY": "CORDATE, heart-shaped [adv]\n",
  "CORDECTOMIES": "CORDECTOMY, the surgical removal of a vocal cord [n]\n",
  "CORDECTOMY": "the surgical removal of a vocal cord [n CORDECTOMIES]\n",
  "CORDED": "CORD, to fasten with a thin rope [v]\n",
  "CORDELLE": "(French) to use a tow rope to tow a boat [v CORDELLED, CORDELLING, CORDELLES]\n",
  "CORDELLED": "CORDELLE, (French) to use a tow rope to tow a boat [v]\n",
  "CORDELLES": "CORDELLE, (French) to use a tow rope to tow a boat [v]\n",
  "CORDELLING": "CORDELLE, (French) to use a tow rope to tow a boat [v]\n",
  "CORDER": "a person who or thing which fastens with a cord or forms a cord [n -S]\n",
  "CORDERS": "CORDER, a person who or thing which fastens with a cord or forms a cord [n]\n",
  "CORDGRASS": "a grass of the genus Spartina found in salt-marshes [n -ES]\n",
  "CORDGRASSES": "CORDGRASS, a grass of the genus Spartina found in salt-marshes [n]\n",
  "CORDIAL": "genial [adj CORDIALLY] / a medicine, food, or drink to stimulate the circulation and invigorate [n -S]\n",
  "CORDIALISE": "to become cordial, fraternise, also CORDIALIZE [v CORDIALISED, CORDIALISING, CORDIALISES]\n",
  "CORDIALISED": "CORDIALISE, to become cordial, fraternise, also CORDIALIZE [v]\n",
  "CORDIALISES": "CORDIALISE, to become cordial, fraternise, also CORDIALIZE [v]\n",
  "CORDIALISING": "CORDIALISE, to become cordial, fraternise, also CORDIALIZE [v]\n",
  "CORDIALITIES": "CORDIALITY, sincere affection and kindness [n]\n",
  "CORDIALITY": "sincere affection and kindness [n CORDIALITIES]\n",
  "CORDIALIZE": "to become cordial, fraternize, also CORDIALISE [v CORDIALIZED, CORDIALIZING, CORDIALIZES]\n",
  "CORDIALIZED": "CORDIALIZE, to become cordial, fraternize, also CORDIALISE [v]\n",
  "CORDIALIZES": "CORDIALIZE, to become cordial, fraternize, also CORDIALISE [v]\n",
  "CORDIALIZING": "CORDIALIZE, to become cordial, fraternize, also CORDIALISE [v]\n",
  "CORDIALLY": "CORDIAL, genial [adv]\n",
  "CORDIALNESS": "the state of being cordial [n -ES]\n",
  "CORDIALNESSES": "CORDIALNESS, the state of being cordial [n]\n",
  "CORDIALS": "CORDIAL, a medicine, food, or drink to stimulate the circulation and invigorate [n]\n",
  "CORDIERITE": "the mineral iolite or dichroite [n -S]\n",
  "CORDIERITES": "CORDIERITE, the mineral iolite or dichroite [n]\n",
  "CORDIFORM": "heart-shaped [adj]\n",
  "CORDILLERA": "(Spanish) a mountain ridge or chain [n -S]\n",
  "CORDILLERAN": "relating to a cordillera, a mountain ridge or chain [adj]\n",
  "CORDILLERAS": "CORDILLERA, (Spanish) a mountain ridge or chain [n]\n",
  "CORDINER": "(archaic) a shoemaker, also CORDWAINER [n -S]\n",
  "CORDINERS": "CORDINER, (archaic) a shoemaker, also CORDWAINER [n]\n",
  "CORDING": "the ribbed surface of cloth [n -S]\n",
  "CORDINGS": "CORDING, the ribbed surface of cloth [n]\n",
  "CORDITE": "a smokeless explosive used in guns, made from guncotton, nitroglycerine, and petroleum jelly [n -S]\n",
  "CORDITES": "CORDITE, a smokeless explosive used in guns, made from guncotton, nitroglycerine, and petroleum jelly [n]\n",
  "CORDLESS": "without a cord [adj] / a cordless telephone [n -ES]\n",
  "CORDLESSES": "CORDLESS, a cordless telephone [n]\n",
  "CORDLIKE": "like a cord [adj]\n",
  "CORDOBA": "(Spanish) a monetary unit of Nicaragua [n -S]\n",
  "CORDOBAS": "CORDOBA, (Spanish) a monetary unit of Nicaragua [n]\n",
  "CORDOCENTESES": "CORDOCENTESIS, the removal of a sample of fetal blood from the umbilical vein by inserting a hollow needle through the wall of the pregnant woman's abdomen [n]\n",
  "CORDOCENTESIS": "the removal of a sample of fetal blood from the umbilical vein by inserting a hollow needle through the wall of the pregnant woman's abdomen [n CORDOCENTESES]\n",
  "CORDON": "to form a barrier around [v -ED, -ING, -S]\n",
  "CORDONED": "CORDON, to form a barrier around [v]\n",
  "CORDONING": "CORDON, to form a barrier around [v]\n",
  "CORDONNET": "a type of thread [n -S]\n",
  "CORDONNETS": "CORDONNET, a type of thread [n]\n",
  "CORDONS": "CORDON, to form a barrier around [v]\n",
  "CORDOTOMIES": "CORDOTOMY, the surgical division of a bundle of nerve fibres in the spinal cord, also CHORDOTOMY [n]\n",
  "CORDOTOMY": "the surgical division of a bundle of nerve fibres in the spinal cord, also CHORDOTOMY [n CORDOTOMIES]\n",
  "CORDOVAN": "(Spanish) a fine leather, also CORDWAIN [n -S]\n",
  "CORDOVANS": "CORDOVAN, (Spanish) a fine leather, also CORDWAIN [n]\n",
  "CORDS": "CORD, to fasten with a thin rope [v]\n",
  "CORDUROY": "to build a road reinforced with transverse logs [v -ED, -ING, -S]\n",
  "CORDUROYED": "CORDUROY, to build a road reinforced with transverse logs [v]\n",
  "CORDUROYING": "CORDUROY, to build a road reinforced with transverse logs [v]\n",
  "CORDUROYS": "CORDUROY, to build a road reinforced with transverse logs [v]\n",
  "CORDWAIN": "a fine goatskin leather, also CORDOVAN [n -S]\n",
  "CORDWAINER": "(archaic) a shoemaker, also CORDINER [n -S]\n",
  "CORDWAINERIES": "CORDWAINERY, (archaic) the craft of shoemaking [n]\n",
  "CORDWAINERS": "CORDWAINER, (archaic) a shoemaker, also CORDINER [n]\n",
  "CORDWAINERY": "(archaic) the craft of shoemaking [n CORDWAINERIES]\n",
  "CORDWAINS": "CORDWAIN, a fine goatskin leather, also CORDOVAN [n]\n",
  "CORDWOOD": "a wood used for fuel [n -S]\n",
  "CORDWOODS": "CORDWOOD, a wood used for fuel [n]\n",
  "CORDYLINE": "a tropical or subtropical palmlike shrub [n -S]\n",
  "CORDYLINES": "CORDYLINE, a tropical or subtropical palmlike shrub [n]\n",
  "CORE": "to remove the central part of [v CORED, CORING, CORES]\n",
  "CORECIPIENT": "a joint recipient [n -S]\n",
  "CORECIPIENTS": "CORECIPIENT, a joint recipient [n]\n",
  "CORED": "CORE, to remove the central part of [v]\n",
  "COREDEEM": "to redeem jointly [v -ED, -ING, -S]\n",
  "COREDEEMED": "COREDEEM, to redeem jointly [v]\n",
  "COREDEEMING": "COREDEEM, to redeem jointly [v]\n",
  "COREDEEMS": "COREDEEM, to redeem jointly [v]\n",
  "COREFERENTIAL": "of more than one linguistic expression, designating the same individual or class [adj]\n",
  "COREGENT": "a joint regent [n -S]\n",
  "COREGENTS": "COREGENT, a joint regent [n]\n",
  "COREGONINE": "of or like the genus Coregonus, a kind of whitefish [adj]\n",
  "COREIGN": "a joint reign [n -S]\n",
  "COREIGNS": "COREIGN, a joint reign [n]\n",
  "CORELATE": "to place in mutual relation [v CORELATED, CORELATING, CORELATES]\n",
  "CORELATED": "CORELATE, to place in mutual relation [v]\n",
  "CORELATES": "CORELATE, to place in mutual relation [v]\n",
  "CORELATING": "CORELATE, to place in mutual relation [v]\n",
  "CORELATION": "correspondence, also CORRELATION [n -S]\n",
  "CORELATIONS": "CORELATION, correspondence, also CORRELATION [n]\n",
  "CORELATIVE": "mutually linked [adj] / a person or thing correspondingly related to another person or thing, also CORRELATIVE [n -S]\n",
  "CORELATIVES": "CORELATIVE, a person or thing correspondingly related to another person or thing, also CORRELATIVE [n]\n",
  "CORELESS": "having no core [adj]\n",
  "CORELIGIONIST": "a person of the same religion, also CORRELIGIONIST [n -S]\n",
  "CORELIGIONISTS": "CORELIGIONIST, a person of the same religion, also CORRELIGIONIST [n]\n",
  "CORELLA": "(Native Australian) an Australian long-billed cockatoo [n -S]\n",
  "CORELLAS": "CORELLA, (Native Australian) an Australian long-billed cockatoo [n]\n",
  "COREMIA": "COREMIUM, (Latin) an organ of certain fungi [n]\n",
  "COREMIUM": "(Latin) an organ of certain fungi [n COREMIA]\n",
  "COREOPSIS": "a genus of herbaceous composite plants, mostly American [n -ES]\n",
  "COREOPSISES": "COREOPSIS, a genus of herbaceous composite plants, mostly American [n]\n",
  "COREPRESSOR": "a small molecule that activates a particular genetic repressor by combining with it [n -S]\n",
  "COREPRESSORS": "COREPRESSOR, a small molecule that activates a particular genetic repressor by combining with it [n]\n",
  "COREQUISITE": "a formal course of study required to be taken simultaneously with another [n -S]\n",
  "COREQUISITES": "COREQUISITE, a formal course of study required to be taken simultaneously with another [n]\n",
  "CORER": "a device for removing the core from an apple [n -S]\n",
  "CORERS": "CORER, a device for removing the core from an apple [n]\n",
  "CORES": "CORE, to remove the central part of [v]\n",
  "CORESEARCHER": "a joint researcher [n -S]\n",
  "CORESEARCHERS": "CORESEARCHER, a joint researcher [n]\n",
  "CORESIDENT": "a fellow resident [n -S]\n",
  "CORESIDENTIAL": "sharing a residence [adj]\n",
  "CORESIDENTS": "CORESIDENT, a fellow resident [n]\n",
  "CORESPONDENT": "a person named as guilty of adultery with the defendant in a divorce suit [n -S]\n",
  "CORESPONDENTS": "CORESPONDENT, a person named as guilty of adultery with the defendant in a divorce suit [n]\n",
  "COREY": "(Romany) the penis, also CORY [n -S]\n",
  "COREYS": "COREY, (Romany) the penis, also CORY [n]\n",
  "CORF": "a coalminer's basket, also CAUF [n CORVES]\n",
  "CORFHOUSE": "(Scots) a salmon-curing house [n -S]\n",
  "CORFHOUSES": "CORFHOUSE, (Scots) a salmon-curing house [n]\n",
  "CORGI": "(Welsh) a dog of a small short-legged breed of Welsh origin [n -S]\n",
  "CORGIS": "CORGI, (Welsh) a dog of a small short-legged breed of Welsh origin [n]\n",
  "CORIA": "CORIUM, (Latin) a leather armour; the true skin, under the epidermis [n]\n",
  "CORIACEOUS": "of plant structures, having a leathery appearance, also CORIOUS [adj]\n",
  "CORIANDER": "a plant yielding seeds used in medical and in curries and pickles [n -S]\n",
  "CORIANDERS": "CORIANDER, a plant yielding seeds used in medical and in curries and pickles [n]\n",
  "CORIES": "CORY, (Romany) the penis, also COREY [n]\n",
  "CORING": "CORE, to remove the central part of [v]\n",
  "CORINTHIANISE": "(archaic) to be licentious, also CORINTHIANIZE [v CORINTHIANISED, CORINTHIANISING, CORINTHIANISES]\n",
  "CORINTHIANISED": "CORINTHIANISE, (archaic) to be licentious, also CORINTHIANIZE [v]\n",
  "CORINTHIANISES": "CORINTHIANISE, (archaic) to be licentious, also CORINTHIANIZE [v]\n",
  "CORINTHIANISING": "CORINTHIANISE, (archaic) to be licentious, also CORINTHIANIZE [v]\n",
  "CORINTHIANIZE": "(archaic) to be licentious, also CORINTHIANISE [v CORINTHIANIZED, CORINTHIANIZING, CORINTHIANIZES]\n",
  "CORINTHIANIZED": "CORINTHIANIZE, (archaic) to be licentious, also CORINTHIANISE [v]\n",
  "CORINTHIANIZES": "CORINTHIANIZE, (archaic) to be licentious, also CORINTHIANISE [v]\n",
  "CORINTHIANIZING": "CORINTHIANIZE, (archaic) to be licentious, also CORINTHIANISE [v]\n",
  "CORIOUS": "having a leathery appearance [adj]\n",
  "CORIUM": "(Latin) a leather armour; the true skin, under the epidermis [n CORIUMS or CORIA]\n",
  "CORIUMS": "CORIUM, (Latin) a leather armour; the true skin, under the epidermis [n]\n",
  "CORIVAL": "to rival [v CORIVALLED, CORIVALLING, CORIVALS]\n",
  "CORIVALLED": "CORIVAL, to rival [v]\n",
  "CORIVALLING": "CORIVAL, to rival [v]\n",
  "CORIVALRIES": "CORIVALRY, rivalry [n]\n",
  "CORIVALRY": "rivalry [n CORIVALRIES]\n",
  "CORIVALS": "CORIVAL, to rival [v]\n",
  "CORIVALSHIP": "rivalry [n -S]\n",
  "CORIVALSHIPS": "CORIVALSHIP, rivalry [n]\n",
  "CORIXID": "a type of water bug [n -S]\n",
  "CORIXIDS": "CORIXID, a type of water bug [n]\n",
  "CORK": "to stop up [v -ED, -ING, -S]\n",
  "CORKAGE": "the charge made by innkeepers for drawing the cork and taking care of bottles of wine bought elsewhere by a guest [n -S]\n",
  "CORKAGES": "CORKAGE, the charge made by innkeepers for drawing the cork and taking care of bottles of wine bought elsewhere by a guest [n]\n",
  "CORKBOARD": "a thin composite board made of cork and resin, used e.g. as insulation [n -S]\n",
  "CORKBOARDS": "CORKBOARD, a thin composite board made of cork and resin, used e.g. as insulation [n]\n",
  "CORKBORER": "an instrument for boring holes in cork to receive glass tubes used in chemistry [n -S]\n",
  "CORKBORERS": "CORKBORER, an instrument for boring holes in cork to receive glass tubes used in chemistry [n]\n",
  "CORKED": "CORK, to stop up [v]\n",
  "CORKER": "one that corks [n -S]\n",
  "CORKERS": "CORKER, one that corks [n]\n",
  "CORKIER": "CORKY, like cork [adj]\n",
  "CORKIEST": "CORKY, like cork [adj]\n",
  "CORKINESS": "the state of being corky [n -ES]\n",
  "CORKINESSES": "CORKINESS, the state of being corky [n]\n",
  "CORKING": "CORK, to stop up [v]\n",
  "CORKIR": "(Gaelic) a lichen used for dying, also KORKIR [n -S]\n",
  "CORKIRS": "CORKIR, (Gaelic) a lichen used for dying, also KORKIR [n]\n",
  "CORKLIKE": "like cork [adj]\n",
  "CORKS": "CORK, to stop up [v]\n",
  "CORKSCREW": "a device, usually consisting of a piece of metal in the shape of a screw, for drawing corks from bottles [n -S] / to twist from side to side [v -ED, -ING, -S]\n",
  "CORKSCREWED": "CORKSCREW, to twist from side to side [v]\n",
  "CORKSCREWING": "CORKSCREW, to twist from side to side [v]\n",
  "CORKSCREWS": "CORKSCREW, to twist from side to side [v]\n",
  "CORKTREE": "the cork oak [n -S]\n",
  "CORKTREES": "CORKTREE, the cork oak [n]\n",
  "CORKWING": "a European fish of the wrasse family [n -S]\n",
  "CORKWINGS": "CORKWING, a European fish of the wrasse family [n]\n",
  "CORKWOOD": "very light wood e.g. balsa, or alligator apple [n -S]\n",
  "CORKWOODS": "CORKWOOD, very light wood e.g. balsa, or alligator apple [n]\n",
  "CORKY": "like cork [adj CORKIER, CORKIEST]\n",
  "CORM": "the swollen subterranean part of a stem [n -S]\n",
  "CORMEL": "a small corm produced from base of a larger one [n -S]\n",
  "CORMELS": "CORMEL, a small corm produced from base of a larger one [n]\n",
  "CORMIDIA": "CORMIDIUM, (Latin) the assemblage of individuals dangling in clusters from the main stem of pelagic siphonophores [n]\n",
  "CORMIDIUM": "(Latin) the assemblage of individuals dangling in clusters from the main stem of pelagic siphonophores [n CORMIDIA]\n",
  "CORMLET": "a small corm [n -S]\n",
  "CORMLETS": "CORMLET, a small corm [n]\n",
  "CORMLIKE": "like a corm, the swollen subterranean part of a stem [adj]\n",
  "CORMOID": "of a corm [adj]\n",
  "CORMOPHYTE": "a plant differentiated into leaf, stem and root [n -S]\n",
  "CORMOPHYTES": "CORMOPHYTE, a plant differentiated into leaf, stem and root [n]\n",
  "CORMOPHYTIC": "like a cormophyte [adj]\n",
  "CORMORANT": "a shiny black webfooted seabird [n -S]\n",
  "CORMORANTS": "CORMORANT, a shiny black webfooted seabird [n]\n",
  "CORMOUS": "producing corms [adj]\n",
  "CORMS": "CORM, the swollen subterranean part of a stem [n]\n",
  "CORMUS": "(Greek) the whole body of a compound animal [n -ES]\n",
  "CORMUSES": "CORMUS, (Greek) the whole body of a compound animal [n]\n",
  "CORN": "to preserve with salt [v -ED, -ING, -S]\n",
  "CORNACEOUS": "of or belonging to the Cornaceae, a genus of shrubs including dogwood [adj]\n",
  "CORNACRE": "the letting by a tenant of small portions of land prepared for crop or grazing, also CONACRE [n -S]\n",
  "CORNACRES": "CORNACRE, the letting by a tenant of small portions of land prepared for crop or grazing, also CONACRE [n]\n",
  "CORNAGE": "(historical) a feudal service, being a form of rent fixed by the number of horned cattle [n -S]\n",
  "CORNAGES": "CORNAGE, (historical) a feudal service, being a form of rent fixed by the number of horned cattle [n]\n",
  "CORNBALL": "(US) a sweetened ball of popcorn; anything trite, banal, sentimental [n -S]\n",
  "CORNBALLS": "CORNBALL, (US) a sweetened ball of popcorn; anything trite, banal, sentimental [n]\n",
  "CORNBORER": "a European moth whose larvae have become a pest of maize in America [n -S]\n",
  "CORNBORERS": "CORNBORER, a European moth whose larvae have become a pest of maize in America [n]\n",
  "CORNBRAID": "to braid hair in cornrows, also CORNROW [v -ED, -ING, -S]\n",
  "CORNBRAIDED": "CORNBRAID, to braid hair in cornrows, also CORNROW [v]\n",
  "CORNBRAIDING": "CORNBRAID, to braid hair in cornrows, also CORNROW [v]\n",
  "CORNBRAIDS": "CORNBRAID, to braid hair in cornrows, also CORNROW [v]\n",
  "CORNBRANDIES": "CORNBRANDY, spirits made from grain; whisky [n]\n",
  "CORNBRANDY": "spirits made from grain; whisky [n CORNBRANDIES]\n",
  "CORNBRASH": "a coarse, shelly limestone whose presence in the soil affords good growth for cereal crops [n -ES]\n",
  "CORNBRASHES": "CORNBRASH, a coarse, shelly limestone whose presence in the soil affords good growth for cereal crops [n]\n",
  "CORNBREAD": "bread made of the meal of maize [n -S]\n",
  "CORNBREADS": "CORNBREAD, bread made of the meal of maize [n]\n",
  "CORNCAKE": "a cake made of maize meal [n -S]\n",
  "CORNCAKES": "CORNCAKE, a cake made of maize meal [n]\n",
  "CORNCOB": "the cob or axis on which the kernels of Indian corn grow [n -S]\n",
  "CORNCOBS": "CORNCOB, the cob or axis on which the kernels of Indian corn grow [n]\n",
  "CORNCOCKLE": "a wild flower formerly prevalent in corn, having large trumpet-shaped reddish-purple flowers and poisonous seed [n -S]\n",
  "CORNCOCKLES": "CORNCOCKLE, a wild flower formerly prevalent in corn, having large trumpet-shaped reddish-purple flowers and poisonous seed [n]\n",
  "CORNCRAKE": "a type of rail, with a rasping cry [n -S]\n",
  "CORNCRAKES": "CORNCRAKE, a type of rail, with a rasping cry [n]\n",
  "CORNCRIB": "a building in which corn is stored [n -S]\n",
  "CORNCRIBS": "CORNCRIB, a building in which corn is stored [n]\n",
  "CORNEA": "(Latin) a transparent hard material protecting the eyeball [n CORNEAS or CORNEAE]\n",
  "CORNEAE": "CORNEA, (Latin) a transparent hard material protecting the eyeball [n]\n",
  "CORNEAL": "relating to the eye [adj]\n",
  "CORNEAS": "CORNEA, (Latin) a transparent hard material protecting the eyeball [n]\n",
  "CORNED": "CORN, to preserve with salt [v]\n",
  "CORNEITIS": "inflammation of the cornea [n -ES]\n",
  "CORNEITISES": "CORNEITIS, inflammation of the cornea [n]\n",
  "CORNEL": "a hardwood tree or shrub, also CORNUS [n -S]\n",
  "CORNELIAN": "a dull red or reddish-white kind of chalcedony, also CARNELIAN [n -S]\n",
  "CORNELIANS": "CORNELIAN, a dull red or reddish-white kind of chalcedony, also CARNELIAN [n]\n",
  "CORNELS": "CORNEL, a hardwood tree or shrub, also CORNUS [n]\n",
  "CORNEMUSE": "(French) a French mouth blown bagpipe with chanter and small drone in one stock, and a separate large drone [n -S]\n",
  "CORNEMUSES": "CORNEMUSE, (French) a French mouth blown bagpipe with chanter and small drone in one stock, and a separate large drone [n]\n",
  "CORNEOUS": "of a hornlike texture [adj]\n",
  "CORNER": "to gain control of [v -ED, -ING, -S]\n",
  "CORNERBACK": "a position in American football [n -S]\n",
  "CORNERBACKS": "CORNERBACK, a position in American football [n]\n",
  "CORNERED": "CORNER, to gain control of [v]\n",
  "CORNERING": "the act of turning a corner [n -S]\n",
  "CORNERINGS": "CORNERING, the act of turning a corner [n]\n",
  "CORNERMAN": "a person who assists a boxer between rounds by treating cuts, giving advice, etc. [n CORNERMEN]\n",
  "CORNERMEN": "CORNERMAN, a person who assists a boxer between rounds by treating cuts, giving advice, etc. [n]\n",
  "CORNERS": "CORNER, to gain control of [v]\n",
  "CORNERSTONE": "a stone forming a part of a corner or angle in a wall [n -S]\n",
  "CORNERSTONES": "CORNERSTONE, a stone forming a part of a corner or angle in a wall [n]\n",
  "CORNERWAYS": "with the corner in front, also CORNERWISE [adv]\n",
  "CORNERWISE": "with the corner in front, also CORNERWAYS [adv]\n",
  "CORNET": "a trumpetlike instrument [n -S]\n",
  "CORNETCIES": "CORNETCY, a rank in the British cavalry [n]\n",
  "CORNETCY": "a rank in the British cavalry [n CORNETCIES]\n",
  "CORNETIST": "one who plays the cornet, also CORNETTIST [n -S]\n",
  "CORNETISTS": "CORNETIST, one who plays the cornet, also CORNETTIST [n]\n",
  "CORNETS": "CORNET, a trumpetlike instrument [n]\n",
  "CORNETT": "an old woodwind instrument, also CORNET [n -S]\n",
  "CORNETTI": "CORNETTO, (Italian) an old woodwind instrument, now revived for performances of early music [n]\n",
  "CORNETTINI": "CORNETTINO, an instrument of the cornet family [n]\n",
  "CORNETTINO": "an instrument of the cornet family [n CORNETTINI or CORNETTINOS]\n",
  "CORNETTINOS": "CORNETTINO, an instrument of the cornet family [n]\n",
  "CORNETTIST": "one who plays the cornet, also CORNETIST [n -S]\n",
  "CORNETTISTS": "CORNETTIST, one who plays the cornet, also CORNETIST [n]\n",
  "CORNETTO": "(Italian) an old woodwind instrument, now revived for performances of early music [n CORNETTI or CORNETTOS]\n",
  "CORNETTOS": "CORNETTO, (Italian) an old woodwind instrument, now revived for performances of early music [n]\n",
  "CORNETTS": "CORNETT, an old woodwind instrument, also CORNET [n]\n",
  "CORNFED": "fed on corn [adj]\n",
  "CORNFIELD": "a field in which corn is growing [n -S]\n",
  "CORNFIELDS": "CORNFIELD, a field in which corn is growing [n]\n",
  "CORNFLAG": "another name for the flower gladiolus [n -S]\n",
  "CORNFLAGS": "CORNFLAG, another name for the flower gladiolus [n]\n",
  "CORNFLAKE": "a crazy or silly person; (in plural) toasted flakes of maize, eaten esp. as a breakfast cereal [n -S]\n",
  "CORNFLAKES": "CORNFLAKE, a crazy or silly person; (in plural) toasted flakes of maize, eaten esp. as a breakfast cereal [n]\n",
  "CORNFLIES": "CORNFLY, the goutfly [n]\n",
  "CORNFLOUR": "finely ground maize, rice, or other grain, used esp. for thickening sauces [n -S]\n",
  "CORNFLOURS": "CORNFLOUR, finely ground maize, rice, or other grain, used esp. for thickening sauces [n]\n",
  "CORNFLOWER": "a beautiful blue-flowered cornfield weed of the Compositae [n -S]\n",
  "CORNFLOWERS": "CORNFLOWER, a beautiful blue-flowered cornfield weed of the Compositae [n]\n",
  "CORNFLY": "the goutfly [n CORNFLIES]\n",
  "CORNHUSK": "the husk covering an ear of corn [n -S]\n",
  "CORNHUSKER": "a person or machine that removes cornhusks [n -S]\n",
  "CORNHUSKERS": "CORNHUSKER, a person or machine that removes cornhusks [n]\n",
  "CORNHUSKING": "the removal of the husk from corn [n -S]\n",
  "CORNHUSKINGS": "CORNHUSKING, the removal of the husk from corn [n]\n",
  "CORNHUSKS": "CORNHUSK, the husk covering an ear of corn [n]\n",
  "CORNI": "CORNO, (Italian) the French horn [n]\n",
  "CORNICE": "to decorate with a moulding [v CORNICED, CORNICING, CORNICES]\n",
  "CORNICED": "CORNICE, to decorate with a moulding [v]\n",
  "CORNICES": "CORNICE, to decorate with a moulding [v]\n",
  "CORNICHE": "(French) a coastal road, esp. one running along a cliff face [n -S]\n",
  "CORNICHES": "CORNICHE, (French) a coastal road, esp. one running along a cliff face [n]\n",
  "CORNICHON": "(French) a small pickled gherkin [n -S]\n",
  "CORNICHONS": "CORNICHON, (French) a small pickled gherkin [n]\n",
  "CORNICING": "the act of providing with a cornice [n -S]\n",
  "CORNICINGS": "CORNICING, the act of providing with a cornice [n]\n",
  "CORNICLE": "a wax-secreting organ on an aphid's abdomen [n -S]\n",
  "CORNICLES": "CORNICLE, a wax-secreting organ on an aphid's abdomen [n]\n",
  "CORNICULA": "CORNICULUM, (Latin) a small hornlike part or process [n]\n",
  "CORNICULATE": "horn-shaped; horned [adj]\n",
  "CORNICULUM": "(Latin) a small hornlike part or process [n CORNICULA or CORNICULUMS]\n",
  "CORNICULUMS": "CORNICULUM, (Latin) a small hornlike part or process [n]\n",
  "CORNIER": "CORNY, trite, sentimental [adj]\n",
  "CORNIEST": "CORNY, trite, sentimental [adj]\n",
  "CORNIFEROUS": "containing hornstone [adj]\n",
  "CORNIFIC": "producing horns [adj]\n",
  "CORNIFICATION": "conversion into horn or a horny or keratinous substance or tissue [n -S]\n",
  "CORNIFICATIONS": "CORNIFICATION, conversion into horn or a horny or keratinous substance or tissue [n]\n",
  "CORNIFIED": "CORNIFY, to form keratin [v]\n",
  "CORNIFIES": "CORNIFY, to form keratin [v]\n",
  "CORNIFORM": "shaped like a horn [adj]\n",
  "CORNIFY": "to form keratin [v CORNIFIED, CORNIFYING, CORNIFIES]\n",
  "CORNIFYING": "CORNIFY, to form keratin [v]\n",
  "CORNIGEROUS": "horned [adj]\n",
  "CORNILY": "CORNY, trite, sentimental [adv]\n",
  "CORNINESS": "the state of being corny [n -ES]\n",
  "CORNINESSES": "CORNINESS, the state of being corny [n]\n",
  "CORNING": "CORN, to preserve with salt [v]\n",
  "CORNIST": "a performer on the cornet or horn [n -S]\n",
  "CORNISTS": "CORNIST, a performer on the cornet or horn [n]\n",
  "CORNLAND": "ground suitable for growing grain [n -S]\n",
  "CORNLANDS": "CORNLAND, ground suitable for growing grain [n]\n",
  "CORNLOFT": "a loft for corn; a granary [n -S]\n",
  "CORNLOFTS": "CORNLOFT, a loft for corn; a granary [n]\n",
  "CORNMEAL": "meal made from corn [n -S]\n",
  "CORNMEALS": "CORNMEAL, meal made from corn [n]\n",
  "CORNMILL": "a flour-mill [n -S]\n",
  "CORNMILLS": "CORNMILL, a flour-mill [n]\n",
  "CORNMOTH": "a moth of the clothes-moth genus [n -S]\n",
  "CORNMOTHS": "CORNMOTH, a moth of the clothes-moth genus [n]\n",
  "CORNO": "(Italian) the French horn [n CORNI]\n",
  "CORNOPEAN": "a brass cornet [n -S]\n",
  "CORNOPEANS": "CORNOPEAN, a brass cornet [n]\n",
  "CORNPIPE": "a musical instrument made of a stalk of oat or other cereal [n -S]\n",
  "CORNPIPES": "CORNPIPE, a musical instrument made of a stalk of oat or other cereal [n]\n",
  "CORNPONE": "a cornbread [n -S]\n",
  "CORNPONES": "CORNPONE, a cornbread [n]\n",
  "CORNRENT": "a rent for agricultural land that is paid in corn rather than money [n -S]\n",
  "CORNRENTS": "CORNRENT, a rent for agricultural land that is paid in corn rather than money [n]\n",
  "CORNROW": "to braid hair tightly in rows close to the scalp, also CORNBRAID [v -ED, -ING, -S]\n",
  "CORNROWED": "CORNROW, to braid hair tightly in rows close to the scalp, also CORNBRAID [v]\n",
  "CORNROWING": "CORNROW, to braid hair tightly in rows close to the scalp, also CORNBRAID [v]\n",
  "CORNROWS": "CORNROW, to braid hair tightly in rows close to the scalp, also CORNBRAID [v]\n",
  "CORNS": "CORN, to preserve with salt [v]\n",
  "CORNSILK": "silky threads on an ear of corn [n -S]\n",
  "CORNSILKS": "CORNSILK, silky threads on an ear of corn [n]\n",
  "CORNSTALK": "a stalk of corn [n -S]\n",
  "CORNSTALKS": "CORNSTALK, a stalk of corn [n]\n",
  "CORNSTARCH": "starch made from Indian corn, esp. a fine white flour used for puddings, etc. [n -ES]\n",
  "CORNSTARCHES": "CORNSTARCH, starch made from Indian corn, esp. a fine white flour used for puddings, etc. [n]\n",
  "CORNSTONE": "a silicious limestone favourable for cereal crops [n -S]\n",
  "CORNSTONES": "CORNSTONE, a silicious limestone favourable for cereal crops [n]\n",
  "CORNU": "(Latin) a horn-shaped process on the thyroid cartilage or certain bones (as the hyoid and the coccyx) [n CORNUA]\n",
  "CORNUA": "CORNU, (Latin) a horn-shaped process on the thyroid cartilage or certain bones (as the hyoid and the coccyx) [n]\n",
  "CORNUAL": "pertaining to the cornu [adj]\n",
  "CORNUCOPIA": "a curved goat's horn overflowing with fruit and ears of grain that is used as a decorative motif emblematic of abundance [n -S]\n",
  "CORNUCOPIAN": "of the nature of a cornucopia [adj]\n",
  "CORNUCOPIAS": "CORNUCOPIA, a curved goat's horn overflowing with fruit and ears of grain that is used as a decorative motif emblematic of abundance [n]\n",
  "CORNUS": "(Latin) a hardwood tree or shrub, also CORNEL [n -ES]\n",
  "CORNUSES": "CORNUS, (Latin) a hardwood tree or shrub, also CORNEL [n]\n",
  "CORNUTE": "to cuckold [v CORNUTED, CORNUTING, CORNUTES]\n",
  "CORNUTED": "CORNUTE, to cuckold [v]\n",
  "CORNUTES": "CORNUTE, to cuckold [v]\n",
  "CORNUTING": "CORNUTE, to cuckold [v]\n",
  "CORNUTO": "(Italian) a cuckold, the husband of an unfaithful wife [n -S]\n",
  "CORNUTOS": "CORNUTO, (Italian) a cuckold, the husband of an unfaithful wife [n]\n",
  "CORNWORM": "a corn weevil [n -S]\n",
  "CORNWORMS": "CORNWORM, a corn weevil [n]\n",
  "CORNY": "trite, sentimental [adj CORNIER, CORNIEST, CORNILY]\n",
  "COROCORE": "(Malay) a Malayan boat, also COROCORO [n -S]\n",
  "COROCORES": "COROCORE, (Malay) a Malayan boat, also COROCORO [n]\n",
  "COROCORO": "(Malay) a Malayan boat, also COROCORE [n -S]\n",
  "COROCOROS": "COROCORO, (Malay) a Malayan boat, also COROCORE [n]\n",
  "CORODIES": "CORODY, an allowance of food or clothes, also CORRODY [n]\n",
  "CORODY": "an allowance of food or clothes, also CORRODY [n CORODIES]\n",
  "COROLLA": "(Latin) the collective name for all the petals of a flower [n -S]\n",
  "COROLLACEOUS": "bearing a corolla [adj]\n",
  "COROLLARIES": "COROLLARY, an easy inference; a natural consequence or result [n]\n",
  "COROLLARY": "an easy inference; a natural consequence or result [n COROLLARIES]\n",
  "COROLLAS": "COROLLA, (Latin) the collective name for all the petals of a flower [n]\n",
  "COROLLATE": "having a corolla, the collective name for all the petals of a flower [adj]\n",
  "COROLLIFLORAL": "belonging to the Corolliflorae, also COROLLIFLOROUS [adj]\n",
  "COROLLIFLOROUS": "belonging to the Corolliflorae, also COROLLIFLORAL [adj]\n",
  "COROLLIFORM": "having the form of a corolla [adj]\n",
  "COROLLINE": "of or pertaining to a corolla [adj]\n",
  "COROMANDEL": "a kind of timber, aka calamander [n -S]\n",
  "COROMANDELS": "COROMANDEL, a kind of timber, aka calamander [n]\n",
  "CORONA": "(Latin) a luminous circle around a celestial body [n CORONAS or CORONAE]\n",
  "CORONACH": "(Gaelic) a dirge, also CORANACH [n -S]\n",
  "CORONACHS": "CORONACH, (Gaelic) a dirge, also CORANACH [n]\n",
  "CORONAE": "CORONA, (Latin) a luminous circle around a celestial body [n]\n",
  "CORONAGRAPH": "an instrument for viewing the corona of the sun [n -S]\n",
  "CORONAGRAPHS": "CORONAGRAPH, an instrument for viewing the corona of the sun [n]\n",
  "CORONAL": "relating to a corona [adj CORONALLY] / a circlet; a small crown or garland for the head [n -S]\n",
  "CORONALLY": "CORONAL, relating to a corona [adv]\n",
  "CORONALS": "CORONAL, a circlet; a small crown or garland for the head [n]\n",
  "CORONARIES": "CORONARY, an artery supplying blood to the heart [n]\n",
  "CORONARY": "an artery supplying blood to the heart [n CORONARIES]\n",
  "CORONAS": "CORONA, (Latin) a luminous circle around a celestial body [n]\n",
  "CORONATE": "to crown [v CORONATED, CORONATING, CORONATES]\n",
  "CORONATED": "CORONATE, to crown [v]\n",
  "CORONATES": "CORONATE, to crown [v]\n",
  "CORONATING": "CORONATE, to crown [v]\n",
  "CORONATION": "the act or occasion of crowning [n -S]\n",
  "CORONATIONS": "CORONATION, the act or occasion of crowning [n]\n",
  "CORONAVIRUS": "a kind of virus named for its crown-like shape [n -ES]\n",
  "CORONAVIRUSES": "CORONAVIRUS, a kind of virus named for its crown-like shape [n]\n",
  "CORONEL": "the iron head of a tilting spear, used in jousting [n -S]\n",
  "CORONELS": "CORONEL, the iron head of a tilting spear, used in jousting [n]\n",
  "CORONER": "an officer who investigates questionable deaths, also CROWNER [n -S]\n",
  "CORONERS": "CORONER, an officer who investigates questionable deaths, also CROWNER [n]\n",
  "CORONERSHIP": "the office of coroner [n -S]\n",
  "CORONERSHIPS": "CORONERSHIP, the office of coroner [n]\n",
  "CORONET": "a small crown, also CROWNET [n -S]\n",
  "CORONETED": "wearing a coronet [adj]\n",
  "CORONETS": "CORONET, a small crown, also CROWNET [n]\n",
  "CORONIAL": "of or relating to a coroner [adj]\n",
  "CORONIS": "(Latin) in Greek grammar, a sign sometimes placed over a contracted syllable [n -ES]\n",
  "CORONISES": "CORONIS, (Latin) in Greek grammar, a sign sometimes placed over a contracted syllable [n]\n",
  "CORONIUM": "the name given to a hypothetical element in the sun's corona showing spectral lines now known to be due to iron and nickel that have lost large numbers of electrons [n -S]\n",
  "CORONIUMS": "CORONIUM, the name given to a hypothetical element in the sun's corona showing spectral lines now known to be due to iron and nickel that have lost large numbers of electrons [n]\n",
  "CORONOGRAPH": "a special telescope used to observe prominences and the corona around the edge of the sun [n -S]\n",
  "CORONOGRAPHS": "CORONOGRAPH, a special telescope used to observe prominences and the corona around the edge of the sun [n]\n",
  "CORONOID": "pertaining to or designating projections of bone likened to a crow's beak [adj]\n",
  "COROTATE": "to rotate together [v COROTATED, COROTATING, COROTATES]\n",
  "COROTATED": "COROTATE, to rotate together [v]\n",
  "COROTATES": "COROTATE, to rotate together [v]\n",
  "COROTATING": "COROTATE, to rotate together [v]\n",
  "COROTATION": "the act of rotating in conjunction with another body [n -S]\n",
  "COROTATIONS": "COROTATION, the act of rotating in conjunction with another body [n]\n",
  "COROZO": "(Spanish) a short-stemmed South American palm [n -S]\n",
  "COROZOS": "COROZO, (Spanish) a short-stemmed South American palm [n]\n",
  "CORPORA": "CORPUS, (Latin) a human or animal body [n]\n",
  "CORPORAL": "relating to the body [adj CORPORALLY] / a white cloth on which Communion bread and wine are placed [n -S]\n",
  "CORPORALE": "a white cloth on which Communion bread and wine are placed, also CORPORAL, CORPORAS [n -S]\n",
  "CORPORALES": "CORPORALE, a white cloth on which Communion bread and wine are placed, also CORPORAL, CORPORAS [n]\n",
  "CORPORALITIES": "CORPORALITY, the state of being or having a body or a material or physical existence [n]\n",
  "CORPORALITY": "the state of being or having a body or a material or physical existence [n CORPORALITIES]\n",
  "CORPORALLY": "CORPORAL, relating to the body [adv]\n",
  "CORPORALS": "CORPORAL, a white cloth on which Communion bread and wine are placed [n]\n",
  "CORPORALSHIP": "the office of corporal [n -S]\n",
  "CORPORALSHIPS": "CORPORALSHIP, the office of corporal [n]\n",
  "CORPORAS": "(obsolete) a white cloth on which Communion bread and wine are placed, also CORPORAL, CORPORALE [n -ES]\n",
  "CORPORASES": "CORPORAS, (obsolete) a white cloth on which Communion bread and wine are placed, also CORPORAL, CORPORALE [n]\n",
  "CORPORATE": "legally united into a body so as to act as an individual [adj CORPORATELY] / a corporate body [n -S]\n",
  "CORPORATELY": "CORPORATE, legally united into a body so as to act as an individual [adv]\n",
  "CORPORATENESS": "CORPORATE, legally united into a body so as to act as an individual [n]\n",
  "CORPORATENESSES": "CORPORATENESS, CORPORATE, legally united into a body so as to act as an individual [n]\n",
  "CORPORATES": "CORPORATE, a corporate body [n]\n",
  "CORPORATION": "a body corporate legally authorized to act as a single individual [n -S]\n",
  "CORPORATIONS": "CORPORATION, a body corporate legally authorized to act as a single individual [n]\n",
  "CORPORATISE": "to make corporate, also CORPORATIZE [v CORPORATISED, CORPORATISING, CORPORATISES]\n",
  "CORPORATISED": "CORPORATISE, to make corporate, also CORPORATIZE [v]\n",
  "CORPORATISES": "CORPORATISE, to make corporate, also CORPORATIZE [v]\n",
  "CORPORATISING": "CORPORATISE, to make corporate, also CORPORATIZE [v]\n",
  "CORPORATISM": "the policy of control of a country's economy through the combined power of the trade unions, large businesses, etc., also CORPORATIVISM [n -S]\n",
  "CORPORATISMS": "CORPORATISM, the policy of control of a country's economy through the combined power of the trade unions, large businesses, etc., also CORPORATIVISM [n]\n",
  "CORPORATIST": "a believer in corporatism [n -S]\n",
  "CORPORATISTS": "CORPORATIST, a believer in corporatism [n]\n",
  "CORPORATIVE": "of or relating to a corporation [adj]\n",
  "CORPORATIVISM": "the policy of control of a country's economy through the combined power of the trade unions, large businesses, etc., also CORPORATISM [n -S]\n",
  "CORPORATIVISMS": "CORPORATIVISM, the policy of control of a country's economy through the combined power of the trade unions, large businesses, etc., also CORPORATISM [n]\n",
  "CORPORATIZE": "to make corporate, also CORPORATISE [v CORPORATIZED, CORPORATIZING, CORPORATIZES]\n",
  "CORPORATIZED": "CORPORATIZE, to make corporate, also CORPORATISE [v]\n",
  "CORPORATIZES": "CORPORATIZE, to make corporate, also CORPORATISE [v]\n",
  "CORPORATIZING": "CORPORATIZE, to make corporate, also CORPORATISE [v]\n",
  "CORPORATOR": "a member of a corporation, esp. one of the original members [n -S]\n",
  "CORPORATORS": "CORPORATOR, a member of a corporation, esp. one of the original members [n]\n",
  "CORPOREAL": "relating to the body [adj CORPOREALLY]\n",
  "CORPOREALISE": "to make corporeal, also CORPOREALIZE [v CORPOREALISED, CORPOREALISING, CORPOREALISES]\n",
  "CORPOREALISED": "CORPOREALISE, to make corporeal, also CORPOREALIZE [v]\n",
  "CORPOREALISES": "CORPOREALISE, to make corporeal, also CORPOREALIZE [v]\n",
  "CORPOREALISING": "CORPOREALISE, to make corporeal, also CORPOREALIZE [v]\n",
  "CORPOREALISM": "materialism [n -S]\n",
  "CORPOREALISMS": "CORPOREALISM, materialism [n]\n",
  "CORPOREALIST": "a believer in corporealism [n -S]\n",
  "CORPOREALISTS": "CORPOREALIST, a believer in corporealism [n]\n",
  "CORPOREALITIES": "CORPOREALITY, the quality of being corporeal [n]\n",
  "CORPOREALITY": "the quality of being corporeal [n CORPOREALITIES]\n",
  "CORPOREALIZE": "to make corporeal, also CORPOREALISE [v CORPOREALIZED, CORPOREALIZING, CORPOREALIZES]\n",
  "CORPOREALIZED": "CORPOREALIZE, to make corporeal, also CORPOREALISE [v]\n",
  "CORPOREALIZES": "CORPOREALIZE, to make corporeal, also CORPOREALISE [v]\n",
  "CORPOREALIZING": "CORPOREALIZE, to make corporeal, also CORPOREALISE [v]\n",
  "CORPOREALLY": "CORPOREAL, relating to the body [adv]\n",
  "CORPOREALNESS": "the state of being corporeal [n -ES]\n",
  "CORPOREALNESSES": "CORPOREALNESS, the state of being corporeal [n]\n",
  "CORPOREITIES": "CORPOREITY, the state of being corporeal [n]\n",
  "CORPOREITY": "the state of being corporeal [n CORPOREITIES]\n",
  "CORPORIFICATION": "the act of corporifying [n]\n",
  "CORPORIFIED": "CORPORIFY, to embody; to form into a body [v]\n",
  "CORPORIFIES": "CORPORIFY, to embody; to form into a body [v]\n",
  "CORPORIFY": "to embody; to form into a body [v CORPORIFIED, CORPORIFYING, CORPORIFIES]\n",
  "CORPORIFYING": "CORPORIFY, to embody; to form into a body [v]\n",
  "CORPOSANT": "St Elmo's fire or similar electrical discharge [n -S]\n",
  "CORPOSANTS": "CORPOSANT, St Elmo's fire or similar electrical discharge [n]\n",
  "CORPS": "(French) a military formation consisting of two or more divisions [n CORPS]\n",
  "CORPSE": "to forget one's lines [v CORPSED, CORPSING, CORPSES]\n",
  "CORPSED": "CORPSE, to forget one's lines [v]\n",
  "CORPSELIKE": "like a corpse [adj]\n",
  "CORPSES": "CORPSE, to forget one's lines [v]\n",
  "CORPSING": "CORPSE, to forget one's lines [v]\n",
  "CORPSMAN": "an enlisted man trained in first aid [n CORPSMEN]\n",
  "CORPSMEN": "CORPSMAN, an enlisted man trained in first aid [n]\n",
  "CORPULENCE": "the state of being corpulent, also CORPULENCY [n -S]\n",
  "CORPULENCES": "CORPULENCE, the state of being corpulent, also CORPULENCY [n]\n",
  "CORPULENCIES": "CORPULENCY, the state of being corpulent, also CORPULENCE [n]\n",
  "CORPULENCY": "the state of being corpulent, also CORPULENCE [n CORPULENCIES]\n",
  "CORPULENT": "fleshy [adj CORPULENTLY]\n",
  "CORPULENTLY": "CORPULENT, fleshy [adv]\n",
  "CORPUS": "(Latin) a human or animal body [n CORPUSES or CORPORA]\n",
  "CORPUSCLE": "a cell or other minute body suspended in fluid, esp. a red or white cell in the blood, also CORPUSCULE [n -S]\n",
  "CORPUSCLES": "CORPUSCLE, a cell or other minute body suspended in fluid, esp. a red or white cell in the blood, also CORPUSCULE [n]\n",
  "CORPUSCULAR": "having the nature of corpuscles [adj]\n",
  "CORPUSCULARIAN": "a person who holds the corpuscular theory [n -S]\n",
  "CORPUSCULARIANS": "CORPUSCULARIAN, a person who holds the corpuscular theory [n]\n",
  "CORPUSCULARITY": "the state of being corpuscular [n]\n",
  "CORPUSCULE": "a cell or other minute body suspended in fluid, esp. a red or white cell in the blood, also CORPUSCLE [n -S]\n",
  "CORPUSCULES": "CORPUSCULE, a cell or other minute body suspended in fluid, esp. a red or white cell in the blood, also CORPUSCLE [n]\n",
  "CORPUSES": "CORPUS, (Latin) a human or animal body [n]\n",
  "CORRADE": "to wear away by the action of loose solid material, e.g. pebbles in a stream [v CORRADED, CORRADING, CORRADES]\n",
  "CORRADED": "CORRADE, to wear away by the action of loose solid material, e.g. pebbles in a stream [v]\n",
  "CORRADES": "CORRADE, to wear away by the action of loose solid material, e.g. pebbles in a stream [v]\n",
  "CORRADING": "CORRADE, to wear away by the action of loose solid material, e.g. pebbles in a stream [v]\n",
  "CORRAL": "to place livestock in an enclosure [v CORRALLED, CORRALLING, CORRALS]\n",
  "CORRALLED": "CORRAL, to place livestock in an enclosure [v]\n",
  "CORRALLING": "CORRAL, to place livestock in an enclosure [v]\n",
  "CORRALS": "CORRAL, to place livestock in an enclosure [v]\n",
  "CORRASION": "the action of wearing away (land) through the action of loose solid material [n -S]\n",
  "CORRASIONS": "CORRASION, the action of wearing away (land) through the action of loose solid material [n]\n",
  "CORRASIVE": "serving to wear away [adj]\n",
  "CORREA": "an Australian evergreen shrub with large tubular showy flowers [n -S]\n",
  "CORREAS": "CORREA, an Australian evergreen shrub with large tubular showy flowers [n]\n",
  "CORRECT": "to make right [v -ED, -ING, -S] / free from error [adj CORRECTER, CORRECTEST, CORRECTLY]\n",
  "CORRECTABLE": "that can be corrected, also CORRECTIBLE [adj]\n",
  "CORRECTED": "CORRECT, to make right [v]\n",
  "CORRECTER": "CORRECT, free from error [adj]\n",
  "CORRECTEST": "CORRECT, free from error [adj]\n",
  "CORRECTIBLE": "that can be corrected, also CORRECTABLE [adj]\n",
  "CORRECTING": "CORRECT, to make right [v]\n",
  "CORRECTION": "the act of correcting [n -S]\n",
  "CORRECTIONAL": "relating to correction [adj]\n",
  "CORRECTIONER": "(Shakespeare) a person who administers correction [n -S]\n",
  "CORRECTIONERS": "CORRECTIONER, (Shakespeare) a person who administers correction [n]\n",
  "CORRECTIONS": "CORRECTION, the act of correcting [n]\n",
  "CORRECTITUDE": "correctness or propriety of conduct [n -S]\n",
  "CORRECTITUDES": "CORRECTITUDE, correctness or propriety of conduct [n]\n",
  "CORRECTIVE": "serving to correct [adj CORRECTIVELY] / something that serves to correct [n -S]\n",
  "CORRECTIVELY": "CORRECTIVE, serving to correct [adv]\n",
  "CORRECTIVES": "CORRECTIVE, something that serves to correct [n]\n",
  "CORRECTLY": "CORRECT, free from error [adv]\n",
  "CORRECTNESS": "the state of being correct [n -ES]\n",
  "CORRECTNESSES": "CORRECTNESS, the state of being correct [n]\n",
  "CORRECTOR": "one who corrects [n -S]\n",
  "CORRECTORS": "CORRECTOR, one who corrects [n]\n",
  "CORRECTORY": "containing or making correction [adj]\n",
  "CORRECTS": "CORRECT, to make right [v]\n",
  "CORREGIDOR": "(Spanish) the chief magistrate of a Spanish town [n -S]\n",
  "CORREGIDORS": "CORREGIDOR, (Spanish) the chief magistrate of a Spanish town [n]\n",
  "CORRELATABLE": "capable of being correlated [adj]\n",
  "CORRELATE": "to be related one to another, also CORELATE [v CORRELATED, CORRELATING, CORRELATES]\n",
  "CORRELATED": "CORRELATE, to be related one to another, also CORELATE [v]\n",
  "CORRELATES": "CORRELATE, to be related one to another, also CORELATE [v]\n",
  "CORRELATING": "CORRELATE, to be related one to another, also CORELATE [v]\n",
  "CORRELATION": "correspondence, also CORELATION [n -S]\n",
  "CORRELATIONAL": "relating to correlation [adj]\n",
  "CORRELATIONS": "CORRELATION, correspondence, also CORELATION [n]\n",
  "CORRELATIVE": "mutually linked, also CORELATIVE [adj CORRELATIVELY] / a person or thing correspondingly related to another person or thing [n -S]\n",
  "CORRELATIVELY": "CORRELATIVE, mutually linked, also CORELATIVE [adv]\n",
  "CORRELATIVENESS": "the state of being correlative [n]\n",
  "CORRELATIVES": "CORRELATIVE, a person or thing correspondingly related to another person or thing [n]\n",
  "CORRELATIVITIES": "CORRELATIVITY, the quality of being correlative [n]\n",
  "CORRELATIVITY": "the quality of being correlative [n CORRELATIVITIES]\n",
  "CORRELATOR": "one who correlates [n -S]\n",
  "CORRELATORS": "CORRELATOR, one who correlates [n]\n",
  "CORRELIGIONIST": "a person of the same religion, also CORELIGIONIST [n -S]\n",
  "CORRELIGIONISTS": "CORRELIGIONIST, a person of the same religion, also CORELIGIONIST [n]\n",
  "CORREPTION": "(obsolete) shortening in pronunciation [n -S]\n",
  "CORREPTIONS": "CORREPTION, (obsolete) shortening in pronunciation [n]\n",
  "CORRESPOND": "to be in conformity or agreement [v -ED, -ING, -S]\n",
  "CORRESPONDED": "CORRESPOND, to be in conformity or agreement [v]\n",
  "CORRESPONDENCE": "the agreement of things with one another, also CORRESPONDENCY [n -S]\n",
  "CORRESPONDENCES": "CORRESPONDENCE, the agreement of things with one another, also CORRESPONDENCY [n]\n",
  "CORRESPONDENCY": "(archaic) correspondence, also CORRESPONDENCE [n]\n",
  "CORRESPONDENT": "corresponding [adj CORRESPONDENTLY] / one who communicates with another by letter [n -S]\n",
  "CORRESPONDENTLY": "CORRESPONDENT, corresponding [adv]\n",
  "CORRESPONDENTS": "CORRESPONDENT, one who communicates with another by letter [n]\n",
  "CORRESPONDING": "similar, comparable [adj CORRESPONDINGLY]\n",
  "CORRESPONDINGLY": "CORRESPONDING, similar, comparable [adv]\n",
  "CORRESPONDS": "CORRESPOND, to be in conformity or agreement [v]\n",
  "CORRESPONSIVE": "mutually responsive [adj]\n",
  "CORRETTO": "(Italian) espresso with booze [n -S]\n",
  "CORRETTOS": "CORRETTO, (Italian) espresso with booze [n]\n",
  "CORRIDA": "(Spanish) a bullfight [n -S]\n",
  "CORRIDAS": "CORRIDA, (Spanish) a bullfight [n]\n",
  "CORRIDOR": "a narrow hallway [n -S]\n",
  "CORRIDORS": "CORRIDOR, a narrow hallway [n]\n",
  "CORRIE": "a deep basin on a mountain, also CIRQUE, CWM [n -S]\n",
  "CORRIES": "CORRIE, a deep basin on a mountain, also CIRQUE, CWM [n]\n",
  "CORRIGENDA": "CORRIGENDUM, an error in a printed work discovered after printing and shown with its correction on a separate sheet [n]\n",
  "CORRIGENDUM": "an error in a printed work discovered after printing and shown with its correction on a separate sheet [n CORRIGENDA]\n",
  "CORRIGENT": "a drug to reduce or counteract undesirable effects of others in a formula [n -S]\n",
  "CORRIGENTS": "CORRIGENT, a drug to reduce or counteract undesirable effects of others in a formula [n]\n",
  "CORRIGIBILITIES": "CORRIGIBILITY, the quality of being corrigible [n]\n",
  "CORRIGIBILITY": "the quality of being corrigible [n CORRIGIBILITIES]\n",
  "CORRIGIBLE": "capable of being corrected [adj CORRIGIBLY]\n",
  "CORRIGIBLY": "CORRIGIBLE, capable of being corrected [adv]\n",
  "CORRIVAL": "to rival, also CORIVAL [v CORRIVALLED, CORRIVALLING, CORRIVALS]\n",
  "CORRIVALLED": "CORRIVAL, to rival, also CORIVAL [v]\n",
  "CORRIVALLING": "CORRIVAL, to rival, also CORIVAL [v]\n",
  "CORRIVALRIES": "CORRIVALRY, the state of being a corrival [n]\n",
  "CORRIVALRY": "the state of being a corrival [n CORRIVALRIES]\n",
  "CORRIVALS": "CORRIVAL, to rival, also CORIVAL [v]\n",
  "CORRIVALSHIP": "the state of being a corrival [n -S]\n",
  "CORRIVALSHIPS": "CORRIVALSHIP, the state of being a corrival [n]\n",
  "CORROBORABLE": "able to be corroborated [adj]\n",
  "CORROBORANT": "having an invigorating effect [adj]\n",
  "CORROBORATE": "to support with evidence or authority [v CORROBORATED, CORROBORATING, CORROBORATES]\n",
  "CORROBORATED": "CORROBORATE, to support with evidence or authority [v]\n",
  "CORROBORATES": "CORROBORATE, to support with evidence or authority [v]\n",
  "CORROBORATING": "CORROBORATE, to support with evidence or authority [v]\n",
  "CORROBORATION": "corroboration [n -S]\n",
  "CORROBORATIONS": "CORROBORATION, corroboration [n]\n",
  "CORROBORATIVE": "serving to corroborate [adj CORROBORATIVELY] / that which serves to corroborate [n -S]\n",
  "CORROBORATIVELY": "CORROBORATIVE, serving to corroborate [adv]\n",
  "CORROBORATIVES": "CORROBORATIVE, that which serves to corroborate [n]\n",
  "CORROBORATOR": "one who corroborates [n -S]\n",
  "CORROBORATORS": "CORROBORATOR, one who corroborates [n]\n",
  "CORROBORATORY": "serving to corroborate [adj]\n",
  "CORROBOREE": "(Native Australian) to hold a kind of festivity [v CORROBOREED, CORROBOREEING, CORROBOREES]\n",
  "CORROBOREED": "CORROBOREE, (Native Australian) to hold a kind of festivity [v]\n",
  "CORROBOREEING": "CORROBOREE, (Native Australian) to hold a kind of festivity [v]\n",
  "CORROBOREES": "CORROBOREE, (Native Australian) to hold a kind of festivity [v]\n",
  "CORRODANT": "a corrosive agent, also CORRODENT [n -S]\n",
  "CORRODANTS": "CORRODANT, a corrosive agent, also CORRODENT [n]\n",
  "CORRODE": "to eat away by degrees [v CORRODED, CORRODING, CORRODES]\n",
  "CORRODED": "CORRODE, to eat away by degrees [v]\n",
  "CORRODENT": "a corrosive agent, also CORRODANT [n -S]\n",
  "CORRODENTS": "CORRODENT, a corrosive agent, also CORRODANT [n]\n",
  "CORRODER": "something that corrodes [n -S]\n",
  "CORRODERS": "CORRODER, something that corrodes [n]\n",
  "CORRODES": "CORRODE, to eat away by degrees [v]\n",
  "CORRODIBILITIES": "CORRODIBILITY, the quality of being corrodible, also CORROSIBILITY [n]\n",
  "CORRODIBILITY": "the quality of being corrodible, also CORROSIBILITY [n CORRODIBILITIES]\n",
  "CORRODIBLE": "able to be corroded, also CORROSIBLE [adj]\n",
  "CORRODIES": "CORRODY, an allowance of food or clothes, also CORODY [n]\n",
  "CORRODING": "CORRODE, to eat away by degrees [v]\n",
  "CORRODY": "an allowance of food or clothes, also CORODY [n CORRODIES]\n",
  "CORROSIBILITIES": "CORROSIBILITY, the quality of being corrosible, also CORRODIBILITY [n]\n",
  "CORROSIBILITY": "the quality of being corrosible, also CORRODIBILITY [n CORROSIBILITIES]\n",
  "CORROSIBLE": "able to be corroded, also CORRODIBLE [adj]\n",
  "CORROSION": "the act of eating, wearing, or wasting away [n -S]\n",
  "CORROSIONS": "CORROSION, the act of eating, wearing, or wasting away [n]\n",
  "CORROSIVE": "having the power to corrode, also CORSIVE [adj CORROSIVELY] / a corrosive substance [n -S]\n",
  "CORROSIVELY": "CORROSIVE, having the power to corrode, also CORSIVE [adv]\n",
  "CORROSIVENESS": "CORROSIVE, having the power to corrode, also CORSIVE [n]\n",
  "CORROSIVENESSES": "CORROSIVENESS, CORROSIVE, having the power to corrode, also CORSIVE [n]\n",
  "CORROSIVES": "CORROSIVE, a corrosive substance [n]\n",
  "CORRUGATE": "to wrinkle or draw into folds [v CORRUGATED, CORRUGATING, CORRUGATES]\n",
  "CORRUGATED": "CORRUGATE, to wrinkle or draw into folds [v]\n",
  "CORRUGATES": "CORRUGATE, to wrinkle or draw into folds [v]\n",
  "CORRUGATING": "CORRUGATE, to wrinkle or draw into folds [v]\n",
  "CORRUGATION": "the act of corrugating [n -S]\n",
  "CORRUGATIONS": "CORRUGATION, the act of corrugating [n]\n",
  "CORRUGATOR": "a muscle which contracts the skin of the forehead into wrinkles [n -S]\n",
  "CORRUGATORS": "CORRUGATOR, a muscle which contracts the skin of the forehead into wrinkles [n]\n",
  "CORRUPT": "to make bad, debase [v -ED, -ING, -S] / debased [adj CORRUPTER, CORRUPTEST, CORRUPTLY]\n",
  "CORRUPTED": "CORRUPT, to make bad, debase [v]\n",
  "CORRUPTER": "someone or something that corrupts, also CORRUPTOR [n -S]\n",
  "CORRUPTERS": "CORRUPTER, someone or something that corrupts, also CORRUPTOR [n]\n",
  "CORRUPTEST": "CORRUPT, debased [adj]\n",
  "CORRUPTIBILITY": "the state of being corruptible [n]\n",
  "CORRUPTIBLE": "that can be corrupted [adj CORRUPTIBLY]\n",
  "CORRUPTIBLENESS": "CORRUPTIBLE, that can be corrupted [n]\n",
  "CORRUPTIBLY": "CORRUPTIBLE, that can be corrupted [adv]\n",
  "CORRUPTING": "CORRUPT, to make bad, debase [v]\n",
  "CORRUPTION": "impairment of integrity, virtue, or moral principle [n -S]\n",
  "CORRUPTIONIST": "one who practices or defends corruption esp. in politics [n -S]\n",
  "CORRUPTIONISTS": "CORRUPTIONIST, one who practices or defends corruption esp. in politics [n]\n",
  "CORRUPTIONS": "CORRUPTION, impairment of integrity, virtue, or moral principle [n]\n",
  "CORRUPTIVE": "tending to corrupt [adj CORRUPTIVELY]\n",
  "CORRUPTIVELY": "CORRUPTIVE, tending to corrupt [adv]\n",
  "CORRUPTLY": "CORRUPT, debased [adv]\n",
  "CORRUPTNESS": "the state of being corrupt [n -ES]\n",
  "CORRUPTNESSES": "CORRUPTNESS, the state of being corrupt [n]\n",
  "CORRUPTOR": "someone or something that corrupts, also CORRUPTER [n -S]\n",
  "CORRUPTORS": "CORRUPTOR, someone or something that corrupts, also CORRUPTER [n]\n",
  "CORRUPTS": "CORRUPT, to make bad, debase [v]\n",
  "CORS": "COR, a Hebrew measure [n]\n",
  "CORSAC": "(Turkish) an Asian fox [n -S]\n",
  "CORSACS": "CORSAC, (Turkish) an Asian fox [n]\n",
  "CORSAGE": "the waist or bodice of a lady's dress [n -S]\n",
  "CORSAGES": "CORSAGE, the waist or bodice of a lady's dress [n]\n",
  "CORSAIR": "(historical) a privateersman of the Mediterranean, esp. the Barbary coast [n -S]\n",
  "CORSAIRS": "CORSAIR, (historical) a privateersman of the Mediterranean, esp. the Barbary coast [n]\n",
  "CORSE": "a corpse [n -S]\n",
  "CORSELET": "a piece of body armour, also CORSLET [n -S]\n",
  "CORSELETS": "CORSELET, a piece of body armour, also CORSLET [n]\n",
  "CORSELETTE": "a cuirass, a protective body covering of leather, also CORSELET, CORSLET [n -S]\n",
  "CORSELETTES": "CORSELETTE, a cuirass, a protective body covering of leather, also CORSELET, CORSLET [n]\n",
  "CORSES": "CORSE, a corpse [n]\n",
  "CORSET": "to fit with a supporting undergarment [v -ED, -ING, -S]\n",
  "CORSETED": "CORSET, to fit with a supporting undergarment [v]\n",
  "CORSETIER": "(French) a (male) corset maker [n -S]\n",
  "CORSETIERE": "(French) a (female) corset maker [n -S]\n",
  "CORSETIERES": "CORSETIERE, (French) a (female) corset maker [n]\n",
  "CORSETIERS": "CORSETIER, (French) a (male) corset maker [n]\n",
  "CORSETING": "CORSET, to fit with a supporting undergarment [v]\n",
  "CORSETRIES": "CORSETRY, the work of making corsets [n]\n",
  "CORSETRY": "the work of making corsets [n CORSETRIES]\n",
  "CORSETS": "CORSET, to fit with a supporting undergarment [v]\n",
  "CORSEY": "(dialect) a pavement, causeway, also CAUSEY [n -S]\n",
  "CORSEYS": "CORSEY, (dialect) a pavement, causeway, also CAUSEY [n]\n",
  "CORSITE": "a variety of diorite rock with a spherical structure, aka napoleonite [n -S]\n",
  "CORSITES": "CORSITE, a variety of diorite rock with a spherical structure, aka napoleonite [n]\n",
  "CORSIVE": "a corrosive [n -S]\n",
  "CORSIVES": "CORSIVE, a corrosive [n]\n",
  "CORSLET": "a piece of body armour, also CORSELET [n -S]\n",
  "CORSLETED": "wearing a corslet, a cuirass, a protective body covering of leather [adj]\n",
  "CORSLETS": "CORSLET, a piece of body armour, also CORSELET [n]\n",
  "CORSNED": "a historical legal process [n -S]\n",
  "CORSNEDS": "CORSNED, a historical legal process [n]\n",
  "CORSO": "(Italian) a race esp. of riderless horses [n -S]\n",
  "CORSOS": "CORSO, (Italian) a race esp. of riderless horses [n]\n",
  "CORTEGE": "(French) a train of attendants; a procession [n -S]\n",
  "CORTEGES": "CORTEGE, (French) a train of attendants; a procession [n]\n",
  "CORTEX": "(Latin) the outer layer of certain organs, esp. of the brain [n CORTICES or CORTEXES]\n",
  "CORTEXES": "CORTEX, (Latin) the outer layer of certain organs, esp. of the brain [n]\n",
  "CORTICAL": "pertaining to the cortex [adj CORTICALLY]\n",
  "CORTICALLY": "CORTICAL, pertaining to the cortex [adv]\n",
  "CORTICATE": "having a special outer covering of a nature unlike the interior part, e.g. bark, also CORTICATED [adj]\n",
  "CORTICATED": "having a special outer covering of a nature unlike the interior part, e.g. bark, also CORTICATE [adj]\n",
  "CORTICATION": "the state of being corticate, having a bark [n -S]\n",
  "CORTICATIONS": "CORTICATION, the state of being corticate, having a bark [n]\n",
  "CORTICES": "CORTEX, (Latin) the outer layer of certain organs, esp. of the brain [n]\n",
  "CORTICOID": "any of the steroid hormones produced in the adrenal cortex, also CORTICOSTEROID [n -S]\n",
  "CORTICOIDS": "CORTICOID, any of the steroid hormones produced in the adrenal cortex, also CORTICOSTEROID [n]\n",
  "CORTICOLOUS": "living or growing on tree bark [adj]\n",
  "CORTICOSE": "consisting of or like bark [adj]\n",
  "CORTICOSTEROID": "any of the steroid hormones produced in the adrenal cortex, also CORTICOID [n -S]\n",
  "CORTICOSTEROIDS": "CORTICOSTEROID, any of the steroid hormones produced in the adrenal cortex, also CORTICOID [n]\n",
  "CORTICOSTERONE": "a colorless crystalline corticosteroid important in protein and carbohydrate metabolism [n -S]\n",
  "CORTICOSTERONES": "CORTICOSTERONE, a colorless crystalline corticosteroid important in protein and carbohydrate metabolism [n]\n",
  "CORTICOTROPHIC": "stimulating the adrenal cortex, also CORTICOTROPIC [adj]\n",
  "CORTICOTROPHIN": "a hormone that stimulates the adrenal gland, also CORTICOTROPIN [n -S]\n",
  "CORTICOTROPHINS": "CORTICOTROPHIN, a hormone that stimulates the adrenal gland, also CORTICOTROPIN [n]\n",
  "CORTICOTROPIC": "stimulating the adrenal cortex, also CORTICOTROPHIC [adj]\n",
  "CORTICOTROPIN": "a hormone that stimulates the adrenal gland, also CORTICOTROPHIN [n -S]\n",
  "CORTICOTROPINS": "CORTICOTROPIN, a hormone that stimulates the adrenal gland, also CORTICOTROPHIN [n]\n",
  "CORTILE": "(Italian) an enclosed, usually roofless courtyard [n CORTILI]\n",
  "CORTILI": "CORTILE, (Italian) an enclosed, usually roofless courtyard [n]\n",
  "CORTIN": "an adrenal extract containing cortisol and other hormones [n -S]\n",
  "CORTINA": "a membrane on some mushrooms [n -S]\n",
  "CORTINAS": "CORTINA, a membrane on some mushrooms [n]\n",
  "CORTINS": "CORTIN, an adrenal extract containing cortisol and other hormones [n]\n",
  "CORTISOL": "a hormone used to treat inflammatory and allergic conditions, aka hydrocortisone [n -S]\n",
  "CORTISOLS": "CORTISOL, a hormone used to treat inflammatory and allergic conditions, aka hydrocortisone [n]\n",
  "CORTISONE": "a steroid hormone produced in the adrenal cortex and made synthetically, used as an anti-inflammatory and anti-allergy agent [n -S]\n",
  "CORTISONES": "CORTISONE, a steroid hormone produced in the adrenal cortex and made synthetically, used as an anti-inflammatory and anti-allergy agent [n]\n",
  "CORULER": "one that rules jointly [n -S]\n",
  "CORULERS": "CORULER, one that rules jointly [n]\n",
  "CORUNDUM": "(Tamil) a mineral consisting of alumina, varieties including sapphire, ruby, emery [n -S]\n",
  "CORUNDUMS": "CORUNDUM, (Tamil) a mineral consisting of alumina, varieties including sapphire, ruby, emery [n]\n",
  "CORUSCANT": "shining, glittering [adj]\n",
  "CORUSCATE": "to sparkle; to throw off flashes of light [v CORUSCATED, CORUSCATING, CORUSCATES]\n",
  "CORUSCATED": "CORUSCATE, to sparkle; to throw off flashes of light [v]\n",
  "CORUSCATES": "CORUSCATE, to sparkle; to throw off flashes of light [v]\n",
  "CORUSCATING": "CORUSCATE, to sparkle; to throw off flashes of light [v]\n",
  "CORUSCATION": "glitter, sparkle [n -S]\n",
  "CORUSCATIONS": "CORUSCATION, glitter, sparkle [n]\n",
  "CORVEE": "(French) labor exacted in lieu of taxes by public authorities esp. for highway construction or repair [n -S]\n",
  "CORVEES": "CORVEE, (French) labor exacted in lieu of taxes by public authorities esp. for highway construction or repair [n]\n",
  "CORVES": "CORF, a coalminer's basket, also CAUF [n]\n",
  "CORVET": "of a horse, to act friskily [v CORVETED or CORVETTED, CORVETING or CORVETTING, CORVETS]\n",
  "CORVETED": "CORVET, of a horse, to act friskily [v]\n",
  "CORVETING": "CORVET, of a horse, to act friskily [v]\n",
  "CORVETS": "CORVET, of a horse, to act friskily [v]\n",
  "CORVETTE": "(French) a highly manoeuvrable armed escort ship [n -S]\n",
  "CORVETTED": "CORVET, of a horse, to act friskily [v]\n",
  "CORVETTES": "CORVETTE, (French) a highly manoeuvrable armed escort ship [n]\n",
  "CORVETTING": "CORVET, of a horse, to act friskily [v]\n",
  "CORVID": "a member of the crow family [n -S]\n",
  "CORVIDS": "CORVID, a member of the crow family [n]\n",
  "CORVINA": "(Spanish) a bluish-grey whiting of the California coast, also CORBINA [n -S]\n",
  "CORVINAS": "CORVINA, (Spanish) a bluish-grey whiting of the California coast, also CORBINA [n]\n",
  "CORVINE": "pertaining to the crow family of birds [adj]\n",
  "CORVUS": "(Latin) a grappling hook, a hooked ram for destroying walls [n -ES]\n",
  "CORVUSES": "CORVUS, (Latin) a grappling hook, a hooked ram for destroying walls [n]\n",
  "CORY": "(Romany) the penis, also COREY [n CORIES]\n",
  "CORYBANT": "(Greek) one of the priests of Cybele in Phrygia, whose rites were accompanied by wild music, dancing, etc. [n CORYBANTES or CORYBANTS]\n",
  "CORYBANTES": "CORYBANT, (Greek) one of the priests of Cybele in Phrygia, whose rites were accompanied by wild music, dancing, etc. [n]\n",
  "CORYBANTIC": "wild; frenzied; uncontrolled [adj]\n",
  "CORYBANTISM": "the rites associated with corybants [n -S]\n",
  "CORYBANTISMS": "CORYBANTISM, the rites associated with corybants [n]\n",
  "CORYBANTS": "CORYBANT, (Greek) one of the priests of Cybele in Phrygia, whose rites were accompanied by wild music, dancing, etc. [n]\n",
  "CORYDALINE": "an alkaloid obtained from the root of Corydalis lutea [n -S]\n",
  "CORYDALINES": "CORYDALINE, an alkaloid obtained from the root of Corydalis lutea [n]\n",
  "CORYDALIS": "a climbing plant [n -ES]\n",
  "CORYDALISES": "CORYDALIS, a climbing plant [n]\n",
  "CORYLOPSES": "CORYLOPSIS, any of various deciduous shrubs with yellow flowers [n]\n",
  "CORYLOPSIS": "any of various deciduous shrubs with yellow flowers [n CORYLOPSES]\n",
  "CORYLUS": "(Latin) a deciduous nut-bearing tree of the Corylus genus, including hazel [n -ES]\n",
  "CORYLUSES": "CORYLUS, (Latin) a deciduous nut-bearing tree of the Corylus genus, including hazel [n]\n",
  "CORYMB": "a type of flower cluster [n -S]\n",
  "CORYMBED": "clustered with flowers [adj]\n",
  "CORYMBOSE": "consisting of corymbs, or resembling them in form [adj CORYMBOSELY]\n",
  "CORYMBOSELY": "CORYMBOSE, consisting of corymbs, or resembling them in form [adv]\n",
  "CORYMBOUS": "like a corymb, a flattish-topped raceme [adj]\n",
  "CORYMBS": "CORYMB, a type of flower cluster [n]\n",
  "CORYNEBACTERIA": "CORYNEBACTERIUM, a bacterium that causes e.g. diphtheria [n]\n",
  "CORYNEBACTERIAL": "relating to corynebacterium, a bacterium that causes e.g. diphtheria [adj]\n",
  "CORYNEBACTERIUM": "a bacterium that causes e.g. diphtheria [n CORYNEBACTERIA]\n",
  "CORYNEFORM": "virgate, rod-shaped [adj]\n",
  "CORYPHAEI": "CORYPHAEUS, (Latin) the leader of a Greek chorus, also CORYPHE, CORYPHEE [n]\n",
  "CORYPHAEUS": "(Latin) the leader of a Greek chorus, also CORYPHE, CORYPHEE [n CORYPHAEI]\n",
  "CORYPHE": "(archaic) the leader of the Greek chorus, also CORYPHAEUS, CORYPHEE [n -S]\n",
  "CORYPHEE": "(French) a leading dancer of a corps de ballet, also CORYPHAEUS, CORYPHE [n -S]\n",
  "CORYPHEES": "CORYPHEE, (French) a leading dancer of a corps de ballet, also CORYPHAEUS, CORYPHE [n]\n",
  "CORYPHENE": "a fish of the genus Coryphaena [n -S]\n",
  "CORYPHENES": "CORYPHENE, a fish of the genus Coryphaena [n]\n",
  "CORYPHES": "CORYPHE, (archaic) the leader of the Greek chorus, also CORYPHAEUS, CORYPHEE [n]\n",
  "CORYZA": "(Latin) a head cold [n -S]\n",
  "CORYZAL": "relating to a head cold [adj]\n",
  "CORYZAS": "CORYZA, (Latin) a head cold [n]\n",
  "COS": "a crisp, long-leaved lettuce [n -ES]\n",
  "COSCINOMANCIES": "COSCINOMANCY, divination using a sieve and a pair of shears [n]\n",
  "COSCINOMANCY": "divination using a sieve and a pair of shears [n COSCINOMANCIES]\n",
  "COSCRIPT": "to collaborate in writing a script [v -ED, -ING, -S]\n",
  "COSCRIPTED": "COSCRIPT, to collaborate in writing a script [v]\n",
  "COSCRIPTING": "COSCRIPT, to collaborate in writing a script [v]\n",
  "COSCRIPTS": "COSCRIPT, to collaborate in writing a script [v]\n",
  "COSE": "to make oneself cosy [v COSED, COSING, COSES]\n",
  "COSEC": "a trigonometrical function of an angle, also COSECANT [n -S]\n",
  "COSECANT": "a trigonometrical function of an angle, also COSEC [n -S]\n",
  "COSECANTS": "COSECANT, a trigonometrical function of an angle, also COSEC [n]\n",
  "COSECH": "a hyperbolic cosecant [n -S]\n",
  "COSECHS": "COSECH, a hyperbolic cosecant [n]\n",
  "COSECS": "COSEC, a trigonometrical function of an angle, also COSECANT [n]\n",
  "COSED": "COSE, to make oneself cosy [v]\n",
  "COSEISMAL": "connecting points simultaneously affected by an earthquake [adj] / a coseismal line, also COSEISMIC [n -S]\n",
  "COSEISMALS": "COSEISMAL, a coseismal line, also COSEISMIC [n]\n",
  "COSEISMIC": "connecting points simultaneously affected by an earthquake [adj] / a coseismal line, also COSEISMAL [n -S]\n",
  "COSEISMICS": "COSEISMIC, a coseismal line, also COSEISMAL [n]\n",
  "COSENTIENT": "perceiving together [adj]\n",
  "COSES": "COSE, to make oneself cosy [v]\n",
  "COSET": "a mathematical subset [n -S]\n",
  "COSETS": "COSET, a mathematical subset [n]\n",
  "COSEY": "a covering for a teapot, also COSIE, COZEY, COZIE [n -S]\n",
  "COSEYS": "COSEY, a covering for a teapot, also COSIE, COZEY, COZIE [n]\n",
  "COSH": "to bludgeon [v -ED, -ING, -ES]\n",
  "COSHED": "COSH, to bludgeon [v]\n",
  "COSHER": "to pamper, coddle [v -ED, -ING, -S]\n",
  "COSHERED": "COSHER, to pamper, coddle [v]\n",
  "COSHERER": "someone who lives on dependants [n -S]\n",
  "COSHERERS": "COSHERER, someone who lives on dependants [n]\n",
  "COSHERIES": "COSHERY, (Irish) the ancient right of an Irish chief [n]\n",
  "COSHERING": "the act of coshering, pampering [n -S]\n",
  "COSHERINGS": "COSHERING, the act of coshering, pampering [n]\n",
  "COSHERS": "COSHER, to pamper, coddle [v]\n",
  "COSHERY": "(Irish) the ancient right of an Irish chief [n COSHERIES]\n",
  "COSHES": "COSH, to bludgeon [v]\n",
  "COSHING": "COSH, to bludgeon [v]\n",
  "COSIE": "a covering for a teapot, also COSEY, COZEY, COZIE [n -S]\n",
  "COSIED": "COSY, to attempt to get on friendly terms, also COZY [v]\n",
  "COSIER": "(Shakespeare) a cobbler, also COZIER [n -S]\n",
  "COSIERS": "COSIER, (Shakespeare) a cobbler, also COZIER [n]\n",
  "COSIES": "COSY, to attempt to get on friendly terms, also COZY [v]\n",
  "COSIEST": "COSY, snug and comfortable, also COZY [adj]\n",
  "COSIGN": "to sign jointly [v -ED, -ING, -S]\n",
  "COSIGNATORIES": "COSIGNATORY, a joint signer, also CONSIGNATORY [n]\n",
  "COSIGNATORY": "a joint signer, also CONSIGNATORY [n COSIGNATORIES]\n",
  "COSIGNED": "COSIGN, to sign jointly [v]\n",
  "COSIGNER": "one who cosigns [n -S]\n",
  "COSIGNERS": "COSIGNER, one who cosigns [n]\n",
  "COSIGNIFICATIVE": "having the same signification [adj]\n",
  "COSIGNING": "COSIGN, to sign jointly [v]\n",
  "COSIGNS": "COSIGN, to sign jointly [v]\n",
  "COSILY": "COSY, snug and comfortable, also COZY [adv]\n",
  "COSINE": "a trigonometrical function of an angle [n -S]\n",
  "COSINES": "COSINE, a trigonometrical function of an angle [n]\n",
  "COSINESS": "the state of being cosy [n -ES]\n",
  "COSINESSES": "COSINESS, the state of being cosy [n]\n",
  "COSING": "COSE, to make oneself cosy [v]\n",
  "COSMEA": "a plant of the genus cosmos [n -S]\n",
  "COSMEAS": "COSMEA, a plant of the genus cosmos [n]\n",
  "COSMECEUTICAL": "a product which overlaps the cosmetics and drugs industries [n -S]\n",
  "COSMECEUTICALS": "COSMECEUTICAL, a product which overlaps the cosmetics and drugs industries [n]\n",
  "COSMESES": "COSMESIS, cosmetic surgery [n]\n",
  "COSMESIS": "cosmetic surgery [n COSMESES]\n",
  "COSMETIC": "relating to beauty preparation, also COSMETICAL [adj COSMETICALLY] / a beauty preparation [n -S]\n",
  "COSMETICAL": "imparting or improving beauty, particularly the beauty of the complexion, also COSMETIC [adj COSMETICALLY]\n",
  "COSMETICALLY": "COSMETICAL, imparting or improving beauty, particularly the beauty of the complexion, also COSMETIC [adv]\n",
  "COSMETICIAN": "a person who is professionally trained in the use of cosmetics [n -S]\n",
  "COSMETICIANS": "COSMETICIAN, a person who is professionally trained in the use of cosmetics [n]\n",
  "COSMETICISE": "to make (something unpleasant or ugly) superficially attractive, also COSMETICIZE [v COSMETICISED, COSMETICISING, COSMETICISES]\n",
  "COSMETICISED": "COSMETICISE, to make (something unpleasant or ugly) superficially attractive, also COSMETICIZE [v]\n",
  "COSMETICISES": "COSMETICISE, to make (something unpleasant or ugly) superficially attractive, also COSMETICIZE [v]\n",
  "COSMETICISING": "COSMETICISE, to make (something unpleasant or ugly) superficially attractive, also COSMETICIZE [v]\n",
  "COSMETICISM": "the use of cosmetics [n -S]\n",
  "COSMETICISMS": "COSMETICISM, the use of cosmetics [n]\n",
  "COSMETICIZE": "to make (something unpleasant or ugly) superficially attractive, also COSMETICISE [v COSMETICIZED, COSMETICIZING, COSMETICIZES]\n",
  "COSMETICIZED": "COSMETICIZE, to make (something unpleasant or ugly) superficially attractive, also COSMETICISE [v]\n",
  "COSMETICIZES": "COSMETICIZE, to make (something unpleasant or ugly) superficially attractive, also COSMETICISE [v]\n",
  "COSMETICIZING": "COSMETICIZE, to make (something unpleasant or ugly) superficially attractive, also COSMETICISE [v]\n",
  "COSMETICOLOGIES": "COSMETICOLOGY, the science of cosmetics [n]\n",
  "COSMETICOLOGY": "the science of cosmetics [n COSMETICOLOGIES]\n",
  "COSMETICS": "COSMETIC, a beauty preparation [n]\n",
  "COSMETOLOGIES": "COSMETOLOGY, the study of cosmetics [n]\n",
  "COSMETOLOGIST": "a person who gives beauty treatments, as to skin and hair [n -S]\n",
  "COSMETOLOGISTS": "COSMETOLOGIST, a person who gives beauty treatments, as to skin and hair [n]\n",
  "COSMETOLOGY": "the study of cosmetics [n COSMETOLOGIES]\n",
  "COSMIC": "pertaining to the cosmos, also COSMICAL [adj COSMICALLY]\n",
  "COSMICAL": "pertaining to the cosmos, also COSMIC [adj COSMICALLY]\n",
  "COSMICALLY": "COSMICAL, pertaining to the cosmos, also COSMIC [adv]\n",
  "COSMID": "a large plasmid used as a vector used in cloning [n -S]\n",
  "COSMIDS": "COSMID, a large plasmid used as a vector used in cloning [n]\n",
  "COSMIN": "a hard substance in fish scales, also COSMINE [n -S]\n",
  "COSMINE": "a hard substance in fish scales, also COSMIN [n -S]\n",
  "COSMINES": "COSMINE, a hard substance in fish scales, also COSMIN [n]\n",
  "COSMINS": "COSMIN, a hard substance in fish scales, also COSMINE [n]\n",
  "COSMISM": "the belief that the cosmos is a self-existing whole [n -S]\n",
  "COSMISMS": "COSMISM, the belief that the cosmos is a self-existing whole [n]\n",
  "COSMIST": "one who adheres to cosmism, the belief that the cosmos is a self-existing whole [n -S]\n",
  "COSMISTS": "COSMIST, one who adheres to cosmism, the belief that the cosmos is a self-existing whole [n]\n",
  "COSMOCHEMICAL": "relating to cosmochemistry [adj]\n",
  "COSMOCHEMIST": "one who practises cosmochemistry [n -S]\n",
  "COSMOCHEMISTRY": "a branch of chemistry that deals with the chemical composition of and changes in the universe [n]\n",
  "COSMOCHEMISTS": "COSMOCHEMIST, one who practises cosmochemistry [n]\n",
  "COSMOCRAT": "a ruler of the world [n -S]\n",
  "COSMOCRATIC": "like a cosmocrat [adj]\n",
  "COSMOCRATS": "COSMOCRAT, a ruler of the world [n]\n",
  "COSMODROME": "a launching-site for spacecraft [n -S]\n",
  "COSMODROMES": "COSMODROME, a launching-site for spacecraft [n]\n",
  "COSMOGENIC": "produced by interaction of cosmic rays with earth's surface [adj]\n",
  "COSMOGENIES": "COSMOGENY, a theory or myth of the origin of the universe, also COSMOGONY [n]\n",
  "COSMOGENY": "a theory or myth of the origin of the universe, also COSMOGONY [n COSMOGENIES]\n",
  "COSMOGONAL": "relating to cosmogony, also COSMOGONIC, COSMOGONICAL [adj]\n",
  "COSMOGONIC": "relating to cosmogony, also COSMOGONAL, COSMOGONICAL [adj]\n",
  "COSMOGONICAL": "relating to cosmogony, also COSMOGONAL, COSMOGONIC [adj]\n",
  "COSMOGONIES": "COSMOGONY, a theory or myth of the origin of the universe, also COSMOGENY [n]\n",
  "COSMOGONIST": "a student of cosmogony [n -S]\n",
  "COSMOGONISTS": "COSMOGONIST, a student of cosmogony [n]\n",
  "COSMOGONY": "a theory or myth of the origin of the universe, also COSMOGENY [n COSMOGONIES]\n",
  "COSMOGRAPHER": "a student of cosmography [n -S]\n",
  "COSMOGRAPHERS": "COSMOGRAPHER, a student of cosmography [n]\n",
  "COSMOGRAPHIC": "relating to cosmography, also COSMOGRAPHICAL [adj]\n",
  "COSMOGRAPHICAL": "relating to cosmography, also COSMOGRAPHIC [adj]\n",
  "COSMOGRAPHIES": "COSMOGRAPHY, a general description of the world or of the universe [n]\n",
  "COSMOGRAPHIST": "a practitioner of cosmography [n -S]\n",
  "COSMOGRAPHISTS": "COSMOGRAPHIST, a practitioner of cosmography [n]\n",
  "COSMOGRAPHY": "a general description of the world or of the universe [n COSMOGRAPHIES]\n",
  "COSMOID": "describing the scale structure of e.g. lungfish [adj]\n",
  "COSMOLATRIES": "COSMOLATRY, worship of the world [n]\n",
  "COSMOLATRY": "worship of the world [n COSMOLATRIES]\n",
  "COSMOLINE": "to smear with a kind of petroleum jelly as a rust prevention [v COSMOLINED, COSMOLINING, COSMOLINES]\n",
  "COSMOLINED": "COSMOLINE, to smear with a kind of petroleum jelly as a rust prevention [v]\n",
  "COSMOLINES": "COSMOLINE, to smear with a kind of petroleum jelly as a rust prevention [v]\n",
  "COSMOLINING": "COSMOLINE, to smear with a kind of petroleum jelly as a rust prevention [v]\n",
  "COSMOLOGIC": "relating to cosmology, also COSMOLOGICAL [adj COSMOLOGICALLY]\n",
  "COSMOLOGICAL": "relating to cosmology, also COSMOLOGIC [adj COSMOLOGICALLY]\n",
  "COSMOLOGICALLY": "COSMOLOGICAL, relating to cosmology, also COSMOLOGIC [adv]\n",
  "COSMOLOGIES": "COSMOLOGY, the study of the cosmos [n]\n",
  "COSMOLOGIST": "one who studies cosmology [n -S]\n",
  "COSMOLOGISTS": "COSMOLOGIST, one who studies cosmology [n]\n",
  "COSMOLOGY": "the study of the cosmos [n COSMOLOGIES]\n",
  "COSMONAUT": "a Russian astronaut [n -S]\n",
  "COSMONAUTICS": "Russian astronautics [n]\n",
  "COSMONAUTS": "COSMONAUT, a Russian astronaut [n]\n",
  "COSMOPLASTIC": "moulding or shaping the universe [adj]\n",
  "COSMOPOLIS": "a large city [n -ES]\n",
  "COSMOPOLISES": "COSMOPOLIS, a large city [n]\n",
  "COSMOPOLITAN": "a citizen of the world [n -S]\n",
  "COSMOPOLITANISM": "the state of being cosmopolitan [n]\n",
  "COSMOPOLITANS": "COSMOPOLITAN, a citizen of the world [n]\n",
  "COSMOPOLITE": "a cosmopolitan person or organism [n -S]\n",
  "COSMOPOLITES": "COSMOPOLITE, a cosmopolitan person or organism [n]\n",
  "COSMOPOLITIC": "relating to cosmopolitics, world politics, also COSMOPOLITICAL [adj]\n",
  "COSMOPOLITICAL": "relating to cosmopolitics, world politics, also COSMOPOLITIC [adj]\n",
  "COSMOPOLITICS": "world politics [n]\n",
  "COSMOPOLITISM": "the state of being cosmopolitan [n -S]\n",
  "COSMOPOLITISMS": "COSMOPOLITISM, the state of being cosmopolitan [n]\n",
  "COSMORAMA": "a view of different parts of the world [n -S]\n",
  "COSMORAMAS": "COSMORAMA, a view of different parts of the world [n]\n",
  "COSMORAMIC": "of or pertaining to a cosmorama [adj]\n",
  "COSMOS": "(Greek) the universe as an orderly system, also KOSMOS [n -ES]\n",
  "COSMOSES": "COSMOS, (Greek) the universe as an orderly system, also KOSMOS [n]\n",
  "COSMOSPHERE": "an apparatus for showing the position of the earth at any given time with reference to the fixed stars [n -S]\n",
  "COSMOSPHERES": "COSMOSPHERE, an apparatus for showing the position of the earth at any given time with reference to the fixed stars [n]\n",
  "COSMOTHEISM": "the belief that identifies God with the cosmos [n -S]\n",
  "COSMOTHEISMS": "COSMOTHEISM, the belief that identifies God with the cosmos [n]\n",
  "COSMOTHETIC": "assuming an external world, also COSMOTHETICAL [adj]\n",
  "COSMOTHETICAL": "assuming an external world, also COSMOTHETIC [adj]\n",
  "COSMOTRON": "a large synchrotron used for accelerating protons to high energies [n -S]\n",
  "COSMOTRONS": "COSMOTRON, a large synchrotron used for accelerating protons to high energies [n]\n",
  "COSPHERED": "(archaic) being in the same sphere [adj]\n",
  "COSPLAY": "the practice of dressing up as a fictional character to attend social events [n -S]\n",
  "COSPLAYS": "COSPLAY, the practice of dressing up as a fictional character to attend social events [n]\n",
  "COSPONSOR": "a joint sponsor [n -S] / to sponsor jointly [v -ED, -ING, -S]\n",
  "COSPONSORED": "COSPONSOR, to sponsor jointly [v]\n",
  "COSPONSORING": "COSPONSOR, to sponsor jointly [v]\n",
  "COSPONSORS": "COSPONSOR, to sponsor jointly [v]\n",
  "COSPONSORSHIP": "the state of being a cosponsor [n -S]\n",
  "COSPONSORSHIPS": "COSPONSORSHIP, the state of being a cosponsor [n]\n",
  "COSS": "(Hindi) a measure of distance in India, also KOS, KOSS [n -ES]\n",
  "COSSACK": "(Russian) a Russian cavalryman [n -S]\n",
  "COSSACKS": "COSSACK, (Russian) a Russian cavalryman [n]\n",
  "COSSES": "COSS, (Hindi) a measure of distance in India, also KOS, KOSS [n]\n",
  "COSSET": "to fondle or pamper [v COSSETED or COSSETTED, COSSETING or COSSETTING, COSSETS]\n",
  "COSSETED": "COSSET, to fondle or pamper [v]\n",
  "COSSETING": "COSSET, to fondle or pamper [v]\n",
  "COSSETS": "COSSET, to fondle or pamper [v]\n",
  "COSSETTED": "pampered, spoilt [adj]\n",
  "COSSETTING": "COSSET, to fondle or pamper [v]\n",
  "COSSIE": "(Australian slang) costume, clothes, also COZZIE [n -S]\n",
  "COSSIES": "COSSIE, (Australian slang) costume, clothes, also COZZIE [n]\n",
  "COST": "to estimate a price for production of [v -ED, -ING, -S]\n",
  "COSTA": "(Latin) a rib [n COSTAE]\n",
  "COSTAE": "COSTA, (Latin) a rib [n]\n",
  "COSTAL": "of or pertaining to the ribs [adj COSTALLY] / a rib which supports an insect's wing [n -S]\n",
  "COSTALGIA": "pain around the chest due to damage to a rib or nerve running below a rib [n -S]\n",
  "COSTALGIAS": "COSTALGIA, pain around the chest due to damage to a rib or nerve running below a rib [n]\n",
  "COSTALLY": "relating to the ribs [adv]\n",
  "COSTALS": "COSTAL, a rib which supports an insect's wing [n]\n",
  "COSTAR": "to star equally with another actor [v COSTARRED, COSTARRING, COSTARS]\n",
  "COSTARD": "an apple, large and round like the head [n -S]\n",
  "COSTARDMONGER": "a hawker of fruits, vegetables, fish, etc., also COSTERMONGER [n -S]\n",
  "COSTARDMONGERS": "COSTARDMONGER, a hawker of fruits, vegetables, fish, etc., also COSTERMONGER [n]\n",
  "COSTARDS": "COSTARD, an apple, large and round like the head [n]\n",
  "COSTARRED": "COSTAR, to star equally with another actor [v]\n",
  "COSTARRING": "COSTAR, to star equally with another actor [v]\n",
  "COSTARS": "COSTAR, to star equally with another actor [v]\n",
  "COSTATE": "having ribs, also COSTATED [adj]\n",
  "COSTATED": "having ribs, also COSTATE [adj]\n",
  "COSTE": "(Spenser) a coast [n -S]\n",
  "COSTEAN": "in mining, to sink pits through the surface soil to the underlying rock in order to establish the direction of a lode [v -ED, -ING, -S]\n",
  "COSTEANED": "COSTEAN, in mining, to sink pits through the surface soil to the underlying rock in order to establish the direction of a lode [v]\n",
  "COSTEANING": "the act of sinking pits [n -S]\n",
  "COSTEANINGS": "COSTEANING, the act of sinking pits [n]\n",
  "COSTEANS": "COSTEAN, in mining, to sink pits through the surface soil to the underlying rock in order to establish the direction of a lode [v]\n",
  "COSTED": "COST, to estimate a price for production of [v]\n",
  "COSTER": "a seller of fruit and vegetables [n -S]\n",
  "COSTERMONGER": "a hawker of fruits, vegetables, fish, etc., also COSTARDMONGER [n -S]\n",
  "COSTERMONGERS": "COSTERMONGER, a hawker of fruits, vegetables, fish, etc., also COSTARDMONGER [n]\n",
  "COSTERS": "COSTER, a seller of fruit and vegetables [n]\n",
  "COSTES": "COSTE, (Spenser) a coast [n]\n",
  "COSTING": "an estimation of the cost of something [n -S]\n",
  "COSTINGS": "COSTING, an estimation of the cost of something [n]\n",
  "COSTIVE": "affected with constipation, causing constipation [adj COSTIVELY]\n",
  "COSTIVELY": "COSTIVE, affected with constipation, causing constipation [adv]\n",
  "COSTIVENESS": "constipation [n -ES]\n",
  "COSTIVENESSES": "COSTIVENESS, constipation [n]\n",
  "COSTLESS": "free of charge [adj COSTLESSLY]\n",
  "COSTLESSLY": "COSTLESS, free of charge [adv]\n",
  "COSTLIER": "COSTLY, expensive [adj]\n",
  "COSTLIEST": "COSTLY, expensive [adj]\n",
  "COSTLINESS": "the state of being costly [n -ES]\n",
  "COSTLINESSES": "COSTLINESS, the state of being costly [n]\n",
  "COSTLY": "expensive [adj COSTLIER, COSTLIEST]\n",
  "COSTMARIES": "COSTMARY, a garden plant having a strong balsamic smell, aka alecost, used as a pot herb and salad plant and in flavoring ale and beer [n]\n",
  "COSTMARY": "a garden plant having a strong balsamic smell, aka alecost, used as a pot herb and salad plant and in flavoring ale and beer [n COSTMARIES]\n",
  "COSTOTOMIES": "COSTOTOMY, surgical incision into a rib [n]\n",
  "COSTOTOMY": "surgical incision into a rib [n COSTOTOMIES]\n",
  "COSTREL": "an eared bottle or small flask, to be hung at the waist [n -S]\n",
  "COSTRELS": "COSTREL, an eared bottle or small flask, to be hung at the waist [n]\n",
  "COSTS": "COST, to estimate a price for production of [v]\n",
  "COSTUME": "to dress [v COSTUMED, COSTUMING, COSTUMES]\n",
  "COSTUMED": "COSTUME, to dress [v]\n",
  "COSTUMER": "one who makes or deals in costumes, as for theaters, fancy balls, etc., also COSTUMIER [n -S]\n",
  "COSTUMERIES": "COSTUMERY, costumes taken collectively [n]\n",
  "COSTUMERS": "COSTUMER, one who makes or deals in costumes, as for theaters, fancy balls, etc., also COSTUMIER [n]\n",
  "COSTUMERY": "costumes taken collectively [n COSTUMERIES]\n",
  "COSTUMES": "COSTUME, to dress [v]\n",
  "COSTUMEY": "pertaining to a costume [adj]\n",
  "COSTUMIER": "one who makes or deals in costumes, as for theaters, fancy balls, etc., also COSTUMER [n -S]\n",
  "COSTUMIERS": "COSTUMIER, one who makes or deals in costumes, as for theaters, fancy balls, etc., also COSTUMER [n]\n",
  "COSTUMING": "the act of dressing [n -S]\n",
  "COSTUMINGS": "COSTUMING, the act of dressing [n]\n",
  "COSTUS": "an aromatic root of the ginger family [n -ES]\n",
  "COSTUSES": "COSTUS, an aromatic root of the ginger family [n]\n",
  "COSURFACTANT": "something that works in combination with a surfactant [n -S]\n",
  "COSURFACTANTS": "COSURFACTANT, something that works in combination with a surfactant [n]\n",
  "COSY": "to attempt to get on friendly terms, also COZY [v COSIED, COSYING, COSIES] / snug and comfortable, also COZY [adj COSIER, COSIEST]\n",
  "COSYING": "COSY, to attempt to get on friendly terms, also COZY [v]\n",
  "COT": "to become tangled [v COTTED, COTTING, COTS]\n",
  "COTAN": "(short for) cotangent, a trigonometrical function of an angle [n -S]\n",
  "COTANGENT": "the tangent of the complement of an arc or angle [n -S]\n",
  "COTANGENTIAL": "of or like a cotangent [adj]\n",
  "COTANGENTS": "COTANGENT, the tangent of the complement of an arc or angle [n]\n",
  "COTANS": "COTAN, (short for) cotangent, a trigonometrical function of an angle [n]\n",
  "COTE": "to pass by; to outstrip (as one dog another) [v COTED, COTING, COTES]\n",
  "COTEAU": "(Canadian) uplands; the higher ground of a region [n COTEAUX or COTEAUS]\n",
  "COTEAUS": "COTEAU, (Canadian) uplands; the higher ground of a region [n]\n",
  "COTEAUX": "COTEAU, (Canadian) uplands; the higher ground of a region [n]\n",
  "COTED": "COTE, to pass by; to outstrip (as one dog another) [v]\n",
  "COTELETTE": "(French) a cutlet, a chop [n -S]\n",
  "COTELETTES": "COTELETTE, (French) a cutlet, a chop [n]\n",
  "COTELINE": "a medieval close-fitting sleeved tunic, worn by both sexes [n -S]\n",
  "COTELINES": "COTELINE, a medieval close-fitting sleeved tunic, worn by both sexes [n]\n",
  "COTEMPORANEOUS": "existing, occurring, or originating during the same time, also CONTEMPORANEOUS [adj]\n",
  "COTEMPORARY": "contemporary, also CONTEMPORARY [adj]\n",
  "COTENANCIES": "COTENANCY, a joint tenancy [n]\n",
  "COTENANCY": "a joint tenancy [n COTENANCIES]\n",
  "COTENANT": "a joint tenant [n -S]\n",
  "COTENANTS": "COTENANT, a joint tenant [n]\n",
  "COTERIE": "(French) a social or literary circle [n -S]\n",
  "COTERIES": "COTERIE, (French) a social or literary circle [n]\n",
  "COTERMINOUS": "having the same or coincident boundaries, also CONTERMINAL, CONTERMINANT, CONTERMINATE, CONTERMINOUS [adj COTERMINOUSLY]\n",
  "COTERMINOUSLY": "COTERMINOUS, having the same or coincident boundaries, also CONTERMINAL, CONTERMINANT, CONTERMINATE, CONTERMINOUS [adv]\n",
  "COTES": "COTE, to pass by; to outstrip (as one dog another) [v]\n",
  "COTH": "(short for) hyperbolic cotangent [n -S]\n",
  "COTHS": "COTH, (short for) hyperbolic cotangent [n]\n",
  "COTHURN": "a buskin worn by Roman actors [n -S]\n",
  "COTHURNAL": "like a cothurnus [adj]\n",
  "COTHURNI": "COTHURN, a buskin worn by Roman actors [n]\n",
  "COTHURNS": "COTHURN, a buskin worn by Roman actors [n]\n",
  "COTHURNUS": "(Latin) a buskin anciently used by tragic actors on the stage, also COTHURN [n COTHURNI]\n",
  "COTICULAR": "(obsolete) of or pertaining to whetstones [adj]\n",
  "COTIDAL": "having high tide at the same time [adj]\n",
  "COTIJA": "a kind of Mexican cheese [n -S]\n",
  "COTIJAS": "COTIJA, a kind of Mexican cheese [n]\n",
  "COTILLION": "(French) an elaborate ballroom dance with frequent changes of partner, also COTILLON [n -S]\n",
  "COTILLIONS": "COTILLION, (French) an elaborate ballroom dance with frequent changes of partner, also COTILLON [n]\n",
  "COTILLON": "(French) an elaborate ballroom dance with frequent changes of partner, also COTILLION [n -S]\n",
  "COTILLONS": "COTILLON, (French) an elaborate ballroom dance with frequent changes of partner, also COTILLION [n]\n",
  "COTING": "COTE, to pass by; to outstrip (as one dog another) [v]\n",
  "COTINGA": "(Tupi) a tropical bird with bright plumage [n -S]\n",
  "COTINGAS": "COTINGA, (Tupi) a tropical bird with bright plumage [n]\n",
  "COTININE": "an alkaloid produced by nicotine in the body [n -S]\n",
  "COTININES": "COTININE, an alkaloid produced by nicotine in the body [n]\n",
  "COTISE": "to give a heraldic border, also COTTISE [v COTISED, COTISING, COTISES]\n",
  "COTISED": "COTISE, to give a heraldic border, also COTTISE [v]\n",
  "COTISES": "COTISE, to give a heraldic border, also COTTISE [v]\n",
  "COTISING": "COTISE, to give a heraldic border, also COTTISE [v]\n",
  "COTLAND": "land belonging to a cottage [n -S]\n",
  "COTLANDS": "COTLAND, land belonging to a cottage [n]\n",
  "COTONEASTER": "any shrub or small tree of the genus Cotoneaster, related to hawthorn [n -S]\n",
  "COTONEASTERS": "COTONEASTER, any shrub or small tree of the genus Cotoneaster, related to hawthorn [n]\n",
  "COTQUEAN": "a woman of humble birth; a man who does women's work [n -S]\n",
  "COTQUEANS": "COTQUEAN, a woman of humble birth; a man who does women's work [n]\n",
  "COTRANSDUCE": "to transduce jointly [v COTRANSDUCED, COTRANSDUCING, COTRANSDUCES]\n",
  "COTRANSDUCED": "COTRANSDUCE, to transduce jointly [v]\n",
  "COTRANSDUCES": "COTRANSDUCE, to transduce jointly [v]\n",
  "COTRANSDUCING": "COTRANSDUCE, to transduce jointly [v]\n",
  "COTRANSDUCTION": "the process by which two genetic markers are simultaneously packaged within a bacteriophage for transfer to a new host bacterium [n -S]\n",
  "COTRANSDUCTIONS": "COTRANSDUCTION, the process by which two genetic markers are simultaneously packaged within a bacteriophage for transfer to a new host bacterium [n]\n",
  "COTRANSFER": "a transfer jointly with another [n -S]\n",
  "COTRANSFERS": "COTRANSFER, a transfer jointly with another [n]\n",
  "COTRANSPORT": "to transport jointly [v -ED, -ING, -S]\n",
  "COTRANSPORTED": "COTRANSPORT, to transport jointly [v]\n",
  "COTRANSPORTING": "COTRANSPORT, to transport jointly [v]\n",
  "COTRANSPORTS": "COTRANSPORT, to transport jointly [v]\n",
  "COTRUSTEE": "a joint trustee [n -S]\n",
  "COTRUSTEES": "COTRUSTEE, a joint trustee [n]\n",
  "COTS": "COT [n]\n",
  "COTT": "(Spenser) a small boat [n -S]\n",
  "COTTA": "(Latin) a short surplice [n COTTAS or COTTAE]\n",
  "COTTABUS": "(Greek) an ancient Greek game of throwing wine into a vessel, also KOTTABOS [n -ES]\n",
  "COTTABUSES": "COTTABUS, (Greek) an ancient Greek game of throwing wine into a vessel, also KOTTABOS [n]\n",
  "COTTAE": "COTTA, (Latin) a short surplice [n]\n",
  "COTTAGE": "to cruise looking for homosexual partners [v COTTAGED, COTTAGING, COTTAGES]\n",
  "COTTAGED": "COTTAGE, to cruise looking for homosexual partners [v]\n",
  "COTTAGER": "one who lives in a cottage [n -S]\n",
  "COTTAGERS": "COTTAGER, one who lives in a cottage [n]\n",
  "COTTAGES": "COTTAGE, to cruise looking for homosexual partners [v]\n",
  "COTTAGEY": "like a cottage [adj COTTAGIER, COTTAGIEST]\n",
  "COTTAGIER": "COTTAGEY, like a cottage [adj]\n",
  "COTTAGIEST": "COTTAGEY, like a cottage [adj]\n",
  "COTTAGING": "cruising looking for homosexual partners [n -S]\n",
  "COTTAGINGS": "COTTAGING, cruising looking for homosexual partners [n]\n",
  "COTTAR": "(Scots) a medieval peasant inhabiting a cottage, also COTTER, COTTIER [n -S]\n",
  "COTTARS": "COTTAR, (Scots) a medieval peasant inhabiting a cottage, also COTTER, COTTIER [n]\n",
  "COTTAS": "COTTA, (Latin) a short surplice [n]\n",
  "COTTED": "COT, to become tangled [v]\n",
  "COTTER": "a medieval peasant inhabiting a cottage, also COTTAR, COTTIER [n -S] / to secure with a kind of pin [v -ED, -ING, -S]\n",
  "COTTERED": "COTTER, to secure with a kind of pin [v]\n",
  "COTTERING": "COTTER, to secure with a kind of pin [v]\n",
  "COTTERLESS": "without cotters [adj]\n",
  "COTTERS": "COTTER, to secure with a kind of pin [v]\n",
  "COTTID": "a type of fish, also COTTUS [n -S]\n",
  "COTTIDS": "COTTID, a type of fish, also COTTUS [n]\n",
  "COTTIER": "an Irish tenant holding land as the highest bidder, also COTTAR, COTTER [n -S]\n",
  "COTTIERISM": "the cottier system of land tenure [n -S]\n",
  "COTTIERISMS": "COTTIERISM, the cottier system of land tenure [n]\n",
  "COTTIERS": "COTTIER, an Irish tenant holding land as the highest bidder, also COTTAR, COTTER [n]\n",
  "COTTING": "COT, to become tangled [v]\n",
  "COTTISE": "(French) to give a heraldic border, also COTISE [v COTTISED, COTTISING, COTTISES]\n",
  "COTTISED": "COTTISE, (French) to give a heraldic border, also COTISE [v]\n",
  "COTTISES": "COTTISE, (French) to give a heraldic border, also COTISE [v]\n",
  "COTTISING": "COTTISE, (French) to give a heraldic border, also COTISE [v]\n",
  "COTTOID": "like a cottid, a fish of the genus Cottus [adj]\n",
  "COTTON": "to take a liking to [v -ED, -ING, -S]\n",
  "COTTONADE": "a somewhat stout and thick fabric of cotton [n -S]\n",
  "COTTONADES": "COTTONADE, a somewhat stout and thick fabric of cotton [n]\n",
  "COTTONED": "COTTON, to take a liking to [v]\n",
  "COTTONIER": "COTTONY, having the texture of cotton [adj]\n",
  "COTTONIEST": "COTTONY, having the texture of cotton [adj]\n",
  "COTTONING": "COTTON, to take a liking to [v]\n",
  "COTTONMOUTH": "a venomous semiaquatic snake of swamps in southern US [n -S]\n",
  "COTTONMOUTHS": "COTTONMOUTH, a venomous semiaquatic snake of swamps in southern US [n]\n",
  "COTTONOCRACIES": "COTTONOCRACY, rule by cotton producers [n]\n",
  "COTTONOCRACY": "rule by cotton producers [n COTTONOCRACIES]\n",
  "COTTONS": "COTTON, to take a liking to [v]\n",
  "COTTONSEED": "the seed of the cotton plant, yielding a valuable oil [n -S]\n",
  "COTTONSEEDS": "COTTONSEED, the seed of the cotton plant, yielding a valuable oil [n]\n",
  "COTTONTAIL": "any of several species of rabbits of the genus Sylvilagus, the ordinary rabbit of the US [n -S]\n",
  "COTTONTAILS": "COTTONTAIL, any of several species of rabbits of the genus Sylvilagus, the ordinary rabbit of the US [n]\n",
  "COTTONWEED": "a cottony seaside composite plant, aka cudweed [n -S]\n",
  "COTTONWEEDS": "COTTONWEED, a cottony seaside composite plant, aka cudweed [n]\n",
  "COTTONWOOD": "an American tree of the poplar genus, having seeds covered with abundant cotton-like hairs [n -S]\n",
  "COTTONWOODS": "COTTONWOOD, an American tree of the poplar genus, having seeds covered with abundant cotton-like hairs [n]\n",
  "COTTONY": "having the texture of cotton [adj COTTONIER, COTTONIEST]\n",
  "COTTOWN": "(Scots) a group of outhouses [n -S]\n",
  "COTTOWNS": "COTTOWN, (Scots) a group of outhouses [n]\n",
  "COTTS": "COTT, (Spenser) a small boat [n]\n",
  "COTTUS": "any fish of the genus Cottus, including the bullhead and father-lasher, also COTTID [n -ES]\n",
  "COTTUSES": "COTTUS, any fish of the genus Cottus, including the bullhead and father-lasher, also COTTID [n]\n",
  "COTURNIX": "a small quail [n -ES]\n",
  "COTURNIXES": "COTURNIX, a small quail [n]\n",
  "COTWAL": "(Hindi) the chief constable of an Indian town, also KOTWAL [n -S]\n",
  "COTWALS": "COTWAL, (Hindi) the chief constable of an Indian town, also KOTWAL [n]\n",
  "COTYLAE": "COTYLE, (Greek) an ancient Greek cup [n]\n",
  "COTYLE": "(Greek) an ancient Greek cup [n COTYLES or COTYLAE]\n",
  "COTYLEDON": "an embryonic leaf within a seed which may act as a food reserve or which may grow and photosynthesize [n -S]\n",
  "COTYLEDONAL": "like a cotyledon [adj]\n",
  "COTYLEDONARY": "relating to or having cotyledons, also COTYLEDONOUS [adj]\n",
  "COTYLEDONOID": "in the form of a cotyledon [adj]\n",
  "COTYLEDONOUS": "relating to or having cotyledons, also COTYLEDONARY [adj]\n",
  "COTYLEDONS": "COTYLEDON, an embryonic leaf within a seed which may act as a food reserve or which may grow and photosynthesize [n]\n",
  "COTYLES": "COTYLE, (Greek) an ancient Greek cup [n]\n",
  "COTYLIFORM": "disc-shaped with a raised rim [adj]\n",
  "COTYLOID": "cup-shaped [adj] / the cavity which receives the head of the thigh bone [n -S]\n",
  "COTYLOIDAL": "a small bone forming part of the acetabular cavity in some mammals, also COTYLOID [n -S]\n",
  "COTYLOIDALS": "COTYLOIDAL, a small bone forming part of the acetabular cavity in some mammals, also COTYLOID [n]\n",
  "COTYLOIDS": "COTYLOID, the cavity which receives the head of the thigh bone [n]\n",
  "COTYLOSAUR": "an extinct primitive reptile with massive body and short legs [n -S]\n",
  "COTYLOSAURS": "COTYLOSAUR, an extinct primitive reptile with massive body and short legs [n]\n",
  "COTYPE": "a taxonomic type [n -S]\n",
  "COTYPES": "COTYPE, a taxonomic type [n]\n",
  "COUCAL": "(French) a large, Old World, ground cuckoo of the genus Centropus, of several species [n -S]\n",
  "COUCALS": "COUCAL, (French) a large, Old World, ground cuckoo of the genus Centropus, of several species [n]\n",
  "COUCH": "to put into words [v -ED, -ING, -ES]\n",
  "COUCHANT": "in heraldry, lying on the belly with head lifted [adj]\n",
  "COUCHE": "(French) an evening reception, also COUCHEE [n -S]\n",
  "COUCHED": "COUCH, to put into words [v]\n",
  "COUCHEE": "(French) an evening reception, also COUCHE [n -S]\n",
  "COUCHEES": "COUCHEE, (French) an evening reception, also COUCHE [n]\n",
  "COUCHER": "one who couches [n -S]\n",
  "COUCHERS": "COUCHER, one who couches [n]\n",
  "COUCHES": "COUCH, to put into words [v]\n",
  "COUCHETTE": "(French) a sleeping-berth on a continental train [n -S]\n",
  "COUCHETTES": "COUCHETTE, (French) a sleeping-berth on a continental train [n]\n",
  "COUCHING": "embroidery in which the surface is covered with threads and these are secured by stitches forming a pattern [n -S]\n",
  "COUCHINGS": "COUCHING, embroidery in which the surface is covered with threads and these are secured by stitches forming a pattern [n]\n",
  "COUCHSURFING": "the practice of sleeping overnight in the houses of friends or fellow members of a social network, esp. as an alternative to staying in hotels, hostels, etc. [n -S]\n",
  "COUCHSURFINGS": "COUCHSURFING, the practice of sleeping overnight in the houses of friends or fellow members of a social network, esp. as an alternative to staying in hotels, hostels, etc. [n]\n",
  "COUDE": "(French) a reflecting telescope in which one or more plane mirrors reflects the light down the polar axis [n -S]\n",
  "COUDES": "COUDE, (French) a reflecting telescope in which one or more plane mirrors reflects the light down the polar axis [n]\n",
  "COUGAN": "(Australian slang) a rowdy heavy drinker [n -S]\n",
  "COUGANS": "COUGAN, (Australian slang) a rowdy heavy drinker [n]\n",
  "COUGAR": "a mountain lion, also COUGUAR [n -S]\n",
  "COUGARS": "COUGAR, a mountain lion, also COUGUAR [n]\n",
  "COUGH": "to expel air from the lungs noisily [v -ED, -ING, -S]\n",
  "COUGHED": "COUGH, to expel air from the lungs noisily [v]\n",
  "COUGHER": "one that coughs [n -S]\n",
  "COUGHERS": "COUGHER, one that coughs [n]\n",
  "COUGHING": "the act of giving a cough [n -S]\n",
  "COUGHINGS": "COUGHING, the act of giving a cough [n]\n",
  "COUGHS": "COUGH, to expel air from the lungs noisily [v]\n",
  "COUGUAR": "a mountain lion, also COUGAR [n -S]\n",
  "COUGUARS": "COUGUAR, a mountain lion, also COUGAR [n]\n",
  "COULD": "CAN, to put in a cylindrical container [v]\n",
  "COULDEST": "(archaic) 2nd person past tense singular of can, also COULDST [v]\n",
  "COULDST": "(archaic) 2nd person past tense singular of can, also COULDEST [v]\n",
  "COULEE": "(French) a lava-flow; a rocky ravine [n -S]\n",
  "COULEES": "COULEE, (French) a lava-flow; a rocky ravine [n]\n",
  "COULIBIAC": "(Russian) a Russian fish pie, also COULIBIACA, KOULIBIACA [n -S]\n",
  "COULIBIACA": "(Russian) a Russian fish pie, also COULIBIAC, KOULIBIACA [n -S]\n",
  "COULIBIACAS": "COULIBIACA, (Russian) a Russian fish pie, also COULIBIAC, KOULIBIACA [n]\n",
  "COULIBIACS": "COULIBIAC, (Russian) a Russian fish pie, also COULIBIACA, KOULIBIACA [n]\n",
  "COULIS": "(French) a thin puree of fish, fowl, fruit or vegetables [n COULIS]\n",
  "COULISSE": "(French) a piece of timber having a groove in which something glides [n -S]\n",
  "COULISSES": "COULISSE, (French) a piece of timber having a groove in which something glides [n]\n",
  "COULOIR": "(French) a steep mountainside gorge [n -S]\n",
  "COULOIRS": "COULOIR, (French) a steep mountainside gorge [n]\n",
  "COULOMB": "(French) the SI unit of electric charge [n -S]\n",
  "COULOMBIC": "of or like a coulomb, the SI unit of electric charge [adj]\n",
  "COULOMBMETER": "an instrument for measuring the amount of a substance released in electrolysis, also COULOMETER [n -S]\n",
  "COULOMBMETERS": "COULOMBMETER, an instrument for measuring the amount of a substance released in electrolysis, also COULOMETER [n]\n",
  "COULOMBS": "COULOMB, (French) the SI unit of electric charge [n]\n",
  "COULOMETER": "an instrument for measuring the amount of a substance released in electrolysis, also COULOMBMETER [n -S]\n",
  "COULOMETERS": "COULOMETER, an instrument for measuring the amount of a substance released in electrolysis, also COULOMBMETER [n]\n",
  "COULOMETRIC": "relating to coulometry [adj COULOMETRICALLY]\n",
  "COULOMETRICALLY": "COULOMETRIC, relating to coulometry [adv]\n",
  "COULOMETRIES": "COULOMETRY, (chemical analysis by) measurement of the number of coulombs used in electrolysis [n]\n",
  "COULOMETRY": "(chemical analysis by) measurement of the number of coulombs used in electrolysis [n COULOMETRIES]\n",
  "COULTER": "a blade on a plow, also COLTER, CULTER [n -S]\n",
  "COULTERS": "COULTER, a blade on a plow, also COLTER, CULTER [n]\n",
  "COUMARIC": "of coumarin, also CUMARIC [adj]\n",
  "COUMARILIC": "of or like coumarin [adj]\n",
  "COUMARIN": "(Tupi) a crystalline compound obtained from Tonka beans, woodruff, melilot, etc used medicinally to prevent coagulation of the blood, also CUMARIN [n -S]\n",
  "COUMARINS": "COUMARIN, (Tupi) a crystalline compound obtained from Tonka beans, woodruff, melilot, etc used medicinally to prevent coagulation of the blood, also CUMARIN [n]\n",
  "COUMARONE": "a liquid derived from coal tar, also CUMARONE [n -S]\n",
  "COUMARONES": "COUMARONE, a liquid derived from coal tar, also CUMARONE [n]\n",
  "COUMAROU": "(Tupi) the seed of a tropical tree, aka tonka bean [n -S]\n",
  "COUMAROUS": "COUMAROU, (Tupi) the seed of a tropical tree, aka tonka bean [n]\n",
  "COUNCIL": "an assembly appointed for a certain reason [n -S]\n",
  "COUNCILLOR": "a member of a council, also COUNCILOR [n -S]\n",
  "COUNCILLORS": "COUNCILLOR, a member of a council, also COUNCILOR [n]\n",
  "COUNCILLORSHIP": "the office of councillor, also COUNCILORSHIP [n -S]\n",
  "COUNCILLORSHIPS": "COUNCILLORSHIP, the office of councillor, also COUNCILORSHIP [n]\n",
  "COUNCILMAN": "a member of a council, esp. of the common council of a city [n COUNCILMEN]\n",
  "COUNCILMANIC": "relating to a councilman [adj]\n",
  "COUNCILMEN": "COUNCILMAN, a member of a council, esp. of the common council of a city [n]\n",
  "COUNCILOR": "(US) a member of a council, also COUNCILLOR [n -S]\n",
  "COUNCILORS": "COUNCILOR, (US) a member of a council, also COUNCILLOR [n]\n",
  "COUNCILORSHIP": "(US) the office of councilor, also COUNCILLORSHIP [n -S]\n",
  "COUNCILORSHIPS": "COUNCILORSHIP, (US) the office of councilor, also COUNCILLORSHIP [n]\n",
  "COUNCILS": "COUNCIL, an assembly appointed for a certain reason [n]\n",
  "COUNCILWOMAN": "a woman who is a member of a council [n COUNCILWOMEN]\n",
  "COUNCILWOMEN": "COUNCILWOMAN, a woman who is a member of a council [n]\n",
  "COUNSEL": "to advise [v COUNSELED or COUNSELLED, COUNSELING or COUNSELLING, COUNSELS]\n",
  "COUNSELABLE": "able to be counseled, also COUNSELLABLE [adj]\n",
  "COUNSELED": "COUNSEL, to advise [v]\n",
  "COUNSELEE": "one who is counselled, also COUNSELLEE [n -S]\n",
  "COUNSELEES": "COUNSELEE, one who is counselled, also COUNSELLEE [n]\n",
  "COUNSELING": "the act of giving counsel [n -S]\n",
  "COUNSELINGS": "COUNSELING, the act of giving counsel [n]\n",
  "COUNSELLABLE": "able to be counselled, also COUNSELABLE [adj]\n",
  "COUNSELLED": "COUNSEL, to advise [v]\n",
  "COUNSELLEE": "one who is counselled, also COUNSELEE [n -S]\n",
  "COUNSELLEES": "COUNSELLEE, one who is counselled, also COUNSELEE [n]\n",
  "COUNSELLING": "the act of giving counsel [n -S]\n",
  "COUNSELLINGS": "COUNSELLING, the act of giving counsel [n]\n",
  "COUNSELLOR": "one who gives counsel, also COUNSELOR [n -S]\n",
  "COUNSELLORS": "COUNSELLOR, one who gives counsel, also COUNSELOR [n]\n",
  "COUNSELLORSHIP": "the office of counsellor, also COUNSELORSHIP [n -S]\n",
  "COUNSELLORSHIPS": "COUNSELLORSHIP, the office of counsellor, also COUNSELORSHIP [n]\n",
  "COUNSELOR": "(US) one who gives counsel, also COUNSELLOR [n -S]\n",
  "COUNSELORS": "COUNSELOR, (US) one who gives counsel, also COUNSELLOR [n]\n",
  "COUNSELORSHIP": "(US) the office of counselor, also COUNSELLORSHIP [n -S]\n",
  "COUNSELORSHIPS": "COUNSELORSHIP, (US) the office of counselor, also COUNSELLORSHIP [n]\n",
  "COUNSELS": "COUNSEL, to advise [v]\n",
  "COUNT": "to number [v -ED, -ING, -S]\n",
  "COUNTABILITIES": "COUNTABILITY, the quality of being countable [n]\n",
  "COUNTABILITY": "the quality of being countable [n COUNTABILITIES]\n",
  "COUNTABLE": "that can be counted, also COMPTABLE, COMPTIBLE [adj COUNTABLY]\n",
  "COUNTABLY": "COUNTABLE, that can be counted, also COMPTABLE, COMPTIBLE [adv]\n",
  "COUNTBACK": "a system of deciding the winner of a tied competition by comparing earlier points or scores [n -S]\n",
  "COUNTBACKS": "COUNTBACK, a system of deciding the winner of a tied competition by comparing earlier points or scores [n]\n",
  "COUNTDOWN": "a descending count or counted check to a moment of happening regarded as zero [n -S]\n",
  "COUNTDOWNS": "COUNTDOWN, a descending count or counted check to a moment of happening regarded as zero [n]\n",
  "COUNTED": "COUNT, to number [v]\n",
  "COUNTENANCE": "to approve of, condone [v COUNTENANCED, COUNTENANCING, COUNTENANCES]\n",
  "COUNTENANCED": "COUNTENANCE, to approve of, condone [v]\n",
  "COUNTENANCER": "one who countenances [n -S]\n",
  "COUNTENANCERS": "COUNTENANCER, one who countenances [n]\n",
  "COUNTENANCES": "COUNTENANCE, to approve of, condone [v]\n",
  "COUNTENANCING": "COUNTENANCE, to approve of, condone [v]\n",
  "COUNTER": "to oppose [v -ED, -ING, -S]\n",
  "COUNTERACT": "to act counter or in opposition to [v -ED, -ING, -S]\n",
  "COUNTERACTED": "COUNTERACT, to act counter or in opposition to [v]\n",
  "COUNTERACTING": "COUNTERACT, to act counter or in opposition to [v]\n",
  "COUNTERACTION": "an opposing action [n -S]\n",
  "COUNTERACTIONS": "COUNTERACTION, an opposing action [n]\n",
  "COUNTERACTIVE": "serving to counteract [adj COUNTERACTIVELY]\n",
  "COUNTERACTIVELY": "COUNTERACTIVE, serving to counteract [adv]\n",
  "COUNTERACTS": "COUNTERACT, to act counter or in opposition to [v]\n",
  "COUNTERAGENT": "anything which counteracts [n -S]\n",
  "COUNTERAGENTS": "COUNTERAGENT, anything which counteracts [n]\n",
  "COUNTERARGUE": "to argue against [v COUNTERARGUED, COUNTERARGUING, COUNTERARGUES]\n",
  "COUNTERARGUED": "COUNTERARGUE, to argue against [v]\n",
  "COUNTERARGUES": "COUNTERARGUE, to argue against [v]\n",
  "COUNTERARGUING": "COUNTERARGUE, to argue against [v]\n",
  "COUNTERARGUMENT": "an opposing argument [n]\n",
  "COUNTERASSAULT": "a counterattack [n -S]\n",
  "COUNTERASSAULTS": "COUNTERASSAULT, a counterattack [n]\n",
  "COUNTERATTACK": "to attack in response to an attack [v -ED, -S]\n",
  "COUNTERATTACKED": "COUNTERATTACK, to attack in response to an attack [v]\n",
  "COUNTERATTACKER": "COUNTERATTACK, to attack in response to an attack [v]\n",
  "COUNTERATTACKS": "COUNTERATTACK, to attack in response to an attack [v]\n",
  "COUNTERBALANCE": "to oppose or balance with an equal weight or force [v COUNTERBALANCED, COUNTERBALANCES]\n",
  "COUNTERBALANCED": "COUNTERBALANCE, to oppose or balance with an equal weight or force [v]\n",
  "COUNTERBALANCES": "COUNTERBALANCE, to oppose or balance with an equal weight or force [v]\n",
  "COUNTERBASE": "(Italian) the double bass, also CONTRABASS, CONTRABASSO, CONTRABBASSO [n -S]\n",
  "COUNTERBASES": "COUNTERBASE, (Italian) the double bass, also CONTRABASS, CONTRABASSO, CONTRABBASSO [n]\n",
  "COUNTERBID": "a bid made in opposition to another bid [n -S]\n",
  "COUNTERBIDDER": "one who makes a counterbid [n -S]\n",
  "COUNTERBIDDERS": "COUNTERBIDDER, one who makes a counterbid [n]\n",
  "COUNTERBIDS": "COUNTERBID, a bid made in opposition to another bid [n]\n",
  "COUNTERBLAST": "a defiant pronouncement or denunciation [n -S]\n",
  "COUNTERBLASTS": "COUNTERBLAST, a defiant pronouncement or denunciation [n]\n",
  "COUNTERBLOCKADE": "an opposing blockade [n]\n",
  "COUNTERBLOW": "a blow in return [n -S]\n",
  "COUNTERBLOWS": "COUNTERBLOW, a blow in return [n]\n",
  "COUNTERBLUFF": "actions or words intended as a bluff, made in opposition to someone else's bluff [n -S]\n",
  "COUNTERBLUFFS": "COUNTERBLUFF, actions or words intended as a bluff, made in opposition to someone else's bluff [n]\n",
  "COUNTERBOND": "a bond to protect a person who has given bond for another from contingent loss [n -S]\n",
  "COUNTERBONDS": "COUNTERBOND, a bond to protect a person who has given bond for another from contingent loss [n]\n",
  "COUNTERBORE": "a straight-sided widening of the end of a bored hole [n -S] / to form a counterbore in [v COUNTERBORED, COUNTERBORING, COUNTERBORES]\n",
  "COUNTERBORED": "COUNTERBORE, to form a counterbore in [v]\n",
  "COUNTERBORES": "COUNTERBORE, to form a counterbore in [v]\n",
  "COUNTERBORING": "COUNTERBORE, to form a counterbore in [v]\n",
  "COUNTERBRACE": "to brace or fasten (the head-yards and after-yards) in opposite ways [v COUNTERBRACED, COUNTERBRACING, COUNTERBRACES]\n",
  "COUNTERBRACED": "COUNTERBRACE, to brace or fasten (the head-yards and after-yards) in opposite ways [v]\n",
  "COUNTERBRACES": "COUNTERBRACE, to brace or fasten (the head-yards and after-yards) in opposite ways [v]\n",
  "COUNTERBRACING": "COUNTERBRACE, to brace or fasten (the head-yards and after-yards) in opposite ways [v]\n",
  "COUNTERBUFF": "to rebuff [v -ED, -ING, -S]\n",
  "COUNTERBUFFED": "COUNTERBUFF, to rebuff [v]\n",
  "COUNTERBUFFING": "COUNTERBUFF, to rebuff [v]\n",
  "COUNTERBUFFS": "COUNTERBUFF, to rebuff [v]\n",
  "COUNTERCAMPAIGN": "an opposing campaign [n]\n",
  "COUNTERCHANGE": "to interchange, transpose [v COUNTERCHANGED, COUNTERCHANGING, COUNTERCHANGES]\n",
  "COUNTERCHANGED": "COUNTERCHANGE, to interchange, transpose [v]\n",
  "COUNTERCHANGES": "COUNTERCHANGE, to interchange, transpose [v]\n",
  "COUNTERCHANGING": "COUNTERCHANGE, to interchange, transpose [v]\n",
  "COUNTERCHARGE": "to bring a charge forward in opposition to another charge [v COUNTERCHARGED, COUNTERCHARGING, COUNTERCHARGES]\n",
  "COUNTERCHARGED": "COUNTERCHARGE, to bring a charge forward in opposition to another charge [v]\n",
  "COUNTERCHARGES": "COUNTERCHARGE, to bring a charge forward in opposition to another charge [v]\n",
  "COUNTERCHARGING": "COUNTERCHARGE, to bring a charge forward in opposition to another charge [v]\n",
  "COUNTERCHARM": "to destroy or dissolve the effects of (another charm) [v -ED, -ING, -S]\n",
  "COUNTERCHARMED": "COUNTERCHARM, to destroy or dissolve the effects of (another charm) [v]\n",
  "COUNTERCHARMING": "COUNTERCHARM, to destroy or dissolve the effects of (another charm) [v]\n",
  "COUNTERCHARMS": "COUNTERCHARM, to destroy or dissolve the effects of (another charm) [v]\n",
  "COUNTERCHECK": "to check by opposing means [v -ED, -ING, -S]\n",
  "COUNTERCHECKED": "COUNTERCHECK, to check by opposing means [v]\n",
  "COUNTERCHECKING": "COUNTERCHECK, to check by opposing means [v]\n",
  "COUNTERCHECKS": "COUNTERCHECK, to check by opposing means [v]\n",
  "COUNTERCLAIM": "to enter or plead a counterclaim [v -ED, -ING, -S]\n",
  "COUNTERCLAIMANT": "one making a counterclaim [n]\n",
  "COUNTERCLAIMED": "COUNTERCLAIM, to enter or plead a counterclaim [v]\n",
  "COUNTERCLAIMING": "COUNTERCLAIM, to enter or plead a counterclaim [v]\n",
  "COUNTERCLAIMS": "COUNTERCLAIM, to enter or plead a counterclaim [v]\n",
  "COUNTERCOUP": "a coup in return [n -S]\n",
  "COUNTERCOUPS": "COUNTERCOUP, a coup in return [n]\n",
  "COUNTERCRIES": "COUNTERCRY, a cry set up in opposition [n]\n",
  "COUNTERCRY": "a cry set up in opposition [n COUNTERCRIES]\n",
  "COUNTERCULTURAL": "relating to counterculture [adj]\n",
  "COUNTERCULTURE": "a culture with values and mores that run counter to those of established society [n -S]\n",
  "COUNTERCULTURES": "COUNTERCULTURE, a culture with values and mores that run counter to those of established society [n]\n",
  "COUNTERCURRENT": "a current flowing in a direction opposite that of another current [n -S]\n",
  "COUNTERCURRENTS": "COUNTERCURRENT, a current flowing in a direction opposite that of another current [n]\n",
  "COUNTERCYCLICAL": "calculated to check excessive developments in a business cycle [adj]\n",
  "COUNTERDEMAND": "a demand made in response to another demand [n -S]\n",
  "COUNTERDEMANDS": "COUNTERDEMAND, a demand made in response to another demand [n]\n",
  "COUNTERDRAW": "to trace on oiled paper or other transparent material [v COUNTERDREW, COUNTERDRAWN, COUNTERDRAWING, COUNTERDRAWS]\n",
  "COUNTERDRAWING": "COUNTERDRAW, to trace on oiled paper or other transparent material [v]\n",
  "COUNTERDRAWN": "COUNTERDRAW, to trace on oiled paper or other transparent material [v]\n",
  "COUNTERDRAWS": "COUNTERDRAW, to trace on oiled paper or other transparent material [v]\n",
  "COUNTERDREW": "COUNTERDRAW, to trace on oiled paper or other transparent material [v]\n",
  "COUNTERED": "COUNTER, to oppose [v]\n",
  "COUNTEREFFORT": "an effort opposing another effort [n -S]\n",
  "COUNTEREFFORTS": "COUNTEREFFORT, an effort opposing another effort [n]\n",
  "COUNTEREVIDENCE": "evidence brought in to counter other evidence [n]\n",
  "COUNTEREXAMPLE": "an example that refutes or disproves a proposition or theory [n -S]\n",
  "COUNTEREXAMPLES": "COUNTEREXAMPLE, an example that refutes or disproves a proposition or theory [n]\n",
  "COUNTERFACTUAL": "something contrary to fact [n -S]\n",
  "COUNTERFACTUALS": "COUNTERFACTUAL, something contrary to fact [n]\n",
  "COUNTERFECT": "(Spenser) counterfeit, made in imitation [adj]\n",
  "COUNTERFEISANCE": "an act of counterfeiting; forgery, also COUNTERFESAUNCE [n]\n",
  "COUNTERFEIT": "imitation, also COUNTERFECT [adj COUNTERFEITLY] / to imitate or feign esp. with intent to deceive [v -ED, -ING, -S]\n",
  "COUNTERFEITED": "COUNTERFEIT, to imitate or feign esp. with intent to deceive [v]\n",
  "COUNTERFEITER": "one who counterfeits [n -S]\n",
  "COUNTERFEITERS": "COUNTERFEITER, one who counterfeits [n]\n",
  "COUNTERFEITING": "the act of making a counterfeit [n -S]\n",
  "COUNTERFEITINGS": "COUNTERFEITING, the act of making a counterfeit [n]\n",
  "COUNTERFEITLY": "COUNTERFEIT, imitation, also COUNTERFECT [adv]\n",
  "COUNTERFEITS": "COUNTERFEIT, to imitate or feign esp. with intent to deceive [v]\n",
  "COUNTERFESAUNCE": "(archaic) an act of counterfeiting; forgery, also COUNTERFEISANCE [n]\n",
  "COUNTERFIRE": "return fire [n -S]\n",
  "COUNTERFIRES": "COUNTERFIRE, return fire [n]\n",
  "COUNTERFLOW": "the flow of a fluid in opposite directions, as in an apparatus [n -S]\n",
  "COUNTERFLOWS": "COUNTERFLOW, the flow of a fluid in opposite directions, as in an apparatus [n]\n",
  "COUNTERFOIL": "part of ticket or cheque retained by giver [n -S]\n",
  "COUNTERFOILS": "COUNTERFOIL, part of ticket or cheque retained by giver [n]\n",
  "COUNTERFORCE": "an opposing force [n -S]\n",
  "COUNTERFORCES": "COUNTERFORCE, an opposing force [n]\n",
  "COUNTERFORT": "a buttress or arch supporting a retaining wall [n -S]\n",
  "COUNTERFORTS": "COUNTERFORT, a buttress or arch supporting a retaining wall [n]\n",
  "COUNTERGLOW": "another name for gegenschein [n -S]\n",
  "COUNTERGLOWS": "COUNTERGLOW, another name for gegenschein [n]\n",
  "COUNTERGUERILLA": "a guerrilla fighting other guerillas [n]\n",
  "COUNTERIMAGE": "a corresponding image [n -S]\n",
  "COUNTERIMAGES": "COUNTERIMAGE, a corresponding image [n]\n",
  "COUNTERING": "COUNTER, to oppose [v]\n",
  "COUNTERINSTANCE": "an instance adduced to counter another instance [n]\n",
  "COUNTERION": "an ion having a charge opposite to that of the substance with which it is associated [n -S]\n",
  "COUNTERIONS": "COUNTERION, an ion having a charge opposite to that of the substance with which it is associated [n]\n",
  "COUNTERIRRITANT": "an agent applied locally to produce superficial inflammation with the object of reducing inflammation in deeper adjacent structures [n]\n",
  "COUNTERLIGHT": "a light opposite to any object, disturbing the effect of its light [n -S]\n",
  "COUNTERLIGHTS": "COUNTERLIGHT, a light opposite to any object, disturbing the effect of its light [n]\n",
  "COUNTERMAN": "(archaic) a man who attends at the counter of a shop to sell goods [n COUNTERMEN]\n",
  "COUNTERMAND": "to revoke an order by a contrary order [v -ED, -ING, -S]\n",
  "COUNTERMANDABLE": "able to be countermanded [adj]\n",
  "COUNTERMANDED": "COUNTERMAND, to revoke an order by a contrary order [v]\n",
  "COUNTERMANDING": "COUNTERMAND, to revoke an order by a contrary order [v]\n",
  "COUNTERMANDS": "COUNTERMAND, to revoke an order by a contrary order [v]\n",
  "COUNTERMARCH": "to march or cause to march back or in a direction opposite to a former one [v -ED, -ING, -ES]\n",
  "COUNTERMARCHED": "COUNTERMARCH, to march or cause to march back or in a direction opposite to a former one [v]\n",
  "COUNTERMARCHES": "COUNTERMARCH, to march or cause to march back or in a direction opposite to a former one [v]\n",
  "COUNTERMARCHING": "COUNTERMARCH, to march or cause to march back or in a direction opposite to a former one [v]\n",
  "COUNTERMARK": "an additional mark put on a bale of goods belonging to several merchants, so that it may not be opened except in the presence of all the owners [n -S]\n",
  "COUNTERMARKS": "COUNTERMARK, an additional mark put on a bale of goods belonging to several merchants, so that it may not be opened except in the presence of all the owners [n]\n",
  "COUNTERMEASURE": "an action or device designed to negate or offset another [n -S]\n",
  "COUNTERMEASURES": "COUNTERMEASURE, an action or device designed to negate or offset another [n]\n",
  "COUNTERMELODIES": "COUNTERMELODY, a secondary melody that is sounded simultaneously with the principal one [n]\n",
  "COUNTERMELODY": "a secondary melody that is sounded simultaneously with the principal one [n COUNTERMELODIES]\n",
  "COUNTERMEMO": "a memo made in contradiction of another [n -S]\n",
  "COUNTERMEMOS": "COUNTERMEMO, a memo made in contradiction of another [n]\n",
  "COUNTERMEN": "COUNTERMAN, (archaic) a man who attends at the counter of a shop to sell goods [n]\n",
  "COUNTERMINE": "to make an excavation in opposition to [v COUNTERMINED, COUNTERMINING, COUNTERMINES]\n",
  "COUNTERMINED": "COUNTERMINE, to make an excavation in opposition to [v]\n",
  "COUNTERMINES": "COUNTERMINE, to make an excavation in opposition to [v]\n",
  "COUNTERMINING": "COUNTERMINE, to make an excavation in opposition to [v]\n",
  "COUNTERMOTION": "an opposite motion [n -S]\n",
  "COUNTERMOTIONS": "COUNTERMOTION, an opposite motion [n]\n",
  "COUNTERMOVE": "to make a move in return [v COUNTERMOVED, COUNTERMOVING, COUNTERMOVES]\n",
  "COUNTERMOVED": "COUNTERMOVE, to make a move in return [v]\n",
  "COUNTERMOVEMENT": "an opposing movement [n]\n",
  "COUNTERMOVES": "COUNTERMOVE, to make a move in return [v]\n",
  "COUNTERMOVING": "COUNTERMOVE, to make a move in return [v]\n",
  "COUNTERMURE": "a wall raised by besiegers against a wall [n -S] / to defend with a countermure [v COUNTERMURED, COUNTERMURING, COUNTERMURES]\n",
  "COUNTERMURED": "COUNTERMURE, to defend with a countermure [v]\n",
  "COUNTERMURES": "COUNTERMURE, to defend with a countermure [v]\n",
  "COUNTERMURING": "COUNTERMURE, to defend with a countermure [v]\n",
  "COUNTERMYTH": "an opposing myth [n -S]\n",
  "COUNTERMYTHS": "COUNTERMYTH, an opposing myth [n]\n",
  "COUNTEROFFER": "a return offer made by one who has rejected an offer [n -S]\n",
  "COUNTEROFFERS": "COUNTEROFFER, a return offer made by one who has rejected an offer [n]\n",
  "COUNTERORDER": "to issue an order contradicting a previous order [v -ED, -ING, -S]\n",
  "COUNTERORDERED": "COUNTERORDER, to issue an order contradicting a previous order [v]\n",
  "COUNTERORDERING": "COUNTERORDER, to issue an order contradicting a previous order [v]\n",
  "COUNTERORDERS": "COUNTERORDER, to issue an order contradicting a previous order [v]\n",
  "COUNTERPACE": "a step in opposition to another; a contrary measure [n -S]\n",
  "COUNTERPACES": "COUNTERPACE, a step in opposition to another; a contrary measure [n]\n",
  "COUNTERPANE": "a bed coverlet [n -S]\n",
  "COUNTERPANES": "COUNTERPANE, a bed coverlet [n]\n",
  "COUNTERPART": "one of two corresponding copies of a legal instrument [n -S]\n",
  "COUNTERPARTIES": "COUNTERPARTY, a party set up in opposition to another party [n]\n",
  "COUNTERPARTS": "COUNTERPART, one of two corresponding copies of a legal instrument [n]\n",
  "COUNTERPARTY": "a party set up in opposition to another party [n COUNTERPARTIES]\n",
  "COUNTERPEISE": "(obsolete) to counterpoise [v COUNTERPEISED, COUNTERPEISING, COUNTERPEISES]\n",
  "COUNTERPEISED": "COUNTERPEISE, (obsolete) to counterpoise [v]\n",
  "COUNTERPEISES": "COUNTERPEISE, (obsolete) to counterpoise [v]\n",
  "COUNTERPEISING": "COUNTERPEISE, (obsolete) to counterpoise [v]\n",
  "COUNTERPETITION": "an opposing petition [n]\n",
  "COUNTERPICKET": "to picket in opposition to another picket [v -ED, -S]\n",
  "COUNTERPICKETED": "COUNTERPICKET, to picket in opposition to another picket [v]\n",
  "COUNTERPICKETS": "COUNTERPICKET, to picket in opposition to another picket [v]\n",
  "COUNTERPLAN": "to form a plan designed to counter another plan [v COUNTERPLANNED, COUNTERPLANNING, COUNTERPLANS]\n",
  "COUNTERPLANNED": "COUNTERPLAN, to form a plan designed to counter another plan [v]\n",
  "COUNTERPLANNING": "COUNTERPLAN, to form a plan designed to counter another plan [v]\n",
  "COUNTERPLANS": "COUNTERPLAN, to form a plan designed to counter another plan [v]\n",
  "COUNTERPLAY": "to make a threat or offensive position in e.g. chess intended to counter an opponent's advantage in another part of the board [v -ED, -ING, -S]\n",
  "COUNTERPLAYED": "COUNTERPLAY, to make a threat or offensive position in e.g. chess intended to counter an opponent's advantage in another part of the board [v]\n",
  "COUNTERPLAYER": "one who makes a counterplay [n -S]\n",
  "COUNTERPLAYERS": "COUNTERPLAYER, one who makes a counterplay [n]\n",
  "COUNTERPLAYING": "COUNTERPLAY, to make a threat or offensive position in e.g. chess intended to counter an opponent's advantage in another part of the board [v]\n",
  "COUNTERPLAYS": "COUNTERPLAY, to make a threat or offensive position in e.g. chess intended to counter an opponent's advantage in another part of the board [v]\n",
  "COUNTERPLEA": "a replication to a legal plea [n -S]\n",
  "COUNTERPLEAD": "to plead the contrary of [v COUNTERPLEAD or COUNTERPLED, COUNTERPLEADING, COUNTERPLEADS]\n",
  "COUNTERPLEADED": "COUNTERPLEAD, to plead the contrary of [v]\n",
  "COUNTERPLEADING": "COUNTERPLEAD, to plead the contrary of [v]\n",
  "COUNTERPLEADS": "COUNTERPLEAD, to plead the contrary of [v]\n",
  "COUNTERPLEAS": "COUNTERPLEA, a replication to a legal plea [n]\n",
  "COUNTERPLED": "COUNTERPLEAD, to plead the contrary of [v]\n",
  "COUNTERPLOT": "to intrigue against [v COUNTERPLOTTED, COUNTERPLOTTING, COUNTERPLOTS]\n",
  "COUNTERPLOTS": "COUNTERPLOT, to intrigue against [v]\n",
  "COUNTERPLOTTED": "COUNTERPLOT, to intrigue against [v]\n",
  "COUNTERPLOTTING": "COUNTERPLOT, to intrigue against [v]\n",
  "COUNTERPLOY": "a ploy in return [n -S]\n",
  "COUNTERPLOYS": "COUNTERPLOY, a ploy in return [n]\n",
  "COUNTERPOINT": "a melody added to another [n -S] / to compose or arrange in counterpoint [v -ED, -ING, -S]\n",
  "COUNTERPOINTED": "COUNTERPOINT, to compose or arrange in counterpoint [v]\n",
  "COUNTERPOINTING": "COUNTERPOINT, to compose or arrange in counterpoint [v]\n",
  "COUNTERPOINTS": "COUNTERPOINT, to compose or arrange in counterpoint [v]\n",
  "COUNTERPOISE": "to poise, balance or weigh against or on the opposite side [v COUNTERPOISED, COUNTERPOISING, COUNTERPOISES]\n",
  "COUNTERPOISED": "COUNTERPOISE, to poise, balance or weigh against or on the opposite side [v]\n",
  "COUNTERPOISES": "COUNTERPOISE, to poise, balance or weigh against or on the opposite side [v]\n",
  "COUNTERPOISING": "COUNTERPOISE, to poise, balance or weigh against or on the opposite side [v]\n",
  "COUNTERPOSE": "to place in opposition, contrast, or equilibrium [v COUNTERPOSED, COUNTERPOSING, COUNTERPOSES]\n",
  "COUNTERPOSED": "COUNTERPOSE, to place in opposition, contrast, or equilibrium [v]\n",
  "COUNTERPOSES": "COUNTERPOSE, to place in opposition, contrast, or equilibrium [v]\n",
  "COUNTERPOSING": "COUNTERPOSE, to place in opposition, contrast, or equilibrium [v]\n",
  "COUNTERPOWER": "a power opposed to another power [n -S]\n",
  "COUNTERPOWERS": "COUNTERPOWER, a power opposed to another power [n]\n",
  "COUNTERPRESSURE": "an opposing pressure [n]\n",
  "COUNTERPROJECT": "a project set up in opposition to another [n -S]\n",
  "COUNTERPROJECTS": "COUNTERPROJECT, a project set up in opposition to another [n]\n",
  "COUNTERPROOF": "an inverted impression obtained from a newly printed proof of an engraving, by laying it, while the ink is still wet, upon plain paper, and passing it through the press [n -S]\n",
  "COUNTERPROOFS": "COUNTERPROOF, an inverted impression obtained from a newly printed proof of an engraving, by laying it, while the ink is still wet, upon plain paper, and passing it through the press [n]\n",
  "COUNTERPROPOSAL": "a return proposal made by one who has rejected a proposal [n]\n",
  "COUNTERPROTEST": "an opposing protest [n -S]\n",
  "COUNTERPROTESTS": "COUNTERPROTEST, an opposing protest [n]\n",
  "COUNTERPUNCH": "to return a punch or blow [v -ED, -ING, -ES]\n",
  "COUNTERPUNCHED": "COUNTERPUNCH, to return a punch or blow [v]\n",
  "COUNTERPUNCHER": "one who counterpunches [n -S]\n",
  "COUNTERPUNCHERS": "COUNTERPUNCHER, one who counterpunches [n]\n",
  "COUNTERPUNCHES": "COUNTERPUNCH, to return a punch or blow [v]\n",
  "COUNTERPUNCHING": "COUNTERPUNCH, to return a punch or blow [v]\n",
  "COUNTERQUESTION": "a question in response to another question [n]\n",
  "COUNTERRAID": "to make a retaliatory raid [v -ED, -ING, -S]\n",
  "COUNTERRAIDED": "COUNTERRAID, to make a retaliatory raid [v]\n",
  "COUNTERRAIDING": "COUNTERRAID, to make a retaliatory raid [v]\n",
  "COUNTERRAIDS": "COUNTERRAID, to make a retaliatory raid [v]\n",
  "COUNTERRALLIED": "COUNTERRALLY, to rally in opposition [v]\n",
  "COUNTERRALLIES": "COUNTERRALLY, to rally in opposition [v]\n",
  "COUNTERRALLY": "to rally in opposition [v COUNTERRALLIED, COUNTERRALLYING, COUNTERRALLIES]\n",
  "COUNTERRALLYING": "COUNTERRALLY, to rally in opposition [v]\n",
  "COUNTERREACTION": "a reaction in opposition to another reaction [n]\n",
  "COUNTERREFORM": "to make a reform designed to counter another reform [v COUNTERREFORMED, COUNTERREFORMS]\n",
  "COUNTERREFORMED": "COUNTERREFORM, to make a reform designed to counter another reform [v]\n",
  "COUNTERREFORMER": "an instigator of a counterreform [n]\n",
  "COUNTERREFORMS": "COUNTERREFORM, to make a reform designed to counter another reform [v]\n",
  "COUNTERRESPONSE": "an answering response [n]\n",
  "COUNTERS": "COUNTER, to oppose [v]\n",
  "COUNTERSANK": "COUNTERSINK, to make a countersink on (a hole) [v]\n",
  "COUNTERSCARP": "a narrow earth band on the outer wall of a defensive ditch [n -S]\n",
  "COUNTERSCARPS": "COUNTERSCARP, a narrow earth band on the outer wall of a defensive ditch [n]\n",
  "COUNTERSEAL": "(Shakespeare) to seal with an extra seal for further security [v -ED, -ING, -S]\n",
  "COUNTERSEALED": "COUNTERSEAL, (Shakespeare) to seal with an extra seal for further security [v]\n",
  "COUNTERSEALING": "COUNTERSEAL, (Shakespeare) to seal with an extra seal for further security [v]\n",
  "COUNTERSEALS": "COUNTERSEAL, (Shakespeare) to seal with an extra seal for further security [v]\n",
  "COUNTERSHADING": "cryptic coloration of an animal with parts normally in shadow being light and parts normally illuminated being dark thereby reducing shadows and contours [n -S]\n",
  "COUNTERSHADINGS": "COUNTERSHADING, cryptic coloration of an animal with parts normally in shadow being light and parts normally illuminated being dark thereby reducing shadows and contours [n]\n",
  "COUNTERSHAFT": "an intermediate shaft driven by the main shaft [n -S]\n",
  "COUNTERSHAFTS": "COUNTERSHAFT, an intermediate shaft driven by the main shaft [n]\n",
  "COUNTERSHOT": "a shot in retaliation [n -S]\n",
  "COUNTERSHOTS": "COUNTERSHOT, a shot in retaliation [n]\n",
  "COUNTERSIGN": "to sign with a signature attesting the authenticity of a document already signed by another [v -ED, -ING, -S]\n",
  "COUNTERSIGNED": "COUNTERSIGN, to sign with a signature attesting the authenticity of a document already signed by another [v]\n",
  "COUNTERSIGNING": "COUNTERSIGN, to sign with a signature attesting the authenticity of a document already signed by another [v]\n",
  "COUNTERSIGNS": "COUNTERSIGN, to sign with a signature attesting the authenticity of a document already signed by another [v]\n",
  "COUNTERSINK": "to make a countersink on (a hole) [v COUNTERSANK, COUNTERSUNK, COUNTERSINKING, COUNTERSINKS]\n",
  "COUNTERSINKING": "COUNTERSINK, to make a countersink on (a hole) [v]\n",
  "COUNTERSINKS": "COUNTERSINK, to make a countersink on (a hole) [v]\n",
  "COUNTERSNIPER": "a sniper working against another sniper [n -S]\n",
  "COUNTERSNIPERS": "COUNTERSNIPER, a sniper working against another sniper [n]\n",
  "COUNTERSPELL": "a spell intended to counter the effect of another spell [n -S]\n",
  "COUNTERSPELLS": "COUNTERSPELL, a spell intended to counter the effect of another spell [n]\n",
  "COUNTERSPIES": "COUNTERSPY, a spy whose job is to catch other spies [n]\n",
  "COUNTERSPY": "a spy whose job is to catch other spies [n COUNTERSPIES]\n",
  "COUNTERSPYING": "the activity of a counterspy [n -S]\n",
  "COUNTERSPYINGS": "COUNTERSPYING, the activity of a counterspy [n]\n",
  "COUNTERSTAIN": "to apply additional dye to a specimen to produce a contrasting background [v -ED, -ING, -S]\n",
  "COUNTERSTAINED": "COUNTERSTAIN, to apply additional dye to a specimen to produce a contrasting background [v]\n",
  "COUNTERSTAINING": "COUNTERSTAIN, to apply additional dye to a specimen to produce a contrasting background [v]\n",
  "COUNTERSTAINS": "COUNTERSTAIN, to apply additional dye to a specimen to produce a contrasting background [v]\n",
  "COUNTERSTATE": "to state in opposition [v COUNTERSTATED, COUNTERSTATING, COUNTERSTATES]\n",
  "COUNTERSTATED": "COUNTERSTATE, to state in opposition [v]\n",
  "COUNTERSTATES": "COUNTERSTATE, to state in opposition [v]\n",
  "COUNTERSTATING": "COUNTERSTATE, to state in opposition [v]\n",
  "COUNTERSTEP": "a step in retaliation [n -S]\n",
  "COUNTERSTEPS": "COUNTERSTEP, a step in retaliation [n]\n",
  "COUNTERSTRATEGY": "a strategy designed to counter another strategy [n]\n",
  "COUNTERSTREAM": "a stream running counter to another [n -S]\n",
  "COUNTERSTREAMS": "COUNTERSTREAM, a stream running counter to another [n]\n",
  "COUNTERSTRICKEN": "COUNTERSTRIKE, to counter with an opposing strike [v]\n",
  "COUNTERSTRIKE": "to counter with an opposing strike [v COUNTERSTRUCK, COUNTERSTRICKEN, COUNTERSTRIKING, COUNTERSTRIKES]\n",
  "COUNTERSTRIKES": "COUNTERSTRIKE, to counter with an opposing strike [v]\n",
  "COUNTERSTRIKING": "COUNTERSTRIKE, to counter with an opposing strike [v]\n",
  "COUNTERSTROKE": "a stroke in return [n -S]\n",
  "COUNTERSTROKES": "COUNTERSTROKE, a stroke in return [n]\n",
  "COUNTERSTRUCK": "COUNTERSTRIKE, to counter with an opposing strike [v]\n",
  "COUNTERSTYLE": "an opposing style [n -S]\n",
  "COUNTERSTYLES": "COUNTERSTYLE, an opposing style [n]\n",
  "COUNTERSUBJECT": "a second theme by the first voice (esp. in a fugue) when accompanying the second voice performing the main subject [n -S]\n",
  "COUNTERSUBJECTS": "COUNTERSUBJECT, a second theme by the first voice (esp. in a fugue) when accompanying the second voice performing the main subject [n]\n",
  "COUNTERSUE": "to sue someone who is suing one [v COUNTERSUED, COUNTERSUING, COUNTERSUES]\n",
  "COUNTERSUED": "COUNTERSUE, to sue someone who is suing one [v]\n",
  "COUNTERSUES": "COUNTERSUE, to sue someone who is suing one [v]\n",
  "COUNTERSUING": "COUNTERSUE, to sue someone who is suing one [v]\n",
  "COUNTERSUIT": "a suit in retaliation [n -S]\n",
  "COUNTERSUITS": "COUNTERSUIT, a suit in retaliation [n]\n",
  "COUNTERSUNK": "COUNTERSINK, to make a countersink on (a hole) [v]\n",
  "COUNTERTACTIC": "an opposing tactic [n -S]\n",
  "COUNTERTACTICS": "COUNTERTACTIC, an opposing tactic [n]\n",
  "COUNTERTENDENCY": "a tendency running counter to another tendency [n]\n",
  "COUNTERTENOR": "the highest alto male voice (so called because a contrast to tenor) [n -S]\n",
  "COUNTERTENORS": "COUNTERTENOR, the highest alto male voice (so called because a contrast to tenor) [n]\n",
  "COUNTERTERROR": "terror designed to counter terrorism [n -S]\n",
  "COUNTERTERRORS": "COUNTERTERROR, terror designed to counter terrorism [n]\n",
  "COUNTERTHREAT": "a threat made in response to another threat [n -S]\n",
  "COUNTERTHREATS": "COUNTERTHREAT, a threat made in response to another threat [n]\n",
  "COUNTERTHRUST": "a thrust to counter another thrust [n -S]\n",
  "COUNTERTHRUSTS": "COUNTERTHRUST, a thrust to counter another thrust [n]\n",
  "COUNTERTOP": "the top of a counter [n -S]\n",
  "COUNTERTOPS": "COUNTERTOP, the top of a counter [n]\n",
  "COUNTERTRADE": "to trade by barter [v COUNTERTRADED, COUNTERTRADING, COUNTERTRADES]\n",
  "COUNTERTRADED": "COUNTERTRADE, to trade by barter [v]\n",
  "COUNTERTRADES": "COUNTERTRADE [n]\n",
  "COUNTERTRADING": "COUNTERTRADE, to trade by barter [v]\n",
  "COUNTERTREND": "an opposing trend [n -S]\n",
  "COUNTERTRENDS": "COUNTERTREND, an opposing trend [n]\n",
  "COUNTERTYPE": "an opposite type [n -S]\n",
  "COUNTERTYPES": "COUNTERTYPE, an opposite type [n]\n",
  "COUNTERVAIL": "to counterbalance, neutralise [v -ED, -ING, -S]\n",
  "COUNTERVAILABLE": "able to be countervailed [adj]\n",
  "COUNTERVAILED": "COUNTERVAIL, to counterbalance, neutralise [v]\n",
  "COUNTERVAILING": "COUNTERVAIL, to counterbalance, neutralise [v]\n",
  "COUNTERVAILS": "COUNTERVAIL, to counterbalance, neutralise [v]\n",
  "COUNTERVIEW": "an opposite point of view [n -S]\n",
  "COUNTERVIEWS": "COUNTERVIEW, an opposite point of view [n]\n",
  "COUNTERVIOLENCE": "violence in response to violence [n]\n",
  "COUNTERWEIGH": "to weigh against, counterbalance [v -ED, -ING, -S]\n",
  "COUNTERWEIGHED": "COUNTERWEIGH, to weigh against, counterbalance [v]\n",
  "COUNTERWEIGHING": "COUNTERWEIGH, to weigh against, counterbalance [v]\n",
  "COUNTERWEIGHS": "COUNTERWEIGH, to weigh against, counterbalance [v]\n",
  "COUNTERWEIGHT": "to balance with an equivalent weight or force [v COUNTERWEIGHTED, COUNTERWEIGHTS]\n",
  "COUNTERWEIGHTED": "COUNTERWEIGHT, to balance with an equivalent weight or force [v]\n",
  "COUNTERWEIGHTS": "COUNTERWEIGHT, to balance with an equivalent weight or force [v]\n",
  "COUNTERWORD": "a word widely used in a sense much looser than its original meaning, such as 'tremendous' or 'awful' [n -S]\n",
  "COUNTERWORDS": "COUNTERWORD, a word widely used in a sense much looser than its original meaning, such as 'tremendous' or 'awful' [n]\n",
  "COUNTERWORK": "to work in opposition to [v -ED, -ING, -S]\n",
  "COUNTERWORKED": "COUNTERWORK, to work in opposition to [v]\n",
  "COUNTERWORKER": "one who does counterwork [n -S]\n",
  "COUNTERWORKERS": "COUNTERWORKER, one who does counterwork [n]\n",
  "COUNTERWORKING": "COUNTERWORK, to work in opposition to [v]\n",
  "COUNTERWORKS": "COUNTERWORK, to work in opposition to [v]\n",
  "COUNTERWORLD": "a world imagined in contrast to our own [n -S]\n",
  "COUNTERWORLDS": "COUNTERWORLD, a world imagined in contrast to our own [n]\n",
  "COUNTESS": "the wife of an earl in the British peerage, or of a count in the Continental nobility [n -ES]\n",
  "COUNTESSES": "COUNTESS, the wife of an earl in the British peerage, or of a count in the Continental nobility [n]\n",
  "COUNTIAN": "a resident of a county [n -S]\n",
  "COUNTIANS": "COUNTIAN, a resident of a county [n]\n",
  "COUNTIES": "COUNTY, an administrative division of a state [n]\n",
  "COUNTING": "the act of listing or mentioning the units of one by one to ascertain the total [n -S]\n",
  "COUNTINGHOUSE": "a building, room, or office used for keeping books and transacting business [n -S]\n",
  "COUNTINGHOUSES": "COUNTINGHOUSE, a building, room, or office used for keeping books and transacting business [n]\n",
  "COUNTINGS": "COUNTING, the act of listing or mentioning the units of one by one to ascertain the total [n]\n",
  "COUNTLESS": "beyond counting [adj COUNTLESSLY]\n",
  "COUNTLESSLY": "COUNTLESS, beyond counting [adv]\n",
  "COUNTLINE": "a confectionery bar made as an individual item, e.g. a filled chocolate bar, rather than as moulded chocolate [n -S]\n",
  "COUNTLINES": "COUNTLINE, a confectionery bar made as an individual item, e.g. a filled chocolate bar, rather than as moulded chocolate [n]\n",
  "COUNTRIES": "COUNTRY, the territory of a nation [n]\n",
  "COUNTRIFIED": "rural, rustic, also COUNTRYFIED [adj]\n",
  "COUNTROL": "to control [v COUNTROLLED, COUNTROLLING, COUNTROLS]\n",
  "COUNTROLLED": "COUNTROL, to control [v]\n",
  "COUNTROLLING": "COUNTROL, to control [v]\n",
  "COUNTROLS": "COUNTROL, to control [v]\n",
  "COUNTRY": "the territory of a nation [n COUNTRIES]\n",
  "COUNTRYFIED": "rural, rustic, also COUNTRIFIED [adj]\n",
  "COUNTRYISH": "rustic, characteristic of the countryside [adj]\n",
  "COUNTRYMAN": "an inhabitant or native of a specified country [n COUNTRYMEN]\n",
  "COUNTRYMEN": "COUNTRYMAN, an inhabitant or native of a specified country [n]\n",
  "COUNTRYSEAT": "a house or estate in the country [n -S]\n",
  "COUNTRYSEATS": "COUNTRYSEAT, a house or estate in the country [n]\n",
  "COUNTRYSIDE": "a rural area [n -S]\n",
  "COUNTRYSIDES": "COUNTRYSIDE, a rural area [n]\n",
  "COUNTRYWIDE": "extending throughout a country [adj]\n",
  "COUNTRYWOMAN": "a woman who is a compatriot [n COUNTRYWOMEN]\n",
  "COUNTRYWOMEN": "COUNTRYWOMAN, a woman who is a compatriot [n]\n",
  "COUNTS": "COUNT, to number [v]\n",
  "COUNTSHIP": "a count's dignity or domain [n -S]\n",
  "COUNTSHIPS": "COUNTSHIP, a count's dignity or domain [n]\n",
  "COUNTY": "an administrative division of a state [n COUNTIES]\n",
  "COUP": "(Scots) to overturn, turn up, also COWP [v -ED, -ING, -S]\n",
  "COUPE": "(French) a four-wheeled closed horse-drawn carriage [n -S]\n",
  "COUPED": "COUP, (Scots) to overturn, turn up, also COWP [v]\n",
  "COUPEE": "(French) a salute to one's partner in dancing [n -S]\n",
  "COUPEES": "COUPEE, (French) a salute to one's partner in dancing [n]\n",
  "COUPER": "(Scots) a dealer [n -S]\n",
  "COUPERS": "COUPER, (Scots) a dealer [n]\n",
  "COUPES": "COUPE, (French) a four-wheeled closed horse-drawn carriage [n]\n",
  "COUPING": "COUP, (Scots) to overturn, turn up, also COWP [v]\n",
  "COUPLE": "to unite in pairs [v COUPLED, COUPLING, COUPLES]\n",
  "COUPLED": "COUPLE, to unite in pairs [v]\n",
  "COUPLEDOM": "the state of being a couple; the world of married couples [n -S]\n",
  "COUPLEDOMS": "COUPLEDOM, the state of being a couple; the world of married couples [n]\n",
  "COUPLEMENT": "union; a couple [n -S]\n",
  "COUPLEMENTS": "COUPLEMENT, union; a couple [n]\n",
  "COUPLER": "someone who or something which couples or unites [n -S]\n",
  "COUPLERS": "COUPLER, someone who or something which couples or unites [n]\n",
  "COUPLES": "COUPLE, to unite in pairs [v]\n",
  "COUPLET": "a pair of rhyming lines [n -S]\n",
  "COUPLETS": "COUPLET, a pair of rhyming lines [n]\n",
  "COUPLING": "a joining device [n -S]\n",
  "COUPLINGS": "COUPLING, a joining device [n]\n",
  "COUPON": "a voucher [n -S]\n",
  "COUPONING": "rationing by means of coupons [n -S]\n",
  "COUPONINGS": "COUPONING, rationing by means of coupons [n]\n",
  "COUPONS": "COUPON, a voucher [n]\n",
  "COUPS": "COUP, (Scots) to overturn, turn up, also COWP [v]\n",
  "COUPURE": "(French) a passage cut through a glacis to facilitate sallies by the besieged [n -S]\n",
  "COUPURES": "COUPURE, (French) a passage cut through a glacis to facilitate sallies by the besieged [n]\n",
  "COUR": "(obsolete) to cover [v COURED or COURD, COURING, COURS]\n",
  "COURAGE": "the quality that enables people to be brave [n -S]\n",
  "COURAGEFUL": "full of courage [adj]\n",
  "COURAGEOUS": "having or characterized by courage [adj COURAGEOUSLY]\n",
  "COURAGEOUSLY": "COURAGEOUS, having or characterized by courage [adv]\n",
  "COURAGEOUSNESS": "the state of being courageous [n]\n",
  "COURAGES": "COURAGE, the quality that enables people to be brave [n]\n",
  "COURANT": "an old dance with a gliding step, also CORANTO, COURANTE, COURANTO [n -S]\n",
  "COURANTE": "(French) an old dance with a gliding step, also CORANTO, COURANT, COURANTO [n -S]\n",
  "COURANTES": "COURANTE, (French) an old dance with a gliding step, also CORANTO, COURANT, COURANTO [n]\n",
  "COURANTO": "an old dance with a gliding step, also CORANTO, COURANT, COURANTE [n COURANTOS or COURANTOES]\n",
  "COURANTOES": "COURANTO, an old dance with a gliding step, also CORANTO, COURANT, COURANTE [n]\n",
  "COURANTOS": "COURANTO, an old dance with a gliding step, also CORANTO, COURANT, COURANTE [n]\n",
  "COURANTS": "COURANT, an old dance with a gliding step, also CORANTO, COURANTE, COURANTO [n]\n",
  "COURB": "(archaic) to bend or stoop [v -ED, -ING, -S]\n",
  "COURBARIL": "the West Indian locust-tree [n -S]\n",
  "COURBARILS": "COURBARIL, the West Indian locust-tree [n]\n",
  "COURBED": "COURB, (archaic) to bend or stoop [v]\n",
  "COURBETTE": "(French) a curvet [n -S]\n",
  "COURBETTES": "COURBETTE, (French) a curvet [n]\n",
  "COURBING": "COURB, (archaic) to bend or stoop [v]\n",
  "COURBS": "COURB, (archaic) to bend or stoop [v]\n",
  "COURD": "covered [adj]\n",
  "COURE": "to cower [v COURED, COURING, COURES]\n",
  "COURED": "COUR, (obsolete) to cover [v]\n",
  "COURES": "COURE, to cower [v]\n",
  "COURGETTE": "(French) a small variety of vegetable marrow, aka zucchini [n -S]\n",
  "COURGETTES": "COURGETTE, (French) a small variety of vegetable marrow, aka zucchini [n]\n",
  "COURIE": "(Scots) to nestle or snuggle, also COORIE [v COURIED, COURIEING, COURIES]\n",
  "COURIED": "COURIE, (Scots) to nestle or snuggle, also COORIE [v]\n",
  "COURIEING": "COURIE, (Scots) to nestle or snuggle, also COORIE [v]\n",
  "COURIER": "a messenger [n -S] / to deliver by courier [v -ED, -ING, -S]\n",
  "COURIERED": "COURIER, to deliver by courier [v]\n",
  "COURIERING": "COURIER, to deliver by courier [v]\n",
  "COURIERS": "COURIER, to deliver by courier [v]\n",
  "COURIES": "COURIE, (Scots) to nestle or snuggle, also COORIE [v]\n",
  "COURING": "COUR, (obsolete) to cover [v]\n",
  "COURLAN": "(French) a South American bird, allied to the rails [n -S]\n",
  "COURLANS": "COURLAN, (French) a South American bird, allied to the rails [n]\n",
  "COURS": "COUR, (obsolete) to cover [v]\n",
  "COURSE": "to chase and hunt [v COURSED, COURSING, COURSES]\n",
  "COURSEBOOK": "a book used on an educational course [n -S]\n",
  "COURSEBOOKS": "COURSEBOOK, a book used on an educational course [n]\n",
  "COURSED": "COURSE, to chase and hunt [v]\n",
  "COURSER": "a swift horse, a large powerful horse ridden in battle [n -S]\n",
  "COURSERS": "COURSER, a swift horse, a large powerful horse ridden in battle [n]\n",
  "COURSES": "COURSE, to chase and hunt [v]\n",
  "COURSEWARE": "computer software associated with educational courses [n -S]\n",
  "COURSEWARES": "COURSEWARE, computer software associated with educational courses [n]\n",
  "COURSEWORK": "work done for an educational course [n -S]\n",
  "COURSEWORKS": "COURSEWORK, work done for an educational course [n]\n",
  "COURSING": "the pursuit of game by hounds [n -S]\n",
  "COURSINGS": "COURSING, the pursuit of game by hounds [n]\n",
  "COURT": "to woo [v -ED, -ING, -S]\n",
  "COURTCRAFT": "the courtier's art, intrigue etc. [n -S]\n",
  "COURTCRAFTS": "COURTCRAFT, the courtier's art, intrigue etc. [n]\n",
  "COURTED": "COURT, to woo [v]\n",
  "COURTEOUS": "polite, considerate [adj COURTEOUSLY]\n",
  "COURTEOUSLY": "COURTEOUS, polite, considerate [adv]\n",
  "COURTEOUSNESS": "the state of being courteous [n -ES]\n",
  "COURTEOUSNESSES": "COURTEOUSNESS, the state of being courteous [n]\n",
  "COURTER": "one who courts [n -S]\n",
  "COURTERS": "COURTER, one who courts [n]\n",
  "COURTESAN": "a prostitute, esp. one whose clients are wealthy or upper-class, also COURTEZAN [n -S]\n",
  "COURTESANS": "COURTESAN, a prostitute, esp. one whose clients are wealthy or upper-class, also COURTEZAN [n]\n",
  "COURTESIED": "COURTESY, to curtsey [v]\n",
  "COURTESIES": "COURTESY, to curtsey [v]\n",
  "COURTESY": "to curtsey [v COURTESIED, COURTESYING, COURTESIES]\n",
  "COURTESYING": "COURTESY, to curtsey [v]\n",
  "COURTEZAN": "a prostitute, esp. one whose clients are wealthy or upper-class, also COURTESAN [n -S]\n",
  "COURTEZANS": "COURTEZAN, a prostitute, esp. one whose clients are wealthy or upper-class, also COURTESAN [n]\n",
  "COURTHOUSE": "a building in which courts of law are regularly held [n -S]\n",
  "COURTHOUSES": "COURTHOUSE, a building in which courts of law are regularly held [n]\n",
  "COURTIER": "someone in attendance at a court or palace [n -S]\n",
  "COURTIERISM": "the behaviour or practices of a courtier [n -S]\n",
  "COURTIERISMS": "COURTIERISM, the behaviour or practices of a courtier [n]\n",
  "COURTIERLIKE": "like a courtier [adj]\n",
  "COURTIERLY": "like a courtier [adj]\n",
  "COURTIERS": "COURTIER, someone in attendance at a court or palace [n]\n",
  "COURTING": "the act of wooing [n -S]\n",
  "COURTINGS": "COURTING, the act of wooing [n]\n",
  "COURTLET": "a petty court [n -S]\n",
  "COURTLETS": "COURTLET, a petty court [n]\n",
  "COURTLIER": "COURTLY, polite [adj]\n",
  "COURTLIEST": "COURTLY, polite [adj]\n",
  "COURTLIKE": "courtly, polite [adj]\n",
  "COURTLINESS": "the state of being courtly [n -ES]\n",
  "COURTLINESSES": "COURTLINESS, the state of being courtly [n]\n",
  "COURTLING": "a sycophantic courtier [n -S]\n",
  "COURTLINGS": "COURTLING, a sycophantic courtier [n]\n",
  "COURTLY": "polite [adj COURTLIER, COURTLIEST]\n",
  "COURTROOM": "a room in a courthouse in which lawsuits and criminal cases are heard [n -S]\n",
  "COURTROOMS": "COURTROOM, a room in a courthouse in which lawsuits and criminal cases are heard [n]\n",
  "COURTS": "COURT, to woo [v]\n",
  "COURTSHIP": "the act of wooing a woman in order to persuade her to become one's wife [n -S]\n",
  "COURTSHIPS": "COURTSHIP, the act of wooing a woman in order to persuade her to become one's wife [n]\n",
  "COURTSIDE": "the area at the edge of a court (as for tennis or basketball) [n -S]\n",
  "COURTSIDES": "COURTSIDE, the area at the edge of a court (as for tennis or basketball) [n]\n",
  "COURTYARD": "a court or enclosed ground attached to a building, usually a large house [n -S]\n",
  "COURTYARDS": "COURTYARD, a court or enclosed ground attached to a building, usually a large house [n]\n",
  "COUSCOUS": "the grain of the African millet, also COUSCOUSOU, CUSCUS, KHUSKHUS, KOUSKOUS [n -ES]\n",
  "COUSCOUSES": "COUSCOUS, the grain of the African millet, also COUSCOUSOU, CUSCUS, KHUSKHUS, KOUSKOUS [n]\n",
  "COUSCOUSOU": "the grain of the African millet, also COUSCOUS, CUSCUS, KHUSKHUS, KOUSKOUS [n -S]\n",
  "COUSCOUSOUS": "COUSCOUSOU, the grain of the African millet, also COUSCOUS, CUSCUS, KHUSKHUS, KOUSKOUS [n]\n",
  "COUSIN": "a child of one's uncle or aunt [n -S]\n",
  "COUSINAGE": "relationship; kinship [n -S]\n",
  "COUSINAGES": "COUSINAGE, relationship; kinship [n]\n",
  "COUSINHOOD": "the state or condition of a cousin; the collective body of cousins [n -S]\n",
  "COUSINHOODS": "COUSINHOOD, the state or condition of a cousin; the collective body of cousins [n]\n",
  "COUSINLY": "like a cousin [adj]\n",
  "COUSINRIES": "COUSINRY, cousins collectively [n]\n",
  "COUSINRY": "cousins collectively [n COUSINRIES]\n",
  "COUSINS": "COUSIN, a child of one's uncle or aunt [n]\n",
  "COUSINSHIP": "the state of being cousins [n -S]\n",
  "COUSINSHIPS": "COUSINSHIP, the state of being cousins [n]\n",
  "COUTA": "a type of fishing boat used round the coast of Australia [n -S]\n",
  "COUTAS": "COUTA, a type of fishing boat used round the coast of Australia [n]\n",
  "COUTEAU": "(French) a knife [n COUTEAUX]\n",
  "COUTEAUX": "COUTEAU, (French) a knife [n]\n",
  "COUTER": "a piece of armour for the elbow [n -S]\n",
  "COUTERS": "COUTER, a piece of armour for the elbow [n]\n",
  "COUTH": "(Scots) refinement [n -S] / sophisticated [adj COUTHER, COUTHEST]\n",
  "COUTHER": "COUTH, sophisticated [adj]\n",
  "COUTHEST": "COUTH, sophisticated [adj]\n",
  "COUTHIE": "(Scots) friendly, also COUTHY [adj COUTHIER, COUTHIEST]\n",
  "COUTHIER": "COUTHIE, (Scots) friendly, also COUTHY [adj]\n",
  "COUTHIEST": "COUTHIE, (Scots) friendly, also COUTHY [adj]\n",
  "COUTHS": "COUTH, (Scots) refinement [n]\n",
  "COUTHY": "(Scots) friendly, also COUTHIE [adj COUTHIER, COUTHIEST]\n",
  "COUTIL": "(French) a type of cotton fabric, also COUTILLE [n -S]\n",
  "COUTILLE": "(French) a type of cotton fabric, also COUTIL [n -S]\n",
  "COUTILLES": "COUTILLE, (French) a type of cotton fabric, also COUTIL [n]\n",
  "COUTILS": "COUTIL, (French) a type of cotton fabric, also COUTILLE [n]\n",
  "COUTURE": "(French) the business of dressmaking [n -S]\n",
  "COUTURES": "COUTURE, (French) the business of dressmaking [n]\n",
  "COUTURIER": "(French) a (male) dressmaker or dress designer [n -S]\n",
  "COUTURIERE": "(French) a (female) dressmaker or dress designer [n -S]\n",
  "COUTURIERES": "COUTURIERE, (French) a (female) dressmaker or dress designer [n]\n",
  "COUTURIERS": "COUTURIER, (French) a (male) dressmaker or dress designer [n]\n",
  "COUVADE": "(French) a primitive birth ritual [n -S]\n",
  "COUVADES": "COUVADE, (French) a primitive birth ritual [n]\n",
  "COUVERT": "(French) a cover (at table) [n -S]\n",
  "COUVERTS": "COUVERT, (French) a cover (at table) [n]\n",
  "COUZIN": "(South African) a friend [n -S]\n",
  "COUZINS": "COUZIN, (South African) a friend [n]\n",
  "COVALENCE": "the union of a pair of atoms by the sharing of a pair of electrons, one from each atom, also COVALENCY [n -S]\n",
  "COVALENCES": "COVALENCE, the union of a pair of atoms by the sharing of a pair of electrons, one from each atom, also COVALENCY [n]\n",
  "COVALENCIES": "COVALENCY, the union of a pair of atoms by the sharing of a pair of electrons, one from each atom, also COVALENCE [n]\n",
  "COVALENCY": "the union of a pair of atoms by the sharing of a pair of electrons, one from each atom, also COVALENCE [n COVALENCIES]\n",
  "COVALENT": "sharing electron pairs [adj]\n",
  "COVALENTLY": "COVALENT, sharing electron pairs [adv]\n",
  "COVARIANCE": "the property of varying concomitantly [n -S]\n",
  "COVARIANCES": "COVARIANCE, the property of varying concomitantly [n]\n",
  "COVARIANT": "a function of the coefficients and variables of a given function which is invariant under a linear transformation except for a factor equal to a power of the determinant of the transformation [n -S]\n",
  "COVARIANTS": "COVARIANT, a function of the coefficients and variables of a given function which is invariant under a linear transformation except for a factor equal to a power of the determinant of the transformation [n]\n",
  "COVARIATE": "a statistical variable [n -S]\n",
  "COVARIATES": "COVARIATE, a statistical variable [n]\n",
  "COVARIATION": "the correlated variation of two or more variables [n -S]\n",
  "COVARIATIONS": "COVARIATION, the correlated variation of two or more variables [n]\n",
  "COVARIED": "COVARY, to vary mean values [v]\n",
  "COVARIES": "COVARY, to vary mean values [v]\n",
  "COVARY": "to vary mean values [v COVARIED, COVARYING, COVARIES]\n",
  "COVARYING": "COVARY, to vary mean values [v]\n",
  "COVE": "to curve over or inward [v COVED, COVING, COVES]\n",
  "COVED": "COVE, to curve over or inward [v]\n",
  "COVELET": "a small cove [n -S]\n",
  "COVELETS": "COVELET, a small cove [n]\n",
  "COVELLINE": "a native sulphide of copper, occurring in masses of a dark blue color, also COVELLITE [n -S]\n",
  "COVELLINES": "COVELLINE, a native sulphide of copper, occurring in masses of a dark blue color, also COVELLITE [n]\n",
  "COVELLITE": "a native sulphide of copper, occurring in masses of a dark blue color, also COVELLINE [n -S]\n",
  "COVELLITES": "COVELLITE, a native sulphide of copper, occurring in masses of a dark blue color, also COVELLINE [n]\n",
  "COVEN": "a group of witches [n -S]\n",
  "COVENANT": "to enter into a binding agreement [v -ED, -ING, -S]\n",
  "COVENANTAL": "relating to a covenant [adj COVENANTALLY]\n",
  "COVENANTALLY": "COVENANTAL, relating to a covenant [adv]\n",
  "COVENANTED": "COVENANT, to enter into a binding agreement [v]\n",
  "COVENANTEE": "the person in whose favor a covenant is made [n -S]\n",
  "COVENANTEES": "COVENANTEE, the person in whose favor a covenant is made [n]\n",
  "COVENANTER": "one who makes a covenant, also COVENANTOR [n -S]\n",
  "COVENANTERS": "COVENANTER, one who makes a covenant, also COVENANTOR [n]\n",
  "COVENANTING": "COVENANT, to enter into a binding agreement [v]\n",
  "COVENANTOR": "the party who makes a covenant, also COVENANTER [n -S]\n",
  "COVENANTORS": "COVENANTOR, the party who makes a covenant, also COVENANTER [n]\n",
  "COVENANTS": "COVENANT, to enter into a binding agreement [v]\n",
  "COVENS": "COVEN, a group of witches [n]\n",
  "COVENT": "(archaic) a convent, also CONVENT [n -S]\n",
  "COVENTS": "COVENT, (archaic) a convent, also CONVENT [n]\n",
  "COVER": "to spread something over [v -ED, -ING, -S]\n",
  "COVERABLE": "that can be covered [adj]\n",
  "COVERAGE": "the extent to which something is covered [n -S]\n",
  "COVERAGES": "COVERAGE, the extent to which something is covered [n]\n",
  "COVERALL": "one-piece protective clothing [n -S]\n",
  "COVERALLED": "wearing a coverall [adj]\n",
  "COVERALLS": "COVERALL, one-piece protective clothing [n]\n",
  "COVERED": "COVER, to spread something over [v]\n",
  "COVERER": "one that covers [n -S]\n",
  "COVERERS": "COVERER, one that covers [n]\n",
  "COVERING": "something that covers [n -S]\n",
  "COVERINGS": "COVERING, something that covers [n]\n",
  "COVERLESS": "without a cover [adj]\n",
  "COVERLET": "a bed covering, also COVERLID [n -S]\n",
  "COVERLETS": "COVERLET, a bed covering, also COVERLID [n]\n",
  "COVERLID": "a bed covering, also COVERLET [n -S]\n",
  "COVERLIDS": "COVERLID, a bed covering, also COVERLET [n]\n",
  "COVERMOUNT": "to attach an item to the front of a magazine as a gift [v -ED, -ING, -S]\n",
  "COVERMOUNTED": "COVERMOUNT, to attach an item to the front of a magazine as a gift [v]\n",
  "COVERMOUNTING": "COVERMOUNT, to attach an item to the front of a magazine as a gift [v]\n",
  "COVERMOUNTS": "COVERMOUNT, to attach an item to the front of a magazine as a gift [v]\n",
  "COVERS": "COVER, to spread something over [v]\n",
  "COVERSED": "as in coversed sine/cosine, the versed sine/cosine of the complement of an arc or angle [adj]\n",
  "COVERSINE": "a function in trigonometry [n -S]\n",
  "COVERSINES": "COVERSINE, a function in trigonometry [n]\n",
  "COVERSLIP": "a loose cover for a duvet [n -S]\n",
  "COVERSLIPS": "COVERSLIP, a loose cover for a duvet [n]\n",
  "COVERT": "secret [adj COVERTER, COVERTEST; COVERTLY] / a hiding place [n -S]\n",
  "COVERTER": "COVERT, secret [adj]\n",
  "COVERTEST": "COVERT, secret [adj]\n",
  "COVERTLY": "COVERT, secret [adv]\n",
  "COVERTNESS": "the state of being covert [n -ES]\n",
  "COVERTNESSES": "COVERTNESS, the state of being covert [n]\n",
  "COVERTS": "COVERT, a hiding place [n]\n",
  "COVERTURE": "covering; shelter [n -S]\n",
  "COVERTURES": "COVERTURE, covering; shelter [n]\n",
  "COVERUP": "something used to conceal improper activity [n -S]\n",
  "COVERUPS": "COVERUP, something used to conceal improper activity [n]\n",
  "COVES": "COVE, to curve over or inward [v]\n",
  "COVET": "to desire greatly [v -ED, -ING, -S]\n",
  "COVETABLE": "that may be coveted [adj]\n",
  "COVETED": "COVET, to desire greatly [v]\n",
  "COVETER": "one who covets [n -S]\n",
  "COVETERS": "COVETER, one who covets [n]\n",
  "COVETING": "COVET, to desire greatly [v]\n",
  "COVETINGLY": "COVETING, COVET, to desire greatly [adv]\n",
  "COVETISE": "(obsolete) covetousness; ardent desire [n -S]\n",
  "COVETISES": "COVETISE, (obsolete) covetousness; ardent desire [n]\n",
  "COVETIVENESS": "(obsolete) acquisitiveness [n -ES]\n",
  "COVETIVENESSES": "COVETIVENESS, (obsolete) acquisitiveness [n]\n",
  "COVETOUS": "avaricious [adj COVETOUSLY]\n",
  "COVETOUSLY": "COVETOUS, avaricious [adv]\n",
  "COVETOUSNESS": "the state of being covetous [n -ES]\n",
  "COVETOUSNESSES": "COVETOUSNESS, the state of being covetous [n]\n",
  "COVETS": "COVET, to desire greatly [v]\n",
  "COVEY": "a small flock of birds such as partridge or quail [n -S]\n",
  "COVEYS": "COVEY, a small flock of birds such as partridge or quail [n]\n",
  "COVIN": "a conspiracy between two or more people to act to the injury of another, also COVINE, COVYNE [n -S]\n",
  "COVINE": "a conspiracy between two or more people to act to the injury of another, also COVIN, COVYNE [n -S]\n",
  "COVINES": "COVINE, a conspiracy between two or more people to act to the injury of another, also COVIN, COVYNE [n]\n",
  "COVING": "a concave moulding [n -S]\n",
  "COVINGS": "COVING, a concave moulding [n]\n",
  "COVINOUS": "(archaic) fraudulent [adj]\n",
  "COVINS": "COVIN, a conspiracy between two or more people to act to the injury of another, also COVINE, COVYNE [n]\n",
  "COVYNE": "a conspiracy between two or more people to act to the injury of another, also COVIN, COVINE [n -S]\n",
  "COVYNES": "COVYNE, a conspiracy between two or more people to act to the injury of another, also COVIN, COVINE [n]\n",
  "COW": "the female of bovine and some other animals [n COWS, KINE, KY, KYE] / to subdue [v COWED, COWING, COWS]\n",
  "COWABUNGA": "an interjection used to express delight or satisfaction [interj]\n",
  "COWAGE": "(Hindi) a leguminous climbing plant with crooked pods covered with sharp stinging hairs, also COWHAGE, COWITCH [n -S]\n",
  "COWAGES": "COWAGE, (Hindi) a leguminous climbing plant with crooked pods covered with sharp stinging hairs, also COWHAGE, COWITCH [n]\n",
  "COWAL": "(Native Australian) a shallow lake or swamp [n -S]\n",
  "COWALS": "COWAL, (Native Australian) a shallow lake or swamp [n]\n",
  "COWAN": "(Scots) a drystone diker; a mason who has never served an apprenticeship [n -S]\n",
  "COWANS": "COWAN, (Scots) a drystone diker; a mason who has never served an apprenticeship [n]\n",
  "COWARD": "one who lacks courage, also COWHEARD [n -S] / to weaken the courage of, make afraid [v -ED, -ING, -S]\n",
  "COWARDED": "COWARD, to weaken the courage of, make afraid [v]\n",
  "COWARDICE": "lack of courage, also COWARDRY [n -S]\n",
  "COWARDICES": "COWARDICE, lack of courage, also COWARDRY [n]\n",
  "COWARDING": "COWARD, to weaken the courage of, make afraid [v]\n",
  "COWARDLIER": "COWARDLY, like a coward, lacking courage [adj]\n",
  "COWARDLIEST": "COWARDLY, like a coward, lacking courage [adj]\n",
  "COWARDLINESS": "the state of being cowardly [n -ES]\n",
  "COWARDLINESSES": "COWARDLINESS, the state of being cowardly [n]\n",
  "COWARDLY": "like a coward, lacking courage [adj COWARDLIER, COWARDLIEST]\n",
  "COWARDRIES": "COWARDRY, cowardice [n]\n",
  "COWARDRY": "cowardice [n COWARDRIES]\n",
  "COWARDS": "COWARD, to weaken the courage of, make afraid [v]\n",
  "COWARDSHIP": "(Shakespeare) cowardice [n -S]\n",
  "COWARDSHIPS": "COWARDSHIP, (Shakespeare) cowardice [n]\n",
  "COWBANE": "the water hemlock, often poisonous to cattle [n -S]\n",
  "COWBANES": "COWBANE, the water hemlock, often poisonous to cattle [n]\n",
  "COWBELL": "a bell worn around a cow's neck [n -S]\n",
  "COWBELLS": "COWBELL, a bell worn around a cow's neck [n]\n",
  "COWBERRIES": "COWBERRY, the red whortleberry [n]\n",
  "COWBERRY": "the red whortleberry [n COWBERRIES]\n",
  "COWBIND": "a species of bryony [n -S]\n",
  "COWBINDS": "COWBIND, a species of bryony [n]\n",
  "COWBIRD": "a kind of American starling, so called because frequently associated with cattle [n -S]\n",
  "COWBIRDS": "COWBIRD, a kind of American starling, so called because frequently associated with cattle [n]\n",
  "COWBOY": "a ranch worker [n -S] / to behave like a cowboy [v -ED, -ING, -S]\n",
  "COWBOYED": "COWBOY, to behave like a cowboy [v]\n",
  "COWBOYING": "working as a cowboy [n -S]\n",
  "COWBOYINGS": "COWBOYING, working as a cowboy [n]\n",
  "COWBOYS": "COWBOY, a ranch worker [n]\n",
  "COWCATCHER": "a device on the front of a train for clearing obstacles off the track [n -S]\n",
  "COWCATCHERS": "COWCATCHER, a device on the front of a train for clearing obstacles off the track [n]\n",
  "COWED": "COW, to subdue [v]\n",
  "COWEDLY": "COWED, COW, to subdue [adv]\n",
  "COWER": "to cringe [v -ED, -ING, -S]\n",
  "COWERED": "COWER, to cringe [v]\n",
  "COWERING": "COWER, to cringe [v]\n",
  "COWERINGLY": "COWERING, COWER, to cringe [adv]\n",
  "COWERS": "COWER, to cringe [v]\n",
  "COWFEEDER": "a dairyman [n -S]\n",
  "COWFEEDERS": "COWFEEDER, a dairyman [n]\n",
  "COWFETERIA": "(New Zealand) a calf feeder with multiple teats [n -S]\n",
  "COWFETERIAS": "COWFETERIA, (New Zealand) a calf feeder with multiple teats [n]\n",
  "COWFISH": "an aquatic mammal, aka manatee [n -ES]\n",
  "COWFISHES": "COWFISH, an aquatic mammal, aka manatee [n]\n",
  "COWFLAP": "a dropping of cow dung, also COWPAT, COWFLOP, COWPIE, COWPLOP [n -S]\n",
  "COWFLAPS": "COWFLAP, a dropping of cow dung, also COWPAT, COWFLOP, COWPIE, COWPLOP [n]\n",
  "COWFLOP": "a dropping of cow dung, also COWPAT, COWFLAP, COWPIE, COWPLOP [n -S]\n",
  "COWFLOPS": "COWFLOP, a dropping of cow dung, also COWPAT, COWFLAP, COWPIE, COWPLOP [n]\n",
  "COWGIRL": "a female ranch worker [n -S]\n",
  "COWGIRLS": "COWGIRL, a female ranch worker [n]\n",
  "COWGRASS": "a type of red clover [n -ES]\n",
  "COWGRASSES": "COWGRASS, a type of red clover [n]\n",
  "COWHAGE": "(Hindi) a leguminous climbing plant with crooked pods covered with sharp stinging hairs, also COWAGE, COWITCH [n -S]\n",
  "COWHAGES": "COWHAGE, (Hindi) a leguminous climbing plant with crooked pods covered with sharp stinging hairs, also COWAGE, COWITCH [n]\n",
  "COWHAND": "one who looks after cows [n -S]\n",
  "COWHANDS": "COWHAND, one who looks after cows [n]\n",
  "COWHEARD": "(Spenser) a coward [n -S]\n",
  "COWHEARDS": "COWHEARD, (Spenser) a coward [n]\n",
  "COWHEEL": "the foot of an ox stewed to a jelly [n -S]\n",
  "COWHEELS": "COWHEEL, the foot of an ox stewed to a jelly [n]\n",
  "COWHERB": "a European flowering plant related to the carnation [n -S]\n",
  "COWHERBS": "COWHERB, a European flowering plant related to the carnation [n]\n",
  "COWHERD": "one who tends cattle [n -S]\n",
  "COWHERDS": "COWHERD, one who tends cattle [n]\n",
  "COWHIDE": "to flog with a leather whip [v COWHIDED, COWHIDING, COWHIDES]\n",
  "COWHIDED": "COWHIDE, to flog with a leather whip [v]\n",
  "COWHIDES": "COWHIDE, to flog with a leather whip [v]\n",
  "COWHIDING": "COWHIDE, to flog with a leather whip [v]\n",
  "COWHOUSE": "a building to house cows [n -S]\n",
  "COWHOUSES": "COWHOUSE, a building to house cows [n]\n",
  "COWIER": "COWY, suggestive of a cow [adj]\n",
  "COWIEST": "COWY, suggestive of a cow [adj]\n",
  "COWING": "COW, to subdue [v]\n",
  "COWINNER": "one of two or more winners [n -S]\n",
  "COWINNERS": "COWINNER, one of two or more winners [n]\n",
  "COWISH": "an umbelliferous plant with an edible tuberous root found in North America [n -ES]\n",
  "COWISHES": "COWISH, an umbelliferous plant with an edible tuberous root found in North America [n]\n",
  "COWITCH": "(Hindi) a leguminous climbing plant with crooked pods covered with sharp stinging hairs, also COWAGE, COWHAGE [n -ES]\n",
  "COWITCHES": "COWITCH, (Hindi) a leguminous climbing plant with crooked pods covered with sharp stinging hairs, also COWAGE, COWHAGE [n]\n",
  "COWK": "(dialect) to retch, feel nauseated [v -ED, -ING, -S]\n",
  "COWKED": "COWK, (dialect) to retch, feel nauseated [v]\n",
  "COWKING": "COWK, (dialect) to retch, feel nauseated [v]\n",
  "COWKS": "COWK, (dialect) to retch, feel nauseated [v]\n",
  "COWL": "to cover with a hood [v -ED, -ING, -S]\n",
  "COWLED": "COWL, to cover with a hood [v]\n",
  "COWLICK": "a lock of unruly hair [n -S]\n",
  "COWLICKS": "COWLICK, a lock of unruly hair [n]\n",
  "COWLIKE": "resembling a cow [adj]\n",
  "COWLING": "a covering for an aircraft engine [n -S]\n",
  "COWLINGS": "COWLING, a covering for an aircraft engine [n]\n",
  "COWLS": "COWL, to cover with a hood [v]\n",
  "COWLSTAFF": "a staff or pole on which a vessel is supported between two persons [n COWLSTAFFS or COWLSTAVES]\n",
  "COWLSTAFFS": "COWLSTAFF, a staff or pole on which a vessel is supported between two persons [n]\n",
  "COWLSTAVES": "COWLSTAFF, a staff or pole on which a vessel is supported between two persons [n]\n",
  "COWMAN": "one who owns cattle [n COWMEN]\n",
  "COWMEN": "COWMAN, one who owns cattle [n]\n",
  "COWORKER": "a fellow worker [n -S]\n",
  "COWORKERS": "COWORKER, a fellow worker [n]\n",
  "COWP": "(Scots) to overturn, turn up, also COUP [v -ED, -ING, -S]\n",
  "COWPAT": "a dropping of cow dung, also COWFLAP, COWFLOP, COWPIE, COWPLOP [n -S]\n",
  "COWPATS": "COWPAT, a dropping of cow dung, also COWFLAP, COWFLOP, COWPIE, COWPLOP [n]\n",
  "COWPEA": "a leguminous plant indigenous to Asia, used like French beans [n -S]\n",
  "COWPEAS": "COWPEA, a leguminous plant indigenous to Asia, used like French beans [n]\n",
  "COWPED": "COWP, (Scots) to overturn, turn up, also COUP [v]\n",
  "COWPIE": "a dropping of cow dung, also COWPAT, COWFLAP, COWFLOP, COWPLOP [n -S]\n",
  "COWPIES": "COWPIE, a dropping of cow dung, also COWPAT, COWFLAP, COWFLOP, COWPLOP [n]\n",
  "COWPING": "COWP, (Scots) to overturn, turn up, also COUP [v]\n",
  "COWPLOP": "a dropping of cow dung, also COWPAT, COWFLAP, COWFLOP, COWPIE [n -S]\n",
  "COWPLOPS": "COWPLOP, a dropping of cow dung, also COWPAT, COWFLAP, COWFLOP, COWPIE [n]\n",
  "COWPOKE": "(colloquial) a cowboy [n -S]\n",
  "COWPOKES": "COWPOKE, (colloquial) a cowboy [n]\n",
  "COWPOX": "a cattle disease [n -ES]\n",
  "COWPOXES": "COWPOX, a cattle disease [n]\n",
  "COWPS": "COWP, (Scots) to overturn, turn up, also COUP [v]\n",
  "COWPUNCHER": "a cowboy [n -S]\n",
  "COWPUNCHERS": "COWPUNCHER, a cowboy [n]\n",
  "COWPUNK": "music combining country and western with punk rock [n -S]\n",
  "COWPUNKS": "COWPUNK, music combining country and western with punk rock [n]\n",
  "COWRIE": "a glossy seashell, also COWRY [n -S]\n",
  "COWRIES": "COWRIE, a glossy seashell, also COWRY [n]\n",
  "COWRITE": "to collaborate in writing [v COWROTE, COWRITTEN, COWRITING, COWRITES]\n",
  "COWRITER": "one who cowrites [n -S]\n",
  "COWRITERS": "COWRITER, one who cowrites [n]\n",
  "COWRITES": "COWRITE, to collaborate in writing [v]\n",
  "COWRITING": "COWRITE, to collaborate in writing [v]\n",
  "COWRITTEN": "COWRITE, to collaborate in writing [v]\n",
  "COWROTE": "COWRITE, to collaborate in writing [v]\n",
  "COWRY": "a glossy seashell, also COWRIE [n COWRIES]\n",
  "COWS": "COW, to subdue [v]\n",
  "COWSHED": "a shelter for cows [n -S]\n",
  "COWSHEDS": "COWSHED, a shelter for cows [n]\n",
  "COWSKIN": "the hide of a cow [n -S]\n",
  "COWSKINS": "COWSKIN, the hide of a cow [n]\n",
  "COWSLIP": "a flowering plant [n -S]\n",
  "COWSLIPS": "COWSLIP, a flowering plant [n]\n",
  "COWTOWN": "a rural town or city in a cattle-raising area [n -S]\n",
  "COWTOWNS": "COWTOWN, a rural town or city in a cattle-raising area [n]\n",
  "COWTREE": "a South American tree of the mulberry family, that produces a nourishing fluid resembling milk [n -S]\n",
  "COWTREES": "COWTREE, a South American tree of the mulberry family, that produces a nourishing fluid resembling milk [n]\n",
  "COWY": "suggestive of a cow [adj COWIER, COWIEST]\n",
  "COX": "to steer a racing rowboat, also COXSWAIN [v -ED, -ING, -ES]\n",
  "COXA": "(Latin) the first joint of the leg of an insect or crustacean [n COXAE]\n",
  "COXAE": "COXA, (Latin) the first joint of the leg of an insect or crustacean [n]\n",
  "COXAL": "pertaining to the hip bone [adj]\n",
  "COXALGIA": "pain in the hip, also COXALGY [n -S]\n",
  "COXALGIAS": "COXALGIA, pain in the hip, also COXALGY [n]\n",
  "COXALGIC": "pertaining to pain in the hip [adj]\n",
  "COXALGIES": "COXALGY, pain in the hip, also COXALGIA [n]\n",
  "COXALGY": "pain in the hip, also COXALGIA [n COXALGIES]\n",
  "COXCOMB": "a foolishly vain or conceited man [n -S]\n",
  "COXCOMBIC": "foppish, vain, also COXCOMBICAL, COXCOMICAL [adj COXCOMBICALLY]\n",
  "COXCOMBICAL": "foppish, vain, also COXCOMBIC, COXCOMICAL [adj COXCOMBICALLY]\n",
  "COXCOMBICALITY": "the state of being coxcombical [n]\n",
  "COXCOMBICALLY": "COXCOMBICAL, foppish, vain, also COXCOMBIC, COXCOMICAL [adv]\n",
  "COXCOMBRIES": "COXCOMBRY, the behaviour of a coxcomb [n]\n",
  "COXCOMBRY": "the behaviour of a coxcomb [n COXCOMBRIES]\n",
  "COXCOMBS": "COXCOMB, a foolishly vain or conceited man [n]\n",
  "COXCOMICAL": "foppish, vain, also COXCOMBIC, COXCOMBICAL [adj]\n",
  "COXED": "COX, to steer a racing rowboat, also COXSWAIN [v]\n",
  "COXES": "COX, to steer a racing rowboat, also COXSWAIN [v]\n",
  "COXIB": "a drug used in the treatment of osteoarthritis [n -S]\n",
  "COXIBS": "COXIB, a drug used in the treatment of osteoarthritis [n]\n",
  "COXIER": "COXY, self-important, also COCKSY [adj]\n",
  "COXIEST": "COXY, self-important, also COCKSY [adj]\n",
  "COXINESS": "cockiness [n -ES]\n",
  "COXINESSES": "COXINESS, cockiness [n]\n",
  "COXING": "COX, to steer a racing rowboat, also COXSWAIN [v]\n",
  "COXITIDES": "COXITIS, inflammation of the hip joint [n]\n",
  "COXITIS": "inflammation of the hip joint [n COXITIDES]\n",
  "COXLESS": "without a cox [adj]\n",
  "COXSACKIE": "as in coxsackie virus [adj]\n",
  "COXSWAIN": "to steer a racing rowboat, also COX [v -ED, -ING, -S]\n",
  "COXSWAINED": "COXSWAIN, to steer a racing rowboat, also COX [v]\n",
  "COXSWAINING": "COXSWAIN, to steer a racing rowboat, also COX [v]\n",
  "COXSWAINS": "COXSWAIN, to steer a racing rowboat, also COX [v]\n",
  "COXY": "self-important, also COCKSY [adj COXIER, COXIEST]\n",
  "COY": "modest, bashful [adj COYER, COYEST, COYLY] / to affect coyness [v -ED, -ING, -S]\n",
  "COYAU": "(French) a steep roof design [n -S]\n",
  "COYAUS": "COYAU, (French) a steep roof design [n]\n",
  "COYDOG": "a cross between a coyote and a wild dog [n -S]\n",
  "COYDOGS": "COYDOG, a cross between a coyote and a wild dog [n]\n",
  "COYED": "COY, to affect coyness [v]\n",
  "COYER": "COY, modest, bashful [adj]\n",
  "COYEST": "COY, modest, bashful [adj]\n",
  "COYING": "COY, to affect coyness [v]\n",
  "COYISH": "somewhat coy [adj COYISHLY]\n",
  "COYISHLY": "COYISH, somewhat coy [adv]\n",
  "COYISHNESS": "the state of being coyish [n -ES]\n",
  "COYISHNESSES": "COYISHNESS, the state of being coyish [n]\n",
  "COYLY": "COY, modest, bashful [adv]\n",
  "COYNESS": "the state of being coy [n -ES]\n",
  "COYNESSES": "COYNESS, the state of being coy [n]\n",
  "COYOTE": "a predatory canine mammal, related to but smaller than the wolf, native to North America [n -S]\n",
  "COYOTES": "COYOTE, a predatory canine mammal, related to but smaller than the wolf, native to North America [n]\n",
  "COYOTILLO": "(Spanish) a poisonous shrub of the southwestern United States and Mexico [n -S]\n",
  "COYOTILLOS": "COYOTILLO, (Spanish) a poisonous shrub of the southwestern United States and Mexico [n]\n",
  "COYPOU": "an aquatic rodent, also COYPU [n -S]\n",
  "COYPOUS": "COYPOU, an aquatic rodent, also COYPU [n]\n",
  "COYPU": "an aquatic rodent, also COYPOU [n -S]\n",
  "COYPUS": "COYPU, an aquatic rodent, also COYPOU [n]\n",
  "COYS": "COY, to affect coyness [v]\n",
  "COYSTREL": "(obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COISTRIL, COYSTRIL, CUSTREL [n -S]\n",
  "COYSTRELS": "COYSTREL, (obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COISTRIL, COYSTRIL, CUSTREL [n]\n",
  "COYSTRIL": "(obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COISTRIL, COYSTREL, CUSTREL [n -S]\n",
  "COYSTRILS": "COYSTRIL, (obsolete) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COISTRIL, COYSTREL, CUSTREL [n]\n",
  "COZ": "(archaic) cousin, also CUZ [n COZZES]\n",
  "COZE": "to converse in a friendly manner, chat [v COZED, COZING, COZES]\n",
  "COZED": "COZE, to converse in a friendly manner, chat [v]\n",
  "COZEN": "to cheat, also COOSEN, COOSIN [v -ED, -ING, -S]\n",
  "COZENAGE": "the practice of cozening [n -S]\n",
  "COZENAGES": "COZENAGE, the practice of cozening [n]\n",
  "COZENED": "COZEN, to cheat, also COOSEN, COOSIN [v]\n",
  "COZENER": "one who cozens [n -S]\n",
  "COZENERS": "COZENER, one who cozens [n]\n",
  "COZENING": "COZEN, to cheat, also COOSEN, COOSIN [v]\n",
  "COZENS": "COZEN, to cheat, also COOSEN, COOSIN [v]\n",
  "COZES": "COZE, to converse in a friendly manner, chat [v]\n",
  "COZEY": "a covering for a teapot, also COSEY, COSIE, COZIE [n -S]\n",
  "COZEYS": "COZEY, a covering for a teapot, also COSEY, COSIE, COZIE [n]\n",
  "COZIE": "a cover for a teapot, also COSEY, COSIE, COSY, COZEY, COZY [n -S]\n",
  "COZIED": "COZY, to attempt to get on friendly terms, also COSY [v]\n",
  "COZIER": "(Shakespeare) a cobbler, also COSIER [n -S]\n",
  "COZIERS": "COZIER, (Shakespeare) a cobbler, also COSIER [n]\n",
  "COZIES": "COZY, to attempt to get on friendly terms, also COSY [v]\n",
  "COZIEST": "COZY, snug and comfortable, also COSY [adj]\n",
  "COZILY": "COZY, snug and comfortable, also COSY [adv]\n",
  "COZINESS": "the state or quality of being cozy [n -ES]\n",
  "COZINESSES": "COZINESS, the state or quality of being cozy [n]\n",
  "COZING": "COZE, to converse in a friendly manner, chat [v]\n",
  "COZY": "to attempt to get on friendly terms, also COSY [v COZIED, COZYING, COZIES] / snug and comfortable, also COSY [adj COZIER, COZIEST, COZILY]\n",
  "COZYING": "COZY, to attempt to get on friendly terms, also COSY [v]\n",
  "COZZES": "COZ, (archaic) cousin, also CUZ [n]\n",
  "COZZIE": "(colloquial) a swimming costume, also COSSIE [n -S]\n",
  "COZZIES": "COZZIE, (colloquial) a swimming costume, also COSSIE [n]\n",
  "CRAAL": "(South African) to pen in an enclosure [v -ED, -ING, -S]\n",
  "CRAALED": "CRAAL, (South African) to pen in an enclosure [v]\n",
  "CRAALING": "CRAAL, (South African) to pen in an enclosure [v]\n",
  "CRAALS": "CRAAL, (South African) to pen in an enclosure [v]\n",
  "CRAB": "a marine crustacean [n -S] / to obstruct, frustrate [v CRABBED, CRABBING, CRABS]\n",
  "CRABAPPLE": "a small sour wild apple [n -S]\n",
  "CRABAPPLES": "CRABAPPLE, a small sour wild apple [n]\n",
  "CRABBED": "CRAB, to obstruct, frustrate [v]\n",
  "CRABBEDLY": "CRABBED, CRAB, to obstruct, frustrate [adv]\n",
  "CRABBEDNESS": "the state of being crabbed [n -ES]\n",
  "CRABBEDNESSES": "CRABBEDNESS, the state of being crabbed [n]\n",
  "CRABBER": "a crab fisherman [n -S]\n",
  "CRABBERS": "CRABBER, a crab fisherman [n]\n",
  "CRABBIER": "CRABBY, ill-tempered [adj]\n",
  "CRABBIEST": "CRABBY, ill-tempered [adj]\n",
  "CRABBILY": "CRABBY, ill-tempered [adv]\n",
  "CRABBINESS": "the state of being crabby [n -ES]\n",
  "CRABBINESSES": "CRABBINESS, the state of being crabby [n]\n",
  "CRABBING": "CRAB, to obstruct, frustrate [v]\n",
  "CRABBIT": "bad-tempered, irritable [adj]\n",
  "CRABBY": "ill-tempered [adj CRABBIER, CRABBIEST, CRABBILY]\n",
  "CRABEATER": "a species of seal [n -S]\n",
  "CRABEATERS": "CRABEATER, a species of seal [n]\n",
  "CRABGRASS": "a type of grass [n -ES]\n",
  "CRABGRASSES": "CRABGRASS, a type of grass [n]\n",
  "CRABLIKE": "like a crab [adj]\n",
  "CRABMEAT": "the edible part of a crab [n -S]\n",
  "CRABMEATS": "CRABMEAT, the edible part of a crab [n]\n",
  "CRABS": "CRAB, to obstruct, frustrate [v]\n",
  "CRABSTICK": "a stick, cane, or cudgel, made of the wood of the crab tree [n -S]\n",
  "CRABSTICKS": "CRABSTICK, a stick, cane, or cudgel, made of the wood of the crab tree [n]\n",
  "CRABWISE": "in the manner of a crab, sideways [adv]\n",
  "CRABWOOD": "a tropical American tree [n -S]\n",
  "CRABWOODS": "CRABWOOD, a tropical American tree [n]\n",
  "CRACHACH": "(Welsh) Welsh people who snobbishly affect English customs, manners and speech [n]\n",
  "CRACK": "to break without dividing into parts [v -ED, -ING, -S]\n",
  "CRACKA": "(offensive US) a derogatory term for a poor white person [n -S]\n",
  "CRACKAJACK": "a person or thing of highest excellence, also CRACKERJACK [n -S]\n",
  "CRACKAJACKS": "CRACKAJACK, a person or thing of highest excellence, also CRACKERJACK [n]\n",
  "CRACKAS": "CRACKA, (offensive US) a derogatory term for a poor white person [n]\n",
  "CRACKBACK": "in American football, an illegal block made by an offensive player [n -S]\n",
  "CRACKBACKS": "CRACKBACK, in American football, an illegal block made by an offensive player [n]\n",
  "CRACKBERRIES": "CRACKBERRY, a BlackBerry handheld computer, particularly one used obsessively; a person who uses such a computer obsessively [n]\n",
  "CRACKBERRY": "a BlackBerry handheld computer, particularly one used obsessively; a person who uses such a computer obsessively [n CRACKBERRIES]\n",
  "CRACKBRAIN": "a crazy person [n -S]\n",
  "CRACKBRAINED": "of or like a crackbrain, a crazy person [adj]\n",
  "CRACKBRAINS": "CRACKBRAIN, a crazy person [n]\n",
  "CRACKDOWN": "the taking of a firm action [n -S]\n",
  "CRACKDOWNS": "CRACKDOWN, the taking of a firm action [n]\n",
  "CRACKED": "CRACK, to break without dividing into parts [v]\n",
  "CRACKER": "a thin, crisp biscuit [n -S]\n",
  "CRACKERJACK": "a person or thing of marked excellence, also CRACKAJACK [n -S]\n",
  "CRACKERJACKS": "CRACKERJACK, a person or thing of marked excellence, also CRACKAJACK [n]\n",
  "CRACKERS": "CRACKER, a thin, crisp biscuit [n]\n",
  "CRACKET": "(English dialect) a low stool or box knelt on by miners [n -S]\n",
  "CRACKETS": "CRACKET, (English dialect) a low stool or box knelt on by miners [n]\n",
  "CRACKHEAD": "a drug addict [n -S]\n",
  "CRACKHEADS": "CRACKHEAD, a drug addict [n]\n",
  "CRACKIE": "a small dog of mixed breed [n -S]\n",
  "CRACKIER": "CRACKY, full of cracks [adj]\n",
  "CRACKIES": "CRACKIE, a small dog of mixed breed [n]\n",
  "CRACKIEST": "CRACKY, full of cracks [adj]\n",
  "CRACKING": "a chemical process [n -S]\n",
  "CRACKINGS": "CRACKING, a chemical process [n]\n",
  "CRACKJAW": "a word which is hard to pronounce [n -S]\n",
  "CRACKJAWS": "CRACKJAW, a word which is hard to pronounce [n]\n",
  "CRACKLE": "to emit snapping sounds [v CRACKLED, CRACKLING, CRACKLES]\n",
  "CRACKLED": "CRACKLE, to emit snapping sounds [v]\n",
  "CRACKLES": "CRACKLE, to emit snapping sounds [v]\n",
  "CRACKLEWARE": "pottery with a crackled glaze [n -S]\n",
  "CRACKLEWARES": "CRACKLEWARE, pottery with a crackled glaze [n]\n",
  "CRACKLIER": "CRACKLY, making a crackling noise [adj]\n",
  "CRACKLIEST": "CRACKLY, making a crackling noise [adj]\n",
  "CRACKLING": "the rind of roast pork [n -S]\n",
  "CRACKLINGS": "CRACKLING, the rind of roast pork [n]\n",
  "CRACKLY": "making a crackling noise [adj CRACKLIER, CRACKLIEST]\n",
  "CRACKNEL": "a hard, crisp biscuit [n -S]\n",
  "CRACKNELS": "CRACKNEL, a hard, crisp biscuit [n]\n",
  "CRACKPOT": "an eccentric person [n -S]\n",
  "CRACKPOTS": "CRACKPOT, an eccentric person [n]\n",
  "CRACKS": "CRACK, to break without dividing into parts [v]\n",
  "CRACKSMAN": "a safe-breaker [n CRACKSMEN]\n",
  "CRACKSMEN": "CRACKSMAN, a safe-breaker [n]\n",
  "CRACKUP": "a mental breakdown [n -S]\n",
  "CRACKUPS": "CRACKUP, a mental breakdown [n]\n",
  "CRACKY": "full of cracks [adj CRACKIER, CRACKIEST]\n",
  "CRACOVIENNE": "(Polish) a lively Polish dance, also KRAKOWIAK [n -S]\n",
  "CRACOVIENNES": "CRACOVIENNE, (Polish) a lively Polish dance, also KRAKOWIAK [n]\n",
  "CRACOWE": "(Polish) a long-toed boot fashionable in the court of Richard II [n -S]\n",
  "CRACOWES": "CRACOWE, (Polish) a long-toed boot fashionable in the court of Richard II [n]\n",
  "CRADLE": "to hold lovingly [v CRADLED, CRADLING, CRADLES]\n",
  "CRADLED": "CRADLE, to hold lovingly [v]\n",
  "CRADLER": "one who cradles [n -S]\n",
  "CRADLERS": "CRADLER, one who cradles [n]\n",
  "CRADLES": "CRADLE, to hold lovingly [v]\n",
  "CRADLESONG": "a lullaby [n -S]\n",
  "CRADLESONGS": "CRADLESONG, a lullaby [n]\n",
  "CRADLEWALK": "an avenue arched over with trees [n -S]\n",
  "CRADLEWALKS": "CRADLEWALK, an avenue arched over with trees [n]\n",
  "CRADLING": "a wooden or iron framework within a ceiling [n -S]\n",
  "CRADLINGS": "CRADLING, a wooden or iron framework within a ceiling [n]\n",
  "CRAFT": "to make by hand [v -ED, -ING, -S]\n",
  "CRAFTED": "CRAFT, to make by hand [v]\n",
  "CRAFTER": "a person doing craftwork [n -S]\n",
  "CRAFTERS": "CRAFTER, a person doing craftwork [n]\n",
  "CRAFTIER": "CRAFTY, skillful in deceiving [adj]\n",
  "CRAFTIEST": "CRAFTY, skillful in deceiving [adj]\n",
  "CRAFTILY": "CRAFTY, skillful in deceiving [adv]\n",
  "CRAFTINESS": "the quality of being crafty [n -ES]\n",
  "CRAFTINESSES": "CRAFTINESS, the quality of being crafty [n]\n",
  "CRAFTING": "CRAFT, to make by hand [v]\n",
  "CRAFTLESS": "without craft or cunning [adj]\n",
  "CRAFTMANSHIP": "the attributes of a craftsman, also CRAFTSMANSHIP [n -S]\n",
  "CRAFTMANSHIPS": "CRAFTMANSHIP, the attributes of a craftsman, also CRAFTSMANSHIP [n]\n",
  "CRAFTS": "CRAFT, to make by hand [v]\n",
  "CRAFTSMAN": "one who has a craft [n CRAFTSMEN]\n",
  "CRAFTSMANLIKE": "like a craftsman [adj]\n",
  "CRAFTSMANLY": "like a craftsman [adj]\n",
  "CRAFTSMANSHIP": "the skills of craftsman, also CRAFTMANSHIP [n -S]\n",
  "CRAFTSMANSHIPS": "CRAFTSMANSHIP, the skills of craftsman, also CRAFTMANSHIP [n]\n",
  "CRAFTSMEN": "CRAFTSMAN, one who has a craft [n]\n",
  "CRAFTSPEOPLE": "workers who practice a trade or craft [n]\n",
  "CRAFTSPERSON": "a craftsman or craftswoman [n CRAFTSPERSONS or CRAFTSPEOPLE]\n",
  "CRAFTSPERSONS": "CRAFTSPERSON, a craftsman or craftswoman [n]\n",
  "CRAFTSWOMAN": "a woman who is an artisan [n CRAFTSWOMEN]\n",
  "CRAFTSWOMEN": "CRAFTSWOMAN, a woman who is an artisan [n]\n",
  "CRAFTWORK": "creative artistic activity involving construction, carving, weaving, sewing, etc. [n -S]\n",
  "CRAFTWORKS": "CRAFTWORK, creative artistic activity involving construction, carving, weaving, sewing, etc. [n]\n",
  "CRAFTY": "skillful in deceiving [adj CRAFTIER, CRAFTIEST, CRAFTILY]\n",
  "CRAG": "a large jagged rock [n -S]\n",
  "CRAGFAST": "stuck on a crag [adj]\n",
  "CRAGGED": "full of crags, or steep, broken rocks [adj]\n",
  "CRAGGEDNESS": "the state of being cragged, full of crags [n -ES]\n",
  "CRAGGEDNESSES": "CRAGGEDNESS, the state of being cragged, full of crags [n]\n",
  "CRAGGER": "a member of a carbon reduction action group [n -S]\n",
  "CRAGGERS": "CRAGGER, a member of a carbon reduction action group [n]\n",
  "CRAGGIER": "CRAGGY, full of crags [adj]\n",
  "CRAGGIEST": "CRAGGY, full of crags [adj]\n",
  "CRAGGILY": "CRAGGY, full of crags [adv]\n",
  "CRAGGINESS": "the quality of being craggy [n -ES]\n",
  "CRAGGINESSES": "CRAGGINESS, the quality of being craggy [n]\n",
  "CRAGGY": "full of crags [adj CRAGGIER, CRAGGIEST]\n",
  "CRAGS": "CRAG, a large jagged rock [n]\n",
  "CRAGSMAN": "someone who climbs crags [n CRAGSMEN]\n",
  "CRAGSMEN": "CRAGSMAN, someone who climbs crags [n]\n",
  "CRAIC": "(Irish) pleasant conversation [n -S]\n",
  "CRAICS": "CRAIC, (Irish) pleasant conversation [n]\n",
  "CRAIG": "(Scots) a crag, in the sense of cliff or neck, also CRAG [n -S]\n",
  "CRAIGFLUKE": "a type of flat fish, aka the witch [n -S]\n",
  "CRAIGFLUKES": "CRAIGFLUKE, a type of flat fish, aka the witch [n]\n",
  "CRAIGS": "CRAIG, (Scots) a crag, in the sense of cliff or neck, also CRAG [n]\n",
  "CRAKE": "(dialect) to utter the cry of a corncrake [v CRAKED, CRAKING, CRAKES]\n",
  "CRAKEBERRIES": "CRAKEBERRY, another name for crowberry [n]\n",
  "CRAKEBERRY": "another name for crowberry [n CRAKEBERRIES]\n",
  "CRAKED": "CRAKE, (dialect) to utter the cry of a corncrake [v]\n",
  "CRAKES": "CRAKE, (dialect) to utter the cry of a corncrake [v]\n",
  "CRAKING": "CRAKE, (dialect) to utter the cry of a corncrake [v]\n",
  "CRAM": "to pack tightly [v CRAMMED, CRAMMING, CRAMS]\n",
  "CRAMBE": "(Latin) warmed-over cabbage; the annoying repetition or a tiresome, harped-on old story [n -S]\n",
  "CRAMBES": "CRAMBE, (Latin) warmed-over cabbage; the annoying repetition or a tiresome, harped-on old story [n]\n",
  "CRAMBO": "a game in which one player gives a word or line of verse to be matched in rhyme by other players [n CRAMBOS or CRAMBOES]\n",
  "CRAMBOCLINK": "(Scots) rhyming doggerel [n -S]\n",
  "CRAMBOCLINKS": "CRAMBOCLINK, (Scots) rhyming doggerel [n]\n",
  "CRAMBOES": "CRAMBO, a game in which one player gives a word or line of verse to be matched in rhyme by other players [n]\n",
  "CRAMBOS": "CRAMBO, a game in which one player gives a word or line of verse to be matched in rhyme by other players [n]\n",
  "CRAME": "(Scots) a booth for selling goods [n -S]\n",
  "CRAMES": "CRAME, (Scots) a booth for selling goods [n]\n",
  "CRAMESIES": "CRAMESY, (archaic) crimson, also CRAMOISIE, CRAMOISY, CREMOSIN, CREMSIN, CRIMSON [n]\n",
  "CRAMESY": "(archaic) crimson, also CRAMOISIE, CRAMOISY, CREMOSIN, CREMSIN, CRIMSON [n CRAMESIES]\n",
  "CRAMFULL": "completely full [adj]\n",
  "CRAMMABLE": "that can be crammed [adj]\n",
  "CRAMMED": "CRAM, to pack tightly [v]\n",
  "CRAMMER": "a person who or an institution which crams pupils for an examination etc. [n -S]\n",
  "CRAMMERS": "CRAMMER, a person who or an institution which crams pupils for an examination etc. [n]\n",
  "CRAMMING": "the act of stuffing full [n -S]\n",
  "CRAMMINGS": "CRAMMING, the act of stuffing full [n]\n",
  "CRAMOISIE": "(archaic) crimson, also CRAMESY, CRAMOISY, CREMOSIN, CREMSIN, CRIMSON [n -S]\n",
  "CRAMOISIES": "CRAMOISY, (archaic) crimson, also CRAMESY, CRAMOISIE, CREMOSIN, CREMSIN, CRIMSON [n]\n",
  "CRAMOISY": "(archaic) crimson, also CRAMESY, CRAMOISIE, CREMOSIN, CREMSIN, CRIMSON [n CRAMOISIES]\n",
  "CRAMP": "to confine or restrain [v -ED, -ING, -S]\n",
  "CRAMPBARK": "(US) the guelder rose; its medicinal bark [n -S]\n",
  "CRAMPBARKS": "CRAMPBARK, (US) the guelder rose; its medicinal bark [n]\n",
  "CRAMPED": "CRAMP, to confine or restrain [v]\n",
  "CRAMPER": "a spiked metal plate, used as a brace for the feet in the sport of curling [n -S]\n",
  "CRAMPERS": "CRAMPER, a spiked metal plate, used as a brace for the feet in the sport of curling [n]\n",
  "CRAMPET": "a metal tip at the end of a scabbard, also CRAMPIT [n -S]\n",
  "CRAMPETS": "CRAMPET, a metal tip at the end of a scabbard, also CRAMPIT [n]\n",
  "CRAMPFISH": "the electric ray [n -ES]\n",
  "CRAMPFISHES": "CRAMPFISH, the electric ray [n]\n",
  "CRAMPIER": "CRAMPY, affected with cramps [adj]\n",
  "CRAMPIEST": "CRAMPY, affected with cramps [adj]\n",
  "CRAMPING": "CRAMP, to confine or restrain [v]\n",
  "CRAMPIT": "a metal tip at the end of a scabbard, also CRAMPET [n -S]\n",
  "CRAMPITS": "CRAMPIT, a metal tip at the end of a scabbard, also CRAMPET [n]\n",
  "CRAMPON": "to climb using a kind of spiked boot [v CRAMPONS, CRAMPONING or CRAMPONNING, CRAMPONED or CRAMPONNED]\n",
  "CRAMPONED": "CRAMPON, to climb using a kind of spiked boot [v]\n",
  "CRAMPONING": "CRAMPON, to climb using a kind of spiked boot [v]\n",
  "CRAMPONNED": "CRAMPON, to climb using a kind of spiked boot [v]\n",
  "CRAMPONNING": "climbing using crampons [n -S]\n",
  "CRAMPONNINGS": "CRAMPONNING, climbing using crampons [n]\n",
  "CRAMPONS": "CRAMPON, to climb using a kind of spiked boot [v]\n",
  "CRAMPOON": "a device for raising heavy objects, also CRAMPET [n -S]\n",
  "CRAMPOONS": "CRAMPOON, a device for raising heavy objects, also CRAMPET [n]\n",
  "CRAMPS": "CRAMP, to confine or restrain [v]\n",
  "CRAMPY": "affected with cramps [adj CRAMPIER, CRAMPIEST]\n",
  "CRAMS": "CRAM, to pack tightly [v]\n",
  "CRAN": "a measure of capacity for landed herrings [n -S]\n",
  "CRANACHAN": "a traditional Scottish dessert, usually made from a mixture of whipped cream, whisky, honey, and fresh raspberries topped with toasted oatmeal [n -S]\n",
  "CRANACHANS": "CRANACHAN, a traditional Scottish dessert, usually made from a mixture of whipped cream, whisky, honey, and fresh raspberries topped with toasted oatmeal [n]\n",
  "CRANAGE": "the use of a crane to hoist goods; the dues paid for this [n -S]\n",
  "CRANAGES": "CRANAGE, the use of a crane to hoist goods; the dues paid for this [n]\n",
  "CRANAPPLE": "designating a combination of cranberries and apple [adj]\n",
  "CRANBERRIES": "CRANBERRY, the red acid berry of a small evergreen shrub, made into sauces and jellies [n]\n",
  "CRANBERRY": "the red acid berry of a small evergreen shrub, made into sauces and jellies [n CRANBERRIES]\n",
  "CRANCH": "to chew with a crackling sound, also CRUNCH, CRAUNCH [v -ED, -ING, -ES]\n",
  "CRANCHED": "CRANCH, to chew with a crackling sound, also CRUNCH, CRAUNCH [v]\n",
  "CRANCHES": "CRANCH, to chew with a crackling sound, also CRUNCH, CRAUNCH [v]\n",
  "CRANCHING": "CRANCH, to chew with a crackling sound, also CRUNCH, CRAUNCH [v]\n",
  "CRANE": "to stretch out one's neck [v CRANED, CRANING, CRANES]\n",
  "CRANED": "CRANE, to stretch out one's neck [v]\n",
  "CRANEFLIES": "CRANEFLY, a fly with very long legs, aka daddy-long-legs [n]\n",
  "CRANEFLY": "a fly with very long legs, aka daddy-long-legs [n CRANEFLIES]\n",
  "CRANELIKE": "like a crane [adj]\n",
  "CRANES": "CRANE, to stretch out one's neck [v]\n",
  "CRANESBILL": "any wild species of the Geranium genus, from the beaked fruit [n -S]\n",
  "CRANESBILLS": "CRANESBILL, any wild species of the Geranium genus, from the beaked fruit [n]\n",
  "CRANIA": "CRANIUM, (Latin) the skull [n]\n",
  "CRANIAL": "pertaining to the skull [adj CRANIALLY]\n",
  "CRANIALLY": "CRANIAL, pertaining to the skull [adv]\n",
  "CRANIATE": "one that has a skull [n -S]\n",
  "CRANIATES": "CRANIATE, one that has a skull [n]\n",
  "CRANIECTOMIES": "CRANIECTOMY, surgical opening of the cranium [n]\n",
  "CRANIECTOMY": "surgical opening of the cranium [n CRANIECTOMIES]\n",
  "CRANING": "CRANE, to stretch out one's neck [v]\n",
  "CRANIOCEREBRAL": "involving both cranium and brain [adj]\n",
  "CRANIOFACIAL": "of, relating to, or involving both the cranium and the face [adj]\n",
  "CRANIOGNOMIES": "CRANIOGNOMY, cranial physiognomy [n]\n",
  "CRANIOGNOMY": "cranial physiognomy [n CRANIOGNOMIES]\n",
  "CRANIOLOGICAL": "relating to craniology [adj CRANIOLOGICALLY]\n",
  "CRANIOLOGICALLY": "CRANIOLOGICAL, relating to craniology [adv]\n",
  "CRANIOLOGIES": "CRANIOLOGY, the study of skulls, aka phrenology [n]\n",
  "CRANIOLOGIST": "a practitioner of craniology [n -S]\n",
  "CRANIOLOGISTS": "CRANIOLOGIST, a practitioner of craniology [n]\n",
  "CRANIOLOGY": "the study of skulls, aka phrenology [n CRANIOLOGIES]\n",
  "CRANIOMETER": "an instrument for measuring the skull [n -S]\n",
  "CRANIOMETERS": "CRANIOMETER, an instrument for measuring the skull [n]\n",
  "CRANIOMETRIC": "relating to craniometry, a science dealing with cranial measurement, also CRANIOMETRICAL [adj]\n",
  "CRANIOMETRICAL": "relating to craniometry, a science dealing with cranial measurement, also CRANIOMETRIC [adj]\n",
  "CRANIOMETRIES": "CRANIOMETRY, a science dealing with cranial measurement [n]\n",
  "CRANIOMETRIST": "one who practises craniometry [n -S]\n",
  "CRANIOMETRISTS": "CRANIOMETRIST, one who practises craniometry [n]\n",
  "CRANIOMETRY": "a science dealing with cranial measurement [n CRANIOMETRIES]\n",
  "CRANIOPAGI": "CRANIOPAGUS, the condition of Siamese twins joined at the head [n]\n",
  "CRANIOPAGUS": "the condition of Siamese twins joined at the head [n CRANIOPAGI]\n",
  "CRANIOSACRAL": "as in craniosacral therapy, an alternative therapy involving gentle manipulation of the bones and membranes of the skull, in order to treat a wide range of physical and psychological disorders [adj]\n",
  "CRANIOSCOPIES": "CRANIOSCOPY, phrenology [n]\n",
  "CRANIOSCOPIST": "a phrenologist [n -S]\n",
  "CRANIOSCOPISTS": "CRANIOSCOPIST, a phrenologist [n]\n",
  "CRANIOSCOPY": "phrenology [n CRANIOSCOPIES]\n",
  "CRANIOTOMIES": "CRANIOTOMY, the operation of opening the fetal head, in order to effect delivery [n]\n",
  "CRANIOTOMY": "the operation of opening the fetal head, in order to effect delivery [n CRANIOTOMIES]\n",
  "CRANIUM": "(Latin) the skull [n CRANIA or CRANIUMS]\n",
  "CRANIUMS": "CRANIUM, (Latin) the skull [n]\n",
  "CRANK": "to start manually [v -ED, -ING, -S] / lively [adj CRANKER, CRANKEST, CRANKLY]\n",
  "CRANKBAIT": "a fishing lure with a shape that enables it to dive and stay under water [n -S]\n",
  "CRANKBAITS": "CRANKBAIT, a fishing lure with a shape that enables it to dive and stay under water [n]\n",
  "CRANKCASE": "the case or covering in which a crankshaft is enclosed [n -S]\n",
  "CRANKCASES": "CRANKCASE, the case or covering in which a crankshaft is enclosed [n]\n",
  "CRANKED": "CRANK, to start manually [v]\n",
  "CRANKER": "CRANK, lively [adj]\n",
  "CRANKEST": "CRANK, lively [adj]\n",
  "CRANKHANDLE": "a handle for starting a motor [n -S]\n",
  "CRANKHANDLES": "CRANKHANDLE, a handle for starting a motor [n]\n",
  "CRANKIER": "CRANKY, cantankerous [adj]\n",
  "CRANKIEST": "CRANKY, cantankerous [adj]\n",
  "CRANKILY": "CRANKY, cantankerous [adv]\n",
  "CRANKINESS": "the state of being cranky, cantankerous [n -ES]\n",
  "CRANKINESSES": "CRANKINESS, the state of being cranky, cantankerous [n]\n",
  "CRANKING": "CRANK, to start manually [v]\n",
  "CRANKISH": "eccentric [adj]\n",
  "CRANKLE": "to bend, twist [v CRANKLED, CRANKLING, CRANKLES]\n",
  "CRANKLED": "CRANKLE, to bend, twist [v]\n",
  "CRANKLES": "CRANKLE, to bend, twist [v]\n",
  "CRANKLING": "CRANKLE, to bend, twist [v]\n",
  "CRANKLY": "CRANK, lively [adv]\n",
  "CRANKNESS": "liability to be capsize [n -ES]\n",
  "CRANKNESSES": "CRANKNESS, liability to be capsize [n]\n",
  "CRANKOUS": "cranky [adj]\n",
  "CRANKPIN": "the handle of a crank [n -S]\n",
  "CRANKPINS": "CRANKPIN, the handle of a crank [n]\n",
  "CRANKS": "CRANK, to start manually [v]\n",
  "CRANKSHAFT": "a shaft driven by or driving a crank [n -S]\n",
  "CRANKSHAFTS": "CRANKSHAFT, a shaft driven by or driving a crank [n]\n",
  "CRANKY": "cantankerous [adj CRANKIER, CRANKIEST, CRANKILY]\n",
  "CRANNIED": "CRANNY, to open in crannies and chinks [v]\n",
  "CRANNIES": "CRANNY, to open in crannies and chinks [v]\n",
  "CRANNOG": "(Gaelic) a lake dwelling in Scotland and Ireland, typically a tiny island artificially enlarged and fortified, also CRANNOGE [n -S]\n",
  "CRANNOGE": "(Gaelic) a lake dwelling in Scotland and Ireland, typically a tiny island artificially enlarged and fortified, also CRANNOG [n -S]\n",
  "CRANNOGES": "CRANNOGE, (Gaelic) a lake dwelling in Scotland and Ireland, typically a tiny island artificially enlarged and fortified, also CRANNOG [n]\n",
  "CRANNOGS": "CRANNOG, (Gaelic) a lake dwelling in Scotland and Ireland, typically a tiny island artificially enlarged and fortified, also CRANNOGE [n]\n",
  "CRANNY": "to open in crannies and chinks [v CRANNIED, CRANNYING, CRANNIES]\n",
  "CRANNYING": "CRANNY, to open in crannies and chinks [v]\n",
  "CRANREUCH": "(Gaelic) a hoarfrost [n -S]\n",
  "CRANREUCHS": "CRANREUCH, (Gaelic) a hoarfrost [n]\n",
  "CRANS": "CRAN, a measure of capacity for landed herrings [n]\n",
  "CRANTS": "(Shakespeare) the garland carried before the bier of a maiden and hung over her grave [n -ES]\n",
  "CRANTSES": "CRANTS, (Shakespeare) the garland carried before the bier of a maiden and hung over her grave [n]\n",
  "CRAP": "to defecate [v CRAPPED, CRAPPING, CRAPS]\n",
  "CRAPAUD": "(French) a frog or toad [n -S]\n",
  "CRAPAUDS": "CRAPAUD, (French) a frog or toad [n]\n",
  "CRAPE": "to cover or shroud with crape, also CREPE [v CRAPED, CRAPING, CRAPES]\n",
  "CRAPED": "CRAPE, to cover or shroud with crape, also CREPE [v]\n",
  "CRAPEHANGER": "a morose, gloomy, or pessimistic person, also CREPEHANGER [n -S]\n",
  "CRAPEHANGERS": "CRAPEHANGER, a morose, gloomy, or pessimistic person, also CREPEHANGER [n]\n",
  "CRAPEHANGING": "pessimism, also CREPEHANGING [n -S]\n",
  "CRAPEHANGINGS": "CRAPEHANGING, pessimism, also CREPEHANGING [n]\n",
  "CRAPELIKE": "like crape [adj]\n",
  "CRAPES": "CRAPE, to cover or shroud with crape, also CREPE [v]\n",
  "CRAPIER": "CRAPY, like crape [adj]\n",
  "CRAPIEST": "CRAPY, like crape [adj]\n",
  "CRAPING": "CRAPE, to cover or shroud with crape, also CREPE [v]\n",
  "CRAPLE": "(Spenser) a grapple [n -S]\n",
  "CRAPLES": "CRAPLE, (Spenser) a grapple [n]\n",
  "CRAPOLA": "(colloquial) rubbish, nonsense [n -S]\n",
  "CRAPOLAS": "CRAPOLA, (colloquial) rubbish, nonsense [n]\n",
  "CRAPPED": "CRAP, to defecate [v]\n",
  "CRAPPER": "a toilet [n -S]\n",
  "CRAPPERS": "CRAPPER, a toilet [n]\n",
  "CRAPPIE": "a kind of fish, a member of the sunfish family, also CROPPIE [n -S]\n",
  "CRAPPIER": "CRAPPY, inferior in quality [adj]\n",
  "CRAPPIES": "CRAPPIE, a kind of fish, a member of the sunfish family, also CROPPIE [n]\n",
  "CRAPPIEST": "CRAPPY, inferior in quality [adj]\n",
  "CRAPPING": "CRAP, to defecate [v]\n",
  "CRAPPY": "inferior in quality [adj CRAPPIER, CRAPPIEST]\n",
  "CRAPS": "CRAP, to defecate [v]\n",
  "CRAPSHOOT": "a game of dice [n -S]\n",
  "CRAPSHOOTER": "one who plays craps [n -S]\n",
  "CRAPSHOOTERS": "CRAPSHOOTER, one who plays craps [n]\n",
  "CRAPSHOOTS": "CRAPSHOOT, a game of dice [n]\n",
  "CRAPULENCE": "the sickness occasioned by intemperance; surfeit [n -S]\n",
  "CRAPULENCES": "CRAPULENCE, the sickness occasioned by intemperance; surfeit [n]\n",
  "CRAPULENT": "suffering from overindulgence in food or drink, also CRAPULOUS [adj CRAPULENTLY]\n",
  "CRAPULENTLY": "CRAPULENT, suffering from overindulgence in food or drink, also CRAPULOUS [adv]\n",
  "CRAPULOSITIES": "CRAPULOSITY, the state of being crapulous [n]\n",
  "CRAPULOSITY": "the state of being crapulous [n CRAPULOSITIES]\n",
  "CRAPULOUS": "suffering from overindulgence in food or drink, also CRAPULENT [adj CRAPULOUSLY]\n",
  "CRAPULOUSLY": "CRAPULOUS, suffering from overindulgence in food or drink, also CRAPULENT [adv]\n",
  "CRAPULOUSNESS": "CRAPULOUS, suffering from overindulgence in food or drink, also CRAPULENT [n]\n",
  "CRAPULOUSNESSES": "CRAPULOUSNESS, CRAPULOUS, suffering from overindulgence in food or drink, also CRAPULENT [n]\n",
  "CRAPY": "like crape [adj CRAPIER, CRAPIEST]\n",
  "CRAQUELURE": "(French) fine cracking that appears in old paintings [n -S]\n",
  "CRAQUELURES": "CRAQUELURE, (French) fine cracking that appears in old paintings [n]\n",
  "CRARE": "a trading vessel, also CRAYER [n -S]\n",
  "CRARES": "CRARE, a trading vessel, also CRAYER [n]\n",
  "CRASES": "CRASIS, (Greek) the melding of two vowels into a diphthong [n]\n",
  "CRASH": "to collide noisily [v -ED, -ING, -ES]\n",
  "CRASHED": "CRASH, to collide noisily [v]\n",
  "CRASHER": "one who crashes [n -S]\n",
  "CRASHERS": "CRASHER, one who crashes [n]\n",
  "CRASHES": "CRASH, to collide noisily [v]\n",
  "CRASHING": "extreme, overwhelming, esp. in a crashing bore [adj CRASHINGLY]\n",
  "CRASHINGLY": "CRASHING, extreme, overwhelming, esp. in a crashing bore [adv]\n",
  "CRASHPAD": "temporary accommodation [n -S]\n",
  "CRASHPADS": "CRASHPAD, temporary accommodation [n]\n",
  "CRASHWORTHIER": "CRASHWORTHY, resistant to the effects of collision [adj]\n",
  "CRASHWORTHIEST": "CRASHWORTHY, resistant to the effects of collision [adj]\n",
  "CRASHWORTHINESS": "the state of being crashworthy [n]\n",
  "CRASHWORTHY": "resistant to the effects of collision [adj CRASHWORTHIER, CRASHWORTHIEST]\n",
  "CRASIS": "(Greek) the melding of two vowels into a diphthong [n CRASES]\n",
  "CRASS": "grossly vulgar [adj CRASSER, CRASSEST, CRASSLY]\n",
  "CRASSAMENTA": "CRASSAMENTUM, (Latin) a clot of blood [n]\n",
  "CRASSAMENTUM": "(Latin) a clot of blood [n CRASSAMENTA]\n",
  "CRASSER": "CRASS, grossly vulgar [adj]\n",
  "CRASSEST": "CRASS, grossly vulgar [adj]\n",
  "CRASSITUDE": "the state of being crass [n -S]\n",
  "CRASSITUDES": "CRASSITUDE, the state of being crass [n]\n",
  "CRASSLY": "CRASS, grossly vulgar [adv]\n",
  "CRASSNESS": "the state of being crass [n -ES]\n",
  "CRASSNESSES": "CRASSNESS, the state of being crass [n]\n",
  "CRASSULACEAN": "as in crassulacean acid metabolism, a method of photosynthesis [adj]\n",
  "CRASSULACEOUS": "belonging to the Crassulaceae, a family of succulent plants including the stonecrops and house leeks [adj]\n",
  "CRATCH": "a feed box for cattle [n -ES]\n",
  "CRATCHES": "CRATCH, a feed box for cattle [n]\n",
  "CRATE": "to put in a packing box [v CRATED, CRATING, CRATES]\n",
  "CRATED": "CRATE, to put in a packing box [v]\n",
  "CRATEFUL": "the contents of a crate [n -S]\n",
  "CRATEFULS": "CRATEFUL, the contents of a crate [n]\n",
  "CRATER": "to form cavities in a surface [v -ED, -ING, -S]\n",
  "CRATERED": "CRATER, to form cavities in a surface [v]\n",
  "CRATERIFORM": "cup-shaped [adj]\n",
  "CRATERING": "the act of forming craters [n -S]\n",
  "CRATERINGS": "CRATERING, the act of forming craters [n]\n",
  "CRATERLESS": "without a crater [adj]\n",
  "CRATERLET": "a small crater [n -S]\n",
  "CRATERLETS": "CRATERLET, a small crater [n]\n",
  "CRATERLIKE": "like a crater [adj]\n",
  "CRATEROUS": "pertaining to, or resembling, a crater [adj]\n",
  "CRATERS": "CRATER, to form cavities in a surface [v]\n",
  "CRATES": "CRATE, to put in a packing box [v]\n",
  "CRATHUR": "(Irish) a creature; whiskey, also CRATUR, CRAYTHUR [n -S]\n",
  "CRATHURS": "CRATHUR, (Irish) a creature; whiskey, also CRATUR, CRAYTHUR [n]\n",
  "CRATING": "CRATE, to put in a packing box [v]\n",
  "CRATON": "(Greek) a large, relatively stable section of earth's crust, forming the basis of a continent or ocean [n -S]\n",
  "CRATONIC": "relating to a craton [adj]\n",
  "CRATONS": "CRATON, (Greek) a large, relatively stable section of earth's crust, forming the basis of a continent or ocean [n]\n",
  "CRATUR": "(Scots) a woman, also CRATHUR, CRAYTHUR [n -S]\n",
  "CRATURS": "CRATUR, (Scots) a woman, also CRATHUR, CRAYTHUR [n]\n",
  "CRAUNCH": "(dialect) to chew with a crackling sound, also CRUNCH, CRANCH [v -ED, -ING, -ES]\n",
  "CRAUNCHABLE": "that can be craunched [adj]\n",
  "CRAUNCHED": "CRAUNCH, (dialect) to chew with a crackling sound, also CRUNCH, CRANCH [v]\n",
  "CRAUNCHES": "CRAUNCH, (dialect) to chew with a crackling sound, also CRUNCH, CRANCH [v]\n",
  "CRAUNCHIER": "CRAUNCHY, crunchy [adj]\n",
  "CRAUNCHIEST": "CRAUNCHY, crunchy [adj]\n",
  "CRAUNCHINESS": "the state of being craunchy, crunchy [n -ES]\n",
  "CRAUNCHINESSES": "CRAUNCHINESS, the state of being craunchy, crunchy [n]\n",
  "CRAUNCHING": "CRAUNCH, (dialect) to chew with a crackling sound, also CRUNCH, CRANCH [v]\n",
  "CRAUNCHY": "crunchy [adj CRAUNCHIER, CRAUNCHIEST]\n",
  "CRAVAT": "(French) a scarf or band worn as necktie, also CRAVATE [n -S] / to dress in a cravat [v CRAVATTED, CRAVATTING, CRAVATS]\n",
  "CRAVATE": "a scarf or band worn as necktie, also CRAVAT [n -S]\n",
  "CRAVATES": "CRAVATE, a scarf or band worn as necktie, also CRAVAT [n]\n",
  "CRAVATS": "CRAVAT, (French) a scarf or band worn as necktie, also CRAVATE [n]\n",
  "CRAVATTED": "CRAVAT, to dress in a cravat [v]\n",
  "CRAVATTING": "CRAVAT, to dress in a cravat [v]\n",
  "CRAVE": "to desire greatly [v CRAVED, CRAVING, CRAVES]\n",
  "CRAVED": "CRAVE, to desire greatly [v]\n",
  "CRAVEN": "cowardly [adj CRAVENER, CRAVENEST; CRAVENLY] / to render spiritless [v -ED, -ING, -S]\n",
  "CRAVENED": "CRAVEN, to render spiritless [v]\n",
  "CRAVENER": "CRAVEN, cowardly [adj]\n",
  "CRAVENEST": "CRAVEN, cowardly [adj]\n",
  "CRAVENING": "CRAVEN, to render spiritless [v]\n",
  "CRAVENLY": "CRAVEN, cowardly [adv]\n",
  "CRAVENNESS": "the state of being craven [n -ES]\n",
  "CRAVENNESSES": "CRAVENNESS, the state of being craven [n]\n",
  "CRAVENS": "CRAVEN, to render spiritless [v]\n",
  "CRAVER": "one who craves [n -S]\n",
  "CRAVERS": "CRAVER, one who craves [n]\n",
  "CRAVES": "CRAVE, to desire greatly [v]\n",
  "CRAVING": "a great desire [n -S]\n",
  "CRAVINGS": "CRAVING, a great desire [n]\n",
  "CRAW": "the stomach of an animal [n -S]\n",
  "CRAWDAD": "a crayfish, also CRAWDADDY [n -S]\n",
  "CRAWDADDIES": "CRAWDADDY, a crayfish, also CRAWDAD [n]\n",
  "CRAWDADDY": "a crayfish, also CRAWDAD [n CRAWDADDIES]\n",
  "CRAWDADS": "CRAWDAD, a crayfish, also CRAWDADDY [n]\n",
  "CRAWFISH": "a large edible freshwater decapod crustacean, also CRAYFISH [n -ES] / to retreat or back out [v -ED, -ING, -ES]\n",
  "CRAWFISHED": "CRAWFISH, to retreat or back out [v]\n",
  "CRAWFISHES": "CRAWFISH, to retreat or back out [v]\n",
  "CRAWFISHING": "CRAWFISH, to retreat or back out [v]\n",
  "CRAWL": "to move with the body close to the ground [v -ED, -ING, -S]\n",
  "CRAWLED": "CRAWL, to move with the body close to the ground [v]\n",
  "CRAWLER": "one that crawls [n -S]\n",
  "CRAWLERS": "CRAWLER, one that crawls [n]\n",
  "CRAWLIER": "CRAWLY, creepy [adj]\n",
  "CRAWLIEST": "CRAWLY, creepy [adj]\n",
  "CRAWLING": "creeping; lousy, verminous [adj CRAWLINGLY] / the act of crawling [n -S]\n",
  "CRAWLINGLY": "CRAWLING, creeping; lousy, verminous [adv]\n",
  "CRAWLINGS": "CRAWLING, the act of crawling [n]\n",
  "CRAWLS": "CRAWL, to move with the body close to the ground [v]\n",
  "CRAWLWAY": "a small low tunnel [n -S]\n",
  "CRAWLWAYS": "CRAWLWAY, a small low tunnel [n]\n",
  "CRAWLY": "creepy [adj CRAWLIER, CRAWLIEST]\n",
  "CRAWS": "CRAW, the stomach of an animal [n]\n",
  "CRAY": "(colloq.) crazy [adj CRAYER, CRAYEST] / a crayfish [n -S]\n",
  "CRAYER": "a trading vessel, also CRARE [n -S]\n",
  "CRAYERS": "CRAYER, a trading vessel, also CRARE [n]\n",
  "CRAYEST": "CRAY, (colloq.) crazy [adj]\n",
  "CRAYFISH": "a large edible freshwater decapod crustacean, also CRAWFISH [n -ES]\n",
  "CRAYFISHES": "CRAYFISH, a large edible freshwater decapod crustacean, also CRAWFISH [n]\n",
  "CRAYON": "to use a drawing implement [v -ED, -ING, -S]\n",
  "CRAYONED": "CRAYON, to use a drawing implement [v]\n",
  "CRAYONER": "one who crayons, also CRAYONIST [n -S]\n",
  "CRAYONERS": "CRAYONER, one who crayons, also CRAYONIST [n]\n",
  "CRAYONING": "CRAYON, to use a drawing implement [v]\n",
  "CRAYONIST": "one who draws in crayon, also CRAYONER [n -S]\n",
  "CRAYONISTS": "CRAYONIST, one who draws in crayon, also CRAYONER [n]\n",
  "CRAYONS": "CRAYON, to use a drawing implement [v]\n",
  "CRAYS": "CRAY, a crayfish [n]\n",
  "CRAYTHUR": "(Irish) a woman, also CRATHUR, CRATUR [n -S]\n",
  "CRAYTHURS": "CRAYTHUR, (Irish) a woman, also CRATHUR, CRATUR [n]\n",
  "CRAZE": "to make insane [v CRAZED, CRAZING, CRAZES]\n",
  "CRAZED": "CRAZE, to make insane [v]\n",
  "CRAZES": "CRAZE, to make insane [v]\n",
  "CRAZIER": "CRAZY, insane [adj]\n",
  "CRAZIES": "CRAZY, a crazy person [n]\n",
  "CRAZIEST": "CRAZY, insane [adj]\n",
  "CRAZILY": "CRAZY, insane [adv]\n",
  "CRAZINESS": "the state of being crazy [n -ES]\n",
  "CRAZINESSES": "CRAZINESS, the state of being crazy [n]\n",
  "CRAZING": "a pattern of fine cracks [n -S]\n",
  "CRAZINGS": "CRAZING, a pattern of fine cracks [n]\n",
  "CRAZY": "insane [adj CRAZIER, CRAZIEST, CRAZILY] / a crazy person [n CRAZIES]\n",
  "CRAZYWEED": "a plant the consumption of which drives cattle mad, aka locoweed [n -S]\n",
  "CRAZYWEEDS": "CRAZYWEED, a plant the consumption of which drives cattle mad, aka locoweed [n]\n",
  "CREACH": "(Gaelic) a foray, booty, also CREAGH [n -S]\n",
  "CREACHS": "CREACH, (Gaelic) a foray, booty, also CREAGH [n]\n",
  "CREAGH": "(Gaelic) a foray, booty, also CREACH [n -S]\n",
  "CREAGHS": "CREAGH, (Gaelic) a foray, booty, also CREACH [n]\n",
  "CREAK": "to make a squeaking sound [v -ED, -ING, -S]\n",
  "CREAKED": "CREAK, to make a squeaking sound [v]\n",
  "CREAKIER": "CREAKY, creaking, also SCREAKY [adj]\n",
  "CREAKIEST": "CREAKY, creaking, also SCREAKY [adj]\n",
  "CREAKILY": "CREAKY, creaking, also SCREAKY [adv]\n",
  "CREAKINESS": "the state of being creaky [n -ES]\n",
  "CREAKINESSES": "CREAKINESS, the state of being creaky [n]\n",
  "CREAKING": "CREAK, to make a squeaking sound [v]\n",
  "CREAKINGLY": "CREAKING, CREAK, to make a squeaking sound [adv]\n",
  "CREAKS": "CREAK, to make a squeaking sound [v]\n",
  "CREAKY": "creaking, also SCREAKY [adj CREAKIER, CREAKIEST, CREAKILY]\n",
  "CREAM": "to select the best from a group [v -ED, -ING, -S]\n",
  "CREAMCUPS": "a California annual of the poppy family [n CREAMCUPS]\n",
  "CREAMED": "CREAM, to select the best from a group [v]\n",
  "CREAMER": "a device for separating cream from milk [n -S]\n",
  "CREAMERIES": "CREAMERY, a place where butter and cheese are made, or where milk and cream are put up in cans for market [n]\n",
  "CREAMERS": "CREAMER, a device for separating cream from milk [n]\n",
  "CREAMERY": "a place where butter and cheese are made, or where milk and cream are put up in cans for market [n CREAMERIES]\n",
  "CREAMIER": "CREAMY, having the consistency of cream [adj]\n",
  "CREAMIEST": "CREAMY, having the consistency of cream [adj]\n",
  "CREAMILY": "CREAMY, having the consistency of cream [adv]\n",
  "CREAMINESS": "the state of being creamy [n -ES]\n",
  "CREAMINESSES": "CREAMINESS, the state of being creamy [n]\n",
  "CREAMING": "CREAM, to select the best from a group [v]\n",
  "CREAMLAID": "of paper, cream or white in colour with a laid watermark [adj]\n",
  "CREAMLIKE": "like cream [adj]\n",
  "CREAMPUFF": "puff pastry filled with cream; (slang) an effeminate man [n -S]\n",
  "CREAMPUFFS": "CREAMPUFF, puff pastry filled with cream; (slang) an effeminate man [n]\n",
  "CREAMS": "CREAM, to select the best from a group [v]\n",
  "CREAMWARE": "a type of earthenware with a cream-coloured glaze [n -S]\n",
  "CREAMWARES": "CREAMWARE, a type of earthenware with a cream-coloured glaze [n]\n",
  "CREAMWOVE": "of woven paper, cream or white in colour [adj]\n",
  "CREAMY": "having the consistency of cream [adj CREAMIER, CREAMIEST, CREAMILY]\n",
  "CREANCE": "the cord used in training a hawk [n -S]\n",
  "CREANCES": "CREANCE, the cord used in training a hawk [n]\n",
  "CREANT": "(Latin) creating, formative [adj]\n",
  "CREASE": "to make a wrinkle in [v CREASED, CREASING, CREASES]\n",
  "CREASED": "CREASE, to make a wrinkle in [v]\n",
  "CREASELESS": "without creases [adj]\n",
  "CREASER": "one who creases [n -S]\n",
  "CREASERS": "CREASER, one who creases [n]\n",
  "CREASES": "CREASE, to make a wrinkle in [v]\n",
  "CREASIER": "CREASY, having wrinkles [adj]\n",
  "CREASIEST": "CREASY, having wrinkles [adj]\n",
  "CREASING": "CREASE, to make a wrinkle in [v]\n",
  "CREASOTE": "a pitch-like substance used to coat fences etc., also CREOSOTE, KREASOTE, KREOSOTE [n -S] / to coat with creasote [v CREASOTED, CREASOTING, CREASOTES]\n",
  "CREASOTED": "CREASOTE, to coat with creasote [v]\n",
  "CREASOTES": "CREASOTE, to coat with creasote [v]\n",
  "CREASOTING": "CREASOTE, to coat with creasote [v]\n",
  "CREASY": "having wrinkles [adj CREASIER, CREASIEST]\n",
  "CREATABLE": "that may be created [adj]\n",
  "CREATE": "to bring into being [v CREATED, CREATING, CREATES]\n",
  "CREATED": "CREATE, to bring into being [v]\n",
  "CREATES": "CREATE, to bring into being [v]\n",
  "CREATIANISM": "a fundamentalism Christian doctrine that denies evolution, also CREATIONISM [n -S]\n",
  "CREATIANISMS": "CREATIANISM, a fundamentalism Christian doctrine that denies evolution, also CREATIONISM [n]\n",
  "CREATIC": "relating to flesh [adj]\n",
  "CREATIN": "a chemical found within vertebrate muscle, also CREATINE, KREATINE [n -S]\n",
  "CREATINE": "a chemical found within vertebrate muscle, also CREATIN, KREATINE [n -S]\n",
  "CREATINES": "CREATINE, a chemical found within vertebrate muscle, also CREATIN, KREATINE [n]\n",
  "CREATING": "CREATE, to bring into being [v]\n",
  "CREATININE": "dehydrated creatin found in urine and muscles [n -S]\n",
  "CREATININES": "CREATININE, dehydrated creatin found in urine and muscles [n]\n",
  "CREATINS": "CREATIN, a chemical found within vertebrate muscle, also CREATINE, KREATINE [n]\n",
  "CREATION": "something that is created [n -S]\n",
  "CREATIONAL": "of or pertaining to creation [adj]\n",
  "CREATIONISM": "a fundamentalism Christian doctrine that denies evolution, also CREATIANISM [n CREATIONISMS]\n",
  "CREATIONISMS": "CREATIONISM, a fundamentalism Christian doctrine that denies evolution, also CREATIANISM [n]\n",
  "CREATIONIST": "a believer in creationism [n -S]\n",
  "CREATIONISTIC": "relating to creationism, a fundamentalism Christian doctrine that denies evolution [adj]\n",
  "CREATIONISTS": "CREATIONIST, a believer in creationism [n]\n",
  "CREATIONS": "CREATION, something that is created [n]\n",
  "CREATIVE": "having the ability to create [adj CREATIVELY] / a creative person [n -S]\n",
  "CREATIVELY": "CREATIVE, having the ability to create [adv]\n",
  "CREATIVENESS": "the state of being creative [n -ES]\n",
  "CREATIVENESSES": "CREATIVENESS, the state of being creative [n]\n",
  "CREATIVES": "CREATIVE, a creative person [n]\n",
  "CREATIVITIES": "CREATIVITY, the quality of being creative [n]\n",
  "CREATIVITY": "the quality of being creative [n CREATIVITIES]\n",
  "CREATOR": "one that creates [n -S]\n",
  "CREATORS": "CREATOR, one that creates [n]\n",
  "CREATORSHIP": "the office of creator [n -S]\n",
  "CREATORSHIPS": "CREATORSHIP, the office of creator [n]\n",
  "CREATRESS": "a female creator, also CREATRIX [n -ES]\n",
  "CREATRESSES": "CREATRESS, a female creator, also CREATRIX [n]\n",
  "CREATRIX": "a female creator, also CREATRESS [n -ES]\n",
  "CREATRIXES": "CREATRIX, a female creator, also CREATRESS [n]\n",
  "CREATURAL": "relating to a creature or thing created, also CREATURELY [adj]\n",
  "CREATURE": "a living being [n -S]\n",
  "CREATUREHOOD": "the state of being a creature [n -S]\n",
  "CREATUREHOODS": "CREATUREHOOD, the state of being a creature [n]\n",
  "CREATURELINESS": "the state of being creaturely [n]\n",
  "CREATURELY": "relating to a creature or thing created, also CREATURAL [adj]\n",
  "CREATURES": "CREATURE, a living being [n]\n",
  "CREATURESHIP": "the state of being a creature [n -S]\n",
  "CREATURESHIPS": "CREATURESHIP, the state of being a creature [n]\n",
  "CRECHE": "(French) a day nursery [n -S]\n",
  "CRECHES": "CRECHE, (French) a day nursery [n]\n",
  "CRED": "(short for) credibility [n -S]\n",
  "CREDAL": "pertaining to a creed, also CREEDAL [adj]\n",
  "CREDENCE": "a small table for holding sacred vessels [n -S]\n",
  "CREDENCES": "CREDENCE, a small table for holding sacred vessels [n]\n",
  "CREDENDA": "CREDENDUM, (Latin) an article of faith [n]\n",
  "CREDENDUM": "(Latin) an article of faith [n CREDENDA]\n",
  "CREDENT": "believing [adj]\n",
  "CREDENTIAL": "giving a title or claim to credit or confidence [n -S] / to give credentials to [v CREDENTIALED or CREDENTIALLED, CREDENTIALING or CREDENTIALLING, CREDENTIALS]\n",
  "CREDENTIALED": "CREDENTIAL, to give credentials to [v]\n",
  "CREDENTIALING": "the act of providing with credentials [n -S]\n",
  "CREDENTIALINGS": "CREDENTIALING, the act of providing with credentials [n]\n",
  "CREDENTIALISM": "undue emphasis on credentials (as college degrees) as prerequisites to employment [n -S]\n",
  "CREDENTIALISMS": "CREDENTIALISM, undue emphasis on credentials (as college degrees) as prerequisites to employment [n]\n",
  "CREDENTIALLED": "CREDENTIAL, to give credentials to [v]\n",
  "CREDENTIALLING": "the act of providing with credentials [n -S]\n",
  "CREDENTIALLINGS": "CREDENTIALLING, the act of providing with credentials [n]\n",
  "CREDENTIALS": "CREDENTIAL, giving a title or claim to credit or confidence [n]\n",
  "CREDENZA": "(Italian) a long sideboard [n -S]\n",
  "CREDENZAS": "CREDENZA, (Italian) a long sideboard [n]\n",
  "CREDIBILITIES": "CREDIBILITY, the power of inspiring belief [n]\n",
  "CREDIBILITY": "the power of inspiring belief [n CREDIBILITIES]\n",
  "CREDIBLE": "believable [adj]\n",
  "CREDIBLENESS": "the state of being credible [n -ES]\n",
  "CREDIBLENESSES": "CREDIBLENESS, the state of being credible [n]\n",
  "CREDIBLY": "CREDIBLE, believable [adv]\n",
  "CREDIT": "to accept as true [v -ED, -ING, -S]\n",
  "CREDITABILITIES": "CREDITABILITY, the quality of being creditable [n]\n",
  "CREDITABILITY": "the quality of being creditable [n CREDITABILITIES]\n",
  "CREDITABLE": "trustworthy [adj CREDITABLY]\n",
  "CREDITABLENESS": "the state of being creditable [n]\n",
  "CREDITABLY": "CREDITABLE, trustworthy [adv]\n",
  "CREDITED": "CREDIT, to accept as true [v]\n",
  "CREDITING": "CREDIT, to accept as true [v]\n",
  "CREDITLESS": "without credit [adj]\n",
  "CREDITOR": "one to whom money is owed [n -S]\n",
  "CREDITORS": "CREDITOR, one to whom money is owed [n]\n",
  "CREDITORSHIP": "the state of being a creditor [n -S]\n",
  "CREDITORSHIPS": "CREDITORSHIP, the state of being a creditor [n]\n",
  "CREDITS": "CREDIT, to accept as true [v]\n",
  "CREDITWORTHIER": "CREDITWORTHY, financially sound enough to justify the extension of credit [adj]\n",
  "CREDITWORTHIEST": "CREDITWORTHY, financially sound enough to justify the extension of credit [adj]\n",
  "CREDITWORTHY": "financially sound enough to justify the extension of credit [adj CREDITWORTHIER, CREDITWORTHIEST]\n",
  "CREDO": "(Latin) a concise statement of doctrine; a section of Mass followed by offertory [n -S]\n",
  "CREDOS": "CREDO, (Latin) a concise statement of doctrine; a section of Mass followed by offertory [n]\n",
  "CREDS": "CRED, (short for) credibility [n]\n",
  "CREDULITIES": "CREDULITY, readiness to believe [n]\n",
  "CREDULITY": "readiness to believe [n CREDULITIES]\n",
  "CREDULOUS": "gullible [adj CREDULOUSLY]\n",
  "CREDULOUSLY": "CREDULOUS, gullible [adv]\n",
  "CREDULOUSNESS": "the state of being credulous [n -ES]\n",
  "CREDULOUSNESSES": "CREDULOUSNESS, the state of being credulous [n]\n",
  "CREE": "to soften by boiling [v CREED, CREEING, CREES]\n",
  "CREED": "a statement of belief [n -S]\n",
  "CREEDAL": "pertaining to a creed, also CREDAL [adj]\n",
  "CREEDS": "CREED, a statement of belief [n]\n",
  "CREEING": "CREE, to soften by boiling [v]\n",
  "CREEK": "a watercourse smaller than a river [n -S]\n",
  "CREEKIER": "CREEKY, full of creeks [adj]\n",
  "CREEKIEST": "CREEKY, full of creeks [adj]\n",
  "CREEKS": "CREEK, a watercourse smaller than a river [n]\n",
  "CREEKSIDE": "the area at the side of a creek [n -S]\n",
  "CREEKSIDES": "CREEKSIDE, the area at the side of a creek [n]\n",
  "CREEKY": "full of creeks [adj CREEKIER, CREEKIEST]\n",
  "CREEL": "to put fish in a fish basket [v -ED, -ING, -S]\n",
  "CREELED": "CREEL, to put fish in a fish basket [v]\n",
  "CREELING": "CREEL, to put fish in a fish basket [v]\n",
  "CREELS": "CREEL, to put fish in a fish basket [v]\n",
  "CREEP": "to advance stealthily [v CREPT or CREEPED, CREEPING, CREEPS]\n",
  "CREEPAGE": "gradual movement [n -S]\n",
  "CREEPAGES": "CREEPAGE, gradual movement [n]\n",
  "CREEPED": "CREEP, to advance stealthily [v]\n",
  "CREEPER": "a creeping plant [n -S]\n",
  "CREEPERED": "covered in creeper [adj]\n",
  "CREEPERS": "CREEPER, a creeping plant [n]\n",
  "CREEPIE": "a low stool; a stool of repentance [n -S]\n",
  "CREEPIER": "CREEPY, rather eerie [adj]\n",
  "CREEPIES": "CREEPIE, a low stool; a stool of repentance [n]\n",
  "CREEPIEST": "CREEPY, rather eerie [adj]\n",
  "CREEPILY": "CREEPY, rather eerie [adv]\n",
  "CREEPINESS": "the state of being creepy [n -ES]\n",
  "CREEPINESSES": "CREEPINESS, the state of being creepy [n]\n",
  "CREEPING": "CREEP, to advance stealthily [v]\n",
  "CREEPINGLY": "CREEPING, CREEP, to advance stealthily [adv]\n",
  "CREEPMICE": "CREEPMOUSE, an informal tickling game played with small children [n]\n",
  "CREEPMOUSE": "an informal tickling game played with small children [n CREEPMOUSES or CREEPMICE]\n",
  "CREEPMOUSES": "CREEPMOUSE, an informal tickling game played with small children [n]\n",
  "CREEPS": "CREEP, to advance stealthily [v]\n",
  "CREEPY": "rather eerie [adj CREEPIER, CREEPIEST, CREEPILY]\n",
  "CREES": "CREE, to soften by boiling [v]\n",
  "CREESE": "(Malay) to stab with a Malay dagger, also KRIS, KREESE [v CREESED, CREESING, CREESES]\n",
  "CREESED": "CREESE, (Malay) to stab with a Malay dagger, also KRIS, KREESE [v]\n",
  "CREESES": "CREESE, (Malay) to stab with a Malay dagger, also KRIS, KREESE [v]\n",
  "CREESH": "(Scots) to grease [v -ED, -ING, -ES]\n",
  "CREESHED": "CREESH, (Scots) to grease [v]\n",
  "CREESHES": "CREESH, (Scots) to grease [v]\n",
  "CREESHIER": "CREESHY, (Scots) greasy [adj]\n",
  "CREESHIEST": "CREESHY, (Scots) greasy [adj]\n",
  "CREESHING": "CREESH, (Scots) to grease [v]\n",
  "CREESHY": "(Scots) greasy [adj CREESHIER, CREESHIEST]\n",
  "CREESING": "CREESE, (Malay) to stab with a Malay dagger, also KRIS, KREESE [v]\n",
  "CREM": "(colloquial) a crematorium [n -S]\n",
  "CREMAILLERE": "(French) a zigzag line of fortification [n -S]\n",
  "CREMAILLERES": "CREMAILLERE, (French) a zigzag line of fortification [n]\n",
  "CREMAINS": "the ashes of a cremated body [n]\n",
  "CREMANT": "of wine, moderately sparkling [adj]\n",
  "CREMASTER": "(Greek) a thin muscle which serves to draw up the testicle [n -S]\n",
  "CREMASTERS": "CREMASTER, (Greek) a thin muscle which serves to draw up the testicle [n]\n",
  "CREMATE": "to reduce to ashes [v CREMATED, CREMATING, CREMATES]\n",
  "CREMATED": "CREMATE, to reduce to ashes [v]\n",
  "CREMATES": "CREMATE, to reduce to ashes [v]\n",
  "CREMATING": "CREMATE, to reduce to ashes [v]\n",
  "CREMATION": "the burning of corpses [n -S]\n",
  "CREMATIONISM": "the policy of burning dead bodies [n -S]\n",
  "CREMATIONISMS": "CREMATIONISM, the policy of burning dead bodies [n]\n",
  "CREMATIONIST": "a believer in cremationism [n -S]\n",
  "CREMATIONISTS": "CREMATIONIST, a believer in cremationism [n]\n",
  "CREMATIONS": "CREMATION, the burning of corpses [n]\n",
  "CREMATOR": "one who, or that which, cremates [n -S]\n",
  "CREMATORIA": "CREMATORIUM, a place where bodies are cremated, also CREMATORY [n]\n",
  "CREMATORIAL": "relating to a crematorium [adj]\n",
  "CREMATORIES": "CREMATORY, a place where bodies are cremated, also CREMATORIUM [n]\n",
  "CREMATORIUM": "a place where bodies are cremated, also CREMATORY [n CREMATORIA or CREMATORIUMS]\n",
  "CREMATORIUMS": "CREMATORIUM, a place where bodies are cremated, also CREMATORY [n]\n",
  "CREMATORS": "CREMATOR, one who, or that which, cremates [n]\n",
  "CREMATORY": "a place where bodies are cremated, also CREMATORIUM [n CREMATORIES]\n",
  "CREME": "(French) cream [n -S]\n",
  "CREMES": "CREME, (French) cream [n]\n",
  "CREMINI": "a dark brown edible mushroom, also CRIMINI [n -S]\n",
  "CREMINIS": "CREMINI, a dark brown edible mushroom, also CRIMINI [n]\n",
  "CREMOCARP": "the characteristic fruit of the Umbelliferae [n -S]\n",
  "CREMOCARPS": "CREMOCARP, the characteristic fruit of the Umbelliferae [n]\n",
  "CREMONA": "(German) an ancient double-reed wind instrument, also CREMORNE, CROMORNA, CROMORNE, CRUMHORN, KRUMHORN, KRUMMHORN [n -S]\n",
  "CREMONAS": "CREMONA, (German) an ancient double-reed wind instrument, also CREMORNE, CROMORNA, CROMORNE, CRUMHORN, KRUMHORN, KRUMMHORN [n]\n",
  "CREMOR": "(Latin) a thick juice [n -S]\n",
  "CREMORNE": "an ancient double-reed wind instrument, also CREMONA, CROMORNA, CROMORNE, CRUMHORN, KRUMHORN, KRUMMHORN [n -S]\n",
  "CREMORNES": "CREMORNE, an ancient double-reed wind instrument, also CREMONA, CROMORNA, CROMORNE, CRUMHORN, KRUMHORN, KRUMMHORN [n]\n",
  "CREMORS": "CREMOR, (Latin) a thick juice [n]\n",
  "CREMOSIN": "(obsolete) crimson, also CRAMESY, CRAMOISIE, CRAMOISY, CREMSIN, CRIMSON [adj]\n",
  "CREMS": "CREM, (colloquial) a crematorium [n]\n",
  "CREMSIN": "(Spenser) crimson, also CRAMESY, CRAMOISIE, CRAMOISY, CREMOSIN, CRIMSON [adj]\n",
  "CRENA": "(Latin) a notch or tooth [n -S]\n",
  "CRENAS": "CRENA, (Latin) a notch or tooth [n]\n",
  "CRENATE": "having a notched or scalloped edge, also CRENATED [adj]\n",
  "CRENATED": "having a notched or scalloped edge, also CRENATE [adj]\n",
  "CRENATELY": "CRENATE, having a notched or scalloped edge, also CRENATED [adv]\n",
  "CRENATION": "a rounded projection [n -S]\n",
  "CRENATIONS": "CRENATION, a rounded projection [n]\n",
  "CRENATURE": "the state of being notched [n -S]\n",
  "CRENATURES": "CRENATURE, the state of being notched [n]\n",
  "CRENEL": "to make indentations in a parapet [v CRENELED or CRENELLED, CRENELING or CRENELLING, CRENELS]\n",
  "CRENELATE": "(US) to provide with battlements, also CRENELLATE [v CRENELATED, CRENELATING, CRENELATES]\n",
  "CRENELATED": "CRENELATE, (US) to provide with battlements, also CRENELLATE [v]\n",
  "CRENELATES": "CRENELATE, (US) to provide with battlements, also CRENELLATE [v]\n",
  "CRENELATING": "CRENELATE, (US) to provide with battlements, also CRENELLATE [v]\n",
  "CRENELATION": "a battlement, also CRENELLATION [n -S]\n",
  "CRENELATIONS": "CRENELATION, a battlement, also CRENELLATION [n]\n",
  "CRENELED": "CRENEL, to make indentations in a parapet [v]\n",
  "CRENELING": "CRENEL, to make indentations in a parapet [v]\n",
  "CRENELLATE": "to provide with battlements, also CRENELATE [v CRENELLATED, CRENELLATING, CRENELLATES]\n",
  "CRENELLATED": "CRENELLATE, to provide with battlements, also CRENELATE [v]\n",
  "CRENELLATES": "CRENELLATE, to provide with battlements, also CRENELATE [v]\n",
  "CRENELLATING": "CRENELLATE, to provide with battlements, also CRENELATE [v]\n",
  "CRENELLATION": "a battlement, also CRENELATION [n -S]\n",
  "CRENELLATIONS": "CRENELLATION, a battlement, also CRENELATION [n]\n",
  "CRENELLE": "(French) a crenellation [n -S]\n",
  "CRENELLED": "CRENEL, to make indentations in a parapet [v]\n",
  "CRENELLES": "CRENELLE, (French) a crenellation [n]\n",
  "CRENELLING": "CRENEL, to make indentations in a parapet [v]\n",
  "CRENELS": "CRENEL, to make indentations in a parapet [v]\n",
  "CRENSHAW": "a variety of honeydew melon [n -S]\n",
  "CRENSHAWS": "CRENSHAW, a variety of honeydew melon [n]\n",
  "CRENULATE": "minutely crenate, also CRENULATED [adj]\n",
  "CRENULATED": "minutely crenate, also CRENULATE [adj]\n",
  "CRENULATION": "the state of being crenulated [n -S]\n",
  "CRENULATIONS": "CRENULATION, the state of being crenulated [n]\n",
  "CREODONT": "any member of a group of primitive fossil carnivores, appearing in Eocene times [n -S]\n",
  "CREODONTS": "CREODONT, any member of a group of primitive fossil carnivores, appearing in Eocene times [n]\n",
  "CREOLE": "a type of mixed language, also CREOLIAN [n -S]\n",
  "CREOLES": "CREOLE, a type of mixed language, also CREOLIAN [n]\n",
  "CREOLIAN": "a type of mixed language, also CREOLE [n -S]\n",
  "CREOLIANS": "CREOLIAN, a type of mixed language, also CREOLE [n]\n",
  "CREOLISATION": "the development of a pidgin into a creole, also CREOLIZATION [n -S]\n",
  "CREOLISATIONS": "CREOLISATION, the development of a pidgin into a creole, also CREOLIZATION [n]\n",
  "CREOLISE": "to cause a language to become creole, also CREOLIZE [v CREOLISED, CREOLISING, CREOLISES]\n",
  "CREOLISED": "CREOLISE, to cause a language to become creole, also CREOLIZE [v]\n",
  "CREOLISES": "CREOLISE, to cause a language to become creole, also CREOLIZE [v]\n",
  "CREOLISING": "CREOLISE, to cause a language to become creole, also CREOLIZE [v]\n",
  "CREOLIST": "a person who studies creole languages [n -S]\n",
  "CREOLISTS": "CREOLIST, a person who studies creole languages [n]\n",
  "CREOLIZATION": "the development of a pidgin into a creole, also CREOLISATION [n -S]\n",
  "CREOLIZATIONS": "CREOLIZATION, the development of a pidgin into a creole, also CREOLISATION [n]\n",
  "CREOLIZE": "to cause a language to become creole, also CREOLISE [v CREOLIZED, CREOLIZING, CREOLIZES]\n",
  "CREOLIZED": "CREOLIZE, to cause a language to become creole, also CREOLISE [v]\n",
  "CREOLIZES": "CREOLIZE, to cause a language to become creole, also CREOLISE [v]\n",
  "CREOLIZING": "CREOLIZE, to cause a language to become creole, also CREOLISE [v]\n",
  "CREOPHAGIES": "CREOPHAGY, the act of eating meat [n]\n",
  "CREOPHAGOUS": "flesh-eating, carnivorous [adj]\n",
  "CREOPHAGY": "the act of eating meat [n CREOPHAGIES]\n",
  "CREOSOL": "one of the active constituents of creosote [n -S]\n",
  "CREOSOLS": "CREOSOL, one of the active constituents of creosote [n]\n",
  "CREOSOTE": "to treat with a wood preservative, also CREASOTE, KREASOTE, KREOSOTE [v CREOSOTED, CREOSOTING, CREOSOTES]\n",
  "CREOSOTED": "CREOSOTE, to treat with a wood preservative, also CREASOTE, KREASOTE, KREOSOTE [v]\n",
  "CREOSOTES": "CREOSOTE, to treat with a wood preservative, also CREASOTE, KREASOTE, KREOSOTE [v]\n",
  "CREOSOTIC": "like creosote [adj]\n",
  "CREOSOTING": "CREOSOTE, to treat with a wood preservative, also CREASOTE, KREASOTE, KREOSOTE [v]\n",
  "CREPANCE": "a sore on a horse's hind ankle-joint [n -S]\n",
  "CREPANCES": "CREPANCE, a sore on a horse's hind ankle-joint [n]\n",
  "CREPE": "(French) to cover with crepe, a light crinkled fabric, also CRAPE [v CREPED, CREPING, CREPES]\n",
  "CREPED": "CREPE, (French) to cover with crepe, a light crinkled fabric, also CRAPE [v]\n",
  "CREPEHANGER": "a pessimist, a gloomy person, also CRAPEHANGER [n -S]\n",
  "CREPEHANGERS": "CREPEHANGER, a pessimist, a gloomy person, also CRAPEHANGER [n]\n",
  "CREPEHANGING": "pessimism, also CRAPEHANGING [n -S]\n",
  "CREPEHANGINGS": "CREPEHANGING, pessimism, also CRAPEHANGING [n]\n",
  "CREPELIKE": "like crepe [adj]\n",
  "CREPERIE": "(French) a restaurant that specializes in pancakes [n -S]\n",
  "CREPERIES": "CREPERIE, (French) a restaurant that specializes in pancakes [n]\n",
  "CREPES": "CREPE, (French) to cover with crepe, a light crinkled fabric, also CRAPE [v]\n",
  "CREPEY": "crinkly, also CREPY [adj CREPIER, CREPIEST]\n",
  "CREPIER": "CREPY, having the texture of crepe, a light crinkled fabric, also CREPEY [adj]\n",
  "CREPIEST": "CREPY, having the texture of crepe, a light crinkled fabric, also CREPEY [adj]\n",
  "CREPINESS": "the state of being crepy [n -ES]\n",
  "CREPINESSES": "CREPINESS, the state of being crepy [n]\n",
  "CREPING": "CREPE, (French) to cover with crepe, a light crinkled fabric, also CRAPE [v]\n",
  "CREPITANT": "having or making a crackling sound [adj]\n",
  "CREPITATE": "to crackle; to snap [v CREPITATED, CREPITATING, CREPITATES]\n",
  "CREPITATED": "CREPITATE, to crackle; to snap [v]\n",
  "CREPITATES": "CREPITATE, to crackle; to snap [v]\n",
  "CREPITATING": "CREPITATE, to crackle; to snap [v]\n",
  "CREPITATION": "a soft crackling sound [n -S]\n",
  "CREPITATIONS": "CREPITATION, a soft crackling sound [n]\n",
  "CREPITATIVE": "crackling [adj]\n",
  "CREPITUS": "(Latin) the sound made by a fractured joint [n -ES]\n",
  "CREPITUSES": "CREPITUS, (Latin) the sound made by a fractured joint [n]\n",
  "CREPOLINE": "a light crapelike dress silk or nylon [n -S]\n",
  "CREPOLINES": "CREPOLINE, a light crapelike dress silk or nylon [n]\n",
  "CREPON": "a heavy crepe fabric with lengthwise crinkles [n -S]\n",
  "CREPONS": "CREPON, a heavy crepe fabric with lengthwise crinkles [n]\n",
  "CREPS": "an informal name for training shoes [n]\n",
  "CREPT": "CREEP, to advance stealthily [v]\n",
  "CREPUSCLE": "twilight, the fading light at the end of the day, also CREPUSCULE [n -S]\n",
  "CREPUSCLES": "CREPUSCLE, twilight, the fading light at the end of the day, also CREPUSCULE [n]\n",
  "CREPUSCULAR": "relating to twilight, also CREPUSCULOUS [adj]\n",
  "CREPUSCULE": "twilight, the fading light at the end of the day, also CREPUSCLE [n -S]\n",
  "CREPUSCULES": "CREPUSCULE, twilight, the fading light at the end of the day, also CREPUSCLE [n]\n",
  "CREPUSCULOUS": "relating to twilight, also CREPUSCULAR [adj]\n",
  "CREPY": "having the texture of crepe, a light crinkled fabric, also CREPEY [adj CREPIER, CREPIEST]\n",
  "CRESCENDI": "CRESCENDO, (Italian) a gradual increase in loudness [n]\n",
  "CRESCENDO": "(Italian) a gradual increase in loudness [n CRESCENDI or CRESCENDOS] / to come to a crescendo [v CRESCENDOED, CRESCENDOING, CRESCENDOS or CRESCENDOES]\n",
  "CRESCENDOED": "CRESCENDO, to come to a crescendo [v]\n",
  "CRESCENDOES": "CRESCENDO, to come to a crescendo [v]\n",
  "CRESCENDOING": "CRESCENDO, to come to a crescendo [v]\n",
  "CRESCENDOS": "CRESCENDO, (Italian) a gradual increase in loudness [n]\n",
  "CRESCENT": "a curved shape like the moon's 1st or last quarter [n -S]\n",
  "CRESCENTADE": "a religious war for Islam [n -S]\n",
  "CRESCENTADES": "CRESCENTADE, a religious war for Islam [n]\n",
  "CRESCENTED": "having the shape of a crescent [adj]\n",
  "CRESCENTIC": "formed like a crescent [adj]\n",
  "CRESCENTS": "CRESCENT, a curved shape like the moon's 1st or last quarter [n]\n",
  "CRESCIVE": "increasing [adj CRESCIVELY]\n",
  "CRESCIVELY": "CRESCIVE, increasing [adv]\n",
  "CRESCOGRAPH": "an instrument for measuring the growth of plants [n -S]\n",
  "CRESCOGRAPHS": "CRESCOGRAPH, an instrument for measuring the growth of plants [n]\n",
  "CRESOL": "a compound found in tar and creosote, used as an antiseptic and disinfectant, aka cresylic acid [n -S]\n",
  "CRESOLS": "CRESOL, a compound found in tar and creosote, used as an antiseptic and disinfectant, aka cresylic acid [n]\n",
  "CRESS": "a cruciferous plant used in salads [n -ES]\n",
  "CRESSES": "CRESS, a cruciferous plant used in salads [n]\n",
  "CRESSET": "(historical) an iron basket for burning oil to provide light [n -S]\n",
  "CRESSETS": "CRESSET, (historical) an iron basket for burning oil to provide light [n]\n",
  "CRESSIER": "CRESSY, like cress [adj]\n",
  "CRESSIEST": "CRESSY, like cress [adj]\n",
  "CRESSY": "like cress [adj CRESSIER, CRESSIEST]\n",
  "CREST": "to reach a peak [v -ED, -ING, -S]\n",
  "CRESTA": "as in cresta run, high-speed tobogganing down a steep narrow passage of compacted snow and ice [adj]\n",
  "CRESTAL": "pertaining to a crest or peak [adj] / a crystal [n -S]\n",
  "CRESTALS": "CRESTAL, a crystal [n]\n",
  "CRESTED": "CREST, to reach a peak [v]\n",
  "CRESTFALLEN": "dispirited or disappointed by having one's hopes dashed [adj CRESTFALLENLY]\n",
  "CRESTFALLENLY": "CRESTFALLEN, dispirited or disappointed by having one's hopes dashed [adv]\n",
  "CRESTFALLENNESS": "CRESTFALLEN, dispirited or disappointed by having one's hopes dashed [n]\n",
  "CRESTING": "an ornamental ridging to a wall or roof [n -S]\n",
  "CRESTINGS": "CRESTING, an ornamental ridging to a wall or roof [n]\n",
  "CRESTLESS": "(archaic) not entitled to bear arms [adj]\n",
  "CRESTON": "(Spanish) a ridge on a hill that curves downwards at the ends [n -S]\n",
  "CRESTONS": "CRESTON, (Spanish) a ridge on a hill that curves downwards at the ends [n]\n",
  "CRESTS": "CREST, to reach a peak [v]\n",
  "CRESYL": "an isomeric radical derived from cresol [n -S]\n",
  "CRESYLIC": "relating to cresol, a compound found in tar and creosote, as in cresylic acid [adj]\n",
  "CRESYLS": "CRESYL, an isomeric radical derived from cresol [n]\n",
  "CRETACEOUS": "of or resembling chalk [adj] / the Cretaceous period [n -ES]\n",
  "CRETACEOUSES": "CRETACEOUS, the Cretaceous period [n]\n",
  "CRETACEOUSLY": "CRETACEOUS, of or resembling chalk [adv]\n",
  "CRETIC": "a type of metrical foot [n -S]\n",
  "CRETICS": "CRETIC, a type of metrical foot [n]\n",
  "CRETIN": "a person afflicted with cretinism [n -S]\n",
  "CRETINISE": "to make into a cretin, also CRETINIZE [v CRETINISED, CRETINISING, CRETINISES]\n",
  "CRETINISED": "CRETINISE, to make into a cretin, also CRETINIZE [v]\n",
  "CRETINISES": "CRETINISE, to make into a cretin, also CRETINIZE [v]\n",
  "CRETINISING": "CRETINISE, to make into a cretin, also CRETINIZE [v]\n",
  "CRETINISM": "a congenital deficiency of thyroxine (thyroid hormone) which, if untreated, can lead to mental retardation and incomplete physical development [n -S]\n",
  "CRETINISMS": "CRETINISM, a congenital deficiency of thyroxine (thyroid hormone) which, if untreated, can lead to mental retardation and incomplete physical development [n]\n",
  "CRETINIZE": "to make into a cretin, also CRETINISE [v CRETINIZED, CRETINIZING, CRETINIZES]\n",
  "CRETINIZED": "CRETINIZE, to make into a cretin, also CRETINISE [v]\n",
  "CRETINIZES": "CRETINIZE, to make into a cretin, also CRETINISE [v]\n",
  "CRETINIZING": "CRETINIZE, to make into a cretin, also CRETINISE [v]\n",
  "CRETINOID": "resembling a cretin [adj] / someone resembling a cretin [n -S]\n",
  "CRETINOIDS": "CRETINOID, someone resembling a cretin [n]\n",
  "CRETINOUS": "like a cretin [adj]\n",
  "CRETINS": "CRETIN, a person afflicted with cretinism [n]\n",
  "CRETISM": "a lie [n -S]\n",
  "CRETISMS": "CRETISM, a lie [n]\n",
  "CRETONNE": "(French) a heavy cotton or linen cloth [n -S]\n",
  "CRETONNES": "CRETONNE, (French) a heavy cotton or linen cloth [n]\n",
  "CRETONS": "a spread of shredded pork cooked with onions in pork fat [n]\n",
  "CREUTZER": "(German) a small copper coin formerly used in South Germany, also KREUTZER, KREUZER [n -S]\n",
  "CREUTZERS": "CREUTZER, (German) a small copper coin formerly used in South Germany, also KREUTZER, KREUZER [n]\n",
  "CREVALLE": "a silvery food and game fish of the western Atlantic [n -S]\n",
  "CREVALLES": "CREVALLE, a silvery food and game fish of the western Atlantic [n]\n",
  "CREVASSE": "to make a fissure in [v CREVASSED, CREVASSING, CREVASSES]\n",
  "CREVASSED": "CREVASSE, to make a fissure in [v]\n",
  "CREVASSES": "CREVASSE, to make a fissure in [v]\n",
  "CREVASSING": "CREVASSE, to make a fissure in [v]\n",
  "CREVETTE": "(French) a shrimp or prawn [n -S]\n",
  "CREVETTES": "CREVETTE, (French) a shrimp or prawn [n]\n",
  "CREVICE": "a cleft [n -S]\n",
  "CREVICED": "having a crevice [adj]\n",
  "CREVICES": "CREVICE, a cleft [n]\n",
  "CREW": "to serve aboard a ship [v -ED, -ING, -S]\n",
  "CREWCUT": "a short haircut [n -S]\n",
  "CREWCUTS": "CREWCUT, a short haircut [n]\n",
  "CREWE": "(archaic) a pot [n -S]\n",
  "CREWED": "CREW, to serve aboard a ship [v]\n",
  "CREWEL": "a fine worsted yarn [n -S] / to work in a fine worsted yarn [v CREWELLED, CREWELLING, CREWELS]\n",
  "CREWELIST": "one who embroiders with crewel [n -S]\n",
  "CREWELISTS": "CREWELIST, one who embroiders with crewel [n]\n",
  "CREWELLED": "CREWEL, to work in a fine worsted yarn [v]\n",
  "CREWELLERIES": "CREWELLERY, crewelwork [n]\n",
  "CREWELLERY": "crewelwork [n CREWELLERIES]\n",
  "CREWELLING": "the act of working in crewel yarn [n -S]\n",
  "CREWELLINGS": "CREWELLING, the act of working in crewel yarn [n]\n",
  "CREWELS": "(Scots) scrofula, the King's Evil, also CRUELLS, CRUELS [n]\n",
  "CREWELWORK": "embroidery done with crewel [n -S]\n",
  "CREWELWORKS": "CREWELWORK, embroidery done with crewel [n]\n",
  "CREWES": "CREWE, (archaic) a pot [n]\n",
  "CREWING": "CREW, to serve aboard a ship [v]\n",
  "CREWLESS": "without a crew [adj]\n",
  "CREWMAN": "one who serves on a ship [n CREWMEN]\n",
  "CREWMATE": "a fellow crewman [n -S]\n",
  "CREWMATES": "CREWMATE, a fellow crewman [n]\n",
  "CREWMEN": "CREWMAN, one who serves on a ship [n]\n",
  "CREWNECK": "a sweater with a round, close fitting neck [n -S]\n",
  "CREWNECKS": "CREWNECK, a sweater with a round, close fitting neck [n]\n",
  "CREWS": "CREW, to serve aboard a ship [v]\n",
  "CRIA": "the offspring of a llama [n -S]\n",
  "CRIANT": "(French) garish [adj]\n",
  "CRIAS": "CRIA, the offspring of a llama [n]\n",
  "CRIB": "to confine closely [v CRIBBED, CRIBBING, CRIBS]\n",
  "CRIBBAGE": "a card game [n -S]\n",
  "CRIBBAGES": "CRIBBAGE, a card game [n]\n",
  "CRIBBED": "CRIB, to confine closely [v]\n",
  "CRIBBER": "one that cribs [n -S]\n",
  "CRIBBERS": "CRIBBER, one that cribs [n]\n",
  "CRIBBING": "a supporting framework [n -S]\n",
  "CRIBBINGS": "CRIBBING, a supporting framework [n]\n",
  "CRIBBLE": "to decorate wood or metal with small dots or punctures [v CRIBBLED, CRIBBLING, CRIBBLES]\n",
  "CRIBBLED": "CRIBBLE, to decorate wood or metal with small dots or punctures [v]\n",
  "CRIBBLES": "CRIBBLE, to decorate wood or metal with small dots or punctures [v]\n",
  "CRIBBLING": "CRIBBLE, to decorate wood or metal with small dots or punctures [v]\n",
  "CRIBELLA": "CRIBELLUM, (Latin) a spinning organ of spiders [n]\n",
  "CRIBELLAR": "relating to a cribellum, a sievelike spinning organ of certain spiders [adj]\n",
  "CRIBELLUM": "(Latin) a spinning organ of spiders [n CRIBELLA]\n",
  "CRIBLE": "(French) a method of engraving in which holes or indentations are made in the surface of a material. [n -S]\n",
  "CRIBLES": "CRIBLE, (French) a method of engraving in which holes or indentations are made in the surface of a material. [n]\n",
  "CRIBRATE": "perforated like a sieve, also CRIBROUS, CRIBROSE [adj]\n",
  "CRIBRATION": "sifting [n -S]\n",
  "CRIBRATIONS": "CRIBRATION, sifting [n]\n",
  "CRIBRIFORM": "shaped like a sieve [adj]\n",
  "CRIBROSE": "perforated like a sieve, also CRIBROUS, CRIBRATE [adj]\n",
  "CRIBROUS": "perforated like a sieve, also CRIBRATE, CRIBROSE [adj]\n",
  "CRIBS": "CRIB, to confine closely [v]\n",
  "CRIBWORK": "a timber framework for e.g. a pier or mine [n -S]\n",
  "CRIBWORKS": "CRIBWORK, a timber framework for e.g. a pier or mine [n]\n",
  "CRICETID": "a member of the Cricetidae, a family of rodents including gerbils [n -S]\n",
  "CRICETIDS": "CRICETID, a member of the Cricetidae, a family of rodents including gerbils [n]\n",
  "CRICK": "to cause a spasm in the neck [v -ED, -ING, -S]\n",
  "CRICKED": "CRICK, to cause a spasm in the neck [v]\n",
  "CRICKET": "an outdoor game played with bat and ball [n -S] / to play a game with bat, ball and stumps [v -ED, -ING, -S]\n",
  "CRICKETED": "CRICKET, to play a game with bat, ball and stumps [v]\n",
  "CRICKETER": "one who plays cricket [n -S]\n",
  "CRICKETERS": "CRICKETER, one who plays cricket [n]\n",
  "CRICKETING": "the playing of cricket [n -S]\n",
  "CRICKETINGS": "CRICKETING, the playing of cricket [n]\n",
  "CRICKETS": "CRICKET, to play a game with bat, ball and stumps [v]\n",
  "CRICKEY": "a mild oath, also CRACKY, CRICKY, CRIKEY [interj]\n",
  "CRICKING": "CRICK, to cause a spasm in the neck [v]\n",
  "CRICKS": "CRICK, to cause a spasm in the neck [v]\n",
  "CRICKY": "a mild oath of surprise [interj]\n",
  "CRICOID": "a ring-shaped cartilage forming the wall of the larynx [n -S]\n",
  "CRICOIDS": "CRICOID, a ring-shaped cartilage forming the wall of the larynx [n]\n",
  "CRIED": "CRY, to utter a sound of distress or to weep [v]\n",
  "CRIER": "one that cries, also CRYER [n -S]\n",
  "CRIERS": "CRIER, one that cries, also CRYER [n]\n",
  "CRIES": "CRY, to utter a sound of distress or to weep [v]\n",
  "CRIKEY": "used as a mild oath, also CRICKEY [interj]\n",
  "CRIM": "(Australian slang) a criminal [n -S]\n",
  "CRIME": "to convict over a breach of regulations [v CRIMED, CRIMING, CRIMES]\n",
  "CRIMED": "CRIME, to convict over a breach of regulations [v]\n",
  "CRIMEFUL": "criminal [adj]\n",
  "CRIMELESS": "without crime [adj]\n",
  "CRIMEN": "(Latin) crime, as in 'crimen falsi', the crime of perjury [n CRIMINA]\n",
  "CRIMES": "CRIME, to convict over a breach of regulations [v]\n",
  "CRIMEWAVE": "a period of increased criminal activity [n -S]\n",
  "CRIMEWAVES": "CRIMEWAVE, a period of increased criminal activity [n]\n",
  "CRIMINA": "CRIMEN, (Latin) crime, as in 'crimen falsi', the crime of perjury [n]\n",
  "CRIMINAL": "relating to crime [adj CRIMINALLY] / one who has committed a crime [n -S]\n",
  "CRIMINALESE": "criminals' slang [n -S]\n",
  "CRIMINALESES": "CRIMINALESE, criminals' slang [n]\n",
  "CRIMINALISATION": "the process of criminalising, also CRIMINALIZATION [n]\n",
  "CRIMINALISE": "to make illegal, also CRIMINALIZE [v CRIMINALISED, CRIMINALISING, CRIMINALISES]\n",
  "CRIMINALISED": "CRIMINALISE, to make illegal, also CRIMINALIZE [v]\n",
  "CRIMINALISES": "CRIMINALISE, to make illegal, also CRIMINALIZE [v]\n",
  "CRIMINALISING": "CRIMINALISE, to make illegal, also CRIMINALIZE [v]\n",
  "CRIMINALIST": "a person versed in criminal law [n -S]\n",
  "CRIMINALISTICS": "the application of scientific techniques in collecting and analyzing physical evidence in criminal cases [n]\n",
  "CRIMINALISTS": "CRIMINALIST, a person versed in criminal law [n]\n",
  "CRIMINALITIES": "CRIMINALITY, the state of being criminal [n]\n",
  "CRIMINALITY": "the state of being criminal [n CRIMINALITIES]\n",
  "CRIMINALIZATION": "the act of criminalizing, also CRIMINALISATION [n]\n",
  "CRIMINALIZE": "to make illegal, also CRIMINALISE [v CRIMINALIZED, CRIMINALIZING, CRIMINALIZES]\n",
  "CRIMINALIZED": "CRIMINALIZE, to make illegal, also CRIMINALISE [v]\n",
  "CRIMINALIZES": "CRIMINALIZE, to make illegal, also CRIMINALISE [v]\n",
  "CRIMINALIZING": "CRIMINALIZE, to make illegal, also CRIMINALISE [v]\n",
  "CRIMINALLY": "CRIMINAL, relating to crime [adv]\n",
  "CRIMINALS": "CRIMINAL, one who has committed a crime [n]\n",
  "CRIMINATE": "to accuse [v CRIMINATED, CRIMINATING, CRIMINATES]\n",
  "CRIMINATED": "CRIMINATE, to accuse [v]\n",
  "CRIMINATES": "CRIMINATE, to accuse [v]\n",
  "CRIMINATING": "CRIMINATE, to accuse [v]\n",
  "CRIMINATION": "the act of criminating, accusation [n -S]\n",
  "CRIMINATIONS": "CRIMINATION, the act of criminating, accusation [n]\n",
  "CRIMINATIVE": "involving crimination, also CRIMINATORY [adj]\n",
  "CRIMINATOR": "one who criminates, accuses of a crime [n -S]\n",
  "CRIMINATORS": "CRIMINATOR, one who criminates, accuses of a crime [n]\n",
  "CRIMINATORY": "involving crimination, also CRIMINATIVE [adj]\n",
  "CRIMINE": "(archaic) an interjection expressing surprise or impatience, also CRIMINY [interj]\n",
  "CRIMING": "CRIME, to convict over a breach of regulations [v]\n",
  "CRIMINI": "a dark brown edible mushroom, also CREMINI [n -S]\n",
  "CRIMINIS": "CRIMINI, a dark brown edible mushroom, also CREMINI [n]\n",
  "CRIMINOGENIC": "causing crime [adj]\n",
  "CRIMINOLOGIC": "relating to criminology, also CRIMINOLOGICAL [adj]\n",
  "CRIMINOLOGICAL": "relating to criminology, also CRIMINOLOGIC [adj]\n",
  "CRIMINOLOGIES": "CRIMINOLOGY, study of crime; criminals [n]\n",
  "CRIMINOLOGIST": "one who studies criminology [n -S]\n",
  "CRIMINOLOGISTS": "CRIMINOLOGIST, one who studies criminology [n]\n",
  "CRIMINOLOGY": "study of crime; criminals [n CRIMINOLOGIES]\n",
  "CRIMINOUS": "criminal, chiefly in the ecclesiastical phrase 'a criminous clerk' [adj]\n",
  "CRIMINOUSNESS": "CRIMINOUS, criminal, chiefly in the ecclesiastical phrase 'a criminous clerk' [n]\n",
  "CRIMINOUSNESSES": "CRIMINOUSNESS, CRIMINOUS, criminal, chiefly in the ecclesiastical phrase 'a criminous clerk' [n]\n",
  "CRIMINY": "an interjection expressing surprise or impatience, also CRIMINE [interj]\n",
  "CRIMMER": "(German) a tightly curled grey or black fur from a Crimean lamb, also KRIMMER [n -S]\n",
  "CRIMMERS": "CRIMMER, (German) a tightly curled grey or black fur from a Crimean lamb, also KRIMMER [n]\n",
  "CRIMP": "to press into folds, flutes or ridges [v -ED, -ING, -S]\n",
  "CRIMPED": "CRIMP, to press into folds, flutes or ridges [v]\n",
  "CRIMPER": "a person or device that crimps; (slang) a hairdresser [n -S]\n",
  "CRIMPERS": "CRIMPER, a person or device that crimps; (slang) a hairdresser [n]\n",
  "CRIMPIER": "CRIMPY, wrinkled, curled [adj]\n",
  "CRIMPIEST": "CRIMPY, wrinkled, curled [adj]\n",
  "CRIMPING": "CRIMP, to press into folds, flutes or ridges [v]\n",
  "CRIMPLE": "to wrinkle, curl [v CRIMPLED, CRIMPLING, CRIMPLES]\n",
  "CRIMPLED": "CRIMPLE, to wrinkle, curl [v]\n",
  "CRIMPLES": "CRIMPLE, to wrinkle, curl [v]\n",
  "CRIMPLING": "CRIMPLE, to wrinkle, curl [v]\n",
  "CRIMPS": "CRIMP, to press into folds, flutes or ridges [v]\n",
  "CRIMPY": "wrinkled, curled [adj CRIMPIER, CRIMPIEST]\n",
  "CRIMS": "CRIM, (Australian slang) a criminal [n]\n",
  "CRIMSON": "a deep red colour, also CRAMESY, CRAMOISIE, CRAMOISY, CREMOSIN, CREMSIN [adj] / to make deep red [v CRIMSONED, CRIMSONING, CRIMSONS]\n",
  "CRIMSONED": "CRIMSON, to make deep red [v]\n",
  "CRIMSONING": "CRIMSON, to make deep red [v]\n",
  "CRIMSONNESS": "the state of being crimson [n -ES]\n",
  "CRIMSONNESSES": "CRIMSONNESS, the state of being crimson [n]\n",
  "CRIMSONS": "CRIMSON, to make deep red [v]\n",
  "CRINAL": "of hair [adj]\n",
  "CRINATE": "having hair, also CRINATED [adj]\n",
  "CRINATED": "having hair, also CRINATE [adj]\n",
  "CRINE": "(Scots) to shrink or shrivel [v CRINED, CRINING, CRINES]\n",
  "CRINED": "CRINE, (Scots) to shrink or shrivel [v]\n",
  "CRINES": "CRINE, (Scots) to shrink or shrivel [v]\n",
  "CRINGE": "to shrink in fear [v CRINGED, CRINGING, CRINGES]\n",
  "CRINGED": "CRINGE, to shrink in fear [v]\n",
  "CRINGELING": "a person who cringes [n -S]\n",
  "CRINGELINGS": "CRINGELING, a person who cringes [n]\n",
  "CRINGER": "a person who cringes [n -S]\n",
  "CRINGERS": "CRINGER, a person who cringes [n]\n",
  "CRINGES": "CRINGE, to shrink in fear [v]\n",
  "CRINGEWORTHIER": "CRINGEWORTHY, causing extreme embarrassment [adj]\n",
  "CRINGEWORTHIEST": "CRINGEWORTHY, causing extreme embarrassment [adj]\n",
  "CRINGEWORTHY": "causing extreme embarrassment [adj CRINGEWORTHIER, CRINGEWORTHIEST]\n",
  "CRINGEY": "causing acute feelings of embarrassment or disgust, also CRINGY [adj CRINGIER, CRINGIEST]\n",
  "CRINGIER": "CRINGY, causing acute feelings of embarrassment or disgust, also CRINGEY [adj]\n",
  "CRINGIEST": "CRINGY, causing acute feelings of embarrassment or disgust, also CRINGEY [adj]\n",
  "CRINGING": "servile [adj CRINGINGLY] / acting in a servile way [n -S]\n",
  "CRINGINGLY": "CRINGING, servile [adv]\n",
  "CRINGINGS": "CRINGING, acting in a servile way [n]\n",
  "CRINGLE": "a loop at the corner of a sail to which a line is attached [n -S]\n",
  "CRINGLES": "CRINGLE, a loop at the corner of a sail to which a line is attached [n]\n",
  "CRINGY": "causing acute feelings of embarrassment or disgust, also CRINGEY [adj CRINGIER, CRINGIEST]\n",
  "CRINICULTURAL": "relating to the culture or growth of the hair [adj]\n",
  "CRINIGEROUS": "hairy [adj]\n",
  "CRINING": "CRINE, (Scots) to shrink or shrivel [v]\n",
  "CRINITE": "a fossil crinoid [n -S]\n",
  "CRINITES": "CRINITE, a fossil crinoid [n]\n",
  "CRINKLE": "to wrinkle [v CRINKLED, CRINKLING, CRINKLES]\n",
  "CRINKLED": "CRINKLE, to wrinkle [v]\n",
  "CRINKLEROOT": "any of several species of toothwort [n -S]\n",
  "CRINKLEROOTS": "CRINKLEROOT, any of several species of toothwort [n]\n",
  "CRINKLES": "CRINKLE, to wrinkle [v]\n",
  "CRINKLIER": "CRINKLY, crinkled [adj]\n",
  "CRINKLIES": "CRINKLY, an old person [n]\n",
  "CRINKLIEST": "CRINKLY, crinkled [adj]\n",
  "CRINKLING": "CRINKLE, to wrinkle [v]\n",
  "CRINKLY": "crinkled [adj CRINKLIER, CRINKLIEST] / an old person [n CRINKLIES]\n",
  "CRINOID": "a family of marine creatures, the sea lilies and feather stars [n -S]\n",
  "CRINOIDAL": "of or like a crinoid, a family of marine creatures [adj]\n",
  "CRINOIDEAN": "like a crinoid [adj] / a crinoid [n -S]\n",
  "CRINOIDEANS": "CRINOIDEAN, a crinoid [n]\n",
  "CRINOIDS": "CRINOID, a family of marine creatures, the sea lilies and feather stars [n]\n",
  "CRINOLETTE": "(French) a small crinoline causing the dress to project behind only [n -S]\n",
  "CRINOLETTES": "CRINOLETTE, (French) a small crinoline causing the dress to project behind only [n]\n",
  "CRINOLINE": "(French) a stiff fabric made of horsehair and cotton or linen thread, used for linings, hats, etc., and formerly for skirts and to expand a petticoat [n -S]\n",
  "CRINOLINED": "wearing a crinoline [adj]\n",
  "CRINOLINES": "CRINOLINE, (French) a stiff fabric made of horsehair and cotton or linen thread, used for linings, hats, etc., and formerly for skirts and to expand a petticoat [n]\n",
  "CRINOSE": "hairy [adj]\n",
  "CRINUM": "a family of tropical plants, having strap-like leaves and lilylike flowers [n -S]\n",
  "CRINUMS": "CRINUM, a family of tropical plants, having strap-like leaves and lilylike flowers [n]\n",
  "CRIOLLO": "(Spanish) a Latin American native of European esp. Spanish blood [n -S]\n",
  "CRIOLLOS": "CRIOLLO, (Spanish) a Latin American native of European esp. Spanish blood [n]\n",
  "CRIOS": "(Irish) a multicoloured woollen belt traditionally worn by men in the Aran Islands [n -ES]\n",
  "CRIOSES": "CRIOS, (Irish) a multicoloured woollen belt traditionally worn by men in the Aran Islands [n]\n",
  "CRIP": "(colloquial) a cripple [n -S]\n",
  "CRIPE": "used as a mild oath, also CRIPES [interj]\n",
  "CRIPES": "used as a mild oath, also CRIPE [interj]\n",
  "CRIPPLE": "to disable or impair [v CRIPPLED, CRIPPLING, CRIPPLES]\n",
  "CRIPPLED": "CRIPPLE, to disable or impair [v]\n",
  "CRIPPLEDOM": "cripples collectively [n -S]\n",
  "CRIPPLEDOMS": "CRIPPLEDOM, cripples collectively [n]\n",
  "CRIPPLER": "one that cripples; (slang) something astonishingly good [n -S]\n",
  "CRIPPLERS": "CRIPPLER, one that cripples; (slang) something astonishingly good [n]\n",
  "CRIPPLES": "CRIPPLE, to disable or impair [v]\n",
  "CRIPPLEWARE": "software that has been partly disabled to provide a limited demonstration of its use [n -S]\n",
  "CRIPPLEWARES": "CRIPPLEWARE, software that has been partly disabled to provide a limited demonstration of its use [n]\n",
  "CRIPPLING": "a prop set up as a support at the site of a building [n -S]\n",
  "CRIPPLINGLY": "CRIPPLING [adv]\n",
  "CRIPPLINGS": "CRIPPLING, a prop set up as a support at the site of a building [n]\n",
  "CRIPS": "CRIP, (colloquial) a cripple [n]\n",
  "CRIS": "(Malay) a dagger or short sword used by the Malays, commonly having a serpentine blade, also CREESE, KREESE, KRIS [n -ES]\n",
  "CRISE": "(French) an expression of surprise [interj]\n",
  "CRISES": "CRISIS, a crucial turning point [n]\n",
  "CRISIC": "relating to a crisis [adj]\n",
  "CRISIS": "a crucial turning point [n CRISES]\n",
  "CRISP": "brittle [adj CRISPER, CRISPEST, CRISPLY] / to make brittle [v -ED, -ING, -S]\n",
  "CRISPATE": "having a wavy edge, also CRISPATED [adj]\n",
  "CRISPATED": "having a wavy edge, also CRISPATE [adj]\n",
  "CRISPATION": "the state of being curled [n -S]\n",
  "CRISPATIONS": "CRISPATION, the state of being curled [n]\n",
  "CRISPATURE": "a curling [n -S]\n",
  "CRISPATURES": "CRISPATURE, a curling [n]\n",
  "CRISPBREAD": "a brittle, unsweetened type of biscuit [n -S]\n",
  "CRISPBREADS": "CRISPBREAD, a brittle, unsweetened type of biscuit [n]\n",
  "CRISPED": "CRISP, to make brittle [v]\n",
  "CRISPEN": "to make crisp [v -ED, -ING, -S]\n",
  "CRISPENED": "CRISPEN, to make crisp [v]\n",
  "CRISPENING": "CRISPEN, to make crisp [v]\n",
  "CRISPENS": "CRISPEN, to make crisp [v]\n",
  "CRISPER": "a compartment in a refrigerator that keeps things crisp [n -S]\n",
  "CRISPERS": "CRISPER, a compartment in a refrigerator that keeps things crisp [n]\n",
  "CRISPEST": "CRISP, brittle [adj]\n",
  "CRISPHEAD": "a variety of lettuce [n -S]\n",
  "CRISPHEADS": "CRISPHEAD, a variety of lettuce [n]\n",
  "CRISPIER": "CRISPY, crisp in texture [adj]\n",
  "CRISPIES": "as in rice crispies, puffed grains of rice, eaten esp. as breakfast cereal [n]\n",
  "CRISPIEST": "CRISPY, crisp in texture [adj]\n",
  "CRISPILY": "CRISPY, crisp in texture [adv]\n",
  "CRISPIN": "a poetic name for a shoemaker [n -S]\n",
  "CRISPINESS": "the state of being crispy [n -ES]\n",
  "CRISPINESSES": "CRISPINESS, the state of being crispy [n]\n",
  "CRISPING": "CRISP, to make brittle [v]\n",
  "CRISPINS": "CRISPIN, a poetic name for a shoemaker [n]\n",
  "CRISPLY": "CRISP, brittle [adv]\n",
  "CRISPNESS": "the state of being crisp [n -ES]\n",
  "CRISPNESSES": "CRISPNESS, the state of being crisp [n]\n",
  "CRISPS": "CRISP, to make brittle [v]\n",
  "CRISPY": "crisp in texture [adj CRISPIER, CRISPIEST, CRISPILY]\n",
  "CRISSA": "CRISSUM, (Latin) the area surrounding a bird's cloaca, including the under-tail feathers [n]\n",
  "CRISSAL": "pertaining to the crissum [adj]\n",
  "CRISSCROSS": "to mark with intersecting lines [v -ED, -ING, -ES]\n",
  "CRISSCROSSED": "CRISSCROSS, to mark with intersecting lines [v]\n",
  "CRISSCROSSES": "CRISSCROSS, to mark with intersecting lines [v]\n",
  "CRISSCROSSING": "CRISSCROSS, to mark with intersecting lines [v]\n",
  "CRISSUM": "(Latin) the area surrounding a bird's cloaca, including the under-tail feathers [n CRISSA]\n",
  "CRISTA": "(Latin) a ridge or fold resembling a crest [n CRISTAE]\n",
  "CRISTAE": "CRISTA, (Latin) a ridge or fold resembling a crest [n]\n",
  "CRISTATE": "having a projection on the head, also CRISTATED [adj]\n",
  "CRISTATED": "with an appendage resembling a crest, also CRISTATE [adj]\n",
  "CRISTIFORM": "in the form of a crest [adj]\n",
  "CRISTOBALITE": "a variety of silica [n -S]\n",
  "CRISTOBALITES": "CRISTOBALITE, a variety of silica [n]\n",
  "CRIT": "(short for) criticism [n -S]\n",
  "CRITERIA": "CRITERION, a standard of judgement [n]\n",
  "CRITERIAL": "relating to a criterion [adj]\n",
  "CRITERION": "a standard of judgement [n CRITERIONS or CRITERIA]\n",
  "CRITERIONS": "CRITERION, a standard of judgement [n]\n",
  "CRITERIUM": "a kind of cycling race [n -S]\n",
  "CRITERIUMS": "CRITERIUM, a kind of cycling race [n]\n",
  "CRITH": "a unit of mass, that of one litre of hydrogen at standard temperature and pressure [n -S]\n",
  "CRITHIDIAL": "relating to the flagellate genus Crithidia [adj]\n",
  "CRITHOMANCIES": "CRITHOMANCY, divination by strewing meal over sacrificial animals [n]\n",
  "CRITHOMANCY": "divination by strewing meal over sacrificial animals [n CRITHOMANCIES]\n",
  "CRITHS": "CRITH, a unit of mass, that of one litre of hydrogen at standard temperature and pressure [n]\n",
  "CRITIC": "one who judges the merits of something [n -S]\n",
  "CRITICAL": "given to criticism [adj CRITICALLY]\n",
  "CRITICALITIES": "CRITICALITY, the state of being critical [n]\n",
  "CRITICALITY": "the state of being critical [n CRITICALITIES]\n",
  "CRITICALLY": "CRITICAL, given to criticism [adv]\n",
  "CRITICALNESS": "the state of being critical [n -ES]\n",
  "CRITICALNESSES": "CRITICALNESS, the state of being critical [n]\n",
  "CRITICASTER": "an inferior or petty critic [n -S]\n",
  "CRITICASTERS": "CRITICASTER, an inferior or petty critic [n]\n",
  "CRITICISABLE": "able to be criticised, also CRITICIZABLE [adj]\n",
  "CRITICISE": "to censure, also CRITICIZE [v CRITICISED, CRITICISING, CRITICISES]\n",
  "CRITICISED": "CRITICISE, to censure, also CRITICIZE [v]\n",
  "CRITICISER": "one who criticises, also CRITICIZER [n -S]\n",
  "CRITICISERS": "CRITICISER, one who criticises, also CRITICIZER [n]\n",
  "CRITICISES": "CRITICISE, to censure, also CRITICIZE [v]\n",
  "CRITICISING": "CRITICISE, to censure, also CRITICIZE [v]\n",
  "CRITICISINGLY": "CRITICISING, CRITICISE, to censure, also CRITICIZE [adv]\n",
  "CRITICISM": "the act of criticising [n -S]\n",
  "CRITICISMS": "CRITICISM, the act of criticising [n]\n",
  "CRITICIZABLE": "able to be criticized, also CRITICISABLE [adj]\n",
  "CRITICIZE": "to censure, also CRITICISE [v CRITICIZED, CRITICIZING, CRITICIZES]\n",
  "CRITICIZED": "CRITICIZE, to censure, also CRITICISE [v]\n",
  "CRITICIZER": "one who criticizes, also CRITICISER [n -S]\n",
  "CRITICIZERS": "CRITICIZER, one who criticizes, also CRITICISER [n]\n",
  "CRITICIZES": "CRITICIZE, to censure, also CRITICISE [v]\n",
  "CRITICIZING": "CRITICIZE, to censure, also CRITICISE [v]\n",
  "CRITICIZINGLY": "CRITICIZING, CRITICIZE, to censure, also CRITICISE [adv]\n",
  "CRITICS": "CRITIC, one who judges the merits of something [n]\n",
  "CRITIQUE": "(French) to judge as a critic [v CRITIQUED, CRITIQUING, CRITIQUES]\n",
  "CRITIQUED": "CRITIQUE, (French) to judge as a critic [v]\n",
  "CRITIQUES": "CRITIQUE, (French) to judge as a critic [v]\n",
  "CRITIQUING": "CRITIQUE, (French) to judge as a critic [v]\n",
  "CRITS": "CRIT, (short for) criticism [n]\n",
  "CRITTER": "a creature, also CRITTUR [n -S]\n",
  "CRITTERS": "CRITTER, a creature, also CRITTUR [n]\n",
  "CRITTUR": "(colloquial) a creature, also CRITTER [n -S]\n",
  "CRITTURS": "CRITTUR, (colloquial) a creature, also CRITTER [n]\n",
  "CRIVENS": "(Scots) an interjection expressing dismay, also CRIVVENS [interj]\n",
  "CRIVVENS": "(Scots) an interjection expressing dismay, also CRIVENS [interj]\n",
  "CROAK": "to utter a low hoarse sound [v -ED, -ING, -S]\n",
  "CROAKED": "CROAK, to utter a low hoarse sound [v]\n",
  "CROAKER": "a person or animal that croaks; specifically any fish of the family Sciaenidae [n -S]\n",
  "CROAKERS": "CROAKER, a person or animal that croaks; specifically any fish of the family Sciaenidae [n]\n",
  "CROAKIER": "CROAKY, low and hoarse [adj]\n",
  "CROAKIEST": "CROAKY, low and hoarse [adj]\n",
  "CROAKILY": "CROAKY, low and hoarse [adv]\n",
  "CROAKINESS": "the state of being croaky [n -ES]\n",
  "CROAKINESSES": "CROAKINESS, the state of being croaky [n]\n",
  "CROAKING": "a low, hoarse sound [n -S]\n",
  "CROAKINGS": "CROAKING, a low, hoarse sound [n]\n",
  "CROAKS": "CROAK, to utter a low hoarse sound [v]\n",
  "CROAKY": "low and hoarse [adj CROAKIER, CROAKIEST, CROAKILY]\n",
  "CROC": "(short for) crocodile [n -S]\n",
  "CROCEATE": "(obsolete) saffron-coloured, also CROCEOUS [adj]\n",
  "CROCEIN": "a red or orange azo dye, also CROCEINE [n -S]\n",
  "CROCEINE": "a red or orange azo dye, also CROCEIN [n -S]\n",
  "CROCEINES": "CROCEINE, a red or orange azo dye, also CROCEIN [n]\n",
  "CROCEINS": "CROCEIN, a red or orange azo dye, also CROCEINE [n]\n",
  "CROCEOUS": "saffron-coloured, also CROCEATE [adj]\n",
  "CROCHE": "(French) a knob at the top of a deer's horn [n -S]\n",
  "CROCHES": "CROCHE, (French) a knob at the top of a deer's horn [n]\n",
  "CROCHET": "to work wool or thread with a small hook [v -ED, -ING, -S]\n",
  "CROCHETED": "CROCHET, to work wool or thread with a small hook [v]\n",
  "CROCHETER": "one who crochets [n -S]\n",
  "CROCHETERS": "CROCHETER, one who crochets [n]\n",
  "CROCHETING": "crochetwork [n -S]\n",
  "CROCHETINGS": "CROCHETING, crochetwork [n]\n",
  "CROCHETS": "CROCHET, to work wool or thread with a small hook [v]\n",
  "CROCI": "CROCUS, (Latin) an iridaceous plant with brilliant yellow, purple or white flowers [n]\n",
  "CROCIDOLITE": "a fibrous mineral consisting mainly of silicate of iron and sodium, called blue asbestos [n -S]\n",
  "CROCIDOLITES": "CROCIDOLITE, a fibrous mineral consisting mainly of silicate of iron and sodium, called blue asbestos [n]\n",
  "CROCINE": "pertaining to the crocus [adj]\n",
  "CROCK": "to break down, disable [v -ED, -ING, -S]\n",
  "CROCKED": "CROCK, to break down, disable [v]\n",
  "CROCKERIES": "CROCKERY, domestic pottery [n]\n",
  "CROCKERY": "domestic pottery [n CROCKERIES]\n",
  "CROCKET": "a curling leaf along the outer angles of pinnacles and gables [n -S]\n",
  "CROCKETED": "having crockets, curling leaves along the outer angles of pinnacles and gables [adj]\n",
  "CROCKETS": "CROCKET, a curling leaf along the outer angles of pinnacles and gables [n]\n",
  "CROCKING": "CROCK, to break down, disable [v]\n",
  "CROCKPOT": "(tradename) a brand of slow cooker [n -S]\n",
  "CROCKPOTS": "CROCKPOT, (tradename) a brand of slow cooker [n]\n",
  "CROCKS": "CROCK, to break down, disable [v]\n",
  "CROCODILE": "a large long-tailed tropical reptile of the genus Crocodilus [n -S]\n",
  "CROCODILES": "CROCODILE, a large long-tailed tropical reptile of the genus Crocodilus [n]\n",
  "CROCODILIAN": "any of an order of reptiles including the crocodiles, alligators, caimans, gharials, and related extinct forms [n -S]\n",
  "CROCODILIANS": "CROCODILIAN, any of an order of reptiles including the crocodiles, alligators, caimans, gharials, and related extinct forms [n]\n",
  "CROCOISITE": "a bright red mineral, lead chromate, also CROCOITE [n -S]\n",
  "CROCOISITES": "CROCOISITE, a bright red mineral, lead chromate, also CROCOITE [n]\n",
  "CROCOITE": "a bright red mineral, lead chromate, also CROCOISITE [n -S]\n",
  "CROCOITES": "CROCOITE, a bright red mineral, lead chromate, also CROCOISITE [n]\n",
  "CROCOSMIA": "any plant of the genus Crocosmia, including montbretia [n -S]\n",
  "CROCOSMIAS": "CROCOSMIA, any plant of the genus Crocosmia, including montbretia [n]\n",
  "CROCS": "CROC, (short for) crocodile [n]\n",
  "CROCUS": "(Latin) an iridaceous plant with brilliant yellow, purple or white flowers [n CROCUSES or CROCI]\n",
  "CROCUSES": "CROCUS, (Latin) an iridaceous plant with brilliant yellow, purple or white flowers [n]\n",
  "CROFT": "to expose cloth to the elements in the course of bleaching it [v -ED, -ING, -S]\n",
  "CROFTED": "CROFT, to expose cloth to the elements in the course of bleaching it [v]\n",
  "CROFTER": "a tenant farmer [n -S]\n",
  "CROFTERS": "CROFTER, a tenant farmer [n]\n",
  "CROFTING": "the system of land tenure by crofters [n -S]\n",
  "CROFTINGS": "CROFTING, the system of land tenure by crofters [n]\n",
  "CROFTS": "CROFT, to expose cloth to the elements in the course of bleaching it [v]\n",
  "CROG": "(dialect) to ride as a passenger on a bicycle [v CROGGED, CROGGING, CROGS]\n",
  "CROGGED": "CROG, (dialect) to ride as a passenger on a bicycle [v]\n",
  "CROGGIES": "CROGGY, a ride on the back of a bicycle [n]\n",
  "CROGGING": "CROG, (dialect) to ride as a passenger on a bicycle [v]\n",
  "CROGGY": "a ride on the back of a bicycle [n CROGGIES]\n",
  "CROGS": "CROG, (dialect) to ride as a passenger on a bicycle [v]\n",
  "CROISSANT": "(French) a crescent-shaped roll [n -S]\n",
  "CROISSANTS": "CROISSANT, (French) a crescent-shaped roll [n]\n",
  "CROJIK": "a triangular sail [n -S]\n",
  "CROJIKS": "CROJIK, a triangular sail [n]\n",
  "CROKINOLE": "(Canadian) a board game popular in Canada in which players flick wooden discs [n -S]\n",
  "CROKINOLES": "CROKINOLE, (Canadian) a board game popular in Canada in which players flick wooden discs [n]\n",
  "CROMACK": "(Gaelic) a stick with a crooked end, also CRUMMOCK, CRUMMACK [n -S]\n",
  "CROMACKS": "CROMACK, (Gaelic) a stick with a crooked end, also CRUMMOCK, CRUMMACK [n]\n",
  "CROMB": "to draw by a crook, also CROME [v -ED, -ING, -S]\n",
  "CROMBEC": "a kind of African warbler [n -S]\n",
  "CROMBECS": "CROMBEC, a kind of African warbler [n]\n",
  "CROMBED": "CROMB, to draw by a crook, also CROME [v]\n",
  "CROMBING": "CROMB, to draw by a crook, also CROME [v]\n",
  "CROMBS": "CROMB, to draw by a crook, also CROME [v]\n",
  "CROME": "to draw by a crook, also CROMB [v CROMED, CROMING, CROMES]\n",
  "CROMED": "CROME, to draw by a crook, also CROMB [v]\n",
  "CROMES": "CROME, to draw by a crook, also CROMB [v]\n",
  "CROMING": "CROME, to draw by a crook, also CROMB [v]\n",
  "CROMLECH": "(Welsh) a prehistoric stone circle; formerly applied to a dolmen [n -S]\n",
  "CROMLECHS": "CROMLECH, (Welsh) a prehistoric stone circle; formerly applied to a dolmen [n]\n",
  "CROMORNA": "(German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNE, CRUMHORN, KRUMHORN, KRUMMHORN [n -S]\n",
  "CROMORNAS": "CROMORNA, (German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNE, CRUMHORN, KRUMHORN, KRUMMHORN [n]\n",
  "CROMORNE": "(German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CRUMHORN, KRUMHORN, KRUMMHORN [n -S]\n",
  "CROMORNES": "CROMORNE, (German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CRUMHORN, KRUMHORN, KRUMMHORN [n]\n",
  "CRON": "in computing, a command used to schedule a job that is executed at a certain time, or periodically [n -S]\n",
  "CRONE": "a withered old woman [n -S]\n",
  "CRONES": "CRONE, a withered old woman [n]\n",
  "CRONET": "(obsolete) the hair growing over the top of a horse's hoof [n -S]\n",
  "CRONETS": "CRONET, (obsolete) the hair growing over the top of a horse's hoof [n]\n",
  "CRONIES": "CRONY, a close friend [n]\n",
  "CRONISH": "like a crone [adj]\n",
  "CRONK": "(Australian colloquial) ill; of poor quality [adj CRONKER, CRONKEST]\n",
  "CRONKER": "CRONK, (Australian colloquial) ill; of poor quality [adj]\n",
  "CRONKEST": "CRONK, (Australian colloquial) ill; of poor quality [adj]\n",
  "CRONS": "CRON, in computing, a command used to schedule a job that is executed at a certain time, or periodically [n]\n",
  "CRONY": "a close friend [n CRONIES]\n",
  "CRONYISM": "appointment of friends to posts [n -S]\n",
  "CRONYISMS": "CRONYISM, appointment of friends to posts [n]\n",
  "CROODLE": "(Scots) to murmur, coo [v CROODLED, CROODLING, CROODLES]\n",
  "CROODLED": "CROODLE, (Scots) to murmur, coo [v]\n",
  "CROODLES": "CROODLE, (Scots) to murmur, coo [v]\n",
  "CROODLING": "CROODLE, (Scots) to murmur, coo [v]\n",
  "CROOK": "(Australian slang) ill, unfair [adj CROOKER, CROOKEST] / to bend or form into a hook [v CROOKED, CROOKING, CROOKS]\n",
  "CROOKBACK": "(Shakespeare) a hunchback [n -S]\n",
  "CROOKBACKED": "hunchbacked [adj]\n",
  "CROOKBACKS": "CROOKBACK, (Shakespeare) a hunchback [n]\n",
  "CROOKED": "dishonest [adj CROOKEDER, CROOKEDEST, CROOKEDLY]\n",
  "CROOKEDER": "CROOKED, dishonest [adj]\n",
  "CROOKEDEST": "CROOKED, dishonest [adj]\n",
  "CROOKEDLY": "CROOKED, dishonest [adv]\n",
  "CROOKEDNESS": "the state of being crooked [n -ES]\n",
  "CROOKEDNESSES": "CROOKEDNESS, the state of being crooked [n]\n",
  "CROOKER": "CROOK, (Australian slang) ill, unfair [adj]\n",
  "CROOKERIES": "CROOKERY, crooked activity [n]\n",
  "CROOKERY": "crooked activity [n CROOKERIES]\n",
  "CROOKEST": "CROOK, (Australian slang) ill, unfair [adj]\n",
  "CROOKING": "CROOK, to bend or form into a hook [v]\n",
  "CROOKNECK": "a squash with a long recurved neck [n -S]\n",
  "CROOKNECKS": "CROOKNECK, a squash with a long recurved neck [n]\n",
  "CROOKS": "CROOK, to bend or form into a hook [v]\n",
  "CROOL": "(Australian slang) to spoil e.g. chances [v -ED, -ING, -S]\n",
  "CROOLED": "CROOL, (Australian slang) to spoil e.g. chances [v]\n",
  "CROOLING": "CROOL, (Australian slang) to spoil e.g. chances [v]\n",
  "CROOLS": "CROOL, (Australian slang) to spoil e.g. chances [v]\n",
  "CROON": "to sing softly [v -ED, -ING, -S]\n",
  "CROONED": "CROON, to sing softly [v]\n",
  "CROONER": "one who croons, i.e. sings softly in a sentimentally contemplative manner [n -S]\n",
  "CROONERS": "CROONER, one who croons, i.e. sings softly in a sentimentally contemplative manner [n]\n",
  "CROONIER": "CROONY, having or being a soft singing style [adj]\n",
  "CROONIEST": "CROONY, having or being a soft singing style [adj]\n",
  "CROONING": "singing in a sentimental way [n -S]\n",
  "CROONINGS": "CROONING, singing in a sentimental way [n]\n",
  "CROONS": "CROON, to sing softly [v]\n",
  "CROONY": "having or being a soft singing style [adj CROONIER, CROONIEST]\n",
  "CROOVE": "(Scots) a pen or sty, also CRUIVE, CRUVE [n -S]\n",
  "CROOVES": "CROOVE, (Scots) a pen or sty, also CRUIVE, CRUVE [n]\n",
  "CROP": "to cut off short [v CROPPED, CROPPING, CROPS]\n",
  "CROPBOUND": "of birds, suffering from impaction of the crop [adj]\n",
  "CROPDUSTER": "an aircraft that sprays crops from the air [n -S]\n",
  "CROPDUSTERS": "CROPDUSTER, an aircraft that sprays crops from the air [n]\n",
  "CROPDUSTING": "the spreading of fungicide, etc. on crops in the form of dust, often from an aircraft [n -S]\n",
  "CROPDUSTINGS": "CROPDUSTING, the spreading of fungicide, etc. on crops in the form of dust, often from an aircraft [n]\n",
  "CROPFUL": "as much as a bird's crop can hold, also CROPFULL [n -S]\n",
  "CROPFULL": "as much as a bird's crop can hold, also CROPFUL [n -S]\n",
  "CROPFULLS": "CROPFULL, as much as a bird's crop can hold, also CROPFUL [n]\n",
  "CROPFULS": "CROPFUL, as much as a bird's crop can hold, also CROPFULL [n]\n",
  "CROPLAND": "farm land [n -S]\n",
  "CROPLANDS": "CROPLAND, farm land [n]\n",
  "CROPLESS": "without a crop [adj]\n",
  "CROPPED": "CROP, to cut off short [v]\n",
  "CROPPER": "a plant that yields a crop [n -S]\n",
  "CROPPERS": "CROPPER, a plant that yields a crop [n]\n",
  "CROPPIE": "a kind of fish, a member of the sunfish family, also CRAPPIE [n -S]\n",
  "CROPPIES": "CROPPY, an Irish rebel of 1798 [n]\n",
  "CROPPING": "the act of cropping [n -S]\n",
  "CROPPINGS": "CROPPING, the act of cropping [n]\n",
  "CROPPY": "an Irish rebel of 1798 [n CROPPIES]\n",
  "CROPS": "CROP, to cut off short [v]\n",
  "CROPSICK": "sick from overeating [adj]\n",
  "CROQUANTE": "(French) a crisp pie or tart [n -S]\n",
  "CROQUANTES": "CROQUANTE, (French) a crisp pie or tart [n]\n",
  "CROQUET": "to play a game with balls, mallets and hoops [v -ED, -ING, -S]\n",
  "CROQUETED": "CROQUET, to play a game with balls, mallets and hoops [v]\n",
  "CROQUETING": "CROQUET, to play a game with balls, mallets and hoops [v]\n",
  "CROQUETS": "CROQUET, to play a game with balls, mallets and hoops [v]\n",
  "CROQUETTE": "(French) a ball or cylindrical cake of minced meat, potatoes etc. [n -S]\n",
  "CROQUETTES": "CROQUETTE, (French) a ball or cylindrical cake of minced meat, potatoes etc. [n]\n",
  "CROQUIGNOLE": "a method used in waving the hair by winding it on curlers from the ends of the hair toward the scalp [n -S]\n",
  "CROQUIGNOLES": "CROQUIGNOLE, a method used in waving the hair by winding it on curlers from the ends of the hair toward the scalp [n]\n",
  "CROQUIS": "(French) an outline or rough sketch [n CROQUIS]\n",
  "CRORE": "(Hindi) an Indian unit of counting, ten million [n -S]\n",
  "CROREPATI": "in India, a person whose assets are worth at least one crore or a million rupees [n -S]\n",
  "CROREPATIS": "CROREPATI, in India, a person whose assets are worth at least one crore or a million rupees [n]\n",
  "CRORES": "CRORE, (Hindi) an Indian unit of counting, ten million [n]\n",
  "CROSIER": "a bishop's staff, also CROZIER [n -S]\n",
  "CROSIERED": "carrying a crosier, a pastoral staff or crook held by bishop or abbot [adj]\n",
  "CROSIERS": "CROSIER, a bishop's staff, also CROZIER [n]\n",
  "CROSS": "to intersect [v CROST or CROSSED, CROSSING, CROSSES] / ill-tempered [adj CROSSER, CROSSEST, CROSSLY]\n",
  "CROSSABILITIES": "CROSSABILITY, the ability of different species or varieties to cross with each other [n]\n",
  "CROSSABILITY": "the ability of different species or varieties to cross with each other [n CROSSABILITIES]\n",
  "CROSSABLE": "that can be crossed [adj]\n",
  "CROSSANDRA": "any evergreen shrub of the genus Crossandra [n -S]\n",
  "CROSSANDRAS": "CROSSANDRA, any evergreen shrub of the genus Crossandra [n]\n",
  "CROSSARM": "a horizontal bar [n -S]\n",
  "CROSSARMS": "CROSSARM, a horizontal bar [n]\n",
  "CROSSBAND": "a horizontal bar e.g. across goalposts [n -S]\n",
  "CROSSBANDED": "of a handrail, having the grain of the veneer run across that of the rail [adj]\n",
  "CROSSBANDING": "a veneer border, as on furniture, with its grain at right angles to the grain of the adjacent wood [n -S]\n",
  "CROSSBANDINGS": "CROSSBANDING, a veneer border, as on furniture, with its grain at right angles to the grain of the adjacent wood [n]\n",
  "CROSSBANDS": "CROSSBAND, a horizontal bar e.g. across goalposts [n]\n",
  "CROSSBAR": "to fasten with crossarms [v CROSSBARRED, CROSSBARRING, CROSSBARS]\n",
  "CROSSBARRED": "CROSSBAR, to fasten with crossarms [v]\n",
  "CROSSBARRING": "the act of fitting with a crossbar [n -S]\n",
  "CROSSBARRINGS": "CROSSBARRING, the act of fitting with a crossbar [n]\n",
  "CROSSBARS": "CROSSBAR, to fasten with crossarms [v]\n",
  "CROSSBEAM": "a beam joining other beams [n -S]\n",
  "CROSSBEAMS": "CROSSBEAM, a beam joining other beams [n]\n",
  "CROSSBEARER": "a person who carries a cross in a procession [n -S]\n",
  "CROSSBEARERS": "CROSSBEARER, a person who carries a cross in a procession [n]\n",
  "CROSSBENCH": "a bench laid crosswise [n -ES]\n",
  "CROSSBENCHER": "an independent member of the House of Lords [n -S]\n",
  "CROSSBENCHERS": "CROSSBENCHER, an independent member of the House of Lords [n]\n",
  "CROSSBENCHES": "CROSSBENCH, a bench laid crosswise [n]\n",
  "CROSSBILL": "a kind of finch [n -S]\n",
  "CROSSBILLS": "CROSSBILL, a kind of finch [n]\n",
  "CROSSBIRTH": "a birth in which the child lies transversely in the uterus [n -S]\n",
  "CROSSBIRTHS": "CROSSBIRTH, a birth in which the child lies transversely in the uterus [n]\n",
  "CROSSBIT": "CROSSBITE, to swindle [v]\n",
  "CROSSBITE": "to swindle [v CROSSBIT, CROSSBITTEN, CROSSBITING, CROSSBITES]\n",
  "CROSSBITES": "CROSSBITE, to swindle [v]\n",
  "CROSSBITING": "CROSSBITE, to swindle [v]\n",
  "CROSSBITTEN": "CROSSBITE, to swindle [v]\n",
  "CROSSBONES": "a figure of two thigh bones laid across each other, forming with the skull a conventional emblem of death or piracy [n]\n",
  "CROSSBOW": "a weapon for shooting bolts, formed of a bow placed crosswise on a stock [n -S]\n",
  "CROSSBOWER": "one who uses a crossbow [n -S]\n",
  "CROSSBOWERS": "CROSSBOWER, one who uses a crossbow [n]\n",
  "CROSSBOWMAN": "a person (as a soldier or a hunter) whose weapon is a crossbow [n CROSSBOWMEN]\n",
  "CROSSBOWMEN": "CROSSBOWMAN, a person (as a soldier or a hunter) whose weapon is a crossbow [n]\n",
  "CROSSBOWS": "CROSSBOW, a weapon for shooting bolts, formed of a bow placed crosswise on a stock [n]\n",
  "CROSSBRED": "an animal produced by crossbreeding; wool from a crossbred sheep [n -S]\n",
  "CROSSBREDS": "CROSSBRED, an animal produced by crossbreeding; wool from a crossbred sheep [n]\n",
  "CROSSBREED": "to hybridize [v CROSSBRED, CROSSBREEDING, CROSSBREEDS]\n",
  "CROSSBREEDING": "hybridization [n -S]\n",
  "CROSSBREEDINGS": "CROSSBREEDING, hybridization [n]\n",
  "CROSSBREEDS": "CROSSBREED, to hybridize [v]\n",
  "CROSSBUCK": "(US) a cross-shaped sign placed at a level crossing to warn motorists [n -S]\n",
  "CROSSBUCKS": "CROSSBUCK, (US) a cross-shaped sign placed at a level crossing to warn motorists [n]\n",
  "CROSSCHECK": "to test the accuracy of e.g. a statement or piece of information by consulting various other sources of information [v -ED, -ING, -S]\n",
  "CROSSCHECKED": "CROSSCHECK, to test the accuracy of e.g. a statement or piece of information by consulting various other sources of information [v]\n",
  "CROSSCHECKING": "CROSSCHECK, to test the accuracy of e.g. a statement or piece of information by consulting various other sources of information [v]\n",
  "CROSSCHECKS": "CROSSCHECK, to test the accuracy of e.g. a statement or piece of information by consulting various other sources of information [v]\n",
  "CROSSCLAIM": "a claim made by a defendant against a plaintiff [n -S]\n",
  "CROSSCLAIMS": "CROSSCLAIM, a claim made by a defendant against a plaintiff [n]\n",
  "CROSSCOURT": "to or toward the opposite side of a court (as in tennis or basketball) [adj]\n",
  "CROSSCURRENT": "a current running counter to the general forward direction [n -S]\n",
  "CROSSCURRENTS": "CROSSCURRENT, a current running counter to the general forward direction [n]\n",
  "CROSSCUT": "to cut across [v CROSSCUT, CROSSCUTTING, CROSSCUTS]\n",
  "CROSSCUTS": "CROSSCUT, to cut across [v]\n",
  "CROSSCUTTING": "cutting and fitting together film sequences so the action moves from one to another [n -S]\n",
  "CROSSCUTTINGS": "CROSSCUTTING, cutting and fitting together film sequences so the action moves from one to another [n]\n",
  "CROSSE": "(French) the stick with which lacrosse is played [n -S]\n",
  "CROSSED": "CROSS, to intersect [v]\n",
  "CROSSER": "one that crosses [n -S]\n",
  "CROSSERS": "CROSSER, one that crosses [n]\n",
  "CROSSES": "CROSS, to intersect [v]\n",
  "CROSSEST": "CROSS, ill-tempered [adj]\n",
  "CROSSETTE": "(French) a small projecting part of an impost-stone at the extremity of an arch [n -S]\n",
  "CROSSETTES": "CROSSETTE, (French) a small projecting part of an impost-stone at the extremity of an arch [n]\n",
  "CROSSFALL": "the transverse inclination on a road [n -S]\n",
  "CROSSFALLS": "CROSSFALL, the transverse inclination on a road [n]\n",
  "CROSSFIELD": "of a football pass, long and transverse in direction [adj]\n",
  "CROSSFIRE": "the crossing of lines of fire from two or more points [n -S]\n",
  "CROSSFIRES": "CROSSFIRE, the crossing of lines of fire from two or more points [n]\n",
  "CROSSFISH": "another name for the common sea urchin [n -ES]\n",
  "CROSSFISHES": "CROSSFISH, another name for the common sea urchin [n]\n",
  "CROSSHAIR": "a fine wire at the focus of an optical instrument, crossing the field of view, to aid in positioning or measuring, also CROSSWIRE [n -S]\n",
  "CROSSHAIRS": "CROSSHAIR, a fine wire at the focus of an optical instrument, crossing the field of view, to aid in positioning or measuring, also CROSSWIRE [n]\n",
  "CROSSHATCH": "to shade with intersecting sets of parallel lines [v -ED, -ING, -ES]\n",
  "CROSSHATCHED": "CROSSHATCH, to shade with intersecting sets of parallel lines [v]\n",
  "CROSSHATCHES": "CROSSHATCH, to shade with intersecting sets of parallel lines [v]\n",
  "CROSSHATCHING": "shading with intersecting sets of parallel lines [n -S]\n",
  "CROSSHATCHINGS": "CROSSHATCHING, shading with intersecting sets of parallel lines [n]\n",
  "CROSSHEAD": "a beam connecting piston rod to connecting rod [n -S]\n",
  "CROSSHEADS": "CROSSHEAD, a beam connecting piston rod to connecting rod [n]\n",
  "CROSSING": "an intersection [n -S]\n",
  "CROSSINGS": "CROSSING, an intersection [n]\n",
  "CROSSISH": "somewhat cross [adj]\n",
  "CROSSJACK": "a square sail set on the mizzenmast [n -S]\n",
  "CROSSJACKS": "CROSSJACK, a square sail set on the mizzenmast [n]\n",
  "CROSSLET": "a heraldic symbol [n -S]\n",
  "CROSSLETS": "CROSSLET, a heraldic symbol [n]\n",
  "CROSSLIGHT": "a light whose direction makes an angle with that of another light [n -S]\n",
  "CROSSLIGHTS": "CROSSLIGHT, a light whose direction makes an angle with that of another light [n]\n",
  "CROSSLIKE": "like a cross [adj]\n",
  "CROSSLINGUISTIC": "of or relating to languages of different families and types [adj]\n",
  "CROSSLY": "CROSS, ill-tempered [adv]\n",
  "CROSSNESS": "the state of being cross [n -ES]\n",
  "CROSSNESSES": "CROSSNESS, the state of being cross [n]\n",
  "CROSSOPTERYGIAN": "a member of a subclass of mostly extinct bony fishes, including the coelacanth [n]\n",
  "CROSSOVER": "a road passing over the top of another road [n -S]\n",
  "CROSSOVERS": "CROSSOVER, a road passing over the top of another road [n]\n",
  "CROSSPATCH": "a bad-tempered person [n -ES]\n",
  "CROSSPATCHES": "CROSSPATCH, a bad-tempered person [n]\n",
  "CROSSPIECE": "a piece of material of any kind crossing another [n -S]\n",
  "CROSSPIECES": "CROSSPIECE, a piece of material of any kind crossing another [n]\n",
  "CROSSPLY": "of a tyre, having layers of fabric with cords lying crosswise [adj]\n",
  "CROSSROAD": "an intersection of roads [n -S]\n",
  "CROSSROADS": "CROSSROAD, an intersection of roads [n]\n",
  "CROSSRUFF": "in whist and bridge, to trump alternately [v -ED, -ING, -S]\n",
  "CROSSRUFFED": "CROSSRUFF, in whist and bridge, to trump alternately [v]\n",
  "CROSSRUFFING": "CROSSRUFF, in whist and bridge, to trump alternately [v]\n",
  "CROSSRUFFS": "CROSSRUFF, in whist and bridge, to trump alternately [v]\n",
  "CROSSTALK": "rapid or witty talk [n -S]\n",
  "CROSSTALKS": "CROSSTALK, rapid or witty talk [n]\n",
  "CROSSTIE": "a supporting tie placed transversely [n -S]\n",
  "CROSSTIED": "tied across [adj]\n",
  "CROSSTIES": "CROSSTIE, a supporting tie placed transversely [n]\n",
  "CROSSTOWN": "extending over a town, as in crosstown bus [adj]\n",
  "CROSSTREE": "one of the two upper shroud spreaders in a fore-and-aft rigged sail [n -S]\n",
  "CROSSTREES": "CROSSTREE, one of the two upper shroud spreaders in a fore-and-aft rigged sail [n]\n",
  "CROSSWALK": "(US) a pedestrian crossing [n -S]\n",
  "CROSSWALKS": "CROSSWALK, (US) a pedestrian crossing [n]\n",
  "CROSSWAY": "a road that crosses another road [n -S]\n",
  "CROSSWAYS": "CROSSWAY, a road that crosses another road [n]\n",
  "CROSSWIND": "a wind blowing across one's direction of travel [n -S]\n",
  "CROSSWINDS": "CROSSWIND, a wind blowing across one's direction of travel [n]\n",
  "CROSSWIRE": "either of the two fine mutually perpendicular lines or wires that cross in the focal plane of a theodolite, gunsight, or other optical instrument and are used to define the line of sight, also CROSSHAIR [n -S]\n",
  "CROSSWIRES": "CROSSWIRE, either of the two fine mutually perpendicular lines or wires that cross in the focal plane of a theodolite, gunsight, or other optical instrument and are used to define the line of sight, also CROSSHAIR [n]\n",
  "CROSSWISE": "in the fashion of a cross [adv]\n",
  "CROSSWORD": "a type of puzzle in which a square with blank spaces is to be filled with letters [n -S]\n",
  "CROSSWORDS": "CROSSWORD, a type of puzzle in which a square with blank spaces is to be filled with letters [n]\n",
  "CROSSWORT": "a bedstraw with leaves set crosswise [n -S]\n",
  "CROSSWORTS": "CROSSWORT, a bedstraw with leaves set crosswise [n]\n",
  "CROST": "CROSS, to intersect [v]\n",
  "CROSTATA": "(Italian) a type of fruit tart [n -S]\n",
  "CROSTATAS": "CROSTATA, (Italian) a type of fruit tart [n]\n",
  "CROSTINI": "(Italian) a dish of toasted or fried bread with savoury topping [n -S]\n",
  "CROSTINIS": "CROSTINI, (Italian) a dish of toasted or fried bread with savoury topping [n]\n",
  "CROSTINO": "(Italian) a piece of toasted bread served with a savoury topping, also CROSTINI [n CROSTINI]\n",
  "CROTAL": "(Gaelic) a type of lichen, also CROTTLE [n -S]\n",
  "CROTALA": "CROTALUM, (Latin) a clapper or castanet used in ancient religious rites [n]\n",
  "CROTALARIA": "any plant of the sunn hemp genus Crotalaria [n -S]\n",
  "CROTALARIAS": "CROTALARIA, any plant of the sunn hemp genus Crotalaria [n]\n",
  "CROTALE": "a small cymbal [n -S]\n",
  "CROTALES": "CROTALE, a small cymbal [n]\n",
  "CROTALINE": "of or pertaining to rattlesnakes [adj]\n",
  "CROTALISM": "poisoning by crotalaria, any plant of the sunn hemp genus Crotalaria [n -S]\n",
  "CROTALISMS": "CROTALISM, poisoning by crotalaria, any plant of the sunn hemp genus Crotalaria [n]\n",
  "CROTALS": "CROTAL, (Gaelic) a type of lichen, also CROTTLE [n]\n",
  "CROTALUM": "(Latin) a clapper or castanet used in ancient religious rites [n CROTALA]\n",
  "CROTCH": "the human genital area [n -ES]\n",
  "CROTCHED": "having a crotch [adj]\n",
  "CROTCHES": "CROTCH, the human genital area [n]\n",
  "CROTCHET": "a small hook [n -S]\n",
  "CROTCHETED": "having crotchets, whimsical, short-tempered, also CROTCHETY [adj]\n",
  "CROTCHETEER": "a crotchety person [n -S]\n",
  "CROTCHETEERS": "CROTCHETEER, a crotchety person [n]\n",
  "CROTCHETIER": "CROTCHETY, bad-tempered, also CROTCHETED [adj]\n",
  "CROTCHETIEST": "CROTCHETY, bad-tempered, also CROTCHETED [adj]\n",
  "CROTCHETINESS": "the state of being crotchety [n -ES]\n",
  "CROTCHETINESSES": "CROTCHETINESS, the state of being crotchety [n]\n",
  "CROTCHETS": "CROTCHET, a small hook [n]\n",
  "CROTCHETY": "bad-tempered, also CROTCHETED [adj CROTCHETIER, CROTCHETIEST]\n",
  "CROTON": "(Greek) a tropical plant yielding an acrid oil used as a purgative [n -S]\n",
  "CROTONALDEHYDE": "a pungent liquid aldehyde obtained by dehydration of aldol [n -S]\n",
  "CROTONALDEHYDES": "CROTONALDEHYDE, a pungent liquid aldehyde obtained by dehydration of aldol [n]\n",
  "CROTONBUG": "a species of cockroach [n -S]\n",
  "CROTONBUGS": "CROTONBUG, a species of cockroach [n]\n",
  "CROTONIC": "as in crotonic acid, a colourless acid [adj]\n",
  "CROTONS": "CROTON, (Greek) a tropical plant yielding an acrid oil used as a purgative [n]\n",
  "CROTTLE": "(Gaelic) a golden-brown lichen used for dyeing, also CROTAL [n -S]\n",
  "CROTTLES": "CROTTLE, (Gaelic) a golden-brown lichen used for dyeing, also CROTAL [n]\n",
  "CROUCH": "to squat or lie close to the ground [v -ED, -ING, -ES]\n",
  "CROUCHED": "CROUCH, to squat or lie close to the ground [v]\n",
  "CROUCHES": "CROUCH, to squat or lie close to the ground [v]\n",
  "CROUCHING": "CROUCH, to squat or lie close to the ground [v]\n",
  "CROUP": "to speak hoarsely [v -ED, -ING, -S]\n",
  "CROUPADE": "(French) in dressage, a leap in which the horse draws its hind legs up towards its belly [n -S]\n",
  "CROUPADES": "CROUPADE, (French) in dressage, a leap in which the horse draws its hind legs up towards its belly [n]\n",
  "CROUPE": "the rump of certain animals [n -S]\n",
  "CROUPED": "CROUP, to speak hoarsely [v]\n",
  "CROUPER": "a strap buckled to the back of a saddle and looped under the horse's tail, to prevent the saddle from slipping forward, also CRUPPER [n -S]\n",
  "CROUPERS": "CROUPER, a strap buckled to the back of a saddle and looped under the horse's tail, to prevent the saddle from slipping forward, also CRUPPER [n]\n",
  "CROUPES": "CROUPE, the rump of certain animals [n]\n",
  "CROUPIER": "(French) an attendant in a casino [n -S]\n",
  "CROUPIERS": "CROUPIER, (French) an attendant in a casino [n]\n",
  "CROUPIEST": "CROUPY, affected with croup [adj]\n",
  "CROUPILY": "CROUPY, affected with croup [adv]\n",
  "CROUPINESS": "the state of being croupy [n -ES]\n",
  "CROUPINESSES": "CROUPINESS, the state of being croupy [n]\n",
  "CROUPING": "CROUP, to speak hoarsely [v]\n",
  "CROUPON": "the human buttocks [n -S]\n",
  "CROUPONS": "CROUPON, the human buttocks [n]\n",
  "CROUPOUS": "pertaining to croup [adj]\n",
  "CROUPS": "CROUP, to speak hoarsely [v]\n",
  "CROUPY": "affected with croup [adj CROUPIER, CROUPIEST, CROUPILY]\n",
  "CROUSE": "(Scots) lively [adj CROUSELY]\n",
  "CROUSELY": "CROUSE, (Scots) lively [adv]\n",
  "CROUSTADE": "(French) a cake of fried bread or pastry for serving game [n -S]\n",
  "CROUSTADES": "CROUSTADE, (French) a cake of fried bread or pastry for serving game [n]\n",
  "CROUT": "cabbage cut fine and allowed to ferment in a brine made of its own juice with salt, aka sauerkraut [n -S]\n",
  "CROUTE": "(French) a slice of fried bread served as an entree [n -S]\n",
  "CROUTES": "CROUTE, (French) a slice of fried bread served as an entree [n]\n",
  "CROUTON": "(French) a small cube of fried bread, used in soup or salads [n -S]\n",
  "CROUTONS": "CROUTON, (French) a small cube of fried bread, used in soup or salads [n]\n",
  "CROUTS": "CROUT, cabbage cut fine and allowed to ferment in a brine made of its own juice with salt, aka sauerkraut [n]\n",
  "CROW": "to gloat, exult [v -ED, -ING, -S]\n",
  "CROWBAIT": "an old horse [n -S]\n",
  "CROWBAITS": "CROWBAIT, an old horse [n]\n",
  "CROWBAR": "to use a steel bar as a lever [v CROWBARRED, CROWBARRING, CROWBARS]\n",
  "CROWBARRED": "CROWBAR, to use a steel bar as a lever [v]\n",
  "CROWBARRING": "CROWBAR, to use a steel bar as a lever [v]\n",
  "CROWBARS": "CROWBAR, to use a steel bar as a lever [v]\n",
  "CROWBERRIES": "CROWBERRY, a low creeping moorland shrub with small black berries [n]\n",
  "CROWBERRY": "a low creeping moorland shrub with small black berries [n CROWBERRIES]\n",
  "CROWBOOT": "a type of Inuit boot made of fur and leather [n -S]\n",
  "CROWBOOTS": "CROWBOOT, a type of Inuit boot made of fur and leather [n]\n",
  "CROWD": "to press closely together [v -ED, -ING, -S]\n",
  "CROWDED": "CROWD, to press closely together [v]\n",
  "CROWDEDLY": "CROWDED, CROWD, to press closely together [adv]\n",
  "CROWDEDNESS": "the state of being crowded [n -ES]\n",
  "CROWDEDNESSES": "CROWDEDNESS, the state of being crowded [n]\n",
  "CROWDER": "a fiddler [n -S]\n",
  "CROWDERS": "CROWDER, a fiddler [n]\n",
  "CROWDFUND": "to fund a project via a large number of supporters who each contribute a small amount [v -ED, -ING, -S]\n",
  "CROWDFUNDED": "CROWDFUND, to fund a project via a large number of supporters who each contribute a small amount [v]\n",
  "CROWDFUNDING": "the practice of soliciting financial contributions from a large number of people especially from the online community [n -S]\n",
  "CROWDFUNDINGS": "CROWDFUNDING, the practice of soliciting financial contributions from a large number of people especially from the online community [n]\n",
  "CROWDFUNDS": "CROWDFUND, to fund a project via a large number of supporters who each contribute a small amount [v]\n",
  "CROWDIE": "(Scots) a mixture of meal and water, aka brose, also CROWDY [n -S]\n",
  "CROWDIES": "CROWDIE, (Scots) a mixture of meal and water, aka brose, also CROWDY [n]\n",
  "CROWDING": "CROWD, to press closely together [v]\n",
  "CROWDS": "CROWD, to press closely together [v]\n",
  "CROWDSOURCE": "to outsource work to an unspecified group of people, typically by making an appeal to the general public on the internet [v CROWDSOURCED, CROWDSOURCING, CROWDSOURCES]\n",
  "CROWDSOURCED": "CROWDSOURCE, to outsource work to an unspecified group of people, typically by making an appeal to the general public on the internet [v]\n",
  "CROWDSOURCES": "CROWDSOURCE, to outsource work to an unspecified group of people, typically by making an appeal to the general public on the internet [v]\n",
  "CROWDSOURCING": "the act of outsourcing work to an unspecified group of people, typically by making an appeal to the general public on the internet [n -S]\n",
  "CROWDSOURCINGS": "CROWDSOURCING, the act of outsourcing work to an unspecified group of people, typically by making an appeal to the general public on the internet [n]\n",
  "CROWDY": "(Scots) a mixture of meal and water, aka brose, also CROWDIE [n CROWDIES]\n",
  "CROWEA": "an Australian shrub with pink flowers [n -S]\n",
  "CROWEAS": "CROWEA, an Australian shrub with pink flowers [n]\n",
  "CROWED": "CROW, to gloat, exult [v]\n",
  "CROWER": "one who crows, gloats [n -S]\n",
  "CROWERS": "CROWER, one who crows, gloats [n]\n",
  "CROWFEET": "CROWFOOT, a wild flower, aka buttercup or spearwort [n]\n",
  "CROWFOOT": "a wild flower, aka buttercup or spearwort [n CROWFEET or CROWFOOTS]\n",
  "CROWFOOTS": "CROWFOOT, a wild flower, aka buttercup or spearwort [n]\n",
  "CROWING": "the act of gloating [n -S]\n",
  "CROWINGLY": "CROWING [adv]\n",
  "CROWINGS": "CROWING, the act of gloating [n]\n",
  "CROWKEEPER": "(Shakespeare) a scarecrow [n -S]\n",
  "CROWKEEPERS": "CROWKEEPER, (Shakespeare) a scarecrow [n]\n",
  "CROWLIKE": "like a crow [adj]\n",
  "CROWN": "to invest with royal dignity [v -ED, -ING, -S]\n",
  "CROWNED": "CROWN, to invest with royal dignity [v]\n",
  "CROWNER": "an officer who investigates questionable deaths, also CORONER [n -S]\n",
  "CROWNERS": "CROWNER, an officer who investigates questionable deaths, also CORONER [n]\n",
  "CROWNET": "a small crown, also CORONET [n -S]\n",
  "CROWNETS": "CROWNET, a small crown, also CORONET [n]\n",
  "CROWNING": "the act of crowning [n -S]\n",
  "CROWNINGS": "CROWNING, the act of crowning [n]\n",
  "CROWNLAND": "a large administrative district of the former Austro-Hungarian empire [n -S]\n",
  "CROWNLANDS": "CROWNLAND, a large administrative district of the former Austro-Hungarian empire [n]\n",
  "CROWNLESS": "without a crown [adj]\n",
  "CROWNLET": "a small crown [n -S]\n",
  "CROWNLETS": "CROWNLET, a small crown [n]\n",
  "CROWNLIKE": "like a crown [adj]\n",
  "CROWNPIECE": "the strap of a bridle that goes over a horse's head behind the ears [n -S]\n",
  "CROWNPIECES": "CROWNPIECE, the strap of a bridle that goes over a horse's head behind the ears [n]\n",
  "CROWNS": "CROWN, to invest with royal dignity [v]\n",
  "CROWNWORK": "the manufacture and fitting of artificial crowns for teeth [n -S]\n",
  "CROWNWORKS": "CROWNWORK, the manufacture and fitting of artificial crowns for teeth [n]\n",
  "CROWS": "CROW, to gloat, exult [v]\n",
  "CROWSFEET": "CROWSFOOT, a wrinkle at the side of the eye [n]\n",
  "CROWSFOOT": "a wrinkle at the side of the eye [n CROWSFEET]\n",
  "CROWSTEP": "a steplike figure on a gable [n -S]\n",
  "CROWSTEPPED": "of a gable, having steplike figures [adj]\n",
  "CROWSTEPS": "CROWSTEP, a steplike figure on a gable [n]\n",
  "CROZE": "a tool used in barrel-making, also CROZER [n -S]\n",
  "CROZER": "a tool used in barrel-making, also CROZE [n -S]\n",
  "CROZERS": "CROZER, a tool used in barrel-making, also CROZE [n]\n",
  "CROZES": "CROZE, a tool used in barrel-making, also CROZER [n]\n",
  "CROZIER": "a bishop's staff, also CROSIER [n -S]\n",
  "CROZIERS": "CROZIER, a bishop's staff, also CROSIER [n]\n",
  "CROZZLED": "(Yorkshire dialect) of toast etc., dry and burnt [adj]\n",
  "CRU": "(French) a vineyard [n -S]\n",
  "CRUBEEN": "(Irish) a pig's trotter [n -S]\n",
  "CRUBEENS": "CRUBEEN, (Irish) a pig's trotter [n]\n",
  "CRUCES": "CRUX, (Latin) a basic or decisive point [n]\n",
  "CRUCIAL": "very important [adj CRUCIALLY]\n",
  "CRUCIALLY": "CRUCIAL, very important [adv]\n",
  "CRUCIAN": "a colourful carp, also CRUSIAN [n -S]\n",
  "CRUCIANS": "CRUCIAN, a colourful carp, also CRUSIAN [n]\n",
  "CRUCIATE": "cross-shaped or Y-shaped [adj CRUCIATELY] / a ligament in the knee [n -S]\n",
  "CRUCIATELY": "CRUCIATE, cross-shaped or Y-shaped [adv]\n",
  "CRUCIATES": "CRUCIATE, a ligament in the knee [n]\n",
  "CRUCIBLE": "a heat-resistant vessel [n -S]\n",
  "CRUCIBLES": "CRUCIBLE, a heat-resistant vessel [n]\n",
  "CRUCIFER": "one who bears a cross in a religious procession [n -S]\n",
  "CRUCIFEROUS": "bearing a cross [adj]\n",
  "CRUCIFERS": "CRUCIFER, one who bears a cross in a religious procession [n]\n",
  "CRUCIFIED": "CRUCIFY, to put to death on a cross [v]\n",
  "CRUCIFIER": "one who crucifies [n -S]\n",
  "CRUCIFIERS": "CRUCIFIER, one who crucifies [n]\n",
  "CRUCIFIES": "CRUCIFY, to put to death on a cross [v]\n",
  "CRUCIFIX": "a cross bearing an image of Christ [n -ES]\n",
  "CRUCIFIXES": "CRUCIFIX, a cross bearing an image of Christ [n]\n",
  "CRUCIFIXION": "execution by crucifying [n -S]\n",
  "CRUCIFIXIONS": "CRUCIFIXION, execution by crucifying [n]\n",
  "CRUCIFORM": "cross-shaped [adj CRUCIFORMLY] / something cross-shaped [n -S]\n",
  "CRUCIFORMLY": "CRUCIFORM, cross-shaped [adv]\n",
  "CRUCIFORMS": "CRUCIFORM, something cross-shaped [n]\n",
  "CRUCIFY": "to put to death on a cross [v CRUCIFIED, CRUCIFYING, CRUCIFIES]\n",
  "CRUCIFYING": "CRUCIFY, to put to death on a cross [v]\n",
  "CRUCIVERBAL": "related to crosswords [adj]\n",
  "CRUCIVERBALISM": "the compiling and solving of crosswords [n -S]\n",
  "CRUCIVERBALISMS": "CRUCIVERBALISM, the compiling and solving of crosswords [n]\n",
  "CRUCIVERBALIST": "a designer or afficionado of crossword puzzles [n -S]\n",
  "CRUCIVERBALISTS": "CRUCIVERBALIST, a designer or afficionado of crossword puzzles [n]\n",
  "CRUCK": "one of a pair of curved timbers supporting a roof [n -S]\n",
  "CRUCKS": "CRUCK, one of a pair of curved timbers supporting a roof [n]\n",
  "CRUD": "to be blocked with filth [v CRUDDED, CRUDDING, CRUDS]\n",
  "CRUDDED": "CRUD, to be blocked with filth [v]\n",
  "CRUDDIER": "CRUDDY, dirty, unpleasant [adj]\n",
  "CRUDDIEST": "CRUDDY, dirty, unpleasant [adj]\n",
  "CRUDDING": "CRUD, to be blocked with filth [v]\n",
  "CRUDDLE": "(Spenser) to curdle, also CURDLE [v CRUDDLED, CRUDDLING, CRUDDLES]\n",
  "CRUDDLED": "CRUDDLE, (Spenser) to curdle, also CURDLE [v]\n",
  "CRUDDLES": "CRUDDLE, (Spenser) to curdle, also CURDLE [v]\n",
  "CRUDDLING": "CRUDDLE, (Spenser) to curdle, also CURDLE [v]\n",
  "CRUDDY": "dirty, unpleasant [adj CRUDDIER, CRUDDIEST]\n",
  "CRUDE": "unrefined petroleum [n -S] / unrefined [adj CRUDER, CRUDEST]\n",
  "CRUDELY": "CRUDE, unrefined [adv]\n",
  "CRUDENESS": "the state of being crude [n -ES]\n",
  "CRUDENESSES": "CRUDENESS, the state of being crude [n]\n",
  "CRUDER": "CRUDE, unrefined [adj]\n",
  "CRUDES": "CRUDE, unrefined petroleum [n]\n",
  "CRUDEST": "CRUDE, unrefined [adj]\n",
  "CRUDIER": "CRUDY, (Shakespeare) crude, raw [adj]\n",
  "CRUDIEST": "CRUDY, (Shakespeare) crude, raw [adj]\n",
  "CRUDITES": "(French) raw vegetables served with a dip [n]\n",
  "CRUDITIES": "CRUDITY, the state of being crude [n]\n",
  "CRUDITY": "the state of being crude [n CRUDITIES]\n",
  "CRUDO": "sliced, uncooked seafood often served with a sauce [n -S]\n",
  "CRUDOS": "CRUDO, sliced, uncooked seafood often served with a sauce [n]\n",
  "CRUDS": "CRUD, to be blocked with filth [v]\n",
  "CRUDY": "(Shakespeare) crude, raw [adj CRUDIER, CRUDIEST]\n",
  "CRUE": "(Milton) crew [n -S]\n",
  "CRUEL": "disposed to inflict pain [adj CRUELER or CRUELLER, CRUELEST or CRUELLEST, CRUELLY]\n",
  "CRUELER": "CRUEL, disposed to inflict pain [adj]\n",
  "CRUELEST": "CRUEL, disposed to inflict pain [adj]\n",
  "CRUELLER": "CRUEL, disposed to inflict pain [adj]\n",
  "CRUELLEST": "CRUEL, disposed to inflict pain [adj]\n",
  "CRUELLS": "(archaic) scrofula, the King's Evil, also CREWELS, CRUELS [n]\n",
  "CRUELLY": "CRUEL, disposed to inflict pain [adv]\n",
  "CRUELNESS": "(obsolete) cruelty [n -ES]\n",
  "CRUELNESSES": "CRUELNESS, (obsolete) cruelty [n]\n",
  "CRUELS": "(Scots) scrofula, the King's Evil, also CREWELS, CRUELLS [n]\n",
  "CRUELTIES": "CRUELTY, savage behaviour towards a person or animal [n]\n",
  "CRUELTY": "savage behaviour towards a person or animal [n CRUELTIES]\n",
  "CRUES": "CRUE, (Milton) crew [n]\n",
  "CRUET": "a vessel used in religious ceremonies, esp. to hold the Eucharist [n -S]\n",
  "CRUETS": "CRUET, a vessel used in religious ceremonies, esp. to hold the Eucharist [n]\n",
  "CRUFT": "technical material that is redundant, old or inferior [n -S]\n",
  "CRUFTS": "CRUFT, technical material that is redundant, old or inferior [n]\n",
  "CRUISE": "to progress smoothly [v CRUISED, CRUISING, CRUISES]\n",
  "CRUISED": "CRUISE, to progress smoothly [v]\n",
  "CRUISER": "a high-speed warship less heavily armed than a battleship [n -S]\n",
  "CRUISERS": "CRUISER, a high-speed warship less heavily armed than a battleship [n]\n",
  "CRUISERWEIGHT": "a weight division in boxing [n -S]\n",
  "CRUISERWEIGHTS": "CRUISERWEIGHT, a weight division in boxing [n]\n",
  "CRUISES": "CRUISE, to progress smoothly [v]\n",
  "CRUISEWAY": "a canal for exclusively recreational use [n -S]\n",
  "CRUISEWAYS": "CRUISEWAY, a canal for exclusively recreational use [n]\n",
  "CRUISEWEAR": "clothing suitable for a leisure cruise [n -S]\n",
  "CRUISEWEARS": "CRUISEWEAR, clothing suitable for a leisure cruise [n]\n",
  "CRUISEY": "frequented by homosexuals looking for partners, also CRUISY [adj CRUISIER, CRUISIEST]\n",
  "CRUISIE": "(Scots) an open iron lamp with a rush wick, also CRUIZIE, CRUSIE, CRUSY, CRUZIE [n -S]\n",
  "CRUISIER": "CRUISY, frequented by homosexuals looking for partners, also CRUISEY [adj]\n",
  "CRUISIES": "CRUISIE, (Scots) an open iron lamp with a rush wick, also CRUIZIE, CRUSIE, CRUSY, CRUZIE [n]\n",
  "CRUISIEST": "CRUISY, frequented by homosexuals looking for partners, also CRUISEY [adj]\n",
  "CRUISING": "the act of driving about leisurely [n -S]\n",
  "CRUISINGS": "CRUISING, the act of driving about leisurely [n]\n",
  "CRUISY": "frequented by homosexuals looking for partners, also CRUISEY [adj CRUISIER, CRUISIEST]\n",
  "CRUIVE": "(Scots) a pen or sty, also CROOVE, CRUVE [n -S]\n",
  "CRUIVES": "CRUIVE, (Scots) a pen or sty, also CROOVE, CRUVE [n]\n",
  "CRUIZIE": "an open iron lamp with a rush wick, also CRUISIE, CRUSIE, CRUSY, CRUZIE [n -S]\n",
  "CRUIZIES": "CRUIZIE, an open iron lamp with a rush wick, also CRUISIE, CRUSIE, CRUSY, CRUZIE [n]\n",
  "CRULLER": "(Dutch) in N. America, a type of sweet cake fried in fat, also KRULLER [n -S]\n",
  "CRULLERS": "CRULLER, (Dutch) in N. America, a type of sweet cake fried in fat, also KRULLER [n]\n",
  "CRUMB": "to break into small pieces [v -ED, -ING, -S]\n",
  "CRUMBCLOTH": "a cloth laid under a table to keep crumbs from the carpet [n -S]\n",
  "CRUMBCLOTHS": "CRUMBCLOTH, a cloth laid under a table to keep crumbs from the carpet [n]\n",
  "CRUMBED": "CRUMB, to break into small pieces [v]\n",
  "CRUMBER": "one who makes crumbs [n -S]\n",
  "CRUMBERS": "CRUMBER, one who makes crumbs [n]\n",
  "CRUMBIER": "CRUMBY, full of crumbs [adj]\n",
  "CRUMBIEST": "CRUMBY, full of crumbs [adj]\n",
  "CRUMBING": "CRUMB, to break into small pieces [v]\n",
  "CRUMBLE": "to break up and fall away [v CRUMBLED, CRUMBLING, CRUMBLES]\n",
  "CRUMBLED": "CRUMBLE, to break up and fall away [v]\n",
  "CRUMBLES": "CRUMBLE, to break up and fall away [v]\n",
  "CRUMBLIER": "CRUMBLY, easily crumbed [adj]\n",
  "CRUMBLIES": "(slang) very old people [n]\n",
  "CRUMBLIEST": "CRUMBLY, easily crumbed [adj]\n",
  "CRUMBLINESS": "the state of being crumbly [n -ES]\n",
  "CRUMBLINESSES": "CRUMBLINESS, the state of being crumbly [n]\n",
  "CRUMBLING": "the act of crumbling [n -S]\n",
  "CRUMBLINGS": "CRUMBLING, the act of crumbling [n]\n",
  "CRUMBLY": "easily crumbed [adj CRUMBLIER, CRUMBLIEST] / an older person [n CRUMBLIES]\n",
  "CRUMBS": "CRUMB, to break into small pieces [v]\n",
  "CRUMBUM": "a despicable person [n -S]\n",
  "CRUMBUMS": "CRUMBUM, a despicable person [n]\n",
  "CRUMBY": "full of crumbs [adj CRUMBIER, CRUMBIEST]\n",
  "CRUMEN": "(Latin) a deer's tear-pit [n -S]\n",
  "CRUMENAL": "(Spenser) a purse [n -S]\n",
  "CRUMENALS": "CRUMENAL, (Spenser) a purse [n]\n",
  "CRUMENS": "CRUMEN, (Latin) a deer's tear-pit [n]\n",
  "CRUMHORN": "(German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CROMORNE, KRUMHORN, KRUMMHORN [n -S]\n",
  "CRUMHORNS": "CRUMHORN, (German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CROMORNE, KRUMHORN, KRUMMHORN [n]\n",
  "CRUMMACK": "(Gaelic) a crook, a stick with a curved head, also CROMACK, CRUMMOCK [n -S]\n",
  "CRUMMACKS": "CRUMMACK, (Gaelic) a crook, a stick with a curved head, also CROMACK, CRUMMOCK [n]\n",
  "CRUMMIE": "(Scots) a cow with crooked horns, also CRUMMY [n -S]\n",
  "CRUMMIER": "CRUMMY, mean, despicable, also CRUMMIE [adj]\n",
  "CRUMMIES": "CRUMMIE, (Scots) a cow with crooked horns, also CRUMMY [n]\n",
  "CRUMMIEST": "CRUMMY, mean, despicable, also CRUMMIE [adj]\n",
  "CRUMMILY": "CRUMMY, mean, despicable, also CRUMMIE [adv]\n",
  "CRUMMINESS": "the state of being crummy [n -ES]\n",
  "CRUMMINESSES": "CRUMMINESS, the state of being crummy [n]\n",
  "CRUMMOCK": "(Gaelic) a crook, a stick with a curved head, also CROMACK, CRUMMACK [n -S]\n",
  "CRUMMOCKS": "CRUMMOCK, (Gaelic) a crook, a stick with a curved head, also CROMACK, CRUMMACK [n]\n",
  "CRUMMY": "mean, despicable, also CRUMMIE [adj CRUMMIER, CRUMMIEST, CRUMMILY] / a cow with a crumpled horn [n CRUMMIES]\n",
  "CRUMP": "crisp, also CRUMPY [adj CRUMPER, CRUMPEST] / to crunch [v -ED, -ING, -S]\n",
  "CRUMPED": "CRUMP, to crunch [v]\n",
  "CRUMPER": "CRUMP, crisp, also CRUMPY [adj]\n",
  "CRUMPEST": "CRUMP, crisp, also CRUMPY [adj]\n",
  "CRUMPET": "a small cake cooked on a griddle [n -S]\n",
  "CRUMPETS": "CRUMPET, a small cake cooked on a griddle [n]\n",
  "CRUMPIER": "CRUMPY, crisp, also CRUMP [adj]\n",
  "CRUMPIEST": "CRUMPY, crisp, also CRUMP [adj]\n",
  "CRUMPING": "CRUMP, to crunch [v]\n",
  "CRUMPLE": "to wrinkle [v CRUMPLED, CRUMPLING, CRUMPLES]\n",
  "CRUMPLED": "CRUMPLE, to wrinkle [v]\n",
  "CRUMPLES": "CRUMPLE, to wrinkle [v]\n",
  "CRUMPLIER": "CRUMPLY, easily wrinkled [adj]\n",
  "CRUMPLIEST": "CRUMPLY, easily wrinkled [adj]\n",
  "CRUMPLING": "the act of creasing [n -S]\n",
  "CRUMPLINGS": "CRUMPLING, the act of creasing [n]\n",
  "CRUMPLY": "easily wrinkled [adj CRUMPLIER, CRUMPLIEST]\n",
  "CRUMPS": "CRUMP, to crunch [v]\n",
  "CRUMPY": "crisp, also CRUMP [adj CRUMPIER, CRUMPIEST]\n",
  "CRUNCH": "to chew with a crackling sound, also CRANCH, CRAUNCH [v -ED, -ING, -ES]\n",
  "CRUNCHABLE": "that can be crunched [adj]\n",
  "CRUNCHED": "CRUNCH, to chew with a crackling sound, also CRANCH, CRAUNCH [v]\n",
  "CRUNCHER": "one that crunches [n -S]\n",
  "CRUNCHERS": "CRUNCHER, one that crunches [n]\n",
  "CRUNCHES": "CRUNCH, to chew with a crackling sound, also CRANCH, CRAUNCH [v]\n",
  "CRUNCHIE": "(offensive South African) an Afrikaaner [n -S]\n",
  "CRUNCHIER": "CRUNCHY, given to crunching [adj]\n",
  "CRUNCHIES": "CRUNCHIE, (offensive South African) an Afrikaaner [n]\n",
  "CRUNCHIEST": "CRUNCHY, given to crunching [adj]\n",
  "CRUNCHILY": "CRUNCHY, given to crunching [adv]\n",
  "CRUNCHINESS": "the state of being crunchy [n -ES]\n",
  "CRUNCHINESSES": "CRUNCHINESS, the state of being crunchy [n]\n",
  "CRUNCHING": "the act of crunching [n -S]\n",
  "CRUNCHINGS": "CRUNCHING, the act of crunching [n]\n",
  "CRUNCHY": "given to crunching [adj CRUNCHIER, CRUNCHIEST]\n",
  "CRUNK": "a form of hip-hop music originating in the southern states of the US [n -S]\n",
  "CRUNKED": "in a state of excitement or exhilaration, also KRUNKED [adj]\n",
  "CRUNKLE": "to crumple [v CRUNKLED, CRUNKLING, CRUNKLES]\n",
  "CRUNKLED": "CRUNKLE, to crumple [v]\n",
  "CRUNKLES": "CRUNKLE, to crumple [v]\n",
  "CRUNKLING": "CRUNKLE, to crumple [v]\n",
  "CRUNKS": "CRUNK, a form of hip-hop music originating in the southern states of the US [n]\n",
  "CRUNODAL": "relating to a crunode, the point at which a curve crosses itself [adj]\n",
  "CRUNODE": "a point at which a curve crosses itself [n -S]\n",
  "CRUNODES": "CRUNODE, a point at which a curve crosses itself [n]\n",
  "CRUOR": "(Latin) a mass of coagulated blood [n CRUORS or CRUORES]\n",
  "CRUORES": "CRUOR, (Latin) a mass of coagulated blood [n]\n",
  "CRUORS": "CRUOR, (Latin) a mass of coagulated blood [n]\n",
  "CRUPPER": "a strap on a saddle that passes beneath a horse's tail, also CROUPER [n -S]\n",
  "CRUPPERS": "CRUPPER, a strap on a saddle that passes beneath a horse's tail, also CROUPER [n]\n",
  "CRURA": "CRUS, (Latin) a part of a leg, the shank [n]\n",
  "CRURAL": "pertaining to the leg or thigh [adj]\n",
  "CRUS": "(Latin) a part of a leg, the shank [n CRURA]\n",
  "CRUSADE": "to engage in a holy war [v CRUSADED, CRUSADING, CRUSADES]\n",
  "CRUSADED": "CRUSADE, to engage in a holy war [v]\n",
  "CRUSADER": "one that crusades [n -S]\n",
  "CRUSADERS": "CRUSADER, one that crusades [n]\n",
  "CRUSADES": "CRUSADE, to engage in a holy war [v]\n",
  "CRUSADING": "CRUSADE, to engage in a holy war [v]\n",
  "CRUSADO": "(Portuguese) an old Portuguese coin, also CRUZADO [n CRUSADOS or CRUSADOES]\n",
  "CRUSADOES": "CRUSADO, (Portuguese) an old Portuguese coin, also CRUZADO [n]\n",
  "CRUSADOS": "CRUSADO, (Portuguese) an old Portuguese coin, also CRUZADO [n]\n",
  "CRUSE": "an earthenware pot [n -S]\n",
  "CRUSES": "CRUSE, an earthenware pot [n]\n",
  "CRUSET": "a goldsmith's crucible [n -S]\n",
  "CRUSETS": "CRUSET, a goldsmith's crucible [n]\n",
  "CRUSH": "to press out of shape [v -ED, -ING, -ES]\n",
  "CRUSHABILITIES": "CRUSHABILITY, the quality of being crushable [n]\n",
  "CRUSHABILITY": "the quality of being crushable [n CRUSHABILITIES]\n",
  "CRUSHABLE": "that can be crushed [adj]\n",
  "CRUSHED": "CRUSH, to press out of shape [v]\n",
  "CRUSHER": "one that crushes [n -S]\n",
  "CRUSHERS": "CRUSHER, one that crushes [n]\n",
  "CRUSHES": "CRUSH, to press out of shape [v]\n",
  "CRUSHING": "oppressive [adj CRUSHINGLY] / the act of crushing [n -S]\n",
  "CRUSHINGLY": "CRUSHING [adv]\n",
  "CRUSHINGS": "CRUSHING, the act of crushing [n]\n",
  "CRUSHPROOF": "resistant to crushing [adj]\n",
  "CRUSIAN": "a colourful carp, also CRUCIAN [n -S]\n",
  "CRUSIANS": "CRUSIAN, a colourful carp, also CRUCIAN [n]\n",
  "CRUSIE": "(Scots) a type of iron lamp, also CRUISIE, CRUSY [n -S]\n",
  "CRUSIES": "CRUSY, (Scots) an open iron lamp with a rush wick, also CRUISIE, CRUIZIE, CRUSIE, CRUZIE [n]\n",
  "CRUSILY": "of a shield or charge, strewn with crosslets rather than crosses [adj]\n",
  "CRUST": "to form a hardened outer surface [v -ED, -ING, -S]\n",
  "CRUSTA": "(Latin) a hard coating [n CRUSTAE] / a cocktail served in a glass, its rim coated with sugar [n CRUSTAS]\n",
  "CRUSTACEA": "a large class of arthropod animals with hard shells [n]\n",
  "CRUSTACEAN": "a member of the crustacea, a large class of arthropod animals with hard shells [n -S]\n",
  "CRUSTACEANS": "CRUSTACEAN, a member of the crustacea, a large class of arthropod animals with hard shells [n]\n",
  "CRUSTACEOUS": "pertaining to, or of the nature of, a crust or hard integument, esp. of lichens [adj]\n",
  "CRUSTAE": "CRUSTA, (Latin) a hard coating [n]\n",
  "CRUSTAL": "pertaining to the earth's crust [adj]\n",
  "CRUSTAS": "plural of crusta in the sense of a cocktail served in a glass, its rim coated with sugar [n]\n",
  "CRUSTATE": "covered with a crust, e.g. crustate lichens, also CRUSTATED [adj]\n",
  "CRUSTATED": "covered with a crust, also CRUSTATE [adj]\n",
  "CRUSTATION": "an adherent crust [n -S]\n",
  "CRUSTATIONS": "CRUSTATION, an adherent crust [n]\n",
  "CRUSTED": "CRUST, to form a hardened outer surface [v]\n",
  "CRUSTIER": "CRUSTY, covered with a crust [adj]\n",
  "CRUSTIES": "CRUSTY, a young vagrant with matted hair [n]\n",
  "CRUSTIEST": "CRUSTY, covered with a crust [adj]\n",
  "CRUSTILY": "CRUSTY, covered with a crust [adv]\n",
  "CRUSTINESS": "the state of being crusty [n -ES]\n",
  "CRUSTINESSES": "CRUSTINESS, the state of being crusty [n]\n",
  "CRUSTING": "CRUST, to form a hardened outer surface [v]\n",
  "CRUSTLESS": "without a crust [adj]\n",
  "CRUSTLIKE": "like a crust [adj]\n",
  "CRUSTOSE": "forming a thin brittle crust [adj]\n",
  "CRUSTS": "CRUST, to form a hardened outer surface [v]\n",
  "CRUSTY": "covered with a crust [adj CRUSTIER, CRUSTIEST, CRUSTILY] / a young vagrant with matted hair [n CRUSTIES]\n",
  "CRUSY": "(Scots) an open iron lamp with a rush wick, also CRUISIE, CRUIZIE, CRUSIE, CRUZIE [n CRUSIES]\n",
  "CRUTCH": "to support on a crutch [v -ED, -ING, -ES]\n",
  "CRUTCHED": "CRUTCH, to support on a crutch [v]\n",
  "CRUTCHES": "CRUTCH, to support on a crutch [v]\n",
  "CRUTCHING": "CRUTCH, to support on a crutch [v]\n",
  "CRUTCHINGS": "the wool clipped from a sheep's hindquarters [n]\n",
  "CRUVE": "(Scots) a pen or sty, also CROOVE, CRUIVE [n -S]\n",
  "CRUVES": "CRUVE, (Scots) a pen or sty, also CROOVE, CRUIVE [n]\n",
  "CRUX": "(Latin) a basic or decisive point [n CRUXES or CRUCES]\n",
  "CRUXES": "CRUX, (Latin) a basic or decisive point [n]\n",
  "CRUZADO": "(Portuguese) an old Portuguese coin, also CRUSADO [n CRUZADOS or CRUZADOES]\n",
  "CRUZADOES": "CRUZADO, (Portuguese) an old Portuguese coin, also CRUSADO [n]\n",
  "CRUZADOS": "CRUZADO, (Portuguese) an old Portuguese coin, also CRUSADO [n]\n",
  "CRUZEIRO": "(Portuguese) the standard monetary unit of Brazil, that replaced the cruzado [n -S]\n",
  "CRUZEIROS": "CRUZEIRO, (Portuguese) the standard monetary unit of Brazil, that replaced the cruzado [n]\n",
  "CRUZIE": "an open iron lamp with a rush wick, also CRUISIE, CRUIZIE, CRUSIE, CRUSY [n -S]\n",
  "CRUZIES": "CRUZIE, an open iron lamp with a rush wick, also CRUISIE, CRUIZIE, CRUSIE, CRUSY [n]\n",
  "CRWTH": "(Welsh) an ancient Celtic musical instrument [n -S]\n",
  "CRWTHS": "CRWTH, (Welsh) an ancient Celtic musical instrument [n]\n",
  "CRY": "to utter a sound of distress or to weep [v CRIED, CRYING, CRIES]\n",
  "CRYBABIES": "CRYBABY, a person who cries easily [n]\n",
  "CRYBABY": "a person who cries easily [n CRYBABIES]\n",
  "CRYER": "one that cries, also CRIER [n -S]\n",
  "CRYERS": "CRYER, one that cries, also CRIER [n]\n",
  "CRYING": "distressing, heartbreaking, lamentable, as in a crying shame [adj CRYINGLY] / the act of crying [n -S]\n",
  "CRYINGLY": "CRYING, distressing, heartbreaking, lamentable, as in a crying shame [adv]\n",
  "CRYINGS": "CRYING, the act of crying [n]\n",
  "CRYMOTHERAPIES": "CRYMOTHERAPY, medical treatment using extreme cold, also CRYOTHERAPY [n]\n",
  "CRYMOTHERAPY": "medical treatment using extreme cold, also CRYOTHERAPY [n CRYMOTHERAPIES]\n",
  "CRYOBANK": "a place for storing human tissue at very low temperatures [n -S]\n",
  "CRYOBANKS": "CRYOBANK, a place for storing human tissue at very low temperatures [n]\n",
  "CRYOBIOLOGICAL": "relating to cryobiology [adj]\n",
  "CRYOBIOLOGIES": "CRYOBIOLOGY, the study of life under cold conditions [n]\n",
  "CRYOBIOLOGIST": "one who studies cryobiology [n -S]\n",
  "CRYOBIOLOGISTS": "CRYOBIOLOGIST, one who studies cryobiology [n]\n",
  "CRYOBIOLOGY": "the study of life under cold conditions [n CRYOBIOLOGIES]\n",
  "CRYOCABLE": "a highly conducting electric cable cooled with a refrigerant [n -S]\n",
  "CRYOCABLES": "CRYOCABLE, a highly conducting electric cable cooled with a refrigerant [n]\n",
  "CRYOCONITE": "dust found on the surface of polar ice [n -S]\n",
  "CRYOCONITES": "CRYOCONITE, dust found on the surface of polar ice [n]\n",
  "CRYOGEN": "a substance for producing low temperatures [n -S]\n",
  "CRYOGENIC": "of or like a cryogen, a substance for obtaining low temperatures, a freezing mixture [adj CRYOGENICALLY]\n",
  "CRYOGENICALLY": "CRYOGENIC, of or like a cryogen, a substance for obtaining low temperatures, a freezing mixture [adv]\n",
  "CRYOGENICS": "the branch of physics and technology that deals with the production of very low temperatures and their effects, also CRYOGENY [n]\n",
  "CRYOGENIES": "CRYOGENY, a branch of physics [n]\n",
  "CRYOGENS": "CRYOGEN, a substance for producing low temperatures [n]\n",
  "CRYOGENY": "a branch of physics [n CRYOGENIES]\n",
  "CRYOGLOBULIN": "an immunoglobulin formed in the blood in certain diseases which forms obstructions in small blood vessels when the extremities are subjected to low temperatures [n -S]\n",
  "CRYOGLOBULINS": "CRYOGLOBULIN, an immunoglobulin formed in the blood in certain diseases which forms obstructions in small blood vessels when the extremities are subjected to low temperatures [n]\n",
  "CRYOHYDRATE": "a crystalline substance containing water and a salt in definite proportions, a eutectic crystallizing below the freezing point of water [n -S]\n",
  "CRYOHYDRATES": "CRYOHYDRATE, a crystalline substance containing water and a salt in definite proportions, a eutectic crystallizing below the freezing point of water [n]\n",
  "CRYOLITE": "a mineral, also KRYOLITE, KRYOLITH [n -S]\n",
  "CRYOLITES": "CRYOLITE, a mineral, also KRYOLITE, KRYOLITH [n]\n",
  "CRYOMETER": "an instrument for measuring low temperatures, also KRYOMETER [n -S]\n",
  "CRYOMETERS": "CRYOMETER, an instrument for measuring low temperatures, also KRYOMETER [n]\n",
  "CRYOMETRIC": "relating to the measurement of low temperatures [adj]\n",
  "CRYOMETRIES": "CRYOMETRY, measurement by use of a cryometer, an instrument for measuring low temperatures [n]\n",
  "CRYOMETRY": "measurement by use of a cryometer, an instrument for measuring low temperatures [n CRYOMETRIES]\n",
  "CRYONIC": "relating to cryonics, the practice of preserving human corpses by freezing them [adj CRYONICALLY]\n",
  "CRYONICALLY": "CRYONIC, relating to cryonics, the practice of preserving human corpses by freezing them [adv]\n",
  "CRYONICS": "the freezing of the dead for future revival [n]\n",
  "CRYOPHILIC": "cold-loving [adj]\n",
  "CRYOPHORUS": "an instrument for showing the decrease in the temperature of water by its evaporation [n -ES]\n",
  "CRYOPHORUSES": "CRYOPHORUS, an instrument for showing the decrease in the temperature of water by its evaporation [n]\n",
  "CRYOPHYSICS": "low-temperature physics [n]\n",
  "CRYOPHYTE": "an organism esp. an alga or moss that grows on snow or ice [n -S]\n",
  "CRYOPHYTES": "CRYOPHYTE, an organism esp. an alga or moss that grows on snow or ice [n]\n",
  "CRYOPLANKTON": "minute organisms, esp. algae, living in ice, snow, or icy water [n -S]\n",
  "CRYOPLANKTONS": "CRYOPLANKTON, minute organisms, esp. algae, living in ice, snow, or icy water [n]\n",
  "CRYOPRECIPITATE": "a precipitate, e.g. from blood plasma, produced by freezing and thawing under controlled conditions [n]\n",
  "CRYOPRESERVE": "to preserve by freezing [v CRYOPRESERVED, CRYOPRESERVING, CRYOPRESERVES]\n",
  "CRYOPRESERVED": "CRYOPRESERVE, to preserve by freezing [v]\n",
  "CRYOPRESERVES": "CRYOPRESERVE, to preserve by freezing [v]\n",
  "CRYOPRESERVING": "CRYOPRESERVE, to preserve by freezing [v]\n",
  "CRYOPROBE": "a blunt chilled probe used to freeze tissue in cryosurgery [n -S]\n",
  "CRYOPROBES": "CRYOPROBE, a blunt chilled probe used to freeze tissue in cryosurgery [n]\n",
  "CRYOPROTECTANT": "a cryoprotective substance [n -S]\n",
  "CRYOPROTECTANTS": "CRYOPROTECTANT, a cryoprotective substance [n]\n",
  "CRYOPROTECTIVE": "serving to protect against the deleterious effects of freezing [adj]\n",
  "CRYOSCOPE": "an instrument for determining freezing points of substances [n -S]\n",
  "CRYOSCOPES": "CRYOSCOPE, an instrument for determining freezing points of substances [n]\n",
  "CRYOSCOPIC": "relating to cryoscopy [adj]\n",
  "CRYOSCOPIES": "CRYOSCOPY, the study of the effect of dissolved substances on the freezing points of solvents [n]\n",
  "CRYOSCOPY": "the study of the effect of dissolved substances on the freezing points of solvents [n CRYOSCOPIES]\n",
  "CRYOSTAT": "a refrigeration apparatus [n -S]\n",
  "CRYOSTATIC": "relating to the use of a cryostat, an apparatus for achieving or demonstrating cooling by evaporation; any apparatus for obtaining a low temperature [adj]\n",
  "CRYOSTATS": "CRYOSTAT, a refrigeration apparatus [n]\n",
  "CRYOSURGEON": "a surgeon who uses freezing techniques [n -S]\n",
  "CRYOSURGEONS": "CRYOSURGEON, a surgeon who uses freezing techniques [n]\n",
  "CRYOSURGERIES": "CRYOSURGERY, surgery using instruments at very low temperatures to cut and destroy tissue [n]\n",
  "CRYOSURGERY": "surgery using instruments at very low temperatures to cut and destroy tissue [n CRYOSURGERIES]\n",
  "CRYOSURGICAL": "relating to cryosurgery [adj]\n",
  "CRYOTHERAPIES": "CRYOTHERAPY, medical treatment using extreme cold, also CRYMOTHERAPY [n]\n",
  "CRYOTHERAPY": "medical treatment using extreme cold, also CRYMOTHERAPY [n CRYOTHERAPIES]\n",
  "CRYOTRON": "a tiny form of electronic switch operating in a bath of liquid helium a few degrees above absolute zero [n -S]\n",
  "CRYOTRONS": "CRYOTRON, a tiny form of electronic switch operating in a bath of liquid helium a few degrees above absolute zero [n]\n",
  "CRYPT": "a burial vault [n -S]\n",
  "CRYPTADIA": "(Greek) things to be kept hidden [n]\n",
  "CRYPTAESTHESIA": "supernormal perception, e.g. clairvoyance, also CRYPTESTHESIA [n -S]\n",
  "CRYPTAESTHESIAS": "CRYPTAESTHESIA, supernormal perception, e.g. clairvoyance, also CRYPTESTHESIA [n]\n",
  "CRYPTAESTHETIC": "of or relating to supernormal perception, also CRYPTESTHETIC [adj]\n",
  "CRYPTAL": "relating to a crypt [adj]\n",
  "CRYPTANALYSES": "CRYPTANALYSIS, the decipherment of code [n]\n",
  "CRYPTANALYSIS": "the decipherment of code [n CRYPTANALYSES]\n",
  "CRYPTANALYST": "one who deciphers codes [n -S]\n",
  "CRYPTANALYSTS": "CRYPTANALYST, one who deciphers codes [n]\n",
  "CRYPTANALYTIC": "relating to cryptanalysis, the decipherment of code, also CRYPTANALYTICAL [adj]\n",
  "CRYPTANALYTICAL": "relating to cryptanalysis, the decipherment of code, also CRYPTANALYTIC [adj]\n",
  "CRYPTARITHM": "an arithmetic problem in which letters have been substituted for numbers and which is solved by finding all possible pairings of digits with letters that produce a numerically correct answer [n -S]\n",
  "CRYPTARITHMS": "CRYPTARITHM, an arithmetic problem in which letters have been substituted for numbers and which is solved by finding all possible pairings of digits with letters that produce a numerically correct answer [n]\n",
  "CRYPTESTHESIA": "supernormal perception, e.g. clairvoyance, also CRYPTAESTHESIA [n -S]\n",
  "CRYPTESTHESIAS": "CRYPTESTHESIA, supernormal perception, e.g. clairvoyance, also CRYPTAESTHESIA [n]\n",
  "CRYPTESTHETIC": "of or relating to cryptesthesia, also CRYPTAESTHETIC [adj]\n",
  "CRYPTIC": "hidden, secret, also CRYPTICAL [adj CRYPTICALLY]\n",
  "CRYPTICAL": "hidden, secret, also CRYPTIC [adj CRYPTICALLY]\n",
  "CRYPTICALLY": "CRYPTICAL, hidden, secret, also CRYPTIC [adv]\n",
  "CRYPTO": "one who belongs secretly to a group [n -S]\n",
  "CRYPTOBIONT": "any organism that exhibits cryptobiosis [n -S]\n",
  "CRYPTOBIONTS": "CRYPTOBIONT, any organism that exhibits cryptobiosis [n]\n",
  "CRYPTOBIOSES": "CRYPTOBIOSIS, a temporary state in an organism in which metabolic activity is absent or undetectable [n]\n",
  "CRYPTOBIOSIS": "a temporary state in an organism in which metabolic activity is absent or undetectable [n CRYPTOBIOSES]\n",
  "CRYPTOCLASTIC": "of minerals and rocks, composed of microscopic fragments [adj]\n",
  "CRYPTOCOCCAL": "of or like a cryptococcus [adj]\n",
  "CRYPTOCOCCI": "CRYPTOCOCCUS, any of a genus of budding imperfect fungi that resemble yeasts and include a number of saprophytes and a few serious pathogens [n]\n",
  "CRYPTOCOCCOSES": "CRYPTOCOCCOSIS, a fungal disease [n]\n",
  "CRYPTOCOCCOSIS": "a fungal disease [n CRYPTOCOCCOSES]\n",
  "CRYPTOCOCCUS": "any of a genus of budding imperfect fungi that resemble yeasts and include a number of saprophytes and a few serious pathogens [n CRYPTOCOCCI]\n",
  "CRYPTOCURRENCY": "a decentralized digital medium of exchange which is created, regulated, and exchanged using cryptography and (usually) open source software [n]\n",
  "CRYPTOGAM": "a plant reproducing by spores and not seeds, e.g. ferns, mosses, fungi etc. [n -S]\n",
  "CRYPTOGAMIAN": "of or like a cryptogam, also CRYPTOGAMIC [adj]\n",
  "CRYPTOGAMIC": "of or like a cryptogam, also CRYPTOGAMIAN [adj]\n",
  "CRYPTOGAMIES": "CRYPTOGAMY, the state of being a cryptogam, reproducing by spores and not seeds [n]\n",
  "CRYPTOGAMIST": "one who studies cryptogams [n -S]\n",
  "CRYPTOGAMISTS": "CRYPTOGAMIST, one who studies cryptogams [n]\n",
  "CRYPTOGAMOUS": "of or like a cryptogam [adj]\n",
  "CRYPTOGAMS": "CRYPTOGAM, a plant reproducing by spores and not seeds, e.g. ferns, mosses, fungi etc. [n]\n",
  "CRYPTOGAMY": "the state of being a cryptogam, reproducing by spores and not seeds [n CRYPTOGAMIES]\n",
  "CRYPTOGENIC": "of unknown origin [adj]\n",
  "CRYPTOGRAM": "anything written in cipher, also CRYPTOGRAPH [n -S]\n",
  "CRYPTOGRAMS": "CRYPTOGRAM, anything written in cipher, also CRYPTOGRAPH [n]\n",
  "CRYPTOGRAPH": "anything written in cipher, also CRYPTOGRAM [n -S]\n",
  "CRYPTOGRAPHER": "a specialist in cryptography [n -S]\n",
  "CRYPTOGRAPHERS": "CRYPTOGRAPHER, a specialist in cryptography [n]\n",
  "CRYPTOGRAPHIC": "of, relating to, or using cryptography, also CRYPTOGRAPHICAL [adj]\n",
  "CRYPTOGRAPHICAL": "of, relating to, or using cryptography, also CRYPTOGRAPHIC [adj]\n",
  "CRYPTOGRAPHIES": "CRYPTOGRAPHY, secret writing [n]\n",
  "CRYPTOGRAPHIST": "one who studies cryptographs [n -S]\n",
  "CRYPTOGRAPHISTS": "CRYPTOGRAPHIST, one who studies cryptographs [n]\n",
  "CRYPTOGRAPHS": "CRYPTOGRAPH, anything written in cipher, also CRYPTOGRAM [n]\n",
  "CRYPTOGRAPHY": "secret writing [n CRYPTOGRAPHIES]\n",
  "CRYPTOLOGIC": "relating to cryptology, the scientific study of codes, also CRYPTOLOGICAL [adj]\n",
  "CRYPTOLOGICAL": "relating to cryptology, the scientific study of codes, also CRYPTOLOGIC [adj]\n",
  "CRYPTOLOGIES": "CRYPTOLOGY, the scientific study of codes [n]\n",
  "CRYPTOLOGIST": "a student of cryptology, the scientific study of codes [n -S]\n",
  "CRYPTOLOGISTS": "CRYPTOLOGIST, a student of cryptology, the scientific study of codes [n]\n",
  "CRYPTOLOGY": "the scientific study of codes [n CRYPTOLOGIES]\n",
  "CRYPTOMERIA": "a kind of evergreen tree [n -S]\n",
  "CRYPTOMERIAS": "CRYPTOMERIA, a kind of evergreen tree [n]\n",
  "CRYPTOMETER": "an instrument used to determine the opacity of pigments and paints [n -S]\n",
  "CRYPTOMETERS": "CRYPTOMETER, an instrument used to determine the opacity of pigments and paints [n]\n",
  "CRYPTOMNESIA": "latent or subconscious memory [n -S]\n",
  "CRYPTOMNESIAS": "CRYPTOMNESIA, latent or subconscious memory [n]\n",
  "CRYPTOMNESIC": "relating to cryptomnesia, latent or subconscious memory [adj]\n",
  "CRYPTON": "(Greek) an element, an inert gas, also KRYPTON [n -S]\n",
  "CRYPTONS": "CRYPTON, (Greek) an element, an inert gas, also KRYPTON [n]\n",
  "CRYPTONYM": "a code name or secret name [n -S]\n",
  "CRYPTONYMOUS": "like a cryptonym, a secret name [adj]\n",
  "CRYPTONYMS": "CRYPTONYM, a code name or secret name [n]\n",
  "CRYPTOPHYTE": "any perennial plant that bears its buds below the soil or water surface [n -S]\n",
  "CRYPTOPHYTES": "CRYPTOPHYTE, any perennial plant that bears its buds below the soil or water surface [n]\n",
  "CRYPTOPHYTIC": "like a cryptophyte, a perennial plant that bears its buds below the soil or water surface [adj]\n",
  "CRYPTORCHID": "a male human or animal in whom one or both testes fail to descend into the scrotum [n -S]\n",
  "CRYPTORCHIDISM": "the condition in which one or both testes do not descend normally, also CRYPTORCHISM [n -S]\n",
  "CRYPTORCHIDISMS": "CRYPTORCHIDISM, the condition in which one or both testes do not descend normally, also CRYPTORCHISM [n]\n",
  "CRYPTORCHIDS": "CRYPTORCHID, a male human or animal in whom one or both testes fail to descend into the scrotum [n]\n",
  "CRYPTORCHISM": "a medical condition in which the testes fail to descend, also CRYPTORCHIDISM [n -S]\n",
  "CRYPTORCHISMS": "CRYPTORCHISM, a medical condition in which the testes fail to descend, also CRYPTORCHIDISM [n]\n",
  "CRYPTOS": "CRYPTO, one who belongs secretly to a group [n]\n",
  "CRYPTOSPORIDIA": "CRYPTOSPORIDIUM, any of a genus of protozoans parasitic in the gut of vertebrates including humans and sometimes causing diarrhea [n]\n",
  "CRYPTOSPORIDIUM": "any of a genus of protozoans parasitic in the gut of vertebrates including humans and sometimes causing diarrhea [n CRYPTOSPORIDIA]\n",
  "CRYPTOZOIC": "of animals, living in dark places, such as holes, caves, and beneath stones [adj]\n",
  "CRYPTOZOITE": "a malarial parasite at the stage of development in its host before it enters the red blood cells [n -S]\n",
  "CRYPTOZOITES": "CRYPTOZOITE, a malarial parasite at the stage of development in its host before it enters the red blood cells [n]\n",
  "CRYPTOZOOLOGIES": "CRYPTOZOOLOGY, the study of and search for animals and esp. legendary animals [n]\n",
  "CRYPTOZOOLOGIST": "one who studies cryptozoology [n]\n",
  "CRYPTOZOOLOGY": "the study of and search for animals and esp. legendary animals [n CRYPTOZOOLOGIES]\n",
  "CRYPTS": "CRYPT, a burial vault [n]\n",
  "CRYSTAL": "a transparent mineral [n -S]\n",
  "CRYSTALISABLE": "able to be crystalised, also CRYSTALIZABLE, CRYSTALLISABLE, CRYSTALLIZABLE [adj]\n",
  "CRYSTALISATION": "the process of forming a crystal, also CRYSTALIZATION, CRYSTALLISATION, CRYSTALLIZATION [n -S]\n",
  "CRYSTALISATIONS": "CRYSTALISATION, the process of forming a crystal, also CRYSTALIZATION, CRYSTALLISATION, CRYSTALLIZATION [n]\n",
  "CRYSTALISE": "to form a crystal, also CRYSTALLISE, CRYSTALIZE, CRYSTALLIZE [v CRYSTALISED, CRYSTALISING, CRYSTALISES]\n",
  "CRYSTALISED": "CRYSTALISE, to form a crystal, also CRYSTALLISE, CRYSTALIZE, CRYSTALLIZE [v]\n",
  "CRYSTALISER": "something that crystalises, also CRYSTALIZER, CRYSTALLISER, CRYSTALLIZER [n -S]\n",
  "CRYSTALISERS": "CRYSTALISER, something that crystalises, also CRYSTALIZER, CRYSTALLISER, CRYSTALLIZER [n]\n",
  "CRYSTALISES": "CRYSTALISE, to form a crystal, also CRYSTALLISE, CRYSTALIZE, CRYSTALLIZE [v]\n",
  "CRYSTALISING": "CRYSTALISE, to form a crystal, also CRYSTALLISE, CRYSTALIZE, CRYSTALLIZE [v]\n",
  "CRYSTALIZABLE": "able to be crystalised, also CRYSTALISABLE, CRYSTALLISABLE, CRYSTALLIZABLE [adj]\n",
  "CRYSTALIZATION": "the process of crystalizing, also CRYSTALISATION, CRYSTALLISATION, CRYSTALLIZATION [n -S]\n",
  "CRYSTALIZATIONS": "CRYSTALIZATION, the process of crystalizing, also CRYSTALISATION, CRYSTALLISATION, CRYSTALLIZATION [n]\n",
  "CRYSTALIZE": "to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALLIZE [v CRYSTALIZED, CRYSTALIZING, CRYSTALIZES]\n",
  "CRYSTALIZED": "CRYSTALIZE, to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALLIZE [v]\n",
  "CRYSTALIZER": "something that crystalizes, also CRYSTALISER, CRYSTALLISER, CRYSTALLIZER [n -S]\n",
  "CRYSTALIZERS": "CRYSTALIZER, something that crystalizes, also CRYSTALISER, CRYSTALLISER, CRYSTALLIZER [n]\n",
  "CRYSTALIZES": "CRYSTALIZE, to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALLIZE [v]\n",
  "CRYSTALIZING": "CRYSTALIZE, to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALLIZE [v]\n",
  "CRYSTALLINE": "strikingly clear or sparkling [adj] / a crystalline substance [n -S]\n",
  "CRYSTALLINES": "CRYSTALLINE, a crystalline substance [n]\n",
  "CRYSTALLINITIES": "CRYSTALLINITY, the quality of being crystalline [n]\n",
  "CRYSTALLINITY": "the quality of being crystalline [n CRYSTALLINITIES]\n",
  "CRYSTALLISABLE": "able to be crystallised, also CRYSTALISABLE, CRYSTALIZABLE, CRYSTALLIZABLE [adj]\n",
  "CRYSTALLISATION": "the process of crystallising, also CRYSTALISATION, CRYSTALIZATION, CRYSTALLIZATION [n]\n",
  "CRYSTALLISE": "to form a crystal, also CRYSTALISE, CRYSTALIZE, CRYSTALLIZE [v CRYSTALLISED, CRYSTALLISING, CRYSTALLISES]\n",
  "CRYSTALLISED": "CRYSTALLISE, to form a crystal, also CRYSTALISE, CRYSTALIZE, CRYSTALLIZE [v]\n",
  "CRYSTALLISER": "an agent that causes crystallisation, also CRYSTALISER, CRYSTALIZER, CRYSTALLIZER [n -S]\n",
  "CRYSTALLISERS": "CRYSTALLISER, an agent that causes crystallisation, also CRYSTALISER, CRYSTALIZER, CRYSTALLIZER [n]\n",
  "CRYSTALLISES": "CRYSTALLISE, to form a crystal, also CRYSTALISE, CRYSTALIZE, CRYSTALLIZE [v]\n",
  "CRYSTALLISING": "CRYSTALLISE, to form a crystal, also CRYSTALISE, CRYSTALIZE, CRYSTALLIZE [v]\n",
  "CRYSTALLITE": "any of the minute rudimentary or imperfect crystals occurring in many glassy rocks [n -S]\n",
  "CRYSTALLITES": "CRYSTALLITE, any of the minute rudimentary or imperfect crystals occurring in many glassy rocks [n]\n",
  "CRYSTALLITIC": "of or like crystallite, any of the minute rudimentary or imperfect crystals occurring in many glassy rocks [adj]\n",
  "CRYSTALLITIS": "inflammation of the crystalline lens [n -ES]\n",
  "CRYSTALLITISES": "CRYSTALLITIS, inflammation of the crystalline lens [n]\n",
  "CRYSTALLIZABLE": "able to be crystallized, also CRYSTALISABLE, CRYSTALIZABLE, CRYSTALLISABLE [adj]\n",
  "CRYSTALLIZATION": "the act of crystallizing, also CRYSTALISATION, CRYSTALIZATION, CRYSTALLISATION [n]\n",
  "CRYSTALLIZE": "to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALIZE [v CRYSTALLIZED, CRYSTALLIZING, CRYSTALLIZES]\n",
  "CRYSTALLIZED": "CRYSTALLIZE, to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALIZE [v]\n",
  "CRYSTALLIZER": "an agent that causes crystallisation, also CRYSTALIZER, CRYSTALLISER, CRYSTALLISER [n -S]\n",
  "CRYSTALLIZERS": "CRYSTALLIZER, an agent that causes crystallisation, also CRYSTALIZER, CRYSTALLISER, CRYSTALLISER [n]\n",
  "CRYSTALLIZES": "CRYSTALLIZE, to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALIZE [v]\n",
  "CRYSTALLIZING": "CRYSTALLIZE, to form a crystal, also CRYSTALISE, CRYSTALLISE, CRYSTALIZE [v]\n",
  "CRYSTALLOGRAPHY": "a science that deals with the forms and structures of crystals [n]\n",
  "CRYSTALLOID": "a water-soluble crystal able to diffuse through semipermeable membranes [n -S]\n",
  "CRYSTALLOIDAL": "of or like a crystalloid [adj]\n",
  "CRYSTALLOIDS": "CRYSTALLOID, a water-soluble crystal able to diffuse through semipermeable membranes [n]\n",
  "CRYSTALLOMANCY": "divination by means of clear objects [n]\n",
  "CRYSTALS": "CRYSTAL, a transparent mineral [n]\n",
  "CSARDAS": "(Hungarian) a Hungarian dance that increases in speed, also CZARDAS [n -ES]\n",
  "CSARDASES": "CSARDAS, (Hungarian) a Hungarian dance that increases in speed, also CZARDAS [n]\n",
  "CTENE": "(Greek) a comblike swimming organ [n -S]\n",
  "CTENES": "CTENE, (Greek) a comblike swimming organ [n]\n",
  "CTENIDIA": "CTENIDIUM, (Greek) a comblike anatomical structure [n]\n",
  "CTENIDIUM": "(Greek) a comblike anatomical structure [n CTENIDIA]\n",
  "CTENIFORM": "comb-shaped [adj]\n",
  "CTENOID": "with comblike edge, e.g. of fish scales [adj]\n",
  "CTENOPHORAN": "a member of the Ctenophora, transparent, free-swimming marine organisms resembling jellyfishes, also CTENOPHORE [n -S]\n",
  "CTENOPHORANS": "CTENOPHORAN, a member of the Ctenophora, transparent, free-swimming marine organisms resembling jellyfishes, also CTENOPHORE [n]\n",
  "CTENOPHORE": "a member of the Ctenophora, transparent, free-swimming marine organisms resembling jellyfishes, also CTENOPHORAN [n -S]\n",
  "CTENOPHORES": "CTENOPHORE, a member of the Ctenophora, transparent, free-swimming marine organisms resembling jellyfishes, also CTENOPHORAN [n]\n",
  "CUADRILLA": "(Spanish) the attendants of a matador [n -S]\n",
  "CUADRILLAS": "CUADRILLA, (Spanish) the attendants of a matador [n]\n",
  "CUATRO": "(Caribbean) a small guitar with four strings [n -S]\n",
  "CUATROS": "CUATRO, (Caribbean) a small guitar with four strings [n]\n",
  "CUB": "to bring forth young [v CUBBED, CUBBING, CUBS]\n",
  "CUBAGE": "the process of finding the cubic content of a body, also CUBATURE [n -S]\n",
  "CUBAGES": "CUBAGE, the process of finding the cubic content of a body, also CUBATURE [n]\n",
  "CUBANE": "a hydrocarbon with CH groups arranged as a cube [n -S]\n",
  "CUBANELLE": "a variety of pepper [n -S]\n",
  "CUBANELLES": "CUBANELLE, a variety of pepper [n]\n",
  "CUBANES": "CUBANE, a hydrocarbon with CH groups arranged as a cube [n]\n",
  "CUBATURE": "the process of finding the cubic content of a body, also CUBAGE [n -S]\n",
  "CUBATURES": "CUBATURE, the process of finding the cubic content of a body, also CUBAGE [n]\n",
  "CUBBED": "CUB, to bring forth young [v]\n",
  "CUBBIER": "CUBBY, plump, squat [adj]\n",
  "CUBBIES": "CUBBY, a snug enclosed space [n]\n",
  "CUBBIEST": "CUBBY, plump, squat [adj]\n",
  "CUBBING": "cub-hunting [n -S]\n",
  "CUBBINGS": "CUBBING, cub-hunting [n]\n",
  "CUBBISH": "like a cub [adj]\n",
  "CUBBISHLY": "CUBBISH, like a cub [adv]\n",
  "CUBBY": "a snug enclosed space [n CUBBIES] / plump, squat [adj CUBBIER, CUBBIEST]\n",
  "CUBBYHOLE": "a small enclosed space or room [n -S]\n",
  "CUBBYHOLES": "CUBBYHOLE, a small enclosed space or room [n]\n",
  "CUBE": "to raise to the third power [v CUBED, CUBING, CUBES]\n",
  "CUBEB": "(Arabic) the pungent berry of a SE Asian shrub of the pepper family, used in medicine and cookery [n -S]\n",
  "CUBEBS": "CUBEB, (Arabic) the pungent berry of a SE Asian shrub of the pepper family, used in medicine and cookery [n]\n",
  "CUBED": "CUBE, to raise to the third power [v]\n",
  "CUBELIKE": "like a cube [adj]\n",
  "CUBER": "a machine for cutting meat etc. into cubes [n -S]\n",
  "CUBERS": "CUBER, a machine for cutting meat etc. into cubes [n]\n",
  "CUBES": "CUBE, to raise to the third power [v]\n",
  "CUBHOOD": "the state of being a cub [n -S]\n",
  "CUBHOODS": "CUBHOOD, the state of being a cub [n]\n",
  "CUBIC": "in the form of a cube [adj CUBICLY or CUBICALLY] / a cubic equation [n -S]\n",
  "CUBICA": "(Spanish) a fine worsted fabric used for linings [n -S]\n",
  "CUBICAL": "shaped like a cube [adj CUBICALLY]\n",
  "CUBICALLY": "CUBICAL, shaped like a cube [adv]\n",
  "CUBICALNESS": "the state of being cubical [n -ES]\n",
  "CUBICALNESSES": "CUBICALNESS, the state of being cubical [n]\n",
  "CUBICAS": "CUBICA, (Spanish) a fine worsted fabric used for linings [n]\n",
  "CUBICITIES": "CUBICITY, the state of being cubic [n]\n",
  "CUBICITY": "the state of being cubic [n CUBICITIES]\n",
  "CUBICLE": "a partially or totally enclosed section of a room, as in a dormitory [n -S]\n",
  "CUBICLES": "CUBICLE, a partially or totally enclosed section of a room, as in a dormitory [n]\n",
  "CUBICLY": "CUBIC, in the form of a cube [adv]\n",
  "CUBICS": "CUBIC, a cubic equation [n]\n",
  "CUBICULA": "CUBICULUM, (Latin) a burial chamber [n]\n",
  "CUBICULUM": "(Latin) a burial chamber [n CUBICULA]\n",
  "CUBIFORM": "shaped like a cube [adj]\n",
  "CUBING": "CUBE, to raise to the third power [v]\n",
  "CUBISM": "an art style [n -S]\n",
  "CUBISMS": "CUBISM, an art style [n]\n",
  "CUBIST": "relating to cubism, a modern movement in painting, also CUBISTIC [adj] / a practitioner of cubism [n -S]\n",
  "CUBISTIC": "relating to cubism, also CUBIST [adj CUBISTICALLY]\n",
  "CUBISTICALLY": "CUBISTIC, relating to cubism, also CUBIST [adv]\n",
  "CUBISTS": "CUBIST, a practitioner of cubism [n]\n",
  "CUBIT": "an old measure of length, also CUBITUS [n -S]\n",
  "CUBITAL": "relating to a cubit [adj]\n",
  "CUBITI": "CUBITUS, an old measure of length, also CUBIT [n]\n",
  "CUBITS": "CUBIT, an old measure of length, also CUBITUS [n]\n",
  "CUBITUS": "an old measure of length, also CUBIT [n CUBITUSES or CUBITI]\n",
  "CUBITUSES": "CUBITUS, an old measure of length, also CUBIT [n]\n",
  "CUBLESS": "without cubs [adj]\n",
  "CUBOID": "cube-shaped, also CUBOIDAL [adj] / a cube-shaped bone [n -S]\n",
  "CUBOIDAL": "relating to a cuboid [adj]\n",
  "CUBOIDS": "CUBOID, a cube-shaped bone [n]\n",
  "CUBS": "CUB, to bring forth young [v]\n",
  "CUCKING": "(historical) as in cucking stool, a kind of ducking stool for witches [adj]\n",
  "CUCKOLD": "a man with an unfaithful wife [n -S] / to humiliate a man by seducing his wife [v -ED, -ING, -S]\n",
  "CUCKOLDED": "CUCKOLD, to humiliate a man by seducing his wife [v]\n",
  "CUCKOLDING": "CUCKOLD, to humiliate a man by seducing his wife [v]\n",
  "CUCKOLDISE": "to make a cuckold of, also CUCKOLDIZE [v CUCKOLDISED, CUCKOLDISING, CUCKOLDISES]\n",
  "CUCKOLDISED": "CUCKOLDISE, to make a cuckold of, also CUCKOLDIZE [v]\n",
  "CUCKOLDISES": "CUCKOLDISE, to make a cuckold of, also CUCKOLDIZE [v]\n",
  "CUCKOLDISING": "CUCKOLDISE, to make a cuckold of, also CUCKOLDIZE [v]\n",
  "CUCKOLDIZE": "to make a cuckold of, also CUCKOLDISE [v CUCKOLDIZED, CUCKOLDIZING, CUCKOLDIZES]\n",
  "CUCKOLDIZED": "CUCKOLDIZE, to make a cuckold of, also CUCKOLDISE [v]\n",
  "CUCKOLDIZES": "CUCKOLDIZE, to make a cuckold of, also CUCKOLDISE [v]\n",
  "CUCKOLDIZING": "CUCKOLDIZE, to make a cuckold of, also CUCKOLDISE [v]\n",
  "CUCKOLDLY": "(Shakespeare) like a cuckold [adj]\n",
  "CUCKOLDOM": "the state of being a cuckold, also CUCKOLDRY [n -S]\n",
  "CUCKOLDOMS": "CUCKOLDOM, the state of being a cuckold, also CUCKOLDRY [n]\n",
  "CUCKOLDRIES": "CUCKOLDRY, the state of being a cuckold, also CUCKOLDOM [n]\n",
  "CUCKOLDRY": "the state of being a cuckold, also CUCKOLDOM [n CUCKOLDRIES]\n",
  "CUCKOLDS": "CUCKOLD, a man with an unfaithful wife [n]\n",
  "CUCKOO": "to repeat monotonously [v -ED, -ING, -S]\n",
  "CUCKOOED": "CUCKOO, to repeat monotonously [v]\n",
  "CUCKOOFLOWER": "a plant commonly found in damp pastures in Europe and America [n -S]\n",
  "CUCKOOFLOWERS": "CUCKOOFLOWER, a plant commonly found in damp pastures in Europe and America [n]\n",
  "CUCKOOING": "CUCKOO, to repeat monotonously [v]\n",
  "CUCKOOPINT": "an arum with erect spathe and short purple spadix [n -S]\n",
  "CUCKOOPINTS": "CUCKOOPINT, an arum with erect spathe and short purple spadix [n]\n",
  "CUCKOOS": "CUCKOO, to repeat monotonously [v]\n",
  "CUCULIFORM": "of, relating to, or belonging to the order Cuculiformes, which includes the cuckoo [adj]\n",
  "CUCULLATE": "hooded; hood-shaped, also CUCULLATED [adj CUCULLATELY]\n",
  "CUCULLATED": "hooded; hood-shaped, also CUCULLATE [adj]\n",
  "CUCULLATELY": "CUCULLATE, hooded; hood-shaped, also CUCULLATED [adv]\n",
  "CUCUMBER": "a garden vegetable, used as a salad vegetable and pickle [n -S]\n",
  "CUCUMBERS": "CUCUMBER, a garden vegetable, used as a salad vegetable and pickle [n]\n",
  "CUCUMIFORM": "cucumber-shaped [adj]\n",
  "CUCURBIT": "a chemical vessel used in a still or alembic [n -S]\n",
  "CUCURBITACEOUS": "resembling a cucumber or a squash [adj]\n",
  "CUCURBITAL": "of or like a cucurbit [adj]\n",
  "CUCURBITS": "CUCURBIT, a chemical vessel used in a still or alembic [n]\n",
  "CUD": "food brought back to be chewed again [n -S]\n",
  "CUDBEAR": "a purple or reddish dyestuff obtained from various lichens [n -S]\n",
  "CUDBEARS": "CUDBEAR, a purple or reddish dyestuff obtained from various lichens [n]\n",
  "CUDDEN": "(Gaelic) a young coalfish, also CUDDIE, CUDDIN, CUDDY [n -S]\n",
  "CUDDENS": "CUDDEN, (Gaelic) a young coalfish, also CUDDIE, CUDDIN, CUDDY [n]\n",
  "CUDDIE": "(Gaelic) a young coalfish, also CUDDEN, CUDDIN, CUDDY [n -S]\n",
  "CUDDIES": "CUDDY, (Scots) a young coalfish, also CUDDEN, CUDDIE, CUDDIN [n]\n",
  "CUDDIN": "(Gaelic) a young coalfish, also CUDDEN, CUDDIE, CUDDY [n -S]\n",
  "CUDDINS": "CUDDIN, (Gaelic) a young coalfish, also CUDDEN, CUDDIE, CUDDY [n]\n",
  "CUDDLE": "to embrace [v CUDDLED, CUDDLING, CUDDLES]\n",
  "CUDDLED": "CUDDLE, to embrace [v]\n",
  "CUDDLER": "one who cuddles [n -S]\n",
  "CUDDLERS": "CUDDLER, one who cuddles [n]\n",
  "CUDDLES": "CUDDLE, to embrace [v]\n",
  "CUDDLESOME": "cuddly [adj]\n",
  "CUDDLIER": "CUDDLY, pleasant to cuddle [adj]\n",
  "CUDDLIEST": "CUDDLY, pleasant to cuddle [adj]\n",
  "CUDDLING": "CUDDLE, to embrace [v]\n",
  "CUDDLY": "pleasant to cuddle [adj CUDDLIER, CUDDLIEST]\n",
  "CUDDY": "(Scots) a young coalfish, also CUDDEN, CUDDIE, CUDDIN [n CUDDIES]\n",
  "CUDGEL": "to beat with a heavy club [v CUDGELED or CUDGELLED, CUDGELING or CUDGELLING, CUDGELS]\n",
  "CUDGELED": "CUDGEL, to beat with a heavy club [v]\n",
  "CUDGELER": "one who cudgels, also CUDGELLER [n -S]\n",
  "CUDGELERS": "CUDGELER, one who cudgels, also CUDGELLER [n]\n",
  "CUDGELING": "the act of beating with a cudgel [n -S]\n",
  "CUDGELINGS": "CUDGELING, the act of beating with a cudgel [n]\n",
  "CUDGELLED": "CUDGEL, to beat with a heavy club [v]\n",
  "CUDGELLER": "one who beats with a cudgel, also CUDGELER [n -S]\n",
  "CUDGELLERS": "CUDGELLER, one who beats with a cudgel, also CUDGELER [n]\n",
  "CUDGELLING": "a beating with a cudgel [n -S]\n",
  "CUDGELLINGS": "CUDGELLING, a beating with a cudgel [n]\n",
  "CUDGELS": "CUDGEL, to beat with a heavy club [v]\n",
  "CUDGERIE": "(Native Australian) a large tropical tree with pink wood [n -S]\n",
  "CUDGERIES": "CUDGERIE, (Native Australian) a large tropical tree with pink wood [n]\n",
  "CUDS": "CUD, food brought back to be chewed again [n]\n",
  "CUDWEED": "a woolly composite plant of the genus Gnaphalium [n -S]\n",
  "CUDWEEDS": "CUDWEED, a woolly composite plant of the genus Gnaphalium [n]\n",
  "CUE": "to prompt an actor [v CUED, CUEING or CUING, CUES]\n",
  "CUED": "CUE, to prompt an actor [v]\n",
  "CUEING": "the act of prompting an actor [n -S]\n",
  "CUEINGS": "CUEING, the act of prompting an actor [n]\n",
  "CUEIST": "a billiard-player [n -S]\n",
  "CUEISTS": "CUEIST, a billiard-player [n]\n",
  "CUES": "CUE, to prompt an actor [v]\n",
  "CUESTA": "(Spanish) a geological feature, gentle slope on one side, cliff on the other [n -S]\n",
  "CUESTAS": "CUESTA, (Spanish) a geological feature, gentle slope on one side, cliff on the other [n]\n",
  "CUFF": "to strike with the open hand [v -ED, -ING, -S]\n",
  "CUFFABLE": "of a sock, intended to be folded down at the ankle [adj]\n",
  "CUFFED": "CUFF, to strike with the open hand [v]\n",
  "CUFFIN": "in thieves' slang, a man [n -S]\n",
  "CUFFING": "CUFF, to strike with the open hand [v]\n",
  "CUFFINS": "CUFFIN, in thieves' slang, a man [n]\n",
  "CUFFLE": "(obsolete) to scuffle [v CUFFLED, CUFFLING, CUFFLES]\n",
  "CUFFLED": "CUFFLE, (obsolete) to scuffle [v]\n",
  "CUFFLES": "CUFFLE, (obsolete) to scuffle [v]\n",
  "CUFFLESS": "without a cuff [adj]\n",
  "CUFFLING": "CUFFLE, (obsolete) to scuffle [v]\n",
  "CUFFLINK": "a small chain used to fasten cuffs [n -S]\n",
  "CUFFLINKS": "CUFFLINK, a small chain used to fasten cuffs [n]\n",
  "CUFFO": "(US slang) without admission charge [adj]\n",
  "CUFFS": "CUFF, to strike with the open hand [v]\n",
  "CUFFUFFLE": "a commotion, also KAFUFFLE [n -S]\n",
  "CUFFUFFLES": "CUFFUFFLE, a commotion, also KAFUFFLE [n]\n",
  "CUIF": "(Scots) a lout, a dolt, also COOF [n -S]\n",
  "CUIFS": "CUIF, (Scots) a lout, a dolt, also COOF [n]\n",
  "CUING": "CUE, to prompt an actor [v]\n",
  "CUIRASS": "to cover with a breastplate [v -ED, -ING, -ES]\n",
  "CUIRASSED": "CUIRASS, to cover with a breastplate [v]\n",
  "CUIRASSES": "CUIRASS, to cover with a breastplate [v]\n",
  "CUIRASSIER": "(French) a soldier who wears a cuirass [n -S]\n",
  "CUIRASSIERS": "CUIRASSIER, (French) a soldier who wears a cuirass [n]\n",
  "CUIRASSING": "CUIRASS, to cover with a breastplate [v]\n",
  "CUISH": "a piece of armour for the thigh, also CUISSE [n -ES]\n",
  "CUISHES": "CUISH, a piece of armour for the thigh, also CUISSE [n]\n",
  "CUISINART": "(tradename) a type of food processor [n -S]\n",
  "CUISINARTS": "CUISINART, (tradename) a type of food processor [n]\n",
  "CUISINE": "(French) cooking [n -S]\n",
  "CUISINES": "CUISINE, (French) cooking [n]\n",
  "CUISINIER": "a cook [n -S]\n",
  "CUISINIERS": "CUISINIER, a cook [n]\n",
  "CUISSE": "a piece of armour for the thigh, also CUISH [n -S]\n",
  "CUISSER": "(Scots) a stallion, also COOSER, CUSSER [n -S]\n",
  "CUISSERS": "CUISSER, (Scots) a stallion, also COOSER, CUSSER [n]\n",
  "CUISSES": "CUISSE, a piece of armour for the thigh, also CUISH [n]\n",
  "CUIT": "(Scots) the ankle [n -S]\n",
  "CUITER": "(Scots) to wheedle; to pamper [v -ED, -ING, -S]\n",
  "CUITERED": "CUITER, (Scots) to wheedle; to pamper [v]\n",
  "CUITERING": "CUITER, (Scots) to wheedle; to pamper [v]\n",
  "CUITERS": "CUITER, (Scots) to wheedle; to pamper [v]\n",
  "CUITIKIN": "(Scots) a gaiter, also COOTIKIN, CUTIKIN [n -S]\n",
  "CUITIKINS": "CUITIKIN, (Scots) a gaiter, also COOTIKIN, CUTIKIN [n]\n",
  "CUITS": "CUIT, (Scots) the ankle [n]\n",
  "CUITTLE": "(Scots) to coax, to cajole [v CUITTLED, CUITTLING, CUITTLES]\n",
  "CUITTLED": "CUITTLE, (Scots) to coax, to cajole [v]\n",
  "CUITTLES": "CUITTLE, (Scots) to coax, to cajole [v]\n",
  "CUITTLING": "CUITTLE, (Scots) to coax, to cajole [v]\n",
  "CUKE": "(slang) a cucumber [n -S]\n",
  "CUKES": "CUKE, (slang) a cucumber [n]\n",
  "CULCH": "the flooring of an oyster-bed, also CULTCH [n -ES]\n",
  "CULCHES": "CULCH, the flooring of an oyster-bed, also CULTCH [n]\n",
  "CULCHIE": "(Irish) rustic, also CULSHIE [adj CULCHIER, CULCHIEST] / a rustic, a country labourer [n -S]\n",
  "CULCHIER": "CULCHIE, (Irish) rustic, also CULSHIE [adj]\n",
  "CULCHIES": "CULCHIE, a rustic, a country labourer [n]\n",
  "CULCHIEST": "CULCHIE, (Irish) rustic, also CULSHIE [adj]\n",
  "CULET": "(French) the flat back or base of a gemstone [n -S]\n",
  "CULETS": "CULET, (French) the flat back or base of a gemstone [n]\n",
  "CULEX": "(Latin) a genus of insects, including the mosquito [n CULICES or CULEXES]\n",
  "CULEXES": "CULEX, (Latin) a genus of insects, including the mosquito [n]\n",
  "CULICES": "CULEX, (Latin) a genus of insects, including the mosquito [n]\n",
  "CULICID": "a mosquito, also CULEX, CULICINE [n -S]\n",
  "CULICIDS": "CULICID, a mosquito, also CULEX, CULICINE [n]\n",
  "CULICIFORM": "like or resembling a mosquito [adj]\n",
  "CULICINE": "a mosquito of a group that contains the genus Culex but not Anopheles [n -S]\n",
  "CULICINES": "CULICINE, a mosquito of a group that contains the genus Culex but not Anopheles [n]\n",
  "CULINARIAN": "a cook, chef [n -S]\n",
  "CULINARIANS": "CULINARIAN, a cook, chef [n]\n",
  "CULINARILY": "CULINARY, pertaining to cookery [adv]\n",
  "CULINARY": "pertaining to cookery [adj CULINARILY]\n",
  "CULL": "to select from others [v -ED, -ING, -S]\n",
  "CULLAY": "the soapbark tree, a rosaceous tree native to Chile, also QUILLAI, QUILLAIA, QUILLAJA [n -S]\n",
  "CULLAYS": "CULLAY, the soapbark tree, a rosaceous tree native to Chile, also QUILLAI, QUILLAIA, QUILLAJA [n]\n",
  "CULLED": "CULL, to select from others [v]\n",
  "CULLENDER": "a perforated vessel used as a strainer in cookery, also COLANDER [n -S]\n",
  "CULLENDERS": "CULLENDER, a perforated vessel used as a strainer in cookery, also COLANDER [n]\n",
  "CULLER": "a person who culls or selects (esp. inferior or surplus items) [n -S]\n",
  "CULLERS": "CULLER, a person who culls or selects (esp. inferior or surplus items) [n]\n",
  "CULLET": "waste glass, melted up again with new material [n -S]\n",
  "CULLETS": "CULLET, waste glass, melted up again with new material [n]\n",
  "CULLIED": "CULLY, to cheat, deceive [v]\n",
  "CULLIES": "CULLY, to cheat, deceive [v]\n",
  "CULLING": "a selection from others [n -S]\n",
  "CULLINGS": "CULLING, a selection from others [n]\n",
  "CULLION": "(archaic) a mean or base person; a rascal [n -S]\n",
  "CULLIONLY": "(archaic) like a cullion, mean, base [adj]\n",
  "CULLIONS": "CULLION, (archaic) a mean or base person; a rascal [n]\n",
  "CULLIS": "a strong broth of meat, fowl, etc., boiled and strained [n -ES]\n",
  "CULLISES": "CULLIS, a strong broth of meat, fowl, etc., boiled and strained [n]\n",
  "CULLS": "CULL, to select from others [v]\n",
  "CULLY": "to cheat, deceive [v CULLIED, CULLYING, CULLIES]\n",
  "CULLYING": "CULLY, to cheat, deceive [v]\n",
  "CULLYISM": "the state of being duped [n -S]\n",
  "CULLYISMS": "CULLYISM, the state of being duped [n]\n",
  "CULM": "the stem of grass or sedge [n -S] / to form a culm [v -ED, -ING, -S]\n",
  "CULMED": "CULM, to form a culm [v]\n",
  "CULMEN": "(Latin) the top ridge of a bird's bill [n CULMINA]\n",
  "CULMIFEROUS": "bearing coaldust [adj]\n",
  "CULMINA": "CULMEN, (Latin) the top ridge of a bird's bill [n]\n",
  "CULMINANT": "at its highest point [adj]\n",
  "CULMINATE": "to climax [v CULMINATED, CULMINATING, CULMINATES]\n",
  "CULMINATED": "CULMINATE, to climax [v]\n",
  "CULMINATES": "CULMINATE, to climax [v]\n",
  "CULMINATING": "CULMINATE, to climax [v]\n",
  "CULMINATION": "the action of culminating [n -S]\n",
  "CULMINATIONS": "CULMINATION, the action of culminating [n]\n",
  "CULMING": "CULM, to form a culm [v]\n",
  "CULMS": "CULM, to form a culm [v]\n",
  "CULOTTE": "(French) a divided skirt [n -S]\n",
  "CULOTTES": "CULOTTE, (French) a divided skirt [n]\n",
  "CULPA": "(Latin) negligence for which one is liable [n CULPAE]\n",
  "CULPABILITIES": "CULPABILITY, the state of being culpable [n]\n",
  "CULPABILITY": "the state of being culpable [n CULPABILITIES]\n",
  "CULPABLE": "blameworthy [adj CULPABLY]\n",
  "CULPABLENESS": "the state of being culpable [n -ES]\n",
  "CULPABLENESSES": "CULPABLENESS, the state of being culpable [n]\n",
  "CULPABLY": "CULPABLE, blameworthy [adv]\n",
  "CULPAE": "CULPA, (Latin) negligence for which one is liable [n]\n",
  "CULPATORY": "expressive of blame [adj]\n",
  "CULPRIT": "one who is guilty [n -S]\n",
  "CULPRITS": "CULPRIT, one who is guilty [n]\n",
  "CULSHIE": "a person from rural Ireland, also CULCHIE [n -S] / rustic, boorish [adj CULSHIER, CULSHIEST]\n",
  "CULSHIER": "CULSHIE, rustic, boorish [adj]\n",
  "CULSHIES": "CULSHIE, a person from rural Ireland, also CULCHIE [n]\n",
  "CULSHIEST": "CULSHIE, rustic, boorish [adj]\n",
  "CULT": "a religious society [n -S]\n",
  "CULTCH": "the flooring of an oyster-bed, also CULCH [n -ES]\n",
  "CULTCHES": "CULTCH, the flooring of an oyster-bed, also CULCH [n]\n",
  "CULTER": "(obsolete) a knife or cutter, attached to the beam of a plow to cut the sward, in advance of the plowshare and moldboard, also COLTER, COULTER [n -S]\n",
  "CULTERS": "CULTER, (obsolete) a knife or cutter, attached to the beam of a plow to cut the sward, in advance of the plowshare and moldboard, also COLTER, COULTER [n]\n",
  "CULTI": "CULTUS, (Latin) a religious ritual; a cult [n]\n",
  "CULTIC": "relating to a cult [adj]\n",
  "CULTIER": "CULTY, intended to appeal to a small group of fashionable people [adj]\n",
  "CULTIEST": "CULTY, intended to appeal to a small group of fashionable people [adj]\n",
  "CULTIGEN": "a variety of plant originating under cultivation, also CULTIVAR [n -S]\n",
  "CULTIGENS": "CULTIGEN, a variety of plant originating under cultivation, also CULTIVAR [n]\n",
  "CULTISH": "having the qualities of a cult [adj CULTISHLY]\n",
  "CULTISHLY": "CULTISH, having the qualities of a cult [adv]\n",
  "CULTISHNESS": "the state of being cultish [n -ES]\n",
  "CULTISHNESSES": "CULTISHNESS, the state of being cultish [n]\n",
  "CULTISM": "devotion to a cult [n -S]\n",
  "CULTISMS": "CULTISM, devotion to a cult [n]\n",
  "CULTIST": "a member of a cult [n -S]\n",
  "CULTISTS": "CULTIST, a member of a cult [n]\n",
  "CULTIVABILITIES": "CULTIVABILITY, the quality of being cultivable [n]\n",
  "CULTIVABILITY": "the quality of being cultivable [n CULTIVABILITIES]\n",
  "CULTIVABLE": "that can be cultivated, also CULTIVATABLE [adj]\n",
  "CULTIVAR": "a variety of plant originating under cultivation, also CULTIGEN [n -S]\n",
  "CULTIVARS": "CULTIVAR, a variety of plant originating under cultivation, also CULTIGEN [n]\n",
  "CULTIVATABLE": "that can be cultivated, also CULTIVABLE [adj]\n",
  "CULTIVATE": "to till or produce by tillage [v CULTIVATED, CULTIVATING, CULTIVATES]\n",
  "CULTIVATED": "CULTIVATE, to till or produce by tillage [v]\n",
  "CULTIVATES": "CULTIVATE, to till or produce by tillage [v]\n",
  "CULTIVATING": "CULTIVATE, to till or produce by tillage [v]\n",
  "CULTIVATION": "the art or practice of cultivating [n -S]\n",
  "CULTIVATIONS": "CULTIVATION, the art or practice of cultivating [n]\n",
  "CULTIVATOR": "one that cultivates [n -S]\n",
  "CULTIVATORS": "CULTIVATOR, one that cultivates [n]\n",
  "CULTLIKE": "like a cult [adj]\n",
  "CULTRATE": "shaped like a knife blade; sharp-edged, also CULTRATED [adj]\n",
  "CULTRATED": "shaped like a knife blade; sharp-edged, also CULTRATE [adj]\n",
  "CULTRIFORM": "knife-shaped [adj]\n",
  "CULTS": "CULT, a religious society [n]\n",
  "CULTURABLE": "that can be cultured [adj]\n",
  "CULTURAL": "relating to culture [adj CULTURALLY]\n",
  "CULTURALLY": "CULTURAL, relating to culture [adv]\n",
  "CULTURATI": "(Latin) cultured people [n]\n",
  "CULTURE": "to cultivate [v CULTURED, CULTURING, CULTURES]\n",
  "CULTURED": "CULTURE, to cultivate [v]\n",
  "CULTURELESS": "without culture [adj]\n",
  "CULTURES": "CULTURE, to cultivate [v]\n",
  "CULTURING": "CULTURE, to cultivate [v]\n",
  "CULTURIST": "a devotee of culture [n -S]\n",
  "CULTURISTS": "CULTURIST, a devotee of culture [n]\n",
  "CULTUS": "(Latin) a religious ritual; a cult [n CULTI or CULTUSES]\n",
  "CULTUSES": "CULTUS, (Latin) a religious ritual; a cult [n]\n",
  "CULTY": "intended to appeal to a small group of fashionable people [adj CULTIER, CULTIEST]\n",
  "CULVER": "a pigeon [n -S]\n",
  "CULVERIN": "a lightweight, portable, long-barrelled cannon [n -S]\n",
  "CULVERINEER": "one who uses a culverin [n -S]\n",
  "CULVERINEERS": "CULVERINEER, one who uses a culverin [n]\n",
  "CULVERINS": "CULVERIN, a lightweight, portable, long-barrelled cannon [n]\n",
  "CULVERS": "CULVER, a pigeon [n]\n",
  "CULVERT": "to channel a stream through an arched construction or channel enclosing a drain or watercourse beneath a road, railway, etc. [v -ED, -ING, -S]\n",
  "CULVERTAGE": "(historical) the degradation of a peasant to the position of a serf [n -S]\n",
  "CULVERTAGES": "CULVERTAGE, (historical) the degradation of a peasant to the position of a serf [n]\n",
  "CULVERTAILED": "having a tail like a culver, a dove [adj]\n",
  "CULVERTED": "CULVERT, to channel a stream through an arched construction or channel enclosing a drain or watercourse beneath a road, railway, etc. [v]\n",
  "CULVERTING": "CULVERT, to channel a stream through an arched construction or channel enclosing a drain or watercourse beneath a road, railway, etc. [v]\n",
  "CULVERTS": "CULVERT, to channel a stream through an arched construction or channel enclosing a drain or watercourse beneath a road, railway, etc. [v]\n",
  "CUM": "(vulgar) to ejaculate sperm [v CUMMED, CUMMING, CUMS]\n",
  "CUMACEAN": "a small crustacean living on the seabed [n -S]\n",
  "CUMACEANS": "CUMACEAN, a small crustacean living on the seabed [n]\n",
  "CUMARIC": "of coumarin, also COUMARIC [adj]\n",
  "CUMARIN": "(Tupi) a crystalline compound obtained from Tonka beans, woodruff, melilot, etc, used medicinally to prevent coagulation of the blood, also COUMARIN [n -S]\n",
  "CUMARINS": "CUMARIN, (Tupi) a crystalline compound obtained from Tonka beans, woodruff, melilot, etc, used medicinally to prevent coagulation of the blood, also COUMARIN [n]\n",
  "CUMARONE": "a liquid derived from coal tar, also COUMARONE [n -S]\n",
  "CUMARONES": "CUMARONE, a liquid derived from coal tar, also COUMARONE [n]\n",
  "CUMBENT": "reclining [adj]\n",
  "CUMBER": "to burden [v -ED, -ING, -S]\n",
  "CUMBERBUND": "(Hindi) a waistband, a sash, also CUMMERBUND, KUMMERBUND [n -S]\n",
  "CUMBERBUNDS": "CUMBERBUND, (Hindi) a waistband, a sash, also CUMMERBUND, KUMMERBUND [n]\n",
  "CUMBERED": "CUMBER, to burden [v]\n",
  "CUMBERER": "one who cumbers [n -S]\n",
  "CUMBERERS": "CUMBERER, one who cumbers [n]\n",
  "CUMBERING": "CUMBER, to burden [v]\n",
  "CUMBERLESS": "unencumbered [adj]\n",
  "CUMBERMENT": "the act of encumbering [n -S]\n",
  "CUMBERMENTS": "CUMBERMENT, the act of encumbering [n]\n",
  "CUMBERS": "CUMBER, to burden [v]\n",
  "CUMBERSOME": "burdensome [adj CUMBERSOMELY]\n",
  "CUMBERSOMELY": "CUMBERSOME, burdensome [adv]\n",
  "CUMBERSOMENESS": "CUMBERSOME, burdensome [n]\n",
  "CUMBIA": "a Columbian style of music [n -S]\n",
  "CUMBIAS": "CUMBIA, a Columbian style of music [n]\n",
  "CUMBRANCE": "an encumbrance [n -S]\n",
  "CUMBRANCES": "CUMBRANCE, an encumbrance [n]\n",
  "CUMBROUS": "hindering, obstructing [adj CUMBROUSLY]\n",
  "CUMBROUSLY": "CUMBROUS, hindering, obstructing [adv]\n",
  "CUMBROUSNESS": "the state of being cumbrous [n -ES]\n",
  "CUMBROUSNESSES": "CUMBROUSNESS, the state of being cumbrous [n]\n",
  "CUMBUNGI": "(Native Australian) a tall Australian marsh plant [n -S]\n",
  "CUMBUNGIS": "CUMBUNGI, (Native Australian) a tall Australian marsh plant [n]\n",
  "CUMEC": "a unit of liquid flow equal to one cubic metre per second [n -S]\n",
  "CUMECS": "CUMEC, a unit of liquid flow equal to one cubic metre per second [n]\n",
  "CUMIN": "an umbelliferous plant of the Mediterranean region with seeds like caraway, also CUMMIN [n -S]\n",
  "CUMINS": "CUMIN, an umbelliferous plant of the Mediterranean region with seeds like caraway, also CUMMIN [n]\n",
  "CUMMED": "CUM, (vulgar) to ejaculate sperm [v]\n",
  "CUMMER": "(Scots) a woman, a girl, also KIMMER [n -S]\n",
  "CUMMERBUND": "(Hindi) a waistband, a sash, also CUMBERBUND, KUMMERBUND [n -S]\n",
  "CUMMERBUNDS": "CUMMERBUND, (Hindi) a waistband, a sash, also CUMBERBUND, KUMMERBUND [n]\n",
  "CUMMERS": "CUMMER, (Scots) a woman, a girl, also KIMMER [n]\n",
  "CUMMIN": "an umbelliferous plant of the Mediterranean region with seeds like caraway, also CUMIN [n -S]\n",
  "CUMMING": "CUM, (vulgar) to ejaculate sperm [v]\n",
  "CUMMINGTONITE": "a mineral of the amphibole group, hydrated magnesium iron silicate [n -S]\n",
  "CUMMINGTONITES": "CUMMINGTONITE, a mineral of the amphibole group, hydrated magnesium iron silicate [n]\n",
  "CUMMINS": "CUMMIN, an umbelliferous plant of the Mediterranean region with seeds like caraway, also CUMIN [n]\n",
  "CUMQUAT": "(Chinese) any of several small yellow to orange citrus fruits, also KUMQUAT [n -S]\n",
  "CUMQUATS": "CUMQUAT, (Chinese) any of several small yellow to orange citrus fruits, also KUMQUAT [n]\n",
  "CUMS": "CUM, (vulgar) to ejaculate sperm [v]\n",
  "CUMSHAW": "(Chinese) a present, gratuity; a bribe [n -S]\n",
  "CUMSHAWS": "CUMSHAW, (Chinese) a present, gratuity; a bribe [n]\n",
  "CUMULATE": "in a heap [adj CUMULATELY] / to heap together, to accumulate [v CUMULATED, CUMULATING, CUMULATES]\n",
  "CUMULATED": "CUMULATE, to heap together, to accumulate [v]\n",
  "CUMULATELY": "CUMULATE, in a heap [adv]\n",
  "CUMULATES": "CUMULATE, to heap together, to accumulate [v]\n",
  "CUMULATING": "CUMULATE, to heap together, to accumulate [v]\n",
  "CUMULATION": "an accumulation [n -S]\n",
  "CUMULATIONS": "CUMULATION, an accumulation [n]\n",
  "CUMULATIVE": "increasing by successive additions [adj CUMULATIVELY]\n",
  "CUMULATIVELY": "CUMULATIVE, increasing by successive additions [adv]\n",
  "CUMULATIVENESS": "CUMULATIVE, increasing by successive additions [n]\n",
  "CUMULET": "a variety of domestic fancy pigeon [n -S]\n",
  "CUMULETS": "CUMULET, a variety of domestic fancy pigeon [n]\n",
  "CUMULI": "CUMULUS, (Latin) a kind of cloud [n]\n",
  "CUMULIFORM": "shaped like a heap, esp. of a cloud [adj]\n",
  "CUMULOCIRRI": "CUMULOCIRRUS, a type of cloud [n]\n",
  "CUMULOCIRRUS": "a type of cloud [n CUMULOCIRRI]\n",
  "CUMULONIMBI": "CUMULONIMBUS, a type of cloud [n]\n",
  "CUMULONIMBUS": "a type of cloud [n CUMULONIMBI or CUMULONIMBUSES]\n",
  "CUMULONIMBUSES": "CUMULONIMBUS, a type of cloud [n]\n",
  "CUMULOSE": "pertaining to clouds [adj]\n",
  "CUMULOSTRATI": "CUMULOSTRATUS, a type of cloud [n]\n",
  "CUMULOSTRATUS": "a type of cloud [n CUMULOSTRATI]\n",
  "CUMULOUS": "like cumulus, a kind of cloud [adj]\n",
  "CUMULUS": "(Latin) a kind of cloud [n CUMULI or CUMULUSES]\n",
  "CUMULUSES": "CUMULUS, (Latin) a kind of cloud [n]\n",
  "CUNABULA": "(Latin) the extant copies of the first printed books [n]\n",
  "CUNCTATION": "delay; procrastination [n -S]\n",
  "CUNCTATIONS": "CUNCTATION, delay; procrastination [n]\n",
  "CUNCTATIOUS": "causing delay, also CUNCTATIVE, CUNCTATORY [adj]\n",
  "CUNCTATIVE": "causing delay, also CUNCTATIOUS, CUNCTATORY [adj]\n",
  "CUNCTATOR": "(Latin) someone who delays or procrastinates [n -S]\n",
  "CUNCTATORS": "CUNCTATOR, (Latin) someone who delays or procrastinates [n]\n",
  "CUNCTATORY": "causing delay, also CUNCTATIOUS, CUNCTATIVE [adj]\n",
  "CUNDIES": "CUNDY, a covered drain, also CONDIE [n]\n",
  "CUNDUM": "a condom [n -S]\n",
  "CUNDUMS": "CUNDUM, a condom [n]\n",
  "CUNDY": "a covered drain, also CONDIE [n CUNDIES]\n",
  "CUNEAL": "wedge-shaped, also CUNEATE, CUNEATED, CUNEATIC [adj]\n",
  "CUNEATE": "wedge-shaped, also CUNEAL, CUNEATED, CUNEATIC [adj CUNEATELY]\n",
  "CUNEATED": "wedge-shaped, also CUNEAL, CUNEATE, CUNEATIC [adj]\n",
  "CUNEATELY": "CUNEATE, wedge-shaped, also CUNEAL, CUNEATED, CUNEATIC [adv]\n",
  "CUNEATIC": "wedge-shaped, also CUNEAL, CUNEATE, CUNEATED [adj]\n",
  "CUNEI": "CUNEUS, a small wedge-shaped structure in the cerebral cortex [n]\n",
  "CUNEIFORM": "a wedge-shaped script, also CUNIFORM [n -S]\n",
  "CUNEIFORMS": "CUNEIFORM, a wedge-shaped script, also CUNIFORM [n]\n",
  "CUNETTE": "(French) a trench sunk along the middle of a dry ditch or moat, serving as a drain, also CUVETTE [n -S]\n",
  "CUNETTES": "CUNETTE, (French) a trench sunk along the middle of a dry ditch or moat, serving as a drain, also CUVETTE [n]\n",
  "CUNEUS": "a small wedge-shaped structure in the cerebral cortex [n CUNEI]\n",
  "CUNIFORM": "a wedge-shaped script, also CUNEIFORM [n -S]\n",
  "CUNIFORMS": "CUNIFORM, a wedge-shaped script, also CUNEIFORM [n]\n",
  "CUNIT": "one hundred cubic feet [n -S]\n",
  "CUNITS": "CUNIT, one hundred cubic feet [n]\n",
  "CUNJEVOI": "(Native Australian) a kind of sea squirt found on Australian reefs and rocks and used as bait [n -S]\n",
  "CUNJEVOIS": "CUNJEVOI, (Native Australian) a kind of sea squirt found on Australian reefs and rocks and used as bait [n]\n",
  "CUNNER": "a kind of wrasse, aka goldsinny, also CONNER, CONNOR [n -S]\n",
  "CUNNERS": "CUNNER, a kind of wrasse, aka goldsinny, also CONNER, CONNOR [n]\n",
  "CUNNILINCTUS": "oral stimulation of clitoris or vulva, also CUNNILINGUS [n -ES]\n",
  "CUNNILINCTUSES": "CUNNILINCTUS, oral stimulation of clitoris or vulva, also CUNNILINGUS [n]\n",
  "CUNNILINGUS": "oral stimulation of the clitoris or vulva, also CUNNILINCTUS [n -ES]\n",
  "CUNNILINGUSES": "CUNNILINGUS, oral stimulation of the clitoris or vulva, also CUNNILINCTUS [n]\n",
  "CUNNING": "skill in deception [n -S] / crafty [adj CUNNINGER, CUNNINGEST]\n",
  "CUNNINGER": "CUNNING, crafty [adj]\n",
  "CUNNINGEST": "CUNNING, crafty [adj]\n",
  "CUNNINGLY": "CUNNING, crafty [adv]\n",
  "CUNNINGNESS": "the state of being cunning [n -ES]\n",
  "CUNNINGNESSES": "CUNNINGNESS, the state of being cunning [n]\n",
  "CUNNINGS": "CUNNING, skill in deception [n]\n",
  "CUNT": "(offensive slang) a taboo word for the female pudendum [n -S]\n",
  "CUNTS": "CUNT, (offensive slang) a taboo word for the female pudendum [n]\n",
  "CUP": "to put into a small, open container [v CUPPED, CUPPING, CUPS]\n",
  "CUPBEARER": "a person who attends at a feast to fill and hand out wine cups [n -S]\n",
  "CUPBEARERS": "CUPBEARER, a person who attends at a feast to fill and hand out wine cups [n]\n",
  "CUPBOARD": "an item of furniture or a recess fitted with a door, used for storage [n -S] / to store [v -ED, -ING, -S]\n",
  "CUPBOARDED": "CUPBOARD, to store [v]\n",
  "CUPBOARDING": "CUPBOARD, to store [v]\n",
  "CUPBOARDS": "CUPBOARD, to store [v]\n",
  "CUPCAKE": "a small round cake baked in a case [n -S]\n",
  "CUPCAKES": "CUPCAKE, a small round cake baked in a case [n]\n",
  "CUPEL": "to refine gold or silver in a small vessel [v CUPELED or CUPELLED, CUPELING or CUPELLING, CUPELS]\n",
  "CUPELED": "CUPEL, to refine gold or silver in a small vessel [v]\n",
  "CUPELER": "one who assays in a cupel, also CUPELLER [n -S]\n",
  "CUPELERS": "CUPELER, one who assays in a cupel, also CUPELLER [n]\n",
  "CUPELING": "CUPEL, to refine gold or silver in a small vessel [v]\n",
  "CUPELLATION": "assaying or refining using a cupel; the separation of silver from lead in this way [n -S]\n",
  "CUPELLATIONS": "CUPELLATION, assaying or refining using a cupel; the separation of silver from lead in this way [n]\n",
  "CUPELLED": "CUPEL, to refine gold or silver in a small vessel [v]\n",
  "CUPELLER": "someone who cupels, also CUPELER [n -S]\n",
  "CUPELLERS": "CUPELLER, someone who cupels, also CUPELER [n]\n",
  "CUPELLING": "CUPEL, to refine gold or silver in a small vessel [v]\n",
  "CUPELS": "CUPEL, to refine gold or silver in a small vessel [v]\n",
  "CUPFERRON": "a compound used in chemical analysis [n -S]\n",
  "CUPFERRONS": "CUPFERRON, a compound used in chemical analysis [n]\n",
  "CUPFUL": "as much as a cup can hold [n CUPFULS or CUPSFUL]\n",
  "CUPFULS": "CUPFUL, as much as a cup can hold [n]\n",
  "CUPGALL": "a cup-shaped gall in oakleaves [n -S]\n",
  "CUPGALLS": "CUPGALL, a cup-shaped gall in oakleaves [n]\n",
  "CUPHEAD": "a hemispherical bolthead [n -S]\n",
  "CUPHEADS": "CUPHEAD, a hemispherical bolthead [n]\n",
  "CUPHOLDER": "a device for holding a plastic cup or other drinking container [n -S]\n",
  "CUPHOLDERS": "CUPHOLDER, a device for holding a plastic cup or other drinking container [n]\n",
  "CUPID": "a statue of the Roman god of love [n -S]\n",
  "CUPIDINOUS": "full of desire, amorous [adj]\n",
  "CUPIDITIES": "CUPIDITY, avarice, greed [n]\n",
  "CUPIDITY": "avarice, greed [n CUPIDITIES]\n",
  "CUPIDS": "CUPID, a statue of the Roman god of love [n]\n",
  "CUPLIKE": "like a cup [adj]\n",
  "CUPMAN": "a boon companion [n CUPMEN]\n",
  "CUPMEN": "CUPMAN, a boon companion [n]\n",
  "CUPOLA": "(Italian) a spherical vault or concave ceiling [n -S] / to furnish with a cupola [v -ED, -ING, -S]\n",
  "CUPOLAED": "CUPOLA, to furnish with a cupola [v]\n",
  "CUPOLAING": "CUPOLA, to furnish with a cupola [v]\n",
  "CUPOLAR": "pertaining to a spherical vault [adj]\n",
  "CUPOLAS": "CUPOLA, to furnish with a cupola [v]\n",
  "CUPOLATED": "furnished with a cupola [adj]\n",
  "CUPPA": "(colloquial) a cup (esp. of tea) [n -S]\n",
  "CUPPAS": "CUPPA, (colloquial) a cup (esp. of tea) [n]\n",
  "CUPPED": "CUP, to put into a small, open container [v]\n",
  "CUPPER": "a cupbearer [n -S]\n",
  "CUPPERS": "CUPPER, a cupbearer [n]\n",
  "CUPPIER": "CUPPY, cuplike [adj]\n",
  "CUPPIEST": "CUPPY, cuplike [adj]\n",
  "CUPPING": "in medicine, the application of cups from which the air has been withdrawn in order to bring the blood to the surface of the skin [n -S]\n",
  "CUPPINGS": "CUPPING, in medicine, the application of cups from which the air has been withdrawn in order to bring the blood to the surface of the skin [n]\n",
  "CUPPY": "cuplike [adj CUPPIER, CUPPIEST]\n",
  "CUPRAMMONIUM": "a solution of cupric hydroxide in ammonia [n -S]\n",
  "CUPRAMMONIUMS": "CUPRAMMONIUM, a solution of cupric hydroxide in ammonia [n]\n",
  "CUPREOUS": "containing copper [adj]\n",
  "CUPRESSUS": "any tree of the genus Cupressus [n -ES]\n",
  "CUPRESSUSES": "CUPRESSUS, any tree of the genus Cupressus [n]\n",
  "CUPRIC": "containing bivalent copper [adj]\n",
  "CUPRIFEROUS": "bearing copper [adj]\n",
  "CUPRITE": "the ore of copper [n -S]\n",
  "CUPRITES": "CUPRITE, the ore of copper [n]\n",
  "CUPRONICKEL": "an alloy of copper and nickel [n -S]\n",
  "CUPRONICKELS": "CUPRONICKEL, an alloy of copper and nickel [n]\n",
  "CUPROUS": "containing univalent copper [adj]\n",
  "CUPRUM": "(Latin) copper [n -S]\n",
  "CUPRUMS": "CUPRUM, (Latin) copper [n]\n",
  "CUPS": "CUP, to put into a small, open container [v]\n",
  "CUPSFUL": "CUPFUL, as much as a cup can hold [n]\n",
  "CUPULA": "(Latin) a cup-shaped anatomical structure, also CUPULE [n CUPULAE]\n",
  "CUPULAE": "CUPULA, (Latin) a cup-shaped anatomical structure, also CUPULE [n]\n",
  "CUPULAR": "cup-shaped, also CUPULATE [adj]\n",
  "CUPULATE": "cup-shaped, also CUPULAR [adj]\n",
  "CUPULE": "a cup-shaped anatomical structure, also CUPULA [n -S]\n",
  "CUPULES": "CUPULE, a cup-shaped anatomical structure, also CUPULA [n]\n",
  "CUPULIFEROUS": "bearing cupules [adj]\n",
  "CUR": "a worthless mongrel dog, also KURRE [n -S]\n",
  "CURABILITIES": "CURABILITY, the ability to be cured [n]\n",
  "CURABILITY": "the ability to be cured [n CURABILITIES]\n",
  "CURABLE": "able to be cured [adj CURABLY]\n",
  "CURABLENESS": "the ability to be cured [n -ES]\n",
  "CURABLENESSES": "CURABLENESS, the ability to be cured [n]\n",
  "CURABLY": "CURABLE, able to be cured [adv]\n",
  "CURACAO": "a type of liqueur, also CURACOA [n -S]\n",
  "CURACAOS": "CURACAO, a type of liqueur, also CURACOA [n]\n",
  "CURACIES": "CURACY, the office of a curate [n]\n",
  "CURACOA": "a type of liqueur, also CURACAO [n -S]\n",
  "CURACOAS": "CURACOA, a type of liqueur, also CURACAO [n]\n",
  "CURACY": "the office of a curate [n CURACIES]\n",
  "CURAGH": "(Irish) a long-shaped boat similar to a coracle, also CURRACH, CURRAGH [n -S]\n",
  "CURAGHS": "CURAGH, (Irish) a long-shaped boat similar to a coracle, also CURRACH, CURRAGH [n]\n",
  "CURANDERA": "a female faith healer [n -S]\n",
  "CURANDERAS": "CURANDERA, a female faith healer [n]\n",
  "CURANDERO": "a male faith healer [n -S]\n",
  "CURANDEROS": "CURANDERO, a male faith healer [n]\n",
  "CURARA": "(Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARE, CURARI, URARE [n -S]\n",
  "CURARAS": "CURARA, (Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARE, CURARI, URARE [n]\n",
  "CURARE": "(Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARA, CURARI, URARE [n -S]\n",
  "CURARES": "CURARE, (Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARA, CURARI, URARE [n]\n",
  "CURARI": "(Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARA, CURARE, URARE [n -S]\n",
  "CURARINE": "an alkaloid derivative of curare [n -S]\n",
  "CURARINES": "CURARINE, an alkaloid derivative of curare [n]\n",
  "CURARIS": "CURARI, (Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARA, CURARE, URARE [n]\n",
  "CURARISATION": "the process of curarising, also CURARIZATION [n -S]\n",
  "CURARISATIONS": "CURARISATION, the process of curarising, also CURARIZATION [n]\n",
  "CURARISE": "to poison with curare, also CURARIZE [v CURARISED, CURARISING, CURARISES]\n",
  "CURARISED": "CURARISE, to poison with curare, also CURARIZE [v]\n",
  "CURARISES": "CURARISE, to poison with curare, also CURARIZE [v]\n",
  "CURARISING": "CURARISE, to poison with curare, also CURARIZE [v]\n",
  "CURARIZATION": "the process of curarizing, also CURARISATION [n -S]\n",
  "CURARIZATIONS": "CURARIZATION, the process of curarizing, also CURARISATION [n]\n",
  "CURARIZE": "to poison with curare, also CURARISE [v CURARIZED, CURARIZING, CURARIZES]\n",
  "CURARIZED": "CURARIZE, to poison with curare, also CURARISE [v]\n",
  "CURARIZES": "CURARIZE, to poison with curare, also CURARISE [v]\n",
  "CURARIZING": "CURARIZE, to poison with curare, also CURARISE [v]\n",
  "CURASSOW": "a turkey-like bird, also CARASSOW [n -S]\n",
  "CURASSOWS": "CURASSOW, a turkey-like bird, also CARASSOW [n]\n",
  "CURAT": "(obsolete) a cuirass, also CURIET [n -S]\n",
  "CURATE": "to act as a curator [v CURATED, CURATING, CURATES]\n",
  "CURATED": "CURATE, to act as a curator [v]\n",
  "CURATES": "CURATE, to act as a curator [v]\n",
  "CURATESHIP": "the office of curate [n -S]\n",
  "CURATESHIPS": "CURATESHIP, the office of curate [n]\n",
  "CURATING": "CURATE, to act as a curator [v]\n",
  "CURATION": "the work of a curator [n -S]\n",
  "CURATIONS": "CURATION, the work of a curator [n]\n",
  "CURATIVE": "tending to cure, also CURATORY [adj CURATIVELY] / something tending to cure [n -S]\n",
  "CURATIVELY": "CURATIVE, tending to cure, also CURATORY [adv]\n",
  "CURATIVENESS": "the property of being curative [n -ES]\n",
  "CURATIVENESSES": "CURATIVENESS, the property of being curative [n]\n",
  "CURATIVES": "CURATIVE, something tending to cure [n]\n",
  "CURATOR": "(Latin) a person who has the charge of anything; a superintendent, esp. of a museum [n -S]\n",
  "CURATORIAL": "relating to a curator [adj]\n",
  "CURATORS": "CURATOR, (Latin) a person who has the charge of anything; a superintendent, esp. of a museum [n]\n",
  "CURATORSHIP": "the office of curator [n -S]\n",
  "CURATORSHIPS": "CURATORSHIP, the office of curator [n]\n",
  "CURATORY": "tending to cure [adj]\n",
  "CURATRIX": "(Latin) a female curator [n -ES]\n",
  "CURATRIXES": "CURATRIX, (Latin) a female curator [n]\n",
  "CURATS": "CURAT, (obsolete) a cuirass, also CURIET [n]\n",
  "CURB": "to restrain [v -ED, -ING, -S]\n",
  "CURBABLE": "able to be curbed [adj]\n",
  "CURBED": "CURB, to restrain [v]\n",
  "CURBER": "one who curbs [n -S]\n",
  "CURBERS": "CURBER, one who curbs [n]\n",
  "CURBING": "a concrete border along the street, also KERBING [n -S]\n",
  "CURBINGS": "CURBING, a concrete border along the street, also KERBING [n]\n",
  "CURBLESS": "without a curb [adj]\n",
  "CURBS": "CURB, to restrain [v]\n",
  "CURBSIDE": "the side of a pavement bordered by a curb, also KERBSIDE [n -S]\n",
  "CURBSIDES": "CURBSIDE, the side of a pavement bordered by a curb, also KERBSIDE [n]\n",
  "CURBSTONE": "a stone lining a curb, also KERBSTONE [n -S]\n",
  "CURBSTONES": "CURBSTONE, a stone lining a curb, also KERBSTONE [n]\n",
  "CURCH": "(Scots) a covering for the head, a kerchief, also CURCHEF [n -ES]\n",
  "CURCHEF": "a covering for the head, a kerchief, also CURCH [n -S]\n",
  "CURCHEFS": "CURCHEF, a covering for the head, a kerchief, also CURCH [n]\n",
  "CURCHES": "CURCH, (Scots) a covering for the head, a kerchief, also CURCHEF [n]\n",
  "CURCULIO": "(Latin) a kind of weevil [n -S]\n",
  "CURCULIOS": "CURCULIO, (Latin) a kind of weevil [n]\n",
  "CURCUMA": "(Arabic) any plant of the genus Curcuma (of the ginger family), esp. one yielding turmeric [n -S]\n",
  "CURCUMAS": "CURCUMA, (Arabic) any plant of the genus Curcuma (of the ginger family), esp. one yielding turmeric [n]\n",
  "CURCUMIN": "the saffron-yellow colouring matter of turmeric, used esp. in food colouring, also CURCUMINE [n -S]\n",
  "CURCUMINE": "the saffron-yellow colouring matter of turmeric, used esp. in food colouring, also CURCUMIN [n -S]\n",
  "CURCUMINES": "CURCUMINE, the saffron-yellow colouring matter of turmeric, used esp. in food colouring, also CURCUMIN [n]\n",
  "CURCUMINS": "CURCUMIN, the saffron-yellow colouring matter of turmeric, used esp. in food colouring, also CURCUMINE [n]\n",
  "CURD": "to curdle [v -ED, -ING, -S]\n",
  "CURDED": "CURD, to curdle [v]\n",
  "CURDIER": "CURDY, having the texture of curds [adj]\n",
  "CURDIEST": "CURDY, having the texture of curds [adj]\n",
  "CURDINESS": "the state of being curdy [n -ES]\n",
  "CURDINESSES": "CURDINESS, the state of being curdy [n]\n",
  "CURDING": "CURD, to curdle [v]\n",
  "CURDLE": "to congeal, also CRUDDLE [v CURDLED, CURDLING, CURDLES]\n",
  "CURDLED": "CURDLE, to congeal, also CRUDDLE [v]\n",
  "CURDLER": "something or someone that curdles [n -S]\n",
  "CURDLERS": "CURDLER, something or someone that curdles [n]\n",
  "CURDLES": "CURDLE, to congeal, also CRUDDLE [v]\n",
  "CURDLING": "CURDLE, to congeal, also CRUDDLE [v]\n",
  "CURDS": "CURD, to curdle [v]\n",
  "CURDY": "having the texture of curds [adj CURDIER, CURDIEST]\n",
  "CURE": "to restore to health [v CURED, CURING, CURES]\n",
  "CURED": "CURE, to restore to health [v]\n",
  "CURELESS": "not curable [adj]\n",
  "CURER": "one who cures [n -S]\n",
  "CURERS": "CURER, one who cures [n]\n",
  "CURES": "CURE, to restore to health [v]\n",
  "CURET": "(US) a surgical instrument used for scraping, also CURETTE [n -S]\n",
  "CURETS": "CURET, (US) a surgical instrument used for scraping, also CURETTE [n]\n",
  "CURETTAGE": "(French) the act of using a curette [n -S]\n",
  "CURETTAGES": "CURETTAGE, (French) the act of using a curette [n]\n",
  "CURETTE": "(French) to scrape with a surgical instrument, also CURET [v CURETTED, CURETTING, CURETTES]\n",
  "CURETTED": "CURETTE, (French) to scrape with a surgical instrument, also CURET [v]\n",
  "CURETTEMENT": "the act of curetting [n -S]\n",
  "CURETTEMENTS": "CURETTEMENT, the act of curetting [n]\n",
  "CURETTES": "CURETTE, (French) to scrape with a surgical instrument, also CURET [v]\n",
  "CURETTING": "CURETTE, (French) to scrape with a surgical instrument, also CURET [v]\n",
  "CURF": "an incision made by a cutting tool, also KERF [n -S]\n",
  "CURFEW": "an imposed time-limit [n -S]\n",
  "CURFEWS": "CURFEW, an imposed time-limit [n]\n",
  "CURFS": "CURF, an incision made by a cutting tool, also KERF [n]\n",
  "CURFUFFLE": "(Scots) to make a commotion, also CARFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v CURFUFFLED, CURFUFFLING, CURFUFFLES]\n",
  "CURFUFFLED": "CURFUFFLE, (Scots) to make a commotion, also CARFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "CURFUFFLES": "CURFUFFLE [n]\n",
  "CURFUFFLING": "CURFUFFLE, (Scots) to make a commotion, also CARFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "CURIA": "(Latin) a court of justice [n CURIAS or CURIAE]\n",
  "CURIAE": "CURIA, (Latin) a court of justice [n]\n",
  "CURIAL": "relating to a curia, a papal court and its officials [adj]\n",
  "CURIALISM": "the system of government of curia [n -S]\n",
  "CURIALISMS": "CURIALISM, the system of government of curia [n]\n",
  "CURIALIST": "one who advocates curialism, the system of government of curia [n -S]\n",
  "CURIALISTIC": "relating to curialism [adj]\n",
  "CURIALISTS": "CURIALIST, one who advocates curialism, the system of government of curia [n]\n",
  "CURIAS": "CURIA, (Latin) a court of justice [n]\n",
  "CURIE": "a unit of radioactive decay and intensity [n -S]\n",
  "CURIES": "CURIE, a unit of radioactive decay and intensity [n]\n",
  "CURIET": "(obsolete) a cuirass, also CURAT [n -S]\n",
  "CURIETHERAPIES": "CURIETHERAPY, a former name for the treatment of disease by radium [n]\n",
  "CURIETHERAPY": "a former name for the treatment of disease by radium [n CURIETHERAPIES]\n",
  "CURIETS": "CURIET, (obsolete) a cuirass, also CURAT [n]\n",
  "CURING": "the act of performing a cure [n -S]\n",
  "CURINGS": "CURING, the act of performing a cure [n]\n",
  "CURIO": "an unusual art object [n -S]\n",
  "CURIOS": "CURIO, an unusual art object [n]\n",
  "CURIOSA": "(Latin) rare and curious books [n]\n",
  "CURIOSITIES": "CURIOSITY, the state of being curious [n]\n",
  "CURIOSITY": "the state of being curious [n CURIOSITIES]\n",
  "CURIOUS": "inquisitive [adj CURIOUSER, CURIOUSEST, CURIOUSLY]\n",
  "CURIOUSER": "CURIOUS, inquisitive [adj]\n",
  "CURIOUSEST": "CURIOUS, inquisitive [adj]\n",
  "CURIOUSLY": "CURIOUS, inquisitive [adv]\n",
  "CURIOUSNESS": "the state of being curious [n -ES]\n",
  "CURIOUSNESSES": "CURIOUSNESS, the state of being curious [n]\n",
  "CURITE": "a radioactive mineral [n -S]\n",
  "CURITES": "CURITE, a radioactive mineral [n]\n",
  "CURIUM": "a radioactive element [n -S]\n",
  "CURIUMS": "CURIUM, a radioactive element [n]\n",
  "CURL": "to form into ringlets [v -ED, -ING, -S]\n",
  "CURLED": "CURL, to form into ringlets [v]\n",
  "CURLER": "one that curls [n -S]\n",
  "CURLERS": "CURLER, one that curls [n]\n",
  "CURLEW": "a wading bird of the woodcock family [n -S]\n",
  "CURLEWS": "CURLEW, a wading bird of the woodcock family [n]\n",
  "CURLI": "curled hairlike processes on the Escherichia coli bacteria [n]\n",
  "CURLICUE": "to decorate with fancy spiral figures, also CURLYCUE [v CURLICUED, CURLICUING, CURLICUES]\n",
  "CURLICUED": "CURLICUE, to decorate with fancy spiral figures, also CURLYCUE [v]\n",
  "CURLICUES": "CURLICUE, to decorate with fancy spiral figures, also CURLYCUE [v]\n",
  "CURLICUING": "CURLICUE, to decorate with fancy spiral figures, also CURLYCUE [v]\n",
  "CURLIER": "CURLY, tending to curl [adj]\n",
  "CURLIES": "(colloquial) the pubic hairs, as 'got him by the short and curlies' [n]\n",
  "CURLIEST": "CURLY, tending to curl [adj]\n",
  "CURLIEWURLIE": "(Scots) a twisted or curled pattern [n -S]\n",
  "CURLIEWURLIES": "CURLIEWURLIE, (Scots) a twisted or curled pattern [n]\n",
  "CURLILY": "CURLY, tending to curl [adv]\n",
  "CURLINESS": "the state of being curly [n -ES]\n",
  "CURLINESSES": "CURLINESS, the state of being curly [n]\n",
  "CURLING": "a sport played on ice [n -S]\n",
  "CURLINGS": "CURLING, a sport played on ice [n]\n",
  "CURLPAPER": "a strip of paper round which the hair is twisted to give it a curl [n -S]\n",
  "CURLPAPERS": "CURLPAPER, a strip of paper round which the hair is twisted to give it a curl [n]\n",
  "CURLS": "CURL, to form into ringlets [v]\n",
  "CURLY": "tending to curl [adj CURLIER, CURLIEST, CURLILY]\n",
  "CURLYCUE": "a fancy twist or curl, esp. in handwriting, also CURLICUE [n -S]\n",
  "CURLYCUES": "CURLYCUE, a fancy twist or curl, esp. in handwriting, also CURLICUE [n]\n",
  "CURMUDGEON": "an avaricious, ill-natured churlish person; a miser [n -S]\n",
  "CURMUDGEONLIER": "CURMUDGEONLY, like a curmudgeon [adj]\n",
  "CURMUDGEONLIEST": "CURMUDGEONLY, like a curmudgeon [adj]\n",
  "CURMUDGEONLY": "like a curmudgeon [adj CURMUDGEONLIER, CURMUDGEONLIEST]\n",
  "CURMUDGEONS": "CURMUDGEON, an avaricious, ill-natured churlish person; a miser [n]\n",
  "CURMURRING": "(Scots) a rumbling or flatulent sound [n -S]\n",
  "CURMURRINGS": "CURMURRING, (Scots) a rumbling or flatulent sound [n]\n",
  "CURN": "(Scots) a grain, a small quantity, also CURRAN [n -S]\n",
  "CURNAPTIOUS": "(Scots) bad-tempered; cantankerous, also CARNAPTIOUS [adj]\n",
  "CURNEY": "granular, also CURNY [adj]\n",
  "CURNIER": "CURNY, granular, also CURNEY [adj]\n",
  "CURNIEST": "CURNY, granular, also CURNEY [adj]\n",
  "CURNS": "CURN, (Scots) a grain, a small quantity, also CURRAN [n]\n",
  "CURNY": "granular, also CURNEY [adj CURNIER, CURNIEST]\n",
  "CURPEL": "(Scots) the crupper, the rump of a horse [n -S]\n",
  "CURPELS": "CURPEL, (Scots) the crupper, the rump of a horse [n]\n",
  "CURR": "to make a purring sound [v -ED, -ING, -S]\n",
  "CURRACH": "(Irish) a long-shaped boat similar to a coracle, also CURAGH, CURRAGH [n -S]\n",
  "CURRACHS": "CURRACH, (Irish) a long-shaped boat similar to a coracle, also CURAGH, CURRAGH [n]\n",
  "CURRAGH": "(Irish) a long-shaped boat similar to a coracle, also CURAGH, CURRACH [n -S]\n",
  "CURRAGHS": "CURRAGH, (Irish) a long-shaped boat similar to a coracle, also CURAGH, CURRACH [n]\n",
  "CURRAJONG": "(Native Australian) an Australian evergreen, also CURREJONG, CURRIJONG, KURRAJONG [n -S]\n",
  "CURRAJONGS": "CURRAJONG, (Native Australian) an Australian evergreen, also CURREJONG, CURRIJONG, KURRAJONG [n]\n",
  "CURRAN": "(Scots) a grain, a small quantity, also CURN [n -S]\n",
  "CURRANS": "CURRAN, (Scots) a grain, a small quantity, also CURN [n]\n",
  "CURRANT": "a small black raisin or dried seedless grape [n -S]\n",
  "CURRANTIER": "CURRANTY, full of currants [adj]\n",
  "CURRANTIEST": "CURRANTY, full of currants [adj]\n",
  "CURRANTS": "CURRANT, a small black raisin or dried seedless grape [n]\n",
  "CURRANTY": "full of currants [adj CURRANTIER, CURRANTIEST]\n",
  "CURRAWONG": "(Native Australian) an Australian crow-like bird with a resounding call [n -S]\n",
  "CURRAWONGS": "CURRAWONG, (Native Australian) an Australian crow-like bird with a resounding call [n]\n",
  "CURRED": "CURR, to make a purring sound [v]\n",
  "CURREJONG": "(Native Australian) an Australian evergreen, also CURRAJONG, CURRIJONG, KURRAJONG [n -S]\n",
  "CURREJONGS": "CURREJONG, (Native Australian) an Australian evergreen, also CURRAJONG, CURRIJONG, KURRAJONG [n]\n",
  "CURRENCIES": "CURRENCY, a monetary medium of exchange [n]\n",
  "CURRENCY": "a monetary medium of exchange [n CURRENCIES]\n",
  "CURRENT": "belonging to the period now passing [adj CURRENTLY] / a continuous flow [n -S]\n",
  "CURRENTLY": "CURRENT, belonging to the period now passing [adv]\n",
  "CURRENTNESS": "the state of being current [n -ES]\n",
  "CURRENTNESSES": "CURRENTNESS, the state of being current [n]\n",
  "CURRENTS": "CURRENT, a continuous flow [n]\n",
  "CURRICLE": "a two-wheeled open carriage [n -S]\n",
  "CURRICLES": "CURRICLE, a two-wheeled open carriage [n]\n",
  "CURRICULA": "CURRICULUM, (Latin) a program of educational resources etc. [n]\n",
  "CURRICULAR": "relating to a curriculum [adj]\n",
  "CURRICULUM": "(Latin) a program of educational resources etc. [n CURRICULA or CURRICULUMS]\n",
  "CURRICULUMS": "CURRICULUM, (Latin) a program of educational resources etc. [n]\n",
  "CURRIE": "(obsolete) the quarry, the parts of an animal killed in hunting that were given to the hounds, also QUARRY [n -S]\n",
  "CURRIED": "CURRY, to make a curry of [v]\n",
  "CURRIER": "a person who dresses tanned leather [n -S]\n",
  "CURRIERIES": "CURRIERY, the shop of a currier [n]\n",
  "CURRIERS": "CURRIER, a person who dresses tanned leather [n]\n",
  "CURRIERY": "the shop of a currier [n CURRIERIES]\n",
  "CURRIES": "CURRY, to make a curry of [v]\n",
  "CURRIJONG": "(Native Australian) an Australian evergreen, also CURRAJONG, CURREJONG, KURRAJONG [n -S]\n",
  "CURRIJONGS": "CURRIJONG, (Native Australian) an Australian evergreen, also CURRAJONG, CURREJONG, KURRAJONG [n]\n",
  "CURRING": "CURR, to make a purring sound [v]\n",
  "CURRISH": "like a cur, rude or bad-tempered [adj CURRISHLY]\n",
  "CURRISHLY": "CURRISH, like a cur, rude or bad-tempered [adv]\n",
  "CURRISHNESS": "the state of being currish [n -ES]\n",
  "CURRISHNESSES": "CURRISHNESS, the state of being currish [n]\n",
  "CURRS": "CURR, to make a purring sound [v]\n",
  "CURRY": "(Tamil) meat, fish, vegetables, etc., cooked with a mixture of strong spices and turmeric [n CURRIES] / to make a curry of [v CURRIED, CURRYING, CURRIES]\n",
  "CURRYCOMB": "a metal comb used to groom horses [n -S] / to comb with this [v -ED, -ING, -S]\n",
  "CURRYCOMBED": "CURRYCOMB, to comb with this [v]\n",
  "CURRYCOMBING": "CURRYCOMB, to comb with this [v]\n",
  "CURRYCOMBS": "CURRYCOMB, a metal comb used to groom horses [n]\n",
  "CURRYING": "the dressing of leather [n -S]\n",
  "CURRYINGS": "CURRYING, the dressing of leather [n]\n",
  "CURS": "CUR, a worthless mongrel dog, also KURRE [n]\n",
  "CURSAL": "relating to a cursus, an elongated prehistoric earthwork [adj]\n",
  "CURSE": "to invoke evil upon [v CURST or CURSED, CURSING, CURSES]\n",
  "CURSED": "wicked [adj CURSEDER, CURSEDEST, CURSEDLY]\n",
  "CURSEDER": "CURSED, wicked [adj]\n",
  "CURSEDEST": "CURSED, wicked [adj]\n",
  "CURSEDLY": "CURSED, wicked [adv]\n",
  "CURSEDNESS": "the quality of being cursed [n -ES]\n",
  "CURSEDNESSES": "CURSEDNESS, the quality of being cursed [n]\n",
  "CURSELARIE": "(Shakespeare) cursory (probably a misreading), also CURSENARY, CURSORARY [adj]\n",
  "CURSENARY": "(Shakespeare) cursory (probably a misreading), also CURSELARIE, CURSORARY [adj]\n",
  "CURSER": "one who curses [n -S]\n",
  "CURSERS": "CURSER, one who curses [n]\n",
  "CURSES": "CURSE, to invoke evil upon [v]\n",
  "CURSI": "CURSUS, (Latin) an elongated prehistoric earthwork [n]\n",
  "CURSILLO": "(tradename) a type of spiritual retreat [n -S]\n",
  "CURSILLOS": "CURSILLO, (tradename) a type of spiritual retreat [n]\n",
  "CURSING": "the act of wishing evil upon [n -S]\n",
  "CURSINGS": "CURSING, the act of wishing evil upon [n]\n",
  "CURSITOR": "(obsolete) a clerk or officer in the Court of Chancery, who made out writs de cursu [n -S]\n",
  "CURSITORS": "CURSITOR, (obsolete) a clerk or officer in the Court of Chancery, who made out writs de cursu [n]\n",
  "CURSITORY": "relating to a cursitor, a clerk or officer in the Court of Chancery, who made out writs de cursu [adj]\n",
  "CURSIVE": "with flowing characteristics [adj CURSIVELY] / a flowing script [n -S]\n",
  "CURSIVELY": "CURSIVE, with flowing characteristics [adv]\n",
  "CURSIVENESS": "the state of being cursive [n -ES]\n",
  "CURSIVENESSES": "CURSIVENESS, the state of being cursive [n]\n",
  "CURSIVES": "CURSIVE, a flowing script [n]\n",
  "CURSOR": "a light indicator on a computer display [n -S]\n",
  "CURSORARY": "(obsolete) cursory, also CURSELARIE, CURSENARY [adj]\n",
  "CURSORES": "(Latin) in old classifications, running birds [n]\n",
  "CURSORIAL": "suited to walking or running [adj]\n",
  "CURSORILY": "CURSORY, hasty and superficial [adv]\n",
  "CURSORINESS": "the state of being cursory [n -ES]\n",
  "CURSORINESSES": "CURSORINESS, the state of being cursory [n]\n",
  "CURSORS": "CURSOR, a light indicator on a computer display [n]\n",
  "CURSORY": "hasty and superficial [adj CURSORILY]\n",
  "CURST": "CURSE, to invoke evil upon [v]\n",
  "CURSTNESS": "shrewishness [n -ES]\n",
  "CURSTNESSES": "CURSTNESS, shrewishness [n]\n",
  "CURSUS": "(Latin) an elongated prehistoric earthwork [n CURSI]\n",
  "CURT": "abrupt [adj CURTER, CURTEST, CURTLY]\n",
  "CURTAIL": "to cut short [v -ED, -ING, -S]\n",
  "CURTAILED": "CURTAIL, to cut short [v]\n",
  "CURTAILER": "one who curtails [n -S]\n",
  "CURTAILERS": "CURTAILER, one who curtails [n]\n",
  "CURTAILING": "CURTAIL, to cut short [v]\n",
  "CURTAILMENT": "the act of curtailing [n -S]\n",
  "CURTAILMENTS": "CURTAILMENT, the act of curtailing [n]\n",
  "CURTAILS": "CURTAIL, to cut short [v]\n",
  "CURTAIN": "to furnish with hanging fabric [v -ED, -ING, -S]\n",
  "CURTAINED": "CURTAIN, to furnish with hanging fabric [v]\n",
  "CURTAINING": "CURTAIN, to furnish with hanging fabric [v]\n",
  "CURTAINLESS": "without curtains [adj]\n",
  "CURTAINS": "CURTAIN, to furnish with hanging fabric [v]\n",
  "CURTAL": "an animal with a docked tail [n -S]\n",
  "CURTALAX": "a short broadsword, also CURTAXE, CURTALAXE [n -ES]\n",
  "CURTALAXE": "(archaic) a short broad sword; a cutlass, also CURTALAX, CURTAXE [n -S]\n",
  "CURTALAXES": "CURTALAX, a short broadsword, also CURTAXE, CURTALAXE [n]\n",
  "CURTALS": "CURTAL, an animal with a docked tail [n]\n",
  "CURTANA": "a sword without a point, symbolic of mercy [n -S]\n",
  "CURTANAS": "CURTANA, a sword without a point, symbolic of mercy [n]\n",
  "CURTATE": "shortened [adj]\n",
  "CURTATION": "a shortening or reduction [n -S]\n",
  "CURTATIONS": "CURTATION, a shortening or reduction [n]\n",
  "CURTAXE": "(archaic) a short broad sword, also CURTALAX, CURTALAXE [n -S]\n",
  "CURTAXES": "CURTAXE, (archaic) a short broad sword, also CURTALAX, CURTALAXE [n]\n",
  "CURTER": "CURT, abrupt [adj]\n",
  "CURTESIES": "CURTESY, the lifetime right of a husband to a deceased wife's property [n]\n",
  "CURTEST": "CURT, abrupt [adj]\n",
  "CURTESY": "the lifetime right of a husband to a deceased wife's property [n CURTESIES]\n",
  "CURTILAGE": "an area of land encompassing a dwelling and its surrounding yard, considered as enclosed whether fenced or not [n -S]\n",
  "CURTILAGES": "CURTILAGE, an area of land encompassing a dwelling and its surrounding yard, considered as enclosed whether fenced or not [n]\n",
  "CURTLY": "CURT, abrupt [adv]\n",
  "CURTNESS": "the quality of being curt [n -ES]\n",
  "CURTNESSES": "CURTNESS, the quality of being curt [n]\n",
  "CURTSEY": "to bow politely, also CURTSY [v -ED, -ING, -S]\n",
  "CURTSEYED": "CURTSEY, to bow politely, also CURTSY [v]\n",
  "CURTSEYING": "CURTSEY, to bow politely, also CURTSY [v]\n",
  "CURTSEYS": "CURTSEY, to bow politely, also CURTSY [v]\n",
  "CURTSIED": "CURTSY, to bow politely, also CURTSEY [v]\n",
  "CURTSIES": "CURTSY, to bow politely, also CURTSEY [v]\n",
  "CURTSY": "to bow politely, also CURTSEY [v CURTSIED, CURTSYING, CURTSIES]\n",
  "CURTSYING": "CURTSY, to bow politely, also CURTSEY [v]\n",
  "CURULE": "of high authority, as a higher Roman magistrate who was entitled to a curule chair, one like a campstool with curved legs [adj]\n",
  "CURVACEOUS": "pleasingly curved, also CURVACIOUS [adj CURVACEOUSLY]\n",
  "CURVACEOUSLY": "CURVACEOUS, pleasingly curved, also CURVACIOUS [adv]\n",
  "CURVACEOUSNESS": "the state of being curvaceous, also CURVACIOUSNESS [n]\n",
  "CURVACIOUS": "pleasingly curved, also CURVACEOUS [adj CURVACIOUSLY]\n",
  "CURVACIOUSLY": "CURVACIOUS, pleasingly curved, also CURVACEOUS [adv]\n",
  "CURVACIOUSNESS": "the state of being curvacious, also CURVACEOUSNESS [n]\n",
  "CURVATE": "curved, also CURVATED [adj]\n",
  "CURVATED": "bent in a regular form [adj]\n",
  "CURVATION": "the state of being curved [n -S]\n",
  "CURVATIONS": "CURVATION, the state of being curved [n]\n",
  "CURVATIVE": "relating to curvation [adj]\n",
  "CURVATURE": "a curving or bending [n -S]\n",
  "CURVATURES": "CURVATURE, a curving or bending [n]\n",
  "CURVE": "to deviate from straightness [v CURVED, CURVING, CURVES]\n",
  "CURVEBALL": "a baseball pitch thrown with spin to make it curve [n -S] / to throw such a ball [v -ED, -ING, -S]\n",
  "CURVEBALLED": "CURVEBALL, to throw such a ball [v]\n",
  "CURVEBALLING": "CURVEBALL, to throw such a ball [v]\n",
  "CURVEBALLS": "CURVEBALL, a baseball pitch thrown with spin to make it curve [n]\n",
  "CURVED": "CURVE, to deviate from straightness [v]\n",
  "CURVEDLY": "CURVED, CURVE, to deviate from straightness [adv]\n",
  "CURVEDNESS": "the state of being curved [n -ES]\n",
  "CURVEDNESSES": "CURVEDNESS, the state of being curved [n]\n",
  "CURVES": "CURVE, to deviate from straightness [v]\n",
  "CURVESOME": "curvy [adj]\n",
  "CURVET": "to leap, frisk [v CURVETED or CURVETTED, CURVETING or CURVETTING, CURVETS]\n",
  "CURVETED": "CURVET, to leap, frisk [v]\n",
  "CURVETING": "CURVET, to leap, frisk [v]\n",
  "CURVETS": "CURVET, to leap, frisk [v]\n",
  "CURVETTED": "CURVET, to leap, frisk [v]\n",
  "CURVETTING": "CURVET, to leap, frisk [v]\n",
  "CURVEY": "curved, also CURVY [adj CURVIER, CURVIEST]\n",
  "CURVICAUDATE": "having a curvy tail [adj]\n",
  "CURVICOSTATE": "having curved ribs [adj]\n",
  "CURVIER": "CURVEY, curved, also CURVY [adj]\n",
  "CURVIEST": "CURVEY, curved, also CURVY [adj]\n",
  "CURVIFOLIATE": "having curved leaves [adj]\n",
  "CURVIFORM": "curving [adj]\n",
  "CURVILINEAL": "bounded by curved lines [adj CURVILINEALLY]\n",
  "CURVILINEALLY": "CURVILINEAL, bounded by curved lines [adv]\n",
  "CURVILINEAR": "bounded by curved lines, also CURVILINEAL [adj CURVILINEARLY]\n",
  "CURVILINEARITY": "the state of being curvilinear [n]\n",
  "CURVILINEARLY": "CURVILINEAR, bounded by curved lines, also CURVILINEAL [adv]\n",
  "CURVINESS": "the state of being curved [n -ES]\n",
  "CURVINESSES": "CURVINESS, the state of being curved [n]\n",
  "CURVING": "CURVE, to deviate from straightness [v]\n",
  "CURVIROSTRAL": "having a curved bill [adj]\n",
  "CURVITAL": "of curvature [adj]\n",
  "CURVITIES": "CURVITY, the state of being curved [n]\n",
  "CURVITY": "the state of being curved [n CURVITIES]\n",
  "CURVY": "curved [adj CURVIER, CURVIEST]\n",
  "CUSCUS": "an arboreal mammal of New Guinea [n -ES]\n",
  "CUSCUSES": "CUSCUS, an arboreal mammal of New Guinea [n]\n",
  "CUSEC": "a unit of liquid flow equal to one cubic foot per second [n -S]\n",
  "CUSECS": "CUSEC, a unit of liquid flow equal to one cubic foot per second [n]\n",
  "CUSH": "the cushion in billiards [n -ES]\n",
  "CUSHAT": "(Scots) the wood-pigeon or ringdove, also CUSHIE [n -S]\n",
  "CUSHATS": "CUSHAT, (Scots) the wood-pigeon or ringdove, also CUSHIE [n]\n",
  "CUSHAW": "a variety of squash, also CASHAW [n -S]\n",
  "CUSHAWS": "CUSHAW, a variety of squash, also CASHAW [n]\n",
  "CUSHES": "CUSH, the cushion in billiards [n]\n",
  "CUSHIE": "the wood-pigeon or ringdove [n -S]\n",
  "CUSHIER": "CUSHY, (colloquial) easy, comfortable [adj]\n",
  "CUSHIES": "CUSHIE, the wood-pigeon or ringdove [n]\n",
  "CUSHIEST": "CUSHY, (colloquial) easy, comfortable [adj]\n",
  "CUSHILY": "CUSHY, (colloquial) easy, comfortable [adv]\n",
  "CUSHINESS": "the state of being cushy [n -ES]\n",
  "CUSHINESSES": "CUSHINESS, the state of being cushy [n]\n",
  "CUSHION": "to pad with soft material [v -ED, -ING, -S]\n",
  "CUSHIONED": "CUSHION, to pad with soft material [v]\n",
  "CUSHIONET": "a little cushion [n -S]\n",
  "CUSHIONETS": "CUSHIONET, a little cushion [n]\n",
  "CUSHIONIER": "CUSHIONY, like a cushion [adj]\n",
  "CUSHIONIEST": "CUSHIONY, like a cushion [adj]\n",
  "CUSHIONING": "the act of providing with a cushion [n -S]\n",
  "CUSHIONINGS": "CUSHIONING, the act of providing with a cushion [n]\n",
  "CUSHIONLESS": "without cushions [adj]\n",
  "CUSHIONS": "CUSHION, to pad with soft material [v]\n",
  "CUSHIONY": "like a cushion [adj CUSHIONIER, CUSHIONIEST]\n",
  "CUSHTY": "an interjection expressing pleasure or agreement [interj]\n",
  "CUSHY": "(colloquial) easy, comfortable [adj CUSHIER, CUSHIEST, CUSHILY]\n",
  "CUSK": "a kind of marine food fish, aka torsk or burbot [n -S]\n",
  "CUSKS": "CUSK, a kind of marine food fish, aka torsk or burbot [n]\n",
  "CUSP": "a toothlike meeting of two branches of a curve, also CUSPIS [n -S]\n",
  "CUSPAL": "relating to a cusp [adj]\n",
  "CUSPATE": "in the form of a cusp, also CUSPATED [adj]\n",
  "CUSPATED": "having a point [adj]\n",
  "CUSPED": "having a cusp [adj]\n",
  "CUSPID": "a tooth with a single point, a canine tooth [n -S]\n",
  "CUSPIDAL": "having a cusp [adj]\n",
  "CUSPIDATE": "shaped like a cuspid, a tooth with a single point, a canine tooth, also CUSPIDATED [adj]\n",
  "CUSPIDATED": "shaped like a cuspid, a tooth with a single point, a canine tooth, also CUSPIDATE [adj]\n",
  "CUSPIDATION": "decoration with cusps [n -S]\n",
  "CUSPIDATIONS": "CUSPIDATION, decoration with cusps [n]\n",
  "CUSPIDES": "CUSPIS, (Latin) a point e.g. the horn of the moon, also CUSP [n]\n",
  "CUSPIDOR": "(Portuguese) a spittoon, also CUSPIDORE [n -S]\n",
  "CUSPIDORE": "(Portuguese) a spittoon, also CUSPIDOR [n -S]\n",
  "CUSPIDORES": "CUSPIDORE, (Portuguese) a spittoon, also CUSPIDOR [n]\n",
  "CUSPIDORS": "CUSPIDOR, (Portuguese) a spittoon, also CUSPIDORE [n]\n",
  "CUSPIDS": "CUSPID, a tooth with a single point, a canine tooth [n]\n",
  "CUSPIER": "CUSPY, of a computer program, well written and easy to use [adj]\n",
  "CUSPIEST": "CUSPY, of a computer program, well written and easy to use [adj]\n",
  "CUSPIS": "(Latin) a point e.g. the horn of the moon, also CUSP [n CUSPIDES]\n",
  "CUSPLIKE": "like a cusp [adj]\n",
  "CUSPS": "CUSP, a toothlike meeting of two branches of a curve, also CUSPIS [n]\n",
  "CUSPY": "of a computer program, well written and easy to use [adj CUSPIER, CUSPIEST]\n",
  "CUSS": "(colloquial) to curse [v CUSSED, CUSSING, CUSSES]\n",
  "CUSSED": "CUSS, (colloquial) to curse [v]\n",
  "CUSSEDLY": "CUSSED, CUSS, (colloquial) to curse [adv]\n",
  "CUSSEDNESS": "the quality of being cussed [n -ES]\n",
  "CUSSEDNESSES": "CUSSEDNESS, the quality of being cussed [n]\n",
  "CUSSER": "(Scots) a stallion, also COOSER, CUISSER [n -S]\n",
  "CUSSERS": "CUSSER, (Scots) a stallion, also COOSER, CUISSER [n]\n",
  "CUSSES": "CUSS, (colloquial) to curse [v]\n",
  "CUSSING": "CUSS, (colloquial) to curse [v]\n",
  "CUSSO": "(Amharic) an Ethiopian tree, also KOUSSO, KUSSO [n -S]\n",
  "CUSSOS": "CUSSO, (Amharic) an Ethiopian tree, also KOUSSO, KUSSO [n]\n",
  "CUSSWORD": "a swearword [n -S]\n",
  "CUSSWORDS": "CUSSWORD, a swearword [n]\n",
  "CUSTARD": "a mixture of milk, eggs, etc., sweetened or seasoned, thickened with cornflour and poured over puddings [n -S]\n",
  "CUSTARDIER": "CUSTARDY, pertaining to custard [adj]\n",
  "CUSTARDIEST": "CUSTARDY, pertaining to custard [adj]\n",
  "CUSTARDS": "CUSTARD, a mixture of milk, eggs, etc., sweetened or seasoned, thickened with cornflour and poured over puddings [n]\n",
  "CUSTARDY": "pertaining to custard [adj CUSTARDIER, CUSTARDIEST]\n",
  "CUSTOCK": "(Scots) a cabbage stock, also CASTOCK [n -S]\n",
  "CUSTOCKS": "CUSTOCK, (Scots) a cabbage stock, also CASTOCK [n]\n",
  "CUSTODE": "a person who has care such as of a public building, also CUSTODIAN, CUSTODIER [n -S]\n",
  "CUSTODES": "CUSTODE, a person who has care such as of a public building, also CUSTODIAN, CUSTODIER [n]\n",
  "CUSTODIAL": "of or like custody e.g. a custodial sentence [adj]\n",
  "CUSTODIAN": "a person who has care such as of a public building, also CUSTODE, CUSTODIER [n -S]\n",
  "CUSTODIANS": "CUSTODIAN, a person who has care such as of a public building, also CUSTODE, CUSTODIER [n]\n",
  "CUSTODIANSHIP": "the office of custodian [n -S]\n",
  "CUSTODIANSHIPS": "CUSTODIANSHIP, the office of custodian [n]\n",
  "CUSTODIER": "a person who has care such as of a public building, also CUSTODE, CUSTODIAN [n -S]\n",
  "CUSTODIERS": "CUSTODIER, a person who has care such as of a public building, also CUSTODE, CUSTODIAN [n]\n",
  "CUSTODIES": "CUSTODY, guardianship [n]\n",
  "CUSTODY": "guardianship [n CUSTODIES]\n",
  "CUSTOM": "a habitual practice [n -S]\n",
  "CUSTOMABLE": "(archaic) customary, common [adj]\n",
  "CUSTOMARIES": "CUSTOMARY, a body or book of the customs of a manor, also CUSTUMARY [n]\n",
  "CUSTOMARILY": "CUSTOMARY, according to custom [adv]\n",
  "CUSTOMARINESS": "the state of being customary [n -ES]\n",
  "CUSTOMARINESSES": "CUSTOMARINESS, the state of being customary [n]\n",
  "CUSTOMARY": "according to custom [adj CUSTOMARILY] / a body or book of the customs of a manor, also CUSTUMARY [n CUSTOMARIES]\n",
  "CUSTOMED": "usual [adj]\n",
  "CUSTOMER": "one who buys something [n -S]\n",
  "CUSTOMERS": "CUSTOMER, one who buys something [n]\n",
  "CUSTOMHOUSE": "an office or residence for customs officials, also CUSTOMSHOUSE [n -S]\n",
  "CUSTOMHOUSES": "CUSTOMHOUSE, an office or residence for customs officials, also CUSTOMSHOUSE [n]\n",
  "CUSTOMISATION": "the process of customising, also CUSTOMIZATION [n -S]\n",
  "CUSTOMISATIONS": "CUSTOMISATION, the process of customising, also CUSTOMIZATION [n]\n",
  "CUSTOMISE": "to adapt for a customer, also CUSTOMIZE [v CUSTOMISED, CUSTOMISING, CUSTOMISES]\n",
  "CUSTOMISED": "CUSTOMISE, to adapt for a customer, also CUSTOMIZE [v]\n",
  "CUSTOMISER": "one who customises, also CUSTOMIZER [n -S]\n",
  "CUSTOMISERS": "CUSTOMISER, one who customises, also CUSTOMIZER [n]\n",
  "CUSTOMISES": "CUSTOMISE, to adapt for a customer, also CUSTOMIZE [v]\n",
  "CUSTOMISING": "CUSTOMISE, to adapt for a customer, also CUSTOMIZE [v]\n",
  "CUSTOMIZATION": "the process of customizing, also CUSTOMISATION [n -S]\n",
  "CUSTOMIZATIONS": "CUSTOMIZATION, the process of customizing, also CUSTOMISATION [n]\n",
  "CUSTOMIZE": "to adapt for a customer, also CUSTOMISE [v CUSTOMIZED, CUSTOMIZING, CUSTOMIZES]\n",
  "CUSTOMIZED": "CUSTOMIZE, to adapt for a customer, also CUSTOMISE [v]\n",
  "CUSTOMIZER": "one who customizes, also CUSTOMISER [n -S]\n",
  "CUSTOMIZERS": "CUSTOMIZER, one who customizes, also CUSTOMISER [n]\n",
  "CUSTOMIZES": "CUSTOMIZE, to adapt for a customer, also CUSTOMISE [v]\n",
  "CUSTOMIZING": "CUSTOMIZE, to adapt for a customer, also CUSTOMISE [v]\n",
  "CUSTOMS": "CUSTOM, a habitual practice [n]\n",
  "CUSTOMSHOUSE": "an office or residence for customs officials, also CUSTOMHOUSE [n -S]\n",
  "CUSTOMSHOUSES": "CUSTOMSHOUSE, an office or residence for customs officials, also CUSTOMHOUSE [n]\n",
  "CUSTOS": "(Latin) a guardian, custodian or keeper, esp. of convents or monasteries [n CUSTODES]\n",
  "CUSTREL": "(historical) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COISTRIL, COYSTREL, COYSTRIL [n -S]\n",
  "CUSTRELS": "CUSTREL, (historical) an inferior groom or lad employed by an esquire to carry the knight's arms and other necessaries, also COISTREL, COISTRIL, COYSTREL, COYSTRIL [n]\n",
  "CUSTUMAL": "a written record or laws and customs [n -S]\n",
  "CUSTUMALS": "CUSTUMAL, a written record or laws and customs [n]\n",
  "CUSTUMARIES": "CUSTUMARY, a body or book of the customs of a manor, also CUSTOMARY [n]\n",
  "CUSTUMARY": "a body or book of the customs of a manor, also CUSTOMARY [n CUSTUMARIES]\n",
  "CUSUM": "a statistical technique that attempts to identify individuals by their characteristic use of language [n -S]\n",
  "CUSUMS": "CUSUM, a statistical technique that attempts to identify individuals by their characteristic use of language [n]\n",
  "CUT": "to make an incision in; to reduce [v CUT, CUTTING, CUTS]\n",
  "CUTABILITIES": "CUTABILITY, the proportion of lean saleable meat yielded by a carcase [n]\n",
  "CUTABILITY": "the proportion of lean saleable meat yielded by a carcase [n CUTABILITIES]\n",
  "CUTANEOUS": "of or related to the skin [adj CUTANEOUSLY]\n",
  "CUTANEOUSLY": "CUTANEOUS, of or related to the skin [adv]\n",
  "CUTAWAY": "a type of coat [n -S]\n",
  "CUTAWAYS": "CUTAWAY, a type of coat [n]\n",
  "CUTBACK": "a reduction, also CUTDOWN [n -S]\n",
  "CUTBACKS": "CUTBACK, a reduction, also CUTDOWN [n]\n",
  "CUTBANK": "a steep stream bank [n -S]\n",
  "CUTBANKS": "CUTBANK, a steep stream bank [n]\n",
  "CUTBLOCK": "a limited area authorised for logging [n -S]\n",
  "CUTBLOCKS": "CUTBLOCK, a limited area authorised for logging [n]\n",
  "CUTCH": "(Malay) a resin used in tanning, also CATECHU, CASHOO, KUTCH [n -ES]\n",
  "CUTCHA": "(Hindi) made of dried mud, makeshift, also KACHA, KACHCHA, KUCHCHA, KUTCHA [adj]\n",
  "CUTCHERIES": "CUTCHERY, (Hindi) a judicial office in India [n]\n",
  "CUTCHERRIES": "CUTCHERRY, (Hindi) an Indian magistrate's office or courthouse, also CUTCHERY, KACHAHRI, KACHERI [n]\n",
  "CUTCHERRY": "(Hindi) an Indian magistrate's office or courthouse, also CUTCHERY, KACHAHRI, KACHERI [n CUTCHERRIES]\n",
  "CUTCHERY": "(Hindi) a judicial office in India [n CUTCHERIES]\n",
  "CUTCHES": "CUTCH, (Malay) a resin used in tanning, also CATECHU, CASHOO, KUTCH [n]\n",
  "CUTDOWN": "a reduction, also CUTBACK [n -S]\n",
  "CUTDOWNS": "CUTDOWN, a reduction, also CUTBACK [n]\n",
  "CUTE": "pleasingly attractive [adj CUTER, CUTEST, CUTELY]\n",
  "CUTELY": "CUTE, pleasingly attractive [adv]\n",
  "CUTENESS": "the quality of being cute [n -ES]\n",
  "CUTENESSES": "CUTENESS, the quality of being cute [n]\n",
  "CUTER": "CUTE, pleasingly attractive [adj]\n",
  "CUTES": "CUTIS, (Latin) the dermis, or true skin [n]\n",
  "CUTESIE": "(US) affectedly cute, also CUTESY [adj CUTESIER, CUTESIEST]\n",
  "CUTESIER": "CUTESY, (US) affectedly cute, also CUTESIE [adj]\n",
  "CUTESIEST": "CUTESY, (US) affectedly cute, also CUTESIE [adj]\n",
  "CUTEST": "CUTE, pleasingly attractive [adj]\n",
  "CUTESY": "(US) affectedly cute, also CUTESIE [adj CUTESIER, CUTESIEST]\n",
  "CUTEY": "a cute person, also CUTIE [n -S]\n",
  "CUTEYS": "CUTEY, a cute person, also CUTIE [n]\n",
  "CUTGLASS": "made of cut glass, i.e. flint glass shaped by cutting or grinding [adj]\n",
  "CUTGRASS": "a kind of swamp grass [n -ES]\n",
  "CUTGRASSES": "CUTGRASS, a kind of swamp grass [n]\n",
  "CUTICLE": "any of various outer layers in a plant or animal, esp. a noncellular protective film covering the epidermis in a plant or insect [n -S]\n",
  "CUTICLES": "CUTICLE, any of various outer layers in a plant or animal, esp. a noncellular protective film covering the epidermis in a plant or insect [n]\n",
  "CUTICULA": "(Latin) the outer hard covering of an insect [n CUTICULAE]\n",
  "CUTICULAE": "CUTICULA, (Latin) the outer hard covering of an insect [n]\n",
  "CUTICULAR": "relating to a cuticle, any of various outer layers in a plant or animal [adj]\n",
  "CUTIE": "a cute person, also CUTEY [n -S]\n",
  "CUTIES": "CUTIE, a cute person, also CUTEY [n]\n",
  "CUTIKIN": "(Scots) a gaiter, also COOTIKIN, CUITIKIN [n -S]\n",
  "CUTIKINS": "CUTIKIN, (Scots) a gaiter, also COOTIKIN, CUITIKIN [n]\n",
  "CUTIN": "the waxy material forming a plant cuticle [n -S]\n",
  "CUTINISATION": "the formation of cutin, also CUTINIZATION [n -S]\n",
  "CUTINISATIONS": "CUTINISATION, the formation of cutin, also CUTINIZATION [n]\n",
  "CUTINISE": "to become coated with cutin, also CUTINIZE [v CUTINISED, CUTINISING, CUTINISES]\n",
  "CUTINISED": "CUTINISE, to become coated with cutin, also CUTINIZE [v]\n",
  "CUTINISES": "CUTINISE, to become coated with cutin, also CUTINIZE [v]\n",
  "CUTINISING": "CUTINISE, to become coated with cutin, also CUTINIZE [v]\n",
  "CUTINIZATION": "the formation of cutin, also CUTINISATION [n -S]\n",
  "CUTINIZATIONS": "CUTINIZATION, the formation of cutin, also CUTINISATION [n]\n",
  "CUTINIZE": "to become coated with cutin, also CUTINISE [v CUTINIZED, CUTINIZING, CUTINIZES]\n",
  "CUTINIZED": "CUTINIZE, to become coated with cutin, also CUTINISE [v]\n",
  "CUTINIZES": "CUTINIZE, to become coated with cutin, also CUTINISE [v]\n",
  "CUTINIZING": "CUTINIZE, to become coated with cutin, also CUTINISE [v]\n",
  "CUTINS": "CUTIN, the waxy material forming a plant cuticle [n]\n",
  "CUTIS": "(Latin) the dermis, or true skin [n CUTES or CUTISES]\n",
  "CUTISES": "CUTIS, (Latin) the dermis, or true skin [n]\n",
  "CUTLAS": "a curved, one-edged sword formerly used by sailors, also CUTLASS [n -ES]\n",
  "CUTLASES": "CUTLAS, a curved, one-edged sword formerly used by sailors, also CUTLASS [n]\n",
  "CUTLASS": "a curved, one-edged sword formerly used by sailors, also CUTLAS [n -ES]\n",
  "CUTLASSES": "CUTLASS, a curved, one-edged sword formerly used by sailors, also CUTLAS [n]\n",
  "CUTLER": "one who sells and repairs cutting tools [n -S]\n",
  "CUTLERIES": "CUTLERY, the business of a cutler [n]\n",
  "CUTLERS": "CUTLER, one who sells and repairs cutting tools [n]\n",
  "CUTLERY": "the business of a cutler [n CUTLERIES]\n",
  "CUTLET": "a cut of meat [n -S]\n",
  "CUTLETS": "CUTLET, a cut of meat [n]\n",
  "CUTLETTE": "a breaded patty of chopped meat [n -S]\n",
  "CUTLETTES": "CUTLETTE, a breaded patty of chopped meat [n]\n",
  "CUTLINE": "(US) a caption [n -S]\n",
  "CUTLINES": "CUTLINE, (US) a caption [n]\n",
  "CUTOFF": "the point at which something terminates [n -S]\n",
  "CUTOFFS": "CUTOFF, the point at which something terminates [n]\n",
  "CUTOUT": "something cut out [n -S]\n",
  "CUTOUTS": "CUTOUT, something cut out [n]\n",
  "CUTOVER": "(US) land cleared of trees [n -S]\n",
  "CUTOVERS": "CUTOVER, (US) land cleared of trees [n]\n",
  "CUTPURSE": "(historical) a person who stole by slitting purses worn at the belt [n -S]\n",
  "CUTPURSES": "CUTPURSE, (historical) a person who stole by slitting purses worn at the belt [n]\n",
  "CUTS": "CUT, to make an incision in; to reduce [v]\n",
  "CUTSCENE": "a type of scene in computer games [n -S]\n",
  "CUTSCENES": "CUTSCENE, a type of scene in computer games [n]\n",
  "CUTTABLE": "able to be cut [adj]\n",
  "CUTTAGE": "a means of plant propagation [n -S]\n",
  "CUTTAGES": "CUTTAGE, a means of plant propagation [n]\n",
  "CUTTER": "a powerful motor-launch (as used by coastguard and navy) [n -S]\n",
  "CUTTERS": "CUTTER, a powerful motor-launch (as used by coastguard and navy) [n]\n",
  "CUTTHROAT": "a murderer, an assassin [n -S]\n",
  "CUTTHROATS": "CUTTHROAT, a murderer, an assassin [n]\n",
  "CUTTIER": "CUTTY, (Scots) short, curtailed [adj]\n",
  "CUTTIES": "CUTTY, a short clay pipe [n]\n",
  "CUTTIEST": "CUTTY, (Scots) short, curtailed [adj]\n",
  "CUTTING": "sharp [adj CUTTINGLY] / a section cut from a plant [n -S]\n",
  "CUTTINGLY": "CUTTING, sharp [adv]\n",
  "CUTTINGS": "CUTTING, a section cut from a plant [n]\n",
  "CUTTLE": "to fold cloth in a particular fashion [v CUTTLED, CUTTLING, CUTTLES]\n",
  "CUTTLEBONE": "the internal shell of the cuttlefish, used for making tooth-powder, for polishing the softer metals and for cage-birds to sharpen their beaks on [n -S]\n",
  "CUTTLEBONES": "CUTTLEBONE, the internal shell of the cuttlefish, used for making tooth-powder, for polishing the softer metals and for cage-birds to sharpen their beaks on [n]\n",
  "CUTTLED": "CUTTLE, to fold cloth in a particular fashion [v]\n",
  "CUTTLEFISH": "any cephalopod mollusc of the genus Sepia [n -ES]\n",
  "CUTTLEFISHES": "CUTTLEFISH, any cephalopod mollusc of the genus Sepia [n]\n",
  "CUTTLES": "CUTTLE, to fold cloth in a particular fashion [v]\n",
  "CUTTLING": "CUTTLE, to fold cloth in a particular fashion [v]\n",
  "CUTTO": "a large knife, also CUTTOE [n -ES]\n",
  "CUTTOE": "a large knife, also CUTTO [n -S]\n",
  "CUTTOES": "CUTTOE, a large knife, also CUTTO [n]\n",
  "CUTTY": "a short clay pipe [n CUTTIES] / (Scots) short, curtailed [adj CUTTIER, CUTTIEST]\n",
  "CUTUP": "a mischievous person [n -S]\n",
  "CUTUPS": "CUTUP, a mischievous person [n]\n",
  "CUTWATER": "the forepart of a ship's prow; the angular edge of a bridge-pier [n -S]\n",
  "CUTWATERS": "CUTWATER, the forepart of a ship's prow; the angular edge of a bridge-pier [n]\n",
  "CUTWORK": "a type of embroidery [n -S]\n",
  "CUTWORKS": "CUTWORK, a type of embroidery [n]\n",
  "CUTWORM": "a caterpillar, esp. of the moth genus Agrotis, that feeds on the stems of young plants [n -S]\n",
  "CUTWORMS": "CUTWORM, a caterpillar, esp. of the moth genus Agrotis, that feeds on the stems of young plants [n]\n",
  "CUVEE": "(French) a vat of blended wine of uniform quality [n -S]\n",
  "CUVEES": "CUVEE, (French) a vat of blended wine of uniform quality [n]\n",
  "CUVETTE": "(French) a trench sunk along the middle of a dry ditch or moat, serving as a drain, also CUNETTE [n -S]\n",
  "CUVETTES": "CUVETTE, (French) a trench sunk along the middle of a dry ditch or moat, serving as a drain, also CUNETTE [n]\n",
  "CUZ": "(obsolete) cousin, also COZ [n CUZES or CUZZES]\n",
  "CUZES": "CUZ, (obsolete) cousin, also COZ [n]\n",
  "CUZZES": "CUZ, (obsolete) cousin, also COZ [n]\n",
  "CUZZIE": "(New Zealand) a close friend or family member [n -S]\n",
  "CUZZIES": "CUZZIE, (New Zealand) a close friend or family member [n]\n",
  "CWM": "(Welsh) a deep basin on a mountain, also CIRQUE, CORRIE [n -S]\n",
  "CWMS": "CWM, (Welsh) a deep basin on a mountain, also CIRQUE, CORRIE [n]\n",
  "CWTCH": "(Welsh) to hide, to cuddle up, also COOTCH [v -ED, -ING, -ES]\n",
  "CWTCHED": "CWTCH, (Welsh) to hide, to cuddle up, also COOTCH [v]\n",
  "CWTCHES": "CWTCH, (Welsh) to hide, to cuddle up, also COOTCH [v]\n",
  "CWTCHING": "CWTCH, (Welsh) to hide, to cuddle up, also COOTCH [v]\n",
  "CYAN": "a greenish-blue colour [n -S]\n",
  "CYANAMID": "the amide of cyanogen, a white crystalline substance, also CYANAMIDE, CYANOGENAMIDE [n -S]\n",
  "CYANAMIDE": "the amide of cyanogen, a white crystalline substance, also CYANAMID, CYANOGENAMIDE [n -S]\n",
  "CYANAMIDES": "CYANAMIDE, the amide of cyanogen, a white crystalline substance, also CYANAMID, CYANOGENAMIDE [n]\n",
  "CYANAMIDS": "CYANAMID, the amide of cyanogen, a white crystalline substance, also CYANAMIDE, CYANOGENAMIDE [n]\n",
  "CYANATE": "a salt of cyanic acid [n -S]\n",
  "CYANATES": "CYANATE, a salt of cyanic acid [n]\n",
  "CYANIC": "of or belonging to cyanogen, as in cyanic acid, an acid composed of cyanogen, oxygen and hydrogen [adj]\n",
  "CYANID": "a direct compound of cyanogen with a metal [n -S]\n",
  "CYANIDATION": "the act of cyaniding [n -S]\n",
  "CYANIDATIONS": "CYANIDATION, the act of cyaniding [n]\n",
  "CYANIDE": "to treat an ore with cyanid [v CYANIDED, CYANIDING, CYANIDES]\n",
  "CYANIDED": "CYANIDE, to treat an ore with cyanid [v]\n",
  "CYANIDES": "CYANIDE, to treat an ore with cyanid [v]\n",
  "CYANIDING": "the extraction of gold or silver from ore by means of potassium cyanide [n -S]\n",
  "CYANIDINGS": "CYANIDING, the extraction of gold or silver from ore by means of potassium cyanide [n]\n",
  "CYANIDS": "CYANID, a direct compound of cyanogen with a metal [n]\n",
  "CYANIN": "a blue dye, also CYANINE [n -S]\n",
  "CYANINE": "a blue dye, also CYANIN [n -S]\n",
  "CYANINES": "CYANINE, a blue dye, also CYANIN [n]\n",
  "CYANINS": "CYANIN, a blue dye, also CYANINE [n]\n",
  "CYANISE": "to turn into cyanide, also CYANIZE [v CYANISED, CYANISING, CYANISES]\n",
  "CYANISED": "CYANISE, to turn into cyanide, also CYANIZE [v]\n",
  "CYANISES": "CYANISE, to turn into cyanide, also CYANIZE [v]\n",
  "CYANISING": "CYANISE, to turn into cyanide, also CYANIZE [v]\n",
  "CYANITE": "a mineral, an aluminum silicate, usually sky-blue, also KYANITE [n -S]\n",
  "CYANITES": "CYANITE, a mineral, an aluminum silicate, usually sky-blue, also KYANITE [n]\n",
  "CYANITIC": "of or like cyanite, a mineral, an aluminum silicate, usually sky-blue [adj]\n",
  "CYANIZE": "to turn into cyanide, also CYANISE [v CYANIZED, CYANIZING, CYANIZES]\n",
  "CYANIZED": "CYANIZE, to turn into cyanide, also CYANISE [v]\n",
  "CYANIZES": "CYANIZE, to turn into cyanide, also CYANISE [v]\n",
  "CYANIZING": "CYANIZE, to turn into cyanide, also CYANISE [v]\n",
  "CYANO": "pertaining to cyanogen [adj]\n",
  "CYANOACETYLENE": "a large and complex organic molecule found in interstellar clouds [n -S]\n",
  "CYANOACETYLENES": "CYANOACETYLENE, a large and complex organic molecule found in interstellar clouds [n]\n",
  "CYANOACRYLATE": "any of several liquid acrylate monomers that readily polymerize as anions and are used as adhesives in industry and in closing wounds in surgery [n -S]\n",
  "CYANOACRYLATES": "CYANOACRYLATE, any of several liquid acrylate monomers that readily polymerize as anions and are used as adhesives in industry and in closing wounds in surgery [n]\n",
  "CYANOBACTERIA": "CYANOBACTERIUM, a blue-green alga [n]\n",
  "CYANOBACTERIUM": "a blue-green alga [n CYANOBACTERIA]\n",
  "CYANOCOBALAMIN": "vitamin B12, which has a large and complicated molecule, in one form including a cyanide group, in all forms including a cobalt atom, also CYANOCOBALAMINE [n -S]\n",
  "CYANOCOBALAMINE": "vitamin B12, which has a large and complicated molecule, in one form including a cyanide group, in all forms including a cobalt atom, also CYANOCOBALAMIN [n]\n",
  "CYANOCOBALAMINS": "CYANOCOBALAMIN, vitamin B12, which has a large and complicated molecule, in one form including a cyanide group, in all forms including a cobalt atom, also CYANOCOBALAMINE [n]\n",
  "CYANOETHYLATE": "to introduce a cyano-ethyl group into [v CYANOETHYLATED, CYANOETHYLATES]\n",
  "CYANOETHYLATED": "CYANOETHYLATE, to introduce a cyano-ethyl group into [v]\n",
  "CYANOETHYLATES": "CYANOETHYLATE, to introduce a cyano-ethyl group into [v]\n",
  "CYANOETHYLATING": "CYANOETHYLATE, to introduce a cyano-ethyl group into [v]\n",
  "CYANOETHYLATION": "the act of introducing a cyano-ethyl group into a compound [n]\n",
  "CYANOGEN": "a compound of carbon and nitrogen, forming a colourless poisonous gas with an almond-like odour [n -S]\n",
  "CYANOGENAMIDE": "the amide of cyanogen, a white crystalline substance, also CYANAMID, CYANAMIDE [n -S]\n",
  "CYANOGENAMIDES": "CYANOGENAMIDE, the amide of cyanogen, a white crystalline substance, also CYANAMID, CYANAMIDE [n]\n",
  "CYANOGENESES": "CYANOGENESIS, the production of cyanide [n]\n",
  "CYANOGENESIS": "the production of cyanide [n CYANOGENESES]\n",
  "CYANOGENETIC": "capable of producing cyanide (as hydrogen cyanide) [adj]\n",
  "CYANOGENIC": "of or like a cyanogen, a compound of carbon and nitrogen, forming a colourless poisonous gas with an almond-like odour [adj]\n",
  "CYANOGENS": "CYANOGEN, a compound of carbon and nitrogen, forming a colourless poisonous gas with an almond-like odour [n]\n",
  "CYANOHYDRIN": "any of various compounds containing both cyano and hydroxyl groups [n -S]\n",
  "CYANOHYDRINS": "CYANOHYDRIN, any of various compounds containing both cyano and hydroxyl groups [n]\n",
  "CYANOMETER": "instrument for measuring blueness of the sky or ocean [n -S]\n",
  "CYANOMETERS": "CYANOMETER, instrument for measuring blueness of the sky or ocean [n]\n",
  "CYANOPHYTE": "a blue-green alga [n -S]\n",
  "CYANOPHYTES": "CYANOPHYTE, a blue-green alga [n]\n",
  "CYANOSE": "a former name of cyanosis [n -S]\n",
  "CYANOSED": "(colloquial) with a bluish discoloration of the skin, as resulting from cyanide poisoning [adj]\n",
  "CYANOSES": "CYANOSIS, bluish discoloration of the skin [n]\n",
  "CYANOSIS": "bluish discoloration of the skin [n CYANOSES]\n",
  "CYANOTIC": "relating to cyanosis, a heart condition or disease causing blueness of surface of body [adj]\n",
  "CYANOTYPE": "a blueprint [n -S]\n",
  "CYANOTYPES": "CYANOTYPE, a blueprint [n]\n",
  "CYANS": "CYAN, a greenish-blue colour [n]\n",
  "CYANURATE": "a chemical derived from cyanide [n -S]\n",
  "CYANURATES": "CYANURATE, a chemical derived from cyanide [n]\n",
  "CYANURET": "(obsolete) cyanide [n -S]\n",
  "CYANURETS": "CYANURET, (obsolete) cyanide [n]\n",
  "CYANURIC": "as in cyanuric acid, a white crystalline powder commonly used to stabilize chlorine in swimming pools [adj]\n",
  "CYATHI": "CYATHUS, (Latin) an ancient Greek measuring cup [n]\n",
  "CYATHIA": "CYATHIUM, (Latin) the characteristic inflorescence of the spurges [n]\n",
  "CYATHIFORM": "shaped like a cup [adj]\n",
  "CYATHIUM": "(Latin) the characteristic inflorescence of the spurges [n CYATHIA]\n",
  "CYATHUS": "(Latin) an ancient Greek measuring cup [n CYATHI]\n",
  "CYBER": "involving computers [adj]\n",
  "CYBERATHLETE": "a professional player of computer games [n -S]\n",
  "CYBERATHLETES": "CYBERATHLETE, a professional player of computer games [n]\n",
  "CYBERATHLETICS": "electronic sports [n]\n",
  "CYBERATTACK": "an attempt to damage or disrupt a computer system, or obtain information stored on a computer system, by means of hacking [n -S]\n",
  "CYBERATTACKS": "CYBERATTACK, an attempt to damage or disrupt a computer system, or obtain information stored on a computer system, by means of hacking [n]\n",
  "CYBERBULLIES": "CYBERBULLY, one who bullies via the medium of the Internet [n]\n",
  "CYBERBULLY": "one who bullies via the medium of the Internet [n CYBERBULLIES]\n",
  "CYBERBULLYING": "bullying via the medium of the Internet [n -S]\n",
  "CYBERBULLYINGS": "CYBERBULLYING, bullying via the medium of the Internet [n]\n",
  "CYBERCAFE": "a cafe where computers can be used [n -S]\n",
  "CYBERCAFES": "CYBERCAFE, a cafe where computers can be used [n]\n",
  "CYBERCAST": "a broadcast over the Internet [n -S]\n",
  "CYBERCASTS": "CYBERCAST, a broadcast over the Internet [n]\n",
  "CYBERCHONDRIA": "unfounded anxiety concerning the state of one's health brought on by visiting health and medical websites [n -S]\n",
  "CYBERCHONDRIAC": "one suffering from CYBERCHONDRIA [n -S]\n",
  "CYBERCHONDRIACS": "CYBERCHONDRIAC, one suffering from CYBERCHONDRIA [n]\n",
  "CYBERCHONDRIAS": "CYBERCHONDRIA, unfounded anxiety concerning the state of one's health brought on by visiting health and medical websites [n]\n",
  "CYBERCRIME": "computer-related crime [n -S]\n",
  "CYBERCRIMES": "CYBERCRIME, computer-related crime [n]\n",
  "CYBERCRIMINAL": "one who commits cybercrime, computer-related crime [n -S]\n",
  "CYBERCRIMINALS": "CYBERCRIMINAL, one who commits cybercrime, computer-related crime [n]\n",
  "CYBERNATE": "to control by means of a computer [v CYBERNATED, CYBERNATING, CYBERNATES]\n",
  "CYBERNATED": "CYBERNATE, to control by means of a computer [v]\n",
  "CYBERNATES": "CYBERNATE, to control by means of a computer [v]\n",
  "CYBERNATING": "CYBERNATE, to control by means of a computer [v]\n",
  "CYBERNATION": "the automatic control of a process or operation (as in manufacturing) by means of computers [n -S]\n",
  "CYBERNATIONS": "CYBERNATION, the automatic control of a process or operation (as in manufacturing) by means of computers [n]\n",
  "CYBERNAUT": "a person using the Internet [n -S]\n",
  "CYBERNAUTS": "CYBERNAUT, a person using the Internet [n]\n",
  "CYBERNETIC": "relating to cybernetics, also CYBERNETICAL [adj CYBERNETICALLY]\n",
  "CYBERNETICAL": "relating to cybernetics, also CYBERNETIC [adj CYBERNETICALLY]\n",
  "CYBERNETICALLY": "CYBERNETICAL, relating to cybernetics, also CYBERNETIC [adv]\n",
  "CYBERNETICIAN": "a specialist in cybernetics [n -S]\n",
  "CYBERNETICIANS": "CYBERNETICIAN, a specialist in cybernetics [n]\n",
  "CYBERNETICIST": "a student of cybernetics [n -S]\n",
  "CYBERNETICISTS": "CYBERNETICIST, a student of cybernetics [n]\n",
  "CYBERNETICS": "the science of communication and control theory that is concerned esp. with the comparative study of automatic control systems [n]\n",
  "CYBERPET": "a computer simulated pet [n -S]\n",
  "CYBERPETS": "CYBERPET, a computer simulated pet [n]\n",
  "CYBERPHOBIA": "fear of computers [n -S]\n",
  "CYBERPHOBIAS": "CYBERPHOBIA, fear of computers [n]\n",
  "CYBERPHOBIC": "suffering from cyberphobia [adj]\n",
  "CYBERPORN": "pornography on the Internet [n -S]\n",
  "CYBERPORNS": "CYBERPORN, pornography on the Internet [n]\n",
  "CYBERPUNK": "a genus of science fiction involving a computer-dominated society and usually a gifted young hacker who rebels against this [n -S]\n",
  "CYBERPUNKS": "CYBERPUNK, a genus of science fiction involving a computer-dominated society and usually a gifted young hacker who rebels against this [n]\n",
  "CYBERSECURITIES": "CYBERSECURITY, the state of being safe from electronic crime and the measures taken to achieve this [n]\n",
  "CYBERSECURITY": "the state of being safe from electronic crime and the measures taken to achieve this [n CYBERSECURITIES]\n",
  "CYBERSEX": "sexual communication through computer networks [n -ES]\n",
  "CYBERSEXES": "CYBERSEX, sexual communication through computer networks [n]\n",
  "CYBERSPACE": "the virtual world of computers [n -S]\n",
  "CYBERSPACES": "CYBERSPACE, the virtual world of computers [n]\n",
  "CYBERSQUATTER": "one who engages in cybersquatting [n -S]\n",
  "CYBERSQUATTERS": "CYBERSQUATTER, one who engages in cybersquatting [n]\n",
  "CYBERSQUATTING": "the practice of registering an internet domain name that is likely to be wanted by another person or organisation [n -S]\n",
  "CYBERSQUATTINGS": "CYBERSQUATTING, the practice of registering an internet domain name that is likely to be wanted by another person or organisation [n]\n",
  "CYBERSTALKER": "one who uses electronic communications to harass someone persistently [n -S]\n",
  "CYBERSTALKERS": "CYBERSTALKER, one who uses electronic communications to harass someone persistently [n]\n",
  "CYBERSTALKING": "the practice of using electronic communications to harass someone persistently [n CYBERSTALKINGS]\n",
  "CYBERSTALKINGS": "CYBERSTALKING, the practice of using electronic communications to harass someone persistently [n]\n",
  "CYBERTERRORISM": "computer-related terrorism [n -S]\n",
  "CYBERTERRORISMS": "CYBERTERRORISM, computer-related terrorism [n]\n",
  "CYBERTERRORIST": "a terrorist who attacks computer networks [n -S]\n",
  "CYBERTERRORISTS": "CYBERTERRORIST, a terrorist who attacks computer networks [n]\n",
  "CYBERWAR": "crippling an enemy state's computer communication [n -S]\n",
  "CYBERWARS": "CYBERWAR, crippling an enemy state's computer communication [n]\n",
  "CYBORG": "a robot made of biological and mechanical components [n -S]\n",
  "CYBORGS": "CYBORG, a robot made of biological and mechanical components [n]\n",
  "CYBRARIAN": "a person in charge of computer archives [n -S]\n",
  "CYBRARIANS": "CYBRARIAN, a person in charge of computer archives [n]\n",
  "CYBRID": "a cell, plant etc. possessing the nuclear genome of one plant with at least some part of the genome of the other [n -S]\n",
  "CYBRIDS": "CYBRID, a cell, plant etc. possessing the nuclear genome of one plant with at least some part of the genome of the other [n]\n",
  "CYCAD": "any member of an order of primitive gymnospermous plants, related to conifers but superficially resembling ferns and palms, also CYCAS [n -S]\n",
  "CYCADACEOUS": "belonging to the cycad family [adj]\n",
  "CYCADEOID": "a member of the cycad family [n -S]\n",
  "CYCADEOIDS": "CYCADEOID, a member of the cycad family [n]\n",
  "CYCADOPHYTE": "any of a division of usually unbranched mostly extinct gymnosperms [n -S]\n",
  "CYCADOPHYTES": "CYCADOPHYTE, any of a division of usually unbranched mostly extinct gymnosperms [n]\n",
  "CYCADS": "CYCAD, any member of an order of primitive gymnospermous plants, related to conifers but superficially resembling ferns and palms, also CYCAS [n]\n",
  "CYCAS": "any member of an order of primitive gymnospermous plants, related to conifers but superficially resembling ferns and palms, also CYCAD [n -ES]\n",
  "CYCASES": "CYCAS, any member of an order of primitive gymnospermous plants, related to conifers but superficially resembling ferns and palms, also CYCAD [n]\n",
  "CYCASIN": "a derivative of sugar [n -S]\n",
  "CYCASINS": "CYCASIN, a derivative of sugar [n]\n",
  "CYCLAMATE": "any of a number of very sweet substances derived from petrochemicals [n -S]\n",
  "CYCLAMATES": "CYCLAMATE, any of a number of very sweet substances derived from petrochemicals [n]\n",
  "CYCLAMEN": "a primulaceous flowering plant [n -S]\n",
  "CYCLAMENS": "CYCLAMEN, a primulaceous flowering plant [n]\n",
  "CYCLAMIC": "as in cyclamic acid, an acid used in the produciton of paints and plastics [adj]\n",
  "CYCLANDELATE": "a drug whose effect is to dilate the veins, etc., used to improve circulation e.g. in cerebrovascular disease [n -S]\n",
  "CYCLANDELATES": "CYCLANDELATE, a drug whose effect is to dilate the veins, etc., used to improve circulation e.g. in cerebrovascular disease [n]\n",
  "CYCLANTHACEOUS": "belonging to the Cyclanthaceae, a tropical South American family of plants related to the screw-pines [adj]\n",
  "CYCLASE": "an enzyme that acts as a catalyst in the formation of certain compounds [n -S]\n",
  "CYCLASES": "CYCLASE, an enzyme that acts as a catalyst in the formation of certain compounds [n]\n",
  "CYCLAZOCINE": "a synthetic drug protecting against the addictive effects of the morphine group [n -S]\n",
  "CYCLAZOCINES": "CYCLAZOCINE, a synthetic drug protecting against the addictive effects of the morphine group [n]\n",
  "CYCLE": "to ride a bicycle [v CYCLED, CYCLING, CYCLES]\n",
  "CYCLECAR": "a type of motor vehicle [n -S]\n",
  "CYCLECARS": "CYCLECAR, a type of motor vehicle [n]\n",
  "CYCLED": "CYCLE, to ride a bicycle [v]\n",
  "CYCLEPATH": "a special route for cyclists [n -S]\n",
  "CYCLEPATHS": "CYCLEPATH, a special route for cyclists [n]\n",
  "CYCLER": "(US) a cyclist [n -S]\n",
  "CYCLERIES": "CYCLERY, a bicycle shop [n]\n",
  "CYCLERS": "CYCLER, (US) a cyclist [n]\n",
  "CYCLERY": "a bicycle shop [n CYCLERIES]\n",
  "CYCLES": "CYCLE, to ride a bicycle [v]\n",
  "CYCLEWAY": "a path reserved for cyclists [n -S]\n",
  "CYCLEWAYS": "CYCLEWAY, a path reserved for cyclists [n]\n",
  "CYCLIC": "moving in complete circles [adj CYCLICLY or CYCLICALLY]\n",
  "CYCLICAL": "relating to a cycle [adj CYCLICALLY] / stock whose earnings fluctuate with the economy [n -S]\n",
  "CYCLICALITIES": "CYCLICALITY, the state of being cyclical [n]\n",
  "CYCLICALITY": "the state of being cyclical [n CYCLICALITIES]\n",
  "CYCLICALLY": "CYCLICAL, relating to a cycle [adv]\n",
  "CYCLICALS": "CYCLICAL, stock whose earnings fluctuate with the economy [n]\n",
  "CYCLICISM": "the state of being cyclic, also CYCLICITY [n -S]\n",
  "CYCLICISMS": "CYCLICISM, the state of being cyclic, also CYCLICITY [n]\n",
  "CYCLICITIES": "CYCLICITY, the state of being cyclic, also CYCLICISM [n]\n",
  "CYCLICITY": "the state of being cyclic, also CYCLICISM [n CYCLICITIES]\n",
  "CYCLICLY": "CYCLIC, moving in complete circles [adv]\n",
  "CYCLIN": "any of a group of proteins that control the cell cycle [n -S]\n",
  "CYCLING": "the act of riding a bicycle [n -S]\n",
  "CYCLINGS": "CYCLING, the act of riding a bicycle [n]\n",
  "CYCLINS": "CYCLIN, any of a group of proteins that control the cell cycle [n]\n",
  "CYCLISATION": "the formation of a ring in a chemical compound, also CYCLIZATION [n -S]\n",
  "CYCLISATIONS": "CYCLISATION, the formation of a ring in a chemical compound, also CYCLIZATION [n]\n",
  "CYCLISE": "to form one or more rings in a chemical compound, also CYCLIZE [v CYCLISED, CYCLISING, CYCLISES]\n",
  "CYCLISED": "CYCLISE, to form one or more rings in a chemical compound, also CYCLIZE [v]\n",
  "CYCLISES": "CYCLISE, to form one or more rings in a chemical compound, also CYCLIZE [v]\n",
  "CYCLISING": "CYCLISE, to form one or more rings in a chemical compound, also CYCLIZE [v]\n",
  "CYCLIST": "one who rides a bicycle [n -S]\n",
  "CYCLISTS": "CYCLIST, one who rides a bicycle [n]\n",
  "CYCLITOL": "an alicyclic compound [n -S]\n",
  "CYCLITOLS": "CYCLITOL, an alicyclic compound [n]\n",
  "CYCLIZATION": "the formation of a ring in a chemical compound, also CYCLISATION [n -S]\n",
  "CYCLIZATIONS": "CYCLIZATION, the formation of a ring in a chemical compound, also CYCLISATION [n]\n",
  "CYCLIZE": "to form one or more rings in a chemical compound, also CYCLISE [v CYCLIZED, CYCLIZING, CYCLIZES]\n",
  "CYCLIZED": "CYCLIZE, to form one or more rings in a chemical compound, also CYCLISE [v]\n",
  "CYCLIZES": "CYCLIZE, to form one or more rings in a chemical compound, also CYCLISE [v]\n",
  "CYCLIZINE": "an antihistamine drug used to relieve travel and postoperative sickness [n -S]\n",
  "CYCLIZINES": "CYCLIZINE, an antihistamine drug used to relieve travel and postoperative sickness [n]\n",
  "CYCLIZING": "CYCLIZE, to form one or more rings in a chemical compound, also CYCLISE [v]\n",
  "CYCLO": "a three wheeled motor vehicle [n -S]\n",
  "CYCLOADDITION": "a chemical reaction leading to ring formation in a compound [n -S]\n",
  "CYCLOADDITIONS": "CYCLOADDITION, a chemical reaction leading to ring formation in a compound [n]\n",
  "CYCLOALIPHATIC": "denoting organic compounds that are both aliphatic and cyclic, i.e. aliphatic in chemical behaviour but having their carbon atoms in a ring, also ALICYCLIC [adj]\n",
  "CYCLOALKANE": "an alicyclic hydrocarbon with a saturated ring, aka cycloparaffin [n -S]\n",
  "CYCLOALKANES": "CYCLOALKANE, an alicyclic hydrocarbon with a saturated ring, aka cycloparaffin [n]\n",
  "CYCLOBARBITONE": "a barbiturate drug used as a hypnotic and sedative [n -S]\n",
  "CYCLOBARBITONES": "CYCLOBARBITONE, a barbiturate drug used as a hypnotic and sedative [n]\n",
  "CYCLODEXTRIN": "any of several water-soluble carbohydrates with hydrophobic interiors, used to provide capsules for drugs [n -S]\n",
  "CYCLODEXTRINS": "CYCLODEXTRIN, any of several water-soluble carbohydrates with hydrophobic interiors, used to provide capsules for drugs [n]\n",
  "CYCLODIALYSES": "CYCLODIALYSIS, an operation to reduce pressure in the eye in glaucoma patients [n]\n",
  "CYCLODIALYSIS": "an operation to reduce pressure in the eye in glaucoma patients [n CYCLODIALYSES]\n",
  "CYCLODIENE": "a kind of organic insecticide [n -S]\n",
  "CYCLODIENES": "CYCLODIENE, a kind of organic insecticide [n]\n",
  "CYCLOGENESES": "CYCLOGENESIS, the development or intensification of a cyclone [n]\n",
  "CYCLOGENESIS": "the development or intensification of a cyclone [n CYCLOGENESES]\n",
  "CYCLOGIRO": "an aircraft lifted and propelled by pivoted blades [n -S]\n",
  "CYCLOGIROS": "CYCLOGIRO, an aircraft lifted and propelled by pivoted blades [n]\n",
  "CYCLOGRAPH": "an instrument for describing arcs of circles without compasses [n -S]\n",
  "CYCLOGRAPHIC": "relating to a cyclograph, an instrument for describing arcs of circles without compasses [adj]\n",
  "CYCLOGRAPHS": "CYCLOGRAPH, an instrument for describing arcs of circles without compasses [n]\n",
  "CYCLOHEXANE": "a pungent saturated cyclic hydrocarbon found in petroleum or made synthetically and used chiefly as a solvent and in organic synthesis [n -S]\n",
  "CYCLOHEXANES": "CYCLOHEXANE, a pungent saturated cyclic hydrocarbon found in petroleum or made synthetically and used chiefly as a solvent and in organic synthesis [n]\n",
  "CYCLOHEXANONE": "a liquid ketone used esp. as a solvent and in organic synthesis [n -S]\n",
  "CYCLOHEXANONES": "CYCLOHEXANONE, a liquid ketone used esp. as a solvent and in organic synthesis [n]\n",
  "CYCLOHEXIMIDE": "an agricultural fungicide that inhibits protein synthesis and is obtained from a soil bacterium, Streptomyces griseus [n -S]\n",
  "CYCLOHEXIMIDES": "CYCLOHEXIMIDE, an agricultural fungicide that inhibits protein synthesis and is obtained from a soil bacterium, Streptomyces griseus [n]\n",
  "CYCLOHEXYLAMINE": "a colorless liquid amine that is used in organic synthesis and to prevent corrosion in boilers and that is believed to be harmful as a metabolic breakdown product of cyclamate [n]\n",
  "CYCLOID": "a curve traced by a point on the circumference of a circle which rolls along a straight line [n -S]\n",
  "CYCLOIDAL": "of or like a cycloid, a curve traced by a point on the circumference of a circle which rolls along a straight line [adj]\n",
  "CYCLOIDALLY": "CYCLOIDAL, of or like a cycloid, a curve traced by a point on the circumference of a circle which rolls along a straight line [adv]\n",
  "CYCLOIDIAN": "a fish with cycloid scales [n -S]\n",
  "CYCLOIDIANS": "CYCLOIDIAN, a fish with cycloid scales [n]\n",
  "CYCLOIDS": "CYCLOID, a curve traced by a point on the circumference of a circle which rolls along a straight line [n]\n",
  "CYCLOLITH": "a stone circle [n -S]\n",
  "CYCLOLITHS": "CYCLOLITH, a stone circle [n]\n",
  "CYCLOMETER": "instrument for measuring revolutions of a wheel [n -S]\n",
  "CYCLOMETERS": "CYCLOMETER, instrument for measuring revolutions of a wheel [n]\n",
  "CYCLOMETRIES": "CYCLOMETRY, measurement by use of a cyclometer, an instrument for measuring revolutions of a wheel [n]\n",
  "CYCLOMETRY": "measurement by use of a cyclometer, an instrument for measuring revolutions of a wheel [n CYCLOMETRIES]\n",
  "CYCLONAL": "relating to a cyclone [adj]\n",
  "CYCLONE": "a rotating system of winds [n -S]\n",
  "CYCLONES": "CYCLONE, a rotating system of winds [n]\n",
  "CYCLONIC": "relating to a cyclone [adj CYCLONICALLY]\n",
  "CYCLONICAL": "of or like a cyclone, a circular storm, also CYCLONIC [adj CYCLONICALLY]\n",
  "CYCLONICALLY": "CYCLONICAL, of or like a cyclone, a circular storm, also CYCLONIC [adv]\n",
  "CYCLONITE": "a type of explosive, aka RDX (Research Department Explosive) [n -S]\n",
  "CYCLONITES": "CYCLONITE, a type of explosive, aka RDX (Research Department Explosive) [n]\n",
  "CYCLOOLEFIN": "a hydrocarbon containing a ring having one or more double bonds [n -S]\n",
  "CYCLOOLEFINIC": "of or like a cycloolefin [adj]\n",
  "CYCLOOLEFINS": "CYCLOOLEFIN, a hydrocarbon containing a ring having one or more double bonds [n]\n",
  "CYCLOPAEDIA": "an encyclopaedia, also CYCLOPEDIA [n -S]\n",
  "CYCLOPAEDIAS": "CYCLOPAEDIA, an encyclopaedia, also CYCLOPEDIA [n]\n",
  "CYCLOPAEDIC": "encyclopaedic, also CYCLOPEDIC [adj]\n",
  "CYCLOPAEDIST": "one who writes encyclopaedias [n -S]\n",
  "CYCLOPAEDISTS": "CYCLOPAEDIST, one who writes encyclopaedias [n]\n",
  "CYCLOPARAFFIN": "a saturated hydrocarbon containing a ring of carbon atoms joined by single bonds, aka cycloalkane [n -S]\n",
  "CYCLOPARAFFINS": "CYCLOPARAFFIN, a saturated hydrocarbon containing a ring of carbon atoms joined by single bonds, aka cycloalkane [n]\n",
  "CYCLOPEAN": "relating to a prehistoric Greek style of masonry with immense stones of irregular form, also CYCLOPIAN [adj]\n",
  "CYCLOPEDIA": "an encyclopaedia, also CYCLOPAEDIA [n -S]\n",
  "CYCLOPEDIAS": "CYCLOPEDIA, an encyclopaedia, also CYCLOPAEDIA [n]\n",
  "CYCLOPEDIC": "encyclopaedic, also CYCLOPAEDIC [adj]\n",
  "CYCLOPEDIST": "one who makes encyclopedias [n -S]\n",
  "CYCLOPEDISTS": "CYCLOPEDIST, one who makes encyclopedias [n]\n",
  "CYCLOPENTADIENE": "a colourless liquid unsaturated cyclic hydrocarbon obtained in the cracking of petroleum hydrocarbons and the distillation of coal tar, used in the manufacture of plastics and insecticides [n]\n",
  "CYCLOPENTANE": "a colourless insoluble cycloalkane found in petroleum and used mainly as a solvent [n -S]\n",
  "CYCLOPENTANES": "CYCLOPENTANE, a colourless insoluble cycloalkane found in petroleum and used mainly as a solvent [n]\n",
  "CYCLOPENTOLATE": "a drug used in eye drops to dilate the pupil and also to treat inflammatory disorders of the eye [n -S]\n",
  "CYCLOPENTOLATES": "CYCLOPENTOLATE, a drug used in eye drops to dilate the pupil and also to treat inflammatory disorders of the eye [n]\n",
  "CYCLOPES": "CYCLOPS, a genus of freshwater copepods [n]\n",
  "CYCLOPIAN": "relating to a prehistoric Greek style of masonry with immense stones of irregular form, also CYCLOPEAN [adj]\n",
  "CYCLOPIC": "like a cyclops [adj]\n",
  "CYCLOPLEGIA": "loss of visual accommodation because of ciliary muscle paralysis [n -S]\n",
  "CYCLOPLEGIAS": "CYCLOPLEGIA, loss of visual accommodation because of ciliary muscle paralysis [n]\n",
  "CYCLOPLEGIC": "suffering from cycloplegia [adj]\n",
  "CYCLOPROPANE": "a flammable gaseous saturated cyclic hydrocarbon sometimes used as a general anesthetic [n -S]\n",
  "CYCLOPROPANES": "CYCLOPROPANE, a flammable gaseous saturated cyclic hydrocarbon sometimes used as a general anesthetic [n]\n",
  "CYCLOPS": "a genus of freshwater copepods [n CYCLOPS] / a one-eyed monster [n CYCLOPES]\n",
  "CYCLORAMA": "a circular panorama [n -S]\n",
  "CYCLORAMAS": "CYCLORAMA, a circular panorama [n]\n",
  "CYCLORAMIC": "of or like a cyclorama, a circular panorama [adj]\n",
  "CYCLOS": "CYCLO, a three wheeled motor vehicle [n]\n",
  "CYCLOSERINE": "a broad-spectrum antibiotic used esp. in the treatment of tuberculosis [n -S]\n",
  "CYCLOSERINES": "CYCLOSERINE, a broad-spectrum antibiotic used esp. in the treatment of tuberculosis [n]\n",
  "CYCLOSES": "CYCLOSIS, the circulation of cytoplasm [n]\n",
  "CYCLOSIS": "the circulation of cytoplasm [n CYCLOSES]\n",
  "CYCLOSPERMOUS": "with the embryo bent round the endosperm [adj]\n",
  "CYCLOSPORIN": "an immunosuppressant drug used in organ transplants, also CYCLOSPORINE [n -S]\n",
  "CYCLOSPORINE": "an immunosuppressive drug used in organ transplants, also CYCLOSPORIN [n -S]\n",
  "CYCLOSPORINES": "CYCLOSPORINE, an immunosuppressive drug used in organ transplants, also CYCLOSPORIN [n]\n",
  "CYCLOSPORINS": "CYCLOSPORIN, an immunosuppressant drug used in organ transplants, also CYCLOSPORINE [n]\n",
  "CYCLOSTOMATE": "of or like a cyclostome [adj]\n",
  "CYCLOSTOMATOUS": "of or like a cyclostome [adj]\n",
  "CYCLOSTOME": "the lamprey [n -S]\n",
  "CYCLOSTOMES": "CYCLOSTOME, the lamprey [n]\n",
  "CYCLOSTOMOUS": "of or like a cyclostome [adj]\n",
  "CYCLOSTYLE": "to make copies using a kind of stencilling device [v CYCLOSTYLED, CYCLOSTYLING, CYCLOSTYLES]\n",
  "CYCLOSTYLED": "CYCLOSTYLE, to make copies using a kind of stencilling device [v]\n",
  "CYCLOSTYLES": "CYCLOSTYLE, to make copies using a kind of stencilling device [v]\n",
  "CYCLOSTYLING": "CYCLOSTYLE, to make copies using a kind of stencilling device [v]\n",
  "CYCLOTHYME": "a person with a cyclothymic temperament, having alternating moods of euphoria and depression [n -S]\n",
  "CYCLOTHYMES": "CYCLOTHYME, a person with a cyclothymic temperament, having alternating moods of euphoria and depression [n]\n",
  "CYCLOTHYMIA": "a mental condition of alternating moods of euphoria and depression [n -S]\n",
  "CYCLOTHYMIAC": "one suffering from cyclothymia [n -S]\n",
  "CYCLOTHYMIACS": "CYCLOTHYMIAC, one suffering from cyclothymia [n]\n",
  "CYCLOTHYMIAS": "CYCLOTHYMIA, a mental condition of alternating moods of euphoria and depression [n]\n",
  "CYCLOTHYMIC": "one suffering from cyclothymia [n -S]\n",
  "CYCLOTHYMICS": "CYCLOTHYMIC, one suffering from cyclothymia [n]\n",
  "CYCLOTOMIC": "a mathematical term relating to a polynomial [adj]\n",
  "CYCLOTRON": "a type of particle accelerator [n -S]\n",
  "CYCLOTRONS": "CYCLOTRON, a type of particle accelerator [n]\n",
  "CYCLUS": "(Latin) a cycle of myths, poems, songs, etc. [n -ES]\n",
  "CYCLUSES": "CYCLUS, (Latin) a cycle of myths, poems, songs, etc. [n]\n",
  "CYDER": "an alcoholic drink made from the fermented juice of apples, also CIDER [n -S]\n",
  "CYDERS": "CYDER, an alcoholic drink made from the fermented juice of apples, also CIDER [n]\n",
  "CYESES": "CYESIS, (Greek) pregnancy [n]\n",
  "CYESIS": "(Greek) pregnancy [n CYESES]\n",
  "CYGNET": "a young swan [n -S]\n",
  "CYGNETS": "CYGNET, a young swan [n]\n",
  "CYLICES": "CYLIX, (Greek) a shallow two-handled drinking-cup, also KYLIX [n]\n",
  "CYLIKES": "CYLIX, (Greek) a shallow two-handled drinking-cup, also KYLIX [n]\n",
  "CYLINDER": "to provide with a tubular chamber [v -ED, -ING, -S]\n",
  "CYLINDERED": "CYLINDER, to provide with a tubular chamber [v]\n",
  "CYLINDERING": "CYLINDER, to provide with a tubular chamber [v]\n",
  "CYLINDERS": "CYLINDER, to provide with a tubular chamber [v]\n",
  "CYLINDRACEOUS": "somewhat cylindrical [adj]\n",
  "CYLINDRIC": "shaped like a cylinder, also CYLINDRICAL [adj CYLINDRICALLY]\n",
  "CYLINDRICAL": "shaped like a cylinder, also CYLINDRIC [adj CYLINDRICALLY]\n",
  "CYLINDRICALITY": "the state of being cylindrical [n]\n",
  "CYLINDRICALLY": "CYLINDRICAL, shaped like a cylinder, also CYLINDRIC [adv]\n",
  "CYLINDRICALNESS": "CYLINDRICAL, shaped like a cylinder, also CYLINDRIC [n]\n",
  "CYLINDRICITIES": "CYLINDRICITY, the state of being cylindrical [n]\n",
  "CYLINDRICITY": "the state of being cylindrical [n CYLINDRICITIES]\n",
  "CYLINDRIFORM": "shaped like a cylinder [adj]\n",
  "CYLINDRITE": "a mineral of cylindrical habit, consisting of tin, sulphur, antimony and lead [n -S]\n",
  "CYLINDRITES": "CYLINDRITE, a mineral of cylindrical habit, consisting of tin, sulphur, antimony and lead [n]\n",
  "CYLINDROID": "a body like a cylinder [n -S]\n",
  "CYLINDROIDS": "CYLINDROID, a body like a cylinder [n]\n",
  "CYLIX": "(Greek) a shallow two-handled drinking-cup, also KYLIX [n CYLICES or CYLIKES]\n",
  "CYMA": "(Latin) a curved moulding, also CYMATIUM [n CYMAS or CYMAE]\n",
  "CYMAE": "CYMA, (Latin) a curved moulding, also CYMATIUM [n]\n",
  "CYMAGRAPH": "an instrument for tracing the outline of mouldings, also CYMOGRAPH [n -S]\n",
  "CYMAGRAPHS": "CYMAGRAPH, an instrument for tracing the outline of mouldings, also CYMOGRAPH [n]\n",
  "CYMAR": "(French) a loose coat, an undergarment formerly worn by women, also CIMAR, SIMAR, SIMARRE, SYMAR [n -S]\n",
  "CYMARS": "CYMAR, (French) a loose coat, an undergarment formerly worn by women, also CIMAR, SIMAR, SIMARRE, SYMAR [n]\n",
  "CYMAS": "CYMA, (Latin) a curved moulding, also CYMATIUM [n]\n",
  "CYMATIA": "CYMATIUM, (Latin) a curved moulding, also CYMA [n]\n",
  "CYMATICS": "the therapeutic use of high frequency sound waves [n]\n",
  "CYMATIUM": "(Latin) a curved moulding, also CYMA [n CYMATIA]\n",
  "CYMBAL": "a percussion instrument, also SYMBOLE [n -S]\n",
  "CYMBALEER": "one who plays the cymbals, also CYMBALER, CYMBALIST [n -S]\n",
  "CYMBALEERS": "CYMBALEER, one who plays the cymbals, also CYMBALER, CYMBALIST [n]\n",
  "CYMBALER": "one who plays the cymbals [n -S]\n",
  "CYMBALERS": "CYMBALER, one who plays the cymbals [n]\n",
  "CYMBALIST": "one who plays the cymbals, also CYMBALEER, CYMBALER [n -S]\n",
  "CYMBALISTS": "CYMBALIST, one who plays the cymbals, also CYMBALEER, CYMBALER [n]\n",
  "CYMBALO": "(Italian) the dulcimer [n CYMBALOES or CYMBALOS]\n",
  "CYMBALOES": "CYMBALO, (Italian) the dulcimer [n]\n",
  "CYMBALOM": "a kind of Hungarian dulcimer, also CIMBALOM [n -S]\n",
  "CYMBALOMS": "CYMBALOM, a kind of Hungarian dulcimer, also CIMBALOM [n]\n",
  "CYMBALOS": "CYMBALO, (Italian) the dulcimer [n]\n",
  "CYMBALS": "CYMBAL, a percussion instrument, also SYMBOLE [n]\n",
  "CYMBIDIA": "CYMBIDIUM, a kind of tropical orchid [n]\n",
  "CYMBIDIUM": "a kind of tropical orchid [n CYMBIDIUMS or CYMBIDIA]\n",
  "CYMBIDIUMS": "CYMBIDIUM, a kind of tropical orchid [n]\n",
  "CYMBIFORM": "boat-shaped [adj]\n",
  "CYMBLING": "a variety of squash, also CYMLIN, CYMLING, SIMLIN [n -S]\n",
  "CYMBLINGS": "CYMBLING, a variety of squash, also CYMLIN, CYMLING, SIMLIN [n]\n",
  "CYME": "a type of flower cluster [n -S]\n",
  "CYMENE": "a hydrocarbon, also CYMOL [n -S]\n",
  "CYMENES": "CYMENE, a hydrocarbon, also CYMOL [n]\n",
  "CYMES": "CYME, a type of flower cluster [n]\n",
  "CYMIFEROUS": "bearing cymes [adj]\n",
  "CYMLIN": "a variety of squash, also CYMBLING, CYMLING, SIMLIN [n -S]\n",
  "CYMLING": "a variety of squash, also CYMBLING, CYMLIN, SIMLIN [n -S]\n",
  "CYMLINGS": "CYMLING, a variety of squash, also CYMBLING, CYMLIN, SIMLIN [n]\n",
  "CYMLINS": "CYMLIN, a variety of squash, also CYMBLING, CYMLING, SIMLIN [n]\n",
  "CYMOGENE": "a volatile compound [n -S]\n",
  "CYMOGENES": "CYMOGENE, a volatile compound [n]\n",
  "CYMOGRAPH": "an instrument for tracing the outline of mouldings, also CYMAGRAPH [n -S]\n",
  "CYMOGRAPHIC": "relating to a cymograph [adj]\n",
  "CYMOGRAPHS": "CYMOGRAPH, an instrument for tracing the outline of mouldings, also CYMAGRAPH [n]\n",
  "CYMOID": "like a cyme, a type of flower cluster [adj]\n",
  "CYMOL": "a hydrocarbon, also CYMENE [n -S]\n",
  "CYMOLS": "CYMOL, a hydrocarbon, also CYMENE [n]\n",
  "CYMOPHANE": "cat's-eye, a variety of chrysoberyl with wavy opalescence [n -S]\n",
  "CYMOPHANES": "CYMOPHANE, cat's-eye, a variety of chrysoberyl with wavy opalescence [n]\n",
  "CYMOPHANOUS": "opalescent [adj]\n",
  "CYMOSE": "resembling a cyme, also CYMOUS [adj]\n",
  "CYMOSELY": "CYMOSE, resembling a cyme, also CYMOUS [adv]\n",
  "CYMOTRICHIES": "CYMOTRICHY, the state of being cymotrichous, having wavy hair [n]\n",
  "CYMOTRICHOUS": "having wavy hair [adj]\n",
  "CYMOTRICHY": "the state of being cymotrichous, having wavy hair [n CYMOTRICHIES]\n",
  "CYMOUS": "resembling a cyme, also CYMOSE [adj]\n",
  "CYNANCHE": "(Greek) any inflammatory disease of the throat, etc. [n -S]\n",
  "CYNANCHES": "CYNANCHE, (Greek) any inflammatory disease of the throat, etc. [n]\n",
  "CYNEGETIC": "related to hunting [adj]\n",
  "CYNGHANEDD": "(Welsh) a technique in Welsh verse [n -S]\n",
  "CYNGHANEDDS": "CYNGHANEDD, (Welsh) a technique in Welsh verse [n]\n",
  "CYNIC": "someone who takes a pessimistic view of human motives and actions [n -S]\n",
  "CYNICAL": "distrusting [adj CYNICALLY]\n",
  "CYNICALLY": "CYNICAL, distrusting [adv]\n",
  "CYNICALNESS": "the state of being cynical [n -ES]\n",
  "CYNICALNESSES": "CYNICALNESS, the state of being cynical [n]\n",
  "CYNICISM": "suspicion of human nature [n -S]\n",
  "CYNICISMS": "CYNICISM, suspicion of human nature [n]\n",
  "CYNICS": "CYNIC, someone who takes a pessimistic view of human motives and actions [n]\n",
  "CYNODONT": "a carnivorous mammal-like reptile of the late Permian and Triassic [n -S]\n",
  "CYNODONTS": "CYNODONT, a carnivorous mammal-like reptile of the late Permian and Triassic [n]\n",
  "CYNOMOLGI": "CYNOMOLGUS, a type of macaque [n]\n",
  "CYNOMOLGUS": "a type of macaque [n CYNOMOLGI or CYNOMOLGUSES]\n",
  "CYNOMOLGUSES": "CYNOMOLGUS, a type of macaque [n]\n",
  "CYNOPHILIA": "the love of dogs, also CANOPHILIA [n -S]\n",
  "CYNOPHILIAS": "CYNOPHILIA, the love of dogs, also CANOPHILIA [n]\n",
  "CYNOPHILIST": "a lover of dogs, also CANOPHILIST [n -S]\n",
  "CYNOPHILISTS": "CYNOPHILIST, a lover of dogs, also CANOPHILIST [n]\n",
  "CYNOPHOBIA": "the morbid fear of dogs [n -S]\n",
  "CYNOPHOBIAS": "CYNOPHOBIA, the morbid fear of dogs [n]\n",
  "CYNOPODOUS": "having claws that do not retract, as dogs [adj]\n",
  "CYNOSURAL": "relating to a cynosure, a centre of attention [adj]\n",
  "CYNOSURE": "a centre of attraction [n -S]\n",
  "CYNOSURES": "CYNOSURE, a centre of attraction [n]\n",
  "CYPERACEOUS": "belonging to the Cyperaceae, a family of grasslike plants including the sedges, certain rushes and papyrus [adj]\n",
  "CYPHER": "to write in a kind of code, also CIPHER [v -ED, -ING, -S]\n",
  "CYPHERED": "CYPHER, to write in a kind of code, also CIPHER [v]\n",
  "CYPHERING": "CYPHER, to write in a kind of code, also CIPHER [v]\n",
  "CYPHERS": "CYPHER, to write in a kind of code, also CIPHER [v]\n",
  "CYPRES": "the legal doctrine of applying money left for a charity to an object as close as possible to the original when the original is impractical [n -ES]\n",
  "CYPRESES": "CYPRES, the legal doctrine of applying money left for a charity to an object as close as possible to the original when the original is impractical [n]\n",
  "CYPRESS": "a coniferous tree [n -ES]\n",
  "CYPRESSES": "CYPRESS, a coniferous tree [n]\n",
  "CYPRIAN": "a lewd woman; a prostitute [n -S]\n",
  "CYPRIANS": "CYPRIAN, a lewd woman; a prostitute [n]\n",
  "CYPRID": "a type of barnacle, also CYPRIS [n -S]\n",
  "CYPRIDES": "CYPRIS, a type of barnacle, also CYPRID [n]\n",
  "CYPRIDS": "CYPRID, a type of barnacle, also CYPRIS [n]\n",
  "CYPRINE": "a type of silicate mineral, aka vesuvianite [n -S]\n",
  "CYPRINES": "CYPRINE, a type of silicate mineral, aka vesuvianite [n]\n",
  "CYPRINID": "relating to the carp family, also CYPRINOID [adj] / a member of the carp family of fish [n -S]\n",
  "CYPRINIDS": "CYPRINID, a member of the carp family of fish [n]\n",
  "CYPRINODONT": "any small tropical or subtropical soft-finned fish of the mostly marine family Cyprinodontidae, resembling carp but having toothed jaws [n -S]\n",
  "CYPRINODONTS": "CYPRINODONT, any small tropical or subtropical soft-finned fish of the mostly marine family Cyprinodontidae, resembling carp but having toothed jaws [n]\n",
  "CYPRINOID": "related to the carp family [adj] / a member of the carp family, also CYPRINID [n -S]\n",
  "CYPRINOIDS": "CYPRINOID, a member of the carp family, also CYPRINID [n]\n",
  "CYPRIPEDIA": "CYPRIPEDIUM, a kind of orchid [n]\n",
  "CYPRIPEDIUM": "a kind of orchid [n CYPRIPEDIA]\n",
  "CYPRIPEDIUMS": "CYPRIPEDIUM, a kind of orchid [n]\n",
  "CYPRIS": "a type of barnacle, also CYPRID [n CYPRIDES]\n",
  "CYPROHEPTADINE": "a powerful antihistamine drug used to treat allergies [n -S]\n",
  "CYPROHEPTADINES": "CYPROHEPTADINE, a powerful antihistamine drug used to treat allergies [n]\n",
  "CYPROTERONE": "a synthetic steroid that inhibits androgenic secretions, as of testosterone [n -S]\n",
  "CYPROTERONES": "CYPROTERONE, a synthetic steroid that inhibits androgenic secretions, as of testosterone [n]\n",
  "CYPRUS": "(obsolete) a thin transparent black fabric like crepe [n -ES]\n",
  "CYPRUSES": "CYPRUS, (obsolete) a thin transparent black fabric like crepe [n]\n",
  "CYPSELA": "(Greek) the fruit of members of the daisy family [n CYPSELAE]\n",
  "CYPSELAE": "CYPSELA, (Greek) the fruit of members of the daisy family [n]\n",
  "CYST": "a sac [n -S]\n",
  "CYSTEAMINE": "a cysteine derivative that has been used in the prevention of radiation sickness [n -S]\n",
  "CYSTEAMINES": "CYSTEAMINE, a cysteine derivative that has been used in the prevention of radiation sickness [n]\n",
  "CYSTECTOMIES": "CYSTECTOMY, the surgical removal of a cyst [n]\n",
  "CYSTECTOMY": "the surgical removal of a cyst [n CYSTECTOMIES]\n",
  "CYSTEIN": "an amino acid that oxidizes to cystine, also CYSTEINE [n -S]\n",
  "CYSTEINE": "an amino acid that oxidizes to cystine, also CYSTEIN [n -S]\n",
  "CYSTEINES": "CYSTEINE, an amino acid that oxidizes to cystine, also CYSTEIN [n]\n",
  "CYSTEINIC": "relating to cysteine [adj]\n",
  "CYSTEINS": "CYSTEIN, an amino acid that oxidizes to cystine, also CYSTEINE [n]\n",
  "CYSTIC": "relating to a cyst, also CISTIC [adj]\n",
  "CYSTICERCI": "CYSTICERCUS, the larval stage of many tapeworms [n]\n",
  "CYSTICERCOID": "a tapeworm larva having an invaginated scolex and solid tailpiece [n -S]\n",
  "CYSTICERCOIDS": "CYSTICERCOID, a tapeworm larva having an invaginated scolex and solid tailpiece [n]\n",
  "CYSTICERCOSES": "CYSTICERCOSIS, infestation with or disease caused by cysticerci [n]\n",
  "CYSTICERCOSIS": "infestation with or disease caused by cysticerci [n CYSTICERCOSES]\n",
  "CYSTICERCUS": "the larval stage of many tapeworms [n CYSTICERCI]\n",
  "CYSTID": "a cyst-like structure, also CYSTOID [n -S]\n",
  "CYSTIDEAN": "a cystoid, an extinct echinoderm [n -S]\n",
  "CYSTIDEANS": "CYSTIDEAN, a cystoid, an extinct echinoderm [n]\n",
  "CYSTIDS": "CYSTID, a cyst-like structure, also CYSTOID [n]\n",
  "CYSTIFORM": "like a cyst [adj]\n",
  "CYSTINE": "a sulphur-containing amino present in proteins [n -S]\n",
  "CYSTINES": "CYSTINE, a sulphur-containing amino present in proteins [n]\n",
  "CYSTINOSES": "CYSTINOSIS, a congenital defect of the metabolism that leads to the accumulation of cystine in the kidneys, blood etc. [n]\n",
  "CYSTINOSIS": "a congenital defect of the metabolism that leads to the accumulation of cystine in the kidneys, blood etc. [n CYSTINOSES]\n",
  "CYSTINURIA": "a condition in which excessive levels of the amino acid cystine are present in the urine [n -S]\n",
  "CYSTINURIAS": "CYSTINURIA, a condition in which excessive levels of the amino acid cystine are present in the urine [n]\n",
  "CYSTITIDES": "CYSTITIS, inflammation of the urinary tract [n]\n",
  "CYSTITIS": "inflammation of the urinary tract [n CYSTITISES or CYSTITIDES]\n",
  "CYSTITISES": "CYSTITIS, inflammation of the urinary tract [n]\n",
  "CYSTOCARP": "the fructification in red seaweeds [n -S]\n",
  "CYSTOCARPIC": "relating to a cystocarp [adj]\n",
  "CYSTOCARPS": "CYSTOCARP, the fructification in red seaweeds [n]\n",
  "CYSTOCELE": "a hernia of the bladder [n -S]\n",
  "CYSTOCELES": "CYSTOCELE, a hernia of the bladder [n]\n",
  "CYSTOGENOUS": "forming or secreting cysts [adj]\n",
  "CYSTOGRAPHIES": "CYSTOGRAPHY, radiography of the urinary bladder using a contrast medium [n]\n",
  "CYSTOGRAPHY": "radiography of the urinary bladder using a contrast medium [n CYSTOGRAPHIES]\n",
  "CYSTOID": "a cyst-like structure, also CYSTID [n -S]\n",
  "CYSTOIDS": "CYSTOID, a cyst-like structure, also CYSTID [n]\n",
  "CYSTOLITH": "a hard mineralized ingrowth of the wall of cells in the epidermis of certain plants [n -S]\n",
  "CYSTOLITHIASES": "CYSTOLITHIASIS, the presence of calculi (stones) in the bladder [n]\n",
  "CYSTOLITHIASIS": "the presence of calculi (stones) in the bladder [n CYSTOLITHIASES]\n",
  "CYSTOLITHS": "CYSTOLITH, a hard mineralized ingrowth of the wall of cells in the epidermis of certain plants [n]\n",
  "CYSTOSCOPE": "an instrument for examining the bladder [n -S]\n",
  "CYSTOSCOPES": "CYSTOSCOPE, an instrument for examining the bladder [n]\n",
  "CYSTOSCOPIC": "relating to a cystoscope [adj]\n",
  "CYSTOSCOPIES": "CYSTOSCOPY, an examination using a cystoscope, an instrument for examining the bladder [n]\n",
  "CYSTOSCOPY": "an examination using a cystoscope, an instrument for examining the bladder [n CYSTOSCOPIES]\n",
  "CYSTOSTOMIES": "CYSTOSTOMY, the surgical operation of creating an artificial opening from the bladder to the abdomen [n]\n",
  "CYSTOSTOMY": "the surgical operation of creating an artificial opening from the bladder to the abdomen [n CYSTOSTOMIES]\n",
  "CYSTOTOMIES": "CYSTOTOMY, surgical incision into the bladder [n]\n",
  "CYSTOTOMY": "surgical incision into the bladder [n CYSTOTOMIES]\n",
  "CYSTS": "CYST, a sac [n]\n",
  "CYTASE": "an enzyme that breaks down cellulose [n -S]\n",
  "CYTASES": "CYTASE, an enzyme that breaks down cellulose [n]\n",
  "CYTASTER": "a structure formed in a cell [n -S]\n",
  "CYTASTERS": "CYTASTER, a structure formed in a cell [n]\n",
  "CYTE": "in biology, a cell [n -S]\n",
  "CYTES": "CYTE, in biology, a cell [n]\n",
  "CYTIDINE": "a compound containing cytosine [n -S]\n",
  "CYTIDINES": "CYTIDINE, a compound containing cytosine [n]\n",
  "CYTIDYLIC": "as in cytidylic acid, a nucleotide that is found in DNA [adj]\n",
  "CYTISI": "CYTISUS, (Latin) a plant of the broom genus [n]\n",
  "CYTISINE": "an alkaloid found in laburnum [n -S]\n",
  "CYTISINES": "CYTISINE, an alkaloid found in laburnum [n]\n",
  "CYTISUS": "(Latin) a plant of the broom genus [n CYTISI]\n",
  "CYTOCHALASIN": "any of a group of metabolites isolated from fungi that inhibit various cell processes [n -S]\n",
  "CYTOCHALASINS": "CYTOCHALASIN, any of a group of metabolites isolated from fungi that inhibit various cell processes [n]\n",
  "CYTOCHEMICAL": "relating to cytochemistry [adj]\n",
  "CYTOCHEMISTRIES": "CYTOCHEMISTRY, microscopic biochemistry [n]\n",
  "CYTOCHEMISTRY": "microscopic biochemistry [n CYTOCHEMISTRIES]\n",
  "CYTOCHROME": "any of a group of substances in living cells, of great importance in cell oxidation [n -S]\n",
  "CYTOCHROMES": "CYTOCHROME, any of a group of substances in living cells, of great importance in cell oxidation [n]\n",
  "CYTODE": "a protoplasm body without nucleus [n -S]\n",
  "CYTODES": "CYTODE, a protoplasm body without nucleus [n]\n",
  "CYTODIAGNOSES": "CYTODIAGNOSIS, medical diagnosis following the close examination of the cells of the body tissues or fluids, e.g. the smear test for cervical cancer [n]\n",
  "CYTODIAGNOSIS": "medical diagnosis following the close examination of the cells of the body tissues or fluids, e.g. the smear test for cervical cancer [n CYTODIAGNOSES]\n",
  "CYTOGENESES": "CYTOGENESIS, the formation of cells [n]\n",
  "CYTOGENESIS": "the formation of cells [n CYTOGENESES]\n",
  "CYTOGENETIC": "relating to cytogenetics, also CYTOGENETICAL [adj CYTOGENETICALLY]\n",
  "CYTOGENETICAL": "relating to cytogenetics, also CYTOGENETIC [adj CYTOGENETICALLY]\n",
  "CYTOGENETICALLY": "CYTOGENETICAL, relating to cytogenetics, also CYTOGENETIC [adv]\n",
  "CYTOGENETICIST": "one who studies cytogenetics [n -S]\n",
  "CYTOGENETICISTS": "CYTOGENETICIST, one who studies cytogenetics [n]\n",
  "CYTOGENETICS": "a branch of biology that deals with the study of heredity and variation by the methods of both cytology and genetics [n]\n",
  "CYTOGENIES": "CYTOGENY, the formation of cells [n]\n",
  "CYTOGENY": "the formation of cells [n CYTOGENIES]\n",
  "CYTOID": "cell-like [adj]\n",
  "CYTOKINE": "a protein chemical messenger that assists the immune system [n -S]\n",
  "CYTOKINES": "CYTOKINE, a protein chemical messenger that assists the immune system [n]\n",
  "CYTOKINESES": "CYTOKINESIS, division of the cytoplasm of a cell, occurring at the end of mitosis or meiosis [n]\n",
  "CYTOKINESIS": "division of the cytoplasm of a cell, occurring at the end of mitosis or meiosis [n CYTOKINESES]\n",
  "CYTOKINETIC": "relating to cytokinesis, division of the cytoplasm of a cell [adj]\n",
  "CYTOKININ": "any of numerous substances which regulate plant growth by inducing cell division [n -S]\n",
  "CYTOKININS": "CYTOKININ, any of numerous substances which regulate plant growth by inducing cell division [n]\n",
  "CYTOLOGIC": "relating to cytology, the study of living cells, also CYTOLOGICAL [adj CYTOLOGICALLY]\n",
  "CYTOLOGICAL": "relating to cytology, the study of living cells, also CYTOLOGIC [adj CYTOLOGICALLY]\n",
  "CYTOLOGICALLY": "CYTOLOGICAL, relating to cytology, the study of living cells, also CYTOLOGIC [adv]\n",
  "CYTOLOGIES": "CYTOLOGY, a study of cells [n]\n",
  "CYTOLOGIST": "a student of living cells [n -S]\n",
  "CYTOLOGISTS": "CYTOLOGIST, a student of living cells [n]\n",
  "CYTOLOGY": "a study of cells [n CYTOLOGIES]\n",
  "CYTOLYSES": "CYTOLYSIS, the dissolution of cells esp. by breaking down their outer membrane [n]\n",
  "CYTOLYSIN": "an agent that dissolves cells esp. by breaking down their outer membrane [n -S]\n",
  "CYTOLYSINS": "CYTOLYSIN, an agent that dissolves cells esp. by breaking down their outer membrane [n]\n",
  "CYTOLYSIS": "the dissolution of cells esp. by breaking down their outer membrane [n CYTOLYSES]\n",
  "CYTOLYTIC": "relating to the dissolution of cells esp. by breaking down their outer membrane [adj]\n",
  "CYTOMEGALIC": "having greatly enlarged cells [adj]\n",
  "CYTOMEGALOVIRUS": "any of a group of viruses containing DNA of the herpes family, which cause cells which they infect to enlarge and may cause an illness similar to glandular fever [n]\n",
  "CYTOMEMBRANE": "one of the cellular membranes including those of the plasma membrane, endoplasmic reticulum, nuclear envelope, and Golgi apparatus [n -S]\n",
  "CYTOMEMBRANES": "CYTOMEMBRANE, one of the cellular membranes including those of the plasma membrane, endoplasmic reticulum, nuclear envelope, and Golgi apparatus [n]\n",
  "CYTOMETER": "an instrument for counting cells [n -S]\n",
  "CYTOMETERS": "CYTOMETER, an instrument for counting cells [n]\n",
  "CYTOMETRIC": "relating to cytometry, the counting of cells [adj]\n",
  "CYTOMETRIES": "CYTOMETRY, the counting of cells [n]\n",
  "CYTOMETRY": "the counting of cells [n CYTOMETRIES]\n",
  "CYTON": "(Greek) the body of a nerve cell [n -S]\n",
  "CYTONS": "CYTON, (Greek) the body of a nerve cell [n]\n",
  "CYTOPATHIC": "producing pathological changes in cells [adj]\n",
  "CYTOPATHIES": "CYTOPATHY, a disease or disorder of a cell [n]\n",
  "CYTOPATHOGENIC": "pathologic for or destructive to cells [adj]\n",
  "CYTOPATHOLOGIES": "CYTOPATHOLOGY, the study of cells in illness [n]\n",
  "CYTOPATHOLOGY": "the study of cells in illness [n CYTOPATHOLOGIES]\n",
  "CYTOPATHY": "a disease or disorder of a cell [n CYTOPATHIES]\n",
  "CYTOPENIA": "a deficiency of one or more types of blood cell [n -S]\n",
  "CYTOPENIAS": "CYTOPENIA, a deficiency of one or more types of blood cell [n]\n",
  "CYTOPHILIC": "of e.g. antibodies, having an affinity for cells [adj]\n",
  "CYTOPHOTOMETRIC": "relating to cytophotometry [adj]\n",
  "CYTOPHOTOMETRY": "photometry applied to the study of the cell or its constituents [n]\n",
  "CYTOPLASM": "the protoplasm of a cell surrounding the nucleus [n -S]\n",
  "CYTOPLASMIC": "relating to cytoplasm [adj CYTOPLASMICALLY]\n",
  "CYTOPLASMICALLY": "CYTOPLASMIC, relating to cytoplasm [adv]\n",
  "CYTOPLASMS": "CYTOPLASM, the protoplasm of a cell surrounding the nucleus [n]\n",
  "CYTOPLAST": "the intact cytoplasm of a single cell [n -S]\n",
  "CYTOPLASTIC": "of or relating to a cytoplast, the intact cytoplasm of a single cell [adj]\n",
  "CYTOPLASTS": "CYTOPLAST, the intact cytoplasm of a single cell [n]\n",
  "CYTOSINE": "one of the nitrogen-containing bases forming nucleotides in deoxyribonucleic acid [n -S]\n",
  "CYTOSINES": "CYTOSINE, one of the nitrogen-containing bases forming nucleotides in deoxyribonucleic acid [n]\n",
  "CYTOSKELETAL": "of or like a cytoskeleton [adj]\n",
  "CYTOSKELETON": "the network of protein filaments and microtubules in the cytoplasm that controls cell shape, maintains intracellular organization, and is involved in cell movement [n -S]\n",
  "CYTOSKELETONS": "CYTOSKELETON, the network of protein filaments and microtubules in the cytoplasm that controls cell shape, maintains intracellular organization, and is involved in cell movement [n]\n",
  "CYTOSOL": "the fluid portion of cell material [n -S]\n",
  "CYTOSOLIC": "relating to the cytosol, the fluid portion of cell material [adj]\n",
  "CYTOSOLS": "CYTOSOL, the fluid portion of cell material [n]\n",
  "CYTOSOME": "the part of a cell outside the nucleus [n -S]\n",
  "CYTOSOMES": "CYTOSOME, the part of a cell outside the nucleus [n]\n",
  "CYTOSTATIC": "tending to retard cellular activity and multiplication [adj CYTOSTATICALLY] / a substance tending to retard cellular activity [n -S]\n",
  "CYTOSTATICALLY": "CYTOSTATIC, tending to retard cellular activity and multiplication [adv]\n",
  "CYTOSTATICS": "CYTOSTATIC, a substance tending to retard cellular activity [n]\n",
  "CYTOTAXES": "CYTOTAXIS, movement of cells due to external stimulus [n]\n",
  "CYTOTAXIS": "movement of cells due to external stimulus [n CYTOTAXES]\n",
  "CYTOTAXONOMIC": "relating to cytotaxonomy [adj]\n",
  "CYTOTAXONOMIES": "CYTOTAXONOMY, the classification of organisms based on cell structure, esp. the number, shape, etc., of the chromosomes [n]\n",
  "CYTOTAXONOMIST": "a practitioner of cytotaxonomy [n -S]\n",
  "CYTOTAXONOMISTS": "CYTOTAXONOMIST, a practitioner of cytotaxonomy [n]\n",
  "CYTOTAXONOMY": "the classification of organisms based on cell structure, esp. the number, shape, etc., of the chromosomes [n CYTOTAXONOMIES]\n",
  "CYTOTECHNOLOGY": "the identification of cells and cellular abnormalities in cancer [n]\n",
  "CYTOTOXIC": "of or like a cytotoxin, a substance damaging to cells [adj]\n",
  "CYTOTOXICITIES": "CYTOTOXICITY, the quality of being cytotoxic [n]\n",
  "CYTOTOXICITY": "the quality of being cytotoxic [n CYTOTOXICITIES]\n",
  "CYTOTOXIN": "a cell-damaging drug [n -S]\n",
  "CYTOTOXINS": "CYTOTOXIN, a cell-damaging drug [n]\n",
  "CZAPKA": "(Polish) a Polish military cap, adapted from the traditional peasant cap, worn by lancers, also CHAPKA, SCHAPSKA [n -S]\n",
  "CZAPKAS": "CZAPKA, (Polish) a Polish military cap, adapted from the traditional peasant cap, worn by lancers, also CHAPKA, SCHAPSKA [n]\n",
  "CZAR": "(Russian) an emperor or king, also TSAR, TZAR, KSAR [n -S]\n",
  "CZARDAS": "(Hungarian) a Hungarian dance that increases in speed, also CSARDAS [n -ES]\n",
  "CZARDASES": "CZARDAS, (Hungarian) a Hungarian dance that increases in speed, also CSARDAS [n]\n",
  "CZARDOM": "the domain of a czar, also TSARDOM, TZARDOM [n -S]\n",
  "CZARDOMS": "CZARDOM, the domain of a czar, also TSARDOM, TZARDOM [n]\n",
  "CZAREVICH": "(Russian) the wife of a czar, also TSAREVICH [n -ES]\n",
  "CZAREVICHES": "CZAREVICH, (Russian) the wife of a czar, also TSAREVICH [n]\n",
  "CZAREVITCH": "the son of a czar [n -ES]\n",
  "CZAREVITCHES": "CZAREVITCH, the son of a czar [n]\n",
  "CZAREVNA": "(Russian) the daughter of a czar, also TSAREVNA, TZAREVNA [n -S]\n",
  "CZAREVNAS": "CZAREVNA, (Russian) the daughter of a czar, also TSAREVNA, TZAREVNA [n]\n",
  "CZARINA": "(Russian) the empress of Russia, also CZARITSA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n -S]\n",
  "CZARINAS": "CZARINA, (Russian) the empress of Russia, also CZARITSA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n]\n",
  "CZARISM": "government by a tsar, also TSARISM, TZARISM [n -S]\n",
  "CZARISMS": "CZARISM, government by a tsar, also TSARISM, TZARISM [n]\n",
  "CZARIST": "a supporter of tsarism, also TSARIST, TZARIST [n -S]\n",
  "CZARISTS": "CZARIST, a supporter of tsarism, also TSARIST, TZARIST [n]\n",
  "CZARITSA": "(Russian) the empress of Russia, also CZARINA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n -S]\n",
  "CZARITSAS": "CZARITSA, (Russian) the empress of Russia, also CZARINA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n]\n",
  "CZARITZA": "(Russian) the empress of Russia, also CZARINA, CZARITSA, TSARINA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n -S]\n",
  "CZARITZAS": "CZARITZA, (Russian) the empress of Russia, also CZARINA, CZARITSA, TSARINA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n]\n",
  "CZARS": "CZAR, (Russian) an emperor or king, also TSAR, TZAR, KSAR [n]\n",
  "DA": "(Burmese) a heavy Burmese knife, also DAH [n -S]\n",
  "DAAL": "(Hindi) the pigeon pea, a pealike plant cultivated in India and the tropics, also DAL, DAHL, DHAL, DHOLL [n -S]\n",
  "DAALS": "DAAL, (Hindi) the pigeon pea, a pealike plant cultivated in India and the tropics, also DAL, DAHL, DHAL, DHOLL [n]\n",
  "DAB": "to touch lightly [v DABBED, DABBING, DABS]\n",
  "DABBA": "(Hindi) in Indian cookery, a round metal box used to transport hot food [n -S]\n",
  "DABBAS": "DABBA, (Hindi) in Indian cookery, a round metal box used to transport hot food [n]\n",
  "DABBED": "DAB, to touch lightly [v]\n",
  "DABBER": "a pad for dabbing ink on blocks or plates [n -S]\n",
  "DABBERS": "DABBER, a pad for dabbing ink on blocks or plates [n]\n",
  "DABBING": "DAB, to touch lightly [v]\n",
  "DABBITIES": "DABBITY, (Scots) a cheap pottery figure found at fairgrounds [n]\n",
  "DABBITY": "(Scots) a cheap pottery figure found at fairgrounds [n DABBITIES]\n",
  "DABBLE": "to dip or splash in liquid [v DABBLED, DABBLING, DABBLES]\n",
  "DABBLED": "DABBLE, to dip or splash in liquid [v]\n",
  "DABBLER": "one who dabbles, a dilettante [n -S]\n",
  "DABBLERS": "DABBLER, one who dabbles, a dilettante [n]\n",
  "DABBLES": "DABBLE, to dip or splash in liquid [v]\n",
  "DABBLING": "bobbing forward and under [adj DABBLINGLY] / the act of dabbling [n -S]\n",
  "DABBLINGLY": "DABBLING, bobbing forward and under [adv]\n",
  "DABBLINGS": "DABBLING, the act of dabbling [n]\n",
  "DABCHICK": "the little grebe, also DIPCHICK, DOBCHICK [n -S]\n",
  "DABCHICKS": "DABCHICK, the little grebe, also DIPCHICK, DOBCHICK [n]\n",
  "DABS": "DAB, to touch lightly [v]\n",
  "DABSTER": "one who is skilled; a master of his business; an adept [n -S]\n",
  "DABSTERS": "DABSTER, one who is skilled; a master of his business; an adept [n]\n",
  "DACE": "a small river fish of the carp family and chub genus [n -S]\n",
  "DACES": "DACE, a small river fish of the carp family and chub genus [n]\n",
  "DACHA": "(Russian) a Russian country house, also DATCHA [n -S]\n",
  "DACHAS": "DACHA, (Russian) a Russian country house, also DATCHA [n]\n",
  "DACHSHUND": "(German) a breed of dog [n -S]\n",
  "DACHSHUNDS": "DACHSHUND, (German) a breed of dog [n]\n",
  "DACITE": "a fine-grained volcanic rock [n -S]\n",
  "DACITES": "DACITE, a fine-grained volcanic rock [n]\n",
  "DACK": "(Australian slang) to remove the trousers from, debag [v -ED, -ING, -S]\n",
  "DACKED": "DACK, (Australian slang) to remove the trousers from, debag [v]\n",
  "DACKER": "(Scots) to lounge, saunter, also DAIKER, DAKER [v -ED, -ING, -S]\n",
  "DACKERED": "DACKER, (Scots) to lounge, saunter, also DAIKER, DAKER [v]\n",
  "DACKERING": "DACKER, (Scots) to lounge, saunter, also DAIKER, DAKER [v]\n",
  "DACKERS": "DACKER, (Scots) to lounge, saunter, also DAIKER, DAKER [v]\n",
  "DACKING": "DACK, (Australian slang) to remove the trousers from, debag [v]\n",
  "DACKS": "DACK, (Australian slang) to remove the trousers from, debag [v]\n",
  "DACOIT": "(Hindi) a member of an Indian robber gang, also DAKOIT [n -S]\n",
  "DACOITAGE": "(Hindi) robbery by dacoits, also DACOITY, DAKOITI, DAKOITY [n -S]\n",
  "DACOITAGES": "DACOITAGE, (Hindi) robbery by dacoits, also DACOITY, DAKOITI, DAKOITY [n]\n",
  "DACOITIES": "DACOITY, (Hindi) robbery by dacoits, also DACOITAGE, DAKOITI, DAKOITY [n]\n",
  "DACOITS": "DACOIT, (Hindi) a member of an Indian robber gang, also DAKOIT [n]\n",
  "DACOITY": "(Hindi) robbery by dacoits, also DACOITAGE, DAKOITI, DAKOITY [n DACOITIES]\n",
  "DACQUOISE": "a layered dessert of meringue with nuts, with a buttery chocolate or mocha filling [n -S]\n",
  "DACQUOISES": "DACQUOISE, a layered dessert of meringue with nuts, with a buttery chocolate or mocha filling [n]\n",
  "DACRON": "a synthetic polyester textile fiber [n -S]\n",
  "DACRONS": "DACRON, a synthetic polyester textile fiber [n]\n",
  "DACTYL": "(Greek) a metrical foot of one short syllable followed by two long syllables [n -S]\n",
  "DACTYLAR": "pertaining to a dactyl, also DACTYLIC [adj]\n",
  "DACTYLI": "DACTYLUS, (Greek) the leg joint of certain insects [n]\n",
  "DACTYLIC": "consisting chiefly or wholly of, dactyls, also DACTYLAR [adj DACTYLICALLY] / a dactylic verse [n -S]\n",
  "DACTYLICALLY": "DACTYLIC, consisting chiefly or wholly of, dactyls, also DACTYLAR [adv]\n",
  "DACTYLICS": "DACTYLIC, a dactylic verse [n]\n",
  "DACTYLIOGRAPHY": "the study of gem engraving [n]\n",
  "DACTYLIOLOGIES": "DACTYLIOLOGY, the study of finger-rings [n]\n",
  "DACTYLIOLOGY": "the study of finger-rings [n DACTYLIOLOGIES]\n",
  "DACTYLIOMANCIES": "DACTYLIOMANCY, divination by means of a finger [n]\n",
  "DACTYLIOMANCY": "divination by means of a finger [n DACTYLIOMANCIES]\n",
  "DACTYLIST": "a writer of dactylic verse [n -S]\n",
  "DACTYLISTS": "DACTYLIST, a writer of dactylic verse [n]\n",
  "DACTYLOGRAM": "a fingerprint [n -S]\n",
  "DACTYLOGRAMS": "DACTYLOGRAM, a fingerprint [n]\n",
  "DACTYLOGRAPHER": "one who studies fingerprints [n -S]\n",
  "DACTYLOGRAPHERS": "DACTYLOGRAPHER, one who studies fingerprints [n]\n",
  "DACTYLOGRAPHIC": "relating to dactylography, the study of fingerprints [adj]\n",
  "DACTYLOGRAPHIES": "DACTYLOGRAPHY, the study of fingerprints as a means of identification [n]\n",
  "DACTYLOGRAPHY": "the study of fingerprints as a means of identification [n DACTYLOGRAPHIES]\n",
  "DACTYLOLOGIES": "DACTYLOLOGY, the study of sign language [n]\n",
  "DACTYLOLOGY": "the study of sign language [n DACTYLOLOGIES]\n",
  "DACTYLOSCOPIES": "DACTYLOSCOPY, the comparison of fingerprints for purpose of identification [n]\n",
  "DACTYLOSCOPY": "the comparison of fingerprints for purpose of identification [n DACTYLOSCOPIES]\n",
  "DACTYLS": "DACTYL, (Greek) a metrical foot of one short syllable followed by two long syllables [n]\n",
  "DACTYLUS": "(Greek) the leg joint of certain insects [n DACTYLI]\n",
  "DAD": "to dash against [v DADDED, DADDING, DADS]\n",
  "DADA": "an artistic and literary movement [n -S]\n",
  "DADAH": "(Australian slang) illegal drugs [n -S]\n",
  "DADAHS": "DADAH, (Australian slang) illegal drugs [n]\n",
  "DADAISM": "an artistic movement [n -S]\n",
  "DADAISMS": "DADAISM, an artistic movement [n]\n",
  "DADAIST": "an adherent of dadaism, an artistic movement [n -S]\n",
  "DADAISTIC": "relating to the art movement dadaism [adj]\n",
  "DADAISTS": "DADAIST, an adherent of dadaism, an artistic movement [n]\n",
  "DADAS": "DADA, an artistic and literary movement [n]\n",
  "DADBOD": "an untoned and slightly plump male physique, esp one considered attractive [n -S]\n",
  "DADBODS": "DADBOD, an untoned and slightly plump male physique, esp one considered attractive [n]\n",
  "DADCHELOR": "as in dadchelor party, a party primarily attended by men and held to honour and present gifts to a prospective father [adj]\n",
  "DADDED": "DAD, to dash against [v]\n",
  "DADDIES": "DADDY, (colloquial) father [n]\n",
  "DADDING": "DAD, to dash against [v]\n",
  "DADDLE": "(Scots) to waddle, stagger, also DAIDLE [v DADDLED, DADDLING, DADDLES]\n",
  "DADDLED": "DADDLE, (Scots) to waddle, stagger, also DAIDLE [v]\n",
  "DADDLES": "DADDLE, (Scots) to waddle, stagger, also DAIDLE [v]\n",
  "DADDLING": "DADDLE, (Scots) to waddle, stagger, also DAIDLE [v]\n",
  "DADDOCK": "the heart of a rotten tree [n -S]\n",
  "DADDOCKS": "DADDOCK, the heart of a rotten tree [n]\n",
  "DADDY": "(colloquial) father [n DADDIES]\n",
  "DADGUM": "(colloquial) damned [adj]\n",
  "DADO": "an ornamental groove [n DADOS or DADOES] / to set into a groove [v -ED, -ING, -S]\n",
  "DADOED": "DADO, to set into a groove [v]\n",
  "DADOES": "DADO, an ornamental groove [n]\n",
  "DADOING": "DADO, to set into a groove [v]\n",
  "DADOS": "DADO, an ornamental groove [n]\n",
  "DADS": "DAD, to dash against [v]\n",
  "DAE": "(Scots) to do [v DONE, DID, DAEING, DAES]\n",
  "DAEDAL": "ingenious and cunningly designed, also DAEDALEAN, DAEDALIAN, DAEDALIC, DEDAL, DEDALIAN [adj]\n",
  "DAEDALEAN": "ingenious and cunningly designed, also DAEDAL, DAEDALIAN, DAEDALIC, DEDAL, DEDALIAN [adj]\n",
  "DAEDALIAN": "ingenious and cunningly designed, also DAEDAL, DAEDALEAN, DAEDALIC, DEDAL, DEDALIAN [adj]\n",
  "DAEDALIC": "ingenious and cunningly designed, also DAEDAL, DAEDALEAN, DAEDALIAN, DEDAL, DEDALIAN [adj]\n",
  "DAEING": "DAE, (Scots) to do [v]\n",
  "DAEMON": "(Greek) an inward spirit; personality; genius, also DAIMON [n DAEMONS or DAEMONES]\n",
  "DAEMONES": "DAEMON, (Greek) an inward spirit; personality; genius, also DAIMON [n]\n",
  "DAEMONIC": "having the qualities of a daemon, also DAIMONIC [adj]\n",
  "DAEMONS": "DAEMON, (Greek) an inward spirit; personality; genius, also DAIMON [n]\n",
  "DAES": "DAE, (Scots) to do [v]\n",
  "DAFF": "to play the fool [v -ED, -ING, -S]\n",
  "DAFFADOWNDILLY": "a yellow-flowered narcissus, also DAFFODIL, DAFFODILLY [n]\n",
  "DAFFED": "DAFF, to play the fool [v]\n",
  "DAFFIER": "DAFFY, daft [adj]\n",
  "DAFFIES": "DAFFY, short for daffodil [n]\n",
  "DAFFIEST": "DAFFY, daft [adj]\n",
  "DAFFILY": "DAFFY, daft [adv]\n",
  "DAFFINESS": "the state of being daffy [n -ES]\n",
  "DAFFINESSES": "DAFFINESS, the state of being daffy [n]\n",
  "DAFFING": "playing the fool [n -S]\n",
  "DAFFINGS": "DAFFING, playing the fool [n]\n",
  "DAFFODIL": "a yellow-flowered narcissus, also DAFFADOWNDILLY, DAFFODILLY [n -S]\n",
  "DAFFODILLIES": "DAFFODILLY, a yellow-flowered narcissus, also DAFFADOWNDILLY, DAFFODIL [n]\n",
  "DAFFODILLY": "a yellow-flowered narcissus, also DAFFADOWNDILLY, DAFFODIL [n DAFFODILLIES]\n",
  "DAFFODILS": "DAFFODIL, a yellow-flowered narcissus, also DAFFADOWNDILLY, DAFFODILLY [n]\n",
  "DAFFS": "DAFF, to play the fool [v]\n",
  "DAFFY": "short for daffodil [n DAFFIES] / daft [adj DAFFIER, DAFFIEST, DAFFILY]\n",
  "DAFT": "insane [adj DAFTER, DAFTEST, DAFTLY]\n",
  "DAFTAR": "(Urdu) in India, an office, esp. a military orderly room [n -S]\n",
  "DAFTARS": "DAFTAR, (Urdu) in India, an office, esp. a military orderly room [n]\n",
  "DAFTER": "DAFT, insane [adj]\n",
  "DAFTEST": "DAFT, insane [adj]\n",
  "DAFTIE": "a simpleton [n -S]\n",
  "DAFTIES": "DAFTIE, a simpleton [n]\n",
  "DAFTLY": "DAFT, insane [adv]\n",
  "DAFTNESS": "the quality of being daft [n -ES]\n",
  "DAFTNESSES": "DAFTNESS, the quality of being daft [n]\n",
  "DAG": "to remove clotted tufts of wool from a sheep [v DAGGED, DAGGING, DAGS]\n",
  "DAGABA": "(Sinhalese) a Buddhist memorial shrine, also DAGOBA [n -S]\n",
  "DAGABAS": "DAGABA, (Sinhalese) a Buddhist memorial shrine, also DAGOBA [n]\n",
  "DAGGA": "(Hottentot) marijuana [n -S]\n",
  "DAGGAS": "DAGGA, (Hottentot) marijuana [n]\n",
  "DAGGED": "DAG, to remove clotted tufts of wool from a sheep [v]\n",
  "DAGGER": "to stab with a small knife [v -ED, -ING, -S]\n",
  "DAGGERBOARD": "a light, narrow, completely removable centreboard [n -S]\n",
  "DAGGERBOARDS": "DAGGERBOARD, a light, narrow, completely removable centreboard [n]\n",
  "DAGGERED": "DAGGER, to stab with a small knife [v]\n",
  "DAGGERING": "DAGGER, to stab with a small knife [v]\n",
  "DAGGERLIKE": "like a dagger [adj]\n",
  "DAGGERS": "DAGGER, to stab with a small knife [v]\n",
  "DAGGIER": "DAGGY, (Australian colloquial) scruffy, dishevelled [adj]\n",
  "DAGGIEST": "DAGGY, (Australian colloquial) scruffy, dishevelled [adj]\n",
  "DAGGING": "dirty clotted wool on a sheep [n -S]\n",
  "DAGGINGS": "DAGGING, dirty clotted wool on a sheep [n]\n",
  "DAGGLE": "to drag in mud [v DAGGLED, DAGGLING, DAGGLES]\n",
  "DAGGLED": "DAGGLE, to drag in mud [v]\n",
  "DAGGLES": "DAGGLE, to drag in mud [v]\n",
  "DAGGLING": "DAGGLE, to drag in mud [v]\n",
  "DAGGY": "(Australian colloquial) scruffy, dishevelled [adj DAGGIER, DAGGIEST]\n",
  "DAGLOCK": "a dirty tangled lock of wool [n -S]\n",
  "DAGLOCKS": "DAGLOCK, a dirty tangled lock of wool [n]\n",
  "DAGO": "(offensive) a man of Italian, Spanish or Portuguese origin [n DAGOS or DAGOES]\n",
  "DAGOBA": "(Sinhalese) a Buddhist memorial shrine, also DAGABA [n -S]\n",
  "DAGOBAS": "DAGOBA, (Sinhalese) a Buddhist memorial shrine, also DAGABA [n]\n",
  "DAGOES": "DAGO, (offensive) a man of Italian, Spanish or Portuguese origin [n]\n",
  "DAGOS": "DAGO, (offensive) a man of Italian, Spanish or Portuguese origin [n]\n",
  "DAGS": "DAG, to remove clotted tufts of wool from a sheep [v]\n",
  "DAGUERREAN": "relating to photography by daguerreotype [adj]\n",
  "DAGUERREOTYPE": "to develop by daguerreotype, a method of photography by mercury vapour development of silver iodide [v DAGUERREOTYPED, DAGUERREOTYPING, DAGUERREOTYPES]\n",
  "DAGUERREOTYPED": "DAGUERREOTYPE, to develop by daguerreotype, a method of photography by mercury vapour development of silver iodide [v]\n",
  "DAGUERREOTYPER": "one who develops daguerreotypes, also DAGUERREOTYPIST [n -S]\n",
  "DAGUERREOTYPERS": "DAGUERREOTYPER, one who develops daguerreotypes, also DAGUERREOTYPIST [n]\n",
  "DAGUERREOTYPES": "DAGUERREOTYPE, to develop by daguerreotype, a method of photography by mercury vapour development of silver iodide [v]\n",
  "DAGUERREOTYPIES": "DAGUERREOTYPY, the art of daguerreotyping [n]\n",
  "DAGUERREOTYPING": "DAGUERREOTYPE, to develop by daguerreotype, a method of photography by mercury vapour development of silver iodide [v]\n",
  "DAGUERREOTYPIST": "one who practises daguerreotyping, also DAGUERREOTYPER [n]\n",
  "DAGUERREOTYPY": "the art of daguerreotyping [n DAGUERREOTYPIES]\n",
  "DAGWOOD": "any of various shrubs and trees of genus Cornus, also DOGWOOD [n -S]\n",
  "DAGWOODS": "DAGWOOD, any of various shrubs and trees of genus Cornus, also DOGWOOD [n]\n",
  "DAH": "a dash in morse code [n -S]\n",
  "DAHABEAH": "(Arabic) a Nile sailing boat, also DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n -S]\n",
  "DAHABEAHS": "DAHABEAH, (Arabic) a Nile sailing boat, also DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n]\n",
  "DAHABEEAH": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n -S]\n",
  "DAHABEEAHS": "DAHABEEAH, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n]\n",
  "DAHABEEYAH": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n -S]\n",
  "DAHABEEYAHS": "DAHABEEYAH, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n]\n",
  "DAHABIAH": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n -S]\n",
  "DAHABIAHS": "DAHABIAH, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIEH, DAHABIYA, DAHABIYAH, DAHABIYEH [n]\n",
  "DAHABIEH": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIYA, DAHABIYAH, DAHABIYEH [n -S]\n",
  "DAHABIEHS": "DAHABIEH, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIYA, DAHABIYAH, DAHABIYEH [n]\n",
  "DAHABIYA": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYAH, DAHABIYEH [n -S]\n",
  "DAHABIYAH": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYEH [n -S]\n",
  "DAHABIYAHS": "DAHABIYAH, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYEH [n]\n",
  "DAHABIYAS": "DAHABIYA, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYAH, DAHABIYEH [n]\n",
  "DAHABIYEH": "(Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH [n -S]\n",
  "DAHABIYEHS": "DAHABIYEH, (Arabic) a Nile sailing boat, also DAHABEAH, DAHABEEAH, DAHABEEYAH, DAHABIAH, DAHABIEH, DAHABIYA, DAHABIYAH [n]\n",
  "DAHL": "(Hindi) an Indian name for a lentil, also DAAL, DAL, DHAL, DHOLL [n -S]\n",
  "DAHLIA": "(Swedish) a flowering plant [n -S]\n",
  "DAHLIAS": "DAHLIA, (Swedish) a flowering plant [n]\n",
  "DAHLS": "DAHL, (Hindi) an Indian name for a lentil, also DAAL, DAL, DHAL, DHOLL [n]\n",
  "DAHOON": "a perennial shrub of the holly family [n -S]\n",
  "DAHOONS": "DAHOON, a perennial shrub of the holly family [n]\n",
  "DAHS": "DAH, a dash in morse code [n]\n",
  "DAIDLE": "(Scots) to waddle, stagger, also DADDLE [v DAIDLED, DAIDLING, DAIDLES]\n",
  "DAIDLED": "DAIDLE, (Scots) to waddle, stagger, also DADDLE [v]\n",
  "DAIDLES": "DAIDLE, (Scots) to waddle, stagger, also DADDLE [v]\n",
  "DAIDLING": "DAIDLE, (Scots) to waddle, stagger, also DADDLE [v]\n",
  "DAIDZEIN": "a chemical found chiefly in soybeans [n -S]\n",
  "DAIDZEINS": "DAIDZEIN, a chemical found chiefly in soybeans [n]\n",
  "DAIKER": "(Scots) to lounge, saunter, also DACKER, DAKER [v -ED, -ING, -S]\n",
  "DAIKERED": "DAIKER, (Scots) to lounge, saunter, also DACKER, DAKER [v]\n",
  "DAIKERING": "DAIKER, (Scots) to lounge, saunter, also DACKER, DAKER [v]\n",
  "DAIKERS": "DAIKER, (Scots) to lounge, saunter, also DACKER, DAKER [v]\n",
  "DAIKO": "(Japanese) a large Japanese drum, also TAIKO [n -S]\n",
  "DAIKON": "(Japanese) a long white root vegetable similar to a radish [n -S]\n",
  "DAIKONS": "DAIKON, (Japanese) a long white root vegetable similar to a radish [n]\n",
  "DAIKOS": "DAIKO, (Japanese) a large Japanese drum, also TAIKO [n]\n",
  "DAILIES": "DAILY, a newspaper published every day [n]\n",
  "DAILINESS": "the quality of being daily, also DAILYNESS [n -ES]\n",
  "DAILINESSES": "DAILINESS, the quality of being daily, also DAILYNESS [n]\n",
  "DAILY": "a newspaper published every day [n DAILIES]\n",
  "DAILYNESS": "the state of being daily, also DAILINESS [n -ES]\n",
  "DAILYNESSES": "DAILYNESS, the state of being daily, also DAILINESS [n]\n",
  "DAIMEN": "(Scots) occasional [adj]\n",
  "DAIMIO": "(Japanese) a former Japanese nobleman, also DAIMYO [n -S]\n",
  "DAIMIOS": "DAIMIO, (Japanese) a former Japanese nobleman, also DAIMYO [n]\n",
  "DAIMOKU": "(Japanese) a Buddhist chant [n -S]\n",
  "DAIMOKUS": "DAIMOKU, (Japanese) a Buddhist chant [n]\n",
  "DAIMON": "(Greek) an inward spirit; personality; genius, also DAEMON [n DAIMONES or DAIMONS]\n",
  "DAIMONES": "DAIMON, (Greek) an inward spirit; personality; genius, also DAEMON [n]\n",
  "DAIMONIC": "having the qualities of a daimon, also DAEMONIC [adj]\n",
  "DAIMONS": "DAIMON, (Greek) an inward spirit; personality; genius, also DAEMON [n]\n",
  "DAIMYO": "(Japanese) a former Japanese nobleman, also DAIMIO [n -S]\n",
  "DAIMYOS": "DAIMYO, (Japanese) a former Japanese nobleman, also DAIMIO [n]\n",
  "DAINE": "(Shakespeare) to deign, also DEIGN [v DAINED, DAINING, DAINES]\n",
  "DAINED": "DAINE, (Shakespeare) to deign, also DEIGN [v]\n",
  "DAINES": "DAINE, (Shakespeare) to deign, also DEIGN [v]\n",
  "DAINING": "DAINE, (Shakespeare) to deign, also DEIGN [v]\n",
  "DAINT": "(Spenser) a dainty, also DAYNT [n -S]\n",
  "DAINTIER": "DAINTY, tasteful, delicate [adj]\n",
  "DAINTIES": "DAINTY, something that is tasteful [n]\n",
  "DAINTIEST": "DAINTY, tasteful, delicate [adj]\n",
  "DAINTILY": "DAINTY, tasteful, delicate [adv]\n",
  "DAINTINESS": "the quality of being dainty [n -ES]\n",
  "DAINTINESSES": "DAINTINESS, the quality of being dainty [n]\n",
  "DAINTS": "DAINT, (Spenser) a dainty, also DAYNT [n]\n",
  "DAINTY": "tasteful, delicate [adj DAINTIER, DAINTIEST, DAINTILY] / something that is tasteful [n DAINTIES]\n",
  "DAIQUIRI": "a cocktail, also DAQUIRI [n -S]\n",
  "DAIQUIRIS": "DAIQUIRI, a cocktail, also DAQUIRI [n]\n",
  "DAIRIES": "DAIRY, a shop where dairy products are sold [n]\n",
  "DAIRY": "a shop where dairy products are sold [n DAIRIES]\n",
  "DAIRYING": "the business of a dairy [n -S]\n",
  "DAIRYINGS": "DAIRYING, the business of a dairy [n]\n",
  "DAIRYMAID": "a woman who works in a dairy [n -S]\n",
  "DAIRYMAIDS": "DAIRYMAID, a woman who works in a dairy [n]\n",
  "DAIRYMAN": "a man who owns a dairy [n DAIRYMEN]\n",
  "DAIRYMEN": "DAIRYMAN, a man who owns a dairy [n]\n",
  "DAIS": "(French) a raised platform [n -ES]\n",
  "DAISES": "DAIS, (French) a raised platform [n]\n",
  "DAISHIKI": "(Yoruba) an African tunic, also DASHEKI, DASHIKI [n -S]\n",
  "DAISHIKIS": "DAISHIKI, (Yoruba) an African tunic, also DASHEKI, DASHIKI [n]\n",
  "DAISIED": "adorned with daisies [adj]\n",
  "DAISIES": "DAISY, a flowering plant [n]\n",
  "DAISY": "a flowering plant [n DAISIES]\n",
  "DAISYLIKE": "resembling a daisy [adj]\n",
  "DAISYWHEEL": "a kind of printer [n -S]\n",
  "DAISYWHEELS": "DAISYWHEEL, a kind of printer [n]\n",
  "DAK": "(Hindi) the mail-post in India, also DAWK [n -S]\n",
  "DAKER": "(Scots) to lounge, also DACKER [v -ED, -ING, -S]\n",
  "DAKERED": "DAKER, (Scots) to lounge, also DACKER [v]\n",
  "DAKERHEN": "another name for the corncrake [n -S]\n",
  "DAKERHENS": "DAKERHEN, another name for the corncrake [n]\n",
  "DAKERING": "DAKER, (Scots) to lounge, also DACKER [v]\n",
  "DAKERS": "DAKER, (Scots) to lounge, also DACKER [v]\n",
  "DAKOIT": "(Hindi) a member of an Indian robber gang, also DACOIT [n -S]\n",
  "DAKOITI": "(Hindi) robbery by dacoits, also DACOITAGE, DACOITY, DAKOITY [n -S]\n",
  "DAKOITIES": "DAKOITY, (Hindi) robbery by dacoits, also DACOITAGE, DACOITY, DAKOITI [n]\n",
  "DAKOITIS": "DAKOITI, (Hindi) robbery by dacoits, also DACOITAGE, DACOITY, DAKOITY [n]\n",
  "DAKOITS": "DAKOIT, (Hindi) a member of an Indian robber gang, also DACOIT [n]\n",
  "DAKOITY": "(Hindi) robbery by dacoits, also DACOITAGE, DACOITY, DAKOITI [n DAKOITIES]\n",
  "DAKS": "DAK, (Hindi) the mail-post in India, also DAWK [n]\n",
  "DAL": "(Hindi) a kind of Indian edible pea, also DAAL, DAHL, DHAL, DHOLL [n -S]\n",
  "DALAPON": "a herbicide used on unwanted grass [n -S]\n",
  "DALAPONS": "DALAPON, a herbicide used on unwanted grass [n]\n",
  "DALASI": "(Wolof) a unit of Gambian currency [n -S]\n",
  "DALASIS": "DALASI, (Wolof) a unit of Gambian currency [n]\n",
  "DALE": "a valley [n -S]\n",
  "DALED": "(Hebrew) the fourth letter of the Hebrew alphabet, also DALETH, DALEDH [n -S]\n",
  "DALEDH": "(Hebrew) the fourth letter of the Hebrew alphabet, also DALED, DALETH [n -S]\n",
  "DALEDHS": "DALEDH, (Hebrew) the fourth letter of the Hebrew alphabet, also DALED, DALETH [n]\n",
  "DALEDS": "DALED, (Hebrew) the fourth letter of the Hebrew alphabet, also DALETH, DALEDH [n]\n",
  "DALES": "DALE, a valley [n]\n",
  "DALESMAN": "one living in a dale [n DALESMEN]\n",
  "DALESMEN": "DALESMAN, one living in a dale [n]\n",
  "DALETH": "(Hebrew) the fourth letter of the Hebrew alphabet, also DALED, DALEDH [n -S]\n",
  "DALETHS": "DALETH, (Hebrew) the fourth letter of the Hebrew alphabet, also DALED, DALEDH [n]\n",
  "DALGYTE": "(Native Australian) a burrowing marsupial, aka bilby [n -S]\n",
  "DALGYTES": "DALGYTE, (Native Australian) a burrowing marsupial, aka bilby [n]\n",
  "DALI": "a tropical American tree related to nutmeg [n -S]\n",
  "DALIS": "DALI, a tropical American tree related to nutmeg [n]\n",
  "DALLE": "(French) a slab or tile, often decorative [n -S]\n",
  "DALLES": "DALLE, (French) a slab or tile, often decorative [n]\n",
  "DALLIANCE": "flirtation [n -S]\n",
  "DALLIANCES": "DALLIANCE, flirtation [n]\n",
  "DALLIED": "DALLY, to waste time [v]\n",
  "DALLIER": "one who dallies [n -S]\n",
  "DALLIERS": "DALLIER, one who dallies [n]\n",
  "DALLIES": "DALLY, to waste time [v]\n",
  "DALLOP": "(obsolete) a tuft or clump [n -S]\n",
  "DALLOPS": "DALLOP, (obsolete) a tuft or clump [n]\n",
  "DALLY": "to waste time [v DALLIED, DALLYING, DALLIES]\n",
  "DALLYING": "DALLY, to waste time [v]\n",
  "DALMAHOY": "(historical) a bushy bobwig worn in the 18th century [n -S]\n",
  "DALMAHOYS": "DALMAHOY, (historical) a bushy bobwig worn in the 18th century [n]\n",
  "DALMATIAN": "a large breed of dog having a short smooth white coat with black or (in liver-spotted dalmatians) brown spots [n -S]\n",
  "DALMATIANS": "DALMATIAN, a large breed of dog having a short smooth white coat with black or (in liver-spotted dalmatians) brown spots [n]\n",
  "DALMATIC": "an ecclesiastical robe or other outer vestment [n -S]\n",
  "DALMATICS": "DALMATIC, an ecclesiastical robe or other outer vestment [n]\n",
  "DALS": "DAL, (Hindi) a kind of Indian edible pea, also DAAL, DAHL, DHAL, DHOLL [n]\n",
  "DALT": "(Scots) a foster-child, also DAULT [n -S]\n",
  "DALTON": "a unit of atomic mass, aka amu [n -S]\n",
  "DALTONIAN": "a person affected by colour blindness [n -S]\n",
  "DALTONIANS": "DALTONIAN, a person affected by colour blindness [n]\n",
  "DALTONIC": "pertaining to a form of color blindness [adj]\n",
  "DALTONISM": "color blindness, esp. the inability to distinguish between red and green [n -S]\n",
  "DALTONISMS": "DALTONISM, color blindness, esp. the inability to distinguish between red and green [n]\n",
  "DALTONS": "DALTON, a unit of atomic mass, aka amu [n]\n",
  "DALTS": "DALT, (Scots) a foster-child, also DAULT [n]\n",
  "DAM": "to build an embankment to retain water [v DAMMED, DAMMING, DAMS]\n",
  "DAMAGE": "to damage [v DAMAGED, DAMAGING, DAMAGES]\n",
  "DAMAGEABILITIES": "DAMAGEABILITY, the quality of being damageable [n]\n",
  "DAMAGEABILITY": "the quality of being damageable [n DAMAGEABILITIES]\n",
  "DAMAGEABLE": "capable of being damaged [adj]\n",
  "DAMAGED": "DAMAGE, to damage [v]\n",
  "DAMAGER": "one who damages [n -S]\n",
  "DAMAGERS": "DAMAGER, one who damages [n]\n",
  "DAMAGES": "DAMAGE, to damage [v]\n",
  "DAMAGING": "DAMAGE, to damage [v]\n",
  "DAMAGINGLY": "DAMAGING, DAMAGE, to damage [adv]\n",
  "DAMAN": "(Arabic) a small herbivorous mammal, the rock hyrax [n -S]\n",
  "DAMANS": "DAMAN, (Arabic) a small herbivorous mammal, the rock hyrax [n]\n",
  "DAMAR": "(Malay) a hard resin used in making varnish, also DAMMAR, DAMMER [n -S]\n",
  "DAMARS": "DAMAR, (Malay) a hard resin used in making varnish, also DAMMAR, DAMMER [n]\n",
  "DAMASCEENE": "to decorate or engrave metal with wavy lines and patterns, also DAMASCENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v DAMASCEENED, DAMASCEENING, DAMASCEENES]\n",
  "DAMASCEENED": "DAMASCEENE, to decorate or engrave metal with wavy lines and patterns, also DAMASCENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASCEENES": "DAMASCEENE, to decorate or engrave metal with wavy lines and patterns, also DAMASCENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASCEENING": "DAMASCEENE, to decorate or engrave metal with wavy lines and patterns, also DAMASCENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASCENE": "to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v DAMASCENED, DAMASCENING, DAMASCENES]\n",
  "DAMASCENED": "DAMASCENE, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASCENES": "DAMASCENE, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASKEEN, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASCENING": "decorative wavy lines and patterns on metal [n -S]\n",
  "DAMASCENINGS": "DAMASCENING, decorative wavy lines and patterns on metal [n]\n",
  "DAMASK": "to weave with elaborate design [v -ED, -ING, -S]\n",
  "DAMASKED": "DAMASK, to weave with elaborate design [v]\n",
  "DAMASKEEN": "to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKIN, DAMASQUIN [v -ED, -ING, -S]\n",
  "DAMASKEENED": "DAMASKEEN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASKEENING": "DAMASKEEN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASKEENS": "DAMASKEEN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKIN, DAMASQUIN [v]\n",
  "DAMASKIN": "to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASQUIN [v -ED, -ING, -S]\n",
  "DAMASKINED": "DAMASKIN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASQUIN [v]\n",
  "DAMASKING": "DAMASK, to weave with elaborate design [v]\n",
  "DAMASKINING": "DAMASKIN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASQUIN [v]\n",
  "DAMASKINS": "DAMASKIN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASQUIN [v]\n",
  "DAMASKS": "DAMASK, to weave with elaborate design [v]\n",
  "DAMASQUIN": "to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASKIN [v -ED, -ING, -S]\n",
  "DAMASQUINED": "DAMASQUIN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASKIN [v]\n",
  "DAMASQUINING": "DAMASQUIN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASKIN [v]\n",
  "DAMASQUINS": "DAMASQUIN, to decorate or engrave metal with wavy lines and patterns, also DAMASCEENE, DAMASCENE, DAMASKEEN, DAMASKIN [v]\n",
  "DAMASSIN": "a kind of modified damask or brocade [n -S]\n",
  "DAMASSINS": "DAMASSIN, a kind of modified damask or brocade [n]\n",
  "DAMBOARD": "a draughtboard, also DAMBROD [n -S]\n",
  "DAMBOARDS": "DAMBOARD, a draughtboard, also DAMBROD [n]\n",
  "DAMBROD": "a draughtboard, also DAMBOARD [n -S]\n",
  "DAMBRODS": "DAMBROD, a draughtboard, also DAMBOARD [n]\n",
  "DAME": "a matron [n -S]\n",
  "DAMEHOOD": "the state of being a dame [n -S]\n",
  "DAMEHOODS": "DAMEHOOD, the state of being a dame [n]\n",
  "DAMES": "DAME, a matron [n]\n",
  "DAMEWORT": "a cruciferous plant, remarkable for its fragrance, esp. toward the close of the day [n -S]\n",
  "DAMEWORTS": "DAMEWORT, a cruciferous plant, remarkable for its fragrance, esp. toward the close of the day [n]\n",
  "DAMFOOL": "a stupid person [n -S]\n",
  "DAMFOOLS": "DAMFOOL, a stupid person [n]\n",
  "DAMIANA": "a tropical American shrub; a herbal medicine derived from this [n -S]\n",
  "DAMIANAS": "DAMIANA, a tropical American shrub; a herbal medicine derived from this [n]\n",
  "DAMINOZIDE": "a kind of pesticide used on apple trees [n -S]\n",
  "DAMINOZIDES": "DAMINOZIDE, a kind of pesticide used on apple trees [n]\n",
  "DAMMAR": "(Malay) a hard resin used in making varnish, also DAMAR, DAMMER [n -S]\n",
  "DAMMARS": "DAMMAR, (Malay) a hard resin used in making varnish, also DAMAR, DAMMER [n]\n",
  "DAMME": "damn me [interj]\n",
  "DAMMED": "DAM, to build an embankment to retain water [v]\n",
  "DAMMER": "(Malay) a hard resin used in making varnish, also DAMAR, DAMMAR [n -S]\n",
  "DAMMERS": "DAMMER, (Malay) a hard resin used in making varnish, also DAMAR, DAMMAR [n]\n",
  "DAMMING": "DAM, to build an embankment to retain water [v]\n",
  "DAMMIT": "damn it [interj]\n",
  "DAMN": "to curse [v -ED, -ING, -S]\n",
  "DAMNABILITIES": "DAMNABILITY, the ability to be damned [n]\n",
  "DAMNABILITY": "the ability to be damned [n DAMNABILITIES]\n",
  "DAMNABLE": "hateful [adj DAMNABLY]\n",
  "DAMNABLENESS": "the state of being damnable [n -ES]\n",
  "DAMNABLENESSES": "DAMNABLENESS, the state of being damnable [n]\n",
  "DAMNABLY": "DAMNABLE, hateful [adv]\n",
  "DAMNATION": "condemnation; the punishment of the impenitent in the future state [n -S]\n",
  "DAMNATIONS": "DAMNATION, condemnation; the punishment of the impenitent in the future state [n]\n",
  "DAMNATORY": "consigning to damnation [adj]\n",
  "DAMNDEST": "utmost effort, in phrase to do one's damndest, also DAMNEDEST, DAMNEST [n -S]\n",
  "DAMNDESTS": "DAMNDEST, utmost effort, in phrase to do one's damndest, also DAMNEDEST, DAMNEST [n]\n",
  "DAMNED": "damnable [adj DAMNEDER, DAMNEDEST or DAMNDEST]\n",
  "DAMNEDER": "DAMNED, damnable [adj]\n",
  "DAMNEDEST": "utmost effort, in phrase to do one's damnedest, also DAMNDEST, DAMNEST [n -S]\n",
  "DAMNEDESTS": "DAMNEDEST, utmost effort, in phrase to do one's damnedest, also DAMNDEST, DAMNEST [n]\n",
  "DAMNER": "one who damns [n -S]\n",
  "DAMNERS": "DAMNER, one who damns [n]\n",
  "DAMNEST": "one's utmost, also DAMNDEST, DAMNEDEST [n -S]\n",
  "DAMNESTS": "DAMNEST, one's utmost, also DAMNDEST, DAMNEDEST [n]\n",
  "DAMNIFICATION": "causation of injury or loss [n -S]\n",
  "DAMNIFICATIONS": "DAMNIFICATION, causation of injury or loss [n]\n",
  "DAMNIFIED": "DAMNIFY, to cause loss or damage to [v]\n",
  "DAMNIFIES": "DAMNIFY, to cause loss or damage to [v]\n",
  "DAMNIFY": "to cause loss or damage to [v DAMNIFIED, DAMNIFYING, DAMNIFIES]\n",
  "DAMNIFYING": "DAMNIFY, to cause loss or damage to [v]\n",
  "DAMNING": "DAMN, to curse [v]\n",
  "DAMNINGLY": "DAMNING, DAMN, to curse [adv]\n",
  "DAMNS": "DAMN, to curse [v]\n",
  "DAMOISEL": "(archaic) a young girl or unmarried woman, also DAMOISELLE, DAMOSEL, DAMOZEL, DAMSEL, DEMOISELLE [n -S]\n",
  "DAMOISELLE": "a young girl or unmarried woman, also DAMOISEL, DAMOSEL, DAMOZEL, DAMSEL, DEMOISELLE [n -S]\n",
  "DAMOISELLES": "DAMOISELLE, a young girl or unmarried woman, also DAMOISEL, DAMOSEL, DAMOZEL, DAMSEL, DEMOISELLE [n]\n",
  "DAMOISELS": "DAMOISEL, (archaic) a young girl or unmarried woman, also DAMOISELLE, DAMOSEL, DAMOZEL, DAMSEL, DEMOISELLE [n]\n",
  "DAMOSEL": "(archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOZEL, DAMSEL, DEMOISELLE [n -S]\n",
  "DAMOSELS": "DAMOSEL, (archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOZEL, DAMSEL, DEMOISELLE [n]\n",
  "DAMOZEL": "(archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOSEL, DAMSEL, DEMOISELLE [n -S]\n",
  "DAMOZELS": "DAMOZEL, (archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOSEL, DAMSEL, DEMOISELLE [n]\n",
  "DAMP": "to wet slightly [v -ED, -ING, -S] / moist [adj DAMPER, DAMPEST, DAMPLY]\n",
  "DAMPCOURSE": "a horizontal layer of impervious material in a brick wall, fairly close to the ground, to stop moisture rising [n -S]\n",
  "DAMPCOURSES": "DAMPCOURSE, a horizontal layer of impervious material in a brick wall, fairly close to the ground, to stop moisture rising [n]\n",
  "DAMPED": "DAMP, to wet slightly [v]\n",
  "DAMPEN": "to moisten [v -ED, -ING, -S]\n",
  "DAMPENED": "DAMPEN, to moisten [v]\n",
  "DAMPENER": "a thing that dampens; (US) a contrivance for moistening linen etc. [n -S]\n",
  "DAMPENERS": "DAMPENER, a thing that dampens; (US) a contrivance for moistening linen etc. [n]\n",
  "DAMPENING": "DAMPEN, to moisten [v]\n",
  "DAMPENS": "DAMPEN, to moisten [v]\n",
  "DAMPER": "(Australian slang) a simple kind of unleavened cake or bread made of flour and water and baked in hot ashes [n -S]\n",
  "DAMPERS": "DAMPER, (Australian slang) a simple kind of unleavened cake or bread made of flour and water and baked in hot ashes [n]\n",
  "DAMPEST": "DAMP, moist [adj]\n",
  "DAMPIER": "DAMPY, somewhat damp [adj]\n",
  "DAMPIEST": "DAMPY, somewhat damp [adj]\n",
  "DAMPING": "the ability of a device to prevent instability [n -S]\n",
  "DAMPINGS": "DAMPING, the ability of a device to prevent instability [n]\n",
  "DAMPISH": "somewhat damp [adj]\n",
  "DAMPISHNESS": "the state of being dampish [n -ES]\n",
  "DAMPISHNESSES": "DAMPISHNESS, the state of being dampish [n]\n",
  "DAMPLY": "DAMP, moist [adv]\n",
  "DAMPNESS": "the state of being damp [n -ES]\n",
  "DAMPNESSES": "DAMPNESS, the state of being damp [n]\n",
  "DAMPS": "DAMP, to wet slightly [v]\n",
  "DAMPY": "somewhat damp [adj DAMPIER, DAMPIEST]\n",
  "DAMS": "DAM, to build an embankment to retain water [v]\n",
  "DAMSEL": "(archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOSEL, DAMOZEL, DEMOISELLE [n -S]\n",
  "DAMSELFISH": "a small brightly-coloured tropical fish [n -ES]\n",
  "DAMSELFISHES": "DAMSELFISH, a small brightly-coloured tropical fish [n]\n",
  "DAMSELFLIES": "DAMSELFLY, an insect of the order Odonata, resembling the dragonfly [n]\n",
  "DAMSELFLY": "an insect of the order Odonata, resembling the dragonfly [n DAMSELFLIES]\n",
  "DAMSELS": "DAMSEL, (archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOSEL, DAMOZEL, DEMOISELLE [n]\n",
  "DAMSON": "a rather small, oval, dark-purple plum, or the tree producing it [n -S]\n",
  "DAMSONS": "DAMSON, a rather small, oval, dark-purple plum, or the tree producing it [n]\n",
  "DAN": "(Japanese) a level of efficiency in Japanese combative sports [n -S]\n",
  "DANAZOL": "a synthetic male hormone [n -S]\n",
  "DANAZOLS": "DANAZOL, a synthetic male hormone [n]\n",
  "DANCE": "to move rhythmically to music [v DANCED, DANCING, DANCES]\n",
  "DANCEABLE": "capable of being danced [adj]\n",
  "DANCECORE": "a type of Electronic/Techno music with rapid beats and often, extreme distortion [n -S]\n",
  "DANCECORES": "DANCECORE, a type of Electronic/Techno music with rapid beats and often, extreme distortion [n]\n",
  "DANCED": "DANCE, to move rhythmically to music [v]\n",
  "DANCEHALL": "a style of dance-oriented reggae, a form of popular music originating in Jamaica [n -S]\n",
  "DANCEHALLS": "DANCEHALL, a style of dance-oriented reggae, a form of popular music originating in Jamaica [n]\n",
  "DANCELIKE": "like a dance [adj]\n",
  "DANCER": "one who dances [n -S]\n",
  "DANCERS": "DANCER, one who dances [n]\n",
  "DANCES": "DANCE, to move rhythmically to music [v]\n",
  "DANCETTE": "(French) of a heraldic line, deeply indented, also DANCETTEE, DANCETTY [adj] / a zigzag line across a shield [n -S]\n",
  "DANCETTEE": "(French) of a heraldic line, deeply indented, also DANCETTE, DANCETTY [adj]\n",
  "DANCETTES": "DANCETTE, a zigzag line across a shield [n]\n",
  "DANCETTY": "of a heraldic line, deeply indented, also DANCETTE, DANCETTEE [adj]\n",
  "DANCEWEAR": "clothing suitable for dance classes, e.g. tights, leotards, bodysuits [n -S]\n",
  "DANCEWEARS": "DANCEWEAR, clothing suitable for dance classes, e.g. tights, leotards, bodysuits [n]\n",
  "DANCEY": "relating to dance music [adj DANCIER, DANCIEST]\n",
  "DANCICAL": "a type of dance show in which choreographed performers dance to pop songs [n -S]\n",
  "DANCICALS": "DANCICAL, a type of dance show in which choreographed performers dance to pop songs [n]\n",
  "DANCIER": "DANCY, (esp. of electronic music) suitable for dancing to, also DANCEY [adj]\n",
  "DANCIEST": "DANCY, (esp. of electronic music) suitable for dancing to, also DANCEY [adj]\n",
  "DANCING": "the act of dancing [n -S]\n",
  "DANCINGS": "DANCING, the act of dancing [n]\n",
  "DANCY": "(esp. of electronic music) suitable for dancing to, also DANCEY [adj DANCIER, DANCIEST]\n",
  "DANDELION": "a common yellow-flowered composite with jagged-toothed leaves [n -S]\n",
  "DANDELIONS": "DANDELION, a common yellow-flowered composite with jagged-toothed leaves [n]\n",
  "DANDER": "(dialect) to stroll, saunter, also DAUNDER, DAUNER, DAWNER [v -ED, -ING, -S]\n",
  "DANDERED": "DANDER, (dialect) to stroll, saunter, also DAUNDER, DAUNER, DAWNER [v]\n",
  "DANDERING": "DANDER, (dialect) to stroll, saunter, also DAUNDER, DAUNER, DAWNER [v]\n",
  "DANDERS": "DANDER, (dialect) to stroll, saunter, also DAUNDER, DAUNER, DAWNER [v]\n",
  "DANDIACAL": "inclined to be a dandy [adj]\n",
  "DANDIER": "DANDY, fine [adj]\n",
  "DANDIES": "DANDY, a fop [n]\n",
  "DANDIEST": "DANDY, fine [adj]\n",
  "DANDIFICATION": "the act of dandifying [n -S]\n",
  "DANDIFICATIONS": "DANDIFICATION, the act of dandifying [n]\n",
  "DANDIFIED": "DANDIFY, to dress up [v]\n",
  "DANDIFIES": "DANDIFY, to dress up [v]\n",
  "DANDIFY": "to dress up [v DANDIFIED, DANDIFYING, DANDIFIES]\n",
  "DANDIFYING": "DANDIFY, to dress up [v]\n",
  "DANDILY": "DANDY, fine [adv]\n",
  "DANDIPRAT": "(obsolete) a silver three-halfpenny piece, also DANDYPRAT [n -S]\n",
  "DANDIPRATS": "DANDIPRAT, (obsolete) a silver three-halfpenny piece, also DANDYPRAT [n]\n",
  "DANDLE": "to dance (a child) on one's knees [v DANDLED, DANDLING, DANDLES]\n",
  "DANDLED": "DANDLE, to dance (a child) on one's knees [v]\n",
  "DANDLER": "one who dandles or fondles [n -S]\n",
  "DANDLERS": "DANDLER, one who dandles or fondles [n]\n",
  "DANDLES": "DANDLE, to dance (a child) on one's knees [v]\n",
  "DANDLING": "DANDLE, to dance (a child) on one's knees [v]\n",
  "DANDRIFF": "a scurf that forms on the scalp, also DANDRUFF [n -S]\n",
  "DANDRIFFS": "DANDRIFF, a scurf that forms on the scalp, also DANDRUFF [n]\n",
  "DANDRUFF": "a scurf that forms on the scalp, also DANDRIFF [n -S]\n",
  "DANDRUFFIER": "DANDRUFFY, full of dandruff [adj]\n",
  "DANDRUFFIEST": "DANDRUFFY, full of dandruff [adj]\n",
  "DANDRUFFS": "DANDRUFF, a scurf that forms on the scalp, also DANDRIFF [n]\n",
  "DANDRUFFY": "full of dandruff [adj DANDRUFFIER, DANDRUFFIEST]\n",
  "DANDY": "a fop [n DANDIES] / fine [adj DANDIER, DANDIEST, DANDILY]\n",
  "DANDYFUNK": "a ship's biscuit, soaked in fat and molasses and baked in a pan, also DUNDERFUNK [n -S]\n",
  "DANDYFUNKS": "DANDYFUNK, a ship's biscuit, soaked in fat and molasses and baked in a pan, also DUNDERFUNK [n]\n",
  "DANDYISH": "suggestive of a dandy [adj DANDYISHLY]\n",
  "DANDYISHLY": "DANDYISH, suggestive of a dandy [adv]\n",
  "DANDYISM": "the conduct of a dandy [n -S]\n",
  "DANDYISMS": "DANDYISM, the conduct of a dandy [n]\n",
  "DANDYPRAT": "(obsolete) a silver three-halfpenny piece, also DANDIPRAT [n -S]\n",
  "DANDYPRATS": "DANDYPRAT, (obsolete) a silver three-halfpenny piece, also DANDIPRAT [n]\n",
  "DANEGELD": "a tax imposed in the 10th century to buy off the Danes or to defend the country against them, also DANEGELT [n -S]\n",
  "DANEGELDS": "DANEGELD, a tax imposed in the 10th century to buy off the Danes or to defend the country against them, also DANEGELT [n]\n",
  "DANEGELT": "a tax imposed in the 10th century to buy off the Danes or to defend the country against them, also DANEGELD [n -S]\n",
  "DANEGELTS": "DANEGELT, a tax imposed in the 10th century to buy off the Danes or to defend the country against them, also DANEGELD [n]\n",
  "DANELAGH": "the law that prevailed in the Danelaw, the part of England ruled by the Danes, also DANELAW [n -S]\n",
  "DANELAGHS": "DANELAGH, the law that prevailed in the Danelaw, the part of England ruled by the Danes, also DANELAW [n]\n",
  "DANELAW": "Danish law that prevailed in England, the part of England ruled by the Danes, also DANELAGH [n -S]\n",
  "DANELAWS": "DANELAW, Danish law that prevailed in England, the part of England ruled by the Danes, also DANELAGH [n]\n",
  "DANEWEED": "an elder-like shrub, said to grow on sites where Danes had fallen, also DANEWORT [n -S]\n",
  "DANEWEEDS": "DANEWEED, an elder-like shrub, said to grow on sites where Danes had fallen, also DANEWORT [n]\n",
  "DANEWORT": "an elder-like shrub, said to grow on sites where Danes had fallen, also DANEWEED [n -S]\n",
  "DANEWORTS": "DANEWORT, an elder-like shrub, said to grow on sites where Danes had fallen, also DANEWEED [n]\n",
  "DANG": "damned [adj DANGER, DANGEST] / to damn [v -ED, -ING, -S]\n",
  "DANGED": "DANG, to damn [v]\n",
  "DANGER": "to expose to loss or injury [v -ED, -ING, -S]\n",
  "DANGERED": "DANGER, to expose to loss or injury [v]\n",
  "DANGERING": "DANGER, to expose to loss or injury [v]\n",
  "DANGERLESS": "without danger [adj]\n",
  "DANGEROUS": "full of danger [adj DANGEROUSLY]\n",
  "DANGEROUSLY": "DANGEROUS, full of danger [adv]\n",
  "DANGEROUSNESS": "DANGEROUS, full of danger [n]\n",
  "DANGEROUSNESSES": "DANGEROUSNESS, DANGEROUS, full of danger [n]\n",
  "DANGERS": "DANGER, to expose to loss or injury [v]\n",
  "DANGEST": "DANG, damned [adj]\n",
  "DANGING": "DANG, to damn [v]\n",
  "DANGLE": "to hang loosely [v DANGLED, DANGLING, DANGLES]\n",
  "DANGLED": "DANGLE, to hang loosely [v]\n",
  "DANGLER": "(archaic) one who dangles about or after others, esp. after women [n -S]\n",
  "DANGLERS": "DANGLER, (archaic) one who dangles about or after others, esp. after women [n]\n",
  "DANGLES": "DANGLE, to hang loosely [v]\n",
  "DANGLIER": "DANGLY, hanging loosely [adj]\n",
  "DANGLIEST": "DANGLY, hanging loosely [adj]\n",
  "DANGLING": "hanging down [adj DANGLINGLY] / the act of dangling [n -S]\n",
  "DANGLINGLY": "DANGLING, hanging down [adv]\n",
  "DANGLINGS": "DANGLING, the act of dangling [n]\n",
  "DANGLY": "hanging loosely [adj DANGLIER, DANGLIEST]\n",
  "DANGS": "DANG, to damn [v]\n",
  "DANIO": "a brightly coloured tropical freshwater fish [n -S]\n",
  "DANIOS": "DANIO, a brightly coloured tropical freshwater fish [n]\n",
  "DANISH": "a pastry of raised dough [n -ES]\n",
  "DANISHES": "DANISH, a pastry of raised dough [n]\n",
  "DANK": "unpleasantly damp [adj DANKER, DANKEST, DANKLY] / a wet place [n -S]\n",
  "DANKER": "DANK, unpleasantly damp [adj]\n",
  "DANKEST": "DANK, unpleasantly damp [adj]\n",
  "DANKISH": "somewhat dank [adj]\n",
  "DANKLY": "DANK, unpleasantly damp [adv]\n",
  "DANKNESS": "the state of being dank [n -ES]\n",
  "DANKNESSES": "DANKNESS, the state of being dank [n]\n",
  "DANKS": "DANK, a wet place [n]\n",
  "DANNEBROG": "(Danish) the ancient battle standard of Denmark, bearing figures of cross and crown [n -S]\n",
  "DANNEBROGS": "DANNEBROG, (Danish) the ancient battle standard of Denmark, bearing figures of cross and crown [n]\n",
  "DANNIES": "DANNY, the hand, also DONNY [n]\n",
  "DANNY": "the hand, also DONNY [n DANNIES]\n",
  "DANS": "DAN, (Japanese) a level of efficiency in Japanese combative sports [n]\n",
  "DANSAK": "(Urdu) any of a variety of Indian dishes consisting of meat or vegetables braised with water or stock and lentils, also DHANSAK [n -S]\n",
  "DANSAKS": "DANSAK, (Urdu) any of a variety of Indian dishes consisting of meat or vegetables braised with water or stock and lentils, also DHANSAK [n]\n",
  "DANSEUR": "(French) a professional male ballet dancer [n -S]\n",
  "DANSEURS": "DANSEUR, (French) a professional male ballet dancer [n]\n",
  "DANSEUSE": "(French) a professional female ballet dancer [n -S]\n",
  "DANSEUSES": "DANSEUSE, (French) a professional female ballet dancer [n]\n",
  "DANT": "(obsolete) to frighten, also DAUNT [v -ED, -ING, -S]\n",
  "DANTED": "DANT, (obsolete) to frighten, also DAUNT [v]\n",
  "DANTHONIA": "a tufted grass native to Australia and New Zealand [n -S]\n",
  "DANTHONIAS": "DANTHONIA, a tufted grass native to Australia and New Zealand [n]\n",
  "DANTING": "DANT, (obsolete) to frighten, also DAUNT [v]\n",
  "DANTON": "to dare, also DAUNTON [v -ED, -ING, -S]\n",
  "DANTONED": "DANTON, to dare, also DAUNTON [v]\n",
  "DANTONING": "DANTON, to dare, also DAUNTON [v]\n",
  "DANTONS": "DANTON, to dare, also DAUNTON [v]\n",
  "DANTS": "DANT, (obsolete) to frighten, also DAUNT [v]\n",
  "DAP": "to dip in water [v DAPPED, DAPPING, DAPS]\n",
  "DAPHNE": "(Greek) a genus of diminutive shrubs, mostly evergreen, and with fragrant blossoms [n -S]\n",
  "DAPHNES": "DAPHNE, (Greek) a genus of diminutive shrubs, mostly evergreen, and with fragrant blossoms [n]\n",
  "DAPHNIA": "any member of the crustacean genus Daphnia, water-fleas, also DAPHNID [n -S]\n",
  "DAPHNIAS": "DAPHNIA, any member of the crustacean genus Daphnia, water-fleas, also DAPHNID [n]\n",
  "DAPHNID": "any member of the crustacean genus Daphnia, water-fleas, also DAPHNIA [n -S]\n",
  "DAPHNIDS": "DAPHNID, any member of the crustacean genus Daphnia, water-fleas, also DAPHNIA [n]\n",
  "DAPPED": "DAP, to dip in water [v]\n",
  "DAPPER": "trim, neat [adj DAPPERER, DAPPEREST, DAPPERLY] / one who daps, in angling [n -S]\n",
  "DAPPERER": "DAPPER, trim, neat [adj]\n",
  "DAPPEREST": "DAPPER, trim, neat [adj]\n",
  "DAPPERLING": "(archaic) a dapper little fellow [n -S]\n",
  "DAPPERLINGS": "DAPPERLING, (archaic) a dapper little fellow [n]\n",
  "DAPPERLY": "DAPPER, trim, neat [adv]\n",
  "DAPPERNESS": "the state of being dapper [n -ES]\n",
  "DAPPERNESSES": "DAPPERNESS, the state of being dapper [n]\n",
  "DAPPERS": "DAPPER, one who daps, in angling [n]\n",
  "DAPPING": "DAP, to dip in water [v]\n",
  "DAPPLE": "to mark with spots [v DAPPLED, DAPPLING, DAPPLES]\n",
  "DAPPLED": "DAPPLE, to mark with spots [v]\n",
  "DAPPLES": "DAPPLE, to mark with spots [v]\n",
  "DAPPLING": "DAPPLE, to mark with spots [v]\n",
  "DAPS": "DAP, to dip in water [v]\n",
  "DAPSONE": "a drug used in the treatment of leprosy, dermatitis, etc. [n -S]\n",
  "DAPSONES": "DAPSONE, a drug used in the treatment of leprosy, dermatitis, etc. [n]\n",
  "DAQUIRI": "a cocktail, also DAIQUIRI [n -S]\n",
  "DAQUIRIS": "DAQUIRI, a cocktail, also DAIQUIRI [n]\n",
  "DARAF": "an electrical inverse unit of capacitance [n -S]\n",
  "DARAFS": "DARAF, an electrical inverse unit of capacitance [n]\n",
  "DARB": "something considered extraordinary [n -S]\n",
  "DARBAR": "the court of a native ruler in India, also DURBAR [n -S]\n",
  "DARBARS": "DARBAR, the court of a native ruler in India, also DURBAR [n]\n",
  "DARBIES": "handcuffs [n]\n",
  "DARBS": "DARB, something considered extraordinary [n]\n",
  "DARCIES": "DARCY, a unit of geological permeability [n]\n",
  "DARCY": "a unit of geological permeability [n DARCIES or DARCYS]\n",
  "DARCYS": "DARCY, a unit of geological permeability [n]\n",
  "DARE": "to venture boldly, also DARRE, DAUR [v DURST or DARED, DARING, DARES]\n",
  "DARED": "DARE, to venture boldly, also DARRE, DAUR [v]\n",
  "DAREDEVIL": "a reckless person [n -S]\n",
  "DAREDEVILRIES": "DAREDEVILRY, the state of being a daredevil, also DAREDEVILTRY [n]\n",
  "DAREDEVILRY": "the state of being a daredevil, also DAREDEVILTRY [n DAREDEVILRIES]\n",
  "DAREDEVILS": "DAREDEVIL, a reckless person [n]\n",
  "DAREDEVILTRIES": "DAREDEVILTRY, the state of being daredevil, also DAREDEVILRY [n]\n",
  "DAREDEVILTRY": "the state of being daredevil, also DAREDEVILRY [n DAREDEVILTRIES]\n",
  "DAREFUL": "(obsolete) full of daring [adj]\n",
  "DARER": "one who dares [n -S]\n",
  "DARERS": "DARER, one who dares [n]\n",
  "DARES": "DARE, to venture boldly, also DARRE, DAUR [v]\n",
  "DARESAY": "(I) venture to say (no other verb parts) [v]\n",
  "DARG": "a day's labour [n -S]\n",
  "DARGA": "(Hindi) the tomb of a Muslim saint, also DARGAH, DURGAH [n -S]\n",
  "DARGAH": "(Persian) the tomb of a Muslim saint, also DARGA, DURGAH [n -S]\n",
  "DARGAHS": "DARGAH, (Persian) the tomb of a Muslim saint, also DARGA, DURGAH [n]\n",
  "DARGAS": "DARGA, (Hindi) the tomb of a Muslim saint, also DARGAH, DURGAH [n]\n",
  "DARGLE": "(Scott) a dell [n -S]\n",
  "DARGLES": "DARGLE, (Scott) a dell [n]\n",
  "DARGS": "DARG, a day's labour [n]\n",
  "DARI": "(Arabic) Indian millet, also DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURR, DURRA [n -S]\n",
  "DARIC": "a gold coin of ancient Persia [n -S]\n",
  "DARICS": "DARIC, a gold coin of ancient Persia [n]\n",
  "DARING": "brave, audacious [adj DARINGLY] / bravery [n -S]\n",
  "DARINGLY": "DARING, brave, audacious [adv]\n",
  "DARINGNESS": "boldness [n -ES]\n",
  "DARINGNESSES": "DARINGNESS, boldness [n]\n",
  "DARINGS": "DARING, bravery [n]\n",
  "DARIOLE": "(French) a small cylindrical mould used in cooking [n -S]\n",
  "DARIOLES": "DARIOLE, (French) a small cylindrical mould used in cooking [n]\n",
  "DARIS": "DARI, (Arabic) Indian millet, also DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURR, DURRA [n]\n",
  "DARK": "having little light [adj DARKER, DARKEST, DARKLY] / to make dark [v -ED, -ING, -S]\n",
  "DARKED": "DARK, to make dark [v]\n",
  "DARKEN": "to make dark [v -ED, -ING, -S]\n",
  "DARKENED": "DARKEN, to make dark [v]\n",
  "DARKENER": "someone or something that darkens [n -S]\n",
  "DARKENERS": "DARKENER, someone or something that darkens [n]\n",
  "DARKENING": "DARKEN, to make dark [v]\n",
  "DARKENS": "DARKEN, to make dark [v]\n",
  "DARKER": "DARK, having little light [adj]\n",
  "DARKEST": "DARK, having little light [adj]\n",
  "DARKEY": "(offensive) a coloured person, also DARKY, DARKIE [n -S]\n",
  "DARKEYS": "DARKEY, (offensive) a coloured person, also DARKY, DARKIE [n]\n",
  "DARKFIELD": "as in darkfield microscope, an ultramicroscope [adj]\n",
  "DARKIE": "(offensive) a coloured person, also DARKY, DARKEY [n -S]\n",
  "DARKIES": "DARKIE, (offensive) a coloured person, also DARKY, DARKEY [n]\n",
  "DARKING": "DARK, to make dark [v]\n",
  "DARKISH": "somewhat dark [adj]\n",
  "DARKLE": "to grow dark; to show indistinctly [v DARKLED, DARKLING, DARKLES]\n",
  "DARKLED": "DARKLE, to grow dark; to show indistinctly [v]\n",
  "DARKLES": "DARKLE, to grow dark; to show indistinctly [v]\n",
  "DARKLIER": "DARKLY, DARK, having little light [adv]\n",
  "DARKLIEST": "DARKLY, DARK, having little light [adv]\n",
  "DARKLING": "in the dark, taking place in the dark, also DARKLINGS [adv]\n",
  "DARKLINGS": "in the dark, taking place in the dark, also DARKLING [adv]\n",
  "DARKLY": "DARK, having little light [adv]\n",
  "DARKMANS": "in thieves' slang, night [n]\n",
  "DARKNESS": "the state of being dark [n -ES]\n",
  "DARKNESSES": "DARKNESS, the state of being dark [n]\n",
  "DARKNET": "the collection of networks and other technologies that enable people to illegally share copyrighted digital files with little or no fear of detection [n -S]\n",
  "DARKNETS": "DARKNET, the collection of networks and other technologies that enable people to illegally share copyrighted digital files with little or no fear of detection [n]\n",
  "DARKROOM": "a room used for the development of photographic negatives [n -S]\n",
  "DARKROOMS": "DARKROOM, a room used for the development of photographic negatives [n]\n",
  "DARKS": "DARK, to make dark [v]\n",
  "DARKSOME": "dark, somber [adj]\n",
  "DARKY": "(offensive) a coloured person, also DARKEY, DARKIE [n DARKIES]\n",
  "DARLING": "lovable [adj DARLINGLY] / a much loved person, also DEARLING [n -S]\n",
  "DARLINGLY": "DARLING, lovable [adv]\n",
  "DARLINGNESS": "the state of being a darling [n -ES]\n",
  "DARLINGNESSES": "DARLINGNESS, the state of being a darling [n]\n",
  "DARLINGS": "DARLING, a much loved person, also DEARLING [n]\n",
  "DARMSTADTIUM": "an artificially produced radioactive element [n -S]\n",
  "DARMSTADTIUMS": "DARMSTADTIUM, an artificially produced radioactive element [n]\n",
  "DARN": "to mend with interlacing stitches [v -ED, -ING, -S]\n",
  "DARNATION": "a mild form of damnation, also TARNATION [n -S]\n",
  "DARNATIONS": "DARNATION, a mild form of damnation, also TARNATION [n]\n",
  "DARNDEST": "one's utmost, also DARNEST [n -S]\n",
  "DARNDESTS": "DARNDEST, one's utmost, also DARNEST [n]\n",
  "DARNED": "bothersome [adj DARNEDER, DARNEDEST]\n",
  "DARNEDER": "DARNED, bothersome [adj]\n",
  "DARNEDEST": "one's utmost, also DARNEST, DARNDEST [n -S]\n",
  "DARNEDESTS": "DARNEDEST, one's utmost, also DARNEST, DARNDEST [n]\n",
  "DARNEL": "a species of ryegrass [n -S]\n",
  "DARNELS": "DARNEL, a species of ryegrass [n]\n",
  "DARNER": "one who darns [n -S]\n",
  "DARNERS": "DARNER, one who darns [n]\n",
  "DARNEST": "one's utmost, also DARNEDEST, DARNDEST [n -S]\n",
  "DARNESTS": "DARNEST, one's utmost, also DARNEDEST, DARNDEST [n]\n",
  "DARNING": "things to be darned [n -S]\n",
  "DARNINGS": "DARNING, things to be darned [n]\n",
  "DARNS": "DARN, to mend with interlacing stitches [v]\n",
  "DAROGHA": "(Urdu) in India, a manager [n -S]\n",
  "DAROGHAS": "DAROGHA, (Urdu) in India, a manager [n]\n",
  "DARRAIGN": "to justify, put in battle array, also DARRAIN, DARRAINE, DARRAYN [v -ED, -ING, -S]\n",
  "DARRAIGNE": "(obsolete) to vindicate; to put in battle array, also DARRAIGN, DARRAIN, DARRAINE, DARRAYN, DERAIGN [v DARRAIGNED, DARRAIGNING, DARRAIGNES]\n",
  "DARRAIGNED": "DARRAIGN, to justify, put in battle array, also DARRAIN, DARRAINE, DARRAYN [v]\n",
  "DARRAIGNES": "DARRAIGNE, (obsolete) to vindicate; to put in battle array, also DARRAIGN, DARRAIN, DARRAINE, DARRAYN, DERAIGN [v]\n",
  "DARRAIGNING": "DARRAIGN, to justify, put in battle array, also DARRAIN, DARRAINE, DARRAYN [v]\n",
  "DARRAIGNMENT": "the act of darraigning [n -S]\n",
  "DARRAIGNMENTS": "DARRAIGNMENT, the act of darraigning [n]\n",
  "DARRAIGNS": "DARRAIGN, to justify, put in battle array, also DARRAIN, DARRAINE, DARRAYN [v]\n",
  "DARRAIN": "to justify, to put in battle array, also DARRAIGN, DARRAINE, DARRAYN [v -ED, -ING, -S]\n",
  "DARRAINE": "to justify, to put in battle array, also DARRAIGN, DARRAIN, DARRAYN [v DARRAINED, DARRAINING, DARRAINES]\n",
  "DARRAINED": "DARRAIN, to justify, to put in battle array, also DARRAIGN, DARRAINE, DARRAYN [v]\n",
  "DARRAINES": "DARRAINE, to justify, to put in battle array, also DARRAIGN, DARRAIN, DARRAYN [v]\n",
  "DARRAINING": "DARRAIN, to justify, to put in battle array, also DARRAIGN, DARRAINE, DARRAYN [v]\n",
  "DARRAINS": "DARRAIN, to justify, to put in battle array, also DARRAIGN, DARRAINE, DARRAYN [v]\n",
  "DARRAYN": "to justify, to put in battle array, also DARRAIGN, DARRAIN, DARRAINE [v -ED, -ING, -S]\n",
  "DARRAYNED": "DARRAYN, to justify, to put in battle array, also DARRAIGN, DARRAIN, DARRAINE [v]\n",
  "DARRAYNING": "DARRAYN, to justify, to put in battle array, also DARRAIGN, DARRAIN, DARRAINE [v]\n",
  "DARRAYNS": "DARRAYN, to justify, to put in battle array, also DARRAIGN, DARRAIN, DARRAINE [v]\n",
  "DARRE": "(Spenser) to venture boldly, also DARE, DAUR [v DARRED, DARRING, DARRES]\n",
  "DARRED": "DARRE, (Spenser) to venture boldly, also DARE, DAUR [v]\n",
  "DARRES": "DARRE, (Spenser) to venture boldly, also DARE, DAUR [v]\n",
  "DARRING": "DARRE, (Spenser) to venture boldly, also DARE, DAUR [v]\n",
  "DARSHAN": "(Hindi) a blessing conferred by touching or seeing a holy person [n -S]\n",
  "DARSHANS": "DARSHAN, (Hindi) a blessing conferred by touching or seeing a holy person [n]\n",
  "DART": "to move suddenly and swiftly [v -ED, -ING, -S]\n",
  "DARTBOARD": "the target used in the game of darts [n -S]\n",
  "DARTBOARDS": "DARTBOARD, the target used in the game of darts [n]\n",
  "DARTED": "DART, to move suddenly and swiftly [v]\n",
  "DARTER": "a freshwater diving bird related to cormorants [n -S]\n",
  "DARTERS": "DARTER, a freshwater diving bird related to cormorants [n]\n",
  "DARTING": "DART, to move suddenly and swiftly [v]\n",
  "DARTINGLY": "DARTING, DART, to move suddenly and swiftly [adv]\n",
  "DARTITIS": "a nervous condition affecting darts players, resulting in an inability to release the dart [n -ES]\n",
  "DARTITISES": "DARTITIS, a nervous condition affecting darts players, resulting in an inability to release the dart [n]\n",
  "DARTLE": "to dart repeatedly [v DARTLED, DARTLING, DARTLES]\n",
  "DARTLED": "DARTLE, to dart repeatedly [v]\n",
  "DARTLES": "DARTLE, to dart repeatedly [v]\n",
  "DARTLING": "DARTLE, to dart repeatedly [v]\n",
  "DARTRE": "(French) a herpes-like skin disease [n -S]\n",
  "DARTRES": "DARTRE, (French) a herpes-like skin disease [n]\n",
  "DARTROUS": "infected with dartre [adj]\n",
  "DARTS": "DART, to move suddenly and swiftly [v]\n",
  "DARZI": "(Hindi) a Hindu tailor, also DURZI [n -S]\n",
  "DARZIS": "DARZI, (Hindi) a Hindu tailor, also DURZI [n]\n",
  "DAS": "DA, (Burmese) a heavy Burmese knife, also DAH [n]\n",
  "DASH": "to strike violently [v -ED, -ING, -ES]\n",
  "DASHBOARD": "the instrument panel of a motor vehicle or small aircraft [n -S]\n",
  "DASHBOARDS": "DASHBOARD, the instrument panel of a motor vehicle or small aircraft [n]\n",
  "DASHCAM": "a small video camera situated on the dashboard of a vehicle, used to record the view through the windscreen [n -S]\n",
  "DASHCAMS": "DASHCAM, a small video camera situated on the dashboard of a vehicle, used to record the view through the windscreen [n]\n",
  "DASHED": "DASH, to strike violently [v]\n",
  "DASHEEN": "the taro, a kind of yam [n -S]\n",
  "DASHEENS": "DASHEEN, the taro, a kind of yam [n]\n",
  "DASHEKI": "(Yoruba) an African tunic, also DAISHIKI, DASHIKI [n -S]\n",
  "DASHEKIS": "DASHEKI, (Yoruba) an African tunic, also DAISHIKI, DASHIKI [n]\n",
  "DASHER": "one who dashes [n -S]\n",
  "DASHERS": "DASHER, one who dashes [n]\n",
  "DASHES": "DASH, to strike violently [v]\n",
  "DASHI": "(Japanese) a fish broth [n -S]\n",
  "DASHIER": "DASHY, stylish [adj]\n",
  "DASHIEST": "DASHY, stylish [adj]\n",
  "DASHIKI": "(Yoruba) an African tunic, also DAISHIKI, DASHEKI [n -S]\n",
  "DASHIKIS": "DASHIKI, (Yoruba) an African tunic, also DAISHIKI, DASHEKI [n]\n",
  "DASHING": "spirited, showy [adj DASHINGLY]\n",
  "DASHINGLY": "DASHING, spirited, showy [adv]\n",
  "DASHIS": "DASHI, (Japanese) a fish broth [n]\n",
  "DASHLIGHT": "a light illuminating the dashboard of an automobile, esp. at night [n -S]\n",
  "DASHLIGHTS": "DASHLIGHT, a light illuminating the dashboard of an automobile, esp. at night [n]\n",
  "DASHPOT": "a shock absorber [n -S]\n",
  "DASHPOTS": "DASHPOT, a shock absorber [n]\n",
  "DASHY": "stylish [adj DASHIER, DASHIEST]\n",
  "DASSIE": "(South African) the hyrax [n -S]\n",
  "DASSIES": "DASSIE, (South African) the hyrax [n]\n",
  "DASTARD": "a base coward [n -S]\n",
  "DASTARDIES": "DASTARDY, despicable behaviour [n]\n",
  "DASTARDLIER": "DASTARDLY, like a dastard, despicable [adj]\n",
  "DASTARDLIEST": "DASTARDLY, like a dastard, despicable [adj]\n",
  "DASTARDLINESS": "the state of being dastardly [n -ES]\n",
  "DASTARDLINESSES": "DASTARDLINESS, the state of being dastardly [n]\n",
  "DASTARDLY": "like a dastard, despicable [adj DASTARDLIER, DASTARDLIEST]\n",
  "DASTARDNESS": "the state of being dastard [n -ES]\n",
  "DASTARDNESSES": "DASTARDNESS, the state of being dastard [n]\n",
  "DASTARDS": "DASTARD, a base coward [n]\n",
  "DASTARDY": "despicable behaviour [n DASTARDIES]\n",
  "DASYMETER": "a device for measuring the density of gases [n -S]\n",
  "DASYMETERS": "DASYMETER, a device for measuring the density of gases [n]\n",
  "DASYPAEDAL": "of young birds, having down [adj]\n",
  "DASYPHYLLOUS": "having crowded, thick or woolly leaves [adj]\n",
  "DASYPOD": "a type of armadillo [n -S]\n",
  "DASYPODS": "DASYPOD, a type of armadillo [n]\n",
  "DASYURE": "(Greek) a flesh-eating Australian marsupial mammal, aka quoll [n -S]\n",
  "DASYURES": "DASYURE, (Greek) a flesh-eating Australian marsupial mammal, aka quoll [n]\n",
  "DATA": "DATUM, (Latin) something used as a basis for calculating [n]\n",
  "DATABANK": "a collection of data in a computer, also DATABASE [n -S]\n",
  "DATABANKS": "DATABANK, a collection of data in a computer, also DATABASE [n]\n",
  "DATABASE": "a collection of data in a computer, also DATABANK [n -S] / to put data into a database [v DATABASED, DATABASING, DATABASES]\n",
  "DATABASED": "DATABASE, to put data into a database [v]\n",
  "DATABASES": "DATABASE, to put data into a database [v]\n",
  "DATABASING": "DATABASE, to put data into a database [v]\n",
  "DATABLE": "capable of being dated [adj]\n",
  "DATABUS": "path for transferring computer data [n DATABUSES or DATABUSSES]\n",
  "DATABUSES": "DATABUS, path for transferring computer data [n]\n",
  "DATABUSSES": "DATABUS, path for transferring computer data [n]\n",
  "DATACARD": "a card containing electronic data [n -S]\n",
  "DATACARDS": "DATACARD, a card containing electronic data [n]\n",
  "DATACOMMS": "(short for) data communications [n]\n",
  "DATAFLOW": "of a computer system, prioritised by data processing [adj]\n",
  "DATAGLOVE": "an electrically wired glove-like device that transmits the wearer's movements to a virtual reality monitor [n -S]\n",
  "DATAGLOVES": "DATAGLOVE, an electrically wired glove-like device that transmits the wearer's movements to a virtual reality monitor [n]\n",
  "DATAGRAM": "a communication channel that uses information routed through a packet-switching network [n -S]\n",
  "DATAGRAMS": "DATAGRAM, a communication channel that uses information routed through a packet-switching network [n]\n",
  "DATAL": "a daily reckoning, also DAYTALE [n -S]\n",
  "DATALLER": "a day-labourer, also DAYTALER [n -S]\n",
  "DATALLERS": "DATALLER, a day-labourer, also DAYTALER [n]\n",
  "DATALS": "DATAL, a daily reckoning, also DAYTALE [n]\n",
  "DATAMATION": "automatic data processing [n -S]\n",
  "DATAMATIONS": "DATAMATION, automatic data processing [n]\n",
  "DATARIA": "an officer who attends to papal bulls, also DATARY [n -S]\n",
  "DATARIAS": "DATARIA, an officer who attends to papal bulls, also DATARY [n]\n",
  "DATARIES": "DATARY, an officer who attends to papal bulls, also DATARIA [n]\n",
  "DATARY": "an officer who attends to papal bulls, also DATARIA [n DATARIES]\n",
  "DATAVEILLANCE": "the monitoring of a person's activities by studying the data trail created by actions such as credit card purchases, cell phone calls, and Internet use [n -S]\n",
  "DATAVEILLANCES": "DATAVEILLANCE, the monitoring of a person's activities by studying the data trail created by actions such as credit card purchases, cell phone calls, and Internet use [n]\n",
  "DATCHA": "(Russian) a Russian country house, also DACHA [n -S]\n",
  "DATCHAS": "DATCHA, (Russian) a Russian country house, also DACHA [n]\n",
  "DATE": "to record a statement of time [v DATED, DATING, DATES]\n",
  "DATEABLE": "that may be dated, also DATABLE [adj]\n",
  "DATEBOOK": "a notebook for listing appointments [n -S]\n",
  "DATEBOOKS": "DATEBOOK, a notebook for listing appointments [n]\n",
  "DATED": "DATE, to record a statement of time [v]\n",
  "DATEDLY": "DATED, DATE, to record a statement of time [adv]\n",
  "DATEDNESS": "the state of being dated [n -ES]\n",
  "DATEDNESSES": "DATEDNESS, the state of being dated [n]\n",
  "DATELESS": "without a date [adj]\n",
  "DATELINE": "to provide a news story with a time and place [v DATELINED, DATELINING, DATELINES]\n",
  "DATELINED": "DATELINE, to provide a news story with a time and place [v]\n",
  "DATELINES": "DATELINE, to provide a news story with a time and place [v]\n",
  "DATELINING": "DATELINE, to provide a news story with a time and place [v]\n",
  "DATER": "one who dates [n -S]\n",
  "DATERS": "DATER, one who dates [n]\n",
  "DATES": "DATE, to record a statement of time [v]\n",
  "DATING": "a determination of a date in time [n -S]\n",
  "DATINGS": "DATING, a determination of a date in time [n]\n",
  "DATIVAL": "pertaining to the dative case [adj]\n",
  "DATIVE": "expressing an indirect object [adj DATIVELY] / a grammatical case, indicating the indirect object of a verb [n -S]\n",
  "DATIVELY": "DATIVE, expressing an indirect object [adv]\n",
  "DATIVES": "DATIVE, a grammatical case, indicating the indirect object of a verb [n]\n",
  "DATO": "(Malay) a Philippine tribal chief, also DATTO [n -S]\n",
  "DATOLITE": "a rock formed from boron and calcium silicates [n -S]\n",
  "DATOLITES": "DATOLITE, a rock formed from boron and calcium silicates [n]\n",
  "DATOS": "DATO, (Malay) a Philippine tribal chief, also DATTO [n]\n",
  "DATTO": "(Malay) a Philippine tribal chief, also DATO [n -S]\n",
  "DATTOS": "DATTO, (Malay) a Philippine tribal chief, also DATO [n]\n",
  "DATUM": "(Latin) something used as a basis for calculating [n DATUMS or DATA]\n",
  "DATUMS": "DATUM, (Latin) something used as a basis for calculating [n]\n",
  "DATURA": "(Hindi) a genus of solanaceous plants, with large funnel-shaped flowers [n -S]\n",
  "DATURAS": "DATURA, (Hindi) a genus of solanaceous plants, with large funnel-shaped flowers [n]\n",
  "DATURIC": "relating to datura [adj]\n",
  "DATURINE": "a poison [n -S]\n",
  "DATURINES": "DATURINE, a poison [n]\n",
  "DAUB": "to smear [v -ED, -ING, -S]\n",
  "DAUBE": "(French) a meat stew [n -S]\n",
  "DAUBED": "DAUB, to smear [v]\n",
  "DAUBER": "one who daubs; an unskilful artist [n -S]\n",
  "DAUBERIES": "DAUBERY, a crudely artful device, a pretence, also DAUBRY, DAWBRY [n]\n",
  "DAUBERS": "DAUBER, one who daubs; an unskilful artist [n]\n",
  "DAUBERY": "a crudely artful device, a pretence, also DAUBRY, DAWBRY [n DAUBERIES]\n",
  "DAUBES": "DAUBE, (French) a meat stew [n]\n",
  "DAUBIER": "DAUBY, smeary [adj]\n",
  "DAUBIEST": "DAUBY, smeary [adj]\n",
  "DAUBING": "the act of daubing [n -S]\n",
  "DAUBINGLY": "DAUBING [adv]\n",
  "DAUBINGS": "DAUBING, the act of daubing [n]\n",
  "DAUBRIES": "DAUBRY, a crudely artful device, a pretence, also DAUBERY, DAWBRY [n]\n",
  "DAUBRY": "a crudely artful device, a pretence, also DAUBERY, DAWBRY [n DAUBRIES]\n",
  "DAUBS": "DAUB, to smear [v]\n",
  "DAUBY": "smeary [adj DAUBIER, DAUBIEST]\n",
  "DAUD": "(Scots) to knock, also DAWD [v -ED, -ING, -S]\n",
  "DAUDED": "DAUD, (Scots) to knock, also DAWD [v]\n",
  "DAUDING": "DAUD, (Scots) to knock, also DAWD [v]\n",
  "DAUDS": "DAUD, (Scots) to knock, also DAWD [v]\n",
  "DAUGHTER": "a female child [n -S]\n",
  "DAUGHTERBOARD": "a small circuit board that can be attached to the motherboard of a computer [n -S]\n",
  "DAUGHTERBOARDS": "DAUGHTERBOARD, a small circuit board that can be attached to the motherboard of a computer [n]\n",
  "DAUGHTERHOOD": "the state of being a daughter [n -S]\n",
  "DAUGHTERHOODS": "DAUGHTERHOOD, the state of being a daughter [n]\n",
  "DAUGHTERLESS": "without a daughter [adj]\n",
  "DAUGHTERLIER": "DAUGHTERLY, as becomes a daughter, filial [adj]\n",
  "DAUGHTERLIEST": "DAUGHTERLY, as becomes a daughter, filial [adj]\n",
  "DAUGHTERLINESS": "the state of being daughterly [n]\n",
  "DAUGHTERLING": "a small daughter [n -S]\n",
  "DAUGHTERLINGS": "DAUGHTERLING, a small daughter [n]\n",
  "DAUGHTERLY": "as becomes a daughter, filial [adj DAUGHTERLIER, DAUGHTERLIEST]\n",
  "DAUGHTERS": "DAUGHTER, a female child [n]\n",
  "DAULT": "(Scots) a foster-child, also DALT [n -S]\n",
  "DAULTS": "DAULT, (Scots) a foster-child, also DALT [n]\n",
  "DAUNDER": "(dialect) to stroll, saunter, also DANDER, DAUNER, DAWNER [v -ED, -ING, -S]\n",
  "DAUNDERED": "DAUNDER, (dialect) to stroll, saunter, also DANDER, DAUNER, DAWNER [v]\n",
  "DAUNDERING": "DAUNDER, (dialect) to stroll, saunter, also DANDER, DAUNER, DAWNER [v]\n",
  "DAUNDERS": "DAUNDER, (dialect) to stroll, saunter, also DANDER, DAUNER, DAWNER [v]\n",
  "DAUNER": "(dialect) to stroll, saunter, also DANDER, DAUNDER, DAWNER [v -ED, -ING, -S]\n",
  "DAUNERED": "DAUNER, (dialect) to stroll, saunter, also DANDER, DAUNDER, DAWNER [v]\n",
  "DAUNERING": "DAUNER, (dialect) to stroll, saunter, also DANDER, DAUNDER, DAWNER [v]\n",
  "DAUNERS": "DAUNER, (dialect) to stroll, saunter, also DANDER, DAUNDER, DAWNER [v]\n",
  "DAUNOMYCIN": "an antibiotic used in treatment of leukaemia [n -S]\n",
  "DAUNOMYCINS": "DAUNOMYCIN, an antibiotic used in treatment of leukaemia [n]\n",
  "DAUNORUBICIN": "an antibiotic used in treatment of leukaemia [n -S]\n",
  "DAUNORUBICINS": "DAUNORUBICIN, an antibiotic used in treatment of leukaemia [n]\n",
  "DAUNT": "to intimidate, also DANT [v -ED, -ING, -S]\n",
  "DAUNTED": "DAUNT, to intimidate, also DANT [v]\n",
  "DAUNTER": "one who daunts [n -S]\n",
  "DAUNTERS": "DAUNTER, one who daunts [n]\n",
  "DAUNTING": "DAUNT, to intimidate, also DANT [v]\n",
  "DAUNTINGLY": "DAUNTING, DAUNT, to intimidate, also DANT [adv]\n",
  "DAUNTLESS": "unafraid [adj DAUNTLESSLY]\n",
  "DAUNTLESSLY": "DAUNTLESS, unafraid [adv]\n",
  "DAUNTLESSNESS": "DAUNTLESS, unafraid [n]\n",
  "DAUNTLESSNESSES": "DAUNTLESSNESS, DAUNTLESS, unafraid [n]\n",
  "DAUNTON": "to dare, also DANTON [v -ED, -ING, -S]\n",
  "DAUNTONED": "DAUNTON, to dare, also DANTON [v]\n",
  "DAUNTONING": "DAUNTON, to dare, also DANTON [v]\n",
  "DAUNTONS": "DAUNTON, to dare, also DANTON [v]\n",
  "DAUNTS": "DAUNT, to intimidate, also DANT [v]\n",
  "DAUPHIN": "(French) the eldest son of a French king [n -S]\n",
  "DAUPHINE": "(French) the title of the wife of the dauphin, also DAUPHINESS [n -S]\n",
  "DAUPHINES": "DAUPHINE, (French) the title of the wife of the dauphin, also DAUPHINESS [n]\n",
  "DAUPHINESS": "the title of the wife of the dauphin, also DAUPHINE [n -ES]\n",
  "DAUPHINESSES": "DAUPHINESS, the title of the wife of the dauphin, also DAUPHINE [n]\n",
  "DAUPHINS": "DAUPHIN, (French) the eldest son of a French king [n]\n",
  "DAUR": "(Scots) to venture boldly, also DARE, DARRE [v -ED, -ING, -S]\n",
  "DAURED": "DAUR, (Scots) to venture boldly, also DARE, DARRE [v]\n",
  "DAURING": "DAUR, (Scots) to venture boldly, also DARE, DARRE [v]\n",
  "DAURS": "DAUR, (Scots) to venture boldly, also DARE, DARRE [v]\n",
  "DAUT": "(Scots) to pet, also DAWT [v -ED, -ING, -S]\n",
  "DAUTED": "DAUT, (Scots) to pet, also DAWT [v]\n",
  "DAUTIE": "(Scots) a pet, also DAWTIE [n -S]\n",
  "DAUTIES": "DAUTIE, (Scots) a pet, also DAWTIE [n]\n",
  "DAUTING": "DAUT, (Scots) to pet, also DAWT [v]\n",
  "DAUTS": "DAUT, (Scots) to pet, also DAWT [v]\n",
  "DAVEN": "(Yiddish) to utter Jewish prayers, also DOVEN [v -ED, -ING, -S]\n",
  "DAVENED": "DAVEN, (Yiddish) to utter Jewish prayers, also DOVEN [v]\n",
  "DAVENING": "DAVEN, (Yiddish) to utter Jewish prayers, also DOVEN [v]\n",
  "DAVENPORT": "a small ornamental writing desk; a large sofa, also DEVONPORT [n -S]\n",
  "DAVENPORTS": "DAVENPORT, a small ornamental writing desk; a large sofa, also DEVONPORT [n]\n",
  "DAVENS": "DAVEN, (Yiddish) to utter Jewish prayers, also DOVEN [v]\n",
  "DAVIDIA": "a kind of tree, aka handkerchief tree [n -S]\n",
  "DAVIDIAS": "DAVIDIA, a kind of tree, aka handkerchief tree [n]\n",
  "DAVIES": "DAVY, a safety lamp [n]\n",
  "DAVIT": "a crane that projects over the side of a ship hatchway for moving cargo [n -S]\n",
  "DAVITS": "DAVIT, a crane that projects over the side of a ship hatchway for moving cargo [n]\n",
  "DAVY": "a safety lamp [n DAVIES]\n",
  "DAW": "to dawn [v DAWED, DAWEN, DAWING, DAWS]\n",
  "DAWAH": "(Arabic) the practice of educating nonbelievers about the practice of Islam [n -S]\n",
  "DAWAHS": "DAWAH, (Arabic) the practice of educating nonbelievers about the practice of Islam [n]\n",
  "DAWBAKE": "(dialect) a slow-witted person [n -S]\n",
  "DAWBAKES": "DAWBAKE, (dialect) a slow-witted person [n]\n",
  "DAWBRIES": "DAWBRY, (Shakespeare) a crudely artful device, a pretence, also DAUBERY, DAUBRY [n]\n",
  "DAWBRY": "(Shakespeare) a crudely artful device, a pretence, also DAUBERY, DAUBRY [n DAWBRIES]\n",
  "DAWCOCK": "(archaic) a cock jackdaw, a simpleton [n -S]\n",
  "DAWCOCKS": "DAWCOCK, (archaic) a cock jackdaw, a simpleton [n]\n",
  "DAWD": "(Scots) to knock, thump, also DAUD, DOD [v -ED, -ING, -S]\n",
  "DAWDED": "DAWD, (Scots) to knock, thump, also DAUD, DOD [v]\n",
  "DAWDING": "DAWD, (Scots) to knock, thump, also DAUD, DOD [v]\n",
  "DAWDLE": "to waste time [v DAWDLED, DAWDLING, DAWDLES]\n",
  "DAWDLED": "DAWDLE, to waste time [v]\n",
  "DAWDLER": "one who dawdles [n -S]\n",
  "DAWDLERS": "DAWDLER, one who dawdles [n]\n",
  "DAWDLES": "DAWDLE, to waste time [v]\n",
  "DAWDLING": "wasting time [adj DAWDLINGLY] / the act of wasting time [n -S]\n",
  "DAWDLINGLY": "DAWDLING [adv]\n",
  "DAWDLINGS": "DAWDLING, the act of wasting time [n]\n",
  "DAWDS": "DAWD, (Scots) to knock, thump, also DAUD, DOD [v]\n",
  "DAWED": "DAW, to dawn [v]\n",
  "DAWEN": "DAW, to dawn [v]\n",
  "DAWING": "DAW, to dawn [v]\n",
  "DAWISH": "like a daw, a jackdaw, foolish [adj]\n",
  "DAWK": "(Hindi) the mail-post in India, also DAK [n -S]\n",
  "DAWKS": "DAWK, (Hindi) the mail-post in India, also DAK [n]\n",
  "DAWN": "to grow light in the morning [v -ED, -ING, -S]\n",
  "DAWNED": "DAWN, to grow light in the morning [v]\n",
  "DAWNER": "(dialect) to stroll, saunter, also DANDER, DAUNDER, DAUNER [v -ED, -ING, -S]\n",
  "DAWNERED": "DAWNER, (dialect) to stroll, saunter, also DANDER, DAUNDER, DAUNER [v]\n",
  "DAWNERING": "DAWNER, (dialect) to stroll, saunter, also DANDER, DAUNDER, DAUNER [v]\n",
  "DAWNERS": "DAWNER, (dialect) to stroll, saunter, also DANDER, DAUNDER, DAUNER [v]\n",
  "DAWNEY": "(Irish) dull or slow [adj]\n",
  "DAWNING": "daybreak [n -S]\n",
  "DAWNINGS": "DAWNING, daybreak [n]\n",
  "DAWNLIKE": "suggestive of daybreak [adj]\n",
  "DAWNS": "DAWN, to grow light in the morning [v]\n",
  "DAWS": "DAW, to dawn [v]\n",
  "DAWSONITE": "a hydrous carbonate of alumina and soda, occurring in white, bladed crystals [n -S]\n",
  "DAWSONITES": "DAWSONITE, a hydrous carbonate of alumina and soda, occurring in white, bladed crystals [n]\n",
  "DAWT": "(Scots) to pet, also DAUT [v -ED, -ING, -S]\n",
  "DAWTED": "DAWT, (Scots) to pet, also DAUT [v]\n",
  "DAWTIE": "(Scots) a pet, also DAUTIE [n -S]\n",
  "DAWTIES": "DAWTIE, (Scots) a pet, also DAUTIE [n]\n",
  "DAWTING": "DAWT, (Scots) to pet, also DAUT [v]\n",
  "DAWTS": "DAWT, (Scots) to pet, also DAUT [v]\n",
  "DAY": "the time between sunrise and sunset [n -S]\n",
  "DAYAN": "(Hebrew) a senior rabbi [n DAYANS or DAYANIM]\n",
  "DAYANIM": "DAYAN, (Hebrew) a senior rabbi [n]\n",
  "DAYANS": "DAYAN, (Hebrew) a senior rabbi [n]\n",
  "DAYBED": "a bed in a hospital for patients coming in for the day [n -S]\n",
  "DAYBEDS": "DAYBED, a bed in a hospital for patients coming in for the day [n]\n",
  "DAYBOAT": "a small pleasure boat with no sleeping accommodation [n -S]\n",
  "DAYBOATS": "DAYBOAT, a small pleasure boat with no sleeping accommodation [n]\n",
  "DAYBOOK": "an account-book in which esp. sale transactions are entered at once for later transfer to a ledger [n -S]\n",
  "DAYBOOKS": "DAYBOOK, an account-book in which esp. sale transactions are entered at once for later transfer to a ledger [n]\n",
  "DAYBOY": "a boy who attends classes at a boarding school, but does not live in [n -S]\n",
  "DAYBOYS": "DAYBOY, a boy who attends classes at a boarding school, but does not live in [n]\n",
  "DAYBREAK": "the first appearance of light in the morning [n -S]\n",
  "DAYBREAKS": "DAYBREAK, the first appearance of light in the morning [n]\n",
  "DAYCARE": "care for children and disabled adults during the day [n -S]\n",
  "DAYCARES": "DAYCARE, care for children and disabled adults during the day [n]\n",
  "DAYCATION": "a day trip to a resort, hotel, etc. that does not involve staying the night [n -S]\n",
  "DAYCATIONS": "DAYCATION, a day trip to a resort, hotel, etc. that does not involve staying the night [n]\n",
  "DAYCENTRE": "a building used for daycare [n -S]\n",
  "DAYCENTRES": "DAYCENTRE, a building used for daycare [n]\n",
  "DAYCH": "(dialect) to thatch [v -ED, -ING, -ES]\n",
  "DAYCHED": "DAYCH, (dialect) to thatch [v]\n",
  "DAYCHES": "DAYCH, (dialect) to thatch [v]\n",
  "DAYCHING": "DAYCH, (dialect) to thatch [v]\n",
  "DAYDREAM": "to fantasize [v DAYDREAMT or DAYDREAMED, DAYDREAMING, DAYDREAMS]\n",
  "DAYDREAMED": "DAYDREAM, to fantasize [v]\n",
  "DAYDREAMER": "one who daydreams [n -S]\n",
  "DAYDREAMERS": "DAYDREAMER, one who daydreams [n]\n",
  "DAYDREAMIER": "DAYDREAMY, given to daydreaming [adj]\n",
  "DAYDREAMIEST": "DAYDREAMY, given to daydreaming [adj]\n",
  "DAYDREAMING": "having daydreams [n -S]\n",
  "DAYDREAMINGS": "DAYDREAMING, having daydreams [n]\n",
  "DAYDREAMLIKE": "like a daydream [adj]\n",
  "DAYDREAMS": "DAYDREAM, to fantasize [v]\n",
  "DAYDREAMT": "DAYDREAM, to fantasize [v]\n",
  "DAYDREAMY": "given to daydreaming [adj DAYDREAMIER, DAYDREAMIEST]\n",
  "DAYFLIES": "DAYFLY, a mayfly [n]\n",
  "DAYFLOWER": "a genus consisting mostly of tropical perennial herbs, having ephemeral flowers [n -S]\n",
  "DAYFLOWERS": "DAYFLOWER, a genus consisting mostly of tropical perennial herbs, having ephemeral flowers [n]\n",
  "DAYFLY": "a mayfly [n DAYFLIES]\n",
  "DAYGIRL": "a girl who attends a boarding-school daily but returns home in the evening [n -S]\n",
  "DAYGIRLS": "DAYGIRL, a girl who attends a boarding-school daily but returns home in the evening [n]\n",
  "DAYGLO": "(tradename) of a luminous green, yellow, pink or orange [adj]\n",
  "DAYGLOW": "an airglow seen during the day [n -S]\n",
  "DAYGLOWS": "DAYGLOW, an airglow seen during the day [n]\n",
  "DAYLIGHT": "to illuminate with the light of day [v DAYLIGHTED, DAYLIT, DAYLIGHTING, DAYLIGHTS]\n",
  "DAYLIGHTED": "DAYLIGHT, to illuminate with the light of day [v]\n",
  "DAYLIGHTING": "illuminating by daylight [n -S]\n",
  "DAYLIGHTINGS": "DAYLIGHTING, illuminating by daylight [n]\n",
  "DAYLIGHTS": "DAYLIGHT, to illuminate with the light of day [v]\n",
  "DAYLILIES": "DAYLILY, a liliaceous plant genus, whose flowers last for one day only [n]\n",
  "DAYLILY": "a liliaceous plant genus, whose flowers last for one day only [n DAYLILIES]\n",
  "DAYLIT": "DAYLIGHT, to illuminate with the light of day [v]\n",
  "DAYLONG": "lasting all day [adj]\n",
  "DAYMARE": "a terrifying experience, similar to a nightmare, felt while awake [n -S]\n",
  "DAYMARES": "DAYMARE, a terrifying experience, similar to a nightmare, felt while awake [n]\n",
  "DAYMARK": "an unlighted seamark [n -S]\n",
  "DAYMARKS": "DAYMARK, an unlighted seamark [n]\n",
  "DAYNT": "(Spenser) a thing or condition that is extravagant or best, also DAINT [n -S]\n",
  "DAYNTS": "DAYNT, (Spenser) a thing or condition that is extravagant or best, also DAINT [n]\n",
  "DAYPACK": "(US) a daysack [n -S]\n",
  "DAYPACKS": "DAYPACK, (US) a daysack [n]\n",
  "DAYROOM": "a room for reading and relaxing [n -S]\n",
  "DAYROOMS": "DAYROOM, a room for reading and relaxing [n]\n",
  "DAYS": "DAY, the time between sunrise and sunset [n]\n",
  "DAYSACK": "a small rucksack for short day walks [n -S]\n",
  "DAYSACKS": "DAYSACK, a small rucksack for short day walks [n]\n",
  "DAYSAIL": "to sail a yacht for a day [v -ED, -ING, -S]\n",
  "DAYSAILED": "DAYSAIL, to sail a yacht for a day [v]\n",
  "DAYSAILER": "a dayboat powered by sail, also DAYSAILOR [n -S]\n",
  "DAYSAILERS": "DAYSAILER, a dayboat powered by sail, also DAYSAILOR [n]\n",
  "DAYSAILING": "DAYSAIL, to sail a yacht for a day [v]\n",
  "DAYSAILOR": "a dayboat powered by sail, also DAYSAILER [n -S]\n",
  "DAYSAILORS": "DAYSAILOR, a dayboat powered by sail, also DAYSAILER [n]\n",
  "DAYSAILS": "DAYSAIL, to sail a yacht for a day [v]\n",
  "DAYSHELL": "(dialect) a thistle [n -S]\n",
  "DAYSHELLS": "DAYSHELL, (dialect) a thistle [n]\n",
  "DAYSIDE": "the sun side of a planet [n -S]\n",
  "DAYSIDES": "DAYSIDE, the sun side of a planet [n]\n",
  "DAYSMAN": "an umpire or arbiter; a mediator [n DAYSMEN]\n",
  "DAYSMEN": "DAYSMAN, an umpire or arbiter; a mediator [n]\n",
  "DAYSPRING": "(archaic) dawn [n -S]\n",
  "DAYSPRINGS": "DAYSPRING, (archaic) dawn [n]\n",
  "DAYSTAR": "the planet Venus, visible just before sunrise [n -S]\n",
  "DAYSTARS": "DAYSTAR, the planet Venus, visible just before sunrise [n]\n",
  "DAYTALE": "reckoning by the day, esp. of work or wages, also DATAL [n -S]\n",
  "DAYTALER": "a day-labourer, also DATALLER [n -S]\n",
  "DAYTALERS": "DAYTALER, a day-labourer, also DATALLER [n]\n",
  "DAYTALES": "DAYTALE, reckoning by the day, esp. of work or wages, also DATAL [n]\n",
  "DAYTIME": "the time during which it is day [n -S]\n",
  "DAYTIMES": "DAYTIME, the time during which it is day [n]\n",
  "DAYWEAR": "clothes intended for wearing during the day or informally [n -S]\n",
  "DAYWEARS": "DAYWEAR, clothes intended for wearing during the day or informally [n]\n",
  "DAYWORK": "work done on a daily basis [n -S]\n",
  "DAYWORKER": "one who does daywork [n -S]\n",
  "DAYWORKERS": "DAYWORKER, one who does daywork [n]\n",
  "DAYWORKS": "DAYWORK, work done on a daily basis [n]\n",
  "DAZE": "to stun [v DAZED, DAZING, DAZES]\n",
  "DAZED": "DAZE, to stun [v]\n",
  "DAZEDLY": "DAZED, DAZE, to stun [adv]\n",
  "DAZEDNESS": "the state of being dazed [n -ES]\n",
  "DAZEDNESSES": "DAZEDNESS, the state of being dazed [n]\n",
  "DAZER": "something that dazes [n -S]\n",
  "DAZERS": "DAZER, something that dazes [n]\n",
  "DAZES": "DAZE, to stun [v]\n",
  "DAZING": "DAZE, to stun [v]\n",
  "DAZZLE": "to blind with a bright light [v DAZZLED, DAZZLING, DAZZLES]\n",
  "DAZZLED": "DAZZLE, to blind with a bright light [v]\n",
  "DAZZLEMENT": "dazzling flash, glare, or burst of light [n -S]\n",
  "DAZZLEMENTS": "DAZZLEMENT, dazzling flash, glare, or burst of light [n]\n",
  "DAZZLER": "a remarkable or excellent thing or person [n -S]\n",
  "DAZZLERS": "DAZZLER, a remarkable or excellent thing or person [n]\n",
  "DAZZLES": "DAZZLE, to blind with a bright light [v]\n",
  "DAZZLING": "blindingly bright [adj DAZZLINGLY] / the act of dazzling [n -S]\n",
  "DAZZLINGLY": "DAZZLING, blindingly bright [adv]\n",
  "DAZZLINGS": "DAZZLING, the act of dazzling [n]\n",
  "DE": "from (as used in names) [prep]\n",
  "DEACIDIFICATION": "the act of deacidifying [n]\n",
  "DEACIDIFIED": "DEACIDIFY, to remove the acid from [v]\n",
  "DEACIDIFIES": "DEACIDIFY, to remove the acid from [v]\n",
  "DEACIDIFY": "to remove the acid from [v DEACIDIFIED, DEACIDIFYING, DEACIDIFIES]\n",
  "DEACIDIFYING": "DEACIDIFY, to remove the acid from [v]\n",
  "DEACON": "to put the best looking goods on top of the pile [v -ED, -ING, -S]\n",
  "DEACONED": "DEACON, to put the best looking goods on top of the pile [v]\n",
  "DEACONESS": "a female deacon [n -ES]\n",
  "DEACONESSES": "DEACONESS, a female deacon [n]\n",
  "DEACONHOOD": "the office of deacon [n -S]\n",
  "DEACONHOODS": "DEACONHOOD, the office of deacon [n]\n",
  "DEACONING": "DEACON, to put the best looking goods on top of the pile [v]\n",
  "DEACONRIES": "DEACONRY, a clerical office [n]\n",
  "DEACONRY": "a clerical office [n DEACONRIES]\n",
  "DEACONS": "DEACON, to put the best looking goods on top of the pile [v]\n",
  "DEACONSHIP": "the office or ministry of a deacon or deaconess [n -S]\n",
  "DEACONSHIPS": "DEACONSHIP, the office or ministry of a deacon or deaconess [n]\n",
  "DEACTIVATE": "to make inactive or ineffective [v DEACTIVATED, DEACTIVATING, DEACTIVATES]\n",
  "DEACTIVATED": "DEACTIVATE, to make inactive or ineffective [v]\n",
  "DEACTIVATES": "DEACTIVATE, to make inactive or ineffective [v]\n",
  "DEACTIVATING": "DEACTIVATE, to make inactive or ineffective [v]\n",
  "DEACTIVATION": "the process of deactivating [n -S]\n",
  "DEACTIVATIONS": "DEACTIVATION, the process of deactivating [n]\n",
  "DEACTIVATOR": "something that deactivates [n -S]\n",
  "DEACTIVATORS": "DEACTIVATOR, something that deactivates [n]\n",
  "DEAD": "not alive [adj DEADER, DEADEST] / (obsolete) to lose vitality, become numb [v -ED, -ING, -S]\n",
  "DEADBEAT": "one who is totally exhausted [n -S]\n",
  "DEADBEATS": "DEADBEAT, one who is totally exhausted [n]\n",
  "DEADBOLT": "a lock for a door [n -S]\n",
  "DEADBOLTS": "DEADBOLT, a lock for a door [n]\n",
  "DEADBOY": "a metal plate driven into firm snow for use by mountaineers as a belaying point, also DEADMAN [n -S]\n",
  "DEADBOYS": "DEADBOY, a metal plate driven into firm snow for use by mountaineers as a belaying point, also DEADMAN [n]\n",
  "DEADED": "DEAD, (obsolete) to lose vitality, become numb [v]\n",
  "DEADEN": "to deprive of feeling [v -ED, -ING, -S]\n",
  "DEADENED": "DEADEN, to deprive of feeling [v]\n",
  "DEADENER": "one that deadens [n -S]\n",
  "DEADENERS": "DEADENER, one that deadens [n]\n",
  "DEADENING": "numbing [adj DEADENINGLY] / the act of numbing, making dead [n -S]\n",
  "DEADENINGLY": "DEADENING [adv]\n",
  "DEADENINGS": "DEADENING, the act of numbing, making dead [n]\n",
  "DEADENS": "DEADEN, to deprive of feeling [v]\n",
  "DEADER": "a dead person [n -S]\n",
  "DEADERS": "DEADER, a dead person [n]\n",
  "DEADEST": "DEAD, not alive [adj]\n",
  "DEADEYE": "a rounded wood block that is encircled by a rope or an iron band and pierced with holes to receive the lanyard and that is used esp. to set up shrouds and stays [n -S]\n",
  "DEADEYES": "DEADEYE, a rounded wood block that is encircled by a rope or an iron band and pierced with holes to receive the lanyard and that is used esp. to set up shrouds and stays [n]\n",
  "DEADFALL": "a type of animal trap [n -S]\n",
  "DEADFALLS": "DEADFALL, a type of animal trap [n]\n",
  "DEADHEAD": "to remove the dead heads from flowers [v -ED, -ING, -S]\n",
  "DEADHEADED": "DEADHEAD, to remove the dead heads from flowers [v]\n",
  "DEADHEADING": "DEADHEAD, to remove the dead heads from flowers [v]\n",
  "DEADHEADS": "DEADHEAD, to remove the dead heads from flowers [v]\n",
  "DEADHOUSE": "a mortuary [n -S]\n",
  "DEADHOUSES": "DEADHOUSE, a mortuary [n]\n",
  "DEADING": "DEAD, (obsolete) to lose vitality, become numb [v]\n",
  "DEADLIER": "DEADLY, lethal [adj]\n",
  "DEADLIEST": "DEADLY, lethal [adj]\n",
  "DEADLIFT": "to lift without leverage [v -ED, -ING, -S]\n",
  "DEADLIFTED": "DEADLIFT, to lift without leverage [v]\n",
  "DEADLIFTING": "DEADLIFT, to lift without leverage [v]\n",
  "DEADLIFTS": "DEADLIFT, to lift without leverage [v]\n",
  "DEADLIGHT": "a strong shutter, made to fit open ports and keep out water in a storm [n -S]\n",
  "DEADLIGHTS": "DEADLIGHT, a strong shutter, made to fit open ports and keep out water in a storm [n]\n",
  "DEADLINE": "a time limit [n -S] / to put a time limit on [v DEADLINED, DEADLINING, DEADLINES]\n",
  "DEADLINED": "DEADLINE, to put a time limit on [v]\n",
  "DEADLINES": "DEADLINE, to put a time limit on [v]\n",
  "DEADLINESS": "the quality of being deadly [n -ES]\n",
  "DEADLINESSES": "DEADLINESS, the quality of being deadly [n]\n",
  "DEADLINING": "DEADLINE, to put a time limit on [v]\n",
  "DEADLOCK": "to come to a standstill [v -ED, -ING, -S]\n",
  "DEADLOCKED": "DEADLOCK, to come to a standstill [v]\n",
  "DEADLOCKING": "DEADLOCK, to come to a standstill [v]\n",
  "DEADLOCKS": "DEADLOCK, to come to a standstill [v]\n",
  "DEADLY": "lethal [adj DEADLIER, DEADLIEST]\n",
  "DEADMAN": "a metal plate driven into firm snow for use by mountaineers as a belaying point, also DEADBOY [n DEADMEN]\n",
  "DEADMEN": "DEADMAN, a metal plate driven into firm snow for use by mountaineers as a belaying point, also DEADBOY [n]\n",
  "DEADNESS": "the state of being dead [n -ES]\n",
  "DEADNESSES": "DEADNESS, the state of being dead [n]\n",
  "DEADPAN": "to act without emotion [v DEADPANNED, DEADPANNING, DEADPANS]\n",
  "DEADPANNED": "DEADPAN, to act without emotion [v]\n",
  "DEADPANNER": "one who acts in a deadpan way [n -S]\n",
  "DEADPANNERS": "DEADPANNER, one who acts in a deadpan way [n]\n",
  "DEADPANNING": "DEADPAN, to act without emotion [v]\n",
  "DEADPANS": "DEADPAN, to act without emotion [v]\n",
  "DEADS": "DEAD, (obsolete) to lose vitality, become numb [v]\n",
  "DEADSTOCK": "farm equipment [n -S]\n",
  "DEADSTOCKS": "DEADSTOCK, farm equipment [n]\n",
  "DEADSTROKE": "without recoil [adj]\n",
  "DEADWATER": "still water without any current [n -S]\n",
  "DEADWATERS": "DEADWATER, still water without any current [n]\n",
  "DEADWEIGHT": "a weight esp. of a person that does not support itself [n -S]\n",
  "DEADWEIGHTS": "DEADWEIGHT, a weight esp. of a person that does not support itself [n]\n",
  "DEADWOOD": "useless material or personnel [n -S]\n",
  "DEADWOODS": "DEADWOOD, useless material or personnel [n]\n",
  "DEAERATE": "to remove air or gas from [v DEAERATED, DEAERATING, DEAERATES]\n",
  "DEAERATED": "DEAERATE, to remove air or gas from [v]\n",
  "DEAERATES": "DEAERATE, to remove air or gas from [v]\n",
  "DEAERATING": "DEAERATE, to remove air or gas from [v]\n",
  "DEAERATION": "the removal of air bubbles [n -S]\n",
  "DEAERATIONS": "DEAERATION, the removal of air bubbles [n]\n",
  "DEAERATOR": "a device for removing air bubbles [n -S]\n",
  "DEAERATORS": "DEAERATOR, a device for removing air bubbles [n]\n",
  "DEAF": "lacking the sense of hearing [adj DEAFER, DEAFEST, DEAFLY]\n",
  "DEAFBLIND": "deaf and blind [adj]\n",
  "DEAFEN": "to make deaf [v -ED, -ING, -S]\n",
  "DEAFENED": "DEAFEN, to make deaf [v]\n",
  "DEAFENING": "very loud [adj DEAFENINGLY] / the act of making deaf [n -S]\n",
  "DEAFENINGLY": "DEAFENING, very loud [adv]\n",
  "DEAFENINGS": "DEAFENING, the act of making deaf [n]\n",
  "DEAFENS": "DEAFEN, to make deaf [v]\n",
  "DEAFER": "DEAF, lacking the sense of hearing [adj]\n",
  "DEAFEST": "DEAF, lacking the sense of hearing [adj]\n",
  "DEAFISH": "somewhat deaf [adj]\n",
  "DEAFLY": "DEAF, lacking the sense of hearing [adv]\n",
  "DEAFNESS": "the state of being deaf [n -ES]\n",
  "DEAFNESSES": "DEAFNESS, the state of being deaf [n]\n",
  "DEAIR": "to remove air from [v -ED, -ING, -S]\n",
  "DEAIRED": "DEAIR, to remove air from [v]\n",
  "DEAIRING": "DEAIR, to remove air from [v]\n",
  "DEAIRS": "DEAIR, to remove air from [v]\n",
  "DEAL": "to trade or do business [v DEALT, DEALING, DEALS]\n",
  "DEALATE": "an insect divested of its wings [n -S]\n",
  "DEALATED": "without wings [adj]\n",
  "DEALATES": "DEALATE, an insect divested of its wings [n]\n",
  "DEALATION": "the removal of wings [n -S]\n",
  "DEALATIONS": "DEALATION, the removal of wings [n]\n",
  "DEALBATE": "whitened [adj]\n",
  "DEALBATION": "whitening; bleaching [n -S]\n",
  "DEALBATIONS": "DEALBATION, whitening; bleaching [n]\n",
  "DEALBREAKER": "an issue that prevents an agreement from being reached [n -S]\n",
  "DEALBREAKERS": "DEALBREAKER, an issue that prevents an agreement from being reached [n]\n",
  "DEALER": "one that deals [n -S]\n",
  "DEALERS": "DEALER, one that deals [n]\n",
  "DEALERSHIP": "an authorized sales agency [n -S]\n",
  "DEALERSHIPS": "DEALERSHIP, an authorized sales agency [n]\n",
  "DEALFISH": "a kind of marine fish, aka ribbonfish [n -ES]\n",
  "DEALFISHES": "DEALFISH, a kind of marine fish, aka ribbonfish [n]\n",
  "DEALIGN": "to withdraw allegiance to a political party [v -ED, -ING, -S]\n",
  "DEALIGNED": "DEALIGN, to withdraw allegiance to a political party [v]\n",
  "DEALIGNING": "DEALIGN, to withdraw allegiance to a political party [v]\n",
  "DEALIGNS": "DEALIGN, to withdraw allegiance to a political party [v]\n",
  "DEALING": "a business transaction [n -S]\n",
  "DEALINGS": "DEALING, a business transaction [n]\n",
  "DEALMAKER": "a person who makes deals, especially commercial deals [n -S]\n",
  "DEALMAKERS": "DEALMAKER, a person who makes deals, especially commercial deals [n]\n",
  "DEALS": "DEAL, to trade or do business [v]\n",
  "DEALT": "DEAL, to trade or do business [v]\n",
  "DEAMBULATORIES": "DEAMBULATORY, a place for walking around or about in [n]\n",
  "DEAMBULATORY": "a place for walking around or about in [n DEAMBULATORIES]\n",
  "DEAMINASE": "an enzyme that hydrolyzes amino compounds [n -S]\n",
  "DEAMINASES": "DEAMINASE, an enzyme that hydrolyzes amino compounds [n]\n",
  "DEAMINATE": "to remove the amino acid from a compound [v DEAMINATED, DEAMINATING, DEAMINATES]\n",
  "DEAMINATED": "DEAMINATE, to remove the amino acid from a compound [v]\n",
  "DEAMINATES": "DEAMINATE, to remove the amino acid from a compound [v]\n",
  "DEAMINATING": "DEAMINATE, to remove the amino acid from a compound [v]\n",
  "DEAMINATION": "the act of deaminating [n -S]\n",
  "DEAMINATIONS": "DEAMINATION, the act of deaminating [n]\n",
  "DEAMINISATION": "the process of deaminising, also DEAMINIZATION [n -S]\n",
  "DEAMINISATIONS": "DEAMINISATION, the process of deaminising, also DEAMINIZATION [n]\n",
  "DEAMINISE": "to remove the amino acid from a compound, also DEAMINIZE [v DEAMINISED, DEAMINISING, DEAMINISES]\n",
  "DEAMINISED": "DEAMINISE, to remove the amino acid from a compound, also DEAMINIZE [v]\n",
  "DEAMINISES": "DEAMINISE, to remove the amino acid from a compound, also DEAMINIZE [v]\n",
  "DEAMINISING": "DEAMINISE, to remove the amino acid from a compound, also DEAMINIZE [v]\n",
  "DEAMINIZATION": "the process of deaminizing, also DEAMINISATION [n -S]\n",
  "DEAMINIZATIONS": "DEAMINIZATION, the process of deaminizing, also DEAMINISATION [n]\n",
  "DEAMINIZE": "to remove the amino acid from a compound, also DEAMINISE [v DEAMINIZED, DEAMINIZING, DEAMINIZES]\n",
  "DEAMINIZED": "DEAMINIZE, to remove the amino acid from a compound, also DEAMINISE [v]\n",
  "DEAMINIZES": "DEAMINIZE, to remove the amino acid from a compound, also DEAMINISE [v]\n",
  "DEAMINIZING": "DEAMINIZE, to remove the amino acid from a compound, also DEAMINISE [v]\n",
  "DEAN": "to serve as the head of faculty [v -ED, -ING, -S]\n",
  "DEANED": "DEAN, to serve as the head of faculty [v]\n",
  "DEANER": "(obsolete slang) a shilling [n -S]\n",
  "DEANERIES": "DEANERY, the office of a dean, also DEANSHIP [n]\n",
  "DEANERS": "DEANER, (obsolete slang) a shilling [n]\n",
  "DEANERY": "the office of a dean, also DEANSHIP [n DEANERIES]\n",
  "DEANING": "DEAN, to serve as the head of faculty [v]\n",
  "DEANS": "DEAN, to serve as the head of faculty [v]\n",
  "DEANSHIP": "the office of a dean, also DEANERY [n -S]\n",
  "DEANSHIPS": "DEANSHIP, the office of a dean, also DEANERY [n]\n",
  "DEAR": "costly [adj DEARER, DEAREST, DEARLY] / (obsolete) to injure, also DEARE, DERE [v -ED, -ING, -S]\n",
  "DEARBOUGHT": "precious [adj]\n",
  "DEARE": "(Spenser) to injure, also DEAR, DERE [v DEARED, DEARING, DEARES]\n",
  "DEARED": "DEARE, (Spenser) to injure, also DEAR, DERE [v]\n",
  "DEARER": "DEAR, costly [adj]\n",
  "DEARES": "DEARE, (Spenser) to injure, also DEAR, DERE [v]\n",
  "DEAREST": "a loved one [n -S]\n",
  "DEARESTS": "DEAREST, a loved one [n]\n",
  "DEARIE": "a term of endearment, also DEARY [n -S]\n",
  "DEARIES": "DEARIE, a term of endearment, also DEARY [n]\n",
  "DEARING": "DEARE, (Spenser) to injure, also DEAR, DERE [v]\n",
  "DEARLING": "(Spenser) a much loved person, also DARLING [n -S]\n",
  "DEARLINGS": "DEARLING, (Spenser) a much loved person, also DARLING [n]\n",
  "DEARLY": "DEAR, costly [adv]\n",
  "DEARN": "secret; lonely, also DERN [adj DEARNLY] / to darn [v -ED, -ING, -S]\n",
  "DEARNED": "DEARN, to darn [v]\n",
  "DEARNESS": "the state of being dear [n -ES]\n",
  "DEARNESSES": "DEARNESS, the state of being dear [n]\n",
  "DEARNFUL": "solitary; mournful, also DERNFUL [adj]\n",
  "DEARNING": "DEARN, to darn [v]\n",
  "DEARNLY": "DEARN, secret; lonely, also DERN [adv]\n",
  "DEARNS": "DEARN, to darn [v]\n",
  "DEARS": "DEAR, (obsolete) to injure, also DEARE, DERE [v]\n",
  "DEARTH": "scarcity, also DERTH [n -S]\n",
  "DEARTHS": "DEARTH, scarcity, also DERTH [n]\n",
  "DEARTICULATE": "to disjoint [v DEARTICULATED, DEARTICULATING, DEARTICULATES]\n",
  "DEARTICULATED": "DEARTICULATE, to disjoint [v]\n",
  "DEARTICULATES": "DEARTICULATE, to disjoint [v]\n",
  "DEARTICULATING": "DEARTICULATE, to disjoint [v]\n",
  "DEARY": "a term of endearment, also DEARIE [n DEARIES]\n",
  "DEASH": "to remove ash from [v -ED, -ING, -ES]\n",
  "DEASHED": "DEASH, to remove ash from [v]\n",
  "DEASHES": "DEASH, to remove ash from [v]\n",
  "DEASHING": "DEASH, to remove ash from [v]\n",
  "DEASIL": "(Scots) motion in the same direction as the sun, also DEASIUL, DEASOIL, DEISEAL, DEISHEAL [n -S]\n",
  "DEASILS": "DEASIL, (Scots) motion in the same direction as the sun, also DEASIUL, DEASOIL, DEISEAL, DEISHEAL [n]\n",
  "DEASIUL": "(Scots) motion in the same direction as the sun, also DEASIL, DEASOIL, DEISEAL, DEISHEAL [n -S]\n",
  "DEASIULS": "DEASIUL, (Scots) motion in the same direction as the sun, also DEASIL, DEASOIL, DEISEAL, DEISHEAL [n]\n",
  "DEASOIL": "(Scots) motion in the same direction as the sun, also DEASIL, DEASIUL, DEISEAL, DEISHEAL [n -S]\n",
  "DEASOILS": "DEASOIL, (Scots) motion in the same direction as the sun, also DEASIL, DEASIUL, DEISEAL, DEISHEAL [n]\n",
  "DEASPIRATE": "to remove the aspirate from [v DEASPIRATED, DEASPIRATING, DEASPIRATES]\n",
  "DEASPIRATED": "DEASPIRATE, to remove the aspirate from [v]\n",
  "DEASPIRATES": "DEASPIRATE, to remove the aspirate from [v]\n",
  "DEASPIRATING": "DEASPIRATE, to remove the aspirate from [v]\n",
  "DEASPIRATION": "the act of deaspirating [n -S]\n",
  "DEASPIRATIONS": "DEASPIRATION, the act of deaspirating [n]\n",
  "DEATH": "the end of life [n -S]\n",
  "DEATHBED": "the bed on which a person dies [n -S]\n",
  "DEATHBEDS": "DEATHBED, the bed on which a person dies [n]\n",
  "DEATHBLOW": "a fatal blow [n -S]\n",
  "DEATHBLOWS": "DEATHBLOW, a fatal blow [n]\n",
  "DEATHCARE": "of, relating to, or providing products or services for the burial or cremation of the dead [adj]\n",
  "DEATHCUP": "a poisonous fungus [n -S]\n",
  "DEATHCUPS": "DEATHCUP, a poisonous fungus [n]\n",
  "DEATHFUL": "deadly, murderous [adj]\n",
  "DEATHIER": "DEATHY, like death [adj]\n",
  "DEATHIEST": "DEATHY, like death [adj]\n",
  "DEATHLESS": "not subject to death [adj DEATHLESSLY]\n",
  "DEATHLESSLY": "DEATHLESS, not subject to death [adv]\n",
  "DEATHLESSNESS": "DEATHLESS, not subject to death [n]\n",
  "DEATHLESSNESSES": "DEATHLESSNESS, DEATHLESS, not subject to death [n]\n",
  "DEATHLIER": "DEATHLY, like death [adj]\n",
  "DEATHLIEST": "DEATHLY, like death [adj]\n",
  "DEATHLIKE": "like death [adj]\n",
  "DEATHLINESS": "the state of being deathly [n -ES]\n",
  "DEATHLINESSES": "DEATHLINESS, the state of being deathly [n]\n",
  "DEATHLY": "like death [adj DEATHLIER, DEATHLIEST]\n",
  "DEATHS": "DEATH, the end of life [n]\n",
  "DEATHSMAN": "(Shakespeare) an executioner [n DEATHSMEN]\n",
  "DEATHSMEN": "DEATHSMAN, (Shakespeare) an executioner [n]\n",
  "DEATHTRAP": "a potentially fatal situation [n -S]\n",
  "DEATHTRAPS": "DEATHTRAP, a potentially fatal situation [n]\n",
  "DEATHWARD": "toward death, also DEATHWARDS [adv]\n",
  "DEATHWARDS": "towards death, also DEATHWARD [adv]\n",
  "DEATHWATCH": "a vigil, a watch kept beside a dying person; a kind of beetle [n -ES]\n",
  "DEATHWATCHES": "DEATHWATCH, a vigil, a watch kept beside a dying person; a kind of beetle [n]\n",
  "DEATHY": "like death [adj DEATHIER, DEATHIEST]\n",
  "DEATTRIBUTE": "to withdraw the attribution of e.g. a work of art or literature to a particular artist, writer, etc. [v DEATTRIBUTED, DEATTRIBUTING, DEATTRIBUTES]\n",
  "DEATTRIBUTED": "DEATTRIBUTE, to withdraw the attribution of e.g. a work of art or literature to a particular artist, writer, etc. [v]\n",
  "DEATTRIBUTES": "DEATTRIBUTE, to withdraw the attribution of e.g. a work of art or literature to a particular artist, writer, etc. [v]\n",
  "DEATTRIBUTING": "DEATTRIBUTE, to withdraw the attribution of e.g. a work of art or literature to a particular artist, writer, etc. [v]\n",
  "DEAVE": "(Scots) to deafen, worry with noise, also DEEVE [v DEAVED, DEAVING, DEAVES]\n",
  "DEAVED": "DEAVE, (Scots) to deafen, worry with noise, also DEEVE [v]\n",
  "DEAVES": "DEAVE, (Scots) to deafen, worry with noise, also DEEVE [v]\n",
  "DEAVING": "DEAVE, (Scots) to deafen, worry with noise, also DEEVE [v]\n",
  "DEAW": "(Spenser) to cover with dew [v -ED, -ING, -S]\n",
  "DEAWED": "DEAW, (Spenser) to cover with dew [v]\n",
  "DEAWIE": "(Spenser) dewy, also DEAWY [adj]\n",
  "DEAWING": "DEAW, (Spenser) to cover with dew [v]\n",
  "DEAWS": "DEAW, (Spenser) to cover with dew [v]\n",
  "DEAWY": "(Spenser) dewy, also DEAWIE, DEWY [adj]\n",
  "DEB": "(short for) debutante [n -S]\n",
  "DEBACLE": "(French) a great disaster, a complete failure [n -S]\n",
  "DEBACLES": "DEBACLE, (French) a great disaster, a complete failure [n]\n",
  "DEBAG": "to take someone's trousers off as a punishment [v DEBAGGED, DEBAGGING, DEBAGS]\n",
  "DEBAGGED": "DEBAG, to take someone's trousers off as a punishment [v]\n",
  "DEBAGGING": "the act of removing the trousers from [n -S]\n",
  "DEBAGGINGS": "DEBAGGING, the act of removing the trousers from [n]\n",
  "DEBAGS": "DEBAG, to take someone's trousers off as a punishment [v]\n",
  "DEBAR": "to exclude [v DEBARRED, DEBARRING, DEBARS]\n",
  "DEBARCATION": "the act of debarking, also DEBARKATION [n -S]\n",
  "DEBARCATIONS": "DEBARCATION, the act of debarking, also DEBARKATION [n]\n",
  "DEBARK": "to unload from a ship [v -ED, -ING, -S]\n",
  "DEBARKATION": "the act of debarking, also DEBARCATION [n -S]\n",
  "DEBARKATIONS": "DEBARKATION, the act of debarking, also DEBARCATION [n]\n",
  "DEBARKED": "DEBARK, to unload from a ship [v]\n",
  "DEBARKER": "one that removes bark (the outer covering of woody plants) [n -S]\n",
  "DEBARKERS": "DEBARKER, one that removes bark (the outer covering of woody plants) [n]\n",
  "DEBARKING": "DEBARK, to unload from a ship [v]\n",
  "DEBARKS": "DEBARK, to unload from a ship [v]\n",
  "DEBARMENT": "the act of debarring [n -S]\n",
  "DEBARMENTS": "DEBARMENT, the act of debarring [n]\n",
  "DEBARRASS": "(archaic) to disembarrass, disentangle [v -ED, -ING, -ES]\n",
  "DEBARRASSED": "DEBARRASS, (archaic) to disembarrass, disentangle [v]\n",
  "DEBARRASSES": "DEBARRASS, (archaic) to disembarrass, disentangle [v]\n",
  "DEBARRASSING": "DEBARRASS, (archaic) to disembarrass, disentangle [v]\n",
  "DEBARRED": "DEBAR, to exclude [v]\n",
  "DEBARRING": "DEBAR, to exclude [v]\n",
  "DEBARS": "DEBAR, to exclude [v]\n",
  "DEBASE": "to lower or degrade [v DEBASED, DEBASING, DEBASES]\n",
  "DEBASED": "DEBASE, to lower or degrade [v]\n",
  "DEBASEDNESS": "the state of being debased [n -ES]\n",
  "DEBASEDNESSES": "DEBASEDNESS, the state of being debased [n]\n",
  "DEBASEMENT": "the act of debasing [n -S]\n",
  "DEBASEMENTS": "DEBASEMENT, the act of debasing [n]\n",
  "DEBASER": "one who debases [n -S]\n",
  "DEBASERS": "DEBASER, one who debases [n]\n",
  "DEBASES": "DEBASE, to lower or degrade [v]\n",
  "DEBASING": "DEBASE, to lower or degrade [v]\n",
  "DEBASINGLY": "DEBASING, DEBASE, to lower or degrade [adv]\n",
  "DEBATABLE": "that can be debated, also DEBATEABLE [adj DEBATABLY]\n",
  "DEBATABLY": "DEBATABLE, that can be debated, also DEBATEABLE [adv]\n",
  "DEBATE": "to deliberate [v DEBATED, DEBATING, DEBATES]\n",
  "DEBATEABLE": "that can be debated, also DEBATABLE [adj]\n",
  "DEBATED": "DEBATE, to deliberate [v]\n",
  "DEBATEFUL": "(obsolete) quarrelsome [adj]\n",
  "DEBATEMENT": "(obsolete) controversy [n -S]\n",
  "DEBATEMENTS": "DEBATEMENT, (obsolete) controversy [n]\n",
  "DEBATER": "one who debates [n -S]\n",
  "DEBATERS": "DEBATER, one who debates [n]\n",
  "DEBATES": "DEBATE, to deliberate [v]\n",
  "DEBATING": "the act of holding a debate [n -S]\n",
  "DEBATINGLY": "DEBATING [adv]\n",
  "DEBATINGS": "DEBATING, the act of holding a debate [n]\n",
  "DEBAUCH": "to lead into lewdness, also DEBOSH [v -ED, -ING, -ES]\n",
  "DEBAUCHED": "DEBAUCH, to lead into lewdness, also DEBOSH [v]\n",
  "DEBAUCHEDLY": "DEBAUCHED, DEBAUCH, to lead into lewdness, also DEBOSH [adv]\n",
  "DEBAUCHEDNESS": "the state of being debauched [n -ES]\n",
  "DEBAUCHEDNESSES": "DEBAUCHEDNESS, the state of being debauched [n]\n",
  "DEBAUCHEE": "one who is debauched [n -S]\n",
  "DEBAUCHEES": "DEBAUCHEE, one who is debauched [n]\n",
  "DEBAUCHER": "one who debauches [n -S]\n",
  "DEBAUCHERIES": "DEBAUCHERY, the act of debauching [n]\n",
  "DEBAUCHERS": "DEBAUCHER, one who debauches [n]\n",
  "DEBAUCHERY": "the act of debauching [n DEBAUCHERIES]\n",
  "DEBAUCHES": "DEBAUCH, to lead into lewdness, also DEBOSH [v]\n",
  "DEBAUCHING": "DEBAUCH, to lead into lewdness, also DEBOSH [v]\n",
  "DEBAUCHMENT": "the act of debauching [n -S]\n",
  "DEBAUCHMENTS": "DEBAUCHMENT, the act of debauching [n]\n",
  "DEBBIER": "DEBBY, like a debutante [adj]\n",
  "DEBBIES": "DEBBY, a debutante [n]\n",
  "DEBBIEST": "DEBBY, like a debutante [adj]\n",
  "DEBBY": "a debutante [n DEBBIES] / like a debutante [adj DEBBIER, DEBBIEST]\n",
  "DEBE": "(Swahili) a large tin [n -S]\n",
  "DEBEAK": "to remove the tip of the upper beak [v -ED, -ING, -S]\n",
  "DEBEAKED": "DEBEAK, to remove the tip of the upper beak [v]\n",
  "DEBEAKING": "DEBEAK, to remove the tip of the upper beak [v]\n",
  "DEBEAKS": "DEBEAK, to remove the tip of the upper beak [v]\n",
  "DEBEARD": "to remove the beard from [v -ED, -ING, -S]\n",
  "DEBEARDED": "DEBEARD, to remove the beard from [v]\n",
  "DEBEARDING": "DEBEARD, to remove the beard from [v]\n",
  "DEBEARDS": "DEBEARD, to remove the beard from [v]\n",
  "DEBEL": "to conquer in war [v DEBELLED, DEBELLING, DEBELS]\n",
  "DEBELLED": "DEBEL, to conquer in war [v]\n",
  "DEBELLING": "DEBEL, to conquer in war [v]\n",
  "DEBELS": "DEBEL, to conquer in war [v]\n",
  "DEBENTURE": "an official certificate of right to receive payment; a bond [n -S]\n",
  "DEBENTURED": "entitled to drawback or debenture; as, debentured goods [adj]\n",
  "DEBENTURES": "DEBENTURE, an official certificate of right to receive payment; a bond [n]\n",
  "DEBES": "DEBE, (Swahili) a large tin [n]\n",
  "DEBILE": "(archaic) feeble [adj]\n",
  "DEBILITATE": "to make weak [v DEBILITATED, DEBILITATING, DEBILITATES]\n",
  "DEBILITATED": "DEBILITATE, to make weak [v]\n",
  "DEBILITATES": "DEBILITATE, to make weak [v]\n",
  "DEBILITATING": "DEBILITATE, to make weak [v]\n",
  "DEBILITATION": "the act of debilitating [n -S]\n",
  "DEBILITATIONS": "DEBILITATION, the act of debilitating [n]\n",
  "DEBILITATIVE": "weakening [adj]\n",
  "DEBILITIES": "DEBILITY, weakness [n]\n",
  "DEBILITY": "weakness [n DEBILITIES]\n",
  "DEBIT": "to charge with a debt [v -ED, -ING, -S]\n",
  "DEBITED": "DEBIT, to charge with a debt [v]\n",
  "DEBITING": "DEBIT, to charge with a debt [v]\n",
  "DEBITOR": "someone who owes a debt, also DEBTOR [n -S]\n",
  "DEBITORS": "DEBITOR, someone who owes a debt, also DEBTOR [n]\n",
  "DEBITS": "DEBIT, to charge with a debt [v]\n",
  "DEBONAIR": "(French) of good appearance, elegant, also DEBONAIRE, DEBONNAIRE [adj]\n",
  "DEBONAIRE": "of good appearance, elegant, also DEBONAIR, DEBONNAIRE [adj]\n",
  "DEBONAIRLY": "DEBONAIR, (French) of good appearance, elegant, also DEBONAIRE, DEBONNAIRE [adv]\n",
  "DEBONAIRNESS": "the state of being debonair [n -ES]\n",
  "DEBONAIRNESSES": "DEBONAIRNESS, the state of being debonair [n]\n",
  "DEBONE": "to remove the bones from [v DEBONED, DEBONING, DEBONES]\n",
  "DEBONED": "DEBONE, to remove the bones from [v]\n",
  "DEBONER": "a utensil for deboning [n -S]\n",
  "DEBONERS": "DEBONER, a utensil for deboning [n]\n",
  "DEBONES": "DEBONE, to remove the bones from [v]\n",
  "DEBONING": "DEBONE, to remove the bones from [v]\n",
  "DEBONNAIRE": "(French) of good appearance, elegant, also DEBONAIR, DEBONAIRE [adj]\n",
  "DEBOSH": "to lead into lewdness, also DEBAUCH [v -ED, -ING, -ES]\n",
  "DEBOSHED": "DEBOSH, to lead into lewdness, also DEBAUCH [v]\n",
  "DEBOSHES": "DEBOSH, to lead into lewdness, also DEBAUCH [v]\n",
  "DEBOSHING": "DEBOSH, to lead into lewdness, also DEBAUCH [v]\n",
  "DEBOSS": "to impress a design into [v -ED, -ING, -ES]\n",
  "DEBOSSED": "DEBOSS, to impress a design into [v]\n",
  "DEBOSSES": "DEBOSS, to impress a design into [v]\n",
  "DEBOSSING": "DEBOSS, to impress a design into [v]\n",
  "DEBOUCH": "to emerge or issue from a narrow area into the open [v -ED, -ING, -ES]\n",
  "DEBOUCHE": "an opening for the passage of troops [n -S]\n",
  "DEBOUCHED": "DEBOUCH, to emerge or issue from a narrow area into the open [v]\n",
  "DEBOUCHES": "DEBOUCH, to emerge or issue from a narrow area into the open [v]\n",
  "DEBOUCHING": "DEBOUCH, to emerge or issue from a narrow area into the open [v]\n",
  "DEBOUCHMENT": "the act of debouching [n -S]\n",
  "DEBOUCHMENTS": "DEBOUCHMENT, the act of debouching [n]\n",
  "DEBOUCHURE": "(French) the mouth of a river or strait [n -S]\n",
  "DEBOUCHURES": "DEBOUCHURE, (French) the mouth of a river or strait [n]\n",
  "DEBRIDE": "(French) to remove dead tissue surgically [v DEBRIDED, DEBRIDING, DEBRIDES]\n",
  "DEBRIDED": "DEBRIDE, (French) to remove dead tissue surgically [v]\n",
  "DEBRIDEMENT": "(French) the surgical removal of dead, infected tissue or foreign matter from a wound [n -S]\n",
  "DEBRIDEMENTS": "DEBRIDEMENT, (French) the surgical removal of dead, infected tissue or foreign matter from a wound [n]\n",
  "DEBRIDES": "DEBRIDE, (French) to remove dead tissue surgically [v]\n",
  "DEBRIDING": "DEBRIDE, (French) to remove dead tissue surgically [v]\n",
  "DEBRIEF": "to question after a mission [v -ED, -ING, -S]\n",
  "DEBRIEFED": "DEBRIEF, to question after a mission [v]\n",
  "DEBRIEFER": "one who debriefs [n -S]\n",
  "DEBRIEFERS": "DEBRIEFER, one who debriefs [n]\n",
  "DEBRIEFING": "questioning after a mission [n -S]\n",
  "DEBRIEFINGS": "DEBRIEFING, questioning after a mission [n]\n",
  "DEBRIEFS": "DEBRIEF, to question after a mission [v]\n",
  "DEBRIS": "scattered remains [n DEBRIS]\n",
  "DEBRUISE": "in heraldry, to cross and partially hide (a charge, esp. an animal) with an ordinary which extends over the field [v DEBRUISED, DEBRUISING, DEBRUISES]\n",
  "DEBRUISED": "DEBRUISE, in heraldry, to cross and partially hide (a charge, esp. an animal) with an ordinary which extends over the field [v]\n",
  "DEBRUISES": "DEBRUISE, in heraldry, to cross and partially hide (a charge, esp. an animal) with an ordinary which extends over the field [v]\n",
  "DEBRUISING": "DEBRUISE, in heraldry, to cross and partially hide (a charge, esp. an animal) with an ordinary which extends over the field [v]\n",
  "DEBS": "DEB, (short for) debutante [n]\n",
  "DEBT": "something that is owed [n -S]\n",
  "DEBTED": "(Shakespeare) indebted [adj]\n",
  "DEBTEE": "one to whom a debt is due [n -S]\n",
  "DEBTEES": "DEBTEE, one to whom a debt is due [n]\n",
  "DEBTLESS": "without debts [adj]\n",
  "DEBTOR": "someone who owes a debt, also DEBITOR [n -S]\n",
  "DEBTORS": "DEBTOR, someone who owes a debt, also DEBITOR [n]\n",
  "DEBTS": "DEBT, something that is owed [n]\n",
  "DEBUD": "to remove the buds from, also DISBUD [v DEBUDDED, DEBUDDING, DEBUDS]\n",
  "DEBUDDED": "DEBUD, to remove the buds from, also DISBUD [v]\n",
  "DEBUDDING": "DEBUD, to remove the buds from, also DISBUD [v]\n",
  "DEBUDS": "DEBUD, to remove the buds from, also DISBUD [v]\n",
  "DEBUG": "to remove the errors from a computer program [v DEBUGGED, DEBUGGING, DEBUGS]\n",
  "DEBUGGED": "DEBUG, to remove the errors from a computer program [v]\n",
  "DEBUGGER": "a computer program designed to find and remove faults or errors [n -S]\n",
  "DEBUGGERS": "DEBUGGER, a computer program designed to find and remove faults or errors [n]\n",
  "DEBUGGING": "the act of removing errors from a computer program [n -S]\n",
  "DEBUGGINGS": "DEBUGGING, the act of removing errors from a computer program [n]\n",
  "DEBUGS": "DEBUG, to remove the errors from a computer program [v]\n",
  "DEBUNK": "to clear of humbug [v -ED, -ING, -S]\n",
  "DEBUNKED": "DEBUNK, to clear of humbug [v]\n",
  "DEBUNKER": "one who debunks [n -S]\n",
  "DEBUNKERS": "DEBUNKER, one who debunks [n]\n",
  "DEBUNKING": "DEBUNK, to clear of humbug [v]\n",
  "DEBUNKS": "DEBUNK, to clear of humbug [v]\n",
  "DEBUR": "to remove rough edges from (a metal object, piece of wood, etc.), also DEBURR [v DEBURRED, DEBURRING, DEBURS]\n",
  "DEBURR": "to remove burrs from [v -ED, -ING, -S]\n",
  "DEBURRED": "DEBURR, to remove burrs from [v]\n",
  "DEBURRING": "DEBURR, to remove burrs from [v]\n",
  "DEBURRS": "DEBURR, to remove burrs from [v]\n",
  "DEBURS": "DEBUR, to remove rough edges from (a metal object, piece of wood, etc.), also DEBURR [v]\n",
  "DEBUS": "to get off a bus [v DEBUSSED or DEBUSED, DEBUSSING or DEBUSING, DEBUSSES or DEBUSES]\n",
  "DEBUSED": "DEBUS, to get off a bus [v]\n",
  "DEBUSES": "DEBUS, to get off a bus [v]\n",
  "DEBUSING": "DEBUS, to get off a bus [v]\n",
  "DEBUSSED": "DEBUS, to get off a bus [v]\n",
  "DEBUSSES": "DEBUS, to get off a bus [v]\n",
  "DEBUSSING": "DEBUS, to get off a bus [v]\n",
  "DEBUT": "(French) to make a first public appearance in society [v -ED, -ING, -S]\n",
  "DEBUTANT": "(French) someone (male) making a beginning [n -S]\n",
  "DEBUTANTE": "(French) someone (female) making a beginning, esp. in society [n -S]\n",
  "DEBUTANTES": "DEBUTANTE, (French) someone (female) making a beginning, esp. in society [n]\n",
  "DEBUTANTS": "DEBUTANT, (French) someone (male) making a beginning [n]\n",
  "DEBUTED": "DEBUT, (French) to make a first public appearance in society [v]\n",
  "DEBUTING": "DEBUT, (French) to make a first public appearance in society [v]\n",
  "DEBUTS": "DEBUT, (French) to make a first public appearance in society [v]\n",
  "DEBYE": "a unit of measure for electric dipole moments [n -S]\n",
  "DEBYES": "DEBYE, a unit of measure for electric dipole moments [n]\n",
  "DECACHORD": "an old ten-stringed musical instrument [n -S]\n",
  "DECACHORDS": "DECACHORD, an old ten-stringed musical instrument [n]\n",
  "DECAD": "(obsolete) a period of ten years, also DECADE [n -S]\n",
  "DECADAL": "pertaining to ten; consisting of tens [adj]\n",
  "DECADE": "a period of ten years, also DECAD [n -S]\n",
  "DECADENCE": "a falling away; decay, also DECADENCY [n -S]\n",
  "DECADENCES": "DECADENCE, a falling away; decay, also DECADENCY [n]\n",
  "DECADENCIES": "DECADENCY, a falling away; decay, also DECADENCE [n]\n",
  "DECADENCY": "a falling away; decay, also DECADENCE [n DECADENCIES]\n",
  "DECADENT": "decaying [adj DECADENTLY] / one who is decadent [n -S]\n",
  "DECADENTLY": "DECADENT, decaying [adv]\n",
  "DECADENTS": "DECADENT, one who is decadent [n]\n",
  "DECADES": "DECADE, a period of ten years, also DECAD [n]\n",
  "DECADS": "DECAD, (obsolete) a period of ten years, also DECADE [n]\n",
  "DECAF": "(short for) decaffeinated coffee, also DECAFF [n -S]\n",
  "DECAFF": "(short for) decaffeinated coffee, also DECAF [n -S]\n",
  "DECAFFEINATE": "to remove caffeine from [v DECAFFEINATED, DECAFFEINATING, DECAFFEINATES]\n",
  "DECAFFEINATED": "DECAFFEINATE, to remove caffeine from [v]\n",
  "DECAFFEINATES": "DECAFFEINATE, to remove caffeine from [v]\n",
  "DECAFFEINATING": "DECAFFEINATE, to remove caffeine from [v]\n",
  "DECAFFS": "DECAFF, (short for) decaffeinated coffee, also DECAF [n]\n",
  "DECAFS": "DECAF, (short for) decaffeinated coffee, also DECAFF [n]\n",
  "DECAGON": "a plane figure with ten equal sides [n -S]\n",
  "DECAGONAL": "of a plane figure, having ten sides [adj DECAGONALLY]\n",
  "DECAGONALLY": "DECAGONAL, of a plane figure, having ten sides [adv]\n",
  "DECAGONS": "DECAGON, a plane figure with ten equal sides [n]\n",
  "DECAGRAM": "a measure equal to ten grams, also DEKAGRAM [n -S]\n",
  "DECAGRAMME": "a weight of the metric system; ten grams, also DECAGRAM, DEKAGRAM [n -S]\n",
  "DECAGRAMMES": "DECAGRAMME, a weight of the metric system; ten grams, also DECAGRAM, DEKAGRAM [n]\n",
  "DECAGRAMS": "DECAGRAM, a measure equal to ten grams, also DEKAGRAM [n]\n",
  "DECAGYNIAN": "having ten pistils, also DECAGYNOUS [adj]\n",
  "DECAGYNOUS": "having ten pistils, also DECAGYNIAN [adj]\n",
  "DECAHEDRA": "DECAHEDRON, a solid figure or body inclosed by ten plane surfaces [n]\n",
  "DECAHEDRAL": "having ten sides [adj]\n",
  "DECAHEDRON": "a solid figure or body inclosed by ten plane surfaces [n DECAHEDRA or DECAHEDRONS]\n",
  "DECAHEDRONS": "DECAHEDRON, a solid figure or body inclosed by ten plane surfaces [n]\n",
  "DECAHYDRATE": "a compound containing ten molecules of water of crystallization [n -S]\n",
  "DECAHYDRATES": "DECAHYDRATE, a compound containing ten molecules of water of crystallization [n]\n",
  "DECAL": "a design made to be transferred [n -S] / to transfer by decal [v DECALLED or DECALED, DECALLING or DECALING, DECALS]\n",
  "DECALCIFICATION": "the removal or loss of calcium or calcium compounds (as from bones or soil) [n]\n",
  "DECALCIFIED": "DECALCIFY, to deprive of calcium [v]\n",
  "DECALCIFIER": "an agent that decalcifies [n -S]\n",
  "DECALCIFIERS": "DECALCIFIER, an agent that decalcifies [n]\n",
  "DECALCIFIES": "DECALCIFY, to deprive of calcium [v]\n",
  "DECALCIFY": "to deprive of calcium [v DECALCIFIED, DECALCIFYING, DECALCIFIES]\n",
  "DECALCIFYING": "DECALCIFY, to deprive of calcium [v]\n",
  "DECALCOMANIA": "the art of transferring a design from paper to another surface [n -S]\n",
  "DECALCOMANIAS": "DECALCOMANIA, the art of transferring a design from paper to another surface [n]\n",
  "DECALED": "DECAL, to transfer by decal [v]\n",
  "DECALESCENCE": "the point in heating metal where it appears to cool [n -S]\n",
  "DECALESCENCES": "DECALESCENCE, the point in heating metal where it appears to cool [n]\n",
  "DECALESCENT": "relating to decalescence [adj]\n",
  "DECALING": "DECAL, to transfer by decal [v]\n",
  "DECALITER": "a cubic volume of ten liters, also DECALITRE, DEKALITER, DEKALITRE [n -S]\n",
  "DECALITERS": "DECALITER, a cubic volume of ten liters, also DECALITRE, DEKALITER, DEKALITRE [n]\n",
  "DECALITRE": "a cubic volume of ten liters, also DECALITER, DEKALITER, DEKALITRE [n -S]\n",
  "DECALITRES": "DECALITRE, a cubic volume of ten liters, also DECALITER, DEKALITER, DEKALITRE [n]\n",
  "DECALLED": "DECAL, to transfer by decal [v]\n",
  "DECALLING": "DECAL, to transfer by decal [v]\n",
  "DECALOG": "the Ten Commandments, also DECALOGUE [n -S]\n",
  "DECALOGIST": "an exponent of the Decalogue (the Ten Commandments) [n -S]\n",
  "DECALOGISTS": "DECALOGIST, an exponent of the Decalogue (the Ten Commandments) [n]\n",
  "DECALOGS": "DECALOG, the Ten Commandments, also DECALOGUE [n]\n",
  "DECALOGUE": "the Ten Commandments, also DECALOG [n -S]\n",
  "DECALOGUES": "DECALOGUE, the Ten Commandments, also DECALOG [n]\n",
  "DECALS": "DECAL, a design made to be transferred [n]\n",
  "DECAMERONIC": "of or like the Decameron [adj]\n",
  "DECAMEROUS": "having parts in tens [adj]\n",
  "DECAMETER": "ten meters, also DECAMETRE, DEKAMETER, DEKAMETRE [n -S]\n",
  "DECAMETERS": "DECAMETER, ten meters, also DECAMETRE, DEKAMETER, DEKAMETRE [n]\n",
  "DECAMETHONIUM": "a type of muscle relaxant [n -S]\n",
  "DECAMETHONIUMS": "DECAMETHONIUM, a type of muscle relaxant [n]\n",
  "DECAMETRE": "ten meters, also DECAMETER, DEKAMETER, DEKAMETRE [n -S]\n",
  "DECAMETRES": "DECAMETRE, ten meters, also DECAMETER, DEKAMETER, DEKAMETRE [n]\n",
  "DECAMETRIC": "of or like a decametre, also DEKAMETRIC [adj]\n",
  "DECAMP": "to depart from a camping ground [v -ED, -ING, -S]\n",
  "DECAMPED": "DECAMP, to depart from a camping ground [v]\n",
  "DECAMPING": "DECAMP, to depart from a camping ground [v]\n",
  "DECAMPMENT": "departure from a camp; a marching off [n -S]\n",
  "DECAMPMENTS": "DECAMPMENT, departure from a camp; a marching off [n]\n",
  "DECAMPS": "DECAMP, to depart from a camping ground [v]\n",
  "DECAN": "one of three equal 10-degree divisions of a sign of the zodiac [n -S]\n",
  "DECANAL": "relating to a dean [adj DECANALLY or DECANICALLY]\n",
  "DECANALLY": "DECANAL, relating to a dean [adv]\n",
  "DECANDRIAN": "belonging to the Decandria; having ten stamens, also DECANDROUS [adj]\n",
  "DECANDROUS": "belonging to the Decandria; having ten stamens, also DECANDRIAN [adj]\n",
  "DECANE": "a hydrocarbon of the alkane series [n -S]\n",
  "DECANEDIOIC": "designating a type of acid [adj]\n",
  "DECANES": "DECANE, a hydrocarbon of the alkane series [n]\n",
  "DECANI": "(Latin) the dean's (south) side of a choir, as opposed to cantoris [adj]\n",
  "DECANICALLY": "DECANAL, relating to a dean [adv]\n",
  "DECANOIC": "as in decanoic acid, used in perfumes [adj]\n",
  "DECANS": "DECAN, one of three equal 10-degree divisions of a sign of the zodiac [n]\n",
  "DECANT": "to pour from one container to another [v -ED, -ING, -S]\n",
  "DECANTATE": "(obsolete) to chant or say repeatedly [v DECANTATED, DECANTATING, DECANTATES]\n",
  "DECANTATED": "DECANTATE, (obsolete) to chant or say repeatedly [v]\n",
  "DECANTATES": "DECANTATE, (obsolete) to chant or say repeatedly [v]\n",
  "DECANTATING": "DECANTATE, (obsolete) to chant or say repeatedly [v]\n",
  "DECANTATION": "the act of decanting [n -S]\n",
  "DECANTATIONS": "DECANTATION, the act of decanting [n]\n",
  "DECANTED": "DECANT, to pour from one container to another [v]\n",
  "DECANTER": "a decorative bottle [n -S]\n",
  "DECANTERS": "DECANTER, a decorative bottle [n]\n",
  "DECANTING": "DECANT, to pour from one container to another [v]\n",
  "DECANTS": "DECANT, to pour from one container to another [v]\n",
  "DECAPITALISE": "to remove capital from, also DECAPITALIZE [v DECAPITALISED, DECAPITALISING, DECAPITALISES]\n",
  "DECAPITALISED": "DECAPITALISE, to remove capital from, also DECAPITALIZE [v]\n",
  "DECAPITALISES": "DECAPITALISE, to remove capital from, also DECAPITALIZE [v]\n",
  "DECAPITALISING": "DECAPITALISE, to remove capital from, also DECAPITALIZE [v]\n",
  "DECAPITALIZE": "to remove capital from, also DECAPITALISE [v DECAPITALIZED, DECAPITALIZING, DECAPITALIZES]\n",
  "DECAPITALIZED": "DECAPITALIZE, to remove capital from, also DECAPITALISE [v]\n",
  "DECAPITALIZES": "DECAPITALIZE, to remove capital from, also DECAPITALISE [v]\n",
  "DECAPITALIZING": "DECAPITALIZE, to remove capital from, also DECAPITALISE [v]\n",
  "DECAPITATE": "to cut off the head of [v DECAPITATED, DECAPITATING, DECAPITATES]\n",
  "DECAPITATED": "DECAPITATE, to cut off the head of [v]\n",
  "DECAPITATES": "DECAPITATE, to cut off the head of [v]\n",
  "DECAPITATING": "DECAPITATE, to cut off the head of [v]\n",
  "DECAPITATION": "the act of decapitating [n -S]\n",
  "DECAPITATIONS": "DECAPITATION, the act of decapitating [n]\n",
  "DECAPITATOR": "one who decapitates [n -S]\n",
  "DECAPITATORS": "DECAPITATOR, one who decapitates [n]\n",
  "DECAPOD": "any ten-legged crustacean, including shrimps and lobsters [n -S]\n",
  "DECAPODAL": "relating to decapods, an order of crustaceans with ten feet, that includes crabs and lobsters, also DECAPODAN, DECAPODOUS [adj]\n",
  "DECAPODAN": "relating to decapods, an order of crustaceans with ten feet, that includes crabs and lobsters, also DECAPODAL, DECAPODOUS [adj] / a decapod [n -S]\n",
  "DECAPODANS": "DECAPODAN, a decapod [n]\n",
  "DECAPODOUS": "relating to the Decapoda, an order of crustaceans with ten feet, also DECAPODAL, DECAPODAN [adj]\n",
  "DECAPODS": "DECAPOD, any ten-legged crustacean, including shrimps and lobsters [n]\n",
  "DECAPSULATE": "to remove a capsule from (a part or organ, esp. the kidney) [v DECAPSULATED, DECAPSULATING, DECAPSULATES]\n",
  "DECAPSULATED": "DECAPSULATE, to remove a capsule from (a part or organ, esp. the kidney) [v]\n",
  "DECAPSULATES": "DECAPSULATE, to remove a capsule from (a part or organ, esp. the kidney) [v]\n",
  "DECAPSULATING": "DECAPSULATE, to remove a capsule from (a part or organ, esp. the kidney) [v]\n",
  "DECAPSULATION": "the removal of the enveloping membrane of an organ [n -S]\n",
  "DECAPSULATIONS": "DECAPSULATION, the removal of the enveloping membrane of an organ [n]\n",
  "DECARB": "to decarbonise [v -ED, -ING, -S]\n",
  "DECARBED": "DECARB, to decarbonise [v]\n",
  "DECARBING": "DECARB, to decarbonise [v]\n",
  "DECARBONATE": "to remove carbon dioxide or carbonic acid from [v DECARBONATED, DECARBONATING, DECARBONATES]\n",
  "DECARBONATED": "DECARBONATE, to remove carbon dioxide or carbonic acid from [v]\n",
  "DECARBONATES": "DECARBONATE, to remove carbon dioxide or carbonic acid from [v]\n",
  "DECARBONATING": "DECARBONATE, to remove carbon dioxide or carbonic acid from [v]\n",
  "DECARBONATION": "the act of decarbonating [n -S]\n",
  "DECARBONATIONS": "DECARBONATION, the act of decarbonating [n]\n",
  "DECARBONATOR": "an apparatus or removing carbon dioxide [n -S]\n",
  "DECARBONATORS": "DECARBONATOR, an apparatus or removing carbon dioxide [n]\n",
  "DECARBONISATION": "the process of decarbonising, also DECARBONIZATION [n]\n",
  "DECARBONISE": "to remove carbon or carbon dioxide from, also DECARBONIZE [v DECARBONISED, DECARBONISING, DECARBONISES]\n",
  "DECARBONISED": "DECARBONISE, to remove carbon or carbon dioxide from, also DECARBONIZE [v]\n",
  "DECARBONISER": "an apparatus or removing carbon, also DECARBONIZER [n -S]\n",
  "DECARBONISERS": "DECARBONISER, an apparatus or removing carbon, also DECARBONIZER [n]\n",
  "DECARBONISES": "DECARBONISE, to remove carbon or carbon dioxide from, also DECARBONIZE [v]\n",
  "DECARBONISING": "DECARBONISE, to remove carbon or carbon dioxide from, also DECARBONIZE [v]\n",
  "DECARBONIZATION": "the process of decarbonizing, also DECARBONISATION [n]\n",
  "DECARBONIZE": "to remove carbon from, also DECARBONISE [v DECARBONIZED, DECARBONIZING, DECARBONIZES]\n",
  "DECARBONIZED": "DECARBONIZE, to remove carbon from, also DECARBONISE [v]\n",
  "DECARBONIZER": "something that decarbonizes, also DECARBONISER [n -S]\n",
  "DECARBONIZERS": "DECARBONIZER, something that decarbonizes, also DECARBONISER [n]\n",
  "DECARBONIZES": "DECARBONIZE, to remove carbon from, also DECARBONISE [v]\n",
  "DECARBONIZING": "DECARBONIZE, to remove carbon from, also DECARBONISE [v]\n",
  "DECARBOXYLASE": "any of a group of enzymes that accelerate decarboxylation esp. of amino acids [n -S]\n",
  "DECARBOXYLASES": "DECARBOXYLASE, any of a group of enzymes that accelerate decarboxylation esp. of amino acids [n]\n",
  "DECARBOXYLATE": "to remove carbon dioxide from its substrate [v DECARBOXYLATED, DECARBOXYLATING, DECARBOXYLATES]\n",
  "DECARBOXYLATED": "DECARBOXYLATE, to remove carbon dioxide from its substrate [v]\n",
  "DECARBOXYLATES": "DECARBOXYLATE, to remove carbon dioxide from its substrate [v]\n",
  "DECARBOXYLATING": "DECARBOXYLATE, to remove carbon dioxide from its substrate [v]\n",
  "DECARBOXYLATION": "the removal or elimination of carboxyl from a molecule [n]\n",
  "DECARBS": "DECARB, to decarbonise [v]\n",
  "DECARBURATION": "the act of decarburizing [n -S]\n",
  "DECARBURATIONS": "DECARBURATION, the act of decarburizing [n]\n",
  "DECARBURISATION": "the process of decarburising, also DECARBURIZATION [n]\n",
  "DECARBURISE": "to remove carbon or carbon dioxide from, also DECARBURIZE [v DECARBURISED, DECARBURISING, DECARBURISES]\n",
  "DECARBURISED": "DECARBURISE, to remove carbon or carbon dioxide from, also DECARBURIZE [v]\n",
  "DECARBURISES": "DECARBURISE, to remove carbon or carbon dioxide from, also DECARBURIZE [v]\n",
  "DECARBURISING": "DECARBURISE, to remove carbon or carbon dioxide from, also DECARBURIZE [v]\n",
  "DECARBURIZATION": "the act of decarburizing, also DECARBURISATION [n]\n",
  "DECARBURIZE": "to remove carbon or carbon dioxide from, also DECARBURISE [v DECARBURIZED, DECARBURIZING, DECARBURIZES]\n",
  "DECARBURIZED": "DECARBURIZE, to remove carbon or carbon dioxide from, also DECARBURISE [v]\n",
  "DECARBURIZES": "DECARBURIZE, to remove carbon or carbon dioxide from, also DECARBURISE [v]\n",
  "DECARBURIZING": "DECARBURIZE, to remove carbon or carbon dioxide from, also DECARBURISE [v]\n",
  "DECARE": "a measure equal to ten ares, also DEKARE [n -S]\n",
  "DECARES": "DECARE, a measure equal to ten ares, also DEKARE [n]\n",
  "DECARTELISE": "to break up (a cartel), also DECARTELIZE [v DECARTELISED, DECARTELISING, DECARTELISES]\n",
  "DECARTELISED": "DECARTELISE, to break up (a cartel), also DECARTELIZE [v]\n",
  "DECARTELISES": "DECARTELISE, to break up (a cartel), also DECARTELIZE [v]\n",
  "DECARTELISING": "DECARTELISE, to break up (a cartel), also DECARTELIZE [v]\n",
  "DECARTELIZE": "to break up (a cartel), also DECARTELISE [v DECARTELIZED, DECARTELIZING, DECARTELIZES]\n",
  "DECARTELIZED": "DECARTELIZE, to break up (a cartel), also DECARTELISE [v]\n",
  "DECARTELIZES": "DECARTELIZE, to break up (a cartel), also DECARTELISE [v]\n",
  "DECARTELIZING": "DECARTELIZE, to break up (a cartel), also DECARTELISE [v]\n",
  "DECASTERE": "a measure of capacity, equal to ten steres, or ten cubic meters [n -S]\n",
  "DECASTERES": "DECASTERE, a measure of capacity, equal to ten steres, or ten cubic meters [n]\n",
  "DECASTICH": "a ten-line poem [n -S]\n",
  "DECASTICHS": "DECASTICH, a ten-line poem [n]\n",
  "DECASTYLE": "a portico with ten columns in front [n -S]\n",
  "DECASTYLES": "DECASTYLE, a portico with ten columns in front [n]\n",
  "DECASUALISATION": "the process of making employment not casual, also DECASUALIZATION [n]\n",
  "DECASUALISE": "(US) to replace the casual workers in (a business) with permanent employees, also DECASUALIZE [v DECASUALISED, DECASUALISING, DECASUALISES]\n",
  "DECASUALISED": "DECASUALISE, (US) to replace the casual workers in (a business) with permanent employees, also DECASUALIZE [v]\n",
  "DECASUALISES": "DECASUALISE, (US) to replace the casual workers in (a business) with permanent employees, also DECASUALIZE [v]\n",
  "DECASUALISING": "DECASUALISE, (US) to replace the casual workers in (a business) with permanent employees, also DECASUALIZE [v]\n",
  "DECASUALIZATION": "the process of eliminating the employment of casual workers in order to stabilize the workforce, also DECASUALISATION [n]\n",
  "DECASUALIZE": "(US) to replace the casual workers in (a business) with permanent employees, also DECASUALISE [v DECASUALIZED, DECASUALIZING, DECASUALIZES]\n",
  "DECASUALIZED": "DECASUALIZE, (US) to replace the casual workers in (a business) with permanent employees, also DECASUALISE [v]\n",
  "DECASUALIZES": "DECASUALIZE, (US) to replace the casual workers in (a business) with permanent employees, also DECASUALISE [v]\n",
  "DECASUALIZING": "DECASUALIZE, (US) to replace the casual workers in (a business) with permanent employees, also DECASUALISE [v]\n",
  "DECASYLLABIC": "consisting of 10 syllables or composed of verses of 10 syllables [adj] / a decasyllabic verse [n -S]\n",
  "DECASYLLABICS": "DECASYLLABIC, a decasyllabic verse [n]\n",
  "DECASYLLABLE": "a line with ten syllables [n -S]\n",
  "DECASYLLABLES": "DECASYLLABLE, a line with ten syllables [n]\n",
  "DECATHLETE": "an athlete who competes in the decathlon [n -S]\n",
  "DECATHLETES": "DECATHLETE, an athlete who competes in the decathlon [n]\n",
  "DECATHLON": "an athletic contest comprising ten events [n -S]\n",
  "DECATHLONS": "DECATHLON, an athletic contest comprising ten events [n]\n",
  "DECAUDATE": "to cut off the tail of [v DECAUDATED, DECAUDATING, DECAUDATES]\n",
  "DECAUDATED": "DECAUDATE, to cut off the tail of [v]\n",
  "DECAUDATES": "DECAUDATE, to cut off the tail of [v]\n",
  "DECAUDATING": "DECAUDATE, to cut off the tail of [v]\n",
  "DECAY": "to decompose [v -ED, -ING, -S]\n",
  "DECAYABLE": "capable of decaying [adj]\n",
  "DECAYED": "DECAY, to decompose [v]\n",
  "DECAYER": "an agent that causes decay [n -S]\n",
  "DECAYERS": "DECAYER, an agent that causes decay [n]\n",
  "DECAYING": "DECAY, to decompose [v]\n",
  "DECAYLESS": "without decay [adj]\n",
  "DECAYS": "DECAY, to decompose [v]\n",
  "DECCIE": "(slang) interior decoration [n -S]\n",
  "DECCIES": "DECCIE, (slang) interior decoration [n]\n",
  "DECEASE": "to die [v DECEASED, DECEASING, DECEASES]\n",
  "DECEASED": "a dead person [n -S]\n",
  "DECEASEDS": "DECEASED, a dead person [n]\n",
  "DECEASES": "DECEASE, to die [v]\n",
  "DECEASING": "DECEASE, to die [v]\n",
  "DECEDENT": "(US) in US law, a deceased person [n -S]\n",
  "DECEDENTS": "DECEDENT, (US) in US law, a deceased person [n]\n",
  "DECEIT": "falseness [n -S]\n",
  "DECEITFUL": "given to deceiving [adj DECEITFULLY]\n",
  "DECEITFULLY": "DECEITFUL, given to deceiving [adv]\n",
  "DECEITFULNESS": "the state of being deceitful [n -ES]\n",
  "DECEITFULNESSES": "DECEITFULNESS, the state of being deceitful [n]\n",
  "DECEITS": "DECEIT, falseness [n]\n",
  "DECEIVABILITIES": "DECEIVABILITY, the quality of being deceivable [n]\n",
  "DECEIVABILITY": "the quality of being deceivable [n DECEIVABILITIES]\n",
  "DECEIVABLE": "fitted to deceive; deceitful [adj DECEIVABLY]\n",
  "DECEIVABLENESS": "the state of being deceivable [n]\n",
  "DECEIVABLY": "DECEIVABLE, fitted to deceive; deceitful [adv]\n",
  "DECEIVE": "to mislead by falsehood [v DECEIVED, DECEIVING, DECEIVES]\n",
  "DECEIVED": "DECEIVE, to mislead by falsehood [v]\n",
  "DECEIVER": "one who deceives [n -S]\n",
  "DECEIVERS": "DECEIVER, one who deceives [n]\n",
  "DECEIVES": "DECEIVE, to mislead by falsehood [v]\n",
  "DECEIVING": "deceptive [adj DECEIVINGLY] / the act of deceiving [n -S]\n",
  "DECEIVINGLY": "DECEIVING, deceptive [adv]\n",
  "DECEIVINGS": "DECEIVING, the act of deceiving [n]\n",
  "DECELERATE": "to reduce the speed of [v DECELERATED, DECELERATING, DECELERATES]\n",
  "DECELERATED": "DECELERATE, to reduce the speed of [v]\n",
  "DECELERATES": "DECELERATE, to reduce the speed of [v]\n",
  "DECELERATING": "DECELERATE, to reduce the speed of [v]\n",
  "DECELERATION": "the act of decelerating [n -S]\n",
  "DECELERATIONS": "DECELERATION, the act of decelerating [n]\n",
  "DECELERATOR": "something that decelerates [n -S]\n",
  "DECELERATORS": "DECELERATOR, something that decelerates [n]\n",
  "DECELEROMETER": "an instrument for measuring deceleration [n -S]\n",
  "DECELEROMETERS": "DECELEROMETER, an instrument for measuring deceleration [n]\n",
  "DECELERON": "a type of aileron [n -S]\n",
  "DECELERONS": "DECELERON, a type of aileron [n]\n",
  "DECEMVIR": "(Latin) one of a body of ten magistrates in ancient Rome [n DECEMVIRS or DECEMVIRI]\n",
  "DECEMVIRAL": "pertaining to the decemvirs in Rome [adj]\n",
  "DECEMVIRATE": "the office of decemvir [n -S]\n",
  "DECEMVIRATES": "DECEMVIRATE, the office of decemvir [n]\n",
  "DECEMVIRI": "DECEMVIR, (Latin) one of a body of ten magistrates in ancient Rome [n]\n",
  "DECEMVIRS": "DECEMVIR, (Latin) one of a body of ten magistrates in ancient Rome [n]\n",
  "DECENARIES": "DECENARY, a tithing, also DECENNARY [n]\n",
  "DECENARY": "a tithing, also DECENNARY [n DECENARIES]\n",
  "DECENCIES": "DECENCY, the state of being decent [n]\n",
  "DECENCY": "the state of being decent [n DECENCIES]\n",
  "DECENNARIES": "DECENNARY, a tithing, also DECENARY [n]\n",
  "DECENNARY": "a tithing, also DECENARY [n DECENNARIES]\n",
  "DECENNIA": "DECENNIUM, (Latin) a period of ten years [n]\n",
  "DECENNIAL": "happening every ten years [adj DECENNIALLY] / a ten-year anniversary [n -S]\n",
  "DECENNIALLY": "DECENNIAL, happening every ten years [adv]\n",
  "DECENNIALS": "DECENNIAL, a ten-year anniversary [n]\n",
  "DECENNIUM": "(Latin) a period of ten years [n DECENNIA or DECENNIUMS]\n",
  "DECENNIUMS": "DECENNIUM, (Latin) a period of ten years [n]\n",
  "DECENNOVAL": "(obsolete) relating to the number nineteen [adj]\n",
  "DECENT": "conforming to standards of propriety [adj DECENTER, DECENTEST, DECENTLY]\n",
  "DECENTER": "to put out of center, also DECENTRE [v -ED, -ING, -S]\n",
  "DECENTERED": "DECENTER, to put out of center, also DECENTRE [v]\n",
  "DECENTERING": "the act of putting out of centre [n -S]\n",
  "DECENTERINGS": "DECENTERING, the act of putting out of centre [n]\n",
  "DECENTERS": "DECENTER, to put out of center, also DECENTRE [v]\n",
  "DECENTEST": "DECENT, conforming to standards of propriety [adj]\n",
  "DECENTLY": "DECENT, conforming to standards of propriety [adv]\n",
  "DECENTNESS": "the state of being decent [n -ES]\n",
  "DECENTNESSES": "DECENTNESS, the state of being decent [n]\n",
  "DECENTRALISE": "to withdraw from the centre, also DECENTRALIZE [v DECENTRALISED, DECENTRALISING, DECENTRALISES]\n",
  "DECENTRALISED": "DECENTRALISE, to withdraw from the centre, also DECENTRALIZE [v]\n",
  "DECENTRALISES": "DECENTRALISE, to withdraw from the centre, also DECENTRALIZE [v]\n",
  "DECENTRALISING": "DECENTRALISE, to withdraw from the centre, also DECENTRALIZE [v]\n",
  "DECENTRALIST": "one who believes in decentralisation of government [n -S]\n",
  "DECENTRALISTS": "DECENTRALIST, one who believes in decentralisation of government [n]\n",
  "DECENTRALIZE": "to withdraw from the centre, also DECENTRALISE [v DECENTRALIZED, DECENTRALIZING, DECENTRALIZES]\n",
  "DECENTRALIZED": "DECENTRALIZE, to withdraw from the centre, also DECENTRALISE [v]\n",
  "DECENTRALIZES": "DECENTRALIZE, to withdraw from the centre, also DECENTRALISE [v]\n",
  "DECENTRALIZING": "DECENTRALIZE, to withdraw from the centre, also DECENTRALISE [v]\n",
  "DECENTRE": "to put out of center, also DECENTER [v DECENTRED, DECENTRING, DECENTRES]\n",
  "DECENTRED": "DECENTRE, to put out of center, also DECENTER [v]\n",
  "DECENTRES": "DECENTRE, to put out of center, also DECENTER [v]\n",
  "DECENTRING": "DECENTRE, to put out of center, also DECENTER [v]\n",
  "DECEPTIBILITIES": "DECEPTIBILITY, the quality of being deceptible [n]\n",
  "DECEPTIBILITY": "the quality of being deceptible [n DECEPTIBILITIES]\n",
  "DECEPTIBLE": "capable of being deceived; deceivable [adj]\n",
  "DECEPTION": "the act of deceiving [n -S]\n",
  "DECEPTIONAL": "of the nature of deception [adj]\n",
  "DECEPTIONS": "DECEPTION, the act of deceiving [n]\n",
  "DECEPTIOUS": "(Shakespeare) deceitful [adj]\n",
  "DECEPTIVE": "tending to deceive, also DECEPTORY [adj DECEPTIVELY]\n",
  "DECEPTIVELY": "DECEPTIVE, tending to deceive, also DECEPTORY [adv]\n",
  "DECEPTIVENESS": "the state of being deceptive [n -ES]\n",
  "DECEPTIVENESSES": "DECEPTIVENESS, the state of being deceptive [n]\n",
  "DECEPTORY": "tending to deceive, also DECEPTIVE [adj]\n",
  "DECEREBRATE": "to eliminate cerebral brain function in (an animal) by removing the cerebrum, as for purposes of experimentation [v DECEREBRATED, DECEREBRATING, DECEREBRATES]\n",
  "DECEREBRATED": "DECEREBRATE, to eliminate cerebral brain function in (an animal) by removing the cerebrum, as for purposes of experimentation [v]\n",
  "DECEREBRATES": "DECEREBRATE, to eliminate cerebral brain function in (an animal) by removing the cerebrum, as for purposes of experimentation [v]\n",
  "DECEREBRATING": "DECEREBRATE, to eliminate cerebral brain function in (an animal) by removing the cerebrum, as for purposes of experimentation [v]\n",
  "DECEREBRATION": "the act of decerebrating [n -S]\n",
  "DECEREBRATIONS": "DECEREBRATION, the act of decerebrating [n]\n",
  "DECEREBRISE": "to deprive of the cerebrum, also DECEREBRIZE [v DECEREBRISED, DECEREBRISING, DECEREBRISES]\n",
  "DECEREBRISED": "DECEREBRISE, to deprive of the cerebrum, also DECEREBRIZE [v]\n",
  "DECEREBRISES": "DECEREBRISE, to deprive of the cerebrum, also DECEREBRIZE [v]\n",
  "DECEREBRISING": "DECEREBRISE, to deprive of the cerebrum, also DECEREBRIZE [v]\n",
  "DECEREBRIZE": "to deprive of the cerebrum, also DECEREBRISE [v DECEREBRIZED, DECEREBRIZING, DECEREBRIZES]\n",
  "DECEREBRIZED": "DECEREBRIZE, to deprive of the cerebrum, also DECEREBRISE [v]\n",
  "DECEREBRIZES": "DECEREBRIZE, to deprive of the cerebrum, also DECEREBRISE [v]\n",
  "DECEREBRIZING": "DECEREBRIZE, to deprive of the cerebrum, also DECEREBRISE [v]\n",
  "DECERN": "to decree by judicial sentence [v -ED, -ING, -S]\n",
  "DECERNED": "DECERN, to decree by judicial sentence [v]\n",
  "DECERNING": "DECERN, to decree by judicial sentence [v]\n",
  "DECERNS": "DECERN, to decree by judicial sentence [v]\n",
  "DECERTIFICATION": "the act of decertifying [n]\n",
  "DECERTIFIED": "DECERTIFY, to withdraw or revoke the certification of [v]\n",
  "DECERTIFIES": "DECERTIFY, to withdraw or revoke the certification of [v]\n",
  "DECERTIFY": "to withdraw or revoke the certification of [v DECERTIFIED, DECERTIFYING, DECERTIFIES]\n",
  "DECERTIFYING": "DECERTIFY, to withdraw or revoke the certification of [v]\n",
  "DECESSION": "departure [n -S]\n",
  "DECESSIONS": "DECESSION, departure [n]\n",
  "DECHEANCE": "(French) forfeiture [n -S]\n",
  "DECHEANCES": "DECHEANCE, (French) forfeiture [n]\n",
  "DECHLORINATE": "to remove chlorine from [v DECHLORINATED, DECHLORINATING, DECHLORINATES]\n",
  "DECHLORINATED": "DECHLORINATE, to remove chlorine from [v]\n",
  "DECHLORINATES": "DECHLORINATE, to remove chlorine from [v]\n",
  "DECHLORINATING": "DECHLORINATE, to remove chlorine from [v]\n",
  "DECHLORINATION": "the act of dechlorinating [n -S]\n",
  "DECHLORINATIONS": "DECHLORINATION, the act of dechlorinating [n]\n",
  "DECHRISTIANISE": "to turn from Christianity, also DECHRISTIANIZE [v DECHRISTIANISED, DECHRISTIANISES]\n",
  "DECHRISTIANISED": "DECHRISTIANISE, to turn from Christianity, also DECHRISTIANIZE [v]\n",
  "DECHRISTIANISES": "DECHRISTIANISE, to turn from Christianity, also DECHRISTIANIZE [v]\n",
  "DECHRISTIANIZE": "to turn from Christianity, also DECHRISTIANISE [v DECHRISTIANIZED, DECHRISTIANIZES]\n",
  "DECHRISTIANIZED": "DECHRISTIANIZE, to turn from Christianity, also DECHRISTIANISE [v]\n",
  "DECHRISTIANIZES": "DECHRISTIANIZE, to turn from Christianity, also DECHRISTIANISE [v]\n",
  "DECIARE": "the tenth part of an are, 10 square metres [n -S]\n",
  "DECIARES": "DECIARE, the tenth part of an are, 10 square metres [n]\n",
  "DECIBEL": "a unit of sound intensity [n -S]\n",
  "DECIBELS": "DECIBEL, a unit of sound intensity [n]\n",
  "DECIDABILITIES": "DECIDABILITY, the quality of being decidable [n]\n",
  "DECIDABILITY": "the quality of being decidable [n DECIDABILITIES]\n",
  "DECIDABLE": "that can be decided [adj]\n",
  "DECIDE": "to make a choice [v DECIDED, DECIDING, DECIDES]\n",
  "DECIDED": "DECIDE, to make a choice [v]\n",
  "DECIDEDLY": "DECIDED, DECIDE, to make a choice [adv]\n",
  "DECIDEDNESS": "the state of being decided [n -ES]\n",
  "DECIDEDNESSES": "DECIDEDNESS, the state of being decided [n]\n",
  "DECIDER": "one that decides [n -S]\n",
  "DECIDERS": "DECIDER, one that decides [n]\n",
  "DECIDES": "DECIDE, to make a choice [v]\n",
  "DECIDING": "DECIDE, to make a choice [v]\n",
  "DECIDUA": "(Latin) a mucous membrane of the uterus [n DECIDUAS or DECIDUAE]\n",
  "DECIDUAE": "DECIDUA, (Latin) a mucous membrane of the uterus [n]\n",
  "DECIDUAL": "pertaining to the decidua [adj]\n",
  "DECIDUAS": "DECIDUA, (Latin) a mucous membrane of the uterus [n]\n",
  "DECIDUATE": "possessed of, or characterized by, a decidua, the inner layer of the wall of the uterus [adj]\n",
  "DECIDUOUS": "losing leaves in autumn [adj]\n",
  "DECIDUOUSLY": "DECIDUOUS, losing leaves in autumn [adv]\n",
  "DECIDUOUSNESS": "the state of being deciduous [n -ES]\n",
  "DECIDUOUSNESSES": "DECIDUOUSNESS, the state of being deciduous [n]\n",
  "DECIGRAM": "a tenth of a gram, also DECIGRAMME [n -S]\n",
  "DECIGRAMME": "a tenth of a gram, also DECIGRAM [n -S]\n",
  "DECIGRAMMES": "DECIGRAMME, a tenth of a gram, also DECIGRAM [n]\n",
  "DECIGRAMS": "DECIGRAM, a tenth of a gram, also DECIGRAMME [n]\n",
  "DECILE": "a statistical interval [n -S]\n",
  "DECILES": "DECILE, a statistical interval [n]\n",
  "DECILITER": "one tenth of a liter, also DECILITRE [n -S]\n",
  "DECILITERS": "DECILITER, one tenth of a liter, also DECILITRE [n]\n",
  "DECILITRE": "one tenth of a liter, also DECILITER [n -S]\n",
  "DECILITRES": "DECILITRE, one tenth of a liter, also DECILITER [n]\n",
  "DECILLION": "the eleventh power of a thousand [n -S]\n",
  "DECILLIONS": "DECILLION, the eleventh power of a thousand [n]\n",
  "DECILLIONTH": "one part in a decillion [n -S]\n",
  "DECILLIONTHS": "DECILLIONTH, one part in a decillion [n]\n",
  "DECIMAL": "relating to a tenth part [adj DECIMALLY] / a fraction whose denominator is some power of ten [n -S]\n",
  "DECIMALISATION": "conversion (as of a currency) to a decimal system, also DECIMALIZATION [n -S]\n",
  "DECIMALISATIONS": "DECIMALISATION, conversion (as of a currency) to a decimal system, also DECIMALIZATION [n]\n",
  "DECIMALISE": "to convert to a decimal system, also DECIMALIZE [v DECIMALISED, DECIMALISING, DECIMALISES]\n",
  "DECIMALISED": "DECIMALISE, to convert to a decimal system, also DECIMALIZE [v]\n",
  "DECIMALISES": "DECIMALISE, to convert to a decimal system, also DECIMALIZE [v]\n",
  "DECIMALISING": "DECIMALISE, to convert to a decimal system, also DECIMALIZE [v]\n",
  "DECIMALISM": "the system of a decimal currency, decimal weights, measures, etc. [n -S]\n",
  "DECIMALISMS": "DECIMALISM, the system of a decimal currency, decimal weights, measures, etc. [n]\n",
  "DECIMALIST": "one who advocates a decimal system [n -S]\n",
  "DECIMALISTS": "DECIMALIST, one who advocates a decimal system [n]\n",
  "DECIMALIZATION": "conversion (as of a currency) to a decimal system, also DECIMALISATION [n -S]\n",
  "DECIMALIZATIONS": "DECIMALIZATION, conversion (as of a currency) to a decimal system, also DECIMALISATION [n]\n",
  "DECIMALIZE": "to convert to a decimal system, esp. the metric system, also DECIMALISE [v DECIMALIZED, DECIMALIZING, DECIMALIZES]\n",
  "DECIMALIZED": "DECIMALIZE, to convert to a decimal system, esp. the metric system, also DECIMALISE [v]\n",
  "DECIMALIZES": "DECIMALIZE, to convert to a decimal system, esp. the metric system, also DECIMALISE [v]\n",
  "DECIMALIZING": "DECIMALIZE, to convert to a decimal system, esp. the metric system, also DECIMALISE [v]\n",
  "DECIMALLY": "DECIMAL, relating to a tenth part [adv]\n",
  "DECIMALS": "DECIMAL, a fraction whose denominator is some power of ten [n]\n",
  "DECIMATE": "to kill every tenth person; to destroy a large proportion of a group [v DECIMATED, DECIMATING, DECIMATES]\n",
  "DECIMATED": "DECIMATE, to kill every tenth person; to destroy a large proportion of a group [v]\n",
  "DECIMATES": "DECIMATE, to kill every tenth person; to destroy a large proportion of a group [v]\n",
  "DECIMATING": "DECIMATE, to kill every tenth person; to destroy a large proportion of a group [v]\n",
  "DECIMATION": "the act of decimating [n -S]\n",
  "DECIMATIONS": "DECIMATION, the act of decimating [n]\n",
  "DECIMATOR": "one who decimates [n -S]\n",
  "DECIMATORS": "DECIMATOR, one who decimates [n]\n",
  "DECIME": "(historical) a former unit of currency in France, 1/10 of a franc [n -S]\n",
  "DECIMES": "DECIME, (historical) a former unit of currency in France, 1/10 of a franc [n]\n",
  "DECIMETER": "one tenth of a metre, also DECIMETRE [n -S]\n",
  "DECIMETERS": "DECIMETER, one tenth of a metre, also DECIMETRE [n]\n",
  "DECIMETRE": "one tenth of a metre, also DECIMETER [n -S]\n",
  "DECIMETRES": "DECIMETRE, one tenth of a metre, also DECIMETER [n]\n",
  "DECIMETRIC": "relating to a decimetre, one tenth of a metre [adj]\n",
  "DECINORMAL": "of a chemical solution, of one tenth of normal concentration [adj]\n",
  "DECIPHER": "to interpret from the unknown [v -ED, -ING, -S]\n",
  "DECIPHERABILITY": "the quality of being decipherable [n]\n",
  "DECIPHERABLE": "capable of being deciphered [adj]\n",
  "DECIPHERED": "DECIPHER, to interpret from the unknown [v]\n",
  "DECIPHERER": "one who deciphers [n -S]\n",
  "DECIPHERERS": "DECIPHERER, one who deciphers [n]\n",
  "DECIPHERING": "DECIPHER, to interpret from the unknown [v]\n",
  "DECIPHERMENT": "the act of deciphering [n -S]\n",
  "DECIPHERMENTS": "DECIPHERMENT, the act of deciphering [n]\n",
  "DECIPHERS": "DECIPHER, to interpret from the unknown [v]\n",
  "DECISION": "the act of deciding [n -S] / to win a boxing decision [v -ED, -ING, -S]\n",
  "DECISIONAL": "relating to a decision [adj]\n",
  "DECISIONED": "DECISION, to win a boxing decision [v]\n",
  "DECISIONING": "DECISION, to win a boxing decision [v]\n",
  "DECISIONS": "DECISION, to win a boxing decision [v]\n",
  "DECISIVE": "conclusive [adj DECISIVELY]\n",
  "DECISIVELY": "DECISIVE, conclusive [adv]\n",
  "DECISIVENESS": "the state of being decisive [n -ES]\n",
  "DECISIVENESSES": "DECISIVENESS, the state of being decisive [n]\n",
  "DECISORY": "decisive [adj]\n",
  "DECISTERE": "one tenth of a stere or cubic meter [n -S]\n",
  "DECISTERES": "DECISTERE, one tenth of a stere or cubic meter [n]\n",
  "DECITIZENISE": "to deprive of citizenship, also DECITIZENIZE [v DECITIZENISED, DECITIZENISING, DECITIZENISES]\n",
  "DECITIZENISED": "DECITIZENISE, to deprive of citizenship, also DECITIZENIZE [v]\n",
  "DECITIZENISES": "DECITIZENISE, to deprive of citizenship, also DECITIZENIZE [v]\n",
  "DECITIZENISING": "DECITIZENISE, to deprive of citizenship, also DECITIZENIZE [v]\n",
  "DECITIZENIZE": "to deprive of citizenship, also DECITIZENISE [v DECITIZENIZED, DECITIZENIZING, DECITIZENIZES]\n",
  "DECITIZENIZED": "DECITIZENIZE, to deprive of citizenship, also DECITIZENISE [v]\n",
  "DECITIZENIZES": "DECITIZENIZE, to deprive of citizenship, also DECITIZENISE [v]\n",
  "DECITIZENIZING": "DECITIZENIZE, to deprive of citizenship, also DECITIZENISE [v]\n",
  "DECIVILISE": "to reduce from civilization to a savage state, also DECIVILIZE [v DECIVILISED, DECIVILISING, DECIVILISES]\n",
  "DECIVILISED": "DECIVILISE, to reduce from civilization to a savage state, also DECIVILIZE [v]\n",
  "DECIVILISES": "DECIVILISE, to reduce from civilization to a savage state, also DECIVILIZE [v]\n",
  "DECIVILISING": "DECIVILISE, to reduce from civilization to a savage state, also DECIVILIZE [v]\n",
  "DECIVILIZE": "to reduce from civilization to a savage state, also DECIVILISE [v DECIVILIZED, DECIVILIZING, DECIVILIZES]\n",
  "DECIVILIZED": "DECIVILIZE, to reduce from civilization to a savage state, also DECIVILISE [v]\n",
  "DECIVILIZES": "DECIVILIZE, to reduce from civilization to a savage state, also DECIVILISE [v]\n",
  "DECIVILIZING": "DECIVILIZE, to reduce from civilization to a savage state, also DECIVILISE [v]\n",
  "DECK": "to adorn [v -ED, -ING, -S]\n",
  "DECKCHAIR": "a chair, usually folding and made of canvas and wood, such as passengers sit or lie on deck in [n -S]\n",
  "DECKCHAIRS": "DECKCHAIR, a chair, usually folding and made of canvas and wood, such as passengers sit or lie on deck in [n]\n",
  "DECKED": "DECK, to adorn [v]\n",
  "DECKEL": "a frame used in making paper by hand, also DECKLE [n -S]\n",
  "DECKELS": "DECKEL, a frame used in making paper by hand, also DECKLE [n]\n",
  "DECKER": "a person who adorns [n -S]\n",
  "DECKERS": "DECKER, a person who adorns [n]\n",
  "DECKHAND": "a seaman who performs manual duties [n -S]\n",
  "DECKHANDS": "DECKHAND, a seaman who performs manual duties [n]\n",
  "DECKHOUSE": "a room erected on the deck of a ship [n -S]\n",
  "DECKHOUSES": "DECKHOUSE, a room erected on the deck of a ship [n]\n",
  "DECKING": "material for a ship's deck [n -S]\n",
  "DECKINGS": "DECKING, material for a ship's deck [n]\n",
  "DECKLE": "a frame used in making paper by hand, also DECKEL [n -S]\n",
  "DECKLED": "deckle-edged [adj]\n",
  "DECKLES": "DECKLE, a frame used in making paper by hand, also DECKEL [n]\n",
  "DECKLESS": "lacking a deck [adj]\n",
  "DECKO": "to take a look, also DEKKO [v DECKOED, DECKOING, DECKOS]\n",
  "DECKOED": "DECKO, to take a look, also DEKKO [v]\n",
  "DECKOING": "DECKO, to take a look, also DEKKO [v]\n",
  "DECKOS": "DECKO, to take a look, also DEKKO [v]\n",
  "DECKS": "DECK, to adorn [v]\n",
  "DECLAIM": "to speak formally [v -ED, -ING, -S]\n",
  "DECLAIMANT": "a declaimer [n -S]\n",
  "DECLAIMANTS": "DECLAIMANT, a declaimer [n]\n",
  "DECLAIMED": "DECLAIM, to speak formally [v]\n",
  "DECLAIMER": "one who declaims [n -S]\n",
  "DECLAIMERS": "DECLAIMER, one who declaims [n]\n",
  "DECLAIMING": "the act of making a declamation [n -S]\n",
  "DECLAIMINGS": "DECLAIMING, the act of making a declamation [n]\n",
  "DECLAIMS": "DECLAIM, to speak formally [v]\n",
  "DECLAMATION": "the act of declaiming [n -S]\n",
  "DECLAMATIONS": "DECLAMATION, the act of declaiming [n]\n",
  "DECLAMATORILY": "DECLAMATORY, in the manner of a declamation [adv]\n",
  "DECLAMATORY": "in the manner of a declamation [adj DECLAMATORILY]\n",
  "DECLARABLE": "that can be declared [adj]\n",
  "DECLARANT": "one who makes a declaration [n -S]\n",
  "DECLARANTS": "DECLARANT, one who makes a declaration [n]\n",
  "DECLARATION": "the act of declaring [n -S]\n",
  "DECLARATIONS": "DECLARATION, the act of declaring [n]\n",
  "DECLARATIVE": "making a declaration [adj DECLARATIVELY]\n",
  "DECLARATIVELY": "DECLARATIVE, making a declaration [adv]\n",
  "DECLARATOR": "a form of action in the Court of Session, with the view of having a fact judicially ascertained and declared [n -S]\n",
  "DECLARATORILY": "DECLARATORY, in the manner of a declaration [adv]\n",
  "DECLARATORS": "DECLARATOR, a form of action in the Court of Session, with the view of having a fact judicially ascertained and declared [n]\n",
  "DECLARATORY": "in the manner of a declaration [adj DECLARATORILY]\n",
  "DECLARE": "to make known clearly [v DECLARED, DECLARING, DECLARES]\n",
  "DECLARED": "DECLARE, to make known clearly [v]\n",
  "DECLAREDLY": "DECLARED, DECLARE, to make known clearly [adv]\n",
  "DECLARER": "one who declares [n -S]\n",
  "DECLARERS": "DECLARER, one who declares [n]\n",
  "DECLARES": "DECLARE, to make known clearly [v]\n",
  "DECLARING": "DECLARE, to make known clearly [v]\n",
  "DECLASS": "to lower in status [v -ED, -ING, -ES]\n",
  "DECLASSE": "(French) having lost caste or social standing [adj] / one has has lost social standing [n -S]\n",
  "DECLASSED": "DECLASS, to lower in status [v]\n",
  "DECLASSEE": "of a female person, reduced or degraded in social class or status [adj]\n",
  "DECLASSES": "DECLASS, to lower in status [v]\n",
  "DECLASSIFIABLE": "able to be declassified [adj]\n",
  "DECLASSIFIED": "DECLASSIFY, to remove or reduce the security classification of [v]\n",
  "DECLASSIFIES": "DECLASSIFY, to remove or reduce the security classification of [v]\n",
  "DECLASSIFY": "to remove or reduce the security classification of [v DECLASSIFIED, DECLASSIFYING, DECLASSIFIES]\n",
  "DECLASSIFYING": "DECLASSIFY, to remove or reduce the security classification of [v]\n",
  "DECLASSING": "DECLASS, to lower in status [v]\n",
  "DECLAW": "to remove the claws of [v -ED, -ING, -S]\n",
  "DECLAWED": "DECLAW, to remove the claws of [v]\n",
  "DECLAWING": "DECLAW, to remove the claws of [v]\n",
  "DECLAWS": "DECLAW, to remove the claws of [v]\n",
  "DECLENSION": "a system of cases and case-endings [n -S]\n",
  "DECLENSIONAL": "relating to declension [adj DECLENSIONALLY]\n",
  "DECLENSIONALLY": "DECLENSIONAL, relating to declension [adv]\n",
  "DECLENSIONS": "DECLENSION, a system of cases and case-endings [n]\n",
  "DECLINABLE": "capable of being declined; admitting of declension or inflection; as, declinable parts of speech [adj]\n",
  "DECLINAL": "the act of declining [n -S]\n",
  "DECLINALS": "DECLINAL, the act of declining [n]\n",
  "DECLINANT": "(French) a person who is declining or diminishing in luck or wealth [n -S]\n",
  "DECLINANTS": "DECLINANT, (French) a person who is declining or diminishing in luck or wealth [n]\n",
  "DECLINATE": "curving downwards [adj]\n",
  "DECLINATION": "the angular distance north or south from the celestial equator measured along a great circle passing through the celestial poles [n -S]\n",
  "DECLINATIONAL": "relating to declination [adj]\n",
  "DECLINATIONS": "DECLINATION, the angular distance north or south from the celestial equator measured along a great circle passing through the celestial poles [n]\n",
  "DECLINATOR": "an instrument for taking the declination or angle which a plane makes with the horizontal plane [n -S]\n",
  "DECLINATORIES": "DECLINATORY, a legal plea that has the aim of demonstrating that the accused is exempt from legal authority and punishment [n]\n",
  "DECLINATORS": "DECLINATOR, an instrument for taking the declination or angle which a plane makes with the horizontal plane [n]\n",
  "DECLINATORY": "a legal plea that has the aim of demonstrating that the accused is exempt from legal authority and punishment [n DECLINATORIES]\n",
  "DECLINATURE": "an act of declining or refusing; a plea declining the jurisdiction of a judge [n -S]\n",
  "DECLINATURES": "DECLINATURE, an act of declining or refusing; a plea declining the jurisdiction of a judge [n]\n",
  "DECLINE": "to refuse [v DECLINED, DECLINING, DECLINES]\n",
  "DECLINED": "DECLINE, to refuse [v]\n",
  "DECLINER": "one who declines [n -S]\n",
  "DECLINERS": "DECLINER, one who declines [n]\n",
  "DECLINES": "DECLINE, to refuse [v]\n",
  "DECLINING": "DECLINE, to refuse [v]\n",
  "DECLINIST": "a person who believes that something is in decline [n -S]\n",
  "DECLINISTS": "DECLINIST, a person who believes that something is in decline [n]\n",
  "DECLINOMETER": "an instrument for measuring magnetic declination [n -S]\n",
  "DECLINOMETERS": "DECLINOMETER, an instrument for measuring magnetic declination [n]\n",
  "DECLIVITIES": "DECLIVITY, a descending slope [n]\n",
  "DECLIVITOUS": "sloping downhill, also DECLIVOUS [adj]\n",
  "DECLIVITY": "a descending slope [n DECLIVITIES]\n",
  "DECLIVOUS": "sloping downhill, also DECLIVITOUS [adj]\n",
  "DECLUTCH": "to release the clutch [v -ED, -ING, -ES]\n",
  "DECLUTCHED": "DECLUTCH, to release the clutch [v]\n",
  "DECLUTCHES": "DECLUTCH, to release the clutch [v]\n",
  "DECLUTCHING": "DECLUTCH, to release the clutch [v]\n",
  "DECLUTTER": "to simplify or get rid of mess [v -ED, -ING, -S]\n",
  "DECLUTTERED": "DECLUTTER, to simplify or get rid of mess [v]\n",
  "DECLUTTERING": "DECLUTTER, to simplify or get rid of mess [v]\n",
  "DECLUTTERS": "DECLUTTER, to simplify or get rid of mess [v]\n",
  "DECO": "a style of decorative art characteristic of the 1920s and 1930s [n -S]\n",
  "DECOCT": "to extract the flavour by boiling [v -ED, -ING, -S]\n",
  "DECOCTED": "DECOCT, to extract the flavour by boiling [v]\n",
  "DECOCTIBLE": "capable of being boiled or digested [adj]\n",
  "DECOCTING": "DECOCT, to extract the flavour by boiling [v]\n",
  "DECOCTION": "the act of boiling anything in a watery fluid to extract its virtues [n -S]\n",
  "DECOCTIONS": "DECOCTION, the act of boiling anything in a watery fluid to extract its virtues [n]\n",
  "DECOCTIVE": "relating to decoction, preparation by boiling [adj]\n",
  "DECOCTS": "DECOCT, to extract the flavour by boiling [v]\n",
  "DECOCTURE": "a decoction [n -S]\n",
  "DECOCTURES": "DECOCTURE, a decoction [n]\n",
  "DECODABLE": "capable of being decoded [adj]\n",
  "DECODE": "to convert a coded message into plain language [v DECODED, DECODING, DECODES]\n",
  "DECODED": "DECODE, to convert a coded message into plain language [v]\n",
  "DECODER": "one that decodes [n -S]\n",
  "DECODERS": "DECODER, one that decodes [n]\n",
  "DECODES": "DECODE, to convert a coded message into plain language [v]\n",
  "DECODING": "the act of breaking a code [n -S]\n",
  "DECODINGS": "DECODING, the act of breaking a code [n]\n",
  "DECOHERENCE": "the act of becoming not coherent [n -S]\n",
  "DECOHERENCES": "DECOHERENCE, the act of becoming not coherent [n]\n",
  "DECOHERER": "a device for bringing a coherer back to its former condition after it has been affected by an electric wave [n -S]\n",
  "DECOHERERS": "DECOHERER, a device for bringing a coherer back to its former condition after it has been affected by an electric wave [n]\n",
  "DECOKE": "to decarbonise (an internal combustion engine) [v DECOKED, DECOKING, DECOKES]\n",
  "DECOKED": "DECOKE, to decarbonise (an internal combustion engine) [v]\n",
  "DECOKES": "DECOKE, to decarbonise (an internal combustion engine) [v]\n",
  "DECOKING": "DECOKE, to decarbonise (an internal combustion engine) [v]\n",
  "DECOLLATE": "to behead [v DECOLLATED, DECOLLATING, DECOLLATES]\n",
  "DECOLLATED": "DECOLLATE, to behead [v]\n",
  "DECOLLATES": "DECOLLATE, to behead [v]\n",
  "DECOLLATING": "DECOLLATE, to behead [v]\n",
  "DECOLLATION": "the act of decollating [n -S]\n",
  "DECOLLATIONS": "DECOLLATION, the act of decollating [n]\n",
  "DECOLLATOR": "one who decollates, beheads [n -S]\n",
  "DECOLLATORS": "DECOLLATOR, one who decollates, beheads [n]\n",
  "DECOLLETAGE": "(French) the low-cut neckline of a woman's garment [n -S]\n",
  "DECOLLETAGES": "DECOLLETAGE, (French) the low-cut neckline of a woman's garment [n]\n",
  "DECOLLETE": "(French) a low cut at the neck [n -S]\n",
  "DECOLLETES": "DECOLLETE, (French) a low cut at the neck [n]\n",
  "DECOLONISATION": "the act of decolonising, also DECOLONIZATION [n -S]\n",
  "DECOLONISATIONS": "DECOLONISATION, the act of decolonising, also DECOLONIZATION [n]\n",
  "DECOLONISE": "to release from being a colony, grant independence to, also DECOLONIZE [v DECOLONISED, DECOLONISING, DECOLONISES]\n",
  "DECOLONISED": "DECOLONISE, to release from being a colony, grant independence to, also DECOLONIZE [v]\n",
  "DECOLONISES": "DECOLONISE, to release from being a colony, grant independence to, also DECOLONIZE [v]\n",
  "DECOLONISING": "DECOLONISE, to release from being a colony, grant independence to, also DECOLONIZE [v]\n",
  "DECOLONIZATION": "the act of decolonizing, also DECOLONISATION [n -S]\n",
  "DECOLONIZATIONS": "DECOLONIZATION, the act of decolonizing, also DECOLONISATION [n]\n",
  "DECOLONIZE": "to release from being a colony, grant independence to, also DECOLONISE [v DECOLONIZED, DECOLONIZING, DECOLONIZES]\n",
  "DECOLONIZED": "DECOLONIZE, to release from being a colony, grant independence to, also DECOLONISE [v]\n",
  "DECOLONIZES": "DECOLONIZE, to release from being a colony, grant independence to, also DECOLONISE [v]\n",
  "DECOLONIZING": "DECOLONIZE, to release from being a colony, grant independence to, also DECOLONISE [v]\n",
  "DECOLOR": "to deprive of color, also DECOLOUR [v -ED, -ING, -S]\n",
  "DECOLORANT": "a substance which removes color, or bleaches [n -S]\n",
  "DECOLORANTS": "DECOLORANT, a substance which removes color, or bleaches [n]\n",
  "DECOLORATE": "to deprive of color [v DECOLORATED, DECOLORATING, DECOLORATES]\n",
  "DECOLORATED": "DECOLORATE, to deprive of color [v]\n",
  "DECOLORATES": "DECOLORATE, to deprive of color [v]\n",
  "DECOLORATING": "DECOLORATE, to deprive of color [v]\n",
  "DECOLORATION": "removal or absence of colour [n -S]\n",
  "DECOLORATIONS": "DECOLORATION, removal or absence of colour [n]\n",
  "DECOLORED": "DECOLOR, to deprive of color, also DECOLOUR [v]\n",
  "DECOLORING": "DECOLOR, to deprive of color, also DECOLOUR [v]\n",
  "DECOLORISATION": "the act of decolorising, also DECOLORIZATION, DECOLOURISATION, DECOLOURIZATION [n -S]\n",
  "DECOLORISATIONS": "DECOLORISATION, the act of decolorising, also DECOLORIZATION, DECOLOURISATION, DECOLOURIZATION [n]\n",
  "DECOLORISE": "to remove the colour from, also DECOLORIZE, DECOLOURISE, DECOLOURIZE [v DECOLORISED, DECOLORISING, DECOLORISES]\n",
  "DECOLORISED": "DECOLORISE, to remove the colour from, also DECOLORIZE, DECOLOURISE, DECOLOURIZE [v]\n",
  "DECOLORISER": "an agent that decolorises, also DECOLORIZER [n -S]\n",
  "DECOLORISERS": "DECOLORISER, an agent that decolorises, also DECOLORIZER [n]\n",
  "DECOLORISES": "DECOLORISE, to remove the colour from, also DECOLORIZE, DECOLOURISE, DECOLOURIZE [v]\n",
  "DECOLORISING": "DECOLORISE, to remove the colour from, also DECOLORIZE, DECOLOURISE, DECOLOURIZE [v]\n",
  "DECOLORIZATION": "the act of decolorizing, also DECOLORISATION, DECOLOURISATION, DECOLOURIZATION [n -S]\n",
  "DECOLORIZATIONS": "DECOLORIZATION, the act of decolorizing, also DECOLORISATION, DECOLOURISATION, DECOLOURIZATION [n]\n",
  "DECOLORIZE": "to remove the colour from, also DECOLORISE, DECOLOURISE, DECOLOURIZE [v DECOLORIZED, DECOLORIZING, DECOLORIZES]\n",
  "DECOLORIZED": "DECOLORIZE, to remove the colour from, also DECOLORISE, DECOLOURISE, DECOLOURIZE [v]\n",
  "DECOLORIZER": "an agent that decolorizes, also DECOLORISER [n -S]\n",
  "DECOLORIZERS": "DECOLORIZER, an agent that decolorizes, also DECOLORISER [n]\n",
  "DECOLORIZES": "DECOLORIZE, to remove the colour from, also DECOLORISE, DECOLOURISE, DECOLOURIZE [v]\n",
  "DECOLORIZING": "DECOLORIZE, to remove the colour from, also DECOLORISE, DECOLOURISE, DECOLOURIZE [v]\n",
  "DECOLORS": "DECOLOR, to deprive of color, also DECOLOUR [v]\n",
  "DECOLOUR": "to deprive of color, also DECOLOR [v -ED, -ING, -S]\n",
  "DECOLOURED": "DECOLOUR, to deprive of color, also DECOLOR [v]\n",
  "DECOLOURING": "DECOLOUR, to deprive of color, also DECOLOR [v]\n",
  "DECOLOURISATION": "the process of decolourising, also DECOLORISATION, DECOLORIZATION, DECOLOURIZATION [n]\n",
  "DECOLOURISE": "to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURIZE [v DECOLOURISED, DECOLOURISING, DECOLOURISES]\n",
  "DECOLOURISED": "DECOLOURISE, to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURIZE [v]\n",
  "DECOLOURISES": "DECOLOURISE, to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURIZE [v]\n",
  "DECOLOURISING": "DECOLOURISE, to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURIZE [v]\n",
  "DECOLOURIZATION": "the process of decolourizing, also DECOLORISATION, DECOLORIZATION, DECOLOURISATION [n]\n",
  "DECOLOURIZE": "to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURISE [v DECOLOURIZED, DECOLOURIZING, DECOLOURIZES]\n",
  "DECOLOURIZED": "DECOLOURIZE, to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURISE [v]\n",
  "DECOLOURIZES": "DECOLOURIZE, to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURISE [v]\n",
  "DECOLOURIZING": "DECOLOURIZE, to remove the colour from, also DECOLORISE, DECOLORIZE, DECOLOURISE [v]\n",
  "DECOLOURS": "DECOLOUR, to deprive of color, also DECOLOR [v]\n",
  "DECOMMISSION": "to remove (as a ship or nuclear power plant) from service [v -ED, -ING, -S]\n",
  "DECOMMISSIONED": "DECOMMISSION, to remove (as a ship or nuclear power plant) from service [v]\n",
  "DECOMMISSIONER": "one who decommissions [n -S]\n",
  "DECOMMISSIONERS": "DECOMMISSIONER, one who decommissions [n]\n",
  "DECOMMISSIONING": "DECOMMISSION, to remove (as a ship or nuclear power plant) from service [v]\n",
  "DECOMMISSIONS": "DECOMMISSION, to remove (as a ship or nuclear power plant) from service [v]\n",
  "DECOMMIT": "to withdraw from a commitment [v DECOMMITTED, DECOMMITTING, DECOMMITS]\n",
  "DECOMMITS": "DECOMMIT, to withdraw from a commitment [v]\n",
  "DECOMMITTED": "DECOMMIT, to withdraw from a commitment [v]\n",
  "DECOMMITTING": "DECOMMIT, to withdraw from a commitment [v]\n",
  "DECOMMUNISATION": "the act or process of decommunising, also DECOMMUNIZATION [n]\n",
  "DECOMMUNISE": "to remove communist politics or influence from (a person or country), also DECOMMUNIZE [v DECOMMUNISED, DECOMMUNISING, DECOMMUNISES]\n",
  "DECOMMUNISED": "DECOMMUNISE, to remove communist politics or influence from (a person or country), also DECOMMUNIZE [v]\n",
  "DECOMMUNISES": "DECOMMUNISE, to remove communist politics or influence from (a person or country), also DECOMMUNIZE [v]\n",
  "DECOMMUNISING": "DECOMMUNISE, to remove communist politics or influence from (a person or country), also DECOMMUNIZE [v]\n",
  "DECOMMUNIZATION": "the act or process of decommunizing, also DECOMMUNISATION [n]\n",
  "DECOMMUNIZE": "to remove communist politics or influence from (a person or country), also DECOMMUNISE [v DECOMMUNIZED, DECOMMUNIZING, DECOMMUNIZES]\n",
  "DECOMMUNIZED": "DECOMMUNIZE, to remove communist politics or influence from (a person or country), also DECOMMUNISE [v]\n",
  "DECOMMUNIZES": "DECOMMUNIZE, to remove communist politics or influence from (a person or country), also DECOMMUNISE [v]\n",
  "DECOMMUNIZING": "DECOMMUNIZE, to remove communist politics or influence from (a person or country), also DECOMMUNISE [v]\n",
  "DECOMPENSATE": "to fail to compensate [v DECOMPENSATED, DECOMPENSATING, DECOMPENSATES]\n",
  "DECOMPENSATED": "DECOMPENSATE, to fail to compensate [v]\n",
  "DECOMPENSATES": "DECOMPENSATE, to fail to compensate [v]\n",
  "DECOMPENSATING": "DECOMPENSATE, to fail to compensate [v]\n",
  "DECOMPENSATION": "the failure of an organ to cope with increasing demands made on it owing to disease [n -S]\n",
  "DECOMPENSATIONS": "DECOMPENSATION, the failure of an organ to cope with increasing demands made on it owing to disease [n]\n",
  "DECOMPLEX": "repeatedly compound [adj]\n",
  "DECOMPOSABILITY": "the state of being decomposable [n]\n",
  "DECOMPOSABLE": "that can be decomposed [adj]\n",
  "DECOMPOSE": "to fall to pieces [v DECOMPOSED, DECOMPOSING, DECOMPOSES]\n",
  "DECOMPOSED": "DECOMPOSE, to fall to pieces [v]\n",
  "DECOMPOSER": "something that decomposes [n -S]\n",
  "DECOMPOSERS": "DECOMPOSER, something that decomposes [n]\n",
  "DECOMPOSES": "DECOMPOSE, to fall to pieces [v]\n",
  "DECOMPOSING": "DECOMPOSE, to fall to pieces [v]\n",
  "DECOMPOSITE": "a composite element that is itself composed of other elements [n -S]\n",
  "DECOMPOSITES": "DECOMPOSITE, a composite element that is itself composed of other elements [n]\n",
  "DECOMPOSITION": "the breakdown of dead organic material by detritivores or saprophytes [n -S]\n",
  "DECOMPOSITIONS": "DECOMPOSITION, the breakdown of dead organic material by detritivores or saprophytes [n]\n",
  "DECOMPOUND": "to decompose, decay [v -ED, -ING, -S]\n",
  "DECOMPOUNDABLE": "able to be decompounded [adj]\n",
  "DECOMPOUNDED": "DECOMPOUND, to decompose, decay [v]\n",
  "DECOMPOUNDING": "DECOMPOUND, to decompose, decay [v]\n",
  "DECOMPOUNDS": "DECOMPOUND, to decompose, decay [v]\n",
  "DECOMPRESS": "to release from pressure or compression [v -ED, -ING, -ES]\n",
  "DECOMPRESSED": "DECOMPRESS, to release from pressure or compression [v]\n",
  "DECOMPRESSES": "DECOMPRESS, to release from pressure or compression [v]\n",
  "DECOMPRESSING": "DECOMPRESS, to release from pressure or compression [v]\n",
  "DECOMPRESSION": "the act of decompressing [n -S]\n",
  "DECOMPRESSIONS": "DECOMPRESSION, the act of decompressing [n]\n",
  "DECOMPRESSIVE": "DECOMPRESS, to release from pressure or compression [adj]\n",
  "DECOMPRESSOR": "a device for decompressing [n -S]\n",
  "DECOMPRESSORS": "DECOMPRESSOR, a device for decompressing [n]\n",
  "DECONCENTRATE": "to reduce or abolish the concentration of [v DECONCENTRATED, DECONCENTRATING, DECONCENTRATES]\n",
  "DECONCENTRATED": "DECONCENTRATE, to reduce or abolish the concentration of [v]\n",
  "DECONCENTRATES": "DECONCENTRATE, to reduce or abolish the concentration of [v]\n",
  "DECONCENTRATING": "DECONCENTRATE, to reduce or abolish the concentration of [v]\n",
  "DECONCENTRATION": "the act of deconcentrating [n]\n",
  "DECONDITION": "to cause extinction of (a conditioned response) [v -ED, -ING, -S]\n",
  "DECONDITIONED": "DECONDITION, to cause extinction of (a conditioned response) [v]\n",
  "DECONDITIONING": "DECONDITION, to cause extinction of (a conditioned response) [v]\n",
  "DECONDITIONS": "DECONDITION, to cause extinction of (a conditioned response) [v]\n",
  "DECONGEST": "to relieve or end the congestion of [v -ED, -ING, -S]\n",
  "DECONGESTANT": "an agent that relieves congestion (as of mucous membranes) [n -S]\n",
  "DECONGESTANTS": "DECONGESTANT, an agent that relieves congestion (as of mucous membranes) [n]\n",
  "DECONGESTED": "DECONGEST, to relieve or end the congestion of [v]\n",
  "DECONGESTING": "DECONGEST, to relieve or end the congestion of [v]\n",
  "DECONGESTION": "the process of relieving congestion [n -S]\n",
  "DECONGESTIONS": "DECONGESTION, the process of relieving congestion [n]\n",
  "DECONGESTIVE": "DECONGEST, to relieve or end the congestion of [adj]\n",
  "DECONGESTS": "DECONGEST, to relieve or end the congestion of [v]\n",
  "DECONSECRATE": "to remove the sacred character of [v DECONSECRATED, DECONSECRATING, DECONSECRATES]\n",
  "DECONSECRATED": "DECONSECRATE, to remove the sacred character of [v]\n",
  "DECONSECRATES": "DECONSECRATE, to remove the sacred character of [v]\n",
  "DECONSECRATING": "DECONSECRATE, to remove the sacred character of [v]\n",
  "DECONSECRATION": "the act of deconsecrating [n -S]\n",
  "DECONSECRATIONS": "DECONSECRATION, the act of deconsecrating [n]\n",
  "DECONSTRUCT": "to examine (as a work of literature) using the methods of deconstruction [v -ED, -ING, -S]\n",
  "DECONSTRUCTED": "DECONSTRUCT, to examine (as a work of literature) using the methods of deconstruction [v]\n",
  "DECONSTRUCTING": "DECONSTRUCT, to examine (as a work of literature) using the methods of deconstruction [v]\n",
  "DECONSTRUCTION": "interpreting literature so as to show the impossibility of a definite interpretation [n -S]\n",
  "DECONSTRUCTIONS": "DECONSTRUCTION, interpreting literature so as to show the impossibility of a definite interpretation [n]\n",
  "DECONSTRUCTIVE": "serving to deconstruct [adj]\n",
  "DECONSTRUCTOR": "one who deconstructs [n -S]\n",
  "DECONSTRUCTORS": "DECONSTRUCTOR, one who deconstructs [n]\n",
  "DECONSTRUCTS": "DECONSTRUCT, to examine (as a work of literature) using the methods of deconstruction [v]\n",
  "DECONTAMINANT": "an agent that decontaminates [n -S]\n",
  "DECONTAMINANTS": "DECONTAMINANT, an agent that decontaminates [n]\n",
  "DECONTAMINATE": "to rid of contamination [v DECONTAMINATED, DECONTAMINATING, DECONTAMINATES]\n",
  "DECONTAMINATED": "DECONTAMINATE, to rid of contamination [v]\n",
  "DECONTAMINATES": "DECONTAMINATE, to rid of contamination [v]\n",
  "DECONTAMINATING": "DECONTAMINATE, to rid of contamination [v]\n",
  "DECONTAMINATION": "the act of decontaminating [n]\n",
  "DECONTAMINATIVE": "related to decontamination [adj]\n",
  "DECONTAMINATOR": "something that decontaminates [n -S]\n",
  "DECONTAMINATORS": "DECONTAMINATOR, something that decontaminates [n]\n",
  "DECONTEXTUALISE": "to consider (something) in isolation from its usual context, also DECONTEXTUALIZE [v]\n",
  "DECONTEXTUALIZE": "to consider (something) in isolation from its usual context, also DECONTEXTUALISE [v]\n",
  "DECONTROL": "to remove (esp. official) control from [v DECONTROLLED, DECONTROLLING, DECONTROLS]\n",
  "DECONTROLLED": "DECONTROL, to remove (esp. official) control from [v]\n",
  "DECONTROLLING": "DECONTROL, to remove (esp. official) control from [v]\n",
  "DECONTROLS": "DECONTROL, to remove (esp. official) control from [v]\n",
  "DECOR": "(French) a style of decoration [n -S]\n",
  "DECORATE": "to adorn [v DECORATED, DECORATING, DECORATES]\n",
  "DECORATED": "DECORATE, to adorn [v]\n",
  "DECORATES": "DECORATE, to adorn [v]\n",
  "DECORATING": "the act of adorning [n -S]\n",
  "DECORATINGS": "DECORATING, the act of adorning [n]\n",
  "DECORATION": "the act of decorating [n -S]\n",
  "DECORATIONS": "DECORATION, the act of decorating [n]\n",
  "DECORATIVE": "serving to decorate [adj DECORATIVELY]\n",
  "DECORATIVELY": "DECORATIVE, serving to decorate [adv]\n",
  "DECORATIVENESS": "DECORATIVE, serving to decorate [n]\n",
  "DECORATOR": "one who decorates [n -S]\n",
  "DECORATORS": "DECORATOR, one who decorates [n]\n",
  "DECOROUS": "marked by propriety and good taste [adj DECOROUSLY]\n",
  "DECOROUSLY": "DECOROUS, marked by propriety and good taste [adv]\n",
  "DECOROUSNESS": "the state of being decorous [n -ES]\n",
  "DECOROUSNESSES": "DECOROUSNESS, the state of being decorous [n]\n",
  "DECORS": "DECOR, (French) a style of decoration [n]\n",
  "DECORTICATE": "to remove the bark, husk or peel of [v DECORTICATED, DECORTICATING, DECORTICATES]\n",
  "DECORTICATED": "DECORTICATE, to remove the bark, husk or peel of [v]\n",
  "DECORTICATES": "DECORTICATE, to remove the bark, husk or peel of [v]\n",
  "DECORTICATING": "DECORTICATE, to remove the bark, husk or peel of [v]\n",
  "DECORTICATION": "the act of removing the outer coverings (as bark or husks) from something (as fiber or seed) [n -S]\n",
  "DECORTICATIONS": "DECORTICATION, the act of removing the outer coverings (as bark or husks) from something (as fiber or seed) [n]\n",
  "DECORTICATOR": "a device for removing bark [n -S]\n",
  "DECORTICATORS": "DECORTICATOR, a device for removing bark [n]\n",
  "DECORUM": "(Latin) proper behaviour [n -S]\n",
  "DECORUMS": "DECORUM, (Latin) proper behaviour [n]\n",
  "DECOS": "DECO, a style of decorative art characteristic of the 1920s and 1930s [n]\n",
  "DECOUPAGE": "(French) the application of paper cutouts to wood surfaces [n -S] / to apply paper cutouts to wood surfaces [v DECOUPAGED, DECOUPAGING, DECOUPAGES]\n",
  "DECOUPAGED": "DECOUPAGE, to apply paper cutouts to wood surfaces [v]\n",
  "DECOUPAGES": "DECOUPAGE, to apply paper cutouts to wood surfaces [v]\n",
  "DECOUPAGING": "DECOUPAGE, to apply paper cutouts to wood surfaces [v]\n",
  "DECOUPLE": "to disconnect [v DECOUPLED, DECOUPLING, DECOUPLES]\n",
  "DECOUPLED": "DECOUPLE, to disconnect [v]\n",
  "DECOUPLER": "one who decouples [n -S]\n",
  "DECOUPLERS": "DECOUPLER, one who decouples [n]\n",
  "DECOUPLES": "DECOUPLE, to disconnect [v]\n",
  "DECOUPLING": "the act of disconnecting [n -S]\n",
  "DECOUPLINGS": "DECOUPLING, the act of disconnecting [n]\n",
  "DECOY": "to lure into a trap [v -ED, -ING, -S]\n",
  "DECOYED": "DECOY, to lure into a trap [v]\n",
  "DECOYER": "one who decoys [n -S]\n",
  "DECOYERS": "DECOYER, one who decoys [n]\n",
  "DECOYING": "DECOY, to lure into a trap [v]\n",
  "DECOYS": "DECOY, to lure into a trap [v]\n",
  "DECRASSIFIED": "DECRASSIFY, to make less crass or boorish [v]\n",
  "DECRASSIFIES": "DECRASSIFY, to make less crass or boorish [v]\n",
  "DECRASSIFY": "to make less crass or boorish [v DECRASSIFIED, DECRASSIFYING, DECRASSIFIES]\n",
  "DECRASSIFYING": "DECRASSIFY, to make less crass or boorish [v]\n",
  "DECREASE": "to diminish, also DECREW [v DECREASED, DECREASING, DECREASES]\n",
  "DECREASED": "DECREASE, to diminish, also DECREW [v]\n",
  "DECREASES": "DECREASE, to diminish, also DECREW [v]\n",
  "DECREASING": "diminishing [adj DECREASINGLY] / the act of diminishing [n -S]\n",
  "DECREASINGLY": "DECREASING, diminishing [adv]\n",
  "DECREASINGS": "DECREASING, the act of diminishing [n]\n",
  "DECREE": "to issue an edict [v DECREED, DECREEING, DECREES]\n",
  "DECREEABLE": "capable of being decreed [adj]\n",
  "DECREED": "DECREE, to issue an edict [v]\n",
  "DECREEING": "DECREE, to issue an edict [v]\n",
  "DECREER": "one who decrees [n -S]\n",
  "DECREERS": "DECREER, one who decrees [n]\n",
  "DECREES": "DECREE, to issue an edict [v]\n",
  "DECREET": "the final judgment of the Court of Session, or of an inferior court, by which the question at issue is decided [n -S]\n",
  "DECREETS": "DECREET, the final judgment of the Court of Session, or of an inferior court, by which the question at issue is decided [n]\n",
  "DECREMENT": "a gradual decrease in quantity or quality [n -S] / to decrease [v -ED, -ING, -S]\n",
  "DECREMENTAL": "having the nature of a decrement [adj]\n",
  "DECREMENTED": "DECREMENT, to decrease [v]\n",
  "DECREMENTING": "DECREMENT, to decrease [v]\n",
  "DECREMENTS": "DECREMENT, to decrease [v]\n",
  "DECREPIT": "worn out, down at heel [adj DECREPITLY]\n",
  "DECREPITATE": "to crackle; to roast so as to cause to crackle [v DECREPITATED, DECREPITATING, DECREPITATES]\n",
  "DECREPITATED": "DECREPITATE, to crackle; to roast so as to cause to crackle [v]\n",
  "DECREPITATES": "DECREPITATE, to crackle; to roast so as to cause to crackle [v]\n",
  "DECREPITATING": "DECREPITATE, to crackle; to roast so as to cause to crackle [v]\n",
  "DECREPITATION": "the act of decrepitating [n -S]\n",
  "DECREPITATIONS": "DECREPITATION, the act of decrepitating [n]\n",
  "DECREPITLY": "DECREPIT, worn out, down at heel [adv]\n",
  "DECREPITNESS": "the state of being decrepit [n -ES]\n",
  "DECREPITNESSES": "DECREPITNESS, the state of being decrepit [n]\n",
  "DECREPITUDE": "the state of being decrepit [n -S]\n",
  "DECREPITUDES": "DECREPITUDE, the state of being decrepit [n]\n",
  "DECRESCENCE": "the state of being decrescent, waning [n -S]\n",
  "DECRESCENCES": "DECRESCENCE, the state of being decrescent, waning [n]\n",
  "DECRESCENDO": "(Italian) in a gradually diminishing manner; with abatement of tone [adv] / a passage to be so played [n -S]\n",
  "DECRESCENDOS": "DECRESCENDO, a passage to be so played [n]\n",
  "DECRESCENT": "waning, with horns towards sinister [adj]\n",
  "DECRETAL": "a papal decree deciding a point of church law [n -S]\n",
  "DECRETALIST": "one who studies decretals, also DECRETIST [n -S]\n",
  "DECRETALISTS": "DECRETALIST, one who studies decretals, also DECRETIST [n]\n",
  "DECRETALS": "DECRETAL, a papal decree deciding a point of church law [n]\n",
  "DECRETIST": "one who studies, or professes the knowledge of, the decretals, also DECRETALIST [n -S]\n",
  "DECRETISTS": "DECRETIST, one who studies, or professes the knowledge of, the decretals, also DECRETALIST [n]\n",
  "DECRETIVE": "relating to or having the force of a decree, also DECRETORY [adj]\n",
  "DECRETORY": "relating to or having the force of a decree, also DECRETIVE [adj]\n",
  "DECREW": "(Spenser) to decrease [v -ED, -ING, -S]\n",
  "DECREWED": "DECREW, (Spenser) to decrease [v]\n",
  "DECREWING": "DECREW, (Spenser) to decrease [v]\n",
  "DECREWS": "DECREW, (Spenser) to decrease [v]\n",
  "DECRIAL": "a crying down; a clamorous censure [n -S]\n",
  "DECRIALS": "DECRIAL, a crying down; a clamorous censure [n]\n",
  "DECRIED": "DECRY, to denounce [v]\n",
  "DECRIER": "one who decries [n -S]\n",
  "DECRIERS": "DECRIER, one who decries [n]\n",
  "DECRIES": "DECRY, to denounce [v]\n",
  "DECRIMINALISE": "to remove or reduce the criminal classification or status of, also DECRIMINALIZE [v DECRIMINALISED, DECRIMINALISING, DECRIMINALISES]\n",
  "DECRIMINALISED": "DECRIMINALISE, to remove or reduce the criminal classification or status of, also DECRIMINALIZE [v]\n",
  "DECRIMINALISES": "DECRIMINALISE, to remove or reduce the criminal classification or status of, also DECRIMINALIZE [v]\n",
  "DECRIMINALISING": "DECRIMINALISE, to remove or reduce the criminal classification or status of, also DECRIMINALIZE [v]\n",
  "DECRIMINALIZE": "to remove or reduce the criminal classification or status of, also DECRIMINALISE [v DECRIMINALIZED, DECRIMINALIZING, DECRIMINALIZES]\n",
  "DECRIMINALIZED": "DECRIMINALIZE, to remove or reduce the criminal classification or status of, also DECRIMINALISE [v]\n",
  "DECRIMINALIZES": "DECRIMINALIZE, to remove or reduce the criminal classification or status of, also DECRIMINALISE [v]\n",
  "DECRIMINALIZING": "DECRIMINALIZE, to remove or reduce the criminal classification or status of, also DECRIMINALISE [v]\n",
  "DECROWN": "to deprive of a crown, also DISCROWN [v -ED, -ING, -S]\n",
  "DECROWNED": "DECROWN, to deprive of a crown, also DISCROWN [v]\n",
  "DECROWNING": "DECROWN, to deprive of a crown, also DISCROWN [v]\n",
  "DECROWNS": "DECROWN, to deprive of a crown, also DISCROWN [v]\n",
  "DECRUSTATION": "removal of a crust [n -S]\n",
  "DECRUSTATIONS": "DECRUSTATION, removal of a crust [n]\n",
  "DECRY": "to denounce [v DECRIED, DECRYING, DECRIES]\n",
  "DECRYING": "DECRY, to denounce [v]\n",
  "DECRYPT": "to decode [v -ED, -ING, -S]\n",
  "DECRYPTED": "DECRYPT, to decode [v]\n",
  "DECRYPTING": "DECRYPT, to decode [v]\n",
  "DECRYPTION": "the act of decrypting [n -S]\n",
  "DECRYPTIONS": "DECRYPTION, the act of decrypting [n]\n",
  "DECRYPTS": "DECRYPT, to decode [v]\n",
  "DECTET": "a group of ten (musicians, lines of verse) [n -S]\n",
  "DECTETS": "DECTET, a group of ten (musicians, lines of verse) [n]\n",
  "DECUBITAL": "in a lying down position [adj]\n",
  "DECUBITI": "DECUBITUS, (Latin) one's posture or position in bed [n]\n",
  "DECUBITUS": "(Latin) one's posture or position in bed [n DECUBITI]\n",
  "DECUMAN": "(Latin) a great wave, as every tenth wave was supposed to be [n -S]\n",
  "DECUMANS": "DECUMAN, (Latin) a great wave, as every tenth wave was supposed to be [n]\n",
  "DECUMBENCE": "the act or posture of lying down, also DECUMBENCY [n -S]\n",
  "DECUMBENCES": "DECUMBENCE, the act or posture of lying down, also DECUMBENCY [n]\n",
  "DECUMBENCIES": "DECUMBENCY, the act or posture of lying down, also DECUMBENCE [n]\n",
  "DECUMBENCY": "the act or posture of lying down, also DECUMBENCE [n DECUMBENCIES]\n",
  "DECUMBENT": "lying down; reclining on the ground [adj DECUMBENTLY]\n",
  "DECUMBENTLY": "DECUMBENT, lying down; reclining on the ground [adv]\n",
  "DECUMBITURE": "the time spent by an invalid in bed [n -S]\n",
  "DECUMBITURES": "DECUMBITURE, the time spent by an invalid in bed [n]\n",
  "DECUMULATION": "a decrease in amount or value [n -S]\n",
  "DECUMULATIONS": "DECUMULATION, a decrease in amount or value [n]\n",
  "DECUPLE": "to increase tenfold [v DECUPLED, DECUPLING, DECUPLES]\n",
  "DECUPLED": "DECUPLE, to increase tenfold [v]\n",
  "DECUPLES": "DECUPLE, to increase tenfold [v]\n",
  "DECUPLING": "DECUPLE, to increase tenfold [v]\n",
  "DECURIA": "(Latin) a company of ten or more Roman soldiers under a decurion, also DECURY [n -S]\n",
  "DECURIAS": "DECURIA, (Latin) a company of ten or more Roman soldiers under a decurion, also DECURY [n]\n",
  "DECURIES": "DECURY, a group of ten soldiers, also DECURIA [n]\n",
  "DECURION": "(historical) in the Roman army, an officer over 10 soldiers [n -S]\n",
  "DECURIONATE": "the office of decurion [n -S]\n",
  "DECURIONATES": "DECURIONATE, the office of decurion [n]\n",
  "DECURIONS": "DECURION, (historical) in the Roman army, an officer over 10 soldiers [n]\n",
  "DECURRENCIES": "DECURRENCY, the state of being decurrent [n]\n",
  "DECURRENCY": "the state of being decurrent [n DECURRENCIES]\n",
  "DECURRENT": "continued down the stem [adj DECURRENTLY]\n",
  "DECURRENTLY": "DECURRENT, continued down the stem [adv]\n",
  "DECURSION": "a military manoeuvre or parade [n -S]\n",
  "DECURSIONS": "DECURSION, a military manoeuvre or parade [n]\n",
  "DECURSIVE": "running down; decurrent [adj DECURSIVELY]\n",
  "DECURSIVELY": "DECURSIVE, running down; decurrent [adv]\n",
  "DECURVATION": "downward curvature [n -S]\n",
  "DECURVATIONS": "DECURVATION, downward curvature [n]\n",
  "DECURVE": "to curve downwards [v DECURVED, DECURVING, DECURVES]\n",
  "DECURVED": "DECURVE, to curve downwards [v]\n",
  "DECURVES": "DECURVE, to curve downwards [v]\n",
  "DECURVING": "DECURVE, to curve downwards [v]\n",
  "DECURY": "a group of ten soldiers, also DECURIA [n DECURIES]\n",
  "DECUSSATE": "arranged in crossing pairs [adj DECUSSATELY] / to divide in the form of an X; to cross or intersect [v DECUSSATED, DECUSSATING, DECUSSATES]\n",
  "DECUSSATED": "DECUSSATE, to divide in the form of an X; to cross or intersect [v]\n",
  "DECUSSATELY": "DECUSSATE, arranged in crossing pairs [adv]\n",
  "DECUSSATES": "DECUSSATE, to divide in the form of an X; to cross or intersect [v]\n",
  "DECUSSATING": "DECUSSATE, to divide in the form of an X; to cross or intersect [v]\n",
  "DECUSSATION": "the action of crossing (as of nerve fibers) esp. in the form of an X [n -S]\n",
  "DECUSSATIONS": "DECUSSATION, the action of crossing (as of nerve fibers) esp. in the form of an X [n]\n",
  "DEDAL": "ingenious and cunningly designed, also DAEDAL, DAEDALEAN, DAEDALIAN, DAEDALIC, DEDALIAN [adj]\n",
  "DEDALIAN": "ingenious and cunningly designed, also DAEDAL, DAEDALEAN, DAEDALIAN, DAEDALIC, DEDAL [adj]\n",
  "DEDANS": "(French) spectators at a court tennis match [n]\n",
  "DEDENDA": "DEDENDUM, the root of a gear tooth [n]\n",
  "DEDENDUM": "the root of a gear tooth [n DEDENDA or DEDENDUMS]\n",
  "DEDENDUMS": "DEDENDUM, the root of a gear tooth [n]\n",
  "DEDICANT": "a person who dedicates [n -S]\n",
  "DEDICANTS": "DEDICANT, a person who dedicates [n]\n",
  "DEDICATE": "to set apart for a special purpose [v DEDICATED, DEDICATING, DEDICATES]\n",
  "DEDICATED": "DEDICATE, to set apart for a special purpose [v]\n",
  "DEDICATEDLY": "DEDICATED, DEDICATE, to set apart for a special purpose [adv]\n",
  "DEDICATEE": "one to whom something is dedicated [n -S]\n",
  "DEDICATEES": "DEDICATEE, one to whom something is dedicated [n]\n",
  "DEDICATES": "DEDICATE, to set apart for a special purpose [v]\n",
  "DEDICATING": "DEDICATE, to set apart for a special purpose [v]\n",
  "DEDICATION": "an act or rite of dedicating to a divine being or to a sacred use [n -S]\n",
  "DEDICATIONAL": "of the nature of a dedication [adj]\n",
  "DEDICATIONS": "DEDICATION, an act or rite of dedicating to a divine being or to a sacred use [n]\n",
  "DEDICATIVE": "of or like a dedication [adj]\n",
  "DEDICATOR": "one who dedicates [n -S]\n",
  "DEDICATORIAL": "related to dedication [adj]\n",
  "DEDICATORS": "DEDICATOR, one who dedicates [n]\n",
  "DEDICATORY": "constituting or serving as a dedication; complimental [adj]\n",
  "DEDIFFERENTIATE": "to effect dedifferentiation, a change by which specialized tissue with several cell types reverts to a generalized and simpler form [v]\n",
  "DEDIMUS": "(Latin) a writ to commission private persons to do some act in place of a judge, as to examine a witness, etc. [n -ES]\n",
  "DEDIMUSES": "DEDIMUS, (Latin) a writ to commission private persons to do some act in place of a judge, as to examine a witness, etc. [n]\n",
  "DEDRAMATISE": "to play down the importance of, lessen or keep low the tension or friction caused by, also DEDRAMATIZE [v DEDRAMATISED, DEDRAMATISING, DEDRAMATISES]\n",
  "DEDRAMATISED": "DEDRAMATISE, to play down the importance of, lessen or keep low the tension or friction caused by, also DEDRAMATIZE [v]\n",
  "DEDRAMATISES": "DEDRAMATISE, to play down the importance of, lessen or keep low the tension or friction caused by, also DEDRAMATIZE [v]\n",
  "DEDRAMATISING": "DEDRAMATISE, to play down the importance of, lessen or keep low the tension or friction caused by, also DEDRAMATIZE [v]\n",
  "DEDRAMATIZE": "to play down the importance of, lessen or keep low the tension or friction caused by also DEDRAMATISE [v DEDRAMATIZED, DEDRAMATIZING, DEDRAMATIZES]\n",
  "DEDRAMATIZED": "DEDRAMATIZE, to play down the importance of, lessen or keep low the tension or friction caused by also DEDRAMATISE [v]\n",
  "DEDRAMATIZES": "DEDRAMATIZE, to play down the importance of, lessen or keep low the tension or friction caused by also DEDRAMATISE [v]\n",
  "DEDRAMATIZING": "DEDRAMATIZE, to play down the importance of, lessen or keep low the tension or friction caused by also DEDRAMATISE [v]\n",
  "DEDUCE": "to infer [v DEDUCED, DEDUCING, DEDUCES]\n",
  "DEDUCED": "DEDUCE, to infer [v]\n",
  "DEDUCEMENT": "inference; deduction [n -S]\n",
  "DEDUCEMENTS": "DEDUCEMENT, inference; deduction [n]\n",
  "DEDUCES": "DEDUCE, to infer [v]\n",
  "DEDUCIBILITIES": "DEDUCIBILITY, the quality of being deducible [n]\n",
  "DEDUCIBILITY": "the quality of being deducible [n DEDUCIBILITIES]\n",
  "DEDUCIBLE": "capable of being deduced [adj DEDUCIBLY]\n",
  "DEDUCIBLENESS": "the state of being deducible [n -ES]\n",
  "DEDUCIBLENESSES": "DEDUCIBLENESS, the state of being deducible [n]\n",
  "DEDUCIBLY": "DEDUCIBLE, capable of being deduced [adv]\n",
  "DEDUCING": "DEDUCE, to infer [v]\n",
  "DEDUCT": "to subtract [v -ED, -ING, -S]\n",
  "DEDUCTED": "DEDUCT, to subtract [v]\n",
  "DEDUCTIBILITIES": "DEDUCTIBILITY, the quality of being deductible [n]\n",
  "DEDUCTIBILITY": "the quality of being deductible [n DEDUCTIBILITIES]\n",
  "DEDUCTIBLE": "a clause in an insurance policy that relieves the insurer of responsibility for an initial specified loss of the kind insured against [n -S]\n",
  "DEDUCTIBLES": "DEDUCTIBLE, a clause in an insurance policy that relieves the insurer of responsibility for an initial specified loss of the kind insured against [n]\n",
  "DEDUCTING": "DEDUCT, to subtract [v]\n",
  "DEDUCTION": "the act of deducing or deducting [n -S]\n",
  "DEDUCTIONS": "DEDUCTION, the act of deducing or deducting [n]\n",
  "DEDUCTIVE": "of thought or reasoning, concerned with deduction from premises or accepted principles [adj DEDUCTIVELY]\n",
  "DEDUCTIVELY": "DEDUCTIVE, of thought or reasoning, concerned with deduction from premises or accepted principles [adv]\n",
  "DEDUCTS": "DEDUCT, to subtract [v]\n",
  "DEDUPLICATE": "to remove (duplicated material) from a system [v DEDUPLICATED, DEDUPLICATING, DEDUPLICATES]\n",
  "DEDUPLICATED": "DEDUPLICATE, to remove (duplicated material) from a system [v]\n",
  "DEDUPLICATES": "DEDUPLICATE, to remove (duplicated material) from a system [v]\n",
  "DEDUPLICATING": "DEDUPLICATE, to remove (duplicated material) from a system [v]\n",
  "DEDUPLICATION": "the act of deduplicating [n -S]\n",
  "DEDUPLICATIONS": "DEDUPLICATION, the act of deduplicating [n]\n",
  "DEE": "to damn [v DEED, DEEING, DEES]\n",
  "DEED": "(Scots) dead [adj DEEDER, DEEDEST] / to transfer by a legal document [v -ED, -ING, -S]\n",
  "DEEDED": "DEED, to transfer by a legal document [v]\n",
  "DEEDER": "DEED, (Scots) dead [adj]\n",
  "DEEDEST": "DEED, (Scots) dead [adj]\n",
  "DEEDFUL": "marked by exploits [adj]\n",
  "DEEDIER": "DEEDY, (dialect) industrious [adj]\n",
  "DEEDIEST": "DEEDY, (dialect) industrious [adj]\n",
  "DEEDILY": "DEEDY, (dialect) industrious [adv]\n",
  "DEEDING": "DEED, to transfer by a legal document [v]\n",
  "DEEDLESS": "(Shakespeare) not having performed deeds [adj]\n",
  "DEEDS": "DEED, to transfer by a legal document [v]\n",
  "DEEDY": "(dialect) industrious [adj DEEDIER, DEEDIEST, DEEDILY]\n",
  "DEEING": "DEE, to damn [v]\n",
  "DEEJAY": "to act as a disk jockey, introducing recorded music [v -ED, -ING, -S]\n",
  "DEEJAYED": "DEEJAY, to act as a disk jockey, introducing recorded music [v]\n",
  "DEEJAYING": "the act of compering as a disc jockey [n -S]\n",
  "DEEJAYINGS": "DEEJAYING, the act of compering as a disc jockey [n]\n",
  "DEEJAYS": "DEEJAY, to act as a disk jockey, introducing recorded music [v]\n",
  "DEEK": "(Romany) look at, see [interj]\n",
  "DEELY": "as in deely boppers, a hairband with two bobbing antennae-like projections [adj]\n",
  "DEEM": "to hold as an opinion [v DEMPT or DEEMED, DEEMING, DEEMS]\n",
  "DEEMED": "DEEM, to hold as an opinion [v]\n",
  "DEEMING": "DEEM, to hold as an opinion [v]\n",
  "DEEMS": "DEEM, to hold as an opinion [v]\n",
  "DEEMSTER": "a judge on the Isle of Man, also DEMPSTER, DOOMSMAN, DOOMSTER [n -S]\n",
  "DEEMSTERS": "DEEMSTER, a judge on the Isle of Man, also DEMPSTER, DOOMSMAN, DOOMSTER [n]\n",
  "DEEMSTERSHIP": "the office of deemster [n -S]\n",
  "DEEMSTERSHIPS": "DEEMSTERSHIP, the office of deemster [n]\n",
  "DEEN": "(Spenser) din [n -S]\n",
  "DEENS": "DEEN, (Spenser) din [n]\n",
  "DEEP": "the place far down under the sea [n -S] / extending far down from the surface [adj DEEPER, DEEPEST, DEEPLY]\n",
  "DEEPEN": "to make deep [v -ED, -ING, -S]\n",
  "DEEPENED": "DEEPEN, to make deep [v]\n",
  "DEEPENER": "one that deepens [n -S]\n",
  "DEEPENERS": "DEEPENER, one that deepens [n]\n",
  "DEEPENING": "the act of making deep [n -S]\n",
  "DEEPENINGS": "DEEPENING, the act of making deep [n]\n",
  "DEEPENS": "DEEPEN, to make deep [v]\n",
  "DEEPER": "DEEP, extending far down from the surface [adj]\n",
  "DEEPEST": "DEEP, extending far down from the surface [adj]\n",
  "DEEPFELT": "profoundly believed [adj]\n",
  "DEEPFREEZE": "(tradename) a type of refrigerator in which food, etc., is stored for long periods at temperatures below freezing [n -S] / to freeze or keep as in a deepfreeze [v DEEPFROZE, DEEPFROZEN, DEEPFREEZING, DEEPFREEZES]\n",
  "DEEPFREEZES": "DEEPFREEZE, to freeze or keep as in a deepfreeze [v]\n",
  "DEEPFREEZING": "DEEPFREEZE, to freeze or keep as in a deepfreeze [v]\n",
  "DEEPFROZE": "DEEPFREEZE, to freeze or keep as in a deepfreeze [v]\n",
  "DEEPFROZEN": "DEEPFREEZE, to freeze or keep as in a deepfreeze [v]\n",
  "DEEPIE": "(colloquial) a three-dimensional cinematograph film [n -S]\n",
  "DEEPIES": "DEEPIE, (colloquial) a three-dimensional cinematograph film [n]\n",
  "DEEPLY": "DEEP, extending far down from the surface [adv]\n",
  "DEEPMOST": "deepest [adj]\n",
  "DEEPNESS": "the quality of being deep [n -ES]\n",
  "DEEPNESSES": "DEEPNESS, the quality of being deep [n]\n",
  "DEEPS": "DEEP, the place far down under the sea [n]\n",
  "DEEPWATER": "relating to the deep sea [adj]\n",
  "DEEPWATERMAN": "a seagoing ship [n DEEPWATERMEN]\n",
  "DEEPWATERMEN": "DEEPWATERMAN, a seagoing ship [n]\n",
  "DEER": "a ruminant mammal [n -S]\n",
  "DEERBERRIES": "DEERBERRY, a shrub of the blueberry group; its bitter, greenish white berry [n]\n",
  "DEERBERRY": "a shrub of the blueberry group; its bitter, greenish white berry [n DEERBERRIES]\n",
  "DEERE": "(Spenser) a deer [n -S]\n",
  "DEERES": "DEERE, (Spenser) a deer [n]\n",
  "DEERFLIES": "DEERFLY, a bloodsucking fly [n]\n",
  "DEERFLY": "a bloodsucking fly [n DEERFLIES]\n",
  "DEERGRASS": "a type of grass [n -ES]\n",
  "DEERGRASSES": "DEERGRASS, a type of grass [n]\n",
  "DEERHORN": "the horn of a deer [n -S]\n",
  "DEERHORNS": "DEERHORN, the horn of a deer [n]\n",
  "DEERHOUND": "a kind of hound used in hunting deer [n -S]\n",
  "DEERHOUNDS": "DEERHOUND, a kind of hound used in hunting deer [n]\n",
  "DEERLET": "a water-deer, a chevrotain [n -S]\n",
  "DEERLETS": "DEERLET, a water-deer, a chevrotain [n]\n",
  "DEERLIKE": "like a deer [adj]\n",
  "DEERS": "DEER, a ruminant mammal [n]\n",
  "DEERSKIN": "the skin of a deer [n -S]\n",
  "DEERSKINS": "DEERSKIN, the skin of a deer [n]\n",
  "DEERSTALKER": "a kind of cap [n -S]\n",
  "DEERSTALKERS": "DEERSTALKER, a kind of cap [n]\n",
  "DEERSTALKING": "the sport of stalking deer [n -S]\n",
  "DEERSTALKINGS": "DEERSTALKING, the sport of stalking deer [n]\n",
  "DEERWEED": "a bushlike herb [n -S]\n",
  "DEERWEEDS": "DEERWEED, a bushlike herb [n]\n",
  "DEERYARD": "an area where deer herd in winter [n -S]\n",
  "DEERYARDS": "DEERYARD, an area where deer herd in winter [n]\n",
  "DEES": "DEE, to damn [v]\n",
  "DEET": "an insect repellent [n -S]\n",
  "DEETS": "DEET, an insect repellent [n]\n",
  "DEEV": "(Persian) in Persian legend, an evil spirit, also DIV [n -S]\n",
  "DEEVE": "(Scots) to deafen, also DEAVE [v DEEVED, DEEVING, DEEVES]\n",
  "DEEVED": "DEEVE, (Scots) to deafen, also DEAVE [v]\n",
  "DEEVES": "DEEVE, (Scots) to deafen, also DEAVE [v]\n",
  "DEEVING": "DEEVE, (Scots) to deafen, also DEAVE [v]\n",
  "DEEVS": "DEEV, (Persian) in Persian legend, an evil spirit, also DIV [n]\n",
  "DEEWAN": "(Urdu) an official in India [n -S]\n",
  "DEEWANS": "DEEWAN, (Urdu) an official in India [n]\n",
  "DEF": "excellent [adj DEFFER, DEFFEST, DEFFLY]\n",
  "DEFACE": "to spoil the appearance of [v DEFACED, DEFAST or DEFASTE or DEFACED, DEFACING, DEFACES]\n",
  "DEFACEABLE": "that can be defaced [adj]\n",
  "DEFACED": "DEFACE, to spoil the appearance of [v]\n",
  "DEFACEMENT": "the act of defacing [n -S]\n",
  "DEFACEMENTS": "DEFACEMENT, the act of defacing [n]\n",
  "DEFACER": "one who defaces [n -S]\n",
  "DEFACERS": "DEFACER, one who defaces [n]\n",
  "DEFACES": "DEFACE, to spoil the appearance of [v]\n",
  "DEFACING": "DEFACE, to spoil the appearance of [v]\n",
  "DEFACINGLY": "DEFACING, DEFACE, to spoil the appearance of [adv]\n",
  "DEFAECATE": "to void excrement, also DEFECATE [v DEFAECATED, DEFAECATING, DEFAECATES]\n",
  "DEFAECATED": "DEFAECATE, to void excrement, also DEFECATE [v]\n",
  "DEFAECATES": "DEFAECATE, to void excrement, also DEFECATE [v]\n",
  "DEFAECATING": "DEFAECATE, to void excrement, also DEFECATE [v]\n",
  "DEFAECATION": "the expulsion of solid waste from the body, also DEFECATION [n -S]\n",
  "DEFAECATIONS": "DEFAECATION, the expulsion of solid waste from the body, also DEFECATION [n]\n",
  "DEFAECATOR": "one who defaecates, also DEFECATOR [n -S]\n",
  "DEFAECATORS": "DEFAECATOR, one who defaecates, also DEFECATOR [n]\n",
  "DEFALCATE": "to embezzle money held on trust [v DEFALCATED, DEFALCATING, DEFALCATES]\n",
  "DEFALCATED": "DEFALCATE, to embezzle money held on trust [v]\n",
  "DEFALCATES": "DEFALCATE, to embezzle money held on trust [v]\n",
  "DEFALCATING": "DEFALCATE, to embezzle money held on trust [v]\n",
  "DEFALCATION": "the act or an instance of embezzling [n -S]\n",
  "DEFALCATIONS": "DEFALCATION, the act or an instance of embezzling [n]\n",
  "DEFALCATOR": "a defaulter or embezzler [n -S]\n",
  "DEFALCATORS": "DEFALCATOR, a defaulter or embezzler [n]\n",
  "DEFAMATION": "the act of defaming another [n -S]\n",
  "DEFAMATIONS": "DEFAMATION, the act of defaming another [n]\n",
  "DEFAMATORILY": "DEFAMATORY, serving to defame [adv]\n",
  "DEFAMATORY": "serving to defame [adj DEFAMATORILY]\n",
  "DEFAME": "to destroy the reputation of [v DEFAMED, DEFAMING, DEFAMES]\n",
  "DEFAMED": "DEFAME, to destroy the reputation of [v]\n",
  "DEFAMER": "one who defames [n -S]\n",
  "DEFAMERS": "DEFAMER, one who defames [n]\n",
  "DEFAMES": "DEFAME, to destroy the reputation of [v]\n",
  "DEFAMING": "the act of defaming [n -S]\n",
  "DEFAMINGS": "DEFAMING, the act of defaming [n]\n",
  "DEFANG": "to remove the fangs from [v -ED, -ING, -S]\n",
  "DEFANGED": "DEFANG, to remove the fangs from [v]\n",
  "DEFANGING": "DEFANG, to remove the fangs from [v]\n",
  "DEFANGS": "DEFANG, to remove the fangs from [v]\n",
  "DEFAST": "DEFACE, to spoil the appearance of [v]\n",
  "DEFASTE": "DEFACE, to spoil the appearance of [v]\n",
  "DEFAT": "to remove fat from [v DEFATTED, DEFATTING, DEFATS]\n",
  "DEFATS": "DEFAT, to remove fat from [v]\n",
  "DEFATTED": "DEFAT, to remove fat from [v]\n",
  "DEFATTING": "DEFAT, to remove fat from [v]\n",
  "DEFAULT": "to fail to do something required [v -ED, -ING, -S]\n",
  "DEFAULTED": "DEFAULT, to fail to do something required [v]\n",
  "DEFAULTER": "one who defaults [n -S]\n",
  "DEFAULTERS": "DEFAULTER, one who defaults [n]\n",
  "DEFAULTING": "DEFAULT, to fail to do something required [v]\n",
  "DEFAULTS": "DEFAULT, to fail to do something required [v]\n",
  "DEFEASANCE": "a condition which, if fulfilled, renders an agreement or instrument null and void; a document setting out such a condition [n -S]\n",
  "DEFEASANCED": "liable to be forfeited [adj]\n",
  "DEFEASANCES": "DEFEASANCE, a condition which, if fulfilled, renders an agreement or instrument null and void; a document setting out such a condition [n]\n",
  "DEFEASIBILITIES": "DEFEASIBILITY, the quality of being defeasible [n]\n",
  "DEFEASIBILITY": "the quality of being defeasible [n DEFEASIBILITIES]\n",
  "DEFEASIBLE": "that may be annulled [adj]\n",
  "DEFEASIBLENESS": "DEFEASIBLE, that may be annulled [n]\n",
  "DEFEAT": "to win a victory over [v -ED, -ING, -S]\n",
  "DEFEATED": "DEFEAT, to win a victory over [v]\n",
  "DEFEATER": "one who defeats [n -S]\n",
  "DEFEATERS": "DEFEATER, one who defeats [n]\n",
  "DEFEATING": "DEFEAT, to win a victory over [v]\n",
  "DEFEATISM": "readiness or inclination to accept defeat [n -S]\n",
  "DEFEATISMS": "DEFEATISM, readiness or inclination to accept defeat [n]\n",
  "DEFEATIST": "one who shows defeatism [n -S]\n",
  "DEFEATISTS": "DEFEATIST, one who shows defeatism [n]\n",
  "DEFEATS": "DEFEAT, to win a victory over [v]\n",
  "DEFEATURE": "(archaic) to disfigure, also DISFEATURE [v DEFEATURED, DEFEATURING, DEFEATURES]\n",
  "DEFEATURED": "DEFEATURE, (archaic) to disfigure, also DISFEATURE [v]\n",
  "DEFEATURES": "DEFEATURE, (archaic) to disfigure, also DISFEATURE [v]\n",
  "DEFEATURING": "DEFEATURE, (archaic) to disfigure, also DISFEATURE [v]\n",
  "DEFECATE": "to void excrement, also DEFAECATE [v DEFECATED, DEFECATING, DEFECATES]\n",
  "DEFECATED": "DEFECATE, to void excrement, also DEFAECATE [v]\n",
  "DEFECATES": "DEFECATE, to void excrement, also DEFAECATE [v]\n",
  "DEFECATING": "DEFECATE, to void excrement, also DEFAECATE [v]\n",
  "DEFECATION": "the act of defecating, also DEFAECATION [n -S]\n",
  "DEFECATIONS": "DEFECATION, the act of defecating, also DEFAECATION [n]\n",
  "DEFECATOR": "a device for purifying e.g. sugar, also DEFAECATOR [n -S]\n",
  "DEFECATORS": "DEFECATOR, a device for purifying e.g. sugar, also DEFAECATOR [n]\n",
  "DEFECT": "to desert an allegiance [v -ED, -ING, -S]\n",
  "DEFECTED": "DEFECT, to desert an allegiance [v]\n",
  "DEFECTIBILITIES": "DEFECTIBILITY, the quality of being defectible, liable to imperfection [n]\n",
  "DEFECTIBILITY": "the quality of being defectible, liable to imperfection [n DEFECTIBILITIES]\n",
  "DEFECTIBLE": "liable to defect; imperfect [adj]\n",
  "DEFECTING": "DEFECT, to desert an allegiance [v]\n",
  "DEFECTION": "a failure to carry out a duty [n -S]\n",
  "DEFECTIONIST": "one who defects [n -S]\n",
  "DEFECTIONISTS": "DEFECTIONIST, one who defects [n]\n",
  "DEFECTIONS": "DEFECTION, a failure to carry out a duty [n]\n",
  "DEFECTIVE": "deficient [adj DEFECTIVELY] / a person who is subnormal in physical or mental powers [n -S]\n",
  "DEFECTIVELY": "DEFECTIVE, deficient [adv]\n",
  "DEFECTIVENESS": "DEFECTIVE, deficient [n]\n",
  "DEFECTIVENESSES": "DEFECTIVENESS, DEFECTIVE, deficient [n]\n",
  "DEFECTIVES": "DEFECTIVE, a person who is subnormal in physical or mental powers [n]\n",
  "DEFECTOR": "one who defects [n -S]\n",
  "DEFECTORS": "DEFECTOR, one who defects [n]\n",
  "DEFECTS": "DEFECT, to desert an allegiance [v]\n",
  "DEFEMINISATION": "the process of defeminising, also DEFEMINIZATION [n -S]\n",
  "DEFEMINISATIONS": "DEFEMINISATION, the process of defeminising, also DEFEMINIZATION [n]\n",
  "DEFEMINISE": "to remove feminine characteristics from, also DEFEMINIZE [v DEFEMINISED, DEFEMINISING, DEFEMINISES]\n",
  "DEFEMINISED": "DEFEMINISE, to remove feminine characteristics from, also DEFEMINIZE [v]\n",
  "DEFEMINISES": "DEFEMINISE, to remove feminine characteristics from, also DEFEMINIZE [v]\n",
  "DEFEMINISING": "DEFEMINISE, to remove feminine characteristics from, also DEFEMINIZE [v]\n",
  "DEFEMINIZATION": "the act of defeminizing, also DEFEMINISATION [n -S]\n",
  "DEFEMINIZATIONS": "DEFEMINIZATION, the act of defeminizing, also DEFEMINISATION [n]\n",
  "DEFEMINIZE": "to remove feminine characteristics from, also DEFEMINISE [v DEFEMINIZED, DEFEMINIZING, DEFEMINIZES]\n",
  "DEFEMINIZED": "DEFEMINIZE, to remove feminine characteristics from, also DEFEMINISE [v]\n",
  "DEFEMINIZES": "DEFEMINIZE, to remove feminine characteristics from, also DEFEMINISE [v]\n",
  "DEFEMINIZING": "DEFEMINIZE, to remove feminine characteristics from, also DEFEMINISE [v]\n",
  "DEFENCE": "protection [n -S] / to make a defence, also DEFENSE [v DEFENCED, DEFENCING, DEFENCES]\n",
  "DEFENCED": "DEFENCE, to make a defence, also DEFENSE [v]\n",
  "DEFENCELESS": "without defence [adj DEFENCELESSLY]\n",
  "DEFENCELESSLY": "DEFENCELESS, without defence [adv]\n",
  "DEFENCELESSNESS": "DEFENCELESS, without defence [n]\n",
  "DEFENCEMAN": "in ice-hockey, a player other than the goalkeeper who defends the goal, also DEFENSEMAN [n DEFENCEMEN]\n",
  "DEFENCEMEN": "DEFENCEMAN, in ice-hockey, a player other than the goalkeeper who defends the goal, also DEFENSEMAN [n]\n",
  "DEFENCES": "DEFENCE, to make a defence, also DEFENSE [v]\n",
  "DEFENCING": "DEFENCE, to make a defence, also DEFENSE [v]\n",
  "DEFEND": "to protect [v -ED, -ING, -S]\n",
  "DEFENDABLE": "capable of being defended; defensible [adj]\n",
  "DEFENDANT": "a person accused or sued [n -S]\n",
  "DEFENDANTS": "DEFENDANT, a person accused or sued [n]\n",
  "DEFENDED": "DEFEND, to protect [v]\n",
  "DEFENDER": "one who defends [n -S]\n",
  "DEFENDERS": "DEFENDER, one who defends [n]\n",
  "DEFENDING": "DEFEND, to protect [v]\n",
  "DEFENDS": "DEFEND, to protect [v]\n",
  "DEFENESTRATE": "to throw out of a window [v DEFENESTRATED, DEFENESTRATING, DEFENESTRATES]\n",
  "DEFENESTRATED": "DEFENESTRATE, to throw out of a window [v]\n",
  "DEFENESTRATES": "DEFENESTRATE, to throw out of a window [v]\n",
  "DEFENESTRATING": "DEFENESTRATE, to throw out of a window [v]\n",
  "DEFENESTRATION": "the act of throwing a thing or person out of a window [n -S]\n",
  "DEFENESTRATIONS": "DEFENESTRATION, the act of throwing a thing or person out of a window [n]\n",
  "DEFENSATIVE": "a protection [n -S]\n",
  "DEFENSATIVES": "DEFENSATIVE, a protection [n]\n",
  "DEFENSE": "to guard against a specific attack, also DEFENCE [v DEFENSED, DEFENSING, DEFENSES]\n",
  "DEFENSED": "DEFENSE, to guard against a specific attack, also DEFENCE [v]\n",
  "DEFENSELESS": "without defense [adj DEFENSELESSLY]\n",
  "DEFENSELESSLY": "DEFENSELESS, without defense [adv]\n",
  "DEFENSELESSNESS": "DEFENSELESS, without defense [n]\n",
  "DEFENSEMAN": "in ice-hockey, a player other than the goalkeeper who defends the goal, also DEFENCEMAN [n DEFENSEMEN]\n",
  "DEFENSEMEN": "DEFENSEMAN, in ice-hockey, a player other than the goalkeeper who defends the goal, also DEFENCEMAN [n]\n",
  "DEFENSES": "DEFENSE, to guard against a specific attack, also DEFENCE [v]\n",
  "DEFENSIBILITIES": "DEFENSIBILITY, the quality of being defensible [n]\n",
  "DEFENSIBILITY": "the quality of being defensible [n DEFENSIBILITIES]\n",
  "DEFENSIBLE": "that can be defended [adj DEFENSIBLY]\n",
  "DEFENSIBLENESS": "the state of being defensible [n]\n",
  "DEFENSIBLY": "DEFENSIBLE, that can be defended [adv]\n",
  "DEFENSING": "DEFENSE, to guard against a specific attack, also DEFENCE [v]\n",
  "DEFENSIVE": "tending to defend [adj DEFENSIVELY] / a state or position of defence [n -S]\n",
  "DEFENSIVELY": "DEFENSIVE, tending to defend [adv]\n",
  "DEFENSIVENESS": "DEFENSIVE, tending to defend [n]\n",
  "DEFENSIVENESSES": "DEFENSIVENESS, DEFENSIVE, tending to defend [n]\n",
  "DEFENSIVES": "DEFENSIVE, a state or position of defence [n]\n",
  "DEFER": "to postpone [v DEFERRED, DEFERRING, DEFERS]\n",
  "DEFERABLE": "that can be deferred, also DEFERRABLE [adj]\n",
  "DEFERENCE": "a deferring or yielding in judgement or opinion [n -S]\n",
  "DEFERENCES": "DEFERENCE, a deferring or yielding in judgement or opinion [n]\n",
  "DEFERENT": "an imaginary circle around the earth [n -S]\n",
  "DEFERENTIAL": "showing or expressing deference [adj DEFERENTIALLY]\n",
  "DEFERENTIALLY": "DEFERENTIAL, showing or expressing deference [adv]\n",
  "DEFERENTS": "DEFERENT, an imaginary circle around the earth [n]\n",
  "DEFERMENT": "the act of deferring [n -S]\n",
  "DEFERMENTS": "DEFERMENT, the act of deferring [n]\n",
  "DEFERRABLE": "that can be deferred, also DEFERABLE [adj] / something that can deferred [n -S]\n",
  "DEFERRABLES": "DEFERRABLE, something that can deferred [n]\n",
  "DEFERRAL": "the act of deferring [n -S]\n",
  "DEFERRALS": "DEFERRAL, the act of deferring [n]\n",
  "DEFERRED": "DEFER, to postpone [v]\n",
  "DEFERRER": "one who defers [n -S]\n",
  "DEFERRERS": "DEFERRER, one who defers [n]\n",
  "DEFERRING": "DEFER, to postpone [v]\n",
  "DEFERS": "DEFER, to postpone [v]\n",
  "DEFERVESCENCE": "an abatement of heat; a decrease of feverish symptoms, also DEFERVESCENCY [n -S]\n",
  "DEFERVESCENCES": "DEFERVESCENCE, an abatement of heat; a decrease of feverish symptoms, also DEFERVESCENCY [n]\n",
  "DEFERVESCENCIES": "DEFERVESCENCY, abatement of heat; decrease of feverish symptoms, also DEFERVESCENCE [n]\n",
  "DEFERVESCENCY": "abatement of heat; decrease of feverish symptoms, also DEFERVESCENCE [n DEFERVESCENCIES]\n",
  "DEFEUDALISE": "to deprive of feudal character, also DEFEUDALIZE [v DEFEUDALISED, DEFEUDALISING, DEFEUDALISES]\n",
  "DEFEUDALISED": "DEFEUDALISE, to deprive of feudal character, also DEFEUDALIZE [v]\n",
  "DEFEUDALISES": "DEFEUDALISE, to deprive of feudal character, also DEFEUDALIZE [v]\n",
  "DEFEUDALISING": "DEFEUDALISE, to deprive of feudal character, also DEFEUDALIZE [v]\n",
  "DEFEUDALIZE": "to deprive of feudal character, also DEFEUDALISE [v DEFEUDALIZED, DEFEUDALIZING, DEFEUDALIZES]\n",
  "DEFEUDALIZED": "DEFEUDALIZE, to deprive of feudal character, also DEFEUDALISE [v]\n",
  "DEFEUDALIZES": "DEFEUDALIZE, to deprive of feudal character, also DEFEUDALISE [v]\n",
  "DEFEUDALIZING": "DEFEUDALIZE, to deprive of feudal character, also DEFEUDALISE [v]\n",
  "DEFFER": "DEF, excellent [adj]\n",
  "DEFFEST": "DEF, excellent [adj]\n",
  "DEFFLY": "(Spenser) deftly [adj]\n",
  "DEFFO": "(colloquial) definitely, also DEFO [interj]\n",
  "DEFI": "(French) a challenge [n -S]\n",
  "DEFIANCE": "a bold opposition [n -S]\n",
  "DEFIANCES": "DEFIANCE, a bold opposition [n]\n",
  "DEFIANT": "showing defiance [adj DEFIANTLY]\n",
  "DEFIANTLY": "DEFIANT, showing defiance [adv]\n",
  "DEFIANTNESS": "the state of being defiant [n -ES]\n",
  "DEFIANTNESSES": "DEFIANTNESS, the state of being defiant [n]\n",
  "DEFIBRILLATE": "to apply a defibrillator to [v DEFIBRILLATED, DEFIBRILLATING, DEFIBRILLATES]\n",
  "DEFIBRILLATED": "DEFIBRILLATE, to apply a defibrillator to [v]\n",
  "DEFIBRILLATES": "DEFIBRILLATE, to apply a defibrillator to [v]\n",
  "DEFIBRILLATING": "DEFIBRILLATE, to apply a defibrillator to [v]\n",
  "DEFIBRILLATION": "the act of defibrillating [n -S]\n",
  "DEFIBRILLATIONS": "DEFIBRILLATION, the act of defibrillating [n]\n",
  "DEFIBRILLATOR": "an electronic device that applies an electric shock to restore the rhythm of a fibrillating heart [n -S]\n",
  "DEFIBRILLATORS": "DEFIBRILLATOR, an electronic device that applies an electric shock to restore the rhythm of a fibrillating heart [n]\n",
  "DEFIBRINATE": "to remove fibrin from blood [v DEFIBRINATED, DEFIBRINATING, DEFIBRINATES]\n",
  "DEFIBRINATED": "DEFIBRINATE, to remove fibrin from blood [v]\n",
  "DEFIBRINATES": "DEFIBRINATE, to remove fibrin from blood [v]\n",
  "DEFIBRINATING": "DEFIBRINATE, to remove fibrin from blood [v]\n",
  "DEFIBRINATION": "the act of defibrinating [n -S]\n",
  "DEFIBRINATIONS": "DEFIBRINATION, the act of defibrinating [n]\n",
  "DEFIBRINISE": "to deprive of fibrin, also DEFIBRINIZE [v DEFIBRINISED, DEFIBRINISING, DEFIBRINISES]\n",
  "DEFIBRINISED": "DEFIBRINISE, to deprive of fibrin, also DEFIBRINIZE [v]\n",
  "DEFIBRINISES": "DEFIBRINISE, to deprive of fibrin, also DEFIBRINIZE [v]\n",
  "DEFIBRINISING": "DEFIBRINISE, to deprive of fibrin, also DEFIBRINIZE [v]\n",
  "DEFIBRINIZE": "to deprive of fibrin, also DEFIBRINISE [v DEFIBRINIZED, DEFIBRINIZING, DEFIBRINIZES]\n",
  "DEFIBRINIZED": "DEFIBRINIZE, to deprive of fibrin, also DEFIBRINISE [v]\n",
  "DEFIBRINIZES": "DEFIBRINIZE, to deprive of fibrin, also DEFIBRINISE [v]\n",
  "DEFIBRINIZING": "DEFIBRINIZE, to deprive of fibrin, also DEFIBRINISE [v]\n",
  "DEFICIENCE": "a lack, shortage, also DEFICIENCY [n -S]\n",
  "DEFICIENCES": "DEFICIENCE, a lack, shortage, also DEFICIENCY [n]\n",
  "DEFICIENCIES": "DEFICIENCY, a lack, shortage, also DEFICIENCE [n]\n",
  "DEFICIENCY": "a lack, shortage, also DEFICIENCE [n DEFICIENCIES]\n",
  "DEFICIENT": "lacking [adj DEFICIENTLY] / a person who is mentally handicapped [n -S]\n",
  "DEFICIENTLY": "DEFICIENT, lacking [adv]\n",
  "DEFICIENTNESS": "DEFICIENT, lacking [n]\n",
  "DEFICIENTNESSES": "DEFICIENTNESS, DEFICIENT, lacking [n]\n",
  "DEFICIENTS": "DEFICIENT, a person who is mentally handicapped [n]\n",
  "DEFICIT": "an inadequacy or insufficiency [n -S]\n",
  "DEFICITS": "DEFICIT, an inadequacy or insufficiency [n]\n",
  "DEFIED": "DEFY, to resist openly and boldly [v]\n",
  "DEFIER": "one that defies [n -S]\n",
  "DEFIERS": "DEFIER, one that defies [n]\n",
  "DEFIES": "DEFY, to resist openly and boldly [v]\n",
  "DEFILADE": "(French) to plan a fortification so as to protect it or those in it from raking crossfire [v DEFILADED, DEFILADING, DEFILADES]\n",
  "DEFILADED": "DEFILADE, (French) to plan a fortification so as to protect it or those in it from raking crossfire [v]\n",
  "DEFILADES": "DEFILADE, (French) to plan a fortification so as to protect it or those in it from raking crossfire [v]\n",
  "DEFILADING": "DEFILADE, (French) to plan a fortification so as to protect it or those in it from raking crossfire [v]\n",
  "DEFILE": "to make dirty [v DEFILED, DEFILING, DEFILES]\n",
  "DEFILED": "DEFILE, to make dirty [v]\n",
  "DEFILEMENT": "the act of defiling [n -S]\n",
  "DEFILEMENTS": "DEFILEMENT, the act of defiling [n]\n",
  "DEFILER": "one who defiles [n -S]\n",
  "DEFILERS": "DEFILER, one who defiles [n]\n",
  "DEFILES": "DEFILE, to make dirty [v]\n",
  "DEFILIATION": "depriving a parent of a child [n -S]\n",
  "DEFILIATIONS": "DEFILIATION, depriving a parent of a child [n]\n",
  "DEFILING": "DEFILE, to make dirty [v]\n",
  "DEFINABILITIES": "DEFINABILITY, the quality of being definable [n]\n",
  "DEFINABILITY": "the quality of being definable [n DEFINABILITIES]\n",
  "DEFINABLE": "that can be defined [adj]\n",
  "DEFINABLY": "DEFINABLE, that can be defined [adv]\n",
  "DEFINE": "to state the meaning of [v DEFINED, DEFINING, DEFINES]\n",
  "DEFINED": "DEFINE, to state the meaning of [v]\n",
  "DEFINEMENT": "the act of defining [n -S]\n",
  "DEFINEMENTS": "DEFINEMENT, the act of defining [n]\n",
  "DEFINER": "one who defines [n -S]\n",
  "DEFINERS": "DEFINER, one who defines [n]\n",
  "DEFINES": "DEFINE, to state the meaning of [v]\n",
  "DEFINIENDA": "DEFINIENDUM, (Latin) a word or phrase that is to be defined in a dictionary [n]\n",
  "DEFINIENDUM": "(Latin) a word or phrase that is to be defined in a dictionary [n DEFINIENDA]\n",
  "DEFINIENS": "(Latin) a word or words used in a dictionary definition [n DEFINIENTIA]\n",
  "DEFINIENTIA": "DEFINIENS, (Latin) a word or words used in a dictionary definition [n]\n",
  "DEFINING": "DEFINE, to state the meaning of [v]\n",
  "DEFINITE": "known for certain [adj DEFINITELY] / something that is known for certain [n -S]\n",
  "DEFINITELY": "DEFINITE, known for certain [adv]\n",
  "DEFINITENESS": "the state of being definite [n -ES]\n",
  "DEFINITENESSES": "DEFINITENESS, the state of being definite [n]\n",
  "DEFINITES": "DEFINITE, something that is known for certain [n]\n",
  "DEFINITION": "an act of determining [n -S]\n",
  "DEFINITIONAL": "relating to the act of definition [adj]\n",
  "DEFINITIONS": "DEFINITION, an act of determining [n]\n",
  "DEFINITISE": "to make definite, also DEFINITIZE [v DEFINITISED, DEFINITISING, DEFINITISES]\n",
  "DEFINITISED": "DEFINITISE, to make definite, also DEFINITIZE [v]\n",
  "DEFINITISES": "DEFINITISE, to make definite, also DEFINITIZE [v]\n",
  "DEFINITISING": "DEFINITISE, to make definite, also DEFINITIZE [v]\n",
  "DEFINITIVE": "serving to define [adj DEFINITIVELY] / a definitive postage stamp [n -S]\n",
  "DEFINITIVELY": "DEFINITIVE, serving to define [adv]\n",
  "DEFINITIVENESS": "the state of being definitive [n]\n",
  "DEFINITIVES": "DEFINITIVE, a definitive postage stamp [n]\n",
  "DEFINITIZE": "to make definite, also DEFINITISE [v DEFINITIZED, DEFINITIZING, DEFINITIZES]\n",
  "DEFINITIZED": "DEFINITIZE, to make definite, also DEFINITISE [v]\n",
  "DEFINITIZES": "DEFINITIZE, to make definite, also DEFINITISE [v]\n",
  "DEFINITIZING": "DEFINITIZE, to make definite, also DEFINITISE [v]\n",
  "DEFINITUDE": "definiteness [n -S]\n",
  "DEFINITUDES": "DEFINITUDE, definiteness [n]\n",
  "DEFIS": "DEFI, (French) a challenge [n]\n",
  "DEFLAGRABILITY": "the quality of being deflagrable [n]\n",
  "DEFLAGRABLE": "which deflagrates; deflagrating readily [adj]\n",
  "DEFLAGRATE": "to burn suddenly, generally with flame and crackling noise [v DEFLAGRATED, DEFLAGRATING, DEFLAGRATES]\n",
  "DEFLAGRATED": "DEFLAGRATE, to burn suddenly, generally with flame and crackling noise [v]\n",
  "DEFLAGRATES": "DEFLAGRATE, to burn suddenly, generally with flame and crackling noise [v]\n",
  "DEFLAGRATING": "DEFLAGRATE, to burn suddenly, generally with flame and crackling noise [v]\n",
  "DEFLAGRATION": "the rapid burning away of anything in a destructive fire [n -S]\n",
  "DEFLAGRATIONS": "DEFLAGRATION, the rapid burning away of anything in a destructive fire [n]\n",
  "DEFLAGRATOR": "an apparatus for deflagration [n -S]\n",
  "DEFLAGRATORS": "DEFLAGRATOR, an apparatus for deflagration [n]\n",
  "DEFLATE": "to release the air or gas from [v DEFLATED, DEFLATING, DEFLATES]\n",
  "DEFLATED": "DEFLATE, to release the air or gas from [v]\n",
  "DEFLATER": "something that deflates, also DEFLATOR [n -S]\n",
  "DEFLATERS": "DEFLATER, something that deflates, also DEFLATOR [n]\n",
  "DEFLATES": "DEFLATE, to release the air or gas from [v]\n",
  "DEFLATING": "DEFLATE, to release the air or gas from [v]\n",
  "DEFLATION": "the act of deflating [n -S]\n",
  "DEFLATIONARY": "relating to deflation [adj]\n",
  "DEFLATIONIST": "someone who favours deflation of currency [n -S]\n",
  "DEFLATIONISTS": "DEFLATIONIST, someone who favours deflation of currency [n]\n",
  "DEFLATIONS": "DEFLATION, the act of deflating [n]\n",
  "DEFLATOR": "something that deflates, also DEFLATER [n -S]\n",
  "DEFLATORS": "DEFLATOR, something that deflates, also DEFLATER [n]\n",
  "DEFLEA": "to rid of fleas [v -ED, -ING, -S]\n",
  "DEFLEAED": "DEFLEA, to rid of fleas [v]\n",
  "DEFLEAING": "DEFLEA, to rid of fleas [v]\n",
  "DEFLEAS": "DEFLEA, to rid of fleas [v]\n",
  "DEFLECT": "to turn aside [v -ED, -ING, -S]\n",
  "DEFLECTABLE": "able to be deflected [adj]\n",
  "DEFLECTED": "DEFLECT, to turn aside [v]\n",
  "DEFLECTING": "DEFLECT, to turn aside [v]\n",
  "DEFLECTION": "an act of bending or turning away, also DEFLEXION [n -S]\n",
  "DEFLECTIONAL": "related to deflection, also DEFLEXIONAL [adj]\n",
  "DEFLECTIONS": "DEFLECTION, an act of bending or turning away, also DEFLEXION [n]\n",
  "DEFLECTIVE": "causing deflection [adj]\n",
  "DEFLECTOR": "something that deflects [n -S]\n",
  "DEFLECTORS": "DEFLECTOR, something that deflects [n]\n",
  "DEFLECTS": "DEFLECT, to turn aside [v]\n",
  "DEFLEX": "to bend down [v -ED, -ING, -ES]\n",
  "DEFLEXED": "DEFLEX, to bend down [v]\n",
  "DEFLEXES": "DEFLEX, to bend down [v]\n",
  "DEFLEXING": "DEFLEX, to bend down [v]\n",
  "DEFLEXION": "an act of bending or turning away, also DEFLECTION [n -S]\n",
  "DEFLEXIONAL": "showing deflexion, also DEFLECTIONAL [adj]\n",
  "DEFLEXIONS": "DEFLEXION, an act of bending or turning away, also DEFLECTION [n]\n",
  "DEFLEXURE": "a deflection [n -S]\n",
  "DEFLEXURES": "DEFLEXURE, a deflection [n]\n",
  "DEFLOCCULANT": "an agent that deflocculates [n -S]\n",
  "DEFLOCCULANTS": "DEFLOCCULANT, an agent that deflocculates [n]\n",
  "DEFLOCCULATE": "to deprive of flocculation [v DEFLOCCULATED, DEFLOCCULATING, DEFLOCCULATES]\n",
  "DEFLOCCULATED": "DEFLOCCULATE, to deprive of flocculation [v]\n",
  "DEFLOCCULATES": "DEFLOCCULATE, to deprive of flocculation [v]\n",
  "DEFLOCCULATING": "DEFLOCCULATE, to deprive of flocculation [v]\n",
  "DEFLOCCULATION": "the process of deflocculating [n -S]\n",
  "DEFLOCCULATIONS": "DEFLOCCULATION, the process of deflocculating [n]\n",
  "DEFLORATE": "past flowering [adj] / to deflower [v DEFLORATED, DEFLORATING, DEFLORATES]\n",
  "DEFLORATED": "DEFLORATE, to deflower [v]\n",
  "DEFLORATES": "DEFLORATE, to deflower [v]\n",
  "DEFLORATING": "DEFLORATE, to deflower [v]\n",
  "DEFLORATION": "rupture of the hymen [n -S]\n",
  "DEFLORATIONS": "DEFLORATION, rupture of the hymen [n]\n",
  "DEFLOWER": "to deprive of virginity [v -ED, -ING, -S]\n",
  "DEFLOWERED": "DEFLOWER, to deprive of virginity [v]\n",
  "DEFLOWERER": "one who deflowers [n -S]\n",
  "DEFLOWERERS": "DEFLOWERER, one who deflowers [n]\n",
  "DEFLOWERING": "DEFLOWER, to deprive of virginity [v]\n",
  "DEFLOWERS": "DEFLOWER, to deprive of virginity [v]\n",
  "DEFLUENT": "running down [adj]\n",
  "DEFLUXION": "(obsolete) a discharge or flowing of humors or fluid matter, as from the nose in catarrh [n -S]\n",
  "DEFLUXIONS": "DEFLUXION, (obsolete) a discharge or flowing of humors or fluid matter, as from the nose in catarrh [n]\n",
  "DEFO": "definitely, as an expression of agreement or consent [interj]\n",
  "DEFOAM": "to remove foam from [v -ED, -ING, -S]\n",
  "DEFOAMED": "DEFOAM, to remove foam from [v]\n",
  "DEFOAMER": "an agent used for defoaming [n -S]\n",
  "DEFOAMERS": "DEFOAMER, an agent used for defoaming [n]\n",
  "DEFOAMING": "DEFOAM, to remove foam from [v]\n",
  "DEFOAMS": "DEFOAM, to remove foam from [v]\n",
  "DEFOCUS": "to cause to go out of focus [v DEFOCUSSED or DEFOCUSED, DEFOCUSSING or DEFOCUSING, DEFOCUSSES or DEFOCUSES]\n",
  "DEFOCUSED": "DEFOCUS, to cause to go out of focus [v]\n",
  "DEFOCUSES": "DEFOCUS, to cause to go out of focus [v]\n",
  "DEFOCUSING": "DEFOCUS, to cause to go out of focus [v]\n",
  "DEFOCUSSED": "DEFOCUS, to cause to go out of focus [v]\n",
  "DEFOCUSSES": "DEFOCUS, to cause to go out of focus [v]\n",
  "DEFOCUSSING": "DEFOCUS, to cause to go out of focus [v]\n",
  "DEFOG": "to remove fog from e.g. spectacles [v DEFOGGED, DEFOGGING, DEFOGS]\n",
  "DEFOGGED": "DEFOG, to remove fog from e.g. spectacles [v]\n",
  "DEFOGGER": "an agent used for defogging [n -S]\n",
  "DEFOGGERS": "DEFOGGER, an agent used for defogging [n]\n",
  "DEFOGGING": "DEFOG, to remove fog from e.g. spectacles [v]\n",
  "DEFOGS": "DEFOG, to remove fog from e.g. spectacles [v]\n",
  "DEFOLIANT": "a chemical used to cause defoliation [n -S]\n",
  "DEFOLIANTS": "DEFOLIANT, a chemical used to cause defoliation [n]\n",
  "DEFOLIATE": "to remove the leaves from [v DEFOLIATED, DEFOLIATING, DEFOLIATES]\n",
  "DEFOLIATED": "DEFOLIATE, to remove the leaves from [v]\n",
  "DEFOLIATES": "DEFOLIATE, to remove the leaves from [v]\n",
  "DEFOLIATING": "DEFOLIATE, to remove the leaves from [v]\n",
  "DEFOLIATION": "the act of defoliating [n -S]\n",
  "DEFOLIATIONS": "DEFOLIATION, the act of defoliating [n]\n",
  "DEFOLIATOR": "a defoliating agent [n -S]\n",
  "DEFOLIATORS": "DEFOLIATOR, a defoliating agent [n]\n",
  "DEFORCE": "to withhold by force [v DEFORCED, DEFORCING, DEFORCES]\n",
  "DEFORCED": "DEFORCE, to withhold by force [v]\n",
  "DEFORCEMENT": "the act of deforcing [n -S]\n",
  "DEFORCEMENTS": "DEFORCEMENT, the act of deforcing [n]\n",
  "DEFORCER": "one who deforces, keeps out of possession by force [n -S]\n",
  "DEFORCERS": "DEFORCER, one who deforces, keeps out of possession by force [n]\n",
  "DEFORCES": "DEFORCE, to withhold by force [v]\n",
  "DEFORCIANT": "one who keeps out of possession the rightful owner of an estate [n -S]\n",
  "DEFORCIANTS": "DEFORCIANT, one who keeps out of possession the rightful owner of an estate [n]\n",
  "DEFORCIATION": "(obsolete) a legal distress [n -S]\n",
  "DEFORCIATIONS": "DEFORCIATION, (obsolete) a legal distress [n]\n",
  "DEFORCING": "DEFORCE, to withhold by force [v]\n",
  "DEFOREST": "to remove the trees from an area [v -ED, -ING, -S]\n",
  "DEFORESTATION": "the act of clearing forests [n -S]\n",
  "DEFORESTATIONS": "DEFORESTATION, the act of clearing forests [n]\n",
  "DEFORESTED": "DEFOREST, to remove the trees from an area [v]\n",
  "DEFORESTER": "one who deforests [n -S]\n",
  "DEFORESTERS": "DEFORESTER, one who deforests [n]\n",
  "DEFORESTING": "DEFOREST, to remove the trees from an area [v]\n",
  "DEFORESTS": "DEFOREST, to remove the trees from an area [v]\n",
  "DEFORM": "to spoil the form of [v -ED, -ING, -S]\n",
  "DEFORMABILITIES": "DEFORMABILITY, the quality of being deformable [n]\n",
  "DEFORMABILITY": "the quality of being deformable [n DEFORMABILITIES]\n",
  "DEFORMABLE": "able to be deformed [adj]\n",
  "DEFORMALISE": "to make less formal, also DEFORMALIZE [v DEFORMALISED, DEFORMALISING, DEFORMALISES]\n",
  "DEFORMALISED": "DEFORMALISE, to make less formal, also DEFORMALIZE [v]\n",
  "DEFORMALISES": "DEFORMALISE, to make less formal, also DEFORMALIZE [v]\n",
  "DEFORMALISING": "DEFORMALISE, to make less formal, also DEFORMALIZE [v]\n",
  "DEFORMALIZE": "to make less formal, also DEFORMALISE [v DEFORMALIZED, DEFORMALIZING, DEFORMALIZES]\n",
  "DEFORMALIZED": "DEFORMALIZE, to make less formal, also DEFORMALISE [v]\n",
  "DEFORMALIZES": "DEFORMALIZE, to make less formal, also DEFORMALISE [v]\n",
  "DEFORMALIZING": "DEFORMALIZE, to make less formal, also DEFORMALISE [v]\n",
  "DEFORMATION": "alteration of form or shape [n -S]\n",
  "DEFORMATIONAL": "relating to deformation [adj]\n",
  "DEFORMATIONS": "DEFORMATION, alteration of form or shape [n]\n",
  "DEFORMATIVE": "tending to deform [adj]\n",
  "DEFORMED": "DEFORM, to spoil the form of [v]\n",
  "DEFORMEDLY": "DEFORMED, DEFORM, to spoil the form of [adv]\n",
  "DEFORMEDNESS": "the state of being deformed [n -ES]\n",
  "DEFORMEDNESSES": "DEFORMEDNESS, the state of being deformed [n]\n",
  "DEFORMER": "one who deforms [n -S]\n",
  "DEFORMERS": "DEFORMER, one who deforms [n]\n",
  "DEFORMING": "DEFORM, to spoil the form of [v]\n",
  "DEFORMITIES": "DEFORMITY, the state of being deformed [n]\n",
  "DEFORMITY": "the state of being deformed [n DEFORMITIES]\n",
  "DEFORMS": "DEFORM, to spoil the form of [v]\n",
  "DEFOUL": "(obsolete) to befoul, defile [v -ED, -ING, -S]\n",
  "DEFOULED": "DEFOUL, (obsolete) to befoul, defile [v]\n",
  "DEFOULING": "DEFOUL, (obsolete) to befoul, defile [v]\n",
  "DEFOULS": "DEFOUL, (obsolete) to befoul, defile [v]\n",
  "DEFRAG": "to defragment (to reorganize computer files into contiguous blocks) [v DEFRAGGED, DEFRAGGING, DEFRAGS]\n",
  "DEFRAGGED": "DEFRAG, to defragment (to reorganize computer files into contiguous blocks) [v]\n",
  "DEFRAGGER": "one who defrags [n -S]\n",
  "DEFRAGGERS": "DEFRAGGER, one who defrags [n]\n",
  "DEFRAGGING": "in computing, the process of moving files adjacently on a hard disc [n -S]\n",
  "DEFRAGGINGS": "DEFRAGGING, in computing, the process of moving files adjacently on a hard disc [n]\n",
  "DEFRAGMENT": "to run a program which reduces or eliminates the fragmentation of (a file or disk) by bringing together parts of files stored in separate locations to a single location on the disk [v -ED, -ING, -S]\n",
  "DEFRAGMENTED": "DEFRAGMENT, to run a program which reduces or eliminates the fragmentation of (a file or disk) by bringing together parts of files stored in separate locations to a single location on the disk [v]\n",
  "DEFRAGMENTING": "DEFRAGMENT, to run a program which reduces or eliminates the fragmentation of (a file or disk) by bringing together parts of files stored in separate locations to a single location on the disk [v]\n",
  "DEFRAGMENTS": "DEFRAGMENT, to run a program which reduces or eliminates the fragmentation of (a file or disk) by bringing together parts of files stored in separate locations to a single location on the disk [v]\n",
  "DEFRAGS": "DEFRAG, to defragment (to reorganize computer files into contiguous blocks) [v]\n",
  "DEFRAUD": "to swindle [v -ED, -ING, -S]\n",
  "DEFRAUDATION": "the act of defrauding [n -S]\n",
  "DEFRAUDATIONS": "DEFRAUDATION, the act of defrauding [n]\n",
  "DEFRAUDED": "DEFRAUD, to swindle [v]\n",
  "DEFRAUDER": "one who defrauds [n -S]\n",
  "DEFRAUDERS": "DEFRAUDER, one who defrauds [n]\n",
  "DEFRAUDING": "DEFRAUD, to swindle [v]\n",
  "DEFRAUDMENT": "the act of defrauding [n -S]\n",
  "DEFRAUDMENTS": "DEFRAUDMENT, the act of defrauding [n]\n",
  "DEFRAUDS": "DEFRAUD, to swindle [v]\n",
  "DEFRAY": "to pay or settle [v -ED, -ING, -S]\n",
  "DEFRAYABLE": "that can be defrayed [adj]\n",
  "DEFRAYAL": "the payment of charges, also DEFRAYMENT [n -S]\n",
  "DEFRAYALS": "DEFRAYAL, the payment of charges, also DEFRAYMENT [n]\n",
  "DEFRAYED": "DEFRAY, to pay or settle [v]\n",
  "DEFRAYER": "one who pays off expenses [n -S]\n",
  "DEFRAYERS": "DEFRAYER, one who pays off expenses [n]\n",
  "DEFRAYING": "DEFRAY, to pay or settle [v]\n",
  "DEFRAYMENT": "the payment of charges, also DEFRAYAL [n -S]\n",
  "DEFRAYMENTS": "DEFRAYMENT, the payment of charges, also DEFRAYAL [n]\n",
  "DEFRAYS": "DEFRAY, to pay or settle [v]\n",
  "DEFREEZE": "to thaw out, defrost [v DEFROZE, DEFROZEN, DEFREEZING, DEFREEZES]\n",
  "DEFREEZES": "DEFREEZE, to thaw out, defrost [v]\n",
  "DEFREEZING": "DEFREEZE, to thaw out, defrost [v]\n",
  "DEFRIEND": "to remove someone from one's list of friends on a social networking site [v -ED, -ING, -S]\n",
  "DEFRIENDED": "DEFRIEND, to remove someone from one's list of friends on a social networking site [v]\n",
  "DEFRIENDING": "DEFRIEND, to remove someone from one's list of friends on a social networking site [v]\n",
  "DEFRIENDS": "DEFRIEND, to remove someone from one's list of friends on a social networking site [v]\n",
  "DEFROCK": "to deprive of priestly frock or ecclesiastical rank, also UNFROCK [v -ED, -ING, -S]\n",
  "DEFROCKED": "DEFROCK, to deprive of priestly frock or ecclesiastical rank, also UNFROCK [v]\n",
  "DEFROCKING": "DEFROCK, to deprive of priestly frock or ecclesiastical rank, also UNFROCK [v]\n",
  "DEFROCKS": "DEFROCK, to deprive of priestly frock or ecclesiastical rank, also UNFROCK [v]\n",
  "DEFROST": "to remove frost from [v -ED, -ING, -S]\n",
  "DEFROSTED": "DEFROST, to remove frost from [v]\n",
  "DEFROSTER": "something that defrosts [n -S]\n",
  "DEFROSTERS": "DEFROSTER, something that defrosts [n]\n",
  "DEFROSTING": "the act of removing frost from [n -S]\n",
  "DEFROSTINGS": "DEFROSTING, the act of removing frost from [n]\n",
  "DEFROSTS": "DEFROST, to remove frost from [v]\n",
  "DEFROZE": "DEFREEZE, to thaw out, defrost [v]\n",
  "DEFROZEN": "DEFREEZE, to thaw out, defrost [v]\n",
  "DEFT": "skilful [adj DEFTER, DEFTEST, DEFTLY]\n",
  "DEFTER": "DEFT, skilful [adj]\n",
  "DEFTEST": "DEFT, skilful [adj]\n",
  "DEFTLY": "DEFT, skilful [adv]\n",
  "DEFTNESS": "the quality of being deft [n -ES]\n",
  "DEFTNESSES": "DEFTNESS, the quality of being deft [n]\n",
  "DEFUEL": "to remove fuel from [v DEFUELLED or DEFUELED, DEFUELLING or DEFUELING, DEFUELS]\n",
  "DEFUELED": "DEFUEL, to remove fuel from [v]\n",
  "DEFUELING": "DEFUEL, to remove fuel from [v]\n",
  "DEFUELLED": "DEFUEL, to remove fuel from [v]\n",
  "DEFUELLING": "DEFUEL, to remove fuel from [v]\n",
  "DEFUELS": "DEFUEL, to remove fuel from [v]\n",
  "DEFUNCT": "dead [adj] / a dead person [n -S]\n",
  "DEFUNCTION": "(Shakespeare) death [n -S]\n",
  "DEFUNCTIONS": "DEFUNCTION, (Shakespeare) death [n]\n",
  "DEFUNCTIVE": "relating to the dead [adj]\n",
  "DEFUNCTNESS": "the state of being defunct [n -ES]\n",
  "DEFUNCTNESSES": "DEFUNCTNESS, the state of being defunct [n]\n",
  "DEFUNCTS": "DEFUNCT, a dead person [n]\n",
  "DEFUND": "to remove funding from [v -ED, -ING, -S]\n",
  "DEFUNDED": "DEFUND, to remove funding from [v]\n",
  "DEFUNDING": "DEFUND, to remove funding from [v]\n",
  "DEFUNDS": "DEFUND, to remove funding from [v]\n",
  "DEFUSE": "to remove the fuse from, also DEFUZE [v DEFUSED, DEFUSING, DEFUSES]\n",
  "DEFUSED": "DEFUSE, to remove the fuse from, also DEFUZE [v]\n",
  "DEFUSER": "one who defuses [n -S]\n",
  "DEFUSERS": "DEFUSER, one who defuses [n]\n",
  "DEFUSES": "DEFUSE, to remove the fuse from, also DEFUZE [v]\n",
  "DEFUSING": "DEFUSE, to remove the fuse from, also DEFUZE [v]\n",
  "DEFUZE": "to remove the fuse from, also DEFUSE [v DEFUZED, DEFUZING, DEFUZES]\n",
  "DEFUZED": "DEFUZE, to remove the fuse from, also DEFUSE [v]\n",
  "DEFUZES": "DEFUZE, to remove the fuse from, also DEFUSE [v]\n",
  "DEFUZING": "DEFUZE, to remove the fuse from, also DEFUSE [v]\n",
  "DEFY": "to resist openly and boldly [v DEFIED, DEFYING, DEFIES]\n",
  "DEFYING": "DEFY, to resist openly and boldly [v]\n",
  "DEG": "(dialect) to water (e.g. a plant) [v DEGGED, DEGGING, DEGS]\n",
  "DEGAGE": "(French) unconstrained, easy; uninvolved [adj]\n",
  "DEGAME": "a tropical tree, lemonwood, also DEGAMI [n -S]\n",
  "DEGAMES": "DEGAME, a tropical tree, lemonwood, also DEGAMI [n]\n",
  "DEGAMI": "a tropical tree, lemonwood, also DEGAME [n -S]\n",
  "DEGAMIS": "DEGAMI, a tropical tree, lemonwood, also DEGAME [n]\n",
  "DEGARNISH": "to despoil, also DISGARNISH [v -ED, -ING, -ES]\n",
  "DEGARNISHED": "DEGARNISH, to despoil, also DISGARNISH [v]\n",
  "DEGARNISHES": "DEGARNISH, to despoil, also DISGARNISH [v]\n",
  "DEGARNISHING": "DEGARNISH, to despoil, also DISGARNISH [v]\n",
  "DEGAS": "to remove gas from [v DEGASSED, DEGASSING, DEGASSES or DEGASES]\n",
  "DEGASES": "DEGAS, to remove gas from [v]\n",
  "DEGASSED": "DEGAS, to remove gas from [v]\n",
  "DEGASSER": "an agent used for degassing [n -S]\n",
  "DEGASSERS": "DEGASSER, an agent used for degassing [n]\n",
  "DEGASSES": "DEGAS, to remove gas from [v]\n",
  "DEGASSING": "DEGAS, to remove gas from [v]\n",
  "DEGAUSS": "to demagnetize [v -ED, -ING, -ES]\n",
  "DEGAUSSED": "DEGAUSS, to demagnetize [v]\n",
  "DEGAUSSER": "a device for nullifying a magnetic field [n -S]\n",
  "DEGAUSSERS": "DEGAUSSER, a device for nullifying a magnetic field [n]\n",
  "DEGAUSSES": "DEGAUSS, to demagnetize [v]\n",
  "DEGAUSSING": "the act of neutralizing the magnetic field of (a ship esp as a protection against magnetic mines) [n -S]\n",
  "DEGAUSSINGS": "DEGAUSSING, the act of neutralizing the magnetic field of (a ship esp as a protection against magnetic mines) [n]\n",
  "DEGEARING": "a process in which a company replaces some or all of its fixed interest loan stock with ordinary shares [n -S]\n",
  "DEGEARINGS": "DEGEARING, a process in which a company replaces some or all of its fixed interest loan stock with ordinary shares [n]\n",
  "DEGENDER": "(Spenser) to degenerate [v -ED, -ING, -S]\n",
  "DEGENDERED": "DEGENDER, (Spenser) to degenerate [v]\n",
  "DEGENDERING": "DEGENDER, (Spenser) to degenerate [v]\n",
  "DEGENDERS": "DEGENDER, (Spenser) to degenerate [v]\n",
  "DEGENERACIES": "DEGENERACY, the state of being degenerate [n]\n",
  "DEGENERACY": "the state of being degenerate [n DEGENERACIES]\n",
  "DEGENERATE": "base, immoral [adj DEGENERATELY] / to pass from a higher to a lower type or condition [v DEGENERATED, DEGENERATING, DEGENERATES]\n",
  "DEGENERATED": "DEGENERATE, to pass from a higher to a lower type or condition [v]\n",
  "DEGENERATELY": "DEGENERATE, base, immoral [adv]\n",
  "DEGENERATENESS": "the state of being degenerate [n]\n",
  "DEGENERATES": "DEGENERATE, to pass from a higher to a lower type or condition [v]\n",
  "DEGENERATING": "DEGENERATE, to pass from a higher to a lower type or condition [v]\n",
  "DEGENERATION": "the act of degenerating [n -S]\n",
  "DEGENERATIONIST": "someone who believes that the tendency of man is not to improve, but to degenerate [n]\n",
  "DEGENERATIONS": "DEGENERATION, the act of degenerating [n]\n",
  "DEGENERATIVE": "of, relating to, involving, or causing degeneration [adj]\n",
  "DEGENEROUS": "(obsolete) degenerate; base [adj]\n",
  "DEGERM": "to remove germs from [v -ED, -ING, -S]\n",
  "DEGERMED": "DEGERM, to remove germs from [v]\n",
  "DEGERMING": "DEGERM, to remove germs from [v]\n",
  "DEGERMS": "DEGERM, to remove germs from [v]\n",
  "DEGGED": "DEG, (dialect) to water (e.g. a plant) [v]\n",
  "DEGGING": "DEG, (dialect) to water (e.g. a plant) [v]\n",
  "DEGLACIATED": "showing deglaciation, the melting of ice due to the retreat of a glacier [adj]\n",
  "DEGLACIATION": "the melting of ice due to the retreat of a glacier [n -S]\n",
  "DEGLACIATIONS": "DEGLACIATION, the melting of ice due to the retreat of a glacier [n]\n",
  "DEGLAMORISATION": "the process of deglamorising, also DEGLAMORIZATION [n]\n",
  "DEGLAMORISE": "to remove the glamour from, also DEGLAMORIZE [v DEGLAMORISED, DEGLAMORISING, DEGLAMORISES]\n",
  "DEGLAMORISED": "DEGLAMORISE, to remove the glamour from, also DEGLAMORIZE [v]\n",
  "DEGLAMORISES": "DEGLAMORISE, to remove the glamour from, also DEGLAMORIZE [v]\n",
  "DEGLAMORISING": "DEGLAMORISE, to remove the glamour from, also DEGLAMORIZE [v]\n",
  "DEGLAMORIZATION": "the act of deglamorizing, also DEGLAMORISATION [n]\n",
  "DEGLAMORIZE": "to remove the glamour from, also DEGLAMORISE [v DEGLAMORIZED, DEGLAMORIZING, DEGLAMORIZES]\n",
  "DEGLAMORIZED": "DEGLAMORIZE, to remove the glamour from, also DEGLAMORISE [v]\n",
  "DEGLAMORIZES": "DEGLAMORIZE, to remove the glamour from, also DEGLAMORISE [v]\n",
  "DEGLAMORIZING": "DEGLAMORIZE, to remove the glamour from, also DEGLAMORISE [v]\n",
  "DEGLAZE": "to remove the glaze from [v DEGLAZED, DEGLAZING, DEGLAZES]\n",
  "DEGLAZED": "DEGLAZE, to remove the glaze from [v]\n",
  "DEGLAZES": "DEGLAZE, to remove the glaze from [v]\n",
  "DEGLAZING": "DEGLAZE, to remove the glaze from [v]\n",
  "DEGLUTINATE": "to unglue or unstick [v DEGLUTINATED, DEGLUTINATING, DEGLUTINATES]\n",
  "DEGLUTINATED": "DEGLUTINATE, to unglue or unstick [v]\n",
  "DEGLUTINATES": "DEGLUTINATE, to unglue or unstick [v]\n",
  "DEGLUTINATING": "DEGLUTINATE, to unglue or unstick [v]\n",
  "DEGLUTINATION": "the removal of gluten [n -S]\n",
  "DEGLUTINATIONS": "DEGLUTINATION, the removal of gluten [n]\n",
  "DEGLUTITION": "the power or act of swallowing [n -S]\n",
  "DEGLUTITIONS": "DEGLUTITION, the power or act of swallowing [n]\n",
  "DEGLUTITIVE": "relating to deglutition, also DEGLUTITORY [adj]\n",
  "DEGLUTITORY": "relating to deglutition, also DEGLUTITIVE [adj]\n",
  "DEGOUT": "(French) to make (something) into drops [v -ED, -ING, -S]\n",
  "DEGOUTED": "DEGOUT, (French) to make (something) into drops [v]\n",
  "DEGOUTING": "DEGOUT, (French) to make (something) into drops [v]\n",
  "DEGOUTS": "DEGOUT, (French) to make (something) into drops [v]\n",
  "DEGRADABILITIES": "DEGRADABILITY, the quality of being degradable [n]\n",
  "DEGRADABILITY": "the quality of being degradable [n DEGRADABILITIES]\n",
  "DEGRADABLE": "capable of being chemically degraded [adj]\n",
  "DEGRADATION": "the act of degrading [n -S]\n",
  "DEGRADATIONS": "DEGRADATION, the act of degrading [n]\n",
  "DEGRADATIVE": "of the nature of degradation [adj]\n",
  "DEGRADE": "to debase, also DISGRADE [v DEGRADED, DEGRADING, DEGRADES]\n",
  "DEGRADED": "DEGRADE, to debase, also DISGRADE [v]\n",
  "DEGRADEDLY": "DEGRADED, DEGRADE, to debase, also DISGRADE [adv]\n",
  "DEGRADER": "one that degrades [n -S]\n",
  "DEGRADERS": "DEGRADER, one that degrades [n]\n",
  "DEGRADES": "DEGRADE, to debase, also DISGRADE [v]\n",
  "DEGRADING": "DEGRADE, to debase, also DISGRADE [v]\n",
  "DEGRADINGLY": "DEGRADING, DEGRADE, to debase, also DISGRADE [adv]\n",
  "DEGRADINGNESS": "the state of being degrading [n -ES]\n",
  "DEGRADINGNESSES": "DEGRADINGNESS, the state of being degrading [n]\n",
  "DEGRANULATION": "the process of losing granules [n -S]\n",
  "DEGRANULATIONS": "DEGRANULATION, the process of losing granules [n]\n",
  "DEGRAS": "(French) a fat obtained from sheepskins [n DEGRAS]\n",
  "DEGREASANT": "a substance which removes grease [n -S]\n",
  "DEGREASANTS": "DEGREASANT, a substance which removes grease [n]\n",
  "DEGREASE": "to remove the grease from [v DEGREASED, DEGREASING, DEGREASES]\n",
  "DEGREASED": "DEGREASE, to remove the grease from [v]\n",
  "DEGREASER": "a substance that removes grease [n -S]\n",
  "DEGREASERS": "DEGREASER, a substance that removes grease [n]\n",
  "DEGREASES": "DEGREASE, to remove the grease from [v]\n",
  "DEGREASING": "the act of removing the grease from [n -S]\n",
  "DEGREASINGS": "DEGREASING, the act of removing the grease from [n]\n",
  "DEGREE": "a graduation on a scale [n -S]\n",
  "DEGREED": "having a degree [adj]\n",
  "DEGREELESS": "without a degree [adj]\n",
  "DEGREES": "DEGREE, a graduation on a scale [n]\n",
  "DEGRESSION": "a gradual decrease; a reduction in taxes [n -S]\n",
  "DEGRESSIONS": "DEGRESSION, a gradual decrease; a reduction in taxes [n]\n",
  "DEGRESSIVE": "showing degression, a gradual decrease, a reduction in taxes [adj DEGRESSIVELY]\n",
  "DEGRESSIVELY": "DEGRESSIVE, showing degression, a gradual decrease, a reduction in taxes [adv]\n",
  "DEGRINGOLADE": "(French) to make a rapid descent [v DEGRINGOLADED, DEGRINGOLADING, DEGRINGOLADES]\n",
  "DEGRINGOLADED": "DEGRINGOLADE, (French) to make a rapid descent [v]\n",
  "DEGRINGOLADES": "DEGRINGOLADE, (French) to make a rapid descent [v]\n",
  "DEGRINGOLADING": "DEGRINGOLADE, (French) to make a rapid descent [v]\n",
  "DEGRINGOLER": "to descend rapidly or steeply; to decline, fail [v -ED, -ING, -S]\n",
  "DEGRINGOLERED": "DEGRINGOLER, to descend rapidly or steeply; to decline, fail [v]\n",
  "DEGRINGOLERING": "DEGRINGOLER, to descend rapidly or steeply; to decline, fail [v]\n",
  "DEGRINGOLERS": "DEGRINGOLER, to descend rapidly or steeply; to decline, fail [v]\n",
  "DEGS": "DEG, (dialect) to water (e.g. a plant) [v]\n",
  "DEGU": "a small rodent native to Chile, aka Brush-Tailed Rat [n -S]\n",
  "DEGUM": "to free from gum [v DEGUMMED, DEGUMMING, DEGUMS]\n",
  "DEGUMMED": "DEGUM, to free from gum [v]\n",
  "DEGUMMING": "DEGUM, to free from gum [v]\n",
  "DEGUMS": "DEGUM, to free from gum [v]\n",
  "DEGUS": "DEGU, a small rodent native to Chile, aka Brush-Tailed Rat [n]\n",
  "DEGUST": "to taste with pleasure [v -ED, -ING, -S]\n",
  "DEGUSTATE": "to taste, relish, also DEGUST [v DEGUSTATED, DEGUSTATING, DEGUSTATES]\n",
  "DEGUSTATED": "DEGUSTATE, to taste, relish, also DEGUST [v]\n",
  "DEGUSTATES": "DEGUSTATE, to taste, relish, also DEGUST [v]\n",
  "DEGUSTATING": "DEGUSTATE, to taste, relish, also DEGUST [v]\n",
  "DEGUSTATION": "the action or an instance of tasting esp. in a series of small portions [n -S]\n",
  "DEGUSTATIONS": "DEGUSTATION, the action or an instance of tasting esp. in a series of small portions [n]\n",
  "DEGUSTATORY": "relating to degustation [adj]\n",
  "DEGUSTED": "DEGUST, to taste with pleasure [v]\n",
  "DEGUSTING": "DEGUST, to taste with pleasure [v]\n",
  "DEGUSTS": "DEGUST, to taste with pleasure [v]\n",
  "DEHAIR": "to remove the hair from [v -ED, -ING, -S]\n",
  "DEHAIRED": "DEHAIR, to remove the hair from [v]\n",
  "DEHAIRING": "DEHAIR, to remove the hair from [v]\n",
  "DEHAIRS": "DEHAIR, to remove the hair from [v]\n",
  "DEHISCE": "to split open [v DEHISCED, DEHISCING, DEHISCES]\n",
  "DEHISCED": "DEHISCE, to split open [v]\n",
  "DEHISCENCE": "the act of gaping [n -S]\n",
  "DEHISCENCES": "DEHISCENCE, the act of gaping [n]\n",
  "DEHISCENT": "gaping, bursting open, as the capsule of a plant [adj]\n",
  "DEHISCES": "DEHISCE, to split open [v]\n",
  "DEHISCING": "DEHISCE, to split open [v]\n",
  "DEHORN": "to deprive of horns [v -ED, -ING, -S]\n",
  "DEHORNED": "DEHORN, to deprive of horns [v]\n",
  "DEHORNER": "an implement for removing the horns from cattle [n -S]\n",
  "DEHORNERS": "DEHORNER, an implement for removing the horns from cattle [n]\n",
  "DEHORNING": "DEHORN, to deprive of horns [v]\n",
  "DEHORNS": "DEHORN, to deprive of horns [v]\n",
  "DEHORS": "other than [prep]\n",
  "DEHORT": "to dissuade [v -ED, -ING, -S]\n",
  "DEHORTATION": "advice against something, dissuasion [n -S]\n",
  "DEHORTATIONS": "DEHORTATION, advice against something, dissuasion [n]\n",
  "DEHORTATIVE": "dissuasive, also DEHORTATORY [adj]\n",
  "DEHORTATORY": "dissuasive, also DEHORTATIVE [adj]\n",
  "DEHORTED": "DEHORT, to dissuade [v]\n",
  "DEHORTER": "a dissuader; an adviser to the contrary [n -S]\n",
  "DEHORTERS": "DEHORTER, a dissuader; an adviser to the contrary [n]\n",
  "DEHORTING": "DEHORT, to dissuade [v]\n",
  "DEHORTS": "DEHORT, to dissuade [v]\n",
  "DEHUMANISATION": "the process of dehumanising, also DEHUMANIZATION [n -S]\n",
  "DEHUMANISATIONS": "DEHUMANISATION, the process of dehumanising, also DEHUMANIZATION [n]\n",
  "DEHUMANISE": "to remove the humanity from, also DEHUMANIZE [v DEHUMANISED, DEHUMANISING, DEHUMANISES]\n",
  "DEHUMANISED": "DEHUMANISE, to remove the humanity from, also DEHUMANIZE [v]\n",
  "DEHUMANISES": "DEHUMANISE, to remove the humanity from, also DEHUMANIZE [v]\n",
  "DEHUMANISING": "DEHUMANISE, to remove the humanity from, also DEHUMANIZE [v]\n",
  "DEHUMANIZATION": "the act of dehumanizing, also DEHUMANISATION [n -S]\n",
  "DEHUMANIZATIONS": "DEHUMANIZATION, the act of dehumanizing, also DEHUMANISATION [n]\n",
  "DEHUMANIZE": "to deprive of human qualities, also DEHUMANISE [v DEHUMANIZED, DEHUMANIZING, DEHUMANIZES]\n",
  "DEHUMANIZED": "DEHUMANIZE, to deprive of human qualities, also DEHUMANISE [v]\n",
  "DEHUMANIZES": "DEHUMANIZE, to deprive of human qualities, also DEHUMANISE [v]\n",
  "DEHUMANIZING": "DEHUMANIZE, to deprive of human qualities, also DEHUMANISE [v]\n",
  "DEHUMIDIFIED": "DEHUMIDIFY, to remove moisture from (as air) [v]\n",
  "DEHUMIDIFIER": "an apparatus for reducing humidity [n -S]\n",
  "DEHUMIDIFIERS": "DEHUMIDIFIER, an apparatus for reducing humidity [n]\n",
  "DEHUMIDIFIES": "DEHUMIDIFY, to remove moisture from (as air) [v]\n",
  "DEHUMIDIFY": "to remove moisture from (as air) [v DEHUMIDIFIED, DEHUMIDIFYING, DEHUMIDIFIES]\n",
  "DEHUMIDIFYING": "DEHUMIDIFY, to remove moisture from (as air) [v]\n",
  "DEHYDRATE": "to dry out, remove the water from [v DEHYDRATED, DEHYDRATING, DEHYDRATES]\n",
  "DEHYDRATED": "DEHYDRATE, to dry out, remove the water from [v]\n",
  "DEHYDRATER": "a dehydrating agent, also DEHYDRATOR [n -S]\n",
  "DEHYDRATERS": "DEHYDRATER, a dehydrating agent, also DEHYDRATOR [n]\n",
  "DEHYDRATES": "DEHYDRATE, to dry out, remove the water from [v]\n",
  "DEHYDRATING": "DEHYDRATE, to dry out, remove the water from [v]\n",
  "DEHYDRATION": "loss or withdrawal of moisture [n -S]\n",
  "DEHYDRATIONS": "DEHYDRATION, loss or withdrawal of moisture [n]\n",
  "DEHYDRATOR": "a dehydrating agent, also DEHYDRATER [n -S]\n",
  "DEHYDRATORS": "DEHYDRATOR, a dehydrating agent, also DEHYDRATER [n]\n",
  "DEHYDROGENASE": "an enzyme that accelerates the removal of hydrogen from metabolites and its transfer to other substances [n -S]\n",
  "DEHYDROGENASES": "DEHYDROGENASE, an enzyme that accelerates the removal of hydrogen from metabolites and its transfer to other substances [n]\n",
  "DEHYDROGENATE": "to remove the hydrogen from [v DEHYDROGENATED, DEHYDROGENATING, DEHYDROGENATES]\n",
  "DEHYDROGENATED": "DEHYDROGENATE, to remove the hydrogen from [v]\n",
  "DEHYDROGENATES": "DEHYDROGENATE, to remove the hydrogen from [v]\n",
  "DEHYDROGENATING": "DEHYDROGENATE, to remove the hydrogen from [v]\n",
  "DEHYDROGENATION": "the removal of hydrogen from a chemical compound [n]\n",
  "DEHYDROGENISE": "to remove hydrogen from, also DEHYDROGENIZE [v DEHYDROGENISED, DEHYDROGENISING, DEHYDROGENISES]\n",
  "DEHYDROGENISED": "DEHYDROGENISE, to remove hydrogen from, also DEHYDROGENIZE [v]\n",
  "DEHYDROGENISES": "DEHYDROGENISE, to remove hydrogen from, also DEHYDROGENIZE [v]\n",
  "DEHYDROGENISING": "DEHYDROGENISE, to remove hydrogen from, also DEHYDROGENIZE [v]\n",
  "DEHYDROGENIZE": "to remove the hydrogen from, also DEHYDROGENISE [v DEHYDROGENIZED, DEHYDROGENIZING, DEHYDROGENIZES]\n",
  "DEHYDROGENIZED": "DEHYDROGENIZE, to remove the hydrogen from, also DEHYDROGENISE [v]\n",
  "DEHYDROGENIZES": "DEHYDROGENIZE, to remove the hydrogen from, also DEHYDROGENISE [v]\n",
  "DEHYDROGENIZING": "DEHYDROGENIZE, to remove the hydrogen from, also DEHYDROGENISE [v]\n",
  "DEHYDRORETINOL": "vitamin A2 [n -S]\n",
  "DEHYDRORETINOLS": "DEHYDRORETINOL, vitamin A2 [n]\n",
  "DEHYPNOTISATION": "the process of dehypnotising, also DEHYPNOTIZATION [n]\n",
  "DEHYPNOTISE": "to free from hypnosis, also DEHYPNOTIZE [v DEHYPNOTISED, DEHYPNOTISING, DEHYPNOTISES]\n",
  "DEHYPNOTISED": "DEHYPNOTISE, to free from hypnosis, also DEHYPNOTIZE [v]\n",
  "DEHYPNOTISES": "DEHYPNOTISE, to free from hypnosis, also DEHYPNOTIZE [v]\n",
  "DEHYPNOTISING": "DEHYPNOTISE, to free from hypnosis, also DEHYPNOTIZE [v]\n",
  "DEHYPNOTIZATION": "the process of dehypnotizing, also DEHYPNOTISATION [n]\n",
  "DEHYPNOTIZE": "to free from hypnosis, also DEHYPNOTISE [v DEHYPNOTIZED, DEHYPNOTIZING, DEHYPNOTIZES]\n",
  "DEHYPNOTIZED": "DEHYPNOTIZE, to free from hypnosis, also DEHYPNOTISE [v]\n",
  "DEHYPNOTIZES": "DEHYPNOTIZE, to free from hypnosis, also DEHYPNOTISE [v]\n",
  "DEHYPNOTIZING": "DEHYPNOTIZE, to free from hypnosis, also DEHYPNOTISE [v]\n",
  "DEI": "DEUS, (Latin) god [n]\n",
  "DEICE": "to free of ice [v DEICED, DEICING, DEICES]\n",
  "DEICED": "DEICE, to free of ice [v]\n",
  "DEICER": "one that deices [n -S]\n",
  "DEICERS": "DEICER, one that deices [n]\n",
  "DEICES": "DEICE, to free of ice [v]\n",
  "DEICIDAL": "relating to deicide, the killing of a god [adj]\n",
  "DEICIDE": "the killing of a god [n -S]\n",
  "DEICIDES": "DEICIDE, the killing of a god [n]\n",
  "DEICING": "DEICE, to free of ice [v]\n",
  "DEICTIC": "relating to the time and place of utterance [adj DEICTICALLY] / a deictic word [n -S]\n",
  "DEICTICALLY": "DEICTIC, relating to the time and place of utterance [adv]\n",
  "DEICTICS": "DEICTIC, a deictic word [n]\n",
  "DEID": "(Scots) death [n -S] / dead [adj DEIDER, DEIDEST]\n",
  "DEIDER": "DEID, dead [adj]\n",
  "DEIDEST": "DEID, dead [adj]\n",
  "DEIDS": "DEID, (Scots) death [n]\n",
  "DEIF": "(Scots) deaf [adj DEIFER, DEIFEST]\n",
  "DEIFER": "DEIF, (Scots) deaf [adj]\n",
  "DEIFEST": "DEIF, (Scots) deaf [adj]\n",
  "DEIFIC": "godlike, also DEIFICAL [adj]\n",
  "DEIFICAL": "godlike, also DEIFIC [adj]\n",
  "DEIFICATION": "the act or an instance of deifying [n -S]\n",
  "DEIFICATIONS": "DEIFICATION, the act or an instance of deifying [n]\n",
  "DEIFIED": "DEIFY, to make a god of [v]\n",
  "DEIFIER": "one who deifies [n -S]\n",
  "DEIFIERS": "DEIFIER, one who deifies [n]\n",
  "DEIFIES": "DEIFY, to make a god of [v]\n",
  "DEIFORM": "having the form of a god [adj]\n",
  "DEIFY": "to make a god of [v DEIFIED, DEIFYING, DEIFIES]\n",
  "DEIFYING": "DEIFY, to make a god of [v]\n",
  "DEIGN": "to condescend, also DAINE [v -ED, -ING, -S]\n",
  "DEIGNED": "DEIGN, to condescend, also DAINE [v]\n",
  "DEIGNING": "DEIGN, to condescend, also DAINE [v]\n",
  "DEIGNS": "DEIGN, to condescend, also DAINE [v]\n",
  "DEIL": "(Scots) devil [n -S]\n",
  "DEILS": "DEIL, (Scots) devil [n]\n",
  "DEINDEX": "to unlink from an index [v -ED, -ING, -ES]\n",
  "DEINDEXATION": "the state of being no longer index-linked [n -S]\n",
  "DEINDEXATIONS": "DEINDEXATION, the state of being no longer index-linked [n]\n",
  "DEINDEXED": "DEINDEX, to unlink from an index [v]\n",
  "DEINDEXES": "DEINDEX, to unlink from an index [v]\n",
  "DEINDEXING": "DEINDEX, to unlink from an index [v]\n",
  "DEINDIVIDUATION": "the loss of a person's sense of individuality and personal responsibility [n]\n",
  "DEINDUSTRIALISE": "to disperse or reduce the industrial organization and potential of a nation, area, etc., also DEINDUSTRIALIZE [v]\n",
  "DEINDUSTRIALIZE": "to disperse or reduce the industrial organization and potential of a nation, area, etc., also DEINDUSTRIALISE [v]\n",
  "DEINONYCHUS": "any of a genus of small bipedal carnivorous theropod dinosaurs from the Cretaceous [n -ES]\n",
  "DEINONYCHUSES": "DEINONYCHUS, any of a genus of small bipedal carnivorous theropod dinosaurs from the Cretaceous [n]\n",
  "DEINOSAUR": "any of a group of extinct reptiles, also DINOSAUR [n -S]\n",
  "DEINOSAURS": "DEINOSAUR, any of a group of extinct reptiles, also DINOSAUR [n]\n",
  "DEINOTHERE": "an extinct elephantine mammal with downward-curving tusks, also DINOTHERE, DINOTHERIUM [n -S]\n",
  "DEINOTHERES": "DEINOTHERE, an extinct elephantine mammal with downward-curving tusks, also DINOTHERE, DINOTHERIUM [n]\n",
  "DEINOTHERIA": "DEINOTHERIUM, an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DINOTHERE, DINOTHERIUM [n]\n",
  "DEINOTHERIUM": "an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DINOTHERE, DINOTHERIUM [n DEINOTHERIA or DEINOTHERIUMS]\n",
  "DEINOTHERIUMS": "DEINOTHERIUM, an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DINOTHERE, DINOTHERIUM [n]\n",
  "DEIONISATION": "the process of deionising, also DEIONIZATION [n -S]\n",
  "DEIONISATIONS": "DEIONISATION, the process of deionising, also DEIONIZATION [n]\n",
  "DEIONISE": "to remove ions from, also DEIONIZE [v DEIONISED, DEIONISING, DEIONISES]\n",
  "DEIONISED": "DEIONISE, to remove ions from, also DEIONIZE [v]\n",
  "DEIONISER": "an apparatus for removing ions, also DEIONIZER [n -S]\n",
  "DEIONISERS": "DEIONISER, an apparatus for removing ions, also DEIONIZER [n]\n",
  "DEIONISES": "DEIONISE, to remove ions from, also DEIONIZE [v]\n",
  "DEIONISING": "DEIONISE, to remove ions from, also DEIONIZE [v]\n",
  "DEIONIZATION": "the process of deionizing, also DEIONISATION [n -S]\n",
  "DEIONIZATIONS": "DEIONIZATION, the process of deionizing, also DEIONISATION [n]\n",
  "DEIONIZE": "to remove ions from, also DEIONISE [v DEIONIZED, DEIONIZING, DEIONIZES]\n",
  "DEIONIZED": "DEIONIZE, to remove ions from, also DEIONISE [v]\n",
  "DEIONIZER": "an apparatus for removing ions, also DEIONISER [n -S]\n",
  "DEIONIZERS": "DEIONIZER, an apparatus for removing ions, also DEIONISER [n]\n",
  "DEIONIZES": "DEIONIZE, to remove ions from, also DEIONISE [v]\n",
  "DEIONIZING": "DEIONIZE, to remove ions from, also DEIONISE [v]\n",
  "DEIPAROUS": "bearing a god [adj]\n",
  "DEIPNOSOPHIST": "a person skilled in dinner conversation [n -S]\n",
  "DEIPNOSOPHISTS": "DEIPNOSOPHIST, a person skilled in dinner conversation [n]\n",
  "DEISEAL": "(Scots) motion in the same direction as the sun, also DEASIL, DEASIUL, DEASOIL, DEISHEAL [n -S]\n",
  "DEISEALS": "DEISEAL, (Scots) motion in the same direction as the sun, also DEASIL, DEASIUL, DEASOIL, DEISHEAL [n]\n",
  "DEISHEAL": "(Scots) motion in the same direction as the sun, also DEASIL, DEASIUL, DEASOIL, DEISEAL [n -S]\n",
  "DEISHEALS": "DEISHEAL, (Scots) motion in the same direction as the sun, also DEASIL, DEASIUL, DEASOIL, DEISEAL [n]\n",
  "DEISM": "belief in God but rejection of religion [n -S]\n",
  "DEISMS": "DEISM, belief in God but rejection of religion [n]\n",
  "DEIST": "an adherent of deism, belief in God but rejection of religion [n -S]\n",
  "DEISTIC": "relating to deism [adj]\n",
  "DEISTICAL": "relating to deism, also DEISTIC [adj DEISTICALLY]\n",
  "DEISTICALLY": "DEISTICAL, relating to deism, also DEISTIC [adv]\n",
  "DEISTS": "DEIST, an adherent of deism, belief in God but rejection of religion [n]\n",
  "DEITIES": "DEITY, a god or goddess [n]\n",
  "DEITY": "a god or goddess [n DEITIES]\n",
  "DEIXES": "DEIXIS, (Greek) use of words relating to the utterer's time and place [n]\n",
  "DEIXIS": "(Greek) use of words relating to the utterer's time and place [n DEIXISES or DEIXES]\n",
  "DEIXISES": "DEIXIS, (Greek) use of words relating to the utterer's time and place [n]\n",
  "DEJECT": "to depress, make sad [v -ED, -ING, -S]\n",
  "DEJECTA": "(Latin) excrements [n]\n",
  "DEJECTED": "DEJECT, to depress, make sad [v]\n",
  "DEJECTEDLY": "DEJECTED, DEJECT, to depress, make sad [adv]\n",
  "DEJECTEDNESS": "the state of being dejected [n -ES]\n",
  "DEJECTEDNESSES": "DEJECTEDNESS, the state of being dejected [n]\n",
  "DEJECTING": "DEJECT, to depress, make sad [v]\n",
  "DEJECTION": "lowness of spirits [n -S]\n",
  "DEJECTIONS": "DEJECTION, lowness of spirits [n]\n",
  "DEJECTORY": "promoting evacuation of the bowel [adj]\n",
  "DEJECTS": "DEJECT, to depress, make sad [v]\n",
  "DEJEUNE": "(archaic) breakfast, lunch, also DEJEUNER, DISJUNE [n -S]\n",
  "DEJEUNER": "(French) a breakfast; sometimes, also, a lunch or collation, also DEJEUNE, DISJUNE [n -S]\n",
  "DEJEUNERS": "DEJEUNER, (French) a breakfast; sometimes, also, a lunch or collation, also DEJEUNE, DISJUNE [n]\n",
  "DEJEUNES": "DEJEUNE, (archaic) breakfast, lunch, also DEJEUNER, DISJUNE [n]\n",
  "DEKAGRAM": "a weight of the metric system; ten grams, also DECAGRAM, DECAGRAMME [n -S]\n",
  "DEKAGRAMS": "DEKAGRAM, a weight of the metric system; ten grams, also DECAGRAM, DECAGRAMME [n]\n",
  "DEKALITER": "a cubic volume of ten liters, also DECALITER, DECALITRE, DEKALITRE [n -S]\n",
  "DEKALITERS": "DEKALITER, a cubic volume of ten liters, also DECALITER, DECALITRE, DEKALITRE [n]\n",
  "DEKALITRE": "a cubic volume of ten liters, also DECALITER, DECALITRE, DEKALITER [n -S]\n",
  "DEKALITRES": "DEKALITRE, a cubic volume of ten liters, also DECALITER, DECALITRE, DEKALITER [n]\n",
  "DEKALOGIES": "DEKALOGY, a group of ten novels [n]\n",
  "DEKALOGY": "a group of ten novels [n DEKALOGIES]\n",
  "DEKAMETER": "ten meters, also DECAMETER, DECAMETRE, DEKAMETRE [n -S]\n",
  "DEKAMETERS": "DEKAMETER, ten meters, also DECAMETER, DECAMETRE, DEKAMETRE [n]\n",
  "DEKAMETRE": "ten meters, also DECAMETER, DECAMETRE, DEKAMETER [n -S]\n",
  "DEKAMETRES": "DEKAMETRE, ten meters, also DECAMETER, DECAMETRE, DEKAMETER [n]\n",
  "DEKAMETRIC": "of or like a dekameter, also DECAMETRIC [adj]\n",
  "DEKARE": "ten ares, or 1000 square metres, also DECARE [n -S]\n",
  "DEKARES": "DEKARE, ten ares, or 1000 square metres, also DECARE [n]\n",
  "DEKE": "to feint in hockey [v DEKED, DEKING or DEKEING, DEKES]\n",
  "DEKED": "DEKE, to feint in hockey [v]\n",
  "DEKEING": "DEKE, to feint in hockey [v]\n",
  "DEKES": "DEKE, to feint in hockey [v]\n",
  "DEKING": "DEKE, to feint in hockey [v]\n",
  "DEKKO": "to take a look, also DECKO [v DEKKOED, DEKKOING, DEKKOS]\n",
  "DEKKOED": "DEKKO, to take a look, also DECKO [v]\n",
  "DEKKOING": "DEKKO, to take a look, also DECKO [v]\n",
  "DEKKOS": "DEKKO, to take a look, also DECKO [v]\n",
  "DEL": "an operator in differential calculus [n -S]\n",
  "DELAINE": "(French) a kind of fabric for women's dresses [n -S]\n",
  "DELAINES": "DELAINE, (French) a kind of fabric for women's dresses [n]\n",
  "DELAMINATE": "to split into layers [v DELAMINATED, DELAMINATING, DELAMINATES]\n",
  "DELAMINATED": "DELAMINATE, to split into layers [v]\n",
  "DELAMINATES": "DELAMINATE, to split into layers [v]\n",
  "DELAMINATING": "DELAMINATE, to split into layers [v]\n",
  "DELAMINATION": "separation into constituent layers [n -S]\n",
  "DELAMINATIONS": "DELAMINATION, separation into constituent layers [n]\n",
  "DELAPSE": "to sink down [v DELAPSED, DELAPSING, DELAPSES]\n",
  "DELAPSED": "DELAPSE, to sink down [v]\n",
  "DELAPSES": "DELAPSE, to sink down [v]\n",
  "DELAPSING": "DELAPSE, to sink down [v]\n",
  "DELAPSION": "a sinking down [n -S]\n",
  "DELAPSIONS": "DELAPSION, a sinking down [n]\n",
  "DELASSEMENT": "(French) a relaxation [n -S]\n",
  "DELASSEMENTS": "DELASSEMENT, (French) a relaxation [n]\n",
  "DELATE": "(archaic) to charge with a crime, report [v DELATED, DELATING, DELATES]\n",
  "DELATED": "DELATE, (archaic) to charge with a crime, report [v]\n",
  "DELATES": "DELATE, (archaic) to charge with a crime, report [v]\n",
  "DELATING": "DELATE, (archaic) to charge with a crime, report [v]\n",
  "DELATION": "the act of informing against someone [n -S]\n",
  "DELATIONS": "DELATION, the act of informing against someone [n]\n",
  "DELATOR": "an accuser; an informer [n -S]\n",
  "DELATORS": "DELATOR, an accuser; an informer [n]\n",
  "DELAY": "to put off to a later time [v -ED, -ING, -S]\n",
  "DELAYABLE": "that can be delayed [adj]\n",
  "DELAYED": "DELAY, to put off to a later time [v]\n",
  "DELAYER": "one who delays [n -S]\n",
  "DELAYERING": "the reduction of the number of levels in the hierarchy of an organization [n -S]\n",
  "DELAYERINGS": "DELAYERING, the reduction of the number of levels in the hierarchy of an organization [n]\n",
  "DELAYERS": "DELAYER, one who delays [n]\n",
  "DELAYING": "DELAY, to put off to a later time [v]\n",
  "DELAYINGLY": "DELAYING, DELAY, to put off to a later time [adv]\n",
  "DELAYS": "DELAY, to put off to a later time [v]\n",
  "DELE": "in printing, to delete [v DELED, DELEING, DELES]\n",
  "DELEAD": "to free from lead [v -ED, -ING, -S]\n",
  "DELEADED": "DELEAD, to free from lead [v]\n",
  "DELEADING": "DELEAD, to free from lead [v]\n",
  "DELEADS": "DELEAD, to free from lead [v]\n",
  "DELEAVE": "to separate the copies of [v DELEAVED, DELEAVING, DELEAVES]\n",
  "DELEAVED": "DELEAVE, to separate the copies of [v]\n",
  "DELEAVES": "DELEAVE, to separate the copies of [v]\n",
  "DELEAVING": "DELEAVE, to separate the copies of [v]\n",
  "DELEBLE": "that can be deleted, also DELIBLE [adj]\n",
  "DELECTABILITIES": "DELECTABILITY, the state of being delectable [n]\n",
  "DELECTABILITY": "the state of being delectable [n DELECTABILITIES]\n",
  "DELECTABLE": "very tasty [adj DELECTABLY] / something tasty [n -S]\n",
  "DELECTABLENESS": "DELECTABLE, very tasty [n]\n",
  "DELECTABLES": "DELECTABLE, something tasty [n]\n",
  "DELECTABLY": "DELECTABLE, very tasty [adv]\n",
  "DELECTATE": "to delight [v DELECTATED, DELECTATING, DELECTATES]\n",
  "DELECTATED": "DELECTATE, to delight [v]\n",
  "DELECTATES": "DELECTATE, to delight [v]\n",
  "DELECTATING": "DELECTATE, to delight [v]\n",
  "DELECTATION": "delight, enjoyment [n -S]\n",
  "DELECTATIONS": "DELECTATION, delight, enjoyment [n]\n",
  "DELED": "DELE, in printing, to delete [v]\n",
  "DELEGABLE": "that can be delegated [adj]\n",
  "DELEGACIES": "DELEGACY, the act of delegating [n]\n",
  "DELEGACY": "the act of delegating [n DELEGACIES]\n",
  "DELEGATE": "to appoint as one's representative [v DELEGATED, DELEGATING, DELEGATES]\n",
  "DELEGATED": "DELEGATE, to appoint as one's representative [v]\n",
  "DELEGATEE": "one to whom something is delegated [n -S]\n",
  "DELEGATEES": "DELEGATEE, one to whom something is delegated [n]\n",
  "DELEGATES": "DELEGATE, to appoint as one's representative [v]\n",
  "DELEGATING": "DELEGATE, to appoint as one's representative [v]\n",
  "DELEGATION": "the act of empowering to act for another [n -S]\n",
  "DELEGATIONS": "DELEGATION, the act of empowering to act for another [n]\n",
  "DELEGATOR": "one who delegates [n -S]\n",
  "DELEGATORS": "DELEGATOR, one who delegates [n]\n",
  "DELEGITIMATION": "the act of delegitimizing [n -S]\n",
  "DELEGITIMATIONS": "DELEGITIMATION, the act of delegitimizing [n]\n",
  "DELEGITIMISE": "to deprive of legitimacy [v DELEGITIMISED, DELEGITIMISING, DELEGITIMISES]\n",
  "DELEGITIMISED": "DELEGITIMISE, to deprive of legitimacy [v]\n",
  "DELEGITIMISES": "DELEGITIMISE, to deprive of legitimacy [v]\n",
  "DELEGITIMISING": "DELEGITIMISE, to deprive of legitimacy [v]\n",
  "DELEGITIMIZE": "to deprive of legitimacy, also DELEGITIMISE [v DELEGITIMIZED, DELEGITIMIZING, DELEGITIMIZES]\n",
  "DELEGITIMIZED": "DELEGITIMIZE, to deprive of legitimacy, also DELEGITIMISE [v]\n",
  "DELEGITIMIZES": "DELEGITIMIZE, to deprive of legitimacy, also DELEGITIMISE [v]\n",
  "DELEGITIMIZING": "DELEGITIMIZE, to deprive of legitimacy, also DELEGITIMISE [v]\n",
  "DELEING": "DELE, in printing, to delete [v]\n",
  "DELENDA": "(Latin) things to be deleted or destroyed [n]\n",
  "DELES": "DELE, in printing, to delete [v]\n",
  "DELETABLE": "that can be deleted, also DELEBLE, DELIBLE [adj]\n",
  "DELETE": "to remove printed matter [v DELETED, DELETING, DELETES]\n",
  "DELETED": "DELETE, to remove printed matter [v]\n",
  "DELETERIOUS": "harmful, injurious [adj DELETERIOUSLY]\n",
  "DELETERIOUSLY": "DELETERIOUS, harmful, injurious [adv]\n",
  "DELETERIOUSNESS": "DELETERIOUS, harmful, injurious [n]\n",
  "DELETES": "DELETE, to remove printed matter [v]\n",
  "DELETING": "DELETE, to remove printed matter [v]\n",
  "DELETION": "the act of deleting [n -S]\n",
  "DELETIONS": "DELETION, the act of deleting [n]\n",
  "DELETIVE": "serving to delete, also DELETORY [adj]\n",
  "DELETORY": "serving to delete, also DELETIVE [adj]\n",
  "DELEVERAGE": "(of an organization) to reduce the ratio of debt capital to equity capital [v DELEVERAGED, DELEVERAGING, DELEVERAGES]\n",
  "DELEVERAGED": "DELEVERAGE, (of an organization) to reduce the ratio of debt capital to equity capital [v]\n",
  "DELEVERAGES": "DELEVERAGE, (of an organization) to reduce the ratio of debt capital to equity capital [v]\n",
  "DELEVERAGING": "the act of reducing the ratio of debt capital to equity capital [n -S]\n",
  "DELEVERAGINGS": "DELEVERAGING, the act of reducing the ratio of debt capital to equity capital [n]\n",
  "DELF": "a type of earthenware originating in the Dutch city of Delft, also DELFT, DELPH, DELFTWARE [n -S]\n",
  "DELFS": "DELF, a type of earthenware originating in the Dutch city of Delft, also DELFT, DELPH, DELFTWARE [n]\n",
  "DELFT": "a type of earthenware originating in the Dutch city of Delft, also DELF, DELPH, DELFTWARE [n -S]\n",
  "DELFTS": "DELFT, a type of earthenware originating in the Dutch city of Delft, also DELF, DELPH, DELFTWARE [n]\n",
  "DELFTWARE": "a type of earthenware originating in the Dutch city of Delft, also DELF, DELFT, DELPH [n -S]\n",
  "DELFTWARES": "DELFTWARE, a type of earthenware originating in the Dutch city of Delft, also DELF, DELFT, DELPH [n]\n",
  "DELI": "(short for) a delicatessen, also DELLY [n -S]\n",
  "DELIBATE": "(obsolete) to sip [v DELIBATED, DELIBATING, DELIBATES]\n",
  "DELIBATED": "DELIBATE, (obsolete) to sip [v]\n",
  "DELIBATES": "DELIBATE, (obsolete) to sip [v]\n",
  "DELIBATING": "DELIBATE, (obsolete) to sip [v]\n",
  "DELIBATION": "the act of tasting; a slight trial [n -S]\n",
  "DELIBATIONS": "DELIBATION, the act of tasting; a slight trial [n]\n",
  "DELIBERATE": "intentional [adj DELIBERATELY] / to think about or discuss issues and decisions carefully [v DELIBERATED, DELIBERATING, DELIBERATES]\n",
  "DELIBERATED": "DELIBERATE, to think about or discuss issues and decisions carefully [v]\n",
  "DELIBERATELY": "DELIBERATE, intentional [adv]\n",
  "DELIBERATENESS": "the state of being deliberate [n]\n",
  "DELIBERATES": "DELIBERATE, to think about or discuss issues and decisions carefully [v]\n",
  "DELIBERATING": "DELIBERATE, to think about or discuss issues and decisions carefully [v]\n",
  "DELIBERATION": "the act of deliberating [n -S]\n",
  "DELIBERATIONS": "DELIBERATION, the act of deliberating [n]\n",
  "DELIBERATIVE": "relating to deliberation [adj DELIBERATIVELY]\n",
  "DELIBERATIVELY": "DELIBERATIVE, relating to deliberation [adv]\n",
  "DELIBERATOR": "one who deliberates [n -S]\n",
  "DELIBERATORS": "DELIBERATOR, one who deliberates [n]\n",
  "DELIBLE": "that can be deleted, also DELEBLE [adj]\n",
  "DELICACIES": "DELICACY, a choice food [n]\n",
  "DELICACY": "a choice food [n DELICACIES]\n",
  "DELICATE": "gently pleasing to the senses [adj DELICATELY] / a delicacy [n -S]\n",
  "DELICATELY": "DELICATE, gently pleasing to the senses [adv]\n",
  "DELICATENESS": "the state of being delicate [n -ES]\n",
  "DELICATENESSES": "DELICATENESS, the state of being delicate [n]\n",
  "DELICATES": "DELICATE, a delicacy [n]\n",
  "DELICATESSEN": "ready to eat food products, such as cooked meats and prepared salads [n -S]\n",
  "DELICATESSENS": "DELICATESSEN, ready to eat food products, such as cooked meats and prepared salads [n]\n",
  "DELICE": "(obsolete) a delight; a delicacy [n -S]\n",
  "DELICES": "DELICE, (obsolete) a delight; a delicacy [n]\n",
  "DELICIOUS": "tasting very good [adj DELICIOUSLY]\n",
  "DELICIOUSLY": "DELICIOUS, tasting very good [adv]\n",
  "DELICIOUSNESS": "the state of being delicious [n -ES]\n",
  "DELICIOUSNESSES": "DELICIOUSNESS, the state of being delicious [n]\n",
  "DELICT": "in Scots law, a civil wrong, a tort [n -S]\n",
  "DELICTS": "DELICT, in Scots law, a civil wrong, a tort [n]\n",
  "DELIGATION": "bandaging [n -S]\n",
  "DELIGATIONS": "DELIGATION, bandaging [n]\n",
  "DELIGHT": "to give great pleasure to [v -ED, -ING, -S]\n",
  "DELIGHTED": "DELIGHT, to give great pleasure to [v]\n",
  "DELIGHTEDLY": "DELIGHTED, DELIGHT, to give great pleasure to [adv]\n",
  "DELIGHTEDNESS": "the state of being delighted [n -ES]\n",
  "DELIGHTEDNESSES": "DELIGHTEDNESS, the state of being delighted [n]\n",
  "DELIGHTER": "one who delights [n -S]\n",
  "DELIGHTERS": "DELIGHTER, one who delights [n]\n",
  "DELIGHTFUL": "full of delight [adj DELIGHTFULLY]\n",
  "DELIGHTFULLY": "DELIGHTFUL, full of delight [adv]\n",
  "DELIGHTFULNESS": "DELIGHTFUL, full of delight [n]\n",
  "DELIGHTING": "DELIGHT, to give great pleasure to [v]\n",
  "DELIGHTLESS": "giving no delight [adj]\n",
  "DELIGHTS": "DELIGHT, to give great pleasure to [v]\n",
  "DELIGHTSOME": "(archaic) delightful [adj]\n",
  "DELIME": "to free from lime [v DELIMED, DELIMING, DELIMES]\n",
  "DELIMED": "DELIME, to free from lime [v]\n",
  "DELIMES": "DELIME, to free from lime [v]\n",
  "DELIMING": "DELIME, to free from lime [v]\n",
  "DELIMIT": "to mark the boundaries of [v -ED, -ING, -S]\n",
  "DELIMITATE": "to delimit [v DELIMITATED, DELIMITATING, DELIMITATES]\n",
  "DELIMITATED": "DELIMITATE, to delimit [v]\n",
  "DELIMITATES": "DELIMITATE, to delimit [v]\n",
  "DELIMITATING": "DELIMITATE, to delimit [v]\n",
  "DELIMITATION": "the act of delimiting [n -S]\n",
  "DELIMITATIONS": "DELIMITATION, the act of delimiting [n]\n",
  "DELIMITATIVE": "serving to delimit [adj]\n",
  "DELIMITED": "DELIMIT, to mark the boundaries of [v]\n",
  "DELIMITER": "something that marks a limit [n -S]\n",
  "DELIMITERS": "DELIMITER, something that marks a limit [n]\n",
  "DELIMITING": "DELIMIT, to mark the boundaries of [v]\n",
  "DELIMITS": "DELIMIT, to mark the boundaries of [v]\n",
  "DELINEABLE": "capable of being delineated [adj]\n",
  "DELINEATE": "to mark out with, or as if with, lines [v DELINEATED, DELINEATING, DELINEATES]\n",
  "DELINEATED": "DELINEATE, to mark out with, or as if with, lines [v]\n",
  "DELINEATES": "DELINEATE, to mark out with, or as if with, lines [v]\n",
  "DELINEATING": "DELINEATE, to mark out with, or as if with, lines [v]\n",
  "DELINEATION": "the act of delineating [n -S]\n",
  "DELINEATIONS": "DELINEATION, the act of delineating [n]\n",
  "DELINEATIVE": "relating to delineation [adj]\n",
  "DELINEATOR": "one who, or that which, delineates; a sketcher [n -S]\n",
  "DELINEATORS": "DELINEATOR, one who, or that which, delineates; a sketcher [n]\n",
  "DELINEAVIT": "(Latin) he or she drew this, added to an artist's signature [v]\n",
  "DELINK": "to break a connection between [v -ED, -ING, -S]\n",
  "DELINKED": "DELINK, to break a connection between [v]\n",
  "DELINKING": "DELINK, to break a connection between [v]\n",
  "DELINKS": "DELINK, to break a connection between [v]\n",
  "DELINQUENCIES": "DELINQUENCY, a delinquent act [n]\n",
  "DELINQUENCY": "a delinquent act [n DELINQUENCIES]\n",
  "DELINQUENT": "failing in duty; of or concerning a bad debt or debtor [adj DELINQUENTLY] / an offender, esp. a young criminal [n -S]\n",
  "DELINQUENTLY": "DELINQUENT, failing in duty; of or concerning a bad debt or debtor [adv]\n",
  "DELINQUENTS": "DELINQUENT, an offender, esp. a young criminal [n]\n",
  "DELIQUESCE": "to melt away; to dissolve gradually and become liquid by attracting and absorbing moisture [v DELIQUESCED, DELIQUESCING, DELIQUESCES]\n",
  "DELIQUESCED": "DELIQUESCE, to melt away; to dissolve gradually and become liquid by attracting and absorbing moisture [v]\n",
  "DELIQUESCENCE": "the state of being deliquescent [n -S]\n",
  "DELIQUESCENCES": "DELIQUESCENCE, the state of being deliquescent [n]\n",
  "DELIQUESCENT": "tending to melt or dissolve [adj]\n",
  "DELIQUESCES": "DELIQUESCE, to melt away; to dissolve gradually and become liquid by attracting and absorbing moisture [v]\n",
  "DELIQUESCING": "DELIQUESCE, to melt away; to dissolve gradually and become liquid by attracting and absorbing moisture [v]\n",
  "DELIQUIUM": "(archaic) a swoon; an eclipse [n -S]\n",
  "DELIQUIUMS": "DELIQUIUM, (archaic) a swoon; an eclipse [n]\n",
  "DELIRATION": "madness; aberration [n -S]\n",
  "DELIRATIONS": "DELIRATION, madness; aberration [n]\n",
  "DELIRIA": "DELIRIUM, (Latin) the state of wild excitement [n]\n",
  "DELIRIANT": "of a drug, causing delirium [adj]\n",
  "DELIRIFACIENT": "a substance producing or creating delirium [n -S]\n",
  "DELIRIFACIENTS": "DELIRIFACIENT, a substance producing or creating delirium [n]\n",
  "DELIRIOUS": "mentally confused, esp. through fever or other illness [adj DELIRIOUSLY]\n",
  "DELIRIOUSLY": "DELIRIOUS, mentally confused, esp. through fever or other illness [adv]\n",
  "DELIRIOUSNESS": "DELIRIOUS, mentally confused, esp. through fever or other illness [n]\n",
  "DELIRIOUSNESSES": "DELIRIOUSNESS, DELIRIOUS, mentally confused, esp. through fever or other illness [n]\n",
  "DELIRIUM": "(Latin) the state of wild excitement [n DELIRIUMS or DELIRIA]\n",
  "DELIRIUMS": "DELIRIUM, (Latin) the state of wild excitement [n]\n",
  "DELIS": "DELI, (short for) a delicatessen, also DELLY [n]\n",
  "DELISH": "(slang) delicious [adj]\n",
  "DELIST": "to remove from a list [v -ED, -ING, -S]\n",
  "DELISTED": "DELIST, to remove from a list [v]\n",
  "DELISTING": "DELIST, to remove from a list [v]\n",
  "DELISTS": "DELIST, to remove from a list [v]\n",
  "DELITESCENCE": "latence [n -S]\n",
  "DELITESCENCES": "DELITESCENCE, latence [n]\n",
  "DELITESCENT": "hidden, latent [adj]\n",
  "DELIVER": "nimble [adj DELIVERLY] / to take to the intended recipient [v -ED, -ING, -S]\n",
  "DELIVERABILITY": "the state of being deliverable [n]\n",
  "DELIVERABLE": "an item named in a contract, course, or project that must be delivered for its successful completion [n -S]\n",
  "DELIVERABLES": "DELIVERABLE, an item named in a contract, course, or project that must be delivered for its successful completion [n]\n",
  "DELIVERANCE": "the act of delivering someone or something [n -S]\n",
  "DELIVERANCES": "DELIVERANCE, the act of delivering someone or something [n]\n",
  "DELIVERED": "DELIVER, to take to the intended recipient [v]\n",
  "DELIVERER": "one who delivers [n -S]\n",
  "DELIVERERS": "DELIVERER, one who delivers [n]\n",
  "DELIVERIES": "DELIVERY, the act of delivering [n]\n",
  "DELIVERING": "DELIVER, to take to the intended recipient [v]\n",
  "DELIVERLY": "DELIVER, nimble [adv]\n",
  "DELIVERS": "DELIVER, to take to the intended recipient [v]\n",
  "DELIVERY": "the act of delivering [n DELIVERIES]\n",
  "DELIVERYMAN": "a person who delivers wholesale or retail goods to customers usually over a regular local route [n DELIVERYMEN]\n",
  "DELIVERYMEN": "DELIVERYMAN, a person who delivers wholesale or retail goods to customers usually over a regular local route [n]\n",
  "DELL": "a small wooded valley, also DINGLE [n -S]\n",
  "DELLIER": "DELLY, like a dell [adj]\n",
  "DELLIES": "DELLY, (colloquial) a delicatessen [n]\n",
  "DELLIEST": "DELLY, like a dell [adj]\n",
  "DELLS": "DELL, a small wooded valley, also DINGLE [n]\n",
  "DELLY": "(colloquial) a delicatessen [n DELLIES] / like a dell [adj DELLIER, DELLIEST]\n",
  "DELO": "(Australian slang) a delegate [n -S]\n",
  "DELOCALISATION": "the act of delocalising, also DELOCALIZATION [n -S]\n",
  "DELOCALISATIONS": "DELOCALISATION, the act of delocalising, also DELOCALIZATION [n]\n",
  "DELOCALISE": "to free from the limitations of locality, also DELOCALIZE [v DELOCALISED, DELOCALISING, DELOCALISES]\n",
  "DELOCALISED": "DELOCALISE, to free from the limitations of locality, also DELOCALIZE [v]\n",
  "DELOCALISES": "DELOCALISE, to free from the limitations of locality, also DELOCALIZE [v]\n",
  "DELOCALISING": "DELOCALISE, to free from the limitations of locality, also DELOCALIZE [v]\n",
  "DELOCALIZATION": "the act of delocalizing, also DELOCALISATION [n -S]\n",
  "DELOCALIZATIONS": "DELOCALIZATION, the act of delocalizing, also DELOCALISATION [n]\n",
  "DELOCALIZE": "to free from the limitations of locality, also DELOCALISE [v DELOCALIZED, DELOCALIZING, DELOCALIZES]\n",
  "DELOCALIZED": "DELOCALIZE, to free from the limitations of locality, also DELOCALISE [v]\n",
  "DELOCALIZES": "DELOCALIZE, to free from the limitations of locality, also DELOCALISE [v]\n",
  "DELOCALIZING": "DELOCALIZE, to free from the limitations of locality, also DELOCALISE [v]\n",
  "DELOPE": "to fire one's gun into the air during a duel [v DELOPED, DELOPING, DELOPES]\n",
  "DELOPED": "DELOPE, to fire one's gun into the air during a duel [v]\n",
  "DELOPES": "DELOPE, to fire one's gun into the air during a duel [v]\n",
  "DELOPING": "DELOPE, to fire one's gun into the air during a duel [v]\n",
  "DELOS": "DELO, (Australian slang) a delegate [n]\n",
  "DELOUSE": "to free from lice [v DELOUSED, DELOUSING, DELOUSES]\n",
  "DELOUSED": "DELOUSE, to free from lice [v]\n",
  "DELOUSER": "an agent that removes lice [n -S]\n",
  "DELOUSERS": "DELOUSER, an agent that removes lice [n]\n",
  "DELOUSES": "DELOUSE, to free from lice [v]\n",
  "DELOUSING": "DELOUSE, to free from lice [v]\n",
  "DELPH": "a type of earthenware originating in the Dutch city of Delft, also DELF, DELFT, DELFTWARE [n -S]\n",
  "DELPHIC": "(Greek) like an oracle, esp. if ambiguous or difficult to interpret [adj DELPHICALLY]\n",
  "DELPHICALLY": "DELPHIC, (Greek) like an oracle, esp. if ambiguous or difficult to interpret [adv]\n",
  "DELPHIN": "an archaic word for dolphin; a fatty substance made from dolphin oil [n -S]\n",
  "DELPHINIA": "DELPHINIUM, a genus of garden flower, comprising larkspur and stavesacre [n]\n",
  "DELPHINIUM": "a genus of garden flower, comprising larkspur and stavesacre [n DELPHINIUMS or DELPHINIA]\n",
  "DELPHINIUMS": "DELPHINIUM, a genus of garden flower, comprising larkspur and stavesacre [n]\n",
  "DELPHINOID": "a member of the genus Delphinoidea, of which dolphins and seals are members [n -S]\n",
  "DELPHINOIDS": "DELPHINOID, a member of the genus Delphinoidea, of which dolphins and seals are members [n]\n",
  "DELPHINS": "DELPHIN, an archaic word for dolphin; a fatty substance made from dolphin oil [n]\n",
  "DELPHS": "DELPH, a type of earthenware originating in the Dutch city of Delft, also DELF, DELFT, DELFTWARE [n]\n",
  "DELS": "DEL, an operator in differential calculus [n]\n",
  "DELT": "(colloquial) a deltoid muscle [n -S]\n",
  "DELTA": "an alluvial deposit at the mouth of a river [n -S]\n",
  "DELTAIC": "pertaining to a delta, also DELTIC [adj]\n",
  "DELTAS": "DELTA, an alluvial deposit at the mouth of a river [n]\n",
  "DELTIC": "pertaining to a delta, also DELTAIC [adj]\n",
  "DELTIOLOGIES": "DELTIOLOGY, the collecting of postcards [n]\n",
  "DELTIOLOGIST": "a collector of picture postcards [n -S]\n",
  "DELTIOLOGISTS": "DELTIOLOGIST, a collector of picture postcards [n]\n",
  "DELTIOLOGY": "the collecting of postcards [n DELTIOLOGIES]\n",
  "DELTOID": "shaped like a delta or triangle [adj] / the large triangular muscle of the shoulder [n -S]\n",
  "DELTOIDEI": "DELTOIDEUS, the deltoid muscle [n]\n",
  "DELTOIDEUS": "the deltoid muscle [n DELTOIDEI]\n",
  "DELTOIDS": "DELTOID, the large triangular muscle of the shoulder [n]\n",
  "DELTS": "DELT, (colloquial) a deltoid muscle [n]\n",
  "DELUBRA": "DELUBRUM, (Latin) a font; a temple or shrine having a font [n]\n",
  "DELUBRUM": "(Latin) a font; a temple or shrine having a font [n DELUBRA or DELUBRUMS]\n",
  "DELUBRUMS": "DELUBRUM, (Latin) a font; a temple or shrine having a font [n]\n",
  "DELUDABLE": "capable of being deluded [adj]\n",
  "DELUDE": "to mislead that what is true is false [v DELUDED, DELUDING, DELUDES]\n",
  "DELUDED": "DELUDE, to mislead that what is true is false [v]\n",
  "DELUDER": "one who deludes [n -S]\n",
  "DELUDERS": "DELUDER, one who deludes [n]\n",
  "DELUDES": "DELUDE, to mislead that what is true is false [v]\n",
  "DELUDING": "DELUDE, to mislead that what is true is false [v]\n",
  "DELUDINGLY": "DELUDING, DELUDE, to mislead that what is true is false [adv]\n",
  "DELUGE": "to flood [v DELUGED, DELUGING, DELUGES]\n",
  "DELUGED": "DELUGE, to flood [v]\n",
  "DELUGES": "DELUGE, to flood [v]\n",
  "DELUGING": "DELUGE, to flood [v]\n",
  "DELUNDUNG": "(Javanese) the weasel cat of Java and Malacca, a small carnivore related to the civet, aka linsang [n -S]\n",
  "DELUNDUNGS": "DELUNDUNG, (Javanese) the weasel cat of Java and Malacca, a small carnivore related to the civet, aka linsang [n]\n",
  "DELUSION": "the act of deluding [n -S]\n",
  "DELUSIONAL": "relating to delusion, also DELUSIONARY [adj]\n",
  "DELUSIONARY": "relating to delusion, also DELUSIONAL [adj]\n",
  "DELUSIONIST": "one who suffers from delusions [n -S]\n",
  "DELUSIONISTS": "DELUSIONIST, one who suffers from delusions [n]\n",
  "DELUSIONS": "DELUSION, the act of deluding [n]\n",
  "DELUSIVE": "tending to delude, also DELUSORY [adj DELUSIVELY]\n",
  "DELUSIVELY": "DELUSIVE, tending to delude, also DELUSORY [adv]\n",
  "DELUSIVENESS": "the state of being delusive [n -ES]\n",
  "DELUSIVENESSES": "DELUSIVENESS, the state of being delusive [n]\n",
  "DELUSORY": "tending to delude, also DELUSIVE [adj]\n",
  "DELUSTER": "to lessen the sheen of [v -ED, -ING, -S]\n",
  "DELUSTERED": "DELUSTER, to lessen the sheen of [v]\n",
  "DELUSTERING": "DELUSTER, to lessen the sheen of [v]\n",
  "DELUSTERS": "DELUSTER, to lessen the sheen of [v]\n",
  "DELUSTRANT": "a dense inorganic material added to manmade fibres that allows a range of fibres with different lustres to be obtained [n -S]\n",
  "DELUSTRANTS": "DELUSTRANT, a dense inorganic material added to manmade fibres that allows a range of fibres with different lustres to be obtained [n]\n",
  "DELUSTRE": "to remove the lustre from [v DELUSTRED, DELUSTRING, DELUSTRES]\n",
  "DELUSTRED": "DELUSTRE, to remove the lustre from [v]\n",
  "DELUSTRES": "DELUSTRE, to remove the lustre from [v]\n",
  "DELUSTRING": "DELUSTRE, to remove the lustre from [v]\n",
  "DELUXE": "of special elegance or luxury [adj]\n",
  "DELVE": "to search in depth [v DELVED, DELVING, DELVES]\n",
  "DELVED": "DELVE, to search in depth [v]\n",
  "DELVER": "one who delves [n -S]\n",
  "DELVERS": "DELVER, one who delves [n]\n",
  "DELVES": "DELVE, to search in depth [v]\n",
  "DELVING": "DELVE, to search in depth [v]\n",
  "DEMAGNETISATION": "the act of demagnetising, also DEMAGNETIZATION [n]\n",
  "DEMAGNETISE": "to remove the magnetic property from, also DEMAGNETIZE [v DEMAGNETISED, DEMAGNETISING, DEMAGNETISES]\n",
  "DEMAGNETISED": "DEMAGNETISE, to remove the magnetic property from, also DEMAGNETIZE [v]\n",
  "DEMAGNETISER": "a device for demagnetising, also DEMAGNETIZER [n -S]\n",
  "DEMAGNETISERS": "DEMAGNETISER, a device for demagnetising, also DEMAGNETIZER [n]\n",
  "DEMAGNETISES": "DEMAGNETISE, to remove the magnetic property from, also DEMAGNETIZE [v]\n",
  "DEMAGNETISING": "DEMAGNETISE, to remove the magnetic property from, also DEMAGNETIZE [v]\n",
  "DEMAGNETIZATION": "the act of demagnetizing, also DEMAGNETISATION [n]\n",
  "DEMAGNETIZE": "to deprive of magnetic properties, also DEMAGNETISE [v DEMAGNETIZED, DEMAGNETIZING, DEMAGNETIZES]\n",
  "DEMAGNETIZED": "DEMAGNETIZE, to deprive of magnetic properties, also DEMAGNETISE [v]\n",
  "DEMAGNETIZER": "a device for demagnetizing, also DEMAGNETISER [n -S]\n",
  "DEMAGNETIZERS": "DEMAGNETIZER, a device for demagnetizing, also DEMAGNETISER [n]\n",
  "DEMAGNETIZES": "DEMAGNETIZE, to deprive of magnetic properties, also DEMAGNETISE [v]\n",
  "DEMAGNETIZING": "DEMAGNETIZE, to deprive of magnetic properties, also DEMAGNETISE [v]\n",
  "DEMAGOG": "(Greek) to behave like a leader who appeals to baser emotions, also DEMAGOGUE [v -ED, -ING, -S]\n",
  "DEMAGOGED": "DEMAGOG, (Greek) to behave like a leader who appeals to baser emotions, also DEMAGOGUE [v]\n",
  "DEMAGOGIC": "of or like a demagogue, also DEMAGOGICAL [adj DEMAGOGICALLY]\n",
  "DEMAGOGICAL": "of or like a demagogue, also DEMAGOGIC [adj DEMAGOGICALLY]\n",
  "DEMAGOGICALLY": "DEMAGOGICAL, of or like a demagogue, also DEMAGOGIC [adv]\n",
  "DEMAGOGIES": "DEMAGOGY, the rule of a demagog [n]\n",
  "DEMAGOGING": "DEMAGOG, (Greek) to behave like a leader who appeals to baser emotions, also DEMAGOGUE [v]\n",
  "DEMAGOGISM": "the practices of a demagogue, also DEMAGOGUISM, DEMAGOGY [n -S]\n",
  "DEMAGOGISMS": "DEMAGOGISM, the practices of a demagogue, also DEMAGOGUISM, DEMAGOGY [n]\n",
  "DEMAGOGS": "DEMAGOG, (Greek) to behave like a leader who appeals to baser emotions, also DEMAGOGUE [v]\n",
  "DEMAGOGUE": "a person who appeals to the prejudices and emotions of the people to gain power [n -S] / to act in the manner of a demagogue, also DEMAGOG [v DEMAGOGUED, DEMAGOGUING, DEMAGOGUES]\n",
  "DEMAGOGUED": "DEMAGOGUE, to act in the manner of a demagogue, also DEMAGOG [v]\n",
  "DEMAGOGUERIES": "DEMAGOGUERY, the actions of a demagogue [n]\n",
  "DEMAGOGUERY": "the actions of a demagogue [n DEMAGOGUERIES]\n",
  "DEMAGOGUES": "DEMAGOGUE, a person who appeals to the prejudices and emotions of the people to gain power [n]\n",
  "DEMAGOGUING": "DEMAGOGUE, to act in the manner of a demagogue, also DEMAGOG [v]\n",
  "DEMAGOGUISM": "being a demagogue, also DEMAGOGISM, DEMAGOGY [n -S]\n",
  "DEMAGOGUISMS": "DEMAGOGUISM, being a demagogue, also DEMAGOGISM, DEMAGOGY [n]\n",
  "DEMAGOGY": "the rule of a demagog [n DEMAGOGIES]\n",
  "DEMAIN": "a manor house and its untenanted land, also DEMESNE [n -S]\n",
  "DEMAINE": "(Spenser) bearing, conduct, also DEMAYNE, DEMEANE, DEMEANOR, DEMEANOUR, DEMEASNURE [n -S]\n",
  "DEMAINES": "DEMAINE, (Spenser) bearing, conduct, also DEMAYNE, DEMEANE, DEMEANOR, DEMEANOUR, DEMEASNURE [n]\n",
  "DEMAINS": "DEMAIN, a manor house and its untenanted land, also DEMESNE [n]\n",
  "DEMAN": "to reduce the number of employees in an industry [v DEMANNED, DEMANNING, DEMANS]\n",
  "DEMAND": "to ask for with authority [v -ED, -ING, -S]\n",
  "DEMANDABLE": "that may be demanded or claimed [adj]\n",
  "DEMANDANT": "one who demands; a plaintiff [n -S]\n",
  "DEMANDANTS": "DEMANDANT, one who demands; a plaintiff [n]\n",
  "DEMANDED": "DEMAND, to ask for with authority [v]\n",
  "DEMANDER": "one who demands [n -S]\n",
  "DEMANDERS": "DEMANDER, one who demands [n]\n",
  "DEMANDING": "DEMAND, to ask for with authority [v]\n",
  "DEMANDINGLY": "DEMANDING, DEMAND, to ask for with authority [adv]\n",
  "DEMANDINGNESS": "the state of being demanding [n -ES]\n",
  "DEMANDINGNESSES": "DEMANDINGNESS, the state of being demanding [n]\n",
  "DEMANDS": "DEMAND, to ask for with authority [v]\n",
  "DEMANNED": "DEMAN, to reduce the number of employees in an industry [v]\n",
  "DEMANNING": "the deliberate reduction of the number of employees in a particular industry, etc [n -S]\n",
  "DEMANNINGS": "DEMANNING, the deliberate reduction of the number of employees in a particular industry, etc [n]\n",
  "DEMANS": "DEMAN, to reduce the number of employees in an industry [v]\n",
  "DEMANTOID": "a lustrous green gem variety of andradite garnet [n -S]\n",
  "DEMANTOIDS": "DEMANTOID, a lustrous green gem variety of andradite garnet [n]\n",
  "DEMARCATE": "to mark the boundary of [v DEMARCATED, DEMARCATING, DEMARCATES]\n",
  "DEMARCATED": "DEMARCATE, to mark the boundary of [v]\n",
  "DEMARCATES": "DEMARCATE, to mark the boundary of [v]\n",
  "DEMARCATING": "DEMARCATE, to mark the boundary of [v]\n",
  "DEMARCATION": "the act of demarking, also DEMARKATION [n -S]\n",
  "DEMARCATIONS": "DEMARCATION, the act of demarking, also DEMARKATION [n]\n",
  "DEMARCATOR": "one who demarcates [n -S]\n",
  "DEMARCATORS": "DEMARCATOR, one who demarcates [n]\n",
  "DEMARCHE": "(French) a course of action, esp. a diplomatic petition or protest [n -S]\n",
  "DEMARCHES": "DEMARCHE, (French) a course of action, esp. a diplomatic petition or protest [n]\n",
  "DEMARK": "to demarcate, mark off, delimit [v -ED, -ING, -S]\n",
  "DEMARKATION": "the act of demarking, also DEMARCATION [n -S]\n",
  "DEMARKATIONS": "DEMARKATION, the act of demarking, also DEMARCATION [n]\n",
  "DEMARKED": "DEMARK, to demarcate, mark off, delimit [v]\n",
  "DEMARKET": "to discourage consumers from buying one's product [v -ED, -ING, -S]\n",
  "DEMARKETED": "DEMARKET, to discourage consumers from buying one's product [v]\n",
  "DEMARKETING": "DEMARKET, to discourage consumers from buying one's product [v]\n",
  "DEMARKETS": "DEMARKET, to discourage consumers from buying one's product [v]\n",
  "DEMARKING": "DEMARK, to demarcate, mark off, delimit [v]\n",
  "DEMARKS": "DEMARK, to demarcate, mark off, delimit [v]\n",
  "DEMAST": "to remove the masts from, also DISMAST [v -ED, -ING, -S]\n",
  "DEMASTED": "DEMAST, to remove the masts from, also DISMAST [v]\n",
  "DEMASTING": "DEMAST, to remove the masts from, also DISMAST [v]\n",
  "DEMASTS": "DEMAST, to remove the masts from, also DISMAST [v]\n",
  "DEMATERIALISE": "to become, or cause to become, invisible, to vanish, cease to exist, also DEMATERIALIZE [v DEMATERIALISED, DEMATERIALISING, DEMATERIALISES]\n",
  "DEMATERIALISED": "DEMATERIALISE, to become, or cause to become, invisible, to vanish, cease to exist, also DEMATERIALIZE [v]\n",
  "DEMATERIALISES": "DEMATERIALISE, to become, or cause to become, invisible, to vanish, cease to exist, also DEMATERIALIZE [v]\n",
  "DEMATERIALISING": "DEMATERIALISE, to become, or cause to become, invisible, to vanish, cease to exist, also DEMATERIALIZE [v]\n",
  "DEMATERIALIZE": "to cause to become or appear immaterial, also DEMATERIALISE [v DEMATERIALIZED, DEMATERIALIZING, DEMATERIALIZES]\n",
  "DEMATERIALIZED": "DEMATERIALIZE, to cause to become or appear immaterial, also DEMATERIALISE [v]\n",
  "DEMATERIALIZES": "DEMATERIALIZE, to cause to become or appear immaterial, also DEMATERIALISE [v]\n",
  "DEMATERIALIZING": "DEMATERIALIZE, to cause to become or appear immaterial, also DEMATERIALISE [v]\n",
  "DEMAYNE": "(Spenser) bearing, conduct, also DEMAINE, DEMEANE, DEMEANOR, DEMEANOUR, DEMEASNURE [n -S]\n",
  "DEMAYNES": "DEMAYNE, (Spenser) bearing, conduct, also DEMAINE, DEMEANE, DEMEANOR, DEMEANOUR, DEMEASNURE [n]\n",
  "DEME": "(Greek) a territorial subdivision of Attica (also of modern Greece), corresponding to a township [n -S]\n",
  "DEMEAN": "to conduct oneself in a particular manner [v -ED, -ING, -S]\n",
  "DEMEANE": "(Spenser) bearing, conduct, also DEMAINE, DEMAYNE, DEMEANOR, DEMEANOUR, DEMEASNURE [n -S]\n",
  "DEMEANED": "DEMEAN, to conduct oneself in a particular manner [v]\n",
  "DEMEANES": "DEMEANE, (Spenser) bearing, conduct, also DEMAINE, DEMAYNE, DEMEANOR, DEMEANOUR, DEMEASNURE [n]\n",
  "DEMEANING": "DEMEAN, to conduct oneself in a particular manner [v]\n",
  "DEMEANOR": "behavior toward others, outward manner, also DEMAINE, DEMAYNE, DEMEANE, DEMEANOUR, DEMEASNURE [n -S]\n",
  "DEMEANORS": "DEMEANOR, behavior toward others, outward manner, also DEMAINE, DEMAYNE, DEMEANE, DEMEANOUR, DEMEASNURE [n]\n",
  "DEMEANOUR": "behavior toward others; outward manner, also DEMAINE, DEMAYNE, DEMEANE, DEMEANOR, DEMEASNURE [n -S]\n",
  "DEMEANOURS": "DEMEANOUR, behavior toward others; outward manner, also DEMAINE, DEMAYNE, DEMEANE, DEMEANOR, DEMEASNURE [n]\n",
  "DEMEANS": "DEMEAN, to conduct oneself in a particular manner [v]\n",
  "DEMEASNURE": "(Spenser) demeanor, also DEMAINE, DEMAYNE, DEMEANE, DEMEANOR, DEMEANOUR [n -S]\n",
  "DEMEASNURES": "DEMEASNURE, (Spenser) demeanor, also DEMAINE, DEMAYNE, DEMEANE, DEMEANOR, DEMEANOUR [n]\n",
  "DEMENT": "to deprive of reason; to make mad [v -ED, -ING, -S]\n",
  "DEMENTATE": "(archaic) to deprive of reason [v DEMENTATED, DEMENTATING, DEMENTATES]\n",
  "DEMENTATED": "DEMENTATE, (archaic) to deprive of reason [v]\n",
  "DEMENTATES": "DEMENTATE, (archaic) to deprive of reason [v]\n",
  "DEMENTATING": "DEMENTATE, (archaic) to deprive of reason [v]\n",
  "DEMENTED": "DEMENT, to deprive of reason; to make mad [v]\n",
  "DEMENTEDLY": "DEMENTED, DEMENT, to deprive of reason; to make mad [adv]\n",
  "DEMENTEDNESS": "the state of being demented [n -ES]\n",
  "DEMENTEDNESSES": "DEMENTEDNESS, the state of being demented [n]\n",
  "DEMENTI": "(French) a contradiction, a denial; now esp. an official denial of a published statement [n -S]\n",
  "DEMENTIA": "chronic mental and emotional deterioration caused by organic brain disease [n -S]\n",
  "DEMENTIAL": "relating to dementia [adj]\n",
  "DEMENTIAS": "DEMENTIA, chronic mental and emotional deterioration caused by organic brain disease [n]\n",
  "DEMENTING": "DEMENT, to deprive of reason; to make mad [v]\n",
  "DEMENTIS": "DEMENTI, (French) a contradiction, a denial; now esp. an official denial of a published statement [n]\n",
  "DEMENTS": "DEMENT, to deprive of reason; to make mad [v]\n",
  "DEMERARA": "a light-brown raw cane-sugar originally and chiefly from the Demerara region of Guyana [n -S]\n",
  "DEMERARAN": "like demerara, a light-brown raw cane-sugar [adj]\n",
  "DEMERARAS": "DEMERARA, a light-brown raw cane-sugar originally and chiefly from the Demerara region of Guyana [n]\n",
  "DEMERGE": "to remove a division from a corporation, also DEMERGER [v DEMERGED, DEMERGING, DEMERGES]\n",
  "DEMERGED": "DEMERGE, to remove a division from a corporation, also DEMERGER [v]\n",
  "DEMERGER": "to remove a division from a corporation, also DEMERGE [v -ED, -ING, -S]\n",
  "DEMERGERED": "DEMERGER, to remove a division from a corporation, also DEMERGE [v]\n",
  "DEMERGERING": "DEMERGER, to remove a division from a corporation, also DEMERGE [v]\n",
  "DEMERGERS": "DEMERGER, to remove a division from a corporation, also DEMERGE [v]\n",
  "DEMERGES": "DEMERGE, to remove a division from a corporation, also DEMERGER [v]\n",
  "DEMERGING": "DEMERGE, to remove a division from a corporation, also DEMERGER [v]\n",
  "DEMERIT": "to lower in status [v -ED, -ING, -S]\n",
  "DEMERITED": "DEMERIT, to lower in status [v]\n",
  "DEMERITING": "DEMERIT, to lower in status [v]\n",
  "DEMERITORIOUS": "not meritorious [adj DEMERITORIOUSLY]\n",
  "DEMERITORIOUSLY": "DEMERITORIOUS, not meritorious [adv]\n",
  "DEMERITS": "DEMERIT, to lower in status [v]\n",
  "DEMERSAL": "found at the bottom of the sea [adj]\n",
  "DEMERSE": "(obsolete) to immerse [v DEMERSED, DEMERSING, DEMERSES]\n",
  "DEMERSED": "DEMERSE, (obsolete) to immerse [v]\n",
  "DEMERSES": "DEMERSE, (obsolete) to immerse [v]\n",
  "DEMERSING": "DEMERSE, (obsolete) to immerse [v]\n",
  "DEMERSION": "immersion [n -S]\n",
  "DEMERSIONS": "DEMERSION, immersion [n]\n",
  "DEMES": "DEME, (Greek) a territorial subdivision of Attica (also of modern Greece), corresponding to a township [n]\n",
  "DEMESNE": "a manor house and its untenanted land, also DEMAIN [n -S]\n",
  "DEMESNES": "DEMESNE, a manor house and its untenanted land, also DEMAIN [n]\n",
  "DEMETON": "an insecticide [n -S]\n",
  "DEMETONS": "DEMETON, an insecticide [n]\n",
  "DEMIBASTION": "half a bastion, having only one flank, at right angles to the wall [n -S]\n",
  "DEMIBASTIONS": "DEMIBASTION, half a bastion, having only one flank, at right angles to the wall [n]\n",
  "DEMIC": "relating to a demos [adj]\n",
  "DEMICANTON": "one of two parts of certain Swiss cantons [n -S]\n",
  "DEMICANTONS": "DEMICANTON, one of two parts of certain Swiss cantons [n]\n",
  "DEMIES": "DEMY, a size of paper [n]\n",
  "DEMIGOD": "a half-god; a person whose nature is partly divine, esp. a hero fabled to be the offspring of a god and a mortal [n -S]\n",
  "DEMIGODDESS": "a half-goddess; a woman whose nature is partly divine, esp. a heroine fabled to be the offspring of a god and a mortal [n -ES]\n",
  "DEMIGODDESSES": "DEMIGODDESS, a half-goddess; a woman whose nature is partly divine, esp. a heroine fabled to be the offspring of a god and a mortal [n]\n",
  "DEMIGODS": "DEMIGOD, a half-god; a person whose nature is partly divine, esp. a hero fabled to be the offspring of a god and a mortal [n]\n",
  "DEMIGRATION": "change of abode [n -S]\n",
  "DEMIGRATIONS": "DEMIGRATION, change of abode [n]\n",
  "DEMIJOHN": "(French) a large bottle having a wicker case [n -S]\n",
  "DEMIJOHNS": "DEMIJOHN, (French) a large bottle having a wicker case [n]\n",
  "DEMILITARISE": "to deprive of a military character, also DEMILITARIZE [v DEMILITARISED, DEMILITARISING, DEMILITARISES]\n",
  "DEMILITARISED": "DEMILITARISE, to deprive of a military character, also DEMILITARIZE [v]\n",
  "DEMILITARISES": "DEMILITARISE, to deprive of a military character, also DEMILITARIZE [v]\n",
  "DEMILITARISING": "DEMILITARISE, to deprive of a military character, also DEMILITARIZE [v]\n",
  "DEMILITARIZE": "to deprive of a military character, also DEMILITARISE [v DEMILITARIZED, DEMILITARIZING, DEMILITARIZES]\n",
  "DEMILITARIZED": "DEMILITARIZE, to deprive of a military character, also DEMILITARISE [v]\n",
  "DEMILITARIZES": "DEMILITARIZE, to deprive of a military character, also DEMILITARISE [v]\n",
  "DEMILITARIZING": "DEMILITARIZE, to deprive of a military character, also DEMILITARISE [v]\n",
  "DEMILUNE": "(French) a half-moon fortification, a ravelin, also SEMILUNE [n -S]\n",
  "DEMILUNES": "DEMILUNE, (French) a half-moon fortification, a ravelin, also SEMILUNE [n]\n",
  "DEMIMONDAINE": "(French) a demirep, a woman of doubtful reputation [n -S]\n",
  "DEMIMONDAINES": "DEMIMONDAINE, (French) a demirep, a woman of doubtful reputation [n]\n",
  "DEMIMONDE": "(French) a class of women on the fringes of respectable society supported by wealthy lovers [n -S]\n",
  "DEMIMONDES": "DEMIMONDE, (French) a class of women on the fringes of respectable society supported by wealthy lovers [n]\n",
  "DEMINER": "one that removes (explosive) mines [n -S]\n",
  "DEMINERALISE": "to remove the minerals from, also DEMINERALIZE [v DEMINERALISED, DEMINERALISING, DEMINERALISES]\n",
  "DEMINERALISED": "DEMINERALISE, to remove the minerals from, also DEMINERALIZE [v]\n",
  "DEMINERALISER": "something that demineralises, also DEMINERALIZER [n -S]\n",
  "DEMINERALISERS": "DEMINERALISER, something that demineralises, also DEMINERALIZER [n]\n",
  "DEMINERALISES": "DEMINERALISE, to remove the minerals from, also DEMINERALIZE [v]\n",
  "DEMINERALISING": "DEMINERALISE, to remove the minerals from, also DEMINERALIZE [v]\n",
  "DEMINERALIZE": "to remove the minerals from, also DEMINERALISE [v DEMINERALIZED, DEMINERALIZING, DEMINERALIZES]\n",
  "DEMINERALIZED": "DEMINERALIZE, to remove the minerals from, also DEMINERALISE [v]\n",
  "DEMINERALIZER": "an agent that removes the minerals from, also DEMINERALISER [n -S]\n",
  "DEMINERALIZERS": "DEMINERALIZER, an agent that removes the minerals from, also DEMINERALISER [n]\n",
  "DEMINERALIZES": "DEMINERALIZE, to remove the minerals from, also DEMINERALISE [v]\n",
  "DEMINERALIZING": "DEMINERALIZE, to remove the minerals from, also DEMINERALISE [v]\n",
  "DEMINERS": "DEMINER, one that removes (explosive) mines [n]\n",
  "DEMINING": "the removal of (explosive) mines [n -S]\n",
  "DEMININGS": "DEMINING, the removal of (explosive) mines [n]\n",
  "DEMIPIQUE": "an 18th century war-saddle having a lower peak than usual [n -S]\n",
  "DEMIPIQUES": "DEMIPIQUE, an 18th century war-saddle having a lower peak than usual [n]\n",
  "DEMIRELIEF": "carving in which the depth of the relief is halfway between that of high relief and low relief [n -S]\n",
  "DEMIRELIEFS": "DEMIRELIEF, carving in which the depth of the relief is halfway between that of high relief and low relief [n]\n",
  "DEMIREP": "(obsolete) a woman of doubtful reputation or suspected character [n -S]\n",
  "DEMIREPDOM": "the state of being a demirep, a woman of doubtful reputation [n -S]\n",
  "DEMIREPDOMS": "DEMIREPDOM, the state of being a demirep, a woman of doubtful reputation [n]\n",
  "DEMIREPS": "DEMIREP, (obsolete) a woman of doubtful reputation or suspected character [n]\n",
  "DEMISABLE": "capable of being transferred by lease; as, a demisable estate [adj]\n",
  "DEMISE": "to give to a successor; to bequeath by will [v DEMISED, DEMISING, DEMISES]\n",
  "DEMISED": "DEMISE, to give to a successor; to bequeath by will [v]\n",
  "DEMISEMIQUAVER": "a 1/32 note in music [n -S]\n",
  "DEMISEMIQUAVERS": "DEMISEMIQUAVER, a 1/32 note in music [n]\n",
  "DEMISES": "DEMISE, to give to a successor; to bequeath by will [v]\n",
  "DEMISING": "DEMISE, to give to a successor; to bequeath by will [v]\n",
  "DEMISS": "humble, also DEMISSIVE [adj DEMISSLY]\n",
  "DEMISSION": "lowering, degradation [n -S]\n",
  "DEMISSIONS": "DEMISSION, lowering, degradation [n]\n",
  "DEMISSIVE": "(obsolete) humble, also DEMISS [adj]\n",
  "DEMISSLY": "DEMISS, humble, also DEMISSIVE [adv]\n",
  "DEMIST": "to clear a windscreen of moisture [v -ED, -ING, -S]\n",
  "DEMISTED": "DEMIST, to clear a windscreen of moisture [v]\n",
  "DEMISTER": "a device that demists [n -S]\n",
  "DEMISTERS": "DEMISTER, a device that demists [n]\n",
  "DEMISTING": "the act of removing the mist from [n -S]\n",
  "DEMISTINGS": "DEMISTING, the act of removing the mist from [n]\n",
  "DEMISTS": "DEMIST, to clear a windscreen of moisture [v]\n",
  "DEMIT": "to give up an office, resign [v DEMITTED, DEMITTING, DEMITS]\n",
  "DEMITASSE": "(French) a half-cup (esp. of black coffee) [n -S]\n",
  "DEMITASSES": "DEMITASSE, (French) a half-cup (esp. of black coffee) [n]\n",
  "DEMITS": "DEMIT, to give up an office, resign [v]\n",
  "DEMITTED": "DEMIT, to give up an office, resign [v]\n",
  "DEMITTING": "DEMIT, to give up an office, resign [v]\n",
  "DEMIURGE": "(Greek) an inferior god who created the world; a creative power or spirit, also DEMIURGUS [n -S]\n",
  "DEMIURGEOUS": "relating to a demiurge, also DEMIURGIC, DEMIURGICAL [adj]\n",
  "DEMIURGES": "DEMIURGE, (Greek) an inferior god who created the world; a creative power or spirit, also DEMIURGUS [n]\n",
  "DEMIURGIC": "relating to a demiurge, also DEMIURGEOUS, DEMIURGICAL [adj DEMIURGICALLY]\n",
  "DEMIURGICAL": "relating to a demiurge, also DEMIURGEOUS, DEMIURGIC [adj DEMIURGICALLY]\n",
  "DEMIURGICALLY": "DEMIURGICAL, relating to a demiurge, also DEMIURGEOUS, DEMIURGIC [adv]\n",
  "DEMIURGUS": "(Greek) an inferior god who created the world; a creative power or spirit, also DEMIURGE [n -ES]\n",
  "DEMIURGUSES": "DEMIURGUS, (Greek) an inferior god who created the world; a creative power or spirit, also DEMIURGE [n]\n",
  "DEMIVEG": "a person who eats no red meat, but eats poultry and fish [n DEMIVEGES or DEMIVEGGES]\n",
  "DEMIVEGES": "DEMIVEG, a person who eats no red meat, but eats poultry and fish [n]\n",
  "DEMIVEGGES": "DEMIVEG, a person who eats no red meat, but eats poultry and fish [n]\n",
  "DEMIVIERGE": "a woman who engages in promiscuous sexual activity but retains her virginity [n -S]\n",
  "DEMIVIERGES": "DEMIVIERGE, a woman who engages in promiscuous sexual activity but retains her virginity [n]\n",
  "DEMIVOLT": "a half turn made by a horse, also DEMIVOLTE [n -S]\n",
  "DEMIVOLTE": "a half-turn of a horse, the forelegs being raised in the air, also DEMIVOLT [n -S]\n",
  "DEMIVOLTES": "DEMIVOLTE, a half-turn of a horse, the forelegs being raised in the air, also DEMIVOLT [n]\n",
  "DEMIVOLTS": "DEMIVOLT, a half turn made by a horse, also DEMIVOLTE [n]\n",
  "DEMIWORLD": "the demimonde, a class of women on the fringes of respectable society supported by wealthy lovers [n -S]\n",
  "DEMIWORLDS": "DEMIWORLD, the demimonde, a class of women on the fringes of respectable society supported by wealthy lovers [n]\n",
  "DEMO": "to demonstrate [v -ED, -ING, -S]\n",
  "DEMOB": "to discharge from military service [v DEMOBBED, DEMOBBING, DEMOBS]\n",
  "DEMOBBED": "DEMOB, to discharge from military service [v]\n",
  "DEMOBBING": "DEMOB, to discharge from military service [v]\n",
  "DEMOBILISATION": "the process of demobilising, also DEMOBILIZATION [n -S]\n",
  "DEMOBILISATIONS": "DEMOBILISATION, the process of demobilising, also DEMOBILIZATION [n]\n",
  "DEMOBILISE": "to disband e.g. soldiers, also DEMOBILIZE [v DEMOBILISED, DEMOBILISING, DEMOBILISES]\n",
  "DEMOBILISED": "DEMOBILISE, to disband e.g. soldiers, also DEMOBILIZE [v]\n",
  "DEMOBILISES": "DEMOBILISE, to disband e.g. soldiers, also DEMOBILIZE [v]\n",
  "DEMOBILISING": "DEMOBILISE, to disband e.g. soldiers, also DEMOBILIZE [v]\n",
  "DEMOBILIZATION": "the act of demobilizing, also DEMOBILISATION [n -S]\n",
  "DEMOBILIZATIONS": "DEMOBILIZATION, the act of demobilizing, also DEMOBILISATION [n]\n",
  "DEMOBILIZE": "to disband e.g. soldiers, also DEMOBILISE [v DEMOBILIZED, DEMOBILIZING, DEMOBILIZES]\n",
  "DEMOBILIZED": "DEMOBILIZE, to disband e.g. soldiers, also DEMOBILISE [v]\n",
  "DEMOBILIZES": "DEMOBILIZE, to disband e.g. soldiers, also DEMOBILISE [v]\n",
  "DEMOBILIZING": "DEMOBILIZE, to disband e.g. soldiers, also DEMOBILISE [v]\n",
  "DEMOBS": "DEMOB, to discharge from military service [v]\n",
  "DEMOCRACIES": "DEMOCRACY, a form of government in which the supreme power is vested in the people collectively, also DEMOCRATY [n]\n",
  "DEMOCRACY": "a form of government in which the supreme power is vested in the people collectively, also DEMOCRATY [n DEMOCRACIES]\n",
  "DEMOCRAT": "a believer in political and social equality [n -S]\n",
  "DEMOCRATIC": "related to democracy, also DEMOCRATICAL [adj DEMOCRATICALLY]\n",
  "DEMOCRATICAL": "related to democracy, also DEMOCRATIC [adj DEMOCRATICALLY]\n",
  "DEMOCRATICALLY": "DEMOCRATICAL, related to democracy, also DEMOCRATIC [adv]\n",
  "DEMOCRATIES": "DEMOCRATY, (Milton) democracy, also DEMOCRACY [n]\n",
  "DEMOCRATIFIABLE": "able to be made democratic [adj]\n",
  "DEMOCRATISATION": "the act of democratising, also DEMOCRATIZATION [n]\n",
  "DEMOCRATISE": "to make democratic, also DEMOCRATIZE [v DEMOCRATISED, DEMOCRATISING, DEMOCRATISES]\n",
  "DEMOCRATISED": "DEMOCRATISE, to make democratic, also DEMOCRATIZE [v]\n",
  "DEMOCRATISER": "one who democratises, also DEMOCRATIZER [n -S]\n",
  "DEMOCRATISERS": "DEMOCRATISER, one who democratises, also DEMOCRATIZER [n]\n",
  "DEMOCRATISES": "DEMOCRATISE, to make democratic, also DEMOCRATIZE [v]\n",
  "DEMOCRATISING": "DEMOCRATISE, to make democratic, also DEMOCRATIZE [v]\n",
  "DEMOCRATIST": "a democrat [n -S]\n",
  "DEMOCRATISTS": "DEMOCRATIST, a democrat [n]\n",
  "DEMOCRATIZATION": "the act of democratizing, also DEMOCRATISATION [n]\n",
  "DEMOCRATIZE": "to make democratic, also DEMOCRATISE [v DEMOCRATIZED, DEMOCRATIZING, DEMOCRATIZES]\n",
  "DEMOCRATIZED": "DEMOCRATIZE, to make democratic, also DEMOCRATISE [v]\n",
  "DEMOCRATIZER": "one who democratizes, also DEMOCRATISER [n -S]\n",
  "DEMOCRATIZERS": "DEMOCRATIZER, one who democratizes, also DEMOCRATISER [n]\n",
  "DEMOCRATIZES": "DEMOCRATIZE, to make democratic, also DEMOCRATISE [v]\n",
  "DEMOCRATIZING": "DEMOCRATIZE, to make democratic, also DEMOCRATISE [v]\n",
  "DEMOCRATS": "DEMOCRAT, a believer in political and social equality [n]\n",
  "DEMOCRATY": "(Milton) democracy, also DEMOCRACY [n DEMOCRATIES]\n",
  "DEMODE": "(French) old-fashioned, also DEMODED [adj]\n",
  "DEMODED": "out-of-date, also DEMODE [adj]\n",
  "DEMODULATE": "to remove the modulation from [v DEMODULATED, DEMODULATING, DEMODULATES]\n",
  "DEMODULATED": "DEMODULATE, to remove the modulation from [v]\n",
  "DEMODULATES": "DEMODULATE, to remove the modulation from [v]\n",
  "DEMODULATING": "DEMODULATE, to remove the modulation from [v]\n",
  "DEMODULATION": "the act of demodulating [n -S]\n",
  "DEMODULATIONS": "DEMODULATION, the act of demodulating [n]\n",
  "DEMODULATOR": "something that demodulates [n -S]\n",
  "DEMODULATORS": "DEMODULATOR, something that demodulates [n]\n",
  "DEMOED": "DEMO, to demonstrate [v]\n",
  "DEMOGRAPHER": "a student of demography [n -S]\n",
  "DEMOGRAPHERS": "DEMOGRAPHER, a student of demography [n]\n",
  "DEMOGRAPHIC": "relating to demography, also DEMOGRAPHICAL [adj DEMOGRAPHICALLY] / an analysis of the structure of a population [n -S]\n",
  "DEMOGRAPHICAL": "relating to demography, also DEMOGRAPHIC [adj DEMOGRAPHICALLY]\n",
  "DEMOGRAPHICALLY": "DEMOGRAPHICAL, relating to demography, also DEMOGRAPHIC [adv]\n",
  "DEMOGRAPHICS": "DEMOGRAPHIC, an analysis of the structure of a population [n]\n",
  "DEMOGRAPHIES": "DEMOGRAPHY, the study of population statistics and trends, such as births, deaths, and disease [n]\n",
  "DEMOGRAPHIST": "a demographer [n -S]\n",
  "DEMOGRAPHISTS": "DEMOGRAPHIST, a demographer [n]\n",
  "DEMOGRAPHY": "the study of population statistics and trends, such as births, deaths, and disease [n DEMOGRAPHIES]\n",
  "DEMOI": "DEMOS, (Greek) the people, esp. contemptuously [n]\n",
  "DEMOING": "DEMO, to demonstrate [v]\n",
  "DEMOISELLE": "(archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOSEL, DAMOZEL, DAMSEL [n -S]\n",
  "DEMOISELLES": "DEMOISELLE, (archaic) a young girl or unmarried woman, also DAMOISEL, DAMOISELLE, DAMOSEL, DAMOZEL, DAMSEL [n]\n",
  "DEMOLISH": "to destroy [v -ED, -ING, -ES]\n",
  "DEMOLISHED": "DEMOLISH, to destroy [v]\n",
  "DEMOLISHER": "one who demolishes [n -S]\n",
  "DEMOLISHERS": "DEMOLISHER, one who demolishes [n]\n",
  "DEMOLISHES": "DEMOLISH, to destroy [v]\n",
  "DEMOLISHING": "DEMOLISH, to destroy [v]\n",
  "DEMOLISHMENT": "the act of demolishing [n -S]\n",
  "DEMOLISHMENTS": "DEMOLISHMENT, the act of demolishing [n]\n",
  "DEMOLITION": "the act of demolishing [n -S]\n",
  "DEMOLITIONIST": "one engaged in the business of demolition [n -S]\n",
  "DEMOLITIONISTS": "DEMOLITIONIST, one engaged in the business of demolition [n]\n",
  "DEMOLITIONS": "DEMOLITION, the act of demolishing [n]\n",
  "DEMOLOGIES": "DEMOLOGY, the study of human behaviour [n]\n",
  "DEMOLOGY": "the study of human behaviour [n DEMOLOGIES]\n",
  "DEMON": "an evil spirit [n -S]\n",
  "DEMONESS": "a female demon [n -ES]\n",
  "DEMONESSES": "DEMONESS, a female demon [n]\n",
  "DEMONETARISE": "to abandon as a monetary standard, also DEMONETARIZE [v DEMONETARISED, DEMONETARISING, DEMONETARISES]\n",
  "DEMONETARISED": "DEMONETARISE, to abandon as a monetary standard, also DEMONETARIZE [v]\n",
  "DEMONETARISES": "DEMONETARISE, to abandon as a monetary standard, also DEMONETARIZE [v]\n",
  "DEMONETARISING": "DEMONETARISE, to abandon as a monetary standard, also DEMONETARIZE [v]\n",
  "DEMONETARIZE": "to abandon as a monetary standard, also DEMONETARISE [v DEMONETARIZED, DEMONETARIZING, DEMONETARIZES]\n",
  "DEMONETARIZED": "DEMONETARIZE, to abandon as a monetary standard, also DEMONETARISE [v]\n",
  "DEMONETARIZES": "DEMONETARIZE, to abandon as a monetary standard, also DEMONETARISE [v]\n",
  "DEMONETARIZING": "DEMONETARIZE, to abandon as a monetary standard, also DEMONETARISE [v]\n",
  "DEMONETISATION": "the act of demonetising, also DEMONETIZATION [n -S]\n",
  "DEMONETISATIONS": "DEMONETISATION, the act of demonetising, also DEMONETIZATION [n]\n",
  "DEMONETISE": "to deprive of monetary value; to withdraw from circulation, also DEMONETIZE [v DEMONETISED, DEMONETISING, DEMONETISES]\n",
  "DEMONETISED": "DEMONETISE, to deprive of monetary value; to withdraw from circulation, also DEMONETIZE [v]\n",
  "DEMONETISES": "DEMONETISE, to deprive of monetary value; to withdraw from circulation, also DEMONETIZE [v]\n",
  "DEMONETISING": "DEMONETISE, to deprive of monetary value; to withdraw from circulation, also DEMONETIZE [v]\n",
  "DEMONETIZATION": "the act of demonetizing, also DEMONETISATION [n -S]\n",
  "DEMONETIZATIONS": "DEMONETIZATION, the act of demonetizing, also DEMONETISATION [n]\n",
  "DEMONETIZE": "to deprive of current value; to withdraw from use, as money, also DEMONETISE [v DEMONETIZED, DEMONETIZING, DEMONETIZES]\n",
  "DEMONETIZED": "DEMONETIZE, to deprive of current value; to withdraw from use, as money, also DEMONETISE [v]\n",
  "DEMONETIZES": "DEMONETIZE, to deprive of current value; to withdraw from use, as money, also DEMONETISE [v]\n",
  "DEMONETIZING": "DEMONETIZE, to deprive of current value; to withdraw from use, as money, also DEMONETISE [v]\n",
  "DEMONIAC": "one possessed by a demon [n -S]\n",
  "DEMONIACAL": "like a demoniac, a person possessed by a demon or evil spirit, also DEMONIC, DEMONICAL [adj DEMONIACALLY]\n",
  "DEMONIACALLY": "DEMONIACAL, like a demoniac, a person possessed by a demon or evil spirit, also DEMONIC, DEMONICAL [adv]\n",
  "DEMONIACISM": "the state of being a demoniac [n -S]\n",
  "DEMONIACISMS": "DEMONIACISM, the state of being a demoniac [n]\n",
  "DEMONIACS": "DEMONIAC, one possessed by a demon [n]\n",
  "DEMONIAN": "characteristic of a demon, also DEMONIC [adj]\n",
  "DEMONIANISM": "possession by a demon [n -S]\n",
  "DEMONIANISMS": "DEMONIANISM, possession by a demon [n]\n",
  "DEMONIC": "characteristic of a demon, also DEMONIAN [adj]\n",
  "DEMONICAL": "of or like a demon, also DEMONIACAL, DEMONIC [adj DEMONICALLY]\n",
  "DEMONICALLY": "DEMONICAL, of or like a demon, also DEMONIACAL, DEMONIC [adv]\n",
  "DEMONISATION": "the act of demonising, also DEMONIZATION [n -S]\n",
  "DEMONISATIONS": "DEMONISATION, the act of demonising, also DEMONIZATION [n]\n",
  "DEMONISE": "to make a demon of, also DEMONIZE [v DEMONISED, DEMONISING, DEMONISES]\n",
  "DEMONISED": "DEMONISE, to make a demon of, also DEMONIZE [v]\n",
  "DEMONISES": "DEMONISE, to make a demon of, also DEMONIZE [v]\n",
  "DEMONISING": "DEMONISE, to make a demon of, also DEMONIZE [v]\n",
  "DEMONISM": "a belief in demons [n -S]\n",
  "DEMONISMS": "DEMONISM, a belief in demons [n]\n",
  "DEMONIST": "one who believes in demons [n -S]\n",
  "DEMONISTS": "DEMONIST, one who believes in demons [n]\n",
  "DEMONIZATION": "the act of demonising, also DEMONISATION [n -S]\n",
  "DEMONIZATIONS": "DEMONIZATION, the act of demonising, also DEMONISATION [n]\n",
  "DEMONIZE": "to make a demon of, also DEMONISE [v DEMONIZED, DEMONIZING, DEMONIZES]\n",
  "DEMONIZED": "DEMONIZE, to make a demon of, also DEMONISE [v]\n",
  "DEMONIZES": "DEMONIZE, to make a demon of, also DEMONISE [v]\n",
  "DEMONIZING": "DEMONIZE, to make a demon of, also DEMONISE [v]\n",
  "DEMONOCRACIES": "DEMONOCRACY, government by demons or evil forces [n]\n",
  "DEMONOCRACY": "government by demons or evil forces [n DEMONOCRACIES]\n",
  "DEMONOLATER": "a worshipper of demons [n -S]\n",
  "DEMONOLATERS": "DEMONOLATER, a worshipper of demons [n]\n",
  "DEMONOLATRIES": "DEMONOLATRY, the worship of or devotion to demons [n]\n",
  "DEMONOLATRY": "the worship of or devotion to demons [n DEMONOLATRIES]\n",
  "DEMONOLOGIC": "relating to demonology, also DEMONOLOGICAL [adj]\n",
  "DEMONOLOGICAL": "relating to demonology, also DEMONOLOGIC [adj]\n",
  "DEMONOLOGIES": "DEMONOLOGY, the study of demons [n]\n",
  "DEMONOLOGIST": "a student of demonology [n -S]\n",
  "DEMONOLOGISTS": "DEMONOLOGIST, a student of demonology [n]\n",
  "DEMONOLOGY": "the study of demons [n DEMONOLOGIES]\n",
  "DEMONOMANIA": "an obsession with demons [n -S]\n",
  "DEMONOMANIAS": "DEMONOMANIA, an obsession with demons [n]\n",
  "DEMONRIES": "DEMONRY, demoniacal influence [n]\n",
  "DEMONRY": "demoniacal influence [n DEMONRIES]\n",
  "DEMONS": "DEMON, an evil spirit [n]\n",
  "DEMONSTRABILITY": "the state of being demonstrable [n]\n",
  "DEMONSTRABLE": "capable of being demonstrated [adj DEMONSTRABLY]\n",
  "DEMONSTRABLY": "DEMONSTRABLE, capable of being demonstrated [adv]\n",
  "DEMONSTRATE": "to show clearly [v DEMONSTRATED, DEMONSTRATING, DEMONSTRATES]\n",
  "DEMONSTRATED": "DEMONSTRATE, to show clearly [v]\n",
  "DEMONSTRATES": "DEMONSTRATE, to show clearly [v]\n",
  "DEMONSTRATING": "DEMONSTRATE, to show clearly [v]\n",
  "DEMONSTRATION": "the act of demonstrating [n -S]\n",
  "DEMONSTRATIONAL": "relating to demonstration [adj]\n",
  "DEMONSTRATIONS": "DEMONSTRATION, the act of demonstrating [n]\n",
  "DEMONSTRATIVE": "serving to demonstrate [adj DEMONSTRATIVELY] / a demonstrative word or morpheme [n -S]\n",
  "DEMONSTRATIVELY": "DEMONSTRATIVE, serving to demonstrate [adv]\n",
  "DEMONSTRATIVES": "DEMONSTRATIVE, a demonstrative word or morpheme [n]\n",
  "DEMONSTRATOR": "one that demonstrates [n -S]\n",
  "DEMONSTRATORS": "DEMONSTRATOR, one that demonstrates [n]\n",
  "DEMONSTRATORY": "serving to demonstrate [adj]\n",
  "DEMONYM": "a name used to denote the inhabitants of a place [n -S]\n",
  "DEMONYMS": "DEMONYM, a name used to denote the inhabitants of a place [n]\n",
  "DEMORALISATION": "the process of demoralising, also DEMORALIZATION [n -S]\n",
  "DEMORALISATIONS": "DEMORALISATION, the process of demoralising, also DEMORALIZATION [n]\n",
  "DEMORALISE": "to corrupt the morals of, also DEMORALIZE [v DEMORALISED, DEMORALISING, DEMORALISES]\n",
  "DEMORALISED": "DEMORALISE, to corrupt the morals of, also DEMORALIZE [v]\n",
  "DEMORALISER": "something or someone that demoralises, also DEMORALIZER [n -S]\n",
  "DEMORALISERS": "DEMORALISER, something or someone that demoralises, also DEMORALIZER [n]\n",
  "DEMORALISES": "DEMORALISE, to corrupt the morals of, also DEMORALIZE [v]\n",
  "DEMORALISING": "disheartening [adj DEMORALISINGLY]\n",
  "DEMORALISINGLY": "DEMORALISING, disheartening [adv]\n",
  "DEMORALIZATION": "the act of demoralizing, also DEMORALISATION [n -S]\n",
  "DEMORALIZATIONS": "DEMORALIZATION, the act of demoralizing, also DEMORALISATION [n]\n",
  "DEMORALIZE": "to corrupt the morals of, also DEMORALISE [v DEMORALIZED, DEMORALIZING, DEMORALIZES]\n",
  "DEMORALIZED": "DEMORALIZE, to corrupt the morals of, also DEMORALISE [v]\n",
  "DEMORALIZER": "one who demoralizes, also DEMORALISER [n -S]\n",
  "DEMORALIZERS": "DEMORALIZER, one who demoralizes, also DEMORALISER [n]\n",
  "DEMORALIZES": "DEMORALIZE, to corrupt the morals of, also DEMORALISE [v]\n",
  "DEMORALIZING": "DEMORALIZE, to corrupt the morals of, also DEMORALISE [v]\n",
  "DEMORALIZINGLY": "DEMORALIZING, DEMORALIZE, to corrupt the morals of, also DEMORALISE [adv]\n",
  "DEMOS": "(Greek) the people, esp. contemptuously [n DEMOI or DEMOSES]\n",
  "DEMOSCENE": "a computer art subculture that specializes in producing demos [n -S]\n",
  "DEMOSCENES": "DEMOSCENE, a computer art subculture that specializes in producing demos [n]\n",
  "DEMOSES": "DEMOS, (Greek) the people, esp. contemptuously [n]\n",
  "DEMOTE": "to lower in rank [v DEMOTED, DEMOTING, DEMOTES]\n",
  "DEMOTED": "DEMOTE, to lower in rank [v]\n",
  "DEMOTES": "DEMOTE, to lower in rank [v]\n",
  "DEMOTIC": "popular, common; of or relating to the form of Modern Greek that is based on everyday speech [adj] / the popular form of a language [n -S]\n",
  "DEMOTICIST": "a student of demotic script, also DEMOTIST [n -S]\n",
  "DEMOTICISTS": "DEMOTICIST, a student of demotic script, also DEMOTIST [n]\n",
  "DEMOTICS": "the study of people in society [n]\n",
  "DEMOTING": "DEMOTE, to lower in rank [v]\n",
  "DEMOTION": "the action of demoting [n -S]\n",
  "DEMOTIONS": "DEMOTION, the action of demoting [n]\n",
  "DEMOTIST": "a student of demotic script, also DEMOTICIST [n -S]\n",
  "DEMOTISTS": "DEMOTIST, a student of demotic script, also DEMOTICIST [n]\n",
  "DEMOTIVATE": "to remove motivation from [v DEMOTIVATED, DEMOTIVATING, DEMOTIVATES]\n",
  "DEMOTIVATED": "DEMOTIVATE, to remove motivation from [v]\n",
  "DEMOTIVATES": "DEMOTIVATE, to remove motivation from [v]\n",
  "DEMOTIVATING": "DEMOTIVATE, to remove motivation from [v]\n",
  "DEMOTIVATION": "the act of demotivating [n -S]\n",
  "DEMOTIVATIONS": "DEMOTIVATION, the act of demotivating [n]\n",
  "DEMOUNT": "to remove from a mounting [v -ED, -ING, -S]\n",
  "DEMOUNTABLE": "that can be demounted [adj]\n",
  "DEMOUNTED": "DEMOUNT, to remove from a mounting [v]\n",
  "DEMOUNTING": "DEMOUNT, to remove from a mounting [v]\n",
  "DEMOUNTS": "DEMOUNT, to remove from a mounting [v]\n",
  "DEMPSTER": "(Scots) formerly in Scotland, an officer who repeated the sentence after the judge, also DEEMSTER, DOOMSMAN, DOOMSTER [n -S]\n",
  "DEMPSTERS": "DEMPSTER, (Scots) formerly in Scotland, an officer who repeated the sentence after the judge, also DEEMSTER, DOOMSMAN, DOOMSTER [n]\n",
  "DEMPT": "DEEM, to hold as an opinion [v]\n",
  "DEMULCENT": "an emulsifier; something soothing [n -S]\n",
  "DEMULCENTS": "DEMULCENT, an emulsifier; something soothing [n]\n",
  "DEMULSIFICATION": "the act of demulsifying [n]\n",
  "DEMULSIFIED": "DEMULSIFY, to separate from an emulsion [v]\n",
  "DEMULSIFIER": "an agent to prevent emulsion [n -S]\n",
  "DEMULSIFIERS": "DEMULSIFIER, an agent to prevent emulsion [n]\n",
  "DEMULSIFIES": "DEMULSIFY, to separate from an emulsion [v]\n",
  "DEMULSIFY": "to separate from an emulsion [v DEMULSIFIED, DEMULSIFYING, DEMULSIFIES]\n",
  "DEMULSIFYING": "DEMULSIFY, to separate from an emulsion [v]\n",
  "DEMULTIPLEXER": "an electronic device that separates a multiplex signal into its component parts [n -S]\n",
  "DEMULTIPLEXERS": "DEMULTIPLEXER, an electronic device that separates a multiplex signal into its component parts [n]\n",
  "DEMUR": "to object [v DEMURRED, DEMURRING, DEMURS]\n",
  "DEMURE": "shy and modest [adj DEMURER, DEMUREST, DEMURELY] / to look modestly [v DEMURED, DEMURING, DEMURES]\n",
  "DEMURED": "DEMURE, to look modestly [v]\n",
  "DEMURELY": "DEMURE, shy and modest [adv]\n",
  "DEMURENESS": "the state of being demure [n -ES]\n",
  "DEMURENESSES": "DEMURENESS, the state of being demure [n]\n",
  "DEMURER": "DEMURE, shy and modest [adj]\n",
  "DEMURES": "DEMURE, to look modestly [v]\n",
  "DEMUREST": "DEMURE, shy and modest [adj]\n",
  "DEMURING": "DEMURE, to look modestly [v]\n",
  "DEMURRABLE": "that may be demurred to [adj]\n",
  "DEMURRAGE": "undue delay or detention of a vessel, railway wagon, etc., and thus in the completion of a contract; compensation for such detention [n -S]\n",
  "DEMURRAGES": "DEMURRAGE, undue delay or detention of a vessel, railway wagon, etc., and thus in the completion of a contract; compensation for such detention [n]\n",
  "DEMURRAL": "the act of demurring [n -S]\n",
  "DEMURRALS": "DEMURRAL, the act of demurring [n]\n",
  "DEMURRED": "DEMUR, to object [v]\n",
  "DEMURRER": "one who demurs [n -S]\n",
  "DEMURRERS": "DEMURRER, one who demurs [n]\n",
  "DEMURRING": "DEMUR, to object [v]\n",
  "DEMURS": "DEMUR, to object [v]\n",
  "DEMUTUALISATION": "the process of demutualising, also DEMUTUALIZATION [n]\n",
  "DEMUTUALISE": "of a mutual institution, to become a public company, also DEMUTUALIZE [v DEMUTUALISED, DEMUTUALISING, DEMUTUALISES]\n",
  "DEMUTUALISED": "DEMUTUALISE, of a mutual institution, to become a public company, also DEMUTUALIZE [v]\n",
  "DEMUTUALISES": "DEMUTUALISE, of a mutual institution, to become a public company, also DEMUTUALIZE [v]\n",
  "DEMUTUALISING": "DEMUTUALISE, of a mutual institution, to become a public company, also DEMUTUALIZE [v]\n",
  "DEMUTUALIZATION": "the process of demutualizing, also DEMUTUALISATION [n]\n",
  "DEMUTUALIZE": "of a company, esp. a building society or other financial institution, to convert from a mutual company to one owned by stock- or shareholders, also DEMUTUALISE [v DEMUTUALIZED, DEMUTUALIZING, DEMUTUALIZES]\n",
  "DEMUTUALIZED": "DEMUTUALIZE, of a company, esp. a building society or other financial institution, to convert from a mutual company to one owned by stock- or shareholders, also DEMUTUALISE [v]\n",
  "DEMUTUALIZES": "DEMUTUALIZE, of a company, esp. a building society or other financial institution, to convert from a mutual company to one owned by stock- or shareholders, also DEMUTUALISE [v]\n",
  "DEMUTUALIZING": "DEMUTUALIZE, of a company, esp. a building society or other financial institution, to convert from a mutual company to one owned by stock- or shareholders, also DEMUTUALISE [v]\n",
  "DEMY": "a size of paper [n DEMIES]\n",
  "DEMYELINATE": "to destroy the myelin (of nerve fibres) [v DEMYELINATED, DEMYELINATING, DEMYELINATES]\n",
  "DEMYELINATED": "DEMYELINATE, to destroy the myelin (of nerve fibres) [v]\n",
  "DEMYELINATES": "DEMYELINATE, to destroy the myelin (of nerve fibres) [v]\n",
  "DEMYELINATING": "DEMYELINATE, to destroy the myelin (of nerve fibres) [v]\n",
  "DEMYELINATION": "the act of destroying the myelin (of nerve fibres) [n -S]\n",
  "DEMYELINATIONS": "DEMYELINATION, the act of destroying the myelin (of nerve fibres) [n]\n",
  "DEMYSHIP": "a minor scholarship [n -S]\n",
  "DEMYSHIPS": "DEMYSHIP, a minor scholarship [n]\n",
  "DEMYSTIFICATION": "the act of demystifying [n]\n",
  "DEMYSTIFIED": "DEMYSTIFY, to remove the mystery from [v]\n",
  "DEMYSTIFIES": "DEMYSTIFY, to remove the mystery from [v]\n",
  "DEMYSTIFY": "to remove the mystery from [v DEMYSTIFIED, DEMYSTIFYING, DEMYSTIFIES]\n",
  "DEMYSTIFYING": "DEMYSTIFY, to remove the mystery from [v]\n",
  "DEMYTHIFICATION": "the process of demythifying [n]\n",
  "DEMYTHIFIED": "DEMYTHIFY, to remove the mythical characteristics from (a person) [v]\n",
  "DEMYTHIFIES": "DEMYTHIFY, to remove the mythical characteristics from (a person) [v]\n",
  "DEMYTHIFY": "to remove the mythical characteristics from (a person) [v DEMYTHIFIED, DEMYTHIFYING, DEMYTHIFIES]\n",
  "DEMYTHIFYING": "DEMYTHIFY, to remove the mythical characteristics from (a person) [v]\n",
  "DEMYTHOLOGISE": "to remove mythology from in order to arrive at the basic meaning, also DEMYTHOLOGIZE [v DEMYTHOLOGISED, DEMYTHOLOGISING, DEMYTHOLOGISES]\n",
  "DEMYTHOLOGISED": "DEMYTHOLOGISE, to remove mythology from in order to arrive at the basic meaning, also DEMYTHOLOGIZE [v]\n",
  "DEMYTHOLOGISER": "one who demythologises, also DEMYTHOLOGIZER [n -S]\n",
  "DEMYTHOLOGISERS": "DEMYTHOLOGISER, one who demythologises, also DEMYTHOLOGIZER [n]\n",
  "DEMYTHOLOGISES": "DEMYTHOLOGISE, to remove mythology from in order to arrive at the basic meaning, also DEMYTHOLOGIZE [v]\n",
  "DEMYTHOLOGISING": "DEMYTHOLOGISE, to remove mythology from in order to arrive at the basic meaning, also DEMYTHOLOGIZE [v]\n",
  "DEMYTHOLOGIZE": "to divest of mythological forms in order to uncover the meaning underlying them, also DEMYTHOLOGISE [v DEMYTHOLOGIZED, DEMYTHOLOGIZING, DEMYTHOLOGIZES]\n",
  "DEMYTHOLOGIZED": "DEMYTHOLOGIZE, to divest of mythological forms in order to uncover the meaning underlying them, also DEMYTHOLOGISE [v]\n",
  "DEMYTHOLOGIZER": "one who demythologizes, also DEMYTHOLOGISER [n -S]\n",
  "DEMYTHOLOGIZERS": "DEMYTHOLOGIZER, one who demythologizes, also DEMYTHOLOGISER [n]\n",
  "DEMYTHOLOGIZES": "DEMYTHOLOGIZE, to divest of mythological forms in order to uncover the meaning underlying them, also DEMYTHOLOGISE [v]\n",
  "DEMYTHOLOGIZING": "DEMYTHOLOGIZE, to divest of mythological forms in order to uncover the meaning underlying them, also DEMYTHOLOGISE [v]\n",
  "DEN": "to live in a lair [v DENNED, DENNING, DENS]\n",
  "DENAR": "a monetary unit of Macedonia [n DENARS or DENARI]\n",
  "DENARI": "DENAR, a monetary unit of Macedonia [n]\n",
  "DENARIES": "DENARY, a group of ten [n]\n",
  "DENARII": "DENARIUS, (Latin) a coin of ancient Rome [n]\n",
  "DENARIUS": "(Latin) a coin of ancient Rome [n DENARII]\n",
  "DENARS": "DENAR, a monetary unit of Macedonia [n]\n",
  "DENARY": "a group of ten [n DENARIES]\n",
  "DENATIONALISE": "to deprive of national rights or character; to return from state to private ownership, also DENATIONALIZE [v DENATIONALISED, DENATIONALISING, DENATIONALISES]\n",
  "DENATIONALISED": "DENATIONALISE, to deprive of national rights or character; to return from state to private ownership, also DENATIONALIZE [v]\n",
  "DENATIONALISES": "DENATIONALISE, to deprive of national rights or character; to return from state to private ownership, also DENATIONALIZE [v]\n",
  "DENATIONALISING": "DENATIONALISE, to deprive of national rights or character; to return from state to private ownership, also DENATIONALIZE [v]\n",
  "DENATIONALIZE": "to divest of national character or rights, also DENATIONALISE [v DENATIONALIZED, DENATIONALIZING, DENATIONALIZES]\n",
  "DENATIONALIZED": "DENATIONALIZE, to divest of national character or rights, also DENATIONALISE [v]\n",
  "DENATIONALIZES": "DENATIONALIZE, to divest of national character or rights, also DENATIONALISE [v]\n",
  "DENATIONALIZING": "DENATIONALIZE, to divest of national character or rights, also DENATIONALISE [v]\n",
  "DENATURALISE": "to make unnatural, also DENATURALIZE [v DENATURALISED, DENATURALISING, DENATURALISES]\n",
  "DENATURALISED": "DENATURALISE, to make unnatural, also DENATURALIZE [v]\n",
  "DENATURALISES": "DENATURALISE, to make unnatural, also DENATURALIZE [v]\n",
  "DENATURALISING": "DENATURALISE, to make unnatural, also DENATURALIZE [v]\n",
  "DENATURALIZE": "to make unnatural, also DENATURALISE [v DENATURALIZED, DENATURALIZING, DENATURALIZES]\n",
  "DENATURALIZED": "DENATURALIZE, to make unnatural, also DENATURALISE [v]\n",
  "DENATURALIZES": "DENATURALIZE, to make unnatural, also DENATURALISE [v]\n",
  "DENATURALIZING": "DENATURALIZE, to make unnatural, also DENATURALISE [v]\n",
  "DENATURANT": "a substance used to denature another [n -S]\n",
  "DENATURANTS": "DENATURANT, a substance used to denature another [n]\n",
  "DENATURATION": "the act of denaturing [n -S]\n",
  "DENATURATIONS": "DENATURATION, the act of denaturing [n]\n",
  "DENATURE": "to deprive of natural qualities [v DENATURED, DENATURING, DENATURES]\n",
  "DENATURED": "DENATURE, to deprive of natural qualities [v]\n",
  "DENATURES": "DENATURE, to deprive of natural qualities [v]\n",
  "DENATURING": "DENATURE, to deprive of natural qualities [v]\n",
  "DENATURISE": "to remove the nature from, also DENATURIZE [v DENATURISED, DENATURISING, DENATURISES]\n",
  "DENATURISED": "DENATURISE, to remove the nature from, also DENATURIZE [v]\n",
  "DENATURISES": "DENATURISE, to remove the nature from, also DENATURIZE [v]\n",
  "DENATURISING": "DENATURISE, to remove the nature from, also DENATURIZE [v]\n",
  "DENATURIZE": "to remove the nature from, also DENATURISE [v DENATURIZED, DENATURIZING, DENATURIZES]\n",
  "DENATURIZED": "DENATURIZE, to remove the nature from, also DENATURISE [v]\n",
  "DENATURIZES": "DENATURIZE, to remove the nature from, also DENATURISE [v]\n",
  "DENATURIZING": "DENATURIZE, to remove the nature from, also DENATURISE [v]\n",
  "DENAY": "(obsolete) to declare to be untrue, also DENY [v -ED, -ING, -S]\n",
  "DENAYED": "DENAY, (obsolete) to declare to be untrue, also DENY [v]\n",
  "DENAYING": "DENAY, (obsolete) to declare to be untrue, also DENY [v]\n",
  "DENAYS": "DENAY, (obsolete) to declare to be untrue, also DENY [v]\n",
  "DENAZIFICATION": "the act of denazifying [n -S]\n",
  "DENAZIFICATIONS": "DENAZIFICATION, the act of denazifying [n]\n",
  "DENAZIFIED": "DENAZIFY, to rid of Nazism [v]\n",
  "DENAZIFIES": "DENAZIFY, to rid of Nazism [v]\n",
  "DENAZIFY": "to rid of Nazism [v DENAZIFIED, DENAZIFYING, DENAZIFIES]\n",
  "DENAZIFYING": "DENAZIFY, to rid of Nazism [v]\n",
  "DENCH": "(slang) excellent [adj]\n",
  "DENDRACHATE": "moss agate [n -S]\n",
  "DENDRACHATES": "DENDRACHATE, moss agate [n]\n",
  "DENDRIFORM": "shaped like a tree, e.g. a dendriform ulcer [adj]\n",
  "DENDRIMER": "a polymer that has a treelike branched molecular structure [n -S]\n",
  "DENDRIMERS": "DENDRIMER, a polymer that has a treelike branched molecular structure [n]\n",
  "DENDRITE": "a branched part of a nerve cell, also DENDRON [n -S]\n",
  "DENDRITES": "DENDRITE, a branched part of a nerve cell, also DENDRON [n]\n",
  "DENDRITIC": "of or like a dendrite, also DENDRITICAL [adj DENDRITICALLY]\n",
  "DENDRITICAL": "of or like a dendrite, also DENDRITIC [adj DENDRITICALLY]\n",
  "DENDRITICALLY": "DENDRITICAL, of or like a dendrite, also DENDRITIC [adv]\n",
  "DENDROBIUM": "a kind of epiphytic orchid [n -S]\n",
  "DENDROBIUMS": "DENDROBIUM, a kind of epiphytic orchid [n]\n",
  "DENDROGLYPH": "an ancient carving on a tree [n -S]\n",
  "DENDROGLYPHS": "DENDROGLYPH, an ancient carving on a tree [n]\n",
  "DENDROGRAM": "a branching diagram to show e.g. evolutionary descent [n -S]\n",
  "DENDROGRAMS": "DENDROGRAM, a branching diagram to show e.g. evolutionary descent [n]\n",
  "DENDROID": "treelike, also DENDROIDAL [adj] / a kind of fossil marine invertebrate [n -S]\n",
  "DENDROIDAL": "treelike, also DENDROID [adj]\n",
  "DENDROIDS": "DENDROID, a kind of fossil marine invertebrate [n]\n",
  "DENDROLATRIES": "DENDROLATRY, worship of trees [n]\n",
  "DENDROLATRY": "worship of trees [n DENDROLATRIES]\n",
  "DENDROLOGIC": "relating to dendrology, the study of trees, also DENDROLOGICAL [adj]\n",
  "DENDROLOGICAL": "relating to dendrology, the study of trees, also DENDROLOGIC [adj]\n",
  "DENDROLOGIES": "DENDROLOGY, the study of trees [n]\n",
  "DENDROLOGIST": "a student of dendrology [n -S]\n",
  "DENDROLOGISTS": "DENDROLOGIST, a student of dendrology [n]\n",
  "DENDROLOGOUS": "related to dendrology, the study of trees [adj]\n",
  "DENDROLOGY": "the study of trees [n DENDROLOGIES]\n",
  "DENDROMETER": "an instrument for measuring trees [n -S]\n",
  "DENDROMETERS": "DENDROMETER, an instrument for measuring trees [n]\n",
  "DENDRON": "(Greek) a branched part of a nerve cell, also DENDRITE [n -S]\n",
  "DENDRONS": "DENDRON, (Greek) a branched part of a nerve cell, also DENDRITE [n]\n",
  "DENDROPHIS": "a snake of the genus Dendrophis, a tree snake [n -ES]\n",
  "DENDROPHISES": "DENDROPHIS, a snake of the genus Dendrophis, a tree snake [n]\n",
  "DENE": "a sandy tract or dune by the seashore [n -S]\n",
  "DENEGATION": "denial [n -S]\n",
  "DENEGATIONS": "DENEGATION, denial [n]\n",
  "DENERVATE": "to deprive of nerve endings [v DENERVATED, DENERVATING, DENERVATES]\n",
  "DENERVATED": "DENERVATE, to deprive of nerve endings [v]\n",
  "DENERVATES": "DENERVATE, to deprive of nerve endings [v]\n",
  "DENERVATING": "DENERVATE, to deprive of nerve endings [v]\n",
  "DENERVATION": "the act of denervating [n -S]\n",
  "DENERVATIONS": "DENERVATION, the act of denervating [n]\n",
  "DENES": "DENE, a sandy tract or dune by the seashore [n]\n",
  "DENET": "to market a book outside the constraints of the Net Book Agreement [v DENETTED, DENETTING, DENETS]\n",
  "DENETS": "DENET, to market a book outside the constraints of the Net Book Agreement [v]\n",
  "DENETTED": "DENET, to market a book outside the constraints of the Net Book Agreement [v]\n",
  "DENETTING": "DENET, to market a book outside the constraints of the Net Book Agreement [v]\n",
  "DENGUE": "(Swahili) an acute tropical epidemic fever, aka breakbone fever [n -S]\n",
  "DENGUES": "DENGUE, (Swahili) an acute tropical epidemic fever, aka breakbone fever [n]\n",
  "DENI": "one hundredth part of a denar [n -S]\n",
  "DENIABILITIES": "DENIABILITY, the ability to deny something esp. on the basis of being officially uninformed [n]\n",
  "DENIABILITY": "the ability to deny something esp. on the basis of being officially uninformed [n DENIABILITIES]\n",
  "DENIABLE": "capable of being denied [adj DENIABLY]\n",
  "DENIABLY": "DENIABLE, capable of being denied [adv]\n",
  "DENIAL": "the act of denying [n -S]\n",
  "DENIALIST": "a person who refuses to accept something that is regarded as an established fact [n -S]\n",
  "DENIALISTS": "DENIALIST, a person who refuses to accept something that is regarded as an established fact [n]\n",
  "DENIALS": "DENIAL, the act of denying [n]\n",
  "DENIED": "DENY, to declare to be untrue, also DENAY [v]\n",
  "DENIER": "(French) a unit of weight for silk, rayon or nylon yarn [n -S]\n",
  "DENIERS": "DENIER, (French) a unit of weight for silk, rayon or nylon yarn [n]\n",
  "DENIES": "DENY, to declare to be untrue, also DENAY [v]\n",
  "DENIGRATE": "to blacken, defame [v DENIGRATED, DENIGRATING, DENIGRATES]\n",
  "DENIGRATED": "DENIGRATE, to blacken, defame [v]\n",
  "DENIGRATES": "DENIGRATE, to blacken, defame [v]\n",
  "DENIGRATING": "DENIGRATE, to blacken, defame [v]\n",
  "DENIGRATION": "the act of denigrating [n -S]\n",
  "DENIGRATIONS": "DENIGRATION, the act of denigrating [n]\n",
  "DENIGRATIVE": "serving to denigrate, also DENIGRATORY [adj]\n",
  "DENIGRATOR": "one who, or that which, blackens [n -S]\n",
  "DENIGRATORS": "DENIGRATOR, one who, or that which, blackens [n]\n",
  "DENIGRATORY": "serving to denigrate, also DENIGRATIVE [adj]\n",
  "DENIM": "(French) a coloured twilled cotton fabric for jeans, overalls, etc. [n -S]\n",
  "DENIMED": "wearing denim [adj]\n",
  "DENIMS": "DENIM, (French) a coloured twilled cotton fabric for jeans, overalls, etc. [n]\n",
  "DENIS": "DENI, one hundredth part of a denar [n]\n",
  "DENISATION": "the act of making one a denizen or adopted citizen; naturalization, also DENIZATION [n -S]\n",
  "DENISATIONS": "DENISATION, the act of making one a denizen or adopted citizen; naturalization, also DENIZATION [n]\n",
  "DENITRATE": "to free from nitric acid or other nitrogen compounds [v DENITRATED, DENITRATING, DENITRATES]\n",
  "DENITRATED": "DENITRATE, to free from nitric acid or other nitrogen compounds [v]\n",
  "DENITRATES": "DENITRATE, to free from nitric acid or other nitrogen compounds [v]\n",
  "DENITRATING": "DENITRATE, to free from nitric acid or other nitrogen compounds [v]\n",
  "DENITRATION": "the removal of nitrogen or its compounds, also DENITRIFICATION [n -S]\n",
  "DENITRATIONS": "DENITRATION, the removal of nitrogen or its compounds, also DENITRIFICATION [n]\n",
  "DENITRIFICATION": "the removal of nitrogen or its compounds, also DENITRATION [n]\n",
  "DENITRIFICATOR": "an agent that denitrifies [n -S]\n",
  "DENITRIFICATORS": "DENITRIFICATOR, an agent that denitrifies [n]\n",
  "DENITRIFIED": "DENITRIFY, to deprive of, or free from, nitrogen [v]\n",
  "DENITRIFIER": "an agent that removes nitrogen [n -S]\n",
  "DENITRIFIERS": "DENITRIFIER, an agent that removes nitrogen [n]\n",
  "DENITRIFIES": "DENITRIFY, to deprive of, or free from, nitrogen [v]\n",
  "DENITRIFY": "to deprive of, or free from, nitrogen [v DENITRIFIED, DENITRIFYING, DENITRIFIES]\n",
  "DENITRIFYING": "DENITRIFY, to deprive of, or free from, nitrogen [v]\n",
  "DENIZATION": "the act of making one a denizen or adopted citizen; naturalization, also DENISATION [n -S]\n",
  "DENIZATIONS": "DENIZATION, the act of making one a denizen or adopted citizen; naturalization, also DENISATION [n]\n",
  "DENIZEN": "a dweller [n -S] / to naturalize a person, word or expression [v -ED, -ING, -S]\n",
  "DENIZENED": "DENIZEN, to naturalize a person, word or expression [v]\n",
  "DENIZENING": "DENIZEN, to naturalize a person, word or expression [v]\n",
  "DENIZENS": "DENIZEN, to naturalize a person, word or expression [v]\n",
  "DENIZENSHIP": "the state of being a denizen [n -S]\n",
  "DENIZENSHIPS": "DENIZENSHIP, the state of being a denizen [n]\n",
  "DENNED": "DEN, to live in a lair [v]\n",
  "DENNET": "a nineteenth century horse gig [n -S]\n",
  "DENNETS": "DENNET, a nineteenth century horse gig [n]\n",
  "DENNING": "DEN, to live in a lair [v]\n",
  "DENOMINABLE": "capable of being denominated [adj]\n",
  "DENOMINAL": "derived from a noun [adj]\n",
  "DENOMINATE": "to give a name to [v DENOMINATED, DENOMINATING, DENOMINATES]\n",
  "DENOMINATED": "DENOMINATE, to give a name to [v]\n",
  "DENOMINATES": "DENOMINATE, to give a name to [v]\n",
  "DENOMINATING": "DENOMINATE, to give a name to [v]\n",
  "DENOMINATION": "an act of denominating [n -S]\n",
  "DENOMINATIONAL": "relating to denomination [adj]\n",
  "DENOMINATIONS": "DENOMINATION, an act of denominating [n]\n",
  "DENOMINATIVE": "giving a title [adj DENOMINATIVELY] / a word derived from a noun or adjective [n -S]\n",
  "DENOMINATIVELY": "DENOMINATIVE, giving a title [adv]\n",
  "DENOMINATIVES": "DENOMINATIVE, a word derived from a noun or adjective [n]\n",
  "DENOMINATOR": "the divisor of a fraction [n -S]\n",
  "DENOMINATORS": "DENOMINATOR, the divisor of a fraction [n]\n",
  "DENOTABLE": "capable of being denoted or marked [adj]\n",
  "DENOTATE": "(obsolete) to denote [v DENOTATED, DENOTATING, DENOTATES]\n",
  "DENOTATED": "DENOTATE, (obsolete) to denote [v]\n",
  "DENOTATES": "DENOTATE, (obsolete) to denote [v]\n",
  "DENOTATING": "DENOTATE, (obsolete) to denote [v]\n",
  "DENOTATION": "the marking off or separation of anything [n -S]\n",
  "DENOTATIONS": "DENOTATION, the marking off or separation of anything [n]\n",
  "DENOTATIVE": "having power to denote [adj DENOTATIVELY]\n",
  "DENOTATIVELY": "DENOTATIVE, having power to denote [adv]\n",
  "DENOTE": "to indicate [v DENOTED, DENOTING, DENOTES]\n",
  "DENOTED": "DENOTE, to indicate [v]\n",
  "DENOTEMENT": "(Shakespeare) a sign, indication [n -S]\n",
  "DENOTEMENTS": "DENOTEMENT, (Shakespeare) a sign, indication [n]\n",
  "DENOTES": "DENOTE, to indicate [v]\n",
  "DENOTING": "DENOTE, to indicate [v]\n",
  "DENOTIVE": "indicative [adj]\n",
  "DENOUEMENT": "(French) the final resolution of the plot of a story or a complex sequence of events [n -S]\n",
  "DENOUEMENTS": "DENOUEMENT, (French) the final resolution of the plot of a story or a complex sequence of events [n]\n",
  "DENOUNCE": "to condemn openly [v DENOUNCED, DENOUNCING, DENOUNCES]\n",
  "DENOUNCED": "DENOUNCE, to condemn openly [v]\n",
  "DENOUNCEMENT": "the act of denouncing [n -S]\n",
  "DENOUNCEMENTS": "DENOUNCEMENT, the act of denouncing [n]\n",
  "DENOUNCER": "one who denounces [n -S]\n",
  "DENOUNCERS": "DENOUNCER, one who denounces [n]\n",
  "DENOUNCES": "DENOUNCE, to condemn openly [v]\n",
  "DENOUNCING": "DENOUNCE, to condemn openly [v]\n",
  "DENS": "DEN, to live in a lair [v]\n",
  "DENSE": "compact [adj DENSER, DENSEST, DENSELY]\n",
  "DENSELY": "DENSE, compact [adv]\n",
  "DENSENESS": "the state of being dense [n -ES]\n",
  "DENSENESSES": "DENSENESS, the state of being dense [n]\n",
  "DENSER": "DENSE, compact [adj]\n",
  "DENSEST": "DENSE, compact [adj]\n",
  "DENSIFICATION": "the act of densifying [n -S]\n",
  "DENSIFICATIONS": "DENSIFICATION, the act of densifying [n]\n",
  "DENSIFIED": "DENSIFY, to increase the density of [v]\n",
  "DENSIFIER": "an agent that densifies [n -S]\n",
  "DENSIFIERS": "DENSIFIER, an agent that densifies [n]\n",
  "DENSIFIES": "DENSIFY, to increase the density of [v]\n",
  "DENSIFY": "to increase the density of [v DENSIFIED, DENSIFYING, DENSIFIES]\n",
  "DENSIFYING": "DENSIFY, to increase the density of [v]\n",
  "DENSIMETER": "an instrument for measuring the closeness of grain of a substance [n -S]\n",
  "DENSIMETERS": "DENSIMETER, an instrument for measuring the closeness of grain of a substance [n]\n",
  "DENSIMETRIC": "measurement by densimeter [adj]\n",
  "DENSIMETRIES": "DENSIMETRY, the measurement of relative density, using a densimeter [n]\n",
  "DENSIMETRY": "the measurement of relative density, using a densimeter [n DENSIMETRIES]\n",
  "DENSITIES": "DENSITY, the state of being dense [n]\n",
  "DENSITOMETER": "an instrument for measuring optical or photographic density [n -S]\n",
  "DENSITOMETERS": "DENSITOMETER, an instrument for measuring optical or photographic density [n]\n",
  "DENSITOMETRIC": "relating to densitometry [adj]\n",
  "DENSITOMETRIES": "DENSITOMETRY, measurement by densitometer [n]\n",
  "DENSITOMETRY": "measurement by densitometer [n DENSITOMETRIES]\n",
  "DENSITY": "the state of being dense [n DENSITIES]\n",
  "DENT": "to make a depression in [v -ED, -ING, -S]\n",
  "DENTAL": "relating to teeth [adj DENTALLY] / a sound produced by applying the tongue to the teeth or gums [n -S]\n",
  "DENTALIA": "DENTALIUM, (Latin) any mollusc or shell of the genus Dentalium, of scaphopod molluscs whose shells resemble an elephant's tusk [n]\n",
  "DENTALISE": "to make (a sound) dental, also DENTALIZE [v DENTALISED, DENTALISING, DENTALISES]\n",
  "DENTALISED": "DENTALISE, to make (a sound) dental, also DENTALIZE [v]\n",
  "DENTALISES": "DENTALISE, to make (a sound) dental, also DENTALIZE [v]\n",
  "DENTALISING": "DENTALISE, to make (a sound) dental, also DENTALIZE [v]\n",
  "DENTALITIES": "DENTALITY, use of the teeth in pronouncing words [n]\n",
  "DENTALITY": "use of the teeth in pronouncing words [n DENTALITIES]\n",
  "DENTALIUM": "(Latin) any mollusc or shell of the genus Dentalium, of scaphopod molluscs whose shells resemble an elephant's tusk [n DENTALIA or DENTALIUMS]\n",
  "DENTALIUMS": "DENTALIUM, (Latin) any mollusc or shell of the genus Dentalium, of scaphopod molluscs whose shells resemble an elephant's tusk [n]\n",
  "DENTALIZE": "to make (a sound) dental, also DENTALISE [v DENTALIZED, DENTALIZING, DENTALIZES]\n",
  "DENTALIZED": "DENTALIZE, to make (a sound) dental, also DENTALISE [v]\n",
  "DENTALIZES": "DENTALIZE, to make (a sound) dental, also DENTALISE [v]\n",
  "DENTALIZING": "DENTALIZE, to make (a sound) dental, also DENTALISE [v]\n",
  "DENTALLY": "DENTAL, relating to teeth [adv]\n",
  "DENTALS": "DENTAL, a sound produced by applying the tongue to the teeth or gums [n]\n",
  "DENTARIA": "any plant of the genus Dentaria, that includes toothwort [n -S]\n",
  "DENTARIAS": "DENTARIA, any plant of the genus Dentaria, that includes toothwort [n]\n",
  "DENTARIES": "DENTARY, a bone of the lower jaw [n]\n",
  "DENTARY": "a bone of the lower jaw [n DENTARIES]\n",
  "DENTATE": "having teeth, also DENTATED [adj]\n",
  "DENTATED": "having teeth, also DENTATE [adj]\n",
  "DENTATELY": "DENTATE, having teeth, also DENTATED [adv]\n",
  "DENTATION": "the condition of being dentate [n -S]\n",
  "DENTATIONS": "DENTATION, the condition of being dentate [n]\n",
  "DENTED": "DENT, to make a depression in [v]\n",
  "DENTEL": "one of a row of tooth-shaped square blocks, also DENTIL [n -S]\n",
  "DENTELLE": "(French) lace, lacework [n -S]\n",
  "DENTELLES": "DENTELLE, (French) lace, lacework [n]\n",
  "DENTELS": "DENTEL, one of a row of tooth-shaped square blocks, also DENTIL [n]\n",
  "DENTEX": "(Latin) a strongly toothed voracious fish related to perch, found in the Mediterranean [n -ES]\n",
  "DENTEXES": "DENTEX, (Latin) a strongly toothed voracious fish related to perch, found in the Mediterranean [n]\n",
  "DENTICARE": "a plan for providing dental care funded by some provincial governments [n -S]\n",
  "DENTICARES": "DENTICARE, a plan for providing dental care funded by some provincial governments [n]\n",
  "DENTICLE": "a small toothlike structure, as on the skin of a shark [n -S]\n",
  "DENTICLES": "DENTICLE, a small toothlike structure, as on the skin of a shark [n]\n",
  "DENTICULATE": "finely dentate or serrate, also DENTICULATED [adj DENTICULATELY]\n",
  "DENTICULATED": "finely dentate or serrate, also DENTICULATE [adj]\n",
  "DENTICULATELY": "DENTICULATE, finely dentate or serrate, also DENTICULATED [adv]\n",
  "DENTICULATION": "the state of being denticulate [n -S]\n",
  "DENTICULATIONS": "DENTICULATION, the state of being denticulate [n]\n",
  "DENTIFORM": "shaped like a tooth [adj]\n",
  "DENTIFRICE": "a powder or other substance to be used in cleaning the teeth; tooth powder [n -S]\n",
  "DENTIFRICES": "DENTIFRICE, a powder or other substance to be used in cleaning the teeth; tooth powder [n]\n",
  "DENTIGEROUS": "having teeth [adj]\n",
  "DENTIL": "one of a row of tooth-shaped square blocks in a moulding, also DENTEL [n -S]\n",
  "DENTILABIAL": "labiodental [adj]\n",
  "DENTILED": "decorated with dentils [adj]\n",
  "DENTILINGUAL": "pronounced (as 'th') with tongue against teeth [adj] / a dentilingual sound [n -S]\n",
  "DENTILINGUALS": "DENTILINGUAL, a dentilingual sound [n]\n",
  "DENTILS": "DENTIL, one of a row of tooth-shaped square blocks in a moulding, also DENTEL [n]\n",
  "DENTIN": "the hard substance forming the body of a tooth, also DENTINE [n -S]\n",
  "DENTINAL": "relating to dentine, an ivorylike material making up teeth [adj]\n",
  "DENTINE": "the hard substance forming the body of a tooth, also DENTIN [n -S]\n",
  "DENTINES": "DENTINE, the hard substance forming the body of a tooth, also DENTIN [n]\n",
  "DENTING": "DENT, to make a depression in [v]\n",
  "DENTINS": "DENTIN, the hard substance forming the body of a tooth, also DENTINE [n]\n",
  "DENTIROSTRAL": "with notched beak [adj]\n",
  "DENTIST": "a tooth doctor [n -S]\n",
  "DENTISTRIES": "DENTISTRY, the work of a dentist [n]\n",
  "DENTISTRY": "the work of a dentist [n DENTISTRIES]\n",
  "DENTISTS": "DENTIST, a tooth doctor [n]\n",
  "DENTITION": "the cutting or growing of teeth [n -S]\n",
  "DENTITIONS": "DENTITION, the cutting or growing of teeth [n]\n",
  "DENTOID": "shaped like a tooth [adj]\n",
  "DENTS": "DENT, to make a depression in [v]\n",
  "DENTULOUS": "having teeth [adj]\n",
  "DENTURAL": "relating to dentures [adj]\n",
  "DENTURE": "a set of teeth [n -S]\n",
  "DENTURES": "DENTURE, a set of teeth [n]\n",
  "DENTURISM": "the practice by denturists of making artificial dentures and fitting them to patients [n -S]\n",
  "DENTURISMS": "DENTURISM, the practice by denturists of making artificial dentures and fitting them to patients [n]\n",
  "DENTURIST": "one who makes dentures [n -S]\n",
  "DENTURISTS": "DENTURIST, one who makes dentures [n]\n",
  "DENUCLEARISE": "to make nonnuclear, also DENUCLEARIZE [v DENUCLEARISED, DENUCLEARISING, DENUCLEARISES]\n",
  "DENUCLEARISED": "DENUCLEARISE, to make nonnuclear, also DENUCLEARIZE [v]\n",
  "DENUCLEARISES": "DENUCLEARISE, to make nonnuclear, also DENUCLEARIZE [v]\n",
  "DENUCLEARISING": "DENUCLEARISE, to make nonnuclear, also DENUCLEARIZE [v]\n",
  "DENUCLEARIZE": "to make nonnuclear, also DENUCLEARISE [v DENUCLEARIZED, DENUCLEARIZING, DENUCLEARIZES]\n",
  "DENUCLEARIZED": "DENUCLEARIZE, to make nonnuclear, also DENUCLEARISE [v]\n",
  "DENUCLEARIZES": "DENUCLEARIZE, to make nonnuclear, also DENUCLEARISE [v]\n",
  "DENUCLEARIZING": "DENUCLEARIZE, to make nonnuclear, also DENUCLEARISE [v]\n",
  "DENUDATE": "to strip of all covering, also DENUDE [v DENUDATED, DENUDATING, DENUDATES]\n",
  "DENUDATED": "DENUDATE, to strip of all covering, also DENUDE [v]\n",
  "DENUDATES": "DENUDATE, to strip of all covering, also DENUDE [v]\n",
  "DENUDATING": "DENUDATE, to strip of all covering, also DENUDE [v]\n",
  "DENUDATION": "the act of making bare [n -S]\n",
  "DENUDATIONS": "DENUDATION, the act of making bare [n]\n",
  "DENUDE": "to strip of all covering, also DENUDATE [v DENUDED, DENUDING, DENUDES]\n",
  "DENUDED": "DENUDE, to strip of all covering, also DENUDATE [v]\n",
  "DENUDEMENT": "the act of denuding [n -S]\n",
  "DENUDEMENTS": "DENUDEMENT, the act of denuding [n]\n",
  "DENUDER": "one who denudes [n -S]\n",
  "DENUDERS": "DENUDER, one who denudes [n]\n",
  "DENUDES": "DENUDE, to strip of all covering, also DENUDATE [v]\n",
  "DENUDING": "DENUDE, to strip of all covering, also DENUDATE [v]\n",
  "DENUMERABILITY": "the state of being denumerable [n]\n",
  "DENUMERABLE": "that can be enumerated [adj DENUMERABLY]\n",
  "DENUMERABLY": "DENUMERABLE, that can be enumerated [adv]\n",
  "DENUNCIATE": "to denounce; to condemn publicly or solemnly [v DENUNCIATED, DENUNCIATING, DENUNCIATES]\n",
  "DENUNCIATED": "DENUNCIATE, to denounce; to condemn publicly or solemnly [v]\n",
  "DENUNCIATES": "DENUNCIATE, to denounce; to condemn publicly or solemnly [v]\n",
  "DENUNCIATING": "DENUNCIATE, to denounce; to condemn publicly or solemnly [v]\n",
  "DENUNCIATION": "an act of denouncing [n -S]\n",
  "DENUNCIATIONS": "DENUNCIATION, an act of denouncing [n]\n",
  "DENUNCIATIVE": "relating to denunciation [adj]\n",
  "DENUNCIATOR": "one who denunciates [n -S]\n",
  "DENUNCIATORS": "DENUNCIATOR, one who denunciates [n]\n",
  "DENUNCIATORY": "relating to denunciation [adj]\n",
  "DENY": "to declare to be untrue, also DENAY [v DENIED, DENYING, DENIES]\n",
  "DENYING": "DENY, to declare to be untrue, also DENAY [v]\n",
  "DENYINGLY": "DENYING, DENY, to declare to be untrue, also DENAY [adv]\n",
  "DEOBSTRUENT": "something that removes an obstacle [n -S]\n",
  "DEOBSTRUENTS": "DEOBSTRUENT, something that removes an obstacle [n]\n",
  "DEODAND": "a personal chattel which had caused the death of a person, and for that reason was given to God, that is, forfeited to the crown [n -S]\n",
  "DEODANDS": "DEODAND, a personal chattel which had caused the death of a person, and for that reason was given to God, that is, forfeited to the crown [n]\n",
  "DEODAR": "(Sanskrit) an East Indian cedar, also DEODARA [n -S]\n",
  "DEODARA": "(Sanskrit) an East Indian cedar, also DEODAR [n -S]\n",
  "DEODARAS": "DEODARA, (Sanskrit) an East Indian cedar, also DEODAR [n]\n",
  "DEODARS": "DEODAR, (Sanskrit) an East Indian cedar, also DEODARA [n]\n",
  "DEODATE": "(obsolete) a gift to or from God [n -S]\n",
  "DEODATES": "DEODATE, (obsolete) a gift to or from God [n]\n",
  "DEODORANT": "a substance that removes a bad smell [n -S]\n",
  "DEODORANTS": "DEODORANT, a substance that removes a bad smell [n]\n",
  "DEODORISATION": "the act of deodorising, also DEODORIZATION [n -S]\n",
  "DEODORISATIONS": "DEODORISATION, the act of deodorising, also DEODORIZATION [n]\n",
  "DEODORISE": "to take the (usually unpleasant) odour or smell from, also DEODORIZE [v DEODORISED, DEODORISING, DEODORISES]\n",
  "DEODORISED": "DEODORISE, to take the (usually unpleasant) odour or smell from, also DEODORIZE [v]\n",
  "DEODORISER": "a substance that destroys or conceals unpleasant smells, also DEODORIZER [n -S]\n",
  "DEODORISERS": "DEODORISER, a substance that destroys or conceals unpleasant smells, also DEODORIZER [n]\n",
  "DEODORISES": "DEODORISE, to take the (usually unpleasant) odour or smell from, also DEODORIZE [v]\n",
  "DEODORISING": "DEODORISE, to take the (usually unpleasant) odour or smell from, also DEODORIZE [v]\n",
  "DEODORIZATION": "the act of deodorizing, also DEODORISATION [n -S]\n",
  "DEODORIZATIONS": "DEODORIZATION, the act of deodorizing, also DEODORISATION [n]\n",
  "DEODORIZE": "to take the (usually unpleasant) odour or smell from, also DEODORISE [v DEODORIZED, DEODORIZING, DEODORIZES]\n",
  "DEODORIZED": "DEODORIZE, to take the (usually unpleasant) odour or smell from, also DEODORISE [v]\n",
  "DEODORIZER": "a substance that deodorizes, also DEODORISER [n -S]\n",
  "DEODORIZERS": "DEODORIZER, a substance that deodorizes, also DEODORISER [n]\n",
  "DEODORIZES": "DEODORIZE, to take the (usually unpleasant) odour or smell from, also DEODORISE [v]\n",
  "DEODORIZING": "DEODORIZE, to take the (usually unpleasant) odour or smell from, also DEODORISE [v]\n",
  "DEONTIC": "pertaining to deontics, the study of ethics [adj]\n",
  "DEONTICS": "the science of duty, ethics [n]\n",
  "DEONTOLOGICAL": "relating to deontology, the theory or study of moral obligation [adj]\n",
  "DEONTOLOGIES": "DEONTOLOGY, the theory or study of moral obligation [n]\n",
  "DEONTOLOGIST": "a student of deontology [n -S]\n",
  "DEONTOLOGISTS": "DEONTOLOGIST, a student of deontology [n]\n",
  "DEONTOLOGY": "the theory or study of moral obligation [n DEONTOLOGIES]\n",
  "DEOPPILATE": "to free from obstruction [v DEOPPILATED, DEOPPILATING, DEOPPILATES]\n",
  "DEOPPILATED": "DEOPPILATE, to free from obstruction [v]\n",
  "DEOPPILATES": "DEOPPILATE, to free from obstruction [v]\n",
  "DEOPPILATING": "DEOPPILATE, to free from obstruction [v]\n",
  "DEOPPILATION": "the act of deoppilating, freeing from obstruction [n -S]\n",
  "DEOPPILATIONS": "DEOPPILATION, the act of deoppilating, freeing from obstruction [n]\n",
  "DEOPPILATIVE": "any drug which removes obstructions in the body [n -S]\n",
  "DEOPPILATIVES": "DEOPPILATIVE, any drug which removes obstructions in the body [n]\n",
  "DEORBIT": "to come out of orbit [v -ED, -ING, -S]\n",
  "DEORBITED": "DEORBIT, to come out of orbit [v]\n",
  "DEORBITING": "DEORBIT, to come out of orbit [v]\n",
  "DEORBITS": "DEORBIT, to come out of orbit [v]\n",
  "DEOXIDATE": "to deoxidize [v DEOXIDATED, DEOXIDATING, DEOXIDATES]\n",
  "DEOXIDATED": "DEOXIDATE, to deoxidize [v]\n",
  "DEOXIDATES": "DEOXIDATE, to deoxidize [v]\n",
  "DEOXIDATING": "DEOXIDATE, to deoxidize [v]\n",
  "DEOXIDATION": "the act of deoxidizing [n -S]\n",
  "DEOXIDATIONS": "DEOXIDATION, the act of deoxidizing [n]\n",
  "DEOXIDISATION": "the process of deoxidising, also DEOXIDIZATION [n -S]\n",
  "DEOXIDISATIONS": "DEOXIDISATION, the process of deoxidising, also DEOXIDIZATION [n]\n",
  "DEOXIDISE": "to remove oxygen from, also DEOXIDIZE [v DEOXIDISED, DEOXIDISING, DEOXIDISES]\n",
  "DEOXIDISED": "DEOXIDISE, to remove oxygen from, also DEOXIDIZE [v]\n",
  "DEOXIDISER": "a substance that deoxidises, also DEOXIDIZER [n -S]\n",
  "DEOXIDISERS": "DEOXIDISER, a substance that deoxidises, also DEOXIDIZER [n]\n",
  "DEOXIDISES": "DEOXIDISE, to remove oxygen from, also DEOXIDIZE [v]\n",
  "DEOXIDISING": "DEOXIDISE, to remove oxygen from, also DEOXIDIZE [v]\n",
  "DEOXIDIZATION": "the process of deoxidizing, also DEOXIDISATION [n -S]\n",
  "DEOXIDIZATIONS": "DEOXIDIZATION, the process of deoxidizing, also DEOXIDISATION [n]\n",
  "DEOXIDIZE": "to remove oxygen from, also DEOXIDISE [v DEOXIDIZED, DEOXIDIZING, DEOXIDIZES]\n",
  "DEOXIDIZED": "DEOXIDIZE, to remove oxygen from, also DEOXIDISE [v]\n",
  "DEOXIDIZER": "a substance that deoxidises, also DEOXIDISER [n -S]\n",
  "DEOXIDIZERS": "DEOXIDIZER, a substance that deoxidises, also DEOXIDISER [n]\n",
  "DEOXIDIZES": "DEOXIDIZE, to remove oxygen from, also DEOXIDISE [v]\n",
  "DEOXIDIZING": "DEOXIDIZE, to remove oxygen from, also DEOXIDISE [v]\n",
  "DEOXY": "having less oxygen than the parent compound, also DESOXY [adj]\n",
  "DEOXYCORTONE": "a corticosteroid hormone important in maintaining sodium and water balance in the body [n -S]\n",
  "DEOXYCORTONES": "DEOXYCORTONE, a corticosteroid hormone important in maintaining sodium and water balance in the body [n]\n",
  "DEOXYGENATE": "to remove esp. molecular oxygen from [v DEOXYGENATED, DEOXYGENATING, DEOXYGENATES]\n",
  "DEOXYGENATED": "DEOXYGENATE, to remove esp. molecular oxygen from [v]\n",
  "DEOXYGENATES": "DEOXYGENATE, to remove esp. molecular oxygen from [v]\n",
  "DEOXYGENATING": "DEOXYGENATE, to remove esp. molecular oxygen from [v]\n",
  "DEOXYGENATION": "the act of deoxygenating [n -S]\n",
  "DEOXYGENATIONS": "DEOXYGENATION, the act of deoxygenating [n]\n",
  "DEOXYGENISE": "to remove oxygen from, also DEOXYGENIZE [v DEOXYGENISED, DEOXYGENISING, DEOXYGENISES]\n",
  "DEOXYGENISED": "DEOXYGENISE, to remove oxygen from, also DEOXYGENIZE [v]\n",
  "DEOXYGENISES": "DEOXYGENISE, to remove oxygen from, also DEOXYGENIZE [v]\n",
  "DEOXYGENISING": "DEOXYGENISE, to remove oxygen from, also DEOXYGENIZE [v]\n",
  "DEOXYGENIZE": "to remove oxygen from, also DEOXYGENISE [v DEOXYGENIZED, DEOXYGENIZING, DEOXYGENIZES]\n",
  "DEOXYGENIZED": "DEOXYGENIZE, to remove oxygen from, also DEOXYGENISE [v]\n",
  "DEOXYGENIZES": "DEOXYGENIZE, to remove oxygen from, also DEOXYGENISE [v]\n",
  "DEOXYGENIZING": "DEOXYGENIZE, to remove oxygen from, also DEOXYGENISE [v]\n",
  "DEOXYRIBOSE": "a pentose sugar obtained by the hydrolysis of DNA, also DESOXYRIBOSE [n -S]\n",
  "DEOXYRIBOSES": "DEOXYRIBOSE, a pentose sugar obtained by the hydrolysis of DNA, also DESOXYRIBOSE [n]\n",
  "DEP": "a convenience store [n -S]\n",
  "DEPAINT": "(Spenser) to paint, also DEPEINCT [v -ED, -ING, -S]\n",
  "DEPAINTED": "DEPAINT, (Spenser) to paint, also DEPEINCT [v]\n",
  "DEPAINTING": "DEPAINT, (Spenser) to paint, also DEPEINCT [v]\n",
  "DEPAINTS": "DEPAINT, (Spenser) to paint, also DEPEINCT [v]\n",
  "DEPANNEUR": "(Canadian) a convenience store in French Canada [n -S]\n",
  "DEPANNEURS": "DEPANNEUR, (Canadian) a convenience store in French Canada [n]\n",
  "DEPART": "to go away [v -ED, -ING, -S]\n",
  "DEPARTED": "a dead person [n -S]\n",
  "DEPARTEDS": "DEPARTED, a dead person [n]\n",
  "DEPARTEE": "one that departs [n -S]\n",
  "DEPARTEES": "DEPARTEE, one that departs [n]\n",
  "DEPARTEMENT": "(French) an administrative department [n -S]\n",
  "DEPARTEMENTS": "DEPARTEMENT, (French) an administrative department [n]\n",
  "DEPARTER": "one who departs [n -S]\n",
  "DEPARTERS": "DEPARTER, one who departs [n]\n",
  "DEPARTING": "the act of departing [n -S]\n",
  "DEPARTINGS": "DEPARTING, the act of departing [n]\n",
  "DEPARTMENT": "a major administrative division of a government [n -S]\n",
  "DEPARTMENTAL": "relating to a department [adj DEPARTMENTALLY]\n",
  "DEPARTMENTALISE": "to form into separate departments, also DEPARTMENTALIZE [v]\n",
  "DEPARTMENTALISM": "too strict division of work among departments with little intercommunication [n]\n",
  "DEPARTMENTALIZE": "to form into separate departments, also DEPARTMENTALISE [v]\n",
  "DEPARTMENTALLY": "DEPARTMENTAL, relating to a department [adv]\n",
  "DEPARTMENTS": "DEPARTMENT, a major administrative division of a government [n]\n",
  "DEPARTS": "DEPART, to go away [v]\n",
  "DEPARTURE": "the act of departing [n -S]\n",
  "DEPARTURES": "DEPARTURE, the act of departing [n]\n",
  "DEPASTURE": "to graze [v DEPASTURED, DEPASTURING, DEPASTURES]\n",
  "DEPASTURED": "DEPASTURE, to graze [v]\n",
  "DEPASTURES": "DEPASTURE, to graze [v]\n",
  "DEPASTURING": "DEPASTURE, to graze [v]\n",
  "DEPAUPERATE": "to impoverish [v DEPAUPERATED, DEPAUPERATING, DEPAUPERATES]\n",
  "DEPAUPERATED": "DEPAUPERATE, to impoverish [v]\n",
  "DEPAUPERATES": "DEPAUPERATE, to impoverish [v]\n",
  "DEPAUPERATING": "DEPAUPERATE, to impoverish [v]\n",
  "DEPAUPERISE": "to free from pauperdom, also DEPAUPERIZE [v DEPAUPERISED, DEPAUPERISING, DEPAUPERISES]\n",
  "DEPAUPERISED": "DEPAUPERISE, to free from pauperdom, also DEPAUPERIZE [v]\n",
  "DEPAUPERISES": "DEPAUPERISE, to free from pauperdom, also DEPAUPERIZE [v]\n",
  "DEPAUPERISING": "DEPAUPERISE, to free from pauperdom, also DEPAUPERIZE [v]\n",
  "DEPAUPERIZE": "to free from pauperdom, also DEPAUPERISE [v DEPAUPERIZED, DEPAUPERIZING, DEPAUPERIZES]\n",
  "DEPAUPERIZED": "DEPAUPERIZE, to free from pauperdom, also DEPAUPERISE [v]\n",
  "DEPAUPERIZES": "DEPAUPERIZE, to free from pauperdom, also DEPAUPERISE [v]\n",
  "DEPAUPERIZING": "DEPAUPERIZE, to free from pauperdom, also DEPAUPERISE [v]\n",
  "DEPECHE": "(French) to dispatch, rid oneself of [v DEPECHED, DEPECHING, DEPECHES]\n",
  "DEPECHED": "DEPECHE, (French) to dispatch, rid oneself of [v]\n",
  "DEPECHES": "DEPECHE, (French) to dispatch, rid oneself of [v]\n",
  "DEPECHING": "DEPECHE, (French) to dispatch, rid oneself of [v]\n",
  "DEPEINCT": "(Spenser) to paint, also DEPAINT [v -ED, -ING, -S]\n",
  "DEPEINCTED": "DEPEINCT, (Spenser) to paint, also DEPAINT [v]\n",
  "DEPEINCTING": "DEPEINCT, (Spenser) to paint, also DEPAINT [v]\n",
  "DEPEINCTS": "DEPEINCT, (Spenser) to paint, also DEPAINT [v]\n",
  "DEPEND": "to rely [v -ED, -ING, -S]\n",
  "DEPENDABILITIES": "DEPENDABILITY, the state of being dependable [n]\n",
  "DEPENDABILITY": "the state of being dependable [n DEPENDABILITIES]\n",
  "DEPENDABLE": "that can be depended on [adj DEPENDABLY]\n",
  "DEPENDABLENESS": "DEPENDABLE, that can be depended on [n]\n",
  "DEPENDABLY": "DEPENDABLE, that can be depended on [adv]\n",
  "DEPENDANCE": "the state of being a dependant, also DEPENDANCY, DEPENDENCE, DEPENDENCY [n -S]\n",
  "DEPENDANCES": "DEPENDANCE, the state of being a dependant, also DEPENDANCY, DEPENDENCE, DEPENDENCY [n]\n",
  "DEPENDANCIES": "DEPENDANCY, the state of being dependent, also DEPENDANCE, DEPENDENCE, DEPENDENCY [n]\n",
  "DEPENDANCY": "the state of being dependent, also DEPENDANCE, DEPENDENCE, DEPENDENCY [n DEPENDANCIES]\n",
  "DEPENDANT": "a person who depends on another for support, also DEPENDENT [n -S]\n",
  "DEPENDANTS": "DEPENDANT, a person who depends on another for support, also DEPENDENT [n]\n",
  "DEPENDED": "DEPEND, to rely [v]\n",
  "DEPENDENCE": "the state of being dependent, also DEPENDANCE, DEPENDANCY, DEPENDENCY [n -S]\n",
  "DEPENDENCES": "DEPENDENCE, the state of being dependent, also DEPENDANCE, DEPENDANCY, DEPENDENCY [n]\n",
  "DEPENDENCIES": "DEPENDENCY, the state of being dependent, also DEPENDANCE, DEPENDANCY, DEPENDENCE [n]\n",
  "DEPENDENCY": "the state of being dependent, also DEPENDANCE, DEPENDANCY, DEPENDENCE [n DEPENDENCIES]\n",
  "DEPENDENT": "depending on another, also DEPENDANT [adj DEPENDENTLY] / a person who depends on another for support [n -S]\n",
  "DEPENDENTLY": "DEPENDENT, depending on another, also DEPENDANT [adv]\n",
  "DEPENDENTS": "DEPENDENT, a person who depends on another for support [n]\n",
  "DEPENDING": "DEPEND, to rely [v]\n",
  "DEPENDINGLY": "DEPENDING, DEPEND, to rely [adv]\n",
  "DEPENDS": "DEPEND, to rely [v]\n",
  "DEPEOPLE": "to reduce the population of [v DEPEOPLED, DEPEOPLING, DEPEOPLES]\n",
  "DEPEOPLED": "DEPEOPLE, to reduce the population of [v]\n",
  "DEPEOPLES": "DEPEOPLE, to reduce the population of [v]\n",
  "DEPEOPLING": "DEPEOPLE, to reduce the population of [v]\n",
  "DEPERM": "to demagnetize (a ship or submarine) to protect it from magnetic detection [v -ED, -ING, -S]\n",
  "DEPERMED": "DEPERM, to demagnetize (a ship or submarine) to protect it from magnetic detection [v]\n",
  "DEPERMING": "DEPERM, to demagnetize (a ship or submarine) to protect it from magnetic detection [v]\n",
  "DEPERMS": "DEPERM, to demagnetize (a ship or submarine) to protect it from magnetic detection [v]\n",
  "DEPERSONALISE": "to take away the characteristics or personality of, also DEPERSONALIZE [v DEPERSONALISED, DEPERSONALISING, DEPERSONALISES]\n",
  "DEPERSONALISED": "DEPERSONALISE, to take away the characteristics or personality of, also DEPERSONALIZE [v]\n",
  "DEPERSONALISES": "DEPERSONALISE, to take away the characteristics or personality of, also DEPERSONALIZE [v]\n",
  "DEPERSONALISING": "DEPERSONALISE, to take away the characteristics or personality of, also DEPERSONALIZE [v]\n",
  "DEPERSONALIZE": "to deprive of the sense of personal identity, also DEPERSONALISE [v DEPERSONALIZED, DEPERSONALIZING, DEPERSONALIZES]\n",
  "DEPERSONALIZED": "DEPERSONALIZE, to deprive of the sense of personal identity, also DEPERSONALISE [v]\n",
  "DEPERSONALIZES": "DEPERSONALIZE, to deprive of the sense of personal identity, also DEPERSONALISE [v]\n",
  "DEPERSONALIZING": "DEPERSONALIZE, to deprive of the sense of personal identity, also DEPERSONALISE [v]\n",
  "DEPHLEGMATE": "to distill something, such as alcohol [v DEPHLEGMATED, DEPHLEGMATING, DEPHLEGMATES]\n",
  "DEPHLEGMATED": "DEPHLEGMATE, to distill something, such as alcohol [v]\n",
  "DEPHLEGMATES": "DEPHLEGMATE, to distill something, such as alcohol [v]\n",
  "DEPHLEGMATING": "DEPHLEGMATE, to distill something, such as alcohol [v]\n",
  "DEPHLEGMATION": "the process of dephlegmating [n -S]\n",
  "DEPHLEGMATIONS": "DEPHLEGMATION, the process of dephlegmating [n]\n",
  "DEPHLEGMATOR": "an agent that dephlegmates [n -S]\n",
  "DEPHLEGMATORS": "DEPHLEGMATOR, an agent that dephlegmates [n]\n",
  "DEPHLOGISTICATE": "to make something fireproof [v]\n",
  "DEPHOSPHORYLATE": "to remove phosphate groups from an organic compounds [v]\n",
  "DEPICT": "to portray [v -ED, -ING, -S]\n",
  "DEPICTED": "DEPICT, to portray [v]\n",
  "DEPICTER": "one that depicts, also DEPICTOR [n -S]\n",
  "DEPICTERS": "DEPICTER, one that depicts, also DEPICTOR [n]\n",
  "DEPICTING": "DEPICT, to portray [v]\n",
  "DEPICTION": "an act of depicting [n -S]\n",
  "DEPICTIONS": "DEPICTION, an act of depicting [n]\n",
  "DEPICTIVE": "relating to depiction [adj]\n",
  "DEPICTOR": "one that depicts, also DEPICTER [n -S]\n",
  "DEPICTORS": "DEPICTOR, one that depicts, also DEPICTER [n]\n",
  "DEPICTS": "DEPICT, to portray [v]\n",
  "DEPICTURE": "(archaic) to depict [v DEPICTURED, DEPICTURING, DEPICTURES]\n",
  "DEPICTURED": "DEPICTURE, (archaic) to depict [v]\n",
  "DEPICTURES": "DEPICTURE, (archaic) to depict [v]\n",
  "DEPICTURING": "DEPICTURE, (archaic) to depict [v]\n",
  "DEPIGMENT": "to take away or reduce the pigmentation in [v -ED, -ING, -S]\n",
  "DEPIGMENTATION": "loss of normal pigmentation [n -S]\n",
  "DEPIGMENTATIONS": "DEPIGMENTATION, loss of normal pigmentation [n]\n",
  "DEPIGMENTED": "DEPIGMENT, to take away or reduce the pigmentation in [v]\n",
  "DEPIGMENTING": "DEPIGMENT, to take away or reduce the pigmentation in [v]\n",
  "DEPIGMENTS": "DEPIGMENT, to take away or reduce the pigmentation in [v]\n",
  "DEPILATE": "to remove hair [v DEPILATED, DEPILATING, DEPILATES]\n",
  "DEPILATED": "DEPILATE, to remove hair [v]\n",
  "DEPILATES": "DEPILATE, to remove hair [v]\n",
  "DEPILATING": "DEPILATE, to remove hair [v]\n",
  "DEPILATION": "the act of removing the hair [n -S]\n",
  "DEPILATIONS": "DEPILATION, the act of removing the hair [n]\n",
  "DEPILATOR": "an agent for removing hair [n -S]\n",
  "DEPILATORIES": "DEPILATORY, a preparation for removing hair [n]\n",
  "DEPILATORS": "DEPILATOR, an agent for removing hair [n]\n",
  "DEPILATORY": "having the power of removing hair [adj] / a preparation for removing hair [n DEPILATORIES]\n",
  "DEPLANE": "to get off an airplane [v DEPLANED, DEPLANING, DEPLANES]\n",
  "DEPLANED": "DEPLANE, to get off an airplane [v]\n",
  "DEPLANES": "DEPLANE, to get off an airplane [v]\n",
  "DEPLANING": "DEPLANE, to get off an airplane [v]\n",
  "DEPLENISH": "to deprive of contents, such as furniture, stock, etc. [v -ED, -ING, -ES]\n",
  "DEPLENISHED": "DEPLENISH, to deprive of contents, such as furniture, stock, etc. [v]\n",
  "DEPLENISHES": "DEPLENISH, to deprive of contents, such as furniture, stock, etc. [v]\n",
  "DEPLENISHING": "DEPLENISH, to deprive of contents, such as furniture, stock, etc. [v]\n",
  "DEPLETABLE": "that can be depleted [adj]\n",
  "DEPLETE": "to lessen the supply of [v DEPLETED, DEPLETING, DEPLETES]\n",
  "DEPLETED": "DEPLETE, to lessen the supply of [v]\n",
  "DEPLETER": "one who depletes [n -S]\n",
  "DEPLETERS": "DEPLETER, one who depletes [n]\n",
  "DEPLETES": "DEPLETE, to lessen the supply of [v]\n",
  "DEPLETING": "DEPLETE, to lessen the supply of [v]\n",
  "DEPLETION": "the act of depleting [n -S]\n",
  "DEPLETIONS": "DEPLETION, the act of depleting [n]\n",
  "DEPLETIVE": "serving to deplete, also DEPLETORY [adj]\n",
  "DEPLETORY": "serving to deplete, also DEPLETIVE [adj]\n",
  "DEPLORABILITIES": "DEPLORABILITY, the quality of being deplorable [n]\n",
  "DEPLORABILITY": "the quality of being deplorable [n DEPLORABILITIES]\n",
  "DEPLORABLE": "to be deplored [adj DEPLORABLY]\n",
  "DEPLORABLENESS": "the state of being deplorable [n]\n",
  "DEPLORABLY": "DEPLORABLE, to be deplored [adv]\n",
  "DEPLORATION": "the act of deploring [n -S]\n",
  "DEPLORATIONS": "DEPLORATION, the act of deploring [n]\n",
  "DEPLORE": "to regret strongly [v DEPLORED, DEPLORING, DEPLORES]\n",
  "DEPLORED": "DEPLORE, to regret strongly [v]\n",
  "DEPLORER": "one who deplores [n -S]\n",
  "DEPLORERS": "DEPLORER, one who deplores [n]\n",
  "DEPLORES": "DEPLORE, to regret strongly [v]\n",
  "DEPLORING": "DEPLORE, to regret strongly [v]\n",
  "DEPLORINGLY": "DEPLORING, DEPLORE, to regret strongly [adv]\n",
  "DEPLOY": "to position troops for battle [v -ED, -ING, -S]\n",
  "DEPLOYABLE": "able to be deployed [adj]\n",
  "DEPLOYED": "DEPLOY, to position troops for battle [v]\n",
  "DEPLOYER": "one who deploys [n -S]\n",
  "DEPLOYERS": "DEPLOYER, one who deploys [n]\n",
  "DEPLOYING": "DEPLOY, to position troops for battle [v]\n",
  "DEPLOYMENT": "the act of deploying [n -S]\n",
  "DEPLOYMENTS": "DEPLOYMENT, the act of deploying [n]\n",
  "DEPLOYS": "DEPLOY, to position troops for battle [v]\n",
  "DEPLUMATION": "the removal of feathers [n -S]\n",
  "DEPLUMATIONS": "DEPLUMATION, the removal of feathers [n]\n",
  "DEPLUME": "to deprive of feathers [v DEPLUMED, DEPLUMING, DEPLUMES]\n",
  "DEPLUMED": "DEPLUME, to deprive of feathers [v]\n",
  "DEPLUMES": "DEPLUME, to deprive of feathers [v]\n",
  "DEPLUMING": "DEPLUME, to deprive of feathers [v]\n",
  "DEPOLARISATION": "the act of depolarising, also DEPOLARIZATION [n -S]\n",
  "DEPOLARISATIONS": "DEPOLARISATION, the act of depolarising, also DEPOLARIZATION [n]\n",
  "DEPOLARISE": "to remove the polarity from, also DEPOLARIZE [v DEPOLARISED, DEPOLARISING, DEPOLARISES]\n",
  "DEPOLARISED": "DEPOLARISE, to remove the polarity from, also DEPOLARIZE [v]\n",
  "DEPOLARISER": "an agent for depolarizing, also DEPOLARIZER [n -S]\n",
  "DEPOLARISERS": "DEPOLARISER, an agent for depolarizing, also DEPOLARIZER [n]\n",
  "DEPOLARISES": "DEPOLARISE, to remove the polarity from, also DEPOLARIZE [v]\n",
  "DEPOLARISING": "DEPOLARISE, to remove the polarity from, also DEPOLARIZE [v]\n",
  "DEPOLARIZATION": "the act of depolarizing, also DEPOLARISATION [n -S]\n",
  "DEPOLARIZATIONS": "DEPOLARIZATION, the act of depolarizing, also DEPOLARISATION [n]\n",
  "DEPOLARIZE": "to remove the polarity from, also DEPOLARISE [v DEPOLARIZED, DEPOLARIZING, DEPOLARIZES]\n",
  "DEPOLARIZED": "DEPOLARIZE, to remove the polarity from, also DEPOLARISE [v]\n",
  "DEPOLARIZER": "an agent for depolarizing, also DEPOLARISER [n -S]\n",
  "DEPOLARIZERS": "DEPOLARIZER, an agent for depolarizing, also DEPOLARISER [n]\n",
  "DEPOLARIZES": "DEPOLARIZE, to remove the polarity from, also DEPOLARISE [v]\n",
  "DEPOLARIZING": "DEPOLARIZE, to remove the polarity from, also DEPOLARISE [v]\n",
  "DEPOLISH": "to remove the gloss from [v -ED, -ING, -ES]\n",
  "DEPOLISHED": "DEPOLISH, to remove the gloss from [v]\n",
  "DEPOLISHES": "DEPOLISH, to remove the gloss from [v]\n",
  "DEPOLISHING": "DEPOLISH, to remove the gloss from [v]\n",
  "DEPOLITICISE": "to remove the political nature or awareness from, also DEPOLITICIZE [v DEPOLITICISED, DEPOLITICISING, DEPOLITICISES]\n",
  "DEPOLITICISED": "DEPOLITICISE, to remove the political nature or awareness from, also DEPOLITICIZE [v]\n",
  "DEPOLITICISES": "DEPOLITICISE, to remove the political nature or awareness from, also DEPOLITICIZE [v]\n",
  "DEPOLITICISING": "DEPOLITICISE, to remove the political nature or awareness from, also DEPOLITICIZE [v]\n",
  "DEPOLITICIZE": "to remove the political nature or awareness from, also DEPOLITICISE [v DEPOLITICIZED, DEPOLITICIZING, DEPOLITICIZES]\n",
  "DEPOLITICIZED": "DEPOLITICIZE, to remove the political nature or awareness from, also DEPOLITICISE [v]\n",
  "DEPOLITICIZES": "DEPOLITICIZE, to remove the political nature or awareness from, also DEPOLITICISE [v]\n",
  "DEPOLITICIZING": "DEPOLITICIZE, to remove the political nature or awareness from, also DEPOLITICISE [v]\n",
  "DEPOLYMERISE": "to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERIZE [v DEPOLYMERISED, DEPOLYMERISING, DEPOLYMERISES]\n",
  "DEPOLYMERISED": "DEPOLYMERISE, to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERIZE [v]\n",
  "DEPOLYMERISES": "DEPOLYMERISE, to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERIZE [v]\n",
  "DEPOLYMERISING": "DEPOLYMERISE, to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERIZE [v]\n",
  "DEPOLYMERIZE": "to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERISE [v DEPOLYMERIZED, DEPOLYMERIZING, DEPOLYMERIZES]\n",
  "DEPOLYMERIZED": "DEPOLYMERIZE, to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERISE [v]\n",
  "DEPOLYMERIZES": "DEPOLYMERIZE, to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERISE [v]\n",
  "DEPOLYMERIZING": "DEPOLYMERIZE, to break a large molecule into simpler ones that have the same basic formula, also DEPOLYMERISE [v]\n",
  "DEPONE": "to testify under oath [v DEPONED, DEPONING, DEPONES]\n",
  "DEPONED": "DEPONE, to testify under oath [v]\n",
  "DEPONENT": "having a passive form but active meaning [adj] / a verb having a passive form but active meaning [n -S]\n",
  "DEPONENTS": "DEPONENT, a verb having a passive form but active meaning [n]\n",
  "DEPONES": "DEPONE, to testify under oath [v]\n",
  "DEPONING": "DEPONE, to testify under oath [v]\n",
  "DEPOPULATE": "to reduce greatly the population of [v DEPOPULATED, DEPOPULATING, DEPOPULATES]\n",
  "DEPOPULATED": "DEPOPULATE, to reduce greatly the population of [v]\n",
  "DEPOPULATES": "DEPOPULATE, to reduce greatly the population of [v]\n",
  "DEPOPULATING": "DEPOPULATE, to reduce greatly the population of [v]\n",
  "DEPOPULATION": "the act of depopulating [n -S]\n",
  "DEPOPULATIONS": "DEPOPULATION, the act of depopulating [n]\n",
  "DEPOPULATOR": "one who depopulates [n -S]\n",
  "DEPOPULATORS": "DEPOPULATOR, one who depopulates [n]\n",
  "DEPORT": "to expel from a country [v -ED, -ING, -S]\n",
  "DEPORTABLE": "that can be deported [adj]\n",
  "DEPORTATION": "an act or instance of deporting [n -S]\n",
  "DEPORTATIONS": "DEPORTATION, an act or instance of deporting [n]\n",
  "DEPORTED": "DEPORT, to expel from a country [v]\n",
  "DEPORTEE": "one who is deported [n -S]\n",
  "DEPORTEES": "DEPORTEE, one who is deported [n]\n",
  "DEPORTER": "one who deports [n -S]\n",
  "DEPORTERS": "DEPORTER, one who deports [n]\n",
  "DEPORTING": "DEPORT, to expel from a country [v]\n",
  "DEPORTMENT": "the manner in which one conducts oneself [n -S]\n",
  "DEPORTMENTS": "DEPORTMENT, the manner in which one conducts oneself [n]\n",
  "DEPORTS": "DEPORT, to expel from a country [v]\n",
  "DEPOSABLE": "capable of being deposed or deprived of office [adj]\n",
  "DEPOSAL": "the act of deposing from office [n -S]\n",
  "DEPOSALS": "DEPOSAL, the act of deposing from office [n]\n",
  "DEPOSE": "to remove from office [v DEPOSED, DEPOSING, DEPOSES]\n",
  "DEPOSED": "DEPOSE, to remove from office [v]\n",
  "DEPOSER": "one who deposes [n -S]\n",
  "DEPOSERS": "DEPOSER, one who deposes [n]\n",
  "DEPOSES": "DEPOSE, to remove from office [v]\n",
  "DEPOSING": "DEPOSE, to remove from office [v]\n",
  "DEPOSIT": "to place [v -ED, -ING, -S]\n",
  "DEPOSITARIES": "DEPOSITARY, a person with whom anything is left for safekeeping, also DEPOSITORY [n]\n",
  "DEPOSITARY": "a person with whom anything is left for safekeeping, also DEPOSITORY [n DEPOSITARIES]\n",
  "DEPOSITATION": "in Scots law, a bailment where one entrusts goods to another to be kept without recompense [n -S]\n",
  "DEPOSITATIONS": "DEPOSITATION, in Scots law, a bailment where one entrusts goods to another to be kept without recompense [n]\n",
  "DEPOSITED": "DEPOSIT, to place [v]\n",
  "DEPOSITING": "DEPOSIT, to place [v]\n",
  "DEPOSITION": "the act of depositing [n -S]\n",
  "DEPOSITIONAL": "relating to deposition [adj]\n",
  "DEPOSITIONS": "DEPOSITION, the act of depositing [n]\n",
  "DEPOSITIVE": "relating to deposition [adj]\n",
  "DEPOSITOR": "one who deposits [n -S]\n",
  "DEPOSITORIES": "DEPOSITORY, a place where anything is deposited, also DEPOSITARY [n]\n",
  "DEPOSITORS": "DEPOSITOR, one who deposits [n]\n",
  "DEPOSITORY": "a place where anything is deposited, also DEPOSITARY [n DEPOSITORIES]\n",
  "DEPOSITS": "DEPOSIT, to place [v]\n",
  "DEPOT": "a railway or bus station [n -S]\n",
  "DEPOTS": "DEPOT, a railway or bus station [n]\n",
  "DEPRAVATION": "the act of depraving [n -S]\n",
  "DEPRAVATIONS": "DEPRAVATION, the act of depraving [n]\n",
  "DEPRAVE": "to corrupt in morals [v DEPRAVED, DEPRAVING, DEPRAVES]\n",
  "DEPRAVED": "DEPRAVE, to corrupt in morals [v]\n",
  "DEPRAVEDLY": "DEPRAVED, DEPRAVE, to corrupt in morals [adv]\n",
  "DEPRAVEDNESS": "the state of being depraved [n -ES]\n",
  "DEPRAVEDNESSES": "DEPRAVEDNESS, the state of being depraved [n]\n",
  "DEPRAVEMENT": "(archaic) vitiation [n -S]\n",
  "DEPRAVEMENTS": "DEPRAVEMENT, (archaic) vitiation [n]\n",
  "DEPRAVER": "one who depraves [n -S]\n",
  "DEPRAVERS": "DEPRAVER, one who depraves [n]\n",
  "DEPRAVES": "DEPRAVE, to corrupt in morals [v]\n",
  "DEPRAVING": "DEPRAVE, to corrupt in morals [v]\n",
  "DEPRAVINGLY": "DEPRAVING, DEPRAVE, to corrupt in morals [adv]\n",
  "DEPRAVITIES": "DEPRAVITY, wickedness [n]\n",
  "DEPRAVITY": "wickedness [n DEPRAVITIES]\n",
  "DEPRECABLE": "that may or should be deprecated [adj]\n",
  "DEPRECATE": "to regret deeply; to express disapproval of [v DEPRECATED, DEPRECATING, DEPRECATES]\n",
  "DEPRECATED": "DEPRECATE, to regret deeply; to express disapproval of [v]\n",
  "DEPRECATES": "DEPRECATE, to regret deeply; to express disapproval of [v]\n",
  "DEPRECATING": "DEPRECATE, to regret deeply; to express disapproval of [v]\n",
  "DEPRECATINGLY": "DEPRECATING, DEPRECATE, to regret deeply; to express disapproval of [adv]\n",
  "DEPRECATION": "the act of deprecating [n -S]\n",
  "DEPRECATIONS": "DEPRECATION, the act of deprecating [n]\n",
  "DEPRECATIVE": "serving to deprecate [adj DEPRECATIVELY]\n",
  "DEPRECATIVELY": "DEPRECATIVE, serving to deprecate [adv]\n",
  "DEPRECATOR": "one who deprecates [n -S]\n",
  "DEPRECATORILY": "DEPRECATORY, serving to deprecate [adv]\n",
  "DEPRECATORS": "DEPRECATOR, one who deprecates [n]\n",
  "DEPRECATORY": "serving to deprecate [adj DEPRECATORILY]\n",
  "DEPRECIABLE": "that can be depreciated [adj]\n",
  "DEPRECIATE": "to lower in estimation or esteem [v DEPRECIATED, DEPRECIATING, DEPRECIATES]\n",
  "DEPRECIATED": "DEPRECIATE, to lower in estimation or esteem [v]\n",
  "DEPRECIATES": "DEPRECIATE, to lower in estimation or esteem [v]\n",
  "DEPRECIATING": "DEPRECIATE, to lower in estimation or esteem [v]\n",
  "DEPRECIATINGLY": "DEPRECIATING, DEPRECIATE, to lower in estimation or esteem [adv]\n",
  "DEPRECIATION": "the act of depreciating [n -S]\n",
  "DEPRECIATIONS": "DEPRECIATION, the act of depreciating [n]\n",
  "DEPRECIATIVE": "tending to depreciate [adj]\n",
  "DEPRECIATOR": "one who depreciates [n -S]\n",
  "DEPRECIATORS": "DEPRECIATOR, one who depreciates [n]\n",
  "DEPRECIATORY": "tending to depreciate [adj]\n",
  "DEPREDATE": "to plunder or prey upon [v DEPREDATED, DEPREDATING, DEPREDATES]\n",
  "DEPREDATED": "DEPREDATE, to plunder or prey upon [v]\n",
  "DEPREDATES": "DEPREDATE, to plunder or prey upon [v]\n",
  "DEPREDATING": "DEPREDATE, to plunder or prey upon [v]\n",
  "DEPREDATION": "the act of depredating [n -S]\n",
  "DEPREDATIONS": "DEPREDATION, the act of depredating [n]\n",
  "DEPREDATOR": "one who plunders or pillages [n -S]\n",
  "DEPREDATORS": "DEPREDATOR, one who plunders or pillages [n]\n",
  "DEPREDATORY": "serving to depredate [adj]\n",
  "DEPREHEND": "(obsolete) to catch; to seize [v -ED, -ING, -S]\n",
  "DEPREHENDED": "DEPREHEND, (obsolete) to catch; to seize [v]\n",
  "DEPREHENDING": "DEPREHEND, (obsolete) to catch; to seize [v]\n",
  "DEPREHENDS": "DEPREHEND, (obsolete) to catch; to seize [v]\n",
  "DEPRENYL": "a drug for treating Parkinson's disease [n -S]\n",
  "DEPRENYLS": "DEPRENYL, a drug for treating Parkinson's disease [n]\n",
  "DEPRESS": "to make sad [v -ED, -ING, -ES]\n",
  "DEPRESSANT": "an agent or remedy which lowers the vital powers [n -S]\n",
  "DEPRESSANTS": "DEPRESSANT, an agent or remedy which lowers the vital powers [n]\n",
  "DEPRESSED": "DEPRESS, to make sad [v]\n",
  "DEPRESSES": "DEPRESS, to make sad [v]\n",
  "DEPRESSIBLE": "able to be depressed [adj]\n",
  "DEPRESSING": "DEPRESS, to make sad [v]\n",
  "DEPRESSINGLY": "DEPRESSING, DEPRESS, to make sad [adv]\n",
  "DEPRESSION": "a pressing down [n -S]\n",
  "DEPRESSIONS": "DEPRESSION, a pressing down [n]\n",
  "DEPRESSIVE": "tending to depress [adj DEPRESSIVELY] / one who is affected with or prone to psychological depression [n -S]\n",
  "DEPRESSIVELY": "DEPRESSIVE, tending to depress [adv]\n",
  "DEPRESSIVENESS": "DEPRESSIVE, tending to depress [n]\n",
  "DEPRESSIVES": "DEPRESSIVE, one who is affected with or prone to psychological depression [n]\n",
  "DEPRESSOMOTOR": "a drug with the effect of retarding motor activity [n -S]\n",
  "DEPRESSOMOTORS": "DEPRESSOMOTOR, a drug with the effect of retarding motor activity [n]\n",
  "DEPRESSOR": "one who, or that which, presses down [n -S]\n",
  "DEPRESSORS": "DEPRESSOR, one who, or that which, presses down [n]\n",
  "DEPRESSURISE": "to reduce the air pressure in esp. suddenly, also DEPRESSURIZE [v DEPRESSURISED, DEPRESSURISING, DEPRESSURISES]\n",
  "DEPRESSURISED": "DEPRESSURISE, to reduce the air pressure in esp. suddenly, also DEPRESSURIZE [v]\n",
  "DEPRESSURISES": "DEPRESSURISE, to reduce the air pressure in esp. suddenly, also DEPRESSURIZE [v]\n",
  "DEPRESSURISING": "DEPRESSURISE, to reduce the air pressure in esp. suddenly, also DEPRESSURIZE [v]\n",
  "DEPRESSURIZE": "to reduce the air pressure in esp. suddenly, also DEPRESSURISE [v DEPRESSURIZED, DEPRESSURIZING, DEPRESSURIZES]\n",
  "DEPRESSURIZED": "DEPRESSURIZE, to reduce the air pressure in esp. suddenly, also DEPRESSURISE [v]\n",
  "DEPRESSURIZES": "DEPRESSURIZE, to reduce the air pressure in esp. suddenly, also DEPRESSURISE [v]\n",
  "DEPRESSURIZING": "DEPRESSURIZE, to reduce the air pressure in esp. suddenly, also DEPRESSURISE [v]\n",
  "DEPRIME": "to remove the primer from eg a shell [v DEPRIMED, DEPRIMING, DEPRIMES]\n",
  "DEPRIMED": "DEPRIME, to remove the primer from eg a shell [v]\n",
  "DEPRIMES": "DEPRIME, to remove the primer from eg a shell [v]\n",
  "DEPRIMING": "DEPRIME, to remove the primer from eg a shell [v]\n",
  "DEPRIVABLE": "capable of being deprived [adj]\n",
  "DEPRIVAL": "deprivation [n -S]\n",
  "DEPRIVALS": "DEPRIVAL, deprivation [n]\n",
  "DEPRIVATION": "the state of being deprived [n -S]\n",
  "DEPRIVATIONS": "DEPRIVATION, the state of being deprived [n]\n",
  "DEPRIVATIVE": "serving to deprive [adj]\n",
  "DEPRIVE": "to take something away from [v DEPRIVED, DEPRIVING, DEPRIVES]\n",
  "DEPRIVED": "DEPRIVE, to take something away from [v]\n",
  "DEPRIVEMENT": "the act of depriving [n -S]\n",
  "DEPRIVEMENTS": "DEPRIVEMENT, the act of depriving [n]\n",
  "DEPRIVER": "one who deprives [n -S]\n",
  "DEPRIVERS": "DEPRIVER, one who deprives [n]\n",
  "DEPRIVES": "DEPRIVE, to take something away from [v]\n",
  "DEPRIVING": "DEPRIVE, to take something away from [v]\n",
  "DEPROGRAM": "to prevail on a person to reject obsessive beliefs, also DEPROGRAMME [v DEPROGRAMED or DEPROGRAMMED, DEPROGRAMING or DEPROGRAMMING, DEPROGRAMS]\n",
  "DEPROGRAMED": "DEPROGRAM, to prevail on a person to reject obsessive beliefs, also DEPROGRAMME [v]\n",
  "DEPROGRAMING": "DEPROGRAM, to prevail on a person to reject obsessive beliefs, also DEPROGRAMME [v]\n",
  "DEPROGRAMME": "to prevail on a person to reject obsessive beliefs, also DEPROGRAM [v DEPROGRAMMED, DEPROGRAMMING, DEPROGRAMMES]\n",
  "DEPROGRAMMED": "DEPROGRAM, to prevail on a person to reject obsessive beliefs, also DEPROGRAMME [v]\n",
  "DEPROGRAMMER": "one who deprograms [n -S]\n",
  "DEPROGRAMMERS": "DEPROGRAMMER, one who deprograms [n]\n",
  "DEPROGRAMMES": "DEPROGRAMME, to prevail on a person to reject obsessive beliefs, also DEPROGRAM [v]\n",
  "DEPROGRAMMING": "DEPROGRAM, to prevail on a person to reject obsessive beliefs, also DEPROGRAMME [v]\n",
  "DEPROGRAMS": "DEPROGRAM, to prevail on a person to reject obsessive beliefs, also DEPROGRAMME [v]\n",
  "DEPS": "DEP, a convenience store [n]\n",
  "DEPSIDE": "an aromatic compound [n -S]\n",
  "DEPSIDES": "DEPSIDE, an aromatic compound [n]\n",
  "DEPTH": "deepness [n -S]\n",
  "DEPTHLESS": "having no depth; shallow [adj]\n",
  "DEPTHS": "DEPTH, deepness [n]\n",
  "DEPURANT": "a purifying agent, also DEPURATIVE [n -S]\n",
  "DEPURANTS": "DEPURANT, a purifying agent, also DEPURATIVE [n]\n",
  "DEPURATE": "to free from impurities [v DEPURATED, DEPURATING, DEPURATES]\n",
  "DEPURATED": "DEPURATE, to free from impurities [v]\n",
  "DEPURATES": "DEPURATE, to free from impurities [v]\n",
  "DEPURATING": "DEPURATE, to free from impurities [v]\n",
  "DEPURATION": "the act of depurating; purification [n -S]\n",
  "DEPURATIONS": "DEPURATION, the act of depurating; purification [n]\n",
  "DEPURATIVE": "a purifying agent, also DEPURANT [n -S]\n",
  "DEPURATIVES": "DEPURATIVE, a purifying agent, also DEPURANT [n]\n",
  "DEPURATOR": "one who, or that which, cleanses [n -S]\n",
  "DEPURATORS": "DEPURATOR, one who, or that which, cleanses [n]\n",
  "DEPURATORY": "tending to depurate or cleanse [adj]\n",
  "DEPUTABLE": "that can be deputed [adj]\n",
  "DEPUTATION": "the act of deputing [n -S]\n",
  "DEPUTATIONS": "DEPUTATION, the act of deputing [n]\n",
  "DEPUTE": "to delegate [v DEPUTED, DEPUTING, DEPUTES]\n",
  "DEPUTED": "DEPUTE, to delegate [v]\n",
  "DEPUTES": "DEPUTE, to delegate [v]\n",
  "DEPUTIES": "DEPUTY, one appointed to act for another [n]\n",
  "DEPUTING": "DEPUTE, to delegate [v]\n",
  "DEPUTISATION": "the act of deputising, also DEPUTIZATION [n -S]\n",
  "DEPUTISATIONS": "DEPUTISATION, the act of deputising, also DEPUTIZATION [n]\n",
  "DEPUTISE": "to act as a deputy, also DEPUTIZE [v DEPUTISED, DEPUTISING, DEPUTISES]\n",
  "DEPUTISED": "DEPUTISE, to act as a deputy, also DEPUTIZE [v]\n",
  "DEPUTISES": "DEPUTISE, to act as a deputy, also DEPUTIZE [v]\n",
  "DEPUTISING": "DEPUTISE, to act as a deputy, also DEPUTIZE [v]\n",
  "DEPUTIZATION": "the act of deputizing, also DEPUTISATION [n -S]\n",
  "DEPUTIZATIONS": "DEPUTIZATION, the act of deputizing, also DEPUTISATION [n]\n",
  "DEPUTIZE": "to act as a deputy, also DEPUTISE [v DEPUTIZED, DEPUTIZING, DEPUTIZES]\n",
  "DEPUTIZED": "DEPUTIZE, to act as a deputy, also DEPUTISE [v]\n",
  "DEPUTIZES": "DEPUTIZE, to act as a deputy, also DEPUTISE [v]\n",
  "DEPUTIZING": "DEPUTIZE, to act as a deputy, also DEPUTISE [v]\n",
  "DEPUTY": "one appointed to act for another [n DEPUTIES]\n",
  "DEQUEUE": "to remove from a (computing) queue [v DEQUEUED, DEQUEUING or DEQUEUEING, DEQUEUES]\n",
  "DEQUEUED": "DEQUEUE, to remove from a (computing) queue [v]\n",
  "DEQUEUEING": "DEQUEUE, to remove from a (computing) queue [v]\n",
  "DEQUEUES": "DEQUEUE, to remove from a (computing) queue [v]\n",
  "DEQUEUING": "DEQUEUE, to remove from a (computing) queue [v]\n",
  "DERACIALISE": "to divest of racial character, also DERACIALIZE [v DERACIALISED, DERACIALISING, DERACIALISES]\n",
  "DERACIALISED": "DERACIALISE, to divest of racial character, also DERACIALIZE [v]\n",
  "DERACIALISES": "DERACIALISE, to divest of racial character, also DERACIALIZE [v]\n",
  "DERACIALISING": "DERACIALISE, to divest of racial character, also DERACIALIZE [v]\n",
  "DERACIALIZE": "to divest of racial character, also DERACIALISE [v DERACIALIZED, DERACIALIZING, DERACIALIZES]\n",
  "DERACIALIZED": "DERACIALIZE, to divest of racial character, also DERACIALISE [v]\n",
  "DERACIALIZES": "DERACIALIZE, to divest of racial character, also DERACIALISE [v]\n",
  "DERACIALIZING": "DERACIALIZE, to divest of racial character, also DERACIALISE [v]\n",
  "DERACINATE": "to uproot [v DERACINATED, DERACINATING, DERACINATES]\n",
  "DERACINATED": "DERACINATE, to uproot [v]\n",
  "DERACINATES": "DERACINATE, to uproot [v]\n",
  "DERACINATING": "DERACINATE, to uproot [v]\n",
  "DERACINATION": "the act of deracinating [n -S]\n",
  "DERACINATIONS": "DERACINATION, the act of deracinating [n]\n",
  "DERACINE": "(French) a displaced person [n -S]\n",
  "DERACINES": "DERACINE, (French) a displaced person [n]\n",
  "DERAIGN": "(obsolete) to vindicate; to put in battle array, also DARRAIGN, DARRAIGNE, DARRAIN, DARRAINE, DARRAYN [v -ED, -ING, -S]\n",
  "DERAIGNED": "DERAIGN, (obsolete) to vindicate; to put in battle array, also DARRAIGN, DARRAIGNE, DARRAIN, DARRAINE, DARRAYN [v]\n",
  "DERAIGNING": "DERAIGN, (obsolete) to vindicate; to put in battle array, also DARRAIGN, DARRAIGNE, DARRAIN, DARRAINE, DARRAYN [v]\n",
  "DERAIGNMENT": "the act of deraigning [n -S]\n",
  "DERAIGNMENTS": "DERAIGNMENT, the act of deraigning [n]\n",
  "DERAIGNS": "DERAIGN, (obsolete) to vindicate; to put in battle array, also DARRAIGN, DARRAIGNE, DARRAIN, DARRAINE, DARRAYN [v]\n",
  "DERAIL": "to cause to leave the rails [v -ED, -ING, -S]\n",
  "DERAILED": "DERAIL, to cause to leave the rails [v]\n",
  "DERAILER": "something which derails [n -S]\n",
  "DERAILERS": "DERAILER, something which derails [n]\n",
  "DERAILING": "DERAIL, to cause to leave the rails [v]\n",
  "DERAILLEUR": "(French) a type of gearing for a bicycle [n -S]\n",
  "DERAILLEURS": "DERAILLEUR, (French) a type of gearing for a bicycle [n]\n",
  "DERAILMENT": "the act of going off the rails of a railroad [n -S]\n",
  "DERAILMENTS": "DERAILMENT, the act of going off the rails of a railroad [n]\n",
  "DERAILS": "DERAIL, to cause to leave the rails [v]\n",
  "DERANGE": "to disorder [v DERANGED, DERANGING, DERANGES]\n",
  "DERANGED": "DERANGE, to disorder [v]\n",
  "DERANGEMENT": "the act of deranging [n -S]\n",
  "DERANGEMENTS": "DERANGEMENT, the act of deranging [n]\n",
  "DERANGER": "one who deranges [n -S]\n",
  "DERANGERS": "DERANGER, one who deranges [n]\n",
  "DERANGES": "DERANGE, to disorder [v]\n",
  "DERANGING": "DERANGE, to disorder [v]\n",
  "DERAT": "to rid of rats [v DERATTED, DERATTING, DERATS]\n",
  "DERATE": "to relieve from some taxes [v DERATED, DERATING, DERATES]\n",
  "DERATED": "DERATE, to relieve from some taxes [v]\n",
  "DERATES": "DERATE, to relieve from some taxes [v]\n",
  "DERATING": "the act of derating [n -S]\n",
  "DERATINGS": "DERATING, the act of derating [n]\n",
  "DERATION": "to free from rationing [v -ED, -ING, -S]\n",
  "DERATIONED": "DERATION, to free from rationing [v]\n",
  "DERATIONING": "DERATION, to free from rationing [v]\n",
  "DERATIONS": "DERATION, to free from rationing [v]\n",
  "DERATS": "DERAT, to rid of rats [v]\n",
  "DERATTED": "DERAT, to rid of rats [v]\n",
  "DERATTING": "DERAT, to rid of rats [v]\n",
  "DERAY": "(obsolete) to derange [v -ED, -ING, -S]\n",
  "DERAYED": "DERAY, (obsolete) to derange [v]\n",
  "DERAYING": "DERAY, (obsolete) to derange [v]\n",
  "DERAYS": "DERAY, (obsolete) to derange [v]\n",
  "DERBIES": "DERBY, a type of hat [n]\n",
  "DERBY": "a type of hat [n DERBIES]\n",
  "DERE": "(Spenser) to injure, also DEAR, DEARE [v DERED, DERING, DERES]\n",
  "DEREALISATION": "a feeling of altered reality (as that occurring in schizophrenia or in some drug reactions) in which one's surroundings appear unreal or unfamiliar, also DEREALIZATION [n -S]\n",
  "DEREALISATIONS": "DEREALISATION, a feeling of altered reality (as that occurring in schizophrenia or in some drug reactions) in which one's surroundings appear unreal or unfamiliar, also DEREALIZATION [n]\n",
  "DEREALIZATION": "a feeling of altered reality (as that occurring in schizophrenia or in some drug reactions) in which one's surroundings appear unreal or unfamiliar, also DEREALISATION [n -S]\n",
  "DEREALIZATIONS": "DEREALIZATION, a feeling of altered reality (as that occurring in schizophrenia or in some drug reactions) in which one's surroundings appear unreal or unfamiliar, also DEREALISATION [n]\n",
  "DERECHO": "a line of intense widespread windstorms [n -S]\n",
  "DERECHOS": "DERECHO, a line of intense widespread windstorms [n]\n",
  "DERECOGNISE": "to withdraw recognition from (esp. a trade union), also DERECOGNIZE [v DERECOGNISED, DERECOGNISING, DERECOGNISES]\n",
  "DERECOGNISED": "DERECOGNISE, to withdraw recognition from (esp. a trade union), also DERECOGNIZE [v]\n",
  "DERECOGNISES": "DERECOGNISE, to withdraw recognition from (esp. a trade union), also DERECOGNIZE [v]\n",
  "DERECOGNISING": "DERECOGNISE, to withdraw recognition from (esp. a trade union), also DERECOGNIZE [v]\n",
  "DERECOGNITION": "the withdrawal of recognition [n -S]\n",
  "DERECOGNITIONS": "DERECOGNITION, the withdrawal of recognition [n]\n",
  "DERECOGNIZE": "to withdraw recognition from (esp. a trade union), also DERECOGNISE [v DERECOGNIZED, DERECOGNIZING, DERECOGNIZES]\n",
  "DERECOGNIZED": "DERECOGNIZE, to withdraw recognition from (esp. a trade union), also DERECOGNISE [v]\n",
  "DERECOGNIZES": "DERECOGNIZE, to withdraw recognition from (esp. a trade union), also DERECOGNISE [v]\n",
  "DERECOGNIZING": "DERECOGNIZE, to withdraw recognition from (esp. a trade union), also DERECOGNISE [v]\n",
  "DERED": "DERE, (Spenser) to injure, also DEAR, DEARE [v]\n",
  "DEREGISTER": "to remove from a register [v -ED, -ING, -S]\n",
  "DEREGISTERED": "DEREGISTER, to remove from a register [v]\n",
  "DEREGISTERING": "DEREGISTER, to remove from a register [v]\n",
  "DEREGISTERS": "DEREGISTER, to remove from a register [v]\n",
  "DEREGISTRATION": "the act of deregistering [n -S]\n",
  "DEREGISTRATIONS": "DEREGISTRATION, the act of deregistering [n]\n",
  "DEREGULATE": "to free from regulations or controls [v DEREGULATED, DEREGULATING, DEREGULATES]\n",
  "DEREGULATED": "DEREGULATE, to free from regulations or controls [v]\n",
  "DEREGULATES": "DEREGULATE, to free from regulations or controls [v]\n",
  "DEREGULATING": "DEREGULATE, to free from regulations or controls [v]\n",
  "DEREGULATION": "the act of removing restrictions and regulations [n -S]\n",
  "DEREGULATIONS": "DEREGULATION, the act of removing restrictions and regulations [n]\n",
  "DEREGULATOR": "one who deregulates [n -S]\n",
  "DEREGULATORS": "DEREGULATOR, one who deregulates [n]\n",
  "DEREGULATORY": "relating to deregulation [adj]\n",
  "DERELICT": "anything forsaken or abandoned [n -S]\n",
  "DERELICTION": "an intentional abandonment [n -S]\n",
  "DERELICTIONS": "DERELICTION, an intentional abandonment [n]\n",
  "DERELICTS": "DERELICT, anything forsaken or abandoned [n]\n",
  "DERELIGIONISE": "to remove the religious element from, also DERELIGIONIZE [v DERELIGIONISED, DERELIGIONISING, DERELIGIONISES]\n",
  "DERELIGIONISED": "DERELIGIONISE, to remove the religious element from, also DERELIGIONIZE [v]\n",
  "DERELIGIONISES": "DERELIGIONISE, to remove the religious element from, also DERELIGIONIZE [v]\n",
  "DERELIGIONISING": "DERELIGIONISE, to remove the religious element from, also DERELIGIONIZE [v]\n",
  "DERELIGIONIZE": "to remove the religious element from, also DERELIGIONISE [v DERELIGIONIZED, DERELIGIONIZING, DERELIGIONIZES]\n",
  "DERELIGIONIZED": "DERELIGIONIZE, to remove the religious element from, also DERELIGIONISE [v]\n",
  "DERELIGIONIZES": "DERELIGIONIZE, to remove the religious element from, also DERELIGIONISE [v]\n",
  "DERELIGIONIZING": "DERELIGIONIZE, to remove the religious element from, also DERELIGIONISE [v]\n",
  "DEREPRESS": "to activate (a gene or enzyme) by releasing it from a blocked state [v -ED, -ING, -ES]\n",
  "DEREPRESSED": "DEREPRESS, to activate (a gene or enzyme) by releasing it from a blocked state [v]\n",
  "DEREPRESSES": "DEREPRESS, to activate (a gene or enzyme) by releasing it from a blocked state [v]\n",
  "DEREPRESSING": "DEREPRESS, to activate (a gene or enzyme) by releasing it from a blocked state [v]\n",
  "DEREPRESSION": "the act of derepressing [n -S]\n",
  "DEREPRESSIONS": "DEREPRESSION, the act of derepressing [n]\n",
  "DEREQUISITION": "to return (something that has been used for a military purpose) to civilian use [v DEREQUISITIONED, DEREQUISITIONS]\n",
  "DEREQUISITIONED": "DEREQUISITION, to return (something that has been used for a military purpose) to civilian use [v]\n",
  "DEREQUISITIONS": "DEREQUISITION, to return (something that has been used for a military purpose) to civilian use [v]\n",
  "DERES": "DERE, (Spenser) to injure, also DEAR, DEARE [v]\n",
  "DERESTRICT": "to remove restrictions from [v -ED, -ING, -S]\n",
  "DERESTRICTED": "DERESTRICT, to remove restrictions from [v]\n",
  "DERESTRICTING": "DERESTRICT, to remove restrictions from [v]\n",
  "DERESTRICTION": "the act of derestricting [n -S]\n",
  "DERESTRICTIONS": "DERESTRICTION, the act of derestricting [n]\n",
  "DERESTRICTS": "DERESTRICT, to remove restrictions from [v]\n",
  "DERHAM": "(Arabic) a Middle Eastern coin, also DIRHAM, DIRHEM [n -S]\n",
  "DERHAMS": "DERHAM, (Arabic) a Middle Eastern coin, also DIRHAM, DIRHEM [n]\n",
  "DERIDE": "to ridicule, mock [v DERIDED, DERIDING, DERIDES]\n",
  "DERIDED": "DERIDE, to ridicule, mock [v]\n",
  "DERIDER": "one who derides [n -S]\n",
  "DERIDERS": "DERIDER, one who derides [n]\n",
  "DERIDES": "DERIDE, to ridicule, mock [v]\n",
  "DERIDING": "DERIDE, to ridicule, mock [v]\n",
  "DERIDINGLY": "DERIDING, DERIDE, to ridicule, mock [adv]\n",
  "DERIG": "to dismantle [v DERIGGED, DERIGGING, DERIGS]\n",
  "DERIGGED": "DERIG, to dismantle [v]\n",
  "DERIGGING": "DERIG, to dismantle [v]\n",
  "DERIGS": "DERIG, to dismantle [v]\n",
  "DERING": "DERE, (Spenser) to injure, also DEAR, DEARE [v]\n",
  "DERINGER": "a small pocket pistol, also DERRINGER [n -S]\n",
  "DERINGERS": "DERINGER, a small pocket pistol, also DERRINGER [n]\n",
  "DERISIBLE": "worthy of derision [adj]\n",
  "DERISION": "the act of deriding [n -S]\n",
  "DERISIONS": "DERISION, the act of deriding [n]\n",
  "DERISIVE": "expressing derision, also DERISORY [adj DERISIVELY]\n",
  "DERISIVELY": "DERISIVE, expressing derision, also DERISORY [adv]\n",
  "DERISIVENESS": "the state of being derisive [n -ES]\n",
  "DERISIVENESSES": "DERISIVENESS, the state of being derisive [n]\n",
  "DERISORY": "expressing derision, also DERISIVE [adj]\n",
  "DERIVABLE": "that can be derived [adj DERIVABLY]\n",
  "DERIVABLY": "DERIVABLE, that can be derived [adv]\n",
  "DERIVATE": "to derive, especially in a chemical sense [v DERIVATED, DERIVATING, DERIVATES]\n",
  "DERIVATED": "DERIVATE, to derive, especially in a chemical sense [v]\n",
  "DERIVATES": "DERIVATE, to derive, especially in a chemical sense [v]\n",
  "DERIVATING": "DERIVATE, to derive, especially in a chemical sense [v]\n",
  "DERIVATION": "the act of deriving [n -S]\n",
  "DERIVATIONAL": "relating to derivation [adj]\n",
  "DERIVATIONIST": "one who derives mathematical formulae [n -S]\n",
  "DERIVATIONISTS": "DERIVATIONIST, one who derives mathematical formulae [n]\n",
  "DERIVATIONS": "DERIVATION, the act of deriving [n]\n",
  "DERIVATISATION": "the conversion of a chemical compound into a derivative (as for identification), also DERIVATIZATION [n -S]\n",
  "DERIVATISATIONS": "DERIVATISATION, the conversion of a chemical compound into a derivative (as for identification), also DERIVATIZATION [n]\n",
  "DERIVATISE": "to make derivative, also DERIVATIZE [v DERIVATISED, DERIVATISING, DERIVATISES]\n",
  "DERIVATISED": "DERIVATISE, to make derivative, also DERIVATIZE [v]\n",
  "DERIVATISES": "DERIVATISE, to make derivative, also DERIVATIZE [v]\n",
  "DERIVATISING": "DERIVATISE, to make derivative, also DERIVATIZE [v]\n",
  "DERIVATIVE": "formed by derivation [adj DERIVATIVELY] / a word formed by derivation [n -S]\n",
  "DERIVATIVELY": "DERIVATIVE, formed by derivation [adv]\n",
  "DERIVATIVENESS": "DERIVATIVE, formed by derivation [n]\n",
  "DERIVATIVES": "DERIVATIVE, a word formed by derivation [n]\n",
  "DERIVATIZATION": "the conversion of a chemical compound into a derivative (as for identification), also DERIVATISATION [n -S]\n",
  "DERIVATIZATIONS": "DERIVATIZATION, the conversion of a chemical compound into a derivative (as for identification), also DERIVATISATION [n]\n",
  "DERIVATIZE": "to make derivative, also DERIVATISE [v DERIVATIZED, DERIVATIZING, DERIVATIZES]\n",
  "DERIVATIZED": "DERIVATIZE, to make derivative, also DERIVATISE [v]\n",
  "DERIVATIZES": "DERIVATIZE, to make derivative, also DERIVATISE [v]\n",
  "DERIVATIZING": "DERIVATIZE, to make derivative, also DERIVATISE [v]\n",
  "DERIVE": "to trace to an origin [v DERIVED, DERIVING, DERIVES]\n",
  "DERIVED": "DERIVE, to trace to an origin [v]\n",
  "DERIVER": "one who derives [n -S]\n",
  "DERIVERS": "DERIVER, one who derives [n]\n",
  "DERIVES": "DERIVE, to trace to an origin [v]\n",
  "DERIVING": "DERIVE, to trace to an origin [v]\n",
  "DERM": "the true skin, below the outer layer, also DERMA, DERMIS [n -S]\n",
  "DERMA": "(Greek) the true skin, below the outer layer, also DERM, DERMIS [n -S]\n",
  "DERMABRASION": "surgical removal of skin blemishes or imperfections (as scars or tattoos) by abrasion [n -S]\n",
  "DERMABRASIONS": "DERMABRASION, surgical removal of skin blemishes or imperfections (as scars or tattoos) by abrasion [n]\n",
  "DERMAL": "relating to the derm or skin, also DERMATIC, DERMIC [adj]\n",
  "DERMAPLANING": "a cosmetic treatment, often used to treat acne scars, in which surface irregularities are surgically scraped to give the skin a smoother appearance [n -S]\n",
  "DERMAPLANINGS": "DERMAPLANING, a cosmetic treatment, often used to treat acne scars, in which surface irregularities are surgically scraped to give the skin a smoother appearance [n]\n",
  "DERMAPTERAN": "any insect of the order Dermaptera, the earwigs [n -S]\n",
  "DERMAPTERANS": "DERMAPTERAN, any insect of the order Dermaptera, the earwigs [n]\n",
  "DERMAS": "DERMA, (Greek) the true skin, below the outer layer, also DERM, DERMIS [n]\n",
  "DERMATIC": "relating to the derm or skin, also DERMAL, DERMIC [adj]\n",
  "DERMATITIDES": "DERMATITIS, inflammation of the skin [n]\n",
  "DERMATITIS": "inflammation of the skin [n DERMATITIDES or DERMATITISES]\n",
  "DERMATITISES": "DERMATITIS, inflammation of the skin [n]\n",
  "DERMATOGEN": "the layer from which epidermis is formed at the growing point [n -S]\n",
  "DERMATOGENS": "DERMATOGEN, the layer from which epidermis is formed at the growing point [n]\n",
  "DERMATOGLYPHIC": "a ridge pattern of skin on the inner surface of the hands and feet [n -S]\n",
  "DERMATOGLYPHICS": "DERMATOGLYPHIC, a ridge pattern of skin on the inner surface of the hands and feet [n]\n",
  "DERMATOGRAPHIA": "a type of urticaria in which the physical allergy causes stroking or scratching, etc. to raise a red weal on the skin [n -S]\n",
  "DERMATOGRAPHIAS": "DERMATOGRAPHIA, a type of urticaria in which the physical allergy causes stroking or scratching, etc. to raise a red weal on the skin [n]\n",
  "DERMATOGRAPHIC": "related to dermatography [adj]\n",
  "DERMATOGRAPHIES": "DERMATOGRAPHY, anatomical description of the skin, also DERMOGRAPHY [n]\n",
  "DERMATOGRAPHY": "anatomical description of the skin, also DERMOGRAPHY [n DERMATOGRAPHIES]\n",
  "DERMATOID": "like or resembling skin [adj]\n",
  "DERMATOLOGIC": "relating to dermatology, also DERMATOLOGICAL [adj]\n",
  "DERMATOLOGICAL": "relating to dermatology, also DERMATOLOGIC [adj]\n",
  "DERMATOLOGIES": "DERMATOLOGY, the study of skin [n]\n",
  "DERMATOLOGIST": "one who studies dermatology [n -S]\n",
  "DERMATOLOGISTS": "DERMATOLOGIST, one who studies dermatology [n]\n",
  "DERMATOLOGY": "the study of skin [n DERMATOLOGIES]\n",
  "DERMATOMAL": "of or like a dermatome, the lateral wall of a somite from which the dermis produced [adj]\n",
  "DERMATOME": "the lateral wall of a somite from which the dermis is produced [n -S]\n",
  "DERMATOMES": "DERMATOME, the lateral wall of a somite from which the dermis is produced [n]\n",
  "DERMATOMIC": "relating to a dermatome, the lateral wall of a somite from which the dermis is produced [adj]\n",
  "DERMATOMYOSITIS": "a disease characterized by inflammation of the skin and muscles, and wasting of the muscles [n]\n",
  "DERMATOPHYTE": "a fungus parasitic on the skin or skin derivatives (as hair or nails) [n -S]\n",
  "DERMATOPHYTES": "DERMATOPHYTE, a fungus parasitic on the skin or skin derivatives (as hair or nails) [n]\n",
  "DERMATOPHYTIC": "of or like a dermatophyte, a fungus parasitic on the skin [adj]\n",
  "DERMATOPHYTOSES": "DERMATOPHYTOSIS, a fungal infection of the skin, esp. the feet [n]\n",
  "DERMATOPHYTOSIS": "a fungal infection of the skin, esp. the feet [n DERMATOPHYTOSES]\n",
  "DERMATOPLASTIC": "relating to dermatoplasty, a plastic operation on the skin [adj]\n",
  "DERMATOPLASTIES": "DERMATOPLASTY, a plastic operation on the skin [n]\n",
  "DERMATOPLASTY": "a plastic operation on the skin [n DERMATOPLASTIES]\n",
  "DERMATOSES": "DERMATOSIS, any skin disease [n]\n",
  "DERMATOSIS": "any skin disease [n DERMATOSES]\n",
  "DERMESTID": "any of a family of beetles with clubbed antennae, destructive to organic material [n -S]\n",
  "DERMESTIDS": "DERMESTID, any of a family of beetles with clubbed antennae, destructive to organic material [n]\n",
  "DERMIC": "relating to the derm or skin, also DERMAL, DERMATIC [adj]\n",
  "DERMIS": "(Greek) the true skin, below the outer layer, also DERM, DERMA [n -ES]\n",
  "DERMISES": "DERMIS, (Greek) the true skin, below the outer layer, also DERM, DERMA [n]\n",
  "DERMOGRAPHIES": "DERMOGRAPHY, anatomical description of the skin, also DERMATOGRAPHY [n]\n",
  "DERMOGRAPHY": "anatomical description of the skin, also DERMATOGRAPHY [n DERMOGRAPHIES]\n",
  "DERMOID": "a cyst or similar cell structure to that of the skin [n -S]\n",
  "DERMOIDS": "DERMOID, a cyst or similar cell structure to that of the skin [n]\n",
  "DERMS": "DERM, the true skin, below the outer layer, also DERMA, DERMIS [n]\n",
  "DERN": "secret; lonely, also DEARN [adj DERNLY] / to keep hidden [v -ED, -ING, -S]\n",
  "DERNED": "DERN, to keep hidden [v]\n",
  "DERNFUL": "solitary; mournful, also DEARNFUL [adj]\n",
  "DERNIER": "(French) last [adj]\n",
  "DERNIES": "DERNY, a bicycle with a small motor, used to set the pace in cycling events such as the keirin [n]\n",
  "DERNING": "DERN, to keep hidden [v]\n",
  "DERNLY": "(archaic) secretly; grievously [adv]\n",
  "DERNS": "DERN [n]\n",
  "DERNY": "a bicycle with a small motor, used to set the pace in cycling events such as the keirin [n DERNIES or DERNYS]\n",
  "DERNYS": "DERNY, a bicycle with a small motor, used to set the pace in cycling events such as the keirin [n]\n",
  "DERO": "(Australian slang) a derelict, also DERRO [n -S]\n",
  "DEROGATE": "degenerate [adj DEROGATELY] / to lessen by taking away; to detract [v DEROGATED, DEROGATING, DEROGATES]\n",
  "DEROGATED": "DEROGATE, to lessen by taking away; to detract [v]\n",
  "DEROGATELY": "(Shakespeare) in a derogatory manner [adj]\n",
  "DEROGATES": "DEROGATE, to lessen by taking away; to detract [v]\n",
  "DEROGATING": "DEROGATE, to lessen by taking away; to detract [v]\n",
  "DEROGATION": "a taking from, a detraction [n -S]\n",
  "DEROGATIONS": "DEROGATION, a taking from, a detraction [n]\n",
  "DEROGATIVE": "derogatory [adj DEROGATIVELY]\n",
  "DEROGATIVELY": "DEROGATIVE, derogatory [adv]\n",
  "DEROGATORILY": "DEROGATORY, detracting, injurious [adv]\n",
  "DEROGATORINESS": "the state of being derogatory [n]\n",
  "DEROGATORY": "detracting, injurious [adj DEROGATORILY]\n",
  "DEROS": "DERO, (Australian slang) a derelict, also DERRO [n]\n",
  "DERRICK": "a hoisting mechanism using a boom and a central post [n -S] / to hoist by use of a derrick [v -ED, -ING, -S]\n",
  "DERRICKED": "DERRICK, to hoist by use of a derrick [v]\n",
  "DERRICKING": "DERRICK, to hoist by use of a derrick [v]\n",
  "DERRICKS": "DERRICK, to hoist by use of a derrick [v]\n",
  "DERRIERE": "(French) the backside [n -S]\n",
  "DERRIERES": "DERRIERE, (French) the backside [n]\n",
  "DERRIES": "DERRY, (Australian slang) a dislike, as in to have a derry on someone [n]\n",
  "DERRINGER": "a small pocket pistol, also DERINGER [n -S]\n",
  "DERRINGERS": "DERRINGER, a small pocket pistol, also DERINGER [n]\n",
  "DERRIS": "a vine yielding rotenone, that can be used as an insecticide [n -ES]\n",
  "DERRISES": "DERRIS, a vine yielding rotenone, that can be used as an insecticide [n]\n",
  "DERRO": "(Australian slang) a derelict, also DERO [n -S]\n",
  "DERROS": "DERRO, (Australian slang) a derelict, also DERO [n]\n",
  "DERRY": "(Australian slang) a dislike, as in to have a derry on someone [n DERRIES]\n",
  "DERTH": "(Spenser) dearth [n -S]\n",
  "DERTHS": "DERTH, (Spenser) dearth [n]\n",
  "DERV": "fuel for a diesel engine road vehicle [n -S]\n",
  "DERVISH": "(Turkish) a Muslim (specifically a Sufi) religious man who has taken vows of poverty and austerity [n -ES]\n",
  "DERVISHES": "DERVISH, (Turkish) a Muslim (specifically a Sufi) religious man who has taken vows of poverty and austerity [n]\n",
  "DERVS": "DERV, fuel for a diesel engine road vehicle [n]\n",
  "DESACRALISATION": "the act of desacralising, also DESACRALIZATION [n]\n",
  "DESACRALISE": "to deprive or remove sacred qualities, also DESACRALIZE [v DESACRALISED, DESACRALISING, DESACRALISES]\n",
  "DESACRALISED": "DESACRALISE, to deprive or remove sacred qualities, also DESACRALIZE [v]\n",
  "DESACRALISES": "DESACRALISE, to deprive or remove sacred qualities, also DESACRALIZE [v]\n",
  "DESACRALISING": "DESACRALISE, to deprive or remove sacred qualities, also DESACRALIZE [v]\n",
  "DESACRALIZATION": "the act of desacralizing, also DESACRALISATION [n]\n",
  "DESACRALIZE": "to divest of supernatural qualities, also DESACRALISE [v DESACRALIZED, DESACRALIZING, DESACRALIZES]\n",
  "DESACRALIZED": "DESACRALIZE, to divest of supernatural qualities, also DESACRALISE [v]\n",
  "DESACRALIZES": "DESACRALIZE, to divest of supernatural qualities, also DESACRALISE [v]\n",
  "DESACRALIZING": "DESACRALIZE, to divest of supernatural qualities, also DESACRALISE [v]\n",
  "DESAGREMENT": "(French) something disagreeable [n -S]\n",
  "DESAGREMENTS": "DESAGREMENT, (French) something disagreeable [n]\n",
  "DESALINATE": "to remove the salt from [v DESALINATED, DESALINATING, DESALINATES]\n",
  "DESALINATED": "DESALINATE, to remove the salt from [v]\n",
  "DESALINATES": "DESALINATE, to remove the salt from [v]\n",
  "DESALINATING": "DESALINATE, to remove the salt from [v]\n",
  "DESALINATION": "the act of desalinating [n -S]\n",
  "DESALINATIONS": "DESALINATION, the act of desalinating [n]\n",
  "DESALINATOR": "an apparatus for desalinating [n -S]\n",
  "DESALINATORS": "DESALINATOR, an apparatus for desalinating [n]\n",
  "DESALINISATION": "the process of desalinising, also DESALINIZATION [n -S]\n",
  "DESALINISATIONS": "DESALINISATION, the process of desalinising, also DESALINIZATION [n]\n",
  "DESALINISE": "to remove the salt from, also DESALINIZE [v DESALINISED, DESALINISING, DESALINISES]\n",
  "DESALINISED": "DESALINISE, to remove the salt from, also DESALINIZE [v]\n",
  "DESALINISES": "DESALINISE, to remove the salt from, also DESALINIZE [v]\n",
  "DESALINISING": "DESALINISE, to remove the salt from, also DESALINIZE [v]\n",
  "DESALINIZATION": "the act of desalinizing, also DESALINISATION [n -S]\n",
  "DESALINIZATIONS": "DESALINIZATION, the act of desalinizing, also DESALINISATION [n]\n",
  "DESALINIZE": "to remove the salt from, also DESALINISE [v DESALINIZED, DESALINIZING, DESALINIZES]\n",
  "DESALINIZED": "DESALINIZE, to remove the salt from, also DESALINISE [v]\n",
  "DESALINIZES": "DESALINIZE, to remove the salt from, also DESALINISE [v]\n",
  "DESALINIZING": "DESALINIZE, to remove the salt from, also DESALINISE [v]\n",
  "DESALT": "to remove the salt from [v -ED, -ING, -S]\n",
  "DESALTED": "DESALT, to remove the salt from [v]\n",
  "DESALTER": "something used for desalting [n -S]\n",
  "DESALTERS": "DESALTER, something used for desalting [n]\n",
  "DESALTING": "the act of removing salt from [n -S]\n",
  "DESALTINGS": "DESALTING, the act of removing salt from [n]\n",
  "DESALTS": "DESALT, to remove the salt from [v]\n",
  "DESAND": "to remove sand from [v -ED, -ING, -S]\n",
  "DESANDED": "DESAND, to remove sand from [v]\n",
  "DESANDING": "DESAND, to remove sand from [v]\n",
  "DESANDS": "DESAND, to remove sand from [v]\n",
  "DESATURATE": "to cause to become unsaturated, to make less saturated [v DESATURATED, DESATURATING, DESATURATES]\n",
  "DESATURATED": "DESATURATE, to cause to become unsaturated, to make less saturated [v]\n",
  "DESATURATES": "DESATURATE, to cause to become unsaturated, to make less saturated [v]\n",
  "DESATURATING": "DESATURATE, to cause to become unsaturated, to make less saturated [v]\n",
  "DESATURATION": "the inverse of saturation, the degree to which a colour departs from white and approaches a pure spectral wavelength [n -S]\n",
  "DESATURATIONS": "DESATURATION, the inverse of saturation, the degree to which a colour departs from white and approaches a pure spectral wavelength [n]\n",
  "DESCALE": "to remove scales from fish [v DESCALED, DESCALING, DESCALES]\n",
  "DESCALED": "DESCALE, to remove scales from fish [v]\n",
  "DESCALER": "a thing for removing limescale from something such as a tap, kettle or coffee machine [n -S]\n",
  "DESCALERS": "DESCALER, a thing for removing limescale from something such as a tap, kettle or coffee machine [n]\n",
  "DESCALES": "DESCALE, to remove scales from fish [v]\n",
  "DESCALING": "DESCALE, to remove scales from fish [v]\n",
  "DESCANT": "an accompaniment above and harmonizing with the main melody [n -S] / to comment on a theme, also DISCANT [v -ED, -ING, -S]\n",
  "DESCANTED": "DESCANT, to comment on a theme, also DISCANT [v]\n",
  "DESCANTER": "one who performs a descant [n -S]\n",
  "DESCANTERS": "DESCANTER, one who performs a descant [n]\n",
  "DESCANTING": "DESCANT, to comment on a theme, also DISCANT [v]\n",
  "DESCANTS": "DESCANT, to comment on a theme, also DISCANT [v]\n",
  "DESCEND": "to come down [v -ED, -ING, -S]\n",
  "DESCENDABLE": "that can be descended, also DESCENDIBLE [adj]\n",
  "DESCENDANT": "one descended from another or from a common stock [n -S]\n",
  "DESCENDANTS": "DESCENDANT, one descended from another or from a common stock [n]\n",
  "DESCENDED": "DESCEND, to come down [v]\n",
  "DESCENDENT": "descending; proceeding from an ancestor or source [adj] / a descendant [n -S]\n",
  "DESCENDENTS": "DESCENDENT, a descendant [n]\n",
  "DESCENDER": "the part of the lowercase letters, such as g, p, and q, that extends below the other lowercase letters [n -S]\n",
  "DESCENDERS": "DESCENDER, the part of the lowercase letters, such as g, p, and q, that extends below the other lowercase letters [n]\n",
  "DESCENDEUR": "a shaped metal piece through which the rope can be fed, used to control the rate of descent in abseiling [n -S]\n",
  "DESCENDEURS": "DESCENDEUR, a shaped metal piece through which the rope can be fed, used to control the rate of descent in abseiling [n]\n",
  "DESCENDIBLE": "that can be descended, also DESCENDABLE [adj]\n",
  "DESCENDING": "(Shakespeare) lineage [n -S]\n",
  "DESCENDINGS": "DESCENDING, (Shakespeare) lineage [n]\n",
  "DESCENDS": "DESCEND, to come down [v]\n",
  "DESCENSION": "the act of going downward [n -S]\n",
  "DESCENSIONAL": "characterised by descension [adj]\n",
  "DESCENSIONS": "DESCENSION, the act of going downward [n]\n",
  "DESCENT": "the act of descending [n -S]\n",
  "DESCENTS": "DESCENT, the act of descending [n]\n",
  "DESCHOOL": "to educate children in a less formal way [v -ED, -ING, -S]\n",
  "DESCHOOLED": "DESCHOOL, to educate children in a less formal way [v]\n",
  "DESCHOOLER": "one who deschools, frees children from the constraints of traditional learning [n -S]\n",
  "DESCHOOLERS": "DESCHOOLER, one who deschools, frees children from the constraints of traditional learning [n]\n",
  "DESCHOOLING": "the freeing of children from the constraints of traditional learning [n -S]\n",
  "DESCHOOLINGS": "DESCHOOLING, the freeing of children from the constraints of traditional learning [n]\n",
  "DESCHOOLS": "DESCHOOL, to educate children in a less formal way [v]\n",
  "DESCRAMBLE": "to unscramble [v DESCRAMBLED, DESCRAMBLING, DESCRAMBLES]\n",
  "DESCRAMBLED": "DESCRAMBLE, to unscramble [v]\n",
  "DESCRAMBLER": "an electronic device for decoding scrambled signals [n -S]\n",
  "DESCRAMBLERS": "DESCRAMBLER, an electronic device for decoding scrambled signals [n]\n",
  "DESCRAMBLES": "DESCRAMBLE, to unscramble [v]\n",
  "DESCRAMBLING": "DESCRAMBLE, to unscramble [v]\n",
  "DESCRIBABLE": "that can be described [adj]\n",
  "DESCRIBE": "to recount the physical appearance, also DESCRIVE [v DESCRIBED, DESCRIBING, DESCRIBES]\n",
  "DESCRIBED": "DESCRIBE, to recount the physical appearance, also DESCRIVE [v]\n",
  "DESCRIBER": "one who describes [n -S]\n",
  "DESCRIBERS": "DESCRIBER, one who describes [n]\n",
  "DESCRIBES": "DESCRIBE, to recount the physical appearance, also DESCRIVE [v]\n",
  "DESCRIBING": "DESCRIBE, to recount the physical appearance, also DESCRIVE [v]\n",
  "DESCRIED": "DESCRY, to discern, detect [v]\n",
  "DESCRIER": "one who descries [n -S]\n",
  "DESCRIERS": "DESCRIER, one who descries [n]\n",
  "DESCRIES": "DESCRY, to discern, detect [v]\n",
  "DESCRIPTION": "an act of describing [n -S]\n",
  "DESCRIPTIONS": "DESCRIPTION, an act of describing [n]\n",
  "DESCRIPTIVE": "serving to describe [adj DESCRIPTIVELY]\n",
  "DESCRIPTIVELY": "DESCRIPTIVE, serving to describe [adv]\n",
  "DESCRIPTIVENESS": "DESCRIPTIVE, serving to describe [n]\n",
  "DESCRIPTIVISM": "a theory of ethics by which only empirical statements are acceptable [n -S]\n",
  "DESCRIPTIVISMS": "DESCRIPTIVISM, a theory of ethics by which only empirical statements are acceptable [n]\n",
  "DESCRIPTIVIST": "relating to descriptivism, a theory of ethics by which only empirical statements are acceptable [adj]\n",
  "DESCRIPTOR": "in computing, a symbol identifying a particular subject in a storage area [n -S]\n",
  "DESCRIPTORS": "DESCRIPTOR, in computing, a symbol identifying a particular subject in a storage area [n]\n",
  "DESCRIVE": "to recount the physical appearance, also DESCRIBE [v DESCRIVED, DESCRIVING, DESCRIVES]\n",
  "DESCRIVED": "DESCRIVE, to recount the physical appearance, also DESCRIBE [v]\n",
  "DESCRIVES": "DESCRIVE, to recount the physical appearance, also DESCRIBE [v]\n",
  "DESCRIVING": "DESCRIVE, to recount the physical appearance, also DESCRIBE [v]\n",
  "DESCRY": "to discern, detect [v DESCRIED, DESCRYING, DESCRIES]\n",
  "DESCRYING": "DESCRY, to discern, detect [v]\n",
  "DESECRATE": "to make no longer consecrated [v DESECRATED, DESECRATING, DESECRATES]\n",
  "DESECRATED": "DESECRATE, to make no longer consecrated [v]\n",
  "DESECRATER": "one who desecrates, also DESECRATOR [n -S]\n",
  "DESECRATERS": "DESECRATER, one who desecrates, also DESECRATOR [n]\n",
  "DESECRATES": "DESECRATE, to make no longer consecrated [v]\n",
  "DESECRATING": "DESECRATE, to make no longer consecrated [v]\n",
  "DESECRATION": "an act of desecrating [n -S]\n",
  "DESECRATIONS": "DESECRATION, an act of desecrating [n]\n",
  "DESECRATOR": "one who desecrates, also DESECRATER [n -S]\n",
  "DESECRATORS": "DESECRATOR, one who desecrates, also DESECRATER [n]\n",
  "DESEED": "to remove the seeds from [v -ED, -ING, -S]\n",
  "DESEEDED": "DESEED, to remove the seeds from [v]\n",
  "DESEEDER": "one that deseeds [n -S]\n",
  "DESEEDERS": "DESEEDER, one that deseeds [n]\n",
  "DESEEDING": "DESEED, to remove the seeds from [v]\n",
  "DESEEDS": "DESEED, to remove the seeds from [v]\n",
  "DESEGREGATE": "to eliminate segregation in [v DESEGREGATED, DESEGREGATING, DESEGREGATES]\n",
  "DESEGREGATED": "DESEGREGATE, to eliminate segregation in [v]\n",
  "DESEGREGATES": "DESEGREGATE, to eliminate segregation in [v]\n",
  "DESEGREGATING": "DESEGREGATE, to eliminate segregation in [v]\n",
  "DESEGREGATION": "the action or an instance of desegregating [n -S]\n",
  "DESEGREGATIONS": "DESEGREGATION, the action or an instance of desegregating [n]\n",
  "DESELECT": "to dismiss from a training program [v -ED, -ING, -S]\n",
  "DESELECTED": "DESELECT, to dismiss from a training program [v]\n",
  "DESELECTING": "DESELECT, to dismiss from a training program [v]\n",
  "DESELECTION": "the act of deselecting [n -S]\n",
  "DESELECTIONS": "DESELECTION, the act of deselecting [n]\n",
  "DESELECTS": "DESELECT, to dismiss from a training program [v]\n",
  "DESENSITISATION": "the act of desensitising, also DESENSITIZATION [n]\n",
  "DESENSITISE": "to make insensitive, also DESENSITIZE [v DESENSITISED, DESENSITISING, DESENSITISES]\n",
  "DESENSITISED": "DESENSITISE, to make insensitive, also DESENSITIZE [v]\n",
  "DESENSITISER": "an agent that desensitises, also DESENSITIZER [n -S]\n",
  "DESENSITISERS": "DESENSITISER, an agent that desensitises, also DESENSITIZER [n]\n",
  "DESENSITISES": "DESENSITISE, to make insensitive, also DESENSITIZE [v]\n",
  "DESENSITISING": "DESENSITISE, to make insensitive, also DESENSITIZE [v]\n",
  "DESENSITIZATION": "the act of desensitizing, also DESENSITISATION [n]\n",
  "DESENSITIZE": "to make insensitive, also DESENSITISE [v DESENSITIZED, DESENSITIZING, DESENSITIZES]\n",
  "DESENSITIZED": "DESENSITIZE, to make insensitive, also DESENSITISE [v]\n",
  "DESENSITIZER": "an agent that desensitizes, also DESENSITISER [n -S]\n",
  "DESENSITIZERS": "DESENSITIZER, an agent that desensitizes, also DESENSITISER [n]\n",
  "DESENSITIZES": "DESENSITIZE, to make insensitive, also DESENSITISE [v]\n",
  "DESENSITIZING": "DESENSITIZE, to make insensitive, also DESENSITISE [v]\n",
  "DESERPIDINE": "a synthetic sedative drug of which the natural base is Rauwolfia serpentina [n -S]\n",
  "DESERPIDINES": "DESERPIDINE, a synthetic sedative drug of which the natural base is Rauwolfia serpentina [n]\n",
  "DESERT": "to abandon [v -ED, -ING, -S]\n",
  "DESERTED": "DESERT, to abandon [v]\n",
  "DESERTER": "one that deserts [n -S]\n",
  "DESERTERS": "DESERTER, one that deserts [n]\n",
  "DESERTIC": "like a desert, arid and barren [adj]\n",
  "DESERTIFICATION": "a process of land degradation initiated by human activity, particularly in the zones along the margins of deserts [n]\n",
  "DESERTIFIED": "DESERTIFY, to make into a desert [v]\n",
  "DESERTIFIES": "DESERTIFY, to make into a desert [v]\n",
  "DESERTIFY": "to make into a desert [v DESERTIFIED, DESERTIFYING, DESERTIFIES]\n",
  "DESERTIFYING": "DESERTIFY, to make into a desert [v]\n",
  "DESERTING": "DESERT, to abandon [v]\n",
  "DESERTION": "the act of deserting [n -S]\n",
  "DESERTIONS": "DESERTION, the act of deserting [n]\n",
  "DESERTISATION": "the process of making into a desert, also DESERTIZATION [n -S]\n",
  "DESERTISATIONS": "DESERTISATION, the process of making into a desert, also DESERTIZATION [n]\n",
  "DESERTIZATION": "the process of making into a desert, also DESERTISATION [n -S]\n",
  "DESERTIZATIONS": "DESERTIZATION, the process of making into a desert, also DESERTISATION [n]\n",
  "DESERTLESS": "without merit [adj]\n",
  "DESERTS": "DESERT, to abandon [v]\n",
  "DESERVE": "to be worthy of [v DESERVED, DESERVING, DESERVES]\n",
  "DESERVED": "DESERVE, to be worthy of [v]\n",
  "DESERVEDLY": "DESERVED, DESERVE, to be worthy of [adv]\n",
  "DESERVEDNESS": "the state of being deserved [n -ES]\n",
  "DESERVEDNESSES": "DESERVEDNESS, the state of being deserved [n]\n",
  "DESERVER": "one who deserves [n -S]\n",
  "DESERVERS": "DESERVER, one who deserves [n]\n",
  "DESERVES": "DESERVE, to be worthy of [v]\n",
  "DESERVING": "worthy [adj DESERVINGLY] / the act of deserving [n -S]\n",
  "DESERVINGLY": "DESERVING, worthy [adv]\n",
  "DESERVINGNESS": "DESERVING, worthy [n]\n",
  "DESERVINGNESSES": "DESERVINGNESS, DESERVING, worthy [n]\n",
  "DESERVINGS": "DESERVING, the act of deserving [n]\n",
  "DESEX": "to remove gender attributes from [v -ED, -ING, -ES]\n",
  "DESEXED": "DESEX, to remove gender attributes from [v]\n",
  "DESEXES": "DESEX, to remove gender attributes from [v]\n",
  "DESEXING": "DESEX, to remove gender attributes from [v]\n",
  "DESEXUALISATION": "the act of desexualising, also DESEXUALIZATION [n]\n",
  "DESEXUALISE": "to deprive of sexual characters or power, also DESEXUALIZE [v DESEXUALISED, DESEXUALISING, DESEXUALISES]\n",
  "DESEXUALISED": "DESEXUALISE, to deprive of sexual characters or power, also DESEXUALIZE [v]\n",
  "DESEXUALISES": "DESEXUALISE, to deprive of sexual characters or power, also DESEXUALIZE [v]\n",
  "DESEXUALISING": "DESEXUALISE, to deprive of sexual characters or power, also DESEXUALIZE [v]\n",
  "DESEXUALIZATION": "the act of desexualizing, also DESEXUALISATION [n]\n",
  "DESEXUALIZE": "to deprive of sexual characters or power, also DESEXUALISE [v DESEXUALIZED, DESEXUALIZING, DESEXUALIZES]\n",
  "DESEXUALIZED": "DESEXUALIZE, to deprive of sexual characters or power, also DESEXUALISE [v]\n",
  "DESEXUALIZES": "DESEXUALIZE, to deprive of sexual characters or power, also DESEXUALISE [v]\n",
  "DESEXUALIZING": "DESEXUALIZE, to deprive of sexual characters or power, also DESEXUALISE [v]\n",
  "DESHABILLE": "(French) an undress; a careless toilet, also DISHABILLE [n -S]\n",
  "DESHABILLES": "DESHABILLE, (French) an undress; a careless toilet, also DISHABILLE [n]\n",
  "DESHI": "(Hinglish) a person of Indian, Pakistani or Bangladeshi birth who lives abroad, also DESI [n -S]\n",
  "DESHIS": "DESHI, (Hinglish) a person of Indian, Pakistani or Bangladeshi birth who lives abroad, also DESI [n]\n",
  "DESI": "(Hinglish) a person of Indian, Pakistani or Bangladeshi birth who lives abroad, also DESHI [n -S]\n",
  "DESICCANT": "a drying or desiccating agent [n -S]\n",
  "DESICCANTS": "DESICCANT, a drying or desiccating agent [n]\n",
  "DESICCATE": "to remove the moisture from, dry up [v DESICCATED, DESICCATING, DESICCATES]\n",
  "DESICCATED": "DESICCATE, to remove the moisture from, dry up [v]\n",
  "DESICCATES": "DESICCATE, to remove the moisture from, dry up [v]\n",
  "DESICCATING": "DESICCATE, to remove the moisture from, dry up [v]\n",
  "DESICCATION": "the state of being desiccated [n -S]\n",
  "DESICCATIONS": "DESICCATION, the state of being desiccated [n]\n",
  "DESICCATIVE": "a drying agent [n -S]\n",
  "DESICCATIVES": "DESICCATIVE, a drying agent [n]\n",
  "DESICCATOR": "one who, or that which, desiccates [n -S]\n",
  "DESICCATORS": "DESICCATOR, one who, or that which, desiccates [n]\n",
  "DESIDERATA": "DESIDERATUM, (Latin) something considered necessary or desirable [n]\n",
  "DESIDERATE": "to desire; to feel the want of [v DESIDERATED, DESIDERATING, DESIDERATES]\n",
  "DESIDERATED": "DESIDERATE, to desire; to feel the want of [v]\n",
  "DESIDERATES": "DESIDERATE, to desire; to feel the want of [v]\n",
  "DESIDERATING": "DESIDERATE, to desire; to feel the want of [v]\n",
  "DESIDERATION": "the act of desiderating [n -S]\n",
  "DESIDERATIONS": "DESIDERATION, the act of desiderating [n]\n",
  "DESIDERATIVE": "implying desire [adj] / something desirable [n -S]\n",
  "DESIDERATIVES": "DESIDERATIVE, something desirable [n]\n",
  "DESIDERATUM": "(Latin) something considered necessary or desirable [n DESIDERATA]\n",
  "DESIDERIUM": "longing or yearning [n -S]\n",
  "DESIDERIUMS": "DESIDERIUM, longing or yearning [n]\n",
  "DESIGN": "to plan in outline, also DESINE, DESYNE [v -ED, -ING, -S]\n",
  "DESIGNABLE": "capable of being designated or distinctly marked out; distinguishable [adj]\n",
  "DESIGNATE": "to mark out so as to make known [v DESIGNATED, DESIGNATING, DESIGNATES]\n",
  "DESIGNATED": "DESIGNATE, to mark out so as to make known [v]\n",
  "DESIGNATES": "DESIGNATE, to mark out so as to make known [v]\n",
  "DESIGNATING": "DESIGNATE, to mark out so as to make known [v]\n",
  "DESIGNATION": "the act of indicating or identifying [n -S]\n",
  "DESIGNATIONS": "DESIGNATION, the act of indicating or identifying [n]\n",
  "DESIGNATIVE": "serving to designate, also DESIGNATORY [adj]\n",
  "DESIGNATOR": "an officer who assigned to each his rank and place in public shows and ceremonies [n -S]\n",
  "DESIGNATORS": "DESIGNATOR, an officer who assigned to each his rank and place in public shows and ceremonies [n]\n",
  "DESIGNATORY": "serving to designate, also DESIGNATIVE [adj]\n",
  "DESIGNED": "DESIGN, to plan in outline, also DESINE, DESYNE [v]\n",
  "DESIGNEDLY": "DESIGNED, DESIGN, to plan in outline, also DESINE, DESYNE [adv]\n",
  "DESIGNEE": "one who is designated [n -S]\n",
  "DESIGNEES": "DESIGNEE, one who is designated [n]\n",
  "DESIGNER": "one who designs [n -S]\n",
  "DESIGNERS": "DESIGNER, one who designs [n]\n",
  "DESIGNFUL": "full of design [adj]\n",
  "DESIGNING": "artful; scheming [adj DESIGNINGLY] / the art of making designs or patterns [n -S]\n",
  "DESIGNINGLY": "DESIGNING, artful; scheming [adv]\n",
  "DESIGNINGS": "DESIGNING, the art of making designs or patterns [n]\n",
  "DESIGNLESS": "without design [adj]\n",
  "DESIGNMENT": "(obsolete) the design or sketch of a work [n -S]\n",
  "DESIGNMENTS": "DESIGNMENT, (obsolete) the design or sketch of a work [n]\n",
  "DESIGNS": "DESIGN, to plan in outline, also DESINE, DESYNE [v]\n",
  "DESILVER": "to remove the silver from [v -ED, -ING, -S]\n",
  "DESILVERED": "DESILVER, to remove the silver from [v]\n",
  "DESILVERING": "DESILVER, to remove the silver from [v]\n",
  "DESILVERISATION": "the process of desilverising, also DESILVERIZATION [n]\n",
  "DESILVERISE": "to remove the silver from, also DESILVERIZE [v DESILVERISED, DESILVERISING, DESILVERISES]\n",
  "DESILVERISED": "DESILVERISE, to remove the silver from, also DESILVERIZE [v]\n",
  "DESILVERISES": "DESILVERISE, to remove the silver from, also DESILVERIZE [v]\n",
  "DESILVERISING": "DESILVERISE, to remove the silver from, also DESILVERIZE [v]\n",
  "DESILVERIZATION": "the process of desilverizing, also DESILVERISATION [n]\n",
  "DESILVERIZE": "to remove the silver from, also DESILVERISE [v DESILVERIZED, DESILVERIZING, DESILVERIZES]\n",
  "DESILVERIZED": "DESILVERIZE, to remove the silver from, also DESILVERISE [v]\n",
  "DESILVERIZES": "DESILVERIZE, to remove the silver from, also DESILVERISE [v]\n",
  "DESILVERIZING": "DESILVERIZE, to remove the silver from, also DESILVERISE [v]\n",
  "DESILVERS": "DESILVER, to remove the silver from [v]\n",
  "DESINE": "(Spenser) to plan in outline, also DESIGN, DESYNE [v DESINED, DESINING, DESINES]\n",
  "DESINED": "DESINE, (Spenser) to plan in outline, also DESIGN, DESYNE [v]\n",
  "DESINENCE": "an ending or termination, especially the terminal inflection of a word [n -S]\n",
  "DESINENCES": "DESINENCE, an ending or termination, especially the terminal inflection of a word [n]\n",
  "DESINENT": "terminal; ending, also DESINENTIAL [adj]\n",
  "DESINENTIAL": "terminal; ending, also DESINENT [adj]\n",
  "DESINES": "DESINE, (Spenser) to plan in outline, also DESIGN, DESYNE [v]\n",
  "DESINING": "DESINE, (Spenser) to plan in outline, also DESIGN, DESYNE [v]\n",
  "DESIPIENCE": "foolishness, trifling [n -S]\n",
  "DESIPIENCES": "DESIPIENCE, foolishness, trifling [n]\n",
  "DESIPIENT": "playing the fool; trifling [adj]\n",
  "DESIPRAMINE": "a tricyclic antidepressant [n -S]\n",
  "DESIPRAMINES": "DESIPRAMINE, a tricyclic antidepressant [n]\n",
  "DESIRABILITIES": "DESIRABILITY, the quality of being desirable [n]\n",
  "DESIRABILITY": "the quality of being desirable [n DESIRABILITIES]\n",
  "DESIRABLE": "to be desired [adj DESIRABLY] / something desirable [n -S]\n",
  "DESIRABLENESS": "the state of being desirable [n -ES]\n",
  "DESIRABLENESSES": "DESIRABLENESS, the state of being desirable [n]\n",
  "DESIRABLES": "DESIRABLE, something desirable [n]\n",
  "DESIRABLY": "DESIRABLE, to be desired [adv]\n",
  "DESIRE": "to wish for [v DESIRED, DESIRING, DESIRES]\n",
  "DESIRED": "DESIRE, to wish for [v]\n",
  "DESIRELESS": "free from desire [adj]\n",
  "DESIRER": "one who desires [n -S]\n",
  "DESIRERS": "DESIRER, one who desires [n]\n",
  "DESIRES": "DESIRE, to wish for [v]\n",
  "DESIRING": "DESIRE, to wish for [v]\n",
  "DESIROUS": "desiring [adj DESIROUSLY]\n",
  "DESIROUSLY": "DESIROUS, desiring [adv]\n",
  "DESIROUSNESS": "the state of being desirous [n -ES]\n",
  "DESIROUSNESSES": "DESIROUSNESS, the state of being desirous [n]\n",
  "DESIS": "DESI, (Hinglish) a person of Indian, Pakistani or Bangladeshi birth who lives abroad, also DESHI [n]\n",
  "DESIST": "to cease doing something [v -ED, -ING, -S]\n",
  "DESISTANCE": "the act or state of desisting, also DESISTENCE [n -S]\n",
  "DESISTANCES": "DESISTANCE, the act or state of desisting, also DESISTENCE [n]\n",
  "DESISTED": "DESIST, to cease doing something [v]\n",
  "DESISTENCE": "the act or state of desisting, also DESISTANCE [n -S]\n",
  "DESISTENCES": "DESISTENCE, the act or state of desisting, also DESISTANCE [n]\n",
  "DESISTING": "DESIST, to cease doing something [v]\n",
  "DESISTS": "DESIST, to cease doing something [v]\n",
  "DESK": "a writing table [n -S]\n",
  "DESKBOUND": "confined to a desk (e.g. of someone doing paperwork and administration rather than active or practical work) [adj]\n",
  "DESKFAST": "breakfast eaten at one's desk [n -S]\n",
  "DESKFASTS": "DESKFAST, breakfast eaten at one's desk [n]\n",
  "DESKILL": "to make unskilled e.g. workers [v -ED, -ING, -S]\n",
  "DESKILLED": "DESKILL, to make unskilled e.g. workers [v]\n",
  "DESKILLING": "the act of making e.g. workers unskilled [n -S]\n",
  "DESKILLINGS": "DESKILLING, the act of making e.g. workers unskilled [n]\n",
  "DESKILLS": "DESKILL, to make unskilled e.g. workers [v]\n",
  "DESKING": "desks collectively [n -S]\n",
  "DESKINGS": "DESKING, desks collectively [n]\n",
  "DESKMAN": "a man who works at a desk [n DESKMEN]\n",
  "DESKMEN": "DESKMAN, a man who works at a desk [n]\n",
  "DESKNOTE": "a notebook computer used like a desktop [n -S]\n",
  "DESKNOTES": "DESKNOTE, a notebook computer used like a desktop [n]\n",
  "DESKS": "DESK, a writing table [n]\n",
  "DESKTOP": "a computer system small enough to use at a desk [n -S]\n",
  "DESKTOPS": "DESKTOP, a computer system small enough to use at a desk [n]\n",
  "DESMAN": "(Swedish) a Russian aquatic insectivore with long snout and musk glands [n -S]\n",
  "DESMANS": "DESMAN, (Swedish) a Russian aquatic insectivore with long snout and musk glands [n]\n",
  "DESMID": "any member of a family of freshwater microscopic unicellular green algae [n -S]\n",
  "DESMIDIAN": "like a desmid, any member of a family of freshwater microscopic unicellular green algae [adj]\n",
  "DESMIDS": "DESMID, any member of a family of freshwater microscopic unicellular green algae [n]\n",
  "DESMINE": "the mineral stilbite [n -S]\n",
  "DESMINES": "DESMINE, the mineral stilbite [n]\n",
  "DESMODIUM": "a plant of the telegraph-plant genus [n -S]\n",
  "DESMODIUMS": "DESMODIUM, a plant of the telegraph-plant genus [n]\n",
  "DESMODROMIC": "denoting a system, used in some motorcycle and racing car engines, that employs e.g. cams, rockers, etc. to ensure that the opening and closing of valves, when the vehicle is at high speed, is fully controlled [adj]\n",
  "DESMOID": "a firm swelling composed of scar tissue [n -S]\n",
  "DESMOIDS": "DESMOID, a firm swelling composed of scar tissue [n]\n",
  "DESMOSOMAL": "relating to a desmosome, a small thickened patch on the membrane of a cell [adj]\n",
  "DESMOSOME": "a small thickened patch on the membrane of a cell [n -S]\n",
  "DESMOSOMES": "DESMOSOME, a small thickened patch on the membrane of a cell [n]\n",
  "DESNOOD": "to remove a turkey's snood to discourage cannibalism [v -ED, -ING, -S]\n",
  "DESNOODED": "DESNOOD, to remove a turkey's snood to discourage cannibalism [v]\n",
  "DESNOODING": "DESNOOD, to remove a turkey's snood to discourage cannibalism [v]\n",
  "DESNOODS": "DESNOOD, to remove a turkey's snood to discourage cannibalism [v]\n",
  "DESOBLIGEANTE": "a carriage for one passenger [n -S]\n",
  "DESOBLIGEANTES": "DESOBLIGEANTE, a carriage for one passenger [n]\n",
  "DESOEUVRE": "(French) unoccupied, at a loose end [adj]\n",
  "DESOLATE": "lonely, waste [adj DESOLATELY] / to lay waste [v DESOLATED, DESOLATING, DESOLATES]\n",
  "DESOLATED": "DESOLATE, to lay waste [v]\n",
  "DESOLATELY": "DESOLATE, lonely, waste [adv]\n",
  "DESOLATENESS": "the state of being desolate [n -ES]\n",
  "DESOLATENESSES": "DESOLATENESS, the state of being desolate [n]\n",
  "DESOLATER": "one who desolates, lays waste, also DESOLATOR [n -S]\n",
  "DESOLATERS": "DESOLATER, one who desolates, lays waste, also DESOLATOR [n]\n",
  "DESOLATES": "DESOLATE, to lay waste [v]\n",
  "DESOLATING": "DESOLATE, to lay waste [v]\n",
  "DESOLATINGLY": "DESOLATING, DESOLATE, to lay waste [adv]\n",
  "DESOLATION": "the action of desolating [n -S]\n",
  "DESOLATIONS": "DESOLATION, the action of desolating [n]\n",
  "DESOLATOR": "one who desolates, lays waste, also DESOLATER [n -S]\n",
  "DESOLATORS": "DESOLATOR, one who desolates, lays waste, also DESOLATER [n]\n",
  "DESOLATORY": "causing desolation [adj]\n",
  "DESORB": "to release a sorbed substance, compare ABSORB, ADSORB, SORB [v -ED, -ING, -S]\n",
  "DESORBED": "DESORB, to release a sorbed substance, compare ABSORB, ADSORB, SORB [v]\n",
  "DESORBER": "one that desorbs [n -S]\n",
  "DESORBERS": "DESORBER, one that desorbs [n]\n",
  "DESORBING": "DESORB, to release a sorbed substance, compare ABSORB, ADSORB, SORB [v]\n",
  "DESORBS": "DESORB, to release a sorbed substance, compare ABSORB, ADSORB, SORB [v]\n",
  "DESORIENTE": "(French) having lost one's bearings, confused [adj]\n",
  "DESORPTION": "release from an adsorbed state [n -S]\n",
  "DESORPTIONS": "DESORPTION, release from an adsorbed state [n]\n",
  "DESOXY": "having less oxygen than its parent compound, also DEOXY [adj]\n",
  "DESOXYRIBOSE": "a pentose sugar obtained by the hydrolysis of DNA, also DEOXYRIBOSE [n -S]\n",
  "DESOXYRIBOSES": "DESOXYRIBOSE, a pentose sugar obtained by the hydrolysis of DNA, also DEOXYRIBOSE [n]\n",
  "DESPAIR": "to lose all hope [v -ED, -ING, -S]\n",
  "DESPAIRED": "DESPAIR, to lose all hope [v]\n",
  "DESPAIRER": "one who despairs [n -S]\n",
  "DESPAIRERS": "DESPAIRER, one who despairs [n]\n",
  "DESPAIRFUL": "(archaic) hopeless [adj]\n",
  "DESPAIRING": "DESPAIR, to lose all hope [v]\n",
  "DESPAIRINGLY": "DESPAIRING, DESPAIR, to lose all hope [adv]\n",
  "DESPAIRS": "DESPAIR, to lose all hope [v]\n",
  "DESPATCH": "to deal with speedily [v -ED, -ING, -ES]\n",
  "DESPATCHED": "DESPATCH, to deal with speedily [v]\n",
  "DESPATCHER": "one who despatches, also DISPATCHER [n -S]\n",
  "DESPATCHERS": "DESPATCHER, one who despatches, also DISPATCHER [n]\n",
  "DESPATCHES": "DESPATCH, to deal with speedily [v]\n",
  "DESPATCHING": "DESPATCH, to deal with speedily [v]\n",
  "DESPERADO": "a desperate fellow, an outlaw [n DESPERADOES or DESPERADOS]\n",
  "DESPERADOES": "DESPERADO, a desperate fellow, an outlaw [n]\n",
  "DESPERADOS": "DESPERADO, a desperate fellow, an outlaw [n]\n",
  "DESPERATE": "in a state of despair [adj DESPERATELY]\n",
  "DESPERATELY": "DESPERATE, in a state of despair [adv]\n",
  "DESPERATENESS": "the state of being desperate [n -ES]\n",
  "DESPERATENESSES": "DESPERATENESS, the state of being desperate [n]\n",
  "DESPERATION": "loss of hope and surrender to despair [n -S]\n",
  "DESPERATIONS": "DESPERATION, loss of hope and surrender to despair [n]\n",
  "DESPICABILITIES": "DESPICABILITY, the quality of being despicable [n]\n",
  "DESPICABILITY": "the quality of being despicable [n DESPICABILITIES]\n",
  "DESPICABLE": "worthy of being despised [adj DESPICABLY]\n",
  "DESPICABLENESS": "the state of being despicable [n]\n",
  "DESPICABLY": "DESPICABLE, worthy of being despised [adv]\n",
  "DESPIGHT": "a looking down with contempt, also DESPITE [n -S]\n",
  "DESPIGHTS": "DESPIGHT, a looking down with contempt, also DESPITE [n]\n",
  "DESPIRITUALISE": "to deprive of spiritual character or influence, also DESPIRITUALIZE [v DESPIRITUALISED, DESPIRITUALISES]\n",
  "DESPIRITUALISED": "DESPIRITUALISE, to deprive of spiritual character or influence, also DESPIRITUALIZE [v]\n",
  "DESPIRITUALISES": "DESPIRITUALISE, to deprive of spiritual character or influence, also DESPIRITUALIZE [v]\n",
  "DESPIRITUALIZE": "to deprive of spiritual character or influence, also DESPIRITUALISE [v DESPIRITUALIZED, DESPIRITUALIZES]\n",
  "DESPIRITUALIZED": "DESPIRITUALIZE, to deprive of spiritual character or influence, also DESPIRITUALISE [v]\n",
  "DESPIRITUALIZES": "DESPIRITUALIZE, to deprive of spiritual character or influence, also DESPIRITUALISE [v]\n",
  "DESPISABLE": "despicable; contemptible [adj]\n",
  "DESPISAL": "the act of despising [n -S]\n",
  "DESPISALS": "DESPISAL, the act of despising [n]\n",
  "DESPISE": "to look down upon with contempt [v DESPISED, DESPISING, DESPISES]\n",
  "DESPISED": "DESPISE, to look down upon with contempt [v]\n",
  "DESPISEDNESS": "(Milton) the state of being despised [n -ES]\n",
  "DESPISEDNESSES": "DESPISEDNESS, (Milton) the state of being despised [n]\n",
  "DESPISEMENT": "the act of despising [n -S]\n",
  "DESPISEMENTS": "DESPISEMENT, the act of despising [n]\n",
  "DESPISER": "one who despises [n -S]\n",
  "DESPISERS": "DESPISER, one who despises [n]\n",
  "DESPISES": "DESPISE, to look down upon with contempt [v]\n",
  "DESPISING": "DESPISE, to look down upon with contempt [v]\n",
  "DESPISINGLY": "DESPISING, DESPISE, to look down upon with contempt [adv]\n",
  "DESPITE": "to treat with contempt [v DESPITED, DESPITING, DESPITES]\n",
  "DESPITED": "DESPITE, to treat with contempt [v]\n",
  "DESPITEFUL": "(archaic) full of despite, malicious [adj DESPITEFULLY]\n",
  "DESPITEFULLY": "DESPITEFUL, (archaic) full of despite, malicious [adv]\n",
  "DESPITEFULNESS": "DESPITEFUL, (archaic) full of despite, malicious [n]\n",
  "DESPITEOUS": "(obsolete) feeling or showing despite [adj DESPITEOUSLY]\n",
  "DESPITEOUSLY": "DESPITEOUS, (obsolete) feeling or showing despite [adv]\n",
  "DESPITEOUSNESS": "the state of being despiteous, spiteful [n]\n",
  "DESPITES": "DESPITE, to treat with contempt [v]\n",
  "DESPITING": "DESPITE, to treat with contempt [v]\n",
  "DESPOIL": "to plunder [v -ED, -ING, -S]\n",
  "DESPOILED": "DESPOIL, to plunder [v]\n",
  "DESPOILER": "one who despoils [n -S]\n",
  "DESPOILERS": "DESPOILER, one who despoils [n]\n",
  "DESPOILING": "the act of pillaging [n -S]\n",
  "DESPOILINGS": "DESPOILING, the act of pillaging [n]\n",
  "DESPOILMENT": "the act of despoiling [n -S]\n",
  "DESPOILMENTS": "DESPOILMENT, the act of despoiling [n]\n",
  "DESPOILS": "DESPOIL, to plunder [v]\n",
  "DESPOLIATION": "the act of despoiling [n -S]\n",
  "DESPOLIATIONS": "DESPOLIATION, the act of despoiling [n]\n",
  "DESPOND": "to lose heart [v -ED, -ING, -S]\n",
  "DESPONDED": "DESPOND, to lose heart [v]\n",
  "DESPONDENCE": "the state of being despondent, also DESPONDENCY [n -S]\n",
  "DESPONDENCES": "DESPONDENCE, the state of being despondent, also DESPONDENCY [n]\n",
  "DESPONDENCIES": "DESPONDENCY, the state of being despondent, also DESPONDENCE [n]\n",
  "DESPONDENCY": "the state of being despondent, also DESPONDENCE [n DESPONDENCIES]\n",
  "DESPONDENT": "feeling or showing extreme discouragement [adj DESPONDENTLY]\n",
  "DESPONDENTLY": "DESPONDENT, feeling or showing extreme discouragement [adv]\n",
  "DESPONDING": "hopeless [adj DESPONDINGLY] / the act of desponding [n -S]\n",
  "DESPONDINGLY": "DESPONDING, hopeless [adv]\n",
  "DESPONDINGS": "DESPONDING, the act of desponding [n]\n",
  "DESPONDS": "DESPOND, to lose heart [v]\n",
  "DESPOT": "a ruler with absolute power and authority [n -S]\n",
  "DESPOTAT": "a territory governed by a despot, also DESPOTATE [n -S]\n",
  "DESPOTATE": "a territory governed by a despot, also DESPOTAT [n -S]\n",
  "DESPOTATES": "DESPOTATE, a territory governed by a despot, also DESPOTAT [n]\n",
  "DESPOTATS": "DESPOTAT, a territory governed by a despot, also DESPOTATE [n]\n",
  "DESPOTIC": "having the character of, or pertaining to, a despot, also DESPOTICAL [adj DESPOTICALLY]\n",
  "DESPOTICAL": "having the character of, or pertaining to, a despot, also DESPOTIC [adj DESPOTICALLY]\n",
  "DESPOTICALLY": "DESPOTICAL, having the character of, or pertaining to, a despot, also DESPOTIC [adv]\n",
  "DESPOTICALNESS": "the state of being despotical [n]\n",
  "DESPOTISM": "absolute power; a state governed by a despot [n -S]\n",
  "DESPOTISMS": "DESPOTISM, absolute power; a state governed by a despot [n]\n",
  "DESPOTOCRACIES": "DESPOTOCRACY, rulership by despots or tyrants [n]\n",
  "DESPOTOCRACY": "rulership by despots or tyrants [n DESPOTOCRACIES]\n",
  "DESPOTS": "DESPOT, a ruler with absolute power and authority [n]\n",
  "DESPUMATE": "to throw off impurities in foam or scum [v DESPUMATED, DESPUMATING, DESPUMATES]\n",
  "DESPUMATED": "DESPUMATE, to throw off impurities in foam or scum [v]\n",
  "DESPUMATES": "DESPUMATE, to throw off impurities in foam or scum [v]\n",
  "DESPUMATING": "DESPUMATE, to throw off impurities in foam or scum [v]\n",
  "DESPUMATION": "the throwing off of impurities [n -S]\n",
  "DESPUMATIONS": "DESPUMATION, the throwing off of impurities [n]\n",
  "DESQUAMATE": "to scale or flake off [v DESQUAMATED, DESQUAMATING, DESQUAMATES]\n",
  "DESQUAMATED": "DESQUAMATE, to scale or flake off [v]\n",
  "DESQUAMATES": "DESQUAMATE, to scale or flake off [v]\n",
  "DESQUAMATING": "DESQUAMATE, to scale or flake off [v]\n",
  "DESQUAMATION": "having one's skin fall off due to its being waterlogged [n -S]\n",
  "DESQUAMATIONS": "DESQUAMATION, having one's skin fall off due to its being waterlogged [n]\n",
  "DESQUAMATIVE": "serving to desquamate [adj]\n",
  "DESQUAMATORIES": "DESQUAMATORY, an obsolete surgical instrument once used for the desquamation of bones [n]\n",
  "DESQUAMATORY": "an obsolete surgical instrument once used for the desquamation of bones [n DESQUAMATORIES]\n",
  "DESSE": "(Spenser) a desk [n -S]\n",
  "DESSERT": "a final course of a meal [n -S]\n",
  "DESSERTS": "DESSERT, a final course of a meal [n]\n",
  "DESSERTSPOON": "a spoon intermediate in size between a teaspoon and a tablespoon for use in eating dessert [n -S]\n",
  "DESSERTSPOONFUL": "the contents of a dessert spoon [n]\n",
  "DESSERTSPOONS": "DESSERTSPOON, a spoon intermediate in size between a teaspoon and a tablespoon for use in eating dessert [n]\n",
  "DESSES": "DESSE, (Spenser) a desk [n]\n",
  "DESSIATINE": "(Russian) a measure of land, also DESSYATIN, DESSYATINE, DESYATIN [n -S]\n",
  "DESSIATINES": "DESSIATINE, (Russian) a measure of land, also DESSYATIN, DESSYATINE, DESYATIN [n]\n",
  "DESSIGNMENT": "(Spenser) design, planning [n -S]\n",
  "DESSIGNMENTS": "DESSIGNMENT, (Spenser) design, planning [n]\n",
  "DESSYATIN": "(Russian) a measure of land, also DESSIATINE, DESSYATINE, DESYATIN [n -S]\n",
  "DESSYATINE": "(Russian) a measure of land, also DESSIATINE, DESSYATIN, DESYATIN [n -S]\n",
  "DESSYATINES": "DESSYATINE, (Russian) a measure of land, also DESSIATINE, DESSYATIN, DESYATIN [n]\n",
  "DESSYATINS": "DESSYATIN, (Russian) a measure of land, also DESSIATINE, DESSYATINE, DESYATIN [n]\n",
  "DESTABILISATION": "the act of destabilising, also DESTABILIZATION [n]\n",
  "DESTABILISE": "to make unstable, also DESTABILIZE [v DESTABILISED, DESTABILISING, DESTABILISES]\n",
  "DESTABILISED": "DESTABILISE, to make unstable, also DESTABILIZE [v]\n",
  "DESTABILISER": "something that destabilises, also DESTABILIZER [n -S]\n",
  "DESTABILISERS": "DESTABILISER, something that destabilises, also DESTABILIZER [n]\n",
  "DESTABILISES": "DESTABILISE, to make unstable, also DESTABILIZE [v]\n",
  "DESTABILISING": "DESTABILISE, to make unstable, also DESTABILIZE [v]\n",
  "DESTABILIZATION": "the act of destabilizing, also DESTABILISATION [n]\n",
  "DESTABILIZE": "to make unstable, also DESTABILISE [v DESTABILIZED, DESTABILIZING, DESTABILIZES]\n",
  "DESTABILIZED": "DESTABILIZE, to make unstable, also DESTABILISE [v]\n",
  "DESTABILIZER": "something that destabilizes, also DESTABILISER [n -S]\n",
  "DESTABILIZERS": "DESTABILIZER, something that destabilizes, also DESTABILISER [n]\n",
  "DESTABILIZES": "DESTABILIZE, to make unstable, also DESTABILISE [v]\n",
  "DESTABILIZING": "DESTABILIZE, to make unstable, also DESTABILISE [v]\n",
  "DESTAIN": "to rid of stain [v -ED, -ING, -S]\n",
  "DESTAINED": "DESTAIN, to rid of stain [v]\n",
  "DESTAINING": "DESTAIN, to rid of stain [v]\n",
  "DESTAINS": "DESTAIN, to rid of stain [v]\n",
  "DESTEMPER": "(obsolete) to distemper, in the paint sense, also DISTEMPER [v -ED, -ING, -S]\n",
  "DESTEMPERED": "DESTEMPER, (obsolete) to distemper, in the paint sense, also DISTEMPER [v]\n",
  "DESTEMPERING": "DESTEMPER, (obsolete) to distemper, in the paint sense, also DISTEMPER [v]\n",
  "DESTEMPERS": "DESTEMPER, (obsolete) to distemper, in the paint sense, also DISTEMPER [v]\n",
  "DESTINATE": "(obsolete) to ordain, to destine [v DESTINATED, DESTINATING, DESTINATES]\n",
  "DESTINATED": "DESTINATE, (obsolete) to ordain, to destine [v]\n",
  "DESTINATES": "DESTINATE, (obsolete) to ordain, to destine [v]\n",
  "DESTINATING": "DESTINATE, (obsolete) to ordain, to destine [v]\n",
  "DESTINATION": "the purpose for which something is destined [n -S]\n",
  "DESTINATIONS": "DESTINATION, the purpose for which something is destined [n]\n",
  "DESTINE": "to determine beforehand [v DESTINED, DESTINING, DESTINES]\n",
  "DESTINED": "DESTINE, to determine beforehand [v]\n",
  "DESTINES": "DESTINE, to determine beforehand [v]\n",
  "DESTINIES": "DESTINY, inevitable fate [n]\n",
  "DESTINING": "DESTINE, to determine beforehand [v]\n",
  "DESTINY": "inevitable fate [n DESTINIES]\n",
  "DESTITUTE": "forsaken, very poor [adj] / to forsake, to deprive [v DESTITUTED, DESTITUTING, DESTITUTES]\n",
  "DESTITUTED": "DESTITUTE, to forsake, to deprive [v]\n",
  "DESTITUTENESS": "the state of being destitute [n -ES]\n",
  "DESTITUTENESSES": "DESTITUTENESS, the state of being destitute [n]\n",
  "DESTITUTES": "DESTITUTE, to forsake, to deprive [v]\n",
  "DESTITUTING": "DESTITUTE, to forsake, to deprive [v]\n",
  "DESTITUTION": "the state of being destitute [n -S]\n",
  "DESTITUTIONS": "DESTITUTION, the state of being destitute [n]\n",
  "DESTOCK": "to reduce the stock level [v -ED, -ING, -S]\n",
  "DESTOCKED": "DESTOCK, to reduce the stock level [v]\n",
  "DESTOCKING": "DESTOCK, to reduce the stock level [v]\n",
  "DESTOCKS": "DESTOCK, to reduce the stock level [v]\n",
  "DESTREAM": "to reverse the categorising of students [v -ED, -ING, -S]\n",
  "DESTREAMED": "DESTREAM, to reverse the categorising of students [v]\n",
  "DESTREAMING": "DESTREAM, to reverse the categorising of students [v]\n",
  "DESTREAMS": "DESTREAM, to reverse the categorising of students [v]\n",
  "DESTRESS": "to remove stress from [v -ED, -ING, -ES]\n",
  "DESTRESSED": "DESTRESS, to remove stress from [v]\n",
  "DESTRESSES": "DESTRESS, to remove stress from [v]\n",
  "DESTRESSING": "DESTRESS, to remove stress from [v]\n",
  "DESTRIER": "(archaic) a warhorse [n -S]\n",
  "DESTRIERS": "DESTRIER, (archaic) a warhorse [n]\n",
  "DESTROY": "to damage beyond repair or renewal, also STROY [v -ED, -ING, -S]\n",
  "DESTROYABLE": "that can be destroyed [adj]\n",
  "DESTROYED": "DESTROY, to damage beyond repair or renewal, also STROY [v]\n",
  "DESTROYER": "a small fast lightly armoured but heavily armed warship [n -S]\n",
  "DESTROYERS": "DESTROYER, a small fast lightly armoured but heavily armed warship [n]\n",
  "DESTROYING": "DESTROY, to damage beyond repair or renewal, also STROY [v]\n",
  "DESTROYS": "DESTROY, to damage beyond repair or renewal, also STROY [v]\n",
  "DESTRUCT": "to destroy [v -ED, -ING, -S]\n",
  "DESTRUCTED": "DESTRUCT, to destroy [v]\n",
  "DESTRUCTIBILITY": "the state of being destructible [n]\n",
  "DESTRUCTIBLE": "capable of being destroyed [adj]\n",
  "DESTRUCTING": "DESTRUCT, to destroy [v]\n",
  "DESTRUCTION": "the state or fact of being destroyed [n -S]\n",
  "DESTRUCTIONAL": "relating to destruction [adj]\n",
  "DESTRUCTIONIST": "one who delights in or advocates destruction [n -S]\n",
  "DESTRUCTIONISTS": "DESTRUCTIONIST, one who delights in or advocates destruction [n]\n",
  "DESTRUCTIONS": "DESTRUCTION, the state or fact of being destroyed [n]\n",
  "DESTRUCTIVE": "causing destruction [adj DESTRUCTIVELY] / something destructive [n -S]\n",
  "DESTRUCTIVELY": "DESTRUCTIVE, causing destruction [adv]\n",
  "DESTRUCTIVENESS": "the state of being destructive [n]\n",
  "DESTRUCTIVES": "DESTRUCTIVE, something destructive [n]\n",
  "DESTRUCTIVISM": "the theory that a part of a whole may be considered a principle part if the destruction of that part would lead to the destruction of the whole [n -S]\n",
  "DESTRUCTIVISMS": "DESTRUCTIVISM, the theory that a part of a whole may be considered a principle part if the destruction of that part would lead to the destruction of the whole [n]\n",
  "DESTRUCTIVIST": "a representative of destructive principles [n -S]\n",
  "DESTRUCTIVISTS": "DESTRUCTIVIST, a representative of destructive principles [n]\n",
  "DESTRUCTIVITIES": "DESTRUCTIVITY, capacity for destruction [n]\n",
  "DESTRUCTIVITY": "capacity for destruction [n DESTRUCTIVITIES]\n",
  "DESTRUCTO": "(Australian slang) a destructive person [n -S]\n",
  "DESTRUCTOR": "a destroyer [n -S]\n",
  "DESTRUCTORS": "DESTRUCTOR, a destroyer [n]\n",
  "DESTRUCTOS": "DESTRUCTO, (Australian slang) a destructive person [n]\n",
  "DESTRUCTS": "DESTRUCT, to destroy [v]\n",
  "DESUETUDE": "disuse, discontinuance [n -S]\n",
  "DESUETUDES": "DESUETUDE, disuse, discontinuance [n]\n",
  "DESUGAR": "to remove the sugar from [v -ED, -ING, -S]\n",
  "DESUGARED": "DESUGAR, to remove the sugar from [v]\n",
  "DESUGARING": "DESUGAR, to remove the sugar from [v]\n",
  "DESUGARS": "DESUGAR, to remove the sugar from [v]\n",
  "DESULFUR": "to free from sulphur [v -ED, -ING, -S]\n",
  "DESULFURATE": "to remove the sulphur from [v DESULFURATED, DESULFURATING, DESULFURATES]\n",
  "DESULFURATED": "DESULFURATE, to remove the sulphur from [v]\n",
  "DESULFURATES": "DESULFURATE, to remove the sulphur from [v]\n",
  "DESULFURATING": "DESULFURATE, to remove the sulphur from [v]\n",
  "DESULFURATION": "the act of removing sulphur from [n -S]\n",
  "DESULFURATIONS": "DESULFURATION, the act of removing sulphur from [n]\n",
  "DESULFURED": "DESULFUR, to free from sulphur [v]\n",
  "DESULFURING": "DESULFUR, to free from sulphur [v]\n",
  "DESULFURISATION": "the removal of sulfur or sulfur compounds (as from coal or flue gas), also DESULFURIZATION [n]\n",
  "DESULFURISE": "to remove the sulfur from a compound, also DESULFURIZE, DESULPHURISE, DESULPHURIZE [v DESULFURISED, DESULFURISING, DESULFURISES]\n",
  "DESULFURISED": "DESULFURISE, to remove the sulfur from a compound, also DESULFURIZE, DESULPHURISE, DESULPHURIZE [v]\n",
  "DESULFURISER": "a device for removing sulfur, also DESULFURIZER [n -S]\n",
  "DESULFURISERS": "DESULFURISER, a device for removing sulfur, also DESULFURIZER [n]\n",
  "DESULFURISES": "DESULFURISE, to remove the sulfur from a compound, also DESULFURIZE, DESULPHURISE, DESULPHURIZE [v]\n",
  "DESULFURISING": "DESULFURISE, to remove the sulfur from a compound, also DESULFURIZE, DESULPHURISE, DESULPHURIZE [v]\n",
  "DESULFURIZATION": "the removal of sulfur or sulfur compounds (as from coal or flue gas), also DESULFURISATION [n]\n",
  "DESULFURIZE": "to remove the sulphur from a compound, also DESULFURISE, DESULPHURISE, DESULPHURIZE [v DESULFURIZED, DESULFURIZING, DESULFURIZES]\n",
  "DESULFURIZED": "DESULFURIZE, to remove the sulphur from a compound, also DESULFURISE, DESULPHURISE, DESULPHURIZE [v]\n",
  "DESULFURIZER": "something for removing sulfur, also DESULFURISER [n -S]\n",
  "DESULFURIZERS": "DESULFURIZER, something for removing sulfur, also DESULFURISER [n]\n",
  "DESULFURIZES": "DESULFURIZE, to remove the sulphur from a compound, also DESULFURISE, DESULPHURISE, DESULPHURIZE [v]\n",
  "DESULFURIZING": "DESULFURIZE, to remove the sulphur from a compound, also DESULFURISE, DESULPHURISE, DESULPHURIZE [v]\n",
  "DESULFURS": "DESULFUR, to free from sulphur [v]\n",
  "DESULPHUR": "to remove sulphur from, also DESULFUR [v -ED, -ING, -S]\n",
  "DESULPHURATE": "to remove sulphur from [v DESULPHURATED, DESULPHURATING, DESULPHURATES]\n",
  "DESULPHURATED": "DESULPHURATE, to remove sulphur from [v]\n",
  "DESULPHURATES": "DESULPHURATE, to remove sulphur from [v]\n",
  "DESULPHURATING": "DESULPHURATE, to remove sulphur from [v]\n",
  "DESULPHURATION": "the act of desulphuring [n -S]\n",
  "DESULPHURATIONS": "DESULPHURATION, the act of desulphuring [n]\n",
  "DESULPHURED": "DESULPHUR, to remove sulphur from, also DESULFUR [v]\n",
  "DESULPHURING": "DESULPHUR, to remove sulphur from, also DESULFUR [v]\n",
  "DESULPHURISE": "to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURIZE [v DESULPHURISED, DESULPHURISING, DESULPHURISES]\n",
  "DESULPHURISED": "DESULPHURISE, to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURIZE [v]\n",
  "DESULPHURISER": "an agent for desulphuring, also DESULPHURIZER [n -S]\n",
  "DESULPHURISERS": "DESULPHURISER, an agent for desulphuring, also DESULPHURIZER [n]\n",
  "DESULPHURISES": "DESULPHURISE, to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURIZE [v]\n",
  "DESULPHURISING": "DESULPHURISE, to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURIZE [v]\n",
  "DESULPHURIZE": "to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURISE [v DESULPHURIZED, DESULPHURIZING, DESULPHURIZES]\n",
  "DESULPHURIZED": "DESULPHURIZE, to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURISE [v]\n",
  "DESULPHURIZER": "an agent for desulphuring, also DESULPHURISER [n -S]\n",
  "DESULPHURIZERS": "DESULPHURIZER, an agent for desulphuring, also DESULPHURISER [n]\n",
  "DESULPHURIZES": "DESULPHURIZE, to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURISE [v]\n",
  "DESULPHURIZING": "DESULPHURIZE, to remove the sulphur from a compound, also DESULFURISE, DESULFURIZE, DESULPHURISE [v]\n",
  "DESULPHURS": "DESULPHUR, to remove sulphur from, also DESULFUR [v]\n",
  "DESULTORILY": "DESULTORY, jumping from one thing to another; rambling [adv]\n",
  "DESULTORINESS": "the state of being desultory [n -ES]\n",
  "DESULTORINESSES": "DESULTORINESS, the state of being desultory [n]\n",
  "DESULTORY": "jumping from one thing to another; rambling [adj DESULTORILY]\n",
  "DESYATIN": "(Russian) a measure of land, also DESSIATINE, DESSYATIN, DESSYATINE [n -S]\n",
  "DESYATINS": "DESYATIN, (Russian) a measure of land, also DESSIATINE, DESSYATIN, DESSYATINE [n]\n",
  "DESYNE": "(Spenser) to plan in outline, also DESIGN, DESINE [v DESYNED, DESYNING, DESYNES]\n",
  "DESYNED": "DESYNE, (Spenser) to plan in outline, also DESIGN, DESINE [v]\n",
  "DESYNES": "DESYNE, (Spenser) to plan in outline, also DESIGN, DESINE [v]\n",
  "DESYNING": "DESYNE, (Spenser) to plan in outline, also DESIGN, DESINE [v]\n",
  "DETACH": "to unfasten and separate [v -ED, -ING, -ES]\n",
  "DETACHABILITIES": "DETACHABILITY, the state of being detachable [n]\n",
  "DETACHABILITY": "the state of being detachable [n DETACHABILITIES]\n",
  "DETACHABLE": "that can be detached [adj DETACHABLY]\n",
  "DETACHABLY": "DETACHABLE, that can be detached [adv]\n",
  "DETACHED": "DETACH, to unfasten and separate [v]\n",
  "DETACHEDLY": "DETACHED, DETACH, to unfasten and separate [adv]\n",
  "DETACHEDNESS": "the state of being detached [n -ES]\n",
  "DETACHEDNESSES": "DETACHEDNESS, the state of being detached [n]\n",
  "DETACHER": "one who detaches [n -S]\n",
  "DETACHERS": "DETACHER, one who detaches [n]\n",
  "DETACHES": "DETACH, to unfasten and separate [v]\n",
  "DETACHING": "DETACH, to unfasten and separate [v]\n",
  "DETACHMENT": "the act of detaching [n -S]\n",
  "DETACHMENTS": "DETACHMENT, the act of detaching [n]\n",
  "DETAIL": "to relate minutely [v -ED, -ING, -S]\n",
  "DETAILED": "DETAIL, to relate minutely [v]\n",
  "DETAILEDLY": "DETAILED, DETAIL, to relate minutely [adv]\n",
  "DETAILEDNESS": "the state of being detailed [n -ES]\n",
  "DETAILEDNESSES": "DETAILEDNESS, the state of being detailed [n]\n",
  "DETAILER": "one who details [n -S]\n",
  "DETAILERS": "DETAILER, one who details [n]\n",
  "DETAILING": "the act of detailing [n -S]\n",
  "DETAILINGS": "DETAILING, the act of detailing [n]\n",
  "DETAILS": "DETAIL, to relate minutely [v]\n",
  "DETAIN": "to hold in custody [v -ED, -ING, -S]\n",
  "DETAINABLE": "that can be detained [adj]\n",
  "DETAINED": "DETAIN, to hold in custody [v]\n",
  "DETAINEE": "one who is detained [n -S]\n",
  "DETAINEES": "DETAINEE, one who is detained [n]\n",
  "DETAINER": "the unlawful withholding of another's property [n -S]\n",
  "DETAINERS": "DETAINER, the unlawful withholding of another's property [n]\n",
  "DETAINING": "DETAIN, to hold in custody [v]\n",
  "DETAINMENT": "detention [n -S]\n",
  "DETAINMENTS": "DETAINMENT, detention [n]\n",
  "DETAINS": "DETAIN, to hold in custody [v]\n",
  "DETANGLE": "to remove knots or tangles from [v DETANGLED, DETANGLING, DETANGLES]\n",
  "DETANGLED": "DETANGLE, to remove knots or tangles from [v]\n",
  "DETANGLER": "a cosmetic product for detangling hair [n -S]\n",
  "DETANGLERS": "DETANGLER, a cosmetic product for detangling hair [n]\n",
  "DETANGLES": "DETANGLE, to remove knots or tangles from [v]\n",
  "DETANGLING": "DETANGLE, to remove knots or tangles from [v]\n",
  "DETASSEL": "to remove the tassels from [v DETASSELED or DETASSELLED, DETASSELING or DETASSELLING, DETASSELS]\n",
  "DETASSELED": "DETASSEL, to remove the tassels from [v]\n",
  "DETASSELING": "DETASSEL, to remove the tassels from [v]\n",
  "DETASSELLED": "DETASSEL, to remove the tassels from [v]\n",
  "DETASSELLING": "DETASSEL, to remove the tassels from [v]\n",
  "DETASSELS": "DETASSEL, to remove the tassels from [v]\n",
  "DETECT": "to discover or perceive [v -ED, -ING, -S]\n",
  "DETECTABILITIES": "DETECTABILITY, the state of being detectable [n]\n",
  "DETECTABILITY": "the state of being detectable [n DETECTABILITIES]\n",
  "DETECTABLE": "that can be detected, also DETECTIBLE [adj]\n",
  "DETECTED": "DETECT, to discover or perceive [v]\n",
  "DETECTER": "one that detects, also DETECTOR [n -S]\n",
  "DETECTERS": "DETECTER, one that detects, also DETECTOR [n]\n",
  "DETECTIBLE": "that can be detected, also DETECTABLE [adj]\n",
  "DETECTING": "DETECT, to discover or perceive [v]\n",
  "DETECTION": "the act of detecting [n -S]\n",
  "DETECTIONS": "DETECTION, the act of detecting [n]\n",
  "DETECTIVE": "a policeman, usually not in uniform, or other person (private detective) who investigates cases of crime [n -S]\n",
  "DETECTIVELIKE": "like a detective [adj]\n",
  "DETECTIVES": "DETECTIVE, a policeman, usually not in uniform, or other person (private detective) who investigates cases of crime [n]\n",
  "DETECTIVIST": "a writer of detective fiction [n -S]\n",
  "DETECTIVISTS": "DETECTIVIST, a writer of detective fiction [n]\n",
  "DETECTOPHONE": "a secret telephone for eavesdropping [n -S]\n",
  "DETECTOPHONES": "DETECTOPHONE, a secret telephone for eavesdropping [n]\n",
  "DETECTOR": "one that detects, also DETECTER [n -S]\n",
  "DETECTORIST": "a person whose hobby is using a metal detector [n -S]\n",
  "DETECTORISTS": "DETECTORIST, a person whose hobby is using a metal detector [n]\n",
  "DETECTORS": "DETECTOR, one that detects, also DETECTER [n]\n",
  "DETECTS": "DETECT, to discover or perceive [v]\n",
  "DETENT": "any stop or catch in a machine which prevents a motion until released, e.g. on a crossbow [n -S]\n",
  "DETENTE": "(French) a relaxation of strained relations, esp. between countries [n -S]\n",
  "DETENTES": "DETENTE, (French) a relaxation of strained relations, esp. between countries [n]\n",
  "DETENTION": "the act of detaining [n -S]\n",
  "DETENTIONS": "DETENTION, the act of detaining [n]\n",
  "DETENTIST": "a supporter of detente [n -S]\n",
  "DETENTISTS": "DETENTIST, a supporter of detente [n]\n",
  "DETENTS": "DETENT, any stop or catch in a machine which prevents a motion until released, e.g. on a crossbow [n]\n",
  "DETENU": "(French) a (male) prisoner, esp. a political prisoner in India [n -S]\n",
  "DETENUE": "(French) a (female) prisoner, esp. a political prisoner in India [n -S]\n",
  "DETENUES": "DETENUE, (French) a (female) prisoner, esp. a political prisoner in India [n]\n",
  "DETENUS": "DETENU, (French) a (male) prisoner, esp. a political prisoner in India [n]\n",
  "DETER": "to hinder or prevent [v DETERRED, DETERRING, DETERS]\n",
  "DETERGE": "to cleanse esp. a wound [v DETERGED, DETERGING, DETERGES]\n",
  "DETERGED": "DETERGE, to cleanse esp. a wound [v]\n",
  "DETERGENCE": "a cleansing quality, also DETERGENCY [n -S]\n",
  "DETERGENCES": "DETERGENCE, a cleansing quality, also DETERGENCY [n]\n",
  "DETERGENCIES": "DETERGENCY, a cleansing quality, also DETERGENCE [n]\n",
  "DETERGENCY": "a cleansing quality, also DETERGENCE [n DETERGENCIES]\n",
  "DETERGENT": "a cleansing agent [n -S]\n",
  "DETERGENTS": "DETERGENT, a cleansing agent [n]\n",
  "DETERGER": "one that deterges [n -S]\n",
  "DETERGERS": "DETERGER, one that deterges [n]\n",
  "DETERGES": "DETERGE, to cleanse esp. a wound [v]\n",
  "DETERGING": "DETERGE, to cleanse esp. a wound [v]\n",
  "DETERIORATE": "to make inferior in quality or value [v DETERIORATED, DETERIORATING, DETERIORATES]\n",
  "DETERIORATED": "DETERIORATE, to make inferior in quality or value [v]\n",
  "DETERIORATES": "DETERIORATE, to make inferior in quality or value [v]\n",
  "DETERIORATING": "DETERIORATE, to make inferior in quality or value [v]\n",
  "DETERIORATION": "the act of deteriorating [n -S]\n",
  "DETERIORATIONS": "DETERIORATION, the act of deteriorating [n]\n",
  "DETERIORATIVE": "tending to deteriorate [adj]\n",
  "DETERIORISM": "the doctrine that the world grows worse [n -S]\n",
  "DETERIORISMS": "DETERIORISM, the doctrine that the world grows worse [n]\n",
  "DETERIORITIES": "DETERIORITY, (obsolete) worseness [n]\n",
  "DETERIORITY": "(obsolete) worseness [n DETERIORITIES]\n",
  "DETERMENT": "the act of deterring [n -S]\n",
  "DETERMENTS": "DETERMENT, the act of deterring [n]\n",
  "DETERMINABILITY": "the quality of being determinable [n]\n",
  "DETERMINABLE": "capable of being determined [adj DETERMINABLY]\n",
  "DETERMINABLY": "DETERMINABLE, capable of being determined [adv]\n",
  "DETERMINACIES": "DETERMINACY, the state of being determinate [n]\n",
  "DETERMINACY": "the state of being determinate [n DETERMINACIES]\n",
  "DETERMINANT": "that which serves to determine [n -S]\n",
  "DETERMINANTAL": "relating to determinant [adj]\n",
  "DETERMINANTS": "DETERMINANT, that which serves to determine [n]\n",
  "DETERMINATE": "of definite or limited growth [adj DETERMINATELY] / (Shakespeare) to determine [v DETERMINATED, DETERMINATING, DETERMINATES]\n",
  "DETERMINATED": "DETERMINATE, (Shakespeare) to determine [v]\n",
  "DETERMINATELY": "DETERMINATE, of definite or limited growth [adv]\n",
  "DETERMINATENESS": "the state of being determinate [n]\n",
  "DETERMINATES": "DETERMINATE, (Shakespeare) to determine [v]\n",
  "DETERMINATING": "DETERMINATE, (Shakespeare) to determine [v]\n",
  "DETERMINATION": "the act, process, or result of an accurate measurement [n -S]\n",
  "DETERMINATIONS": "DETERMINATION, the act, process, or result of an accurate measurement [n]\n",
  "DETERMINATIVE": "having power or tendency to determine [adj DETERMINATIVELY] / a factor that determines [n -S]\n",
  "DETERMINATIVELY": "DETERMINATIVE, having power or tendency to determine [adv]\n",
  "DETERMINATIVES": "DETERMINATIVE, a factor that determines [n]\n",
  "DETERMINATOR": "something that determines [n -S]\n",
  "DETERMINATORS": "DETERMINATOR, something that determines [n]\n",
  "DETERMINE": "to put terms or bounds to [v DETERMINED, DETERMINING, DETERMINES]\n",
  "DETERMINED": "DETERMINE, to put terms or bounds to [v]\n",
  "DETERMINEDLY": "DETERMINED, DETERMINE, to put terms or bounds to [adv]\n",
  "DETERMINEDNESS": "the state of being determined [n]\n",
  "DETERMINER": "one that determines [n -S]\n",
  "DETERMINERS": "DETERMINER, one that determines [n]\n",
  "DETERMINES": "DETERMINE, to put terms or bounds to [v]\n",
  "DETERMINING": "DETERMINE, to put terms or bounds to [v]\n",
  "DETERMINISM": "the doctrine that all things, including the will, are determined by causes [n -S]\n",
  "DETERMINISMS": "DETERMINISM, the doctrine that all things, including the will, are determined by causes [n]\n",
  "DETERMINIST": "a believer in determinism [n -S]\n",
  "DETERMINISTIC": "relating to determinism [adj]\n",
  "DETERMINISTS": "DETERMINIST, a believer in determinism [n]\n",
  "DETERRABILITIES": "DETERRABILITY, the state of being deterrable [n]\n",
  "DETERRABILITY": "the state of being deterrable [n DETERRABILITIES]\n",
  "DETERRABLE": "that can be deterred [adj]\n",
  "DETERRED": "DETER, to hinder or prevent [v]\n",
  "DETERRENCE": "the act of deterring [n -S]\n",
  "DETERRENCES": "DETERRENCE, the act of deterring [n]\n",
  "DETERRENT": "serving to deter [adj DETERRENTLY] / something that deters [n -S]\n",
  "DETERRENTLY": "DETERRENT, serving to deter [adv]\n",
  "DETERRENTS": "DETERRENT, something that deters [n]\n",
  "DETERRER": "one that deters [n -S]\n",
  "DETERRERS": "DETERRER, one that deters [n]\n",
  "DETERRING": "DETER, to hinder or prevent [v]\n",
  "DETERS": "DETER, to hinder or prevent [v]\n",
  "DETERSION": "the act of cleaning [n -S]\n",
  "DETERSIONS": "DETERSION, the act of cleaning [n]\n",
  "DETERSIVE": "cleansing [adj] / a detergent [n -S]\n",
  "DETERSIVES": "DETERSIVE, a detergent [n]\n",
  "DETEST": "to hate intensely [v -ED, -ING, -S]\n",
  "DETESTABILITIES": "DETESTABILITY, the quality of being detestable [n]\n",
  "DETESTABILITY": "the quality of being detestable [n DETESTABILITIES]\n",
  "DETESTABLE": "hateful [adj DETESTABLY]\n",
  "DETESTABLENESS": "the state of being detestable [n]\n",
  "DETESTABLY": "DETESTABLE, hateful [adv]\n",
  "DETESTATION": "extreme dislike [n -S]\n",
  "DETESTATIONS": "DETESTATION, extreme dislike [n]\n",
  "DETESTED": "DETEST, to hate intensely [v]\n",
  "DETESTER": "one who detests [n -S]\n",
  "DETESTERS": "DETESTER, one who detests [n]\n",
  "DETESTING": "DETEST, to hate intensely [v]\n",
  "DETESTS": "DETEST, to hate intensely [v]\n",
  "DETHATCH": "to remove thatch from [v -ED, -ING, -ES]\n",
  "DETHATCHED": "DETHATCH, to remove thatch from [v]\n",
  "DETHATCHES": "DETHATCH, to remove thatch from [v]\n",
  "DETHATCHING": "DETHATCH, to remove thatch from [v]\n",
  "DETHRONE": "to remove from a throne also DISTHRONE, UNTHRONE [v DETHRONED, DETHRONING, DETHRONES]\n",
  "DETHRONED": "DETHRONE, to remove from a throne also DISTHRONE, UNTHRONE [v]\n",
  "DETHRONEMENT": "the act of dethroning [n -S]\n",
  "DETHRONEMENTS": "DETHRONEMENT, the act of dethroning [n]\n",
  "DETHRONER": "one who dethrones [n -S]\n",
  "DETHRONERS": "DETHRONER, one who dethrones [n]\n",
  "DETHRONES": "DETHRONE, to remove from a throne also DISTHRONE, UNTHRONE [v]\n",
  "DETHRONING": "the act of removing from a throne [n -S]\n",
  "DETHRONINGS": "DETHRONING, the act of removing from a throne [n]\n",
  "DETHRONISE": "to remove from a throne, also DETHRONIZE [v DETHRONISED, DETHRONISING, DETHRONISES]\n",
  "DETHRONISED": "DETHRONISE, to remove from a throne, also DETHRONIZE [v]\n",
  "DETHRONISES": "DETHRONISE, to remove from a throne, also DETHRONIZE [v]\n",
  "DETHRONISING": "DETHRONISE, to remove from a throne, also DETHRONIZE [v]\n",
  "DETHRONIZE": "to dethrone, also DETHRONISE [v DETHRONIZED, DETHRONIZING, DETHRONIZES]\n",
  "DETHRONIZED": "DETHRONIZE, to dethrone, also DETHRONISE [v]\n",
  "DETHRONIZES": "DETHRONIZE, to dethrone, also DETHRONISE [v]\n",
  "DETHRONIZING": "DETHRONIZE, to dethrone, also DETHRONISE [v]\n",
  "DETICK": "to free from ticks [v -ED, -ING, -S]\n",
  "DETICKED": "DETICK, to free from ticks [v]\n",
  "DETICKER": "an agent used for deticking [n -S]\n",
  "DETICKERS": "DETICKER, an agent used for deticking [n]\n",
  "DETICKING": "DETICK, to free from ticks [v]\n",
  "DETICKS": "DETICK, to free from ticks [v]\n",
  "DETINUE": "action to recover property wrongfully detained [n -S]\n",
  "DETINUES": "DETINUE, action to recover property wrongfully detained [n]\n",
  "DETONABILITIES": "DETONABILITY, the state of being detonable [n]\n",
  "DETONABILITY": "the state of being detonable [n DETONABILITIES]\n",
  "DETONABLE": "able to be detonated, also DETONATABLE [adj]\n",
  "DETONATABLE": "able to be detonated, also DETONABLE [adj]\n",
  "DETONATE": "to cause to explode [v DETONATED, DETONATING, DETONATES]\n",
  "DETONATED": "DETONATE, to cause to explode [v]\n",
  "DETONATES": "DETONATE, to cause to explode [v]\n",
  "DETONATING": "DETONATE, to cause to explode [v]\n",
  "DETONATION": "the act of detonating [n -S]\n",
  "DETONATIONS": "DETONATION, the act of detonating [n]\n",
  "DETONATIVE": "of or like a detonation [adj]\n",
  "DETONATOR": "a substance that detonates [n -S]\n",
  "DETONATORS": "DETONATOR, a substance that detonates [n]\n",
  "DETORSION": "the act of detorting; a twisting or warping, also DETORTION [n -S]\n",
  "DETORSIONS": "DETORSION, the act of detorting; a twisting or warping, also DETORTION [n]\n",
  "DETORT": "(obsolete) to untwist [v -ED, -ING, -S]\n",
  "DETORTED": "DETORT, (obsolete) to untwist [v]\n",
  "DETORTING": "DETORT, (obsolete) to untwist [v]\n",
  "DETORTION": "(obsolete) the act of detorting; a twisting or warping, also DETORSION [n -S]\n",
  "DETORTIONS": "DETORTION, (obsolete) the act of detorting; a twisting or warping, also DETORSION [n]\n",
  "DETORTS": "DETORT, (obsolete) to untwist [v]\n",
  "DETOUR": "to take an indirect route [v -ED, -ING, -S]\n",
  "DETOURED": "DETOUR, to take an indirect route [v]\n",
  "DETOURING": "DETOUR, to take an indirect route [v]\n",
  "DETOURS": "DETOUR, to take an indirect route [v]\n",
  "DETOX": "to remove a toxin from, also DETOXIFY [v -ED, -ING, -ES]\n",
  "DETOXED": "DETOX, to remove a toxin from, also DETOXIFY [v]\n",
  "DETOXES": "DETOX, to remove a toxin from, also DETOXIFY [v]\n",
  "DETOXICANT": "an agent that detoxicates, gets rid of a poison [n -S]\n",
  "DETOXICANTS": "DETOXICANT, an agent that detoxicates, gets rid of a poison [n]\n",
  "DETOXICATE": "to rid of a poison or the effects of it [v DETOXICATED, DETOXICATING, DETOXICATES]\n",
  "DETOXICATED": "DETOXICATE, to rid of a poison or the effects of it [v]\n",
  "DETOXICATES": "DETOXICATE, to rid of a poison or the effects of it [v]\n",
  "DETOXICATING": "DETOXICATE, to rid of a poison or the effects of it [v]\n",
  "DETOXICATION": "the act of detoxicating [n -S]\n",
  "DETOXICATIONS": "DETOXICATION, the act of detoxicating [n]\n",
  "DETOXIFICATION": "the act of detoxifying [n -S]\n",
  "DETOXIFICATIONS": "DETOXIFICATION, the act of detoxifying [n]\n",
  "DETOXIFIED": "DETOXIFY, to remove a toxin from, also DETOX [v]\n",
  "DETOXIFIES": "DETOXIFY, to remove a toxin from, also DETOX [v]\n",
  "DETOXIFY": "to remove a toxin from, also DETOX [v DETOXIFIED, DETOXIFYING, DETOXIFIES]\n",
  "DETOXIFYING": "DETOXIFY, to remove a toxin from, also DETOX [v]\n",
  "DETOXING": "DETOX, to remove a toxin from, also DETOXIFY [v]\n",
  "DETRACT": "to take away [v -ED, -ING, -S]\n",
  "DETRACTED": "DETRACT, to take away [v]\n",
  "DETRACTING": "taking away [adj DETRACTINGLY] / the act of taking away from [n -S]\n",
  "DETRACTINGLY": "DETRACTING [adv]\n",
  "DETRACTINGS": "DETRACTING, the act of taking away from [n]\n",
  "DETRACTION": "depreciation, slander [n -S]\n",
  "DETRACTIONS": "DETRACTION, depreciation, slander [n]\n",
  "DETRACTIVE": "tending to detract, also DETRACTORY [adj DETRACTIVELY]\n",
  "DETRACTIVELY": "DETRACTIVE, tending to detract, also DETRACTORY [adv]\n",
  "DETRACTOR": "a belittler or disparager [n -S]\n",
  "DETRACTORS": "DETRACTOR, a belittler or disparager [n]\n",
  "DETRACTORY": "tending to detract, also DETRACTIVE [adj]\n",
  "DETRACTRESS": "a female detractor [n -ES]\n",
  "DETRACTRESSES": "DETRACTRESS, a female detractor [n]\n",
  "DETRACTS": "DETRACT, to take away [v]\n",
  "DETRAIN": "to alight from a train [v -ED, -ING, -S]\n",
  "DETRAINED": "DETRAIN, to alight from a train [v]\n",
  "DETRAINING": "DETRAIN, to alight from a train [v]\n",
  "DETRAINMENT": "the act of detraining [n -S]\n",
  "DETRAINMENTS": "DETRAINMENT, the act of detraining [n]\n",
  "DETRAINS": "DETRAIN, to alight from a train [v]\n",
  "DETRAQUE": "(French) a (male) person who is deranged [n -S]\n",
  "DETRAQUEE": "(French) a (female) person who is deranged [n -S]\n",
  "DETRAQUEES": "DETRAQUEE, (French) a (female) person who is deranged [n]\n",
  "DETRAQUES": "DETRAQUE, (French) a (male) person who is deranged [n]\n",
  "DETRIBALISATION": "the act of detribalising, also DETRIBALIZATION [n]\n",
  "DETRIBALISE": "to cause to lose tribal identity, also DETRIBALIZE [v DETRIBALISED, DETRIBALISING, DETRIBALISES]\n",
  "DETRIBALISED": "DETRIBALISE, to cause to lose tribal identity, also DETRIBALIZE [v]\n",
  "DETRIBALISES": "DETRIBALISE, to cause to lose tribal identity, also DETRIBALIZE [v]\n",
  "DETRIBALISING": "DETRIBALISE, to cause to lose tribal identity, also DETRIBALIZE [v]\n",
  "DETRIBALIZATION": "the act of detribalizing, also DETRIBALISATION [n]\n",
  "DETRIBALIZE": "to cause to lose tribal identity, also DETRIBALISE [v DETRIBALIZED, DETRIBALIZING, DETRIBALIZES]\n",
  "DETRIBALIZED": "DETRIBALIZE, to cause to lose tribal identity, also DETRIBALISE [v]\n",
  "DETRIBALIZES": "DETRIBALIZE, to cause to lose tribal identity, also DETRIBALISE [v]\n",
  "DETRIBALIZING": "DETRIBALIZE, to cause to lose tribal identity, also DETRIBALISE [v]\n",
  "DETRIMENT": "diminution; damage [n -S]\n",
  "DETRIMENTAL": "harmful [adj DETRIMENTALLY] / an undesirable or harmful person or thing [n -S]\n",
  "DETRIMENTALLY": "DETRIMENTAL, harmful [adv]\n",
  "DETRIMENTALS": "DETRIMENTAL, an undesirable or harmful person or thing [n]\n",
  "DETRIMENTS": "DETRIMENT, diminution; damage [n]\n",
  "DETRITAL": "pertaining to, or composed of, detritus [adj]\n",
  "DETRITION": "a wearing off or away [n -S]\n",
  "DETRITIONS": "DETRITION, a wearing off or away [n]\n",
  "DETRITOVORE": "an organism that feeds on detritus [n -S]\n",
  "DETRITOVORES": "DETRITOVORE, an organism that feeds on detritus [n]\n",
  "DETRITUS": "(Latin) particles of rock [n DETRITUS]\n",
  "DETRUDE": "to thrust out [v DETRUDED, DETRUDING, DETRUDES]\n",
  "DETRUDED": "DETRUDE, to thrust out [v]\n",
  "DETRUDES": "DETRUDE, to thrust out [v]\n",
  "DETRUDING": "DETRUDE, to thrust out [v]\n",
  "DETRUNCATE": "to cut short, lop, mutilate [v DETRUNCATED, DETRUNCATING, DETRUNCATES]\n",
  "DETRUNCATED": "DETRUNCATE, to cut short, lop, mutilate [v]\n",
  "DETRUNCATES": "DETRUNCATE, to cut short, lop, mutilate [v]\n",
  "DETRUNCATING": "DETRUNCATE, to cut short, lop, mutilate [v]\n",
  "DETRUNCATION": "the act of detruncating [n -S]\n",
  "DETRUNCATIONS": "DETRUNCATION, the act of detruncating [n]\n",
  "DETRUSION": "the act of thrusting or driving down or outward [n -S]\n",
  "DETRUSIONS": "DETRUSION, the act of thrusting or driving down or outward [n]\n",
  "DETRUSOR": "a muscle in the wall of the bladder that contracts when the bladder is full [n -S]\n",
  "DETRUSORS": "DETRUSOR, a muscle in the wall of the bladder that contracts when the bladder is full [n]\n",
  "DETUMESCENCE": "diminution of swelling [n -S]\n",
  "DETUMESCENCES": "DETUMESCENCE, diminution of swelling [n]\n",
  "DETUMESCENT": "causing detumescence [adj]\n",
  "DETUNE": "to reduce the power of a car engine [v DETUNED, DETUNING, DETUNES]\n",
  "DETUNED": "DETUNE, to reduce the power of a car engine [v]\n",
  "DETUNES": "DETUNE, to reduce the power of a car engine [v]\n",
  "DETUNING": "DETUNE, to reduce the power of a car engine [v]\n",
  "DEUCE": "to even the score at tennis [v DEUCED, DEUCING, DEUCES]\n",
  "DEUCED": "DEUCE, to even the score at tennis [v]\n",
  "DEUCEDLY": "extremely [adv]\n",
  "DEUCES": "DEUCE, to even the score at tennis [v]\n",
  "DEUCING": "DEUCE, to even the score at tennis [v]\n",
  "DEUDDARN": "(Welsh) a Welsh dresser or sideboard in two stages [n -S]\n",
  "DEUDDARNS": "DEUDDARN, (Welsh) a Welsh dresser or sideboard in two stages [n]\n",
  "DEUS": "(Latin) god [n DEI or DI]\n",
  "DEUTERAGONIST": "the actor taking the part of second importance in a classical Greek drama [n -S]\n",
  "DEUTERAGONISTS": "DEUTERAGONIST, the actor taking the part of second importance in a classical Greek drama [n]\n",
  "DEUTERANOMALIES": "DEUTERANOMALY, the state of being deuteranomalous [n]\n",
  "DEUTERANOMALOUS": "exhibiting partial loss of green color vision so that an increased intensity of green is required in a mixture of red and green to match a given yellow [adj]\n",
  "DEUTERANOMALY": "the state of being deuteranomalous [n DEUTERANOMALIES]\n",
  "DEUTERANOPE": "an individual affected with deuteranopia, red-green colour-blindness [n -S]\n",
  "DEUTERANOPES": "DEUTERANOPE, an individual affected with deuteranopia, red-green colour-blindness [n]\n",
  "DEUTERANOPIA": "red-green colour-blindness [n -S]\n",
  "DEUTERANOPIAS": "DEUTERANOPIA, red-green colour-blindness [n]\n",
  "DEUTERANOPIC": "relating to deuteranopia, red-green colour-blindness [adj]\n",
  "DEUTERATE": "to add deuterium to; to replace hydrogen by deuterium in molecules [v DEUTERATED, DEUTERATING, DEUTERATES]\n",
  "DEUTERATED": "DEUTERATE, to add deuterium to; to replace hydrogen by deuterium in molecules [v]\n",
  "DEUTERATES": "DEUTERATE, to add deuterium to; to replace hydrogen by deuterium in molecules [v]\n",
  "DEUTERATING": "DEUTERATE, to add deuterium to; to replace hydrogen by deuterium in molecules [v]\n",
  "DEUTERATION": "the act of deuterating [n -S]\n",
  "DEUTERATIONS": "DEUTERATION, the act of deuterating [n]\n",
  "DEUTERIC": "pertaining to heavy hydrogen [adj]\n",
  "DEUTERIDE": "a hydrogen compound containing another element [n -S]\n",
  "DEUTERIDES": "DEUTERIDE, a hydrogen compound containing another element [n]\n",
  "DEUTERIUM": "heavy hydrogen, an isotope of hydrogen of double mass [n -S]\n",
  "DEUTERIUMS": "DEUTERIUM, heavy hydrogen, an isotope of hydrogen of double mass [n]\n",
  "DEUTEROGAMIES": "DEUTEROGAMY, a second marriage after the death of the first spouse, also DIGAMY [n]\n",
  "DEUTEROGAMIST": "someone who remarries after a spouse's death, also DIGAMIST [n -S]\n",
  "DEUTEROGAMISTS": "DEUTEROGAMIST, someone who remarries after a spouse's death, also DIGAMIST [n]\n",
  "DEUTEROGAMY": "a second marriage after the death of the first spouse, also DIGAMY [n DEUTEROGAMIES]\n",
  "DEUTERON": "the nucleus of heavy hydrogen, also DEUTON [n -S]\n",
  "DEUTERONS": "DEUTERON, the nucleus of heavy hydrogen, also DEUTON [n]\n",
  "DEUTEROPLASM": "the food material, such as yolk or fat, within an egg or cell [n -S]\n",
  "DEUTEROPLASMS": "DEUTEROPLASM, the food material, such as yolk or fat, within an egg or cell [n]\n",
  "DEUTEROSCOPIC": "relating to deuteroscopy, second view or meaning; second sight [adj]\n",
  "DEUTEROSCOPIES": "DEUTEROSCOPY, second view or meaning; second sight [n]\n",
  "DEUTEROSCOPY": "second view or meaning; second sight [n DEUTEROSCOPIES]\n",
  "DEUTEROSTOME": "any of a major division of the animal kingdom that includes the bilaterally symmetrical animals [n -S]\n",
  "DEUTEROSTOMES": "DEUTEROSTOME, any of a major division of the animal kingdom that includes the bilaterally symmetrical animals [n]\n",
  "DEUTEROTOKIES": "DEUTEROTOKY, parthenogenesis in which both males and females are produced [n]\n",
  "DEUTEROTOKY": "parthenogenesis in which both males and females are produced [n DEUTEROTOKIES]\n",
  "DEUTON": "the nucleus of heavy hydrogen, also DEUTERON [n -S]\n",
  "DEUTONS": "DEUTON, the nucleus of heavy hydrogen, also DEUTERON [n]\n",
  "DEUTOPLASM": "the food material, such as yolk or fat, within an egg or cell [n -S]\n",
  "DEUTOPLASMIC": "of or like deutoplasm, the food material, such as yolk or fat, within an egg or cell [adj]\n",
  "DEUTOPLASMS": "DEUTOPLASM, the food material, such as yolk or fat, within an egg or cell [n]\n",
  "DEUTOPLASTIC": "of or like deutoplasm, the food material, such as yolk or fat, within an egg or cell [adj]\n",
  "DEUTZIA": "a genus of saxifragaceous plants with panicles of white flowers [n -S]\n",
  "DEUTZIAS": "DEUTZIA, a genus of saxifragaceous plants with panicles of white flowers [n]\n",
  "DEV": "(Sanskrit) a Hindu god, also DEVA [n -S]\n",
  "DEVA": "(Sanskrit) a Hindu god, also DEV [n -S]\n",
  "DEVALL": "to sink, decline [v -ED, -ING, -S]\n",
  "DEVALLED": "DEVALL, to sink, decline [v]\n",
  "DEVALLING": "DEVALL, to sink, decline [v]\n",
  "DEVALLS": "DEVALL, to sink, decline [v]\n",
  "DEVALORISATION": "the process of devalorising, also DEVALORIZATION [n -S]\n",
  "DEVALORISATIONS": "DEVALORISATION, the process of devalorising, also DEVALORIZATION [n]\n",
  "DEVALORISE": "to devalue, also DEVALORIZE [v DEVALORISED, DEVALORISING, DEVALORISES]\n",
  "DEVALORISED": "DEVALORISE, to devalue, also DEVALORIZE [v]\n",
  "DEVALORISES": "DEVALORISE, to devalue, also DEVALORIZE [v]\n",
  "DEVALORISING": "DEVALORISE, to devalue, also DEVALORIZE [v]\n",
  "DEVALORIZATION": "the process of devalorizing, also DEVALORISATION [n -S]\n",
  "DEVALORIZATIONS": "DEVALORIZATION, the process of devalorizing, also DEVALORISATION [n]\n",
  "DEVALORIZE": "to devalue, also DEVALORISE [v DEVALORIZED, DEVALORIZING, DEVALORIZES]\n",
  "DEVALORIZED": "DEVALORIZE, to devalue, also DEVALORISE [v]\n",
  "DEVALORIZES": "DEVALORIZE, to devalue, also DEVALORISE [v]\n",
  "DEVALORIZING": "DEVALORIZE, to devalue, also DEVALORISE [v]\n",
  "DEVALUATE": "to devalue, to reduce the value of a country's currency by lowering the exchange rate [v DEVALUATED, DEVALUATING, DEVALUATES]\n",
  "DEVALUATED": "DEVALUATE, to devalue, to reduce the value of a country's currency by lowering the exchange rate [v]\n",
  "DEVALUATES": "DEVALUATE, to devalue, to reduce the value of a country's currency by lowering the exchange rate [v]\n",
  "DEVALUATING": "DEVALUATE, to devalue, to reduce the value of a country's currency by lowering the exchange rate [v]\n",
  "DEVALUATION": "an official reduction in the exchange value of a currency by a lowering of its gold equivalency or its value relative to another currency [n -S]\n",
  "DEVALUATIONS": "DEVALUATION, an official reduction in the exchange value of a currency by a lowering of its gold equivalency or its value relative to another currency [n]\n",
  "DEVALUE": "to lessen the worth of [v DEVALUED, DEVALUING, DEVALUES]\n",
  "DEVALUED": "DEVALUE, to lessen the worth of [v]\n",
  "DEVALUES": "DEVALUE, to lessen the worth of [v]\n",
  "DEVALUING": "DEVALUE, to lessen the worth of [v]\n",
  "DEVANAGARI": "(Sanskrit) the character in which Sanskrit is usually printed, also NAGARI [n -S]\n",
  "DEVANAGARIS": "DEVANAGARI, (Sanskrit) the character in which Sanskrit is usually printed, also NAGARI [n]\n",
  "DEVAS": "DEVA, (Sanskrit) a Hindu god, also DEV [n]\n",
  "DEVASTATE": "to lay waste [v DEVASTATED, DEVASTATING, DEVASTATES]\n",
  "DEVASTATED": "DEVASTATE, to lay waste [v]\n",
  "DEVASTATES": "DEVASTATE, to lay waste [v]\n",
  "DEVASTATING": "overpoweringly effective [adj DEVASTATINGLY]\n",
  "DEVASTATINGLY": "DEVASTATING, overpoweringly effective [adv]\n",
  "DEVASTATION": "ruin, destruction [n -S]\n",
  "DEVASTATIONS": "DEVASTATION, ruin, destruction [n]\n",
  "DEVASTATIVE": "serving to devastate [adj]\n",
  "DEVASTATOR": "one who, or that which, devastates [n -S]\n",
  "DEVASTATORS": "DEVASTATOR, one who, or that which, devastates [n]\n",
  "DEVASTAVIT": "waste or misapplication of the assets of a deceased person by an executor or an administrator [n -S]\n",
  "DEVASTAVITS": "DEVASTAVIT, waste or misapplication of the assets of a deceased person by an executor or an administrator [n]\n",
  "DEVEIN": "to remove the dorsal vein of [v -ED, -ING, -S]\n",
  "DEVEINED": "DEVEIN, to remove the dorsal vein of [v]\n",
  "DEVEINING": "DEVEIN, to remove the dorsal vein of [v]\n",
  "DEVEINS": "DEVEIN, to remove the dorsal vein of [v]\n",
  "DEVEL": "(Scots) to hit hard with a club [v DEVELLED or DEVELED, DEVELLING or DEVELING, DEVELS]\n",
  "DEVELED": "DEVEL, (Scots) to hit hard with a club [v]\n",
  "DEVELING": "DEVEL, (Scots) to hit hard with a club [v]\n",
  "DEVELLED": "DEVEL, (Scots) to hit hard with a club [v]\n",
  "DEVELLING": "DEVEL, (Scots) to hit hard with a club [v]\n",
  "DEVELOP": "to bring to a more advanced state, also DEVELOPE [v -ED, -ING, -S]\n",
  "DEVELOPABLE": "that can be developed [adj]\n",
  "DEVELOPE": "to bring to a more advanced state, also DEVELOP [v DEVELOPED, DEVELOPING, DEVELOPES]\n",
  "DEVELOPED": "DEVELOP, to bring to a more advanced state, also DEVELOPE [v]\n",
  "DEVELOPER": "one who develops [n -S]\n",
  "DEVELOPERS": "DEVELOPER, one who develops [n]\n",
  "DEVELOPES": "DEVELOPE, to bring to a more advanced state, also DEVELOP [v]\n",
  "DEVELOPING": "DEVELOP, to bring to a more advanced state, also DEVELOPE [v]\n",
  "DEVELOPMENT": "the act of developing [n -S]\n",
  "DEVELOPMENTAL": "relating to development [adj DEVELOPMENTALLY]\n",
  "DEVELOPMENTALLY": "DEVELOPMENTAL, relating to development [adv]\n",
  "DEVELOPMENTS": "DEVELOPMENT, the act of developing [n]\n",
  "DEVELOPPE": "(French) a ballet position [n -S]\n",
  "DEVELOPPES": "DEVELOPPE, (French) a ballet position [n]\n",
  "DEVELOPS": "DEVELOP, to bring to a more advanced state, also DEVELOPE [v]\n",
  "DEVELS": "DEVEL, (Scots) to hit hard with a club [v]\n",
  "DEVERBAL": "a word derived from a verb [n -S]\n",
  "DEVERBALS": "DEVERBAL, a word derived from a verb [n]\n",
  "DEVERBATIVE": "a noun derived from a verb e.g. worker [n -S]\n",
  "DEVERBATIVES": "DEVERBATIVE, a noun derived from a verb e.g. worker [n]\n",
  "DEVEST": "to strip or deprive of [v -ED, -ING, -S]\n",
  "DEVESTED": "DEVEST, to strip or deprive of [v]\n",
  "DEVESTING": "DEVEST, to strip or deprive of [v]\n",
  "DEVESTS": "DEVEST, to strip or deprive of [v]\n",
  "DEVI": "(Sanskrit) a Hindu goddess [n -S]\n",
  "DEVIANCE": "the behaviour of a deviant, also DEVIANCY [n -S]\n",
  "DEVIANCES": "DEVIANCE, the behaviour of a deviant, also DEVIANCY [n]\n",
  "DEVIANCIES": "DEVIANCY, the behaviour of a deviant, also DEVIANCE [n]\n",
  "DEVIANCY": "the behaviour of a deviant, also DEVIANCE [n DEVIANCIES]\n",
  "DEVIANT": "one who deviates from the norm [n -S]\n",
  "DEVIANTS": "DEVIANT, one who deviates from the norm [n]\n",
  "DEVIATE": "to differ from normal ways [v DEVIATED, DEVIATING, DEVIATES]\n",
  "DEVIATED": "DEVIATE, to differ from normal ways [v]\n",
  "DEVIATES": "DEVIATE, to differ from normal ways [v]\n",
  "DEVIATING": "DEVIATE, to differ from normal ways [v]\n",
  "DEVIATION": "the act of deviating [n -S]\n",
  "DEVIATIONISM": "the deviation of a doctrine from the strictly orthodox [n -S]\n",
  "DEVIATIONISMS": "DEVIATIONISM, the deviation of a doctrine from the strictly orthodox [n]\n",
  "DEVIATIONIST": "one who deviates from a strictly orthodox doctrine [n -S]\n",
  "DEVIATIONISTS": "DEVIATIONIST, one who deviates from a strictly orthodox doctrine [n]\n",
  "DEVIATIONS": "DEVIATION, the act of deviating [n]\n",
  "DEVIATIVE": "tending to deviate [adj]\n",
  "DEVIATOR": "one who deviates [n -S]\n",
  "DEVIATORS": "DEVIATOR, one who deviates [n]\n",
  "DEVIATORY": "tending to deviate [adj]\n",
  "DEVICE": "something constructed for a specific purpose [n -S]\n",
  "DEVICEFUL": "(Spenser) full of devices, inventive [adj]\n",
  "DEVICES": "DEVICE, something constructed for a specific purpose [n]\n",
  "DEVIL": "to prepare food with pungent seasoning [v DEVILED or DEVILLED, DEVILING or DEVILLING, DEVILS]\n",
  "DEVILDOM": "the domain of a devil [n -S]\n",
  "DEVILDOMS": "DEVILDOM, the domain of a devil [n]\n",
  "DEVILED": "DEVIL, to prepare food with pungent seasoning [v]\n",
  "DEVILESS": "a female devil [n -ES]\n",
  "DEVILESSES": "DEVILESS, a female devil [n]\n",
  "DEVILET": "a young devil, also DEVILING, DEVLING, DEVILKIN [n -S]\n",
  "DEVILETS": "DEVILET, a young devil, also DEVILING, DEVLING, DEVILKIN [n]\n",
  "DEVILFISH": "an octopus; also, a huge ray of the Gulf of Mexico and Southern Atlantic coasts [n -ES]\n",
  "DEVILFISHES": "DEVILFISH, an octopus; also, a huge ray of the Gulf of Mexico and Southern Atlantic coasts [n]\n",
  "DEVILING": "a young devil, also DEVILET, DEVLING, DEVILKIN [n -S]\n",
  "DEVILINGS": "DEVILING, a young devil, also DEVILET, DEVLING, DEVILKIN [n]\n",
  "DEVILISH": "fiendish [adj DEVILISHLY]\n",
  "DEVILISHLY": "DEVILISH, fiendish [adv]\n",
  "DEVILISHNESS": "the state of being devilish [n -ES]\n",
  "DEVILISHNESSES": "DEVILISHNESS, the state of being devilish [n]\n",
  "DEVILISM": "the cult of a devil [n -S]\n",
  "DEVILISMS": "DEVILISM, the cult of a devil [n]\n",
  "DEVILKIN": "a little devil, also DEVILET, DEVLING, DEVILING [n -S]\n",
  "DEVILKINS": "DEVILKIN, a little devil, also DEVILET, DEVLING, DEVILING [n]\n",
  "DEVILLED": "DEVIL, to prepare food with pungent seasoning [v]\n",
  "DEVILLING": "DEVIL, to prepare food with pungent seasoning [v]\n",
  "DEVILMENT": "deviltry [n -S]\n",
  "DEVILMENTS": "DEVILMENT, deviltry [n]\n",
  "DEVILRIES": "DEVILRY, mischief, also DEVILTRY [n]\n",
  "DEVILRY": "mischief, also DEVILTRY [n DEVILRIES]\n",
  "DEVILS": "DEVIL, to prepare food with pungent seasoning [v]\n",
  "DEVILSHIP": "the character or person of a devil or the Devil [n -S]\n",
  "DEVILSHIPS": "DEVILSHIP, the character or person of a devil or the Devil [n]\n",
  "DEVILTRIES": "DEVILTRY, mischief, also DEVILRY [n]\n",
  "DEVILTRY": "mischief, also DEVILRY [n DEVILTRIES]\n",
  "DEVILWOOD": "a kind of tree, allied to the European olive [n -S]\n",
  "DEVILWOODS": "DEVILWOOD, a kind of tree, allied to the European olive [n]\n",
  "DEVIOUS": "indirect [adj]\n",
  "DEVIOUSLY": "DEVIOUS, indirect [adv]\n",
  "DEVIOUSNESS": "the state of being devious [n -ES]\n",
  "DEVIOUSNESSES": "DEVIOUSNESS, the state of being devious [n]\n",
  "DEVIS": "DEVI, (Sanskrit) a Hindu goddess [n]\n",
  "DEVISABLE": "capable of being devised [adj]\n",
  "DEVISAL": "the act of devising [n -S]\n",
  "DEVISALS": "DEVISAL, the act of devising [n]\n",
  "DEVISE": "to form in the mind [v DEVISED, DEVISING, DEVISES]\n",
  "DEVISED": "DEVISE, to form in the mind [v]\n",
  "DEVISEE": "one to whom property is bequeathed in a will [n -S]\n",
  "DEVISEES": "DEVISEE, one to whom property is bequeathed in a will [n]\n",
  "DEVISER": "one who devises [n -S]\n",
  "DEVISERS": "DEVISER, one who devises [n]\n",
  "DEVISES": "DEVISE, to form in the mind [v]\n",
  "DEVISING": "DEVISE, to form in the mind [v]\n",
  "DEVISOR": "a person who bequeaths [n -S]\n",
  "DEVISORS": "DEVISOR, a person who bequeaths [n]\n",
  "DEVITALISATION": "the process of devitalising, also DEVITALIZATION [n -S]\n",
  "DEVITALISATIONS": "DEVITALISATION, the process of devitalising, also DEVITALIZATION [n]\n",
  "DEVITALISE": "to deprive of vitality, also DEVITALIZE [v DEVITALISED, DEVITALISING, DEVITALISES]\n",
  "DEVITALISED": "DEVITALISE, to deprive of vitality, also DEVITALIZE [v]\n",
  "DEVITALISES": "DEVITALISE, to deprive of vitality, also DEVITALIZE [v]\n",
  "DEVITALISING": "DEVITALISE, to deprive of vitality, also DEVITALIZE [v]\n",
  "DEVITALIZATION": "the process of devitalizing, also DEVITALISATION [n -S]\n",
  "DEVITALIZATIONS": "DEVITALIZATION, the process of devitalizing, also DEVITALISATION [n]\n",
  "DEVITALIZE": "to deprive of life or vitality, also DEVITALISE [v DEVITALIZED, DEVITALIZING, DEVITALIZES]\n",
  "DEVITALIZED": "DEVITALIZE, to deprive of life or vitality, also DEVITALISE [v]\n",
  "DEVITALIZES": "DEVITALIZE, to deprive of life or vitality, also DEVITALISE [v]\n",
  "DEVITALIZING": "DEVITALIZE, to deprive of life or vitality, also DEVITALISE [v]\n",
  "DEVITRIFICATION": "the act of devitrifying [n]\n",
  "DEVITRIFIED": "DEVITRIFY, to deprive of glasslike character, make brittle [v]\n",
  "DEVITRIFIES": "DEVITRIFY, to deprive of glasslike character, make brittle [v]\n",
  "DEVITRIFY": "to deprive of glasslike character, make brittle [v DEVITRIFIED, DEVITRIFYING, DEVITRIFIES]\n",
  "DEVITRIFYING": "DEVITRIFY, to deprive of glasslike character, make brittle [v]\n",
  "DEVLING": "a little devil, also DEVILET, DEVILKIN, DEVILING [n -S]\n",
  "DEVLINGS": "DEVLING, a little devil, also DEVILET, DEVILKIN, DEVILING [n]\n",
  "DEVO": "(short for) devolution, as in devo max, an arrangement in which a central government transfers the maximum amount of authority to a regional government while still retaining sovereignty over it [n -S]\n",
  "DEVOCALISE": "to make voiceless, also DEVOCALIZE [v DEVOCALISED, DEVOCALISING, DEVOCALISES]\n",
  "DEVOCALISED": "DEVOCALISE, to make voiceless, also DEVOCALIZE [v]\n",
  "DEVOCALISES": "DEVOCALISE, to make voiceless, also DEVOCALIZE [v]\n",
  "DEVOCALISING": "DEVOCALISE, to make voiceless, also DEVOCALIZE [v]\n",
  "DEVOCALIZE": "to make toneless; to deprive of vowel quality, also DEVOCALISE [v DEVOCALIZED, DEVOCALIZING, DEVOCALIZES]\n",
  "DEVOCALIZED": "DEVOCALIZE, to make toneless; to deprive of vowel quality, also DEVOCALISE [v]\n",
  "DEVOCALIZES": "DEVOCALIZE, to make toneless; to deprive of vowel quality, also DEVOCALISE [v]\n",
  "DEVOCALIZING": "DEVOCALIZE, to make toneless; to deprive of vowel quality, also DEVOCALISE [v]\n",
  "DEVOICE": "to make voiceless [v DEVOICED, DEVOICING, DEVOICES]\n",
  "DEVOICED": "DEVOICE, to make voiceless [v]\n",
  "DEVOICES": "DEVOICE, to make voiceless [v]\n",
  "DEVOICING": "the act of not using the vocal cords in utterance [n -S]\n",
  "DEVOICINGS": "DEVOICING, the act of not using the vocal cords in utterance [n]\n",
  "DEVOID": "completely lacking [adj]\n",
  "DEVOIR": "(French) duty, responsibility; a usually formal act of civility or respect [n -S]\n",
  "DEVOIRS": "DEVOIR, (French) duty, responsibility; a usually formal act of civility or respect [n]\n",
  "DEVOLUTION": "transference (as of rights, powers, property, or responsibility) to another [n -S]\n",
  "DEVOLUTIONARY": "relating to devolution [adj]\n",
  "DEVOLUTIONIST": "a believer in a policy of devolution [n -S]\n",
  "DEVOLUTIONISTS": "DEVOLUTIONIST, a believer in a policy of devolution [n]\n",
  "DEVOLUTIONS": "DEVOLUTION, transference (as of rights, powers, property, or responsibility) to another [n]\n",
  "DEVOLVE": "to transfer from one person to another [v DEVOLVED, DEVOLVING, DEVOLVES]\n",
  "DEVOLVED": "DEVOLVE, to transfer from one person to another [v]\n",
  "DEVOLVEMENT": "the act of devolving [n -S]\n",
  "DEVOLVEMENTS": "DEVOLVEMENT, the act of devolving [n]\n",
  "DEVOLVES": "DEVOLVE, to transfer from one person to another [v]\n",
  "DEVOLVING": "DEVOLVE, to transfer from one person to another [v]\n",
  "DEVON": "one of a breed of hardy cattle originating in the county of Devon, England [n -S]\n",
  "DEVONIAN": "relating to a type of rock formed in the fourth period of the Palaeozoic era [adj]\n",
  "DEVONPORT": "a small ornamental writing desk; a large sofa, also DAVENPORT [n -S]\n",
  "DEVONPORTS": "DEVONPORT, a small ornamental writing desk; a large sofa, also DAVENPORT [n]\n",
  "DEVONS": "DEVON, one of a breed of hardy cattle originating in the county of Devon, England [n]\n",
  "DEVORE": "(French) (of velvet or satin), having a design etched with acid [adj] / something etched with devore [n -S]\n",
  "DEVORES": "DEVORE, something etched with devore [n]\n",
  "DEVOS": "DEVO, (short for) devolution, as in devo max, an arrangement in which a central government transfers the maximum amount of authority to a regional government while still retaining sovereignty over it [n]\n",
  "DEVOT": "(French) a devotee [n -S]\n",
  "DEVOTE": "to give oneself wholly to [v DEVOTED, DEVOTING, DEVOTES]\n",
  "DEVOTED": "DEVOTE, to give oneself wholly to [v]\n",
  "DEVOTEDLY": "DEVOTED, DEVOTE, to give oneself wholly to [adv]\n",
  "DEVOTEDNESS": "the state of being devoted [n -ES]\n",
  "DEVOTEDNESSES": "DEVOTEDNESS, the state of being devoted [n]\n",
  "DEVOTEE": "an ardent follower [n -S]\n",
  "DEVOTEES": "DEVOTEE, an ardent follower [n]\n",
  "DEVOTEMENT": "(archaic) the state of being devoted, or set apart by a vow [n -S]\n",
  "DEVOTEMENTS": "DEVOTEMENT, (archaic) the state of being devoted, or set apart by a vow [n]\n",
  "DEVOTES": "DEVOTE, to give oneself wholly to [v]\n",
  "DEVOTING": "DEVOTE, to give oneself wholly to [v]\n",
  "DEVOTION": "the act of devoting [n -S]\n",
  "DEVOTIONAL": "relating to devotion [adj DEVOTIONALLY] / a short worship service [n -S]\n",
  "DEVOTIONALIST": "one who practises devotion [n -S]\n",
  "DEVOTIONALISTS": "DEVOTIONALIST, one who practises devotion [n]\n",
  "DEVOTIONALITIES": "DEVOTIONALITY, the state of being devotional [n]\n",
  "DEVOTIONALITY": "the state of being devotional [n DEVOTIONALITIES]\n",
  "DEVOTIONALLY": "DEVOTIONAL, relating to devotion [adv]\n",
  "DEVOTIONALNESS": "DEVOTIONAL, relating to devotion [n]\n",
  "DEVOTIONALS": "DEVOTIONAL, a short worship service [n]\n",
  "DEVOTIONIST": "one who practises devotion [n -S]\n",
  "DEVOTIONISTS": "DEVOTIONIST, one who practises devotion [n]\n",
  "DEVOTIONS": "DEVOTION, the act of devoting [n]\n",
  "DEVOTS": "DEVOT, (French) a devotee [n]\n",
  "DEVOUR": "to eat voraciously [v -ED, -ING, -S]\n",
  "DEVOURED": "DEVOUR, to eat voraciously [v]\n",
  "DEVOURER": "one who devours [n -S]\n",
  "DEVOURERS": "DEVOURER, one who devours [n]\n",
  "DEVOURING": "DEVOUR, to eat voraciously [v]\n",
  "DEVOURINGLY": "DEVOURING, DEVOUR, to eat voraciously [adv]\n",
  "DEVOURMENT": "the act of devouring [n -S]\n",
  "DEVOURMENTS": "DEVOURMENT, the act of devouring [n]\n",
  "DEVOURS": "DEVOUR, to eat voraciously [v]\n",
  "DEVOUT": "pious [adj DEVOUTER, DEVOUTEST, DEVOUTLY]\n",
  "DEVOUTER": "DEVOUT, pious [adj]\n",
  "DEVOUTEST": "DEVOUT, pious [adj]\n",
  "DEVOUTLY": "DEVOUT, pious [adj]\n",
  "DEVOUTNESS": "the state of being devout [n -ES]\n",
  "DEVOUTNESSES": "DEVOUTNESS, the state of being devout [n]\n",
  "DEVS": "DEV, (Sanskrit) a Hindu god, also DEVA [n]\n",
  "DEVVEL": "(Scots) to stun with a club, also DEVEL [v DEVVELLED, DEVVELLING, DEVVELS]\n",
  "DEVVELLED": "DEVVEL, (Scots) to stun with a club, also DEVEL [v]\n",
  "DEVVELLING": "DEVVEL, (Scots) to stun with a club, also DEVEL [v]\n",
  "DEVVELS": "DEVVEL, (Scots) to stun with a club, also DEVEL [v]\n",
  "DEW": "to wet with condensed moisture, also DEAW [v -ED, -ING, -S]\n",
  "DEWAN": "(Urdu) in India, a financial minister, also DEEWAN, DIWAN [n -S]\n",
  "DEWANI": "(Urdu) the office of dewan, also DEWANNY [n -S]\n",
  "DEWANIS": "DEWANI, (Urdu) the office of dewan, also DEWANNY [n]\n",
  "DEWANNIES": "DEWANNY, (Urdu) the office of dewan, also DEWANI [n]\n",
  "DEWANNY": "(Urdu) the office of dewan, also DEWANI [n DEWANNIES]\n",
  "DEWANS": "DEWAN, (Urdu) in India, a financial minister, also DEEWAN, DIWAN [n]\n",
  "DEWAR": "a double-walled flask [n -S]\n",
  "DEWARS": "DEWAR, a double-walled flask [n]\n",
  "DEWATER": "to remove water from [v -ED, -ING, -S]\n",
  "DEWATERED": "DEWATER, to remove water from [v]\n",
  "DEWATERER": "an agent for dewatering [n -S]\n",
  "DEWATERERS": "DEWATERER, an agent for dewatering [n]\n",
  "DEWATERING": "the act of removing water from [n -S]\n",
  "DEWATERINGS": "DEWATERING, the act of removing water from [n]\n",
  "DEWATERS": "DEWATER, to remove water from [v]\n",
  "DEWAX": "to remove wax from [v -ED, -ING, -ES]\n",
  "DEWAXED": "DEWAX, to remove wax from [v]\n",
  "DEWAXES": "DEWAX, to remove wax from [v]\n",
  "DEWAXING": "DEWAX, to remove wax from [v]\n",
  "DEWBERRIES": "DEWBERRY, a fruit like a blackberry, with a bluish, dew-like bloom [n]\n",
  "DEWBERRY": "a fruit like a blackberry, with a bluish, dew-like bloom [n DEWBERRIES]\n",
  "DEWCLAW": "a vestigial digit or claw [n -S]\n",
  "DEWCLAWED": "having a vestigial toe [adj]\n",
  "DEWCLAWS": "DEWCLAW, a vestigial digit or claw [n]\n",
  "DEWDROP": "a drop of dew [n -S]\n",
  "DEWDROPS": "DEWDROP, a drop of dew [n]\n",
  "DEWED": "DEW, to wet with condensed moisture, also DEAW [v]\n",
  "DEWFALL": "the formation of dew [n -S]\n",
  "DEWFALLS": "DEWFALL, the formation of dew [n]\n",
  "DEWFULL": "(Spenser) proper, fit, also DUEFUL [adj]\n",
  "DEWIER": "DEWY, covered with dew, also DEAWIE, DEAWY [adj]\n",
  "DEWIEST": "DEWY, covered with dew, also DEAWIE, DEAWY [adj]\n",
  "DEWILY": "DEWY, covered with dew, also DEAWIE, DEAWY [adv]\n",
  "DEWINESS": "the state of being dewy [n -ES]\n",
  "DEWINESSES": "DEWINESS, the state of being dewy [n]\n",
  "DEWING": "DEW, to wet with condensed moisture, also DEAW [v]\n",
  "DEWITT": "(Dutch) to lynch [v -ED, -ING, -S]\n",
  "DEWITTED": "DEWITT, (Dutch) to lynch [v]\n",
  "DEWITTING": "DEWITT, (Dutch) to lynch [v]\n",
  "DEWITTS": "DEWITT, (Dutch) to lynch [v]\n",
  "DEWLAP": "a fold of loose skin under the neck [n -S]\n",
  "DEWLAPPED": "having dewlaps, also DEWLAPT [adj]\n",
  "DEWLAPS": "DEWLAP, a fold of loose skin under the neck [n]\n",
  "DEWLAPT": "having dewlaps, also DEWLAPPED [adj]\n",
  "DEWLESS": "without dew [adj]\n",
  "DEWOOL": "to remove the wool from [v -ED, -ING, -S]\n",
  "DEWOOLED": "DEWOOL, to remove the wool from [v]\n",
  "DEWOOLING": "DEWOOL, to remove the wool from [v]\n",
  "DEWOOLS": "DEWOOL, to remove the wool from [v]\n",
  "DEWORM": "to rid of worms [v -ED, -ING, -S]\n",
  "DEWORMED": "DEWORM, to rid of worms [v]\n",
  "DEWORMER": "an agent for removing worms [n -S]\n",
  "DEWORMERS": "DEWORMER, an agent for removing worms [n]\n",
  "DEWORMING": "DEWORM, to rid of worms [v]\n",
  "DEWORMS": "DEWORM, to rid of worms [v]\n",
  "DEWPOINT": "the temperature at which dew forms [n -S]\n",
  "DEWPOINTS": "DEWPOINT, the temperature at which dew forms [n]\n",
  "DEWS": "DEW, to wet with condensed moisture, also DEAW [v]\n",
  "DEWY": "covered with dew, also DEAWIE, DEAWY [adj DEWIER, DEWIEST]\n",
  "DEX": "a pill containing Dexedrine, a sulfate used as a stimulant, also DEXIE, DEXY [n -ES]\n",
  "DEXAMETHASONE": "a synthetic glucocorticoid used esp. as an anti-inflammatory agent [n -S]\n",
  "DEXAMETHASONES": "DEXAMETHASONE, a synthetic glucocorticoid used esp. as an anti-inflammatory agent [n]\n",
  "DEXAMPHETAMINE": "the dextrorotatory isomer of amphetamine, used as a stimulant [n -S]\n",
  "DEXAMPHETAMINES": "DEXAMPHETAMINE, the dextrorotatory isomer of amphetamine, used as a stimulant [n]\n",
  "DEXES": "DEX, a pill containing Dexedrine, a sulfate used as a stimulant, also DEXIE, DEXY [n]\n",
  "DEXIE": "a tablet of dex, also DEXY [n DEXIES]\n",
  "DEXIES": "DEXY, a pill containing Dexedrine, a sulfate used as a stimulant, also DEX, DEXIE [n]\n",
  "DEXIOTROPIC": "coiled in a rightward direction, as of a right-spiralling snail shell [adj]\n",
  "DEXTER": "(Latin) a small breed of Kerry cattle [n -S]\n",
  "DEXTERITIES": "DEXTERITY, adroitness [n]\n",
  "DEXTERITY": "adroitness [n DEXTERITIES]\n",
  "DEXTEROUS": "skilful and active with the hands, also DEXTROUS [adj DEXTEROUSLY]\n",
  "DEXTEROUSLY": "DEXTEROUS, skilful and active with the hands, also DEXTROUS [adv]\n",
  "DEXTEROUSNESS": "the state of being dexterous [n -ES]\n",
  "DEXTEROUSNESSES": "DEXTEROUSNESS, the state of being dexterous [n]\n",
  "DEXTERS": "DEXTER, (Latin) a small breed of Kerry cattle [n]\n",
  "DEXTERWISE": "on the right-hand side e.g. of a shield [adv]\n",
  "DEXTRAL": "right, as opposed to sinistral, or left [adj DEXTRALLY] / a right-handed person [n -S]\n",
  "DEXTRALITIES": "DEXTRALITY, right-handedness [n]\n",
  "DEXTRALITY": "right-handedness [n DEXTRALITIES]\n",
  "DEXTRALLY": "DEXTRAL, right, as opposed to sinistral, or left [adv]\n",
  "DEXTRALS": "DEXTRAL, a right-handed person [n]\n",
  "DEXTRAN": "a substitute for blood plasma [n -S]\n",
  "DEXTRANASE": "a hydrolase that prevents tooth decay [n -S]\n",
  "DEXTRANASES": "DEXTRANASE, a hydrolase that prevents tooth decay [n]\n",
  "DEXTRANS": "DEXTRAN, a substitute for blood plasma [n]\n",
  "DEXTRIN": "a substance used as an adhesive, also DEXTRINE [n -S]\n",
  "DEXTRINE": "a substance used as an adhesive, also DEXTRIN [n -S]\n",
  "DEXTRINES": "DEXTRINE, a substance used as an adhesive, also DEXTRIN [n]\n",
  "DEXTRINS": "DEXTRIN, a substance used as an adhesive, also DEXTRINE [n]\n",
  "DEXTRO": "in compounds, towards the right [adj]\n",
  "DEXTROCARDIA": "a condition in which the heart is on the right-hand side of the chest [n -S]\n",
  "DEXTROCARDIAC": "a person who has dextrocardia, a condition in which the heart is on the right-hand side of the chest [n -S]\n",
  "DEXTROCARDIACS": "DEXTROCARDIAC, a person who has dextrocardia, a condition in which the heart is on the right-hand side of the chest [n]\n",
  "DEXTROCARDIAS": "DEXTROCARDIA, a condition in which the heart is on the right-hand side of the chest [n]\n",
  "DEXTROGLUCOSE": "a white soluble sweet-tasting crystalline solid that is the dextrorotatory isomer of glucose, aka dextrose [n -S]\n",
  "DEXTROGLUCOSES": "DEXTROGLUCOSE, a white soluble sweet-tasting crystalline solid that is the dextrorotatory isomer of glucose, aka dextrose [n]\n",
  "DEXTROGYRATE": "causing to turn to the right hand, also DEXTROGYRE [adj]\n",
  "DEXTROGYRE": "causing to turn to the right hand, also DEXTROGYRATE [adj]\n",
  "DEXTROROTARY": "turning to the right, esp. turning plane of polarized light, also DEXTROROTATORY [adj]\n",
  "DEXTROROTATION": "rotation to the right [n -S]\n",
  "DEXTROROTATIONS": "DEXTROROTATION, rotation to the right [n]\n",
  "DEXTROROTATORY": "turning to the right, esp. turning plane of polarized light, also DEXTROROTARY [adj]\n",
  "DEXTRORSAL": "rising spirally and turning to the left, also DEXTRORSE [adj]\n",
  "DEXTRORSE": "rising spirally and turning to the left, also DEXTRORSAL [adj DEXTRORSELY]\n",
  "DEXTRORSELY": "DEXTRORSE, rising spirally and turning to the left, also DEXTRORSAL [adv]\n",
  "DEXTROSE": "a form of glucose [n -S]\n",
  "DEXTROSES": "DEXTROSE, a form of glucose [n]\n",
  "DEXTROUS": "skillful and active with the hands, also DEXTEROUS [adj DEXTROUSLY]\n",
  "DEXTROUSLY": "DEXTROUS, skillful and active with the hands, also DEXTEROUS [adv]\n",
  "DEXTROUSNESS": "the state of being dextrous [n -ES]\n",
  "DEXTROUSNESSES": "DEXTROUSNESS, the state of being dextrous [n]\n",
  "DEXY": "a pill containing Dexedrine, a sulfate used as a stimulant, also DEX, DEXIE [n DEXIES]\n",
  "DEY": "formerly, the pasha of Algiers [n -S]\n",
  "DEYS": "DEY, formerly, the pasha of Algiers [n]\n",
  "DEZINC": "to remove zinc from [v DEZINCKED or DEZINCED, DEZINCKING or DEZINCING, DEZINCS]\n",
  "DEZINCED": "DEZINC, to remove zinc from [v]\n",
  "DEZINCING": "DEZINC, to remove zinc from [v]\n",
  "DEZINCKED": "DEZINC, to remove zinc from [v]\n",
  "DEZINCKING": "DEZINC, to remove zinc from [v]\n",
  "DEZINCS": "DEZINC, to remove zinc from [v]\n",
  "DHABA": "(Hindi) (in India) a roadside cafi or food stall [n -S]\n",
  "DHABAS": "DHABA, (Hindi) (in India) a roadside cafi or food stall [n]\n",
  "DHAK": "(Hindi) a leguminous tree of eastern India and Myanmar, with showy orange or red flowers [n -S]\n",
  "DHAKS": "DHAK, (Hindi) a leguminous tree of eastern India and Myanmar, with showy orange or red flowers [n]\n",
  "DHAL": "(Hindi) an Indian name for a lentil, also DAAL, DAHL, DAL, DHOLL [n -S]\n",
  "DHALS": "DHAL, (Hindi) an Indian name for a lentil, also DAAL, DAHL, DAL, DHOLL [n]\n",
  "DHAMMA": "(Sanskrit) custom or law regarded as duty; the basic principles of cosmic or individual existence, also DHARMA [n -S]\n",
  "DHAMMAS": "DHAMMA, (Sanskrit) custom or law regarded as duty; the basic principles of cosmic or individual existence, also DHARMA [n]\n",
  "DHANSAK": "(Urdu) any of a variety of Indian dishes consisting of meat or vegetables braised with water or stock and lentils, also DANSAK [n -S]\n",
  "DHANSAKS": "DHANSAK, (Urdu) any of a variety of Indian dishes consisting of meat or vegetables braised with water or stock and lentils, also DANSAK [n]\n",
  "DHARMA": "(Sanskrit) custom or law regarded as duty; the basic principles of cosmic or individual existence, also DHAMMA [n -S]\n",
  "DHARMAS": "DHARMA, (Sanskrit) custom or law regarded as duty; the basic principles of cosmic or individual existence, also DHAMMA [n]\n",
  "DHARMIC": "(Sanskrit) of or like dharma [adj]\n",
  "DHARMSALA": "(Hindi) a building having a religious or charitable purpose, a free or cheap lodging for travellers, also DHARMSHALA [n -S]\n",
  "DHARMSALAS": "DHARMSALA, (Hindi) a building having a religious or charitable purpose, a free or cheap lodging for travellers, also DHARMSHALA [n]\n",
  "DHARMSHALA": "(Hindi) a building having a religious or charitable purpose, a free or cheap lodging for travellers, also DHARMSALA [n -S]\n",
  "DHARMSHALAS": "DHARMSHALA, (Hindi) a building having a religious or charitable purpose, a free or cheap lodging for travellers, also DHARMSALA [n]\n",
  "DHARNA": "(Hindi) a method of collecting a debt in which the person who is owed money sits on the debtor's doorstep until payment is made, or the debtor starves to death, also DHURNA [n -S]\n",
  "DHARNAS": "DHARNA, (Hindi) a method of collecting a debt in which the person who is owed money sits on the debtor's doorstep until payment is made, or the debtor starves to death, also DHURNA [n]\n",
  "DHIKR": "(Arabic) a Sufi religious ceremony [n -S]\n",
  "DHIKRS": "DHIKR, (Arabic) a Sufi religious ceremony [n]\n",
  "DHIMMI": "a non-Muslim subject of a state governed in accordance with sharia law [n -S]\n",
  "DHIMMIS": "DHIMMI, a non-Muslim subject of a state governed in accordance with sharia law [n]\n",
  "DHOBI": "(Hindi) an Indian washerwoman [n -S]\n",
  "DHOBIS": "DHOBI, (Hindi) an Indian washerwoman [n]\n",
  "DHOL": "(Hindi) a large cylindrical drum, used in Indian music [n -S]\n",
  "DHOLAK": "(Hindi) a two-headed drum [n -S]\n",
  "DHOLAKS": "DHOLAK, (Hindi) a two-headed drum [n]\n",
  "DHOLE": "an Indian wild dog [n -S]\n",
  "DHOLES": "DHOLE, an Indian wild dog [n]\n",
  "DHOLL": "(Hindi) an Indian name for lentil, also DAAL, DAHL, DAL, DHAL [n -S]\n",
  "DHOLLS": "DHOLL, (Hindi) an Indian name for lentil, also DAAL, DAHL, DAL, DHAL [n]\n",
  "DHOLS": "DHOL, (Hindi) a large cylindrical drum, used in Indian music [n]\n",
  "DHOOLIES": "DHOOLY, (Hindi) a litter or palanquin, also DOOLEE, DOOLIE, DOOLY [n]\n",
  "DHOOLY": "(Hindi) a litter or palanquin, also DOOLEE, DOOLIE, DOOLY [n DHOOLIES]\n",
  "DHOORA": "(Arabic) Indian millet, also DARI, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURR, DURRA [n -S]\n",
  "DHOORAS": "DHOORA, (Arabic) Indian millet, also DARI, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURR, DURRA [n]\n",
  "DHOOTI": "(Hindi) a loincloth worn by Indian men, also DHOOTIE, DHOTI, DHUTI [n -S]\n",
  "DHOOTIE": "(Hindi) a loincloth worn by Indian men, also DHOOTI, DHOTI, DHUTI [n -S]\n",
  "DHOOTIES": "DHOOTIE, (Hindi) a loincloth worn by Indian men, also DHOOTI, DHOTI, DHUTI [n]\n",
  "DHOOTIS": "DHOOTI, (Hindi) a loincloth worn by Indian men, also DHOOTIE, DHOTI, DHUTI [n]\n",
  "DHOTI": "(Hindi) a loincloth worn by Indian men, also DHOOTI, DHOOTIE, DHUTI [n -S]\n",
  "DHOTIS": "DHOTI, (Hindi) a loincloth worn by Indian men, also DHOOTI, DHOOTIE, DHUTI [n]\n",
  "DHOURRA": "(Arabic) Indian millet, also DARI, DHOORA, DHURRA, DOURA, DOURAH, DURA, DURR, DURRA [n -S]\n",
  "DHOURRAS": "DHOURRA, (Arabic) Indian millet, also DARI, DHOORA, DHURRA, DOURA, DOURAH, DURA, DURR, DURRA [n]\n",
  "DHOW": "(Arabic) a lateenrigged oriental craft, also DOW [n -S]\n",
  "DHOWS": "DHOW, (Arabic) a lateenrigged oriental craft, also DOW [n]\n",
  "DHURNA": "(Hindi) a method of collecting a debt in which the person who is owed money sits on the debtor's doorstep until payment is made, or the debtor starves to death, also DHARNA [n -S]\n",
  "DHURNAS": "DHURNA, (Hindi) a method of collecting a debt in which the person who is owed money sits on the debtor's doorstep until payment is made, or the debtor starves to death, also DHARNA [n]\n",
  "DHURRA": "(Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DOURA, DOURAH, DURA, DURR, DURRA [n -S]\n",
  "DHURRAS": "DHURRA, (Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DOURA, DOURAH, DURA, DURR, DURRA [n]\n",
  "DHURRIE": "(Hindi) an Indian cotton rug, also DURRIE [n -S]\n",
  "DHURRIES": "DHURRIE, (Hindi) an Indian cotton rug, also DURRIE [n]\n",
  "DHUTI": "(Hindi) a loincloth worn by Indian men, also DHOOTI, DHOOTIE, DHOTI [n -S]\n",
  "DHUTIS": "DHUTI, (Hindi) a loincloth worn by Indian men, also DHOOTI, DHOOTIE, DHOTI [n]\n",
  "DHYANA": "(Sanskrit) a profound meditation in Hinduism [n -S]\n",
  "DHYANAS": "DHYANA, (Sanskrit) a profound meditation in Hinduism [n]\n",
  "DI": "DEUS, (Latin) god [n]\n",
  "DIABASE": "an igneous rock, an altered diorite or basalt [n -S]\n",
  "DIABASES": "DIABASE, an igneous rock, an altered diorite or basalt [n]\n",
  "DIABASIC": "of or like diabase, an altered diorite or basalt [adj]\n",
  "DIABETES": "(Greek) a metabolic disorder [n DIABETES]\n",
  "DIABETIC": "one who has diabetes [n -S]\n",
  "DIABETICAL": "pertaining to diabetes [adj]\n",
  "DIABETICS": "DIABETIC, one who has diabetes [n]\n",
  "DIABETOGENIC": "producing diabetes [adj]\n",
  "DIABETOLOGIST": "a doctor specializing in the study and treatment of diabetes and the care of diabetics [n -S]\n",
  "DIABETOLOGISTS": "DIABETOLOGIST, a doctor specializing in the study and treatment of diabetes and the care of diabetics [n]\n",
  "DIABLE": "(French) an unglazed earthenware casserole [n -S]\n",
  "DIABLERIE": "(French) black magic, sorcery, also DIABLERY [n -S]\n",
  "DIABLERIES": "DIABLERY, black magic; sorcery, also DIABLERIE [n]\n",
  "DIABLERY": "black magic; sorcery, also DIABLERIE [n DIABLERIES]\n",
  "DIABLES": "DIABLE, (French) an unglazed earthenware casserole [n]\n",
  "DIABOLIC": "devilish [adj DIABOLICALLY]\n",
  "DIABOLICAL": "of, relating to, or characteristic of the devil [adj DIABOLICALLY]\n",
  "DIABOLICALLY": "DIABOLICAL, of, relating to, or characteristic of the devil [adv]\n",
  "DIABOLICALNESS": "DIABOLICAL, of, relating to, or characteristic of the devil [n]\n",
  "DIABOLISE": "to convert into a devil, render diabolical, also DIABOLIZE [v DIABOLISED, DIABOLISING, DIABOLISES]\n",
  "DIABOLISED": "DIABOLISE, to convert into a devil, render diabolical, also DIABOLIZE [v]\n",
  "DIABOLISES": "DIABOLISE, to convert into a devil, render diabolical, also DIABOLIZE [v]\n",
  "DIABOLISING": "DIABOLISE, to convert into a devil, render diabolical, also DIABOLIZE [v]\n",
  "DIABOLISM": "devil-worship [n -S]\n",
  "DIABOLISMS": "DIABOLISM, devil-worship [n]\n",
  "DIABOLIST": "one who practises diabolism [n -S]\n",
  "DIABOLISTS": "DIABOLIST, one who practises diabolism [n]\n",
  "DIABOLIZE": "to convert into a devil, render diabolical, also DIABOLISE [v DIABOLIZED, DIABOLIZING, DIABOLIZES]\n",
  "DIABOLIZED": "DIABOLIZE, to convert into a devil, render diabolical, also DIABOLISE [v]\n",
  "DIABOLIZES": "DIABOLIZE, to convert into a devil, render diabolical, also DIABOLISE [v]\n",
  "DIABOLIZING": "DIABOLIZE, to convert into a devil, render diabolical, also DIABOLISE [v]\n",
  "DIABOLO": "(Italian) a game in which a two-headed top is thrown up and caught on a string stretched between two sticks [n -S]\n",
  "DIABOLOGIES": "DIABOLOGY, the study of devils, also DIABOLOLOGY [n]\n",
  "DIABOLOGY": "the study of devils, also DIABOLOLOGY [n DIABOLOGIES]\n",
  "DIABOLOLOGIES": "DIABOLOLOGY, the study of devils, also DIABOLOGY [n]\n",
  "DIABOLOLOGY": "the study of devils, also DIABOLOGY [n DIABOLOLOGIES]\n",
  "DIABOLOS": "DIABOLO, (Italian) a game in which a two-headed top is thrown up and caught on a string stretched between two sticks [n]\n",
  "DIACATHOLICON": "(obsolete) a purgative electuary, the drug being mixed with honey or syrup [n -S]\n",
  "DIACATHOLICONS": "DIACATHOLICON, (obsolete) a purgative electuary, the drug being mixed with honey or syrup [n]\n",
  "DIACAUSTIC": "a type of curve formed by refraction [n -S]\n",
  "DIACAUSTICS": "DIACAUSTIC, a type of curve formed by refraction [n]\n",
  "DIACETYL": "a chemical flavour enhancer [n -S]\n",
  "DIACETYLS": "DIACETYL, a chemical flavour enhancer [n]\n",
  "DIACHRONIC": "of the study of a subject (esp. a language) through its historical development, as opposed to synchronic [adj DIACHRONICALLY]\n",
  "DIACHRONICALLY": "DIACHRONIC, of the study of a subject (esp. a language) through its historical development, as opposed to synchronic [adv]\n",
  "DIACHRONIES": "DIACHRONY, the historical development of a language etc. [n]\n",
  "DIACHRONISM": "the study of a subject, esp. a language, through its historical development [n -S]\n",
  "DIACHRONISMS": "DIACHRONISM, the study of a subject, esp. a language, through its historical development [n]\n",
  "DIACHRONISTIC": "relating to diachronism, the study of a subject, esp. a language, through its historical development [adj]\n",
  "DIACHRONOUS": "relating to the study of a language through its development [adj]\n",
  "DIACHRONY": "the historical development of a language etc. [n DIACHRONIES]\n",
  "DIACHYLON": "formerly a plaster of plant juices; now lead-plaster, also DIACHYLUM [n -S]\n",
  "DIACHYLONS": "DIACHYLON, formerly a plaster of plant juices; now lead-plaster, also DIACHYLUM [n]\n",
  "DIACHYLUM": "formerly a plaster of plant juices; now lead-plaster, also DIACHYLON [n -S]\n",
  "DIACHYLUMS": "DIACHYLUM, formerly a plaster of plant juices; now lead-plaster, also DIACHYLON [n]\n",
  "DIACID": "a type of chemical compound having two replaceable hydrogen atoms [n -S]\n",
  "DIACIDIC": "of or like a diacid, divalent [adj]\n",
  "DIACIDS": "DIACID, a type of chemical compound having two replaceable hydrogen atoms [n]\n",
  "DIACODION": "(obsolete) a syrup of poppies, also DIACODIUM [n -S]\n",
  "DIACODIONS": "DIACODION, (obsolete) a syrup of poppies, also DIACODIUM [n]\n",
  "DIACODIUM": "(obsolete) a syrup of poppies, also DIACODION [n -S]\n",
  "DIACODIUMS": "DIACODIUM, (obsolete) a syrup of poppies, also DIACODION [n]\n",
  "DIACONAL": "pertaining to a deacon [adj]\n",
  "DIACONATE": "the office of a deacon [n -S]\n",
  "DIACONATES": "DIACONATE, the office of a deacon [n]\n",
  "DIACONICON": "a sacristy for sacred vessels in Orthodox churches [n -S]\n",
  "DIACONICONS": "DIACONICON, a sacristy for sacred vessels in Orthodox churches [n]\n",
  "DIACOUSTIC": "pertaining to the refraction of sound [adj]\n",
  "DIACOUSTICS": "the branch of physics that deals with refracted sound [n]\n",
  "DIACRITIC": "distinguishing [adj DIACRITICALLY] / a mark or sign serving to distinguish different values or sounds of the same letter e.g. an acute accent [n -S]\n",
  "DIACRITICAL": "distinctive; serving as a diacritic [adj DIACRITICALLY]\n",
  "DIACRITICALLY": "DIACRITICAL, distinctive; serving as a diacritic [adv]\n",
  "DIACRITICS": "DIACRITIC, a mark or sign serving to distinguish different values or sounds of the same letter e.g. an acute accent [n]\n",
  "DIACT": "a sponge spicule having two rays that develop in different directions from a single point of origin, also DIACTINE [n -S]\n",
  "DIACTINAL": "having two rays, also DIACT, DIACTINE [adj]\n",
  "DIACTINE": "a sponge spicule having two rays that develop in different directions from a single point of origin, also DIACT [n -S]\n",
  "DIACTINES": "DIACTINE, a sponge spicule having two rays that develop in different directions from a single point of origin, also DIACT [n]\n",
  "DIACTINIC": "capable of transmitting actinic rays [adj]\n",
  "DIACTINISM": "the ability to transmit photochemically active radiation [n -S]\n",
  "DIACTINISMS": "DIACTINISM, the ability to transmit photochemically active radiation [n]\n",
  "DIACTS": "DIACT, a sponge spicule having two rays that develop in different directions from a single point of origin, also DIACTINE [n]\n",
  "DIADELPHOUS": "having the filaments united to make two groups [adj]\n",
  "DIADEM": "to adorn with a crown [v -ED, -ING, -S]\n",
  "DIADEMED": "DIADEM, to adorn with a crown [v]\n",
  "DIADEMING": "DIADEM, to adorn with a crown [v]\n",
  "DIADEMS": "DIADEM, to adorn with a crown [v]\n",
  "DIADOCHI": "(Greek) the generals who became monarchs of the various kingdoms into which the empire was split after the death of Alexander the Great [n]\n",
  "DIADOCHIES": "DIADOCHY, the replacement of one element of a crystal by another [n]\n",
  "DIADOCHY": "the replacement of one element of a crystal by another [n DIADOCHIES]\n",
  "DIADROM": "(Greek) a course or passing; a vibration [n -S]\n",
  "DIADROMOUS": "migrating between fresh and salt water [adj]\n",
  "DIADROMS": "DIADROM, (Greek) a course or passing; a vibration [n]\n",
  "DIAERESES": "DIAERESIS, (Greek) the separation or resolution of one syllable into two, also DIERESIS [n]\n",
  "DIAERESIS": "(Greek) the separation or resolution of one syllable into two, also DIERESIS [n DIAERESES]\n",
  "DIAERETIC": "pertaining to diaeresis, the separation or resolution of one syllable into two, also DIERETIC [adj]\n",
  "DIAGENESES": "DIAGENESIS, the physical and chemical changes (other than metamorphism) undergone by a sediment after deposition [n]\n",
  "DIAGENESIS": "the physical and chemical changes (other than metamorphism) undergone by a sediment after deposition [n DIAGENESES]\n",
  "DIAGENETIC": "pertaining to changes, such as recrystallization and replacement, that take place in sediments after their deposition [adj DIAGENETICALLY]\n",
  "DIAGENETICALLY": "DIAGENETIC, pertaining to changes, such as recrystallization and replacement, that take place in sediments after their deposition [adv]\n",
  "DIAGEOTROPIC": "tending to grow at right angles to the line of gravity [adj]\n",
  "DIAGEOTROPISM": "the tendency of roots to orient perpendicular to gravity [n -S]\n",
  "DIAGEOTROPISMS": "DIAGEOTROPISM, the tendency of roots to orient perpendicular to gravity [n]\n",
  "DIAGLYPH": "a figure cut into any substance [n -S]\n",
  "DIAGLYPHS": "DIAGLYPH, a figure cut into any substance [n]\n",
  "DIAGNOSABILITY": "the quality of being diagnosable [n]\n",
  "DIAGNOSABLE": "capable of being diagnosed, also DIAGNOSEABLE [adj]\n",
  "DIAGNOSE": "to identify a disease by symptoms [v DIAGNOSED, DIAGNOSING, DIAGNOSES]\n",
  "DIAGNOSEABLE": "capable of being diagnosed, also DIAGNOSABLE [adj]\n",
  "DIAGNOSED": "DIAGNOSE, to identify a disease by symptoms [v]\n",
  "DIAGNOSES": "DIAGNOSE, to identify a disease by symptoms [v]\n",
  "DIAGNOSING": "DIAGNOSE, to identify a disease by symptoms [v]\n",
  "DIAGNOSIS": "the identification of a disease by means of its symptoms [n DIAGNOSES]\n",
  "DIAGNOSTIC": "relating to diagnosis [adj DIAGNOSTICALLY] / the art or practice of diagnosis [n -S]\n",
  "DIAGNOSTICAL": "relating to diagnosis [adj DIAGNOSTICALLY]\n",
  "DIAGNOSTICALLY": "DIAGNOSTICAL, relating to diagnosis [adv]\n",
  "DIAGNOSTICIAN": "one who specialises in diagnosis [n -S]\n",
  "DIAGNOSTICIANS": "DIAGNOSTICIAN, one who specialises in diagnosis [n]\n",
  "DIAGNOSTICS": "DIAGNOSTIC, the art or practice of diagnosis [n]\n",
  "DIAGOMETER": "an instrument for measuring electrical conductivity [n -S]\n",
  "DIAGOMETERS": "DIAGOMETER, an instrument for measuring electrical conductivity [n]\n",
  "DIAGONAL": "slanting [adj DIAGONALLY] / an oblique line [n -S]\n",
  "DIAGONALISABLE": "a mathematical term relating to a property of matrices, also DIAGONALIZABLE [adj]\n",
  "DIAGONALISATION": "the act of diagonalising, also DIAGONALIZATION [n]\n",
  "DIAGONALISE": "to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALIZE [v DIAGONALISED, DIAGONALISING, DIAGONALISES]\n",
  "DIAGONALISED": "DIAGONALISE, to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALIZE [v]\n",
  "DIAGONALISES": "DIAGONALISE, to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALIZE [v]\n",
  "DIAGONALISING": "DIAGONALISE, to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALIZE [v]\n",
  "DIAGONALIZABLE": "a mathematical term relating to a property of matrices, also DIAGONALISABLE [adj]\n",
  "DIAGONALIZATION": "the act of diagonalizing, also DIAGONALISATION [n]\n",
  "DIAGONALIZE": "to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALISE [v DIAGONALIZED, DIAGONALIZING, DIAGONALIZES]\n",
  "DIAGONALIZED": "DIAGONALIZE, to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALISE [v]\n",
  "DIAGONALIZES": "DIAGONALIZE, to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALISE [v]\n",
  "DIAGONALIZING": "DIAGONALIZE, to put (a matrix) in a form with all the nonzero elements along the diagonal from upper left to lower right, also DIAGONALISE [v]\n",
  "DIAGONALLY": "DIAGONAL, slanting [adv]\n",
  "DIAGONALS": "DIAGONAL, an oblique line [n]\n",
  "DIAGRAM": "to illustrate by drawing a plan [v DIAGRAMED or DIAGRAMMED, DIAGRAMING or DIAGRAMMING, DIAGRAMS]\n",
  "DIAGRAMED": "DIAGRAM, to illustrate by drawing a plan [v]\n",
  "DIAGRAMING": "DIAGRAM, to illustrate by drawing a plan [v]\n",
  "DIAGRAMMABLE": "capable of being diagrammed [adj]\n",
  "DIAGRAMMATIC": "of or like a diagram, also DIAGRAMMATICAL [adj]\n",
  "DIAGRAMMATICAL": "of or like a diagram, also DIAGRAMMATIC [adj]\n",
  "DIAGRAMMED": "DIAGRAM, to illustrate by drawing a plan [v]\n",
  "DIAGRAMMING": "DIAGRAM, to illustrate by drawing a plan [v]\n",
  "DIAGRAMS": "DIAGRAM, to illustrate by drawing a plan [v]\n",
  "DIAGRAPH": "an instrument for copying [n -S]\n",
  "DIAGRAPHIC": "pertaining to a diagraph, an instrument for enlarging or projecting drawings [adj]\n",
  "DIAGRAPHS": "DIAGRAPH, an instrument for copying [n]\n",
  "DIAGRID": "a structure of interlocking diagonal beams used for support [n -S]\n",
  "DIAGRIDS": "DIAGRID, a structure of interlocking diagonal beams used for support [n]\n",
  "DIAHELIOTROPIC": "turning transversely to the light [adj]\n",
  "DIAHELIOTROPISM": "the state of being diaheliotropic, turning transversely to the light [n]\n",
  "DIAKINESES": "DIAKINESIS, the final stage of prophase in meiosis [n]\n",
  "DIAKINESIS": "the final stage of prophase in meiosis [n DIAKINESES]\n",
  "DIAL": "to use a calibrated disk [v DIALLED or DIALED, DIALING or DIALLING, DIALS]\n",
  "DIALECT": "a language peculiar to a region [n -S]\n",
  "DIALECTAL": "relating to a dialect [adj DIALECTALLY]\n",
  "DIALECTALLY": "DIALECTAL, relating to a dialect [adv]\n",
  "DIALECTIC": "relating to discourse or to dialectics [adj] / the art of arriving at the truth by disclosing the contradictions in the opponent's argument and overcoming them [n -S]\n",
  "DIALECTICAL": "relating to the dialectic, the art of arriving at the truth by disclosing the contradictions in the opponent's argument and overcoming them [adj DIALECTICALLY]\n",
  "DIALECTICALLY": "DIALECTICAL, relating to the dialectic, the art of arriving at the truth by disclosing the contradictions in the opponent's argument and overcoming them [adv]\n",
  "DIALECTICIAN": "one who is skilled in or practices dialectic [n -S]\n",
  "DIALECTICIANS": "DIALECTICIAN, one who is skilled in or practices dialectic [n]\n",
  "DIALECTICISM": "the study of dialects [n -S]\n",
  "DIALECTICISMS": "DIALECTICISM, the study of dialects [n]\n",
  "DIALECTICS": "DIALECTIC, the art of arriving at the truth by disclosing the contradictions in the opponent's argument and overcoming them [n]\n",
  "DIALECTOLOGICAL": "relating to dialectology [adj]\n",
  "DIALECTOLOGIES": "DIALECTOLOGY, the study of dialects [n]\n",
  "DIALECTOLOGIST": "a specialist in dialectology [n -S]\n",
  "DIALECTOLOGISTS": "DIALECTOLOGIST, a specialist in dialectology [n]\n",
  "DIALECTOLOGY": "the study of dialects [n DIALECTOLOGIES]\n",
  "DIALECTS": "DIALECT, a language peculiar to a region [n]\n",
  "DIALED": "DIAL, to use a calibrated disk [v]\n",
  "DIALER": "one that dials, also DIALLER [n -S]\n",
  "DIALERS": "DIALER, one that dials, also DIALLER [n]\n",
  "DIALING": "the art of making sundials, also DIALLING [n -S]\n",
  "DIALINGS": "DIALING, the art of making sundials, also DIALLING [n]\n",
  "DIALIST": "a dialer, also DIALLIST [n -S]\n",
  "DIALISTS": "DIALIST, a dialer, also DIALLIST [n]\n",
  "DIALLAGE": "(Greek) a mineral, a brown, green or grey form of augite [n -S]\n",
  "DIALLAGES": "DIALLAGE, (Greek) a mineral, a brown, green or grey form of augite [n]\n",
  "DIALLAGIC": "relating to diallage, a brown, green or grey form of augite [adj]\n",
  "DIALLAGOID": "of or like diallage, a mineral, a brown, green or grey form of augite [adj]\n",
  "DIALLED": "DIAL, to use a calibrated disk [v]\n",
  "DIALLEL": "a scheme of crossbreeding within a select group of parents, designed to produce various hybrids with different genetic properties [n -S]\n",
  "DIALLELS": "DIALLEL, a scheme of crossbreeding within a select group of parents, designed to produce various hybrids with different genetic properties [n]\n",
  "DIALLER": "one that dials, also DIALER [n -S]\n",
  "DIALLERS": "DIALLER, one that dials, also DIALER [n]\n",
  "DIALLING": "the art of making sundials, also DIALING [n -S]\n",
  "DIALLINGS": "DIALLING, the art of making sundials, also DIALING [n]\n",
  "DIALLIST": "a dialer, also DIALIST [n -S]\n",
  "DIALLISTS": "DIALLIST, a dialer, also DIALIST [n]\n",
  "DIALOG": "to hold a conversation between two people [v -ED, -ING, -S]\n",
  "DIALOGED": "DIALOG, to hold a conversation between two people [v]\n",
  "DIALOGER": "one who makes things into dialogues, also DIALOGUER [n -S]\n",
  "DIALOGERS": "DIALOGER, one who makes things into dialogues, also DIALOGUER [n]\n",
  "DIALOGIC": "relating to dialogue, also DIALOGICAL [adj DIALOGICALLY]\n",
  "DIALOGICAL": "relating to a dialogue, also DIALOGIC [adj DIALOGICALLY]\n",
  "DIALOGICALLY": "DIALOGICAL, relating to a dialogue, also DIALOGIC [adv]\n",
  "DIALOGING": "DIALOG, to hold a conversation between two people [v]\n",
  "DIALOGISE": "to discourse in dialogue, also DIALOGIZE [v DIALOGISED, DIALOGISING, DIALOGISES]\n",
  "DIALOGISED": "DIALOGISE, to discourse in dialogue, also DIALOGIZE [v]\n",
  "DIALOGISES": "DIALOGISE, to discourse in dialogue, also DIALOGIZE [v]\n",
  "DIALOGISING": "DIALOGISE, to discourse in dialogue, also DIALOGIZE [v]\n",
  "DIALOGISM": "deduction with one premise and a disjunctive conclusion [n -S]\n",
  "DIALOGISMS": "DIALOGISM, deduction with one premise and a disjunctive conclusion [n]\n",
  "DIALOGIST": "a speaker in a dialogue [n -S]\n",
  "DIALOGISTIC": "relating to dialog, also DIALOGISTICAL [adj]\n",
  "DIALOGISTICAL": "relating to dialog, also DIALOGISTIC [adj]\n",
  "DIALOGISTS": "DIALOGIST, a speaker in a dialogue [n]\n",
  "DIALOGITE": "a native carbonate of manganese, aka rhodochrosite [n -S]\n",
  "DIALOGITES": "DIALOGITE, a native carbonate of manganese, aka rhodochrosite [n]\n",
  "DIALOGIZE": "to discourse in dialogue, also DIALOGISE [v DIALOGIZED, DIALOGIZING, DIALOGIZES]\n",
  "DIALOGIZED": "DIALOGIZE, to discourse in dialogue, also DIALOGISE [v]\n",
  "DIALOGIZES": "DIALOGIZE, to discourse in dialogue, also DIALOGISE [v]\n",
  "DIALOGIZING": "DIALOGIZE, to discourse in dialogue, also DIALOGISE [v]\n",
  "DIALOGS": "DIALOG, to hold a conversation between two people [v]\n",
  "DIALOGUE": "to hold a conversation between two people, also DIALOG [v DIALOGUED, DIALOGUING, DIALOGUES]\n",
  "DIALOGUED": "DIALOGUE, to hold a conversation between two people, also DIALOG [v]\n",
  "DIALOGUER": "one who makes things into dialogues, also DIALOGER [n -S]\n",
  "DIALOGUERS": "DIALOGUER, one who makes things into dialogues, also DIALOGER [n]\n",
  "DIALOGUES": "DIALOGUE, to hold a conversation between two people, also DIALOG [v]\n",
  "DIALOGUING": "DIALOGUE, to hold a conversation between two people, also DIALOG [v]\n",
  "DIALS": "DIAL, to use a calibrated disk [v]\n",
  "DIALYPETALOUS": "having the petals separate [adj]\n",
  "DIALYSABILITIES": "DIALYSABILITY, the quality of being dialysable, also DIALYZABILITY [n]\n",
  "DIALYSABILITY": "the quality of being dialysable, also DIALYZABILITY [n DIALYSABILITIES]\n",
  "DIALYSABLE": "able to be dialysed [adj]\n",
  "DIALYSATE": "the material subjected to dialysis, the separation of substances by diffusion through a membranous septum or partition, also DIALYZATE [n -S]\n",
  "DIALYSATES": "DIALYSATE, the material subjected to dialysis, the separation of substances by diffusion through a membranous septum or partition, also DIALYZATE [n]\n",
  "DIALYSATION": "the act of dialysing, also DIALYZATION [n -S]\n",
  "DIALYSATIONS": "DIALYSATION, the act of dialysing, also DIALYZATION [n]\n",
  "DIALYSE": "to use a kidney machine, also DIALYZE [v DIALYSED, DIALYSING, DIALYSES]\n",
  "DIALYSED": "DIALYSE, to use a kidney machine, also DIALYZE [v]\n",
  "DIALYSER": "an apparatus used for dialysis, also DIALYZER [n -S]\n",
  "DIALYSERS": "DIALYSER, an apparatus used for dialysis, also DIALYZER [n]\n",
  "DIALYSES": "DIALYSE, to use a kidney machine, also DIALYZE [v]\n",
  "DIALYSING": "DIALYSE, to use a kidney machine, also DIALYZE [v]\n",
  "DIALYSIS": "the separation of substances by diffusion through a membranous septum or partition [n DIALYSES]\n",
  "DIALYTIC": "having the quality of unloosing or separating [adj DIALYTICALLY]\n",
  "DIALYTICALLY": "DIALYTIC, having the quality of unloosing or separating [adv]\n",
  "DIALYZABILITIES": "DIALYZABILITY, the quality of being dialyzable [n]\n",
  "DIALYZABILITY": "the quality of being dialyzable [n DIALYZABILITIES]\n",
  "DIALYZABLE": "that can be dialyzed [adj]\n",
  "DIALYZATE": "the material subjected to dialysis, the separation of substances by diffusion through a membranous septum or partition, also DIALYSATE [n -S]\n",
  "DIALYZATES": "DIALYZATE, the material subjected to dialysis, the separation of substances by diffusion through a membranous septum or partition, also DIALYSATE [n]\n",
  "DIALYZATION": "the act of dialyzing, also DIALYSATION [n -S]\n",
  "DIALYZATIONS": "DIALYZATION, the act of dialyzing, also DIALYSATION [n]\n",
  "DIALYZE": "to use a kidney machine, also DIALYSE [v DIALYZED, DIALYZING, DIALYZES]\n",
  "DIALYZED": "DIALYZE, to use a kidney machine, also DIALYSE [v]\n",
  "DIALYZER": "an apparatus used for dialysis, also DIALYSER [n -S]\n",
  "DIALYZERS": "DIALYZER, an apparatus used for dialysis, also DIALYSER [n]\n",
  "DIALYZES": "DIALYZE, to use a kidney machine, also DIALYSE [v]\n",
  "DIALYZING": "DIALYZE, to use a kidney machine, also DIALYSE [v]\n",
  "DIAMAGNET": "a body having diamagnetic polarity [n -S]\n",
  "DIAMAGNETIC": "applied to any substance of which a rod suspended between the poles of a magnet arranges itself across the lines of force, as opposed to paramagnetic [adj DIAMAGNETICALLY]\n",
  "DIAMAGNETICALLY": "DIAMAGNETIC, applied to any substance of which a rod suspended between the poles of a magnet arranges itself across the lines of force, as opposed to paramagnetic [adv]\n",
  "DIAMAGNETISM": "the form of magnetism possessed by diamagnetic bodies [n -S]\n",
  "DIAMAGNETISMS": "DIAMAGNETISM, the form of magnetism possessed by diamagnetic bodies [n]\n",
  "DIAMAGNETS": "DIAMAGNET, a body having diamagnetic polarity [n]\n",
  "DIAMANTE": "(French) a sparkling decoration on a dress [n -S]\n",
  "DIAMANTES": "DIAMANTE, (French) a sparkling decoration on a dress [n]\n",
  "DIAMANTIFEROUS": "bearing diamonds [adj]\n",
  "DIAMANTINE": "adamantine, like diamond [adj]\n",
  "DIAMETER": "a straight line passing through the center of a circle and ending at the periphery [n -S]\n",
  "DIAMETERS": "DIAMETER, a straight line passing through the center of a circle and ending at the periphery [n]\n",
  "DIAMETRAL": "pertaining to a diameter, also DIAMETRIC, DIAMETRICAL [adj DIAMETRALLY]\n",
  "DIAMETRALLY": "DIAMETRAL, pertaining to a diameter, also DIAMETRIC, DIAMETRICAL [adv]\n",
  "DIAMETRIC": "pertaining to a diameter, also DIAMETRAL, DIAMETRICAL [adj DIAMETRICALLY]\n",
  "DIAMETRICAL": "pertaining to a diameter, also DIAMETRAL, DIAMETRIC [adj DIAMETRICALLY]\n",
  "DIAMETRICALLY": "DIAMETRICAL, pertaining to a diameter, also DIAMETRAL, DIAMETRIC [adv]\n",
  "DIAMIDE": "any compound containing two amido groups united with one or more acid or negative radicals [n -S]\n",
  "DIAMIDES": "DIAMIDE, any compound containing two amido groups united with one or more acid or negative radicals [n]\n",
  "DIAMIN": "a chemical compound containing two amino groups, also DIAMINE [n -S]\n",
  "DIAMINE": "a chemical compound containing two amino groups, also DIAMIN [n -S]\n",
  "DIAMINES": "DIAMINE, a chemical compound containing two amino groups, also DIAMIN [n]\n",
  "DIAMINS": "DIAMIN, a chemical compound containing two amino groups, also DIAMINE [n]\n",
  "DIAMOND": "to adorn with precious gems [v -ED, -ING, -S]\n",
  "DIAMONDBACK": "a kind of rattlesnake [n -S]\n",
  "DIAMONDBACKS": "DIAMONDBACK, a kind of rattlesnake [n]\n",
  "DIAMONDED": "DIAMOND, to adorn with precious gems [v]\n",
  "DIAMONDIFEROUS": "containing diamonds [adj]\n",
  "DIAMONDING": "DIAMOND, to adorn with precious gems [v]\n",
  "DIAMONDS": "DIAMOND, to adorn with precious gems [v]\n",
  "DIAMORPHINE": "a strong painkilling drug [n -S]\n",
  "DIAMORPHINES": "DIAMORPHINE, a strong painkilling drug [n]\n",
  "DIAMYL": "having two amyl groups [adj]\n",
  "DIANDRIES": "DIANDRY, the state of being diandrous [n]\n",
  "DIANDROUS": "having two stamens [adj]\n",
  "DIANDRY": "the state of being diandrous [n DIANDRIES]\n",
  "DIANE": "as in steak diane, steak served in a rich seasoned sauce [adj]\n",
  "DIANODAL": "passing through a node [adj]\n",
  "DIANOETIC": "capable of or relating to thought [adj]\n",
  "DIANOIA": "perception or experience as inferior forms of knowledge [n -S]\n",
  "DIANOIAS": "DIANOIA, perception or experience as inferior forms of knowledge [n]\n",
  "DIANTHUS": "a genus of plants including the pink, carnation, and sweet william [n -ES]\n",
  "DIANTHUSES": "DIANTHUS, a genus of plants including the pink, carnation, and sweet william [n]\n",
  "DIAPASE": "(Spenser) a loud, harmonious burst of music, also DIAPASON [n -S]\n",
  "DIAPASES": "DIAPASE, (Spenser) a loud, harmonious burst of music, also DIAPASON [n]\n",
  "DIAPASON": "a loud, harmonious burst of music, also DIAPASE [n -S]\n",
  "DIAPASONAL": "relating to a diapason, also DIAPASONIC [adj]\n",
  "DIAPASONIC": "relating to a diapason, also DIAPASONAL [adj]\n",
  "DIAPASONS": "DIAPASON, a loud, harmonious burst of music, also DIAPASE [n]\n",
  "DIAPAUSE": "in insects and the embryos of some animals, to undergo a period of suspended animation and growth [v DIAPAUSED, DIAPAUSING, DIAPAUSES]\n",
  "DIAPAUSED": "DIAPAUSE, in insects and the embryos of some animals, to undergo a period of suspended animation and growth [v]\n",
  "DIAPAUSES": "DIAPAUSE, in insects and the embryos of some animals, to undergo a period of suspended animation and growth [v]\n",
  "DIAPAUSING": "DIAPAUSE, in insects and the embryos of some animals, to undergo a period of suspended animation and growth [v]\n",
  "DIAPEDESES": "DIAPEDESIS, the migration of white blood corpuscles through the walls of the blood vessels without apparent rupture [n]\n",
  "DIAPEDESIS": "the migration of white blood corpuscles through the walls of the blood vessels without apparent rupture [n DIAPEDESES]\n",
  "DIAPEDETIC": "relating to diapedesis, the migration of white blood corpuscles through the walls of the blood vessels without apparent rupture [adj]\n",
  "DIAPENTE": "(Greek) in Greek music, the interval of the fifth [n -S]\n",
  "DIAPENTES": "DIAPENTE, (Greek) in Greek music, the interval of the fifth [n]\n",
  "DIAPER": "to put a nappy on [v -ED, -ING, -S]\n",
  "DIAPERED": "DIAPER, to put a nappy on [v]\n",
  "DIAPERING": "nappies collectively [n -S]\n",
  "DIAPERINGS": "DIAPERING, nappies collectively [n]\n",
  "DIAPERS": "DIAPER, to put a nappy on [v]\n",
  "DIAPHANEITIES": "DIAPHANEITY, the quality of transmitting light [n]\n",
  "DIAPHANEITY": "the quality of transmitting light [n DIAPHANEITIES]\n",
  "DIAPHANOMETER": "an instrument for measuring the transparency of air [n -S]\n",
  "DIAPHANOMETERS": "DIAPHANOMETER, an instrument for measuring the transparency of air [n]\n",
  "DIAPHANOUS": "transparent, translucent [adj DIAPHANOUSLY]\n",
  "DIAPHANOUSLY": "DIAPHANOUS, transparent, translucent [adv]\n",
  "DIAPHANOUSNESS": "DIAPHANOUS, transparent, translucent [n]\n",
  "DIAPHONE": "a low-pitched foghorn [n -S]\n",
  "DIAPHONES": "DIAPHONE, a low-pitched foghorn [n]\n",
  "DIAPHONIC": "relating to diaphony, two-part polyphony [adj]\n",
  "DIAPHONIES": "DIAPHONY, a system of rules for scientific investigation [n]\n",
  "DIAPHONY": "a system of rules for scientific investigation [n DIAPHONIES]\n",
  "DIAPHORASE": "a flavoprotein enzyme [n -S]\n",
  "DIAPHORASES": "DIAPHORASE, a flavoprotein enzyme [n]\n",
  "DIAPHORESES": "DIAPHORESIS, perspiration, esp. when copious and medically induced [n]\n",
  "DIAPHORESIS": "perspiration, esp. when copious and medically induced [n DIAPHORESES]\n",
  "DIAPHORETIC": "promoting sweating [adj] / a drug having the power to increase perspiration [n -S]\n",
  "DIAPHORETICS": "DIAPHORETIC, a drug having the power to increase perspiration [n]\n",
  "DIAPHOTOTROPIC": "diaheliotropic, turning transversely to the light [adj]\n",
  "DIAPHOTOTROPIES": "DIAPHOTOTROPY, the state of being diaphototropic, turning transversely to the light [n]\n",
  "DIAPHOTOTROPISM": "the state of being diaphototropic, turning transversely to the light [n]\n",
  "DIAPHOTOTROPY": "the state of being diaphototropic, turning transversely to the light [n DIAPHOTOTROPIES]\n",
  "DIAPHRAGM": "the muscular structure separating the chest from the abdomen [n -S] / to fit with a diaphragm [v -ED, -ING, -S]\n",
  "DIAPHRAGMAL": "relating to the diaphragm [adj]\n",
  "DIAPHRAGMATIC": "relating to the diaphragm [adj]\n",
  "DIAPHRAGMATITIS": "inflammation of the diaphragm [n]\n",
  "DIAPHRAGMED": "DIAPHRAGM, to fit with a diaphragm [v]\n",
  "DIAPHRAGMING": "DIAPHRAGM, to fit with a diaphragm [v]\n",
  "DIAPHRAGMITIS": "inflammation of the diaphragm, also DIAPHRAGMATITIS [n -ES]\n",
  "DIAPHRAGMITISES": "DIAPHRAGMITIS, inflammation of the diaphragm, also DIAPHRAGMATITIS [n]\n",
  "DIAPHRAGMS": "DIAPHRAGM, the muscular structure separating the chest from the abdomen [n]\n",
  "DIAPHYSEAL": "of or like a diaphysis, the shaft of a long bone, also DIAPHYSIAL [adj]\n",
  "DIAPHYSES": "DIAPHYSIS, (Greek) the shaft of a long bone [n]\n",
  "DIAPHYSIAL": "of or like a diaphysis, the shaft of a long bone, also DIAPHYSEAL [adj]\n",
  "DIAPHYSIS": "(Greek) the shaft of a long bone [n DIAPHYSES]\n",
  "DIAPIR": "an anticlinal fold in which the overlying rock has been pierced by material from beneath [n -S]\n",
  "DIAPIRIC": "of or like diapir, an anticlinal fold in which the overlying rock has been pierced by material from beneath [adj]\n",
  "DIAPIRISM": "the upward movement of material through denser rock [n -S]\n",
  "DIAPIRISMS": "DIAPIRISM, the upward movement of material through denser rock [n]\n",
  "DIAPIRS": "DIAPIR, an anticlinal fold in which the overlying rock has been pierced by material from beneath [n]\n",
  "DIAPOPHYSES": "DIAPOPHYSIS, a dorsal transverse process of a vertebra [n]\n",
  "DIAPOPHYSIAL": "of or like a diapophysis, a dorsal transverse process of a vertebra [adj]\n",
  "DIAPOPHYSIS": "a dorsal transverse process of a vertebra [n DIAPOPHYSES]\n",
  "DIAPOSITIVE": "a transparent photographic positive; a slide [n -S]\n",
  "DIAPOSITIVES": "DIAPOSITIVE, a transparent photographic positive; a slide [n]\n",
  "DIAPSID": "of a reptile, having two pairs of temporal openings [adj] / a diapsid reptile [n -S]\n",
  "DIAPSIDS": "DIAPSID, a diapsid reptile [n]\n",
  "DIAPYESES": "DIAPYESIS, release or discharge of pus [n]\n",
  "DIAPYESIS": "release or discharge of pus [n DIAPYESES]\n",
  "DIAPYETIC": "a substance causing suppuration [n -S]\n",
  "DIAPYETICS": "DIAPYETIC, a substance causing suppuration [n]\n",
  "DIARCH": "having two xylem strands [adj]\n",
  "DIARCHAL": "relating to a diarchy, rulership by two people, also DIARCHIC, DYARCHAL, DYARCHIC, DYARCHICAL [adj]\n",
  "DIARCHIC": "relating to a diarchy, rulership by two people, also DIARCHAL, DYARCHAL, DYARCHIC, DYARCHICAL [adj]\n",
  "DIARCHICAL": "relating to a diarchy, rulership by two people, also DIARCHAL, DIARCHIC, DYARCHICAL [adj]\n",
  "DIARCHIES": "DIARCHY, government by two powers, also DINARCHY, DUARCHY, DYARCHY [n]\n",
  "DIARCHY": "government by two powers, also DINARCHY, DUARCHY, DYARCHY [n DIARCHIES]\n",
  "DIARIAL": "pertaining to a diary; daily, also DIARIAN [adj]\n",
  "DIARIAN": "pertaining to a diary; daily, also DIARIAL [adj]\n",
  "DIARIES": "DIARY, a personal journal [n]\n",
  "DIARISE": "to keep a diary, also DIARIZE [v DIARISED, DIARISING, DIARISES]\n",
  "DIARISED": "DIARISE, to keep a diary, also DIARIZE [v]\n",
  "DIARISES": "DIARISE, to keep a diary, also DIARIZE [v]\n",
  "DIARISING": "DIARISE, to keep a diary, also DIARIZE [v]\n",
  "DIARIST": "one who keeps a diary [n -S]\n",
  "DIARISTIC": "like a diarist, one who keeps a diary [adj]\n",
  "DIARISTS": "DIARIST, one who keeps a diary [n]\n",
  "DIARIZE": "to keep a diary, also DIARISE [v DIARIZED, DIARIZING, DIARIZES]\n",
  "DIARIZED": "DIARIZE, to keep a diary, also DIARISE [v]\n",
  "DIARIZES": "DIARIZE, to keep a diary, also DIARISE [v]\n",
  "DIARIZING": "DIARIZE, to keep a diary, also DIARISE [v]\n",
  "DIARRHEA": "a persistent purging or looseness of the bowels, also DIARRHOEA [n -S]\n",
  "DIARRHEAL": "of or like diarrhoea, also DIARRHEIC, DIARRHETIC, DIARRHOEAL, DIARRHOEIC [adj]\n",
  "DIARRHEAS": "DIARRHEA, a persistent purging or looseness of the bowels, also DIARRHOEA [n]\n",
  "DIARRHEIC": "of or like diarrhoea, also DIARRHEAL, DIARRHETIC, DIARRHOEAL, DIARRHOEIC [adj]\n",
  "DIARRHETIC": "of or like diarrhoea, also DIARRHEAL, DIARRHEIC, DIARRHOEAL, DIARRHOEIC [adj]\n",
  "DIARRHOEA": "a persistent purging or looseness of the bowels, also DIARRHEA [n -S]\n",
  "DIARRHOEAL": "of or like diarrhoea, also DIARRHEAL, DIARRHEIC, DIARRHETIC, DIARRHOEIC [adj]\n",
  "DIARRHOEAS": "DIARRHOEA, a persistent purging or looseness of the bowels, also DIARRHEA [n]\n",
  "DIARRHOEIC": "of or like diarrhoea, also DIARRHEAL, DIARRHEIC, DIARRHETIC, DIARRHOEAL [adj]\n",
  "DIARTHRODIAL": "of or like a diarthrosis, a joint permitting free movement [adj]\n",
  "DIARTHROSES": "DIARTHROSIS, a joint permitting free movement [n]\n",
  "DIARTHROSIS": "a joint permitting free movement [n DIARTHROSES]\n",
  "DIARY": "a personal journal [n DIARIES]\n",
  "DIASCIA": "a plant of the genus Diascia, native to southern Africa, cultivated for its colourful, pink flowers [n -S]\n",
  "DIASCIAS": "DIASCIA, a plant of the genus Diascia, native to southern Africa, cultivated for its colourful, pink flowers [n]\n",
  "DIASCOPE": "an optical projector used for showing transparencies on a screen [n -S]\n",
  "DIASCOPES": "DIASCOPE, an optical projector used for showing transparencies on a screen [n]\n",
  "DIASCORDIUM": "(obsolete) a medicine made from water-germander, etc. [n -S]\n",
  "DIASCORDIUMS": "DIASCORDIUM, (obsolete) a medicine made from water-germander, etc. [n]\n",
  "DIASKEUAST": "a reviser, an interpolator [n -S]\n",
  "DIASKEUASTS": "DIASKEUAST, a reviser, an interpolator [n]\n",
  "DIASPORA": "(Greek) an emigration, a dispersal of people [n -S]\n",
  "DIASPORAS": "DIASPORA, (Greek) an emigration, a dispersal of people [n]\n",
  "DIASPORE": "a hydrate of alumina, often occurring in white lamellar masses with brilliant pearly lustre [n -S]\n",
  "DIASPORES": "DIASPORE, a hydrate of alumina, often occurring in white lamellar masses with brilliant pearly lustre [n]\n",
  "DIASPORIC": "relating to a diaspora, a dispersion or migration [adj]\n",
  "DIASTALSES": "DIASTALSIS, a downward wave of contraction occurring in the intestine during digestion [n]\n",
  "DIASTALSIS": "a downward wave of contraction occurring in the intestine during digestion [n DIASTALSES]\n",
  "DIASTALTIC": "(Greek music) of intervals, extended; of style, bold [adj]\n",
  "DIASTASE": "a soluble, nitrogenous ferment, capable of converting starch and dextrin into sugar [n -S]\n",
  "DIASTASES": "DIASTASE, a soluble, nitrogenous ferment, capable of converting starch and dextrin into sugar [n]\n",
  "DIASTASIC": "of or like diastase, also DIASTATIC [adj]\n",
  "DIASTASIS": "the separation of two parts of a bone without fracture, esp. of an epiphysis from a long bone [n DIASTASES]\n",
  "DIASTATIC": "of or like diastase, also DIASTASIC [adj]\n",
  "DIASTEM": "(Greek) in Greek music, an interval, esp. one forming a single degree of the scale [n -S]\n",
  "DIASTEMA": "(Greek) a space between consecutive teeth [n DIASTEMAS or DIASTEMATA]\n",
  "DIASTEMAS": "DIASTEMA, (Greek) a space between consecutive teeth [n]\n",
  "DIASTEMATA": "DIASTEMA, (Greek) a space between consecutive teeth [n]\n",
  "DIASTEMATIC": "of or like a diastema [adj]\n",
  "DIASTEMS": "DIASTEM, (Greek) in Greek music, an interval, esp. one forming a single degree of the scale [n]\n",
  "DIASTER": "(Greek) a stage in cellular mitosis [n -S]\n",
  "DIASTEREOISOMER": "a stereoisomer that is not an enantiomorph, also DIASTEREOMER [n]\n",
  "DIASTEREOMER": "a stereoisomer that is not an enantiomorph, also DIASTEREOISOMER [n -S]\n",
  "DIASTEREOMERIC": "of or like a diastereomer [adj]\n",
  "DIASTEREOMERS": "DIASTEREOMER, a stereoisomer that is not an enantiomorph, also DIASTEREOISOMER [n]\n",
  "DIASTERS": "DIASTER, (Greek) a stage in cellular mitosis [n]\n",
  "DIASTOLE": "the normal rhythmical dilation of the heart [n -S]\n",
  "DIASTOLES": "DIASTOLE, the normal rhythmical dilation of the heart [n]\n",
  "DIASTOLIC": "of or pertaining to diastole, the rhythmical expansion or dilatation of the heart and arteries [adj]\n",
  "DIASTRAL": "relating to diaster, a stage in cellular mitosis [adj]\n",
  "DIASTROPHIC": "relating to diastrophism [adj DIASTROPHICALLY]\n",
  "DIASTROPHICALLY": "DIASTROPHIC, relating to diastrophism [adv]\n",
  "DIASTROPHISM": "the process by which continents, mountains, ocean beds, folds and faults are formed [n -S]\n",
  "DIASTROPHISMS": "DIASTROPHISM, the process by which continents, mountains, ocean beds, folds and faults are formed [n]\n",
  "DIASTYLE": "a colonnade with closely spaced columns [n -S]\n",
  "DIASTYLES": "DIASTYLE, a colonnade with closely spaced columns [n]\n",
  "DIATESSARON": "a medicine with four ingredients [n -S]\n",
  "DIATESSARONS": "DIATESSARON, a medicine with four ingredients [n]\n",
  "DIATHERMACIES": "DIATHERMACY, permeability by or conductibility of radiant heat, also DIATHERMANCY [n]\n",
  "DIATHERMACY": "permeability by or conductibility of radiant heat, also DIATHERMANCY [n DIATHERMACIES]\n",
  "DIATHERMAL": "freely permeable by radiant heat [adj]\n",
  "DIATHERMANCIES": "DIATHERMANCY, permeability by or conductibility of radiant heat, also DIATHERMACY [n]\n",
  "DIATHERMANCY": "permeability by or conductibility of radiant heat, also DIATHERMACY [n DIATHERMANCIES]\n",
  "DIATHERMANEITY": "the state of being diathermic, permeable to or able to conduct radiant heat [n]\n",
  "DIATHERMANOUS": "permeable by or able to conduct radiant heat [adj]\n",
  "DIATHERMIA": "heating of internal parts of the body by electric currents, also DIATHERMY [n -S]\n",
  "DIATHERMIAS": "DIATHERMIA, heating of internal parts of the body by electric currents, also DIATHERMY [n]\n",
  "DIATHERMIC": "permeable to or able to conduct radiant heat, also DIATHERMOUS [adj]\n",
  "DIATHERMIES": "DIATHERMY, heating of internal parts of the body by electric currents, also DIATHERMIA [n]\n",
  "DIATHERMOUS": "permeable to or able to conduct radiant heat, also DIATHERMIC [adj]\n",
  "DIATHERMY": "heating of internal parts of the body by electric currents, also DIATHERMIA [n DIATHERMIES]\n",
  "DIATHESES": "DIATHESIS, a constitutional predisposition to a particular disease or condition [n]\n",
  "DIATHESIS": "a constitutional predisposition to a particular disease or condition [n DIATHESES]\n",
  "DIATHETIC": "pertaining to a diathesis, a constitutional predisposition to a particular disease or condition [adj]\n",
  "DIATOM": "a microscopic unicellular alga that has a rigid siliceous cell wall [n -S]\n",
  "DIATOMACEOUS": "consisting of or abounding in diatoms or their siliceous remains [adj]\n",
  "DIATOMIC": "composed of two atoms [adj]\n",
  "DIATOMICITIES": "DIATOMICITY, the state of being a diatom [n]\n",
  "DIATOMICITY": "the state of being a diatom [n DIATOMICITIES]\n",
  "DIATOMIST": "a person who studies diatoms [n -S]\n",
  "DIATOMISTS": "DIATOMIST, a person who studies diatoms [n]\n",
  "DIATOMITE": "a siliceous sedimentary rock formed from the accumulations of diatoms or other nanoplankton [n -S]\n",
  "DIATOMITES": "DIATOMITE, a siliceous sedimentary rock formed from the accumulations of diatoms or other nanoplankton [n]\n",
  "DIATOMS": "DIATOM, a microscopic unicellular alga that has a rigid siliceous cell wall [n]\n",
  "DIATONIC": "using only the eight tones of a major or minor scale without chromatic deviations [adj DIATONICALLY]\n",
  "DIATONICALLY": "DIATONIC, using only the eight tones of a major or minor scale without chromatic deviations [adv]\n",
  "DIATONICISM": "the state of being diatonic [n -S]\n",
  "DIATONICISMS": "DIATONICISM, the state of being diatonic [n]\n",
  "DIATREME": "a volcanic vent produced by gaseous explosions [n -S]\n",
  "DIATREMES": "DIATREME, a volcanic vent produced by gaseous explosions [n]\n",
  "DIATRETA": "DIATRETUM, (Latin) a kind of glass bowl of late Roman times [n]\n",
  "DIATRETUM": "(Latin) a kind of glass bowl of late Roman times [n DIATRETA or DIATRETUMS]\n",
  "DIATRETUMS": "DIATRETUM, (Latin) a kind of glass bowl of late Roman times [n]\n",
  "DIATRIBE": "(Greek) an abusive, bitter harangue [n -S]\n",
  "DIATRIBES": "DIATRIBE, (Greek) an abusive, bitter harangue [n]\n",
  "DIATRIBIST": "one who makes a diatribe or diatribes [n -S]\n",
  "DIATRIBISTS": "DIATRIBIST, one who makes a diatribe or diatribes [n]\n",
  "DIATRON": "a circuitry design that uses diodes [n -S]\n",
  "DIATRONS": "DIATRON, a circuitry design that uses diodes [n]\n",
  "DIATROPIC": "relating to diatropism, the growth of plant roots at right angles to an applied force [adj]\n",
  "DIATROPISM": "the growth of plant roots at right angles to an applied force [n -S]\n",
  "DIATROPISMS": "DIATROPISM, the growth of plant roots at right angles to an applied force [n]\n",
  "DIAXON": "a bipolar nerve-cell [n -S]\n",
  "DIAXONS": "DIAXON, a bipolar nerve-cell [n]\n",
  "DIAZEPAM": "a tranquillizer of the benzodiazepine group [n -S]\n",
  "DIAZEPAMS": "DIAZEPAM, a tranquillizer of the benzodiazepine group [n]\n",
  "DIAZEUCTIC": "relating to diazeuxis, the separation of two tetrachords by a whole tone [adj]\n",
  "DIAZEUXES": "DIAZEUXIS, in Greek music, the separation of two tetrachords by a whole tone [n]\n",
  "DIAZEUXIS": "in Greek music, the separation of two tetrachords by a whole tone [n DIAZEUXES]\n",
  "DIAZIN": "any organic compound whose molecules contain a hexagonal ring of four carbon atoms and two nitrogen atoms, also DIAZINE [n -S]\n",
  "DIAZINE": "any organic compound whose molecules contain a hexagonal ring of four carbon atoms and two nitrogen atoms, also DIAZIN [n -S]\n",
  "DIAZINES": "DIAZINE, any organic compound whose molecules contain a hexagonal ring of four carbon atoms and two nitrogen atoms, also DIAZIN [n]\n",
  "DIAZINON": "(tradename) an insecticide [n -S]\n",
  "DIAZINONS": "DIAZINON, (tradename) an insecticide [n]\n",
  "DIAZINS": "DIAZIN, any organic compound whose molecules contain a hexagonal ring of four carbon atoms and two nitrogen atoms, also DIAZINE [n]\n",
  "DIAZO": "a type of photocopy [n DIAZOS or DIAZOES]\n",
  "DIAZOES": "DIAZO, a type of photocopy [n]\n",
  "DIAZOLE": "any of a group of organic compounds containing three carbon atoms and two nitrogen atoms arranged in a ring [n -S]\n",
  "DIAZOLES": "DIAZOLE, any of a group of organic compounds containing three carbon atoms and two nitrogen atoms arranged in a ring [n]\n",
  "DIAZOMETHANE": "a yellow odourless explosive gas, used as a methylating agent [n -S]\n",
  "DIAZOMETHANES": "DIAZOMETHANE, a yellow odourless explosive gas, used as a methylating agent [n]\n",
  "DIAZONIUM": "a group of diazo compounds used in the manufacture of certain dyes [n -S]\n",
  "DIAZONIUMS": "DIAZONIUM, a group of diazo compounds used in the manufacture of certain dyes [n]\n",
  "DIAZOS": "DIAZO, a type of photocopy [n]\n",
  "DIAZOTISATION": "the process of diazotising, also DIAZOTIZATION [n -S]\n",
  "DIAZOTISATIONS": "DIAZOTISATION, the process of diazotising, also DIAZOTIZATION [n]\n",
  "DIAZOTISE": "to convert a compound into a diazo compound, also DIAZOTIZE [v DIAZOTISED, DIAZOTISING, DIAZOTISES]\n",
  "DIAZOTISED": "DIAZOTISE, to convert a compound into a diazo compound, also DIAZOTIZE [v]\n",
  "DIAZOTISES": "DIAZOTISE, to convert a compound into a diazo compound, also DIAZOTIZE [v]\n",
  "DIAZOTISING": "DIAZOTISE, to convert a compound into a diazo compound, also DIAZOTIZE [v]\n",
  "DIAZOTIZATION": "the process of diazotizing, also DIAZOTISATION [n -S]\n",
  "DIAZOTIZATIONS": "DIAZOTIZATION, the process of diazotizing, also DIAZOTISATION [n]\n",
  "DIAZOTIZE": "to convert a compound into a diazo compound, also DIAZOTISE [v DIAZOTIZED, DIAZOTIZING, DIAZOTIZES]\n",
  "DIAZOTIZED": "DIAZOTIZE, to convert a compound into a diazo compound, also DIAZOTISE [v]\n",
  "DIAZOTIZES": "DIAZOTIZE, to convert a compound into a diazo compound, also DIAZOTISE [v]\n",
  "DIAZOTIZING": "DIAZOTIZE, to convert a compound into a diazo compound, also DIAZOTISE [v]\n",
  "DIB": "to fish by floating the bait [v DIBBED, DIBBING, DIBS]\n",
  "DIBASIC": "of acids, having two replaceable hydrogen atoms [adj]\n",
  "DIBASICITIES": "DIBASICITY, the quality of being dibasic [n]\n",
  "DIBASICITY": "the quality of being dibasic [n DIBASICITIES]\n",
  "DIBBED": "DIB, to fish by floating the bait [v]\n",
  "DIBBER": "a planting instrument [n -S]\n",
  "DIBBERS": "DIBBER, a planting instrument [n]\n",
  "DIBBING": "DIB, to fish by floating the bait [v]\n",
  "DIBBLE": "to fish by floating the bait, also DIB [v DIBBLED, DIBBLING, DIBBLES]\n",
  "DIBBLED": "DIBBLE, to fish by floating the bait, also DIB [v]\n",
  "DIBBLER": "a device for making holes in soil [n -S]\n",
  "DIBBLERS": "DIBBLER, a device for making holes in soil [n]\n",
  "DIBBLES": "DIBBLE, to fish by floating the bait, also DIB [v]\n",
  "DIBBLING": "DIBBLE, to fish by floating the bait, also DIB [v]\n",
  "DIBBS": "(slang) money, also DIBS [n]\n",
  "DIBBUK": "(Yiddish) a wandering soul in Jewish folklore, also DYBBUK [n DIBBUKS or DIBBUKIM or DIBBUKKIM]\n",
  "DIBBUKIM": "DIBBUK, (Yiddish) a wandering soul in Jewish folklore, also DYBBUK [n]\n",
  "DIBBUKKIM": "DIBBUK, (Yiddish) a wandering soul in Jewish folklore, also DYBBUK [n]\n",
  "DIBBUKS": "DIBBUK, (Yiddish) a wandering soul in Jewish folklore, also DYBBUK [n]\n",
  "DIBENZOFURAN": "a highly toxic chemical compound that is used in chemical synthesis and as an insecticide [n -S]\n",
  "DIBENZOFURANS": "DIBENZOFURAN, a highly toxic chemical compound that is used in chemical synthesis and as an insecticide [n]\n",
  "DIBRANCHIATE": "having two gills [adj] / any of a certain subclass of cephalopods [n -S]\n",
  "DIBRANCHIATES": "DIBRANCHIATE, any of a certain subclass of cephalopods [n]\n",
  "DIBROMIDE": "a compound containing two bromine atoms per molecule [n -S]\n",
  "DIBROMIDES": "DIBROMIDE, a compound containing two bromine atoms per molecule [n]\n",
  "DIBS": "DIB, to fish by floating the bait [v]\n",
  "DIBUTYL": "in chemistry, having two butyl groups [adj]\n",
  "DICACIOUS": "talkative; pert; saucy [adj]\n",
  "DICACITIES": "DICACITY, (archaic) raillery, banter [n]\n",
  "DICACITY": "(archaic) raillery, banter [n DICACITIES]\n",
  "DICACODYL": "an oily poisonous liquid, aka cacodyl [n -S]\n",
  "DICACODYLS": "DICACODYL, an oily poisonous liquid, aka cacodyl [n]\n",
  "DICALCIUM": "as in dicalcium silicate, a calcium silicate that is an essential ingredient of portland cement [adj]\n",
  "DICAMBA": "a type of weedkiller [n -S]\n",
  "DICAMBAS": "DICAMBA, a type of weedkiller [n]\n",
  "DICARBOXYLIC": "containing two carboxyl groups in the molecule [adj]\n",
  "DICARPELLARY": "of or with two carpels [adj]\n",
  "DICAST": "(historical) one of the 6000 Athenians chosen annually to act as judges, also DIKAST [n -S]\n",
  "DICASTERIES": "DICASTERY, a court of justice; a judgment hall [n]\n",
  "DICASTERY": "a court of justice; a judgment hall [n DICASTERIES]\n",
  "DICASTIC": "relating to the old Athenian dicast system of choosing jurors [adj]\n",
  "DICASTS": "DICAST, (historical) one of the 6000 Athenians chosen annually to act as judges, also DIKAST [n]\n",
  "DICE": "to cut into small cubes [v DICED, DICING, DICES]\n",
  "DICED": "DICE, to cut into small cubes [v]\n",
  "DICELIKE": "like a dice [adj]\n",
  "DICENTRA": "a plant with two broadly pouched outer petals, also DIELYTRA [n -S]\n",
  "DICENTRAS": "DICENTRA, a plant with two broadly pouched outer petals, also DIELYTRA [n]\n",
  "DICENTRIC": "a chromosome having two centromeres [n -S]\n",
  "DICENTRICS": "DICENTRIC, a chromosome having two centromeres [n]\n",
  "DICEPHALISM": "the state of being dicephalous, having two heads [n -S]\n",
  "DICEPHALISMS": "DICEPHALISM, the state of being dicephalous, having two heads [n]\n",
  "DICEPHALOUS": "having two heads [adj]\n",
  "DICER": "a device that dices food [n -S]\n",
  "DICERS": "DICER, a device that dices food [n]\n",
  "DICES": "DICE, to cut into small cubes [v]\n",
  "DICEY": "dangerous [adj DICIER, DICIEST]\n",
  "DICH": "(Shakespeare) supposed to be for 'do it', may it do [v]\n",
  "DICHASIA": "DICHASIUM, a cymose inflorescence in which each axis in turn produces a pair of nearly equal branches [n]\n",
  "DICHASIAL": "relating to a dichasium, a flower cluster [adj DICHASIALLY]\n",
  "DICHASIALLY": "DICHASIAL, relating to a dichasium, a flower cluster [adv]\n",
  "DICHASIUM": "a cymose inflorescence in which each axis in turn produces a pair of nearly equal branches [n DICHASIA]\n",
  "DICHLAMYDEOUS": "having both a calyx and a corolla [adj]\n",
  "DICHLORACETIC": "as in dichloracetic acid [adj]\n",
  "DICHLORIDE": "a compound in which two atoms of chlorine are combined with another atom or group, also BICHLORIDE [n -S]\n",
  "DICHLORIDES": "DICHLORIDE, a compound in which two atoms of chlorine are combined with another atom or group, also BICHLORIDE [n]\n",
  "DICHLOROBENZENE": "any of three isomeric benzene compounds [n]\n",
  "DICHLOROETHANE": "a colorless toxic liquid compound that is used chiefly as a solvent [n -S]\n",
  "DICHLOROETHANES": "DICHLOROETHANE, a colorless toxic liquid compound that is used chiefly as a solvent [n]\n",
  "DICHLOROMETHANE": "a noxious colourless liquid widely used as a solvent, e.g. in paint strippers [n]\n",
  "DICHLORVOS": "a pesticide used in fish-farming to reduce sea-lice [n -ES]\n",
  "DICHLORVOSES": "DICHLORVOS, a pesticide used in fish-farming to reduce sea-lice [n]\n",
  "DICHOGAMIC": "relating to dichogamy, an arrangement for preventing the self-fertilization of hermaphrodite flowers [adj]\n",
  "DICHOGAMIES": "DICHOGAMY, an arrangement for preventing the self-fertilization of hermaphrodite flowers, the stamens and stigmas ripening at different times [n]\n",
  "DICHOGAMOUS": "having males and females maturing at different rates [adj]\n",
  "DICHOGAMY": "an arrangement for preventing the self-fertilization of hermaphrodite flowers, the stamens and stigmas ripening at different times [n DICHOGAMIES]\n",
  "DICHONDRA": "a genus of tropical perennial herbs of the morning glory family [n -S]\n",
  "DICHONDRAS": "DICHONDRA, a genus of tropical perennial herbs of the morning glory family [n]\n",
  "DICHOPTIC": "having eyes distinctly separate [adj]\n",
  "DICHORD": "a musical instrument with two strings [n -S]\n",
  "DICHORDS": "DICHORD, a musical instrument with two strings [n]\n",
  "DICHOTIC": "affecting the two ears differently [adj DICHOTICALLY]\n",
  "DICHOTICALLY": "DICHOTIC, affecting the two ears differently [adv]\n",
  "DICHOTOMIC": "of or like a dichotomy [adj]\n",
  "DICHOTOMIES": "DICHOTOMY, division into two usually contradictory parts or opinions [n]\n",
  "DICHOTOMISATION": "the act of dichotomising, also DICHOTOMIZATION [n]\n",
  "DICHOTOMISE": "to render dichotomous, also DICHOTOMIZE [v DICHOTOMISED, DICHOTOMISING, DICHOTOMISES]\n",
  "DICHOTOMISED": "DICHOTOMISE, to render dichotomous, also DICHOTOMIZE [v]\n",
  "DICHOTOMISES": "DICHOTOMISE, to render dichotomous, also DICHOTOMIZE [v]\n",
  "DICHOTOMISING": "DICHOTOMISE, to render dichotomous, also DICHOTOMIZE [v]\n",
  "DICHOTOMIST": "one that dichotomizes [n -S]\n",
  "DICHOTOMISTS": "DICHOTOMIST, one that dichotomizes [n]\n",
  "DICHOTOMIZATION": "the act of dichotomizing, also DICHOTOMISATION [n]\n",
  "DICHOTOMIZE": "to render dichotomous, also DICHOTOMISE [v DICHOTOMIZED, DICHOTOMIZING, DICHOTOMIZES]\n",
  "DICHOTOMIZED": "DICHOTOMIZE, to render dichotomous, also DICHOTOMISE [v]\n",
  "DICHOTOMIZES": "DICHOTOMIZE, to render dichotomous, also DICHOTOMISE [v]\n",
  "DICHOTOMIZING": "DICHOTOMIZE, to render dichotomous, also DICHOTOMISE [v]\n",
  "DICHOTOMOUS": "forking into two equal branches [adj DICHOTOMOUSLY]\n",
  "DICHOTOMOUSLY": "DICHOTOMOUS, forking into two equal branches [adv]\n",
  "DICHOTOMOUSNESS": "DICHOTOMOUS, forking into two equal branches [n]\n",
  "DICHOTOMY": "division into two usually contradictory parts or opinions [n DICHOTOMIES]\n",
  "DICHROIC": "having two colours [adj]\n",
  "DICHROISCOPE": "an instrument for investigating the dichroism of solutions or crystals, also DICHROOSCOPE, DICHROSCOPE [n -S]\n",
  "DICHROISCOPES": "DICHROISCOPE, an instrument for investigating the dichroism of solutions or crystals, also DICHROOSCOPE, DICHROSCOPE [n]\n",
  "DICHROISCOPIC": "relating to a dichroiscope [adj]\n",
  "DICHROISM": "the property of showing different colours exhibited by doubly refracting crystals when viewed in different directions by transmitted light [n -S]\n",
  "DICHROISMS": "DICHROISM, the property of showing different colours exhibited by doubly refracting crystals when viewed in different directions by transmitted light [n]\n",
  "DICHROITE": "a strongly dichroic mineral, iolite or cordierite [n -S]\n",
  "DICHROITES": "DICHROITE, a strongly dichroic mineral, iolite or cordierite [n]\n",
  "DICHROITIC": "having two colours; as, a dichroic crystal, also DICHROIC [adj]\n",
  "DICHROMAT": "a salt of chromic acid containing two equivalents of the acid radical to one of the base, also DICHROMATE [n -S]\n",
  "DICHROMATE": "a salt of chromic acid containing two equivalents of the acid radical to one of the base, also DICHROMAT [n -S]\n",
  "DICHROMATES": "DICHROMATE, a salt of chromic acid containing two equivalents of the acid radical to one of the base, also DICHROMAT [n]\n",
  "DICHROMATIC": "having or exhibiting two colors [adj] / a person with dichromatic vision [n -S]\n",
  "DICHROMATICISM": "the property of presenting different colours by transmitted light, when viewed in two different directions [n -S]\n",
  "DICHROMATICISMS": "DICHROMATICISM, the property of presenting different colours by transmitted light, when viewed in two different directions [n]\n",
  "DICHROMATICS": "DICHROMATIC, a person with dichromatic vision [n]\n",
  "DICHROMATISM": "partial color blindness in which only two colors are perceptible [n -S]\n",
  "DICHROMATISMS": "DICHROMATISM, partial color blindness in which only two colors are perceptible [n]\n",
  "DICHROMATS": "DICHROMAT, a salt of chromic acid containing two equivalents of the acid radical to one of the base, also DICHROMATE [n]\n",
  "DICHROMIC": "able to see two colours and two only, as in red-green colour-blind persons who see only blue and yellow [adj]\n",
  "DICHROMISM": "the state of being dichromic [n -S]\n",
  "DICHROMISMS": "DICHROMISM, the state of being dichromic [n]\n",
  "DICHROOSCOPE": "an instrument for examining crystals for dichroism, also DICHROISCOPE, DICHROSCOPE [n -S]\n",
  "DICHROOSCOPES": "DICHROOSCOPE, an instrument for examining crystals for dichroism, also DICHROISCOPE, DICHROSCOPE [n]\n",
  "DICHROOSCOPIC": "relating to a dichrooscope [adj]\n",
  "DICHROSCOPE": "an instrument for examining crystals for dichroism, also DICHROISCOPE, DICHROOSCOPE [n -S]\n",
  "DICHROSCOPES": "DICHROSCOPE, an instrument for examining crystals for dichroism, also DICHROISCOPE, DICHROOSCOPE [n]\n",
  "DICHROSCOPIC": "relating to a dichroscope [adj]\n",
  "DICHT": "(Scots) to wipe [v -ED, -ING, -S]\n",
  "DICHTED": "DICHT, (Scots) to wipe [v]\n",
  "DICHTING": "DICHT, (Scots) to wipe [v]\n",
  "DICHTS": "DICHT, (Scots) to wipe [v]\n",
  "DICIER": "DICEY, dangerous [adj]\n",
  "DICIEST": "DICEY, dangerous [adj]\n",
  "DICING": "dice-playing [n -S]\n",
  "DICINGS": "DICING, dice-playing [n]\n",
  "DICK": "(vulgar) to copulate with [v -ED, -ING, -S]\n",
  "DICKCISSEL": "the American black-throated bunting [n -S]\n",
  "DICKCISSELS": "DICKCISSEL, the American black-throated bunting [n]\n",
  "DICKED": "DICK, (vulgar) to copulate with [v]\n",
  "DICKENS": "(colloquial) the devil [n -ES]\n",
  "DICKENSES": "DICKENS, (colloquial) the devil [n]\n",
  "DICKER": "to haggle, to hesitate or dither [v -ED, -ING, -S]\n",
  "DICKERED": "DICKER, to haggle, to hesitate or dither [v]\n",
  "DICKERER": "one who dickers [n -S]\n",
  "DICKERERS": "DICKERER, one who dickers [n]\n",
  "DICKERING": "DICKER, to haggle, to hesitate or dither [v]\n",
  "DICKERS": "DICKER, to haggle, to hesitate or dither [v]\n",
  "DICKEY": "a false shirt front, also DICKIE, DICKY [n -S]\n",
  "DICKEYBIRD": "a false shirtfront, also DICKYBIRD [n -S]\n",
  "DICKEYBIRDS": "DICKEYBIRD, a false shirtfront, also DICKYBIRD [n]\n",
  "DICKEYS": "DICKEY, a false shirt front, also DICKIE, DICKY [n]\n",
  "DICKHEAD": "(vulgar) a fool, also KNOBHEAD [n -S]\n",
  "DICKHEADS": "DICKHEAD, (vulgar) a fool, also KNOBHEAD [n]\n",
  "DICKIE": "a false shirt front, also DICKEY, DICKY [n -S]\n",
  "DICKIER": "DICKY, poor in condition [adj]\n",
  "DICKIES": "DICKIE, a false shirt front, also DICKEY, DICKY [n]\n",
  "DICKIEST": "DICKY, poor in condition [adj]\n",
  "DICKING": "the act of copulation [n -S]\n",
  "DICKINGS": "DICKING, the act of copulation [n]\n",
  "DICKS": "DICK, (vulgar) to copulate with [v]\n",
  "DICKTIER": "DICKTY, (US slang) proud, snobbish, also DICTY [adj]\n",
  "DICKTIEST": "DICKTY, (US slang) proud, snobbish, also DICTY [adj]\n",
  "DICKTY": "(US slang) proud, snobbish, also DICTY [adj DICKTIER, DICKTIEST]\n",
  "DICKY": "poor in condition [adj DICKIER, DICKIEST] / a false shirt front, also DICKEY, DICKIE [n DICKIES]\n",
  "DICKYBIRD": "a false shirtfront, also DICKEYBIRD [n -S]\n",
  "DICKYBIRDS": "DICKYBIRD, a false shirtfront, also DICKEYBIRD [n]\n",
  "DICLINIES": "DICLINY, the state of having two stamens and pistils, also DICLINISM [n]\n",
  "DICLINISM": "the state of having two stamens and pistils, also DICLINY [n -S]\n",
  "DICLINISMS": "DICLINISM, the state of having two stamens and pistils, also DICLINY [n]\n",
  "DICLINOUS": "having the stamens and pistils in separate flowers [adj]\n",
  "DICLINY": "the state of having two stamens and pistils, also DICLINISM [n DICLINIES]\n",
  "DICOT": "(short for) a dicotyledon, a plant having two cotyledons, seed-leaves, also DICOTYL [n -S]\n",
  "DICOTS": "DICOT, (short for) a dicotyledon, a plant having two cotyledons, seed-leaves, also DICOTYL [n]\n",
  "DICOTYL": "(short for) a dicotyledon, a plant having two cotyledons, seed-leaves, also DICOT [n -S]\n",
  "DICOTYLEDON": "a plant having two cotyledons, seed-leaves, also DICOT [n -S]\n",
  "DICOTYLEDONOUS": "of or like a dicotyledon [adj]\n",
  "DICOTYLEDONS": "DICOTYLEDON, a plant having two cotyledons, seed-leaves, also DICOT [n]\n",
  "DICOTYLS": "DICOTYL, (short for) a dicotyledon, a plant having two cotyledons, seed-leaves, also DICOT [n]\n",
  "DICOUMARIN": "a crystalline compound obtained from sweet clover hay, also DICOUMAROL, DICUMAROL [n -S]\n",
  "DICOUMARINS": "DICOUMARIN, a crystalline compound obtained from sweet clover hay, also DICOUMAROL, DICUMAROL [n]\n",
  "DICOUMAROL": "a crystalline compound obtained from sweet clover hay, also DICOUMARIN, DICUMAROL [n -S]\n",
  "DICOUMAROLS": "DICOUMAROL, a crystalline compound obtained from sweet clover hay, also DICOUMARIN, DICUMAROL [n]\n",
  "DICROTAL": "having a double pulse beat, also DICROTIC [adj]\n",
  "DICROTIC": "having a double pulse beat, also DICROTAL [adj]\n",
  "DICROTISM": "a condition in which there are two beats or waves of the arterial pulse to each beat of the heart [n -S]\n",
  "DICROTISMS": "DICROTISM, a condition in which there are two beats or waves of the arterial pulse to each beat of the heart [n]\n",
  "DICROTOUS": "of or pertaining to dicrotism, a condition in which there are two beats or waves of the arterial pulse to each beat of the heart [adj]\n",
  "DICT": "(obsolete) to dictate, also DICTATE [v -ED, -ING, -S]\n",
  "DICTA": "DICTUM, (Latin) an authoritative statement [n]\n",
  "DICTATE": "to read aloud for recording [v DICTATED, DICTATING, DICTATES]\n",
  "DICTATED": "DICTATE, to read aloud for recording [v]\n",
  "DICTATES": "DICTATE, to read aloud for recording [v]\n",
  "DICTATING": "DICTATE, to read aloud for recording [v]\n",
  "DICTATION": "the act, art or practice of dictating [n -S]\n",
  "DICTATIONAL": "relating to dictation [adj]\n",
  "DICTATIONS": "DICTATION, the act, art or practice of dictating [n]\n",
  "DICTATOR": "one that dictates [n -S]\n",
  "DICTATORIAL": "befitting a dictator [adj DICTATORIALLY]\n",
  "DICTATORIALLY": "DICTATORIAL, befitting a dictator [adv]\n",
  "DICTATORIALNESS": "DICTATORIAL, befitting a dictator [n]\n",
  "DICTATORS": "DICTATOR, one that dictates [n]\n",
  "DICTATORSHIP": "the office of dictator [n -S]\n",
  "DICTATORSHIPS": "DICTATORSHIP, the office of dictator [n]\n",
  "DICTATORY": "dogmatical; overbearing [adj]\n",
  "DICTATRESS": "a female dictator, also DICTATRIX [n -ES]\n",
  "DICTATRESSES": "DICTATRESS, a female dictator, also DICTATRIX [n]\n",
  "DICTATRICES": "DICTATRIX, a female dictator, also DICTATRESS [n]\n",
  "DICTATRIX": "a female dictator, also DICTATRESS [n DICTATRIXES or DICTATRICES]\n",
  "DICTATRIXES": "DICTATRIX, a female dictator, also DICTATRESS [n]\n",
  "DICTATURE": "the office of a dictator [n -S]\n",
  "DICTATURES": "DICTATURE, the office of a dictator [n]\n",
  "DICTED": "DICT, (obsolete) to dictate, also DICTATE [v]\n",
  "DICTIER": "DICTY, (US slang) proud, snobbish, also DICKTY [adj]\n",
  "DICTIEST": "DICTY, (US slang) proud, snobbish, also DICKTY [adj]\n",
  "DICTING": "DICT, (obsolete) to dictate, also DICTATE [v]\n",
  "DICTION": "the manner of enunciation in speaking, singing, etc. [n -S]\n",
  "DICTIONAL": "relating to diction [adj DICTIONALLY]\n",
  "DICTIONALLY": "DICTIONAL, relating to diction [adv]\n",
  "DICTIONARIES": "DICTIONARY, a book containing the words of a language alphabetically arranged, with their meanings, etymology, etc. [n]\n",
  "DICTIONARY": "a book containing the words of a language alphabetically arranged, with their meanings, etymology, etc. [n DICTIONARIES]\n",
  "DICTIONS": "DICTION, the manner of enunciation in speaking, singing, etc. [n]\n",
  "DICTS": "DICT, (obsolete) to dictate, also DICTATE [v]\n",
  "DICTUM": "(Latin) an authoritative statement [n DICTUMS or DICTA]\n",
  "DICTUMS": "DICTUM, (Latin) an authoritative statement [n]\n",
  "DICTY": "(US slang) proud, snobbish, also DICKTY [adj DICTIER, DICTIEST]\n",
  "DICTYOGEN": "a monocotyledon with net-veined leaves [n -S]\n",
  "DICTYOGENS": "DICTYOGEN, a monocotyledon with net-veined leaves [n]\n",
  "DICTYOPTERAN": "any insect of an order including cockroaches and mantises [n -S]\n",
  "DICTYOPTERANS": "DICTYOPTERAN, any insect of an order including cockroaches and mantises [n]\n",
  "DICTYOSOME": "any of the membranous or vesicular structures making up the Golgi apparatus [n -S]\n",
  "DICTYOSOMES": "DICTYOSOME, any of the membranous or vesicular structures making up the Golgi apparatus [n]\n",
  "DICTYOSTELE": "a complex stele with large overlapping leaf-gaps [n -S]\n",
  "DICTYOSTELES": "DICTYOSTELE, a complex stele with large overlapping leaf-gaps [n]\n",
  "DICUMAROL": "a crystalline compound obtained from sweet clover hay, also DICOUMARIN, DICOUMAROL [n -S]\n",
  "DICUMAROLS": "DICUMAROL, a crystalline compound obtained from sweet clover hay, also DICOUMARIN, DICOUMAROL [n]\n",
  "DICYCLIC": "having two maxima of population each year [adj]\n",
  "DICYCLIES": "DICYCLY, the state of being dicyclic, having two whorls or rings [n]\n",
  "DICYCLY": "the state of being dicyclic, having two whorls or rings [n DICYCLIES]\n",
  "DICYNODONT": "a fossil reptile with no teeth except for two in the upper jaw [n -S]\n",
  "DICYNODONTS": "DICYNODONT, a fossil reptile with no teeth except for two in the upper jaw [n]\n",
  "DID": "DO, to perform [v]\n",
  "DIDACT": "a person given to lecturing or moralizing [n -S]\n",
  "DIDACTIC": "designed or intended to teach, also DIDACTICAL [adj DIDACTICALLY]\n",
  "DIDACTICAL": "designed or intended to teach, also DIDACTIC [adj DIDACTICALLY]\n",
  "DIDACTICALLY": "DIDACTICAL, designed or intended to teach, also DIDACTIC [adv]\n",
  "DIDACTICISM": "being didactic [n -S]\n",
  "DIDACTICISMS": "DIDACTICISM, being didactic [n]\n",
  "DIDACTICS": "the art or science of teaching [n]\n",
  "DIDACTS": "DIDACT, a person given to lecturing or moralizing [n]\n",
  "DIDACTYL": "a creature with two toes, fingers or claws [n -S]\n",
  "DIDACTYLISM": "having twelve fingers [n -S]\n",
  "DIDACTYLISMS": "DIDACTYLISM, having twelve fingers [n]\n",
  "DIDACTYLOUS": "having twelve fingers [adj]\n",
  "DIDACTYLS": "DIDACTYL, a creature with two toes, fingers or claws [n]\n",
  "DIDAKAI": "(Romany) an itinerant tinker, also DIDDICOY, DIDAKEI, DIDICOI, DIDICOY [n -S]\n",
  "DIDAKAIS": "DIDAKAI, (Romany) an itinerant tinker, also DIDDICOY, DIDAKEI, DIDICOI, DIDICOY [n]\n",
  "DIDAKEI": "(Romany) an itinerant tinker, also DIDDICOY, DIDAKAI, DIDICOI, DIDICOY [n -S]\n",
  "DIDAKEIS": "DIDAKEI, (Romany) an itinerant tinker, also DIDDICOY, DIDAKAI, DIDICOI, DIDICOY [n]\n",
  "DIDAPPER": "a small grebe, also DOPPER [n -S]\n",
  "DIDAPPERS": "DIDAPPER, a small grebe, also DOPPER [n]\n",
  "DIDASCALIC": "didactic; pertaining to education or teaching [adj]\n",
  "DIDDER": "(dialect) to shake [v -ED, -ING, -S]\n",
  "DIDDERED": "DIDDER, (dialect) to shake [v]\n",
  "DIDDERING": "DIDDER, (dialect) to shake [v]\n",
  "DIDDERS": "DIDDER, (dialect) to shake [v]\n",
  "DIDDICOY": "(Romany) an itinerant tinker, also DIDAKAI, DIDAKEI, DIDICOI, DIDICOY [n -S]\n",
  "DIDDICOYS": "DIDDICOY, (Romany) an itinerant tinker, also DIDAKAI, DIDAKEI, DIDICOI, DIDICOY [n]\n",
  "DIDDIER": "DIDDY, (colloquial) small, tiny [adj]\n",
  "DIDDIES": "DIDDY, a female breast, a nipple or teat [n]\n",
  "DIDDIEST": "DIDDY, (colloquial) small, tiny [adj]\n",
  "DIDDLE": "to cheat, swindle [v DIDDLED, DIDDLING, DIDDLES]\n",
  "DIDDLED": "DIDDLE, to cheat, swindle [v]\n",
  "DIDDLER": "a cheat [n -S]\n",
  "DIDDLERS": "DIDDLER, a cheat [n]\n",
  "DIDDLES": "DIDDLE, to cheat, swindle [v]\n",
  "DIDDLEY": "the least amount, also DIDDLY [n -S]\n",
  "DIDDLEYS": "DIDDLEY, the least amount, also DIDDLY [n]\n",
  "DIDDLIES": "DIDDLY, the least amount, also DIDDLEY [n]\n",
  "DIDDLING": "DIDDLE, to cheat, swindle [v]\n",
  "DIDDLY": "the least amount, also DIDDLEY [n DIDDLIES]\n",
  "DIDDUMS": "an interjection used to express sympathy to a child [interj]\n",
  "DIDDY": "(colloquial) small, tiny [adj DIDDIER, DIDDIEST] / a female breast, a nipple or teat [n DIDDIES]\n",
  "DIDELPHIAN": "of or relating to the marsupial family Didelphia, opossums, also DIDELPHINE, DIDELPHOUS [adj]\n",
  "DIDELPHIC": "having a double womb, like a marsupial [adj]\n",
  "DIDELPHID": "any member of the marsupial family Didelphidae [n -S]\n",
  "DIDELPHIDS": "DIDELPHID, any member of the marsupial family Didelphidae [n]\n",
  "DIDELPHINE": "of or relating to the marsupial family Didelphia, opossums, also DIDELPHIAN, DIDELPHOUS [adj]\n",
  "DIDELPHOUS": "of or relating to the marsupial family Didelphia, opossums, also DIDELPHIAN, DIDELPHINE [adj]\n",
  "DIDGERIDOO": "(Native Australian) a native Australian musical instrument, also DIDJERIDOO, DIDJERIDU [n -S]\n",
  "DIDGERIDOOS": "DIDGERIDOO, (Native Australian) a native Australian musical instrument, also DIDJERIDOO, DIDJERIDU [n]\n",
  "DIDICOI": "(Romany) an itinerant tinker, also DIDDICOY, DIDAKAI, DIDAKEI, DIDICOY [n -S]\n",
  "DIDICOIS": "DIDICOI, (Romany) an itinerant tinker, also DIDDICOY, DIDAKAI, DIDAKEI, DIDICOY [n]\n",
  "DIDICOY": "(Romany) an itinerant tinker, also DIDDICOY, DIDAKAI, DIDAKEI, DIDICOI [n -S]\n",
  "DIDICOYS": "DIDICOY, (Romany) an itinerant tinker, also DIDDICOY, DIDAKAI, DIDAKEI, DIDICOI [n]\n",
  "DIDIE": "a diaper, also DIDY [n -S]\n",
  "DIDIES": "DIDY, a diaper, also DIDIE [n]\n",
  "DIDJERIDOO": "(Native Australian) a native Australian musical instrument, also DIDGERIDOO, DIDJERIDU [n -S]\n",
  "DIDJERIDOOS": "DIDJERIDOO, (Native Australian) a native Australian musical instrument, also DIDGERIDOO, DIDJERIDU [n]\n",
  "DIDJERIDU": "a native Australian musical instrument, also DIDGERIDOO, DIDJERIDOO [n -S]\n",
  "DIDJERIDUS": "DIDJERIDU, a native Australian musical instrument, also DIDGERIDOO, DIDJERIDOO [n]\n",
  "DIDO": "a mischievous act [n DIDOS or DIDOES]\n",
  "DIDOES": "DIDO, a mischievous act [n]\n",
  "DIDOS": "DIDO, a mischievous act [n]\n",
  "DIDRACHM": "(Greek) a two-drachma piece, also DIDRACHMA [n -S]\n",
  "DIDRACHMA": "(Greek) a two-drachma piece, also DIDRACHM [n -S]\n",
  "DIDRACHMAS": "DIDRACHMA, (Greek) a two-drachma piece, also DIDRACHM [n]\n",
  "DIDRACHMS": "DIDRACHM, (Greek) a two-drachma piece, also DIDRACHMA [n]\n",
  "DIDST": "DO, to perform [v]\n",
  "DIDY": "a diaper, also DIDIE [n DIDIES]\n",
  "DIDYMIUM": "a mixture of rare earth elements [n -S]\n",
  "DIDYMIUMS": "DIDYMIUM, a mixture of rare earth elements [n]\n",
  "DIDYMO": "a class of algae [n -S]\n",
  "DIDYMOS": "DIDYMO, a class of algae [n]\n",
  "DIDYMOUS": "occurring in pairs [adj]\n",
  "DIDYNAMIAN": "belonging to the Didynamia, a class of plants in the Linnaean system with two long stamens and two short, also DIDYNAMOUS [adj]\n",
  "DIDYNAMIES": "DIDYNAMY, the state of having four stamens of unequal length [n]\n",
  "DIDYNAMOUS": "belonging to the Didynamia, a class of plants in the Linnaean system with two long stamens and two short, also DIDYNAMIAN [adj]\n",
  "DIDYNAMY": "the state of having four stamens of unequal length [n DIDYNAMIES]\n",
  "DIE": "to cut with a material shaping device [v DIED, DIEING, DIES] / to lose one's life [v DIED, DYING, DIES]\n",
  "DIEB": "(Arabic) a North African jackal [n -S]\n",
  "DIEBACK": "a gradual dying of plant shoots [n -S]\n",
  "DIEBACKS": "DIEBACK, a gradual dying of plant shoots [n]\n",
  "DIEBS": "DIEB, (Arabic) a North African jackal [n]\n",
  "DIECIOUS": "having male and female sexual organs in different individuals, also DIOECIOUS, DIOICOUS [adj DIECIOUSLY]\n",
  "DIECIOUSLY": "DIECIOUS, having male and female sexual organs in different individuals, also DIOECIOUS, DIOICOUS [adv]\n",
  "DIECIOUSNESS": "the state of being diecious [n -ES]\n",
  "DIECIOUSNESSES": "DIECIOUSNESS, the state of being diecious [n]\n",
  "DIED": "DIE, to cut with a material shaping device [v]\n",
  "DIEDRAL": "the angle between two planes, also DIHEDRAL [n -S]\n",
  "DIEDRALS": "DIEDRAL, the angle between two planes, also DIHEDRAL [n]\n",
  "DIEDRE": "(French) a rock angle or reentrant corner, usually with a crack in it [n -S]\n",
  "DIEDRES": "DIEDRE, (French) a rock angle or reentrant corner, usually with a crack in it [n]\n",
  "DIEFFENBACHIA": "any plant of the tropical American araceous genus Dieffenbachia, including the dumbcane [n -S]\n",
  "DIEFFENBACHIAS": "DIEFFENBACHIA, any plant of the tropical American araceous genus Dieffenbachia, including the dumbcane [n]\n",
  "DIEGESES": "DIEGESIS, (Greek) the narration of the facts [n]\n",
  "DIEGESIS": "(Greek) the narration of the facts [n DIEGESES]\n",
  "DIEGETIC": "relating to DIEGESIS, the narration of the facts [adj]\n",
  "DIEHARD": "a stubborn person [n -S]\n",
  "DIEHARDS": "DIEHARD, a stubborn person [n]\n",
  "DIEING": "DIE, to cut with a material shaping device [v]\n",
  "DIEL": "a 24-hour period, in relation to animal behaviour patterns [n -S]\n",
  "DIELDRIN": "a persistent chemical pesticide [n -S]\n",
  "DIELDRINS": "DIELDRIN, a persistent chemical pesticide [n]\n",
  "DIELECTRIC": "nonconducting [adj DIELECTRICALLY] / a substance which does not allow the passage of an electric current through it [n -S]\n",
  "DIELECTRICALLY": "DIELECTRIC, nonconducting [adv]\n",
  "DIELECTRICS": "DIELECTRIC, a substance which does not allow the passage of an electric current through it [n]\n",
  "DIELS": "DIEL, a 24-hour period, in relation to animal behaviour patterns [n]\n",
  "DIELYTRA": "a plant with two broadly pouched outer petals, also DICENTRA [n -S]\n",
  "DIELYTRAS": "DIELYTRA, a plant with two broadly pouched outer petals, also DICENTRA [n]\n",
  "DIEMAKER": "one that makes dies [n -S]\n",
  "DIEMAKERS": "DIEMAKER, one that makes dies [n]\n",
  "DIENCEPHALA": "DIENCEPHALON, the back of the forebrain, connecting the midbrain with the cerebral hemispheres [n]\n",
  "DIENCEPHALIC": "relating to the diencephalon, the back of the forebrain [adj]\n",
  "DIENCEPHALON": "the back of the forebrain, connecting the midbrain with the cerebral hemispheres [n DIENCEPHALA or DIENCEPHALONS]\n",
  "DIENCEPHALONS": "DIENCEPHALON, the back of the forebrain, connecting the midbrain with the cerebral hemispheres [n]\n",
  "DIENE": "an organic compound containing two double bonds between carbon atoms [n -S]\n",
  "DIENES": "DIENE, an organic compound containing two double bonds between carbon atoms [n]\n",
  "DIEOFF": "a dying off of vegetation [n -S]\n",
  "DIEOFFS": "DIEOFF, a dying off of vegetation [n]\n",
  "DIERESES": "DIERESIS, (Greek) the separation of two vowels into two syllables [n]\n",
  "DIERESIS": "(Greek) the separation of two vowels into two syllables [n DIERESES]\n",
  "DIERETIC": "of or like dieresis, the separation of two vowels into two syllables, also DIAERETIC [adj]\n",
  "DIES": "DIE, to cut with a material shaping device [v]\n",
  "DIESEL": "to continue running after ignition is turned off [v -ED, -ING, -S]\n",
  "DIESELED": "DIESEL, to continue running after ignition is turned off [v]\n",
  "DIESELING": "the act of continuing to run after the engine has been turned off [n -S]\n",
  "DIESELINGS": "DIESELING, the act of continuing to run after the engine has been turned off [n]\n",
  "DIESELISATION": "the process of dieselising, also DIESELIZATION [n -S]\n",
  "DIESELISATIONS": "DIESELISATION, the process of dieselising, also DIESELIZATION [n]\n",
  "DIESELISE": "to equip e.g. a train with a diesel engine, also DIESELIZE [v DIESELISED, DIESELISING, DIESELISES]\n",
  "DIESELISED": "DIESELISE, to equip e.g. a train with a diesel engine, also DIESELIZE [v]\n",
  "DIESELISES": "DIESELISE, to equip e.g. a train with a diesel engine, also DIESELIZE [v]\n",
  "DIESELISING": "DIESELISE, to equip e.g. a train with a diesel engine, also DIESELIZE [v]\n",
  "DIESELIZATION": "the process of dieselizing, also DIESELISATION [n -S]\n",
  "DIESELIZATIONS": "DIESELIZATION, the process of dieselizing, also DIESELISATION [n]\n",
  "DIESELIZE": "to equip e.g. a train with a diesel engine, also DIESELISE [v DIESELIZED, DIESELIZING, DIESELIZES]\n",
  "DIESELIZED": "DIESELIZE, to equip e.g. a train with a diesel engine, also DIESELISE [v]\n",
  "DIESELIZES": "DIESELIZE, to equip e.g. a train with a diesel engine, also DIESELISE [v]\n",
  "DIESELIZING": "DIESELIZE, to equip e.g. a train with a diesel engine, also DIESELISE [v]\n",
  "DIESELLING": "running after the engine is switched off, also DIESELING [n -S]\n",
  "DIESELLINGS": "DIESELLING, running after the engine is switched off, also DIESELING [n]\n",
  "DIESELS": "DIESEL, to continue running after ignition is turned off [v]\n",
  "DIESES": "DIESIS, (Greek) a reference mark in printing [n]\n",
  "DIESINKER": "a person who engraves dies [n -S]\n",
  "DIESINKERS": "DIESINKER, a person who engraves dies [n]\n",
  "DIESIS": "(Greek) a reference mark in printing [n DIESES]\n",
  "DIESTER": "a compound that contains two ester groups [n -S]\n",
  "DIESTERS": "DIESTER, a compound that contains two ester groups [n]\n",
  "DIESTOCK": "a stock to hold the dies used for cutting screws [n -S]\n",
  "DIESTOCKS": "DIESTOCK, a stock to hold the dies used for cutting screws [n]\n",
  "DIESTROUS": "in a sexually inactive state following ovulation [adj]\n",
  "DIESTRUM": "a period of sexual inactivity, also DIESTRUS [n -S]\n",
  "DIESTRUMS": "DIESTRUM, a period of sexual inactivity, also DIESTRUS [n]\n",
  "DIESTRUS": "a period of sexual inactivity, also DIESTRUM [n -ES]\n",
  "DIESTRUSES": "DIESTRUS, a period of sexual inactivity, also DIESTRUM [n]\n",
  "DIET": "to regulate food and drink [v -ED, -ING, -S]\n",
  "DIETARIAN": "one who lives in accordance with prescribed rules for diet [n -S]\n",
  "DIETARIANS": "DIETARIAN, one who lives in accordance with prescribed rules for diet [n]\n",
  "DIETARIES": "DIETARY, a diet; a book etc. [n]\n",
  "DIETARILY": "DIETARY, relating to diet [adv]\n",
  "DIETARY": "relating to diet [adj DIETARILY] / a diet; a book etc. [n DIETARIES]\n",
  "DIETED": "DIET, to regulate food and drink [v]\n",
  "DIETER": "one who diets [n -S]\n",
  "DIETERS": "DIETER, one who diets [n]\n",
  "DIETETIC": "pertaining to a diet, also DIETETICAL [adj DIETETICALLY]\n",
  "DIETETICAL": "relating to diet, also DIETETIC [adj DIETETICALLY]\n",
  "DIETETICALLY": "DIETETICAL, relating to diet, also DIETETIC [adv]\n",
  "DIETETICS": "that part of the medical or hygienic art which relates to diet or food [n]\n",
  "DIETHER": "an organic chemical compound that contains two ethers [n -S]\n",
  "DIETHERS": "DIETHER, an organic chemical compound that contains two ethers [n]\n",
  "DIETHYL": "a compound having two ethyl groups [n -S]\n",
  "DIETHYLAMIDE": "as in lysergic acid diethylamide, LSD [n -S]\n",
  "DIETHYLAMIDES": "DIETHYLAMIDE, as in lysergic acid diethylamide, LSD [n]\n",
  "DIETHYLAMINE": "a liquid resembling ethylamine, derived from ammonia, with ethyl groups replacing two hydrogen atoms [n -S]\n",
  "DIETHYLAMINES": "DIETHYLAMINE, a liquid resembling ethylamine, derived from ammonia, with ethyl groups replacing two hydrogen atoms [n]\n",
  "DIETHYLENE": "as in diethylene glycol, a colourless soluble liquid [n -S]\n",
  "DIETHYLENES": "DIETHYLENE, as in diethylene glycol, a colourless soluble liquid [n]\n",
  "DIETHYLS": "DIETHYL, a compound having two ethyl groups [n]\n",
  "DIETICIAN": "an expert on diet, also DIETIST, DIETITIAN [n -S]\n",
  "DIETICIANS": "DIETICIAN, an expert on diet, also DIETIST, DIETITIAN [n]\n",
  "DIETINE": "a minor or local diet, assembly [n -S]\n",
  "DIETINES": "DIETINE, a minor or local diet, assembly [n]\n",
  "DIETING": "the act of dieting [n -S]\n",
  "DIETINGS": "DIETING, the act of dieting [n]\n",
  "DIETIST": "an expert on diet, also DIETICIAN, DIETITIAN [n -S]\n",
  "DIETISTS": "DIETIST, an expert on diet, also DIETICIAN, DIETITIAN [n]\n",
  "DIETITIAN": "an expert on diet, also DIETICIAN, DIETIST [n -S]\n",
  "DIETITIANS": "DIETITIAN, an expert on diet, also DIETICIAN, DIETIST [n]\n",
  "DIETS": "DIET, to regulate food and drink [v]\n",
  "DIEZEUGMENON": "a term in Greek prosody [n -S]\n",
  "DIEZEUGMENONS": "DIEZEUGMENON, a term in Greek prosody [n]\n",
  "DIF": "(colloquial) difference, also DIFF [n -S]\n",
  "DIFF": "(colloquial) difference, also DIF [n -S]\n",
  "DIFFARREATION": "(historical) a Roman form of divorce [n -S]\n",
  "DIFFARREATIONS": "DIFFARREATION, (historical) a Roman form of divorce [n]\n",
  "DIFFER": "to be unlike [v -ED, -ING, -S]\n",
  "DIFFERED": "DIFFER, to be unlike [v]\n",
  "DIFFERENCE": "to make or perceive a difference between or in, also DIFFERENCY [v DIFFERENCED, DIFFERENCING, DIFFERENCES]\n",
  "DIFFERENCED": "DIFFERENCE, to make or perceive a difference between or in, also DIFFERENCY [v]\n",
  "DIFFERENCES": "DIFFERENCE, to make or perceive a difference between or in, also DIFFERENCY [v]\n",
  "DIFFERENCIED": "DIFFERENCY, to make or perceive a difference in, also DIFFERENCE [v]\n",
  "DIFFERENCIES": "DIFFERENCY, to make or perceive a difference in, also DIFFERENCE [v]\n",
  "DIFFERENCING": "DIFFERENCE, to make or perceive a difference between or in, also DIFFERENCY [v]\n",
  "DIFFERENCY": "(archaic) difference [n DIFFERENCIES] / to make or perceive a difference in, also DIFFERENCE [v DIFFERENCIED, DIFFERENCYING, DIFFERENCIES]\n",
  "DIFFERENCYING": "DIFFERENCY, to make or perceive a difference in, also DIFFERENCE [v]\n",
  "DIFFERENT": "separate, unlike [adj DIFFERENTLY]\n",
  "DIFFERENTIA": "a property which distinguishes one from another [n DIFFERENTIAE]\n",
  "DIFFERENTIABLE": "that can be differentiated [adj]\n",
  "DIFFERENTIAE": "DIFFERENTIA, a property which distinguishes one from another [n]\n",
  "DIFFERENTIAL": "relating to a difference [adj DIFFERENTIALLY] / in maths, the product of the derivative of a function of one variable by the increment of the independent variable [n -S]\n",
  "DIFFERENTIALLY": "DIFFERENTIAL, relating to a difference [adv]\n",
  "DIFFERENTIALS": "DIFFERENTIAL, in maths, the product of the derivative of a function of one variable by the increment of the independent variable [n]\n",
  "DIFFERENTIATE": "to obtain the mathematical derivative of [v DIFFERENTIATED, DIFFERENTIATING, DIFFERENTIATES]\n",
  "DIFFERENTIATED": "DIFFERENTIATE, to obtain the mathematical derivative of [v]\n",
  "DIFFERENTIATES": "DIFFERENTIATE, to obtain the mathematical derivative of [v]\n",
  "DIFFERENTIATING": "DIFFERENTIATE, to obtain the mathematical derivative of [v]\n",
  "DIFFERENTIATION": "the act of differentiating [n]\n",
  "DIFFERENTIATOR": "someone who or that which differentiates [n -S]\n",
  "DIFFERENTIATORS": "DIFFERENTIATOR, someone who or that which differentiates [n]\n",
  "DIFFERENTLY": "DIFFERENT, separate, unlike [adv]\n",
  "DIFFERENTNESS": "DIFFERENT, separate, unlike [n]\n",
  "DIFFERENTNESSES": "DIFFERENTNESS, DIFFERENT, separate, unlike [n]\n",
  "DIFFERING": "DIFFER, to be unlike [v]\n",
  "DIFFERS": "DIFFER, to be unlike [v]\n",
  "DIFFICILE": "(French) difficult [adj]\n",
  "DIFFICULT": "not easy, hard to do [adj DIFFICULTLY]\n",
  "DIFFICULTIES": "DIFFICULTY, the state of being difficult [n]\n",
  "DIFFICULTLY": "DIFFICULT, not easy, hard to do [adv]\n",
  "DIFFICULTY": "the state of being difficult [n DIFFICULTIES]\n",
  "DIFFIDENCE": "the state of being diffident [n -S]\n",
  "DIFFIDENCES": "DIFFIDENCE, the state of being diffident [n]\n",
  "DIFFIDENT": "hesitant in acting or speaking [adj DIFFIDENTLY]\n",
  "DIFFIDENTLY": "DIFFIDENT, hesitant in acting or speaking [adv]\n",
  "DIFFLUENT": "readily flowing away [adj]\n",
  "DIFFORM": "(obsolete) unlike, irregular in form [adj]\n",
  "DIFFORMITIES": "DIFFORMITY, irregularity of form [n]\n",
  "DIFFORMITY": "irregularity of form [n DIFFORMITIES]\n",
  "DIFFRACT": "to separate into parts [v -ED, -ING, -S]\n",
  "DIFFRACTED": "DIFFRACT, to separate into parts [v]\n",
  "DIFFRACTING": "DIFFRACT, to separate into parts [v]\n",
  "DIFFRACTION": "a modification which light undergoes esp. in passing by the edges of opaque bodies or through narrow openings and in which the rays appear to be deflected [n -S]\n",
  "DIFFRACTIONS": "DIFFRACTION, a modification which light undergoes esp. in passing by the edges of opaque bodies or through narrow openings and in which the rays appear to be deflected [n]\n",
  "DIFFRACTIVE": "causing diffraction [adj DIFFRACTIVELY]\n",
  "DIFFRACTIVELY": "DIFFRACTIVE, causing diffraction [adv]\n",
  "DIFFRACTIVENESS": "DIFFRACTIVE, causing diffraction [n]\n",
  "DIFFRACTOMETER": "an instrument for determining structure of crystal through light diffraction [n -S]\n",
  "DIFFRACTOMETERS": "DIFFRACTOMETER, an instrument for determining structure of crystal through light diffraction [n]\n",
  "DIFFRACTOMETRIC": "relating to measurement by diffractometer, an instrument for determining structure of crystal through light diffraction [adj]\n",
  "DIFFRACTOMETRY": "measurement by diffractometer [n]\n",
  "DIFFRACTS": "DIFFRACT, to separate into parts [v]\n",
  "DIFFRANGIBILITY": "the state of being diffrangible, capable of being diffracted or separated [n]\n",
  "DIFFRANGIBLE": "capable of being diffracted or separated [adj]\n",
  "DIFFS": "DIFF, (colloquial) difference, also DIF [n]\n",
  "DIFFUSE": "spread wide [adj DIFFUSELY] / to spread widely or thinly [v DIFFUSED, DIFFUSING, DIFFUSES]\n",
  "DIFFUSED": "DIFFUSE, to spread widely or thinly [v]\n",
  "DIFFUSEDLY": "DIFFUSED, DIFFUSE, to spread widely or thinly [adv]\n",
  "DIFFUSEDNESS": "the state of being diffused [n -ES]\n",
  "DIFFUSEDNESSES": "DIFFUSEDNESS, the state of being diffused [n]\n",
  "DIFFUSELY": "DIFFUSE, spread wide [adv]\n",
  "DIFFUSENESS": "the state of being diffuse [n -ES]\n",
  "DIFFUSENESSES": "DIFFUSENESS, the state of being diffuse [n]\n",
  "DIFFUSER": "one that diffuses, also DIFFUSOR [n -S]\n",
  "DIFFUSERS": "DIFFUSER, one that diffuses, also DIFFUSOR [n]\n",
  "DIFFUSES": "DIFFUSE, to spread widely or thinly [v]\n",
  "DIFFUSIBILITIES": "DIFFUSIBILITY, the state of being diffusible [n]\n",
  "DIFFUSIBILITY": "the state of being diffusible [n DIFFUSIBILITIES]\n",
  "DIFFUSIBLE": "capable of being diffused [adj]\n",
  "DIFFUSIBLENESS": "the state of being diffusible [n]\n",
  "DIFFUSING": "DIFFUSE, to spread widely or thinly [v]\n",
  "DIFFUSION": "the spread of ideas, disease, technology, etc. [n -S]\n",
  "DIFFUSIONAL": "relating to diffusion [adj]\n",
  "DIFFUSIONISM": "the theory that diffusion is mainly responsible for cultural similarities [n -S]\n",
  "DIFFUSIONISMS": "DIFFUSIONISM, the theory that diffusion is mainly responsible for cultural similarities [n]\n",
  "DIFFUSIONIST": "an anthropologist who emphasizes the role of diffusion in the history of culture rather than independent invention or discovery [n -S]\n",
  "DIFFUSIONISTS": "DIFFUSIONIST, an anthropologist who emphasizes the role of diffusion in the history of culture rather than independent invention or discovery [n]\n",
  "DIFFUSIONS": "DIFFUSION, the spread of ideas, disease, technology, etc. [n]\n",
  "DIFFUSIVE": "having the quality of diffusing [adj DIFFUSIVELY]\n",
  "DIFFUSIVELY": "DIFFUSIVE, having the quality of diffusing [adv]\n",
  "DIFFUSIVENESS": "the state of being diffusive [n -ES]\n",
  "DIFFUSIVENESSES": "DIFFUSIVENESS, the state of being diffusive [n]\n",
  "DIFFUSIVITIES": "DIFFUSIVITY, the state of being diffusive [n]\n",
  "DIFFUSIVITY": "the state of being diffusive [n DIFFUSIVITIES]\n",
  "DIFFUSOR": "one that diffuses, also DIFFUSER [n -S]\n",
  "DIFFUSORS": "DIFFUSOR, one that diffuses, also DIFFUSER [n]\n",
  "DIFS": "DIF, (colloquial) difference, also DIFF [n]\n",
  "DIFUNCTIONAL": "a compound with two highly reactive sites in each molecule [n -S]\n",
  "DIFUNCTIONALS": "DIFUNCTIONAL, a compound with two highly reactive sites in each molecule [n]\n",
  "DIG": "to make a hole, excavate [v DUG or DIGGED, DIGGING, DIGS]\n",
  "DIGAMIES": "DIGAMY, a second legal marriage [n]\n",
  "DIGAMIST": "one who marries for the second time [n -S]\n",
  "DIGAMISTS": "DIGAMIST, one who marries for the second time [n]\n",
  "DIGAMMA": "(Greek) a letter of the Greek alphabet, which early fell into disuse [n -S]\n",
  "DIGAMMAS": "DIGAMMA, (Greek) a letter of the Greek alphabet, which early fell into disuse [n]\n",
  "DIGAMOUS": "pertaining to a second marriage, that is, one after the death of the first wife or the first husband [adj]\n",
  "DIGAMY": "a second legal marriage [n DIGAMIES]\n",
  "DIGASTRIC": "fleshy at each end [adj] / a muscle of the lower jaw [n -S]\n",
  "DIGASTRICS": "DIGASTRIC, a muscle of the lower jaw [n]\n",
  "DIGENESES": "DIGENESIS, the ability to alternate sexual and asexual means of reproduction [n]\n",
  "DIGENESIS": "the ability to alternate sexual and asexual means of reproduction [n DIGENESES]\n",
  "DIGENETIC": "of or relating to a subclass of trematode worms [adj]\n",
  "DIGERATI": "the elite who make money by internet related commerce [n]\n",
  "DIGEST": "to assimilate food in the stomach, also DISGEST [v -ED, -ING, -S]\n",
  "DIGESTANT": "serving to digest, also DIGESTIVE [n -S]\n",
  "DIGESTANTS": "DIGESTANT, serving to digest, also DIGESTIVE [n]\n",
  "DIGESTED": "DIGEST, to assimilate food in the stomach, also DISGEST [v]\n",
  "DIGESTEDLY": "(obsolete) in neat order [adv]\n",
  "DIGESTER": "an apparatus which softens substances, also DIGESTOR [n -S]\n",
  "DIGESTERS": "DIGESTER, an apparatus which softens substances, also DIGESTOR [n]\n",
  "DIGESTIBILITIES": "DIGESTIBILITY, the fitness of something for digestion [n]\n",
  "DIGESTIBILITY": "the fitness of something for digestion [n DIGESTIBILITIES]\n",
  "DIGESTIBLE": "that can be digested [adj DIGESTIBLY]\n",
  "DIGESTIBLENESS": "the state of being digestible [n]\n",
  "DIGESTIBLY": "DIGESTIBLE, that can be digested [adv]\n",
  "DIGESTIF": "an alcoholic drink taken after a meal [n -S]\n",
  "DIGESTIFS": "DIGESTIF, an alcoholic drink taken after a meal [n]\n",
  "DIGESTING": "DIGEST, to assimilate food in the stomach, also DISGEST [v]\n",
  "DIGESTION": "the act of digesting [n -S]\n",
  "DIGESTIONAL": "relating to digestion [adj]\n",
  "DIGESTIONS": "DIGESTION, the act of digesting [n]\n",
  "DIGESTIVE": "related to digestion, also DIGESTANT [adj DIGESTIVELY] / something which promotes digestion [n -S]\n",
  "DIGESTIVELY": "DIGESTIVE, related to digestion, also DIGESTANT [adv]\n",
  "DIGESTIVES": "DIGESTIVE, something which promotes digestion [n]\n",
  "DIGESTOR": "an apparatus which softens substances, also DIGESTER [n -S]\n",
  "DIGESTORS": "DIGESTOR, an apparatus which softens substances, also DIGESTER [n]\n",
  "DIGESTS": "DIGEST, to assimilate food in the stomach, also DISGEST [v]\n",
  "DIGGABLE": "able to be dug [adj]\n",
  "DIGGED": "DIG, to make a hole, excavate [v]\n",
  "DIGGER": "one who or something that digs [n -S]\n",
  "DIGGERS": "DIGGER, one who or something that digs [n]\n",
  "DIGGING": "an excavation [n -S]\n",
  "DIGGINGS": "DIGGING, an excavation [n]\n",
  "DIGHT": "to adorn, to prepare for action [v -ED, -ING, -S]\n",
  "DIGHTED": "DIGHT, to adorn, to prepare for action [v]\n",
  "DIGHTING": "DIGHT, to adorn, to prepare for action [v]\n",
  "DIGHTS": "DIGHT, to adorn, to prepare for action [v]\n",
  "DIGICAM": "a digital camera [n -S]\n",
  "DIGICAMS": "DIGICAM, a digital camera [n]\n",
  "DIGIPACK": "a storage case for a CD or DVD with a paperboard outer binding [n -S]\n",
  "DIGIPACKS": "DIGIPACK, a storage case for a CD or DVD with a paperboard outer binding [n]\n",
  "DIGIT": "a finger or a toe [n -S]\n",
  "DIGITAL": "relating to digits [adj DIGITALLY] / a piano key [n -S]\n",
  "DIGITALIN": "a drug extracted from foxglove, used for heart complaints [n -S]\n",
  "DIGITALINS": "DIGITALIN, a drug extracted from foxglove, used for heart complaints [n]\n",
  "DIGITALIS": "any plant of the foxglove genus [n -ES]\n",
  "DIGITALISATION": "the act of digitalising, also DIGITALIZATION [n -S]\n",
  "DIGITALISATIONS": "DIGITALISATION, the act of digitalising, also DIGITALIZATION [n]\n",
  "DIGITALISE": "to make digital, also DIGITALIZE [v DIGITALISED, DIGITALISING, DIGITALISES]\n",
  "DIGITALISED": "DIGITALISE, to make digital, also DIGITALIZE [v]\n",
  "DIGITALISES": "DIGITALISE, to make digital, also DIGITALIZE [v]\n",
  "DIGITALISING": "DIGITALISE, to make digital, also DIGITALIZE [v]\n",
  "DIGITALISM": "a serious condition resulting from digitalis poisoning, characterized by nausea, vomiting, and a disturbance in heart rhythm or rate [n -S]\n",
  "DIGITALISMS": "DIGITALISM, a serious condition resulting from digitalis poisoning, characterized by nausea, vomiting, and a disturbance in heart rhythm or rate [n]\n",
  "DIGITALIZATION": "the act of digitalizing, also DIGITALISATION [n -S]\n",
  "DIGITALIZATIONS": "DIGITALIZATION, the act of digitalizing, also DIGITALISATION [n]\n",
  "DIGITALIZE": "to make digital, also DIGITALISE [v DIGITALIZED, DIGITALIZING, DIGITALIZES]\n",
  "DIGITALIZED": "DIGITALIZE, to make digital, also DIGITALISE [v]\n",
  "DIGITALIZES": "DIGITALIZE, to make digital, also DIGITALISE [v]\n",
  "DIGITALIZING": "DIGITALIZE, to make digital, also DIGITALISE [v]\n",
  "DIGITALLY": "DIGITAL, relating to digits [adv]\n",
  "DIGITALS": "DIGITAL, a piano key [n]\n",
  "DIGITATE": "of a leaf, divided into fingerlike parts, also DIGITATED [adj DIGITATELY]\n",
  "DIGITATED": "of a leaf, divided into fingerlike parts, also DIGITATE [adj]\n",
  "DIGITATELY": "DIGITATE, of a leaf, divided into fingerlike parts, also DIGITATED [adv]\n",
  "DIGITATION": "a division into fingers or fingerlike processes [n -S]\n",
  "DIGITATIONS": "DIGITATION, a division into fingers or fingerlike processes [n]\n",
  "DIGITIFORM": "shaped like a finger [adj]\n",
  "DIGITIGRADE": "an animal that walks on the toes alone [n -S]\n",
  "DIGITIGRADES": "DIGITIGRADE, an animal that walks on the toes alone [n]\n",
  "DIGITISATION": "the process of making digital, also DIGITIZATION [n -S]\n",
  "DIGITISATIONS": "DIGITISATION, the process of making digital, also DIGITIZATION [n]\n",
  "DIGITISE": "to put into digital form, also DIGITIZE [v DIGITISED, DIGITISING, DIGITISES]\n",
  "DIGITISED": "DIGITISE, to put into digital form, also DIGITIZE [v]\n",
  "DIGITISER": "a device that converts analogue signals etc. to digital ones, also DIGITIZER [n -S]\n",
  "DIGITISERS": "DIGITISER, a device that converts analogue signals etc. to digital ones, also DIGITIZER [n]\n",
  "DIGITISES": "DIGITISE, to put into digital form, also DIGITIZE [v]\n",
  "DIGITISING": "DIGITISE, to put into digital form, also DIGITIZE [v]\n",
  "DIGITIZATION": "the process of making digital, also DIGITISATION [n -S]\n",
  "DIGITIZATIONS": "DIGITIZATION, the process of making digital, also DIGITISATION [n]\n",
  "DIGITIZE": "to put into digital form, also DIGITISE [v DIGITIZED, DIGITIZING, DIGITIZES]\n",
  "DIGITIZED": "DIGITIZE, to put into digital form, also DIGITISE [v]\n",
  "DIGITIZER": "a device that converts analogue signals etc. to digital ones, also DIGITISER [n -S]\n",
  "DIGITIZERS": "DIGITIZER, a device that converts analogue signals etc. to digital ones, also DIGITISER [n]\n",
  "DIGITIZES": "DIGITIZE, to put into digital form, also DIGITISE [v]\n",
  "DIGITIZING": "DIGITIZE, to put into digital form, also DIGITISE [v]\n",
  "DIGITONIN": "a steroid saponin occurring in the leaves and seeds of foxglove [n -S]\n",
  "DIGITONINS": "DIGITONIN, a steroid saponin occurring in the leaves and seeds of foxglove [n]\n",
  "DIGITORIUM": "(Latin) a silent piano for practicing [n -S]\n",
  "DIGITORIUMS": "DIGITORIUM, (Latin) a silent piano for practicing [n]\n",
  "DIGITOXIGENIN": "a steroid lactone obtained esp. by hydrolysis of digitoxin [n -S]\n",
  "DIGITOXIGENINS": "DIGITOXIGENIN, a steroid lactone obtained esp. by hydrolysis of digitoxin [n]\n",
  "DIGITOXIN": "a poisonous glycoside that is the most active ingredient of digitalin [n -S]\n",
  "DIGITOXINS": "DIGITOXIN, a poisonous glycoside that is the most active ingredient of digitalin [n]\n",
  "DIGITRON": "(tradename) a type of tube for displaying information which can be lit by a low discharge [n -S]\n",
  "DIGITRONS": "DIGITRON, (tradename) a type of tube for displaying information which can be lit by a low discharge [n]\n",
  "DIGITS": "DIGIT, a finger or a toe [n]\n",
  "DIGITULE": "any small fingerlike process [n -S]\n",
  "DIGITULES": "DIGITULE, any small fingerlike process [n]\n",
  "DIGLADIATE": "(obsolete) to fight with swords; to fence [v DIGLADIATED, DIGLADIATING, DIGLADIATES]\n",
  "DIGLADIATED": "DIGLADIATE, (obsolete) to fight with swords; to fence [v]\n",
  "DIGLADIATES": "DIGLADIATE, (obsolete) to fight with swords; to fence [v]\n",
  "DIGLADIATING": "DIGLADIATE, (obsolete) to fight with swords; to fence [v]\n",
  "DIGLADIATION": "a fight, a dispute [n -S]\n",
  "DIGLADIATIONS": "DIGLADIATION, a fight, a dispute [n]\n",
  "DIGLADIATOR": "one who fights with swords [n -S]\n",
  "DIGLADIATORS": "DIGLADIATOR, one who fights with swords [n]\n",
  "DIGLOSSIA": "the coexistence of a prestige language and a lower language [n -S]\n",
  "DIGLOSSIAS": "DIGLOSSIA, the coexistence of a prestige language and a lower language [n]\n",
  "DIGLOSSIC": "relating to diglossia, the coexistence of a prestige language and a lower language [adj]\n",
  "DIGLOT": "(Greek) a bilingual book [n -S]\n",
  "DIGLOTS": "DIGLOT, (Greek) a bilingual book [n]\n",
  "DIGLOTTIC": "relating to a diglot, a bilingual person [adj]\n",
  "DIGLYCERIDE": "an ester formed from glycerol [n -S]\n",
  "DIGLYCERIDES": "DIGLYCERIDE, an ester formed from glycerol [n]\n",
  "DIGLYPH": "an architectural decorative double groove [n -S]\n",
  "DIGLYPHS": "DIGLYPH, an architectural decorative double groove [n]\n",
  "DIGNIFICATION": "the act of dignifying [n -S]\n",
  "DIGNIFICATIONS": "DIGNIFICATION, the act of dignifying [n]\n",
  "DIGNIFIED": "DIGNIFY, to add dignity to [v]\n",
  "DIGNIFIEDLY": "DIGNIFIED, DIGNIFY, to add dignity to [adv]\n",
  "DIGNIFIEDNESS": "the state of being dignified [n -ES]\n",
  "DIGNIFIEDNESSES": "DIGNIFIEDNESS, the state of being dignified [n]\n",
  "DIGNIFIES": "DIGNIFY, to add dignity to [v]\n",
  "DIGNIFY": "to add dignity to [v DIGNIFIED, DIGNIFYING, DIGNIFIES]\n",
  "DIGNIFYING": "DIGNIFY, to add dignity to [v]\n",
  "DIGNITARIES": "DIGNITARY, someone in a high position or rank, esp. in the church [n]\n",
  "DIGNITARY": "someone in a high position or rank, esp. in the church [n DIGNITARIES]\n",
  "DIGNITIES": "DIGNITY, the state of being dignified [n]\n",
  "DIGNITY": "the state of being dignified [n DIGNITIES]\n",
  "DIGONAL": "of symmetry about an axis, such that a half-turn (180 degrees) gives the same figure [adj]\n",
  "DIGONEUTIC": "breeding twice a year [adj]\n",
  "DIGONEUTISM": "the state of being digoneutic, producing offspring twice yearly [n -S]\n",
  "DIGONEUTISMS": "DIGONEUTISM, the state of being digoneutic, producing offspring twice yearly [n]\n",
  "DIGOXIN": "a drug to improve heart function [n -S]\n",
  "DIGOXINS": "DIGOXIN, a drug to improve heart function [n]\n",
  "DIGRAPH": "a pair of letters representing a single speech sound [n -S]\n",
  "DIGRAPHIC": "of or pertaining to a digraph, two letters expressing a single sound [adj DIGRAPHICALLY]\n",
  "DIGRAPHICALLY": "DIGRAPHIC, of or pertaining to a digraph, two letters expressing a single sound [adv]\n",
  "DIGRAPHS": "DIGRAPH, a pair of letters representing a single speech sound [n]\n",
  "DIGRESS": "to stray from the main topic [v -ED, -ING, -ES]\n",
  "DIGRESSED": "DIGRESS, to stray from the main topic [v]\n",
  "DIGRESSER": "one who digresses [n -S]\n",
  "DIGRESSERS": "DIGRESSER, one who digresses [n]\n",
  "DIGRESSES": "DIGRESS, to stray from the main topic [v]\n",
  "DIGRESSING": "DIGRESS, to stray from the main topic [v]\n",
  "DIGRESSION": "the act of digressing [n -S]\n",
  "DIGRESSIONAL": "relating to digression [adj]\n",
  "DIGRESSIONARY": "relating to digression [adj]\n",
  "DIGRESSIONS": "DIGRESSION, the act of digressing [n]\n",
  "DIGRESSIVE": "characterized by digressions [adj DIGRESSIVELY]\n",
  "DIGRESSIVELY": "DIGRESSIVE, characterized by digressions [adv]\n",
  "DIGRESSIVENESS": "DIGRESSIVE, characterized by digressions [n]\n",
  "DIGS": "DIG, to make a hole, excavate [v]\n",
  "DIGYNIAN": "of or pertaining to the Digynia; having two styles, also DIGYNOUS [adj]\n",
  "DIGYNOUS": "of or pertaining to the Digynia; having two styles, also DIGYNIAN [adj]\n",
  "DIHEDRA": "DIHEDRON, a flattened double pyramid [n]\n",
  "DIHEDRAL": "the angle between two planes, also DIEDRAL [n -S]\n",
  "DIHEDRALS": "DIHEDRAL, the angle between two planes, also DIEDRAL [n]\n",
  "DIHEDRON": "a flattened double pyramid [n DIHEDRONS or DIHEDRA]\n",
  "DIHEDRONS": "DIHEDRON, a flattened double pyramid [n]\n",
  "DIHYBRID": "the child of parents with differing genes [n -S]\n",
  "DIHYBRIDISM": "the state of being a dihybrid [n -S]\n",
  "DIHYBRIDISMS": "DIHYBRIDISM, the state of being a dihybrid [n]\n",
  "DIHYBRIDS": "DIHYBRID, the child of parents with differing genes [n]\n",
  "DIHYDRIC": "containing two hydroxyl radicals [adj]\n",
  "DIHYDROCODEINE": "a synthetic drug similar to codeine, used as an analgesic, an antidiarrhoeal, and to relieve coughing [n -S]\n",
  "DIHYDROCODEINES": "DIHYDROCODEINE, a synthetic drug similar to codeine, used as an analgesic, an antidiarrhoeal, and to relieve coughing [n]\n",
  "DIHYDROGEN": "containing two atoms of hydrogen [adj]\n",
  "DIJUDICATE": "to judge, to decide [v DIJUDICATED, DIJUDICATING, DIJUDICATES]\n",
  "DIJUDICATED": "DIJUDICATE, to judge, to decide [v]\n",
  "DIJUDICATES": "DIJUDICATE, to judge, to decide [v]\n",
  "DIJUDICATING": "DIJUDICATE, to judge, to decide [v]\n",
  "DIJUDICATION": "a judgment [n -S]\n",
  "DIJUDICATIONS": "DIJUDICATION, a judgment [n]\n",
  "DIKA": "the wild mango, a West African tree [n -S]\n",
  "DIKAS": "DIKA, the wild mango, a West African tree [n]\n",
  "DIKAST": "(historical) one of the 6000 Athenians chosen annually to act as judges, also DICAST [n -S]\n",
  "DIKASTS": "DIKAST, (historical) one of the 6000 Athenians chosen annually to act as judges, also DICAST [n]\n",
  "DIKDIK": "a small East African antelope of the genus Madoqua [n -S]\n",
  "DIKDIKS": "DIKDIK, a small East African antelope of the genus Madoqua [n]\n",
  "DIKE": "to furnish with an embankment, also DYKE [v DIKED, DIKING, DIKES]\n",
  "DIKED": "DIKE, to furnish with an embankment, also DYKE [v]\n",
  "DIKER": "a person who makes dikes [n -S]\n",
  "DIKERS": "DIKER, a person who makes dikes [n]\n",
  "DIKES": "DIKE, to furnish with an embankment, also DYKE [v]\n",
  "DIKETONE": "a compound used in dye manufacture [n -S]\n",
  "DIKETONES": "DIKETONE, a compound used in dye manufacture [n]\n",
  "DIKEY": "(offensive colloquial) like a lesbian, also DYKEY [adj DIKIER, DIKIEST]\n",
  "DIKIER": "DIKEY, (offensive colloquial) like a lesbian, also DYKEY [adj]\n",
  "DIKIEST": "DIKEY, (offensive colloquial) like a lesbian, also DYKEY [adj]\n",
  "DIKING": "DIKE, to furnish with an embankment, also DYKE [v]\n",
  "DIKKOP": "(South African) the stone curlew [n -S]\n",
  "DIKKOPS": "DIKKOP, (South African) the stone curlew [n]\n",
  "DIKTAT": "(German) a harsh settlement imposed on a defeated nation [n -S]\n",
  "DIKTATS": "DIKTAT, (German) a harsh settlement imposed on a defeated nation [n]\n",
  "DILACERATE": "to rend or tear asunder [v DILACERATED, DILACERATING, DILACERATES]\n",
  "DILACERATED": "DILACERATE, to rend or tear asunder [v]\n",
  "DILACERATES": "DILACERATE, to rend or tear asunder [v]\n",
  "DILACERATING": "DILACERATE, to rend or tear asunder [v]\n",
  "DILACERATION": "a bend in a tooth resulting from an injury during its growth causing it to grow at an angle [n -S]\n",
  "DILACERATIONS": "DILACERATION, a bend in a tooth resulting from an injury during its growth causing it to grow at an angle [n]\n",
  "DILAPIDATE": "to bring into a condition of decay or partial ruin [v DILAPIDATED, DILAPIDATING, DILAPIDATES]\n",
  "DILAPIDATED": "DILAPIDATE, to bring into a condition of decay or partial ruin [v]\n",
  "DILAPIDATES": "DILAPIDATE, to bring into a condition of decay or partial ruin [v]\n",
  "DILAPIDATING": "DILAPIDATE, to bring into a condition of decay or partial ruin [v]\n",
  "DILAPIDATION": "the state of being dilapidated [n -S]\n",
  "DILAPIDATIONS": "DILAPIDATION, the state of being dilapidated [n]\n",
  "DILAPIDATOR": "an agent that dilapidates [n -S]\n",
  "DILAPIDATORS": "DILAPIDATOR, an agent that dilapidates [n]\n",
  "DILATABILITIES": "DILATABILITY, the state of being dilatable [n]\n",
  "DILATABILITY": "the state of being dilatable [n DILATABILITIES]\n",
  "DILATABLE": "capable of being dilated [adj DILATABLY]\n",
  "DILATABLENESS": "DILATABLE, capable of being dilated [n]\n",
  "DILATABLENESSES": "DILATABLENESS, DILATABLE, capable of being dilated [n]\n",
  "DILATABLY": "DILATABLE, capable of being dilated [adv]\n",
  "DILATANCIES": "DILATANCY, the property of increasing in volume when subjected to pressure or deformed [n]\n",
  "DILATANCY": "the property of increasing in volume when subjected to pressure or deformed [n DILATANCIES]\n",
  "DILATANT": "something that enlarges, also DILATER [n -S]\n",
  "DILATANTS": "DILATANT, something that enlarges, also DILATER [n]\n",
  "DILATATE": "dilated [adj]\n",
  "DILATATION": "prolixity; diffuse discourse [n -S]\n",
  "DILATATIONAL": "relating to dilatation [adj]\n",
  "DILATATIONS": "DILATATION, prolixity; diffuse discourse [n]\n",
  "DILATATOR": "a muscle which dilates any part [n -S]\n",
  "DILATATORS": "DILATATOR, a muscle which dilates any part [n]\n",
  "DILATE": "to make wider or larger [v DILATED, DILATING, DILATES]\n",
  "DILATED": "DILATE, to make wider or larger [v]\n",
  "DILATER": "something that enlarges, also DILATANT [n -S]\n",
  "DILATERS": "DILATER, something that enlarges, also DILATANT [n]\n",
  "DILATES": "DILATE, to make wider or larger [v]\n",
  "DILATING": "DILATE, to make wider or larger [v]\n",
  "DILATION": "the act of dilating [n -S]\n",
  "DILATIONS": "DILATION, the act of dilating [n]\n",
  "DILATIVE": "tending to dilate [adj]\n",
  "DILATOMETER": "an instrument for measuring expansion [n -S]\n",
  "DILATOMETERS": "DILATOMETER, an instrument for measuring expansion [n]\n",
  "DILATOMETRIC": "relating to measurement by dilatometer, an instrument for measuring expansion [adj]\n",
  "DILATOMETRIES": "DILATOMETRY, measurement by dilatometer [n]\n",
  "DILATOMETRY": "measurement by dilatometer [n DILATOMETRIES]\n",
  "DILATOR": "something that dilates, also DILATER [n -S]\n",
  "DILATORILY": "DILATORY, given to delay or procrastination [adv]\n",
  "DILATORINESS": "the state of being dilatory [n -ES]\n",
  "DILATORINESSES": "DILATORINESS, the state of being dilatory [n]\n",
  "DILATORS": "DILATOR, something that dilates, also DILATER [n]\n",
  "DILATORY": "given to delay or procrastination [adj DILATORILY]\n",
  "DILDO": "an object used as a penis substitute, also DILDOE [n -S]\n",
  "DILDOE": "an object used as a penis substitute, also DILDO [n -S]\n",
  "DILDOES": "DILDOE, an object used as a penis substitute, also DILDO [n]\n",
  "DILDOS": "DILDO, an object used as a penis substitute, also DILDOE [n]\n",
  "DILEMMA": "a position where each of two alternative courses (or of all the feasible courses) is eminently undesirable [n -S]\n",
  "DILEMMAS": "DILEMMA, a position where each of two alternative courses (or of all the feasible courses) is eminently undesirable [n]\n",
  "DILEMMATIC": "relating to a dilemma [adj]\n",
  "DILEMMIC": "relating to a dilemma [adj]\n",
  "DILETTANTE": "(Italian) a dabbler or lover of fine arts [n DILETTANTI or DILETTANTES]\n",
  "DILETTANTEISH": "somewhat like a dilettante, also DILETTANTISH [adj]\n",
  "DILETTANTEISM": "the state of being a dilettante, also DILETTANTISM [n -S]\n",
  "DILETTANTEISMS": "DILETTANTEISM, the state of being a dilettante, also DILETTANTISM [n]\n",
  "DILETTANTES": "DILETTANTE, (Italian) a dabbler or lover of fine arts [n]\n",
  "DILETTANTI": "DILETTANTE, (Italian) a dabbler or lover of fine arts [n]\n",
  "DILETTANTISH": "somewhat like a dilettante, also DILETTANTEISH [adj]\n",
  "DILETTANTISM": "the state of being a dilettante, also DILETTANTEISM [n -S]\n",
  "DILETTANTISMS": "DILETTANTISM, the state of being a dilettante, also DILETTANTEISM [n]\n",
  "DILIGENCE": "a French or continental stagecoach [n -S]\n",
  "DILIGENCES": "DILIGENCE, a French or continental stagecoach [n]\n",
  "DILIGENT": "persevering [adj DILIGENTLY]\n",
  "DILIGENTLY": "DILIGENT, persevering [adv]\n",
  "DILL": "an umbelliferous herb related to parsnip, the fruits of which are used in condiments [n -S]\n",
  "DILLED": "flavoured with dill [adj]\n",
  "DILLI": "(Native Australian) a dilly-bag, an Australian aboriginal bag made of woven grass or fibre [n -S]\n",
  "DILLIER": "DILLY, very pleasing [adj]\n",
  "DILLIES": "DILLY, a small bag, also DILLI [n]\n",
  "DILLIEST": "DILLY, very pleasing [adj]\n",
  "DILLING": "a darling; the youngest child; the weakest of a litter [n -S]\n",
  "DILLINGS": "DILLING, a darling; the youngest child; the weakest of a litter [n]\n",
  "DILLIS": "DILLI, (Native Australian) a dilly-bag, an Australian aboriginal bag made of woven grass or fibre [n]\n",
  "DILLS": "DILL, an umbelliferous herb related to parsnip, the fruits of which are used in condiments [n]\n",
  "DILLWEED": "the leaves of the dill plant [n -S]\n",
  "DILLWEEDS": "DILLWEED, the leaves of the dill plant [n]\n",
  "DILLY": "a small bag, also DILLI [n DILLIES] / very pleasing [adj DILLIER, DILLIEST]\n",
  "DILLYDALLIED": "DILLYDALLY, to loiter or trifle [v]\n",
  "DILLYDALLIES": "DILLYDALLY, to loiter or trifle [v]\n",
  "DILLYDALLY": "to loiter or trifle [v DILLYDALLIED, DILLYDALLYING, DILLYDALLIES]\n",
  "DILLYDALLYING": "DILLYDALLY, to loiter or trifle [v]\n",
  "DILSCOOP": "in cricket, an attacking shot that lifts the ball over the wicketkeeper's head [n -S]\n",
  "DILSCOOPS": "DILSCOOP, in cricket, an attacking shot that lifts the ball over the wicketkeeper's head [n]\n",
  "DILTIAZEM": "a drug used to treat angina [n -S]\n",
  "DILTIAZEMS": "DILTIAZEM, a drug used to treat angina [n]\n",
  "DILUCIDATE": "(obsolete) to elucidate [v DILUCIDATED, DILUCIDATING, DILUCIDATES]\n",
  "DILUCIDATED": "DILUCIDATE, (obsolete) to elucidate [v]\n",
  "DILUCIDATES": "DILUCIDATE, (obsolete) to elucidate [v]\n",
  "DILUCIDATING": "DILUCIDATE, (obsolete) to elucidate [v]\n",
  "DILUCIDATION": "the act of dilucidating [n -S]\n",
  "DILUCIDATIONS": "DILUCIDATION, the act of dilucidating [n]\n",
  "DILUENT": "a diluting substance [n -S]\n",
  "DILUENTS": "DILUENT, a diluting substance [n]\n",
  "DILUTABLE": "that can be diluted [adj] / something that can diluted [n -S]\n",
  "DILUTABLES": "DILUTABLE, something that can diluted [n]\n",
  "DILUTE": "to make thinner [v DILUTED, DILUTING, DILUTES]\n",
  "DILUTED": "DILUTE, to make thinner [v]\n",
  "DILUTEE": "an unskilled worker employed in a skilled area [n -S]\n",
  "DILUTEES": "DILUTEE, an unskilled worker employed in a skilled area [n]\n",
  "DILUTENESS": "the state of being dilute [n -ES]\n",
  "DILUTENESSES": "DILUTENESS, the state of being dilute [n]\n",
  "DILUTER": "someone who or something that dilutes, also DILUTOR [n -S]\n",
  "DILUTERS": "DILUTER, someone who or something that dilutes, also DILUTOR [n]\n",
  "DILUTES": "DILUTE, to make thinner [v]\n",
  "DILUTING": "DILUTE, to make thinner [v]\n",
  "DILUTION": "the act of diluting [n -S]\n",
  "DILUTIONARY": "tending to dilute [adj]\n",
  "DILUTIONS": "DILUTION, the act of diluting [n]\n",
  "DILUTIVE": "tending to dilute [adj]\n",
  "DILUTOR": "one that dilutes, also DILUTER [n -S]\n",
  "DILUTORS": "DILUTOR, one that dilutes, also DILUTER [n]\n",
  "DILUVIA": "DILUVIUM, (Latin) a deposit of superficial loam, sand, gravel, stones, etc. caused by former action of flowing waters, or the melting of glacial ice, also DILUVION [n]\n",
  "DILUVIAL": "pertaining to a flood, also DILUVIAN [adj]\n",
  "DILUVIALISM": "a belief in Noah's flood [n -S]\n",
  "DILUVIALISMS": "DILUVIALISM, a belief in Noah's flood [n]\n",
  "DILUVIALIST": "one who believes in Noah's flood [n -S]\n",
  "DILUVIALISTS": "DILUVIALIST, one who believes in Noah's flood [n]\n",
  "DILUVIAN": "pertaining to a flood, also DILUVIAL [adj]\n",
  "DILUVION": "a deposit of superficial loam, sand, gravel, stones, etc., caused by former action of flowing waters, or the melting of glacial ice, also DILUVIUM [n -S]\n",
  "DILUVIONS": "DILUVION, a deposit of superficial loam, sand, gravel, stones, etc., caused by former action of flowing waters, or the melting of glacial ice, also DILUVIUM [n]\n",
  "DILUVIUM": "(Latin) a deposit of superficial loam, sand, gravel, stones, etc. caused by former action of flowing waters, or the melting of glacial ice, also DILUVION [n DILUVIA or DILUVIUMS]\n",
  "DILUVIUMS": "DILUVIUM, (Latin) a deposit of superficial loam, sand, gravel, stones, etc. caused by former action of flowing waters, or the melting of glacial ice, also DILUVION [n]\n",
  "DIM": "to reduce the light of [v DIMMED, DIMMING, DIMS] / obscure [adj DIMMER, DIMMEST, DIMLY]\n",
  "DIMBLE": "a deep narrow wooded valley, also DINGLE [n -S]\n",
  "DIMBLES": "DIMBLE, a deep narrow wooded valley, also DINGLE [n]\n",
  "DIMBO": "an unintelligent person [n DIMBOES or DIMBOS]\n",
  "DIMBOES": "DIMBO, an unintelligent person [n]\n",
  "DIMBOS": "DIMBO, an unintelligent person [n]\n",
  "DIME": "the tenth part of an American and Canadian dollar, 10 cents [n -S]\n",
  "DIMENHYDRINATE": "a crystalline antihistamine used esp. to prevent nausea, as in motion sickness [n -S]\n",
  "DIMENHYDRINATES": "DIMENHYDRINATE, a crystalline antihistamine used esp. to prevent nausea, as in motion sickness [n]\n",
  "DIMENSION": "to give the length, breadth and thickness of [v -ED, -ING, -S]\n",
  "DIMENSIONAL": "concerning dimension [adj DIMENSIONALLY]\n",
  "DIMENSIONALITY": "the state of being dimensional [n]\n",
  "DIMENSIONALLY": "DIMENSIONAL, concerning dimension [adv]\n",
  "DIMENSIONED": "DIMENSION, to give the length, breadth and thickness of [v]\n",
  "DIMENSIONING": "DIMENSION, to give the length, breadth and thickness of [v]\n",
  "DIMENSIONLESS": "without dimensions [adj]\n",
  "DIMENSIONS": "DIMENSION, to give the length, breadth and thickness of [v]\n",
  "DIMER": "a molecular compound with two identical molecules [n -S]\n",
  "DIMERCAPROL": "a compound developed as an antidote against lewisite and used to treat arsenic, mercury, and gold poisoning [n -S]\n",
  "DIMERCAPROLS": "DIMERCAPROL, a compound developed as an antidote against lewisite and used to treat arsenic, mercury, and gold poisoning [n]\n",
  "DIMERIC": "composed of two parts, also DIMEROUS [adj]\n",
  "DIMERISATION": "the creation of a dimer, also DIMERIZATION [n -S]\n",
  "DIMERISATIONS": "DIMERISATION, the creation of a dimer, also DIMERIZATION [n]\n",
  "DIMERISE": "to make into a dimer, also DIMERIZE [v DIMERISED, DIMERISING, DIMERISES]\n",
  "DIMERISED": "DIMERISE, to make into a dimer, also DIMERIZE [v]\n",
  "DIMERISES": "DIMERISE, to make into a dimer, also DIMERIZE [v]\n",
  "DIMERISING": "DIMERISE, to make into a dimer, also DIMERIZE [v]\n",
  "DIMERISM": "the state of being dimerous, having two parts or members, specifically in a whorl [n -S]\n",
  "DIMERISMS": "DIMERISM, the state of being dimerous, having two parts or members, specifically in a whorl [n]\n",
  "DIMERIZATION": "the creation of a dimer, also DIMERISATION [n -S]\n",
  "DIMERIZATIONS": "DIMERIZATION, the creation of a dimer, also DIMERISATION [n]\n",
  "DIMERIZE": "to make into a dimer, also DIMERISE [v DIMERIZED, DIMERIZING, DIMERIZES]\n",
  "DIMERIZED": "DIMERIZE, to make into a dimer, also DIMERISE [v]\n",
  "DIMERIZES": "DIMERIZE, to make into a dimer, also DIMERISE [v]\n",
  "DIMERIZING": "DIMERIZE, to make into a dimer, also DIMERISE [v]\n",
  "DIMEROUS": "composed of two parts, also DIMERIC [adj]\n",
  "DIMERS": "DIMER, a molecular compound with two identical molecules [n]\n",
  "DIMES": "DIME, the tenth part of an American and Canadian dollar, 10 cents [n]\n",
  "DIMETER": "a verse of two metrical feet [n -S]\n",
  "DIMETERS": "DIMETER, a verse of two metrical feet [n]\n",
  "DIMETHOATE": "a kind of insecticide [n -S]\n",
  "DIMETHOATES": "DIMETHOATE, a kind of insecticide [n]\n",
  "DIMETHYL": "ethane [n -S]\n",
  "DIMETHYLAMINE": "a gas derived from ammonia with two methyl groups replacing two hydrogen atoms [n -S]\n",
  "DIMETHYLAMINES": "DIMETHYLAMINE, a gas derived from ammonia with two methyl groups replacing two hydrogen atoms [n]\n",
  "DIMETHYLANILINE": "an oily liquid, aniline heated with methyl alcohol and hydrochloric acid, from which dyes are obtained [n]\n",
  "DIMETHYLS": "DIMETHYL, ethane [n]\n",
  "DIMETRIC": "pertaining to a type of crystal system [adj]\n",
  "DIMIDIATE": "to divide (a heraldic shield) into halves [v DIMIDIATED, DIMIDIATING, DIMIDIATES]\n",
  "DIMIDIATED": "DIMIDIATE, to divide (a heraldic shield) into halves [v]\n",
  "DIMIDIATES": "DIMIDIATE, to divide (a heraldic shield) into halves [v]\n",
  "DIMIDIATING": "DIMIDIATE, to divide (a heraldic shield) into halves [v]\n",
  "DIMIDIATION": "division into two halves, as of a heraldic shield [n -S]\n",
  "DIMIDIATIONS": "DIMIDIATION, division into two halves, as of a heraldic shield [n]\n",
  "DIMINISH": "to lessen [v -ED, -ING, -ES]\n",
  "DIMINISHABLE": "that can be diminished [adj]\n",
  "DIMINISHED": "DIMINISH, to lessen [v]\n",
  "DIMINISHES": "DIMINISH, to lessen [v]\n",
  "DIMINISHING": "lessening [adj DIMINISHINGLY] / the act of diminishing [n -S]\n",
  "DIMINISHINGLY": "DIMINISHING, lessening [adv]\n",
  "DIMINISHINGS": "DIMINISHING, the act of diminishing [n]\n",
  "DIMINISHMENT": "the act of diminishing [n -S]\n",
  "DIMINISHMENTS": "DIMINISHMENT, the act of diminishing [n]\n",
  "DIMINUENDO": "(Italian) gradually dying away [adv] / a passage of decreasing loudness [n DIMINUENDOES or DIMINUENDOS]\n",
  "DIMINUENDOES": "DIMINUENDO, a passage of decreasing loudness [n]\n",
  "DIMINUENDOS": "DIMINUENDO, a passage of decreasing loudness [n]\n",
  "DIMINUTION": "the act of diminishing [n -S]\n",
  "DIMINUTIONS": "DIMINUTION, the act of diminishing [n]\n",
  "DIMINUTIVAL": "relating to or like a diminutive [adj]\n",
  "DIMINUTIVE": "small [adj DIMINUTIVELY] / a diminutive word, affix, or name [n -S]\n",
  "DIMINUTIVELY": "DIMINUTIVE, small [adv]\n",
  "DIMINUTIVENESS": "the state of being diminutive [n]\n",
  "DIMINUTIVES": "DIMINUTIVE, a diminutive word, affix, or name [n]\n",
  "DIMISSORY": "giving leave to depart [adj]\n",
  "DIMITIES": "DIMITY, a cotton fabric [n]\n",
  "DIMITY": "a cotton fabric [n DIMITIES]\n",
  "DIMLY": "DIM, obscure [adv]\n",
  "DIMMABLE": "able to be dimmed [adj]\n",
  "DIMMED": "DIM, to reduce the light of [v]\n",
  "DIMMER": "a device for dimming lights [n -S]\n",
  "DIMMERS": "DIMMER, a device for dimming lights [n]\n",
  "DIMMEST": "DIM, obscure [adj]\n",
  "DIMMING": "the act of reducing light [n -S]\n",
  "DIMMINGS": "DIMMING, the act of reducing light [n]\n",
  "DIMMISH": "somewhat dim [adj]\n",
  "DIMNESS": "the state of being dim [n -ES]\n",
  "DIMNESSES": "DIMNESS, the state of being dim [n]\n",
  "DIMORPH": "either one of the two forms of a dimorphous substance [n -S]\n",
  "DIMORPHIC": "of a species, where two (e.g. color) forms may be produced in a single brood [adj]\n",
  "DIMORPHISM": "the state of existing or occurring in two distinct forms in the same plant or species [n -S]\n",
  "DIMORPHISMS": "DIMORPHISM, the state of existing or occurring in two distinct forms in the same plant or species [n]\n",
  "DIMORPHOUS": "characterized by dimorphism; occurring under two distinct forms, not dependent on sex; dimorphic [adj]\n",
  "DIMORPHS": "DIMORPH, either one of the two forms of a dimorphous substance [n]\n",
  "DIMOUT": "a condition of partial darkness [n -S]\n",
  "DIMOUTS": "DIMOUT, a condition of partial darkness [n]\n",
  "DIMP": "(slang) a cigarette butt [n -S]\n",
  "DIMPLE": "to mark with indentations [v DIMPLED, DIMPLING, DIMPLES]\n",
  "DIMPLED": "DIMPLE, to mark with indentations [v]\n",
  "DIMPLEMENT": "the state of being dimpled, or marked with gentle depressions [n -S]\n",
  "DIMPLEMENTS": "DIMPLEMENT, the state of being dimpled, or marked with gentle depressions [n]\n",
  "DIMPLES": "DIMPLE, to mark with indentations [v]\n",
  "DIMPLIER": "DIMPLY, dimpled [adj]\n",
  "DIMPLIEST": "DIMPLY, dimpled [adj]\n",
  "DIMPLING": "DIMPLE, to mark with indentations [v]\n",
  "DIMPLY": "dimpled [adj DIMPLIER, DIMPLIEST]\n",
  "DIMPS": "DIMP, (slang) a cigarette butt [n]\n",
  "DIMPSIES": "DIMPSY, (dialect) twilight [n]\n",
  "DIMPSY": "(dialect) twilight [n DIMPSIES]\n",
  "DIMS": "DIM, to reduce the light of [v]\n",
  "DIMWIT": "a person of low intelligence [n -S]\n",
  "DIMWITS": "DIMWIT, a person of low intelligence [n]\n",
  "DIMWITTED": "stupid [adj]\n",
  "DIMYARIAN": "having two adductor muscles, also DIMYARY [adj]\n",
  "DIMYARY": "having two adductor muscles, also DIMYARIAN [adj]\n",
  "DIN": "to make a loud noise [v DINNED, DINNING, DINS]\n",
  "DINANDERIE": "(French) domestic decorative brassware, originally that made at Dinant in Belgium [n -S]\n",
  "DINANDERIES": "DINANDERIE, (French) domestic decorative brassware, originally that made at Dinant in Belgium [n]\n",
  "DINAR": "a monetary unit in Yugoslavia [n -S]\n",
  "DINARCHIES": "DINARCHY, government by two powers, also DIARCHY, DUARCHY, DYARCHY [n]\n",
  "DINARCHY": "government by two powers, also DIARCHY, DUARCHY, DYARCHY [n DINARCHIES]\n",
  "DINARS": "DINAR, a monetary unit in Yugoslavia [n]\n",
  "DINDLE": "(Scots) to tingle, vibrate, also DINNLE [v DINDLED, DINDLING, DINDLES]\n",
  "DINDLED": "DINDLE, (Scots) to tingle, vibrate, also DINNLE [v]\n",
  "DINDLES": "DINDLE, (Scots) to tingle, vibrate, also DINNLE [v]\n",
  "DINDLING": "DINDLE, (Scots) to tingle, vibrate, also DINNLE [v]\n",
  "DINE": "to eat dinner [v DINED, DINING, DINES]\n",
  "DINED": "DINE, to eat dinner [v]\n",
  "DINER": "one that dines [n -S]\n",
  "DINERIC": "pertaining to the interface between two immiscible liquids [adj]\n",
  "DINERO": "(Spanish) a former Peruvian silver coin [n -S]\n",
  "DINEROS": "DINERO, (Spanish) a former Peruvian silver coin [n]\n",
  "DINERS": "DINER, one that dines [n]\n",
  "DINES": "DINE, to eat dinner [v]\n",
  "DINETTE": "an alcove or other part of a room or kitchen set apart for meals [n -S]\n",
  "DINETTES": "DINETTE, an alcove or other part of a room or kitchen set apart for meals [n]\n",
  "DINFUL": "full of din [adj]\n",
  "DING": "to dash; to throw violently [v DINGED, DANG or DUNG, DINGING, DINGS]\n",
  "DINGBAT": "(US slang) a crazy person [n -S]\n",
  "DINGBATS": "DINGBAT, (US slang) a crazy person [n]\n",
  "DINGDONG": "to have a set-to [v -ED, -ING, -S]\n",
  "DINGDONGED": "DINGDONG, to have a set-to [v]\n",
  "DINGDONGING": "DINGDONG, to have a set-to [v]\n",
  "DINGDONGS": "DINGDONG, to have a set-to [v]\n",
  "DINGE": "the condition of being dingy [n -S]\n",
  "DINGED": "DING, to dash; to throw violently [v]\n",
  "DINGER": "anything superlative [n -S]\n",
  "DINGERS": "DINGER, anything superlative [n]\n",
  "DINGES": "(South African) a doodad, also DINGUS [n -ES]\n",
  "DINGESES": "DINGES, (South African) a doodad, also DINGUS [n]\n",
  "DINGEY": "a small open boat, prepared by oars, sails or an outboard motor, also DINGHY, DINGY [n -S]\n",
  "DINGEYS": "DINGEY, a small open boat, prepared by oars, sails or an outboard motor, also DINGHY, DINGY [n]\n",
  "DINGHIES": "DINGHY, a small open boat, prepared by oars, sails or an outboard motor, also DINGEY, DINGY [n]\n",
  "DINGHY": "a small open boat, prepared by oars, sails or an outboard motor, also DINGEY, DINGY [n DINGHIES]\n",
  "DINGIED": "DINGY, to ignore or avoid [v]\n",
  "DINGIER": "DINGY, grimy, also DINGEY [adj]\n",
  "DINGIES": "DINGY, to ignore or avoid [v]\n",
  "DINGIEST": "DINGY, grimy, also DINGEY [adj]\n",
  "DINGILY": "DINGY, grimy, also DINGEY [adv]\n",
  "DINGINESS": "the state of being dingy [n -ES]\n",
  "DINGINESSES": "DINGINESS, the state of being dingy [n]\n",
  "DINGING": "DING, to dash; to throw violently [v]\n",
  "DINGLE": "a deep narrow wooded valley, a dell, also DIMBLE [n -S]\n",
  "DINGLEBERRIES": "DINGLEBERRY, a piece of dried fecal matter clinging to the hair round the anus [n]\n",
  "DINGLEBERRY": "a piece of dried fecal matter clinging to the hair round the anus [n DINGLEBERRIES]\n",
  "DINGLES": "DINGLE, a deep narrow wooded valley, a dell, also DIMBLE [n]\n",
  "DINGO": "(Native Australian) the Australian wild dog [n -ES or -S] / to act in a cowardly manner [v -ED, -ING, -ES]\n",
  "DINGOED": "DINGO, to act in a cowardly manner [v]\n",
  "DINGOES": "DINGO, to act in a cowardly manner [v]\n",
  "DINGOING": "DINGO, to act in a cowardly manner [v]\n",
  "DINGOS": "DINGO, (Native Australian) the Australian wild dog [n]\n",
  "DINGS": "DING, to dash; to throw violently [v]\n",
  "DINGUS": "(South African) a doodad, also DINGES [n -ES]\n",
  "DINGUSES": "DINGUS, (South African) a doodad, also DINGES [n]\n",
  "DINGY": "to ignore or avoid [v DINGIED, DINGYING, DINGIES] / grimy, also DINGEY [adj DINGIER, DINGIEST]\n",
  "DINGYING": "DINGY, to ignore or avoid [v]\n",
  "DINIC": "a remedy for dizziness [n -S]\n",
  "DINICS": "DINIC, a remedy for dizziness [n]\n",
  "DINING": "an act of formal eating [n -S]\n",
  "DININGS": "DINING, an act of formal eating [n]\n",
  "DINITRO": "having two nitro groups [adj]\n",
  "DINITROBENZENE": "any of three isomeric toxic compounds [n -S]\n",
  "DINITROBENZENES": "DINITROBENZENE, any of three isomeric toxic compounds [n]\n",
  "DINITROGEN": "denoting a chemical compound containing two nitrogen atoms [adj]\n",
  "DINITROPHENOL": "any of six isomeric crystalline compounds some of whose derivatives are pesticides [n -S]\n",
  "DINITROPHENOLS": "DINITROPHENOL, any of six isomeric crystalline compounds some of whose derivatives are pesticides [n]\n",
  "DINK": "to play a dropshot in tennis [v -ED, -ING, -S] / neat [adj DINKER, DINKEST, DINKLY]\n",
  "DINKED": "DINK, to play a dropshot in tennis [v]\n",
  "DINKER": "DINK, neat [adj]\n",
  "DINKEST": "DINK, neat [adj]\n",
  "DINKEY": "a small locomotive, also DINKY [n -S]\n",
  "DINKEYS": "DINKEY, a small locomotive, also DINKY [n]\n",
  "DINKIE": "an affluent married childless couple, also DINKY [n -S]\n",
  "DINKIER": "DINKY, small, neat [adj]\n",
  "DINKIES": "DINKIE, an affluent married childless couple, also DINKY [n]\n",
  "DINKIEST": "DINKY, small, neat [adj]\n",
  "DINKING": "DINK, to play a dropshot in tennis [v]\n",
  "DINKLIER": "DINKLY, neat, tidy [adj]\n",
  "DINKLIEST": "DINKLY, neat, tidy [adj]\n",
  "DINKLY": "neat, tidy [adj DINKLIER, DINKLIEST]\n",
  "DINKS": "DINK, to play a dropshot in tennis [v]\n",
  "DINKUM": "(Australian slang) the truth [n -S]\n",
  "DINKUMS": "DINKUM, (Australian slang) the truth [n]\n",
  "DINKY": "a small locomotive, also DINKEY [n DINKIES] / small, neat [adj DINKIER, DINKIEST]\n",
  "DINMONT": "(Scots) a wether between the first and second shearing [n -S]\n",
  "DINMONTS": "DINMONT, (Scots) a wether between the first and second shearing [n]\n",
  "DINNA": "(Scots) do not, also DINNAE [v]\n",
  "DINNAE": "(Scots) do not, also DINNA [v]\n",
  "DINNED": "DIN, to make a loud noise [v]\n",
  "DINNER": "the chief meal of the day [n -S] / to dine [v -ED, -ING, -S]\n",
  "DINNERED": "DINNER, to dine [v]\n",
  "DINNERING": "DINNER, to dine [v]\n",
  "DINNERLESS": "having no dinner [adj]\n",
  "DINNERS": "DINNER, to dine [v]\n",
  "DINNERTIME": "the time at which dinner is taken [n -S]\n",
  "DINNERTIMES": "DINNERTIME, the time at which dinner is taken [n]\n",
  "DINNERWARE": "plates etc. used for dinner [n -S]\n",
  "DINNERWARES": "DINNERWARE, plates etc. used for dinner [n]\n",
  "DINNING": "DIN, to make a loud noise [v]\n",
  "DINNLE": "(Scots) to tingle, vibrate, also DINDLE [v DINNLED, DINNLING, DINNLES]\n",
  "DINNLED": "DINNLE, (Scots) to tingle, vibrate, also DINDLE [v]\n",
  "DINNLES": "DINNLE, (Scots) to tingle, vibrate, also DINDLE [v]\n",
  "DINNLING": "DINNLE, (Scots) to tingle, vibrate, also DINDLE [v]\n",
  "DINO": "(short for) a dinosaur [n -S]\n",
  "DINOCERAS": "a uintathere, an animal of the genus Uintatherium, gigantic fossil ungulates [n -ES]\n",
  "DINOCERASES": "DINOCERAS, a uintathere, an animal of the genus Uintatherium, gigantic fossil ungulates [n]\n",
  "DINOFLAGELLATE": "a kind of marine protozoan, one of the principal constituents of plankton [n -S]\n",
  "DINOFLAGELLATES": "DINOFLAGELLATE, a kind of marine protozoan, one of the principal constituents of plankton [n]\n",
  "DINOMANIA": "public interest in dinosaurs [n -S]\n",
  "DINOMANIAS": "DINOMANIA, public interest in dinosaurs [n]\n",
  "DINOS": "DINO, (short for) a dinosaur [n]\n",
  "DINOSAUR": "any of a group of extinct reptiles, also DEINOSAUR [n -S]\n",
  "DINOSAURIAN": "of or like a dinosaur, also DINOSAURIC [adj]\n",
  "DINOSAURIC": "of or like a dinosaur, also DINOSAURIAN [adj]\n",
  "DINOSAURS": "DINOSAUR, any of a group of extinct reptiles, also DEINOSAUR [n]\n",
  "DINOTHERE": "an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DEINOTHERIUM, DINOTHERIUM [n -S]\n",
  "DINOTHERES": "DINOTHERE, an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DEINOTHERIUM, DINOTHERIUM [n]\n",
  "DINOTHERIA": "DINOTHERIUM, an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DEINOTHERIUM, DINOTHERE [n]\n",
  "DINOTHERIUM": "an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DEINOTHERIUM, DINOTHERE [n DINOTHERIA or DINOTHERIUMS]\n",
  "DINOTHERIUMS": "DINOTHERIUM, an extinct elephantine mammal with downward-curving tusks, also DEINOTHERE, DEINOTHERIUM, DINOTHERE [n]\n",
  "DINOTURBATION": "the effects of dinosaur trampling on the formation of sedimentary rock [n -S]\n",
  "DINOTURBATIONS": "DINOTURBATION, the effects of dinosaur trampling on the formation of sedimentary rock [n]\n",
  "DINS": "DIN, to make a loud noise [v]\n",
  "DINT": "to make a dent in [v -ED, -ING, -S]\n",
  "DINTED": "DINT, to make a dent in [v]\n",
  "DINTING": "DINT, to make a dent in [v]\n",
  "DINTLESS": "having no dints (dents) [adj]\n",
  "DINTS": "DINT, to make a dent in [v]\n",
  "DINUCLEOTIDE": "a nucleotide consisting of two units each composed of a phosphate, a pentose, and a nitrogen base [n -S]\n",
  "DINUCLEOTIDES": "DINUCLEOTIDE, a nucleotide consisting of two units each composed of a phosphate, a pentose, and a nitrogen base [n]\n",
  "DIOBOL": "(Greek) an ancient Greek coin, also DIOBOLON [n -S]\n",
  "DIOBOLON": "(Greek) an ancient Greek coin, also DIOBOL [n -S]\n",
  "DIOBOLONS": "DIOBOLON, (Greek) an ancient Greek coin, also DIOBOL [n]\n",
  "DIOBOLS": "DIOBOL, (Greek) an ancient Greek coin, also DIOBOLON [n]\n",
  "DIOCESAN": "the bishop of a diocese [n -S]\n",
  "DIOCESANS": "DIOCESAN, the bishop of a diocese [n]\n",
  "DIOCESE": "the circuit or extent of a bishop's jurisdiction [n -S]\n",
  "DIOCESES": "DIOCESE, the circuit or extent of a bishop's jurisdiction [n]\n",
  "DIODE": "a type of electron tube [n -S]\n",
  "DIODES": "DIODE, a type of electron tube [n]\n",
  "DIOECIES": "DIOECY, the state of having separate male and female types [n]\n",
  "DIOECIOUS": "having male and female sexual organs in different individuals, also DIECIOUS, DIOICOUS [adj DIOECIOUSLY]\n",
  "DIOECIOUSLY": "DIOECIOUS, having male and female sexual organs in different individuals, also DIECIOUS, DIOICOUS [adv]\n",
  "DIOECIOUSNESS": "DIOECIOUS, having male and female sexual organs in different individuals, also DIECIOUS, DIOICOUS [n]\n",
  "DIOECIOUSNESSES": "DIOECIOUSNESS, DIOECIOUS, having male and female sexual organs in different individuals, also DIECIOUS, DIOICOUS [n]\n",
  "DIOECISM": "the condition of being dioecious, having male and female sexual organs in different individuals [n -S]\n",
  "DIOECISMS": "DIOECISM, the condition of being dioecious, having male and female sexual organs in different individuals [n]\n",
  "DIOECY": "the state of having separate male and female types [n DIOECIES]\n",
  "DIOESTRUS": "a period of sexual inactivity, also DIESTRUM, DIESTRUS [n DIOESTRUSES]\n",
  "DIOESTRUSES": "DIOESTRUS, a period of sexual inactivity, also DIESTRUM, DIESTRUS [n]\n",
  "DIOICOUS": "having male and female sexual organs in different individuals, also DIECIOUS, DIOECIOUS [adj DIOICOUSLY]\n",
  "DIOICOUSLY": "DIOICOUS, having male and female sexual organs in different individuals, also DIECIOUS, DIOECIOUS [adv]\n",
  "DIOICOUSNESS": "the state of being dioicous [n -ES]\n",
  "DIOICOUSNESSES": "DIOICOUSNESS, the state of being dioicous [n]\n",
  "DIOL": "an alcohol with two hydroxyl groups in the molecule [n -S]\n",
  "DIOLEFIN": "a compound containing two double bonds between hydrogen atoms, aka diene [n -S]\n",
  "DIOLEFINS": "DIOLEFIN, a compound containing two double bonds between hydrogen atoms, aka diene [n]\n",
  "DIOLS": "DIOL, an alcohol with two hydroxyl groups in the molecule [n]\n",
  "DIONYSIAC": "orgiastic, also DIONYSIAN [adj]\n",
  "DIONYSIAN": "orgiastic, also DIONYSIAC [adj]\n",
  "DIOPHYSITE": "a believer in the existence of two natures in Christ, human and divine, also DIPHYSITE, DYOPHYSITE [n -S]\n",
  "DIOPHYSITES": "DIOPHYSITE, a believer in the existence of two natures in Christ, human and divine, also DIPHYSITE, DYOPHYSITE [n]\n",
  "DIOPSIDE": "a mineral, a crystallized variety of pyroxene, of a clear, grayish green color [n -S]\n",
  "DIOPSIDES": "DIOPSIDE, a mineral, a crystallized variety of pyroxene, of a clear, grayish green color [n]\n",
  "DIOPSIDIC": "relating to diopside, a crystallized variety of pyroxene, of a clear, grayish green color [adj]\n",
  "DIOPTASE": "a mineral, a hydrous silicate of copper, occurring in emerald-green crystals [n -S]\n",
  "DIOPTASES": "DIOPTASE, a mineral, a hydrous silicate of copper, occurring in emerald-green crystals [n]\n",
  "DIOPTER": "a measure of refractive power, also DIOPTRE [n -S]\n",
  "DIOPTERS": "DIOPTER, a measure of refractive power, also DIOPTRE [n]\n",
  "DIOPTOMETER": "an instrument for measuring ocular refraction [n -S]\n",
  "DIOPTOMETERS": "DIOPTOMETER, an instrument for measuring ocular refraction [n]\n",
  "DIOPTOMETRIES": "DIOPTOMETRY, the measurement of ocular refraction [n]\n",
  "DIOPTOMETRY": "the measurement of ocular refraction [n DIOPTOMETRIES]\n",
  "DIOPTRAL": "relating to a diopter, a measure of refractive power [adj]\n",
  "DIOPTRATE": "of insects, having the compound eye divided transversely [adj]\n",
  "DIOPTRE": "a measure of refractive power, also DIOPTER [n -S]\n",
  "DIOPTRES": "DIOPTRE, a measure of refractive power, also DIOPTER [n]\n",
  "DIOPTRIC": "transparent, also DIOPTRICAL [adj DIOPTRICALLY]\n",
  "DIOPTRICAL": "transparent, also DIOPTRIC [adj DIOPTRICALLY]\n",
  "DIOPTRICALLY": "DIOPTRICAL, transparent, also DIOPTRIC [adv]\n",
  "DIOPTRICS": "the study of light refraction [n]\n",
  "DIORAMA": "(Greek) an exhibition of translucent pictures seen through an opening with lighting effects [n -S]\n",
  "DIORAMAS": "DIORAMA, (Greek) an exhibition of translucent pictures seen through an opening with lighting effects [n]\n",
  "DIORAMIC": "pertaining to a diorama, an exhibition of translucent pictures seen through an opening with lighting effects [adj]\n",
  "DIORISM": "a distinction, a definition [n -S]\n",
  "DIORISMS": "DIORISM, a distinction, a definition [n]\n",
  "DIORISTIC": "serving to distinguish, also DIORISTICAL [adj DIORISTICALLY]\n",
  "DIORISTICAL": "serving to distinguish, also DIORISTIC [adj DIORISTICALLY]\n",
  "DIORISTICALLY": "DIORISTICAL, serving to distinguish, also DIORISTIC [adv]\n",
  "DIORITE": "a crystalline granular igneous rock composed of plagioclase and hornblende [n -S]\n",
  "DIORITES": "DIORITE, a crystalline granular igneous rock composed of plagioclase and hornblende [n]\n",
  "DIORITIC": "containing diorite, a crystalline granular igneous rock composed of plagioclase and hornblende [adj]\n",
  "DIORTHOSES": "DIORTHOSIS, a critical revision of a text; any correction or adjustment [n]\n",
  "DIORTHOSIS": "a critical revision of a text; any correction or adjustment [n DIORTHOSES]\n",
  "DIORTHOTIC": "relating to the correcting or straightening out of something; corrective [adj]\n",
  "DIOSCOREACEOUS": "belonging to the Dioscorea, the yam family [adj]\n",
  "DIOSGENIN": "a crystalline substance obtained from the Mexican yam, used in the preparation of steroid hormones [n -S]\n",
  "DIOSGENINS": "DIOSGENIN, a crystalline substance obtained from the Mexican yam, used in the preparation of steroid hormones [n]\n",
  "DIOTA": "(Greek) an ancient two-handled vase [n -S]\n",
  "DIOTAS": "DIOTA, (Greek) an ancient two-handled vase [n]\n",
  "DIOTHELETE": "a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DITHELETE, DYOTHELETE, DYOTHELITE [n -S]\n",
  "DIOTHELETES": "DIOTHELETE, a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DITHELETE, DYOTHELETE, DYOTHELITE [n]\n",
  "DIOTHELETIC": "relating to ditheletism, the doctrine that Christ had two wills, also DITHELETIC, DITHELETICAL [adj]\n",
  "DIOTHELETICAL": "relating to ditheletism, the doctrine that Christ had two wills, also DITHELETIC, DITHELETICAL [adj]\n",
  "DIOTHELISM": "the doctrine that Christ on earth had two will, human and divine, also DITHELISM, DYOTHELISM [n -S]\n",
  "DIOTHELISMS": "DIOTHELISM, the doctrine that Christ on earth had two will, human and divine, also DITHELISM, DYOTHELISM [n]\n",
  "DIOTHELITE": "a believer in the doctrine of ditheletism [n -S]\n",
  "DIOTHELITES": "DIOTHELITE, a believer in the doctrine of ditheletism [n]\n",
  "DIOXAN": "a toxic flammable solvent, also DIOXANE [n -S]\n",
  "DIOXANE": "a toxic flammable solvent, also DIOXAN [n -S]\n",
  "DIOXANES": "DIOXANE, a toxic flammable solvent, also DIOXAN [n]\n",
  "DIOXANS": "DIOXAN, a toxic flammable solvent, also DIOXANE [n]\n",
  "DIOXID": "an oxide with two atoms of oxygen in the molecule, also DIOXIDE [n -S]\n",
  "DIOXIDE": "a type of oxide, also DIOXID [n -S]\n",
  "DIOXIDES": "DIOXIDE, a type of oxide, also DIOXID [n]\n",
  "DIOXIDS": "DIOXID, an oxide with two atoms of oxygen in the molecule, also DIOXIDE [n]\n",
  "DIOXIN": "an extremely toxic poison found in certain weedkillers [n -S]\n",
  "DIOXINS": "DIOXIN, an extremely toxic poison found in certain weedkillers [n]\n",
  "DIOXONITRIC": "as in dioxonitric acid, the systematic name of nitrous acid [adj]\n",
  "DIP": "to immerse briefly in a liquid [v DIPPED, DIPT, DIPPING, DIPS]\n",
  "DIPCHICK": "the little grebe, also DABCHICK, DOBCHICK [n -S]\n",
  "DIPCHICKS": "DIPCHICK, the little grebe, also DABCHICK, DOBCHICK [n]\n",
  "DIPEPTIDASE": "any of various enzymes that hydrolyze dipeptides but not polypeptides [n -S]\n",
  "DIPEPTIDASES": "DIPEPTIDASE, any of various enzymes that hydrolyze dipeptides but not polypeptides [n]\n",
  "DIPEPTIDE": "a peptide formed by the combination of two amino acids [n -S]\n",
  "DIPEPTIDES": "DIPEPTIDE, a peptide formed by the combination of two amino acids [n]\n",
  "DIPETALOUS": "having two petals [adj]\n",
  "DIPHASE": "having two phases, also DIPHASIC [adj]\n",
  "DIPHASIC": "having two phases, also DIPHASE [adj]\n",
  "DIPHENHYDRAMINE": "a type of antihistamine [n]\n",
  "DIPHENYL": "a hydrocarbon consisting of two phenyl groups, used as a fungicide and in dye-manufacture, also BIPHENYL [n -S]\n",
  "DIPHENYLAMINE": "a crystalline compound used chiefly in the manufacture of dyes and as an indicator [n -S]\n",
  "DIPHENYLAMINES": "DIPHENYLAMINE, a crystalline compound used chiefly in the manufacture of dyes and as an indicator [n]\n",
  "DIPHENYLENE": "as in diphenylene diketone, a compound used in dye manufacture [adj]\n",
  "DIPHENYLENIMINE": "a derivative of benzene, aka carbazole, used in the manufacture of dyes [n]\n",
  "DIPHENYLKETONE": "the aromatic ketone benzophenone [n -S]\n",
  "DIPHENYLKETONES": "DIPHENYLKETONE, the aromatic ketone benzophenone [n]\n",
  "DIPHENYLS": "DIPHENYL, a hydrocarbon consisting of two phenyl groups, used as a fungicide and in dye-manufacture, also BIPHENYL [n]\n",
  "DIPHONE": "a shorthand sign for a diphthong [n -S]\n",
  "DIPHONES": "DIPHONE, a shorthand sign for a diphthong [n]\n",
  "DIPHOSGENE": "a liquid compound used as a poisonous gas [n -S]\n",
  "DIPHOSGENES": "DIPHOSGENE, a liquid compound used as a poisonous gas [n]\n",
  "DIPHOSPHATE": "a phosphate containing two phosphate groups [n -S]\n",
  "DIPHOSPHATES": "DIPHOSPHATE, a phosphate containing two phosphate groups [n]\n",
  "DIPHTHERIA": "an infectious throat disease in which the air-passages become covered with a leathery membrane [n -S]\n",
  "DIPHTHERIAL": "relating to diphtheria [adj]\n",
  "DIPHTHERIAS": "DIPHTHERIA, an infectious throat disease in which the air-passages become covered with a leathery membrane [n]\n",
  "DIPHTHERIC": "relating to diphtheria [adj]\n",
  "DIPHTHERITIC": "relating to diphtheria [adj]\n",
  "DIPHTHERITIS": "diphtheria [n -ES]\n",
  "DIPHTHERITISES": "DIPHTHERITIS, diphtheria [n]\n",
  "DIPHTHEROID": "a bacterium that resembles the bacterium of diphtheria but does not produce diphtheria toxin [n -S]\n",
  "DIPHTHEROIDS": "DIPHTHEROID, a bacterium that resembles the bacterium of diphtheria but does not produce diphtheria toxin [n]\n",
  "DIPHTHONG": "a union of two vowels pronounced in one syllable [n -S] / to pronounce as a diphthong [v -ED, -ING, -S]\n",
  "DIPHTHONGAL": "of or like a diphthong [adj DIPHTHONGALLY]\n",
  "DIPHTHONGALLY": "DIPHTHONGAL, of or like a diphthong [adv]\n",
  "DIPHTHONGED": "DIPHTHONG, to pronounce as a diphthong [v]\n",
  "DIPHTHONGIC": "having the nature of a diphthong [adj]\n",
  "DIPHTHONGING": "DIPHTHONG, to pronounce as a diphthong [v]\n",
  "DIPHTHONGISE": "to make into a diphthong, also DIPHTHONGIZE [v DIPHTHONGISED, DIPHTHONGISING, DIPHTHONGISES]\n",
  "DIPHTHONGISED": "DIPHTHONGISE, to make into a diphthong, also DIPHTHONGIZE [v]\n",
  "DIPHTHONGISES": "DIPHTHONGISE, to make into a diphthong, also DIPHTHONGIZE [v]\n",
  "DIPHTHONGISING": "DIPHTHONGISE, to make into a diphthong, also DIPHTHONGIZE [v]\n",
  "DIPHTHONGIZE": "to make into a diphthong, also DIPHTHONGISE [v DIPHTHONGIZED, DIPHTHONGIZING, DIPHTHONGIZES]\n",
  "DIPHTHONGIZED": "DIPHTHONGIZE, to make into a diphthong, also DIPHTHONGISE [v]\n",
  "DIPHTHONGIZES": "DIPHTHONGIZE, to make into a diphthong, also DIPHTHONGISE [v]\n",
  "DIPHTHONGIZING": "DIPHTHONGIZE, to make into a diphthong, also DIPHTHONGISE [v]\n",
  "DIPHTHONGS": "DIPHTHONG, a union of two vowels pronounced in one syllable [n]\n",
  "DIPHYCERCAL": "of fishes, etc., having the tail symmetrical about the vertebral column [adj]\n",
  "DIPHYLETIC": "descended from two distinct ancestral groups [adj]\n",
  "DIPHYLLOUS": "having two leaves [adj]\n",
  "DIPHYODONT": "a mammal having a second set of teeth that replaces the first [n -S]\n",
  "DIPHYODONTS": "DIPHYODONT, a mammal having a second set of teeth that replaces the first [n]\n",
  "DIPHYSITE": "a believer in the existence of two natures in Christ, human and divine, also DIOPHYSITE, DYOPHYSITE [n -S]\n",
  "DIPHYSITES": "DIPHYSITE, a believer in the existence of two natures in Christ, human and divine, also DIOPHYSITE, DYOPHYSITE [n]\n",
  "DIPHYSITISM": "belief in the dual nature of Christ [n -S]\n",
  "DIPHYSITISMS": "DIPHYSITISM, belief in the dual nature of Christ [n]\n",
  "DIPLEGIA": "paralysis of a part on both sides of the body [n -S]\n",
  "DIPLEGIAS": "DIPLEGIA, paralysis of a part on both sides of the body [n]\n",
  "DIPLEGIC": "paralysed on both sides of the body [adj]\n",
  "DIPLEIDOSCOPE": "an instrument for ascertaining the moment of meridian passage by observing the coincidence of two images [n -S]\n",
  "DIPLEIDOSCOPES": "DIPLEIDOSCOPE, an instrument for ascertaining the moment of meridian passage by observing the coincidence of two images [n]\n",
  "DIPLEX": "pertaining to transmission of radio signals [adj]\n",
  "DIPLEXER": "a device which enables two transmitters to operate simultaneously using the same aerial [n -S]\n",
  "DIPLEXERS": "DIPLEXER, a device which enables two transmitters to operate simultaneously using the same aerial [n]\n",
  "DIPLOBIONT": "an organism that has both haploid and diploid individuals in its life cycle [n -S]\n",
  "DIPLOBIONTIC": "of or like a diplobiont, an organism that has both haploid and diploid individuals in its life cycle [adj]\n",
  "DIPLOBIONTS": "DIPLOBIONT, an organism that has both haploid and diploid individuals in its life cycle [n]\n",
  "DIPLOBLASTIC": "having ectoderm and endoderm but no mesoderm, as in coelenterates [adj]\n",
  "DIPLOCARDIAC": "of birds and mammals, having a four-chambered heart, which enables two separate circulations and prevents mixing of the arterial and venous blood [adj]\n",
  "DIPLOCOCCAL": "of or like a diplococcus, also DIPLOCOCCIC [adj]\n",
  "DIPLOCOCCI": "DIPLOCOCCUS, a coccus that divides by fission, the two resulting individuals remaining paired [n]\n",
  "DIPLOCOCCIC": "of or like a diplococcus, also DIPLOCOCCAL [adj]\n",
  "DIPLOCOCCUS": "a coccus that divides by fission, the two resulting individuals remaining paired [n DIPLOCOCCI]\n",
  "DIPLODOCUS": "a gigantic, quadruped, herbivorous dinosaur [n -ES]\n",
  "DIPLODOCUSES": "DIPLODOCUS, a gigantic, quadruped, herbivorous dinosaur [n]\n",
  "DIPLOE": "(Greek) the soft, spongy, or cancellated substance between the plates of the skull [n -S]\n",
  "DIPLOES": "DIPLOE, (Greek) the soft, spongy, or cancellated substance between the plates of the skull [n]\n",
  "DIPLOGEN": "an alternative name for deuterium or heavy hydrogen [n -S]\n",
  "DIPLOGENESES": "DIPLOGENESIS, the doubling of ordinarily single organ or part [n]\n",
  "DIPLOGENESIS": "the doubling of ordinarily single organ or part [n DIPLOGENESES]\n",
  "DIPLOGENS": "DIPLOGEN, an alternative name for deuterium or heavy hydrogen [n]\n",
  "DIPLOIC": "of or pertaining to the diploe, the soft, spongy, or cancellated substance between the plates of the skull [adj]\n",
  "DIPLOID": "an animal with two homologous sets of chromosomes [n -S]\n",
  "DIPLOIDIC": "relating to diploidy, the state of being diploid [adj]\n",
  "DIPLOIDIES": "DIPLOIDY, the condition of being a diploid [n]\n",
  "DIPLOIDS": "DIPLOID, an animal with two homologous sets of chromosomes [n]\n",
  "DIPLOIDY": "the condition of being a diploid [n DIPLOIDIES]\n",
  "DIPLOMA": "a document indicating an honour or privilege [n DIPLOMAS or DIPLOMATA] / to confer an honour or privilege upon [v -ED, -ING, -S]\n",
  "DIPLOMACIES": "DIPLOMACY, the art of negotiation [n]\n",
  "DIPLOMACY": "the art of negotiation [n DIPLOMACIES]\n",
  "DIPLOMAED": "DIPLOMA, to confer an honour or privilege upon [v]\n",
  "DIPLOMAING": "DIPLOMA, to confer an honour or privilege upon [v]\n",
  "DIPLOMAS": "DIPLOMA, to confer an honour or privilege upon [v]\n",
  "DIPLOMAT": "a person employed or skilled in diplomacy [n -S] / to act as a diplomat [v -ED, -ING, -S]\n",
  "DIPLOMATA": "DIPLOMA, a document indicating an honour or privilege [n]\n",
  "DIPLOMATE": "someone who holds a diploma [n -S] / to invest with a degree or title by diploma [v DIPLOMATED, DIPLOMATING, DIPLOMATES]\n",
  "DIPLOMATED": "DIPLOMATE, to invest with a degree or title by diploma [v]\n",
  "DIPLOMATES": "DIPLOMATE, to invest with a degree or title by diploma [v]\n",
  "DIPLOMATESE": "the language of diplomacy [n -S]\n",
  "DIPLOMATESES": "DIPLOMATESE, the language of diplomacy [n]\n",
  "DIPLOMATIC": "relating to diplomacy, also DIPLOMATICAL [adj DIPLOMATICALLY]\n",
  "DIPLOMATICAL": "relating to diplomacy, also DIPLOMATIC [adj DIPLOMATICALLY]\n",
  "DIPLOMATICALLY": "DIPLOMATICAL, relating to diplomacy, also DIPLOMATIC [adv]\n",
  "DIPLOMATICS": "the science of deciphering ancient writings and texts [n]\n",
  "DIPLOMATING": "DIPLOMATE, to invest with a degree or title by diploma [v]\n",
  "DIPLOMATISE": "to practise, or bring about by, diplomacy, also DIPLOMATIZE [v DIPLOMATISED, DIPLOMATISING, DIPLOMATISES]\n",
  "DIPLOMATISED": "DIPLOMATISE, to practise, or bring about by, diplomacy, also DIPLOMATIZE [v]\n",
  "DIPLOMATISES": "DIPLOMATISE, to practise, or bring about by, diplomacy, also DIPLOMATIZE [v]\n",
  "DIPLOMATISING": "DIPLOMATISE, to practise, or bring about by, diplomacy, also DIPLOMATIZE [v]\n",
  "DIPLOMATIST": "a diplomat [n -S]\n",
  "DIPLOMATISTS": "DIPLOMATIST, a diplomat [n]\n",
  "DIPLOMATIZE": "to practise, or bring about by, diplomacy, also DIPLOMATISE [v DIPLOMATIZED, DIPLOMATIZING, DIPLOMATIZES]\n",
  "DIPLOMATIZED": "DIPLOMATIZE, to practise, or bring about by, diplomacy, also DIPLOMATISE [v]\n",
  "DIPLOMATIZES": "DIPLOMATIZE, to practise, or bring about by, diplomacy, also DIPLOMATISE [v]\n",
  "DIPLOMATIZING": "DIPLOMATIZE, to practise, or bring about by, diplomacy, also DIPLOMATISE [v]\n",
  "DIPLOMATOLOGIES": "DIPLOMATOLOGY, the study of diplomats [n]\n",
  "DIPLOMATOLOGY": "the study of diplomats [n DIPLOMATOLOGIES]\n",
  "DIPLOMATS": "DIPLOMAT, to act as a diplomat [v]\n",
  "DIPLON": "an alternative name for deuteron, the nucleus of heavy hydrogen [n -S]\n",
  "DIPLONEMA": "a less common name for diplotene, a stage of meiotic prophase (cell division) [n -S]\n",
  "DIPLONEMAS": "DIPLONEMA, a less common name for diplotene, a stage of meiotic prophase (cell division) [n]\n",
  "DIPLONS": "DIPLON, an alternative name for deuteron, the nucleus of heavy hydrogen [n]\n",
  "DIPLONT": "an organism with a particular chromosomal structure [n -S]\n",
  "DIPLONTIC": "relating to a diplont, an animal or plant body containing diploid nuclei [adj]\n",
  "DIPLONTS": "DIPLONT, an organism with a particular chromosomal structure [n]\n",
  "DIPLOPHASE": "a diploid phase in a life cycle [n -S]\n",
  "DIPLOPHASES": "DIPLOPHASE, a diploid phase in a life cycle [n]\n",
  "DIPLOPIA": "a disorder of vision in which two images of a single object are seen [n -S]\n",
  "DIPLOPIAS": "DIPLOPIA, a disorder of vision in which two images of a single object are seen [n]\n",
  "DIPLOPIC": "relating to diplopia [adj]\n",
  "DIPLOPOD": "any myriapod of the class Diplopoda bearing two pairs of legs on each segment [n -S]\n",
  "DIPLOPODS": "DIPLOPOD, any myriapod of the class Diplopoda bearing two pairs of legs on each segment [n]\n",
  "DIPLOSES": "DIPLOSIS, a method of chromosome formation [n]\n",
  "DIPLOSIS": "a method of chromosome formation [n DIPLOSES]\n",
  "DIPLOSPEAK": "the polite and placatory language usually associated with diplomats [n -S]\n",
  "DIPLOSPEAKS": "DIPLOSPEAK, the polite and placatory language usually associated with diplomats [n]\n",
  "DIPLOSTEMONOUS": "having two whorls of stamens, the outer alternating with the petals, the inner with the outer [adj]\n",
  "DIPLOTENE": "the fourth stage of the prophase of meiosis, in which the chromosomes clearly double [n -S]\n",
  "DIPLOTENES": "DIPLOTENE, the fourth stage of the prophase of meiosis, in which the chromosomes clearly double [n]\n",
  "DIPLOZOA": "DIPLOZOON, a parasitic flatworm that fuses in pairs [n]\n",
  "DIPLOZOIC": "of animals, bilaterally symmetrical [adj]\n",
  "DIPLOZOON": "a parasitic flatworm that fuses in pairs [n DIPLOZOA]\n",
  "DIPNET": "a handheld fishing scoop [n -S] / to scoop fish [v DIPNETTED, DIPNETTING, DIPNETS]\n",
  "DIPNETS": "DIPNET, to scoop fish [v]\n",
  "DIPNETTED": "DIPNET, to scoop fish [v]\n",
  "DIPNETTING": "DIPNET, to scoop fish [v]\n",
  "DIPNOAN": "a lungfish [n -S]\n",
  "DIPNOANS": "DIPNOAN, a lungfish [n]\n",
  "DIPNOOUS": "having lungs and gills [adj]\n",
  "DIPODIC": "of or like dipody, a double foot in prosody [adj]\n",
  "DIPODIES": "DIPODY, a verse of two metrical feet, also DIMETER [n]\n",
  "DIPODY": "a verse of two metrical feet, also DIMETER [n DIPODIES]\n",
  "DIPOLAR": "having two poles, as a magnetic bar [adj]\n",
  "DIPOLE": "a pair of equal and opposite electric charges [n -S]\n",
  "DIPOLES": "DIPOLE, a pair of equal and opposite electric charges [n]\n",
  "DIPPABLE": "able to be dipped [adj]\n",
  "DIPPED": "DIP, to immerse briefly in a liquid [v]\n",
  "DIPPER": "a water bird with a dipping action [n -S]\n",
  "DIPPERFUL": "the contents of a dipper [n -S]\n",
  "DIPPERFULS": "DIPPERFUL, the contents of a dipper [n]\n",
  "DIPPERS": "DIPPER, a water bird with a dipping action [n]\n",
  "DIPPIER": "DIPPY, crazy, insane [adj]\n",
  "DIPPIEST": "DIPPY, crazy, insane [adj]\n",
  "DIPPINESS": "the state of being dippy [n -ES]\n",
  "DIPPINESSES": "DIPPINESS, the state of being dippy [n]\n",
  "DIPPING": "the act of dipping [n -S]\n",
  "DIPPINGS": "DIPPING, the act of dipping [n]\n",
  "DIPPY": "crazy, insane [adj DIPPIER, DIPPIEST]\n",
  "DIPRIONIDIAN": "of graptolites, serrated on both sides [adj]\n",
  "DIPROPELLANT": "a rocket propellant consisting of two substances, usually a fuel and an oxidizer [n -S]\n",
  "DIPROPELLANTS": "DIPROPELLANT, a rocket propellant consisting of two substances, usually a fuel and an oxidizer [n]\n",
  "DIPROTIC": "(of an acid) having two transferable protons [adj]\n",
  "DIPROTODON": "any marsupial of the Diprotodontia, that includes kangaroos, wombats, etc., also DIPROTODONT [n -S]\n",
  "DIPROTODONS": "DIPROTODON, any marsupial of the Diprotodontia, that includes kangaroos, wombats, etc., also DIPROTODONT [n]\n",
  "DIPROTODONT": "any marsupial of the Diprotodontia, the suborder including kangaroos, wombats, etc., also DIPROTODON [n -S]\n",
  "DIPROTODONTID": "an animal of the Diprotodontidae, an extinct family of marsupials including the genus Diprotodon [n -S]\n",
  "DIPROTODONTIDS": "DIPROTODONTID, an animal of the Diprotodontidae, an extinct family of marsupials including the genus Diprotodon [n]\n",
  "DIPROTODONTS": "DIPROTODONT, any marsupial of the Diprotodontia, the suborder including kangaroos, wombats, etc., also DIPROTODON [n]\n",
  "DIPS": "DIP, to immerse briefly in a liquid [v]\n",
  "DIPSADES": "DIPSAS, (Greek) a fabled serpent whose bite was believed to cause intense thirst [n]\n",
  "DIPSAS": "(Greek) a fabled serpent whose bite was believed to cause intense thirst [n DIPSADES]\n",
  "DIPSHIT": "(vulgar) a contemptible person [n -S]\n",
  "DIPSHITS": "DIPSHIT, (vulgar) a contemptible person [n]\n",
  "DIPSO": "(short for) a dipsomaniac, one addicted to drink [n -S]\n",
  "DIPSOMANIA": "an abnormal craving for alcohol [n -S]\n",
  "DIPSOMANIAC": "one addicted to drink [n -S]\n",
  "DIPSOMANIACAL": "relating to dipsomania [adj]\n",
  "DIPSOMANIACS": "DIPSOMANIAC, one addicted to drink [n]\n",
  "DIPSOMANIAS": "DIPSOMANIA, an abnormal craving for alcohol [n]\n",
  "DIPSOS": "DIPSO, (short for) a dipsomaniac, one addicted to drink [n]\n",
  "DIPSTICK": "a measuring rod [n -S]\n",
  "DIPSTICKS": "DIPSTICK, a measuring rod [n]\n",
  "DIPSWITCH": "a switch for dipping headlights on a car [n -ES]\n",
  "DIPSWITCHES": "DIPSWITCH, a switch for dipping headlights on a car [n]\n",
  "DIPT": "DIP, to immerse briefly in a liquid [v]\n",
  "DIPTERA": "an extensive order of insects having only two functional wings and two balancers [n -S]\n",
  "DIPTERAL": "having two wings only; belonging to the order Diptera [adj]\n",
  "DIPTERAN": "an insect of the order Diptera, a large order of two-winged insects including flies, gnats, mosquitoes, etc., also DIPTERON [n -S]\n",
  "DIPTERANS": "DIPTERAN, an insect of the order Diptera, a large order of two-winged insects including flies, gnats, mosquitoes, etc., also DIPTERON [n]\n",
  "DIPTERAS": "DIPTERA, an extensive order of insects having only two functional wings and two balancers [n]\n",
  "DIPTERIST": "a person who studies flies [n -S]\n",
  "DIPTERISTS": "DIPTERIST, a person who studies flies [n]\n",
  "DIPTEROCARP": "a kind of Oriental tree, with sepals that serve as wings for the fruit [n -S]\n",
  "DIPTEROCARPOUS": "of or like a dipterocarp [adj]\n",
  "DIPTEROCARPS": "DIPTEROCARP, a kind of Oriental tree, with sepals that serve as wings for the fruit [n]\n",
  "DIPTEROI": "DIPTEROS, (Greek) a building with two colonnades [n]\n",
  "DIPTERON": "a two-winged insect, also DIPTERAN, DIPTERA [n DIPTERONS or DIPTERA]\n",
  "DIPTERONS": "DIPTERON, a two-winged insect, also DIPTERAN, DIPTERA [n]\n",
  "DIPTEROS": "(Greek) a building with two colonnades [n DIPTEROSES or DIPTEROI]\n",
  "DIPTEROSES": "DIPTEROS, (Greek) a building with two colonnades [n]\n",
  "DIPTEROUS": "having two wings, as certain insects; belonging to the order Diptera [adj]\n",
  "DIPTYCA": "a pair of pictures on hinged panels, also DIPTYCH [n -S]\n",
  "DIPTYCAS": "DIPTYCA, a pair of pictures on hinged panels, also DIPTYCH [n]\n",
  "DIPTYCH": "an ancient writing tablet, also DIPTYCA [n -S]\n",
  "DIPTYCHS": "DIPTYCH, an ancient writing tablet, also DIPTYCA [n]\n",
  "DIQUARK": "a low energy configuration of two quarks [n -S]\n",
  "DIQUARKS": "DIQUARK, a low energy configuration of two quarks [n]\n",
  "DIQUAT": "a kind of herbicide [n -S]\n",
  "DIQUATS": "DIQUAT, a kind of herbicide [n]\n",
  "DIRAM": "a monetary unit of Tajikistan [n -S]\n",
  "DIRAMS": "DIRAM, a monetary unit of Tajikistan [n]\n",
  "DIRDAM": "(Scots) an uproar, also DIRDUM, DURDUM [n -S]\n",
  "DIRDAMS": "DIRDAM, (Scots) an uproar, also DIRDUM, DURDUM [n]\n",
  "DIRDUM": "(Scots) an uproar, also DIRDAM, DURDUM [n -S]\n",
  "DIRDUMS": "DIRDUM, (Scots) an uproar, also DIRDAM, DURDUM [n]\n",
  "DIRE": "disastrous [adj DIRER, DIREST, DIRELY]\n",
  "DIRECT": "straightforward [adj DIRECTER, DIRECTEST, DIRECTLY] / to control or conduct the affairs of [v -ED, -ING, -S]\n",
  "DIRECTED": "DIRECT, to control or conduct the affairs of [v]\n",
  "DIRECTEDNESS": "the state of being directed [n -ES]\n",
  "DIRECTEDNESSES": "DIRECTEDNESS, the state of being directed [n]\n",
  "DIRECTER": "DIRECT, straightforward [adj]\n",
  "DIRECTEST": "DIRECT, straightforward [adj]\n",
  "DIRECTING": "DIRECT, to control or conduct the affairs of [v]\n",
  "DIRECTION": "aim at a certain point [n -S]\n",
  "DIRECTIONAL": "suitable for detecting the direction from which radio signals come or for sending out radio signals in one direction only [adj]\n",
  "DIRECTIONALITY": "the state of being directional [n]\n",
  "DIRECTIONLESS": "without direction [adj]\n",
  "DIRECTIONS": "DIRECTION, aim at a certain point [n]\n",
  "DIRECTIVE": "a general instruction [n -S]\n",
  "DIRECTIVES": "DIRECTIVE, a general instruction [n]\n",
  "DIRECTIVITIES": "DIRECTIVITY, the property of being directional [n]\n",
  "DIRECTIVITY": "the property of being directional [n DIRECTIVITIES]\n",
  "DIRECTLY": "DIRECT, straightforward [adv]\n",
  "DIRECTNESS": "the quality of being direct [n -ES]\n",
  "DIRECTNESSES": "DIRECTNESS, the quality of being direct [n]\n",
  "DIRECTOR": "one that directs [n -S]\n",
  "DIRECTORATE": "the office of director [n -S]\n",
  "DIRECTORATES": "DIRECTORATE, the office of director [n]\n",
  "DIRECTORIAL": "serving to direct [adj DIRECTORIALLY]\n",
  "DIRECTORIALLY": "DIRECTORIAL, serving to direct [adv]\n",
  "DIRECTORIES": "DIRECTORY, a body of directions, a guide [n]\n",
  "DIRECTORS": "DIRECTOR, one that directs [n]\n",
  "DIRECTORSHIP": "the office of director [n -S]\n",
  "DIRECTORSHIPS": "DIRECTORSHIP, the office of director [n]\n",
  "DIRECTORY": "a body of directions, a guide [n DIRECTORIES]\n",
  "DIRECTRESS": "a female director, also DIRECTRICE, DIRECTRIX [n -ES]\n",
  "DIRECTRESSES": "DIRECTRESS, a female director, also DIRECTRICE, DIRECTRIX [n]\n",
  "DIRECTRICE": "(French) a female director, also DIRECTRESS, DIRECTRIX [n -S]\n",
  "DIRECTRICES": "DIRECTRICE, (French) a female director, also DIRECTRESS, DIRECTRIX [n]\n",
  "DIRECTRIX": "a female director, also DIRECTRESS, DIRECTRICE [n DIRECTRIXES or DIRECTRICES]\n",
  "DIRECTRIXES": "DIRECTRIX, a female director, also DIRECTRESS, DIRECTRICE [n]\n",
  "DIRECTS": "DIRECT, to control or conduct the affairs of [v]\n",
  "DIREFUL": "dreadful [adj DIREFULLY]\n",
  "DIREFULLY": "DIREFUL, dreadful [adv]\n",
  "DIREFULNESS": "the state of being direful [n -ES]\n",
  "DIREFULNESSES": "DIREFULNESS, the state of being direful [n]\n",
  "DIRELY": "DIRE, disastrous [adv]\n",
  "DIREMPT": "to separate into two [v -ED, -ING, -S]\n",
  "DIREMPTED": "DIREMPT, to separate into two [v]\n",
  "DIREMPTING": "DIREMPT, to separate into two [v]\n",
  "DIREMPTION": "separation into two [n -S]\n",
  "DIREMPTIONS": "DIREMPTION, separation into two [n]\n",
  "DIREMPTS": "DIREMPT, to separate into two [v]\n",
  "DIRENESS": "the state of being dire [n -ES]\n",
  "DIRENESSES": "DIRENESS, the state of being dire [n]\n",
  "DIRER": "DIRE, disastrous [adj]\n",
  "DIREST": "DIRE, disastrous [adj]\n",
  "DIRGE": "a funeral song or hymn; a slow and mournful piece of music, also DIRIGE [n -S]\n",
  "DIRGEFUL": "funereal; moaning [adj]\n",
  "DIRGELIKE": "in the manner of a dirge [adj]\n",
  "DIRGES": "DIRGE, a funeral song or hymn; a slow and mournful piece of music, also DIRIGE [n]\n",
  "DIRHAM": "(Arabic) a Middle Eastern coin, also DERHAM, DIRHEM [n -S]\n",
  "DIRHAMS": "DIRHAM, (Arabic) a Middle Eastern coin, also DERHAM, DIRHEM [n]\n",
  "DIRHEM": "(Arabic) a Middle Eastern coin, also DIRHAM, DERHAM [n -S]\n",
  "DIRHEMS": "DIRHEM, (Arabic) a Middle Eastern coin, also DIRHAM, DERHAM [n]\n",
  "DIRIGE": "(obsolete) a dirge [n -S]\n",
  "DIRIGENT": "directing [adj]\n",
  "DIRIGES": "DIRIGE, (obsolete) a dirge [n]\n",
  "DIRIGIBILITIES": "DIRIGIBILITY, the state of being dirigible [n]\n",
  "DIRIGIBILITY": "the state of being dirigible [n DIRIGIBILITIES]\n",
  "DIRIGIBLE": "that can be directed [adj] / a dirigible balloon or airship [n -S]\n",
  "DIRIGIBLES": "DIRIGIBLE, a dirigible balloon or airship [n]\n",
  "DIRIGISM": "state control of economic and social spheres [n -S]\n",
  "DIRIGISME": "(French) state control of economic and social affairs, also DIRIGISM [n -S]\n",
  "DIRIGISMES": "DIRIGISME, (French) state control of economic and social affairs, also DIRIGISM [n]\n",
  "DIRIGISMS": "DIRIGISM, state control of economic and social spheres [n]\n",
  "DIRIGISTE": "(French) relating to State control of economic and social affairs [adj]\n",
  "DIRIMENT": "that renders absolutely void; nullifying [adj]\n",
  "DIRK": "to stab with a small knife [v -ED, -ING, -S]\n",
  "DIRKE": "(Spenser) to darken [v DIRKED, DIRKING, DIRKES]\n",
  "DIRKED": "DIRK, to stab with a small knife [v]\n",
  "DIRKES": "DIRKE, (Spenser) to darken [v]\n",
  "DIRKING": "DIRK, to stab with a small knife [v]\n",
  "DIRKS": "DIRK, to stab with a small knife [v]\n",
  "DIRL": "(Scots) to (cause to) vibrate, also THIRL, TIRL [v -ED, -ING, -S]\n",
  "DIRLED": "DIRL, (Scots) to (cause to) vibrate, also THIRL, TIRL [v]\n",
  "DIRLING": "DIRL, (Scots) to (cause to) vibrate, also THIRL, TIRL [v]\n",
  "DIRLS": "DIRL, (Scots) to (cause to) vibrate, also THIRL, TIRL [v]\n",
  "DIRNDL": "(German) an Alpine peasant woman's dress [n -S]\n",
  "DIRNDLS": "DIRNDL, (German) an Alpine peasant woman's dress [n]\n",
  "DIRT": "to make dirty [v -ED, -ING, -S]\n",
  "DIRTBAG": "a contemptible person [n -S]\n",
  "DIRTBAGS": "DIRTBAG, a contemptible person [n]\n",
  "DIRTBALL": "a dirty or contemptible person [n -S]\n",
  "DIRTBALLS": "DIRTBALL, a dirty or contemptible person [n]\n",
  "DIRTED": "DIRT, to make dirty [v]\n",
  "DIRTIED": "DIRTY, to soil [v]\n",
  "DIRTIER": "DIRTY, soiled [adj]\n",
  "DIRTIES": "DIRTY, to soil [v]\n",
  "DIRTIEST": "DIRTY, soiled [adj]\n",
  "DIRTILY": "DIRTY, soiled [adv]\n",
  "DIRTINESS": "the state of being dirty [n -ES]\n",
  "DIRTINESSES": "DIRTINESS, the state of being dirty [n]\n",
  "DIRTING": "DIRT, to make dirty [v]\n",
  "DIRTS": "DIRT, to make dirty [v]\n",
  "DIRTY": "soiled [adj DIRTIER, DIRTIEST, DIRTILY] / to soil [v DIRTIED, DIRTYING, DIRTIES]\n",
  "DIRTYING": "DIRTY, to soil [v]\n",
  "DIS": "to disparage, also DISS [v DISSED, DISSING, DISSES]\n",
  "DISA": "an African orchid, with dark green leaves [n -S]\n",
  "DISABILITIES": "DISABILITY, the condition of being disabled [n]\n",
  "DISABILITY": "the condition of being disabled [n DISABILITIES]\n",
  "DISABLE": "to render incapable, also DISHABLE [v DISABLED, DISABLING, DISABLES]\n",
  "DISABLED": "DISABLE, to render incapable, also DISHABLE [v]\n",
  "DISABLEMENT": "the act of disabling [n -S]\n",
  "DISABLEMENTS": "DISABLEMENT, the act of disabling [n]\n",
  "DISABLER": "one who disables [n -S]\n",
  "DISABLERS": "DISABLER, one who disables [n]\n",
  "DISABLES": "DISABLE, to render incapable, also DISHABLE [v]\n",
  "DISABLING": "DISABLE, to render incapable, also DISHABLE [v]\n",
  "DISABLISM": "discrimination against the disabled [n -S]\n",
  "DISABLISMS": "DISABLISM, discrimination against the disabled [n]\n",
  "DISABLIST": "one who discriminates against the disabled [n -S]\n",
  "DISABLISTS": "DISABLIST, one who discriminates against the disabled [n]\n",
  "DISABUSAL": "the act of disabusing [n -S]\n",
  "DISABUSALS": "DISABUSAL, the act of disabusing [n]\n",
  "DISABUSE": "to free from false ideas [v DISABUSED, DISABUSING, DISABUSES]\n",
  "DISABUSED": "DISABUSE, to free from false ideas [v]\n",
  "DISABUSES": "DISABUSE, to free from false ideas [v]\n",
  "DISABUSING": "DISABUSE, to free from false ideas [v]\n",
  "DISACCHARID": "any of a class of sugars, such as maltose, lactose, and sucrose, having two linked monosaccharide units per molecule [n -S]\n",
  "DISACCHARIDASE": "an enzyme (as maltase or lactase) that hydrolyzes disaccharides [n -S]\n",
  "DISACCHARIDASES": "DISACCHARIDASE, an enzyme (as maltase or lactase) that hydrolyzes disaccharides [n]\n",
  "DISACCHARIDE": "any sugar that consists of two monosaccharide residues linked together [n -S]\n",
  "DISACCHARIDES": "DISACCHARIDE, any sugar that consists of two monosaccharide residues linked together [n]\n",
  "DISACCHARIDS": "DISACCHARID, any of a class of sugars, such as maltose, lactose, and sucrose, having two linked monosaccharide units per molecule [n]\n",
  "DISACCOMMODATE": "to put to inconvenience [v DISACCOMMODATED, DISACCOMMODATES]\n",
  "DISACCOMMODATED": "DISACCOMMODATE, to put to inconvenience [v]\n",
  "DISACCOMMODATES": "DISACCOMMODATE, to put to inconvenience [v]\n",
  "DISACCORD": "to refuse to assent [v -ED, -ING, -S]\n",
  "DISACCORDANT": "lacking in accord [adj]\n",
  "DISACCORDED": "DISACCORD, to refuse to assent [v]\n",
  "DISACCORDING": "DISACCORD, to refuse to assent [v]\n",
  "DISACCORDS": "DISACCORD, to refuse to assent [v]\n",
  "DISACCREDIT": "to remove accreditation from [v -ED, -ING, -S]\n",
  "DISACCREDITED": "DISACCREDIT, to remove accreditation from [v]\n",
  "DISACCREDITING": "DISACCREDIT, to remove accreditation from [v]\n",
  "DISACCREDITS": "DISACCREDIT, to remove accreditation from [v]\n",
  "DISACCUSTOM": "to free from a habit [v -ED, -ING, -S]\n",
  "DISACCUSTOMED": "DISACCUSTOM, to free from a habit [v]\n",
  "DISACCUSTOMING": "DISACCUSTOM, to free from a habit [v]\n",
  "DISACCUSTOMS": "DISACCUSTOM, to free from a habit [v]\n",
  "DISACKNOWLEDGE": "to refuse to acknowledge, disown [v DISACKNOWLEDGED, DISACKNOWLEDGES]\n",
  "DISACKNOWLEDGED": "DISACKNOWLEDGE, to refuse to acknowledge, disown [v]\n",
  "DISACKNOWLEDGES": "DISACKNOWLEDGE, to refuse to acknowledge, disown [v]\n",
  "DISADORN": "to deprive of ornaments [v -ED, -ING, -S]\n",
  "DISADORNED": "DISADORN, to deprive of ornaments [v]\n",
  "DISADORNING": "DISADORN, to deprive of ornaments [v]\n",
  "DISADORNS": "DISADORN, to deprive of ornaments [v]\n",
  "DISADVANCE": "(Spenser) to draw back, or cause to draw back, also DISAVAUNCE [v DISADVANCED, DISADVANCING, DISADVANCES]\n",
  "DISADVANCED": "DISADVANCE, (Spenser) to draw back, or cause to draw back, also DISAVAUNCE [v]\n",
  "DISADVANCES": "DISADVANCE, (Spenser) to draw back, or cause to draw back, also DISAVAUNCE [v]\n",
  "DISADVANCING": "DISADVANCE, (Spenser) to draw back, or cause to draw back, also DISAVAUNCE [v]\n",
  "DISADVANTAGE": "to place at a disadvantage [v DISADVANTAGED, DISADVANTAGING, DISADVANTAGES]\n",
  "DISADVANTAGED": "DISADVANTAGE, to place at a disadvantage [v]\n",
  "DISADVANTAGEOUS": "constituting a disadvantage [adj]\n",
  "DISADVANTAGES": "DISADVANTAGE, to place at a disadvantage [v]\n",
  "DISADVANTAGING": "DISADVANTAGE, to place at a disadvantage [v]\n",
  "DISADVENTURE": "(Spenser) a mishap, also DISAVENTURE [n -S]\n",
  "DISADVENTURES": "DISADVENTURE, (Spenser) a mishap, also DISAVENTURE [n]\n",
  "DISADVENTUROUS": "(obsolete) unfortunate [adj]\n",
  "DISAFFECT": "to take away the affection of; to make discontented or unfriendly [v -ED, -ING, -S]\n",
  "DISAFFECTED": "DISAFFECT, to take away the affection of; to make discontented or unfriendly [v]\n",
  "DISAFFECTEDLY": "DISAFFECTED, DISAFFECT, to take away the affection of; to make discontented or unfriendly [adv]\n",
  "DISAFFECTEDNESS": "the state of being disaffected [n]\n",
  "DISAFFECTING": "DISAFFECT, to take away the affection of; to make discontented or unfriendly [v]\n",
  "DISAFFECTION": "the state of being disaffected [n -S]\n",
  "DISAFFECTIONATE": "showing disaffection [adj]\n",
  "DISAFFECTIONS": "DISAFFECTION, the state of being disaffected [n]\n",
  "DISAFFECTS": "DISAFFECT, to take away the affection of; to make discontented or unfriendly [v]\n",
  "DISAFFILIATE": "to end an affiliation [v DISAFFILIATED, DISAFFILIATING, DISAFFILIATES]\n",
  "DISAFFILIATED": "DISAFFILIATE, to end an affiliation [v]\n",
  "DISAFFILIATES": "DISAFFILIATE, to end an affiliation [v]\n",
  "DISAFFILIATING": "DISAFFILIATE, to end an affiliation [v]\n",
  "DISAFFILIATION": "the act of disaffiliating [n -S]\n",
  "DISAFFILIATIONS": "DISAFFILIATION, the act of disaffiliating [n]\n",
  "DISAFFIRM": "to assert the contrary of; to contradict [v -ED, -ING, -S]\n",
  "DISAFFIRMANCE": "the act of disaffirming [n -S]\n",
  "DISAFFIRMANCES": "DISAFFIRMANCE, the act of disaffirming [n]\n",
  "DISAFFIRMATION": "the act of disaffirming [n -S]\n",
  "DISAFFIRMATIONS": "DISAFFIRMATION, the act of disaffirming [n]\n",
  "DISAFFIRMED": "DISAFFIRM, to assert the contrary of; to contradict [v]\n",
  "DISAFFIRMING": "DISAFFIRM, to assert the contrary of; to contradict [v]\n",
  "DISAFFIRMS": "DISAFFIRM, to assert the contrary of; to contradict [v]\n",
  "DISAFFOREST": "to clear of forest, also DISFOREST [v -ED, -ING, -S]\n",
  "DISAFFORESTED": "DISAFFOREST, to clear of forest, also DISFOREST [v]\n",
  "DISAFFORESTING": "DISAFFOREST, to clear of forest, also DISFOREST [v]\n",
  "DISAFFORESTMENT": "the act of disafforesting [n]\n",
  "DISAFFORESTS": "DISAFFOREST, to clear of forest, also DISFOREST [v]\n",
  "DISAGGREGATE": "to separate into component parts [v DISAGGREGATED, DISAGGREGATING, DISAGGREGATES]\n",
  "DISAGGREGATED": "DISAGGREGATE, to separate into component parts [v]\n",
  "DISAGGREGATES": "DISAGGREGATE, to separate into component parts [v]\n",
  "DISAGGREGATING": "DISAGGREGATE, to separate into component parts [v]\n",
  "DISAGGREGATION": "the act of disaggregating [n -S]\n",
  "DISAGGREGATIONS": "DISAGGREGATION, the act of disaggregating [n]\n",
  "DISAGGREGATIVE": "tending to disaggregate [adj]\n",
  "DISAGREE": "to differ in opinion [v DISAGREED, DISAGREEING, DISAGREES]\n",
  "DISAGREEABILITY": "the quality of being disagreeable [n]\n",
  "DISAGREEABLE": "causing discomfort [adj DISAGREEABLY] / something causing discomfort [n -S]\n",
  "DISAGREEABLES": "DISAGREEABLE, something causing discomfort [n]\n",
  "DISAGREEABLY": "DISAGREEABLE, causing discomfort [adv]\n",
  "DISAGREED": "DISAGREE, to differ in opinion [v]\n",
  "DISAGREEING": "DISAGREE, to differ in opinion [v]\n",
  "DISAGREEMENT": "the act of disagreeing [n -S]\n",
  "DISAGREEMENTS": "DISAGREEMENT, the act of disagreeing [n]\n",
  "DISAGREES": "DISAGREE, to differ in opinion [v]\n",
  "DISALLIED": "DISALLY, to break an alliance [v]\n",
  "DISALLIES": "DISALLY, to break an alliance [v]\n",
  "DISALLOW": "to refuse to allow [v -ED, -ING, -S]\n",
  "DISALLOWABLE": "that can be disallowed [adj]\n",
  "DISALLOWANCE": "the act of disallowing [n -S]\n",
  "DISALLOWANCES": "DISALLOWANCE, the act of disallowing [n]\n",
  "DISALLOWED": "DISALLOW, to refuse to allow [v]\n",
  "DISALLOWING": "DISALLOW, to refuse to allow [v]\n",
  "DISALLOWS": "DISALLOW, to refuse to allow [v]\n",
  "DISALLY": "to break an alliance [v DISALLIED, DISALLYING, DISALLIES]\n",
  "DISALLYING": "DISALLY, to break an alliance [v]\n",
  "DISAMBIGUATE": "to establish a single grammatical interpretation [v DISAMBIGUATED, DISAMBIGUATING, DISAMBIGUATES]\n",
  "DISAMBIGUATED": "DISAMBIGUATE, to establish a single grammatical interpretation [v]\n",
  "DISAMBIGUATES": "DISAMBIGUATE, to establish a single grammatical interpretation [v]\n",
  "DISAMBIGUATING": "DISAMBIGUATE, to establish a single grammatical interpretation [v]\n",
  "DISAMBIGUATION": "the establishment of a single semantic or grammatical interpretation [n -S]\n",
  "DISAMBIGUATIONS": "DISAMBIGUATION, the establishment of a single semantic or grammatical interpretation [n]\n",
  "DISAMENITIES": "DISAMENITY, a lack of amenity; a disadvantage or drawback [n]\n",
  "DISAMENITY": "a lack of amenity; a disadvantage or drawback [n DISAMENITIES]\n",
  "DISANALOGIES": "DISANALOGY, a non-correspondence [n]\n",
  "DISANALOGOUS": "not analogous [adj]\n",
  "DISANALOGY": "a non-correspondence [n DISANALOGIES]\n",
  "DISANCHOR": "to raise the anchor, as of a ship [v -ED, -ING, -S]\n",
  "DISANCHORED": "DISANCHOR, to raise the anchor, as of a ship [v]\n",
  "DISANCHORING": "DISANCHOR, to raise the anchor, as of a ship [v]\n",
  "DISANCHORS": "DISANCHOR, to raise the anchor, as of a ship [v]\n",
  "DISANIMATE": "to deprive of life [v DISANIMATED, DISANIMATING, DISANIMATES]\n",
  "DISANIMATED": "DISANIMATE, to deprive of life [v]\n",
  "DISANIMATES": "DISANIMATE, to deprive of life [v]\n",
  "DISANIMATING": "DISANIMATE, to deprive of life [v]\n",
  "DISANNEX": "to disunite; to undo or repeal the annexation of [v DISANNEXED, DISANNEXING, DISANNEXES]\n",
  "DISANNEXED": "DISANNEX, to disunite; to undo or repeal the annexation of [v]\n",
  "DISANNEXES": "DISANNEX, to disunite; to undo or repeal the annexation of [v]\n",
  "DISANNEXING": "DISANNEX, to disunite; to undo or repeal the annexation of [v]\n",
  "DISANNUL": "to annul completely [v DISANNULLED, DISANNULLING, DISANNULS]\n",
  "DISANNULLED": "DISANNUL, to annul completely [v]\n",
  "DISANNULLER": "one who disannuls [n -S]\n",
  "DISANNULLERS": "DISANNULLER, one who disannuls [n]\n",
  "DISANNULLING": "the act of disannulling [n -S]\n",
  "DISANNULLINGS": "DISANNULLING, the act of disannulling [n]\n",
  "DISANNULMENT": "the act of disannulling [n -S]\n",
  "DISANNULMENTS": "DISANNULMENT, the act of disannulling [n]\n",
  "DISANNULS": "DISANNUL, to annul completely [v]\n",
  "DISANOINT": "to undo the anointing or consecration of [v -ED, -ING, -S]\n",
  "DISANOINTED": "DISANOINT, to undo the anointing or consecration of [v]\n",
  "DISANOINTING": "DISANOINT, to undo the anointing or consecration of [v]\n",
  "DISANOINTS": "DISANOINT, to undo the anointing or consecration of [v]\n",
  "DISAPPAREL": "to disrobe; to strip of apparel [v DISAPPARELLED, DISAPPARELLING, DISAPPARELS]\n",
  "DISAPPARELLED": "DISAPPAREL, to disrobe; to strip of apparel [v]\n",
  "DISAPPARELLING": "DISAPPAREL, to disrobe; to strip of apparel [v]\n",
  "DISAPPARELS": "DISAPPAREL, to disrobe; to strip of apparel [v]\n",
  "DISAPPEAR": "to vanish from sight [v -ED, -ING, -S]\n",
  "DISAPPEARANCE": "the act of disappearing [n -S]\n",
  "DISAPPEARANCES": "DISAPPEARANCE, the act of disappearing [n]\n",
  "DISAPPEARED": "DISAPPEAR, to vanish from sight [v]\n",
  "DISAPPEARING": "DISAPPEAR, to vanish from sight [v]\n",
  "DISAPPEARS": "DISAPPEAR, to vanish from sight [v]\n",
  "DISAPPLICATION": "the act of disapplying, rendering a law inapplicable [n -S]\n",
  "DISAPPLICATIONS": "DISAPPLICATION, the act of disapplying, rendering a law inapplicable [n]\n",
  "DISAPPLIED": "DISAPPLY, to make a law inapplicable [v]\n",
  "DISAPPLIES": "DISAPPLY, to make a law inapplicable [v]\n",
  "DISAPPLY": "to make a law inapplicable [v DISAPPLIED, DISAPPLYING, DISAPPLIES]\n",
  "DISAPPLYING": "DISAPPLY, to make a law inapplicable [v]\n",
  "DISAPPOINT": "to fail to meet the expectation or hope of [v -ED, -ING, -S]\n",
  "DISAPPOINTED": "DISAPPOINT, to fail to meet the expectation or hope of [v]\n",
  "DISAPPOINTEDLY": "DISAPPOINTED, DISAPPOINT, to fail to meet the expectation or hope of [adv]\n",
  "DISAPPOINTING": "DISAPPOINT, to fail to meet the expectation or hope of [v]\n",
  "DISAPPOINTINGLY": "DISAPPOINTING, DISAPPOINT, to fail to meet the expectation or hope of [adv]\n",
  "DISAPPOINTMENT": "the act or an instance of disappointing [n -S]\n",
  "DISAPPOINTMENTS": "DISAPPOINTMENT, the act or an instance of disappointing [n]\n",
  "DISAPPOINTS": "DISAPPOINT, to fail to meet the expectation or hope of [v]\n",
  "DISAPPROBATION": "the act or state of disapproving [n -S]\n",
  "DISAPPROBATIONS": "DISAPPROBATION, the act or state of disapproving [n]\n",
  "DISAPPROBATIVE": "disapproving [adj]\n",
  "DISAPPROBATORY": "disapproving [adj]\n",
  "DISAPPROPRIATE": "to take away from the condition of being appropriated [v DISAPPROPRIATED, DISAPPROPRIATES]\n",
  "DISAPPROPRIATED": "DISAPPROPRIATE, to take away from the condition of being appropriated [v]\n",
  "DISAPPROPRIATES": "DISAPPROPRIATE, to take away from the condition of being appropriated [v]\n",
  "DISAPPROVAL": "censure, disapprobation [n -S]\n",
  "DISAPPROVALS": "DISAPPROVAL, censure, disapprobation [n]\n",
  "DISAPPROVE": "to pass unfavorable judgment on [v DISAPPROVED, DISAPPROVING, DISAPPROVES]\n",
  "DISAPPROVED": "DISAPPROVE, to pass unfavorable judgment on [v]\n",
  "DISAPPROVER": "one who disapproves [n -S]\n",
  "DISAPPROVERS": "DISAPPROVER, one who disapproves [n]\n",
  "DISAPPROVES": "DISAPPROVE, to pass unfavorable judgment on [v]\n",
  "DISAPPROVING": "passing unfavorable judgment on [adj DISAPPROVINGLY]\n",
  "DISAPPROVINGLY": "DISAPPROVING, passing unfavorable judgment on [adv]\n",
  "DISARM": "to deprive of weapons [v -ED, -ING, -S]\n",
  "DISARMAMENT": "the act of disarming [n -S]\n",
  "DISARMAMENTS": "DISARMAMENT, the act of disarming [n]\n",
  "DISARMED": "DISARM, to deprive of weapons [v]\n",
  "DISARMER": "one that disarms [n -S]\n",
  "DISARMERS": "DISARMER, one that disarms [n]\n",
  "DISARMING": "DISARM, to deprive of weapons [v]\n",
  "DISARMINGLY": "DISARMING, DISARM, to deprive of weapons [adv]\n",
  "DISARMS": "DISARM, to deprive of weapons [v]\n",
  "DISARRANGE": "to disturb the arrangement of [v DISARRANGED, DISARRANGING, DISARRANGES]\n",
  "DISARRANGED": "DISARRANGE, to disturb the arrangement of [v]\n",
  "DISARRANGEMENT": "the act of disarranging [n -S]\n",
  "DISARRANGEMENTS": "DISARRANGEMENT, the act of disarranging [n]\n",
  "DISARRANGES": "DISARRANGE, to disturb the arrangement of [v]\n",
  "DISARRANGING": "DISARRANGE, to disturb the arrangement of [v]\n",
  "DISARRAY": "to throw into disorder [v -ED, -ING, -S]\n",
  "DISARRAYED": "DISARRAY, to throw into disorder [v]\n",
  "DISARRAYING": "DISARRAY, to throw into disorder [v]\n",
  "DISARRAYS": "DISARRAY, to throw into disorder [v]\n",
  "DISARTICULATE": "to separate at a joint or articulation [v DISARTICULATED, DISARTICULATING, DISARTICULATES]\n",
  "DISARTICULATED": "DISARTICULATE, to separate at a joint or articulation [v]\n",
  "DISARTICULATES": "DISARTICULATE, to separate at a joint or articulation [v]\n",
  "DISARTICULATING": "DISARTICULATE, to separate at a joint or articulation [v]\n",
  "DISARTICULATION": "the act of disarticulating [n]\n",
  "DISARTICULATOR": "a device for disarticulating joints [n -S]\n",
  "DISARTICULATORS": "DISARTICULATOR, a device for disarticulating joints [n]\n",
  "DISAS": "DISA, an African orchid, with dark green leaves [n]\n",
  "DISASSEMBLE": "to take apart [v DISASSEMBLED, DISASSEMBLING, DISASSEMBLES]\n",
  "DISASSEMBLED": "DISASSEMBLE, to take apart [v]\n",
  "DISASSEMBLER": "a program that translates from machine code to an assembly language [n -S]\n",
  "DISASSEMBLERS": "DISASSEMBLER, a program that translates from machine code to an assembly language [n]\n",
  "DISASSEMBLES": "DISASSEMBLE, to take apart [v]\n",
  "DISASSEMBLIES": "DISASSEMBLY, the act of disassembling, also DISSEMBLY [n]\n",
  "DISASSEMBLING": "DISASSEMBLE, to take apart [v]\n",
  "DISASSEMBLY": "the act of disassembling, also DISSEMBLY [n DISASSEMBLIES]\n",
  "DISASSIMILATE": "to subject to catabolism [v DISASSIMILATED, DISASSIMILATING, DISASSIMILATES]\n",
  "DISASSIMILATED": "DISASSIMILATE, to subject to catabolism [v]\n",
  "DISASSIMILATES": "DISASSIMILATE, to subject to catabolism [v]\n",
  "DISASSIMILATING": "DISASSIMILATE, to subject to catabolism [v]\n",
  "DISASSIMILATION": "the act of disassimilating, subjecting to catabolism [n]\n",
  "DISASSIMILATIVE": "relating to the act of dissimilation, subjecting to catabolism [adj]\n",
  "DISASSOCIATE": "to separate from association or union with another, also DISSOCIATE [v DISASSOCIATED, DISASSOCIATING, DISASSOCIATES]\n",
  "DISASSOCIATED": "DISASSOCIATE, to separate from association or union with another, also DISSOCIATE [v]\n",
  "DISASSOCIATES": "DISASSOCIATE, to separate from association or union with another, also DISSOCIATE [v]\n",
  "DISASSOCIATING": "DISASSOCIATE, to separate from association or union with another, also DISSOCIATE [v]\n",
  "DISASSOCIATION": "the act of disassociating [n -S]\n",
  "DISASSOCIATIONS": "DISASSOCIATION, the act of disassociating [n]\n",
  "DISASTER": "a calamity [n -S]\n",
  "DISASTERS": "DISASTER, a calamity [n]\n",
  "DISASTROUS": "attended by or causing suffering or disaster [adj DISASTROUSLY]\n",
  "DISASTROUSLY": "DISASTROUS, attended by or causing suffering or disaster [adv]\n",
  "DISATTIRE": "(Spenser) to unrobe; to undress [v DISATTIRED, DISATTIRING, DISATTIRES]\n",
  "DISATTIRED": "DISATTIRE, (Spenser) to unrobe; to undress [v]\n",
  "DISATTIRES": "DISATTIRE, (Spenser) to unrobe; to undress [v]\n",
  "DISATTIRING": "DISATTIRE, (Spenser) to unrobe; to undress [v]\n",
  "DISATTRIBUTION": "the act of adjudging a work of art, etc. to be no longer the product of a particular artist etc. [n -S]\n",
  "DISATTRIBUTIONS": "DISATTRIBUTION, the act of adjudging a work of art, etc. to be no longer the product of a particular artist etc. [n]\n",
  "DISATTUNE": "to put out of harmony [v DISATTUNED, DISATTUNING, DISATTUNES]\n",
  "DISATTUNED": "DISATTUNE, to put out of harmony [v]\n",
  "DISATTUNES": "DISATTUNE, to put out of harmony [v]\n",
  "DISATTUNING": "DISATTUNE, to put out of harmony [v]\n",
  "DISAUTHORISE": "to deprive of authority, also DISAUTHORIZE [v DISAUTHORISED, DISAUTHORISING, DISAUTHORISES]\n",
  "DISAUTHORISED": "DISAUTHORISE, to deprive of authority, also DISAUTHORIZE [v]\n",
  "DISAUTHORISES": "DISAUTHORISE, to deprive of authority, also DISAUTHORIZE [v]\n",
  "DISAUTHORISING": "DISAUTHORISE, to deprive of authority, also DISAUTHORIZE [v]\n",
  "DISAUTHORIZE": "to deprive of authority, also DISAUTHORISE [v DISAUTHORIZED, DISAUTHORIZING, DISAUTHORIZES]\n",
  "DISAUTHORIZED": "DISAUTHORIZE, to deprive of authority, also DISAUTHORISE [v]\n",
  "DISAUTHORIZES": "DISAUTHORIZE, to deprive of authority, also DISAUTHORISE [v]\n",
  "DISAUTHORIZING": "DISAUTHORIZE, to deprive of authority, also DISAUTHORISE [v]\n",
  "DISAVAUNCE": "(Spenser) to retard; to repel, also DISADVANCE [v DISAVAUNCED, DISAVAUNCING, DISAVAUNCES]\n",
  "DISAVAUNCED": "DISAVAUNCE, (Spenser) to retard; to repel, also DISADVANCE [v]\n",
  "DISAVAUNCES": "DISAVAUNCE, (Spenser) to retard; to repel, also DISADVANCE [v]\n",
  "DISAVAUNCING": "DISAVAUNCE, (Spenser) to retard; to repel, also DISADVANCE [v]\n",
  "DISAVENTROUS": "(Spenser) unfortunate [adj]\n",
  "DISAVENTURE": "(Spenser) a mishap, also DISADVENTURE [n -S]\n",
  "DISAVENTURES": "DISAVENTURE, (Spenser) a mishap, also DISADVENTURE [n]\n",
  "DISAVOUCH": "(obsolete) to disavow, also DISAVOW [v -ED, -ING, -ES]\n",
  "DISAVOUCHED": "DISAVOUCH, (obsolete) to disavow, also DISAVOW [v]\n",
  "DISAVOUCHES": "DISAVOUCH, (obsolete) to disavow, also DISAVOW [v]\n",
  "DISAVOUCHING": "DISAVOUCH, (obsolete) to disavow, also DISAVOW [v]\n",
  "DISAVOW": "to disclaim responsibility for [v -ED, -ING, -S]\n",
  "DISAVOWABLE": "that can be disavowed [adj]\n",
  "DISAVOWAL": "the act of disavowing [n -S]\n",
  "DISAVOWALS": "DISAVOWAL, the act of disavowing [n]\n",
  "DISAVOWED": "DISAVOW, to disclaim responsibility for [v]\n",
  "DISAVOWEDLY": "DISAVOWED, DISAVOW, to disclaim responsibility for [adv]\n",
  "DISAVOWER": "one who disavows [n -S]\n",
  "DISAVOWERS": "DISAVOWER, one who disavows [n]\n",
  "DISAVOWING": "DISAVOW, to disclaim responsibility for [v]\n",
  "DISAVOWS": "DISAVOW, to disclaim responsibility for [v]\n",
  "DISBAND": "to break up [v -ED, -ING, -S]\n",
  "DISBANDED": "DISBAND, to break up [v]\n",
  "DISBANDING": "DISBAND, to break up [v]\n",
  "DISBANDMENT": "the act of disbanding [n -S]\n",
  "DISBANDMENTS": "DISBANDMENT, the act of disbanding [n]\n",
  "DISBANDS": "DISBAND, to break up [v]\n",
  "DISBAR": "to expel from the legal profession [v DISBARRED, DISBARRING, DISBARS]\n",
  "DISBARK": "to strip of bark [v -ED, -ING, -S]\n",
  "DISBARKED": "DISBARK, to strip of bark [v]\n",
  "DISBARKING": "DISBARK, to strip of bark [v]\n",
  "DISBARKS": "DISBARK, to strip of bark [v]\n",
  "DISBARMENT": "the act of disbarring [n -S]\n",
  "DISBARMENTS": "DISBARMENT, the act of disbarring [n]\n",
  "DISBARRED": "DISBAR, to expel from the legal profession [v]\n",
  "DISBARRING": "DISBAR, to expel from the legal profession [v]\n",
  "DISBARS": "DISBAR, to expel from the legal profession [v]\n",
  "DISBELIEF": "lack of belief [n -S]\n",
  "DISBELIEFS": "DISBELIEF, lack of belief [n]\n",
  "DISBELIEVE": "to hold not worthy of belief [v DISBELIEVED, DISBELIEVING, DISBELIEVES]\n",
  "DISBELIEVED": "DISBELIEVE, to hold not worthy of belief [v]\n",
  "DISBELIEVER": "one who disbelieves [n -S]\n",
  "DISBELIEVERS": "DISBELIEVER, one who disbelieves [n]\n",
  "DISBELIEVES": "DISBELIEVE, to hold not worthy of belief [v]\n",
  "DISBELIEVING": "incredulous [adj DISBELIEVINGLY]\n",
  "DISBELIEVINGLY": "DISBELIEVING, incredulous [adv]\n",
  "DISBENCH": "to drive from a bench [v -ED, -ING, -ES]\n",
  "DISBENCHED": "DISBENCH, to drive from a bench [v]\n",
  "DISBENCHES": "DISBENCH, to drive from a bench [v]\n",
  "DISBENCHING": "DISBENCH, to drive from a bench [v]\n",
  "DISBENEFIT": "a drawback, loss, inconvenience [n -S]\n",
  "DISBENEFITS": "DISBENEFIT, a drawback, loss, inconvenience [n]\n",
  "DISBODIED": "disembodied [adj]\n",
  "DISBOSOM": "to make known; to reveal [v -ED, -ING, -S]\n",
  "DISBOSOMED": "DISBOSOM, to make known; to reveal [v]\n",
  "DISBOSOMING": "DISBOSOM, to make known; to reveal [v]\n",
  "DISBOSOMS": "DISBOSOM, to make known; to reveal [v]\n",
  "DISBOUND": "not having a binding [adj]\n",
  "DISBOWEL": "to remove the intestines of [v DISBOWELED or DISBOWELLED, DISBOWELING or DISBOWELLING, DISBOWELS]\n",
  "DISBOWELED": "DISBOWEL, to remove the intestines of [v]\n",
  "DISBOWELING": "DISBOWEL, to remove the intestines of [v]\n",
  "DISBOWELLED": "DISBOWEL, to remove the intestines of [v]\n",
  "DISBOWELLING": "DISBOWEL, to remove the intestines of [v]\n",
  "DISBOWELS": "DISBOWEL, to remove the intestines of [v]\n",
  "DISBRANCH": "to divest of a branch or branches [v -ED, -ING, -ES]\n",
  "DISBRANCHED": "DISBRANCH, to divest of a branch or branches [v]\n",
  "DISBRANCHES": "DISBRANCH, to divest of a branch or branches [v]\n",
  "DISBRANCHING": "DISBRANCH, to divest of a branch or branches [v]\n",
  "DISBUD": "to remove buds from [v DISBUDDED, DISBUDDING, DISBUDS]\n",
  "DISBUDDED": "DISBUD, to remove buds from [v]\n",
  "DISBUDDING": "DISBUD, to remove buds from [v]\n",
  "DISBUDS": "DISBUD, to remove buds from [v]\n",
  "DISBURDEN": "to rid of a burden, also DISBURTHEN [v -ED, -ING, -S]\n",
  "DISBURDENED": "DISBURDEN, to rid of a burden, also DISBURTHEN [v]\n",
  "DISBURDENING": "DISBURDEN, to rid of a burden, also DISBURTHEN [v]\n",
  "DISBURDENMENT": "the act of disburdening [n -S]\n",
  "DISBURDENMENTS": "DISBURDENMENT, the act of disburdening [n]\n",
  "DISBURDENS": "DISBURDEN, to rid of a burden, also DISBURTHEN [v]\n",
  "DISBURSABLE": "that can be disbursed [adj]\n",
  "DISBURSAL": "the act of disbursing [n -S]\n",
  "DISBURSALS": "DISBURSAL, the act of disbursing [n]\n",
  "DISBURSE": "to pay out [v DISBURSED, DISBURSING, DISBURSES]\n",
  "DISBURSED": "DISBURSE, to pay out [v]\n",
  "DISBURSEMENT": "the act of disbursing [n -S]\n",
  "DISBURSEMENTS": "DISBURSEMENT, the act of disbursing [n]\n",
  "DISBURSER": "one who disburses [n -S]\n",
  "DISBURSERS": "DISBURSER, one who disburses [n]\n",
  "DISBURSES": "DISBURSE, to pay out [v]\n",
  "DISBURSING": "DISBURSE, to pay out [v]\n",
  "DISBURTHEN": "to get rid of a burden, also DISBURDEN [v -ED, -ING, -S]\n",
  "DISBURTHENED": "DISBURTHEN, to get rid of a burden, also DISBURDEN [v]\n",
  "DISBURTHENING": "DISBURTHEN, to get rid of a burden, also DISBURDEN [v]\n",
  "DISBURTHENS": "DISBURTHEN, to get rid of a burden, also DISBURDEN [v]\n",
  "DISC": "to break up land with a kind of harrow, also DISK [v -ED, -ING, -S]\n",
  "DISCAGE": "to free from a cage [v DISCAGED, DISCAGING, DISCAGES]\n",
  "DISCAGED": "DISCAGE, to free from a cage [v]\n",
  "DISCAGES": "DISCAGE, to free from a cage [v]\n",
  "DISCAGING": "DISCAGE, to free from a cage [v]\n",
  "DISCAL": "pertaining to a disc [adj]\n",
  "DISCALCEATE": "unshod [adj] / one who goes unshod, a discalced friar [n -S]\n",
  "DISCALCEATES": "DISCALCEATE, one who goes unshod, a discalced friar [n]\n",
  "DISCALCED": "unshod; barefoot as in discalced friars [adj]\n",
  "DISCANDERING": "(Shakespeare) melting from a state of being candied [n -S]\n",
  "DISCANDERINGS": "DISCANDERING, (Shakespeare) melting from a state of being candied [n]\n",
  "DISCANDIE": "(Shakespeare) to dissolve or melt from a state of being candied, also DISCANDY [v DISCANDIED, DISCANDYING, DISCANDIES]\n",
  "DISCANDIED": "DISCANDY, (Shakespeare) to dissolve or melt from a state of being candied, also DISCANDIE [v]\n",
  "DISCANDIES": "DISCANDY, (Shakespeare) to dissolve or melt from a state of being candied, also DISCANDIE [v]\n",
  "DISCANDY": "(Shakespeare) to dissolve or melt from a state of being candied, also DISCANDIE [v DISCANDIED, DISCANDYING, DISCANDIES]\n",
  "DISCANDYING": "the act of melting from a state of being candied [n -S]\n",
  "DISCANDYINGS": "DISCANDYING, the act of melting from a state of being candied [n]\n",
  "DISCANT": "to sing, also DESCANT [v -ED, -ING, -S]\n",
  "DISCANTED": "DISCANT, to sing, also DESCANT [v]\n",
  "DISCANTER": "one who sings the discant [n -S]\n",
  "DISCANTERS": "DISCANTER, one who sings the discant [n]\n",
  "DISCANTING": "DISCANT, to sing, also DESCANT [v]\n",
  "DISCANTS": "DISCANT, to sing, also DESCANT [v]\n",
  "DISCAPACITATE": "to incapacitate [v DISCAPACITATED, DISCAPACITATING, DISCAPACITATES]\n",
  "DISCAPACITATED": "DISCAPACITATE, to incapacitate [v]\n",
  "DISCAPACITATES": "DISCAPACITATE, to incapacitate [v]\n",
  "DISCAPACITATING": "DISCAPACITATE, to incapacitate [v]\n",
  "DISCARD": "to throw away [v -ED, -ING, -S]\n",
  "DISCARDABLE": "that can be discarded [adj]\n",
  "DISCARDED": "DISCARD, to throw away [v]\n",
  "DISCARDER": "one who discards [n -S]\n",
  "DISCARDERS": "DISCARDER, one who discards [n]\n",
  "DISCARDING": "DISCARD, to throw away [v]\n",
  "DISCARDMENT": "the act of discarding [n -S]\n",
  "DISCARDMENTS": "DISCARDMENT, the act of discarding [n]\n",
  "DISCARDS": "DISCARD, to throw away [v]\n",
  "DISCARNATE": "disembodied; separated from the body [adj]\n",
  "DISCASE": "(Shakespeare) to undress [v DISCASED, DISCASING, DISCASES]\n",
  "DISCASED": "DISCASE, (Shakespeare) to undress [v]\n",
  "DISCASES": "DISCASE, (Shakespeare) to undress [v]\n",
  "DISCASING": "DISCASE, (Shakespeare) to undress [v]\n",
  "DISCED": "DISC, to break up land with a kind of harrow, also DISK [v]\n",
  "DISCEPT": "to dispute, debate [v -ED, -ING, -S]\n",
  "DISCEPTATION": "(archaic) the act of discepting [n -S]\n",
  "DISCEPTATIONS": "DISCEPTATION, (archaic) the act of discepting [n]\n",
  "DISCEPTATIOUS": "(obsolete) relating to being discepted [adj]\n",
  "DISCEPTATOR": "(obsolete) one who discepts [n -S]\n",
  "DISCEPTATORIAL": "(obsolete) relating to debate [adj]\n",
  "DISCEPTATORS": "DISCEPTATOR, (obsolete) one who discepts [n]\n",
  "DISCEPTED": "DISCEPT, to dispute, debate [v]\n",
  "DISCEPTING": "DISCEPT, to dispute, debate [v]\n",
  "DISCEPTS": "DISCEPT, to dispute, debate [v]\n",
  "DISCERN": "to perceive, also SCERNE [v -ED, -ING, -S]\n",
  "DISCERNABLE": "that can be discerned, also DISCERNIBLE [adj DISCERNABLY]\n",
  "DISCERNABLY": "DISCERNABLE, that can be discerned, also DISCERNIBLE [adv]\n",
  "DISCERNED": "DISCERN, to perceive, also SCERNE [v]\n",
  "DISCERNER": "one who discerns [n -S]\n",
  "DISCERNERS": "DISCERNER, one who discerns [n]\n",
  "DISCERNIBLE": "that can be discerned, also DISCERNABLE [adj DISCERNIBLY]\n",
  "DISCERNIBLY": "DISCERNIBLE, that can be discerned, also DISCERNABLE [adv]\n",
  "DISCERNING": "DISCERN, to perceive, also SCERNE [v]\n",
  "DISCERNINGLY": "DISCERNING, DISCERN, to perceive, also SCERNE [adv]\n",
  "DISCERNMENT": "the quality of being able to grasp and comprehend what is obscure [n -S]\n",
  "DISCERNMENTS": "DISCERNMENT, the quality of being able to grasp and comprehend what is obscure [n]\n",
  "DISCERNS": "DISCERN, to perceive, also SCERNE [v]\n",
  "DISCERP": "to separate [v -ED, -ING, -S]\n",
  "DISCERPED": "DISCERP, to separate [v]\n",
  "DISCERPIBILITY": "the state of being discerpible [n]\n",
  "DISCERPIBLE": "(obsolete) that can be discerped [adj]\n",
  "DISCERPING": "DISCERP, to separate [v]\n",
  "DISCERPS": "DISCERP, to separate [v]\n",
  "DISCERPTIBLE": "able to be separated [adj]\n",
  "DISCERPTION": "the act of discerping [n -S]\n",
  "DISCERPTIONS": "DISCERPTION, the act of discerping [n]\n",
  "DISCERPTIVE": "tending to discerp [adj]\n",
  "DISCHARGE": "to free from or relieve of a charge of any kind [v DISCHARGED, DISCHARGING, DISCHARGES]\n",
  "DISCHARGEABLE": "capable of being discharged [adj]\n",
  "DISCHARGED": "DISCHARGE, to free from or relieve of a charge of any kind [v]\n",
  "DISCHARGEE": "one who is discharged [n -S]\n",
  "DISCHARGEES": "DISCHARGEE, one who is discharged [n]\n",
  "DISCHARGER": "one who, or that which, discharges [n -S]\n",
  "DISCHARGERS": "DISCHARGER, one who, or that which, discharges [n]\n",
  "DISCHARGES": "DISCHARGE, to free from or relieve of a charge of any kind [v]\n",
  "DISCHARGING": "DISCHARGE, to free from or relieve of a charge of any kind [v]\n",
  "DISCHUFFED": "(colloquial) not pleased [adj]\n",
  "DISCHURCH": "(obsolete) to deprive of church rank or privileges [v -ED, -ING, -ES]\n",
  "DISCHURCHED": "DISCHURCH, (obsolete) to deprive of church rank or privileges [v]\n",
  "DISCHURCHES": "DISCHURCH, (obsolete) to deprive of church rank or privileges [v]\n",
  "DISCHURCHING": "DISCHURCH, (obsolete) to deprive of church rank or privileges [v]\n",
  "DISCI": "DISCUS, (Latin) a disc hurled in athletic competition [n]\n",
  "DISCIDE": "to cut asunder [v DISCIDED, DISCIDING, DISCIDES]\n",
  "DISCIDED": "DISCIDE, to cut asunder [v]\n",
  "DISCIDES": "DISCIDE, to cut asunder [v]\n",
  "DISCIDING": "DISCIDE, to cut asunder [v]\n",
  "DISCIFORM": "round or oval in shape [adj]\n",
  "DISCINCT": "ungirded [adj]\n",
  "DISCING": "DISC, to break up land with a kind of harrow, also DISK [v]\n",
  "DISCIPLE": "to cause to become a follower [v DISCIPLED, DISCIPLING, DISCIPLES]\n",
  "DISCIPLED": "DISCIPLE, to cause to become a follower [v]\n",
  "DISCIPLES": "DISCIPLE, to cause to become a follower [v]\n",
  "DISCIPLESHIP": "the office of disciple [n -S]\n",
  "DISCIPLESHIPS": "DISCIPLESHIP, the office of disciple [n]\n",
  "DISCIPLINABLE": "docile, teachable [adj]\n",
  "DISCIPLINAL": "relating to discipline [adj]\n",
  "DISCIPLINANT": "a person who subjects themselves to a discipline, esp. one of an order of Spanish flagellants [n -S]\n",
  "DISCIPLINANTS": "DISCIPLINANT, a person who subjects themselves to a discipline, esp. one of an order of Spanish flagellants [n]\n",
  "DISCIPLINARIAN": "one who disciplines or enforces order [n -S]\n",
  "DISCIPLINARIANS": "DISCIPLINARIAN, one who disciplines or enforces order [n]\n",
  "DISCIPLINARILY": "DISCIPLINARY, serving to discipline [adv]\n",
  "DISCIPLINARITY": "the state of being disciplinary [n]\n",
  "DISCIPLINARIUM": "a scourge for penitential flogging [n -S]\n",
  "DISCIPLINARIUMS": "DISCIPLINARIUM, a scourge for penitential flogging [n]\n",
  "DISCIPLINARY": "serving to discipline [adj DISCIPLINARILY]\n",
  "DISCIPLINE": "to punish or penalize for the sake of discipline [v DISCIPLINED, DISCIPLINING, DISCIPLINES]\n",
  "DISCIPLINED": "DISCIPLINE, to punish or penalize for the sake of discipline [v]\n",
  "DISCIPLINER": "one who disciplines [n -S]\n",
  "DISCIPLINERS": "DISCIPLINER, one who disciplines [n]\n",
  "DISCIPLINES": "DISCIPLINE, to punish or penalize for the sake of discipline [v]\n",
  "DISCIPLING": "DISCIPLE, to cause to become a follower [v]\n",
  "DISCIPLINING": "DISCIPLINE, to punish or penalize for the sake of discipline [v]\n",
  "DISCIPULAR": "like a disciple [adj]\n",
  "DISCISSION": "an open incision or cut [n -S]\n",
  "DISCISSIONS": "DISCISSION, an open incision or cut [n]\n",
  "DISCLAIM": "to renounce all claim [v -ED, -ING, -S]\n",
  "DISCLAIMED": "DISCLAIM, to renounce all claim [v]\n",
  "DISCLAIMER": "a denial or disavowal of legal claim [n -S]\n",
  "DISCLAIMERS": "DISCLAIMER, a denial or disavowal of legal claim [n]\n",
  "DISCLAIMING": "DISCLAIM, to renounce all claim [v]\n",
  "DISCLAIMS": "DISCLAIM, to renounce all claim [v]\n",
  "DISCLAMATION": "the act of disclaiming [n -S]\n",
  "DISCLAMATIONS": "DISCLAMATION, the act of disclaiming [n]\n",
  "DISCLESS": "having no disc; appearing as a point and not expanded into a disk, as the image of a faint star in a telescope, also DISKLESS [adj]\n",
  "DISCLIKE": "resembling a flat circular plate, also DISKLIKE [adj]\n",
  "DISCLIMAX": "a relatively stable ecological community not progressing to climax because of the intervention of e.g. man [n -ES]\n",
  "DISCLIMAXES": "DISCLIMAX, a relatively stable ecological community not progressing to climax because of the intervention of e.g. man [n]\n",
  "DISCLOSE": "to reveal [v DISCLOSED, DISCLOST, DISCLOSING, DISCLOSES]\n",
  "DISCLOSED": "DISCLOSE, to reveal [v]\n",
  "DISCLOSER": "one who discloses [n -S]\n",
  "DISCLOSERS": "DISCLOSER, one who discloses [n]\n",
  "DISCLOSES": "DISCLOSE, to reveal [v]\n",
  "DISCLOSING": "DISCLOSE, to reveal [v]\n",
  "DISCLOST": "DISCLOSE, to reveal [v]\n",
  "DISCLOSURE": "the act or an instance of disclosing [n -S]\n",
  "DISCLOSURES": "DISCLOSURE, the act or an instance of disclosing [n]\n",
  "DISCO": "a club or party where music for dancing is provided by records [n -S] / to take part in a disco [v -ED, -ING, -ES]\n",
  "DISCOBOLI": "DISCOBOLUS, (historical) a discus thrower, also DISCOBOLOS [n]\n",
  "DISCOBOLOS": "a discus thrower, also DISCOBOLUS [n DISCOBOLI]\n",
  "DISCOBOLUS": "(historical) a discus thrower, also DISCOBOLOS [n DISCOBOLI or DISCOBOLUSES]\n",
  "DISCOBOLUSES": "DISCOBOLUS, (historical) a discus thrower, also DISCOBOLOS [n]\n",
  "DISCOED": "DISCO, to take part in a disco [v]\n",
  "DISCOER": "one who frequents discos [n -S]\n",
  "DISCOERS": "DISCOER, one who frequents discos [n]\n",
  "DISCOES": "DISCO, to take part in a disco [v]\n",
  "DISCOGRAPHER": "a person who compiles discographies [n -S]\n",
  "DISCOGRAPHERS": "DISCOGRAPHER, a person who compiles discographies [n]\n",
  "DISCOGRAPHIC": "relating to discography, also DISCOGRAPHICAL [adj]\n",
  "DISCOGRAPHICAL": "relating to discography, also DISCOGRAPHIC [adj]\n",
  "DISCOGRAPHIES": "DISCOGRAPHY, phonographic records [n]\n",
  "DISCOGRAPHY": "phonographic records [n DISCOGRAPHIES]\n",
  "DISCOID": "something in the form of a disc [n -S]\n",
  "DISCOIDAL": "disk-shaped [adj]\n",
  "DISCOIDS": "DISCOID, something in the form of a disc [n]\n",
  "DISCOING": "DISCO, to take part in a disco [v]\n",
  "DISCOLOGIES": "DISCOLOGY, the study of gramophone records [n]\n",
  "DISCOLOGIST": "one who studies gramophone records [n -S]\n",
  "DISCOLOGISTS": "DISCOLOGIST, one who studies gramophone records [n]\n",
  "DISCOLOGY": "the study of gramophone records [n DISCOLOGIES]\n",
  "DISCOLOR": "to alter the color of [v -ED, -ING, -S]\n",
  "DISCOLORATION": "the act of discoloring [n -S]\n",
  "DISCOLORATIONS": "DISCOLORATION, the act of discoloring [n]\n",
  "DISCOLORED": "DISCOLOR, to alter the color of [v]\n",
  "DISCOLORING": "DISCOLOR, to alter the color of [v]\n",
  "DISCOLORMENT": "the act of discoloring [n -S]\n",
  "DISCOLORMENTS": "DISCOLORMENT, the act of discoloring [n]\n",
  "DISCOLORS": "DISCOLOR, to alter the color of [v]\n",
  "DISCOLOUR": "to alter the natural hue or color of, also DISCOLOR [v -ED, -ING, -S]\n",
  "DISCOLOURATION": "the act of discolouring, also DISCOLORATION [n -S]\n",
  "DISCOLOURATIONS": "DISCOLOURATION, the act of discolouring, also DISCOLORATION [n]\n",
  "DISCOLOURED": "DISCOLOUR, to alter the natural hue or color of, also DISCOLOR [v]\n",
  "DISCOLOURING": "DISCOLOUR, to alter the natural hue or color of, also DISCOLOR [v]\n",
  "DISCOLOURMENT": "the act of discolouring, also DISCOLORMENT [n -S]\n",
  "DISCOLOURMENTS": "DISCOLOURMENT, the act of discolouring, also DISCOLORMENT [n]\n",
  "DISCOLOURS": "DISCOLOUR, to alter the natural hue or color of, also DISCOLOR [v]\n",
  "DISCOMBOBERATE": "to throw into a state of confusion, also DISCOMBOBULATE [v DISCOMBOBERATED, DISCOMBOBERATES]\n",
  "DISCOMBOBERATED": "DISCOMBOBERATE, to throw into a state of confusion, also DISCOMBOBULATE [v]\n",
  "DISCOMBOBERATES": "DISCOMBOBERATE, to throw into a state of confusion, also DISCOMBOBULATE [v]\n",
  "DISCOMBOBULATE": "to throw into a state of confusion, also DISCOMBOBERATE [v DISCOMBOBULATED, DISCOMBOBULATES]\n",
  "DISCOMBOBULATED": "DISCOMBOBULATE, to throw into a state of confusion, also DISCOMBOBERATE [v]\n",
  "DISCOMBOBULATES": "DISCOMBOBULATE, to throw into a state of confusion, also DISCOMBOBERATE [v]\n",
  "DISCOMEDUSAN": "a member of the Discomedusae, an order of jellyfishes with flattened umbrella [n -S]\n",
  "DISCOMEDUSANS": "DISCOMEDUSAN, a member of the Discomedusae, an order of jellyfishes with flattened umbrella [n]\n",
  "DISCOMFIT": "to disconcert or balk [v -ED, -ING, -S]\n",
  "DISCOMFITED": "DISCOMFIT, to disconcert or balk [v]\n",
  "DISCOMFITER": "one who discomfits [n -S]\n",
  "DISCOMFITERS": "DISCOMFITER, one who discomfits [n]\n",
  "DISCOMFITING": "DISCOMFIT, to disconcert or balk [v]\n",
  "DISCOMFITS": "DISCOMFIT, to disconcert or balk [v]\n",
  "DISCOMFITURE": "the act of discomfiting [n -S]\n",
  "DISCOMFITURES": "DISCOMFITURE, the act of discomfiting [n]\n",
  "DISCOMFORT": "to make uncomfortable or uneasy [v -ED, -ING, -S]\n",
  "DISCOMFORTABLE": "uncomfortable [adj]\n",
  "DISCOMFORTED": "DISCOMFORT, to make uncomfortable or uneasy [v]\n",
  "DISCOMFORTING": "DISCOMFORT, to make uncomfortable or uneasy [v]\n",
  "DISCOMFORTS": "DISCOMFORT, to make uncomfortable or uneasy [v]\n",
  "DISCOMMEND": "to mention with disapprobation [v -ED, -ING, -S]\n",
  "DISCOMMENDABLE": "that can be discommended [adj]\n",
  "DISCOMMENDATION": "the act of discommending [n]\n",
  "DISCOMMENDED": "DISCOMMEND, to mention with disapprobation [v]\n",
  "DISCOMMENDING": "DISCOMMEND, to mention with disapprobation [v]\n",
  "DISCOMMENDS": "DISCOMMEND, to mention with disapprobation [v]\n",
  "DISCOMMISSION": "(Milton) to deprive of a commission [v DISCOMMISSIONED, DISCOMMISSIONS]\n",
  "DISCOMMISSIONED": "DISCOMMISSION, (Milton) to deprive of a commission [v]\n",
  "DISCOMMISSIONS": "DISCOMMISSION, (Milton) to deprive of a commission [v]\n",
  "DISCOMMODE": "to put to inconvenience, also INCOMMODE [v DISCOMMODED, DISCOMMODING, DISCOMMODES]\n",
  "DISCOMMODED": "DISCOMMODE, to put to inconvenience, also INCOMMODE [v]\n",
  "DISCOMMODES": "DISCOMMODE, to put to inconvenience, also INCOMMODE [v]\n",
  "DISCOMMODING": "DISCOMMODE, to put to inconvenience, also INCOMMODE [v]\n",
  "DISCOMMODIOUS": "inconvenient [adj DISCOMMODIOUSLY]\n",
  "DISCOMMODIOUSLY": "DISCOMMODIOUS, inconvenient [adv]\n",
  "DISCOMMODITIES": "DISCOMMODITY, inconvenience [n]\n",
  "DISCOMMODITY": "inconvenience [n DISCOMMODITIES]\n",
  "DISCOMMON": "to deprive of the right of common [v -ED, -ING, -S]\n",
  "DISCOMMONED": "DISCOMMON, to deprive of the right of common [v]\n",
  "DISCOMMONING": "DISCOMMON, to deprive of the right of common [v]\n",
  "DISCOMMONS": "DISCOMMON, to deprive of the right of common [v]\n",
  "DISCOMMUNITIES": "DISCOMMUNITY, lack of community [n]\n",
  "DISCOMMUNITY": "lack of community [n DISCOMMUNITIES]\n",
  "DISCOMPOSE": "to disarrange; to disturb [v DISCOMPOSED, DISCOMPOSING, DISCOMPOSES]\n",
  "DISCOMPOSED": "DISCOMPOSE, to disarrange; to disturb [v]\n",
  "DISCOMPOSEDLY": "DISCOMPOSED, DISCOMPOSE, to disarrange; to disturb [adv]\n",
  "DISCOMPOSES": "DISCOMPOSE, to disarrange; to disturb [v]\n",
  "DISCOMPOSING": "DISCOMPOSE, to disarrange; to disturb [v]\n",
  "DISCOMPOSINGLY": "DISCOMPOSING, DISCOMPOSE, to disarrange; to disturb [adv]\n",
  "DISCOMPOSURE": "lack of composure [n -S]\n",
  "DISCOMPOSURES": "DISCOMPOSURE, lack of composure [n]\n",
  "DISCOMYCETE": "one of a group of fungi with open apothecia [n -S]\n",
  "DISCOMYCETES": "DISCOMYCETE, one of a group of fungi with open apothecia [n]\n",
  "DISCOMYCETOUS": "of or like a discomycete [adj]\n",
  "DISCONCERT": "to throw into confusion [v -ED, -ING, -S]\n",
  "DISCONCERTED": "DISCONCERT, to throw into confusion [v]\n",
  "DISCONCERTEDLY": "DISCONCERTED, DISCONCERT, to throw into confusion [adv]\n",
  "DISCONCERTING": "DISCONCERT, to throw into confusion [v]\n",
  "DISCONCERTINGLY": "DISCONCERTING, DISCONCERT, to throw into confusion [adv]\n",
  "DISCONCERTION": "confusion [n -S]\n",
  "DISCONCERTIONS": "DISCONCERTION, confusion [n]\n",
  "DISCONCERTMENT": "the act of disconcerting [n -S]\n",
  "DISCONCERTMENTS": "DISCONCERTMENT, the act of disconcerting [n]\n",
  "DISCONCERTS": "DISCONCERT, to throw into confusion [v]\n",
  "DISCONFIRM": "to deny the validity of [v -ED, -ING, -S]\n",
  "DISCONFIRMATION": "the act of disconfirming [n]\n",
  "DISCONFIRMED": "DISCONFIRM, to deny the validity of [v]\n",
  "DISCONFIRMING": "DISCONFIRM, to deny the validity of [v]\n",
  "DISCONFIRMS": "DISCONFIRM, to deny the validity of [v]\n",
  "DISCONFORMABLE": "not conformable [adj]\n",
  "DISCONFORMITIES": "DISCONFORMITY, an unconformity in which the beds above the unconformity are parallel to the beds below the unconformity [n]\n",
  "DISCONFORMITY": "an unconformity in which the beds above the unconformity are parallel to the beds below the unconformity [n DISCONFORMITIES]\n",
  "DISCONNECT": "to sever the connection of or between [v -ED, -ING, -S]\n",
  "DISCONNECTED": "DISCONNECT, to sever the connection of or between [v]\n",
  "DISCONNECTEDLY": "DISCONNECTED, DISCONNECT, to sever the connection of or between [adv]\n",
  "DISCONNECTER": "one who disconnects [n -S]\n",
  "DISCONNECTERS": "DISCONNECTER, one who disconnects [n]\n",
  "DISCONNECTING": "DISCONNECT, to sever the connection of or between [v]\n",
  "DISCONNECTION": "the act of disconnecting, also DISCONNEXION [n -S]\n",
  "DISCONNECTIONS": "DISCONNECTION, the act of disconnecting, also DISCONNEXION [n]\n",
  "DISCONNECTIVE": "DISCONNECT, to sever the connection of or between [adj]\n",
  "DISCONNECTS": "DISCONNECT, to sever the connection of or between [v]\n",
  "DISCONNEXION": "the act of disconnecting, also DISCONNECTION [n -S]\n",
  "DISCONNEXIONS": "DISCONNEXION, the act of disconnecting, also DISCONNECTION [n]\n",
  "DISCONSENT": "(obsolete) to differ or dissent [v -ED, -ING, -S]\n",
  "DISCONSENTED": "DISCONSENT, (obsolete) to differ or dissent [v]\n",
  "DISCONSENTING": "DISCONSENT, (obsolete) to differ or dissent [v]\n",
  "DISCONSENTS": "DISCONSENT, (obsolete) to differ or dissent [v]\n",
  "DISCONSOLATE": "cheerless [adj DISCONSOLATELY]\n",
  "DISCONSOLATELY": "DISCONSOLATE, cheerless [adv]\n",
  "DISCONSOLATION": "the state of being disconsolate [n -S]\n",
  "DISCONSOLATIONS": "DISCONSOLATION, the state of being disconsolate [n]\n",
  "DISCONTENT": "to make discontented [v -ED, -ING, -S]\n",
  "DISCONTENTED": "DISCONTENT, to make discontented [v]\n",
  "DISCONTENTEDLY": "DISCONTENTED, DISCONTENT, to make discontented [adv]\n",
  "DISCONTENTFUL": "full of discontent [adj]\n",
  "DISCONTENTING": "DISCONTENT, to make discontented [v]\n",
  "DISCONTENTMENT": "discontent [n -S]\n",
  "DISCONTENTMENTS": "DISCONTENTMENT, discontent [n]\n",
  "DISCONTENTS": "DISCONTENT, to make discontented [v]\n",
  "DISCONTIGUITIES": "DISCONTIGUITY, lack of contiguity [n]\n",
  "DISCONTIGUITY": "lack of contiguity [n DISCONTIGUITIES]\n",
  "DISCONTIGUOUS": "not contiguous [adj]\n",
  "DISCONTINUANCE": "the act or an instance of discontinuing [n -S]\n",
  "DISCONTINUANCES": "DISCONTINUANCE, the act or an instance of discontinuing [n]\n",
  "DISCONTINUATION": "the act of discontinuing [n]\n",
  "DISCONTINUE": "to break the continuity of [v DISCONTINUED, DISCONTINUING, DISCONTINUES]\n",
  "DISCONTINUED": "DISCONTINUE, to break the continuity of [v]\n",
  "DISCONTINUER": "one who discontinues [n -S]\n",
  "DISCONTINUERS": "DISCONTINUER, one who discontinues [n]\n",
  "DISCONTINUES": "DISCONTINUE, to break the continuity of [v]\n",
  "DISCONTINUING": "DISCONTINUE, to break the continuity of [v]\n",
  "DISCONTINUITIES": "DISCONTINUITY, lack of continuity or cohesion [n]\n",
  "DISCONTINUITY": "lack of continuity or cohesion [n DISCONTINUITIES]\n",
  "DISCONTINUOUS": "not continuous [adj DISCONTINUOUSLY]\n",
  "DISCONTINUOUSLY": "DISCONTINUOUS, not continuous [adv]\n",
  "DISCOPHILE": "one who loves records [n -S]\n",
  "DISCOPHILES": "DISCOPHILE, one who loves records [n]\n",
  "DISCOPHORAN": "a jellyfish [n -S]\n",
  "DISCOPHORANS": "DISCOPHORAN, a jellyfish [n]\n",
  "DISCOPHOROUS": "relating to the Discophora, an order of jellyfish [adj]\n",
  "DISCORD": "to disagree [v -ED, -ING, -S]\n",
  "DISCORDANCE": "the state or an instance of being discordant, also DISCORDANCY [n -S]\n",
  "DISCORDANCES": "DISCORDANCE, the state or an instance of being discordant, also DISCORDANCY [n]\n",
  "DISCORDANCIES": "DISCORDANCY, the state or an instance of being discordant, also DISCORDANCE [n]\n",
  "DISCORDANCY": "the state or an instance of being discordant, also DISCORDANCE [n DISCORDANCIES]\n",
  "DISCORDANT": "being at variance [adj DISCORDANTLY]\n",
  "DISCORDANTLY": "DISCORDANT, being at variance [adv]\n",
  "DISCORDED": "DISCORD, to disagree [v]\n",
  "DISCORDFUL": "(Spenser) full of discord [adj]\n",
  "DISCORDING": "DISCORD, to disagree [v]\n",
  "DISCORDS": "DISCORD, to disagree [v]\n",
  "DISCORPORATE": "to deprive (a corporate body) of corporation [v DISCORPORATED, DISCORPORATING, DISCORPORATES]\n",
  "DISCORPORATED": "DISCORPORATE, to deprive (a corporate body) of corporation [v]\n",
  "DISCORPORATES": "DISCORPORATE, to deprive (a corporate body) of corporation [v]\n",
  "DISCORPORATING": "DISCORPORATE, to deprive (a corporate body) of corporation [v]\n",
  "DISCOS": "DISCO, to take part in a disco [v]\n",
  "DISCOTHEQUE": "a place or event at which recorded pop music is played for dancing [n -S]\n",
  "DISCOTHEQUES": "DISCOTHEQUE, a place or event at which recorded pop music is played for dancing [n]\n",
  "DISCOUNSEL": "(Spenser) to dissuade [v DISCOUNSELLED, DISCOUNSELLING, DISCOUNSELS]\n",
  "DISCOUNSELLED": "DISCOUNSEL, (Spenser) to dissuade [v]\n",
  "DISCOUNSELLING": "DISCOUNSEL, (Spenser) to dissuade [v]\n",
  "DISCOUNSELS": "DISCOUNSEL, (Spenser) to dissuade [v]\n",
  "DISCOUNT": "to reduce the price of [v -ED, -ING, -S]\n",
  "DISCOUNTABLE": "set apart for discounting [adj]\n",
  "DISCOUNTED": "DISCOUNT, to reduce the price of [v]\n",
  "DISCOUNTENANCE": "to abash; to discourage [v DISCOUNTENANCED, DISCOUNTENANCES]\n",
  "DISCOUNTENANCED": "DISCOUNTENANCE, to abash; to discourage [v]\n",
  "DISCOUNTENANCES": "DISCOUNTENANCE, to abash; to discourage [v]\n",
  "DISCOUNTER": "one who discounts; a discount broker [n -S]\n",
  "DISCOUNTERS": "DISCOUNTER, one who discounts; a discount broker [n]\n",
  "DISCOUNTING": "DISCOUNT, to reduce the price of [v]\n",
  "DISCOUNTS": "DISCOUNT, to reduce the price of [v]\n",
  "DISCOURAGE": "to dishearten; to depress the spirits of [v DISCOURAGED, DISCOURAGING, DISCOURAGES]\n",
  "DISCOURAGEABLE": "capable of being discouraged [adj]\n",
  "DISCOURAGED": "DISCOURAGE, to dishearten; to depress the spirits of [v]\n",
  "DISCOURAGEMENT": "the act of discouraging [n -S]\n",
  "DISCOURAGEMENTS": "DISCOURAGEMENT, the act of discouraging [n]\n",
  "DISCOURAGER": "one who discourages [n -S]\n",
  "DISCOURAGERS": "DISCOURAGER, one who discourages [n]\n",
  "DISCOURAGES": "DISCOURAGE, to dishearten; to depress the spirits of [v]\n",
  "DISCOURAGING": "disheartening [adj DISCOURAGINGLY]\n",
  "DISCOURAGINGLY": "DISCOURAGING, disheartening [adv]\n",
  "DISCOURE": "(Spenser) to find out, also DISCOVER, DISCURE [v DISCOURED, DISCOURING, DISCOURES]\n",
  "DISCOURED": "DISCOURE, (Spenser) to find out, also DISCOVER, DISCURE [v]\n",
  "DISCOURES": "DISCOURE, (Spenser) to find out, also DISCOVER, DISCURE [v]\n",
  "DISCOURING": "DISCOURE, (Spenser) to find out, also DISCOVER, DISCURE [v]\n",
  "DISCOURSAL": "relating to discourse [adj]\n",
  "DISCOURSE": "to talk or converse [v DISCOURSED, DISCOURSING, DISCOURSES]\n",
  "DISCOURSED": "DISCOURSE, to talk or converse [v]\n",
  "DISCOURSER": "(Shakespeare) one who discourses [n -S]\n",
  "DISCOURSERS": "DISCOURSER, (Shakespeare) one who discourses [n]\n",
  "DISCOURSES": "DISCOURSE, to talk or converse [v]\n",
  "DISCOURSING": "DISCOURSE, to talk or converse [v]\n",
  "DISCOURSIVE": "(obsolete) relating to discourse [adj]\n",
  "DISCOURTEISE": "(Spenser) discourteous, also DISCOURTEOUS [adj]\n",
  "DISCOURTEOUS": "lacking courtesy, also DISCOURTEISE [adj DISCOURTEOUSLY]\n",
  "DISCOURTEOUSLY": "DISCOURTEOUS, lacking courtesy, also DISCOURTEISE [adv]\n",
  "DISCOURTESIES": "DISCOURTESY, lack of courtesy [n]\n",
  "DISCOURTESY": "lack of courtesy [n DISCOURTESIES]\n",
  "DISCOVER": "to find out, also DISCOURE, DISCURE [v -ED, -ING, -S]\n",
  "DISCOVERABLE": "that can be discovered [adj]\n",
  "DISCOVERED": "DISCOVER, to find out, also DISCOURE, DISCURE [v]\n",
  "DISCOVERER": "one who discovers [n -S]\n",
  "DISCOVERERS": "DISCOVERER, one who discovers [n]\n",
  "DISCOVERIES": "DISCOVERY, the act of finding out [n]\n",
  "DISCOVERING": "DISCOVER, to find out, also DISCOURE, DISCURE [v]\n",
  "DISCOVERS": "DISCOVER, to find out, also DISCOURE, DISCURE [v]\n",
  "DISCOVERT": "of a woman, without a husband, not covert [adj]\n",
  "DISCOVERTURE": "the state of being discovert, not married [n -S]\n",
  "DISCOVERTURES": "DISCOVERTURE, the state of being discovert, not married [n]\n",
  "DISCOVERY": "the act of finding out [n DISCOVERIES]\n",
  "DISCREDIT": "to refuse to believe in [v -ED, -ING, -S]\n",
  "DISCREDITABLE": "injurious to reputation [adj DISCREDITABLY]\n",
  "DISCREDITABLY": "DISCREDITABLE, injurious to reputation [adv]\n",
  "DISCREDITED": "DISCREDIT, to refuse to believe in [v]\n",
  "DISCREDITING": "DISCREDIT, to refuse to believe in [v]\n",
  "DISCREDITS": "DISCREDIT, to refuse to believe in [v]\n",
  "DISCREET": "tactful [adj DISCREETER, DISCREETEST, DISCREETLY]\n",
  "DISCREETER": "DISCREET, tactful [adj]\n",
  "DISCREETEST": "DISCREET, tactful [adj]\n",
  "DISCREETLY": "DISCREET, tactful [adv]\n",
  "DISCREETNESS": "the state of being discreet [n -ES]\n",
  "DISCREETNESSES": "DISCREETNESS, the state of being discreet [n]\n",
  "DISCREPANCE": "the state of being discrepant, also DISCREPANCY [n -S]\n",
  "DISCREPANCES": "DISCREPANCE, the state of being discrepant, also DISCREPANCY [n]\n",
  "DISCREPANCIES": "DISCREPANCY, the state of being discrepant, also DISCREPANCE [n]\n",
  "DISCREPANCY": "the state of being discrepant, also DISCREPANCE [n DISCREPANCIES]\n",
  "DISCREPANT": "marked by disagreement, incompatibility, or inconsistency [adj DISCREPANTLY]\n",
  "DISCREPANTLY": "DISCREPANT, marked by disagreement, incompatibility, or inconsistency [adv]\n",
  "DISCRETE": "separate, distinct [adj DISCRETER, DISCRETEST, DISCRETELY]\n",
  "DISCRETELY": "DISCRETE, separate, distinct [adv]\n",
  "DISCRETENESS": "the state of being discrete [n -ES]\n",
  "DISCRETENESSES": "DISCRETENESS, the state of being discrete [n]\n",
  "DISCRETER": "DISCRETE, separate, distinct [adj]\n",
  "DISCRETEST": "DISCRETE, separate, distinct [adj]\n",
  "DISCRETION": "the quality of being discreet [n -S]\n",
  "DISCRETIONAL": "relating to discretion [adj DISCRETIONALLY]\n",
  "DISCRETIONALLY": "DISCRETIONAL, relating to discretion [adv]\n",
  "DISCRETIONARILY": "DISCRETIONARY, at discretion [adv]\n",
  "DISCRETIONARY": "at discretion [adj DISCRETIONARILY]\n",
  "DISCRETIONS": "DISCRETION, the quality of being discreet [n]\n",
  "DISCRETIVE": "marking distinction or separation [adj DISCRETIVELY] / a disjunctive conjunction or preposition [n -S]\n",
  "DISCRETIVELY": "DISCRETIVE, marking distinction or separation [adv]\n",
  "DISCRETIVES": "DISCRETIVE, a disjunctive conjunction or preposition [n]\n",
  "DISCRIMINABLE": "capable of being discriminated [adj DISCRIMINABLY]\n",
  "DISCRIMINABLY": "DISCRIMINABLE, capable of being discriminated [adv]\n",
  "DISCRIMINANT": "a mathematical expression providing a criterion for the behavior of another more complicated expression [n -S]\n",
  "DISCRIMINANTS": "DISCRIMINANT, a mathematical expression providing a criterion for the behavior of another more complicated expression [n]\n",
  "DISCRIMINATE": "discriminating [adj DISCRIMINATELY] / to mark or perceive the distinguishing or peculiar features of [v DISCRIMINATED, DISCRIMINATING, DISCRIMINATES]\n",
  "DISCRIMINATED": "DISCRIMINATE, to mark or perceive the distinguishing or peculiar features of [v]\n",
  "DISCRIMINATELY": "DISCRIMINATE, discriminating [adv]\n",
  "DISCRIMINATES": "DISCRIMINATE, to mark or perceive the distinguishing or peculiar features of [v]\n",
  "DISCRIMINATING": "DISCRIMINATE, to mark or perceive the distinguishing or peculiar features of [v]\n",
  "DISCRIMINATION": "the act of discriminating [n -S]\n",
  "DISCRIMINATIONS": "DISCRIMINATION, the act of discriminating [n]\n",
  "DISCRIMINATIVE": "making distinctions [adj]\n",
  "DISCRIMINATOR": "one that discriminates [n -S]\n",
  "DISCRIMINATORS": "DISCRIMINATOR, one that discriminates [n]\n",
  "DISCRIMINATORY": "discriminative [adj]\n",
  "DISCROWN": "to deprive of a crown, also DECROWN [v -ED, -ING, -S]\n",
  "DISCROWNED": "DISCROWN, to deprive of a crown, also DECROWN [v]\n",
  "DISCROWNING": "DISCROWN, to deprive of a crown, also DECROWN [v]\n",
  "DISCROWNS": "DISCROWN, to deprive of a crown, also DECROWN [v]\n",
  "DISCS": "DISC, to break up land with a kind of harrow, also DISK [v]\n",
  "DISCULPATE": "to free from blame [v DISCULPATED, DISCULPATING, DISCULPATES]\n",
  "DISCULPATED": "DISCULPATE, to free from blame [v]\n",
  "DISCULPATES": "DISCULPATE, to free from blame [v]\n",
  "DISCULPATING": "DISCULPATE, to free from blame [v]\n",
  "DISCUMBER": "(archaic) to free of encumbrance, also DISENCUMBER [v -ED, -ING, -S]\n",
  "DISCUMBERED": "DISCUMBER, (archaic) to free of encumbrance, also DISENCUMBER [v]\n",
  "DISCUMBERING": "DISCUMBER, (archaic) to free of encumbrance, also DISENCUMBER [v]\n",
  "DISCUMBERS": "DISCUMBER, (archaic) to free of encumbrance, also DISENCUMBER [v]\n",
  "DISCURE": "(Spenser) to find out, also DISCOVER, DISCOURE [v DISCURED, DISCURING, DISCURES]\n",
  "DISCURED": "DISCURE, (Spenser) to find out, also DISCOVER, DISCOURE [v]\n",
  "DISCURES": "DISCURE, (Spenser) to find out, also DISCOVER, DISCOURE [v]\n",
  "DISCURING": "DISCURE, (Spenser) to find out, also DISCOVER, DISCOURE [v]\n",
  "DISCURSION": "desultory talk [n -S]\n",
  "DISCURSIONS": "DISCURSION, desultory talk [n]\n",
  "DISCURSIST": "(obsolete) a disputer [n -S]\n",
  "DISCURSISTS": "DISCURSIST, (obsolete) a disputer [n]\n",
  "DISCURSIVE": "moving from topic to topic without order [adj DISCURSIVELY]\n",
  "DISCURSIVELY": "DISCURSIVE, moving from topic to topic without order [adv]\n",
  "DISCURSIVENESS": "DISCURSIVE, moving from topic to topic without order [n]\n",
  "DISCURSORY": "argumentative; discursive; reasoning [adj]\n",
  "DISCURSUS": "(Latin) argumentation; ratiocination; discursive reasoning [n -ES]\n",
  "DISCURSUSES": "DISCURSUS, (Latin) argumentation; ratiocination; discursive reasoning [n]\n",
  "DISCUS": "(Latin) a disc hurled in athletic competition [n DISCUSES or DISCI]\n",
  "DISCUSES": "DISCUS, (Latin) a disc hurled in athletic competition [n]\n",
  "DISCUSS": "to talk over [v -ED, -ING, -ES]\n",
  "DISCUSSABLE": "that can be discussed, also DISCUSSIBLE [adj]\n",
  "DISCUSSANT": "one who takes part in a formal symposium [n -S]\n",
  "DISCUSSANTS": "DISCUSSANT, one who takes part in a formal symposium [n]\n",
  "DISCUSSED": "DISCUSS, to talk over [v]\n",
  "DISCUSSER": "one who discusses [n -S]\n",
  "DISCUSSERS": "DISCUSSER, one who discusses [n]\n",
  "DISCUSSES": "DISCUSS, to talk over [v]\n",
  "DISCUSSIBLE": "that can be discussed, also DISCUSSABLE [adj]\n",
  "DISCUSSING": "DISCUSS, to talk over [v]\n",
  "DISCUSSION": "consideration of a question in open and usually informal debate [n -S]\n",
  "DISCUSSIONAL": "relating to discussion [adj]\n",
  "DISCUSSIONS": "DISCUSSION, consideration of a question in open and usually informal debate [n]\n",
  "DISCUSSIVE": "a medicine able or tending to discuss or disperse tumors or coagulated matter [n -S]\n",
  "DISCUSSIVES": "DISCUSSIVE, a medicine able or tending to discuss or disperse tumors or coagulated matter [n]\n",
  "DISCUTIENT": "a medicine serving to disperse morbid matter [n -S]\n",
  "DISCUTIENTS": "DISCUTIENT, a medicine serving to disperse morbid matter [n]\n",
  "DISDAIN": "to scorn, look down on [v -ED, -ING, -S]\n",
  "DISDAINED": "DISDAIN, to scorn, look down on [v]\n",
  "DISDAINFUL": "full of or expressing disdain, also SDEIGNFULL [adj DISDAINFULLY]\n",
  "DISDAINFULLY": "DISDAINFUL, full of or expressing disdain, also SDEIGNFULL [adv]\n",
  "DISDAINFULNESS": "DISDAINFUL, full of or expressing disdain, also SDEIGNFULL [n]\n",
  "DISDAINING": "DISDAIN, to scorn, look down on [v]\n",
  "DISDAINS": "DISDAIN, to scorn, look down on [v]\n",
  "DISEASE": "to make unhealthy [v DISEASED, DISEASING, DISEASES]\n",
  "DISEASED": "DISEASE, to make unhealthy [v]\n",
  "DISEASEDNESS": "the state of being diseased [n -ES]\n",
  "DISEASEDNESSES": "DISEASEDNESS, the state of being diseased [n]\n",
  "DISEASEFUL": "(obsolete) causing uneasiness [adj]\n",
  "DISEASES": "DISEASE, to make unhealthy [v]\n",
  "DISEASING": "DISEASE, to make unhealthy [v]\n",
  "DISECONOMIES": "DISECONOMY, lack of economy; a factor responsible for an increase in cost [n]\n",
  "DISECONOMY": "lack of economy; a factor responsible for an increase in cost [n DISECONOMIES]\n",
  "DISEDGE": "(Shakespeare) to deprive of an edge; to blunt [v DISEDGED, DISEDGING, DISEDGES]\n",
  "DISEDGED": "DISEDGE, (Shakespeare) to deprive of an edge; to blunt [v]\n",
  "DISEDGES": "DISEDGE, (Shakespeare) to deprive of an edge; to blunt [v]\n",
  "DISEDGING": "DISEDGE, (Shakespeare) to deprive of an edge; to blunt [v]\n",
  "DISEMBARK": "to leave a ship, to land [v -ED, -ING, -S]\n",
  "DISEMBARKATION": "the act of disembarking [n -S]\n",
  "DISEMBARKATIONS": "DISEMBARKATION, the act of disembarking [n]\n",
  "DISEMBARKED": "DISEMBARK, to leave a ship, to land [v]\n",
  "DISEMBARKING": "DISEMBARK, to leave a ship, to land [v]\n",
  "DISEMBARKMENT": "the act of disembarking [n -S]\n",
  "DISEMBARKMENTS": "DISEMBARKMENT, the act of disembarking [n]\n",
  "DISEMBARKS": "DISEMBARK, to leave a ship, to land [v]\n",
  "DISEMBARRASS": "to free from something troublesome or superfluous [v -ED, -ING, -ES]\n",
  "DISEMBARRASSED": "DISEMBARRASS, to free from something troublesome or superfluous [v]\n",
  "DISEMBARRASSES": "DISEMBARRASS, to free from something troublesome or superfluous [v]\n",
  "DISEMBARRASSING": "DISEMBARRASS, to free from something troublesome or superfluous [v]\n",
  "DISEMBELLISH": "to deprive of embellishment [v -ED, -ING, -ES]\n",
  "DISEMBELLISHED": "DISEMBELLISH, to deprive of embellishment [v]\n",
  "DISEMBELLISHES": "DISEMBELLISH, to deprive of embellishment [v]\n",
  "DISEMBELLISHING": "DISEMBELLISH, to deprive of embellishment [v]\n",
  "DISEMBITTER": "to free from bitterness [v -ED, -ING, -S]\n",
  "DISEMBITTERED": "DISEMBITTER, to free from bitterness [v]\n",
  "DISEMBITTERING": "DISEMBITTER, to free from bitterness [v]\n",
  "DISEMBITTERS": "DISEMBITTER, to free from bitterness [v]\n",
  "DISEMBODIED": "DISEMBODY, to remove or free (a spirit) from the body [v]\n",
  "DISEMBODIES": "DISEMBODY, to remove or free (a spirit) from the body [v]\n",
  "DISEMBODIMENT": "the state of being disembodied [n -S]\n",
  "DISEMBODIMENTS": "DISEMBODIMENT, the state of being disembodied [n]\n",
  "DISEMBODY": "to remove or free (a spirit) from the body [v DISEMBODIED, DISEMBODYING, DISEMBODIES]\n",
  "DISEMBODYING": "DISEMBODY, to remove or free (a spirit) from the body [v]\n",
  "DISEMBOGUE": "(Spanish) to discharge or pour forth from the mouth (as from a river) [v DISEMBOGUED, DISEMBOGUING, DISEMBOGUES]\n",
  "DISEMBOGUED": "DISEMBOGUE, (Spanish) to discharge or pour forth from the mouth (as from a river) [v]\n",
  "DISEMBOGUEMENT": "the act of disemboguing [n -S]\n",
  "DISEMBOGUEMENTS": "DISEMBOGUEMENT, the act of disemboguing [n]\n",
  "DISEMBOGUES": "DISEMBOGUE, (Spanish) to discharge or pour forth from the mouth (as from a river) [v]\n",
  "DISEMBOGUING": "DISEMBOGUE, (Spanish) to discharge or pour forth from the mouth (as from a river) [v]\n",
  "DISEMBOSOM": "to separate from the bosom, to unburden [v -ED, -ING, -S]\n",
  "DISEMBOSOMED": "DISEMBOSOM, to separate from the bosom, to unburden [v]\n",
  "DISEMBOSOMING": "DISEMBOSOM, to separate from the bosom, to unburden [v]\n",
  "DISEMBOSOMS": "DISEMBOSOM, to separate from the bosom, to unburden [v]\n",
  "DISEMBOWEL": "to take out the bowels of [v DISEMBOWELED or DISEMBOWELLED, DISEMBOWELING or DISEMBOWELLING, DISEMBOWELS]\n",
  "DISEMBOWELED": "DISEMBOWEL, to take out the bowels of [v]\n",
  "DISEMBOWELING": "DISEMBOWEL, to take out the bowels of [v]\n",
  "DISEMBOWELLED": "DISEMBOWEL, to take out the bowels of [v]\n",
  "DISEMBOWELLING": "DISEMBOWEL, to take out the bowels of [v]\n",
  "DISEMBOWELMENT": "the act of disembowelling [n -S]\n",
  "DISEMBOWELMENTS": "DISEMBOWELMENT, the act of disembowelling [n]\n",
  "DISEMBOWELS": "DISEMBOWEL, to take out the bowels of [v]\n",
  "DISEMBRANGLE": "(obsolete) to free from dispute [v DISEMBRANGLED, DISEMBRANGLING, DISEMBRANGLES]\n",
  "DISEMBRANGLED": "DISEMBRANGLE, (obsolete) to free from dispute [v]\n",
  "DISEMBRANGLES": "DISEMBRANGLE, (obsolete) to free from dispute [v]\n",
  "DISEMBRANGLING": "DISEMBRANGLE, (obsolete) to free from dispute [v]\n",
  "DISEMBROIL": "to disentangle; to free from perplexity [v -ED, -ING, -S]\n",
  "DISEMBROILED": "DISEMBROIL, to disentangle; to free from perplexity [v]\n",
  "DISEMBROILING": "DISEMBROIL, to disentangle; to free from perplexity [v]\n",
  "DISEMBROILS": "DISEMBROIL, to disentangle; to free from perplexity [v]\n",
  "DISEMBURDEN": "to disburden [v -ED, -ING, -S]\n",
  "DISEMBURDENED": "DISEMBURDEN, to disburden [v]\n",
  "DISEMBURDENING": "DISEMBURDEN, to disburden [v]\n",
  "DISEMBURDENS": "DISEMBURDEN, to disburden [v]\n",
  "DISEMPLOY": "to throw out of employment [v -ED, -ING, -S]\n",
  "DISEMPLOYED": "DISEMPLOY, to throw out of employment [v]\n",
  "DISEMPLOYING": "DISEMPLOY, to throw out of employment [v]\n",
  "DISEMPLOYMENT": "the act of disemploying [n -S]\n",
  "DISEMPLOYMENTS": "DISEMPLOYMENT, the act of disemploying [n]\n",
  "DISEMPLOYS": "DISEMPLOY, to throw out of employment [v]\n",
  "DISEMPOWER": "to deprive of power; to divest of strength [v -ED, -ING, -S]\n",
  "DISEMPOWERED": "DISEMPOWER, to deprive of power; to divest of strength [v]\n",
  "DISEMPOWERING": "DISEMPOWER, to deprive of power; to divest of strength [v]\n",
  "DISEMPOWERMENT": "the act of disempowering [n -S]\n",
  "DISEMPOWERMENTS": "DISEMPOWERMENT, the act of disempowering [n]\n",
  "DISEMPOWERS": "DISEMPOWER, to deprive of power; to divest of strength [v]\n",
  "DISEMVOWEL": "to remove the vowels from (a word in a text message, email, etc.) in order to abbreviate it [v DISEMVOWELLED, DISEMVOWELLING, DISEMVOWELS]\n",
  "DISEMVOWELLED": "DISEMVOWEL, to remove the vowels from (a word in a text message, email, etc.) in order to abbreviate it [v]\n",
  "DISEMVOWELLING": "DISEMVOWEL, to remove the vowels from (a word in a text message, email, etc.) in order to abbreviate it [v]\n",
  "DISEMVOWELS": "DISEMVOWEL, to remove the vowels from (a word in a text message, email, etc.) in order to abbreviate it [v]\n",
  "DISENABLE": "to disable; to disqualify [v DISENABLED, DISENABLING, DISENABLES]\n",
  "DISENABLED": "DISENABLE, to disable; to disqualify [v]\n",
  "DISENABLEMENT": "the act of disenabling [n -S]\n",
  "DISENABLEMENTS": "DISENABLEMENT, the act of disenabling [n]\n",
  "DISENABLES": "DISENABLE, to disable; to disqualify [v]\n",
  "DISENABLING": "DISENABLE, to disable; to disqualify [v]\n",
  "DISENCHAIN": "to free from restraint [v -ED, -ING, -S]\n",
  "DISENCHAINED": "DISENCHAIN, to free from restraint [v]\n",
  "DISENCHAINING": "DISENCHAIN, to free from restraint [v]\n",
  "DISENCHAINS": "DISENCHAIN, to free from restraint [v]\n",
  "DISENCHANT": "to free from enchantment [v -ED, -ING, -S]\n",
  "DISENCHANTED": "DISENCHANT, to free from enchantment [v]\n",
  "DISENCHANTER": "one who disenchants [n -S]\n",
  "DISENCHANTERS": "DISENCHANTER, one who disenchants [n]\n",
  "DISENCHANTING": "DISENCHANT, to free from enchantment [v]\n",
  "DISENCHANTINGLY": "DISENCHANTING, DISENCHANT, to free from enchantment [adv]\n",
  "DISENCHANTMENT": "the state of being disenchanted [n -S]\n",
  "DISENCHANTMENTS": "DISENCHANTMENT, the state of being disenchanted [n]\n",
  "DISENCHANTRESS": "a female disenchanter [n]\n",
  "DISENCHANTS": "DISENCHANT, to free from enchantment [v]\n",
  "DISENCLOSE": "to free from being inclosed, also DISINCLOSE [v DISENCLOSED, DISENCLOSING, DISENCLOSES]\n",
  "DISENCLOSED": "DISENCLOSE, to free from being inclosed, also DISINCLOSE [v]\n",
  "DISENCLOSES": "DISENCLOSE, to free from being inclosed, also DISINCLOSE [v]\n",
  "DISENCLOSING": "DISENCLOSE, to free from being inclosed, also DISINCLOSE [v]\n",
  "DISENCUMBER": "to free from encumbrance, also DISCUMBER [v -ED, -ING, -S]\n",
  "DISENCUMBERED": "DISENCUMBER, to free from encumbrance, also DISCUMBER [v]\n",
  "DISENCUMBERING": "DISENCUMBER, to free from encumbrance, also DISCUMBER [v]\n",
  "DISENCUMBERMENT": "the act of disencumbering [n]\n",
  "DISENCUMBERS": "DISENCUMBER, to free from encumbrance, also DISCUMBER [v]\n",
  "DISENCUMBRANCE": "the act of freeing from encumbrance [n -S]\n",
  "DISENCUMBRANCES": "DISENCUMBRANCE, the act of freeing from encumbrance [n]\n",
  "DISENDOW": "to deprive of endowment [v -ED, -ING, -S]\n",
  "DISENDOWED": "DISENDOW, to deprive of endowment [v]\n",
  "DISENDOWER": "one who disendows [n -S]\n",
  "DISENDOWERS": "DISENDOWER, one who disendows [n]\n",
  "DISENDOWING": "DISENDOW, to deprive of endowment [v]\n",
  "DISENDOWMENT": "the act of disendowing [n -S]\n",
  "DISENDOWMENTS": "DISENDOWMENT, the act of disendowing [n]\n",
  "DISENDOWS": "DISENDOW, to deprive of endowment [v]\n",
  "DISENFRANCHISE": "to deprive of a franchise [v DISENFRANCHISED, DISENFRANCHISES]\n",
  "DISENFRANCHISED": "DISENFRANCHISE, to deprive of a franchise [v]\n",
  "DISENFRANCHISES": "DISENFRANCHISE, to deprive of a franchise [v]\n",
  "DISENGAGE": "to separate or free from being engaged [v DISENGAGED, DISENGAGING, DISENGAGES]\n",
  "DISENGAGED": "DISENGAGE, to separate or free from being engaged [v]\n",
  "DISENGAGEDNESS": "the state of being disengaged [n]\n",
  "DISENGAGEMENT": "the state of being disengaged [n -S]\n",
  "DISENGAGEMENTS": "DISENGAGEMENT, the state of being disengaged [n]\n",
  "DISENGAGES": "DISENGAGE, to separate or free from being engaged [v]\n",
  "DISENGAGING": "DISENGAGE, to separate or free from being engaged [v]\n",
  "DISENNOBLE": "to deprive of that which ennobles; to degrade [v DISENNOBLED, DISENNOBLING, DISENNOBLES]\n",
  "DISENNOBLED": "DISENNOBLE, to deprive of that which ennobles; to degrade [v]\n",
  "DISENNOBLES": "DISENNOBLE, to deprive of that which ennobles; to degrade [v]\n",
  "DISENNOBLING": "DISENNOBLE, to deprive of that which ennobles; to degrade [v]\n",
  "DISENROL": "to remove from a roll [v DISENROLLED, DISENROLLING, DISENROLS]\n",
  "DISENROLLED": "DISENROL, to remove from a roll [v]\n",
  "DISENROLLING": "the act of removing from an enrolment list [n -S]\n",
  "DISENROLLINGS": "DISENROLLING, the act of removing from an enrolment list [n]\n",
  "DISENROLS": "DISENROL, to remove from a roll [v]\n",
  "DISENSHROUD": "to divest of a shroud [v -ED, -ING, -S]\n",
  "DISENSHROUDED": "DISENSHROUD, to divest of a shroud [v]\n",
  "DISENSHROUDING": "DISENSHROUD, to divest of a shroud [v]\n",
  "DISENSHROUDS": "DISENSHROUD, to divest of a shroud [v]\n",
  "DISENSLAVE": "to free from bondage or slavery [v DISENSLAVED, DISENSLAVING, DISENSLAVES]\n",
  "DISENSLAVED": "DISENSLAVE, to free from bondage or slavery [v]\n",
  "DISENSLAVES": "DISENSLAVE, to free from bondage or slavery [v]\n",
  "DISENSLAVING": "DISENSLAVE, to free from bondage or slavery [v]\n",
  "DISENTAIL": "to free from entailment [v -ED, -ING, -S]\n",
  "DISENTAILED": "DISENTAIL, to free from entailment [v]\n",
  "DISENTAILING": "DISENTAIL, to free from entailment [v]\n",
  "DISENTAILMENT": "the act of disentailing [n -S]\n",
  "DISENTAILMENTS": "DISENTAILMENT, the act of disentailing [n]\n",
  "DISENTAILS": "DISENTAIL, to free from entailment [v]\n",
  "DISENTANGLE": "to free from entanglement [v DISENTANGLED, DISENTANGLING, DISENTANGLES]\n",
  "DISENTANGLED": "DISENTANGLE, to free from entanglement [v]\n",
  "DISENTANGLEMENT": "the act of disentangling [n]\n",
  "DISENTANGLES": "DISENTANGLE, to free from entanglement [v]\n",
  "DISENTANGLING": "DISENTANGLE, to free from entanglement [v]\n",
  "DISENTHRAL": "to release from a state of enthralment, also DISENTHRALL, DISINTHRAL [v DISENTHRALLED, DISENTHRALLING, DISENTHRALS]\n",
  "DISENTHRALL": "to release from a state of enthralment, also DISENTHRAL, DISINTHRAL [v -ED, -ING, -S]\n",
  "DISENTHRALLED": "DISENTHRALL, to release from a state of enthralment, also DISENTHRAL, DISINTHRAL [v]\n",
  "DISENTHRALLING": "DISENTHRALL, to release from a state of enthralment, also DISENTHRAL, DISINTHRAL [v]\n",
  "DISENTHRALLMENT": "the act of disenthralling, also DISENTHRALMENT [n]\n",
  "DISENTHRALLS": "DISENTHRALL, to release from a state of enthralment, also DISENTHRAL, DISINTHRAL [v]\n",
  "DISENTHRALMENT": "the act of disenthralling, also DISENTHRALLMENT [n -S]\n",
  "DISENTHRALMENTS": "DISENTHRALMENT, the act of disenthralling, also DISENTHRALLMENT [n]\n",
  "DISENTHRALS": "DISENTHRAL, to release from a state of enthralment, also DISENTHRALL, DISINTHRAL [v]\n",
  "DISENTHRONE": "(Milton) to dethrone [v DISENTHRONED, DISENTHRONING, DISENTHRONES]\n",
  "DISENTHRONED": "DISENTHRONE, (Milton) to dethrone [v]\n",
  "DISENTHRONES": "DISENTHRONE, (Milton) to dethrone [v]\n",
  "DISENTHRONING": "DISENTHRONE, (Milton) to dethrone [v]\n",
  "DISENTITLE": "to deprive of title or claim [v DISENTITLED, DISENTITLING, DISENTITLES]\n",
  "DISENTITLED": "DISENTITLE, to deprive of title or claim [v]\n",
  "DISENTITLES": "DISENTITLE, to deprive of title or claim [v]\n",
  "DISENTITLING": "DISENTITLE, to deprive of title or claim [v]\n",
  "DISENTOMB": "to take out from a tomb; to disinter [v -ED, -ING, -S]\n",
  "DISENTOMBED": "DISENTOMB, to take out from a tomb; to disinter [v]\n",
  "DISENTOMBING": "DISENTOMB, to take out from a tomb; to disinter [v]\n",
  "DISENTOMBS": "DISENTOMB, to take out from a tomb; to disinter [v]\n",
  "DISENTRAIL": "(Spenser) to disembowel, remove the entrails, also DISENTRAYLE [v -ED, -ING, -S]\n",
  "DISENTRAILED": "DISENTRAIL, (Spenser) to disembowel, remove the entrails, also DISENTRAYLE [v]\n",
  "DISENTRAILING": "DISENTRAIL, (Spenser) to disembowel, remove the entrails, also DISENTRAYLE [v]\n",
  "DISENTRAILS": "DISENTRAIL, (Spenser) to disembowel, remove the entrails, also DISENTRAYLE [v]\n",
  "DISENTRAIN": "to set down from a train [v -ED, -ING, -S]\n",
  "DISENTRAINED": "DISENTRAIN, to set down from a train [v]\n",
  "DISENTRAINING": "DISENTRAIN, to set down from a train [v]\n",
  "DISENTRAINMENT": "the act of disentraining [n -S]\n",
  "DISENTRAINMENTS": "DISENTRAINMENT, the act of disentraining [n]\n",
  "DISENTRAINS": "DISENTRAIN, to set down from a train [v]\n",
  "DISENTRANCE": "to awaken from a trance or entrancement [v DISENTRANCED, DISENTRANCING, DISENTRANCES]\n",
  "DISENTRANCED": "DISENTRANCE, to awaken from a trance or entrancement [v]\n",
  "DISENTRANCEMENT": "the act of disentrancing [n]\n",
  "DISENTRANCES": "DISENTRANCE, to awaken from a trance or entrancement [v]\n",
  "DISENTRANCING": "DISENTRANCE, to awaken from a trance or entrancement [v]\n",
  "DISENTRAYLE": "(Spenser) to disembowel, remove the entrails, also DISENTRAIL [v DISENTRAYLED, DISENTRAYLING, DISENTRAYLES]\n",
  "DISENTRAYLED": "DISENTRAYLE, (Spenser) to disembowel, remove the entrails, also DISENTRAIL [v]\n",
  "DISENTRAYLES": "DISENTRAYLE, (Spenser) to disembowel, remove the entrails, also DISENTRAIL [v]\n",
  "DISENTRAYLING": "DISENTRAYLE, (Spenser) to disembowel, remove the entrails, also DISENTRAIL [v]\n",
  "DISENTWINE": "to free from being entwined or twisted [v DISENTWINED, DISENTWINING, DISENTWINES]\n",
  "DISENTWINED": "DISENTWINE, to free from being entwined or twisted [v]\n",
  "DISENTWINES": "DISENTWINE, to free from being entwined or twisted [v]\n",
  "DISENTWINING": "DISENTWINE, to free from being entwined or twisted [v]\n",
  "DISENVELOP": "to free from that in which a thing is enveloped [v -ED, -ING, -S]\n",
  "DISENVELOPED": "DISENVELOP, to free from that in which a thing is enveloped [v]\n",
  "DISENVELOPING": "DISENVELOP, to free from that in which a thing is enveloped [v]\n",
  "DISENVELOPS": "DISENVELOP, to free from that in which a thing is enveloped [v]\n",
  "DISENVIRON": "to deprive of environment [v -ED, -ING, -S]\n",
  "DISENVIRONED": "DISENVIRON, to deprive of environment [v]\n",
  "DISENVIRONING": "DISENVIRON, to deprive of environment [v]\n",
  "DISENVIRONS": "DISENVIRON, to deprive of environment [v]\n",
  "DISEPALOUS": "having two sepals [adj]\n",
  "DISEQUILIBRATE": "to put out of balance [v DISEQUILIBRATED, DISEQUILIBRATES]\n",
  "DISEQUILIBRATED": "DISEQUILIBRATE, to put out of balance [v]\n",
  "DISEQUILIBRATES": "DISEQUILIBRATE, to put out of balance [v]\n",
  "DISEQUILIBRIA": "DISEQUILIBRIUM, loss or lack of equilibrium [n]\n",
  "DISEQUILIBRIUM": "loss or lack of equilibrium [n DISEQUILIBRIA or DISEQUILIBRIUMS]\n",
  "DISEQUILIBRIUMS": "DISEQUILIBRIUM, loss or lack of equilibrium [n]\n",
  "DISESPOUSE": "(Milton) to release from espousal or plighted faith [v DISESPOUSED, DISESPOUSING, DISESPOUSES]\n",
  "DISESPOUSED": "DISESPOUSE, (Milton) to release from espousal or plighted faith [v]\n",
  "DISESPOUSES": "DISESPOUSE, (Milton) to release from espousal or plighted faith [v]\n",
  "DISESPOUSING": "DISESPOUSE, (Milton) to release from espousal or plighted faith [v]\n",
  "DISESTABLISH": "to deprive of an established status [v -ED, -ING, -ES]\n",
  "DISESTABLISHED": "DISESTABLISH, to deprive of an established status [v]\n",
  "DISESTABLISHES": "DISESTABLISH, to deprive of an established status [v]\n",
  "DISESTABLISHING": "DISESTABLISH, to deprive of an established status [v]\n",
  "DISESTEEM": "to hold of low value [v -ED, -ING, -S]\n",
  "DISESTEEMED": "DISESTEEM, to hold of low value [v]\n",
  "DISESTEEMING": "DISESTEEM, to hold of low value [v]\n",
  "DISESTEEMS": "DISESTEEM, to hold of low value [v]\n",
  "DISESTIMATION": "the act of disesteeming [n -S]\n",
  "DISESTIMATIONS": "DISESTIMATION, the act of disesteeming [n]\n",
  "DISEUR": "(French) a (male) reciter or entertainer [n -S]\n",
  "DISEURS": "DISEUR, (French) a (male) reciter or entertainer [n]\n",
  "DISEUSE": "(French) a female diseur, a reciter [n -S]\n",
  "DISEUSES": "DISEUSE, (French) a female diseur, a reciter [n]\n",
  "DISFAME": "to throw into disrepute or remove fame (from) [v DISFAMED, DISFAMING, DISFAMES]\n",
  "DISFAMED": "DISFAME, to throw into disrepute or remove fame (from) [v]\n",
  "DISFAMES": "DISFAME, to throw into disrepute or remove fame (from) [v]\n",
  "DISFAMING": "DISFAME, to throw into disrepute or remove fame (from) [v]\n",
  "DISFAVOR": "to regard with disapproval, also DISFAVOUR [v -ED, -ING, -S]\n",
  "DISFAVORED": "DISFAVOR, to regard with disapproval, also DISFAVOUR [v]\n",
  "DISFAVORING": "DISFAVOR, to regard with disapproval, also DISFAVOUR [v]\n",
  "DISFAVORS": "DISFAVOR, to regard with disapproval, also DISFAVOUR [v]\n",
  "DISFAVOUR": "want of favorable regard [n -S] / to disesteem, also DISFAVOR [v -ED, -ING, -S]\n",
  "DISFAVOURED": "DISFAVOUR, to disesteem, also DISFAVOR [v]\n",
  "DISFAVOURER": "one who disfavours [n -S]\n",
  "DISFAVOURERS": "DISFAVOURER, one who disfavours [n]\n",
  "DISFAVOURING": "DISFAVOUR, to disesteem, also DISFAVOR [v]\n",
  "DISFAVOURS": "DISFAVOUR, to disesteem, also DISFAVOR [v]\n",
  "DISFEATURE": "to deprive of features; to mar the features of, also DEFEATURE [v DISFEATURED, DISFEATURING, DISFEATURES]\n",
  "DISFEATURED": "DISFEATURE, to deprive of features; to mar the features of, also DEFEATURE [v]\n",
  "DISFEATUREMENT": "the act of disfeaturing [n -S]\n",
  "DISFEATUREMENTS": "DISFEATUREMENT, the act of disfeaturing [n]\n",
  "DISFEATURES": "DISFEATURE, to deprive of features; to mar the features of, also DEFEATURE [v]\n",
  "DISFEATURING": "DISFEATURE, to deprive of features; to mar the features of, also DEFEATURE [v]\n",
  "DISFELLOWSHIP": "to exclude from fellowship [v DISFELLOWSHIPED, DISFELLOWSHIPS]\n",
  "DISFELLOWSHIPED": "DISFELLOWSHIP, to exclude from fellowship [v]\n",
  "DISFELLOWSHIPS": "DISFELLOWSHIP, to exclude from fellowship [v]\n",
  "DISFIGURATION": "the act of disfiguring [n -S]\n",
  "DISFIGURATIONS": "DISFIGURATION, the act of disfiguring [n]\n",
  "DISFIGURE": "to spoil the appearance of [v DISFIGURED, DISFIGURING, DISFIGURES]\n",
  "DISFIGURED": "DISFIGURE, to spoil the appearance of [v]\n",
  "DISFIGUREMENT": "the state of being disfigured [n -S]\n",
  "DISFIGUREMENTS": "DISFIGUREMENT, the state of being disfigured [n]\n",
  "DISFIGURER": "one who disfigures [n -S]\n",
  "DISFIGURERS": "DISFIGURER, one who disfigures [n]\n",
  "DISFIGURES": "DISFIGURE, to spoil the appearance of [v]\n",
  "DISFIGURING": "DISFIGURE, to spoil the appearance of [v]\n",
  "DISFLESH": "(archaic) to reduce the flesh or obesity of [v DISFLESHED, DISFLESHING, DISFLESHES]\n",
  "DISFLESHED": "DISFLESH, (archaic) to reduce the flesh or obesity of [v]\n",
  "DISFLESHES": "DISFLESH, (archaic) to reduce the flesh or obesity of [v]\n",
  "DISFLESHING": "DISFLESH, (archaic) to reduce the flesh or obesity of [v]\n",
  "DISFLUENCIES": "DISFLUENCY, a lack of fluency in speech [n]\n",
  "DISFLUENCY": "a lack of fluency in speech [n DISFLUENCIES]\n",
  "DISFLUENT": "not fluent, also DYSFLUENT [adj]\n",
  "DISFOREST": "to clear of forest, also DISAFFOREST [v -ED, -ING, -S]\n",
  "DISFORESTATION": "the act of disforesting [n -S]\n",
  "DISFORESTATIONS": "DISFORESTATION, the act of disforesting [n]\n",
  "DISFORESTED": "DISFOREST, to clear of forest, also DISAFFOREST [v]\n",
  "DISFORESTING": "DISFOREST, to clear of forest, also DISAFFOREST [v]\n",
  "DISFORESTS": "DISFOREST, to clear of forest, also DISAFFOREST [v]\n",
  "DISFORM": "to alter the form of [v -ED, -ING, -S]\n",
  "DISFORMED": "DISFORM, to alter the form of [v]\n",
  "DISFORMING": "DISFORM, to alter the form of [v]\n",
  "DISFORMS": "DISFORM, to alter the form of [v]\n",
  "DISFRANCHISE": "to deprive of franchise [v DISFRANCHISED, DISFRANCHISING, DISFRANCHISES]\n",
  "DISFRANCHISED": "DISFRANCHISE, to deprive of franchise [v]\n",
  "DISFRANCHISES": "DISFRANCHISE, to deprive of franchise [v]\n",
  "DISFRANCHISING": "DISFRANCHISE, to deprive of franchise [v]\n",
  "DISFROCK": "to deprive of clerical garb [v -ED, -ING, -S]\n",
  "DISFROCKED": "DISFROCK, to deprive of clerical garb [v]\n",
  "DISFROCKING": "DISFROCK, to deprive of clerical garb [v]\n",
  "DISFROCKS": "DISFROCK, to deprive of clerical garb [v]\n",
  "DISFUNCTION": "impairment or abnormality of the functioning of an organ, also DYSFUNCTION [n -S]\n",
  "DISFUNCTIONAL": "relating to disfunction, also DYSFUNCTIONAL [adj]\n",
  "DISFUNCTIONS": "DISFUNCTION, impairment or abnormality of the functioning of an organ, also DYSFUNCTION [n]\n",
  "DISFURNISH": "to strip, render destitute [v -ED, -ING, -ES]\n",
  "DISFURNISHED": "DISFURNISH, to strip, render destitute [v]\n",
  "DISFURNISHES": "DISFURNISH, to strip, render destitute [v]\n",
  "DISFURNISHING": "DISFURNISH, to strip, render destitute [v]\n",
  "DISFURNISHMENT": "the state of being disfurnished [n -S]\n",
  "DISFURNISHMENTS": "DISFURNISHMENT, the state of being disfurnished [n]\n",
  "DISGARNISH": "to despoil, also DEGARNISH [v -ED, -ING, -ES]\n",
  "DISGARNISHED": "DISGARNISH, to despoil, also DEGARNISH [v]\n",
  "DISGARNISHES": "DISGARNISH, to despoil, also DEGARNISH [v]\n",
  "DISGARNISHING": "DISGARNISH, to despoil, also DEGARNISH [v]\n",
  "DISGARRISON": "to deprive of a garrison [v -ED, -ING, -S]\n",
  "DISGARRISONED": "DISGARRISON, to deprive of a garrison [v]\n",
  "DISGARRISONING": "DISGARRISON, to deprive of a garrison [v]\n",
  "DISGARRISONS": "DISGARRISON, to deprive of a garrison [v]\n",
  "DISGAVEL": "to release from gavelkind, an old system of land tenure in Kent [v DISGAVELLED, DISGAVELLING, DISGAVELS]\n",
  "DISGAVELLED": "DISGAVEL, to release from gavelkind, an old system of land tenure in Kent [v]\n",
  "DISGAVELLING": "the act of releasing from gavelkind, an old system of land tenure in Kent [n -S]\n",
  "DISGAVELLINGS": "DISGAVELLING, the act of releasing from gavelkind, an old system of land tenure in Kent [n]\n",
  "DISGAVELS": "DISGAVEL, to release from gavelkind, an old system of land tenure in Kent [v]\n",
  "DISGEST": "to assimilate food in the stomach, also DIGEST [v -ED, -ING, -S]\n",
  "DISGESTED": "DISGEST, to assimilate food in the stomach, also DIGEST [v]\n",
  "DISGESTING": "DISGEST, to assimilate food in the stomach, also DIGEST [v]\n",
  "DISGESTION": "digestion [n -S]\n",
  "DISGESTIONS": "DISGESTION, digestion [n]\n",
  "DISGESTS": "DISGEST, to assimilate food in the stomach, also DIGEST [v]\n",
  "DISGLORIFIED": "DISGLORIFY, (Milton) to deprive of glory [v]\n",
  "DISGLORIFIES": "DISGLORIFY, (Milton) to deprive of glory [v]\n",
  "DISGLORIFY": "(Milton) to deprive of glory [v DISGLORIFIED, DISGLORIFYING, DISGLORIFIES]\n",
  "DISGLORIFYING": "DISGLORIFY, (Milton) to deprive of glory [v]\n",
  "DISGODDED": "deprived of divinity [adj]\n",
  "DISGORGE": "to vomit [v DISGORGED, DISGORGING, DISGORGES]\n",
  "DISGORGED": "DISGORGE, to vomit [v]\n",
  "DISGORGEMENT": "the act of disgorging [n -S]\n",
  "DISGORGEMENTS": "DISGORGEMENT, the act of disgorging [n]\n",
  "DISGORGER": "one who disgorges [n -S]\n",
  "DISGORGERS": "DISGORGER, one who disgorges [n]\n",
  "DISGORGES": "DISGORGE, to vomit [v]\n",
  "DISGORGING": "DISGORGE, to vomit [v]\n",
  "DISGOSPELLING": "(Milton) withholding the gospel [adj]\n",
  "DISGOWN": "to strip of a gown [v -ED, -ING, -S]\n",
  "DISGOWNED": "DISGOWN, to strip of a gown [v]\n",
  "DISGOWNING": "DISGOWN, to strip of a gown [v]\n",
  "DISGOWNS": "DISGOWN, to strip of a gown [v]\n",
  "DISGRACE": "to bring shame upon [v DISGRACED, DISGRACING, DISGRACES]\n",
  "DISGRACED": "DISGRACE, to bring shame upon [v]\n",
  "DISGRACEFUL": "bringing or involving disgrace [adj DISGRACEFULLY]\n",
  "DISGRACEFULLY": "DISGRACEFUL, bringing or involving disgrace [adv]\n",
  "DISGRACEFULNESS": "DISGRACEFUL, bringing or involving disgrace [n]\n",
  "DISGRACER": "one who disgraces [n -S]\n",
  "DISGRACERS": "DISGRACER, one who disgraces [n]\n",
  "DISGRACES": "DISGRACE, to bring shame upon [v]\n",
  "DISGRACING": "DISGRACE, to bring shame upon [v]\n",
  "DISGRACIOUS": "(Shakespeare) ungracious, unpleasing [adj]\n",
  "DISGRADATION": "the act of disgrading, depriving of rank [n -S]\n",
  "DISGRADATIONS": "DISGRADATION, the act of disgrading, depriving of rank [n]\n",
  "DISGRADE": "to strip of rank [v DISGRADED, DISGRADING, DISGRADES]\n",
  "DISGRADED": "DISGRADE, to strip of rank [v]\n",
  "DISGRADES": "DISGRADE, to strip of rank [v]\n",
  "DISGRADING": "DISGRADE, to strip of rank [v]\n",
  "DISGREGATION": "separation; scattering [n -S]\n",
  "DISGREGATIONS": "DISGREGATION, separation; scattering [n]\n",
  "DISGRUNTLE": "to make ill-humoured or discontented [v DISGRUNTLED, DISGRUNTLING, DISGRUNTLES]\n",
  "DISGRUNTLED": "DISGRUNTLE, to make ill-humoured or discontented [v]\n",
  "DISGRUNTLEMENT": "the state of being disgruntled [n -S]\n",
  "DISGRUNTLEMENTS": "DISGRUNTLEMENT, the state of being disgruntled [n]\n",
  "DISGRUNTLES": "DISGRUNTLE, to make ill-humoured or discontented [v]\n",
  "DISGRUNTLING": "DISGRUNTLE, to make ill-humoured or discontented [v]\n",
  "DISGUISABLE": "that can be disguised [adj]\n",
  "DISGUISE": "to conceal the identity of [v DISGUISED, DISGUISING, DISGUISES]\n",
  "DISGUISED": "DISGUISE, to conceal the identity of [v]\n",
  "DISGUISEDLY": "DISGUISED, DISGUISE, to conceal the identity of [adv]\n",
  "DISGUISEDNESS": "the state of being disguised [n -ES]\n",
  "DISGUISEDNESSES": "DISGUISEDNESS, the state of being disguised [n]\n",
  "DISGUISELESS": "without a disguise [adj]\n",
  "DISGUISEMENT": "a disguise [n -S]\n",
  "DISGUISEMENTS": "DISGUISEMENT, a disguise [n]\n",
  "DISGUISER": "one who disguises [n -S]\n",
  "DISGUISERS": "DISGUISER, one who disguises [n]\n",
  "DISGUISES": "DISGUISE, to conceal the identity of [v]\n",
  "DISGUISING": "the act of disguise [n -S]\n",
  "DISGUISINGS": "DISGUISING, the act of disguise [n]\n",
  "DISGUST": "to cause loathing [v -ED, -ING, -S]\n",
  "DISGUSTED": "DISGUST, to cause loathing [v]\n",
  "DISGUSTEDLY": "DISGUSTED, DISGUST, to cause loathing [adv]\n",
  "DISGUSTEDNESS": "the state of being disgusted [n -ES]\n",
  "DISGUSTEDNESSES": "DISGUSTEDNESS, the state of being disgusted [n]\n",
  "DISGUSTFUL": "provoking disgust [adj DISGUSTFULLY]\n",
  "DISGUSTFULLY": "DISGUSTFUL, provoking disgust [adv]\n",
  "DISGUSTFULNESS": "the state of being disgustful [n]\n",
  "DISGUSTING": "DISGUST, to cause loathing [v]\n",
  "DISGUSTINGLY": "DISGUSTING, DISGUST, to cause loathing [adv]\n",
  "DISGUSTINGNESS": "the state of being disgusting [n]\n",
  "DISGUSTS": "DISGUST, to cause loathing [v]\n",
  "DISH": "to put into a concave vessel [v -ED, -ING, -ES]\n",
  "DISHABILITATE": "to disqualify; to attaint [v DISHABILITATED, DISHABILITATING, DISHABILITATES]\n",
  "DISHABILITATED": "DISHABILITATE, to disqualify; to attaint [v]\n",
  "DISHABILITATES": "DISHABILITATE, to disqualify; to attaint [v]\n",
  "DISHABILITATING": "DISHABILITATE, to disqualify; to attaint [v]\n",
  "DISHABILITATION": "disqualification [n]\n",
  "DISHABILLE": "(French) an undress; a careless toilet, also DESHABILLE [n -S]\n",
  "DISHABILLES": "DISHABILLE, (French) an undress; a careless toilet, also DESHABILLE [n]\n",
  "DISHABIT": "(Shakespeare) to drive from a habitation [v -ED, -ING, -S]\n",
  "DISHABITED": "DISHABIT, (Shakespeare) to drive from a habitation [v]\n",
  "DISHABITING": "DISHABIT, (Shakespeare) to drive from a habitation [v]\n",
  "DISHABITS": "DISHABIT, (Shakespeare) to drive from a habitation [v]\n",
  "DISHABLE": "(Spenser) to render incapable, also DISABLE [v DISHABLED, DISHABLING, DISHABLES]\n",
  "DISHABLED": "DISHABLE, (Spenser) to render incapable, also DISABLE [v]\n",
  "DISHABLES": "DISHABLE, (Spenser) to render incapable, also DISABLE [v]\n",
  "DISHABLING": "DISHABLE, (Spenser) to render incapable, also DISABLE [v]\n",
  "DISHALLOW": "to make unholy; to profane [v -ED, -ING, -S]\n",
  "DISHALLOWED": "DISHALLOW, to make unholy; to profane [v]\n",
  "DISHALLOWING": "DISHALLOW, to make unholy; to profane [v]\n",
  "DISHALLOWS": "DISHALLOW, to make unholy; to profane [v]\n",
  "DISHARMONIC": "out of harmony, discordant, also DYSHARMONIC [adj]\n",
  "DISHARMONIES": "DISHARMONY, lack of harmony [n]\n",
  "DISHARMONIOUS": "lacking in harmony [adj DISHARMONIOUSLY]\n",
  "DISHARMONIOUSLY": "DISHARMONIOUS, lacking in harmony [adv]\n",
  "DISHARMONISE": "to put out of harmony, also DISHARMONIZE [v DISHARMONISED, DISHARMONISING, DISHARMONISES]\n",
  "DISHARMONISED": "DISHARMONISE, to put out of harmony, also DISHARMONIZE [v]\n",
  "DISHARMONISES": "DISHARMONISE, to put out of harmony, also DISHARMONIZE [v]\n",
  "DISHARMONISING": "DISHARMONISE, to put out of harmony, also DISHARMONIZE [v]\n",
  "DISHARMONIZE": "to put out of harmony, also DISHARMONISE [v DISHARMONIZED, DISHARMONIZING, DISHARMONIZES]\n",
  "DISHARMONIZED": "DISHARMONIZE, to put out of harmony, also DISHARMONISE [v]\n",
  "DISHARMONIZES": "DISHARMONIZE, to put out of harmony, also DISHARMONISE [v]\n",
  "DISHARMONIZING": "DISHARMONIZE, to put out of harmony, also DISHARMONISE [v]\n",
  "DISHARMONY": "lack of harmony [n DISHARMONIES]\n",
  "DISHCLOTH": "a cloth used for washing dishes [n -S]\n",
  "DISHCLOTHS": "DISHCLOTH, a cloth used for washing dishes [n]\n",
  "DISHCLOUT": "a dishcloth [n -S]\n",
  "DISHCLOUTS": "DISHCLOUT, a dishcloth [n]\n",
  "DISHDASH": "a long one-piece garment worn by men in some Arab countries, also DISHDASHA [n -ES]\n",
  "DISHDASHA": "(Arabic) a long-sleeved collarless white garment worn by some Muslim men, also DISHDASH [n -S]\n",
  "DISHDASHAS": "DISHDASHA, (Arabic) a long-sleeved collarless white garment worn by some Muslim men, also DISHDASH [n]\n",
  "DISHDASHES": "DISHDASH, a long one-piece garment worn by men in some Arab countries, also DISHDASHA [n]\n",
  "DISHEARTEN": "to cause to lose spirit or morale [v -ED, -ING, -S]\n",
  "DISHEARTENED": "DISHEARTEN, to cause to lose spirit or morale [v]\n",
  "DISHEARTENING": "DISHEARTEN, to cause to lose spirit or morale [v]\n",
  "DISHEARTENINGLY": "DISHEARTENING, DISHEARTEN, to cause to lose spirit or morale [adv]\n",
  "DISHEARTENMENT": "the state of being disheartened [n -S]\n",
  "DISHEARTENMENTS": "DISHEARTENMENT, the state of being disheartened [n]\n",
  "DISHEARTENS": "DISHEARTEN, to cause to lose spirit or morale [v]\n",
  "DISHED": "DISH, to put into a concave vessel [v]\n",
  "DISHELM": "to deprive of a helmet [v -ED, -ING, -S]\n",
  "DISHELMED": "DISHELM, to deprive of a helmet [v]\n",
  "DISHELMING": "DISHELM, to deprive of a helmet [v]\n",
  "DISHELMS": "DISHELM, to deprive of a helmet [v]\n",
  "DISHERISON": "the act of disheriting [n -S]\n",
  "DISHERISONS": "DISHERISON, the act of disheriting [n]\n",
  "DISHERIT": "(Spenser) to deprive of an inheritance, also DISINHERIT [v -ED, -ING, -S]\n",
  "DISHERITED": "DISHERIT, (Spenser) to deprive of an inheritance, also DISINHERIT [v]\n",
  "DISHERITING": "DISHERIT, (Spenser) to deprive of an inheritance, also DISINHERIT [v]\n",
  "DISHERITOR": "one who puts another out of his inheritance [n -S]\n",
  "DISHERITORS": "DISHERITOR, one who puts another out of his inheritance [n]\n",
  "DISHERITS": "DISHERIT, (Spenser) to deprive of an inheritance, also DISINHERIT [v]\n",
  "DISHES": "DISH, to put into a concave vessel [v]\n",
  "DISHEVEL": "to make the hair untidy [v DISHEVELED or DISHEVELLED, DISHEVELING or DISHEVELLING, DISHEVELS]\n",
  "DISHEVELED": "DISHEVEL, to make the hair untidy [v]\n",
  "DISHEVELING": "DISHEVEL, to make the hair untidy [v]\n",
  "DISHEVELLED": "DISHEVEL, to make the hair untidy [v]\n",
  "DISHEVELLING": "DISHEVEL, to make the hair untidy [v]\n",
  "DISHEVELMENT": "the state of being dishevelled [n -S]\n",
  "DISHEVELMENTS": "DISHEVELMENT, the state of being dishevelled [n]\n",
  "DISHEVELS": "DISHEVEL, to make the hair untidy [v]\n",
  "DISHFUL": "as much as a dish can hold [n -S]\n",
  "DISHFULS": "DISHFUL, as much as a dish can hold [n]\n",
  "DISHIER": "DISHY, (colloquial) attractive [adj]\n",
  "DISHIEST": "DISHY, (colloquial) attractive [adj]\n",
  "DISHING": "a hollow, a concavity [n -S]\n",
  "DISHINGS": "DISHING, a hollow, a concavity [n]\n",
  "DISHLIKE": "like a dish [adj]\n",
  "DISHMOP": "a mop for cleaning dishes [n -S]\n",
  "DISHMOPS": "DISHMOP, a mop for cleaning dishes [n]\n",
  "DISHOARD": "to put previously withheld (money) into circulation [v -ED, -ING, -S]\n",
  "DISHOARDED": "DISHOARD, to put previously withheld (money) into circulation [v]\n",
  "DISHOARDING": "DISHOARD, to put previously withheld (money) into circulation [v]\n",
  "DISHOARDS": "DISHOARD, to put previously withheld (money) into circulation [v]\n",
  "DISHOME": "to deprive of a home [v DISHOMED, DISHOMING, DISHOMES]\n",
  "DISHOMED": "DISHOME, to deprive of a home [v]\n",
  "DISHOMES": "DISHOME, to deprive of a home [v]\n",
  "DISHOMING": "DISHOME, to deprive of a home [v]\n",
  "DISHONEST": "not honest [adj DISHONESTLY]\n",
  "DISHONESTIES": "DISHONESTY, lack of honesty [n]\n",
  "DISHONESTLY": "DISHONEST, not honest [adv]\n",
  "DISHONESTY": "lack of honesty [n DISHONESTIES]\n",
  "DISHONOR": "(US) to deprive of honour, also DISHONOUR [v -ED, -ING, -S]\n",
  "DISHONORABLE": "lacking honor, also DISHONOURABLE [adj DISHONORABLY]\n",
  "DISHONORABLY": "DISHONORABLE, lacking honor, also DISHONOURABLE [adv]\n",
  "DISHONORARY": "causing dishonour [adj]\n",
  "DISHONORED": "DISHONOR, (US) to deprive of honour, also DISHONOUR [v]\n",
  "DISHONORER": "(US) one who dishonors, also DISHONOURER [n -S]\n",
  "DISHONORERS": "DISHONORER, (US) one who dishonors, also DISHONOURER [n]\n",
  "DISHONORING": "DISHONOR, (US) to deprive of honour, also DISHONOUR [v]\n",
  "DISHONORS": "DISHONOR, (US) to deprive of honour, also DISHONOUR [v]\n",
  "DISHONOUR": "to deprive of honour, disgrace, also DISHONOR [v -ED, -ING, -S]\n",
  "DISHONOURABLE": "not honourable, also DISHONORABLE [adj DISHONOURABLY]\n",
  "DISHONOURABLY": "DISHONOURABLE, not honourable, also DISHONORABLE [adv]\n",
  "DISHONOURED": "DISHONOUR, to deprive of honour, disgrace, also DISHONOR [v]\n",
  "DISHONOURER": "one who dishonours, also DISHONORER [n -S]\n",
  "DISHONOURERS": "DISHONOURER, one who dishonours, also DISHONORER [n]\n",
  "DISHONOURING": "DISHONOUR, to deprive of honour, disgrace, also DISHONOR [v]\n",
  "DISHONOURS": "DISHONOUR, to deprive of honour, disgrace, also DISHONOR [v]\n",
  "DISHORN": "to deprive of horns [v -ED, -ING, -S]\n",
  "DISHORNED": "DISHORN, to deprive of horns [v]\n",
  "DISHORNING": "DISHORN, to deprive of horns [v]\n",
  "DISHORNS": "DISHORN, to deprive of horns [v]\n",
  "DISHORSE": "to make someone fall from a horse [v DISHORSED, DISHORSING, DISHORSES]\n",
  "DISHORSED": "DISHORSE, to make someone fall from a horse [v]\n",
  "DISHORSES": "DISHORSE, to make someone fall from a horse [v]\n",
  "DISHORSING": "DISHORSE, to make someone fall from a horse [v]\n",
  "DISHOUSE": "to deprive of housing [v DISHOUSED, DISHOUSING, DISHOUSES]\n",
  "DISHOUSED": "DISHOUSE, to deprive of housing [v]\n",
  "DISHOUSES": "DISHOUSE, to deprive of housing [v]\n",
  "DISHOUSING": "DISHOUSE, to deprive of housing [v]\n",
  "DISHPAN": "a pan for washing dishes [n -S]\n",
  "DISHPANS": "DISHPAN, a pan for washing dishes [n]\n",
  "DISHRAG": "a cloth for washing dishes [n -S]\n",
  "DISHRAGS": "DISHRAG, a cloth for washing dishes [n]\n",
  "DISHTOWEL": "a wiping up cloth [n -S]\n",
  "DISHTOWELS": "DISHTOWEL, a wiping up cloth [n]\n",
  "DISHUMOUR": "(obsolete) to put out of humour [v -ED, -ING, -S]\n",
  "DISHUMOURED": "DISHUMOUR, (obsolete) to put out of humour [v]\n",
  "DISHUMOURING": "DISHUMOUR, (obsolete) to put out of humour [v]\n",
  "DISHUMOURS": "DISHUMOUR, (obsolete) to put out of humour [v]\n",
  "DISHWARE": "tableware used for serving food [n -S]\n",
  "DISHWARES": "DISHWARE, tableware used for serving food [n]\n",
  "DISHWASHER": "a worker employed to wash dishes [n -S]\n",
  "DISHWASHERS": "DISHWASHER, a worker employed to wash dishes [n]\n",
  "DISHWATER": "water used for washing dishes [n -S]\n",
  "DISHWATERS": "DISHWATER, water used for washing dishes [n]\n",
  "DISHY": "(colloquial) attractive [adj DISHIER, DISHIEST]\n",
  "DISILLUDE": "to free from illusion [v DISILLUDED, DISILLUDING, DISILLUDES]\n",
  "DISILLUDED": "DISILLUDE, to free from illusion [v]\n",
  "DISILLUDES": "DISILLUDE, to free from illusion [v]\n",
  "DISILLUDING": "DISILLUDE, to free from illusion [v]\n",
  "DISILLUMINATE": "to destroy the light of, to darken [v DISILLUMINATED, DISILLUMINATING, DISILLUMINATES]\n",
  "DISILLUMINATED": "DISILLUMINATE, to destroy the light of, to darken [v]\n",
  "DISILLUMINATES": "DISILLUMINATE, to destroy the light of, to darken [v]\n",
  "DISILLUMINATING": "DISILLUMINATE, to destroy the light of, to darken [v]\n",
  "DISILLUSION": "to free from illusion [v -ED, -ING, -S]\n",
  "DISILLUSIONARY": "of or like disillusion [adj]\n",
  "DISILLUSIONED": "DISILLUSION, to free from illusion [v]\n",
  "DISILLUSIONING": "DISILLUSION, to free from illusion [v]\n",
  "DISILLUSIONISE": "to free from illusion, also DISILLUSIONIZE [v DISILLUSIONISED, DISILLUSIONISES]\n",
  "DISILLUSIONISED": "DISILLUSIONISE, to free from illusion, also DISILLUSIONIZE [v]\n",
  "DISILLUSIONISES": "DISILLUSIONISE, to free from illusion, also DISILLUSIONIZE [v]\n",
  "DISILLUSIONIZE": "to free from illusion, also DISILLUSIONISE [v DISILLUSIONIZED, DISILLUSIONIZES]\n",
  "DISILLUSIONIZED": "DISILLUSIONIZE, to free from illusion, also DISILLUSIONISE [v]\n",
  "DISILLUSIONIZES": "DISILLUSIONIZE, to free from illusion, also DISILLUSIONISE [v]\n",
  "DISILLUSIONMENT": "the state of being disillusioned [n]\n",
  "DISILLUSIONS": "DISILLUSION, to free from illusion [v]\n",
  "DISILLUSIVE": "tending to disillusion [adj]\n",
  "DISIMAGINE": "to banish from the imagination [v DISIMAGINED, DISIMAGINING, DISIMAGINES]\n",
  "DISIMAGINED": "DISIMAGINE, to banish from the imagination [v]\n",
  "DISIMAGINES": "DISIMAGINE, to banish from the imagination [v]\n",
  "DISIMAGINING": "DISIMAGINE, to banish from the imagination [v]\n",
  "DISIMMURE": "to liberate; to release from walls [v DISIMMURED, DISIMMURING, DISIMMURES]\n",
  "DISIMMURED": "DISIMMURE, to liberate; to release from walls [v]\n",
  "DISIMMURES": "DISIMMURE, to liberate; to release from walls [v]\n",
  "DISIMMURING": "DISIMMURE, to liberate; to release from walls [v]\n",
  "DISIMPASSIONED": "free of passion [adj]\n",
  "DISIMPRISON": "to free from prison or restraint [v -ED, -ING, -S]\n",
  "DISIMPRISONED": "DISIMPRISON, to free from prison or restraint [v]\n",
  "DISIMPRISONING": "DISIMPRISON, to free from prison or restraint [v]\n",
  "DISIMPRISONMENT": "the act of freeing from prison [n]\n",
  "DISIMPRISONS": "DISIMPRISON, to free from prison or restraint [v]\n",
  "DISIMPROVE": "to make worse [v DISIMPROVED, DISIMPROVING, DISIMPROVES]\n",
  "DISIMPROVED": "DISIMPROVE, to make worse [v]\n",
  "DISIMPROVES": "DISIMPROVE, to make worse [v]\n",
  "DISIMPROVING": "DISIMPROVE, to make worse [v]\n",
  "DISINCARCERATE": "to free from incarceration [v DISINCARCERATED, DISINCARCERATES]\n",
  "DISINCARCERATED": "DISINCARCERATE, to free from incarceration [v]\n",
  "DISINCARCERATES": "DISINCARCERATE, to free from incarceration [v]\n",
  "DISINCENTIVE": "a deterrent [n -S]\n",
  "DISINCENTIVES": "DISINCENTIVE, a deterrent [n]\n",
  "DISINCLINATION": "a preference for avoiding something [n -S]\n",
  "DISINCLINATIONS": "DISINCLINATION, a preference for avoiding something [n]\n",
  "DISINCLINE": "to make unwilling [v DISINCLINED, DISINCLINING, DISINCLINES]\n",
  "DISINCLINED": "DISINCLINE, to make unwilling [v]\n",
  "DISINCLINES": "DISINCLINE, to make unwilling [v]\n",
  "DISINCLINING": "DISINCLINE, to make unwilling [v]\n",
  "DISINCLOSE": "to free from being inclosed, also DISENCLOSE [v DISINCLOSED, DISINCLOSING, DISINCLOSES]\n",
  "DISINCLOSED": "DISINCLOSE, to free from being inclosed, also DISENCLOSE [v]\n",
  "DISINCLOSES": "DISINCLOSE, to free from being inclosed, also DISENCLOSE [v]\n",
  "DISINCLOSING": "DISINCLOSE, to free from being inclosed, also DISENCLOSE [v]\n",
  "DISINCORPORATE": "to deprive of corporate rights [v DISINCORPORATED, DISINCORPORATES]\n",
  "DISINCORPORATED": "DISINCORPORATE, to deprive of corporate rights [v]\n",
  "DISINCORPORATES": "DISINCORPORATE, to deprive of corporate rights [v]\n",
  "DISINFECT": "to rid of disease-causing bacteria, etc. by cleaning, esp. with a chemical [v -ED, -ING, -S]\n",
  "DISINFECTANT": "an agent that frees from infection [n -S]\n",
  "DISINFECTANTS": "DISINFECTANT, an agent that frees from infection [n]\n",
  "DISINFECTED": "DISINFECT, to rid of disease-causing bacteria, etc. by cleaning, esp. with a chemical [v]\n",
  "DISINFECTING": "DISINFECT, to rid of disease-causing bacteria, etc. by cleaning, esp. with a chemical [v]\n",
  "DISINFECTION": "the act of disinfecting [n -S]\n",
  "DISINFECTIONS": "DISINFECTION, the act of disinfecting [n]\n",
  "DISINFECTOR": "an agent that disinfects [n -S]\n",
  "DISINFECTORS": "DISINFECTOR, an agent that disinfects [n]\n",
  "DISINFECTS": "DISINFECT, to rid of disease-causing bacteria, etc. by cleaning, esp. with a chemical [v]\n",
  "DISINFEST": "to remove infestation from [v -ED, -ING, -S]\n",
  "DISINFESTANT": "an agent that disinfests, rids of vermin [n -S]\n",
  "DISINFESTANTS": "DISINFESTANT, an agent that disinfests, rids of vermin [n]\n",
  "DISINFESTATION": "the act of disinfesting [n -S]\n",
  "DISINFESTATIONS": "DISINFESTATION, the act of disinfesting [n]\n",
  "DISINFESTED": "DISINFEST, to remove infestation from [v]\n",
  "DISINFESTING": "DISINFEST, to remove infestation from [v]\n",
  "DISINFESTS": "DISINFEST, to remove infestation from [v]\n",
  "DISINFLATION": "a reversal of inflationary pressures [n -S]\n",
  "DISINFLATIONARY": "relating to disinflation, a reversal of inflationary pressures [adj]\n",
  "DISINFLATIONS": "DISINFLATION, a reversal of inflationary pressures [n]\n",
  "DISINFORM": "to inform incorrectly, also MISINFORM [v -ED, -ING, -S]\n",
  "DISINFORMATION": "deliberate leakage of misleading information [n -S]\n",
  "DISINFORMATIONS": "DISINFORMATION, deliberate leakage of misleading information [n]\n",
  "DISINFORMED": "DISINFORM, to inform incorrectly, also MISINFORM [v]\n",
  "DISINFORMING": "DISINFORM, to inform incorrectly, also MISINFORM [v]\n",
  "DISINFORMS": "DISINFORM, to inform incorrectly, also MISINFORM [v]\n",
  "DISINGENUITIES": "DISINGENUITY, the state of being disingenuous [n]\n",
  "DISINGENUITY": "the state of being disingenuous [n DISINGENUITIES]\n",
  "DISINGENUOUS": "lacking in candor; giving a false appearance of simple frankness [adj DISINGENUOUSLY]\n",
  "DISINGENUOUSLY": "DISINGENUOUS, lacking in candor; giving a false appearance of simple frankness [adv]\n",
  "DISINHERISON": "the act of disinheriting [n -S]\n",
  "DISINHERISONS": "DISINHERISON, the act of disinheriting [n]\n",
  "DISINHERIT": "to deprive of an inheritance, also DISHERIT [v -ED, -ING, -S]\n",
  "DISINHERITANCE": "the act of disinheriting [n -S]\n",
  "DISINHERITANCES": "DISINHERITANCE, the act of disinheriting [n]\n",
  "DISINHERITED": "DISINHERIT, to deprive of an inheritance, also DISHERIT [v]\n",
  "DISINHERITING": "DISINHERIT, to deprive of an inheritance, also DISHERIT [v]\n",
  "DISINHERITS": "DISINHERIT, to deprive of an inheritance, also DISHERIT [v]\n",
  "DISINHIBIT": "to remove restraints on (used esp. of drugs affecting behaviour) [v -ED, -ING, -S]\n",
  "DISINHIBITED": "DISINHIBIT, to remove restraints on (used esp. of drugs affecting behaviour) [v]\n",
  "DISINHIBITING": "DISINHIBIT, to remove restraints on (used esp. of drugs affecting behaviour) [v]\n",
  "DISINHIBITION": "the removal of inhibitions controlling normal behaviour [n -S]\n",
  "DISINHIBITIONS": "DISINHIBITION, the removal of inhibitions controlling normal behaviour [n]\n",
  "DISINHIBITORY": "serving to disinhibit [adj]\n",
  "DISINHIBITS": "DISINHIBIT, to remove restraints on (used esp. of drugs affecting behaviour) [v]\n",
  "DISINHUME": "to disinter [v DISINHUMED, DISINHUMING, DISINHUMES]\n",
  "DISINHUMED": "DISINHUME, to disinter [v]\n",
  "DISINHUMES": "DISINHUME, to disinter [v]\n",
  "DISINHUMING": "DISINHUME, to disinter [v]\n",
  "DISINTEGRABLE": "capable of being disintegrated [adj]\n",
  "DISINTEGRATE": "to break or decompose into constituent elements, parts, or small particles [v DISINTEGRATED, DISINTEGRATING, DISINTEGRATES]\n",
  "DISINTEGRATED": "DISINTEGRATE, to break or decompose into constituent elements, parts, or small particles [v]\n",
  "DISINTEGRATES": "DISINTEGRATE, to break or decompose into constituent elements, parts, or small particles [v]\n",
  "DISINTEGRATING": "DISINTEGRATE, to break or decompose into constituent elements, parts, or small particles [v]\n",
  "DISINTEGRATION": "the act of disintegrating [n -S]\n",
  "DISINTEGRATIONS": "DISINTEGRATION, the act of disintegrating [n]\n",
  "DISINTEGRATIVE": "tending to disintegrate [adj]\n",
  "DISINTEGRATOR": "something that causes disintegration [n -S]\n",
  "DISINTEGRATORS": "DISINTEGRATOR, something that causes disintegration [n]\n",
  "DISINTER": "to exhume [v DISINTERRED, DISINTERRING, DISINTERS]\n",
  "DISINTEREST": "to cause to regard something with no interest or concern [v -ED, -ING, -S]\n",
  "DISINTERESTED": "having no personal stake [adj DISINTERESTEDLY]\n",
  "DISINTERESTEDLY": "DISINTERESTED, having no personal stake [adv]\n",
  "DISINTERESTING": "(obsolete) uninteresting [adj]\n",
  "DISINTERESTS": "DISINTEREST, to cause to regard something with no interest or concern [v]\n",
  "DISINTERMENT": "the act of disinterring [n -S]\n",
  "DISINTERMENTS": "DISINTERMENT, the act of disinterring [n]\n",
  "DISINTERRED": "DISINTER, to exhume [v]\n",
  "DISINTERRING": "DISINTER, to exhume [v]\n",
  "DISINTERS": "DISINTER, to exhume [v]\n",
  "DISINTHRAL": "to release from a state of enthralment, also DISENTHRAL, DISENTHRALL [v DISINTHRALLED, DISINTHRALLING, DISINTHRALS]\n",
  "DISINTHRALLED": "DISINTHRAL, to release from a state of enthralment, also DISENTHRAL, DISENTHRALL [v]\n",
  "DISINTHRALLING": "the act of releasing from a state of enthralment [n -S]\n",
  "DISINTHRALLINGS": "DISINTHRALLING, the act of releasing from a state of enthralment [n]\n",
  "DISINTHRALS": "DISINTHRAL, to release from a state of enthralment, also DISENTHRAL, DISENTHRALL [v]\n",
  "DISINTOXICATE": "to detoxify [v DISINTOXICATED, DISINTOXICATING, DISINTOXICATES]\n",
  "DISINTOXICATED": "DISINTOXICATE, to detoxify [v]\n",
  "DISINTOXICATES": "DISINTOXICATE, to detoxify [v]\n",
  "DISINTOXICATING": "DISINTOXICATE, to detoxify [v]\n",
  "DISINTOXICATION": "the act of disintoxicating [n]\n",
  "DISINTRICATE": "to free from intricacy [v DISINTRICATED, DISINTRICATING, DISINTRICATES]\n",
  "DISINTRICATED": "DISINTRICATE, to free from intricacy [v]\n",
  "DISINTRICATES": "DISINTRICATE, to free from intricacy [v]\n",
  "DISINTRICATING": "DISINTRICATE, to free from intricacy [v]\n",
  "DISINURE": "to render unfamiliar [v DISINURED, DISINURING, DISINURES]\n",
  "DISINURED": "DISINURE, to render unfamiliar [v]\n",
  "DISINURES": "DISINURE, to render unfamiliar [v]\n",
  "DISINURING": "DISINURE, to render unfamiliar [v]\n",
  "DISINVENT": "to undo the invention of [v -ED, -ING, -S]\n",
  "DISINVENTED": "DISINVENT, to undo the invention of [v]\n",
  "DISINVENTING": "DISINVENT, to undo the invention of [v]\n",
  "DISINVENTS": "DISINVENT, to undo the invention of [v]\n",
  "DISINVEST": "to reduce or eliminate capital investment [v -ED, -ING, -S]\n",
  "DISINVESTED": "DISINVEST, to reduce or eliminate capital investment [v]\n",
  "DISINVESTING": "DISINVEST, to reduce or eliminate capital investment [v]\n",
  "DISINVESTITURE": "the action of disinvesting [n -S]\n",
  "DISINVESTITURES": "DISINVESTITURE, the action of disinvesting [n]\n",
  "DISINVESTMENT": "consumption of capital [n -S]\n",
  "DISINVESTMENTS": "DISINVESTMENT, consumption of capital [n]\n",
  "DISINVESTS": "DISINVEST, to reduce or eliminate capital investment [v]\n",
  "DISINVIGORATE": "to weaken [v DISINVIGORATED, DISINVIGORATING, DISINVIGORATES]\n",
  "DISINVIGORATED": "DISINVIGORATE, to weaken [v]\n",
  "DISINVIGORATES": "DISINVIGORATE, to weaken [v]\n",
  "DISINVIGORATING": "DISINVIGORATE, to weaken [v]\n",
  "DISINVITE": "to withdraw an invitation to [v DISINVITED, DISINVITING, DISINVITES]\n",
  "DISINVITED": "DISINVITE, to withdraw an invitation to [v]\n",
  "DISINVITES": "DISINVITE, to withdraw an invitation to [v]\n",
  "DISINVITING": "DISINVITE, to withdraw an invitation to [v]\n",
  "DISINVOLVE": "to unfold; to disentangle [v DISINVOLVED, DISINVOLVING, DISINVOLVES]\n",
  "DISINVOLVED": "DISINVOLVE, to unfold; to disentangle [v]\n",
  "DISINVOLVES": "DISINVOLVE, to unfold; to disentangle [v]\n",
  "DISINVOLVING": "DISINVOLVE, to unfold; to disentangle [v]\n",
  "DISJASKIT": "(Scots) tired out, also FORJASKIT, FORJESKIT [adj]\n",
  "DISJECT": "to dismember, to scatter [v -ED, -ING, -S]\n",
  "DISJECTED": "DISJECT, to dismember, to scatter [v]\n",
  "DISJECTING": "DISJECT, to dismember, to scatter [v]\n",
  "DISJECTION": "scattering or dispersion [n -S]\n",
  "DISJECTIONS": "DISJECTION, scattering or dispersion [n]\n",
  "DISJECTS": "DISJECT, to dismember, to scatter [v]\n",
  "DISJOIN": "to separate [v -ED, -ING, -S]\n",
  "DISJOINABLE": "that can be disjoined [adj]\n",
  "DISJOINED": "DISJOIN, to separate [v]\n",
  "DISJOINING": "DISJOIN, to separate [v]\n",
  "DISJOINS": "DISJOIN, to separate [v]\n",
  "DISJOINT": "to put out of order [v -ED, -ING, -S]\n",
  "DISJOINTED": "DISJOINT, to put out of order [v]\n",
  "DISJOINTEDLY": "DISJOINTED, DISJOINT, to put out of order [adv]\n",
  "DISJOINTEDNESS": "the state of being disjointed [n]\n",
  "DISJOINTING": "DISJOINT, to put out of order [v]\n",
  "DISJOINTS": "DISJOINT, to put out of order [v]\n",
  "DISJUNCT": "an alternative in a logical disjunction [n -S]\n",
  "DISJUNCTION": "the act of disjoining, also DISJUNCTURE [n -S]\n",
  "DISJUNCTIONS": "DISJUNCTION, the act of disjoining, also DISJUNCTURE [n]\n",
  "DISJUNCTIVE": "separating [adj DISJUNCTIVELY] / a disjunctive conjunction [n -S]\n",
  "DISJUNCTIVELY": "DISJUNCTIVE, separating [adv]\n",
  "DISJUNCTIVES": "DISJUNCTIVE, a disjunctive conjunction [n]\n",
  "DISJUNCTOR": "a device for breaking an electric circuit [n -S]\n",
  "DISJUNCTORS": "DISJUNCTOR, a device for breaking an electric circuit [n]\n",
  "DISJUNCTS": "DISJUNCT, an alternative in a logical disjunction [n]\n",
  "DISJUNCTURE": "the act of disjoining, also DISJUNCTION [n -S]\n",
  "DISJUNCTURES": "DISJUNCTURE, the act of disjoining, also DISJUNCTION [n]\n",
  "DISJUNE": "(Scots) breakfast [n -S] / to take breakfast, also DEJEUNE, DEJEUNER [v DISJUNED, DISJUNING, DISJUNES]\n",
  "DISJUNED": "DISJUNE, to take breakfast, also DEJEUNE, DEJEUNER [v]\n",
  "DISJUNES": "DISJUNE, to take breakfast, also DEJEUNE, DEJEUNER [v]\n",
  "DISJUNING": "DISJUNE, to take breakfast, also DEJEUNE, DEJEUNER [v]\n",
  "DISK": "to break up land with a farm implement, also DISC [v -ED, -ING, -S]\n",
  "DISKED": "DISK, to break up land with a farm implement, also DISC [v]\n",
  "DISKER": "one who disks, breaks up land with a type of farm implement [n -S]\n",
  "DISKERS": "DISKER, one who disks, breaks up land with a type of farm implement [n]\n",
  "DISKETTE": "a small flexible plastic disk with a magnetic coating used as an inexpensive data-storage device of moderate capacity [n -S]\n",
  "DISKETTES": "DISKETTE, a small flexible plastic disk with a magnetic coating used as an inexpensive data-storage device of moderate capacity [n]\n",
  "DISKING": "DISK, to break up land with a farm implement, also DISC [v]\n",
  "DISKLESS": "having no disk; appearing as a point and not expanded into a disk, as the image of a faint star in a telescope, also DISCLESS [adj]\n",
  "DISKLIKE": "resembling a flat circular plate, also DISCLIKE [adj]\n",
  "DISKS": "DISK, to break up land with a farm implement, also DISC [v]\n",
  "DISLEAF": "to deprive of leaves, also DISLEAVE [v -ED, -ING, -S]\n",
  "DISLEAFED": "DISLEAF, to deprive of leaves, also DISLEAVE [v]\n",
  "DISLEAFING": "DISLEAF, to deprive of leaves, also DISLEAVE [v]\n",
  "DISLEAFS": "DISLEAF, to deprive of leaves, also DISLEAVE [v]\n",
  "DISLEAL": "(Spenser) disloyal [adj]\n",
  "DISLEAVE": "to deprive of leaves, also DISLEAF [v DISLEAVED, DISLEAVING, DISLEAVES]\n",
  "DISLEAVED": "DISLEAVE, to deprive of leaves, also DISLEAF [v]\n",
  "DISLEAVES": "DISLEAVE, to deprive of leaves, also DISLEAF [v]\n",
  "DISLEAVING": "DISLEAVE, to deprive of leaves, also DISLEAF [v]\n",
  "DISLIKABLE": "capable of being disliked, also DISLIKEABLE [adj]\n",
  "DISLIKE": "to regard with aversion [v DISLIKED, DISLIKING, DISLIKES]\n",
  "DISLIKEABLE": "capable of being disliked, also DISLIKABLE [adj]\n",
  "DISLIKED": "DISLIKE, to regard with aversion [v]\n",
  "DISLIKEFUL": "full of dislike [adj]\n",
  "DISLIKEN": "(Shakespeare) to make unlike [v -ED, -ING, -S]\n",
  "DISLIKENED": "DISLIKEN, (Shakespeare) to make unlike [v]\n",
  "DISLIKENESS": "(obsolete) unlikeness [n -ES]\n",
  "DISLIKENESSES": "DISLIKENESS, (obsolete) unlikeness [n]\n",
  "DISLIKENING": "DISLIKEN, (Shakespeare) to make unlike [v]\n",
  "DISLIKENS": "DISLIKEN, (Shakespeare) to make unlike [v]\n",
  "DISLIKER": "one who dislikes [n -S]\n",
  "DISLIKERS": "DISLIKER, one who dislikes [n]\n",
  "DISLIKES": "DISLIKE, to regard with aversion [v]\n",
  "DISLIKING": "DISLIKE, to regard with aversion [v]\n",
  "DISLIMB": "to tear limb from limb; to dismember [v -ED, -ING, -S]\n",
  "DISLIMBED": "DISLIMB, to tear limb from limb; to dismember [v]\n",
  "DISLIMBING": "DISLIMB, to tear limb from limb; to dismember [v]\n",
  "DISLIMBS": "DISLIMB, to tear limb from limb; to dismember [v]\n",
  "DISLIMN": "(Shakespeare) to deface [v -ED, -ING, -S]\n",
  "DISLIMNED": "DISLIMN, (Shakespeare) to deface [v]\n",
  "DISLIMNING": "DISLIMN, (Shakespeare) to deface [v]\n",
  "DISLIMNS": "DISLIMN, (Shakespeare) to deface [v]\n",
  "DISLINK": "to unlink, separate [v -ED, -ING, -S]\n",
  "DISLINKED": "DISLINK, to unlink, separate [v]\n",
  "DISLINKING": "DISLINK, to unlink, separate [v]\n",
  "DISLINKS": "DISLINK, to unlink, separate [v]\n",
  "DISLOAD": "to unload, disburden [v -ED, -ING, -S]\n",
  "DISLOADED": "DISLOAD, to unload, disburden [v]\n",
  "DISLOADING": "DISLOAD, to unload, disburden [v]\n",
  "DISLOADS": "DISLOAD, to unload, disburden [v]\n",
  "DISLOCATE": "to put out of joint [v DISLOCATED, DISLOCATING, DISLOCATES]\n",
  "DISLOCATED": "DISLOCATE, to put out of joint [v]\n",
  "DISLOCATEDLY": "DISLOCATED, DISLOCATE, to put out of joint [adv]\n",
  "DISLOCATES": "DISLOCATE, to put out of joint [v]\n",
  "DISLOCATING": "DISLOCATE, to put out of joint [v]\n",
  "DISLOCATION": "the act of dislocating [n -S]\n",
  "DISLOCATIONS": "DISLOCATION, the act of dislocating [n]\n",
  "DISLODGE": "to remove from a firm position [v DISLODGED, DISLODGING, DISLODGES]\n",
  "DISLODGED": "DISLODGE, to remove from a firm position [v]\n",
  "DISLODGEMENT": "the act of dislodging, also DISLODGMENT [n -S]\n",
  "DISLODGEMENTS": "DISLODGEMENT, the act of dislodging, also DISLODGMENT [n]\n",
  "DISLODGES": "DISLODGE, to remove from a firm position [v]\n",
  "DISLODGING": "DISLODGE, to remove from a firm position [v]\n",
  "DISLODGMENT": "the act of dislodging, also DISLODGEMENT [n -S]\n",
  "DISLODGMENTS": "DISLODGMENT, the act of dislodging, also DISLODGEMENT [n]\n",
  "DISLOIGN": "(Spenser) to put at a distance; to remove [v -ED, -ING, -S]\n",
  "DISLOIGNED": "DISLOIGN, (Spenser) to put at a distance; to remove [v]\n",
  "DISLOIGNING": "DISLOIGN, (Spenser) to put at a distance; to remove [v]\n",
  "DISLOIGNS": "DISLOIGN, (Spenser) to put at a distance; to remove [v]\n",
  "DISLOYAL": "not loyal, also DISLEAL [adj DISLOYALLY]\n",
  "DISLOYALLY": "DISLOYAL, not loyal, also DISLEAL [adv]\n",
  "DISLOYALTIES": "DISLOYALTY, lack of loyalty [n]\n",
  "DISLOYALTY": "lack of loyalty [n DISLOYALTIES]\n",
  "DISLUSTRE": "(archaic) to deprive of lustre [v DISLUSTRED, DISLUSTRING, DISLUSTRES]\n",
  "DISLUSTRED": "DISLUSTRE, (archaic) to deprive of lustre [v]\n",
  "DISLUSTRES": "DISLUSTRE, (archaic) to deprive of lustre [v]\n",
  "DISLUSTRING": "DISLUSTRE, (archaic) to deprive of lustre [v]\n",
  "DISMAL": "sad, gloomy [adj DISMALER or DISMALLER, DISMALEST or DISMALLEST, DISMALLY] / a swamp [n -S]\n",
  "DISMALER": "DISMAL, sad, gloomy [adj]\n",
  "DISMALEST": "DISMAL, sad, gloomy [adj]\n",
  "DISMALITIES": "DISMALITY, the state of being dismal [n]\n",
  "DISMALITY": "the state of being dismal [n DISMALITIES]\n",
  "DISMALLER": "DISMAL, sad, gloomy [adj]\n",
  "DISMALLEST": "DISMAL, sad, gloomy [adj]\n",
  "DISMALLY": "DISMAL, sad, gloomy [adv]\n",
  "DISMALNESS": "the quality of being dismal [n -ES]\n",
  "DISMALNESSES": "DISMALNESS, the quality of being dismal [n]\n",
  "DISMALS": "DISMAL, a swamp [n]\n",
  "DISMAN": "to deprive of men [v DISMANNED, DISMANNING, DISMANS]\n",
  "DISMANNED": "DISMAN, to deprive of men [v]\n",
  "DISMANNING": "DISMAN, to deprive of men [v]\n",
  "DISMANS": "DISMAN, to deprive of men [v]\n",
  "DISMANTLE": "to take to pieces [v DISMANTLED, DISMANTLING, DISMANTLES]\n",
  "DISMANTLED": "DISMANTLE, to take to pieces [v]\n",
  "DISMANTLEMENT": "the act of dismantling [n -S]\n",
  "DISMANTLEMENTS": "DISMANTLEMENT, the act of dismantling [n]\n",
  "DISMANTLER": "one who dismantles [n -S]\n",
  "DISMANTLERS": "DISMANTLER, one who dismantles [n]\n",
  "DISMANTLES": "DISMANTLE, to take to pieces [v]\n",
  "DISMANTLING": "the act of taking apart [n -S]\n",
  "DISMANTLINGS": "DISMANTLING, the act of taking apart [n]\n",
  "DISMASK": "to divest of a mask [v -ED, -ING, -S]\n",
  "DISMASKED": "DISMASK, to divest of a mask [v]\n",
  "DISMASKING": "DISMASK, to divest of a mask [v]\n",
  "DISMASKS": "DISMASK, to divest of a mask [v]\n",
  "DISMAST": "to remove the mast of, also DEMAST [v -ED, -ING, -S]\n",
  "DISMASTED": "DISMAST, to remove the mast of, also DEMAST [v]\n",
  "DISMASTING": "DISMAST, to remove the mast of, also DEMAST [v]\n",
  "DISMASTMENT": "the act of dismasting [n -S]\n",
  "DISMASTMENTS": "DISMASTMENT, the act of dismasting [n]\n",
  "DISMASTS": "DISMAST, to remove the mast of, also DEMAST [v]\n",
  "DISMAY": "to appall or alarm [v -ED, -ING, -S]\n",
  "DISMAYD": "(Spenser) misshapen [adj]\n",
  "DISMAYED": "DISMAY, to appall or alarm [v]\n",
  "DISMAYEDNESS": "the state of being dismayed [n -ES]\n",
  "DISMAYEDNESSES": "DISMAYEDNESS, the state of being dismayed [n]\n",
  "DISMAYFUL": "terrifying [adj DISMAYFULLY]\n",
  "DISMAYFULLY": "DISMAYFUL, terrifying [adv]\n",
  "DISMAYING": "DISMAY, to appall or alarm [v]\n",
  "DISMAYINGLY": "DISMAYING [adv]\n",
  "DISMAYL": "(Spenser) to deprive of mail (armour) [v -ED, -ING, -S]\n",
  "DISMAYLED": "DISMAYL, (Spenser) to deprive of mail (armour) [v]\n",
  "DISMAYLING": "DISMAYL, (Spenser) to deprive of mail (armour) [v]\n",
  "DISMAYLS": "DISMAYL, (Spenser) to deprive of mail (armour) [v]\n",
  "DISMAYS": "DISMAY, to appall or alarm [v]\n",
  "DISME": "a former 10-cent coin of the USA [n -S]\n",
  "DISMEMBER": "to cut or tear a body limb from limb [v -ED, -ING, -S]\n",
  "DISMEMBERED": "DISMEMBER, to cut or tear a body limb from limb [v]\n",
  "DISMEMBERER": "one who dismembers [n -S]\n",
  "DISMEMBERERS": "DISMEMBERER, one who dismembers [n]\n",
  "DISMEMBERING": "DISMEMBER, to cut or tear a body limb from limb [v]\n",
  "DISMEMBERMENT": "the act of dismembering [n -S]\n",
  "DISMEMBERMENTS": "DISMEMBERMENT, the act of dismembering [n]\n",
  "DISMEMBERS": "DISMEMBER, to cut or tear a body limb from limb [v]\n",
  "DISMES": "DISME, a former 10-cent coin of the USA [n]\n",
  "DISMISS": "to send away [v -ED, -ING, -ES]\n",
  "DISMISSAL": "the act of dismissing [n -S]\n",
  "DISMISSALS": "DISMISSAL, the act of dismissing [n]\n",
  "DISMISSED": "DISMISS, to send away [v]\n",
  "DISMISSES": "DISMISS, to send away [v]\n",
  "DISMISSIBLE": "capable of being dismissed [adj]\n",
  "DISMISSING": "DISMISS, to send away [v]\n",
  "DISMISSION": "the act of dismissing [n -S]\n",
  "DISMISSIONS": "DISMISSION, the act of dismissing [n]\n",
  "DISMISSIVE": "disrespectful, inconsiderate [adj DISMISSIVELY]\n",
  "DISMISSIVELY": "DISMISSIVE, disrespectful, inconsiderate [adv]\n",
  "DISMISSORY": "relating to the act of dismissal [adj]\n",
  "DISMODED": "out of fashion [adj]\n",
  "DISMOUNT": "to get down from an elevated position [v -ED, -ING, -S]\n",
  "DISMOUNTABLE": "capable of being dismounted [adj]\n",
  "DISMOUNTED": "DISMOUNT, to get down from an elevated position [v]\n",
  "DISMOUNTING": "DISMOUNT, to get down from an elevated position [v]\n",
  "DISMOUNTS": "DISMOUNT, to get down from an elevated position [v]\n",
  "DISMUTATION": "simultaneous oxidation and reduction [n -S]\n",
  "DISMUTATIONS": "DISMUTATION, simultaneous oxidation and reduction [n]\n",
  "DISNATURALISE": "to make alien or unnatural, also DISNATURALIZE [v DISNATURALISED, DISNATURALISING, DISNATURALISES]\n",
  "DISNATURALISED": "DISNATURALISE, to make alien or unnatural, also DISNATURALIZE [v]\n",
  "DISNATURALISES": "DISNATURALISE, to make alien or unnatural, also DISNATURALIZE [v]\n",
  "DISNATURALISING": "DISNATURALISE, to make alien or unnatural, also DISNATURALIZE [v]\n",
  "DISNATURALIZE": "to make alien or unnatural, also DISNATURALISE [v DISNATURALIZED, DISNATURALIZING, DISNATURALIZES]\n",
  "DISNATURALIZED": "DISNATURALIZE, to make alien or unnatural, also DISNATURALISE [v]\n",
  "DISNATURALIZES": "DISNATURALIZE, to make alien or unnatural, also DISNATURALISE [v]\n",
  "DISNATURALIZING": "DISNATURALIZE, to make alien or unnatural, also DISNATURALISE [v]\n",
  "DISNATURE": "to cause to be in an unnatural condition [v DISNATURED, DISNATURING, DISNATURES]\n",
  "DISNATURED": "DISNATURE, to cause to be in an unnatural condition [v]\n",
  "DISNATURES": "DISNATURE, to cause to be in an unnatural condition [v]\n",
  "DISNATURING": "DISNATURE, to cause to be in an unnatural condition [v]\n",
  "DISNEST": "to dislodge from a nest [v -ED, -ING, -S]\n",
  "DISNESTED": "DISNEST, to dislodge from a nest [v]\n",
  "DISNESTING": "DISNEST, to dislodge from a nest [v]\n",
  "DISNESTS": "DISNEST, to dislodge from a nest [v]\n",
  "DISOBEDIENCE": "refusal or neglect to obey [n -S]\n",
  "DISOBEDIENCES": "DISOBEDIENCE, refusal or neglect to obey [n]\n",
  "DISOBEDIENT": "refusing or neglecting to obey [adj DISOBEDIENTLY]\n",
  "DISOBEDIENTLY": "DISOBEDIENT, refusing or neglecting to obey [adv]\n",
  "DISOBEY": "to refuse to follow instruction [v -ED, -ING, -S]\n",
  "DISOBEYED": "DISOBEY, to refuse to follow instruction [v]\n",
  "DISOBEYER": "one who disobeys [n -S]\n",
  "DISOBEYERS": "DISOBEYER, one who disobeys [n]\n",
  "DISOBEYING": "DISOBEY, to refuse to follow instruction [v]\n",
  "DISOBEYS": "DISOBEY, to refuse to follow instruction [v]\n",
  "DISOBLIGATION": "the act of disobliging [n -S]\n",
  "DISOBLIGATIONS": "DISOBLIGATION, the act of disobliging [n]\n",
  "DISOBLIGATORY": "releasing from disobligation [adj]\n",
  "DISOBLIGE": "to slight, inconvenience, etc. [v DISOBLIGED, DISOBLIGING, DISOBLIGES]\n",
  "DISOBLIGED": "DISOBLIGE, to slight, inconvenience, etc. [v]\n",
  "DISOBLIGEMENT": "the act of disobliging [n -S]\n",
  "DISOBLIGEMENTS": "DISOBLIGEMENT, the act of disobliging [n]\n",
  "DISOBLIGES": "DISOBLIGE, to slight, inconvenience, etc. [v]\n",
  "DISOBLIGING": "uncooperative [adj DISOBLIGINGLY]\n",
  "DISOBLIGINGLY": "DISOBLIGING, uncooperative [adv]\n",
  "DISOBLIGINGNESS": "DISOBLIGING, uncooperative [n]\n",
  "DISODIUM": "of a molecule, having two sodium atoms [adj]\n",
  "DISOMIC": "having a number of chromosomes duplicated [adj]\n",
  "DISOMIES": "DISOMY, the state of being disomic, having a number of chromosomes duplicated [n]\n",
  "DISOMY": "the state of being disomic, having a number of chromosomes duplicated [n DISOMIES]\n",
  "DISOPERATION": "a mutually harmful relationship between two organisms in a community [n -S]\n",
  "DISOPERATIONS": "DISOPERATION, a mutually harmful relationship between two organisms in a community [n]\n",
  "DISORBED": "deprived of the orb of sovereignty [adj]\n",
  "DISORDER": "to disarrange [v -ED, -ING, -S]\n",
  "DISORDERED": "DISORDER, to disarrange [v]\n",
  "DISORDEREDLY": "DISORDERED, DISORDER, to disarrange [adv]\n",
  "DISORDEREDNESS": "the state of being disordered [n]\n",
  "DISORDERING": "DISORDER, to disarrange [v]\n",
  "DISORDERLIES": "DISORDERLY, a disorderly person [n]\n",
  "DISORDERLINESS": "the state of being disorderly [n]\n",
  "DISORDERLY": "not orderly [adj] / a disorderly person [n DISORDERLIES]\n",
  "DISORDERS": "DISORDER, to disarrange [v]\n",
  "DISORDINATE": "not in order [adj DISORDINATELY]\n",
  "DISORDINATELY": "DISORDINATE, not in order [adv]\n",
  "DISORGANIC": "lacking organic structure [adj]\n",
  "DISORGANISATION": "the process of disorganising, also DISORGANIZATION [n]\n",
  "DISORGANISE": "to remove organisation from, also DISORGANIZE [v DISORGANISED, DISORGANISING, DISORGANISES]\n",
  "DISORGANISED": "DISORGANISE, to remove organisation from, also DISORGANIZE [v]\n",
  "DISORGANISER": "one who disorganises, also DISORGANIZER [n -S]\n",
  "DISORGANISERS": "DISORGANISER, one who disorganises, also DISORGANIZER [n]\n",
  "DISORGANISES": "DISORGANISE, to remove organisation from, also DISORGANIZE [v]\n",
  "DISORGANISING": "DISORGANISE, to remove organisation from, also DISORGANIZE [v]\n",
  "DISORGANIZATION": "the act of disorganizing, also DISORGANISATION [n]\n",
  "DISORGANIZE": "to remove organisation from, also DISORGANISE [v DISORGANIZED, DISORGANIZING, DISORGANIZES]\n",
  "DISORGANIZED": "DISORGANIZE, to remove organisation from, also DISORGANISE [v]\n",
  "DISORGANIZER": "one who disorganizes, also DISORGANISER [n -S]\n",
  "DISORGANIZERS": "DISORGANIZER, one who disorganizes, also DISORGANISER [n]\n",
  "DISORGANIZES": "DISORGANIZE, to remove organisation from, also DISORGANISE [v]\n",
  "DISORGANIZING": "DISORGANIZE, to remove organisation from, also DISORGANISE [v]\n",
  "DISORIENT": "to confuse as to direction [v -ED, -ING, -S]\n",
  "DISORIENTATE": "to cause to lose a sense of direction [v DISORIENTATED, DISORIENTATING, DISORIENTATES]\n",
  "DISORIENTATED": "DISORIENTATE, to cause to lose a sense of direction [v]\n",
  "DISORIENTATES": "DISORIENTATE, to cause to lose a sense of direction [v]\n",
  "DISORIENTATING": "DISORIENTATE, to cause to lose a sense of direction [v]\n",
  "DISORIENTATION": "the act of disorientating [n -S]\n",
  "DISORIENTATIONS": "DISORIENTATION, the act of disorientating [n]\n",
  "DISORIENTED": "DISORIENT, to confuse as to direction [v]\n",
  "DISORIENTING": "DISORIENT, to confuse as to direction [v]\n",
  "DISORIENTS": "DISORIENT, to confuse as to direction [v]\n",
  "DISOWN": "to deny the ownership of [v -ED, -ING, -S]\n",
  "DISOWNED": "DISOWN, to deny the ownership of [v]\n",
  "DISOWNER": "one who disowns [n -S]\n",
  "DISOWNERS": "DISOWNER, one who disowns [n]\n",
  "DISOWNING": "DISOWN, to deny the ownership of [v]\n",
  "DISOWNMENT": "the act of disowning [n -S]\n",
  "DISOWNMENTS": "DISOWNMENT, the act of disowning [n]\n",
  "DISOWNS": "DISOWN, to deny the ownership of [v]\n",
  "DISPACE": "(Spenser) to range about [v DISPACED, DISPACING, DISPACES]\n",
  "DISPACED": "DISPACE, (Spenser) to range about [v]\n",
  "DISPACES": "DISPACE, (Spenser) to range about [v]\n",
  "DISPACING": "DISPACE, (Spenser) to range about [v]\n",
  "DISPARAGE": "to belittle; to match in marriage with an inferior [v DISPARAGED, DISPARAGING, DISPARAGES]\n",
  "DISPARAGED": "DISPARAGE, to belittle; to match in marriage with an inferior [v]\n",
  "DISPARAGEMENT": "the act of disparaging [n -S]\n",
  "DISPARAGEMENTS": "DISPARAGEMENT, the act of disparaging [n]\n",
  "DISPARAGER": "one who disparages [n -S]\n",
  "DISPARAGERS": "DISPARAGER, one who disparages [n]\n",
  "DISPARAGES": "DISPARAGE, to belittle; to match in marriage with an inferior [v]\n",
  "DISPARAGING": "DISPARAGE, to belittle; to match in marriage with an inferior [v]\n",
  "DISPARAGINGLY": "DISPARAGING, DISPARAGE, to belittle; to match in marriage with an inferior [adv]\n",
  "DISPARATE": "unequal, essentially unlike [adj DISPARATELY] / a disparate thing or person [n -S]\n",
  "DISPARATELY": "DISPARATE, unequal, essentially unlike [adv]\n",
  "DISPARATENESS": "DISPARATE, unequal, essentially unlike [n]\n",
  "DISPARATENESSES": "DISPARATENESS, DISPARATE, unequal, essentially unlike [n]\n",
  "DISPARATES": "DISPARATE, a disparate thing or person [n]\n",
  "DISPARITIES": "DISPARITY, inequality [n]\n",
  "DISPARITY": "inequality [n DISPARITIES]\n",
  "DISPARK": "(archaic) to make no longer a park [v -ED, -ING, -S]\n",
  "DISPARKED": "DISPARK, (archaic) to make no longer a park [v]\n",
  "DISPARKING": "DISPARK, (archaic) to make no longer a park [v]\n",
  "DISPARKS": "DISPARK, (archaic) to make no longer a park [v]\n",
  "DISPART": "(archaic) to part, split in two [v -ED, -ING, -S]\n",
  "DISPARTED": "DISPART, (archaic) to part, split in two [v]\n",
  "DISPARTING": "DISPART, (archaic) to part, split in two [v]\n",
  "DISPARTS": "DISPART, (archaic) to part, split in two [v]\n",
  "DISPASSION": "freedom from passion [n -S]\n",
  "DISPASSIONATE": "not influenced by strong feeling [adj DISPASSIONATELY]\n",
  "DISPASSIONATELY": "DISPASSIONATE, not influenced by strong feeling [adv]\n",
  "DISPASSIONS": "DISPASSION, freedom from passion [n]\n",
  "DISPATCH": "to send off with speed [v -ED, -ING, -ES]\n",
  "DISPATCHED": "DISPATCH, to send off with speed [v]\n",
  "DISPATCHER": "one who dispatches, also DESPATCHER [n -S]\n",
  "DISPATCHERS": "DISPATCHER, one who dispatches, also DESPATCHER [n]\n",
  "DISPATCHES": "DISPATCH, to send off with speed [v]\n",
  "DISPATCHFUL": "(Milton) swift [adj]\n",
  "DISPATCHING": "DISPATCH, to send off with speed [v]\n",
  "DISPATHIES": "DISPATHY, dislike, also DYSPATHY [n]\n",
  "DISPATHY": "dislike, also DYSPATHY [n DISPATHIES]\n",
  "DISPAUPER": "to deprive of the claim of a pauper to public support [v -ED, -ING, -S]\n",
  "DISPAUPERED": "DISPAUPER, to deprive of the claim of a pauper to public support [v]\n",
  "DISPAUPERING": "DISPAUPER, to deprive of the claim of a pauper to public support [v]\n",
  "DISPAUPERISE": "to free from pauperdom, also DISPAUPERIZE [v DISPAUPERISED, DISPAUPERISING, DISPAUPERISES]\n",
  "DISPAUPERISED": "DISPAUPERISE, to free from pauperdom, also DISPAUPERIZE [v]\n",
  "DISPAUPERISES": "DISPAUPERISE, to free from pauperdom, also DISPAUPERIZE [v]\n",
  "DISPAUPERISING": "DISPAUPERISE, to free from pauperdom, also DISPAUPERIZE [v]\n",
  "DISPAUPERIZE": "to free from pauperdom, also DISPAUPERISE [v DISPAUPERIZED, DISPAUPERIZING, DISPAUPERIZES]\n",
  "DISPAUPERIZED": "DISPAUPERIZE, to free from pauperdom, also DISPAUPERISE [v]\n",
  "DISPAUPERIZES": "DISPAUPERIZE, to free from pauperdom, also DISPAUPERISE [v]\n",
  "DISPAUPERIZING": "DISPAUPERIZE, to free from pauperdom, also DISPAUPERISE [v]\n",
  "DISPAUPERS": "DISPAUPER, to deprive of the claim of a pauper to public support [v]\n",
  "DISPEACE": "lack of peace [n -S]\n",
  "DISPEACES": "DISPEACE, lack of peace [n]\n",
  "DISPEL": "to drive away and scatter [v DISPELLED, DISPELLING, DISPELS]\n",
  "DISPELLED": "DISPEL, to drive away and scatter [v]\n",
  "DISPELLER": "one who dispels [n -S]\n",
  "DISPELLERS": "DISPELLER, one who dispels [n]\n",
  "DISPELLING": "DISPEL, to drive away and scatter [v]\n",
  "DISPELS": "DISPEL, to drive away and scatter [v]\n",
  "DISPENCE": "(Spenser) to distribute, also DISPENSE [v DISPENCED, DISPENCING, DISPENCES]\n",
  "DISPENCED": "DISPENCE, (Spenser) to distribute, also DISPENSE [v]\n",
  "DISPENCES": "DISPENCE, (Spenser) to distribute, also DISPENSE [v]\n",
  "DISPENCING": "DISPENCE, (Spenser) to distribute, also DISPENSE [v]\n",
  "DISPEND": "(obsolete) to expend, pay out [v -ED, -ING, -S]\n",
  "DISPENDED": "DISPEND, (obsolete) to expend, pay out [v]\n",
  "DISPENDING": "DISPEND, (obsolete) to expend, pay out [v]\n",
  "DISPENDS": "DISPEND, (obsolete) to expend, pay out [v]\n",
  "DISPENSABILITY": "the state of being dispensable [n]\n",
  "DISPENSABLE": "that can be dispensed with [adj DISPENSABLY]\n",
  "DISPENSABLENESS": "the state of being dispensable [n]\n",
  "DISPENSABLY": "DISPENSABLE, that can be dispensed with [adv]\n",
  "DISPENSARIES": "DISPENSARY, a place where medicines are dispensed [n]\n",
  "DISPENSARY": "a place where medicines are dispensed [n DISPENSARIES]\n",
  "DISPENSATION": "a general state or ordering of things [n -S]\n",
  "DISPENSATIONAL": "of the nature of a dispensation [adj]\n",
  "DISPENSATIONS": "DISPENSATION, a general state or ordering of things [n]\n",
  "DISPENSATIVE": "granting dispensation [adj DISPENSATIVELY]\n",
  "DISPENSATIVELY": "DISPENSATIVE, granting dispensation [adv]\n",
  "DISPENSATOR": "a dispenser, a distributor [n -S]\n",
  "DISPENSATORIES": "DISPENSATORY, a book listening the composition and appliation of various drugs [n]\n",
  "DISPENSATORILY": "DISPENSATORY, granting dispensation [adv]\n",
  "DISPENSATORS": "DISPENSATOR, a dispenser, a distributor [n]\n",
  "DISPENSATORY": "granting dispensation [adj DISPENSATORILY] / a book listening the composition and appliation of various drugs [n DISPENSATORIES]\n",
  "DISPENSE": "to distribute, also DISPENCE [v DISPENSED, DISPENSING, DISPENSES]\n",
  "DISPENSED": "DISPENSE, to distribute, also DISPENCE [v]\n",
  "DISPENSER": "one who dispenses [n -S]\n",
  "DISPENSERS": "DISPENSER, one who dispenses [n]\n",
  "DISPENSES": "DISPENSE, to distribute, also DISPENCE [v]\n",
  "DISPENSING": "DISPENSE, to distribute, also DISPENCE [v]\n",
  "DISPEOPLE": "to depopulate [v DISPEOPLED, DISPEOPLING, DISPEOPLES]\n",
  "DISPEOPLED": "DISPEOPLE, to depopulate [v]\n",
  "DISPEOPLES": "DISPEOPLE, to depopulate [v]\n",
  "DISPEOPLING": "DISPEOPLE, to depopulate [v]\n",
  "DISPERMOUS": "having two seeds [adj]\n",
  "DISPERSAL": "dispersion, distribution [n -S]\n",
  "DISPERSALS": "DISPERSAL, dispersion, distribution [n]\n",
  "DISPERSANT": "an agent that causes dispersion [n -S]\n",
  "DISPERSANTS": "DISPERSANT, an agent that causes dispersion [n]\n",
  "DISPERSE": "to scatter [v DISPERSED, DISPERSING, DISPERSES]\n",
  "DISPERSED": "DISPERSE, to scatter [v]\n",
  "DISPERSEDLY": "DISPERSED, DISPERSE, to scatter [adv]\n",
  "DISPERSEDNESS": "the state of being dispersed [n -ES]\n",
  "DISPERSEDNESSES": "DISPERSEDNESS, the state of being dispersed [n]\n",
  "DISPERSER": "one who disperses [n -S]\n",
  "DISPERSERS": "DISPERSER, one who disperses [n]\n",
  "DISPERSES": "DISPERSE, to scatter [v]\n",
  "DISPERSIBLE": "that can be dispersed [adj]\n",
  "DISPERSING": "DISPERSE, to scatter [v]\n",
  "DISPERSION": "the act of dispersing [n -S]\n",
  "DISPERSIONS": "DISPERSION, the act of dispersing [n]\n",
  "DISPERSIVE": "tending to disperse [adj DISPERSIVELY]\n",
  "DISPERSIVELY": "DISPERSIVE, tending to disperse [adv]\n",
  "DISPERSIVENESS": "DISPERSIVE, tending to disperse [n]\n",
  "DISPERSOID": "a substance in a state of dispersion [n -S]\n",
  "DISPERSOIDS": "DISPERSOID, a substance in a state of dispersion [n]\n",
  "DISPIRIT": "to lower in spirits [v -ED, -ING, -S]\n",
  "DISPIRITED": "DISPIRIT, to lower in spirits [v]\n",
  "DISPIRITEDLY": "DISPIRITED, DISPIRIT, to lower in spirits [adv]\n",
  "DISPIRITEDNESS": "the state of being dispirited [n]\n",
  "DISPIRITING": "DISPIRIT, to lower in spirits [v]\n",
  "DISPIRITINGLY": "DISPIRITING, DISPIRIT, to lower in spirits [adv]\n",
  "DISPIRITMENT": "a state of being dispirited [n -S]\n",
  "DISPIRITMENTS": "DISPIRITMENT, a state of being dispirited [n]\n",
  "DISPIRITS": "DISPIRIT, to lower in spirits [v]\n",
  "DISPITEOUS": "(obsolete) pitiless, malicious [adj DISPITEOUSLY]\n",
  "DISPITEOUSLY": "DISPITEOUS, (obsolete) pitiless, malicious [adv]\n",
  "DISPITEOUSNESS": "DISPITEOUS, (obsolete) pitiless, malicious [n]\n",
  "DISPLACE": "to put in the wrong place [v DISPLACED, DISPLACING, DISPLACES]\n",
  "DISPLACEABLE": "capable of being displaced [adj]\n",
  "DISPLACED": "DISPLACE, to put in the wrong place [v]\n",
  "DISPLACEMENT": "the act of displacing [n -S]\n",
  "DISPLACEMENTS": "DISPLACEMENT, the act of displacing [n]\n",
  "DISPLACER": "one who displaces [n -S]\n",
  "DISPLACERS": "DISPLACER, one who displaces [n]\n",
  "DISPLACES": "DISPLACE, to put in the wrong place [v]\n",
  "DISPLACING": "DISPLACE, to put in the wrong place [v]\n",
  "DISPLANT": "to uproot; to remove from a town or country of settlement [v -ED, -ING, -S]\n",
  "DISPLANTATION": "the act of displanting [n -S]\n",
  "DISPLANTATIONS": "DISPLANTATION, the act of displanting [n]\n",
  "DISPLANTED": "DISPLANT, to uproot; to remove from a town or country of settlement [v]\n",
  "DISPLANTING": "DISPLANT, to uproot; to remove from a town or country of settlement [v]\n",
  "DISPLANTS": "DISPLANT, to uproot; to remove from a town or country of settlement [v]\n",
  "DISPLAY": "to put on show [v -ED, -ING, -S]\n",
  "DISPLAYABLE": "that can be displayed [adj]\n",
  "DISPLAYED": "DISPLAY, to put on show [v]\n",
  "DISPLAYER": "one who displays [n -S]\n",
  "DISPLAYERS": "DISPLAYER, one who displays [n]\n",
  "DISPLAYING": "DISPLAY, to put on show [v]\n",
  "DISPLAYS": "DISPLAY, to put on show [v]\n",
  "DISPLE": "(Spenser) to discipline, chastise [v DISPLED, DISPLING, DISPLES]\n",
  "DISPLEASANCE": "(Spenser) displeasure [n -S]\n",
  "DISPLEASANCES": "DISPLEASANCE, (Spenser) displeasure [n]\n",
  "DISPLEASANT": "to render unpleasing [v -ED, -ING, -S]\n",
  "DISPLEASANTED": "DISPLEASANT, to render unpleasing [v]\n",
  "DISPLEASANTING": "DISPLEASANT, to render unpleasing [v]\n",
  "DISPLEASANTS": "DISPLEASANT, to render unpleasing [v]\n",
  "DISPLEASE": "to offend, to annoy [v DISPLEASED, DISPLEASING, DISPLEASES]\n",
  "DISPLEASED": "DISPLEASE, to offend, to annoy [v]\n",
  "DISPLEASEDLY": "DISPLEASED, DISPLEASE, to offend, to annoy [adv]\n",
  "DISPLEASEDNESS": "the state of being displeased [n]\n",
  "DISPLEASES": "DISPLEASE, to offend, to annoy [v]\n",
  "DISPLEASING": "causing displeasure; disagreeable [adj DISPLEASINGLY]\n",
  "DISPLEASINGLY": "DISPLEASING, causing displeasure; disagreeable [adv]\n",
  "DISPLEASINGNESS": "DISPLEASING, causing displeasure; disagreeable [n]\n",
  "DISPLEASURE": "(archaic) to displease [v DISPLEASURED, DISPLEASURING, DISPLEASURES]\n",
  "DISPLEASURED": "DISPLEASURE, (archaic) to displease [v]\n",
  "DISPLEASURES": "DISPLEASURE, (archaic) to displease [v]\n",
  "DISPLEASURING": "DISPLEASURE, (archaic) to displease [v]\n",
  "DISPLED": "DISPLE, (Spenser) to discipline, chastise [v]\n",
  "DISPLENISH": "to deprive or strip, as a house of furniture, or a barn of stock [v -ED, -ING, -ES]\n",
  "DISPLENISHED": "DISPLENISH, to deprive or strip, as a house of furniture, or a barn of stock [v]\n",
  "DISPLENISHES": "DISPLENISH, to deprive or strip, as a house of furniture, or a barn of stock [v]\n",
  "DISPLENISHING": "DISPLENISH, to deprive or strip, as a house of furniture, or a barn of stock [v]\n",
  "DISPLENISHMENT": "the act of displenishing [n -S]\n",
  "DISPLENISHMENTS": "DISPLENISHMENT, the act of displenishing [n]\n",
  "DISPLES": "DISPLE, (Spenser) to discipline, chastise [v]\n",
  "DISPLING": "DISPLE, (Spenser) to discipline, chastise [v]\n",
  "DISPLODE": "(Milton) to discharge; to explode [v DISPLODED, DISPLODING, DISPLODES]\n",
  "DISPLODED": "DISPLODE, (Milton) to discharge; to explode [v]\n",
  "DISPLODES": "DISPLODE, (Milton) to discharge; to explode [v]\n",
  "DISPLODING": "DISPLODE, (Milton) to discharge; to explode [v]\n",
  "DISPLOSION": "an explosion [n -S]\n",
  "DISPLOSIONS": "DISPLOSION, an explosion [n]\n",
  "DISPLUME": "to deprive of feathers [v DISPLUMED, DISPLUMING, DISPLUMES]\n",
  "DISPLUMED": "DISPLUME, to deprive of feathers [v]\n",
  "DISPLUMES": "DISPLUME, to deprive of feathers [v]\n",
  "DISPLUMING": "DISPLUME, to deprive of feathers [v]\n",
  "DISPONDAIC": "relating to a dispondee, a double spondee [adj]\n",
  "DISPONDEE": "a double spondee; a foot consisting of four long syllables [n -S]\n",
  "DISPONDEES": "DISPONDEE, a double spondee; a foot consisting of four long syllables [n]\n",
  "DISPONE": "to make a legal transfer [v DISPONED, DISPONING, DISPONES]\n",
  "DISPONED": "DISPONE, to make a legal transfer [v]\n",
  "DISPONEE": "the person who receives a legal transfer [n -S]\n",
  "DISPONEES": "DISPONEE, the person who receives a legal transfer [n]\n",
  "DISPONER": "one who legally transfers property from himself to another [n -S]\n",
  "DISPONERS": "DISPONER, one who legally transfers property from himself to another [n]\n",
  "DISPONES": "DISPONE, to make a legal transfer [v]\n",
  "DISPONGE": "to sprinkle, also DISPUNGE [v DISPONGED, DISPONGING, DISPONGES]\n",
  "DISPONGED": "DISPONGE, to sprinkle, also DISPUNGE [v]\n",
  "DISPONGES": "DISPONGE, to sprinkle, also DISPUNGE [v]\n",
  "DISPONGING": "DISPONGE, to sprinkle, also DISPUNGE [v]\n",
  "DISPONING": "DISPONE, to make a legal transfer [v]\n",
  "DISPORT": "to amuse oneself [v -ED, -ING, -S]\n",
  "DISPORTED": "DISPORT, to amuse oneself [v]\n",
  "DISPORTING": "DISPORT, to amuse oneself [v]\n",
  "DISPORTMENT": "the act of disporting [n -S]\n",
  "DISPORTMENTS": "DISPORTMENT, the act of disporting [n]\n",
  "DISPORTS": "DISPORT, to amuse oneself [v]\n",
  "DISPOSABILITIES": "DISPOSABILITY, the state of being disposable [n]\n",
  "DISPOSABILITY": "the state of being disposable [n DISPOSABILITIES]\n",
  "DISPOSABLE": "able to be disposed of [adj] / something that is disposable [n -S]\n",
  "DISPOSABLENESS": "DISPOSABLE, able to be disposed of [n]\n",
  "DISPOSABLES": "DISPOSABLE, something that is disposable [n]\n",
  "DISPOSAL": "the act of disposing [n -S]\n",
  "DISPOSALS": "DISPOSAL, the act of disposing [n]\n",
  "DISPOSE": "to arrange or settle [v DISPOSED, DISPOSING, DISPOSES]\n",
  "DISPOSED": "DISPOSE, to arrange or settle [v]\n",
  "DISPOSEDLY": "DISPOSED, DISPOSE, to arrange or settle [adv]\n",
  "DISPOSER": "one who disposes [n -S]\n",
  "DISPOSERS": "DISPOSER, one who disposes [n]\n",
  "DISPOSES": "DISPOSE, to arrange or settle [v]\n",
  "DISPOSING": "the act of putting in place [n -S]\n",
  "DISPOSINGLY": "DISPOSING [adv]\n",
  "DISPOSINGS": "DISPOSING, the act of putting in place [n]\n",
  "DISPOSITION": "a person's usual temperament or frame of mind [n -S]\n",
  "DISPOSITIONAL": "relating to disposition [adj]\n",
  "DISPOSITIONED": "having a certain disposition [adj]\n",
  "DISPOSITIONS": "DISPOSITION, a person's usual temperament or frame of mind [n]\n",
  "DISPOSITIVE": "relating to or bringing about the settlement of a case [adj DISPOSITIVELY] / a thing that disposes [n -S]\n",
  "DISPOSITIVELY": "DISPOSITIVE, relating to or bringing about the settlement of a case [adv]\n",
  "DISPOSITIVES": "DISPOSITIVE, a thing that disposes [n]\n",
  "DISPOSITOR": "in astrology, a planet that disposes or controls another [n -S]\n",
  "DISPOSITORS": "DISPOSITOR, in astrology, a planet that disposes or controls another [n]\n",
  "DISPOSSESS": "to put out of possession or occupancy [v -ED, -ING, -ES]\n",
  "DISPOSSESSED": "DISPOSSESS, to put out of possession or occupancy [v]\n",
  "DISPOSSESSES": "DISPOSSESS, to put out of possession or occupancy [v]\n",
  "DISPOSSESSING": "DISPOSSESS, to put out of possession or occupancy [v]\n",
  "DISPOSSESSION": "the act of dispossessing [n -S]\n",
  "DISPOSSESSIONS": "DISPOSSESSION, the act of dispossessing [n]\n",
  "DISPOSSESSOR": "one who dispossesses [n -S]\n",
  "DISPOSSESSORS": "DISPOSSESSOR, one who dispossesses [n]\n",
  "DISPOSSESSORY": "serving to dispossess [adj]\n",
  "DISPOST": "to displace from a post [v -ED, -ING, -S]\n",
  "DISPOSTED": "DISPOST, to displace from a post [v]\n",
  "DISPOSTING": "DISPOST, to displace from a post [v]\n",
  "DISPOSTS": "DISPOST, to displace from a post [v]\n",
  "DISPOSURE": "disposal, disposition [n -S]\n",
  "DISPOSURES": "DISPOSURE, disposal, disposition [n]\n",
  "DISPRAD": "DISPRED, (Spenser) to spread out, also DISPREAD [v]\n",
  "DISPRAISE": "to censure [v DISPRAISED, DISPRAISING, DISPRAISES]\n",
  "DISPRAISED": "DISPRAISE, to censure [v]\n",
  "DISPRAISER": "one who dispraises [n -S]\n",
  "DISPRAISERS": "DISPRAISER, one who dispraises [n]\n",
  "DISPRAISES": "DISPRAISE, to censure [v]\n",
  "DISPRAISING": "DISPRAISE, to censure [v]\n",
  "DISPRAISINGLY": "DISPRAISING, DISPRAISE, to censure [adv]\n",
  "DISPREAD": "(Spenser) to spread out, also DISPRED [v DISPREAD, DISPREDDEN, DISPREADING, DISPREADS]\n",
  "DISPREADING": "DISPREAD, (Spenser) to spread out, also DISPRED [v]\n",
  "DISPREADS": "DISPREAD, (Spenser) to spread out, also DISPRED [v]\n",
  "DISPRED": "(Spenser) to spread out, also DISPREAD [v DISPRAD, DISPREDDING, DISPREDS]\n",
  "DISPREDDEN": "DISPREAD, (Spenser) to spread out, also DISPRED [v]\n",
  "DISPREDDING": "DISPRED, (Spenser) to spread out, also DISPREAD [v]\n",
  "DISPREDS": "DISPRED, (Spenser) to spread out, also DISPREAD [v]\n",
  "DISPRINCED": "(Tennyson) deprived of the appearance of a prince [adj]\n",
  "DISPRISON": "to let loose from prison, to set at liberty [v -ED, -ING, -S]\n",
  "DISPRISONED": "DISPRISON, to let loose from prison, to set at liberty [v]\n",
  "DISPRISONING": "DISPRISON, to let loose from prison, to set at liberty [v]\n",
  "DISPRISONS": "DISPRISON, to let loose from prison, to set at liberty [v]\n",
  "DISPRIVACIED": "deprived of privacy [adj]\n",
  "DISPRIVILEGE": "to deprive of a privilege [v DISPRIVILEGED, DISPRIVILEGING, DISPRIVILEGES]\n",
  "DISPRIVILEGED": "DISPRIVILEGE, to deprive of a privilege [v]\n",
  "DISPRIVILEGES": "DISPRIVILEGE, to deprive of a privilege [v]\n",
  "DISPRIVILEGING": "DISPRIVILEGE, to deprive of a privilege [v]\n",
  "DISPRIZE": "to depreciate [v DISPRIZED, DISPRIZING, DISPRIZES]\n",
  "DISPRIZED": "DISPRIZE, to depreciate [v]\n",
  "DISPRIZES": "DISPRIZE, to depreciate [v]\n",
  "DISPRIZING": "DISPRIZE, to depreciate [v]\n",
  "DISPROFESS": "to renounce the profession or pursuit of [v -ED, -ING, -ES]\n",
  "DISPROFESSED": "DISPROFESS, to renounce the profession or pursuit of [v]\n",
  "DISPROFESSES": "DISPROFESS, to renounce the profession or pursuit of [v]\n",
  "DISPROFESSING": "DISPROFESS, to renounce the profession or pursuit of [v]\n",
  "DISPROFIT": "(archaic) to cause to fail to profit [v -ED, -ING, -S]\n",
  "DISPROFITED": "DISPROFIT, (archaic) to cause to fail to profit [v]\n",
  "DISPROFITING": "DISPROFIT, (archaic) to cause to fail to profit [v]\n",
  "DISPROFITS": "DISPROFIT, (archaic) to cause to fail to profit [v]\n",
  "DISPROOF": "the act of disproving [n -S]\n",
  "DISPROOFS": "DISPROOF, the act of disproving [n]\n",
  "DISPROOVE": "(Spenser) to disapprove of [v DISPROOVED, DISPROOVING, DISPROOVES]\n",
  "DISPROOVED": "DISPROOVE, (Spenser) to disapprove of [v]\n",
  "DISPROOVES": "DISPROOVE, (Spenser) to disapprove of [v]\n",
  "DISPROOVING": "DISPROOVE, (Spenser) to disapprove of [v]\n",
  "DISPROPERTIED": "DISPROPERTY, (Shakespeare) to deprive of property [v]\n",
  "DISPROPERTIES": "DISPROPERTY, (Shakespeare) to deprive of property [v]\n",
  "DISPROPERTY": "(Shakespeare) to deprive of property [v DISPROPERTIED, DISPROPERTYING, DISPROPERTIES]\n",
  "DISPROPERTYING": "DISPROPERTY, (Shakespeare) to deprive of property [v]\n",
  "DISPROPORTION": "to make out of proportion [v -ED, -S]\n",
  "DISPROPORTIONAL": "relating to disproportion [adj]\n",
  "DISPROPORTIONED": "DISPROPORTION, to make out of proportion [v]\n",
  "DISPROPORTIONS": "DISPROPORTION, to make out of proportion [v]\n",
  "DISPROPRIATE": "(obsolete) to disappropriate [v DISPROPRIATED, DISPROPRIATING, DISPROPRIATES]\n",
  "DISPROPRIATED": "DISPROPRIATE, (obsolete) to disappropriate [v]\n",
  "DISPROPRIATES": "DISPROPRIATE, (obsolete) to disappropriate [v]\n",
  "DISPROPRIATING": "DISPROPRIATE, (obsolete) to disappropriate [v]\n",
  "DISPROVABLE": "that can be disproved [adj]\n",
  "DISPROVAL": "the act of disproving [n -S]\n",
  "DISPROVALS": "DISPROVAL, the act of disproving [n]\n",
  "DISPROVE": "to refute [v DISPROVED, DISPROVEN, DISPROVING, DISPROVES]\n",
  "DISPROVED": "DISPROVE, to refute [v]\n",
  "DISPROVEN": "DISPROVE, to refute [v]\n",
  "DISPROVER": "one who disproves [n -S]\n",
  "DISPROVERS": "DISPROVER, one who disproves [n]\n",
  "DISPROVES": "DISPROVE, to refute [v]\n",
  "DISPROVIDE": "(archaic) to fail to provide [v DISPROVIDED, DISPROVIDING, DISPROVIDES]\n",
  "DISPROVIDED": "DISPROVIDE, (archaic) to fail to provide [v]\n",
  "DISPROVIDES": "DISPROVIDE, (archaic) to fail to provide [v]\n",
  "DISPROVIDING": "DISPROVIDE, (archaic) to fail to provide [v]\n",
  "DISPROVING": "DISPROVE, to refute [v]\n",
  "DISPUNGE": "(Shakespeare) to sprinkle as from a sponge, also DISPONGE [v DISPUNGED, DISPUNGING, DISPUNGES]\n",
  "DISPUNGED": "DISPUNGE, (Shakespeare) to sprinkle as from a sponge, also DISPONGE [v]\n",
  "DISPUNGES": "DISPUNGE, (Shakespeare) to sprinkle as from a sponge, also DISPONGE [v]\n",
  "DISPUNGING": "DISPUNGE, (Shakespeare) to sprinkle as from a sponge, also DISPONGE [v]\n",
  "DISPURSE": "(Shakespeare) to disburse [v DISPURSED, DISPURSING, DISPURSES]\n",
  "DISPURSED": "DISPURSE, (Shakespeare) to disburse [v]\n",
  "DISPURSES": "DISPURSE, (Shakespeare) to disburse [v]\n",
  "DISPURSING": "DISPURSE, (Shakespeare) to disburse [v]\n",
  "DISPURVEY": "(archaic) to deprive of provisions [v -ED, -ING, -S]\n",
  "DISPURVEYANCE": "(Spenser) depriving of provisions [n -S]\n",
  "DISPURVEYANCES": "DISPURVEYANCE, (Spenser) depriving of provisions [n]\n",
  "DISPURVEYED": "DISPURVEY, (archaic) to deprive of provisions [v]\n",
  "DISPURVEYING": "DISPURVEY, (archaic) to deprive of provisions [v]\n",
  "DISPURVEYS": "DISPURVEY, (archaic) to deprive of provisions [v]\n",
  "DISPUTABILITIES": "DISPUTABILITY, the quality of being disputable [n]\n",
  "DISPUTABILITY": "the quality of being disputable [n DISPUTABILITIES]\n",
  "DISPUTABLE": "that can be disputed [adj DISPUTABLY]\n",
  "DISPUTABLENESS": "the state of being disputable [n]\n",
  "DISPUTABLY": "DISPUTABLE, that can be disputed [adv]\n",
  "DISPUTANT": "one who disputes [n -S]\n",
  "DISPUTANTS": "DISPUTANT, one who disputes [n]\n",
  "DISPUTATION": "the action of disputing [n -S]\n",
  "DISPUTATIONS": "DISPUTATION, the action of disputing [n]\n",
  "DISPUTATIOUS": "inclined to dispute [adj DISPUTATIOUSLY]\n",
  "DISPUTATIOUSLY": "DISPUTATIOUS, inclined to dispute [adv]\n",
  "DISPUTATIVE": "inclined to dispute [adj DISPUTATIVELY]\n",
  "DISPUTATIVELY": "DISPUTATIVE, inclined to dispute [adv]\n",
  "DISPUTATIVENESS": "DISPUTATIVE, inclined to dispute [n]\n",
  "DISPUTE": "to argue about [v DISPUTED, DISPUTING, DISPUTES]\n",
  "DISPUTED": "DISPUTE, to argue about [v]\n",
  "DISPUTER": "one who disputes [n -S]\n",
  "DISPUTERS": "DISPUTER, one who disputes [n]\n",
  "DISPUTES": "DISPUTE, to argue about [v]\n",
  "DISPUTING": "DISPUTE, to argue about [v]\n",
  "DISQUALIFIABLE": "capable of being disqualified [adj]\n",
  "DISQUALIFIED": "DISQUALIFY, to debar [v]\n",
  "DISQUALIFIER": "one who disqualifies [n -S]\n",
  "DISQUALIFIERS": "DISQUALIFIER, one who disqualifies [n]\n",
  "DISQUALIFIES": "DISQUALIFY, to debar [v]\n",
  "DISQUALIFY": "to debar [v DISQUALIFIED, DISQUALIFYING, DISQUALIFIES]\n",
  "DISQUALIFYING": "DISQUALIFY, to debar [v]\n",
  "DISQUANTITIED": "DISQUANTITY, (Shakespeare) to reduce in quantity [v]\n",
  "DISQUANTITIES": "DISQUANTITY, (Shakespeare) to reduce in quantity [v]\n",
  "DISQUANTITY": "(Shakespeare) to reduce in quantity [v DISQUANTITIED, DISQUANTITYING, DISQUANTITIES]\n",
  "DISQUANTITYING": "DISQUANTITY, (Shakespeare) to reduce in quantity [v]\n",
  "DISQUIET": "not quiet [adj DISQUIETLY] / to deprive of quiet, rest, or peace [v -ED, -ING, -S]\n",
  "DISQUIETED": "DISQUIET, to deprive of quiet, rest, or peace [v]\n",
  "DISQUIETEDLY": "DISQUIETED, DISQUIET, to deprive of quiet, rest, or peace [adv]\n",
  "DISQUIETEDNESS": "the state of being disquieted [n]\n",
  "DISQUIETEN": "to make disquiet, anxious [v -ED, -ING, -S]\n",
  "DISQUIETENED": "DISQUIETEN, to make disquiet, anxious [v]\n",
  "DISQUIETENING": "DISQUIETEN, to make disquiet, anxious [v]\n",
  "DISQUIETENS": "DISQUIETEN, to make disquiet, anxious [v]\n",
  "DISQUIETFUL": "full of disquiet [adj]\n",
  "DISQUIETING": "DISQUIET, to deprive of quiet, rest, or peace [v]\n",
  "DISQUIETINGLY": "DISQUIETING, DISQUIET, to deprive of quiet, rest, or peace [adv]\n",
  "DISQUIETIVE": "causing disquiet [adj]\n",
  "DISQUIETLY": "DISQUIET, not quiet [adv]\n",
  "DISQUIETNESS": "the state of being disquiet [n -ES]\n",
  "DISQUIETNESSES": "DISQUIETNESS, the state of being disquiet [n]\n",
  "DISQUIETOUS": "causing disquiet [adj]\n",
  "DISQUIETS": "DISQUIET, to deprive of quiet, rest, or peace [v]\n",
  "DISQUIETUDE": "anxiety, agitation [n -S]\n",
  "DISQUIETUDES": "DISQUIETUDE, anxiety, agitation [n]\n",
  "DISQUISITION": "a carefully argued examination of a topic [n -S]\n",
  "DISQUISITIONAL": "of or like a disquisition, also DISQUISITIONARY, DISQUISITIVE, DISQUISITORY [adj]\n",
  "DISQUISITIONARY": "of or like a disquisition, also DISQUISITIONAL, DISQUISITIVE, DISQUISITORY [adj]\n",
  "DISQUISITIONS": "DISQUISITION, a carefully argued examination of a topic [n]\n",
  "DISQUISITIVE": "of or like a disquisition, also DISQUISITIONAL, DISQUISITIONARY, DISQUISITORY [adj]\n",
  "DISQUISITORY": "of or like a disquisition, also DISQUISITIONAL, DISQUISITIONARY, DISQUISITIVE [adj]\n",
  "DISRANK": "to reduce rank [v -ED, -ING, -S]\n",
  "DISRANKED": "DISRANK, to reduce rank [v]\n",
  "DISRANKING": "DISRANK, to reduce rank [v]\n",
  "DISRANKS": "DISRANK, to reduce rank [v]\n",
  "DISRATE": "to lower in rank [v DISRATED, DISRATING, DISRATES]\n",
  "DISRATED": "DISRATE, to lower in rank [v]\n",
  "DISRATES": "DISRATE, to lower in rank [v]\n",
  "DISRATING": "DISRATE, to lower in rank [v]\n",
  "DISREGARD": "to pay no attention to [v -ED, -ING, -S]\n",
  "DISREGARDED": "DISREGARD, to pay no attention to [v]\n",
  "DISREGARDER": "one who disregards [n -S]\n",
  "DISREGARDERS": "DISREGARDER, one who disregards [n]\n",
  "DISREGARDFUL": "full of disregard [adj DISREGARDFULLY]\n",
  "DISREGARDFULLY": "DISREGARDFUL, full of disregard [adv]\n",
  "DISREGARDING": "DISREGARD, to pay no attention to [v]\n",
  "DISREGARDS": "DISREGARD, to pay no attention to [v]\n",
  "DISRELATED": "not related [adj]\n",
  "DISRELATION": "lack of a fitting or proportionate connection or relationship [n -S]\n",
  "DISRELATIONS": "DISRELATION, lack of a fitting or proportionate connection or relationship [n]\n",
  "DISRELISH": "to dislike, not relish [v -ED, -ING, -ES]\n",
  "DISRELISHED": "DISRELISH, to dislike, not relish [v]\n",
  "DISRELISHES": "DISRELISH, to dislike, not relish [v]\n",
  "DISRELISHING": "DISRELISH, to dislike, not relish [v]\n",
  "DISREMEMBER": "to forget [v -ED, -ING, -S]\n",
  "DISREMEMBERED": "DISREMEMBER, to forget [v]\n",
  "DISREMEMBERING": "DISREMEMBER, to forget [v]\n",
  "DISREMEMBERS": "DISREMEMBER, to forget [v]\n",
  "DISREPAIR": "a worn-out or dilapidated condition [n -S]\n",
  "DISREPAIRS": "DISREPAIR, a worn-out or dilapidated condition [n]\n",
  "DISREPUTABILITY": "the state of being disreputable [n]\n",
  "DISREPUTABLE": "not reputable [adj DISREPUTABLY]\n",
  "DISREPUTABLY": "DISREPUTABLE, not reputable [adv]\n",
  "DISREPUTATION": "bad repute [n -S]\n",
  "DISREPUTATIONS": "DISREPUTATION, bad repute [n]\n",
  "DISREPUTE": "bad repute, discredit [n -S]\n",
  "DISREPUTES": "DISREPUTE, bad repute, discredit [n]\n",
  "DISRESPECT": "lack of respect [n -S] / to have disrespect for [v -ED, -ING, -S]\n",
  "DISRESPECTABLE": "not respectable [adj]\n",
  "DISRESPECTED": "DISRESPECT, to have disrespect for [v]\n",
  "DISRESPECTFUL": "showing a lack of respect [adj DISRESPECTFULLY]\n",
  "DISRESPECTFULLY": "DISRESPECTFUL, showing a lack of respect [adv]\n",
  "DISRESPECTING": "DISRESPECT, to have disrespect for [v]\n",
  "DISRESPECTS": "DISRESPECT, to have disrespect for [v]\n",
  "DISROBE": "to undress [v DISROBED, DISROBING, DISROBES]\n",
  "DISROBED": "DISROBE, to undress [v]\n",
  "DISROBEMENT": "the act of undressing [n -S]\n",
  "DISROBEMENTS": "DISROBEMENT, the act of undressing [n]\n",
  "DISROBER": "one who, or that which, disrobes [n -S]\n",
  "DISROBERS": "DISROBER, one who, or that which, disrobes [n]\n",
  "DISROBES": "DISROBE, to undress [v]\n",
  "DISROBING": "DISROBE, to undress [v]\n",
  "DISROOT": "to tear up the roots of, or by the roots [v -ED, -ING, -S]\n",
  "DISROOTED": "DISROOT, to tear up the roots of, or by the roots [v]\n",
  "DISROOTING": "DISROOT, to tear up the roots of, or by the roots [v]\n",
  "DISROOTS": "DISROOT, to tear up the roots of, or by the roots [v]\n",
  "DISRUPT": "to throw into confusion [v -ED, -ING, -S]\n",
  "DISRUPTED": "DISRUPT, to throw into confusion [v]\n",
  "DISRUPTER": "one who disrupts, also DISRUPTOR [n -S]\n",
  "DISRUPTERS": "DISRUPTER, one who disrupts, also DISRUPTOR [n]\n",
  "DISRUPTING": "DISRUPT, to throw into confusion [v]\n",
  "DISRUPTION": "the act of disrupting [n -S]\n",
  "DISRUPTIONS": "DISRUPTION, the act of disrupting [n]\n",
  "DISRUPTIVE": "causing disruption [adj DISRUPTIVELY]\n",
  "DISRUPTIVELY": "DISRUPTIVE, causing disruption [adv]\n",
  "DISRUPTIVENESS": "DISRUPTIVE, causing disruption [n]\n",
  "DISRUPTOR": "one who disrupts, also DISRUPTER [n -S]\n",
  "DISRUPTORS": "DISRUPTOR, one who disrupts, also DISRUPTER [n]\n",
  "DISRUPTS": "DISRUPT, to throw into confusion [v]\n",
  "DISS": "to disrespect, also DIS [v -ED, -ING, -ES]\n",
  "DISSATISFACTION": "the state of being dissatisfied [n]\n",
  "DISSATISFACTORY": "causing dissatisfaction [adj]\n",
  "DISSATISFIED": "DISSATISFY, to fail to satisfy [v]\n",
  "DISSATISFIEDLY": "DISSATISFIED, DISSATISFY, to fail to satisfy [adv]\n",
  "DISSATISFIES": "DISSATISFY, to fail to satisfy [v]\n",
  "DISSATISFY": "to fail to satisfy [v DISSATISFIED, DISSATISFYING, DISSATISFIES]\n",
  "DISSATISFYING": "DISSATISFY, to fail to satisfy [v]\n",
  "DISSAVE": "to use savings for current expenses [v DISSAVED, DISSAVING, DISSAVES]\n",
  "DISSAVED": "DISSAVE, to use savings for current expenses [v]\n",
  "DISSAVER": "one who dissaves [n -S]\n",
  "DISSAVERS": "DISSAVER, one who dissaves [n]\n",
  "DISSAVES": "DISSAVE, to use savings for current expenses [v]\n",
  "DISSAVING": "the spending of savings made in the past to finance an excess of spending over disposable income, thus diminishing accumulated assets [n -S]\n",
  "DISSAVINGS": "DISSAVING, the spending of savings made in the past to finance an excess of spending over disposable income, thus diminishing accumulated assets [n]\n",
  "DISSEAT": "to unseat, dethrone [v -ED, -ING, -S]\n",
  "DISSEATED": "DISSEAT, to unseat, dethrone [v]\n",
  "DISSEATING": "DISSEAT, to unseat, dethrone [v]\n",
  "DISSEATS": "DISSEAT, to unseat, dethrone [v]\n",
  "DISSECT": "to cut apart for scientific examination [v -ED, -ING, -S]\n",
  "DISSECTED": "DISSECT, to cut apart for scientific examination [v]\n",
  "DISSECTIBLE": "capable of being dissected [adj]\n",
  "DISSECTING": "the act of taking apart [n -S]\n",
  "DISSECTINGS": "DISSECTING, the act of taking apart [n]\n",
  "DISSECTION": "the act of dissecting [n -S]\n",
  "DISSECTIONS": "DISSECTION, the act of dissecting [n]\n",
  "DISSECTIVE": "relating to dissection [adj]\n",
  "DISSECTOR": "one who dissects [n -S]\n",
  "DISSECTORS": "DISSECTOR, one who dissects [n]\n",
  "DISSECTS": "DISSECT, to cut apart for scientific examination [v]\n",
  "DISSED": "DIS, to disparage, also DISS [v]\n",
  "DISSEISE": "to deprive of seisin, to dispossess wrongfully, also DISSEIZE [v DISSEISED, DISSEISING, DISSEISES]\n",
  "DISSEISED": "DISSEISE, to deprive of seisin, to dispossess wrongfully, also DISSEIZE [v]\n",
  "DISSEISEE": "one who is disseised, deprived of seisin, also DISSEIZEE [n -S]\n",
  "DISSEISEES": "DISSEISEE, one who is disseised, deprived of seisin, also DISSEIZEE [n]\n",
  "DISSEISES": "DISSEISE, to deprive of seisin, to dispossess wrongfully, also DISSEIZE [v]\n",
  "DISSEISIN": "the act of disseizing; an unlawful dispossessing and ouster of a person actually seized of the freehold, also DISSEIZIN [n -S]\n",
  "DISSEISING": "DISSEISE, to deprive of seisin, to dispossess wrongfully, also DISSEIZE [v]\n",
  "DISSEISINS": "DISSEISIN, the act of disseizing; an unlawful dispossessing and ouster of a person actually seized of the freehold, also DISSEIZIN [n]\n",
  "DISSEISOR": "one who deprives another of seisin, also DISSEIZOR [n -S]\n",
  "DISSEISORS": "DISSEISOR, one who deprives another of seisin, also DISSEIZOR [n]\n",
  "DISSEIZE": "to deprive of seisin; to dispossess wrongfully, also DISSEISE [v DISSEIZED, DISSEIZING, DISSEIZES]\n",
  "DISSEIZED": "DISSEIZE, to deprive of seisin; to dispossess wrongfully, also DISSEISE [v]\n",
  "DISSEIZEE": "one who is disseized, deprived of seisin, also DISSEISEE [n -S]\n",
  "DISSEIZEES": "DISSEIZEE, one who is disseized, deprived of seisin, also DISSEISEE [n]\n",
  "DISSEIZES": "DISSEIZE, to deprive of seisin; to dispossess wrongfully, also DISSEISE [v]\n",
  "DISSEIZIN": "the act of disseizing; an unlawful dispossessing and ouster of a person actually seized of the freehold, also DISSEISIN [n -S]\n",
  "DISSEIZING": "DISSEIZE, to deprive of seisin; to dispossess wrongfully, also DISSEISE [v]\n",
  "DISSEIZINS": "DISSEIZIN, the act of disseizing; an unlawful dispossessing and ouster of a person actually seized of the freehold, also DISSEISIN [n]\n",
  "DISSEIZOR": "one who deprives another of seisin, also DISSEISOR [n -S]\n",
  "DISSEIZORS": "DISSEIZOR, one who deprives another of seisin, also DISSEISOR [n]\n",
  "DISSELBOOM": "(South African) the single shaft of an ox-wagon or other cart [n -S]\n",
  "DISSELBOOMS": "DISSELBOOM, (South African) the single shaft of an ox-wagon or other cart [n]\n",
  "DISSEMBLANCE": "the act of dissembling [n -S]\n",
  "DISSEMBLANCES": "DISSEMBLANCE, the act of dissembling [n]\n",
  "DISSEMBLE": "to hide true feelings, motives, or the facts [v DISSEMBLED, DISSEMBLING, DISSEMBLES]\n",
  "DISSEMBLED": "DISSEMBLE, to hide true feelings, motives, or the facts [v]\n",
  "DISSEMBLER": "one who dissembles, hides true feelings [n -S]\n",
  "DISSEMBLERS": "DISSEMBLER, one who dissembles, hides true feelings [n]\n",
  "DISSEMBLES": "DISSEMBLE, to hide true feelings, motives, or the facts [v]\n",
  "DISSEMBLIES": "DISSEMBLY, the breaking up of an assembly, also DISASSEMBLY [n]\n",
  "DISSEMBLING": "hiding true feelings [adj DISSEMBLINGLY] / to hide true feelings, motives, or the facts [n -S]\n",
  "DISSEMBLINGLY": "DISSEMBLING [adv]\n",
  "DISSEMBLINGS": "DISSEMBLING, to hide true feelings, motives, or the facts [n]\n",
  "DISSEMBLY": "the breaking up of an assembly, also DISASSEMBLY [n DISSEMBLIES]\n",
  "DISSEMINATE": "to spread abroad as though sowing seed [v DISSEMINATED, DISSEMINATING, DISSEMINATES]\n",
  "DISSEMINATED": "DISSEMINATE, to spread abroad as though sowing seed [v]\n",
  "DISSEMINATES": "DISSEMINATE, to spread abroad as though sowing seed [v]\n",
  "DISSEMINATING": "DISSEMINATE, to spread abroad as though sowing seed [v]\n",
  "DISSEMINATION": "the act of disseminating [n -S]\n",
  "DISSEMINATIONS": "DISSEMINATION, the act of disseminating [n]\n",
  "DISSEMINATIVE": "serving to disseminate [adj]\n",
  "DISSEMINATOR": "one who disseminates [n -S]\n",
  "DISSEMINATORS": "DISSEMINATOR, one who disseminates [n]\n",
  "DISSEMINULE": "a reproductive plant part [n -S]\n",
  "DISSEMINULES": "DISSEMINULE, a reproductive plant part [n]\n",
  "DISSENSION": "disagreement, also DISSENTION [n -S]\n",
  "DISSENSIONS": "DISSENSION, disagreement, also DISSENTION [n]\n",
  "DISSENSUS": "(Latin) a widespread difference of opinion [n -ES]\n",
  "DISSENSUSES": "DISSENSUS, (Latin) a widespread difference of opinion [n]\n",
  "DISSENT": "to disagree [v -ED, -ING, -S]\n",
  "DISSENTED": "DISSENT, to disagree [v]\n",
  "DISSENTER": "one who dissents [n -S]\n",
  "DISSENTERISH": "like a (religious) dissenter [adj]\n",
  "DISSENTERISM": "the beliefs of a dissenter [n -S]\n",
  "DISSENTERISMS": "DISSENTERISM, the beliefs of a dissenter [n]\n",
  "DISSENTERS": "DISSENTER, one who dissents [n]\n",
  "DISSENTIENCE": "the state of being dissentient, also DISSENTIENCY [n -S]\n",
  "DISSENTIENCES": "DISSENTIENCE, the state of being dissentient, also DISSENTIENCY [n]\n",
  "DISSENTIENCIES": "DISSENTIENCY, the state of being dissentient, also DISSENTIENCE [n]\n",
  "DISSENTIENCY": "the state of being dissentient, also DISSENTIENCE [n DISSENTIENCIES]\n",
  "DISSENTIENT": "dissenting [adj DISSENTIENTLY] / one who dissents [n -S]\n",
  "DISSENTIENTLY": "DISSENTIENT, dissenting [adv]\n",
  "DISSENTIENTS": "DISSENTIENT, one who dissents [n]\n",
  "DISSENTING": "DISSENT, to disagree [v]\n",
  "DISSENTINGLY": "DISSENTING, DISSENT, to disagree [adv]\n",
  "DISSENTION": "(US) dissension, also DISSENSION [n -S]\n",
  "DISSENTIONS": "DISSENTION, (US) dissension, also DISSENSION [n]\n",
  "DISSENTIOUS": "characterized by dissension or dissent [adj]\n",
  "DISSENTS": "DISSENT, to disagree [v]\n",
  "DISSEPIMENT": "a partition in an ovary [n -S]\n",
  "DISSEPIMENTAL": "relating to a dissepiment, a partition in an ovary [adj]\n",
  "DISSEPIMENTS": "DISSEPIMENT, a partition in an ovary [n]\n",
  "DISSERT": "to discuss in a formal manner [v -ED, -ING, -S]\n",
  "DISSERTATE": "to discourse [v DISSERTATED, DISSERTATING, DISSERTATES]\n",
  "DISSERTATED": "DISSERTATE, to discourse [v]\n",
  "DISSERTATES": "DISSERTATE, to discourse [v]\n",
  "DISSERTATING": "DISSERTATE, to discourse [v]\n",
  "DISSERTATION": "an extended usually written treatment of a subject [n -S]\n",
  "DISSERTATIONAL": "relating to dissertation [adj]\n",
  "DISSERTATIONIST": "one who produces dissertations [n]\n",
  "DISSERTATIONS": "DISSERTATION, an extended usually written treatment of a subject [n]\n",
  "DISSERTATIVE": "relating to dissertation [adj]\n",
  "DISSERTATOR": "one who writes a dissertation [n -S]\n",
  "DISSERTATORS": "DISSERTATOR, one who writes a dissertation [n]\n",
  "DISSERTED": "DISSERT, to discuss in a formal manner [v]\n",
  "DISSERTING": "DISSERT, to discuss in a formal manner [v]\n",
  "DISSERTS": "DISSERT, to discuss in a formal manner [v]\n",
  "DISSERVE": "to treat badly [v DISSERVED, DISSERVING, DISSERVES]\n",
  "DISSERVED": "DISSERVE, to treat badly [v]\n",
  "DISSERVES": "DISSERVE, to treat badly [v]\n",
  "DISSERVICE": "ill service [n -S]\n",
  "DISSERVICEABLE": "not serviceable [adj]\n",
  "DISSERVICES": "DISSERVICE, ill service [n]\n",
  "DISSERVING": "DISSERVE, to treat badly [v]\n",
  "DISSES": "DISS, to disrespect, also DIS [v]\n",
  "DISSEVER": "to sever, part in two [v -ED, -ING, -S]\n",
  "DISSEVERANCE": "the act of dissevering, also DISSEVERATION, DISSEVERMENT [n -S]\n",
  "DISSEVERANCES": "DISSEVERANCE, the act of dissevering, also DISSEVERATION, DISSEVERMENT [n]\n",
  "DISSEVERATION": "the act of dissevering, also DISSEVERANCE, DISSEVERMENT [n -S]\n",
  "DISSEVERATIONS": "DISSEVERATION, the act of dissevering, also DISSEVERANCE, DISSEVERMENT [n]\n",
  "DISSEVERED": "DISSEVER, to sever, part in two [v]\n",
  "DISSEVERING": "DISSEVER, to sever, part in two [v]\n",
  "DISSEVERMENT": "the act of dissevering, also DISSEVERANCE, DISSEVERATION [n -S]\n",
  "DISSEVERMENTS": "DISSEVERMENT, the act of dissevering, also DISSEVERANCE, DISSEVERATION [n]\n",
  "DISSEVERS": "DISSEVER, to sever, part in two [v]\n",
  "DISSHEATHE": "to become unsheathed [v DISSHEATHED, DISSHEATHING, DISSHEATHES]\n",
  "DISSHEATHED": "DISSHEATHE, to become unsheathed [v]\n",
  "DISSHEATHES": "DISSHEATHE, to become unsheathed [v]\n",
  "DISSHEATHING": "DISSHEATHE, to become unsheathed [v]\n",
  "DISSHIVER": "(Spenser) to shiver or break in pieces [v -ED, -ING, -S]\n",
  "DISSHIVERED": "DISSHIVER, (Spenser) to shiver or break in pieces [v]\n",
  "DISSHIVERING": "DISSHIVER, (Spenser) to shiver or break in pieces [v]\n",
  "DISSHIVERS": "DISSHIVER, (Spenser) to shiver or break in pieces [v]\n",
  "DISSIDENCE": "disagreement; dissent [n -S]\n",
  "DISSIDENCES": "DISSIDENCE, disagreement; dissent [n]\n",
  "DISSIDENT": "dissenting [adj DISSIDENTLY] / a dissenter, esp. one who disagrees with the aims and procedures of the government [n -S]\n",
  "DISSIDENTLY": "DISSIDENT, dissenting [adv]\n",
  "DISSIDENTS": "DISSIDENT, a dissenter, esp. one who disagrees with the aims and procedures of the government [n]\n",
  "DISSIGHT": "(archaic) an unsightly object [n -S]\n",
  "DISSIGHTS": "DISSIGHT, (archaic) an unsightly object [n]\n",
  "DISSILIENCE": "springing apart [n -S]\n",
  "DISSILIENCES": "DISSILIENCE, springing apart [n]\n",
  "DISSILIENT": "springing apart; bursting open with force [adj]\n",
  "DISSIMILAR": "unlike [adj DISSIMILARLY] / something not similar [n -S]\n",
  "DISSIMILARITIES": "DISSIMILARITY, the state of being dissimilar [n]\n",
  "DISSIMILARITY": "the state of being dissimilar [n DISSIMILARITIES]\n",
  "DISSIMILARLY": "DISSIMILAR, unlike [adv]\n",
  "DISSIMILARS": "DISSIMILAR, something not similar [n]\n",
  "DISSIMILATE": "to undergo dissimilation [v DISSIMILATED, DISSIMILATING, DISSIMILATES]\n",
  "DISSIMILATED": "DISSIMILATE, to undergo dissimilation [v]\n",
  "DISSIMILATES": "DISSIMILATE, to undergo dissimilation [v]\n",
  "DISSIMILATING": "DISSIMILATE, to undergo dissimilation [v]\n",
  "DISSIMILATION": "the change or omission of one of two identical or closely related sounds in a word [n -S]\n",
  "DISSIMILATIONS": "DISSIMILATION, the change or omission of one of two identical or closely related sounds in a word [n]\n",
  "DISSIMILATIVE": "serving to dissimilate, make dissimilar, also DISSIMILATORY [adj]\n",
  "DISSIMILATORY": "serving to dissimilate, make dissimilar, also DISSIMILATIVE [adj]\n",
  "DISSIMILE": "a comparison or illustration by contraries [n -S]\n",
  "DISSIMILES": "DISSIMILE, a comparison or illustration by contraries [n]\n",
  "DISSIMILITUDE": "lack of resemblance [n -S]\n",
  "DISSIMILITUDES": "DISSIMILITUDE, lack of resemblance [n]\n",
  "DISSIMULATE": "to pretend, feign [v DISSIMULATED, DISSIMULATING, DISSIMULATES]\n",
  "DISSIMULATED": "DISSIMULATE, to pretend, feign [v]\n",
  "DISSIMULATES": "DISSIMULATE, to pretend, feign [v]\n",
  "DISSIMULATING": "DISSIMULATE, to pretend, feign [v]\n",
  "DISSIMULATION": "the act of dissimulating [n -S]\n",
  "DISSIMULATIONS": "DISSIMULATION, the act of dissimulating [n]\n",
  "DISSIMULATIVE": "related to dissimulation [adj]\n",
  "DISSIMULATOR": "one who dissimulates [n -S]\n",
  "DISSIMULATORS": "DISSIMULATOR, one who dissimulates [n]\n",
  "DISSING": "DIS, to disparage, also DISS [v]\n",
  "DISSIPABLE": "capable of being scattered or dissipated [adj]\n",
  "DISSIPATE": "to scatter or disperse [v DISSIPATED, DISSIPATING, DISSIPATES]\n",
  "DISSIPATED": "DISSIPATE, to scatter or disperse [v]\n",
  "DISSIPATEDLY": "DISSIPATED, DISSIPATE, to scatter or disperse [adv]\n",
  "DISSIPATEDNESS": "the state of being dissipated [n]\n",
  "DISSIPATER": "one who dissipates, also DISSIPATOR [n -S]\n",
  "DISSIPATERS": "DISSIPATER, one who dissipates, also DISSIPATOR [n]\n",
  "DISSIPATES": "DISSIPATE, to scatter or disperse [v]\n",
  "DISSIPATING": "DISSIPATE, to scatter or disperse [v]\n",
  "DISSIPATION": "the act of dissipating [n -S]\n",
  "DISSIPATIONS": "DISSIPATION, the act of dissipating [n]\n",
  "DISSIPATIVE": "relating to dissipation esp. of heat [adj]\n",
  "DISSIPATOR": "one who dissipates, also DISSIPATER [n -S]\n",
  "DISSIPATORS": "DISSIPATOR, one who dissipates, also DISSIPATER [n]\n",
  "DISSOCIABILITY": "the state of being dissociable [n]\n",
  "DISSOCIABLE": "that can be dissociated [adj DISSOCIABLY]\n",
  "DISSOCIABLENESS": "DISSOCIABLE, that can be dissociated [n]\n",
  "DISSOCIABLY": "DISSOCIABLE, that can be dissociated [adv]\n",
  "DISSOCIAL": "(archaic) not social [adj]\n",
  "DISSOCIALISE": "to make unsocial, also DISSOCIALIZE [v DISSOCIALISED, DISSOCIALISING, DISSOCIALISES]\n",
  "DISSOCIALISED": "DISSOCIALISE, to make unsocial, also DISSOCIALIZE [v]\n",
  "DISSOCIALISES": "DISSOCIALISE, to make unsocial, also DISSOCIALIZE [v]\n",
  "DISSOCIALISING": "DISSOCIALISE, to make unsocial, also DISSOCIALIZE [v]\n",
  "DISSOCIALITIES": "DISSOCIALITY, the state of being dissocial [n]\n",
  "DISSOCIALITY": "the state of being dissocial [n DISSOCIALITIES]\n",
  "DISSOCIALIZE": "to make unsocial, also DISSOCIALISE [v DISSOCIALIZED, DISSOCIALIZING, DISSOCIALIZES]\n",
  "DISSOCIALIZED": "DISSOCIALIZE, to make unsocial, also DISSOCIALISE [v]\n",
  "DISSOCIALIZES": "DISSOCIALIZE, to make unsocial, also DISSOCIALISE [v]\n",
  "DISSOCIALIZING": "DISSOCIALIZE, to make unsocial, also DISSOCIALISE [v]\n",
  "DISSOCIATE": "to separate from association or union with another, also DISASSOCIATE [v DISSOCIATED, DISSOCIATING, DISSOCIATES]\n",
  "DISSOCIATED": "DISSOCIATE, to separate from association or union with another, also DISASSOCIATE [v]\n",
  "DISSOCIATES": "DISSOCIATE, to separate from association or union with another, also DISASSOCIATE [v]\n",
  "DISSOCIATING": "DISSOCIATE, to separate from association or union with another, also DISASSOCIATE [v]\n",
  "DISSOCIATION": "the act of dissociating [n -S]\n",
  "DISSOCIATIONS": "DISSOCIATION, the act of dissociating [n]\n",
  "DISSOCIATIVE": "serving to dissociate [adj]\n",
  "DISSOLUBILITIES": "DISSOLUBILITY, the state of being dissoluble [n]\n",
  "DISSOLUBILITY": "the state of being dissoluble [n DISSOLUBILITIES]\n",
  "DISSOLUBLE": "capable of being dissolved [adj]\n",
  "DISSOLUBLENESS": "the state of being dissoluble [n]\n",
  "DISSOLUTE": "of loose morals; debauched [adj DISSOLUTELY] / a dissolute person [n -S]\n",
  "DISSOLUTELY": "DISSOLUTE, of loose morals; debauched [adv]\n",
  "DISSOLUTENESS": "the state of being dissolute [n -ES]\n",
  "DISSOLUTENESSES": "DISSOLUTENESS, the state of being dissolute [n]\n",
  "DISSOLUTES": "DISSOLUTE, a dissolute person [n]\n",
  "DISSOLUTION": "separation into component parts [n -S]\n",
  "DISSOLUTIONISM": "belief in political dissolution [n -S]\n",
  "DISSOLUTIONISMS": "DISSOLUTIONISM, belief in political dissolution [n]\n",
  "DISSOLUTIONIST": "a proponent of dissolutionism [n -S]\n",
  "DISSOLUTIONISTS": "DISSOLUTIONIST, a proponent of dissolutionism [n]\n",
  "DISSOLUTIONS": "DISSOLUTION, separation into component parts [n]\n",
  "DISSOLUTIVE": "causing dissolution [adj]\n",
  "DISSOLVABILITY": "the quality of being dissolvable [n]\n",
  "DISSOLVABLE": "that can be dissolved [adj]\n",
  "DISSOLVABLENESS": "DISSOLVABLE, that can be dissolved [n]\n",
  "DISSOLVE": "to make into a solution [v DISSOLVED, DISSOLVING, DISSOLVES]\n",
  "DISSOLVED": "DISSOLVE, to make into a solution [v]\n",
  "DISSOLVENT": "a solvent [n -S]\n",
  "DISSOLVENTS": "DISSOLVENT, a solvent [n]\n",
  "DISSOLVER": "something that dissolves [n -S]\n",
  "DISSOLVERS": "DISSOLVER, something that dissolves [n]\n",
  "DISSOLVES": "DISSOLVE, to make into a solution [v]\n",
  "DISSOLVING": "the act of dissolution [n -S]\n",
  "DISSOLVINGS": "DISSOLVING, the act of dissolution [n]\n",
  "DISSONANCE": "lack of agreement [n -S]\n",
  "DISSONANCES": "DISSONANCE, lack of agreement [n]\n",
  "DISSONANCIES": "DISSONANCY, discord, dissonance [n]\n",
  "DISSONANCY": "discord, dissonance [n DISSONANCIES]\n",
  "DISSONANT": "discordant, inharmonious [adj DISSONANTLY]\n",
  "DISSONANTLY": "DISSONANT, discordant, inharmonious [adv]\n",
  "DISSUADABLE": "that can be dissuaded [adj]\n",
  "DISSUADE": "to persuade not to do something [v DISSUADED, DISSUADING, DISSUADES]\n",
  "DISSUADED": "DISSUADE, to persuade not to do something [v]\n",
  "DISSUADER": "one who dissuades [n -S]\n",
  "DISSUADERS": "DISSUADER, one who dissuades [n]\n",
  "DISSUADES": "DISSUADE, to persuade not to do something [v]\n",
  "DISSUADING": "DISSUADE, to persuade not to do something [v]\n",
  "DISSUASION": "the act of dissuading [n -S]\n",
  "DISSUASIONS": "DISSUASION, the act of dissuading [n]\n",
  "DISSUASIVE": "tending to dissuade [adj DISSUASIVELY] / that which dissuades [n -S]\n",
  "DISSUASIVELY": "DISSUASIVE, tending to dissuade [adv]\n",
  "DISSUASIVENESS": "DISSUASIVE, tending to dissuade [n]\n",
  "DISSUASIVES": "DISSUASIVE, that which dissuades [n]\n",
  "DISSUASORIES": "DISSUASORY, a dissuasive [n]\n",
  "DISSUASORY": "a dissuasive [n DISSUASORIES]\n",
  "DISSUNDER": "(archaic) to sunder [v -ED, -ING, -S]\n",
  "DISSUNDERED": "DISSUNDER, (archaic) to sunder [v]\n",
  "DISSUNDERING": "DISSUNDER, (archaic) to sunder [v]\n",
  "DISSUNDERS": "DISSUNDER, (archaic) to sunder [v]\n",
  "DISSYLLABIC": "having two syllables, also DISYLLABIC [adj]\n",
  "DISSYLLABIFIED": "DISSYLLABIFY, to make disyllabic [v]\n",
  "DISSYLLABIFIES": "DISSYLLABIFY, to make disyllabic [v]\n",
  "DISSYLLABIFY": "to make disyllabic [v DISSYLLABIFIED, DISSYLLABIFYING, DISSYLLABIFIES]\n",
  "DISSYLLABIFYING": "DISSYLLABIFY, to make disyllabic [v]\n",
  "DISSYLLABISM": "the fact of having two syllables [n -S]\n",
  "DISSYLLABISMS": "DISSYLLABISM, the fact of having two syllables [n]\n",
  "DISSYLLABLE": "a word with two syllables [n -S]\n",
  "DISSYLLABLES": "DISSYLLABLE, a word with two syllables [n]\n",
  "DISSYMMETRIC": "relating to dissymmetry, also DISSYMMETRICAL [adj]\n",
  "DISSYMMETRICAL": "relating to dissymmetry, also DISSYMMETRIC [adj]\n",
  "DISSYMMETRIES": "DISSYMMETRY, the absence of or the lack of symmetry [n]\n",
  "DISSYMMETRY": "the absence of or the lack of symmetry [n DISSYMMETRIES]\n",
  "DISTAFF": "a type of staff [n DISTAFFS or DISTAVES]\n",
  "DISTAFFS": "DISTAFF, a type of staff [n]\n",
  "DISTAIN": "(archaic) to stain, sully [v -ED, -ING, -S]\n",
  "DISTAINED": "DISTAIN, (archaic) to stain, sully [v]\n",
  "DISTAINING": "DISTAIN, (archaic) to stain, sully [v]\n",
  "DISTAINS": "DISTAIN, (archaic) to stain, sully [v]\n",
  "DISTAL": "remote from the point of attachment or origin; as, the distal end of a bone or muscle [adj DISTALLY]\n",
  "DISTALLY": "DISTAL, remote from the point of attachment or origin; as, the distal end of a bone or muscle [adv]\n",
  "DISTANCE": "to move far from a particular point [v DISTANCED, DISTANCING, DISTANCES]\n",
  "DISTANCED": "DISTANCE, to move far from a particular point [v]\n",
  "DISTANCELESS": "without distance [adj]\n",
  "DISTANCES": "DISTANCE, to move far from a particular point [v]\n",
  "DISTANCING": "DISTANCE, to move far from a particular point [v]\n",
  "DISTANT": "far off or apart [adj DISTANTLY]\n",
  "DISTANTLY": "DISTANT, far off or apart [adv]\n",
  "DISTANTNESS": "the state of being distant [n -ES]\n",
  "DISTANTNESSES": "DISTANTNESS, the state of being distant [n]\n",
  "DISTASTE": "dislike [n -S] / (archaic) to feel distaste for [v DISTASTED, DISTASTING, DISTASTES]\n",
  "DISTASTED": "DISTASTE, (archaic) to feel distaste for [v]\n",
  "DISTASTEFUL": "objectionable because offensive to one's personal taste [adj DISTASTEFULLY]\n",
  "DISTASTEFULLY": "DISTASTEFUL, objectionable because offensive to one's personal taste [adv]\n",
  "DISTASTEFULNESS": "DISTASTEFUL, objectionable because offensive to one's personal taste [n]\n",
  "DISTASTES": "DISTASTE, (archaic) to feel distaste for [v]\n",
  "DISTASTING": "DISTASTE, (archaic) to feel distaste for [v]\n",
  "DISTAVES": "DISTAFF, a type of staff [n]\n",
  "DISTELFINK": "(Dutch) a traditional Pennsylvanian Dutch design motif in the form of a stylised bird [n -S]\n",
  "DISTELFINKS": "DISTELFINK, (Dutch) a traditional Pennsylvanian Dutch design motif in the form of a stylised bird [n]\n",
  "DISTEMPER": "a kind of paint [n -S] / to paint or colour with distemper, also DESTEMPER [v -ED, -ING, -S]\n",
  "DISTEMPERATE": "not temperate [adj]\n",
  "DISTEMPERATURE": "(archaic) lack of proper temperature; intemperateness [n -S]\n",
  "DISTEMPERATURES": "DISTEMPERATURE, (archaic) lack of proper temperature; intemperateness [n]\n",
  "DISTEMPERED": "DISTEMPER, to paint or colour with distemper, also DESTEMPER [v]\n",
  "DISTEMPERING": "DISTEMPER, to paint or colour with distemper, also DESTEMPER [v]\n",
  "DISTEMPERS": "DISTEMPER, to paint or colour with distemper, also DESTEMPER [v]\n",
  "DISTEND": "to swell [v -ED, -ING, -S]\n",
  "DISTENDED": "DISTEND, to swell [v]\n",
  "DISTENDER": "one who distends [n -S]\n",
  "DISTENDERS": "DISTENDER, one who distends [n]\n",
  "DISTENDING": "DISTEND, to swell [v]\n",
  "DISTENDS": "DISTEND, to swell [v]\n",
  "DISTENSIBILITY": "the state of being distensible [n]\n",
  "DISTENSIBLE": "that may be stretched, also DISTENSILE [adj]\n",
  "DISTENSILE": "that may be stretched, also DISTENSIBLE [adj]\n",
  "DISTENSION": "the act of distending, also DISTENTION [n -S]\n",
  "DISTENSIONS": "DISTENSION, the act of distending, also DISTENTION [n]\n",
  "DISTENSIVE": "distending, or capable of being distended [adj]\n",
  "DISTENT": "(Spenser) breadth, distention [n -S]\n",
  "DISTENTION": "the act of distending, also DISTENSION [n -S]\n",
  "DISTENTIONS": "DISTENTION, the act of distending, also DISTENSION [n]\n",
  "DISTENTS": "DISTENT, (Spenser) breadth, distention [n]\n",
  "DISTHENE": "a mineral, aka cyanite or kyanite, so called in allusion to its unequal hardness in two different directions [n -S]\n",
  "DISTHENES": "DISTHENE, a mineral, aka cyanite or kyanite, so called in allusion to its unequal hardness in two different directions [n]\n",
  "DISTHRONE": "to remove from a throne, also DETHRONE, UNTHRONE [v DISTHRONED, DISTHRONING, DISTHRONES]\n",
  "DISTHRONED": "DISTHRONE, to remove from a throne, also DETHRONE, UNTHRONE [v]\n",
  "DISTHRONES": "DISTHRONE, to remove from a throne, also DETHRONE, UNTHRONE [v]\n",
  "DISTHRONING": "DISTHRONE, to remove from a throne, also DETHRONE, UNTHRONE [v]\n",
  "DISTHRONISE": "(Spenser) to dethrone, also DISTHRONIZE [v DISTHRONISED, DISTHRONISING, DISTHRONISES]\n",
  "DISTHRONISED": "DISTHRONISE, (Spenser) to dethrone, also DISTHRONIZE [v]\n",
  "DISTHRONISES": "DISTHRONISE, (Spenser) to dethrone, also DISTHRONIZE [v]\n",
  "DISTHRONISING": "DISTHRONISE, (Spenser) to dethrone, also DISTHRONIZE [v]\n",
  "DISTHRONIZE": "(Spenser) to dethrone, also DISTHRONISE [v DISTHRONIZED, DISTHRONIZING, DISTHRONIZES]\n",
  "DISTHRONIZED": "DISTHRONIZE, (Spenser) to dethrone, also DISTHRONISE [v]\n",
  "DISTHRONIZES": "DISTHRONIZE, (Spenser) to dethrone, also DISTHRONISE [v]\n",
  "DISTHRONIZING": "DISTHRONIZE, (Spenser) to dethrone, also DISTHRONISE [v]\n",
  "DISTICH": "(Greek) a pair of verses or poetic lines making complete sense [n -S]\n",
  "DISTICHAL": "in or having two rows, also DISTICHOUS [adj]\n",
  "DISTICHOUS": "in or having two rows, also DISTICHAL [adj DISTICHOUSLY]\n",
  "DISTICHOUSLY": "DISTICHOUS, in or having two rows, also DISTICHAL [adv]\n",
  "DISTICHS": "DISTICH, (Greek) a pair of verses or poetic lines making complete sense [n]\n",
  "DISTIL": "to extract by vaporization and condensation, also DISTILL [v DISTILLED, DISTILLING, DISTILS]\n",
  "DISTILL": "to extract by vaporization and condensation, also DISTIL [v -ED, -ING, -S]\n",
  "DISTILLABLE": "that can be distilled [adj]\n",
  "DISTILLAND": "that which is to be, or is, distilled [n -S]\n",
  "DISTILLANDS": "DISTILLAND, that which is to be, or is, distilled [n]\n",
  "DISTILLATE": "the product of distillation [n -S]\n",
  "DISTILLATES": "DISTILLATE, the product of distillation [n]\n",
  "DISTILLATION": "the process of purifying a liquid by successive evaporation and condensation [n -S]\n",
  "DISTILLATIONS": "DISTILLATION, the process of purifying a liquid by successive evaporation and condensation [n]\n",
  "DISTILLATORY": "relating to distillation [adj]\n",
  "DISTILLED": "DISTILL, to extract by vaporization and condensation, also DISTIL [v]\n",
  "DISTILLER": "one who distils [n -S]\n",
  "DISTILLERIES": "DISTILLERY, the building and works where distilling, esp. of alcoholic liquors, is carried on [n]\n",
  "DISTILLERS": "DISTILLER, one who distils [n]\n",
  "DISTILLERY": "the building and works where distilling, esp. of alcoholic liquors, is carried on [n DISTILLERIES]\n",
  "DISTILLING": "the act of distillation [n -S]\n",
  "DISTILLINGS": "DISTILLING, the act of distillation [n]\n",
  "DISTILLS": "DISTILL, to extract by vaporization and condensation, also DISTIL [v]\n",
  "DISTILMENT": "(Shakespeare) that which is distilled [n -S]\n",
  "DISTILMENTS": "DISTILMENT, (Shakespeare) that which is distilled [n]\n",
  "DISTILS": "DISTIL, to extract by vaporization and condensation, also DISTILL [v]\n",
  "DISTINCT": "clearly different [adj DISTINCTER, DISTINCTEST, DISTINCTLY]\n",
  "DISTINCTER": "DISTINCT, clearly different [adj]\n",
  "DISTINCTEST": "DISTINCT, clearly different [adj]\n",
  "DISTINCTION": "separation or division [n -S]\n",
  "DISTINCTIONS": "DISTINCTION, separation or division [n]\n",
  "DISTINCTIVE": "serving to distinguish [adj DISTINCTIVELY] / something distinctive [n -S]\n",
  "DISTINCTIVELY": "DISTINCTIVE, serving to distinguish [adv]\n",
  "DISTINCTIVENESS": "the state of being distinctive [n]\n",
  "DISTINCTIVES": "DISTINCTIVE, something distinctive [n]\n",
  "DISTINCTLY": "DISTINCT, clearly different [adv]\n",
  "DISTINCTNESS": "the state of being distinct [n -ES]\n",
  "DISTINCTNESSES": "DISTINCTNESS, the state of being distinct [n]\n",
  "DISTINCTURE": "distinctness [n -S]\n",
  "DISTINCTURES": "DISTINCTURE, distinctness [n]\n",
  "DISTINGUE": "(French) (of a male) distinguished esp. in manner, or bearing [adj]\n",
  "DISTINGUEE": "(French) (of a female) distinguished, esp. in manner or bearing [adj]\n",
  "DISTINGUISH": "to perceive a difference in [v -ED, -ING, -ES]\n",
  "DISTINGUISHABLE": "capable of being distinguished [adj DISTINGUISHABLY]\n",
  "DISTINGUISHABLY": "DISTINGUISHABLE, capable of being distinguished [adv]\n",
  "DISTINGUISHED": "DISTINGUISH, to perceive a difference in [v]\n",
  "DISTINGUISHER": "one who distinguishes [n -S]\n",
  "DISTINGUISHERS": "DISTINGUISHER, one who distinguishes [n]\n",
  "DISTINGUISHES": "DISTINGUISH, to perceive a difference in [v]\n",
  "DISTINGUISHING": "DISTINGUISH, to perceive a difference in [v]\n",
  "DISTINGUISHMENT": "(Shakespeare) distinction [n]\n",
  "DISTOME": "a parasitic flatworm [n -S]\n",
  "DISTOMES": "DISTOME, a parasitic flatworm [n]\n",
  "DISTORT": "to twist or bend out of shape [v -ED, -ING, -S]\n",
  "DISTORTED": "DISTORT, to twist or bend out of shape [v]\n",
  "DISTORTEDLY": "DISTORTED, DISTORT, to twist or bend out of shape [adv]\n",
  "DISTORTEDNESS": "the state of being distorted [n -ES]\n",
  "DISTORTEDNESSES": "DISTORTEDNESS, the state of being distorted [n]\n",
  "DISTORTER": "one who distorts [n -S]\n",
  "DISTORTERS": "DISTORTER, one who distorts [n]\n",
  "DISTORTING": "DISTORT, to twist or bend out of shape [v]\n",
  "DISTORTION": "a lack of proportionality in an image resulting from defects in the optical system [n -S]\n",
  "DISTORTIONAL": "relating to distortion [adj]\n",
  "DISTORTIONS": "DISTORTION, a lack of proportionality in an image resulting from defects in the optical system [n]\n",
  "DISTORTIVE": "causing distortion [adj]\n",
  "DISTORTS": "DISTORT, to twist or bend out of shape [v]\n",
  "DISTRACT": "to divert the attention of [v -ED, -ING, -S]\n",
  "DISTRACTABLE": "that can be distracted, also DISTRACTIBLE [adj]\n",
  "DISTRACTED": "DISTRACT, to divert the attention of [v]\n",
  "DISTRACTEDLY": "DISTRACTED, DISTRACT, to divert the attention of [adv]\n",
  "DISTRACTEDNESS": "the state of being distracted [n]\n",
  "DISTRACTER": "one who distracts [n -S]\n",
  "DISTRACTERS": "DISTRACTER, one who distracts [n]\n",
  "DISTRACTIBILITY": "the state of being distractible [n]\n",
  "DISTRACTIBLE": "that can be distracted, also DISTRACTABLE [adj]\n",
  "DISTRACTING": "DISTRACT, to divert the attention of [v]\n",
  "DISTRACTINGLY": "DISTRACTING, DISTRACT, to divert the attention of [adv]\n",
  "DISTRACTION": "the act of distracting or the state of being distracted [n -S]\n",
  "DISTRACTIONS": "DISTRACTION, the act of distracting or the state of being distracted [n]\n",
  "DISTRACTIVE": "serving to distract [adj DISTRACTIVELY]\n",
  "DISTRACTIVELY": "DISTRACTIVE, serving to distract [adv]\n",
  "DISTRACTOR": "any of the incorrect choices in a multiple choice question [n -S]\n",
  "DISTRACTORS": "DISTRACTOR, any of the incorrect choices in a multiple choice question [n]\n",
  "DISTRACTS": "DISTRACT, to divert the attention of [v]\n",
  "DISTRAIL": "an aircraft's dissipation trail [n -S]\n",
  "DISTRAILS": "DISTRAIL, an aircraft's dissipation trail [n]\n",
  "DISTRAIN": "to seize and hold property as security [v -ED, -ING, -S]\n",
  "DISTRAINABLE": "capable of being distrained [adj]\n",
  "DISTRAINED": "DISTRAIN, to seize and hold property as security [v]\n",
  "DISTRAINEE": "a person whose property has been distrained [n -S]\n",
  "DISTRAINEES": "DISTRAINEE, a person whose property has been distrained [n]\n",
  "DISTRAINER": "one who distrains; the party distraining goods or chattels, also DISTRAINOR [n -S]\n",
  "DISTRAINERS": "DISTRAINER, one who distrains; the party distraining goods or chattels, also DISTRAINOR [n]\n",
  "DISTRAINING": "DISTRAIN, to seize and hold property as security [v]\n",
  "DISTRAINMENT": "the act of distraining [n -S]\n",
  "DISTRAINMENTS": "DISTRAINMENT, the act of distraining [n]\n",
  "DISTRAINOR": "one who distrains; the party distraining goods or chattels, also DISTRAINER [n -S]\n",
  "DISTRAINORS": "DISTRAINOR, one who distrains; the party distraining goods or chattels, also DISTRAINER [n]\n",
  "DISTRAINS": "DISTRAIN, to seize and hold property as security [v]\n",
  "DISTRAINT": "seizure of goods [n -S]\n",
  "DISTRAINTS": "DISTRAINT, seizure of goods [n]\n",
  "DISTRAIT": "(French) distracted in mind; excessively perplexed or troubled, also DISTRAITE [adj]\n",
  "DISTRAITE": "(French) distracted in mind; excessively perplexed or troubled, also DISTRAIT [adj]\n",
  "DISTRAUGHT": "agitated with doubt or mental conflict or pain [adj DISTRAUGHTLY]\n",
  "DISTRAUGHTLY": "DISTRAUGHT, agitated with doubt or mental conflict or pain [adv]\n",
  "DISTRESS": "to cause anxiety or suffering to [v -ED, -ING, -ES]\n",
  "DISTRESSED": "DISTRESS, to cause anxiety or suffering to [v]\n",
  "DISTRESSER": "one who distresses [n -S]\n",
  "DISTRESSERS": "DISTRESSER, one who distresses [n]\n",
  "DISTRESSES": "DISTRESS, to cause anxiety or suffering to [v]\n",
  "DISTRESSFUL": "causing distress [adj DISTRESSFULLY]\n",
  "DISTRESSFULLY": "DISTRESSFUL, causing distress [adv]\n",
  "DISTRESSFULNESS": "DISTRESSFUL, causing distress [n]\n",
  "DISTRESSING": "causing anxiety or suffering to [adj DISTRESSINGLY] / the act of distressing [n -S]\n",
  "DISTRESSINGLY": "DISTRESSING, causing anxiety or suffering to [adv]\n",
  "DISTRESSINGS": "DISTRESSING, the act of distressing [n]\n",
  "DISTRIBUEND": "that which is to be distributed [n -S]\n",
  "DISTRIBUENDS": "DISTRIBUEND, that which is to be distributed [n]\n",
  "DISTRIBUTABLE": "capable of being distributed [adj]\n",
  "DISTRIBUTARIES": "DISTRIBUTARY, a branch of a river that flows away from the main stream and does not rejoin it, as in a delta [n]\n",
  "DISTRIBUTARY": "a branch of a river that flows away from the main stream and does not rejoin it, as in a delta [n DISTRIBUTARIES]\n",
  "DISTRIBUTE": "to divide among several or many [v DISTRIBUTED, DISTRIBUTING, DISTRIBUTES]\n",
  "DISTRIBUTED": "DISTRIBUTE, to divide among several or many [v]\n",
  "DISTRIBUTEE": "one who receives a distribution [n -S]\n",
  "DISTRIBUTEES": "DISTRIBUTEE, one who receives a distribution [n]\n",
  "DISTRIBUTER": "one who distributes, also DISTRIBUTOR [n -S]\n",
  "DISTRIBUTERS": "DISTRIBUTER, one who distributes, also DISTRIBUTOR [n]\n",
  "DISTRIBUTES": "DISTRIBUTE, to divide among several or many [v]\n",
  "DISTRIBUTING": "DISTRIBUTE, to divide among several or many [v]\n",
  "DISTRIBUTION": "the act of distributing [n -S]\n",
  "DISTRIBUTIONAL": "relating to distribution [adj]\n",
  "DISTRIBUTIONS": "DISTRIBUTION, the act of distributing [n]\n",
  "DISTRIBUTIVE": "relating to distribution [adj DISTRIBUTIVELY] / a distributive word, like each or every, that indicates the several individuals of a number taken separately [n -S]\n",
  "DISTRIBUTIVELY": "DISTRIBUTIVE, relating to distribution [adv]\n",
  "DISTRIBUTIVES": "DISTRIBUTIVE, a distributive word, like each or every, that indicates the several individuals of a number taken separately [n]\n",
  "DISTRIBUTIVITY": "the state of being distributive [n]\n",
  "DISTRIBUTOR": "one who distributes, also DISTRIBUTER [n -S]\n",
  "DISTRIBUTORS": "DISTRIBUTOR, one who distributes, also DISTRIBUTER [n]\n",
  "DISTRIBUTORSHIP": "a company that distributes something, esp. one that has exclusive license to do this [n]\n",
  "DISTRICT": "an area or region [n -S] / to divide into districts [v -ED, -ING, -S]\n",
  "DISTRICTED": "DISTRICT, to divide into districts [v]\n",
  "DISTRICTING": "DISTRICT, to divide into districts [v]\n",
  "DISTRICTS": "DISTRICT, to divide into districts [v]\n",
  "DISTRINGAS": "formerly, a writ directing a sheriff or other officer to distrain [n -ES]\n",
  "DISTRINGASES": "DISTRINGAS, formerly, a writ directing a sheriff or other officer to distrain [n]\n",
  "DISTRIX": "the splitting of hair ends [n -ES]\n",
  "DISTRIXES": "DISTRIX, the splitting of hair ends [n]\n",
  "DISTROUBLE": "(obsolete) to trouble [v DISTROUBLED, DISTROUBLING, DISTROUBLES]\n",
  "DISTROUBLED": "DISTROUBLE, (obsolete) to trouble [v]\n",
  "DISTROUBLES": "DISTROUBLE, (obsolete) to trouble [v]\n",
  "DISTROUBLING": "DISTROUBLE, (obsolete) to trouble [v]\n",
  "DISTRUST": "to have no trust in, also MISTRUST [v -ED, -ING, -S]\n",
  "DISTRUSTED": "DISTRUST, to have no trust in, also MISTRUST [v]\n",
  "DISTRUSTER": "one who distrusts [n -S]\n",
  "DISTRUSTERS": "DISTRUSTER, one who distrusts [n]\n",
  "DISTRUSTFUL": "having or showing distrust [adj DISTRUSTFULLY]\n",
  "DISTRUSTFULLY": "DISTRUSTFUL, having or showing distrust [adv]\n",
  "DISTRUSTFULNESS": "DISTRUSTFUL, having or showing distrust [n]\n",
  "DISTRUSTING": "DISTRUST, to have no trust in, also MISTRUST [v]\n",
  "DISTRUSTLESS": "without distrust [adj]\n",
  "DISTRUSTS": "DISTRUST, to have no trust in, also MISTRUST [v]\n",
  "DISTUNE": "to put out of tune [v DISTUNED, DISTUNING, DISTUNES]\n",
  "DISTUNED": "DISTUNE, to put out of tune [v]\n",
  "DISTUNES": "DISTUNE, to put out of tune [v]\n",
  "DISTUNING": "DISTUNE, to put out of tune [v]\n",
  "DISTURB": "to interrupt the quiet, rest, or peace of [v -ED, -ING, -S]\n",
  "DISTURBANCE": "the act of disturbing [n -S]\n",
  "DISTURBANCES": "DISTURBANCE, the act of disturbing [n]\n",
  "DISTURBANT": "disturbing [adj] / that which disturbs [n -S]\n",
  "DISTURBANTS": "DISTURBANT, that which disturbs [n]\n",
  "DISTURBATIVE": "serving to disturb [adj]\n",
  "DISTURBED": "DISTURB, to interrupt the quiet, rest, or peace of [v]\n",
  "DISTURBER": "something that disturbs [n -S]\n",
  "DISTURBERS": "DISTURBER, something that disturbs [n]\n",
  "DISTURBING": "DISTURB, to interrupt the quiet, rest, or peace of [v]\n",
  "DISTURBINGLY": "DISTURBING, DISTURB, to interrupt the quiet, rest, or peace of [adv]\n",
  "DISTURBS": "DISTURB, to interrupt the quiet, rest, or peace of [v]\n",
  "DISTYLE": "a portico with two columns [n -S]\n",
  "DISTYLES": "DISTYLE, a portico with two columns [n]\n",
  "DISUBSTITUTED": "having two substituent atoms or groups in a molecule [adj]\n",
  "DISULFATE": "a compound containing two sulfate ions [n -S]\n",
  "DISULFATES": "DISULFATE, a compound containing two sulfate ions [n]\n",
  "DISULFID": "a sulphide containing two atoms of sulphur to the molecule, also DISULFIDE, DISULPHIDE, DISULPHURET [n -S]\n",
  "DISULFIDE": "a sulphide containing two atoms of sulphur to the molecule, also DISULFID, DISULPHIDE, DISULPHURET [n -S]\n",
  "DISULFIDES": "DISULFIDE, a sulphide containing two atoms of sulphur to the molecule, also DISULFID, DISULPHIDE, DISULPHURET [n]\n",
  "DISULFIDS": "DISULFID, a sulphide containing two atoms of sulphur to the molecule, also DISULFIDE, DISULPHIDE, DISULPHURET [n]\n",
  "DISULFIRAM": "a compound used in the treatment of alcoholism [n -S]\n",
  "DISULFIRAMS": "DISULFIRAM, a compound used in the treatment of alcoholism [n]\n",
  "DISULFOTON": "an organophosphorus systemic insecticide [n -S]\n",
  "DISULFOTONS": "DISULFOTON, an organophosphorus systemic insecticide [n]\n",
  "DISULPHATE": "a pyrosulphate [n -S]\n",
  "DISULPHATES": "DISULPHATE, a pyrosulphate [n]\n",
  "DISULPHIDE": "a sulphide containing two atoms of sulphur to the molecule, also DISULFID, DISULFIDE, DISULPHURET [n -S]\n",
  "DISULPHIDES": "DISULPHIDE, a sulphide containing two atoms of sulphur to the molecule, also DISULFID, DISULFIDE, DISULPHURET [n]\n",
  "DISULPHURET": "(obsolete) a sulphide containing two atoms of sulphur to the molecule, also DISULFID, DISULFIDE, DISULPHIDE [n -S]\n",
  "DISULPHURETS": "DISULPHURET, (obsolete) a sulphide containing two atoms of sulphur to the molecule, also DISULFID, DISULFIDE, DISULPHIDE [n]\n",
  "DISULPHURIC": "pyrosulphuric [adj]\n",
  "DISUNION": "the state of being disunited [n -S]\n",
  "DISUNIONIST": "someone who favours dissolution of a union [n -S]\n",
  "DISUNIONISTS": "DISUNIONIST, someone who favours dissolution of a union [n]\n",
  "DISUNIONS": "DISUNION, the state of being disunited [n]\n",
  "DISUNITE": "to separate [v DISUNITED, DISUNITING, DISUNITES]\n",
  "DISUNITED": "DISUNITE, to separate [v]\n",
  "DISUNITER": "one who disunites [n -S]\n",
  "DISUNITERS": "DISUNITER, one who disunites [n]\n",
  "DISUNITES": "DISUNITE, to separate [v]\n",
  "DISUNITIES": "DISUNITY, lack of unity [n]\n",
  "DISUNITING": "DISUNITE, to separate [v]\n",
  "DISUNITY": "lack of unity [n DISUNITIES]\n",
  "DISUSAGE": "gradual cessation of use [n -S]\n",
  "DISUSAGES": "DISUSAGE, gradual cessation of use [n]\n",
  "DISUSE": "to stop using [v DISUSED, DISUSING, DISUSES]\n",
  "DISUSED": "DISUSE, to stop using [v]\n",
  "DISUSES": "DISUSE, to stop using [v]\n",
  "DISUSING": "DISUSE, to stop using [v]\n",
  "DISUTILITIES": "DISUTILITY, the state of being counterproductive [n]\n",
  "DISUTILITY": "the state of being counterproductive [n DISUTILITIES]\n",
  "DISVALUE": "to disparage [v DISVALUED, DISVALUING, DISVALUES]\n",
  "DISVALUED": "DISVALUE, to disparage [v]\n",
  "DISVALUES": "DISVALUE, to disparage [v]\n",
  "DISVALUING": "DISVALUE, to disparage [v]\n",
  "DISVOUCH": "(Shakespeare) to disavow [v -ED, -ING, -ES]\n",
  "DISVOUCHED": "DISVOUCH, (Shakespeare) to disavow [v]\n",
  "DISVOUCHES": "DISVOUCH, (Shakespeare) to disavow [v]\n",
  "DISVOUCHING": "DISVOUCH, (Shakespeare) to disavow [v]\n",
  "DISWORSHIP": "(Milton) to refuse to worship [v DISWORSHIPED or DISWORSHIPPED, DISWORSHIPING or DISWORSHIPPING, DISWORSHIPS]\n",
  "DISWORSHIPED": "DISWORSHIP, (Milton) to refuse to worship [v]\n",
  "DISWORSHIPING": "DISWORSHIP, (Milton) to refuse to worship [v]\n",
  "DISWORSHIPPED": "DISWORSHIP, (Milton) to refuse to worship [v]\n",
  "DISWORSHIPPING": "DISWORSHIP, (Milton) to refuse to worship [v]\n",
  "DISWORSHIPS": "DISWORSHIP, (Milton) to refuse to worship [v]\n",
  "DISYLLABIC": "having two syllables, also DISSYLLABIC [adj]\n",
  "DISYLLABIFIED": "DISYLLABIFY, to make into two syllables [v]\n",
  "DISYLLABIFIES": "DISYLLABIFY, to make into two syllables [v]\n",
  "DISYLLABIFY": "to make into two syllables [v DISYLLABIFIED, DISYLLABIFYING, DISYLLABIFIES]\n",
  "DISYLLABIFYING": "DISYLLABIFY, to make into two syllables [v]\n",
  "DISYLLABISM": "the character of having two syllables [n -S]\n",
  "DISYLLABISMS": "DISYLLABISM, the character of having two syllables [n]\n",
  "DISYLLABLE": "a word with two syllables [n -S]\n",
  "DISYLLABLES": "DISYLLABLE, a word with two syllables [n]\n",
  "DISYOKE": "to free from a yoke [v DISYOKED, DISYOKING, DISYOKES]\n",
  "DISYOKED": "DISYOKE, to free from a yoke [v]\n",
  "DISYOKES": "DISYOKE, to free from a yoke [v]\n",
  "DISYOKING": "DISYOKE, to free from a yoke [v]\n",
  "DIT": "(Scots) to block [v DITTED, DITTIT, DITTING, DITS]\n",
  "DITA": "(Tagalog) a tree of India and the Philippines [n -S]\n",
  "DITAL": "a device which raises a guitar string's pitch [n -S]\n",
  "DITALS": "DITAL, a device which raises a guitar string's pitch [n]\n",
  "DITAS": "DITA, (Tagalog) a tree of India and the Philippines [n]\n",
  "DITCH": "to dig a long, narrow excavation in the ground [v -ED, -ING, -ES]\n",
  "DITCHDIGGER": "one that digs ditches [n -S]\n",
  "DITCHDIGGERS": "DITCHDIGGER, one that digs ditches [n]\n",
  "DITCHED": "DITCH, to dig a long, narrow excavation in the ground [v]\n",
  "DITCHER": "one who digs ditches [n -S]\n",
  "DITCHERS": "DITCHER, one who digs ditches [n]\n",
  "DITCHES": "DITCH, to dig a long, narrow excavation in the ground [v]\n",
  "DITCHING": "DITCH, to dig a long, narrow excavation in the ground [v]\n",
  "DITCHLESS": "without a ditch [adj]\n",
  "DITCHWATER": "water found in a ditch [n -S]\n",
  "DITCHWATERS": "DITCHWATER, water found in a ditch [n]\n",
  "DITE": "(obsolete) to compose, indite [v DITED, DITING, DITES]\n",
  "DITED": "DITE, (obsolete) to compose, indite [v]\n",
  "DITES": "DITE, (obsolete) to compose, indite [v]\n",
  "DITHECAL": "having two spore-cases, also DITHECOUS [adj]\n",
  "DITHECOUS": "having two spore-cases, also DITHECAL [adj]\n",
  "DITHEISM": "belief in two equal gods, one good and one evil [n -S]\n",
  "DITHEISMS": "DITHEISM, belief in two equal gods, one good and one evil [n]\n",
  "DITHEIST": "one who holds the doctrine of ditheism [n -S]\n",
  "DITHEISTIC": "relating to ditheism, belief in two equal gods, one good and one evil, also DITHEISTICAL [adj]\n",
  "DITHEISTICAL": "relating to ditheism, belief in two equal gods, one good and one evil, also DITHEISTIC [adj]\n",
  "DITHEISTS": "DITHEIST, one who holds the doctrine of ditheism [n]\n",
  "DITHELETE": "a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DIOTHELETE, DYOTHELETE, DYOTHELITE [n -S]\n",
  "DITHELETES": "DITHELETE, a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DIOTHELETE, DYOTHELETE, DYOTHELITE [n]\n",
  "DITHELETIC": "relating to ditheletism, the doctrine that Christ had two wills, also DIOTHELETIC, DITHELETICAL [adj]\n",
  "DITHELETICAL": "relating to ditheletism, the doctrine that Christ had two wills, also DIOTHELETIC, DITHELETIC [adj]\n",
  "DITHELETISM": "the doctrine that Christ on earth had two wills, also DITHELISM, DIOTHELISM, DYOTHELISM [n -S]\n",
  "DITHELETISMS": "DITHELETISM, the doctrine that Christ on earth had two wills, also DITHELISM, DIOTHELISM, DYOTHELISM [n]\n",
  "DITHELISM": "the doctrine that Christ on earth had two wills, human and divine, also DITHELITISM, DIOTHELISM, DYOTHELISM [n -S]\n",
  "DITHELISMS": "DITHELISM, the doctrine that Christ on earth had two wills, human and divine, also DITHELITISM, DIOTHELISM, DYOTHELISM [n]\n",
  "DITHELITISM": "the doctrine that Christ on earth had two wills, human and divine, also DITHELISM, DIOTHELISM, DYOTHELISM [n -S]\n",
  "DITHELITISMS": "DITHELITISM, the doctrine that Christ on earth had two wills, human and divine, also DITHELISM, DIOTHELISM, DYOTHELISM [n]\n",
  "DITHER": "to act indecisively [v -ED, -ING, -S]\n",
  "DITHERED": "DITHER, to act indecisively [v]\n",
  "DITHERER": "one who dithers [n -S]\n",
  "DITHERERS": "DITHERER, one who dithers [n]\n",
  "DITHERIER": "DITHERY, nervously excited [adj]\n",
  "DITHERIEST": "DITHERY, nervously excited [adj]\n",
  "DITHERING": "acting nervously or indecisively [n -S]\n",
  "DITHERINGS": "DITHERING, acting nervously or indecisively [n]\n",
  "DITHERS": "DITHER, to act indecisively [v]\n",
  "DITHERY": "nervously excited [adj DITHERIER, DITHERIEST]\n",
  "DITHIOCARBAMATE": "any of several sulfur analogs of the carbamates including some used as fungicides [n]\n",
  "DITHIOCARBAMIC": "as in dithiocarbamic acid [adj]\n",
  "DITHIOL": "a chemical compound consisting of two thiols [n -S]\n",
  "DITHIOLS": "DITHIOL, a chemical compound consisting of two thiols [n]\n",
  "DITHIONATE": "a salt of dithionic acid [n -S]\n",
  "DITHIONATES": "DITHIONATE, a salt of dithionic acid [n]\n",
  "DITHIONIC": "as in dithionic acid [adj]\n",
  "DITHIONITE": "any salt of dithionous acid [n -S]\n",
  "DITHIONITES": "DITHIONITE, any salt of dithionous acid [n]\n",
  "DITHIONOUS": "as in dithionous acid [adj]\n",
  "DITHYRAMB": "a hymn or poem to honor Bacchus [n -S]\n",
  "DITHYRAMBIC": "like a dithyramb, wildly enthusiastic in statement or writing [adj DITHYRAMBICALLY]\n",
  "DITHYRAMBICALLY": "DITHYRAMBIC, like a dithyramb, wildly enthusiastic in statement or writing [adv]\n",
  "DITHYRAMBIST": "one who sings dithyrambic hymns [n -S]\n",
  "DITHYRAMBISTS": "DITHYRAMBIST, one who sings dithyrambic hymns [n]\n",
  "DITHYRAMBS": "DITHYRAMB, a hymn or poem to honor Bacchus [n]\n",
  "DITING": "DITE, (obsolete) to compose, indite [v]\n",
  "DITOKOUS": "producing two at a birth or in a clutch [adj]\n",
  "DITONE": "in ancient Greek music, an interval of two major tones [n -S]\n",
  "DITONES": "DITONE, in ancient Greek music, an interval of two major tones [n]\n",
  "DITRANSITIVE": "a verb able to take both a direct and an indirect object [n -S]\n",
  "DITRANSITIVES": "DITRANSITIVE, a verb able to take both a direct and an indirect object [n]\n",
  "DITRIGLYPH": "a space for two triglyphs in the entablature between columns [n -S]\n",
  "DITRIGLYPHIC": "of or like a ditriglyph, a space for two triglyphs in the entablature between columns [adj]\n",
  "DITRIGLYPHS": "DITRIGLYPH, a space for two triglyphs in the entablature between columns [n]\n",
  "DITROCHEAN": "containing two trochees [adj]\n",
  "DITROCHEE": "a double trochee; a foot made up of two trochees [n -S]\n",
  "DITROCHEES": "DITROCHEE, a double trochee; a foot made up of two trochees [n]\n",
  "DITS": "DIT, (Scots) to block [v]\n",
  "DITSIER": "DITSY, eccentric, also DITZY [adj]\n",
  "DITSIEST": "DITSY, eccentric, also DITZY [adj]\n",
  "DITSINESS": "the state of being ditsy, also DITZINESS [n -ES]\n",
  "DITSINESSES": "DITSINESS, the state of being ditsy, also DITZINESS [n]\n",
  "DITSY": "eccentric, also DITZY [adj DITSIER, DITSIEST]\n",
  "DITT": "(archaic) a poem, the words of a song [n -S]\n",
  "DITTANDER": "a pungent cruciferous plant, aka pepperwort [n -S]\n",
  "DITTANDERS": "DITTANDER, a pungent cruciferous plant, aka pepperwort [n]\n",
  "DITTANIES": "DITTANY, a plant of the mint family, a native of Crete [n]\n",
  "DITTANY": "a plant of the mint family, a native of Crete [n DITTANIES]\n",
  "DITTAY": "(Scots) a legal charge in Scots law [n -S]\n",
  "DITTAYS": "DITTAY, (Scots) a legal charge in Scots law [n]\n",
  "DITTED": "DIT, (Scots) to block [v]\n",
  "DITTIED": "DITTY, to put to music [v]\n",
  "DITTIES": "DITTY, to put to music [v]\n",
  "DITTING": "DIT, (Scots) to block [v]\n",
  "DITTIT": "DIT, (Scots) to block [v]\n",
  "DITTO": "to repeat that which has been said before [v -ED, -ING, -S]\n",
  "DITTOED": "DITTO, to repeat that which has been said before [v]\n",
  "DITTOGRAPHIC": "relating to dittography, the unintentional repetition of letters in print [adj]\n",
  "DITTOGRAPHIES": "DITTOGRAPHY, the unintentional repetition of letters in print [n]\n",
  "DITTOGRAPHY": "the unintentional repetition of letters in print [n DITTOGRAPHIES]\n",
  "DITTOING": "DITTO, to repeat that which has been said before [v]\n",
  "DITTOLOGIES": "DITTOLOGY, a twofold reading or interpretation [n]\n",
  "DITTOLOGY": "a twofold reading or interpretation [n DITTOLOGIES]\n",
  "DITTOS": "DITTO, to repeat that which has been said before [v]\n",
  "DITTS": "DITT, (archaic) a poem, the words of a song [n]\n",
  "DITTY": "to put to music [v DITTIED, DITTYING, DITTIES]\n",
  "DITTYING": "DITTY, to put to music [v]\n",
  "DITZ": "a silly person [n -ES]\n",
  "DITZES": "DITZ, a silly person [n]\n",
  "DITZIER": "DITZY, eccentric, also DITSY [adj]\n",
  "DITZIEST": "DITZY, eccentric, also DITSY [adj]\n",
  "DITZINESS": "the state of being ditzy, also DITSINESS [n -ES]\n",
  "DITZINESSES": "DITZINESS, the state of being ditzy, also DITSINESS [n]\n",
  "DITZY": "eccentric, also DITSY [adj DITZIER, DITZIEST]\n",
  "DIURESES": "DIURESIS, excessive discharge of urine [n]\n",
  "DIURESIS": "excessive discharge of urine [n DIURESES]\n",
  "DIURETIC": "increasing the flow of urine [adj DIURETICALLY] / a medicine that increases the flow of urine [n -S]\n",
  "DIURETICALLY": "DIURETIC, increasing the flow of urine [adv]\n",
  "DIURETICALNESS": "the state of being diuretic [n]\n",
  "DIURETICS": "DIURETIC, a medicine that increases the flow of urine [n]\n",
  "DIURNAL": "recurring every day; having a daily cycle [adj DIURNALLY] / a service book containing the day hours [n -S]\n",
  "DIURNALIST": "(archaic) a journalist [n -S]\n",
  "DIURNALISTS": "DIURNALIST, (archaic) a journalist [n]\n",
  "DIURNALLY": "DIURNAL, recurring every day; having a daily cycle [adv]\n",
  "DIURNALS": "DIURNAL, a service book containing the day hours [n]\n",
  "DIURON": "a herbicide [n -S]\n",
  "DIURONS": "DIURON, a herbicide [n]\n",
  "DIUTURNAL": "of long continuance; lasting [adj]\n",
  "DIUTURNITIES": "DIUTURNITY, long duration; lastingness [n]\n",
  "DIUTURNITY": "long duration; lastingness [n DIUTURNITIES]\n",
  "DIV": "in Persian legend, an evil spirit, also DEEV [n -S]\n",
  "DIVA": "(Italian) a distinguished female operatic singer [n -S]\n",
  "DIVAGATE": "to wander or stray from a course or subject [v DIVAGATED, DIVAGATING, DIVAGATES]\n",
  "DIVAGATED": "DIVAGATE, to wander or stray from a course or subject [v]\n",
  "DIVAGATES": "DIVAGATE, to wander or stray from a course or subject [v]\n",
  "DIVAGATING": "DIVAGATE, to wander or stray from a course or subject [v]\n",
  "DIVAGATION": "a wandering about or going astray; digression [n -S]\n",
  "DIVAGATIONS": "DIVAGATION, a wandering about or going astray; digression [n]\n",
  "DIVALENCE": "the state of being divalent, also DIVALENCY [n -S]\n",
  "DIVALENCES": "DIVALENCE, the state of being divalent, also DIVALENCY [n]\n",
  "DIVALENCIES": "DIVALENCY, the state of being divalent, also DIVALENCE [n]\n",
  "DIVALENCY": "the state of being divalent, also DIVALENCE [n DIVALENCIES]\n",
  "DIVALENT": "a pair of chromosomes, also BIVALENT [n -S]\n",
  "DIVALENTS": "DIVALENT, a pair of chromosomes, also BIVALENT [n]\n",
  "DIVAN": "a couch or bed without a head- or footboard [n -S]\n",
  "DIVANS": "DIVAN, a couch or bed without a head- or footboard [n]\n",
  "DIVARICATE": "forking [adj DIVARICATELY] / to fork, diverge [v DIVARICATED, DIVARICATING, DIVARICATES]\n",
  "DIVARICATED": "DIVARICATE, to fork, diverge [v]\n",
  "DIVARICATELY": "DIVARICATE, forking [adv]\n",
  "DIVARICATES": "DIVARICATE, to fork, diverge [v]\n",
  "DIVARICATING": "DIVARICATE, to fork, diverge [v]\n",
  "DIVARICATINGLY": "DIVARICATING, DIVARICATE, to fork, diverge [adv]\n",
  "DIVARICATION": "the act of divaricating [n -S]\n",
  "DIVARICATIONS": "DIVARICATION, the act of divaricating [n]\n",
  "DIVARICATOR": "one who divaricates [n -S]\n",
  "DIVARICATORS": "DIVARICATOR, one who divaricates [n]\n",
  "DIVAS": "DIVA, (Italian) a distinguished female operatic singer [n]\n",
  "DIVE": "to plunge headfirst into water [v DIVED, DIVING, DIVES]\n",
  "DIVEBOMB": "to drop bombs on a target from a diving airplane [v -ED, -ING, -S]\n",
  "DIVEBOMBED": "DIVEBOMB, to drop bombs on a target from a diving airplane [v]\n",
  "DIVEBOMBING": "DIVEBOMB, to drop bombs on a target from a diving airplane [v]\n",
  "DIVEBOMBS": "DIVEBOMB, to drop bombs on a target from a diving airplane [v]\n",
  "DIVED": "DIVE, to plunge headfirst into water [v]\n",
  "DIVELLENT": "drawing apart; pulling apart in pieces [adj]\n",
  "DIVELLICATE": "to pull in pieces; to pluck apart [v DIVELLICATED, DIVELLICATING, DIVELLICATES]\n",
  "DIVELLICATED": "DIVELLICATE, to pull in pieces; to pluck apart [v]\n",
  "DIVELLICATES": "DIVELLICATE, to pull in pieces; to pluck apart [v]\n",
  "DIVELLICATING": "DIVELLICATE, to pull in pieces; to pluck apart [v]\n",
  "DIVER": "one who dives; a diving bird [n -S]\n",
  "DIVERGE": "to move in different directions from a point [v DIVERGED, DIVERGING, DIVERGES]\n",
  "DIVERGED": "DIVERGE, to move in different directions from a point [v]\n",
  "DIVERGEMENT": "the act of diverging [n -S]\n",
  "DIVERGEMENTS": "DIVERGEMENT, the act of diverging [n]\n",
  "DIVERGENCE": "a drawing apart (as of lines extending from a common center) [n -S]\n",
  "DIVERGENCES": "DIVERGENCE, a drawing apart (as of lines extending from a common center) [n]\n",
  "DIVERGENCIES": "DIVERGENCY, a drawing apart, as of lines extending from a common center [n]\n",
  "DIVERGENCY": "a drawing apart, as of lines extending from a common center [n DIVERGENCIES]\n",
  "DIVERGENT": "diverging [adj DIVERGENTLY]\n",
  "DIVERGENTLY": "DIVERGENT, diverging [adv]\n",
  "DIVERGES": "DIVERGE, to move in different directions from a point [v]\n",
  "DIVERGING": "DIVERGE, to move in different directions from a point [v]\n",
  "DIVERGINGLY": "DIVERGING, DIVERGE, to move in different directions from a point [adv]\n",
  "DIVERS": "sundry, several [adj DIVERSLY]\n",
  "DIVERSE": "varied [adj DIVERSELY] / to turn aside [v DIVERSED, DIVERSING, DIVERSES]\n",
  "DIVERSED": "DIVERSE, to turn aside [v]\n",
  "DIVERSELY": "DIVERSE, varied [adv]\n",
  "DIVERSENESS": "the state of being diverse [n -ES]\n",
  "DIVERSENESSES": "DIVERSENESS, the state of being diverse [n]\n",
  "DIVERSES": "DIVERSE, to turn aside [v]\n",
  "DIVERSIFIABLE": "capable of being diversified [adj]\n",
  "DIVERSIFICATION": "the act of diversifying [n]\n",
  "DIVERSIFIED": "DIVERSIFY, to give variety to [v]\n",
  "DIVERSIFIER": "one who diversifies [n -S]\n",
  "DIVERSIFIERS": "DIVERSIFIER, one who diversifies [n]\n",
  "DIVERSIFIES": "DIVERSIFY, to give variety to [v]\n",
  "DIVERSIFORM": "of diverse form [adj]\n",
  "DIVERSIFY": "to give variety to [v DIVERSIFIED, DIVERSIFYING, DIVERSIFIES]\n",
  "DIVERSIFYING": "DIVERSIFY, to give variety to [v]\n",
  "DIVERSING": "DIVERSE, to turn aside [v]\n",
  "DIVERSION": "the act of diverting or turning aside [n -S]\n",
  "DIVERSIONAL": "relating to a diversion [adj]\n",
  "DIVERSIONARY": "tending to draw attention away from the principal concern [adj]\n",
  "DIVERSIONIST": "one engaged in diversionary activities [n -S]\n",
  "DIVERSIONISTS": "DIVERSIONIST, one engaged in diversionary activities [n]\n",
  "DIVERSIONS": "DIVERSION, the act of diverting or turning aside [n]\n",
  "DIVERSITIES": "DIVERSITY, variety [n]\n",
  "DIVERSITY": "variety [n DIVERSITIES]\n",
  "DIVERSLY": "DIVERS, sundry, several [adv]\n",
  "DIVERT": "to turn aside [v -ED, -ING, -S]\n",
  "DIVERTED": "DIVERT, to turn aside [v]\n",
  "DIVERTER": "one who diverts [n -S]\n",
  "DIVERTERS": "DIVERTER, one who diverts [n]\n",
  "DIVERTIBILITIES": "DIVERTIBILITY, the state of being divertible [n]\n",
  "DIVERTIBILITY": "the state of being divertible [n DIVERTIBILITIES]\n",
  "DIVERTIBLE": "capable of being diverted [adj]\n",
  "DIVERTICULA": "DIVERTICULUM, a blind passage or tunnel [n]\n",
  "DIVERTICULAR": "relating to a diverticulum [adj]\n",
  "DIVERTICULATE": "having diverticula, intestinal pouches, also DIVERTICULATED [adj]\n",
  "DIVERTICULATED": "having diverticula, intestinal pouches, also DIVERTICULATE [adj]\n",
  "DIVERTICULITIS": "an intestinal disorder [n]\n",
  "DIVERTICULOSES": "DIVERTICULOSIS, an intestinal disorder characterized by the presence of many diverticula [n]\n",
  "DIVERTICULOSIS": "an intestinal disorder characterized by the presence of many diverticula [n DIVERTICULOSES]\n",
  "DIVERTICULUM": "a blind passage or tunnel [n DIVERTICULA]\n",
  "DIVERTIMENTI": "DIVERTIMENTO, (Italian) a genre of 18th century chamber music having several short movements [n]\n",
  "DIVERTIMENTO": "(Italian) a genre of 18th century chamber music having several short movements [n DIVERTIMENTI or DIVERTIMENTOS]\n",
  "DIVERTIMENTOS": "DIVERTIMENTO, (Italian) a genre of 18th century chamber music having several short movements [n]\n",
  "DIVERTING": "DIVERT, to turn aside [v]\n",
  "DIVERTINGLY": "DIVERTING [adv]\n",
  "DIVERTISEMENT": "a diversion; a divertimento [n -S]\n",
  "DIVERTISEMENTS": "DIVERTISEMENT, a diversion; a divertimento [n]\n",
  "DIVERTISSEMENT": "(French) a diversion or entertainment; a short ballet used as an interlude [n -S]\n",
  "DIVERTISSEMENTS": "DIVERTISSEMENT, (French) a diversion or entertainment; a short ballet used as an interlude [n]\n",
  "DIVERTIVE": "tending to divert [adj]\n",
  "DIVERTS": "DIVERT, to turn aside [v]\n",
  "DIVES": "DIVE, to plunge headfirst into water [v]\n",
  "DIVEST": "to strip or deprive of anything [v -ED, -ING, -S]\n",
  "DIVESTED": "DIVEST, to strip or deprive of anything [v]\n",
  "DIVESTIBLE": "capable of being divested [adj]\n",
  "DIVESTING": "DIVEST, to strip or deprive of anything [v]\n",
  "DIVESTITURE": "the act of divesting, also DIVESTURE [n -S]\n",
  "DIVESTITURES": "DIVESTITURE, the act of divesting, also DIVESTURE [n]\n",
  "DIVESTMENT": "the act of divesting [n -S]\n",
  "DIVESTMENTS": "DIVESTMENT, the act of divesting [n]\n",
  "DIVESTS": "DIVEST, to strip or deprive of anything [v]\n",
  "DIVESTURE": "the act of divesting, also DIVESTITURE [n -S]\n",
  "DIVESTURES": "DIVESTURE, the act of divesting, also DIVESTITURE [n]\n",
  "DIVI": "to divide up, also DIVVY [v DIVIED, DIVYING, DIVIS]\n",
  "DIVIDABLE": "that can be divided, also DIVISIBLE [adj]\n",
  "DIVIDANT": "(Shakespeare) divisible, divided [adj]\n",
  "DIVIDE": "to separate into different parts [v DIVIDED, DIVIDING, DIVIDES]\n",
  "DIVIDED": "DIVIDE, to separate into different parts [v]\n",
  "DIVIDEDLY": "DIVIDED, DIVIDE, to separate into different parts [adv]\n",
  "DIVIDEDNESS": "the state of being divided [n -ES]\n",
  "DIVIDEDNESSES": "DIVIDEDNESS, the state of being divided [n]\n",
  "DIVIDEND": "a portion or share of anything divided, esp. the share that falls to each party [n -S]\n",
  "DIVIDENDLESS": "without a dividend [adj]\n",
  "DIVIDENDS": "DIVIDEND, a portion or share of anything divided, esp. the share that falls to each party [n]\n",
  "DIVIDER": "one who divides [n -S]\n",
  "DIVIDERS": "DIVIDER, one who divides [n]\n",
  "DIVIDES": "DIVIDE, to separate into different parts [v]\n",
  "DIVIDING": "separation [n -S]\n",
  "DIVIDINGS": "DIVIDING, separation [n]\n",
  "DIVIDIVI": "(Caribbean) the curved pods of a small tropical American tree, used for tanning and dyeing [n -S]\n",
  "DIVIDIVIS": "DIVIDIVI, (Caribbean) the curved pods of a small tropical American tree, used for tanning and dyeing [n]\n",
  "DIVIDUAL": "capable of being divided [adj]\n",
  "DIVIDUOUS": "divided; special [adj]\n",
  "DIVIED": "DIVI, to divide up, also DIVVY [v]\n",
  "DIVINABLE": "that can be divined [adj]\n",
  "DIVINATION": "the art or practice of divining [n -S]\n",
  "DIVINATIONS": "DIVINATION, the art or practice of divining [n]\n",
  "DIVINATOR": "(archaic) one who practices or pretends to divination [n -S]\n",
  "DIVINATORIAL": "relating to divination, conjectural [adj]\n",
  "DIVINATORS": "DIVINATOR, (archaic) one who practices or pretends to divination [n]\n",
  "DIVINATORY": "professing, or relating to, divination [adj]\n",
  "DIVINE": "pertaining to or characteristic of a god [adj DIVINER, DIVINEST, DIVINELY] / to foretell by occult means [v DIVINED, DIVINING, DIVINES]\n",
  "DIVINED": "DIVINE, to foretell by occult means [v]\n",
  "DIVINELY": "DIVINE, pertaining to or characteristic of a god [adv]\n",
  "DIVINENESS": "the quality of being divine [n -ES]\n",
  "DIVINENESSES": "DIVINENESS, the quality of being divine [n]\n",
  "DIVINER": "one who divines [n -S]\n",
  "DIVINERESS": "a woman who divines [n -ES]\n",
  "DIVINERESSES": "DIVINERESS, a woman who divines [n]\n",
  "DIVINERS": "DIVINER, one who divines [n]\n",
  "DIVINES": "DIVINE, to foretell by occult means [v]\n",
  "DIVINEST": "DIVINE, pertaining to or characteristic of a god [adj]\n",
  "DIVING": "the sport or profession of diving [n -S]\n",
  "DIVINGS": "DIVING, the sport or profession of diving [n]\n",
  "DIVINIFIED": "DIVINIFY, to treat as divine, also DIVINIZE, DIVINISE [v]\n",
  "DIVINIFIES": "DIVINIFY, to treat as divine, also DIVINIZE, DIVINISE [v]\n",
  "DIVINIFY": "to treat as divine, also DIVINIZE, DIVINISE [v DIVINIFIED, DIVINIFYING, DIVINIFIES]\n",
  "DIVINIFYING": "DIVINIFY, to treat as divine, also DIVINIZE, DIVINISE [v]\n",
  "DIVINING": "DIVINE, to foretell by occult means [v]\n",
  "DIVINISATION": "the process of divinising, also DIVINIZATION [n -S]\n",
  "DIVINISATIONS": "DIVINISATION, the process of divinising, also DIVINIZATION [n]\n",
  "DIVINISE": "to treat as divine, also DIVINIZE, DIVINIFY [v DIVINISED, DIVINISING, DIVINISES]\n",
  "DIVINISED": "DIVINISE, to treat as divine, also DIVINIZE, DIVINIFY [v]\n",
  "DIVINISES": "DIVINISE, to treat as divine, also DIVINIZE, DIVINIFY [v]\n",
  "DIVINISING": "DIVINISE, to treat as divine, also DIVINIZE, DIVINIFY [v]\n",
  "DIVINITIES": "DIVINITY, the quality of being divine; a spirit possessing this quality [n]\n",
  "DIVINITY": "the quality of being divine; a spirit possessing this quality [n DIVINITIES]\n",
  "DIVINIZATION": "the process of divinizing, also DIVINISATION [n -S]\n",
  "DIVINIZATIONS": "DIVINIZATION, the process of divinizing, also DIVINISATION [n]\n",
  "DIVINIZE": "to treat as divine, also DIVINIFY, DIVINISE [v DIVINIZED, DIVINIZING, DIVINIZES]\n",
  "DIVINIZED": "DIVINIZE, to treat as divine, also DIVINIFY, DIVINISE [v]\n",
  "DIVINIZES": "DIVINIZE, to treat as divine, also DIVINIFY, DIVINISE [v]\n",
  "DIVINIZING": "DIVINIZE, to treat as divine, also DIVINIFY, DIVINISE [v]\n",
  "DIVIS": "DIVI, to divide up, also DIVVY [v]\n",
  "DIVISIBILITIES": "DIVISIBILITY, the state of being divisible [n]\n",
  "DIVISIBILITY": "the state of being divisible [n DIVISIBILITIES]\n",
  "DIVISIBLE": "that can be divided, also DIVIDABLE [adj DIVISIBLY]\n",
  "DIVISIBLENESS": "DIVISIBLE, that can be divided, also DIVIDABLE [n]\n",
  "DIVISIBLENESSES": "DIVISIBLENESS, DIVISIBLE, that can be divided, also DIVIDABLE [n]\n",
  "DIVISIBLY": "DIVISIBLE, that can be divided, also DIVIDABLE [adv]\n",
  "DIVISIM": "(Latin) separately [adv]\n",
  "DIVISION": "the act of dividing [n -S]\n",
  "DIVISIONAL": "relating to or making a division [adj DIVISIONALLY]\n",
  "DIVISIONALLY": "DIVISIONAL, relating to or making a division [adv]\n",
  "DIVISIONARY": "marking a division [adj]\n",
  "DIVISIONISM": "pointillism [n -S]\n",
  "DIVISIONISMS": "DIVISIONISM, pointillism [n]\n",
  "DIVISIONIST": "a practitioner of divisionism [n -S]\n",
  "DIVISIONISTS": "DIVISIONIST, a practitioner of divisionism [n]\n",
  "DIVISIONS": "DIVISION, the act of dividing [n]\n",
  "DIVISIVE": "causing disunity or dissension [adj DIVISIVELY]\n",
  "DIVISIVELY": "DIVISIVE, causing disunity or dissension [adv]\n",
  "DIVISIVENESS": "the state of being divisive [n -ES]\n",
  "DIVISIVENESSES": "DIVISIVENESS, the state of being divisive [n]\n",
  "DIVISOR": "the number by which a dividend is divided [n -S]\n",
  "DIVISORS": "DIVISOR, the number by which a dividend is divided [n]\n",
  "DIVNA": "(Scots) do not [v]\n",
  "DIVO": "(Italian) a highly distinguished male singer [n DIVI or DIVOS]\n",
  "DIVORCE": "to terminate the marriage contract [v DIVORCED, DIVORCING, DIVORCES]\n",
  "DIVORCEABLE": "that can be divorced [adj]\n",
  "DIVORCED": "DIVORCE, to terminate the marriage contract [v]\n",
  "DIVORCEE": "a divorced woman [n -S]\n",
  "DIVORCEES": "DIVORCEE, a divorced woman [n]\n",
  "DIVORCEMENT": "the act of divorcing [n -S]\n",
  "DIVORCEMENTS": "DIVORCEMENT, the act of divorcing [n]\n",
  "DIVORCER": "one who divorces [n -S]\n",
  "DIVORCERS": "DIVORCER, one who divorces [n]\n",
  "DIVORCES": "DIVORCE, to terminate the marriage contract [v]\n",
  "DIVORCING": "DIVORCE, to terminate the marriage contract [v]\n",
  "DIVORCIVE": "having power to divorce [adj]\n",
  "DIVOS": "DIVO, (Italian) a highly distinguished male singer [n]\n",
  "DIVOT": "a piece of turf [n -S]\n",
  "DIVOTS": "DIVOT, a piece of turf [n]\n",
  "DIVS": "DIV, in Persian legend, an evil spirit, also DEEV [n]\n",
  "DIVULGATE": "(archaic) to publish [v DIVULGATED, DIVULGATING, DIVULGATES]\n",
  "DIVULGATED": "DIVULGATE, (archaic) to publish [v]\n",
  "DIVULGATER": "one who divulgates, also DIVULGATOR [n -S]\n",
  "DIVULGATERS": "DIVULGATER, one who divulgates, also DIVULGATOR [n]\n",
  "DIVULGATES": "DIVULGATE, (archaic) to publish [v]\n",
  "DIVULGATING": "DIVULGATE, (archaic) to publish [v]\n",
  "DIVULGATION": "the act of divulgating [n -S]\n",
  "DIVULGATIONS": "DIVULGATION, the act of divulgating [n]\n",
  "DIVULGATOR": "one who divulgates, also DIVULGATER [n -S]\n",
  "DIVULGATORS": "DIVULGATOR, one who divulgates, also DIVULGATER [n]\n",
  "DIVULGE": "to reveal [v DIVULGED, DIVULGING, DIVULGES]\n",
  "DIVULGED": "DIVULGE, to reveal [v]\n",
  "DIVULGEMENT": "the act of divulging [n -S]\n",
  "DIVULGEMENTS": "DIVULGEMENT, the act of divulging [n]\n",
  "DIVULGENCE": "the act of divulging [n -S]\n",
  "DIVULGENCES": "DIVULGENCE, the act of divulging [n]\n",
  "DIVULGER": "one who divulges [n -S]\n",
  "DIVULGERS": "DIVULGER, one who divulges [n]\n",
  "DIVULGES": "DIVULGE, to reveal [v]\n",
  "DIVULGING": "DIVULGE, to reveal [v]\n",
  "DIVULSE": "to tear away [v DIVULSED, DIVULSING, DIVULSES]\n",
  "DIVULSED": "DIVULSE, to tear away [v]\n",
  "DIVULSES": "DIVULSE, to tear away [v]\n",
  "DIVULSING": "DIVULSE, to tear away [v]\n",
  "DIVULSION": "the act of pulling or rendering apart or away [n -S]\n",
  "DIVULSIONS": "DIVULSION, the act of pulling or rendering apart or away [n]\n",
  "DIVULSIVE": "tending to pull asunder, tear, or rend [adj]\n",
  "DIVVIED": "DIVVY, to divide up, also DIVI [v]\n",
  "DIVVIER": "DIVVY, stupid [adj]\n",
  "DIVVIES": "DIVVY, to divide up, also DIVI [v]\n",
  "DIVVIEST": "DIVVY, stupid [adj]\n",
  "DIVVY": "to divide up, also DIVI [v DIVVIED, DIVVYING, DIVVIES] / stupid [adj DIVVIER, DIVVIEST]\n",
  "DIVVYING": "DIVVY, to divide up, also DIVI [v]\n",
  "DIVYING": "DIVI, to divide up, also DIVVY [v]\n",
  "DIWAN": "(Urdu) in India, a financial minister, also DEEWAN, DEWAN [n -S]\n",
  "DIWANS": "DIWAN, (Urdu) in India, a financial minister, also DEEWAN, DEWAN [n]\n",
  "DIXI": "(Latin) I have spoken [v]\n",
  "DIXIE": "(Hindi) a military cooking-pot, also DIXY [n -S]\n",
  "DIXIES": "DIXIE, (Hindi) a military cooking-pot, also DIXY [n]\n",
  "DIXIT": "(Latin) an utterance or statement (quoted as) already made [n -S]\n",
  "DIXITS": "DIXIT, (Latin) an utterance or statement (quoted as) already made [n]\n",
  "DIXY": "(Hindi) a military cooking-pot, also DIXIE [n DIXIES]\n",
  "DIYA": "(Hindi) a small oil lamp used in Hindu worship, esp. at Diwali [n -S]\n",
  "DIYAS": "DIYA, (Hindi) a small oil lamp used in Hindu worship, esp. at Diwali [n]\n",
  "DIZAIN": "(French) a ten-line stanza or poem [n -S]\n",
  "DIZAINS": "DIZAIN, (French) a ten-line stanza or poem [n]\n",
  "DIZEN": "to dress in fine clothes [v -ED, -ING, -S]\n",
  "DIZENED": "DIZEN, to dress in fine clothes [v]\n",
  "DIZENING": "DIZEN, to dress in fine clothes [v]\n",
  "DIZENMENT": "the state of being dizened [n -S]\n",
  "DIZENMENTS": "DIZENMENT, the state of being dizened [n]\n",
  "DIZENS": "DIZEN, to dress in fine clothes [v]\n",
  "DIZYGOTIC": "developed from two zygotes or fertilised eggs [adj]\n",
  "DIZYGOUS": "developed from two fertilized ova [adj]\n",
  "DIZZARD": "(obsolete) a blockhead [n -S]\n",
  "DIZZARDS": "DIZZARD, (obsolete) a blockhead [n]\n",
  "DIZZIED": "DIZZY, to make giddy [v]\n",
  "DIZZIER": "DIZZY, giddy [adj]\n",
  "DIZZIES": "DIZZY, to make giddy [v]\n",
  "DIZZIEST": "DIZZY, giddy [adj]\n",
  "DIZZILY": "DIZZY, giddy [adv]\n",
  "DIZZINESS": "the state of being dizzy [n -ES]\n",
  "DIZZINESSES": "DIZZINESS, the state of being dizzy [n]\n",
  "DIZZY": "giddy [adj DIZZIER, DIZZIEST, DIZZILY] / to make giddy [v DIZZIED, DIZZYING, DIZZIES]\n",
  "DIZZYING": "DIZZY, to make giddy [v]\n",
  "DIZZYINGLY": "DIZZYING, DIZZY, to make giddy [adv]\n",
  "DJEBEL": "(Arabic) a hill, a range of mountains, also JEBEL [n -S]\n",
  "DJEBELS": "DJEBEL, (Arabic) a hill, a range of mountains, also JEBEL [n]\n",
  "DJELLABA": "(Arabic) a Middle Eastern hooded cloak, also DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "DJELLABAH": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "DJELLABAHS": "DJELLABAH, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "DJELLABAS": "DJELLABA, (Arabic) a Middle Eastern hooded cloak, also DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "DJEMBE": "(Swahili) a West African drum played by beating with the hand [n -S]\n",
  "DJEMBES": "DJEMBE, (Swahili) a West African drum played by beating with the hand [n]\n",
  "DJIBBA": "a long loose outer garment worn by Muslims, also DJIBBAH, JIBBA, JIBBAH, JUBBAH, JUBHAH [n -S]\n",
  "DJIBBAH": "(Arabic) a long loose outer garment worn by Muslims, also DJIBBA, JIBBA, JIBBAH, JUBBAH, JUBHAH [n -S]\n",
  "DJIBBAHS": "DJIBBAH, (Arabic) a long loose outer garment worn by Muslims, also DJIBBA, JIBBA, JIBBAH, JUBBAH, JUBHAH [n]\n",
  "DJIBBAS": "DJIBBA, a long loose outer garment worn by Muslims, also DJIBBAH, JIBBA, JIBBAH, JUBBAH, JUBHAH [n]\n",
  "DJIN": "(Arabic) one of a class of spirits in Muslim theology, also DJINNI, DJINNY, GENIE, JIN, JINNEE, JINNI [n -S]\n",
  "DJINN": "a supernatural being in Muslim mythology, also DJIN, DJINNI, DJINNY, GENIE, JANN, JIN, JINN, JINNEE, JINNI [n -S]\n",
  "DJINNI": "(Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNY, GENIE, JANN, JIN, JINN, JINNEE, JINNI [n DJINN]\n",
  "DJINNS": "DJINN, a supernatural being in Muslim mythology, also DJIN, DJINNI, DJINNY, GENIE, JANN, JIN, JINN, JINNEE, JINNI [n]\n",
  "DJINNY": "(Arabic) one of a class of spirits in Muslim theology, also DJIN, DJINN, DJINNI, GENIE, JANN, JIN, JINN, JINNEE, JINNI [n DJINN]\n",
  "DJINS": "DJIN, (Arabic) one of a class of spirits in Muslim theology, also DJINNI, DJINNY, GENIE, JIN, JINNEE, JINNI [n]\n",
  "DO": "a party, celebration [n -S] / to perform [v DID or DIDST, DONE or DOEN, DOING, present sing 2d person DO, DOEST or DOST, 3d person DOES, DOETH or DOTH]\n",
  "DOAB": "(Urdu) a tongue or tract of land included between two rivers; as, the doab between the Ganges and the Jumna [n -S]\n",
  "DOABLE": "able to be done [adj]\n",
  "DOABS": "DOAB, (Urdu) a tongue or tract of land included between two rivers; as, the doab between the Ganges and the Jumna [n]\n",
  "DOAT": "to love excessively, also DOTE [v -ED, -ING, -S]\n",
  "DOATED": "DOAT, to love excessively, also DOTE [v]\n",
  "DOATER": "one who dotes, also DOTER [n -S]\n",
  "DOATERS": "DOATER, one who dotes, also DOTER [n]\n",
  "DOATING": "an excessive love, also DOTING [n -S]\n",
  "DOATINGS": "DOATING, an excessive love, also DOTING [n]\n",
  "DOATS": "DOAT, to love excessively, also DOTE [v]\n",
  "DOB": "(Australian slang) to inform on or betray [v DOBBED, DOBBING, DOBS]\n",
  "DOBBED": "DOB, (Australian slang) to inform on or betray [v]\n",
  "DOBBER": "(Australian slang) one who dobs, an informer [n -S]\n",
  "DOBBERS": "DOBBER, (Australian slang) one who dobs, an informer [n]\n",
  "DOBBIE": "a loom attachment which can weave small figures, also DOBBY [n -S]\n",
  "DOBBIES": "DOBBIE, a loom attachment which can weave small figures, also DOBBY [n]\n",
  "DOBBIN": "a farm horse [n -S]\n",
  "DOBBING": "DOB, (Australian slang) to inform on or betray [v]\n",
  "DOBBINS": "DOBBIN, a farm horse [n]\n",
  "DOBBY": "a loom attachment which can weave small figures, also DOBBIE [n DOBBIES]\n",
  "DOBCHICK": "the little grebe, also DABCHICK, DIPCHICK [n -S]\n",
  "DOBCHICKS": "DOBCHICK, the little grebe, also DABCHICK, DIPCHICK [n]\n",
  "DOBE": "an unburned, sun-dried brick made of clay and straw, also ADOBE, DOBIE, DOBY [n -S]\n",
  "DOBES": "DOBE, an unburned, sun-dried brick made of clay and straw, also ADOBE, DOBIE, DOBY [n]\n",
  "DOBHASH": "(Hindi) an interpreter [n -ES]\n",
  "DOBHASHES": "DOBHASH, (Hindi) an interpreter [n]\n",
  "DOBIE": "an unburnt sun-dried brick, also ADOBE, DOBE, DOBY [n -S]\n",
  "DOBIES": "DOBIE, an unburnt sun-dried brick, also ADOBE, DOBE, DOBY [n]\n",
  "DOBLA": "(Spanish) a former gold coin of Spain, also DOBLON, DOUBLOON [n -S]\n",
  "DOBLAS": "DOBLA, (Spanish) a former gold coin of Spain, also DOBLON, DOUBLOON [n]\n",
  "DOBLON": "(Spanish) a former gold coin of Spain, also DOBLA, DOUBLOON [n DOBLONS or DOBLONES]\n",
  "DOBLONES": "DOBLON, (Spanish) a former gold coin of Spain, also DOBLA, DOUBLOON [n]\n",
  "DOBLONS": "DOBLON, (Spanish) a former gold coin of Spain, also DOBLA, DOUBLOON [n]\n",
  "DOBRA": "(Portuguese) a former gold coin of Portugal [n -S]\n",
  "DOBRAS": "DOBRA, (Portuguese) a former gold coin of Portugal [n]\n",
  "DOBRO": "a type of acoustic guitar with a metal resonator built into the body [n -S]\n",
  "DOBROS": "DOBRO, a type of acoustic guitar with a metal resonator built into the body [n]\n",
  "DOBS": "DOB, (Australian slang) to inform on or betray [v]\n",
  "DOBSON": "the larva of a large neuropterous insect, used as fish bait, also DOBSONFLY [n -S]\n",
  "DOBSONFLIES": "DOBSONFLY, the larva of a large neuropterous insect, used as fish bait, also DOBSON [n]\n",
  "DOBSONFLY": "the larva of a large neuropterous insect, used as fish bait, also DOBSON [n DOBSONFLIES]\n",
  "DOBSONS": "DOBSON, the larva of a large neuropterous insect, used as fish bait, also DOBSONFLY [n]\n",
  "DOBY": "an unburnt sun-dried brick, also ADOBE, DOBE, DOBIE [n DOBIES]\n",
  "DOC": "(short for) doctor [n -S]\n",
  "DOCENT": "(German) a college or university teacher or lecturer; a person who leads guided tours esp. through a museum or art gallery [n -S]\n",
  "DOCENTS": "DOCENT, (German) a college or university teacher or lecturer; a person who leads guided tours esp. through a museum or art gallery [n]\n",
  "DOCENTSHIP": "the office of docent [n -S]\n",
  "DOCENTSHIPS": "DOCENTSHIP, the office of docent [n]\n",
  "DOCETIC": "pertaining to the heresy that Christ's body was insubstantial [adj]\n",
  "DOCHMIAC": "a foot of five syllables, also DOCHMIUS [n -S]\n",
  "DOCHMIACAL": "pertaining to, or containing, the dochmius, also DOCHMIAC [adj]\n",
  "DOCHMIACS": "DOCHMIAC, a foot of five syllables, also DOCHMIUS [n]\n",
  "DOCHMII": "DOCHMIUS, (Greek) a foot of five syllables [n]\n",
  "DOCHMIUS": "(Greek) a foot of five syllables [n DOCHMIUSES or DOCHMII]\n",
  "DOCHMIUSES": "DOCHMIUS, (Greek) a foot of five syllables [n]\n",
  "DOCHT": "DOW, to be able [v]\n",
  "DOCIBILITIES": "DOCIBILITY, docility, also DOCIBLENESS [n]\n",
  "DOCIBILITY": "docility, also DOCIBLENESS [n DOCIBILITIES]\n",
  "DOCIBLE": "able to be made docile [adj]\n",
  "DOCIBLENESS": "docility, also DOCIBILITY [n -ES]\n",
  "DOCIBLENESSES": "DOCIBLENESS, docility, also DOCIBILITY [n]\n",
  "DOCILE": "compliant [adj DOCILER, DOCILEST, DOCILELY]\n",
  "DOCILELY": "DOCILE, compliant [adv]\n",
  "DOCILER": "DOCILE, compliant [adj]\n",
  "DOCILEST": "DOCILE, compliant [adj]\n",
  "DOCILITIES": "DOCILITY, the quality of being docile [n]\n",
  "DOCILITY": "the quality of being docile [n DOCILITIES]\n",
  "DOCIMASIES": "DOCIMASY, scrutiny, examination [n]\n",
  "DOCIMASTIC": "proving by docimasy, experiments or tests [adj]\n",
  "DOCIMASY": "scrutiny, examination [n DOCIMASIES]\n",
  "DOCIMOLOGIES": "DOCIMOLOGY, the art of assaying [n]\n",
  "DOCIMOLOGY": "the art of assaying [n DOCIMOLOGIES]\n",
  "DOCK": "to bring into a wharf [v -ED, -ING, -S]\n",
  "DOCKAGE": "a charge for the use of a dock [n -S]\n",
  "DOCKAGES": "DOCKAGE, a charge for the use of a dock [n]\n",
  "DOCKED": "DOCK, to bring into a wharf [v]\n",
  "DOCKEN": "(Scots) a dock plant [n -S]\n",
  "DOCKENS": "DOCKEN, (Scots) a dock plant [n]\n",
  "DOCKER": "a dock worker [n -S]\n",
  "DOCKERS": "DOCKER, a dock worker [n]\n",
  "DOCKET": "to provide with an identifying statement, also DOCQUET [v -ED, -ING, -S]\n",
  "DOCKETED": "DOCKET, to provide with an identifying statement, also DOCQUET [v]\n",
  "DOCKETING": "DOCKET, to provide with an identifying statement, also DOCQUET [v]\n",
  "DOCKETS": "DOCKET, to provide with an identifying statement, also DOCQUET [v]\n",
  "DOCKHAND": "one who works on the docks [n -S]\n",
  "DOCKHANDS": "DOCKHAND, one who works on the docks [n]\n",
  "DOCKING": "the act of docking [n -S]\n",
  "DOCKINGS": "DOCKING, the act of docking [n]\n",
  "DOCKISATION": "the act of dockising, also DOCKIZATION [n -S]\n",
  "DOCKISATIONS": "DOCKISATION, the act of dockising, also DOCKIZATION [n]\n",
  "DOCKISE": "to convert to dock use, also DOCKIZE [v DOCKISED, DOCKISING, DOCKISES]\n",
  "DOCKISED": "DOCKISE, to convert to dock use, also DOCKIZE [v]\n",
  "DOCKISES": "DOCKISE, to convert to dock use, also DOCKIZE [v]\n",
  "DOCKISING": "DOCKISE, to convert to dock use, also DOCKIZE [v]\n",
  "DOCKIZATION": "the act of dockizing, also DOCKISATION [n -S]\n",
  "DOCKIZATIONS": "DOCKIZATION, the act of dockizing, also DOCKISATION [n]\n",
  "DOCKIZE": "to convert to dock use, also DOCKISE [v DOCKIZED, DOCKIZING, DOCKIZES]\n",
  "DOCKIZED": "DOCKIZE, to convert to dock use, also DOCKISE [v]\n",
  "DOCKIZES": "DOCKIZE, to convert to dock use, also DOCKISE [v]\n",
  "DOCKIZING": "DOCKIZE, to convert to dock use, also DOCKISE [v]\n",
  "DOCKLAND": "the part of a port occupied by docks [n -S]\n",
  "DOCKLANDS": "DOCKLAND, the part of a port occupied by docks [n]\n",
  "DOCKMASTER": "one in charge of a dock [n -S]\n",
  "DOCKMASTERS": "DOCKMASTER, one in charge of a dock [n]\n",
  "DOCKS": "DOCK, to bring into a wharf [v]\n",
  "DOCKSIDE": "the area adjacent to a dock [n -S]\n",
  "DOCKSIDES": "DOCKSIDE, the area adjacent to a dock [n]\n",
  "DOCKWALLOPER": "an informal US name for docker [n -S]\n",
  "DOCKWALLOPERS": "DOCKWALLOPER, an informal US name for docker [n]\n",
  "DOCKWORKER": "one who works on the docks [n -S]\n",
  "DOCKWORKERS": "DOCKWORKER, one who works on the docks [n]\n",
  "DOCKYARD": "a shipyard [n -S]\n",
  "DOCKYARDS": "DOCKYARD, a shipyard [n]\n",
  "DOCO": "(Australian slang) a documentary [n -S]\n",
  "DOCOS": "DOCO, (Australian slang) a documentary [n]\n",
  "DOCQUET": "to make a summary of the contents of a document, also DOCKET [v -ED, -ING, -S]\n",
  "DOCQUETED": "DOCQUET, to make a summary of the contents of a document, also DOCKET [v]\n",
  "DOCQUETING": "DOCQUET, to make a summary of the contents of a document, also DOCKET [v]\n",
  "DOCQUETS": "DOCQUET, to make a summary of the contents of a document, also DOCKET [v]\n",
  "DOCS": "DOC, (short for) doctor [n]\n",
  "DOCTOR": "to treat medically [v -ED, -ING, -S]\n",
  "DOCTORAL": "pertaining to a doctor [adj]\n",
  "DOCTORAND": "a candidate for a doctorate [n -S]\n",
  "DOCTORANDS": "DOCTORAND, a candidate for a doctorate [n]\n",
  "DOCTORATE": "the academic degree of doctor [n -S] / to take a doctorate [v DOCTORATED, DOCTORATING, DOCTORATES]\n",
  "DOCTORATED": "DOCTORATE, to take a doctorate [v]\n",
  "DOCTORATES": "DOCTORATE, to take a doctorate [v]\n",
  "DOCTORATING": "DOCTORATE, to take a doctorate [v]\n",
  "DOCTORED": "DOCTOR, to treat medically [v]\n",
  "DOCTORESS": "a female doctor, also DOCTRESS [n -ES]\n",
  "DOCTORESSES": "DOCTORESS, a female doctor, also DOCTRESS [n]\n",
  "DOCTORIAL": "of or pertaining to (the holder of) a doctorate, also DOCTORAL [adj]\n",
  "DOCTORING": "the act of falsifying e.g. a document [n -S]\n",
  "DOCTORINGS": "DOCTORING, the act of falsifying e.g. a document [n]\n",
  "DOCTORLESS": "without a doctor [adj]\n",
  "DOCTORLY": "pertaining to a doctor [adj]\n",
  "DOCTORS": "DOCTOR, to treat medically [v]\n",
  "DOCTORSHIP": "a doctorate [n -S]\n",
  "DOCTORSHIPS": "DOCTORSHIP, a doctorate [n]\n",
  "DOCTRESS": "a female doctor [n -ES]\n",
  "DOCTRESSES": "DOCTRESS, a female doctor [n]\n",
  "DOCTRINAIRE": "(French) a person who tries to apply principle without allowance for circumstance [n -S]\n",
  "DOCTRINAIRES": "DOCTRINAIRE, (French) a person who tries to apply principle without allowance for circumstance [n]\n",
  "DOCTRINAIRISM": "the state of being doctrinaire [n -S]\n",
  "DOCTRINAIRISMS": "DOCTRINAIRISM, the state of being doctrinaire [n]\n",
  "DOCTRINAL": "of or relating to doctrine [adj DOCTRINALLY]\n",
  "DOCTRINALITIES": "DOCTRINALITY, the state of being doctrinal, of or relating to doctrine [n]\n",
  "DOCTRINALITY": "the state of being doctrinal, of or relating to doctrine [n DOCTRINALITIES]\n",
  "DOCTRINALLY": "DOCTRINAL, of or relating to doctrine [adv]\n",
  "DOCTRINARIAN": "a doctrinaire, an impractical theorist [n -S]\n",
  "DOCTRINARIANISM": "being doctrinaire, also DOCTRINARISM [n]\n",
  "DOCTRINARIANS": "DOCTRINARIAN, a doctrinaire, an impractical theorist [n]\n",
  "DOCTRINARISM": "being doctrinaire, also DOCTRINARIANISM [n -S]\n",
  "DOCTRINARISMS": "DOCTRINARISM, being doctrinaire, also DOCTRINARIANISM [n]\n",
  "DOCTRINE": "a belief taught or advocated [n -S]\n",
  "DOCTRINES": "DOCTRINE, a belief taught or advocated [n]\n",
  "DOCTRINISM": "adherence to doctrines [n -S]\n",
  "DOCTRINISMS": "DOCTRINISM, adherence to doctrines [n]\n",
  "DOCTRINIST": "one who adheres to doctrines [n -S]\n",
  "DOCTRINISTS": "DOCTRINIST, one who adheres to doctrines [n]\n",
  "DOCU": "(colloquial) a documentary film [n -S]\n",
  "DOCUDRAMA": "a play or film representing real events [n -S]\n",
  "DOCUDRAMAS": "DOCUDRAMA, a play or film representing real events [n]\n",
  "DOCUMENT": "to support by conclusive information [v -ED, -ING, -S]\n",
  "DOCUMENTABLE": "capable of being documented [adj]\n",
  "DOCUMENTAL": "of or pertaining to instruction [adj]\n",
  "DOCUMENTALIST": "a specialist in documentation [n -S]\n",
  "DOCUMENTALISTS": "DOCUMENTALIST, a specialist in documentation [n]\n",
  "DOCUMENTARIAN": "one who makes a documentary [n -S]\n",
  "DOCUMENTARIANS": "DOCUMENTARIAN, one who makes a documentary [n]\n",
  "DOCUMENTARIES": "DOCUMENTARY, a program about real things [n]\n",
  "DOCUMENTARILY": "DOCUMENTARY, serving to document [adv]\n",
  "DOCUMENTARISE": "to make into a documentary, also DOCUMENTARIZE [v DOCUMENTARISED, DOCUMENTARISING, DOCUMENTARISES]\n",
  "DOCUMENTARISED": "DOCUMENTARISE, to make into a documentary, also DOCUMENTARIZE [v]\n",
  "DOCUMENTARISES": "DOCUMENTARISE, to make into a documentary, also DOCUMENTARIZE [v]\n",
  "DOCUMENTARISING": "DOCUMENTARISE, to make into a documentary, also DOCUMENTARIZE [v]\n",
  "DOCUMENTARIST": "a person who makes documentaries [n -S]\n",
  "DOCUMENTARISTS": "DOCUMENTARIST, a person who makes documentaries [n]\n",
  "DOCUMENTARIZE": "to make into a documentary, also DOCUMENTARISE [v DOCUMENTARIZED, DOCUMENTARIZING, DOCUMENTARIZES]\n",
  "DOCUMENTARIZED": "DOCUMENTARIZE, to make into a documentary, also DOCUMENTARISE [v]\n",
  "DOCUMENTARIZES": "DOCUMENTARIZE, to make into a documentary, also DOCUMENTARISE [v]\n",
  "DOCUMENTARIZING": "DOCUMENTARIZE, to make into a documentary, also DOCUMENTARISE [v]\n",
  "DOCUMENTARY": "serving to document [adj DOCUMENTARILY] / a program about real things [n DOCUMENTARIES]\n",
  "DOCUMENTATION": "the act or an instance of furnishing or authenticating with documents [n -S]\n",
  "DOCUMENTATIONAL": "relating to documentation [adj]\n",
  "DOCUMENTATIONS": "DOCUMENTATION, the act or an instance of furnishing or authenticating with documents [n]\n",
  "DOCUMENTED": "DOCUMENT, to support by conclusive information [v]\n",
  "DOCUMENTER": "one who documents [n -S]\n",
  "DOCUMENTERS": "DOCUMENTER, one who documents [n]\n",
  "DOCUMENTING": "DOCUMENT, to support by conclusive information [v]\n",
  "DOCUMENTS": "DOCUMENT, to support by conclusive information [v]\n",
  "DOCUS": "DOCU, (colloquial) a documentary film [n]\n",
  "DOCUSOAP": "a television series that follows the lives of real people over a period of time [n -S]\n",
  "DOCUSOAPS": "DOCUSOAP, a television series that follows the lives of real people over a period of time [n]\n",
  "DOD": "(Scots) to knock, thump, also DAUD, DAWD [v DODDED, DODDING, DODS]\n",
  "DODDARD": "(obsolete) a tree missing its top branches through rot or decay [n -S]\n",
  "DODDARDS": "DODDARD, (obsolete) a tree missing its top branches through rot or decay [n]\n",
  "DODDED": "DOD, (Scots) to knock, thump, also DAUD, DAWD [v]\n",
  "DODDER": "to walk unsteadily or falteringly, totter [v -ED, -ING, -S]\n",
  "DODDERED": "DODDER, to walk unsteadily or falteringly, totter [v]\n",
  "DODDERER": "one who dodders [n -S]\n",
  "DODDERERS": "DODDERER, one who dodders [n]\n",
  "DODDERIER": "DODDERY, unsteady with age [adj]\n",
  "DODDERIEST": "DODDERY, unsteady with age [adj]\n",
  "DODDERING": "DODDER, to walk unsteadily or falteringly, totter [v]\n",
  "DODDERS": "DODDER, to walk unsteadily or falteringly, totter [v]\n",
  "DODDERY": "unsteady with age [adj DODDERIER, DODDERIEST]\n",
  "DODDIER": "DODDY, sulky [adj]\n",
  "DODDIES": "DODDY, (Scots) a hornless cow [n]\n",
  "DODDIEST": "DODDY, sulky [adj]\n",
  "DODDING": "DOD, (Scots) to knock, thump, also DAUD, DAWD [v]\n",
  "DODDIPOLL": "(obsolete) a blockhead, also DODDYPOLL [n -S]\n",
  "DODDIPOLLS": "DODDIPOLL, (obsolete) a blockhead, also DODDYPOLL [n]\n",
  "DODDLE": "an easy task [n -S]\n",
  "DODDLES": "DODDLE, an easy task [n]\n",
  "DODDY": "(Scots) a hornless cow [n DODDIES] / sulky [adj DODDIER, DODDIEST]\n",
  "DODDYPOLL": "(obsolete) a blockhead, also DODDIPOLL [n -S]\n",
  "DODDYPOLLS": "DODDYPOLL, (obsolete) a blockhead, also DODDIPOLL [n]\n",
  "DODECAGON": "a plane figure with twelve sides [n -S]\n",
  "DODECAGONAL": "like a dodecagon, a plane figure with twelve sides [adj]\n",
  "DODECAGONS": "DODECAGON, a plane figure with twelve sides [n]\n",
  "DODECAGYNIAN": "having twelve styles, also DODECAGYNOUS [adj]\n",
  "DODECAGYNOUS": "having twelve styles, also DODECAGYNIAN [adj]\n",
  "DODECAHEDRA": "DODECAHEDRON, (Greek) a twelve-sided solid figure [n]\n",
  "DODECAHEDRAL": "relating to a dodecahedron, a twelve-sided solid figure [adj]\n",
  "DODECAHEDRON": "(Greek) a twelve-sided solid figure [n DODECAHEDRA or DODECAHEDRONS]\n",
  "DODECAHEDRONS": "DODECAHEDRON, (Greek) a twelve-sided solid figure [n]\n",
  "DODECANDROUS": "having twelve stamens [adj]\n",
  "DODECANOIC": "as in dodecanoic acid, a crystalline fatty acid [adj]\n",
  "DODECAPHONIC": "of music, twelve-tone [adj]\n",
  "DODECAPHONIES": "DODECAPHONY, twelve-tone music, also DODECAPHONISM [n]\n",
  "DODECAPHONISM": "twelve-tone music, also DODECAPHONY [n -S]\n",
  "DODECAPHONISMS": "DODECAPHONISM, twelve-tone music, also DODECAPHONY [n]\n",
  "DODECAPHONIST": "a composer or admirer of twelve-tone music [n -S]\n",
  "DODECAPHONISTS": "DODECAPHONIST, a composer or admirer of twelve-tone music [n]\n",
  "DODECAPHONY": "twelve-tone music, also DODECAPHONISM [n DODECAPHONIES]\n",
  "DODECASTYLE": "having twelve columns in front [adj] / a portico so built [n -S]\n",
  "DODECASTYLES": "DODECASTYLE, a portico so built [n]\n",
  "DODECASYLLABIC": "of a line of verse, having twelve syllables [adj]\n",
  "DODECASYLLABLE": "a line of twelve syllables [n -S]\n",
  "DODECASYLLABLES": "DODECASYLLABLE, a line of twelve syllables [n]\n",
  "DODGE": "to evade [v DODGED, DODGING, DODGES]\n",
  "DODGEBALL": "a ball game [n -S]\n",
  "DODGEBALLS": "DODGEBALL, a ball game [n]\n",
  "DODGED": "DODGE, to evade [v]\n",
  "DODGEM": "an amusement park ride [n -S]\n",
  "DODGEMS": "DODGEM, an amusement park ride [n]\n",
  "DODGER": "one that dodges [n -S]\n",
  "DODGERIES": "DODGERY, evasion, trickery [n]\n",
  "DODGERS": "DODGER, one that dodges [n]\n",
  "DODGERY": "evasion, trickery [n DODGERIES]\n",
  "DODGES": "DODGE, to evade [v]\n",
  "DODGIER": "DODGY, dubious, shady [adj]\n",
  "DODGIEST": "DODGY, dubious, shady [adj]\n",
  "DODGINESS": "the state of being dodgy [n -ES]\n",
  "DODGINESSES": "DODGINESS, the state of being dodgy [n]\n",
  "DODGING": "a photographic technique [n -S]\n",
  "DODGINGS": "DODGING, a photographic technique [n]\n",
  "DODGY": "dubious, shady [adj DODGIER, DODGIEST]\n",
  "DODKIN": "(Dutch) an old Dutch coin of small value, also DOIT, DOITKIN, DUIT [n -S]\n",
  "DODKINS": "DODKIN, (Dutch) an old Dutch coin of small value, also DOIT, DOITKIN, DUIT [n]\n",
  "DODMAN": "a snail [n -S]\n",
  "DODMANS": "DODMAN, a snail [n]\n",
  "DODO": "(Portuguese) an extinct bird [n DODOS or DODOES]\n",
  "DODOES": "DODO, (Portuguese) an extinct bird [n]\n",
  "DODOISM": "a stupid remark [n -S]\n",
  "DODOISMS": "DODOISM, a stupid remark [n]\n",
  "DODOS": "DODO, (Portuguese) an extinct bird [n]\n",
  "DODS": "DOD, (Scots) to knock, thump, also DAUD, DAWD [v]\n",
  "DOE": "the female of a deer, rabbit and some other animals [n -S]\n",
  "DOEK": "(South African) a square cloth for tying round the head, worn by African women [n -S]\n",
  "DOEKS": "DOEK, (South African) a square cloth for tying round the head, worn by African women [n]\n",
  "DOEN": "DO, to perform [v]\n",
  "DOER": "one that does something [n -S]\n",
  "DOERS": "DOER, one that does something [n]\n",
  "DOES": "DO, to perform [v]\n",
  "DOESKIN": "the skin of a doe [n -S]\n",
  "DOESKINS": "DOESKIN, the skin of a doe [n]\n",
  "DOEST": "DO, to perform [v]\n",
  "DOETH": "DO, to perform [v]\n",
  "DOF": "(South African) stupid [adj]\n",
  "DOFF": "to take off [v -ED, -ING, -S]\n",
  "DOFFED": "DOFF, to take off [v]\n",
  "DOFFER": "part of a carding machine that strips the cotton from the cylinder when carded [n -S]\n",
  "DOFFERS": "DOFFER, part of a carding machine that strips the cotton from the cylinder when carded [n]\n",
  "DOFFING": "DOFF, to take off [v]\n",
  "DOFFS": "DOFF, to take off [v]\n",
  "DOG": "to follow closely behind [v DOGGED, DOGGING, DOGS]\n",
  "DOGAN": "(offensive) a derogatory term for a person who follows the Catholic faith [n -S]\n",
  "DOGANS": "DOGAN, (offensive) a derogatory term for a person who follows the Catholic faith [n]\n",
  "DOGARESSA": "(Italian) a doge's wife [n -S]\n",
  "DOGARESSAS": "DOGARESSA, (Italian) a doge's wife [n]\n",
  "DOGATE": "the office of a doge, or chief magistrate of Venice, also DOGESHIP, DOGEATE [n -S]\n",
  "DOGATES": "DOGATE, the office of a doge, or chief magistrate of Venice, also DOGESHIP, DOGEATE [n]\n",
  "DOGBANE": "a small genus of perennial herbaceous plants, with poisonous milky juice [n -S]\n",
  "DOGBANES": "DOGBANE, a small genus of perennial herbaceous plants, with poisonous milky juice [n]\n",
  "DOGBERRIES": "DOGBERRY, the berry of the dogwood [n]\n",
  "DOGBERRY": "the berry of the dogwood [n DOGBERRIES]\n",
  "DOGBERRYISM": "the state of being like Dogberry, a foolish meddling person [n -S]\n",
  "DOGBERRYISMS": "DOGBERRYISM, the state of being like Dogberry, a foolish meddling person [n]\n",
  "DOGBOLT": "a type of arrow [n -S]\n",
  "DOGBOLTS": "DOGBOLT, a type of arrow [n]\n",
  "DOGCART": "a light two-wheeled carriage with seats back-to-back [n -S]\n",
  "DOGCARTS": "DOGCART, a light two-wheeled carriage with seats back-to-back [n]\n",
  "DOGCATCHER": "one whose job is to catch stray dogs [n -S]\n",
  "DOGCATCHERS": "DOGCATCHER, one whose job is to catch stray dogs [n]\n",
  "DOGDOM": "the world of dogs [n -S]\n",
  "DOGDOMS": "DOGDOM, the world of dogs [n]\n",
  "DOGE": "(Italian) the former title of the chief magistrate in Venice [n -S]\n",
  "DOGEAR": "to turn down a corner of a page [v -ED, -ING, -S]\n",
  "DOGEARED": "DOGEAR, to turn down a corner of a page [v]\n",
  "DOGEARING": "DOGEAR, to turn down a corner of a page [v]\n",
  "DOGEARS": "DOGEAR, to turn down a corner of a page [v]\n",
  "DOGEATE": "the office of a doge, or chief magistrate of Venice, also DOGESHIP, DOGATE [n -S]\n",
  "DOGEATES": "DOGEATE, the office of a doge, or chief magistrate of Venice, also DOGESHIP, DOGATE [n]\n",
  "DOGEDOM": "the office of doge [n -S]\n",
  "DOGEDOMS": "DOGEDOM, the office of doge [n]\n",
  "DOGES": "DOGE, (Italian) the former title of the chief magistrate in Venice [n]\n",
  "DOGESHIP": "the office of a doge, also DOGATE, DOGEATE [n -S]\n",
  "DOGESHIPS": "DOGESHIP, the office of a doge, also DOGATE, DOGEATE [n]\n",
  "DOGEY": "a stray calf, also DOGIE, DOGY [n -S]\n",
  "DOGEYS": "DOGEY, a stray calf, also DOGIE, DOGY [n]\n",
  "DOGFACE": "a soldier in the US army [n -S]\n",
  "DOGFACES": "DOGFACE, a soldier in the US army [n]\n",
  "DOGFIGHT": "to engage in an aerial battle [v DOGFOUGHT, DOGFIGHTING, DOGFIGHTS]\n",
  "DOGFIGHTING": "engaging in aerial combat [n -S]\n",
  "DOGFIGHTINGS": "DOGFIGHTING, engaging in aerial combat [n]\n",
  "DOGFIGHTS": "DOGFIGHT, to engage in an aerial battle [v]\n",
  "DOGFISH": "a kind of small shark [n -ES]\n",
  "DOGFISHES": "DOGFISH, a kind of small shark [n]\n",
  "DOGFOOD": "food for a dog [n -S]\n",
  "DOGFOODS": "DOGFOOD, food for a dog [n]\n",
  "DOGFOUGHT": "DOGFIGHT, to engage in an aerial battle [v]\n",
  "DOGFOX": "a male fox [n -ES]\n",
  "DOGFOXES": "DOGFOX, a male fox [n]\n",
  "DOGGED": "stubbornly determined [adj DOGGEDER, DOGGEDEST, DOGGEDLY]\n",
  "DOGGEDER": "DOGGED, stubbornly determined [adj]\n",
  "DOGGEDEST": "DOGGED, stubbornly determined [adj]\n",
  "DOGGEDLY": "DOGGED, stubbornly determined [adv]\n",
  "DOGGEDNESS": "the quality of being dogged [n -ES]\n",
  "DOGGEDNESSES": "DOGGEDNESS, the quality of being dogged [n]\n",
  "DOGGER": "(Dutch) a two-masted fishing vessel, used by the Dutch [n -S]\n",
  "DOGGEREL": "poor quality comic verse, also DOGGREL, DOGREL [n -S]\n",
  "DOGGERELS": "DOGGEREL, poor quality comic verse, also DOGGREL, DOGREL [n]\n",
  "DOGGERIES": "DOGGERY, surly behaviour [n]\n",
  "DOGGERMAN": "(Dutch) a sailor belonging to a dogger, a two-masted fishing vessel, used by the Dutch [n DOGGERMEN]\n",
  "DOGGERMEN": "DOGGERMAN, (Dutch) a sailor belonging to a dogger, a two-masted fishing vessel, used by the Dutch [n]\n",
  "DOGGERS": "DOGGER, (Dutch) a two-masted fishing vessel, used by the Dutch [n]\n",
  "DOGGERY": "surly behaviour [n DOGGERIES]\n",
  "DOGGESS": "(facetious) a bitch [n -ES]\n",
  "DOGGESSES": "DOGGESS, (facetious) a bitch [n]\n",
  "DOGGIE": "a small dog, also DOGGY [n -S]\n",
  "DOGGIER": "DOGGY, resembling a dog [adj]\n",
  "DOGGIES": "DOGGIE, a small dog, also DOGGY [n]\n",
  "DOGGIEST": "DOGGY, resembling a dog [adj]\n",
  "DOGGINESS": "being like a dog [n -ES]\n",
  "DOGGINESSES": "DOGGINESS, being like a dog [n]\n",
  "DOGGING": "hunting with dogs [n -S]\n",
  "DOGGINGS": "DOGGING, hunting with dogs [n]\n",
  "DOGGISH": "like a dog; having the bad qualities of a dog; churlish [adj DOGGISHLY]\n",
  "DOGGISHLY": "DOGGISH, like a dog; having the bad qualities of a dog; churlish [adv]\n",
  "DOGGISHNESS": "being like a dog [n -ES]\n",
  "DOGGISHNESSES": "DOGGISHNESS, being like a dog [n]\n",
  "DOGGO": "still and quiet, as in to lie doggo [adv]\n",
  "DOGGONE": "damned, cursed [adj DOGGONER, DOGGONEST] / to damn [v DOGGONED, DOGGONING, DOGGONES]\n",
  "DOGGONED": "damned, cursed [adj DOGGONEDER, DOGGONEDEST]\n",
  "DOGGONEDER": "DOGGONED, damned, cursed [adj]\n",
  "DOGGONEDEST": "DOGGONED, damned, cursed [adj]\n",
  "DOGGONER": "DOGGONE, damned, cursed [adj]\n",
  "DOGGONES": "DOGGONE, to damn [v]\n",
  "DOGGONEST": "DOGGONE, damned, cursed [adj]\n",
  "DOGGONING": "DOGGONE, to damn [v]\n",
  "DOGGREL": "poor quality comic verse, also DOGGEREL, DOGREL [n -S]\n",
  "DOGGRELS": "DOGGREL, poor quality comic verse, also DOGGEREL, DOGREL [n]\n",
  "DOGGY": "resembling a dog [adj DOGGIER, DOGGIEST] / a small dog, also DOGGIE [n DOGGIES]\n",
  "DOGHANGED": "shamefaced [adj]\n",
  "DOGHOLE": "a wretched dwelling [n -S]\n",
  "DOGHOLES": "DOGHOLE, a wretched dwelling [n]\n",
  "DOGHOUSE": "a shelter for a dog [n -S]\n",
  "DOGHOUSES": "DOGHOUSE, a shelter for a dog [n]\n",
  "DOGIE": "a stray calf, also DOGEY, DOGY [n -S]\n",
  "DOGIES": "DOGY, a stray calf, also DOGEY, DOGIE [n]\n",
  "DOGLEG": "to move along a bent course [v DOGLEGGED, DOGLEGGING, DOGLEGS]\n",
  "DOGLEGGED": "DOGLEG, to move along a bent course [v]\n",
  "DOGLEGGING": "DOGLEG, to move along a bent course [v]\n",
  "DOGLEGS": "DOGLEG, to move along a bent course [v]\n",
  "DOGLIKE": "resembling a dog [adj]\n",
  "DOGMA": "(Greek) an authoritative belief [n DOGMAS or DOGMATA]\n",
  "DOGMAN": "(Australian slang) a person who directs the operation of a crane while riding on the object being lifted by it [n DOGMEN]\n",
  "DOGMAS": "DOGMA, (Greek) an authoritative belief [n]\n",
  "DOGMATA": "DOGMA, (Greek) an authoritative belief [n]\n",
  "DOGMATIC": "overbearing [adj DOGMATICALLY]\n",
  "DOGMATICAL": "pertaining to a dogma, or to an established and authorized doctrine or tenet, also DOGMATIC [adj DOGMATICALLY]\n",
  "DOGMATICALLY": "DOGMATICAL, pertaining to a dogma, or to an established and authorized doctrine or tenet, also DOGMATIC [adv]\n",
  "DOGMATICALNESS": "the state of being dogmatical [n]\n",
  "DOGMATICS": "the science which treats of Christian doctrinal theology [n]\n",
  "DOGMATISATION": "the act of dogmatising, also DOGMATIZATION [n -S]\n",
  "DOGMATISATIONS": "DOGMATISATION, the act of dogmatising, also DOGMATIZATION [n]\n",
  "DOGMATISE": "to assert positively, also DOGMATIZE [v DOGMATISED, DOGMATISING, DOGMATISES]\n",
  "DOGMATISED": "DOGMATISE, to assert positively, also DOGMATIZE [v]\n",
  "DOGMATISER": "one who dogmatises, also DOGMATIZER [n -S]\n",
  "DOGMATISERS": "DOGMATISER, one who dogmatises, also DOGMATIZER [n]\n",
  "DOGMATISES": "DOGMATISE, to assert positively, also DOGMATIZE [v]\n",
  "DOGMATISING": "DOGMATISE, to assert positively, also DOGMATIZE [v]\n",
  "DOGMATISM": "the manner or character of a dogmatist; arrogance or positiveness in stating opinion [n -S]\n",
  "DOGMATISMS": "DOGMATISM, the manner or character of a dogmatist; arrogance or positiveness in stating opinion [n]\n",
  "DOGMATIST": "one who dogmatizes [n -S]\n",
  "DOGMATISTS": "DOGMATIST, one who dogmatizes [n]\n",
  "DOGMATIZATION": "the act of dogmatizing, also DOGMATISATION [n -S]\n",
  "DOGMATIZATIONS": "DOGMATIZATION, the act of dogmatizing, also DOGMATISATION [n]\n",
  "DOGMATIZE": "to assert positively, also DOGMATISE [v DOGMATIZED, DOGMATIZING, DOGMATIZES]\n",
  "DOGMATIZED": "DOGMATIZE, to assert positively, also DOGMATISE [v]\n",
  "DOGMATIZER": "one who dogmatizes, also DOGMATISER [n -S]\n",
  "DOGMATIZERS": "DOGMATIZER, one who dogmatizes, also DOGMATISER [n]\n",
  "DOGMATIZES": "DOGMATIZE, to assert positively, also DOGMATISE [v]\n",
  "DOGMATIZING": "DOGMATIZE, to assert positively, also DOGMATISE [v]\n",
  "DOGMATOLOGIES": "DOGMATOLOGY, the science of dogma [n]\n",
  "DOGMATOLOGY": "the science of dogma [n DOGMATOLOGIES]\n",
  "DOGMATORY": "relating to dogma, a settled opinion, a principle or belief [adj]\n",
  "DOGMEN": "DOGMAN, (Australian slang) a person who directs the operation of a crane while riding on the object being lifted by it [n]\n",
  "DOGNAP": "to steal a dog [v DOGNAPED or DOGNAPPED, DOGNAPING or DOGNAPPING, DOGNAPS]\n",
  "DOGNAPED": "DOGNAP, to steal a dog [v]\n",
  "DOGNAPER": "one who dognaps, abducts dogs, also DOGNAPPER [n -S]\n",
  "DOGNAPERS": "DOGNAPER, one who dognaps, abducts dogs, also DOGNAPPER [n]\n",
  "DOGNAPING": "the abduction of a dog [n -S]\n",
  "DOGNAPINGS": "DOGNAPING, the abduction of a dog [n]\n",
  "DOGNAPPED": "DOGNAP, to steal a dog [v]\n",
  "DOGNAPPER": "one who dognaps, abducts a dog, also DOGNAPER [n -S]\n",
  "DOGNAPPERS": "DOGNAPPER, one who dognaps, abducts a dog, also DOGNAPER [n]\n",
  "DOGNAPPING": "the abduction of a dog [n -S]\n",
  "DOGNAPPINGS": "DOGNAPPING, the abduction of a dog [n]\n",
  "DOGNAPS": "DOGNAP, to steal a dog [v]\n",
  "DOGPILE": "a heap of bodies formed by people jumping on top of each other in an act of celebration [n -S]\n",
  "DOGPILES": "DOGPILE, a heap of bodies formed by people jumping on top of each other in an act of celebration [n]\n",
  "DOGREL": "doggerel, also DOGGEREL, DOGGREL [n -S]\n",
  "DOGRELS": "DOGREL, doggerel, also DOGGEREL, DOGGREL [n]\n",
  "DOGROBBER": "an army cook [n -S]\n",
  "DOGROBBERS": "DOGROBBER, an army cook [n]\n",
  "DOGS": "DOG, to follow closely behind [v]\n",
  "DOGSBODIED": "DOGSBODY, to do menial work [v]\n",
  "DOGSBODIES": "DOGSBODY, a menial worker [n]\n",
  "DOGSBODY": "a menial worker [n DOGSBODIES] / to do menial work [v DOGSBODIED, DOGSBODYING, DOGSBODIES]\n",
  "DOGSBODYING": "acting as a dogsbody [n -S]\n",
  "DOGSBODYINGS": "DOGSBODYING, acting as a dogsbody [n]\n",
  "DOGSHIP": "the personality of a dog [n -S]\n",
  "DOGSHIPS": "DOGSHIP, the personality of a dog [n]\n",
  "DOGSHORES": "shores used to hold a ship firmly and prevent her moving while the blocks are knocked away before launching [n]\n",
  "DOGSHOW": "a show for dogs [n -S]\n",
  "DOGSHOWS": "DOGSHOW, a show for dogs [n]\n",
  "DOGSKIN": "leather made from dog's skin [n -S]\n",
  "DOGSKINS": "DOGSKIN, leather made from dog's skin [n]\n",
  "DOGSLED": "to ride a sled drawn by dogs [v DOGSLEDDED, DOGSLEDDING, DOGSLEDS]\n",
  "DOGSLEDDED": "DOGSLED, to ride a sled drawn by dogs [v]\n",
  "DOGSLEDDER": "one who travels by dogsled [n -S]\n",
  "DOGSLEDDERS": "DOGSLEDDER, one who travels by dogsled [n]\n",
  "DOGSLEDDING": "travelling by dogsled [n -S]\n",
  "DOGSLEDDINGS": "DOGSLEDDING, travelling by dogsled [n]\n",
  "DOGSLEDS": "DOGSLED, to ride a sled drawn by dogs [v]\n",
  "DOGSLEEP": "a light sleep [n -S]\n",
  "DOGSLEEPS": "DOGSLEEP, a light sleep [n]\n",
  "DOGSTAIL": "a grass with spiky flower-heads, also DOGTAIL [n -S]\n",
  "DOGSTAILS": "DOGSTAIL, a grass with spiky flower-heads, also DOGTAIL [n]\n",
  "DOGTAIL": "a grass with spiky flower-heads, also DOGSTAIL [n -S]\n",
  "DOGTAILS": "DOGTAIL, a grass with spiky flower-heads, also DOGSTAIL [n]\n",
  "DOGTEETH": "DOGTOOTH, a canine tooth [n]\n",
  "DOGTOOTH": "a canine tooth [n DOGTEETH]\n",
  "DOGTOWN": "a prairie-dog community [n -S]\n",
  "DOGTOWNS": "DOGTOWN, a prairie-dog community [n]\n",
  "DOGTROT": "to move at a steady trot [v DOGTROTTED, DOGTROTTING, DOGTROTS]\n",
  "DOGTROTS": "DOGTROT, to move at a steady trot [v]\n",
  "DOGTROTTED": "DOGTROT, to move at a steady trot [v]\n",
  "DOGTROTTING": "DOGTROT, to move at a steady trot [v]\n",
  "DOGVANE": "a small vane to show the direction of the wind [n -S]\n",
  "DOGVANES": "DOGVANE, a small vane to show the direction of the wind [n]\n",
  "DOGWATCH": "either of the two shorter (two-hour) watches on a ship (4-6, 6-8 p.m.) [n -ES]\n",
  "DOGWATCHES": "DOGWATCH, either of the two shorter (two-hour) watches on a ship (4-6, 6-8 p.m.) [n]\n",
  "DOGWOOD": "any of various shrubs and trees of genus Cornus, also DAGWOOD [n -S]\n",
  "DOGWOODS": "DOGWOOD, any of various shrubs and trees of genus Cornus, also DAGWOOD [n]\n",
  "DOGY": "a stray calf, also DOGEY, DOGIE [n DOGIES]\n",
  "DOH": "a musical note [n -S]\n",
  "DOHS": "DOH, a musical note [n]\n",
  "DOHYO": "(Japanese) a sumo wrestling ring [n -S]\n",
  "DOHYOS": "DOHYO, (Japanese) a sumo wrestling ring [n]\n",
  "DOILED": "(Scots) crazy, foolish, also DOILT [adj]\n",
  "DOILIED": "having a doily [adj]\n",
  "DOILIES": "DOILY, an ornamental napkin, also DOYLEY, DOYLY [n]\n",
  "DOILT": "(Scots) crazy, foolish, also DOILED [adj DOILTER, DOILTEST]\n",
  "DOILTER": "DOILT, (Scots) crazy, foolish, also DOILED [adj]\n",
  "DOILTEST": "DOILT, (Scots) crazy, foolish, also DOILED [adj]\n",
  "DOILY": "an ornamental napkin, also DOYLEY, DOYLY [n DOILIES]\n",
  "DOING": "an action [n -S]\n",
  "DOINGS": "DOING, an action [n]\n",
  "DOIT": "(Dutch) an old Dutch coin of little value, also DODKIN, DOITKIN, DUIT [n -S]\n",
  "DOITED": "(Scots) in one's dotage, also DOITIT [adj]\n",
  "DOITIT": "(Scots) in one's dotage, also DOITED [adj]\n",
  "DOITKIN": "(Dutch) an old Dutch coin of little value, also DODKIN, DOIT, DUIT [n -S]\n",
  "DOITKINS": "DOITKIN, (Dutch) an old Dutch coin of little value, also DODKIN, DOIT, DUIT [n]\n",
  "DOITS": "DOIT, (Dutch) an old Dutch coin of little value, also DODKIN, DOITKIN, DUIT [n]\n",
  "DOJO": "(Japanese) a martial arts school [n -S]\n",
  "DOJOS": "DOJO, (Japanese) a martial arts school [n]\n",
  "DOL": "a unit of pain intensity [n -S]\n",
  "DOLABRATE": "shaped like the head of an axe [adj]\n",
  "DOLABRIFORM": "shaped like a hatchet or cleaver [adj]\n",
  "DOLCE": "(Italian) a soft-toned organ stop [n -S]\n",
  "DOLCELATTE": "(tradename) a soft blue-veined Italian cheese [n -S]\n",
  "DOLCELATTES": "DOLCELATTE, (tradename) a soft blue-veined Italian cheese [n]\n",
  "DOLCEMENTE": "(Italian) softly; sweetly; with soft, smooth, and delicate execution [adj]\n",
  "DOLCES": "DOLCE, (Italian) a soft-toned organ stop [n]\n",
  "DOLCETTO": "(Italian) a variety of grape for making wine [n -S]\n",
  "DOLCETTOS": "DOLCETTO, (Italian) a variety of grape for making wine [n]\n",
  "DOLCI": "(Italian) sweet things [n]\n",
  "DOLDRUMS": "those parts of the ocean near the equator where calm and baffling winds prevail [n]\n",
  "DOLE": "to distribute in small portions [v DOLED, DOLING, DOLES]\n",
  "DOLED": "DOLE, to distribute in small portions [v]\n",
  "DOLEFUL": "sad, full of woe [adj DOLEFULLER, DOLEFULLEST, DOLEFULLY]\n",
  "DOLEFULLER": "DOLEFUL, sad, full of woe [adj]\n",
  "DOLEFULLEST": "DOLEFUL, sad, full of woe [adj]\n",
  "DOLEFULLY": "DOLEFUL, sad, full of woe [adv]\n",
  "DOLEFULNESS": "the state of being doleful [n -ES]\n",
  "DOLEFULNESSES": "DOLEFULNESS, the state of being doleful [n]\n",
  "DOLENT": "(obsolete) causing sorrow or grief [adj]\n",
  "DOLENTE": "(Italian) musical direction, to be performed in a sorrowful manner [adj]\n",
  "DOLERITE": "a type of igneous rock [n -S]\n",
  "DOLERITES": "DOLERITE, a type of igneous rock [n]\n",
  "DOLERITIC": "of or like dolerite [adj]\n",
  "DOLES": "DOLE, to distribute in small portions [v]\n",
  "DOLESOME": "doleful, dismal [adj DOLESOMELY]\n",
  "DOLESOMELY": "DOLESOME, doleful, dismal [adv]\n",
  "DOLIA": "DOLIUM, (Latin) a Roman earthenware jar for grain, oil etc. [n]\n",
  "DOLICHOCEPHAL": "a person with a long head [n -S]\n",
  "DOLICHOCEPHALIC": "longheaded [adj]\n",
  "DOLICHOCEPHALS": "DOLICHOCEPHAL, a person with a long head [n]\n",
  "DOLICHOCEPHALY": "the state of being dolichocephalic [n]\n",
  "DOLICHOS": "(Greek) a long-podded leguminous plant allied to the haricot [n -ES]\n",
  "DOLICHOSAURUS": "any member of the Dolichosauria, a group of Cretaceous fossil reptiles [n -ES]\n",
  "DOLICHOSAURUSES": "DOLICHOSAURUS, any member of the Dolichosauria, a group of Cretaceous fossil reptiles [n]\n",
  "DOLICHOSES": "DOLICHOS, (Greek) a long-podded leguminous plant allied to the haricot [n]\n",
  "DOLICHURI": "DOLICHURUS, (Greek) a dactylic hexameter with a redundant syllable at the end [n]\n",
  "DOLICHURUS": "(Greek) a dactylic hexameter with a redundant syllable at the end [n DOLICHURI or DOLICHURUSES]\n",
  "DOLICHURUSES": "DOLICHURUS, (Greek) a dactylic hexameter with a redundant syllable at the end [n]\n",
  "DOLINA": "(Russian) a swallow-hole, also DOLINE [n -S]\n",
  "DOLINAS": "DOLINA, (Russian) a swallow-hole, also DOLINE [n]\n",
  "DOLINE": "(Russian) a swallow-hole, also DOLINA [n -S]\n",
  "DOLINES": "DOLINE, (Russian) a swallow-hole, also DOLINA [n]\n",
  "DOLING": "DOLE, to distribute in small portions [v]\n",
  "DOLIUM": "(Latin) a Roman earthenware jar for grain, oil etc. [n DOLIA]\n",
  "DOLL": "to dress stylishly [v -ED, -ING, -S]\n",
  "DOLLAR": "a monetary unit of the USA [n -S]\n",
  "DOLLARBIRD": "a bird of the roller family, found in S and SE Asia and Australia, with a round white spot on each wing [n -S]\n",
  "DOLLARBIRDS": "DOLLARBIRD, a bird of the roller family, found in S and SE Asia and Australia, with a round white spot on each wing [n]\n",
  "DOLLARED": "having dollars [adj]\n",
  "DOLLARFISH": "any of various fishes that have a rounded compressed silvery body, esp. the moonfishes or the American butterfish [n -ES]\n",
  "DOLLARFISHES": "DOLLARFISH, any of various fishes that have a rounded compressed silvery body, esp. the moonfishes or the American butterfish [n]\n",
  "DOLLARISATION": "the process of dollarising, also DOLLARIZATION [n -S]\n",
  "DOLLARISATIONS": "DOLLARISATION, the process of dollarising, also DOLLARIZATION [n]\n",
  "DOLLARISE": "to replace a country's currency with the US dollar, also DOLLARIZE [v DOLLARISED, DOLLARISING, DOLLARISES]\n",
  "DOLLARISED": "DOLLARISE, to replace a country's currency with the US dollar, also DOLLARIZE [v]\n",
  "DOLLARISES": "DOLLARISE, to replace a country's currency with the US dollar, also DOLLARIZE [v]\n",
  "DOLLARISING": "DOLLARISE, to replace a country's currency with the US dollar, also DOLLARIZE [v]\n",
  "DOLLARIZATION": "the process of dollarizing, also DOLLARISATION [n -S]\n",
  "DOLLARIZATIONS": "DOLLARIZATION, the process of dollarizing, also DOLLARISATION [n]\n",
  "DOLLARIZE": "to replace a country's currency with the US dollar, also DOLLARISE [v DOLLARIZED, DOLLARIZING, DOLLARIZES]\n",
  "DOLLARIZED": "DOLLARIZE, to replace a country's currency with the US dollar, also DOLLARISE [v]\n",
  "DOLLARIZES": "DOLLARIZE, to replace a country's currency with the US dollar, also DOLLARISE [v]\n",
  "DOLLARIZING": "DOLLARIZE, to replace a country's currency with the US dollar, also DOLLARISE [v]\n",
  "DOLLARLESS": "without dollars [adj]\n",
  "DOLLAROCRACIES": "DOLLAROCRACY, rule by the dollar [n]\n",
  "DOLLAROCRACY": "rule by the dollar [n DOLLAROCRACIES]\n",
  "DOLLARS": "DOLLAR, a monetary unit of the USA [n]\n",
  "DOLLARSHIP": "the domain of the dollar [n -S]\n",
  "DOLLARSHIPS": "DOLLARSHIP, the domain of the dollar [n]\n",
  "DOLLDOM": "the world of dolls [n -S]\n",
  "DOLLDOMS": "DOLLDOM, the world of dolls [n]\n",
  "DOLLED": "DOLL, to dress stylishly [v]\n",
  "DOLLHOOD": "the state of being a doll [n -S]\n",
  "DOLLHOODS": "DOLLHOOD, the state of being a doll [n]\n",
  "DOLLHOUSE": "a house for dolls [n -S]\n",
  "DOLLHOUSES": "DOLLHOUSE, a house for dolls [n]\n",
  "DOLLIED": "DOLLY, to move on a wheeled platform [v]\n",
  "DOLLIER": "one who wheels a trolley [n -S]\n",
  "DOLLIERS": "DOLLIER, one who wheels a trolley [n]\n",
  "DOLLIES": "DOLLY, to move on a wheeled platform [v]\n",
  "DOLLINESS": "the state of being a dolly [n -ES]\n",
  "DOLLINESSES": "DOLLINESS, the state of being a dolly [n]\n",
  "DOLLING": "DOLL, to dress stylishly [v]\n",
  "DOLLISH": "like a doll [adj DOLLISHLY]\n",
  "DOLLISHLY": "DOLLISH, like a doll [adv]\n",
  "DOLLISHNESS": "the state of being dollish [n -ES]\n",
  "DOLLISHNESSES": "DOLLISHNESS, the state of being dollish [n]\n",
  "DOLLOP": "to dispense in small amounts [v -ED, -ING, -S]\n",
  "DOLLOPED": "DOLLOP, to dispense in small amounts [v]\n",
  "DOLLOPING": "DOLLOP, to dispense in small amounts [v]\n",
  "DOLLOPS": "DOLLOP, to dispense in small amounts [v]\n",
  "DOLLS": "DOLL, to dress stylishly [v]\n",
  "DOLLY": "to move on a wheeled platform [v DOLLIED, DOLLYING, DOLLIES]\n",
  "DOLLYBIRD": "an attractive young girl [n -S]\n",
  "DOLLYBIRDS": "DOLLYBIRD, an attractive young girl [n]\n",
  "DOLLYING": "DOLLY, to move on a wheeled platform [v]\n",
  "DOLMA": "(Turkish) a vine or cabbage leaf with a savoury stuffing [n DOLMAS or DOLMADES]\n",
  "DOLMADES": "DOLMA, (Turkish) a vine or cabbage leaf with a savoury stuffing [n]\n",
  "DOLMAN": "(Turkish) a Turkish robe; a hussar's jacket [n -S]\n",
  "DOLMANS": "DOLMAN, (Turkish) a Turkish robe; a hussar's jacket [n]\n",
  "DOLMAS": "DOLMA, (Turkish) a vine or cabbage leaf with a savoury stuffing [n]\n",
  "DOLMEN": "a prehistoric structure or tomb of unhewn stones [n -S]\n",
  "DOLMENIC": "like a dolmen, a prehistoric structure or tomb of unhewn stones [adj]\n",
  "DOLMENS": "DOLMEN, a prehistoric structure or tomb of unhewn stones [n]\n",
  "DOLOMITE": "a mineral, double carbonate of calcium and magnesium; a rock composed of that mineral, magnesian limestone [n -S]\n",
  "DOLOMITES": "DOLOMITE, a mineral, double carbonate of calcium and magnesium; a rock composed of that mineral, magnesian limestone [n]\n",
  "DOLOMITIC": "pertaining to dolomite, a carbonate sedimentary rock [adj]\n",
  "DOLOMITISATION": "the process of converting into dolomite, also DOLOMITIZATION [n -S]\n",
  "DOLOMITISATIONS": "DOLOMITISATION, the process of converting into dolomite, also DOLOMITIZATION [n]\n",
  "DOLOMITISE": "to convert into dolomite, also DOLOMITIZE [v DOLOMITISED, DOLOMITISING, DOLOMITISES]\n",
  "DOLOMITISED": "DOLOMITISE, to convert into dolomite, also DOLOMITIZE [v]\n",
  "DOLOMITISES": "DOLOMITISE, to convert into dolomite, also DOLOMITIZE [v]\n",
  "DOLOMITISING": "DOLOMITISE, to convert into dolomite, also DOLOMITIZE [v]\n",
  "DOLOMITIZATION": "the process of converting into dolomite, also DOLOMITISATION [n -S]\n",
  "DOLOMITIZATIONS": "DOLOMITIZATION, the process of converting into dolomite, also DOLOMITISATION [n]\n",
  "DOLOMITIZE": "to convert into dolomite, also DOLOMITISE [v DOLOMITIZED, DOLOMITIZING, DOLOMITIZES]\n",
  "DOLOMITIZED": "DOLOMITIZE, to convert into dolomite, also DOLOMITISE [v]\n",
  "DOLOMITIZES": "DOLOMITIZE, to convert into dolomite, also DOLOMITISE [v]\n",
  "DOLOMITIZING": "DOLOMITIZE, to convert into dolomite, also DOLOMITISE [v]\n",
  "DOLOR": "grief, also DOLOUR [n -S]\n",
  "DOLORIFEROUS": "bearing grief or pain, also DOLORIFIC [adj]\n",
  "DOLORIFIC": "bearing grief or pain, also DOLORIFEROUS [adj]\n",
  "DOLORIMETRIES": "DOLORIMETRY, the measurement of pain [n]\n",
  "DOLORIMETRY": "the measurement of pain [n DOLORIMETRIES]\n",
  "DOLOROSO": "(Italian) having a mournful musical quality [adj]\n",
  "DOLOROUS": "full of pain or grief; doleful [adj DOLOROUSLY]\n",
  "DOLOROUSLY": "DOLOROUS, full of pain or grief; doleful [adv]\n",
  "DOLOROUSNESS": "the state of being dolorous [n -ES]\n",
  "DOLOROUSNESSES": "DOLOROUSNESS, the state of being dolorous [n]\n",
  "DOLORS": "DOLOR, grief, also DOLOUR [n]\n",
  "DOLOS": "(South African) the knucklebone of a sheep used by diviners [n DOLOSSE]\n",
  "DOLOSSE": "DOLOS, (South African) the knucklebone of a sheep used by diviners [n]\n",
  "DOLOSTONE": "a rock composed of dolomite [n -S]\n",
  "DOLOSTONES": "DOLOSTONE, a rock composed of dolomite [n]\n",
  "DOLOUR": "grief, also DOLOR [n -S]\n",
  "DOLOURS": "DOLOUR, grief, also DOLOR [n]\n",
  "DOLPHIN": "any of a group of small toothed whales belonging to the family Delphinidae [n -S]\n",
  "DOLPHINARIA": "DOLPHINARIUM, a place where dolphins are kept [n]\n",
  "DOLPHINARIUM": "a place where dolphins are kept [n DOLPHINARIA or DOLPHINARIUMS]\n",
  "DOLPHINARIUMS": "DOLPHINARIUM, a place where dolphins are kept [n]\n",
  "DOLPHINET": "(Spenser) a female dolphin [n -S]\n",
  "DOLPHINETS": "DOLPHINET, (Spenser) a female dolphin [n]\n",
  "DOLPHINFISH": "a fish of genus Coryphaea, noted for the brilliance of its colours [n -ES]\n",
  "DOLPHINFISHES": "DOLPHINFISH, a fish of genus Coryphaea, noted for the brilliance of its colours [n]\n",
  "DOLPHINS": "DOLPHIN, any of a group of small toothed whales belonging to the family Delphinidae [n]\n",
  "DOLS": "DOL, a unit of pain intensity [n]\n",
  "DOLT": "a stupid person [n -S]\n",
  "DOLTISH": "like a dolt [adj DOLTISHLY]\n",
  "DOLTISHLY": "DOLTISH, like a dolt [adv]\n",
  "DOLTISHNESS": "the state of being doltish [n -ES]\n",
  "DOLTISHNESSES": "DOLTISHNESS, the state of being doltish [n]\n",
  "DOLTS": "DOLT, a stupid person [n]\n",
  "DOM": "a title given to certain monks [n -S]\n",
  "DOMAIN": "an area of control [n -S]\n",
  "DOMAINAL": "of a domain, also DOMANIAL [adj]\n",
  "DOMAINE": "(French) an estate where wine is made [n -S]\n",
  "DOMAINES": "DOMAINE, (French) an estate where wine is made [n]\n",
  "DOMAINS": "DOMAIN, an area of control [n]\n",
  "DOMAL": "shaped like a dome, also DOMIC, DOMICAL [adj]\n",
  "DOMANIAL": "of a domain, also DOMAINAL [adj]\n",
  "DOMATIA": "DOMATIUM, (Greek) a plant-structure that harbours mites [n]\n",
  "DOMATIUM": "(Greek) a plant-structure that harbours mites [n DOMATIA]\n",
  "DOME": "to cover with a rounded roof [v DOMED, DOMING, DOMES]\n",
  "DOMED": "DOME, to cover with a rounded roof [v]\n",
  "DOMELIKE": "resembling a dome [adj]\n",
  "DOMES": "DOME, to cover with a rounded roof [v]\n",
  "DOMESDAY": "a day of judgment, also DOOMSDAY [n -S]\n",
  "DOMESDAYS": "DOMESDAY, a day of judgment, also DOOMSDAY [n]\n",
  "DOMESTIC": "related to the home [adj DOMESTICALLY] / a household servant [n -S]\n",
  "DOMESTICABLE": "capable of being domesticated [adj]\n",
  "DOMESTICAL": "(archaic) domestic [adj]\n",
  "DOMESTICALLY": "DOMESTICAL, (archaic) domestic [adv]\n",
  "DOMESTICATE": "to bring into domestic use [v DOMESTICATED, DOMESTICATING, DOMESTICATES]\n",
  "DOMESTICATED": "DOMESTICATE, to bring into domestic use [v]\n",
  "DOMESTICATES": "DOMESTICATE, to bring into domestic use [v]\n",
  "DOMESTICATING": "DOMESTICATE, to bring into domestic use [v]\n",
  "DOMESTICATION": "the act of domesticating [n -S]\n",
  "DOMESTICATIONS": "DOMESTICATION, the act of domesticating [n]\n",
  "DOMESTICATIVE": "relating to domestication [adj]\n",
  "DOMESTICATOR": "one who domesticates [n -S]\n",
  "DOMESTICATORS": "DOMESTICATOR, one who domesticates [n]\n",
  "DOMESTICISE": "to make domestic, also DOMESTICIZE [v DOMESTICISED, DOMESTICISING, DOMESTICISES]\n",
  "DOMESTICISED": "DOMESTICISE, to make domestic, also DOMESTICIZE [v]\n",
  "DOMESTICISES": "DOMESTICISE, to make domestic, also DOMESTICIZE [v]\n",
  "DOMESTICISING": "DOMESTICISE, to make domestic, also DOMESTICIZE [v]\n",
  "DOMESTICITIES": "DOMESTICITY, the state of being domestic or domesticated [n]\n",
  "DOMESTICITY": "the state of being domestic or domesticated [n DOMESTICITIES]\n",
  "DOMESTICIZE": "to make domestic, also DOMESTICISE [v DOMESTICIZED, DOMESTICIZING, DOMESTICIZES]\n",
  "DOMESTICIZED": "DOMESTICIZE, to make domestic, also DOMESTICISE [v]\n",
  "DOMESTICIZES": "DOMESTICIZE, to make domestic, also DOMESTICISE [v]\n",
  "DOMESTICIZING": "DOMESTICIZE, to make domestic, also DOMESTICISE [v]\n",
  "DOMESTICS": "DOMESTIC, a household servant [n]\n",
  "DOMESTIQUE": "a cyclist whose job is to support the higher-ranking members of the team [n -S]\n",
  "DOMESTIQUES": "DOMESTIQUE, a cyclist whose job is to support the higher-ranking members of the team [n]\n",
  "DOMETT": "a type of plain cloth [n -S]\n",
  "DOMETTS": "DOMETT, a type of plain cloth [n]\n",
  "DOMIC": "shaped like a dome, also DOMAL, DOMICAL [adj]\n",
  "DOMICAL": "shaped like a dome, also DOMIC, DOMAL [adj]\n",
  "DOMICALLY": "DOMICAL, shaped like a dome, also DOMIC, DOMAL [adv]\n",
  "DOMICIL": "to establish in a residence, also DOMICILE [v -ED, -ING, -S]\n",
  "DOMICILE": "to establish in a residence, also DOMICIL [v DOMICILED, DOMICILING, DOMICILES]\n",
  "DOMICILED": "DOMICIL, to establish in a residence, also DOMICILE [v]\n",
  "DOMICILES": "DOMICILE, to establish in a residence, also DOMICIL [v]\n",
  "DOMICILIARY": "of or pertaining to a domicile [adj]\n",
  "DOMICILIATE": "to establish in a permanent residence [v DOMICILIATED, DOMICILIATING, DOMICILIATES]\n",
  "DOMICILIATED": "DOMICILIATE, to establish in a permanent residence [v]\n",
  "DOMICILIATES": "DOMICILIATE, to establish in a permanent residence [v]\n",
  "DOMICILIATING": "DOMICILIATE, to establish in a permanent residence [v]\n",
  "DOMICILIATION": "the act of domiciliating [n -S]\n",
  "DOMICILIATIONS": "DOMICILIATION, the act of domiciliating [n]\n",
  "DOMICILING": "DOMICIL, to establish in a residence, also DOMICILE [v]\n",
  "DOMICILS": "DOMICIL, to establish in a residence, also DOMICILE [v]\n",
  "DOMIER": "DOMY, like a dome [adj]\n",
  "DOMIEST": "DOMY, like a dome [adj]\n",
  "DOMINANCE": "the state of being dominant, also DOMINANCY [n -S]\n",
  "DOMINANCES": "DOMINANCE, the state of being dominant, also DOMINANCY [n]\n",
  "DOMINANCIES": "DOMINANCY, the state of being dominant, also DOMINANCE [n]\n",
  "DOMINANCY": "the state of being dominant, also DOMINANCE [n DOMINANCIES]\n",
  "DOMINANT": "controlling [adj DOMINANTLY] / a controlling genetic character [n -S]\n",
  "DOMINANTLY": "DOMINANT, controlling [adv]\n",
  "DOMINANTS": "DOMINANT, a controlling genetic character [n]\n",
  "DOMINATE": "to control [v DOMINATED, DOMINATING, DOMINATES]\n",
  "DOMINATED": "DOMINATE, to control [v]\n",
  "DOMINATES": "DOMINATE, to control [v]\n",
  "DOMINATING": "DOMINATE, to control [v]\n",
  "DOMINATINGLY": "DOMINATING, DOMINATE, to control [adv]\n",
  "DOMINATION": "supremacy or preeminence over another [n -S]\n",
  "DOMINATIONS": "DOMINATION, supremacy or preeminence over another [n]\n",
  "DOMINATIVE": "governing; ruling; imperious [adj]\n",
  "DOMINATOR": "a ruler or ruling power [n -S]\n",
  "DOMINATORS": "DOMINATOR, a ruler or ruling power [n]\n",
  "DOMINATRICES": "DOMINATRIX, a prostitute catering for masochists [n]\n",
  "DOMINATRIX": "a prostitute catering for masochists [n DOMINATRIXES or DOMINATRICES]\n",
  "DOMINATRIXES": "DOMINATRIX, a prostitute catering for masochists [n]\n",
  "DOMINE": "a member of the clergy, a pastor; esp. a pastor of the Dutch Reformed Church, also DOMINEE [n -S]\n",
  "DOMINEE": "a minister of the Dutch Reformed Church or other Afrikaner church, also DOMINE [n -S]\n",
  "DOMINEER": "to be overbearing [v -ED, -ING, -S]\n",
  "DOMINEERED": "DOMINEER, to be overbearing [v]\n",
  "DOMINEERING": "DOMINEER, to be overbearing [v]\n",
  "DOMINEERINGLY": "DOMINEERING, DOMINEER, to be overbearing [adv]\n",
  "DOMINEERINGNESS": "the state of being domineering [n]\n",
  "DOMINEERS": "DOMINEER, to be overbearing [v]\n",
  "DOMINEES": "DOMINEE, a minister of the Dutch Reformed Church or other Afrikaner church, also DOMINE [n]\n",
  "DOMINES": "DOMINE, a member of the clergy, a pastor; esp. a pastor of the Dutch Reformed Church, also DOMINEE [n]\n",
  "DOMING": "DOME, to cover with a rounded roof [v]\n",
  "DOMINICAL": "indicating, or pertaining to, the Lord's day, or Sunday [adj]\n",
  "DOMINICK": "one of an American breed of chickens, also DOMINICKER, DOMINIQUE [n -S]\n",
  "DOMINICKER": "one of an American breed of chickens, also DOMINICK, DOMINIQUE [n -S]\n",
  "DOMINICKERS": "DOMINICKER, one of an American breed of chickens, also DOMINICK, DOMINIQUE [n]\n",
  "DOMINICKS": "DOMINICK, one of an American breed of chickens, also DOMINICKER, DOMINIQUE [n]\n",
  "DOMINIE": "a schoolmaster, a tutor [n -S]\n",
  "DOMINIES": "DOMINIE, a schoolmaster, a tutor [n]\n",
  "DOMINION": "supreme authority [n -S]\n",
  "DOMINIONS": "DOMINION, supreme authority [n]\n",
  "DOMINIQUE": "(French) one of an American breed of chickens, also DOMINICK, DOMINICKER [n -S]\n",
  "DOMINIQUES": "DOMINIQUE, (French) one of an American breed of chickens, also DOMINICK, DOMINICKER [n]\n",
  "DOMINIUM": "(Latin) the right of ownership and control of property [n -S]\n",
  "DOMINIUMS": "DOMINIUM, (Latin) the right of ownership and control of property [n]\n",
  "DOMINO": "a small mask [n DOMINOS or DOMINOES]\n",
  "DOMINOES": "DOMINO, a small mask [n]\n",
  "DOMINOS": "DOMINO, a small mask [n]\n",
  "DOMOIC": "as in domoic acid, a poisonous amino acid found in marine algae [adj]\n",
  "DOMS": "DOM, a title given to certain monks [n]\n",
  "DOMY": "like a dome [adj DOMIER, DOMIEST]\n",
  "DON": "to put on [v DONNED, DONNING, DONS]\n",
  "DONA": "(Spanish) a Spanish lady, also DONAH [n -S]\n",
  "DONAH": "(Spanish) feminine of don, the title, also DONA [n -S]\n",
  "DONAHS": "DONAH, (Spanish) feminine of don, the title, also DONA [n]\n",
  "DONAIR": "(Canadian) sliced lamb rolled in pita bread [n -S]\n",
  "DONAIRS": "DONAIR, (Canadian) sliced lamb rolled in pita bread [n]\n",
  "DONARIES": "DONARY, a thing given to sacred use [n]\n",
  "DONARY": "a thing given to sacred use [n DONARIES]\n",
  "DONAS": "DONA, (Spanish) a Spanish lady, also DONAH [n]\n",
  "DONATARIES": "DONATARY, a person who is given crown lands [n]\n",
  "DONATARY": "a person who is given crown lands [n DONATARIES]\n",
  "DONATE": "to contribute [v DONATED, DONATING, DONATES]\n",
  "DONATED": "DONATE, to contribute [v]\n",
  "DONATES": "DONATE, to contribute [v]\n",
  "DONATING": "DONATE, to contribute [v]\n",
  "DONATION": "something donated [n -S]\n",
  "DONATIONS": "DONATION, something donated [n]\n",
  "DONATISM": "the tenets of the Donatists, a schismatic body of North African Christians [n -S]\n",
  "DONATISMS": "DONATISM, the tenets of the Donatists, a schismatic body of North African Christians [n]\n",
  "DONATISTIC": "pertaining to donatism, also DONATISTICAL [adj]\n",
  "DONATISTICAL": "pertaining to donatism, also DONATISTIC [adj]\n",
  "DONATIVE": "a benefice presented to church without reference to a bishop [n -S]\n",
  "DONATIVES": "DONATIVE, a benefice presented to church without reference to a bishop [n]\n",
  "DONATOR": "one that donates, also DONOR [n -S]\n",
  "DONATORIES": "DONATORY, a donee of the crown; one to whom, upon certain condition, escheated property is made over, also DONATARY [n]\n",
  "DONATORS": "DONATOR, one that donates, also DONOR [n]\n",
  "DONATORY": "a donee of the crown; one to whom, upon certain condition, escheated property is made over, also DONATARY [n DONATORIES]\n",
  "DONDER": "(South African) to beat up, thrash [v -ED, -ING, -S]\n",
  "DONDERED": "DONDER, (South African) to beat up, thrash [v]\n",
  "DONDERING": "DONDER, (South African) to beat up, thrash [v]\n",
  "DONDERS": "DONDER, (South African) to beat up, thrash [v]\n",
  "DONE": "DO, to perform [v]\n",
  "DONEE": "the person to whom a gift or donation is made [n -S]\n",
  "DONEES": "DONEE, the person to whom a gift or donation is made [n]\n",
  "DONEGAL": "a type of tweed [n -S]\n",
  "DONEGALS": "DONEGAL, a type of tweed [n]\n",
  "DONENESS": "the state of being cooked enough [n -ES]\n",
  "DONENESSES": "DONENESS, the state of being cooked enough [n]\n",
  "DONEPEZIL": "a drug used in the treatment of Alzheimer's disease [n -S]\n",
  "DONEPEZILS": "DONEPEZIL, a drug used in the treatment of Alzheimer's disease [n]\n",
  "DONER": "grilled meat and salad served in pitta bread [n -S]\n",
  "DONERS": "DONER, grilled meat and salad served in pitta bread [n]\n",
  "DONG": "to ring a deep sound [v -ED, -ING, -S]\n",
  "DONGA": "(Zulu) a gully in a veldt [n -S]\n",
  "DONGAS": "DONGA, (Zulu) a gully in a veldt [n]\n",
  "DONGED": "DONG, to ring a deep sound [v]\n",
  "DONGING": "DONG, to ring a deep sound [v]\n",
  "DONGLE": "a security device on computers [n -S]\n",
  "DONGLES": "DONGLE, a security device on computers [n]\n",
  "DONGOLA": "a type of tanned leather designed to resemble kidskin [n -S]\n",
  "DONGOLAS": "DONGOLA, a type of tanned leather designed to resemble kidskin [n]\n",
  "DONGS": "DONG, to ring a deep sound [v]\n",
  "DONING": "(colloquial) the act of donating e.g. blood [n -S]\n",
  "DONINGS": "DONING, (colloquial) the act of donating e.g. blood [n]\n",
  "DONJON": "the main tower of a castle [n -S]\n",
  "DONJONS": "DONJON, the main tower of a castle [n]\n",
  "DONKEY": "the common ass [n -S]\n",
  "DONKEYMAN": "a man with responsibilities in a ship's engine room [n DONKEYMEN]\n",
  "DONKEYMEN": "DONKEYMAN, a man with responsibilities in a ship's engine room [n]\n",
  "DONKEYS": "DONKEY, the common ass [n]\n",
  "DONKEYWORK": "monotonous and routine work [n -S]\n",
  "DONKEYWORKS": "DONKEYWORK, monotonous and routine work [n]\n",
  "DONKO": "(New Zealand) an informal tearoom in a factory [n -S]\n",
  "DONKOS": "DONKO, (New Zealand) an informal tearoom in a factory [n]\n",
  "DONNA": "(Italian) a title given to a lady in Italy [n -S]\n",
  "DONNARD": "(Scots) stupid, dazed, also DONNART, DONNERD, DONNERED, DONNERT [adj]\n",
  "DONNART": "(Scots) stupid, dazed, also DONNARD, DONNERD, DONNERED, DONNERT [adj]\n",
  "DONNAS": "DONNA, (Italian) a title given to a lady in Italy [n]\n",
  "DONNAT": "(dialect) a good-for-nothing, also DONNOT [n -S]\n",
  "DONNATS": "DONNAT, (dialect) a good-for-nothing, also DONNOT [n]\n",
  "DONNE": "(French) a datum, something given, also DONNEE [n -S]\n",
  "DONNED": "DON, to put on [v]\n",
  "DONNEE": "(French) a datum, something given, also DONNE [n -S]\n",
  "DONNEES": "DONNEE, (French) a datum, something given, also DONNE [n]\n",
  "DONNERD": "(Scots) stupid, dull-witted, also DONNARD, DONNART, DONNERED, DONNERT [adj]\n",
  "DONNERED": "(Scots) stupid, dull-witted, also DONNARD, DONNART, DONNERD, DONNERT [adj]\n",
  "DONNERT": "(Scots) stupid, dull-witted, also DONNARD, DONNART, DONNERD, DONNERED [adj]\n",
  "DONNES": "DONNE, (French) a datum, something given, also DONNEE [n]\n",
  "DONNICKER": "an outside lavatory, also DONNIKER [n -S]\n",
  "DONNICKERS": "DONNICKER, an outside lavatory, also DONNIKER [n]\n",
  "DONNIES": "DONNY, (colloquial) the hand, also DANNY [n]\n",
  "DONNIKER": "an outside lavatory, also DUNNY, DUNNAKIN [n -S]\n",
  "DONNIKERS": "DONNIKER, an outside lavatory, also DUNNY, DUNNAKIN [n]\n",
  "DONNING": "DON, to put on [v]\n",
  "DONNISH": "scholarly [adj DONNISHLY]\n",
  "DONNISHLY": "DONNISH, scholarly [adv]\n",
  "DONNISHNESS": "the state of being donnish [n -ES]\n",
  "DONNISHNESSES": "DONNISHNESS, the state of being donnish [n]\n",
  "DONNISM": "self-importance [n -S]\n",
  "DONNISMS": "DONNISM, self-importance [n]\n",
  "DONNOT": "(dialect) an idler, also DONNAT [n -S]\n",
  "DONNOTS": "DONNOT, (dialect) an idler, also DONNAT [n]\n",
  "DONNY": "(colloquial) the hand, also DANNY [n DONNIES]\n",
  "DONNYBROOK": "(Irish) a brawl or heated public dispute [n -S]\n",
  "DONNYBROOKS": "DONNYBROOK, (Irish) a brawl or heated public dispute [n]\n",
  "DONOR": "one that donates, also DONATOR [n -S]\n",
  "DONORS": "DONOR, one that donates, also DONATOR [n]\n",
  "DONORSHIP": "the state of being a donor [n -S]\n",
  "DONORSHIPS": "DONORSHIP, the state of being a donor [n]\n",
  "DONS": "DON, to put on [v]\n",
  "DONSHIP": "the rank of a Spanish nobleman [n -S]\n",
  "DONSHIPS": "DONSHIP, the rank of a Spanish nobleman [n]\n",
  "DONSIE": "(Gaelic) unlucky, also DONSY [adj DONSIER, DONSIEST]\n",
  "DONSIER": "DONSIE, (Gaelic) unlucky, also DONSY [adj]\n",
  "DONSIEST": "DONSIE, (Gaelic) unlucky, also DONSY [adj]\n",
  "DONSY": "(Gaelic) unlucky, also DONSIE [adj]\n",
  "DONUT": "to surround a parliamentary orator to impress TV audiences [v DONUTTED, DONUTTING, DONUTS]\n",
  "DONUTS": "DONUT, to surround a parliamentary orator to impress TV audiences [v]\n",
  "DONUTTED": "DONUT, to surround a parliamentary orator to impress TV audiences [v]\n",
  "DONUTTING": "DONUT, to surround a parliamentary orator to impress TV audiences [v]\n",
  "DONZEL": "(obsolete) a squire, aspirant to knighthood [n -S]\n",
  "DONZELS": "DONZEL, (obsolete) a squire, aspirant to knighthood [n]\n",
  "DOO": "(Scots) a dove or pigeon [n -S]\n",
  "DOOB": "(Hindi) dog's tooth grass, prized as food for cattle [n -S]\n",
  "DOOBIE": "a marijuana cigarette [n -S]\n",
  "DOOBIES": "DOOBIE, a marijuana cigarette [n]\n",
  "DOOBREY": "a thing whose name is unknown or temporarily forgotten, a what's-its-name, also DOOBRIE [n -S]\n",
  "DOOBREYS": "DOOBREY, a thing whose name is unknown or temporarily forgotten, a what's-its-name, also DOOBRIE [n]\n",
  "DOOBRIE": "a thing whose name is unknown or temporarily forgotten, a what's-its-name, also DOOBREY, DOOBRY [n -S]\n",
  "DOOBRIES": "DOOBRIE, a thing whose name is unknown or temporarily forgotten, a what's-its-name, also DOOBREY, DOOBRY [n]\n",
  "DOOBRY": "a thing whose name is unknown or temporarily forgotten, a what's-its-name, also DOOBREY, DOOBRIE [n DOOBRIES]\n",
  "DOOBS": "DOOB, (Hindi) dog's tooth grass, prized as food for cattle [n]\n",
  "DOOCE": "to dismiss (an employee) as a result of unguarded remarks published on the World Wide Web [v DOOCED, DOOCING, DOOCES]\n",
  "DOOCED": "DOOCE, to dismiss (an employee) as a result of unguarded remarks published on the World Wide Web [v]\n",
  "DOOCES": "DOOCE, to dismiss (an employee) as a result of unguarded remarks published on the World Wide Web [v]\n",
  "DOOCING": "DOOCE, to dismiss (an employee) as a result of unguarded remarks published on the World Wide Web [v]\n",
  "DOOCOT": "(Scots) a dovecote, also DOOKET, DOVECOT, DOVECOTE [n -S]\n",
  "DOOCOTS": "DOOCOT, (Scots) a dovecote, also DOOKET, DOVECOT, DOVECOTE [n]\n",
  "DOODAD": "something whose name one has forgotten, also DOODAH [n -S]\n",
  "DOODADS": "DOODAD, something whose name one has forgotten, also DOODAH [n]\n",
  "DOODAH": "something whose name one has forgotten, also DOODAD [n -S]\n",
  "DOODAHS": "DOODAH, something whose name one has forgotten, also DOODAD [n]\n",
  "DOODIES": "DOODY, a childish word for excrement, also DOODOO [n]\n",
  "DOODLE": "to scribble aimlessly [v DOODLED, DOODLING, DOODLES]\n",
  "DOODLEBUG": "the larva of an antlion or other insect; (colloquial) a flying bomb of the 1939-45 war [n -S]\n",
  "DOODLEBUGS": "DOODLEBUG, the larva of an antlion or other insect; (colloquial) a flying bomb of the 1939-45 war [n]\n",
  "DOODLED": "DOODLE, to scribble aimlessly [v]\n",
  "DOODLER": "one that doodles [n -S]\n",
  "DOODLERS": "DOODLER, one that doodles [n]\n",
  "DOODLES": "DOODLE, to scribble aimlessly [v]\n",
  "DOODLING": "DOODLE, to scribble aimlessly [v]\n",
  "DOODOO": "a childish word for excrement, also DOODY [n -S]\n",
  "DOODOOS": "DOODOO, a childish word for excrement, also DOODY [n]\n",
  "DOODY": "a childish word for excrement, also DOODOO [n DOODIES]\n",
  "DOOFER": "a thingummybob The name will 'do for now' [n -S]\n",
  "DOOFERS": "DOOFER, a thingummybob The name will 'do for now' [n]\n",
  "DOOFUS": "a stupid person, also DUFUS [n -ES]\n",
  "DOOFUSES": "DOOFUS, a stupid person, also DUFUS [n]\n",
  "DOOHICKEY": "a doodad, a thingy [n DOOHICKIES or DOOHICKEYS]\n",
  "DOOHICKEYS": "DOOHICKEY, a doodad, a thingy [n]\n",
  "DOOHICKIES": "DOOHICKEY, a doodad, a thingy [n]\n",
  "DOOK": "(Scots) to duck, bathe, also DOUK [v -ED, -ING, -S]\n",
  "DOOKED": "DOOK, (Scots) to duck, bathe, also DOUK [v]\n",
  "DOOKET": "(Scots) a dovecote, also DOOCOT, DOVECOT, DOVECOTE [n -S]\n",
  "DOOKETS": "DOOKET, (Scots) a dovecote, also DOOCOT, DOVECOT, DOVECOTE [n]\n",
  "DOOKING": "DOOK, (Scots) to duck, bathe, also DOUK [v]\n",
  "DOOKS": "DOOK, (Scots) to duck, bathe, also DOUK [v]\n",
  "DOOL": "(obsolete) pain, woe, trouble, also DOLE, DOOLE, DULE [n -S]\n",
  "DOOLALLY": "(Hindi) crazy, deranged [adj]\n",
  "DOOLAN": "(New Zealand) a Roman Catholic [n -S]\n",
  "DOOLANS": "DOOLAN, (New Zealand) a Roman Catholic [n]\n",
  "DOOLE": "(obsolete) pain, woe, trouble, also DOLE, DOOL, DULE [n -S]\n",
  "DOOLEE": "(Hindi) a litter or palanquin, also DHOOLY, DOOLIE, DOOLY [n -S]\n",
  "DOOLEES": "DOOLEE, (Hindi) a litter or palanquin, also DHOOLY, DOOLIE, DOOLY [n]\n",
  "DOOLES": "DOOLE, (obsolete) pain, woe, trouble, also DOLE, DOOL, DULE [n]\n",
  "DOOLIE": "(Hindi) a litter or palanquin, also DHOOLY, DOOLEE, DOOLY [n -S]\n",
  "DOOLIES": "DOOLY, (Hindi) a litter or palanquin, also DHOOLY, DOOLEE, DOOLIE [n]\n",
  "DOOLS": "DOOL, (obsolete) pain, woe, trouble, also DOLE, DOOLE, DULE [n]\n",
  "DOOLY": "(Hindi) a litter or palanquin, also DHOOLY, DOOLEE, DOOLIE [n DOOLIES]\n",
  "DOOM": "to condemn to catastrophe [v -ED, -ING, -S]\n",
  "DOOMED": "DOOM, to condemn to catastrophe [v]\n",
  "DOOMFUL": "(Spenser) dispensing judgment [adj DOOMFULLY]\n",
  "DOOMFULLY": "DOOMFUL, (Spenser) dispensing judgment [adv]\n",
  "DOOMIER": "DOOMY, depressed [adj]\n",
  "DOOMIEST": "DOOMY, depressed [adj]\n",
  "DOOMILY": "ominously [adv]\n",
  "DOOMING": "DOOM, to condemn to catastrophe [v]\n",
  "DOOMS": "DOOM, to condemn to catastrophe [v]\n",
  "DOOMSAYER": "one who prophesies doom, also DOOMSDAYER [n -S]\n",
  "DOOMSAYERS": "DOOMSAYER, one who prophesies doom, also DOOMSDAYER [n]\n",
  "DOOMSAYING": "the act of prophesying doom [n -S]\n",
  "DOOMSAYINGS": "DOOMSAYING, the act of prophesying doom [n]\n",
  "DOOMSDAY": "a day of judgment, also DOMESDAY [n -S]\n",
  "DOOMSDAYER": "one who prophesies doom, also DOOMSAYER [n -S]\n",
  "DOOMSDAYERS": "DOOMSDAYER, one who prophesies doom, also DOOMSAYER [n]\n",
  "DOOMSDAYS": "DOOMSDAY, a day of judgment, also DOMESDAY [n]\n",
  "DOOMSMAN": "one who pronounces doom [n DOOMSMEN]\n",
  "DOOMSMEN": "DOOMSMAN, one who pronounces doom [n]\n",
  "DOOMSTER": "(Scots) formerly in Scotland, an officer who repeated the sentence after the judge, also DEEMSTER, DEMPSTER, DOOMSMAN [n -S]\n",
  "DOOMSTERS": "DOOMSTER, (Scots) formerly in Scotland, an officer who repeated the sentence after the judge, also DEEMSTER, DEMPSTER, DOOMSMAN [n]\n",
  "DOOMWATCH": "to keep an eye on the state of the environment [v -ED, -ING, -ES]\n",
  "DOOMWATCHED": "DOOMWATCH, to keep an eye on the state of the environment [v]\n",
  "DOOMWATCHER": "one who engages in doomwatching [n -S]\n",
  "DOOMWATCHERS": "DOOMWATCHER, one who engages in doomwatching [n]\n",
  "DOOMWATCHES": "DOOMWATCH, to keep an eye on the state of the environment [v]\n",
  "DOOMWATCHING": "the act of keeping an eye on the environment [n -S]\n",
  "DOOMWATCHINGS": "DOOMWATCHING, the act of keeping an eye on the environment [n]\n",
  "DOOMY": "depressed [adj DOOMIER, DOOMIEST, DOOMILY]\n",
  "DOON": "(Scots) down, also DOUN [adv]\n",
  "DOONA": "(Australian) a continental quilt (orig. a trademark) [n -S]\n",
  "DOONAS": "DOONA, (Australian) a continental quilt (orig. a trademark) [n]\n",
  "DOOR": "an entrance that opens and closes [n -S]\n",
  "DOORBELL": "a bell at the door [n -S]\n",
  "DOORBELLS": "DOORBELL, a bell at the door [n]\n",
  "DOORCASE": "the frame of a door [n -S]\n",
  "DOORCASES": "DOORCASE, the frame of a door [n]\n",
  "DOORED": "having a door [adj]\n",
  "DOORFRAME": "the frame of a door [n -S]\n",
  "DOORFRAMES": "DOORFRAME, the frame of a door [n]\n",
  "DOORJAMB": "one of the two vertical members forming the sides of a doorframe, aka doorpost [n -S]\n",
  "DOORJAMBS": "DOORJAMB, one of the two vertical members forming the sides of a doorframe, aka doorpost [n]\n",
  "DOORKEEPER": "a person who tends a door [n -S]\n",
  "DOORKEEPERS": "DOORKEEPER, a person who tends a door [n]\n",
  "DOORKNOB": "a handle for opening a door [n -S]\n",
  "DOORKNOBS": "DOORKNOB, a handle for opening a door [n]\n",
  "DOORKNOCK": "a fundraising appeal in which people go from door to door [n -S] / to go from door to door [v -ED, -ING, -S]\n",
  "DOORKNOCKED": "DOORKNOCK, to go from door to door [v]\n",
  "DOORKNOCKER": "a knocker on a door [n -S]\n",
  "DOORKNOCKERS": "DOORKNOCKER, a knocker on a door [n]\n",
  "DOORKNOCKING": "DOORKNOCK, to go from door to door [v]\n",
  "DOORKNOCKS": "DOORKNOCK, to go from door to door [v]\n",
  "DOORLESS": "having no door [adj]\n",
  "DOORLIKE": "like a door [adj]\n",
  "DOORMAN": "a porter, a doorkeeper, also DOORSMAN [n DOORMEN]\n",
  "DOORMAT": "a mat in front of a door [n -S]\n",
  "DOORMATS": "DOORMAT, a mat in front of a door [n]\n",
  "DOORMEN": "DOORMAN, a porter, a doorkeeper, also DOORSMAN [n]\n",
  "DOORN": "(South African) a thorn [n -S]\n",
  "DOORNAIL": "a large-headed nail [n -S]\n",
  "DOORNAILS": "DOORNAIL, a large-headed nail [n]\n",
  "DOORNBOOM": "(South African) a kind of acacia tree [n -S]\n",
  "DOORNBOOMS": "DOORNBOOM, (South African) a kind of acacia tree [n]\n",
  "DOORNS": "DOORN, (South African) a thorn [n]\n",
  "DOORPLATE": "a plate on a door with a householder's name on it [n -S]\n",
  "DOORPLATES": "DOORPLATE, a plate on a door with a householder's name on it [n]\n",
  "DOORPOST": "one of the two vertical members forming the sides of a doorframe, also DOORJAMB [n -S]\n",
  "DOORPOSTS": "DOORPOST, one of the two vertical members forming the sides of a doorframe, also DOORJAMB [n]\n",
  "DOORS": "DOOR, an entrance that opens and closes [n]\n",
  "DOORSILL": "the sill of a door [n -S]\n",
  "DOORSILLS": "DOORSILL, the sill of a door [n]\n",
  "DOORSMAN": "a porter, a doorkeeper, also DOORMAN [n DOORSMEN]\n",
  "DOORSMEN": "DOORSMAN, a porter, a doorkeeper, also DOORMAN [n]\n",
  "DOORSTEP": "to canvass door to door [v DOORSTEPPED, DOORSTEPPING, DOORSTEPS]\n",
  "DOORSTEPPED": "DOORSTEP, to canvass door to door [v]\n",
  "DOORSTEPPER": "a salesman who tries to sell on the doorstep [n -S]\n",
  "DOORSTEPPERS": "DOORSTEPPER, a salesman who tries to sell on the doorstep [n]\n",
  "DOORSTEPPING": "going from door to door canvassing [n -S]\n",
  "DOORSTEPPINGS": "DOORSTEPPING, going from door to door canvassing [n]\n",
  "DOORSTEPS": "DOORSTEP, to canvass door to door [v]\n",
  "DOORSTONE": "the stone forming a threshold [n -S]\n",
  "DOORSTONES": "DOORSTONE, the stone forming a threshold [n]\n",
  "DOORSTOP": "an object used for holding open a door [n -S]\n",
  "DOORSTOPS": "DOORSTOP, an object used for holding open a door [n]\n",
  "DOORWAY": "the entrance to a house or building [n -S]\n",
  "DOORWAYS": "DOORWAY, the entrance to a house or building [n]\n",
  "DOORWOMAN": "a female doorman [n DOORWOMEN]\n",
  "DOORWOMEN": "DOORWOMAN, a female doorman [n]\n",
  "DOORYARD": "a yard in front of a house [n -S]\n",
  "DOORYARDS": "DOORYARD, a yard in front of a house [n]\n",
  "DOOS": "(South African) a foolish or despicable person [n -ES]\n",
  "DOOSES": "DOOS, (South African) a foolish or despicable person [n]\n",
  "DOOSRA": "(Urdu) a delivery bowled by an off-spinner [n -S]\n",
  "DOOSRAS": "DOOSRA, (Urdu) a delivery bowled by an off-spinner [n]\n",
  "DOOWOP": "a style of singing in harmony [n -S]\n",
  "DOOWOPS": "DOOWOP, a style of singing in harmony [n]\n",
  "DOOZER": "an extraordinary one of its kind, also DOOZIE, DOOZY [n -S]\n",
  "DOOZERS": "DOOZER, an extraordinary one of its kind, also DOOZIE, DOOZY [n]\n",
  "DOOZIE": "an extraordinary one of its kind, also DOOZER, DOOZY [n -S]\n",
  "DOOZIES": "DOOZY, an extraordinary one of its kind, also DOOZER, DOOZIE [n]\n",
  "DOOZY": "an extraordinary one of its kind, also DOOZER, DOOZIE [n DOOZIES]\n",
  "DOP": "to dip [v DOPPED, DOPPING, DOPS]\n",
  "DOPA": "a drug used to treat Parkinson's disease [n -S]\n",
  "DOPAMINE": "a chemical found in brain tissue that acts as a neurotransmitter [n -S]\n",
  "DOPAMINERGIC": "liberating, activated by, or involving dopamine or related substances [adj]\n",
  "DOPAMINES": "DOPAMINE, a chemical found in brain tissue that acts as a neurotransmitter [n]\n",
  "DOPANT": "in electronics, an impurity added to a pure substance [n -S]\n",
  "DOPANTS": "DOPANT, in electronics, an impurity added to a pure substance [n]\n",
  "DOPAS": "DOPA, a drug used to treat Parkinson's disease [n]\n",
  "DOPATTA": "(Hindi) a silk or muslin shawl, also DUPATTA [n -S]\n",
  "DOPATTAS": "DOPATTA, (Hindi) a silk or muslin shawl, also DUPATTA [n]\n",
  "DOPE": "excellent [adj DOPER, DOPEST] / to give a narcotic to [v DOPED, DOPING, DOPES]\n",
  "DOPED": "DOPE, to give a narcotic to [v]\n",
  "DOPEHEAD": "a drug addict [n -S]\n",
  "DOPEHEADS": "DOPEHEAD, a drug addict [n]\n",
  "DOPER": "one who dopes [n -S]\n",
  "DOPERS": "DOPER, one who dopes [n]\n",
  "DOPES": "DOPE, to give a narcotic to [v]\n",
  "DOPESHEET": "a document giving information on horse races [n -S]\n",
  "DOPESHEETS": "DOPESHEET, a document giving information on horse races [n]\n",
  "DOPEST": "DOPE, excellent [adj]\n",
  "DOPESTER": "one who predicts the outcomes of contests [n -S]\n",
  "DOPESTERS": "DOPESTER, one who predicts the outcomes of contests [n]\n",
  "DOPEY": "lethargic; stupid, also DOPY [adj DOPIER, DOPIEST]\n",
  "DOPEYNESS": "the state of being dopey [n -ES]\n",
  "DOPEYNESSES": "DOPEYNESS, the state of being dopey [n]\n",
  "DOPIAZA": "an Indian dish, meat or fish in onion sauce [n -S]\n",
  "DOPIAZAS": "DOPIAZA, an Indian dish, meat or fish in onion sauce [n]\n",
  "DOPIER": "DOPY, lethargic; stupid, also DOPEY [adj]\n",
  "DOPIEST": "DOPY, lethargic; stupid, also DOPEY [adj]\n",
  "DOPILY": "DOPY, lethargic; stupid, also DOPEY [adv]\n",
  "DOPINESS": "the state of being dopy [n -ES]\n",
  "DOPINESSES": "DOPINESS, the state of being dopy [n]\n",
  "DOPING": "the act of doping [n -S]\n",
  "DOPINGS": "DOPING, the act of doping [n]\n",
  "DOPPED": "DOP, to dip [v]\n",
  "DOPPELGANGER": "(German) a ghostly counterpart of a living person [n -S]\n",
  "DOPPELGANGERS": "DOPPELGANGER, (German) a ghostly counterpart of a living person [n]\n",
  "DOPPER": "a little grebe, also DIDAPPER [n -S]\n",
  "DOPPERS": "DOPPER, a little grebe, also DIDAPPER [n]\n",
  "DOPPIE": "(South African) a cartridge-case [n -S]\n",
  "DOPPIES": "DOPPIE, (South African) a cartridge-case [n]\n",
  "DOPPING": "a flock of sheldrake [n -S]\n",
  "DOPPINGS": "DOPPING, a flock of sheldrake [n]\n",
  "DOPPIO": "(Italian) a double measure of espresso coffee [n -S]\n",
  "DOPPIOS": "DOPPIO, (Italian) a double measure of espresso coffee [n]\n",
  "DOPPLERITE": "a black elastic substance (calcium salts of humus acids) found in peat beds [n -S]\n",
  "DOPPLERITES": "DOPPLERITE, a black elastic substance (calcium salts of humus acids) found in peat beds [n]\n",
  "DOPS": "DOP, to dip [v]\n",
  "DOPY": "lethargic; stupid, also DOPEY [adj DOPIER, DOPIEST, DOPILY]\n",
  "DOR": "to mock, scoff at, also DORR [v DORRED, DORRING, DORS]\n",
  "DORAD": "any member of the fish genus Doras, a bony-plated river fish [n -S]\n",
  "DORADO": "(Spanish) a large edible marine fish, aka coryphene [n -S]\n",
  "DORADOS": "DORADO, (Spanish) a large edible marine fish, aka coryphene [n]\n",
  "DORADS": "DORAD, any member of the fish genus Doras, a bony-plated river fish [n]\n",
  "DORB": "(Australian slang) a stupid or inept person, also DORBA [n -S]\n",
  "DORBA": "(Australian slang) a stupid or inept person, also DORB [n -S]\n",
  "DORBAS": "DORBA, (Australian slang) a stupid or inept person, also DORB [n]\n",
  "DORBEETLE": "a dung-beetle [n -S]\n",
  "DORBEETLES": "DORBEETLE, a dung-beetle [n]\n",
  "DORBS": "DORB, (Australian slang) a stupid or inept person, also DORBA [n]\n",
  "DORBUG": "(US) a cockchafer [n -S]\n",
  "DORBUGS": "DORBUG, (US) a cockchafer [n]\n",
  "DORE": "another name for the fish walleye [n -S]\n",
  "DOREE": "a yellow mackerel, also DORY [n -S]\n",
  "DOREES": "DOREE, a yellow mackerel, also DORY [n]\n",
  "DORES": "DORE, another name for the fish walleye [n]\n",
  "DORHAWK": "(dialect) the nightjar [n -S]\n",
  "DORHAWKS": "DORHAWK, (dialect) the nightjar [n]\n",
  "DORIC": "rustic [adj]\n",
  "DORIDOID": "a shell-less mollusc [n -S]\n",
  "DORIDOIDS": "DORIDOID, a shell-less mollusc [n]\n",
  "DORIES": "DORY, a golden-yellow fish of the mackerel family, also DOREE [n]\n",
  "DORIS": "(slang) a woman [n -ES]\n",
  "DORISE": "(Greek) to become like the Dorians, also DORIZE [v DORISED, DORISING, DORISES]\n",
  "DORISED": "DORISE, (Greek) to become like the Dorians, also DORIZE [v]\n",
  "DORISES": "DORISE, (Greek) to become like the Dorians, also DORIZE [v]\n",
  "DORISING": "DORISE, (Greek) to become like the Dorians, also DORIZE [v]\n",
  "DORIZE": "(Greek) to become like the Dorians, also DORISE [v DORIZED, DORIZING, DORIZES]\n",
  "DORIZED": "DORIZE, (Greek) to become like the Dorians, also DORISE [v]\n",
  "DORIZES": "DORIZE, (Greek) to become like the Dorians, also DORISE [v]\n",
  "DORIZING": "DORIZE, (Greek) to become like the Dorians, also DORISE [v]\n",
  "DORK": "a stupid person [n -S]\n",
  "DORKIER": "DORKY, (slang) idiotic, contemptible [adj]\n",
  "DORKIEST": "DORKY, (slang) idiotic, contemptible [adj]\n",
  "DORKINESS": "the state of being dorky [n -ES]\n",
  "DORKINESSES": "DORKINESS, the state of being dorky [n]\n",
  "DORKISH": "like a dork, idiotic [adj]\n",
  "DORKS": "DORK, a stupid person [n]\n",
  "DORKY": "(slang) idiotic, contemptible [adj DORKIER, DORKIEST]\n",
  "DORLACH": "(Gaelic) a bundle formerly carried on the person by Highland troops [n -S]\n",
  "DORLACHS": "DORLACH, (Gaelic) a bundle formerly carried on the person by Highland troops [n]\n",
  "DORM": "(short for) dormitory [n -S]\n",
  "DORMANCIES": "DORMANCY, a period of suspended growth and metabolic activity [n]\n",
  "DORMANCY": "a period of suspended growth and metabolic activity [n DORMANCIES]\n",
  "DORMANT": "of volcanoes, inactive but not extinct [adj] / a crossbeam, a joist [n -S]\n",
  "DORMANTS": "DORMANT, a crossbeam, a joist [n]\n",
  "DORMER": "a type of gabled window [n -S]\n",
  "DORMERED": "having dormer windows [adj]\n",
  "DORMERS": "DORMER, a type of gabled window [n]\n",
  "DORMICE": "DORMOUSE, any member of a family of rodents related to mice [n]\n",
  "DORMIE": "being ahead in golf by as many holes to be played, also DORMY [adj]\n",
  "DORMIENT": "(archaic) sleeping, dormant [adj]\n",
  "DORMIN": "abscisic acid, a plant hormone, aka ABSCISIN, ABSCISSIN [n -S]\n",
  "DORMINS": "DORMIN, abscisic acid, a plant hormone, aka ABSCISIN, ABSCISSIN [n]\n",
  "DORMITION": "the act of sleeping; falling asleep [n -S]\n",
  "DORMITIONS": "DORMITION, the act of sleeping; falling asleep [n]\n",
  "DORMITIVE": "a soporific, such as opium [n -S]\n",
  "DORMITIVES": "DORMITIVE, a soporific, such as opium [n]\n",
  "DORMITORIES": "DORMITORY, a sleeping room, or a building containing a series of sleeping rooms [n]\n",
  "DORMITORY": "a sleeping room, or a building containing a series of sleeping rooms [n DORMITORIES]\n",
  "DORMOUSE": "any member of a family of rodents related to mice [n DORMICE]\n",
  "DORMS": "DORM, (short for) dormitory [n]\n",
  "DORMY": "being ahead in golf by as many holes to be played, also DORMIE [adj]\n",
  "DORNECK": "a heavy linen fabric, also DORNICK, DORNOCK [n -S]\n",
  "DORNECKS": "DORNECK, a heavy linen fabric, also DORNICK, DORNOCK [n]\n",
  "DORNICK": "a heavy linen fabric, also DORNECK, DORNOCK [n -S]\n",
  "DORNICKS": "DORNICK, a heavy linen fabric, also DORNECK, DORNOCK [n]\n",
  "DORNOCK": "a heavy linen fabric, also DORNECK, DORNICK [n -S]\n",
  "DORNOCKS": "DORNOCK, a heavy linen fabric, also DORNECK, DORNICK [n]\n",
  "DORONICUM": "a flower, leopard's-bane [n -S]\n",
  "DORONICUMS": "DORONICUM, a flower, leopard's-bane [n]\n",
  "DORP": "(South African) a South African village or small town [n -S]\n",
  "DORPER": "a breed of mutton-producing sheep [n -S]\n",
  "DORPERS": "DORPER, a breed of mutton-producing sheep [n]\n",
  "DORPS": "DORP, (South African) a South African village or small town [n]\n",
  "DORR": "(obsolete) to mock, scoff, also DOR [v -ED, -ING, -S]\n",
  "DORRED": "DOR, to mock, scoff at, also DORR [v]\n",
  "DORRING": "DOR, to mock, scoff at, also DORR [v]\n",
  "DORRS": "DORR, (obsolete) to mock, scoff, also DOR [v]\n",
  "DORS": "DOR, to mock, scoff at, also DORR [v]\n",
  "DORSA": "DORSUM, (Latin) the back [n]\n",
  "DORSAD": "toward the dorsum or back [adj]\n",
  "DORSAL": "relating to the back, situated on the back [adj DORSALLY] / a dorsal fin [n -S]\n",
  "DORSALLY": "towards the back [adv]\n",
  "DORSALS": "DORSAL, a dorsal fin [n]\n",
  "DORSE": "a kind of small cod [n -S]\n",
  "DORSEL": "an ornamental cloth hung behind an altar, also DOSSAL, DOSSEL [n -S]\n",
  "DORSELS": "DORSEL, an ornamental cloth hung behind an altar, also DOSSAL, DOSSEL [n]\n",
  "DORSER": "a covering for the back of a throne, also DOSSAL, DOSSEL, DOSSER [n -S]\n",
  "DORSERS": "DORSER, a covering for the back of a throne, also DOSSAL, DOSSEL, DOSSER [n]\n",
  "DORSES": "DORSE, a kind of small cod [n]\n",
  "DORSIBRANCHIATE": "having gills on the back [adj]\n",
  "DORSIFEROUS": "carrying young on the back [adj]\n",
  "DORSIFIXED": "attached at or by the back [adj]\n",
  "DORSIFLEX": "to bend towards the back or dorsal [v -ED, -ING, -ES]\n",
  "DORSIFLEXED": "DORSIFLEX, to bend towards the back or dorsal [v]\n",
  "DORSIFLEXES": "DORSIFLEX, to bend towards the back or dorsal [v]\n",
  "DORSIFLEXING": "DORSIFLEX, to bend towards the back or dorsal [v]\n",
  "DORSIFLEXION": "a bending backwards; a bending of the back [n -S]\n",
  "DORSIFLEXIONS": "DORSIFLEXION, a bending backwards; a bending of the back [n]\n",
  "DORSIGRADE": "walking on the back of the toes [adj]\n",
  "DORSIVENTRAL": "having differentiated opposite faces or surfaces [adj DORSIVENTRALLY]\n",
  "DORSIVENTRALITY": "the state of being dorsiventral [n]\n",
  "DORSIVENTRALLY": "DORSIVENTRAL, having differentiated opposite faces or surfaces [adv]\n",
  "DORSOLATERAL": "of, relating to, or involving both the back and the sides [adj]\n",
  "DORSOLUMBAR": "of or relating to the dorsal and lumbar vertebrae, or the area of the body that they occupy [adj]\n",
  "DORSOVENTRAL": "extending from a dorsal to a ventral surface [adj DORSOVENTRALLY]\n",
  "DORSOVENTRALITY": "the state of being dorsoventral [n]\n",
  "DORSOVENTRALLY": "DORSOVENTRAL, extending from a dorsal to a ventral surface [adv]\n",
  "DORSUM": "(Latin) the back [n DORSA]\n",
  "DORT": "(Scots) to sulk [v -ED, -ING, -S]\n",
  "DORTED": "DORT, (Scots) to sulk [v]\n",
  "DORTER": "(archaic) a dormitory, also DORTOUR [n -S]\n",
  "DORTERS": "DORTER, (archaic) a dormitory, also DORTOUR [n]\n",
  "DORTIER": "DORTY, (Scots) pettish, sulky [adj]\n",
  "DORTIEST": "DORTY, (Scots) pettish, sulky [adj]\n",
  "DORTINESS": "the state of being dorty, pettish, sulky [n -ES]\n",
  "DORTINESSES": "DORTINESS, the state of being dorty, pettish, sulky [n]\n",
  "DORTING": "DORT, (Scots) to sulk [v]\n",
  "DORTOUR": "(archaic) a dormitory, also DORTER [n -S]\n",
  "DORTOURS": "DORTOUR, (archaic) a dormitory, also DORTER [n]\n",
  "DORTS": "DORT, (Scots) to sulk [v]\n",
  "DORTY": "(Scots) pettish, sulky [adj DORTIER, DORTIEST]\n",
  "DORY": "a golden-yellow fish of the mackerel family, also DOREE [n DORIES]\n",
  "DORYMAN": "one that fishes from a dory [n DORYMEN]\n",
  "DORYMEN": "DORYMAN, one that fishes from a dory [n]\n",
  "DOS": "DO, a party, celebration [n]\n",
  "DOSA": "(Hindi) an Indian pancake made from rice flour [n DOSAI or DOSAS]\n",
  "DOSAGE": "the amount of medicine to be given [n -S]\n",
  "DOSAGES": "DOSAGE, the amount of medicine to be given [n]\n",
  "DOSAI": "DOSA, (Hindi) an Indian pancake made from rice flour [n]\n",
  "DOSAS": "DOSA, (Hindi) an Indian pancake made from rice flour [n]\n",
  "DOSE": "to give a measure of medicine to [v DOSED, DOSING, DOSES]\n",
  "DOSED": "DOSE, to give a measure of medicine to [v]\n",
  "DOSEH": "(Arabic) a religious ceremony at Cairo (abolished 1884), during the festival of the Prophet's birth, when the sheikh of the Sadi dervishes rode on horseback over the prostrate bodies of his followers [n -S]\n",
  "DOSEHS": "DOSEH, (Arabic) a religious ceremony at Cairo (abolished 1884), during the festival of the Prophet's birth, when the sheikh of the Sadi dervishes rode on horseback over the prostrate bodies of his followers [n]\n",
  "DOSEMETER": "an instrument for measuring doses of radiation, also DOSIMETER [n -S]\n",
  "DOSEMETERS": "DOSEMETER, an instrument for measuring doses of radiation, also DOSIMETER [n]\n",
  "DOSER": "one who doses [n -S]\n",
  "DOSERS": "DOSER, one who doses [n]\n",
  "DOSES": "DOSE, to give a measure of medicine to [v]\n",
  "DOSH": "(slang) money [n -ES]\n",
  "DOSHA": "(Sanskrit) each of three energies believed in Ayurveda to circulate in the body [n -S]\n",
  "DOSHAS": "DOSHA, (Sanskrit) each of three energies believed in Ayurveda to circulate in the body [n]\n",
  "DOSHES": "DOSH, (slang) money [n]\n",
  "DOSIMETER": "an instrument for measuring doses of radiation, also DOSEMETER [n -S]\n",
  "DOSIMETERS": "DOSIMETER, an instrument for measuring doses of radiation, also DOSEMETER [n]\n",
  "DOSIMETRIC": "relating to dosimetry [adj]\n",
  "DOSIMETRICIAN": "one who uses a dosimeter, an instrument for measuring doses of radiation [n -S]\n",
  "DOSIMETRICIANS": "DOSIMETRICIAN, one who uses a dosimeter, an instrument for measuring doses of radiation [n]\n",
  "DOSIMETRIES": "DOSIMETRY, the measurement of doses of drugs [n]\n",
  "DOSIMETRIST": "one who uses a dosimeter [n -S]\n",
  "DOSIMETRISTS": "DOSIMETRIST, one who uses a dosimeter [n]\n",
  "DOSIMETRY": "the measurement of doses of drugs [n DOSIMETRIES]\n",
  "DOSING": "DOSE, to give a measure of medicine to [v]\n",
  "DOSIOLOGIES": "DOSIOLOGY, the branch of medicine that deals with dosages, also DOSOLOGY, POSOLOGY [n]\n",
  "DOSIOLOGY": "the branch of medicine that deals with dosages, also DOSOLOGY, POSOLOGY [n DOSIOLOGIES]\n",
  "DOSOLOGIES": "DOSOLOGY, the science of doses [n]\n",
  "DOSOLOGY": "the science of doses [n DOSOLOGIES]\n",
  "DOSS": "to sleep in any convenient place [v -ED, -ING, -ES]\n",
  "DOSSAL": "an ornamental cloth hung behind an altar, also DORSEL, DOSSEL [n -S]\n",
  "DOSSALS": "DOSSAL, an ornamental cloth hung behind an altar, also DORSEL, DOSSEL [n]\n",
  "DOSSED": "DOSS, to sleep in any convenient place [v]\n",
  "DOSSEL": "an ornamental cloth hung behind an altar, also DORSEL, DORSER, DOSSAL [n -S]\n",
  "DOSSELS": "DOSSEL, an ornamental cloth hung behind an altar, also DORSEL, DORSER, DOSSAL [n]\n",
  "DOSSER": "a covering for the back of a throne, also DORSER, DOSSAL, DOSSEL [n -S]\n",
  "DOSSERET": "a block resting on the capital of a column [n -S]\n",
  "DOSSERETS": "DOSSERET, a block resting on the capital of a column [n]\n",
  "DOSSERS": "DOSSER, a covering for the back of a throne, also DORSER, DOSSAL, DOSSEL [n]\n",
  "DOSSES": "DOSS, to sleep in any convenient place [v]\n",
  "DOSSHOUSE": "a very cheap lodging-house [n -S]\n",
  "DOSSHOUSES": "DOSSHOUSE, a very cheap lodging-house [n]\n",
  "DOSSIER": "a file of papers on a single subject [n -S]\n",
  "DOSSIERS": "DOSSIER, a file of papers on a single subject [n]\n",
  "DOSSIL": "a wad of lint for wiping a wound [n -S]\n",
  "DOSSILS": "DOSSIL, a wad of lint for wiping a wound [n]\n",
  "DOSSING": "DOSS, to sleep in any convenient place [v]\n",
  "DOST": "DO, to perform [v]\n",
  "DOT": "to cover with tiny round marks [v DOTTED, DOTTING, DOTS]\n",
  "DOTAGE": "the state of senility [n -S]\n",
  "DOTAGES": "DOTAGE, the state of senility [n]\n",
  "DOTAL": "pertaining to dower, or a woman's marriage portion [adj]\n",
  "DOTANT": "(Shakespeare) one who dotes, a dotard [n -S]\n",
  "DOTANTS": "DOTANT, (Shakespeare) one who dotes, a dotard [n]\n",
  "DOTARD": "someone who dotes, also DOTANT [n -S]\n",
  "DOTARDLIER": "DOTARDLY, like a dotard, one in his dotage [adj]\n",
  "DOTARDLIEST": "DOTARDLY, like a dotard, one in his dotage [adj]\n",
  "DOTARDLY": "like a dotard, one in his dotage [adj DOTARDLIER, DOTARDLIEST]\n",
  "DOTARDS": "DOTARD, someone who dotes, also DOTANT [n]\n",
  "DOTATION": "an endowment [n -S]\n",
  "DOTATIONS": "DOTATION, an endowment [n]\n",
  "DOTCOM": "a company that conducts most of its business on the internet [n -S]\n",
  "DOTCOMMER": "a person who carries out business on the Internet [n -S]\n",
  "DOTCOMMERS": "DOTCOMMER, a person who carries out business on the Internet [n]\n",
  "DOTCOMS": "DOTCOM, a company that conducts most of its business on the internet [n]\n",
  "DOTE": "to love excessively, also DOAT [v DOTED, DOTING, DOTES]\n",
  "DOTED": "DOTE, to love excessively, also DOAT [v]\n",
  "DOTER": "one who dotes, also DOATER [n -S]\n",
  "DOTERS": "DOTER, one who dotes, also DOATER [n]\n",
  "DOTES": "DOTE, to love excessively, also DOAT [v]\n",
  "DOTH": "(archaic) 3rd person singular of do, also DOETH [v]\n",
  "DOTIER": "DOTY, stained by decay [adj]\n",
  "DOTIEST": "DOTY, stained by decay [adj]\n",
  "DOTING": "an excessive love, also DOATING [n -S]\n",
  "DOTINGLY": "DOTING [adv]\n",
  "DOTINGS": "DOTING, an excessive love, also DOATING [n]\n",
  "DOTISH": "foolish; weak [adj]\n",
  "DOTS": "DOT, to cover with tiny round marks [v]\n",
  "DOTTED": "DOT, to cover with tiny round marks [v]\n",
  "DOTTEL": "a mass of half-burnt pipe tobacco, also DOTTLE [n -S]\n",
  "DOTTELS": "DOTTEL, a mass of half-burnt pipe tobacco, also DOTTLE [n]\n",
  "DOTTER": "one who dots [n -S]\n",
  "DOTTEREL": "a shore bird, also DOTTREL [n -S]\n",
  "DOTTERELS": "DOTTEREL, a shore bird, also DOTTREL [n]\n",
  "DOTTERS": "DOTTER, one who dots [n]\n",
  "DOTTIER": "DOTTY, feebleminded, harmlessly eccentric [adj]\n",
  "DOTTIEST": "DOTTY, feebleminded, harmlessly eccentric [adj]\n",
  "DOTTILY": "DOTTY, feebleminded, harmlessly eccentric [adv]\n",
  "DOTTINESS": "the state of being dotty [n -ES]\n",
  "DOTTINESSES": "DOTTINESS, the state of being dotty [n]\n",
  "DOTTING": "DOT, to cover with tiny round marks [v]\n",
  "DOTTLE": "a mass of partly burnt pipe tobacco, also DOTTEL [n -S] / of tobacco, partly burnt [adj DOTTLER, DOTTLEST]\n",
  "DOTTLED": "full of dottle, unburnt and partially burnt tobacco caked in the bowl of a pipe [adj]\n",
  "DOTTLER": "DOTTLE, of tobacco, partly burnt [adj]\n",
  "DOTTLES": "DOTTLE, a mass of partly burnt pipe tobacco, also DOTTEL [n]\n",
  "DOTTLEST": "DOTTLE, of tobacco, partly burnt [adj]\n",
  "DOTTREL": "a shore bird, also DOTTEREL [n -S]\n",
  "DOTTRELS": "DOTTREL, a shore bird, also DOTTEREL [n]\n",
  "DOTTY": "feebleminded, harmlessly eccentric [adj DOTTIER, DOTTIEST, DOTTILY]\n",
  "DOTY": "stained by decay [adj DOTIER, DOTIEST]\n",
  "DOUANE": "a customhouse [n -S]\n",
  "DOUANES": "DOUANE, a customhouse [n]\n",
  "DOUANIER": "(French) a customhouse officer [n -S]\n",
  "DOUANIERS": "DOUANIER, (French) a customhouse officer [n]\n",
  "DOUAR": "(Arabic) a type of tent village, also DUAR, DOWAR [n -S]\n",
  "DOUARS": "DOUAR, (Arabic) a type of tent village, also DUAR, DOWAR [n]\n",
  "DOUBLE": "twofold [adj DOUBLY] / to make twice as much [v DOUBLED, DOUBLING, DOUBLES]\n",
  "DOUBLED": "DOUBLE, to make twice as much [v]\n",
  "DOUBLEHEADER": "two games, contests or events held consecutively on the same program [n -S]\n",
  "DOUBLEHEADERS": "DOUBLEHEADER, two games, contests or events held consecutively on the same program [n]\n",
  "DOUBLENESS": "the state of being double or doubled [n -ES]\n",
  "DOUBLENESSES": "DOUBLENESS, the state of being double or doubled [n]\n",
  "DOUBLER": "one that doubles [n -S]\n",
  "DOUBLERS": "DOUBLER, one that doubles [n]\n",
  "DOUBLES": "DOUBLE, to make twice as much [v]\n",
  "DOUBLESPEAK": "language used to deceive usually through concealment or misrepresentation of truth [n -S]\n",
  "DOUBLESPEAKER": "one who engages in doublespeak [n -S]\n",
  "DOUBLESPEAKERS": "DOUBLESPEAKER, one who engages in doublespeak [n]\n",
  "DOUBLESPEAKS": "DOUBLESPEAK, language used to deceive usually through concealment or misrepresentation of truth [n]\n",
  "DOUBLET": "a close-fitting body garment formerly worn by men [n -S]\n",
  "DOUBLETHINK": "thought marked by the acceptance of gross contradictions and falsehoods, esp. when used as a technique of self-indoctrination [n -S]\n",
  "DOUBLETHINKS": "DOUBLETHINK, thought marked by the acceptance of gross contradictions and falsehoods, esp. when used as a technique of self-indoctrination [n]\n",
  "DOUBLETON": "two cards that are the only ones of their suit dealt to a player [n -S]\n",
  "DOUBLETONS": "DOUBLETON, two cards that are the only ones of their suit dealt to a player [n]\n",
  "DOUBLETREE": "the bar, or crosspiece, of a carriage, to which the singletrees are attached [n -S]\n",
  "DOUBLETREES": "DOUBLETREE, the bar, or crosspiece, of a carriage, to which the singletrees are attached [n]\n",
  "DOUBLETS": "DOUBLET, a close-fitting body garment formerly worn by men [n]\n",
  "DOUBLING": "the act of making double [n -S]\n",
  "DOUBLINGS": "DOUBLING, the act of making double [n]\n",
  "DOUBLOON": "an obsolete Spanish gold coin, also DOBLA, DOBLON [n -S]\n",
  "DOUBLOONS": "DOUBLOON, an obsolete Spanish gold coin, also DOBLA, DOBLON [n]\n",
  "DOUBLURE": "(French) an ornamental lining on the inside of a book, of leather or vellum [n -S]\n",
  "DOUBLURES": "DOUBLURE, (French) an ornamental lining on the inside of a book, of leather or vellum [n]\n",
  "DOUBLY": "DOUBLE, twofold [adv]\n",
  "DOUBT": "to be uncertain about [v -ED, -ING, -S]\n",
  "DOUBTABLE": "capable of being doubted [adj DOUBTABLY]\n",
  "DOUBTABLY": "DOUBTABLE, capable of being doubted [adv]\n",
  "DOUBTED": "DOUBT, to be uncertain about [v]\n",
  "DOUBTER": "one who doubts [n -S]\n",
  "DOUBTERS": "DOUBTER, one who doubts [n]\n",
  "DOUBTFUL": "worthy of doubt [adj DOUBTFULLY] / something doubtful e.g. a starter in a race [n -S]\n",
  "DOUBTFULLY": "DOUBTFUL, worthy of doubt [adv]\n",
  "DOUBTFULNESS": "the state of being doubtful [n -ES]\n",
  "DOUBTFULNESSES": "DOUBTFULNESS, the state of being doubtful [n]\n",
  "DOUBTFULS": "DOUBTFUL, something doubtful e.g. a starter in a race [n]\n",
  "DOUBTING": "in a state of doubt [adj DOUBTINGLY] / the act of doubting [n -S]\n",
  "DOUBTINGLY": "DOUBTING, in a state of doubt [adv]\n",
  "DOUBTINGS": "DOUBTING, the act of doubting [n]\n",
  "DOUBTLESS": "without doubt [adj DOUBTLESSLY]\n",
  "DOUBTLESSLY": "DOUBTLESS, without doubt [adv]\n",
  "DOUBTLESSNESS": "DOUBTLESS, without doubt [n]\n",
  "DOUBTLESSNESSES": "DOUBTLESSNESS, DOUBTLESS, without doubt [n]\n",
  "DOUBTS": "DOUBT, to be uncertain about [v]\n",
  "DOUC": "a kind of monkey, remarkable for its varied and brilliant colors, native to Cochin China [n -S]\n",
  "DOUCE": "(French) sweet, pleasant [adj DOUCER, DOUCEST, DOUCELY]\n",
  "DOUCELY": "DOUCE, (French) sweet, pleasant [adv]\n",
  "DOUCENESS": "sweetness [n -ES]\n",
  "DOUCENESSES": "DOUCENESS, sweetness [n]\n",
  "DOUCEPERE": "(Spenser) one of the twelve peers of France, companions of Charlemagne in war, also DOUZEPER [n -S]\n",
  "DOUCEPERES": "DOUCEPERE, (Spenser) one of the twelve peers of France, companions of Charlemagne in war, also DOUZEPER [n]\n",
  "DOUCER": "DOUCE, (French) sweet, pleasant [adj]\n",
  "DOUCEST": "DOUCE, (French) sweet, pleasant [adj]\n",
  "DOUCET": "a sweet dish, also DOWSET [n -S]\n",
  "DOUCETS": "DOUCET, a sweet dish, also DOWSET [n]\n",
  "DOUCEUR": "(French) a subtly offered bribe [n -S]\n",
  "DOUCEURS": "DOUCEUR, (French) a subtly offered bribe [n]\n",
  "DOUCHE": "to cleanse with a jet of water [v DOUCHED, DOUCHING, DOUCHES]\n",
  "DOUCHEBAG": "a despicable person [n -S]\n",
  "DOUCHEBAGS": "DOUCHEBAG, a despicable person [n]\n",
  "DOUCHED": "DOUCHE, to cleanse with a jet of water [v]\n",
  "DOUCHES": "DOUCHE, to cleanse with a jet of water [v]\n",
  "DOUCHING": "the act of using a douche [n -S]\n",
  "DOUCHINGS": "DOUCHING, the act of using a douche [n]\n",
  "DOUCINE": "(French) an ogee moulding of the cornice [n -S]\n",
  "DOUCINES": "DOUCINE, (French) an ogee moulding of the cornice [n]\n",
  "DOUCS": "DOUC, a kind of monkey, remarkable for its varied and brilliant colors, native to Cochin China [n]\n",
  "DOUGH": "a flour mixture [n -S]\n",
  "DOUGHBALL": "a kind of bait used in carp fishing [n -S]\n",
  "DOUGHBALLS": "DOUGHBALL, a kind of bait used in carp fishing [n]\n",
  "DOUGHBOY": "a boiled flour dumpling; an American infantryman [n -S]\n",
  "DOUGHBOYS": "DOUGHBOY, a boiled flour dumpling; an American infantryman [n]\n",
  "DOUGHFACE": "a contemptuous nickname for a timid, yielding politician [n -S]\n",
  "DOUGHFACED": "over-persuadable, esp. of North American politicians inclined to favour the South in the Civil War [adj]\n",
  "DOUGHFACES": "DOUGHFACE, a contemptuous nickname for a timid, yielding politician [n]\n",
  "DOUGHIER": "DOUGHY, resembling dough [adj]\n",
  "DOUGHIEST": "DOUGHY, resembling dough [adj]\n",
  "DOUGHINESS": "the state of being doughy [n -ES]\n",
  "DOUGHINESSES": "DOUGHINESS, the state of being doughy [n]\n",
  "DOUGHLIKE": "like dough [adj]\n",
  "DOUGHNUT": "to surround a speaker to give the impression of a packed house, also DONUT [v DOUGHNUTTED, DOUGHNUTTING, DOUGHNUTS]\n",
  "DOUGHNUTLIKE": "like a doughnut [adj]\n",
  "DOUGHNUTS": "DOUGHNUT, to surround a speaker to give the impression of a packed house, also DONUT [v]\n",
  "DOUGHNUTTED": "DOUGHNUT, to surround a speaker to give the impression of a packed house, also DONUT [v]\n",
  "DOUGHNUTTING": "the act of surrounding a speaker to give the impression of a packed house [n -S]\n",
  "DOUGHNUTTINGS": "DOUGHNUTTING, the act of surrounding a speaker to give the impression of a packed house [n]\n",
  "DOUGHS": "DOUGH, a flour mixture [n]\n",
  "DOUGHT": "DOW, to be able [v]\n",
  "DOUGHTIER": "DOUGHTY, courageous [adj]\n",
  "DOUGHTIEST": "DOUGHTY, courageous [adj]\n",
  "DOUGHTILY": "DOUGHTY, courageous [adv]\n",
  "DOUGHTINESS": "the state of being doughty [n -ES]\n",
  "DOUGHTINESSES": "DOUGHTINESS, the state of being doughty [n]\n",
  "DOUGHTY": "courageous [adj DOUGHTIER, DOUGHTIEST, DOUGHTILY]\n",
  "DOUGHY": "resembling dough [adj DOUGHIER, DOUGHIEST]\n",
  "DOUK": "to duck, bathe, also DOOK [v -ED, -ING, -S]\n",
  "DOUKED": "DOUK, to duck, bathe, also DOOK [v]\n",
  "DOUKING": "DOUK, to duck, bathe, also DOOK [v]\n",
  "DOUKS": "DOUK, to duck, bathe, also DOOK [v]\n",
  "DOULA": "(Modern Greek) a woman trained to give support after childbirth [n -S]\n",
  "DOULAS": "DOULA, (Modern Greek) a woman trained to give support after childbirth [n]\n",
  "DOULEIA": "(Greek) in Roman Catholicism, the inferior veneration accorded to saints and angels, also DULIA [n -S]\n",
  "DOULEIAS": "DOULEIA, (Greek) in Roman Catholicism, the inferior veneration accorded to saints and angels, also DULIA [n]\n",
  "DOULOCRACIES": "DOULOCRACY, a government formed of privileged slaves, also DULOCRACY [n]\n",
  "DOULOCRACY": "a government formed of privileged slaves, also DULOCRACY [n DOULOCRACIES]\n",
  "DOUM": "(Arabic) a kind of African palm tree [n -S]\n",
  "DOUMA": "(Russian) the Russian parliament, also DUMA [n -S]\n",
  "DOUMAS": "DOUMA, (Russian) the Russian parliament, also DUMA [n]\n",
  "DOUMS": "DOUM, (Arabic) a kind of African palm tree [n]\n",
  "DOUN": "(Scots) down, also DOON [adv]\n",
  "DOUP": "(Scots) the bottom of anything, also DOWP [n -S]\n",
  "DOUPIONI": "a kind of silk yarn, also DOUPPIONI, DUPION [n -S]\n",
  "DOUPIONIS": "DOUPIONI, a kind of silk yarn, also DOUPPIONI, DUPION [n]\n",
  "DOUPPIONI": "a kind of silk yarn, also DOUPIONI, DUPION [n -S]\n",
  "DOUPPIONIS": "DOUPPIONI, a kind of silk yarn, also DOUPIONI, DUPION [n]\n",
  "DOUPS": "DOUP, (Scots) the bottom of anything, also DOWP [n]\n",
  "DOUR": "determined, sullen [adj DOURER, DOUREST, DOURLY]\n",
  "DOURA": "(Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURAH, DURA, DURR, DURRA [n -S]\n",
  "DOURAH": "(Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DURA, DURR, DURRA [n -S]\n",
  "DOURAHS": "DOURAH, (Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DURA, DURR, DURRA [n]\n",
  "DOURAS": "DOURA, (Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURAH, DURA, DURR, DURRA [n]\n",
  "DOURER": "DOUR, determined, sullen [adj]\n",
  "DOUREST": "DOUR, determined, sullen [adj]\n",
  "DOURINE": "(French) a disease of horses [n -S]\n",
  "DOURINES": "DOURINE, (French) a disease of horses [n]\n",
  "DOURLY": "DOUR, determined, sullen [adv]\n",
  "DOURNESS": "the state of being dour [n -ES]\n",
  "DOURNESSES": "DOURNESS, the state of being dour [n]\n",
  "DOUROUCOULI": "a small, nocturnal, South American monkey, also DURUKULI [n -S]\n",
  "DOUROUCOULIS": "DOUROUCOULI, a small, nocturnal, South American monkey, also DURUKULI [n]\n",
  "DOUSE": "to plunge into water [v DOUSED, DOUSING, DOUSES]\n",
  "DOUSED": "DOUSE, to plunge into water [v]\n",
  "DOUSER": "something used for dousing [n -S]\n",
  "DOUSERS": "DOUSER, something used for dousing [n]\n",
  "DOUSES": "DOUSE, to plunge into water [v]\n",
  "DOUSING": "DOUSE, to plunge into water [v]\n",
  "DOUT": "(Scots) to put out, extinguish [v -ED, -ING, -S]\n",
  "DOUTED": "DOUT, (Scots) to put out, extinguish [v]\n",
  "DOUTER": "an extinguisher for candles [n -S]\n",
  "DOUTERS": "DOUTER, an extinguisher for candles [n]\n",
  "DOUTING": "DOUT, (Scots) to put out, extinguish [v]\n",
  "DOUTS": "DOUT, (Scots) to put out, extinguish [v]\n",
  "DOUX": "(French) of champagne, very sweet [adj]\n",
  "DOUZEPER": "(Spenser) one of the twelve peers of France, companions of Charlemagne in war, also DOUCEPERE [n -S]\n",
  "DOUZEPERS": "DOUZEPER, (Spenser) one of the twelve peers of France, companions of Charlemagne in war, also DOUCEPERE [n]\n",
  "DOVE": "to doze, also DOVER [v DOVED, DOVING, DOVES]\n",
  "DOVECOT": "a roost for domesticated pigeons, also DOVECOTE [n -S]\n",
  "DOVECOTE": "a roost for domesticated pigeons, also DOVECOT [n -S]\n",
  "DOVECOTES": "DOVECOTE, a roost for domesticated pigeons, also DOVECOT [n]\n",
  "DOVECOTS": "DOVECOT, a roost for domesticated pigeons, also DOVECOTE [n]\n",
  "DOVED": "DOVE, to doze, also DOVER [v]\n",
  "DOVEISH": "like a dove, also DOVISH [adj DOVEISHLY]\n",
  "DOVEISHLY": "DOVEISH, like a dove, also DOVISH [adv]\n",
  "DOVEISHNESS": "the state of being doveish, like a dove, also DOVISHNESS [n -ES]\n",
  "DOVEISHNESSES": "DOVEISHNESS, the state of being doveish, like a dove, also DOVISHNESS [n]\n",
  "DOVEKEY": "(Scots) a kind of guillemot, also DOVEKIE [n -S]\n",
  "DOVEKEYS": "DOVEKEY, (Scots) a kind of guillemot, also DOVEKIE [n]\n",
  "DOVEKIE": "(Scots) a kind of guillemot, also DOVEKEY [n -S]\n",
  "DOVEKIES": "DOVEKIE, (Scots) a kind of guillemot, also DOVEKEY [n]\n",
  "DOVELET": "a young or small dove [n -S]\n",
  "DOVELETS": "DOVELET, a young or small dove [n]\n",
  "DOVELIKE": "like a dove [adj]\n",
  "DOVEN": "(Yiddish) to utter Jewish prayers, also DAVEN [v -ED, -ING, -S]\n",
  "DOVENED": "DOVEN, (Yiddish) to utter Jewish prayers, also DAVEN [v]\n",
  "DOVENING": "DOVEN, (Yiddish) to utter Jewish prayers, also DAVEN [v]\n",
  "DOVENS": "DOVEN, (Yiddish) to utter Jewish prayers, also DAVEN [v]\n",
  "DOVER": "(Scots) to doze, also DOVE [v -ED, -ING, -S]\n",
  "DOVERED": "DOVER, (Scots) to doze, also DOVE [v]\n",
  "DOVERING": "DOVER, (Scots) to doze, also DOVE [v]\n",
  "DOVERS": "DOVER, (Scots) to doze, also DOVE [v]\n",
  "DOVES": "DOVE, to doze, also DOVER [v]\n",
  "DOVETAIL": "to fit together closely [v -ED, -ING, -S]\n",
  "DOVETAILED": "DOVETAIL, to fit together closely [v]\n",
  "DOVETAILING": "the act of making a dovetail joint [n -S]\n",
  "DOVETAILINGS": "DOVETAILING, the act of making a dovetail joint [n]\n",
  "DOVETAILS": "DOVETAIL, to fit together closely [v]\n",
  "DOVIE": "(Scots) stupid [adj DOVIER, DOVIEST]\n",
  "DOVIER": "DOVIE, (Scots) stupid [adj]\n",
  "DOVIEST": "DOVIE, (Scots) stupid [adj]\n",
  "DOVING": "DOVE, to doze, also DOVER [v]\n",
  "DOVISH": "like a dove, also DOVEISH [adj DOVISHLY]\n",
  "DOVISHLY": "DOVISH, like a dove, also DOVEISH [adv]\n",
  "DOVISHNESS": "the state of being dovish, like a dove, also DOVEISHNESS [n -ES]\n",
  "DOVISHNESSES": "DOVISHNESS, the state of being dovish, like a dove, also DOVEISHNESS [n]\n",
  "DOW": "to be able [v DOCHT or DOUGHT or DOWED, DOWING, DOWS]\n",
  "DOWABLE": "entitled to an endowment [adj]\n",
  "DOWAGER": "a title given to a widow to distinguish her from the wife of her husband's heir [n -S]\n",
  "DOWAGERS": "DOWAGER, a title given to a widow to distinguish her from the wife of her husband's heir [n]\n",
  "DOWAR": "(Arabic) a circular Arab encampment, also DOUAR, DUAR [n -S]\n",
  "DOWARS": "DOWAR, (Arabic) a circular Arab encampment, also DOUAR, DUAR [n]\n",
  "DOWD": "a woman who wears unstylish clothes, also DOWDY [n -S]\n",
  "DOWDIER": "DOWDY, dressed un-stylishly [adj]\n",
  "DOWDIES": "DOWDY, a woman who wears un-stylish clothes, also DOWD [n]\n",
  "DOWDIEST": "DOWDY, dressed un-stylishly [adj]\n",
  "DOWDILY": "DOWDY, dressed un-stylishly [adv]\n",
  "DOWDINESS": "the state of being dowdy [n -ES]\n",
  "DOWDINESSES": "DOWDINESS, the state of being dowdy [n]\n",
  "DOWDS": "DOWD, a woman who wears unstylish clothes, also DOWDY [n]\n",
  "DOWDY": "a woman who wears un-stylish clothes, also DOWD [n DOWDIES] / dressed un-stylishly [adj DOWDIER, DOWDIEST, DOWDILY]\n",
  "DOWDYISH": "somewhat dowdy [adj]\n",
  "DOWDYISM": "the wearing of unstylish clothes [n -S]\n",
  "DOWDYISMS": "DOWDYISM, the wearing of unstylish clothes [n]\n",
  "DOWED": "DOW, to be able [v]\n",
  "DOWEL": "to fasten with wooden pins [v DOWELED or DOWELLED, DOWELING or DOWELLING, DOWELS]\n",
  "DOWELED": "DOWEL, to fasten with wooden pins [v]\n",
  "DOWELING": "long thin wooden rods of circular section, also DOWELLING [n -S]\n",
  "DOWELINGS": "DOWELING, long thin wooden rods of circular section, also DOWELLING [n]\n",
  "DOWELLED": "DOWEL, to fasten with wooden pins [v]\n",
  "DOWELLING": "long thin wooden rods of circular section, also DOWELING [n -S]\n",
  "DOWELLINGS": "DOWELLING, long thin wooden rods of circular section, also DOWELING [n]\n",
  "DOWELS": "DOWEL, to fasten with wooden pins [v]\n",
  "DOWER": "to provide with a dowry [v -ED, -ING, -S]\n",
  "DOWERED": "DOWER, to provide with a dowry [v]\n",
  "DOWERIES": "DOWERY, the property which a woman brings to her husband at marriage, also DOWRY [n]\n",
  "DOWERING": "DOWER, to provide with a dowry [v]\n",
  "DOWERLESS": "destitute of dower; having no marriage portion [adj]\n",
  "DOWERS": "DOWER, to provide with a dowry [v]\n",
  "DOWERY": "the property which a woman brings to her husband at marriage, also DOWRY [n DOWERIES]\n",
  "DOWF": "(Scots) dull, heavy, spiritless [adj]\n",
  "DOWFNESS": "(Scots) dullness, heaviness [n -ES]\n",
  "DOWFNESSES": "DOWFNESS, (Scots) dullness, heaviness [n]\n",
  "DOWIE": "(Scots) dull, low-spirited, also DOWLY [adj DOWIER, DOWIEST]\n",
  "DOWIER": "DOWIE, (Scots) dull, low-spirited, also DOWLY [adj]\n",
  "DOWIEST": "DOWIE, (Scots) dull, low-spirited, also DOWLY [adj]\n",
  "DOWING": "DOW, to be able [v]\n",
  "DOWITCHER": "(Native American) the red-breasted or gray snipe [n -S]\n",
  "DOWITCHERS": "DOWITCHER, (Native American) the red-breasted or gray snipe [n]\n",
  "DOWL": "(dialect) a portion of down in a feather; a piece of fluff, also DOWLE, DOWLNE [n -S]\n",
  "DOWLAS": "a coarse linen cloth [n -ES]\n",
  "DOWLASES": "DOWLAS, a coarse linen cloth [n]\n",
  "DOWLE": "(dialect) a portion of down in a feather; a piece of fluff, also DOWL, DOWLNE [n -S]\n",
  "DOWLES": "DOWLE, (dialect) a portion of down in a feather; a piece of fluff, also DOWL, DOWLNE [n]\n",
  "DOWLIER": "DOWLY, (English dialect) dull, low-spirited, also DOWIE [adj]\n",
  "DOWLIEST": "DOWLY, (English dialect) dull, low-spirited, also DOWIE [adj]\n",
  "DOWLNE": "(Shakespeare) down, in sense of feathers, also DOWL, DOWLE [n -S]\n",
  "DOWLNES": "DOWLNE, (Shakespeare) down, in sense of feathers, also DOWL, DOWLE [n]\n",
  "DOWLNEY": "(Shakespeare) downy, fluffily soft [adj]\n",
  "DOWLS": "DOWL, (dialect) a portion of down in a feather; a piece of fluff, also DOWLE, DOWLNE [n]\n",
  "DOWLY": "(English dialect) dull, low-spirited, also DOWIE [adj DOWLIER, DOWLIEST]\n",
  "DOWN": "to a lower position, also DOON, DOUN [adv] / to cause to fall [v -ED, -ING, -S]\n",
  "DOWNA": "(dialect) cannot, cannot be bothered [v]\n",
  "DOWNBEAT": "the first beat of a musical measure [n -S]\n",
  "DOWNBEATS": "DOWNBEAT, the first beat of a musical measure [n]\n",
  "DOWNBOUND": "of e.g. a train, heading in a southerly directio [adj]\n",
  "DOWNBOW": "a way of bowing a violin [n -S]\n",
  "DOWNBOWS": "DOWNBOW, a way of bowing a violin [n]\n",
  "DOWNBURST": "a sudden, violent downward rush of air usually associated with thunderstorms, also MICROBURST [n -S]\n",
  "DOWNBURSTS": "DOWNBURST, a sudden, violent downward rush of air usually associated with thunderstorms, also MICROBURST [n]\n",
  "DOWNCAST": "a current of air into a mine [n -S]\n",
  "DOWNCASTS": "DOWNCAST, a current of air into a mine [n]\n",
  "DOWNCOME": "a sudden fall; a downfall [n -S]\n",
  "DOWNCOMER": "a pipe that connects a cistern to a toilet pan [n -S]\n",
  "DOWNCOMERS": "DOWNCOMER, a pipe that connects a cistern to a toilet pan [n]\n",
  "DOWNCOMES": "DOWNCOME, a sudden fall; a downfall [n]\n",
  "DOWNCOURT": "in or into the opposing end of the court, as in basketball [adj]\n",
  "DOWNCRIED": "DOWNCRY, to denigrate or disparage [v]\n",
  "DOWNCRIES": "DOWNCRY, to denigrate or disparage [v]\n",
  "DOWNCRY": "to denigrate or disparage [v DOWNCRIED, DOWNCRYING, DOWNCRIES]\n",
  "DOWNCRYING": "DOWNCRY, to denigrate or disparage [v]\n",
  "DOWNDRAFT": "a downward movement of air, also DOWNDRAUGHT [n -S]\n",
  "DOWNDRAFTS": "DOWNDRAFT, a downward movement of air, also DOWNDRAUGHT [n]\n",
  "DOWNDRAUGHT": "a downward movement of air, also DOWNDRAFT [n -S]\n",
  "DOWNDRAUGHTS": "DOWNDRAUGHT, a downward movement of air, also DOWNDRAFT [n]\n",
  "DOWNED": "DOWN, to cause to fall [v]\n",
  "DOWNER": "something that oppresses one; a depressant drug [n -S]\n",
  "DOWNERS": "DOWNER, something that oppresses one; a depressant drug [n]\n",
  "DOWNFALL": "a sudden fall [n -S]\n",
  "DOWNFALLEN": "fallen down [adj]\n",
  "DOWNFALLS": "DOWNFALL, a sudden fall [n]\n",
  "DOWNFIELD": "in or into the part of the field towards which the opposing team is headed [adv]\n",
  "DOWNFLOW": "a running down [n -S]\n",
  "DOWNFLOWS": "DOWNFLOW, a running down [n]\n",
  "DOWNFORCE": "an aerodynamically caused downward force in a car, which improves its roadholding [n -S]\n",
  "DOWNFORCES": "DOWNFORCE, an aerodynamically caused downward force in a car, which improves its roadholding [n]\n",
  "DOWNGRADE": "to relegate to an inferior status [v DOWNGRADED, DOWNGRADING, DOWNGRADES]\n",
  "DOWNGRADED": "DOWNGRADE, to relegate to an inferior status [v]\n",
  "DOWNGRADES": "DOWNGRADE, to relegate to an inferior status [v]\n",
  "DOWNGRADING": "DOWNGRADE, to relegate to an inferior status [v]\n",
  "DOWNHAUL": "a rope for hauling down sails [n -S]\n",
  "DOWNHAULS": "DOWNHAUL, a rope for hauling down sails [n]\n",
  "DOWNHEARTED": "downcast, dejected [adj DOWNHEARTEDLY]\n",
  "DOWNHEARTEDLY": "DOWNHEARTED, downcast, dejected [adv]\n",
  "DOWNHEARTEDNESS": "DOWNHEARTED, downcast, dejected [n]\n",
  "DOWNHILL": "a downward slope [n -S]\n",
  "DOWNHILLER": "one who skis downhill [n -S]\n",
  "DOWNHILLERS": "DOWNHILLER, one who skis downhill [n]\n",
  "DOWNHILLS": "DOWNHILL, a downward slope [n]\n",
  "DOWNHOLE": "pertaining to subterranean drilling equipment [adj]\n",
  "DOWNIER": "DOWNY, covered in down [adj]\n",
  "DOWNIES": "DOWNY, a bed [n]\n",
  "DOWNIEST": "DOWNY, covered in down [adj]\n",
  "DOWNILY": "DOWNY, covered in down [adv]\n",
  "DOWNINESS": "the state of being downy [n -ES]\n",
  "DOWNINESSES": "DOWNINESS, the state of being downy [n]\n",
  "DOWNING": "DOWN, to cause to fall [v]\n",
  "DOWNLAND": "a rolling treeless upland [n -S]\n",
  "DOWNLANDS": "DOWNLAND, a rolling treeless upland [n]\n",
  "DOWNLESS": "having no down (soft, fluffy feathers) [adj]\n",
  "DOWNLIGHT": "a lamp shining downwards [n -S]\n",
  "DOWNLIGHTER": "a downward directed light-fitting, attached to or recessed in the ceiling [n -S]\n",
  "DOWNLIGHTERS": "DOWNLIGHTER, a downward directed light-fitting, attached to or recessed in the ceiling [n]\n",
  "DOWNLIGHTS": "DOWNLIGHT, a lamp shining downwards [n]\n",
  "DOWNLIKE": "like down [adj]\n",
  "DOWNLINK": "a communication channel from a satellite [n -S] / to provide a downlink [v -ED, -ING, -S]\n",
  "DOWNLINKED": "DOWNLINK, to provide a downlink [v]\n",
  "DOWNLINKING": "DOWNLINK, to provide a downlink [v]\n",
  "DOWNLINKS": "DOWNLINK, a communication channel from a satellite [n]\n",
  "DOWNLOAD": "to transfer data from a large computer to a smaller one [v -ED, -ING, -S]\n",
  "DOWNLOADABLE": "capable of being downloaded [adj]\n",
  "DOWNLOADED": "DOWNLOAD, to transfer data from a large computer to a smaller one [v]\n",
  "DOWNLOADING": "the act of obtaining data files from the Internet [n -S]\n",
  "DOWNLOADINGS": "DOWNLOADING, the act of obtaining data files from the Internet [n]\n",
  "DOWNLOADS": "DOWNLOAD, to transfer data from a large computer to a smaller one [v]\n",
  "DOWNLOOKED": "(Dryden) downcast, gloomy [adj]\n",
  "DOWNLOW": "as in on the downlow, not widely known [n -S]\n",
  "DOWNLOWS": "DOWNLOW, as in on the downlow, not widely known [n]\n",
  "DOWNMOST": "furthest down [adj]\n",
  "DOWNPIPE": "a drainpipe which takes rainwater from the gutter of a roof [n -S]\n",
  "DOWNPIPES": "DOWNPIPE, a drainpipe which takes rainwater from the gutter of a roof [n]\n",
  "DOWNPLAY": "to understate, underemphasise [v -ED, -ING, -S]\n",
  "DOWNPLAYED": "DOWNPLAY, to understate, underemphasise [v]\n",
  "DOWNPLAYING": "DOWNPLAY, to understate, underemphasise [v]\n",
  "DOWNPLAYS": "DOWNPLAY, to understate, underemphasise [v]\n",
  "DOWNPOUR": "a heavy rain [n -S]\n",
  "DOWNPOURS": "DOWNPOUR, a heavy rain [n]\n",
  "DOWNRANGE": "in a direction down the range [adv]\n",
  "DOWNRATE": "to make lower in value [v DOWNRATED, DOWNRATING, DOWNRATES]\n",
  "DOWNRATED": "DOWNRATE, to make lower in value [v]\n",
  "DOWNRATES": "DOWNRATE, to make lower in value [v]\n",
  "DOWNRATING": "DOWNRATE, to make lower in value [v]\n",
  "DOWNREGULATION": "the process of reducing or suppressing a response to a stimulus [n -S]\n",
  "DOWNREGULATIONS": "DOWNREGULATION, the process of reducing or suppressing a response to a stimulus [n]\n",
  "DOWNRIGHT": "straight down; perpendicularly [adv] / plainspoken, blunt [adj DOWNRIGHTLY]\n",
  "DOWNRIGHTLY": "DOWNRIGHT, plainspoken, blunt [adv]\n",
  "DOWNRIGHTNESS": "DOWNRIGHT, plainspoken, blunt [n]\n",
  "DOWNRIGHTNESSES": "DOWNRIGHTNESS, DOWNRIGHT, plainspoken, blunt [n]\n",
  "DOWNRIVER": "down the river [adv]\n",
  "DOWNRUSH": "a rushing down [n -ES]\n",
  "DOWNRUSHES": "DOWNRUSH, a rushing down [n]\n",
  "DOWNS": "DOWN, to cause to fall [v]\n",
  "DOWNSCALE": "to scale down [v DOWNSCALED, DOWNSCALING, DOWNSCALES]\n",
  "DOWNSCALED": "DOWNSCALE, to scale down [v]\n",
  "DOWNSCALES": "DOWNSCALE, to scale down [v]\n",
  "DOWNSCALING": "DOWNSCALE, to scale down [v]\n",
  "DOWNSHIFT": "to change gear down [v -ED, -ING, -S]\n",
  "DOWNSHIFTED": "DOWNSHIFT, to change gear down [v]\n",
  "DOWNSHIFTER": "one who reduces his or her working hours [n -S]\n",
  "DOWNSHIFTERS": "DOWNSHIFTER, one who reduces his or her working hours [n]\n",
  "DOWNSHIFTING": "the act of selecting a lower gear [n -S]\n",
  "DOWNSHIFTINGS": "DOWNSHIFTING, the act of selecting a lower gear [n]\n",
  "DOWNSHIFTS": "DOWNSHIFT, to change gear down [v]\n",
  "DOWNSIDE": "a negative aspect [n -S]\n",
  "DOWNSIDES": "DOWNSIDE, a negative aspect [n]\n",
  "DOWNSIZE": "to produce in a smaller size [v DOWNSIZED, DOWNSIZING, DOWNSIZES]\n",
  "DOWNSIZED": "DOWNSIZE, to produce in a smaller size [v]\n",
  "DOWNSIZER": "one who downsizes [n -S]\n",
  "DOWNSIZERS": "DOWNSIZER, one who downsizes [n]\n",
  "DOWNSIZES": "DOWNSIZE, to produce in a smaller size [v]\n",
  "DOWNSIZING": "the act of reducing a company etc. in size [n -S]\n",
  "DOWNSIZINGS": "DOWNSIZING, the act of reducing a company etc. in size [n]\n",
  "DOWNSLIDE": "a downward movement [n -S]\n",
  "DOWNSLIDES": "DOWNSLIDE, a downward movement [n]\n",
  "DOWNSLOPE": "a downward slope [n -S]\n",
  "DOWNSLOPES": "DOWNSLOPE, a downward slope [n]\n",
  "DOWNSPIN": "a spinning motion [n -S]\n",
  "DOWNSPINS": "DOWNSPIN, a spinning motion [n]\n",
  "DOWNSPOUT": "(US) a drainpipe [n -S]\n",
  "DOWNSPOUTS": "DOWNSPOUT, (US) a drainpipe [n]\n",
  "DOWNSTAGE": "the front of a stage [n -S]\n",
  "DOWNSTAGES": "DOWNSTAGE, the front of a stage [n]\n",
  "DOWNSTAIR": "situated in the lower storey of a house, also DOWNSTAIRS [adj]\n",
  "DOWNSTAIRS": "in or towards a lower storey [adj] / a lower storey, also DOWNSTAIR [n -ES]\n",
  "DOWNSTAIRSES": "DOWNSTAIRS, a lower storey, also DOWNSTAIR [n]\n",
  "DOWNSTATE": "the region of a State remote from large cities, a rural area [n -S]\n",
  "DOWNSTATER": "one who lives or comes from downstate [n -S]\n",
  "DOWNSTATERS": "DOWNSTATER, one who lives or comes from downstate [n]\n",
  "DOWNSTATES": "DOWNSTATE, the region of a State remote from large cities, a rural area [n]\n",
  "DOWNSTREAM": "in the direction of or nearer to the mouth of a stream [adj]\n",
  "DOWNSTROKE": "a stroke made with a downward motion of the pen or pencil [n -S]\n",
  "DOWNSTROKES": "DOWNSTROKE, a stroke made with a downward motion of the pen or pencil [n]\n",
  "DOWNSWEPT": "curved downwards [adj]\n",
  "DOWNSWING": "a decline, a downturn [n -S]\n",
  "DOWNSWINGS": "DOWNSWING, a decline, a downturn [n]\n",
  "DOWNTHROW": "a state of being thrown down [n -S]\n",
  "DOWNTHROWS": "DOWNTHROW, a state of being thrown down [n]\n",
  "DOWNTICK": "a stock market transaction [n -S]\n",
  "DOWNTICKS": "DOWNTICK, a stock market transaction [n]\n",
  "DOWNTIME": "the time when a machine or a factory is inactive [n -S]\n",
  "DOWNTIMES": "DOWNTIME, the time when a machine or a factory is inactive [n]\n",
  "DOWNTOWN": "the business district of a city [n -S]\n",
  "DOWNTOWNER": "one from down town [n -S]\n",
  "DOWNTOWNERS": "DOWNTOWNER, one from down town [n]\n",
  "DOWNTOWNS": "DOWNTOWN, the business district of a city [n]\n",
  "DOWNTREND": "a tendency in a downward direction [n -S] / to tend in a downward direction [v -ED, -ING, -S]\n",
  "DOWNTRENDED": "DOWNTREND, to tend in a downward direction [v]\n",
  "DOWNTRENDING": "DOWNTREND, to tend in a downward direction [v]\n",
  "DOWNTRENDS": "DOWNTREND, a tendency in a downward direction [n]\n",
  "DOWNTROD": "suffering oppression, also DOWNTRODDEN [adj]\n",
  "DOWNTRODDEN": "suffering oppression, also DOWNTROD [adj]\n",
  "DOWNTURN": "a decline [n -S]\n",
  "DOWNTURNED": "turned down [adj]\n",
  "DOWNTURNS": "DOWNTURN, a decline [n]\n",
  "DOWNVOTE": "to register disapproval of (a post) on social media [v DOWNVOTED, DOWNVOTING, DOWNVOTES]\n",
  "DOWNVOTED": "DOWNVOTE, to register disapproval of (a post) on social media [v]\n",
  "DOWNVOTES": "DOWNVOTE, to register disapproval of (a post) on social media [v]\n",
  "DOWNVOTING": "DOWNVOTE, to register disapproval of (a post) on social media [v]\n",
  "DOWNWARD": "from a higher to a lower place, also DOWNWARDS [adj DOWNWARDLY]\n",
  "DOWNWARDLY": "in a downward direction [adv]\n",
  "DOWNWARDNESS": "the state of being downward [n -ES]\n",
  "DOWNWARDNESSES": "DOWNWARDNESS, the state of being downward [n]\n",
  "DOWNWARDS": "from a higher place to a lower, also DOWNWARD [adv]\n",
  "DOWNWARP": "a broad surface depression [n -S]\n",
  "DOWNWARPS": "DOWNWARP, a broad surface depression [n]\n",
  "DOWNWASH": "a downward deflection of air [n -ES]\n",
  "DOWNWASHES": "DOWNWASH, a downward deflection of air [n]\n",
  "DOWNWIND": "the direction that the wind blows [adv]\n",
  "DOWNY": "covered in down [adj DOWNIER, DOWNIEST, DOWNILY] / a bed [n DOWNIES]\n",
  "DOWNZONE": "to reduce or limit the number of buildings permitted [v DOWNZONED, DOWNZONING, DOWNZONES]\n",
  "DOWNZONED": "DOWNZONE, to reduce or limit the number of buildings permitted [v]\n",
  "DOWNZONES": "DOWNZONE, to reduce or limit the number of buildings permitted [v]\n",
  "DOWNZONING": "DOWNZONE, to reduce or limit the number of buildings permitted [v]\n",
  "DOWP": "(Scots) the bottom of anything, also DOUP [n -S]\n",
  "DOWPS": "DOWP, (Scots) the bottom of anything, also DOUP [n]\n",
  "DOWRIES": "DOWRY, the property which a woman brings to her husband at marriage, also DOWERY [n]\n",
  "DOWRY": "the property which a woman brings to her husband at marriage, also DOWERY [n DOWRIES]\n",
  "DOWS": "DOW, to be able [v]\n",
  "DOWSABEL": "a sweetheart [n -S]\n",
  "DOWSABELS": "DOWSABEL, a sweetheart [n]\n",
  "DOWSE": "to search for water with a divining rod [v DOWSED, DOWSING, DOWSES]\n",
  "DOWSED": "DOWSE, to search for water with a divining rod [v]\n",
  "DOWSER": "one who searches for e.g. water with e.g. a hazel twig [n -S]\n",
  "DOWSERS": "DOWSER, one who searches for e.g. water with e.g. a hazel twig [n]\n",
  "DOWSES": "DOWSE, to search for water with a divining rod [v]\n",
  "DOWSET": "a savory tart baked in sweet dough, also DOUCET [n -S]\n",
  "DOWSETS": "DOWSET, a savory tart baked in sweet dough, also DOUCET [n]\n",
  "DOWSING": "the act of looking for water with a divining rod [n -S]\n",
  "DOWSINGS": "DOWSING, the act of looking for water with a divining rod [n]\n",
  "DOWT": "(Scots) a cigarette end [n -S]\n",
  "DOWTS": "DOWT, (Scots) a cigarette end [n]\n",
  "DOX": "to publish personal information about (a person) on the internet [v DOXED, DOXING, DOXES]\n",
  "DOXAPRAM": "a drug used as a respiratory stimulant [n -S]\n",
  "DOXAPRAMS": "DOXAPRAM, a drug used as a respiratory stimulant [n]\n",
  "DOXASTIC": "of or relating to the branch of logic concerned with belief [adj]\n",
  "DOXASTICS": "the branch of logic concerned with belief [n]\n",
  "DOXED": "DOX, to publish personal information about (a person) on the internet [v]\n",
  "DOXES": "DOX, to publish personal information about (a person) on the internet [v]\n",
  "DOXIE": "a doctrine, also DOXY [n -S]\n",
  "DOXIES": "DOXIE, a doctrine, also DOXY [n]\n",
  "DOXING": "DOX, to publish personal information about (a person) on the internet [v]\n",
  "DOXOGRAPHER": "a compiler of the opinions of philosophers [n -S]\n",
  "DOXOGRAPHERS": "DOXOGRAPHER, a compiler of the opinions of philosophers [n]\n",
  "DOXOGRAPHIC": "relating to doxography [adj]\n",
  "DOXOGRAPHIES": "DOXOGRAPHY, the compilation of opinions on philosophers [n]\n",
  "DOXOGRAPHY": "the compilation of opinions on philosophers [n DOXOGRAPHIES]\n",
  "DOXOLOGICAL": "relating to doxology [adj DOXOLOGICALLY]\n",
  "DOXOLOGICALLY": "DOXOLOGICAL, relating to doxology [adv]\n",
  "DOXOLOGIES": "DOXOLOGY, a hymn or verse of praise to God [n]\n",
  "DOXOLOGY": "a hymn or verse of praise to God [n DOXOLOGIES]\n",
  "DOXORUBICIN": "a bacterial antibiotic used to treat various forms of cancer [n -S]\n",
  "DOXORUBICINS": "DOXORUBICIN, a bacterial antibiotic used to treat various forms of cancer [n]\n",
  "DOXY": "a woman of loose morals, a prostitute, also DOXIE [n DOXIES]\n",
  "DOXYCYCLINE": "a broad-spectrum tetracycline antibiotic with potent antibacterial activity that is often taken by travelers to prevent diarrhea [n -S]\n",
  "DOXYCYCLINES": "DOXYCYCLINE, a broad-spectrum tetracycline antibiotic with potent antibacterial activity that is often taken by travelers to prevent diarrhea [n]\n",
  "DOY": "(Scots) dear, a loved one [n -S]\n",
  "DOYEN": "the senior member of a group [n -S]\n",
  "DOYENNE": "(French) a women who is the eldest or senior member of a group or profession [n -S]\n",
  "DOYENNES": "DOYENNE, (French) a women who is the eldest or senior member of a group or profession [n]\n",
  "DOYENS": "DOYEN, the senior member of a group [n]\n",
  "DOYLEY": "an ornamental napkin, also DOILY, DOYLY [n -S]\n",
  "DOYLEYS": "DOYLEY, an ornamental napkin, also DOILY, DOYLY [n]\n",
  "DOYLIES": "DOYLY, an ornamental napkin, also DOILY, DOYLEY [n]\n",
  "DOYLY": "an ornamental napkin, also DOILY, DOYLEY [n DOYLIES]\n",
  "DOYS": "DOY, (Scots) dear, a loved one [n]\n",
  "DOZE": "to sleep lightly [v DOZED, DOZING, DOZES]\n",
  "DOZED": "DOZE, to sleep lightly [v]\n",
  "DOZEN": "a set of twelve [n -S] / (Scots) to doze [v -ED, -ING, -S]\n",
  "DOZENED": "DOZEN, (Scots) to doze [v]\n",
  "DOZENING": "DOZEN, (Scots) to doze [v]\n",
  "DOZENS": "DOZEN, (Scots) to doze [v]\n",
  "DOZENTH": "the ordinal of dozen [adj] / a twelfth [n -S]\n",
  "DOZENTHS": "DOZENTH, a twelfth [n]\n",
  "DOZER": "one who dozes [n -S]\n",
  "DOZERS": "DOZER, one who dozes [n]\n",
  "DOZES": "DOZE, to sleep lightly [v]\n",
  "DOZIER": "DOZY, sleepy [adj]\n",
  "DOZIEST": "DOZY, sleepy [adj]\n",
  "DOZILY": "DOZY, sleepy [adv]\n",
  "DOZINESS": "the state of being dozy [n -ES]\n",
  "DOZINESSES": "DOZINESS, the state of being dozy [n]\n",
  "DOZING": "the act of taking a short sleep [n -S]\n",
  "DOZINGS": "DOZING, the act of taking a short sleep [n]\n",
  "DOZY": "sleepy [adj DOZIER, DOZIEST, DOZILY]\n",
  "DRAB": "dull and monotonous [adj DRABBER, DRABBEST, DRABLY] / to associate with prostitutes [v DRABBED, DRABBING, DRABS]\n",
  "DRABBED": "DRAB, to associate with prostitutes [v]\n",
  "DRABBER": "one who associates with prostitutes [n -S]\n",
  "DRABBERS": "DRABBER, one who associates with prostitutes [n]\n",
  "DRABBEST": "DRAB, dull and monotonous [adj]\n",
  "DRABBET": "a coarse linen fabric, also DRABETTE [n -S]\n",
  "DRABBETS": "DRABBET, a coarse linen fabric, also DRABETTE [n]\n",
  "DRABBIER": "DRABBY, sluttish, also DRABBISH [adj]\n",
  "DRABBIEST": "DRABBY, sluttish, also DRABBISH [adj]\n",
  "DRABBINESS": "the state of being a drab [n -ES]\n",
  "DRABBINESSES": "DRABBINESS, the state of being a drab [n]\n",
  "DRABBING": "DRAB, to associate with prostitutes [v]\n",
  "DRABBISH": "sluttish, also DRABBY [adj]\n",
  "DRABBLE": "to make wet and dirty [v DRABBLED, DRABBLING, DRABBLES]\n",
  "DRABBLED": "DRABBLE, to make wet and dirty [v]\n",
  "DRABBLER": "a piece of canvas fastened by lacing to the bonnet of a sail, to give it a greater depth, or more drop, also DRABLER [n -S]\n",
  "DRABBLERS": "DRABBLER, a piece of canvas fastened by lacing to the bonnet of a sail, to give it a greater depth, or more drop, also DRABLER [n]\n",
  "DRABBLES": "DRABBLE, to make wet and dirty [v]\n",
  "DRABBLING": "a manner of fishing for barbels with a rod and long line passed through a piece of lead [n -S]\n",
  "DRABBLINGS": "DRABBLING, a manner of fishing for barbels with a rod and long line passed through a piece of lead [n]\n",
  "DRABBY": "sluttish, also DRABBISH [adj DRABBIER, DRABBIEST]\n",
  "DRABETTE": "a coarse linen fabric, also DRABBET [n -S]\n",
  "DRABETTES": "DRABETTE, a coarse linen fabric, also DRABBET [n]\n",
  "DRABLER": "a piece of canvas fastened by lacing to the bonnet of a sail, to give it a greater depth, or more drop, also DRABBLER [n -S]\n",
  "DRABLERS": "DRABLER, a piece of canvas fastened by lacing to the bonnet of a sail, to give it a greater depth, or more drop, also DRABBLER [n]\n",
  "DRABLY": "DRAB, dull and monotonous [adv]\n",
  "DRABNESS": "the quality of being drab [n -ES]\n",
  "DRABNESSES": "DRABNESS, the quality of being drab [n]\n",
  "DRABS": "DRAB, to associate with prostitutes [v]\n",
  "DRAC": "(Australian slang) of a woman, unattractive, also DRACK [adj]\n",
  "DRACAENA": "(Greek) a genus of liliaceous plants with woody stems and funnel-shaped flowers, also DRACENA [n -S]\n",
  "DRACAENAS": "DRACAENA, (Greek) a genus of liliaceous plants with woody stems and funnel-shaped flowers, also DRACENA [n]\n",
  "DRACENA": "(Greek) a genus of liliaceous plants with woody stems and funnel-shaped flowers, also DRACAENA [n -S]\n",
  "DRACENAS": "DRACENA, (Greek) a genus of liliaceous plants with woody stems and funnel-shaped flowers, also DRACAENA [n]\n",
  "DRACHM": "(Greek) a Greek monetary unit, also DRACHMA [n -S]\n",
  "DRACHMA": "(Greek) a Greek monetary unit, also DRACHM [n DRACHMAS, DRACHMAE or DRACHMAI]\n",
  "DRACHMAE": "DRACHMA, (Greek) a Greek monetary unit, also DRACHM [n]\n",
  "DRACHMAI": "DRACHMA, (Greek) a Greek monetary unit, also DRACHM [n]\n",
  "DRACHMAS": "DRACHMA, (Greek) a Greek monetary unit, also DRACHM [n]\n",
  "DRACHMS": "DRACHM, (Greek) a Greek monetary unit, also DRACHMA [n]\n",
  "DRACK": "(Australian slang) of a woman, unattractive, also DRAC [adj]\n",
  "DRACO": "as in draco lizard, a flying lizard [adj]\n",
  "DRACONE": "(tradename) a towed flexible container for transporting liquids by water [n -S]\n",
  "DRACONES": "DRACONE, (tradename) a towed flexible container for transporting liquids by water [n]\n",
  "DRACONIAN": "unusually harsh, also DRACONIC, DRACONTIC [adj]\n",
  "DRACONIANISM": "extreme harshness of laws [n -S]\n",
  "DRACONIANISMS": "DRACONIANISM, extreme harshness of laws [n]\n",
  "DRACONIC": "unusually harsh, also DRACONIAN, DRACONTIC [adj DRACONICALLY]\n",
  "DRACONICALLY": "DRACONIC, unusually harsh, also DRACONIAN, DRACONTIC [adv]\n",
  "DRACONISM": "being draconic in the administration of laws [n -S]\n",
  "DRACONISMS": "DRACONISM, being draconic in the administration of laws [n]\n",
  "DRACONITES": "a jewel supposedly found inside a dragon's head [n]\n",
  "DRACONTIASES": "DRACONTIASIS, guinea worm disease [n]\n",
  "DRACONTIASIS": "guinea worm disease [n DRACONTIASES]\n",
  "DRACONTIC": "unusually harsh, also DRACONIAN, DRACONIC [adj]\n",
  "DRACUNCULIASES": "DRACUNCULIASIS, a disease that is caused by infestation with the guinea worm and that has been eradicated in most regions except Africa [n]\n",
  "DRACUNCULIASIS": "a disease that is caused by infestation with the guinea worm and that has been eradicated in most regions except Africa [n DRACUNCULIASES]\n",
  "DRACUNCULUS": "the green dragon genus of Araceae [n DRACUNCULUSES]\n",
  "DRACUNCULUSES": "DRACUNCULUS, the green dragon genus of Araceae [n]\n",
  "DRAD": "DREAD, to fear greatly [v]\n",
  "DRAFF": "the damp remains of malt after brewing [n -S]\n",
  "DRAFFIER": "DRAFFY, like dregs, worthless [adj]\n",
  "DRAFFIEST": "DRAFFY, like dregs, worthless [adj]\n",
  "DRAFFISH": "like dregs, worthless, also DRAFFY [adj]\n",
  "DRAFFS": "DRAFF, the damp remains of malt after brewing [n]\n",
  "DRAFFY": "like dregs, worthless [adj DRAFFIER, DRAFFIEST]\n",
  "DRAFT": "to conscript for military service [v -ED, -ING, -S]\n",
  "DRAFTABLE": "that can be drafted [adj]\n",
  "DRAFTED": "DRAFT, to conscript for military service [v]\n",
  "DRAFTEE": "one that is drafted [n -S]\n",
  "DRAFTEES": "DRAFTEE, one that is drafted [n]\n",
  "DRAFTER": "a person who prepares preliminary drafts [n -S]\n",
  "DRAFTERS": "DRAFTER, a person who prepares preliminary drafts [n]\n",
  "DRAFTIER": "DRAFTY, exposed to currents of air, also DRAUGHTY [adj]\n",
  "DRAFTIEST": "DRAFTY, exposed to currents of air, also DRAUGHTY [adj]\n",
  "DRAFTILY": "DRAFTY, exposed to currents of air, also DRAUGHTY [adv]\n",
  "DRAFTINESS": "the state of being drafty [n -ES]\n",
  "DRAFTINESSES": "DRAFTINESS, the state of being drafty [n]\n",
  "DRAFTING": "mechanical drawing [n -S]\n",
  "DRAFTINGS": "DRAFTING, mechanical drawing [n]\n",
  "DRAFTS": "DRAFT, to conscript for military service [v]\n",
  "DRAFTSMAN": "a person whose profession is to make drawings, plans, or sketches, also DRAUGHTSMAN [n DRAFTSMEN]\n",
  "DRAFTSMANSHIP": "the craft of the draftsman, also DRAUGHTSMANSHIP [n -S]\n",
  "DRAFTSMANSHIPS": "DRAFTSMANSHIP, the craft of the draftsman, also DRAUGHTSMANSHIP [n]\n",
  "DRAFTSMEN": "DRAFTSMAN, a person whose profession is to make drawings, plans, or sketches, also DRAUGHTSMAN [n]\n",
  "DRAFTSPERSON": "a draftsman or draftswoman (used as a neutral alternative) [n -S]\n",
  "DRAFTSPERSONS": "DRAFTSPERSON, a draftsman or draftswoman (used as a neutral alternative) [n]\n",
  "DRAFTSWOMAN": "(US) a draughtswoman [n DRAFTSWOMEN]\n",
  "DRAFTSWOMEN": "DRAFTSWOMAN, (US) a draughtswoman [n]\n",
  "DRAFTY": "exposed to currents of air, also DRAUGHTY [adj DRAFTIER, DRAFTIEST, DRAFTILY]\n",
  "DRAG": "to pull along the ground [v DRAGGED, DRAGGING, DRAGS]\n",
  "DRAGEE": "(French) a sugarcoated candy [n -S]\n",
  "DRAGEES": "DRAGEE, (French) a sugarcoated candy [n]\n",
  "DRAGGED": "DRAG, to pull along the ground [v]\n",
  "DRAGGER": "a fishing vessel that drags the bottom [n -S]\n",
  "DRAGGERS": "DRAGGER, a fishing vessel that drags the bottom [n]\n",
  "DRAGGIER": "DRAGGY, boring [adj]\n",
  "DRAGGIEST": "DRAGGY, boring [adj]\n",
  "DRAGGING": "a technique in interior decoration, in which a brush is pulled through freshly-applied paint to give an irregular decorative effect [n -S]\n",
  "DRAGGINGLY": "DRAGGING [adv]\n",
  "DRAGGINGS": "DRAGGING, a technique in interior decoration, in which a brush is pulled through freshly-applied paint to give an irregular decorative effect [n]\n",
  "DRAGGLE": "to make wet and dirty by dragging on the ground [v DRAGGLED, DRAGGLING, DRAGGLES]\n",
  "DRAGGLED": "DRAGGLE, to make wet and dirty by dragging on the ground [v]\n",
  "DRAGGLES": "DRAGGLE, to make wet and dirty by dragging on the ground [v]\n",
  "DRAGGLETAILED": "(archaic) (esp. of a woman) bedraggled; besmirched [adj]\n",
  "DRAGGLING": "DRAGGLE, to make wet and dirty by dragging on the ground [v]\n",
  "DRAGGY": "boring [adj DRAGGIER, DRAGGIEST]\n",
  "DRAGHOUND": "a foxhound trained to follow a drag [n -S]\n",
  "DRAGHOUNDS": "DRAGHOUND, a foxhound trained to follow a drag [n]\n",
  "DRAGLINE": "an excavating machine moving on articulated tracks [n -S]\n",
  "DRAGLINES": "DRAGLINE, an excavating machine moving on articulated tracks [n]\n",
  "DRAGNET": "a large net drawn behind a boat [n -S]\n",
  "DRAGNETS": "DRAGNET, a large net drawn behind a boat [n]\n",
  "DRAGOMAN": "(Arabic) an interpreter in Eastern countries [n DRAGOMEN or DRAGOMANS]\n",
  "DRAGOMANS": "DRAGOMAN, (Arabic) an interpreter in Eastern countries [n]\n",
  "DRAGOMEN": "DRAGOMAN, (Arabic) an interpreter in Eastern countries [n]\n",
  "DRAGON": "a mythical, serpentlike monster [n -S]\n",
  "DRAGONESS": "a female dragon [n -ES]\n",
  "DRAGONESSES": "DRAGONESS, a female dragon [n]\n",
  "DRAGONET": "a marine fish of the genus Callionymus [n -S]\n",
  "DRAGONETS": "DRAGONET, a marine fish of the genus Callionymus [n]\n",
  "DRAGONFLIES": "DRAGONFLY, a predaceous long-bodied often brilliantly-coloured insect of the Odonata [n]\n",
  "DRAGONFLY": "a predaceous long-bodied often brilliantly-coloured insect of the Odonata [n DRAGONFLIES]\n",
  "DRAGONHEAD": "a labiate garden plant [n -S]\n",
  "DRAGONHEADS": "DRAGONHEAD, a labiate garden plant [n]\n",
  "DRAGONISE": "to turn into a dragon, also DRAGONIZE [v DRAGONISED, DRAGONISING, DRAGONISES]\n",
  "DRAGONISED": "DRAGONISE, to turn into a dragon, also DRAGONIZE [v]\n",
  "DRAGONISES": "DRAGONISE, to turn into a dragon, also DRAGONIZE [v]\n",
  "DRAGONISH": "resembling a dragon [adj]\n",
  "DRAGONISING": "DRAGONISE, to turn into a dragon, also DRAGONIZE [v]\n",
  "DRAGONISM": "unremitting watchfulness [n -S]\n",
  "DRAGONISMS": "DRAGONISM, unremitting watchfulness [n]\n",
  "DRAGONIZE": "to turn into a dragon, also DRAGONISE [v DRAGONIZED, DRAGONIZING, DRAGONIZES]\n",
  "DRAGONIZED": "DRAGONIZE, to turn into a dragon, also DRAGONISE [v]\n",
  "DRAGONIZES": "DRAGONIZE, to turn into a dragon, also DRAGONISE [v]\n",
  "DRAGONIZING": "DRAGONIZE, to turn into a dragon, also DRAGONISE [v]\n",
  "DRAGONLIKE": "like a dragon [adj]\n",
  "DRAGONNADE": "(French) a persecution conducted by Louis XIV against French Protestants in the 1680s, in which dragoons were quartered on them [n -S] / to persecute by troops [v DRAGONNADED, DRAGONNADING, DRAGONNADES]\n",
  "DRAGONNADED": "DRAGONNADE, to persecute by troops [v]\n",
  "DRAGONNADES": "DRAGONNADE, (French) a persecution conducted by Louis XIV against French Protestants in the 1680s, in which dragoons were quartered on them [n]\n",
  "DRAGONNADING": "DRAGONNADE, to persecute by troops [v]\n",
  "DRAGONNE": "like a heraldic dragon [adj]\n",
  "DRAGONROOT": "(US) an araceous plant (genus Arisaema) or its tuberous root, used in medicine [n -S]\n",
  "DRAGONROOTS": "DRAGONROOT, (US) an araceous plant (genus Arisaema) or its tuberous root, used in medicine [n]\n",
  "DRAGONS": "DRAGON, a mythical, serpentlike monster [n]\n",
  "DRAGOON": "a heavy cavalry [n -S] / to compel by military bullying; to compel by force [v -ED, -ING, -S]\n",
  "DRAGOONAGE": "the act of dragooning [n -S]\n",
  "DRAGOONAGES": "DRAGOONAGE, the act of dragooning [n]\n",
  "DRAGOONED": "DRAGOON, to compel by military bullying; to compel by force [v]\n",
  "DRAGOONING": "DRAGOON, to compel by military bullying; to compel by force [v]\n",
  "DRAGOONS": "DRAGOON, to compel by military bullying; to compel by force [v]\n",
  "DRAGROPE": "a rope used for dragging [n -S]\n",
  "DRAGROPES": "DRAGROPE, a rope used for dragging [n]\n",
  "DRAGS": "DRAG, to pull along the ground [v]\n",
  "DRAGSMAN": "the driver of a coach [n DRAGSMEN]\n",
  "DRAGSMEN": "DRAGSMAN, the driver of a coach [n]\n",
  "DRAGSTER": "a car built or modified for use in drag races [n -S]\n",
  "DRAGSTERS": "DRAGSTER, a car built or modified for use in drag races [n]\n",
  "DRAGSTRIP": "a race course for drag racing, also DRAGWAY [n -S]\n",
  "DRAGSTRIPS": "DRAGSTRIP, a race course for drag racing, also DRAGWAY [n]\n",
  "DRAGSVILLE": "(US) boredom [n -S]\n",
  "DRAGSVILLES": "DRAGSVILLE, (US) boredom [n]\n",
  "DRAGWAY": "a race course for drag racing, also DRAGSTRIP [n -S]\n",
  "DRAGWAYS": "DRAGWAY, a race course for drag racing, also DRAGSTRIP [n]\n",
  "DRAIL": "to dirty by dragging [v -ED, -ING, -S]\n",
  "DRAILED": "DRAIL, to dirty by dragging [v]\n",
  "DRAILING": "DRAIL, to dirty by dragging [v]\n",
  "DRAILS": "DRAIL, to dirty by dragging [v]\n",
  "DRAIN": "to draw off a liquid [v -ED, -ING, -S]\n",
  "DRAINABLE": "capable of being drained [adj]\n",
  "DRAINAGE": "the act of draining [n -S]\n",
  "DRAINAGES": "DRAINAGE, the act of draining [n]\n",
  "DRAINBOARD": "a sloping grooved board or surface, on which washed dishes are left to drain, typically into a sink [n DRAINBOARDS]\n",
  "DRAINBOARDS": "DRAINBOARD, a sloping grooved board or surface, on which washed dishes are left to drain, typically into a sink [n]\n",
  "DRAINED": "DRAIN, to draw off a liquid [v]\n",
  "DRAINER": "someone or something that drains [n -S]\n",
  "DRAINERS": "DRAINER, someone or something that drains [n]\n",
  "DRAINING": "DRAIN, to draw off a liquid [v]\n",
  "DRAINLAYER": "(New Zealand) one whose job is to lay drains [n -S]\n",
  "DRAINLAYERS": "DRAINLAYER, (New Zealand) one whose job is to lay drains [n]\n",
  "DRAINPIPE": "a pipe used for carrying off surplus water [n -S]\n",
  "DRAINPIPES": "DRAINPIPE, a pipe used for carrying off surplus water [n]\n",
  "DRAINS": "DRAIN, to draw off a liquid [v]\n",
  "DRAISENE": "(historical) a dandy-horse, a sort of early bicycle, also DRAISINE [n -S]\n",
  "DRAISENES": "DRAISENE, (historical) a dandy-horse, a sort of early bicycle, also DRAISINE [n]\n",
  "DRAISINE": "(historical) a dandy-horse, a sort of early bicycle, also DRAISENE [n -S]\n",
  "DRAISINES": "DRAISINE, (historical) a dandy-horse, a sort of early bicycle, also DRAISENE [n]\n",
  "DRAKE": "a male duck [n -S]\n",
  "DRAKES": "DRAKE, a male duck [n]\n",
  "DRAKESTONE": "a flat stone so thrown along the surface of water as to skip from point to point before it sinks [n -S]\n",
  "DRAKESTONES": "DRAKESTONE, a flat stone so thrown along the surface of water as to skip from point to point before it sinks [n]\n",
  "DRAM": "to tipple, drink a small measure of whisky [v DRAMMED, DRAMMING, DRAMS]\n",
  "DRAMA": "a story showing life and action [n -S]\n",
  "DRAMADIES": "DRAMADY, a sitcom with dramatic scenes, also DRAMEDY [n]\n",
  "DRAMADY": "a sitcom with dramatic scenes, also DRAMEDY [n DRAMADIES]\n",
  "DRAMAS": "DRAMA, a story showing life and action [n]\n",
  "DRAMATIC": "pertaining to drama [adj DRAMATICALLY]\n",
  "DRAMATICAL": "of or pertaining to the drama; theatrical [adj DRAMATICALLY]\n",
  "DRAMATICALLY": "DRAMATICAL, of or pertaining to the drama; theatrical [adv]\n",
  "DRAMATICISM": "the quality of being dramatic [n -S]\n",
  "DRAMATICISMS": "DRAMATICISM, the quality of being dramatic [n]\n",
  "DRAMATICS": "the acting, production and study of plays [n]\n",
  "DRAMATISABLE": "capable of being dramatised, also DRAMATIZABLE [adj]\n",
  "DRAMATISATION": "the act of dramatising, also DRAMATIZATION [n -S]\n",
  "DRAMATISATIONS": "DRAMATISATION, the act of dramatising, also DRAMATIZATION [n]\n",
  "DRAMATISE": "to adapt to dramatic representation; as, to dramatize a novel, also DRAMATIZE [v DRAMATISED, DRAMATISING, DRAMATISES]\n",
  "DRAMATISED": "DRAMATISE, to adapt to dramatic representation; as, to dramatize a novel, also DRAMATIZE [v]\n",
  "DRAMATISER": "one who dramatises, also DRAMATIZER [n -S]\n",
  "DRAMATISERS": "DRAMATISER, one who dramatises, also DRAMATIZER [n]\n",
  "DRAMATISES": "DRAMATISE, to adapt to dramatic representation; as, to dramatize a novel, also DRAMATIZE [v]\n",
  "DRAMATISING": "DRAMATISE, to adapt to dramatic representation; as, to dramatize a novel, also DRAMATIZE [v]\n",
  "DRAMATIST": "the author of a dramatic composition; a writer of plays [n -S]\n",
  "DRAMATISTS": "DRAMATIST, the author of a dramatic composition; a writer of plays [n]\n",
  "DRAMATIZABLE": "capable of being dramatized, also DRAMATISABLE [adj]\n",
  "DRAMATIZATION": "the act of dramatizing, also DRAMATISATION [n -S]\n",
  "DRAMATIZATIONS": "DRAMATIZATION, the act of dramatizing, also DRAMATISATION [n]\n",
  "DRAMATIZE": "to adapt to dramatic representation; as, to dramatize a novel, also DRAMATISE [v DRAMATIZED, DRAMATIZING, DRAMATIZES]\n",
  "DRAMATIZED": "DRAMATIZE, to adapt to dramatic representation; as, to dramatize a novel, also DRAMATISE [v]\n",
  "DRAMATIZER": "one who dramatizes, also DRAMATISER [n -S]\n",
  "DRAMATIZERS": "DRAMATIZER, one who dramatizes, also DRAMATISER [n]\n",
  "DRAMATIZES": "DRAMATIZE, to adapt to dramatic representation; as, to dramatize a novel, also DRAMATISE [v]\n",
  "DRAMATIZING": "DRAMATIZE, to adapt to dramatic representation; as, to dramatize a novel, also DRAMATISE [v]\n",
  "DRAMATURG": "a dramatist; specifically a reader and literary editor etc. to a permanent theatrical company, also DRAMATURGE, DRAMATURGIST [n -S]\n",
  "DRAMATURGE": "a dramatist; specifically a reader and literary editor etc. to a permanent theatrical company, also DRAMATURG, DRAMATURGIST [n -S]\n",
  "DRAMATURGES": "DRAMATURGE, a dramatist; specifically a reader and literary editor etc. to a permanent theatrical company, also DRAMATURG, DRAMATURGIST [n]\n",
  "DRAMATURGIC": "relating to dramaturgy, also DRAMATURGICAL [adj DRAMATURGICALLY]\n",
  "DRAMATURGICAL": "related to dramaturgy, also DRAMATURGIC [adj DRAMATURGICALLY]\n",
  "DRAMATURGICALLY": "DRAMATURGICAL, related to dramaturgy, also DRAMATURGIC [adv]\n",
  "DRAMATURGIES": "DRAMATURGY, the art of producing and staging dramatic works [n]\n",
  "DRAMATURGIST": "a dramatist; specifically a reader and literary editor etc. to a permanent theatrical company, also DRAMATURG, DRAMATURGE [n -S]\n",
  "DRAMATURGISTS": "DRAMATURGIST, a dramatist; specifically a reader and literary editor etc. to a permanent theatrical company, also DRAMATURG, DRAMATURGE [n]\n",
  "DRAMATURGS": "DRAMATURG, a dramatist; specifically a reader and literary editor etc. to a permanent theatrical company, also DRAMATURGE, DRAMATURGIST [n]\n",
  "DRAMATURGY": "the art of producing and staging dramatic works [n DRAMATURGIES]\n",
  "DRAMEDIES": "DRAMEDY, a sitcom with dramatic scenes, also DRAMADY [n]\n",
  "DRAMEDY": "a sitcom with dramatic scenes, also DRAMADY [n DRAMEDIES]\n",
  "DRAMMACH": "(Gaelic) a mixture of raw meal and water, also DRAMMOCK, DRUMMOCK [n -S]\n",
  "DRAMMACHS": "DRAMMACH, (Gaelic) a mixture of raw meal and water, also DRAMMOCK, DRUMMOCK [n]\n",
  "DRAMMED": "DRAM, to tipple, drink a small measure of whisky [v]\n",
  "DRAMMING": "DRAM, to tipple, drink a small measure of whisky [v]\n",
  "DRAMMOCK": "(Gaelic) a mixture of raw meal and water, also DRAMMACH, DRUMMOCK [n -S]\n",
  "DRAMMOCKS": "DRAMMOCK, (Gaelic) a mixture of raw meal and water, also DRAMMACH, DRUMMOCK [n]\n",
  "DRAMS": "DRAM, to tipple, drink a small measure of whisky [v]\n",
  "DRAMSHOP": "a shop or barroom where spirits are sold by the dram [n -S]\n",
  "DRAMSHOPS": "DRAMSHOP, a shop or barroom where spirits are sold by the dram [n]\n",
  "DRANGWAY": "(English dialect) a narrow passageway [n -S]\n",
  "DRANGWAYS": "DRANGWAY, (English dialect) a narrow passageway [n]\n",
  "DRANK": "DRINK, to swallow liquid [v]\n",
  "DRANT": "(dialect) to drawl, drone, also DRAUNT [v -ED, -ING, -S]\n",
  "DRANTED": "DRANT, (dialect) to drawl, drone, also DRAUNT [v]\n",
  "DRANTING": "DRANT, (dialect) to drawl, drone, also DRAUNT [v]\n",
  "DRANTS": "DRANT, (dialect) to drawl, drone, also DRAUNT [v]\n",
  "DRAP": "(Scots) to drop [v DRAPPED, DRAPPING, DRAPS]\n",
  "DRAPABILITIES": "DRAPABILITY, the state of being drapable, also DRAPEABILITY [n]\n",
  "DRAPABILITY": "the state of being drapable, also DRAPEABILITY [n DRAPABILITIES]\n",
  "DRAPABLE": "that can be draped, also DRAPEABLE [adj]\n",
  "DRAPE": "to arrange in graceful folds [v DRAPED, DRAPING, DRAPES]\n",
  "DRAPEABILITIES": "DRAPEABILITY, the state of being drapeable, also DRAPABILITY [n]\n",
  "DRAPEABILITY": "the state of being drapeable, also DRAPABILITY [n DRAPEABILITIES]\n",
  "DRAPEABLE": "that can be draped, also DRAPABLE [adj]\n",
  "DRAPED": "DRAPE, to arrange in graceful folds [v]\n",
  "DRAPER": "a dealer in cloth [n -S]\n",
  "DRAPERIED": "DRAPERY, to drape [v]\n",
  "DRAPERIES": "DRAPERY, to drape [v]\n",
  "DRAPERS": "DRAPER, a dealer in cloth [n]\n",
  "DRAPERY": "cloth, textiles etc. [n DRAPERIES] / to drape [v DRAPERIED, DRAPERYING, DRAPERIES]\n",
  "DRAPERYING": "DRAPERY, to drape [v]\n",
  "DRAPES": "DRAPE, to arrange in graceful folds [v]\n",
  "DRAPET": "(Spenser) a cloth covering [n -S]\n",
  "DRAPETS": "DRAPET, (Spenser) a cloth covering [n]\n",
  "DRAPEY": "characterized by graceful folds [adj DRAPIER, DRAPIEST]\n",
  "DRAPIER": "(obsolete) one whose job it is to drape e.g. figures in a shop window [n -S]\n",
  "DRAPIERS": "DRAPIER, (obsolete) one whose job it is to drape e.g. figures in a shop window [n]\n",
  "DRAPIEST": "DRAPEY, characterized by graceful folds [adj]\n",
  "DRAPING": "DRAPE, to arrange in graceful folds [v]\n",
  "DRAPPED": "DRAP, (Scots) to drop [v]\n",
  "DRAPPIE": "(Scots) a little drop, esp. of spirits, also DRAPPY [n -S]\n",
  "DRAPPIES": "DRAPPY, (Scots) a little drop, esp. of spirits, also DRAPPIE [n]\n",
  "DRAPPING": "DRAP, (Scots) to drop [v]\n",
  "DRAPPY": "(Scots) a little drop, esp. of spirits, also DRAPPIE [n DRAPPIES]\n",
  "DRAPS": "DRAP, (Scots) to drop [v]\n",
  "DRASTIC": "severe [adj DRASTICALLY] / a severe purgative [n -S]\n",
  "DRASTICALLY": "DRASTIC, severe [adv]\n",
  "DRASTICS": "DRASTIC, a severe purgative [n]\n",
  "DRAT": "to damn [v DRATTED, DRATTING, DRATS]\n",
  "DRATCHELL": "a slut, also DRAZEL [n -S]\n",
  "DRATCHELLS": "DRATCHELL, a slut, also DRAZEL [n]\n",
  "DRATS": "DRAT, to damn [v]\n",
  "DRATTED": "DRAT, to damn [v]\n",
  "DRATTING": "DRAT, to damn [v]\n",
  "DRAUGHT": "to draft [v -ED, -ING, -S]\n",
  "DRAUGHTBOARD": "a board for the playing of draughts [n -S]\n",
  "DRAUGHTBOARDS": "DRAUGHTBOARD, a board for the playing of draughts [n]\n",
  "DRAUGHTED": "DRAUGHT, to draft [v]\n",
  "DRAUGHTER": "one who makes a draft [n -S]\n",
  "DRAUGHTERS": "DRAUGHTER, one who makes a draft [n]\n",
  "DRAUGHTIER": "DRAUGHTY, exposed to currents of air, also DRAFTY [adj]\n",
  "DRAUGHTIEST": "DRAUGHTY, exposed to currents of air, also DRAFTY [adj]\n",
  "DRAUGHTILY": "DRAUGHTY, exposed to currents of air, also DRAFTY [adv]\n",
  "DRAUGHTINESS": "the state of being draughty [n -ES]\n",
  "DRAUGHTINESSES": "DRAUGHTINESS, the state of being draughty [n]\n",
  "DRAUGHTING": "DRAUGHT, to draft [v]\n",
  "DRAUGHTMAN": "a piece used in playing draughts [n DRAUGHTMEN]\n",
  "DRAUGHTMEN": "DRAUGHTMAN, a piece used in playing draughts [n]\n",
  "DRAUGHTPROOF": "to make proof against draughts [v -ED, -ING, -S]\n",
  "DRAUGHTPROOFED": "DRAUGHTPROOF, to make proof against draughts [v]\n",
  "DRAUGHTPROOFING": "DRAUGHTPROOF, to make proof against draughts [v]\n",
  "DRAUGHTPROOFS": "DRAUGHTPROOF, to make proof against draughts [v]\n",
  "DRAUGHTS": "DRAUGHT, to draft [v]\n",
  "DRAUGHTSMAN": "a person whose profession is to make drawings, plans, or sketches, also DRAFTSMAN [n DRAUGHTSMEN]\n",
  "DRAUGHTSMANSHIP": "the craft of draughtsman [n]\n",
  "DRAUGHTSMEN": "DRAUGHTSMAN, a person whose profession is to make drawings, plans, or sketches, also DRAFTSMAN [n]\n",
  "DRAUGHTSPERSON": "a gender-neutral term for draughtsman or draughtswoman [n -S]\n",
  "DRAUGHTSPERSONS": "DRAUGHTSPERSON, a gender-neutral term for draughtsman or draughtswoman [n]\n",
  "DRAUGHTSWOMAN": "a female draughtsman [n DRAUGHTSWOMEN]\n",
  "DRAUGHTSWOMEN": "DRAUGHTSWOMAN, a female draughtsman [n]\n",
  "DRAUGHTY": "exposed to currents of air, also DRAFTY [adj DRAUGHTIER, DRAUGHTIEST, DRAUGHTILY]\n",
  "DRAUNT": "(dialect) to drawl, to drone, also DRANT [v -ED, -ING, -S]\n",
  "DRAUNTED": "DRAUNT, (dialect) to drawl, to drone, also DRANT [v]\n",
  "DRAUNTING": "DRAUNT, (dialect) to drawl, to drone, also DRANT [v]\n",
  "DRAUNTS": "DRAUNT, (dialect) to drawl, to drone, also DRANT [v]\n",
  "DRAVE": "DRIVE, to urge or convey forward [v]\n",
  "DRAW": "to move by pulling [v DREW, DRAWN, DRAWING, DRAWS]\n",
  "DRAWABLE": "able to be drawn [adj]\n",
  "DRAWBACK": "a hinderance [n -S]\n",
  "DRAWBACKS": "DRAWBACK, a hinderance [n]\n",
  "DRAWBAR": "a sliding bar [n -S]\n",
  "DRAWBARS": "DRAWBAR, a sliding bar [n]\n",
  "DRAWBORE": "a hole for joining a mortise and tenon [n -S]\n",
  "DRAWBORES": "DRAWBORE, a hole for joining a mortise and tenon [n]\n",
  "DRAWBRIDGE": "a bridge that can be drawn up or let down as required [n -S]\n",
  "DRAWBRIDGES": "DRAWBRIDGE, a bridge that can be drawn up or let down as required [n]\n",
  "DRAWCARD": "a drawing card [n -S]\n",
  "DRAWCARDS": "DRAWCARD, a drawing card [n]\n",
  "DRAWCORD": "a cord for drawing a garment tight [n -S]\n",
  "DRAWCORDS": "DRAWCORD, a cord for drawing a garment tight [n]\n",
  "DRAWDOWN": "a reduction, a diminution [n -S]\n",
  "DRAWDOWNS": "DRAWDOWN, a reduction, a diminution [n]\n",
  "DRAWEE": "the person on whom a bill of exchange is drawn [n -S]\n",
  "DRAWEES": "DRAWEE, the person on whom a bill of exchange is drawn [n]\n",
  "DRAWER": "one that draws [n -S]\n",
  "DRAWERFUL": "the contents of a drawer [n -S]\n",
  "DRAWERFULS": "DRAWERFUL, the contents of a drawer [n]\n",
  "DRAWERS": "DRAWER, one that draws [n]\n",
  "DRAWING": "a portrayal in lines of a form or figure [n -S]\n",
  "DRAWINGS": "DRAWING, a portrayal in lines of a form or figure [n]\n",
  "DRAWKNIFE": "a carpentry tool, also DRAWSHAVE [n DRAWKNIVES]\n",
  "DRAWKNIVES": "DRAWKNIFE, a carpentry tool, also DRAWSHAVE [n]\n",
  "DRAWL": "to speak slowly with drawn out vowels [v -ED, -ING, -S]\n",
  "DRAWLED": "DRAWL, to speak slowly with drawn out vowels [v]\n",
  "DRAWLER": "one who drawls [n -S]\n",
  "DRAWLERS": "DRAWLER, one who drawls [n]\n",
  "DRAWLIER": "DRAWLY, marked by drawling [adj]\n",
  "DRAWLIEST": "DRAWLY, marked by drawling [adj]\n",
  "DRAWLING": "DRAWL, to speak slowly with drawn out vowels [v]\n",
  "DRAWLINGLY": "DRAWLING, DRAWL, to speak slowly with drawn out vowels [adv]\n",
  "DRAWLINGNESS": "the state of being drawling [n -ES]\n",
  "DRAWLINGNESSES": "DRAWLINGNESS, the state of being drawling [n]\n",
  "DRAWLS": "DRAWL, to speak slowly with drawn out vowels [v]\n",
  "DRAWLY": "marked by drawling [adj DRAWLIER, DRAWLIEST]\n",
  "DRAWN": "DRAW, to move by pulling [v]\n",
  "DRAWNWORK": "ornamental needlework done by pulling out some of the threads of a fabric [n -S]\n",
  "DRAWNWORKS": "DRAWNWORK, ornamental needlework done by pulling out some of the threads of a fabric [n]\n",
  "DRAWPLATE": "a hardened steel plate having a hole, or a gradation of conical holes, through which wires are drawn to be reduced and elongated [n -S]\n",
  "DRAWPLATES": "DRAWPLATE, a hardened steel plate having a hole, or a gradation of conical holes, through which wires are drawn to be reduced and elongated [n]\n",
  "DRAWS": "DRAW, to move by pulling [v]\n",
  "DRAWSHAVE": "a carpentry tool, also DRAWKNIFE [n -S]\n",
  "DRAWSHAVES": "DRAWSHAVE, a carpentry tool, also DRAWKNIFE [n]\n",
  "DRAWSTRING": "a cord for drawing tight e.g. round a hood [n -S]\n",
  "DRAWSTRINGS": "DRAWSTRING, a cord for drawing tight e.g. round a hood [n]\n",
  "DRAWTUBE": "a tube that slides within another tube [n -S]\n",
  "DRAWTUBES": "DRAWTUBE, a tube that slides within another tube [n]\n",
  "DRAY": "a low heavy cart used for haulage [n -S] / to transport by dray [v -ED, -ING, -S]\n",
  "DRAYAGE": "transportation by dray [n -S]\n",
  "DRAYAGES": "DRAYAGE, transportation by dray [n]\n",
  "DRAYED": "DRAY, to transport by dray [v]\n",
  "DRAYHORSE": "a horse used to pull a dray [n -S]\n",
  "DRAYHORSES": "DRAYHORSE, a horse used to pull a dray [n]\n",
  "DRAYING": "DRAY, to transport by dray [v]\n",
  "DRAYMAN": "one who drives a dray [n DRAYMEN]\n",
  "DRAYMEN": "DRAYMAN, one who drives a dray [n]\n",
  "DRAYS": "DRAY, to transport by dray [v]\n",
  "DRAZEL": "(dialect) a slut; a vagabond wench, also DRATCHELL [n -S]\n",
  "DRAZELS": "DRAZEL, (dialect) a slut; a vagabond wench, also DRATCHELL [n]\n",
  "DREAD": "inspiring fear [adj DREADER, DREADEST] / to fear greatly [v DREADED or (obsolete) DRAD, YDRED, YDRAD, DREADING, DREADS]\n",
  "DREADED": "DREAD, to fear greatly [v]\n",
  "DREADER": "someone who dreads [n -S]\n",
  "DREADERS": "DREADER, someone who dreads [n]\n",
  "DREADEST": "DREAD, inspiring fear [adj]\n",
  "DREADFUL": "awful [adj DREADFULLY] / a lurid novel [n -S]\n",
  "DREADFULLY": "DREADFUL, awful [adv]\n",
  "DREADFULNESS": "the state of being dreadful [n -ES]\n",
  "DREADFULNESSES": "DREADFULNESS, the state of being dreadful [n]\n",
  "DREADFULS": "DREADFUL, a lurid novel [n]\n",
  "DREADING": "DREAD, to fear greatly [v]\n",
  "DREADLESS": "free from dread [adj DREADLESSLY]\n",
  "DREADLESSLY": "DREADLESS, free from dread [adv]\n",
  "DREADLESSNESS": "the state of being dreadless [n -ES]\n",
  "DREADLESSNESSES": "DREADLESSNESS, the state of being dreadless [n]\n",
  "DREADLOCK": "a hairstyle favoured by Afro-Americans [n -S]\n",
  "DREADLOCKED": "having dreadlocks [adj]\n",
  "DREADLOCKS": "DREADLOCK, a hairstyle favoured by Afro-Americans [n]\n",
  "DREADLY": "dreadful [adj]\n",
  "DREADNAUGHT": "a large battleship; a garment of heavy woollen cloth, also DREADNOUGHT [n -S]\n",
  "DREADNAUGHTS": "DREADNAUGHT, a large battleship; a garment of heavy woollen cloth, also DREADNOUGHT [n]\n",
  "DREADNOUGHT": "a large battleship; a garment of heavy woollen cloth, also DREADNAUGHT [n -S]\n",
  "DREADNOUGHTS": "DREADNOUGHT, a large battleship; a garment of heavy woollen cloth, also DREADNAUGHT [n]\n",
  "DREADS": "DREAD, to fear greatly [v]\n",
  "DREAM": "to experience thoughts and images during sleep [v DREAMED, DREAMT, DREAMING, DREAMS]\n",
  "DREAMBOAT": "someone wonderful and desirable, usually of the opposite sex [n -S]\n",
  "DREAMBOATS": "DREAMBOAT, someone wonderful and desirable, usually of the opposite sex [n]\n",
  "DREAMED": "DREAM, to experience thoughts and images during sleep [v]\n",
  "DREAMER": "one that dreams [n -S]\n",
  "DREAMERIES": "DREAMERY, a place favourable to dreams [n]\n",
  "DREAMERS": "DREAMER, one that dreams [n]\n",
  "DREAMERY": "a place favourable to dreams [n DREAMERIES]\n",
  "DREAMFUL": "full of dreams [adj DREAMFULLY]\n",
  "DREAMFULLY": "DREAMFUL, full of dreams [adv]\n",
  "DREAMFULNESS": "the state of being dreamful [n -ES]\n",
  "DREAMFULNESSES": "DREAMFULNESS, the state of being dreamful [n]\n",
  "DREAMHOLE": "a hole in the wall of a tower, steeple etc. admitting light [n -S]\n",
  "DREAMHOLES": "DREAMHOLE, a hole in the wall of a tower, steeple etc. admitting light [n]\n",
  "DREAMIER": "DREAMY, full of dreams [adj]\n",
  "DREAMIEST": "DREAMY, full of dreams [adj]\n",
  "DREAMILY": "DREAMY, full of dreams [adv]\n",
  "DREAMINESS": "the state of being dreamy [n -ES]\n",
  "DREAMINESSES": "DREAMINESS, the state of being dreamy [n]\n",
  "DREAMING": "in a state of dreaming [adj DREAMINGLY] / the act of dreaming [n -S]\n",
  "DREAMINGLY": "DREAMING, in a state of dreaming [adv]\n",
  "DREAMINGS": "DREAMING, the act of dreaming [n]\n",
  "DREAMLAND": "an unreal, delightful country such as in sometimes pictured in dreams [n -S]\n",
  "DREAMLANDS": "DREAMLAND, an unreal, delightful country such as in sometimes pictured in dreams [n]\n",
  "DREAMLESS": "free from, or without, dreams [adj DREAMLESSLY]\n",
  "DREAMLESSLY": "DREAMLESS, free from, or without, dreams [adv]\n",
  "DREAMLESSNESS": "DREAMLESS, free from, or without, dreams [n]\n",
  "DREAMLESSNESSES": "DREAMLESSNESS, DREAMLESS, free from, or without, dreams [n]\n",
  "DREAMLIKE": "like a dream [adj]\n",
  "DREAMS": "DREAM, to experience thoughts and images during sleep [v]\n",
  "DREAMT": "DREAM, to experience thoughts and images during sleep [v]\n",
  "DREAMTIME": "in the mythology of Australian Aboriginals, the time when the earth and patterns of life on earth took shape [n -S]\n",
  "DREAMTIMES": "DREAMTIME, in the mythology of Australian Aboriginals, the time when the earth and patterns of life on earth took shape [n]\n",
  "DREAMWHILE": "the duration of a dream [n -S]\n",
  "DREAMWHILES": "DREAMWHILE, the duration of a dream [n]\n",
  "DREAMWORLD": "a world of illusion or fantasy [n -S]\n",
  "DREAMWORLDS": "DREAMWORLD, a world of illusion or fantasy [n]\n",
  "DREAMY": "full of dreams [adj DREAMIER, DREAMIEST, DREAMILY]\n",
  "DREAR": "gloom [n -S] / dreary, also DREARE, DRERE [adj DREARER, DREAREST]\n",
  "DREARE": "(Spenser) dreariness, gloom, also DRERE [n -S]\n",
  "DREARER": "DREAR, dreary, also DREARE, DRERE [adj]\n",
  "DREARES": "DREARE, (Spenser) dreariness, gloom, also DRERE [n]\n",
  "DREAREST": "DREAR, dreary, also DREARE, DRERE [adj]\n",
  "DREARIER": "DREARY, dismal [adj]\n",
  "DREARIES": "DREARY, a dismal person [n]\n",
  "DREARIEST": "DREARY, dismal [adj]\n",
  "DREARIHEAD": "(Spenser) affliction; dreariness, also DREARIHOOD, DRERIHEAD [n -S]\n",
  "DREARIHEADS": "DREARIHEAD, (Spenser) affliction; dreariness, also DREARIHOOD, DRERIHEAD [n]\n",
  "DREARIHOOD": "(Spenser) affliction; dreariness, also DREARIHEAD, DRERIHEAD [n -S]\n",
  "DREARIHOODS": "DREARIHOOD, (Spenser) affliction; dreariness, also DREARIHEAD, DRERIHEAD [n]\n",
  "DREARILY": "DREARY, dismal [adv]\n",
  "DREARIMENT": "(Spenser) dreariness [n -S]\n",
  "DREARIMENTS": "DREARIMENT, (Spenser) dreariness [n]\n",
  "DREARINESS": "the state of being dreary [n -ES]\n",
  "DREARINESSES": "DREARINESS, the state of being dreary [n]\n",
  "DREARING": "(Spenser) dreariness [n -S]\n",
  "DREARINGS": "DREARING, (Spenser) dreariness [n]\n",
  "DREARISOME": "very dreary [adj]\n",
  "DREARS": "DREAR, gloom [n]\n",
  "DREARY": "a dismal person [n DREARIES] / dismal [adj DREARIER, DREARIEST, DREARILY]\n",
  "DRECK": "(Yiddish) inferior merchandise, rubbish, also DREK [n -S]\n",
  "DRECKIER": "DRECKY, rubbishy, also DREKKY [adj]\n",
  "DRECKIEST": "DRECKY, rubbishy, also DREKKY [adj]\n",
  "DRECKISH": "like dreck, rubbish [adj]\n",
  "DRECKS": "DRECK, (Yiddish) inferior merchandise, rubbish, also DREK [n]\n",
  "DRECKSILL": "(dialect) a doorstep [n -S]\n",
  "DRECKSILLS": "DRECKSILL, (dialect) a doorstep [n]\n",
  "DRECKY": "rubbishy, also DREKKY [adj DRECKIER, DRECKIEST]\n",
  "DREDGE": "to scoop mud with a machine [v DREDGED, DREDGING, DREDGES]\n",
  "DREDGED": "DREDGE, to scoop mud with a machine [v]\n",
  "DREDGER": "a boat or machine used for dredging [n -S]\n",
  "DREDGERS": "DREDGER, a boat or machine used for dredging [n]\n",
  "DREDGES": "DREDGE, to scoop mud with a machine [v]\n",
  "DREDGING": "matter that is dredged up [n -S]\n",
  "DREDGINGS": "DREDGING, matter that is dredged up [n]\n",
  "DREE": "(Scots) dreary [adj DREER, DREEST] / to suffer, endure [v DREED, DREEING, DREES]\n",
  "DREED": "DREE, to suffer, endure [v]\n",
  "DREEING": "DREE, to suffer, endure [v]\n",
  "DREER": "DREE, (Scots) dreary [adj]\n",
  "DREES": "DREE, to suffer, endure [v]\n",
  "DREEST": "DREE, (Scots) dreary [adj]\n",
  "DREG": "the sediment of liquors [n -S]\n",
  "DREGGIER": "DREGGY, full of dregs [adj]\n",
  "DREGGIEST": "DREGGY, full of dregs [adj]\n",
  "DREGGINESS": "fullness of dregs or lees [n -ES]\n",
  "DREGGINESSES": "DREGGINESS, fullness of dregs or lees [n]\n",
  "DREGGISH": "somewhat dreggy [adj]\n",
  "DREGGY": "full of dregs [adj DREGGIER, DREGGIEST]\n",
  "DREGS": "DREG, the sediment of liquors [n]\n",
  "DREICH": "(Scots) dreary, also DREIGH [adj DREICHER, DREICHEST]\n",
  "DREICHER": "DREICH, (Scots) dreary, also DREIGH [adj]\n",
  "DREICHEST": "DREICH, (Scots) dreary, also DREIGH [adj]\n",
  "DREIDEL": "(Yiddish) a four-sided toy marked with Hebrew letters and spun like a top; a children's game of chance played with this esp. at Hanukkah, also DREIDL [n -S]\n",
  "DREIDELS": "DREIDEL, (Yiddish) a four-sided toy marked with Hebrew letters and spun like a top; a children's game of chance played with this esp. at Hanukkah, also DREIDL [n]\n",
  "DREIDL": "(Yiddish) a four-sided toy marked with Hebrew letters and spun like a top; a children's game of chance played with this esp. at Hanukkah, also DREIDEL [n -S]\n",
  "DREIDLS": "DREIDL, (Yiddish) a four-sided toy marked with Hebrew letters and spun like a top; a children's game of chance played with this esp. at Hanukkah, also DREIDEL [n]\n",
  "DREIGH": "(Scots) dreary, also DREICH, DRIEGH [adj DREIGHER, DREIGHEST]\n",
  "DREIGHER": "DREIGH, (Scots) dreary, also DREICH, DRIEGH [adj]\n",
  "DREIGHEST": "DREIGH, (Scots) dreary, also DREICH, DRIEGH [adj]\n",
  "DREIKANTER": "(German) a three-faced pebble worn by wind [n -S]\n",
  "DREIKANTERS": "DREIKANTER, (German) a three-faced pebble worn by wind [n]\n",
  "DREK": "(Yiddish) inferior merchandise, rubbish, also DRECK [n -S]\n",
  "DREKKIER": "DREKKY, rubbishy, also DRECKY [adj]\n",
  "DREKKIEST": "DREKKY, rubbishy, also DRECKY [adj]\n",
  "DREKKY": "rubbishy, also DRECKY [adj DREKKIER, DREKKIEST]\n",
  "DREKS": "DREK, (Yiddish) inferior merchandise, rubbish, also DRECK [n]\n",
  "DRENCH": "to wet thoroughly [v DRENCHED or (Spenser) DRENT, DRENCHING, DRENCHES]\n",
  "DRENCHED": "DRENCH, to wet thoroughly [v]\n",
  "DRENCHER": "something that drenches [n -S]\n",
  "DRENCHERS": "DRENCHER, something that drenches [n]\n",
  "DRENCHES": "DRENCH, to wet thoroughly [v]\n",
  "DRENCHING": "the act of drenching [n -S]\n",
  "DRENCHINGS": "DRENCHING, the act of drenching [n]\n",
  "DRENT": "DRENCH, to wet thoroughly [v]\n",
  "DREPANID": "a hook-tip moth [n -S]\n",
  "DREPANIDS": "DREPANID, a hook-tip moth [n]\n",
  "DREPANIUM": "a kind of cymose inflorescence [n -S]\n",
  "DREPANIUMS": "DREPANIUM, a kind of cymose inflorescence [n]\n",
  "DRERE": "(Spenser) dreariness, gloom, also DREARE [n -S]\n",
  "DRERES": "DRERE, (Spenser) dreariness, gloom, also DREARE [n]\n",
  "DRERIHEAD": "(Spenser) dreariness, also DREARIHEAD, DREARIHOOD [n -S]\n",
  "DRERIHEADS": "DRERIHEAD, (Spenser) dreariness, also DREARIHEAD, DREARIHOOD [n]\n",
  "DRESS": "to put clothes on [v DREST or DRESSED, DRESSING, DRESSES]\n",
  "DRESSAGE": "(French) the training of a horse in deportment and control [n -S]\n",
  "DRESSAGES": "DRESSAGE, (French) the training of a horse in deportment and control [n]\n",
  "DRESSED": "DRESS, to put clothes on [v]\n",
  "DRESSER": "one that dresses [n -S]\n",
  "DRESSERS": "DRESSER, one that dresses [n]\n",
  "DRESSES": "DRESS, to put clothes on [v]\n",
  "DRESSGUARD": "(archaic) an arrangement of strings used to protect a rider's dress from contact with a bicycle wheel [n -S]\n",
  "DRESSGUARDS": "DRESSGUARD, (archaic) an arrangement of strings used to protect a rider's dress from contact with a bicycle wheel [n]\n",
  "DRESSIER": "DRESSY, showy in dress [adj]\n",
  "DRESSIEST": "DRESSY, showy in dress [adj]\n",
  "DRESSILY": "DRESSY, showy in dress [adv]\n",
  "DRESSINESS": "the state of being dressy [n -ES]\n",
  "DRESSINESSES": "DRESSINESS, the state of being dressy [n]\n",
  "DRESSING": "material applied to a wound [n -S]\n",
  "DRESSINGS": "DRESSING, material applied to a wound [n]\n",
  "DRESSMADE": "DRESSMAKE, to make dresses [v]\n",
  "DRESSMAKE": "to make dresses [v DRESSMADE, DRESSMAKING, DRESSMAKES]\n",
  "DRESSMAKER": "one that makes dresses [n -S]\n",
  "DRESSMAKERS": "DRESSMAKER, one that makes dresses [n]\n",
  "DRESSMAKES": "DRESSMAKE, to make dresses [v]\n",
  "DRESSMAKING": "the craft of making dresses [n -S]\n",
  "DRESSMAKINGS": "DRESSMAKING, the craft of making dresses [n]\n",
  "DRESSY": "showy in dress [adj DRESSIER, DRESSIEST, DRESSILY]\n",
  "DREST": "DRESS, to put clothes on [v]\n",
  "DREVILL": "(Spenser) a foul person [n -S]\n",
  "DREVILLS": "DREVILL, (Spenser) a foul person [n]\n",
  "DREW": "DRAW, to move by pulling [v]\n",
  "DREY": "a squirrel's nest [n -S]\n",
  "DREYS": "DREY, a squirrel's nest [n]\n",
  "DRIB": "to do by little and little [v DRIBBED, DRIBBING, DRIBS]\n",
  "DRIBBED": "DRIB, to do by little and little [v]\n",
  "DRIBBER": "(obsolete) one who shoots arrows weakly or badly [n -S]\n",
  "DRIBBERS": "DRIBBER, (obsolete) one who shoots arrows weakly or badly [n]\n",
  "DRIBBING": "DRIB, to do by little and little [v]\n",
  "DRIBBLE": "to let saliva flow from the mouth [v DRIBBLED, DRIBBLING, DRIBBLES]\n",
  "DRIBBLED": "DRIBBLE, to let saliva flow from the mouth [v]\n",
  "DRIBBLER": "one who dribbles [n -S]\n",
  "DRIBBLERS": "DRIBBLER, one who dribbles [n]\n",
  "DRIBBLES": "DRIBBLE, to let saliva flow from the mouth [v]\n",
  "DRIBBLET": "a small drop of liquid, also DRIBLET [n -S]\n",
  "DRIBBLETS": "DRIBBLET, a small drop of liquid, also DRIBLET [n]\n",
  "DRIBBLIER": "DRIBBLY, given to dribbling [adj]\n",
  "DRIBBLIEST": "DRIBBLY, given to dribbling [adj]\n",
  "DRIBBLING": "the act of propelling a football with repeated small taps [n -S]\n",
  "DRIBBLINGS": "DRIBBLING, the act of propelling a football with repeated small taps [n]\n",
  "DRIBBLY": "given to dribbling [adj DRIBBLIER, DRIBBLIEST]\n",
  "DRIBLET": "a small drop of liquid, also DRIBBLET [n -S]\n",
  "DRIBLETS": "DRIBLET, a small drop of liquid, also DRIBBLET [n]\n",
  "DRIBS": "DRIB, to do by little and little [v]\n",
  "DRICE": "dry ice or frozen granular carbon dioxide [n -S]\n",
  "DRICES": "DRICE, dry ice or frozen granular carbon dioxide [n]\n",
  "DRICKSIE": "of timber, having hidden decayed spots, also DRUXY [adj DRICKSIER, DRICKSIEST]\n",
  "DRICKSIER": "DRICKSIE, of timber, having hidden decayed spots, also DRUXY [adj]\n",
  "DRICKSIEST": "DRICKSIE, of timber, having hidden decayed spots, also DRUXY [adj]\n",
  "DRIED": "DRY, to remove the moisture from [v]\n",
  "DRIEGH": "(Scots) dreary, also DREICH, DREIGH [adj]\n",
  "DRIER": "an apparatus for drying, also DRYER [n -S]\n",
  "DRIERS": "DRIER, an apparatus for drying, also DRYER [n]\n",
  "DRIES": "DRY, to remove the moisture from [v]\n",
  "DRIEST": "DRY, having no moisture [adj]\n",
  "DRIFT": "to drift along in a current [v -ED, -ING, -S]\n",
  "DRIFTAGE": "deviation from a ship's course due to leeway [n -S]\n",
  "DRIFTAGES": "DRIFTAGE, deviation from a ship's course due to leeway [n]\n",
  "DRIFTED": "DRIFT, to drift along in a current [v]\n",
  "DRIFTER": "one that drifts [n -S]\n",
  "DRIFTERS": "DRIFTER, one that drifts [n]\n",
  "DRIFTIER": "DRIFTY, full of masses of wind-driven snow [adj]\n",
  "DRIFTIEST": "DRIFTY, full of masses of wind-driven snow [adj]\n",
  "DRIFTING": "the act of moving with the wind [n -S]\n",
  "DRIFTINGLY": "DRIFTING [adv]\n",
  "DRIFTINGS": "DRIFTING, the act of moving with the wind [n]\n",
  "DRIFTLESS": "without drift [adj]\n",
  "DRIFTNET": "a large fishnet arranged to drift with the tide or current [n -S]\n",
  "DRIFTNETS": "DRIFTNET, a large fishnet arranged to drift with the tide or current [n]\n",
  "DRIFTPIN": "a metal pin for securing timbers [n -S]\n",
  "DRIFTPINS": "DRIFTPIN, a metal pin for securing timbers [n]\n",
  "DRIFTS": "DRIFT, to drift along in a current [v]\n",
  "DRIFTWOOD": "wood drifted or floated by water [n -S]\n",
  "DRIFTWOODS": "DRIFTWOOD, wood drifted or floated by water [n]\n",
  "DRIFTY": "full of masses of wind-driven snow [adj DRIFTIER, DRIFTIEST]\n",
  "DRILL": "to bore a hole in [v -ED, -ING, -S]\n",
  "DRILLABILITIES": "DRILLABILITY, the state of being drillable [n]\n",
  "DRILLABILITY": "the state of being drillable [n DRILLABILITIES]\n",
  "DRILLABLE": "that can be drilled [adj]\n",
  "DRILLED": "DRILL, to bore a hole in [v]\n",
  "DRILLER": "one who drills [n -S]\n",
  "DRILLERS": "DRILLER, one who drills [n]\n",
  "DRILLHOLE": "a hole bored in the ground e.g. for rock samples [n -S]\n",
  "DRILLHOLES": "DRILLHOLE, a hole bored in the ground e.g. for rock samples [n]\n",
  "DRILLING": "a heavy twilled cotton fabric [n -S]\n",
  "DRILLINGS": "DRILLING, a heavy twilled cotton fabric [n]\n",
  "DRILLMASTER": "an instructor in military drill [n -S]\n",
  "DRILLMASTERS": "DRILLMASTER, an instructor in military drill [n]\n",
  "DRILLS": "DRILL, to bore a hole in [v]\n",
  "DRILLSHIP": "a free-floating ship-shaped drilling platform [n -S]\n",
  "DRILLSHIPS": "DRILLSHIP, a free-floating ship-shaped drilling platform [n]\n",
  "DRILLSTOCK": "the part of a machine tool that holds the shank of a drill or bit, aka chuck [n -S]\n",
  "DRILLSTOCKS": "DRILLSTOCK, the part of a machine tool that holds the shank of a drill or bit, aka chuck [n]\n",
  "DRILY": "DRY, having no moisture [adv]\n",
  "DRINK": "to swallow liquid [v DRANK, DRUNK, DRUNKEN, DRINKING, DRINKS]\n",
  "DRINKABILITIES": "DRINKABILITY, the state of being drinkable [n]\n",
  "DRINKABILITY": "the state of being drinkable [n DRINKABILITIES]\n",
  "DRINKABLE": "capable of being drunk [adj DRINKABLY] / something drinkable [n -S]\n",
  "DRINKABLENESS": "the state of being drinkable [n -ES]\n",
  "DRINKABLENESSES": "DRINKABLENESS, the state of being drinkable [n]\n",
  "DRINKABLES": "DRINKABLE, something drinkable [n]\n",
  "DRINKABLY": "DRINKABLE, capable of being drunk [adv]\n",
  "DRINKER": "one who drinks [n -S]\n",
  "DRINKERS": "DRINKER, one who drinks [n]\n",
  "DRINKING": "the act of drinking [n -S]\n",
  "DRINKINGS": "DRINKING, the act of drinking [n]\n",
  "DRINKS": "DRINK, to swallow liquid [v]\n",
  "DRIP": "to fall in drops [v DRIPT or DRIPPED, DRIPPING, DRIPS]\n",
  "DRIPLESS": "designed not to drip [adj]\n",
  "DRIPPED": "DRIP, to fall in drops [v]\n",
  "DRIPPER": "something from liquid drips [n -S]\n",
  "DRIPPERS": "DRIPPER, something from liquid drips [n]\n",
  "DRIPPIER": "DRIPPY, silly, inane [adj]\n",
  "DRIPPIEST": "DRIPPY, silly, inane [adj]\n",
  "DRIPPILY": "DRIPPY, silly, inane [adv]\n",
  "DRIPPING": "fat from meat [n -S]\n",
  "DRIPPINGS": "DRIPPING, fat from meat [n]\n",
  "DRIPPY": "silly, inane [adj DRIPPIER, DRIPPIEST, DRIPPILY]\n",
  "DRIPS": "DRIP, to fall in drops [v]\n",
  "DRIPSTONE": "mineral matter deposited from a dripping solution e.g. stalactites [n -S]\n",
  "DRIPSTONES": "DRIPSTONE, mineral matter deposited from a dripping solution e.g. stalactites [n]\n",
  "DRIPT": "DRIP, to fall in drops [v]\n",
  "DRISHEEN": "(Irish) a type of Irish sausage made with sheep's blood [n -S]\n",
  "DRISHEENS": "DRISHEEN, (Irish) a type of Irish sausage made with sheep's blood [n]\n",
  "DRIVABILITIES": "DRIVABILITY, the ability to be driven, also DRIVEABILITY [n]\n",
  "DRIVABILITY": "the ability to be driven, also DRIVEABILITY [n DRIVABILITIES]\n",
  "DRIVABLE": "that can be driven, also DRIVEABLE [adj]\n",
  "DRIVE": "to urge or convey forward [v DROVE or DRAVE, DRIVEN, DRIVING, DRIVES]\n",
  "DRIVEABILITIES": "DRIVEABILITY, the ability to be driven, also DRIVABILITY [n]\n",
  "DRIVEABILITY": "the ability to be driven, also DRIVABILITY [n DRIVEABILITIES]\n",
  "DRIVEABLE": "that can be driven, also DRIVABLE [adj]\n",
  "DRIVEL": "to let saliva flow from the mouth [v DRIVELED or DRIVELLED, DRIVELING or DRIVELLING, DRIVELS]\n",
  "DRIVELED": "DRIVEL, to let saliva flow from the mouth [v]\n",
  "DRIVELER": "one who drivels, also DRIVELLER [n -S]\n",
  "DRIVELERS": "DRIVELER, one who drivels, also DRIVELLER [n]\n",
  "DRIVELINE": "the part that connects the transmission with the driving axles of an automobile, also DRIVETRAIN [n -S]\n",
  "DRIVELINES": "DRIVELINE, the part that connects the transmission with the driving axles of an automobile, also DRIVETRAIN [n]\n",
  "DRIVELING": "DRIVEL, to let saliva flow from the mouth [v]\n",
  "DRIVELLED": "DRIVEL, to let saliva flow from the mouth [v]\n",
  "DRIVELLER": "one who drivels, also DRIVELER [n -S]\n",
  "DRIVELLERS": "DRIVELLER, one who drivels, also DRIVELER [n]\n",
  "DRIVELLING": "DRIVEL, to let saliva flow from the mouth [v]\n",
  "DRIVELS": "DRIVEL, to let saliva flow from the mouth [v]\n",
  "DRIVEN": "DRIVE, to urge or convey forward [v]\n",
  "DRIVENNESS": "the state of being driven [n -ES]\n",
  "DRIVENNESSES": "DRIVENNESS, the state of being driven [n]\n",
  "DRIVER": "one who drives [n -S]\n",
  "DRIVERLESS": "without a driver [adj]\n",
  "DRIVERS": "DRIVER, one who drives [n]\n",
  "DRIVES": "DRIVE, to urge or convey forward [v]\n",
  "DRIVESHAFT": "a shaft from a driving wheel communicating motion to machinery [n -S]\n",
  "DRIVESHAFTS": "DRIVESHAFT, a shaft from a driving wheel communicating motion to machinery [n]\n",
  "DRIVETHROUGH": "a shop or restaurant designed so that customers can be served without leaving their cars [n -S]\n",
  "DRIVETHROUGHS": "DRIVETHROUGH, a shop or restaurant designed so that customers can be served without leaving their cars [n]\n",
  "DRIVETRAIN": "the parts that connect the transmission with the driving axles of an automobile, also DRIVELINE [n -S]\n",
  "DRIVETRAINS": "DRIVETRAIN, the parts that connect the transmission with the driving axles of an automobile, also DRIVELINE [n]\n",
  "DRIVEWAY": "a private road providing access to a building [n -S]\n",
  "DRIVEWAYS": "DRIVEWAY, a private road providing access to a building [n]\n",
  "DRIVING": "of rain, heavy and windblown [adj DRIVINGLY] / the act of driving [n -S]\n",
  "DRIVINGLY": "DRIVING, of rain, heavy and windblown [adv]\n",
  "DRIVINGS": "DRIVING, the act of driving [n]\n",
  "DRIZZLE": "to rain lightly [v DRIZZLED, DRIZZLING, DRIZZLES]\n",
  "DRIZZLED": "DRIZZLE, to rain lightly [v]\n",
  "DRIZZLES": "DRIZZLE, to rain lightly [v]\n",
  "DRIZZLIER": "DRIZZLY, marked by light rain [adj]\n",
  "DRIZZLIEST": "DRIZZLY, marked by light rain [adj]\n",
  "DRIZZLING": "DRIZZLE, to rain lightly [v]\n",
  "DRIZZLINGLY": "DRIZZLING, DRIZZLE, to rain lightly [adv]\n",
  "DRIZZLY": "marked by light rain [adj DRIZZLIER, DRIZZLIEST]\n",
  "DROGER": "(Dutch) a W. Indian coasting vessel, with long masts and lateen sails, also DROGHER [n -S]\n",
  "DROGERS": "DROGER, (Dutch) a W. Indian coasting vessel, with long masts and lateen sails, also DROGHER [n]\n",
  "DROGHER": "(Dutch) a W. Indian coasting vessel, with long masts and lateen sails, also DROGER [n -S]\n",
  "DROGHERS": "DROGHER, (Dutch) a W. Indian coasting vessel, with long masts and lateen sails, also DROGER [n]\n",
  "DROGUE": "a funnel-shaped sea anchor; a type of parachute [n -S]\n",
  "DROGUES": "DROGUE, a funnel-shaped sea anchor; a type of parachute [n]\n",
  "DROGUET": "(French) a ribbed woollen dress, also DRUGGET [n -S]\n",
  "DROGUETS": "DROGUET, (French) a ribbed woollen dress, also DRUGGET [n]\n",
  "DROICH": "(Gaelic) a dwarf [n -S]\n",
  "DROICHIER": "DROICHY, (Gaelic) dwarfish [adj]\n",
  "DROICHIEST": "DROICHY, (Gaelic) dwarfish [adj]\n",
  "DROICHS": "DROICH, (Gaelic) a dwarf [n]\n",
  "DROICHY": "(Gaelic) dwarfish [adj DROICHIER, DROICHIEST]\n",
  "DROID": "(colloquial) an android [n -S]\n",
  "DROIDS": "DROID, (colloquial) an android [n]\n",
  "DROIL": "(obsolete) to drudge [v -ED, -ING, -S]\n",
  "DROILED": "DROIL, (obsolete) to drudge [v]\n",
  "DROILING": "DROIL, (obsolete) to drudge [v]\n",
  "DROILS": "DROIL, (obsolete) to drudge [v]\n",
  "DROIT": "(French) a legal right [n -S]\n",
  "DROITS": "DROIT, (French) a legal right [n]\n",
  "DROKE": "(Canadian) a valley with steeply sloping sides [n -S]\n",
  "DROKES": "DROKE, (Canadian) a valley with steeply sloping sides [n]\n",
  "DROLE": "a rogue or knave [n -S] / amusing [adj DROLER, DROLEST]\n",
  "DROLER": "DROLE, amusing [adj]\n",
  "DROLES": "DROLE, a rogue or knave [n]\n",
  "DROLEST": "DROLE, amusing [adj]\n",
  "DROLL": "to jest [v -ED, -ING, -S] / quaintly amusing [adj DROLLER, DROLLEST, DROLLY]\n",
  "DROLLED": "DROLL, to jest [v]\n",
  "DROLLER": "DROLL, quaintly amusing [adj]\n",
  "DROLLERIES": "DROLLERY, something droll [n]\n",
  "DROLLERY": "something droll [n DROLLERIES]\n",
  "DROLLEST": "DROLL, quaintly amusing [adj]\n",
  "DROLLING": "the act of a jester [n -S]\n",
  "DROLLINGS": "DROLLING, the act of a jester [n]\n",
  "DROLLISH": "rather droll [adj]\n",
  "DROLLNESS": "the state of being droll [n -ES]\n",
  "DROLLNESSES": "DROLLNESS, the state of being droll [n]\n",
  "DROLLS": "DROLL, to jest [v]\n",
  "DROLLY": "DROLL, quaintly amusing [adv]\n",
  "DROME": "(colloquial) an aerodrome [n -S]\n",
  "DROMEDARE": "(Spenser) a dromedary, also DROMEDARY [n -S]\n",
  "DROMEDARES": "DROMEDARE, (Spenser) a dromedary, also DROMEDARY [n]\n",
  "DROMEDARIES": "DROMEDARY, the Arabian camel, having one hump or protuberance on the back, in distinction from the Bactrian camel, which has two humps, also DROMEDARE [n]\n",
  "DROMEDARY": "the Arabian camel, having one hump or protuberance on the back, in distinction from the Bactrian camel, which has two humps, also DROMEDARE [n DROMEDARIES]\n",
  "DROMES": "DROME, (colloquial) an aerodrome [n]\n",
  "DROMIC": "relating to a racecourse, also DROMICAL [adj]\n",
  "DROMICAL": "relating to a racecourse, also DROMIC [adj]\n",
  "DROMOI": "DROMOS, (Greek) a Greek racecourse; an entrance or subterranean passage [n]\n",
  "DROMON": "a large fast-sailing medieval galley, also DROMOND [n -S]\n",
  "DROMOND": "a large fast-sailing medieval galley, also DROMON [n -S]\n",
  "DROMONDS": "DROMOND, a large fast-sailing medieval galley, also DROMON [n]\n",
  "DROMONS": "DROMON, a large fast-sailing medieval galley, also DROMOND [n]\n",
  "DROMOPHOBIA": "a fear of crossing streets [n -S]\n",
  "DROMOPHOBIAS": "DROMOPHOBIA, a fear of crossing streets [n]\n",
  "DROMOS": "(Greek) a Greek racecourse; an entrance or subterranean passage [n DROMOI]\n",
  "DRONE": "to make a monotonous humming sound [v DRONED, DRONING, DRONES]\n",
  "DRONED": "DRONE, to make a monotonous humming sound [v]\n",
  "DRONER": "one who drones [n -S]\n",
  "DRONERS": "DRONER, one who drones [n]\n",
  "DRONES": "DRONE, to make a monotonous humming sound [v]\n",
  "DRONGO": "(Australian slang) a no-hoper [n DRONGOS or DRONGOES]\n",
  "DRONGOES": "DRONGO, (Australian slang) a no-hoper [n]\n",
  "DRONGOS": "DRONGO, (Australian slang) a no-hoper [n]\n",
  "DRONIER": "DRONY, monotonous [adj]\n",
  "DRONIEST": "DRONY, monotonous [adj]\n",
  "DRONING": "DRONE, to make a monotonous humming sound [v]\n",
  "DRONINGLY": "DRONING, DRONE, to make a monotonous humming sound [adv]\n",
  "DRONISH": "like a drone; idle [adj DRONISHLY]\n",
  "DRONISHLY": "DRONISH, like a drone; idle [adv]\n",
  "DRONISHNESS": "the state of being dronish [n -ES]\n",
  "DRONISHNESSES": "DRONISHNESS, the state of being dronish [n]\n",
  "DRONKLAP": "(South African) a drunkard [n -S]\n",
  "DRONKLAPS": "DRONKLAP, (South African) a drunkard [n]\n",
  "DRONKVERDRIET": "(South African) depressed after the consumption of alcohol [adj]\n",
  "DRONY": "monotonous [adj DRONIER, DRONIEST]\n",
  "DROOB": "(Australian slang) a pathetic person [n -S]\n",
  "DROOBS": "DROOB, (Australian slang) a pathetic person [n]\n",
  "DROOG": "(Russian) a violent hooligan [n -S]\n",
  "DROOGISH": "like a droog [adj]\n",
  "DROOGS": "DROOG, (Russian) a violent hooligan [n]\n",
  "DROOK": "(Scots) to drench, also DROUK [v DROOKED, DROOKIT, DROOKING, DROOKS]\n",
  "DROOKED": "DROOK, (Scots) to drench, also DROUK [v]\n",
  "DROOKING": "a drenching, also DROUKING [n -S]\n",
  "DROOKINGS": "DROOKING, a drenching, also DROUKING [n]\n",
  "DROOKIT": "(Scots) drenched, also DROUKIT [adj]\n",
  "DROOKS": "DROOK, (Scots) to drench, also DROUK [v]\n",
  "DROOL": "to let saliva flow from the mouth [v -ED, -ING, -S]\n",
  "DROOLED": "DROOL, to let saliva flow from the mouth [v]\n",
  "DROOLIER": "DROOLY, drooling [adj]\n",
  "DROOLIEST": "DROOLY, drooling [adj]\n",
  "DROOLING": "DROOL, to let saliva flow from the mouth [v]\n",
  "DROOLS": "DROOL, to let saliva flow from the mouth [v]\n",
  "DROOLWORTHIER": "DROOLWORTHY, inspiring or likely to inspire excessive enthusiasm or pleasure; extremely attractive or desirable [adj]\n",
  "DROOLWORTHIEST": "DROOLWORTHY, inspiring or likely to inspire excessive enthusiasm or pleasure; extremely attractive or desirable [adj]\n",
  "DROOLWORTHY": "inspiring or likely to inspire excessive enthusiasm or pleasure; extremely attractive or desirable [adj DROOLWORTHIER, DROOLWORTHIEST]\n",
  "DROOLY": "drooling [adj DROOLIER, DROOLIEST]\n",
  "DROOME": "(Spenser) a drum [n -S]\n",
  "DROOMES": "DROOME, (Spenser) a drum [n]\n",
  "DROOP": "to hang downward [v -ED, -ING, -S]\n",
  "DROOPED": "DROOP, to hang downward [v]\n",
  "DROOPIER": "DROOPY, hanging [adj]\n",
  "DROOPIEST": "DROOPY, hanging [adj]\n",
  "DROOPILY": "DROOPY, hanging [adv]\n",
  "DROOPINESS": "the state of being droopy [n -ES]\n",
  "DROOPINESSES": "DROOPINESS, the state of being droopy [n]\n",
  "DROOPING": "DROOP, to hang downward [v]\n",
  "DROOPINGLY": "DROOPING, DROOP, to hang downward [adv]\n",
  "DROOPS": "DROOP, to hang downward [v]\n",
  "DROOPY": "hanging [adj DROOPIER, DROOPIEST, DROOPILY]\n",
  "DROP": "to let fall in globules [v DROPT or DROPPED, DROPPING, DROPS]\n",
  "DROPCLOTH": "a cloth dropped on the floor to catch drips from painting [n -S]\n",
  "DROPCLOTHS": "DROPCLOTH, a cloth dropped on the floor to catch drips from painting [n]\n",
  "DROPDOWN": "a menu that appears on a computer screen beneath a selected item [n -S]\n",
  "DROPDOWNS": "DROPDOWN, a menu that appears on a computer screen beneath a selected item [n]\n",
  "DROPFLIES": "DROPFLY, an angling fly [n]\n",
  "DROPFLY": "an angling fly [n DROPFLIES]\n",
  "DROPFORGE": "to forge metal between two dies [v DROPFORGED, DROPFORGING, DROPFORGES]\n",
  "DROPFORGED": "DROPFORGE, to forge metal between two dies [v]\n",
  "DROPFORGES": "DROPFORGE, to forge metal between two dies [v]\n",
  "DROPFORGING": "DROPFORGE, to forge metal between two dies [v]\n",
  "DROPHEAD": "a convertible car [n -S]\n",
  "DROPHEADS": "DROPHEAD, a convertible car [n]\n",
  "DROPKICK": "a kick made by both feet while jumping in the air [n -S]\n",
  "DROPKICKER": "one who takes dropkicks [n -S]\n",
  "DROPKICKERS": "DROPKICKER, one who takes dropkicks [n]\n",
  "DROPKICKS": "DROPKICK, a kick made by both feet while jumping in the air [n]\n",
  "DROPLET": "a tiny drop [n -S]\n",
  "DROPLETS": "DROPLET, a tiny drop [n]\n",
  "DROPLIGHT": "an apparatus for bringing artificial light down from a chandelier nearer to a table or desk [n -S]\n",
  "DROPLIGHTS": "DROPLIGHT, an apparatus for bringing artificial light down from a chandelier nearer to a table or desk [n]\n",
  "DROPLIKE": "like a drop [adj]\n",
  "DROPLOCK": "a bank loan for which interest rates vary with the market, but if the long-term interest rates fall to a specified level it is converted to a fixed-rate long-term bond [n -S]\n",
  "DROPLOCKS": "DROPLOCK, a bank loan for which interest rates vary with the market, but if the long-term interest rates fall to a specified level it is converted to a fixed-rate long-term bond [n]\n",
  "DROPOUT": "one who drops out of normal society [n -S]\n",
  "DROPOUTS": "DROPOUT, one who drops out of normal society [n]\n",
  "DROPPABLE": "that can be dropped [adj]\n",
  "DROPPED": "DROP, to let fall in globules [v]\n",
  "DROPPER": "a tube for dispensing liquid in drops [n -S]\n",
  "DROPPERFUL": "the contents of a dropper [n DROPPERFULS or DROPPERSFUL]\n",
  "DROPPERFULS": "DROPPERFUL, the contents of a dropper [n]\n",
  "DROPPERS": "DROPPER, a tube for dispensing liquid in drops [n]\n",
  "DROPPERSFUL": "DROPPERFUL, the contents of a dropper [n]\n",
  "DROPPING": "something that has been dropped [n -S]\n",
  "DROPPINGS": "DROPPING, something that has been dropped [n]\n",
  "DROPPLE": "a trickle [n -S]\n",
  "DROPPLES": "DROPPLE, a trickle [n]\n",
  "DROPS": "DROP, to let fall in globules [v]\n",
  "DROPSEED": "a type of grass [n -S]\n",
  "DROPSEEDS": "DROPSEED, a type of grass [n]\n",
  "DROPSHOT": "a type of shot in tennis [n -S]\n",
  "DROPSHOTS": "DROPSHOT, a type of shot in tennis [n]\n",
  "DROPSICAL": "of, pertaining to, or of the nature of dropsy [adj DROPSICALLY]\n",
  "DROPSICALLY": "DROPSICAL, of, pertaining to, or of the nature of dropsy [adv]\n",
  "DROPSIED": "(Shakespeare) diseased with dropsy [adj]\n",
  "DROPSIES": "DROPSY, unnatural accumulation of serous fluid [n]\n",
  "DROPSONDE": "a radiosonde dropped by parachute [n -S]\n",
  "DROPSONDES": "DROPSONDE, a radiosonde dropped by parachute [n]\n",
  "DROPSTONE": "a stone embedded in a sedimentary deposit and believed to have got there after being released from a melting glacier [n -S]\n",
  "DROPSTONES": "DROPSTONE, a stone embedded in a sedimentary deposit and believed to have got there after being released from a melting glacier [n]\n",
  "DROPSY": "unnatural accumulation of serous fluid [n DROPSIES]\n",
  "DROPT": "DROP, to let fall in globules [v]\n",
  "DROPTOP": "a convertible automobile [n -S]\n",
  "DROPTOPS": "DROPTOP, a convertible automobile [n]\n",
  "DROPWISE": "by drops [adv]\n",
  "DROPWORT": "a wild flower, a species of Spiraea [n -S]\n",
  "DROPWORTS": "DROPWORT, a wild flower, a species of Spiraea [n]\n",
  "DROSERA": "a genus of insectivorous plants that includes the sundew [n -S]\n",
  "DROSERACEOUS": "belonging to the Drosera genus, sundews [adj]\n",
  "DROSERAS": "DROSERA, a genus of insectivorous plants that includes the sundew [n]\n",
  "DROSHKIES": "DROSHKY, (Russian) an open carriage, also DROSKY [n]\n",
  "DROSHKY": "(Russian) an open carriage, also DROSKY [n DROSHKIES]\n",
  "DROSKIES": "DROSKY, (Russian) an open carriage, also DROSHKY [n]\n",
  "DROSKY": "(Russian) an open carriage, also DROSHKY [n DROSKIES]\n",
  "DROSOMETER": "an instrument for measuring dew [n -S]\n",
  "DROSOMETERS": "DROSOMETER, an instrument for measuring dew [n]\n",
  "DROSOPHILA": "a kind of fruit-fly [n DROSOPHILAS or DROSOPHILAE]\n",
  "DROSOPHILAE": "DROSOPHILA, a kind of fruit-fly [n]\n",
  "DROSOPHILAS": "DROSOPHILA, a kind of fruit-fly [n]\n",
  "DROSS": "waste matter [n -ES]\n",
  "DROSSES": "DROSS, waste matter [n]\n",
  "DROSSIER": "DROSSY, worthless [adj]\n",
  "DROSSIEST": "DROSSY, worthless [adj]\n",
  "DROSSINESS": "the quality of being drossy [n -ES]\n",
  "DROSSINESSES": "DROSSINESS, the quality of being drossy [n]\n",
  "DROSSY": "worthless [adj DROSSIER, DROSSIEST]\n",
  "DROSTDIES": "DROSTDY, (South African) a type of South African house [n]\n",
  "DROSTDY": "(South African) a type of South African house [n DROSTDIES or DROSTDYS]\n",
  "DROSTDYS": "DROSTDY, (South African) a type of South African house [n]\n",
  "DROUGHT": "a dry period [n -S]\n",
  "DROUGHTIER": "DROUGHTY, dry, also DROUTHY [adj]\n",
  "DROUGHTIEST": "DROUGHTY, dry, also DROUTHY [adj]\n",
  "DROUGHTINESS": "the state of being droughty [n -ES]\n",
  "DROUGHTINESSES": "DROUGHTINESS, the state of being droughty [n]\n",
  "DROUGHTS": "DROUGHT, a dry period [n]\n",
  "DROUGHTY": "dry, also DROUTHY [adj DROUGHTIER, DROUGHTIEST]\n",
  "DROUK": "(Scots) to drench, also DROOK [v DROUKED, DROUKIT, DROUKING, DROUKS]\n",
  "DROUKED": "DROUK, (Scots) to drench, also DROOK [v]\n",
  "DROUKING": "a drenching, also DROOKING [n -S]\n",
  "DROUKINGS": "DROUKING, a drenching, also DROOKING [n]\n",
  "DROUKIT": "(Scots) drenched, also DROOKIT [adj]\n",
  "DROUKS": "DROUK, (Scots) to drench, also DROOK [v]\n",
  "DROUTH": "drought [n -S]\n",
  "DROUTHIER": "DROUTHY, dry, also DROUGHTY [adj]\n",
  "DROUTHIEST": "DROUTHY, dry, also DROUGHTY [adj]\n",
  "DROUTHINESS": "the state of being drouthy [n -ES]\n",
  "DROUTHINESSES": "DROUTHINESS, the state of being drouthy [n]\n",
  "DROUTHS": "DROUTH, drought [n]\n",
  "DROUTHY": "dry, also DROUGHTY [adj DROUTHIER, DROUTHIEST]\n",
  "DROVE": "to drive sheep or cattle [v DROVED, DROVING, DROVES]\n",
  "DROVED": "DROVE, to drive sheep or cattle [v]\n",
  "DROVER": "a driver of cattle or sheep [n -S]\n",
  "DROVERS": "DROVER, a driver of cattle or sheep [n]\n",
  "DROVES": "DROVE, to drive sheep or cattle [v]\n",
  "DROVING": "the action of herding cattle [n -S]\n",
  "DROVINGS": "DROVING, the action of herding cattle [n]\n",
  "DROW": "(Scots) wet mist [n -S]\n",
  "DROWN": "to suffocate in water [v -ED, -ING, -S]\n",
  "DROWND": "(colloquial) to drown [v -ED, -ING, -S]\n",
  "DROWNDED": "DROWND, (colloquial) to drown [v]\n",
  "DROWNDING": "DROWND, (colloquial) to drown [v]\n",
  "DROWNDS": "DROWND, (colloquial) to drown [v]\n",
  "DROWNED": "DROWN, to suffocate in water [v]\n",
  "DROWNER": "one who drowns [n -S]\n",
  "DROWNERS": "DROWNER, one who drowns [n]\n",
  "DROWNING": "an instance of someone drowning [n -S]\n",
  "DROWNINGS": "DROWNING, an instance of someone drowning [n]\n",
  "DROWNS": "DROWN, to suffocate in water [v]\n",
  "DROWS": "DROW, (Scots) wet mist [n]\n",
  "DROWSE": "to doze [v DROWSED, DROWSING, DROWSES]\n",
  "DROWSED": "DROWSE, to doze [v]\n",
  "DROWSES": "DROWSE, to doze [v]\n",
  "DROWSIER": "DROWSY, sleepy [adj]\n",
  "DROWSIEST": "DROWSY, sleepy [adj]\n",
  "DROWSIHEAD": "(Spenser) drowsiness, also DROWSIHED [n -S]\n",
  "DROWSIHEADS": "DROWSIHEAD, (Spenser) drowsiness, also DROWSIHED [n]\n",
  "DROWSIHED": "(Spenser) drowsiness, also DROWSIHEAD [n -S]\n",
  "DROWSIHEDS": "DROWSIHED, (Spenser) drowsiness, also DROWSIHEAD [n]\n",
  "DROWSILY": "DROWSY, sleepy [adv]\n",
  "DROWSINESS": "the state of being drowsy [n -ES]\n",
  "DROWSINESSES": "DROWSINESS, the state of being drowsy [n]\n",
  "DROWSING": "DROWSE, to doze [v]\n",
  "DROWSY": "sleepy [adj DROWSIER, DROWSIEST, DROWSILY]\n",
  "DRUB": "to beat severely [v DRUBBED, DRUBBING, DRUBS]\n",
  "DRUBBED": "DRUB, to beat severely [v]\n",
  "DRUBBER": "one who drubs [n -S]\n",
  "DRUBBERS": "DRUBBER, one who drubs [n]\n",
  "DRUBBING": "a cudgelling [n -S]\n",
  "DRUBBINGS": "DRUBBING, a cudgelling [n]\n",
  "DRUBS": "DRUB, to beat severely [v]\n",
  "DRUCKEN": "(Scots) drunken [adj]\n",
  "DRUCKENNESS": "the state of being drucken [n -ES]\n",
  "DRUCKENNESSES": "DRUCKENNESS, the state of being drucken [n]\n",
  "DRUDGE": "to do hard, tedious work [v DRUDGED, DRUDGING, DRUDGES]\n",
  "DRUDGED": "DRUDGE, to do hard, tedious work [v]\n",
  "DRUDGER": "one who drudges [n -S]\n",
  "DRUDGERIES": "DRUDGERY, hard, tedious work [n]\n",
  "DRUDGERS": "DRUDGER, one who drudges [n]\n",
  "DRUDGERY": "hard, tedious work [n DRUDGERIES]\n",
  "DRUDGES": "DRUDGE, to do hard, tedious work [v]\n",
  "DRUDGING": "DRUDGE, to do hard, tedious work [v]\n",
  "DRUDGINGLY": "DRUDGING, DRUDGE, to do hard, tedious work [adv]\n",
  "DRUDGISM": "uninteresting work [n -S]\n",
  "DRUDGISMS": "DRUDGISM, uninteresting work [n]\n",
  "DRUG": "to dose with a medicinal substance [v DRUGGED, DRUGGING, DRUGS]\n",
  "DRUGGED": "DRUG, to dose with a medicinal substance [v]\n",
  "DRUGGER": "one who drugs [n -S]\n",
  "DRUGGERS": "DRUGGER, one who drugs [n]\n",
  "DRUGGET": "a coarse durable wool fabric, also DROGUET [n -S]\n",
  "DRUGGETS": "DRUGGET, a coarse durable wool fabric, also DROGUET [n]\n",
  "DRUGGIE": "(colloquial) a drug addict [n -S]\n",
  "DRUGGIER": "DRUGGY, affected by drugs [adj]\n",
  "DRUGGIES": "DRUGGIE, (colloquial) a drug addict [n]\n",
  "DRUGGIEST": "DRUGGY, affected by drugs [adj]\n",
  "DRUGGING": "DRUG, to dose with a medicinal substance [v]\n",
  "DRUGGIST": "a person who deals in drugs, a pharmacist [n -S]\n",
  "DRUGGISTS": "DRUGGIST, a person who deals in drugs, a pharmacist [n]\n",
  "DRUGGY": "affected by drugs [adj DRUGGIER, DRUGGIEST]\n",
  "DRUGLESS": "being without drugs [adj]\n",
  "DRUGLORD": "a criminal controlling the supply of drugs [n -S]\n",
  "DRUGLORDS": "DRUGLORD, a criminal controlling the supply of drugs [n]\n",
  "DRUGMAKER": "one who manufactures drugs [n -S]\n",
  "DRUGMAKERS": "DRUGMAKER, one who manufactures drugs [n]\n",
  "DRUGS": "DRUG, to dose with a medicinal substance [v]\n",
  "DRUGSTER": "a drug addict [n -S]\n",
  "DRUGSTERS": "DRUGSTER, a drug addict [n]\n",
  "DRUGSTORE": "(US) a chemist's shop [n -S]\n",
  "DRUGSTORES": "DRUGSTORE, (US) a chemist's shop [n]\n",
  "DRUID": "one of an ancient order of Celtic priests [n -S]\n",
  "DRUIDESS": "a female druid [n -ES]\n",
  "DRUIDESSES": "DRUIDESS, a female druid [n]\n",
  "DRUIDIC": "pertaining to, or resembling, the Druids, also DRUIDICAL [adj]\n",
  "DRUIDICAL": "pertaining to, or resembling, the Druids, also DRUIDIC [adj]\n",
  "DRUIDISM": "the religious system of the druids [n -S]\n",
  "DRUIDISMS": "DRUIDISM, the religious system of the druids [n]\n",
  "DRUIDRIES": "DRUIDRY, the practice of druids [n]\n",
  "DRUIDRY": "the practice of druids [n DRUIDRIES]\n",
  "DRUIDS": "DRUID, one of an ancient order of Celtic priests [n]\n",
  "DRUM": "to beat a percussion instrument [v DRUMMED, DRUMMING, DRUMS]\n",
  "DRUMBEAT": "the sound of a drum [n -S]\n",
  "DRUMBEATER": "one who makes drumbeats [n -S]\n",
  "DRUMBEATERS": "DRUMBEATER, one who makes drumbeats [n]\n",
  "DRUMBEATING": "the beating of a drum [n -S]\n",
  "DRUMBEATINGS": "DRUMBEATING, the beating of a drum [n]\n",
  "DRUMBEATS": "DRUMBEAT, the sound of a drum [n]\n",
  "DRUMBLE": "(dialect) to move slowly [v DRUMBLED, DRUMBLING, DRUMBLES]\n",
  "DRUMBLED": "DRUMBLE, (dialect) to move slowly [v]\n",
  "DRUMBLEDOR": "a large flying beetle, also DUMBLEDORE [n -S]\n",
  "DRUMBLEDORS": "DRUMBLEDOR, a large flying beetle, also DUMBLEDORE [n]\n",
  "DRUMBLEDRANE": "(dialect) a bumble bee [n -S]\n",
  "DRUMBLEDRANES": "DRUMBLEDRANE, (dialect) a bumble bee [n]\n",
  "DRUMBLES": "DRUMBLE, (dialect) to move slowly [v]\n",
  "DRUMBLING": "DRUMBLE, (dialect) to move slowly [v]\n",
  "DRUMFIRE": "massed artillery fire with a rolling sound [n -S]\n",
  "DRUMFIRES": "DRUMFIRE, massed artillery fire with a rolling sound [n]\n",
  "DRUMFISH": "a fish that makes a drumming sound [n -ES]\n",
  "DRUMFISHES": "DRUMFISH, a fish that makes a drumming sound [n]\n",
  "DRUMHEAD": "the material stretched over the end of a drum [n -S]\n",
  "DRUMHEADS": "DRUMHEAD, the material stretched over the end of a drum [n]\n",
  "DRUMLIER": "DRUMLY, (Scots) turbid, muddy, gloomy [adj]\n",
  "DRUMLIEST": "DRUMLY, (Scots) turbid, muddy, gloomy [adj]\n",
  "DRUMLIKE": "resembling the head of a drum [adj]\n",
  "DRUMLIN": "a long hill of glacial drift [n -S]\n",
  "DRUMLINS": "DRUMLIN, a long hill of glacial drift [n]\n",
  "DRUMLY": "(Scots) turbid, muddy, gloomy [adj DRUMLIER, DRUMLIEST]\n",
  "DRUMMED": "DRUM, to beat a percussion instrument [v]\n",
  "DRUMMER": "one who plays a drum [n -S]\n",
  "DRUMMERS": "DRUMMER, one who plays a drum [n]\n",
  "DRUMMIES": "DRUMMY, (South African) a drum majorette [n]\n",
  "DRUMMING": "the sound made by a drum [n -S]\n",
  "DRUMMINGS": "DRUMMING, the sound made by a drum [n]\n",
  "DRUMMOCK": "(Gaelic) a mixture of raw meal and water, also DRAMMOCK, DRAMMACH [n -S]\n",
  "DRUMMOCKS": "DRUMMOCK, (Gaelic) a mixture of raw meal and water, also DRAMMOCK, DRAMMACH [n]\n",
  "DRUMMY": "(South African) a drum majorette [n DRUMMIES]\n",
  "DRUMROLL": "a roll played on a drum [n -S]\n",
  "DRUMROLLS": "DRUMROLL, a roll played on a drum [n]\n",
  "DRUMS": "DRUM, to beat a percussion instrument [v]\n",
  "DRUMSTICK": "a stick with which a drum is beaten [n -S]\n",
  "DRUMSTICKS": "DRUMSTICK, a stick with which a drum is beaten [n]\n",
  "DRUNK": "intoxicated [adj DRUNKER, DRUNKEST] / an intoxicated person [n -S]\n",
  "DRUNKALOGUE": "an account of a person's problems with alcohol [n -S]\n",
  "DRUNKALOGUES": "DRUNKALOGUE, an account of a person's problems with alcohol [n]\n",
  "DRUNKARD": "one who is habitually drunk [n -S]\n",
  "DRUNKARDS": "DRUNKARD, one who is habitually drunk [n]\n",
  "DRUNKATHON": "a prolonged drinking session [n -S]\n",
  "DRUNKATHONS": "DRUNKATHON, a prolonged drinking session [n]\n",
  "DRUNKEN": "drunk [adj DRUNKENLY]\n",
  "DRUNKENLY": "DRUNKEN, drunk [adv]\n",
  "DRUNKENNESS": "the state of being drunken [n -ES]\n",
  "DRUNKENNESSES": "DRUNKENNESS, the state of being drunken [n]\n",
  "DRUNKER": "DRUNK, intoxicated [adj]\n",
  "DRUNKEST": "DRUNK, intoxicated [adj]\n",
  "DRUNKISH": "somewhat drunk [adj]\n",
  "DRUNKOMETER": "a device for measuring how much alcohol there is on someone's breath [n -S]\n",
  "DRUNKOMETERS": "DRUNKOMETER, a device for measuring how much alcohol there is on someone's breath [n]\n",
  "DRUNKS": "DRUNK, an intoxicated person [n]\n",
  "DRUPACEOUS": "pertaining to drupes or stone-fruits [adj]\n",
  "DRUPE": "a fleshy fruit [n -S]\n",
  "DRUPEL": "a small part of a fruit like a raspberry, also DRUPELET [n -S]\n",
  "DRUPELET": "a small part of a fruit like a raspberry, also DRUPEL [n -S]\n",
  "DRUPELETS": "DRUPELET, a small part of a fruit like a raspberry, also DRUPEL [n]\n",
  "DRUPELS": "DRUPEL, a small part of a fruit like a raspberry, also DRUPELET [n]\n",
  "DRUPES": "DRUPE, a fleshy fruit [n]\n",
  "DRUSE": "a crust of small crystals lining a rock cavity [n -S]\n",
  "DRUSEN": "DRUSE, a crust of small crystals lining a rock cavity [n]\n",
  "DRUSES": "DRUSE, a crust of small crystals lining a rock cavity [n]\n",
  "DRUSIER": "DRUSY, rough with minute crystals [adj]\n",
  "DRUSIEST": "DRUSY, rough with minute crystals [adj]\n",
  "DRUSY": "rough with minute crystals [adj DRUSIER, DRUSIEST]\n",
  "DRUTHER": "one's preference [n -S]\n",
  "DRUTHERS": "DRUTHER, one's preference [n]\n",
  "DRUXIER": "DRUXY, of timber, having hidden decayed spots, also DRICKSIE [adj]\n",
  "DRUXIEST": "DRUXY, of timber, having hidden decayed spots, also DRICKSIE [adj]\n",
  "DRUXY": "of timber, having hidden decayed spots, also DRICKSIE [adj DRUXIER, DRUXIEST]\n",
  "DRY": "having no moisture [adj DRIER or DRYER, DRIEST or DRYEST, DRILY or DRYLY] / a prohibitionist [n DRIES or DRYS] / to remove the moisture from [v DRIED, DRYING, DRIES]\n",
  "DRYABLE": "able to be dried [adj]\n",
  "DRYAD": "(Greek) a nymph of the woods [n DRYADS or DRYADES]\n",
  "DRYADES": "DRYAD, (Greek) a nymph of the woods [n]\n",
  "DRYADIC": "like a dryad [adj]\n",
  "DRYADS": "DRYAD, (Greek) a nymph of the woods [n]\n",
  "DRYAS": "a flowering alpine plant [n DRYAS]\n",
  "DRYASDUST": "boring; pedantic [adj] / a boring person [n -S]\n",
  "DRYASDUSTS": "DRYASDUST, a boring person [n]\n",
  "DRYBEAT": "(Shakespeare) to beat without drawing blood [v DRYBEAT, DRYBEATEN, DRYBEATING, DRYBEATS]\n",
  "DRYBEATEN": "DRYBEAT, (Shakespeare) to beat without drawing blood [v]\n",
  "DRYBEATING": "DRYBEAT, (Shakespeare) to beat without drawing blood [v]\n",
  "DRYBEATS": "DRYBEAT, (Shakespeare) to beat without drawing blood [v]\n",
  "DRYER": "an apparatus for drying, also DRIER [n -S]\n",
  "DRYERS": "DRYER, an apparatus for drying, also DRIER [n]\n",
  "DRYEST": "DRY, having no moisture [adj]\n",
  "DRYING": "the act of drying [n -S]\n",
  "DRYINGS": "DRYING, the act of drying [n]\n",
  "DRYISH": "somewhat dry [adj]\n",
  "DRYLAND": "an arid region [n -S]\n",
  "DRYLANDS": "DRYLAND, an arid region [n]\n",
  "DRYLOT": "an enclosure for livestock [n -S]\n",
  "DRYLOTS": "DRYLOT, an enclosure for livestock [n]\n",
  "DRYLY": "DRY, having no moisture [adv]\n",
  "DRYMOUTH": "excessive dryness of the mouth [n -S]\n",
  "DRYMOUTHS": "DRYMOUTH, excessive dryness of the mouth [n]\n",
  "DRYNESS": "the state of being dry [n -ES]\n",
  "DRYNESSES": "DRYNESS, the state of being dry [n]\n",
  "DRYOPITHECINE": "a gorilla, chimpanzee or man [n -S]\n",
  "DRYOPITHECINES": "DRYOPITHECINE, a gorilla, chimpanzee or man [n]\n",
  "DRYPOINT": "a sharp needle by which fine lines are drawn in copper engraving [n -S]\n",
  "DRYPOINTS": "DRYPOINT, a sharp needle by which fine lines are drawn in copper engraving [n]\n",
  "DRYS": "DRY, a prohibitionist [n]\n",
  "DRYSALTER": "a seller of dry goods and chemicals [n -S]\n",
  "DRYSALTERIES": "DRYSALTERY, the articles kept by a drysalter; also, the business of a drysalter [n]\n",
  "DRYSALTERS": "DRYSALTER, a seller of dry goods and chemicals [n]\n",
  "DRYSALTERY": "the articles kept by a drysalter; also, the business of a drysalter [n DRYSALTERIES]\n",
  "DRYSTONE": "built from stones without using mortar [adj]\n",
  "DRYSUIT": "a close-fitting air- and watertight synthetic suit for wearing in esp. cold water, that retains warmth by a layer of air, and allows clothing to be worn underneath it [n -S]\n",
  "DRYSUITS": "DRYSUIT, a close-fitting air- and watertight synthetic suit for wearing in esp. cold water, that retains warmth by a layer of air, and allows clothing to be worn underneath it [n]\n",
  "DRYWALL": "board used in walls instead of plaster [n -S] / to build with drywalls [v -ED, -ING, -S]\n",
  "DRYWALLED": "DRYWALL, to build with drywalls [v]\n",
  "DRYWALLER": "one who constructs drystone walls [n -S]\n",
  "DRYWALLERS": "DRYWALLER, one who constructs drystone walls [n]\n",
  "DRYWALLING": "the act of building a drywall [n -S]\n",
  "DRYWALLINGS": "DRYWALLING, the act of building a drywall [n]\n",
  "DRYWALLS": "DRYWALL, to build with drywalls [v]\n",
  "DRYWELL": "a hole for receiving drainage from a roof [n -S]\n",
  "DRYWELLS": "DRYWELL, a hole for receiving drainage from a roof [n]\n",
  "DSO": "a cross between a yak and a cow, also DZHO, DZO, ZHO, ZO [n -S]\n",
  "DSOBO": "(Tibetan) a male zo, also ZOBO, ZOBU [n -S]\n",
  "DSOBOS": "DSOBO, (Tibetan) a male zo, also ZOBO, ZOBU [n]\n",
  "DSOMO": "(Tibetan) a female zo, also JOMO, ZHOMO [n -S]\n",
  "DSOMOS": "DSOMO, (Tibetan) a female zo, also JOMO, ZHOMO [n]\n",
  "DSOS": "DSO, a cross between a yak and a cow, also DZHO, DZO, ZHO, ZO [n]\n",
  "DUAD": "a pair, also DYAD [n -S]\n",
  "DUADS": "DUAD, a pair, also DYAD [n]\n",
  "DUAL": "twofold [adj DUALLY] / to make a road into a dual carriageway [v DUALLED, DUALLING, DUALS]\n",
  "DUALIN": "an explosive mixture of sawdust, saltpetre and nitroglycerine [n -S]\n",
  "DUALINS": "DUALIN, an explosive mixture of sawdust, saltpetre and nitroglycerine [n]\n",
  "DUALISE": "to make twofold, also DUALIZE [v DUALISED, DUALISING, DUALISES]\n",
  "DUALISED": "DUALISE, to make twofold, also DUALIZE [v]\n",
  "DUALISES": "DUALISE, to make twofold, also DUALIZE [v]\n",
  "DUALISING": "DUALISE, to make twofold, also DUALIZE [v]\n",
  "DUALISM": "the doctrine of two distinct principles of good and evil, or of two divine beings of these characters [n -S]\n",
  "DUALISMS": "DUALISM, the doctrine of two distinct principles of good and evil, or of two divine beings of these characters [n]\n",
  "DUALIST": "an adherent of dualism [n -S]\n",
  "DUALISTIC": "consisting of two; pertaining to dualism [adj DUALISTICALLY]\n",
  "DUALISTICALLY": "DUALISTIC, consisting of two; pertaining to dualism [adv]\n",
  "DUALISTS": "DUALIST, an adherent of dualism [n]\n",
  "DUALITIES": "DUALITY, the state of being twofold [n]\n",
  "DUALITY": "the state of being twofold [n DUALITIES]\n",
  "DUALIZE": "to make twofold, also DUALISE [v DUALIZED, DUALIZING, DUALIZES]\n",
  "DUALIZED": "DUALIZE, to make twofold, also DUALISE [v]\n",
  "DUALIZES": "DUALIZE, to make twofold, also DUALISE [v]\n",
  "DUALIZING": "DUALIZE, to make twofold, also DUALISE [v]\n",
  "DUALLED": "DUAL, to make a road into a dual carriageway [v]\n",
  "DUALLIE": "a pickup truck with double rear wheels [n -S]\n",
  "DUALLIES": "DUALLIE, a pickup truck with double rear wheels [n]\n",
  "DUALLING": "DUAL, to make a road into a dual carriageway [v]\n",
  "DUALLY": "DUAL, twofold [adv]\n",
  "DUALS": "DUAL, to make a road into a dual carriageway [v]\n",
  "DUAN": "(Gaelic) a division of a poem corresponding to a canto; a poem or song [n -S]\n",
  "DUANS": "DUAN, (Gaelic) a division of a poem corresponding to a canto; a poem or song [n]\n",
  "DUAR": "(Arabic) a circular Arab encampment, also DOUAR, DOWAR [n -S]\n",
  "DUARCHIES": "DUARCHY, government by two powers, also DIARCHY, DINARCHY, DYARCHY [n]\n",
  "DUARCHY": "government by two powers, also DIARCHY, DINARCHY, DYARCHY [n DUARCHIES]\n",
  "DUARS": "DUAR, (Arabic) a circular Arab encampment, also DOUAR, DOWAR [n]\n",
  "DUATHLETE": "someone who takes part in duathlons [n -S]\n",
  "DUATHLETES": "DUATHLETE, someone who takes part in duathlons [n]\n",
  "DUATHLON": "an athletic event where everyone runs and cycles [n -S]\n",
  "DUATHLONS": "DUATHLON, an athletic event where everyone runs and cycles [n]\n",
  "DUB": "to confer knighthood on [v DUBBED, DUBBING, DUBS]\n",
  "DUBBED": "DUB, to confer knighthood on [v]\n",
  "DUBBER": "one that dubs [n -S]\n",
  "DUBBERS": "DUBBER, one that dubs [n]\n",
  "DUBBIN": "a preparation of grease for softening and waterproofing leather [n -S] / to apply a preparation of grease to leather [v -ED, -ING, -S]\n",
  "DUBBINED": "DUBBIN, to apply a preparation of grease to leather [v]\n",
  "DUBBING": "the act of adding sound effects, etc. [n -S]\n",
  "DUBBINGS": "DUBBING, the act of adding sound effects, etc. [n]\n",
  "DUBBINING": "DUBBIN, to apply a preparation of grease to leather [v]\n",
  "DUBBINS": "DUBBIN, to apply a preparation of grease to leather [v]\n",
  "DUBBO": "(Australian slang) a stupid person [n -S]\n",
  "DUBBOS": "DUBBO, (Australian slang) a stupid person [n]\n",
  "DUBIETIES": "DUBIETY, doubtfulness [n]\n",
  "DUBIETY": "doubtfulness [n DUBIETIES]\n",
  "DUBIOSITIES": "DUBIOSITY, the state of being doubtful [n]\n",
  "DUBIOSITY": "the state of being doubtful [n DUBIOSITIES]\n",
  "DUBIOUS": "doubtful [adj DUBIOUSLY]\n",
  "DUBIOUSLY": "DUBIOUS, doubtful [adv]\n",
  "DUBIOUSNESS": "the state of being dubious [n -ES]\n",
  "DUBIOUSNESSES": "DUBIOUSNESS, the state of being dubious [n]\n",
  "DUBITABLE": "liable to be doubted; uncertain [adj DUBITABLY]\n",
  "DUBITABLY": "DUBITABLE, liable to be doubted; uncertain [adv]\n",
  "DUBITANCIES": "DUBITANCY, (obsolete) doubt [n]\n",
  "DUBITANCY": "(obsolete) doubt [n DUBITANCIES]\n",
  "DUBITATE": "to doubt [v DUBITATED, DUBITATING, DUBITATES]\n",
  "DUBITATED": "DUBITATE, to doubt [v]\n",
  "DUBITATES": "DUBITATE, to doubt [v]\n",
  "DUBITATING": "DUBITATE, to doubt [v]\n",
  "DUBITATION": "the act of doubting [n -S]\n",
  "DUBITATIONS": "DUBITATION, the act of doubting [n]\n",
  "DUBITATIVE": "relating to doubt or incertitude [adj DUBITATIVELY]\n",
  "DUBITATIVELY": "DUBITATIVE, relating to doubt or incertitude [adv]\n",
  "DUBNIUM": "an element produced by bombarding plutonium with high energy neon ions [n -S]\n",
  "DUBNIUMS": "DUBNIUM, an element produced by bombarding plutonium with high energy neon ions [n]\n",
  "DUBONNET": "(French) a red colour [n -S]\n",
  "DUBONNETS": "DUBONNET, (French) a red colour [n]\n",
  "DUBS": "DUB, to confer knighthood on [v]\n",
  "DUBSTEP": "a genre of electronic music conveying a dark and brooding atmosphere through prominent bass lines [n -S]\n",
  "DUBSTEPS": "DUBSTEP, a genre of electronic music conveying a dark and brooding atmosphere through prominent bass lines [n]\n",
  "DUCAL": "pertaining to a duke [adj DUCALLY]\n",
  "DUCALLY": "DUCAL, pertaining to a duke [adv]\n",
  "DUCAT": "(historical) a gold or silver coin of varying values, formerly much used on the Continent [n -S]\n",
  "DUCATOON": "an old silver coin in Venice and elsewhere [n -S]\n",
  "DUCATOONS": "DUCATOON, an old silver coin in Venice and elsewhere [n]\n",
  "DUCATS": "DUCAT, (historical) a gold or silver coin of varying values, formerly much used on the Continent [n]\n",
  "DUCDAME": "(Shakespeare) a meaningless refrain [int]\n",
  "DUCE": "(Italian) a leader [n DUCI or DUCES]\n",
  "DUCES": "DUCE, (Italian) a leader [n]\n",
  "DUCHESS": "the wife or widow of a duke [n -ES] / to overwhelm with flattery [v -ED, -ING, -ES]\n",
  "DUCHESSE": "(French) a table-cover or centrepiece [n -S]\n",
  "DUCHESSED": "DUCHESS, to overwhelm with flattery [v]\n",
  "DUCHESSES": "DUCHESSE, (French) a table-cover or centrepiece [n]\n",
  "DUCHESSING": "DUCHESS, to overwhelm with flattery [v]\n",
  "DUCHIES": "DUCHY, the domain of a duke, also DUKEDOM [n]\n",
  "DUCHY": "the domain of a duke, also DUKEDOM [n DUCHIES]\n",
  "DUCI": "DUCE, (Italian) a leader [n]\n",
  "DUCK": "to bob quickly [v -ED, -ING, -S]\n",
  "DUCKBILL": "a platypus, also DUCKMOLE [n -S]\n",
  "DUCKBILLS": "DUCKBILL, a platypus, also DUCKMOLE [n]\n",
  "DUCKBOARD": "a board with slats nailed across it to help passage across wet ground [n -S]\n",
  "DUCKBOARDS": "DUCKBOARD, a board with slats nailed across it to help passage across wet ground [n]\n",
  "DUCKED": "DUCK, to bob quickly [v]\n",
  "DUCKER": "a diving-bird [n -S]\n",
  "DUCKERS": "DUCKER, a diving-bird [n]\n",
  "DUCKFOOT": "as in duckfoot quote, European quotation marks << >> [adj]\n",
  "DUCKIE": "(US slang) excellent, also DUCKY [adj DUCKIER, DUCKIEST]\n",
  "DUCKIER": "DUCKY, (US slang) excellent, also DUCKIE [adj]\n",
  "DUCKIES": "DUCKY, a term of endearment [n]\n",
  "DUCKIEST": "DUCKY, (US slang) excellent, also DUCKIE [adj]\n",
  "DUCKING": "duck-hunting [n -S]\n",
  "DUCKINGS": "DUCKING, duck-hunting [n]\n",
  "DUCKISH": "dusk [n -ES]\n",
  "DUCKISHES": "DUCKISH, dusk [n]\n",
  "DUCKLING": "a young duck [n -S]\n",
  "DUCKLINGS": "DUCKLING, a young duck [n]\n",
  "DUCKMOLE": "a platypus, also DUCKBILL [n -S]\n",
  "DUCKMOLES": "DUCKMOLE, a platypus, also DUCKBILL [n]\n",
  "DUCKPIN": "a type of bowling pin [n -S]\n",
  "DUCKPINS": "DUCKPIN, a type of bowling pin [n]\n",
  "DUCKS": "DUCK, to bob quickly [v]\n",
  "DUCKSHOVE": "(Australian colloquial) to jump a queue; to cheat; to avoid responsibilities [v DUCKSHOVED, DUCKSHOVING, DUCKSHOVES]\n",
  "DUCKSHOVED": "DUCKSHOVE, (Australian colloquial) to jump a queue; to cheat; to avoid responsibilities [v]\n",
  "DUCKSHOVER": "(Australian) one who duckshoves, jumps a queue; cheats [n -S]\n",
  "DUCKSHOVERS": "DUCKSHOVER, (Australian) one who duckshoves, jumps a queue; cheats [n]\n",
  "DUCKSHOVES": "DUCKSHOVE, (Australian colloquial) to jump a queue; to cheat; to avoid responsibilities [v]\n",
  "DUCKSHOVING": "the act of jumping a queue [n -S]\n",
  "DUCKSHOVINGS": "DUCKSHOVING, the act of jumping a queue [n]\n",
  "DUCKTAIL": "(US) a style of haircut [n -S]\n",
  "DUCKTAILS": "DUCKTAIL, (US) a style of haircut [n]\n",
  "DUCKWALK": "to do a comic walk, like a duck's [v -ED, -ING, -S]\n",
  "DUCKWALKED": "DUCKWALK, to do a comic walk, like a duck's [v]\n",
  "DUCKWALKING": "DUCKWALK, to do a comic walk, like a duck's [v]\n",
  "DUCKWALKS": "DUCKWALK, to do a comic walk, like a duck's [v]\n",
  "DUCKWEED": "any of various tiny aquatic plants belonging to the genus Lemna [n -S]\n",
  "DUCKWEEDS": "DUCKWEED, any of various tiny aquatic plants belonging to the genus Lemna [n]\n",
  "DUCKY": "(US slang) excellent, also DUCKIE [adj DUCKIER, DUCKIEST] / a term of endearment [n DUCKIES]\n",
  "DUCT": "a pipe or tube for carrying fluid, cables etc. [n -S] / to transport along a duct [v -ED, -ING, -S]\n",
  "DUCTAL": "made up of ducts [adj]\n",
  "DUCTED": "DUCT, to transport along a duct [v]\n",
  "DUCTILE": "easily molded or shaped [adj DUCTILELY]\n",
  "DUCTILELY": "DUCTILE, easily molded or shaped [adv]\n",
  "DUCTILENESS": "ductility [n -ES]\n",
  "DUCTILENESSES": "DUCTILENESS, ductility [n]\n",
  "DUCTILITIES": "DUCTILITY, the property of a metal which allows it to be drawn into wires or filaments [n]\n",
  "DUCTILITY": "the property of a metal which allows it to be drawn into wires or filaments [n DUCTILITIES]\n",
  "DUCTING": "a system of ducts [n -S]\n",
  "DUCTINGS": "DUCTING, a system of ducts [n]\n",
  "DUCTLESS": "without ducts [adj]\n",
  "DUCTS": "DUCT, to transport along a duct [v]\n",
  "DUCTULE": "a small duct [n -S]\n",
  "DUCTULES": "DUCTULE, a small duct [n]\n",
  "DUCTWORK": "a system of ducts [n -S]\n",
  "DUCTWORKS": "DUCTWORK, a system of ducts [n]\n",
  "DUD": "a bomb that fails to explode [n -S]\n",
  "DUDDER": "to tremble, shudder [v -ED, -ING, -S]\n",
  "DUDDERED": "DUDDER, to tremble, shudder [v]\n",
  "DUDDERIES": "DUDDERY, rags collectively [n]\n",
  "DUDDERING": "DUDDER, to tremble, shudder [v]\n",
  "DUDDERS": "DUDDER, to tremble, shudder [v]\n",
  "DUDDERY": "rags collectively [n DUDDERIES]\n",
  "DUDDIE": "(Scots) ragged, also DUDDY [adj DUDDIER, DUDDIEST] / a friend, a chum [n -S]\n",
  "DUDDIER": "DUDDY, (Scots) ragged, also DUDDIE [adj]\n",
  "DUDDIES": "DUDDIE, a friend, a chum [n]\n",
  "DUDDIEST": "DUDDY, (Scots) ragged, also DUDDIE [adj]\n",
  "DUDDY": "(Scots) ragged, also DUDDIE [adj DUDDIER, DUDDIEST]\n",
  "DUDE": "a fop, a dandy [n -S] / to dress in flashy clothes [v DUDED, DUDING, DUDES]\n",
  "DUDED": "DUDE, to dress in flashy clothes [v]\n",
  "DUDEEN": "(Irish) a clay pipe, also DUDHEEN [n -S]\n",
  "DUDEENS": "DUDEEN, (Irish) a clay pipe, also DUDHEEN [n]\n",
  "DUDENESS": "the state of being a dude [n -ES]\n",
  "DUDENESSES": "DUDENESS, the state of being a dude [n]\n",
  "DUDES": "DUDE, to dress in flashy clothes [v]\n",
  "DUDETTE": "a dudish female [n -S]\n",
  "DUDETTES": "DUDETTE, a dudish female [n]\n",
  "DUDGEON": "the haft of a dagger; a fit or state of angry indignation usually provoked by opposition [n -S]\n",
  "DUDGEONS": "DUDGEON, the haft of a dagger; a fit or state of angry indignation usually provoked by opposition [n]\n",
  "DUDHEEN": "(Irish) a clay pipe, also DUDEEN [n -S]\n",
  "DUDHEENS": "DUDHEEN, (Irish) a clay pipe, also DUDEEN [n]\n",
  "DUDING": "DUDE, to dress in flashy clothes [v]\n",
  "DUDISH": "like, or characteristic of, a dude [adj DUDISHLY]\n",
  "DUDISHLY": "DUDISH, like, or characteristic of, a dude [adv]\n",
  "DUDISM": "dressing up like a dude, flashily [n -S]\n",
  "DUDISMS": "DUDISM, dressing up like a dude, flashily [n]\n",
  "DUDS": "DUD, a bomb that fails to explode [n]\n",
  "DUE": "required [adj DULY] / to endue [v DUED, DUING, DUES]\n",
  "DUECENTO": "(Italian) the thirteenth century, esp. in Italian art [n -S]\n",
  "DUECENTOS": "DUECENTO, (Italian) the thirteenth century, esp. in Italian art [n]\n",
  "DUED": "DUE, to endue [v]\n",
  "DUEFUL": "(Spenser) proper, fit, also DEWFULL [adj]\n",
  "DUEL": "to fight formally [v DUELLED or DUELED, DUELLING or DUELING, DUELS]\n",
  "DUELED": "DUEL, to fight formally [v]\n",
  "DUELER": "one who duels, also DUELIST, DUELLER, DUELLIST [n -S]\n",
  "DUELERS": "DUELER, one who duels, also DUELIST, DUELLER, DUELLIST [n]\n",
  "DUELING": "the act of fighting a duel, also DUELLING [n -S]\n",
  "DUELINGS": "DUELING, the act of fighting a duel, also DUELLING [n]\n",
  "DUELIST": "one who duels, also DUELER, DUELLER, DUELLIST [n -S]\n",
  "DUELISTS": "DUELIST, one who duels, also DUELER, DUELLER, DUELLIST [n]\n",
  "DUELLED": "DUEL, to fight formally [v]\n",
  "DUELLER": "one who duels, also DUELER, DUELIST, DUELLIST [n -S]\n",
  "DUELLERS": "DUELLER, one who duels, also DUELER, DUELIST, DUELLIST [n]\n",
  "DUELLI": "DUELLO, (Italian) a duel, duelling [n]\n",
  "DUELLING": "the act of fighting a duel, also DUELING [n -S]\n",
  "DUELLINGS": "DUELLING, the act of fighting a duel, also DUELING [n]\n",
  "DUELLIST": "one who duels, also DUELER, DUELIST, DUELLER [n -S]\n",
  "DUELLISTS": "DUELLIST, one who duels, also DUELER, DUELIST, DUELLER [n]\n",
  "DUELLO": "(Italian) a duel, duelling [n DUELLI or DUELLOS]\n",
  "DUELLOS": "DUELLO, (Italian) a duel, duelling [n]\n",
  "DUELS": "DUEL, to fight formally [v]\n",
  "DUELSOME": "given to duelling [adj]\n",
  "DUENDE": "(Spanish) the power to attract through personal charm [n -S]\n",
  "DUENDES": "DUENDE, (Spanish) the power to attract through personal charm [n]\n",
  "DUENESS": "the state of being owed [n -ES]\n",
  "DUENESSES": "DUENESS, the state of being owed [n]\n",
  "DUENNA": "(Spanish) a governess; a chaperone [n -S]\n",
  "DUENNAS": "DUENNA, (Spanish) a governess; a chaperone [n]\n",
  "DUENNASHIP": "the office of duenna [n -S]\n",
  "DUENNASHIPS": "DUENNASHIP, the office of duenna [n]\n",
  "DUES": "DUE, to endue [v]\n",
  "DUET": "a musical performance by two people, also DUETT, DUETTO [n -S] / to perform a duet [v DUETED or DUETTED, DUETING or DUETTING, DUETS]\n",
  "DUETED": "DUET, to perform a duet [v]\n",
  "DUETING": "DUET, to perform a duet [v]\n",
  "DUETS": "DUET, to perform a duet [v]\n",
  "DUETT": "a musical performance by two people, also DUET, DUETTO [n -S]\n",
  "DUETTED": "DUET, to perform a duet [v]\n",
  "DUETTI": "DUETTO, (Italian) a musical performance by two people, also DUET, DUETT [n]\n",
  "DUETTING": "DUET, to perform a duet [v]\n",
  "DUETTINO": "(Italian) a simple duet [n -S]\n",
  "DUETTINOS": "DUETTINO, (Italian) a simple duet [n]\n",
  "DUETTIST": "a participant in a duet [n -S]\n",
  "DUETTISTS": "DUETTIST, a participant in a duet [n]\n",
  "DUETTO": "(Italian) a musical performance by two people, also DUET, DUETT [n DUETTOS or DUETTI]\n",
  "DUETTOS": "DUETTO, (Italian) a musical performance by two people, also DUET, DUETT [n]\n",
  "DUETTS": "DUETT, a musical performance by two people, also DUET, DUETTO [n]\n",
  "DUFF": "no good [adj DUFFER, DUFFEST] / to bungle [v -ED, -ING, -S]\n",
  "DUFFED": "DUFF, to bungle [v]\n",
  "DUFFEL": "a coarse woollen fabric, also DUFFLE [n -S]\n",
  "DUFFELS": "DUFFEL, a coarse woollen fabric, also DUFFLE [n]\n",
  "DUFFER": "a clumsy person [n -S]\n",
  "DUFFERDOM": "being a duffer, also DUFFERISM [n -S]\n",
  "DUFFERDOMS": "DUFFERDOM, being a duffer, also DUFFERISM [n]\n",
  "DUFFERISM": "being a duffer, also DUFFERDOM [n -S]\n",
  "DUFFERISMS": "DUFFERISM, being a duffer, also DUFFERDOM [n]\n",
  "DUFFERS": "DUFFER, a clumsy person [n]\n",
  "DUFFEST": "DUFF, no good [adj]\n",
  "DUFFING": "cattle stealing [n -S]\n",
  "DUFFINGS": "DUFFING, cattle stealing [n]\n",
  "DUFFLE": "a coarse woollen fabric, also DUFFEL [n -S]\n",
  "DUFFLES": "DUFFLE, a coarse woollen fabric, also DUFFEL [n]\n",
  "DUFFS": "DUFF, to bungle [v]\n",
  "DUFUS": "a stupid person, also DOOFUS [n -ES]\n",
  "DUFUSES": "DUFUS, a stupid person, also DOOFUS [n]\n",
  "DUG": "the udder of a female mammal [n -S]\n",
  "DUGITE": "(Native Australian) an Australian venomous snake [n -S]\n",
  "DUGITES": "DUGITE, (Native Australian) an Australian venomous snake [n]\n",
  "DUGONG": "(Malay) an aquatic mammal, aka manatee or sea-cow [n -S]\n",
  "DUGONGS": "DUGONG, (Malay) an aquatic mammal, aka manatee or sea-cow [n]\n",
  "DUGOUT": "a canoe made by hollowing out a log [n -S]\n",
  "DUGOUTS": "DUGOUT, a canoe made by hollowing out a log [n]\n",
  "DUGS": "DUG, the udder of a female mammal [n]\n",
  "DUH": "an ironic response to a question [interj]\n",
  "DUHKHA": "(Sanskrit) suffering due to the desire for permanence, also DUKKHA [n -S]\n",
  "DUHKHAS": "DUHKHA, (Sanskrit) suffering due to the desire for permanence, also DUKKHA [n]\n",
  "DUI": "DUO, two people considered a pair for a specific reason [n]\n",
  "DUIKER": "(South African) a small South African antelope, also DUIKERBOK, DUYKER [n -S]\n",
  "DUIKERBOK": "(South African) a small South African antelope, also DUIKER, DUYKER [n -S]\n",
  "DUIKERBOKS": "DUIKERBOK, (South African) a small South African antelope, also DUIKER, DUYKER [n]\n",
  "DUIKERS": "DUIKER, (South African) a small South African antelope, also DUIKERBOK, DUYKER [n]\n",
  "DUING": "DUE, to endue [v]\n",
  "DUIT": "(Dutch) a former Dutch coin, also DODKIN, DOIT, DOITKIN [n -S]\n",
  "DUITS": "DUIT, (Dutch) a former Dutch coin, also DODKIN, DOIT, DOITKIN [n]\n",
  "DUKA": "(Swahili) in East Africa, a shop, store [n -S]\n",
  "DUKAS": "DUKA, (Swahili) in East Africa, a shop, store [n]\n",
  "DUKE": "to fight with fists [v DUKED, DUKING, DUKES]\n",
  "DUKED": "DUKE, to fight with fists [v]\n",
  "DUKEDOM": "the domain of a duke, also DUCHY [n -S]\n",
  "DUKEDOMS": "DUKEDOM, the domain of a duke, also DUCHY [n]\n",
  "DUKELING": "a petty duke [n -S]\n",
  "DUKELINGS": "DUKELING, a petty duke [n]\n",
  "DUKERIES": "DUKERY, a duke's seat [n]\n",
  "DUKERY": "a duke's seat [n DUKERIES]\n",
  "DUKES": "DUKE, to fight with fists [v]\n",
  "DUKESHIP": "the entitlement to being a duke [n -S]\n",
  "DUKESHIPS": "DUKESHIP, the entitlement to being a duke [n]\n",
  "DUKING": "DUKE, to fight with fists [v]\n",
  "DUKKA": "a mix of ground nuts and spices, used as a dip, also DUKKAH [n -S]\n",
  "DUKKAH": "a mix of ground nuts and spices, used as a dip, also DUKKA [n -S]\n",
  "DUKKAHS": "DUKKAH, a mix of ground nuts and spices, used as a dip, also DUKKA [n]\n",
  "DUKKAS": "DUKKA, a mix of ground nuts and spices, used as a dip, also DUKKAH [n]\n",
  "DUKKERIPEN": "(Romany) fortune-telling [n -S]\n",
  "DUKKERIPENS": "DUKKERIPEN, (Romany) fortune-telling [n]\n",
  "DUKKHA": "(Sanskrit) suffering due to the desire for permanence, also DUHKHA [n -S]\n",
  "DUKKHAS": "DUKKHA, (Sanskrit) suffering due to the desire for permanence, also DUHKHA [n]\n",
  "DULCAMARA": "(Latin) a flower of the potato family, aka bittersweet [n -S]\n",
  "DULCAMARAS": "DULCAMARA, (Latin) a flower of the potato family, aka bittersweet [n]\n",
  "DULCE": "a sweet food or drink [n -S]\n",
  "DULCES": "DULCE, a sweet food or drink [n]\n",
  "DULCET": "sweet-toned [adj DULCETLY] / a soft-toned organ stop [n -S]\n",
  "DULCETLY": "DULCET, sweet-toned [adv]\n",
  "DULCETNESS": "the state of being dulcet [n -ES]\n",
  "DULCETNESSES": "DULCETNESS, the state of being dulcet [n]\n",
  "DULCETS": "DULCET, a soft-toned organ stop [n]\n",
  "DULCIAN": "(historical) a small bassoon [n -S]\n",
  "DULCIANA": "a soft-toned organ stop, also DULCET [n -S]\n",
  "DULCIANAS": "DULCIANA, a soft-toned organ stop, also DULCET [n]\n",
  "DULCIANS": "DULCIAN, (historical) a small bassoon [n]\n",
  "DULCIFICATION": "the act of dulcifying [n -S]\n",
  "DULCIFICATIONS": "DULCIFICATION, the act of dulcifying [n]\n",
  "DULCIFIED": "DULCIFY, to sweeten [v]\n",
  "DULCIFIES": "DULCIFY, to sweeten [v]\n",
  "DULCIFLUOUS": "flowing sweetly [adj]\n",
  "DULCIFY": "to sweeten [v DULCIFIED, DULCIFYING, DULCIFIES]\n",
  "DULCIFYING": "DULCIFY, to sweeten [v]\n",
  "DULCILOQUIES": "DULCILOQUY, a soft manner of speaking [n]\n",
  "DULCILOQUY": "a soft manner of speaking [n DULCILOQUIES]\n",
  "DULCIMER": "a musical instrument like a flat box, with sounding board and wires stretched across bridges, also DULCIMORE [n -S]\n",
  "DULCIMERS": "DULCIMER, a musical instrument like a flat box, with sounding board and wires stretched across bridges, also DULCIMORE [n]\n",
  "DULCIMORE": "a musical instrument like a flat box, with sounding board and wires stretched across bridges, also DULCIMER [n -S]\n",
  "DULCIMORES": "DULCIMORE, a musical instrument like a flat box, with sounding board and wires stretched across bridges, also DULCIMER [n]\n",
  "DULCINEA": "a sweetheart [n -S]\n",
  "DULCINEAS": "DULCINEA, a sweetheart [n]\n",
  "DULCITE": "a saccharine substance derived from plants, also DULCITOL, DULCOSE [n -S]\n",
  "DULCITES": "DULCITE, a saccharine substance derived from plants, also DULCITOL, DULCOSE [n]\n",
  "DULCITOL": "a saccharine substance derived from plants, also DULCITE, DULCOSE [n -S]\n",
  "DULCITOLS": "DULCITOL, a saccharine substance derived from plants, also DULCITE, DULCOSE [n]\n",
  "DULCITUDE": "sweetness [n -S]\n",
  "DULCITUDES": "DULCITUDE, sweetness [n]\n",
  "DULCOSE": "a saccharine substance derived from plants, also DULCITE, DULCITOL [n -S]\n",
  "DULCOSES": "DULCOSE, a saccharine substance derived from plants, also DULCITE, DULCITOL [n]\n",
  "DULE": "(obsolete) pain, woe, trouble, also DOLE, DOOL, DOOLE [n -S]\n",
  "DULES": "DULE, (obsolete) pain, woe, trouble, also DOLE, DOOL, DOOLE [n]\n",
  "DULIA": "in Roman Catholicism, the inferior veneration accorded to saints and angels, also DOULEIA [n -S]\n",
  "DULIAS": "DULIA, in Roman Catholicism, the inferior veneration accorded to saints and angels, also DOULEIA [n]\n",
  "DULL": "mentally slow [adj DULLER, DULLEST, DULLY] / to blunt, make dull [v -ED, -ING, -S]\n",
  "DULLARD": "a dolt [n -S]\n",
  "DULLARDS": "DULLARD, a dolt [n]\n",
  "DULLED": "DULL, to blunt, make dull [v]\n",
  "DULLER": "DULL, mentally slow [adj]\n",
  "DULLEST": "DULL, mentally slow [adj]\n",
  "DULLIER": "DULLY, somewhat dull [adj]\n",
  "DULLIEST": "DULLY, somewhat dull [adj]\n",
  "DULLING": "DULL, to blunt, make dull [v]\n",
  "DULLISH": "somewhat dull [adj DULLISHLY]\n",
  "DULLISHLY": "DULLISH, somewhat dull [adv]\n",
  "DULLNESS": "the state of being dull, also DULNESS [n -ES]\n",
  "DULLNESSES": "DULLNESS, the state of being dull, also DULNESS [n]\n",
  "DULLS": "DULL, to blunt, make dull [v]\n",
  "DULLSVILLE": "a boring place where nothing happens [n -S]\n",
  "DULLSVILLES": "DULLSVILLE, a boring place where nothing happens [n]\n",
  "DULLY": "somewhat dull [adj DULLIER, DULLIEST]\n",
  "DULNESS": "the state of being dull, also DULLNESS [n -ES]\n",
  "DULNESSES": "DULNESS, the state of being dull, also DULLNESS [n]\n",
  "DULOCRACIES": "DULOCRACY, a government formed of privileged slaves, also DOULOCRACY [n]\n",
  "DULOCRACY": "a government formed of privileged slaves, also DOULOCRACY [n DULOCRACIES]\n",
  "DULOSES": "DULOSIS, enslavement by an insect [n]\n",
  "DULOSIS": "enslavement by an insect [n DULOSES]\n",
  "DULOTIC": "relating to dulosis, enslavement as practised by ants [adj]\n",
  "DULSE": "(Gaelic) an edible red seaweed [n -S]\n",
  "DULSES": "DULSE, (Gaelic) an edible red seaweed [n]\n",
  "DULY": "DUE, required [adv]\n",
  "DUM": "cooked with steam [adj]\n",
  "DUMA": "(Russian) the Russian parliament, also DOUMA [n -S]\n",
  "DUMAIST": "(Russian) a member of the duma, the Russian parliament [n -S]\n",
  "DUMAISTS": "DUMAIST, (Russian) a member of the duma, the Russian parliament [n]\n",
  "DUMAS": "DUMA, (Russian) the Russian parliament, also DOUMA [n]\n",
  "DUMB": "incapable of speech [adj DUMBER, DUMBEST, DUMBLY] / to deprive of speech [v -ED, -ING, -S]\n",
  "DUMBBELL": "a weight lifted in feats of strength [n -S]\n",
  "DUMBBELLS": "DUMBBELL, a weight lifted in feats of strength [n]\n",
  "DUMBCANE": "a poisonous tropical plant [n -S]\n",
  "DUMBCANES": "DUMBCANE, a poisonous tropical plant [n]\n",
  "DUMBED": "DUMB, to deprive of speech [v]\n",
  "DUMBER": "DUMB, incapable of speech [adj]\n",
  "DUMBEST": "DUMB, incapable of speech [adj]\n",
  "DUMBFOUND": "to strike dumb; to confuse with astonishment, also DUMBFOUNDER, DUMFOUND, DUMFOUNDER [v -ED, -ING, -S]\n",
  "DUMBFOUNDED": "DUMBFOUND, to strike dumb; to confuse with astonishment, also DUMBFOUNDER, DUMFOUND, DUMFOUNDER [v]\n",
  "DUMBFOUNDER": "to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMFOUND, DUMFOUNDER [v -ED, -ING, -S]\n",
  "DUMBFOUNDERED": "DUMBFOUNDER, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMFOUND, DUMFOUNDER [v]\n",
  "DUMBFOUNDERING": "DUMBFOUNDER, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMFOUND, DUMFOUNDER [v]\n",
  "DUMBFOUNDERS": "DUMBFOUNDER, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMFOUND, DUMFOUNDER [v]\n",
  "DUMBFOUNDING": "DUMBFOUND, to strike dumb; to confuse with astonishment, also DUMBFOUNDER, DUMFOUND, DUMFOUNDER [v]\n",
  "DUMBFOUNDS": "DUMBFOUND, to strike dumb; to confuse with astonishment, also DUMBFOUNDER, DUMFOUND, DUMFOUNDER [v]\n",
  "DUMBHEAD": "a stupid person [n -S]\n",
  "DUMBHEADS": "DUMBHEAD, a stupid person [n]\n",
  "DUMBING": "DUMB, to deprive of speech [v]\n",
  "DUMBLEDORE": "a large flying beetle, aka the brown cockchafer, also DRUMBLEDOR [n -S]\n",
  "DUMBLEDORES": "DUMBLEDORE, a large flying beetle, aka the brown cockchafer, also DRUMBLEDOR [n]\n",
  "DUMBLY": "DUMB, incapable of speech [adv]\n",
  "DUMBNESS": "the state of being dumb [n -ES]\n",
  "DUMBNESSES": "DUMBNESS, the state of being dumb [n]\n",
  "DUMBO": "(colloquial) a dimwit [n -S]\n",
  "DUMBOS": "DUMBO, (colloquial) a dimwit [n]\n",
  "DUMBS": "DUMB, to deprive of speech [v]\n",
  "DUMBSHIT": "(vulgar slang) a stupid person [n -S]\n",
  "DUMBSHITS": "DUMBSHIT, (vulgar slang) a stupid person [n]\n",
  "DUMBSHOW": "gesture without words; pantomime [n -S]\n",
  "DUMBSHOWS": "DUMBSHOW, gesture without words; pantomime [n]\n",
  "DUMBSIZE": "to reduce the size of a workforce so low that the work cannot be done effectively [v DUMBSIZED, DUMBSIZING, DUMBSIZES]\n",
  "DUMBSIZED": "DUMBSIZE, to reduce the size of a workforce so low that the work cannot be done effectively [v]\n",
  "DUMBSIZES": "DUMBSIZE, to reduce the size of a workforce so low that the work cannot be done effectively [v]\n",
  "DUMBSIZING": "DUMBSIZE, to reduce the size of a workforce so low that the work cannot be done effectively [v]\n",
  "DUMBSTRICKEN": "made silent by astonishment, also DUMBSTRUCK [adj]\n",
  "DUMBSTRUCK": "made silent by astonishment, also DUMBSTRICKEN [adj]\n",
  "DUMBWAITER": "a movable platform used for conveying food etc. [n -S]\n",
  "DUMBWAITERS": "DUMBWAITER, a movable platform used for conveying food etc. [n]\n",
  "DUMDUM": "a soft-nosed expanding bullet [n -S]\n",
  "DUMDUMS": "DUMDUM, a soft-nosed expanding bullet [n]\n",
  "DUMELA": "(South African) hello, good morning [interj]\n",
  "DUMFOUND": "to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUNDER [v -ED, -ING, -S]\n",
  "DUMFOUNDED": "DUMFOUND, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUNDER [v]\n",
  "DUMFOUNDER": "to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUND [v -ED, -ING, -S]\n",
  "DUMFOUNDERED": "DUMFOUNDER, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUND [v]\n",
  "DUMFOUNDERING": "DUMFOUNDER, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUND [v]\n",
  "DUMFOUNDERS": "DUMFOUNDER, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUND [v]\n",
  "DUMFOUNDING": "DUMFOUND, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUNDER [v]\n",
  "DUMFOUNDS": "DUMFOUND, to strike dumb; to confuse with astonishment, also DUMBFOUND, DUMBFOUNDER, DUMFOUNDER [v]\n",
  "DUMKA": "(Czech) a lament, a piece alternating between lively and sorrowful moods [n DUMKY or DUMKAS]\n",
  "DUMKAS": "DUMKA, (Czech) a lament, a piece alternating between lively and sorrowful moods [n]\n",
  "DUMKY": "DUMKA, (Czech) a lament, a piece alternating between lively and sorrowful moods [n]\n",
  "DUMMELHEAD": "(dialect) a stupid person [n -S]\n",
  "DUMMELHEADS": "DUMMELHEAD, (dialect) a stupid person [n]\n",
  "DUMMERER": "somebody who pretends to be dumb in order to appear a more deserving beggar [n -S]\n",
  "DUMMERERS": "DUMMERER, somebody who pretends to be dumb in order to appear a more deserving beggar [n]\n",
  "DUMMIED": "DUMMY, to fake [v]\n",
  "DUMMIER": "DUMMY, sham, feigned [adj]\n",
  "DUMMIES": "DUMMY, to fake [v]\n",
  "DUMMIEST": "DUMMY, sham, feigned [adj]\n",
  "DUMMINESS": "being like a dummy, sham [n -ES]\n",
  "DUMMINESSES": "DUMMINESS, being like a dummy, sham [n]\n",
  "DUMMKOPF": "(German) a stupid person [n -S]\n",
  "DUMMKOPFS": "DUMMKOPF, (German) a stupid person [n]\n",
  "DUMMY": "sham, feigned [adj DUMMIER, DUMMIEST] / to fake [v DUMMIED, DUMMYING, DUMMIES]\n",
  "DUMMYING": "DUMMY, to fake [v]\n",
  "DUMORTIERITE": "(French) an orthorhombic borosilicate of aluminium occurring as small violet or blue needles or fibrous masses esp. in gneisses and schists [n -S]\n",
  "DUMORTIERITES": "DUMORTIERITE, (French) an orthorhombic borosilicate of aluminium occurring as small violet or blue needles or fibrous masses esp. in gneisses and schists [n]\n",
  "DUMOSE": "abounding with bushes and briers, also DUMOUS [adj]\n",
  "DUMOSITIES": "DUMOSITY, bushiness [n]\n",
  "DUMOSITY": "bushiness [n DUMOSITIES]\n",
  "DUMOUS": "abounding with bushes and briers, also DUMOSE [adj]\n",
  "DUMP": "to unload, let fall heavily [v -ED, -ING, -S]\n",
  "DUMPBIN": "a bin for rubbish [n -S]\n",
  "DUMPBINS": "DUMPBIN, a bin for rubbish [n]\n",
  "DUMPCART": "a cart for collecting rubbish [n -S]\n",
  "DUMPCARTS": "DUMPCART, a cart for collecting rubbish [n]\n",
  "DUMPED": "DUMP, to unload, let fall heavily [v]\n",
  "DUMPEE": "the person in a relationship being dumped [n -S]\n",
  "DUMPEES": "DUMPEE, the person in a relationship being dumped [n]\n",
  "DUMPER": "a wave that crashes suddenly downwards with great force, causing surfers to fall [n -S]\n",
  "DUMPERS": "DUMPER, a wave that crashes suddenly downwards with great force, causing surfers to fall [n]\n",
  "DUMPIER": "DUMPY, short and thick [adj]\n",
  "DUMPIES": "DUMPY, a dumpy person [n]\n",
  "DUMPIEST": "DUMPY, short and thick [adj]\n",
  "DUMPILY": "DUMPY, short and thick [adv]\n",
  "DUMPINESS": "the state of being dumpy [n -ES]\n",
  "DUMPINESSES": "DUMPINESS, the state of being dumpy [n]\n",
  "DUMPING": "the selling of large quantities of goods below market price [n -S]\n",
  "DUMPINGS": "DUMPING, the selling of large quantities of goods below market price [n]\n",
  "DUMPISH": "dull; sad [adj DUMPISHLY]\n",
  "DUMPISHLY": "DUMPISH, dull; sad [adv]\n",
  "DUMPISHNESS": "the state of being dumpish [n -ES]\n",
  "DUMPISHNESSES": "DUMPISHNESS, the state of being dumpish [n]\n",
  "DUMPLE": "to make dumpy; to fold, or bend, as one part over another [v DUMPLED, DUMPLING, DUMPLES]\n",
  "DUMPLED": "DUMPLE, to make dumpy; to fold, or bend, as one part over another [v]\n",
  "DUMPLES": "DUMPLE, to make dumpy; to fold, or bend, as one part over another [v]\n",
  "DUMPLING": "a ball of dough cooked with something else [n -S]\n",
  "DUMPLINGS": "DUMPLING, a ball of dough cooked with something else [n]\n",
  "DUMPS": "DUMP, to unload, let fall heavily [v]\n",
  "DUMPSITE": "a place for dumping rubbish [n -S]\n",
  "DUMPSITES": "DUMPSITE, a place for dumping rubbish [n]\n",
  "DUMPSTER": "a large skip for refuse [n -S]\n",
  "DUMPSTERS": "DUMPSTER, a large skip for refuse [n]\n",
  "DUMPTRUCK": "a lorry with a tipping container [n -S]\n",
  "DUMPTRUCKS": "DUMPTRUCK, a lorry with a tipping container [n]\n",
  "DUMPY": "a dumpy person [n DUMPIES] / short and thick [adj DUMPIER, DUMPIEST, DUMPILY]\n",
  "DUN": "to make demands for payment of a debt [v DUNNED, DUNNING, DUNS] / of a dull brown colour [adj DUNNER, DUNNEST]\n",
  "DUNAM": "(Hebrew) an Israeli land measure [n -S]\n",
  "DUNAMS": "DUNAM, (Hebrew) an Israeli land measure [n]\n",
  "DUNCE": "a stupid person [n -S]\n",
  "DUNCEDOM": "the class of dunces [n -S]\n",
  "DUNCEDOMS": "DUNCEDOM, the class of dunces [n]\n",
  "DUNCELIKE": "like a dunce [adj]\n",
  "DUNCERIES": "DUNCERY, stupidity [n]\n",
  "DUNCERY": "stupidity [n DUNCERIES]\n",
  "DUNCES": "DUNCE, a stupid person [n]\n",
  "DUNCH": "(Scots) to jog, nudge, also DUNSH [v -ED, -ING, -ES]\n",
  "DUNCHED": "DUNCH, (Scots) to jog, nudge, also DUNSH [v]\n",
  "DUNCHES": "DUNCH, (Scots) to jog, nudge, also DUNSH [v]\n",
  "DUNCHING": "DUNCH, (Scots) to jog, nudge, also DUNSH [v]\n",
  "DUNCICAL": "relating to a dunce [adj]\n",
  "DUNCISH": "like a dunce [adj DUNCISHLY]\n",
  "DUNCISHLY": "DUNCISH, like a dunce [adv]\n",
  "DUNDER": "the lees or dregs of sugarcane juice, used in the distillation of rum [n -S]\n",
  "DUNDERFUNK": "ship's biscuit soaked in water and mixed with fat and molasses, also DANDYFUNK [n -S]\n",
  "DUNDERFUNKS": "DUNDERFUNK, ship's biscuit soaked in water and mixed with fat and molasses, also DANDYFUNK [n]\n",
  "DUNDERHEAD": "a dunce; a numskull; a blockhead [n -S]\n",
  "DUNDERHEADED": "of or like a dunderhead [adj]\n",
  "DUNDERHEADISM": "being a dunderhead [n -S]\n",
  "DUNDERHEADISMS": "DUNDERHEADISM, being a dunderhead [n]\n",
  "DUNDERHEADS": "DUNDERHEAD, a dunce; a numskull; a blockhead [n]\n",
  "DUNDERPATE": "a dunce; a numskull; a blockhead [n -S]\n",
  "DUNDERPATES": "DUNDERPATE, a dunce; a numskull; a blockhead [n]\n",
  "DUNDERS": "DUNDER, the lees or dregs of sugarcane juice, used in the distillation of rum [n]\n",
  "DUNDREARIES": "long flowing sideburns [n]\n",
  "DUNE": "a hill of sand [n -S]\n",
  "DUNELAND": "an area having many dunes [n -S]\n",
  "DUNELANDS": "DUNELAND, an area having many dunes [n]\n",
  "DUNELIKE": "like a dune [adj]\n",
  "DUNES": "DUNE, a hill of sand [n]\n",
  "DUNG": "to fertilize with manure [v -ED, -ING, -S]\n",
  "DUNGAREE": "(Hindi) a coarse cotton fabric, trousers made from this [n -S]\n",
  "DUNGAREED": "wearing dungarees [adj]\n",
  "DUNGAREES": "DUNGAREE, (Hindi) a coarse cotton fabric, trousers made from this [n]\n",
  "DUNGED": "DUNG, to fertilize with manure [v]\n",
  "DUNGEON": "to confine in an underground prison [v -ED, -ING, -S]\n",
  "DUNGEONED": "DUNGEON, to confine in an underground prison [v]\n",
  "DUNGEONER": "a gaoler [n -S]\n",
  "DUNGEONERS": "DUNGEONER, a gaoler [n]\n",
  "DUNGEONING": "DUNGEON, to confine in an underground prison [v]\n",
  "DUNGEONS": "DUNGEON, to confine in an underground prison [v]\n",
  "DUNGER": "(New Zealand) a dilapidated car or machine [n -S]\n",
  "DUNGERS": "DUNGER, (New Zealand) a dilapidated car or machine [n]\n",
  "DUNGHEAP": "a heap of dung [n -S]\n",
  "DUNGHEAPS": "DUNGHEAP, a heap of dung [n]\n",
  "DUNGHILL": "a heap of manure [n -S]\n",
  "DUNGHILLS": "DUNGHILL, a heap of manure [n]\n",
  "DUNGIER": "DUNGY, having the quality of dung, filthy [adj]\n",
  "DUNGIEST": "DUNGY, having the quality of dung, filthy [adj]\n",
  "DUNGING": "DUNG, to fertilize with manure [v]\n",
  "DUNGMERE": "a manure-pit [n -S]\n",
  "DUNGMERES": "DUNGMERE, a manure-pit [n]\n",
  "DUNGS": "DUNG, to fertilize with manure [v]\n",
  "DUNGY": "having the quality of dung, filthy [adj DUNGIER, DUNGIEST]\n",
  "DUNIEWASSAL": "(Gaelic) a Highland gentleman of inferior rank, also DUNIWASSAL, DUNNIEWASSAL [n -S]\n",
  "DUNIEWASSALS": "DUNIEWASSAL, (Gaelic) a Highland gentleman of inferior rank, also DUNIWASSAL, DUNNIEWASSAL [n]\n",
  "DUNITE": "an igneous rock composed almost entirely of olivine [n -S]\n",
  "DUNITES": "DUNITE, an igneous rock composed almost entirely of olivine [n]\n",
  "DUNITIC": "relating to dunite, an igneous rock [adj]\n",
  "DUNIWASSAL": "(Gaelic) a Highland gentleman of inferior rank, also DUNIEWASSAL, DUNNIEWASSAL [n -S]\n",
  "DUNIWASSALS": "DUNIWASSAL, (Gaelic) a Highland gentleman of inferior rank, also DUNIEWASSAL, DUNNIEWASSAL [n]\n",
  "DUNK": "to dip into liquid [v -ED, -ING, -S]\n",
  "DUNKED": "DUNK, to dip into liquid [v]\n",
  "DUNKER": "one who dunks [n -S]\n",
  "DUNKERS": "DUNKER, one who dunks [n]\n",
  "DUNKING": "the act of immersing in a liquid [n -S]\n",
  "DUNKINGS": "DUNKING, the act of immersing in a liquid [n]\n",
  "DUNKS": "DUNK, to dip into liquid [v]\n",
  "DUNLIN": "a species of brown-and-white sandpiper [n -S]\n",
  "DUNLINS": "DUNLIN, a species of brown-and-white sandpiper [n]\n",
  "DUNNAGE": "wood laid in a ship's hold to keep cargo dry and safe, aka fardage [n -S]\n",
  "DUNNAGES": "DUNNAGE, wood laid in a ship's hold to keep cargo dry and safe, aka fardage [n]\n",
  "DUNNAKIN": "an outside lavatory, also DUNNY, DONNIKER [n -S]\n",
  "DUNNAKINS": "DUNNAKIN, an outside lavatory, also DUNNY, DONNIKER [n]\n",
  "DUNNART": "(Native Australian) an Australian marsupial mouse [n -S]\n",
  "DUNNARTS": "DUNNART, (Native Australian) an Australian marsupial mouse [n]\n",
  "DUNNED": "DUN, to make demands for payment of a debt [v]\n",
  "DUNNER": "DUN, of a dull brown colour [adj]\n",
  "DUNNESS": "the state of being dun [n -ES]\n",
  "DUNNESSES": "DUNNESS, the state of being dun [n]\n",
  "DUNNEST": "DUN, of a dull brown colour [adj]\n",
  "DUNNIER": "DUNNY, stupid [adj]\n",
  "DUNNIES": "DUNNY, an outside lavatory, also DONNIKER, DUNNAKIN [n]\n",
  "DUNNIEST": "DUNNY, stupid [adj]\n",
  "DUNNIEWASSAL": "(Gaelic) a Highland gentleman of inferior rank, also DUNIEWASSAL, DUNIWASSAL [n -S]\n",
  "DUNNIEWASSALS": "DUNNIEWASSAL, (Gaelic) a Highland gentleman of inferior rank, also DUNIEWASSAL, DUNIWASSAL [n]\n",
  "DUNNING": "the act of dunning, pressing for payment [n -S]\n",
  "DUNNINGS": "DUNNING, the act of dunning, pressing for payment [n]\n",
  "DUNNISH": "somewhat dun [adj]\n",
  "DUNNITE": "a kind of explosive based on ammonium picrate [n -S]\n",
  "DUNNITES": "DUNNITE, a kind of explosive based on ammonium picrate [n]\n",
  "DUNNO": "(colloquial) I don't know [v]\n",
  "DUNNOCK": "the hedge-sparrow [n -S]\n",
  "DUNNOCKS": "DUNNOCK, the hedge-sparrow [n]\n",
  "DUNNY": "an outside lavatory, also DONNIKER, DUNNAKIN [n DUNNIES] / stupid [adj DUNNIER, DUNNIEST]\n",
  "DUNS": "DUN, to make demands for payment of a debt [v]\n",
  "DUNSH": "(Scots) to jog, nudge, also DUNCH [v -ED, -ING, -ES]\n",
  "DUNSHED": "DUNSH, (Scots) to jog, nudge, also DUNCH [v]\n",
  "DUNSHES": "DUNSH, (Scots) to jog, nudge, also DUNCH [v]\n",
  "DUNSHING": "DUNSH, (Scots) to jog, nudge, also DUNCH [v]\n",
  "DUNT": "to strike with a heavy blow [v -ED, -ING, -S]\n",
  "DUNTED": "DUNT, to strike with a heavy blow [v]\n",
  "DUNTING": "DUNT, to strike with a heavy blow [v]\n",
  "DUNTS": "DUNT, to strike with a heavy blow [v]\n",
  "DUO": "two people considered a pair for a specific reason [n DUI or DUOS]\n",
  "DUOBINARY": "denoting a communications system for coding digital data [adj]\n",
  "DUODECENNIAL": "recurring twelve years [adj]\n",
  "DUODECILLION": "ten to the power of 39 [n -S]\n",
  "DUODECILLIONS": "DUODECILLION, ten to the power of 39 [n]\n",
  "DUODECIMAL": "of or relating to the number twelve [adj DUODECIMALLY]\n",
  "DUODECIMALLY": "DUODECIMAL, of or relating to the number twelve [adv]\n",
  "DUODECIMALS": "a method of multiplying together quantities given in feet and inches, etc., without reducing them to one denomination; also called cross-multiplication [n]\n",
  "DUODECIMO": "having twelve leaves to a sheet [adj] / a duodecimo book [n -S]\n",
  "DUODECIMOS": "DUODECIMO, a duodecimo book [n]\n",
  "DUODENA": "DUODENUM, (Latin) the first portion of the small intestine [n]\n",
  "DUODENAL": "pertaining to the duodenum [adj]\n",
  "DUODENARY": "relating to the number twelve [adj]\n",
  "DUODENECTOMIES": "DUODENECTOMY, the surgical removal of the duodenum [n]\n",
  "DUODENECTOMY": "the surgical removal of the duodenum [n DUODENECTOMIES]\n",
  "DUODENITIS": "inflammation of the duodenum [n -ES]\n",
  "DUODENITISES": "DUODENITIS, inflammation of the duodenum [n]\n",
  "DUODENUM": "(Latin) the first portion of the small intestine [n DUODENUMS or DUODENA]\n",
  "DUODENUMS": "DUODENUM, (Latin) the first portion of the small intestine [n]\n",
  "DUOLOG": "a conversation between two people, also DUOLOGUE [n -S]\n",
  "DUOLOGS": "DUOLOG, a conversation between two people, also DUOLOGUE [n]\n",
  "DUOLOGUE": "a conversation between two people, also DUOLOG [n -S]\n",
  "DUOLOGUES": "DUOLOGUE, a conversation between two people, also DUOLOG [n]\n",
  "DUOMI": "DUOMO, (Italian) a cathedral [n]\n",
  "DUOMO": "(Italian) a cathedral [n DUOMI or DUOMOS]\n",
  "DUOMOS": "DUOMO, (Italian) a cathedral [n]\n",
  "DUOPOLIES": "DUOPOLY, the market condition when there are two sellers only [n]\n",
  "DUOPOLIST": "a member of a duopoly, a situation in which two companies etc are the only suppliers in a particular market [n -S]\n",
  "DUOPOLISTIC": "relating to duopoly [adj]\n",
  "DUOPOLISTS": "DUOPOLIST, a member of a duopoly, a situation in which two companies etc are the only suppliers in a particular market [n]\n",
  "DUOPOLY": "the market condition when there are two sellers only [n DUOPOLIES]\n",
  "DUOPSONIES": "DUOPSONY, the market condition when there are two buyers only [n]\n",
  "DUOPSONY": "the market condition when there are two buyers only [n DUOPSONIES]\n",
  "DUOS": "DUO, two people considered a pair for a specific reason [n]\n",
  "DUOTONE": "a drawing etc. done in two tones or colours [n -S]\n",
  "DUOTONES": "DUOTONE, a drawing etc. done in two tones or colours [n]\n",
  "DUP": "(Shakespeare) to undo [v DUPPED, DUPPING, DUPS]\n",
  "DUPABILITIES": "DUPABILITY, the ability to be duped [n]\n",
  "DUPABILITY": "the ability to be duped [n DUPABILITIES]\n",
  "DUPABLE": "able to be duped [adj]\n",
  "DUPATTA": "(Hindi) a silk or muslin shawl, also DOPATTA [n -S]\n",
  "DUPATTAS": "DUPATTA, (Hindi) a silk or muslin shawl, also DOPATTA [n]\n",
  "DUPE": "to deceive [v DUPED, DUPING, DUPES]\n",
  "DUPED": "DUPE, to deceive [v]\n",
  "DUPER": "one who dupes another [n -S]\n",
  "DUPERIES": "DUPERY, the act or practice of duping [n]\n",
  "DUPERS": "DUPER, one who dupes another [n]\n",
  "DUPERY": "the act or practice of duping [n DUPERIES]\n",
  "DUPES": "DUPE, to deceive [v]\n",
  "DUPING": "the act of deceiving [n -S]\n",
  "DUPINGS": "DUPING, the act of deceiving [n]\n",
  "DUPION": "(French) a coarse silk, also DOUPIONI, DOUPPIONI [n -S]\n",
  "DUPIONS": "DUPION, (French) a coarse silk, also DOUPIONI, DOUPPIONI [n]\n",
  "DUPLE": "having two parts or elements [adj]\n",
  "DUPLET": "a pair of electrons forming a single bond between atoms [n -S]\n",
  "DUPLETS": "DUPLET, a pair of electrons forming a single bond between atoms [n]\n",
  "DUPLEX": "to make duple [v -ED, -ING, -ES]\n",
  "DUPLEXED": "DUPLEX, to make duple [v]\n",
  "DUPLEXER": "a system allowing use of the same aerial for transmission and response [n -S]\n",
  "DUPLEXERS": "DUPLEXER, a system allowing use of the same aerial for transmission and response [n]\n",
  "DUPLEXES": "DUPLEX, to make duple [v]\n",
  "DUPLEXING": "the act of making duplex [n -S]\n",
  "DUPLEXINGS": "DUPLEXING, the act of making duplex [n]\n",
  "DUPLEXITIES": "DUPLEXITY, the state of being duplex, double [n]\n",
  "DUPLEXITY": "the state of being duplex, double [n DUPLEXITIES]\n",
  "DUPLICABILITIES": "DUPLICABILITY, the quality of being duplicable [n]\n",
  "DUPLICABILITY": "the quality of being duplicable [n DUPLICABILITIES]\n",
  "DUPLICABLE": "that can be duplicated [adj]\n",
  "DUPLICAND": "something being duplicated [n -S]\n",
  "DUPLICANDS": "DUPLICAND, something being duplicated [n]\n",
  "DUPLICATE": "double, twofold [adj DUPLICATELY] / to copy [v DUPLICATED, DUPLICATING, DUPLICATES]\n",
  "DUPLICATED": "DUPLICATE, to copy [v]\n",
  "DUPLICATELY": "DUPLICATE, double, twofold [adv]\n",
  "DUPLICATES": "DUPLICATE, to copy [v]\n",
  "DUPLICATING": "DUPLICATE, to copy [v]\n",
  "DUPLICATION": "the act of duplicating [n -S]\n",
  "DUPLICATIONS": "DUPLICATION, the act of duplicating [n]\n",
  "DUPLICATIVE": "serving to duplicate [adj]\n",
  "DUPLICATOR": "one that duplicates [n -S]\n",
  "DUPLICATORS": "DUPLICATOR, one that duplicates [n]\n",
  "DUPLICATURE": "a doubling, anything doubled [n -S]\n",
  "DUPLICATURES": "DUPLICATURE, a doubling, anything doubled [n]\n",
  "DUPLICIDENT": "of certain animals, such as rabbits, having two pairs of incisors in the upper jaw [adj]\n",
  "DUPLICITIES": "DUPLICITY, doubleness, esp. in conduct or intention [n]\n",
  "DUPLICITOUS": "given to or marked by deliberate deceptiveness in behavior or speech [adj DUPLICITOUSLY]\n",
  "DUPLICITOUSLY": "DUPLICITOUS, given to or marked by deliberate deceptiveness in behavior or speech [adv]\n",
  "DUPLICITY": "doubleness, esp. in conduct or intention [n DUPLICITIES]\n",
  "DUPLIED": "DUPLY, (Scots) to give a second reply in Scots law [v]\n",
  "DUPLIES": "DUPLY, (Scots) to give a second reply in Scots law [v]\n",
  "DUPLY": "(Scots) to give a second reply in Scots law [v DUPLIED, DUPLYING, DUPLIES]\n",
  "DUPLYING": "DUPLY, (Scots) to give a second reply in Scots law [v]\n",
  "DUPONDII": "DUPONDIUS, an old Roman coin [n]\n",
  "DUPONDIUS": "an old Roman coin [n DUPONDII]\n",
  "DUPPED": "DUP, (Shakespeare) to undo [v]\n",
  "DUPPIES": "DUPPY, (Caribbean) in the West Indies, a ghost [n]\n",
  "DUPPING": "DUP, (Shakespeare) to undo [v]\n",
  "DUPPY": "(Caribbean) in the West Indies, a ghost [n DUPPIES]\n",
  "DUPS": "DUP, (Shakespeare) to undo [v]\n",
  "DURA": "(Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURR, DURRA [n -S]\n",
  "DURABILITIES": "DURABILITY, the state of being durable [n]\n",
  "DURABILITY": "the state of being durable [n DURABILITIES]\n",
  "DURABLE": "lasting [adj DURABLY] / something that will endure [n -S]\n",
  "DURABLENESS": "the state of being durable [n -ES]\n",
  "DURABLENESSES": "DURABLENESS, the state of being durable [n]\n",
  "DURABLES": "DURABLE, something that will endure [n]\n",
  "DURABLY": "DURABLE, lasting [adv]\n",
  "DURAL": "(tradename) a strong light aluminum alloy containing copper, also DURALUMIN, DURALUMINIUM [n -S]\n",
  "DURALS": "DURAL, (tradename) a strong light aluminum alloy containing copper, also DURALUMIN, DURALUMINIUM [n]\n",
  "DURALUMIN": "(tradename) a strong light aluminum alloy containing copper, also DURAL, DURALUMINIUM [n -S]\n",
  "DURALUMINIUM": "a strong, light, aluminium alloy containing copper, also DURAL, DURALUMIN [n -S]\n",
  "DURALUMINIUMS": "DURALUMINIUM, a strong, light, aluminium alloy containing copper, also DURAL, DURALUMIN [n]\n",
  "DURALUMINS": "DURALUMIN, (tradename) a strong light aluminum alloy containing copper, also DURAL, DURALUMINIUM [n]\n",
  "DURAMEN": "(Latin) the heartwood of a tree or other woody plant [n -S]\n",
  "DURAMENS": "DURAMEN, (Latin) the heartwood of a tree or other woody plant [n]\n",
  "DURANCE": "restraint by physical force [n -S]\n",
  "DURANCES": "DURANCE, restraint by physical force [n]\n",
  "DURANT": "a strong cloth in imitation of buff leather [n -S]\n",
  "DURANTS": "DURANT, a strong cloth in imitation of buff leather [n]\n",
  "DURAS": "DURA, (Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURR, DURRA [n]\n",
  "DURATION": "the portion of time during which anything exists [n -S]\n",
  "DURATIONAL": "relating to a duration [adj]\n",
  "DURATIONS": "DURATION, the portion of time during which anything exists [n]\n",
  "DURATIVE": "a verb denoting continuing action [n -S]\n",
  "DURATIVES": "DURATIVE, a verb denoting continuing action [n]\n",
  "DURBAR": "(Urdu) the court of a native ruler in India, also DARBAR [n -S]\n",
  "DURBARS": "DURBAR, (Urdu) the court of a native ruler in India, also DARBAR [n]\n",
  "DURCHKOMPONIERT": "(German) having the music especially adapted to each stanza, also DURCHKOMPONIRT [adj]\n",
  "DURCHKOMPONIRT": "(German) having the music especially adapted to each stanza, also DURCHKOMPONIERT [adj]\n",
  "DURDUM": "(Scots) an uproar; a scolding; blame, also DIRDAM, DIRDUM [n -S]\n",
  "DURDUMS": "DURDUM, (Scots) an uproar; a scolding; blame, also DIRDAM, DIRDUM [n]\n",
  "DURE": "(obsolete) to endure, last [v DURED, DURING, DURES]\n",
  "DURED": "DURE, (obsolete) to endure, last [v]\n",
  "DUREFUL": "(Spenser) enduring, lasting [adj]\n",
  "DURES": "DURE, (obsolete) to endure, last [v]\n",
  "DURESS": "compulsion by force, also DURESSE [n -ES]\n",
  "DURESSE": "compulsion by force, also DURESS [n -S]\n",
  "DURESSES": "DURESS, compulsion by force, also DURESSE [n]\n",
  "DURGAH": "(Persian) a structure over a place where a holy person was buried or cremated, also DARGA, DARGAH [n -S]\n",
  "DURGAHS": "DURGAH, (Persian) a structure over a place where a holy person was buried or cremated, also DARGA, DARGAH [n]\n",
  "DURGAN": "(dialect) a dwarf, any undersized creature [n -S]\n",
  "DURGANS": "DURGAN, (dialect) a dwarf, any undersized creature [n]\n",
  "DURGIER": "DURGY, dwarfish [adj]\n",
  "DURGIEST": "DURGY, dwarfish [adj]\n",
  "DURGY": "dwarfish [adj DURGIER, DURGIEST]\n",
  "DURIAN": "(Malay) a tree of the bombax family, widely grown in tropical Asia; its spinous fruit, also DURION [n -S]\n",
  "DURIANS": "DURIAN, (Malay) a tree of the bombax family, widely grown in tropical Asia; its spinous fruit, also DURION [n]\n",
  "DURICRUST": "gravel, sand, or desert debris cemented by calcium carbonate, an accumulated product of chemical weathering in a dry climate [n -S]\n",
  "DURICRUSTS": "DURICRUST, gravel, sand, or desert debris cemented by calcium carbonate, an accumulated product of chemical weathering in a dry climate [n]\n",
  "DURING": "throughout the duration of [prep]\n",
  "DURION": "(Malay) a tree of the bombax family, widely grown in tropical Asia; its spinous fruit, also DURIAN [n -S]\n",
  "DURIONS": "DURION, (Malay) a tree of the bombax family, widely grown in tropical Asia; its spinous fruit, also DURIAN [n]\n",
  "DURMAST": "a Eurasian oak, which bears sessile acorns and grows chiefly on acid soils [n -S]\n",
  "DURMASTS": "DURMAST, a Eurasian oak, which bears sessile acorns and grows chiefly on acid soils [n]\n",
  "DURN": "to damn [v -ED, -ING, -S]\n",
  "DURNDEST": "DURNED, damned [adj]\n",
  "DURNED": "damned [adj DURNEDER, DURNDEST or DURNEDEST]\n",
  "DURNEDER": "DURNED, damned [adj]\n",
  "DURNEDEST": "DURNED, damned [adj]\n",
  "DURNING": "DURN, to damn [v]\n",
  "DURNS": "DURN, to damn [v]\n",
  "DURO": "(Spanish) a Spanish silver dollar [n -S]\n",
  "DUROC": "a large red hog [n -S]\n",
  "DUROCS": "DUROC, a large red hog [n]\n",
  "DUROMETER": "an instrument for measuring the hardness of substances [n -S]\n",
  "DUROMETERS": "DUROMETER, an instrument for measuring the hardness of substances [n]\n",
  "DUROS": "DURO, (Spanish) a Spanish silver dollar [n]\n",
  "DUROY": "a coarse woollen fabric [n -S]\n",
  "DUROYS": "DUROY, a coarse woollen fabric [n]\n",
  "DURR": "(Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURRA [n -S]\n",
  "DURRA": "(Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURR [n -S]\n",
  "DURRAS": "DURRA, (Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURR [n]\n",
  "DURRIE": "(Hindi) an Indian cotton rug, also DHURRIE [n -S]\n",
  "DURRIES": "DURRIE, (Hindi) an Indian cotton rug, also DHURRIE [n]\n",
  "DURRS": "DURR, (Arabic) Indian millet, also DARI, DHOORA, DHOURRA, DHURRA, DOURA, DOURAH, DURA, DURRA [n]\n",
  "DURRY": "(Australian slang) a cigarette [n DURRIES]\n",
  "DURST": "DARE, to venture boldly, also DARRE, DAUR [v]\n",
  "DURUKULI": "a small, nocturnal, South American monkey, also DOUROUCOULI [n -S]\n",
  "DURUKULIS": "DURUKULI, a small, nocturnal, South American monkey, also DOUROUCOULI [n]\n",
  "DURUM": "(Latin) a strain of wheat, aka macaroni wheat [n -S]\n",
  "DURUMS": "DURUM, (Latin) a strain of wheat, aka macaroni wheat [n]\n",
  "DURZI": "(Hindi) a Hindu tailor, also DARZI [n -S]\n",
  "DURZIS": "DURZI, (Hindi) a Hindu tailor, also DARZI [n]\n",
  "DUSH": "(Scots) to strike heavily against [v -ED, -ING, -ES]\n",
  "DUSHED": "DUSH, (Scots) to strike heavily against [v]\n",
  "DUSHES": "DUSH, (Scots) to strike heavily against [v]\n",
  "DUSHING": "DUSH, (Scots) to strike heavily against [v]\n",
  "DUSK": "to make dim [v -ED, -ING, -S] / dim, darkening [adj DUSKER, DUSKEST, DUSKLY]\n",
  "DUSKED": "DUSK, to make dim [v]\n",
  "DUSKEN": "to grow dark [v -ED, -ING, -S]\n",
  "DUSKENED": "DUSKEN, to grow dark [v]\n",
  "DUSKENING": "DUSKEN, to grow dark [v]\n",
  "DUSKENS": "DUSKEN, to grow dark [v]\n",
  "DUSKER": "DUSK, dim, darkening [adj]\n",
  "DUSKEST": "DUSK, dim, darkening [adj]\n",
  "DUSKIER": "DUSKY, somewhat dark [adj]\n",
  "DUSKIEST": "DUSKY, somewhat dark [adj]\n",
  "DUSKILY": "DUSKY, somewhat dark [adv]\n",
  "DUSKINESS": "the state of being dusky [n -ES]\n",
  "DUSKINESSES": "DUSKINESS, the state of being dusky [n]\n",
  "DUSKING": "DUSK, to make dim [v]\n",
  "DUSKISH": "somewhat dusky [adj DUSKISHLY]\n",
  "DUSKISHLY": "DUSKISH, somewhat dusky [adv]\n",
  "DUSKISHNESS": "the state of being duskish [n -ES]\n",
  "DUSKISHNESSES": "DUSKISHNESS, the state of being duskish [n]\n",
  "DUSKLY": "DUSK, dim, darkening [adv]\n",
  "DUSKNESS": "duskiness [n -ES]\n",
  "DUSKNESSES": "DUSKNESS, duskiness [n]\n",
  "DUSKS": "DUSK, to make dim [v]\n",
  "DUSKY": "somewhat dark [adj DUSKIER, DUSKIEST, DUSKILY]\n",
  "DUST": "to rid of minute particles of matter [v -ED, -ING, -S]\n",
  "DUSTBALL": "a ball of dust [n -S]\n",
  "DUSTBALLS": "DUSTBALL, a ball of dust [n]\n",
  "DUSTBIN": "a trash can [n -S]\n",
  "DUSTBINS": "DUSTBIN, a trash can [n]\n",
  "DUSTCART": "a cart used for collecting rubbish [n -S]\n",
  "DUSTCARTS": "DUSTCART, a cart used for collecting rubbish [n]\n",
  "DUSTCLOTH": "a cloth used for dusting [n -S]\n",
  "DUSTCLOTHS": "DUSTCLOTH, a cloth used for dusting [n]\n",
  "DUSTCOAT": "an overall; a light overcoat [n -S]\n",
  "DUSTCOATS": "DUSTCOAT, an overall; a light overcoat [n]\n",
  "DUSTCOVER": "a cover to protect against dust [n -S]\n",
  "DUSTCOVERS": "DUSTCOVER, a cover to protect against dust [n]\n",
  "DUSTED": "DUST, to rid of minute particles of matter [v]\n",
  "DUSTER": "one who dusts [n -S]\n",
  "DUSTERS": "DUSTER, one who dusts [n]\n",
  "DUSTHEAP": "a pile of trash [n -S]\n",
  "DUSTHEAPS": "DUSTHEAP, a pile of trash [n]\n",
  "DUSTIER": "DUSTY, full of dust [adj]\n",
  "DUSTIEST": "DUSTY, full of dust [adj]\n",
  "DUSTILY": "DUSTY, full of dust [adv]\n",
  "DUSTINESS": "the state of being dusty [n -ES]\n",
  "DUSTINESSES": "DUSTINESS, the state of being dusty [n]\n",
  "DUSTING": "a light sprinkling [n -S]\n",
  "DUSTINGS": "DUSTING, a light sprinkling [n]\n",
  "DUSTLESS": "free of dust [adj]\n",
  "DUSTLIKE": "resembling dust [adj]\n",
  "DUSTMAN": "a trashman [n DUSTMEN]\n",
  "DUSTMEN": "DUSTMAN, a trashman [n]\n",
  "DUSTOFF": "a military helicopter for evacuating the wounded [n -S]\n",
  "DUSTOFFS": "DUSTOFF, a military helicopter for evacuating the wounded [n]\n",
  "DUSTPAN": "a pan for holding swept dust [n -S]\n",
  "DUSTPANS": "DUSTPAN, a pan for holding swept dust [n]\n",
  "DUSTPROOF": "designed to exclude dust [adj]\n",
  "DUSTRAG": "a rag used for dusting [n -S]\n",
  "DUSTRAGS": "DUSTRAG, a rag used for dusting [n]\n",
  "DUSTS": "DUST, to rid of minute particles of matter [v]\n",
  "DUSTSHEET": "a sheet to protect against dust [n -S]\n",
  "DUSTSHEETS": "DUSTSHEET, a sheet to protect against dust [n]\n",
  "DUSTSTORM": "a storm of dust [n -S]\n",
  "DUSTSTORMS": "DUSTSTORM, a storm of dust [n]\n",
  "DUSTUP": "a to-do, a quarrel [n -S]\n",
  "DUSTUPS": "DUSTUP, a to-do, a quarrel [n]\n",
  "DUSTY": "full of dust [adj DUSTIER, DUSTIEST, DUSTILY]\n",
  "DUTCH": "(colloquial) a wife [n -ES]\n",
  "DUTCHES": "DUTCH, (colloquial) a wife [n]\n",
  "DUTCHMAN": "something used to hide structural defects [n DUTCHMEN]\n",
  "DUTCHMEN": "DUTCHMAN, something used to hide structural defects [n]\n",
  "DUTEOUS": "devoted to duty; obedient [adj DUTEOUSLY]\n",
  "DUTEOUSLY": "DUTEOUS, devoted to duty; obedient [adv]\n",
  "DUTEOUSNESS": "the state of being duteous [n -ES]\n",
  "DUTEOUSNESSES": "DUTEOUSNESS, the state of being duteous [n]\n",
  "DUTIABILITIES": "DUTIABILITY, the state of being dutiable [n]\n",
  "DUTIABILITY": "the state of being dutiable [n DUTIABILITIES]\n",
  "DUTIABLE": "subject to import tax [adj]\n",
  "DUTIED": "subjected to duties [adj]\n",
  "DUTIES": "DUTY, a moral or legal obligation [n]\n",
  "DUTIFUL": "obedient [adj DUTIFULLY]\n",
  "DUTIFULLY": "DUTIFUL, obedient [adv]\n",
  "DUTIFULNESS": "the state of being dutiful [n -ES]\n",
  "DUTIFULNESSES": "DUTIFULNESS, the state of being dutiful [n]\n",
  "DUTY": "a moral or legal obligation [n DUTIES]\n",
  "DUUMVIR": "(Latin) a magistrate of ancient Rome [n DUUMVIRS or DUUMVIRI]\n",
  "DUUMVIRAL": "of or belonging to the duumviri or the duumvirate [adj]\n",
  "DUUMVIRATE": "government or control by two people [n -S]\n",
  "DUUMVIRATES": "DUUMVIRATE, government or control by two people [n]\n",
  "DUUMVIRI": "DUUMVIR, (Latin) a magistrate of ancient Rome [n]\n",
  "DUUMVIRS": "DUUMVIR, (Latin) a magistrate of ancient Rome [n]\n",
  "DUVET": "(French) a light quilt filled with down [n -S]\n",
  "DUVETINE": "(tradename) a smooth lustrous velvety fabric, also DUVETYN, DUVETYNE [n -S]\n",
  "DUVETINES": "DUVETINE, (tradename) a smooth lustrous velvety fabric, also DUVETYN, DUVETYNE [n]\n",
  "DUVETS": "DUVET, (French) a light quilt filled with down [n]\n",
  "DUVETYN": "(tradename) a smooth lustrous velvety fabric, also DUVETINE, DUVETYNE [n -S]\n",
  "DUVETYNE": "(tradename) a smooth lustrous velvety fabric, also DUVETINE, DUVETYN [n -S]\n",
  "DUVETYNES": "DUVETYNE, (tradename) a smooth lustrous velvety fabric, also DUVETINE, DUVETYN [n]\n",
  "DUVETYNS": "DUVETYN, (tradename) a smooth lustrous velvety fabric, also DUVETINE, DUVETYNE [n]\n",
  "DUX": "a leader [n DUCES or DUXES]\n",
  "DUXELLES": "(French) a mince of mushrooms, chopped shallots and herbs simmered in butter [n]\n",
  "DUXES": "DUX, a leader [n]\n",
  "DUYKER": "(South African) a small South African antelope, also DUIKER, DUIKERBOK [n -S]\n",
  "DUYKERS": "DUYKER, (South African) a small South African antelope, also DUIKER, DUIKERBOK [n]\n",
  "DVANDVA": "(Sanskrit) a compound word in which neither element is subordinated to the other, e.g. tragicomedy [n -S]\n",
  "DVANDVAS": "DVANDVA, (Sanskrit) a compound word in which neither element is subordinated to the other, e.g. tragicomedy [n]\n",
  "DVORNIK": "(Russian) a Russian concierge or porter [n -S]\n",
  "DVORNIKS": "DVORNIK, (Russian) a Russian concierge or porter [n]\n",
  "DWAAL": "(South African) a state of befuddlement [n -S]\n",
  "DWAALS": "DWAAL, (South African) a state of befuddlement [n]\n",
  "DWALE": "(Old Norse) deadly nightshade [n -S]\n",
  "DWALES": "DWALE, (Old Norse) deadly nightshade [n]\n",
  "DWALM": "(Scots) to swoon, also DWAM, DWAUM [v -ED, -ING, -S]\n",
  "DWALMED": "DWALM, (Scots) to swoon, also DWAM, DWAUM [v]\n",
  "DWALMING": "DWALM, (Scots) to swoon, also DWAM, DWAUM [v]\n",
  "DWALMS": "DWALM, (Scots) to swoon, also DWAM, DWAUM [v]\n",
  "DWAM": "(Scots) to swoon, also DWALM, DWAUM [v DWAMMED, DWAMMING, DWAMS]\n",
  "DWAMMED": "DWAM, (Scots) to swoon, also DWALM, DWAUM [v]\n",
  "DWAMMING": "DWAM, (Scots) to swoon, also DWALM, DWAUM [v]\n",
  "DWAMS": "DWAM, (Scots) to swoon, also DWALM, DWAUM [v]\n",
  "DWANG": "(Dutch) a piece of timber used to reinforce joists, a strut [n -S]\n",
  "DWANGS": "DWANG, (Dutch) a piece of timber used to reinforce joists, a strut [n]\n",
  "DWARF": "extremely small [adj DWARFER, DWARFEST] / to cause to appear small [v -ED, -ING, -S] / an extremely small person [n DWARFS or DWARVES]\n",
  "DWARFED": "DWARF, to cause to appear small [v]\n",
  "DWARFER": "DWARF, extremely small [adj]\n",
  "DWARFEST": "DWARF, extremely small [adj]\n",
  "DWARFING": "DWARF, to cause to appear small [v]\n",
  "DWARFISH": "like a dwarf [adj DWARFISHLY]\n",
  "DWARFISHLY": "DWARFISH, like a dwarf [adv]\n",
  "DWARFISHNESS": "the state of being dwarfish [n -ES]\n",
  "DWARFISHNESSES": "DWARFISHNESS, the state of being dwarfish [n]\n",
  "DWARFISM": "a condition of stunted growth [n -S]\n",
  "DWARFISMS": "DWARFISM, a condition of stunted growth [n]\n",
  "DWARFLIKE": "like a dwarf [adj]\n",
  "DWARFNESS": "the state of being dwarf [n -ES]\n",
  "DWARFNESSES": "DWARFNESS, the state of being dwarf [n]\n",
  "DWARFS": "DWARF, to cause to appear small [v]\n",
  "DWARVES": "DWARF, an extremely small person [n]\n",
  "DWAUM": "(Scots) to swoon, also DWAM, DWALM [v -ED, -ING, -S]\n",
  "DWAUMED": "DWAUM, (Scots) to swoon, also DWAM, DWALM [v]\n",
  "DWAUMING": "DWAUM, (Scots) to swoon, also DWAM, DWALM [v]\n",
  "DWAUMS": "DWAUM, (Scots) to swoon, also DWAM, DWALM [v]\n",
  "DWEEB": "a fool [n -S]\n",
  "DWEEBIER": "DWEEBY, socially inept, also DWEEBISH [adj]\n",
  "DWEEBIEST": "DWEEBY, socially inept, also DWEEBISH [adj]\n",
  "DWEEBISH": "socially inept, also DWEEBY [adj]\n",
  "DWEEBS": "DWEEB, a fool [n]\n",
  "DWEEBY": "socially inept, also DWEEBISH [adj DWEEBIER, DWEEBIEST]\n",
  "DWELL": "to reside [v DWELT or DWELLED, DWELLING, DWELLS]\n",
  "DWELLED": "DWELL, to reside [v]\n",
  "DWELLER": "one who dwells [n -S]\n",
  "DWELLERS": "DWELLER, one who dwells [n]\n",
  "DWELLING": "the place where one lives [n -S]\n",
  "DWELLINGS": "DWELLING, the place where one lives [n]\n",
  "DWELLS": "DWELL, to reside [v]\n",
  "DWELT": "DWELL, to reside [v]\n",
  "DWILE": "a floorcloth or mop [n -S]\n",
  "DWILES": "DWILE, a floorcloth or mop [n]\n",
  "DWINDLE": "to decrease steadily [v DWINDLED, DWINDLING, DWINDLES]\n",
  "DWINDLED": "DWINDLE, to decrease steadily [v]\n",
  "DWINDLEMENT": "the state of dwindling [n -S]\n",
  "DWINDLEMENTS": "DWINDLEMENT, the state of dwindling [n]\n",
  "DWINDLES": "DWINDLE, to decrease steadily [v]\n",
  "DWINDLING": "DWINDLE, to decrease steadily [v]\n",
  "DWINE": "(Scots) to pine, to waste away [v DWINED, DWINING, DWINES]\n",
  "DWINED": "DWINE, (Scots) to pine, to waste away [v]\n",
  "DWINES": "DWINE, (Scots) to pine, to waste away [v]\n",
  "DWINING": "DWINE, (Scots) to pine, to waste away [v]\n",
  "DYABLE": "that can be dyed, also DYEABLE [adj]\n",
  "DYAD": "two units treated as one; a couple; a pair, also DUAD [n -S]\n",
  "DYADIC": "pertaining to the number two; of two parts or elements [adj DYADICALLY] / a sum of mathematical dyads [n -S]\n",
  "DYADICALLY": "DYADIC, pertaining to the number two; of two parts or elements [adv]\n",
  "DYADICS": "DYADIC, a sum of mathematical dyads [n]\n",
  "DYADS": "DYAD, two units treated as one; a couple; a pair, also DUAD [n]\n",
  "DYARCHAL": "relating to a dyarchy, government by two persons, also DIARCHAL, DIARCHIC, DYARCHIC, DYARCHICAL [adj]\n",
  "DYARCHIC": "relating to a dyarchy, government by two persons, also DIARCHAL, DIARCHIC, DYARCHAL, DYARCHICAL [adj]\n",
  "DYARCHICAL": "relating to a diarchy, rulership by two people, also DIARCHAL, DIARCHIC, DIARCHICAL, DYARCHIC [adj]\n",
  "DYARCHIES": "DYARCHY, government by two powers, also DIARCHY, DINARCHY, DUARCHY [n]\n",
  "DYARCHY": "government by two powers, also DIARCHY, DINARCHY, DUARCHY [n DYARCHIES]\n",
  "DYBBUK": "(Yiddish) a wandering soul in Jewish folklore, also DIBBUK [n DYBBUKS or DYBBUKIM or DYBBUKKIM]\n",
  "DYBBUKIM": "DYBBUK, (Yiddish) a wandering soul in Jewish folklore, also DIBBUK [n]\n",
  "DYBBUKKIM": "DYBBUK, (Yiddish) a wandering soul in Jewish folklore, also DIBBUK [n]\n",
  "DYBBUKS": "DYBBUK, (Yiddish) a wandering soul in Jewish folklore, also DIBBUK [n]\n",
  "DYE": "to change the colour of [v DYED, DYEING, DYES]\n",
  "DYEABILITIES": "DYEABILITY, the ability to be dyed [n]\n",
  "DYEABILITY": "the ability to be dyed [n DYEABILITIES]\n",
  "DYEABLE": "that can be dyed, also DYABLE [adj]\n",
  "DYED": "DYE, to change the colour of [v]\n",
  "DYEING": "something coloured with a dye [n -S]\n",
  "DYEINGS": "DYEING, something coloured with a dye [n]\n",
  "DYELINE": "a photocopying process using a diazo compound exposed to the light [n -S]\n",
  "DYELINES": "DYELINE, a photocopying process using a diazo compound exposed to the light [n]\n",
  "DYER": "one who dyes [n -S]\n",
  "DYERS": "DYER, one who dyes [n]\n",
  "DYES": "DYE, to change the colour of [v]\n",
  "DYESTER": "(Scots) one who dyes cloth [n -S]\n",
  "DYESTERS": "DYESTER, (Scots) one who dyes cloth [n]\n",
  "DYESTUFF": "a substance used in dyeing [n -S]\n",
  "DYESTUFFS": "DYESTUFF, a substance used in dyeing [n]\n",
  "DYEWEED": "a shrub that yields yellow dye [n -S]\n",
  "DYEWEEDS": "DYEWEED, a shrub that yields yellow dye [n]\n",
  "DYEWOOD": "any wood from which coloring matter is extracted for dyeing [n -S]\n",
  "DYEWOODS": "DYEWOOD, any wood from which coloring matter is extracted for dyeing [n]\n",
  "DYEWORKS": "a place where dye is manufactured [n]\n",
  "DYING": "fading [adj DYINGLY] / a passing out of existence [n -S]\n",
  "DYINGLY": "DYING, fading [adv]\n",
  "DYINGNESS": "the state of dying or the simulation of such a state [n -ES]\n",
  "DYINGNESSES": "DYINGNESS, the state of dying or the simulation of such a state [n]\n",
  "DYINGS": "DYING, a passing out of existence [n]\n",
  "DYKE": "to furnish with an embankment, also DIKE [v DYKED, DYKING, DYKES]\n",
  "DYKED": "DYKE, to furnish with an embankment, also DIKE [v]\n",
  "DYKES": "DYKE, to furnish with an embankment, also DIKE [v]\n",
  "DYKEY": "(offensive) like a lesbian, also DIKEY [adj DYKIER, DYKIEST]\n",
  "DYKIER": "DYKEY, (offensive) like a lesbian, also DIKEY [adj]\n",
  "DYKIEST": "DYKEY, (offensive) like a lesbian, also DIKEY [adj]\n",
  "DYKING": "DYKE, to furnish with an embankment, also DIKE [v]\n",
  "DYKON": "(offensive) a celebrity, often a woman, who is much admired by lesbians [n -S]\n",
  "DYKONS": "DYKON, (offensive) a celebrity, often a woman, who is much admired by lesbians [n]\n",
  "DYNAMETER": "an instrument for determining the magnifying power of telescopes [n -S]\n",
  "DYNAMETERS": "DYNAMETER, an instrument for determining the magnifying power of telescopes [n]\n",
  "DYNAMIC": "related to force, also DYNAMICAL [adj DYNAMICALLY] / a physical force [n -S]\n",
  "DYNAMICAL": "related to force, also DYNAMIC [adj DYNAMICALLY]\n",
  "DYNAMICALLY": "DYNAMICAL, related to force, also DYNAMIC [adv]\n",
  "DYNAMICIST": "a person who studies dynamics [n -S]\n",
  "DYNAMICISTS": "DYNAMICIST, a person who studies dynamics [n]\n",
  "DYNAMICS": "DYNAMIC, a physical force [n]\n",
  "DYNAMISE": "to make dynamic, also DYNAMIZE [v DYNAMISED, DYNAMISING, DYNAMISES]\n",
  "DYNAMISED": "DYNAMISE, to make dynamic, also DYNAMIZE [v]\n",
  "DYNAMISES": "DYNAMISE, to make dynamic, also DYNAMIZE [v]\n",
  "DYNAMISING": "DYNAMISE, to make dynamic, also DYNAMIZE [v]\n",
  "DYNAMISM": "a theory of the universe in terms of energy [n -S]\n",
  "DYNAMISMS": "DYNAMISM, a theory of the universe in terms of energy [n]\n",
  "DYNAMIST": "one who accounts for material phenomena by a theory of dynamics [n -S]\n",
  "DYNAMISTIC": "relating to dynamism [adj]\n",
  "DYNAMISTS": "DYNAMIST, one who accounts for material phenomena by a theory of dynamics [n]\n",
  "DYNAMITARD": "(archaic) a user of dynamite esp. for political purposes, also DYNAMITER [n -S]\n",
  "DYNAMITARDS": "DYNAMITARD, (archaic) a user of dynamite esp. for political purposes, also DYNAMITER [n]\n",
  "DYNAMITE": "to blow up with a powerful explosive [v DYNAMITED, DYNAMITING, DYNAMITES]\n",
  "DYNAMITED": "DYNAMITE, to blow up with a powerful explosive [v]\n",
  "DYNAMITER": "(archaic) a user of dynamite esp. for political purposes, also DYNAMITARD [n -S]\n",
  "DYNAMITERS": "DYNAMITER, (archaic) a user of dynamite esp. for political purposes, also DYNAMITARD [n]\n",
  "DYNAMITES": "DYNAMITE, to blow up with a powerful explosive [v]\n",
  "DYNAMITIC": "relating to dynamite [adj]\n",
  "DYNAMITING": "DYNAMITE, to blow up with a powerful explosive [v]\n",
  "DYNAMIZE": "to make dynamic, also DYNAMISE [v DYNAMIZED, DYNAMIZING, DYNAMIZES]\n",
  "DYNAMIZED": "DYNAMIZE, to make dynamic, also DYNAMISE [v]\n",
  "DYNAMIZES": "DYNAMIZE, to make dynamic, also DYNAMISE [v]\n",
  "DYNAMIZING": "DYNAMIZE, to make dynamic, also DYNAMISE [v]\n",
  "DYNAMO": "a machine for generating electric currents by means of the relative movement of conductors and magnets [n -S]\n",
  "DYNAMOELECTRIC": "of or concerned with the interconversion of mechanical and electrical energy [adj]\n",
  "DYNAMOGENESES": "DYNAMOGENESIS, production of increased nerve activity, also DYNAMOGENY [n]\n",
  "DYNAMOGENESIS": "production of increased nerve activity, also DYNAMOGENY [n DYNAMOGENESES]\n",
  "DYNAMOGENIES": "DYNAMOGENY, production of increased nervous activity, also DYNAMOGENESIS [n]\n",
  "DYNAMOGENY": "production of increased nervous activity, also DYNAMOGENESIS [n DYNAMOGENIES]\n",
  "DYNAMOGRAPH": "an instrument for recording mechanical forces [n -S]\n",
  "DYNAMOGRAPHS": "DYNAMOGRAPH, an instrument for recording mechanical forces [n]\n",
  "DYNAMOMETER": "instrument for measuring mechanical force [n -S]\n",
  "DYNAMOMETERS": "DYNAMOMETER, instrument for measuring mechanical force [n]\n",
  "DYNAMOMETRIC": "relating to a dynamometer, also DYNAMOMETRICAL [adj]\n",
  "DYNAMOMETRICAL": "relating to a dynamometer, also DYNAMOMETRIC [adj]\n",
  "DYNAMOMETRIES": "DYNAMOMETRY, measurement by dynamometer [n]\n",
  "DYNAMOMETRY": "measurement by dynamometer [n DYNAMOMETRIES]\n",
  "DYNAMOS": "DYNAMO, a machine for generating electric currents by means of the relative movement of conductors and magnets [n]\n",
  "DYNAMOTOR": "a kind of electrical machine [n -S]\n",
  "DYNAMOTORS": "DYNAMOTOR, a kind of electrical machine [n]\n",
  "DYNAST": "a hereditary ruler [n -S]\n",
  "DYNASTIC": "relating to a dynasty, also DYNASTICAL [adj DYNASTICALLY]\n",
  "DYNASTICAL": "relating to a dynasty, also DYNASTIC [adj DYNASTICALLY]\n",
  "DYNASTICALLY": "DYNASTICAL, relating to a dynasty, also DYNASTIC [adv]\n",
  "DYNASTICISM": "a system of government in which the rulers are all drawn from the same family [n -S]\n",
  "DYNASTICISMS": "DYNASTICISM, a system of government in which the rulers are all drawn from the same family [n]\n",
  "DYNASTIES": "DYNASTY, a succession of rulers from the same line of descent [n]\n",
  "DYNASTS": "DYNAST, a hereditary ruler [n]\n",
  "DYNASTY": "a succession of rulers from the same line of descent [n DYNASTIES]\n",
  "DYNATRON": "an electrode thermionic valve used to generate continuous oscillation [n -S]\n",
  "DYNATRONS": "DYNATRON, an electrode thermionic valve used to generate continuous oscillation [n]\n",
  "DYNE": "a unit of force, the force required to accelerate 1 gram to 1 cm per second per second [n -S]\n",
  "DYNEIN": "an enzyme involved in cell movement [n -S]\n",
  "DYNEINS": "DYNEIN, an enzyme involved in cell movement [n]\n",
  "DYNEL": "a synthetic fibre [n -S]\n",
  "DYNELS": "DYNEL, a synthetic fibre [n]\n",
  "DYNES": "DYNE, a unit of force, the force required to accelerate 1 gram to 1 cm per second per second [n]\n",
  "DYNODE": "an intermediate electrode between anode and cathode [n -S]\n",
  "DYNODES": "DYNODE, an intermediate electrode between anode and cathode [n]\n",
  "DYNORPHIN": "a drug used to treat cocaine addiction [n -S]\n",
  "DYNORPHINS": "DYNORPHIN, a drug used to treat cocaine addiction [n]\n",
  "DYOPHYSITE": "a believer in the existence of two natures in Christ, human and divine, also DIOPHYSITE, DIPHYSITE [n -S]\n",
  "DYOPHYSITES": "DYOPHYSITE, a believer in the existence of two natures in Christ, human and divine, also DIOPHYSITE, DIPHYSITE [n]\n",
  "DYOTHELETE": "a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DIOTHELETE, DITHELETE, DYOTHELITE [n -S]\n",
  "DYOTHELETES": "DYOTHELETE, a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DIOTHELETE, DITHELETE, DYOTHELITE [n]\n",
  "DYOTHELETIC": "relating to dyotheletism, the doctrine that Christ on earth had two wills, human and divine, also DYOTHELITIC [adj]\n",
  "DYOTHELETICAL": "relating to dyotheletism, the doctrine that Christ on earth had two wills, human and divine, also DYOTHELITICAL [adj]\n",
  "DYOTHELETISM": "the doctrine that Christ on earth had two wills, human and divine [n -S]\n",
  "DYOTHELETISMS": "DYOTHELETISM, the doctrine that Christ on earth had two wills, human and divine [n]\n",
  "DYOTHELISM": "the doctrine that Christ on earth had two will, human and divine, also DIOTHELISM, DITHELETISM, DITHELISM [n -S]\n",
  "DYOTHELISMS": "DYOTHELISM, the doctrine that Christ on earth had two will, human and divine, also DIOTHELISM, DITHELETISM, DITHELISM [n]\n",
  "DYOTHELITE": "a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DIOTHELETE, DITHELETE, DYOTHELETE [n -S]\n",
  "DYOTHELITES": "DYOTHELITE, a believer in dithelism, the doctrine that Christ on earth had two wills, human and divine, also DIOTHELETE, DITHELETE, DYOTHELETE [n]\n",
  "DYOTHELITIC": "relating to dyotheletism, the doctrine that Christ on earth had two wills, human and divine, also DYOTHELETIC [adj]\n",
  "DYOTHELITICAL": "relating to dyotheletism, the doctrine that Christ on earth had two wills, human and divine, also DYOTHELETICAL [adj]\n",
  "DYSAESTHESIA": "loss of sensation [n -S]\n",
  "DYSAESTHESIAS": "DYSAESTHESIA, loss of sensation [n]\n",
  "DYSAESTHETIC": "relating to dysaesthesia, loss of sensation [adj]\n",
  "DYSARTHRIA": "the impaired ability to articulate speech due to damage to the nervous system [n -S]\n",
  "DYSARTHRIAS": "DYSARTHRIA, the impaired ability to articulate speech due to damage to the nervous system [n]\n",
  "DYSBINDIN": "a gene associated with schizophrenia [n -S]\n",
  "DYSBINDINS": "DYSBINDIN, a gene associated with schizophrenia [n]\n",
  "DYSCALCULIA": "the inability to calculate correctly, also ACALCULIA [n -S]\n",
  "DYSCALCULIAS": "DYSCALCULIA, the inability to calculate correctly, also ACALCULIA [n]\n",
  "DYSCHROA": "discoloration of the skin from disease, also DYSCHROIA [n -S]\n",
  "DYSCHROAS": "DYSCHROA, discoloration of the skin from disease, also DYSCHROIA [n]\n",
  "DYSCHROIA": "discoloration of the skin from disease, also DYSCHROA [n -S]\n",
  "DYSCHROIAS": "DYSCHROIA, discoloration of the skin from disease, also DYSCHROA [n]\n",
  "DYSCRASIA": "(obsolete) a disordered condition of the body attributed originally to unsuitable mixing of the body fluids or humours [n -S]\n",
  "DYSCRASIAS": "DYSCRASIA, (obsolete) a disordered condition of the body attributed originally to unsuitable mixing of the body fluids or humours [n]\n",
  "DYSCRASIC": "relating to dyscrasia, a disordered condition of the body, also DYSCRATIC [adj]\n",
  "DYSCRASITE": "a mineral consisting of antimony and silver [n -S]\n",
  "DYSCRASITES": "DYSCRASITE, a mineral consisting of antimony and silver [n]\n",
  "DYSCRATIC": "relating to dyscrasia, a disordered condition of the body, also DYSCRASIC [adj]\n",
  "DYSENTERIC": "relating to dysentery [adj]\n",
  "DYSENTERIES": "DYSENTERY, inflammation of the mucous membranes of the large intestine [n]\n",
  "DYSENTERY": "inflammation of the mucous membranes of the large intestine [n DYSENTERIES]\n",
  "DYSFLUENT": "not fluent, also DISFLUENT [adj]\n",
  "DYSFUNCTION": "impaired or abnormal functioning, also DISFUNCTION [n -S]\n",
  "DYSFUNCTIONAL": "relating to dysfunction, also DISFUNCTIONAL [adj]\n",
  "DYSFUNCTIONS": "DYSFUNCTION, impaired or abnormal functioning, also DISFUNCTION [n]\n",
  "DYSGENESES": "DYSGENESIS, sterility in hybrid creatures [n]\n",
  "DYSGENESIS": "sterility in hybrid creatures [n DYSGENESES]\n",
  "DYSGENIC": "causing the deterioration of hereditary qualities [adj]\n",
  "DYSGENICS": "the study of racial degeneration [n]\n",
  "DYSGRAPHIA": "writing impairment [n -S]\n",
  "DYSGRAPHIAS": "DYSGRAPHIA, writing impairment [n]\n",
  "DYSGRAPHIC": "someone suffering from dysgraphia, the inability to write [n -S]\n",
  "DYSGRAPHICS": "DYSGRAPHIC, someone suffering from dysgraphia, the inability to write [n]\n",
  "DYSHARMONIC": "out of harmony, discordant, also DISHARMONIC [adj]\n",
  "DYSKINESIA": "the loss of the power of voluntary movement [n -S]\n",
  "DYSKINESIAS": "DYSKINESIA, the loss of the power of voluntary movement [n]\n",
  "DYSKINETIC": "suffering from dyskinesia, loss of power of voluntary movement [adj]\n",
  "DYSLALIA": "defective speech characteristic of those affected by aphasia [n -S]\n",
  "DYSLALIAS": "DYSLALIA, defective speech characteristic of those affected by aphasia [n]\n",
  "DYSLECTIC": "suffering from dyslexia, reading impairment [adj] / one suffering from dyslexia, also DYSLEXIC [n -S]\n",
  "DYSLECTICS": "DYSLECTIC, one suffering from dyslexia, also DYSLEXIC [n]\n",
  "DYSLEXIA": "impairment of the ability to read [n -S]\n",
  "DYSLEXIAS": "DYSLEXIA, impairment of the ability to read [n]\n",
  "DYSLEXIC": "suffering from dyslexia, reading impairment [adj] / one suffering from dyslexia, also DYSLECTIC [n -S]\n",
  "DYSLEXICS": "DYSLEXIC, one suffering from dyslexia, also DYSLECTIC [n]\n",
  "DYSLOGIES": "DYSLOGY, dispraise [n]\n",
  "DYSLOGISTIC": "conveying censure [adj DYSLOGISTICALLY]\n",
  "DYSLOGISTICALLY": "DYSLOGISTIC, conveying censure [adv]\n",
  "DYSLOGY": "dispraise [n DYSLOGIES]\n",
  "DYSMELIA": "the condition in which one or more limbs are misshapen or incomplete [n -S]\n",
  "DYSMELIAS": "DYSMELIA, the condition in which one or more limbs are misshapen or incomplete [n]\n",
  "DYSMELIC": "suffering from dysmelia, the condition of having misshapen or incomplete limbs [adj]\n",
  "DYSMENORRHEA": "painful menstruation, also DYSMENORRHOEA [n -S]\n",
  "DYSMENORRHEAL": "suffering from dysmenorrhea, painful menstruation, also DYSMENORRHOEAL [adj]\n",
  "DYSMENORRHEAS": "DYSMENORRHEA, painful menstruation, also DYSMENORRHOEA [n]\n",
  "DYSMENORRHEIC": "relating to dysmenorrhea, also DYSMENORRHOEIC [adj]\n",
  "DYSMENORRHOEA": "painful menstruation, also DYSMENORRHEA [n -S]\n",
  "DYSMENORRHOEAL": "suffering from dysmenorrhoea, painful menstruation, also DYSMENORRHEAL [adj]\n",
  "DYSMENORRHOEAS": "DYSMENORRHOEA, painful menstruation, also DYSMENORRHEA [n]\n",
  "DYSMENORRHOEIC": "suffering from dysmenorrhoea, painful menstruation, also DYSMENORRHEIC [adj]\n",
  "DYSMORPHIC": "obsessively concerned with supposed defects in one's appearance [adj]\n",
  "DYSMORPHOPHOBIA": "fear of physical deformities [n]\n",
  "DYSMORPHOPHOBIC": "relating to or affected with dysmorphophobia, the fear that one's body is repulsive [adj]\n",
  "DYSODIL": "an impure earthy or coaly bitumen, which emits a highly fetid odor when burning, also DYSODILE, DYSODYLE [n -S]\n",
  "DYSODILE": "an impure earthy or coaly bitumen, which emits a highly fetid odor when burning, also DYSODIL, DYSODYLE [n -S]\n",
  "DYSODILES": "DYSODILE, an impure earthy or coaly bitumen, which emits a highly fetid odor when burning, also DYSODIL, DYSODYLE [n]\n",
  "DYSODILS": "DYSODIL, an impure earthy or coaly bitumen, which emits a highly fetid odor when burning, also DYSODILE, DYSODYLE [n]\n",
  "DYSODYLE": "an impure earthy or coaly bitumen, which emits a highly fetid odor when burning, also DYSODIL, DYSODILE [n -S]\n",
  "DYSODYLES": "DYSODYLE, an impure earthy or coaly bitumen, which emits a highly fetid odor when burning, also DYSODIL, DYSODILE [n]\n",
  "DYSPAREUNIA": "painful or difficult coitus [n -S]\n",
  "DYSPAREUNIAS": "DYSPAREUNIA, painful or difficult coitus [n]\n",
  "DYSPATHETIC": "relating to dyspathy [adj]\n",
  "DYSPATHIES": "DYSPATHY, dislike, also DISPATHY [n]\n",
  "DYSPATHY": "dislike, also DISPATHY [n DYSPATHIES]\n",
  "DYSPEPSIA": "severe indigestion, esp. chronic, also DYSPEPSY [n -S]\n",
  "DYSPEPSIAS": "DYSPEPSIA, severe indigestion, esp. chronic, also DYSPEPSY [n]\n",
  "DYSPEPSIES": "DYSPEPSY, indigestion [n]\n",
  "DYSPEPSY": "indigestion [n DYSPEPSIES]\n",
  "DYSPEPTIC": "suffering from dyspepsia, also DYSPEPTICAL [adj DYSPEPTICALLY] / someone suffering from dyspepsia [n -S]\n",
  "DYSPEPTICAL": "suffering from dyspepsia, also DYSPEPTIC [adj DYSPEPTICALLY]\n",
  "DYSPEPTICALLY": "DYSPEPTICAL, suffering from dyspepsia, also DYSPEPTIC [adv]\n",
  "DYSPEPTICS": "DYSPEPTIC, someone suffering from dyspepsia [n]\n",
  "DYSPHAGIA": "pathological difficulty in swallowing [n -S]\n",
  "DYSPHAGIAS": "DYSPHAGIA, pathological difficulty in swallowing [n]\n",
  "DYSPHAGIC": "suffering from dysphagia, difficulty in swallowing [adj]\n",
  "DYSPHAGIES": "DYSPHAGY, difficulty in swallowing [n]\n",
  "DYSPHAGY": "difficulty in swallowing [n DYSPHAGIES]\n",
  "DYSPHASIA": "impairment of speech coordination, due to brain disease or injury [n -S]\n",
  "DYSPHASIAS": "DYSPHASIA, impairment of speech coordination, due to brain disease or injury [n]\n",
  "DYSPHASIC": "suffering from dysphasia, impairment of speech coordination, due to brain disease or injury [adj] / someone suffering from dysphasia [n -S]\n",
  "DYSPHASICS": "DYSPHASIC, someone suffering from dysphasia [n]\n",
  "DYSPHEMISM": "the substitution of a disagreeable or offensive expression for an agreeable or inoffensive one, e.g. The Holocaust (the dysphemism chosen by Jewish historians to replace the Nazis' ghastly euphemism, The Final Solution) [n -S]\n",
  "DYSPHEMISMS": "DYSPHEMISM, the substitution of a disagreeable or offensive expression for an agreeable or inoffensive one, e.g. The Holocaust (the dysphemism chosen by Jewish historians to replace the Nazis' ghastly euphemism, The Final Solution) [n]\n",
  "DYSPHEMISTIC": "relating to dysphemism [adj]\n",
  "DYSPHONIA": "physical abnormality causing speech impediment [n -S]\n",
  "DYSPHONIAS": "DYSPHONIA, physical abnormality causing speech impediment [n]\n",
  "DYSPHONIC": "relating to dysphonia, a difficulty in pronouncing sounds [adj]\n",
  "DYSPHORIA": "depression, pathological discontent [n -S]\n",
  "DYSPHORIAS": "DYSPHORIA, depression, pathological discontent [n]\n",
  "DYSPHORIC": "relating to dysphoria, a state of feeling unwell or unhappy [adj]\n",
  "DYSPLASIA": "abnormal tissue development [n -S]\n",
  "DYSPLASIAS": "DYSPLASIA, abnormal tissue development [n]\n",
  "DYSPLASTIC": "suffering from dysplasia, abnormal tissue development [adj]\n",
  "DYSPNEA": "laboured breathing, also DYSPNOEA [n -S]\n",
  "DYSPNEAL": "of or like dyspnea, laboured breathing, also DYSPNEIC, DYSPNOEAL, DYSPNOEIC, DYSPNOIC [adj]\n",
  "DYSPNEAS": "DYSPNEA, laboured breathing, also DYSPNOEA [n]\n",
  "DYSPNEIC": "of or like dyspnea, laboured breathing, also DYSPNEAL, DYSPNOEAL, DYSPNOEIC, DYSPNOIC [adj]\n",
  "DYSPNOEA": "laboured breathing, also DYSPNEA [n -S]\n",
  "DYSPNOEAL": "of or like dyspnoea, laboured breathing, also DYSPNEAL, DYSPNEIC, DYSPNOEIC, DYSPNOIC [adj]\n",
  "DYSPNOEAS": "DYSPNOEA, laboured breathing, also DYSPNEA [n]\n",
  "DYSPNOEIC": "of or like dyspnoea, laboured breathing, also DYSPNEAL, DYSPNEIC, DYSPNOEAL, DYSPNOIC [adj]\n",
  "DYSPNOIC": "of or like dyspnoea, laboured breathing, also DYSPNEAL, DYSPNEIC, DYSPNOEAL, DYSPNOEIC [adj]\n",
  "DYSPRACTIC": "suffering from dyspraxia, also DYSPRAXIC [adj]\n",
  "DYSPRAXIA": "an impaired ability to perform deliberate actions [n -S]\n",
  "DYSPRAXIAS": "DYSPRAXIA, an impaired ability to perform deliberate actions [n]\n",
  "DYSPRAXIC": "relating to dyspraxia, an impaired ability to coordinate and perform certain actions, also DYSPRACTIC [adj]\n",
  "DYSPROSIUM": "a rare-earth metal used in nuclear research [n -S]\n",
  "DYSPROSIUMS": "DYSPROSIUM, a rare-earth metal used in nuclear research [n]\n",
  "DYSRHYTHMIA": "an abnormal rhythm [n -S]\n",
  "DYSRHYTHMIAS": "DYSRHYTHMIA, an abnormal rhythm [n]\n",
  "DYSRHYTHMIC": "someone suffering from dysrhythmia [n -S]\n",
  "DYSRHYTHMICS": "DYSRHYTHMIC, someone suffering from dysrhythmia [n]\n",
  "DYSSYNERGIA": "muscular incoordination caused by a brain disorder, also DYSSYNERGY [n -S]\n",
  "DYSSYNERGIAS": "DYSSYNERGIA, muscular incoordination caused by a brain disorder, also DYSSYNERGY [n]\n",
  "DYSSYNERGIC": "relating to or affected by dyssynergia [adj]\n",
  "DYSSYNERGIES": "DYSSYNERGY, muscular incoordination caused by a brain disorder, also DYSSYNERGIA [n]\n",
  "DYSSYNERGY": "muscular incoordination caused by a brain disorder, also DYSSYNERGIA [n DYSSYNERGIES]\n",
  "DYSTAXIA": "a form of muscular tremor [n -S]\n",
  "DYSTAXIAS": "DYSTAXIA, a form of muscular tremor [n]\n",
  "DYSTAXIC": "relating to or affected by dystaxia [adj]\n",
  "DYSTECTIC": "not easily fused [adj]\n",
  "DYSTELEOLOGICAL": "related to dysteleology, the study of functionless rudimentary organs in animals and plants [adj]\n",
  "DYSTELEOLOGIES": "DYSTELEOLOGY, the study of functionless rudimentary organs in animals and plants [n]\n",
  "DYSTELEOLOGIST": "a specialist in dysteleology, the study of functionless rudimentary organs in animals and plants [n -S]\n",
  "DYSTELEOLOGISTS": "DYSTELEOLOGIST, a specialist in dysteleology, the study of functionless rudimentary organs in animals and plants [n]\n",
  "DYSTELEOLOGY": "the study of functionless rudimentary organs in animals and plants [n DYSTELEOLOGIES]\n",
  "DYSTHESIA": "a morbid habit of body, resulting in general discomfort and impatience [n -S]\n",
  "DYSTHESIAS": "DYSTHESIA, a morbid habit of body, resulting in general discomfort and impatience [n]\n",
  "DYSTHETIC": "suffering from dysthesia, a morbid habit of body, resulting in general discomfort and impatience [adj]\n",
  "DYSTHYMIA": "a mild depression, despondency [n -S]\n",
  "DYSTHYMIAC": "a person who suffers from dysthymia, despondency [n -S]\n",
  "DYSTHYMIACS": "DYSTHYMIAC, a person who suffers from dysthymia, despondency [n]\n",
  "DYSTHYMIAS": "DYSTHYMIA, a mild depression, despondency [n]\n",
  "DYSTHYMIC": "despondent [adj] / one given to despondency [n -S]\n",
  "DYSTHYMICS": "DYSTHYMIC, one given to despondency [n]\n",
  "DYSTOCIA": "difficult labour and delivery in childbirth [n -S]\n",
  "DYSTOCIAL": "relating to dystocia, difficult childbirth [adj]\n",
  "DYSTOCIAS": "DYSTOCIA, difficult labour and delivery in childbirth [n]\n",
  "DYSTONIA": "a condition of disordered tonicity of muscle tissue [n -S]\n",
  "DYSTONIAS": "DYSTONIA, a condition of disordered tonicity of muscle tissue [n]\n",
  "DYSTONIC": "relating to dystonia, a disorder of muscle tone [adj]\n",
  "DYSTOPIA": "a place thought of as the opposite to Utopia, i.e. where everything is as bad as possible [n -S]\n",
  "DYSTOPIAN": "relating to dystopia, a place thought of as the opposite to Utopia, i.e. where everything is as bad as possible [adj] / a believer in dystopia [n -S]\n",
  "DYSTOPIANS": "DYSTOPIAN, a believer in dystopia [n]\n",
  "DYSTOPIAS": "DYSTOPIA, a place thought of as the opposite to Utopia, i.e. where everything is as bad as possible [n]\n",
  "DYSTROPHIA": "impaired or imperfect nutrition; any of several disorders in which there is wasting of muscle tissue, also DYSTROPHY [n -S]\n",
  "DYSTROPHIAS": "DYSTROPHIA, impaired or imperfect nutrition; any of several disorders in which there is wasting of muscle tissue, also DYSTROPHY [n]\n",
  "DYSTROPHIC": "relating to dystrophia [adj]\n",
  "DYSTROPHIES": "DYSTROPHY, impaired or imperfect nutrition; any of several disorders in which there is wasting of muscle tissue, also DYSTROPHIA [n]\n",
  "DYSTROPHIN": "a protein essential to normal muscle function, found to be lacking in muscular dystrophy sufferers [n -S]\n",
  "DYSTROPHINS": "DYSTROPHIN, a protein essential to normal muscle function, found to be lacking in muscular dystrophy sufferers [n]\n",
  "DYSTROPHY": "impaired or imperfect nutrition; any of several disorders in which there is wasting of muscle tissue, also DYSTROPHIA [n DYSTROPHIES]\n",
  "DYSURIA": "pain in passing urine, also DYSURY [n -S]\n",
  "DYSURIAS": "DYSURIA, pain in passing urine, also DYSURY [n]\n",
  "DYSURIC": "pertaining to, or afflicted with, dysury, difficult or painful discharge of urine [adj]\n",
  "DYSURIES": "DYSURY, pain in passing urine, also DYSURIA [n]\n",
  "DYSURY": "pain in passing urine, also DYSURIA [n DYSURIES]\n",
  "DYTISCID": "a carnivorous water beetle [n -S]\n",
  "DYTISCIDS": "DYTISCID, a carnivorous water beetle [n]\n",
  "DYVOUR": "(Scots) a bankrupt [n -S]\n",
  "DYVOURIES": "DYVOURY, (Scots) bankruptcy [n]\n",
  "DYVOURS": "DYVOUR, (Scots) a bankrupt [n]\n",
  "DYVOURY": "(Scots) bankruptcy [n DYVOURIES]\n",
  "DZEREN": "(Mongolian) a kind of Asian antelope [n -S]\n",
  "DZERENS": "DZEREN, (Mongolian) a kind of Asian antelope [n]\n",
  "DZHO": "a cross between a yak and a cow, also ZHO, DSO, DZO, JOMO [n -S]\n",
  "DZHOS": "DZHO, a cross between a yak and a cow, also ZHO, DSO, DZO, JOMO [n]\n",
  "DZIGGETAI": "(Mongolian) a wild ass native to the Tibetan plateau, aka kiang or kyang, also CHIGETAI [n -S]\n",
  "DZIGGETAIS": "DZIGGETAI, (Mongolian) a wild ass native to the Tibetan plateau, aka kiang or kyang, also CHIGETAI [n]\n",
  "DZO": "a cross between a yak and a cow, also DSO, DZHO, ZO, ZHO [n -S]\n",
  "DZOS": "DZO, a cross between a yak and a cow, also DSO, DZHO, ZO, ZHO [n]\n",
  "EA": "(dialect) a river [n -S]\n",
  "EACH": "every one taken separately [adj]\n",
  "EACHWHERE": "(obsolete) everywhere [adv]\n",
  "EADISH": "pasturage, also EDDISH [n -ES]\n",
  "EADISHES": "EADISH, pasturage, also EDDISH [n]\n",
  "EAGER": "a tidal flood, also EAGRE, EGER [n -S] / full of keen desire, also AYGRE [adj EAGERER, EAGEREST, EAGERLY]\n",
  "EAGERER": "EAGER, full of keen desire, also AYGRE [adj]\n",
  "EAGEREST": "EAGER, full of keen desire, also AYGRE [adj]\n",
  "EAGERLY": "EAGER, full of keen desire, also AYGRE [adv]\n",
  "EAGERNESS": "the state of being eager [n -ES]\n",
  "EAGERNESSES": "EAGERNESS, the state of being eager [n]\n",
  "EAGERS": "EAGER, a tidal flood, also EAGRE, EGER [n]\n",
  "EAGLE": "a large bird of prey [n -S] / to score two under par in golf [v EAGLED, EAGLING, EAGLES]\n",
  "EAGLED": "EAGLE, to score two under par in golf [v]\n",
  "EAGLEHAWK": "a large bird of prey [n -S]\n",
  "EAGLEHAWKS": "EAGLEHAWK, a large bird of prey [n]\n",
  "EAGLES": "EAGLE, to score two under par in golf [v]\n",
  "EAGLESTONE": "a hollow oval nodule of clay ironstone [n -S]\n",
  "EAGLESTONES": "EAGLESTONE, a hollow oval nodule of clay ironstone [n]\n",
  "EAGLET": "a young eagle [n -S]\n",
  "EAGLETS": "EAGLET, a young eagle [n]\n",
  "EAGLEWOOD": "a kind of fragrant wood, aka agalloch [n -S]\n",
  "EAGLEWOODS": "EAGLEWOOD, a kind of fragrant wood, aka agalloch [n]\n",
  "EAGLING": "EAGLE, to score two under par in golf [v]\n",
  "EAGRE": "a bore or sudden rise of the tide, also EAGER, EGER [n -S]\n",
  "EAGRES": "EAGRE, a bore or sudden rise of the tide, also EAGER, EGER [n]\n",
  "EALDORMAN": "(obsolete) a chief magistrate in Anglo-Saxon England [n EALDORMEN]\n",
  "EALDORMEN": "EALDORMAN, (obsolete) a chief magistrate in Anglo-Saxon England [n]\n",
  "EALE": "(Shakespeare) to ail [v EALED, EALING, EALES]\n",
  "EALED": "EALE, (Shakespeare) to ail [v]\n",
  "EALES": "EALE, (Shakespeare) to ail [v]\n",
  "EALING": "EALE, (Shakespeare) to ail [v]\n",
  "EAN": "(Shakespeare) to give birth to, also YEAN [v -ED, -ING, -S]\n",
  "EANED": "EAN, (Shakespeare) to give birth to, also YEAN [v]\n",
  "EANING": "EAN, (Shakespeare) to give birth to, also YEAN [v]\n",
  "EANLING": "(Shakespeare) a young lamb, also WEANEL, WEANLING, YEANLING [n -S]\n",
  "EANLINGS": "EANLING, (Shakespeare) a young lamb, also WEANEL, WEANLING, YEANLING [n]\n",
  "EANS": "EAN, (Shakespeare) to give birth to, also YEAN [v]\n",
  "EAR": "to plough or till [v -ED, -ING, -S]\n",
  "EARACHE": "a pain in the ear [n -S]\n",
  "EARACHES": "EARACHE, a pain in the ear [n]\n",
  "EARBALL": "a small ball kept in the ear and squeezed to relieve stress [n -S]\n",
  "EARBALLS": "EARBALL, a small ball kept in the ear and squeezed to relieve stress [n]\n",
  "EARBASH": "to talk to someone loudly and at length [v -ED, -ING, -ES]\n",
  "EARBASHED": "EARBASH, to talk to someone loudly and at length [v]\n",
  "EARBASHER": "(Australian slang) one who earbashes, talks incessantly [n -S]\n",
  "EARBASHERS": "EARBASHER, (Australian slang) one who earbashes, talks incessantly [n]\n",
  "EARBASHES": "EARBASH, to talk to someone loudly and at length [v]\n",
  "EARBASHING": "talking to someone loudly and at length [n -S]\n",
  "EARBASHINGS": "EARBASHING, talking to someone loudly and at length [n]\n",
  "EARBOB": "an earring [n -S]\n",
  "EARBOBS": "EARBOB, an earring [n]\n",
  "EARBUD": "a small earphone [n -S]\n",
  "EARBUDS": "EARBUD, a small earphone [n]\n",
  "EARCON": "an audible marker in a computer display [n -S]\n",
  "EARCONS": "EARCON, an audible marker in a computer display [n]\n",
  "EARD": "(Scots) to bury, also YEARD, YERD, YIRD, YIRTH [v -ED, -ING, -S]\n",
  "EARDED": "EARD, (Scots) to bury, also YEARD, YERD, YIRD, YIRTH [v]\n",
  "EARDING": "EARD, (Scots) to bury, also YEARD, YERD, YIRD, YIRTH [v]\n",
  "EARDROP": "a pendant for the ear [n -S]\n",
  "EARDROPS": "EARDROP, a pendant for the ear [n]\n",
  "EARDRUM": "the tympanic membrane [n -S]\n",
  "EARDRUMS": "EARDRUM, the tympanic membrane [n]\n",
  "EARDS": "EARD, (Scots) to bury, also YEARD, YERD, YIRD, YIRTH [v]\n",
  "EARED": "EAR, to plough or till [v]\n",
  "EARFLAP": "a part of a cap that covers the ears [n -S]\n",
  "EARFLAPS": "EARFLAP, a part of a cap that covers the ears [n]\n",
  "EARFUL": "as much gossip as one can stand [n -S]\n",
  "EARFULS": "EARFUL, as much gossip as one can stand [n]\n",
  "EARHOLE": "the external opening of the ear [n -S]\n",
  "EARHOLES": "EARHOLE, the external opening of the ear [n]\n",
  "EARING": "a line for fastening the corner of a sail to the gaff or yard [n -S]\n",
  "EARINGS": "EARING, a line for fastening the corner of a sail to the gaff or yard [n]\n",
  "EARL": "a rank above viscount, below marquis [n -S]\n",
  "EARLAP": "the lobe of the ear [n -S]\n",
  "EARLAPS": "EARLAP, the lobe of the ear [n]\n",
  "EARLDOM": "the rank of an earl [n -S]\n",
  "EARLDOMS": "EARLDOM, the rank of an earl [n]\n",
  "EARLESS": "without ears [adj]\n",
  "EARLIER": "EARLY, before the due time [adj]\n",
  "EARLIERISE": "to do at a date earlier than that arranged, also EARLIERIZE [v EARLIERISED, EARLIERISING, EARLIERISES]\n",
  "EARLIERISED": "EARLIERISE, to do at a date earlier than that arranged, also EARLIERIZE [v]\n",
  "EARLIERISES": "EARLIERISE, to do at a date earlier than that arranged, also EARLIERIZE [v]\n",
  "EARLIERISING": "EARLIERISE, to do at a date earlier than that arranged, also EARLIERIZE [v]\n",
  "EARLIERIZE": "to do at a date earlier than that arranged, also EARLIERISE [v EARLIERIZED, EARLIERIZING, EARLIERIZES]\n",
  "EARLIERIZED": "EARLIERIZE, to do at a date earlier than that arranged, also EARLIERISE [v]\n",
  "EARLIERIZES": "EARLIERIZE, to do at a date earlier than that arranged, also EARLIERISE [v]\n",
  "EARLIERIZING": "EARLIERIZE, to do at a date earlier than that arranged, also EARLIERISE [v]\n",
  "EARLIES": "EARLY, an early potato [n]\n",
  "EARLIEST": "EARLY, before the due time [adj]\n",
  "EARLIKE": "like an ear [adj]\n",
  "EARLINESS": "the state of being early [n -ES]\n",
  "EARLINESSES": "EARLINESS, the state of being early [n]\n",
  "EARLOBE": "the soft lower part of the outer ear [n -S]\n",
  "EARLOBES": "EARLOBE, the soft lower part of the outer ear [n]\n",
  "EARLOCK": "a curl of hair near the ear [n -S]\n",
  "EARLOCKS": "EARLOCK, a curl of hair near the ear [n]\n",
  "EARLS": "EARL, a rank above viscount, below marquis [n]\n",
  "EARLSHIP": "the rank of earl [n -S]\n",
  "EARLSHIPS": "EARLSHIP, the rank of earl [n]\n",
  "EARLY": "an early potato [n EARLIES] / before the due time [adj EARLIER, EARLIEST]\n",
  "EARLYWOOD": "the wood formed in the first part of the growth layer during the spring [n -S]\n",
  "EARLYWOODS": "EARLYWOOD, the wood formed in the first part of the growth layer during the spring [n]\n",
  "EARMARK": "to set aside for a definite purpose [v -ED, -ING, -S]\n",
  "EARMARKED": "EARMARK, to set aside for a definite purpose [v]\n",
  "EARMARKING": "EARMARK, to set aside for a definite purpose [v]\n",
  "EARMARKS": "EARMARK, to set aside for a definite purpose [v]\n",
  "EARMUFF": "one of a pair of ear coverings, joined by a band across the head, worn to protect the ears from cold or noise [n -S]\n",
  "EARMUFFS": "EARMUFF, one of a pair of ear coverings, joined by a band across the head, worn to protect the ears from cold or noise [n]\n",
  "EARN": "to gain or deserve for one's labour or service, also ERN [v EARNED or EARNT, EARNING, EARNS]\n",
  "EARNED": "EARN, to gain or deserve for one's labour or service, also ERN [v]\n",
  "EARNER": "one that earns [n -S]\n",
  "EARNERS": "EARNER, one that earns [n]\n",
  "EARNEST": "serious [adj EARNESTLY] / a pledge of good intent [n -S]\n",
  "EARNESTLY": "EARNEST, serious [adv]\n",
  "EARNESTNESS": "the state of being earnest [n -ES]\n",
  "EARNESTNESSES": "EARNESTNESS, the state of being earnest [n]\n",
  "EARNESTS": "EARNEST, a pledge of good intent [n]\n",
  "EARNING": "what is earned [n -S]\n",
  "EARNINGS": "EARNING, what is earned [n]\n",
  "EARNS": "EARN, to gain or deserve for one's labour or service, also ERN [v]\n",
  "EARNT": "EARN, to gain or deserve for one's labour or service, also ERN [v]\n",
  "EARPHONE": "a headphone [n -S]\n",
  "EARPHONES": "EARPHONE, a headphone [n]\n",
  "EARPICK": "an instrument for removing wax from the ear [n -S]\n",
  "EARPICKS": "EARPICK, an instrument for removing wax from the ear [n]\n",
  "EARPIECE": "an earphone [n -S]\n",
  "EARPIECES": "EARPIECE, an earphone [n]\n",
  "EARPLUG": "a plug for the ear [n -S]\n",
  "EARPLUGS": "EARPLUG, a plug for the ear [n]\n",
  "EARRING": "a ring worn on the earlobe [n -S]\n",
  "EARRINGED": "wearing earrings [adj]\n",
  "EARRINGS": "EARRING, a ring worn on the earlobe [n]\n",
  "EARS": "EAR, to plough or till [v]\n",
  "EARSHOT": "a range from which a sound can be heard [n -S]\n",
  "EARSHOTS": "EARSHOT, a range from which a sound can be heard [n]\n",
  "EARSPLITTING": "distressingly loud or shrill [adj]\n",
  "EARST": "formerly, also ERST [adv]\n",
  "EARSTONE": "an otolith, a calcium concretion in the inside of a vertebrate's ear to aid in equilibrium [n -S]\n",
  "EARSTONES": "EARSTONE, an otolith, a calcium concretion in the inside of a vertebrate's ear to aid in equilibrium [n]\n",
  "EARTH": "to cover with soil [v -ED, -ING, -S]\n",
  "EARTHBORN": "born from or on the earth [adj]\n",
  "EARTHBOUND": "fast in or to the soil [adj]\n",
  "EARTHED": "EARTH, to cover with soil [v]\n",
  "EARTHEN": "made of earth [adj]\n",
  "EARTHENWARE": "ceramic ware made of slightly porous opaque clay fired at low heat [n -S]\n",
  "EARTHENWARES": "EARTHENWARE, ceramic ware made of slightly porous opaque clay fired at low heat [n]\n",
  "EARTHFALL": "a landslide [n -S]\n",
  "EARTHFALLS": "EARTHFALL, a landslide [n]\n",
  "EARTHFAST": "fixed in the earth [adj]\n",
  "EARTHFLAX": "asbestos [n -ES]\n",
  "EARTHFLAXES": "EARTHFLAX, asbestos [n]\n",
  "EARTHIER": "EARTHY, consisting of earth [adj]\n",
  "EARTHIEST": "EARTHY, consisting of earth [adj]\n",
  "EARTHILY": "EARTHY, consisting of earth [adv]\n",
  "EARTHINESS": "the state of being earthy [n -ES]\n",
  "EARTHINESSES": "EARTHINESS, the state of being earthy [n]\n",
  "EARTHING": "EARTH, to cover with soil [v]\n",
  "EARTHLIER": "EARTHLY, of earth [adj]\n",
  "EARTHLIES": "EARTHLY, any chance on earth, as in \"haven't an earthly\" [n]\n",
  "EARTHLIEST": "EARTHLY, of earth [adj]\n",
  "EARTHLIGHT": "the faint light visible on parts of the moon not illuminated by the sun [n -S]\n",
  "EARTHLIGHTS": "EARTHLIGHT, the faint light visible on parts of the moon not illuminated by the sun [n]\n",
  "EARTHLIKE": "like the planet earth [adj]\n",
  "EARTHLINESS": "the state of being earthly [n -ES]\n",
  "EARTHLINESSES": "EARTHLINESS, the state of being earthly [n]\n",
  "EARTHLING": "an inhabitant of the earth [n -S]\n",
  "EARTHLINGS": "EARTHLING, an inhabitant of the earth [n]\n",
  "EARTHLY": "any chance on earth, as in \"haven't an earthly\" [n EARTHLIES] / of earth [adj EARTHLIER, EARTHLIEST]\n",
  "EARTHMAN": "a male inhabitant of the planet earth [n EARTHMEN]\n",
  "EARTHMEN": "EARTHMAN, a male inhabitant of the planet earth [n]\n",
  "EARTHMOVER": "any piece of machinery designed to move earth, e.g. a bulldozer [n -S]\n",
  "EARTHMOVERS": "EARTHMOVER, any piece of machinery designed to move earth, e.g. a bulldozer [n]\n",
  "EARTHMOVING": "the act of moving large quantities of earth, as with a bulldozer [n -S]\n",
  "EARTHMOVINGS": "EARTHMOVING, the act of moving large quantities of earth, as with a bulldozer [n]\n",
  "EARTHNUT": "a pignut, also EARTHPEA [n -S]\n",
  "EARTHNUTS": "EARTHNUT, a pignut, also EARTHPEA [n]\n",
  "EARTHPEA": "the peanut, also EARTHNUT [n -S]\n",
  "EARTHPEAS": "EARTHPEA, the peanut, also EARTHNUT [n]\n",
  "EARTHQUAKE": "a quaking or shaking of the earth [n -S]\n",
  "EARTHQUAKED": "shaken or destroyed by an earthquake [adj]\n",
  "EARTHQUAKES": "EARTHQUAKE, a quaking or shaking of the earth [n]\n",
  "EARTHQUAKING": "having the nature of an earthquake [adj]\n",
  "EARTHRISE": "the rising of the earth as seen from the moon [n -S]\n",
  "EARTHRISES": "EARTHRISE, the rising of the earth as seen from the moon [n]\n",
  "EARTHS": "EARTH, to cover with soil [v]\n",
  "EARTHSET": "the setting of the earth as seen from the moon [n -S]\n",
  "EARTHSETS": "EARTHSET, the setting of the earth as seen from the moon [n]\n",
  "EARTHSHAKER": "an event of great importance [n -S]\n",
  "EARTHSHAKERS": "EARTHSHAKER, an event of great importance [n]\n",
  "EARTHSHAKING": "of great importance or consequence [adj EARTHSHAKINGLY]\n",
  "EARTHSHAKINGLY": "EARTHSHAKING, of great importance or consequence [adv]\n",
  "EARTHSHATTERING": "of great importance or consequence [adj]\n",
  "EARTHSHINE": "the faint light visible on parts of the moon not illuminated by the sun [n -S]\n",
  "EARTHSHINES": "EARTHSHINE, the faint light visible on parts of the moon not illuminated by the sun [n]\n",
  "EARTHSTAR": "a fungus related to the puffballs that opens out into a starlike form [n -S]\n",
  "EARTHSTARS": "EARTHSTAR, a fungus related to the puffballs that opens out into a starlike form [n]\n",
  "EARTHWARD": "in the direction of the earth, also EARTHWARDS [adv]\n",
  "EARTHWARDS": "in the direction of the earth, also EARTHWARD [adv]\n",
  "EARTHWAX": "a natural wax used for electrical insulation [n -ES]\n",
  "EARTHWAXES": "EARTHWAX, a natural wax used for electrical insulation [n]\n",
  "EARTHWOLF": "a hyena-like African mammal, aka aardwolf [n EARTHWOLVES]\n",
  "EARTHWOLVES": "EARTHWOLF, a hyena-like African mammal, aka aardwolf [n]\n",
  "EARTHWOMAN": "a female inhabitant of the earth [n EARTHWOMEN]\n",
  "EARTHWOMEN": "EARTHWOMAN, a female inhabitant of the earth [n]\n",
  "EARTHWORK": "a fortification of earth [n -S]\n",
  "EARTHWORKS": "EARTHWORK, a fortification of earth [n]\n",
  "EARTHWORM": "the common worm [n -S]\n",
  "EARTHWORMS": "EARTHWORM, the common worm [n]\n",
  "EARTHY": "consisting of earth [adj EARTHIER, EARTHIEST, EARTHILY]\n",
  "EARWAX": "a waxy secretion of the ear [n -ES]\n",
  "EARWAXES": "EARWAX, a waxy secretion of the ear [n]\n",
  "EARWIG": "to pester with demands; to eavesdrop [v EARWIGGED, EARWIGGING, EARWIGS]\n",
  "EARWIGGED": "EARWIG, to pester with demands; to eavesdrop [v]\n",
  "EARWIGGIER": "EARWIGGY, full of earwigs [adj]\n",
  "EARWIGGIEST": "EARWIGGY, full of earwigs [adj]\n",
  "EARWIGGING": "a scolding [n -S]\n",
  "EARWIGGINGS": "EARWIGGING, a scolding [n]\n",
  "EARWIGGY": "full of earwigs [adj EARWIGGIER, EARWIGGIEST]\n",
  "EARWIGS": "EARWIG, to pester with demands; to eavesdrop [v]\n",
  "EARWITNESS": "a witness that can testify from his or her own hearing [n -ES]\n",
  "EARWITNESSES": "EARWITNESS, a witness that can testify from his or her own hearing [n]\n",
  "EARWORM": "the larva of a moth which devours the bolls or unripe pods of the cotton plant, aka bollworm [n -S]\n",
  "EARWORMS": "EARWORM, the larva of a moth which devours the bolls or unripe pods of the cotton plant, aka bollworm [n]\n",
  "EAS": "EA, (dialect) a river [n]\n",
  "EASE": "to free from pain or trouble [v EASED, EASING, EASES]\n",
  "EASED": "EASE, to free from pain or trouble [v]\n",
  "EASEFUL": "full of ease; restful [adj EASEFULLY]\n",
  "EASEFULLY": "EASEFUL, full of ease; restful [adv]\n",
  "EASEFULNESS": "the state of being easeful [n -ES]\n",
  "EASEFULNESSES": "EASEFULNESS, the state of being easeful [n]\n",
  "EASEL": "a three-legged frame [n -S]\n",
  "EASELED": "mounted on an easel [adj]\n",
  "EASELESS": "without ease [adj]\n",
  "EASELS": "EASEL, a three-legged frame [n]\n",
  "EASEMENT": "the right to use something (especially land) not one's own or to prevent its owner from making an inconvenient use of it [n -S]\n",
  "EASEMENTS": "EASEMENT, the right to use something (especially land) not one's own or to prevent its owner from making an inconvenient use of it [n]\n",
  "EASER": "one who eases [n -S]\n",
  "EASERS": "EASER, one who eases [n]\n",
  "EASES": "EASE, to free from pain or trouble [v]\n",
  "EASIED": "EASY, to stop rowing [v]\n",
  "EASIER": "EASY, not difficult [adj]\n",
  "EASIES": "EASY, to stop rowing [v]\n",
  "EASIEST": "EASY, not difficult [adj]\n",
  "EASILY": "EASY, not difficult [adv]\n",
  "EASINESS": "the state of being easy [n -ES]\n",
  "EASINESSES": "EASINESS, the state of being easy [n]\n",
  "EASING": "the act of freeing from pain or trouble [n -S]\n",
  "EASINGS": "EASING, the act of freeing from pain or trouble [n]\n",
  "EASLE": "(Scots) hot ashes, also AIZLE [n -S]\n",
  "EASLES": "EASLE, (Scots) hot ashes, also AIZLE [n]\n",
  "EASSEL": "(Scots) eastwards, easterly, also EASSELGATE, EASSELWARD, EASSIL [adj]\n",
  "EASSELGATE": "(Scots) eastwards, also EASSEL, EASSELWARD, EASSIL [adv]\n",
  "EASSELWARD": "(Scots) eastwards, also EASSEL, EASSELGATE, EASSIL [adv]\n",
  "EASSIL": "(Scots) eastwards, easterly, also EASSEL, EASSELGATE, EASSELWARD [adv]\n",
  "EAST": "to turn east (a point on the compass) [v -ED, -ING, -S]\n",
  "EASTABOUT": "towards the east [adj]\n",
  "EASTBOUND": "bound for the east; travelling east [adj]\n",
  "EASTED": "EAST, to turn east (a point on the compass) [v]\n",
  "EASTER": "one living in the east [n -S]\n",
  "EASTERLIES": "EASTERLY, a wind from the east [n]\n",
  "EASTERLING": "a native of the east; a trader from the Baltic [n -S]\n",
  "EASTERLINGS": "EASTERLING, a native of the east; a trader from the Baltic [n]\n",
  "EASTERLY": "a wind from the east [n EASTERLIES]\n",
  "EASTERMOST": "(obsolete) most easterly, also EASTERNMOST, EASTMOST [adj]\n",
  "EASTERN": "pertaining to the east [adj]\n",
  "EASTERNER": "one who lives in or comes from the east [n -S]\n",
  "EASTERNERS": "EASTERNER, one who lives in or comes from the east [n]\n",
  "EASTERNMOST": "at the furthest point east, also EASTERMOST, EASTMOST [adj]\n",
  "EASTERS": "EASTER, one living in the east [n]\n",
  "EASTING": "a movement toward the east [n -S]\n",
  "EASTINGS": "EASTING, a movement toward the east [n]\n",
  "EASTLAND": "the land in the east [n -S]\n",
  "EASTLANDS": "EASTLAND, the land in the east [n]\n",
  "EASTLIN": "(Scots) eastward, also EASTLING, EASTLINGS, EASTLINS [adj]\n",
  "EASTLING": "eastward, also EASTLIN, EASTLINGS, EASTLINS [adj]\n",
  "EASTLINGS": "(Scots) eastward, also EASTLIN, EASTLING, EASTLINS [adv]\n",
  "EASTLINS": "(Scots) eastward, also EASTLIN, EASTLING, EASTLINGS [adv]\n",
  "EASTMOST": "at the furthest point east, also EASTERMOST, EASTERNMOST [adj]\n",
  "EASTS": "EAST, to turn east (a point on the compass) [v]\n",
  "EASTWARD": "towards the east, also EASTWARDS [adj EASTWARDLY]\n",
  "EASTWARDLY": "in an eastward direction [adv]\n",
  "EASTWARDS": "towards the east, also EASTWARD [adv]\n",
  "EASY": "not difficult [adj EASIER, EASIEST] / to stop rowing [v EASIED, EASYING, EASIES]\n",
  "EASYGOING": "tolerant [adj]\n",
  "EASYGOINGNESS": "EASYGOING, tolerant [n]\n",
  "EASYGOINGNESSES": "EASYGOINGNESS, EASYGOING, tolerant [n]\n",
  "EASYING": "EASY, to stop rowing [v]\n",
  "EAT": "to consume food [v ATE or (obsolete) ET, EATEN, EATING, EATS]\n",
  "EATABLE": "anything used as food [n -S]\n",
  "EATABLES": "EATABLE, anything used as food [n]\n",
  "EATAGE": "the eatable growth of grass for horses and cattle, esp. that of aftermath [n -S]\n",
  "EATAGES": "EATAGE, the eatable growth of grass for horses and cattle, esp. that of aftermath [n]\n",
  "EATCHE": "(Scott) an adze [n -S]\n",
  "EATCHES": "EATCHE, (Scott) an adze [n]\n",
  "EATEN": "EAT, to consume food [v]\n",
  "EATER": "one who eats [n -S]\n",
  "EATERIE": "a restaurant, also EATERY [n -S]\n",
  "EATERIES": "EATERIE, a restaurant, also EATERY [n]\n",
  "EATERS": "EATER, one who eats [n]\n",
  "EATERY": "a restaurant, also EATERIE [n EATERIES]\n",
  "EATH": "(Spenser) easy, also EATHE, ETHE [adj EATHLY]\n",
  "EATHE": "(Spenser) easy, also EATH, ETHE [adj]\n",
  "EATHLY": "(Spenser) easily [adv]\n",
  "EATING": "the act of consuming food [n -S]\n",
  "EATINGS": "EATING, the act of consuming food [n]\n",
  "EATS": "EAT, to consume food [v]\n",
  "EAU": "(French) a river or water [n EAUS or EAUX]\n",
  "EAUS": "EAU, (French) a river or water [n]\n",
  "EAUX": "EAU, (French) a river or water [n]\n",
  "EAVE": "to give cover under the eaves of a building [v EAVED, EAVING, EAVES]\n",
  "EAVED": "EAVE, to give cover under the eaves of a building [v]\n",
  "EAVES": "EAVE, to give cover under the eaves of a building [v]\n",
  "EAVESDRIP": "the water that falls from the eaves of a house, also EAVESDROP [n -S]\n",
  "EAVESDRIPS": "EAVESDRIP, the water that falls from the eaves of a house, also EAVESDROP [n]\n",
  "EAVESDROP": "the water that falls from the eaves of a house [n -S] / to listen in on a private conversation, also EAVESDRIP [v EAVESDROPPED, EAVESDROPPING, EAVESDROPS]\n",
  "EAVESDROPPED": "EAVESDROP, to listen in on a private conversation, also EAVESDRIP [v]\n",
  "EAVESDROPPER": "one who eavesdrops [n -S]\n",
  "EAVESDROPPERS": "EAVESDROPPER, one who eavesdrops [n]\n",
  "EAVESDROPPING": "the act of listening in on a private conversation [n -S]\n",
  "EAVESDROPPINGS": "EAVESDROPPING, the act of listening in on a private conversation [n]\n",
  "EAVESDROPS": "EAVESDROP, the water that falls from the eaves of a house [n]\n",
  "EAVESTROUGH": "(Canadian) a gutter at the eaves of a building [n -S]\n",
  "EAVESTROUGHS": "EAVESTROUGH, (Canadian) a gutter at the eaves of a building [n]\n",
  "EAVING": "EAVE, to give cover under the eaves of a building [v]\n",
  "EBAUCHE": "(French) a rough draught or sketch [n -S]\n",
  "EBAUCHES": "EBAUCHE, (French) a rough draught or sketch [n]\n",
  "EBAYER": "someone who trades on eBay [n -S]\n",
  "EBAYERS": "EBAYER, someone who trades on eBay [n]\n",
  "EBAYING": "selling on eBay [n -S]\n",
  "EBAYINGS": "EBAYING, selling on eBay [n]\n",
  "EBB": "to move back from the land, to recede [v -ED, -ING, -S]\n",
  "EBBED": "EBB, to move back from the land, to recede [v]\n",
  "EBBET": "a common green newt [n -S]\n",
  "EBBETS": "EBBET, a common green newt [n]\n",
  "EBBING": "EBB, to move back from the land, to recede [v]\n",
  "EBBLESS": "without ebb [adj]\n",
  "EBBS": "EBB, to move back from the land, to recede [v]\n",
  "EBENEZER": "(Hebrew) a chapel or religious meeting place [n -S]\n",
  "EBENEZERS": "EBENEZER, (Hebrew) a chapel or religious meeting place [n]\n",
  "EBENISTE": "(French) a cabinetmaker [n -S]\n",
  "EBENISTES": "EBENISTE, (French) a cabinetmaker [n]\n",
  "EBIONISE": "to follow the sect of ebionism, also EBIONIZE [v EBIONISED, EBIONISING, EBIONISES]\n",
  "EBIONISED": "EBIONISE, to follow the sect of ebionism, also EBIONIZE [v]\n",
  "EBIONISES": "EBIONISE, to follow the sect of ebionism, also EBIONIZE [v]\n",
  "EBIONISING": "EBIONISE, to follow the sect of ebionism, also EBIONIZE [v]\n",
  "EBIONISM": "an early Christian sect which honoured Mosaic law [n -S]\n",
  "EBIONISMS": "EBIONISM, an early Christian sect which honoured Mosaic law [n]\n",
  "EBIONITIC": "relating to ebionism, an early Christian sect which honoured Mosaic law [adj]\n",
  "EBIONITISM": "the system or doctrine of the Ebionites [n -S]\n",
  "EBIONITISMS": "EBIONITISM, the system or doctrine of the Ebionites [n]\n",
  "EBIONIZE": "to follow the sect of ebionism, also EBIONISE [v EBIONIZED, EBIONIZING, EBIONIZES]\n",
  "EBIONIZED": "EBIONIZE, to follow the sect of ebionism, also EBIONISE [v]\n",
  "EBIONIZES": "EBIONIZE, to follow the sect of ebionism, also EBIONISE [v]\n",
  "EBIONIZING": "EBIONIZE, to follow the sect of ebionism, also EBIONISE [v]\n",
  "EBON": "a hard wood like stone, also EBONY, HEBEN [n -S]\n",
  "EBONICS": "American black slang as an object of academic study [n]\n",
  "EBONIES": "EBONY, a dark heavy tropical wood, also EBON, HEBEN [n]\n",
  "EBONISE": "to stain black in imitation of ebony, also EBONIZE [v EBONISED, EBONISING, EBONISES]\n",
  "EBONISED": "EBONISE, to stain black in imitation of ebony, also EBONIZE [v]\n",
  "EBONISES": "EBONISE, to stain black in imitation of ebony, also EBONIZE [v]\n",
  "EBONISING": "EBONISE, to stain black in imitation of ebony, also EBONIZE [v]\n",
  "EBONIST": "an ebony worker [n -S]\n",
  "EBONISTS": "EBONIST, an ebony worker [n]\n",
  "EBONITE": "a kind of black vulcanized rubber [n -S]\n",
  "EBONITES": "EBONITE, a kind of black vulcanized rubber [n]\n",
  "EBONIZE": "to stain black in imitation of ebony, also EBONISE [v EBONIZED, EBONIZING, EBONIZES]\n",
  "EBONIZED": "EBONIZE, to stain black in imitation of ebony, also EBONISE [v]\n",
  "EBONIZES": "EBONIZE, to stain black in imitation of ebony, also EBONISE [v]\n",
  "EBONIZING": "EBONIZE, to stain black in imitation of ebony, also EBONISE [v]\n",
  "EBONS": "EBON, a hard wood like stone, also EBONY, HEBEN [n]\n",
  "EBONY": "a dark heavy tropical wood, also EBON, HEBEN [n EBONIES]\n",
  "EBOOK": "a book in electronic form [n -S]\n",
  "EBOOKS": "EBOOK, a book in electronic form [n]\n",
  "EBOULEMENT": "(French) the falling in of the wall of a fortification; a landslip [n -S]\n",
  "EBOULEMENTS": "EBOULEMENT, (French) the falling in of the wall of a fortification; a landslip [n]\n",
  "EBRACTEATE": "without bracts [adj]\n",
  "EBRACTEOLATE": "without bracteoles [adj]\n",
  "EBRIATE": "intoxicated, also EBRIATED, EBRIOSE [adj]\n",
  "EBRIATED": "intoxicated, also EBRIATE, EBRIOSE [adj]\n",
  "EBRIETIES": "EBRIETY, drunkenness [n]\n",
  "EBRIETY": "drunkenness [n EBRIETIES]\n",
  "EBRILLADE": "(French) a bridle check; a jerk of one rein, given to a horse when he refuses to turn [n -S]\n",
  "EBRILLADES": "EBRILLADE, (French) a bridle check; a jerk of one rein, given to a horse when he refuses to turn [n]\n",
  "EBRIOSE": "intoxicated, also EBRIATE, EBRIATED [adj]\n",
  "EBRIOSITIES": "EBRIOSITY, addiction to drink; habitual drunkenness [n]\n",
  "EBRIOSITY": "addiction to drink; habitual drunkenness [n EBRIOSITIES]\n",
  "EBULLIENCE": "the quality of lively or enthusiastic expression of thoughts or feelings, also EBULLIENCY [n -S]\n",
  "EBULLIENCES": "EBULLIENCE, the quality of lively or enthusiastic expression of thoughts or feelings, also EBULLIENCY [n]\n",
  "EBULLIENCIES": "EBULLIENCY, the quality of lively or enthusiastic expression of thoughts or feelings, also EBULLIENCE [n]\n",
  "EBULLIENCY": "the quality of lively or enthusiastic expression of thoughts or feelings, also EBULLIENCE [n EBULLIENCIES]\n",
  "EBULLIENT": "bubbling with enthusiasm or excitement [adj EBULLIENTLY]\n",
  "EBULLIENTLY": "EBULLIENT, bubbling with enthusiasm or excitement [adv]\n",
  "EBULLIOMETER": "a device used to determine the boiling point of a solution [n -S]\n",
  "EBULLIOMETERS": "EBULLIOMETER, a device used to determine the boiling point of a solution [n]\n",
  "EBULLIOMETRIES": "EBULLIOMETRY, the measurement of the boiling point of a solution [n]\n",
  "EBULLIOMETRY": "the measurement of the boiling point of a solution [n EBULLIOMETRIES]\n",
  "EBULLIOSCOPE": "an instrument for measuring the boiling point of liquids [n -S]\n",
  "EBULLIOSCOPES": "EBULLIOSCOPE, an instrument for measuring the boiling point of liquids [n]\n",
  "EBULLIOSCOPIC": "relating to measurement by ebullioscope [adj]\n",
  "EBULLIOSCOPICAL": "relating to an ebullioscope, an instrument for measuring the boiling point of liquids, also EBULLIOSCOPIC [adj]\n",
  "EBULLIOSCOPIES": "EBULLIOSCOPY, measurement by use of an ebullioscope [n]\n",
  "EBULLIOSCOPY": "measurement by use of an ebullioscope [n EBULLIOSCOPIES]\n",
  "EBULLITION": "the act, process or state of boiling or bubbling up; a sudden violent outburst or display [n -S]\n",
  "EBULLITIONS": "EBULLITION, the act, process or state of boiling or bubbling up; a sudden violent outburst or display [n]\n",
  "EBURNATION": "an abnormal change of bone by which it becomes very hard and dense [n -S]\n",
  "EBURNATIONS": "EBURNATION, an abnormal change of bone by which it becomes very hard and dense [n]\n",
  "EBURNEAN": "of or like ivory, also EBURNEOUS [adj]\n",
  "EBURNEOUS": "of or like ivory, also EBURNEAN [adj]\n",
  "EBURNIFICATION": "the art of making like ivory [n -S]\n",
  "EBURNIFICATIONS": "EBURNIFICATION, the art of making like ivory [n]\n",
  "ECAD": "a plant which has supposedly adapted to its environment [n -S]\n",
  "ECADS": "ECAD, a plant which has supposedly adapted to its environment [n]\n",
  "ECARDINATE": "without hinges [adj]\n",
  "ECARINATE": "without a keel [adj]\n",
  "ECARTE": "(French) a card game [n -S]\n",
  "ECARTES": "ECARTE, (French) a card game [n]\n",
  "ECAUDATE": "tailless, also ACAUDAL, ACAUDATE [adj]\n",
  "ECBLASTESES": "ECBLASTESIS, proliferation of a floral axis [n]\n",
  "ECBLASTESIS": "proliferation of a floral axis [n ECBLASTESES]\n",
  "ECBOLE": "a rhetorical digression [n -S]\n",
  "ECBOLES": "ECBOLE, a rhetorical digression [n]\n",
  "ECBOLIC": "a drug used to assist childbirth [n -S]\n",
  "ECBOLICS": "ECBOLIC, a drug used to assist childbirth [n]\n",
  "ECCALEOBION": "(historical) a kind of incubator [n -S]\n",
  "ECCALEOBIONS": "ECCALEOBION, (historical) a kind of incubator [n]\n",
  "ECCE": "(Italian) behold, also ECCO [interj]\n",
  "ECCENTRIC": "odd or unconventional, also ECCENTRICAL [adj ECCENTRICALLY] / one who is odd or unconventional [n -S]\n",
  "ECCENTRICAL": "(archaic) eccentric, also ECCENTRIC [adj ECCENTRICALLY]\n",
  "ECCENTRICALLY": "ECCENTRICAL, (archaic) eccentric, also ECCENTRIC [adv]\n",
  "ECCENTRICITIES": "ECCENTRICITY, the state of being eccentric [n]\n",
  "ECCENTRICITY": "the state of being eccentric [n ECCENTRICITIES]\n",
  "ECCENTRICS": "ECCENTRIC, one who is odd or unconventional [n]\n",
  "ECCHYMOSED": "affected by ecchymosis [adj]\n",
  "ECCHYMOSES": "ECCHYMOSIS, discoloration of the skin due to effusion of blood into tissue [n]\n",
  "ECCHYMOSIS": "discoloration of the skin due to effusion of blood into tissue [n ECCHYMOSES]\n",
  "ECCHYMOTIC": "pertaining to ecchymosis [adj]\n",
  "ECCLESIA": "(Latin) the public legislative assembly of the Athenians [n ECCLESIAE]\n",
  "ECCLESIAE": "ECCLESIA, (Latin) the public legislative assembly of the Athenians [n]\n",
  "ECCLESIAL": "ecclesiastical [adj]\n",
  "ECCLESIARCH": "(archaic) a church ruler [n -S]\n",
  "ECCLESIARCHS": "ECCLESIARCH, (archaic) a church ruler [n]\n",
  "ECCLESIAST": "an ecclesiastic [n -S]\n",
  "ECCLESIASTIC": "relating to the church or to the clergy [adj] / a person consecrated to the church, such as a priest or a clergyman [n -S]\n",
  "ECCLESIASTICAL": "of or relating to a church esp. as an established institution, also ECCLESIASTIC [adj]\n",
  "ECCLESIASTICISM": "excessive attachment to ecclesiastical forms and practices [n]\n",
  "ECCLESIASTICS": "ECCLESIASTIC, a person consecrated to the church, such as a priest or a clergyman [n]\n",
  "ECCLESIASTS": "ECCLESIAST, an ecclesiastic [n]\n",
  "ECCLESIOLATER": "one with excessive reverence for ecclesiastical traditions [n -S]\n",
  "ECCLESIOLATERS": "ECCLESIOLATER, one with excessive reverence for ecclesiastical traditions [n]\n",
  "ECCLESIOLATRIES": "ECCLESIOLATRY, excessive devotion to church tradition and form [n]\n",
  "ECCLESIOLATRY": "excessive devotion to church tradition and form [n ECCLESIOLATRIES]\n",
  "ECCLESIOLOGICAL": "relating to ecclesiology [adj]\n",
  "ECCLESIOLOGIES": "ECCLESIOLOGY, the study of church ornamentation and architecture [n]\n",
  "ECCLESIOLOGIST": "one who studies ecclesiology [n -S]\n",
  "ECCLESIOLOGISTS": "ECCLESIOLOGIST, one who studies ecclesiology [n]\n",
  "ECCLESIOLOGY": "the study of church ornamentation and architecture [n ECCLESIOLOGIES]\n",
  "ECCO": "(Italian) behold, also ECCE [interj]\n",
  "ECCOPROTIC": "a laxative [n -S]\n",
  "ECCOPROTICS": "ECCOPROTIC, a laxative [n]\n",
  "ECCREMOCARPUS": "an evergreen climbing plant, grown for its decorative pinnate foliage and bright orange-red bell flowers [n -ES]\n",
  "ECCREMOCARPUSES": "ECCREMOCARPUS, an evergreen climbing plant, grown for its decorative pinnate foliage and bright orange-red bell flowers [n]\n",
  "ECCRINE": "of a gland, e.g. a sweat gland, secreting externally [adj]\n",
  "ECCRINOLOGIES": "ECCRINOLOGY, the branch of physiology relating to the secretions of the eccrine glands [n]\n",
  "ECCRINOLOGY": "the branch of physiology relating to the secretions of the eccrine glands [n ECCRINOLOGIES]\n",
  "ECCRISES": "ECCRISIS, expulsion of waste [n]\n",
  "ECCRISIS": "expulsion of waste [n ECCRISES]\n",
  "ECCRITIC": "a remedy which promotes discharges, as an emetic, or a cathartic [n -S]\n",
  "ECCRITICS": "ECCRITIC, a remedy which promotes discharges, as an emetic, or a cathartic [n]\n",
  "ECDEMIC": "foreign, the opposite of endemic [adj]\n",
  "ECDYSES": "ECDYSIS, (Greek) the act of molting or shedding an outer cuticular layer (as in insects and crustaceans) [n]\n",
  "ECDYSIAL": "relating to ecdysis, the act of shedding, or casting off [adj]\n",
  "ECDYSIAST": "a striptease performer [n -S]\n",
  "ECDYSIASTS": "ECDYSIAST, a striptease performer [n]\n",
  "ECDYSIS": "(Greek) the act of molting or shedding an outer cuticular layer (as in insects and crustaceans) [n ECDYSES or ECDYSISES]\n",
  "ECDYSISES": "ECDYSIS, (Greek) the act of molting or shedding an outer cuticular layer (as in insects and crustaceans) [n]\n",
  "ECDYSON": "an insect hormone, also ECDYSONE [n -S]\n",
  "ECDYSONE": "an insect hormone, also ECDYSON [n -S]\n",
  "ECDYSONES": "ECDYSONE, an insect hormone, also ECDYSON [n]\n",
  "ECDYSONS": "ECDYSON, an insect hormone, also ECDYSONE [n]\n",
  "ECESIC": "relating to ecesis, the establishment of a plant or animal in a new habitat [adj]\n",
  "ECESIS": "the establishment of a plant or animal in a new environment [n -ES]\n",
  "ECESISES": "ECESIS, the establishment of a plant or animal in a new environment [n]\n",
  "ECH": "(Shakespeare) to eke, also ECHE, EECH, EIK, EKE, ICH [v -ED, -ING, -ES]\n",
  "ECHAPPE": "(French) a kind of leap in ballet [n -S]\n",
  "ECHAPPES": "ECHAPPE, (French) a kind of leap in ballet [n]\n",
  "ECHARD": "the total quantity of water in the soil not available to plants [n -S]\n",
  "ECHARDS": "ECHARD, the total quantity of water in the soil not available to plants [n]\n",
  "ECHE": "(obsolete) to eke, also ECH, EECH, EIK, EKE, ICH [v ECHED, ECHING, ECHES]\n",
  "ECHED": "ECHE, (obsolete) to eke, also ECH, EECH, EIK, EKE, ICH [v]\n",
  "ECHELLE": "(French) an arrangement of ribbons in the form of a ladder, decorating the front of the stomacher of a dress, etc. [n -S]\n",
  "ECHELLES": "ECHELLE, (French) an arrangement of ribbons in the form of a ladder, decorating the front of the stomacher of a dress, etc. [n]\n",
  "ECHELON": "to arrange in a steplike formation [v -ED, -ING, -S]\n",
  "ECHELONED": "ECHELON, to arrange in a steplike formation [v]\n",
  "ECHELONING": "ECHELON, to arrange in a steplike formation [v]\n",
  "ECHELONS": "ECHELON, to arrange in a steplike formation [v]\n",
  "ECHES": "ECHE, (obsolete) to eke, also ECH, EECH, EIK, EKE, ICH [v]\n",
  "ECHEVERIA": "a kind of succulent plant [n -S]\n",
  "ECHEVERIAS": "ECHEVERIA, a kind of succulent plant [n]\n",
  "ECHIDNA": "the spiny anteater [n ECHIDNAS or ECHIDNAE]\n",
  "ECHIDNAE": "ECHIDNA, the spiny anteater [n]\n",
  "ECHIDNAS": "ECHIDNA, the spiny anteater [n]\n",
  "ECHIDNINE": "snake-poison [n -S]\n",
  "ECHIDNINES": "ECHIDNINE, snake-poison [n]\n",
  "ECHINACEA": "a plant of the genus Echinaceae [n -S]\n",
  "ECHINACEAS": "ECHINACEA, a plant of the genus Echinaceae [n]\n",
  "ECHINATE": "prickly like a hedgehog, bristly, also ECHINATED [adj]\n",
  "ECHINATED": "prickly like a hedgehog, bristly, also ECHINATE [adj]\n",
  "ECHING": "ECHE, (obsolete) to eke, also ECH, EECH, EIK, EKE, ICH [v]\n",
  "ECHINI": "ECHINUS, (Latin) a sea urchin, also ECHINOID [n]\n",
  "ECHINOCOCCI": "ECHINOCOCCUS, a parasitic tapeworm [n]\n",
  "ECHINOCOCCOSES": "ECHINOCOCCOSIS, infestation with or disease caused by an echinococcus [n]\n",
  "ECHINOCOCCOSIS": "infestation with or disease caused by an echinococcus [n ECHINOCOCCOSES]\n",
  "ECHINOCOCCUS": "a parasitic tapeworm [n ECHINOCOCCI]\n",
  "ECHINODERM": "one of the Echinodermata, starfishes, sand dollars, sea urchins, and sea cucumbers [n -S]\n",
  "ECHINODERMAL": "of or like an echinoderm [adj]\n",
  "ECHINODERMATOUS": "of or like an echinoderm [adj]\n",
  "ECHINODERMS": "ECHINODERM, one of the Echinodermata, starfishes, sand dollars, sea urchins, and sea cucumbers [n]\n",
  "ECHINOID": "a sea urchin, also ECHINUS [n -S]\n",
  "ECHINOIDS": "ECHINOID, a sea urchin, also ECHINUS [n]\n",
  "ECHINUS": "(Latin) a sea urchin, also ECHINOID [n ECHINUSES or ECHINI]\n",
  "ECHINUSES": "ECHINUS, (Latin) a sea urchin, also ECHINOID [n]\n",
  "ECHIUM": "any plant of a genus that includes viper's bugloss [n -S]\n",
  "ECHIUMS": "ECHIUM, any plant of a genus that includes viper's bugloss [n]\n",
  "ECHIURAN": "one of the Echiura, a phylum of marine invertebrates, aka spoonworms [n -S]\n",
  "ECHIURANS": "ECHIURAN, one of the Echiura, a phylum of marine invertebrates, aka spoonworms [n]\n",
  "ECHIUROID": "any of a taxon of marine worms [n -S]\n",
  "ECHIUROIDS": "ECHIUROID, any of a taxon of marine worms [n]\n",
  "ECHO": "a reflected sound [n ECHOES or ECHOS] / to repeat a sound [v -ED, -ING, -ES]\n",
  "ECHOCARDIOGRAM": "a visual record made by echocardiography [n -S]\n",
  "ECHOCARDIOGRAMS": "ECHOCARDIOGRAM, a visual record made by echocardiography [n]\n",
  "ECHOED": "ECHO, to repeat a sound [v]\n",
  "ECHOER": "one that echoes [n -S]\n",
  "ECHOERS": "ECHOER, one that echoes [n]\n",
  "ECHOES": "ECHO, a reflected sound [n]\n",
  "ECHOEY": "full of echos [adj ECHOIER, ECHOIEST]\n",
  "ECHOGRAM": "a record produced by a device that uses ultrasonic waves [n -S]\n",
  "ECHOGRAMS": "ECHOGRAM, a record produced by a device that uses ultrasonic waves [n]\n",
  "ECHOGRAPH": "an echo-sounder, used to measure the depth of water [n -S]\n",
  "ECHOGRAPHIES": "ECHOGRAPHY, medical examination of the internal structures of the body by means of ultrasound [n]\n",
  "ECHOGRAPHS": "ECHOGRAPH, an echo-sounder, used to measure the depth of water [n]\n",
  "ECHOGRAPHY": "medical examination of the internal structures of the body by means of ultrasound [n ECHOGRAPHIES]\n",
  "ECHOIC": "resembling an echo [adj ECHOICALLY]\n",
  "ECHOICALLY": "ECHOIC, resembling an echo [adv]\n",
  "ECHOIER": "ECHOEY, full of echos [adj]\n",
  "ECHOIEST": "ECHOEY, full of echos [adj]\n",
  "ECHOING": "ECHO, to repeat a sound [v]\n",
  "ECHOISE": "to repeat another person's words, also ECHOIZE [v ECHOISED, ECHOISING, ECHOISES]\n",
  "ECHOISED": "ECHOISE, to repeat another person's words, also ECHOIZE [v]\n",
  "ECHOISES": "ECHOISE, to repeat another person's words, also ECHOIZE [v]\n",
  "ECHOISING": "ECHOISE, to repeat another person's words, also ECHOIZE [v]\n",
  "ECHOISM": "the formation of repeated words [n -S]\n",
  "ECHOISMS": "ECHOISM, the formation of repeated words [n]\n",
  "ECHOIST": "a person who repeats another person's words [n -S]\n",
  "ECHOISTS": "ECHOIST, a person who repeats another person's words [n]\n",
  "ECHOIZE": "to repeat another person's words, also ECHOISE [v ECHOIZED, ECHOIZING, ECHOIZES]\n",
  "ECHOIZED": "ECHOIZE, to repeat another person's words, also ECHOISE [v]\n",
  "ECHOIZES": "ECHOIZE, to repeat another person's words, also ECHOISE [v]\n",
  "ECHOIZING": "ECHOIZE, to repeat another person's words, also ECHOISE [v]\n",
  "ECHOLALIA": "the often pathological repetition of what is said by other people as if echoing them [n -S]\n",
  "ECHOLALIAS": "ECHOLALIA, the often pathological repetition of what is said by other people as if echoing them [n]\n",
  "ECHOLALIC": "of or like echolalia, the often pathological repetition of what is said by other people as if echoing them [adj]\n",
  "ECHOLESS": "without an echo [adj]\n",
  "ECHOLOCATION": "determining the position of objects by means of supersonic vibrations echoed from them, as a bat does [n -S]\n",
  "ECHOLOCATIONS": "ECHOLOCATION, determining the position of objects by means of supersonic vibrations echoed from them, as a bat does [n]\n",
  "ECHOPRAXES": "ECHOPRAXIS, in mental illness, echo-like repetition of another's actions, also ECHOPRAXIA [n]\n",
  "ECHOPRAXIA": "in mental illness, echo-like repetition of another's actions, also ECHOPRAXIS [n -S]\n",
  "ECHOPRAXIAS": "ECHOPRAXIA, in mental illness, echo-like repetition of another's actions, also ECHOPRAXIS [n]\n",
  "ECHOPRAXIS": "in mental illness, echo-like repetition of another's actions, also ECHOPRAXIA [n ECHOPRAXES]\n",
  "ECHOS": "ECHO, a reflected sound [n]\n",
  "ECHOVIRUS": "any of a group of viruses that cause respiratory or intestinal diseases [n -ES]\n",
  "ECHOVIRUSES": "ECHOVIRUS, any of a group of viruses that cause respiratory or intestinal diseases [n]\n",
  "ECHT": "(German) genuine, authentic [adj]\n",
  "ECLAIR": "a cake with cream filling and usually chocolate icing [n -S]\n",
  "ECLAIRCISSEMENT": "(French) clarification, enlightenment [n]\n",
  "ECLAIRS": "ECLAIR, a cake with cream filling and usually chocolate icing [n]\n",
  "ECLAMPSIA": "a fancied perception of flashes of light, a symptom of epilepsy; hence, epilepsy itself, also ECLAMPSY [n -S]\n",
  "ECLAMPSIAS": "ECLAMPSIA, a fancied perception of flashes of light, a symptom of epilepsy; hence, epilepsy itself, also ECLAMPSY [n]\n",
  "ECLAMPSIES": "ECLAMPSY, a fancied perception of flashes of light, a symptom of epilepsy; hence, epilepsy itself; convulsions, also ECLAMPSIA [n]\n",
  "ECLAMPSY": "a fancied perception of flashes of light, a symptom of epilepsy; hence, epilepsy itself; convulsions, also ECLAMPSIA [n ECLAMPSIES]\n",
  "ECLAMPTIC": "relating to eclampsia, a symptom of epilepsy [adj]\n",
  "ECLAT": "(French) great brilliance, acclamation; conspicuous success [n -S]\n",
  "ECLATS": "ECLAT, (French) great brilliance, acclamation; conspicuous success [n]\n",
  "ECLECTIC": "selecting and employing individual elements from a variety of sources, systems, or styles [adj ECLECTICALLY] / an eclectic person [n -S]\n",
  "ECLECTICALLY": "ECLECTIC, selecting and employing individual elements from a variety of sources, systems, or styles [adv]\n",
  "ECLECTICISM": "being eclectic [n -S]\n",
  "ECLECTICISMS": "ECLECTICISM, being eclectic [n]\n",
  "ECLECTICS": "ECLECTIC, an eclectic person [n]\n",
  "ECLIPSE": "to obscure [v ECLIPSED, ECLIPSING, ECLIPSES]\n",
  "ECLIPSED": "ECLIPSE, to obscure [v]\n",
  "ECLIPSER": "one that eclipses [n -S]\n",
  "ECLIPSERS": "ECLIPSER, one that eclipses [n]\n",
  "ECLIPSES": "ECLIPSIS, a figure of syntax [n]\n",
  "ECLIPSING": "ECLIPSE, to obscure [v]\n",
  "ECLIPSIS": "a figure of syntax [n ECLIPSISES or ECLIPSES]\n",
  "ECLIPSISES": "ECLIPSIS, a figure of syntax [n]\n",
  "ECLIPTIC": "relating to the ecliptic [adj ECLIPTICALLY] / an imaginary circle which the sun follows from Earth perspective [n -S]\n",
  "ECLIPTICALLY": "ECLIPTIC, relating to the ecliptic [adv]\n",
  "ECLIPTICS": "ECLIPTIC, an imaginary circle which the sun follows from Earth perspective [n]\n",
  "ECLOGITE": "a crystalline rock containing red garnet, also EKLOGITE [n -S]\n",
  "ECLOGITES": "ECLOGITE, a crystalline rock containing red garnet, also EKLOGITE [n]\n",
  "ECLOGUE": "a pastoral poem, often in the form of a dialogue between shepherds, also AEGLOGUE [n -S]\n",
  "ECLOGUES": "ECLOGUE, a pastoral poem, often in the form of a dialogue between shepherds, also AEGLOGUE [n]\n",
  "ECLOSE": "to emerge from a pupal case [v ECLOSED, ECLOSING, ECLOSES]\n",
  "ECLOSED": "ECLOSE, to emerge from a pupal case [v]\n",
  "ECLOSES": "ECLOSE, to emerge from a pupal case [v]\n",
  "ECLOSING": "ECLOSE, to emerge from a pupal case [v]\n",
  "ECLOSION": "the emergence of insect from pupa [n -S]\n",
  "ECLOSIONS": "ECLOSION, the emergence of insect from pupa [n]\n",
  "ECO": "(short for) ecology [n -S]\n",
  "ECOCATASTROPHE": "a major destructive upset in the balance of nature esp. when caused by the action of humans [n -S]\n",
  "ECOCATASTROPHES": "ECOCATASTROPHE, a major destructive upset in the balance of nature esp. when caused by the action of humans [n]\n",
  "ECOCENTRIC": "having a serious concern for environmental issues [adj]\n",
  "ECOCIDAL": "relating to ecocide, destruction of the environment [adj]\n",
  "ECOCIDE": "the destruction of the environment [n -S]\n",
  "ECOCIDES": "ECOCIDE, the destruction of the environment [n]\n",
  "ECOCLIMATE": "a local climate regarded as an ecological factor [n -S]\n",
  "ECOCLIMATES": "ECOCLIMATE, a local climate regarded as an ecological factor [n]\n",
  "ECOD": "(archaic) a mild oath, also EGAD, EGADS, IGAD [interj]\n",
  "ECOFEMINISM": "a movement or theory that applies feminist principles and ideas to ecological issues [n -S]\n",
  "ECOFEMINISMS": "ECOFEMINISM, a movement or theory that applies feminist principles and ideas to ecological issues [n]\n",
  "ECOFEMINIST": "an adherent of ecofeminism [n -S]\n",
  "ECOFEMINISTS": "ECOFEMINIST, an adherent of ecofeminism [n]\n",
  "ECOFREAK": "a zealous environmentalist [n -S]\n",
  "ECOFREAKS": "ECOFREAK, a zealous environmentalist [n]\n",
  "ECOFRIENDLIER": "ECOFRIENDLY, respectful of the environment [adj]\n",
  "ECOFRIENDLIEST": "ECOFRIENDLY, respectful of the environment [adj]\n",
  "ECOFRIENDLY": "respectful of the environment [adj ECOFRIENDLIER, ECOFRIENDLIEST]\n",
  "ECOGIFT": "a donation of land to the government for ecological purposes [n -S]\n",
  "ECOGIFTS": "ECOGIFT, a donation of land to the government for ecological purposes [n]\n",
  "ECOLODGE": "a tourist accommodation facility designed to have minimal impact on the environment, often constructed as part of an environmental project [n -S]\n",
  "ECOLODGES": "ECOLODGE, a tourist accommodation facility designed to have minimal impact on the environment, often constructed as part of an environmental project [n]\n",
  "ECOLOGIC": "relating to ecology, also ECOLOGICAL, OECOLOGIC, OECOLOGICAL [adj ECOLOGICALLY]\n",
  "ECOLOGICAL": "relating to ecology, also ECOLOGIC, OECOLOGIC, OECOLOGICAL [adj ECOLOGICALLY]\n",
  "ECOLOGICALLY": "ECOLOGICAL, relating to ecology, also ECOLOGIC, OECOLOGIC, OECOLOGICAL [adv]\n",
  "ECOLOGIES": "ECOLOGY, the study of the interrelationships between life forms and their environment, also OECOLOGY [n]\n",
  "ECOLOGIST": "a student of ecology, also OECOLOGIST [n -S]\n",
  "ECOLOGISTS": "ECOLOGIST, a student of ecology, also OECOLOGIST [n]\n",
  "ECOLOGY": "the study of the interrelationships between life forms and their environment, also OECOLOGY [n ECOLOGIES]\n",
  "ECOMAP": "a diagrammatic representation of a person's or family's interactions with other individuals and groups in the community [n -S]\n",
  "ECOMAPS": "ECOMAP, a diagrammatic representation of a person's or family's interactions with other individuals and groups in the community [n]\n",
  "ECOMMERCE": "business conducted on the internet [n -S]\n",
  "ECOMMERCES": "ECOMMERCE, business conducted on the internet [n]\n",
  "ECOMOVEMENT": "an organized movement to deal with environmental issues, reduce emissions, etc. [n -S]\n",
  "ECOMOVEMENTS": "ECOMOVEMENT, an organized movement to deal with environmental issues, reduce emissions, etc. [n]\n",
  "ECOMUSEUM": "a type of interdisciplinary museum presenting the history and heritage of a region [n -S]\n",
  "ECOMUSEUMS": "ECOMUSEUM, a type of interdisciplinary museum presenting the history and heritage of a region [n]\n",
  "ECONOBOX": "a small economical car [n -ES]\n",
  "ECONOBOXES": "ECONOBOX, a small economical car [n]\n",
  "ECONOMETER": "a device in a car that informs the driver of how much fuel they are consuming [n -S]\n",
  "ECONOMETERS": "ECONOMETER, a device in a car that informs the driver of how much fuel they are consuming [n]\n",
  "ECONOMETRIC": "relating to the measurement of the economy, also ECONOMETRICAL [adj ECONOMETRICALLY]\n",
  "ECONOMETRICAL": "relating to econometrics [adj ECONOMETRICALLY]\n",
  "ECONOMETRICALLY": "ECONOMETRICAL, relating to econometrics [adv]\n",
  "ECONOMETRICIAN": "one who studies econometrics [n -S]\n",
  "ECONOMETRICIANS": "ECONOMETRICIAN, one who studies econometrics [n]\n",
  "ECONOMETRICS": "the science of the measurement of the economy [n]\n",
  "ECONOMETRIST": "a student of econometrics [n -S]\n",
  "ECONOMETRISTS": "ECONOMETRIST, a student of econometrics [n]\n",
  "ECONOMIC": "relating to finance [adj ECONOMICALLY]\n",
  "ECONOMICAL": "marked by careful, efficient, and prudent use of resources [adj ECONOMICALLY]\n",
  "ECONOMICALLY": "ECONOMICAL, marked by careful, efficient, and prudent use of resources [adv]\n",
  "ECONOMICS": "the study of financial matters [n]\n",
  "ECONOMIES": "ECONOMY, thrift [n]\n",
  "ECONOMISATION": "the process of economising, also ECONOMIZATION [n -S]\n",
  "ECONOMISATIONS": "ECONOMISATION, the process of economising, also ECONOMIZATION [n]\n",
  "ECONOMISE": "to make economies, also ECONOMIZE [v ECONOMISED, ECONOMISING, ECONOMISES]\n",
  "ECONOMISED": "ECONOMISE, to make economies, also ECONOMIZE [v]\n",
  "ECONOMISER": "one who economises, also ECONOMIZER [n -S]\n",
  "ECONOMISERS": "ECONOMISER, one who economises, also ECONOMIZER [n]\n",
  "ECONOMISES": "ECONOMISE, to make economies, also ECONOMIZE [v]\n",
  "ECONOMISING": "ECONOMISE, to make economies, also ECONOMIZE [v]\n",
  "ECONOMISM": "a belief that economic causes are of primary importance [n -S]\n",
  "ECONOMISMS": "ECONOMISM, a belief that economic causes are of primary importance [n]\n",
  "ECONOMIST": "a student of economics [n -S]\n",
  "ECONOMISTIC": "relating to economists [adj]\n",
  "ECONOMISTS": "ECONOMIST, a student of economics [n]\n",
  "ECONOMIZATION": "the process of economizing, also ECONOMISATION [n -S]\n",
  "ECONOMIZATIONS": "ECONOMIZATION, the process of economizing, also ECONOMISATION [n]\n",
  "ECONOMIZE": "to make economies, also ECONOMISE [v ECONOMIZED, ECONOMIZING, ECONOMIZES]\n",
  "ECONOMIZED": "ECONOMIZE, to make economies, also ECONOMISE [v]\n",
  "ECONOMIZER": "one who economizes, also ECONOMISER [n -S]\n",
  "ECONOMIZERS": "ECONOMIZER, one who economizes, also ECONOMISER [n]\n",
  "ECONOMIZES": "ECONOMIZE, to make economies, also ECONOMISE [v]\n",
  "ECONOMIZING": "ECONOMIZE, to make economies, also ECONOMISE [v]\n",
  "ECONOMY": "thrift [n ECONOMIES]\n",
  "ECONUT": "one concerned for the environment [n -S]\n",
  "ECONUTS": "ECONUT, one concerned for the environment [n]\n",
  "ECOPHOBIA": "fear of one's home surroundings [n -S]\n",
  "ECOPHOBIAS": "ECOPHOBIA, fear of one's home surroundings [n]\n",
  "ECOPHYSIOLOGIES": "ECOPHYSIOLOGY, the science of the interrelationships between the physiology of organisms and their environment [n]\n",
  "ECOPHYSIOLOGY": "the science of the interrelationships between the physiology of organisms and their environment [n ECOPHYSIOLOGIES]\n",
  "ECORCHE": "(French) a manikin, or image, representing an animal, esp. man, with the skin removed so that the muscles are exposed for purposes of study [n -S]\n",
  "ECORCHES": "ECORCHE, (French) a manikin, or image, representing an animal, esp. man, with the skin removed so that the muscles are exposed for purposes of study [n]\n",
  "ECOREGION": "an area defined by its environmental conditions [n -S]\n",
  "ECOREGIONS": "ECOREGION, an area defined by its environmental conditions [n]\n",
  "ECOS": "ECO, (short for) ecology [n]\n",
  "ECOSPECIES": "a group of ecotypes [n]\n",
  "ECOSPECIFIC": "relating to an ecospecies [adj]\n",
  "ECOSPHERE": "the biosphere [n -S]\n",
  "ECOSPHERES": "ECOSPHERE, the biosphere [n]\n",
  "ECOSSAISE": "(French) a dancing tune in the Scotch style [n -S]\n",
  "ECOSSAISES": "ECOSSAISE, (French) a dancing tune in the Scotch style [n]\n",
  "ECOSTATE": "of a leaf, having no ribs or nerves [adj]\n",
  "ECOSYSTEM": "all the organisms in a particular region and the environment in which they live [n -S]\n",
  "ECOSYSTEMS": "ECOSYSTEM, all the organisms in a particular region and the environment in which they live [n]\n",
  "ECOTAGE": "sabotage for ecological motives [n -S]\n",
  "ECOTAGES": "ECOTAGE, sabotage for ecological motives [n]\n",
  "ECOTARIAN": "a person who eats only food that has been produced in an environmentally friendly manner [n -S]\n",
  "ECOTARIANISM": "the principle or practice of avoiding eating any foods whose production or transportation are considered ecologically damaging [n -S]\n",
  "ECOTARIANISMS": "ECOTARIANISM, the principle or practice of avoiding eating any foods whose production or transportation are considered ecologically damaging [n]\n",
  "ECOTARIANS": "ECOTARIAN, a person who eats only food that has been produced in an environmentally friendly manner [n]\n",
  "ECOTECTURE": "a type of architecture based on concern for ecological principles such as sustainability and environmental impact [n -S]\n",
  "ECOTECTURES": "ECOTECTURE, a type of architecture based on concern for ecological principles such as sustainability and environmental impact [n]\n",
  "ECOTERRORISM": "sabotage intended to hinder activities that are considered damaging to the environment [n -S]\n",
  "ECOTERRORISMS": "ECOTERRORISM, sabotage intended to hinder activities that are considered damaging to the environment [n]\n",
  "ECOTERRORIST": "one who practises ecological terrorism [n -S]\n",
  "ECOTERRORISTS": "ECOTERRORIST, one who practises ecological terrorism [n]\n",
  "ECOTONAL": "relating to an ecotone, a zone of mixed vegetation formed by the overlapping of adjoining communities [adj]\n",
  "ECOTONE": "a transition area between two adjacent ecological communities [n -S]\n",
  "ECOTONES": "ECOTONE, a transition area between two adjacent ecological communities [n]\n",
  "ECOTOPIA": "an ecologically ideal region or type of society [n -S]\n",
  "ECOTOPIAS": "ECOTOPIA, an ecologically ideal region or type of society [n]\n",
  "ECOTOUR": "to go on a tour with an ecological purpose [v -ED, -ING, -S]\n",
  "ECOTOURED": "ECOTOUR, to go on a tour with an ecological purpose [v]\n",
  "ECOTOURING": "ECOTOUR, to go on a tour with an ecological purpose [v]\n",
  "ECOTOURISM": "the practice of touring natural habitats in a manner meant to minimize ecological impact [n -S]\n",
  "ECOTOURISMS": "ECOTOURISM, the practice of touring natural habitats in a manner meant to minimize ecological impact [n]\n",
  "ECOTOURIST": "a tourist who visits areas of ecological interest (typically exotic and often threatened natural environments), esp. to help conservation efforts and observe wildlife [n -S]\n",
  "ECOTOURISTS": "ECOTOURIST, a tourist who visits areas of ecological interest (typically exotic and often threatened natural environments), esp. to help conservation efforts and observe wildlife [n]\n",
  "ECOTOURS": "ECOTOUR, to go on a tour with an ecological purpose [v]\n",
  "ECOTOXIC": "poisonous to flora and fauna [adj]\n",
  "ECOTOXICOLOGIES": "ECOTOXICOLOGY, the study of the destructive effect of waste materials, etc. on the environment [n]\n",
  "ECOTOXICOLOGIST": "a specialist in ecotoxicology [n]\n",
  "ECOTOXICOLOGY": "the study of the destructive effect of waste materials, etc. on the environment [n ECOTOXICOLOGIES]\n",
  "ECOTYPE": "a group of organisms which have adapted to a particular environment and so have become different from other groups within the species [n -S]\n",
  "ECOTYPES": "ECOTYPE, a group of organisms which have adapted to a particular environment and so have become different from other groups within the species [n]\n",
  "ECOTYPIC": "of or like an ecotype, a group of organisms which have adapted to a particular environment [adj ECOTYPICALLY]\n",
  "ECOTYPICALLY": "ECOTYPIC, of or like an ecotype, a group of organisms which have adapted to a particular environment [adv]\n",
  "ECOZONE": "a regional ecosystem [n -S]\n",
  "ECOZONES": "ECOZONE, a regional ecosystem [n]\n",
  "ECPHONESES": "ECPHONESIS, an animated or passionate exclamation [n]\n",
  "ECPHONESIS": "an animated or passionate exclamation [n ECPHONESES]\n",
  "ECPHRACTIC": "(obsolete) serving to remove obstructions [adj] / a drug that removes obstructions [n -S]\n",
  "ECPHRACTICS": "ECPHRACTIC, a drug that removes obstructions [n]\n",
  "ECPHRASES": "ECPHRASIS, a description of a work of art, possibly imaginary, produced as a rhetorical exercise, also EKPHRASIS [n]\n",
  "ECPHRASIS": "a description of a work of art, possibly imaginary, produced as a rhetorical exercise, also EKPHRASIS [n ECPHRASES]\n",
  "ECRASEUR": "(French) a surgical instrument in the form of a wire or chain loop which cuts as it tightens [n -S]\n",
  "ECRASEURS": "ECRASEUR, (French) a surgical instrument in the form of a wire or chain loop which cuts as it tightens [n]\n",
  "ECRITOIRE": "(French) a writing-desk [n -S]\n",
  "ECRITOIRES": "ECRITOIRE, (French) a writing-desk [n]\n",
  "ECRU": "(French) the color or appearance of unbleached stuff, as silk, linen, or the like [n -S]\n",
  "ECRUS": "ECRU, (French) the color or appearance of unbleached stuff, as silk, linen, or the like [n]\n",
  "ECSTASES": "ECSTASIS, ecstasy [n]\n",
  "ECSTASIED": "ECSTASY, to send into a state of ecstasy [v]\n",
  "ECSTASIES": "ECSTASY, to send into a state of ecstasy [v]\n",
  "ECSTASIS": "ecstasy [n ECSTASISES or ECSTASES]\n",
  "ECSTASISE": "to be ecstatic, also ECSTASIZE [v ECSTASISED, ECSTASISING, ECSTASISES]\n",
  "ECSTASISED": "ECSTASISE, to be ecstatic, also ECSTASIZE [v]\n",
  "ECSTASISES": "ECSTASISE, to be ecstatic, also ECSTASIZE [v]\n",
  "ECSTASISING": "ECSTASISE, to be ecstatic, also ECSTASIZE [v]\n",
  "ECSTASIZE": "to be ecstatic, also ECSTASISE [v ECSTASIZED, ECSTASIZING, ECSTASIZES]\n",
  "ECSTASIZED": "ECSTASIZE, to be ecstatic, also ECSTASISE [v]\n",
  "ECSTASIZES": "ECSTASIZE, to be ecstatic, also ECSTASISE [v]\n",
  "ECSTASIZING": "ECSTASIZE, to be ecstatic, also ECSTASISE [v]\n",
  "ECSTASY": "a state of exalted pleasure or happiness, also EXTASY [n ECSTASIES] / to send into a state of ecstasy [v ECSTASIED, ECSTASYING, ECSTASIES]\n",
  "ECSTASYING": "ECSTASY, to send into a state of ecstasy [v]\n",
  "ECSTATIC": "very happy [adj ECSTATICALLY] / one who is subject to ecstasies [n -S]\n",
  "ECSTATICALLY": "ECSTATIC, very happy [adv]\n",
  "ECSTATICS": "ECSTATIC, one who is subject to ecstasies [n]\n",
  "ECTASES": "ECTASIS, (Greek) the lengthening of a short syllable, also ECTASIA [n]\n",
  "ECTASIA": "the lengthening of a short syllable, also ECTASIS [n -S]\n",
  "ECTASIAS": "ECTASIA, the lengthening of a short syllable, also ECTASIS [n]\n",
  "ECTASIS": "(Greek) the lengthening of a short syllable, also ECTASIA [n ECTASES]\n",
  "ECTATIC": "relating to ectasis [adj]\n",
  "ECTHLIPSES": "ECTHLIPSIS, the omission of one or more sounds in pronouncing a word [n]\n",
  "ECTHLIPSIS": "the omission of one or more sounds in pronouncing a word [n ECTHLIPSES]\n",
  "ECTHYMA": "(Greek) a skin disease with large round pustules [n ECTHYMAS or ECTHYMATA]\n",
  "ECTHYMAS": "ECTHYMA, (Greek) a skin disease with large round pustules [n]\n",
  "ECTHYMATA": "ECTHYMA, (Greek) a skin disease with large round pustules [n]\n",
  "ECTOBLAST": "the outer layer of the blastoderm, also EPIBLAST [n -S]\n",
  "ECTOBLASTIC": "relating to the ectoblast, the outer layer of the blastoderm [adj]\n",
  "ECTOBLASTS": "ECTOBLAST, the outer layer of the blastoderm, also EPIBLAST [n]\n",
  "ECTOCRINE": "any metabolite that is released into an organism's environment and influences the vital processes of other organisms [n -S]\n",
  "ECTOCRINES": "ECTOCRINE, any metabolite that is released into an organism's environment and influences the vital processes of other organisms [n]\n",
  "ECTODERM": "the external layer of an embryo, also EXODERM [n -S]\n",
  "ECTODERMAL": "of or relating to the ectoderm, also ECTODERMIC [adj]\n",
  "ECTODERMIC": "of or relating to the ectoderm, also ECTODERMAL [adj]\n",
  "ECTODERMS": "ECTODERM, the external layer of an embryo, also EXODERM [n]\n",
  "ECTOENZYME": "an exoenzyme, an enzyme that functions outside the cell producing it [n -S]\n",
  "ECTOENZYMES": "ECTOENZYME, an exoenzyme, an enzyme that functions outside the cell producing it [n]\n",
  "ECTOGENE": "a gene involved in the development of an embryo in artificial conditions [n -S]\n",
  "ECTOGENES": "ECTOGENE, a gene involved in the development of an embryo in artificial conditions [n]\n",
  "ECTOGENESES": "ECTOGENESIS, variation in response to outside conditions [n]\n",
  "ECTOGENESIS": "variation in response to outside conditions [n ECTOGENESES]\n",
  "ECTOGENETIC": "produced by or characteristic of ectogenesis [adj]\n",
  "ECTOGENIC": "relating to ectogeny, the effect of pollen on the tissues of a plant [adj ECTOGENICALLY]\n",
  "ECTOGENICALLY": "ECTOGENIC, relating to ectogeny, the effect of pollen on the tissues of a plant [adv]\n",
  "ECTOGENIES": "ECTOGENY, the effect of pollen on the tissues of a plant [n]\n",
  "ECTOGENOUS": "of a parasite, that can live outside a host [adj]\n",
  "ECTOGENY": "the effect of pollen on the tissues of a plant [n ECTOGENIES]\n",
  "ECTOMERE": "a cell that develops into ectoderm [n -S]\n",
  "ECTOMERES": "ECTOMERE, a cell that develops into ectoderm [n]\n",
  "ECTOMERIC": "like an ectomere, the more transparent cells, which finally become external, in many segmenting ova, as those of mammals [adj]\n",
  "ECTOMORPH": "a psychophysical type with long thin bones and large surface relative [n -S]\n",
  "ECTOMORPHIC": "being slender and thin [adj]\n",
  "ECTOMORPHIES": "ECTOMORPHY, the state of being an ectomorph [n]\n",
  "ECTOMORPHS": "ECTOMORPH, a psychophysical type with long thin bones and large surface relative [n]\n",
  "ECTOMORPHY": "the state of being an ectomorph [n ECTOMORPHIES]\n",
  "ECTOMYCORRHIZA": "a type of mycorrhiza in which the fungus forms a layer on the outside of the roots of the plant [n ECTOMYCORRHIZAE or ECTOMYCORRHIZAS]\n",
  "ECTOMYCORRHIZAE": "ECTOMYCORRHIZA, a type of mycorrhiza in which the fungus forms a layer on the outside of the roots of the plant [n]\n",
  "ECTOMYCORRHIZAS": "ECTOMYCORRHIZA, a type of mycorrhiza in which the fungus forms a layer on the outside of the roots of the plant [n]\n",
  "ECTOPARASITE": "a parasite that lives on the surface of animals [n -S]\n",
  "ECTOPARASITES": "ECTOPARASITE, a parasite that lives on the surface of animals [n]\n",
  "ECTOPARASITIC": "of or like an ectoparasite [adj]\n",
  "ECTOPHYTE": "a vegetable ectoparasite [n -S]\n",
  "ECTOPHYTES": "ECTOPHYTE, a vegetable ectoparasite [n]\n",
  "ECTOPHYTIC": "relating to an ectophyte, a vegetable ectoparasite [adj]\n",
  "ECTOPIA": "abnormal displacement of body parts, also ECTOPY [n -S]\n",
  "ECTOPIAS": "ECTOPIA, abnormal displacement of body parts, also ECTOPY [n]\n",
  "ECTOPIC": "relating to ectopia [adj ECTOPICALLY]\n",
  "ECTOPICALLY": "ECTOPIC, relating to ectopia [adv]\n",
  "ECTOPIES": "ECTOPY, abnormal displacement of body parts, also ECTOPIA [n]\n",
  "ECTOPLASM": "the outer transparent layer of protoplasm in a developing ovum, also EXOPLASM [n -S]\n",
  "ECTOPLASMIC": "of or like ectoplasm, also ECTOPLASTIC [adj]\n",
  "ECTOPLASMS": "ECTOPLASM, the outer transparent layer of protoplasm in a developing ovum, also EXOPLASM [n]\n",
  "ECTOPLASTIC": "relating to ectoplasm, also ECTOPLASMIC [adj]\n",
  "ECTOPROCT": "a bryozoan, a moss or liverwort [n -S]\n",
  "ECTOPROCTS": "ECTOPROCT, a bryozoan, a moss or liverwort [n]\n",
  "ECTOPY": "abnormal displacement of body parts, also ECTOPIA [n ECTOPIES]\n",
  "ECTOSARC": "the outermost layer of some protozoans [n -S]\n",
  "ECTOSARCOUS": "like ectosarc [adj]\n",
  "ECTOSARCS": "ECTOSARC, the outermost layer of some protozoans [n]\n",
  "ECTOTHERM": "a cold-blooded animal [n -S]\n",
  "ECTOTHERMIC": "cold-blooded [adj]\n",
  "ECTOTHERMS": "ECTOTHERM, a cold-blooded animal [n]\n",
  "ECTOTROPHIC": "growing in a close web on the surface of the associated root [adj]\n",
  "ECTOZOA": "ECTOZOON, a parasite on the body of an animal, also ECTOZOAN [n]\n",
  "ECTOZOAN": "a parasite on the body of an animal, also ECTOZOON [n -S]\n",
  "ECTOZOANS": "ECTOZOAN, a parasite on the body of an animal, also ECTOZOON [n]\n",
  "ECTOZOIC": "externally parasitic [adj]\n",
  "ECTOZOON": "a parasite on the body of an animal, also ECTOZOAN [n ECTOZOA]\n",
  "ECTROPIC": "displaying the red inner surface of the eyelid [adj]\n",
  "ECTROPION": "an unnatural eversion of the eyelids, also ECTROPIUM [n -S]\n",
  "ECTROPIONS": "ECTROPION, an unnatural eversion of the eyelids, also ECTROPIUM [n]\n",
  "ECTROPIUM": "an unnatural eversion of the eyelids, also ECTROPION [n -S]\n",
  "ECTROPIUMS": "ECTROPIUM, an unnatural eversion of the eyelids, also ECTROPION [n]\n",
  "ECTYPAL": "or or like an ectype, a reproduction or copy [adj]\n",
  "ECTYPE": "a reproduction or copy [n -S]\n",
  "ECTYPES": "ECTYPE, a reproduction or copy [n]\n",
  "ECTYPOGRAPHIES": "ECTYPOGRAPHY, etching in relief [n]\n",
  "ECTYPOGRAPHY": "etching in relief [n ECTYPOGRAPHIES]\n",
  "ECU": "(French) an old French coin [n -S]\n",
  "ECUELLE": "(French) a two-handled soup bowl [n -S]\n",
  "ECUELLES": "ECUELLE, (French) a two-handled soup bowl [n]\n",
  "ECUMENE": "an inhabited area [n -S]\n",
  "ECUMENES": "ECUMENE, an inhabited area [n]\n",
  "ECUMENIC": "general; universal; in ecclesiastical usage, that which concerns the whole church, also ECUMENICAL, OECUMENIC, OECUMENICAL [adj ECUMENICALLY]\n",
  "ECUMENICAL": "general; universal; in ecclesiastical usage, that which concerns the whole church, also ECUMENIC, OECUMENIC, OECUMENICAL [adj ECUMENICALLY]\n",
  "ECUMENICALISM": "the doctrines and practice of the Christian ecumenical movement, also ECUMENICISM [n -S]\n",
  "ECUMENICALISMS": "ECUMENICALISM, the doctrines and practice of the Christian ecumenical movement, also ECUMENICISM [n]\n",
  "ECUMENICALLY": "ECUMENICAL, general; universal; in ecclesiastical usage, that which concerns the whole church, also ECUMENIC, OECUMENIC, OECUMENICAL [adv]\n",
  "ECUMENICISM": "the doctrines and practice of the Christian ecumenical movement, also ECUMENICALISM [n -S]\n",
  "ECUMENICISMS": "ECUMENICISM, the doctrines and practice of the Christian ecumenical movement, also ECUMENICALISM [n]\n",
  "ECUMENICIST": "a believer in ecumenicism [n -S]\n",
  "ECUMENICISTS": "ECUMENICIST, a believer in ecumenicism [n]\n",
  "ECUMENICITIES": "ECUMENICITY, the state of being drawn close to others esp. through Christian ecumenism [n]\n",
  "ECUMENICITY": "the state of being drawn close to others esp. through Christian ecumenism [n ECUMENICITIES]\n",
  "ECUMENICS": "the study of ecumenicism [n]\n",
  "ECUMENISM": "the doctrines and practice of the Christian ecumenical movement [n -S]\n",
  "ECUMENISMS": "ECUMENISM, the doctrines and practice of the Christian ecumenical movement [n]\n",
  "ECUMENIST": "an adherent of ecumenism, the doctrines and practice of the Christian ecumenical movement [n -S]\n",
  "ECUMENISTS": "ECUMENIST, an adherent of ecumenism, the doctrines and practice of the Christian ecumenical movement [n]\n",
  "ECURIE": "(French) a team of motor racing cars [n -S]\n",
  "ECURIES": "ECURIE, (French) a team of motor racing cars [n]\n",
  "ECUS": "ECU, (French) an old French coin [n]\n",
  "ECZEMA": "a skin disease [n -S]\n",
  "ECZEMAS": "ECZEMA, a skin disease [n]\n",
  "ECZEMATOUS": "pertaining to eczema [adj]\n",
  "ED": "(short for) education [n -S]\n",
  "EDACIOUS": "voracious, devouring [adj EDACIOUSLY]\n",
  "EDACIOUSLY": "EDACIOUS, voracious, devouring [adv]\n",
  "EDACIOUSNESS": "the state of being edacious [n -ES]\n",
  "EDACIOUSNESSES": "EDACIOUSNESS, the state of being edacious [n]\n",
  "EDACITIES": "EDACITY, ravenousness, voracity [n]\n",
  "EDACITY": "ravenousness, voracity [n EDACITIES]\n",
  "EDAMAME": "a preparation of baby soybeans in the pod commonly found in Japan, China and Korea [n -S]\n",
  "EDAMAMES": "EDAMAME, a preparation of baby soybeans in the pod commonly found in Japan, China and Korea [n]\n",
  "EDAPHIC": "pertaining to the soil [adj EDAPHICALLY]\n",
  "EDAPHICALLY": "EDAPHIC, pertaining to the soil [adv]\n",
  "EDAPHOLOGIES": "EDAPHOLOGY, the science of soil as a plant growing medium [n]\n",
  "EDAPHOLOGY": "the science of soil as a plant growing medium [n EDAPHOLOGIES]\n",
  "EDDIED": "EDDY, to move against the main current [v]\n",
  "EDDIES": "EDDY, to move against the main current [v]\n",
  "EDDISH": "pasturage, or the eatable growth of grass after mowing, also ARISH, ARRISH, EADISH [n -ES]\n",
  "EDDISHES": "EDDISH, pasturage, or the eatable growth of grass after mowing, also ARISH, ARRISH, EADISH [n]\n",
  "EDDO": "a kind of yam, aka taro, dasheen [n -ES]\n",
  "EDDOES": "EDDO, a kind of yam, aka taro, dasheen [n]\n",
  "EDDY": "to move against the main current [v EDDIED, EDDYING, EDDIES]\n",
  "EDDYING": "EDDY, to move against the main current [v]\n",
  "EDELWEISS": "(German) a white Alpine flower of the composite family [n -ES]\n",
  "EDELWEISSES": "EDELWEISS, (German) a white Alpine flower of the composite family [n]\n",
  "EDEMA": "(Greek) local or general swelling produced by the accumulation of fluid in the body tissues or cavities, also OEDEMA [n EDEMAS or EDEMATA]\n",
  "EDEMAS": "EDEMA, (Greek) local or general swelling produced by the accumulation of fluid in the body tissues or cavities, also OEDEMA [n]\n",
  "EDEMATA": "EDEMA, (Greek) local or general swelling produced by the accumulation of fluid in the body tissues or cavities, also OEDEMA [n]\n",
  "EDEMATOSE": "pertaining to, or of the nature of, edema, also EDEMATOUS, OEDEMATOSE, OEDEMATOUS [adj]\n",
  "EDEMATOUS": "pertaining to, or of the nature of, edema, also EDEMATOSE, OEDEMATOSE, OEDEMATOUS [adj]\n",
  "EDENIC": "of or pertaining to Eden [adj]\n",
  "EDENTAL": "without teeth, as of anteaters, armadillos, and sloths, also EDENTATE [adj]\n",
  "EDENTATE": "a toothless mammal as an armadillo or sloth [n -S]\n",
  "EDENTATES": "EDENTATE, a toothless mammal as an armadillo or sloth [n]\n",
  "EDENTULATE": "without teeth, also EDENTULOUS [adj]\n",
  "EDENTULOUS": "without teeth, also EDENTULATE [adj]\n",
  "EDGE": "to furnish with a border [v EDGED, EDGING, EDGES]\n",
  "EDGEBONE": "the bone of the rump in cattle, also AITCHBONE [n -S]\n",
  "EDGEBONES": "EDGEBONE, the bone of the rump in cattle, also AITCHBONE [n]\n",
  "EDGED": "EDGE, to furnish with a border [v]\n",
  "EDGELESS": "without an edge [adj]\n",
  "EDGER": "a tool used to trim lawn borders [n -S]\n",
  "EDGERS": "EDGER, a tool used to trim lawn borders [n]\n",
  "EDGES": "EDGE, to furnish with a border [v]\n",
  "EDGEWAYS": "with edge foremost or uppermost, also EDGEWISE [adv]\n",
  "EDGEWISE": "with edge foremost or uppermost, also EDGEWAYS [adv]\n",
  "EDGIER": "EDGY, nervous [adj]\n",
  "EDGIEST": "EDGY, nervous [adj]\n",
  "EDGILY": "EDGY, nervous [adv]\n",
  "EDGINESS": "the state of being edgy [n -ES]\n",
  "EDGINESSES": "EDGINESS, the state of being edgy [n]\n",
  "EDGING": "something that serves as an edge [n -S]\n",
  "EDGINGS": "EDGING, something that serves as an edge [n]\n",
  "EDGY": "nervous [adj EDGIER, EDGIEST, EDGILY]\n",
  "EDH": "a letter used in old English, also ETH [n -S]\n",
  "EDHS": "EDH, a letter used in old English, also ETH [n]\n",
  "EDIBILITIES": "EDIBILITY, the quality of being edible [n]\n",
  "EDIBILITY": "the quality of being edible [n EDIBILITIES]\n",
  "EDIBLE": "something fit to be eaten [n -S]\n",
  "EDIBLENESS": "suitableness for being eaten [n -ES]\n",
  "EDIBLENESSES": "EDIBLENESS, suitableness for being eaten [n]\n",
  "EDIBLES": "EDIBLE, something fit to be eaten [n]\n",
  "EDICT": "an authoritative order having the force of law [n -S]\n",
  "EDICTAL": "relating to an edict [adj EDICTALLY]\n",
  "EDICTALLY": "EDICTAL, relating to an edict [adv]\n",
  "EDICTS": "EDICT, an authoritative order having the force of law [n]\n",
  "EDIFICATION": "an act of edifying [n -S]\n",
  "EDIFICATIONS": "EDIFICATION, an act of edifying [n]\n",
  "EDIFICATORY": "giving edification [adj]\n",
  "EDIFICE": "a building [n -S]\n",
  "EDIFICES": "EDIFICE, a building [n]\n",
  "EDIFICIAL": "pertaining to an edifice [adj]\n",
  "EDIFIED": "EDIFY, to enlighten [v]\n",
  "EDIFIER": "one who edifies [n -S]\n",
  "EDIFIERS": "EDIFIER, one who edifies [n]\n",
  "EDIFIES": "EDIFY, to enlighten [v]\n",
  "EDIFY": "to enlighten [v EDIFIED, EDIFYING, EDIFIES]\n",
  "EDIFYING": "EDIFY, to enlighten [v]\n",
  "EDIFYINGLY": "EDIFYING, EDIFY, to enlighten [adv]\n",
  "EDILE": "(Latin) in classical times, a magistrate in charge of games, markets or buildings, also AEDILE [n -S]\n",
  "EDILES": "EDILE, (Latin) in classical times, a magistrate in charge of games, markets or buildings, also AEDILE [n]\n",
  "EDIT": "to prepare for publication [v -ED, -ING, -S]\n",
  "EDITABLE": "able to be edited [adj]\n",
  "EDITED": "EDIT, to prepare for publication [v]\n",
  "EDITING": "the act of editing [n -S]\n",
  "EDITINGS": "EDITING, the act of editing [n]\n",
  "EDITION": "to produce multiple copies of an art work [v -ED, -ING, -S]\n",
  "EDITIONED": "EDITION, to produce multiple copies of an art work [v]\n",
  "EDITIONING": "EDITION, to produce multiple copies of an art work [v]\n",
  "EDITIONS": "EDITION [n]\n",
  "EDITOR": "one that edits [n -S]\n",
  "EDITORIAL": "relating to editors [adj EDITORIALLY] / an article in a newspaper written by an editor or leader writer [n -S]\n",
  "EDITORIALISE": "to introduce personal opinions or bias into reporting, also EDITORIALIZE [v EDITORIALISED, EDITORIALISING, EDITORIALISES]\n",
  "EDITORIALISED": "EDITORIALISE, to introduce personal opinions or bias into reporting, also EDITORIALIZE [v]\n",
  "EDITORIALISER": "one who editorialises, also EDITORIALIZER [n -S]\n",
  "EDITORIALISERS": "EDITORIALISER, one who editorialises, also EDITORIALIZER [n]\n",
  "EDITORIALISES": "EDITORIALISE, to introduce personal opinions or bias into reporting, also EDITORIALIZE [v]\n",
  "EDITORIALISING": "EDITORIALISE, to introduce personal opinions or bias into reporting, also EDITORIALIZE [v]\n",
  "EDITORIALIST": "a writer of editorials [n -S]\n",
  "EDITORIALISTS": "EDITORIALIST, a writer of editorials [n]\n",
  "EDITORIALIZE": "to introduce personal opinions or bias into reporting, also EDITORIALISE [v EDITORIALIZED, EDITORIALIZING, EDITORIALIZES]\n",
  "EDITORIALIZED": "EDITORIALIZE, to introduce personal opinions or bias into reporting, also EDITORIALISE [v]\n",
  "EDITORIALIZER": "one who editorializes, also EDITORIALISER [n -S]\n",
  "EDITORIALIZERS": "EDITORIALIZER, one who editorializes, also EDITORIALISER [n]\n",
  "EDITORIALIZES": "EDITORIALIZE, to introduce personal opinions or bias into reporting, also EDITORIALISE [v]\n",
  "EDITORIALIZING": "EDITORIALIZE, to introduce personal opinions or bias into reporting, also EDITORIALISE [v]\n",
  "EDITORIALLY": "EDITORIAL, relating to editors [adv]\n",
  "EDITORIALS": "EDITORIAL, an article in a newspaper written by an editor or leader writer [n]\n",
  "EDITORS": "EDITOR, one that edits [n]\n",
  "EDITORSHIP": "the office or charge of an editor [n -S]\n",
  "EDITORSHIPS": "EDITORSHIP, the office or charge of an editor [n]\n",
  "EDITRESS": "a female editor, also EDITRIX [n -ES]\n",
  "EDITRESSES": "EDITRESS, a female editor, also EDITRIX [n]\n",
  "EDITRICES": "EDITRIX, a female editor, also EDITRESS [n]\n",
  "EDITRIX": "a female editor, also EDITRESS [n EDITRICES or EDITRIXES]\n",
  "EDITRIXES": "EDITRIX, a female editor, also EDITRESS [n]\n",
  "EDITS": "EDIT, to prepare for publication [v]\n",
  "EDRIOPHTHALMIAN": "of crustaceans, with stalkless eyes, also EDRIOPHTHALMIC, EDRIOPHTHALMOUS [adj]\n",
  "EDRIOPHTHALMIC": "of crustaceans, with stalkless eyes, also EDRIOPHTHALMIAN, EDRIOPHTHALMOUS [adj]\n",
  "EDRIOPHTHALMOUS": "of crustaceans, with stalkless eyes, also EDRIOPHTHALMIAN, EDRIOPHTHALMIC [adj]\n",
  "EDS": "ED, (short for) education [n]\n",
  "EDUCABILITIES": "EDUCABILITY, the capacity to be educated [n]\n",
  "EDUCABILITY": "the capacity to be educated [n EDUCABILITIES]\n",
  "EDUCABLE": "someone able to be educated [n -S]\n",
  "EDUCABLES": "EDUCABLE, someone able to be educated [n]\n",
  "EDUCATABILITIES": "EDUCATABILITY, the quality of being educatable [n]\n",
  "EDUCATABILITY": "the quality of being educatable [n EDUCATABILITIES]\n",
  "EDUCATABLE": "that can be educated [adj]\n",
  "EDUCATE": "to teach [v EDUCATED, EDUCATING, EDUCATES]\n",
  "EDUCATED": "EDUCATE, to teach [v]\n",
  "EDUCATEDNESS": "the state of being educated [n -ES]\n",
  "EDUCATEDNESSES": "EDUCATEDNESS, the state of being educated [n]\n",
  "EDUCATES": "EDUCATE, to teach [v]\n",
  "EDUCATING": "EDUCATE, to teach [v]\n",
  "EDUCATION": "bringing up or training esp. of a child [n -S]\n",
  "EDUCATIONAL": "serving to educate [adj EDUCATIONALLY]\n",
  "EDUCATIONALIST": "a person skilled in methods of educating or teaching [n -S]\n",
  "EDUCATIONALISTS": "EDUCATIONALIST, a person skilled in methods of educating or teaching [n]\n",
  "EDUCATIONALLY": "EDUCATIONAL, serving to educate [adv]\n",
  "EDUCATIONESE": "the jargon used esp. by educational theorists [n -S]\n",
  "EDUCATIONESES": "EDUCATIONESE, the jargon used esp. by educational theorists [n]\n",
  "EDUCATIONIST": "a professional educator [n -S]\n",
  "EDUCATIONISTS": "EDUCATIONIST, a professional educator [n]\n",
  "EDUCATIONS": "EDUCATION, bringing up or training esp. of a child [n]\n",
  "EDUCATIVE": "relating to education [adj]\n",
  "EDUCATOR": "one who educates [n -S]\n",
  "EDUCATORS": "EDUCATOR, one who educates [n]\n",
  "EDUCATORY": "relating to education [adj]\n",
  "EDUCE": "to draw out, elicit [v EDUCED, EDUCING, EDUCES]\n",
  "EDUCED": "EDUCE, to draw out, elicit [v]\n",
  "EDUCEMENT": "the act of educing [n -S]\n",
  "EDUCEMENTS": "EDUCEMENT, the act of educing [n]\n",
  "EDUCES": "EDUCE, to draw out, elicit [v]\n",
  "EDUCIBLE": "able to be drawn out [adj]\n",
  "EDUCING": "EDUCE, to draw out, elicit [v]\n",
  "EDUCT": "that which is educed, as by analysis [n -S]\n",
  "EDUCTION": "the act of drawing out or bringing into view [n -S]\n",
  "EDUCTIONS": "EDUCTION, the act of drawing out or bringing into view [n]\n",
  "EDUCTIVE": "drawn out [adj]\n",
  "EDUCTOR": "someone who or something which educes [n -S]\n",
  "EDUCTORS": "EDUCTOR, someone who or something which educes [n]\n",
  "EDUCTS": "EDUCT, that which is educed, as by analysis [n]\n",
  "EDULCORANT": "having a tendency to purify or to sweeten by removing or correcting acidity and acrimony [adj]\n",
  "EDULCORATE": "to make pleasant, sweeten [v EDULCORATED, EDULCORATING, EDULCORATES]\n",
  "EDULCORATED": "EDULCORATE, to make pleasant, sweeten [v]\n",
  "EDULCORATES": "EDULCORATE, to make pleasant, sweeten [v]\n",
  "EDULCORATING": "EDULCORATE, to make pleasant, sweeten [v]\n",
  "EDULCORATION": "freeing from soluble particles by washing [n -S]\n",
  "EDULCORATIONS": "EDULCORATION, freeing from soluble particles by washing [n]\n",
  "EDULCORATIVE": "serving to edulcorate, to sweeten [adj]\n",
  "EDULCORATOR": "an agent that edulcorates [n -S]\n",
  "EDULCORATORS": "EDULCORATOR, an agent that edulcorates [n]\n",
  "EDUTAINMENT": "education combined with entertainment [n -S]\n",
  "EDUTAINMENTS": "EDUTAINMENT, education combined with entertainment [n]\n",
  "EE": "(Scots) an eye [n EEN]\n",
  "EECH": "to augment, also EKE, ECH, ECHE, EIK, ICH [v -ED, -ING, -ES]\n",
  "EECHED": "EECH, to augment, also EKE, ECH, ECHE, EIK, ICH [v]\n",
  "EECHES": "EECH, to augment, also EKE, ECH, ECHE, EIK, ICH [v]\n",
  "EECHING": "EECH, to augment, also EKE, ECH, ECHE, EIK, ICH [v]\n",
  "EEEW": "an interjection used to express disgust, also EEW, EW [interj]\n",
  "EEJIT": "(colloquial) an idiot [n -S]\n",
  "EEJITS": "EEJIT, (colloquial) an idiot [n]\n",
  "EEK": "an interjection expressing fright [interj]\n",
  "EEL": "a snakelike fish [n -S]\n",
  "EELFARE": "a group of young eels [n -S]\n",
  "EELFARES": "EELFARE, a group of young eels [n]\n",
  "EELGRASS": "any of several submerged marine flowering plants with ribbonlike leaves [n -ES]\n",
  "EELGRASSES": "EELGRASS, any of several submerged marine flowering plants with ribbonlike leaves [n]\n",
  "EELIER": "EELY, like an eel [adj]\n",
  "EELIEST": "EELY, like an eel [adj]\n",
  "EELING": "the practice of catching eels [n -S]\n",
  "EELINGS": "EELING, the practice of catching eels [n]\n",
  "EELLIKE": "like an eel [adj]\n",
  "EELPOUT": "a kind of fish, aka burbot [n -S]\n",
  "EELPOUTS": "EELPOUT, a kind of fish, aka burbot [n]\n",
  "EELS": "EEL, a snakelike fish [n]\n",
  "EELWORM": "a small roundworm [n -S]\n",
  "EELWORMS": "EELWORM, a small roundworm [n]\n",
  "EELWRACK": "a grasslike flowering plant of the pondweed family [n -S]\n",
  "EELWRACKS": "EELWRACK, a grasslike flowering plant of the pondweed family [n]\n",
  "EELY": "like an eel [adj EELIER, EELIEST]\n",
  "EEN": "EE, (Scots) an eye [n]\n",
  "EENSIER": "EENSY, (colloquial) very small [adj]\n",
  "EENSIEST": "EENSY, (colloquial) very small [adj]\n",
  "EENSY": "(colloquial) very small [adj EENSIER, EENSIEST]\n",
  "EERIE": "uncanny, also EERY [adj EERIER, EERIEST, EERILY]\n",
  "EERIER": "EERY, uncanny, also EERIE [adj]\n",
  "EERIEST": "EERY, uncanny, also EERIE [adj]\n",
  "EERILY": "EERY, uncanny, also EERIE [adv]\n",
  "EERINESS": "the state of being eerie [n -ES]\n",
  "EERINESSES": "EERINESS, the state of being eerie [n]\n",
  "EERY": "uncanny, also EERIE [adj EERIER, EERIEST, EERILY]\n",
  "EEVEN": "the latter part of daylight hours, also EVENING, EEVN, EEVNING [n -S]\n",
  "EEVENS": "EEVEN, the latter part of daylight hours, also EVENING, EEVN, EEVNING [n]\n",
  "EEVN": "the latter part of daylight hours, also EVENING, EEVEN, EEVNING [n -S]\n",
  "EEVNING": "the latter part of daylight hours, also EVENING, EEVEN, EEVN [n -S]\n",
  "EEVNINGS": "EEVNING, the latter part of daylight hours, also EVENING, EEVEN, EEVN [n]\n",
  "EEVNS": "EEVN, the latter part of daylight hours, also EVENING, EEVEN, EEVNING [n]\n",
  "EEW": "an interjection used to express disgust, also EEEW, EW [interj]\n",
  "EF": "the letter F [n -S]\n",
  "EFF": "euphemism for fuck [v -ED, -ING, -S]\n",
  "EFFABLE": "capable of being expressed [adj]\n",
  "EFFACE": "to erase [v EFFACED, EFFACING, EFFACES]\n",
  "EFFACEABLE": "that can be effaced [adj]\n",
  "EFFACED": "EFFACE, to erase [v]\n",
  "EFFACEMENT": "the act of effacing [n -S]\n",
  "EFFACEMENTS": "EFFACEMENT, the act of effacing [n]\n",
  "EFFACER": "one who effaces [n -S]\n",
  "EFFACERS": "EFFACER, one who effaces [n]\n",
  "EFFACES": "EFFACE, to erase [v]\n",
  "EFFACING": "EFFACE, to erase [v]\n",
  "EFFECT": "to bring about [v -ED, -ING, -S]\n",
  "EFFECTED": "EFFECT, to bring about [v]\n",
  "EFFECTER": "an organ that responds to stimulus, also EFFECTOR [n -S]\n",
  "EFFECTERS": "EFFECTER, an organ that responds to stimulus, also EFFECTOR [n]\n",
  "EFFECTIBLE": "capable of being done or achieved [adj]\n",
  "EFFECTING": "EFFECT, to bring about [v]\n",
  "EFFECTIVE": "that works [adj EFFECTIVELY] / an effective serviceman or other person [n -S]\n",
  "EFFECTIVELY": "EFFECTIVE, that works [adv]\n",
  "EFFECTIVENESS": "the state of being effective [n -ES]\n",
  "EFFECTIVENESSES": "EFFECTIVENESS, the state of being effective [n]\n",
  "EFFECTIVES": "EFFECTIVE, an effective serviceman or other person [n]\n",
  "EFFECTIVITIES": "EFFECTIVITY, the state of being effective [n]\n",
  "EFFECTIVITY": "the state of being effective [n EFFECTIVITIES]\n",
  "EFFECTLESS": "without effect or advantage [adj]\n",
  "EFFECTOR": "an organ that responds to stimulus, also EFFECTER [n -S]\n",
  "EFFECTORS": "EFFECTOR, an organ that responds to stimulus, also EFFECTER [n]\n",
  "EFFECTS": "EFFECT, to bring about [v]\n",
  "EFFECTUAL": "successful in producing the desired effect [adj EFFECTUALLY]\n",
  "EFFECTUALITIES": "EFFECTUALITY, the state of being effectual [n]\n",
  "EFFECTUALITY": "the state of being effectual [n EFFECTUALITIES]\n",
  "EFFECTUALLY": "EFFECTUAL, successful in producing the desired effect [adv]\n",
  "EFFECTUALNESS": "the state of being effectual [n -ES]\n",
  "EFFECTUALNESSES": "EFFECTUALNESS, the state of being effectual [n]\n",
  "EFFECTUATE": "to effect [v EFFECTUATED, EFFECTUATING, EFFECTUATES]\n",
  "EFFECTUATED": "EFFECTUATE, to effect [v]\n",
  "EFFECTUATES": "EFFECTUATE, to effect [v]\n",
  "EFFECTUATING": "EFFECTUATE, to effect [v]\n",
  "EFFECTUATION": "the act of effectuating [n -S]\n",
  "EFFECTUATIONS": "EFFECTUATION, the act of effectuating [n]\n",
  "EFFED": "EFF, euphemism for fuck [v]\n",
  "EFFEIR": "(obsolete) to appertain, to suit, also EFFERE [v -ED, -ING, -S]\n",
  "EFFEIRED": "EFFEIR, (obsolete) to appertain, to suit, also EFFERE [v]\n",
  "EFFEIRING": "EFFEIR, (obsolete) to appertain, to suit, also EFFERE [v]\n",
  "EFFEIRS": "EFFEIR, (obsolete) to appertain, to suit, also EFFERE [v]\n",
  "EFFEMINACIES": "EFFEMINACY, the quality of being effeminate [n]\n",
  "EFFEMINACY": "the quality of being effeminate [n EFFEMINACIES]\n",
  "EFFEMINATE": "womanish [adj EFFEMINATELY] / (archaic) to render effeminate [v EFFEMINATED, EFFEMINATING, EFFEMINATES]\n",
  "EFFEMINATED": "EFFEMINATE, (archaic) to render effeminate [v]\n",
  "EFFEMINATELY": "EFFEMINATE, womanish [adv]\n",
  "EFFEMINATENESS": "the state of being effeminate [n]\n",
  "EFFEMINATES": "EFFEMINATE, (archaic) to render effeminate [v]\n",
  "EFFEMINATING": "EFFEMINATE, (archaic) to render effeminate [v]\n",
  "EFFEMINISE": "(archaic) to make effeminate, also EFFEMINIZE [v EFFEMINISED, EFFEMINISING, EFFEMINISES]\n",
  "EFFEMINISED": "EFFEMINISE, (archaic) to make effeminate, also EFFEMINIZE [v]\n",
  "EFFEMINISES": "EFFEMINISE, (archaic) to make effeminate, also EFFEMINIZE [v]\n",
  "EFFEMINISING": "EFFEMINISE, (archaic) to make effeminate, also EFFEMINIZE [v]\n",
  "EFFEMINIZE": "(archaic) to make effeminate [v EFFEMINIZED, EFFEMINIZING, EFFEMINIZES]\n",
  "EFFEMINIZED": "EFFEMINIZE, (archaic) to make effeminate [v]\n",
  "EFFEMINIZES": "EFFEMINIZE, (archaic) to make effeminate [v]\n",
  "EFFEMINIZING": "EFFEMINIZE, (archaic) to make effeminate [v]\n",
  "EFFENDI": "(Turkish) in the Eastern Mediterranean, a title of respect for high-ranking people [n -S]\n",
  "EFFENDIS": "EFFENDI, (Turkish) in the Eastern Mediterranean, a title of respect for high-ranking people [n]\n",
  "EFFERE": "(obsolete) to appertain, to suit, also EFFEIR [v EFFERED, EFFERING, EFFERES]\n",
  "EFFERED": "EFFERE, (obsolete) to appertain, to suit, also EFFEIR [v]\n",
  "EFFERENCE": "the act of conveying outward or away [n -S]\n",
  "EFFERENCES": "EFFERENCE, the act of conveying outward or away [n]\n",
  "EFFERENT": "carrying outward or away [adj EFFERENTLY] / a nerve carrying impulses away [n -S]\n",
  "EFFERENTLY": "EFFERENT, carrying outward or away [adv]\n",
  "EFFERENTS": "EFFERENT, a nerve carrying impulses away [n]\n",
  "EFFERES": "EFFERE, (obsolete) to appertain, to suit, also EFFEIR [v]\n",
  "EFFERING": "EFFERE, (obsolete) to appertain, to suit, also EFFEIR [v]\n",
  "EFFERVESCE": "to bubble, hiss, and foam as gas escapes [v EFFERVESCED, EFFERVESCING, EFFERVESCES]\n",
  "EFFERVESCED": "EFFERVESCE, to bubble, hiss, and foam as gas escapes [v]\n",
  "EFFERVESCENCE": "boiling or bubbling, also EFFERVESCENCY [n -S]\n",
  "EFFERVESCENCES": "EFFERVESCENCE, boiling or bubbling, also EFFERVESCENCY [n]\n",
  "EFFERVESCENCIES": "EFFERVESCENCY, boiling or bubbling, also EFFERVESCENCE [n]\n",
  "EFFERVESCENCY": "boiling or bubbling, also EFFERVESCENCE [n EFFERVESCENCIES]\n",
  "EFFERVESCENT": "frothing, bubbling [adj EFFERVESCENTLY]\n",
  "EFFERVESCENTLY": "EFFERVESCENT, frothing, bubbling [adv]\n",
  "EFFERVESCES": "EFFERVESCE, to bubble, hiss, and foam as gas escapes [v]\n",
  "EFFERVESCIBLE": "capable of effervescing [adj]\n",
  "EFFERVESCING": "EFFERVESCE, to bubble, hiss, and foam as gas escapes [v]\n",
  "EFFERVESCINGLY": "EFFERVESCING, EFFERVESCE, to bubble, hiss, and foam as gas escapes [adv]\n",
  "EFFETE": "exhausted [adj EFFETELY]\n",
  "EFFETELY": "EFFETE, exhausted [adv]\n",
  "EFFETENESS": "the state of being effete [n -ES]\n",
  "EFFETENESSES": "EFFETENESS, the state of being effete [n]\n",
  "EFFICACIES": "EFFICACY, effectiveness [n]\n",
  "EFFICACIOUS": "having the power to produce a desired effect [adj EFFICACIOUSLY]\n",
  "EFFICACIOUSLY": "EFFICACIOUS, having the power to produce a desired effect [adv]\n",
  "EFFICACIOUSNESS": "EFFICACIOUS, having the power to produce a desired effect [n]\n",
  "EFFICACITIES": "EFFICACITY, the state of being efficacious [n]\n",
  "EFFICACITY": "the state of being efficacious [n EFFICACITIES]\n",
  "EFFICACY": "effectiveness [n EFFICACIES]\n",
  "EFFICIENCE": "(archaic) efficiency, also EFFICIENCY [n -S]\n",
  "EFFICIENCES": "EFFICIENCE, (archaic) efficiency, also EFFICIENCY [n]\n",
  "EFFICIENCIES": "EFFICIENCY, the quality of being efficient, also EFFICIENCE [n]\n",
  "EFFICIENCY": "the quality of being efficient, also EFFICIENCE [n EFFICIENCIES]\n",
  "EFFICIENT": "capable of doing what may be required [adj EFFICIENTLY] / a trained soldier, esp. one volunteering for service [n -S]\n",
  "EFFICIENTLY": "EFFICIENT, capable of doing what may be required [adv]\n",
  "EFFICIENTS": "EFFICIENT, a trained soldier, esp. one volunteering for service [n]\n",
  "EFFIERCE": "(Spenser) to make fierce, also ENFIERCE [v EFFIERCED, EFFIERCING, EFFIERCES]\n",
  "EFFIERCED": "EFFIERCE, (Spenser) to make fierce, also ENFIERCE [v]\n",
  "EFFIERCES": "EFFIERCE, (Spenser) to make fierce, also ENFIERCE [v]\n",
  "EFFIERCING": "EFFIERCE, (Spenser) to make fierce, also ENFIERCE [v]\n",
  "EFFIGIAL": "relating to an effigy [adj]\n",
  "EFFIGIES": "EFFIGY, a likeness of a person [n]\n",
  "EFFIGURATE": "having a definite shape [adj]\n",
  "EFFIGURATION": "an elaborate, detailed description of an object or an event [n -S]\n",
  "EFFIGURATIONS": "EFFIGURATION, an elaborate, detailed description of an object or an event [n]\n",
  "EFFIGY": "a likeness of a person [n EFFIGIES]\n",
  "EFFING": "euphemistic for a fucking [n -S]\n",
  "EFFINGS": "EFFING, euphemistic for a fucking [n]\n",
  "EFFLEURAGE": "(French) a stroking movement in massage [n -S] / to make a stroking movement in massage [v EFFLEURAGED, EFFLEURAGING, EFFLEURAGES]\n",
  "EFFLEURAGED": "EFFLEURAGE, to make a stroking movement in massage [v]\n",
  "EFFLEURAGES": "EFFLEURAGE, (French) a stroking movement in massage [n]\n",
  "EFFLEURAGING": "EFFLEURAGE, to make a stroking movement in massage [v]\n",
  "EFFLORESCE": "to flower; burgeon; (chemistry) to become powder when exposed to air [v EFFLORESCED, EFFLORESCING, EFFLORESCES]\n",
  "EFFLORESCED": "EFFLORESCE, to flower; burgeon; (chemistry) to become powder when exposed to air [v]\n",
  "EFFLORESCENCE": "the act of developing and unfolding as if coming into flower [n -S]\n",
  "EFFLORESCENCES": "EFFLORESCENCE, the act of developing and unfolding as if coming into flower [n]\n",
  "EFFLORESCENT": "displaying efflorescence [adj]\n",
  "EFFLORESCES": "EFFLORESCE, to flower; burgeon; (chemistry) to become powder when exposed to air [v]\n",
  "EFFLORESCING": "EFFLORESCE, to flower; burgeon; (chemistry) to become powder when exposed to air [v]\n",
  "EFFLUENCE": "flowing out, emanation [n -S]\n",
  "EFFLUENCES": "EFFLUENCE, flowing out, emanation [n]\n",
  "EFFLUENT": "outflow from sewage [n -S]\n",
  "EFFLUENTS": "EFFLUENT, outflow from sewage [n]\n",
  "EFFLUVIA": "EFFLUVIUM, (Latin) disagreeable vapours [n]\n",
  "EFFLUVIAL": "of or like effluvia, an offensive exhalation or smell [adj]\n",
  "EFFLUVIUM": "(Latin) disagreeable vapours [n EFFLUVIUMS or EFFLUVIA]\n",
  "EFFLUVIUMS": "EFFLUVIUM, (Latin) disagreeable vapours [n]\n",
  "EFFLUX": "the act of flowing out, or issuing forth [n -ES]\n",
  "EFFLUXES": "EFFLUX, the act of flowing out, or issuing forth [n]\n",
  "EFFLUXION": "the act of flowing out [n -S]\n",
  "EFFLUXIONS": "EFFLUXION, the act of flowing out [n]\n",
  "EFFORCE": "(obsolete) to force [v EFFORCED, EFFORCING, EFFORCES]\n",
  "EFFORCED": "EFFORCE, (obsolete) to force [v]\n",
  "EFFORCES": "EFFORCE, (obsolete) to force [v]\n",
  "EFFORCING": "EFFORCE, (obsolete) to force [v]\n",
  "EFFORT": "a deliberate exertion [n -S]\n",
  "EFFORTFUL": "requiring effort [adj EFFORTFULLY]\n",
  "EFFORTFULLY": "EFFORTFUL, requiring effort [adv]\n",
  "EFFORTFULNESS": "EFFORTFUL, requiring effort [n]\n",
  "EFFORTFULNESSES": "EFFORTFULNESS, EFFORTFUL, requiring effort [n]\n",
  "EFFORTLESS": "showing or requiring little or no effort [adj EFFORTLESSLY]\n",
  "EFFORTLESSLY": "EFFORTLESS, showing or requiring little or no effort [adv]\n",
  "EFFORTLESSNESS": "EFFORTLESS, showing or requiring little or no effort [n]\n",
  "EFFORTS": "EFFORT, a deliberate exertion [n]\n",
  "EFFRAIDE": "(obsolete) afraid, also AFEARD, AFFEARD, AFRAID [adj]\n",
  "EFFRAY": "(obsolete) fright [n -S]\n",
  "EFFRAYS": "EFFRAY, (obsolete) fright [n]\n",
  "EFFRONTERIES": "EFFRONTERY, shameless boldness; presumptuousness [n]\n",
  "EFFRONTERY": "shameless boldness; presumptuousness [n EFFRONTERIES]\n",
  "EFFS": "EFF, euphemism for fuck [v]\n",
  "EFFULGE": "to shine out [v EFFULGED, EFFULGING, EFFULGES]\n",
  "EFFULGED": "EFFULGE, to shine out [v]\n",
  "EFFULGENCE": "radiant splendor [n -S]\n",
  "EFFULGENCES": "EFFULGENCE, radiant splendor [n]\n",
  "EFFULGENT": "radiant; bright [adj EFFULGENTLY]\n",
  "EFFULGENTLY": "EFFULGENT, radiant; bright [adv]\n",
  "EFFULGES": "EFFULGE, to shine out [v]\n",
  "EFFULGING": "EFFULGE, to shine out [v]\n",
  "EFFUSE": "to pour forth [v EFFUSED, EFFUSING, EFFUSES]\n",
  "EFFUSED": "EFFUSE, to pour forth [v]\n",
  "EFFUSES": "EFFUSE, to pour forth [v]\n",
  "EFFUSING": "EFFUSE, to pour forth [v]\n",
  "EFFUSIOMETER": "an instrument for comparing the molecular weights of gases [n -S]\n",
  "EFFUSIOMETERS": "EFFUSIOMETER, an instrument for comparing the molecular weights of gases [n]\n",
  "EFFUSION": "a pouring or streaming out [n -S]\n",
  "EFFUSIONS": "EFFUSION, a pouring or streaming out [n]\n",
  "EFFUSIVE": "pouring forth [adj EFFUSIVELY]\n",
  "EFFUSIVELY": "EFFUSIVE, pouring forth [adv]\n",
  "EFFUSIVENESS": "the state of being effusive [n -ES]\n",
  "EFFUSIVENESSES": "EFFUSIVENESS, the state of being effusive [n]\n",
  "EFS": "EF, the letter F [n]\n",
  "EFT": "a newt, also EVET, EWT [n -S]\n",
  "EFTEST": "(dialect) readiest, most convenient [adj]\n",
  "EFTS": "EFT, a newt, also EVET, EWT [n]\n",
  "EFTSOON": "soon afterward, also EFTSOONS [adv]\n",
  "EFTSOONS": "soon afterward, also EFTSOON [adv]\n",
  "EGAD": "(archaic) a mild oath, also ECOD, EGADS, IGAD [interj]\n",
  "EGADS": "a mild oath, also EGAD, ECOD, IGAD [interj]\n",
  "EGAL": "(Shakespeare) equal [adj EGALLY]\n",
  "EGALITARIAN": "a believer in egalitarianism [n -S]\n",
  "EGALITARIANISM": "a belief in human equality esp. with respect to social, political, and economic rights and privileges [n -S]\n",
  "EGALITARIANISMS": "EGALITARIANISM, a belief in human equality esp. with respect to social, political, and economic rights and privileges [n]\n",
  "EGALITARIANS": "EGALITARIAN, a believer in egalitarianism [n]\n",
  "EGALITE": "(French) the state of being equal, also EQUALITY, EGALITY [n -S]\n",
  "EGALITES": "EGALITE, (French) the state of being equal, also EQUALITY, EGALITY [n]\n",
  "EGALITIES": "EGALITY, the state of being equal, also EQUALITY, EGALITE [n]\n",
  "EGALITY": "the state of being equal, also EQUALITY, EGALITE [n EGALITIES]\n",
  "EGALLY": "(Shakespeare) in an equal way, also EQUALLY [adv]\n",
  "EGAREMENT": "(French) confusion, bewilderment [n -S]\n",
  "EGAREMENTS": "EGAREMENT, (French) confusion, bewilderment [n]\n",
  "EGENCE": "need, also EGENCY [n -S]\n",
  "EGENCES": "EGENCE, need, also EGENCY [n]\n",
  "EGENCIES": "EGENCY, need, also EGENCE [n]\n",
  "EGENCY": "need, also EGENCE [n EGENCIES]\n",
  "EGER": "a tidal flood, also EAGER, EAGRE [n -S]\n",
  "EGERS": "EGER, a tidal flood, also EAGER, EAGRE [n]\n",
  "EGEST": "to discharge from the body [v -ED, -ING, -S]\n",
  "EGESTA": "(Latin) egested matter [n]\n",
  "EGESTED": "EGEST, to discharge from the body [v]\n",
  "EGESTING": "EGEST, to discharge from the body [v]\n",
  "EGESTION": "the process of excretion from the body [n -S]\n",
  "EGESTIONS": "EGESTION, the process of excretion from the body [n]\n",
  "EGESTIVE": "able to be egested [adj]\n",
  "EGESTS": "EGEST, to discharge from the body [v]\n",
  "EGG": "to incite [v -ED, -ING, -S]\n",
  "EGGAR": "any of several large brown moths, also EGGER [n -S]\n",
  "EGGARS": "EGGAR, any of several large brown moths, also EGGER [n]\n",
  "EGGBEATER": "a utensil for beating eggs [n -S]\n",
  "EGGBEATERS": "EGGBEATER, a utensil for beating eggs [n]\n",
  "EGGCORN": "a malapropism or misspelling arising from similarity between the sound of the misspelled or misused word and the correct one in the accent of the person making the mistake [n -S]\n",
  "EGGCORNS": "EGGCORN, a malapropism or misspelling arising from similarity between the sound of the misspelled or misused word and the correct one in the accent of the person making the mistake [n]\n",
  "EGGCUP": "a cup which holds an egg [n -S]\n",
  "EGGCUPS": "EGGCUP, a cup which holds an egg [n]\n",
  "EGGED": "EGG, to incite [v]\n",
  "EGGER": "any of several large brown moths, also EGGAR [n -S]\n",
  "EGGERIES": "EGGERY, a place where eggs are laid [n]\n",
  "EGGERS": "EGGER, any of several large brown moths, also EGGAR [n]\n",
  "EGGERY": "a place where eggs are laid [n EGGERIES]\n",
  "EGGFRUIT": "an aubergine [n -S]\n",
  "EGGFRUITS": "EGGFRUIT, an aubergine [n]\n",
  "EGGHEAD": "an intellectual [n -S]\n",
  "EGGHEADED": "intellectual [adj]\n",
  "EGGHEADEDNESS": "the state of being eggheaded [n -ES]\n",
  "EGGHEADEDNESSES": "EGGHEADEDNESS, the state of being eggheaded [n]\n",
  "EGGHEADS": "EGGHEAD, an intellectual [n]\n",
  "EGGIER": "EGGY, containing eggs to some extent [adj]\n",
  "EGGIEST": "EGGY, containing eggs to some extent [adj]\n",
  "EGGING": "EGG, to incite [v]\n",
  "EGGLER": "(archaic) an egg-dealer [n -S]\n",
  "EGGLERS": "EGGLER, (archaic) an egg-dealer [n]\n",
  "EGGLESS": "without eggs [adj]\n",
  "EGGLIKE": "like an egg [adj]\n",
  "EGGMASS": "(colloquial) intellectuals as a group [n -ES]\n",
  "EGGMASSES": "EGGMASS, (colloquial) intellectuals as a group [n]\n",
  "EGGNOG": "a hot or cold alcoholic drink with added egg and usually milk [n -S]\n",
  "EGGNOGS": "EGGNOG, a hot or cold alcoholic drink with added egg and usually milk [n]\n",
  "EGGPLANT": "(US) the aubergine [n -S]\n",
  "EGGPLANTS": "EGGPLANT, (US) the aubergine [n]\n",
  "EGGS": "EGG, to incite [v]\n",
  "EGGSHELL": "the hard exterior of an egg [n -S]\n",
  "EGGSHELLS": "EGGSHELL, the hard exterior of an egg [n]\n",
  "EGGWASH": "a thin mixture of egg and milk used as a glaze for pastry [n -ES]\n",
  "EGGWASHES": "EGGWASH, a thin mixture of egg and milk used as a glaze for pastry [n]\n",
  "EGGWHISK": "a whisk for beating eggs [n -S]\n",
  "EGGWHISKS": "EGGWHISK, a whisk for beating eggs [n]\n",
  "EGGY": "containing eggs to some extent [adj EGGIER, EGGIEST]\n",
  "EGIS": "(Greek) protection, defense; patronage, also AEGIS [n -ES]\n",
  "EGISES": "EGIS, (Greek) protection, defense; patronage, also AEGIS [n]\n",
  "EGLANDULAR": "having no glands, also EGLANDULOSE [adj]\n",
  "EGLANDULOSE": "having no glands, also EGLANDULAR [adj]\n",
  "EGLANTINE": "sweetbriar, also EGLATERE [n -S]\n",
  "EGLANTINES": "EGLANTINE, sweetbriar, also EGLATERE [n]\n",
  "EGLATERE": "(archaic) sweetbriar, also EGLANTINE [n -S]\n",
  "EGLATERES": "EGLATERE, (archaic) sweetbriar, also EGLANTINE [n]\n",
  "EGLOMISE": "(French) the technique of gilding the back of a sheet of glass [n -S]\n",
  "EGLOMISES": "EGLOMISE, (French) the technique of gilding the back of a sheet of glass [n]\n",
  "EGMA": "(Shakespeare) an enigma, also ENIGMA [n -S]\n",
  "EGMAS": "EGMA, (Shakespeare) an enigma, also ENIGMA [n]\n",
  "EGO": "the 'I' or self [n -S]\n",
  "EGOCENTRIC": "concerned with the individual rather than society, also EGOCENTRICAL [adj EGOCENTRICALLY] / an egocentric person [n -S]\n",
  "EGOCENTRICAL": "concerned with the individual rather than society, also EGOCENTRIC [adj EGOCENTRICALLY]\n",
  "EGOCENTRICALLY": "EGOCENTRICAL, concerned with the individual rather than society, also EGOCENTRIC [adv]\n",
  "EGOCENTRICITIES": "EGOCENTRICITY, the state of being egocentric, also EGOCENTRISM [n]\n",
  "EGOCENTRICITY": "the state of being egocentric, also EGOCENTRISM [n EGOCENTRICITIES]\n",
  "EGOCENTRICS": "EGOCENTRIC, an egocentric person [n]\n",
  "EGOCENTRISM": "being egocentric, also EGOCENTRICITY [n -S]\n",
  "EGOCENTRISMS": "EGOCENTRISM, being egocentric, also EGOCENTRICITY [n]\n",
  "EGOISM": "the doctrine that the pursuit of self-interest is the highest good [n -S]\n",
  "EGOISMS": "EGOISM, the doctrine that the pursuit of self-interest is the highest good [n]\n",
  "EGOIST": "one who practices egoism [n -S]\n",
  "EGOISTIC": "relating to or displaying egoism, also EGOISTICAL, EGOTISTIC, EGOTISTICAL [adj EGOISTICALLY]\n",
  "EGOISTICAL": "relating to or displaying egoism, also EGOISTIC, EGOTISTIC, EGOTISTICAL [adj EGOISTICALLY]\n",
  "EGOISTICALLY": "EGOISTICAL, relating to or displaying egoism, also EGOISTIC, EGOTISTIC, EGOTISTICAL [adv]\n",
  "EGOISTS": "EGOIST, one who practices egoism [n]\n",
  "EGOITIES": "EGOITY, the essence of the ego [n]\n",
  "EGOITY": "the essence of the ego [n EGOITIES]\n",
  "EGOLESS": "not self-centered [adj]\n",
  "EGOMANIA": "extreme egotism [n -S]\n",
  "EGOMANIAC": "one suffering from egomania, excessive preoccupation with the self [n -S]\n",
  "EGOMANIACAL": "of or like an egomaniac [adj EGOMANIACALLY]\n",
  "EGOMANIACALLY": "EGOMANIACAL, of or like an egomaniac [adv]\n",
  "EGOMANIACS": "EGOMANIAC, one suffering from egomania, excessive preoccupation with the self [n]\n",
  "EGOMANIAS": "EGOMANIA, extreme egotism [n]\n",
  "EGOS": "EGO, the 'I' or self [n]\n",
  "EGOSURF": "to search for one's own name on the internet [v -ED, -ING, -S]\n",
  "EGOSURFED": "EGOSURF, to search for one's own name on the internet [v]\n",
  "EGOSURFING": "EGOSURF, to search for one's own name on the internet [v]\n",
  "EGOSURFS": "EGOSURF, to search for one's own name on the internet [v]\n",
  "EGOTHEISM": "identification of oneself with God [n -S]\n",
  "EGOTHEISMS": "EGOTHEISM, identification of oneself with God [n]\n",
  "EGOTISE": "to talk about oneself a lot, also EGOTIZE [v EGOTISED, EGOTISING, EGOTISES]\n",
  "EGOTISED": "EGOTISE, to talk about oneself a lot, also EGOTIZE [v]\n",
  "EGOTISES": "EGOTISE, to talk about oneself a lot, also EGOTIZE [v]\n",
  "EGOTISING": "EGOTISE, to talk about oneself a lot, also EGOTIZE [v]\n",
  "EGOTISM": "self-conceit [n -S]\n",
  "EGOTISMS": "EGOTISM, self-conceit [n]\n",
  "EGOTIST": "a conceited person [n -S]\n",
  "EGOTISTIC": "relating to or displaying egoism, also EGOISTIC, EGOISTICAL, EGOTISTICAL [adj EGOTISTICALLY]\n",
  "EGOTISTICAL": "relating to or displaying egoism, also EGOISTIC, EGOISTICAL, EGOTISTIC [adj EGOTISTICALLY]\n",
  "EGOTISTICALLY": "EGOTISTICAL, relating to or displaying egoism, also EGOISTIC, EGOISTICAL, EGOTISTIC [adv]\n",
  "EGOTISTS": "EGOTIST, a conceited person [n]\n",
  "EGOTIZE": "to talk about oneself a lot, also EGOTISE [v EGOTIZED, EGOTIZING, EGOTIZES]\n",
  "EGOTIZED": "EGOTIZE, to talk about oneself a lot, also EGOTISE [v]\n",
  "EGOTIZES": "EGOTIZE, to talk about oneself a lot, also EGOTISE [v]\n",
  "EGOTIZING": "EGOTIZE, to talk about oneself a lot, also EGOTISE [v]\n",
  "EGREGIOUS": "conspicuously bad or offensive [adj EGREGIOUSLY]\n",
  "EGREGIOUSLY": "EGREGIOUS, conspicuously bad or offensive [adv]\n",
  "EGREGIOUSNESS": "the state of being egregious [n -ES]\n",
  "EGREGIOUSNESSES": "EGREGIOUSNESS, the state of being egregious [n]\n",
  "EGRESS": "to go out [v -ED, -ING, -ES]\n",
  "EGRESSED": "EGRESS, to go out [v]\n",
  "EGRESSES": "EGRESS, to go out [v]\n",
  "EGRESSING": "EGRESS, to go out [v]\n",
  "EGRESSION": "the act of going out [n -S]\n",
  "EGRESSIONS": "EGRESSION, the act of going out [n]\n",
  "EGRESSIVE": "(of speech sounds) pronounced with exhalation of breath [adj] / an egressive speech sound [n -S]\n",
  "EGRESSIVES": "EGRESSIVE, an egressive speech sound [n]\n",
  "EGRET": "a wading bird of the heron family [n -S]\n",
  "EGRETS": "EGRET, a wading bird of the heron family [n]\n",
  "EGURGITATE": "to vomit, to cast forth [v EGURGITATED, EGURGITATING, EGURGITATES]\n",
  "EGURGITATED": "EGURGITATE, to vomit, to cast forth [v]\n",
  "EGURGITATES": "EGURGITATE, to vomit, to cast forth [v]\n",
  "EGURGITATING": "EGURGITATE, to vomit, to cast forth [v]\n",
  "EGYPTIAN": "a typeface with squared serifs [n -S]\n",
  "EGYPTIANS": "EGYPTIAN, a typeface with squared serifs [n]\n",
  "EH": "to say 'Eh', expressing enquiry [v -ED, -ING, -S]\n",
  "EHED": "EH, to say 'Eh', expressing enquiry [v]\n",
  "EHING": "EH, to say 'Eh', expressing enquiry [v]\n",
  "EHS": "EH, to say 'Eh', expressing enquiry [v]\n",
  "EICOSANOID": "any of a class of compounds derived from polyunsaturated acids [n -S]\n",
  "EICOSANOIDS": "EICOSANOID, any of a class of compounds derived from polyunsaturated acids [n]\n",
  "EIDE": "EIDOS, (Greek) the formal sum of a culture, its intellectual character, ideas [n]\n",
  "EIDENT": "(Scots) busy, diligent [adj]\n",
  "EIDER": "(Icelandic) a large sea duck [n -S]\n",
  "EIDERDOWN": "the soft down of the eider duck; a bedcover, usually quilted [n -S]\n",
  "EIDERDOWNS": "EIDERDOWN, the soft down of the eider duck; a bedcover, usually quilted [n]\n",
  "EIDERS": "EIDER, (Icelandic) a large sea duck [n]\n",
  "EIDETIC": "marked by or involving extraordinarily accurate and vivid recall [adj EIDETICALLY] / a person with eidetic recall [n -S]\n",
  "EIDETICALLY": "EIDETIC, marked by or involving extraordinarily accurate and vivid recall [adv]\n",
  "EIDETICS": "EIDETIC, a person with eidetic recall [n]\n",
  "EIDOGRAPH": "an instrument for copying drawings [n -S]\n",
  "EIDOGRAPHS": "EIDOGRAPH, an instrument for copying drawings [n]\n",
  "EIDOLA": "EIDOLON, (Greek) an unsubstantial image, a phantom, also IDOLON, IDOLUM [n]\n",
  "EIDOLIC": "like an eidolon, an unsubstantial image, a phantom [adj]\n",
  "EIDOLON": "(Greek) an unsubstantial image, a phantom, also IDOLON, IDOLUM [n EIDOLA or EIDOLONS]\n",
  "EIDOLONS": "EIDOLON, (Greek) an unsubstantial image, a phantom, also IDOLON, IDOLUM [n]\n",
  "EIDOS": "(Greek) the formal sum of a culture, its intellectual character, ideas [n EIDE]\n",
  "EIGENFREQUENCY": "a resonance frequency of a system [n]\n",
  "EIGENFUNCTION": "each of a set of independent functions which are the solutions to a given differential equation [n -S]\n",
  "EIGENFUNCTIONS": "EIGENFUNCTION, each of a set of independent functions which are the solutions to a given differential equation [n]\n",
  "EIGENMODE": "(German) a normal mode of vibration of an oscillating system [n -S]\n",
  "EIGENMODES": "EIGENMODE, (German) a normal mode of vibration of an oscillating system [n]\n",
  "EIGENTONE": "(German) a tone characteristic of a particular vibrating system [n -S]\n",
  "EIGENTONES": "EIGENTONE, (German) a tone characteristic of a particular vibrating system [n]\n",
  "EIGENVALUE": "a mathematical term relating to solutions of an equation [n -S]\n",
  "EIGENVALUES": "EIGENVALUE, a mathematical term relating to solutions of an equation [n]\n",
  "EIGENVECTOR": "a vector which when operated on by a given operator gives a scalar multiple of that vector [n -S]\n",
  "EIGENVECTORS": "EIGENVECTOR, a vector which when operated on by a given operator gives a scalar multiple of that vector [n]\n",
  "EIGHT": "the cardinal number one above seven [n -S]\n",
  "EIGHTBALL": "the black ball in pool [n -S]\n",
  "EIGHTBALLS": "EIGHTBALL, the black ball in pool [n]\n",
  "EIGHTEEN": "a number, ten and eight [n -S]\n",
  "EIGHTEENMO": "a paper size, aka octodecimo [n -S]\n",
  "EIGHTEENMOS": "EIGHTEENMO, a paper size, aka octodecimo [n]\n",
  "EIGHTEENS": "EIGHTEEN, a number, ten and eight [n]\n",
  "EIGHTEENTH": "number eighteen in sequence [adj EIGHTEENTHLY] / an eighteenth part [n -S]\n",
  "EIGHTEENTHLY": "EIGHTEENTH, number eighteen in sequence [adv]\n",
  "EIGHTEENTHS": "EIGHTEENTH, an eighteenth part [n]\n",
  "EIGHTFOIL": "an eight-leaved flower [n -S]\n",
  "EIGHTFOILS": "EIGHTFOIL, an eight-leaved flower [n]\n",
  "EIGHTFOLD": "multiplied by eight [adj]\n",
  "EIGHTFOOT": "measuring eight feet [adj]\n",
  "EIGHTH": "number eight in sequence [adj EIGHTHLY] / one of eight equal parts [n -S]\n",
  "EIGHTHLY": "in the eighth place [adv]\n",
  "EIGHTHS": "EIGHTH, one of eight equal parts [n]\n",
  "EIGHTIES": "EIGHTY, a number, eight times ten [n]\n",
  "EIGHTIETH": "number eighty in sequence [adj] / one of eighty equal parts [n -S]\n",
  "EIGHTIETHS": "EIGHTIETH, one of eighty equal parts [n]\n",
  "EIGHTPENCE": "a coin worth eight pence [n -S]\n",
  "EIGHTPENCES": "EIGHTPENCE, a coin worth eight pence [n]\n",
  "EIGHTPENNY": "worth eight pennies [adj]\n",
  "EIGHTS": "EIGHT, the cardinal number one above seven [n]\n",
  "EIGHTSCORE": "eight times twenty [n -S]\n",
  "EIGHTSCORES": "EIGHTSCORE, eight times twenty [n]\n",
  "EIGHTSMAN": "one of a crew or team of eight [n EIGHTSMEN]\n",
  "EIGHTSMEN": "EIGHTSMAN, one of a crew or team of eight [n]\n",
  "EIGHTSOME": "a group of eight [n -S]\n",
  "EIGHTSOMES": "EIGHTSOME, a group of eight [n]\n",
  "EIGHTVO": "a printer's page size, also OCTAVO [n -S]\n",
  "EIGHTVOS": "EIGHTVO, a printer's page size, also OCTAVO [n]\n",
  "EIGHTY": "a number, eight times ten [n EIGHTIES]\n",
  "EIGNE": "(archaic) first born [adj]\n",
  "EIK": "(Scots) to augment, also ECH, ECHE, EECH, EKE, ICH [v -ED, -ING, -S]\n",
  "EIKED": "EIK, (Scots) to augment, also ECH, ECHE, EECH, EKE, ICH [v]\n",
  "EIKING": "EIK, (Scots) to augment, also ECH, ECHE, EECH, EKE, ICH [v]\n",
  "EIKON": "(Greek) a religious carving of a saint etc., also ICON, IKON [n EIKONS or EIKONES]\n",
  "EIKONES": "EIKON, (Greek) a religious carving of a saint etc., also ICON, IKON [n]\n",
  "EIKONS": "EIKON, (Greek) a religious carving of a saint etc., also ICON, IKON [n]\n",
  "EIKS": "EIK, (Scots) to augment, also ECH, ECHE, EECH, EKE, ICH [v]\n",
  "EILD": "old age, also ELD [n -S]\n",
  "EILDING": "(Scots) fuel, also ELDIN, ELDING, YEALDON [n -S]\n",
  "EILDINGS": "EILDING, (Scots) fuel, also ELDIN, ELDING, YEALDON [n]\n",
  "EILDS": "EILD, old age, also ELD [n]\n",
  "EINA": "(South African) expressing sudden pain [interj]\n",
  "EINE": "(obsolete) eyes, also EYEN, EYNE [n]\n",
  "EINKORN": "(German) a variety of wheat [n -S]\n",
  "EINKORNS": "EINKORN, (German) a variety of wheat [n]\n",
  "EINSTEIN": "a very intelligent person [n -S]\n",
  "EINSTEINIUM": "a radioactive element produced artificially [n -S]\n",
  "EINSTEINIUMS": "EINSTEINIUM, a radioactive element produced artificially [n]\n",
  "EINSTEINS": "EINSTEIN, a very intelligent person [n]\n",
  "EIRACK": "(Gaelic) a young hen [n -S]\n",
  "EIRACKS": "EIRACK, (Gaelic) a young hen [n]\n",
  "EIRENIC": "conducive to or working toward peace, also EIRENICAL, IRENIC, IRENICAL [adj EIRENICALLY]\n",
  "EIRENICAL": "conducive to or working toward peace, also EIRENIC, IRENIC, IRENICAL [adj EIRENICALLY]\n",
  "EIRENICALLY": "EIRENICAL, conducive to or working toward peace, also EIRENIC, IRENIC, IRENICAL [adv]\n",
  "EIRENICON": "(Greek) a peacemaking message, a proposition for peace, also IRENICON [n -S]\n",
  "EIRENICONS": "EIRENICON, (Greek) a peacemaking message, a proposition for peace, also IRENICON [n]\n",
  "EIRENICS": "eirenical theology, concerned with promoting peace between churches [n]\n",
  "EISEGESES": "EISEGESIS, the interpretation of a text (as of the Bible) by reading into it one's own ideas [n]\n",
  "EISEGESIS": "the interpretation of a text (as of the Bible) by reading into it one's own ideas [n EISEGESES]\n",
  "EISEL": "(obsolete) sour wine resembling vinegar, also EISELL, ESILE [n -S]\n",
  "EISELL": "(obsolete) sour wine resembling vinegar, also EISEL, ESILE [n -S]\n",
  "EISELLS": "EISELL, (obsolete) sour wine resembling vinegar, also EISEL, ESILE [n]\n",
  "EISELS": "EISEL, (obsolete) sour wine resembling vinegar, also EISELL, ESILE [n]\n",
  "EISH": "(South African) expressing surprise, dismay [interj]\n",
  "EISTEDDFOD": "(Welsh) an annual assembly of Welsh poets and musicians [n EISTEDDFODAU or EISTEDDFODS]\n",
  "EISTEDDFODAU": "EISTEDDFOD, (Welsh) an annual assembly of Welsh poets and musicians [n]\n",
  "EISTEDDFODIC": "(Welsh) of or like an eisteddfod [adj]\n",
  "EISTEDDFODS": "EISTEDDFOD, (Welsh) an annual assembly of Welsh poets and musicians [n]\n",
  "EISWEIN": "(German) a sweet German wine made from grapes that have frozen on the vine, also ICEWINE [n -S]\n",
  "EISWEINS": "EISWEIN, (German) a sweet German wine made from grapes that have frozen on the vine, also ICEWINE [n]\n",
  "EITHER": "relating to one or the other, also OUTHER [adj]\n",
  "EJACULATE": "to exclaim, to eject [v EJACULATED, EJACULATING, EJACULATES]\n",
  "EJACULATED": "EJACULATE, to exclaim, to eject [v]\n",
  "EJACULATES": "EJACULATE, to exclaim, to eject [v]\n",
  "EJACULATING": "EJACULATE, to exclaim, to eject [v]\n",
  "EJACULATION": "an act of ejaculating [n -S]\n",
  "EJACULATIONS": "EJACULATION, an act of ejaculating [n]\n",
  "EJACULATIVE": "relating to ejaculation [adj]\n",
  "EJACULATOR": "one who ejaculates [n -S]\n",
  "EJACULATORS": "EJACULATOR, one who ejaculates [n]\n",
  "EJACULATORY": "marked by or given to vocal ejaculation [adj]\n",
  "EJECT": "to throw out forcibly [v -ED, -ING, -S]\n",
  "EJECTA": "material ejected esp. from a volcano, also EJECTAMENTA [n]\n",
  "EJECTABLE": "able to be ejected [adj]\n",
  "EJECTAMENTA": "material ejected esp. from a volcano, also EJECTA [n]\n",
  "EJECTED": "EJECT, to throw out forcibly [v]\n",
  "EJECTING": "EJECT, to throw out forcibly [v]\n",
  "EJECTION": "the act of ejecting [n -S]\n",
  "EJECTIONS": "EJECTION, the act of ejecting [n]\n",
  "EJECTIVE": "relating to ejection [adj EJECTIVELY] / a sound produced with air compressed above the closed glottis [n -S]\n",
  "EJECTIVELY": "EJECTIVE, relating to ejection [adv]\n",
  "EJECTIVES": "EJECTIVE, a sound produced with air compressed above the closed glottis [n]\n",
  "EJECTMENT": "expulsion; dispossession; an action for the recovery of the possession of land [n -S]\n",
  "EJECTMENTS": "EJECTMENT, expulsion; dispossession; an action for the recovery of the possession of land [n]\n",
  "EJECTOR": "one who, or that which, ejects or dispossesses [n -S]\n",
  "EJECTORS": "EJECTOR, one who, or that which, ejects or dispossesses [n]\n",
  "EJECTS": "EJECT, to throw out forcibly [v]\n",
  "EJIDO": "(Spanish) a piece of land farmed communally in Mexico [n -S]\n",
  "EJIDOS": "EJIDO, (Spanish) a piece of land farmed communally in Mexico [n]\n",
  "EKE": "to augment, also ECH, ECHE, EECH, EIK, ICH [v EKED, EKING, EKES]\n",
  "EKED": "EKE, to augment, also ECH, ECHE, EECH, EIK, ICH [v]\n",
  "EKES": "EKE, to augment, also ECH, ECHE, EECH, EIK, ICH [v]\n",
  "EKING": "EKE, to augment, also ECH, ECHE, EECH, EIK, ICH [v]\n",
  "EKISTIC": "relating to ekistics, the study of human settlements, also EKISTICAL [adj]\n",
  "EKISTICAL": "relating to ekistics, the study of human settlements, also EKISTIC [adj]\n",
  "EKISTICIAN": "a student of ekistics, the study of human settlements [n -S]\n",
  "EKISTICIANS": "EKISTICIAN, a student of ekistics, the study of human settlements [n]\n",
  "EKISTICS": "the study of human settlements [n]\n",
  "EKKA": "(Hindi) a small one-horse carriage [n -S]\n",
  "EKKAS": "EKKA, (Hindi) a small one-horse carriage [n]\n",
  "EKLOGITE": "a crystalline rock containing red garnet, also ECLOGITE [n -S]\n",
  "EKLOGITES": "EKLOGITE, a crystalline rock containing red garnet, also ECLOGITE [n]\n",
  "EKPHRASES": "EKPHRASIS, a literary description of or commentary on a visual work of art, also ECPHRASIS [n]\n",
  "EKPHRASIS": "a literary description of or commentary on a visual work of art, also ECPHRASIS [n EKPHRASES]\n",
  "EKPWELE": "a former monetary unit of Equatorial Guinea, also EKUELE [n -S]\n",
  "EKPWELES": "EKPWELE, a former monetary unit of Equatorial Guinea, also EKUELE [n]\n",
  "EKTEXINE": "an outer layer of the exine, the tough outer wall of a pollen grain [n -S]\n",
  "EKTEXINES": "EKTEXINE, an outer layer of the exine, the tough outer wall of a pollen grain [n]\n",
  "EKUELE": "a former monetary unit of Equatorial Guinea, also EKPWELE [n]\n",
  "EL": "(US) an elevated railroad [n -S]\n",
  "ELABORATE": "highly detailed [adj ELABORATELY] / to produce by labour [v ELABORATED, ELABORATING, ELABORATES]\n",
  "ELABORATED": "ELABORATE, to produce by labour [v]\n",
  "ELABORATELY": "ELABORATE, highly detailed [adv]\n",
  "ELABORATENESS": "ELABORATE, highly detailed [n]\n",
  "ELABORATENESSES": "ELABORATENESS, ELABORATE, highly detailed [n]\n",
  "ELABORATES": "ELABORATE, to produce by labour [v]\n",
  "ELABORATING": "ELABORATE, to produce by labour [v]\n",
  "ELABORATION": "the act of elaborating [n -S]\n",
  "ELABORATIONS": "ELABORATION, the act of elaborating [n]\n",
  "ELABORATIVE": "serving to elaborate [adj]\n",
  "ELABORATOR": "one who, or that which, elaborates [n -S]\n",
  "ELABORATORIES": "ELABORATORY, (obsolete) a laboratory, also LABORATORY [n]\n",
  "ELABORATORS": "ELABORATOR, one who, or that which, elaborates [n]\n",
  "ELABORATORY": "(obsolete) a laboratory, also LABORATORY [n ELABORATORIES]\n",
  "ELAEAGNUS": "another name for oleaster, a Eurasian shrub or small tree cultivated as an ornamental [n -ES]\n",
  "ELAEAGNUSES": "ELAEAGNUS, another name for oleaster, a Eurasian shrub or small tree cultivated as an ornamental [n]\n",
  "ELAEOLITE": "a variety of nephelite, usually massive, of greasy luster, and gray to reddish color [n -S]\n",
  "ELAEOLITES": "ELAEOLITE, a variety of nephelite, usually massive, of greasy luster, and gray to reddish color [n]\n",
  "ELAEOPTENE": "the liquid part of a volatile oil [n -S]\n",
  "ELAEOPTENES": "ELAEOPTENE, the liquid part of a volatile oil [n]\n",
  "ELAIN": "a glyceride of oleic acid, also OLEIN, OLEINE, TRIOLEIN [n -S]\n",
  "ELAINS": "ELAIN, a glyceride of oleic acid, also OLEIN, OLEINE, TRIOLEIN [n]\n",
  "ELAIOSOME": "an oil-rich body on seeds that attracts ants and thus effects seed dispersal [n -S]\n",
  "ELAIOSOMES": "ELAIOSOME, an oil-rich body on seeds that attracts ants and thus effects seed dispersal [n]\n",
  "ELAN": "(French) ardor inspired by passion or enthusiasm [n -S]\n",
  "ELANCE": "(French) to throw as a lance [v ELANCED, ELANCING, ELANCES]\n",
  "ELANCED": "ELANCE, (French) to throw as a lance [v]\n",
  "ELANCES": "ELANCE, (French) to throw as a lance [v]\n",
  "ELANCING": "ELANCE, (French) to throw as a lance [v]\n",
  "ELAND": "(Dutch) a large African antelope with spiral horns [n -S]\n",
  "ELANDS": "ELAND, (Dutch) a large African antelope with spiral horns [n]\n",
  "ELANET": "(Greek) a kite of the genus Elanus [n -S]\n",
  "ELANETS": "ELANET, (Greek) a kite of the genus Elanus [n]\n",
  "ELANS": "ELAN, (French) ardor inspired by passion or enthusiasm [n]\n",
  "ELAPHINE": "pertaining to a genus of deer [adj]\n",
  "ELAPID": "a kind of snake, including cobras, krait, taipan etc. [n -S]\n",
  "ELAPIDS": "ELAPID, a kind of snake, including cobras, krait, taipan etc. [n]\n",
  "ELAPINE": "like or pertaining to the Elapidae, a family of poisonous serpents, including the cobras [adj]\n",
  "ELAPSE": "to pass by [v ELAPSED, ELAPSING, ELAPSES]\n",
  "ELAPSED": "ELAPSE, to pass by [v]\n",
  "ELAPSES": "ELAPSE, to pass by [v]\n",
  "ELAPSING": "ELAPSE, to pass by [v]\n",
  "ELASMOBRANCH": "any member of the Elasmobranchii, that include sharks, rays, and skates [n -S]\n",
  "ELASMOBRANCHS": "ELASMOBRANCH, any member of the Elasmobranchii, that include sharks, rays, and skates [n]\n",
  "ELASMOSAUR": "a very long-necked extinct marine reptile, a type of plesiosaur [n -S]\n",
  "ELASMOSAURS": "ELASMOSAUR, a very long-necked extinct marine reptile, a type of plesiosaur [n]\n",
  "ELASTANCE": "the reciprocal of the capacity of a condenser, from its electromechanical analogy with a spring [n -S]\n",
  "ELASTANCES": "ELASTANCE, the reciprocal of the capacity of a condenser, from its electromechanical analogy with a spring [n]\n",
  "ELASTANE": "a synthetic fibre that retains its shape after being stretched [n -S]\n",
  "ELASTANES": "ELASTANE, a synthetic fibre that retains its shape after being stretched [n]\n",
  "ELASTASE": "an enzyme found in the pancreatic juice that decomposes elastin [n -S]\n",
  "ELASTASES": "ELASTASE, an enzyme found in the pancreatic juice that decomposes elastin [n]\n",
  "ELASTIC": "stretchy [adj ELASTICALLY] / a stretchable material [n -S]\n",
  "ELASTICALLY": "ELASTIC, stretchy [adv]\n",
  "ELASTICATE": "to make elastic [v ELASTICATED, ELASTICATING, ELASTICATES]\n",
  "ELASTICATED": "ELASTICATE, to make elastic [v]\n",
  "ELASTICATES": "ELASTICATE, to make elastic [v]\n",
  "ELASTICATING": "ELASTICATE, to make elastic [v]\n",
  "ELASTICATION": "the process of elasticating [n -S]\n",
  "ELASTICATIONS": "ELASTICATION, the process of elasticating [n]\n",
  "ELASTICISE": "to make elastic, also ELASTICIZE [v ELASTICISED, ELASTICISING, ELASTICISES]\n",
  "ELASTICISED": "ELASTICISE, to make elastic, also ELASTICIZE [v]\n",
  "ELASTICISES": "ELASTICISE, to make elastic, also ELASTICIZE [v]\n",
  "ELASTICISING": "ELASTICISE, to make elastic, also ELASTICIZE [v]\n",
  "ELASTICITIES": "ELASTICITY, the capability of a strained body to recover its size and shape after deformation [n]\n",
  "ELASTICITY": "the capability of a strained body to recover its size and shape after deformation [n ELASTICITIES]\n",
  "ELASTICIZE": "to make elastic, also ELASTICISE [v ELASTICIZED, ELASTICIZING, ELASTICIZES]\n",
  "ELASTICIZED": "made with elastic thread or inserts [adj]\n",
  "ELASTICIZES": "ELASTICIZE, to make elastic, also ELASTICISE [v]\n",
  "ELASTICIZING": "ELASTICIZE, to make elastic, also ELASTICISE [v]\n",
  "ELASTICNESS": "the state of being elastic [n -ES]\n",
  "ELASTICNESSES": "ELASTICNESS, the state of being elastic [n]\n",
  "ELASTICS": "ELASTIC, a stretchable material [n]\n",
  "ELASTIN": "a protein, the chief constituent of elastic tissue [n -S]\n",
  "ELASTINS": "ELASTIN, a protein, the chief constituent of elastic tissue [n]\n",
  "ELASTOMER": "any rubberlike substance [n -S]\n",
  "ELASTOMERIC": "relating to an elastomer [adj]\n",
  "ELASTOMERS": "ELASTOMER, any rubberlike substance [n]\n",
  "ELATE": "to raise the spirits of [v ELATED, ELATING, ELATES]\n",
  "ELATED": "ELATE, to raise the spirits of [v]\n",
  "ELATEDLY": "ELATED [adv]\n",
  "ELATEDNESS": "the state of being elated [n -ES]\n",
  "ELATEDNESSES": "ELATEDNESS, the state of being elated [n]\n",
  "ELATER": "a kind of beetle, aka skipjack beetle [n -S]\n",
  "ELATERID": "a click beetle, also ELATER [n -S]\n",
  "ELATERIDS": "ELATERID, a click beetle, also ELATER [n]\n",
  "ELATERIN": "a purgative produced from elaterium, a substance found in the juice of the squirting cucumber [n -S]\n",
  "ELATERINS": "ELATERIN, a purgative produced from elaterium, a substance found in the juice of the squirting cucumber [n]\n",
  "ELATERITE": "elastic bitumen, a rubberlike mineral resin [n -S]\n",
  "ELATERITES": "ELATERITE, elastic bitumen, a rubberlike mineral resin [n]\n",
  "ELATERIUM": "a substance contained in the juice of the fruit of the squirting cucumber, producing the purgative elaterin [n -S]\n",
  "ELATERIUMS": "ELATERIUM, a substance contained in the juice of the fruit of the squirting cucumber, producing the purgative elaterin [n]\n",
  "ELATERS": "ELATER, a kind of beetle, aka skipjack beetle [n]\n",
  "ELATES": "ELATE, to raise the spirits of [v]\n",
  "ELATING": "ELATE, to raise the spirits of [v]\n",
  "ELATION": "a feeling of great joy [n -S]\n",
  "ELATIONS": "ELATION, a feeling of great joy [n]\n",
  "ELATIVE": "a grammatical case indicating movement away from [n -S]\n",
  "ELATIVES": "ELATIVE, a grammatical case indicating movement away from [n]\n",
  "ELBOW": "to jostle [v -ED, -ING, -S]\n",
  "ELBOWED": "ELBOW, to jostle [v]\n",
  "ELBOWING": "the act of nudging with the elbow [n -S]\n",
  "ELBOWINGS": "ELBOWING, the act of nudging with the elbow [n]\n",
  "ELBOWROOM": "room to extend the elbows on each side; ample room for motion or action [n -S]\n",
  "ELBOWROOMS": "ELBOWROOM, room to extend the elbows on each side; ample room for motion or action [n]\n",
  "ELBOWS": "ELBOW, to jostle [v]\n",
  "ELCHEE": "(Turkish) an ambassador, also ELCHI, ELTCHI [n -S]\n",
  "ELCHEES": "ELCHEE, (Turkish) an ambassador, also ELCHI, ELTCHI [n]\n",
  "ELCHI": "(Turkish) an ambassador, also ELCHEE, ELTCHI [n -S]\n",
  "ELCHIS": "ELCHI, (Turkish) an ambassador, also ELCHEE, ELTCHI [n]\n",
  "ELD": "(archaic) old age, also EILD [n -S]\n",
  "ELDER": "a kind of shrub or small tree bearing white flowers and black berries [n -S]\n",
  "ELDERBERRIES": "ELDERBERRY, the fruit of the elder, used in winemaking [n]\n",
  "ELDERBERRY": "the fruit of the elder, used in winemaking [n ELDERBERRIES]\n",
  "ELDERCARE": "care of the elderly [n -S]\n",
  "ELDERCARES": "ELDERCARE, care of the elderly [n]\n",
  "ELDERFLOWER": "the flower of the elder [n -S]\n",
  "ELDERFLOWERS": "ELDERFLOWER, the flower of the elder [n]\n",
  "ELDERLIES": "ELDERLY, older people [n]\n",
  "ELDERLINESS": "the state of being elderly [n -ES]\n",
  "ELDERLINESSES": "ELDERLINESS, the state of being elderly [n]\n",
  "ELDERLY": "older people [n ELDERLIES]\n",
  "ELDERS": "ELDER, a kind of shrub or small tree bearing white flowers and black berries [n]\n",
  "ELDERSHIP": "the state of being older; seniority [n -S]\n",
  "ELDERSHIPS": "ELDERSHIP, the state of being older; seniority [n]\n",
  "ELDEST": "the oldest of a set of e.g. children [n -S]\n",
  "ELDESTS": "ELDEST, the oldest of a set of e.g. children [n]\n",
  "ELDIN": "(Scots) fuel, also EILDING, ELDING, YEALDON [n -S]\n",
  "ELDING": "(Scots) fuel, also ELDIN, EILDING, YEALDON [n -S]\n",
  "ELDINGS": "ELDING, (Scots) fuel, also ELDIN, EILDING, YEALDON [n]\n",
  "ELDINS": "ELDIN, (Scots) fuel, also EILDING, ELDING, YEALDON [n]\n",
  "ELDORADO": "a place of fabulous riches [n -S]\n",
  "ELDORADOS": "ELDORADO, a place of fabulous riches [n]\n",
  "ELDRESS": "a female church elder [n -ES]\n",
  "ELDRESSES": "ELDRESS, a female church elder [n]\n",
  "ELDRICH": "weird, also ELDRITCH [adj]\n",
  "ELDRITCH": "weird, also ELDRICH [adj]\n",
  "ELDS": "ELD, (archaic) old age, also EILD [n]\n",
  "ELECAMPANE": "a composite plant formerly much cultivated for its medicinal root, also ALYCOMPAINE [n -S]\n",
  "ELECAMPANES": "ELECAMPANE, a composite plant formerly much cultivated for its medicinal root, also ALYCOMPAINE [n]\n",
  "ELECT": "to select by vote [v -ED, -ING, -S]\n",
  "ELECTABILITIES": "ELECTABILITY, the state of being electable [n]\n",
  "ELECTABILITY": "the state of being electable [n ELECTABILITIES]\n",
  "ELECTABLE": "capable of being elected [adj]\n",
  "ELECTED": "ELECT, to select by vote [v]\n",
  "ELECTEE": "a person who has been elected [n -S]\n",
  "ELECTEES": "ELECTEE, a person who has been elected [n]\n",
  "ELECTING": "ELECT, to select by vote [v]\n",
  "ELECTION": "the act of electing [n -S]\n",
  "ELECTIONEER": "to take an active part in an election [v -ED, -ING, -S]\n",
  "ELECTIONEERED": "ELECTIONEER, to take an active part in an election [v]\n",
  "ELECTIONEERER": "one who works to secure the election of a candidate [n -S]\n",
  "ELECTIONEERERS": "ELECTIONEERER, one who works to secure the election of a candidate [n]\n",
  "ELECTIONEERING": "the act of canvassing for votes [n -S]\n",
  "ELECTIONEERINGS": "ELECTIONEERING, the act of canvassing for votes [n]\n",
  "ELECTIONEERS": "ELECTIONEER, to take an active part in an election [v]\n",
  "ELECTIONS": "ELECTION, the act of electing [n]\n",
  "ELECTIVE": "concerning the power of choice [adj ELECTIVELY] / an optional course of study [n -S]\n",
  "ELECTIVELY": "ELECTIVE, concerning the power of choice [adv]\n",
  "ELECTIVENESS": "the state of being elective [n -ES]\n",
  "ELECTIVENESSES": "ELECTIVENESS, the state of being elective [n]\n",
  "ELECTIVES": "ELECTIVE, an optional course of study [n]\n",
  "ELECTIVITIES": "ELECTIVITY, the state of being elective [n]\n",
  "ELECTIVITY": "the state of being elective [n ELECTIVITIES]\n",
  "ELECTOR": "one that elects [n -S]\n",
  "ELECTORAL": "relating to elections or electors, also ELECTORIAL [adj ELECTORALLY]\n",
  "ELECTORALLY": "ELECTORAL, relating to elections or electors, also ELECTORIAL [adv]\n",
  "ELECTORATE": "the territory, jurisdiction, or dignity of a German elector [n -S]\n",
  "ELECTORATES": "ELECTORATE, the territory, jurisdiction, or dignity of a German elector [n]\n",
  "ELECTORESS": "the wife or widow of an elector in the old German empire, also ELECTRESS [n -ES]\n",
  "ELECTORESSES": "ELECTORESS, the wife or widow of an elector in the old German empire, also ELECTRESS [n]\n",
  "ELECTORIAL": "relating to elections or electors, also ELECTORAL [adj]\n",
  "ELECTORIALLY": "ELECTORIAL, relating to elections or electors, also ELECTORAL [adv]\n",
  "ELECTORS": "ELECTOR, one that elects [n]\n",
  "ELECTORSHIP": "the electorate [n -S]\n",
  "ELECTORSHIPS": "ELECTORSHIP, the electorate [n]\n",
  "ELECTRESS": "the wife or widow of an elector in the old German empire, also ELECTORESS [n -ES]\n",
  "ELECTRESSES": "ELECTRESS, the wife or widow of an elector in the old German empire, also ELECTORESS [n]\n",
  "ELECTRET": "a nonconductor having permanent positive and negative poles [n -S]\n",
  "ELECTRETS": "ELECTRET, a nonconductor having permanent positive and negative poles [n]\n",
  "ELECTRIC": "relating to electricity [adj ELECTRICALLY] / an electric vehicle, machine etc. [n -S]\n",
  "ELECTRICAL": "relating to electricity [adj ELECTRICALLY]\n",
  "ELECTRICALLY": "ELECTRICAL, relating to electricity [adv]\n",
  "ELECTRICALS": "electrical equipment [n]\n",
  "ELECTRICIAN": "one who installs, maintains, operates, or repairs electrical equipment [n -S]\n",
  "ELECTRICIANS": "ELECTRICIAN, one who installs, maintains, operates, or repairs electrical equipment [n]\n",
  "ELECTRICITIES": "ELECTRICITY, the manifestation of a form of energy associated with separation or movement of charged particles, such as electrons and protons [n]\n",
  "ELECTRICITY": "the manifestation of a form of energy associated with separation or movement of charged particles, such as electrons and protons [n ELECTRICITIES]\n",
  "ELECTRICS": "ELECTRIC, an electric vehicle, machine etc. [n]\n",
  "ELECTRIFIABLE": "capable of being electrified [adj]\n",
  "ELECTRIFICATION": "an act of electrifying [n]\n",
  "ELECTRIFIED": "ELECTRIFY, to charge with electricity [v]\n",
  "ELECTRIFIER": "something or someone that electrifies [n -S]\n",
  "ELECTRIFIERS": "ELECTRIFIER, something or someone that electrifies [n]\n",
  "ELECTRIFIES": "ELECTRIFY, to charge with electricity [v]\n",
  "ELECTRIFY": "to charge with electricity [v ELECTRIFIED, ELECTRIFYING, ELECTRIFIES]\n",
  "ELECTRIFYING": "ELECTRIFY, to charge with electricity [v]\n",
  "ELECTRIFYINGLY": "in the manner of being charged with electricity [adv]\n",
  "ELECTRISATION": "the act of electrifying, also ELECTRIZATION [n -S]\n",
  "ELECTRISATIONS": "ELECTRISATION, the act of electrifying, also ELECTRIZATION [n]\n",
  "ELECTRISE": "to make electric, also ELECTRIZE [v ELECTRISED, ELECTRISING, ELECTRISES]\n",
  "ELECTRISED": "ELECTRISE, to make electric, also ELECTRIZE [v]\n",
  "ELECTRISES": "ELECTRISE, to make electric, also ELECTRIZE [v]\n",
  "ELECTRISING": "ELECTRISE, to make electric, also ELECTRIZE [v]\n",
  "ELECTRIZATION": "the act of electrifying, also ELECTRISATION [n -S]\n",
  "ELECTRIZATIONS": "ELECTRIZATION, the act of electrifying, also ELECTRISATION [n]\n",
  "ELECTRIZE": "to make electric, also ELECTRISE [v ELECTRIZED, ELECTRIZING, ELECTRIZES]\n",
  "ELECTRIZED": "ELECTRIZE, to make electric, also ELECTRISE [v]\n",
  "ELECTRIZES": "ELECTRIZE, to make electric, also ELECTRISE [v]\n",
  "ELECTRIZING": "ELECTRIZE, to make electric, also ELECTRISE [v]\n",
  "ELECTRO": "to make an electroplate for printing [v -ED, -ING, -S]\n",
  "ELECTROACOUSTIC": "relating to electroacoustics, the technology of converting acoustic energy into electrical energy and vice versa [adj]\n",
  "ELECTROACTIVE": "as in electroactive polymers, polymers whose shape is modified when a voltage is applied to them [adj]\n",
  "ELECTROACTIVITY": "the state of being electroactive [n]\n",
  "ELECTROANALYSES": "ELECTROANALYSIS, electrochemical analysis [n]\n",
  "ELECTROANALYSIS": "electrochemical analysis [n ELECTROANALYSES]\n",
  "ELECTROANALYTIC": "related to electroanalysis, electrochemical analysis [adj]\n",
  "ELECTROBIOLOGY": "the science of the electrical phenomena in living organisms [n]\n",
  "ELECTROCAUTERY": "a handheld, needlelike cautery heated by an electric current [n]\n",
  "ELECTROCEMENT": "cement made in an electric furnace by adding lime to molten slag [n -S]\n",
  "ELECTROCEMENTS": "ELECTROCEMENT, cement made in an electric furnace by adding lime to molten slag [n]\n",
  "ELECTROCHEMIC": "related to the study of the relation between electricity and chemical change, also ELECTROCHEMICAL [adj]\n",
  "ELECTROCHEMICAL": "related to the study of the relation between electricity and chemical change, also ELECTROCHEMIC [adj]\n",
  "ELECTROCHEMIST": "one who studies the relation between electricity and chemical change [n -S]\n",
  "ELECTROCHEMISTS": "ELECTROCHEMIST, one who studies the relation between electricity and chemical change [n]\n",
  "ELECTROCLASH": "a type of electronic music [n -ES]\n",
  "ELECTROCLASHES": "ELECTROCLASH, a type of electronic music [n]\n",
  "ELECTROCULTURE": "the cultivation of plants under the stimulus of electricity [n -S]\n",
  "ELECTROCULTURES": "ELECTROCULTURE, the cultivation of plants under the stimulus of electricity [n]\n",
  "ELECTROCUTE": "to execute (a criminal) by electricity [v ELECTROCUTED, ELECTROCUTING, ELECTROCUTES]\n",
  "ELECTROCUTED": "ELECTROCUTE, to execute (a criminal) by electricity [v]\n",
  "ELECTROCUTES": "ELECTROCUTE, to execute (a criminal) by electricity [v]\n",
  "ELECTROCUTING": "ELECTROCUTE, to execute (a criminal) by electricity [v]\n",
  "ELECTROCUTION": "execution by electricity [n -S]\n",
  "ELECTROCUTIONS": "ELECTROCUTION, execution by electricity [n]\n",
  "ELECTROCYTE": "a specialized muscle or nerve cell that generates electricity [n -S]\n",
  "ELECTROCYTES": "ELECTROCYTE, a specialized muscle or nerve cell that generates electricity [n]\n",
  "ELECTRODE": "a conductor by which a current of electricity enters or leaves an electrolytic cell [n -S]\n",
  "ELECTRODEPOSIT": "a deposit (as of metal or rubber) made by electrolysis [n -S]\n",
  "ELECTRODEPOSITS": "ELECTRODEPOSIT, a deposit (as of metal or rubber) made by electrolysis [n]\n",
  "ELECTRODERMAL": "of or relating to electrical activity in or electrical properties of the skin [adj]\n",
  "ELECTRODES": "ELECTRODE, a conductor by which a current of electricity enters or leaves an electrolytic cell [n]\n",
  "ELECTRODIALYSES": "ELECTRODIALYSIS, the use of an electric field to speed up membranal diffusion [n]\n",
  "ELECTRODIALYSIS": "the use of an electric field to speed up membranal diffusion [n ELECTRODIALYSES]\n",
  "ELECTRODIALYTIC": "relating to electrodialysis [adj]\n",
  "ELECTRODYNAMIC": "relating to electrodynamics [adj]\n",
  "ELECTRODYNAMICS": "a branch of physics that deals with the effects arising from the interactions of electric currents with magnets, with other currents, or with themselves [n]\n",
  "ELECTROED": "ELECTRO, to make an electroplate for printing [v]\n",
  "ELECTROFISHING": "fishing by stunning fish with electric shock [n -S]\n",
  "ELECTROFISHINGS": "ELECTROFISHING, fishing by stunning fish with electric shock [n]\n",
  "ELECTROFLUOR": "a transparent material that stores electrical energy and subsequently releases it as light [n -S]\n",
  "ELECTROFLUORS": "ELECTROFLUOR, a transparent material that stores electrical energy and subsequently releases it as light [n]\n",
  "ELECTROFORM": "to form (shaped articles) by electrodeposition on a mold [v -ED, -ING, -S]\n",
  "ELECTROFORMED": "ELECTROFORM, to form (shaped articles) by electrodeposition on a mold [v]\n",
  "ELECTROFORMING": "forming (shaped articles) by electrodeposition on a mould [n -S]\n",
  "ELECTROFORMINGS": "ELECTROFORMING, forming (shaped articles) by electrodeposition on a mould [n]\n",
  "ELECTROFORMS": "ELECTROFORM, to form (shaped articles) by electrodeposition on a mold [v]\n",
  "ELECTROGEN": "a molecule which emits electrons when it is illuminated [n -S]\n",
  "ELECTROGENESES": "ELECTROGENESIS, the production of electricity [n]\n",
  "ELECTROGENESIS": "the production of electricity [n ELECTROGENESES]\n",
  "ELECTROGENIC": "of or relating to the production of electrical activity in living tissue [adj]\n",
  "ELECTROGENS": "ELECTROGEN, a molecule which emits electrons when it is illuminated [n]\n",
  "ELECTROGILDING": "electroplating with gold [n -S]\n",
  "ELECTROGILDINGS": "ELECTROGILDING, electroplating with gold [n]\n",
  "ELECTROGRAM": "a tracing of the electrical potentials of a tissue (as the brain or heart) made by means of electrodes placed directly in the tissue instead of on the surface of the body [n -S]\n",
  "ELECTROGRAMS": "ELECTROGRAM, a tracing of the electrical potentials of a tissue (as the brain or heart) made by means of electrodes placed directly in the tissue instead of on the surface of the body [n]\n",
  "ELECTROGRAPH": "an instrument for recording electrical potential [n -S]\n",
  "ELECTROGRAPHIC": "relating to electrography [adj]\n",
  "ELECTROGRAPHIES": "ELECTROGRAPHY, the use of an electrograph, an instrument for recording electrical potential [n]\n",
  "ELECTROGRAPHS": "ELECTROGRAPH, an instrument for recording electrical potential [n]\n",
  "ELECTROGRAPHY": "the use of an electrograph, an instrument for recording electrical potential [n ELECTROGRAPHIES]\n",
  "ELECTROING": "ELECTRO, to make an electroplate for printing [v]\n",
  "ELECTROJET": "an overhead concentration of electric current found in the region of strong auroral displays [n -S]\n",
  "ELECTROJETS": "ELECTROJET, an overhead concentration of electric current found in the region of strong auroral displays [n]\n",
  "ELECTROKINETIC": "of or relating to the motion of particles or liquids that results from or produces a difference of electric potential [adj]\n",
  "ELECTROKINETICS": "a branch of physics dealing with the motion of electric currents or charged particles [n]\n",
  "ELECTROLESS": "being or involving deposition of metal by chemical means instead of by electrodeposition [adj]\n",
  "ELECTROLIER": "a chandelier for electric lamps [n -S]\n",
  "ELECTROLIERS": "ELECTROLIER, a chandelier for electric lamps [n]\n",
  "ELECTROLOGIES": "ELECTROLOGY, the study of electricity [n]\n",
  "ELECTROLOGIST": "one who removes body hair [n -S]\n",
  "ELECTROLOGISTS": "ELECTROLOGIST, one who removes body hair [n]\n",
  "ELECTROLOGY": "the study of electricity [n ELECTROLOGIES]\n",
  "ELECTROLYSATION": "the act of electrolysing, also ELECTROLYZATION [n]\n",
  "ELECTROLYSE": "to subject to electrolysis, also ELECTROLYZE [v ELECTROLYSED, ELECTROLYSING, ELECTROLYSES]\n",
  "ELECTROLYSED": "ELECTROLYSE, to subject to electrolysis, also ELECTROLYZE [v]\n",
  "ELECTROLYSER": "something that electrolyses [n -S]\n",
  "ELECTROLYSERS": "ELECTROLYSER, something that electrolyses [n]\n",
  "ELECTROLYSES": "ELECTROLYSE, to subject to electrolysis, also ELECTROLYZE [v]\n",
  "ELECTROLYSING": "ELECTROLYSE, to subject to electrolysis, also ELECTROLYZE [v]\n",
  "ELECTROLYSIS": "the producing of chemical changes by passage of an electric current through an electrolyte [n ELECTROLYSES]\n",
  "ELECTROLYTE": "a nonmetallic electric conductor in which current is carried by the movement of ions [n -S]\n",
  "ELECTROLYTES": "ELECTROLYTE, a nonmetallic electric conductor in which current is carried by the movement of ions [n]\n",
  "ELECTROLYTIC": "of or relating to electrolysis or an electrolyte [adj] / a small capacitor consisting of two electrodes separated by an electrolyte [n -S]\n",
  "ELECTROLYTICS": "ELECTROLYTIC, a small capacitor consisting of two electrodes separated by an electrolyte [n]\n",
  "ELECTROLYZATION": "the act of electrolyzing, also ELECTROLYSATION [n]\n",
  "ELECTROLYZE": "to subject to electrolysis, also ELECTROLYSE [v ELECTROLYZED, ELECTROLYZING, ELECTROLYZES]\n",
  "ELECTROLYZED": "ELECTROLYZE, to subject to electrolysis, also ELECTROLYSE [v]\n",
  "ELECTROLYZER": "an agent for electrolyzing [n -S]\n",
  "ELECTROLYZERS": "ELECTROLYZER, an agent for electrolyzing [n]\n",
  "ELECTROLYZES": "ELECTROLYZE, to subject to electrolysis, also ELECTROLYSE [v]\n",
  "ELECTROLYZING": "ELECTROLYZE, to subject to electrolysis, also ELECTROLYSE [v]\n",
  "ELECTROMAGNET": "a core of magnetic material surrounded by a coil of wire through which an electric current is passed to magnetize the core [n -S]\n",
  "ELECTROMAGNETIC": "of, relating to, or produced by electromagnetism [adj]\n",
  "ELECTROMAGNETS": "ELECTROMAGNET, a core of magnetic material surrounded by a coil of wire through which an electric current is passed to magnetize the core [n]\n",
  "ELECTROMER": "a substance showing electromerism [n -S]\n",
  "ELECTROMERIC": "of or like an electromer, a substance showing electromerism [adj]\n",
  "ELECTROMERISM": "the ionization of gases [n -S]\n",
  "ELECTROMERISMS": "ELECTROMERISM, the ionization of gases [n]\n",
  "ELECTROMERS": "ELECTROMER, a substance showing electromerism [n]\n",
  "ELECTROMETER": "an instrument for measuring electrical potential [n -S]\n",
  "ELECTROMETERS": "ELECTROMETER, an instrument for measuring electrical potential [n]\n",
  "ELECTROMETRIC": "relating to an electrometer, an instrument for measuring electrical potential, also ELECTROMETRICAL [adj]\n",
  "ELECTROMETRICAL": "relating to an electrometer, an instrument for measuring electrical potential, also ELECTROMETRIC [adj]\n",
  "ELECTROMETRIES": "ELECTROMETRY, the science of electrical measurements [n]\n",
  "ELECTROMETRY": "the science of electrical measurements [n ELECTROMETRIES]\n",
  "ELECTROMOTANCE": "the force of an electric current [n -S]\n",
  "ELECTROMOTANCES": "ELECTROMOTANCE, the force of an electric current [n]\n",
  "ELECTROMOTIVE": "pertaining to electric motion; causing electric current [adj]\n",
  "ELECTROMOTOR": "a device for applying electricity as a motive power [n -S]\n",
  "ELECTROMOTORS": "ELECTROMOTOR, a device for applying electricity as a motive power [n]\n",
  "ELECTROMYOGRAM": "a tracing made by an electromyograph [n -S]\n",
  "ELECTROMYOGRAMS": "ELECTROMYOGRAM, a tracing made by an electromyograph [n]\n",
  "ELECTROMYOGRAPH": "an instrument for diagnosing neuromuscular disorders [n]\n",
  "ELECTRON": "an elementary particle [n -S]\n",
  "ELECTRONEGATIVE": "having a tendency to attract electrons [adj]\n",
  "ELECTRONIC": "of or relating to electrons [adj ELECTRONICALLY]\n",
  "ELECTRONICA": "dance music featuring extensive use of synthesizers, electronic percussion, and samples of recorded music or sound [n -S]\n",
  "ELECTRONICALLY": "ELECTRONIC, of or relating to electrons [adv]\n",
  "ELECTRONICAS": "ELECTRONICA, dance music featuring extensive use of synthesizers, electronic percussion, and samples of recorded music or sound [n]\n",
  "ELECTRONICS": "a branch of physics that deals with the emission, behavior, and effects of electrons (as in electron tubes and transistors) and with electronic devices [n]\n",
  "ELECTRONS": "ELECTRON, an elementary particle [n]\n",
  "ELECTRONVOLT": "a unit of energy equal to the work done on an electron accelerated through a potential difference of 1 volt [n -S]\n",
  "ELECTRONVOLTS": "ELECTRONVOLT, a unit of energy equal to the work done on an electron accelerated through a potential difference of 1 volt [n]\n",
  "ELECTROOSMOSES": "ELECTROOSMOSIS, the movement of a liquid out of or through a porous material or a biological membrane under the influence of an electric field [n]\n",
  "ELECTROOSMOSIS": "the movement of a liquid out of or through a porous material or a biological membrane under the influence of an electric field [n ELECTROOSMOSES]\n",
  "ELECTROOSMOTIC": "relating to electroosmosis [adj]\n",
  "ELECTROPHILE": "an electrophilic substance, such as an electron-accepting reagent [n -S]\n",
  "ELECTROPHILES": "ELECTROPHILE, an electrophilic substance, such as an electron-accepting reagent [n]\n",
  "ELECTROPHILIC": "having an affinity for electrons [adj]\n",
  "ELECTROPHONE": "any instrument whose sound is produced by the oscillation of an electric current, such as an electronic organ, synthesizer, etc. [n -S]\n",
  "ELECTROPHONES": "ELECTROPHONE, any instrument whose sound is produced by the oscillation of an electric current, such as an electronic organ, synthesizer, etc. [n]\n",
  "ELECTROPHONIC": "of or like an electrophone [adj]\n",
  "ELECTROPHORESE": "to subject to electrophoresis [v ELECTROPHORESED, ELECTROPHORESES]\n",
  "ELECTROPHORESED": "ELECTROPHORESE, to subject to electrophoresis [v]\n",
  "ELECTROPHORESES": "ELECTROPHORESE, to subject to electrophoresis [v]\n",
  "ELECTROPHORESIS": "the use of an electric field to move chemicals [n ELECTROPHORESES]\n",
  "ELECTROPHORETIC": "relating to electrophoresis [adj]\n",
  "ELECTROPHORI": "ELECTROPHORUS, an apparatus consisting of a disk and metal plate to demonstrate static electricity [n]\n",
  "ELECTROPHORUS": "an apparatus consisting of a disk and metal plate to demonstrate static electricity [n ELECTROPHORI or ELECTROPHORUSES]\n",
  "ELECTROPHORUSES": "ELECTROPHORUS, an apparatus consisting of a disk and metal plate to demonstrate static electricity [n]\n",
  "ELECTROPLATE": "to plate with an adherent continuous coating by electrodeposition [v ELECTROPLATED, ELECTROPLATING, ELECTROPLATES]\n",
  "ELECTROPLATED": "ELECTROPLATE, to plate with an adherent continuous coating by electrodeposition [v]\n",
  "ELECTROPLATER": "one who electroplates [n -S]\n",
  "ELECTROPLATERS": "ELECTROPLATER, one who electroplates [n]\n",
  "ELECTROPLATES": "ELECTROPLATE, to plate with an adherent continuous coating by electrodeposition [v]\n",
  "ELECTROPLATING": "the act of electroplating [n -S]\n",
  "ELECTROPLATINGS": "ELECTROPLATING, the act of electroplating [n]\n",
  "ELECTROPOLAR": "having, as an electrical conductor, one end or surface positive and the other negative [adj]\n",
  "ELECTROPOP": "a genre of pop music characterized by the use of synthesizers to replace guitars and drums [n -S]\n",
  "ELECTROPOPS": "ELECTROPOP, a genre of pop music characterized by the use of synthesizers to replace guitars and drums [n]\n",
  "ELECTROPOSITIVE": "positively charged; passing to cathode in electrolysis [adj]\n",
  "ELECTROPUNCTURE": "the insertion into the body of one or more needles through which an electric current is passed [n]\n",
  "ELECTRORECEPTOR": "an organ, present in some fishes, that detects electrical discharges [n]\n",
  "ELECTRORHEOLOGY": "the study of the flow of fluids under the influence of electric fields [n]\n",
  "ELECTROS": "ELECTRO, to make an electroplate for printing [v]\n",
  "ELECTROSCOPE": "an instrument for detecting electrical charges in the body [n -S]\n",
  "ELECTROSCOPES": "ELECTROSCOPE, an instrument for detecting electrical charges in the body [n]\n",
  "ELECTROSCOPIC": "of or like an electroscope, an instrument for detecting electrical charges in the body [adj]\n",
  "ELECTROSHOCK": "an electric shock [n -S]\n",
  "ELECTROSHOCKS": "ELECTROSHOCK, an electric shock [n]\n",
  "ELECTROSONDE": "a sonde for measuring atmospheric electricity [n -S]\n",
  "ELECTROSONDES": "ELECTROSONDE, a sonde for measuring atmospheric electricity [n]\n",
  "ELECTROSTATIC": "of or relating to static electricity or electrostatics [adj]\n",
  "ELECTROSTATICS": "the study of static electricity [n]\n",
  "ELECTROSURGERY": "surgery by means of diathermy [n]\n",
  "ELECTROSURGICAL": "relating to electrosurgery [adj]\n",
  "ELECTROTECHNICS": "electrical technology [n]\n",
  "ELECTROTHERAPY": "the therapeutic use of electricity [n]\n",
  "ELECTROTHERMAL": "of or relating to electricity and heat, or heat obtained electrically, also ELECTROTHERMIC [adj]\n",
  "ELECTROTHERMIC": "of or relating to electricity and heat, or heat obtained electrically, also ELECTROTHERMAL [adj]\n",
  "ELECTROTHERMICS": "the study of electricity and heat, or heat obtained electrically [n]\n",
  "ELECTROTHERMIES": "ELECTROTHERMY, the study of electricity and heat, or heat obtained electrically [n]\n",
  "ELECTROTHERMY": "the study of electricity and heat, or heat obtained electrically [n ELECTROTHERMIES]\n",
  "ELECTROTINT": "a printing block produced by drawing with varnish on a metal plate, and depositing metal electrically on the parts not covered [n -S]\n",
  "ELECTROTINTS": "ELECTROTINT, a printing block produced by drawing with varnish on a metal plate, and depositing metal electrically on the parts not covered [n]\n",
  "ELECTROTONIC": "of, induced by, relating to, or constituting electrotonus [adj]\n",
  "ELECTROTONUS": "excitability and conductivity in a nerve [n -ES]\n",
  "ELECTROTONUSES": "ELECTROTONUS, excitability and conductivity in a nerve [n]\n",
  "ELECTROTYPE": "to make a copy of something by electrolytically coating a mould with copper [v ELECTROTYPED, ELECTROTYPING, ELECTROTYPES]\n",
  "ELECTROTYPED": "ELECTROTYPE, to make a copy of something by electrolytically coating a mould with copper [v]\n",
  "ELECTROTYPER": "a person who makes electrotypes [n -S]\n",
  "ELECTROTYPERS": "ELECTROTYPER, a person who makes electrotypes [n]\n",
  "ELECTROTYPES": "ELECTROTYPE, to make a copy of something by electrolytically coating a mould with copper [v]\n",
  "ELECTROTYPIC": "relating to printing by electrotype [adj]\n",
  "ELECTROTYPIES": "ELECTROTYPY, printing by electrotype [n]\n",
  "ELECTROTYPING": "ELECTROTYPE, to make a copy of something by electrolytically coating a mould with copper [v]\n",
  "ELECTROTYPIST": "one who does electrotyping [n -S]\n",
  "ELECTROTYPISTS": "ELECTROTYPIST, one who does electrotyping [n]\n",
  "ELECTROTYPY": "printing by electrotype [n ELECTROTYPIES]\n",
  "ELECTROVALENCE": "the valency of a substance in forming ions, equal to the number of electrons gained or lost, also ELECTROVALENCY [n -S]\n",
  "ELECTROVALENCES": "ELECTROVALENCE, the valency of a substance in forming ions, equal to the number of electrons gained or lost, also ELECTROVALENCY [n]\n",
  "ELECTROVALENCY": "the valency of a substance in forming ions, equal to the number of electrons gained or lost, also ELECTROVALENCE [n]\n",
  "ELECTROVALENT": "relating to union within a chemical compound achieved by transfer of electrons [adj ELECTROVALENTLY]\n",
  "ELECTROVALENTLY": "ELECTROVALENT, relating to union within a chemical compound achieved by transfer of electrons [adv]\n",
  "ELECTROWEAK": "of or relating to a theory unifying electromagnetic and weak interactions between particles [adj]\n",
  "ELECTROWINNING": "the recovery of a metal from its salts by passing an electric current through a solution [n -S]\n",
  "ELECTROWINNINGS": "ELECTROWINNING, the recovery of a metal from its salts by passing an electric current through a solution [n]\n",
  "ELECTRUM": "(Latin) an alloy of gold and silver [n -S]\n",
  "ELECTRUMS": "ELECTRUM, (Latin) an alloy of gold and silver [n]\n",
  "ELECTS": "ELECT, to select by vote [v]\n",
  "ELECTUARIES": "ELECTUARY, a medicine mixed with honey or syrup [n]\n",
  "ELECTUARY": "a medicine mixed with honey or syrup [n ELECTUARIES]\n",
  "ELEDOISIN": "a small protein from the salivary glands of various octopuses [n -S]\n",
  "ELEDOISINS": "ELEDOISIN, a small protein from the salivary glands of various octopuses [n]\n",
  "ELEEMOSYNARY": "pertaining to alms or almsgiving, charitable [adj]\n",
  "ELEGANCE": "the state of being elegant, also ELEGANCY [n -S]\n",
  "ELEGANCES": "ELEGANCE, the state of being elegant, also ELEGANCY [n]\n",
  "ELEGANCIES": "ELEGANCY, the state of being elegant, also ELEGANCE [n]\n",
  "ELEGANCY": "the state of being elegant, also ELEGANCE [n ELEGANCIES]\n",
  "ELEGANT": "tastefully opulent [adj ELEGANTLY]\n",
  "ELEGANTLY": "ELEGANT, tastefully opulent [adv]\n",
  "ELEGIAC": "relating to elegy, also ELEGIACAL [adj ELEGIACALLY] / a verse line of five dactyls with a marked caesura [n -S]\n",
  "ELEGIACAL": "related to elegy, also ELEGIAC [adj ELEGIACALLY]\n",
  "ELEGIACALLY": "ELEGIACAL, related to elegy, also ELEGIAC [adv]\n",
  "ELEGIACS": "ELEGIAC, a verse line of five dactyls with a marked caesura [n]\n",
  "ELEGIAST": "one who composes elegies, also ELEGIST [n -S]\n",
  "ELEGIASTS": "ELEGIAST, one who composes elegies, also ELEGIST [n]\n",
  "ELEGIES": "ELEGY, a mournful poem for the dead [n]\n",
  "ELEGISE": "to write an elegy, also ELEGIZE [v ELEGISED, ELEGISING, ELEGISES]\n",
  "ELEGISED": "ELEGISE, to write an elegy, also ELEGIZE [v]\n",
  "ELEGISES": "ELEGISE, to write an elegy, also ELEGIZE [v]\n",
  "ELEGISING": "ELEGISE, to write an elegy, also ELEGIZE [v]\n",
  "ELEGIST": "one who writes elegies [n -S]\n",
  "ELEGISTS": "ELEGIST, one who writes elegies [n]\n",
  "ELEGIT": "(Latin) a writ of execution on a debtor's property [n -S]\n",
  "ELEGITS": "ELEGIT, (Latin) a writ of execution on a debtor's property [n]\n",
  "ELEGIZE": "to write an elegy, also ELEGISE [v ELEGIZED, ELEGIZING, ELEGIZES]\n",
  "ELEGIZED": "ELEGIZE, to write an elegy, also ELEGISE [v]\n",
  "ELEGIZES": "ELEGIZE, to write an elegy, also ELEGISE [v]\n",
  "ELEGIZING": "ELEGIZE, to write an elegy, also ELEGISE [v]\n",
  "ELEGY": "a mournful poem for the dead [n ELEGIES]\n",
  "ELEMENT": "a substance that cannot be separated into simpler substances by chemical means [n -S]\n",
  "ELEMENTAL": "of or concerned with the elements [adj ELEMENTALLY] / an elemental spirit [n -S]\n",
  "ELEMENTALISM": "the worship of elemental spirits [n -S]\n",
  "ELEMENTALISMS": "ELEMENTALISM, the worship of elemental spirits [n]\n",
  "ELEMENTALLY": "ELEMENTAL, of or concerned with the elements [adv]\n",
  "ELEMENTALS": "ELEMENTAL, an elemental spirit [n]\n",
  "ELEMENTARILY": "ELEMENTARY, relating to the simplest elements or principles of something [adv]\n",
  "ELEMENTARINESS": "the state of being elementary [n]\n",
  "ELEMENTARY": "relating to the simplest elements or principles of something [adj ELEMENTARILY]\n",
  "ELEMENTS": "ELEMENT, a substance that cannot be separated into simpler substances by chemical means [n]\n",
  "ELEMI": "a fragrant resinous substance obtained from various tropical trees [n -S]\n",
  "ELEMIS": "ELEMI, a fragrant resinous substance obtained from various tropical trees [n]\n",
  "ELENCH": "(obsolete) in logic, that part of an argument on which its conclusiveness depends, also ELENCHUS [n -S]\n",
  "ELENCHI": "ELENCHUS, (Greek) a refutation, also ELENCH [n]\n",
  "ELENCHIC": "relating to an elenchus, that part of an argument on which its conclusiveness depends [adj]\n",
  "ELENCHS": "ELENCH, (obsolete) in logic, that part of an argument on which its conclusiveness depends, also ELENCHUS [n]\n",
  "ELENCHTIC": "relating to argument, cross-examination or refuting, also ELENCTIC [adj]\n",
  "ELENCHUS": "(Greek) a refutation, also ELENCH [n ELENCHI]\n",
  "ELENCTIC": "relating to argument, cross-examination or refuting, also ELENCHTIC [adj]\n",
  "ELEOPTENE": "the liquid part of a volatile oil [n -S]\n",
  "ELEOPTENES": "ELEOPTENE, the liquid part of a volatile oil [n]\n",
  "ELEPHANT": "a large tusked mammal [n -S]\n",
  "ELEPHANTIASES": "ELEPHANTIASIS, enlargement and thickening of tissues [n]\n",
  "ELEPHANTIASIC": "suffering from elephantiasis [adj]\n",
  "ELEPHANTIASIS": "enlargement and thickening of tissues [n ELEPHANTIASES]\n",
  "ELEPHANTINE": "having enormous size or strength [adj]\n",
  "ELEPHANTOID": "elephant-like [adj]\n",
  "ELEPHANTS": "ELEPHANT, a large tusked mammal [n]\n",
  "ELEPIDOTE": "any of various medium to large rhododendrons with large, leathery leaves lacking the scales characteristic of the related lepidotes [n -S]\n",
  "ELEPIDOTES": "ELEPIDOTE, any of various medium to large rhododendrons with large, leathery leaves lacking the scales characteristic of the related lepidotes [n]\n",
  "ELEUTHERARCH": "the chief of the eleutheri, an invented secret society [n -S]\n",
  "ELEUTHERARCHS": "ELEUTHERARCH, the chief of the eleutheri, an invented secret society [n]\n",
  "ELEUTHERI": "(Greek) an invented secret society [n]\n",
  "ELEUTHERIAN": "freedom-giving [adj]\n",
  "ELEUTHEROCOCCI": "ELEUTHEROCOCCUS, a creeping shrub found in Siberia, from which a drug is prepared that apparently increases stamina and concentration [n]\n",
  "ELEUTHEROCOCCUS": "a creeping shrub found in Siberia, from which a drug is prepared that apparently increases stamina and concentration [n ELEUTHEROCOCCI]\n",
  "ELEUTHERODACTYL": "of birds, having the hind toe free [n]\n",
  "ELEUTHEROMANIA": "a manic desire for freedom [n -S]\n",
  "ELEUTHEROMANIAS": "ELEUTHEROMANIA, a manic desire for freedom [n]\n",
  "ELEUTHEROPHOBIA": "a morbid fear of freedom [n]\n",
  "ELEUTHEROPHOBIC": "suffering from a fear of freedom [adj]\n",
  "ELEVATE": "to raise [v ELEVATED, ELEVATING, ELEVATES]\n",
  "ELEVATED": "a raised railway [n -S]\n",
  "ELEVATEDS": "ELEVATED, a raised railway [n]\n",
  "ELEVATES": "ELEVATE, to raise [v]\n",
  "ELEVATING": "ELEVATE, to raise [v]\n",
  "ELEVATION": "the act of elevating [n -S]\n",
  "ELEVATIONAL": "relating to elevation [adj]\n",
  "ELEVATIONS": "ELEVATION, the act of elevating [n]\n",
  "ELEVATOR": "a lift [n -S]\n",
  "ELEVATORS": "ELEVATOR, a lift [n]\n",
  "ELEVATORY": "able or tending to raise [adj]\n",
  "ELEVEN": "a number, ten and one [n -S]\n",
  "ELEVENS": "ELEVEN, a number, ten and one [n]\n",
  "ELEVENSES": "a light meal or coffee break at around 11 a.m. [n]\n",
  "ELEVENTH": "eleventh in sequence [adj ELEVENTHLY] / one of eleven equal parts [n -S]\n",
  "ELEVENTHLY": "ELEVENTH, eleventh in sequence [adv]\n",
  "ELEVENTHS": "ELEVENTH, one of eleven equal parts [n]\n",
  "ELEVON": "a hinged flap on the trailing edge of a delta wing, taking the place of both aileron and elevator in a conventional aircraft [n -S]\n",
  "ELEVONS": "ELEVON, a hinged flap on the trailing edge of a delta wing, taking the place of both aileron and elevator in a conventional aircraft [n]\n",
  "ELF": "to entangle (hair) [v -ED, -ING, -S] / a fairylike being [n ELVES]\n",
  "ELFED": "ELF, to entangle (hair) [v]\n",
  "ELFHOOD": "the state of being an elf [n -S]\n",
  "ELFHOODS": "ELFHOOD, the state of being an elf [n]\n",
  "ELFIN": "like an elf, also ELVEN [adj] / a little elf [n -S]\n",
  "ELFING": "ELF, to entangle (hair) [v]\n",
  "ELFINS": "ELFIN, a little elf [n]\n",
  "ELFISH": "like an elf, also ELVISH [adj ELFISHLY] / the imagined language of elves [n -ES]\n",
  "ELFISHES": "ELFISH, the imagined language of elves [n]\n",
  "ELFISHLY": "ELFISH, like an elf, also ELVISH [adv]\n",
  "ELFISHNESS": "being like an elf, also ELVISHNESS [n -ES]\n",
  "ELFISHNESSES": "ELFISHNESS, being like an elf, also ELVISHNESS [n]\n",
  "ELFLAND": "the land of the elves [n -S]\n",
  "ELFLANDS": "ELFLAND, the land of the elves [n]\n",
  "ELFLIKE": "like an elf [adj]\n",
  "ELFLOCK": "a lock of tangled hair [n -S]\n",
  "ELFLOCKS": "ELFLOCK, a lock of tangled hair [n]\n",
  "ELFS": "ELF, to entangle (hair) [v]\n",
  "ELHI": "(US) pertaining to school grades 1 to 12 [adj]\n",
  "ELIAD": "(Shakespeare) an amorous glance, also OEILLADE, EYELIAD, EYLIAD, ILLIAD [n -S]\n",
  "ELIADS": "ELIAD, (Shakespeare) an amorous glance, also OEILLADE, EYELIAD, EYLIAD, ILLIAD [n]\n",
  "ELICHE": "(Italian) spiral-shaped pasta [n -S]\n",
  "ELICHES": "ELICHE, (Italian) spiral-shaped pasta [n]\n",
  "ELICIT": "to draw forth [v -ED, -ING, -S]\n",
  "ELICITABLE": "that can be elicited [adj]\n",
  "ELICITATION": "the act of eliciting [n -S]\n",
  "ELICITATIONS": "ELICITATION, the act of eliciting [n]\n",
  "ELICITED": "ELICIT, to draw forth [v]\n",
  "ELICITING": "ELICIT, to draw forth [v]\n",
  "ELICITOR": "one who elicits [n -S]\n",
  "ELICITORS": "ELICITOR, one who elicits [n]\n",
  "ELICITS": "ELICIT, to draw forth [v]\n",
  "ELIDE": "to strike out (a word or passage) [v ELIDED, ELIDING, ELIDES]\n",
  "ELIDED": "ELIDE, to strike out (a word or passage) [v]\n",
  "ELIDES": "ELIDE, to strike out (a word or passage) [v]\n",
  "ELIDIBLE": "able to be elided [adj]\n",
  "ELIDING": "ELIDE, to strike out (a word or passage) [v]\n",
  "ELIGIBILITIES": "ELIGIBILITY, the state of being eligible [n]\n",
  "ELIGIBILITY": "the state of being eligible [n ELIGIBILITIES]\n",
  "ELIGIBLE": "fit to be chosen [adj ELIGIBLY] / one fit to be chosen [n -S]\n",
  "ELIGIBLES": "ELIGIBLE, one fit to be chosen [n]\n",
  "ELIGIBLY": "ELIGIBLE, fit to be chosen [adv]\n",
  "ELIMINABILITIES": "ELIMINABILITY, the capacity to be eliminated [n]\n",
  "ELIMINABILITY": "the capacity to be eliminated [n ELIMINABILITIES]\n",
  "ELIMINABLE": "that can be eliminated [adj]\n",
  "ELIMINANT": "an agent causing elimination of waste or abnormal matter [n -S]\n",
  "ELIMINANTS": "ELIMINANT, an agent causing elimination of waste or abnormal matter [n]\n",
  "ELIMINATE": "to remove, get rid of [v ELIMINATED, ELIMINATING, ELIMINATES]\n",
  "ELIMINATED": "ELIMINATE, to remove, get rid of [v]\n",
  "ELIMINATES": "ELIMINATE, to remove, get rid of [v]\n",
  "ELIMINATING": "ELIMINATE, to remove, get rid of [v]\n",
  "ELIMINATION": "the act of eliminating [n -S]\n",
  "ELIMINATIONS": "ELIMINATION, the act of eliminating [n]\n",
  "ELIMINATIVE": "serving to eliminate [adj]\n",
  "ELIMINATIVISM": "the theory that people's commonsense understanding of the mind is false [n -S]\n",
  "ELIMINATIVISMS": "ELIMINATIVISM, the theory that people's commonsense understanding of the mind is false [n]\n",
  "ELIMINATOR": "one who eliminates [n -S]\n",
  "ELIMINATORS": "ELIMINATOR, one who eliminates [n]\n",
  "ELIMINATORY": "serving to eliminate [adj]\n",
  "ELINT": "(short for) electronic intelligence [n -S]\n",
  "ELINTS": "ELINT, (short for) electronic intelligence [n]\n",
  "ELISION": "the act of eliding [n -S]\n",
  "ELISIONS": "ELISION, the act of eliding [n]\n",
  "ELITE": "a socially select group [n -S]\n",
  "ELITES": "ELITE, a socially select group [n]\n",
  "ELITISM": "belief in rule by an elite [n -S]\n",
  "ELITISMS": "ELITISM, belief in rule by an elite [n]\n",
  "ELITIST": "an adherent of elitism [n -S]\n",
  "ELITISTS": "ELITIST, an adherent of elitism [n]\n",
  "ELIXIR": "a medicinal beverage [n -S]\n",
  "ELIXIRS": "ELIXIR, a medicinal beverage [n]\n",
  "ELK": "a kind of large deer [n -S]\n",
  "ELKHORN": "as in elkhorn fern, a fern with a large leaf like an elk's horn [adj]\n",
  "ELKHOUND": "a breed of hunting dog [n -S]\n",
  "ELKHOUNDS": "ELKHOUND, a breed of hunting dog [n]\n",
  "ELKS": "ELK, a kind of large deer [n]\n",
  "ELL": "an old measure of length equal to 45 inches [n -S]\n",
  "ELLAGIC": "relating to gallnuts, as, ellagic acid [adj]\n",
  "ELLIPSE": "a type of plane curve [n -S]\n",
  "ELLIPSES": "ELLIPSE, a type of plane curve [n]\n",
  "ELLIPSIS": "a figure of syntax by which a word or words are left out and merely implied [n ELLIPSES]\n",
  "ELLIPSOGRAPH": "an instrument for describing ellipses [n -S]\n",
  "ELLIPSOGRAPHS": "ELLIPSOGRAPH, an instrument for describing ellipses [n]\n",
  "ELLIPSOID": "a solid, all plane sections of which are ellipses or circles [n -S]\n",
  "ELLIPSOIDAL": "having the shape of an ellipse [adj]\n",
  "ELLIPSOIDS": "ELLIPSOID, a solid, all plane sections of which are ellipses or circles [n]\n",
  "ELLIPTIC": "having the shape of an ellipse, also ELLIPTICAL [adj ELLIPTICALLY]\n",
  "ELLIPTICAL": "having the shape of an ellipse, also ELLIPTIC [adj ELLIPTICALLY] / an ellipse [n -S]\n",
  "ELLIPTICALLY": "ELLIPTICAL, having the shape of an ellipse, also ELLIPTIC [adv]\n",
  "ELLIPTICALNESS": "ELLIPTICAL, having the shape of an ellipse, also ELLIPTIC [n]\n",
  "ELLIPTICALS": "ELLIPTICAL, an ellipse [n]\n",
  "ELLIPTICITIES": "ELLIPTICITY, the state of being an ellipse [n]\n",
  "ELLIPTICITY": "the state of being an ellipse [n ELLIPTICITIES]\n",
  "ELLOPS": "(obsolete) a type of sturgeon, also ELOPS [n -ES]\n",
  "ELLOPSES": "ELLOPS, (obsolete) a type of sturgeon, also ELOPS [n]\n",
  "ELLS": "ELL, an old measure of length equal to 45 inches [n]\n",
  "ELLWAND": "a measuring rod [n -S]\n",
  "ELLWANDS": "ELLWAND, a measuring rod [n]\n",
  "ELM": "a kind of deciduous tree [n -S]\n",
  "ELMEN": "made of elm [adj]\n",
  "ELMIER": "ELMY, full of elm trees [adj]\n",
  "ELMIEST": "ELMY, full of elm trees [adj]\n",
  "ELMS": "ELM, a kind of deciduous tree [n]\n",
  "ELMWOOD": "wood of the elm tree [n -S]\n",
  "ELMWOODS": "ELMWOOD, wood of the elm tree [n]\n",
  "ELMY": "full of elm trees [adj ELMIER, ELMIEST]\n",
  "ELOCUTE": "to speak publicly [v ELOCUTED, ELOCUTING, ELOCUTES]\n",
  "ELOCUTED": "ELOCUTE, to speak publicly [v]\n",
  "ELOCUTES": "ELOCUTE, to speak publicly [v]\n",
  "ELOCUTING": "ELOCUTE, to speak publicly [v]\n",
  "ELOCUTION": "the art of effective speaking [n -S]\n",
  "ELOCUTIONARY": "relating to elocution [adj]\n",
  "ELOCUTIONIST": "a person trained or expert in or practising elocution [n -S]\n",
  "ELOCUTIONISTS": "ELOCUTIONIST, a person trained or expert in or practising elocution [n]\n",
  "ELOCUTIONS": "ELOCUTION, the art of effective speaking [n]\n",
  "ELOCUTORY": "pertaining to elocution [adj]\n",
  "ELODEA": "an American genus of aquatic plant that includes the Canadian waterweed [n -S]\n",
  "ELODEAS": "ELODEA, an American genus of aquatic plant that includes the Canadian waterweed [n]\n",
  "ELOGE": "(French) a funeral oration, also ELOGIUM, ELOGY [n -S]\n",
  "ELOGES": "ELOGE, (French) a funeral oration, also ELOGIUM, ELOGY [n]\n",
  "ELOGIES": "ELOGY, a funeral oration, also ELOGE, ELOGIUM [n]\n",
  "ELOGIST": "one who delivers an eloge [n -S]\n",
  "ELOGISTS": "ELOGIST, one who delivers an eloge [n]\n",
  "ELOGIUM": "(Latin) a funeral oration, also ELOGE, ELOGY [n -S]\n",
  "ELOGIUMS": "ELOGIUM, (Latin) a funeral oration, also ELOGE, ELOGY [n]\n",
  "ELOGY": "a funeral oration, also ELOGE, ELOGIUM [n ELOGIES]\n",
  "ELOIGN": "to remove to a distant place, also ELOIN, ESLOIN, ESLOYNE [v -ED, -ING, -S]\n",
  "ELOIGNED": "ELOIGN, to remove to a distant place, also ELOIN, ESLOIN, ESLOYNE [v]\n",
  "ELOIGNER": "one who eloigns, also ELOINER [n -S]\n",
  "ELOIGNERS": "ELOIGNER, one who eloigns, also ELOINER [n]\n",
  "ELOIGNING": "ELOIGN, to remove to a distant place, also ELOIN, ESLOIN, ESLOYNE [v]\n",
  "ELOIGNMENT": "the act of eloigning, conveying to a distance [n -S]\n",
  "ELOIGNMENTS": "ELOIGNMENT, the act of eloigning, conveying to a distance [n]\n",
  "ELOIGNS": "ELOIGN, to remove to a distant place, also ELOIN, ESLOIN, ESLOYNE [v]\n",
  "ELOIN": "to remove to a distant place, also ELOIGN, ESLOIN, ESLOYNE [v -ED, -ING, -S]\n",
  "ELOINED": "ELOIN, to remove to a distant place, also ELOIGN, ESLOIN, ESLOYNE [v]\n",
  "ELOINER": "one who eloins, also ELOIGNER [n -S]\n",
  "ELOINERS": "ELOINER, one who eloins, also ELOIGNER [n]\n",
  "ELOINING": "ELOIN, to remove to a distant place, also ELOIGN, ESLOIN, ESLOYNE [v]\n",
  "ELOINMENT": "the act of eloining, conveying to a distance [n -S]\n",
  "ELOINMENTS": "ELOINMENT, the act of eloining, conveying to a distance [n]\n",
  "ELOINS": "ELOIN, to remove to a distant place, also ELOIGN, ESLOIN, ESLOYNE [v]\n",
  "ELONGATE": "to lengthen [v ELONGATED, ELONGATING, ELONGATES]\n",
  "ELONGATED": "ELONGATE, to lengthen [v]\n",
  "ELONGATES": "ELONGATE, to lengthen [v]\n",
  "ELONGATING": "ELONGATE, to lengthen [v]\n",
  "ELONGATION": "the act of elongating [n -S]\n",
  "ELONGATIONS": "ELONGATION, the act of elongating [n]\n",
  "ELOPE": "to run away to be married secretly [v ELOPED, ELOPING, ELOPES]\n",
  "ELOPED": "ELOPE, to run away to be married secretly [v]\n",
  "ELOPEMENT": "the act of eloping [n -S]\n",
  "ELOPEMENTS": "ELOPEMENT, the act of eloping [n]\n",
  "ELOPER": "one who elopes [n -S]\n",
  "ELOPERS": "ELOPER, one who elopes [n]\n",
  "ELOPES": "ELOPE, to run away to be married secretly [v]\n",
  "ELOPING": "ELOPE, to run away to be married secretly [v]\n",
  "ELOPS": "a type of sturgeon, also ELLOPS [n -ES]\n",
  "ELOPSES": "ELOPS, a type of sturgeon, also ELLOPS [n]\n",
  "ELOQUENCE": "the power, art or practice of expressing strong emotion in correct, appropriate, expressive and fluent language [n -S]\n",
  "ELOQUENCES": "ELOQUENCE, the power, art or practice of expressing strong emotion in correct, appropriate, expressive and fluent language [n]\n",
  "ELOQUENT": "fluent in speech [adj ELOQUENTLY]\n",
  "ELOQUENTLY": "ELOQUENT, fluent in speech [adv]\n",
  "ELPEE": "a long-playing record [n -S]\n",
  "ELPEES": "ELPEE, a long-playing record [n]\n",
  "ELS": "EL, (US) an elevated railroad [n]\n",
  "ELSE": "otherwise [adv]\n",
  "ELSEWHERE": "in another place [adv]\n",
  "ELSEWHITHER": "to another place [adv]\n",
  "ELSEWISE": "otherwise [adv]\n",
  "ELSHIN": "(Scots) an awl, also ELSIN [n -S]\n",
  "ELSHINS": "ELSHIN, (Scots) an awl, also ELSIN [n]\n",
  "ELSIN": "(Scots) an awl, also ELSHIN [n -S]\n",
  "ELSINS": "ELSIN, (Scots) an awl, also ELSHIN [n]\n",
  "ELT": "a young sow, also GILT, YELT [n -S]\n",
  "ELTCHI": "(Turkish) an ambassador, also ELCHI, ELCHEE [n -S]\n",
  "ELTCHIS": "ELTCHI, (Turkish) an ambassador, also ELCHI, ELCHEE [n]\n",
  "ELTS": "ELT, a young sow, also GILT, YELT [n]\n",
  "ELUANT": "a solvent, also ELUENT [n -S]\n",
  "ELUANTS": "ELUANT, a solvent, also ELUENT [n]\n",
  "ELUATE": "liquid obtained by eluting [n -S]\n",
  "ELUATES": "ELUATE, liquid obtained by eluting [n]\n",
  "ELUCIDATE": "to make clear [v ELUCIDATED, ELUCIDATING, ELUCIDATES]\n",
  "ELUCIDATED": "ELUCIDATE, to make clear [v]\n",
  "ELUCIDATES": "ELUCIDATE, to make clear [v]\n",
  "ELUCIDATING": "ELUCIDATE, to make clear [v]\n",
  "ELUCIDATION": "the act of elucidating [n -S]\n",
  "ELUCIDATIONS": "ELUCIDATION, the act of elucidating [n]\n",
  "ELUCIDATIVE": "serving to elucidate [adj]\n",
  "ELUCIDATOR": "one who elucidates [n -S]\n",
  "ELUCIDATORS": "ELUCIDATOR, one who elucidates [n]\n",
  "ELUCIDATORY": "serving to elucidate [adj]\n",
  "ELUCUBRATE": "to work out or express by studious effort; to burn the midnight oil [v ELUCUBRATED, ELUCUBRATING, ELUCUBRATES]\n",
  "ELUCUBRATED": "ELUCUBRATE, to work out or express by studious effort; to burn the midnight oil [v]\n",
  "ELUCUBRATES": "ELUCUBRATE, to work out or express by studious effort; to burn the midnight oil [v]\n",
  "ELUCUBRATING": "ELUCUBRATE, to work out or express by studious effort; to burn the midnight oil [v]\n",
  "ELUCUBRATION": "(obsolete) lucubration [n -S]\n",
  "ELUCUBRATIONS": "ELUCUBRATION, (obsolete) lucubration [n]\n",
  "ELUDE": "to evade [v ELUDED, ELUDING, ELUDES]\n",
  "ELUDED": "ELUDE, to evade [v]\n",
  "ELUDER": "one who eludes [n -S]\n",
  "ELUDERS": "ELUDER, one who eludes [n]\n",
  "ELUDES": "ELUDE, to evade [v]\n",
  "ELUDIBLE": "able to be eluded [adj]\n",
  "ELUDING": "ELUDE, to evade [v]\n",
  "ELUENT": "a solvent, also ELUANT [n -S]\n",
  "ELUENTS": "ELUENT, a solvent, also ELUANT [n]\n",
  "ELUSION": "the action of eluding [n -S]\n",
  "ELUSIONS": "ELUSION, the action of eluding [n]\n",
  "ELUSIVE": "tending to elude [adj ELUSIVELY]\n",
  "ELUSIVELY": "ELUSIVE, tending to elude [adv]\n",
  "ELUSIVENESS": "the state of being elusive [n -ES]\n",
  "ELUSIVENESSES": "ELUSIVENESS, the state of being elusive [n]\n",
  "ELUSORINESS": "the quality of being elusory [n -ES]\n",
  "ELUSORINESSES": "ELUSORINESS, the quality of being elusory [n]\n",
  "ELUSORY": "tending to elude or deceive [adj]\n",
  "ELUTE": "to remove by means of a solvent [v ELUTED, ELUTING, ELUTES]\n",
  "ELUTED": "ELUTE, to remove by means of a solvent [v]\n",
  "ELUTES": "ELUTE, to remove by means of a solvent [v]\n",
  "ELUTING": "ELUTE, to remove by means of a solvent [v]\n",
  "ELUTION": "purification or separation by washing [n -S]\n",
  "ELUTIONS": "ELUTION, purification or separation by washing [n]\n",
  "ELUTOR": "a vessel for elution [n -S]\n",
  "ELUTORS": "ELUTOR, a vessel for elution [n]\n",
  "ELUTRIATE": "to separate by washing into finer portions [v ELUTRIATED, ELUTRIATING, ELUTRIATES]\n",
  "ELUTRIATED": "ELUTRIATE, to separate by washing into finer portions [v]\n",
  "ELUTRIATES": "ELUTRIATE, to separate by washing into finer portions [v]\n",
  "ELUTRIATING": "ELUTRIATE, to separate by washing into finer portions [v]\n",
  "ELUTRIATION": "the act of elutriating [n -S]\n",
  "ELUTRIATIONS": "ELUTRIATION, the act of elutriating [n]\n",
  "ELUTRIATOR": "an apparatus for elutriating [n -S]\n",
  "ELUTRIATORS": "ELUTRIATOR, an apparatus for elutriating [n]\n",
  "ELUVIA": "ELUVIUM, (Latin) an accumulation of rock debris [n]\n",
  "ELUVIAL": "relating to an eluvium, an accumulation of rock debris [adj]\n",
  "ELUVIATE": "to undergo a transfer of materials in the soil [v ELUVIATED, ELUVIATING, ELUVIATES]\n",
  "ELUVIATED": "ELUVIATE, to undergo a transfer of materials in the soil [v]\n",
  "ELUVIATES": "ELUVIATE, to undergo a transfer of materials in the soil [v]\n",
  "ELUVIATING": "ELUVIATE, to undergo a transfer of materials in the soil [v]\n",
  "ELUVIATION": "the formation of eluvium, an accumulation of rock debris [n -S]\n",
  "ELUVIATIONS": "ELUVIATION, the formation of eluvium, an accumulation of rock debris [n]\n",
  "ELUVIUM": "(Latin) an accumulation of rock debris [n ELUVIA or ELUVIUMS]\n",
  "ELUVIUMS": "ELUVIUM, (Latin) an accumulation of rock debris [n]\n",
  "ELVAN": "(Welsh) a granular rock, also ELVANITE [n -S]\n",
  "ELVANITE": "a granular rock, also ELVAN [n -S]\n",
  "ELVANITES": "ELVANITE, a granular rock, also ELVAN [n]\n",
  "ELVANS": "ELVAN, (Welsh) a granular rock, also ELVANITE [n]\n",
  "ELVEN": "resembling an elf, also ELFIN [adj]\n",
  "ELVER": "a young eel [n -S]\n",
  "ELVERS": "ELVER, a young eel [n]\n",
  "ELVES": "ELF, a fairylike being [n]\n",
  "ELVISH": "like an elf, also ELFISH [adj ELVISHLY] / the imagined language of elves [n -ES]\n",
  "ELVISHES": "ELVISH, the imagined language of elves [n]\n",
  "ELVISHLY": "ELVISH, like an elf, also ELFISH [adv]\n",
  "ELVISHNESS": "being like an elf, also ELFISHNESS [n -ES]\n",
  "ELVISHNESSES": "ELVISHNESS, being like an elf, also ELFISHNESS [n]\n",
  "ELYSIAN": "delightful [adj]\n",
  "ELYTRA": "ELYTRUM, (Latin) a hardened forewing of certain insects, also ELYTRON [n]\n",
  "ELYTRAL": "pertaining to the beetle's forewing [adj]\n",
  "ELYTRIFORM": "having the form, or structure, of an elytron [adj]\n",
  "ELYTRIGEROUS": "bearing elytra [adj]\n",
  "ELYTROID": "of or like an elytron, a beetle's forewing, also ELYTROUS [adj]\n",
  "ELYTRON": "(Greek) a hardened forewing of certain insects, also ELYTRUM [n ELYTRA]\n",
  "ELYTROUS": "of or like an elytron, a beetle's forewing, also ELYTROID [adj]\n",
  "ELYTRUM": "(Latin) a hardened forewing of certain insects, also ELYTRON [n ELYTRA]\n",
  "EM": "a unit of measurement in printing [n -S]\n",
  "EMACIATE": "to make thin [v EMACIATED, EMACIATING, EMACIATES]\n",
  "EMACIATED": "EMACIATE, to make thin [v]\n",
  "EMACIATES": "EMACIATE, to make thin [v]\n",
  "EMACIATING": "EMACIATE, to make thin [v]\n",
  "EMACIATION": "the act of making very lean [n -S]\n",
  "EMACIATIONS": "EMACIATION, the act of making very lean [n]\n",
  "EMACS": "a powerful computer program for editing text [n EMACSEN]\n",
  "EMACSEN": "using an editing style like emacs [adj]\n",
  "EMAIL": "to send electronic mail [v -ED, -ING, -S]\n",
  "EMAILABLE": "capable of being sent by email [adj]\n",
  "EMAILED": "EMAIL, to send electronic mail [v]\n",
  "EMAILER": "one who sends electronic messages via computer [n -S]\n",
  "EMAILERS": "EMAILER, one who sends electronic messages via computer [n]\n",
  "EMAILING": "the act of sending electronic mail [n -S]\n",
  "EMAILINGS": "EMAILING, the act of sending electronic mail [n]\n",
  "EMAILS": "EMAIL, to send electronic mail [v]\n",
  "EMALANGENI": "LILANGENI, (Bantu) the standard monetary unit of Swaziland [n]\n",
  "EMANANT": "flowing forth [adj]\n",
  "EMANATE": "to send forth [v EMANATED, EMANATING, EMANATES]\n",
  "EMANATED": "EMANATE, to send forth [v]\n",
  "EMANATES": "EMANATE, to send forth [v]\n",
  "EMANATING": "EMANATE, to send forth [v]\n",
  "EMANATION": "a flowing out from a source [n -S]\n",
  "EMANATIONAL": "relating to emanation [adj]\n",
  "EMANATIONS": "EMANATION, a flowing out from a source [n]\n",
  "EMANATIST": "one who believes in emanation, the universe considered as issuing from God [n -S]\n",
  "EMANATISTS": "EMANATIST, one who believes in emanation, the universe considered as issuing from God [n]\n",
  "EMANATIVE": "issuing forth; effluent [adj]\n",
  "EMANATOR": "one that emanates [n -S]\n",
  "EMANATORS": "EMANATOR, one that emanates [n]\n",
  "EMANATORY": "of the nature of an emanation [adj]\n",
  "EMANCIPATE": "to free from restraint, control, or the power of another [v EMANCIPATED, EMANCIPATING, EMANCIPATES]\n",
  "EMANCIPATED": "EMANCIPATE, to free from restraint, control, or the power of another [v]\n",
  "EMANCIPATES": "EMANCIPATE, to free from restraint, control, or the power of another [v]\n",
  "EMANCIPATING": "EMANCIPATE, to free from restraint, control, or the power of another [v]\n",
  "EMANCIPATION": "the act of emancipating [n -S]\n",
  "EMANCIPATIONIST": "a believer in emancipation [n]\n",
  "EMANCIPATIONS": "EMANCIPATION, the act of emancipating [n]\n",
  "EMANCIPATIVE": "serving to emancipate [adj]\n",
  "EMANCIPATOR": "one who emancipates [n -S]\n",
  "EMANCIPATORS": "EMANCIPATOR, one who emancipates [n]\n",
  "EMANCIPATORY": "serving to emancipate [adj]\n",
  "EMANCIPIST": "(historical) a convict who has served his time of punishment in a penal colony [n -S]\n",
  "EMANCIPISTS": "EMANCIPIST, (historical) a convict who has served his time of punishment in a penal colony [n]\n",
  "EMARGINATE": "without a margin [adj EMARGINATELY] / to take away the margin of [v EMARGINATED, EMARGINATING, EMARGINATES]\n",
  "EMARGINATED": "EMARGINATE, to take away the margin of [v]\n",
  "EMARGINATELY": "EMARGINATE, without a margin [adv]\n",
  "EMARGINATES": "EMARGINATE, to take away the margin of [v]\n",
  "EMARGINATING": "EMARGINATE, to take away the margin of [v]\n",
  "EMARGINATION": "the act of emarginating [n -S]\n",
  "EMARGINATIONS": "EMARGINATION, the act of emarginating [n]\n",
  "EMASCULATE": "to deprive of strength, vigor, or spirit [v EMASCULATED, EMASCULATING, EMASCULATES]\n",
  "EMASCULATED": "EMASCULATE, to deprive of strength, vigor, or spirit [v]\n",
  "EMASCULATES": "EMASCULATE, to deprive of strength, vigor, or spirit [v]\n",
  "EMASCULATING": "EMASCULATE, to deprive of strength, vigor, or spirit [v]\n",
  "EMASCULATION": "the act of emasculating [n -S]\n",
  "EMASCULATIONS": "EMASCULATION, the act of emasculating [n]\n",
  "EMASCULATIVE": "tending to emasculate [adj]\n",
  "EMASCULATOR": "one who emasculates [n -S]\n",
  "EMASCULATORS": "EMASCULATOR, one who emasculates [n]\n",
  "EMASCULATORY": "tending to emasculate [adj]\n",
  "EMBACE": "(Spenser) to lower, also EMBASE, IMBASE [v EMBASTE, EMBACING, EMBACES]\n",
  "EMBACES": "EMBACE, (Spenser) to lower, also EMBASE, IMBASE [v]\n",
  "EMBACING": "EMBACE, (Spenser) to lower, also EMBASE, IMBASE [v]\n",
  "EMBAIL": "(obsolete) to encircle, to hoop in [v EMBAILED or (Spenser) EMBAYLD, EMBAILING, EMBAILS]\n",
  "EMBAILED": "EMBAIL, (obsolete) to encircle, to hoop in [v]\n",
  "EMBAILING": "EMBAIL, (obsolete) to encircle, to hoop in [v]\n",
  "EMBAILS": "EMBAIL, (obsolete) to encircle, to hoop in [v]\n",
  "EMBALE": "to form into a bale [v EMBALED, EMBALING, EMBALES]\n",
  "EMBALED": "EMBALE, to form into a bale [v]\n",
  "EMBALES": "EMBALE, to form into a bale [v]\n",
  "EMBALING": "EMBALE, to form into a bale [v]\n",
  "EMBALL": "to enclose in a ball [v -ED, -ING, -S]\n",
  "EMBALLED": "EMBALL, to enclose in a ball [v]\n",
  "EMBALLING": "the act of enclosing in a ball [n -S]\n",
  "EMBALLINGS": "EMBALLING, the act of enclosing in a ball [n]\n",
  "EMBALLS": "EMBALL, to enclose in a ball [v]\n",
  "EMBALM": "to preserve a dead body, also IMBALM [v -ED, -ING, -S]\n",
  "EMBALMED": "EMBALM, to preserve a dead body, also IMBALM [v]\n",
  "EMBALMER": "one that embalms, also IMBALMER [n -S]\n",
  "EMBALMERS": "EMBALMER, one that embalms, also IMBALMER [n]\n",
  "EMBALMING": "the act of embalming [n -S]\n",
  "EMBALMINGS": "EMBALMING, the act of embalming [n]\n",
  "EMBALMMENT": "the act of embalming [n -S]\n",
  "EMBALMMENTS": "EMBALMMENT, the act of embalming [n]\n",
  "EMBALMS": "EMBALM, to preserve a dead body, also IMBALM [v]\n",
  "EMBANK": "to enclose with a raised structure [v -ED, -ING, -S]\n",
  "EMBANKED": "EMBANK, to enclose with a raised structure [v]\n",
  "EMBANKER": "one who makes banks or dikes [n -S]\n",
  "EMBANKERS": "EMBANKER, one who makes banks or dikes [n]\n",
  "EMBANKING": "EMBANK, to enclose with a raised structure [v]\n",
  "EMBANKMENT": "a raised structure (as of earth or gravel) used esp. to hold back water or to carry a roadway [n -S]\n",
  "EMBANKMENTS": "EMBANKMENT, a raised structure (as of earth or gravel) used esp. to hold back water or to carry a roadway [n]\n",
  "EMBANKS": "EMBANK, to enclose with a raised structure [v]\n",
  "EMBAR": "(archaic) to shut in; to put under embargo, also IMBAR [v EMBARRED, EMBARRING, EMBARS]\n",
  "EMBARCADERO": "a landing place esp. on an inland waterway [n -S]\n",
  "EMBARCADEROS": "EMBARCADERO, a landing place esp. on an inland waterway [n]\n",
  "EMBARCATION": "the act of embarking [n -S]\n",
  "EMBARCATIONS": "EMBARCATION, the act of embarking [n]\n",
  "EMBARGO": "to prohibit trade by a governmental order [v -ED, -ING, -ES]\n",
  "EMBARGOED": "EMBARGO, to prohibit trade by a governmental order [v]\n",
  "EMBARGOES": "EMBARGO, to prohibit trade by a governmental order [v]\n",
  "EMBARGOING": "EMBARGO, to prohibit trade by a governmental order [v]\n",
  "EMBARK": "to go on board ship, also IMBARK [v -ED, -ING, -S]\n",
  "EMBARKATION": "the act of embarking [n -S]\n",
  "EMBARKATIONS": "EMBARKATION, the act of embarking [n]\n",
  "EMBARKED": "EMBARK, to go on board ship, also IMBARK [v]\n",
  "EMBARKING": "EMBARK, to go on board ship, also IMBARK [v]\n",
  "EMBARKMENT": "embarkation [n -S]\n",
  "EMBARKMENTS": "EMBARKMENT, embarkation [n]\n",
  "EMBARKS": "EMBARK, to go on board ship, also IMBARK [v]\n",
  "EMBARQUEMENT": "(Shakespeare) a placing under embargo [n -S]\n",
  "EMBARQUEMENTS": "EMBARQUEMENT, (Shakespeare) a placing under embargo [n]\n",
  "EMBARRAS": "(French) an embarrassment [n EMBARRAS]\n",
  "EMBARRASS": "to discomfit [v -ED, -ING, -ES]\n",
  "EMBARRASSABLE": "capable of being embarrassed [adj]\n",
  "EMBARRASSED": "EMBARRASS, to discomfit [v]\n",
  "EMBARRASSEDLY": "EMBARRASSED, EMBARRASS, to discomfit [adv]\n",
  "EMBARRASSES": "EMBARRASS, to discomfit [v]\n",
  "EMBARRASSING": "EMBARRASS, to discomfit [v]\n",
  "EMBARRASSINGLY": "EMBARRASSING, EMBARRASS, to discomfit [adv]\n",
  "EMBARRASSMENT": "confusion or disturbance of mind [n -S]\n",
  "EMBARRASSMENTS": "EMBARRASSMENT, confusion or disturbance of mind [n]\n",
  "EMBARRED": "EMBAR, (archaic) to shut in; to put under embargo, also IMBAR [v]\n",
  "EMBARRING": "the act of shutting in [n -S]\n",
  "EMBARRINGS": "EMBARRING, the act of shutting in [n]\n",
  "EMBARS": "EMBAR, (archaic) to shut in; to put under embargo, also IMBAR [v]\n",
  "EMBASE": "to lower, also EMBACE, IMBASE [v EMBASTE or EMBASED, EMBASING, EMBASES]\n",
  "EMBASED": "EMBASE, to lower, also EMBACE, IMBASE [v]\n",
  "EMBASEMENT": "the act of bringing down; depravation [n -S]\n",
  "EMBASEMENTS": "EMBASEMENT, the act of bringing down; depravation [n]\n",
  "EMBASES": "EMBASE, to lower, also EMBACE, IMBASE [v]\n",
  "EMBASING": "EMBASE, to lower, also EMBACE, IMBASE [v]\n",
  "EMBASSADE": "(Shakespeare) the mission of an ambassador [n -S]\n",
  "EMBASSADES": "EMBASSADE, (Shakespeare) the mission of an ambassador [n]\n",
  "EMBASSADOR": "(obsolete) an ambassador, also AMBASSADOR [n -S]\n",
  "EMBASSADORS": "EMBASSADOR, (obsolete) an ambassador, also AMBASSADOR [n]\n",
  "EMBASSAGE": "an embassy, also AMBASSAGE [n -S]\n",
  "EMBASSAGES": "EMBASSAGE, an embassy, also AMBASSAGE [n]\n",
  "EMBASSIES": "EMBASSY, the offices of an ambassador, also AMBASSY [n]\n",
  "EMBASSY": "the offices of an ambassador, also AMBASSY [n EMBASSIES]\n",
  "EMBASTE": "EMBACE, (Spenser) to lower, also EMBASE, IMBASE [v]\n",
  "EMBATHE": "to bathe, also IMBATHE [v EMBATHED, EMBATHING, EMBATHES]\n",
  "EMBATHED": "EMBATHE, to bathe, also IMBATHE [v]\n",
  "EMBATHES": "EMBATHE, to bathe, also IMBATHE [v]\n",
  "EMBATHING": "EMBATHE, to bathe, also IMBATHE [v]\n",
  "EMBATTLE": "to fortify against attack [v EMBATTLED, EMBATTLING, EMBATTLES]\n",
  "EMBATTLED": "EMBATTLE, to fortify against attack [v]\n",
  "EMBATTLEMENT": "a battlement [n -S]\n",
  "EMBATTLEMENTS": "EMBATTLEMENT, a battlement [n]\n",
  "EMBATTLES": "EMBATTLE, to fortify against attack [v]\n",
  "EMBATTLING": "EMBATTLE, to fortify against attack [v]\n",
  "EMBAY": "to enclose in a bay [v -ED, -ING, -S]\n",
  "EMBAYED": "EMBAY, to enclose in a bay [v]\n",
  "EMBAYING": "EMBAY, to enclose in a bay [v]\n",
  "EMBAYLD": "EMBAIL, (obsolete) to encircle, to hoop in [v]\n",
  "EMBAYMENT": "a bay; a recess in a coastline forming a bay [n -S]\n",
  "EMBAYMENTS": "EMBAYMENT, a bay; a recess in a coastline forming a bay [n]\n",
  "EMBAYS": "EMBAY, to enclose in a bay [v]\n",
  "EMBED": "to plant firmly, also IMBED [v EMBEDDED, EMBEDDING, EMBEDS]\n",
  "EMBEDDED": "EMBED, to plant firmly, also IMBED [v]\n",
  "EMBEDDING": "the technique by which specimens are embedded in a supporting medium in preparation for sectioning with a microtome and viewing with a microscope [n -S]\n",
  "EMBEDDINGS": "EMBEDDING, the technique by which specimens are embedded in a supporting medium in preparation for sectioning with a microtome and viewing with a microscope [n]\n",
  "EMBEDMENT": "the act of embedding, or the state of being embedded [n -S]\n",
  "EMBEDMENTS": "EMBEDMENT, the act of embedding, or the state of being embedded [n]\n",
  "EMBEDS": "EMBED, to plant firmly, also IMBED [v]\n",
  "EMBELLISH": "to add beauty to [v -ED, -ING, -ES]\n",
  "EMBELLISHED": "EMBELLISH, to add beauty to [v]\n",
  "EMBELLISHER": "one who embellishes [n -S]\n",
  "EMBELLISHERS": "EMBELLISHER, one who embellishes [n]\n",
  "EMBELLISHES": "EMBELLISH, to add beauty to [v]\n",
  "EMBELLISHING": "EMBELLISH, to add beauty to [v]\n",
  "EMBELLISHINGLY": "EMBELLISHING, EMBELLISH, to add beauty to [adv]\n",
  "EMBELLISHMENT": "the act of embellishing [n -S]\n",
  "EMBELLISHMENTS": "EMBELLISHMENT, the act of embellishing [n]\n",
  "EMBER": "a small piece of wood or coal from a dying fire [n -S]\n",
  "EMBERS": "EMBER, a small piece of wood or coal from a dying fire [n]\n",
  "EMBEZZLE": "to appropriate money fraudulently for one's own use [v EMBEZZLED, EMBEZZLING, EMBEZZLES]\n",
  "EMBEZZLED": "EMBEZZLE, to appropriate money fraudulently for one's own use [v]\n",
  "EMBEZZLEMENT": "the act of embezzling [n -S]\n",
  "EMBEZZLEMENTS": "EMBEZZLEMENT, the act of embezzling [n]\n",
  "EMBEZZLER": "one who embezzles [n -S]\n",
  "EMBEZZLERS": "EMBEZZLER, one who embezzles [n]\n",
  "EMBEZZLES": "EMBEZZLE, to appropriate money fraudulently for one's own use [v]\n",
  "EMBEZZLING": "EMBEZZLE, to appropriate money fraudulently for one's own use [v]\n",
  "EMBIGGEN": "to make bigger or more expansive [v -ED, -ING, -S]\n",
  "EMBIGGENED": "EMBIGGEN, to make bigger or more expansive [v]\n",
  "EMBIGGENING": "EMBIGGEN, to make bigger or more expansive [v]\n",
  "EMBIGGENS": "EMBIGGEN, to make bigger or more expansive [v]\n",
  "EMBITTER": "to make bitter, also IMBITTER [v -ED, -ING, -S]\n",
  "EMBITTERED": "EMBITTER, to make bitter, also IMBITTER [v]\n",
  "EMBITTERER": "one who embitters [n -S]\n",
  "EMBITTERERS": "EMBITTERER, one who embitters [n]\n",
  "EMBITTERING": "the act of making bitter [n -S]\n",
  "EMBITTERINGS": "EMBITTERING, the act of making bitter [n]\n",
  "EMBITTERMENT": "the act of embittering [n -S]\n",
  "EMBITTERMENTS": "EMBITTERMENT, the act of embittering [n]\n",
  "EMBITTERS": "EMBITTER, to make bitter, also IMBITTER [v]\n",
  "EMBLAZE": "to set on fire, also IMBLAZE [v EMBLAZED, EMBLAZING, EMBLAZES]\n",
  "EMBLAZED": "EMBLAZE, to set on fire, also IMBLAZE [v]\n",
  "EMBLAZER": "one who emblazes [n -S]\n",
  "EMBLAZERS": "EMBLAZER, one who emblazes [n]\n",
  "EMBLAZES": "EMBLAZE, to set on fire, also IMBLAZE [v]\n",
  "EMBLAZING": "EMBLAZE, to set on fire, also IMBLAZE [v]\n",
  "EMBLAZON": "to depict heraldically [v -ED, -ING, -S]\n",
  "EMBLAZONED": "EMBLAZON, to depict heraldically [v]\n",
  "EMBLAZONER": "one who emblazons [n -S]\n",
  "EMBLAZONERS": "EMBLAZONER, one who emblazons [n]\n",
  "EMBLAZONING": "EMBLAZON, to depict heraldically [v]\n",
  "EMBLAZONMENT": "the act of emblazoning [n -S]\n",
  "EMBLAZONMENTS": "EMBLAZONMENT, the act of emblazoning [n]\n",
  "EMBLAZONRIES": "EMBLAZONRY, the act or art of an emblazoner [n]\n",
  "EMBLAZONRY": "the act or art of an emblazoner [n EMBLAZONRIES]\n",
  "EMBLAZONS": "EMBLAZON, to depict heraldically [v]\n",
  "EMBLEM": "to represent with a symbolic device [v -ED, -ING, -S]\n",
  "EMBLEMA": "(Greek) a carved or mounted ornament in relief [n EMBLEMATA]\n",
  "EMBLEMATA": "EMBLEMA, (Greek) a carved or mounted ornament in relief [n]\n",
  "EMBLEMATIC": "of, relating to, or constituting an emblem, also EMBLEMATICAL [adj EMBLEMATICALLY]\n",
  "EMBLEMATICAL": "of, relating to, or constituting an emblem, also EMBLEMATIC [adj EMBLEMATICALLY]\n",
  "EMBLEMATICALLY": "EMBLEMATICAL, of, relating to, or constituting an emblem, also EMBLEMATIC [adv]\n",
  "EMBLEMATISE": "to represent by or as if by an emblem, also EMBLEMATIZE [v EMBLEMATISED, EMBLEMATISING, EMBLEMATISES]\n",
  "EMBLEMATISED": "EMBLEMATISE, to represent by or as if by an emblem, also EMBLEMATIZE [v]\n",
  "EMBLEMATISES": "EMBLEMATISE, to represent by or as if by an emblem, also EMBLEMATIZE [v]\n",
  "EMBLEMATISING": "EMBLEMATISE, to represent by or as if by an emblem, also EMBLEMATIZE [v]\n",
  "EMBLEMATIST": "a user or inventor of emblems [n -S]\n",
  "EMBLEMATISTS": "EMBLEMATIST, a user or inventor of emblems [n]\n",
  "EMBLEMATIZE": "to represent by or as if by an emblem, also EMBLEMATISE [v EMBLEMATIZED, EMBLEMATIZING, EMBLEMATIZES]\n",
  "EMBLEMATIZED": "EMBLEMATIZE, to represent by or as if by an emblem, also EMBLEMATISE [v]\n",
  "EMBLEMATIZES": "EMBLEMATIZE, to represent by or as if by an emblem, also EMBLEMATISE [v]\n",
  "EMBLEMATIZING": "EMBLEMATIZE, to represent by or as if by an emblem, also EMBLEMATISE [v]\n",
  "EMBLEMED": "EMBLEM, to represent with a symbolic device [v]\n",
  "EMBLEMENTS": "crops raised by the labour of the cultivator of land (but not tree-fruits or grass) or the profits arising from these [n]\n",
  "EMBLEMING": "EMBLEM, to represent with a symbolic device [v]\n",
  "EMBLEMISE": "to represent by or as if by an emblem, also EMBLEMIZE [v EMBLEMISED, EMBLEMISING, EMBLEMISES]\n",
  "EMBLEMISED": "EMBLEMISE, to represent by or as if by an emblem, also EMBLEMIZE [v]\n",
  "EMBLEMISES": "EMBLEMISE, to represent by or as if by an emblem, also EMBLEMIZE [v]\n",
  "EMBLEMISING": "EMBLEMISE, to represent by or as if by an emblem, also EMBLEMIZE [v]\n",
  "EMBLEMIZE": "to represent by or as if by an emblem, also EMBLEMISE [v EMBLEMIZED, EMBLEMIZING, EMBLEMIZES]\n",
  "EMBLEMIZED": "EMBLEMIZE, to represent by or as if by an emblem, also EMBLEMISE [v]\n",
  "EMBLEMIZES": "EMBLEMIZE, to represent by or as if by an emblem, also EMBLEMISE [v]\n",
  "EMBLEMIZING": "EMBLEMIZE, to represent by or as if by an emblem, also EMBLEMISE [v]\n",
  "EMBLEMS": "EMBLEM, to represent with a symbolic device [v]\n",
  "EMBLIC": "(Arabic) a tree of the euphorbia family, native to tropical Asia [n -S]\n",
  "EMBLICS": "EMBLIC, (Arabic) a tree of the euphorbia family, native to tropical Asia [n]\n",
  "EMBLOOM": "to cover with bloom [v -ED, -ING, -S]\n",
  "EMBLOOMED": "EMBLOOM, to cover with bloom [v]\n",
  "EMBLOOMING": "EMBLOOM, to cover with bloom [v]\n",
  "EMBLOOMS": "EMBLOOM, to cover with bloom [v]\n",
  "EMBLOSSOM": "to cover or adorn with blossoms [v -ED, -ING, -S]\n",
  "EMBLOSSOMED": "EMBLOSSOM, to cover or adorn with blossoms [v]\n",
  "EMBLOSSOMING": "EMBLOSSOM, to cover or adorn with blossoms [v]\n",
  "EMBLOSSOMS": "EMBLOSSOM, to cover or adorn with blossoms [v]\n",
  "EMBODIED": "EMBODY, to form into a body, also IMBODY [v]\n",
  "EMBODIER": "one who embodies [n -S]\n",
  "EMBODIERS": "EMBODIER, one who embodies [n]\n",
  "EMBODIES": "EMBODY, to form into a body, also IMBODY [v]\n",
  "EMBODIMENT": "one that embodies something [n -S]\n",
  "EMBODIMENTS": "EMBODIMENT, one that embodies something [n]\n",
  "EMBODY": "to form into a body, also IMBODY [v EMBODIED, EMBODYING, EMBODIES]\n",
  "EMBODYING": "EMBODY, to form into a body, also IMBODY [v]\n",
  "EMBOG": "to bog down [v EMBOGGED, EMBOGGING, EMBOGS]\n",
  "EMBOGGED": "EMBOG, to bog down [v]\n",
  "EMBOGGING": "EMBOG, to bog down [v]\n",
  "EMBOGS": "EMBOG, to bog down [v]\n",
  "EMBOGUE": "to flow out from a river mouth [v EMBOGUED, EMBOGUING, EMBOGUES]\n",
  "EMBOGUED": "EMBOGUE, to flow out from a river mouth [v]\n",
  "EMBOGUES": "EMBOGUE, to flow out from a river mouth [v]\n",
  "EMBOGUING": "EMBOGUE, to flow out from a river mouth [v]\n",
  "EMBOIL": "(obsolete) to burn with anger [v -ED, -ING, -S]\n",
  "EMBOILED": "EMBOIL, (obsolete) to burn with anger [v]\n",
  "EMBOILING": "EMBOIL, (obsolete) to burn with anger [v]\n",
  "EMBOILS": "EMBOIL, (obsolete) to burn with anger [v]\n",
  "EMBOITEMENT": "(French) encasement [n -S]\n",
  "EMBOITEMENTS": "EMBOITEMENT, (French) encasement [n]\n",
  "EMBOLDEN": "to instil with courage, also IMBOLDEN [v -ED, -ING, -S]\n",
  "EMBOLDENED": "EMBOLDEN, to instil with courage, also IMBOLDEN [v]\n",
  "EMBOLDENER": "one who emboldens [n -S]\n",
  "EMBOLDENERS": "EMBOLDENER, one who emboldens [n]\n",
  "EMBOLDENING": "EMBOLDEN, to instil with courage, also IMBOLDEN [v]\n",
  "EMBOLDENS": "EMBOLDEN, to instil with courage, also IMBOLDEN [v]\n",
  "EMBOLECTOMIES": "EMBOLECTOMY, the surgical removal of an embolism [n]\n",
  "EMBOLECTOMY": "the surgical removal of an embolism [n EMBOLECTOMIES]\n",
  "EMBOLI": "EMBOLUS, (Latin) a clot or air bubble obstructing a blood-vessel [n]\n",
  "EMBOLIC": "pertaining to an embolism, the presence of one or more obstructing blood-clots in a blood vessel, also EMBOLISMIC [adj]\n",
  "EMBOLIES": "EMBOLY, the formation of a gastrula by invagination of the blastula [n]\n",
  "EMBOLISATION": "the process of embolising, also EMBOLIZATION [n -S]\n",
  "EMBOLISATIONS": "EMBOLISATION, the process of embolising, also EMBOLIZATION [n]\n",
  "EMBOLISE": "to cause an embolism, also EMBOLIZE [v EMBOLISED, EMBOLISING, EMBOLISES]\n",
  "EMBOLISED": "EMBOLISE, to cause an embolism, also EMBOLIZE [v]\n",
  "EMBOLISES": "EMBOLISE, to cause an embolism, also EMBOLIZE [v]\n",
  "EMBOLISING": "EMBOLISE, to cause an embolism, also EMBOLIZE [v]\n",
  "EMBOLISM": "obstruction of a blood vessel by an embolus [n -S]\n",
  "EMBOLISMAL": "pertaining to embolism [adj]\n",
  "EMBOLISMIC": "pertaining to an embolism, the presence of one or more obstructing blood-clots in a blood vessel, also EMBOLIC [adj]\n",
  "EMBOLISMS": "EMBOLISM, obstruction of a blood vessel by an embolus [n]\n",
  "EMBOLIZATION": "the process of embolizing, also EMBOLISATION [n -S]\n",
  "EMBOLIZATIONS": "EMBOLIZATION, the process of embolizing, also EMBOLISATION [n]\n",
  "EMBOLIZE": "to cause an embolism, also EMBOLISE [v EMBOLIZED, EMBOLIZING, EMBOLIZES]\n",
  "EMBOLIZED": "EMBOLIZE, to cause an embolism, also EMBOLISE [v]\n",
  "EMBOLIZES": "EMBOLIZE, to cause an embolism, also EMBOLISE [v]\n",
  "EMBOLIZING": "EMBOLIZE, to cause an embolism, also EMBOLISE [v]\n",
  "EMBOLUS": "(Latin) a clot or air bubble obstructing a blood-vessel [n EMBOLUSES or EMBOLI]\n",
  "EMBOLUSES": "EMBOLUS, (Latin) a clot or air bubble obstructing a blood-vessel [n]\n",
  "EMBOLY": "the formation of a gastrula by invagination of the blastula [n EMBOLIES]\n",
  "EMBONPOINT": "(French) plumpness of person; stoutness [n -S]\n",
  "EMBONPOINTS": "EMBONPOINT, (French) plumpness of person; stoutness [n]\n",
  "EMBORDER": "to provide with a border, also IMBORDER [v -ED, -ING, -S]\n",
  "EMBORDERED": "EMBORDER, to provide with a border, also IMBORDER [v]\n",
  "EMBORDERING": "EMBORDER, to provide with a border, also IMBORDER [v]\n",
  "EMBORDERS": "EMBORDER, to provide with a border, also IMBORDER [v]\n",
  "EMBOSCATA": "(Italian) an ambuscade [n -S]\n",
  "EMBOSCATAS": "EMBOSCATA, (Italian) an ambuscade [n]\n",
  "EMBOSK": "to conceal with foliage [v -ED, -ING, -S]\n",
  "EMBOSKED": "EMBOSK, to conceal with foliage [v]\n",
  "EMBOSKING": "EMBOSK, to conceal with foliage [v]\n",
  "EMBOSKS": "EMBOSK, to conceal with foliage [v]\n",
  "EMBOSOM": "to embrace, also IMBOSOM [v -ED, -ING, -S]\n",
  "EMBOSOMED": "EMBOSOM, to embrace, also IMBOSOM [v]\n",
  "EMBOSOMING": "EMBOSOM, to embrace, also IMBOSOM [v]\n",
  "EMBOSOMS": "EMBOSOM, to embrace, also IMBOSOM [v]\n",
  "EMBOSS": "to decorate with a raised design, also IMBOSS [v EMBOSSED, EMBOST, EMBOSSING, EMBOSSES]\n",
  "EMBOSSABLE": "that can be embossed [adj]\n",
  "EMBOSSED": "EMBOSS, to decorate with a raised design, also IMBOSS [v]\n",
  "EMBOSSER": "one who embosses [n -S]\n",
  "EMBOSSERS": "EMBOSSER, one who embosses [n]\n",
  "EMBOSSES": "EMBOSS, to decorate with a raised design, also IMBOSS [v]\n",
  "EMBOSSING": "the act of decorating with raised designs [n -S]\n",
  "EMBOSSINGS": "EMBOSSING, the act of decorating with raised designs [n]\n",
  "EMBOSSMENT": "the act of forming bosses or raised figures [n -S]\n",
  "EMBOSSMENTS": "EMBOSSMENT, the act of forming bosses or raised figures [n]\n",
  "EMBOST": "EMBOSS, to decorate with a raised design, also IMBOSS [v]\n",
  "EMBOTHRIUM": "an evergreen shrub native to South America, widely cultivated as an ornamental for its scarlet flowers [n -S]\n",
  "EMBOTHRIUMS": "EMBOTHRIUM, an evergreen shrub native to South America, widely cultivated as an ornamental for its scarlet flowers [n]\n",
  "EMBOUCHURE": "(French) the position and use of the lips in producing a musical tone on a wind instrument [n -S]\n",
  "EMBOUCHURES": "EMBOUCHURE, (French) the position and use of the lips in producing a musical tone on a wind instrument [n]\n",
  "EMBOUND": "(Shakespeare) to enclose [v -ED, -ING, -S]\n",
  "EMBOUNDED": "EMBOUND, (Shakespeare) to enclose [v]\n",
  "EMBOUNDING": "EMBOUND, (Shakespeare) to enclose [v]\n",
  "EMBOUNDS": "EMBOUND, (Shakespeare) to enclose [v]\n",
  "EMBOURGEOISE": "to cause to become bourgeois or middle-class [v EMBOURGEOISED, EMBOURGEOISING, EMBOURGEOISES]\n",
  "EMBOURGEOISED": "EMBOURGEOISE, to cause to become bourgeois or middle-class [v]\n",
  "EMBOURGEOISES": "EMBOURGEOISE, to cause to become bourgeois or middle-class [v]\n",
  "EMBOURGEOISING": "EMBOURGEOISE, to cause to become bourgeois or middle-class [v]\n",
  "EMBOW": "to bend or arch [v -ED, -ING, -S]\n",
  "EMBOWED": "EMBOW, to bend or arch [v]\n",
  "EMBOWEL": "to remove the entrails of, also DISEMBOWEL [v EMBOWELLED, EMBOWELLING, EMBOWELS]\n",
  "EMBOWELED": "EMBOWEL, to remove the entrails of, also DISEMBOWEL [v]\n",
  "EMBOWELING": "EMBOWEL, to remove the entrails of, also DISEMBOWEL [v]\n",
  "EMBOWELLED": "EMBOWEL, to remove the entrails of, also DISEMBOWEL [v]\n",
  "EMBOWELLING": "EMBOWEL, to remove the entrails of, also DISEMBOWEL [v]\n",
  "EMBOWELMENT": "the act of embowelling [n -S]\n",
  "EMBOWELMENTS": "EMBOWELMENT, the act of embowelling [n]\n",
  "EMBOWELS": "EMBOWEL, to remove the entrails of, also DISEMBOWEL [v]\n",
  "EMBOWER": "to place in a bower; to shelter with trees, also IMBOWER [v -ED, -ING, -S]\n",
  "EMBOWERED": "EMBOWER, to place in a bower; to shelter with trees, also IMBOWER [v]\n",
  "EMBOWERING": "EMBOWER, to place in a bower; to shelter with trees, also IMBOWER [v]\n",
  "EMBOWERMENT": "the act of embowering [n -S]\n",
  "EMBOWERMENTS": "EMBOWERMENT, the act of embowering [n]\n",
  "EMBOWERS": "EMBOWER, to place in a bower; to shelter with trees, also IMBOWER [v]\n",
  "EMBOWING": "EMBOW, to bend or arch [v]\n",
  "EMBOWMENT": "the act of embowing, bending [n -S]\n",
  "EMBOWMENTS": "EMBOWMENT, the act of embowing, bending [n]\n",
  "EMBOWS": "EMBOW, to bend or arch [v]\n",
  "EMBOX": "to set in a box [v -ED, -ING, -ES]\n",
  "EMBOXED": "EMBOX, to set in a box [v]\n",
  "EMBOXES": "EMBOX, to set in a box [v]\n",
  "EMBOXING": "EMBOX, to set in a box [v]\n",
  "EMBRACE": "to hug [v EMBRACED, EMBRACING, EMBRACES]\n",
  "EMBRACEABLE": "capable of being embraced [adj]\n",
  "EMBRACED": "EMBRACE, to hug [v]\n",
  "EMBRACEMENT": "an embrace; an undertaking [n -S]\n",
  "EMBRACEMENTS": "EMBRACEMENT, an embrace; an undertaking [n]\n",
  "EMBRACEOR": "a person who seeks to influence jurors by corrupt means to deliver a partial verdict, also EMBRACER, EMBRASOR [n -S]\n",
  "EMBRACEORS": "EMBRACEOR, a person who seeks to influence jurors by corrupt means to deliver a partial verdict, also EMBRACER, EMBRASOR [n]\n",
  "EMBRACER": "a person who seeks to influence jurors by corrupt means, also EMBRACEOR, EMBRASOR [n -S]\n",
  "EMBRACERIES": "EMBRACERY, an attempt to influence a jury illegally as by bribery, threats, or promises [n]\n",
  "EMBRACERS": "EMBRACER, a person who seeks to influence jurors by corrupt means, also EMBRACEOR, EMBRASOR [n]\n",
  "EMBRACERY": "an attempt to influence a jury illegally as by bribery, threats, or promises [n EMBRACERIES]\n",
  "EMBRACES": "EMBRACE, to hug [v]\n",
  "EMBRACING": "EMBRACE, to hug [v]\n",
  "EMBRACINGLY": "EMBRACING, EMBRACE, to hug [adv]\n",
  "EMBRACINGNESS": "the state of being embracing [n -ES]\n",
  "EMBRACINGNESSES": "EMBRACINGNESS, the state of being embracing [n]\n",
  "EMBRACIVE": "disposed to embrace [adj]\n",
  "EMBRAID": "(Spenser) to braid, also EMBREAD [v -ED, -ING, -S]\n",
  "EMBRAIDED": "EMBRAID, (Spenser) to braid, also EMBREAD [v]\n",
  "EMBRAIDING": "EMBRAID, (Spenser) to braid, also EMBREAD [v]\n",
  "EMBRAIDS": "EMBRAID, (Spenser) to braid, also EMBREAD [v]\n",
  "EMBRANCHMENT": "branching out [n -S]\n",
  "EMBRANCHMENTS": "EMBRANCHMENT, branching out [n]\n",
  "EMBRANGLE": "(archaic) to embroil or entangle, also IMBRANGLE [v EMBRANGLED, EMBRANGLING, EMBRANGLES]\n",
  "EMBRANGLED": "EMBRANGLE, (archaic) to embroil or entangle, also IMBRANGLE [v]\n",
  "EMBRANGLEMENT": "the act of embrangling [n -S]\n",
  "EMBRANGLEMENTS": "EMBRANGLEMENT, the act of embrangling [n]\n",
  "EMBRANGLES": "EMBRANGLE, (archaic) to embroil or entangle, also IMBRANGLE [v]\n",
  "EMBRANGLING": "EMBRANGLE, (archaic) to embroil or entangle, also IMBRANGLE [v]\n",
  "EMBRASOR": "a person who seeks to influence jurors by corrupt means, also EMBRACEOR, EMBRACER [n -S]\n",
  "EMBRASORS": "EMBRASOR, a person who seeks to influence jurors by corrupt means, also EMBRACEOR, EMBRACER [n]\n",
  "EMBRASURE": "(French) a loophole in fortifications; a window-opening with slanted sides, also EMBRAZURE [n -S]\n",
  "EMBRASURED": "having an embrasure, a loophole in fortifications [adj]\n",
  "EMBRASURES": "EMBRASURE, (French) a loophole in fortifications; a window-opening with slanted sides, also EMBRAZURE [n]\n",
  "EMBRAVE": "to inspire with bravery [v EMBRAVED, EMBRAVING, EMBRAVES]\n",
  "EMBRAVED": "EMBRAVE, to inspire with bravery [v]\n",
  "EMBRAVES": "EMBRAVE, to inspire with bravery [v]\n",
  "EMBRAVING": "EMBRAVE, to inspire with bravery [v]\n",
  "EMBRAZURE": "(French) a loophole in fortifications; a window-opening with slanted sides, also EMBRASURE [n -S]\n",
  "EMBRAZURES": "EMBRAZURE, (French) a loophole in fortifications; a window-opening with slanted sides, also EMBRASURE [n]\n",
  "EMBREAD": "(Spenser) to braid, also EMBRAID [v -ED, -ING, -S]\n",
  "EMBREADED": "EMBREAD, (Spenser) to braid, also EMBRAID [v]\n",
  "EMBREADING": "EMBREAD, (Spenser) to braid, also EMBRAID [v]\n",
  "EMBREADS": "EMBREAD, (Spenser) to braid, also EMBRAID [v]\n",
  "EMBREATHE": "(archaic) to breathe into [v EMBREATHED, EMBREATHING, EMBREATHES]\n",
  "EMBREATHED": "EMBREATHE, (archaic) to breathe into [v]\n",
  "EMBREATHES": "EMBREATHE, (archaic) to breathe into [v]\n",
  "EMBREATHING": "EMBREATHE, (archaic) to breathe into [v]\n",
  "EMBRITTLE": "(archaic) to make or become brittle [v EMBRITTLED, EMBRITTLING, EMBRITTLES]\n",
  "EMBRITTLED": "EMBRITTLE, (archaic) to make or become brittle [v]\n",
  "EMBRITTLEMENT": "the act of embrittling [n -S]\n",
  "EMBRITTLEMENTS": "EMBRITTLEMENT, the act of embrittling [n]\n",
  "EMBRITTLES": "EMBRITTLE, (archaic) to make or become brittle [v]\n",
  "EMBRITTLING": "EMBRITTLE, (archaic) to make or become brittle [v]\n",
  "EMBROCATE": "to moisten and rub with a lotion [v EMBROCATED, EMBROCATING, EMBROCATES]\n",
  "EMBROCATED": "EMBROCATE, to moisten and rub with a lotion [v]\n",
  "EMBROCATES": "EMBROCATE, to moisten and rub with a lotion [v]\n",
  "EMBROCATING": "EMBROCATE, to moisten and rub with a lotion [v]\n",
  "EMBROCATION": "a liquid medication rubbed on the skin [n -S]\n",
  "EMBROCATIONS": "EMBROCATION, a liquid medication rubbed on the skin [n]\n",
  "EMBROGLIO": "(Italian) a confusing or disturbing situation, also IMBROGLIO [n -S]\n",
  "EMBROGLIOS": "EMBROGLIO, (Italian) a confusing or disturbing situation, also IMBROGLIO [n]\n",
  "EMBROIDER": "to ornament with designs in needlework, also BROIDER [v -ED, -ING, -S]\n",
  "EMBROIDERED": "EMBROIDER, to ornament with designs in needlework, also BROIDER [v]\n",
  "EMBROIDERER": "one who embroiders, also BROIDERER [n -S]\n",
  "EMBROIDERERS": "EMBROIDERER, one who embroiders, also BROIDERER [n]\n",
  "EMBROIDERIES": "EMBROIDERY, the art or process of forming decorative designs with hand or machine needlework, also BROIDERY [n]\n",
  "EMBROIDERING": "EMBROIDER, to ornament with designs in needlework, also BROIDER [v]\n",
  "EMBROIDERS": "EMBROIDER, to ornament with designs in needlework, also BROIDER [v]\n",
  "EMBROIDERY": "the art or process of forming decorative designs with hand or machine needlework, also BROIDERY [n EMBROIDERIES]\n",
  "EMBROIL": "to involve in conflict [v -ED, -ING, -S]\n",
  "EMBROILED": "EMBROIL, to involve in conflict [v]\n",
  "EMBROILER": "one who embroils [n -S]\n",
  "EMBROILERS": "EMBROILER, one who embroils [n]\n",
  "EMBROILING": "EMBROIL, to involve in conflict [v]\n",
  "EMBROILMENT": "the state of being embroiled [n -S]\n",
  "EMBROILMENTS": "EMBROILMENT, the state of being embroiled [n]\n",
  "EMBROILS": "EMBROIL, to involve in conflict [v]\n",
  "EMBROWN": "to make brown, also IMBROWN [v -ED, -ING, -S]\n",
  "EMBROWNED": "EMBROWN, to make brown, also IMBROWN [v]\n",
  "EMBROWNING": "EMBROWN, to make brown, also IMBROWN [v]\n",
  "EMBROWNS": "EMBROWN, to make brown, also IMBROWN [v]\n",
  "EMBRUE": "to drench, also IMBRUE [v EMBRUED, EMBRUING, EMBRUES]\n",
  "EMBRUED": "EMBRUE, to drench, also IMBRUE [v]\n",
  "EMBRUEMENT": "the act of embruing or state of being embrued, also IMBRUEMENT [n -S]\n",
  "EMBRUEMENTS": "EMBRUEMENT, the act of embruing or state of being embrued, also IMBRUEMENT [n]\n",
  "EMBRUES": "EMBRUE, to drench, also IMBRUE [v]\n",
  "EMBRUING": "EMBRUE, to drench, also IMBRUE [v]\n",
  "EMBRUTE": "(archaic) to degrade to the state of a brute, also IMBRUTE [v EMBRUTED, EMBRUTING, EMBRUTES]\n",
  "EMBRUTED": "EMBRUTE, (archaic) to degrade to the state of a brute, also IMBRUTE [v]\n",
  "EMBRUTES": "EMBRUTE, (archaic) to degrade to the state of a brute, also IMBRUTE [v]\n",
  "EMBRUTING": "EMBRUTE, (archaic) to degrade to the state of a brute, also IMBRUTE [v]\n",
  "EMBRYECTOMIES": "EMBRYECTOMY, the surgical removal of an embryo [n]\n",
  "EMBRYECTOMY": "the surgical removal of an embryo [n EMBRYECTOMIES]\n",
  "EMBRYO": "the entity which develops in a woman's womb until it is born as a baby, esp. up to about eight weeks, after which it is known as a foetus, also EMBRYON [n -S]\n",
  "EMBRYOGENESES": "EMBRYOGENESIS, the production of an embryo [n]\n",
  "EMBRYOGENESIS": "the production of an embryo [n EMBRYOGENESES]\n",
  "EMBRYOGENETIC": "relating to embryogenesis [adj]\n",
  "EMBRYOGENIC": "relating to embryogeny [adj]\n",
  "EMBRYOGENIES": "EMBRYOGENY, the production and development of an embryo [n]\n",
  "EMBRYOGENY": "the production and development of an embryo [n EMBRYOGENIES]\n",
  "EMBRYOID": "a mass of tissue that resembles an embryo [n -S]\n",
  "EMBRYOIDS": "EMBRYOID, a mass of tissue that resembles an embryo [n]\n",
  "EMBRYOLOGIC": "relating to embryology, also EMBRYOLOGICAL [adj EMBRYOLOGICALLY]\n",
  "EMBRYOLOGICAL": "relating to embryology, also EMBRYOLOGIC [adj EMBRYOLOGICALLY]\n",
  "EMBRYOLOGICALLY": "EMBRYOLOGICAL, relating to embryology, also EMBRYOLOGIC [adv]\n",
  "EMBRYOLOGIES": "EMBRYOLOGY, the science which relates to the formation and development of the embryo in animals and plants [n]\n",
  "EMBRYOLOGIST": "a specialist in embryology [n -S]\n",
  "EMBRYOLOGISTS": "EMBRYOLOGIST, a specialist in embryology [n]\n",
  "EMBRYOLOGY": "the science which relates to the formation and development of the embryo in animals and plants [n EMBRYOLOGIES]\n",
  "EMBRYON": "(archaic) an embryo [n -S]\n",
  "EMBRYONAL": "of or like an embryo, also EMBRYONIC, EMBRYOTIC [adj]\n",
  "EMBRYONATE": "(obsolete) of minerals, embedded in other material, also EMBRYONATED [adj]\n",
  "EMBRYONATED": "(obsolete) of minerals, embedded in other material, also EMBRYONATE [adj]\n",
  "EMBRYONIC": "of or like an embryo, also EMBRYONAL, EMBRYOTIC [adj EMBRYONICALLY]\n",
  "EMBRYONICALLY": "EMBRYONIC, of or like an embryo, also EMBRYONAL, EMBRYOTIC [adv]\n",
  "EMBRYONS": "EMBRYON, (archaic) an embryo [n]\n",
  "EMBRYOPHYTE": "any green photosynthetic organism which begins the development of the sporophyte generation within the archegonium [n -S]\n",
  "EMBRYOPHYTES": "EMBRYOPHYTE, any green photosynthetic organism which begins the development of the sporophyte generation within the archegonium [n]\n",
  "EMBRYOS": "EMBRYO, the entity which develops in a woman's womb until it is born as a baby, esp. up to about eight weeks, after which it is known as a foetus, also EMBRYON [n]\n",
  "EMBRYOTIC": "of or pertaining to an embryo [adj EMBRYOTICALLY]\n",
  "EMBRYOTICALLY": "EMBRYOTIC, of or pertaining to an embryo [adv]\n",
  "EMBRYOTOMIES": "EMBRYOTOMY, the cutting a fetus into pieces within the womb, so as to effect its removal [n]\n",
  "EMBRYOTOMY": "the cutting a fetus into pieces within the womb, so as to effect its removal [n EMBRYOTOMIES]\n",
  "EMBRYULCIA": "forcible extraction of a foetus [n -S]\n",
  "EMBRYULCIAS": "EMBRYULCIA, forcible extraction of a foetus [n]\n",
  "EMBUS": "to board a bus [v EMBUSSED or EMBUSED, EMBUSSING or EMBUSING, EMBUSSES or EMBUSES]\n",
  "EMBUSED": "EMBUS, to board a bus [v]\n",
  "EMBUSES": "EMBUS, to board a bus [v]\n",
  "EMBUSIED": "EMBUSY, (Spenser) to employ [v]\n",
  "EMBUSIES": "EMBUSY, (Spenser) to employ [v]\n",
  "EMBUSING": "EMBUS, to board a bus [v]\n",
  "EMBUSQUE": "(French) a slacker or shirker, a person who evades military service [n -S]\n",
  "EMBUSQUES": "EMBUSQUE, (French) a slacker or shirker, a person who evades military service [n]\n",
  "EMBUSSED": "EMBUS, to board a bus [v]\n",
  "EMBUSSES": "EMBUS, to board a bus [v]\n",
  "EMBUSSING": "EMBUS, to board a bus [v]\n",
  "EMBUSY": "(Spenser) to employ [v EMBUSIED, EMBUSYING, EMBUSIES]\n",
  "EMBUSYING": "EMBUSY, (Spenser) to employ [v]\n",
  "EMCEE": "to serve as master of ceremonies [v EMCEED, EMCEEING, EMCEES]\n",
  "EMCEED": "EMCEE, to serve as master of ceremonies [v]\n",
  "EMCEEING": "EMCEE, to serve as master of ceremonies [v]\n",
  "EMCEES": "EMCEE, to serve as master of ceremonies [v]\n",
  "EMDASH": "a mark in writing that indicates a break in thought or structure [n -ES]\n",
  "EMDASHES": "EMDASH, a mark in writing that indicates a break in thought or structure [n]\n",
  "EME": "(obsolete) an uncle [n -S]\n",
  "EMEER": "(Arabic) an Eastern ruler, also AMEER, AMIR, EMIR [n -S]\n",
  "EMEERATE": "the office of emeer, also AMEERATE, AMIRATE, EMIRATE [n -S]\n",
  "EMEERATES": "EMEERATE, the office of emeer, also AMEERATE, AMIRATE, EMIRATE [n]\n",
  "EMEERS": "EMEER, (Arabic) an Eastern ruler, also AMEER, AMIR, EMIR [n]\n",
  "EMEND": "to correct, also EMENDATE [v -ED, -ING, -S]\n",
  "EMENDABLE": "that can be emended [adj]\n",
  "EMENDALS": "funds set aside for repairs [n]\n",
  "EMENDATE": "to correct, also EMEND [v EMENDATED, EMENDATING, EMENDATES]\n",
  "EMENDATED": "EMENDATE, to correct, also EMEND [v]\n",
  "EMENDATES": "EMENDATE, to correct, also EMEND [v]\n",
  "EMENDATING": "EMENDATE, to correct, also EMEND [v]\n",
  "EMENDATION": "correction, usually of a text [n -S]\n",
  "EMENDATIONS": "EMENDATION, correction, usually of a text [n]\n",
  "EMENDATOR": "one who emends or critically edits [n -S]\n",
  "EMENDATORS": "EMENDATOR, one who emends or critically edits [n]\n",
  "EMENDATORY": "pertaining to emendation; corrective [adj]\n",
  "EMENDED": "EMEND, to correct, also EMENDATE [v]\n",
  "EMENDER": "one who emends [n -S]\n",
  "EMENDERS": "EMENDER, one who emends [n]\n",
  "EMENDING": "EMEND, to correct, also EMENDATE [v]\n",
  "EMENDS": "EMEND, to correct, also EMENDATE [v]\n",
  "EMERALD": "a gemstone, a green variety of beryl, also EMERAUDE, SMARAGD, SMARAGDE [n -S]\n",
  "EMERALDS": "EMERALD, a gemstone, a green variety of beryl, also EMERAUDE, SMARAGD, SMARAGDE [n]\n",
  "EMERAUDE": "(Spenser) emerald, also SMARAGD, SMARAGDE [n -S]\n",
  "EMERAUDES": "EMERAUDE, (Spenser) emerald, also SMARAGD, SMARAGDE [n]\n",
  "EMERG": "the section of a hospital that deals with emergencies [n -S]\n",
  "EMERGE": "to come into view [v EMERGED, EMERGING, EMERGES]\n",
  "EMERGED": "EMERGE, to come into view [v]\n",
  "EMERGENCE": "the act of emerging [n -S]\n",
  "EMERGENCES": "EMERGENCE, the act of emerging [n]\n",
  "EMERGENCIES": "EMERGENCY, an unexpected occurrence, requiring immediate action [n]\n",
  "EMERGENCY": "an unexpected occurrence, requiring immediate action [n EMERGENCIES]\n",
  "EMERGENT": "emerging [adj EMERGENTLY] / an effect produced by a combination of causes but unable to be seen as the sum of their individual effects [n -S]\n",
  "EMERGENTLY": "EMERGENT, emerging [adv]\n",
  "EMERGENTS": "EMERGENT, an effect produced by a combination of causes but unable to be seen as the sum of their individual effects [n]\n",
  "EMERGES": "EMERGE, to come into view [v]\n",
  "EMERGING": "EMERGE, to come into view [v]\n",
  "EMERGS": "EMERG, the section of a hospital that deals with emergencies [n]\n",
  "EMERIED": "EMERY, to coat with emery (a polishing powder) [v]\n",
  "EMERIES": "EMERY, to coat with emery (a polishing powder) [v]\n",
  "EMERITA": "(Latin) a retired woman who retains an honorary title [n EMERITAS or EMERITAE]\n",
  "EMERITAE": "EMERITA, (Latin) a retired woman who retains an honorary title [n]\n",
  "EMERITAS": "EMERITA, (Latin) a retired woman who retains an honorary title [n]\n",
  "EMERITI": "EMERITUS, (Latin) a retired person who retains an honorary title [n]\n",
  "EMERITUS": "(Latin) a retired person who retains an honorary title [n EMERITI]\n",
  "EMEROD": "a haemorrhoid, also EMEROID [n -S]\n",
  "EMERODS": "EMEROD, a haemorrhoid, also EMEROID [n]\n",
  "EMEROID": "a haemorrhoid, also EMEROD [n -S]\n",
  "EMEROIDS": "EMEROID, a haemorrhoid, also EMEROD [n]\n",
  "EMERSE": "of leaves, rising above the surface of water, also EMERSED [adj]\n",
  "EMERSED": "of leaves, rising above the surface of water, also EMERSE [adj]\n",
  "EMERSION": "the act of emerging esp. the reappearance of a heavenly body after eclipse or occultation [n -S]\n",
  "EMERSIONS": "EMERSION, the act of emerging esp. the reappearance of a heavenly body after eclipse or occultation [n]\n",
  "EMERY": "to coat with emery (a polishing powder) [v EMERIED, EMERYING, EMERIES]\n",
  "EMERYING": "EMERY, to coat with emery (a polishing powder) [v]\n",
  "EMES": "EME, (obsolete) an uncle [n]\n",
  "EMESES": "EMESIS, (Greek) the act of vomiting [n]\n",
  "EMESIS": "(Greek) the act of vomiting [n EMESES or EMESISES]\n",
  "EMESISES": "EMESIS, (Greek) the act of vomiting [n]\n",
  "EMETIC": "tending to cause vomiting, also EMETICAL [adj EMETICALLY] / an emetic substance [n -S]\n",
  "EMETICAL": "tending to cause vomiting, also EMETIC [adj EMETICALLY]\n",
  "EMETICALLY": "EMETICAL, tending to cause vomiting, also EMETIC [adv]\n",
  "EMETICS": "EMETIC, an emetic substance [n]\n",
  "EMETIN": "an alkaloid which causes vomiting, also EMETINE [n -S]\n",
  "EMETINE": "an alkaloid which causes vomiting, also EMETIN [n -S]\n",
  "EMETINES": "EMETINE, an alkaloid which causes vomiting, also EMETIN [n]\n",
  "EMETINS": "EMETIN, an alkaloid which causes vomiting, also EMETINE [n]\n",
  "EMETOPHOBIA": "the fear of vomiting [n -S]\n",
  "EMETOPHOBIAS": "EMETOPHOBIA, the fear of vomiting [n]\n",
  "EMEU": "aa large flightless bird, also EMU [n -S]\n",
  "EMEUS": "EMEU, aa large flightless bird, also EMU [n]\n",
  "EMEUTE": "(French) a popular rising or uproar [n -S]\n",
  "EMEUTES": "EMEUTE, (French) a popular rising or uproar [n]\n",
  "EMIC": "a type of linguistic analysis [n -S]\n",
  "EMICANT": "sparkling [adj]\n",
  "EMICATE": "to sparkle [v EMICATED, EMICATING, EMICATES]\n",
  "EMICATED": "EMICATE, to sparkle [v]\n",
  "EMICATES": "EMICATE, to sparkle [v]\n",
  "EMICATING": "EMICATE, to sparkle [v]\n",
  "EMICATION": "a sparkling [n -S]\n",
  "EMICATIONS": "EMICATION, a sparkling [n]\n",
  "EMICS": "EMIC, a type of linguistic analysis [n]\n",
  "EMICTION": "the discharge of urine [n -S]\n",
  "EMICTIONS": "EMICTION, the discharge of urine [n]\n",
  "EMICTORY": "promoting urine flow [adj]\n",
  "EMIGRANT": "one who emigrates [n -S]\n",
  "EMIGRANTS": "EMIGRANT, one who emigrates [n]\n",
  "EMIGRATE": "to leave one's birthplace to settle in another [v EMIGRATED, EMIGRATING, EMIGRATES]\n",
  "EMIGRATED": "EMIGRATE, to leave one's birthplace to settle in another [v]\n",
  "EMIGRATES": "EMIGRATE, to leave one's birthplace to settle in another [v]\n",
  "EMIGRATING": "EMIGRATE, to leave one's birthplace to settle in another [v]\n",
  "EMIGRATION": "the act of emigrating [n -S]\n",
  "EMIGRATIONAL": "relating to emigration [adj]\n",
  "EMIGRATIONIST": "an advocate or promoter of emigration [n -S]\n",
  "EMIGRATIONISTS": "EMIGRATIONIST, an advocate or promoter of emigration [n]\n",
  "EMIGRATIONS": "EMIGRATION, the act of emigrating [n]\n",
  "EMIGRATORY": "relating to emigration [adj]\n",
  "EMIGRE": "(French) one of the natives of France who were opposed to the first Revolution, and who left their country in consequence [n -S]\n",
  "EMIGREE": "(French) one of the (female) natives of France who were opposed to the first Revolution, and who left their country in consequence [n -S]\n",
  "EMIGREES": "EMIGREE, (French) one of the (female) natives of France who were opposed to the first Revolution, and who left their country in consequence [n]\n",
  "EMIGRES": "EMIGRE, (French) one of the natives of France who were opposed to the first Revolution, and who left their country in consequence [n]\n",
  "EMINENCE": "a high station or rank, also EMINENCY [n -S]\n",
  "EMINENCES": "EMINENCE, a high station or rank, also EMINENCY [n]\n",
  "EMINENCIES": "EMINENCY, a high station or rank, also EMINENCE [n]\n",
  "EMINENCY": "a high station or rank, also EMINENCE [n EMINENCIES]\n",
  "EMINENT": "of high station or rank [adj EMINENTLY]\n",
  "EMINENTIAL": "(obsolete) eminent, relating to eminence [adj]\n",
  "EMINENTLY": "EMINENT, of high station or rank [adv]\n",
  "EMIR": "(Arabic) an Eastern ruler, also AMEER, AMIR, EMEER [n -S]\n",
  "EMIRATE": "(Arabic) the rank of an emir, also EMEERATE [n -S]\n",
  "EMIRATES": "EMIRATE, (Arabic) the rank of an emir, also EMEERATE [n]\n",
  "EMIRS": "EMIR, (Arabic) an Eastern ruler, also AMEER, AMIR, EMEER [n]\n",
  "EMISSARIES": "EMISSARY, a person sent on a special mission [n]\n",
  "EMISSARY": "a person sent on a special mission [n EMISSARIES]\n",
  "EMISSILE": "able to be pushed out [adj]\n",
  "EMISSION": "the act of emitting [n -S]\n",
  "EMISSIONS": "EMISSION, the act of emitting [n]\n",
  "EMISSIVE": "emitting or sending out [adj]\n",
  "EMISSIVITIES": "EMISSIVITY, the ratio of emissive power of a surface at a given temperature to that of a black body at the same temperature and with the same surroundings [n]\n",
  "EMISSIVITY": "the ratio of emissive power of a surface at a given temperature to that of a black body at the same temperature and with the same surroundings [n EMISSIVITIES]\n",
  "EMIT": "to send forth [v EMITTED, EMITTING, EMITS]\n",
  "EMITS": "EMIT, to send forth [v]\n",
  "EMITTANCE": "the energy radiated by the surface of a body per unit area per second [n -S]\n",
  "EMITTANCES": "EMITTANCE, the energy radiated by the surface of a body per unit area per second [n]\n",
  "EMITTED": "EMIT, to send forth [v]\n",
  "EMITTER": "something that emits [n -S]\n",
  "EMITTERS": "EMITTER, something that emits [n]\n",
  "EMITTING": "EMIT, to send forth [v]\n",
  "EMLETS": "as in blood-drop emlets, a Chilean flower [n]\n",
  "EMMA": "formerly, a signaller's name for the letter M [n -S]\n",
  "EMMARBLE": "to adorn with marble [v EMMARBLED, EMMARBLING, EMMARBLES]\n",
  "EMMARBLED": "EMMARBLE, to adorn with marble [v]\n",
  "EMMARBLES": "EMMARBLE, to adorn with marble [v]\n",
  "EMMARBLING": "EMMARBLE, to adorn with marble [v]\n",
  "EMMAS": "EMMA, formerly, a signaller's name for the letter M [n]\n",
  "EMMENAGOGIC": "relating to an emmenagogue, a drug aiding menstrual flow [adj]\n",
  "EMMENAGOGUE": "a drug aiding menstrual flow [n -S]\n",
  "EMMENAGOGUES": "EMMENAGOGUE, a drug aiding menstrual flow [n]\n",
  "EMMENOLOGIES": "EMMENOLOGY, the study of menstruation [n]\n",
  "EMMENOLOGY": "the study of menstruation [n EMMENOLOGIES]\n",
  "EMMER": "(German) a primitive strain of wheat [n -S]\n",
  "EMMERS": "EMMER, (German) a primitive strain of wheat [n]\n",
  "EMMESH": "to entangle, also ENMESH, IMMESH, INMESH [v -ED, -ING, -ES]\n",
  "EMMESHED": "EMMESH, to entangle, also ENMESH, IMMESH, INMESH [v]\n",
  "EMMESHES": "EMMESH, to entangle, also ENMESH, IMMESH, INMESH [v]\n",
  "EMMESHING": "EMMESH, to entangle, also ENMESH, IMMESH, INMESH [v]\n",
  "EMMET": "(dialect) an ant [n -S]\n",
  "EMMETROPE": "a person showing emmetropia, correct refraction of light by the eyes [n -S]\n",
  "EMMETROPES": "EMMETROPE, a person showing emmetropia, correct refraction of light by the eyes [n]\n",
  "EMMETROPIA": "correct refraction of light by the eyes [n -S]\n",
  "EMMETROPIAS": "EMMETROPIA, correct refraction of light by the eyes [n]\n",
  "EMMETROPIC": "pertaining to, or characterized by, emmetropia [adj]\n",
  "EMMETS": "EMMET, (dialect) an ant [n]\n",
  "EMMEW": "to confine, mew up, as a hawk in mews, also ENMEW, IMMEW [v -ED, -ING, -S]\n",
  "EMMEWED": "EMMEW, to confine, mew up, as a hawk in mews, also ENMEW, IMMEW [v]\n",
  "EMMEWING": "EMMEW, to confine, mew up, as a hawk in mews, also ENMEW, IMMEW [v]\n",
  "EMMEWS": "EMMEW, to confine, mew up, as a hawk in mews, also ENMEW, IMMEW [v]\n",
  "EMMOVE": "(Spenser) to affect emotionally, also EMOVE, ENMOVE [v EMMOVED, EMMOVING, EMMOVES]\n",
  "EMMOVED": "EMMOVE, (Spenser) to affect emotionally, also EMOVE, ENMOVE [v]\n",
  "EMMOVES": "EMMOVE, (Spenser) to affect emotionally, also EMOVE, ENMOVE [v]\n",
  "EMMOVING": "EMMOVE, (Spenser) to affect emotionally, also EMOVE, ENMOVE [v]\n",
  "EMMY": "(tradename) a gold plated statuette awarded annually for television [n -S]\n",
  "EMMYS": "EMMY, (tradename) a gold plated statuette awarded annually for television [n]\n",
  "EMO": "a type of music combining traditional hard rock with personal and emotional lyrics, also EMOCORE [n -S]\n",
  "EMOCORE": "a type of music combining traditional hard rock with personal and emotional lyrics, also EMO [n -S]\n",
  "EMOCORES": "EMOCORE, a type of music combining traditional hard rock with personal and emotional lyrics, also EMO [n]\n",
  "EMODIN": "a compound obtained from rhubarb, cascara, and some other plants and having cathartic properties [n -S]\n",
  "EMODINS": "EMODIN, a compound obtained from rhubarb, cascara, and some other plants and having cathartic properties [n]\n",
  "EMOJI": "(Japanese) a standardized image with a specific meaning, used in electronic communication [n -S]\n",
  "EMOJIS": "EMOJI, (Japanese) a standardized image with a specific meaning, used in electronic communication [n]\n",
  "EMOLLESCENCE": "incipient fusion [n -S]\n",
  "EMOLLESCENCES": "EMOLLESCENCE, incipient fusion [n]\n",
  "EMOLLIATE": "to soften; to render effeminate [v EMOLLIATED, EMOLLIATING, EMOLLIATES]\n",
  "EMOLLIATED": "EMOLLIATE, to soften; to render effeminate [v]\n",
  "EMOLLIATES": "EMOLLIATE, to soften; to render effeminate [v]\n",
  "EMOLLIATING": "EMOLLIATE, to soften; to render effeminate [v]\n",
  "EMOLLIENCE": "the state of being emollient [n -S]\n",
  "EMOLLIENCES": "EMOLLIENCE, the state of being emollient [n]\n",
  "EMOLLIENT": "something that softens, makes supple [n -S]\n",
  "EMOLLIENTS": "EMOLLIENT, something that softens, makes supple [n]\n",
  "EMOLLITION": "the act of softening or relaxing [n -S]\n",
  "EMOLLITIONS": "EMOLLITION, the act of softening or relaxing [n]\n",
  "EMOLUMENT": "payment; profit arising from employment [n -S]\n",
  "EMOLUMENTAL": "relating to emolument [adj]\n",
  "EMOLUMENTARY": "relating to emolument [adj]\n",
  "EMOLUMENTS": "EMOLUMENT, payment; profit arising from employment [n]\n",
  "EMONG": "(obsolete) among, also AMONGST, EMONGES, EMONGEST, EMONGST, MONGST [prep]\n",
  "EMONGES": "(obsolete) in the midst of, also AMONG, AMONGST, EMONG, EMONGEST, EMONGST, MONGST [prep]\n",
  "EMONGEST": "(obsolete) in the midst of, also AMONG, AMONGST, EMONG, EMONGES, EMONGST, MONGST [prep]\n",
  "EMONGST": "(obsolete) in the midst of, also AMONG, AMONGST, EMONG, EMONGES, EMONGEST, MONGST [prep]\n",
  "EMOS": "EMO, a type of music combining traditional hard rock with personal and emotional lyrics, also EMOCORE [n]\n",
  "EMOTE": "to show exaggerated emotion [v EMOTED, EMOTING, EMOTES]\n",
  "EMOTED": "EMOTE, to show exaggerated emotion [v]\n",
  "EMOTER": "one who emotes, shows agitated emotion [n -S]\n",
  "EMOTERS": "EMOTER, one who emotes, shows agitated emotion [n]\n",
  "EMOTES": "EMOTE, to show exaggerated emotion [v]\n",
  "EMOTICON": "in computing, an icon used in an email to express feeling [n -S]\n",
  "EMOTICONS": "EMOTICON, in computing, an icon used in an email to express feeling [n]\n",
  "EMOTING": "EMOTE, to show exaggerated emotion [v]\n",
  "EMOTION": "instinctive feeling as opposed to reason [n -S]\n",
  "EMOTIONABLE": "capable of rousing emotion [adj]\n",
  "EMOTIONAL": "full of emotion [adj EMOTIONALLY]\n",
  "EMOTIONALISE": "to make emotional, also EMOTIONALIZE [v EMOTIONALISED, EMOTIONALISING, EMOTIONALISES]\n",
  "EMOTIONALISED": "EMOTIONALISE, to make emotional, also EMOTIONALIZE [v]\n",
  "EMOTIONALISES": "EMOTIONALISE, to make emotional, also EMOTIONALIZE [v]\n",
  "EMOTIONALISING": "EMOTIONALISE, to make emotional, also EMOTIONALIZE [v]\n",
  "EMOTIONALISM": "a tendency to regard things emotionally [n -S]\n",
  "EMOTIONALISMS": "EMOTIONALISM, a tendency to regard things emotionally [n]\n",
  "EMOTIONALIST": "one who bases a theory or policy on an emotional conviction [n -S]\n",
  "EMOTIONALISTIC": "basing theory or policy on an emotional conviction [adj]\n",
  "EMOTIONALISTS": "EMOTIONALIST, one who bases a theory or policy on an emotional conviction [n]\n",
  "EMOTIONALITIES": "EMOTIONALITY, the state of being emotional [n]\n",
  "EMOTIONALITY": "the state of being emotional [n EMOTIONALITIES]\n",
  "EMOTIONALIZE": "to make emotional, also EMOTIONALISE [v EMOTIONALIZED, EMOTIONALIZING, EMOTIONALIZES]\n",
  "EMOTIONALIZED": "EMOTIONALIZE, to make emotional, also EMOTIONALISE [v]\n",
  "EMOTIONALIZES": "EMOTIONALIZE, to make emotional, also EMOTIONALISE [v]\n",
  "EMOTIONALIZING": "EMOTIONALIZE, to make emotional, also EMOTIONALISE [v]\n",
  "EMOTIONALLY": "EMOTIONAL, full of emotion [adv]\n",
  "EMOTIONLESS": "expressing no emotion [adj EMOTIONLESSLY]\n",
  "EMOTIONLESSLY": "EMOTIONLESS, expressing no emotion [adv]\n",
  "EMOTIONLESSNESS": "EMOTIONLESS, expressing no emotion [n]\n",
  "EMOTIONS": "EMOTION, instinctive feeling as opposed to reason [n]\n",
  "EMOTIVE": "pertaining to emotion [adj EMOTIVELY]\n",
  "EMOTIVELY": "EMOTIVE, pertaining to emotion [adv]\n",
  "EMOTIVENESS": "the state of being emotive [n -ES]\n",
  "EMOTIVENESSES": "EMOTIVENESS, the state of being emotive [n]\n",
  "EMOTIVISM": "the theory that moral statements are inherently biased [n -S]\n",
  "EMOTIVISMS": "EMOTIVISM, the theory that moral statements are inherently biased [n]\n",
  "EMOTIVITIES": "EMOTIVITY, emotiveness [n]\n",
  "EMOTIVITY": "emotiveness [n EMOTIVITIES]\n",
  "EMOVE": "to affect emotionally, also EMMOVE, ENMOVE [v EMOVED, EMOVING, EMOVES]\n",
  "EMOVED": "EMOVE, to affect emotionally, also EMMOVE, ENMOVE [v]\n",
  "EMOVES": "EMOVE, to affect emotionally, also EMMOVE, ENMOVE [v]\n",
  "EMOVING": "EMOVE, to affect emotionally, also EMMOVE, ENMOVE [v]\n",
  "EMPACKET": "to pack up [v -ED, -ING, -S]\n",
  "EMPACKETED": "EMPACKET, to pack up [v]\n",
  "EMPACKETING": "EMPACKET, to pack up [v]\n",
  "EMPACKETS": "EMPACKET, to pack up [v]\n",
  "EMPAESTIC": "pertaining to the art of embossing [adj]\n",
  "EMPAIRE": "(Spenser) to become worse, also EMPARE [v EMPAIRED, EMPAIRING, EMPAIRES]\n",
  "EMPAIRED": "EMPAIRE, (Spenser) to become worse, also EMPARE [v]\n",
  "EMPAIRES": "EMPAIRE, (Spenser) to become worse, also EMPARE [v]\n",
  "EMPAIRING": "EMPAIRE, (Spenser) to become worse, also EMPARE [v]\n",
  "EMPALE": "to pierce with something pointed [v EMPALED, EMPALING, EMPALES]\n",
  "EMPALED": "EMPALE, to pierce with something pointed [v]\n",
  "EMPALEMENT": "a fencing, inclosing, or fortifying with stakes [n -S]\n",
  "EMPALEMENTS": "EMPALEMENT, a fencing, inclosing, or fortifying with stakes [n]\n",
  "EMPALER": "one that empales, impales, also IMPALER [n -S]\n",
  "EMPALERS": "EMPALER, one that empales, impales, also IMPALER [n]\n",
  "EMPALES": "EMPALE, to pierce with something pointed [v]\n",
  "EMPALING": "EMPALE, to pierce with something pointed [v]\n",
  "EMPANADA": "(Spanish) a pastry turnover [n -S]\n",
  "EMPANADAS": "EMPANADA, (Spanish) a pastry turnover [n]\n",
  "EMPANEL": "to select a jury from a list, also IMPANEL, IMPANNEL [v EMPANELED or EMPANELLED, EMPANELING or EMPANELLING, EMPANELS]\n",
  "EMPANELED": "EMPANEL, to select a jury from a list, also IMPANEL, IMPANNEL [v]\n",
  "EMPANELING": "EMPANEL, to select a jury from a list, also IMPANEL, IMPANNEL [v]\n",
  "EMPANELLED": "EMPANEL, to select a jury from a list, also IMPANEL, IMPANNEL [v]\n",
  "EMPANELLING": "EMPANEL, to select a jury from a list, also IMPANEL, IMPANNEL [v]\n",
  "EMPANELMENT": "the act of empanelling [n -S]\n",
  "EMPANELMENTS": "EMPANELMENT, the act of empanelling [n]\n",
  "EMPANELS": "EMPANEL, to select a jury from a list, also IMPANEL, IMPANNEL [v]\n",
  "EMPANOPLIED": "EMPANOPLY, to clothe in full armor [v]\n",
  "EMPANOPLIES": "EMPANOPLY, to clothe in full armor [v]\n",
  "EMPANOPLY": "to clothe in full armor [v EMPANOPLIED, EMPANOPLYING, EMPANOPLIES]\n",
  "EMPANOPLYING": "EMPANOPLY, to clothe in full armor [v]\n",
  "EMPARADISE": "(Milton) to put in a state like paradise; to make supremely happy [v EMPARADISED, EMPARADISING, EMPARADISES]\n",
  "EMPARADISED": "EMPARADISE, (Milton) to put in a state like paradise; to make supremely happy [v]\n",
  "EMPARADISES": "EMPARADISE, (Milton) to put in a state like paradise; to make supremely happy [v]\n",
  "EMPARADISING": "EMPARADISE, (Milton) to put in a state like paradise; to make supremely happy [v]\n",
  "EMPARE": "(Spenser) to become worse, also EMPAIRE [v EMPARED, EMPARING, EMPARES]\n",
  "EMPARED": "EMPARE, (Spenser) to become worse, also EMPAIRE [v]\n",
  "EMPARES": "EMPARE, (Spenser) to become worse, also EMPAIRE [v]\n",
  "EMPARING": "EMPARE, (Spenser) to become worse, also EMPAIRE [v]\n",
  "EMPARL": "(Spenser) to hold discourse, to parley, also IMPARL [v -ED, -ING, -S]\n",
  "EMPARLAUNCE": "(Spenser) parleying, conference, also IMPARLANCE [n -S]\n",
  "EMPARLAUNCES": "EMPARLAUNCE, (Spenser) parleying, conference, also IMPARLANCE [n]\n",
  "EMPARLED": "EMPARL, (Spenser) to hold discourse, to parley, also IMPARL [v]\n",
  "EMPARLING": "EMPARL, (Spenser) to hold discourse, to parley, also IMPARL [v]\n",
  "EMPARLS": "EMPARL, (Spenser) to hold discourse, to parley, also IMPARL [v]\n",
  "EMPART": "(Spenser) to impart [v -ED, -ING, -S]\n",
  "EMPARTED": "EMPART, (Spenser) to impart [v]\n",
  "EMPARTING": "EMPART, (Spenser) to impart [v]\n",
  "EMPARTS": "EMPART, (Spenser) to impart [v]\n",
  "EMPASSIONATE": "(Spenser) impassioned, also IMPASSIONATE [adj]\n",
  "EMPASSIONED": "(Spenser) full of passion [adj]\n",
  "EMPATHETIC": "involving or showing empathy, also EMPATHIC [adj EMPATHETICALLY]\n",
  "EMPATHETICALLY": "EMPATHETIC, involving or showing empathy, also EMPATHIC [adv]\n",
  "EMPATHIC": "involving or showing empathy, also EMPATHETIC [adj EMPATHICALLY]\n",
  "EMPATHICALLY": "EMPATHIC, involving or showing empathy, also EMPATHETIC [adv]\n",
  "EMPATHIES": "EMPATHY, the comprehension of another's feelings [n]\n",
  "EMPATHISE": "to enter imaginatively into another's personality and experience his experiences, also EMPATHIZE [v EMPATHISED, EMPATHISING, EMPATHISES]\n",
  "EMPATHISED": "EMPATHISE, to enter imaginatively into another's personality and experience his experiences, also EMPATHIZE [v]\n",
  "EMPATHISES": "EMPATHISE, to enter imaginatively into another's personality and experience his experiences, also EMPATHIZE [v]\n",
  "EMPATHISING": "EMPATHISE, to enter imaginatively into another's personality and experience his experiences, also EMPATHIZE [v]\n",
  "EMPATHIST": "one who empathises [n -S]\n",
  "EMPATHISTS": "EMPATHIST, one who empathises [n]\n",
  "EMPATHIZE": "to enter imaginatively into another's personality and experience his experiences, also EMPATHISE [v EMPATHIZED, EMPATHIZING, EMPATHIZES]\n",
  "EMPATHIZED": "EMPATHIZE, to enter imaginatively into another's personality and experience his experiences, also EMPATHISE [v]\n",
  "EMPATHIZES": "EMPATHIZE, to enter imaginatively into another's personality and experience his experiences, also EMPATHISE [v]\n",
  "EMPATHIZING": "EMPATHIZE, to enter imaginatively into another's personality and experience his experiences, also EMPATHISE [v]\n",
  "EMPATHY": "the comprehension of another's feelings [n EMPATHIES]\n",
  "EMPATRON": "(Shakespeare) to patronize [v -ED, -ING, -S]\n",
  "EMPATRONED": "EMPATRON, (Shakespeare) to patronize [v]\n",
  "EMPATRONING": "EMPATRON, (Shakespeare) to patronize [v]\n",
  "EMPATRONS": "EMPATRON, (Shakespeare) to patronize [v]\n",
  "EMPAYRE": "(Spenser) to impair, also EMPAIRE, EMPARE [v EMPAYRED, EMPAYRING, EMPAYRES]\n",
  "EMPAYRED": "EMPAYRE, (Spenser) to impair, also EMPAIRE, EMPARE [v]\n",
  "EMPAYRES": "EMPAYRE, (Spenser) to impair, also EMPAIRE, EMPARE [v]\n",
  "EMPAYRING": "EMPAYRE, (Spenser) to impair, also EMPAIRE, EMPARE [v]\n",
  "EMPEACH": "(Spenser) to accuse of impropriety, also IMPEACH [v -ED, -ING, -ES]\n",
  "EMPEACHED": "EMPEACH, (Spenser) to accuse of impropriety, also IMPEACH [v]\n",
  "EMPEACHES": "EMPEACH, (Spenser) to accuse of impropriety, also IMPEACH [v]\n",
  "EMPEACHING": "EMPEACH, (Spenser) to accuse of impropriety, also IMPEACH [v]\n",
  "EMPENNAGE": "(French) the tail assembly of an airplane [n -S]\n",
  "EMPENNAGES": "EMPENNAGE, (French) the tail assembly of an airplane [n]\n",
  "EMPEOPLE": "to fill with people [v EMPEOPLED, EMPEOPLING, EMPEOPLES]\n",
  "EMPEOPLED": "EMPEOPLE, to fill with people [v]\n",
  "EMPEOPLES": "EMPEOPLE, to fill with people [v]\n",
  "EMPEOPLING": "EMPEOPLE, to fill with people [v]\n",
  "EMPERCE": "(Spenser) to pierce, also EMPIERCE [v EMPERCED, EMPERCING, EMPERCES]\n",
  "EMPERCED": "EMPERCE, (Spenser) to pierce, also EMPIERCE [v]\n",
  "EMPERCES": "EMPERCE, (Spenser) to pierce, also EMPIERCE [v]\n",
  "EMPERCING": "EMPERCE, (Spenser) to pierce, also EMPIERCE [v]\n",
  "EMPERIES": "EMPERY, empire or power [n]\n",
  "EMPERISE": "to play the emperor, also EMPERIZE [v EMPERISED, EMPERISING, EMPERISES]\n",
  "EMPERISED": "EMPERISE, to play the emperor, also EMPERIZE [v]\n",
  "EMPERISES": "EMPERISE, to play the emperor, also EMPERIZE [v]\n",
  "EMPERISH": "(Spenser) to impair [v -ED, -ING, -ES]\n",
  "EMPERISHED": "EMPERISH, (Spenser) to impair [v]\n",
  "EMPERISHES": "EMPERISH, (Spenser) to impair [v]\n",
  "EMPERISHING": "EMPERISH, (Spenser) to impair [v]\n",
  "EMPERISING": "EMPERISE, to play the emperor, also EMPERIZE [v]\n",
  "EMPERIZE": "to play the emperor, also EMPERISE [v EMPERIZED, EMPERIZING, EMPERIZES]\n",
  "EMPERIZED": "EMPERIZE, to play the emperor, also EMPERISE [v]\n",
  "EMPERIZES": "EMPERIZE, to play the emperor, also EMPERISE [v]\n",
  "EMPERIZING": "EMPERIZE, to play the emperor, also EMPERISE [v]\n",
  "EMPEROR": "the ruler of an empire [n -S]\n",
  "EMPERORS": "EMPEROR, the ruler of an empire [n]\n",
  "EMPERORSHIP": "the office of emperor [n -S]\n",
  "EMPERORSHIPS": "EMPERORSHIP, the office of emperor [n]\n",
  "EMPERY": "empire or power [n EMPERIES]\n",
  "EMPHASES": "EMPHASIS, stress imparted to something to indicate significance [n]\n",
  "EMPHASIS": "stress imparted to something to indicate significance [n EMPHASES]\n",
  "EMPHASISE": "to add emphasis to, also EMPHASIZE [v EMPHASISED, EMPHASISING, EMPHASISES]\n",
  "EMPHASISED": "EMPHASISE, to add emphasis to, also EMPHASIZE [v]\n",
  "EMPHASISES": "EMPHASISE, to add emphasis to, also EMPHASIZE [v]\n",
  "EMPHASISING": "EMPHASISE, to add emphasis to, also EMPHASIZE [v]\n",
  "EMPHASIZE": "to add emphasis to, also EMPHASISE [v EMPHASIZED, EMPHASIZING, EMPHASIZES]\n",
  "EMPHASIZED": "EMPHASIZE, to add emphasis to, also EMPHASISE [v]\n",
  "EMPHASIZES": "EMPHASIZE, to add emphasis to, also EMPHASISE [v]\n",
  "EMPHASIZING": "EMPHASIZE, to add emphasis to, also EMPHASISE [v]\n",
  "EMPHATIC": "stressed forcibly, also EMPHATICAL [adj EMPHATICALLY] / an emphatic consonant [n -S]\n",
  "EMPHATICAL": "uttered with emphasis, also EMPHATIC [adj EMPHATICALLY]\n",
  "EMPHATICALLY": "EMPHATICAL, uttered with emphasis, also EMPHATIC [adv]\n",
  "EMPHATICALNESS": "the state of being emphatical [n]\n",
  "EMPHATICS": "EMPHATIC, an emphatic consonant [n]\n",
  "EMPHLYSES": "EMPHLYSIS, a vesicular eruption [n]\n",
  "EMPHLYSIS": "a vesicular eruption [n EMPHLYSES]\n",
  "EMPHRACTIC": "blocking the pores of the skin [adj] / a substance that stops the pores of the skin [n -S]\n",
  "EMPHRACTICS": "EMPHRACTIC, a substance that stops the pores of the skin [n]\n",
  "EMPHYSEMA": "a swelling produced by gas or air diffused in the cellular tissue [n -S]\n",
  "EMPHYSEMAS": "EMPHYSEMA, a swelling produced by gas or air diffused in the cellular tissue [n]\n",
  "EMPHYSEMATOUS": "relating to emphysema [adj]\n",
  "EMPHYSEMIC": "a sufferer from emphysema [n -S]\n",
  "EMPHYSEMICS": "EMPHYSEMIC, a sufferer from emphysema [n]\n",
  "EMPHYTEUSES": "EMPHYTEUSIS, a perpetual but conditional lease of property [n]\n",
  "EMPHYTEUSIS": "a perpetual but conditional lease of property [n EMPHYTEUSES]\n",
  "EMPHYTEUTIC": "relating to emphyteusis, perpetual but conditional lease of property [adj]\n",
  "EMPIECEMENT": "(French) an insertion in a garment [n -S]\n",
  "EMPIECEMENTS": "EMPIECEMENT, (French) an insertion in a garment [n]\n",
  "EMPIERCE": "(Spenser) to pierce, also EMPERCE [v EMPIERCED, EMPIERCING, EMPIERCES]\n",
  "EMPIERCED": "EMPIERCE, (Spenser) to pierce, also EMPERCE [v]\n",
  "EMPIERCES": "EMPIERCE, (Spenser) to pierce, also EMPERCE [v]\n",
  "EMPIERCING": "EMPIERCE, (Spenser) to pierce, also EMPERCE [v]\n",
  "EMPIGHT": "(Spenser) to fix or position [v -ED, -ING, -S]\n",
  "EMPIGHTED": "EMPIGHT, (Spenser) to fix or position [v]\n",
  "EMPIGHTING": "EMPIGHT, (Spenser) to fix or position [v]\n",
  "EMPIGHTS": "EMPIGHT, (Spenser) to fix or position [v]\n",
  "EMPIRE": "a dominion of peoples and nations under the same power [n -S]\n",
  "EMPIRES": "EMPIRE, a dominion of peoples and nations under the same power [n]\n",
  "EMPIRIC": "based on experience, also EMPIRICAL [adj EMPIRICALLY] / one who follows an empirical method; one who relies upon practical experience [n -S]\n",
  "EMPIRICAL": "relying on or derived from observation or experiment; guided by practical experience rather than theory, also EMPIRIC [adj EMPIRICALLY] / in statistics, the posterior probability of an event [n -S]\n",
  "EMPIRICALLY": "EMPIRICAL, relying on or derived from observation or experiment; guided by practical experience rather than theory, also EMPIRIC [adv]\n",
  "EMPIRICALNESS": "EMPIRICAL, relying on or derived from observation or experiment; guided by practical experience rather than theory, also EMPIRIC [n]\n",
  "EMPIRICALNESSES": "EMPIRICALNESS, EMPIRICAL, relying on or derived from observation or experiment; guided by practical experience rather than theory, also EMPIRIC [n]\n",
  "EMPIRICALS": "EMPIRICAL, in statistics, the posterior probability of an event [n]\n",
  "EMPIRICISM": "pursuit of knowledge by observation and experiment [n -S]\n",
  "EMPIRICISMS": "EMPIRICISM, pursuit of knowledge by observation and experiment [n]\n",
  "EMPIRICIST": "an empiric [n -S]\n",
  "EMPIRICISTS": "EMPIRICIST, an empiric [n]\n",
  "EMPIRICS": "EMPIRIC, one who follows an empirical method; one who relies upon practical experience [n]\n",
  "EMPIRICUTIC": "(obsolete) empirical [adj]\n",
  "EMPLACE": "to put in position [v EMPLACED, EMPLACING, EMPLACES]\n",
  "EMPLACED": "EMPLACE, to put in position [v]\n",
  "EMPLACEMENT": "the situation or location of something [n -S]\n",
  "EMPLACEMENTS": "EMPLACEMENT, the situation or location of something [n]\n",
  "EMPLACES": "EMPLACE, to put in position [v]\n",
  "EMPLACING": "EMPLACE, to put in position [v]\n",
  "EMPLANE": "to put on an aeroplane, also ENPLANE [v EMPLANED, EMPLANING, EMPLANES]\n",
  "EMPLANED": "EMPLANE, to put on an aeroplane, also ENPLANE [v]\n",
  "EMPLANES": "EMPLANE, to put on an aeroplane, also ENPLANE [v]\n",
  "EMPLANING": "EMPLANE, to put on an aeroplane, also ENPLANE [v]\n",
  "EMPLASTER": "(obsolete) to plaster [v -ED, -ING, -S]\n",
  "EMPLASTERED": "EMPLASTER, (obsolete) to plaster [v]\n",
  "EMPLASTERING": "EMPLASTER, (obsolete) to plaster [v]\n",
  "EMPLASTERS": "EMPLASTER, (obsolete) to plaster [v]\n",
  "EMPLASTIC": "glutinous, adhesive [adj] / a medicine that stops the pores [n -S]\n",
  "EMPLASTICS": "EMPLASTIC, a medicine that stops the pores [n]\n",
  "EMPLASTRA": "EMPLASTRUM, a medicated plaster, also EMPLASTRON [n]\n",
  "EMPLASTRON": "a medicated plaster, also EMPLASTRUM [n -S]\n",
  "EMPLASTRONS": "EMPLASTRON, a medicated plaster, also EMPLASTRUM [n]\n",
  "EMPLASTRUM": "a medicated plaster, also EMPLASTRON [n EMPLASTRA or EMPLASTRUMS]\n",
  "EMPLASTRUMS": "EMPLASTRUM, a medicated plaster, also EMPLASTRON [n]\n",
  "EMPLEACH": "to intertwine, also IMPLEACH [v -ED, -ING, -ES]\n",
  "EMPLEACHED": "EMPLEACH, to intertwine, also IMPLEACH [v]\n",
  "EMPLEACHES": "EMPLEACH, to intertwine, also IMPLEACH [v]\n",
  "EMPLEACHING": "EMPLEACH, to intertwine, also IMPLEACH [v]\n",
  "EMPLECTON": "(archaic) ashlar masonry filled up with rubble, also EMPLECTUM [n -S]\n",
  "EMPLECTONS": "EMPLECTON, (archaic) ashlar masonry filled up with rubble, also EMPLECTUM [n]\n",
  "EMPLECTUM": "(archaic) ashlar masonry filled up with rubble, also EMPLECTON [n -S]\n",
  "EMPLECTUMS": "EMPLECTUM, (archaic) ashlar masonry filled up with rubble, also EMPLECTON [n]\n",
  "EMPLONGE": "(Spenser) to plunge, also IMPLUNGE [v EMPLONGED, EMPLONGING, EMPLONGES]\n",
  "EMPLONGED": "EMPLONGE, (Spenser) to plunge, also IMPLUNGE [v]\n",
  "EMPLONGES": "EMPLONGE, (Spenser) to plunge, also IMPLUNGE [v]\n",
  "EMPLONGING": "EMPLONGE, (Spenser) to plunge, also IMPLUNGE [v]\n",
  "EMPLOY": "to hire, use [v -ED, -ING, -S]\n",
  "EMPLOYABILITIES": "EMPLOYABILITY, the state of being employable [n]\n",
  "EMPLOYABILITY": "the state of being employable [n EMPLOYABILITIES]\n",
  "EMPLOYABLE": "that can be employed [adj] / one who is employable [n -S]\n",
  "EMPLOYABLES": "EMPLOYABLE, one who is employable [n]\n",
  "EMPLOYE": "a person employed, also EMPLOYEE [n -S]\n",
  "EMPLOYED": "EMPLOY, to hire, use [v]\n",
  "EMPLOYEE": "a person employed, also EMPLOYE [n -S]\n",
  "EMPLOYEES": "EMPLOYEE, a person employed, also EMPLOYE [n]\n",
  "EMPLOYER": "one who employs people [n -S]\n",
  "EMPLOYERS": "EMPLOYER, one who employs people [n]\n",
  "EMPLOYES": "EMPLOYE, a person employed, also EMPLOYEE [n]\n",
  "EMPLOYING": "EMPLOY, to hire, use [v]\n",
  "EMPLOYMENT": "the act of employing [n -S]\n",
  "EMPLOYMENTS": "EMPLOYMENT, the act of employing [n]\n",
  "EMPLOYS": "EMPLOY, to hire, use [v]\n",
  "EMPLUME": "(archaic) to provide with a plume [v EMPLUMED, EMPLUMING, EMPLUMES]\n",
  "EMPLUMED": "EMPLUME, (archaic) to provide with a plume [v]\n",
  "EMPLUMES": "EMPLUME, (archaic) to provide with a plume [v]\n",
  "EMPLUMING": "EMPLUME, (archaic) to provide with a plume [v]\n",
  "EMPOISON": "(archaic) to poison [v -ED, -ING, -S]\n",
  "EMPOISONED": "EMPOISON, (archaic) to poison [v]\n",
  "EMPOISONING": "EMPOISON, (archaic) to poison [v]\n",
  "EMPOISONMENT": "the act of poisoning [n -S]\n",
  "EMPOISONMENTS": "EMPOISONMENT, the act of poisoning [n]\n",
  "EMPOISONS": "EMPOISON, (archaic) to poison [v]\n",
  "EMPOLDER": "to reclaim low-lying land, also IMPOLDER [v -ED, -ING, -S]\n",
  "EMPOLDERED": "EMPOLDER, to reclaim low-lying land, also IMPOLDER [v]\n",
  "EMPOLDERING": "EMPOLDER, to reclaim low-lying land, also IMPOLDER [v]\n",
  "EMPOLDERS": "EMPOLDER, to reclaim low-lying land, also IMPOLDER [v]\n",
  "EMPORIA": "EMPORIUM, (Latin) a large trading centre [n]\n",
  "EMPORIUM": "(Latin) a large trading centre [n EMPORIUMS or EMPORIA]\n",
  "EMPORIUMS": "EMPORIUM, (Latin) a large trading centre [n]\n",
  "EMPOVERISH": "(obsolete) to make poor, also IMPOVERISH [v -ED, -ING, -ES]\n",
  "EMPOVERISHED": "EMPOVERISH, (obsolete) to make poor, also IMPOVERISH [v]\n",
  "EMPOVERISHER": "one who empoverishes [n -S]\n",
  "EMPOVERISHERS": "EMPOVERISHER, one who empoverishes [n]\n",
  "EMPOVERISHES": "EMPOVERISH, (obsolete) to make poor, also IMPOVERISH [v]\n",
  "EMPOVERISHING": "EMPOVERISH, (obsolete) to make poor, also IMPOVERISH [v]\n",
  "EMPOVERISHMENT": "the state of becoming empoverished [n -S]\n",
  "EMPOVERISHMENTS": "EMPOVERISHMENT, the state of becoming empoverished [n]\n",
  "EMPOWER": "to authorize, also IMPOWER [v -ED, -ING, -S]\n",
  "EMPOWERED": "EMPOWER, to authorize, also IMPOWER [v]\n",
  "EMPOWERING": "EMPOWER, to authorize, also IMPOWER [v]\n",
  "EMPOWERMENT": "the act of empowering [n -S]\n",
  "EMPOWERMENTS": "EMPOWERMENT, the act of empowering [n]\n",
  "EMPOWERS": "EMPOWER, to authorize, also IMPOWER [v]\n",
  "EMPRESS": "a female ruler of an empire [n -ES]\n",
  "EMPRESSE": "(French) eager, enthusiastic [adj]\n",
  "EMPRESSEMENT": "(French) extreme politeness [n -S]\n",
  "EMPRESSEMENTS": "EMPRESSEMENT, (French) extreme politeness [n]\n",
  "EMPRESSES": "EMPRESS, a female ruler of an empire [n]\n",
  "EMPRISE": "(archaic) an adventurous undertaking, also EMPRIZE [n -S]\n",
  "EMPRISES": "EMPRISE, (archaic) an adventurous undertaking, also EMPRIZE [n]\n",
  "EMPRIZE": "a dangerous undertaking, also EMPRISE [n -S]\n",
  "EMPRIZES": "EMPRIZE, a dangerous undertaking, also EMPRISE [n]\n",
  "EMPT": "(dialect) to empty [v -ED, -ING, -S]\n",
  "EMPTED": "EMPT, (dialect) to empty [v]\n",
  "EMPTIABLE": "that can be emptied [adj]\n",
  "EMPTIED": "EMPTY, to remove the contents of [v]\n",
  "EMPTIER": "one who empties [n -S]\n",
  "EMPTIERS": "EMPTIER, one who empties [n]\n",
  "EMPTIES": "EMPTY, to remove the contents of [v]\n",
  "EMPTIEST": "EMPTY, containing nothing [adj]\n",
  "EMPTILY": "EMPTY, containing nothing [adv]\n",
  "EMPTINESS": "the state of being empty [n -ES]\n",
  "EMPTINESSES": "EMPTINESS, the state of being empty [n]\n",
  "EMPTING": "the act of emptying [n -S]\n",
  "EMPTINGS": "the yeasty lees of beer or cider, also EMPTINS [n]\n",
  "EMPTINS": "the yeasty lees of beer or cider, also EMPTINGS [n]\n",
  "EMPTION": "the act of buying [n -S]\n",
  "EMPTIONAL": "capable of being purchased [adj]\n",
  "EMPTIONS": "EMPTION, the act of buying [n]\n",
  "EMPTS": "EMPT, (dialect) to empty [v]\n",
  "EMPTY": "to remove the contents of [v EMPTIED, EMPTYING, EMPTIES] / containing nothing [adj EMPTIER, EMPTIEST, EMPTILY]\n",
  "EMPTYING": "the act of emptying [n -S]\n",
  "EMPTYINGS": "EMPTYING, the act of emptying [n]\n",
  "EMPTYSES": "EMPTYSIS, spitting of e.g. blood [n]\n",
  "EMPTYSIS": "spitting of e.g. blood [n EMPTYSES]\n",
  "EMPURPLE": "to dye purple, also IMPURPLE [v EMPURPLED, EMPURPLING, EMPURPLES]\n",
  "EMPURPLED": "EMPURPLE, to dye purple, also IMPURPLE [v]\n",
  "EMPURPLES": "EMPURPLE, to dye purple, also IMPURPLE [v]\n",
  "EMPURPLING": "EMPURPLE, to dye purple, also IMPURPLE [v]\n",
  "EMPUSA": "(Greek) a phantom or specter sent by Hecate, also EMPUSE [n -S]\n",
  "EMPUSAS": "EMPUSA, (Greek) a phantom or specter sent by Hecate, also EMPUSE [n]\n",
  "EMPUSE": "(Greek) a phantom or spectre sent by Hecate, also EMPUSA [n -S]\n",
  "EMPUSES": "EMPUSE, (Greek) a phantom or spectre sent by Hecate, also EMPUSA [n]\n",
  "EMPYEMA": "(Greek) a collection of pus in a body cavity [n EMPYEMAS or EMPYEMATA]\n",
  "EMPYEMAS": "EMPYEMA, (Greek) a collection of pus in a body cavity [n]\n",
  "EMPYEMATA": "EMPYEMA, (Greek) a collection of pus in a body cavity [n]\n",
  "EMPYEMIC": "relating to empyema, a collection of pus in any cavity, esp. the pleura [adj]\n",
  "EMPYESES": "EMPYESIS, a skin eruption containing pus [n]\n",
  "EMPYESIS": "a skin eruption containing pus [n EMPYESES]\n",
  "EMPYREAL": "pertaining to the sky, also EMPYREAN [adj]\n",
  "EMPYREAN": "pertaining to the sky, also EMPYREAL [adj] / the highest heaven [n -S]\n",
  "EMPYREANS": "EMPYREAN, the highest heaven [n]\n",
  "EMPYREUMA": "the peculiar smell and taste arising from products of decomposition of animal or vegetable substances when burnt in close vessels [n EMPYREUMATA]\n",
  "EMPYREUMATA": "EMPYREUMA, the peculiar smell and taste arising from products of decomposition of animal or vegetable substances when burnt in close vessels [n]\n",
  "EMPYREUMATIC": "relating to empyreuma, also EMPYREUMATICAL [adj]\n",
  "EMPYREUMATICAL": "relating to empyreuma, also EMPYREUMATIC [adj]\n",
  "EMPYREUMATISE": "to render empyreumatic, also EMPYREUMATIZE [v EMPYREUMATISED, EMPYREUMATISES]\n",
  "EMPYREUMATISED": "EMPYREUMATISE, to render empyreumatic, also EMPYREUMATIZE [v]\n",
  "EMPYREUMATISES": "EMPYREUMATISE, to render empyreumatic, also EMPYREUMATIZE [v]\n",
  "EMPYREUMATISING": "EMPYREUMATISE, to render empyreumatic, also EMPYREUMATIZE [v]\n",
  "EMPYREUMATIZE": "to render empyreumatic, also EMPYREUMATISE [v EMPYREUMATIZED, EMPYREUMATIZES]\n",
  "EMPYREUMATIZED": "EMPYREUMATIZE, to render empyreumatic, also EMPYREUMATISE [v]\n",
  "EMPYREUMATIZES": "EMPYREUMATIZE, to render empyreumatic, also EMPYREUMATISE [v]\n",
  "EMPYREUMATIZING": "EMPYREUMATIZE, to render empyreumatic, also EMPYREUMATISE [v]\n",
  "EMS": "EM, a unit of measurement in printing [n]\n",
  "EMU": "a large flightless bird, also EMEU [n -S]\n",
  "EMULATE": "to strive to equal or excel; to imitate, also AEMULE, EMULE [v EMULATED, EMULATING, EMULATES]\n",
  "EMULATED": "EMULATE, to strive to equal or excel; to imitate, also AEMULE, EMULE [v]\n",
  "EMULATES": "EMULATE, to strive to equal or excel; to imitate, also AEMULE, EMULE [v]\n",
  "EMULATING": "EMULATE, to strive to equal or excel; to imitate, also AEMULE, EMULE [v]\n",
  "EMULATION": "the act of emulating or attempting to equal or excel [n -S]\n",
  "EMULATIONS": "EMULATION, the act of emulating or attempting to equal or excel [n]\n",
  "EMULATIVE": "inclined to emulation [adj EMULATIVELY]\n",
  "EMULATIVELY": "EMULATIVE, inclined to emulation [adv]\n",
  "EMULATOR": "one who emulates [n -S]\n",
  "EMULATORS": "EMULATOR, one who emulates [n]\n",
  "EMULATRESS": "(obsolete) a female emulator [n -ES]\n",
  "EMULATRESSES": "EMULATRESS, (obsolete) a female emulator [n]\n",
  "EMULE": "(Southey) to emulate, also AEMULE, EMULATE [v EMULED, EMULING, EMULES]\n",
  "EMULED": "EMULE, (Southey) to emulate, also AEMULE, EMULATE [v]\n",
  "EMULES": "EMULE, (Southey) to emulate, also AEMULE, EMULATE [v]\n",
  "EMULGE": "(archaic) to milk or drain out [v EMULGED, EMULGING, EMULGES]\n",
  "EMULGED": "EMULGE, (archaic) to milk or drain out [v]\n",
  "EMULGENCE": "(archaic) the process of emulging, milking or draining out [n -S]\n",
  "EMULGENCES": "EMULGENCE, (archaic) the process of emulging, milking or draining out [n]\n",
  "EMULGENT": "acting as a drain for [adj]\n",
  "EMULGES": "EMULGE, (archaic) to milk or drain out [v]\n",
  "EMULGING": "EMULGE, (archaic) to milk or drain out [v]\n",
  "EMULING": "EMULE, (Southey) to emulate, also AEMULE, EMULATE [v]\n",
  "EMULOUS": "eager to equal or surpass another [adj EMULOUSLY]\n",
  "EMULOUSLY": "EMULOUS, eager to equal or surpass another [adv]\n",
  "EMULOUSNESS": "the state of being emulous [n -ES]\n",
  "EMULOUSNESSES": "EMULOUSNESS, the state of being emulous [n]\n",
  "EMULSIBLE": "that can be emulsified [adj]\n",
  "EMULSIFIABLE": "capable of being emulsified [adj]\n",
  "EMULSIFICATION": "the act of emulsifying [n -S]\n",
  "EMULSIFICATIONS": "EMULSIFICATION, the act of emulsifying [n]\n",
  "EMULSIFIED": "EMULSIFY, to convert into an emulsion [v]\n",
  "EMULSIFIER": "an agent that emulsifies [n -S]\n",
  "EMULSIFIERS": "EMULSIFIER, an agent that emulsifies [n]\n",
  "EMULSIFIES": "EMULSIFY, to convert into an emulsion [v]\n",
  "EMULSIFY": "to convert into an emulsion [v EMULSIFIED, EMULSIFYING, EMULSIFIES]\n",
  "EMULSIFYING": "EMULSIFY, to convert into an emulsion [v]\n",
  "EMULSIN": "the white milky pulp or extract of bitter almonds [n -S]\n",
  "EMULSINS": "EMULSIN, the white milky pulp or extract of bitter almonds [n]\n",
  "EMULSION": "a colloidal suspension of one liquid in another [n -S]\n",
  "EMULSIONISE": "to make an emulsion of, also EMULSIONIZE [v EMULSIONISED, EMULSIONISING, EMULSIONISES]\n",
  "EMULSIONISED": "EMULSIONISE, to make an emulsion of, also EMULSIONIZE [v]\n",
  "EMULSIONISES": "EMULSIONISE, to make an emulsion of, also EMULSIONIZE [v]\n",
  "EMULSIONISING": "EMULSIONISE, to make an emulsion of, also EMULSIONIZE [v]\n",
  "EMULSIONIZE": "to make an emulsion of, also EMULSIONISE [v EMULSIONIZED, EMULSIONIZING, EMULSIONIZES]\n",
  "EMULSIONIZED": "EMULSIONIZE, to make an emulsion of, also EMULSIONISE [v]\n",
  "EMULSIONIZES": "EMULSIONIZE, to make an emulsion of, also EMULSIONISE [v]\n",
  "EMULSIONIZING": "EMULSIONIZE, to make an emulsion of, also EMULSIONISE [v]\n",
  "EMULSIONS": "EMULSION, a colloidal suspension of one liquid in another [n]\n",
  "EMULSIVE": "relating to emulsion [adj]\n",
  "EMULSOID": "a liquid dispersed in another liquid [n -S]\n",
  "EMULSOIDAL": "relating to an emulsoid, an easily dispersed colloid, giving a suspension readily formed again after coagulation [adj]\n",
  "EMULSOIDS": "EMULSOID, a liquid dispersed in another liquid [n]\n",
  "EMULSOR": "an emulsifying apparatus [n -S]\n",
  "EMULSORS": "EMULSOR, an emulsifying apparatus [n]\n",
  "EMUNCTION": "the act of removing obstructions from or cleaning bodily passages [n -S]\n",
  "EMUNCTIONS": "EMUNCTION, the act of removing obstructions from or cleaning bodily passages [n]\n",
  "EMUNCTORIES": "EMUNCTORY, a cleansing organ or canal; a term applied to the excretory ducts and organs of the body [n]\n",
  "EMUNCTORY": "a cleansing organ or canal; a term applied to the excretory ducts and organs of the body [n EMUNCTORIES]\n",
  "EMUNGE": "(obsolete) to clean [v EMUNGED, EMUNGING, EMUNGES]\n",
  "EMUNGED": "EMUNGE, (obsolete) to clean [v]\n",
  "EMUNGES": "EMUNGE, (obsolete) to clean [v]\n",
  "EMUNGING": "EMUNGE, (obsolete) to clean [v]\n",
  "EMURE": "(Shakespeare) to immure, also IMMURE [v EMURED, EMURING, EMURES]\n",
  "EMURED": "EMURE, (Shakespeare) to immure, also IMMURE [v]\n",
  "EMURES": "EMURE, (Shakespeare) to immure, also IMMURE [v]\n",
  "EMURING": "EMURE, (Shakespeare) to immure, also IMMURE [v]\n",
  "EMUS": "EMU, a large flightless bird, also EMEU [n]\n",
  "EMYD": "a genus of freshwater terrapin, also EMYDE, EMYS [n -S]\n",
  "EMYDE": "a genus of freshwater terrapin, also EMYD, EMYS [n -S]\n",
  "EMYDES": "EMYDE, a genus of freshwater terrapin, also EMYD, EMYS [n]\n",
  "EMYDS": "EMYD, a genus of freshwater terrapin, also EMYDE, EMYS [n]\n",
  "EMYS": "a genus of freshwater terrapin, also EMYD, EMYDE [n EMYDES]\n",
  "EN": "a unit of measurement in printing, half the width of an em [n -S]\n",
  "ENABLE": "to make possible [v ENABLED, ENABLING, ENABLES]\n",
  "ENABLED": "ENABLE, to make possible [v]\n",
  "ENABLEMENT": "the act of enabling [n -S]\n",
  "ENABLEMENTS": "ENABLEMENT, the act of enabling [n]\n",
  "ENABLER": "one who enables [n -S]\n",
  "ENABLERS": "ENABLER, one who enables [n]\n",
  "ENABLES": "ENABLE, to make possible [v]\n",
  "ENABLING": "ENABLE, to make possible [v]\n",
  "ENACT": "to establish by law [v -ED, -ING, -S]\n",
  "ENACTABLE": "that can be enacted [adj]\n",
  "ENACTED": "ENACT, to establish by law [v]\n",
  "ENACTING": "ENACT, to establish by law [v]\n",
  "ENACTION": "the passing of a bill into law [n -S]\n",
  "ENACTIONS": "ENACTION, the passing of a bill into law [n]\n",
  "ENACTIVE": "having the power to enact [adj]\n",
  "ENACTMENT": "the passing of a bill into law [n -S]\n",
  "ENACTMENTS": "ENACTMENT, the passing of a bill into law [n]\n",
  "ENACTOR": "one who enacts [n -S]\n",
  "ENACTORS": "ENACTOR, one who enacts [n]\n",
  "ENACTORY": "pertaining to the enactment of law [adj]\n",
  "ENACTS": "ENACT, to establish by law [v]\n",
  "ENACTURE": "(Shakespeare) a performance, a fulfilment [n -S]\n",
  "ENACTURES": "ENACTURE, (Shakespeare) a performance, a fulfilment [n]\n",
  "ENALAPRIL": "an ace inhibitor used to treat high blood pressure [n -S]\n",
  "ENALAPRILS": "ENALAPRIL, an ace inhibitor used to treat high blood pressure [n]\n",
  "ENALLAGE": "the exchange of one grammatical case for another, as of singular for plural, present for past tense, etc. [n -S]\n",
  "ENALLAGES": "ENALLAGE, the exchange of one grammatical case for another, as of singular for plural, present for past tense, etc. [n]\n",
  "ENAMEL": "to cover with a vitrified coating [v ENAMELED or ENAMELLED, ENAMELING or ENAMELLING, ENAMELS]\n",
  "ENAMELED": "ENAMEL, to cover with a vitrified coating [v]\n",
  "ENAMELER": "one who enamels; a workman or artist who applies enamels in ornamental work, also ENAMELIST, ENAMELLER, ENAMELLIST [n -S]\n",
  "ENAMELERS": "ENAMELER, one who enamels; a workman or artist who applies enamels in ornamental work, also ENAMELIST, ENAMELLER, ENAMELLIST [n]\n",
  "ENAMELING": "the act of coating with enamel [n -S]\n",
  "ENAMELINGS": "ENAMELING, the act of coating with enamel [n]\n",
  "ENAMELIST": "one who enamels; a workman or artist who applies enamels in ornamental work, also ENAMELER, ENAMELLER, ENAMELLIST [n -S]\n",
  "ENAMELISTS": "ENAMELIST, one who enamels; a workman or artist who applies enamels in ornamental work, also ENAMELER, ENAMELLER, ENAMELLIST [n]\n",
  "ENAMELLED": "ENAMEL, to cover with a vitrified coating [v]\n",
  "ENAMELLER": "one who enamels; a workman or artist who applies enamels in ornamental work, also ENAMELER, ENAMELIST, ENAMELLIST [n -S]\n",
  "ENAMELLERS": "ENAMELLER, one who enamels; a workman or artist who applies enamels in ornamental work, also ENAMELER, ENAMELIST, ENAMELLIST [n]\n",
  "ENAMELLING": "the act of coating with enamel [n -S]\n",
  "ENAMELLINGS": "ENAMELLING, the act of coating with enamel [n]\n",
  "ENAMELLIST": "a worker in enamel, also ENAMELER, ENAMELIST, ENAMELLER [n -S]\n",
  "ENAMELLISTS": "ENAMELLIST, a worker in enamel, also ENAMELER, ENAMELIST, ENAMELLER [n]\n",
  "ENAMELS": "ENAMEL, to cover with a vitrified coating [v]\n",
  "ENAMELWARE": "craft goods made from enamel [n -S]\n",
  "ENAMELWARES": "ENAMELWARE, craft goods made from enamel [n]\n",
  "ENAMELWORK": "work done in enamel [n -S]\n",
  "ENAMELWORKS": "ENAMELWORK, work done in enamel [n]\n",
  "ENAMINE": "a type of amine [n -S]\n",
  "ENAMINES": "ENAMINE, a type of amine [n]\n",
  "ENAMOR": "to inspire with love, also ENAMOUR [v -ED, -ING, -S]\n",
  "ENAMORADO": "(obsolete) a lover [n -S]\n",
  "ENAMORADOS": "ENAMORADO, (obsolete) a lover [n]\n",
  "ENAMORED": "ENAMOR, to inspire with love, also ENAMOUR [v]\n",
  "ENAMORING": "ENAMOR, to inspire with love, also ENAMOUR [v]\n",
  "ENAMORS": "ENAMOR, to inspire with love, also ENAMOUR [v]\n",
  "ENAMOUR": "to inspire with love, also ENAMOR [v -ED, -ING, -S]\n",
  "ENAMOURED": "ENAMOUR, to inspire with love, also ENAMOR [v]\n",
  "ENAMOURING": "ENAMOUR, to inspire with love, also ENAMOR [v]\n",
  "ENAMOURS": "ENAMOUR, to inspire with love, also ENAMOR [v]\n",
  "ENANTHEMA": "an ulcer on a mucous membrane [n -S]\n",
  "ENANTHEMAS": "ENANTHEMA, an ulcer on a mucous membrane [n]\n",
  "ENANTIODROMIA": "the changing of something into its opposite [n -S]\n",
  "ENANTIODROMIAS": "ENANTIODROMIA, the changing of something into its opposite [n]\n",
  "ENANTIODROMIC": "characteristic of something that has become its opposite [adj]\n",
  "ENANTIOMER": "an enantiomorph, an object which is the mirror image of another [n -S]\n",
  "ENANTIOMERIC": "of or like an enantiomer, either of a pair of optical isomers [adj]\n",
  "ENANTIOMERS": "ENANTIOMER, an enantiomorph, an object which is the mirror image of another [n]\n",
  "ENANTIOMORPH": "an object which is the mirror image of another [n -S]\n",
  "ENANTIOMORPHIC": "of or like an enantiomorph, also ENANTIOMORPHOUS [adj]\n",
  "ENANTIOMORPHIES": "ENANTIOMORPHY, the state of being an enantiomorph, an object which is the mirror image of another [n]\n",
  "ENANTIOMORPHISM": "the state of being enantiomorphic [n]\n",
  "ENANTIOMORPHOUS": "of or like an enantiomorph, also ENANTIOMORPHIC [adj]\n",
  "ENANTIOMORPHS": "ENANTIOMORPH, an object which is the mirror image of another [n]\n",
  "ENANTIOMORPHY": "the state of being an enantiomorph, an object which is the mirror image of another [n ENANTIOMORPHIES]\n",
  "ENANTIOPATHIES": "ENANTIOPATHY, a disease or affliction which protects you from another [n]\n",
  "ENANTIOPATHY": "a disease or affliction which protects you from another [n ENANTIOPATHIES]\n",
  "ENANTIOSES": "ENANTIOSIS, the rhetorical device of stating the opposite of what is meant, usually ironically [n]\n",
  "ENANTIOSIS": "the rhetorical device of stating the opposite of what is meant, usually ironically [n ENANTIOSES]\n",
  "ENANTIOSTYLIES": "ENANTIOSTYLY, a dimorphous condition in which the style projects at one side or the other in different flowers [n]\n",
  "ENANTIOSTYLOUS": "showing enantiostyly, a dimorphous condition in which the style projects at one side or the other in different flowers [adj]\n",
  "ENANTIOSTYLY": "a dimorphous condition in which the style projects at one side or the other in different flowers [n ENANTIOSTYLIES]\n",
  "ENANTIOTROPIC": "displaying enantiotropy [adj]\n",
  "ENANTIOTROPIES": "ENANTIOTROPY, the existence in a substance of two crystal forms, one stable above, the other below, a transition temperature [n]\n",
  "ENANTIOTROPY": "the existence in a substance of two crystal forms, one stable above, the other below, a transition temperature [n ENANTIOTROPIES]\n",
  "ENARCH": "to graft a plant [v -ED, -ING, -ES]\n",
  "ENARCHED": "ENARCH, to graft a plant [v]\n",
  "ENARCHES": "ENARCH, to graft a plant [v]\n",
  "ENARCHING": "ENARCH, to graft a plant [v]\n",
  "ENARGITE": "a dark-grey crystalline copper arsenic sulphide, a minor ore of copper [n -S]\n",
  "ENARGITES": "ENARGITE, a dark-grey crystalline copper arsenic sulphide, a minor ore of copper [n]\n",
  "ENARM": "(obsolete) to arm [v -ED, -ING, -S]\n",
  "ENARMED": "ENARM, (obsolete) to arm [v]\n",
  "ENARMING": "ENARM, (obsolete) to arm [v]\n",
  "ENARMS": "ENARM, (obsolete) to arm [v]\n",
  "ENARRATION": "(archaic) a detailed exposition [n -S]\n",
  "ENARRATIONS": "ENARRATION, (archaic) a detailed exposition [n]\n",
  "ENARTHRODIAL": "of or like an enarthrosis, a ball-and-socket joint [adj]\n",
  "ENARTHROSES": "ENARTHROSIS, a ball-and-socket joint [n]\n",
  "ENARTHROSIS": "a ball-and-socket joint [n ENARTHROSES]\n",
  "ENATE": "a relative in the mother's side [n -S]\n",
  "ENATES": "ENATE, a relative in the mother's side [n]\n",
  "ENATIC": "possessed of a relative [adj]\n",
  "ENATION": "an outgrowth [n -S]\n",
  "ENATIONS": "ENATION, an outgrowth [n]\n",
  "ENAUNTER": "(obsolete) lest by chance [conj]\n",
  "ENCAENIA": "an annual tribute to the founders of Oxford [n -S]\n",
  "ENCAENIAS": "ENCAENIA, an annual tribute to the founders of Oxford [n]\n",
  "ENCAGE": "to put in a cage, also INCAGE [v ENCAGED, ENCAGING, ENCAGES]\n",
  "ENCAGED": "ENCAGE, to put in a cage, also INCAGE [v]\n",
  "ENCAGES": "ENCAGE, to put in a cage, also INCAGE [v]\n",
  "ENCAGING": "ENCAGE, to put in a cage, also INCAGE [v]\n",
  "ENCALM": "(obsolete) to becalm [v -ED, -ING, -S]\n",
  "ENCALMED": "ENCALM, (obsolete) to becalm [v]\n",
  "ENCALMING": "ENCALM, (obsolete) to becalm [v]\n",
  "ENCALMS": "ENCALM, (obsolete) to becalm [v]\n",
  "ENCAMP": "to set up a camp [v -ED, -ING, -S]\n",
  "ENCAMPED": "ENCAMP, to set up a camp [v]\n",
  "ENCAMPING": "ENCAMP, to set up a camp [v]\n",
  "ENCAMPMENT": "the place where a group (as a body of troops) is encamped [n -S]\n",
  "ENCAMPMENTS": "ENCAMPMENT, the place where a group (as a body of troops) is encamped [n]\n",
  "ENCAMPS": "ENCAMP, to set up a camp [v]\n",
  "ENCANTHIS": "(Greek) a small tumour of the inner corner of the eye [n ENCANTHISES]\n",
  "ENCANTHISES": "ENCANTHIS, (Greek) a small tumour of the inner corner of the eye [n]\n",
  "ENCAPSULATE": "to enclose in or as if in a capsule, also INCAPSULATE [v ENCAPSULATED, ENCAPSULATING, ENCAPSULATES]\n",
  "ENCAPSULATED": "ENCAPSULATE, to enclose in or as if in a capsule, also INCAPSULATE [v]\n",
  "ENCAPSULATES": "ENCAPSULATE, to enclose in or as if in a capsule, also INCAPSULATE [v]\n",
  "ENCAPSULATING": "ENCAPSULATE, to enclose in or as if in a capsule, also INCAPSULATE [v]\n",
  "ENCAPSULATION": "the act of encapsulating [n -S]\n",
  "ENCAPSULATIONS": "ENCAPSULATION, the act of encapsulating [n]\n",
  "ENCAPSULE": "to encapsulate [v ENCAPSULED, ENCAPSULING, ENCAPSULES]\n",
  "ENCAPSULED": "ENCAPSULE, to encapsulate [v]\n",
  "ENCAPSULES": "ENCAPSULE, to encapsulate [v]\n",
  "ENCAPSULING": "ENCAPSULE, to encapsulate [v]\n",
  "ENCARNALISE": "to make carnal or sensual, also ENCARNALIZE [v ENCARNALISED, ENCARNALISING, ENCARNALISES]\n",
  "ENCARNALISED": "ENCARNALISE, to make carnal or sensual, also ENCARNALIZE [v]\n",
  "ENCARNALISES": "ENCARNALISE, to make carnal or sensual, also ENCARNALIZE [v]\n",
  "ENCARNALISING": "ENCARNALISE, to make carnal or sensual, also ENCARNALIZE [v]\n",
  "ENCARNALIZE": "to make carnal or sensual, also ENCARNALISE [v ENCARNALIZED, ENCARNALIZING, ENCARNALIZES]\n",
  "ENCARNALIZED": "ENCARNALIZE, to make carnal or sensual, also ENCARNALISE [v]\n",
  "ENCARNALIZES": "ENCARNALIZE, to make carnal or sensual, also ENCARNALISE [v]\n",
  "ENCARNALIZING": "ENCARNALIZE, to make carnal or sensual, also ENCARNALISE [v]\n",
  "ENCARPUS": "(Greek) a frieze decoration of festooned fruit [n -ES]\n",
  "ENCARPUSES": "ENCARPUS, (Greek) a frieze decoration of festooned fruit [n]\n",
  "ENCASE": "to put in a case, also INCASE [v ENCASED, ENCASING, ENCASES]\n",
  "ENCASED": "ENCASE, to put in a case, also INCASE [v]\n",
  "ENCASEMENT": "the act of encasing; also, that which encases [n -S]\n",
  "ENCASEMENTS": "ENCASEMENT, the act of encasing; also, that which encases [n]\n",
  "ENCASES": "ENCASE, to put in a case, also INCASE [v]\n",
  "ENCASH": "to convert into cash [v -ED, -ING, -ES]\n",
  "ENCASHABLE": "that can be encashed [adj]\n",
  "ENCASHED": "ENCASH, to convert into cash [v]\n",
  "ENCASHES": "ENCASH, to convert into cash [v]\n",
  "ENCASHING": "ENCASH, to convert into cash [v]\n",
  "ENCASHMENT": "the payment in cash of a note, draft, etc. [n -S]\n",
  "ENCASHMENTS": "ENCASHMENT, the payment in cash of a note, draft, etc. [n]\n",
  "ENCASING": "ENCASE, to put in a case, also INCASE [v]\n",
  "ENCASTRE": "of a beam, fixed at the ends [adj]\n",
  "ENCAUSTIC": "having the colours burned in [adj ENCAUSTICALLY] / an ancient method of painting in melted wax; a piece of pottery or other article decorated in this way [n -S]\n",
  "ENCAUSTICALLY": "ENCAUSTIC, having the colours burned in [adv]\n",
  "ENCAUSTICS": "ENCAUSTIC, an ancient method of painting in melted wax; a piece of pottery or other article decorated in this way [n]\n",
  "ENCAVE": "(Shakespeare) to secrete, also INCAVE [v ENCAVED, ENCAVING, ENCAVES]\n",
  "ENCAVED": "ENCAVE, (Shakespeare) to secrete, also INCAVE [v]\n",
  "ENCAVES": "ENCAVE, (Shakespeare) to secrete, also INCAVE [v]\n",
  "ENCAVING": "ENCAVE, (Shakespeare) to secrete, also INCAVE [v]\n",
  "ENCEINTE": "a boundary wall enclosing a defended area [n -S]\n",
  "ENCEINTES": "ENCEINTE, a boundary wall enclosing a defended area [n]\n",
  "ENCEPHALA": "ENCEPHALON, the contents of the cranium; the brain [n]\n",
  "ENCEPHALALGIA": "pain in the head; headache [n -S]\n",
  "ENCEPHALALGIAS": "ENCEPHALALGIA, pain in the head; headache [n]\n",
  "ENCEPHALIC": "pertaining to the encephalon or brain [adj]\n",
  "ENCEPHALIN": "a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALINE, ENKEPHALIN, ENKEPHALINE [n -S]\n",
  "ENCEPHALINE": "a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALIN, ENKEPHALIN, ENKEPHALINE [n -S]\n",
  "ENCEPHALINES": "ENCEPHALINE, a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALIN, ENKEPHALIN, ENKEPHALINE [n]\n",
  "ENCEPHALINS": "ENCEPHALIN, a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALINE, ENKEPHALIN, ENKEPHALINE [n]\n",
  "ENCEPHALITIC": "relating to encephalitis [adj]\n",
  "ENCEPHALITIDES": "ENCEPHALITIS, inflammation of the brain [n]\n",
  "ENCEPHALITIS": "inflammation of the brain [n ENCEPHALITISES or ENCEPHALITIDES]\n",
  "ENCEPHALITISES": "ENCEPHALITIS, inflammation of the brain [n]\n",
  "ENCEPHALITOGEN": "an encephalitogenic agent, such as a virus [n -S]\n",
  "ENCEPHALITOGENS": "ENCEPHALITOGEN, an encephalitogenic agent, such as a virus [n]\n",
  "ENCEPHALOCELE": "a protrusion of a portion of the brain through the skull, where the bones are incomplete in infancy [n -S]\n",
  "ENCEPHALOCELES": "ENCEPHALOCELE, a protrusion of a portion of the brain through the skull, where the bones are incomplete in infancy [n]\n",
  "ENCEPHALOGRAM": "an X-ray picture of the brain made by encephalography [n -S]\n",
  "ENCEPHALOGRAMS": "ENCEPHALOGRAM, an X-ray picture of the brain made by encephalography [n]\n",
  "ENCEPHALOGRAPH": "an instrument for recording brain images [n -S]\n",
  "ENCEPHALOGRAPHS": "ENCEPHALOGRAPH, an instrument for recording brain images [n]\n",
  "ENCEPHALOGRAPHY": "radiography of the brain after the cerebrospinal fluid has been replaced by a gas (as air) [n]\n",
  "ENCEPHALOID": "like or resembling a brain [adj]\n",
  "ENCEPHALOMA": "a brain tumour [n ENCEPHALOMAS or ENCEPHALOMATA]\n",
  "ENCEPHALOMAS": "ENCEPHALOMA, a brain tumour [n]\n",
  "ENCEPHALOMATA": "ENCEPHALOMA, a brain tumour [n]\n",
  "ENCEPHALON": "the contents of the cranium; the brain [n ENCEPHALA or ENCEPHALONS]\n",
  "ENCEPHALONS": "ENCEPHALON, the contents of the cranium; the brain [n]\n",
  "ENCEPHALOPATHIC": "relating to encephalopathy [adj]\n",
  "ENCEPHALOPATHY": "any of various brain diseases [n]\n",
  "ENCEPHALOTOMIES": "ENCEPHALOTOMY, dissection of the brain [n]\n",
  "ENCEPHALOTOMY": "dissection of the brain [n ENCEPHALOTOMIES]\n",
  "ENCEPHALOUS": "having a head, also CEPHALOUS [adj]\n",
  "ENCHAFE": "(obsolete) to make warm; to irritate [v ENCHAFED, ENCHAFING, ENCHAFES]\n",
  "ENCHAFED": "ENCHAFE, (obsolete) to make warm; to irritate [v]\n",
  "ENCHAFES": "ENCHAFE, (obsolete) to make warm; to irritate [v]\n",
  "ENCHAFING": "ENCHAFE, (obsolete) to make warm; to irritate [v]\n",
  "ENCHAIN": "to bind with chains [v -ED, -ING, -S]\n",
  "ENCHAINED": "ENCHAIN, to bind with chains [v]\n",
  "ENCHAINING": "ENCHAIN, to bind with chains [v]\n",
  "ENCHAINMENT": "the act of enchaining [n -S]\n",
  "ENCHAINMENTS": "ENCHAINMENT, the act of enchaining [n]\n",
  "ENCHAINS": "ENCHAIN, to bind with chains [v]\n",
  "ENCHANT": "to delight [v -ED, -ING, -S]\n",
  "ENCHANTED": "ENCHANT, to delight [v]\n",
  "ENCHANTER": "one who enchants [n -S]\n",
  "ENCHANTERS": "ENCHANTER, one who enchants [n]\n",
  "ENCHANTING": "ENCHANT, to delight [v]\n",
  "ENCHANTINGLY": "ENCHANTING, ENCHANT, to delight [adv]\n",
  "ENCHANTMENT": "the act or art of enchanting [n -S]\n",
  "ENCHANTMENTS": "ENCHANTMENT, the act or art of enchanting [n]\n",
  "ENCHANTRESS": "a woman who practices magic [n -ES]\n",
  "ENCHANTRESSES": "ENCHANTRESS, a woman who practices magic [n]\n",
  "ENCHANTS": "ENCHANT, to delight [v]\n",
  "ENCHARGE": "(archaic) to entrust [v ENCHARGED, ENCHARGING, ENCHARGES]\n",
  "ENCHARGED": "ENCHARGE, (archaic) to entrust [v]\n",
  "ENCHARGES": "ENCHARGE, (archaic) to entrust [v]\n",
  "ENCHARGING": "ENCHARGE, (archaic) to entrust [v]\n",
  "ENCHARM": "(obsolete) to cast a spell on, to charm [v -ED, -ING, -S]\n",
  "ENCHARMED": "ENCHARM, (obsolete) to cast a spell on, to charm [v]\n",
  "ENCHARMING": "ENCHARM, (obsolete) to cast a spell on, to charm [v]\n",
  "ENCHARMS": "ENCHARM, (obsolete) to cast a spell on, to charm [v]\n",
  "ENCHASE": "to place in an ornamental border, also INCHASE [v ENCHASED, ENCHASING, ENCHASES]\n",
  "ENCHASED": "ENCHASE, to place in an ornamental border, also INCHASE [v]\n",
  "ENCHASER": "one who enchases [n -S]\n",
  "ENCHASERS": "ENCHASER, one who enchases [n]\n",
  "ENCHASES": "ENCHASE, to place in an ornamental border, also INCHASE [v]\n",
  "ENCHASING": "ENCHASE, to place in an ornamental border, also INCHASE [v]\n",
  "ENCHEASON": "(Spenser) a reason, cause [n -S]\n",
  "ENCHEASONS": "ENCHEASON, (Spenser) a reason, cause [n]\n",
  "ENCHEER": "(archaic) to cheer or comfort [v -ED, -ING, -S]\n",
  "ENCHEERED": "ENCHEER, (archaic) to cheer or comfort [v]\n",
  "ENCHEERING": "ENCHEER, (archaic) to cheer or comfort [v]\n",
  "ENCHEERS": "ENCHEER, (archaic) to cheer or comfort [v]\n",
  "ENCHEIRIDIA": "ENCHEIRIDION, a handbook or a manual, also ENCHIRIDION [n]\n",
  "ENCHEIRIDION": "a handbook or a manual, also ENCHIRIDION [n ENCHEIRIDIA or ENCHEIRIDIONS]\n",
  "ENCHEIRIDIONS": "ENCHEIRIDION, a handbook or a manual, also ENCHIRIDION [n]\n",
  "ENCHILADA": "(Spanish) a Mexican dish consisting of a rolled stuffed tortilla cooked with a chilli-flavoured sauce [n -S]\n",
  "ENCHILADAS": "ENCHILADA, (Spanish) a Mexican dish consisting of a rolled stuffed tortilla cooked with a chilli-flavoured sauce [n]\n",
  "ENCHIRIDIA": "ENCHIRIDION, a manual or handbook, also ENCHEIRIDION [n]\n",
  "ENCHIRIDION": "a manual or handbook, also ENCHEIRIDION [n ENCHIRIDIA or ENCHIRIDIONS]\n",
  "ENCHIRIDIONS": "ENCHIRIDION, a manual or handbook, also ENCHEIRIDION [n]\n",
  "ENCHONDROMA": "an abnormal cartilaginous growth [n ENCHONDROMAS or ENCHONDROMATA]\n",
  "ENCHONDROMAS": "ENCHONDROMA, an abnormal cartilaginous growth [n]\n",
  "ENCHONDROMATA": "ENCHONDROMA, an abnormal cartilaginous growth [n]\n",
  "ENCHONDROMATOUS": "of or like an enchondroma, an abnormal cartilaginous growth [adj]\n",
  "ENCHORIAL": "belonging to or used in a country; domestic, also ENCHORIC [adj]\n",
  "ENCHORIC": "belonging to or used in a country; domestic, also ENCHORIAL [adj]\n",
  "ENCIERRO": "(Spanish) in Spanish towns, an event in which bulls are driven through the streets of a town to a bullring [n -S]\n",
  "ENCIERROS": "ENCIERRO, (Spanish) in Spanish towns, an event in which bulls are driven through the streets of a town to a bullring [n]\n",
  "ENCINA": "(Spanish) an evergreen oak [n -S]\n",
  "ENCINAL": "relating to an encina, an evergreen oak [adj]\n",
  "ENCINAS": "ENCINA, (Spanish) an evergreen oak [n]\n",
  "ENCINCTURE": "a cincture [n -S] / to girdle [v ENCINCTURED, ENCINCTURING, ENCINCTURES]\n",
  "ENCINCTURED": "ENCINCTURE, to girdle [v]\n",
  "ENCINCTURES": "ENCINCTURE, a cincture [n]\n",
  "ENCINCTURING": "ENCINCTURE, to girdle [v]\n",
  "ENCIPHER": "to write in a secret code [v -ED, -ING, -S]\n",
  "ENCIPHERED": "ENCIPHER, to write in a secret code [v]\n",
  "ENCIPHERER": "one who enciphers [n -S]\n",
  "ENCIPHERERS": "ENCIPHERER, one who enciphers [n]\n",
  "ENCIPHERING": "ENCIPHER, to write in a secret code [v]\n",
  "ENCIPHERMENT": "the act of enciphering [n -S]\n",
  "ENCIPHERMENTS": "ENCIPHERMENT, the act of enciphering [n]\n",
  "ENCIPHERS": "ENCIPHER, to write in a secret code [v]\n",
  "ENCIRCLE": "to form a circle around [v ENCIRCLED, ENCIRCLING, ENCIRCLES]\n",
  "ENCIRCLED": "ENCIRCLE, to form a circle around [v]\n",
  "ENCIRCLEMENT": "the act of encircling [n -S]\n",
  "ENCIRCLEMENTS": "ENCIRCLEMENT, the act of encircling [n]\n",
  "ENCIRCLES": "ENCIRCLE, to form a circle around [v]\n",
  "ENCIRCLING": "ENCIRCLE, to form a circle around [v]\n",
  "ENCLASP": "to embrace, also INCLASP [v -ED, -ING, -S]\n",
  "ENCLASPED": "ENCLASP, to embrace, also INCLASP [v]\n",
  "ENCLASPING": "ENCLASP, to embrace, also INCLASP [v]\n",
  "ENCLASPS": "ENCLASP, to embrace, also INCLASP [v]\n",
  "ENCLAVE": "a distinct territorial, cultural, or social unit enclosed within or as if within foreign territory [n -S] / to surround [v ENCLAVED, ENCLAVING, ENCLAVES]\n",
  "ENCLAVED": "ENCLAVE, to surround [v]\n",
  "ENCLAVES": "ENCLAVE, to surround [v]\n",
  "ENCLAVING": "ENCLAVE, to surround [v]\n",
  "ENCLISES": "ENCLISIS, the shifting of stress to a preceding word [n]\n",
  "ENCLISIS": "the shifting of stress to a preceding word [n ENCLISES]\n",
  "ENCLITIC": "without accent or stress, behaving as if not a separate word [adj ENCLITICALLY] / a word or particle which always follows another word and which is enclitic to it [n -S]\n",
  "ENCLITICALLY": "ENCLITIC, without accent or stress, behaving as if not a separate word [adv]\n",
  "ENCLITICS": "ENCLITIC, a word or particle which always follows another word and which is enclitic to it [n]\n",
  "ENCLOISTER": "(obsolete) to shut up in a cloister [v -ED, -ING, -S]\n",
  "ENCLOISTERED": "ENCLOISTER, (obsolete) to shut up in a cloister [v]\n",
  "ENCLOISTERING": "ENCLOISTER, (obsolete) to shut up in a cloister [v]\n",
  "ENCLOISTERS": "ENCLOISTER, (obsolete) to shut up in a cloister [v]\n",
  "ENCLOSABLE": "that can be enclosed, also INCLOSABLE [adj]\n",
  "ENCLOSE": "to surround, also INCLOSE [v ENCLOSED, ENCLOSING, ENCLOSES]\n",
  "ENCLOSED": "ENCLOSE, to surround, also INCLOSE [v]\n",
  "ENCLOSER": "one who encloses [n -S]\n",
  "ENCLOSERS": "ENCLOSER, one who encloses [n]\n",
  "ENCLOSES": "ENCLOSE, to surround, also INCLOSE [v]\n",
  "ENCLOSING": "ENCLOSE, to surround, also INCLOSE [v]\n",
  "ENCLOSURE": "the act of enclosing, also INCLOSURE [n -S]\n",
  "ENCLOSURES": "ENCLOSURE, the act of enclosing, also INCLOSURE [n]\n",
  "ENCLOTHE": "to clothe [v ENCLOTHED, ENCLOTHING, ENCLOTHES]\n",
  "ENCLOTHED": "ENCLOTHE, to clothe [v]\n",
  "ENCLOTHES": "ENCLOTHE, to clothe [v]\n",
  "ENCLOTHING": "ENCLOTHE, to clothe [v]\n",
  "ENCLOUD": "to cover with clouds [v -ED, -ING, -S]\n",
  "ENCLOUDED": "ENCLOUD, to cover with clouds [v]\n",
  "ENCLOUDING": "ENCLOUD, to cover with clouds [v]\n",
  "ENCLOUDS": "ENCLOUD, to cover with clouds [v]\n",
  "ENCODABLE": "that can be encoded [adj]\n",
  "ENCODE": "to put into code [v ENCODED, ENCODING, ENCODES]\n",
  "ENCODED": "ENCODE, to put into code [v]\n",
  "ENCODEMENT": "the act of encoding [n -S]\n",
  "ENCODEMENTS": "ENCODEMENT, the act of encoding [n]\n",
  "ENCODER": "one who encodes [n -S]\n",
  "ENCODERS": "ENCODER, one who encodes [n]\n",
  "ENCODES": "ENCODE, to put into code [v]\n",
  "ENCODING": "the act of putting into coded form [n -S]\n",
  "ENCODINGS": "ENCODING, the act of putting into coded form [n]\n",
  "ENCOIGNURE": "a piece of furniture made to fit into a corner [n -S]\n",
  "ENCOIGNURES": "ENCOIGNURE, a piece of furniture made to fit into a corner [n]\n",
  "ENCOLOUR": "to colour or tinge [v -ED, -ING, -S]\n",
  "ENCOLOURED": "ENCOLOUR, to colour or tinge [v]\n",
  "ENCOLOURING": "ENCOLOUR, to colour or tinge [v]\n",
  "ENCOLOURS": "ENCOLOUR, to colour or tinge [v]\n",
  "ENCOLPIA": "ENCOLPION, (Greek) a reliquary; a cross worn on the breast, also ENCOLPIUM [n]\n",
  "ENCOLPION": "(Greek) a reliquary; a cross worn on the breast, also ENCOLPIUM [n ENCOLPIA or ENCOLPIONS]\n",
  "ENCOLPIONS": "ENCOLPION, (Greek) a reliquary; a cross worn on the breast, also ENCOLPIUM [n]\n",
  "ENCOLPIUM": "a reliquary; a cross worn on the breast, also ENCOLPION [n -S]\n",
  "ENCOLPIUMS": "ENCOLPIUM, a reliquary; a cross worn on the breast, also ENCOLPION [n]\n",
  "ENCOLURE": "a mane of a horse [n -S]\n",
  "ENCOLURES": "ENCOLURE, a mane of a horse [n]\n",
  "ENCOMENDERO": "the commander of an encomienda [n -S]\n",
  "ENCOMENDEROS": "ENCOMENDERO, the commander of an encomienda [n]\n",
  "ENCOMIA": "ENCOMIUM, (Greek) an address of praise, also ENCOMION [n]\n",
  "ENCOMIAST": "a person who utters encomiums [n -S]\n",
  "ENCOMIASTIC": "bestowing praise, also ENCOMIASTICAL [adj ENCOMIASTICALLY]\n",
  "ENCOMIASTICAL": "bestowing praise, also ENCOMIASTIC [adj ENCOMIASTICALLY]\n",
  "ENCOMIASTICALLY": "ENCOMIASTICAL, bestowing praise, also ENCOMIASTIC [adv]\n",
  "ENCOMIASTS": "ENCOMIAST, a person who utters encomiums [n]\n",
  "ENCOMIENDA": "(Spanish) a commandery or commander's district [n -S]\n",
  "ENCOMIENDAS": "ENCOMIENDA, (Spanish) a commandery or commander's district [n]\n",
  "ENCOMION": "(Greek) glowing and warmly enthusiastic praise, also ENCOMIUM [n ENCOMIA]\n",
  "ENCOMIUM": "(Greek) an address of praise, also ENCOMION [n ENCOMIUMS or ENCOMIA]\n",
  "ENCOMIUMS": "ENCOMIUM, (Greek) an address of praise, also ENCOMION [n]\n",
  "ENCOMPASS": "to surround [v -ED, -ING, -ES]\n",
  "ENCOMPASSED": "ENCOMPASS, to surround [v]\n",
  "ENCOMPASSES": "ENCOMPASS, to surround [v]\n",
  "ENCOMPASSING": "ENCOMPASS, to surround [v]\n",
  "ENCOMPASSMENT": "the act of encompassing [n -S]\n",
  "ENCOMPASSMENTS": "ENCOMPASSMENT, the act of encompassing [n]\n",
  "ENCOPRESES": "ENCOPRESIS, the involuntary discharge of faeces, esp. when associated with psychiatric disturbance [n]\n",
  "ENCOPRESIS": "the involuntary discharge of faeces, esp. when associated with psychiatric disturbance [n ENCOPRESES]\n",
  "ENCOPRETIC": "relating to encopresis, the involuntary discharge of faeces [adj]\n",
  "ENCORE": "(French) to call for a repetition of a performance [v ENCORED, ENCORING, ENCORES]\n",
  "ENCORED": "ENCORE, (French) to call for a repetition of a performance [v]\n",
  "ENCORES": "ENCORE, (French) to call for a repetition of a performance [v]\n",
  "ENCORING": "ENCORE, (French) to call for a repetition of a performance [v]\n",
  "ENCOUNTER": "to meet [v -ED, -ING, -S]\n",
  "ENCOUNTERED": "ENCOUNTER, to meet [v]\n",
  "ENCOUNTERER": "one who encounters [n -S]\n",
  "ENCOUNTERERS": "ENCOUNTERER, one who encounters [n]\n",
  "ENCOUNTERING": "ENCOUNTER, to meet [v]\n",
  "ENCOUNTERS": "ENCOUNTER, to meet [v]\n",
  "ENCOURAGE": "to hearten, also ACCORAGE, ACCOURAGE [v ENCOURAGED, ENCOURAGING, ENCOURAGES]\n",
  "ENCOURAGED": "ENCOURAGE, to hearten, also ACCORAGE, ACCOURAGE [v]\n",
  "ENCOURAGEMENT": "the act of encouraging [n -S]\n",
  "ENCOURAGEMENTS": "ENCOURAGEMENT, the act of encouraging [n]\n",
  "ENCOURAGER": "one who encourages [n -S]\n",
  "ENCOURAGERS": "ENCOURAGER, one who encourages [n]\n",
  "ENCOURAGES": "ENCOURAGE, to hearten, also ACCORAGE, ACCOURAGE [v]\n",
  "ENCOURAGING": "heartening [adj ENCOURAGINGLY] / the act of giving encouragement [n -S]\n",
  "ENCOURAGINGLY": "ENCOURAGING, heartening [adv]\n",
  "ENCOURAGINGS": "ENCOURAGING, the act of giving encouragement [n]\n",
  "ENCRADLE": "(Spenser) to lay in a cradle [v ENCRADLED, ENCRADLING, ENCRADLES]\n",
  "ENCRADLED": "ENCRADLE, (Spenser) to lay in a cradle [v]\n",
  "ENCRADLES": "ENCRADLE, (Spenser) to lay in a cradle [v]\n",
  "ENCRADLING": "ENCRADLE, (Spenser) to lay in a cradle [v]\n",
  "ENCRATIES": "ENCRATY, (Greek) self-control [n]\n",
  "ENCRATY": "(Greek) self-control [n ENCRATIES]\n",
  "ENCREASE": "to become larger, also INCREASE [v ENCREASED, ENCREASING, ENCREASES]\n",
  "ENCREASED": "ENCREASE, to become larger, also INCREASE [v]\n",
  "ENCREASES": "ENCREASE, to become larger, also INCREASE [v]\n",
  "ENCREASING": "ENCREASE, to become larger, also INCREASE [v]\n",
  "ENCRIMSON": "to colour crimson [v -ED, -ING, -S]\n",
  "ENCRIMSONED": "ENCRIMSON, to colour crimson [v]\n",
  "ENCRIMSONING": "ENCRIMSON, to colour crimson [v]\n",
  "ENCRIMSONS": "ENCRIMSON, to colour crimson [v]\n",
  "ENCRINAL": "containing fossils with branching arms, also ENCRINIC [adj]\n",
  "ENCRINIC": "containing fossils with branching arms, also ENCRINAL [adj]\n",
  "ENCRINITAL": "of or like an encrinite, a fossil crinoid, also ENCRINAL, ENCRINIC, ENCRINITIC [adj]\n",
  "ENCRINITE": "a fossil crinoid, esp. one belonging to, or resembling, the genus Encrinus [n -S]\n",
  "ENCRINITES": "ENCRINITE, a fossil crinoid, esp. one belonging to, or resembling, the genus Encrinus [n]\n",
  "ENCRINITIC": "of or like an encrinite, a fossil crinoid, also ENCRINAL, ENCRINIC, ENCRINITAL [adj]\n",
  "ENCROACH": "to intrude on another's territory [v -ED, -ING, -ES]\n",
  "ENCROACHED": "ENCROACH, to intrude on another's territory [v]\n",
  "ENCROACHER": "one who encroaches [n -S]\n",
  "ENCROACHERS": "ENCROACHER, one who encroaches [n]\n",
  "ENCROACHES": "ENCROACH, to intrude on another's territory [v]\n",
  "ENCROACHING": "ENCROACH, to intrude on another's territory [v]\n",
  "ENCROACHINGLY": "ENCROACHING, ENCROACH, to intrude on another's territory [adv]\n",
  "ENCROACHMENT": "the act of encroaching [n -S]\n",
  "ENCROACHMENTS": "ENCROACHMENT, the act of encroaching [n]\n",
  "ENCRUST": "to cover with a crust, also INCRUST [v -ED, -ING, -S]\n",
  "ENCRUSTATION": "the act of encrusting; a crust or layer of anything, also INCRUSTATION [n -S]\n",
  "ENCRUSTATIONS": "ENCRUSTATION, the act of encrusting; a crust or layer of anything, also INCRUSTATION [n]\n",
  "ENCRUSTED": "ENCRUST, to cover with a crust, also INCRUST [v]\n",
  "ENCRUSTING": "ENCRUST, to cover with a crust, also INCRUST [v]\n",
  "ENCRUSTMENT": "the act of encrusting, also INCRUSTMENT [n -S]\n",
  "ENCRUSTMENTS": "ENCRUSTMENT, the act of encrusting, also INCRUSTMENT [n]\n",
  "ENCRUSTS": "ENCRUST, to cover with a crust, also INCRUST [v]\n",
  "ENCRYPT": "to put a message into code [v -ED, -ING, -S]\n",
  "ENCRYPTED": "ENCRYPT, to put a message into code [v]\n",
  "ENCRYPTING": "ENCRYPT, to put a message into code [v]\n",
  "ENCRYPTION": "the act of encrypting [n -S]\n",
  "ENCRYPTIONS": "ENCRYPTION, the act of encrypting [n]\n",
  "ENCRYPTS": "ENCRYPT, to put a message into code [v]\n",
  "ENCULTURATE": "to culture [v ENCULTURATED, ENCULTURATING, ENCULTURATES]\n",
  "ENCULTURATED": "ENCULTURATE, to culture [v]\n",
  "ENCULTURATES": "ENCULTURATE, to culture [v]\n",
  "ENCULTURATING": "ENCULTURATE, to culture [v]\n",
  "ENCULTURATION": "the process by which an individual learns the traditional content of a culture and assimilates its practices and values [n -S]\n",
  "ENCULTURATIONS": "ENCULTURATION, the process by which an individual learns the traditional content of a culture and assimilates its practices and values [n]\n",
  "ENCULTURATIVE": "relating to enculturation [adj]\n",
  "ENCUMBER": "to impede the motion of, also INCUMBER [v -ED, -ING, -S]\n",
  "ENCUMBERED": "ENCUMBER, to impede the motion of, also INCUMBER [v]\n",
  "ENCUMBERING": "ENCUMBER, to impede the motion of, also INCUMBER [v]\n",
  "ENCUMBERINGLY": "ENCUMBERING, ENCUMBER, to impede the motion of, also INCUMBER [adv]\n",
  "ENCUMBERMENT": "the act of encumbering; the state of being encumbered [n -S]\n",
  "ENCUMBERMENTS": "ENCUMBERMENT, the act of encumbering; the state of being encumbered [n]\n",
  "ENCUMBERS": "ENCUMBER, to impede the motion of, also INCUMBER [v]\n",
  "ENCUMBRANCE": "something that encumbers, also INCUMBRANCE [n -S]\n",
  "ENCUMBRANCER": "one that holds an encumbrance, also INCUMBRANCER [n -S]\n",
  "ENCUMBRANCERS": "ENCUMBRANCER, one that holds an encumbrance, also INCUMBRANCER [n]\n",
  "ENCUMBRANCES": "ENCUMBRANCE, something that encumbers, also INCUMBRANCE [n]\n",
  "ENCURTAIN": "to enclose with curtains [v -ED, -ING, -S]\n",
  "ENCURTAINED": "ENCURTAIN, to enclose with curtains [v]\n",
  "ENCURTAINING": "ENCURTAIN, to enclose with curtains [v]\n",
  "ENCURTAINS": "ENCURTAIN, to enclose with curtains [v]\n",
  "ENCYCLIC": "a letter sent by the pope to multiple bishops, also ENCYCLICAL [n -S]\n",
  "ENCYCLICAL": "a letter sent by the pope to multiple bishops, also ENCYCLIC [n -S]\n",
  "ENCYCLICALS": "ENCYCLICAL, a letter sent by the pope to multiple bishops, also ENCYCLIC [n]\n",
  "ENCYCLICS": "ENCYCLIC, a letter sent by the pope to multiple bishops, also ENCYCLICAL [n]\n",
  "ENCYCLOPAEDIA": "a work containing information on every branch, or on a particular branch, of knowledge, also ENCYCLOPEDIA [n -S]\n",
  "ENCYCLOPAEDIAS": "ENCYCLOPAEDIA, a work containing information on every branch, or on a particular branch, of knowledge, also ENCYCLOPEDIA [n]\n",
  "ENCYCLOPAEDIC": "like an encyclopaedia, comprehensive, also ENCYCLOPEDIC, ENCYCLOPAEDICAL, ENCYCLOPEDICAL [adj]\n",
  "ENCYCLOPAEDICAL": "of or relating to an encyclopedia; comprehensive; full of information, also ENCYCLOPEDIC, ENCYCLOPEDICAL [adj]\n",
  "ENCYCLOPAEDISM": "the compiling of encyclopaedias, also ENCYCLOPEDISM [n -S]\n",
  "ENCYCLOPAEDISMS": "ENCYCLOPAEDISM, the compiling of encyclopaedias, also ENCYCLOPEDISM [n]\n",
  "ENCYCLOPAEDIST": "one who compiles encyclopaedias, also ENCYCLOPEDIST [n -S]\n",
  "ENCYCLOPAEDISTS": "ENCYCLOPAEDIST, one who compiles encyclopaedias, also ENCYCLOPEDIST [n]\n",
  "ENCYCLOPEDIA": "a work containing information on every branch, or on a particular branch, of knowledge, also ENCYCLOPAEDIA [n -S]\n",
  "ENCYCLOPEDIAN": "embracing the whole circle of learning [adj]\n",
  "ENCYCLOPEDIAS": "ENCYCLOPEDIA, a work containing information on every branch, or on a particular branch, of knowledge, also ENCYCLOPAEDIA [n]\n",
  "ENCYCLOPEDIC": "of or relating to an encyclopedia; comprehensive; full of information, also ENCYCLOPAEDIC, ENCYCLOPAEDICAL, ENCYCLOPEDICAL [adj]\n",
  "ENCYCLOPEDICAL": "of or relating to an encyclopedia; comprehensive; full of information, also ENCYCLOPAEDIC, ENCYCLOPAEDICAL, ENCYCLOPEDIC [adj]\n",
  "ENCYCLOPEDISM": "the state of being encyclopedic, also ENCYCLOPAEDISM [n -S]\n",
  "ENCYCLOPEDISMS": "ENCYCLOPEDISM, the state of being encyclopedic, also ENCYCLOPAEDISM [n]\n",
  "ENCYCLOPEDIST": "one who compiles or writes for an encyclopedia, also ENCYCLOPAEDIST [n -S]\n",
  "ENCYCLOPEDISTS": "ENCYCLOPEDIST, one who compiles or writes for an encyclopedia, also ENCYCLOPAEDIST [n]\n",
  "ENCYST": "to become enclosed in a vesicle [v -ED, -ING, -S]\n",
  "ENCYSTATION": "the state of being encysted [n -S]\n",
  "ENCYSTATIONS": "ENCYSTATION, the state of being encysted [n]\n",
  "ENCYSTED": "ENCYST, to become enclosed in a vesicle [v]\n",
  "ENCYSTING": "ENCYST, to become enclosed in a vesicle [v]\n",
  "ENCYSTMENT": "the act of encysting [n -S]\n",
  "ENCYSTMENTS": "ENCYSTMENT, the act of encysting [n]\n",
  "ENCYSTS": "ENCYST, to become enclosed in a vesicle [v]\n",
  "END": "to terminate [v -ED, -ING, -S]\n",
  "ENDAMAGE": "to damage [v ENDAMAGED, ENDAMAGING, ENDAMAGES]\n",
  "ENDAMAGED": "ENDAMAGE, to damage [v]\n",
  "ENDAMAGEMENT": "damage, injury [n -S]\n",
  "ENDAMAGEMENTS": "ENDAMAGEMENT, damage, injury [n]\n",
  "ENDAMAGES": "ENDAMAGE, to damage [v]\n",
  "ENDAMAGING": "ENDAMAGE, to damage [v]\n",
  "ENDAMEBA": "(Greek) a parasitic amoeba, also ENDAMOEBA, ENTAMEBA [n ENDAMEBAS or ENDAMEBAE]\n",
  "ENDAMEBAE": "ENDAMEBA, (Greek) a parasitic amoeba, also ENDAMOEBA, ENTAMEBA [n]\n",
  "ENDAMEBAS": "ENDAMEBA, (Greek) a parasitic amoeba, also ENDAMOEBA, ENTAMEBA [n]\n",
  "ENDAMEBIC": "like an endameba, a parasitic amoeba, also ENDAMOEBIC [adj]\n",
  "ENDAMOEBA": "(Greek) a parasitic amoeba, also ENDAMEBA [n ENDAMOEBAE or ENDAMOEBAS]\n",
  "ENDAMOEBAE": "ENDAMOEBA, (Greek) a parasitic amoeba, also ENDAMEBA [n]\n",
  "ENDAMOEBAS": "ENDAMOEBA, (Greek) a parasitic amoeba, also ENDAMEBA [n]\n",
  "ENDAMOEBIC": "like an endamoeba, a parasitic amoeba, also ENDAMEBIC [adj]\n",
  "ENDANGER": "to expose to loss or injury [v -ED, -ING, -S]\n",
  "ENDANGERED": "ENDANGER, to expose to loss or injury [v]\n",
  "ENDANGERER": "one who endangers [n -S]\n",
  "ENDANGERERS": "ENDANGERER, one who endangers [n]\n",
  "ENDANGERING": "ENDANGER, to expose to loss or injury [v]\n",
  "ENDANGERMENT": "the act of endangering [n -S]\n",
  "ENDANGERMENTS": "ENDANGERMENT, the act of endangering [n]\n",
  "ENDANGERS": "ENDANGER, to expose to loss or injury [v]\n",
  "ENDARCH": "having the protoxylem on the inner edge [adj]\n",
  "ENDARCHIES": "ENDARCHY, the condition of being endarch [n]\n",
  "ENDARCHY": "the condition of being endarch [n ENDARCHIES]\n",
  "ENDART": "(Shakespeare) to dart in, also INDART [v -ED, -ING, -S]\n",
  "ENDARTED": "ENDART, (Shakespeare) to dart in, also INDART [v]\n",
  "ENDARTERECTOMY": "surgical removal of arterial plaque [n]\n",
  "ENDARTING": "ENDART, (Shakespeare) to dart in, also INDART [v]\n",
  "ENDARTS": "ENDART, (Shakespeare) to dart in, also INDART [v]\n",
  "ENDASH": "a mark in writing used to connect elements of a compound [n -ES]\n",
  "ENDASHES": "ENDASH, a mark in writing used to connect elements of a compound [n]\n",
  "ENDBRAIN": "a part of the brain [n -S]\n",
  "ENDBRAINS": "ENDBRAIN, a part of the brain [n]\n",
  "ENDCAP": "a display of products at the end of an aisle in a store [n -S]\n",
  "ENDCAPS": "ENDCAP, a display of products at the end of an aisle in a store [n]\n",
  "ENDEAR": "to make beloved [v -ED, -ING, -S]\n",
  "ENDEARED": "ENDEAR, to make beloved [v]\n",
  "ENDEARING": "ENDEAR, to make beloved [v]\n",
  "ENDEARINGLY": "ENDEARING, ENDEAR, to make beloved [adv]\n",
  "ENDEARINGNESS": "the state of being endearing [n -ES]\n",
  "ENDEARINGNESSES": "ENDEARINGNESS, the state of being endearing [n]\n",
  "ENDEARMENT": "a word or an act (as a caress) expressing affection [n -S]\n",
  "ENDEARMENTS": "ENDEARMENT, a word or an act (as a caress) expressing affection [n]\n",
  "ENDEARS": "ENDEAR, to make beloved [v]\n",
  "ENDEAVOR": "to strive or attempt [v -ED, -ING, -S]\n",
  "ENDEAVORED": "ENDEAVOR, to strive or attempt [v]\n",
  "ENDEAVORER": "one who endeavours, also ENDEAVOURER [n -S]\n",
  "ENDEAVORERS": "ENDEAVORER, one who endeavours, also ENDEAVOURER [n]\n",
  "ENDEAVORING": "ENDEAVOR, to strive or attempt [v]\n",
  "ENDEAVORS": "ENDEAVOR, to strive or attempt [v]\n",
  "ENDEAVOUR": "to try, also ENDEAVOR [v -ED, -ING, -S]\n",
  "ENDEAVOURED": "ENDEAVOUR, to try, also ENDEAVOR [v]\n",
  "ENDEAVOURER": "one who endeavours, also ENDEAVORER [n -S]\n",
  "ENDEAVOURERS": "ENDEAVOURER, one who endeavours, also ENDEAVORER [n]\n",
  "ENDEAVOURING": "ENDEAVOUR, to try, also ENDEAVOR [v]\n",
  "ENDEAVOURMENT": "(Spenser) endeavour [n -S]\n",
  "ENDEAVOURMENTS": "ENDEAVOURMENT, (Spenser) endeavour [n]\n",
  "ENDEAVOURS": "ENDEAVOUR, to try, also ENDEAVOR [v]\n",
  "ENDECAGON": "an eleven-sided polygon, also HENDECAGON [n -S]\n",
  "ENDECAGONS": "ENDECAGON, an eleven-sided polygon, also HENDECAGON [n]\n",
  "ENDED": "END, to terminate [v]\n",
  "ENDEICTIC": "showing, exhibiting or demonstrating [adj]\n",
  "ENDEIXES": "ENDEIXIS, (Greek) in medicine, an indication [n]\n",
  "ENDEIXIS": "(Greek) in medicine, an indication [n ENDEIXISES or ENDEIXES]\n",
  "ENDEIXISES": "ENDEIXIS, (Greek) in medicine, an indication [n]\n",
  "ENDEMIAL": "confined to a people or area, also ENDEMIC, ENDEMICAL [adj]\n",
  "ENDEMIC": "confined to one particular area, also ENDEMICAL [adj ENDEMICALLY] / an endemic disease [n -S]\n",
  "ENDEMICAL": "confined to one particular area, e.g. of a disease also ENDEMIC [adj ENDEMICALLY]\n",
  "ENDEMICALLY": "ENDEMICAL, confined to one particular area, e.g. of a disease also ENDEMIC [adv]\n",
  "ENDEMICITIES": "ENDEMICITY, the state of being endemic [n]\n",
  "ENDEMICITY": "the state of being endemic [n ENDEMICITIES]\n",
  "ENDEMICS": "ENDEMIC, an endemic disease [n]\n",
  "ENDEMIOLOGIES": "ENDEMIOLOGY, the study of local diseases [n]\n",
  "ENDEMIOLOGY": "the study of local diseases [n ENDEMIOLOGIES]\n",
  "ENDEMISM": "the state of being endemic, confined to one particular area [n -S]\n",
  "ENDEMISMS": "ENDEMISM, the state of being endemic, confined to one particular area [n]\n",
  "ENDENIZEN": "to admit to the privileges of a denizen; to naturalize [v -ED, -ING, -S]\n",
  "ENDENIZENED": "ENDENIZEN, to admit to the privileges of a denizen; to naturalize [v]\n",
  "ENDENIZENING": "ENDENIZEN, to admit to the privileges of a denizen; to naturalize [v]\n",
  "ENDENIZENS": "ENDENIZEN, to admit to the privileges of a denizen; to naturalize [v]\n",
  "ENDER": "one that ends something [n -S]\n",
  "ENDERGONIC": "requiring energy [adj]\n",
  "ENDERMATIC": "through or applied directly to the skin, also ENDERMIC, ENDERMICAL [adj]\n",
  "ENDERMIC": "acting by absorption through the skin [adj]\n",
  "ENDERMICAL": "acting through the skin, or by direct application to the skin, also ENDERMATIC, ENDERMIC [adj]\n",
  "ENDERON": "the sensitive layer of the skin [n -S]\n",
  "ENDERONS": "ENDERON, the sensitive layer of the skin [n]\n",
  "ENDERS": "ENDER, one that ends something [n]\n",
  "ENDEW": "(Spenser) to endow, also ENDUE, INDEW, INDOW, INDUE [v -ED, -ING, -S]\n",
  "ENDEWED": "ENDEW, (Spenser) to endow, also ENDUE, INDEW, INDOW, INDUE [v]\n",
  "ENDEWING": "ENDEW, (Spenser) to endow, also ENDUE, INDEW, INDOW, INDUE [v]\n",
  "ENDEWS": "ENDEW, (Spenser) to endow, also ENDUE, INDEW, INDOW, INDUE [v]\n",
  "ENDEXINE": "an inner layer of the exine, the tough outer wall of a pollen grain [n -S]\n",
  "ENDEXINES": "ENDEXINE, an inner layer of the exine, the tough outer wall of a pollen grain [n]\n",
  "ENDGAME": "the last stage of a board game [n -S]\n",
  "ENDGAMES": "ENDGAME, the last stage of a board game [n]\n",
  "ENDGATE": "(US) a tailboard [n -S]\n",
  "ENDGATES": "ENDGATE, (US) a tailboard [n]\n",
  "ENDING": "termination [n -S]\n",
  "ENDINGS": "ENDING, termination [n]\n",
  "ENDIRON": "a metal support for logs in a fireplace, also ANDIRON [n -S]\n",
  "ENDIRONS": "ENDIRON, a metal support for logs in a fireplace, also ANDIRON [n]\n",
  "ENDITE": "to charge formally with a crime [v ENDITED, ENDITING, ENDITES]\n",
  "ENDITED": "ENDITE, to charge formally with a crime [v]\n",
  "ENDITES": "ENDITE, to charge formally with a crime [v]\n",
  "ENDITING": "ENDITE, to charge formally with a crime [v]\n",
  "ENDIVE": "(French) a salad plant of the chicory genus [n -S]\n",
  "ENDIVES": "ENDIVE, (French) a salad plant of the chicory genus [n]\n",
  "ENDLANG": "(Scots) endlong, lengthwise, also ENDLONG [adv]\n",
  "ENDLEAF": "an endpaper [n ENDLEAFS or ENDLEAVES]\n",
  "ENDLEAFS": "ENDLEAF, an endpaper [n]\n",
  "ENDLEAVES": "ENDLEAF, an endpaper [n]\n",
  "ENDLESS": "eternal [adj ENDLESSLY]\n",
  "ENDLESSLY": "ENDLESS, eternal [adv]\n",
  "ENDLESSNESS": "the state of being endless [n -ES]\n",
  "ENDLESSNESSES": "ENDLESSNESS, the state of being endless [n]\n",
  "ENDLONG": "lengthwise, also ENDLANG [adv]\n",
  "ENDMOST": "farthest [adj]\n",
  "ENDNOTE": "a note placed at the end of the text [n -S]\n",
  "ENDNOTES": "ENDNOTE, a note placed at the end of the text [n]\n",
  "ENDOBIOTIC": "living within the tissues of the host [adj]\n",
  "ENDOBLAST": "the inner cell-layer of a gastrula, also ENTOBLAST [n -S]\n",
  "ENDOBLASTIC": "relating to the endoblast [adj]\n",
  "ENDOBLASTS": "ENDOBLAST, the inner cell-layer of a gastrula, also ENTOBLAST [n]\n",
  "ENDOCARDIA": "ENDOCARDIUM, (Latin) a membrane lining the heart cavities [n]\n",
  "ENDOCARDIAC": "relating to the endocardium, a membrane lining the heart cavities, also ENDOCARDIAL [adj]\n",
  "ENDOCARDIAL": "relating to the endocardium, a membrane lining the heart cavities, also ENDOCARDIAC [adj]\n",
  "ENDOCARDITIC": "relating to endocarditis, inflammation of the inner lining of the heart [adj]\n",
  "ENDOCARDITIDES": "ENDOCARDITIS, inflammation of the inner lining of the heart [n]\n",
  "ENDOCARDITIS": "inflammation of the inner lining of the heart [n ENDOCARDITIDES or ENDOCARDITISES]\n",
  "ENDOCARDITISES": "ENDOCARDITIS, inflammation of the inner lining of the heart [n]\n",
  "ENDOCARDIUM": "(Latin) a membrane lining the heart cavities [n ENDOCARDIA]\n",
  "ENDOCARP": "the inner layer of a pericarp [n -S]\n",
  "ENDOCARPAL": "relating to an endocarp, also ENDOCARPIC [adj]\n",
  "ENDOCARPIC": "relating to an endocarp, also ENDOCARPAL [adj]\n",
  "ENDOCARPS": "ENDOCARP, the inner layer of a pericarp [n]\n",
  "ENDOCAST": "a cast of the cranial cavity [n -S]\n",
  "ENDOCASTS": "ENDOCAST, a cast of the cranial cavity [n]\n",
  "ENDOCENTRIC": "of a construction, fulfilling the grammatical role of one of its constituents [adj]\n",
  "ENDOCHONDRAL": "relating to a type of ossification affecting cartilage [adj]\n",
  "ENDOCHYLOUS": "having internal water-storing cells [adj]\n",
  "ENDOCRANIA": "ENDOCRANIUM, the thick fibrous membrane that lines the cranial cavity and forms the outermost layer of the dura mater [n]\n",
  "ENDOCRANIAL": "relating to the endocranium [adj]\n",
  "ENDOCRANIUM": "the thick fibrous membrane that lines the cranial cavity and forms the outermost layer of the dura mater [n ENDOCRANIA]\n",
  "ENDOCRINAL": "relating to the endocrine gland, also ENDOCRINIC [adj]\n",
  "ENDOCRINE": "secreting internally, also ENDOCRITIC [adj] / a gland that secretes directly into the blood or lymph [n -S]\n",
  "ENDOCRINES": "ENDOCRINE, a gland that secretes directly into the blood or lymph [n]\n",
  "ENDOCRINIC": "relating to the endocrine gland, also ENDOCRINAL [adj]\n",
  "ENDOCRINOLOGIC": "involving or relating to the endocrine glands or secretions or to endocrinology [adj]\n",
  "ENDOCRINOLOGIES": "ENDOCRINOLOGY, the study of glands [n]\n",
  "ENDOCRINOLOGIST": "one who studies endocrinology [n]\n",
  "ENDOCRINOLOGY": "the study of glands [n ENDOCRINOLOGIES]\n",
  "ENDOCRINOPATHIC": "of a disease, due to disorder of the endocrine system [adj]\n",
  "ENDOCRINOPATHY": "any disease due to disorder of the endocrine system [n]\n",
  "ENDOCRINOUS": "relating to the endocrine glands [adj]\n",
  "ENDOCRITIC": "endocrine, also ENDOCRINE [adj]\n",
  "ENDOCUTICLE": "the inner layer of the cuticle of an insect [n -S]\n",
  "ENDOCUTICLES": "ENDOCUTICLE, the inner layer of the cuticle of an insect [n]\n",
  "ENDOCYTIC": "involved absorption of cells [adj]\n",
  "ENDOCYTOSES": "ENDOCYTOSIS, the process by which a living cell takes up molecules bound to its surface [n]\n",
  "ENDOCYTOSIS": "the process by which a living cell takes up molecules bound to its surface [n ENDOCYTOSES]\n",
  "ENDOCYTOTIC": "relating to endocytosis [adj]\n",
  "ENDODERM": "the innermost layer of embryo, also ENTODERM [n -S]\n",
  "ENDODERMAL": "of or pertaining to the endoderm, also ENDODERMIC [adj]\n",
  "ENDODERMIC": "of or pertaining to the endoderm, also ENDODERMAL [adj]\n",
  "ENDODERMIS": "a close-set sheath, one cell thick, enclosing the central cylinder in plants [n -ES]\n",
  "ENDODERMISES": "ENDODERMIS, a close-set sheath, one cell thick, enclosing the central cylinder in plants [n]\n",
  "ENDODERMS": "ENDODERM, the innermost layer of embryo, also ENTODERM [n]\n",
  "ENDODONTAL": "relating to endodontics, a branch of dentistry concerned with diseases of the pulp [adj]\n",
  "ENDODONTIC": "relating to endodontics, a branch of dentistry concerned with diseases of the pulp [adj ENDODONTICALLY]\n",
  "ENDODONTICALLY": "ENDODONTIC, relating to endodontics, a branch of dentistry concerned with diseases of the pulp [adv]\n",
  "ENDODONTICS": "a branch of dentistry concerned with diseases of the pulp [n]\n",
  "ENDODONTIST": "a practitioner of endodontics [n -S]\n",
  "ENDODONTISTS": "ENDODONTIST, a practitioner of endodontics [n]\n",
  "ENDODYNE": "of an electrical circuit in which the same elements and valves are used both as oscillator and detector, aka autodyne [adj]\n",
  "ENDOENZYME": "an enzyme that functions inside the cell [n -S]\n",
  "ENDOENZYMES": "ENDOENZYME, an enzyme that functions inside the cell [n]\n",
  "ENDOERGIC": "of a reaction, absorbing energy [adj]\n",
  "ENDOGAMIC": "relating to endogamy, marriage within the group [adj]\n",
  "ENDOGAMIES": "ENDOGAMY, the practice of marriage within a specific social group [n]\n",
  "ENDOGAMOUS": "marrying within the same tribe [adj]\n",
  "ENDOGAMY": "the practice of marriage within a specific social group [n ENDOGAMIES]\n",
  "ENDOGEN": "a plant which grows from within [n -S]\n",
  "ENDOGENIC": "formed or occurring inside the earth [adj]\n",
  "ENDOGENIES": "ENDOGENY, growth from within [n]\n",
  "ENDOGENOUS": "produced or growing from within [adj ENDOGENOUSLY]\n",
  "ENDOGENOUSLY": "ENDOGENOUS, produced or growing from within [adv]\n",
  "ENDOGENS": "ENDOGEN, a plant which grows from within [n]\n",
  "ENDOGENY": "growth from within [n ENDOGENIES]\n",
  "ENDOLITHIC": "living within or penetrating deeply into stony substances, e.g. endolithic lichens [adj]\n",
  "ENDOLYMPH": "the watery fluid contained in the membranous labyrinth of the internal ear [n -S]\n",
  "ENDOLYMPHATIC": "relating to endolymph, the watery fluid contained in the membranous labyrinth of the internal ear [adj]\n",
  "ENDOLYMPHS": "ENDOLYMPH, the watery fluid contained in the membranous labyrinth of the internal ear [n]\n",
  "ENDOMETRIA": "ENDOMETRIUM, (Latin) the inner lining of the womb [n]\n",
  "ENDOMETRIAL": "relating to the endometrium [adj]\n",
  "ENDOMETRIOSES": "ENDOMETRIOSIS, the presence and growth of functioning endometrial tissue in places other than the uterus, that often results in severe pain and infertility [n]\n",
  "ENDOMETRIOSIS": "the presence and growth of functioning endometrial tissue in places other than the uterus, that often results in severe pain and infertility [n ENDOMETRIOSES]\n",
  "ENDOMETRITIS": "inflammation of the endometrium [n -ES]\n",
  "ENDOMETRITISES": "ENDOMETRITIS, inflammation of the endometrium [n]\n",
  "ENDOMETRIUM": "(Latin) the inner lining of the womb [n ENDOMETRIA]\n",
  "ENDOMITOSES": "ENDOMITOSIS, division of chromosomes not followed by nuclear division that results in an increased number of chromosomes in the cell [n]\n",
  "ENDOMITOSIS": "division of chromosomes not followed by nuclear division that results in an increased number of chromosomes in the cell [n ENDOMITOSES]\n",
  "ENDOMITOTIC": "relating to endomitosis [adj]\n",
  "ENDOMIXES": "ENDOMIXIS, in Protozoa, a nuclear reorganization without conjugation [n]\n",
  "ENDOMIXIS": "in Protozoa, a nuclear reorganization without conjugation [n ENDOMIXES or ENDOMIXISES]\n",
  "ENDOMIXISES": "ENDOMIXIS, in Protozoa, a nuclear reorganization without conjugation [n]\n",
  "ENDOMORPH": "a person of generally heavy or rounded body build [n -S]\n",
  "ENDOMORPHIC": "heavily built [adj]\n",
  "ENDOMORPHIES": "ENDOMORPHY, the state of being an endomorph, a crystal of one species inclosed within one of another, as one of rutile inclosed in quartz [n]\n",
  "ENDOMORPHISM": "metamorphism of cooling igneous rock; mapping a set into itself [n -S]\n",
  "ENDOMORPHISMS": "ENDOMORPHISM, metamorphism of cooling igneous rock; mapping a set into itself [n]\n",
  "ENDOMORPHS": "ENDOMORPH, a person of generally heavy or rounded body build [n]\n",
  "ENDOMORPHY": "the state of being an endomorph, a crystal of one species inclosed within one of another, as one of rutile inclosed in quartz [n ENDOMORPHIES]\n",
  "ENDOMYCORRHIZA": "a type of fungus with hyphae that penetrate the cell wall and invaginate the cell membrane [n]\n",
  "ENDONEURIA": "ENDONEURIUM, the delicate connective tissue surrounding nerve fibres within a bundle [n]\n",
  "ENDONEURIUM": "the delicate connective tissue surrounding nerve fibres within a bundle [n ENDONEURIA]\n",
  "ENDONUCLEASE": "an enzyme that cuts a polynucleotide chain internally [n -S]\n",
  "ENDONUCLEASES": "ENDONUCLEASE, an enzyme that cuts a polynucleotide chain internally [n]\n",
  "ENDONUCLEOLYTIC": "cleaving a nucleotide chain into two parts at an internal point [adj]\n",
  "ENDOPARASITE": "a parasite that lives inside an animal [n -S]\n",
  "ENDOPARASITES": "ENDOPARASITE, a parasite that lives inside an animal [n]\n",
  "ENDOPARASITIC": "relating to endoparasites [adj]\n",
  "ENDOPARASITISM": "the state of being an endoparasite, a parasite that lives inside an animal [n -S]\n",
  "ENDOPARASITISMS": "ENDOPARASITISM, the state of being an endoparasite, a parasite that lives inside an animal [n]\n",
  "ENDOPEPTIDASE": "any of a group of enzymes that hydrolyze peptide bonds within the long chains of protein molecules [n -S]\n",
  "ENDOPEPTIDASES": "ENDOPEPTIDASE, any of a group of enzymes that hydrolyze peptide bonds within the long chains of protein molecules [n]\n",
  "ENDOPEROXIDE": "any of various biosynthetic intermediates in the formation of prostaglandins [n -S]\n",
  "ENDOPEROXIDES": "ENDOPEROXIDE, any of various biosynthetic intermediates in the formation of prostaglandins [n]\n",
  "ENDOPHAGIES": "ENDOPHAGY, cannibalism within a tribe; eating away from within [n]\n",
  "ENDOPHAGOUS": "exhibiting endophagy, cannibalism within a tribe [adj]\n",
  "ENDOPHAGY": "cannibalism within a tribe; eating away from within [n ENDOPHAGIES]\n",
  "ENDOPHITIC": "of or like an endophyte, an endoparasitic plant, also ENDOPHYTIC [adj]\n",
  "ENDOPHYLLOUS": "being or formed within a sheathing leaf; living inside a leaf [adj]\n",
  "ENDOPHYTE": "an endoparasitic plant [n -S]\n",
  "ENDOPHYTES": "ENDOPHYTE, an endoparasitic plant [n]\n",
  "ENDOPHYTIC": "of or like an endophyte, an endoparasitic plant, also ENDOPHITIC [adj]\n",
  "ENDOPHYTICALLY": "ENDOPHYTIC, of or like an endophyte, an endoparasitic plant, also ENDOPHITIC [adv]\n",
  "ENDOPLASM": "the protoplasm in the interior of a cell [n -S]\n",
  "ENDOPLASMIC": "as in endoplasmic reticulum, a series of flattened membranous tubules and cisternae in the cytoplasm of eukaryotic cells, also ENDOPLASTIC [adj]\n",
  "ENDOPLASMS": "ENDOPLASM, the protoplasm in the interior of a cell [n]\n",
  "ENDOPLASTIC": "as in endoplasmic reticulum, a series of flattened membranous tubules and cisternae in the cytoplasm of eukaryotic cells, also ENDOPLASMIC [adj]\n",
  "ENDOPLEURA": "the inner coating of a seed [n -S]\n",
  "ENDOPLEURAS": "ENDOPLEURA, the inner coating of a seed [n]\n",
  "ENDOPOD": "a branch of a crustacean limb [n -S]\n",
  "ENDOPODITE": "the internal or principal branch of the locomotive appendages of Crustacea [n -S]\n",
  "ENDOPODITES": "ENDOPODITE, the internal or principal branch of the locomotive appendages of Crustacea [n]\n",
  "ENDOPODS": "ENDOPOD, a branch of a crustacean limb [n]\n",
  "ENDOPOLYPLOID": "relating to endopolyploidy [adj]\n",
  "ENDOPOLYPLOIDY": "a polyploid state in which the chromosomes have divided repeatedly without subsequent division of the nucleus or cell [n]\n",
  "ENDOPROCT": "a small animal living in water [n -S]\n",
  "ENDOPROCTS": "ENDOPROCT, a small animal living in water [n]\n",
  "ENDORADIOSONDE": "a miniature battery-powered transmitter designed to be swallowed by the patient to send out information about a bodily function such as digestion [n -S]\n",
  "ENDORADIOSONDES": "ENDORADIOSONDE, a miniature battery-powered transmitter designed to be swallowed by the patient to send out information about a bodily function such as digestion [n]\n",
  "ENDORHIZAL": "having the radicle of the embryo enclosed in a sheath [adj]\n",
  "ENDORPHIN": "any of a group of peptides that occur in the brain and bind to the same receptors as morphine, thereby inhibiting pain [n -S]\n",
  "ENDORPHINS": "ENDORPHIN, any of a group of peptides that occur in the brain and bind to the same receptors as morphine, thereby inhibiting pain [n]\n",
  "ENDORSABLE": "that can be endorsed [adj]\n",
  "ENDORSATION": "approval or support, also INDORSATION [n -S]\n",
  "ENDORSATIONS": "ENDORSATION, approval or support, also INDORSATION [n]\n",
  "ENDORSE": "to declare one's approval, also INDORSE [v ENDORSED, ENDORSING, ENDORSES]\n",
  "ENDORSED": "ENDORSE, to declare one's approval, also INDORSE [v]\n",
  "ENDORSEE": "a person to whom a bill is assigned, also INDORSEE [n -S]\n",
  "ENDORSEES": "ENDORSEE, a person to whom a bill is assigned, also INDORSEE [n]\n",
  "ENDORSEMENT": "the act of endorsing [n -S]\n",
  "ENDORSEMENTS": "ENDORSEMENT, the act of endorsing [n]\n",
  "ENDORSER": "one that endorses, also ENDORSOR, INDORSER, INDORSOR [n -S]\n",
  "ENDORSERS": "ENDORSER, one that endorses, also ENDORSOR, INDORSER, INDORSOR [n]\n",
  "ENDORSES": "ENDORSE, to declare one's approval, also INDORSE [v]\n",
  "ENDORSING": "ENDORSE, to declare one's approval, also INDORSE [v]\n",
  "ENDORSIVE": "tending to endorse [adj]\n",
  "ENDORSOR": "one that endorses, also ENDORSER, INDORSER, INDORSOR [n -S]\n",
  "ENDORSORS": "ENDORSOR, one that endorses, also ENDORSER, INDORSER, INDORSOR [n]\n",
  "ENDOSARC": "a portion of a cell [n -S]\n",
  "ENDOSARCS": "ENDOSARC, a portion of a cell [n]\n",
  "ENDOSCOPE": "an instrument for visualizing the interior of a hollow organ [n -S]\n",
  "ENDOSCOPES": "ENDOSCOPE, an instrument for visualizing the interior of a hollow organ [n]\n",
  "ENDOSCOPIC": "relating to an endoscope [adj ENDOSCOPICALLY]\n",
  "ENDOSCOPICALLY": "ENDOSCOPIC, relating to an endoscope [adv]\n",
  "ENDOSCOPIES": "ENDOSCOPY, the art or process of examining by means of the endoscope [n]\n",
  "ENDOSCOPIST": "one who uses an endoscope [n -S]\n",
  "ENDOSCOPISTS": "ENDOSCOPIST, one who uses an endoscope [n]\n",
  "ENDOSCOPY": "the art or process of examining by means of the endoscope [n ENDOSCOPIES]\n",
  "ENDOSKELETAL": "relating to the endoskeleton [adj]\n",
  "ENDOSKELETON": "an internal skeleton or supporting framework in an animal [n -S]\n",
  "ENDOSKELETONS": "ENDOSKELETON, an internal skeleton or supporting framework in an animal [n]\n",
  "ENDOSMOMETER": "an instrument for measuring osmosis into a solution [n -S]\n",
  "ENDOSMOMETERS": "ENDOSMOMETER, an instrument for measuring osmosis into a solution [n]\n",
  "ENDOSMOMETRIC": "relating to an endosmometer, an instrument for measuring osmosis into a solution [adj]\n",
  "ENDOSMOS": "a form of osmosis [n -ES]\n",
  "ENDOSMOSE": "the transmission of a fluid or gas from without inward in the phenomena, or by the process, of osmose, also ENDOSMOSIS [n -S]\n",
  "ENDOSMOSES": "ENDOSMOS, a form of osmosis [n]\n",
  "ENDOSMOSIS": "the transmission of a fluid or gas from without inward in the phenomena, or by the process, of osmose, also ENDOSMOSE [n ENDOSMOSES]\n",
  "ENDOSMOTIC": "pertaining to endosmose [adj ENDOSMOTICALLY]\n",
  "ENDOSMOTICALLY": "ENDOSMOTIC, pertaining to endosmose [adv]\n",
  "ENDOSOME": "a cellular particle [n -S]\n",
  "ENDOSOMES": "ENDOSOME, a cellular particle [n]\n",
  "ENDOSPERM": "in a seed, nutritive tissue formed from the embryo-sac [n -S]\n",
  "ENDOSPERMIC": "relating to the endosperm [adj]\n",
  "ENDOSPERMS": "ENDOSPERM, in a seed, nutritive tissue formed from the embryo-sac [n]\n",
  "ENDOSPORE": "the thin inner coat of certain spores [n -S]\n",
  "ENDOSPORES": "ENDOSPORE, the thin inner coat of certain spores [n]\n",
  "ENDOSPOROUS": "of or like an endospore [adj]\n",
  "ENDOSS": "(obsolete) to endorse, to inscribe [v -ED, -ING, -ES]\n",
  "ENDOSSED": "ENDOSS, (obsolete) to endorse, to inscribe [v]\n",
  "ENDOSSES": "ENDOSS, (obsolete) to endorse, to inscribe [v]\n",
  "ENDOSSING": "ENDOSS, (obsolete) to endorse, to inscribe [v]\n",
  "ENDOSTEA": "ENDOSTEUM, the internal periosteum, a membrane lining the medullary capillary of a bone [n]\n",
  "ENDOSTEAL": "relating to the endosteum, as in endosteal ossification [adj ENDOSTEALLY]\n",
  "ENDOSTEALLY": "ENDOSTEAL, relating to the endosteum, as in endosteal ossification [adv]\n",
  "ENDOSTEUM": "the internal periosteum, a membrane lining the medullary capillary of a bone [n ENDOSTEA]\n",
  "ENDOSTOSES": "ENDOSTOSIS, the conversion of cartilage into bone [n]\n",
  "ENDOSTOSIS": "the conversion of cartilage into bone [n ENDOSTOSES]\n",
  "ENDOSTYLE": "a fold of the endoderm, which projects into the blood cavity of ascidians [n -S]\n",
  "ENDOSTYLES": "ENDOSTYLE, a fold of the endoderm, which projects into the blood cavity of ascidians [n]\n",
  "ENDOSULFAN": "a brownish crystalline insecticide [n -S]\n",
  "ENDOSULFANS": "ENDOSULFAN, a brownish crystalline insecticide [n]\n",
  "ENDOSYMBIONT": "an endosymbiotic organism [n -S]\n",
  "ENDOSYMBIONTS": "ENDOSYMBIONT, an endosymbiotic organism [n]\n",
  "ENDOSYMBIOSES": "ENDOSYMBIOSIS, symbiosis in which one of the symbiotic organisms lives inside the other [n]\n",
  "ENDOSYMBIOSIS": "symbiosis in which one of the symbiotic organisms lives inside the other [n ENDOSYMBIOSES]\n",
  "ENDOSYMBIOTIC": "of or pertaining to endosymbiosis; (of an organism) living in such a relationship [adj]\n",
  "ENDOTHECIA": "ENDOTHECIUM, the inner lining of a mature anther [n]\n",
  "ENDOTHECIAL": "relating to the endothecium [adj]\n",
  "ENDOTHECIUM": "the inner lining of a mature anther [n ENDOTHECIA]\n",
  "ENDOTHELIA": "ENDOTHELIUM, the layer of cell tissue on the internal surfaces of blood vessels, lymphatics, etc. [n]\n",
  "ENDOTHELIAL": "of or like the endothelium, the layer of cell tissue on the internal surfaces of blood vessels, lymphatics, etc., also ENDOTHELIOID [adj]\n",
  "ENDOTHELIOID": "of or like the endothelium, the layer of cell tissue on the internal surfaces of blood vessels, lymphatics, etc., also ENDOTHELIAL [adj]\n",
  "ENDOTHELIOMA": "a tumour of the endothelia [n ENDOTHELIOMAS or ENDOTHELIOMATA]\n",
  "ENDOTHELIOMAS": "ENDOTHELIOMA, a tumour of the endothelia [n]\n",
  "ENDOTHELIOMATA": "ENDOTHELIOMA, a tumour of the endothelia [n]\n",
  "ENDOTHELIUM": "the layer of cell tissue on the internal surfaces of blood vessels, lymphatics, etc. [n ENDOTHELIA]\n",
  "ENDOTHERM": "a warm-blooded animal [n -S]\n",
  "ENDOTHERMAL": "characterized by or formed with absorption of heat, also ENDOTHERMIC [adj]\n",
  "ENDOTHERMIC": "characterized by or formed with absorption of heat, also ENDOTHERMAL [adj ENDOTHERMICALLY]\n",
  "ENDOTHERMICALLY": "ENDOTHERMIC, characterized by or formed with absorption of heat, also ENDOTHERMAL [adv]\n",
  "ENDOTHERMIES": "ENDOTHERMY, surgical introduction of electric needle or knife into tissues [n]\n",
  "ENDOTHERMISM": "the formation of a chemical compound with the absorption of heat [n -S]\n",
  "ENDOTHERMISMS": "ENDOTHERMISM, the formation of a chemical compound with the absorption of heat [n]\n",
  "ENDOTHERMS": "ENDOTHERM, a warm-blooded animal [n]\n",
  "ENDOTHERMY": "surgical introduction of electric needle or knife into tissues [n ENDOTHERMIES]\n",
  "ENDOTOXIC": "of or like an endotoxin, a toxin of internal origin [adj]\n",
  "ENDOTOXIN": "a toxin of internal origin, specifically a poisonous substance present in bacteria [n -S]\n",
  "ENDOTOXINS": "ENDOTOXIN, a toxin of internal origin, specifically a poisonous substance present in bacteria [n]\n",
  "ENDOTRACHEAL": "placed within the trachea [adj]\n",
  "ENDOTROPHIC": "penetrating into the associated root and ramifying between the cells [adj]\n",
  "ENDOW": "to bequeath, also INDOW [v -ED, -ING, -S]\n",
  "ENDOWED": "ENDOW, to bequeath, also INDOW [v]\n",
  "ENDOWER": "one who endows [n -S]\n",
  "ENDOWERS": "ENDOWER, one who endows [n]\n",
  "ENDOWING": "ENDOW, to bequeath, also INDOW [v]\n",
  "ENDOWMENT": "the act of endowing; something that is settled on any person or institution [n -S]\n",
  "ENDOWMENTS": "ENDOWMENT, the act of endowing; something that is settled on any person or institution [n]\n",
  "ENDOWS": "ENDOW, to bequeath, also INDOW [v]\n",
  "ENDOZOA": "ENDOZOON, an internal parasite, also ENTOZOAN, ENTOZOON [n]\n",
  "ENDOZOIC": "having seeds dispersed by animals that swallow them, also ENTOZOAL, ENTOZOIC [adj]\n",
  "ENDOZOON": "an internal parasite, also ENTOZOAN, ENTOZOON [n ENDOZOA]\n",
  "ENDPAPER": "a sheet of paper used in bookbinding [n -S]\n",
  "ENDPAPERS": "ENDPAPER, a sheet of paper used in bookbinding [n]\n",
  "ENDPLATE": "a type of nerve terminal [n -S]\n",
  "ENDPLATES": "ENDPLATE, a type of nerve terminal [n]\n",
  "ENDPLAY": "to force (an opponent in bridge) to lead [v -ED, -ING, -S]\n",
  "ENDPLAYED": "ENDPLAY, to force (an opponent in bridge) to lead [v]\n",
  "ENDPLAYING": "ENDPLAY, to force (an opponent in bridge) to lead [v]\n",
  "ENDPLAYS": "ENDPLAY, to force (an opponent in bridge) to lead [v]\n",
  "ENDPOINT": "either of two points that mark the end of a line segment [n -S]\n",
  "ENDPOINTS": "ENDPOINT, either of two points that mark the end of a line segment [n]\n",
  "ENDRIN": "an insecticide [n -S]\n",
  "ENDRINS": "ENDRIN, an insecticide [n]\n",
  "ENDS": "END, to terminate [v]\n",
  "ENDSHIP": "(obsolete) a village [n -S]\n",
  "ENDSHIPS": "ENDSHIP, (obsolete) a village [n]\n",
  "ENDUE": "to put on, as of clothes; to invest with, also ENDEW, INDEW, INDOW, INDUE [v ENDUED, ENDUING, ENDUES]\n",
  "ENDUED": "ENDUE, to put on, as of clothes; to invest with, also ENDEW, INDEW, INDOW, INDUE [v]\n",
  "ENDUES": "ENDUE, to put on, as of clothes; to invest with, also ENDEW, INDEW, INDOW, INDUE [v]\n",
  "ENDUING": "ENDUE, to put on, as of clothes; to invest with, also ENDEW, INDEW, INDOW, INDUE [v]\n",
  "ENDUNGEON": "to shut up in a dungeon [v -ED, -ING, -S]\n",
  "ENDUNGEONED": "ENDUNGEON, to shut up in a dungeon [v]\n",
  "ENDUNGEONING": "ENDUNGEON, to shut up in a dungeon [v]\n",
  "ENDUNGEONS": "ENDUNGEON, to shut up in a dungeon [v]\n",
  "ENDURABILITIES": "ENDURABILITY, the state of being endurable [n]\n",
  "ENDURABILITY": "the state of being endurable [n ENDURABILITIES]\n",
  "ENDURABLE": "that can be endured [adj ENDURABLY]\n",
  "ENDURABLENESS": "ENDURABLE, that can be endured [n]\n",
  "ENDURABLENESSES": "ENDURABLENESS, ENDURABLE, that can be endured [n]\n",
  "ENDURABLY": "ENDURABLE, that can be endured [adv]\n",
  "ENDURANCE": "the capacity for enduring [n -S]\n",
  "ENDURANCES": "ENDURANCE, the capacity for enduring [n]\n",
  "ENDURE": "to last [v ENDURED, ENDURING, ENDURES]\n",
  "ENDURED": "ENDURE, to last [v]\n",
  "ENDURER": "(obsolete) one who endures [n -S]\n",
  "ENDURERS": "ENDURER, (obsolete) one who endures [n]\n",
  "ENDURES": "ENDURE, to last [v]\n",
  "ENDURING": "ENDURE, to last [v]\n",
  "ENDURINGLY": "ENDURING, ENDURE, to last [adv]\n",
  "ENDURINGNESS": "the state of being enduring [n -ES]\n",
  "ENDURINGNESSES": "ENDURINGNESS, the state of being enduring [n]\n",
  "ENDURO": "a long distance race testing the endurance of motor vehicles rather than their speed [n -S]\n",
  "ENDUROS": "ENDURO, a long distance race testing the endurance of motor vehicles rather than their speed [n]\n",
  "ENDWAYS": "on end, lengthwise, also ENDWISE [adv]\n",
  "ENDWISE": "lengthwise [adj]\n",
  "ENDYSES": "ENDYSIS, the act or process of developing a new coat of hair or a new set of feathers [n]\n",
  "ENDYSIS": "the act or process of developing a new coat of hair or a new set of feathers [n ENDYSES]\n",
  "ENDZONE": "in American football, one of the areas at either end of the field of play into which the offensive team attempts to take the ball [n -S]\n",
  "ENDZONES": "ENDZONE, in American football, one of the areas at either end of the field of play into which the offensive team attempts to take the ball [n]\n",
  "ENE": "a poetic word for evening [n -S]\n",
  "ENEMA": "(Greek) fluid injected into the rectum [n ENEMAS or ENEMATA]\n",
  "ENEMAS": "ENEMA, (Greek) fluid injected into the rectum [n]\n",
  "ENEMATA": "ENEMA, (Greek) fluid injected into the rectum [n]\n",
  "ENEMIES": "ENEMY, one that is antagonistic toward another [n]\n",
  "ENEMY": "one that is antagonistic toward another [n ENEMIES]\n",
  "ENERGETIC": "full of energetic, also ENERGETICAL [adj ENERGETICALLY]\n",
  "ENERGETICAL": "full of energetic, also ENERGETIC [adj ENERGETICALLY]\n",
  "ENERGETICALLY": "ENERGETICAL, full of energetic, also ENERGETIC [adv]\n",
  "ENERGETICS": "that branch of science which treats of the laws governing the physical or mechanical, in distinction from the vital, forces [n]\n",
  "ENERGIC": "showing energy [adj]\n",
  "ENERGID": "the nucleus and active cytoplasm of a cell [n -S]\n",
  "ENERGIDS": "ENERGID, the nucleus and active cytoplasm of a cell [n]\n",
  "ENERGIES": "ENERGY, the power required for doing work [n]\n",
  "ENERGISATION": "the process of energising, also ENERGIZATION [n -S]\n",
  "ENERGISATIONS": "ENERGISATION, the process of energising, also ENERGIZATION [n]\n",
  "ENERGISE": "to give energy to, also ENERGIZE [v ENERGISED, ENERGISING, ENERGISES]\n",
  "ENERGISED": "ENERGISE, to give energy to, also ENERGIZE [v]\n",
  "ENERGISER": "something that energises, also ENERGIZER [n -S]\n",
  "ENERGISERS": "ENERGISER, something that energises, also ENERGIZER [n]\n",
  "ENERGISES": "ENERGISE, to give energy to, also ENERGIZE [v]\n",
  "ENERGISING": "ENERGISE, to give energy to, also ENERGIZE [v]\n",
  "ENERGIZATION": "the process of energizing, also ENERGISATION [n -S]\n",
  "ENERGIZATIONS": "ENERGIZATION, the process of energizing, also ENERGISATION [n]\n",
  "ENERGIZE": "to give energy to, also ENERGISE [v ENERGIZED, ENERGIZING, ENERGIZES]\n",
  "ENERGIZED": "ENERGIZE, to give energy to, also ENERGISE [v]\n",
  "ENERGIZER": "something that energizes, also ENERGISER [n -S]\n",
  "ENERGIZERS": "ENERGIZER, something that energizes, also ENERGISER [n]\n",
  "ENERGIZES": "ENERGIZE, to give energy to, also ENERGISE [v]\n",
  "ENERGIZING": "ENERGIZE, to give energy to, also ENERGISE [v]\n",
  "ENERGUMEN": "(obsolete) a person supposedly possessed by an evil spirit [n -S]\n",
  "ENERGUMENS": "ENERGUMEN, (obsolete) a person supposedly possessed by an evil spirit [n]\n",
  "ENERGY": "the power required for doing work [n ENERGIES]\n",
  "ENERVATE": "to weaken, to debilitate [v ENERVATED, ENERVATING, ENERVATES]\n",
  "ENERVATED": "ENERVATE, to weaken, to debilitate [v]\n",
  "ENERVATES": "ENERVATE, to weaken, to debilitate [v]\n",
  "ENERVATING": "ENERVATE, to weaken, to debilitate [v]\n",
  "ENERVATION": "the act of weakening, or reducing strength [n -S]\n",
  "ENERVATIONS": "ENERVATION, the act of weakening, or reducing strength [n]\n",
  "ENERVATIVE": "having power, or a tendency, to enervate [adj]\n",
  "ENERVATOR": "something that enervates [n -S]\n",
  "ENERVATORS": "ENERVATOR, something that enervates [n]\n",
  "ENERVE": "(obsolete) to weaken, to enervate [v ENERVED, ENERVING, ENERVES]\n",
  "ENERVED": "ENERVE, (obsolete) to weaken, to enervate [v]\n",
  "ENERVES": "ENERVE, (obsolete) to weaken, to enervate [v]\n",
  "ENERVING": "ENERVE, (obsolete) to weaken, to enervate [v]\n",
  "ENES": "ENE, a poetic word for evening [n]\n",
  "ENEW": "in falconry, to plunge the quarry into water [v -ED, -ING, -S]\n",
  "ENEWED": "ENEW, in falconry, to plunge the quarry into water [v]\n",
  "ENEWING": "ENEW, in falconry, to plunge the quarry into water [v]\n",
  "ENEWS": "ENEW, in falconry, to plunge the quarry into water [v]\n",
  "ENFACE": "to stamp or print on the front of [v ENFACED, ENFACING, ENFACES]\n",
  "ENFACED": "ENFACE, to stamp or print on the front of [v]\n",
  "ENFACEMENT": "the act of enfacing, printing on the face of a bill etc. [n -S]\n",
  "ENFACEMENTS": "ENFACEMENT, the act of enfacing, printing on the face of a bill etc. [n]\n",
  "ENFACES": "ENFACE, to stamp or print on the front of [v]\n",
  "ENFACING": "ENFACE, to stamp or print on the front of [v]\n",
  "ENFANT": "(French) a child [n -S]\n",
  "ENFANTS": "ENFANT, (French) a child [n]\n",
  "ENFEEBLE": "to make feeble [v ENFEEBLED, ENFEEBLING, ENFEEBLES]\n",
  "ENFEEBLED": "ENFEEBLE, to make feeble [v]\n",
  "ENFEEBLEMENT": "the act of enfeebling [n -S]\n",
  "ENFEEBLEMENTS": "ENFEEBLEMENT, the act of enfeebling [n]\n",
  "ENFEEBLER": "something that enfeebles [n -S]\n",
  "ENFEEBLERS": "ENFEEBLER, something that enfeebles [n]\n",
  "ENFEEBLES": "ENFEEBLE, to make feeble [v]\n",
  "ENFEEBLING": "ENFEEBLE, to make feeble [v]\n",
  "ENFELON": "(Spenser) to make fierce [v -ED, -ING, -S]\n",
  "ENFELONED": "ENFELON, (Spenser) to make fierce [v]\n",
  "ENFELONING": "ENFELON, (Spenser) to make fierce [v]\n",
  "ENFELONS": "ENFELON, (Spenser) to make fierce [v]\n",
  "ENFEOFF": "to invest with a feudal property, also INFEOFF [v -ED, -ING, -S]\n",
  "ENFEOFFED": "ENFEOFF, to invest with a feudal property, also INFEOFF [v]\n",
  "ENFEOFFING": "ENFEOFF, to invest with a feudal property, also INFEOFF [v]\n",
  "ENFEOFFMENT": "the act of enfeoffing [n -S]\n",
  "ENFEOFFMENTS": "ENFEOFFMENT, the act of enfeoffing [n]\n",
  "ENFEOFFS": "ENFEOFF, to invest with a feudal property, also INFEOFF [v]\n",
  "ENFESTED": "(Spenser) embittered [adj]\n",
  "ENFESTERED": "festered [adj]\n",
  "ENFETTER": "(Shakespeare) to bind with chains or shackles [v -ED, -ING, -S]\n",
  "ENFETTERED": "ENFETTER, (Shakespeare) to bind with chains or shackles [v]\n",
  "ENFETTERING": "ENFETTER, (Shakespeare) to bind with chains or shackles [v]\n",
  "ENFETTERS": "ENFETTER, (Shakespeare) to bind with chains or shackles [v]\n",
  "ENFEVER": "to excite fever in [v -ED, -ING, -S]\n",
  "ENFEVERED": "ENFEVER, to excite fever in [v]\n",
  "ENFEVERING": "ENFEVER, to excite fever in [v]\n",
  "ENFEVERS": "ENFEVER, to excite fever in [v]\n",
  "ENFIERCE": "(Spenser) to make fierce, also EFFIERCE [v ENFIERCED, ENFIERCING, ENFIERCES]\n",
  "ENFIERCED": "ENFIERCE, (Spenser) to make fierce, also EFFIERCE [v]\n",
  "ENFIERCES": "ENFIERCE, (Spenser) to make fierce, also EFFIERCE [v]\n",
  "ENFIERCING": "ENFIERCE, (Spenser) to make fierce, also EFFIERCE [v]\n",
  "ENFILADE": "(French) to direct gunfire along a whole line [v ENFILADED, ENFILADING, ENFILADES]\n",
  "ENFILADED": "ENFILADE, (French) to direct gunfire along a whole line [v]\n",
  "ENFILADES": "ENFILADE, (French) to direct gunfire along a whole line [v]\n",
  "ENFILADING": "ENFILADE, (French) to direct gunfire along a whole line [v]\n",
  "ENFILED": "in heraldry, thrust through like a sword [adj]\n",
  "ENFIRE": "(Spenser) to set on fire [v ENFIRED, ENFIRING, ENFIRES]\n",
  "ENFIRED": "ENFIRE, (Spenser) to set on fire [v]\n",
  "ENFIRES": "ENFIRE, (Spenser) to set on fire [v]\n",
  "ENFIRING": "ENFIRE, (Spenser) to set on fire [v]\n",
  "ENFIX": "(archaic) to fasten or fix by piercing or thrusting in, also INFIX [v ENFIXED, ENFIXING, ENFIXES]\n",
  "ENFIXED": "ENFIX, (archaic) to fasten or fix by piercing or thrusting in, also INFIX [v]\n",
  "ENFIXES": "ENFIX, (archaic) to fasten or fix by piercing or thrusting in, also INFIX [v]\n",
  "ENFIXING": "ENFIX, (archaic) to fasten or fix by piercing or thrusting in, also INFIX [v]\n",
  "ENFLAME": "(obsolete) to inflame, also INFLAME [v ENFLAMED, ENFLAMING, ENFLAMES]\n",
  "ENFLAMED": "ENFLAME, (obsolete) to inflame, also INFLAME [v]\n",
  "ENFLAMES": "ENFLAME, (obsolete) to inflame, also INFLAME [v]\n",
  "ENFLAMING": "ENFLAME, (obsolete) to inflame, also INFLAME [v]\n",
  "ENFLESH": "to turn into flesh [v -ED, -ING, -ES]\n",
  "ENFLESHED": "ENFLESH, to turn into flesh [v]\n",
  "ENFLESHES": "ENFLESH, to turn into flesh [v]\n",
  "ENFLESHING": "ENFLESH, to turn into flesh [v]\n",
  "ENFLEURAGE": "the exposure of oils to scent of fresh flowers in perfume-making [n -S]\n",
  "ENFLEURAGES": "ENFLEURAGE, the exposure of oils to scent of fresh flowers in perfume-making [n]\n",
  "ENFLOWER": "to cover with flowers [v -ED, -ING, -S]\n",
  "ENFLOWERED": "ENFLOWER, to cover with flowers [v]\n",
  "ENFLOWERING": "ENFLOWER, to cover with flowers [v]\n",
  "ENFLOWERS": "ENFLOWER, to cover with flowers [v]\n",
  "ENFOLD": "to envelop [v -ED, -ING, -S]\n",
  "ENFOLDED": "ENFOLD, to envelop [v]\n",
  "ENFOLDER": "one who enfolds [n -S]\n",
  "ENFOLDERS": "ENFOLDER, one who enfolds [n]\n",
  "ENFOLDING": "ENFOLD, to envelop [v]\n",
  "ENFOLDMENT": "the act of enfolding [n -S]\n",
  "ENFOLDMENTS": "ENFOLDMENT, the act of enfolding [n]\n",
  "ENFOLDS": "ENFOLD, to envelop [v]\n",
  "ENFORCE": "to compel, also INFORCE [v ENFORCED, ENFORCING, ENFORCES]\n",
  "ENFORCEABILITY": "the state of being enforceable [n]\n",
  "ENFORCEABLE": "that can be enforced [adj]\n",
  "ENFORCED": "ENFORCE, to compel, also INFORCE [v]\n",
  "ENFORCEDLY": "ENFORCED, ENFORCE, to compel, also INFORCE [adv]\n",
  "ENFORCEMENT": "the act of enforcing [n -S]\n",
  "ENFORCEMENTS": "ENFORCEMENT, the act of enforcing [n]\n",
  "ENFORCER": "one that enforces [n -S]\n",
  "ENFORCERS": "ENFORCER, one that enforces [n]\n",
  "ENFORCES": "ENFORCE, to compel, also INFORCE [v]\n",
  "ENFORCING": "ENFORCE, to compel, also INFORCE [v]\n",
  "ENFOREST": "to turn into forest [v -ED, -ING, -S]\n",
  "ENFORESTED": "ENFOREST, to turn into forest [v]\n",
  "ENFORESTING": "ENFOREST, to turn into forest [v]\n",
  "ENFORESTS": "ENFOREST, to turn into forest [v]\n",
  "ENFORM": "(Spenser) to form; to fashion [v -ED, -ING, -S]\n",
  "ENFORMED": "ENFORM, (Spenser) to form; to fashion [v]\n",
  "ENFORMING": "ENFORM, (Spenser) to form; to fashion [v]\n",
  "ENFORMS": "ENFORM, (Spenser) to form; to fashion [v]\n",
  "ENFOULDERED": "(Spenser) charged with or like lightning [adj]\n",
  "ENFRAME": "to put in a frame [v ENFRAMED, ENFRAMING, ENFRAMES]\n",
  "ENFRAMED": "ENFRAME, to put in a frame [v]\n",
  "ENFRAMEMENT": "the act of enframing [n -S]\n",
  "ENFRAMEMENTS": "ENFRAMEMENT, the act of enframing [n]\n",
  "ENFRAMES": "ENFRAME, to put in a frame [v]\n",
  "ENFRAMING": "ENFRAME, to put in a frame [v]\n",
  "ENFRANCHISE": "to admit to the privileges of a citizen and esp. to the right of suffrage [v ENFRANCHISED, ENFRANCHISING, ENFRANCHISES]\n",
  "ENFRANCHISED": "ENFRANCHISE, to admit to the privileges of a citizen and esp. to the right of suffrage [v]\n",
  "ENFRANCHISEMENT": "the state of being enfranchised [n]\n",
  "ENFRANCHISER": "one who enfranchises [n -S]\n",
  "ENFRANCHISERS": "ENFRANCHISER, one who enfranchises [n]\n",
  "ENFRANCHISES": "ENFRANCHISE, to admit to the privileges of a citizen and esp. to the right of suffrage [v]\n",
  "ENFRANCHISING": "ENFRANCHISE, to admit to the privileges of a citizen and esp. to the right of suffrage [v]\n",
  "ENFREE": "(Shakespeare) to set free [v ENFREED, ENFREEING, ENFREES]\n",
  "ENFREED": "ENFREE, (Shakespeare) to set free [v]\n",
  "ENFREEDOM": "(Shakespeare) to set free, also ENFREE [v -ED, -ING, -S]\n",
  "ENFREEDOMED": "ENFREEDOM, (Shakespeare) to set free, also ENFREE [v]\n",
  "ENFREEDOMING": "ENFREEDOM, (Shakespeare) to set free, also ENFREE [v]\n",
  "ENFREEDOMS": "ENFREEDOM, (Shakespeare) to set free, also ENFREE [v]\n",
  "ENFREEING": "ENFREE, (Shakespeare) to set free [v]\n",
  "ENFREES": "ENFREE, (Shakespeare) to set free [v]\n",
  "ENFREEZE": "to freeze; to congeal [v ENFROZE, ENFROZEN or (Spenser) ENFROSEN, ENFREEZING, ENFREEZES]\n",
  "ENFREEZES": "ENFREEZE, to freeze; to congeal [v]\n",
  "ENFREEZING": "ENFREEZE, to freeze; to congeal [v]\n",
  "ENFROSEN": "ENFREEZE, to freeze; to congeal [v]\n",
  "ENFROZE": "ENFREEZE, to freeze; to congeal [v]\n",
  "ENFROZEN": "ENFREEZE, to freeze; to congeal [v]\n",
  "ENG": "a phonetic symbol representing the sound 'ng', aka agma [n -S]\n",
  "ENGAGE": "to employ [v ENGAGED, ENGAGING, ENGAGES]\n",
  "ENGAGED": "ENGAGE, to employ [v]\n",
  "ENGAGEDLY": "ENGAGED, ENGAGE, to employ [adv]\n",
  "ENGAGEE": "of a female writer or artist, morally or politically committed to an ideology [adj]\n",
  "ENGAGEMENT": "an arrangement to meet or be present at a specified time and place [n -S]\n",
  "ENGAGEMENTS": "ENGAGEMENT, an arrangement to meet or be present at a specified time and place [n]\n",
  "ENGAGER": "one who engages [n -S]\n",
  "ENGAGERS": "ENGAGER, one who engages [n]\n",
  "ENGAGES": "ENGAGE, to employ [v]\n",
  "ENGAGING": "ENGAGE, to employ [v]\n",
  "ENGAGINGLY": "ENGAGING, ENGAGE, to employ [adv]\n",
  "ENGAGINGNESS": "the state of being engaging [n -ES]\n",
  "ENGAGINGNESSES": "ENGAGINGNESS, the state of being engaging [n]\n",
  "ENGAOL": "(Shakespeare) to put in gaol [v -ED, -ING, -S]\n",
  "ENGAOLED": "ENGAOL, (Shakespeare) to put in gaol [v]\n",
  "ENGAOLING": "ENGAOL, (Shakespeare) to put in gaol [v]\n",
  "ENGAOLS": "ENGAOL, (Shakespeare) to put in gaol [v]\n",
  "ENGARLAND": "to encircle with a garland, or with garlands [v -ED, -ING, -S]\n",
  "ENGARLANDED": "ENGARLAND, to encircle with a garland, or with garlands [v]\n",
  "ENGARLANDING": "ENGARLAND, to encircle with a garland, or with garlands [v]\n",
  "ENGARLANDS": "ENGARLAND, to encircle with a garland, or with garlands [v]\n",
  "ENGARRISON": "to garrison; to protect by a garrison [v -ED, -ING, -S]\n",
  "ENGARRISONED": "ENGARRISON, to garrison; to protect by a garrison [v]\n",
  "ENGARRISONING": "ENGARRISON, to garrison; to protect by a garrison [v]\n",
  "ENGARRISONS": "ENGARRISON, to garrison; to protect by a garrison [v]\n",
  "ENGENDER": "to bring into existence [v -ED, -ING, -S]\n",
  "ENGENDERED": "ENGENDER, to bring into existence [v]\n",
  "ENGENDERER": "one who engenders [n -S]\n",
  "ENGENDERERS": "ENGENDERER, one who engenders [n]\n",
  "ENGENDERING": "ENGENDER, to bring into existence [v]\n",
  "ENGENDERMENT": "the act of engendering [n -S]\n",
  "ENGENDERMENTS": "ENGENDERMENT, the act of engendering [n]\n",
  "ENGENDERS": "ENGENDER, to bring into existence [v]\n",
  "ENGENDRURE": "(archaic) the act of engendering, also ENGENDURE [n -S]\n",
  "ENGENDRURES": "ENGENDRURE, (archaic) the act of engendering, also ENGENDURE [n]\n",
  "ENGENDURE": "(archaic) the act of engendering, also ENGENDRURE [n -S]\n",
  "ENGENDURES": "ENGENDURE, (archaic) the act of engendering, also ENGENDRURE [n]\n",
  "ENGILD": "(Shakespeare) to gild [v ENGILDED or ENGILT, ENGILDING, ENGILDS]\n",
  "ENGILDED": "ENGILD, (Shakespeare) to gild [v]\n",
  "ENGILDING": "ENGILD, (Shakespeare) to gild [v]\n",
  "ENGILDS": "ENGILD, (Shakespeare) to gild [v]\n",
  "ENGILT": "ENGILD, (Shakespeare) to gild [v]\n",
  "ENGINE": "to equip with machinery [v ENGINED, ENGINING, ENGINES]\n",
  "ENGINED": "ENGINE, to equip with machinery [v]\n",
  "ENGINEER": "to arrange or contrive [v -ED, -ING, -S]\n",
  "ENGINEERED": "ENGINEER, to arrange or contrive [v]\n",
  "ENGINEERING": "the business of the engineer [n -S]\n",
  "ENGINEERINGS": "ENGINEERING, the business of the engineer [n]\n",
  "ENGINEERS": "ENGINEER, to arrange or contrive [v]\n",
  "ENGINER": "(Shakespeare) an engineer, also INGENER [n -S]\n",
  "ENGINERIES": "ENGINERY, the act or art of managing engines, or artillery [n]\n",
  "ENGINERS": "ENGINER, (Shakespeare) an engineer, also INGENER [n]\n",
  "ENGINERY": "the act or art of managing engines, or artillery [n ENGINERIES]\n",
  "ENGINES": "ENGINE, to equip with machinery [v]\n",
  "ENGINING": "ENGINE, to equip with machinery [v]\n",
  "ENGINOUS": "ingenious [adj]\n",
  "ENGIRD": "to gird; to encompass [v ENGIRDED or ENGIRT, ENGIRDING, ENGIRDS]\n",
  "ENGIRDED": "ENGIRD, to gird; to encompass [v]\n",
  "ENGIRDING": "ENGIRD, to gird; to encompass [v]\n",
  "ENGIRDLE": "to secure with a belt, also ENGIRD [v ENGIRDLED, ENGIRDLING, ENGIRDLES]\n",
  "ENGIRDLED": "ENGIRDLE, to secure with a belt, also ENGIRD [v]\n",
  "ENGIRDLES": "ENGIRDLE, to secure with a belt, also ENGIRD [v]\n",
  "ENGIRDLING": "ENGIRDLE, to secure with a belt, also ENGIRD [v]\n",
  "ENGIRDS": "ENGIRD, to gird; to encompass [v]\n",
  "ENGIRT": "ENGIRD, to gird; to encompass [v]\n",
  "ENGLACIAL": "embedded in, carried in or running through a glacier [adj ENGLACIALLY]\n",
  "ENGLACIALLY": "ENGLACIAL, embedded in, carried in or running through a glacier [adv]\n",
  "ENGLISH": "to cause a billiard ball to spin on its axis [v -ED, -ING, -ES]\n",
  "ENGLISHED": "ENGLISH, to cause a billiard ball to spin on its axis [v]\n",
  "ENGLISHES": "ENGLISH, to cause a billiard ball to spin on its axis [v]\n",
  "ENGLISHING": "ENGLISH, to cause a billiard ball to spin on its axis [v]\n",
  "ENGLOBE": "to form into a globe, also INGLOBE [v ENGLOBED, ENGLOBING, ENGLOBES]\n",
  "ENGLOBED": "ENGLOBE, to form into a globe, also INGLOBE [v]\n",
  "ENGLOBES": "ENGLOBE, to form into a globe, also INGLOBE [v]\n",
  "ENGLOBING": "ENGLOBE, to form into a globe, also INGLOBE [v]\n",
  "ENGLOOM": "to make gloomy [v -ED, -ING, -S]\n",
  "ENGLOOMED": "ENGLOOM, to make gloomy [v]\n",
  "ENGLOOMING": "ENGLOOM, to make gloomy [v]\n",
  "ENGLOOMS": "ENGLOOM, to make gloomy [v]\n",
  "ENGLUT": "to glut, to fill [v ENGLUTTED, ENGLUTTING, ENGLUTS]\n",
  "ENGLUTS": "ENGLUT, to glut, to fill [v]\n",
  "ENGLUTTED": "ENGLUT, to glut, to fill [v]\n",
  "ENGLUTTING": "ENGLUT, to glut, to fill [v]\n",
  "ENGOBE": "(French) a slip applied to ceramics before the glaze, e.g. to mask their natural colours [n -S]\n",
  "ENGOBES": "ENGOBE, (French) a slip applied to ceramics before the glaze, e.g. to mask their natural colours [n]\n",
  "ENGORE": "to gore; to pierce [v ENGORED, ENGORING, ENGORES]\n",
  "ENGORED": "ENGORE, to gore; to pierce [v]\n",
  "ENGORES": "ENGORE, to gore; to pierce [v]\n",
  "ENGORGE": "to fill with blood [v ENGORGED, ENGORGING, ENGORGES]\n",
  "ENGORGED": "ENGORGE, to fill with blood [v]\n",
  "ENGORGEMENT": "the act of engorging [n -S]\n",
  "ENGORGEMENTS": "ENGORGEMENT, the act of engorging [n]\n",
  "ENGORGES": "ENGORGE, to fill with blood [v]\n",
  "ENGORGING": "ENGORGE, to fill with blood [v]\n",
  "ENGORING": "ENGORE, to gore; to pierce [v]\n",
  "ENGOUEMENT": "(French) an excessive fondness, an infatuation, also ENGOUMENT [n -S]\n",
  "ENGOUEMENTS": "ENGOUEMENT, (French) an excessive fondness, an infatuation, also ENGOUMENT [n]\n",
  "ENGOULED": "(of heraldic decoration) entering an animal's mouth [adj]\n",
  "ENGOUMENT": "(French) an excessive fondness, an infatuation, also ENGOUEMENT [n -S]\n",
  "ENGOUMENTS": "ENGOUMENT, (French) an excessive fondness, an infatuation, also ENGOUEMENT [n]\n",
  "ENGRACE": "to introduce into the favour of another [v ENGRACED, ENGRACING, ENGRACES]\n",
  "ENGRACED": "ENGRACE, to introduce into the favour of another [v]\n",
  "ENGRACES": "ENGRACE, to introduce into the favour of another [v]\n",
  "ENGRACING": "ENGRACE, to introduce into the favour of another [v]\n",
  "ENGRAFF": "(obsolete) to graft onto, also ENGRAFT, INGRAFT [v -ED, -ING, -S]\n",
  "ENGRAFFED": "ENGRAFF, (obsolete) to graft onto, also ENGRAFT, INGRAFT [v]\n",
  "ENGRAFFING": "ENGRAFF, (obsolete) to graft onto, also ENGRAFT, INGRAFT [v]\n",
  "ENGRAFFS": "ENGRAFF, (obsolete) to graft onto, also ENGRAFT, INGRAFT [v]\n",
  "ENGRAFT": "to graft onto, also ENGRAFF, INGRAFT [v -ED, -ING, -S]\n",
  "ENGRAFTATION": "the act of engrafting [n -S]\n",
  "ENGRAFTATIONS": "ENGRAFTATION, the act of engrafting [n]\n",
  "ENGRAFTED": "ENGRAFT, to graft onto, also ENGRAFF, INGRAFT [v]\n",
  "ENGRAFTING": "ENGRAFT, to graft onto, also ENGRAFF, INGRAFT [v]\n",
  "ENGRAFTMENT": "the act of engrafting [n -S]\n",
  "ENGRAFTMENTS": "ENGRAFTMENT, the act of engrafting [n]\n",
  "ENGRAFTS": "ENGRAFT, to graft onto, also ENGRAFF, INGRAFT [v]\n",
  "ENGRAIL": "to border with curved indentations [v -ED, -ING, -S]\n",
  "ENGRAILED": "ENGRAIL, to border with curved indentations [v]\n",
  "ENGRAILING": "ENGRAIL, to border with curved indentations [v]\n",
  "ENGRAILMENT": "a ring of dots around edge of a coin [n -S]\n",
  "ENGRAILMENTS": "ENGRAILMENT, a ring of dots around edge of a coin [n]\n",
  "ENGRAILS": "ENGRAIL, to border with curved indentations [v]\n",
  "ENGRAIN": "to fix deeply [v -ED, -ING, -S]\n",
  "ENGRAINED": "ENGRAIN, to fix deeply [v]\n",
  "ENGRAINEDLY": "ENGRAINED, ENGRAIN, to fix deeply [adv]\n",
  "ENGRAINEDNESS": "the state of being engrained [n -ES]\n",
  "ENGRAINEDNESSES": "ENGRAINEDNESS, the state of being engrained [n]\n",
  "ENGRAINER": "one who engrains, dyes in a lasting colour, also INGRAINER [n -S]\n",
  "ENGRAINERS": "ENGRAINER, one who engrains, dyes in a lasting colour, also INGRAINER [n]\n",
  "ENGRAINING": "ENGRAIN, to fix deeply [v]\n",
  "ENGRAINS": "ENGRAIN, to fix deeply [v]\n",
  "ENGRAM": "a deep-seated psychological impression, also ENGRAMMA, ENGRAMME [n -S]\n",
  "ENGRAMMA": "a deep-seated psychological impression, also ENGRAM, ENGRAMME [n -S]\n",
  "ENGRAMMAS": "ENGRAMMA, a deep-seated psychological impression, also ENGRAM, ENGRAMME [n]\n",
  "ENGRAMMATIC": "relating to an engram [adj]\n",
  "ENGRAMME": "a deep-seated psychological impression, also ENGRAM, ENGRAMMA [n -S]\n",
  "ENGRAMMES": "ENGRAMME, a deep-seated psychological impression, also ENGRAM, ENGRAMMA [n]\n",
  "ENGRAMMIC": "related to an engram, a hypothetical change in neural tissue due to memory, also ENGRAMMATIC [adj]\n",
  "ENGRAMS": "ENGRAM, a deep-seated psychological impression, also ENGRAMMA, ENGRAMME [n]\n",
  "ENGRASP": "(Spenser) to grasp [v -ED, -ING, -S]\n",
  "ENGRASPED": "ENGRASP, (Spenser) to grasp [v]\n",
  "ENGRASPING": "ENGRASP, (Spenser) to grasp [v]\n",
  "ENGRASPS": "ENGRASP, (Spenser) to grasp [v]\n",
  "ENGRAVE": "to carve a design upon [v ENGRAVED, ENGRAVEN, ENGRAVING, ENGRAVES]\n",
  "ENGRAVED": "ENGRAVE, to carve a design upon [v]\n",
  "ENGRAVEN": "ENGRAVE, to carve a design upon [v]\n",
  "ENGRAVER": "one who engraves [n -S]\n",
  "ENGRAVERIES": "ENGRAVERY, (obsolete) the trade or work of an engraver [n]\n",
  "ENGRAVERS": "ENGRAVER, one who engraves [n]\n",
  "ENGRAVERY": "(obsolete) the trade or work of an engraver [n ENGRAVERIES]\n",
  "ENGRAVES": "ENGRAVE, to carve a design upon [v]\n",
  "ENGRAVING": "the act or art of cutting or incising designs on metal, wood etc. [n -S]\n",
  "ENGRAVINGS": "ENGRAVING, the act or art of cutting or incising designs on metal, wood etc. [n]\n",
  "ENGRENAGE": "(French) the process of preparing for effective joint action [n -S]\n",
  "ENGRENAGES": "ENGRENAGE, (French) the process of preparing for effective joint action [n]\n",
  "ENGRIEVE": "(Spenser) to grieve [v ENGRIEVED, ENGRIEVING, ENGRIEVES]\n",
  "ENGRIEVED": "ENGRIEVE, (Spenser) to grieve [v]\n",
  "ENGRIEVES": "ENGRIEVE, (Spenser) to grieve [v]\n",
  "ENGRIEVING": "ENGRIEVE, (Spenser) to grieve [v]\n",
  "ENGROOVE": "to fit into a groove, also INGROOVE [v ENGROOVED, ENGROOVING, ENGROOVES]\n",
  "ENGROOVED": "ENGROOVE, to fit into a groove, also INGROOVE [v]\n",
  "ENGROOVES": "ENGROOVE, to fit into a groove, also INGROOVE [v]\n",
  "ENGROOVING": "ENGROOVE, to fit into a groove, also INGROOVE [v]\n",
  "ENGROSS": "to completely absorb one's attention, also INGROSS [v -ED, -ING, -ES]\n",
  "ENGROSSED": "ENGROSS, to completely absorb one's attention, also INGROSS [v]\n",
  "ENGROSSEDLY": "ENGROSSED, ENGROSS, to completely absorb one's attention, also INGROSS [adv]\n",
  "ENGROSSER": "one who copies a writing in large, fair characters [n -S]\n",
  "ENGROSSERS": "ENGROSSER, one who copies a writing in large, fair characters [n]\n",
  "ENGROSSES": "ENGROSS, to completely absorb one's attention, also INGROSS [v]\n",
  "ENGROSSING": "ENGROSS, to completely absorb one's attention, also INGROSS [v]\n",
  "ENGROSSINGLY": "ENGROSSING, ENGROSS, to completely absorb one's attention, also INGROSS [adv]\n",
  "ENGROSSMENT": "immoderate acquisition [n -S]\n",
  "ENGROSSMENTS": "ENGROSSMENT, immoderate acquisition [n]\n",
  "ENGS": "ENG, a phonetic symbol representing the sound 'ng', aka agma [n]\n",
  "ENGUARD": "(Shakespeare) to guard or defend [v -ED, -ING, -S]\n",
  "ENGUARDED": "ENGUARD, (Shakespeare) to guard or defend [v]\n",
  "ENGUARDING": "ENGUARD, (Shakespeare) to guard or defend [v]\n",
  "ENGUARDS": "ENGUARD, (Shakespeare) to guard or defend [v]\n",
  "ENGULF": "to swallow up completely, also ENGULPH, INGULF, INGULPH [v -ED, -ING, -S]\n",
  "ENGULFED": "ENGULF, to swallow up completely, also ENGULPH, INGULF, INGULPH [v]\n",
  "ENGULFING": "ENGULF, to swallow up completely, also ENGULPH, INGULF, INGULPH [v]\n",
  "ENGULFMENT": "a swallowing up as if in a gulf, also INGULFMENT [n -S]\n",
  "ENGULFMENTS": "ENGULFMENT, a swallowing up as if in a gulf, also INGULFMENT [n]\n",
  "ENGULFS": "ENGULF, to swallow up completely, also ENGULPH, INGULF, INGULPH [v]\n",
  "ENGULPH": "to swallow up completely, also ENGULF, INGULF, INGULPH [v -ED, -ING, -S]\n",
  "ENGULPHED": "ENGULPH, to swallow up completely, also ENGULF, INGULF, INGULPH [v]\n",
  "ENGULPHING": "ENGULPH, to swallow up completely, also ENGULF, INGULF, INGULPH [v]\n",
  "ENGULPHS": "ENGULPH, to swallow up completely, also ENGULF, INGULF, INGULPH [v]\n",
  "ENGYSCOPE": "(obsolete) a kind of reflecting microscope [n -S]\n",
  "ENGYSCOPES": "ENGYSCOPE, (obsolete) a kind of reflecting microscope [n]\n",
  "ENHALO": "to surround with a halo [v ENHALOED, ENHALOING, ENHALOES or ENHALOS]\n",
  "ENHALOED": "ENHALO, to surround with a halo [v]\n",
  "ENHALOES": "ENHALO, to surround with a halo [v]\n",
  "ENHALOING": "ENHALO, to surround with a halo [v]\n",
  "ENHALOS": "ENHALO, to surround with a halo [v]\n",
  "ENHANCE": "to raise in value or quality [v ENHANCED, ENHANCING, ENHANCES]\n",
  "ENHANCED": "ENHANCE, to raise in value or quality [v]\n",
  "ENHANCEMENT": "the act of enhancing [n -S]\n",
  "ENHANCEMENTS": "ENHANCEMENT, the act of enhancing [n]\n",
  "ENHANCER": "one who enhances [n -S]\n",
  "ENHANCERS": "ENHANCER, one who enhances [n]\n",
  "ENHANCES": "ENHANCE, to raise in value or quality [v]\n",
  "ENHANCING": "ENHANCE, to raise in value or quality [v]\n",
  "ENHANCIVE": "having the effect of enhancing [adj]\n",
  "ENHARMONIC": "relating to music constructed on a scale containing intervals of less than a semitone, also ENHARMONICAL [adj ENHARMONICALLY]\n",
  "ENHARMONICAL": "relating to music constructed on a scale containing intervals of less than a semitone, also ENHARMONIC [adj ENHARMONICALLY]\n",
  "ENHARMONICALLY": "ENHARMONICAL, relating to music constructed on a scale containing intervals of less than a semitone, also ENHARMONIC [adv]\n",
  "ENHEARSE": "(Shakespeare) to enclose in a hearse, also INHEARSE, INHERCE [v ENHEARSED, ENHEARSING, ENHEARSES]\n",
  "ENHEARSED": "ENHEARSE, (Shakespeare) to enclose in a hearse, also INHEARSE, INHERCE [v]\n",
  "ENHEARSES": "ENHEARSE, (Shakespeare) to enclose in a hearse, also INHEARSE, INHERCE [v]\n",
  "ENHEARSING": "ENHEARSE, (Shakespeare) to enclose in a hearse, also INHEARSE, INHERCE [v]\n",
  "ENHEARTEN": "to encourage, give heart to [v -ED, -ING, -S]\n",
  "ENHEARTENED": "ENHEARTEN, to encourage, give heart to [v]\n",
  "ENHEARTENING": "ENHEARTEN, to encourage, give heart to [v]\n",
  "ENHEARTENS": "ENHEARTEN, to encourage, give heart to [v]\n",
  "ENHUNGER": "to make hungry [v -ED, -ING, -S]\n",
  "ENHUNGERED": "ENHUNGER, to make hungry [v]\n",
  "ENHUNGERING": "ENHUNGER, to make hungry [v]\n",
  "ENHUNGERS": "ENHUNGER, to make hungry [v]\n",
  "ENHYDRITE": "a mineral with fluid inclusions [n -S]\n",
  "ENHYDRITES": "ENHYDRITE, a mineral with fluid inclusions [n]\n",
  "ENHYDRITIC": "of or like enhydrite, a mineral with fluid inclusions [adj]\n",
  "ENHYDROS": "(Greek) a variety of chalcedony containing water [n -ES]\n",
  "ENHYDROSES": "ENHYDROS, (Greek) a variety of chalcedony containing water [n]\n",
  "ENHYDROUS": "of or like an enhydros, containing water [adj]\n",
  "ENHYPOSTASIA": "personality not existing independently but by union with another, as the human nature of Christ was said to be dependent on his divine nature [n -S]\n",
  "ENHYPOSTASIAS": "ENHYPOSTASIA, personality not existing independently but by union with another, as the human nature of Christ was said to be dependent on his divine nature [n]\n",
  "ENHYPOSTATIC": "of or like enhypostasia, substantial or personal existence [adj]\n",
  "ENHYPOSTATISE": "to subject to enhypostasia, also ENHYPOSTATIZE [v ENHYPOSTATISED, ENHYPOSTATISING, ENHYPOSTATISES]\n",
  "ENHYPOSTATISED": "ENHYPOSTATISE, to subject to enhypostasia, also ENHYPOSTATIZE [v]\n",
  "ENHYPOSTATISES": "ENHYPOSTATISE, to subject to enhypostasia, also ENHYPOSTATIZE [v]\n",
  "ENHYPOSTATISING": "ENHYPOSTATISE, to subject to enhypostasia, also ENHYPOSTATIZE [v]\n",
  "ENHYPOSTATIZE": "to subject to enhypostasia, also ENHYPOSTATISE [v ENHYPOSTATIZED, ENHYPOSTATIZING, ENHYPOSTATIZES]\n",
  "ENHYPOSTATIZED": "ENHYPOSTATIZE, to subject to enhypostasia, also ENHYPOSTATISE [v]\n",
  "ENHYPOSTATIZES": "ENHYPOSTATIZE, to subject to enhypostasia, also ENHYPOSTATISE [v]\n",
  "ENHYPOSTATIZING": "ENHYPOSTATIZE, to subject to enhypostasia, also ENHYPOSTATISE [v]\n",
  "ENIAC": "an early computer [n -S]\n",
  "ENIACS": "ENIAC, an early computer [n]\n",
  "ENIGMA": "(Greek) something that is difficult to understand [n ENIGMAS or ENIGMATA]\n",
  "ENIGMAS": "ENIGMA, (Greek) something that is difficult to understand [n]\n",
  "ENIGMATA": "ENIGMA, (Greek) something that is difficult to understand [n]\n",
  "ENIGMATIC": "puzzling, mysterious, also ENIGMATICAL [adj ENIGMATICALLY]\n",
  "ENIGMATICAL": "puzzling, mysterious, also ENIGMATIC [adj ENIGMATICALLY]\n",
  "ENIGMATICALLY": "ENIGMATICAL, puzzling, mysterious, also ENIGMATIC [adv]\n",
  "ENIGMATISE": "to express enigmatically or symbolically, also ENIGMATIZE [v ENIGMATISED, ENIGMATISING, ENIGMATISES]\n",
  "ENIGMATISED": "ENIGMATISE, to express enigmatically or symbolically, also ENIGMATIZE [v]\n",
  "ENIGMATISES": "ENIGMATISE, to express enigmatically or symbolically, also ENIGMATIZE [v]\n",
  "ENIGMATISING": "ENIGMATISE, to express enigmatically or symbolically, also ENIGMATIZE [v]\n",
  "ENIGMATIST": "one who makes, or talks in, enigmas [n -S]\n",
  "ENIGMATISTS": "ENIGMATIST, one who makes, or talks in, enigmas [n]\n",
  "ENIGMATIZE": "to express enigmatically or symbolically, also ENIGMATISE [v ENIGMATIZED, ENIGMATIZING, ENIGMATIZES]\n",
  "ENIGMATIZED": "ENIGMATIZE, to express enigmatically or symbolically, also ENIGMATISE [v]\n",
  "ENIGMATIZES": "ENIGMATIZE, to express enigmatically or symbolically, also ENIGMATISE [v]\n",
  "ENIGMATIZING": "ENIGMATIZE, to express enigmatically or symbolically, also ENIGMATISE [v]\n",
  "ENIGMATOGRAPHY": "the composition of enigmas [n]\n",
  "ENISLE": "to put onto an island, also INISLE [v ENISLED, ENISLING, ENISLES]\n",
  "ENISLED": "ENISLE, to put onto an island, also INISLE [v]\n",
  "ENISLES": "ENISLE, to put onto an island, also INISLE [v]\n",
  "ENISLING": "ENISLE, to put onto an island, also INISLE [v]\n",
  "ENJAMB": "in poetry, to join the sense from one line to the next [v -ED, -ING, -S]\n",
  "ENJAMBED": "ENJAMB, in poetry, to join the sense from one line to the next [v]\n",
  "ENJAMBEMENT": "(French) the continuation of a sentence from one line of a couplet to the next, also ENJAMBMENT [n -S]\n",
  "ENJAMBEMENTS": "ENJAMBEMENT, (French) the continuation of a sentence from one line of a couplet to the next, also ENJAMBMENT [n]\n",
  "ENJAMBING": "ENJAMB, in poetry, to join the sense from one line to the next [v]\n",
  "ENJAMBMENT": "(French) the continuation of a sentence from one line of a couplet to the next, also ENJAMBEMENT [n -S]\n",
  "ENJAMBMENTS": "ENJAMBMENT, (French) the continuation of a sentence from one line of a couplet to the next, also ENJAMBEMENT [n]\n",
  "ENJAMBS": "ENJAMB, in poetry, to join the sense from one line to the next [v]\n",
  "ENJOIN": "to order or direct [v -ED, -ING, -S]\n",
  "ENJOINDER": "an order [n -S]\n",
  "ENJOINDERS": "ENJOINDER, an order [n]\n",
  "ENJOINED": "ENJOIN, to order or direct [v]\n",
  "ENJOINER": "one who enjoins [n -S]\n",
  "ENJOINERS": "ENJOINER, one who enjoins [n]\n",
  "ENJOINING": "ENJOIN, to order or direct [v]\n",
  "ENJOINMENT": "direction; command; authoritative admonition [n -S]\n",
  "ENJOINMENTS": "ENJOINMENT, direction; command; authoritative admonition [n]\n",
  "ENJOINS": "ENJOIN, to order or direct [v]\n",
  "ENJOY": "to take pleasure in [v -ED, -ING, -S]\n",
  "ENJOYABLE": "that can be enjoyed [adj ENJOYABLY]\n",
  "ENJOYABLENESS": "ENJOYABLE, that can be enjoyed [n]\n",
  "ENJOYABLENESSES": "ENJOYABLENESS, ENJOYABLE, that can be enjoyed [n]\n",
  "ENJOYABLY": "ENJOYABLE, that can be enjoyed [adv]\n",
  "ENJOYED": "ENJOY, to take pleasure in [v]\n",
  "ENJOYER": "one who enjoys [n -S]\n",
  "ENJOYERS": "ENJOYER, one who enjoys [n]\n",
  "ENJOYING": "ENJOY, to take pleasure in [v]\n",
  "ENJOYMENT": "the act of enjoying [n -S]\n",
  "ENJOYMENTS": "ENJOYMENT, the act of enjoying [n]\n",
  "ENJOYS": "ENJOY, to take pleasure in [v]\n",
  "ENKEPHALIN": "a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALIN, ENCEPHALINE, ENKEPHALINE [n -S]\n",
  "ENKEPHALINE": "a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALIN, ENCEPHALINE, ENKEPHALIN [n -S]\n",
  "ENKEPHALINES": "ENKEPHALINE, a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALIN, ENCEPHALINE, ENKEPHALIN [n]\n",
  "ENKEPHALINS": "ENKEPHALIN, a chemical found in small quantities in the brain, which relieves pain, also ENCEPHALIN, ENCEPHALINE, ENKEPHALINE [n]\n",
  "ENKERNEL": "to enclose in a kernel [v ENKERNELLED, ENKERNELLING, ENKERNELS]\n",
  "ENKERNELLED": "ENKERNEL, to enclose in a kernel [v]\n",
  "ENKERNELLING": "ENKERNEL, to enclose in a kernel [v]\n",
  "ENKERNELS": "ENKERNEL, to enclose in a kernel [v]\n",
  "ENKINDLE": "to set on fire [v ENKINDLED, ENKINDLING, ENKINDLES]\n",
  "ENKINDLED": "ENKINDLE, to set on fire [v]\n",
  "ENKINDLER": "one who enkindles [n -S]\n",
  "ENKINDLERS": "ENKINDLER, one who enkindles [n]\n",
  "ENKINDLES": "ENKINDLE, to set on fire [v]\n",
  "ENKINDLING": "ENKINDLE, to set on fire [v]\n",
  "ENLACE": "to entwine or entangle, also INLACE [v ENLACED, ENLACING, ENLACES]\n",
  "ENLACED": "ENLACE, to entwine or entangle, also INLACE [v]\n",
  "ENLACEMENT": "the act of enlacing, or state of being enlaced [n -S]\n",
  "ENLACEMENTS": "ENLACEMENT, the act of enlacing, or state of being enlaced [n]\n",
  "ENLACES": "ENLACE, to entwine or entangle, also INLACE [v]\n",
  "ENLACING": "ENLACE, to entwine or entangle, also INLACE [v]\n",
  "ENLARD": "(Shakespeare) to grease, lard [v -ED, -ING, -S]\n",
  "ENLARDED": "ENLARD, (Shakespeare) to grease, lard [v]\n",
  "ENLARDING": "ENLARD, (Shakespeare) to grease, lard [v]\n",
  "ENLARDS": "ENLARD, (Shakespeare) to grease, lard [v]\n",
  "ENLARGE": "to make larger, also ENLARGEN [v ENLARGED, ENLARGING, ENLARGES]\n",
  "ENLARGEABLE": "that can be enlarged [adj]\n",
  "ENLARGED": "ENLARGE, to make larger, also ENLARGEN [v]\n",
  "ENLARGEDLY": "ENLARGED, ENLARGE, to make larger, also ENLARGEN [adv]\n",
  "ENLARGEDNESS": "the state of being enlarged [n -ES]\n",
  "ENLARGEDNESSES": "ENLARGEDNESS, the state of being enlarged [n]\n",
  "ENLARGEMENT": "an act or instance of enlarging [n -S]\n",
  "ENLARGEMENTS": "ENLARGEMENT, an act or instance of enlarging [n]\n",
  "ENLARGEN": "(Spenser) to make larger, also ENLARGE [v -ED, -ING, -S]\n",
  "ENLARGENED": "ENLARGEN, (Spenser) to make larger, also ENLARGE [v]\n",
  "ENLARGENING": "ENLARGEN, (Spenser) to make larger, also ENLARGE [v]\n",
  "ENLARGENS": "ENLARGEN, (Spenser) to make larger, also ENLARGE [v]\n",
  "ENLARGER": "a device which enlarges photographs [n -S]\n",
  "ENLARGERS": "ENLARGER, a device which enlarges photographs [n]\n",
  "ENLARGES": "ENLARGE, to make larger, also ENLARGEN [v]\n",
  "ENLARGING": "ENLARGE, to make larger, also ENLARGEN [v]\n",
  "ENLEVE": "(French) carried away, kidnapped [adj]\n",
  "ENLEVEMENT": "(obsolete) in Scots law, the abduction of a woman or child [n -S]\n",
  "ENLEVEMENTS": "ENLEVEMENT, (obsolete) in Scots law, the abduction of a woman or child [n]\n",
  "ENLIGHT": "to shed light on [v ENLIGHTED, ENLIT, ENLIGHTING, ENLIGHTS]\n",
  "ENLIGHTED": "ENLIGHT, to shed light on [v]\n",
  "ENLIGHTEN": "to impart knowledge or information to [v -ED, -ING, -S]\n",
  "ENLIGHTENED": "ENLIGHTEN, to impart knowledge or information to [v]\n",
  "ENLIGHTENER": "one who enlightens [n -S]\n",
  "ENLIGHTENERS": "ENLIGHTENER, one who enlightens [n]\n",
  "ENLIGHTENING": "ENLIGHTEN, to impart knowledge or information to [v]\n",
  "ENLIGHTENMENT": "the act or means of enlightening [n -S]\n",
  "ENLIGHTENMENTS": "ENLIGHTENMENT, the act or means of enlightening [n]\n",
  "ENLIGHTENS": "ENLIGHTEN, to impart knowledge or information to [v]\n",
  "ENLIGHTING": "ENLIGHT, to shed light on [v]\n",
  "ENLIGHTS": "ENLIGHT, to shed light on [v]\n",
  "ENLINK": "to connect closely [v -ED, -ING, -S]\n",
  "ENLINKED": "ENLINK, to connect closely [v]\n",
  "ENLINKING": "ENLINK, to connect closely [v]\n",
  "ENLINKS": "ENLINK, to connect closely [v]\n",
  "ENLIST": "to engage for military service [v -ED, -ING, -S]\n",
  "ENLISTED": "ENLIST, to engage for military service [v]\n",
  "ENLISTEE": "one who is enlisted [n -S]\n",
  "ENLISTEES": "ENLISTEE, one who is enlisted [n]\n",
  "ENLISTER": "one who enlists [n -S]\n",
  "ENLISTERS": "ENLISTER, one who enlists [n]\n",
  "ENLISTING": "ENLIST, to engage for military service [v]\n",
  "ENLISTMENT": "the act or enlisting, or the state of being enlisted [n -S]\n",
  "ENLISTMENTS": "ENLISTMENT, the act or enlisting, or the state of being enlisted [n]\n",
  "ENLISTS": "ENLIST, to engage for military service [v]\n",
  "ENLIT": "ENLIGHT, to shed light on [v]\n",
  "ENLIVEN": "to make lively [v -ED, -ING, -S]\n",
  "ENLIVENED": "ENLIVEN, to make lively [v]\n",
  "ENLIVENER": "something that enlivens [n -S]\n",
  "ENLIVENERS": "ENLIVENER, something that enlivens [n]\n",
  "ENLIVENING": "ENLIVEN, to make lively [v]\n",
  "ENLIVENMENT": "the act of enlivening [n -S]\n",
  "ENLIVENMENTS": "ENLIVENMENT, the act of enlivening [n]\n",
  "ENLIVENS": "ENLIVEN, to make lively [v]\n",
  "ENLOCK": "to lock up, also INLOCK [v -ED, -ING, -S]\n",
  "ENLOCKED": "ENLOCK, to lock up, also INLOCK [v]\n",
  "ENLOCKING": "ENLOCK, to lock up, also INLOCK [v]\n",
  "ENLOCKS": "ENLOCK, to lock up, also INLOCK [v]\n",
  "ENLUMINE": "(Spenser) to throw light upon, also ILLUMINE [v ENLUMINED, ENLUMINING, ENLUMINES]\n",
  "ENLUMINED": "ENLUMINE, (Spenser) to throw light upon, also ILLUMINE [v]\n",
  "ENLUMINES": "ENLUMINE, (Spenser) to throw light upon, also ILLUMINE [v]\n",
  "ENLUMINING": "ENLUMINE, (Spenser) to throw light upon, also ILLUMINE [v]\n",
  "ENMESH": "to entangle, also EMMESH, IMMESH, INMESH [v -ED, -ING, -ES]\n",
  "ENMESHED": "ENMESH, to entangle, also EMMESH, IMMESH, INMESH [v]\n",
  "ENMESHES": "ENMESH, to entangle, also EMMESH, IMMESH, INMESH [v]\n",
  "ENMESHING": "ENMESH, to entangle, also EMMESH, IMMESH, INMESH [v]\n",
  "ENMESHMENT": "the state of being enmeshed [n -S]\n",
  "ENMESHMENTS": "ENMESHMENT, the state of being enmeshed [n]\n",
  "ENMEW": "to confine, also EMMEW, IMMEW [v -ED, -ING, -S]\n",
  "ENMEWED": "ENMEW, to confine, also EMMEW, IMMEW [v]\n",
  "ENMEWING": "ENMEW, to confine, also EMMEW, IMMEW [v]\n",
  "ENMEWS": "ENMEW, to confine, also EMMEW, IMMEW [v]\n",
  "ENMITIES": "ENMITY, hostility [n]\n",
  "ENMITY": "hostility [n ENMITIES]\n",
  "ENMOSSED": "covered with moss [adj]\n",
  "ENMOVE": "(Spenser) to affect emotionally, also EMOVE, EMMOVE [v ENMOVED, ENMOVING, ENMOVES]\n",
  "ENMOVED": "ENMOVE, (Spenser) to affect emotionally, also EMOVE, EMMOVE [v]\n",
  "ENMOVES": "ENMOVE, (Spenser) to affect emotionally, also EMOVE, EMMOVE [v]\n",
  "ENMOVING": "ENMOVE, (Spenser) to affect emotionally, also EMOVE, EMMOVE [v]\n",
  "ENNAGE": "a measurement of printing type in ens [n -S]\n",
  "ENNAGES": "ENNAGE, a measurement of printing type in ens [n]\n",
  "ENNEAD": "(Greek) a group of nine [n -S]\n",
  "ENNEADIC": "relating to an ennead, a set of nine [adj]\n",
  "ENNEADS": "ENNEAD, (Greek) a group of nine [n]\n",
  "ENNEAGON": "a polygon with nine angles [n -S]\n",
  "ENNEAGONAL": "belonging to an enneagon; having nine angles [adj]\n",
  "ENNEAGONS": "ENNEAGON, a polygon with nine angles [n]\n",
  "ENNEAGRAM": "a personality system involving nine distinct personality types [n -S]\n",
  "ENNEAGRAMS": "ENNEAGRAM, a personality system involving nine distinct personality types [n]\n",
  "ENNEAHEDRA": "ENNEAHEDRON, a nine-sided solid figure [n]\n",
  "ENNEAHEDRAL": "of or like an enneahedron, a nine-sided solid figure [adj]\n",
  "ENNEAHEDRON": "a nine-sided solid figure [n ENNEAHEDRA or ENNEAHEDRONS]\n",
  "ENNEAHEDRONS": "ENNEAHEDRON, a nine-sided solid figure [n]\n",
  "ENNEANDRIAN": "of the class Enneandria, having nine stamens, also ENNEANDROUS [adj]\n",
  "ENNEANDROUS": "of the class Enneandria, having nine stamens, also ENNEANDRIAN [adj]\n",
  "ENNEASTYLE": "having nine columns [adj]\n",
  "ENNEATHLON": "an athletic contest in which each athlete competes in nine events [n -S]\n",
  "ENNEATHLONS": "ENNEATHLON, an athletic contest in which each athlete competes in nine events [n]\n",
  "ENNOBLE": "to make noble [v ENNOBLED, ENNOBLING, ENNOBLES]\n",
  "ENNOBLED": "ENNOBLE, to make noble [v]\n",
  "ENNOBLEMENT": "the act of ennobling, esp. as involving the granting of a coat-of-arms [n -S]\n",
  "ENNOBLEMENTS": "ENNOBLEMENT, the act of ennobling, esp. as involving the granting of a coat-of-arms [n]\n",
  "ENNOBLER": "one who ennobles [n -S]\n",
  "ENNOBLERS": "ENNOBLER, one who ennobles [n]\n",
  "ENNOBLES": "ENNOBLE, to make noble [v]\n",
  "ENNOBLING": "ENNOBLE, to make noble [v]\n",
  "ENNOG": "(dialect) a back alley [n -S]\n",
  "ENNOGS": "ENNOG, (dialect) a back alley [n]\n",
  "ENNUI": "(French) to bore, annoy [v ENNUIED or ENNUYED, ENNUYING, ENNUIS]\n",
  "ENNUIED": "ENNUI, (French) to bore, annoy [v]\n",
  "ENNUIS": "ENNUI, (French) to bore, annoy [v]\n",
  "ENNUYE": "(French) affected with ennui (of a man) [adj]\n",
  "ENNUYED": "ENNUI, (French) to bore, annoy [v]\n",
  "ENNUYEE": "(French) affected with ennui (of a woman) [adj]\n",
  "ENNUYING": "boring, uninteresting [adj]\n",
  "ENODAL": "without nodes [adj]\n",
  "ENOKI": "(Japanese) a thin white edible mushroom native to Japan [n -S]\n",
  "ENOKIDAKE": "(Japanese) chinese hackberry, also ENOKITAKE [n -S]\n",
  "ENOKIDAKES": "ENOKIDAKE, (Japanese) chinese hackberry, also ENOKITAKE [n]\n",
  "ENOKIS": "ENOKI, (Japanese) a thin white edible mushroom native to Japan [n]\n",
  "ENOKITAKE": "(Japanese) a type of mushroom, also ENOKIDAKE [n -S]\n",
  "ENOKITAKES": "ENOKITAKE, (Japanese) a type of mushroom, also ENOKIDAKE [n]\n",
  "ENOL": "a type of organic chemical compound [n -S]\n",
  "ENOLASE": "a muscle enzyme [n -S]\n",
  "ENOLASES": "ENOLASE, a muscle enzyme [n]\n",
  "ENOLIC": "relating to enol, a chemical compound [adj]\n",
  "ENOLOGICAL": "relating to enology, the science of wine, also OENOLOGICAL [adj]\n",
  "ENOLOGIES": "ENOLOGY, the study of wines, also OENOLOGY, OINOLOGY [n]\n",
  "ENOLOGIST": "one who studies enology, the science of winemaking [n -S]\n",
  "ENOLOGISTS": "ENOLOGIST, one who studies enology, the science of winemaking [n]\n",
  "ENOLOGY": "the study of wines, also OENOLOGY, OINOLOGY [n ENOLOGIES]\n",
  "ENOLS": "ENOL, a type of organic chemical compound [n]\n",
  "ENOMOTIES": "ENOMOTY, (Greek) a band of sworn soldiers in the Spartan army [n]\n",
  "ENOMOTY": "(Greek) a band of sworn soldiers in the Spartan army [n ENOMOTIES]\n",
  "ENOPHILE": "a wine connoisseur, also OENOPHILE, OENOPHIL [n -S]\n",
  "ENOPHILES": "ENOPHILE, a wine connoisseur, also OENOPHILE, OENOPHIL [n]\n",
  "ENORM": "huge, also ENORMOUS [adj]\n",
  "ENORMITIES": "ENORMITY, a great crime [n]\n",
  "ENORMITY": "a great crime [n ENORMITIES]\n",
  "ENORMOUS": "huge, also ENORM [adj ENORMOUSLY]\n",
  "ENORMOUSLY": "ENORMOUS, huge, also ENORM [adv]\n",
  "ENORMOUSNESS": "the state of being enormous [n -ES]\n",
  "ENORMOUSNESSES": "ENORMOUSNESS, the state of being enormous [n]\n",
  "ENOSES": "ENOSIS, (Modern Greek) political union [n]\n",
  "ENOSIS": "(Modern Greek) political union [n ENOSISES or ENOSES]\n",
  "ENOSISES": "ENOSIS, (Modern Greek) political union [n]\n",
  "ENOUGH": "sufficient [n -S]\n",
  "ENOUGHS": "ENOUGH, sufficient [n]\n",
  "ENOUNCE": "to enunciate; to proclaim [v ENOUNCED, ENOUNCING, ENOUNCES]\n",
  "ENOUNCED": "ENOUNCE, to enunciate; to proclaim [v]\n",
  "ENOUNCEMENT": "the act of enouncing [n -S]\n",
  "ENOUNCEMENTS": "ENOUNCEMENT, the act of enouncing [n]\n",
  "ENOUNCES": "ENOUNCE, to enunciate; to proclaim [v]\n",
  "ENOUNCING": "ENOUNCE, to enunciate; to proclaim [v]\n",
  "ENOW": "(archaic) enough, also ANOW, ENOUGH, ENUF [n -S]\n",
  "ENOWS": "ENOW, (archaic) enough, also ANOW, ENOUGH, ENUF [n]\n",
  "ENPHYTOTIC": "of plant diseases, causing a constant amount of damage each year [adj]\n",
  "ENPLANE": "to put on an aeroplane, also EMPLANE [v ENPLANED, ENPLANING, ENPLANES]\n",
  "ENPLANED": "ENPLANE, to put on an aeroplane, also EMPLANE [v]\n",
  "ENPLANES": "ENPLANE, to put on an aeroplane, also EMPLANE [v]\n",
  "ENPLANING": "ENPLANE, to put on an aeroplane, also EMPLANE [v]\n",
  "ENPRINT": "a size of photographic print [n -S]\n",
  "ENPRINTS": "ENPRINT, a size of photographic print [n]\n",
  "ENQUEUE": "to add (a data-processing task) to a list of tasks awaiting processing in a buffer [v ENQUEUED, ENQUEUING or ENQUEUEING, ENQUEUES]\n",
  "ENQUEUED": "ENQUEUE, to add (a data-processing task) to a list of tasks awaiting processing in a buffer [v]\n",
  "ENQUEUEING": "ENQUEUE, to add (a data-processing task) to a list of tasks awaiting processing in a buffer [v]\n",
  "ENQUEUES": "ENQUEUE, to add (a data-processing task) to a list of tasks awaiting processing in a buffer [v]\n",
  "ENQUEUING": "ENQUEUE, to add (a data-processing task) to a list of tasks awaiting processing in a buffer [v]\n",
  "ENQUIRATION": "(dialect) inquiry, also INQUIRATION [n -S]\n",
  "ENQUIRATIONS": "ENQUIRATION, (dialect) inquiry, also INQUIRATION [n]\n",
  "ENQUIRE": "to ask, also INQUERE, INQUIRE [v ENQUIRED, ENQUIRING, ENQUIRES]\n",
  "ENQUIRED": "ENQUIRE, to ask, also INQUERE, INQUIRE [v]\n",
  "ENQUIRER": "one who enquires, also INQUIRER [n -S]\n",
  "ENQUIRERS": "ENQUIRER, one who enquires, also INQUIRER [n]\n",
  "ENQUIRES": "ENQUIRE, to ask, also INQUERE, INQUIRE [v]\n",
  "ENQUIRIES": "ENQUIRY, a question, also INQUIRY [n]\n",
  "ENQUIRING": "ENQUIRE, to ask, also INQUERE, INQUIRE [v]\n",
  "ENQUIRY": "a question, also INQUIRY [n ENQUIRIES]\n",
  "ENRACE": "(Spenser) to implant [v ENRACED, ENRACING, ENRACES]\n",
  "ENRACED": "ENRACE, (Spenser) to implant [v]\n",
  "ENRACES": "ENRACE, (Spenser) to implant [v]\n",
  "ENRACING": "ENRACE, (Spenser) to implant [v]\n",
  "ENRAGE": "to make very angry [v ENRAGED, ENRAGING, ENRAGES]\n",
  "ENRAGED": "ENRAGE, to make very angry [v]\n",
  "ENRAGEDLY": "ENRAGED, ENRAGE, to make very angry [adv]\n",
  "ENRAGEMENT": "the act of enraging or state of being enraged [n -S]\n",
  "ENRAGEMENTS": "ENRAGEMENT, the act of enraging or state of being enraged [n]\n",
  "ENRAGES": "ENRAGE, to make very angry [v]\n",
  "ENRAGING": "ENRAGE, to make very angry [v]\n",
  "ENRANCKLE": "(Spenser) to enrage [v ENRANCKLED, ENRANCKLING, ENRANCKLES]\n",
  "ENRANCKLED": "ENRANCKLE, (Spenser) to enrage [v]\n",
  "ENRANCKLES": "ENRANCKLE, (Spenser) to enrage [v]\n",
  "ENRANCKLING": "ENRANCKLE, (Spenser) to enrage [v]\n",
  "ENRANGE": "to arrange, also ENRAUNGE [v ENRANGED, ENRANGING, ENRANGES]\n",
  "ENRANGED": "ENRANGE, to arrange, also ENRAUNGE [v]\n",
  "ENRANGES": "ENRANGE, to arrange, also ENRAUNGE [v]\n",
  "ENRANGING": "ENRANGE, to arrange, also ENRAUNGE [v]\n",
  "ENRANK": "(Shakespeare) to place in order [v -ED, -ING, -S]\n",
  "ENRANKED": "ENRANK, (Shakespeare) to place in order [v]\n",
  "ENRANKING": "ENRANK, (Shakespeare) to place in order [v]\n",
  "ENRANKS": "ENRANK, (Shakespeare) to place in order [v]\n",
  "ENRAPT": "in ecstasy [adj]\n",
  "ENRAPTURE": "to delight [v ENRAPTURED, ENRAPTURING, ENRAPTURES]\n",
  "ENRAPTURED": "ENRAPTURE, to delight [v]\n",
  "ENRAPTURES": "ENRAPTURE, to delight [v]\n",
  "ENRAPTURING": "ENRAPTURE, to delight [v]\n",
  "ENRAUNGE": "(Spenser) to arrange; to rove over, also ENRANGE [v ENRAUNGED, ENRAUNGING, ENRAUNGES]\n",
  "ENRAUNGED": "ENRAUNGE, (Spenser) to arrange; to rove over, also ENRANGE [v]\n",
  "ENRAUNGES": "ENRAUNGE, (Spenser) to arrange; to rove over, also ENRANGE [v]\n",
  "ENRAUNGING": "ENRAUNGE, (Spenser) to arrange; to rove over, also ENRANGE [v]\n",
  "ENRAVISH": "to enrapture [v -ED, -ING, -ES]\n",
  "ENRAVISHED": "ENRAVISH, to enrapture [v]\n",
  "ENRAVISHES": "ENRAVISH, to enrapture [v]\n",
  "ENRAVISHING": "ENRAVISH, to enrapture [v]\n",
  "ENREGIMENT": "to form into a regiment [v -ED, -ING, -S]\n",
  "ENREGIMENTED": "ENREGIMENT, to form into a regiment [v]\n",
  "ENREGIMENTING": "ENREGIMENT, to form into a regiment [v]\n",
  "ENREGIMENTS": "ENREGIMENT, to form into a regiment [v]\n",
  "ENREGISTER": "to register; to enroll or record [v -ED, -ING, -S]\n",
  "ENREGISTERED": "ENREGISTER, to register; to enroll or record [v]\n",
  "ENREGISTERING": "ENREGISTER, to register; to enroll or record [v]\n",
  "ENREGISTERS": "ENREGISTER, to register; to enroll or record [v]\n",
  "ENRHEUM": "(obsolete) to contract a rheum, a cold [v -ED, -ING, -S]\n",
  "ENRHEUMED": "ENRHEUM, (obsolete) to contract a rheum, a cold [v]\n",
  "ENRHEUMING": "ENRHEUM, (obsolete) to contract a rheum, a cold [v]\n",
  "ENRHEUMS": "ENRHEUM, (obsolete) to contract a rheum, a cold [v]\n",
  "ENRICH": "to add desirable elements to, also RICHEN [v -ED, -ING, -ES]\n",
  "ENRICHED": "ENRICH, to add desirable elements to, also RICHEN [v]\n",
  "ENRICHER": "one who enriches [n -S]\n",
  "ENRICHERS": "ENRICHER, one who enriches [n]\n",
  "ENRICHES": "ENRICH, to add desirable elements to, also RICHEN [v]\n",
  "ENRICHING": "ENRICH, to add desirable elements to, also RICHEN [v]\n",
  "ENRICHMENT": "the act of making rich [n -S]\n",
  "ENRICHMENTS": "ENRICHMENT, the act of making rich [n]\n",
  "ENRIDGED": "(Shakespeare) formed into ridges [adj]\n",
  "ENRING": "to encircle [v -ED, -ING, -S]\n",
  "ENRINGED": "ENRING, to encircle [v]\n",
  "ENRINGING": "ENRING, to encircle [v]\n",
  "ENRINGS": "ENRING, to encircle [v]\n",
  "ENRIVEN": "(Spenser) torn [adj]\n",
  "ENROBE": "to put on a robe [v ENROBED, ENROBING, ENROBES]\n",
  "ENROBED": "ENROBE, to put on a robe [v]\n",
  "ENROBER": "one who enrobes [n -S]\n",
  "ENROBERS": "ENROBER, one who enrobes [n]\n",
  "ENROBES": "ENROBE, to put on a robe [v]\n",
  "ENROBING": "ENROBE, to put on a robe [v]\n",
  "ENROL": "to insert on a register, also ENROLL [v ENROLLED, ENROLLING, ENROLS]\n",
  "ENROLL": "to insert on a register, also ENROL [v ENROLLED, ENROLLING, ENROLLS]\n",
  "ENROLLED": "ENROL, to insert on a register, also ENROLL [v]\n",
  "ENROLLEE": "one who is enrolled [n -S]\n",
  "ENROLLEES": "ENROLLEE, one who is enrolled [n]\n",
  "ENROLLER": "one who enrols [n -S]\n",
  "ENROLLERS": "ENROLLER, one who enrols [n]\n",
  "ENROLLING": "ENROL, to insert on a register, also ENROLL [v]\n",
  "ENROLLMENT": "the act of enrolling [n -S]\n",
  "ENROLLMENTS": "ENROLLMENT, the act of enrolling [n]\n",
  "ENROLLS": "ENROLL, to insert on a register, also ENROL [v]\n",
  "ENROLMENT": "the act of enrolling, also ENROLLMENT [n -S]\n",
  "ENROLMENTS": "ENROLMENT, the act of enrolling, also ENROLLMENT [n]\n",
  "ENROLS": "ENROL, to insert on a register, also ENROLL [v]\n",
  "ENROOT": "to implant firmly [v -ED, -ING, -S]\n",
  "ENROOTED": "ENROOT, to implant firmly [v]\n",
  "ENROOTING": "ENROOT, to implant firmly [v]\n",
  "ENROOTS": "ENROOT, to implant firmly [v]\n",
  "ENROUGH": "(archaic) to make rough [v -ED, -ING, -S]\n",
  "ENROUGHED": "ENROUGH, (archaic) to make rough [v]\n",
  "ENROUGHING": "ENROUGH, (archaic) to make rough [v]\n",
  "ENROUGHS": "ENROUGH, (archaic) to make rough [v]\n",
  "ENROUND": "(Shakespeare) to make round, surround [v -ED, -ING, -S]\n",
  "ENROUNDED": "ENROUND, (Shakespeare) to make round, surround [v]\n",
  "ENROUNDING": "ENROUND, (Shakespeare) to make round, surround [v]\n",
  "ENROUNDS": "ENROUND, (Shakespeare) to make round, surround [v]\n",
  "ENS": "being, existence; an entity [n ENTIA]\n",
  "ENSAMPLE": "to give an example of [v ENSAMPLED, ENSAMPLING, ENSAMPLES]\n",
  "ENSAMPLED": "ENSAMPLE, to give an example of [v]\n",
  "ENSAMPLES": "ENSAMPLE, to give an example of [v]\n",
  "ENSAMPLING": "ENSAMPLE, to give an example of [v]\n",
  "ENSANGUINATED": "bloody [adj]\n",
  "ENSANGUINE": "to cover with blood [v ENSANGUINED, ENSANGUINING, ENSANGUINES]\n",
  "ENSANGUINED": "ENSANGUINE, to cover with blood [v]\n",
  "ENSANGUINES": "ENSANGUINE, to cover with blood [v]\n",
  "ENSANGUINING": "ENSANGUINE, to cover with blood [v]\n",
  "ENSATE": "sword-shaped, also ENSIFORM [adj]\n",
  "ENSCHEDULE": "(Shakespeare) to insert into a schedule [v ENSCHEDULED, ENSCHEDULING, ENSCHEDULES]\n",
  "ENSCHEDULED": "ENSCHEDULE, (Shakespeare) to insert into a schedule [v]\n",
  "ENSCHEDULES": "ENSCHEDULE, (Shakespeare) to insert into a schedule [v]\n",
  "ENSCHEDULING": "ENSCHEDULE, (Shakespeare) to insert into a schedule [v]\n",
  "ENSCONCE": "to settle comfortably, also INSCONCE [v ENSCONCED, ENSCONCING, ENSCONCES]\n",
  "ENSCONCED": "ENSCONCE, to settle comfortably, also INSCONCE [v]\n",
  "ENSCONCES": "ENSCONCE, to settle comfortably, also INSCONCE [v]\n",
  "ENSCONCING": "ENSCONCE, to settle comfortably, also INSCONCE [v]\n",
  "ENSCROLL": "to write on a scroll, also INSCROLL [v -ED, -ING, -S]\n",
  "ENSCROLLED": "ENSCROLL, to write on a scroll, also INSCROLL [v]\n",
  "ENSCROLLING": "ENSCROLL, to write on a scroll, also INSCROLL [v]\n",
  "ENSCROLLS": "ENSCROLL, to write on a scroll, also INSCROLL [v]\n",
  "ENSEAL": "to put a seal upon [v -ED, -ING, -S]\n",
  "ENSEALED": "ENSEAL, to put a seal upon [v]\n",
  "ENSEALING": "ENSEAL, to put a seal upon [v]\n",
  "ENSEALS": "ENSEAL, to put a seal upon [v]\n",
  "ENSEAM": "to cover with grease [v -ED, -ING, -S]\n",
  "ENSEAMED": "ENSEAM, to cover with grease [v]\n",
  "ENSEAMING": "ENSEAM, to cover with grease [v]\n",
  "ENSEAMS": "ENSEAM, to cover with grease [v]\n",
  "ENSEAR": "(Shakespeare) to dry up [v -ED, -ING, -S]\n",
  "ENSEARED": "ENSEAR, (Shakespeare) to dry up [v]\n",
  "ENSEARING": "ENSEAR, (Shakespeare) to dry up [v]\n",
  "ENSEARS": "ENSEAR, (Shakespeare) to dry up [v]\n",
  "ENSEMBLE": "(French) a group of musicians playing together [n -S]\n",
  "ENSEMBLES": "ENSEMBLE, (French) a group of musicians playing together [n]\n",
  "ENSEPULCHRE": "to place in a sepulchre [v ENSEPULCHRED, ENSEPULCHRING, ENSEPULCHRES]\n",
  "ENSEPULCHRED": "ENSEPULCHRE, to place in a sepulchre [v]\n",
  "ENSEPULCHRES": "ENSEPULCHRE, to place in a sepulchre [v]\n",
  "ENSEPULCHRING": "ENSEPULCHRE, to place in a sepulchre [v]\n",
  "ENSERF": "to make a serf of [v -ED, -ING, -S]\n",
  "ENSERFED": "ENSERF, to make a serf of [v]\n",
  "ENSERFING": "ENSERF, to make a serf of [v]\n",
  "ENSERFMENT": "the state of being made a serf [n -S]\n",
  "ENSERFMENTS": "ENSERFMENT, the state of being made a serf [n]\n",
  "ENSERFS": "ENSERF, to make a serf of [v]\n",
  "ENSEW": "(Spenser) to ensue [v -ED, -ING, -S]\n",
  "ENSEWED": "ENSEW, (Spenser) to ensue [v]\n",
  "ENSEWING": "ENSEW, (Spenser) to ensue [v]\n",
  "ENSEWS": "ENSEW, (Spenser) to ensue [v]\n",
  "ENSHEATH": "to enclose as in a sheath, also ENSHEATHE, INSHEATH, INSHEATHE [v -ED, -ING, -S]\n",
  "ENSHEATHE": "to enclose as in a sheath, also ENSHEATH, INSHEATH, INSHEATHE [v ENSHEATHED, ENSHEATHING, ENSHEATHES]\n",
  "ENSHEATHED": "ENSHEATH, to enclose as in a sheath, also ENSHEATHE, INSHEATH, INSHEATHE [v]\n",
  "ENSHEATHES": "ENSHEATHE, to enclose as in a sheath, also ENSHEATH, INSHEATH, INSHEATHE [v]\n",
  "ENSHEATHING": "ENSHEATH, to enclose as in a sheath, also ENSHEATHE, INSHEATH, INSHEATHE [v]\n",
  "ENSHEATHS": "ENSHEATH, to enclose as in a sheath, also ENSHEATHE, INSHEATH, INSHEATHE [v]\n",
  "ENSHELL": "to enclose in a shell, also INSHELL [v -ED, -ING, -S]\n",
  "ENSHELLED": "ENSHELL, to enclose in a shell, also INSHELL [v]\n",
  "ENSHELLING": "ENSHELL, to enclose in a shell, also INSHELL [v]\n",
  "ENSHELLS": "ENSHELL, to enclose in a shell, also INSHELL [v]\n",
  "ENSHELTER": "(Shakespeare) to give shelter to [v -ED, -ING, -S]\n",
  "ENSHELTERED": "ENSHELTER, (Shakespeare) to give shelter to [v]\n",
  "ENSHELTERING": "ENSHELTER, (Shakespeare) to give shelter to [v]\n",
  "ENSHELTERS": "ENSHELTER, (Shakespeare) to give shelter to [v]\n",
  "ENSHIELD": "to defend, as with a shield [v -ED, -ING, -S]\n",
  "ENSHIELDED": "ENSHIELD, to defend, as with a shield [v]\n",
  "ENSHIELDING": "ENSHIELD, to defend, as with a shield [v]\n",
  "ENSHIELDS": "ENSHIELD, to defend, as with a shield [v]\n",
  "ENSHRINE": "to place in a shrine, also INSHRINE [v ENSHRINED, ENSHRINING, ENSHRINES]\n",
  "ENSHRINED": "ENSHRINE, to place in a shrine, also INSHRINE [v]\n",
  "ENSHRINEE": "one who is enshrined [n -S]\n",
  "ENSHRINEES": "ENSHRINEE, one who is enshrined [n]\n",
  "ENSHRINEMENT": "the act of enshrining, also INSHRINEMENT [n -S]\n",
  "ENSHRINEMENTS": "ENSHRINEMENT, the act of enshrining, also INSHRINEMENT [n]\n",
  "ENSHRINES": "ENSHRINE, to place in a shrine, also INSHRINE [v]\n",
  "ENSHRINING": "ENSHRINE, to place in a shrine, also INSHRINE [v]\n",
  "ENSHROUD": "to cover up [v -ED, -ING, -S]\n",
  "ENSHROUDED": "ENSHROUD, to cover up [v]\n",
  "ENSHROUDING": "ENSHROUD, to cover up [v]\n",
  "ENSHROUDS": "ENSHROUD, to cover up [v]\n",
  "ENSIFORM": "in botany, sword-shaped [adj]\n",
  "ENSIGN": "to mark with a badge or sign [v -ED, -ING, -S]\n",
  "ENSIGNCIES": "ENSIGNCY, the rank of a navy officer [n]\n",
  "ENSIGNCY": "the rank of a navy officer [n ENSIGNCIES]\n",
  "ENSIGNED": "ENSIGN, to mark with a badge or sign [v]\n",
  "ENSIGNING": "ENSIGN, to mark with a badge or sign [v]\n",
  "ENSIGNS": "ENSIGN, to mark with a badge or sign [v]\n",
  "ENSIGNSHIP": "(historical) the state or rank of an ensign [n -S]\n",
  "ENSIGNSHIPS": "ENSIGNSHIP, (historical) the state or rank of an ensign [n]\n",
  "ENSILABILITIES": "ENSILABILITY, the capacity for being ensiled [n]\n",
  "ENSILABILITY": "the capacity for being ensiled [n ENSILABILITIES]\n",
  "ENSILAGE": "to store in a silo, also ENSILE [v ENSILAGED, ENSILAGING or ENSILAGEING, ENSILAGES]\n",
  "ENSILAGED": "ENSILAGE, to store in a silo, also ENSILE [v]\n",
  "ENSILAGEING": "ENSILAGE, to store in a silo, also ENSILE [v]\n",
  "ENSILAGES": "ENSILAGE, to store in a silo, also ENSILE [v]\n",
  "ENSILAGING": "ENSILAGE, to store in a silo, also ENSILE [v]\n",
  "ENSILE": "to store in a silo, also ENSILAGE [v ENSILED, ENSILING, ENSILES]\n",
  "ENSILED": "ENSILE, to store in a silo, also ENSILAGE [v]\n",
  "ENSILES": "ENSILE, to store in a silo, also ENSILAGE [v]\n",
  "ENSILING": "ENSILE, to store in a silo, also ENSILAGE [v]\n",
  "ENSKIED": "ENSKY, (Shakespeare) to raise in the skies [v]\n",
  "ENSKIES": "ENSKY, (Shakespeare) to raise in the skies [v]\n",
  "ENSKY": "(Shakespeare) to raise in the skies [v ENSKIED or ENSKYED, ENSKYING, ENSKIES]\n",
  "ENSKYED": "ENSKY, (Shakespeare) to raise in the skies [v]\n",
  "ENSKYING": "ENSKY, (Shakespeare) to raise in the skies [v]\n",
  "ENSLAVE": "to make a slave of [v ENSLAVED, ENSLAVING, ENSLAVES]\n",
  "ENSLAVED": "ENSLAVE, to make a slave of [v]\n",
  "ENSLAVEMENT": "the state of being enslaved [n -S]\n",
  "ENSLAVEMENTS": "ENSLAVEMENT, the state of being enslaved [n]\n",
  "ENSLAVER": "one who enslaves [n -S]\n",
  "ENSLAVERS": "ENSLAVER, one who enslaves [n]\n",
  "ENSLAVES": "ENSLAVE, to make a slave of [v]\n",
  "ENSLAVING": "ENSLAVE, to make a slave of [v]\n",
  "ENSNARE": "to trap, also INSNARE [v ENSNARED, ENSNARING, ENSNARES]\n",
  "ENSNARED": "ENSNARE, to trap, also INSNARE [v]\n",
  "ENSNAREMENT": "the act of ensnaring [n -S]\n",
  "ENSNAREMENTS": "ENSNAREMENT, the act of ensnaring [n]\n",
  "ENSNARER": "one that ensnares, also INSNARER [n -S]\n",
  "ENSNARERS": "ENSNARER, one that ensnares, also INSNARER [n]\n",
  "ENSNARES": "ENSNARE, to trap, also INSNARE [v]\n",
  "ENSNARING": "ENSNARE, to trap, also INSNARE [v]\n",
  "ENSNARL": "to snarl up, entangle [v -ED, -ING, -S]\n",
  "ENSNARLED": "ENSNARL, to snarl up, entangle [v]\n",
  "ENSNARLING": "ENSNARL, to snarl up, entangle [v]\n",
  "ENSNARLS": "ENSNARL, to snarl up, entangle [v]\n",
  "ENSORCEL": "to bewitch, also ENSORCELL [v ENSORCELED or ENSORCELLED, ENSORCELING or ENSORCELLING, ENSORCELS]\n",
  "ENSORCELED": "ENSORCEL, to bewitch, also ENSORCELL [v]\n",
  "ENSORCELING": "ENSORCEL, to bewitch, also ENSORCELL [v]\n",
  "ENSORCELL": "(archaic) to enchant, also ENSORCEL [v -ED, -ING, -S]\n",
  "ENSORCELLED": "ENSORCEL, to bewitch, also ENSORCELL [v]\n",
  "ENSORCELLING": "ENSORCEL, to bewitch, also ENSORCELL [v]\n",
  "ENSORCELLMENT": "the state of being ensorcelled [n -S]\n",
  "ENSORCELLMENTS": "ENSORCELLMENT, the state of being ensorcelled [n]\n",
  "ENSORCELLS": "ENSORCELL, (archaic) to enchant, also ENSORCEL [v]\n",
  "ENSORCELS": "ENSORCEL, to bewitch, also ENSORCELL [v]\n",
  "ENSOUL": "to infuse with a soul, also INSOUL [v -ED, -ING, -S]\n",
  "ENSOULED": "ENSOUL, to infuse with a soul, also INSOUL [v]\n",
  "ENSOULING": "ENSOUL, to infuse with a soul, also INSOUL [v]\n",
  "ENSOULMENT": "the act of animating with a soul, also INSOULMENT [n -S]\n",
  "ENSOULMENTS": "ENSOULMENT, the act of animating with a soul, also INSOULMENT [n]\n",
  "ENSOULS": "ENSOUL, to infuse with a soul, also INSOUL [v]\n",
  "ENSPHERE": "to enclose in a sphere, also INSPHERE [v ENSPHERED, ENSPHERING, ENSPHERES]\n",
  "ENSPHERED": "ENSPHERE, to enclose in a sphere, also INSPHERE [v]\n",
  "ENSPHERES": "ENSPHERE, to enclose in a sphere, also INSPHERE [v]\n",
  "ENSPHERING": "ENSPHERE, to enclose in a sphere, also INSPHERE [v]\n",
  "ENSTAMP": "to mark as with a stamp [v -ED, -ING, -S]\n",
  "ENSTAMPED": "ENSTAMP, to mark as with a stamp [v]\n",
  "ENSTAMPING": "ENSTAMP, to mark as with a stamp [v]\n",
  "ENSTAMPS": "ENSTAMP, to mark as with a stamp [v]\n",
  "ENSTATITE": "a mineral of the pyroxene group, a silicate of magnesia with some iron [n -S]\n",
  "ENSTATITES": "ENSTATITE, a mineral of the pyroxene group, a silicate of magnesia with some iron [n]\n",
  "ENSTEEP": "(Shakespeare) to steep; to place under water [v -ED, -ING, -S]\n",
  "ENSTEEPED": "ENSTEEP, (Shakespeare) to steep; to place under water [v]\n",
  "ENSTEEPING": "ENSTEEP, (Shakespeare) to steep; to place under water [v]\n",
  "ENSTEEPS": "ENSTEEP, (Shakespeare) to steep; to place under water [v]\n",
  "ENSTRUCTURED": "incorporated into or made part of the structure of something [adj]\n",
  "ENSTYLE": "(archaic) to style; to name [v ENSTYLED, ENSTYLING, ENSTYLES]\n",
  "ENSTYLED": "ENSTYLE, (archaic) to style; to name [v]\n",
  "ENSTYLES": "ENSTYLE, (archaic) to style; to name [v]\n",
  "ENSTYLING": "ENSTYLE, (archaic) to style; to name [v]\n",
  "ENSUE": "to follow, also ENSEW [v ENSUED, ENSUING, ENSUES]\n",
  "ENSUED": "ENSUE, to follow, also ENSEW [v]\n",
  "ENSUES": "ENSUE, to follow, also ENSEW [v]\n",
  "ENSUING": "ENSUE, to follow, also ENSEW [v]\n",
  "ENSUITE": "(French) a room, as a bathroom, adjoining another room [n -S]\n",
  "ENSUITES": "ENSUITE, (French) a room, as a bathroom, adjoining another room [n]\n",
  "ENSURE": "to make sure [v ENSURED, ENSURING, ENSURES]\n",
  "ENSURED": "ENSURE, to make sure [v]\n",
  "ENSURER": "one who ensures, also INSURER [n -S]\n",
  "ENSURERS": "ENSURER, one who ensures, also INSURER [n]\n",
  "ENSURES": "ENSURE, to make sure [v]\n",
  "ENSURING": "ENSURE, to make sure [v]\n",
  "ENSWATHE": "to wrap around, also INSWATHE [v ENSWATHED, ENSWATHING, ENSWATHES]\n",
  "ENSWATHED": "ENSWATHE, to wrap around, also INSWATHE [v]\n",
  "ENSWATHEMENT": "the act of enswathing [n -S]\n",
  "ENSWATHEMENTS": "ENSWATHEMENT, the act of enswathing [n]\n",
  "ENSWATHES": "ENSWATHE, to wrap around, also INSWATHE [v]\n",
  "ENSWATHING": "ENSWATHE, to wrap around, also INSWATHE [v]\n",
  "ENSWEEP": "to sweep over [v ENSWEPT, ENSWEEPING, ENSWEEPS]\n",
  "ENSWEEPING": "ENSWEEP, to sweep over [v]\n",
  "ENSWEEPS": "ENSWEEP, to sweep over [v]\n",
  "ENSWEPT": "ENSWEEP, to sweep over [v]\n",
  "ENTABLATURE": "(French) that part of a design in classical architecture which surmounts the columns and rests upon the capitals [n -S]\n",
  "ENTABLATURES": "ENTABLATURE, (French) that part of a design in classical architecture which surmounts the columns and rests upon the capitals [n]\n",
  "ENTABLEMENT": "the platform of a pedestal, supporting a statue [n -S]\n",
  "ENTABLEMENTS": "ENTABLEMENT, the platform of a pedestal, supporting a statue [n]\n",
  "ENTAIL": "to settle an estate on a series of heirs, so that the immediate possessor may not dispose of it [v -ED, -ING, -S]\n",
  "ENTAILED": "ENTAIL, to settle an estate on a series of heirs, so that the immediate possessor may not dispose of it [v]\n",
  "ENTAILER": "one who entails (an estate) [n -S]\n",
  "ENTAILERS": "ENTAILER, one who entails (an estate) [n]\n",
  "ENTAILING": "ENTAIL, to settle an estate on a series of heirs, so that the immediate possessor may not dispose of it [v]\n",
  "ENTAILMENT": "the act of entailing or of giving, as an estate, and directing the mode of descent [n -S]\n",
  "ENTAILMENTS": "ENTAILMENT, the act of entailing or of giving, as an estate, and directing the mode of descent [n]\n",
  "ENTAILS": "ENTAIL, to settle an estate on a series of heirs, so that the immediate possessor may not dispose of it [v]\n",
  "ENTAME": "(Shakespeare) to tame [v ENTAMED, ENTAMING, ENTAMES]\n",
  "ENTAMEBA": "(Greek) an amoeba that causes amoebic dysentery, also ENDAMEBA, ENDAMOEBA, ENTAMOEBA [n ENTAMEBAS or ENTAMEBAE]\n",
  "ENTAMEBAE": "ENTAMEBA, (Greek) an amoeba that causes amoebic dysentery, also ENDAMEBA, ENDAMOEBA, ENTAMOEBA [n]\n",
  "ENTAMEBAS": "ENTAMEBA, (Greek) an amoeba that causes amoebic dysentery, also ENDAMEBA, ENDAMOEBA, ENTAMOEBA [n]\n",
  "ENTAMED": "ENTAME, (Shakespeare) to tame [v]\n",
  "ENTAMES": "ENTAME, (Shakespeare) to tame [v]\n",
  "ENTAMING": "ENTAME, (Shakespeare) to tame [v]\n",
  "ENTAMOEBA": "(Greek) an amoeba that causes amoebic dysentery, also ENDAMEBA, ENDAMOEBA, ENTAMEBA [n ENTAMOEBAS or ENTAMOEBAE]\n",
  "ENTAMOEBAE": "ENTAMOEBA, (Greek) an amoeba that causes amoebic dysentery, also ENDAMEBA, ENDAMOEBA, ENTAMEBA [n]\n",
  "ENTAMOEBAS": "ENTAMOEBA, (Greek) an amoeba that causes amoebic dysentery, also ENDAMEBA, ENDAMOEBA, ENTAMEBA [n]\n",
  "ENTANGLE": "to twist together [v ENTANGLED, ENTANGLING, ENTANGLES]\n",
  "ENTANGLED": "ENTANGLE, to twist together [v]\n",
  "ENTANGLEMENT": "the action of entangling [n -S]\n",
  "ENTANGLEMENTS": "ENTANGLEMENT, the action of entangling [n]\n",
  "ENTANGLER": "one who entangles [n -S]\n",
  "ENTANGLERS": "ENTANGLER, one who entangles [n]\n",
  "ENTANGLES": "ENTANGLE, to twist together [v]\n",
  "ENTANGLING": "ENTANGLE, to twist together [v]\n",
  "ENTASES": "ENTASIS, (Greek) a swelling on vertical columns to counteract an optical illusion of concavity [n]\n",
  "ENTASIA": "a spasmodic contraction of a muscle [n -S]\n",
  "ENTASIAS": "ENTASIA, a spasmodic contraction of a muscle [n]\n",
  "ENTASIS": "(Greek) a swelling on vertical columns to counteract an optical illusion of concavity [n ENTASES]\n",
  "ENTASTIC": "relating to entasia, any disease characterized by tonic spasms [adj]\n",
  "ENTAYLE": "(obsolete) to carve [v ENTAYLED, ENTAYLING, ENTAYLES]\n",
  "ENTAYLED": "ENTAYLE, (obsolete) to carve [v]\n",
  "ENTAYLES": "ENTAYLE, (obsolete) to carve [v]\n",
  "ENTAYLING": "ENTAYLE, (obsolete) to carve [v]\n",
  "ENTELECHIES": "ENTELECHY, perfect realization as opposed to a potentiality [n]\n",
  "ENTELECHY": "perfect realization as opposed to a potentiality [n ENTELECHIES]\n",
  "ENTELLUS": "(Latin) an East Indian long-tailed bearded monkey, remarkable for the cap-like arrangement of the hair on the head [n -ES]\n",
  "ENTELLUSES": "ENTELLUS, (Latin) an East Indian long-tailed bearded monkey, remarkable for the cap-like arrangement of the hair on the head [n]\n",
  "ENTENDER": "(obsolete) to make tender or weaken, also INTENDER [v -ED, -ING, -S]\n",
  "ENTENDERED": "ENTENDER, (obsolete) to make tender or weaken, also INTENDER [v]\n",
  "ENTENDERING": "ENTENDER, (obsolete) to make tender or weaken, also INTENDER [v]\n",
  "ENTENDERS": "ENTENDER, (obsolete) to make tender or weaken, also INTENDER [v]\n",
  "ENTENTE": "(French) a friendly understanding between states [n -S]\n",
  "ENTENTES": "ENTENTE, (French) a friendly understanding between states [n]\n",
  "ENTER": "to go or come in [v -ED, -ING, -S]\n",
  "ENTERA": "ENTERON, (Greek) a body cavity in coelenterates [n]\n",
  "ENTERABLE": "that can be entered [adj]\n",
  "ENTERAL": "pertaining to the enteron [adj ENTERALLY]\n",
  "ENTERALLY": "ENTERAL, pertaining to the enteron [adv]\n",
  "ENTERATE": "having an alimentary canal [adj]\n",
  "ENTERCHAUNGE": "(obsolete) to interchange, also INTERCHANGE [v ENTERCHAUNGED, ENTERCHAUNGING, ENTERCHAUNGES]\n",
  "ENTERCHAUNGED": "ENTERCHAUNGE, (obsolete) to interchange, also INTERCHANGE [v]\n",
  "ENTERCHAUNGES": "ENTERCHAUNGE, (obsolete) to interchange, also INTERCHANGE [v]\n",
  "ENTERCHAUNGING": "ENTERCHAUNGE, (obsolete) to interchange, also INTERCHANGE [v]\n",
  "ENTERDEALE": "(Spenser) to interdeal, to intrigue, also INTERDEAL [v ENTERDEALED, ENTERDEALING, ENTERDEALES]\n",
  "ENTERDEALED": "ENTERDEALE, (Spenser) to interdeal, to intrigue, also INTERDEAL [v]\n",
  "ENTERDEALES": "ENTERDEALE, (Spenser) to interdeal, to intrigue, also INTERDEAL [v]\n",
  "ENTERDEALING": "ENTERDEALE, (Spenser) to interdeal, to intrigue, also INTERDEAL [v]\n",
  "ENTERECTOMIES": "ENTERECTOMY, surgical removal of the intestines [n]\n",
  "ENTERECTOMY": "surgical removal of the intestines [n ENTERECTOMIES]\n",
  "ENTERED": "ENTER, to go or come in [v]\n",
  "ENTERER": "someone who enters [n -S]\n",
  "ENTERERS": "ENTERER, someone who enters [n]\n",
  "ENTERIC": "typhoid fever [n -S]\n",
  "ENTERICS": "ENTERIC, typhoid fever [n]\n",
  "ENTERING": "the act of entering [n -S]\n",
  "ENTERINGS": "ENTERING, the act of entering [n]\n",
  "ENTERITIDES": "ENTERITIS, inflammation of the intestines [n]\n",
  "ENTERITIS": "inflammation of the intestines [n ENTERITIDES or ENTERITISES]\n",
  "ENTERITISES": "ENTERITIS, inflammation of the intestines [n]\n",
  "ENTEROBACTERIA": "ENTEROBACTERIUM, any of a family of bacteria that includes salmonella and shigella [n]\n",
  "ENTEROBACTERIAL": "relating to enterobacteria [adj]\n",
  "ENTEROBACTERIUM": "any of a family of bacteria that includes salmonella and shigella [n ENTEROBACTERIA]\n",
  "ENTEROBIASES": "ENTEROBIASIS, pinworm infestation [n]\n",
  "ENTEROBIASIS": "pinworm infestation [n ENTEROBIASES]\n",
  "ENTEROCELE": "a hernial tumor whose contents are intestine [n -S]\n",
  "ENTEROCELES": "ENTEROCELE, a hernial tumor whose contents are intestine [n]\n",
  "ENTEROCENTESES": "ENTEROCENTESIS, operative puncturing of the intestine [n]\n",
  "ENTEROCENTESIS": "operative puncturing of the intestine [n ENTEROCENTESES]\n",
  "ENTEROCOCCAL": "relating to enterococcus [adj]\n",
  "ENTEROCOCCI": "ENTEROCOCCUS, any of a genus of bacteria that resemble streptococci and were formerly classified with them [n]\n",
  "ENTEROCOCCUS": "any of a genus of bacteria that resemble streptococci and were formerly classified with them [n ENTEROCOCCI]\n",
  "ENTEROCOEL": "a coelom originating by outgrowth from the archenteron, also ENTEROCOELE [n -S]\n",
  "ENTEROCOELE": "a coelom originating by outgrowth from the archenteron, also ENTEROCOEL [n -S]\n",
  "ENTEROCOELES": "ENTEROCOELE, a coelom originating by outgrowth from the archenteron, also ENTEROCOEL [n]\n",
  "ENTEROCOELIC": "of or like an enterocoele [adj]\n",
  "ENTEROCOELOUS": "of or like an enterocoele [adj]\n",
  "ENTEROCOELS": "ENTEROCOEL, a coelom originating by outgrowth from the archenteron, also ENTEROCOELE [n]\n",
  "ENTEROCOLITIDES": "ENTEROCOLITIS, inflammation of a part of the intestines [n]\n",
  "ENTEROCOLITIS": "inflammation of a part of the intestines [n ENTEROCOLITIDES or ENTEROCOLITISES]\n",
  "ENTEROCOLITISES": "ENTEROCOLITIS, inflammation of a part of the intestines [n]\n",
  "ENTEROGASTRONE": "a hormone that is produced by the duodenal mucosa and has an inhibitory action on gastric motility and secretion [n -S]\n",
  "ENTEROGASTRONES": "ENTEROGASTRONE, a hormone that is produced by the duodenal mucosa and has an inhibitory action on gastric motility and secretion [n]\n",
  "ENTEROHEPATITIS": "an infectious disease of turkeys and some wildfowl that is caused by a protozoan, aka blackhead [n]\n",
  "ENTEROKINASE": "an enzyme esp. of the duodenal mucosa that activates trypsinogen by converting it to trypsin [n -S]\n",
  "ENTEROKINASES": "ENTEROKINASE, an enzyme esp. of the duodenal mucosa that activates trypsinogen by converting it to trypsin [n]\n",
  "ENTEROLITH": "an intestinal concretion [n -S]\n",
  "ENTEROLITHS": "ENTEROLITH, an intestinal concretion [n]\n",
  "ENTERON": "(Greek) a body cavity in coelenterates [n ENTERA or ENTERONS]\n",
  "ENTERONS": "ENTERON, (Greek) a body cavity in coelenterates [n]\n",
  "ENTEROPATHIES": "ENTEROPATHY, a disease of the intestinal tract [n]\n",
  "ENTEROPATHY": "a disease of the intestinal tract [n ENTEROPATHIES]\n",
  "ENTEROPNEUST": "any animal of the Enteropneusta, literally, gut-breathers [n -S]\n",
  "ENTEROPNEUSTAL": "of or like an enteropneust [adj]\n",
  "ENTEROPNEUSTS": "ENTEROPNEUST, any animal of the Enteropneusta, literally, gut-breathers [n]\n",
  "ENTEROPTOSES": "ENTEROPTOSIS, downward displacement of the intestines [n]\n",
  "ENTEROPTOSIS": "downward displacement of the intestines [n ENTEROPTOSES]\n",
  "ENTEROSTOMAL": "relating to enterostomy [adj]\n",
  "ENTEROSTOMIES": "ENTEROSTOMY, a surgical formation of an opening into the intestine through the abdominal wall [n]\n",
  "ENTEROSTOMY": "a surgical formation of an opening into the intestine through the abdominal wall [n ENTEROSTOMIES]\n",
  "ENTEROTOMIES": "ENTEROTOMY, incision of the intestines, esp. in reducing certain cases of hernia [n]\n",
  "ENTEROTOMY": "incision of the intestines, esp. in reducing certain cases of hernia [n ENTEROTOMIES]\n",
  "ENTEROTOXIN": "an intestinal toxin that causes food poisoning [n -S]\n",
  "ENTEROTOXINS": "ENTEROTOXIN, an intestinal toxin that causes food poisoning [n]\n",
  "ENTEROVIRAL": "of or like an enterovirus [adj]\n",
  "ENTEROVIRUS": "any of several viruses occurring in and infecting the intestines [n -ES]\n",
  "ENTEROVIRUSES": "ENTEROVIRUS, any of several viruses occurring in and infecting the intestines [n]\n",
  "ENTERPRISE": "to undertake [v ENTERPRISED, ENTERPRISING, ENTERPRISES]\n",
  "ENTERPRISED": "ENTERPRISE, to undertake [v]\n",
  "ENTERPRISER": "one who undertakes an enterprise, an entrepreneur [n -S]\n",
  "ENTERPRISERS": "ENTERPRISER, one who undertakes an enterprise, an entrepreneur [n]\n",
  "ENTERPRISES": "ENTERPRISE, to undertake [v]\n",
  "ENTERPRISING": "marked by an independent energetic spirit and by readiness to act [adj ENTERPRISINGLY]\n",
  "ENTERPRISINGLY": "ENTERPRISING, marked by an independent energetic spirit and by readiness to act [adv]\n",
  "ENTERS": "ENTER, to go or come in [v]\n",
  "ENTERTAIN": "to hold the attention or thoughts of; to amuse [v -ED, -ING, -S]\n",
  "ENTERTAINED": "ENTERTAIN, to hold the attention or thoughts of; to amuse [v]\n",
  "ENTERTAINER": "one who entertains [n -S]\n",
  "ENTERTAINERS": "ENTERTAINER, one who entertains [n]\n",
  "ENTERTAINING": "amusing [adj ENTERTAININGLY] / the act of entertaining [n -S]\n",
  "ENTERTAININGLY": "ENTERTAINING, amusing [adv]\n",
  "ENTERTAININGS": "ENTERTAINING, the act of entertaining [n]\n",
  "ENTERTAINMENT": "a public performance [n -S]\n",
  "ENTERTAINMENTS": "ENTERTAINMENT, a public performance [n]\n",
  "ENTERTAINS": "ENTERTAIN, to hold the attention or thoughts of; to amuse [v]\n",
  "ENTERTAKE": "(Spenser) to receive, entertain [v ENTERTOOK, ENTERTAKEN, ENTERTAKING, ENTERTAKES]\n",
  "ENTERTAKEN": "ENTERTAKE, (Spenser) to receive, entertain [v]\n",
  "ENTERTAKES": "ENTERTAKE, (Spenser) to receive, entertain [v]\n",
  "ENTERTAKING": "ENTERTAKE, (Spenser) to receive, entertain [v]\n",
  "ENTERTISSUED": "(Shakespeare) interwoven, also INTERTISSUED [adj]\n",
  "ENTERTOOK": "ENTERTAKE, (Spenser) to receive, entertain [v]\n",
  "ENTETE": "(French) obstinate (of a male) [adj]\n",
  "ENTETEE": "(French) obstinate (of a female) [adj]\n",
  "ENTHALPIES": "ENTHALPY, the total heat content of a system [n]\n",
  "ENTHALPY": "the total heat content of a system [n ENTHALPIES]\n",
  "ENTHETIC": "of infectious disease, introduced into the body from outside [adj]\n",
  "ENTHRAL": "to reduce to the condition of a thrall, also ENTHRALL, INTHRAL, INTHRALL [v ENTHRALLED, ENTHRALLING, ENTHRALS]\n",
  "ENTHRALDOM": "(archaic) the state of being enthralled [n -S]\n",
  "ENTHRALDOMS": "ENTHRALDOM, (archaic) the state of being enthralled [n]\n",
  "ENTHRALL": "to reduce to the condition of a thrall, also ENTHRAL, INTHRAL, INTHRALL [v -ED, -ING, -S]\n",
  "ENTHRALLED": "ENTHRAL, to reduce to the condition of a thrall, also ENTHRALL, INTHRAL, INTHRALL [v]\n",
  "ENTHRALLER": "one who enthrals [n -S]\n",
  "ENTHRALLERS": "ENTHRALLER, one who enthrals [n]\n",
  "ENTHRALLING": "ENTHRAL, to reduce to the condition of a thrall, also ENTHRALL, INTHRAL, INTHRALL [v]\n",
  "ENTHRALLMENT": "(US) the state of being enthralled, also ENTHRALMENT [n -S]\n",
  "ENTHRALLMENTS": "ENTHRALLMENT, (US) the state of being enthralled, also ENTHRALMENT [n]\n",
  "ENTHRALLS": "ENTHRALL, to reduce to the condition of a thrall, also ENTHRAL, INTHRAL, INTHRALL [v]\n",
  "ENTHRALMENT": "the state of being enthralled, also ENTHRALLMENT [n -S]\n",
  "ENTHRALMENTS": "ENTHRALMENT, the state of being enthralled, also ENTHRALLMENT [n]\n",
  "ENTHRALS": "ENTHRAL, to reduce to the condition of a thrall, also ENTHRALL, INTHRAL, INTHRALL [v]\n",
  "ENTHRONE": "to place on a throne, also INTHRONE [v ENTHRONED, ENTHRONING, ENTHRONES]\n",
  "ENTHRONED": "ENTHRONE, to place on a throne, also INTHRONE [v]\n",
  "ENTHRONEMENT": "the act of enthroning [n -S]\n",
  "ENTHRONEMENTS": "ENTHRONEMENT, the act of enthroning [n]\n",
  "ENTHRONES": "ENTHRONE, to place on a throne, also INTHRONE [v]\n",
  "ENTHRONING": "ENTHRONE, to place on a throne, also INTHRONE [v]\n",
  "ENTHRONISATION": "the process of enthronising, also ENTHRONIZATION [n -S]\n",
  "ENTHRONISATIONS": "ENTHRONISATION, the process of enthronising, also ENTHRONIZATION [n]\n",
  "ENTHRONISE": "to enthrone e.g. a bishop, also ENTHRONIZE [v ENTHRONISED, ENTHRONISING, ENTHRONISES]\n",
  "ENTHRONISED": "ENTHRONISE, to enthrone e.g. a bishop, also ENTHRONIZE [v]\n",
  "ENTHRONISES": "ENTHRONISE, to enthrone e.g. a bishop, also ENTHRONIZE [v]\n",
  "ENTHRONISING": "ENTHRONISE, to enthrone e.g. a bishop, also ENTHRONIZE [v]\n",
  "ENTHRONIZATION": "the process of enthronizing, also ENTHRONISATION [n -S]\n",
  "ENTHRONIZATIONS": "ENTHRONIZATION, the process of enthronizing, also ENTHRONISATION [n]\n",
  "ENTHRONIZE": "to enthrone e.g. a bishop, also ENTHRONISE [v ENTHRONIZED, ENTHRONIZING, ENTHRONIZES]\n",
  "ENTHRONIZED": "ENTHRONIZE, to enthrone e.g. a bishop, also ENTHRONISE [v]\n",
  "ENTHRONIZES": "ENTHRONIZE, to enthrone e.g. a bishop, also ENTHRONISE [v]\n",
  "ENTHRONIZING": "ENTHRONIZE, to enthrone e.g. a bishop, also ENTHRONISE [v]\n",
  "ENTHUSE": "to show enthusiasm [v ENTHUSED, ENTHUSING, ENTHUSES]\n",
  "ENTHUSED": "ENTHUSE, to show enthusiasm [v]\n",
  "ENTHUSES": "ENTHUSE, to show enthusiasm [v]\n",
  "ENTHUSIASM": "intense and lively interest [n -S]\n",
  "ENTHUSIASMS": "ENTHUSIASM, intense and lively interest [n]\n",
  "ENTHUSIAST": "a person filled with enthusiasm [n -S]\n",
  "ENTHUSIASTIC": "filled with or marked by enthusiasm, also ENTHUSIASTICAL [adj]\n",
  "ENTHUSIASTICAL": "(archaic) filled with enthusiasm, also ENTHUSIASTIC [adj]\n",
  "ENTHUSIASTS": "ENTHUSIAST, a person filled with enthusiasm [n]\n",
  "ENTHUSING": "ENTHUSE, to show enthusiasm [v]\n",
  "ENTHYMEMATIC": "of or like an enthymeme, an argument of probability only, also ENTHYMEMATICAL [adj]\n",
  "ENTHYMEMATICAL": "of or like an enthymeme, an argument of probability only, also ENTHYMEMATIC [adj]\n",
  "ENTHYMEME": "an argument of probability only [n -S]\n",
  "ENTHYMEMES": "ENTHYMEME, an argument of probability only [n]\n",
  "ENTIA": "ENS, being, existence; an entity [n]\n",
  "ENTICE": "to lead astray [v ENTICED, ENTICING, ENTICES]\n",
  "ENTICEABLE": "capable of being enticed [adj]\n",
  "ENTICED": "ENTICE, to lead astray [v]\n",
  "ENTICEMENT": "the act of enticing [n -S]\n",
  "ENTICEMENTS": "ENTICEMENT, the act of enticing [n]\n",
  "ENTICER": "one who entices [n -S]\n",
  "ENTICERS": "ENTICER, one who entices [n]\n",
  "ENTICES": "ENTICE, to lead astray [v]\n",
  "ENTICING": "very inviting [adj ENTICINGLY] / the act of enticing [n -S]\n",
  "ENTICINGLY": "ENTICING, very inviting [adv]\n",
  "ENTICINGNESS": "the state of being enticing [n -ES]\n",
  "ENTICINGNESSES": "ENTICINGNESS, the state of being enticing [n]\n",
  "ENTICINGS": "ENTICING, the act of enticing [n]\n",
  "ENTIRE": "whole, also INTIRE [adj ENTIRELY] / the whole of something [n -S]\n",
  "ENTIRELY": "completely [adv]\n",
  "ENTIRENESS": "the state of being entire [n -ES]\n",
  "ENTIRENESSES": "ENTIRENESS, the state of being entire [n]\n",
  "ENTIRES": "ENTIRE, the whole of something [n]\n",
  "ENTIRETIES": "ENTIRETY, completeness [n]\n",
  "ENTIRETY": "completeness [n ENTIRETIES]\n",
  "ENTITATIVE": "regarded as a distinct entity [adj]\n",
  "ENTITIES": "ENTITY, the basic essential nature of something [n]\n",
  "ENTITLE": "to give a right to, also INTITLE, INTITULE [v ENTITLED, ENTITLING, ENTITLES]\n",
  "ENTITLED": "ENTITLE, to give a right to, also INTITLE, INTITULE [v]\n",
  "ENTITLEMENT": "the state or condition of being entitled [n -S]\n",
  "ENTITLEMENTS": "ENTITLEMENT, the state or condition of being entitled [n]\n",
  "ENTITLES": "ENTITLE, to give a right to, also INTITLE, INTITULE [v]\n",
  "ENTITLING": "ENTITLE, to give a right to, also INTITLE, INTITULE [v]\n",
  "ENTITY": "the basic essential nature of something [n ENTITIES]\n",
  "ENTOBLAST": "the inner germ layer, the endoderm, also ENDOBLAST [n -S]\n",
  "ENTOBLASTIC": "relating to the entoblast [adj]\n",
  "ENTOBLASTS": "ENTOBLAST, the inner germ layer, the endoderm, also ENDOBLAST [n]\n",
  "ENTODERM": "the innermost layer of embryo, also ENDODERM [n -S]\n",
  "ENTODERMAL": "relating to the entoderm, the innermost basic layer of tissue in those animals with true tissues, also ENTODERMIC [adj]\n",
  "ENTODERMIC": "relating to the entoderm, the innermost basic layer of tissue in those animals with true tissues, also ENTODERMAL [adj]\n",
  "ENTODERMS": "ENTODERM, the innermost layer of embryo, also ENDODERM [n]\n",
  "ENTOIL": "to entangle or ensnare [v -ED, -ING, -S]\n",
  "ENTOILED": "ENTOIL, to entangle or ensnare [v]\n",
  "ENTOILING": "ENTOIL, to entangle or ensnare [v]\n",
  "ENTOILMENT": "entanglement, ensnaring [n -S]\n",
  "ENTOILMENTS": "ENTOILMENT, entanglement, ensnaring [n]\n",
  "ENTOILS": "ENTOIL, to entangle or ensnare [v]\n",
  "ENTOMB": "to place in a tomb, also INTOMB [v -ED, -ING, -S]\n",
  "ENTOMBED": "ENTOMB, to place in a tomb, also INTOMB [v]\n",
  "ENTOMBING": "ENTOMB, to place in a tomb, also INTOMB [v]\n",
  "ENTOMBMENT": "the act of entombing [n -S]\n",
  "ENTOMBMENTS": "ENTOMBMENT, the act of entombing [n]\n",
  "ENTOMBS": "ENTOMB, to place in a tomb, also INTOMB [v]\n",
  "ENTOMIC": "of or pertaining to insects [adj]\n",
  "ENTOMOFAUNA": "(Latin) insect life [n ENTOMOFAUNAE or ENTOMOFAUNAS]\n",
  "ENTOMOFAUNAE": "ENTOMOFAUNA, (Latin) insect life [n]\n",
  "ENTOMOFAUNAS": "ENTOMOFAUNA, (Latin) insect life [n]\n",
  "ENTOMOLOGIC": "related to entomology [adj ENTOMOLOGICALLY]\n",
  "ENTOMOLOGICAL": "relating to entomology [adj ENTOMOLOGICALLY]\n",
  "ENTOMOLOGICALLY": "ENTOMOLOGICAL, relating to entomology [adv]\n",
  "ENTOMOLOGIES": "ENTOMOLOGY, the study of insects [n]\n",
  "ENTOMOLOGISE": "to practise entomology, also ENTOMOLOGIZE [v ENTOMOLOGISED, ENTOMOLOGISING, ENTOMOLOGISES]\n",
  "ENTOMOLOGISED": "ENTOMOLOGISE, to practise entomology, also ENTOMOLOGIZE [v]\n",
  "ENTOMOLOGISES": "ENTOMOLOGISE, to practise entomology, also ENTOMOLOGIZE [v]\n",
  "ENTOMOLOGISING": "ENTOMOLOGISE, to practise entomology, also ENTOMOLOGIZE [v]\n",
  "ENTOMOLOGIST": "one who studies insects [n -S]\n",
  "ENTOMOLOGISTS": "ENTOMOLOGIST, one who studies insects [n]\n",
  "ENTOMOLOGIZE": "to practise entomology, also ENTOMOLOGISE [v ENTOMOLOGIZED, ENTOMOLOGIZING, ENTOMOLOGIZES]\n",
  "ENTOMOLOGIZED": "ENTOMOLOGIZE, to practise entomology, also ENTOMOLOGISE [v]\n",
  "ENTOMOLOGIZES": "ENTOMOLOGIZE, to practise entomology, also ENTOMOLOGISE [v]\n",
  "ENTOMOLOGIZING": "ENTOMOLOGIZE, to practise entomology, also ENTOMOLOGISE [v]\n",
  "ENTOMOLOGY": "the study of insects [n ENTOMOLOGIES]\n",
  "ENTOMOPHAGIES": "ENTOMOPHAGY, the eating of insects [n]\n",
  "ENTOMOPHAGOUS": "eating insects [adj]\n",
  "ENTOMOPHAGY": "the eating of insects [n ENTOMOPHAGIES]\n",
  "ENTOMOPHILIES": "ENTOMOPHILY, seed plants which are pollinated by insects are said to be entomophilous [n]\n",
  "ENTOMOPHILOUS": "of flowers, pollinated by insects [adj]\n",
  "ENTOMOPHILY": "seed plants which are pollinated by insects are said to be entomophilous [n ENTOMOPHILIES]\n",
  "ENTOMOSTRACAN": "any of the lower order of crustaceans [n -S]\n",
  "ENTOMOSTRACANS": "ENTOMOSTRACAN, any of the lower order of crustaceans [n]\n",
  "ENTOMOSTRACOUS": "of or like an entomostracan, any of the lower order of crustaceans [adj]\n",
  "ENTOPHYTAL": "of or like an entophyte, a vegetable parasite subsisting in the interior of the body [adj]\n",
  "ENTOPHYTE": "a vegetable parasite subsisting in the interior of the body [n -S]\n",
  "ENTOPHYTES": "ENTOPHYTE, a vegetable parasite subsisting in the interior of the body [n]\n",
  "ENTOPHYTIC": "of or pertaining to entophytes; as, an entophytic disease, also ENTOPHYTOUS [adj]\n",
  "ENTOPHYTOUS": "of or pertaining to entophytes, also ENTOPHYTIC [adj]\n",
  "ENTOPIC": "in the normal position, as opposed to ectopic [adj]\n",
  "ENTOPLASTRA": "ENTOPLASTRON, the unpaired plate behind the epiplastra in a turtle's plastron [n]\n",
  "ENTOPLASTRAL": "relating to the entoplastron, the unpaired plate behind the epiplastra in a turtle's plastron [adj]\n",
  "ENTOPLASTRON": "the unpaired plate behind the epiplastra in a turtle's plastron [n ENTOPLASTRA]\n",
  "ENTOPROCT": "any of a phylum of animals related to Bryozoans [n -S]\n",
  "ENTOPROCTS": "ENTOPROCT, any of a phylum of animals related to Bryozoans [n]\n",
  "ENTOPTIC": "within the eyeball [adj] / a visual phenomenon originating inside the eye [n -S]\n",
  "ENTOPTICS": "ENTOPTIC, a visual phenomenon originating inside the eye [n]\n",
  "ENTOTIC": "pertaining to the ear's interior [adj]\n",
  "ENTOURAGE": "(French) a group of people in attendance on or accompanying someone important [n -S]\n",
  "ENTOURAGES": "ENTOURAGE, (French) a group of people in attendance on or accompanying someone important [n]\n",
  "ENTOZOA": "ENTOZOON, an internal parasite, also ENDOZOON, ENTOZOAN [n]\n",
  "ENTOZOAL": "having seeds dispersed by animals that swallow them, also ENDOZOIC, ENTOZOIC [adj]\n",
  "ENTOZOAN": "an internal parasite, also ENDOZOON, ENTOZOON [n -S]\n",
  "ENTOZOANS": "ENTOZOAN, an internal parasite, also ENDOZOON, ENTOZOON [n]\n",
  "ENTOZOIC": "having seeds dispersed by animals that swallow them, also ENDOZOIC, ENTOZOAL [adj]\n",
  "ENTOZOON": "an internal parasite, also ENDOZOON, ENTOZOAN [n ENTOZOA]\n",
  "ENTRAIL": "(Spenser) to interlace or entwine [v -ED, -ING, -S]\n",
  "ENTRAILED": "ENTRAIL, (Spenser) to interlace or entwine [v]\n",
  "ENTRAILING": "ENTRAIL, (Spenser) to interlace or entwine [v]\n",
  "ENTRAILS": "ENTRAIL, (Spenser) to interlace or entwine [v]\n",
  "ENTRAIN": "to board a train [v -ED, -ING, -S]\n",
  "ENTRAINED": "ENTRAIN, to board a train [v]\n",
  "ENTRAINEMENT": "(French) enthusiasm [n -S]\n",
  "ENTRAINEMENTS": "ENTRAINEMENT, (French) enthusiasm [n]\n",
  "ENTRAINER": "one who entrains [n -S]\n",
  "ENTRAINERS": "ENTRAINER, one who entrains [n]\n",
  "ENTRAINING": "ENTRAIN, to board a train [v]\n",
  "ENTRAINMENT": "the act of entraining [n -S]\n",
  "ENTRAINMENTS": "ENTRAINMENT, the act of entraining [n]\n",
  "ENTRAINS": "ENTRAIN, to board a train [v]\n",
  "ENTRALL": "(Spenser) an entrail [n -ES]\n",
  "ENTRALLES": "ENTRALL, (Spenser) an entrail [n]\n",
  "ENTRAMMEL": "to trammel; to entangle [v ENTRAMMELED or ENTRAMMELLED, ENTRAMMELING or ENTRAMMELLING, ENTRAMMELS]\n",
  "ENTRAMMELED": "ENTRAMMEL, to trammel; to entangle [v]\n",
  "ENTRAMMELING": "ENTRAMMEL, to trammel; to entangle [v]\n",
  "ENTRAMMELLED": "ENTRAMMEL, to trammel; to entangle [v]\n",
  "ENTRAMMELLING": "ENTRAMMEL, to trammel; to entangle [v]\n",
  "ENTRAMMELS": "ENTRAMMEL, to trammel; to entangle [v]\n",
  "ENTRANCE": "to fill with delight [v ENTRANCED, ENTRANCING, ENTRANCES]\n",
  "ENTRANCED": "ENTRANCE, to fill with delight [v]\n",
  "ENTRANCEMENT": "the state of being entranced [n -S]\n",
  "ENTRANCEMENTS": "ENTRANCEMENT, the state of being entranced [n]\n",
  "ENTRANCES": "ENTRANCE, to fill with delight [v]\n",
  "ENTRANCEWAY": "an entrance [n -S]\n",
  "ENTRANCEWAYS": "ENTRANCEWAY, an entrance [n]\n",
  "ENTRANCING": "ENTRANCE, to fill with delight [v]\n",
  "ENTRANCINGLY": "in the manner of filling with delight [adv]\n",
  "ENTRANT": "someone who enters, also INTRANT [n -S]\n",
  "ENTRANTS": "ENTRANT, someone who enters, also INTRANT [n]\n",
  "ENTRAP": "to trap [v ENTRAPPED, ENTRAPPING, ENTRAPS]\n",
  "ENTRAPMENT": "the act of entrapping [n -S]\n",
  "ENTRAPMENTS": "ENTRAPMENT, the act of entrapping [n]\n",
  "ENTRAPPED": "ENTRAP, to trap [v]\n",
  "ENTRAPPER": "one who entraps [n -S]\n",
  "ENTRAPPERS": "ENTRAPPER, one who entraps [n]\n",
  "ENTRAPPING": "ENTRAP, to trap [v]\n",
  "ENTRAPS": "ENTRAP, to trap [v]\n",
  "ENTREASURE": "(archaic) to store in or as if in a treasury [v ENTREASURED, ENTREASURING, ENTREASURES]\n",
  "ENTREASURED": "ENTREASURE, (archaic) to store in or as if in a treasury [v]\n",
  "ENTREASURES": "ENTREASURE, (archaic) to store in or as if in a treasury [v]\n",
  "ENTREASURING": "ENTREASURE, (archaic) to store in or as if in a treasury [v]\n",
  "ENTREAT": "to ask for earnestly, also INTREAT [v -ED, -ING, -S]\n",
  "ENTREATABLE": "(obsolete) that can be entreated [adj]\n",
  "ENTREATED": "ENTREAT, to ask for earnestly, also INTREAT [v]\n",
  "ENTREATIES": "ENTREATY, an earnest request or prayer [n]\n",
  "ENTREATING": "asking for earnestly [adj ENTREATINGLY] / the act of asking earnestly [n -S]\n",
  "ENTREATINGLY": "ENTREATING [adv]\n",
  "ENTREATINGS": "ENTREATING, the act of asking earnestly [n]\n",
  "ENTREATIVE": "(obsolete) used in entreaty; pleading [adj]\n",
  "ENTREATMENT": "the act of entreating [n -S]\n",
  "ENTREATMENTS": "ENTREATMENT, the act of entreating [n]\n",
  "ENTREATS": "ENTREAT, to ask for earnestly, also INTREAT [v]\n",
  "ENTREATY": "an earnest request or prayer [n ENTREATIES]\n",
  "ENTRECHAT": "(French) a ballet leap in which the dancer repeatedly crosses the legs [n -S]\n",
  "ENTRECHATS": "ENTRECHAT, (French) a ballet leap in which the dancer repeatedly crosses the legs [n]\n",
  "ENTRECOTE": "(French) a steak cut from between two ribs [n -S]\n",
  "ENTRECOTES": "ENTRECOTE, (French) a steak cut from between two ribs [n]\n",
  "ENTREE": "(French) freedom of access [n -S]\n",
  "ENTREES": "ENTREE, (French) freedom of access [n]\n",
  "ENTREMES": "(French) edible pastry sculpture served between main courses, also ENTREMESSE, ENTREMETS [n ENTREMES]\n",
  "ENTREMESSE": "(French) edible pastry sculpture served between main courses, also ENTREMES, ENTREMETS [n -S]\n",
  "ENTREMESSES": "ENTREMESSE, (French) edible pastry sculpture served between main courses, also ENTREMES, ENTREMETS [n]\n",
  "ENTREMETS": "(French) edible pastry sculpture served between main courses, also ENTREMES, ENTREMESSE [n]\n",
  "ENTRENCH": "to fix firmly, also INTRENCH [v -ED, -ING, -ES]\n",
  "ENTRENCHED": "ENTRENCH, to fix firmly, also INTRENCH [v]\n",
  "ENTRENCHER": "one who entrenches, also INTRENCHER [n -S]\n",
  "ENTRENCHERS": "ENTRENCHER, one who entrenches, also INTRENCHER [n]\n",
  "ENTRENCHES": "ENTRENCH, to fix firmly, also INTRENCH [v]\n",
  "ENTRENCHING": "ENTRENCH, to fix firmly, also INTRENCH [v]\n",
  "ENTRENCHMENT": "the act of entrenching [n -S]\n",
  "ENTRENCHMENTS": "ENTRENCHMENT, the act of entrenching [n]\n",
  "ENTREPOT": "(French) a place, such as a warehouse, port, or trading center, to which goods are brought for distribution to other parts of the world [n -S]\n",
  "ENTREPOTS": "ENTREPOT, (French) a place, such as a warehouse, port, or trading center, to which goods are brought for distribution to other parts of the world [n]\n",
  "ENTREPRENEUR": "(French) one who undertakes commercial ventures [n -S]\n",
  "ENTREPRENEURIAL": "of or like an entrepreneur [adj]\n",
  "ENTREPRENEURS": "ENTREPRENEUR, (French) one who undertakes commercial ventures [n]\n",
  "ENTREPRENEUSE": "(French) a female entrepreneur [n -S]\n",
  "ENTREPRENEUSES": "ENTREPRENEUSE, (French) a female entrepreneur [n]\n",
  "ENTRESOL": "(French) a low storey between two higher ones, usually between the ground floor and the first storey [n -S]\n",
  "ENTRESOLS": "ENTRESOL, (French) a low storey between two higher ones, usually between the ground floor and the first storey [n]\n",
  "ENTREZ": "(French) come in [v]\n",
  "ENTRIES": "ENTRY, a place of entrance [n]\n",
  "ENTRISM": "political branch-stacking, also ENTRYISM [n -S]\n",
  "ENTRISMS": "ENTRISM, political branch-stacking, also ENTRYISM [n]\n",
  "ENTRIST": "one who indulges in entryism, also ENTRYIST [n -S]\n",
  "ENTRISTS": "ENTRIST, one who indulges in entryism, also ENTRYIST [n]\n",
  "ENTROLD": "(Spenser) a past participle of obscure meaning, possibly enrolled, also INTROLD [v]\n",
  "ENTROPIC": "relating to entropy [adj ENTROPICALLY]\n",
  "ENTROPICALLY": "ENTROPIC, relating to entropy [adv]\n",
  "ENTROPIES": "ENTROPY, a thermodynamic measure of unavailable energy [n]\n",
  "ENTROPION": "(Greek) the inversion or turning in of the border of the eyelids, also ENTROPIUM [n -S]\n",
  "ENTROPIONS": "ENTROPION, (Greek) the inversion or turning in of the border of the eyelids, also ENTROPIUM [n]\n",
  "ENTROPIUM": "(Greek) the inversion or turning in of the border of the eyelids, also ENTROPION [n -S]\n",
  "ENTROPIUMS": "ENTROPIUM, (Greek) the inversion or turning in of the border of the eyelids, also ENTROPION [n]\n",
  "ENTROPY": "a thermodynamic measure of unavailable energy [n ENTROPIES]\n",
  "ENTRUST": "to give over for safe keeping, also INTRUST [v -ED, -ING, -S]\n",
  "ENTRUSTED": "ENTRUST, to give over for safe keeping, also INTRUST [v]\n",
  "ENTRUSTING": "ENTRUST, to give over for safe keeping, also INTRUST [v]\n",
  "ENTRUSTMENT": "the act of entrusting [n -S]\n",
  "ENTRUSTMENTS": "ENTRUSTMENT, the act of entrusting [n]\n",
  "ENTRUSTS": "ENTRUST, to give over for safe keeping, also INTRUST [v]\n",
  "ENTRY": "a place of entrance [n ENTRIES]\n",
  "ENTRYISM": "political branch-stacking, also ENTRISM [n -S]\n",
  "ENTRYISMS": "ENTRYISM, political branch-stacking, also ENTRISM [n]\n",
  "ENTRYIST": "one who indulges in entryism, also ENTRIST [n -S]\n",
  "ENTRYISTS": "ENTRYIST, one who indulges in entryism, also ENTRIST [n]\n",
  "ENTRYWAY": "a passage serving as an entrance [n -S]\n",
  "ENTRYWAYS": "ENTRYWAY, a passage serving as an entrance [n]\n",
  "ENTS": "(colloquial) entertainments [n]\n",
  "ENTWINE": "to weave together, also INTWINE [v ENTWINED, ENTWINING, ENTWINES]\n",
  "ENTWINED": "ENTWINE, to weave together, also INTWINE [v]\n",
  "ENTWINEMENT": "the act of entwining [n -S]\n",
  "ENTWINEMENTS": "ENTWINEMENT, the act of entwining [n]\n",
  "ENTWINES": "ENTWINE, to weave together, also INTWINE [v]\n",
  "ENTWINING": "ENTWINE, to weave together, also INTWINE [v]\n",
  "ENTWIST": "to twist together, also INTWIST [v -ED, -ING, -S]\n",
  "ENTWISTED": "ENTWIST, to twist together, also INTWIST [v]\n",
  "ENTWISTING": "ENTWIST, to twist together, also INTWIST [v]\n",
  "ENTWISTS": "ENTWIST, to twist together, also INTWIST [v]\n",
  "ENUCLEATE": "to bring or peel out, as a kernel from its enveloping husks or shell [v ENUCLEATED, ENUCLEATING, ENUCLEATES]\n",
  "ENUCLEATED": "ENUCLEATE, to bring or peel out, as a kernel from its enveloping husks or shell [v]\n",
  "ENUCLEATES": "ENUCLEATE, to bring or peel out, as a kernel from its enveloping husks or shell [v]\n",
  "ENUCLEATING": "ENUCLEATE, to bring or peel out, as a kernel from its enveloping husks or shell [v]\n",
  "ENUCLEATION": "clarification, explanation [n -S]\n",
  "ENUCLEATIONS": "ENUCLEATION, clarification, explanation [n]\n",
  "ENUF": "(colloquial) enough, also ANOW, ENOUGH, ENOW [adj]\n",
  "ENUMERABILITIES": "ENUMERABILITY, the state of being enumerable [n]\n",
  "ENUMERABILITY": "the state of being enumerable [n ENUMERABILITIES]\n",
  "ENUMERABLE": "that can be counted [adj]\n",
  "ENUMERATE": "to count, also NUMERATE [v ENUMERATED, ENUMERATING, ENUMERATES]\n",
  "ENUMERATED": "ENUMERATE, to count, also NUMERATE [v]\n",
  "ENUMERATES": "ENUMERATE, to count, also NUMERATE [v]\n",
  "ENUMERATING": "ENUMERATE, to count, also NUMERATE [v]\n",
  "ENUMERATION": "the act of enumerating [n -S]\n",
  "ENUMERATIONS": "ENUMERATION, the act of enumerating [n]\n",
  "ENUMERATIVE": "serving to enumerate [adj]\n",
  "ENUMERATOR": "one that enumerates [n -S]\n",
  "ENUMERATORS": "ENUMERATOR, one that enumerates [n]\n",
  "ENUNCIABLE": "capable of being enunciated or expressed [adj]\n",
  "ENUNCIATE": "to pronounce [v ENUNCIATED, ENUNCIATING, ENUNCIATES]\n",
  "ENUNCIATED": "ENUNCIATE, to pronounce [v]\n",
  "ENUNCIATES": "ENUNCIATE, to pronounce [v]\n",
  "ENUNCIATING": "ENUNCIATE, to pronounce [v]\n",
  "ENUNCIATION": "the act of enunciating [n -S]\n",
  "ENUNCIATIONS": "ENUNCIATION, the act of enunciating [n]\n",
  "ENUNCIATIVE": "containing enunciation or utterance, also ENUNCIATORY [adj ENUNCIATIVELY]\n",
  "ENUNCIATIVELY": "ENUNCIATIVE, containing enunciation or utterance, also ENUNCIATORY [adv]\n",
  "ENUNCIATOR": "one who enunciates [n -S]\n",
  "ENUNCIATORS": "ENUNCIATOR, one who enunciates [n]\n",
  "ENUNCIATORY": "relating to enunciation, also ENUNCIATIVE [adj]\n",
  "ENURE": "to accustom or habituate to, also INURE [v ENURED, ENURING, ENURES]\n",
  "ENURED": "ENURE, to accustom or habituate to, also INURE [v]\n",
  "ENUREDNESS": "the state of being enured [n -ES]\n",
  "ENUREDNESSES": "ENUREDNESS, the state of being enured [n]\n",
  "ENUREMENT": "the act of enuring, also INUREMENT [n -S]\n",
  "ENUREMENTS": "ENUREMENT, the act of enuring, also INUREMENT [n]\n",
  "ENURES": "ENURE, to accustom or habituate to, also INURE [v]\n",
  "ENURESES": "ENURESIS, involuntary urination [n]\n",
  "ENURESIS": "involuntary urination [n ENURESISES or ENURESES]\n",
  "ENURESISES": "ENURESIS, involuntary urination [n]\n",
  "ENURETIC": "one who is affected with enuresis [n -S]\n",
  "ENURETICS": "ENURETIC, one who is affected with enuresis [n]\n",
  "ENURING": "ENURE, to accustom or habituate to, also INURE [v]\n",
  "ENURN": "to put into an urn, also INURN [v -ED, -ING, -S]\n",
  "ENURNED": "ENURN, to put into an urn, also INURN [v]\n",
  "ENURNING": "ENURN, to put into an urn, also INURN [v]\n",
  "ENURNS": "ENURN, to put into an urn, also INURN [v]\n",
  "ENVASSAL": "to make a vassal [v ENVASSALLED, ENVASSALLING, ENVASSALS]\n",
  "ENVASSALLED": "ENVASSAL, to make a vassal [v]\n",
  "ENVASSALLING": "ENVASSAL, to make a vassal [v]\n",
  "ENVASSALS": "ENVASSAL, to make a vassal [v]\n",
  "ENVAULT": "to enclose in a vault [v -ED, -ING, -S]\n",
  "ENVAULTED": "ENVAULT, to enclose in a vault [v]\n",
  "ENVAULTING": "ENVAULT, to enclose in a vault [v]\n",
  "ENVAULTS": "ENVAULT, to enclose in a vault [v]\n",
  "ENVEIGLE": "to cajole, also INVEIGLE, INVEAGLE [v ENVEIGLED, ENVEIGLING, ENVEIGLES]\n",
  "ENVEIGLED": "ENVEIGLE, to cajole, also INVEIGLE, INVEAGLE [v]\n",
  "ENVEIGLES": "ENVEIGLE, to cajole, also INVEIGLE, INVEAGLE [v]\n",
  "ENVEIGLING": "ENVEIGLE, to cajole, also INVEIGLE, INVEAGLE [v]\n",
  "ENVELOP": "to cover completely [v -ED, -ING, -S]\n",
  "ENVELOPE": "a paper container [n -S]\n",
  "ENVELOPED": "ENVELOP, to cover completely [v]\n",
  "ENVELOPER": "one who envelops [n -S]\n",
  "ENVELOPERS": "ENVELOPER, one who envelops [n]\n",
  "ENVELOPES": "ENVELOPE, a paper container [n]\n",
  "ENVELOPING": "ENVELOP, to cover completely [v]\n",
  "ENVELOPMENT": "the act of enveloping [n -S]\n",
  "ENVELOPMENTS": "ENVELOPMENT, the act of enveloping [n]\n",
  "ENVELOPS": "ENVELOP, to cover completely [v]\n",
  "ENVENOM": "to put venom into, poison [v -ED, -ING, -S]\n",
  "ENVENOMED": "ENVENOM, to put venom into, poison [v]\n",
  "ENVENOMING": "ENVENOM, to put venom into, poison [v]\n",
  "ENVENOMISATION": "the process of envenoming, also ENVENOMIZATION [n -S]\n",
  "ENVENOMISATIONS": "ENVENOMISATION, the process of envenoming, also ENVENOMIZATION [n]\n",
  "ENVENOMIZATION": "the process of envenoming, also ENVENOMISATION [n -S]\n",
  "ENVENOMIZATIONS": "ENVENOMIZATION, the process of envenoming, also ENVENOMISATION [n]\n",
  "ENVENOMS": "ENVENOM, to put venom into, poison [v]\n",
  "ENVERMEIL": "(Milton) to color with, or as with, vermilion [v -ED, -ING, -S]\n",
  "ENVERMEILED": "ENVERMEIL, (Milton) to color with, or as with, vermilion [v]\n",
  "ENVERMEILING": "ENVERMEIL, (Milton) to color with, or as with, vermilion [v]\n",
  "ENVERMEILS": "ENVERMEIL, (Milton) to color with, or as with, vermilion [v]\n",
  "ENVIABLE": "causing envy [adj]\n",
  "ENVIABLENESS": "the state of being enviable [n -ES]\n",
  "ENVIABLENESSES": "ENVIABLENESS, the state of being enviable [n]\n",
  "ENVIABLY": "ENVIABLE, causing envy [adv]\n",
  "ENVIED": "ENVY, to covet others' possessions, looks etc. [v]\n",
  "ENVIER": "one who envies [n -S]\n",
  "ENVIERS": "ENVIER, one who envies [n]\n",
  "ENVIES": "ENVY, to covet others' possessions, looks etc. [v]\n",
  "ENVIOUS": "resentful and desirous of another's possessions or qualities [adj ENVIOUSLY]\n",
  "ENVIOUSLY": "ENVIOUS, resentful and desirous of another's possessions or qualities [adv]\n",
  "ENVIOUSNESS": "the state of being envious [n -ES]\n",
  "ENVIOUSNESSES": "ENVIOUSNESS, the state of being envious [n]\n",
  "ENVIRO": "(colloquial) an environmentalist [n -S]\n",
  "ENVIRON": "to envelop, enclose [v -ED, -ING, -S]\n",
  "ENVIRONED": "ENVIRON, to envelop, enclose [v]\n",
  "ENVIRONICS": "the study of the method of influencing behaviour by controlled environmental factors [n]\n",
  "ENVIRONING": "ENVIRON, to envelop, enclose [v]\n",
  "ENVIRONMENT": "the circumstances, objects, or conditions by which one is surrounded [n -S]\n",
  "ENVIRONMENTAL": "relating to the environment [adj ENVIRONMENTALLY]\n",
  "ENVIRONMENTALLY": "ENVIRONMENTAL, relating to the environment [adv]\n",
  "ENVIRONMENTS": "ENVIRONMENT, the circumstances, objects, or conditions by which one is surrounded [n]\n",
  "ENVIRONS": "ENVIRON, to envelop, enclose [v]\n",
  "ENVIROS": "ENVIRO, (colloquial) an environmentalist [n]\n",
  "ENVISAGE": "to visualize, also ENVISION [v ENVISAGED, ENVISAGING, ENVISAGES]\n",
  "ENVISAGED": "ENVISAGE, to visualize, also ENVISION [v]\n",
  "ENVISAGEMENT": "the act of envisaging [n -S]\n",
  "ENVISAGEMENTS": "ENVISAGEMENT, the act of envisaging [n]\n",
  "ENVISAGES": "ENVISAGE, to visualize, also ENVISION [v]\n",
  "ENVISAGING": "ENVISAGE, to visualize, also ENVISION [v]\n",
  "ENVISION": "to visualize, also ENVISAGE [v -ED, -ING, -S]\n",
  "ENVISIONED": "ENVISION, to visualize, also ENVISAGE [v]\n",
  "ENVISIONING": "ENVISION, to visualize, also ENVISAGE [v]\n",
  "ENVISIONS": "ENVISION, to visualize, also ENVISAGE [v]\n",
  "ENVOI": "(French) the concluding part of a poem or book [n -S]\n",
  "ENVOIS": "ENVOI, (French) the concluding part of a poem or book [n]\n",
  "ENVOY": "a representative [n -S]\n",
  "ENVOYS": "ENVOY, a representative [n]\n",
  "ENVOYSHIP": "the office or position of an envoy [n -S]\n",
  "ENVOYSHIPS": "ENVOYSHIP, the office or position of an envoy [n]\n",
  "ENVY": "to covet others' possessions, looks etc. [v ENVIED, ENVYING, ENVIES]\n",
  "ENVYING": "in a state of envy [adj ENVYINGLY] / the act of envying [n -S]\n",
  "ENVYINGLY": "ENVYING, in a state of envy [adv]\n",
  "ENVYINGS": "ENVYING, the act of envying [n]\n",
  "ENWALL": "to enclose within a wall [v -ED, -ING, -S]\n",
  "ENWALLED": "ENWALL, to enclose within a wall [v]\n",
  "ENWALLING": "ENWALL, to enclose within a wall [v]\n",
  "ENWALLOW": "(Spenser) to roll about in a wallowing way [v -ED, -ING, -S]\n",
  "ENWALLOWED": "ENWALLOW, (Spenser) to roll about in a wallowing way [v]\n",
  "ENWALLOWING": "ENWALLOW, (Spenser) to roll about in a wallowing way [v]\n",
  "ENWALLOWS": "ENWALLOW, (Spenser) to roll about in a wallowing way [v]\n",
  "ENWALLS": "ENWALL, to enclose within a wall [v]\n",
  "ENWHEEL": "(Shakespeare) to encircle [v -ED, -ING, -S]\n",
  "ENWHEELED": "ENWHEEL, (Shakespeare) to encircle [v]\n",
  "ENWHEELING": "ENWHEEL, (Shakespeare) to encircle [v]\n",
  "ENWHEELS": "ENWHEEL, (Shakespeare) to encircle [v]\n",
  "ENWIND": "to enwrap, also INWIND [v ENWOUND, ENWINDING, ENWINDS]\n",
  "ENWINDING": "ENWIND, to enwrap, also INWIND [v]\n",
  "ENWINDS": "ENWIND, to enwrap, also INWIND [v]\n",
  "ENWOMB": "to enclose as if in a womb [v -ED, -ING, -S]\n",
  "ENWOMBED": "ENWOMB, to enclose as if in a womb [v]\n",
  "ENWOMBING": "ENWOMB, to enclose as if in a womb [v]\n",
  "ENWOMBS": "ENWOMB, to enclose as if in a womb [v]\n",
  "ENWOUND": "ENWIND, to enwrap, also INWIND [v]\n",
  "ENWRAP": "to envelop, also INWRAP [v ENWRAPPED or ENWRAPT, ENWRAPPING, ENWRAPS]\n",
  "ENWRAPMENT": "the act of enwrapping, also INWRAPMENT [n -S]\n",
  "ENWRAPMENTS": "ENWRAPMENT, the act of enwrapping, also INWRAPMENT [n]\n",
  "ENWRAPPED": "ENWRAP, to envelop, also INWRAP [v]\n",
  "ENWRAPPING": "the act of wrapping [n -S]\n",
  "ENWRAPPINGS": "ENWRAPPING, the act of wrapping [n]\n",
  "ENWRAPS": "ENWRAP, to envelop, also INWRAP [v]\n",
  "ENWRAPT": "ENWRAP, to envelop, also INWRAP [v]\n",
  "ENWREATH": "to encircle with a wreath, also ENWREATHE [v -ED, -ING, -S]\n",
  "ENWREATHE": "to surround or encompass as with a wreath, also ENWREATH, INWREATHE [v ENWREATHED, ENWREATHING, ENWREATHES]\n",
  "ENWREATHED": "ENWREATH, to encircle with a wreath, also ENWREATHE [v]\n",
  "ENWREATHES": "ENWREATHE, to surround or encompass as with a wreath, also ENWREATH, INWREATHE [v]\n",
  "ENWREATHING": "ENWREATH, to encircle with a wreath, also ENWREATHE [v]\n",
  "ENWREATHS": "ENWREATH, to encircle with a wreath, also ENWREATHE [v]\n",
  "ENZIAN": "(German) a type of schnapps flavoured with gentian roots [n -S]\n",
  "ENZIANS": "ENZIAN, (German) a type of schnapps flavoured with gentian roots [n]\n",
  "ENZONE": "to engirdle or surround with a zone or belt [v ENZONED, ENZONING, ENZONES]\n",
  "ENZONED": "ENZONE, to engirdle or surround with a zone or belt [v]\n",
  "ENZONES": "ENZONE, to engirdle or surround with a zone or belt [v]\n",
  "ENZONING": "ENZONE, to engirdle or surround with a zone or belt [v]\n",
  "ENZOOTIC": "of a disease, affecting the animals of a district, corresponding to an endemic disease among human beings [adj ENZOOTICALLY] / an enzootic disease [n -S]\n",
  "ENZOOTICALLY": "ENZOOTIC, of a disease, affecting the animals of a district, corresponding to an endemic disease among human beings [adv]\n",
  "ENZOOTICS": "ENZOOTIC, an enzootic disease [n]\n",
  "ENZYM": "a complex protein that acts as a catalyst, also ENZYME [n -S]\n",
  "ENZYMATIC": "of or like an enzyme, also ENZYMIC [adj ENZYMATICALLY]\n",
  "ENZYMATICALLY": "ENZYMATIC, of or like an enzyme, also ENZYMIC [adv]\n",
  "ENZYME": "a complex protein that acts as a catalyst, also ENZYM [n -S]\n",
  "ENZYMES": "ENZYME, a complex protein that acts as a catalyst, also ENZYM [n]\n",
  "ENZYMIC": "of or like an enzyme, also ENZYMATIC [adj ENZYMICALLY]\n",
  "ENZYMICALLY": "ENZYMIC, of or like an enzyme, also ENZYMATIC [adv]\n",
  "ENZYMOLOGICAL": "related to enzymology [adj]\n",
  "ENZYMOLOGIES": "ENZYMOLOGY, the study of enzymes [n]\n",
  "ENZYMOLOGIST": "a specialist in enzymology [n -S]\n",
  "ENZYMOLOGISTS": "ENZYMOLOGIST, a specialist in enzymology [n]\n",
  "ENZYMOLOGY": "the study of enzymes [n ENZYMOLOGIES]\n",
  "ENZYMOLYSES": "ENZYMOLYSIS, a biochemical decomposition, such as a fermentation, that is catalysed by an enzyme [n]\n",
  "ENZYMOLYSIS": "a biochemical decomposition, such as a fermentation, that is catalysed by an enzyme [n ENZYMOLYSES]\n",
  "ENZYMOLYTIC": "relating to enzymolysis [adj]\n",
  "ENZYMS": "ENZYM, a complex protein that acts as a catalyst, also ENZYME [n]\n",
  "EOAN": "pertaining to dawn [adj]\n",
  "EOBIONT": "a type of basic organism [n -S]\n",
  "EOBIONTS": "EOBIONT, a type of basic organism [n]\n",
  "EOCENE": "of rock formed in the second epoch of the Tertiary geological period [adj]\n",
  "EOHIPPUS": "(Greek) an ancestor of the horse [n -ES]\n",
  "EOHIPPUSES": "EOHIPPUS, (Greek) an ancestor of the horse [n]\n",
  "EOLIAN": "(Latin) relating to, acted on by, or due to the agency of, the wind, also AEOLIAN [adj]\n",
  "EOLIENNE": "(French) a fine dress fabric of silk and wool [n -S]\n",
  "EOLIENNES": "EOLIENNE, (French) a fine dress fabric of silk and wool [n]\n",
  "EOLIPILE": "the first steam engine, with a globe made to revolve by steam jets, also AEOLIPILE, AEOLIPYLE, EOLOPILE [n -S]\n",
  "EOLIPILES": "EOLIPILE, the first steam engine, with a globe made to revolve by steam jets, also AEOLIPILE, AEOLIPYLE, EOLOPILE [n]\n",
  "EOLITH": "a very early rough stone implement, or stone naturally formed but thought to be manufactured [n -S]\n",
  "EOLITHIC": "of or like an eolith [adj]\n",
  "EOLITHS": "EOLITH, a very early rough stone implement, or stone naturally formed but thought to be manufactured [n]\n",
  "EOLOPILE": "the first steam engine, with a globe made to revolve by steam jets, also AEOLIPILE, AEOLIPYLE, EOLIPILE [n -S]\n",
  "EOLOPILES": "EOLOPILE, the first steam engine, with a globe made to revolve by steam jets, also AEOLIPILE, AEOLIPYLE, EOLIPILE [n]\n",
  "EON": "a long period of time, also AEON [n -S]\n",
  "EONIAN": "lasting for eons, eternal, also AEONIAN, AEONIC [adj]\n",
  "EONISM": "transvestism, especially by a man [n -S]\n",
  "EONISMS": "EONISM, transvestism, especially by a man [n]\n",
  "EONS": "EON, a long period of time, also AEON [n]\n",
  "EORL": "(obsolete) an earl [n -S]\n",
  "EORLS": "EORL, (obsolete) an earl [n]\n",
  "EOSIN": "a red dye, also EOSINE [n -S]\n",
  "EOSINE": "a red dye, also EOSIN [n -S]\n",
  "EOSINES": "EOSINE, a red dye, also EOSIN [n]\n",
  "EOSINIC": "of or like eosin, a red dyestuff [adj]\n",
  "EOSINOPHIL": "a type of white blood cell, so called because it is easily stained by eosin, also EOSINOPHILE [n -S]\n",
  "EOSINOPHILE": "a type of white blood cell, so called because it is easily stained by eosin, also EOSINOPHIL [n -S]\n",
  "EOSINOPHILES": "EOSINOPHILE, a type of white blood cell, so called because it is easily stained by eosin, also EOSINOPHIL [n]\n",
  "EOSINOPHILIA": "an abnormal increase in the number of eosinophils in the blood [n -S]\n",
  "EOSINOPHILIAS": "EOSINOPHILIA, an abnormal increase in the number of eosinophils in the blood [n]\n",
  "EOSINOPHILIC": "staining readily with eosin, also EOSINOPHILOUS [adj]\n",
  "EOSINOPHILOUS": "staining readily with eosin, also EOSINOPHILIC [adj]\n",
  "EOSINOPHILS": "EOSINOPHIL, a type of white blood cell, so called because it is easily stained by eosin, also EOSINOPHILE [n]\n",
  "EOSINS": "EOSIN, a red dye, also EOSINE [n]\n",
  "EOTHEN": "(archaic) from the east [adv]\n",
  "EPACRID": "an Australian plant resembling heath, also EPACRIS [n -S]\n",
  "EPACRIDS": "EPACRID, an Australian plant resembling heath, also EPACRIS [n]\n",
  "EPACRIS": "an Australian plant resembling heath, also EPACRID [n -ES]\n",
  "EPACRISES": "EPACRIS, an Australian plant resembling heath, also EPACRID [n]\n",
  "EPACT": "the difference in days between the lunar and solar year [n -S]\n",
  "EPACTS": "EPACT, the difference in days between the lunar and solar year [n]\n",
  "EPAENETIC": "(archaic) eulogistic [adj]\n",
  "EPAGOGE": "(Greek) argument by logical induction [n -S]\n",
  "EPAGOGES": "EPAGOGE, (Greek) argument by logical induction [n]\n",
  "EPAGOGIC": "reasoned by logical induction [adj]\n",
  "EPAGOMENAL": "of days, intercalary, or inserted between others [adj]\n",
  "EPANADIPLOSES": "EPANADIPLOSIS, a figure by which a sentence begins and ends with the same word, e.g. 'Rejoice in the Lord alway, and again I say, rejoice' [n]\n",
  "EPANADIPLOSIS": "a figure by which a sentence begins and ends with the same word, e.g. 'Rejoice in the Lord alway, and again I say, rejoice' [n EPANADIPLOSES]\n",
  "EPANALEPSES": "EPANALEPSIS, repetition or resumption with the same words e.g. 'The king is dead, long live the king' [n]\n",
  "EPANALEPSIS": "repetition or resumption with the same words e.g. 'The king is dead, long live the king' [n EPANALEPSES]\n",
  "EPANALEPTIC": "related to epanalepsis, repetition or resumption with the same words [adj]\n",
  "EPANAPHORA": "the repetition of a word or expression at the beginning of successive phrases, clauses, sentences or verses esp. for rhetorical effect, also ANAPHOR, ANAPHORA [n -S]\n",
  "EPANAPHORAL": "relating to epanaphora [adj]\n",
  "EPANAPHORAS": "EPANAPHORA, the repetition of a word or expression at the beginning of successive phrases, clauses, sentences or verses esp. for rhetorical effect, also ANAPHOR, ANAPHORA [n]\n",
  "EPANODOS": "(Greek) a recapitulation of the chief points in a discourse after digression [n -ES]\n",
  "EPANODOSES": "EPANODOS, (Greek) a recapitulation of the chief points in a discourse after digression [n]\n",
  "EPANORTHOSES": "EPANORTHOSIS, the retracting of a statement in order to correct or intensify it, e.g. 'I've warned you a thousand, no, a million times!' [n]\n",
  "EPANORTHOSIS": "the retracting of a statement in order to correct or intensify it, e.g. 'I've warned you a thousand, no, a million times!' [n EPANORTHOSES]\n",
  "EPANORTHOTIC": "relating to epanorthosis, the retracting of a statement in order to correct or intensify [adj]\n",
  "EPARCH": "(Greek) the ruler of an eparchy [n -S]\n",
  "EPARCHATE": "the province or diocese of an eparch, also EPARCHY [n -S]\n",
  "EPARCHATES": "EPARCHATE, the province or diocese of an eparch, also EPARCHY [n]\n",
  "EPARCHIAL": "having an eparch, in ancient Greece, the governor or prefect of a province [adj]\n",
  "EPARCHIES": "EPARCHY, an administrative subdivision of Greece; a diocese in the Eastern Orthodox Church, also EPARCHATE [n]\n",
  "EPARCHS": "EPARCH, (Greek) the ruler of an eparchy [n]\n",
  "EPARCHY": "an administrative subdivision of Greece; a diocese in the Eastern Orthodox Church, also EPARCHATE [n EPARCHIES]\n",
  "EPATANT": "(French) wonderful, marvellous [adj]\n",
  "EPATER": "(French) to shock complacent people [v -ED, -ING, -S]\n",
  "EPATERED": "EPATER, (French) to shock complacent people [v]\n",
  "EPATERING": "EPATER, (French) to shock complacent people [v]\n",
  "EPATERS": "EPATER, (French) to shock complacent people [v]\n",
  "EPAULE": "(French) the shoulder of a bastion [n -S]\n",
  "EPAULEMENT": "a side-work of a battery or earthwork to protect it from flanking fire [n -S]\n",
  "EPAULEMENTS": "EPAULEMENT, a side-work of a battery or earthwork to protect it from flanking fire [n]\n",
  "EPAULES": "EPAULE, (French) the shoulder of a bastion [n]\n",
  "EPAULET": "(French) a shoulder ornament or badge worn by military and naval officers, also EPAULETTE [n -S]\n",
  "EPAULETED": "wearing an epaulet, also EPAULETTED [adj]\n",
  "EPAULETS": "EPAULET, (French) a shoulder ornament or badge worn by military and naval officers, also EPAULETTE [n]\n",
  "EPAULETTE": "(French) a shoulder ornament or badge worn by military and naval officers, also EPAULET [n -S]\n",
  "EPAULETTED": "wearing epaulettes, also EPAULETED [adj]\n",
  "EPAULETTES": "EPAULETTE, (French) a shoulder ornament or badge worn by military and naval officers, also EPAULET [n]\n",
  "EPAXIAL": "in zoology, above the axis of the neck [adj]\n",
  "EPAZOTE": "a herb of the goosefoot family [n -S]\n",
  "EPAZOTES": "EPAZOTE, a herb of the goosefoot family [n]\n",
  "EPEDAPHIC": "pertaining to atmospheric conditions [adj]\n",
  "EPEE": "(French) a sword similar to the foil but with a larger guard and a heavier blade of triangular cross section [n -S]\n",
  "EPEEIST": "one who fences with an epee [n -S]\n",
  "EPEEISTS": "EPEEIST, one who fences with an epee [n]\n",
  "EPEES": "EPEE, (French) a sword similar to the foil but with a larger guard and a heavier blade of triangular cross section [n]\n",
  "EPEIRA": "a genus of spiders, including the common garden spider, also EPEIRID [n -S]\n",
  "EPEIRAS": "EPEIRA, a genus of spiders, including the common garden spider, also EPEIRID [n]\n",
  "EPEIRIC": "of sea, within the continental shelf [adj]\n",
  "EPEIRID": "a member of the family Epeiridae, that includes garden spiders, also EPEIRA [n -S]\n",
  "EPEIRIDS": "EPEIRID, a member of the family Epeiridae, that includes garden spiders, also EPEIRA [n]\n",
  "EPEIROGENESES": "EPEIROGENESIS, the geological formation of continents, oceans, etc. [n]\n",
  "EPEIROGENESIS": "the geological formation of continents, oceans, etc. [n EPEIROGENESES]\n",
  "EPEIROGENETIC": "relating to epeirogenesis, the geological formation of continents, oceans, etc. [adj]\n",
  "EPEIROGENIC": "relating to epeirogeny, the geological formation of continents, oceans, etc. [adj EPEIROGENICALLY]\n",
  "EPEIROGENICALLY": "EPEIROGENIC, relating to epeirogeny, the geological formation of continents, oceans, etc. [adv]\n",
  "EPEIROGENIES": "EPEIROGENY, the geological formation of continents, oceans, etc., also EPIROGENY [n]\n",
  "EPEIROGENY": "the geological formation of continents, oceans, etc., also EPIROGENY [n EPEIROGENIES]\n",
  "EPENCEPHALA": "EPENCEPHALON, the cerebellum [n]\n",
  "EPENCEPHALIC": "relating to the epencephalon, the cerebellum [adj]\n",
  "EPENCEPHALON": "the cerebellum [n EPENCEPHALA or EPENCEPHALONS]\n",
  "EPENCEPHALONS": "EPENCEPHALON, the cerebellum [n]\n",
  "EPENDYMA": "a membrane lining certain body cavities [n -S]\n",
  "EPENDYMAL": "having an ependyma, the epithelial lining of the ventricles of the brain and the canal of the spinal cord [adj]\n",
  "EPENDYMAS": "EPENDYMA, a membrane lining certain body cavities [n]\n",
  "EPENTHESES": "EPENTHESIS, the insertion of an extra sound into a word, e.g. 'fillum' for 'film' [n]\n",
  "EPENTHESIS": "the insertion of an extra sound into a word, e.g. 'fillum' for 'film' [n EPENTHESES]\n",
  "EPENTHETIC": "inserted in the body of a word; as, an epenthetic letter or sound [adj]\n",
  "EPEOLATRIES": "EPEOLATRY, the worship of words [n]\n",
  "EPEOLATRY": "the worship of words [n EPEOLATRIES]\n",
  "EPERDU": "(French) desperately in love (of a male) [adj]\n",
  "EPERDUE": "(French) desperately in love (of a female) [adj]\n",
  "EPERGNE": "(French) a branched ornamental centrepiece [n -S]\n",
  "EPERGNES": "EPERGNE, (French) a branched ornamental centrepiece [n]\n",
  "EPEXEGESES": "EPEXEGESIS, additional explanation [n]\n",
  "EPEXEGESIS": "additional explanation [n EPEXEGESES]\n",
  "EPEXEGETIC": "providing additional explanation or clarification, also EPEXEGETICAL [adj EPEXEGETICALLY]\n",
  "EPEXEGETICAL": "providing additional explanation or clarification, also EPEXEGETIC [adj EPEXEGETICALLY]\n",
  "EPEXEGETICALLY": "EPEXEGETICAL, providing additional explanation or clarification, also EPEXEGETIC [adv]\n",
  "EPHA": "(Hebrew) a Hebrew unit of dry measure, also EPHAH [n -S]\n",
  "EPHAH": "(Hebrew) a Hebrew unit of dry measure, also EPHA [n -S]\n",
  "EPHAHS": "EPHAH, (Hebrew) a Hebrew unit of dry measure, also EPHA [n]\n",
  "EPHAS": "EPHA, (Hebrew) a Hebrew unit of dry measure, also EPHAH [n]\n",
  "EPHEBE": "(Greek) a young man of ancient Greece, also EPHEBOS, EPHEBUS [n -S]\n",
  "EPHEBES": "EPHEBE, (Greek) a young man of ancient Greece, also EPHEBOS, EPHEBUS [n]\n",
  "EPHEBI": "EPHEBUS, (Latin) a young man of ancient Greece, also EPHEBE, EPHEBOS [n]\n",
  "EPHEBIC": "pertaining to the adult period in the life-history of an individual [adj]\n",
  "EPHEBOI": "EPHEBOS, (Greek) a young man of ancient Greece, also EPHEBE, EPHEBUS [n]\n",
  "EPHEBOPHILE": "one who is sexually attracted to adolescents [n -S]\n",
  "EPHEBOPHILES": "EPHEBOPHILE, one who is sexually attracted to adolescents [n]\n",
  "EPHEBOPHILIA": "sexual desire for youths or adolescents [n -S]\n",
  "EPHEBOPHILIAS": "EPHEBOPHILIA, sexual desire for youths or adolescents [n]\n",
  "EPHEBOS": "(Greek) a young man of ancient Greece, also EPHEBE, EPHEBUS [n EPHEBOI]\n",
  "EPHEBUS": "(Latin) a young man of ancient Greece, also EPHEBE, EPHEBOS [n EPHEBI]\n",
  "EPHEDRA": "(Greek) a plant of the sea-grape genus [n -S]\n",
  "EPHEDRAS": "EPHEDRA, (Greek) a plant of the sea-grape genus [n]\n",
  "EPHEDRIN": "an alkaloid obtained from the plant ephedra and used in treating hay fever, asthma etc., also EPHEDRINE [n -S]\n",
  "EPHEDRINE": "an alkaloid obtained from the plant ephedra and used in treating hay fever, asthma etc., also EPHEDRIN [n -S]\n",
  "EPHEDRINES": "EPHEDRINE, an alkaloid obtained from the plant ephedra and used in treating hay fever, asthma etc., also EPHEDRIN [n]\n",
  "EPHEDRINS": "EPHEDRIN, an alkaloid obtained from the plant ephedra and used in treating hay fever, asthma etc., also EPHEDRINE [n]\n",
  "EPHELIDES": "EPHELIS, (Latin) a freckle or mole [n]\n",
  "EPHELIS": "(Latin) a freckle or mole [n EPHELIDES]\n",
  "EPHEMERA": "(Greek) an insect of the mayfly genus Ephemera, whose adult life is very short [n EPHEMERAS or EPHEMERAE]\n",
  "EPHEMERAE": "EPHEMERA, (Greek) an insect of the mayfly genus Ephemera, whose adult life is very short [n]\n",
  "EPHEMERAL": "existing only for a day, or short period [adj EPHEMERALLY] / a creature, such as a mayfly, that lives for one day only [n -S]\n",
  "EPHEMERALITIES": "EPHEMERALITY, the state of being ephemeral [n]\n",
  "EPHEMERALITY": "the state of being ephemeral [n EPHEMERALITIES]\n",
  "EPHEMERALLY": "EPHEMERAL, existing only for a day, or short period [adv]\n",
  "EPHEMERALNESS": "EPHEMERAL, existing only for a day, or short period [n]\n",
  "EPHEMERALNESSES": "EPHEMERALNESS, EPHEMERAL, existing only for a day, or short period [n]\n",
  "EPHEMERALS": "EPHEMERAL, a creature, such as a mayfly, that lives for one day only [n]\n",
  "EPHEMERAS": "EPHEMERA, (Greek) an insect of the mayfly genus Ephemera, whose adult life is very short [n]\n",
  "EPHEMERID": "an insect of the mayfly family [n EPHEMERIDES or EPHEMERIDS]\n",
  "EPHEMERIDES": "EPHEMERIS, (Greek) a table giving the positions of celestial bodies at different times [n]\n",
  "EPHEMERIDIAN": "of or like an ephemerid, an insect of the mayfly family [adj]\n",
  "EPHEMERIDS": "EPHEMERID, an insect of the mayfly family [n]\n",
  "EPHEMERIS": "(Greek) a table giving the positions of celestial bodies at different times [n EPHEMERIDES]\n",
  "EPHEMERIST": "one who studies the daily motions and positions of the planets [n -S]\n",
  "EPHEMERISTS": "EPHEMERIST, one who studies the daily motions and positions of the planets [n]\n",
  "EPHEMERON": "something of short lifetime [n EPHEMERONS or EPHEMERA]\n",
  "EPHEMERONS": "EPHEMERON, something of short lifetime [n]\n",
  "EPHEMEROPTERAN": "any insect of the mayfly family [n -S]\n",
  "EPHEMEROPTERANS": "EPHEMEROPTERAN, any insect of the mayfly family [n]\n",
  "EPHEMEROUS": "ephemeral [adj]\n",
  "EPHIALTES": "(archaic) an incubus, a nightmare [n EPHIALTES]\n",
  "EPHOD": "(Hebrew) a sleeveless garment worn by priests in ancient Israel [n -S]\n",
  "EPHODS": "EPHOD, (Hebrew) a sleeveless garment worn by priests in ancient Israel [n]\n",
  "EPHOR": "(Greek) a magistrate of ancient Greece [n EPHORS or EPHORI]\n",
  "EPHORAL": "pertaining to an ephor, one of a body of five magistrates chosen by the people of ancient Sparta [adj]\n",
  "EPHORALTIES": "EPHORALTY, the office of an ephor, or the body of ephors [n]\n",
  "EPHORALTY": "the office of an ephor, or the body of ephors [n EPHORALTIES]\n",
  "EPHORATE": "the office of ephor, one of a body of five magistrates chosen by the people of ancient Sparta [n -S]\n",
  "EPHORATES": "EPHORATE, the office of ephor, one of a body of five magistrates chosen by the people of ancient Sparta [n]\n",
  "EPHORI": "EPHOR, (Greek) a magistrate of ancient Greece [n]\n",
  "EPHORS": "EPHOR, (Greek) a magistrate of ancient Greece [n]\n",
  "EPIBIOSES": "EPIBIOSIS, any relationship between two organisms where one grows on the other but is not parasitic [n]\n",
  "EPIBIOSIS": "any relationship between two organisms where one grows on the other but is not parasitic [n EPIBIOSES]\n",
  "EPIBIOTIC": "relating to epibiosis, a relationship between two organisms where one grows on the other but is not parasitic [adj]\n",
  "EPIBLAST": "the external layer of an embryo, also ECTODERM, EXODERM [n -S]\n",
  "EPIBLASTIC": "of or relating to, or consisting of, the epiblast [adj]\n",
  "EPIBLASTS": "EPIBLAST, the external layer of an embryo, also ECTODERM, EXODERM [n]\n",
  "EPIBLEM": "the outer cell layer of the root of a plant [n -S]\n",
  "EPIBLEMS": "EPIBLEM, the outer cell layer of the root of a plant [n]\n",
  "EPIBOLIC": "relating to epiboly, the process by which one set of cells spreads over and surrounds another by dividing more rapidly [adj]\n",
  "EPIBOLIES": "EPIBOLY, the process by which one set of cells spreads over and surrounds another by dividing more rapidly, as in gastrulation [n]\n",
  "EPIBOLY": "the process by which one set of cells spreads over and surrounds another by dividing more rapidly, as in gastrulation [n EPIBOLIES]\n",
  "EPIC": "large-scale [adj EPICALLY] / a long narrative poem [n -S]\n",
  "EPICAL": "epic [adj EPICALLY]\n",
  "EPICALLY": "EPICAL, epic [adv]\n",
  "EPICALYCES": "EPICALYX, a set of bracts resembling a calyx [n]\n",
  "EPICALYX": "a set of bracts resembling a calyx [n EPICALYXES or EPICALYCES]\n",
  "EPICALYXES": "EPICALYX, a set of bracts resembling a calyx [n]\n",
  "EPICANTHI": "EPICANTHUS, a fold of skin over the inner canthus of the eye [n]\n",
  "EPICANTHIC": "relating to the epicanthus, a fold of skin over the inner canthus of the eye [adj]\n",
  "EPICANTHUS": "a fold of skin over the inner canthus of the eye [n EPICANTHI]\n",
  "EPICARDIA": "EPICARDIUM, (Latin) that part of the pericardium which forms the outer surface of the heart [n]\n",
  "EPICARDIAC": "relating to the epicardium, that part of the pericardium which forms the outer surface of the heart, also EPICARDIAL [adj]\n",
  "EPICARDIAL": "relating to the epicardium, that part of the pericardium which forms the outer surface of the heart, also EPICARDIAC [adj]\n",
  "EPICARDIUM": "(Latin) that part of the pericardium which forms the outer surface of the heart [n EPICARDIA or EPICARDIUMS]\n",
  "EPICARDIUMS": "EPICARDIUM, (Latin) that part of the pericardium which forms the outer surface of the heart [n]\n",
  "EPICARP": "the outermost layer of a fruit [n -S]\n",
  "EPICARPS": "EPICARP, the outermost layer of a fruit [n]\n",
  "EPICEDE": "a funeral ode, also EPICEDIUM [n -S]\n",
  "EPICEDES": "EPICEDE, a funeral ode, also EPICEDIUM [n]\n",
  "EPICEDIA": "EPICEDIUM, (Latin) a funeral ode, also EPICEDE [n]\n",
  "EPICEDIAL": "of or relating to dirges or elegies, also EPICEDIAN [adj]\n",
  "EPICEDIAN": "a dirge or elegy [n -S]\n",
  "EPICEDIANS": "EPICEDIAN, a dirge or elegy [n]\n",
  "EPICEDIUM": "(Latin) a funeral ode, also EPICEDE [n EPICEDIA]\n",
  "EPICENE": "one having characteristics of both sexes [n -S]\n",
  "EPICENES": "EPICENE, one having characteristics of both sexes [n]\n",
  "EPICENISM": "the state of being epicene, common to both sexes [n -S]\n",
  "EPICENISMS": "EPICENISM, the state of being epicene, common to both sexes [n]\n",
  "EPICENTER": "(US) the point on the Earth's surface that is directly above the focus of an earthquake, also EPICENTRE, EPICENTRUM [n -S]\n",
  "EPICENTERS": "EPICENTER, (US) the point on the Earth's surface that is directly above the focus of an earthquake, also EPICENTRE, EPICENTRUM [n]\n",
  "EPICENTRA": "EPICENTRUM, the point on the Earth's surface that is directly above the focus of an earthquake, also EPICENTER, EPICENTRE [n]\n",
  "EPICENTRAL": "relating to an epicentre [adj]\n",
  "EPICENTRE": "the point on the Earth's surface that is directly above the focus of an earthquake, also EPICENTER, EPICENTRUM [n -S]\n",
  "EPICENTRES": "EPICENTRE, the point on the Earth's surface that is directly above the focus of an earthquake, also EPICENTER, EPICENTRUM [n]\n",
  "EPICENTRUM": "the point on the Earth's surface that is directly above the focus of an earthquake, also EPICENTER, EPICENTRE [n EPICENTRA]\n",
  "EPICHEIREMA": "a syllogism confirmed by an incidental proposition [n EPICHEIREMAS or EPICHEIREMATA]\n",
  "EPICHEIREMAS": "EPICHEIREMA, a syllogism confirmed by an incidental proposition [n]\n",
  "EPICHEIREMATA": "EPICHEIREMA, a syllogism confirmed by an incidental proposition [n]\n",
  "EPICHLOROHYDRIN": "a volatile liquid toxic epoxide used esp. in making epoxy resins and rubbers [n]\n",
  "EPICIER": "(French) a grocer [n -S]\n",
  "EPICIERS": "EPICIER, (French) a grocer [n]\n",
  "EPICISM": "epic quality [n -S]\n",
  "EPICISMS": "EPICISM, epic quality [n]\n",
  "EPICIST": "one who tells an epic [n -S]\n",
  "EPICISTS": "EPICIST, one who tells an epic [n]\n",
  "EPICLESES": "EPICLESIS, (Greek) the act of calling on the Holy Spirit to consecrate the Eucharist [n]\n",
  "EPICLESIS": "(Greek) the act of calling on the Holy Spirit to consecrate the Eucharist [n EPICLESES]\n",
  "EPICLIKE": "like an epic [adj]\n",
  "EPICONDYLE": "a projection on the inner side of the distal end of the humerus [n -S]\n",
  "EPICONDYLES": "EPICONDYLE, a projection on the inner side of the distal end of the humerus [n]\n",
  "EPICONDYLITIS": "inflammation of the epicondyle [n -ES]\n",
  "EPICONDYLITISES": "EPICONDYLITIS, inflammation of the epicondyle [n]\n",
  "EPICONTINENTAL": "denoting a shallow sea that forms over a continental shelf [adj]\n",
  "EPICORMIC": "denoting shoots that grow from buds below the bark on the trunk or branch of a tree [adj]\n",
  "EPICOTYL": "the part of an embryo or seedling stem above the cotyledon(s) [n -S]\n",
  "EPICOTYLS": "EPICOTYL, the part of an embryo or seedling stem above the cotyledon(s) [n]\n",
  "EPICRANIA": "EPICRANIUM, the medical term for the collection of structures covering the cranium [n]\n",
  "EPICRANIUM": "the medical term for the collection of structures covering the cranium [n EPICRANIA or EPICRANIUMS]\n",
  "EPICRANIUMS": "EPICRANIUM, the medical term for the collection of structures covering the cranium [n]\n",
  "EPICRISES": "EPICRISIS, a secondary crisis occurring in the course of a disease [n]\n",
  "EPICRISIS": "a secondary crisis occurring in the course of a disease [n EPICRISES]\n",
  "EPICRITIC": "of certain sensory nerve fibres in the skin, able to discriminate accurately between small degrees of sensation [adj]\n",
  "EPICS": "EPIC, a long narrative poem [n]\n",
  "EPICURE": "one with refined tastes, who engages in sensuous living [n -S]\n",
  "EPICUREAN": "devoted to luxury [adj] / someone who believes that avoidance of pain is the greatest good [n -S]\n",
  "EPICUREANISM": "a Greek philosophy holding that freedom from pain is the highest good [n -S]\n",
  "EPICUREANISMS": "EPICUREANISM, a Greek philosophy holding that freedom from pain is the highest good [n]\n",
  "EPICUREANS": "EPICUREAN, someone who believes that avoidance of pain is the greatest good [n]\n",
  "EPICURES": "EPICURE, one with refined tastes, who engages in sensuous living [n]\n",
  "EPICURISE": "(archaic) to act as an epicure, also EPICURIZE [v EPICURISED, EPICURISING, EPICURISES]\n",
  "EPICURISED": "EPICURISE, (archaic) to act as an epicure, also EPICURIZE [v]\n",
  "EPICURISES": "EPICURISE, (archaic) to act as an epicure, also EPICURIZE [v]\n",
  "EPICURISING": "EPICURISE, (archaic) to act as an epicure, also EPICURIZE [v]\n",
  "EPICURISM": "the doctrines of Epicurus [n -S]\n",
  "EPICURISMS": "EPICURISM, the doctrines of Epicurus [n]\n",
  "EPICURIZE": "(archaic) to act as an epicure, also EPICURISE [v EPICURIZED, EPICURIZING, EPICURIZES]\n",
  "EPICURIZED": "EPICURIZE, (archaic) to act as an epicure, also EPICURISE [v]\n",
  "EPICURIZES": "EPICURIZE, (archaic) to act as an epicure, also EPICURISE [v]\n",
  "EPICURIZING": "EPICURIZE, (archaic) to act as an epicure, also EPICURISE [v]\n",
  "EPICUTICLE": "the outermost layer of cuticle of an insect exoskeleton [n -S]\n",
  "EPICUTICLES": "EPICUTICLE, the outermost layer of cuticle of an insect exoskeleton [n]\n",
  "EPICUTICULAR": "relating to the epicuticle [adj]\n",
  "EPICYCLE": "a small circle that moves in the circumference of another [n -S]\n",
  "EPICYCLES": "EPICYCLE, a small circle that moves in the circumference of another [n]\n",
  "EPICYCLIC": "pertaining to or having the motion of, an epicycle, also EPICYCLICAL [adj]\n",
  "EPICYCLICAL": "pertaining to or having the motion of, an epicycle, also EPICYCLIC [adj]\n",
  "EPICYCLOID": "a curve traced by a point in the circumference of a circle which rolls on the convex side of a fixed circle [n -S]\n",
  "EPICYCLOIDAL": "of or like an epicycloid [adj]\n",
  "EPICYCLOIDS": "EPICYCLOID, a curve traced by a point in the circumference of a circle which rolls on the convex side of a fixed circle [n]\n",
  "EPIDEICTIC": "done for show or display, also EPIDEICTICAL [adj]\n",
  "EPIDEICTICAL": "done for show or display, also EPIDEICTIC [adj]\n",
  "EPIDEMIC": "occurring in many places [adj EPIDEMICALLY] / a rapid spread of a disease [n -S]\n",
  "EPIDEMICAL": "common to, or affecting at the same time, a large number in a community [adj EPIDEMICALLY]\n",
  "EPIDEMICALLY": "EPIDEMICAL, common to, or affecting at the same time, a large number in a community [adv]\n",
  "EPIDEMICITIES": "EPIDEMICITY, the state of being epidemic [n]\n",
  "EPIDEMICITY": "the state of being epidemic [n EPIDEMICITIES]\n",
  "EPIDEMICS": "EPIDEMIC, a rapid spread of a disease [n]\n",
  "EPIDEMIOLOGIC": "relating to epidemiology, also EPIDEMIOLOGICAL [adj]\n",
  "EPIDEMIOLOGICAL": "relating to epidemiology, also EPIDEMIOLOGIC [adj]\n",
  "EPIDEMIOLOGIES": "EPIDEMIOLOGY, the study of diseases [n]\n",
  "EPIDEMIOLOGIST": "one who studies diseases [n -S]\n",
  "EPIDEMIOLOGISTS": "EPIDEMIOLOGIST, one who studies diseases [n]\n",
  "EPIDEMIOLOGY": "the study of diseases [n EPIDEMIOLOGIES]\n",
  "EPIDENDRONE": "a genus of tropical plant, also EPIDENDRUM [n -S]\n",
  "EPIDENDRONES": "EPIDENDRONE, a genus of tropical plant, also EPIDENDRUM [n]\n",
  "EPIDENDRUM": "a genus of tropical plant, also EPIDENDRONE [n -S]\n",
  "EPIDENDRUMS": "EPIDENDRUM, a genus of tropical plant, also EPIDENDRONE [n]\n",
  "EPIDERM": "the outermost layer of the skin, also EPIDERMIS [n -S]\n",
  "EPIDERMAL": "of or pertaining to the epidermis, also EPIDERMIC [adj]\n",
  "EPIDERMIC": "of or pertaining to the epidermis, also EPIDERMAL [adj]\n",
  "EPIDERMIS": "(Greek) the outermost layer of the skin, also EPIDERM [n -ES]\n",
  "EPIDERMISES": "EPIDERMIS, (Greek) the outermost layer of the skin, also EPIDERM [n]\n",
  "EPIDERMOID": "like epidermis; pertaining to the epidermis [adj]\n",
  "EPIDERMOLYSES": "EPIDERMOLYSIS, a state of detachment or loosening of the epidermis [n]\n",
  "EPIDERMOLYSIS": "a state of detachment or loosening of the epidermis [n EPIDERMOLYSES]\n",
  "EPIDERMS": "EPIDERM, the outermost layer of the skin, also EPIDERMIS [n]\n",
  "EPIDIASCOPE": "an instrument for projecting images of objects [n -S]\n",
  "EPIDIASCOPES": "EPIDIASCOPE, an instrument for projecting images of objects [n]\n",
  "EPIDICTIC": "designed to display something, esp. the skill of the speaker in rhetoric, also EPIDEICTIC, EPIDEICTICAL [adj]\n",
  "EPIDIDYMAL": "relating to the epididymis, a mass of sperm-carrying tubes at the back of the testis [adj]\n",
  "EPIDIDYMIDES": "EPIDIDYMIS, a mass of sperm-carrying tubes at the back of the testis [n]\n",
  "EPIDIDYMIS": "a mass of sperm-carrying tubes at the back of the testis [n EPIDIDYMIDES]\n",
  "EPIDIDYMITIS": "inflammation of an epididymis [n -ES]\n",
  "EPIDIDYMITISES": "EPIDIDYMITIS, inflammation of an epididymis [n]\n",
  "EPIDIORITE": "a dioritic or gabbroitic rock more or less metamorphosed [n -S]\n",
  "EPIDIORITES": "EPIDIORITE, a dioritic or gabbroitic rock more or less metamorphosed [n]\n",
  "EPIDOSITE": "a rock composed of epidote and quartz [n -S]\n",
  "EPIDOSITES": "EPIDOSITE, a rock composed of epidote and quartz [n]\n",
  "EPIDOTE": "a mineral, a silicate of alumina, lime, and oxide of iron, or manganese [n -S]\n",
  "EPIDOTES": "EPIDOTE, a mineral, a silicate of alumina, lime, and oxide of iron, or manganese [n]\n",
  "EPIDOTIC": "resembling or containing epidote [adj]\n",
  "EPIDOTISATION": "the process of transforming into epidote, also EPIDOTIZATION [n -S]\n",
  "EPIDOTISATIONS": "EPIDOTISATION, the process of transforming into epidote, also EPIDOTIZATION [n]\n",
  "EPIDOTISED": "changed into epidote, also EPIDOTIZED [adj]\n",
  "EPIDOTIZATION": "the process of transforming into epidote, also EPIDOTISATION [n -S]\n",
  "EPIDOTIZATIONS": "EPIDOTIZATION, the process of transforming into epidote, also EPIDOTISATION [n]\n",
  "EPIDOTIZED": "changed into epidote, also EPIDOTISED [adj]\n",
  "EPIDURAL": "an anaesthetic injected into the lower spinal canal [n -S]\n",
  "EPIDURALS": "EPIDURAL, an anaesthetic injected into the lower spinal canal [n]\n",
  "EPIFAUNA": "(Latin) fauna living on a hard sea floor [n EPIFAUNAS or EPIFAUNAE]\n",
  "EPIFAUNAE": "EPIFAUNA, (Latin) fauna living on a hard sea floor [n]\n",
  "EPIFAUNAL": "of or relating to epifauna, the class of animals that inhabit submerged ground and river and sea beds [adj]\n",
  "EPIFAUNAS": "EPIFAUNA, (Latin) fauna living on a hard sea floor [n]\n",
  "EPIFOCAL": "pertaining to the point of origin of an earthquake [adj]\n",
  "EPIGAEAL": "growing close to the ground, also EPIGEAL, EPIGEAN, EPIGEIC, EPIGEOUS [adj]\n",
  "EPIGAEAN": "living close to the ground [adj]\n",
  "EPIGAEOUS": "growing or living close to the ground, with cotyledons above ground, also EPIGAEAL, EPIGAEAN, EPIGEAL, EPIGEAN, EPIGEIC, EPIGEOUS [adj]\n",
  "EPIGAMIC": "of or relating to a trait or behavior that attracts a mate e.g. big antlers [adj]\n",
  "EPIGASTRIA": "EPIGASTRIUM, part of abdomen lying over the stomach [n]\n",
  "EPIGASTRIAL": "relating to the epigastrium, part of abdomen lying over the stomach, also EPIGASTRIC [adj]\n",
  "EPIGASTRIC": "relating to the epigastrium, part of abdomen lying over the stomach, also EPIGASTRIAL [adj]\n",
  "EPIGASTRIUM": "part of abdomen lying over the stomach [n EPIGASTRIA]\n",
  "EPIGEAL": "growing close to the ground, also EPIGAEAL, EPIGEAN, EPIGEIC, EPIGEOUS [adj]\n",
  "EPIGEAN": "growing close to the ground, also EPIGEAL, EPIGAEAL, EPIGEIC, EPIGEOUS [adj]\n",
  "EPIGEIC": "growing close to the ground, also EPIGEAL, EPIGAEAL, EPIGEAN, EPIGEOUS [adj]\n",
  "EPIGENE": "taking place near the earth's surface [adj]\n",
  "EPIGENESES": "EPIGENESIS, the theory of embryonic development [n]\n",
  "EPIGENESIS": "the theory of embryonic development [n EPIGENESES]\n",
  "EPIGENESIST": "an adherent of epigenesis, a theory of embryonic development [n -S]\n",
  "EPIGENESISTS": "EPIGENESIST, an adherent of epigenesis, a theory of embryonic development [n]\n",
  "EPIGENETIC": "resulting from external features, not genetic [adj EPIGENETICALLY]\n",
  "EPIGENETICALLY": "EPIGENETIC, resulting from external features, not genetic [adv]\n",
  "EPIGENETICIST": "a student of epigenetics [n -S]\n",
  "EPIGENETICISTS": "EPIGENETICIST, a student of epigenetics [n]\n",
  "EPIGENETICS": "the science which studies the causes at work in development [n]\n",
  "EPIGENIC": "acting or taking place at the earth's surface [adj]\n",
  "EPIGENIST": "one who studies the gradual development of the embryo [n -S]\n",
  "EPIGENISTS": "EPIGENIST, one who studies the gradual development of the embryo [n]\n",
  "EPIGENOME": "the complement of chemical compounds that modify the expression and function of the genome [n -S]\n",
  "EPIGENOMES": "EPIGENOME, the complement of chemical compounds that modify the expression and function of the genome [n]\n",
  "EPIGENOUS": "growing on the surface of an organism [adj]\n",
  "EPIGEOUS": "growing close to the ground, also EPIGEAL, EPIGAEAL, EPIGEAN, EPIGEIC [adj]\n",
  "EPIGLOTTAL": "of or like the epiglottis, also EPIGLOTTIC [adj]\n",
  "EPIGLOTTIC": "of or like the epiglottis, also EPIGLOTTAL [adj]\n",
  "EPIGLOTTIDES": "EPIGLOTTIS, a cartilaginous flap over the glottis [n]\n",
  "EPIGLOTTIS": "a cartilaginous flap over the glottis [n EPIGLOTTIDES or EPIGLOTTISES]\n",
  "EPIGLOTTISES": "EPIGLOTTIS, a cartilaginous flap over the glottis [n]\n",
  "EPIGNATHOUS": "having a protruding upper jaw [adj]\n",
  "EPIGON": "(Greek) an inferior imitator, also EPIGONE, EPIGONUS [n -S]\n",
  "EPIGONE": "(Greek) an inferior imitator, also EPIGON, EPIGONUS [n -S]\n",
  "EPIGONES": "EPIGONE, (Greek) an inferior imitator, also EPIGON, EPIGONUS [n]\n",
  "EPIGONI": "EPIGONUS, (Greek) an inferior imitator, also EPIGON, EPIGONE [n]\n",
  "EPIGONIC": "of or like an epigon, an inferior imitator of a creative thinker or artist [adj]\n",
  "EPIGONISM": "the state of being a follower or inferior imitator [n -S]\n",
  "EPIGONISMS": "EPIGONISM, the state of being a follower or inferior imitator [n]\n",
  "EPIGONOUS": "relating to a follower or inferior imitator [adj]\n",
  "EPIGONS": "EPIGON, (Greek) an inferior imitator, also EPIGONE, EPIGONUS [n]\n",
  "EPIGONUS": "(Greek) an inferior imitator, also EPIGON, EPIGONE [n EPIGONI]\n",
  "EPIGRAM": "a short, witty poem; a concise, clever and often paradoxical statement [n -S]\n",
  "EPIGRAMMATIC": "of, relating to, or resembling an epigram, also EPIGRAMMATICAL [adj]\n",
  "EPIGRAMMATICAL": "of or like an epigram, also EPIGRAMMATIC [adj]\n",
  "EPIGRAMMATISE": "to make an epigram, also EPIGRAMMATIZE [v EPIGRAMMATISED, EPIGRAMMATISING, EPIGRAMMATISES]\n",
  "EPIGRAMMATISED": "EPIGRAMMATISE, to make an epigram, also EPIGRAMMATIZE [v]\n",
  "EPIGRAMMATISER": "one who writes epigrams, also EPIGRAMMATIZER [n -S]\n",
  "EPIGRAMMATISERS": "EPIGRAMMATISER, one who writes epigrams, also EPIGRAMMATIZER [n]\n",
  "EPIGRAMMATISES": "EPIGRAMMATISE, to make an epigram, also EPIGRAMMATIZE [v]\n",
  "EPIGRAMMATISING": "EPIGRAMMATISE, to make an epigram, also EPIGRAMMATIZE [v]\n",
  "EPIGRAMMATISM": "the making of epigrams [n -S]\n",
  "EPIGRAMMATISMS": "EPIGRAMMATISM, the making of epigrams [n]\n",
  "EPIGRAMMATIST": "one who makes epigrams [n -S]\n",
  "EPIGRAMMATISTS": "EPIGRAMMATIST, one who makes epigrams [n]\n",
  "EPIGRAMMATIZE": "to make an epigram, also EPIGRAMMATISE [v EPIGRAMMATIZED, EPIGRAMMATIZING, EPIGRAMMATIZES]\n",
  "EPIGRAMMATIZED": "EPIGRAMMATIZE, to make an epigram, also EPIGRAMMATISE [v]\n",
  "EPIGRAMMATIZER": "one who epigrammatizes, also EPIGRAMMATISER [n -S]\n",
  "EPIGRAMMATIZERS": "EPIGRAMMATIZER, one who epigrammatizes, also EPIGRAMMATISER [n]\n",
  "EPIGRAMMATIZES": "EPIGRAMMATIZE, to make an epigram, also EPIGRAMMATISE [v]\n",
  "EPIGRAMMATIZING": "EPIGRAMMATIZE, to make an epigram, also EPIGRAMMATISE [v]\n",
  "EPIGRAMS": "EPIGRAM, a short, witty poem; a concise, clever and often paradoxical statement [n]\n",
  "EPIGRAPH": "an inscription; a motto or quotation [n -S] / to mark with an epigraph [v -ED, -ING, -S]\n",
  "EPIGRAPHED": "EPIGRAPH, to mark with an epigraph [v]\n",
  "EPIGRAPHER": "one who writes epigraphs, also EPIGRAPHIST [n -S]\n",
  "EPIGRAPHERS": "EPIGRAPHER, one who writes epigraphs, also EPIGRAPHIST [n]\n",
  "EPIGRAPHIC": "relating to an epigraph, also EPIGRAPHICAL [adj EPIGRAPHICALLY]\n",
  "EPIGRAPHICAL": "relating to an epigraph, also EPIGRAPHIC [adj EPIGRAPHICALLY]\n",
  "EPIGRAPHICALLY": "EPIGRAPHICAL, relating to an epigraph, also EPIGRAPHIC [adv]\n",
  "EPIGRAPHIES": "EPIGRAPHY, the study of ancient inscriptions; inscriptions collectively [n]\n",
  "EPIGRAPHING": "EPIGRAPH, to mark with an epigraph [v]\n",
  "EPIGRAPHIST": "one who writes epigraphs, also EPIGRAPHER [n -S]\n",
  "EPIGRAPHISTS": "EPIGRAPHIST, one who writes epigraphs, also EPIGRAPHER [n]\n",
  "EPIGRAPHS": "EPIGRAPH, an inscription; a motto or quotation [n]\n",
  "EPIGRAPHY": "the study of ancient inscriptions; inscriptions collectively [n EPIGRAPHIES]\n",
  "EPIGYNIES": "EPIGYNY, the state of having floral organs on the ovary [n]\n",
  "EPIGYNOUS": "growing upon the top of the ovary; having calyx, corolla and stamens inserted on the top of an inferior ovary [adj]\n",
  "EPIGYNY": "the state of having floral organs on the ovary [n EPIGYNIES]\n",
  "EPILATE": "to remove hair from, also DEPILATE [v EPILATED, EPILATING, EPILATES]\n",
  "EPILATED": "EPILATE, to remove hair from, also DEPILATE [v]\n",
  "EPILATES": "EPILATE, to remove hair from, also DEPILATE [v]\n",
  "EPILATING": "EPILATE, to remove hair from, also DEPILATE [v]\n",
  "EPILATION": "the loss or removal of hair [n -S]\n",
  "EPILATIONS": "EPILATION, the loss or removal of hair [n]\n",
  "EPILATOR": "an agent used for epilating [n -S]\n",
  "EPILATORS": "EPILATOR, an agent used for epilating [n]\n",
  "EPILEPSIES": "EPILEPSY, a disorder of the nervous system [n]\n",
  "EPILEPSY": "a disorder of the nervous system [n EPILEPSIES]\n",
  "EPILEPTIC": "suffering from epilepsy, also EPILEPTICAL [adj EPILEPTICALLY] / one suffering from epilepsy [n -S]\n",
  "EPILEPTICAL": "suffering from epilepsy, also EPILEPTIC [adj EPILEPTICALLY]\n",
  "EPILEPTICALLY": "EPILEPTICAL, suffering from epilepsy, also EPILEPTIC [adv]\n",
  "EPILEPTICS": "EPILEPTIC, one suffering from epilepsy [n]\n",
  "EPILEPTIFORM": "resembling that of epilepsy [adj]\n",
  "EPILEPTOGENIC": "inducing or tending to induce epilepsy [adj]\n",
  "EPILEPTOID": "resembling epilepsy; as, epileptoid convulsions [adj]\n",
  "EPILIMNIA": "EPILIMNION, the upper, warm layer of water in a lake [n]\n",
  "EPILIMNION": "the upper, warm layer of water in a lake [n EPILIMNIONS or EPILIMNIA]\n",
  "EPILIMNIONS": "EPILIMNION, the upper, warm layer of water in a lake [n]\n",
  "EPILITHIC": "of plants, growing on the surface of rock [adj]\n",
  "EPILOBIUM": "a genus of plants that includes willowherb [n -S]\n",
  "EPILOBIUMS": "EPILOBIUM, a genus of plants that includes willowherb [n]\n",
  "EPILOG": "a conclusion [n -S]\n",
  "EPILOGIC": "relating to an epilogue [adj]\n",
  "EPILOGISE": "to speak or write an epilogue, also EPILOGIZE [v EPILOGISED, EPILOGISING, EPILOGISES]\n",
  "EPILOGISED": "EPILOGISE, to speak or write an epilogue, also EPILOGIZE [v]\n",
  "EPILOGISES": "EPILOGISE, to speak or write an epilogue, also EPILOGIZE [v]\n",
  "EPILOGISING": "EPILOGISE, to speak or write an epilogue, also EPILOGIZE [v]\n",
  "EPILOGIST": "one who writes or speaks an epilogue [n -S]\n",
  "EPILOGISTIC": "of or like an epilog, also EPILOGIC [adj]\n",
  "EPILOGISTS": "EPILOGIST, one who writes or speaks an epilogue [n]\n",
  "EPILOGIZE": "to speak or write an epilogue, also EPILOGISE [v EPILOGIZED, EPILOGIZING, EPILOGIZES]\n",
  "EPILOGIZED": "EPILOGIZE, to speak or write an epilogue, also EPILOGISE [v]\n",
  "EPILOGIZES": "EPILOGIZE, to speak or write an epilogue, also EPILOGISE [v]\n",
  "EPILOGIZING": "EPILOGIZE, to speak or write an epilogue, also EPILOGISE [v]\n",
  "EPILOGS": "EPILOG, a conclusion [n]\n",
  "EPILOGUE": "to supply with a concluding section [v EPILOGUED, EPILOGUING, EPILOGUES]\n",
  "EPILOGUED": "EPILOGUE, to supply with a concluding section [v]\n",
  "EPILOGUES": "EPILOGUE, to supply with a concluding section [v]\n",
  "EPILOGUING": "EPILOGUE, to supply with a concluding section [v]\n",
  "EPILOGUISE": "to speak or write an epilogue, also EPILOGUIZE [v EPILOGUISED, EPILOGUISING, EPILOGUISES]\n",
  "EPILOGUISED": "EPILOGUISE, to speak or write an epilogue, also EPILOGUIZE [v]\n",
  "EPILOGUISES": "EPILOGUISE, to speak or write an epilogue, also EPILOGUIZE [v]\n",
  "EPILOGUISING": "EPILOGUISE, to speak or write an epilogue, also EPILOGUIZE [v]\n",
  "EPILOGUIZE": "to speak or write an epilogue, also EPILOGUISE [v EPILOGUIZED, EPILOGUIZING, EPILOGUIZES]\n",
  "EPILOGUIZED": "EPILOGUIZE, to speak or write an epilogue, also EPILOGUISE [v]\n",
  "EPILOGUIZES": "EPILOGUIZE, to speak or write an epilogue, also EPILOGUISE [v]\n",
  "EPILOGUIZING": "EPILOGUIZE, to speak or write an epilogue, also EPILOGUISE [v]\n",
  "EPIMELETIC": "of a type of social behaviour in which the young are cared for by other individuals of the same species e.g. worker bees [adj]\n",
  "EPIMER": "a type of sugar compound [n -S]\n",
  "EPIMERASE": "an enzyme which catalyses inversion at an asymmetric carbon atom in a molecule containing more than one such atom [n -S]\n",
  "EPIMERASES": "EPIMERASE, an enzyme which catalyses inversion at an asymmetric carbon atom in a molecule containing more than one such atom [n]\n",
  "EPIMERE": "in an embryo, the part of the mesoderm that divides to form the dermatome and myotomes [n -S]\n",
  "EPIMERES": "EPIMERE, in an embryo, the part of the mesoderm that divides to form the dermatome and myotomes [n]\n",
  "EPIMERIC": "having the characteristics or relationship of epimers [adj]\n",
  "EPIMERISE": "to make into an epimer, also EPIMERIZE [v EPIMERISED, EPIMERISING, EPIMERISES]\n",
  "EPIMERISED": "EPIMERISE, to make into an epimer, also EPIMERIZE [v]\n",
  "EPIMERISES": "EPIMERISE, to make into an epimer, also EPIMERIZE [v]\n",
  "EPIMERISING": "EPIMERISE, to make into an epimer, also EPIMERIZE [v]\n",
  "EPIMERISM": "optical isomerism [n -S]\n",
  "EPIMERISMS": "EPIMERISM, optical isomerism [n]\n",
  "EPIMERIZE": "to make an epimer of, also EPIMERISE [v EPIMERIZED, EPIMERIZING, EPIMERIZES]\n",
  "EPIMERIZED": "EPIMERIZE, to make an epimer of, also EPIMERISE [v]\n",
  "EPIMERIZES": "EPIMERIZE, to make an epimer of, also EPIMERISE [v]\n",
  "EPIMERIZING": "EPIMERIZE, to make an epimer of, also EPIMERISE [v]\n",
  "EPIMERS": "EPIMER, a type of sugar compound [n]\n",
  "EPIMORPHIC": "relating to epimorphosis, a type of development in animals, such as certain insect larvae, in which segmentation of the body is complete before hatching [adj]\n",
  "EPIMORPHOSES": "EPIMORPHOSIS, a type of development in animals, such as certain insect larvae, in which segmentation of the body is complete before hatching [n]\n",
  "EPIMORPHOSIS": "a type of development in animals, such as certain insect larvae, in which segmentation of the body is complete before hatching [n EPIMORPHOSES]\n",
  "EPIMYSIA": "EPIMYSIUM, a fibrous sheet enclosing a muscle [n]\n",
  "EPIMYSIUM": "a fibrous sheet enclosing a muscle [n EPIMYSIA]\n",
  "EPINAOI": "EPINAOS, (Greek) a rear vestibule [n]\n",
  "EPINAOS": "(Greek) a rear vestibule [n EPINAOI]\n",
  "EPINASTIC": "growing more rapidly on the upper than on the under surface [adj EPINASTICALLY]\n",
  "EPINASTICALLY": "EPINASTIC, growing more rapidly on the upper than on the under surface [adv]\n",
  "EPINASTIES": "EPINASTY, a downward bending of plant parts [n]\n",
  "EPINASTY": "a downward bending of plant parts [n EPINASTIES]\n",
  "EPINEPHRIN": "adrenalin, also EPINEPHRINE [n -S]\n",
  "EPINEPHRINE": "adrenalin, also EPINEPHRIN [n -S]\n",
  "EPINEPHRINES": "EPINEPHRINE, adrenalin, also EPINEPHRIN [n]\n",
  "EPINEPHRINS": "EPINEPHRIN, adrenalin, also EPINEPHRINE [n]\n",
  "EPINEURAL": "lying over and parallel to a nerve [adj]\n",
  "EPINEURIA": "EPINEURIUM, the connective tissue framework and sheath of a nerve [n]\n",
  "EPINEURIAL": "relating to the epineurium, the connective tissue framework and sheath of a nerve [adj]\n",
  "EPINEURIUM": "the connective tissue framework and sheath of a nerve [n EPINEURIUMS or EPINEURIA]\n",
  "EPINEURIUMS": "EPINEURIUM, the connective tissue framework and sheath of a nerve [n]\n",
  "EPINICIAN": "celebrating a triumph [adj]\n",
  "EPINICION": "(Greek) an ode in honour of a victor or winner, also EPINIKIAN, EPINIKION [n -S]\n",
  "EPINICIONS": "EPINICION, (Greek) an ode in honour of a victor or winner, also EPINIKIAN, EPINIKION [n]\n",
  "EPINIKIAN": "an ode celebrating a triumph, also EPINICION, EPINIKION [n -S]\n",
  "EPINIKIANS": "EPINIKIAN, an ode celebrating a triumph, also EPINICION, EPINIKION [n]\n",
  "EPINIKION": "(Greek) an ode in honour of a victor or winner, also EPINICION, EPINIKIAN [n -S]\n",
  "EPINIKIONS": "EPINIKION, (Greek) an ode in honour of a victor or winner, also EPINICION, EPINIKIAN [n]\n",
  "EPINOSIC": "(Greek) unhealthy, unwholesome [adj]\n",
  "EPIPELAGIC": "relating to the upper, sunlit layer of sea [adj]\n",
  "EPIPETALOUS": "inserted or growing on a petal or petals [adj]\n",
  "EPIPHANIC": "of or like an epiphany, a sudden revelation [adj]\n",
  "EPIPHANIES": "EPIPHANY, an appearance of a deity [n]\n",
  "EPIPHANOUS": "of or like an epiphany [adj]\n",
  "EPIPHANY": "an appearance of a deity [n EPIPHANIES]\n",
  "EPIPHENOMENA": "EPIPHENOMENON, a secondary phenomenon associated with and apparently due to another [n]\n",
  "EPIPHENOMENAL": "of or relating to an epiphenomenon [adj EPIPHENOMENALLY]\n",
  "EPIPHENOMENALLY": "EPIPHENOMENAL, of or relating to an epiphenomenon [adv]\n",
  "EPIPHENOMENON": "a secondary phenomenon associated with and apparently due to another [n EPIPHENOMENA]\n",
  "EPIPHONEMA": "an exclamation, finishing phrase or reflection [n -S]\n",
  "EPIPHONEMAS": "EPIPHONEMA, an exclamation, finishing phrase or reflection [n]\n",
  "EPIPHRAGM": "the disc with which certain molluscs close the aperture of their shell [n -S]\n",
  "EPIPHRAGMS": "EPIPHRAGM, the disc with which certain molluscs close the aperture of their shell [n]\n",
  "EPIPHYLLOUS": "borne on the leaves or leaflike organs [adj]\n",
  "EPIPHYSEAL": "pertaining to, or having the nature of, an epiphysis, also EPIPHYSIAL [adj]\n",
  "EPIPHYSES": "EPIPHYSIS, any portion of a bone having its own centre of ossification [n]\n",
  "EPIPHYSIAL": "pertaining to, or having the nature of, an epiphysis, also EPIPHYSEAL [adj]\n",
  "EPIPHYSIS": "any portion of a bone having its own centre of ossification [n EPIPHYSES]\n",
  "EPIPHYTAL": "pertaining to an epiphyte, a plant which grows upon another plant, also EPIPHYTIC, EPIPHYTICAL [adj]\n",
  "EPIPHYTE": "a plant which grows upon another plant, using it for structural support [n -S]\n",
  "EPIPHYTES": "EPIPHYTE, a plant which grows upon another plant, using it for structural support [n]\n",
  "EPIPHYTIC": "of or like an epiphyte, also EPIPHYTAL, EPIPHYTICAL [adj EPIPHYTICALLY]\n",
  "EPIPHYTICAL": "of or like an epiphyte, also EPIPHYTAL, EPIPHYTIC [adj EPIPHYTICALLY]\n",
  "EPIPHYTICALLY": "EPIPHYTICAL, of or like an epiphyte, also EPIPHYTAL, EPIPHYTIC [adv]\n",
  "EPIPHYTISM": "the state of being an epiphyte, a plant which grows upon another plant [n -S]\n",
  "EPIPHYTISMS": "EPIPHYTISM, the state of being an epiphyte, a plant which grows upon another plant [n]\n",
  "EPIPHYTOLOGIES": "EPIPHYTOLOGY, the study of epiphytes [n]\n",
  "EPIPHYTOLOGY": "the study of epiphytes [n EPIPHYTOLOGIES]\n",
  "EPIPHYTOTIC": "a sudden outbreak of plant disease over extended geographical area [n -S]\n",
  "EPIPHYTOTICS": "EPIPHYTOTIC, a sudden outbreak of plant disease over extended geographical area [n]\n",
  "EPIPLASTRA": "EPIPLASTRON, either of the two anterior lateral plates in the plastron of a turtle [n]\n",
  "EPIPLASTRAL": "relating to an epiplastron, either of the two anterior lateral plates in the plastron of a turtle [adj]\n",
  "EPIPLASTRON": "either of the two anterior lateral plates in the plastron of a turtle [n EPIPLASTRA]\n",
  "EPIPLOA": "EPIPLOON, a free fold of the peritoneum, or one serving to connect viscera, support blood vessels, etc [n]\n",
  "EPIPLOIC": "pertaining to the epiploon [adj]\n",
  "EPIPLOON": "a free fold of the peritoneum, or one serving to connect viscera, support blood vessels, etc [n EPIPLOA or EPIPLOONS]\n",
  "EPIPLOONS": "EPIPLOON, a free fold of the peritoneum, or one serving to connect viscera, support blood vessels, etc [n]\n",
  "EPIPOLIC": "producing epipolism or fluorescence [adj]\n",
  "EPIPOLISM": "fluorescence [n -S]\n",
  "EPIPOLISMS": "EPIPOLISM, fluorescence [n]\n",
  "EPIROGENETIC": "relating to epirogeny, the geological formation of continents, oceans, etc., also EPIROGENIC [adj]\n",
  "EPIROGENIC": "relating to epirogeny, the geological formation of continents, oceans, etc., also EPIROGENETIC [adj]\n",
  "EPIROGENIES": "EPIROGENY, the geological formation of continents, oceans, etc., also EPEIROGENY [n]\n",
  "EPIROGENY": "the geological formation of continents, oceans, etc., also EPEIROGENY [n EPIROGENIES]\n",
  "EPIRRHEMA": "(Greek) in Greek comedy, the address of the coryphaeus to the audience after the parabasis [n EPIRRHEMAS or EPIRRHEMATA]\n",
  "EPIRRHEMAS": "EPIRRHEMA, (Greek) in Greek comedy, the address of the coryphaeus to the audience after the parabasis [n]\n",
  "EPIRRHEMATA": "EPIRRHEMA, (Greek) in Greek comedy, the address of the coryphaeus to the audience after the parabasis [n]\n",
  "EPIRRHEMATIC": "of or like an epirrhema, in Greek comedy, the address of the coryphaeus to the audience after the parabasis [adj]\n",
  "EPISCIA": "a tropical American herb related to the African violet [n -S]\n",
  "EPISCIAS": "EPISCIA, a tropical American herb related to the African violet [n]\n",
  "EPISCOPACIES": "EPISCOPACY, government of the church by bishops [n]\n",
  "EPISCOPACY": "government of the church by bishops [n EPISCOPACIES]\n",
  "EPISCOPAL": "governed by bishops; as, an episcopal church [adj EPISCOPALLY]\n",
  "EPISCOPALIAN": "relating to bishops [adj] / an adherent of episcopacy; a person who belongs to an episcopal (esp. Anglican) church [n -S]\n",
  "EPISCOPALIANISM": "the state of being episcopalian [n]\n",
  "EPISCOPALIANS": "EPISCOPALIAN, an adherent of episcopacy; a person who belongs to an episcopal (esp. Anglican) church [n]\n",
  "EPISCOPALISM": "episcopalian government and doctrine [n -S]\n",
  "EPISCOPALISMS": "EPISCOPALISM, episcopalian government and doctrine [n]\n",
  "EPISCOPALLY": "EPISCOPAL, governed by bishops; as, an episcopal church [adv]\n",
  "EPISCOPANT": "(Milton) a holder of a bishopric [n -S]\n",
  "EPISCOPANTS": "EPISCOPANT, (Milton) a holder of a bishopric [n]\n",
  "EPISCOPATE": "a bishopric; the office and dignity of a bishop [n -S] / to act as a bishop [v EPISCOPATED, EPISCOPATING, EPISCOPATES]\n",
  "EPISCOPATED": "EPISCOPATE, to act as a bishop [v]\n",
  "EPISCOPATES": "EPISCOPATE, a bishopric; the office and dignity of a bishop [n]\n",
  "EPISCOPATING": "EPISCOPATE, to act as a bishop [v]\n",
  "EPISCOPE": "an instrument for projecting images of opaque objects [n -S]\n",
  "EPISCOPES": "EPISCOPE, an instrument for projecting images of opaque objects [n]\n",
  "EPISCOPIES": "EPISCOPY, (Milton) survey, superintendence [n]\n",
  "EPISCOPISE": "to make a bishop of by consecration, also EPISCOPIZE [v EPISCOPISED, EPISCOPISING, EPISCOPISES]\n",
  "EPISCOPISED": "EPISCOPISE, to make a bishop of by consecration, also EPISCOPIZE [v]\n",
  "EPISCOPISES": "EPISCOPISE, to make a bishop of by consecration, also EPISCOPIZE [v]\n",
  "EPISCOPISING": "EPISCOPISE, to make a bishop of by consecration, also EPISCOPIZE [v]\n",
  "EPISCOPIZE": "to make a bishop of by consecration, also EPISCOPISE [v EPISCOPIZED, EPISCOPIZING, EPISCOPIZES]\n",
  "EPISCOPIZED": "EPISCOPIZE, to make a bishop of by consecration, also EPISCOPISE [v]\n",
  "EPISCOPIZES": "EPISCOPIZE, to make a bishop of by consecration, also EPISCOPISE [v]\n",
  "EPISCOPIZING": "EPISCOPIZE, to make a bishop of by consecration, also EPISCOPISE [v]\n",
  "EPISCOPY": "(Milton) survey, superintendence [n EPISCOPIES]\n",
  "EPISEMATIC": "of coloration, assisting recognition between members of the same species [adj]\n",
  "EPISEMON": "(Greek) a badge or characteristic device [n -S]\n",
  "EPISEMONS": "EPISEMON, (Greek) a badge or characteristic device [n]\n",
  "EPISEPALOUS": "inserted or growing on a sepal or sepals [adj]\n",
  "EPISIOTOMIES": "EPISIOTOMY, an incision made in the perineum to facilitate delivery of a foetus [n]\n",
  "EPISIOTOMY": "an incision made in the perineum to facilitate delivery of a foetus [n EPISIOTOMIES]\n",
  "EPISODAL": "pertaining to or contained in an episode, also EPISODIAL, EPISODIC, EPISODICAL [adj]\n",
  "EPISODE": "a series of events forming digression [n -S]\n",
  "EPISODES": "EPISODE, a series of events forming digression [n]\n",
  "EPISODIAL": "pertaining to or contained in an episode, also EPISODAL, EPISODIC, EPISODICAL [adj]\n",
  "EPISODIC": "pertaining to or contained in an episode, also EPISODAL, EPISODIAL, EPISODICAL [adj EPISODICALLY]\n",
  "EPISODICAL": "pertaining to or contained in an episode, also EPISODAL, EPISODIAL, EPISODIC [adj EPISODICALLY]\n",
  "EPISODICALLY": "EPISODICAL, pertaining to or contained in an episode, also EPISODAL, EPISODIAL, EPISODIC [adv]\n",
  "EPISOMAL": "of or like an episome, a genetically active particle found in bacteria [adj EPISOMALLY]\n",
  "EPISOMALLY": "EPISOMAL, of or like an episome, a genetically active particle found in bacteria [adv]\n",
  "EPISOME": "a genetically active particle found in bacteria [n -S]\n",
  "EPISOMES": "EPISOME, a genetically active particle found in bacteria [n]\n",
  "EPISPASTIC": "blistering [adj] / a blistering agent [n -S]\n",
  "EPISPASTICS": "EPISPASTIC, a blistering agent [n]\n",
  "EPISPERM": "the skin or coat of a seed, esp. the outer coat [n -S]\n",
  "EPISPERMS": "EPISPERM, the skin or coat of a seed, esp. the outer coat [n]\n",
  "EPISPORE": "the outer layer of a spore wall, also EXOSPORE [n -S]\n",
  "EPISPORES": "EPISPORE, the outer layer of a spore wall, also EXOSPORE [n]\n",
  "EPISTASES": "EPISTASIS, the suppression of a gene by another non-allelomorphic gene [n]\n",
  "EPISTASIES": "EPISTASY, a suppression of genetic effect [n]\n",
  "EPISTASIS": "the suppression of a gene by another non-allelomorphic gene [n EPISTASES]\n",
  "EPISTASY": "a suppression of genetic effect [n EPISTASIES]\n",
  "EPISTATIC": "of, exhibiting, or caused by epistasis, the suppression of a gene by another non-allelomorphic gene [adj]\n",
  "EPISTAXES": "EPISTAXIS, bleeding from the nose [n]\n",
  "EPISTAXIS": "bleeding from the nose [n EPISTAXES or EPISTAXISES]\n",
  "EPISTAXISES": "EPISTAXIS, bleeding from the nose [n]\n",
  "EPISTEMIC": "(Greek) relating to knowledge or the act of knowing [adj EPISTEMICALLY]\n",
  "EPISTEMICALLY": "EPISTEMIC, (Greek) relating to knowledge or the act of knowing [adv]\n",
  "EPISTEMICS": "the study of knowledge or the act of knowing [n]\n",
  "EPISTEMOLOGICAL": "relating to epistemology [adj]\n",
  "EPISTEMOLOGIES": "EPISTEMOLOGY, the branch of philosophy that deals with the nature of knowledge [n]\n",
  "EPISTEMOLOGIST": "a student of epistemology [n -S]\n",
  "EPISTEMOLOGISTS": "EPISTEMOLOGIST, a student of epistemology [n]\n",
  "EPISTEMOLOGY": "the branch of philosophy that deals with the nature of knowledge [n EPISTEMOLOGIES]\n",
  "EPISTERNA": "EPISTERNUM, a median bone connected with the sternum [n]\n",
  "EPISTERNAL": "of or pertaining to the episternum, a median bone connected with the sternum [adj]\n",
  "EPISTERNUM": "a median bone connected with the sternum [n EPISTERNA or EPISTERNUMS]\n",
  "EPISTERNUMS": "EPISTERNUM, a median bone connected with the sternum [n]\n",
  "EPISTILBITE": "a zeolite closely related to stilbite [n -S]\n",
  "EPISTILBITES": "EPISTILBITE, a zeolite closely related to stilbite [n]\n",
  "EPISTLE": "to preface [v EPISTLED, EPISTLING, EPISTLES]\n",
  "EPISTLED": "EPISTLE, to preface [v]\n",
  "EPISTLER": "one who writes epistles [n -S]\n",
  "EPISTLERS": "EPISTLER, one who writes epistles [n]\n",
  "EPISTLES": "EPISTLE, to preface [v]\n",
  "EPISTLING": "EPISTLE, to preface [v]\n",
  "EPISTOLARIAN": "a letter-writer [n -S]\n",
  "EPISTOLARIANS": "EPISTOLARIAN, a letter-writer [n]\n",
  "EPISTOLARIES": "EPISTOLARY, a book containing the Epistles, used for readings in church [n]\n",
  "EPISTOLARY": "relating to or consisting of epistles or letters [adj] / a book containing the Epistles, used for readings in church [n EPISTOLARIES]\n",
  "EPISTOLATORY": "of the nature of an epistle [adj]\n",
  "EPISTOLER": "the reader of the epistle in an Anglican service [n -S]\n",
  "EPISTOLERS": "EPISTOLER, the reader of the epistle in an Anglican service [n]\n",
  "EPISTOLET": "a little epistle [n -S]\n",
  "EPISTOLETS": "EPISTOLET, a little epistle [n]\n",
  "EPISTOLIC": "of or like an epistle, also EPISTOLICAL [adj]\n",
  "EPISTOLICAL": "of or like an epistle, also EPISTOLIC [adj]\n",
  "EPISTOLISE": "to write a letter, also EPISTOLIZE [v EPISTOLISED, EPISTOLISING, EPISTOLISES]\n",
  "EPISTOLISED": "EPISTOLISE, to write a letter, also EPISTOLIZE [v]\n",
  "EPISTOLISES": "EPISTOLISE, to write a letter, also EPISTOLIZE [v]\n",
  "EPISTOLISING": "EPISTOLISE, to write a letter, also EPISTOLIZE [v]\n",
  "EPISTOLIST": "one who writes epistles [n -S]\n",
  "EPISTOLISTS": "EPISTOLIST, one who writes epistles [n]\n",
  "EPISTOLIZE": "to write a letter, also EPISTOLISE [v EPISTOLIZED, EPISTOLIZING, EPISTOLIZES]\n",
  "EPISTOLIZED": "EPISTOLIZE, to write a letter, also EPISTOLISE [v]\n",
  "EPISTOLIZES": "EPISTOLIZE, to write a letter, also EPISTOLISE [v]\n",
  "EPISTOLIZING": "EPISTOLIZE, to write a letter, also EPISTOLISE [v]\n",
  "EPISTOLOGRAPHY": "letter-writing [n]\n",
  "EPISTOME": "a structure over the mouth of some invertebrates [n -S]\n",
  "EPISTOMES": "EPISTOME, a structure over the mouth of some invertebrates [n]\n",
  "EPISTROPHE": "the ending of successive clauses with the same word e.g. 'government of the people, by the people, for the people' [n -S]\n",
  "EPISTROPHES": "EPISTROPHE, the ending of successive clauses with the same word e.g. 'government of the people, by the people, for the people' [n]\n",
  "EPISTYLE": "a part of a classical building [n -S]\n",
  "EPISTYLES": "EPISTYLE, a part of a classical building [n]\n",
  "EPITAPH": "to compose an inscription on a tomb [v -ED, -ING, -S]\n",
  "EPITAPHED": "EPITAPH, to compose an inscription on a tomb [v]\n",
  "EPITAPHER": "a writer of epitaphs [n -S]\n",
  "EPITAPHERS": "EPITAPHER, a writer of epitaphs [n]\n",
  "EPITAPHIAL": "pertaining to an epitaph, also EPITAPHIAN, EPITAPHIC [adj]\n",
  "EPITAPHIAN": "pertaining to an epitaph, also EPITAPHIAL, EPITAPHIC [adj]\n",
  "EPITAPHIC": "pertaining to an epitaph, also EPITAPHIAL, EPITAPHIAN [adj]\n",
  "EPITAPHING": "EPITAPH, to compose an inscription on a tomb [v]\n",
  "EPITAPHIST": "an epitapher [n -S]\n",
  "EPITAPHISTS": "EPITAPHIST, an epitapher [n]\n",
  "EPITAPHS": "EPITAPH, to compose an inscription on a tomb [v]\n",
  "EPITASES": "EPITASIS, the part of the play developing the main action and leading to the catastrophe, also EPITAXIS [n]\n",
  "EPITASIS": "the part of the play developing the main action and leading to the catastrophe, also EPITAXIS [n EPITASES]\n",
  "EPITAXES": "EPITAXIS, the part of a play in which the main action develops, also EPITASIS [n]\n",
  "EPITAXIAL": "relating to epitaxy, the growth of a thin layer of crystals on another crystal so that they have the same structure, also EPITAXIC [adj EPITAXIALLY]\n",
  "EPITAXIALLY": "EPITAXIAL, relating to epitaxy, the growth of a thin layer of crystals on another crystal so that they have the same structure, also EPITAXIC [adv]\n",
  "EPITAXIC": "relating to epitaxy, the growth of a thin layer of crystals on another crystal so that they have the same structure, also EPITAXIAL [adj]\n",
  "EPITAXIES": "EPITAXY, the growth of a thin layer of crystals on another crystal so that they have the same structure [n]\n",
  "EPITAXIS": "the part of a play in which the main action develops, also EPITASIS [n EPITAXES]\n",
  "EPITAXY": "the growth of a thin layer of crystals on another crystal so that they have the same structure [n EPITAXIES]\n",
  "EPITHALAMIA": "EPITHALAMION, a poem or song in honor of a bride and bridegroom, also EPITHALAMIUM [n]\n",
  "EPITHALAMIC": "of or like an epithalamium [adj]\n",
  "EPITHALAMION": "a poem or song in honor of a bride and bridegroom, also EPITHALAMIUM [n EPITHALAMIA]\n",
  "EPITHALAMIUM": "a lyric ode in honor of a bride and bridegroom, also EPITHALAMION [n -S]\n",
  "EPITHALAMIUMS": "EPITHALAMIUM, a lyric ode in honor of a bride and bridegroom, also EPITHALAMION [n]\n",
  "EPITHECA": "the outer older cell layer of a diatom [n EPITHECAE]\n",
  "EPITHECAE": "EPITHECA, the outer older cell layer of a diatom [n]\n",
  "EPITHELIA": "EPITHELIUM, the outer skin and cover for most internal organs [n]\n",
  "EPITHELIAL": "of or pertaining to the epithelium, the outer skin and cover for most internal organs [adj]\n",
  "EPITHELIALISE": "to make epithelial, also EPITHELIALIZE [v EPITHELIALISED, EPITHELIALISING, EPITHELIALISES]\n",
  "EPITHELIALISED": "EPITHELIALISE, to make epithelial, also EPITHELIALIZE [v]\n",
  "EPITHELIALISES": "EPITHELIALISE, to make epithelial, also EPITHELIALIZE [v]\n",
  "EPITHELIALISING": "EPITHELIALISE, to make epithelial, also EPITHELIALIZE [v]\n",
  "EPITHELIALIZE": "to make epithelial, also EPITHELIALISE [v EPITHELIALIZED, EPITHELIALIZING, EPITHELIALIZES]\n",
  "EPITHELIALIZED": "EPITHELIALIZE, to make epithelial, also EPITHELIALISE [v]\n",
  "EPITHELIALIZES": "EPITHELIALIZE, to make epithelial, also EPITHELIALISE [v]\n",
  "EPITHELIALIZING": "EPITHELIALIZE, to make epithelial, also EPITHELIALISE [v]\n",
  "EPITHELIOID": "resembling epithelium [adj]\n",
  "EPITHELIOMA": "a tumour of the epithelium [n EPITHELIOMAS or EPITHELIOMATA]\n",
  "EPITHELIOMAS": "EPITHELIOMA, a tumour of the epithelium [n]\n",
  "EPITHELIOMATA": "EPITHELIOMA, a tumour of the epithelium [n]\n",
  "EPITHELIOMATOUS": "relating to epithelioma [adj]\n",
  "EPITHELISATION": "the process of epithelising, also EPITHELIZATION [n -S]\n",
  "EPITHELISATIONS": "EPITHELISATION, the process of epithelising, also EPITHELIZATION [n]\n",
  "EPITHELISE": "to convert to epithelium, also EPITHELIZE [v EPITHELISED, EPITHELISING, EPITHELISES]\n",
  "EPITHELISED": "EPITHELISE, to convert to epithelium, also EPITHELIZE [v]\n",
  "EPITHELISES": "EPITHELISE, to convert to epithelium, also EPITHELIZE [v]\n",
  "EPITHELISING": "EPITHELISE, to convert to epithelium, also EPITHELIZE [v]\n",
  "EPITHELIUM": "the outer skin and cover for most internal organs [n EPITHELIA or EPITHELIUMS]\n",
  "EPITHELIUMS": "EPITHELIUM, the outer skin and cover for most internal organs [n]\n",
  "EPITHELIZATION": "the act of epithelizing, also EPITHELISATION [n -S]\n",
  "EPITHELIZATIONS": "EPITHELIZATION, the act of epithelizing, also EPITHELISATION [n]\n",
  "EPITHELIZE": "to convert to epithelium, also EPITHELISE [v EPITHELIZED, EPITHELIZING, EPITHELIZES]\n",
  "EPITHELIZED": "EPITHELIZE, to convert to epithelium, also EPITHELISE [v]\n",
  "EPITHELIZES": "EPITHELIZE, to convert to epithelium, also EPITHELISE [v]\n",
  "EPITHELIZING": "EPITHELIZE, to convert to epithelium, also EPITHELISE [v]\n",
  "EPITHEM": "(Greek) a group of leaf cells which exude water, also EPITHEMA [n -S]\n",
  "EPITHEMA": "(Greek) a group of leaf cells which exude water, also EPITHEM [n EPITHEMATA]\n",
  "EPITHEMATA": "EPITHEMA, (Greek) a group of leaf cells which exude water, also EPITHEM [n]\n",
  "EPITHEMS": "EPITHEM, (Greek) a group of leaf cells which exude water, also EPITHEMA [n]\n",
  "EPITHERMAL": "having energy just above the level of thermal agitation [adj]\n",
  "EPITHESES": "EPITHESIS, the addition of one or more letters to a word [n]\n",
  "EPITHESIS": "the addition of one or more letters to a word [n EPITHESES]\n",
  "EPITHET": "an adjective or adjectival phrase, also APATHATON, EPITHETON [n -S] / to apply an epithet to [v -ED, -ING, -S]\n",
  "EPITHETED": "EPITHET, to apply an epithet to [v]\n",
  "EPITHETIC": "relating to an epithet, also EPITHETICAL [adj EPITHETICALLY]\n",
  "EPITHETICAL": "pertaining to, or abounding with, epithets [adj EPITHETICALLY]\n",
  "EPITHETICALLY": "EPITHETICAL, pertaining to, or abounding with, epithets [adv]\n",
  "EPITHETING": "EPITHET, to apply an epithet to [v]\n",
  "EPITHETON": "an epithet, also APATHATON, EPITHET [n -S]\n",
  "EPITHETONS": "EPITHETON, an epithet, also APATHATON, EPITHET [n]\n",
  "EPITHETS": "EPITHET, to apply an epithet to [v]\n",
  "EPITHYMETIC": "of or pertaining to desire [adj]\n",
  "EPITOME": "a typical example [n -S]\n",
  "EPITOMES": "EPITOME, a typical example [n]\n",
  "EPITOMIC": "of or like an epitome, also EPITOMICAL [adj]\n",
  "EPITOMICAL": "of or like an epitome, also EPITOMIC [adj]\n",
  "EPITOMISATION": "the process of epitomising, also EPITOMIZATION [n -S]\n",
  "EPITOMISATIONS": "EPITOMISATION, the process of epitomising, also EPITOMIZATION [n]\n",
  "EPITOMISE": "to make an epitome of; to shorten or abridge, also EPITOMIZE [v EPITOMISED, EPITOMISING, EPITOMISES]\n",
  "EPITOMISED": "EPITOMISE, to make an epitome of; to shorten or abridge, also EPITOMIZE [v]\n",
  "EPITOMISER": "one who epitomises, also EPITOMIST, EPITOMIZER [n -S]\n",
  "EPITOMISERS": "EPITOMISER, one who epitomises, also EPITOMIST, EPITOMIZER [n]\n",
  "EPITOMISES": "EPITOMISE, to make an epitome of; to shorten or abridge, also EPITOMIZE [v]\n",
  "EPITOMISING": "EPITOMISE, to make an epitome of; to shorten or abridge, also EPITOMIZE [v]\n",
  "EPITOMIST": "one who makes an epitome, also EPITOMIZER [n -S]\n",
  "EPITOMISTS": "EPITOMIST, one who makes an epitome, also EPITOMIZER [n]\n",
  "EPITOMIZATION": "the process of epitomizing, also EPITOMISATION [n -S]\n",
  "EPITOMIZATIONS": "EPITOMIZATION, the process of epitomizing, also EPITOMISATION [n]\n",
  "EPITOMIZE": "to make an epitome of; to shorten or abridge, also EPITOMISE [v EPITOMIZED, EPITOMIZING, EPITOMIZES]\n",
  "EPITOMIZED": "EPITOMIZE, to make an epitome of; to shorten or abridge, also EPITOMISE [v]\n",
  "EPITOMIZER": "one who makes an epitome, also EPITOMISER, EPITOMIST [n -S]\n",
  "EPITOMIZERS": "EPITOMIZER, one who makes an epitome, also EPITOMISER, EPITOMIST [n]\n",
  "EPITOMIZES": "EPITOMIZE, to make an epitome of; to shorten or abridge, also EPITOMISE [v]\n",
  "EPITOMIZING": "EPITOMIZE, to make an epitome of; to shorten or abridge, also EPITOMISE [v]\n",
  "EPITONIC": "overstrained [adj]\n",
  "EPITOPE": "a part of an antigen complementary to an antibody [n -S]\n",
  "EPITOPES": "EPITOPE, a part of an antigen complementary to an antibody [n]\n",
  "EPITRACHELION": "the stole of an Orthodox priest or bishop [n -S]\n",
  "EPITRACHELIONS": "EPITRACHELION, the stole of an Orthodox priest or bishop [n]\n",
  "EPITRITE": "a metrical foot consisting of three long syllables and one short syllable [n -S]\n",
  "EPITRITES": "EPITRITE, a metrical foot consisting of three long syllables and one short syllable [n]\n",
  "EPITROCHOID": "a curve like an epicycloid but generated by any point on a radius [n -S]\n",
  "EPITROCHOIDS": "EPITROCHOID, a curve like an epicycloid but generated by any point on a radius [n]\n",
  "EPIZEUXES": "EPIZEUXIS, the immediate repetition of a word for emphasis [n]\n",
  "EPIZEUXIS": "the immediate repetition of a word for emphasis [n EPIZEUXES or EPIZEUXISES]\n",
  "EPIZEUXISES": "EPIZEUXIS, the immediate repetition of a word for emphasis [n]\n",
  "EPIZOA": "EPIZOON, an animal that lives on the surface of another, esp. as a parasite, also EPIZOAN [n]\n",
  "EPIZOAN": "an animal that lives on the surface of another, esp. as a parasite, also EPIZOON [n -S]\n",
  "EPIZOANS": "EPIZOAN, an animal that lives on the surface of another, esp. as a parasite, also EPIZOON [n]\n",
  "EPIZOIC": "living on the body of an animal [adj]\n",
  "EPIZOISM": "the state of being epizoic, living on the outside of an animal [n -S]\n",
  "EPIZOISMS": "EPIZOISM, the state of being epizoic, living on the outside of an animal [n]\n",
  "EPIZOITE": "an epizoic organism [n -S]\n",
  "EPIZOITES": "EPIZOITE, an epizoic organism [n]\n",
  "EPIZOON": "an animal that lives on the surface of another, esp. as a parasite, also EPIZOAN [n EPIZOA]\n",
  "EPIZOOTIC": "of a disease, affecting many animals of one kind at the same time [adj EPIZOOTICALLY] / an epizootic disease [n -S]\n",
  "EPIZOOTICALLY": "EPIZOOTIC, of a disease, affecting many animals of one kind at the same time [adv]\n",
  "EPIZOOTICS": "EPIZOOTIC, an epizootic disease [n]\n",
  "EPIZOOTIES": "EPIZOOTY, a type of animal disease [n]\n",
  "EPIZOOTIOLOGIC": "relating to epizootiology [adj]\n",
  "EPIZOOTIOLOGIES": "EPIZOOTIOLOGY, the sum of the factors controlling the occurrence of a disease or pathogen of animals [n]\n",
  "EPIZOOTIOLOGY": "the sum of the factors controlling the occurrence of a disease or pathogen of animals [n EPIZOOTIOLOGIES]\n",
  "EPIZOOTY": "a type of animal disease [n EPIZOOTIES]\n",
  "EPOCH": "an important period of time, also EPOCHA [n -S]\n",
  "EPOCHA": "an important period of time, also EPOCH [n -S]\n",
  "EPOCHAL": "belonging to an epoch; of the nature of an epoch [adj EPOCHALLY]\n",
  "EPOCHALLY": "EPOCHAL, belonging to an epoch; of the nature of an epoch [adv]\n",
  "EPOCHAS": "EPOCHA, an important period of time, also EPOCH [n]\n",
  "EPOCHS": "EPOCH, an important period of time, also EPOCHA [n]\n",
  "EPODE": "a genre of lyric poem, in which a longer verse is followed by a shorter one [n -S]\n",
  "EPODES": "EPODE, a genre of lyric poem, in which a longer verse is followed by a shorter one [n]\n",
  "EPODIC": "relating to an epode, a kind of lyric poem [adj]\n",
  "EPONYCHIUM": "a narrow band of cuticle over the base of a nail [n -S]\n",
  "EPONYCHIUMS": "EPONYCHIUM, a narrow band of cuticle over the base of a nail [n]\n",
  "EPONYM": "a personal name from which another name is derived [n -S]\n",
  "EPONYMIC": "of, relating to, or being the person for whom something is believed to be named, also EPONYMOUS [adj]\n",
  "EPONYMIES": "EPONYMY, the derivation of an eponymic name [n]\n",
  "EPONYMOUS": "of, relating to, or being the person for whom something is believed to be named, also EPONYMIC [adj EPONYMOUSLY]\n",
  "EPONYMOUSLY": "EPONYMOUS, of, relating to, or being the person for whom something is believed to be named, also EPONYMIC [adv]\n",
  "EPONYMS": "EPONYM, a personal name from which another name is derived [n]\n",
  "EPONYMY": "the derivation of an eponymic name [n EPONYMIES]\n",
  "EPOPEE": "(French) an epic poem, also EPOPOEIA, EPOS [n -S]\n",
  "EPOPEES": "EPOPEE, (French) an epic poem, also EPOPOEIA, EPOS [n]\n",
  "EPOPOEIA": "(Greek) an epic poem, also EPOPEE, EPOS [n -S]\n",
  "EPOPOEIAS": "EPOPOEIA, (Greek) an epic poem, also EPOPEE, EPOS [n]\n",
  "EPOPT": "someone initiated into the Eleusian mysteries [n -S]\n",
  "EPOPTS": "EPOPT, someone initiated into the Eleusian mysteries [n]\n",
  "EPOS": "(Greek) an epic poem, also EPOPEE, EPOPOEIA [n -ES]\n",
  "EPOSES": "EPOS, (Greek) an epic poem, also EPOPEE, EPOPOEIA [n]\n",
  "EPOXIDATION": "a conversion of a usually unsaturated compound into an epoxide [n -S]\n",
  "EPOXIDATIONS": "EPOXIDATION, a conversion of a usually unsaturated compound into an epoxide [n]\n",
  "EPOXIDE": "an epoxy compound [n -S]\n",
  "EPOXIDES": "EPOXIDE, an epoxy compound [n]\n",
  "EPOXIDISE": "to convert into an epoxide, an epoxy compound, also EPOXIDIZE [v EPOXIDISED, EPOXIDISING, EPOXIDISES]\n",
  "EPOXIDISED": "EPOXIDISE, to convert into an epoxide, an epoxy compound, also EPOXIDIZE [v]\n",
  "EPOXIDISES": "EPOXIDISE, to convert into an epoxide, an epoxy compound, also EPOXIDIZE [v]\n",
  "EPOXIDISING": "EPOXIDISE, to convert into an epoxide, an epoxy compound, also EPOXIDIZE [v]\n",
  "EPOXIDIZE": "to convert into an epoxide, an epoxy compound, also EPOXIDISE [v EPOXIDIZED, EPOXIDIZING, EPOXIDIZES]\n",
  "EPOXIDIZED": "EPOXIDIZE, to convert into an epoxide, an epoxy compound, also EPOXIDISE [v]\n",
  "EPOXIDIZES": "EPOXIDIZE, to convert into an epoxide, an epoxy compound, also EPOXIDISE [v]\n",
  "EPOXIDIZING": "EPOXIDIZE, to convert into an epoxide, an epoxy compound, also EPOXIDISE [v]\n",
  "EPOXIED": "EPOXY, to glue with a type of resin [v]\n",
  "EPOXIES": "EPOXY, to glue with a type of resin [v]\n",
  "EPOXY": "to glue with a type of resin [v EPOXYED or EPOXIED, EPOXYING, EPOXIES]\n",
  "EPOXYED": "EPOXY, to glue with a type of resin [v]\n",
  "EPOXYING": "EPOXY, to glue with a type of resin [v]\n",
  "EPRIS": "(French) captivated or smitten (of a male) [adj]\n",
  "EPRISE": "(French) captivated or smitten (of a female) [adj]\n",
  "EPROUVETTE": "(French) an apparatus for testing or proving the strength of gunpowder [n -S]\n",
  "EPROUVETTES": "EPROUVETTE, (French) an apparatus for testing or proving the strength of gunpowder [n]\n",
  "EPSILON": "(Greek) a letter of the Greek alphabet [n -S]\n",
  "EPSILONIC": "relating to the Greek letter epsilon [adj]\n",
  "EPSILONS": "EPSILON, (Greek) a letter of the Greek alphabet [n]\n",
  "EPSOMITE": "a mineral, native sulphate of magnesia or Epsom salt [n -S]\n",
  "EPSOMITES": "EPSOMITE, a mineral, native sulphate of magnesia or Epsom salt [n]\n",
  "EPUISE": "(French) exhausted (of a male) [adj]\n",
  "EPUISEE": "(French) exhausted (of a female) [adj]\n",
  "EPULARY": "concerning feasting [adj]\n",
  "EPULATION": "feasting, indulging in fine food [n -S]\n",
  "EPULATIONS": "EPULATION, feasting, indulging in fine food [n]\n",
  "EPULIDES": "EPULIS, (Greek) a tumor of the gums [n]\n",
  "EPULIS": "(Greek) a tumor of the gums [n EPULISES or EPULIDES]\n",
  "EPULISES": "EPULIS, (Greek) a tumor of the gums [n]\n",
  "EPULOTIC": "a substance which aids the forming of scar-tissue [n -S]\n",
  "EPULOTICS": "EPULOTIC, a substance which aids the forming of scar-tissue [n]\n",
  "EPURATE": "to purify [v EPURATED, EPURATING, EPURATES]\n",
  "EPURATED": "EPURATE, to purify [v]\n",
  "EPURATES": "EPURATE, to purify [v]\n",
  "EPURATING": "EPURATE, to purify [v]\n",
  "EPURATION": "purification, esp. removal of officials or politicians believed to be disloyal [n -S]\n",
  "EPURATIONS": "EPURATION, purification, esp. removal of officials or politicians believed to be disloyal [n]\n",
  "EPYLLIA": "EPYLLION, (Greek) a shorter epic poem [n]\n",
  "EPYLLION": "(Greek) a shorter epic poem [n EPYLLIONS or EPYLLIA]\n",
  "EPYLLIONS": "EPYLLION, (Greek) a shorter epic poem [n]\n",
  "EQUABILITIES": "EQUABILITY, the state of being equable [n]\n",
  "EQUABILITY": "the state of being equable [n EQUABILITIES]\n",
  "EQUABLE": "smooth; without wide variations [adj EQUABLY]\n",
  "EQUABLENESS": "being equable [n -ES]\n",
  "EQUABLENESSES": "EQUABLENESS, being equable [n]\n",
  "EQUABLY": "EQUABLE, smooth; without wide variations [adv]\n",
  "EQUAL": "equivalent, also EGAL [adj EQUALLY] / to make equal [v EQUALED or EQUALLED, EQUALING or EQUALLING, EQUALS]\n",
  "EQUALED": "EQUAL, to make equal [v]\n",
  "EQUALI": "(Italian) pieces for a group of instruments of the same kind e.g. Beethoven's Equali for four trombones [n]\n",
  "EQUALING": "EQUAL, to make equal [v]\n",
  "EQUALISATION": "the act of equalising, also EQUALIZATION [n -S]\n",
  "EQUALISATIONS": "EQUALISATION, the act of equalising, also EQUALIZATION [n]\n",
  "EQUALISE": "to make equal, also EQUALIZE [v EQUALISED, EQUALISING, EQUALISES]\n",
  "EQUALISED": "EQUALISE, to make equal, also EQUALIZE [v]\n",
  "EQUALISER": "a goal that equalises, also EQUALIZER [n -S]\n",
  "EQUALISERS": "EQUALISER, a goal that equalises, also EQUALIZER [n]\n",
  "EQUALISES": "EQUALISE, to make equal, also EQUALIZE [v]\n",
  "EQUALISING": "EQUALISE, to make equal, also EQUALIZE [v]\n",
  "EQUALITARIAN": "an egalitarian [n -S]\n",
  "EQUALITARIANISM": "belief in equality [n]\n",
  "EQUALITARIANS": "EQUALITARIAN, an egalitarian [n]\n",
  "EQUALITIES": "EQUALITY, the state of being equal, also EGALITE, EGALITY [n]\n",
  "EQUALITY": "the state of being equal, also EGALITE, EGALITY [n EQUALITIES]\n",
  "EQUALIZATION": "the act of equalising, also EQUALISATION [n -S]\n",
  "EQUALIZATIONS": "EQUALIZATION, the act of equalising, also EQUALISATION [n]\n",
  "EQUALIZE": "to make equal, also EQUALISE [v EQUALIZED, EQUALIZING, EQUALIZES]\n",
  "EQUALIZED": "EQUALIZE, to make equal, also EQUALISE [v]\n",
  "EQUALIZER": "a goal that equalises, also EQUALISER [n -S]\n",
  "EQUALIZERS": "EQUALIZER, a goal that equalises, also EQUALISER [n]\n",
  "EQUALIZES": "EQUALIZE, to make equal, also EQUALISE [v]\n",
  "EQUALIZING": "EQUALIZE, to make equal, also EQUALISE [v]\n",
  "EQUALLED": "EQUAL, to make equal [v]\n",
  "EQUALLING": "EQUAL, to make equal [v]\n",
  "EQUALLY": "in an equal way, also EGALLY [adv]\n",
  "EQUALNESS": "equality; evenness [n -ES]\n",
  "EQUALNESSES": "EQUALNESS, equality; evenness [n]\n",
  "EQUALS": "EQUAL, to make equal [v]\n",
  "EQUANIMITIES": "EQUANIMITY, evenness of mind esp. under stress [n]\n",
  "EQUANIMITY": "evenness of mind esp. under stress [n EQUANIMITIES]\n",
  "EQUANIMOUS": "of an even, composed frame of mind [adj EQUANIMOUSLY]\n",
  "EQUANIMOUSLY": "EQUANIMOUS, of an even, composed frame of mind [adv]\n",
  "EQUANT": "(Latin) a geometric adjustment to explain planetary motion [n -S]\n",
  "EQUANTS": "EQUANT, (Latin) a geometric adjustment to explain planetary motion [n]\n",
  "EQUATABILITIES": "EQUATABILITY, the quality of being equatable [n]\n",
  "EQUATABILITY": "the quality of being equatable [n EQUATABILITIES]\n",
  "EQUATABLE": "that can be equated [adj]\n",
  "EQUATE": "to be regarded as equal [v EQUATED, EQUATING, EQUATES]\n",
  "EQUATED": "EQUATE, to be regarded as equal [v]\n",
  "EQUATES": "EQUATE, to be regarded as equal [v]\n",
  "EQUATING": "EQUATE, to be regarded as equal [v]\n",
  "EQUATION": "the act of making equal [n -S]\n",
  "EQUATIONAL": "relating to an equation [adj EQUATIONALLY]\n",
  "EQUATIONALLY": "EQUATIONAL, relating to an equation [adv]\n",
  "EQUATIONS": "EQUATION, the act of making equal [n]\n",
  "EQUATIVE": "in grammar, denoting identity or equivalence [adj]\n",
  "EQUATOR": "an imaginary circle round the middle of the earth [n -S]\n",
  "EQUATORIAL": "of, relating to, or located at the equator [adj EQUATORIALLY] / an equatorial telescope [n -S]\n",
  "EQUATORIALLY": "EQUATORIAL, of, relating to, or located at the equator [adv]\n",
  "EQUATORIALS": "EQUATORIAL, an equatorial telescope [n]\n",
  "EQUATORS": "EQUATOR, an imaginary circle round the middle of the earth [n]\n",
  "EQUATORWARD": "in the direction of the equator [adv]\n",
  "EQUERRIES": "EQUERRY, an official who attends the royal family [n]\n",
  "EQUERRY": "an official who attends the royal family [n EQUERRIES]\n",
  "EQUES": "(Latin) a member of the privileged military class of ancient Rome [n EQUITES]\n",
  "EQUESTRIAN": "one who rides on horseback [n -S]\n",
  "EQUESTRIANISM": "horsemanship [n -S]\n",
  "EQUESTRIANISMS": "EQUESTRIANISM, horsemanship [n]\n",
  "EQUESTRIANS": "EQUESTRIAN, one who rides on horseback [n]\n",
  "EQUESTRIENNE": "a girl or woman who rides on horseback [n -S]\n",
  "EQUESTRIENNES": "EQUESTRIENNE, a girl or woman who rides on horseback [n]\n",
  "EQUIANGULAR": "having equal angles [adj]\n",
  "EQUIANGULARITY": "the state of being equiangular [n]\n",
  "EQUIBALANCE": "equipoise [n -S] / to balance equally [v EQUIBALANCED, EQUIBALANCING, EQUIBALANCES]\n",
  "EQUIBALANCED": "EQUIBALANCE, to balance equally [v]\n",
  "EQUIBALANCES": "EQUIBALANCE, to balance equally [v]\n",
  "EQUIBALANCING": "EQUIBALANCE, to balance equally [v]\n",
  "EQUICALORIC": "capable of yielding equal amounts of energy in the body [adj]\n",
  "EQUID": "(Latin) any member of the horse family [n -S]\n",
  "EQUIDIFFERENT": "having equal differences [adj]\n",
  "EQUIDISTANCE": "equality of distance [n -S]\n",
  "EQUIDISTANCES": "EQUIDISTANCE, equality of distance [n]\n",
  "EQUIDISTANT": "equally distant [adj EQUIDISTANTLY]\n",
  "EQUIDISTANTLY": "EQUIDISTANT, equally distant [adv]\n",
  "EQUIDS": "EQUID, (Latin) any member of the horse family [n]\n",
  "EQUIFINAL": "having the same result [adj EQUIFINALLY]\n",
  "EQUIFINALLY": "EQUIFINAL, having the same result [adv]\n",
  "EQUILATERAL": "having all sides equal [adj EQUILATERALLY] / a shape with all sides equal [n -S]\n",
  "EQUILATERALLY": "EQUILATERAL, having all sides equal [adv]\n",
  "EQUILATERALS": "EQUILATERAL, a shape with all sides equal [n]\n",
  "EQUILIBRANT": "a force that will balance one or more unbalanced forces [n -S]\n",
  "EQUILIBRANTS": "EQUILIBRANT, a force that will balance one or more unbalanced forces [n]\n",
  "EQUILIBRATE": "to bring into or keep in equilibrium [v EQUILIBRATED, EQUILIBRATING, EQUILIBRATES]\n",
  "EQUILIBRATED": "EQUILIBRATE, to bring into or keep in equilibrium [v]\n",
  "EQUILIBRATES": "EQUILIBRATE, to bring into or keep in equilibrium [v]\n",
  "EQUILIBRATING": "EQUILIBRATE, to bring into or keep in equilibrium [v]\n",
  "EQUILIBRATION": "the act of equilibrating [n -S]\n",
  "EQUILIBRATIONS": "EQUILIBRATION, the act of equilibrating [n]\n",
  "EQUILIBRATOR": "one who equilibrates [n -S]\n",
  "EQUILIBRATORS": "EQUILIBRATOR, one who equilibrates [n]\n",
  "EQUILIBRATORY": "relating to equilibration [adj]\n",
  "EQUILIBRIA": "EQUILIBRIUM, a state of intellectual or emotional balance [n]\n",
  "EQUILIBRIST": "a tightrope walker [n -S]\n",
  "EQUILIBRISTIC": "of or like an equilibrist [adj]\n",
  "EQUILIBRISTS": "EQUILIBRIST, a tightrope walker [n]\n",
  "EQUILIBRITIES": "EQUILIBRITY, the state of being in equilibrium [n]\n",
  "EQUILIBRITY": "the state of being in equilibrium [n EQUILIBRITIES]\n",
  "EQUILIBRIUM": "a state of intellectual or emotional balance [n EQUILIBRIUMS or EQUILIBRIA]\n",
  "EQUILIBRIUMS": "EQUILIBRIUM, a state of intellectual or emotional balance [n]\n",
  "EQUIMOLAL": "having an equal number of moles, also EQUIMOLAR [adj]\n",
  "EQUIMOLAR": "having an equal number of moles, also EQUIMOLAL [adj]\n",
  "EQUIMOLECULAR": "of substances, solutions, etc., containing equal numbers of molecules [adj]\n",
  "EQUIMULTIPLE": "a number multiplied by the same number as another [n -S]\n",
  "EQUIMULTIPLES": "EQUIMULTIPLE, a number multiplied by the same number as another [n]\n",
  "EQUINAL": "pertaining to horses [adj]\n",
  "EQUINE": "relating to horses, also EQUINAL [adj EQUINELY] / a member of the horse family [n -S]\n",
  "EQUINELY": "EQUINE, relating to horses, also EQUINAL [adv]\n",
  "EQUINES": "EQUINE, a member of the horse family [n]\n",
  "EQUINIA": "glanders, a contagious horse disease [n -S]\n",
  "EQUINIAS": "EQUINIA, glanders, a contagious horse disease [n]\n",
  "EQUINITIES": "EQUINITY, equine nature [n]\n",
  "EQUINITY": "equine nature [n EQUINITIES]\n",
  "EQUINOCTIAL": "relating to the equinox [adj EQUINOCTIALLY] / an equinoctial gale [n -S]\n",
  "EQUINOCTIALLY": "EQUINOCTIAL, relating to the equinox [adv]\n",
  "EQUINOCTIALS": "EQUINOCTIAL, an equinoctial gale [n]\n",
  "EQUINOX": "(Latin) the time when the sun crosses the equator [n -ES]\n",
  "EQUINOXES": "EQUINOX, (Latin) the time when the sun crosses the equator [n]\n",
  "EQUINUMEROUS": "having the same number of members [adj]\n",
  "EQUIP": "to provide with what is needed [v EQUIPPED, EQUIPPING, EQUIPS]\n",
  "EQUIPAGE": "(French) attendance, retinue [n -S] / to fit out with a retinue [v EQUIPAGED, EQUIPAGING, EQUIPAGES]\n",
  "EQUIPAGED": "EQUIPAGE, to fit out with a retinue [v]\n",
  "EQUIPAGES": "EQUIPAGE, to fit out with a retinue [v]\n",
  "EQUIPAGING": "EQUIPAGE, to fit out with a retinue [v]\n",
  "EQUIPARATE": "(obsolete) to regard or treat as equal [v EQUIPARATED, EQUIPARATING, EQUIPARATES]\n",
  "EQUIPARATED": "EQUIPARATE, (obsolete) to regard or treat as equal [v]\n",
  "EQUIPARATES": "EQUIPARATE, (obsolete) to regard or treat as equal [v]\n",
  "EQUIPARATING": "EQUIPARATE, (obsolete) to regard or treat as equal [v]\n",
  "EQUIPARATION": "equal treatment [n -S]\n",
  "EQUIPARATIONS": "EQUIPARATION, equal treatment [n]\n",
  "EQUIPARTITION": "the equal division of the energy of a system in thermal equilibrium between different degrees of freedom [n -S]\n",
  "EQUIPARTITIONS": "EQUIPARTITION, the equal division of the energy of a system in thermal equilibrium between different degrees of freedom [n]\n",
  "EQUIPE": "(French) in motor-racing and other sports, a team [n -S]\n",
  "EQUIPES": "EQUIPE, (French) in motor-racing and other sports, a team [n]\n",
  "EQUIPMENT": "things used in equipping [n -S]\n",
  "EQUIPMENTS": "EQUIPMENT, things used in equipping [n]\n",
  "EQUIPOISE": "to provide with a counterbalance [v EQUIPOISED, EQUIPOISING, EQUIPOISES]\n",
  "EQUIPOISED": "EQUIPOISE, to provide with a counterbalance [v]\n",
  "EQUIPOISES": "EQUIPOISE, to provide with a counterbalance [v]\n",
  "EQUIPOISING": "EQUIPOISE, to provide with a counterbalance [v]\n",
  "EQUIPOLLENCE": "the quality of being equipollent, also EQUIPOLLENCY [n -S]\n",
  "EQUIPOLLENCES": "EQUIPOLLENCE, the quality of being equipollent, also EQUIPOLLENCY [n]\n",
  "EQUIPOLLENCIES": "EQUIPOLLENCY, equality of force or power, also EQUIPOLLENCE [n]\n",
  "EQUIPOLLENCY": "equality of force or power, also EQUIPOLLENCE [n EQUIPOLLENCIES]\n",
  "EQUIPOLLENT": "having equal power or force [adj EQUIPOLLENTLY] / something of equal power [n -S]\n",
  "EQUIPOLLENTLY": "EQUIPOLLENT, having equal power or force [adv]\n",
  "EQUIPOLLENTS": "EQUIPOLLENT, something of equal power [n]\n",
  "EQUIPONDERANCE": "equality of weight or balance, also EQUIPONDERANCY [n -S]\n",
  "EQUIPONDERANCES": "EQUIPONDERANCE, equality of weight or balance, also EQUIPONDERANCY [n]\n",
  "EQUIPONDERANCY": "equality of weight or balance, also EQUIPONDERANCE [n]\n",
  "EQUIPONDERANT": "evenly balanced [adj]\n",
  "EQUIPONDERATE": "to be equal in weight; to balance [v EQUIPONDERATED, EQUIPONDERATES]\n",
  "EQUIPONDERATED": "EQUIPONDERATE, to be equal in weight; to balance [v]\n",
  "EQUIPONDERATES": "EQUIPONDERATE, to be equal in weight; to balance [v]\n",
  "EQUIPONDERATING": "EQUIPONDERATE, to be equal in weight; to balance [v]\n",
  "EQUIPOTENT": "of equal power [adj]\n",
  "EQUIPOTENTIAL": "having the same potential [adj] / an equipotential line or surface [n -S]\n",
  "EQUIPOTENTIALS": "EQUIPOTENTIAL, an equipotential line or surface [n]\n",
  "EQUIPPED": "EQUIP, to provide with what is needed [v]\n",
  "EQUIPPER": "one who equips [n -S]\n",
  "EQUIPPERS": "EQUIPPER, one who equips [n]\n",
  "EQUIPPING": "EQUIP, to provide with what is needed [v]\n",
  "EQUIPROBABILITY": "the quality of being equiprobable [n]\n",
  "EQUIPROBABLE": "having the same degree of logical or mathematical probability [adj]\n",
  "EQUIPS": "EQUIP, to provide with what is needed [v]\n",
  "EQUISETA": "EQUISETUM, (Latin) a plant, horsetail [n]\n",
  "EQUISETACEOUS": "pertaining to the horsetail family [adj]\n",
  "EQUISETIC": "of or relating to plants of the genus Equisetum, horsetails [adj]\n",
  "EQUISETIFORM": "having the form of an equisetum, a horsetail [adj]\n",
  "EQUISETUM": "(Latin) a plant, horsetail [n EQUISETA or EQUISETUMS]\n",
  "EQUISETUMS": "EQUISETUM, (Latin) a plant, horsetail [n]\n",
  "EQUITABILITIES": "EQUITABILITY, the state of being equitable [n]\n",
  "EQUITABILITY": "the state of being equitable [n EQUITABILITIES]\n",
  "EQUITABLE": "fair, just [adj EQUITABLY]\n",
  "EQUITABLENESS": "the state of being equitable [n -ES]\n",
  "EQUITABLENESSES": "EQUITABLENESS, the state of being equitable [n]\n",
  "EQUITABLY": "EQUITABLE, fair, just [adv]\n",
  "EQUITANT": "of leaves, folded lengthwise over succeeding leaves [adj]\n",
  "EQUITATION": "the act or art of riding on horseback [n -S]\n",
  "EQUITATIONS": "EQUITATION, the act or art of riding on horseback [n]\n",
  "EQUITES": "EQUES, (Latin) a member of the privileged military class of ancient Rome [n]\n",
  "EQUITIES": "EQUITY, fairness or impartiality [n]\n",
  "EQUITY": "fairness or impartiality [n EQUITIES]\n",
  "EQUIVALENCE": "the state or property of being equivalent, also EQUIVALENCY [n -S]\n",
  "EQUIVALENCES": "EQUIVALENCE, the state or property of being equivalent, also EQUIVALENCY [n]\n",
  "EQUIVALENCIES": "EQUIVALENCY, the state or property of being equivalent, also EQUIVALENCE [n]\n",
  "EQUIVALENCY": "the state or property of being equivalent, also EQUIVALENCE [n EQUIVALENCIES]\n",
  "EQUIVALENT": "equal in force, amount, or value [adj EQUIVALENTLY] / something equal [n -S]\n",
  "EQUIVALENTLY": "EQUIVALENT, equal in force, amount, or value [adv]\n",
  "EQUIVALENTS": "EQUIVALENT, something equal [n]\n",
  "EQUIVALVE": "having valves of similar size and form [adj]\n",
  "EQUIVOCACIES": "EQUIVOCACY, equivocal character [n]\n",
  "EQUIVOCACY": "equivocal character [n EQUIVOCACIES]\n",
  "EQUIVOCAL": "subject to two or more interpretations and usually used to mislead or confuse [adj EQUIVOCALLY]\n",
  "EQUIVOCALITIES": "EQUIVOCALITY, the state of being equivocal [n]\n",
  "EQUIVOCALITY": "the state of being equivocal [n EQUIVOCALITIES]\n",
  "EQUIVOCALLY": "EQUIVOCAL, subject to two or more interpretations and usually used to mislead or confuse [adv]\n",
  "EQUIVOCALNESS": "the state of being equivocal [n -ES]\n",
  "EQUIVOCALNESSES": "EQUIVOCALNESS, the state of being equivocal [n]\n",
  "EQUIVOCATE": "to use equivocal or doubtful words in order to mislead or to avoid answering a question [v EQUIVOCATED, EQUIVOCATING, EQUIVOCATES]\n",
  "EQUIVOCATED": "EQUIVOCATE, to use equivocal or doubtful words in order to mislead or to avoid answering a question [v]\n",
  "EQUIVOCATES": "EQUIVOCATE, to use equivocal or doubtful words in order to mislead or to avoid answering a question [v]\n",
  "EQUIVOCATING": "EQUIVOCATE, to use equivocal or doubtful words in order to mislead or to avoid answering a question [v]\n",
  "EQUIVOCATINGLY": "EQUIVOCATING, EQUIVOCATE, to use equivocal or doubtful words in order to mislead or to avoid answering a question [adv]\n",
  "EQUIVOCATION": "the use of equivocal or doubtful words [n -S]\n",
  "EQUIVOCATIONS": "EQUIVOCATION, the use of equivocal or doubtful words [n]\n",
  "EQUIVOCATOR": "one who equivocates [n -S]\n",
  "EQUIVOCATORS": "EQUIVOCATOR, one who equivocates [n]\n",
  "EQUIVOCATORY": "relating to equivocation [adj]\n",
  "EQUIVOKE": "an ambiguous term; a word susceptible of different significations, also EQUIVOQUE [n -S]\n",
  "EQUIVOKES": "EQUIVOKE, an ambiguous term; a word susceptible of different significations, also EQUIVOQUE [n]\n",
  "EQUIVOQUE": "an ambiguous term; a word susceptible of different significations, also EQUIVOKE [n -S]\n",
  "EQUIVOQUES": "EQUIVOQUE, an ambiguous term; a word susceptible of different significations, also EQUIVOKE [n]\n",
  "ER": "used to express hesitation [interj]\n",
  "ERA": "a main division of geological time [n -S]\n",
  "ERADIATE": "to shoot out like a ray of light [v ERADIATED, ERADIATING, ERADIATES]\n",
  "ERADIATED": "ERADIATE, to shoot out like a ray of light [v]\n",
  "ERADIATES": "ERADIATE, to shoot out like a ray of light [v]\n",
  "ERADIATING": "ERADIATE, to shoot out like a ray of light [v]\n",
  "ERADIATION": "emission of radiance [n -S]\n",
  "ERADIATIONS": "ERADIATION, emission of radiance [n]\n",
  "ERADICABLE": "that can be eradicated [adj ERADICABLY]\n",
  "ERADICABLY": "ERADICABLE, that can be eradicated [adv]\n",
  "ERADICANT": "something that eradicates [n -S]\n",
  "ERADICANTS": "ERADICANT, something that eradicates [n]\n",
  "ERADICATE": "to root out [v ERADICATED, ERADICATING, ERADICATES]\n",
  "ERADICATED": "ERADICATE, to root out [v]\n",
  "ERADICATES": "ERADICATE, to root out [v]\n",
  "ERADICATING": "ERADICATE, to root out [v]\n",
  "ERADICATION": "the act of eradicating [n -S]\n",
  "ERADICATIONS": "ERADICATION, the act of eradicating [n]\n",
  "ERADICATIVE": "serving to eradicate or drive thoroughly away [adj]\n",
  "ERADICATOR": "one who eradicates [n -S]\n",
  "ERADICATORS": "ERADICATOR, one who eradicates [n]\n",
  "ERAS": "ERA, a main division of geological time [n]\n",
  "ERASABILITIES": "ERASABILITY, the capacity to be erased [n]\n",
  "ERASABILITY": "the capacity to be erased [n ERASABILITIES]\n",
  "ERASABLE": "able to be erased [adj]\n",
  "ERASE": "to efface or rub out [v ERASED, ERASING, ERASES]\n",
  "ERASED": "ERASE, to efface or rub out [v]\n",
  "ERASEMENT": "the act of erasing; a rubbing out [n -S]\n",
  "ERASEMENTS": "ERASEMENT, the act of erasing; a rubbing out [n]\n",
  "ERASER": "one that erases [n -S]\n",
  "ERASERS": "ERASER, one that erases [n]\n",
  "ERASES": "ERASE, to efface or rub out [v]\n",
  "ERASING": "ERASE, to efface or rub out [v]\n",
  "ERASION": "the act of rubbing out [n -S]\n",
  "ERASIONS": "ERASION, the act of rubbing out [n]\n",
  "ERASURE": "the act of erasing [n -S]\n",
  "ERASURES": "ERASURE, the act of erasing [n]\n",
  "ERATHEM": "the stratigraphical unit of rock strata, corresponding to a geological era [n -S]\n",
  "ERATHEMS": "ERATHEM, the stratigraphical unit of rock strata, corresponding to a geological era [n]\n",
  "ERBIA": "(Swedish) erbium oxide [n -S]\n",
  "ERBIAS": "ERBIA, (Swedish) erbium oxide [n]\n",
  "ERBIUM": "(Swedish) a metallic element [n -S]\n",
  "ERBIUMS": "ERBIUM, (Swedish) a metallic element [n]\n",
  "ERE": "to plough [v ERED, ERING, ERES]\n",
  "ERECT": "upright [adj ERECTLY] / to build or raise up [v -ED, -ING, -S]\n",
  "ERECTABLE": "capable of being erected [adj]\n",
  "ERECTED": "ERECT, to build or raise up [v]\n",
  "ERECTER": "one that erects, also ERECTOR [n -S]\n",
  "ERECTERS": "ERECTER, one that erects, also ERECTOR [n]\n",
  "ERECTILE": "capable of being raised upright [adj]\n",
  "ERECTILITIES": "ERECTILITY, the state of being erectile [n]\n",
  "ERECTILITY": "the state of being erectile [n ERECTILITIES]\n",
  "ERECTING": "ERECT, to build or raise up [v]\n",
  "ERECTION": "the act of erecting [n -S]\n",
  "ERECTIONS": "ERECTION, the act of erecting [n]\n",
  "ERECTIVE": "tending to erect [adj]\n",
  "ERECTLY": "ERECT, upright [adv]\n",
  "ERECTNESS": "the state of being erect [n -ES]\n",
  "ERECTNESSES": "ERECTNESS, the state of being erect [n]\n",
  "ERECTOR": "one that erects, also ERECTER [n -S]\n",
  "ERECTORS": "ERECTOR, one that erects, also ERECTER [n]\n",
  "ERECTS": "ERECT, to build or raise up [v]\n",
  "ERED": "ERE, to plough [v]\n",
  "ERELONG": "before long; soon [adv]\n",
  "EREMACAUSES": "EREMACAUSIS, very slow oxidation [n]\n",
  "EREMACAUSIS": "very slow oxidation [n EREMACAUSES]\n",
  "EREMIC": "of deserts [adj]\n",
  "EREMITAL": "of or like an eremite, a hermit, esp. a religious recluse [adj]\n",
  "EREMITE": "a hermit, esp. a religious recluse [n -S]\n",
  "EREMITES": "EREMITE, a hermit, esp. a religious recluse [n]\n",
  "EREMITIC": "of or pertaining to an eremite, also EREMITICAL [adj]\n",
  "EREMITICAL": "of or pertaining to an eremite, also EREMITIC [adj]\n",
  "EREMITISH": "like an eremite, a hermit [adj]\n",
  "EREMITISM": "the state of a hermit [n -S]\n",
  "EREMITISMS": "EREMITISM, the state of a hermit [n]\n",
  "EREMURI": "EREMURUS, (Latin) a flower, the foxtail lily [n]\n",
  "EREMURUS": "(Latin) a flower, the foxtail lily [n EREMURI or EREMURUSES]\n",
  "EREMURUSES": "EREMURUS, (Latin) a flower, the foxtail lily [n]\n",
  "ERENOW": "before this time [adv]\n",
  "EREPSIN": "an enzyme of the small intestine [n -S]\n",
  "EREPSINS": "EREPSIN, an enzyme of the small intestine [n]\n",
  "ERES": "ERE, to plough [v]\n",
  "ERETHIC": "showing erethism, abnormal irritability [adj]\n",
  "ERETHISM": "abnormal irritability [n -S]\n",
  "ERETHISMIC": "relating to erethism, abnormal irritability [adj]\n",
  "ERETHISMS": "ERETHISM, abnormal irritability [n]\n",
  "ERETHISTIC": "causing erethism, abnormal irritability, also ERETHITIC [adj]\n",
  "ERETHITIC": "causing erethism, abnormal irritability, also ERETHISTIC [adj]\n",
  "EREV": "(Hebrew) the day before a Jewish special day [n EREVS]\n",
  "EREVS": "EREV, (Hebrew) the day before a Jewish special day [n]\n",
  "EREWHILE": "some time ago [adv]\n",
  "EREWHILES": "(archaic) some time ago, heretofore, also EREWHILE [adv]\n",
  "ERF": "(South African) in South Africa, a garden plot [n ERVEN]\n",
  "ERG": "a unit of work [n -S] / a Saharan area of shifting sands [n AREG]\n",
  "ERGASTIC": "pertaining to byproducts of protoplasmic activity [adj]\n",
  "ERGASTOPLASM": "ribosome-studded endoplasmic reticulum [n -S]\n",
  "ERGASTOPLASMIC": "relating to ergastoplasm [adj]\n",
  "ERGASTOPLASMS": "ERGASTOPLASM, ribosome-studded endoplasmic reticulum [n]\n",
  "ERGATANDROMORPH": "an ant combining characteristics of males and workers [n]\n",
  "ERGATANER": "a worker-like wingless male ant [n -S]\n",
  "ERGATANERS": "ERGATANER, a worker-like wingless male ant [n]\n",
  "ERGATE": "a worker ant, an undeveloped female [n -S]\n",
  "ERGATES": "ERGATE, a worker ant, an undeveloped female [n]\n",
  "ERGATIVE": "a certain grammatical inflection [n -S]\n",
  "ERGATIVES": "ERGATIVE, a certain grammatical inflection [n]\n",
  "ERGATIVITIES": "ERGATIVITY, the state of being ergative, a grammatical case found in certain languages [n]\n",
  "ERGATIVITY": "the state of being ergative, a grammatical case found in certain languages [n ERGATIVITIES]\n",
  "ERGATOCRACIES": "ERGATOCRACY, government by the workers or the working class [n]\n",
  "ERGATOCRACY": "government by the workers or the working class [n ERGATOCRACIES]\n",
  "ERGATOGYNE": "a worker-like wingless female ant [n -S]\n",
  "ERGATOGYNES": "ERGATOGYNE, a worker-like wingless female ant [n]\n",
  "ERGATOID": "a wingless but sexually perfect worker [n -S]\n",
  "ERGATOIDS": "ERGATOID, a wingless but sexually perfect worker [n]\n",
  "ERGATOMORPH": "an ergatoid ant [n -S]\n",
  "ERGATOMORPHIC": "of or like an ergatomorph, an ergatoid ant [adj]\n",
  "ERGATOMORPHS": "ERGATOMORPH, an ergatoid ant [n]\n",
  "ERGO": "(short for) ergometer [n -S]\n",
  "ERGODIC": "of or relating to the probability that in a system any state will occur again [adj]\n",
  "ERGODICITIES": "ERGODICITY, the state of being ergodic, relating to the probability that in a system any state will occur again [n]\n",
  "ERGODICITY": "the state of being ergodic, relating to the probability that in a system any state will occur again [n ERGODICITIES]\n",
  "ERGOGENIC": "enhancing physical performance e.g. of a protein supplement [adj]\n",
  "ERGOGRAM": "a record made by an ergograph, an instrument for measuring and recording muscular work [n -S]\n",
  "ERGOGRAMS": "ERGOGRAM, a record made by an ergograph, an instrument for measuring and recording muscular work [n]\n",
  "ERGOGRAPH": "an instrument for measuring and recording muscular work [n -S]\n",
  "ERGOGRAPHS": "ERGOGRAPH, an instrument for measuring and recording muscular work [n]\n",
  "ERGOMANIA": "excessive desire to work [n -S]\n",
  "ERGOMANIAC": "one who suffers from ergomania, excessive desire to work [n -S]\n",
  "ERGOMANIACS": "ERGOMANIAC, one who suffers from ergomania, excessive desire to work [n]\n",
  "ERGOMANIAS": "ERGOMANIA, excessive desire to work [n]\n",
  "ERGOMETER": "an instrument for measuring work performed [n -S]\n",
  "ERGOMETERS": "ERGOMETER, an instrument for measuring work performed [n]\n",
  "ERGOMETRIC": "relating to measurement made by an ergometer, an instrument for measuring work performed [adj]\n",
  "ERGOMETRIES": "ERGOMETRY, the measurement of work done [n]\n",
  "ERGOMETRY": "the measurement of work done [n ERGOMETRIES]\n",
  "ERGON": "(Greek) work or business [n -S]\n",
  "ERGONOMIC": "of or pertaining to ergonomics; (designed to be) conducive to efficient use [adj ERGONOMICALLY]\n",
  "ERGONOMICALLY": "ERGONOMIC, of or pertaining to ergonomics; (designed to be) conducive to efficient use [adv]\n",
  "ERGONOMICS": "the study of people at work [n]\n",
  "ERGONOMIST": "one who engages in ergonomics, the study of people at work [n -S]\n",
  "ERGONOMISTS": "ERGONOMIST, one who engages in ergonomics, the study of people at work [n]\n",
  "ERGONOVINE": "an alkaloid derived from ergot used in the treatment of migraines [n -S]\n",
  "ERGONOVINES": "ERGONOVINE, an alkaloid derived from ergot used in the treatment of migraines [n]\n",
  "ERGONS": "ERGON, (Greek) work or business [n]\n",
  "ERGOPHOBIA": "a morbid fear of work [n -S]\n",
  "ERGOPHOBIAS": "ERGOPHOBIA, a morbid fear of work [n]\n",
  "ERGOS": "ERGO, (short for) ergometer [n]\n",
  "ERGOSTEROL": "a chemical substance in the body developing into vitamin D on exposure [n -S]\n",
  "ERGOSTEROLS": "ERGOSTEROL, a chemical substance in the body developing into vitamin D on exposure [n]\n",
  "ERGOT": "a fungal disease of grasses [n -S]\n",
  "ERGOTAMINE": "an alkaloid from ergot used in the treatment of migraine [n -S]\n",
  "ERGOTAMINES": "ERGOTAMINE, an alkaloid from ergot used in the treatment of migraine [n]\n",
  "ERGOTIC": "pertaining to, or derived from, ergot; as, ergotic acid [adj]\n",
  "ERGOTISE": "to affect with ergot, also ERGOTIZE [v ERGOTISED, ERGOTISING, ERGOTISES]\n",
  "ERGOTISED": "ERGOTISE, to affect with ergot, also ERGOTIZE [v]\n",
  "ERGOTISES": "ERGOTISE, to affect with ergot, also ERGOTIZE [v]\n",
  "ERGOTISING": "ERGOTISE, to affect with ergot, also ERGOTIZE [v]\n",
  "ERGOTISM": "poisoning by eating ergot-infected grain [n -S]\n",
  "ERGOTISMS": "ERGOTISM, poisoning by eating ergot-infected grain [n]\n",
  "ERGOTIZE": "to affect with ergot, also ERGOTISE [v ERGOTIZED, ERGOTIZING, ERGOTIZES]\n",
  "ERGOTIZED": "ERGOTIZE, to affect with ergot, also ERGOTISE [v]\n",
  "ERGOTIZES": "ERGOTIZE, to affect with ergot, also ERGOTISE [v]\n",
  "ERGOTIZING": "ERGOTIZE, to affect with ergot, also ERGOTISE [v]\n",
  "ERGOTS": "ERGOT, a fungal disease of grasses [n]\n",
  "ERGS": "ERG, a unit of work [n]\n",
  "ERHU": "(Chinese) a two-stringed musical instrument, played with a bow [n -S]\n",
  "ERHUS": "ERHU, (Chinese) a two-stringed musical instrument, played with a bow [n]\n",
  "ERIACH": "(Irish) a murderer's fine in old Irish law, also ERIC, ERICK [n -S]\n",
  "ERIACHS": "ERIACH, (Irish) a murderer's fine in old Irish law, also ERIC, ERICK [n]\n",
  "ERIC": "(Irish) a murderer's fine in old Irish law, also ERIACH, ERICK [n -S]\n",
  "ERICA": "(Latin) a shrub of the heath family [n -S]\n",
  "ERICACEOUS": "belonging to the heath family [adj]\n",
  "ERICAS": "ERICA, (Latin) a shrub of the heath family [n]\n",
  "ERICK": "(Irish) a murderer's fine in old Irish law, also ERIC, ERIACH [n -S]\n",
  "ERICKS": "ERICK, (Irish) a murderer's fine in old Irish law, also ERIC, ERIACH [n]\n",
  "ERICOID": "with heather-like leaves [adj]\n",
  "ERICS": "ERIC, (Irish) a murderer's fine in old Irish law, also ERIACH, ERICK [n]\n",
  "ERIGERON": "(Greek) a plant of the genus Erigeron, fleabanes [n -S]\n",
  "ERIGERONS": "ERIGERON, (Greek) a plant of the genus Erigeron, fleabanes [n]\n",
  "ERINACEOUS": "of, relating to, or resembling hedgehogs [adj]\n",
  "ERING": "ERE, to plough [v]\n",
  "ERINGO": "(Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERYNGIUM, ERYNGO [n ERINGOES or ERINGOS]\n",
  "ERINGOES": "ERINGO, (Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERYNGIUM, ERYNGO [n]\n",
  "ERINGOS": "ERINGO, (Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERYNGIUM, ERYNGO [n]\n",
  "ERINITE": "a basic arsenate of copper [n -S]\n",
  "ERINITES": "ERINITE, a basic arsenate of copper [n]\n",
  "ERINUS": "any rock plant of the genus Erinus [n -ES]\n",
  "ERINUSES": "ERINUS, any rock plant of the genus Erinus [n]\n",
  "ERIOMETER": "an instrument for measuring very small diameters [n -S]\n",
  "ERIOMETERS": "ERIOMETER, an instrument for measuring very small diameters [n]\n",
  "ERIONITE": "a mineral which occurs in white woollike crystals [n -S]\n",
  "ERIONITES": "ERIONITE, a mineral which occurs in white woollike crystals [n]\n",
  "ERIOPHOROUS": "very cottony [adj]\n",
  "ERIOPHORUM": "a plant of the cotton-grass genus [n -S]\n",
  "ERIOPHORUMS": "ERIOPHORUM, a plant of the cotton-grass genus [n]\n",
  "ERIOPHYID": "any of a large family of minute plant-feeding mites [n -S]\n",
  "ERIOPHYIDS": "ERIOPHYID, any of a large family of minute plant-feeding mites [n]\n",
  "ERIOSTEMON": "an Australian shrub [n -S]\n",
  "ERIOSTEMONS": "ERIOSTEMON, an Australian shrub [n]\n",
  "ERISTIC": "pertaining to dispute, argument or controversy, also ERISTICAL [adj ERISTICALLY] / a disputant [n -S]\n",
  "ERISTICAL": "pertaining to dispute, argument or controversy, also ERISTIC [adj ERISTICALLY]\n",
  "ERISTICALLY": "ERISTICAL, pertaining to dispute, argument or controversy, also ERISTIC [adv]\n",
  "ERISTICS": "ERISTIC, a disputant [n]\n",
  "ERK": "(slang) an aircraftsman [n -S]\n",
  "ERKS": "ERK, (slang) an aircraftsman [n]\n",
  "ERLANG": "a unit of traffic intensity in a telephone system [n -S]\n",
  "ERLANGS": "ERLANG, a unit of traffic intensity in a telephone system [n]\n",
  "ERLKING": "(German) a spirit that does mischief or evil, esp. to children [n -S]\n",
  "ERLKINGS": "ERLKING, (German) a spirit that does mischief or evil, esp. to children [n]\n",
  "ERM": "expressing hesitation or doubt [interj]\n",
  "ERMELIN": "(archaic) ermine [n -S]\n",
  "ERMELINS": "ERMELIN, (archaic) ermine [n]\n",
  "ERMINE": "the stoat; a white fur, the stoat's winter coat in northern lands, also ERMELIN [n -S]\n",
  "ERMINED": "trimmed with ermine [adj]\n",
  "ERMINES": "ERMINE, the stoat; a white fur, the stoat's winter coat in northern lands, also ERMELIN [n]\n",
  "ERN": "(Milton) to earn [v -ED, -ING, -S]\n",
  "ERNE": "an eagle, esp. a long-winged sea eagle with a short white wedge-shaped tail [n -S]\n",
  "ERNED": "ERN, (Milton) to earn [v]\n",
  "ERNES": "ERNE, an eagle, esp. a long-winged sea eagle with a short white wedge-shaped tail [n]\n",
  "ERNING": "ERN, (Milton) to earn [v]\n",
  "ERNS": "ERN, (Milton) to earn [v]\n",
  "ERODABLE": "that can be eroded, also ERODIBLE, EROSIBLE [adj]\n",
  "ERODE": "to wear away [v ERODED, ERODING, ERODES]\n",
  "ERODED": "ERODE, to wear away [v]\n",
  "ERODENT": "a caustic chemical [n -S]\n",
  "ERODENTS": "ERODENT, a caustic chemical [n]\n",
  "ERODES": "ERODE, to wear away [v]\n",
  "ERODIBILITIES": "ERODIBILITY, the capacity to be eroded [n]\n",
  "ERODIBILITY": "the capacity to be eroded [n ERODIBILITIES]\n",
  "ERODIBLE": "that can be eroded, also ERODABLE, EROSIBLE [adj]\n",
  "ERODING": "ERODE, to wear away [v]\n",
  "ERODIUM": "(Greek) a plant of the geranium family [n -S]\n",
  "ERODIUMS": "ERODIUM, (Greek) a plant of the geranium family [n]\n",
  "EROGENEITIES": "EROGENEITY, the state of being erogenous [n]\n",
  "EROGENEITY": "the state of being erogenous [n EROGENEITIES]\n",
  "EROGENIC": "producing erotic desire or gratification [adj]\n",
  "EROGENOUS": "producing erotic desire or gratification [adj]\n",
  "EROS": "(Greek) the sum of the self-preservative, as opposed to self-destructive, instincts [n -ES]\n",
  "EROSE": "irregularly notched as if bitten [adj]\n",
  "EROSELY": "EROSE, irregularly notched as if bitten [adv]\n",
  "EROSES": "EROS, (Greek) the sum of the self-preservative, as opposed to self-destructive, instincts [n]\n",
  "EROSIBLE": "that can be eroded, also ERODABLE, ERODIBLE [adj]\n",
  "EROSION": "the act of eroding [n -S]\n",
  "EROSIONAL": "relating or causing erosion [adj EROSIONALLY]\n",
  "EROSIONALLY": "EROSIONAL, relating or causing erosion [adv]\n",
  "EROSIONS": "EROSION, the act of eroding [n]\n",
  "EROSIVE": "causing erosion [adj]\n",
  "EROSIVENESS": "the state of being erosive [n -ES]\n",
  "EROSIVENESSES": "EROSIVENESS, the state of being erosive [n]\n",
  "EROSIVITIES": "EROSIVITY, the state of being erosive [n]\n",
  "EROSIVITY": "the state of being erosive [n EROSIVITIES]\n",
  "EROSTRATE": "without a beak [adj]\n",
  "EROTEMA": "(Greek) a rhetorical question, also EROTEME, EROTESIS [n -S]\n",
  "EROTEMAS": "EROTEMA, (Greek) a rhetorical question, also EROTEME, EROTESIS [n]\n",
  "EROTEME": "(Greek) a rhetorical question, also EROTEMA, EROTESIS [n -S]\n",
  "EROTEMES": "EROTEME, (Greek) a rhetorical question, also EROTEMA, EROTESIS [n]\n",
  "EROTESES": "EROTESIS, (Greek) a rhetorical question, also EROTEMA, EROTEME [n]\n",
  "EROTESIS": "(Greek) a rhetorical question, also EROTEMA, EROTEME [n EROTESES]\n",
  "EROTETIC": "interrogatory [adj]\n",
  "EROTIC": "relating to sexual desire [adj EROTICALLY] / a person who is particularly susceptible to sexual arousal [n -S]\n",
  "EROTICA": "(Latin) erotic books, art etc. [n -S]\n",
  "EROTICAL": "of or pertaining to the passion of love [adj EROTICALLY]\n",
  "EROTICALLY": "EROTICAL, of or pertaining to the passion of love [adv]\n",
  "EROTICAS": "EROTICA, (Latin) erotic books, art etc. [n]\n",
  "EROTICISATION": "the process of eroticising, also EROTICIZATION [n -S]\n",
  "EROTICISATIONS": "EROTICISATION, the process of eroticising, also EROTICIZATION [n]\n",
  "EROTICISE": "to render erotic, also EROTICIZE [v EROTICISED, EROTICISING, EROTICISES]\n",
  "EROTICISED": "EROTICISE, to render erotic, also EROTICIZE [v]\n",
  "EROTICISES": "EROTICISE, to render erotic, also EROTICIZE [v]\n",
  "EROTICISING": "EROTICISE, to render erotic, also EROTICIZE [v]\n",
  "EROTICISM": "erotic quality [n -S]\n",
  "EROTICISMS": "EROTICISM, erotic quality [n]\n",
  "EROTICIST": "one of an amorous temperament or habit [n -S]\n",
  "EROTICISTS": "EROTICIST, one of an amorous temperament or habit [n]\n",
  "EROTICIZATION": "the process of eroticizing, also EROTICISATION [n -S]\n",
  "EROTICIZATIONS": "EROTICIZATION, the process of eroticizing, also EROTICISATION [n]\n",
  "EROTICIZE": "to render erotic, also EROTICISE [v EROTICIZED, EROTICIZING, EROTICIZES]\n",
  "EROTICIZED": "EROTICIZE, to render erotic, also EROTICISE [v]\n",
  "EROTICIZES": "EROTICIZE, to render erotic, also EROTICISE [v]\n",
  "EROTICIZING": "EROTICIZE, to render erotic, also EROTICISE [v]\n",
  "EROTICS": "EROTIC, a person who is particularly susceptible to sexual arousal [n]\n",
  "EROTISATION": "the act of erotising, also EROTIZATION [n -S]\n",
  "EROTISATIONS": "EROTISATION, the act of erotising, also EROTIZATION [n]\n",
  "EROTISE": "to give a sexual meaning to, also EROTIZE [v EROTISED, EROTISING, EROTISES]\n",
  "EROTISED": "EROTISE, to give a sexual meaning to, also EROTIZE [v]\n",
  "EROTISES": "EROTISE, to give a sexual meaning to, also EROTIZE [v]\n",
  "EROTISING": "EROTISE, to give a sexual meaning to, also EROTIZE [v]\n",
  "EROTISM": "sexual excitement [n -S]\n",
  "EROTISMS": "EROTISM, sexual excitement [n]\n",
  "EROTIZATION": "the act of erotizing, also EROTISATION [n -S]\n",
  "EROTIZATIONS": "EROTIZATION, the act of erotizing, also EROTISATION [n]\n",
  "EROTIZE": "to give a sexual meaning to, also EROTISE [v EROTIZED, EROTIZING, EROTIZES]\n",
  "EROTIZED": "EROTIZE, to give a sexual meaning to, also EROTISE [v]\n",
  "EROTIZES": "EROTIZE, to give a sexual meaning to, also EROTISE [v]\n",
  "EROTIZING": "EROTIZE, to give a sexual meaning to, also EROTISE [v]\n",
  "EROTOGENIC": "producing erotic desire or gratification [adj]\n",
  "EROTOGENOUS": "producing erotic desire or gratification [adj]\n",
  "EROTOLOGICAL": "related to erotology [adj]\n",
  "EROTOLOGIES": "EROTOLOGY, the study of erotic stimuli and sexual behaviour [n]\n",
  "EROTOLOGIST": "a student of erotology [n -S]\n",
  "EROTOLOGISTS": "EROTOLOGIST, a student of erotology [n]\n",
  "EROTOLOGY": "the study of erotic stimuli and sexual behaviour [n EROTOLOGIES]\n",
  "EROTOMANIA": "an unusually strong sexual desire [n -S]\n",
  "EROTOMANIAC": "one suffering from erotomania, an unusually strong sexual desire [n -S]\n",
  "EROTOMANIACS": "EROTOMANIAC, one suffering from erotomania, an unusually strong sexual desire [n]\n",
  "EROTOMANIAS": "EROTOMANIA, an unusually strong sexual desire [n]\n",
  "EROTOPHOBIA": "fear of sex [n -S]\n",
  "EROTOPHOBIAS": "EROTOPHOBIA, fear of sex [n]\n",
  "ERR": "to make a mistake [v -ED, -ING, -S]\n",
  "ERRABLE": "capable of erring [adj]\n",
  "ERRANCIES": "ERRANCY, an instance of erring [n]\n",
  "ERRANCY": "an instance of erring [n ERRANCIES]\n",
  "ERRAND": "a message or mission [n -S]\n",
  "ERRANDS": "ERRAND, a message or mission [n]\n",
  "ERRANT": "wandering [adj ERRANTLY] / a knight errant, a person who is errant [n -S]\n",
  "ERRANTLY": "ERRANT, wandering [adv]\n",
  "ERRANTRIES": "ERRANTRY, roaming around, looking for adventure [n]\n",
  "ERRANTRY": "roaming around, looking for adventure [n ERRANTRIES]\n",
  "ERRANTS": "ERRANT, a knight errant, a person who is errant [n]\n",
  "ERRATA": "a list of printing errors [n -S]\n",
  "ERRATAS": "ERRATA, a list of printing errors [n]\n",
  "ERRATIC": "wandering, also ERRATICAL [adj ERRATICALLY] / a boulder carried far from its origin by glacial action [n -S]\n",
  "ERRATICAL": "(archaic) erratic, also ERRATIC [adj ERRATICALLY]\n",
  "ERRATICALLY": "ERRATICAL, (archaic) erratic, also ERRATIC [adv]\n",
  "ERRATICISM": "the state of being erratic [n -S]\n",
  "ERRATICISMS": "ERRATICISM, the state of being erratic [n]\n",
  "ERRATICS": "ERRATIC, a boulder carried far from its origin by glacial action [n]\n",
  "ERRATUM": "(Latin) an error in writing or printing [n ERRATA]\n",
  "ERRED": "ERR, to make a mistake [v]\n",
  "ERRHINE": "an obsolete medicine, which caused sneezing as a treatment for nasal congestion [n -S]\n",
  "ERRHINES": "ERRHINE, an obsolete medicine, which caused sneezing as a treatment for nasal congestion [n]\n",
  "ERRING": "mistaken [adj ERRINGLY] / the act of erring [n -S]\n",
  "ERRINGLY": "ERRING, mistaken [adv]\n",
  "ERRINGS": "ERRING, the act of erring [n]\n",
  "ERRONEOUS": "wrong [adj ERRONEOUSLY]\n",
  "ERRONEOUSLY": "ERRONEOUS, wrong [adv]\n",
  "ERRONEOUSNESS": "ERRONEOUS, wrong [n]\n",
  "ERRONEOUSNESSES": "ERRONEOUSNESS, ERRONEOUS, wrong [n]\n",
  "ERROR": "a mistake [n -S]\n",
  "ERRORIST": "one holding a mistaken opinion [n -S]\n",
  "ERRORISTS": "ERRORIST, one holding a mistaken opinion [n]\n",
  "ERRORLESS": "without errors [adj]\n",
  "ERRORS": "ERROR, a mistake [n]\n",
  "ERRS": "ERR, to make a mistake [v]\n",
  "ERS": "a European vetch, also ERVIL [n -ES]\n",
  "ERSATZ": "(German) a substitute, usually artificial and inferior [n -ES]\n",
  "ERSATZES": "ERSATZ, (German) a substitute, usually artificial and inferior [n]\n",
  "ERSES": "ERS, a European vetch, also ERVIL [n]\n",
  "ERST": "formerly, also EARST [adv]\n",
  "ERSTWHILE": "former; in the past [adj]\n",
  "ERUBESCENCE": "a blush, also ERUBESCENCY [n -S]\n",
  "ERUBESCENCES": "ERUBESCENCE, a blush, also ERUBESCENCY [n]\n",
  "ERUBESCENCIES": "ERUBESCENCY, a blush, also ERUBESCENCE [n]\n",
  "ERUBESCENCY": "a blush, also ERUBESCENCE [n ERUBESCENCIES]\n",
  "ERUBESCENT": "growing red; blushing [adj]\n",
  "ERUBESCITE": "a reddish mineral, aka bornite [n -S]\n",
  "ERUBESCITES": "ERUBESCITE, a reddish mineral, aka bornite [n]\n",
  "ERUCIC": "as in erucic acid, a crystalline fatty acid [adj]\n",
  "ERUCIFORM": "like a caterpillar [adj]\n",
  "ERUCT": "to belch out, also ERUCTATE [v -ED, -ING, -S]\n",
  "ERUCTATE": "to belch out, also ERUCT [v ERUCTATED, ERUCTATING, ERUCTATES]\n",
  "ERUCTATED": "ERUCTATE, to belch out, also ERUCT [v]\n",
  "ERUCTATES": "ERUCTATE, to belch out, also ERUCT [v]\n",
  "ERUCTATING": "ERUCTATE, to belch out, also ERUCT [v]\n",
  "ERUCTATION": "an act or instance of belching, also RUCTATION [n -S]\n",
  "ERUCTATIONS": "ERUCTATION, an act or instance of belching, also RUCTATION [n]\n",
  "ERUCTATIVE": "tending to produce eructation [adj]\n",
  "ERUCTED": "ERUCT, to belch out, also ERUCTATE [v]\n",
  "ERUCTING": "ERUCT, to belch out, also ERUCTATE [v]\n",
  "ERUCTS": "ERUCT, to belch out, also ERUCTATE [v]\n",
  "ERUDITE": "learned [adj ERUDITELY] / a learned person [n -S]\n",
  "ERUDITELY": "ERUDITE, learned [adv]\n",
  "ERUDITENESS": "the state of being erudite [n -ES]\n",
  "ERUDITENESSES": "ERUDITENESS, the state of being erudite [n]\n",
  "ERUDITES": "ERUDITE, a learned person [n]\n",
  "ERUDITION": "learning [n -S]\n",
  "ERUDITIONS": "ERUDITION, learning [n]\n",
  "ERUGO": "(Latin) a green film that forms on copper, also AERUGO [n -S]\n",
  "ERUGOS": "ERUGO, (Latin) a green film that forms on copper, also AERUGO [n]\n",
  "ERUMPENT": "breaking or bursting out through the skin, as do certain fungus spores [adj]\n",
  "ERUPT": "to break out or through [v -ED, -ING, -S]\n",
  "ERUPTED": "ERUPT, to break out or through [v]\n",
  "ERUPTIBLE": "capable of undergoing eruption [adj]\n",
  "ERUPTING": "ERUPT, to break out or through [v]\n",
  "ERUPTION": "the action of a volcano [n -S]\n",
  "ERUPTIONAL": "eruptive [adj]\n",
  "ERUPTIONS": "ERUPTION, the action of a volcano [n]\n",
  "ERUPTIVE": "breaking out or bursting forth [adj ERUPTIVELY] / a type of rock [n -S]\n",
  "ERUPTIVELY": "ERUPTIVE, breaking out or bursting forth [adv]\n",
  "ERUPTIVENESS": "the state of being eruptive [n -ES]\n",
  "ERUPTIVENESSES": "ERUPTIVENESS, the state of being eruptive [n]\n",
  "ERUPTIVES": "ERUPTIVE, a type of rock [n]\n",
  "ERUPTIVITIES": "ERUPTIVITY, the state of being eruptive [n]\n",
  "ERUPTIVITY": "the state of being eruptive [n ERUPTIVITIES]\n",
  "ERUPTS": "ERUPT, to break out or through [v]\n",
  "ERUV": "(Hebrew) a designated region within which Jewish religious rules are relaxed [n ERUVS or ERUVIM or ERUVIN]\n",
  "ERUVIM": "ERUV, (Hebrew) a designated region within which Jewish religious rules are relaxed [n]\n",
  "ERUVIN": "ERUV, (Hebrew) a designated region within which Jewish religious rules are relaxed [n]\n",
  "ERUVS": "ERUV, (Hebrew) a designated region within which Jewish religious rules are relaxed [n]\n",
  "ERVALENTA": "lentil-meal, also REVALENTA [n -S]\n",
  "ERVALENTAS": "ERVALENTA, lentil-meal, also REVALENTA [n]\n",
  "ERVEN": "ERF, (South African) in South Africa, a garden plot [n]\n",
  "ERVIL": "a European vetch, also ERS [n -S]\n",
  "ERVILS": "ERVIL, a European vetch, also ERS [n]\n",
  "ERYNGIUM": "(Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERINGO, ERYNGO [n -S]\n",
  "ERYNGIUMS": "ERYNGIUM, (Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERINGO, ERYNGO [n]\n",
  "ERYNGO": "(Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERINGO, ERYNGIUM [n ERYNGOES or ERYNGOS]\n",
  "ERYNGOES": "ERYNGO, (Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERINGO, ERYNGIUM [n]\n",
  "ERYNGOS": "ERYNGO, (Greek) a plant of the genus Eryngium, sea holly, reputed to be an aphrodisiac, also ERINGO, ERYNGIUM [n]\n",
  "ERYSIPELAS": "a febrile disease accompanied with a diffused inflammation of the skin, aka St Anthony's Fire [n ERYSIPELASES]\n",
  "ERYSIPELASES": "ERYSIPELAS, a febrile disease accompanied with a diffused inflammation of the skin, aka St Anthony's Fire [n]\n",
  "ERYSIPELATOUS": "suffering from the skin disease erysipelas [adj]\n",
  "ERYSIPELOID": "an infective dermatitis mainly affecting the hands [n -S]\n",
  "ERYSIPELOIDS": "ERYSIPELOID, an infective dermatitis mainly affecting the hands [n]\n",
  "ERYTHEMA": "(Greek) a redness of the skin [n -S]\n",
  "ERYTHEMAL": "relating to erythema, redness of the skin, also ERYTHEMIC [adj]\n",
  "ERYTHEMAS": "ERYTHEMA, (Greek) a redness of the skin [n]\n",
  "ERYTHEMATIC": "relating to erythema, redness of the skin [adj]\n",
  "ERYTHEMATOUS": "showing erythema, redness of the skin [adj]\n",
  "ERYTHEMIC": "relating to erythema, redness of the skin, also ERYTHEMAL [adj]\n",
  "ERYTHORBATE": "a salt of erythorbic acid that is used in foods as an antioxidant [n -S]\n",
  "ERYTHORBATES": "ERYTHORBATE, a salt of erythorbic acid that is used in foods as an antioxidant [n]\n",
  "ERYTHORBIC": "as in erythorbic acid, a diastereoisomer of ascorbic acid [adj]\n",
  "ERYTHRAEMIA": "another name for the medical condition polycythaemia vera, also ERYTHREMIA [n -S]\n",
  "ERYTHRAEMIAS": "ERYTHRAEMIA, another name for the medical condition polycythaemia vera, also ERYTHREMIA [n]\n",
  "ERYTHREMIA": "another name for the medical condition polycythaemia vera, also ERYTHRAEMIA [n -S]\n",
  "ERYTHREMIAS": "ERYTHREMIA, another name for the medical condition polycythaemia vera, also ERYTHRAEMIA [n]\n",
  "ERYTHRINA": "a plant of the kaffirboom genus of tropical and subtropical trees with brilliant red flowers [n -S]\n",
  "ERYTHRINAS": "ERYTHRINA, a plant of the kaffirboom genus of tropical and subtropical trees with brilliant red flowers [n]\n",
  "ERYTHRISM": "a condition of excessive redness [n -S]\n",
  "ERYTHRISMAL": "suffering from erythrism, also ERYTHRISTIC [adj]\n",
  "ERYTHRISMS": "ERYTHRISM, a condition of excessive redness [n]\n",
  "ERYTHRISTIC": "suffering from erythrism, also ERYTHRISMAL [adj]\n",
  "ERYTHRITE": "a reddish hydrous arsenate of cobalt [n -S]\n",
  "ERYTHRITES": "ERYTHRITE, a reddish hydrous arsenate of cobalt [n]\n",
  "ERYTHRITIC": "of or like erythrite, a reddish hydrous arsenate of cobalt [adj]\n",
  "ERYTHRITOL": "a sweet crystalline compound extracted from certain algae and lichens and used in medicine to dilate the blood vessels of the heart [n -S]\n",
  "ERYTHRITOLS": "ERYTHRITOL, a sweet crystalline compound extracted from certain algae and lichens and used in medicine to dilate the blood vessels of the heart [n]\n",
  "ERYTHROBLAST": "a cell in bone marrow that develops into an erythrocyte [n -S]\n",
  "ERYTHROBLASTIC": "of or like an erythroblast [adj]\n",
  "ERYTHROBLASTS": "ERYTHROBLAST, a cell in bone marrow that develops into an erythrocyte [n]\n",
  "ERYTHROCYTE": "a red blood corpuscle [n -S]\n",
  "ERYTHROCYTES": "ERYTHROCYTE, a red blood corpuscle [n]\n",
  "ERYTHROCYTIC": "of or like an erythrocyte, a red blood corpuscle [adj]\n",
  "ERYTHROID": "of a red color [adj]\n",
  "ERYTHROMELALGIA": "a state of excessive dilation of the superficial blood vessels of the feet or hands [n]\n",
  "ERYTHROMYCIN": "a broad-spectrum antibiotic produced by an actinomycete and administered orally or topically [n -S]\n",
  "ERYTHROMYCINS": "ERYTHROMYCIN, a broad-spectrum antibiotic produced by an actinomycete and administered orally or topically [n]\n",
  "ERYTHRON": "a bodily organ consisting of the red blood cells [n -S]\n",
  "ERYTHRONIUM": "any plant of the bulbous genus Erythronium, with decoratively mottled leaves and cyclamen-like flowers [n -S]\n",
  "ERYTHRONIUMS": "ERYTHRONIUM, any plant of the bulbous genus Erythronium, with decoratively mottled leaves and cyclamen-like flowers [n]\n",
  "ERYTHRONS": "ERYTHRON, a bodily organ consisting of the red blood cells [n]\n",
  "ERYTHROPENIA": "diminution below the normal of the number of red cells in the blood [n -S]\n",
  "ERYTHROPENIAS": "ERYTHROPENIA, diminution below the normal of the number of red cells in the blood [n]\n",
  "ERYTHROPHOBIA": "an aversion to the color red; an extreme fear of blushing [n -S]\n",
  "ERYTHROPHOBIAS": "ERYTHROPHOBIA, an aversion to the color red; an extreme fear of blushing [n]\n",
  "ERYTHROPOIESES": "ERYTHROPOIESIS, the making of red blood cells [n]\n",
  "ERYTHROPOIESIS": "the making of red blood cells [n ERYTHROPOIESES]\n",
  "ERYTHROPOIETIC": "relating to erythropoiesis, the making of red blood cells [adj]\n",
  "ERYTHROPOIETIN": "a glycoprotein hormone that stimulates the production of red blood cells by stem cells in bone marrow [n -S]\n",
  "ERYTHROPOIETINS": "ERYTHROPOIETIN, a glycoprotein hormone that stimulates the production of red blood cells by stem cells in bone marrow [n]\n",
  "ERYTHROPSIA": "a defect of vision in which objects appear red [n -S]\n",
  "ERYTHROPSIAS": "ERYTHROPSIA, a defect of vision in which objects appear red [n]\n",
  "ERYTHROSIN": "a red substance formed by the oxidation of tyrosine, also ERYTHROSINE [n -S]\n",
  "ERYTHROSINE": "a red substance formed by the oxidation of tyrosine, also ERYTHROSIN [n -S]\n",
  "ERYTHROSINES": "ERYTHROSINE, a red substance formed by the oxidation of tyrosine, also ERYTHROSIN [n]\n",
  "ERYTHROSINS": "ERYTHROSIN, a red substance formed by the oxidation of tyrosine, also ERYTHROSINE [n]\n",
  "ES": "the letter S, also ESS [n -ES]\n",
  "ESCABECHE": "pickled vegetables such as onions, carrots, jalapeno peppers and garlic, typically served with fish [n -S]\n",
  "ESCABECHES": "ESCABECHE, pickled vegetables such as onions, carrots, jalapeno peppers and garlic, typically served with fish [n]\n",
  "ESCADRILLE": "(French) a squadron of aircraft; a flotilla [n -S]\n",
  "ESCADRILLES": "ESCADRILLE, (French) a squadron of aircraft; a flotilla [n]\n",
  "ESCALADE": "(French) to scale the walls of a fortress by ladders, also ESCALADO, SCALADE, SCALADO [v ESCALADED, ESCALADING, ESCALADES]\n",
  "ESCALADED": "ESCALADE, (French) to scale the walls of a fortress by ladders, also ESCALADO, SCALADE, SCALADO [v]\n",
  "ESCALADER": "one who escalades, scales fortress walls by means of ladders [n -S]\n",
  "ESCALADERS": "ESCALADER, one who escalades, scales fortress walls by means of ladders [n]\n",
  "ESCALADES": "ESCALADE, (French) to scale the walls of a fortress by ladders, also ESCALADO, SCALADE, SCALADO [v]\n",
  "ESCALADING": "ESCALADE, (French) to scale the walls of a fortress by ladders, also ESCALADO, SCALADE, SCALADO [v]\n",
  "ESCALADO": "(French) the scaling of walls of a fortress by ladders, also ESCALADE, SCALADE, SCALADO [n -ES]\n",
  "ESCALADOES": "ESCALADO, (French) the scaling of walls of a fortress by ladders, also ESCALADE, SCALADE, SCALADO [n]\n",
  "ESCALATE": "to increase [v ESCALATED, ESCALATING, ESCALATES]\n",
  "ESCALATED": "ESCALATE, to increase [v]\n",
  "ESCALATES": "ESCALATE, to increase [v]\n",
  "ESCALATING": "ESCALATE, to increase [v]\n",
  "ESCALATION": "the act of escalating [n -S]\n",
  "ESCALATIONS": "ESCALATION, the act of escalating [n]\n",
  "ESCALATOR": "a moving stair [n -S]\n",
  "ESCALATORS": "ESCALATOR, a moving stair [n]\n",
  "ESCALATORY": "relating to escalation [adj]\n",
  "ESCALIER": "(French) a staircase [n -S]\n",
  "ESCALIERS": "ESCALIER, (French) a staircase [n]\n",
  "ESCALLONIA": "an evergreen shrub, often grown as a windbreak [n -S]\n",
  "ESCALLONIAS": "ESCALLONIA, an evergreen shrub, often grown as a windbreak [n]\n",
  "ESCALLOP": "to bake in a scallop shell, also SCALLOP, SCOLLOP [v -ED, -ING, -S]\n",
  "ESCALLOPED": "ESCALLOP, to bake in a scallop shell, also SCALLOP, SCOLLOP [v]\n",
  "ESCALLOPING": "ESCALLOP, to bake in a scallop shell, also SCALLOP, SCOLLOP [v]\n",
  "ESCALLOPS": "ESCALLOP, to bake in a scallop shell, also SCALLOP, SCOLLOP [v]\n",
  "ESCALOP": "(French) to bake in a scallop shell, also SCALLOP, ESCALLOP, SCOLLOP [v -ED, -ING, -S]\n",
  "ESCALOPE": "(French) to cut in a scallop shape, also ESCALOP [v ESCALOPED, ESCALOPING, ESCALOPES]\n",
  "ESCALOPED": "ESCALOP, (French) to bake in a scallop shell, also SCALLOP, ESCALLOP, SCOLLOP [v]\n",
  "ESCALOPES": "ESCALOPE, (French) to cut in a scallop shape, also ESCALOP [v]\n",
  "ESCALOPING": "ESCALOP, (French) to bake in a scallop shell, also SCALLOP, ESCALLOP, SCOLLOP [v]\n",
  "ESCALOPS": "ESCALOP, (French) to bake in a scallop shell, also SCALLOP, ESCALLOP, SCOLLOP [v]\n",
  "ESCAMOTAGE": "(French) juggling [n -S]\n",
  "ESCAMOTAGES": "ESCAMOTAGE, (French) juggling [n]\n",
  "ESCAPABLE": "avoidable [adj]\n",
  "ESCAPADE": "a reckless adventure [n -S]\n",
  "ESCAPADES": "ESCAPADE, a reckless adventure [n]\n",
  "ESCAPADO": "an escaped evildoer; an escapade [n -ES or -S]\n",
  "ESCAPADOES": "ESCAPADO, an escaped evildoer; an escapade [n]\n",
  "ESCAPADOS": "ESCAPADO, an escaped evildoer; an escapade [n]\n",
  "ESCAPE": "to free oneself [v ESCAPED, ESCAPING, ESCAPES]\n",
  "ESCAPED": "ESCAPE, to free oneself [v]\n",
  "ESCAPEE": "a person who has escaped [n -S]\n",
  "ESCAPEES": "ESCAPEE, a person who has escaped [n]\n",
  "ESCAPELESS": "without escape [adj]\n",
  "ESCAPEMENT": "a part of a clock or watch connecting the wheelwork with the pendulum or balance, and allowing a tooth to escape at each vibration, also SCAPEMENT [n -S]\n",
  "ESCAPEMENTS": "ESCAPEMENT, a part of a clock or watch connecting the wheelwork with the pendulum or balance, and allowing a tooth to escape at each vibration, also SCAPEMENT [n]\n",
  "ESCAPER": "one that escapes [n -S]\n",
  "ESCAPERS": "ESCAPER, one that escapes [n]\n",
  "ESCAPES": "ESCAPE, to free oneself [v]\n",
  "ESCAPING": "ESCAPE, to free oneself [v]\n",
  "ESCAPISM": "avoidance of reality [n -S]\n",
  "ESCAPISMS": "ESCAPISM, avoidance of reality [n]\n",
  "ESCAPIST": "one given to escapism [n -S]\n",
  "ESCAPISTS": "ESCAPIST, one given to escapism [n]\n",
  "ESCAPOLOGIES": "ESCAPOLOGY, the study of freeing oneself from constraints [n]\n",
  "ESCAPOLOGIST": "a practitioner of escapology [n -S]\n",
  "ESCAPOLOGISTS": "ESCAPOLOGIST, a practitioner of escapology [n]\n",
  "ESCAPOLOGY": "the study of freeing oneself from constraints [n ESCAPOLOGIES]\n",
  "ESCAR": "a narrow ridge of gravel and sand, also ESKAR, ESKER [n -S]\n",
  "ESCARGOT": "(French) a snail as an article of food [n -S]\n",
  "ESCARGOTS": "ESCARGOT, (French) a snail as an article of food [n]\n",
  "ESCARMOUCHE": "(obsolete) a skirmish [n -S]\n",
  "ESCARMOUCHES": "ESCARMOUCHE, (obsolete) a skirmish [n]\n",
  "ESCAROLE": "(French) a wavy-leafed salad plant of the endive family [n -S]\n",
  "ESCAROLES": "ESCAROLE, (French) a wavy-leafed salad plant of the endive family [n]\n",
  "ESCARP": "to cause to slope steeply [v -ED, -ING, -S]\n",
  "ESCARPED": "ESCARP, to cause to slope steeply [v]\n",
  "ESCARPING": "ESCARP, to cause to slope steeply [v]\n",
  "ESCARPMENT": "a steep slope in front of a fortification [n -S]\n",
  "ESCARPMENTS": "ESCARPMENT, a steep slope in front of a fortification [n]\n",
  "ESCARPS": "ESCARP, to cause to slope steeply [v]\n",
  "ESCARS": "ESCAR, a narrow ridge of gravel and sand, also ESKAR, ESKER [n]\n",
  "ESCHALOT": "(French) an onion with garlic-flavoured bulbs, also SHALLOT, SHALOT [n -S]\n",
  "ESCHALOTS": "ESCHALOT, (French) an onion with garlic-flavoured bulbs, also SHALLOT, SHALOT [n]\n",
  "ESCHAR": "(French) a slough of dead tissue, esp. an artificial slough produced by caustics [n -S]\n",
  "ESCHAROTIC": "caustic [adj] / a caustic substance [n -S]\n",
  "ESCHAROTICS": "ESCHAROTIC, a caustic substance [n]\n",
  "ESCHARS": "ESCHAR, (French) a slough of dead tissue, esp. an artificial slough produced by caustics [n]\n",
  "ESCHATOLOGIC": "relating to eschatology, also ESCHATOLOGICAL [adj]\n",
  "ESCHATOLOGICAL": "relating to eschatology, also ESCHATOLOGIC [adj]\n",
  "ESCHATOLOGIES": "ESCHATOLOGY, a branch of theology concerned with the end of the world [n]\n",
  "ESCHATOLOGIST": "a specialist in eschatology [n -S]\n",
  "ESCHATOLOGISTS": "ESCHATOLOGIST, a specialist in eschatology [n]\n",
  "ESCHATOLOGY": "a branch of theology concerned with the end of the world [n ESCHATOLOGIES]\n",
  "ESCHEAT": "the reversion of property to the state or crown in case of no legal heirs [n -S] / to make an escheat of, also EXCHEAT [v -ED, -ING, -S]\n",
  "ESCHEATABLE": "capable of being escheated [adj]\n",
  "ESCHEATAGE": "the right of succeeding to an escheat [n -S]\n",
  "ESCHEATAGES": "ESCHEATAGE, the right of succeeding to an escheat [n]\n",
  "ESCHEATED": "ESCHEAT, to make an escheat of, also EXCHEAT [v]\n",
  "ESCHEATING": "ESCHEAT, to make an escheat of, also EXCHEAT [v]\n",
  "ESCHEATMENT": "forfeiture of property to state for lack of heir [n -S]\n",
  "ESCHEATMENTS": "ESCHEATMENT, forfeiture of property to state for lack of heir [n]\n",
  "ESCHEATOR": "(historical) an official who watched over escheats [n -S]\n",
  "ESCHEATORS": "ESCHEATOR, (historical) an official who watched over escheats [n]\n",
  "ESCHEATS": "ESCHEAT, to make an escheat of, also EXCHEAT [v]\n",
  "ESCHEW": "to avoid [v -ED, -ING, -S]\n",
  "ESCHEWAL": "the act of eschewing [n -S]\n",
  "ESCHEWALS": "ESCHEWAL, the act of eschewing [n]\n",
  "ESCHEWED": "ESCHEW, to avoid [v]\n",
  "ESCHEWER": "one who eschews [n -S]\n",
  "ESCHEWERS": "ESCHEWER, one who eschews [n]\n",
  "ESCHEWING": "ESCHEW, to avoid [v]\n",
  "ESCHEWS": "ESCHEW, to avoid [v]\n",
  "ESCHSCHOLTZIA": "a flower of the poppy family, also ESCHSCHOLZIA [n -S]\n",
  "ESCHSCHOLTZIAS": "ESCHSCHOLTZIA, a flower of the poppy family, also ESCHSCHOLZIA [n]\n",
  "ESCHSCHOLZIA": "a flower of the poppy family, also ESCHSCHOLTZIA [n -S]\n",
  "ESCHSCHOLZIAS": "ESCHSCHOLZIA, a flower of the poppy family, also ESCHSCHOLTZIA [n]\n",
  "ESCLANDRE": "(French) unpleasant notoriety; a scandal, a scene [n -S]\n",
  "ESCLANDRES": "ESCLANDRE, (French) unpleasant notoriety; a scandal, a scene [n]\n",
  "ESCOLAR": "(Spanish) an Atlantic fish of spectacled appearance [n -S]\n",
  "ESCOLARS": "ESCOLAR, (Spanish) an Atlantic fish of spectacled appearance [n]\n",
  "ESCOPETTE": "(French) a kind of firearm; a carbine [n -S]\n",
  "ESCOPETTES": "ESCOPETTE, (French) a kind of firearm; a carbine [n]\n",
  "ESCORT": "to accompany [v -ED, -ING, -S]\n",
  "ESCORTAGE": "(US) escort [n -S]\n",
  "ESCORTAGES": "ESCORTAGE, (US) escort [n]\n",
  "ESCORTED": "ESCORT, to accompany [v]\n",
  "ESCORTING": "ESCORT, to accompany [v]\n",
  "ESCORTS": "ESCORT, to accompany [v]\n",
  "ESCOT": "(Shakespeare) to maintain financially [v ESCOTTED or ESCOTED, ESCOTTING or ESCOTING, ESCOTS]\n",
  "ESCOTED": "ESCOT, (Shakespeare) to maintain financially [v]\n",
  "ESCOTING": "ESCOT, (Shakespeare) to maintain financially [v]\n",
  "ESCOTS": "ESCOT, (Shakespeare) to maintain financially [v]\n",
  "ESCOTTED": "ESCOT, (Shakespeare) to maintain financially [v]\n",
  "ESCOTTING": "ESCOT, (Shakespeare) to maintain financially [v]\n",
  "ESCRIBANO": "(Spanish) a notary [n -S]\n",
  "ESCRIBANOS": "ESCRIBANO, (Spanish) a notary [n]\n",
  "ESCRIBE": "to construct a circle touching a triangle externally [v ESCRIBED, ESCRIBING, ESCRIBES]\n",
  "ESCRIBED": "ESCRIBE, to construct a circle touching a triangle externally [v]\n",
  "ESCRIBES": "ESCRIBE, to construct a circle touching a triangle externally [v]\n",
  "ESCRIBING": "ESCRIBE, to construct a circle touching a triangle externally [v]\n",
  "ESCRITOIRE": "(French) a writing-desk, also SCRUTOIRE [n -S]\n",
  "ESCRITOIRES": "ESCRITOIRE, (French) a writing-desk, also SCRUTOIRE [n]\n",
  "ESCRITORIAL": "relating to an escritoire [adj]\n",
  "ESCROC": "(French) a swindler [n -S]\n",
  "ESCROCS": "ESCROC, (French) a swindler [n]\n",
  "ESCROL": "a heraldic scroll, also ESCROLL [n -S]\n",
  "ESCROLL": "a heraldic scroll, also ESCROL [n -S]\n",
  "ESCROLLS": "ESCROLL, a heraldic scroll, also ESCROL [n]\n",
  "ESCROLS": "ESCROL, a heraldic scroll, also ESCROLL [n]\n",
  "ESCROW": "to place a deed in the hands of a third party [v -ED, -ING, -S]\n",
  "ESCROWED": "ESCROW, to place a deed in the hands of a third party [v]\n",
  "ESCROWING": "ESCROW, to place a deed in the hands of a third party [v]\n",
  "ESCROWS": "ESCROW, to place a deed in the hands of a third party [v]\n",
  "ESCUAGE": "a tax exacted by a feudal lord [n -S]\n",
  "ESCUAGES": "ESCUAGE, a tax exacted by a feudal lord [n]\n",
  "ESCUDO": "(Portuguese) a monetary unit of Portugal [n -S]\n",
  "ESCUDOS": "ESCUDO, (Portuguese) a monetary unit of Portugal [n]\n",
  "ESCULENT": "something that is edible [n -S]\n",
  "ESCULENTS": "ESCULENT, something that is edible [n]\n",
  "ESCUTCHEON": "a shield bearing a coat-of-arms, also SCUCHIN, SCUTCHEON [n -S]\n",
  "ESCUTCHEONED": "having an escutcheon [adj]\n",
  "ESCUTCHEONS": "ESCUTCHEON, a shield bearing a coat-of-arms, also SCUCHIN, SCUTCHEON [n]\n",
  "ESEMPLASIES": "ESEMPLASY, the unifying power of imagination [n]\n",
  "ESEMPLASTIC": "having the power to shape disparate things into a unified whole [adj ESEMPLASTICALLY]\n",
  "ESEMPLASTICALLY": "ESEMPLASTIC, having the power to shape disparate things into a unified whole [adv]\n",
  "ESEMPLASY": "the unifying power of imagination [n ESEMPLASIES]\n",
  "ESERINE": "an alkaloid found in the Calabar bean, used in ophthalmic surgery for its effect in contracting the pupil [n -S]\n",
  "ESERINES": "ESERINE, an alkaloid found in the Calabar bean, used in ophthalmic surgery for its effect in contracting the pupil [n]\n",
  "ESES": "ES, the letter S, also ESS [n]\n",
  "ESILE": "(obsolete) sour wine resembling vinegar, also EISEL, EISELL [n -S]\n",
  "ESILES": "ESILE, (obsolete) sour wine resembling vinegar, also EISEL, EISELL [n]\n",
  "ESKAR": "a narrow ridge of gravel and sand, also ESCAR, ESKER [n -S]\n",
  "ESKARS": "ESKAR, a narrow ridge of gravel and sand, also ESCAR, ESKER [n]\n",
  "ESKER": "a narrow ridge of gravel and sand, also ESCAR, ESKAR [n -S]\n",
  "ESKERS": "ESKER, a narrow ridge of gravel and sand, also ESCAR, ESKAR [n]\n",
  "ESKIES": "ESKY, a container for keeping drinks cool [n]\n",
  "ESKY": "a container for keeping drinks cool [n ESKIES]\n",
  "ESLOIN": "to remove to a distant place, also ELOIN, ELOIGN, ESLOYNE [v -ED, -ING, -S]\n",
  "ESLOINED": "ESLOIN, to remove to a distant place, also ELOIN, ELOIGN, ESLOYNE [v]\n",
  "ESLOINING": "ESLOIN, to remove to a distant place, also ELOIN, ELOIGN, ESLOYNE [v]\n",
  "ESLOINS": "ESLOIN, to remove to a distant place, also ELOIN, ELOIGN, ESLOYNE [v]\n",
  "ESLOYNE": "to remove to a distant place, also ELOIN, ELOIGN, ESLOIN [v ESLOYNED, ESLOYNING, ESLOYNES]\n",
  "ESLOYNED": "ESLOYNE, to remove to a distant place, also ELOIN, ELOIGN, ESLOIN [v]\n",
  "ESLOYNES": "ESLOYNE, to remove to a distant place, also ELOIN, ELOIGN, ESLOIN [v]\n",
  "ESLOYNING": "ESLOYNE, to remove to a distant place, also ELOIN, ELOIGN, ESLOIN [v]\n",
  "ESNE": "(historical) a domestic slave in Old English times [n -S]\n",
  "ESNECIES": "ESNECY, the primary inheritance of the eldest daughter [n]\n",
  "ESNECY": "the primary inheritance of the eldest daughter [n ESNECIES]\n",
  "ESNES": "ESNE, (historical) a domestic slave in Old English times [n]\n",
  "ESOPHAGEAL": "pertaining to the esophagus, also OESOPHAGEAL [adj]\n",
  "ESOPHAGI": "ESOPHAGUS, that portion of the gut which connects the pharynx to the stomach, also OESOPHAGUS [n]\n",
  "ESOPHAGITIDES": "ESOPHAGITIS, inflammation of the esophagus, also OESOPHAGITIS [n]\n",
  "ESOPHAGITIS": "inflammation of the esophagus, also OESOPHAGITIS [n ESOPHAGITIDES or ESOPHAGITISES]\n",
  "ESOPHAGITISES": "ESOPHAGITIS, inflammation of the esophagus, also OESOPHAGITIS [n]\n",
  "ESOPHAGOSCOPE": "an implement for examining the oesophagus [n -S]\n",
  "ESOPHAGOSCOPES": "ESOPHAGOSCOPE, an implement for examining the oesophagus [n]\n",
  "ESOPHAGOSCOPIES": "ESOPHAGOSCOPY, examination of the oesophagus, also OESOPHAGOSCOPY [n]\n",
  "ESOPHAGOSCOPY": "examination of the oesophagus, also OESOPHAGOSCOPY [n ESOPHAGOSCOPIES]\n",
  "ESOPHAGUS": "that portion of the gut which connects the pharynx to the stomach, also OESOPHAGUS [n ESOPHAGI or ESOPHAGUSES]\n",
  "ESOPHAGUSES": "ESOPHAGUS, that portion of the gut which connects the pharynx to the stomach, also OESOPHAGUS [n]\n",
  "ESOTERIC": "intended for or understood by only a particular group [adj ESOTERICALLY]\n",
  "ESOTERICA": "esoteric things [n -S]\n",
  "ESOTERICALLY": "ESOTERIC, intended for or understood by only a particular group [adv]\n",
  "ESOTERICAS": "ESOTERICA, esoteric things [n]\n",
  "ESOTERICISM": "esoteric doctrines or practices [n -S]\n",
  "ESOTERICISMS": "ESOTERICISM, esoteric doctrines or practices [n]\n",
  "ESOTERICIST": "a student of esoterica [n -S]\n",
  "ESOTERICISTS": "ESOTERICIST, a student of esoterica [n]\n",
  "ESOTERIES": "ESOTERY, secret doctrine [n]\n",
  "ESOTERISM": "the holding of esoteric opinions [n -S]\n",
  "ESOTERISMS": "ESOTERISM, the holding of esoteric opinions [n]\n",
  "ESOTERY": "secret doctrine [n ESOTERIES]\n",
  "ESOTROPIA": "a condition in which the eye turns inwards [n -S]\n",
  "ESOTROPIAS": "ESOTROPIA, a condition in which the eye turns inwards [n]\n",
  "ESOTROPIC": "relating to esotropia, a condition in which the eye turns inwards [adj]\n",
  "ESPADA": "(Spanish) a sword, esp. as used by a matador [n -S]\n",
  "ESPADAS": "ESPADA, (Spanish) a sword, esp. as used by a matador [n]\n",
  "ESPADRILLE": "(French) a sandal with rope bottom and canvas top [n -S]\n",
  "ESPADRILLES": "ESPADRILLE, (French) a sandal with rope bottom and canvas top [n]\n",
  "ESPAGNOLE": "(French) a brown sauce flavoured with tomatoes and sherry [n -S]\n",
  "ESPAGNOLES": "ESPAGNOLE, (French) a brown sauce flavoured with tomatoes and sherry [n]\n",
  "ESPAGNOLETTE": "(French) the fastening of a French window [n -S]\n",
  "ESPAGNOLETTES": "ESPAGNOLETTE, (French) the fastening of a French window [n]\n",
  "ESPALIER": "(French) a lattice on which trees are trained across [n -S] / to train a tree to grow on a lattice [v -ED, -ING, -S]\n",
  "ESPALIERED": "ESPALIER, to train a tree to grow on a lattice [v]\n",
  "ESPALIERING": "ESPALIER, to train a tree to grow on a lattice [v]\n",
  "ESPALIERS": "ESPALIER, to train a tree to grow on a lattice [v]\n",
  "ESPANOL": "(Spanish) a native of Spain [n -ES]\n",
  "ESPANOLES": "ESPANOL, (Spanish) a native of Spain [n]\n",
  "ESPARTO": "(Spanish) a tough, wiry grass, providing a fiber used for paper and cordage [n -S]\n",
  "ESPARTOS": "ESPARTO, (Spanish) a tough, wiry grass, providing a fiber used for paper and cordage [n]\n",
  "ESPECIAL": "special [adj ESPECIALLY]\n",
  "ESPECIALLY": "ESPECIAL, special [adv]\n",
  "ESPERANCE": "(Shakespeare) hope [n -S]\n",
  "ESPERANCES": "ESPERANCE, (Shakespeare) hope [n]\n",
  "ESPIAL": "a scout or spy [n -S]\n",
  "ESPIALS": "ESPIAL, a scout or spy [n]\n",
  "ESPIED": "ESPY, to catch sight of [v]\n",
  "ESPIEGLE": "(French) roguish, frolicsome [adj]\n",
  "ESPIEGLERIE": "(French) the quality of being espiegle, roguish [n -S]\n",
  "ESPIEGLERIES": "ESPIEGLERIE, (French) the quality of being espiegle, roguish [n]\n",
  "ESPIER": "someone who espies [n -S]\n",
  "ESPIERS": "ESPIER, someone who espies [n]\n",
  "ESPIES": "ESPY, to catch sight of [v]\n",
  "ESPIONAGE": "the practice of spying [n -S]\n",
  "ESPIONAGES": "ESPIONAGE, the practice of spying [n]\n",
  "ESPLANADE": "(French) a level open stretch of paved or grassy ground, esp. one designed for walking or driving along a shore [n -S]\n",
  "ESPLANADES": "ESPLANADE, (French) a level open stretch of paved or grassy ground, esp. one designed for walking or driving along a shore [n]\n",
  "ESPOIR": "(French) a category of wrestler [n -S]\n",
  "ESPOIRS": "ESPOIR, (French) a category of wrestler [n]\n",
  "ESPOUSAL": "a mutual promise of marriage [n -S]\n",
  "ESPOUSALS": "ESPOUSAL, a mutual promise of marriage [n]\n",
  "ESPOUSE": "to make a mutual promise of marriage [v ESPOUSED, ESPOUSING, ESPOUSES]\n",
  "ESPOUSED": "ESPOUSE, to make a mutual promise of marriage [v]\n",
  "ESPOUSER": "one who espouses [n -S]\n",
  "ESPOUSERS": "ESPOUSER, one who espouses [n]\n",
  "ESPOUSES": "ESPOUSE, to make a mutual promise of marriage [v]\n",
  "ESPOUSING": "ESPOUSE, to make a mutual promise of marriage [v]\n",
  "ESPRESSIVO": "(Italian) in an expressive way [adv]\n",
  "ESPRESSO": "(Italian) a strong coffee, also EXPRESSO [n -S]\n",
  "ESPRESSOS": "ESPRESSO, (Italian) a strong coffee, also EXPRESSO [n]\n",
  "ESPRIT": "(French) spirit, wit [n -S]\n",
  "ESPRITS": "ESPRIT, (French) spirit, wit [n]\n",
  "ESPUMOSO": "(Spanish) a sparkling wine [n -S]\n",
  "ESPUMOSOS": "ESPUMOSO, (Spanish) a sparkling wine [n]\n",
  "ESPY": "to catch sight of [v ESPIED, ESPYING, ESPIES]\n",
  "ESPYING": "ESPY, to catch sight of [v]\n",
  "ESQUIRE": "a squire or shield-bearer; an attendant on a knight [n -S] / to escort [v ESQUIRED, ESQUIRING, ESQUIRES]\n",
  "ESQUIRED": "ESQUIRE, to escort [v]\n",
  "ESQUIRES": "ESQUIRE, to escort [v]\n",
  "ESQUIRESS": "(historical) a female esquire [n -ES]\n",
  "ESQUIRESSES": "ESQUIRESS, (historical) a female esquire [n]\n",
  "ESQUIRING": "ESQUIRE, to escort [v]\n",
  "ESQUISSE": "(French) the first sketch of a picture or model of a statue [n -S]\n",
  "ESQUISSES": "ESQUISSE, (French) the first sketch of a picture or model of a statue [n]\n",
  "ESS": "the letter S, also ES [n -ES]\n",
  "ESSAY": "to attempt [v -ED, -ING, -S]\n",
  "ESSAYED": "ESSAY, to attempt [v]\n",
  "ESSAYER": "one who essays [n -S]\n",
  "ESSAYERS": "ESSAYER, one who essays [n]\n",
  "ESSAYETTE": "a short essay [n -S]\n",
  "ESSAYETTES": "ESSAYETTE, a short essay [n]\n",
  "ESSAYING": "ESSAY, to attempt [v]\n",
  "ESSAYISH": "like an essay [adj]\n",
  "ESSAYIST": "a writer of prose compositions [n -S]\n",
  "ESSAYISTIC": "relating to an essayist [adj]\n",
  "ESSAYISTS": "ESSAYIST, a writer of prose compositions [n]\n",
  "ESSAYS": "ESSAY, to attempt [v]\n",
  "ESSE": "(Latin) actual existence, essence [n -S]\n",
  "ESSENCE": "a fundamental nature [n -S]\n",
  "ESSENCES": "ESSENCE, a fundamental nature [n]\n",
  "ESSENTIAL": "absolutely necessary [adj ESSENTIALLY] / something absolutely necessary [n -S]\n",
  "ESSENTIALISE": "to express or formulate in essential form, also ESSENTIALIZE [v ESSENTIALISED, ESSENTIALISING, ESSENTIALISES]\n",
  "ESSENTIALISED": "ESSENTIALISE, to express or formulate in essential form, also ESSENTIALIZE [v]\n",
  "ESSENTIALISES": "ESSENTIALISE, to express or formulate in essential form, also ESSENTIALIZE [v]\n",
  "ESSENTIALISING": "ESSENTIALISE, to express or formulate in essential form, also ESSENTIALIZE [v]\n",
  "ESSENTIALISM": "a belief that the variation of nature can be reduced to a limited number of basic classes [n -S]\n",
  "ESSENTIALISMS": "ESSENTIALISM, a belief that the variation of nature can be reduced to a limited number of basic classes [n]\n",
  "ESSENTIALIST": "a believer in essentialism [n -S]\n",
  "ESSENTIALISTS": "ESSENTIALIST, a believer in essentialism [n]\n",
  "ESSENTIALITIES": "ESSENTIALITY, the state of being essential [n]\n",
  "ESSENTIALITY": "the state of being essential [n ESSENTIALITIES]\n",
  "ESSENTIALIZE": "to express or formulate in essential form, also ESSENTIALISE [v ESSENTIALIZED, ESSENTIALIZING, ESSENTIALIZES]\n",
  "ESSENTIALIZED": "ESSENTIALIZE, to express or formulate in essential form, also ESSENTIALISE [v]\n",
  "ESSENTIALIZES": "ESSENTIALIZE, to express or formulate in essential form, also ESSENTIALISE [v]\n",
  "ESSENTIALIZING": "ESSENTIALIZE, to express or formulate in essential form, also ESSENTIALISE [v]\n",
  "ESSENTIALLY": "ESSENTIAL, absolutely necessary [adv]\n",
  "ESSENTIALNESS": "ESSENTIAL, absolutely necessary [n]\n",
  "ESSENTIALNESSES": "ESSENTIALNESS, ESSENTIAL, absolutely necessary [n]\n",
  "ESSENTIALS": "ESSENTIAL, something absolutely necessary [n]\n",
  "ESSES": "ESSE, (Latin) actual existence, essence [n]\n",
  "ESSIVE": "a grammatical case denoting a state of being [n -S]\n",
  "ESSIVES": "ESSIVE, a grammatical case denoting a state of being [n]\n",
  "ESSOIN": "to give an excuse for not appearing in court [v -ED, -ING, -S]\n",
  "ESSOINED": "ESSOIN, to give an excuse for not appearing in court [v]\n",
  "ESSOINER": "one who submits an essoin to court [n -S]\n",
  "ESSOINERS": "ESSOINER, one who submits an essoin to court [n]\n",
  "ESSOINING": "ESSOIN, to give an excuse for not appearing in court [v]\n",
  "ESSOINS": "ESSOIN, to give an excuse for not appearing in court [v]\n",
  "ESSONITE": "cinnamon stone, a variety of garnet, also HESSONITE [n -S]\n",
  "ESSONITES": "ESSONITE, cinnamon stone, a variety of garnet, also HESSONITE [n]\n",
  "ESSOYNE": "an excuse for not appearing in court, also ESSOIN [n -S]\n",
  "ESSOYNES": "ESSOYNE, an excuse for not appearing in court, also ESSOIN [n]\n",
  "EST": "a programme designed to develop human potential [n -S]\n",
  "ESTABLISH": "to settle or fix, also STABLISH [v -ED, -ING, -ES]\n",
  "ESTABLISHABLE": "capable of being established [adj]\n",
  "ESTABLISHED": "ESTABLISH, to settle or fix, also STABLISH [v]\n",
  "ESTABLISHER": "one who establishes [n -S]\n",
  "ESTABLISHERS": "ESTABLISHER, one who establishes [n]\n",
  "ESTABLISHES": "ESTABLISH, to settle or fix, also STABLISH [v]\n",
  "ESTABLISHING": "ESTABLISH, to settle or fix, also STABLISH [v]\n",
  "ESTABLISHMENT": "a settled arrangement [n -S]\n",
  "ESTABLISHMENTS": "ESTABLISHMENT, a settled arrangement [n]\n",
  "ESTACADE": "(French) a dike of stakes in a river against an enemy [n -S]\n",
  "ESTACADES": "ESTACADE, (French) a dike of stakes in a river against an enemy [n]\n",
  "ESTAFETTE": "(French) a mounted courier [n -S]\n",
  "ESTAFETTES": "ESTAFETTE, (French) a mounted courier [n]\n",
  "ESTAMINET": "(French) a small cafe; a bistro [n -S]\n",
  "ESTAMINETS": "ESTAMINET, (French) a small cafe; a bistro [n]\n",
  "ESTANCIA": "(Spanish) a cattle ranch [n -S]\n",
  "ESTANCIAS": "ESTANCIA, (Spanish) a cattle ranch [n]\n",
  "ESTANCIERO": "(Spanish) a farmer on an estancia, a Spanish-American cattle-estate [n -S]\n",
  "ESTANCIEROS": "ESTANCIERO, (Spanish) a farmer on an estancia, a Spanish-American cattle-estate [n]\n",
  "ESTATE": "to bestow landed property [v ESTATED, ESTATING, ESTATES]\n",
  "ESTATED": "ESTATE, to bestow landed property [v]\n",
  "ESTATES": "ESTATE, to bestow landed property [v]\n",
  "ESTATESMAN": "in New England, a small landholder [n ESTATESMEN]\n",
  "ESTATESMEN": "ESTATESMAN, in New England, a small landholder [n]\n",
  "ESTATING": "ESTATE, to bestow landed property [v]\n",
  "ESTEEM": "to have a high opinion of, also STEEM [v -ED, -ING, -S]\n",
  "ESTEEMED": "ESTEEM, to have a high opinion of, also STEEM [v]\n",
  "ESTEEMING": "ESTEEM, to have a high opinion of, also STEEM [v]\n",
  "ESTEEMS": "ESTEEM, to have a high opinion of, also STEEM [v]\n",
  "ESTER": "a compound formed by the condensation of an alcohol and an acid, with elimination of water [n -S]\n",
  "ESTERASE": "any of a number of enzymes that catalyse the hydrolysis of an ester [n -S]\n",
  "ESTERASES": "ESTERASE, any of a number of enzymes that catalyse the hydrolysis of an ester [n]\n",
  "ESTERIFICATION": "the act of esterifying [n -S]\n",
  "ESTERIFICATIONS": "ESTERIFICATION, the act of esterifying [n]\n",
  "ESTERIFIED": "ESTERIFY, to convert into an ester [v]\n",
  "ESTERIFIES": "ESTERIFY, to convert into an ester [v]\n",
  "ESTERIFY": "to convert into an ester [v ESTERIFIED, ESTERIFYING, ESTERIFIES]\n",
  "ESTERIFYING": "ESTERIFY, to convert into an ester [v]\n",
  "ESTERISATION": "the process of making into an ester, also ESTERIZATION [n -S]\n",
  "ESTERISATIONS": "ESTERISATION, the process of making into an ester, also ESTERIZATION [n]\n",
  "ESTERIZATION": "the process of making into an ester, also ESTERISATION [n -S]\n",
  "ESTERIZATIONS": "ESTERIZATION, the process of making into an ester, also ESTERISATION [n]\n",
  "ESTERS": "ESTER, a compound formed by the condensation of an alcohol and an acid, with elimination of water [n]\n",
  "ESTHESES": "ESTHESIS, the ability to receive sensation, also ESTHESIA [n]\n",
  "ESTHESIA": "the ability to receive sensation, also ESTHESIS [n -S]\n",
  "ESTHESIAS": "ESTHESIA, the ability to receive sensation, also ESTHESIS [n]\n",
  "ESTHESIOGEN": "something producing sensation, esp. a stimulus or suggestion producing a sensory effect on a subject under hypnosis, also AESTHESIOGEN [n -S]\n",
  "ESTHESIOGENS": "ESTHESIOGEN, something producing sensation, esp. a stimulus or suggestion producing a sensory effect on a subject under hypnosis, also AESTHESIOGEN [n]\n",
  "ESTHESIS": "the ability to receive sensation, also ESTHESIA [n ESTHESISES or ESTHESES]\n",
  "ESTHESISES": "ESTHESIS, the ability to receive sensation, also ESTHESIA [n]\n",
  "ESTHETE": "a person who loves beautiful things [n -S]\n",
  "ESTHETES": "ESTHETE, a person who loves beautiful things [n]\n",
  "ESTHETIC": "keenly appreciative of the beautiful, also AESTHETIC, AESTHETICAL, ESTHETICAL [adj ESTHETICALLY]\n",
  "ESTHETICAL": "keenly appreciative of the beautiful, also AESTHETIC, AESTHETICAL, ESTHETIC [adj ESTHETICALLY]\n",
  "ESTHETICALLY": "ESTHETICAL, keenly appreciative of the beautiful, also AESTHETIC, AESTHETICAL, ESTHETIC [adv]\n",
  "ESTHETICIAN": "a specialist in aesthetics, also AESTHETICIAN [n -S]\n",
  "ESTHETICIANS": "ESTHETICIAN, a specialist in aesthetics, also AESTHETICIAN [n]\n",
  "ESTHETICISM": "the doctrine that beauty is central to other moral principles, also AESTHETICISM [n -S]\n",
  "ESTHETICISMS": "ESTHETICISM, the doctrine that beauty is central to other moral principles, also AESTHETICISM [n]\n",
  "ESTHETICS": "the principles of taste and art; the philosophy of the fine arts, also AESTHETICS [n]\n",
  "ESTIMABLE": "worthy of regard [adj ESTIMABLY]\n",
  "ESTIMABLENESS": "the state of being estimable [n -ES]\n",
  "ESTIMABLENESSES": "ESTIMABLENESS, the state of being estimable [n]\n",
  "ESTIMABLY": "ESTIMABLE, worthy of regard [adv]\n",
  "ESTIMATE": "to calculate [v ESTIMATED, ESTIMATING, ESTIMATES]\n",
  "ESTIMATED": "ESTIMATE, to calculate [v]\n",
  "ESTIMATES": "ESTIMATE, to calculate [v]\n",
  "ESTIMATING": "ESTIMATE, to calculate [v]\n",
  "ESTIMATION": "the act of estimating [n -S]\n",
  "ESTIMATIONS": "ESTIMATION, the act of estimating [n]\n",
  "ESTIMATIVE": "inclined, or able, to estimate [adj]\n",
  "ESTIMATOR": "one who estimates or values [n -S]\n",
  "ESTIMATORS": "ESTIMATOR, one who estimates or values [n]\n",
  "ESTIPULATE": "without stipules, also EXSTIPULATE [adj]\n",
  "ESTIVAL": "of or relating to summer, also AESTIVAL [adj]\n",
  "ESTIVATE": "to spend the summer in a torpid state, also AESTIVATE [v ESTIVATED, ESTIVATING, ESTIVATES]\n",
  "ESTIVATED": "ESTIVATE, to spend the summer in a torpid state, also AESTIVATE [v]\n",
  "ESTIVATES": "ESTIVATE, to spend the summer in a torpid state, also AESTIVATE [v]\n",
  "ESTIVATING": "ESTIVATE, to spend the summer in a torpid state, also AESTIVATE [v]\n",
  "ESTIVATION": "the act of spending the summer in a state of torpor, also AESTIVATION [n -S]\n",
  "ESTIVATIONS": "ESTIVATION, the act of spending the summer in a state of torpor, also AESTIVATION [n]\n",
  "ESTIVATOR": "an animal that aestivates, also AESTIVATOR [n -S]\n",
  "ESTIVATORS": "ESTIVATOR, an animal that aestivates, also AESTIVATOR [n]\n",
  "ESTOC": "(French) a short sword [n -S]\n",
  "ESTOCS": "ESTOC, (French) a short sword [n]\n",
  "ESTOILE": "(French) in heraldry, a six-pointed star whose rays are wavy, instead of straight like those of a mullet, also ETOILE [n -S]\n",
  "ESTOILES": "ESTOILE, (French) in heraldry, a six-pointed star whose rays are wavy, instead of straight like those of a mullet, also ETOILE [n]\n",
  "ESTOP": "to hinder or preclude [v ESTOPPED, ESTOPPING, ESTOPS]\n",
  "ESTOPPAGE": "the condition of being barred by estoppel [n -S]\n",
  "ESTOPPAGES": "ESTOPPAGE, the condition of being barred by estoppel [n]\n",
  "ESTOPPED": "ESTOP, to hinder or preclude [v]\n",
  "ESTOPPEL": "a bar to alleging or denying a fact because of one's own previous contrary actions or words [n -S]\n",
  "ESTOPPELS": "ESTOPPEL, a bar to alleging or denying a fact because of one's own previous contrary actions or words [n]\n",
  "ESTOPPING": "ESTOP, to hinder or preclude [v]\n",
  "ESTOPS": "ESTOP, to hinder or preclude [v]\n",
  "ESTOVER": "a common right to collect firewood, also STOVER [n -S]\n",
  "ESTOVERS": "ESTOVER, a common right to collect firewood, also STOVER [n]\n",
  "ESTRADE": "(French) a low platform [n -S]\n",
  "ESTRADES": "ESTRADE, (French) a low platform [n]\n",
  "ESTRADIOL": "a natural estrogenic hormone [n -S]\n",
  "ESTRADIOLS": "ESTRADIOL, a natural estrogenic hormone [n]\n",
  "ESTRAGON": "a kind of herb, also STARAGEN, TARRAGON [n -S]\n",
  "ESTRAGONS": "ESTRAGON, a kind of herb, also STARAGEN, TARRAGON [n]\n",
  "ESTRAL": "pertaining to estrus, also OESTRAL, ESTROUS, OESTROUS, ESTRUAL [adj]\n",
  "ESTRAMAZONE": "(obsolete) a downward cut in fencing, also STRAMACON, STRAMAZON [n -S]\n",
  "ESTRAMAZONES": "ESTRAMAZONE, (obsolete) a downward cut in fencing, also STRAMACON, STRAMAZON [n]\n",
  "ESTRANGE": "to alienate [v ESTRANGED, ESTRANGING, ESTRANGES]\n",
  "ESTRANGED": "ESTRANGE, to alienate [v]\n",
  "ESTRANGEDNESS": "the state of being estranged [n -ES]\n",
  "ESTRANGEDNESSES": "ESTRANGEDNESS, the state of being estranged [n]\n",
  "ESTRANGELO": "a cursive form of the old Syrian alphabet, also ESTRANGHELO [n -S]\n",
  "ESTRANGELOS": "ESTRANGELO, a cursive form of the old Syrian alphabet, also ESTRANGHELO [n]\n",
  "ESTRANGEMENT": "the act of estranging [n -S]\n",
  "ESTRANGEMENTS": "ESTRANGEMENT, the act of estranging [n]\n",
  "ESTRANGER": "one who estranges [n -S]\n",
  "ESTRANGERS": "ESTRANGER, one who estranges [n]\n",
  "ESTRANGES": "ESTRANGE, to alienate [v]\n",
  "ESTRANGHELO": "a cursive form of the old Syrian alphabet, also ESTRANGELO [n -S]\n",
  "ESTRANGHELOS": "ESTRANGHELO, a cursive form of the old Syrian alphabet, also ESTRANGELO [n]\n",
  "ESTRANGING": "ESTRANGE, to alienate [v]\n",
  "ESTRAPADE": "(French) a horse's attempt to throw its rider [n -S]\n",
  "ESTRAPADES": "ESTRAPADE, (French) a horse's attempt to throw its rider [n]\n",
  "ESTRAY": "to stray [v -ED, -ING, -S]\n",
  "ESTRAYED": "ESTRAY, to stray [v]\n",
  "ESTRAYING": "ESTRAY, to stray [v]\n",
  "ESTRAYS": "ESTRAY, to stray [v]\n",
  "ESTREAT": "to extract from the records of a court [v -ED, -ING, -S]\n",
  "ESTREATED": "ESTREAT, to extract from the records of a court [v]\n",
  "ESTREATING": "ESTREAT, to extract from the records of a court [v]\n",
  "ESTREATS": "ESTREAT, to extract from the records of a court [v]\n",
  "ESTREPE": "to create waste as a tenant e.g. by cutting down trees [v ESTREPED, ESTREPING, ESTREPES]\n",
  "ESTREPED": "ESTREPE, to create waste as a tenant e.g. by cutting down trees [v]\n",
  "ESTREPEMENT": "the act of estreping [n -S]\n",
  "ESTREPEMENTS": "ESTREPEMENT, the act of estreping [n]\n",
  "ESTREPES": "ESTREPE, to create waste as a tenant e.g. by cutting down trees [v]\n",
  "ESTREPING": "ESTREPE, to create waste as a tenant e.g. by cutting down trees [v]\n",
  "ESTRIBUTOR": "a person or organization that helps an author publish and distribute his or her own work in electronic form [n -S]\n",
  "ESTRIBUTORS": "ESTRIBUTOR, a person or organization that helps an author publish and distribute his or her own work in electronic form [n]\n",
  "ESTRICH": "(obsolete) an ostrich, also ESTRIDGE, OYSTRIGE [n -ES]\n",
  "ESTRICHES": "ESTRICH, (obsolete) an ostrich, also ESTRIDGE, OYSTRIGE [n]\n",
  "ESTRIDGE": "(obsolete) an ostrich, also ESTRICH, OYSTRIGE [n -S]\n",
  "ESTRIDGES": "ESTRIDGE, (obsolete) an ostrich, also ESTRICH, OYSTRIGE [n]\n",
  "ESTRILDID": "any member of a genus of oscinine birds, the weaver-finches [n -S]\n",
  "ESTRILDIDS": "ESTRILDID, any member of a genus of oscinine birds, the weaver-finches [n]\n",
  "ESTRIN": "an estrogen, also ESTRONE, OESTRIN, OESTRONE [n -S]\n",
  "ESTRINS": "ESTRIN, an estrogen, also ESTRONE, OESTRIN, OESTRONE [n]\n",
  "ESTRIOL": "an estrogen, also OESTRIOL [n -S]\n",
  "ESTRIOLS": "ESTRIOL, an estrogen, also OESTRIOL [n]\n",
  "ESTRO": "(Italian) the height of poetic inspiration [n -S]\n",
  "ESTROGEN": "a female sex-hormone, also OESTROGEN [n -S]\n",
  "ESTROGENIC": "of or like estrogen, a female sex-hormone, also OESTROGENIC [adj ESTROGENICALLY]\n",
  "ESTROGENICALLY": "ESTROGENIC, of or like estrogen, a female sex-hormone, also OESTROGENIC [adv]\n",
  "ESTROGENS": "ESTROGEN, a female sex-hormone, also OESTROGEN [n]\n",
  "ESTRONE": "an estrogen, also ESTRIN, OESTRIN, OESTRONE [n -S]\n",
  "ESTRONES": "ESTRONE, an estrogen, also ESTRIN, OESTRIN, OESTRONE [n]\n",
  "ESTROS": "ESTRO, (Italian) the height of poetic inspiration [n]\n",
  "ESTROUS": "pertaining to estrus, also ESTRAL, OESTRAL, OESTROUS, ESTRUAL [adj]\n",
  "ESTRUAL": "pertaining to estrus, a period of sexual excitement and ovulation in animals, also ESTROUS, OESTRUAL [adj]\n",
  "ESTRUM": "(Latin) the period of heat in female mammals, also OESTRUM, ESTRUS, OESTRUS [n -S]\n",
  "ESTRUMS": "ESTRUM, (Latin) the period of heat in female mammals, also OESTRUM, ESTRUS, OESTRUS [n]\n",
  "ESTRUS": "(Latin) the period of heat in female mammals, also ESTRUM, OESTRUM, OESTRUS [n -ES]\n",
  "ESTRUSES": "ESTRUS, (Latin) the period of heat in female mammals, also ESTRUM, OESTRUM, OESTRUS [n]\n",
  "ESTS": "EST, a programme designed to develop human potential [n]\n",
  "ESTUARIAL": "relating to estuaries, also ESTUARIAN, ESTUARINE [adj]\n",
  "ESTUARIAN": "relating to estuaries, also ESTUARIAL, ESTUARINE [adj]\n",
  "ESTUARIES": "ESTUARY, the tidal mouth of a large river [n]\n",
  "ESTUARINE": "relating to estuaries, also ESTUARIAL, ESTUARIAN [adj]\n",
  "ESTUARY": "the tidal mouth of a large river [n ESTUARIES]\n",
  "ESURIENCE": "greed, gluttony, also ESURIENCY [n -S]\n",
  "ESURIENCES": "ESURIENCE, greed, gluttony, also ESURIENCY [n]\n",
  "ESURIENCIES": "ESURIENCY, greed, gluttony, also ESURIENCE [n]\n",
  "ESURIENCY": "greed, gluttony, also ESURIENCE [n ESURIENCIES]\n",
  "ESURIENT": "hungry, greedy [adj ESURIENTLY]\n",
  "ESURIENTLY": "ESURIENT, hungry, greedy [adv]\n",
  "ET": "EAT, to consume food [v]\n",
  "ETA": "a Greek letter [n -S]\n",
  "ETACISM": "the pronunciation of the Greek letter eta as close e, also ITACISM [n -S]\n",
  "ETACISMS": "ETACISM, the pronunciation of the Greek letter eta as close e, also ITACISM [n]\n",
  "ETAERIO": "an aggregated fruit like a blackberry [n -S]\n",
  "ETAERIOS": "ETAERIO, an aggregated fruit like a blackberry [n]\n",
  "ETAGE": "(French) a floor storey [n -S]\n",
  "ETAGERE": "(French) a display stand with shelves for small objects or ornaments, etc. [n -S]\n",
  "ETAGERES": "ETAGERE, (French) a display stand with shelves for small objects or ornaments, etc. [n]\n",
  "ETAGES": "ETAGE, (French) a floor storey [n]\n",
  "ETALAGE": "(French) a display, esp. of goods in a shop window [n -S]\n",
  "ETALAGES": "ETALAGE, (French) a display, esp. of goods in a shop window [n]\n",
  "ETALON": "(French) a device used to measure wavelengths [n -S]\n",
  "ETALONS": "ETALON, (French) a device used to measure wavelengths [n]\n",
  "ETAMIN": "(French) a loosely woven fabric, also ETAMINE [n -S]\n",
  "ETAMINE": "(French) a loosely woven open-mesh cotton or worsted fabric, also ETAMIN [n -S]\n",
  "ETAMINES": "ETAMINE, (French) a loosely woven open-mesh cotton or worsted fabric, also ETAMIN [n]\n",
  "ETAMINS": "ETAMIN, (French) a loosely woven fabric, also ETAMINE [n]\n",
  "ETAPE": "(French) a storehouse; a halting-place; a day's march [n -S]\n",
  "ETAPES": "ETAPE, (French) a storehouse; a halting-place; a day's march [n]\n",
  "ETAS": "ETA, a Greek letter [n]\n",
  "ETAT": "(French) the staff of an army, including all officers above the rank of colonel [n -S]\n",
  "ETATISM": "extreme state control over the individual, also ETATISME [n -S]\n",
  "ETATISME": "(French) extreme state control over the individual, also ETATISM [n -S]\n",
  "ETATISMES": "ETATISME, (French) extreme state control over the individual, also ETATISM [n]\n",
  "ETATISMS": "ETATISM, extreme state control over the individual, also ETATISME [n]\n",
  "ETATIST": "relating to etatism, extreme state control over the individual [adj]\n",
  "ETATISTE": "(French) someone who advocates etatism [n -S]\n",
  "ETATISTES": "ETATISTE, (French) someone who advocates etatism [n]\n",
  "ETATS": "ETAT, (French) the staff of an army, including all officers above the rank of colonel [n]\n",
  "ETCETERA": "(Latin) additional items [n -S]\n",
  "ETCETERAS": "ETCETERA, (Latin) additional items [n]\n",
  "ETCH": "to engrave with acid [v -ED, -ING, -ES]\n",
  "ETCHANT": "an acid used in etching [n -S]\n",
  "ETCHANTS": "ETCHANT, an acid used in etching [n]\n",
  "ETCHED": "ETCH, to engrave with acid [v]\n",
  "ETCHER": "one who etches [n -S]\n",
  "ETCHERS": "ETCHER, one who etches [n]\n",
  "ETCHES": "ETCH, to engrave with acid [v]\n",
  "ETCHING": "an etched design [n -S]\n",
  "ETCHINGS": "ETCHING, an etched design [n]\n",
  "ETEN": "a giant, also ETTIN [n -S]\n",
  "ETENS": "ETEN, a giant, also ETTIN [n]\n",
  "ETEPIMELETIC": "of a type of social behaviour shown by young animals to elicit epimeletic behaviour [adj]\n",
  "ETERNAL": "everlasting, also ETERNE [adj ETERNALLY] / something lasting forever [n -S]\n",
  "ETERNALISATION": "the process of eternalising, also ETERNALIZATION [n -S]\n",
  "ETERNALISATIONS": "ETERNALISATION, the process of eternalising, also ETERNALIZATION [n]\n",
  "ETERNALISE": "to make eternal, also ETERNALIZE [v ETERNALISED, ETERNALISING, ETERNALISES]\n",
  "ETERNALISED": "ETERNALISE, to make eternal, also ETERNALIZE [v]\n",
  "ETERNALISES": "ETERNALISE, to make eternal, also ETERNALIZE [v]\n",
  "ETERNALISING": "ETERNALISE, to make eternal, also ETERNALIZE [v]\n",
  "ETERNALIST": "one who holds the existence of matter to be from eternity [n -S]\n",
  "ETERNALISTS": "ETERNALIST, one who holds the existence of matter to be from eternity [n]\n",
  "ETERNALITIES": "ETERNALITY, the quality of being eternal [n]\n",
  "ETERNALITY": "the quality of being eternal [n ETERNALITIES]\n",
  "ETERNALIZATION": "the process of eternalizing, also ETERNALISATION [n -S]\n",
  "ETERNALIZATIONS": "ETERNALIZATION, the process of eternalizing, also ETERNALISATION [n]\n",
  "ETERNALIZE": "to make eternal, also ETERNALISE [v ETERNALIZED, ETERNALIZING, ETERNALIZES]\n",
  "ETERNALIZED": "ETERNALIZE, to make eternal, also ETERNALISE [v]\n",
  "ETERNALIZES": "ETERNALIZE, to make eternal, also ETERNALISE [v]\n",
  "ETERNALIZING": "ETERNALIZE, to make eternal, also ETERNALISE [v]\n",
  "ETERNALLY": "ETERNAL, everlasting, also ETERNE [adv]\n",
  "ETERNALNESS": "being eternal [n -ES]\n",
  "ETERNALNESSES": "ETERNALNESS, being eternal [n]\n",
  "ETERNALS": "ETERNAL, something lasting forever [n]\n",
  "ETERNE": "everlasting [adj]\n",
  "ETERNISATION": "the act of making eternal, also ETERNIZATION [n -S]\n",
  "ETERNISATIONS": "ETERNISATION, the act of making eternal, also ETERNIZATION [n]\n",
  "ETERNISE": "to make eternal, also ETERNIZE [v ETERNISED, ETERNISING, ETERNISES]\n",
  "ETERNISED": "ETERNISE, to make eternal, also ETERNIZE [v]\n",
  "ETERNISES": "ETERNISE, to make eternal, also ETERNIZE [v]\n",
  "ETERNISING": "ETERNISE, to make eternal, also ETERNIZE [v]\n",
  "ETERNITIES": "ETERNITY, duration without beginning or end [n]\n",
  "ETERNITY": "duration without beginning or end [n ETERNITIES]\n",
  "ETERNIZATION": "the act of making eternal, also ETERNISATION [n -S]\n",
  "ETERNIZATIONS": "ETERNIZATION, the act of making eternal, also ETERNISATION [n]\n",
  "ETERNIZE": "to make eternal, also ETERNISE [v ETERNIZED, ETERNIZING, ETERNIZES]\n",
  "ETERNIZED": "ETERNIZE, to make eternal, also ETERNISE [v]\n",
  "ETERNIZES": "ETERNIZE, to make eternal, also ETERNISE [v]\n",
  "ETERNIZING": "ETERNIZE, to make eternal, also ETERNISE [v]\n",
  "ETESIAN": "a NW wind that recurs annually in the summer in the eastern part of the Mediterranean Sea [n -S]\n",
  "ETESIANS": "ETESIAN, a NW wind that recurs annually in the summer in the eastern part of the Mediterranean Sea [n]\n",
  "ETH": "an Old English letter, also EDH [n -S]\n",
  "ETHAL": "a white waxy solid, aka cetyl alcohol [n -S]\n",
  "ETHALS": "ETHAL, a white waxy solid, aka cetyl alcohol [n]\n",
  "ETHAMBUTOL": "a drug used in the treatment of tuberculosis [n -S]\n",
  "ETHAMBUTOLS": "ETHAMBUTOL, a drug used in the treatment of tuberculosis [n]\n",
  "ETHANAL": "another name for acetaldehyde [n -S]\n",
  "ETHANALS": "ETHANAL, another name for acetaldehyde [n]\n",
  "ETHANE": "a gaseous hydrocarbon [n -S]\n",
  "ETHANEDIOIC": "designating a type of acid [adj]\n",
  "ETHANEDIOL": "a clear colourless syrupy soluble liquid substance, used as an antifreeze and solvent [n -S]\n",
  "ETHANEDIOLS": "ETHANEDIOL, a clear colourless syrupy soluble liquid substance, used as an antifreeze and solvent [n]\n",
  "ETHANES": "ETHANE, a gaseous hydrocarbon [n]\n",
  "ETHANOATE": "an ester of acetic acid, aka acetate [n -S]\n",
  "ETHANOATES": "ETHANOATE, an ester of acetic acid, aka acetate [n]\n",
  "ETHANOIC": "as in ethanoic acid, the same as acetic acid [adj]\n",
  "ETHANOL": "ethyl alcohol [n -S]\n",
  "ETHANOLAMINE": "a colorless liquid amino alcohol used esp. as a solvent in the synthesis of detergents and in gas purification [n -S]\n",
  "ETHANOLAMINES": "ETHANOLAMINE, a colorless liquid amino alcohol used esp. as a solvent in the synthesis of detergents and in gas purification [n]\n",
  "ETHANOLS": "ETHANOL, ethyl alcohol [n]\n",
  "ETHANOYL": "acetyl as a combining group [n -S]\n",
  "ETHANOYLS": "ETHANOYL, acetyl as a combining group [n]\n",
  "ETHE": "(Spenser) easy, also EATH, EATHE [adj]\n",
  "ETHENE": "a flammable gas, also ETHYLENE [n -S]\n",
  "ETHENES": "ETHENE, a flammable gas, also ETHYLENE [n]\n",
  "ETHEOSTOMINE": "of or like the Etheostoma, a genus of small American freshwater fishes related to perch [adj]\n",
  "ETHEPHON": "a synthetic plant growth regulator [n -S]\n",
  "ETHEPHONS": "ETHEPHON, a synthetic plant growth regulator [n]\n",
  "ETHER": "a volatile liquid used as an anaesthetic [n -S]\n",
  "ETHERCAP": "(Scots) a spider, also ATTERCOP, ETTERCAP [n -S]\n",
  "ETHERCAPS": "ETHERCAP, (Scots) a spider, also ATTERCOP, ETTERCAP [n]\n",
  "ETHEREAL": "characterized by lightness and insubstantiality, also AETHEREAL, ETHEREOUS, ETHERIAL [adj ETHEREALLY]\n",
  "ETHEREALISATION": "the process of etherealising, also ETHEREALIZATION [n]\n",
  "ETHEREALISE": "to make ethereal, also ETHEREALIZE [v ETHEREALISED, ETHEREALISING, ETHEREALISES]\n",
  "ETHEREALISED": "ETHEREALISE, to make ethereal, also ETHEREALIZE [v]\n",
  "ETHEREALISES": "ETHEREALISE, to make ethereal, also ETHEREALIZE [v]\n",
  "ETHEREALISING": "ETHEREALISE, to make ethereal, also ETHEREALIZE [v]\n",
  "ETHEREALITIES": "ETHEREALITY, the quality of being ethereal [n]\n",
  "ETHEREALITY": "the quality of being ethereal [n ETHEREALITIES]\n",
  "ETHEREALIZATION": "the act of etherealizing, also ETHEREALISATION [n]\n",
  "ETHEREALIZE": "to make ethereal [v ETHEREALIZED, ETHEREALIZING, ETHEREALIZES]\n",
  "ETHEREALIZED": "ETHEREALIZE, to make ethereal [v]\n",
  "ETHEREALIZES": "ETHEREALIZE, to make ethereal [v]\n",
  "ETHEREALIZING": "ETHEREALIZE, to make ethereal [v]\n",
  "ETHEREALLY": "ETHEREAL, characterized by lightness and insubstantiality, also AETHEREAL, ETHEREOUS, ETHERIAL [adv]\n",
  "ETHEREALNESS": "the state of being ethereal [n -ES]\n",
  "ETHEREALNESSES": "ETHEREALNESS, the state of being ethereal [n]\n",
  "ETHEREOUS": "(Milton) of or like the ether, also AETHEREAL, ETHEREAL, ETHERIAL [adj]\n",
  "ETHERIAL": "like a spirit, also AETHEREAL, ETHEREAL, ETHERIC [adj]\n",
  "ETHERIC": "like a spirit, also AETHEREAL, ETHEREAL, ETHERIAL [adj]\n",
  "ETHERICAL": "relating to the ether, also AETHERIC, ETHERIC [adj]\n",
  "ETHERIFICATION": "the act of etherifying, converting into ether [n -S]\n",
  "ETHERIFICATIONS": "ETHERIFICATION, the act of etherifying, converting into ether [n]\n",
  "ETHERIFIED": "ETHERIFY, to convert into ether [v]\n",
  "ETHERIFIES": "ETHERIFY, to convert into ether [v]\n",
  "ETHERIFY": "to convert into ether [v ETHERIFIED, ETHERIFYING, ETHERIFIES]\n",
  "ETHERIFYING": "ETHERIFY, to convert into ether [v]\n",
  "ETHERION": "a very light gas once supposed to exist in air [n -S]\n",
  "ETHERIONS": "ETHERION, a very light gas once supposed to exist in air [n]\n",
  "ETHERISATION": "conversion into ether, also ETHERIZATION [n -S]\n",
  "ETHERISATIONS": "ETHERISATION, conversion into ether, also ETHERIZATION [n]\n",
  "ETHERISE": "to administer ether as an anaesthetic, also ETHERIZE [v ETHERISED, ETHERISING, ETHERISES]\n",
  "ETHERISED": "ETHERISE, to administer ether as an anaesthetic, also ETHERIZE [v]\n",
  "ETHERISER": "one who etherises, also ETHERIZER [n -S]\n",
  "ETHERISERS": "ETHERISER, one who etherises, also ETHERIZER [n]\n",
  "ETHERISES": "ETHERISE, to administer ether as an anaesthetic, also ETHERIZE [v]\n",
  "ETHERISH": "somewhat like ether [adj]\n",
  "ETHERISING": "ETHERISE, to administer ether as an anaesthetic, also ETHERIZE [v]\n",
  "ETHERISM": "addiction to ether [n -S]\n",
  "ETHERISMS": "ETHERISM, addiction to ether [n]\n",
  "ETHERIST": "one who administers ether [n -S]\n",
  "ETHERISTS": "ETHERIST, one who administers ether [n]\n",
  "ETHERIZATION": "conversion into ether, also ETHERISATION [n -S]\n",
  "ETHERIZATIONS": "ETHERIZATION, conversion into ether, also ETHERISATION [n]\n",
  "ETHERIZE": "to administer ether as an anaesthetic, also ETHERISE [v ETHERIZED, ETHERIZING, ETHERIZES]\n",
  "ETHERIZED": "ETHERIZE, to administer ether as an anaesthetic, also ETHERISE [v]\n",
  "ETHERIZER": "one who administers ether, also ETHERISER [n -S]\n",
  "ETHERIZERS": "ETHERIZER, one who administers ether, also ETHERISER [n]\n",
  "ETHERIZES": "ETHERIZE, to administer ether as an anaesthetic, also ETHERISE [v]\n",
  "ETHERIZING": "ETHERIZE, to administer ether as an anaesthetic, also ETHERISE [v]\n",
  "ETHEROMANIA": "addiction to the taking of ether [n -S]\n",
  "ETHEROMANIAC": "one addicted to taking ether [n -S]\n",
  "ETHEROMANIACS": "ETHEROMANIAC, one addicted to taking ether [n]\n",
  "ETHEROMANIAS": "ETHEROMANIA, addiction to the taking of ether [n]\n",
  "ETHERS": "ETHER, a volatile liquid used as an anaesthetic [n]\n",
  "ETHIC": "relating to morals, also ETHICAL [adj ETHICALLY] / a body of moral principles [n -S]\n",
  "ETHICAL": "in accordance with ethics [adj ETHICALLY] / a drug sold by prescription only [n -S]\n",
  "ETHICALITIES": "ETHICALITY, the quality of being ethical [n]\n",
  "ETHICALITY": "the quality of being ethical [n ETHICALITIES]\n",
  "ETHICALLY": "ETHICAL, in accordance with ethics [adv]\n",
  "ETHICALNESS": "being ethical [n -ES]\n",
  "ETHICALNESSES": "ETHICALNESS, being ethical [n]\n",
  "ETHICALS": "ETHICAL, a drug sold by prescription only [n]\n",
  "ETHICIAN": "an expert upon ethics, also ETHICIST [n -S]\n",
  "ETHICIANS": "ETHICIAN, an expert upon ethics, also ETHICIST [n]\n",
  "ETHICISE": "to treat as an ethical matter, also ETHICIZE [v ETHICISED, ETHICISING, ETHICISES]\n",
  "ETHICISED": "ETHICISE, to treat as an ethical matter, also ETHICIZE [v]\n",
  "ETHICISES": "ETHICISE, to treat as an ethical matter, also ETHICIZE [v]\n",
  "ETHICISING": "ETHICISE, to treat as an ethical matter, also ETHICIZE [v]\n",
  "ETHICISM": "the tendency to moralize [n -S]\n",
  "ETHICISMS": "ETHICISM, the tendency to moralize [n]\n",
  "ETHICIST": "an expert upon ethics, also ETHICIAN [n -S]\n",
  "ETHICISTS": "ETHICIST, an expert upon ethics, also ETHICIAN [n]\n",
  "ETHICIZE": "to treat as an ethical matter, also ETHICISE [v ETHICIZED, ETHICIZING, ETHICIZES]\n",
  "ETHICIZED": "ETHICIZE, to treat as an ethical matter, also ETHICISE [v]\n",
  "ETHICIZES": "ETHICIZE, to treat as an ethical matter, also ETHICISE [v]\n",
  "ETHICIZING": "ETHICIZE, to treat as an ethical matter, also ETHICISE [v]\n",
  "ETHICS": "ETHIC, a body of moral principles [n]\n",
  "ETHINYL": "a univalent chemical radical, also ETHOXY, ETHOXYL, ETHYL, ETHYNYL [n -S]\n",
  "ETHINYLS": "ETHINYL, a univalent chemical radical, also ETHOXY, ETHOXYL, ETHYL, ETHYNYL [n]\n",
  "ETHION": "a pesticide [n -S]\n",
  "ETHIONAMIDE": "a compound used against mycobacteria, as in tuberculosis and leprosy [n -S]\n",
  "ETHIONAMIDES": "ETHIONAMIDE, a compound used against mycobacteria, as in tuberculosis and leprosy [n]\n",
  "ETHIONINE": "an amino acid [n -S]\n",
  "ETHIONINES": "ETHIONINE, an amino acid [n]\n",
  "ETHIONS": "ETHION, a pesticide [n]\n",
  "ETHIOPS": "an old name for various dingy chemicals [n -ES]\n",
  "ETHIOPSES": "ETHIOPS, an old name for various dingy chemicals [n]\n",
  "ETHMOID": "a square bone at the root of the nose [n -S]\n",
  "ETHMOIDAL": "of or like a sieve, also ETHMOID [adj]\n",
  "ETHMOIDS": "ETHMOID, a square bone at the root of the nose [n]\n",
  "ETHNARCH": "the ruler of a people or province [n -S]\n",
  "ETHNARCHIES": "ETHNARCHY, the dominion of an ethnarch [n]\n",
  "ETHNARCHS": "ETHNARCH, the ruler of a people or province [n]\n",
  "ETHNARCHY": "the dominion of an ethnarch [n ETHNARCHIES]\n",
  "ETHNE": "ETHNOS, (Greek) a group of people who share a common culture [n]\n",
  "ETHNIC": "relating to race, also ETHNICAL [adj ETHNICALLY] / a member of a particular ethnos [n -S]\n",
  "ETHNICAL": "concerning races or nations, also ETHNIC [adj ETHNICALLY]\n",
  "ETHNICALLY": "ETHNICAL, concerning races or nations, also ETHNIC [adv]\n",
  "ETHNICISM": "consciousness of or emphasis on racial or national identity [n -S]\n",
  "ETHNICISMS": "ETHNICISM, consciousness of or emphasis on racial or national identity [n]\n",
  "ETHNICITIES": "ETHNICITY, ethnic character; the fact or sense of belonging to a particular ethnic group [n]\n",
  "ETHNICITY": "ethnic character; the fact or sense of belonging to a particular ethnic group [n ETHNICITIES]\n",
  "ETHNICS": "ETHNIC, a member of a particular ethnos [n]\n",
  "ETHNOBIOLOGIES": "ETHNOBIOLOGY, the branch of biology involving the study of the traditional uses of plants and animals in various human societies [n]\n",
  "ETHNOBIOLOGY": "the branch of biology involving the study of the traditional uses of plants and animals in various human societies [n ETHNOBIOLOGIES]\n",
  "ETHNOBOTANICAL": "relating to ethnobotany [adj]\n",
  "ETHNOBOTANIES": "ETHNOBOTANY, the plant lore of indigenous cultures [n]\n",
  "ETHNOBOTANIST": "a student of ethnobotany [n -S]\n",
  "ETHNOBOTANISTS": "ETHNOBOTANIST, a student of ethnobotany [n]\n",
  "ETHNOBOTANY": "the plant lore of indigenous cultures [n ETHNOBOTANIES]\n",
  "ETHNOCENTRIC": "characterized by or based on the attitude that one's own group is superior [adj]\n",
  "ETHNOCENTRICITY": "the state of being ethnocentric, also ETHNOCENTRISM [n]\n",
  "ETHNOCENTRISM": "the state of being ethnocentric, also ETHNOCENTRICITY [n -S]\n",
  "ETHNOCENTRISMS": "ETHNOCENTRISM, the state of being ethnocentric, also ETHNOCENTRICITY [n]\n",
  "ETHNOCIDE": "the extermination of a racial or cultural group [n -S]\n",
  "ETHNOCIDES": "ETHNOCIDE, the extermination of a racial or cultural group [n]\n",
  "ETHNOGENIC": "relating to ethnogeny, the study of human races [adj]\n",
  "ETHNOGENIES": "ETHNOGENY, the study of human races [n]\n",
  "ETHNOGENIST": "a student of ethnogeny [n -S]\n",
  "ETHNOGENISTS": "ETHNOGENIST, a student of ethnogeny [n]\n",
  "ETHNOGENY": "the study of human races [n ETHNOGENIES]\n",
  "ETHNOGRAPHER": "a student of ethnography [n -S]\n",
  "ETHNOGRAPHERS": "ETHNOGRAPHER, a student of ethnography [n]\n",
  "ETHNOGRAPHIC": "related to ethnography [adj]\n",
  "ETHNOGRAPHICA": "a collection of ethnographic objects [n]\n",
  "ETHNOGRAPHICAL": "relating to ethnography [adj]\n",
  "ETHNOGRAPHIES": "ETHNOGRAPHY, the study and systematic recording of human cultures [n]\n",
  "ETHNOGRAPHY": "the study and systematic recording of human cultures [n ETHNOGRAPHIES]\n",
  "ETHNOHISTORIAN": "a student of ethnohistory [n -S]\n",
  "ETHNOHISTORIANS": "ETHNOHISTORIAN, a student of ethnohistory [n]\n",
  "ETHNOHISTORIC": "relating to ethnohistory, also ETHNOHISTORICAL [adj]\n",
  "ETHNOHISTORICAL": "relating to ethnohistory, also ETHNOHISTORIC [adj]\n",
  "ETHNOHISTORIES": "ETHNOHISTORY, a study of the development of cultures [n]\n",
  "ETHNOHISTORY": "a study of the development of cultures [n ETHNOHISTORIES]\n",
  "ETHNOLINGUIST": "one who studies the relationship between language and cultural behaviour [n -S]\n",
  "ETHNOLINGUISTIC": "pertaining to the study of the relationship between language and cultural behaviour [adj]\n",
  "ETHNOLINGUISTS": "ETHNOLINGUIST, one who studies the relationship between language and cultural behaviour [n]\n",
  "ETHNOLOGIC": "relating to ethnology, cultural anthropology, also ETHNOLOGICAL [adj ETHNOLOGICALLY]\n",
  "ETHNOLOGICAL": "relating to ethnology, cultural anthropology, also ETHNOLOGIC [adj ETHNOLOGICALLY]\n",
  "ETHNOLOGICALLY": "ETHNOLOGICAL, relating to ethnology, cultural anthropology, also ETHNOLOGIC [adv]\n",
  "ETHNOLOGIES": "ETHNOLOGY, cultural anthropology; the science concerned with the varieties of the human race [n]\n",
  "ETHNOLOGIST": "a student of ethnology [n -S]\n",
  "ETHNOLOGISTS": "ETHNOLOGIST, a student of ethnology [n]\n",
  "ETHNOLOGY": "cultural anthropology; the science concerned with the varieties of the human race [n ETHNOLOGIES]\n",
  "ETHNOMEDICINE": "a branch of ethnobotany or medical anthropology that deals with the study of traditional medicines [n -S]\n",
  "ETHNOMEDICINES": "ETHNOMEDICINE, a branch of ethnobotany or medical anthropology that deals with the study of traditional medicines [n]\n",
  "ETHNOMUSICOLOGY": "the study of comparative musical systems [n]\n",
  "ETHNONYM": "the name of an ethnic group [n -S]\n",
  "ETHNONYMS": "ETHNONYM, the name of an ethnic group [n]\n",
  "ETHNOS": "(Greek) a group of people who share a common culture [n ETHNE or ETHNOSES]\n",
  "ETHNOSCIENCE": "the study of a culture's system of classifying knowledge (as its taxonomy of plants and animals) [n -S]\n",
  "ETHNOSCIENCES": "ETHNOSCIENCE, the study of a culture's system of classifying knowledge (as its taxonomy of plants and animals) [n]\n",
  "ETHNOSES": "ETHNOS, (Greek) a group of people who share a common culture [n]\n",
  "ETHOGRAM": "a list of the behavior patterns of a species [n -S]\n",
  "ETHOGRAMS": "ETHOGRAM, a list of the behavior patterns of a species [n]\n",
  "ETHOLOGIC": "relating to ethology, the study of animals' behavior in their natural environments, also ETHOLOGICAL [adj ETHOLOGICALLY]\n",
  "ETHOLOGICAL": "relating to ethology, also ETHOLOGIC [adj ETHOLOGICALLY]\n",
  "ETHOLOGICALLY": "ETHOLOGICAL, relating to ethology, also ETHOLOGIC [adv]\n",
  "ETHOLOGIES": "ETHOLOGY, the study of animal behaviour [n]\n",
  "ETHOLOGIST": "one who studies or writes upon ethology [n -S]\n",
  "ETHOLOGISTS": "ETHOLOGIST, one who studies or writes upon ethology [n]\n",
  "ETHOLOGY": "the study of animal behaviour [n ETHOLOGIES]\n",
  "ETHONONE": "a toxic gas [n -S]\n",
  "ETHONONES": "ETHONONE, a toxic gas [n]\n",
  "ETHOS": "(Greek) the fundamental character of a culture [n -ES]\n",
  "ETHOSES": "ETHOS, (Greek) the fundamental character of a culture [n]\n",
  "ETHOXIDE": "a type of saltlike compound with metal and organic components, also ETHYLATE [n -S]\n",
  "ETHOXIDES": "ETHOXIDE, a type of saltlike compound with metal and organic components, also ETHYLATE [n]\n",
  "ETHOXIES": "ETHOXY, a univalent chemical radical, also ETHOXYL [n]\n",
  "ETHOXY": "a univalent chemical radical, also ETHOXYL [n ETHOXIES]\n",
  "ETHOXYETHANE": "a type of ether, aka diethyl ether, an isomer of butanol [n -S]\n",
  "ETHOXYETHANES": "ETHOXYETHANE, a type of ether, aka diethyl ether, an isomer of butanol [n]\n",
  "ETHOXYL": "a univalent chemical radical, also ETHOXY [n -S]\n",
  "ETHOXYLS": "ETHOXYL, a univalent chemical radical, also ETHOXY [n]\n",
  "ETHS": "ETH, an Old English letter, also EDH [n]\n",
  "ETHYL": "a univalent chemical radical, also ETHINYL, ETHOXY, ETHOXYL, ETHYNYL [n -S]\n",
  "ETHYLAMINE": "a colorless, mobile, inflammable liquid, very volatile and with an ammoniacal odor [n -S]\n",
  "ETHYLAMINES": "ETHYLAMINE, a colorless, mobile, inflammable liquid, very volatile and with an ammoniacal odor [n]\n",
  "ETHYLATE": "to introduce the ethyl group into [v ETHYLATED, ETHYLATING, ETHYLATES]\n",
  "ETHYLATED": "ETHYLATE, to introduce the ethyl group into [v]\n",
  "ETHYLATES": "ETHYLATE, to introduce the ethyl group into [v]\n",
  "ETHYLATING": "ETHYLATE, to introduce the ethyl group into [v]\n",
  "ETHYLATION": "a chemical reaction in which an ethyl group is introduced into a molecule [n -S]\n",
  "ETHYLATIONS": "ETHYLATION, a chemical reaction in which an ethyl group is introduced into a molecule [n]\n",
  "ETHYLBENZENE": "a liquid aromatic hydrocarbon used chiefly in the manufacture of styrene [n -S]\n",
  "ETHYLBENZENES": "ETHYLBENZENE, a liquid aromatic hydrocarbon used chiefly in the manufacture of styrene [n]\n",
  "ETHYLENE": "an oil-forming gas, hydrogen combined with carbon, also ETHENE [n -S]\n",
  "ETHYLENES": "ETHYLENE, an oil-forming gas, hydrogen combined with carbon, also ETHENE [n]\n",
  "ETHYLENIC": "of or like ethylene, a flammable gas, present in coal gas [adj]\n",
  "ETHYLIC": "pertaining to, derived from, or containing, ethyl; as, ethylic alcohol [adj]\n",
  "ETHYLS": "ETHYL, a univalent chemical radical, also ETHINYL, ETHOXY, ETHOXYL, ETHYNYL [n]\n",
  "ETHYNE": "a colourless toxic inflammable gas formed by the action of water on calcium carbide, aka acetylene [n -S]\n",
  "ETHYNES": "ETHYNE, a colourless toxic inflammable gas formed by the action of water on calcium carbide, aka acetylene [n]\n",
  "ETHYNYL": "a univalent chemical radical, also ETHINYL [n -S]\n",
  "ETHYNYLS": "ETHYNYL, a univalent chemical radical, also ETHINYL [n]\n",
  "ETIC": "a type of linguistic analysis [n -S]\n",
  "ETICS": "ETIC, a type of linguistic analysis [n]\n",
  "ETIOLATE": "to make pale by preventing exposure to sunlight [v ETIOLATED, ETIOLATING, ETIOLATES]\n",
  "ETIOLATED": "ETIOLATE, to make pale by preventing exposure to sunlight [v]\n",
  "ETIOLATES": "ETIOLATE, to make pale by preventing exposure to sunlight [v]\n",
  "ETIOLATING": "ETIOLATE, to make pale by preventing exposure to sunlight [v]\n",
  "ETIOLATION": "the operation of blanching plants, by excluding the light of the sun; the condition of a blanched plant [n -S]\n",
  "ETIOLATIONS": "ETIOLATION, the operation of blanching plants, by excluding the light of the sun; the condition of a blanched plant [n]\n",
  "ETIOLIN": "a yellow pigment in light-starved plants [n -S]\n",
  "ETIOLINS": "ETIOLIN, a yellow pigment in light-starved plants [n]\n",
  "ETIOLOGIC": "relating to etiology, the study of causes, also ETIOLOGICAL [adj ETIOLOGICALLY]\n",
  "ETIOLOGICAL": "relating to etiology, the study of causes, also ETIOLOGIC [adj ETIOLOGICALLY]\n",
  "ETIOLOGICALLY": "ETIOLOGICAL, relating to etiology, the study of causes, also ETIOLOGIC [adv]\n",
  "ETIOLOGIES": "ETIOLOGY, the science of causes, esp. of disease, also AETIOLOGY [n]\n",
  "ETIOLOGIST": "a student of etiology, also AETIOLOGIST [n -S]\n",
  "ETIOLOGISTS": "ETIOLOGIST, a student of etiology, also AETIOLOGIST [n]\n",
  "ETIOLOGY": "the science of causes, esp. of disease, also AETIOLOGY [n ETIOLOGIES]\n",
  "ETIQUETTE": "(French) the conventional rules of personal behaviour in polite society [n -S]\n",
  "ETIQUETTES": "ETIQUETTE, (French) the conventional rules of personal behaviour in polite society [n]\n",
  "ETNA": "a vessel for heating liquids [n -S]\n",
  "ETNAS": "ETNA, a vessel for heating liquids [n]\n",
  "ETOILE": "(French) in heraldry, a six-pointed star whose rays are wavy, instead of straight like those of a mullet, also ESTOILE [n -S]\n",
  "ETOILES": "ETOILE, (French) in heraldry, a six-pointed star whose rays are wavy, instead of straight like those of a mullet, also ESTOILE [n]\n",
  "ETONOGESTREL": "a molecule used in certain hormonal contraceptives [n -S]\n",
  "ETONOGESTRELS": "ETONOGESTREL, a molecule used in certain hormonal contraceptives [n]\n",
  "ETOUFFEE": "(French) a Cajun stew [n -S]\n",
  "ETOUFFEES": "ETOUFFEE, (French) a Cajun stew [n]\n",
  "ETOURDERIE": "(French) heedlessness or stupid blundering [n -S]\n",
  "ETOURDERIES": "ETOURDERIE, (French) heedlessness or stupid blundering [n]\n",
  "ETOURDI": "(French) foolish, thoughtless (of a male) [adj]\n",
  "ETOURDIE": "(French) foolish, thoughtless (of a female) [adj]\n",
  "ETRANGER": "(French) a (male) foreigner [n -S]\n",
  "ETRANGERE": "(French) a (female) foreigner [n -S]\n",
  "ETRANGERES": "ETRANGERE, (French) a (female) foreigner [n]\n",
  "ETRANGERS": "ETRANGER, (French) a (male) foreigner [n]\n",
  "ETRENNE": "(French) a New Year's gift [n -S]\n",
  "ETRENNES": "ETRENNE, (French) a New Year's gift [n]\n",
  "ETRIER": "(French) a small rope ladder used by mountaineers [n -S]\n",
  "ETRIERS": "ETRIER, (French) a small rope ladder used by mountaineers [n]\n",
  "ETTERCAP": "(Scots) a spider, also ATTERCOP, ETHERCAP [n -S]\n",
  "ETTERCAPS": "ETTERCAP, (Scots) a spider, also ATTERCOP, ETHERCAP [n]\n",
  "ETTIN": "(archaic) a giant, also ETEN [n -S]\n",
  "ETTINS": "ETTIN, (archaic) a giant, also ETEN [n]\n",
  "ETTLE": "(Scots) to intend, purpose [v ETTLED, ETTLING, ETTLES]\n",
  "ETTLED": "ETTLE, (Scots) to intend, purpose [v]\n",
  "ETTLES": "ETTLE, (Scots) to intend, purpose [v]\n",
  "ETTLING": "ETTLE, (Scots) to intend, purpose [v]\n",
  "ETUDE": "(French) a composition in the fine arts which is intended, or may serve, for a study [n -S]\n",
  "ETUDES": "ETUDE, (French) a composition in the fine arts which is intended, or may serve, for a study [n]\n",
  "ETUI": "(French) a small ornamental case for holding e.g. needles, also ETWEE [n -S]\n",
  "ETUIS": "ETUI, (French) a small ornamental case for holding e.g. needles, also ETWEE [n]\n",
  "ETWEE": "a small ornamental case for holding, e.g. needles, also ETUI [n -S]\n",
  "ETWEES": "ETWEE, a small ornamental case for holding, e.g. needles, also ETUI [n]\n",
  "ETYMA": "ETYMON, the true origin of a word [n]\n",
  "ETYMIC": "relating to the etymon, the original form of a word, as, an etymic word [adj]\n",
  "ETYMOLOGICA": "ETYMOLOGICON, an etymological dictionary, also ETYMOLOGICUM [n]\n",
  "ETYMOLOGICAL": "related to etymology [adj ETYMOLOGICALLY]\n",
  "ETYMOLOGICALLY": "ETYMOLOGICAL, related to etymology [adv]\n",
  "ETYMOLOGICON": "an etymological dictionary, also ETYMOLOGICUM [n ETYMOLOGICA]\n",
  "ETYMOLOGICUM": "an etymological dictionary, also ETYMOLOGICON [n ETYMOLOGICA]\n",
  "ETYMOLOGIES": "ETYMOLOGY, the study of the origins of words [n]\n",
  "ETYMOLOGISE": "to trace or suggest an etymology for, also ETYMOLOGIZE [v ETYMOLOGISED, ETYMOLOGISING, ETYMOLOGISES]\n",
  "ETYMOLOGISED": "ETYMOLOGISE, to trace or suggest an etymology for, also ETYMOLOGIZE [v]\n",
  "ETYMOLOGISES": "ETYMOLOGISE, to trace or suggest an etymology for, also ETYMOLOGIZE [v]\n",
  "ETYMOLOGISING": "ETYMOLOGISE, to trace or suggest an etymology for, also ETYMOLOGIZE [v]\n",
  "ETYMOLOGIST": "a specialist in etymology [n -S]\n",
  "ETYMOLOGISTS": "ETYMOLOGIST, a specialist in etymology [n]\n",
  "ETYMOLOGIZE": "to discover, formulate, or state an etymology for, also ETYMOLOGISE [v ETYMOLOGIZED, ETYMOLOGIZING, ETYMOLOGIZES]\n",
  "ETYMOLOGIZED": "ETYMOLOGIZE, to discover, formulate, or state an etymology for, also ETYMOLOGISE [v]\n",
  "ETYMOLOGIZES": "ETYMOLOGIZE, to discover, formulate, or state an etymology for, also ETYMOLOGISE [v]\n",
  "ETYMOLOGIZING": "ETYMOLOGIZE, to discover, formulate, or state an etymology for, also ETYMOLOGISE [v]\n",
  "ETYMOLOGY": "the study of the origins of words [n ETYMOLOGIES]\n",
  "ETYMON": "the true origin of a word [n ETYMONS or ETYMA]\n",
  "ETYMONS": "ETYMON, the true origin of a word [n]\n",
  "ETYPIC": "not conforming to a type, also ETYPICAL [adj]\n",
  "ETYPICAL": "not conforming to a type, also ETYPIC [adj]\n",
  "EUBACTERIA": "EUBACTERIUM, a member of the Eubacteriales; any typical bacterium [n]\n",
  "EUBACTERIUM": "a member of the Eubacteriales; any typical bacterium [n EUBACTERIA]\n",
  "EUCAIN": "an anaesthetic safer than cocaine, also EUCAINE [n -S]\n",
  "EUCAINE": "an anaesthetic safer than cocaine, also EUCAIN [n -S]\n",
  "EUCAINES": "EUCAINE, an anaesthetic safer than cocaine, also EUCAIN [n]\n",
  "EUCAINS": "EUCAIN, an anaesthetic safer than cocaine, also EUCAINE [n]\n",
  "EUCALYPT": "a large Australian tree, also EUCALYPTUS [n -S]\n",
  "EUCALYPTI": "EUCALYPTUS, a large Australian tree, also EUCALYPT [n]\n",
  "EUCALYPTOL": "a volatile, terpene-like oil extracted from the eucalyptus, also EUCALYPTOLE [n -S]\n",
  "EUCALYPTOLE": "a volatile, terpene-like oil extracted from the eucalyptus, also EUCALYPTOL [n -S]\n",
  "EUCALYPTOLES": "EUCALYPTOLE, a volatile, terpene-like oil extracted from the eucalyptus, also EUCALYPTOL [n]\n",
  "EUCALYPTOLS": "EUCALYPTOL, a volatile, terpene-like oil extracted from the eucalyptus, also EUCALYPTOLE [n]\n",
  "EUCALYPTS": "EUCALYPT, a large Australian tree, also EUCALYPTUS [n]\n",
  "EUCALYPTUS": "a large Australian tree, also EUCALYPT [n EUCALYPTI or EUCALYPTUSES]\n",
  "EUCALYPTUSES": "EUCALYPTUS, a large Australian tree, also EUCALYPT [n]\n",
  "EUCARYON": "a type of cell nucleus, also EUKARYON [n -S]\n",
  "EUCARYONS": "EUCARYON, a type of cell nucleus, also EUKARYON [n]\n",
  "EUCARYOT": "an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOTE, EUKARYOT, EUKARYOTE [n -S]\n",
  "EUCARYOTE": "an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOT, EUKARYOT, EUKARYOTE [n -S]\n",
  "EUCARYOTES": "EUCARYOTE, an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOT, EUKARYOT, EUKARYOTE [n]\n",
  "EUCARYOTIC": "of or like a eucaryote, an organism whose cells have a eukaryon, a highly organised nucleus, also EUKARYOTIC [adj]\n",
  "EUCARYOTS": "EUCARYOT, an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOTE, EUKARYOT, EUKARYOTE [n]\n",
  "EUCHARIS": "(Greek) a plant of a genus of South American bulbous plants with fragrant white flowers [n -ES]\n",
  "EUCHARISES": "EUCHARIS, (Greek) a plant of a genus of South American bulbous plants with fragrant white flowers [n]\n",
  "EUCHARISTIC": "relating to the Eucharist [adj]\n",
  "EUCHLORIC": "relating to, or consisting of, euchlorine [adj]\n",
  "EUCHLORIN": "an explosive gas, a mixture of chlorine and chlorine dioxide, also EUCHLORINE [n -S]\n",
  "EUCHLORINE": "a highly explosive green-coloured gas, a mixture of chlorine with chlorine peroxide, also EUCHLORIN [n -S]\n",
  "EUCHLORINES": "EUCHLORINE, a highly explosive green-coloured gas, a mixture of chlorine with chlorine peroxide, also EUCHLORIN [n]\n",
  "EUCHLORINS": "EUCHLORIN, an explosive gas, a mixture of chlorine and chlorine dioxide, also EUCHLORINE [n]\n",
  "EUCHOLOGIA": "EUCHOLOGION, (Greek) a formulary of prayers, esp. that of the Greek Church, also EUCHOLOGY [n]\n",
  "EUCHOLOGIES": "EUCHOLOGY, (Greek) a formulary of prayers, esp. that of the Greek Church, also EUCHOLOGION [n]\n",
  "EUCHOLOGION": "(Greek) a formulary of prayers, esp. that of the Greek Church, also EUCHOLOGY [n EUCHOLOGIA]\n",
  "EUCHOLOGY": "(Greek) a formulary of prayers, esp. that of the Greek Church, also EUCHOLOGION [n EUCHOLOGIES]\n",
  "EUCHRE": "to prevent from winning three tricks in a card game [v EUCHRED, EUCHRING, EUCHRES]\n",
  "EUCHRED": "EUCHRE, to prevent from winning three tricks in a card game [v]\n",
  "EUCHRES": "EUCHRE, to prevent from winning three tricks in a card game [v]\n",
  "EUCHRING": "EUCHRE, to prevent from winning three tricks in a card game [v]\n",
  "EUCHROMATIC": "of or like euchromatin [adj]\n",
  "EUCHROMATIN": "the part of chromatin that is genetically active and is largely composed of genes [n -S]\n",
  "EUCHROMATINS": "EUCHROMATIN, the part of chromatin that is genetically active and is largely composed of genes [n]\n",
  "EUCLASE": "a mineral, hydrated beryllium aluminium silicate occurring in pale-green transparent crystals [n -S]\n",
  "EUCLASES": "EUCLASE, a mineral, hydrated beryllium aluminium silicate occurring in pale-green transparent crystals [n]\n",
  "EUCLIDEAN": "related to Euclid, or to the geometry of Euclid, also EUCLIDIAN [adj]\n",
  "EUCLIDIAN": "related to Euclid, or to the geometry of Euclid, also EUCLIDEAN [adj]\n",
  "EUCRITE": "a gabbroitic rock composed of lime-feldspar, pyroxenes and olivine [n -S]\n",
  "EUCRITES": "EUCRITE, a gabbroitic rock composed of lime-feldspar, pyroxenes and olivine [n]\n",
  "EUCRITIC": "of or like eucrite, a gabbroitic rock [adj]\n",
  "EUCRYPHIA": "a tree or shrub of the mostly evergreen genus Eucryphia [n -S]\n",
  "EUCRYPHIAS": "EUCRYPHIA, a tree or shrub of the mostly evergreen genus Eucryphia [n]\n",
  "EUCYCLIC": "having the same number of leaves in each whorl [adj]\n",
  "EUDAEMON": "(Greek) a benevolent spirit, also EUDAIMON, EUDEMON [n -S]\n",
  "EUDAEMONIA": "(Greek) happiness or wellbeing; in Aristotelian philosophy, a full, active life governed by reason, also EUDEMONIA [n -S]\n",
  "EUDAEMONIAS": "EUDAEMONIA, (Greek) happiness or wellbeing; in Aristotelian philosophy, a full, active life governed by reason, also EUDEMONIA [n]\n",
  "EUDAEMONIC": "relating to eudaemonism, the theory that the highest ethical goal is happiness and personal wellbeing [adj]\n",
  "EUDAEMONICS": "the art or theory of happiness, also EUDEMONICS [n]\n",
  "EUDAEMONIES": "EUDAEMONY, (Greek) happiness or wellbeing [n]\n",
  "EUDAEMONISM": "the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAIMONISM, EUDEMONISM [n -S]\n",
  "EUDAEMONISMS": "EUDAEMONISM, the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAIMONISM, EUDEMONISM [n]\n",
  "EUDAEMONIST": "a student of eudemonics, the art or theory of happiness, also EUDEMONIST [n -S]\n",
  "EUDAEMONISTIC": "relating to eudaemonism, the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAEMONISTICAL, EUDEMONISTIC, EUDEMONISTICAL [adj]\n",
  "EUDAEMONISTICAL": "relating to eudaemonism, the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAEMONISTIC, EUDEMONISTIC, EUDEMONISTICAL [adj]\n",
  "EUDAEMONISTS": "EUDAEMONIST, a student of eudemonics, the art or theory of happiness, also EUDEMONIST [n]\n",
  "EUDAEMONS": "EUDAEMON, (Greek) a benevolent spirit, also EUDAIMON, EUDEMON [n]\n",
  "EUDAEMONY": "(Greek) happiness or wellbeing [n EUDAEMONIES]\n",
  "EUDAIMON": "(Greek) a benevolent spirit, also EUDAEMON, EUDEMON [n -S]\n",
  "EUDAIMONISM": "the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAEMONISM, EUDEMONISM [n -S]\n",
  "EUDAIMONISMS": "EUDAIMONISM, the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAEMONISM, EUDEMONISM [n]\n",
  "EUDAIMONS": "EUDAIMON, (Greek) a benevolent spirit, also EUDAEMON, EUDEMON [n]\n",
  "EUDEMON": "(Greek) a benevolent spirit, also EUDAEMON, EUDAIMON [n -S]\n",
  "EUDEMONIA": "(Greek) happiness esp. that resulting from a rational active life, also EUDAEMONIA [n -S]\n",
  "EUDEMONIAS": "EUDEMONIA, (Greek) happiness esp. that resulting from a rational active life, also EUDAEMONIA [n]\n",
  "EUDEMONIC": "relating to eudemonia [adj]\n",
  "EUDEMONICS": "the art or theory of happiness, also EUDAEMONICS [n]\n",
  "EUDEMONISM": "the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAEMONISM, EUDAIMONISM [n -S]\n",
  "EUDEMONISMS": "EUDEMONISM, the theory that the highest ethical goal is happiness and personal wellbeing, also EUDAEMONISM, EUDAIMONISM [n]\n",
  "EUDEMONIST": "a student of eudemonics, the art or theory of happiness, also EUDAEMONIST [n -S]\n",
  "EUDEMONISTIC": "relating to eudemonism, ethics evaluating morality in terms of ability to promote happiness, also EUDAEMONISTIC, EUDAEMONISTICAL, EUDEMONISTICAL [adj]\n",
  "EUDEMONISTICAL": "relating to eudemonism, ethics evaluating morality in terms of ability to promote happiness, also EUDAEMONISTIC, EUDAEMONISTICAL, EUDEMONISTIC [adj]\n",
  "EUDEMONISTS": "EUDEMONIST, a student of eudemonics, the art or theory of happiness, also EUDAEMONIST [n]\n",
  "EUDEMONS": "EUDEMON, (Greek) a benevolent spirit, also EUDAEMON, EUDAIMON [n]\n",
  "EUDIALYTE": "a silicate of zirconium, sodium, calcium and iron, occurring in Greenland, easily dissolved by acids [n -S]\n",
  "EUDIALYTES": "EUDIALYTE, a silicate of zirconium, sodium, calcium and iron, occurring in Greenland, easily dissolved by acids [n]\n",
  "EUDICOTYLEDON": "an angiosperm having two cotyledons in the seed [n -S]\n",
  "EUDICOTYLEDONS": "EUDICOTYLEDON, an angiosperm having two cotyledons in the seed [n]\n",
  "EUDIOMETER": "an apparatus for gas analysis [n -S]\n",
  "EUDIOMETERS": "EUDIOMETER, an apparatus for gas analysis [n]\n",
  "EUDIOMETRIC": "relating to a eudiometer, also EUDIOMETRICAL [adj]\n",
  "EUDIOMETRICAL": "relating to a eudiometer, also EUDIOMETRIC [adj]\n",
  "EUDIOMETRICALLY": "EUDIOMETRICAL, relating to a eudiometer, also EUDIOMETRIC [adv]\n",
  "EUDIOMETRIES": "EUDIOMETRY, measurement by use of a eudiometer, an apparatus for gas analysis [n]\n",
  "EUDIOMETRY": "measurement by use of a eudiometer, an apparatus for gas analysis [n EUDIOMETRIES]\n",
  "EUGARIE": "(Native Australian) another name for pipi, any of various shellfishes, also YUGARIE [n -S]\n",
  "EUGARIES": "EUGARIE, (Native Australian) another name for pipi, any of various shellfishes, also YUGARIE [n]\n",
  "EUGE": "(Greek) an interjection meaning well done [interj]\n",
  "EUGENECIST": "a student or advocate of eugenics, also EUGENICIST [n -S]\n",
  "EUGENECISTS": "EUGENECIST, a student or advocate of eugenics, also EUGENICIST [n]\n",
  "EUGENIA": "a genus of myrtaceous plants, mostly of tropical countries, and including several aromatic trees and shrubs [n -S]\n",
  "EUGENIAS": "EUGENIA, a genus of myrtaceous plants, mostly of tropical countries, and including several aromatic trees and shrubs [n]\n",
  "EUGENIC": "relating to genetic improvement of a race by judicious mating, also EUGENICAL [adj EUGENICALLY]\n",
  "EUGENICAL": "relating to genetic improvement of a race by judicious mating, also EUGENIC [adj EUGENICALLY]\n",
  "EUGENICALLY": "EUGENICAL, relating to genetic improvement of a race by judicious mating, also EUGENIC [adv]\n",
  "EUGENICIST": "a student or advocate of eugenics, also EUGENECIST [n -S]\n",
  "EUGENICISTS": "EUGENICIST, a student or advocate of eugenics, also EUGENECIST [n]\n",
  "EUGENICS": "the genetic improvement of a race by selective breeding [n]\n",
  "EUGENISM": "advocacy of eugenics [n -S]\n",
  "EUGENISMS": "EUGENISM, advocacy of eugenics [n]\n",
  "EUGENIST": "a student of eugenics [n -S]\n",
  "EUGENISTS": "EUGENIST, a student of eugenics [n]\n",
  "EUGENOL": "an aromatic liquid [n -S]\n",
  "EUGENOLS": "EUGENOL, an aromatic liquid [n]\n",
  "EUGEOSYNCLINAL": "of or like a eugeosyncline [adj]\n",
  "EUGEOSYNCLINE": "a narrow rapidly subsiding geosyncline usually with volcanic materials mingled with clastic sediments [n -S]\n",
  "EUGEOSYNCLINES": "EUGEOSYNCLINE, a narrow rapidly subsiding geosyncline usually with volcanic materials mingled with clastic sediments [n]\n",
  "EUGH": "(Spenser) a yew [n -S]\n",
  "EUGHEN": "(Spenser) made of yew-wood, also EWGHEN, YEWEN [adj]\n",
  "EUGHS": "EUGH, (Spenser) a yew [n]\n",
  "EUGLENA": "a photosynthesizing, motile protozoan, also EUGLENID [n -S]\n",
  "EUGLENAS": "EUGLENA, a photosynthesizing, motile protozoan, also EUGLENID [n]\n",
  "EUGLENID": "a photosynthesizing, motile protozoan, also EUGLENA [n -S]\n",
  "EUGLENIDS": "EUGLENID, a photosynthesizing, motile protozoan, also EUGLENA [n]\n",
  "EUGLENOID": "any member of the Euglenia, a genus of aquatic unicellular organisms [n -S]\n",
  "EUGLENOIDS": "EUGLENOID, any member of the Euglenia, a genus of aquatic unicellular organisms [n]\n",
  "EUGLOBULIN": "a simple protein that does not dissolve in pure water [n -S]\n",
  "EUGLOBULINS": "EUGLOBULIN, a simple protein that does not dissolve in pure water [n]\n",
  "EUHARMONIC": "producing mathematically perfect harmony or concord; sweetly or perfectly harmonious [adj]\n",
  "EUHEMERISE": "to give a historical explanation for a myth, also EUHEMERIZE [v EUHEMERISED, EUHEMERISING, EUHEMERISES]\n",
  "EUHEMERISED": "EUHEMERISE, to give a historical explanation for a myth, also EUHEMERIZE [v]\n",
  "EUHEMERISES": "EUHEMERISE, to give a historical explanation for a myth, also EUHEMERIZE [v]\n",
  "EUHEMERISING": "EUHEMERISE, to give a historical explanation for a myth, also EUHEMERIZE [v]\n",
  "EUHEMERISM": "the interpretation of myths as traditional accounts of historical persons and events [n -S]\n",
  "EUHEMERISMS": "EUHEMERISM, the interpretation of myths as traditional accounts of historical persons and events [n]\n",
  "EUHEMERIST": "one who advocates euhemerism [n -S]\n",
  "EUHEMERISTIC": "relating to euhemerism [adj]\n",
  "EUHEMERISTS": "EUHEMERIST, one who advocates euhemerism [n]\n",
  "EUHEMERIZE": "to give a historical explanation for a myth, also EUHEMERISE [v EUHEMERIZED, EUHEMERIZING, EUHEMERIZES]\n",
  "EUHEMERIZED": "EUHEMERIZE, to give a historical explanation for a myth, also EUHEMERISE [v]\n",
  "EUHEMERIZES": "EUHEMERIZE, to give a historical explanation for a myth, also EUHEMERISE [v]\n",
  "EUHEMERIZING": "EUHEMERIZE, to give a historical explanation for a myth, also EUHEMERISE [v]\n",
  "EUK": "(dialect) to itch, also EWK, YEUK, YOUK, YUKE [v -ED, -ING, -S]\n",
  "EUKARYON": "a type of cell nucleus, also EUCARYON [n -S]\n",
  "EUKARYONS": "EUKARYON, a type of cell nucleus, also EUCARYON [n]\n",
  "EUKARYOT": "an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOT, EUCARYOTE, EUKARYOTE [n -S]\n",
  "EUKARYOTE": "an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOT, EUCARYOTE, EUKARYOT [n -S]\n",
  "EUKARYOTES": "EUKARYOTE, an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOT, EUCARYOTE, EUKARYOT [n]\n",
  "EUKARYOTIC": "of or like a eukaryote, an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOTIC [adj]\n",
  "EUKARYOTS": "EUKARYOT, an organism whose cells have a eukaryon, a highly organised nucleus, also EUCARYOT, EUCARYOTE, EUKARYOTE [n]\n",
  "EUKED": "EUK, (dialect) to itch, also EWK, YEUK, YOUK, YUKE [v]\n",
  "EUKING": "EUK, (dialect) to itch, also EWK, YEUK, YOUK, YUKE [v]\n",
  "EUKS": "EUK, (dialect) to itch, also EWK, YEUK, YOUK, YUKE [v]\n",
  "EULACHAN": "(Native American) the north Pacific candlefish, also EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n -S]\n",
  "EULACHANS": "EULACHAN, (Native American) the north Pacific candlefish, also EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n]\n",
  "EULACHON": "(Native American) the north Pacific candlefish, also EULACHAN, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n -S]\n",
  "EULACHONS": "EULACHON, (Native American) the north Pacific candlefish, also EULACHAN, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n]\n",
  "EULOGIA": "(Latin) a blessing; holy bread [n EULOGIAE or EULOGIAS]\n",
  "EULOGIAE": "EULOGIA, (Latin) a blessing; holy bread [n]\n",
  "EULOGIAS": "EULOGIA, (Latin) a blessing; holy bread [n]\n",
  "EULOGIES": "EULOGY, a speech or writing in praise, also EULOGIUM [n]\n",
  "EULOGISE": "to extol, also EULOGIZE [v EULOGISED, EULOGISING, EULOGISES]\n",
  "EULOGISED": "EULOGISE, to extol, also EULOGIZE [v]\n",
  "EULOGISER": "one who eulogises, also EULOGIZER [n -S]\n",
  "EULOGISERS": "EULOGISER, one who eulogises, also EULOGIZER [n]\n",
  "EULOGISES": "EULOGISE, to extol, also EULOGIZE [v]\n",
  "EULOGISING": "EULOGISE, to extol, also EULOGIZE [v]\n",
  "EULOGIST": "one who composes eulogies [n -S]\n",
  "EULOGISTIC": "of or like a eulogy, also EULOGISTICAL [adj EULOGISTICALLY]\n",
  "EULOGISTICAL": "of or like a eulogy, also EULOGISTIC [adj EULOGISTICALLY]\n",
  "EULOGISTICALLY": "EULOGISTICAL, of or like a eulogy, also EULOGISTIC [adv]\n",
  "EULOGISTS": "EULOGIST, one who composes eulogies [n]\n",
  "EULOGIUM": "(Latin) a speech or writing in praise, also EULOGY [n -S]\n",
  "EULOGIUMS": "EULOGIUM, (Latin) a speech or writing in praise, also EULOGY [n]\n",
  "EULOGIZE": "to extol, also EULOGISE [v EULOGIZED, EULOGIZING, EULOGIZES]\n",
  "EULOGIZED": "EULOGIZE, to extol, also EULOGISE [v]\n",
  "EULOGIZER": "one who eulogizes, also EULOGISER [n -S]\n",
  "EULOGIZERS": "EULOGIZER, one who eulogizes, also EULOGISER [n]\n",
  "EULOGIZES": "EULOGIZE, to extol, also EULOGISE [v]\n",
  "EULOGIZING": "EULOGIZE, to extol, also EULOGISE [v]\n",
  "EULOGY": "a speech or writing in praise, also EULOGIUM [n EULOGIES]\n",
  "EUMELANIN": "any melanin pigment of darker type [n -S]\n",
  "EUMELANINS": "EUMELANIN, any melanin pigment of darker type [n]\n",
  "EUMERISM": "a biologic aggregation of similar parts [n -S]\n",
  "EUMERISMS": "EUMERISM, a biologic aggregation of similar parts [n]\n",
  "EUMONG": "(Native Australian) an Australian acacia, also EUMUNG [n -S]\n",
  "EUMONGS": "EUMONG, (Native Australian) an Australian acacia, also EUMUNG [n]\n",
  "EUMUNG": "(Native Australian) an Australian acacia, also EUMONG [n -S]\n",
  "EUMUNGS": "EUMUNG, (Native Australian) an Australian acacia, also EUMONG [n]\n",
  "EUNUCH": "a castrated man [n -S]\n",
  "EUNUCHISE": "to make a eunuch of, also EUNUCHIZE [v EUNUCHISED, EUNUCHISING, EUNUCHISES]\n",
  "EUNUCHISED": "EUNUCHISE, to make a eunuch of, also EUNUCHIZE [v]\n",
  "EUNUCHISES": "EUNUCHISE, to make a eunuch of, also EUNUCHIZE [v]\n",
  "EUNUCHISING": "EUNUCHISE, to make a eunuch of, also EUNUCHIZE [v]\n",
  "EUNUCHISM": "the state of being eunuch [n -S]\n",
  "EUNUCHISMS": "EUNUCHISM, the state of being eunuch [n]\n",
  "EUNUCHIZE": "to make a eunuch of, also EUNUCHISE [v EUNUCHIZED, EUNUCHIZING, EUNUCHIZES]\n",
  "EUNUCHIZED": "EUNUCHIZE, to make a eunuch of, also EUNUCHISE [v]\n",
  "EUNUCHIZES": "EUNUCHIZE, to make a eunuch of, also EUNUCHISE [v]\n",
  "EUNUCHIZING": "EUNUCHIZE, to make a eunuch of, also EUNUCHISE [v]\n",
  "EUNUCHOID": "having the characteristics of a eunuch [adj] / a eunuchoid person [n -S]\n",
  "EUNUCHOIDISM": "a condition in which there is a deficiency of sexual development and in which certain female sex characteristics are often present [n -S]\n",
  "EUNUCHOIDISMS": "EUNUCHOIDISM, a condition in which there is a deficiency of sexual development and in which certain female sex characteristics are often present [n]\n",
  "EUNUCHOIDS": "EUNUCHOID, a eunuchoid person [n]\n",
  "EUNUCHS": "EUNUCH, a castrated man [n]\n",
  "EUOI": "(Greek) expressing Bacchic frenzy, also EVOE, EVHOE, EVOHE [interj]\n",
  "EUONYMIN": "an extract of the bark of the euonymus [n -S]\n",
  "EUONYMINS": "EUONYMIN, an extract of the bark of the euonymus [n]\n",
  "EUONYMUS": "a plant of the burning bush family, also EVONYMUS [n -ES]\n",
  "EUONYMUSES": "EUONYMUS, a plant of the burning bush family, also EVONYMUS [n]\n",
  "EUOUAE": "(Latin) a name for a Gregorian cadence, also EVOVAE [n -S]\n",
  "EUOUAES": "EUOUAE, (Latin) a name for a Gregorian cadence, also EVOVAE [n]\n",
  "EUPAD": "an antiseptic powder [n -S]\n",
  "EUPADS": "EUPAD, an antiseptic powder [n]\n",
  "EUPATORIUM": "any plant of the genus Eupatorium, of tropical America and the Caribbean, cultivated for their ornamental clusters of purple, pink, or white flowers [n -S]\n",
  "EUPATORIUMS": "EUPATORIUM, any plant of the genus Eupatorium, of tropical America and the Caribbean, cultivated for their ornamental clusters of purple, pink, or white flowers [n]\n",
  "EUPATRID": "(Greek) a member of the aristocracy in ancient Greek states [n EUPATRIDAE or EUPATRIDS]\n",
  "EUPATRIDAE": "EUPATRID, (Greek) a member of the aristocracy in ancient Greek states [n]\n",
  "EUPATRIDS": "EUPATRID, (Greek) a member of the aristocracy in ancient Greek states [n]\n",
  "EUPEPSIA": "a good digestion, also EUPEPSY [n -S]\n",
  "EUPEPSIAS": "EUPEPSIA, a good digestion, also EUPEPSY [n]\n",
  "EUPEPSIES": "EUPEPSY, a good digestion, also EUPEPSIA [n]\n",
  "EUPEPSY": "a good digestion, also EUPEPSIA [n EUPEPSIES]\n",
  "EUPEPTIC": "relating to or having good digestion; cheerful [adj]\n",
  "EUPEPTICITIES": "EUPEPTICITY, the state of being eupeptic [n]\n",
  "EUPEPTICITY": "the state of being eupeptic [n EUPEPTICITIES]\n",
  "EUPHAUSIACEAN": "a member of the Euphausiidae or the Euphausiacea, shrimplike creatures [n -S]\n",
  "EUPHAUSIACEANS": "EUPHAUSIACEAN, a member of the Euphausiidae or the Euphausiacea, shrimplike creatures [n]\n",
  "EUPHAUSID": "one of a genus of shrimplike crustaceans, also EUPHAUSIID [n -S]\n",
  "EUPHAUSIDS": "EUPHAUSID, one of a genus of shrimplike crustaceans, also EUPHAUSIID [n]\n",
  "EUPHAUSIID": "one of a genus of shrimplike crustaceans, also EUPHAUSID [n -S]\n",
  "EUPHAUSIIDS": "EUPHAUSIID, one of a genus of shrimplike crustaceans, also EUPHAUSID [n]\n",
  "EUPHEMISE": "to speak or write (of) euphemistically, also EUPHEMIZE [v EUPHEMISED, EUPHEMISING, EUPHEMISES]\n",
  "EUPHEMISED": "EUPHEMISE, to speak or write (of) euphemistically, also EUPHEMIZE [v]\n",
  "EUPHEMISER": "one who euphemises, also EUPHEMIZER [n -S]\n",
  "EUPHEMISERS": "EUPHEMISER, one who euphemises, also EUPHEMIZER [n]\n",
  "EUPHEMISES": "EUPHEMISE, to speak or write (of) euphemistically, also EUPHEMIZE [v]\n",
  "EUPHEMISING": "EUPHEMISE, to speak or write (of) euphemistically, also EUPHEMIZE [v]\n",
  "EUPHEMISM": "a figure of rhetoric by which an unpleasant or offensive thing is described or referred to by a milder term [n -S]\n",
  "EUPHEMISMS": "EUPHEMISM, a figure of rhetoric by which an unpleasant or offensive thing is described or referred to by a milder term [n]\n",
  "EUPHEMIST": "one who engages in euphemism [n -S]\n",
  "EUPHEMISTIC": "relating to euphemism [adj EUPHEMISTICALLY]\n",
  "EUPHEMISTICALLY": "EUPHEMISTIC, relating to euphemism [adv]\n",
  "EUPHEMISTS": "EUPHEMIST, one who engages in euphemism [n]\n",
  "EUPHEMIZE": "to speak or write (of) euphemistically, also EUPHEMISE [v EUPHEMIZED, EUPHEMIZING, EUPHEMIZES]\n",
  "EUPHEMIZED": "EUPHEMIZE, to speak or write (of) euphemistically, also EUPHEMISE [v]\n",
  "EUPHEMIZER": "one who euphemizes, also EUPHEMISER [n -S]\n",
  "EUPHEMIZERS": "EUPHEMIZER, one who euphemizes, also EUPHEMISER [n]\n",
  "EUPHEMIZES": "EUPHEMIZE, to speak or write (of) euphemistically, also EUPHEMISE [v]\n",
  "EUPHEMIZING": "EUPHEMIZE, to speak or write (of) euphemistically, also EUPHEMISE [v]\n",
  "EUPHENIC": "relating to the physical improvement of human beings by modifying their development after birth [adj]\n",
  "EUPHENICS": "the biological improvement of human beings after birth [n]\n",
  "EUPHOBIA": "a fear of good news [n -S]\n",
  "EUPHOBIAS": "EUPHOBIA, a fear of good news [n]\n",
  "EUPHON": "(Greek) a type of glass harmonica [n -S]\n",
  "EUPHONIA": "an agreeable sound, also EUPHONY [n -S]\n",
  "EUPHONIAS": "EUPHONIA, an agreeable sound, also EUPHONY [n]\n",
  "EUPHONIC": "pleasant sounding, also EUPHONICAL, EUPHONIOUS [adj EUPHONICALLY]\n",
  "EUPHONICAL": "agreeable in sound, also EUPHONIC, EUPHONIOUS [adj]\n",
  "EUPHONICALLY": "EUPHONICAL, agreeable in sound, also EUPHONIC, EUPHONIOUS [adv]\n",
  "EUPHONIES": "EUPHONY, an agreeable sound, also EUPHONIA [n]\n",
  "EUPHONIOUS": "agreeable in sound, also EUPHONIC, EUPHONICAL [adj EUPHONIOUSLY]\n",
  "EUPHONIOUSLY": "EUPHONIOUS, agreeable in sound, also EUPHONIC, EUPHONICAL [adv]\n",
  "EUPHONIOUSNESS": "EUPHONIOUS, agreeable in sound, also EUPHONIC, EUPHONICAL [n]\n",
  "EUPHONISE": "to make euphonic, pleasant sounding, also EUPHONIZE [v EUPHONISED, EUPHONISING, EUPHONISES]\n",
  "EUPHONISED": "EUPHONISE, to make euphonic, pleasant sounding, also EUPHONIZE [v]\n",
  "EUPHONISES": "EUPHONISE, to make euphonic, pleasant sounding, also EUPHONIZE [v]\n",
  "EUPHONISING": "EUPHONISE, to make euphonic, pleasant sounding, also EUPHONIZE [v]\n",
  "EUPHONISM": "the custom of using pleasing sounding words [n -S]\n",
  "EUPHONISMS": "EUPHONISM, the custom of using pleasing sounding words [n]\n",
  "EUPHONIUM": "a musical instrument like a tuba but with somewhat higher pitch [n -S]\n",
  "EUPHONIUMS": "EUPHONIUM, a musical instrument like a tuba but with somewhat higher pitch [n]\n",
  "EUPHONIZE": "to make euphonic, pleasant sounding, also EUPHONISE [v EUPHONIZED, EUPHONIZING, EUPHONIZES]\n",
  "EUPHONIZED": "EUPHONIZE, to make euphonic, pleasant sounding, also EUPHONISE [v]\n",
  "EUPHONIZES": "EUPHONIZE, to make euphonic, pleasant sounding, also EUPHONISE [v]\n",
  "EUPHONIZING": "EUPHONIZE, to make euphonic, pleasant sounding, also EUPHONISE [v]\n",
  "EUPHONS": "EUPHON, (Greek) a type of glass harmonica [n]\n",
  "EUPHONY": "an agreeable sound, also EUPHONIA [n EUPHONIES]\n",
  "EUPHORBIA": "any herb or shrub of the spurge family [n -S]\n",
  "EUPHORBIACEOUS": "belonging to the euphorbia family [adj]\n",
  "EUPHORBIAS": "EUPHORBIA, any herb or shrub of the spurge family [n]\n",
  "EUPHORBIUM": "the resinous gum of certain succulent plants of the genus Euphorbia, formerly used as an emetic and purgative [n -S]\n",
  "EUPHORBIUMS": "EUPHORBIUM, the resinous gum of certain succulent plants of the genus Euphorbia, formerly used as an emetic and purgative [n]\n",
  "EUPHORIA": "elation, also EUPHORY [n -S]\n",
  "EUPHORIANT": "a drug that tends to induce euphoria [n -S]\n",
  "EUPHORIANTS": "EUPHORIANT, a drug that tends to induce euphoria [n]\n",
  "EUPHORIAS": "EUPHORIA, elation, also EUPHORY [n]\n",
  "EUPHORIC": "overjoyed [adj EUPHORICALLY]\n",
  "EUPHORICALLY": "EUPHORIC, overjoyed [adv]\n",
  "EUPHORIES": "EUPHORY, elation, also EUPHORIA [n]\n",
  "EUPHORY": "elation, also EUPHORIA [n EUPHORIES]\n",
  "EUPHOTIC": "pertaining to the upper layer of a body of water [adj]\n",
  "EUPHRASIA": "eyebright, a plant once used to treat disorders of the eyes, also EUPHRASY [n -S]\n",
  "EUPHRASIAS": "EUPHRASIA, eyebright, a plant once used to treat disorders of the eyes, also EUPHRASY [n]\n",
  "EUPHRASIES": "EUPHRASY, eyebright, a plant once used to treat disorders of the eyes, also EUPHRASIA [n]\n",
  "EUPHRASY": "eyebright, a plant once used to treat disorders of the eyes, also EUPHRASIA [n EUPHRASIES]\n",
  "EUPHROE": "(Dutch) the wooden block through which the lines of a crowfoot are rove, also UPHROE [n -S]\n",
  "EUPHROES": "EUPHROE, (Dutch) the wooden block through which the lines of a crowfoot are rove, also UPHROE [n]\n",
  "EUPHUISE": "to write in an affected literary style, also EUPHUIZE [v EUPHUISED, EUPHUISING, EUPHUISES]\n",
  "EUPHUISED": "EUPHUISE, to write in an affected literary style, also EUPHUIZE [v]\n",
  "EUPHUISES": "EUPHUISE, to write in an affected literary style, also EUPHUIZE [v]\n",
  "EUPHUISING": "EUPHUISE, to write in an affected literary style, also EUPHUIZE [v]\n",
  "EUPHUISM": "an affected literary style [n -S]\n",
  "EUPHUISMS": "EUPHUISM, an affected literary style [n]\n",
  "EUPHUIST": "one given to euphuism [n -S]\n",
  "EUPHUISTIC": "characterised by euphuism, also EUPHUISTICAL [adj EUPHUISTICALLY]\n",
  "EUPHUISTICAL": "characterised by euphuism, also EUPHUISTIC [adj EUPHUISTICALLY]\n",
  "EUPHUISTICALLY": "EUPHUISTICAL, characterised by euphuism, also EUPHUISTIC [adv]\n",
  "EUPHUISTS": "EUPHUIST, one given to euphuism [n]\n",
  "EUPHUIZE": "to write in an affected literary style, also EUPHUISE [v EUPHUIZED, EUPHUIZING, EUPHUIZES]\n",
  "EUPHUIZED": "EUPHUIZE, to write in an affected literary style, also EUPHUISE [v]\n",
  "EUPHUIZES": "EUPHUIZE, to write in an affected literary style, also EUPHUISE [v]\n",
  "EUPHUIZING": "EUPHUIZE, to write in an affected literary style, also EUPHUISE [v]\n",
  "EUPLASTIC": "healing quickly and well [adj]\n",
  "EUPLASTICS": "the art of healing [n]\n",
  "EUPLOID": "having a chromosome complement that is an exact multiple of the haploid [adj] / a euploid animal [n -S]\n",
  "EUPLOIDIES": "EUPLOIDY, the state of being an euploid, that is, having a chromosome complement that is an exact multiple of the haploid [n]\n",
  "EUPLOIDS": "EUPLOID, a euploid animal [n]\n",
  "EUPLOIDY": "the state of being an euploid, that is, having a chromosome complement that is an exact multiple of the haploid [n EUPLOIDIES]\n",
  "EUPNEA": "normal breathing, also EUPNOEA [n -S]\n",
  "EUPNEAS": "EUPNEA, normal breathing, also EUPNOEA [n]\n",
  "EUPNEIC": "relating to eupnea, normal breathing, also EUPNOEIC [adj]\n",
  "EUPNOEA": "normal breathing, also EUPNEA [n -S]\n",
  "EUPNOEAS": "EUPNOEA, normal breathing, also EUPNEA [n]\n",
  "EUPNOEIC": "relating to eupnoea, normal breathing, also EUPNEIC [adj]\n",
  "EUREKA": "(Greek) the exclamation attributed to Archimedes, meaning I have found it! [interj] / a brilliant discovery, also HEUREKA [n -S]\n",
  "EUREKAS": "EUREKA, a brilliant discovery, also HEUREKA [n]\n",
  "EURHYTHMIC": "relating to eurhythmy, rhythmical movement or order, also EURHYTHMICAL, EURYTHMIC, EURYTHMICAL [adj]\n",
  "EURHYTHMICAL": "relating to eurhythmy, rhythmical movement or order, also EURHYTHMIC, EURYTHMIC, EURYTHMICAL [adj]\n",
  "EURHYTHMICS": "a system of training through physical movement, also EURYTHMICS [n]\n",
  "EURHYTHMIES": "EURHYTHMY, rhythmical movement or order, also EURYTHMY [n]\n",
  "EURHYTHMIST": "a practitioner of eurhythmics, also EURYTHMIST [n -S]\n",
  "EURHYTHMISTS": "EURHYTHMIST, a practitioner of eurhythmics, also EURYTHMIST [n]\n",
  "EURHYTHMY": "rhythmical movement or order, also EURYTHMY [n EURHYTHMIES]\n",
  "EURIPI": "EURIPUS, (Latin) a sea channel with strong currents [n]\n",
  "EURIPUS": "(Latin) a sea channel with strong currents [n EURIPUSES or EURIPI]\n",
  "EURIPUSES": "EURIPUS, (Latin) a sea channel with strong currents [n]\n",
  "EURO": "(Native Australian) any of several large types of kangaroo, aka wallaroo [n -S]\n",
  "EUROBOND": "a bond issued in a euro currency [n -S]\n",
  "EUROBONDS": "EUROBOND, a bond issued in a euro currency [n]\n",
  "EUROCHEQUE": "a cheque drawn on a European bank that can be cashed at any bank or bureau de change displaying the EC sign [n -S]\n",
  "EUROCHEQUES": "EUROCHEQUE, a cheque drawn on a European bank that can be cashed at any bank or bureau de change displaying the EC sign [n]\n",
  "EUROCRAT": "a senior member of the administration of the European Union [n -S]\n",
  "EUROCRATS": "EUROCRAT, a senior member of the administration of the European Union [n]\n",
  "EUROCREDIT": "a loan in which the currency of the loan is different from the national currency of the lending bank [n EUROCREDITS]\n",
  "EUROCREDITS": "EUROCREDIT, a loan in which the currency of the loan is different from the national currency of the lending bank [n]\n",
  "EUROCREEP": "the gradual introduction of the euro into use in Britain [n -S]\n",
  "EUROCREEPS": "EUROCREEP, the gradual introduction of the euro into use in Britain [n]\n",
  "EUROCURRENCIES": "EUROCURRENCY, a currency traded on the foreign currency markets of the European Union [n]\n",
  "EUROCURRENCY": "a currency traded on the foreign currency markets of the European Union [n EUROCURRENCIES]\n",
  "EURODEPOSIT": "a deposit of the currency of any country in the eurocurrency market [n -S]\n",
  "EURODEPOSITS": "EURODEPOSIT, a deposit of the currency of any country in the eurocurrency market [n]\n",
  "EURODOLLAR": "a United States dollar as part of a European holding [n -S]\n",
  "EURODOLLARS": "EURODOLLAR, a United States dollar as part of a European holding [n]\n",
  "EUROKIES": "EUROKY, the ability of an organism to live under various conditions, also EURYOKY [n]\n",
  "EUROKOUS": "of an organism, able to live under different conditions, also EURYOKOUS [adj]\n",
  "EUROKY": "the ability of an organism to live under various conditions, also EURYOKY [n EUROKIES]\n",
  "EUROLAND": "the area formed by the countries using the euro [n -S]\n",
  "EUROLANDS": "EUROLAND, the area formed by the countries using the euro [n]\n",
  "EUROMARKET": "a market for financing international trade backed by the central banks and commercial banks of the European Union [n -S]\n",
  "EUROMARKETS": "EUROMARKET, a market for financing international trade backed by the central banks and commercial banks of the European Union [n]\n",
  "EURONOTE": "negotiable bearer notes used in the European Union [n -S]\n",
  "EURONOTES": "EURONOTE, negotiable bearer notes used in the European Union [n]\n",
  "EUROPHILE": "one who admires Europe and Europeans [n -S]\n",
  "EUROPHILES": "EUROPHILE, one who admires Europe and Europeans [n]\n",
  "EUROPHILIA": "the love of Europe and things European [n -S]\n",
  "EUROPHILIAS": "EUROPHILIA, the love of Europe and things European [n]\n",
  "EUROPHOBIA": "an irrational fear of Europe and things European [n -S]\n",
  "EUROPHOBIAS": "EUROPHOBIA, an irrational fear of Europe and things European [n]\n",
  "EUROPHOBIC": "suffering from europhobia, an irrational fear of Europe and things European [adj]\n",
  "EUROPIUM": "a rare earth metallic element [n -S]\n",
  "EUROPIUMS": "EUROPIUM, a rare earth metallic element [n]\n",
  "EUROPOP": "a form of simple yet infuriatingly catchy pop music, performed by European artists [n -S]\n",
  "EUROPOPS": "EUROPOP, a form of simple yet infuriatingly catchy pop music, performed by European artists [n]\n",
  "EUROS": "EURO, (Native Australian) any of several large types of kangaroo, aka wallaroo [n]\n",
  "EUROTERMINAL": "the end station of a railway line, coach-route, etc. that operates a direct service from the UK into Europe [n -S]\n",
  "EUROTERMINALS": "EUROTERMINAL, the end station of a railway line, coach-route, etc. that operates a direct service from the UK into Europe [n]\n",
  "EUROZONE": "the area formed by the countries using the euro [n -S]\n",
  "EUROZONES": "EUROZONE, the area formed by the countries using the euro [n]\n",
  "EURYBATH": "an organism that can live in various water depths [n -S]\n",
  "EURYBATHIC": "capable of living at a wide range of depths in water [adj]\n",
  "EURYBATHS": "EURYBATH, an organism that can live in various water depths [n]\n",
  "EURYHALINE": "of marine animals, tolerating a wide variation in salinity [adj]\n",
  "EURYOECIOUS": "(of an organism) able to live under variable conditions [adj]\n",
  "EURYOKIES": "EURYOKY, the ability of an organism to live under variable conditions, also EUROKY [n]\n",
  "EURYOKOUS": "of an organism, able to live under different conditions, also EUROKOUS [adj]\n",
  "EURYOKY": "the ability of an organism to live under variable conditions, also EUROKY [n EURYOKIES]\n",
  "EURYPTERID": "any of an order of large extinct aquatic Paleozoic arthropods related to the horseshoe crab [n -S]\n",
  "EURYPTERIDS": "EURYPTERID, any of an order of large extinct aquatic Paleozoic arthropods related to the horseshoe crab [n]\n",
  "EURYPTEROID": "like a member of the Eurypterida, a fossil order of scorpion-like aquatic animals [adj] / a eurypterid [n -S]\n",
  "EURYPTEROIDS": "EURYPTEROID, a eurypterid [n]\n",
  "EURYTHERM": "an organism which tolerates a wide range of temperatures [n -S]\n",
  "EURYTHERMAL": "tolerating a wide range of temperature, also EURYTHERMIC, EURYTHERMOUS [adj]\n",
  "EURYTHERMIC": "tolerating a wide range of temperature, also EURYTHERMAL, EURYTHERMOUS [adj]\n",
  "EURYTHERMOUS": "tolerating a wide range of temperature, also EURYTHERMAL, EURYTHERMIC [adj]\n",
  "EURYTHERMS": "EURYTHERM, an organism which tolerates a wide range of temperatures [n]\n",
  "EURYTHMIC": "relating to eurhythmy, rhythmical movement or order, also EURHYTHMIC, EURHYTHMICAL, EURYTHMICAL [adj]\n",
  "EURYTHMICAL": "relating to eurhythmy, rhythmical movement or order; harmony of proportion, also EURHYTHMIC, EURHYTHMICAL, EURYTHMIC [adj]\n",
  "EURYTHMICS": "a system of rhythmic and harmonious movement, also EURHYTHMICS [n]\n",
  "EURYTHMIES": "EURYTHMY, rhythmical movement or order, also EURHYTHMY [n]\n",
  "EURYTHMIST": "a person who teaches or practises eurhythmics, also EURHYTHMIST [n -S]\n",
  "EURYTHMISTS": "EURYTHMIST, a person who teaches or practises eurhythmics, also EURHYTHMIST [n]\n",
  "EURYTHMY": "rhythmical movement or order, also EURHYTHMY [n EURYTHMIES]\n",
  "EURYTOPIC": "tolerant of wide variation in one or more environmental factors [adj]\n",
  "EUSOCIAL": "characterized by cooperative specialization of tasks, as in ant colonies [adj]\n",
  "EUSOL": "an antiseptic solution obtained by treating eupad with water [n -S]\n",
  "EUSOLS": "EUSOL, an antiseptic solution obtained by treating eupad with water [n]\n",
  "EUSPORANGIATE": "of a group of ferns, having each sporangium derived from a group of cells [adj]\n",
  "EUSTACIES": "EUSTACY, (Greek) a worldwide change in the sea level, also EUSTASY [n]\n",
  "EUSTACY": "(Greek) a worldwide change in the sea level, also EUSTASY [n EUSTACIES]\n",
  "EUSTASIES": "EUSTASY, (Greek) a worldwide change in the sea level, also EUSTACY [n]\n",
  "EUSTASY": "(Greek) a worldwide change in the sea level, also EUSTACY [n EUSTASIES]\n",
  "EUSTATIC": "of changes in world shoreline level, probably caused by rise or fall of the sea-level and not by subsidence or elevation of the land [adj EUSTATICALLY]\n",
  "EUSTATICALLY": "EUSTATIC, of changes in world shoreline level, probably caused by rise or fall of the sea-level and not by subsidence or elevation of the land [adv]\n",
  "EUSTELE": "when a plant's vascular tissue develops in discrete bundles, it is said to have a eustele [n -S]\n",
  "EUSTELES": "EUSTELE, when a plant's vascular tissue develops in discrete bundles, it is said to have a eustele [n]\n",
  "EUSTRESS": "a form of stress that is beneficial to one's health [n -ES]\n",
  "EUSTRESSES": "EUSTRESS, a form of stress that is beneficial to one's health [n]\n",
  "EUSTYLE": "a colonnade with closely spaced columns [n -S]\n",
  "EUSTYLES": "EUSTYLE, a colonnade with closely spaced columns [n]\n",
  "EUTAXIA": "the property of being easily melted, also EUTEXIA [n -S]\n",
  "EUTAXIAS": "EUTAXIA, the property of being easily melted, also EUTEXIA [n]\n",
  "EUTAXIES": "EUTAXY, (Greek) good order [n]\n",
  "EUTAXITE": "a volcanic rock with bands [n -S]\n",
  "EUTAXITES": "EUTAXITE, a volcanic rock with bands [n]\n",
  "EUTAXITIC": "of or like eutaxite, a volcanic rock with a banded structure [adj]\n",
  "EUTAXY": "(Greek) good order [n EUTAXIES]\n",
  "EUTECTIC": "a mixture with a low melting point [n -S]\n",
  "EUTECTICS": "EUTECTIC, a mixture with a low melting point [n]\n",
  "EUTECTOID": "an alloy similar to a eutectic [n -S]\n",
  "EUTECTOIDS": "EUTECTOID, an alloy similar to a eutectic [n]\n",
  "EUTEXIA": "the property of being easily melted, also EUTAXIA [n -S]\n",
  "EUTEXIAS": "EUTEXIA, the property of being easily melted, also EUTAXIA [n]\n",
  "EUTHANASE": "to subject to euthanasia, also EUTHANAZE [v EUTHANASED, EUTHANASING, EUTHANASES]\n",
  "EUTHANASED": "EUTHANASE, to subject to euthanasia, also EUTHANAZE [v]\n",
  "EUTHANASES": "EUTHANASE, to subject to euthanasia, also EUTHANAZE [v]\n",
  "EUTHANASIA": "the practice of ending the life of an individual suffering from a terminal illness or incurable condition, also EUTHANASY [n -S]\n",
  "EUTHANASIAS": "EUTHANASIA, the practice of ending the life of an individual suffering from a terminal illness or incurable condition, also EUTHANASY [n]\n",
  "EUTHANASIAST": "a supporter of euthanasia [n -S]\n",
  "EUTHANASIASTS": "EUTHANASIAST, a supporter of euthanasia [n]\n",
  "EUTHANASIC": "of or like euthanasia [adj]\n",
  "EUTHANASIES": "EUTHANASY, the practice of ending the life of an individual suffering from a terminal illness or incurable condition, also EUTHANASIA [n]\n",
  "EUTHANASING": "EUTHANASE, to subject to euthanasia, also EUTHANAZE [v]\n",
  "EUTHANASY": "the practice of ending the life of an individual suffering from a terminal illness or incurable condition, also EUTHANASIA [n EUTHANASIES]\n",
  "EUTHANATISE": "to perform euthanasia on, also EUTHANATIZE, EUTHANISE, EUTHANIZE [v EUTHANATISED, EUTHANATISING, EUTHANATISES]\n",
  "EUTHANATISED": "EUTHANATISE, to perform euthanasia on, also EUTHANATIZE, EUTHANISE, EUTHANIZE [v]\n",
  "EUTHANATISES": "EUTHANATISE, to perform euthanasia on, also EUTHANATIZE, EUTHANISE, EUTHANIZE [v]\n",
  "EUTHANATISING": "EUTHANATISE, to perform euthanasia on, also EUTHANATIZE, EUTHANISE, EUTHANIZE [v]\n",
  "EUTHANATIZE": "to perform euthanasia on, also EUTHANATISE, EUTHANISE, EUTHANIZE [v EUTHANATIZED, EUTHANATIZING, EUTHANATIZES]\n",
  "EUTHANATIZED": "EUTHANATIZE, to perform euthanasia on, also EUTHANATISE, EUTHANISE, EUTHANIZE [v]\n",
  "EUTHANATIZES": "EUTHANATIZE, to perform euthanasia on, also EUTHANATISE, EUTHANISE, EUTHANIZE [v]\n",
  "EUTHANATIZING": "EUTHANATIZE, to perform euthanasia on, also EUTHANATISE, EUTHANISE, EUTHANIZE [v]\n",
  "EUTHANAZE": "to subject to euthanasia, also EUTHANASE [v EUTHANAZED, EUTHANAZING, EUTHANAZES]\n",
  "EUTHANAZED": "EUTHANAZE, to subject to euthanasia, also EUTHANASE [v]\n",
  "EUTHANAZES": "EUTHANAZE, to subject to euthanasia, also EUTHANASE [v]\n",
  "EUTHANAZING": "EUTHANAZE, to subject to euthanasia, also EUTHANASE [v]\n",
  "EUTHANISE": "to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANIZE [v EUTHANISED, EUTHANISING, EUTHANISES]\n",
  "EUTHANISED": "EUTHANISE, to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANIZE [v]\n",
  "EUTHANISES": "EUTHANISE, to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANIZE [v]\n",
  "EUTHANISING": "EUTHANISE, to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANIZE [v]\n",
  "EUTHANIZE": "to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANISE [v EUTHANIZED, EUTHANIZING, EUTHANIZES]\n",
  "EUTHANIZED": "EUTHANIZE, to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANISE [v]\n",
  "EUTHANIZES": "EUTHANIZE, to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANISE [v]\n",
  "EUTHANIZING": "EUTHANIZE, to subject to euthanasia, also EUTHANATISE, EUTHANATIZE, EUTHANISE [v]\n",
  "EUTHENICS": "the science concerned with improving living conditions [n]\n",
  "EUTHENIST": "a student of euthenics, the science concerned with improving living conditions [n -S]\n",
  "EUTHENISTS": "EUTHENIST, a student of euthenics, the science concerned with improving living conditions [n]\n",
  "EUTHERIAN": "belonging to the Eutheria, placental mammals [adj] / a placental mammal (as distinct from marsupial) [n -S]\n",
  "EUTHERIANS": "EUTHERIAN, a placental mammal (as distinct from marsupial) [n]\n",
  "EUTHYMIA": "a pleasant state of mind [n -S]\n",
  "EUTHYMIAS": "EUTHYMIA, a pleasant state of mind [n]\n",
  "EUTHYROID": "someone with normal thyroid function [n -S]\n",
  "EUTHYROIDS": "EUTHYROID, someone with normal thyroid function [n]\n",
  "EUTRAPELIA": "(obsolete) wit, ease and urbanity of conversation, also EUTRAPELY [n -S]\n",
  "EUTRAPELIAS": "EUTRAPELIA, (obsolete) wit, ease and urbanity of conversation, also EUTRAPELY [n]\n",
  "EUTRAPELIES": "EUTRAPELY, wit, ease and urbanity of conversation, also EUTRAPELIA [n]\n",
  "EUTRAPELY": "wit, ease and urbanity of conversation, also EUTRAPELIA [n EUTRAPELIES]\n",
  "EUTROPHIC": "of a body of water, overrich in nutrients, and hence having a too abundant growth of water-plants and animals [adj]\n",
  "EUTROPHICATION": "the process of becoming eutrophic [n -S]\n",
  "EUTROPHICATIONS": "EUTROPHICATION, the process of becoming eutrophic [n]\n",
  "EUTROPHIES": "EUTROPHY, healthy nutrition [n]\n",
  "EUTROPHY": "healthy nutrition [n EUTROPHIES]\n",
  "EUTROPIC": "having the property of eutropy [adj]\n",
  "EUTROPIES": "EUTROPY, variation of crystalline forms by atomic number [n]\n",
  "EUTROPOUS": "according to eutropy, turning sunwise [adj]\n",
  "EUTROPY": "variation of crystalline forms by atomic number [n EUTROPIES]\n",
  "EUXENITE": "a mineral, a niobate and tantalate of yttrium and other rare earth elements and uranium [n -S]\n",
  "EUXENITES": "EUXENITE, a mineral, a niobate and tantalate of yttrium and other rare earth elements and uranium [n]\n",
  "EVACUANT": "a medicine that induces some kind of bodily discharge, as defecation, vomiting, or sweating [n -S]\n",
  "EVACUANTS": "EVACUANT, a medicine that induces some kind of bodily discharge, as defecation, vomiting, or sweating [n]\n",
  "EVACUATE": "to move from a place of danger [v EVACUATED, EVACUATING, EVACUATES]\n",
  "EVACUATED": "EVACUATE, to move from a place of danger [v]\n",
  "EVACUATES": "EVACUATE, to move from a place of danger [v]\n",
  "EVACUATING": "EVACUATE, to move from a place of danger [v]\n",
  "EVACUATION": "the act of evacuating [n -S]\n",
  "EVACUATIONS": "EVACUATION, the act of evacuating [n]\n",
  "EVACUATIVE": "a purgative [n -S]\n",
  "EVACUATIVES": "EVACUATIVE, a purgative [n]\n",
  "EVACUATOR": "something or someone that evacuates [n -S]\n",
  "EVACUATORS": "EVACUATOR, something or someone that evacuates [n]\n",
  "EVACUEE": "one who is evacuated [n -S]\n",
  "EVACUEES": "EVACUEE, one who is evacuated [n]\n",
  "EVADABLE": "able to be evaded [adj]\n",
  "EVADE": "to escape or avoid by cunning [v EVADED, EVADING, EVADES]\n",
  "EVADED": "EVADE, to escape or avoid by cunning [v]\n",
  "EVADER": "one that evades [n -S]\n",
  "EVADERS": "EVADER, one that evades [n]\n",
  "EVADES": "EVADE, to escape or avoid by cunning [v]\n",
  "EVADIBLE": "that may be evaded, also EVADABLE, EVASIBLE [adj]\n",
  "EVADING": "EVADE, to escape or avoid by cunning [v]\n",
  "EVADINGLY": "EVADING, EVADE, to escape or avoid by cunning [adv]\n",
  "EVAGATION": "wandering; digression [n -S]\n",
  "EVAGATIONS": "EVAGATION, wandering; digression [n]\n",
  "EVAGINATE": "to turn inside out [v EVAGINATED, EVAGINATING, EVAGINATES]\n",
  "EVAGINATED": "EVAGINATE, to turn inside out [v]\n",
  "EVAGINATES": "EVAGINATE, to turn inside out [v]\n",
  "EVAGINATING": "EVAGINATE, to turn inside out [v]\n",
  "EVAGINATION": "surgical removal of the vagina [n -S]\n",
  "EVAGINATIONS": "EVAGINATION, surgical removal of the vagina [n]\n",
  "EVALUABLE": "that can be evaluated [adj]\n",
  "EVALUATE": "to estimate the value of [v EVALUATED, EVALUATING, EVALUATES]\n",
  "EVALUATED": "EVALUATE, to estimate the value of [v]\n",
  "EVALUATES": "EVALUATE, to estimate the value of [v]\n",
  "EVALUATING": "EVALUATE, to estimate the value of [v]\n",
  "EVALUATION": "the act of evaluating [n -S]\n",
  "EVALUATIONS": "EVALUATION, the act of evaluating [n]\n",
  "EVALUATIVE": "relating to the process of evaluation [adj]\n",
  "EVALUATOR": "one who evaluates, also VALUATOR [n -S]\n",
  "EVALUATORS": "EVALUATOR, one who evaluates, also VALUATOR [n]\n",
  "EVANESCE": "to fade away or vanish [v EVANESCED, EVANESCING, EVANESCES]\n",
  "EVANESCED": "EVANESCE, to fade away or vanish [v]\n",
  "EVANESCENCE": "the process or fact of evanescing [n -S]\n",
  "EVANESCENCES": "EVANESCENCE, the process or fact of evanescing [n]\n",
  "EVANESCENT": "fleeting, transitory [adj EVANESCENTLY]\n",
  "EVANESCENTLY": "EVANESCENT, fleeting, transitory [adv]\n",
  "EVANESCES": "EVANESCE, to fade away or vanish [v]\n",
  "EVANESCING": "EVANESCE, to fade away or vanish [v]\n",
  "EVANGEL": "good news; announcement of glad tidings; esp. the gospel, or a gospel, also EVANGELY [n -S]\n",
  "EVANGELARIUM": "a book containing passages from the gospels to be used as part of the liturgy, also EVANGELIAR, EVANGELIARION, EVANGELIARIUM, EVANGELIARY [n -S]\n",
  "EVANGELARIUMS": "EVANGELARIUM, a book containing passages from the gospels to be used as part of the liturgy, also EVANGELIAR, EVANGELIARION, EVANGELIARIUM, EVANGELIARY [n]\n",
  "EVANGELIAR": "a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIARION, EVANGELIARIUM, EVANGELIARY [n -S]\n",
  "EVANGELIARIES": "EVANGELIARY, a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIAR, EVANGELIARION, EVANGELIARIUM [n]\n",
  "EVANGELIARION": "a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIAR, EVANGELIARIUM, EVANGELIARY [n -S]\n",
  "EVANGELIARIONS": "EVANGELIARION, a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIAR, EVANGELIARIUM, EVANGELIARY [n]\n",
  "EVANGELIARIUM": "(Latin) a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIAR, EVANGELIARION, EVANGELIARY [n -S]\n",
  "EVANGELIARIUMS": "EVANGELIARIUM, (Latin) a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIAR, EVANGELIARION, EVANGELIARY [n]\n",
  "EVANGELIARS": "EVANGELIAR, a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIARION, EVANGELIARIUM, EVANGELIARY [n]\n",
  "EVANGELIARY": "a book of passages from the Gospels to be used at Mass or other services, also EVANGELARIUM, EVANGELIAR, EVANGELIARION, EVANGELIARIUM [n EVANGELIARIES]\n",
  "EVANGELIC": "(archaic) of or relating to the Christian gospel, also EVANGELICAL [adj EVANGELICALLY]\n",
  "EVANGELICAL": "of or relating to the Christian gospel [adj EVANGELICALLY] / a person inspired by evangelical belief, also EVANGELIC [n -S]\n",
  "EVANGELICALISM": "being evangelical [n -S]\n",
  "EVANGELICALISMS": "EVANGELICALISM, being evangelical [n]\n",
  "EVANGELICALLY": "EVANGELICAL, of or relating to the Christian gospel [adv]\n",
  "EVANGELICALNESS": "the state of being evangelical [n]\n",
  "EVANGELICALS": "EVANGELICAL, a person inspired by evangelical belief, also EVANGELIC [n]\n",
  "EVANGELICISM": "being an evangelist [n -S]\n",
  "EVANGELICISMS": "EVANGELICISM, being an evangelist [n]\n",
  "EVANGELIES": "EVANGELY, (obsolete) the Gospel, also EVANGEL [n]\n",
  "EVANGELISATION": "the process of evangelising, also EVANGELIZATION [n -S]\n",
  "EVANGELISATIONS": "EVANGELISATION, the process of evangelising, also EVANGELIZATION [n]\n",
  "EVANGELISE": "to preach the gospel to, also EVANGELIZE [v EVANGELISED, EVANGELISING, EVANGELISES]\n",
  "EVANGELISED": "EVANGELISE, to preach the gospel to, also EVANGELIZE [v]\n",
  "EVANGELISER": "one who evangelises, also EVANGELIZER [n -S]\n",
  "EVANGELISERS": "EVANGELISER, one who evangelises, also EVANGELIZER [n]\n",
  "EVANGELISES": "EVANGELISE, to preach the gospel to, also EVANGELIZE [v]\n",
  "EVANGELISING": "EVANGELISE, to preach the gospel to, also EVANGELIZE [v]\n",
  "EVANGELISM": "the winning or revival of personal commitments to Christ [n -S]\n",
  "EVANGELISMS": "EVANGELISM, the winning or revival of personal commitments to Christ [n]\n",
  "EVANGELIST": "a writer of any of the four Gospels [n -S]\n",
  "EVANGELISTARIES": "EVANGELISTARY, a book of the Gospels or of passages from them to be read at divine service, also EVANGELISTARION [n]\n",
  "EVANGELISTARION": "a book of the Gospels or of passages from them to be read at divine service, also EVANGELISTARY [n]\n",
  "EVANGELISTARY": "a book of the Gospels or of passages from them to be read at divine service, also EVANGELISTARION [n EVANGELISTARIES]\n",
  "EVANGELISTIC": "relating to evangelism [adj]\n",
  "EVANGELISTS": "EVANGELIST, a writer of any of the four Gospels [n]\n",
  "EVANGELIZATION": "the act of evangelizing, also EVANGELISATION [n -S]\n",
  "EVANGELIZATIONS": "EVANGELIZATION, the act of evangelizing, also EVANGELISATION [n]\n",
  "EVANGELIZE": "to preach the gospel to, also EVANGELISE [v EVANGELIZED, EVANGELIZING, EVANGELIZES]\n",
  "EVANGELIZED": "EVANGELIZE, to preach the gospel to, also EVANGELISE [v]\n",
  "EVANGELIZER": "one who evangelises, also EVANGELISER [n -S]\n",
  "EVANGELIZERS": "EVANGELIZER, one who evangelises, also EVANGELISER [n]\n",
  "EVANGELIZES": "EVANGELIZE, to preach the gospel to, also EVANGELISE [v]\n",
  "EVANGELIZING": "EVANGELIZE, to preach the gospel to, also EVANGELISE [v]\n",
  "EVANGELS": "EVANGEL, good news; announcement of glad tidings; esp. the gospel, or a gospel, also EVANGELY [n]\n",
  "EVANGELY": "(obsolete) the Gospel, also EVANGEL [n EVANGELIES]\n",
  "EVANISH": "to vanish [v -ED, -ING, -ES]\n",
  "EVANISHED": "EVANISH, to vanish [v]\n",
  "EVANISHES": "EVANISH, to vanish [v]\n",
  "EVANISHING": "EVANISH, to vanish [v]\n",
  "EVANISHMENT": "the act of vanishing [n -S]\n",
  "EVANISHMENTS": "EVANISHMENT, the act of vanishing [n]\n",
  "EVANITION": "vanishing away [n -S]\n",
  "EVANITIONS": "EVANITION, vanishing away [n]\n",
  "EVAPORABILITIES": "EVAPORABILITY, the quality of being evaporable [n]\n",
  "EVAPORABILITY": "the quality of being evaporable [n EVAPORABILITIES]\n",
  "EVAPORABLE": "capable of being converted into vapor [adj]\n",
  "EVAPORATE": "to change into vapour [v EVAPORATED, EVAPORATING, EVAPORATES]\n",
  "EVAPORATED": "EVAPORATE, to change into vapour [v]\n",
  "EVAPORATES": "EVAPORATE, to change into vapour [v]\n",
  "EVAPORATING": "EVAPORATE, to change into vapour [v]\n",
  "EVAPORATION": "the act of evaporating [n -S]\n",
  "EVAPORATIONS": "EVAPORATION, the act of evaporating [n]\n",
  "EVAPORATIVE": "serving to evaporate [adj]\n",
  "EVAPORATOR": "an agent that causes evaporation [n -S]\n",
  "EVAPORATORS": "EVAPORATOR, an agent that causes evaporation [n]\n",
  "EVAPORIMETER": "an instrument for measuring the rate of evaporation, also EVAPOROMETER [n -S]\n",
  "EVAPORIMETERS": "EVAPORIMETER, an instrument for measuring the rate of evaporation, also EVAPOROMETER [n]\n",
  "EVAPORITE": "a sedimentary rock formed by the evaporation of salt water e.g. halite [n -S]\n",
  "EVAPORITES": "EVAPORITE, a sedimentary rock formed by the evaporation of salt water e.g. halite [n]\n",
  "EVAPORITIC": "of or like an evaporite, a mineral or rock deposited directly from a solution (commonly seawater) during evaporation [adj]\n",
  "EVAPOROGRAPH": "a device giving direct or photographic images of objects in darkness by focusing infrared radiations from them onto an oil-film [n -S]\n",
  "EVAPOROGRAPHS": "EVAPOROGRAPH, a device giving direct or photographic images of objects in darkness by focusing infrared radiations from them onto an oil-film [n]\n",
  "EVAPOROMETER": "an instrument for measuring rate of evaporation, also EVAPORIMETER [n -S]\n",
  "EVAPOROMETERS": "EVAPOROMETER, an instrument for measuring rate of evaporation, also EVAPORIMETER [n]\n",
  "EVASIBLE": "capable of being evaded [adj]\n",
  "EVASION": "the act of evading [n -S]\n",
  "EVASIONAL": "relating to evasion [adj]\n",
  "EVASIONS": "EVASION, the act of evading [n]\n",
  "EVASIVE": "tending to evade [adj EVASIVELY]\n",
  "EVASIVELY": "EVASIVE, tending to evade [adv]\n",
  "EVASIVENESS": "the state of being evasive [n -ES]\n",
  "EVASIVENESSES": "EVASIVENESS, the state of being evasive [n]\n",
  "EVE": "a poetic word for evening, also EEVEN, EEVN, EEVNING [n -S]\n",
  "EVECTION": "a lunar inequality, the combined effect of the irregularity of the point of the moon's orbit at which it is nearest to Earth and the alternate increase and decrease of the eccentricity of the moon's orbit [n -S]\n",
  "EVECTIONAL": "relating to evection, a lunar inequality [adj]\n",
  "EVECTIONS": "EVECTION, a lunar inequality, the combined effect of the irregularity of the point of the moon's orbit at which it is nearest to Earth and the alternate increase and decrease of the eccentricity of the moon's orbit [n]\n",
  "EVEJAR": "(dialect) the nightjar [n -S]\n",
  "EVEJARS": "EVEJAR, (dialect) the nightjar [n]\n",
  "EVEN": "to make smooth or level [v -ED, -ING, -S] / smooth and level [adj EVENER, EVENEST, EVENLY]\n",
  "EVENED": "EVEN, to make smooth or level [v]\n",
  "EVENEMENT": "(French) an event or happening; specifically a political strike [n -S]\n",
  "EVENEMENTS": "EVENEMENT, (French) an event or happening; specifically a political strike [n]\n",
  "EVENER": "something or someone that evens [n -S]\n",
  "EVENERS": "EVENER, something or someone that evens [n]\n",
  "EVENEST": "EVEN, smooth and level [adj]\n",
  "EVENFALL": "the onset of evening [n -S]\n",
  "EVENFALLS": "EVENFALL, the onset of evening [n]\n",
  "EVENHANDED": "fair, impartial [adj EVENHANDEDLY]\n",
  "EVENHANDEDLY": "EVENHANDED, fair, impartial [adv]\n",
  "EVENHANDEDNESS": "EVENHANDED, fair, impartial [n]\n",
  "EVENING": "the latter part of daylight hours, also EEVEN, EEVN, EEVNING [n -S]\n",
  "EVENINGS": "EVENING, the latter part of daylight hours, also EEVEN, EEVN, EEVNING [n]\n",
  "EVENLY": "EVEN, smooth and level [adv]\n",
  "EVENNESS": "the state of being even [n -ES]\n",
  "EVENNESSES": "EVENNESS, the state of being even [n]\n",
  "EVENS": "EVEN, to make smooth or level [v]\n",
  "EVENSONG": "an evening prayer service [n -S]\n",
  "EVENSONGS": "EVENSONG, an evening prayer service [n]\n",
  "EVENT": "a happening [n -S] / to take part in a horse-riding event [v -ED, -ING, -S]\n",
  "EVENTED": "EVENT, to take part in a horse-riding event [v]\n",
  "EVENTER": "a horse which is trained for events [n -S]\n",
  "EVENTERS": "EVENTER, a horse which is trained for events [n]\n",
  "EVENTFUL": "momentous [adj EVENTFULLY]\n",
  "EVENTFULLY": "EVENTFUL, momentous [adv]\n",
  "EVENTFULNESS": "the state of being eventful [n -ES]\n",
  "EVENTFULNESSES": "EVENTFULNESS, the state of being eventful [n]\n",
  "EVENTIDE": "evening [n -S]\n",
  "EVENTIDES": "EVENTIDE, evening [n]\n",
  "EVENTING": "the act of taking part in riding events [n -S]\n",
  "EVENTINGS": "EVENTING, the act of taking part in riding events [n]\n",
  "EVENTIVE": "denoting an event [adj]\n",
  "EVENTLESS": "without events [adj]\n",
  "EVENTRATE": "to open the belly [v EVENTRATED, EVENTRATING, EVENTRATES]\n",
  "EVENTRATED": "EVENTRATE, to open the belly [v]\n",
  "EVENTRATES": "EVENTRATE, to open the belly [v]\n",
  "EVENTRATING": "EVENTRATE, to open the belly [v]\n",
  "EVENTRATION": "the protrusion of an organ from the abdomen [n -S]\n",
  "EVENTRATIONS": "EVENTRATION, the protrusion of an organ from the abdomen [n]\n",
  "EVENTS": "EVENT, to take part in a horse-riding event [v]\n",
  "EVENTUAL": "happening as a consequence [adj EVENTUALLY]\n",
  "EVENTUALISE": "to happen, come into being, also EVENTUALIZE [v EVENTUALISED, EVENTUALISING, EVENTUALISES]\n",
  "EVENTUALISED": "EVENTUALISE, to happen, come into being, also EVENTUALIZE [v]\n",
  "EVENTUALISES": "EVENTUALISE, to happen, come into being, also EVENTUALIZE [v]\n",
  "EVENTUALISING": "EVENTUALISE, to happen, come into being, also EVENTUALIZE [v]\n",
  "EVENTUALITIES": "EVENTUALITY, a possible event or outcome [n]\n",
  "EVENTUALITY": "a possible event or outcome [n EVENTUALITIES]\n",
  "EVENTUALIZE": "to happen, come into being, also EVENTUALISE [v EVENTUALIZED, EVENTUALIZING, EVENTUALIZES]\n",
  "EVENTUALIZED": "EVENTUALIZE, to happen, come into being, also EVENTUALISE [v]\n",
  "EVENTUALIZES": "EVENTUALIZE, to happen, come into being, also EVENTUALISE [v]\n",
  "EVENTUALIZING": "EVENTUALIZE, to happen, come into being, also EVENTUALISE [v]\n",
  "EVENTUALLY": "EVENTUAL, happening as a consequence [adv]\n",
  "EVENTUATE": "to turn out [v EVENTUATED, EVENTUATING, EVENTUATES]\n",
  "EVENTUATED": "EVENTUATE, to turn out [v]\n",
  "EVENTUATES": "EVENTUATE, to turn out [v]\n",
  "EVENTUATING": "EVENTUATE, to turn out [v]\n",
  "EVENTUATION": "the act of eventuating [n -S]\n",
  "EVENTUATIONS": "EVENTUATION, the act of eventuating [n]\n",
  "EVER": "at all times [adv]\n",
  "EVERBLOOMING": "always in bloom [adj]\n",
  "EVERDURING": "everlasting [adj]\n",
  "EVERGLADE": "a swampy grassland, esp. in southern Florida [n -S]\n",
  "EVERGLADES": "EVERGLADE, a swampy grassland, esp. in southern Florida [n]\n",
  "EVERGREEN": "a tree or shrub that is green throughout the year [n -S]\n",
  "EVERGREENS": "EVERGREEN, a tree or shrub that is green throughout the year [n]\n",
  "EVERLASTING": "lasting forever [adj EVERLASTINGLY] / a flower that may be kept for years without much change of appearance [n -S]\n",
  "EVERLASTINGLY": "EVERLASTING, lasting forever [adv]\n",
  "EVERLASTINGNESS": "the state of being everlasting [n]\n",
  "EVERLASTINGS": "EVERLASTING, a flower that may be kept for years without much change of appearance [n]\n",
  "EVERMORE": "forever [adv]\n",
  "EVERNET": "a hypothetical form of the Internet [n -S]\n",
  "EVERNETS": "EVERNET, a hypothetical form of the Internet [n]\n",
  "EVERSIBLE": "that can be everted [adj]\n",
  "EVERSION": "the act of turning inside out or outwards [n -S]\n",
  "EVERSIONS": "EVERSION, the act of turning inside out or outwards [n]\n",
  "EVERT": "to turn inside out [v -ED, -ING, -S]\n",
  "EVERTED": "EVERT, to turn inside out [v]\n",
  "EVERTING": "EVERT, to turn inside out [v]\n",
  "EVERTOR": "a muscle that turns outwards [n -S]\n",
  "EVERTORS": "EVERTOR, a muscle that turns outwards [n]\n",
  "EVERTS": "EVERT, to turn inside out [v]\n",
  "EVERWHERE": "to or in all parts and places [adv]\n",
  "EVERWHICH": "whichever [adj]\n",
  "EVERY": "each without exception [adj]\n",
  "EVERYBODY": "every person [pron]\n",
  "EVERYDAY": "something appropriate for weekdays rather than Sunday [n -S]\n",
  "EVERYDAYNESS": "the state of being everyday [n -ES]\n",
  "EVERYDAYNESSES": "EVERYDAYNESS, the state of being everyday [n]\n",
  "EVERYDAYS": "EVERYDAY, something appropriate for weekdays rather than Sunday [n]\n",
  "EVERYMAN": "the hero of an old morality play, representing mankind, everybody or anybody [n EVERYMEN]\n",
  "EVERYMEN": "EVERYMAN, the hero of an old morality play, representing mankind, everybody or anybody [n]\n",
  "EVERYONE": "every person [pron]\n",
  "EVERYPLACE": "everywhere [adv]\n",
  "EVERYTHING": "all that exists [pron]\n",
  "EVERYWAY": "all ways [adv]\n",
  "EVERYWHEN": "on every occasion [adv]\n",
  "EVERYWHENCE": "from all directions [adv]\n",
  "EVERYWHERE": "in every place or part [adv]\n",
  "EVERYWHITHER": "in all directions [adv]\n",
  "EVERYWOMAN": "the typical or ordinary woman [n EVERYWOMEN]\n",
  "EVERYWOMEN": "EVERYWOMAN, the typical or ordinary woman [n]\n",
  "EVES": "EVE, a poetic word for evening, also EEVEN, EEVN, EEVNING [n]\n",
  "EVET": "a newt, also EFT, EWT [n -S]\n",
  "EVETS": "EVET, a newt, also EFT, EWT [n]\n",
  "EVHOE": "(Greek) a cry expressing Bacchic frenzy, also EUOI, EVOE, EVOHE [interj]\n",
  "EVICT": "to dispossess by law [v -ED, -ING, -S]\n",
  "EVICTED": "EVICT, to dispossess by law [v]\n",
  "EVICTEE": "one who is evicted [n -S]\n",
  "EVICTEES": "EVICTEE, one who is evicted [n]\n",
  "EVICTING": "EVICT, to dispossess by law [v]\n",
  "EVICTION": "the act of evicting [n -S]\n",
  "EVICTIONS": "EVICTION, the act of evicting [n]\n",
  "EVICTOR": "one who evicts [n -S]\n",
  "EVICTORS": "EVICTOR, one who evicts [n]\n",
  "EVICTS": "EVICT, to dispossess by law [v]\n",
  "EVIDENCE": "to make apparent or visible [v EVIDENCED, EVIDENCING, EVIDENCES]\n",
  "EVIDENCED": "EVIDENCE, to make apparent or visible [v]\n",
  "EVIDENCES": "EVIDENCE, to make apparent or visible [v]\n",
  "EVIDENCING": "EVIDENCE, to make apparent or visible [v]\n",
  "EVIDENT": "clear [adj EVIDENTLY] / that which serves as evidence [n -S]\n",
  "EVIDENTIAL": "relating to, or affording, evidence [adj EVIDENTIALLY]\n",
  "EVIDENTIALLY": "EVIDENTIAL, relating to, or affording, evidence [adv]\n",
  "EVIDENTIARY": "being, relating to, or affording evidence [adj]\n",
  "EVIDENTLY": "EVIDENT, clear [adv]\n",
  "EVIDENTS": "EVIDENT, that which serves as evidence [n]\n",
  "EVIL": "wickedness or depravity [n -S] / morally bad [adj EVILLER or EVILER, EVILLEST or EVILLEST, EVILLY]\n",
  "EVILDOER": "one who commits evil [n -S]\n",
  "EVILDOERS": "EVILDOER, one who commits evil [n]\n",
  "EVILDOING": "the doing of evil [n -S]\n",
  "EVILDOINGS": "EVILDOING, the doing of evil [n]\n",
  "EVILER": "EVIL, morally bad [adj]\n",
  "EVILEST": "EVIL, morally bad [adj]\n",
  "EVILLER": "EVIL, morally bad [adj]\n",
  "EVILLEST": "EVIL, morally bad [adj]\n",
  "EVILLY": "EVIL, morally bad [adv]\n",
  "EVILNESS": "the quality of being evil [n -ES]\n",
  "EVILNESSES": "EVILNESS, the quality of being evil [n]\n",
  "EVILS": "EVIL, wickedness or depravity [n]\n",
  "EVINCE": "to show clearly [v EVINCED, EVINCING, EVINCES]\n",
  "EVINCED": "EVINCE, to show clearly [v]\n",
  "EVINCEMENT": "the act of evincing or proving [n -S]\n",
  "EVINCEMENTS": "EVINCEMENT, the act of evincing or proving [n]\n",
  "EVINCES": "EVINCE, to show clearly [v]\n",
  "EVINCIBLE": "capable of being evinced [adj EVINCIBLY]\n",
  "EVINCIBLY": "EVINCIBLE, capable of being evinced [adv]\n",
  "EVINCING": "EVINCE, to show clearly [v]\n",
  "EVINCIVE": "tending to evince [adj]\n",
  "EVIRATE": "to castrate; to make weak or unmanly [v EVIRATED, EVIRATING, EVIRATES]\n",
  "EVIRATED": "EVIRATE, to castrate; to make weak or unmanly [v]\n",
  "EVIRATES": "EVIRATE, to castrate; to make weak or unmanly [v]\n",
  "EVIRATING": "EVIRATE, to castrate; to make weak or unmanly [v]\n",
  "EVISCERATE": "to deprive of the viscera, or entrails, also VISCERATE [v EVISCERATED, EVISCERATING, EVISCERATES]\n",
  "EVISCERATED": "EVISCERATE, to deprive of the viscera, or entrails, also VISCERATE [v]\n",
  "EVISCERATES": "EVISCERATE, to deprive of the viscera, or entrails, also VISCERATE [v]\n",
  "EVISCERATING": "EVISCERATE, to deprive of the viscera, or entrails, also VISCERATE [v]\n",
  "EVISCERATION": "the act of eviscerating [n -S]\n",
  "EVISCERATIONS": "EVISCERATION, the act of eviscerating [n]\n",
  "EVISCERATOR": "one who eviscerates [n -S]\n",
  "EVISCERATORS": "EVISCERATOR, one who eviscerates [n]\n",
  "EVITABLE": "avoidable [adj]\n",
  "EVITATE": "(Shakespeare) to avoid, also EVITE [v EVITATED, EVITATING, EVITATES]\n",
  "EVITATED": "EVITATE, (Shakespeare) to avoid, also EVITE [v]\n",
  "EVITATES": "EVITATE, (Shakespeare) to avoid, also EVITE [v]\n",
  "EVITATING": "EVITATE, (Shakespeare) to avoid, also EVITE [v]\n",
  "EVITATION": "a shunning, avoidance [n -S]\n",
  "EVITATIONS": "EVITATION, a shunning, avoidance [n]\n",
  "EVITE": "to avoid, also EVITATE [v EVITED, EVITING, EVITES]\n",
  "EVITED": "EVITE, to avoid, also EVITATE [v]\n",
  "EVITERNAL": "eternal [adj EVITERNALLY]\n",
  "EVITERNALLY": "EVITERNAL, eternal [adv]\n",
  "EVITERNITIES": "EVITERNITY, eternity [n]\n",
  "EVITERNITY": "eternity [n EVITERNITIES]\n",
  "EVITES": "EVITE, to avoid, also EVITATE [v]\n",
  "EVITING": "EVITE, to avoid, also EVITATE [v]\n",
  "EVO": "(Australian slang) evening [n -S]\n",
  "EVOCABLE": "able to be evoked [adj]\n",
  "EVOCATE": "to evoke [v EVOCATED, EVOCATING, EVOCATES]\n",
  "EVOCATED": "EVOCATE, to evoke [v]\n",
  "EVOCATES": "EVOCATE, to evoke [v]\n",
  "EVOCATING": "EVOCATE, to evoke [v]\n",
  "EVOCATION": "the act of calling out or forth [n -S]\n",
  "EVOCATIONS": "EVOCATION, the act of calling out or forth [n]\n",
  "EVOCATIVE": "calling forth; serving to evoke [adj EVOCATIVELY]\n",
  "EVOCATIVELY": "EVOCATIVE, calling forth; serving to evoke [adv]\n",
  "EVOCATIVENESS": "EVOCATIVE, calling forth; serving to evoke [n]\n",
  "EVOCATIVENESSES": "EVOCATIVENESS, EVOCATIVE, calling forth; serving to evoke [n]\n",
  "EVOCATOR": "one who evokes, calls forth [n -S]\n",
  "EVOCATORS": "EVOCATOR, one who evokes, calls forth [n]\n",
  "EVOCATORY": "evocative [adj]\n",
  "EVOE": "(Greek) expressing Bacchic frenzy, also EUOI, EVHOE, EVOHE [interj]\n",
  "EVOHE": "(Greek) expressing Bacchic frenzy, also EVOE, EUOI, EVHOE [interj]\n",
  "EVOKE": "to call forth [v EVOKED, EVOKING, EVOKES]\n",
  "EVOKED": "EVOKE, to call forth [v]\n",
  "EVOKER": "one who evokes [n -S]\n",
  "EVOKERS": "EVOKER, one who evokes [n]\n",
  "EVOKES": "EVOKE, to call forth [v]\n",
  "EVOKING": "EVOKE, to call forth [v]\n",
  "EVOLUE": "(French) a primitive person improved by education [n -S]\n",
  "EVOLUES": "EVOLUE, (French) a primitive person improved by education [n]\n",
  "EVOLUTE": "to develop by evolution [v EVOLUTED, EVOLUTING, EVOLUTES]\n",
  "EVOLUTED": "EVOLUTE, to develop by evolution [v]\n",
  "EVOLUTES": "EVOLUTE, to develop by evolution [v]\n",
  "EVOLUTING": "EVOLUTE, to develop by evolution [v]\n",
  "EVOLUTION": "the cumulative change in the genetic composition of a population of an organism over succeeding generations [n -S]\n",
  "EVOLUTIONAL": "relating to evolution [adj]\n",
  "EVOLUTIONARILY": "EVOLUTIONARY, relating to evolution [adv]\n",
  "EVOLUTIONARY": "relating to evolution [adj EVOLUTIONARILY]\n",
  "EVOLUTIONISM": "belief in evolution [n -S]\n",
  "EVOLUTIONISMS": "EVOLUTIONISM, belief in evolution [n]\n",
  "EVOLUTIONIST": "one who believes in evolution [n -S]\n",
  "EVOLUTIONISTIC": "related to evolutionism [adj]\n",
  "EVOLUTIONISTS": "EVOLUTIONIST, one who believes in evolution [n]\n",
  "EVOLUTIONS": "EVOLUTION, the cumulative change in the genetic composition of a population of an organism over succeeding generations [n]\n",
  "EVOLUTIVE": "promoting evolution [adj]\n",
  "EVOLVABLE": "that can be evolved [adj]\n",
  "EVOLVE": "to develop [v EVOLVED, EVOLVING, EVOLVES]\n",
  "EVOLVED": "EVOLVE, to develop [v]\n",
  "EVOLVEMENT": "the act of evolving, evolution [n -S]\n",
  "EVOLVEMENTS": "EVOLVEMENT, the act of evolving, evolution [n]\n",
  "EVOLVENT": "an involute curve [n -S]\n",
  "EVOLVENTS": "EVOLVENT, an involute curve [n]\n",
  "EVOLVER": "one who evolves [n -S]\n",
  "EVOLVERS": "EVOLVER, one who evolves [n]\n",
  "EVOLVES": "EVOLVE, to develop [v]\n",
  "EVOLVING": "EVOLVE, to develop [v]\n",
  "EVONYMUS": "a plant of the burning bush family, also EUONYMUS [n -ES]\n",
  "EVONYMUSES": "EVONYMUS, a plant of the burning bush family, also EUONYMUS [n]\n",
  "EVOS": "EVO, (Australian slang) evening [n]\n",
  "EVOVAE": "(Latin) a name for a Gregorian cadence, also EUOUAE [n -S]\n",
  "EVOVAES": "EVOVAE, (Latin) a name for a Gregorian cadence, also EUOUAE [n]\n",
  "EVULGATE": "to divulge; to publish [v EVULGATED, EVULGATING, EVULGATES]\n",
  "EVULGATED": "EVULGATE, to divulge; to publish [v]\n",
  "EVULGATES": "EVULGATE, to divulge; to publish [v]\n",
  "EVULGATING": "EVULGATE, to divulge; to publish [v]\n",
  "EVULSE": "to pluck out [v EVULSED, EVULSING, EVULSES]\n",
  "EVULSED": "EVULSE, to pluck out [v]\n",
  "EVULSES": "EVULSE, to pluck out [v]\n",
  "EVULSING": "EVULSE, to pluck out [v]\n",
  "EVULSION": "the act of pulling out [n -S]\n",
  "EVULSIONS": "EVULSION, the act of pulling out [n]\n",
  "EVZONE": "(Modern Greek) a soldier in an elite Greek infantry regiment [n -S]\n",
  "EVZONES": "EVZONE, (Modern Greek) a soldier in an elite Greek infantry regiment [n]\n",
  "EW": "an interjection used to express disgust, also EEEW, EEW [interj]\n",
  "EWE": "a female sheep, also YOWE [n -S]\n",
  "EWER": "a jug with a wide mouth, esp. a water-jug of the kind formerly used in bedrooms [n -S]\n",
  "EWERS": "EWER, a jug with a wide mouth, esp. a water-jug of the kind formerly used in bedrooms [n]\n",
  "EWES": "EWE, a female sheep, also YOWE [n]\n",
  "EWEST": "(Scots) near, close at hand [adj]\n",
  "EWFTES": "(Spenser) efts [n]\n",
  "EWGHEN": "(Spenser) made of yew-wood, also EUGHEN, YEWEN [adj]\n",
  "EWHOW": "(Scots) expressing regret [interj]\n",
  "EWK": "(dialect) to itch, also EUK, YEUK, YOUK, YUKE [v -ED, -ING, -S]\n",
  "EWKED": "EWK, (dialect) to itch, also EUK, YEUK, YOUK, YUKE [v]\n",
  "EWKING": "EWK, (dialect) to itch, also EUK, YEUK, YOUK, YUKE [v]\n",
  "EWKS": "EWK, (dialect) to itch, also EUK, YEUK, YOUK, YUKE [v]\n",
  "EWT": "(dialect) a newt, also EFT, EVET [n -S]\n",
  "EWTS": "EWT, (dialect) a newt, also EFT, EVET [n]\n",
  "EX": "to cross out [v -ED, -ING, -ES]\n",
  "EXABYTE": "a very large unit of computer memory [n -S]\n",
  "EXABYTES": "EXABYTE, a very large unit of computer memory [n]\n",
  "EXACERBATE": "to make more violent, bitter, or severe [v EXACERBATED, EXACERBATING, EXACERBATES]\n",
  "EXACERBATED": "EXACERBATE, to make more violent, bitter, or severe [v]\n",
  "EXACERBATES": "EXACERBATE, to make more violent, bitter, or severe [v]\n",
  "EXACERBATING": "EXACERBATE, to make more violent, bitter, or severe [v]\n",
  "EXACERBATION": "the act of exarcebating [n -S]\n",
  "EXACERBATIONS": "EXACERBATION, the act of exarcebating [n]\n",
  "EXACERBESCENCE": "(archaic) exacerbation [n -S]\n",
  "EXACERBESCENCES": "EXACERBESCENCE, (archaic) exacerbation [n]\n",
  "EXACT": "precise [adj EXACTER, EXACTEST, EXACTLY] / to demand [v -ED, -ING, -S]\n",
  "EXACTA": "(Spanish) a type of horse racing bet [n -S]\n",
  "EXACTABLE": "that can be exacted [adj]\n",
  "EXACTAS": "EXACTA, (Spanish) a type of horse racing bet [n]\n",
  "EXACTED": "EXACT, to demand [v]\n",
  "EXACTER": "one that exacts, also EXACTOR [n -S]\n",
  "EXACTERS": "EXACTER, one that exacts, also EXACTOR [n]\n",
  "EXACTEST": "EXACT, precise [adj]\n",
  "EXACTING": "EXACT, to demand [v]\n",
  "EXACTINGLY": "EXACTING, EXACT, to demand [adv]\n",
  "EXACTINGNESS": "the state of being exacting [n -ES]\n",
  "EXACTINGNESSES": "EXACTINGNESS, the state of being exacting [n]\n",
  "EXACTION": "the act of exacting [n -S]\n",
  "EXACTIONS": "EXACTION, the act of exacting [n]\n",
  "EXACTITUDE": "the quality of being exact [n -S]\n",
  "EXACTITUDES": "EXACTITUDE, the quality of being exact [n]\n",
  "EXACTLY": "EXACT, precise [adv]\n",
  "EXACTMENT": "exactness [n -S]\n",
  "EXACTMENTS": "EXACTMENT, exactness [n]\n",
  "EXACTNESS": "the state of being exact [n -ES]\n",
  "EXACTNESSES": "EXACTNESS, the state of being exact [n]\n",
  "EXACTOR": "one that exacts, also EXACTER [n -S]\n",
  "EXACTORS": "EXACTOR, one that exacts, also EXACTER [n]\n",
  "EXACTRESS": "a female exactor [n -ES]\n",
  "EXACTRESSES": "EXACTRESS, a female exactor [n]\n",
  "EXACTS": "EXACT, to demand [v]\n",
  "EXACUM": "any plant of the tropical genus Exacum [n -S]\n",
  "EXACUMS": "EXACUM, any plant of the tropical genus Exacum [n]\n",
  "EXAGGERATE": "to enlarge beyond bounds or the truth [v EXAGGERATED, EXAGGERATING, EXAGGERATES]\n",
  "EXAGGERATED": "EXAGGERATE, to enlarge beyond bounds or the truth [v]\n",
  "EXAGGERATEDLY": "EXAGGERATED, EXAGGERATE, to enlarge beyond bounds or the truth [adv]\n",
  "EXAGGERATEDNESS": "the state of being exaggerated [n]\n",
  "EXAGGERATES": "EXAGGERATE, to enlarge beyond bounds or the truth [v]\n",
  "EXAGGERATING": "EXAGGERATE, to enlarge beyond bounds or the truth [v]\n",
  "EXAGGERATINGLY": "EXAGGERATING, EXAGGERATE, to enlarge beyond bounds or the truth [adv]\n",
  "EXAGGERATION": "extravagant overstatement [n -S]\n",
  "EXAGGERATIONS": "EXAGGERATION, extravagant overstatement [n]\n",
  "EXAGGERATIVE": "tending to exaggerate [adj]\n",
  "EXAGGERATOR": "one who exaggerates [n -S]\n",
  "EXAGGERATORS": "EXAGGERATOR, one who exaggerates [n]\n",
  "EXAGGERATORY": "tending to exaggerate [adj]\n",
  "EXAHERTZ": "one quintillion hertz [n -ES]\n",
  "EXAHERTZES": "EXAHERTZ, one quintillion hertz [n]\n",
  "EXALBUMINOUS": "without albumen [adj]\n",
  "EXALT": "to place in a high position [v -ED, -ING, -S]\n",
  "EXALTATION": "an act of exalting [n -S]\n",
  "EXALTATIONS": "EXALTATION, an act of exalting [n]\n",
  "EXALTED": "EXALT, to place in a high position [v]\n",
  "EXALTEDLY": "EXALTED [adv]\n",
  "EXALTEDNESS": "the state of being exalted [n -ES]\n",
  "EXALTEDNESSES": "EXALTEDNESS, the state of being exalted [n]\n",
  "EXALTER": "one who exalts or raises to dignity [n -S]\n",
  "EXALTERS": "EXALTER, one who exalts or raises to dignity [n]\n",
  "EXALTING": "EXALT, to place in a high position [v]\n",
  "EXALTS": "EXALT, to place in a high position [v]\n",
  "EXAM": "an examination [n -S]\n",
  "EXAMEN": "(Latin) a critical study of conscience [n -S]\n",
  "EXAMENS": "EXAMEN, (Latin) a critical study of conscience [n]\n",
  "EXAMETRE": "ten to the power of eighteen metres [n -S]\n",
  "EXAMETRES": "EXAMETRE, ten to the power of eighteen metres [n]\n",
  "EXAMINABILITIES": "EXAMINABILITY, the quality of being examinable [n]\n",
  "EXAMINABILITY": "the quality of being examinable [n EXAMINABILITIES]\n",
  "EXAMINABLE": "that can be examined [adj]\n",
  "EXAMINANT": "one who examines [n -S]\n",
  "EXAMINANTS": "EXAMINANT, one who examines [n]\n",
  "EXAMINATE": "a person subjected to examination [n -S]\n",
  "EXAMINATES": "EXAMINATE, a person subjected to examination [n]\n",
  "EXAMINATION": "the act of examining [n -S]\n",
  "EXAMINATIONAL": "relating to examination [adj]\n",
  "EXAMINATIONS": "EXAMINATION, the act of examining [n]\n",
  "EXAMINATOR": "an examiner [n -S]\n",
  "EXAMINATORS": "EXAMINATOR, an examiner [n]\n",
  "EXAMINE": "to inspect [v EXAMINED, EXAMINING, EXAMINES]\n",
  "EXAMINED": "EXAMINE, to inspect [v]\n",
  "EXAMINEE": "one who is taking an examination [n -S]\n",
  "EXAMINEES": "EXAMINEE, one who is taking an examination [n]\n",
  "EXAMINER": "one that examines [n -S]\n",
  "EXAMINERS": "EXAMINER, one that examines [n]\n",
  "EXAMINERSHIP": "the office of examiner [n -S]\n",
  "EXAMINERSHIPS": "EXAMINERSHIP, the office of examiner [n]\n",
  "EXAMINES": "EXAMINE, to inspect [v]\n",
  "EXAMINING": "EXAMINE, to inspect [v]\n",
  "EXAMPLAR": "an ideal model, also EXEMPLAR [n -S]\n",
  "EXAMPLARS": "EXAMPLAR, an ideal model, also EXEMPLAR [n]\n",
  "EXAMPLE": "to illustrate, show by representation [v EXAMPLED, EXAMPLING, EXAMPLES]\n",
  "EXAMPLED": "EXAMPLE, to illustrate, show by representation [v]\n",
  "EXAMPLES": "EXAMPLE, to illustrate, show by representation [v]\n",
  "EXAMPLING": "EXAMPLE, to illustrate, show by representation [v]\n",
  "EXAMS": "EXAM, an examination [n]\n",
  "EXANIMATE": "lifeless; spiritless; depressed [adj]\n",
  "EXANIMATION": "lifelessness [n -S]\n",
  "EXANIMATIONS": "EXANIMATION, lifelessness [n]\n",
  "EXANTHEM": "a skin eruption, esp. accompanied by fever, also EXANTHEMA [n -S]\n",
  "EXANTHEMA": "a skin eruption, esp. accompanied by fever, also EXANTHEM [n EXANTHEMAS or EXANTHEMATA]\n",
  "EXANTHEMAS": "EXANTHEMA, a skin eruption, esp. accompanied by fever, also EXANTHEM [n]\n",
  "EXANTHEMATA": "EXANTHEMA, a skin eruption, esp. accompanied by fever, also EXANTHEM [n]\n",
  "EXANTHEMATIC": "of or like an exanthem, a skin eruption, esp. accompanied by fever, also EXANTHEMATOUS [adj]\n",
  "EXANTHEMATOUS": "of or like an exanthem, a skin eruption, esp. accompanied by fever, also EXANTHEMATIC [adj]\n",
  "EXANTHEMS": "EXANTHEM, a skin eruption, esp. accompanied by fever, also EXANTHEMA [n]\n",
  "EXAPTED": "of a biological feature, having a function differing from that for which it was originally evolved e.g. feathers evolved originally for warmth, also EXAPTIVE [adj]\n",
  "EXAPTIVE": "of a biological feature, having a function differing from that for which it was originally evolved e.g. feathers evolved originally for warmth, also EXAPTED [adj]\n",
  "EXARATE": "of a pupa, having the appendages free from the body [adj]\n",
  "EXARATION": "the act of writing or engraving on stone [n -S]\n",
  "EXARATIONS": "EXARATION, the act of writing or engraving on stone [n]\n",
  "EXARCH": "a Byzantine provincial governor [n -S]\n",
  "EXARCHAL": "relating to an exarch, the rank below patriarch in the Eastern church [adj]\n",
  "EXARCHATE": "the office or the province of an exarch, the rank below patriarch in the Eastern church [n -S]\n",
  "EXARCHATES": "EXARCHATE, the office or the province of an exarch, the rank below patriarch in the Eastern church [n]\n",
  "EXARCHIES": "EXARCHY, the domain of an exarch [n]\n",
  "EXARCHIST": "a supporter of the Bulgarian exarch [n -S]\n",
  "EXARCHISTS": "EXARCHIST, a supporter of the Bulgarian exarch [n]\n",
  "EXARCHS": "EXARCH, a Byzantine provincial governor [n]\n",
  "EXARCHY": "the domain of an exarch [n EXARCHIES]\n",
  "EXASPERATE": "to excite the anger of [v EXASPERATED, EXASPERATING, EXASPERATES]\n",
  "EXASPERATED": "EXASPERATE, to excite the anger of [v]\n",
  "EXASPERATEDLY": "EXASPERATED, EXASPERATE, to excite the anger of [adv]\n",
  "EXASPERATER": "one who exasperates, also EXASPERATOR [n -S]\n",
  "EXASPERATERS": "EXASPERATER, one who exasperates, also EXASPERATOR [n]\n",
  "EXASPERATES": "EXASPERATE, to excite the anger of [v]\n",
  "EXASPERATING": "exciting the anger of [adj EXASPERATINGLY]\n",
  "EXASPERATINGLY": "EXASPERATING, exciting the anger of [adv]\n",
  "EXASPERATION": "the state of being exasperated [n -S]\n",
  "EXASPERATIONS": "EXASPERATION, the state of being exasperated [n]\n",
  "EXASPERATIVE": "causing exasperation [adj]\n",
  "EXASPERATOR": "one who exasperates, also EXASPERATER [n -S]\n",
  "EXASPERATORS": "EXASPERATOR, one who exasperates, also EXASPERATER [n]\n",
  "EXCAMB": "(Scots) in Scots law, to exchange [v -ED, -ING, -S]\n",
  "EXCAMBED": "EXCAMB, (Scots) in Scots law, to exchange [v]\n",
  "EXCAMBING": "EXCAMB, (Scots) in Scots law, to exchange [v]\n",
  "EXCAMBION": "in Scots law, exchange of lands, also EXCAMBIUM [n -S]\n",
  "EXCAMBIONS": "EXCAMBION, in Scots law, exchange of lands, also EXCAMBIUM [n]\n",
  "EXCAMBIUM": "in Scots law, exchange of lands, also EXCAMBION [n -S]\n",
  "EXCAMBIUMS": "EXCAMBIUM, in Scots law, exchange of lands, also EXCAMBION [n]\n",
  "EXCAMBS": "EXCAMB, (Scots) in Scots law, to exchange [v]\n",
  "EXCARNATE": "to deprive or strip of flesh [v EXCARNATED, EXCARNATING, EXCARNATES]\n",
  "EXCARNATED": "EXCARNATE, to deprive or strip of flesh [v]\n",
  "EXCARNATES": "EXCARNATE, to deprive or strip of flesh [v]\n",
  "EXCARNATING": "EXCARNATE, to deprive or strip of flesh [v]\n",
  "EXCARNATION": "the act of excarnating, removing the flesh from [n -S]\n",
  "EXCARNATIONS": "EXCARNATION, the act of excarnating, removing the flesh from [n]\n",
  "EXCAUDATE": "tailless [adj]\n",
  "EXCAVATE": "to dig out [v EXCAVATED, EXCAVATING, EXCAVATES]\n",
  "EXCAVATED": "EXCAVATE, to dig out [v]\n",
  "EXCAVATES": "EXCAVATE, to dig out [v]\n",
  "EXCAVATING": "EXCAVATE, to dig out [v]\n",
  "EXCAVATION": "the act of excavating [n -S]\n",
  "EXCAVATIONAL": "relating to excavation [adj]\n",
  "EXCAVATIONS": "EXCAVATION, the act of excavating [n]\n",
  "EXCAVATOR": "a vehicle for excavating [n -S]\n",
  "EXCAVATORS": "EXCAVATOR, a vehicle for excavating [n]\n",
  "EXCEED": "to go beyond the limit [v -ED, -ING, -S]\n",
  "EXCEEDABLE": "that can be exceeded [adj]\n",
  "EXCEEDED": "EXCEED, to go beyond the limit [v]\n",
  "EXCEEDER": "one who exceeds [n -S]\n",
  "EXCEEDERS": "EXCEEDER, one who exceeds [n]\n",
  "EXCEEDING": "EXCEED, to go beyond the limit [v]\n",
  "EXCEEDINGLY": "EXCEEDING, EXCEED, to go beyond the limit [adv]\n",
  "EXCEEDS": "EXCEED, to go beyond the limit [v]\n",
  "EXCEL": "to surpass others [v EXCELLED, EXCELLING, EXCELS]\n",
  "EXCELLED": "EXCEL, to surpass others [v]\n",
  "EXCELLENCE": "the quality of being excellent, also EXCELLENCY [n -S]\n",
  "EXCELLENCES": "EXCELLENCE, the quality of being excellent, also EXCELLENCY [n]\n",
  "EXCELLENCIES": "EXCELLENCY, the quality of being excellent, also EXCELLENCE [n]\n",
  "EXCELLENCY": "the quality of being excellent, also EXCELLENCE [n EXCELLENCIES]\n",
  "EXCELLENT": "very good [adj EXCELLENTLY]\n",
  "EXCELLENTLY": "EXCELLENT, very good [adv]\n",
  "EXCELLING": "EXCEL, to surpass others [v]\n",
  "EXCELS": "EXCEL, to surpass others [v]\n",
  "EXCELSIOR": "higher still [adj] / slender, curved wood shavings used esp. for packing [n -S]\n",
  "EXCELSIORS": "EXCELSIOR, slender, curved wood shavings used esp. for packing [n]\n",
  "EXCENTRIC": "something excentric, lying outside the centre [n -S]\n",
  "EXCENTRICS": "EXCENTRIC, something excentric, lying outside the centre [n]\n",
  "EXCEPT": "to exclude, leave out [v -ED, -ING, -S]\n",
  "EXCEPTANT": "something excepted, left out [n -S]\n",
  "EXCEPTANTS": "EXCEPTANT, something excepted, left out [n]\n",
  "EXCEPTED": "EXCEPT, to exclude, leave out [v]\n",
  "EXCEPTING": "EXCEPT, to exclude, leave out [v]\n",
  "EXCEPTION": "the act of excepting; something that is excepted [n -S]\n",
  "EXCEPTIONABLE": "being likely to cause objection [adj EXCEPTIONABLY]\n",
  "EXCEPTIONABLY": "EXCEPTIONABLE, being likely to cause objection [adv]\n",
  "EXCEPTIONAL": "by way of an exception [adj EXCEPTIONALLY] / someone having above or below average intelligence [n -S]\n",
  "EXCEPTIONALISM": "the condition of being different from the norm [n -S]\n",
  "EXCEPTIONALISMS": "EXCEPTIONALISM, the condition of being different from the norm [n]\n",
  "EXCEPTIONALITY": "the state of being exceptional [n]\n",
  "EXCEPTIONALLY": "EXCEPTIONAL, by way of an exception [adv]\n",
  "EXCEPTIONALNESS": "EXCEPTIONAL, by way of an exception [n]\n",
  "EXCEPTIONALS": "EXCEPTIONAL, someone having above or below average intelligence [n]\n",
  "EXCEPTIONS": "EXCEPTION, the act of excepting; something that is excepted [n]\n",
  "EXCEPTIOUS": "(archaic) disposed to take exception [adj]\n",
  "EXCEPTIVE": "including, making or being an exception [adj]\n",
  "EXCEPTLESS": "(Shakespeare) making no exceptions [adj]\n",
  "EXCEPTOR": "one who excepts [n -S]\n",
  "EXCEPTORS": "EXCEPTOR, one who excepts [n]\n",
  "EXCEPTS": "EXCEPT, to exclude, leave out [v]\n",
  "EXCERPT": "to pick out a passage from for quoting [v -ED, -ING, -S]\n",
  "EXCERPTA": "EXCERPTUM, (Latin) an excerpt, selection [n]\n",
  "EXCERPTED": "EXCERPT, to pick out a passage from for quoting [v]\n",
  "EXCERPTER": "one who makes excerpts, also EXCERPTOR [n -S]\n",
  "EXCERPTERS": "EXCERPTER, one who makes excerpts, also EXCERPTOR [n]\n",
  "EXCERPTIBLE": "that can be excerpted [adj]\n",
  "EXCERPTING": "the act of making an excerpt [n -S]\n",
  "EXCERPTINGS": "EXCERPTING, the act of making an excerpt [n]\n",
  "EXCERPTION": "the act of excerpting or selecting [n -S]\n",
  "EXCERPTIONS": "EXCERPTION, the act of excerpting or selecting [n]\n",
  "EXCERPTOR": "one who makes excerpts, also EXCERPTER [n -S]\n",
  "EXCERPTORS": "EXCERPTOR, one who makes excerpts, also EXCERPTER [n]\n",
  "EXCERPTS": "EXCERPT, to pick out a passage from for quoting [v]\n",
  "EXCERPTUM": "(Latin) an excerpt, selection [n EXCERPTA]\n",
  "EXCESS": "to eliminate the position of [v -ED, -ING, -ES]\n",
  "EXCESSED": "EXCESS, to eliminate the position of [v]\n",
  "EXCESSES": "EXCESS, to eliminate the position of [v]\n",
  "EXCESSING": "EXCESS, to eliminate the position of [v]\n",
  "EXCESSIVE": "beyond what is usual or right; immoderate [adj EXCESSIVELY]\n",
  "EXCESSIVELY": "EXCESSIVE, beyond what is usual or right; immoderate [adv]\n",
  "EXCESSIVENESS": "EXCESSIVE, beyond what is usual or right; immoderate [n]\n",
  "EXCESSIVENESSES": "EXCESSIVENESS, EXCESSIVE, beyond what is usual or right; immoderate [n]\n",
  "EXCHANGE": "to give and receive reciprocally [v EXCHANGED, EXCHANGING, EXCHANGES]\n",
  "EXCHANGEABILITY": "the state of being exchangeable [n]\n",
  "EXCHANGEABLE": "capable of being exchanged [adj EXCHANGEABLY]\n",
  "EXCHANGEABLY": "EXCHANGEABLE, capable of being exchanged [adv]\n",
  "EXCHANGED": "EXCHANGE, to give and receive reciprocally [v]\n",
  "EXCHANGER": "one who exchanges [n -S]\n",
  "EXCHANGERS": "EXCHANGER, one who exchanges [n]\n",
  "EXCHANGES": "EXCHANGE, to give and receive reciprocally [v]\n",
  "EXCHANGING": "EXCHANGE, to give and receive reciprocally [v]\n",
  "EXCHEAT": "(Spenser) property that falls to the state or feudal lord for lack of an heir, also ESCHEAT [n -S]\n",
  "EXCHEATS": "EXCHEAT, (Spenser) property that falls to the state or feudal lord for lack of an heir, also ESCHEAT [n]\n",
  "EXCHEQUER": "the Government's account at the Bank of England whose balance forms the Consolidated Fund [n -S] / to place in an exchequer or treasury [v -ED, -ING, -S]\n",
  "EXCHEQUERED": "EXCHEQUER, to place in an exchequer or treasury [v]\n",
  "EXCHEQUERING": "EXCHEQUER, to place in an exchequer or treasury [v]\n",
  "EXCHEQUERS": "EXCHEQUER, to place in an exchequer or treasury [v]\n",
  "EXCIDE": "(archaic) to cut off [v EXCIDED, EXCIDING, EXCIDES]\n",
  "EXCIDED": "EXCIDE, (archaic) to cut off [v]\n",
  "EXCIDES": "EXCIDE, (archaic) to cut off [v]\n",
  "EXCIDING": "EXCIDE, (archaic) to cut off [v]\n",
  "EXCIMER": "a dimer above the ground state [n -S]\n",
  "EXCIMERS": "EXCIMER, a dimer above the ground state [n]\n",
  "EXCIPIENT": "a substance mixed with a medicine to give it consistency [n -S]\n",
  "EXCIPIENTS": "EXCIPIENT, a substance mixed with a medicine to give it consistency [n]\n",
  "EXCIPLE": "a rim around the hymenium of various lichens [n -S]\n",
  "EXCIPLES": "EXCIPLE, a rim around the hymenium of various lichens [n]\n",
  "EXCISABLE": "liable or subject to excise; as, tobacco in an excisable commodity [adj]\n",
  "EXCISE": "to cut off or out [v EXCISED, EXCISING, EXCISES]\n",
  "EXCISED": "EXCISE, to cut off or out [v]\n",
  "EXCISEMAN": "an officer charged with collecting excise duty [n EXCISEMEN]\n",
  "EXCISEMEN": "EXCISEMAN, an officer charged with collecting excise duty [n]\n",
  "EXCISES": "EXCISE, to cut off or out [v]\n",
  "EXCISING": "EXCISE, to cut off or out [v]\n",
  "EXCISION": "the act of excising [n -S]\n",
  "EXCISIONAL": "relating to the act of excision [adj]\n",
  "EXCISIONS": "EXCISION, the act of excising [n]\n",
  "EXCITABILITIES": "EXCITABILITY, the state of being excitable [n]\n",
  "EXCITABILITY": "the state of being excitable [n EXCITABILITIES]\n",
  "EXCITABLE": "able to be excited [adj EXCITABLY]\n",
  "EXCITABLENESS": "EXCITABLE, able to be excited [n]\n",
  "EXCITABLENESSES": "EXCITABLENESS, EXCITABLE, able to be excited [n]\n",
  "EXCITABLY": "EXCITABLE, able to be excited [adv]\n",
  "EXCITANCIES": "EXCITANCY, the property of being an excitant [n]\n",
  "EXCITANCY": "the property of being an excitant [n EXCITANCIES]\n",
  "EXCITANT": "a stimulant [n -S]\n",
  "EXCITANTS": "EXCITANT, a stimulant [n]\n",
  "EXCITATION": "the act of exciting or putting in motion [n -S]\n",
  "EXCITATIONS": "EXCITATION, the act of exciting or putting in motion [n]\n",
  "EXCITATIVE": "having power to excite [adj]\n",
  "EXCITATORY": "tending to excite [adj]\n",
  "EXCITE": "to arouse the emotions of [v EXCITED, EXCITING, EXCITES]\n",
  "EXCITED": "EXCITE, to arouse the emotions of [v]\n",
  "EXCITEDLY": "EXCITED, EXCITE, to arouse the emotions of [adv]\n",
  "EXCITEDNESS": "the state of being excited [n -ES]\n",
  "EXCITEDNESSES": "EXCITEDNESS, the state of being excited [n]\n",
  "EXCITEMENT": "something that excites or rouses [n -S]\n",
  "EXCITEMENTS": "EXCITEMENT, something that excites or rouses [n]\n",
  "EXCITER": "one that excites, also EXCITOR [n -S]\n",
  "EXCITERS": "EXCITER, one that excites, also EXCITOR [n]\n",
  "EXCITES": "EXCITE, to arouse the emotions of [v]\n",
  "EXCITING": "EXCITE, to arouse the emotions of [v]\n",
  "EXCITINGLY": "EXCITING, EXCITE, to arouse the emotions of [adv]\n",
  "EXCITON": "a combination of excited electron and hole [n -S]\n",
  "EXCITONIC": "relating to an exciton, an electrically neutral excited crystal state, bound state of electron and hole [adj]\n",
  "EXCITONS": "EXCITON, a combination of excited electron and hole [n]\n",
  "EXCITOR": "one that excites, also EXCITER [n -S]\n",
  "EXCITORS": "EXCITOR, one that excites, also EXCITER [n]\n",
  "EXCLAIM": "to cry out in surprise [v -ED, -ING, -S]\n",
  "EXCLAIMED": "EXCLAIM, to cry out in surprise [v]\n",
  "EXCLAIMER": "one who exclaims [n -S]\n",
  "EXCLAIMERS": "EXCLAIMER, one who exclaims [n]\n",
  "EXCLAIMING": "EXCLAIM, to cry out in surprise [v]\n",
  "EXCLAIMS": "EXCLAIM, to cry out in surprise [v]\n",
  "EXCLAMATION": "a sharp or sudden utterance [n -S]\n",
  "EXCLAMATIONAL": "of or like an exclamation [adj]\n",
  "EXCLAMATIONS": "EXCLAMATION, a sharp or sudden utterance [n]\n",
  "EXCLAMATIVE": "a word or sentence that denotes an exclamation [n -S]\n",
  "EXCLAMATIVES": "EXCLAMATIVE, a word or sentence that denotes an exclamation [n]\n",
  "EXCLAMATORILY": "EXCLAMATORY, containing or expressing exclamation, also EXCLAMATIVE [adv]\n",
  "EXCLAMATORY": "containing or expressing exclamation, also EXCLAMATIVE [adj EXCLAMATORILY]\n",
  "EXCLAUSTRATION": "a release from religious vows to return to the secular world [n -S]\n",
  "EXCLAUSTRATIONS": "EXCLAUSTRATION, a release from religious vows to return to the secular world [n]\n",
  "EXCLAVE": "a portion of a country separated from the main part and constituting an enclave in respect to the surrounding territory [n -S]\n",
  "EXCLAVES": "EXCLAVE, a portion of a country separated from the main part and constituting an enclave in respect to the surrounding territory [n]\n",
  "EXCLOSURE": "an area shut off from intrusion [n -S]\n",
  "EXCLOSURES": "EXCLOSURE, an area shut off from intrusion [n]\n",
  "EXCLUDABILITIES": "EXCLUDABILITY, the state of being excludable [n]\n",
  "EXCLUDABILITY": "the state of being excludable [n EXCLUDABILITIES]\n",
  "EXCLUDABLE": "that can be excluded, also EXCLUDIBLE [adj]\n",
  "EXCLUDE": "to shut out [v EXCLUDED, EXCLUDING, EXCLUDES]\n",
  "EXCLUDED": "EXCLUDE, to shut out [v]\n",
  "EXCLUDEE": "someone who is excluded [n -S]\n",
  "EXCLUDEES": "EXCLUDEE, someone who is excluded [n]\n",
  "EXCLUDER": "one who excludes [n -S]\n",
  "EXCLUDERS": "EXCLUDER, one who excludes [n]\n",
  "EXCLUDES": "EXCLUDE, to shut out [v]\n",
  "EXCLUDIBLE": "that can be excluded, also EXCLUDABLE [adj]\n",
  "EXCLUDING": "EXCLUDE, to shut out [v]\n",
  "EXCLUSION": "the act of excluding [n -S]\n",
  "EXCLUSIONARY": "relating to exclusion [adj]\n",
  "EXCLUSIONISM": "the practice of excluding others from some right or privilege [n -S]\n",
  "EXCLUSIONISMS": "EXCLUSIONISM, the practice of excluding others from some right or privilege [n]\n",
  "EXCLUSIONIST": "one who would exclude another from some right or privilege [n -S]\n",
  "EXCLUSIONISTS": "EXCLUSIONIST, one who would exclude another from some right or privilege [n]\n",
  "EXCLUSIONS": "EXCLUSION, the act of excluding [n]\n",
  "EXCLUSIVE": "able or tending to exclude [adj EXCLUSIVELY] / an exclusive news scoop [n -S]\n",
  "EXCLUSIVELY": "EXCLUSIVE, able or tending to exclude [adv]\n",
  "EXCLUSIVENESS": "the state of being exclusive [n -ES]\n",
  "EXCLUSIVENESSES": "EXCLUSIVENESS, the state of being exclusive [n]\n",
  "EXCLUSIVES": "EXCLUSIVE, an exclusive news scoop [n]\n",
  "EXCLUSIVISM": "the practice of excluding or of being exclusive [n -S]\n",
  "EXCLUSIVISMS": "EXCLUSIVISM, the practice of excluding or of being exclusive [n]\n",
  "EXCLUSIVIST": "a believer in exclusivism [n -S]\n",
  "EXCLUSIVISTS": "EXCLUSIVIST, a believer in exclusivism [n]\n",
  "EXCLUSIVITIES": "EXCLUSIVITY, the state of being exclusive [n]\n",
  "EXCLUSIVITY": "the state of being exclusive [n EXCLUSIVITIES]\n",
  "EXCLUSORY": "acting or tending to exclude [adj]\n",
  "EXCOGITABLE": "that can be excogitated [adj]\n",
  "EXCOGITATE": "to discover by thinking out or reasoning [v EXCOGITATED, EXCOGITATING, EXCOGITATES]\n",
  "EXCOGITATED": "EXCOGITATE, to discover by thinking out or reasoning [v]\n",
  "EXCOGITATES": "EXCOGITATE, to discover by thinking out or reasoning [v]\n",
  "EXCOGITATING": "EXCOGITATE, to discover by thinking out or reasoning [v]\n",
  "EXCOGITATION": "the act of excogitating [n -S]\n",
  "EXCOGITATIONS": "EXCOGITATION, the act of excogitating [n]\n",
  "EXCOGITATIVE": "relating to excogitation [adj]\n",
  "EXCOGITATOR": "one who excogitates [n -S]\n",
  "EXCOGITATORS": "EXCOGITATOR, one who excogitates [n]\n",
  "EXCOMMUNICABLE": "that can be excommunicated [adj]\n",
  "EXCOMMUNICATE": "to formally exclude someone from a group or community, esp. from a religious community [v EXCOMMUNICATED, EXCOMMUNICATING, EXCOMMUNICATES]\n",
  "EXCOMMUNICATED": "EXCOMMUNICATE, to formally exclude someone from a group or community, esp. from a religious community [v]\n",
  "EXCOMMUNICATES": "EXCOMMUNICATE, to formally exclude someone from a group or community, esp. from a religious community [v]\n",
  "EXCOMMUNICATING": "EXCOMMUNICATE, to formally exclude someone from a group or community, esp. from a religious community [v]\n",
  "EXCOMMUNICATION": "an ecclesiastical censure depriving a person of the rights of church membership [n]\n",
  "EXCOMMUNICATIVE": "relating to excommunication [adj]\n",
  "EXCOMMUNICATOR": "one who excommunicates [n -S]\n",
  "EXCOMMUNICATORS": "EXCOMMUNICATOR, one who excommunicates [n]\n",
  "EXCOMMUNICATORY": "of or relating to excommunication [adj]\n",
  "EXCOMMUNION": "(Milton) excommunication [n -S]\n",
  "EXCOMMUNIONS": "EXCOMMUNION, (Milton) excommunication [n]\n",
  "EXCORIATE": "to abrade; to heap abuse [v EXCORIATED, EXCORIATING, EXCORIATES]\n",
  "EXCORIATED": "EXCORIATE, to abrade; to heap abuse [v]\n",
  "EXCORIATES": "EXCORIATE, to abrade; to heap abuse [v]\n",
  "EXCORIATING": "EXCORIATE, to abrade; to heap abuse [v]\n",
  "EXCORIATION": "the act of excoriating [n -S]\n",
  "EXCORIATIONS": "EXCORIATION, the act of excoriating [n]\n",
  "EXCORTICATE": "to strip the bark off of [v EXCORTICATED, EXCORTICATING, EXCORTICATES]\n",
  "EXCORTICATED": "EXCORTICATE, to strip the bark off of [v]\n",
  "EXCORTICATES": "EXCORTICATE, to strip the bark off of [v]\n",
  "EXCORTICATING": "EXCORTICATE, to strip the bark off of [v]\n",
  "EXCORTICATION": "the act of excorticating, stripping the bark from [n -S]\n",
  "EXCORTICATIONS": "EXCORTICATION, the act of excorticating, stripping the bark from [n]\n",
  "EXCREMENT": "waste matter discharged from the digestive system [n -S]\n",
  "EXCREMENTA": "EXCREMENTUM, (Latin) waste material or rubbish [n]\n",
  "EXCREMENTAL": "relating to excrement, also EXCREMENTITIAL [adj]\n",
  "EXCREMENTITIAL": "of or pertaining to excrement, also EXCREMENTAL [adj]\n",
  "EXCREMENTITIOUS": "relating to excrement [adj]\n",
  "EXCREMENTS": "EXCREMENT, waste matter discharged from the digestive system [n]\n",
  "EXCREMENTUM": "(Latin) waste material or rubbish [n EXCREMENTA]\n",
  "EXCRESCENCE": "an outgrowth from the surface, also EXCRESCENCY [n -S]\n",
  "EXCRESCENCES": "EXCRESCENCE, an outgrowth from the surface, also EXCRESCENCY [n]\n",
  "EXCRESCENCIES": "EXCRESCENCY, an outgrowth from the surface, also EXCRESCENCE [n]\n",
  "EXCRESCENCY": "an outgrowth from the surface, also EXCRESCENCE [n EXCRESCENCIES]\n",
  "EXCRESCENT": "growing out in an abnormal or morbid manner or as a superfluity [adj EXCRESCENTLY]\n",
  "EXCRESCENTIAL": "of or like an excrescence [adj]\n",
  "EXCRESCENTLY": "EXCRESCENT, growing out in an abnormal or morbid manner or as a superfluity [adv]\n",
  "EXCRETA": "(Latin) waste discharged from the body [n]\n",
  "EXCRETAL": "relating to excreta [adj]\n",
  "EXCRETE": "to discharge or eject [v EXCRETED, EXCRETING, EXCRETES]\n",
  "EXCRETED": "EXCRETE, to discharge or eject [v]\n",
  "EXCRETER": "one who excretes [n -S]\n",
  "EXCRETERS": "EXCRETER, one who excretes [n]\n",
  "EXCRETES": "EXCRETE, to discharge or eject [v]\n",
  "EXCRETING": "EXCRETE, to discharge or eject [v]\n",
  "EXCRETION": "the act of excreting [n -S]\n",
  "EXCRETIONS": "EXCRETION, the act of excreting [n]\n",
  "EXCRETIVE": "having the power of excreting, or promoting excretion [adj]\n",
  "EXCRETORIES": "EXCRETORY, a duct that helps to receive and excrete matter [n]\n",
  "EXCRETORY": "serving to excrete [adj] / a duct that helps to receive and excrete matter [n EXCRETORIES]\n",
  "EXCRUCIATE": "to inflict intense pain on [v EXCRUCIATED, EXCRUCIATING, EXCRUCIATES]\n",
  "EXCRUCIATED": "EXCRUCIATE, to inflict intense pain on [v]\n",
  "EXCRUCIATES": "EXCRUCIATE, to inflict intense pain on [v]\n",
  "EXCRUCIATING": "EXCRUCIATE, to inflict intense pain on [v]\n",
  "EXCRUCIATINGLY": "EXCRUCIATING, EXCRUCIATE, to inflict intense pain on [adv]\n",
  "EXCRUCIATION": "the act of excruciating [n -S]\n",
  "EXCRUCIATIONS": "EXCRUCIATION, the act of excruciating [n]\n",
  "EXCUBANT": "on guard [adj]\n",
  "EXCUDIT": "(Latin) used in art to denote the publisher, literally \"he/she executed it\" [v]\n",
  "EXCULPABLE": "capable of being exculpated [adj]\n",
  "EXCULPATE": "to free from blame [v EXCULPATED, EXCULPATING, EXCULPATES]\n",
  "EXCULPATED": "EXCULPATE, to free from blame [v]\n",
  "EXCULPATES": "EXCULPATE, to free from blame [v]\n",
  "EXCULPATING": "EXCULPATE, to free from blame [v]\n",
  "EXCULPATION": "the act of exculpating [n -S]\n",
  "EXCULPATIONS": "EXCULPATION, the act of exculpating [n]\n",
  "EXCULPATORY": "tending or serving to clear from alleged fault or guilt [adj]\n",
  "EXCURRENT": "running or flowing out [adj]\n",
  "EXCURSE": "(archaic) to digress [v EXCURSED, EXCURSING, EXCURSES]\n",
  "EXCURSED": "EXCURSE, (archaic) to digress [v]\n",
  "EXCURSES": "EXCURSE, (archaic) to digress [v]\n",
  "EXCURSING": "EXCURSE, (archaic) to digress [v]\n",
  "EXCURSION": "a pleasure trip [n -S] / to go on an excursion [v -ED, -ING, -S]\n",
  "EXCURSIONED": "EXCURSION, to go on an excursion [v]\n",
  "EXCURSIONING": "EXCURSION, to go on an excursion [v]\n",
  "EXCURSIONISE": "to go on an excursion, also EXCURSIONIZE [v EXCURSIONISED, EXCURSIONISING, EXCURSIONISES]\n",
  "EXCURSIONISED": "EXCURSIONISE, to go on an excursion, also EXCURSIONIZE [v]\n",
  "EXCURSIONISES": "EXCURSIONISE, to go on an excursion, also EXCURSIONIZE [v]\n",
  "EXCURSIONISING": "EXCURSIONISE, to go on an excursion, also EXCURSIONIZE [v]\n",
  "EXCURSIONIST": "a person who goes on an excursion [n -S]\n",
  "EXCURSIONISTS": "EXCURSIONIST, a person who goes on an excursion [n]\n",
  "EXCURSIONIZE": "to go on an excursion, also EXCURSIONISE [v EXCURSIONIZED, EXCURSIONIZING, EXCURSIONIZES]\n",
  "EXCURSIONIZED": "EXCURSIONIZE, to go on an excursion, also EXCURSIONISE [v]\n",
  "EXCURSIONIZES": "EXCURSIONIZE, to go on an excursion, also EXCURSIONISE [v]\n",
  "EXCURSIONIZING": "EXCURSIONIZE, to go on an excursion, also EXCURSIONISE [v]\n",
  "EXCURSIONS": "EXCURSION, to go on an excursion [v]\n",
  "EXCURSIVE": "constituting a digression [adj EXCURSIVELY]\n",
  "EXCURSIVELY": "EXCURSIVE, constituting a digression [adv]\n",
  "EXCURSIVENESS": "EXCURSIVE, constituting a digression [n]\n",
  "EXCURSIVENESSES": "EXCURSIVENESS, EXCURSIVE, constituting a digression [n]\n",
  "EXCURSUS": "(Latin) a dissertation or discussion on some particular matter appended to the main body of a book or chapter [n -ES]\n",
  "EXCURSUSES": "EXCURSUS, (Latin) a dissertation or discussion on some particular matter appended to the main body of a book or chapter [n]\n",
  "EXCUSABLE": "that can be excused [adj EXCUSABLY]\n",
  "EXCUSABLENESS": "EXCUSABLE, that can be excused [n]\n",
  "EXCUSABLENESSES": "EXCUSABLENESS, EXCUSABLE, that can be excused [n]\n",
  "EXCUSABLY": "EXCUSABLE, that can be excused [adv]\n",
  "EXCUSAL": "an acceptance of an excuse [n -S]\n",
  "EXCUSALS": "EXCUSAL, an acceptance of an excuse [n]\n",
  "EXCUSATORY": "making or containing excuse or apology [adj]\n",
  "EXCUSE": "to free from blame or guilt [v EXCUSED, EXCUSING, EXCUSES]\n",
  "EXCUSED": "EXCUSE, to free from blame or guilt [v]\n",
  "EXCUSER": "one who excuses [n -S]\n",
  "EXCUSERS": "EXCUSER, one who excuses [n]\n",
  "EXCUSES": "EXCUSE, to free from blame or guilt [v]\n",
  "EXCUSING": "EXCUSE, to free from blame or guilt [v]\n",
  "EXCUSIVE": "pertaining to an excuse [adj]\n",
  "EXEAT": "(Latin) a permit for temporary absence (as from a college or monastery) [n -S]\n",
  "EXEATS": "EXEAT, (Latin) a permit for temporary absence (as from a college or monastery) [n]\n",
  "EXEC": "(short for) an executive [n -S]\n",
  "EXECRABLE": "detestable, wretched [adj EXECRABLY]\n",
  "EXECRABLENESS": "EXECRABLE, detestable, wretched [n]\n",
  "EXECRABLENESSES": "EXECRABLENESS, EXECRABLE, detestable, wretched [n]\n",
  "EXECRABLY": "EXECRABLE, detestable, wretched [adv]\n",
  "EXECRATE": "to declare to be evil; to denounce or place under a curse [v EXECRATED, EXECRATING, EXECRATES]\n",
  "EXECRATED": "EXECRATE, to declare to be evil; to denounce or place under a curse [v]\n",
  "EXECRATES": "EXECRATE, to declare to be evil; to denounce or place under a curse [v]\n",
  "EXECRATING": "EXECRATE, to declare to be evil; to denounce or place under a curse [v]\n",
  "EXECRATION": "the act of cursing [n -S]\n",
  "EXECRATIONS": "EXECRATION, the act of cursing [n]\n",
  "EXECRATIVE": "cursing; vilifying [adj EXECRATIVELY]\n",
  "EXECRATIVELY": "EXECRATIVE, cursing; vilifying [adv]\n",
  "EXECRATOR": "one who execrates [n -S]\n",
  "EXECRATORS": "EXECRATOR, one who execrates [n]\n",
  "EXECRATORY": "of the nature of execration [adj]\n",
  "EXECS": "EXEC, (short for) an executive [n]\n",
  "EXECUTABLE": "that can be executed [adj] / an executable piece of code [n -S]\n",
  "EXECUTABLES": "EXECUTABLE, an executable piece of code [n]\n",
  "EXECUTANCIES": "EXECUTANCY, technique in music [n]\n",
  "EXECUTANCY": "technique in music [n EXECUTANCIES]\n",
  "EXECUTANT": "one who executes or performs, esp. a performer on a musical instrument [n -S]\n",
  "EXECUTANTS": "EXECUTANT, one who executes or performs, esp. a performer on a musical instrument [n]\n",
  "EXECUTARIES": "EXECUTARY, a business whose job comprises tasks appropriate to middle management as well as those traditionally carried out by a secretary [n]\n",
  "EXECUTARY": "a business whose job comprises tasks appropriate to middle management as well as those traditionally carried out by a secretary [n EXECUTARIES]\n",
  "EXECUTE": "to perform or carry out [v EXECUTED, EXECUTING, EXECUTES]\n",
  "EXECUTED": "EXECUTE, to perform or carry out [v]\n",
  "EXECUTER": "one who executes, also EXECUTOR [n -S]\n",
  "EXECUTERS": "EXECUTER, one who executes, also EXECUTOR [n]\n",
  "EXECUTES": "EXECUTE, to perform or carry out [v]\n",
  "EXECUTING": "EXECUTE, to perform or carry out [v]\n",
  "EXECUTION": "the act of executing [n -S]\n",
  "EXECUTIONER": "one who executes [n -S]\n",
  "EXECUTIONERS": "EXECUTIONER, one who executes [n]\n",
  "EXECUTIONS": "EXECUTION, the act of executing [n]\n",
  "EXECUTIVE": "concerned with performance, administration or management [adj EXECUTIVELY] / a person in an executive position in government [n -S]\n",
  "EXECUTIVELY": "EXECUTIVE, concerned with performance, administration or management [adv]\n",
  "EXECUTIVES": "EXECUTIVE, a person in an executive position in government [n]\n",
  "EXECUTOR": "one who executes, also EXECUTER [n -S]\n",
  "EXECUTORIAL": "relating to an executor [adj]\n",
  "EXECUTORS": "EXECUTOR, one who executes, also EXECUTER [n]\n",
  "EXECUTORSHIP": "the office of executor [n -S]\n",
  "EXECUTORSHIPS": "EXECUTORSHIP, the office of executor [n]\n",
  "EXECUTORY": "pertaining to administration, or putting the laws in force [adj]\n",
  "EXECUTRESS": "a female executor, also EXECUTRIX [n -ES]\n",
  "EXECUTRESSES": "EXECUTRESS, a female executor, also EXECUTRIX [n]\n",
  "EXECUTRICES": "EXECUTRIX, a woman exercising the functions of an executor, also EXECUTRESS [n]\n",
  "EXECUTRIES": "EXECUTRY, in Scots law, movable or heritable estate and effects [n]\n",
  "EXECUTRIX": "a woman exercising the functions of an executor, also EXECUTRESS [n EXECUTRICES or EXECUTRIXES]\n",
  "EXECUTRIXES": "EXECUTRIX, a woman exercising the functions of an executor, also EXECUTRESS [n]\n",
  "EXECUTRY": "in Scots law, movable or heritable estate and effects [n EXECUTRIES]\n",
  "EXED": "EX, to cross out [v]\n",
  "EXEDRA": "(Latin) a curved bench in a recess, also EXHEDRA [n EXEDRAE or EXEDRAS]\n",
  "EXEDRAE": "EXEDRA, (Latin) a curved bench in a recess, also EXHEDRA [n]\n",
  "EXEDRAS": "EXEDRA, (Latin) a curved bench in a recess, also EXHEDRA [n]\n",
  "EXEEM": "(Scots) to release or exempt, also EXEME [v -ED, -ING, -S]\n",
  "EXEEMED": "EXEEM, (Scots) to release or exempt, also EXEME [v]\n",
  "EXEEMING": "EXEEM, (Scots) to release or exempt, also EXEME [v]\n",
  "EXEEMS": "EXEEM, (Scots) to release or exempt, also EXEME [v]\n",
  "EXEGESES": "EXEGESIS, a critical interpretation of a text [n]\n",
  "EXEGESIS": "a critical interpretation of a text [n EXEGESES]\n",
  "EXEGETE": "one versed in the science of exegesis or interpretation, also EXEGETIST [n -S]\n",
  "EXEGETES": "EXEGETE, one versed in the science of exegesis or interpretation, also EXEGETIST [n]\n",
  "EXEGETIC": "pertaining to exegesis, expository, also EXEGETICAL [adj EXEGETICALLY]\n",
  "EXEGETICAL": "pertaining to exegesis, expository, also EXEGETIC [adj EXEGETICALLY]\n",
  "EXEGETICALLY": "EXEGETICAL, pertaining to exegesis, expository, also EXEGETIC [adv]\n",
  "EXEGETICS": "the science of interpretation or exegesis [n]\n",
  "EXEGETIST": "one versed in the science of exegesis or interpretation, also EXEGETE [n -S]\n",
  "EXEGETISTS": "EXEGETIST, one versed in the science of exegesis or interpretation, also EXEGETE [n]\n",
  "EXEME": "(Scots) to release or exempt, also EXEEM [v EXEMED, EXEMING, EXEMES]\n",
  "EXEMED": "EXEME, (Scots) to release or exempt, also EXEEM [v]\n",
  "EXEMES": "EXEME, (Scots) to release or exempt, also EXEEM [v]\n",
  "EXEMING": "EXEME, (Scots) to release or exempt, also EXEEM [v]\n",
  "EXEMPLA": "EXEMPLUM, (Latin) a short story or anecdote with a moral [n]\n",
  "EXEMPLAR": "an ideal model, also EXAMPLAR [n -S]\n",
  "EXEMPLARILY": "EXEMPLARY, serving as an example [adv]\n",
  "EXEMPLARINESS": "the state of being exemplary [n -ES]\n",
  "EXEMPLARINESSES": "EXEMPLARINESS, the state of being exemplary [n]\n",
  "EXEMPLARITIES": "EXEMPLARITY, the state of being exemplary [n]\n",
  "EXEMPLARITY": "the state of being exemplary [n EXEMPLARITIES]\n",
  "EXEMPLARS": "EXEMPLAR, an ideal model, also EXAMPLAR [n]\n",
  "EXEMPLARY": "serving as an example [adj EXEMPLARILY]\n",
  "EXEMPLE": "(French) an example or model [n -S]\n",
  "EXEMPLES": "EXEMPLE, (French) an example or model [n]\n",
  "EXEMPLIFIABLE": "that can be exemplified [adj]\n",
  "EXEMPLIFICATION": "the act of exemplifying [n]\n",
  "EXEMPLIFICATIVE": "serving to exemplify [adj]\n",
  "EXEMPLIFIED": "EXEMPLIFY, to serve as an example [v]\n",
  "EXEMPLIFIER": "one who exemplifies [n -S]\n",
  "EXEMPLIFIERS": "EXEMPLIFIER, one who exemplifies [n]\n",
  "EXEMPLIFIES": "EXEMPLIFY, to serve as an example [v]\n",
  "EXEMPLIFY": "to serve as an example [v EXEMPLIFIED, EXEMPLIFYING, EXEMPLIFIES]\n",
  "EXEMPLIFYING": "EXEMPLIFY, to serve as an example [v]\n",
  "EXEMPLUM": "(Latin) a short story or anecdote with a moral [n EXEMPLA]\n",
  "EXEMPT": "to free from liability [v -ED, -ING, -S]\n",
  "EXEMPTED": "EXEMPT, to free from liability [v]\n",
  "EXEMPTING": "EXEMPT, to free from liability [v]\n",
  "EXEMPTION": "the act of making exempt [n -S]\n",
  "EXEMPTIONS": "EXEMPTION, the act of making exempt [n]\n",
  "EXEMPTIVE": "tending to exempt [adj]\n",
  "EXEMPTS": "EXEMPT, to free from liability [v]\n",
  "EXENTERATE": "(obsolete) to disembowel [v EXENTERATED, EXENTERATING, EXENTERATES]\n",
  "EXENTERATED": "EXENTERATE, (obsolete) to disembowel [v]\n",
  "EXENTERATES": "EXENTERATE, (obsolete) to disembowel [v]\n",
  "EXENTERATING": "EXENTERATE, (obsolete) to disembowel [v]\n",
  "EXENTERATION": "the act of exenterating [n -S]\n",
  "EXENTERATIONS": "EXENTERATION, the act of exenterating [n]\n",
  "EXEQUATUR": "(Latin) an official recognition of a consul or commercial agent given by the government of the country in which he or she is to be based [n -S]\n",
  "EXEQUATURS": "EXEQUATUR, (Latin) an official recognition of a consul or commercial agent given by the government of the country in which he or she is to be based [n]\n",
  "EXEQUIAL": "of or pertaining to funerals [adj]\n",
  "EXEQUIES": "EXEQUY, a funeral procession [n]\n",
  "EXEQUY": "a funeral procession [n EXEQUIES]\n",
  "EXERCISABLE": "that can be exercised [adj]\n",
  "EXERCISE": "to perform a set drill [v EXERCISED, EXERCISING, EXERCISES]\n",
  "EXERCISED": "EXERCISE, to perform a set drill [v]\n",
  "EXERCISER": "one who exercises [n -S]\n",
  "EXERCISERS": "EXERCISER, one who exercises [n]\n",
  "EXERCISES": "EXERCISE, to perform a set drill [v]\n",
  "EXERCISING": "EXERCISE, to perform a set drill [v]\n",
  "EXERCITATION": "putting into practice [n -S]\n",
  "EXERCITATIONS": "EXERCITATION, putting into practice [n]\n",
  "EXERCYCLE": "an exercise bike [n -S]\n",
  "EXERCYCLES": "EXERCYCLE, an exercise bike [n]\n",
  "EXERGAMING": "the playing of video games that require rigorous physical exercise and are intended as a workout [n -S]\n",
  "EXERGAMINGS": "EXERGAMING, the playing of video games that require rigorous physical exercise and are intended as a workout [n]\n",
  "EXERGIES": "EXERGY, a measure of the maximum amount of work that can theoretically be obtained from a system [n]\n",
  "EXERGONIC": "of a biochemical reaction, accompanied by the release of energy and therefore capable of proceeding spontaneously [adj]\n",
  "EXERGUAL": "relating to the exergue, the space on a coin, token or medal usually on the reverse below the date [adj]\n",
  "EXERGUE": "(French) a space on a coin, token or medal usually on the reverse below the date [n -S]\n",
  "EXERGUES": "EXERGUE, (French) a space on a coin, token or medal usually on the reverse below the date [n]\n",
  "EXERGY": "a measure of the maximum amount of work that can theoretically be obtained from a system [n EXERGIES]\n",
  "EXERT": "to make an effort [v -ED, -ING, -S]\n",
  "EXERTAINMENT": "entertainment resources for use while exercising [n -S]\n",
  "EXERTAINMENTS": "EXERTAINMENT, entertainment resources for use while exercising [n]\n",
  "EXERTED": "EXERT, to make an effort [v]\n",
  "EXERTING": "EXERT, to make an effort [v]\n",
  "EXERTION": "the act of exerting [n -S]\n",
  "EXERTIONS": "EXERTION, the act of exerting [n]\n",
  "EXERTIVE": "having power or a tendency to exert [adj]\n",
  "EXERTS": "EXERT, to make an effort [v]\n",
  "EXES": "EX, to cross out [v]\n",
  "EXEUNT": "(Latin) (stage direction) they go out [v]\n",
  "EXFIL": "to remove (data) from a computer, network, etc. surreptitiously and without permission or unlawfully [v EXFILLED, EXFILLING, EXFILS]\n",
  "EXFILLED": "EXFIL, to remove (data) from a computer, network, etc. surreptitiously and without permission or unlawfully [v]\n",
  "EXFILLING": "EXFIL, to remove (data) from a computer, network, etc. surreptitiously and without permission or unlawfully [v]\n",
  "EXFILS": "EXFIL, to remove (data) from a computer, network, etc. surreptitiously and without permission or unlawfully [v]\n",
  "EXFILTRATE": "to remove or withdraw (an intelligence agent, soldier, etc.) surreptitiously from an enemy-held area [v EXFILTRATED, EXFILTRATING, EXFILTRATES]\n",
  "EXFILTRATED": "EXFILTRATE, to remove or withdraw (an intelligence agent, soldier, etc.) surreptitiously from an enemy-held area [v]\n",
  "EXFILTRATES": "EXFILTRATE, to remove or withdraw (an intelligence agent, soldier, etc.) surreptitiously from an enemy-held area [v]\n",
  "EXFILTRATING": "EXFILTRATE, to remove or withdraw (an intelligence agent, soldier, etc.) surreptitiously from an enemy-held area [v]\n",
  "EXFOLIANT": "a cosmetic for removing dead skin [n -S]\n",
  "EXFOLIANTS": "EXFOLIANT, a cosmetic for removing dead skin [n]\n",
  "EXFOLIATE": "to separate and come off in scales or laminae, as pieces of carious bone or of bark [v EXFOLIATED, EXFOLIATING, EXFOLIATES]\n",
  "EXFOLIATED": "EXFOLIATE, to separate and come off in scales or laminae, as pieces of carious bone or of bark [v]\n",
  "EXFOLIATES": "EXFOLIATE, to separate and come off in scales or laminae, as pieces of carious bone or of bark [v]\n",
  "EXFOLIATING": "EXFOLIATE, to separate and come off in scales or laminae, as pieces of carious bone or of bark [v]\n",
  "EXFOLIATION": "the process by which concentric scales, plates, or shells of rock are stripped or spall from the bare surface of a large rock mass [n -S]\n",
  "EXFOLIATIONS": "EXFOLIATION, the process by which concentric scales, plates, or shells of rock are stripped or spall from the bare surface of a large rock mass [n]\n",
  "EXFOLIATIVE": "serving to exfoliate [adj]\n",
  "EXFOLIATOR": "an exfoliating agent [n -S]\n",
  "EXFOLIATORS": "EXFOLIATOR, an exfoliating agent [n]\n",
  "EXHALABLE": "capable of being exhaled or evaporated [adj]\n",
  "EXHALANT": "a vessel that emits vapour or liquid, also EXHALENT [n -S]\n",
  "EXHALANTS": "EXHALANT, a vessel that emits vapour or liquid, also EXHALENT [n]\n",
  "EXHALATION": "something exhaled or given off [n -S]\n",
  "EXHALATIONS": "EXHALATION, something exhaled or given off [n]\n",
  "EXHALE": "to breathe out [v EXHALED, EXHALING, EXHALES]\n",
  "EXHALED": "EXHALE, to breathe out [v]\n",
  "EXHALENT": "a vessel that emits vapour or liquid, also EXHALANT [n -S]\n",
  "EXHALENTS": "EXHALENT, a vessel that emits vapour or liquid, also EXHALANT [n]\n",
  "EXHALES": "EXHALE, to breathe out [v]\n",
  "EXHALING": "EXHALE, to breathe out [v]\n",
  "EXHAUST": "to use the whole strength of [v -ED, -ING, -S]\n",
  "EXHAUSTED": "EXHAUST, to use the whole strength of [v]\n",
  "EXHAUSTEDLY": "in the manner of one who has no strength [adv]\n",
  "EXHAUSTER": "one who, or that which, exhausts [n -S]\n",
  "EXHAUSTERS": "EXHAUSTER, one who, or that which, exhausts [n]\n",
  "EXHAUSTIBILITY": "the state of being exhaustible [n]\n",
  "EXHAUSTIBLE": "capable of being exhausted [adj]\n",
  "EXHAUSTING": "EXHAUST, to use the whole strength of [v]\n",
  "EXHAUSTINGLY": "in the manner of using the whole strength of [adv]\n",
  "EXHAUSTION": "the act of exhausting [n -S]\n",
  "EXHAUSTIONS": "EXHAUSTION, the act of exhausting [n]\n",
  "EXHAUSTIVE": "testing all possibilities or considering all elements [adj EXHAUSTIVELY]\n",
  "EXHAUSTIVELY": "EXHAUSTIVE, testing all possibilities or considering all elements [adv]\n",
  "EXHAUSTIVENESS": "EXHAUSTIVE, testing all possibilities or considering all elements [n]\n",
  "EXHAUSTIVITIES": "EXHAUSTIVITY, the state of being exhaustive [n]\n",
  "EXHAUSTIVITY": "the state of being exhaustive [n EXHAUSTIVITIES]\n",
  "EXHAUSTLESS": "inexhaustible [adj EXHAUSTLESSLY]\n",
  "EXHAUSTLESSLY": "EXHAUSTLESS, inexhaustible [adv]\n",
  "EXHAUSTLESSNESS": "EXHAUSTLESS, inexhaustible [n]\n",
  "EXHAUSTS": "EXHAUST, to use the whole strength of [v]\n",
  "EXHEDRA": "(Latin) a semicircular bench beside an episcopal throne, also EXEDRA [n EXHEDRAE]\n",
  "EXHEDRAE": "EXHEDRA, (Latin) a semicircular bench beside an episcopal throne, also EXEDRA [n]\n",
  "EXHEREDATE": "to disinherit [v EXHEREDATED, EXHEREDATING, EXHEREDATES]\n",
  "EXHEREDATED": "EXHEREDATE, to disinherit [v]\n",
  "EXHEREDATES": "EXHEREDATE, to disinherit [v]\n",
  "EXHEREDATING": "EXHEREDATE, to disinherit [v]\n",
  "EXHEREDATION": "the act of exheredating, disinheriting [n -S]\n",
  "EXHEREDATIONS": "EXHEREDATION, the act of exheredating, disinheriting [n]\n",
  "EXHIBIT": "to display publicly [v -ED, -ING, -S]\n",
  "EXHIBITED": "EXHIBIT, to display publicly [v]\n",
  "EXHIBITER": "one who exhibits, also EXHIBITOR [n -S]\n",
  "EXHIBITERS": "EXHIBITER, one who exhibits, also EXHIBITOR [n]\n",
  "EXHIBITING": "EXHIBIT, to display publicly [v]\n",
  "EXHIBITION": "an act or instance of exhibiting [n -S]\n",
  "EXHIBITIONER": "a university student who has been awarded an exhibition at a university [n -S]\n",
  "EXHIBITIONERS": "EXHIBITIONER, a university student who has been awarded an exhibition at a university [n]\n",
  "EXHIBITIONISM": "extravagant behaviour aimed at drawing attention to oneself [n -S]\n",
  "EXHIBITIONISMS": "EXHIBITIONISM, extravagant behaviour aimed at drawing attention to oneself [n]\n",
  "EXHIBITIONIST": "one who engages in exhibitionism [n -S]\n",
  "EXHIBITIONISTIC": "characterised by exhibitionism [adj]\n",
  "EXHIBITIONISTS": "EXHIBITIONIST, one who engages in exhibitionism [n]\n",
  "EXHIBITIONS": "EXHIBITION, an act or instance of exhibiting [n]\n",
  "EXHIBITIVE": "serving for exhibition; representative [adj EXHIBITIVELY]\n",
  "EXHIBITIVELY": "EXHIBITIVE, serving for exhibition; representative [adv]\n",
  "EXHIBITOR": "one who exhibits, also EXHIBITER [n -S]\n",
  "EXHIBITORS": "EXHIBITOR, one who exhibits, also EXHIBITER [n]\n",
  "EXHIBITORY": "exhibiting; publicly showing [adj]\n",
  "EXHIBITS": "EXHIBIT, to display publicly [v]\n",
  "EXHILARANT": "exciting joy, mirth, or pleasure [adj] / an exhilarant medicine [n -S]\n",
  "EXHILARANTS": "EXHILARANT, an exhilarant medicine [n]\n",
  "EXHILARATE": "to make cheerful and excited [v EXHILARATED, EXHILARATING, EXHILARATES]\n",
  "EXHILARATED": "EXHILARATE, to make cheerful and excited [v]\n",
  "EXHILARATES": "EXHILARATE, to make cheerful and excited [v]\n",
  "EXHILARATING": "EXHILARATE, to make cheerful and excited [v]\n",
  "EXHILARATINGLY": "EXHILARATING, EXHILARATE, to make cheerful and excited [adv]\n",
  "EXHILARATION": "the action of exhilarating [n -S]\n",
  "EXHILARATIONS": "EXHILARATION, the action of exhilarating [n]\n",
  "EXHILARATIVE": "tending to exhilarate [adj]\n",
  "EXHILARATOR": "one who exhilarates [n -S]\n",
  "EXHILARATORS": "EXHILARATOR, one who exhilarates [n]\n",
  "EXHILARATORY": "serving to exhilarate [adj]\n",
  "EXHORT": "to admonish earnestly [v -ED, -ING, -S]\n",
  "EXHORTATION": "an act or instance of exhorting [n -S]\n",
  "EXHORTATIONS": "EXHORTATION, an act or instance of exhorting [n]\n",
  "EXHORTATIVE": "serving to exhort [adj]\n",
  "EXHORTATORY": "using exhortation [adj]\n",
  "EXHORTED": "EXHORT, to admonish earnestly [v]\n",
  "EXHORTER": "one who exhorts or incites [n -S]\n",
  "EXHORTERS": "EXHORTER, one who exhorts or incites [n]\n",
  "EXHORTING": "EXHORT, to admonish earnestly [v]\n",
  "EXHORTS": "EXHORT, to admonish earnestly [v]\n",
  "EXHUMATE": "to dig out from the earth, also EXHUME [v EXHUMATED, EXHUMATING, EXHUMATES]\n",
  "EXHUMATED": "EXHUMATE, to dig out from the earth, also EXHUME [v]\n",
  "EXHUMATES": "EXHUMATE, to dig out from the earth, also EXHUME [v]\n",
  "EXHUMATING": "EXHUMATE, to dig out from the earth, also EXHUME [v]\n",
  "EXHUMATION": "the act of exhuming [n -S]\n",
  "EXHUMATIONS": "EXHUMATION, the act of exhuming [n]\n",
  "EXHUME": "to dig out from the earth, also EXHUMATE [v EXHUMED, EXHUMING, EXHUMES]\n",
  "EXHUMED": "EXHUME, to dig out from the earth, also EXHUMATE [v]\n",
  "EXHUMER": "someone who exhumes [n -S]\n",
  "EXHUMERS": "EXHUMER, someone who exhumes [n]\n",
  "EXHUMES": "EXHUME, to dig out from the earth, also EXHUMATE [v]\n",
  "EXHUMING": "EXHUME, to dig out from the earth, also EXHUMATE [v]\n",
  "EXIES": "(Scots) a fit, e.g. of hysterics or the ague [n]\n",
  "EXIGEANT": "(French) exacting [adj]\n",
  "EXIGEANTE": "(French) (of a female) exacting [adj]\n",
  "EXIGENCE": "urgency, also EXIGENCY [n -S]\n",
  "EXIGENCES": "EXIGENCE, urgency, also EXIGENCY [n]\n",
  "EXIGENCIES": "EXIGENCY, urgency, also EXIGENCE [n]\n",
  "EXIGENCY": "urgency, also EXIGENCE [n EXIGENCIES]\n",
  "EXIGENT": "exacting; urgent [adj EXIGENTLY] / extremity, the last need [n -S]\n",
  "EXIGENTLY": "EXIGENT, exacting; urgent [adv]\n",
  "EXIGENTS": "EXIGENT, extremity, the last need [n]\n",
  "EXIGIBLE": "liable to be demanded [adj]\n",
  "EXIGUITIES": "EXIGUITY, meagreness [n]\n",
  "EXIGUITY": "meagreness [n EXIGUITIES]\n",
  "EXIGUOUS": "scanty in amount, meager [adj EXIGUOUSLY]\n",
  "EXIGUOUSLY": "EXIGUOUS, scanty in amount, meager [adv]\n",
  "EXIGUOUSNESS": "the state of being exiguous [n -ES]\n",
  "EXIGUOUSNESSES": "EXIGUOUSNESS, the state of being exiguous [n]\n",
  "EXILABLE": "able to be exiled [adj]\n",
  "EXILE": "to banish from one's own country [v EXILED, EXILING, EXILES]\n",
  "EXILED": "EXILE, to banish from one's own country [v]\n",
  "EXILEMENT": "banishment [n -S]\n",
  "EXILEMENTS": "EXILEMENT, banishment [n]\n",
  "EXILER": "one who exiles [n -S]\n",
  "EXILERS": "EXILER, one who exiles [n]\n",
  "EXILES": "EXILE, to banish from one's own country [v]\n",
  "EXILIAN": "pertaining to exile or banishment, esp. to that of the Jews in Babylon, also EXILIC [adj]\n",
  "EXILIC": "pertaining to exile or banishment, esp. to that of the Jews in Babylon, also EXILIAN [adj]\n",
  "EXILING": "EXILE, to banish from one's own country [v]\n",
  "EXILITIES": "EXILITY, (obsolete) slenderness, refinement [n]\n",
  "EXILITY": "(obsolete) slenderness, refinement [n EXILITIES]\n",
  "EXIMIOUS": "(archaic) choice, excellent [adj EXIMIOUSLY]\n",
  "EXIMIOUSLY": "EXIMIOUS, (archaic) choice, excellent [adv]\n",
  "EXINE": "the outer layer of some spores, also EXTINE [n -S]\n",
  "EXINES": "EXINE, the outer layer of some spores, also EXTINE [n]\n",
  "EXING": "EX, to cross out [v]\n",
  "EXIST": "to have actual being, to live [v -ED, -ING, -S]\n",
  "EXISTED": "EXIST, to have actual being, to live [v]\n",
  "EXISTENCE": "the fact of existing [n -S]\n",
  "EXISTENCES": "EXISTENCE, the fact of existing [n]\n",
  "EXISTENT": "something that exists [n -S]\n",
  "EXISTENTIAL": "of, relating to, or affirming existence [adj EXISTENTIALLY] / an existential statement or formula [n -S]\n",
  "EXISTENTIALISM": "the doctrine of individual human responsibility in an unfathomable universe [n -S]\n",
  "EXISTENTIALISMS": "EXISTENTIALISM, the doctrine of individual human responsibility in an unfathomable universe [n]\n",
  "EXISTENTIALIST": "an adherent of existentialism, the doctrine of individual human responsibility in an unfathomable universe [n -S]\n",
  "EXISTENTIALISTS": "EXISTENTIALIST, an adherent of existentialism, the doctrine of individual human responsibility in an unfathomable universe [n]\n",
  "EXISTENTIALLY": "EXISTENTIAL, of, relating to, or affirming existence [adv]\n",
  "EXISTENTIALS": "EXISTENTIAL, an existential statement or formula [n]\n",
  "EXISTENTS": "EXISTENT, something that exists [n]\n",
  "EXISTING": "EXIST, to have actual being, to live [v]\n",
  "EXISTS": "EXIST, to have actual being, to live [v]\n",
  "EXIT": "to go out [v -ED, -ING, -S]\n",
  "EXITANCE": "a measure of radiation from a surface [n -S]\n",
  "EXITANCES": "EXITANCE, a measure of radiation from a surface [n]\n",
  "EXITED": "EXIT, to go out [v]\n",
  "EXITING": "EXIT, to go out [v]\n",
  "EXITLESS": "without a way out [adj]\n",
  "EXITS": "EXIT, to go out [v]\n",
  "EXO": "(Australian slang) excellent [adj]\n",
  "EXOBIOLOGICAL": "relating to exobiology [adj]\n",
  "EXOBIOLOGIES": "EXOBIOLOGY, the study of extraterrestrial life [n]\n",
  "EXOBIOLOGIST": "a student of exobiology [n -S]\n",
  "EXOBIOLOGISTS": "EXOBIOLOGIST, a student of exobiology [n]\n",
  "EXOBIOLOGY": "the study of extraterrestrial life [n EXOBIOLOGIES]\n",
  "EXOCARP": "the outer portion of a fruit, as the flesh of a peach or the rind of an orange [n -S]\n",
  "EXOCARPS": "EXOCARP, the outer portion of a fruit, as the flesh of a peach or the rind of an orange [n]\n",
  "EXOCENTRIC": "of a construction, not fulfilling the grammatical role of any of its constituents [adj]\n",
  "EXOCRINE": "a gland that secretes through a duct [n -S]\n",
  "EXOCRINES": "EXOCRINE, a gland that secretes through a duct [n]\n",
  "EXOCUTICLE": "the middle layer of an insect's cuticle [n -S]\n",
  "EXOCUTICLES": "EXOCUTICLE, the middle layer of an insect's cuticle [n]\n",
  "EXOCYCLIC": "situated outside of a ring in a chemical structure [adj]\n",
  "EXOCYTIC": "outside biological cells [adj]\n",
  "EXOCYTOSE": "to secrete a substance from within a cell [v EXOCYTOSED, EXOCYTOSING, EXOCYTOSES]\n",
  "EXOCYTOSED": "EXOCYTOSE, to secrete a substance from within a cell [v]\n",
  "EXOCYTOSES": "EXOCYTOSE, to secrete a substance from within a cell [v]\n",
  "EXOCYTOSING": "EXOCYTOSE, to secrete a substance from within a cell [v]\n",
  "EXOCYTOSIS": "the release of cellular substances contained in cell vesicles [n EXOCYTOSES]\n",
  "EXOCYTOTIC": "relating to exocytosis, the release of cellular substances contained in cell vesicles [adj]\n",
  "EXODE": "(Greek) the concluding part of a Greek drama, a farce or afterpiece [n -S]\n",
  "EXODERM": "the external layer of an embryo, also ECTODERM, EPIBLAST [n -S]\n",
  "EXODERMAL": "relating to the exodermis, the outer cortex layer of a root [adj]\n",
  "EXODERMIS": "the outer cortex layer of a root [n EXODERMISES]\n",
  "EXODERMISES": "EXODERMIS, the outer cortex layer of a root [n]\n",
  "EXODERMS": "EXODERM, the external layer of an embryo, also ECTODERM, EPIBLAST [n]\n",
  "EXODES": "EXODE, (Greek) the concluding part of a Greek drama, a farce or afterpiece [n]\n",
  "EXODIC": "relating to exodus [adj]\n",
  "EXODIST": "a person who goes out; an emigrant [n -S]\n",
  "EXODISTS": "EXODIST, a person who goes out; an emigrant [n]\n",
  "EXODOI": "EXODOS, (Greek) a concluding dramatic scene [n]\n",
  "EXODONTIA": "the branch of dentistry involving the extraction of teeth [n -S]\n",
  "EXODONTIAS": "EXODONTIA, the branch of dentistry involving the extraction of teeth [n]\n",
  "EXODONTICS": "the branch of dental surgery concerned with the extraction of teeth [n]\n",
  "EXODONTIST": "a specialist in exodontia, the branch of dentistry involving the extraction of teeth [n -S]\n",
  "EXODONTISTS": "EXODONTIST, a specialist in exodontia, the branch of dentistry involving the extraction of teeth [n]\n",
  "EXODOS": "(Greek) a concluding dramatic scene [n EXODOI]\n",
  "EXODUS": "(Latin) a departure [n -ES]\n",
  "EXODUSES": "EXODUS, (Latin) a departure [n]\n",
  "EXOENZYME": "an enzyme that functions outside the cell producing it [n -S]\n",
  "EXOENZYMES": "EXOENZYME, an enzyme that functions outside the cell producing it [n]\n",
  "EXOERGIC": "releasing energy [adj]\n",
  "EXOERYTHROCYTIC": "occurring outside the red blood cells [adj]\n",
  "EXOGAMIC": "relating to exogamy, also EXOGAMOUS [adj]\n",
  "EXOGAMIES": "EXOGAMY, marriage outside a particular group [n]\n",
  "EXOGAMOUS": "relating to exogamy, also EXOGAMIC [adj]\n",
  "EXOGAMY": "marriage outside a particular group [n EXOGAMIES]\n",
  "EXOGEN": "a plant which grows by thickening its outer layer [n -S]\n",
  "EXOGENETIC": "not genetic, not caused by genetic factors [adj]\n",
  "EXOGENIC": "formed or occurring on the surface of the earth [adj]\n",
  "EXOGENISM": "the state of being exogenous, developing from superficial rather than deep tissue [n -S]\n",
  "EXOGENISMS": "EXOGENISM, the state of being exogenous, developing from superficial rather than deep tissue [n]\n",
  "EXOGENOUS": "originating from outside [adj EXOGENOUSLY]\n",
  "EXOGENOUSLY": "EXOGENOUS, originating from outside [adv]\n",
  "EXOGENS": "EXOGEN, a plant which grows by thickening its outer layer [n]\n",
  "EXOME": "a part of the genome consisting of exons [n -S]\n",
  "EXOMES": "EXOME, a part of the genome consisting of exons [n]\n",
  "EXOMION": "a Roman sleeveless garment, also EXOMIS [n -S]\n",
  "EXOMIONS": "EXOMION, a Roman sleeveless garment, also EXOMIS [n]\n",
  "EXOMIS": "(Greek) a Roman sleeveless garment, also EXOMION [n -ES]\n",
  "EXOMISES": "EXOMIS, (Greek) a Roman sleeveless garment, also EXOMION [n]\n",
  "EXON": "within a nucleic acid, a sequence which codes for protein synthesis [n -S]\n",
  "EXONERATE": "to clear of blame [v EXONERATED, EXONERATING, EXONERATES]\n",
  "EXONERATED": "EXONERATE, to clear of blame [v]\n",
  "EXONERATES": "EXONERATE, to clear of blame [v]\n",
  "EXONERATING": "EXONERATE, to clear of blame [v]\n",
  "EXONERATION": "the act of exonerating [n -S]\n",
  "EXONERATIONS": "EXONERATION, the act of exonerating [n]\n",
  "EXONERATIVE": "serving to exonerate [adj]\n",
  "EXONERATOR": "one who exonerates or frees from obligation [n -S]\n",
  "EXONERATORS": "EXONERATOR, one who exonerates or frees from obligation [n]\n",
  "EXONEREE": "a person who is proven not guilty of a crime [n -S]\n",
  "EXONEREES": "EXONEREE, a person who is proven not guilty of a crime [n]\n",
  "EXONIC": "relating to an exon, any segment of a gene which consists of codons [adj]\n",
  "EXONS": "EXON, within a nucleic acid, a sequence which codes for protein synthesis [n]\n",
  "EXONUCLEASE": "an enzyme that breaks down a nucleic acid by removing nucleotides one by one from the end of a chain [n -S]\n",
  "EXONUCLEASES": "EXONUCLEASE, an enzyme that breaks down a nucleic acid by removing nucleotides one by one from the end of a chain [n]\n",
  "EXONUMIA": "objects that resemble money but do not circulate as coin or paper money e.g. tokens, coupons, medal [n]\n",
  "EXONUMIST": "a collector of medals and tokens [n -S]\n",
  "EXONUMISTS": "EXONUMIST, a collector of medals and tokens [n]\n",
  "EXONYM": "a name for a town in a foreign language [n -S]\n",
  "EXONYMS": "EXONYM, a name for a town in a foreign language [n]\n",
  "EXOPARASITE": "a parasite, such as the flea, that lives on the outer surface of its host [n -S]\n",
  "EXOPARASITES": "EXOPARASITE, a parasite, such as the flea, that lives on the outer surface of its host [n]\n",
  "EXOPARASITIC": "of or like an exoparasite [adj]\n",
  "EXOPEPTIDASE": "any of a group of enzymes that hydrolyze peptide bonds [n -S]\n",
  "EXOPEPTIDASES": "EXOPEPTIDASE, any of a group of enzymes that hydrolyze peptide bonds [n]\n",
  "EXOPHAGIES": "EXOPHAGY, a cannibal custom of eating other than one's kin [n]\n",
  "EXOPHAGOUS": "relating to exophagy, cannibalism outside one's own group [adj]\n",
  "EXOPHAGY": "a cannibal custom of eating other than one's kin [n EXOPHAGIES]\n",
  "EXOPHORIC": "denoting or relating to a pronoun such as I or you [adj]\n",
  "EXOPHTHALMIA": "a protrusion of the eyeballs [n -S]\n",
  "EXOPHTHALMIAS": "EXOPHTHALMIA, a protrusion of the eyeballs [n]\n",
  "EXOPHTHALMIC": "pertaining to or marked by protrusion of eyeball [adj]\n",
  "EXOPHTHALMOS": "abnormal protrusion of the eyeball, also EXOPHTHALMUS [n EXOPHTHALMOSES]\n",
  "EXOPHTHALMOSES": "EXOPHTHALMOS, abnormal protrusion of the eyeball, also EXOPHTHALMUS [n]\n",
  "EXOPHTHALMUS": "abnormal protrusion of the eyeball, also EXOPHTHALMOS [n EXOPHTHALMUSES]\n",
  "EXOPHTHALMUSES": "EXOPHTHALMUS, abnormal protrusion of the eyeball, also EXOPHTHALMOS [n]\n",
  "EXOPLANET": "a planet that orbits a star in another solar system [n -S]\n",
  "EXOPLANETS": "EXOPLANET, a planet that orbits a star in another solar system [n]\n",
  "EXOPLASM": "the outer transparent layer of protoplasm in a developing ovum, also ECTOPLASM [n -S]\n",
  "EXOPLASMS": "EXOPLASM, the outer transparent layer of protoplasm in a developing ovum, also ECTOPLASM [n]\n",
  "EXOPOD": "the outer branch of a crustacean limb, also EXOPODITE [n -S]\n",
  "EXOPODITE": "the outer branch of a crustacean limb, also EXOPOD [n -S]\n",
  "EXOPODITES": "EXOPODITE, the outer branch of a crustacean limb, also EXOPOD [n]\n",
  "EXOPODITIC": "of or like an exopodite, the outer branch of a crustacean limb [adj]\n",
  "EXOPODS": "EXOPOD, the outer branch of a crustacean limb, also EXOPODITE [n]\n",
  "EXORABILITIES": "EXORABILITY, the state of being exorable [n]\n",
  "EXORABILITY": "the state of being exorable [n EXORABILITIES]\n",
  "EXORABLE": "persuadable [adj]\n",
  "EXORATION": "(obsolete) entreaty [n -S]\n",
  "EXORATIONS": "EXORATION, (obsolete) entreaty [n]\n",
  "EXORBITANCE": "an exorbitant action or procedure, also EXORBITANCY [n -S]\n",
  "EXORBITANCES": "EXORBITANCE, an exorbitant action or procedure, also EXORBITANCY [n]\n",
  "EXORBITANCIES": "EXORBITANCY, the state of being exorbitant, also EXORBITANCE [n]\n",
  "EXORBITANCY": "the state of being exorbitant, also EXORBITANCE [n EXORBITANCIES]\n",
  "EXORBITANT": "going beyond the usual limits; (esp. of prices) excessive [adj EXORBITANTLY]\n",
  "EXORBITANTLY": "EXORBITANT, going beyond the usual limits; (esp. of prices) excessive [adv]\n",
  "EXORBITATE": "(obsolete) to stray [v EXORBITATED, EXORBITATING, EXORBITATES]\n",
  "EXORBITATED": "EXORBITATE, (obsolete) to stray [v]\n",
  "EXORBITATES": "EXORBITATE, (obsolete) to stray [v]\n",
  "EXORBITATING": "EXORBITATE, (obsolete) to stray [v]\n",
  "EXORCISE": "to free of an evil spirit, also EXORCIZE [v EXORCISED, EXORCISING, EXORCISES]\n",
  "EXORCISED": "EXORCISE, to free of an evil spirit, also EXORCIZE [v]\n",
  "EXORCISER": "one who exorcises, also EXORCIZER [n -S]\n",
  "EXORCISERS": "EXORCISER, one who exorcises, also EXORCIZER [n]\n",
  "EXORCISES": "EXORCISE, to free of an evil spirit, also EXORCIZE [v]\n",
  "EXORCISING": "EXORCISE, to free of an evil spirit, also EXORCIZE [v]\n",
  "EXORCISM": "the act of exorcising [n -S]\n",
  "EXORCISMS": "EXORCISM, the act of exorcising [n]\n",
  "EXORCIST": "one who practices exorcism [n -S]\n",
  "EXORCISTIC": "relating to exorcism, also EXORCISTICAL [adj]\n",
  "EXORCISTICAL": "relating to exorcism, also EXORCISTIC [adj]\n",
  "EXORCISTS": "EXORCIST, one who practices exorcism [n]\n",
  "EXORCIZE": "to free of an evil spirit, also EXORCISE [v EXORCIZED, EXORCIZING, EXORCIZES]\n",
  "EXORCIZED": "EXORCIZE, to free of an evil spirit, also EXORCISE [v]\n",
  "EXORCIZER": "one who exorcizes, also EXORCISER [n -S]\n",
  "EXORCIZERS": "EXORCIZER, one who exorcizes, also EXORCISER [n]\n",
  "EXORCIZES": "EXORCIZE, to free of an evil spirit, also EXORCISE [v]\n",
  "EXORCIZING": "EXORCIZE, to free of an evil spirit, also EXORCISE [v]\n",
  "EXORDIA": "EXORDIUM, (Latin) a beginning [n]\n",
  "EXORDIAL": "pertaining to the exordium of a discourse, introductory [adj]\n",
  "EXORDIUM": "(Latin) a beginning [n EXORDIUMS or EXORDIA]\n",
  "EXORDIUMS": "EXORDIUM, (Latin) a beginning [n]\n",
  "EXOSKELETAL": "relating to an exoskeleton [adj]\n",
  "EXOSKELETON": "an external skeleton [n -S]\n",
  "EXOSKELETONS": "EXOSKELETON, an external skeleton [n]\n",
  "EXOSMIC": "relating to exosmose, a form of osmosis [adj]\n",
  "EXOSMOSE": "osmosis outwards, i.e. away from the solution, also EXOSMOSIS [n -S]\n",
  "EXOSMOSES": "EXOSMOSE, osmosis outwards, i.e. away from the solution, also EXOSMOSIS [n]\n",
  "EXOSMOSIS": "osmosis outwards, i.e. away from the solution, also EXOSMOSE [n EXOSMOSES]\n",
  "EXOSMOTIC": "pertaining to exosmose, osmosis outwards [adj]\n",
  "EXOSPHERE": "the outermost layer of the earth's atmosphere [n -S]\n",
  "EXOSPHERES": "EXOSPHERE, the outermost layer of the earth's atmosphere [n]\n",
  "EXOSPHERIC": "related to the exosphere, the outermost layer of the earth's atmosphere, also EXOSPHERICAL [adj]\n",
  "EXOSPHERICAL": "related to the exosphere, the outermost layer of the earth's atmosphere, also EXOSPHERIC [adj]\n",
  "EXOSPORAL": "of or like an exospore, the extreme outer layer of a spore [adj]\n",
  "EXOSPORE": "the outer covering of a spore [n -S]\n",
  "EXOSPORES": "EXOSPORE, the outer covering of a spore [n]\n",
  "EXOSPORIA": "EXOSPORIUM, the outermost layer of spores of certain bacilli [n]\n",
  "EXOSPORIUM": "the outermost layer of spores of certain bacilli [n EXOSPORIA]\n",
  "EXOSPOROUS": "of or like an exospore, the extreme outer wall of a spore; the epispore [adj]\n",
  "EXOSTOSES": "EXOSTOSIS, any protuberance of a bone which is not natural [n]\n",
  "EXOSTOSIS": "any protuberance of a bone which is not natural [n EXOSTOSES]\n",
  "EXOTERIC": "intelligible to the uninitiated; commonplace [adj EXOTERICALLY]\n",
  "EXOTERICAL": "intelligible to the uninitiated [adj EXOTERICALLY]\n",
  "EXOTERICALLY": "EXOTERICAL, intelligible to the uninitiated [adv]\n",
  "EXOTERICISM": "the state of being exoteric [n -S]\n",
  "EXOTERICISMS": "EXOTERICISM, the state of being exoteric [n]\n",
  "EXOTHERMAL": "of a chemical reaction, giving out heat, also EXOTHERMIC [adj EXOTHERMALLY]\n",
  "EXOTHERMALLY": "EXOTHERMAL, of a chemical reaction, giving out heat, also EXOTHERMIC [adv]\n",
  "EXOTHERMIC": "of a chemical reaction, giving out heat, also EXOTHERMAL [adj EXOTHERMICALLY]\n",
  "EXOTHERMICALLY": "EXOTHERMIC, of a chemical reaction, giving out heat, also EXOTHERMAL [adv]\n",
  "EXOTHERMICITIES": "EXOTHERMICITY, the state of being exothermic [n]\n",
  "EXOTHERMICITY": "the state of being exothermic [n EXOTHERMICITIES]\n",
  "EXOTIC": "from another part of the world [adj EXOTICALLY] / something from another part of the world [n -S]\n",
  "EXOTICA": "things excitingly different or unusual [n]\n",
  "EXOTICALLY": "EXOTIC, from another part of the world [adv]\n",
  "EXOTICISE": "to regard or present as exotic, also EXOTICIZE [v EXOTICISED, EXOTICISING, EXOTICISES]\n",
  "EXOTICISED": "EXOTICISE, to regard or present as exotic, also EXOTICIZE [v]\n",
  "EXOTICISES": "EXOTICISE, to regard or present as exotic, also EXOTICIZE [v]\n",
  "EXOTICISING": "EXOTICISE, to regard or present as exotic, also EXOTICIZE [v]\n",
  "EXOTICISM": "the state of being exotic; also, anything foreign, as a word or idiom [n -S]\n",
  "EXOTICISMS": "EXOTICISM, the state of being exotic; also, anything foreign, as a word or idiom [n]\n",
  "EXOTICIST": "an enthusiast for the exotic [n -S]\n",
  "EXOTICISTS": "EXOTICIST, an enthusiast for the exotic [n]\n",
  "EXOTICIZE": "to regard or present as exotic, also EXOTICISE [v EXOTICIZED, EXOTICIZING, EXOTICIZES]\n",
  "EXOTICIZED": "EXOTICIZE, to regard or present as exotic, also EXOTICISE [v]\n",
  "EXOTICIZES": "EXOTICIZE, to regard or present as exotic, also EXOTICISE [v]\n",
  "EXOTICIZING": "EXOTICIZE, to regard or present as exotic, also EXOTICISE [v]\n",
  "EXOTICNESS": "the state of being exotic [n -ES]\n",
  "EXOTICNESSES": "EXOTICNESS, the state of being exotic [n]\n",
  "EXOTICS": "EXOTIC, something from another part of the world [n]\n",
  "EXOTISM": "something exotic [n -S]\n",
  "EXOTISMS": "EXOTISM, something exotic [n]\n",
  "EXOTOXIC": "relating to an exotoxin, an excreted toxin [adj]\n",
  "EXOTOXIN": "a secreted toxin [n -S]\n",
  "EXOTOXINS": "EXOTOXIN, a secreted toxin [n]\n",
  "EXOTROPIA": "a condition in which the eyes turn outwards [n -S]\n",
  "EXOTROPIAS": "EXOTROPIA, a condition in which the eyes turn outwards [n]\n",
  "EXOTROPIC": "relating to exotropia, a condition in which the eyes turn outwards [adj]\n",
  "EXPAND": "to increase in size or volume [v -ED, -ING, -S]\n",
  "EXPANDABILITIES": "EXPANDABILITY, the state of being expandable [n]\n",
  "EXPANDABILITY": "the state of being expandable [n EXPANDABILITIES]\n",
  "EXPANDABLE": "that can be expanded [adj]\n",
  "EXPANDED": "EXPAND, to increase in size or volume [v]\n",
  "EXPANDER": "a type of transducer, an electronic device transmitting received energy in a different form, also EXPANDOR [n -S]\n",
  "EXPANDERS": "EXPANDER, a type of transducer, an electronic device transmitting received energy in a different form, also EXPANDOR [n]\n",
  "EXPANDING": "EXPAND, to increase in size or volume [v]\n",
  "EXPANDOR": "a type of transducer, an electronic device transmitting received energy in a different form, also EXPANDER [n -S]\n",
  "EXPANDORS": "EXPANDOR, a type of transducer, an electronic device transmitting received energy in a different form, also EXPANDER [n]\n",
  "EXPANDS": "EXPAND, to increase in size or volume [v]\n",
  "EXPANSE": "a wide area or extent [n -S]\n",
  "EXPANSES": "EXPANSE, a wide area or extent [n]\n",
  "EXPANSIBILITIES": "EXPANSIBILITY, the state of being expansible [n]\n",
  "EXPANSIBILITY": "the state of being expansible [n EXPANSIBILITIES]\n",
  "EXPANSIBLE": "capable of being expanded [adj EXPANSIBLY]\n",
  "EXPANSIBLY": "EXPANSIBLE, capable of being expanded [adv]\n",
  "EXPANSILE": "expansible [adj]\n",
  "EXPANSION": "the act of expanding [n -S]\n",
  "EXPANSIONAL": "relating to an expansion [adj]\n",
  "EXPANSIONARY": "tending toward expansion [adj]\n",
  "EXPANSIONISM": "a policy or practice of expansion and esp. of territorial expansion by a nation [n -S]\n",
  "EXPANSIONISMS": "EXPANSIONISM, a policy or practice of expansion and esp. of territorial expansion by a nation [n]\n",
  "EXPANSIONIST": "an advocate of expansionism [n -S]\n",
  "EXPANSIONISTIC": "relating to expansionism [adj]\n",
  "EXPANSIONISTS": "EXPANSIONIST, an advocate of expansionism [n]\n",
  "EXPANSIONS": "EXPANSION, the act of expanding [n]\n",
  "EXPANSIVE": "widely extended [adj EXPANSIVELY]\n",
  "EXPANSIVELY": "EXPANSIVE, widely extended [adv]\n",
  "EXPANSIVENESS": "EXPANSIVE, widely extended [n]\n",
  "EXPANSIVENESSES": "EXPANSIVENESS, EXPANSIVE, widely extended [n]\n",
  "EXPANSIVITIES": "EXPANSIVITY, the state of being expansive [n]\n",
  "EXPANSIVITY": "the state of being expansive [n EXPANSIVITIES]\n",
  "EXPAT": "someone who lives abroad, an expatriate [n -S]\n",
  "EXPATIATE": "to speak or write about in great detail [v EXPATIATED, EXPATIATING, EXPATIATES]\n",
  "EXPATIATED": "EXPATIATE, to speak or write about in great detail [v]\n",
  "EXPATIATES": "EXPATIATE, to speak or write about in great detail [v]\n",
  "EXPATIATING": "EXPATIATE, to speak or write about in great detail [v]\n",
  "EXPATIATION": "the act of expatiating [n -S]\n",
  "EXPATIATIONS": "EXPATIATION, the act of expatiating [n]\n",
  "EXPATIATIVE": "expansive, also EXPATIATORY [adj]\n",
  "EXPATIATOR": "one who expatiates [n -S]\n",
  "EXPATIATORS": "EXPATIATOR, one who expatiates [n]\n",
  "EXPATIATORY": "expansive, also EXPATIATIVE [adj]\n",
  "EXPATRIATE": "to banish, exile [v EXPATRIATED, EXPATRIATING, EXPATRIATES]\n",
  "EXPATRIATED": "EXPATRIATE, to banish, exile [v]\n",
  "EXPATRIATES": "EXPATRIATE, to banish, exile [v]\n",
  "EXPATRIATING": "EXPATRIATE, to banish, exile [v]\n",
  "EXPATRIATION": "the act of expatriating [n -S]\n",
  "EXPATRIATIONS": "EXPATRIATION, the act of expatriating [n]\n",
  "EXPATRIATISM": "the state of being an expatriate [n -S]\n",
  "EXPATRIATISMS": "EXPATRIATISM, the state of being an expatriate [n]\n",
  "EXPATS": "EXPAT, someone who lives abroad, an expatriate [n]\n",
  "EXPECT": "to anticipate [v -ED, -ING, -S]\n",
  "EXPECTABLE": "that may be expected [adj EXPECTABLY]\n",
  "EXPECTABLY": "EXPECTABLE, that may be expected [adv]\n",
  "EXPECTANCE": "the state of expecting, also EXPECTANCY [n -S]\n",
  "EXPECTANCES": "EXPECTANCE, the state of expecting, also EXPECTANCY [n]\n",
  "EXPECTANCIES": "EXPECTANCY, the state of expecting, also EXPECTANCE [n]\n",
  "EXPECTANCY": "the state of expecting, also EXPECTANCE [n EXPECTANCIES]\n",
  "EXPECTANT": "in a state of expectancy [adj EXPECTANTLY] / a person who is expectant [n -S]\n",
  "EXPECTANTLY": "EXPECTANT, in a state of expectancy [adv]\n",
  "EXPECTANTS": "EXPECTANT, a person who is expectant [n]\n",
  "EXPECTATION": "the act or state of expecting [n -S]\n",
  "EXPECTATIONAL": "relating to expectation [adj]\n",
  "EXPECTATIONS": "EXPECTATION, the act or state of expecting [n]\n",
  "EXPECTATIVE": "giving rise to expectation [adj] / an anticipatory grant of a benefice not yet vacant [n -S]\n",
  "EXPECTATIVES": "EXPECTATIVE, an anticipatory grant of a benefice not yet vacant [n]\n",
  "EXPECTED": "EXPECT, to anticipate [v]\n",
  "EXPECTEDLY": "EXPECTED, EXPECT, to anticipate [adv]\n",
  "EXPECTEDNESS": "the state of being expected [n -ES]\n",
  "EXPECTEDNESSES": "EXPECTEDNESS, the state of being expected [n]\n",
  "EXPECTER": "someone who expects [n -S]\n",
  "EXPECTERS": "EXPECTER, someone who expects [n]\n",
  "EXPECTING": "in a state of expectation [adj EXPECTINGLY] / the act of expecting [n -S]\n",
  "EXPECTINGLY": "EXPECTING, in a state of expectation [adv]\n",
  "EXPECTINGS": "EXPECTING, the act of expecting [n]\n",
  "EXPECTORANT": "an agent that promotes the discharge or expulsion of mucus from the respiratory tract [n -S]\n",
  "EXPECTORANTS": "EXPECTORANT, an agent that promotes the discharge or expulsion of mucus from the respiratory tract [n]\n",
  "EXPECTORATE": "to eject from the throat or lungs by coughing or hawking and spitting [v EXPECTORATED, EXPECTORATING, EXPECTORATES]\n",
  "EXPECTORATED": "EXPECTORATE, to eject from the throat or lungs by coughing or hawking and spitting [v]\n",
  "EXPECTORATES": "EXPECTORATE, to eject from the throat or lungs by coughing or hawking and spitting [v]\n",
  "EXPECTORATING": "EXPECTORATE, to eject from the throat or lungs by coughing or hawking and spitting [v]\n",
  "EXPECTORATION": "the act of expectorating [n -S]\n",
  "EXPECTORATIONS": "EXPECTORATION, the act of expectorating [n]\n",
  "EXPECTORATIVE": "an expectorant medicine [n -S]\n",
  "EXPECTORATIVES": "EXPECTORATIVE, an expectorant medicine [n]\n",
  "EXPECTORATOR": "one who expectorates [n -S]\n",
  "EXPECTORATORS": "EXPECTORATOR, one who expectorates [n]\n",
  "EXPECTS": "EXPECT, to anticipate [v]\n",
  "EXPEDIENCE": "the state of being expedient, also EXPEDIENCY [n -S]\n",
  "EXPEDIENCES": "EXPEDIENCE, the state of being expedient, also EXPEDIENCY [n]\n",
  "EXPEDIENCIES": "EXPEDIENCY, the state of being expedient, also EXPEDIENCE [n]\n",
  "EXPEDIENCY": "the state of being expedient, also EXPEDIENCE [n EXPEDIENCIES]\n",
  "EXPEDIENT": "suitable or appropriate [adj EXPEDIENTLY] / a means [n -S]\n",
  "EXPEDIENTIAL": "relating to expediency [adj EXPEDIENTIALLY]\n",
  "EXPEDIENTIALLY": "EXPEDIENTIAL, relating to expediency [adv]\n",
  "EXPEDIENTLY": "EXPEDIENT, suitable or appropriate [adv]\n",
  "EXPEDIENTS": "EXPEDIENT, a means [n]\n",
  "EXPEDITATE": "to deprive of the ball of the foot or the claws [v EXPEDITATED, EXPEDITATING, EXPEDITATES]\n",
  "EXPEDITATED": "EXPEDITATE, to deprive of the ball of the foot or the claws [v]\n",
  "EXPEDITATES": "EXPEDITATE, to deprive of the ball of the foot or the claws [v]\n",
  "EXPEDITATING": "EXPEDITATE, to deprive of the ball of the foot or the claws [v]\n",
  "EXPEDITATION": "the act of expediting [n -S]\n",
  "EXPEDITATIONS": "EXPEDITATION, the act of expediting [n]\n",
  "EXPEDITE": "expeditious [adj EXPEDITELY] / to speed up the progress of [v EXPEDITED, EXPEDITING, EXPEDITES]\n",
  "EXPEDITED": "EXPEDITE, to speed up the progress of [v]\n",
  "EXPEDITELY": "EXPEDITE, expeditious [adv]\n",
  "EXPEDITER": "one who expedites, also EXPEDITOR [n -S]\n",
  "EXPEDITERS": "EXPEDITER, one who expedites, also EXPEDITOR [n]\n",
  "EXPEDITES": "EXPEDITE, to speed up the progress of [v]\n",
  "EXPEDITING": "EXPEDITE, to speed up the progress of [v]\n",
  "EXPEDITION": "a journey or excursion undertaken for a specific purpose [n -S]\n",
  "EXPEDITIONARY": "of, relating to, or being an expedition [adj]\n",
  "EXPEDITIONS": "EXPEDITION, a journey or excursion undertaken for a specific purpose [n]\n",
  "EXPEDITIOUS": "characterized by or acting promptly and efficiently [adj EXPEDITIOUSLY]\n",
  "EXPEDITIOUSLY": "EXPEDITIOUS, characterized by or acting promptly and efficiently [adv]\n",
  "EXPEDITIOUSNESS": "EXPEDITIOUS, characterized by or acting promptly and efficiently [n]\n",
  "EXPEDITIVE": "performing with speed [adj]\n",
  "EXPEDITOR": "one who expedites, also EXPEDITER [n -S]\n",
  "EXPEDITORS": "EXPEDITOR, one who expedites, also EXPEDITER [n]\n",
  "EXPEL": "to force out [v EXPELLED, EXPELLING, EXPELS]\n",
  "EXPELLABLE": "that can be expelled [adj]\n",
  "EXPELLANT": "tending to expel [adj] / something that expels, also EXPELLENT [n -S]\n",
  "EXPELLANTS": "EXPELLANT, something that expels, also EXPELLENT [n]\n",
  "EXPELLED": "EXPEL, to force out [v]\n",
  "EXPELLEE": "someone who has been expelled [n -S]\n",
  "EXPELLEES": "EXPELLEE, someone who has been expelled [n]\n",
  "EXPELLENT": "tending to expel [adj] / something that expels, also EXPELLANT [n -S]\n",
  "EXPELLENTS": "EXPELLENT, something that expels, also EXPELLANT [n]\n",
  "EXPELLER": "one who expels [n -S]\n",
  "EXPELLERS": "EXPELLER, one who expels [n]\n",
  "EXPELLING": "EXPEL, to force out [v]\n",
  "EXPELS": "EXPEL, to force out [v]\n",
  "EXPEND": "to consume in any way [v -ED, -ING, -S]\n",
  "EXPENDABILITIES": "EXPENDABILITY, the state of being expendable [n]\n",
  "EXPENDABILITY": "the state of being expendable [n EXPENDABILITIES]\n",
  "EXPENDABLE": "able to be expended [adj EXPENDABLY] / one who is expendable [n -S]\n",
  "EXPENDABLES": "EXPENDABLE, one who is expendable [n]\n",
  "EXPENDABLY": "EXPENDABLE, able to be expended [adv]\n",
  "EXPENDED": "EXPEND, to consume in any way [v]\n",
  "EXPENDER": "one who expends [n -S]\n",
  "EXPENDERS": "EXPENDER, one who expends [n]\n",
  "EXPENDING": "EXPEND, to consume in any way [v]\n",
  "EXPENDITURE": "the act of expending [n -S]\n",
  "EXPENDITURES": "EXPENDITURE, the act of expending [n]\n",
  "EXPENDS": "EXPEND, to consume in any way [v]\n",
  "EXPENSE": "to charge with costs [v EXPENSED, EXPENSING, EXPENSES]\n",
  "EXPENSED": "EXPENSE, to charge with costs [v]\n",
  "EXPENSES": "EXPENSE, to charge with costs [v]\n",
  "EXPENSING": "EXPENSE, to charge with costs [v]\n",
  "EXPENSIVE": "costing a lot of money [adj EXPENSIVELY]\n",
  "EXPENSIVELY": "EXPENSIVE, costing a lot of money [adv]\n",
  "EXPENSIVENESS": "EXPENSIVE, costing a lot of money [n]\n",
  "EXPENSIVENESSES": "EXPENSIVENESS, EXPENSIVE, costing a lot of money [n]\n",
  "EXPERIENCE": "to have practical acquaintance with [v EXPERIENCED, EXPERIENCING, EXPERIENCES]\n",
  "EXPERIENCEABLE": "that can be experienced [adj]\n",
  "EXPERIENCED": "EXPERIENCE, to have practical acquaintance with [v]\n",
  "EXPERIENCELESS": "without experience [adj]\n",
  "EXPERIENCER": "one who experiences [n -S]\n",
  "EXPERIENCERS": "EXPERIENCER, one who experiences [n]\n",
  "EXPERIENCES": "EXPERIENCE, to have practical acquaintance with [v]\n",
  "EXPERIENCING": "EXPERIENCE, to have practical acquaintance with [v]\n",
  "EXPERIENTIAL": "relating to, derived from, or providing experience [adj EXPERIENTIALLY]\n",
  "EXPERIENTIALISM": "the doctrine that knowledge comes from experience [n]\n",
  "EXPERIENTIALIST": "a believer in experientialism, the doctrine that knowledge comes from experience [n]\n",
  "EXPERIENTIALLY": "EXPERIENTIAL, relating to, derived from, or providing experience [adv]\n",
  "EXPERIMENT": "to carry out experiments [v -ED, -ING, -S]\n",
  "EXPERIMENTAL": "of, relating to, or based on experience or experiment [adj EXPERIMENTALLY]\n",
  "EXPERIMENTALISE": "to rely on experiment, also EXPERIMENTALIZE [v]\n",
  "EXPERIMENTALISM": "reliance on or advocacy of experimental or empirical principles and procedures [n]\n",
  "EXPERIMENTALIST": "one who experiments [n]\n",
  "EXPERIMENTALIZE": "to rely on experiment, also EXPERIMENTALISE [v]\n",
  "EXPERIMENTALLY": "EXPERIMENTAL, of, relating to, or based on experience or experiment [adv]\n",
  "EXPERIMENTATION": "the act of experimenting [n]\n",
  "EXPERIMENTATIVE": "related to experiment [adj]\n",
  "EXPERIMENTED": "EXPERIMENT, to carry out experiments [v]\n",
  "EXPERIMENTER": "one who experiments [n -S]\n",
  "EXPERIMENTERS": "EXPERIMENTER, one who experiments [n]\n",
  "EXPERIMENTING": "EXPERIMENT, to carry out experiments [v]\n",
  "EXPERIMENTIST": "a person who carries out experiments [n -S]\n",
  "EXPERIMENTISTS": "EXPERIMENTIST, a person who carries out experiments [n]\n",
  "EXPERIMENTS": "EXPERIMENT, to carry out experiments [v]\n",
  "EXPERT": "skilled [adj EXPERTLY] / (Spenser) to experience [v -ED, -ING, -S]\n",
  "EXPERTED": "EXPERT, (Spenser) to experience [v]\n",
  "EXPERTING": "EXPERT, (Spenser) to experience [v]\n",
  "EXPERTISE": "expert knowledge [n -S] / to give an expert opinion on, also EXPERTIZE [v EXPERTISED, EXPERTISING, EXPERTISES]\n",
  "EXPERTISED": "EXPERTISE, to give an expert opinion on, also EXPERTIZE [v]\n",
  "EXPERTISES": "EXPERTISE, to give an expert opinion on, also EXPERTIZE [v]\n",
  "EXPERTISING": "EXPERTISE, to give an expert opinion on, also EXPERTIZE [v]\n",
  "EXPERTISM": "possession of specific skills, also EXPERTNESS [n -S]\n",
  "EXPERTISMS": "EXPERTISM, possession of specific skills, also EXPERTNESS [n]\n",
  "EXPERTIZE": "to give an expert opinion on, also EXPERTISE [v EXPERTIZED, EXPERTIZING, EXPERTIZES]\n",
  "EXPERTIZED": "EXPERTIZE, to give an expert opinion on, also EXPERTISE [v]\n",
  "EXPERTIZES": "EXPERTIZE, to give an expert opinion on, also EXPERTISE [v]\n",
  "EXPERTIZING": "EXPERTIZE, to give an expert opinion on, also EXPERTISE [v]\n",
  "EXPERTLY": "EXPERT, skilled [adv]\n",
  "EXPERTNESS": "a possession of specific skills, also EXPERTISM [n -ES]\n",
  "EXPERTNESSES": "EXPERTNESS, a possession of specific skills, also EXPERTISM [n]\n",
  "EXPERTS": "EXPERT, (Spenser) to experience [v]\n",
  "EXPIABLE": "capable of being expiated [adj]\n",
  "EXPIATE": "to make complete atonement for [v EXPIATED, EXPIATING, EXPIATES]\n",
  "EXPIATED": "EXPIATE, to make complete atonement for [v]\n",
  "EXPIATES": "EXPIATE, to make complete atonement for [v]\n",
  "EXPIATING": "EXPIATE, to make complete atonement for [v]\n",
  "EXPIATION": "the act of expiating [n -S]\n",
  "EXPIATIONS": "EXPIATION, the act of expiating [n]\n",
  "EXPIATOR": "one who makes expiation or atonement [n -S]\n",
  "EXPIATORS": "EXPIATOR, one who makes expiation or atonement [n]\n",
  "EXPIATORY": "having power, or intended, to make expiation [adj]\n",
  "EXPIRABLE": "that may expire or come to an end [adj]\n",
  "EXPIRANT": "someone expiring [n -S]\n",
  "EXPIRANTS": "EXPIRANT, someone expiring [n]\n",
  "EXPIRATION": "the last emission of breath [n -S]\n",
  "EXPIRATIONS": "EXPIRATION, the last emission of breath [n]\n",
  "EXPIRATORY": "pertaining to the expiration of air from the lungs [adj]\n",
  "EXPIRE": "to come to an end [v EXPIRED, EXPIRING, EXPIRES]\n",
  "EXPIRED": "EXPIRE, to come to an end [v]\n",
  "EXPIRER": "one who expires [n -S]\n",
  "EXPIRERS": "EXPIRER, one who expires [n]\n",
  "EXPIRES": "EXPIRE, to come to an end [v]\n",
  "EXPIRIES": "EXPIRY, expiration; death [n]\n",
  "EXPIRING": "EXPIRE, to come to an end [v]\n",
  "EXPIRY": "expiration; death [n EXPIRIES]\n",
  "EXPISCATE": "to learn through laborious investigation; literally, to fish out [v EXPISCATED, EXPISCATING, EXPISCATES]\n",
  "EXPISCATED": "EXPISCATE, to learn through laborious investigation; literally, to fish out [v]\n",
  "EXPISCATES": "EXPISCATE, to learn through laborious investigation; literally, to fish out [v]\n",
  "EXPISCATING": "EXPISCATE, to learn through laborious investigation; literally, to fish out [v]\n",
  "EXPISCATION": "the act of expiscating [n -S]\n",
  "EXPISCATIONS": "EXPISCATION, the act of expiscating [n]\n",
  "EXPISCATORY": "serving to expiscate [adj]\n",
  "EXPLAIN": "to make clear and understandable [v -ED, -ING, -S]\n",
  "EXPLAINABLE": "that can be explained [adj]\n",
  "EXPLAINED": "EXPLAIN, to make clear and understandable [v]\n",
  "EXPLAINER": "one who explains [n -S]\n",
  "EXPLAINERS": "EXPLAINER, one who explains [n]\n",
  "EXPLAINING": "EXPLAIN, to make clear and understandable [v]\n",
  "EXPLAINS": "EXPLAIN, to make clear and understandable [v]\n",
  "EXPLANATION": "the act of explaining [n -S]\n",
  "EXPLANATIONS": "EXPLANATION, the act of explaining [n]\n",
  "EXPLANATIVE": "serving to explain, also EXPLANATORY [adj EXPLANATIVELY]\n",
  "EXPLANATIVELY": "EXPLANATIVE, serving to explain, also EXPLANATORY [adv]\n",
  "EXPLANATORILY": "EXPLANATORY, serving to explain, also EXPLANATIVE [adv]\n",
  "EXPLANATORY": "serving to explain, also EXPLANATIVE [adj EXPLANATORILY]\n",
  "EXPLANT": "to transfer living tissue [v -ED, -ING, -S]\n",
  "EXPLANTATION": "the act of explanting [n -S]\n",
  "EXPLANTATIONS": "EXPLANTATION, the act of explanting [n]\n",
  "EXPLANTED": "EXPLANT, to transfer living tissue [v]\n",
  "EXPLANTING": "EXPLANT, to transfer living tissue [v]\n",
  "EXPLANTS": "EXPLANT, to transfer living tissue [v]\n",
  "EXPLETIVE": "filling out [adj EXPLETIVELY] / a swearword [n -S]\n",
  "EXPLETIVELY": "EXPLETIVE, filling out [adv]\n",
  "EXPLETIVES": "EXPLETIVE, a swearword [n]\n",
  "EXPLETORY": "serving to fill up; supplementary; as, an expletory word [adj]\n",
  "EXPLICABLE": "that can be explicated [adj EXPLICABLY]\n",
  "EXPLICABLY": "EXPLICABLE, that can be explicated [adv]\n",
  "EXPLICATE": "to explain [v EXPLICATED, EXPLICATING, EXPLICATES]\n",
  "EXPLICATED": "EXPLICATE, to explain [v]\n",
  "EXPLICATES": "EXPLICATE, to explain [v]\n",
  "EXPLICATING": "EXPLICATE, to explain [v]\n",
  "EXPLICATION": "the act of explicating [n -S]\n",
  "EXPLICATIONS": "EXPLICATION, the act of explicating [n]\n",
  "EXPLICATIVE": "serving to explicate [adj EXPLICATIVELY]\n",
  "EXPLICATIVELY": "EXPLICATIVE, serving to explicate [adv]\n",
  "EXPLICATOR": "one who explicates [n -S]\n",
  "EXPLICATORS": "EXPLICATOR, one who explicates [n]\n",
  "EXPLICATORY": "serving to explicate [adj]\n",
  "EXPLICIT": "distinctly stated [adj EXPLICITLY] / a conclusion or the last words in a book [n -S]\n",
  "EXPLICITLY": "EXPLICIT, distinctly stated [adv]\n",
  "EXPLICITNESS": "the state of being explicit [n -ES]\n",
  "EXPLICITNESSES": "EXPLICITNESS, the state of being explicit [n]\n",
  "EXPLICITS": "EXPLICIT, a conclusion or the last words in a book [n]\n",
  "EXPLODE": "to blow up [v EXPLODED, EXPLODING, EXPLODES]\n",
  "EXPLODED": "EXPLODE, to blow up [v]\n",
  "EXPLODER": "one that explodes [n -S]\n",
  "EXPLODERS": "EXPLODER, one that explodes [n]\n",
  "EXPLODES": "EXPLODE, to blow up [v]\n",
  "EXPLODING": "EXPLODE, to blow up [v]\n",
  "EXPLOIT": "to take advantage of [v -ED, -ING, -S]\n",
  "EXPLOITABLE": "that can be exploited [adj]\n",
  "EXPLOITAGE": "the act of exploiting [n -S]\n",
  "EXPLOITAGES": "EXPLOITAGE, the act of exploiting [n]\n",
  "EXPLOITATION": "an act or instance of exploiting [n -S]\n",
  "EXPLOITATIONS": "EXPLOITATION, an act or instance of exploiting [n]\n",
  "EXPLOITATIVE": "serving to exploit, also EXPLOITIVE [adj EXPLOITATIVELY]\n",
  "EXPLOITATIVELY": "EXPLOITATIVE, serving to exploit, also EXPLOITIVE [adv]\n",
  "EXPLOITED": "EXPLOIT, to take advantage of [v]\n",
  "EXPLOITER": "one who exploits [n -S]\n",
  "EXPLOITERS": "EXPLOITER, one who exploits [n]\n",
  "EXPLOITING": "EXPLOIT, to take advantage of [v]\n",
  "EXPLOITIVE": "serving to exploit, also EXPLOITATIVE [adj]\n",
  "EXPLOITS": "EXPLOIT, to take advantage of [v]\n",
  "EXPLORATION": "the act or an instance of exploring [n -S]\n",
  "EXPLORATIONAL": "relating to exploration [adj]\n",
  "EXPLORATIONIST": "a scientist engaged in mineral exploration [n -S]\n",
  "EXPLORATIONISTS": "EXPLORATIONIST, a scientist engaged in mineral exploration [n]\n",
  "EXPLORATIONS": "EXPLORATION, the act or an instance of exploring [n]\n",
  "EXPLORATIVE": "serving to explore [adj EXPLORATIVELY]\n",
  "EXPLORATIVELY": "EXPLORATIVE, serving to explore [adv]\n",
  "EXPLORATORY": "of, relating to, or being exploration [adj]\n",
  "EXPLORE": "to examine thoroughly [v EXPLORED, EXPLORING, EXPLORES]\n",
  "EXPLORED": "EXPLORE, to examine thoroughly [v]\n",
  "EXPLORER": "one who explores [n -S]\n",
  "EXPLORERS": "EXPLORER, one who explores [n]\n",
  "EXPLORES": "EXPLORE, to examine thoroughly [v]\n",
  "EXPLORING": "EXPLORE, to examine thoroughly [v]\n",
  "EXPLOSIBLE": "liable to explode [adj]\n",
  "EXPLOSION": "the act of exploding [n -S]\n",
  "EXPLOSIONS": "EXPLOSION, the act of exploding [n]\n",
  "EXPLOSIVE": "tending to explode [adj EXPLOSIVELY] / something that will explode [n -S]\n",
  "EXPLOSIVELY": "EXPLOSIVE, tending to explode [adv]\n",
  "EXPLOSIVENESS": "EXPLOSIVE, tending to explode [n]\n",
  "EXPLOSIVENESSES": "EXPLOSIVENESS, EXPLOSIVE, tending to explode [n]\n",
  "EXPLOSIVES": "EXPLOSIVE, something that will explode [n]\n",
  "EXPO": "an exhibition or public showing [n -S]\n",
  "EXPONENT": "one who practises a discipline [n -S]\n",
  "EXPONENTIAL": "of or relating to an exponent [adj EXPONENTIALLY] / an exponential function [n -S]\n",
  "EXPONENTIALLY": "EXPONENTIAL, of or relating to an exponent [adv]\n",
  "EXPONENTIALS": "EXPONENTIAL, an exponential function [n]\n",
  "EXPONENTIATION": "the mathematical operation of raising a quantity to a power [n -S]\n",
  "EXPONENTIATIONS": "EXPONENTIATION, the mathematical operation of raising a quantity to a power [n]\n",
  "EXPONENTS": "EXPONENT, one who practises a discipline [n]\n",
  "EXPONIBLE": "capable of being explained [adj]\n",
  "EXPORT": "to send goods out of a country [v -ED, -ING, -S]\n",
  "EXPORTABILITIES": "EXPORTABILITY, the state of being exportable [n]\n",
  "EXPORTABILITY": "the state of being exportable [n EXPORTABILITIES]\n",
  "EXPORTABLE": "that can be exported [adj]\n",
  "EXPORTATION": "the act of exporting [n -S]\n",
  "EXPORTATIONS": "EXPORTATION, the act of exporting [n]\n",
  "EXPORTED": "EXPORT, to send goods out of a country [v]\n",
  "EXPORTER": "one who exports [n -S]\n",
  "EXPORTERS": "EXPORTER, one who exports [n]\n",
  "EXPORTING": "EXPORT, to send goods out of a country [v]\n",
  "EXPORTS": "EXPORT, to send goods out of a country [v]\n",
  "EXPOS": "EXPO, an exhibition or public showing [n]\n",
  "EXPOSABLE": "that can be exposed [adj]\n",
  "EXPOSAL": "exposure [n -S]\n",
  "EXPOSALS": "EXPOSAL, exposure [n]\n",
  "EXPOSE": "to lay open to view [v EXPOSED, EXPOSING, EXPOSES]\n",
  "EXPOSED": "EXPOSE, to lay open to view [v]\n",
  "EXPOSEDNESS": "the state of being exposed [n -ES]\n",
  "EXPOSEDNESSES": "EXPOSEDNESS, the state of being exposed [n]\n",
  "EXPOSER": "one who exposes [n -S]\n",
  "EXPOSERS": "EXPOSER, one who exposes [n]\n",
  "EXPOSES": "EXPOSE, to lay open to view [v]\n",
  "EXPOSING": "EXPOSE, to lay open to view [v]\n",
  "EXPOSIT": "to expound [v -ED, -ING, -S]\n",
  "EXPOSITED": "EXPOSIT, to expound [v]\n",
  "EXPOSITING": "EXPOSIT, to expound [v]\n",
  "EXPOSITION": "a setting forth of the meaning or purpose (as of a writing) [n -S]\n",
  "EXPOSITIONAL": "relating to exposition [adj]\n",
  "EXPOSITIONS": "EXPOSITION, a setting forth of the meaning or purpose (as of a writing) [n]\n",
  "EXPOSITIVE": "serving to explain [adj EXPOSITIVELY]\n",
  "EXPOSITIVELY": "EXPOSITIVE, serving to explain [adv]\n",
  "EXPOSITOR": "one who, or that which, exposits [n -S]\n",
  "EXPOSITORILY": "EXPOSITORY, pertaining to, or containing, exposition [adv]\n",
  "EXPOSITORS": "EXPOSITOR, one who, or that which, exposits [n]\n",
  "EXPOSITORY": "pertaining to, or containing, exposition [adj EXPOSITORILY]\n",
  "EXPOSITRESS": "a female expositor [n -ES]\n",
  "EXPOSITRESSES": "EXPOSITRESS, a female expositor [n]\n",
  "EXPOSITS": "EXPOSIT, to expound [v]\n",
  "EXPOSOME": "a collection of environmental factors, such as stress and diet, to which an individual is exposed and which can have an effect on health [n -S]\n",
  "EXPOSOMES": "EXPOSOME, a collection of environmental factors, such as stress and diet, to which an individual is exposed and which can have an effect on health [n]\n",
  "EXPOSTULATE": "to remonstrate; to discuss or reason with [v EXPOSTULATED, EXPOSTULATING, EXPOSTULATES]\n",
  "EXPOSTULATED": "EXPOSTULATE, to remonstrate; to discuss or reason with [v]\n",
  "EXPOSTULATES": "EXPOSTULATE, to remonstrate; to discuss or reason with [v]\n",
  "EXPOSTULATING": "EXPOSTULATE, to remonstrate; to discuss or reason with [v]\n",
  "EXPOSTULATINGLY": "EXPOSTULATING, EXPOSTULATE, to remonstrate; to discuss or reason with [adv]\n",
  "EXPOSTULATION": "an act or an instance of expostulating [n -S]\n",
  "EXPOSTULATIONS": "EXPOSTULATION, an act or an instance of expostulating [n]\n",
  "EXPOSTULATIVE": "related to expostulation, also EXPOSTULATORY [adj]\n",
  "EXPOSTULATOR": "one who expostulates [n -S]\n",
  "EXPOSTULATORS": "EXPOSTULATOR, one who expostulates [n]\n",
  "EXPOSTULATORY": "relating to expostulation, also EXPOSTULATIVE [adj]\n",
  "EXPOSTURE": "(Shakespeare) exposure [n -S]\n",
  "EXPOSTURES": "EXPOSTURE, (Shakespeare) exposure [n]\n",
  "EXPOSURE": "the act of exposing [n -S]\n",
  "EXPOSURES": "EXPOSURE, the act of exposing [n]\n",
  "EXPOUND": "to explain in detail [v -ED, -ING, -S]\n",
  "EXPOUNDED": "EXPOUND, to explain in detail [v]\n",
  "EXPOUNDER": "one who expounds [n -S]\n",
  "EXPOUNDERS": "EXPOUNDER, one who expounds [n]\n",
  "EXPOUNDING": "EXPOUND, to explain in detail [v]\n",
  "EXPOUNDS": "EXPOUND, to explain in detail [v]\n",
  "EXPRESS": "explicit, clearly stated [adj EXPRESSLY] / to set forth in words [v -ED, -ING, -ES]\n",
  "EXPRESSAGE": "the charge for carrying a parcel by express [n -S]\n",
  "EXPRESSAGES": "EXPRESSAGE, the charge for carrying a parcel by express [n]\n",
  "EXPRESSED": "EXPRESS, to set forth in words [v]\n",
  "EXPRESSER": "one who expresses [n -S]\n",
  "EXPRESSERS": "EXPRESSER, one who expresses [n]\n",
  "EXPRESSES": "EXPRESS, to set forth in words [v]\n",
  "EXPRESSIBLE": "that can be expressed [adj]\n",
  "EXPRESSING": "EXPRESS, to set forth in words [v]\n",
  "EXPRESSION": "an act, process, or instance of representing in a medium [n -S]\n",
  "EXPRESSIONAL": "relating to expression [adj]\n",
  "EXPRESSIONISM": "a theory or practice in art of seeking to depict the subjective emotions and responses that objects and events arouse in the artist [n -S]\n",
  "EXPRESSIONISMS": "EXPRESSIONISM, a theory or practice in art of seeking to depict the subjective emotions and responses that objects and events arouse in the artist [n]\n",
  "EXPRESSIONIST": "an exponent of expressionism [n -S]\n",
  "EXPRESSIONISTIC": "relating to expressionism [adj]\n",
  "EXPRESSIONISTS": "EXPRESSIONIST, an exponent of expressionism [n]\n",
  "EXPRESSIONLESS": "lacking expression [adj]\n",
  "EXPRESSIONS": "EXPRESSION, an act, process, or instance of representing in a medium [n]\n",
  "EXPRESSIVE": "full of expression [adj EXPRESSIVELY]\n",
  "EXPRESSIVELY": "EXPRESSIVE, full of expression [adv]\n",
  "EXPRESSIVENESS": "EXPRESSIVE, full of expression [n]\n",
  "EXPRESSIVITIES": "EXPRESSIVITY, the relative capacity of a gene to affect the phenotype of the organism of which it is a part [n]\n",
  "EXPRESSIVITY": "the relative capacity of a gene to affect the phenotype of the organism of which it is a part [n EXPRESSIVITIES]\n",
  "EXPRESSLY": "EXPRESS, explicit, clearly stated [adv]\n",
  "EXPRESSMAN": "a person employed in the express business [n EXPRESSMEN]\n",
  "EXPRESSMEN": "EXPRESSMAN, a person employed in the express business [n]\n",
  "EXPRESSNESS": "the state of being express [n -ES]\n",
  "EXPRESSNESSES": "EXPRESSNESS, the state of being express [n]\n",
  "EXPRESSO": "(Italian) a strong coffee, also ESPRESSO [n -S]\n",
  "EXPRESSOS": "EXPRESSO, (Italian) a strong coffee, also ESPRESSO [n]\n",
  "EXPRESSURE": "the act of expressing [n -S]\n",
  "EXPRESSURES": "EXPRESSURE, the act of expressing [n]\n",
  "EXPRESSWAY": "(US) a motorway [n -S]\n",
  "EXPRESSWAYS": "EXPRESSWAY, (US) a motorway [n]\n",
  "EXPROBRATE": "(archaic) to upbraid [v EXPROBRATED, EXPROBRATING, EXPROBRATES]\n",
  "EXPROBRATED": "EXPROBRATE, (archaic) to upbraid [v]\n",
  "EXPROBRATES": "EXPROBRATE, (archaic) to upbraid [v]\n",
  "EXPROBRATING": "EXPROBRATE, (archaic) to upbraid [v]\n",
  "EXPROBRATION": "the act of exprobrating, upbraiding [n -S]\n",
  "EXPROBRATIONS": "EXPROBRATION, the act of exprobrating, upbraiding [n]\n",
  "EXPROBRATIVE": "expressing reproach, also EXPROBRATORY [adj]\n",
  "EXPROBRATORY": "expressing reproach, also EXPROBRATIVE [adj]\n",
  "EXPROMISSION": "relieving another person's debt by taking it upon oneself [n -S]\n",
  "EXPROMISSIONS": "EXPROMISSION, relieving another person's debt by taking it upon oneself [n]\n",
  "EXPROMISSOR": "a person relieving another of debt by taking it upon himself [n -S]\n",
  "EXPROMISSORS": "EXPROMISSOR, a person relieving another of debt by taking it upon himself [n]\n",
  "EXPROPRIABLE": "that can be expropriated [adj]\n",
  "EXPROPRIATE": "to deprive of possession or proprietary rights [v EXPROPRIATED, EXPROPRIATING, EXPROPRIATES]\n",
  "EXPROPRIATED": "EXPROPRIATE, to deprive of possession or proprietary rights [v]\n",
  "EXPROPRIATES": "EXPROPRIATE, to deprive of possession or proprietary rights [v]\n",
  "EXPROPRIATING": "EXPROPRIATE, to deprive of possession or proprietary rights [v]\n",
  "EXPROPRIATION": "the act of expropriating [n -S]\n",
  "EXPROPRIATIONS": "EXPROPRIATION, the act of expropriating [n]\n",
  "EXPROPRIATOR": "one who expropriates [n -S]\n",
  "EXPROPRIATORS": "EXPROPRIATOR, one who expropriates [n]\n",
  "EXPUGN": "to take by storm [v -ED, -ING, -S]\n",
  "EXPUGNABLE": "capable of being expugned [adj]\n",
  "EXPUGNATION": "the act of expugning [n -S]\n",
  "EXPUGNATIONS": "EXPUGNATION, the act of expugning [n]\n",
  "EXPUGNED": "EXPUGN, to take by storm [v]\n",
  "EXPUGNING": "EXPUGN, to take by storm [v]\n",
  "EXPUGNS": "EXPUGN, to take by storm [v]\n",
  "EXPULSE": "(obsolete) to expel [v EXPULSED, EXPULSING, EXPULSES]\n",
  "EXPULSED": "EXPULSE, (obsolete) to expel [v]\n",
  "EXPULSES": "EXPULSE, (obsolete) to expel [v]\n",
  "EXPULSING": "EXPULSE, (obsolete) to expel [v]\n",
  "EXPULSION": "the act of expelling or state of being expelled [n -S]\n",
  "EXPULSIONS": "EXPULSION, the act of expelling or state of being expelled [n]\n",
  "EXPULSIVE": "serving to expel [adj]\n",
  "EXPUNCT": "(archaic) to expunge, wipe out [v -ED, -ING, -S]\n",
  "EXPUNCTED": "EXPUNCT, (archaic) to expunge, wipe out [v]\n",
  "EXPUNCTING": "EXPUNCT, (archaic) to expunge, wipe out [v]\n",
  "EXPUNCTION": "the act of expunging or erasing [n -S]\n",
  "EXPUNCTIONS": "EXPUNCTION, the act of expunging or erasing [n]\n",
  "EXPUNCTS": "EXPUNCT, (archaic) to expunge, wipe out [v]\n",
  "EXPUNGE": "to delete [v EXPUNGED, EXPUNGING, EXPUNGES]\n",
  "EXPUNGED": "EXPUNGE, to delete [v]\n",
  "EXPUNGER": "one who expunges [n -S]\n",
  "EXPUNGERS": "EXPUNGER, one who expunges [n]\n",
  "EXPUNGES": "EXPUNGE, to delete [v]\n",
  "EXPUNGING": "EXPUNGE, to delete [v]\n",
  "EXPURGATE": "to purify or revise; to censor [v EXPURGATED, EXPURGATING, EXPURGATES]\n",
  "EXPURGATED": "EXPURGATE, to purify or revise; to censor [v]\n",
  "EXPURGATES": "EXPURGATE, to purify or revise; to censor [v]\n",
  "EXPURGATING": "EXPURGATE, to purify or revise; to censor [v]\n",
  "EXPURGATION": "the act of expurgating [n -S]\n",
  "EXPURGATIONS": "EXPURGATION, the act of expurgating [n]\n",
  "EXPURGATOR": "one who expurgates [n -S]\n",
  "EXPURGATORIAL": "tending to expurgate or purify, also EXPURGATORY [adj]\n",
  "EXPURGATORS": "EXPURGATOR, one who expurgates [n]\n",
  "EXPURGATORY": "tending to expurgate or purify, also EXPURGATORIAL [adj]\n",
  "EXPURGE": "to purge away [v EXPURGED, EXPURGING, EXPURGES]\n",
  "EXPURGED": "EXPURGE, to purge away [v]\n",
  "EXPURGES": "EXPURGE, to purge away [v]\n",
  "EXPURGING": "EXPURGE, to purge away [v]\n",
  "EXQUISITE": "delicate and intricate [adj EXQUISITELY] / a person who is obsessively or fashionably exact or fastidious in dress [n -S]\n",
  "EXQUISITELY": "EXQUISITE, delicate and intricate [adv]\n",
  "EXQUISITENESS": "the state of being exquisite [n -ES]\n",
  "EXQUISITENESSES": "EXQUISITENESS, the state of being exquisite [n]\n",
  "EXQUISITES": "EXQUISITE, a person who is obsessively or fashionably exact or fastidious in dress [n]\n",
  "EXSANGUINATE": "to drain blood from [v EXSANGUINATED, EXSANGUINATING, EXSANGUINATES]\n",
  "EXSANGUINATED": "EXSANGUINATE, to drain blood from [v]\n",
  "EXSANGUINATES": "EXSANGUINATE, to drain blood from [v]\n",
  "EXSANGUINATING": "EXSANGUINATE, to drain blood from [v]\n",
  "EXSANGUINATION": "the process of draining or losing blood [n -S]\n",
  "EXSANGUINATIONS": "EXSANGUINATION, the process of draining or losing blood [n]\n",
  "EXSANGUINE": "without blood, anaemic, also EXSANGUINED, EXSANGUINEOUS, EXSANGUINOUS [adj]\n",
  "EXSANGUINED": "without blood, anaemic, also EXSANGUINE, EXSANGUINEOUS, EXSANGUINOUS [adj]\n",
  "EXSANGUINEOUS": "without blood, anaemic, also EXSANGUINE, EXSANGUINED, EXSANGUINOUS [adj]\n",
  "EXSANGUINITIES": "EXSANGUINITY, the state of being exsanguine, without blood [n]\n",
  "EXSANGUINITY": "the state of being exsanguine, without blood [n EXSANGUINITIES]\n",
  "EXSANGUINOUS": "without blood, anaemic, also EXSANGUINE, EXSANGUINED, EXSANGUINEOUS [adj]\n",
  "EXSCIND": "to cut out [v -ED, -ING, -S]\n",
  "EXSCINDED": "EXSCIND, to cut out [v]\n",
  "EXSCINDING": "EXSCIND, to cut out [v]\n",
  "EXSCINDS": "EXSCIND, to cut out [v]\n",
  "EXSECANT": "a trigonometric function of an angle [n -S]\n",
  "EXSECANTS": "EXSECANT, a trigonometric function of an angle [n]\n",
  "EXSECT": "to cut out [v -ED, -ING, -S]\n",
  "EXSECTED": "EXSECT, to cut out [v]\n",
  "EXSECTING": "EXSECT, to cut out [v]\n",
  "EXSECTION": "a cutting out [n -S]\n",
  "EXSECTIONS": "EXSECTION, a cutting out [n]\n",
  "EXSECTS": "EXSECT, to cut out [v]\n",
  "EXSERT": "to protrude [v -ED, -ING, -S]\n",
  "EXSERTED": "EXSERT, to protrude [v]\n",
  "EXSERTILE": "capable of being thrust out or protruded [adj]\n",
  "EXSERTING": "EXSERT, to protrude [v]\n",
  "EXSERTION": "a protrusion [n -S]\n",
  "EXSERTIONS": "EXSERTION, a protrusion [n]\n",
  "EXSERTS": "EXSERT, to protrude [v]\n",
  "EXSICCANT": "something having the quality of drying up [n -S]\n",
  "EXSICCANTS": "EXSICCANT, something having the quality of drying up [n]\n",
  "EXSICCATE": "to dry up [v EXSICCATED, EXSICCATING, EXSICCATES]\n",
  "EXSICCATED": "EXSICCATE, to dry up [v]\n",
  "EXSICCATES": "EXSICCATE, to dry up [v]\n",
  "EXSICCATING": "EXSICCATE, to dry up [v]\n",
  "EXSICCATION": "the act of exsiccating [n -S]\n",
  "EXSICCATIONS": "EXSICCATION, the act of exsiccating [n]\n",
  "EXSICCATIVE": "serving to dry up [adj]\n",
  "EXSICCATOR": "a drying agent or apparatus [n -S]\n",
  "EXSICCATORS": "EXSICCATOR, a drying agent or apparatus [n]\n",
  "EXSOLUTION": "relaxation [n -S]\n",
  "EXSOLUTIONS": "EXSOLUTION, relaxation [n]\n",
  "EXSTIPULATE": "without stipules, also ESTIPULATE [adj]\n",
  "EXSTROPHIES": "EXSTROPHY, congenital eversion of a hollow organ, esp. the bladder [n]\n",
  "EXSTROPHY": "congenital eversion of a hollow organ, esp. the bladder [n EXSTROPHIES]\n",
  "EXSUCCOUS": "lacking sap [adj]\n",
  "EXSUFFLATE": "to blow away; to exorcise [v EXSUFFLATED, EXSUFFLATING, EXSUFFLATES]\n",
  "EXSUFFLATED": "EXSUFFLATE, to blow away; to exorcise [v]\n",
  "EXSUFFLATES": "EXSUFFLATE, to blow away; to exorcise [v]\n",
  "EXSUFFLATING": "EXSUFFLATE, to blow away; to exorcise [v]\n",
  "EXSUFFLATION": "expiration; exorcism by blowing [n -S]\n",
  "EXSUFFLATIONS": "EXSUFFLATION, expiration; exorcism by blowing [n]\n",
  "EXSUFFLICATE": "(Shakespeare) puffed out, trifling [adj]\n",
  "EXTANT": "still in existence [adj]\n",
  "EXTASIES": "EXTASY, a state of rapture [n]\n",
  "EXTASY": "a state of rapture [n EXTASIES]\n",
  "EXTATIC": "ecstatic [adj]\n",
  "EXTEMPORAL": "extemporaneous; unpremeditated [adj EXTEMPORALLY]\n",
  "EXTEMPORALLY": "EXTEMPORAL, extemporaneous; unpremeditated [adv]\n",
  "EXTEMPORANEITY": "the state of being extemporaneous [n]\n",
  "EXTEMPORANEOUS": "unpremeditated; esp. of prayer, discourse, composition, etc., also EXTEMPORARY, EXTEMPORE [adj]\n",
  "EXTEMPORARILY": "EXTEMPORARY, unpremeditated; esp. of prayer, discourse, composition, etc., also EXTEMPORANEOUS, EXTEMPORE [adv]\n",
  "EXTEMPORARINESS": "the state of being extemporary [n]\n",
  "EXTEMPORARY": "unpremeditated; esp. of prayer, discourse, composition, etc., also EXTEMPORANEOUS, EXTEMPORE [adj EXTEMPORARILY]\n",
  "EXTEMPORE": "(Latin) an impromptu speech etc. [n -S]\n",
  "EXTEMPORES": "EXTEMPORE, (Latin) an impromptu speech etc. [n]\n",
  "EXTEMPORISATION": "the act of extemporising, also EXTEMPORIZATION [n]\n",
  "EXTEMPORISE": "to perform without preparation or practice; to improvise, also EXTEMPORIZE [v EXTEMPORISED, EXTEMPORISING, EXTEMPORISES]\n",
  "EXTEMPORISED": "EXTEMPORISE, to perform without preparation or practice; to improvise, also EXTEMPORIZE [v]\n",
  "EXTEMPORISER": "one who extemporises, also EXTEMPORIZER [n -S]\n",
  "EXTEMPORISERS": "EXTEMPORISER, one who extemporises, also EXTEMPORIZER [n]\n",
  "EXTEMPORISES": "EXTEMPORISE, to perform without preparation or practice; to improvise, also EXTEMPORIZE [v]\n",
  "EXTEMPORISING": "EXTEMPORISE, to perform without preparation or practice; to improvise, also EXTEMPORIZE [v]\n",
  "EXTEMPORIZATION": "the act of extemporizing, also EXTEMPORISATION [n]\n",
  "EXTEMPORIZE": "to perform without preparation or practice; to improvise, also EXTEMPORISE [v EXTEMPORIZED, EXTEMPORIZING, EXTEMPORIZES]\n",
  "EXTEMPORIZED": "EXTEMPORIZE, to perform without preparation or practice; to improvise, also EXTEMPORISE [v]\n",
  "EXTEMPORIZER": "one who extemporizes, also EXTEMPORISER [n -S]\n",
  "EXTEMPORIZERS": "EXTEMPORIZER, one who extemporizes, also EXTEMPORISER [n]\n",
  "EXTEMPORIZES": "EXTEMPORIZE, to perform without preparation or practice; to improvise, also EXTEMPORISE [v]\n",
  "EXTEMPORIZING": "EXTEMPORISE, to perform without preparation or practice; to improvise, also EXTEMPORIZE [v]\n",
  "EXTEND": "to stretch out to full length [v -ED, -ING, -S]\n",
  "EXTENDABILITIES": "EXTENDABILITY, the state of being extendable [n]\n",
  "EXTENDABILITY": "the state of being extendable [n EXTENDABILITIES]\n",
  "EXTENDABLE": "that can be extended, also EXTENDIBLE, EXTENSIBLE, EXTENSILE [adj]\n",
  "EXTENDANT": "displaced [adj]\n",
  "EXTENDED": "EXTEND, to stretch out to full length [v]\n",
  "EXTENDEDLY": "EXTENDED, EXTEND, to stretch out to full length [adv]\n",
  "EXTENDEDNESS": "the state of being extended [n -ES]\n",
  "EXTENDEDNESSES": "EXTENDEDNESS, the state of being extended [n]\n",
  "EXTENDER": "a substance added to another substance [n -S]\n",
  "EXTENDERS": "EXTENDER, a substance added to another substance [n]\n",
  "EXTENDIBILITIES": "EXTENDIBILITY, the state of being extendible [n]\n",
  "EXTENDIBILITY": "the state of being extendible [n EXTENDIBILITIES]\n",
  "EXTENDIBLE": "that can be extended, also EXTENDABLE, EXTENSIBLE, EXTENSILE [adj]\n",
  "EXTENDING": "EXTEND, to stretch out to full length [v]\n",
  "EXTENDS": "EXTEND, to stretch out to full length [v]\n",
  "EXTENSE": "(obsolete) an extent [n -S]\n",
  "EXTENSES": "EXTENSE, (obsolete) an extent [n]\n",
  "EXTENSIBILITIES": "EXTENSIBILITY, the state of being extensible [n]\n",
  "EXTENSIBILITY": "the state of being extensible [n EXTENSIBILITIES]\n",
  "EXTENSIBLE": "that can be extended, also EXTENDABLE, EXTENDIBLE, EXTENSILE [adj]\n",
  "EXTENSIBLENESS": "the state of being extensible [n]\n",
  "EXTENSIFICATION": "an agricultural policy within the European Union by which land is farmed less intensively and savings made in expenditure on feed, fertilizers and pesticides to balance lower production [n]\n",
  "EXTENSILE": "that can be extended, also EXTENDABLE, EXTENDIBLE, EXTENSIBLE [adj]\n",
  "EXTENSIMETER": "an instrument for measuring small changes in length, etc. in metal to which tension has been applied [n -S]\n",
  "EXTENSIMETERS": "EXTENSIMETER, an instrument for measuring small changes in length, etc. in metal to which tension has been applied [n]\n",
  "EXTENSION": "an act of extending [n -S]\n",
  "EXTENSIONAL": "of, relating to, or marked by extension [adj EXTENSIONALLY]\n",
  "EXTENSIONALISM": "the state of being extensional [n -S]\n",
  "EXTENSIONALISMS": "EXTENSIONALISM, the state of being extensional [n]\n",
  "EXTENSIONALITY": "the state of being extensional [n]\n",
  "EXTENSIONALLY": "EXTENSIONAL, of, relating to, or marked by extension [adv]\n",
  "EXTENSIONIST": "an advocate of extension; a university extension lecturer or student [n -S]\n",
  "EXTENSIONISTS": "EXTENSIONIST, an advocate of extension; a university extension lecturer or student [n]\n",
  "EXTENSIONS": "EXTENSION, an act of extending [n]\n",
  "EXTENSITIES": "EXTENSITY, massiveness or spatial quality in sensation from which perception of extension is derived [n]\n",
  "EXTENSITY": "massiveness or spatial quality in sensation from which perception of extension is derived [n EXTENSITIES]\n",
  "EXTENSIVE": "large, widespread, also EXTENSE [adj EXTENSIVELY]\n",
  "EXTENSIVELY": "EXTENSIVE, large, widespread, also EXTENSE [adv]\n",
  "EXTENSIVENESS": "the state of being extensive [n -ES]\n",
  "EXTENSIVENESSES": "EXTENSIVENESS, the state of being extensive [n]\n",
  "EXTENSIVISATION": "the extensive method of agriculture, also EXTENSIVIZATION [n]\n",
  "EXTENSIVIZATION": "the extensive method of agriculture, also EXTENSIVISATION [n]\n",
  "EXTENSOMETER": "an instrument for measuring deformation in an object due to forces applied [n -S]\n",
  "EXTENSOMETERS": "EXTENSOMETER, an instrument for measuring deformation in an object due to forces applied [n]\n",
  "EXTENSOR": "a muscle that extends a limb [n -S]\n",
  "EXTENSORS": "EXTENSOR, a muscle that extends a limb [n]\n",
  "EXTENT": "the range over which something extends [n -S]\n",
  "EXTENTS": "EXTENT, the range over which something extends [n]\n",
  "EXTENUATE": "to lessen; to weaken the force of [v EXTENUATED, EXTENUATING, EXTENUATES]\n",
  "EXTENUATED": "EXTENUATE, to lessen; to weaken the force of [v]\n",
  "EXTENUATES": "EXTENUATE, to lessen; to weaken the force of [v]\n",
  "EXTENUATING": "excusing [adj EXTENUATINGLY] / the act of excusing [n -S]\n",
  "EXTENUATINGLY": "EXTENUATING, excusing [adv]\n",
  "EXTENUATINGS": "EXTENUATING, the act of excusing [n]\n",
  "EXTENUATION": "the act of extenuating [n -S]\n",
  "EXTENUATIONS": "EXTENUATION, the act of extenuating [n]\n",
  "EXTENUATIVE": "a medicine which causes thinness or emaciation [n -S]\n",
  "EXTENUATIVES": "EXTENUATIVE, a medicine which causes thinness or emaciation [n]\n",
  "EXTENUATOR": "one who extenuates [n -S]\n",
  "EXTENUATORS": "EXTENUATOR, one who extenuates [n]\n",
  "EXTENUATORY": "serving to extenuate [adj]\n",
  "EXTERIOR": "outside [adj EXTERIORLY] / a part or surface that is outside [n -S]\n",
  "EXTERIORISATION": "the process of exteriorising, also EXTERIORIZATION [n]\n",
  "EXTERIORISE": "to make exterior, also EXTERIORIZE [v EXTERIORISED, EXTERIORISING, EXTERIORISES]\n",
  "EXTERIORISED": "EXTERIORISE, to make exterior, also EXTERIORIZE [v]\n",
  "EXTERIORISES": "EXTERIORISE, to make exterior, also EXTERIORIZE [v]\n",
  "EXTERIORISING": "EXTERIORISE, to make exterior, also EXTERIORIZE [v]\n",
  "EXTERIORITIES": "EXTERIORITY, the state of being exterior or exteriorized [n]\n",
  "EXTERIORITY": "the state of being exterior or exteriorized [n EXTERIORITIES]\n",
  "EXTERIORIZATION": "the act of exteriorizing, also EXTERIORISATION [n]\n",
  "EXTERIORIZE": "to make exterior, also EXTERIORISE [v EXTERIORIZED, EXTERIORIZING, EXTERIORIZES]\n",
  "EXTERIORIZED": "EXTERIORIZE, to make exterior, also EXTERIORISE [v]\n",
  "EXTERIORIZES": "EXTERIORIZE, to make exterior, also EXTERIORISE [v]\n",
  "EXTERIORIZING": "EXTERIORIZE, to make exterior, also EXTERIORISE [v]\n",
  "EXTERIORLY": "EXTERIOR, outside [adv]\n",
  "EXTERIORS": "EXTERIOR, a part or surface that is outside [n]\n",
  "EXTERMINABLE": "that can be exterminated [adj]\n",
  "EXTERMINATE": "to get rid of completely usually by killing off, also EXTERMINE [v EXTERMINATED, EXTERMINATING, EXTERMINATES]\n",
  "EXTERMINATED": "EXTERMINATE, to get rid of completely usually by killing off, also EXTERMINE [v]\n",
  "EXTERMINATES": "EXTERMINATE, to get rid of completely usually by killing off, also EXTERMINE [v]\n",
  "EXTERMINATING": "EXTERMINATE, to get rid of completely usually by killing off, also EXTERMINE [v]\n",
  "EXTERMINATION": "the act of exterminating [n -S]\n",
  "EXTERMINATIONS": "EXTERMINATION, the act of exterminating [n]\n",
  "EXTERMINATIVE": "related to extermination [adj]\n",
  "EXTERMINATOR": "one who exterminates [n -S]\n",
  "EXTERMINATORS": "EXTERMINATOR, one who exterminates [n]\n",
  "EXTERMINATORY": "of, relating to, or marked by extermination [adj]\n",
  "EXTERMINE": "(Shakespeare) to exterminate [v EXTERMINED, EXTERMINING, EXTERMINES]\n",
  "EXTERMINED": "EXTERMINE, (Shakespeare) to exterminate [v]\n",
  "EXTERMINES": "EXTERMINE, (Shakespeare) to exterminate [v]\n",
  "EXTERMINING": "EXTERMINE, (Shakespeare) to exterminate [v]\n",
  "EXTERN": "an officer in attendance upon a hospital, but not residing in it; esp. one who cares for the outpatients, also EXTERNE [n -S]\n",
  "EXTERNAL": "on the outside [adj EXTERNALLY] / an exterior [n -S]\n",
  "EXTERNALISATION": "the act of externalising, also EXTERNALIZATION [n]\n",
  "EXTERNALISE": "to make external, also EXTERNALIZE [v EXTERNALISED, EXTERNALISING, EXTERNALISES]\n",
  "EXTERNALISED": "EXTERNALISE, to make external, also EXTERNALIZE [v]\n",
  "EXTERNALISES": "EXTERNALISE, to make external, also EXTERNALIZE [v]\n",
  "EXTERNALISING": "EXTERNALISE, to make external, also EXTERNALIZE [v]\n",
  "EXTERNALISM": "undue regard to mere externals or nonessential outward forms, esp. of religion [n -S]\n",
  "EXTERNALISMS": "EXTERNALISM, undue regard to mere externals or nonessential outward forms, esp. of religion [n]\n",
  "EXTERNALIST": "a believer in externalism [n -S]\n",
  "EXTERNALISTS": "EXTERNALIST, a believer in externalism [n]\n",
  "EXTERNALITIES": "EXTERNALITY, the state of being external [n]\n",
  "EXTERNALITY": "the state of being external [n EXTERNALITIES]\n",
  "EXTERNALIZATION": "the act of externalizing, also EXTERNALISATION [n]\n",
  "EXTERNALIZE": "to make external, also EXTERNALISE [v EXTERNALIZED, EXTERNALIZING, EXTERNALIZES]\n",
  "EXTERNALIZED": "EXTERNALIZE, to make external, also EXTERNALISE [v]\n",
  "EXTERNALIZES": "EXTERNALIZE, to make external, also EXTERNALISE [v]\n",
  "EXTERNALIZING": "EXTERNALIZE, to make external, also EXTERNALISE [v]\n",
  "EXTERNALLY": "EXTERNAL, on the outside [adv]\n",
  "EXTERNALS": "EXTERNAL, an exterior [n]\n",
  "EXTERNAT": "(French) a day-school [n -S]\n",
  "EXTERNATS": "EXTERNAT, (French) a day-school [n]\n",
  "EXTERNE": "an officer in attendance upon a hospital, but not residing in it; esp. one who cares for the outpatients, also EXTERN [n -S]\n",
  "EXTERNES": "EXTERNE, an officer in attendance upon a hospital, but not residing in it; esp. one who cares for the outpatients, also EXTERN [n]\n",
  "EXTERNS": "EXTERN, an officer in attendance upon a hospital, but not residing in it; esp. one who cares for the outpatients, also EXTERNE [n]\n",
  "EXTERNSHIP": "the position of an extern [n -S]\n",
  "EXTERNSHIPS": "EXTERNSHIP, the position of an extern [n]\n",
  "EXTEROCEPTIVE": "relating to, being, or activated by stimuli received by an organism from outside [adj]\n",
  "EXTEROCEPTOR": "a sense organ excited by exteroceptive stimuli [n -S]\n",
  "EXTEROCEPTORS": "EXTEROCEPTOR, a sense organ excited by exteroceptive stimuli [n]\n",
  "EXTERRITORIAL": "extraterritorial [adj EXTERRITORIALLY]\n",
  "EXTERRITORIALLY": "EXTERRITORIAL, extraterritorial [adv]\n",
  "EXTINCT": "to extinguish [v -ED, -ING, -S]\n",
  "EXTINCTED": "EXTINCT, to extinguish [v]\n",
  "EXTINCTING": "EXTINCT, to extinguish [v]\n",
  "EXTINCTION": "the act of making extinct [n -S]\n",
  "EXTINCTIONS": "EXTINCTION, the act of making extinct [n]\n",
  "EXTINCTIVE": "tending to extinguish [adj]\n",
  "EXTINCTS": "EXTINCT, to extinguish [v]\n",
  "EXTINCTURE": "(Shakespeare) extinction [n -S]\n",
  "EXTINCTURES": "EXTINCTURE, (Shakespeare) extinction [n]\n",
  "EXTINE": "the outer layer of some spores, also EXINE [n -S]\n",
  "EXTINES": "EXTINE, the outer layer of some spores, also EXINE [n]\n",
  "EXTINGUISH": "to bring to an end [v -ED, -ING, -ES]\n",
  "EXTINGUISHABLE": "that can be extinguished [adj]\n",
  "EXTINGUISHANT": "a substance used to extinguish fires [n -S]\n",
  "EXTINGUISHANTS": "EXTINGUISHANT, a substance used to extinguish fires [n]\n",
  "EXTINGUISHED": "EXTINGUISH, to bring to an end [v]\n",
  "EXTINGUISHER": "a device that extinguishes [n -S]\n",
  "EXTINGUISHERS": "EXTINGUISHER, a device that extinguishes [n]\n",
  "EXTINGUISHES": "EXTINGUISH, to bring to an end [v]\n",
  "EXTINGUISHING": "EXTINGUISH, to bring to an end [v]\n",
  "EXTINGUISHMENT": "the act of extinguishing [n -S]\n",
  "EXTINGUISHMENTS": "EXTINGUISHMENT, the act of extinguishing [n]\n",
  "EXTIRP": "(Shakespeare) to root out [v -ED, -ING, -S]\n",
  "EXTIRPABLE": "capable of being extirpated or eradicated; as, an extirpable plant [adj]\n",
  "EXTIRPATE": "to pull out by the roots [v EXTIRPATED, EXTIRPATING, EXTIRPATES]\n",
  "EXTIRPATED": "EXTIRPATE, to pull out by the roots [v]\n",
  "EXTIRPATES": "EXTIRPATE, to pull out by the roots [v]\n",
  "EXTIRPATING": "EXTIRPATE, to pull out by the roots [v]\n",
  "EXTIRPATION": "the act of extirpating [n -S]\n",
  "EXTIRPATIONS": "EXTIRPATION, the act of extirpating [n]\n",
  "EXTIRPATIVE": "serving to extirpate, also EXTIRPATORY [adj]\n",
  "EXTIRPATOR": "one who extirpates or roots out [n -S]\n",
  "EXTIRPATORS": "EXTIRPATOR, one who extirpates or roots out [n]\n",
  "EXTIRPATORY": "serving to extirpate, also EXTIRPATIVE [adj]\n",
  "EXTIRPED": "EXTIRP, (Shakespeare) to root out [v]\n",
  "EXTIRPING": "EXTIRP, (Shakespeare) to root out [v]\n",
  "EXTIRPS": "EXTIRP, (Shakespeare) to root out [v]\n",
  "EXTOL": "to praise highly, also EXTOLL [v EXTOLLED or (Spenser) EXTOLD, EXTOLLING, EXTOLS]\n",
  "EXTOLD": "EXTOL, to praise highly, also EXTOLL [v]\n",
  "EXTOLL": "to praise highly, also EXTOL [v -ED, -ING, -S]\n",
  "EXTOLLED": "EXTOLL, to praise highly, also EXTOL [v]\n",
  "EXTOLLER": "one who extols [n -S]\n",
  "EXTOLLERS": "EXTOLLER, one who extols [n]\n",
  "EXTOLLING": "EXTOLL, to praise highly, also EXTOL [v]\n",
  "EXTOLLINGLY": "EXTOLLING, EXTOLL, to praise highly, also EXTOL [adv]\n",
  "EXTOLLS": "EXTOLL, to praise highly, also EXTOL [v]\n",
  "EXTOLMENT": "praise [n -S]\n",
  "EXTOLMENTS": "EXTOLMENT, praise [n]\n",
  "EXTOLS": "EXTOL, to praise highly, also EXTOLL [v]\n",
  "EXTORSIVE": "relating to or practising extortion, also EXTORTIVE [adj]\n",
  "EXTORSIVELY": "EXTORSIVE, relating to or practising extortion, also EXTORTIVE [adv]\n",
  "EXTORT": "to obtain something by violence or intimidation [v -ED, -ING, -S]\n",
  "EXTORTED": "EXTORT, to obtain something by violence or intimidation [v]\n",
  "EXTORTER": "one who extorts [n -S]\n",
  "EXTORTERS": "EXTORTER, one who extorts [n]\n",
  "EXTORTING": "EXTORT, to obtain something by violence or intimidation [v]\n",
  "EXTORTION": "the illegal securing of money by compulsion or violence [n -S]\n",
  "EXTORTIONARY": "relating to extortion [adj]\n",
  "EXTORTIONATE": "characterized by extortion [adj EXTORTIONATELY]\n",
  "EXTORTIONATELY": "EXTORTIONATE, characterized by extortion [adv]\n",
  "EXTORTIONER": "one who practises extortion [n -S]\n",
  "EXTORTIONERS": "EXTORTIONER, one who practises extortion [n]\n",
  "EXTORTIONIST": "one who practises extortion [n -S]\n",
  "EXTORTIONISTS": "EXTORTIONIST, one who practises extortion [n]\n",
  "EXTORTIONS": "EXTORTION, the illegal securing of money by compulsion or violence [n]\n",
  "EXTORTIVE": "relating to or practising extortion, also EXTORSIVE [adj]\n",
  "EXTORTS": "EXTORT, to obtain something by violence or intimidation [v]\n",
  "EXTRA": "something additional [n -S]\n",
  "EXTRABOLD": "a very bold typeface [n -S]\n",
  "EXTRABOLDS": "EXTRABOLD, a very bold typeface [n]\n",
  "EXTRACANONICAL": "not part of the canon of the Bible [adj]\n",
  "EXTRACELLULAR": "situated or occurring outside a cell or the cells of the body [adj EXTRACELLULARLY]\n",
  "EXTRACELLULARLY": "EXTRACELLULAR, situated or occurring outside a cell or the cells of the body [adv]\n",
  "EXTRACORPOREAL": "occurring or based outside the living body [adj]\n",
  "EXTRACRANIAL": "situated or occurring outside the cranium [adj]\n",
  "EXTRACT": "to draw out by force [v EXTRACTED or (obsolete) EXTRAUGHT, EXTRACTING, EXTRACTS]\n",
  "EXTRACTABILITY": "the state of being extractable [n]\n",
  "EXTRACTABLE": "that can be extracted, also EXTRACTIBLE [adj]\n",
  "EXTRACTANT": "a solvent used for extraction [n -S]\n",
  "EXTRACTANTS": "EXTRACTANT, a solvent used for extraction [n]\n",
  "EXTRACTED": "EXTRACT, to draw out by force [v]\n",
  "EXTRACTIBLE": "that can be extracted, also EXTRACTABLE [adj]\n",
  "EXTRACTING": "EXTRACT, to draw out by force [v]\n",
  "EXTRACTION": "the act of extracting something [n -S]\n",
  "EXTRACTIONS": "EXTRACTION, the act of extracting something [n]\n",
  "EXTRACTIVE": "capable of being extracted [adj EXTRACTIVELY] / an extract [n -S]\n",
  "EXTRACTIVELY": "EXTRACTIVE, capable of being extracted [adv]\n",
  "EXTRACTIVES": "EXTRACTIVE, an extract [n]\n",
  "EXTRACTOR": "one who, or that which, extracts [n -S]\n",
  "EXTRACTORS": "EXTRACTOR, one who, or that which, extracts [n]\n",
  "EXTRACTS": "EXTRACT, to draw out by force [v]\n",
  "EXTRACURRICULAR": "not falling within the scope of a regular curriculum [adj]\n",
  "EXTRADITABLE": "subject or liable to extradition [adj]\n",
  "EXTRADITE": "to deliver up by one government to another, as a fugitive from justice [v EXTRADITED, EXTRADITING, EXTRADITES]\n",
  "EXTRADITED": "EXTRADITE, to deliver up by one government to another, as a fugitive from justice [v]\n",
  "EXTRADITES": "EXTRADITE, to deliver up by one government to another, as a fugitive from justice [v]\n",
  "EXTRADITING": "EXTRADITE, to deliver up by one government to another, as a fugitive from justice [v]\n",
  "EXTRADITION": "a delivering up of an accused person by one government to another [n -S]\n",
  "EXTRADITIONS": "EXTRADITION, a delivering up of an accused person by one government to another [n]\n",
  "EXTRADOS": "(French) the outer curve of an arch [n -ES]\n",
  "EXTRADOSES": "EXTRADOS, (French) the outer curve of an arch [n]\n",
  "EXTRADOTAL": "forming no part of the dowry; as, extradotal property [adj]\n",
  "EXTRADURAL": "the epidural injection of an anaesthetic esp. in childbirth [n -S]\n",
  "EXTRADURALS": "EXTRADURAL, the epidural injection of an anaesthetic esp. in childbirth [n]\n",
  "EXTRAEMBRYONIC": "situated outside the embryo [adj]\n",
  "EXTRAFLORAL": "of nectaries borne outside flowers [adj]\n",
  "EXTRAFORANEOUS": "outdoors [adj]\n",
  "EXTRAGALACTIC": "originating or existing outside the Milky Way galaxy [adj]\n",
  "EXTRAHEPATIC": "situated or originating outside the liver [adj]\n",
  "EXTRAIT": "(French) an extract [n -S]\n",
  "EXTRAITS": "EXTRAIT, (French) an extract [n]\n",
  "EXTRAJUDICIAL": "not forming a valid part of regular legal proceedings [adj EXTRAJUDICIALLY]\n",
  "EXTRAJUDICIALLY": "EXTRAJUDICIAL, not forming a valid part of regular legal proceedings [adv]\n",
  "EXTRALEGAL": "outside the law [adj EXTRALEGALLY]\n",
  "EXTRALEGALLY": "EXTRALEGAL, outside the law [adv]\n",
  "EXTRALIMITAL": "not present in a given area [adj]\n",
  "EXTRALIMITARY": "not found within a given faunal area; lying outside a prescribed area [adj]\n",
  "EXTRALINGUISTIC": "lying outside the province of linguistics [adj]\n",
  "EXTRALITERARY": "lying outside the field of literature [adj]\n",
  "EXTRALITIES": "EXTRALITY, the privilege of being outside the jurisdiction of the country one is in [n]\n",
  "EXTRALITY": "the privilege of being outside the jurisdiction of the country one is in [n EXTRALITIES]\n",
  "EXTRALOGICAL": "not guided or determined by considerations of logic [adj]\n",
  "EXTRAMARITAL": "of, relating to, or being sexual intercourse between a married person and someone other than his or her spouse [adj EXTRAMARITALLY]\n",
  "EXTRAMARITALLY": "EXTRAMARITAL, of, relating to, or being sexual intercourse between a married person and someone other than his or her spouse [adv]\n",
  "EXTRAMETRICAL": "in excess of the prescribed number of syllables in the line [adj]\n",
  "EXTRAMUNDANE": "beyond the known universe [adj]\n",
  "EXTRAMURAL": "outside the walls or fortifications; outside, but under the aegis of e.g. a university [adj EXTRAMURALLY]\n",
  "EXTRAMURALLY": "EXTRAMURAL, outside the walls or fortifications; outside, but under the aegis of e.g. a university [adv]\n",
  "EXTRAMUSICAL": "lying outside the province of music [adj]\n",
  "EXTRANEITIES": "EXTRANEITY, the state of being without or beyond a thing [n]\n",
  "EXTRANEITY": "the state of being without or beyond a thing [n EXTRANEITIES]\n",
  "EXTRANEOUS": "not forming an essential or vital part [adj]\n",
  "EXTRANEOUSLY": "EXTRANEOUS, not forming an essential or vital part [adv]\n",
  "EXTRANEOUSNESS": "EXTRANEOUS, not forming an essential or vital part [n]\n",
  "EXTRANET": "a type of network like the internet [n -S]\n",
  "EXTRANETS": "EXTRANET, a type of network like the internet [n]\n",
  "EXTRANUCLEAR": "situated in or affecting the parts of a cell external to the nucleus [adj]\n",
  "EXTRAORDINAIRE": "(French) extraordinary, used postpositively as in 'a teacher extraordinaire' [adj]\n",
  "EXTRAORDINARIES": "EXTRAORDINARY, something out of the ordinary [n]\n",
  "EXTRAORDINARILY": "EXTRAORDINARY, going beyond what is usual, regular, or customary [adv]\n",
  "EXTRAORDINARY": "going beyond what is usual, regular, or customary [adj EXTRAORDINARILY] / something out of the ordinary [n EXTRAORDINARIES]\n",
  "EXTRAPOLATE": "to infer (values of a variable in an unobserved interval) from values within an already observed interval [v EXTRAPOLATED, EXTRAPOLATING, EXTRAPOLATES]\n",
  "EXTRAPOLATED": "EXTRAPOLATE, to infer (values of a variable in an unobserved interval) from values within an already observed interval [v]\n",
  "EXTRAPOLATES": "EXTRAPOLATE, to infer (values of a variable in an unobserved interval) from values within an already observed interval [v]\n",
  "EXTRAPOLATING": "EXTRAPOLATE, to infer (values of a variable in an unobserved interval) from values within an already observed interval [v]\n",
  "EXTRAPOLATION": "the act of extrapolating [n -S]\n",
  "EXTRAPOLATIONS": "EXTRAPOLATION, the act of extrapolating [n]\n",
  "EXTRAPOLATIVE": "relating to extrapolation [adj]\n",
  "EXTRAPOLATOR": "one who extrapolates [n -S]\n",
  "EXTRAPOLATORS": "EXTRAPOLATOR, one who extrapolates [n]\n",
  "EXTRAPOLATORY": "of or like an extrapolation [adj]\n",
  "EXTRAPOSE": "to move an item normally positioned within a phrase or sentence to the end, to focus attention on it [v EXTRAPOSED, EXTRAPOSING, EXTRAPOSES]\n",
  "EXTRAPOSED": "EXTRAPOSE, to move an item normally positioned within a phrase or sentence to the end, to focus attention on it [v]\n",
  "EXTRAPOSES": "EXTRAPOSE, to move an item normally positioned within a phrase or sentence to the end, to focus attention on it [v]\n",
  "EXTRAPOSING": "EXTRAPOSE, to move an item normally positioned within a phrase or sentence to the end, to focus attention on it [v]\n",
  "EXTRAPOSITION": "the act of extraposing [n -S]\n",
  "EXTRAPOSITIONS": "EXTRAPOSITION, the act of extraposing [n]\n",
  "EXTRAPYRAMIDAL": "situated outside of the pyramidal tracts [adj]\n",
  "EXTRAS": "EXTRA, something additional [n]\n",
  "EXTRASENSORY": "residing beyond or outside the ordinary senses [adj]\n",
  "EXTRASOLAR": "beyond the solar system [adj]\n",
  "EXTRASYSTOLE": "a premature beat of one of the chambers of the heart that leads to momentary arrhythmia [n -S]\n",
  "EXTRASYSTOLES": "EXTRASYSTOLE, a premature beat of one of the chambers of the heart that leads to momentary arrhythmia [n]\n",
  "EXTRATEXTUAL": "of, relating to, or being something outside a literary text [adj]\n",
  "EXTRATROPICAL": "outside the tropics [adj]\n",
  "EXTRAUGHT": "EXTRACT, to draw out by force [v]\n",
  "EXTRAUTERINE": "situated or occurring outside the uterus [adj]\n",
  "EXTRAVAGANCE": "an instance of excess or prodigality, also EXTRAVAGANCY [n -S]\n",
  "EXTRAVAGANCES": "EXTRAVAGANCE, an instance of excess or prodigality, also EXTRAVAGANCY [n]\n",
  "EXTRAVAGANCIES": "EXTRAVAGANCY, an instance of excess or prodigality, also EXTRAVAGANCE [n]\n",
  "EXTRAVAGANCY": "an instance of excess or prodigality, also EXTRAVAGANCE [n EXTRAVAGANCIES]\n",
  "EXTRAVAGANT": "exceeding the limits of reason or necessity [adj EXTRAVAGANTLY]\n",
  "EXTRAVAGANTLY": "EXTRAVAGANT, exceeding the limits of reason or necessity [adv]\n",
  "EXTRAVAGANZA": "(Italian) a literary, musical, or dramatic composition of an extravagant or fanciful character [n -S]\n",
  "EXTRAVAGANZAS": "EXTRAVAGANZA, (Italian) a literary, musical, or dramatic composition of an extravagant or fanciful character [n]\n",
  "EXTRAVAGATE": "(archaic) to wander; to exceed reasonable limits [v EXTRAVAGATED, EXTRAVAGATING, EXTRAVAGATES]\n",
  "EXTRAVAGATED": "EXTRAVAGATE, (archaic) to wander; to exceed reasonable limits [v]\n",
  "EXTRAVAGATES": "EXTRAVAGATE, (archaic) to wander; to exceed reasonable limits [v]\n",
  "EXTRAVAGATING": "EXTRAVAGATE, (archaic) to wander; to exceed reasonable limits [v]\n",
  "EXTRAVAGATION": "the act of extravagating, wandering [n -S]\n",
  "EXTRAVAGATIONS": "EXTRAVAGATION, the act of extravagating, wandering [n]\n",
  "EXTRAVASATE": "in pathology, to exude from a vessel into surrounding tissue; in geology, to erupt [v EXTRAVASATED, EXTRAVASATING, EXTRAVASATES]\n",
  "EXTRAVASATED": "EXTRAVASATE, in pathology, to exude from a vessel into surrounding tissue; in geology, to erupt [v]\n",
  "EXTRAVASATES": "EXTRAVASATE, in pathology, to exude from a vessel into surrounding tissue; in geology, to erupt [v]\n",
  "EXTRAVASATING": "EXTRAVASATE, in pathology, to exude from a vessel into surrounding tissue; in geology, to erupt [v]\n",
  "EXTRAVASATION": "an escape or effusion of blood or other fluid, esp. from many small vessels into surrounding tissue [n -S]\n",
  "EXTRAVASATIONS": "EXTRAVASATION, an escape or effusion of blood or other fluid, esp. from many small vessels into surrounding tissue [n]\n",
  "EXTRAVASCULAR": "not occurring or contained in body vessels [adj]\n",
  "EXTRAVEHICULAR": "taking place outside a vehicle (as a spacecraft) [adj]\n",
  "EXTRAVERSION": "the state of being extravert [n -S]\n",
  "EXTRAVERSIONS": "EXTRAVERSION, the state of being extravert [n]\n",
  "EXTRAVERSIVE": "turning outwards [adj]\n",
  "EXTRAVERSIVELY": "EXTRAVERSIVE, turning outwards [adv]\n",
  "EXTRAVERT": "turning outwards, also EXTROVERT [adj EXTRAVERTLY] / to turn outwards [v -ED, -ING, -S]\n",
  "EXTRAVERTED": "EXTRAVERT, to turn outwards [v]\n",
  "EXTRAVERTING": "EXTRAVERT, to turn outwards [v]\n",
  "EXTRAVERTLY": "EXTRAVERT, turning outwards, also EXTROVERT [adv]\n",
  "EXTRAVERTS": "EXTRAVERT, to turn outwards [v]\n",
  "EXTREAT": "(Spenser) to extract or eliminate (something) [v -ED, -ING, -S]\n",
  "EXTREATED": "EXTREAT, (Spenser) to extract or eliminate (something) [v]\n",
  "EXTREATING": "EXTREAT, (Spenser) to extract or eliminate (something) [v]\n",
  "EXTREATS": "EXTREAT, (Spenser) to extract or eliminate (something) [v]\n",
  "EXTREMA": "EXTREMUM, (Latin) a maximum or minimum of a mathematical function [n]\n",
  "EXTREMAL": "a clause which limits recursion [n -S]\n",
  "EXTREMALS": "EXTREMAL, a clause which limits recursion [n]\n",
  "EXTREME": "the highest degree [n -S] / farthest from centre [adj EXTREMER, EXTREMEST, EXTREMELY]\n",
  "EXTREMELY": "EXTREME, farthest from centre [adv]\n",
  "EXTREMENESS": "being extreme [n -ES]\n",
  "EXTREMENESSES": "EXTREMENESS, being extreme [n]\n",
  "EXTREMER": "EXTREME, farthest from centre [adj]\n",
  "EXTREMES": "EXTREME, the highest degree [n]\n",
  "EXTREMEST": "EXTREME, farthest from centre [adj]\n",
  "EXTREMISM": "the taking of an extreme position [n -S]\n",
  "EXTREMISMS": "EXTREMISM, the taking of an extreme position [n]\n",
  "EXTREMIST": "one who takes an extreme position [n -S]\n",
  "EXTREMISTS": "EXTREMIST, one who takes an extreme position [n]\n",
  "EXTREMITIES": "EXTREMITY, the utmost limit [n]\n",
  "EXTREMITY": "the utmost limit [n EXTREMITIES]\n",
  "EXTREMOPHILE": "an organism that lives under extreme environmental conditions [n -S]\n",
  "EXTREMOPHILES": "EXTREMOPHILE, an organism that lives under extreme environmental conditions [n]\n",
  "EXTREMUM": "(Latin) a maximum or minimum of a mathematical function [n EXTREMA or EXTREMUMS]\n",
  "EXTREMUMS": "EXTREMUM, (Latin) a maximum or minimum of a mathematical function [n]\n",
  "EXTRICABLE": "capable of being extricated [adj]\n",
  "EXTRICATE": "to free from entanglements or perplexities [v EXTRICATED, EXTRICATING, EXTRICATES]\n",
  "EXTRICATED": "EXTRICATE, to free from entanglements or perplexities [v]\n",
  "EXTRICATES": "EXTRICATE, to free from entanglements or perplexities [v]\n",
  "EXTRICATING": "EXTRICATE, to free from entanglements or perplexities [v]\n",
  "EXTRICATION": "the act of extricating [n -S]\n",
  "EXTRICATIONS": "EXTRICATION, the act of extricating [n]\n",
  "EXTRINSIC": "outward, external, as opposed to intrinsic, also EXTRINSICAL [adj EXTRINSICALLY]\n",
  "EXTRINSICAL": "outward, external, as opposed to intrinsic, also EXTRINSIC [adj EXTRINSICALLY] / an extrinsic thing [n -S]\n",
  "EXTRINSICALITY": "the state of being extrinsic [n]\n",
  "EXTRINSICALLY": "EXTRINSICAL, outward, external, as opposed to intrinsic, also EXTRINSIC [adv]\n",
  "EXTRINSICALS": "EXTRINSICAL, an extrinsic thing [n]\n",
  "EXTROPIAN": "a believer in extropy, the principle that human intelligence will enable life to expand throughout the universe [n -S]\n",
  "EXTROPIANS": "EXTROPIAN, a believer in extropy, the principle that human intelligence will enable life to expand throughout the universe [n]\n",
  "EXTROPIES": "EXTROPY, the prediction that human intelligence will enable life to expand throughout the universe [n]\n",
  "EXTROPY": "the prediction that human intelligence will enable life to expand throughout the universe [n EXTROPIES]\n",
  "EXTRORSAL": "facing outward, away from the axis, also EXTRORSE [adj]\n",
  "EXTRORSE": "facing outwards [adj]\n",
  "EXTROVERSION": "the state of being extrovert [n -S]\n",
  "EXTROVERSIONS": "EXTROVERSION, the state of being extrovert [n]\n",
  "EXTROVERSIVE": "characterised by extroversion [adj]\n",
  "EXTROVERSIVELY": "EXTROVERSIVE, characterised by extroversion [adv]\n",
  "EXTROVERT": "turning outwards, also EXTRAVERT [adj EXTROVERTLY] / to turn outwards [v -ED, -ING, -S]\n",
  "EXTROVERTED": "EXTROVERT, to turn outwards [v]\n",
  "EXTROVERTING": "EXTROVERT, to turn outwards [v]\n",
  "EXTROVERTLY": "EXTROVERT, turning outwards, also EXTRAVERT [adv]\n",
  "EXTROVERTS": "EXTROVERT, to turn outwards [v]\n",
  "EXTRUDABILITIES": "EXTRUDABILITY, the state of being extrudable [n]\n",
  "EXTRUDABILITY": "the state of being extrudable [n EXTRUDABILITIES]\n",
  "EXTRUDABLE": "that can be extruded, also EXTRUSIBLE [adj]\n",
  "EXTRUDE": "to force or urge out; to expel [v EXTRUDED, EXTRUDING, EXTRUDES]\n",
  "EXTRUDED": "EXTRUDE, to force or urge out; to expel [v]\n",
  "EXTRUDER": "something or someone that extrudes [n -S]\n",
  "EXTRUDERS": "EXTRUDER, something or someone that extrudes [n]\n",
  "EXTRUDES": "EXTRUDE, to force or urge out; to expel [v]\n",
  "EXTRUDING": "EXTRUDE, to force or urge out; to expel [v]\n",
  "EXTRUSIBLE": "that can be extruded, also EXTRUDABLE [adj]\n",
  "EXTRUSILE": "capable of being extruded [adj]\n",
  "EXTRUSION": "the act of extruding [n -S]\n",
  "EXTRUSIONS": "EXTRUSION, the act of extruding [n]\n",
  "EXTRUSIVE": "forced out [adj]\n",
  "EXTRUSORY": "relating to extrusion [adj]\n",
  "EXTUBATE": "to remove a tube from [v EXTUBATED, EXTUBATING, EXTUBATES]\n",
  "EXTUBATED": "EXTUBATE, to remove a tube from [v]\n",
  "EXTUBATES": "EXTUBATE, to remove a tube from [v]\n",
  "EXTUBATING": "EXTUBATE, to remove a tube from [v]\n",
  "EXUBERANCE": "the state of being exuberant, also EXUBERANCY [n -S]\n",
  "EXUBERANCES": "EXUBERANCE, the state of being exuberant, also EXUBERANCY [n]\n",
  "EXUBERANCIES": "EXUBERANCY, the state of being exuberant, also EXUBERANCE [n]\n",
  "EXUBERANCY": "the state of being exuberant, also EXUBERANCE [n EXUBERANCIES]\n",
  "EXUBERANT": "luxuriant, overflowing [adj EXUBERANTLY]\n",
  "EXUBERANTLY": "EXUBERANT, luxuriant, overflowing [adv]\n",
  "EXUBERATE": "to be exuberant [v EXUBERATED, EXUBERATING, EXUBERATES]\n",
  "EXUBERATED": "EXUBERATE, to be exuberant [v]\n",
  "EXUBERATES": "EXUBERATE, to be exuberant [v]\n",
  "EXUBERATING": "EXUBERATE, to be exuberant [v]\n",
  "EXUDATE": "an exuded substance [n -S]\n",
  "EXUDATES": "EXUDATE, an exuded substance [n]\n",
  "EXUDATION": "the act of exuding [n -S]\n",
  "EXUDATIONS": "EXUDATION, the act of exuding [n]\n",
  "EXUDATIVE": "relating to exudation [adj]\n",
  "EXUDE": "to ooze forth [v EXUDED, EXUDING, EXUDES]\n",
  "EXUDED": "EXUDE, to ooze forth [v]\n",
  "EXUDES": "EXUDE, to ooze forth [v]\n",
  "EXUDING": "EXUDE, to ooze forth [v]\n",
  "EXUL": "(Spenser) to exile [v EXULLED, EXULLING, EXULS]\n",
  "EXULCERATE": "to ulcerate [v EXULCERATED, EXULCERATING, EXULCERATES]\n",
  "EXULCERATED": "EXULCERATE, to ulcerate [v]\n",
  "EXULCERATES": "EXULCERATE, to ulcerate [v]\n",
  "EXULCERATING": "EXULCERATE, to ulcerate [v]\n",
  "EXULCERATION": "ulceration [n -S]\n",
  "EXULCERATIONS": "EXULCERATION, ulceration [n]\n",
  "EXULLED": "EXUL, (Spenser) to exile [v]\n",
  "EXULLING": "EXUL, (Spenser) to exile [v]\n",
  "EXULS": "EXUL, (Spenser) to exile [v]\n",
  "EXULT": "to rejoice greatly [v -ED, -ING, -S]\n",
  "EXULTANCE": "exultation, also EXULTANCY [n -S]\n",
  "EXULTANCES": "EXULTANCE, exultation, also EXULTANCY [n]\n",
  "EXULTANCIES": "EXULTANCY, exultation, also EXULTANCE [n]\n",
  "EXULTANCY": "exultation, also EXULTANCE [n EXULTANCIES]\n",
  "EXULTANT": "exulting [adj EXULTANTLY]\n",
  "EXULTANTLY": "EXULTANT, exulting [adv]\n",
  "EXULTATION": "the act of exulting [n -S]\n",
  "EXULTATIONS": "EXULTATION, the act of exulting [n]\n",
  "EXULTED": "EXULT, to rejoice greatly [v]\n",
  "EXULTING": "EXULT, to rejoice greatly [v]\n",
  "EXULTINGLY": "EXULTING, EXULT, to rejoice greatly [adv]\n",
  "EXULTS": "EXULT, to rejoice greatly [v]\n",
  "EXURB": "a residential area beyond the suburbs in a city [n -S]\n",
  "EXURBAN": "relating to an exurb, a residential area, esp. a prosperous one, outside the suburbs of a town [adj]\n",
  "EXURBANITE": "a resident of an exurb, a residential area outside the suburbs of a town [n -S]\n",
  "EXURBANITES": "EXURBANITE, a resident of an exurb, a residential area outside the suburbs of a town [n]\n",
  "EXURBIA": "exurbs collectively [n -S]\n",
  "EXURBIAS": "EXURBIA, exurbs collectively [n]\n",
  "EXURBS": "EXURB, a residential area beyond the suburbs in a city [n]\n",
  "EXUVIA": "EXUVIUM, (Latin) the moulted covering of an animal [n]\n",
  "EXUVIAE": "(Latin) skins, shells or other animal coverings that have been cast off; fossil remains of animals [n]\n",
  "EXUVIAL": "of or pertaining to exuviae, cast skins, shells, or coverings of animals [adj]\n",
  "EXUVIATE": "to cast off or shed [v EXUVIATED, EXUVIATING, EXUVIATES]\n",
  "EXUVIATED": "EXUVIATE, to cast off or shed [v]\n",
  "EXUVIATES": "EXUVIATE, to cast off or shed [v]\n",
  "EXUVIATING": "EXUVIATE, to cast off or shed [v]\n",
  "EXUVIATION": "the act of exuviating [n -S]\n",
  "EXUVIATIONS": "EXUVIATION, the act of exuviating [n]\n",
  "EXUVIUM": "(Latin) the moulted covering of an animal [n EXUVIA]\n",
  "EYALET": "(Turkish) a province in the former Ottoman Empire, a vilayet [n -S]\n",
  "EYALETS": "EYALET, (Turkish) a province in the former Ottoman Empire, a vilayet [n]\n",
  "EYAS": "an untrained young hawk, also EYASS, NYAS [n -ES]\n",
  "EYASES": "EYAS, an untrained young hawk, also EYASS, NYAS [n]\n",
  "EYASS": "an untrained young hawk, also EYAS, NYAS [n -ES]\n",
  "EYASSES": "EYASS, an untrained young hawk, also EYAS, NYAS [n]\n",
  "EYE": "the organ of sight [n EYES or (US) EYEN or (obsolete) EINE, EYNE or EEN] / to watch closely [v EYED, EYEING or EYING, EYES]\n",
  "EYEABLE": "able to be eyed [adj]\n",
  "EYEBALL": "to look closely at [v -ED, -ING, -S]\n",
  "EYEBALLED": "EYEBALL, to look closely at [v]\n",
  "EYEBALLING": "EYEBALL, to look closely at [v]\n",
  "EYEBALLS": "EYEBALL, to look closely at [v]\n",
  "EYEBANK": "a bank of corneas for corneal grafts [n -S]\n",
  "EYEBANKS": "EYEBANK, a bank of corneas for corneal grafts [n]\n",
  "EYEBAR": "a metal bar with a loop on the end [n -S]\n",
  "EYEBARS": "EYEBAR, a metal bar with a loop on the end [n]\n",
  "EYEBATH": "a small vessel for washing the eye [n -S]\n",
  "EYEBATHS": "EYEBATH, a small vessel for washing the eye [n]\n",
  "EYEBEAM": "a glance [n -S]\n",
  "EYEBEAMS": "EYEBEAM, a glance [n]\n",
  "EYEBLACK": "a dark pigment applied under the eyes [n -S]\n",
  "EYEBLACKS": "EYEBLACK, a dark pigment applied under the eyes [n]\n",
  "EYEBLINK": "a very small amount of time [n -S]\n",
  "EYEBLINKS": "EYEBLINK, a very small amount of time [n]\n",
  "EYEBOLT": "a bolt with a looped head, or an opening in the head [n -S]\n",
  "EYEBOLTS": "EYEBOLT, a bolt with a looped head, or an opening in the head [n]\n",
  "EYEBRIGHT": "a small annual plant, formerly much used as a remedy for diseases of the eye [n -S]\n",
  "EYEBRIGHTS": "EYEBRIGHT, a small annual plant, formerly much used as a remedy for diseases of the eye [n]\n",
  "EYEBROW": "the hairy arch above the eye [n -S] / to provide with artificial eyebrows [v -ED, -ING, -S]\n",
  "EYEBROWED": "EYEBROW, to provide with artificial eyebrows [v]\n",
  "EYEBROWING": "EYEBROW, to provide with artificial eyebrows [v]\n",
  "EYEBROWLESS": "without eyebrows [adj]\n",
  "EYEBROWS": "EYEBROW, to provide with artificial eyebrows [v]\n",
  "EYECUP": "a cup used for applying lotions to the eye [n -S]\n",
  "EYECUPS": "EYECUP, a cup used for applying lotions to the eye [n]\n",
  "EYED": "EYE, to watch closely [v]\n",
  "EYEDNESS": "the preference for the use of one eye over the other [n -ES]\n",
  "EYEDNESSES": "EYEDNESS, the preference for the use of one eye over the other [n]\n",
  "EYEDROPPER": "a device used to administer eyedrops [n -S]\n",
  "EYEDROPPERS": "EYEDROPPER, a device used to administer eyedrops [n]\n",
  "EYEDROPS": "medicated solution for the eyes [n]\n",
  "EYEFOLD": "a fold of skin of the upper eyelid [n -S]\n",
  "EYEFOLDS": "EYEFOLD, a fold of skin of the upper eyelid [n]\n",
  "EYEFUL": "a complete view [n -S]\n",
  "EYEFULS": "EYEFUL, a complete view [n]\n",
  "EYEGLASS": "a lens used to aid vision [n -ES]\n",
  "EYEGLASSES": "EYEGLASS, a lens used to aid vision [n]\n",
  "EYEHOLE": "a circular opening to receive a hook etc. [n -S]\n",
  "EYEHOLES": "EYEHOLE, a circular opening to receive a hook etc. [n]\n",
  "EYEHOOK": "a hook or ring on the end of a rope or chain [n -S]\n",
  "EYEHOOKS": "EYEHOOK, a hook or ring on the end of a rope or chain [n]\n",
  "EYEING": "EYE, to watch closely [v]\n",
  "EYELASH": "a hair growing on the edge of the eyelid [n -ES]\n",
  "EYELASHES": "EYELASH, a hair growing on the edge of the eyelid [n]\n",
  "EYELESS": "without eyes [adj]\n",
  "EYELET": "to make a small hole in [v EYELETED or EYELETTED, EYELETING or EYELETTING, EYELETS]\n",
  "EYELETED": "EYELET, to make a small hole in [v]\n",
  "EYELETEER": "a small, sharp-pointed instrument used in piercing eyelet holes [n -S]\n",
  "EYELETEERS": "EYELETEER, a small, sharp-pointed instrument used in piercing eyelet holes [n]\n",
  "EYELETING": "EYELET, to make a small hole in [v]\n",
  "EYELETS": "EYELET, to make a small hole in [v]\n",
  "EYELETTED": "EYELET, to make a small hole in [v]\n",
  "EYELETTING": "EYELET, to make a small hole in [v]\n",
  "EYELEVEL": "at the same height as one's eyes [adj]\n",
  "EYELIAD": "an amorous glance, also OEILLADE, ELIAD, EYLIAD, ILLIAD [n -S]\n",
  "EYELIADS": "EYELIAD, an amorous glance, also OEILLADE, ELIAD, EYLIAD, ILLIAD [n]\n",
  "EYELID": "a fold of skin that covers the eye [n -S]\n",
  "EYELIDS": "EYELID, a fold of skin that covers the eye [n]\n",
  "EYELIFT": "cosmetic surgery for eyes [n -S]\n",
  "EYELIFTS": "EYELIFT, cosmetic surgery for eyes [n]\n",
  "EYELIKE": "like an eye [adj]\n",
  "EYELINE": "the line of sight [n -S]\n",
  "EYELINER": "makeup for the eyes [n -S]\n",
  "EYELINERS": "EYELINER, makeup for the eyes [n]\n",
  "EYELINES": "EYELINE, the line of sight [n]\n",
  "EYEN": "EYE, the organ of sight [n]\n",
  "EYEOPENER": "something surprising [n -S]\n",
  "EYEOPENERS": "EYEOPENER, something surprising [n]\n",
  "EYEPATCH": "a patch worn to protect an injured eye [n -ES]\n",
  "EYEPATCHES": "EYEPATCH, a patch worn to protect an injured eye [n]\n",
  "EYEPIECE": "the lens nearest the eye in an optical instrument [n -S]\n",
  "EYEPIECES": "EYEPIECE, the lens nearest the eye in an optical instrument [n]\n",
  "EYEPOINT": "the point at which the eye is placed when using an optical instrument [n -S]\n",
  "EYEPOINTS": "EYEPOINT, the point at which the eye is placed when using an optical instrument [n]\n",
  "EYEPOPPER": "something that excites, astonishes or attracts the eye [n -S]\n",
  "EYEPOPPERS": "EYEPOPPER, something that excites, astonishes or attracts the eye [n]\n",
  "EYER": "one who eyes [n -S]\n",
  "EYERS": "EYER, one who eyes [n]\n",
  "EYES": "EYE, to watch closely [v]\n",
  "EYESHADE": "a visor for shading the eyes [n -S]\n",
  "EYESHADES": "EYESHADE, a visor for shading the eyes [n]\n",
  "EYESHADOW": "a coloured cosmetic for the eyelids [n -S]\n",
  "EYESHADOWS": "EYESHADOW, a coloured cosmetic for the eyelids [n]\n",
  "EYESHINE": "a reflection from the eyes of some animals [n -S]\n",
  "EYESHINES": "EYESHINE, a reflection from the eyes of some animals [n]\n",
  "EYESHOT": "the range of the eye; as, to be out of eyeshot [n -S]\n",
  "EYESHOTS": "EYESHOT, the range of the eye; as, to be out of eyeshot [n]\n",
  "EYESIGHT": "the ability to see [n -S]\n",
  "EYESIGHTS": "EYESIGHT, the ability to see [n]\n",
  "EYESOME": "pleasant to look at [adj]\n",
  "EYESORE": "something unpleasant to look at [n -S]\n",
  "EYESORES": "EYESORE, something unpleasant to look at [n]\n",
  "EYESPOT": "a spot like an eye; any of several plant diseases causing eyelike spots [n -S]\n",
  "EYESPOTS": "EYESPOT, a spot like an eye; any of several plant diseases causing eyelike spots [n]\n",
  "EYESTALK": "a stalklike structure with an eye at its tip [n -S]\n",
  "EYESTALKS": "EYESTALK, a stalklike structure with an eye at its tip [n]\n",
  "EYESTONE": "a small, lenticular, calcareous body, esp. an operculum of a marine shell of the family Turbinidae, used to remove a foreign substance from the eye [n -S]\n",
  "EYESTONES": "EYESTONE, a small, lenticular, calcareous body, esp. an operculum of a marine shell of the family Turbinidae, used to remove a foreign substance from the eye [n]\n",
  "EYESTRAIN": "tiredness or irritation of the eyes [n -S]\n",
  "EYESTRAINS": "EYESTRAIN, tiredness or irritation of the eyes [n]\n",
  "EYESTRINGS": "(obsolete) organic eye attachments once believed to break at death or blindness [n]\n",
  "EYETEETH": "EYETOOTH, one of the canine teeth directly under or next to the eye, esp. in the upper jaw [n]\n",
  "EYETOOTH": "one of the canine teeth directly under or next to the eye, esp. in the upper jaw [n EYETEETH]\n",
  "EYEWASH": "an eye lotion [n -ES]\n",
  "EYEWASHES": "EYEWASH, an eye lotion [n]\n",
  "EYEWATER": "a wash or lotion for application to the eyes [n -S]\n",
  "EYEWATERS": "EYEWATER, a wash or lotion for application to the eyes [n]\n",
  "EYEWEAR": "corrective eye lenses [n -S]\n",
  "EYEWEARS": "EYEWEAR, corrective eye lenses [n]\n",
  "EYEWINK": "(Shakespeare) a wink of the eye [n -S]\n",
  "EYEWINKS": "EYEWINK, (Shakespeare) a wink of the eye [n]\n",
  "EYEWITNESS": "to testify from one's own seeing [v EYEWITNESSED, EYEWITNESSING, EYEWITNESSES]\n",
  "EYEWITNESSED": "EYEWITNESS, to testify from one's own seeing [v]\n",
  "EYEWITNESSES": "EYEWITNESS, to testify from one's own seeing [v]\n",
  "EYEWITNESSING": "EYEWITNESS, to testify from one's own seeing [v]\n",
  "EYING": "EYE, to watch closely [v]\n",
  "EYLIAD": "an amorous glance, also OEILLADE, ELIAD, EYELIAD, ILLIAD [n -S]\n",
  "EYLIADS": "EYLIAD, an amorous glance, also OEILLADE, ELIAD, EYELIAD, ILLIAD [n]\n",
  "EYNE": "EYE, the organ of sight [n]\n",
  "EYOT": "a small island, also AIT [n -S]\n",
  "EYOTS": "EYOT, a small island, also AIT [n]\n",
  "EYRA": "a South American wild cat, aka jaguarundi, jaguarondi [n -S]\n",
  "EYRAS": "EYRA, a South American wild cat, aka jaguarundi, jaguarondi [n]\n",
  "EYRE": "(historical) a journey in circuit of certain judges called justices in eyre [n -S]\n",
  "EYRES": "EYRE, (historical) a journey in circuit of certain judges called justices in eyre [n]\n",
  "EYRIE": "a bird of prey's nest, also AERIE, AERY, AIERY, AYRIE, EYRY [n -S]\n",
  "EYRIES": "EYRY, a bird of prey's nest, also AERIE, AERY, AIERY, AYRIE, EYRIE [n]\n",
  "EYRIR": "(Icelandic) a monetary unit of Iceland [n AURAR]\n",
  "EYRY": "a bird of prey's nest, also AERIE, AERY, AIERY, AYRIE, EYRIE [n EYRIES]\n",
  "EZINE": "a magazine available only in electronic form, for example on the internet [n -S]\n",
  "EZINES": "EZINE, a magazine available only in electronic form, for example on the internet [n]\n",
  "FA": "a musical note, also FAH [n -S]\n",
  "FAA": "(Scots) to fall [v FELL, FAAN, FAAING, FAAS]\n",
  "FAAING": "FAA, (Scots) to fall [v]\n",
  "FAAN": "FAA, (Scots) to fall [v]\n",
  "FAAS": "FAA, (Scots) to fall [v]\n",
  "FAB": "excellent [adj FABBER, FABBEST] / something fabricated [n -S]\n",
  "FABACEOUS": "beanlike [adj]\n",
  "FABBER": "FAB, excellent [adj]\n",
  "FABBEST": "FAB, excellent [adj]\n",
  "FABBIER": "FABBY, excellent, marvellous [adj]\n",
  "FABBIEST": "FABBY, excellent, marvellous [adj]\n",
  "FABBY": "excellent, marvellous [adj FABBIER, FABBIEST]\n",
  "FABLE": "to tell fictitious tales [v FABLED, FABLING, FABLES]\n",
  "FABLED": "FABLE, to tell fictitious tales [v]\n",
  "FABLER": "a writer of fables [n -S]\n",
  "FABLERS": "FABLER, a writer of fables [n]\n",
  "FABLES": "FABLE, to tell fictitious tales [v]\n",
  "FABLET": "a large smartphone that is able to perform many of the functions of a tablet computer, also PHABLET [n -S]\n",
  "FABLETS": "FABLET, a large smartphone that is able to perform many of the functions of a tablet computer, also PHABLET [n]\n",
  "FABLIAU": "(French) one of the metrical tales of the Trouveres, or early poets of the north of France [n FABLIAUX]\n",
  "FABLIAUX": "FABLIAU, (French) one of the metrical tales of the Trouveres, or early poets of the north of France [n]\n",
  "FABLING": "the telling of fables [n -S]\n",
  "FABLINGS": "FABLING, the telling of fables [n]\n",
  "FABRIC": "to construct [v FABRICKED, FABRICKING, FABRICS]\n",
  "FABRICANT": "(archaic) a manufacturer [n -S]\n",
  "FABRICANTS": "FABRICANT, (archaic) a manufacturer [n]\n",
  "FABRICATE": "to manufacture; to produce; to devise falsely [v FABRICATED, FABRICATING, FABRICATES]\n",
  "FABRICATED": "FABRICATE, to manufacture; to produce; to devise falsely [v]\n",
  "FABRICATES": "FABRICATE, to manufacture; to produce; to devise falsely [v]\n",
  "FABRICATING": "FABRICATE, to manufacture; to produce; to devise falsely [v]\n",
  "FABRICATION": "the act of fabricating [n -S]\n",
  "FABRICATIONS": "FABRICATION, the act of fabricating [n]\n",
  "FABRICATIVE": "relating to fabrication [adj]\n",
  "FABRICATOR": "one who fabricates [n -S]\n",
  "FABRICATORS": "FABRICATOR, one who fabricates [n]\n",
  "FABRICKED": "FABRIC, to construct [v]\n",
  "FABRICKING": "the act of fashioning [n -S]\n",
  "FABRICKINGS": "FABRICKING, the act of fashioning [n]\n",
  "FABRICS": "FABRIC, to construct [v]\n",
  "FABRIQUE": "a parish group that deals with church property [n -S]\n",
  "FABRIQUES": "FABRIQUE, a parish group that deals with church property [n]\n",
  "FABS": "FAB, something fabricated [n]\n",
  "FABULAR": "legendary [adj]\n",
  "FABULATE": "to compose fables [v FABULATED, FABULATING, FABULATES]\n",
  "FABULATED": "FABULATE, to compose fables [v]\n",
  "FABULATES": "FABULATE, to compose fables [v]\n",
  "FABULATING": "FABULATE, to compose fables [v]\n",
  "FABULATOR": "one who fabulates [n -S]\n",
  "FABULATORS": "FABULATOR, one who fabulates [n]\n",
  "FABULISE": "to write fables, also FABULIZE [v FABULISED, FABULISING, FABULISES]\n",
  "FABULISED": "FABULISE, to write fables, also FABULIZE [v]\n",
  "FABULISES": "FABULISE, to write fables, also FABULIZE [v]\n",
  "FABULISING": "FABULISE, to write fables, also FABULIZE [v]\n",
  "FABULISM": "the placing of fantastical elements into everyday settings [n -S]\n",
  "FABULISMS": "FABULISM, the placing of fantastical elements into everyday settings [n]\n",
  "FABULIST": "one who invents fables [n -S]\n",
  "FABULISTIC": "having the nature of a fable [adj]\n",
  "FABULISTS": "FABULIST, one who invents fables [n]\n",
  "FABULIZE": "to write fables, also FABULISE [v FABULIZED, FABULIZING, FABULIZES]\n",
  "FABULIZED": "FABULIZE, to write fables, also FABULISE [v]\n",
  "FABULIZES": "FABULIZE, to write fables, also FABULISE [v]\n",
  "FABULIZING": "FABULIZE, to write fables, also FABULISE [v]\n",
  "FABULOSITIES": "FABULOSITY, fabulousness [n]\n",
  "FABULOSITY": "fabulousness [n FABULOSITIES]\n",
  "FABULOUS": "amazing, excellent [adj FABULOUSLY]\n",
  "FABULOUSLY": "FABULOUS, amazing, excellent [adv]\n",
  "FABULOUSNESS": "the state of being fabulous [n -ES]\n",
  "FABULOUSNESSES": "FABULOUSNESS, the state of being fabulous [n]\n",
  "FABURDEN": "(obsolete) a type of improvised polyphony, popular in England from the 15th century to the Reformation, also FAUXBOURDON [n -S]\n",
  "FABURDENS": "FABURDEN, (obsolete) a type of improvised polyphony, popular in England from the 15th century to the Reformation, also FAUXBOURDON [n]\n",
  "FACADE": "(French) the front of a building [n -S]\n",
  "FACADES": "FACADE, (French) the front of a building [n]\n",
  "FACE": "to confront [v FACED, FACING, FACES]\n",
  "FACEABLE": "able to be faced [adj]\n",
  "FACEBAR": "a wrestling hold pulling on the opponent's facial skin [n -S]\n",
  "FACEBARS": "FACEBAR, a wrestling hold pulling on the opponent's facial skin [n]\n",
  "FACEBOOK": "to look for someone's profile on Facebook [v -ED, -ING, -S]\n",
  "FACEBOOKED": "FACEBOOK, to look for someone's profile on Facebook [v]\n",
  "FACEBOOKING": "FACEBOOK, to look for someone's profile on Facebook [v]\n",
  "FACEBOOKS": "FACEBOOK, to look for someone's profile on Facebook [v]\n",
  "FACECLOTH": "a cloth used in washing the face [n -S]\n",
  "FACECLOTHS": "FACECLOTH, a cloth used in washing the face [n]\n",
  "FACED": "FACE, to confront [v]\n",
  "FACEDOWN": "the act of confronting someone and forcing them to back down [n -S]\n",
  "FACEDOWNS": "FACEDOWN, the act of confronting someone and forcing them to back down [n]\n",
  "FACELESS": "lacking personal distinction or identity [adj]\n",
  "FACELESSNESS": "the state of being faceless [n -ES]\n",
  "FACELESSNESSES": "FACELESSNESS, the state of being faceless [n]\n",
  "FACELIFT": "to perform plastic surgery on the face [v -ED, -ING, -S]\n",
  "FACELIFTED": "FACELIFT, to perform plastic surgery on the face [v]\n",
  "FACELIFTING": "FACELIFT, to perform plastic surgery on the face [v]\n",
  "FACELIFTS": "FACELIFT, to perform plastic surgery on the face [v]\n",
  "FACEMAIL": "electronic mail delivered by a computer generated face [n -S]\n",
  "FACEMAILS": "FACEMAIL, electronic mail delivered by a computer generated face [n]\n",
  "FACEMAN": "a miner who works at the coalface [n FACEMEN]\n",
  "FACEMASK": "a device to shield the face [n -S]\n",
  "FACEMASKS": "FACEMASK, a device to shield the face [n]\n",
  "FACEMEN": "FACEMAN, a miner who works at the coalface [n]\n",
  "FACEOFF": "the action that starts a hockey game [n -S]\n",
  "FACEOFFS": "FACEOFF, the action that starts a hockey game [n]\n",
  "FACEPALM": "to bring the palm of one's hand to one's face as an expression of dismay [v -ED, -ING, -S]\n",
  "FACEPALMED": "FACEPALM, to bring the palm of one's hand to one's face as an expression of dismay [v]\n",
  "FACEPALMING": "FACEPALM, to bring the palm of one's hand to one's face as an expression of dismay [v]\n",
  "FACEPALMS": "FACEPALM, to bring the palm of one's hand to one's face as an expression of dismay [v]\n",
  "FACEPLANT": "to fall onto one\u0012s face [v -ED, -ING, -S]\n",
  "FACEPLANTED": "FACEPLANT, to fall onto one\u0012s face [v]\n",
  "FACEPLANTING": "FACEPLANT, to fall onto one\u0012s face [v]\n",
  "FACEPLANTS": "FACEPLANT, to fall onto one\u0012s face [v]\n",
  "FACEPLATE": "a flat transparent panel on the front of a protective helmet [n -S]\n",
  "FACEPLATES": "FACEPLATE, a flat transparent panel on the front of a protective helmet [n]\n",
  "FACEPRINT": "a digitally recorded representation of a person's face that can be used for security purposes [n -S]\n",
  "FACEPRINTS": "FACEPRINT, a digitally recorded representation of a person's face that can be used for security purposes [n]\n",
  "FACER": "a sudden difficulty [n -S]\n",
  "FACERS": "FACER, a sudden difficulty [n]\n",
  "FACES": "FACE, to confront [v]\n",
  "FACET": "to cut small plane surfaces on [v FACETED or FACETTED, FACETING or FACETTING, FACETS]\n",
  "FACETE": "(archaic) facetious [adj]\n",
  "FACETED": "FACET, to cut small plane surfaces on [v]\n",
  "FACETELY": "FACETE, (archaic) facetious [adv]\n",
  "FACETIAE": "(Latin) witty sayings or writings [n]\n",
  "FACETIME": "to communicate with (a person) using the FaceTime application [v FACETIMED, FACETIMING, FACETIMES]\n",
  "FACETIMED": "FACETIME, to communicate with (a person) using the FaceTime application [v]\n",
  "FACETIMES": "FACETIME, to communicate with (a person) using the FaceTime application [v]\n",
  "FACETIMING": "FACETIME, to communicate with (a person) using the FaceTime application [v]\n",
  "FACETING": "the act of cutting into facets [n -S]\n",
  "FACETINGS": "FACETING, the act of cutting into facets [n]\n",
  "FACETIOUS": "playfully jocular; humorous [adj FACETIOUSLY]\n",
  "FACETIOUSLY": "FACETIOUS, playfully jocular; humorous [adv]\n",
  "FACETIOUSNESS": "FACETIOUS, playfully jocular; humorous [n]\n",
  "FACETIOUSNESSES": "FACETIOUSNESS, FACETIOUS, playfully jocular; humorous [n]\n",
  "FACETS": "FACET, to cut small plane surfaces on [v]\n",
  "FACETTED": "FACET, to cut small plane surfaces on [v]\n",
  "FACETTING": "FACET, to cut small plane surfaces on [v]\n",
  "FACEUP": "with the front part up [adv]\n",
  "FACEWORKER": "a miner who works at the coalface, also FACEMAN [n -S]\n",
  "FACEWORKERS": "FACEWORKER, a miner who works at the coalface, also FACEMAN [n]\n",
  "FACIA": "an architectural band, also FASCIA [n FACIAS or FACIAE]\n",
  "FACIAE": "FACIA, an architectural band, also FASCIA [n]\n",
  "FACIAL": "relating to the face [adj FACIALLY] / a beauty treatment to the face [n -S]\n",
  "FACIALIST": "a beautician who specialises in facial treatments [n -S]\n",
  "FACIALISTS": "FACIALIST, a beautician who specialises in facial treatments [n]\n",
  "FACIALLY": "pertaining to the face [adv]\n",
  "FACIALS": "FACIAL, a beauty treatment to the face [n]\n",
  "FACIAS": "FACIA, an architectural band, also FASCIA [n]\n",
  "FACIEND": "(Latin) a number to be multiplied by another [n -S]\n",
  "FACIENDS": "FACIEND, (Latin) a number to be multiplied by another [n]\n",
  "FACIES": "(Latin) facial expression as a symptom; general aspect [n]\n",
  "FACILE": "(French) easily said, etc., but unthinkingly stupid [adj FACILELY]\n",
  "FACILELY": "FACILE, (French) easily said, etc., but unthinkingly stupid [adv]\n",
  "FACILENESS": "the state of being facile [n -ES]\n",
  "FACILENESSES": "FACILENESS, the state of being facile [n]\n",
  "FACILITATE": "to make easier [v FACILITATED, FACILITATING, FACILITATES]\n",
  "FACILITATED": "FACILITATE, to make easier [v]\n",
  "FACILITATES": "FACILITATE, to make easier [v]\n",
  "FACILITATING": "FACILITATE, to make easier [v]\n",
  "FACILITATION": "the act of facilitating [n -S]\n",
  "FACILITATIONS": "FACILITATION, the act of facilitating [n]\n",
  "FACILITATIVE": "serving to facilitate [adj]\n",
  "FACILITATOR": "one that facilitates [n -S]\n",
  "FACILITATORS": "FACILITATOR, one that facilitates [n]\n",
  "FACILITATORY": "inducing or involved in facilitation esp. of a reflex action [adj]\n",
  "FACILITIES": "FACILITY, ease in performance or action [n]\n",
  "FACILITY": "ease in performance or action [n FACILITIES]\n",
  "FACINERIOUS": "(Shakespeare) extremely wicked, also FACINOROUS [adj]\n",
  "FACING": "the lining at the edge of a garment [n -S]\n",
  "FACINGS": "FACING, the lining at the edge of a garment [n]\n",
  "FACINOROUS": "(archaic) extremely wicked, also FACINERIOUS [adj]\n",
  "FACINOROUSNESS": "FACINOROUS, (archaic) extremely wicked, also FACINERIOUS [n]\n",
  "FACONNE": "(French) a fabric with a pattern of small figures woven into it [n -S]\n",
  "FACONNES": "FACONNE, (French) a fabric with a pattern of small figures woven into it [n]\n",
  "FACSIMILE": "an exact copy [n -S] / to make a facsimile of [v FACSIMILED, FACSIMILEING, FACSIMILES]\n",
  "FACSIMILED": "FACSIMILE, to make a facsimile of [v]\n",
  "FACSIMILEING": "FACSIMILE, to make a facsimile of [v]\n",
  "FACSIMILES": "FACSIMILE, to make a facsimile of [v]\n",
  "FACSIMILIST": "one who makes facsimiles [n -S]\n",
  "FACSIMILISTS": "FACSIMILIST, one who makes facsimiles [n]\n",
  "FACT": "something known with certainty [n -S]\n",
  "FACTA": "FACTUM, (Latin) a man's own act and deed [n]\n",
  "FACTFUL": "full of fact [adj]\n",
  "FACTICE": "vulcanized oil, used as substitute for rubber, also FACTIS [n -S]\n",
  "FACTICES": "FACTICE, vulcanized oil, used as substitute for rubber, also FACTIS [n]\n",
  "FACTICITIES": "FACTICITY, the quality of being a fact [n]\n",
  "FACTICITY": "the quality of being a fact [n FACTICITIES]\n",
  "FACTION": "a clique within a larger group [n -S]\n",
  "FACTIONAL": "relating to factions [adj FACTIONALLY]\n",
  "FACTIONALISE": "to split into factions, also FACTIONALIZE [v FACTIONALISED, FACTIONALISING, FACTIONALISES]\n",
  "FACTIONALISED": "FACTIONALISE, to split into factions, also FACTIONALIZE [v]\n",
  "FACTIONALISES": "FACTIONALISE, to split into factions, also FACTIONALIZE [v]\n",
  "FACTIONALISING": "FACTIONALISE, to split into factions, also FACTIONALIZE [v]\n",
  "FACTIONALISM": "belonging to a faction [n -S]\n",
  "FACTIONALISMS": "FACTIONALISM, belonging to a faction [n]\n",
  "FACTIONALIST": "a supporter of factions [n -S]\n",
  "FACTIONALISTS": "FACTIONALIST, a supporter of factions [n]\n",
  "FACTIONALIZE": "to split into factions, also FACTIONALISE [v FACTIONALIZED, FACTIONALIZING, FACTIONALIZES]\n",
  "FACTIONALIZED": "FACTIONALIZE, to split into factions, also FACTIONALISE [v]\n",
  "FACTIONALIZES": "FACTIONALIZE, to split into factions, also FACTIONALISE [v]\n",
  "FACTIONALIZING": "FACTIONALIZE, to split into factions, also FACTIONALISE [v]\n",
  "FACTIONALLY": "FACTIONAL, relating to factions [adv]\n",
  "FACTIONARIES": "FACTIONARY, a member of a faction [n]\n",
  "FACTIONARY": "a member of a faction [n FACTIONARIES]\n",
  "FACTIONIST": "one who promotes faction [n -S]\n",
  "FACTIONISTS": "FACTIONIST, one who promotes faction [n]\n",
  "FACTIONS": "FACTION, a clique within a larger group [n]\n",
  "FACTIOUS": "inclined to form factions [adj FACTIOUSLY]\n",
  "FACTIOUSLY": "FACTIOUS, inclined to form factions [adv]\n",
  "FACTIOUSNESS": "the state of being factious [n -ES]\n",
  "FACTIOUSNESSES": "FACTIOUSNESS, the state of being factious [n]\n",
  "FACTIS": "(Latin) vulcanized oil, used as substitute for rubber, also FACTICE [n -ES]\n",
  "FACTISES": "FACTIS, (Latin) vulcanized oil, used as substitute for rubber, also FACTICE [n]\n",
  "FACTITIOUS": "contrived, artificial [adj FACTITIOUSLY]\n",
  "FACTITIOUSLY": "FACTITIOUS, contrived, artificial [adv]\n",
  "FACTITIOUSNESS": "FACTITIOUS, contrived, artificial [n]\n",
  "FACTITIVE": "causative; (of a verb) able to take both a direct object and a complement [adj FACTITIVELY]\n",
  "FACTITIVELY": "FACTITIVE, causative; (of a verb) able to take both a direct object and a complement [adv]\n",
  "FACTIVE": "of a linguistic context, giving rise to the presupposition that a sentence occurring in that context is true [adj]\n",
  "FACTOID": "a statement said so often that it is believed to be true [n -S]\n",
  "FACTOIDAL": "like a factoid [adj]\n",
  "FACTOIDS": "FACTOID, a statement said so often that it is believed to be true [n]\n",
  "FACTOR": "to express as a product of two or more quantities [v -ED, -ING, -S]\n",
  "FACTORABILITIES": "FACTORABILITY, the quality of being factorable [n]\n",
  "FACTORABILITY": "the quality of being factorable [n FACTORABILITIES]\n",
  "FACTORABLE": "that can be factored [adj]\n",
  "FACTORAGE": "the fees or commission of a factor [n -S]\n",
  "FACTORAGES": "FACTORAGE, the fees or commission of a factor [n]\n",
  "FACTORED": "FACTOR, to express as a product of two or more quantities [v]\n",
  "FACTORIAL": "relating to a factor [adj FACTORIALLY] / the product of a series of factors; specifically the product of an integer and all lower integers [n -S]\n",
  "FACTORIALLY": "FACTORIAL, relating to a factor [adv]\n",
  "FACTORIALS": "FACTORIAL, the product of a series of factors; specifically the product of an integer and all lower integers [n]\n",
  "FACTORIES": "FACTORY, a place where goods are manufactured [n]\n",
  "FACTORING": "the act of factoring [n -S]\n",
  "FACTORINGS": "FACTORING, the act of factoring [n]\n",
  "FACTORISATION": "the operation of resolving a quantity into factors, also FACTORIZATION [n -S]\n",
  "FACTORISATIONS": "FACTORISATION, the operation of resolving a quantity into factors, also FACTORIZATION [n]\n",
  "FACTORISE": "to reduce a number to its prime factors, also FACTORIZE [v FACTORISED, FACTORISING, FACTORISES]\n",
  "FACTORISED": "FACTORISE, to reduce a number to its prime factors, also FACTORIZE [v]\n",
  "FACTORISES": "FACTORISE, to reduce a number to its prime factors, also FACTORIZE [v]\n",
  "FACTORISING": "FACTORISE, to reduce a number to its prime factors, also FACTORIZE [v]\n",
  "FACTORIZATION": "the operation of resolving a quantity into factors, also FACTORISATION [n -S]\n",
  "FACTORIZATIONS": "FACTORIZATION, the operation of resolving a quantity into factors, also FACTORISATION [n]\n",
  "FACTORIZE": "to reduce a number to its prime factors, also FACTORISE [v FACTORIZED, FACTORIZING, FACTORIZES]\n",
  "FACTORIZED": "FACTORIZE, to reduce a number to its prime factors, also FACTORISE [v]\n",
  "FACTORIZES": "FACTORIZE, to reduce a number to its prime factors, also FACTORISE [v]\n",
  "FACTORIZING": "FACTORIZE, to reduce a number to its prime factors, also FACTORISE [v]\n",
  "FACTORS": "FACTOR, to express as a product of two or more quantities [v]\n",
  "FACTORSHIP": "the business of a factor [n -S]\n",
  "FACTORSHIPS": "FACTORSHIP, the business of a factor [n]\n",
  "FACTORY": "a place where goods are manufactured [n FACTORIES]\n",
  "FACTORYLIKE": "like a factory [adj]\n",
  "FACTOTUM": "(Latin) a person employed to do many kinds of work [n -S]\n",
  "FACTOTUMS": "FACTOTUM, (Latin) a person employed to do many kinds of work [n]\n",
  "FACTS": "FACT, something known with certainty [n]\n",
  "FACTSHEET": "a printed sheet containing information relating to items covered in a television or radio program [n -S]\n",
  "FACTSHEETS": "FACTSHEET, a printed sheet containing information relating to items covered in a television or radio program [n]\n",
  "FACTUAL": "actual, real [adj FACTUALLY]\n",
  "FACTUALISM": "the quality of being factual [n -S]\n",
  "FACTUALISMS": "FACTUALISM, the quality of being factual [n]\n",
  "FACTUALIST": "one who adheres to facts [n -S]\n",
  "FACTUALISTIC": "factual [adj]\n",
  "FACTUALISTS": "FACTUALIST, one who adheres to facts [n]\n",
  "FACTUALITIES": "FACTUALITY, the state of being factual [n]\n",
  "FACTUALITY": "the state of being factual [n FACTUALITIES]\n",
  "FACTUALLY": "FACTUAL, actual, real [adv]\n",
  "FACTUALNESS": "the state of being factual [n -ES]\n",
  "FACTUALNESSES": "FACTUALNESS, the state of being factual [n]\n",
  "FACTUM": "(Latin) a man's own act and deed [n FACTA or FACTUMS]\n",
  "FACTUMS": "FACTUM, (Latin) a man's own act and deed [n]\n",
  "FACTURE": "the quality of the execution of a painting; an artist's characteristic handling of the paint [n -S]\n",
  "FACTURES": "FACTURE, the quality of the execution of a painting; an artist's characteristic handling of the paint [n]\n",
  "FACULA": "(Latin) an unusually bright spot on the sun's surface [n FACULAE]\n",
  "FACULAE": "FACULA, (Latin) an unusually bright spot on the sun's surface [n]\n",
  "FACULAR": "of or pertaining to faculae, groups of small shining spots on the surface of the sun [adj]\n",
  "FACULTATIVE": "optional; incidental [adj FACULTATIVELY]\n",
  "FACULTATIVELY": "FACULTATIVE, optional; incidental [adv]\n",
  "FACULTIES": "FACULTY, an inherent power or ability [n]\n",
  "FACULTY": "an inherent power or ability [n FACULTIES]\n",
  "FACUNDITIES": "FACUNDITY, eloquence [n]\n",
  "FACUNDITY": "eloquence [n FACUNDITIES]\n",
  "FAD": "a hobby or interest that enjoys brief popularity [n -S]\n",
  "FADABLE": "capable of fading [adj]\n",
  "FADAISE": "(French) an obvious or silly remark [n -S]\n",
  "FADAISES": "FADAISE, (French) an obvious or silly remark [n]\n",
  "FADDIER": "FADDY, inclined to take up fads, also FADDISH [adj]\n",
  "FADDIEST": "FADDY, inclined to take up fads, also FADDISH [adj]\n",
  "FADDINESS": "fussiness about food [n -ES]\n",
  "FADDINESSES": "FADDINESS, fussiness about food [n]\n",
  "FADDISH": "inclined to take up fads, also FADDY [adj]\n",
  "FADDISHLY": "FADDISH, inclined to take up fads, also FADDY [adv]\n",
  "FADDISHNESS": "the state of being faddish [n -ES]\n",
  "FADDISHNESSES": "FADDISHNESS, the state of being faddish [n]\n",
  "FADDISM": "the taking up of fads [n -S]\n",
  "FADDISMS": "FADDISM, the taking up of fads [n]\n",
  "FADDIST": "a faddish person [n -S]\n",
  "FADDISTS": "FADDIST, a faddish person [n]\n",
  "FADDLE": "to trifle; to toy [v FADDLED, FADDLING, FADDLES]\n",
  "FADDLED": "FADDLE, to trifle; to toy [v]\n",
  "FADDLES": "FADDLE, to trifle; to toy [v]\n",
  "FADDLING": "FADDLE, to trifle; to toy [v]\n",
  "FADDY": "inclined to take up fads, also FADDISH [adj FADDIER, FADDIEST]\n",
  "FADE": "to lose colour or brightness [v FADED, FADING, FADES]\n",
  "FADEAWAY": "a type of pitch in baseball [n -S]\n",
  "FADEAWAYS": "FADEAWAY, a type of pitch in baseball [n]\n",
  "FADED": "FADE, to lose colour or brightness [v]\n",
  "FADEDLY": "FADED, FADE, to lose colour or brightness [adv]\n",
  "FADEDNESS": "the state of being faded [n -ES]\n",
  "FADEDNESSES": "FADEDNESS, the state of being faded [n]\n",
  "FADEIN": "a gradual increase in the brightness of an image [n -S]\n",
  "FADEINS": "FADEIN, a gradual increase in the brightness of an image [n]\n",
  "FADELESS": "not fading [adj FADELESSLY]\n",
  "FADELESSLY": "FADELESS, not fading [adv]\n",
  "FADEOUT": "a gradual disappearance of an image [n -S]\n",
  "FADEOUTS": "FADEOUT, a gradual disappearance of an image [n]\n",
  "FADER": "a sliding control as used e.g. on audio and lighting equipment to set levels of sound and light [n -S]\n",
  "FADERS": "FADER, a sliding control as used e.g. on audio and lighting equipment to set levels of sound and light [n]\n",
  "FADES": "FADE, to lose colour or brightness [v]\n",
  "FADEUR": "(French) dullness, insipidity [n -S]\n",
  "FADEURS": "FADEUR, (French) dullness, insipidity [n]\n",
  "FADGE": "(archaic) to agree, hit it off [v FADGED, FADGING, FADGES]\n",
  "FADGED": "FADGE, (archaic) to agree, hit it off [v]\n",
  "FADGES": "FADGE, (archaic) to agree, hit it off [v]\n",
  "FADGING": "FADGE, (archaic) to agree, hit it off [v]\n",
  "FADIER": "FADY, wearing away [adj]\n",
  "FADIEST": "FADY, wearing away [adj]\n",
  "FADING": "an Irish dance [n -S]\n",
  "FADINGS": "FADING, an Irish dance [n]\n",
  "FADLIKE": "like a fad [adj]\n",
  "FADO": "(Portuguese) a Portuguese folksong [n -S]\n",
  "FADOMETER": "an instrument used to determine the resistance to fading of a pigment or dye [n -S]\n",
  "FADOMETERS": "FADOMETER, an instrument used to determine the resistance to fading of a pigment or dye [n]\n",
  "FADOS": "FADO, (Portuguese) a Portuguese folksong [n]\n",
  "FADS": "FAD, a hobby or interest that enjoys brief popularity [n]\n",
  "FADY": "wearing away [adj FADIER, FADIEST]\n",
  "FAE": "(Scots) from [prep]\n",
  "FAECAL": "relating to faeces, also FECAL [adj]\n",
  "FAECES": "(Latin) bodily waste discharged through the anus, also FECES [n]\n",
  "FAENA": "(Spanish) a series of passes made by a matador in a bullfight [n -S]\n",
  "FAENAS": "FAENA, (Spanish) a series of passes made by a matador in a bullfight [n]\n",
  "FAERIE": "(archaic) the world of fairies, fairyland, also FAERY [n -S]\n",
  "FAERIES": "FAERIE, (archaic) the world of fairies, fairyland, also FAERY [n]\n",
  "FAERY": "(archaic) the world of fairies, fairyland, also FAERIE [n FAERIES]\n",
  "FAFF": "(colloquial) to mess around [v -ED, -ING, -S]\n",
  "FAFFED": "FAFF, (colloquial) to mess around [v]\n",
  "FAFFIER": "FAFFY, awkward and time-consuming to do or use [adj]\n",
  "FAFFIEST": "FAFFY, awkward and time-consuming to do or use [adj]\n",
  "FAFFING": "FAFF, (colloquial) to mess around [v]\n",
  "FAFFS": "FAFF, (colloquial) to mess around [v]\n",
  "FAFFY": "awkward and time-consuming to do or use [adj FAFFIER, FAFFIEST]\n",
  "FAG": "to make weary by hard work [v FAGGED, FAGGING, FAGS]\n",
  "FAGACEOUS": "belonging to the beech family of trees [adj]\n",
  "FAGGED": "FAG, to make weary by hard work [v]\n",
  "FAGGERIES": "FAGGERY, drudgery, fagging [n]\n",
  "FAGGERY": "drudgery, fagging [n FAGGERIES]\n",
  "FAGGIER": "FAGGY, (offensive slang) having the characteristics of a male homosexual, also FAGGOTY [adj]\n",
  "FAGGIEST": "FAGGY, (offensive slang) having the characteristics of a male homosexual, also FAGGOTY [adj]\n",
  "FAGGING": "the practice of a schoolboy doing menial tasks for another [n -S]\n",
  "FAGGINGS": "FAGGING, the practice of a schoolboy doing menial tasks for another [n]\n",
  "FAGGOT": "to bind together in a bundle, also FAGOT [v -ED, -ING, -S]\n",
  "FAGGOTED": "FAGGOT, to bind together in a bundle, also FAGOT [v]\n",
  "FAGGOTIER": "FAGGOTY, (slang) homosexual, also FAGGY [adj]\n",
  "FAGGOTIEST": "FAGGOTY, (slang) homosexual, also FAGGY [adj]\n",
  "FAGGOTING": "a kind of embroidery in which some of the cross-threads are drawn together in the middle, also FAGOTING [n -S]\n",
  "FAGGOTINGS": "FAGGOTING, a kind of embroidery in which some of the cross-threads are drawn together in the middle, also FAGOTING [n]\n",
  "FAGGOTRIES": "FAGGOTRY, (offensive slang) male homosexuality [n]\n",
  "FAGGOTRY": "(offensive slang) male homosexuality [n FAGGOTRIES]\n",
  "FAGGOTS": "FAGGOT, to bind together in a bundle, also FAGOT [v]\n",
  "FAGGOTY": "(slang) homosexual, also FAGGY [adj FAGGOTIER, FAGGOTIEST]\n",
  "FAGGY": "(offensive slang) having the characteristics of a male homosexual, also FAGGOTY [adj FAGGIER, FAGGIEST]\n",
  "FAGIN": "an adult who instructs others in crime [n -S]\n",
  "FAGINS": "FAGIN, an adult who instructs others in crime [n]\n",
  "FAGOT": "to bind together in a bundle, also FAGGOT [v -ED, -ING, -S]\n",
  "FAGOTED": "FAGOT, to bind together in a bundle, also FAGGOT [v]\n",
  "FAGOTER": "one who does fagoting, a kind of embroidery [n -S]\n",
  "FAGOTERS": "FAGOTER, one who does fagoting, a kind of embroidery [n]\n",
  "FAGOTING": "a kind of embroidery in which some of the cross-threads are drawn together in the middle, also FAGGOTING [n -S]\n",
  "FAGOTINGS": "FAGOTING, a kind of embroidery in which some of the cross-threads are drawn together in the middle, also FAGGOTING [n]\n",
  "FAGOTS": "FAGOT, to bind together in a bundle, also FAGGOT [v]\n",
  "FAGOTTI": "FAGOTTO, (Italian) a bassoon [n]\n",
  "FAGOTTIST": "a bassoon player [n -S]\n",
  "FAGOTTISTS": "FAGOTTIST, a bassoon player [n]\n",
  "FAGOTTO": "(Italian) a bassoon [n FAGOTTI or FAGOTTOS]\n",
  "FAGOTTOS": "FAGOTTO, (Italian) a bassoon [n]\n",
  "FAGS": "FAG, to make weary by hard work [v]\n",
  "FAH": "a musical note, also FA [n -S]\n",
  "FAHLBAND": "(German) in crystalline rocks, a stratum rich in metals [n -S]\n",
  "FAHLBANDS": "FAHLBAND, (German) in crystalline rocks, a stratum rich in metals [n]\n",
  "FAHLERZ": "(German) an ore of copper, also FAHLORE [n -ES]\n",
  "FAHLERZES": "FAHLERZ, (German) an ore of copper, also FAHLORE [n]\n",
  "FAHLORE": "(German) an ore of copper, also FAHLERZ [n -S]\n",
  "FAHLORES": "FAHLORE, (German) an ore of copper, also FAHLERZ [n]\n",
  "FAHS": "FAH, a musical note, also FA [n]\n",
  "FAIBLE": "(French) the part of a foil blade between the middle and the point, also FOIBLE [n -S]\n",
  "FAIBLES": "FAIBLE, (French) the part of a foil blade between the middle and the point, also FOIBLE [n]\n",
  "FAIENCE": "(French) a type of glazed pottery, also FAYENCE [n -S]\n",
  "FAIENCES": "FAIENCE, (French) a type of glazed pottery, also FAYENCE [n]\n",
  "FAIK": "(Scots) to abate [v -ED, -ING, -S]\n",
  "FAIKED": "FAIK, (Scots) to abate [v]\n",
  "FAIKES": "a kind of thin-bedded shaly or micaceous sandstone [n]\n",
  "FAIKING": "FAIK, (Scots) to abate [v]\n",
  "FAIKS": "FAIK, (Scots) to abate [v]\n",
  "FAIL": "to be unsuccessful in an attempt [v -ED, -ING, -S]\n",
  "FAILED": "FAIL, to be unsuccessful in an attempt [v]\n",
  "FAILING": "in a state of failure [adj FAILINGLY] / a weakness [n -S]\n",
  "FAILINGLY": "FAILING, in a state of failure [adv]\n",
  "FAILINGS": "FAILING, a weakness [n]\n",
  "FAILLE": "(French) a shiny closely woven silk, cotton or rayon fabric [n -S]\n",
  "FAILLES": "FAILLE, (French) a shiny closely woven silk, cotton or rayon fabric [n]\n",
  "FAILOVER": "a procedure by which a computer system automatically transfers control to a backup system on detecting a failure [n -S]\n",
  "FAILOVERS": "FAILOVER, a procedure by which a computer system automatically transfers control to a backup system on detecting a failure [n]\n",
  "FAILS": "FAIL, to be unsuccessful in an attempt [v]\n",
  "FAILURE": "the act of failing [n -S]\n",
  "FAILURES": "FAILURE, the act of failing [n]\n",
  "FAIN": "happy; inclined; pleased, also FAINE, FAYNE [adj FAINER, FAINEST, FAINLY] / (Spenser) to feign [v -ED, -ING, -S]\n",
  "FAINE": "(Spenser) to feign, also FAIN, FAYNE [v FAINED, FAINING, FAINES]\n",
  "FAINEANCE": "(French) doing nothing, being a mere puppet, also FAINEANCY [n -S]\n",
  "FAINEANCES": "FAINEANCE, (French) doing nothing, being a mere puppet, also FAINEANCY [n]\n",
  "FAINEANCIES": "FAINEANCY, doing nothing, being a mere puppet, also FAINEANCE [n]\n",
  "FAINEANCY": "doing nothing, being a mere puppet, also FAINEANCE [n FAINEANCIES]\n",
  "FAINEANT": "(French) a lazy person [n -S]\n",
  "FAINEANTISE": "(French) do-nothing-ness; an indisposition to do anything [n -S]\n",
  "FAINEANTISES": "FAINEANTISE, (French) do-nothing-ness; an indisposition to do anything [n]\n",
  "FAINEANTS": "FAINEANT, (French) a lazy person [n]\n",
  "FAINED": "FAIN, (Spenser) to feign [v]\n",
  "FAINER": "FAIN, happy; inclined; pleased, also FAINE, FAYNE [adj]\n",
  "FAINES": "FAINE, (Spenser) to feign, also FAIN, FAYNE [v]\n",
  "FAINEST": "FAIN, happy; inclined; pleased, also FAINE, FAYNE [adj]\n",
  "FAINING": "FAIN, (Spenser) to feign [v]\n",
  "FAINITES": "a plea for a truce [interj]\n",
  "FAINLY": "FAIN, happy; inclined; pleased, also FAINE, FAYNE [adv]\n",
  "FAINNE": "(Irish) a ring-shaped badge worn to show support for the Irish language [n -S]\n",
  "FAINNES": "FAINNE, (Irish) a ring-shaped badge worn to show support for the Irish language [n]\n",
  "FAINNESS": "eagerness [n -ES]\n",
  "FAINNESSES": "FAINNESS, eagerness [n]\n",
  "FAINS": "FAIN, (Spenser) to feign [v]\n",
  "FAINT": "to lose consciousness [v -ED, -ING, -S] / lacking strength [adj FAINTER, FAINTEST, FAINTLY]\n",
  "FAINTED": "FAINT, to lose consciousness [v]\n",
  "FAINTER": "one who faints [n -S]\n",
  "FAINTERS": "FAINTER, one who faints [n]\n",
  "FAINTEST": "FAINT, lacking strength [adj]\n",
  "FAINTHEARTED": "lacking courage or resolution [adj]\n",
  "FAINTHEARTEDLY": "FAINTHEARTED, lacking courage or resolution [adv]\n",
  "FAINTIER": "FAINTY, somewhat faint, also FAINTISH [adj]\n",
  "FAINTIEST": "FAINTY, somewhat faint, also FAINTISH [adj]\n",
  "FAINTING": "in a fainting state [adj FAINTINGLY] / the act of fainting [n -S]\n",
  "FAINTINGLY": "FAINTING, in a fainting state [adv]\n",
  "FAINTINGS": "FAINTING, the act of fainting [n]\n",
  "FAINTISH": "somewhat faint, also FAINTY [adj]\n",
  "FAINTISHNESS": "the state of being faintish [n -ES]\n",
  "FAINTISHNESSES": "FAINTISHNESS, the state of being faintish [n]\n",
  "FAINTLY": "FAINT, lacking strength [adv]\n",
  "FAINTNESS": "the state of being faint [n -ES]\n",
  "FAINTNESSES": "FAINTNESS, the state of being faint [n]\n",
  "FAINTS": "FAINT, to lose consciousness [v]\n",
  "FAINTY": "somewhat faint, also FAINTISH [adj FAINTIER, FAINTIEST]\n",
  "FAIR": "just; pleasant to look at [adj FAIRER, FAIREST, FAIRLY] / to make fair [v -ED, -ING, -S]\n",
  "FAIRED": "FAIR, to make fair [v]\n",
  "FAIRER": "FAIR, just; pleasant to look at [adj]\n",
  "FAIREST": "FAIR, just; pleasant to look at [adj]\n",
  "FAIRFACED": "of bricks, with a smooth unplastered surface [adj]\n",
  "FAIRGOER": "one who attends a fair [n -S]\n",
  "FAIRGOERS": "FAIRGOER, one who attends a fair [n]\n",
  "FAIRGROUND": "an area where outdoor fairs, circuses, or exhibitions are held [n -S]\n",
  "FAIRGROUNDS": "FAIRGROUND, an area where outdoor fairs, circuses, or exhibitions are held [n]\n",
  "FAIRIER": "FAIRY, of or like a fairy [adj]\n",
  "FAIRIES": "FAIRY, a creature of folklore, an imaginary being, generally of diminutive and graceful human form [n]\n",
  "FAIRIEST": "FAIRY, of or like a fairy [adj]\n",
  "FAIRILY": "FAIRY, of or like a fairy [adv]\n",
  "FAIRING": "a complimentary gift given at a fair [n -S]\n",
  "FAIRINGS": "FAIRING, a complimentary gift given at a fair [n]\n",
  "FAIRISH": "moderately good [adj]\n",
  "FAIRISHLY": "FAIRISH, moderately good [adv]\n",
  "FAIRLEAD": "a ring through which a rope is led to change its direction without friction, also FAIRLEADER [n -S]\n",
  "FAIRLEADER": "a ring through which a rope is led to change its direction without friction, also FAIRLEAD [n -S]\n",
  "FAIRLEADERS": "FAIRLEADER, a ring through which a rope is led to change its direction without friction, also FAIRLEAD [n]\n",
  "FAIRLEADS": "FAIRLEAD, a ring through which a rope is led to change its direction without friction, also FAIRLEADER [n]\n",
  "FAIRLY": "FAIR, just; pleasant to look at [adv]\n",
  "FAIRNESS": "the quality of being fair [n -ES]\n",
  "FAIRNESSES": "FAIRNESS, the quality of being fair [n]\n",
  "FAIRNITICKLE": "(Scots) a freckle, also FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FAIRNITICKLES": "FAIRNITICKLE, (Scots) a freckle, also FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FAIRNITICLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FAIRNITICLES": "FAIRNITICLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FAIRNYTICKLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FAIRNYTICKLES": "FAIRNYTICKLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FAIRNYTICLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FAIRNYTICLES": "FAIRNYTICLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FAIRS": "FAIR, to make fair [v]\n",
  "FAIRWAY": "the mown part of a golf course between tee and green [n -S]\n",
  "FAIRWAYS": "FAIRWAY, the mown part of a golf course between tee and green [n]\n",
  "FAIRY": "a creature of folklore, an imaginary being, generally of diminutive and graceful human form [n FAIRIES] / of or like a fairy [adj FAIRIER, FAIRIEST, FAIRILY]\n",
  "FAIRYDOM": "the world of fairies [n -S]\n",
  "FAIRYDOMS": "FAIRYDOM, the world of fairies [n]\n",
  "FAIRYFLOSS": "(Australian) candyfloss [n -ES]\n",
  "FAIRYFLOSSES": "FAIRYFLOSS, (Australian) candyfloss [n]\n",
  "FAIRYHOOD": "the state of being a fairy [n -S]\n",
  "FAIRYHOODS": "FAIRYHOOD, the state of being a fairy [n]\n",
  "FAIRYISM": "the quality of being like a fairy [n -S]\n",
  "FAIRYISMS": "FAIRYISM, the quality of being like a fairy [n]\n",
  "FAIRYLAND": "the land of the fairies [n -S]\n",
  "FAIRYLANDS": "FAIRYLAND, the land of the fairies [n]\n",
  "FAIRYLIKE": "like a fairy [adj]\n",
  "FAIRYTALE": "pertaining to a story about magical or mythological creatures [adj]\n",
  "FAITH": "to believe or trust [v -ED, -ING, -S]\n",
  "FAITHCURE": "a cure or healing through prayer or faith in God [n -S]\n",
  "FAITHCURES": "FAITHCURE, a cure or healing through prayer or faith in God [n]\n",
  "FAITHED": "FAITH, to believe or trust [v]\n",
  "FAITHER": "(Scots) father [n -S]\n",
  "FAITHERS": "FAITHER, (Scots) father [n]\n",
  "FAITHFUL": "loyal [adj FAITHFULLY] / one who is faithful [n -S]\n",
  "FAITHFULLY": "FAITHFUL, loyal [adv]\n",
  "FAITHFULNESS": "the state of being faithful [n -ES]\n",
  "FAITHFULNESSES": "FAITHFULNESS, the state of being faithful [n]\n",
  "FAITHFULS": "FAITHFUL, one who is faithful [n]\n",
  "FAITHING": "the act of believing [n -S]\n",
  "FAITHINGS": "FAITHING, the act of believing [n]\n",
  "FAITHLESS": "without faith [adj FAITHLESSLY]\n",
  "FAITHLESSLY": "FAITHLESS, without faith [adv]\n",
  "FAITHLESSNESS": "FAITHLESS, without faith [n]\n",
  "FAITHLESSNESSES": "FAITHLESSNESS, FAITHLESS, without faith [n]\n",
  "FAITHS": "FAITH, to believe or trust [v]\n",
  "FAITHWORTHIER": "FAITHWORTHY, worthy of faith or belief [adj]\n",
  "FAITHWORTHIEST": "FAITHWORTHY, worthy of faith or belief [adj]\n",
  "FAITHWORTHINESS": "the state of being faithworthy, worthy of faith or belief [n]\n",
  "FAITHWORTHY": "worthy of faith or belief [adj FAITHWORTHIER, FAITHWORTHIEST]\n",
  "FAITOR": "an imposter, also FAITOUR [n -S]\n",
  "FAITORS": "FAITOR, an imposter, also FAITOUR [n]\n",
  "FAITOUR": "an imposter, also FAITOR [n -S]\n",
  "FAITOURS": "FAITOUR, an imposter, also FAITOR [n]\n",
  "FAIX": "(dialect) faith [interj]\n",
  "FAJITA": "(Spanish) marinated or grilled beef or chicken, served hot, wrapped in flour tortillas [n -S]\n",
  "FAJITAS": "FAJITA, (Spanish) marinated or grilled beef or chicken, served hot, wrapped in flour tortillas [n]\n",
  "FAKE": "not genuine [adj FAKER, FAKEST] / to contrive and present as genuine [v FAKED, FAKING, FAKES]\n",
  "FAKED": "FAKE, to contrive and present as genuine [v]\n",
  "FAKEER": "(Arabic) a Hindu ascetic, also FAKIR, FAQIR, FAQUIR [n -S]\n",
  "FAKEERS": "FAKEER, (Arabic) a Hindu ascetic, also FAKIR, FAQIR, FAQUIR [n]\n",
  "FAKEMENT": "a sham, a dodge [n -S]\n",
  "FAKEMENTS": "FAKEMENT, a sham, a dodge [n]\n",
  "FAKER": "one who fakes e.g. works of art [n -S]\n",
  "FAKERIES": "FAKERY, the practice of faking [n]\n",
  "FAKERS": "FAKER, one who fakes e.g. works of art [n]\n",
  "FAKERY": "the practice of faking [n FAKERIES]\n",
  "FAKES": "FAKE, to contrive and present as genuine [v]\n",
  "FAKEST": "FAKE, not genuine [adj]\n",
  "FAKEY": "fake [adj FAKIER, FAKIEST] / a skateboarding position in which the skateboarder faces the opposite direction to that which they would normally, also FAKIE [n -S]\n",
  "FAKEYS": "FAKEY, a skateboarding position in which the skateboarder faces the opposite direction to that which they would normally, also FAKIE [n]\n",
  "FAKIE": "(in skateboarding and snowboarding) the movement or act of riding backwards, also FAKEY [n -S]\n",
  "FAKIER": "FAKEY, fake [adj]\n",
  "FAKIES": "FAKIE, (in skateboarding and snowboarding) the movement or act of riding backwards, also FAKEY [n]\n",
  "FAKIEST": "FAKEY, fake [adj]\n",
  "FAKING": "FAKE, to contrive and present as genuine [v]\n",
  "FAKIR": "(Arabic) a Hindu ascetic, also FAKEER, FAQIR, FAQUIR [n -S]\n",
  "FAKIRISM": "religious asceticism in India [n -S]\n",
  "FAKIRISMS": "FAKIRISM, religious asceticism in India [n]\n",
  "FAKIRS": "FAKIR, (Arabic) a Hindu ascetic, also FAKEER, FAQIR, FAQUIR [n]\n",
  "FALAFEL": "(Arabic) a fried patty of ground vegetables, also FELAFEL [n -S]\n",
  "FALAFELS": "FALAFEL, (Arabic) a fried patty of ground vegetables, also FELAFEL [n]\n",
  "FALAJ": "(Arabic) an irrigation channel, esp. in Oman [n AFLAJ]\n",
  "FALANGISM": "membership of the Spanish Fascist party [n -S]\n",
  "FALANGISMS": "FALANGISM, membership of the Spanish Fascist party [n]\n",
  "FALANGIST": "a member of the Spanish Fascist party [n -S]\n",
  "FALANGISTS": "FALANGIST, a member of the Spanish Fascist party [n]\n",
  "FALBALA": "a trimming for a woman's garment [n -S]\n",
  "FALBALAS": "FALBALA, a trimming for a woman's garment [n]\n",
  "FALCADE": "(French) a leaping motion of a horse [n -S]\n",
  "FALCADES": "FALCADE, (French) a leaping motion of a horse [n]\n",
  "FALCATE": "curved and tapering to a point, also FALCATED [adj]\n",
  "FALCATED": "curved and tapering to a point, also FALCATE [adj]\n",
  "FALCATION": "the state of being falcate, sickle-shaped [n -S]\n",
  "FALCATIONS": "FALCATION, the state of being falcate, sickle-shaped [n]\n",
  "FALCES": "FALX, (Latin) the sickle-shaped fold of the dura mater on the midline of the brain between the cerebral hemispheres [n]\n",
  "FALCHION": "a curved short sword with a broad blade, also FAUCHION, FAUCHON, FAULCHION [n -S]\n",
  "FALCHIONS": "FALCHION, a curved short sword with a broad blade, also FAUCHION, FAUCHON, FAULCHION [n]\n",
  "FALCIFORM": "shaped like a sickle [adj]\n",
  "FALCON": "any of various long-winged birds of prey of genus Falco [n -S]\n",
  "FALCONER": "one that hunts with hawks [n -S]\n",
  "FALCONERS": "FALCONER, one that hunts with hawks [n]\n",
  "FALCONET": "one of the smaller cannon used in the 15th century and later [n -S]\n",
  "FALCONETS": "FALCONET, one of the smaller cannon used in the 15th century and later [n]\n",
  "FALCONIFORM": "shaped like a falcon [adj]\n",
  "FALCONINE": "like a falcon or hawk; belonging to the Falconidae [adj]\n",
  "FALCONOID": "an antioxidant compound found in tea and thought to resist cancer [n -S]\n",
  "FALCONOIDS": "FALCONOID, an antioxidant compound found in tea and thought to resist cancer [n]\n",
  "FALCONRIES": "FALCONRY, the sport of hunting with falcons [n]\n",
  "FALCONRY": "the sport of hunting with falcons [n FALCONRIES]\n",
  "FALCONS": "FALCON, any of various long-winged birds of prey of genus Falco [n]\n",
  "FALCULA": "(Latin) a claw bent like a sickle [n FALCULAS or FALCULAE]\n",
  "FALCULAE": "FALCULA, (Latin) a claw bent like a sickle [n]\n",
  "FALCULAS": "FALCULA, (Latin) a claw bent like a sickle [n]\n",
  "FALCULATE": "curved and sharp-pointed, like a falcula, or claw of a falcon [adj]\n",
  "FALDAGE": "(historical) the right of the lord of a manor to graze a tenant's sheep in folds on his land, in order to manure it [n -S]\n",
  "FALDAGES": "FALDAGE, (historical) the right of the lord of a manor to graze a tenant's sheep in folds on his land, in order to manure it [n]\n",
  "FALDERAL": "to sing meaningless sounds, also FALDEROL, FOLDEROL [v -ED, -ING, -S]\n",
  "FALDERALED": "FALDERAL, to sing meaningless sounds, also FALDEROL, FOLDEROL [v]\n",
  "FALDERALING": "FALDERAL, to sing meaningless sounds, also FALDEROL, FOLDEROL [v]\n",
  "FALDERALS": "FALDERAL, to sing meaningless sounds, also FALDEROL, FOLDEROL [v]\n",
  "FALDEROL": "nonsense; a meaningless refrain of a song, also FALDERAL, FOLDEROL [n -S]\n",
  "FALDEROLS": "FALDEROL, nonsense; a meaningless refrain of a song, also FALDERAL, FOLDEROL [n]\n",
  "FALDETTA": "(Italian) a Maltese woman's combined hood and cape [n -S]\n",
  "FALDETTAS": "FALDETTA, (Italian) a Maltese woman's combined hood and cape [n]\n",
  "FALDISTORIES": "FALDISTORY, (obsolete) the throne or seat of a bishop within the chancel [n]\n",
  "FALDISTORY": "(obsolete) the throne or seat of a bishop within the chancel [n FALDISTORIES]\n",
  "FALDSTOOL": "a prayer desk from which the Litany is read at church service; a bishop's round armless chair [n -S]\n",
  "FALDSTOOLS": "FALDSTOOL, a prayer desk from which the Litany is read at church service; a bishop's round armless chair [n]\n",
  "FALL": "to descend freely by force of gravity [v FELL, FALLEN, FALLING, FALLS]\n",
  "FALLACIES": "FALLACY, delusion or error [n]\n",
  "FALLACIOUS": "embodying or pertaining to a fallacy [adj FALLACIOUSLY]\n",
  "FALLACIOUSLY": "FALLACIOUS, embodying or pertaining to a fallacy [adv]\n",
  "FALLACIOUSNESS": "FALLACIOUS, embodying or pertaining to a fallacy [n]\n",
  "FALLACY": "delusion or error [n FALLACIES]\n",
  "FALLAL": "a showy article of dress [n -S]\n",
  "FALLALERIES": "FALLALERY, foppishness [n]\n",
  "FALLALERY": "foppishness [n FALLALERIES]\n",
  "FALLALISH": "like a fallal, foppish [adj FALLALISHLY]\n",
  "FALLALISHLY": "FALLALISH, like a fallal, foppish [adv]\n",
  "FALLALS": "FALLAL, a showy article of dress [n]\n",
  "FALLAWAY": "a shot in basketball made while moving away from the basket [n -S]\n",
  "FALLAWAYS": "FALLAWAY, a shot in basketball made while moving away from the basket [n]\n",
  "FALLBACK": "a retreat, a contingency plan [n -S]\n",
  "FALLBACKS": "FALLBACK, a retreat, a contingency plan [n]\n",
  "FALLBOARD": "a cover for a piano keyboard [n -S]\n",
  "FALLBOARDS": "FALLBOARD, a cover for a piano keyboard [n]\n",
  "FALLEN": "FALL, to descend freely by force of gravity [v]\n",
  "FALLER": "one who falls [n -S]\n",
  "FALLERS": "FALLER, one who falls [n]\n",
  "FALLFISH": "a freshwater fish of the United States [n -ES]\n",
  "FALLFISHES": "FALLFISH, a freshwater fish of the United States [n]\n",
  "FALLIBILISM": "the doctrine that empirical knowledge is uncertain [n -S]\n",
  "FALLIBILISMS": "FALLIBILISM, the doctrine that empirical knowledge is uncertain [n]\n",
  "FALLIBILIST": "one who holds to the doctrine that empirical knowledge is uncertain [n -S]\n",
  "FALLIBILISTS": "FALLIBILIST, one who holds to the doctrine that empirical knowledge is uncertain [n]\n",
  "FALLIBILITIES": "FALLIBILITY, liability to err [n]\n",
  "FALLIBILITY": "liability to err [n FALLIBILITIES]\n",
  "FALLIBLE": "capable of erring [adj FALLIBLY]\n",
  "FALLIBLENESS": "the state of being fallible [n -ES]\n",
  "FALLIBLENESSES": "FALLIBLENESS, the state of being fallible [n]\n",
  "FALLIBLY": "FALLIBLE, capable of erring [adv]\n",
  "FALLING": "the act of falling [n -S]\n",
  "FALLINGS": "FALLING, the act of falling [n]\n",
  "FALLOFF": "a decline in quantity or quality [n -S]\n",
  "FALLOFFS": "FALLOFF, a decline in quantity or quality [n]\n",
  "FALLOUT": "radioactive debris [n -S]\n",
  "FALLOUTS": "FALLOUT, radioactive debris [n]\n",
  "FALLOW": "to plough and leave unseeded [v -ED, -ING, -S] / brownish-yellow [adj FALLOWER, FALLOWEST]\n",
  "FALLOWED": "FALLOW, to plough and leave unseeded [v]\n",
  "FALLOWER": "FALLOW, brownish-yellow [adj]\n",
  "FALLOWEST": "FALLOW, brownish-yellow [adj]\n",
  "FALLOWING": "FALLOW, to plough and leave unseeded [v]\n",
  "FALLOWNESS": "the state of being fallow [n -ES]\n",
  "FALLOWNESSES": "FALLOWNESS, the state of being fallow [n]\n",
  "FALLOWS": "FALLOW, to plough and leave unseeded [v]\n",
  "FALLS": "FALL, to descend freely by force of gravity [v]\n",
  "FALSE": "to deceive [v FALSED, FALSING, FALSES] / not genuine [adj FALSER, FALSEST, FALSELY]\n",
  "FALSED": "FALSE, to deceive [v]\n",
  "FALSEFACE": "a mask [n -S]\n",
  "FALSEFACES": "FALSEFACE, a mask [n]\n",
  "FALSEHOOD": "a lie [n -S]\n",
  "FALSEHOODS": "FALSEHOOD, a lie [n]\n",
  "FALSELY": "FALSE, not genuine [adv]\n",
  "FALSENESS": "the state of being false [n -ES]\n",
  "FALSENESSES": "FALSENESS, the state of being false [n]\n",
  "FALSER": "(obsolete) a falsifier, a counterfeiter [n -S]\n",
  "FALSERS": "FALSER, (obsolete) a falsifier, a counterfeiter [n]\n",
  "FALSES": "FALSE, to deceive [v]\n",
  "FALSEST": "FALSE, not genuine [adj]\n",
  "FALSETTO": "(Italian) an artificially high voice [n -S]\n",
  "FALSETTOS": "FALSETTO, (Italian) an artificially high voice [n]\n",
  "FALSEWORK": "a temporary framework used to support a building during construction [n -S]\n",
  "FALSEWORKS": "FALSEWORK, a temporary framework used to support a building during construction [n]\n",
  "FALSIDICAL": "conveying a meaning that is false [adj]\n",
  "FALSIE": "a pad worn within a brassiere [n -S]\n",
  "FALSIES": "FALSIE, a pad worn within a brassiere [n]\n",
  "FALSIFIABILITY": "the state of being falsifiable [n]\n",
  "FALSIFIABLE": "that can be falsified [adj]\n",
  "FALSIFICATION": "the act of falsifying [n -S]\n",
  "FALSIFICATIONS": "FALSIFICATION, the act of falsifying [n]\n",
  "FALSIFIED": "FALSIFY, to misrepresent [v]\n",
  "FALSIFIER": "one who falsifies [n -S]\n",
  "FALSIFIERS": "FALSIFIER, one who falsifies [n]\n",
  "FALSIFIES": "FALSIFY, to misrepresent [v]\n",
  "FALSIFY": "to misrepresent [v FALSIFIED, FALSIFYING, FALSIFIES]\n",
  "FALSIFYING": "FALSIFY, to misrepresent [v]\n",
  "FALSING": "FALSE, to deceive [v]\n",
  "FALSISH": "somewhat false [adj]\n",
  "FALSISM": "something which is obviously false [n -S]\n",
  "FALSISMS": "FALSISM, something which is obviously false [n]\n",
  "FALSITIES": "FALSITY, something false [n]\n",
  "FALSITY": "something false [n FALSITIES]\n",
  "FALTBOAT": "a collapsible boat of rubberized sailcloth, also FOLDBOAT [n -S]\n",
  "FALTBOATS": "FALTBOAT, a collapsible boat of rubberized sailcloth, also FOLDBOAT [n]\n",
  "FALTER": "to hesitate [v -ED, -ING, -S]\n",
  "FALTERED": "FALTER, to hesitate [v]\n",
  "FALTERER": "one who falters [n -S]\n",
  "FALTERERS": "FALTERER, one who falters [n]\n",
  "FALTERING": "hesitant [adj FALTERINGLY] / the act of faltering [n -S]\n",
  "FALTERINGLY": "FALTERING, hesitant [adv]\n",
  "FALTERINGS": "FALTERING, the act of faltering [n]\n",
  "FALTERS": "FALTER, to hesitate [v]\n",
  "FALX": "(Latin) the sickle-shaped fold of the dura mater on the midline of the brain between the cerebral hemispheres [n FALCES]\n",
  "FAME": "to make famous [v FAMED, FAMING, FAMES]\n",
  "FAMED": "FAME, to make famous [v]\n",
  "FAMELESS": "not famous [adj]\n",
  "FAMES": "FAME, to make famous [v]\n",
  "FAMILIAL": "characteristic of a family [adj]\n",
  "FAMILIAR": "well-known [adj FAMILIARLY] / a close friend or associate [n -S]\n",
  "FAMILIARISATION": "the act of familiarising, also FAMILIARIZATION [n]\n",
  "FAMILIARISE": "to make familiar, also FAMILIARIZE [v FAMILIARISED, FAMILIARISING, FAMILIARISES]\n",
  "FAMILIARISED": "FAMILIARISE, to make familiar, also FAMILIARIZE [v]\n",
  "FAMILIARISER": "one who familiarises, also FAMILIARIZER [n -S]\n",
  "FAMILIARISERS": "FAMILIARISER, one who familiarises, also FAMILIARIZER [n]\n",
  "FAMILIARISES": "FAMILIARISE, to make familiar, also FAMILIARIZE [v]\n",
  "FAMILIARISING": "FAMILIARISE, to make familiar, also FAMILIARIZE [v]\n",
  "FAMILIARITIES": "FAMILIARITY, the state of being familiar [n]\n",
  "FAMILIARITY": "the state of being familiar [n FAMILIARITIES]\n",
  "FAMILIARIZATION": "the act of familiarizing, also FAMILIARISATION [n]\n",
  "FAMILIARIZE": "to make familiar, also FAMILIARISE [v FAMILIARIZED, FAMILIARIZING, FAMILIARIZES]\n",
  "FAMILIARIZED": "FAMILIARIZE, to make familiar, also FAMILIARISE [v]\n",
  "FAMILIARIZER": "one who familiarizes, also FAMILIARISER [n -S]\n",
  "FAMILIARIZERS": "FAMILIARIZER, one who familiarizes, also FAMILIARISER [n]\n",
  "FAMILIARIZES": "FAMILIARIZE, to make familiar, also FAMILIARISE [v]\n",
  "FAMILIARIZING": "FAMILIARIZE, to make familiar, also FAMILIARISE [v]\n",
  "FAMILIARLY": "FAMILIAR, well-known [adv]\n",
  "FAMILIARNESS": "the state of being familiar [n -ES]\n",
  "FAMILIARNESSES": "FAMILIARNESS, the state of being familiar [n]\n",
  "FAMILIARS": "FAMILIAR, a close friend or associate [n]\n",
  "FAMILIES": "FAMILY, a group of persons related by blood or marriage [n]\n",
  "FAMILISM": "the tendency of a family to cohere as a group [n -S]\n",
  "FAMILISMS": "FAMILISM, the tendency of a family to cohere as a group [n]\n",
  "FAMILIST": "relating to familism, the tendency of a family to cohere as a group, also FAMILISTIC [adj]\n",
  "FAMILISTIC": "relating to familism, the tendency of a family to cohere as a group, also FAMILIST [adj]\n",
  "FAMILLE": "(French) a type of Chinese porcelain [n -S]\n",
  "FAMILLES": "FAMILLE, (French) a type of Chinese porcelain [n]\n",
  "FAMILY": "a group of persons related by blood or marriage [n FAMILIES]\n",
  "FAMINE": "extreme scarcity of food in a district [n -S]\n",
  "FAMINES": "FAMINE, extreme scarcity of food in a district [n]\n",
  "FAMING": "FAME, to make famous [v]\n",
  "FAMISH": "to suffer extreme hunger [v -ED, -ING, -ES]\n",
  "FAMISHED": "FAMISH, to suffer extreme hunger [v]\n",
  "FAMISHES": "FAMISH, to suffer extreme hunger [v]\n",
  "FAMISHING": "FAMISH, to suffer extreme hunger [v]\n",
  "FAMISHMENT": "the state of being famished [n -S]\n",
  "FAMISHMENTS": "FAMISHMENT, the state of being famished [n]\n",
  "FAMOUS": "renowned [adj FAMOUSLY] / (archaic) to make famous [v -ED, -ING, -ES]\n",
  "FAMOUSED": "FAMOUS, (archaic) to make famous [v]\n",
  "FAMOUSES": "FAMOUS, (archaic) to make famous [v]\n",
  "FAMOUSING": "FAMOUS, (archaic) to make famous [v]\n",
  "FAMOUSLY": "FAMOUS, renowned [adv]\n",
  "FAMOUSNESS": "the state of being famous [n -ES]\n",
  "FAMOUSNESSES": "FAMOUSNESS, the state of being famous [n]\n",
  "FAMULI": "FAMULUS, (Latin) an assistant, esp. to a magician or a scholar [n]\n",
  "FAMULUS": "(Latin) an assistant, esp. to a magician or a scholar [n FAMULI]\n",
  "FAN": "to cool with a device for circulating the air [v FANNED, FANNING, FANS]\n",
  "FANAL": "(archaic) a lighthouse, a beacon [n -S]\n",
  "FANALS": "FANAL, (archaic) a lighthouse, a beacon [n]\n",
  "FANATIC": "extravagantly or unreasonably zealous [adj FANATICALLY] / a zealot [n -S]\n",
  "FANATICAL": "extravagantly or unreasonably zealous [adj FANATICALLY]\n",
  "FANATICALLY": "FANATICAL, extravagantly or unreasonably zealous [adv]\n",
  "FANATICALNESS": "FANATICAL, extravagantly or unreasonably zealous [n]\n",
  "FANATICALNESSES": "FANATICALNESS, FANATICAL, extravagantly or unreasonably zealous [n]\n",
  "FANATICISATION": "the process of making fanatical, also FANATICIZATION [n -S]\n",
  "FANATICISATIONS": "FANATICISATION, the process of making fanatical, also FANATICIZATION [n]\n",
  "FANATICISE": "to make fanatical, also FANATICIZE [v FANATICISED, FANATICISING, FANATICISES]\n",
  "FANATICISED": "FANATICISE, to make fanatical, also FANATICIZE [v]\n",
  "FANATICISES": "FANATICISE, to make fanatical, also FANATICIZE [v]\n",
  "FANATICISING": "FANATICISE, to make fanatical, also FANATICIZE [v]\n",
  "FANATICISM": "fanatical outlook or behaviour [n -S]\n",
  "FANATICISMS": "FANATICISM, fanatical outlook or behaviour [n]\n",
  "FANATICIZATION": "the process of making fanatical, also FANATICISATION [n -S]\n",
  "FANATICIZATIONS": "FANATICIZATION, the process of making fanatical, also FANATICISATION [n]\n",
  "FANATICIZE": "to make fanatical, also FANATICISE [v FANATICIZED, FANATICIZING, FANATICIZES]\n",
  "FANATICIZED": "FANATICIZE, to make fanatical, also FANATICISE [v]\n",
  "FANATICIZES": "FANATICIZE, to make fanatical, also FANATICISE [v]\n",
  "FANATICIZING": "FANATICIZE, to make fanatical, also FANATICISE [v]\n",
  "FANATICS": "FANATIC, a zealot [n]\n",
  "FANBASE": "the body of fans of a celebrity [n -S]\n",
  "FANBASES": "FANBASE, the body of fans of a celebrity [n]\n",
  "FANBOY": "an obsessively enthusiastic fan of an element of popular culture, esp. comic books or films [n -S]\n",
  "FANBOYS": "FANBOY, an obsessively enthusiastic fan of an element of popular culture, esp. comic books or films [n]\n",
  "FANCIABLE": "attractive [adj]\n",
  "FANCIED": "FANCY, to take a liking to [v]\n",
  "FANCIER": "one that has a special liking for something [n -S]\n",
  "FANCIERS": "FANCIER, one that has a special liking for something [n]\n",
  "FANCIES": "FANCY, to take a liking to [v]\n",
  "FANCIEST": "FANCY, ornamental [adj]\n",
  "FANCIFIED": "FANCIFY, to make fancy [v]\n",
  "FANCIFIES": "FANCIFY, to make fancy [v]\n",
  "FANCIFUL": "indulging in fancies [adj FANCIFULLY]\n",
  "FANCIFULLY": "FANCIFUL, indulging in fancies [adv]\n",
  "FANCIFULNESS": "the state of being fanciful [n -ES]\n",
  "FANCIFULNESSES": "FANCIFULNESS, the state of being fanciful [n]\n",
  "FANCIFY": "to make fancy [v FANCIFIED, FANCIFYING, FANCIFIES]\n",
  "FANCIFYING": "FANCIFY, to make fancy [v]\n",
  "FANCILESS": "lacking in imagination [adj]\n",
  "FANCILY": "FANCY, ornamental [adv]\n",
  "FANCINESS": "the state of being fancy [n -ES]\n",
  "FANCINESSES": "FANCINESS, the state of being fancy [n]\n",
  "FANCY": "to take a liking to [v FANCIED, FANCYING, FANCIES] / ornamental [adj FANCIER, FANCIEST, FANCILY]\n",
  "FANCYING": "FANCY, to take a liking to [v]\n",
  "FANCYWORK": "ornamental needlework [n -S]\n",
  "FANCYWORKS": "FANCYWORK, ornamental needlework [n]\n",
  "FAND": "(Scots) to try or attempt [v -ED, -ING, -S]\n",
  "FANDABIDOZI": "an expression of admiration or enthusiasm [interj]\n",
  "FANDANGLE": "an elaborate ornament [n -S]\n",
  "FANDANGLES": "FANDANGLE, an elaborate ornament [n]\n",
  "FANDANGO": "(Spanish) a lively Spanish dance performed by a couple [n FANDANGOS or FANDANGOES]\n",
  "FANDANGOES": "FANDANGO, (Spanish) a lively Spanish dance performed by a couple [n]\n",
  "FANDANGOS": "FANDANGO, (Spanish) a lively Spanish dance performed by a couple [n]\n",
  "FANDED": "FAND, (Scots) to try or attempt [v]\n",
  "FANDING": "FAND, (Scots) to try or attempt [v]\n",
  "FANDOM": "an aggregate of enthusiastic devotees [n -S]\n",
  "FANDOMS": "FANDOM, an aggregate of enthusiastic devotees [n]\n",
  "FANDS": "FAND, (Scots) to try or attempt [v]\n",
  "FANE": "a temple [n -S]\n",
  "FANEGA": "(Spanish) a dry measure in Spain and Spanish America, also FANEGADA, FANGA [n -S]\n",
  "FANEGADA": "(Spanish) a dry measure in Spain and Spanish America, also FANEGA, FANGA [n -S]\n",
  "FANEGADAS": "FANEGADA, (Spanish) a dry measure in Spain and Spanish America, also FANEGA, FANGA [n]\n",
  "FANEGAS": "FANEGA, (Spanish) a dry measure in Spain and Spanish America, also FANEGADA, FANGA [n]\n",
  "FANES": "FANE, a temple [n]\n",
  "FANFARADE": "(French) a fanfare [n -S]\n",
  "FANFARADES": "FANFARADE, (French) a fanfare [n]\n",
  "FANFARE": "to herald with loud acclaim [v FANFARED, FANFARING, FANFARES]\n",
  "FANFARED": "FANFARE, to herald with loud acclaim [v]\n",
  "FANFARES": "FANFARE, to herald with loud acclaim [v]\n",
  "FANFARING": "FANFARE, to herald with loud acclaim [v]\n",
  "FANFARON": "(Spanish) an empty boaster [n -S]\n",
  "FANFARONA": "(Scott) a gold chain [n -S]\n",
  "FANFARONADE": "(French) empty boasting, bluster [n -S] / to bluster [v FANFARONADED, FANFARONADING, FANFARONADES]\n",
  "FANFARONADED": "FANFARONADE, to bluster [v]\n",
  "FANFARONADES": "FANFARONADE, (French) empty boasting, bluster [n]\n",
  "FANFARONADING": "FANFARONADE, to bluster [v]\n",
  "FANFARONAS": "FANFARONA, (Scott) a gold chain [n]\n",
  "FANFARONS": "FANFARON, (Spanish) an empty boaster [n]\n",
  "FANFIC": "(short for) fiction written around previously established characters invented by other authors [n -S]\n",
  "FANFICS": "FANFIC, (short for) fiction written around previously established characters invented by other authors [n]\n",
  "FANFOLD": "to fold paper like a fan [v -ED, -ING, -S]\n",
  "FANFOLDED": "FANFOLD, to fold paper like a fan [v]\n",
  "FANFOLDING": "FANFOLD, to fold paper like a fan [v]\n",
  "FANFOLDS": "FANFOLD, to fold paper like a fan [v]\n",
  "FANG": "to seize in the teeth, also PHANG [v -ED, -ING, -S]\n",
  "FANGA": "(Spanish) a dry measure in Spain and Spanish America, also FANEGA, FANEGADA [n -S]\n",
  "FANGAS": "FANGA, (Spanish) a dry measure in Spain and Spanish America, also FANEGA, FANEGADA [n]\n",
  "FANGED": "FANG, to seize in the teeth, also PHANG [v]\n",
  "FANGING": "FANG, to seize in the teeth, also PHANG [v]\n",
  "FANGIRL": "a female who is an enthusiastic devotee of something [n -S]\n",
  "FANGIRLS": "FANGIRL, a female who is an enthusiastic devotee of something [n]\n",
  "FANGLE": "to decorate fancily [v FANGLED, FANGLING, FANGLES]\n",
  "FANGLED": "FANGLE, to decorate fancily [v]\n",
  "FANGLES": "FANGLE, to decorate fancily [v]\n",
  "FANGLESS": "without fangs [adj]\n",
  "FANGLIKE": "like a fang [adj]\n",
  "FANGLING": "FANGLE, to decorate fancily [v]\n",
  "FANGO": "(Italian) clay or mud from thermal springs in Italy, used in curing gout [n -S]\n",
  "FANGOS": "FANGO, (Italian) clay or mud from thermal springs in Italy, used in curing gout [n]\n",
  "FANGS": "FANG, to seize in the teeth, also PHANG [v]\n",
  "FANION": "a small flag, esp. for surveying [n -S]\n",
  "FANIONS": "FANION, a small flag, esp. for surveying [n]\n",
  "FANJET": "a type of jet engine [n -S]\n",
  "FANJETS": "FANJET, a type of jet engine [n]\n",
  "FANK": "(Scots) to put sheep in a pen, to securely contain [v -ED, -ING, -S]\n",
  "FANKED": "FANK, (Scots) to put sheep in a pen, to securely contain [v]\n",
  "FANKING": "FANK, (Scots) to put sheep in a pen, to securely contain [v]\n",
  "FANKLE": "(Scots) to entangle [v FANKLED, FANKLING, FANKLES]\n",
  "FANKLED": "FANKLE, (Scots) to entangle [v]\n",
  "FANKLES": "FANKLE, (Scots) to entangle [v]\n",
  "FANKLING": "FANKLE, (Scots) to entangle [v]\n",
  "FANKS": "FANK, (Scots) to put sheep in a pen, to securely contain [v]\n",
  "FANLIGHT": "a half-circle window with crossbars arranged like ribs of fan [n -S]\n",
  "FANLIGHTS": "FANLIGHT, a half-circle window with crossbars arranged like ribs of fan [n]\n",
  "FANLIKE": "resembling a fan [adj]\n",
  "FANNED": "FAN, to cool with a device for circulating the air [v]\n",
  "FANNEL": "a strip of material worn on a priest's arm, also FANNELL [n -S]\n",
  "FANNELL": "a strip of material worn on a priest's arm, also FANNEL [n -S]\n",
  "FANNELLS": "FANNELL, a strip of material worn on a priest's arm, also FANNEL [n]\n",
  "FANNELS": "FANNEL, a strip of material worn on a priest's arm, also FANNELL [n]\n",
  "FANNER": "one who fans [n -S]\n",
  "FANNERS": "FANNER, one who fans [n]\n",
  "FANNIED": "FANNY, (vulgar) as in to fanny about, to procrastinate [v]\n",
  "FANNIES": "FANNY, (vulgar) as in to fanny about, to procrastinate [v]\n",
  "FANNING": "FAN, to cool with a device for circulating the air [v]\n",
  "FANNINGS": "material strained from tea [n]\n",
  "FANNY": "(vulgar) as in to fanny about, to procrastinate [v FANNIED, FANNYING, FANNIES]\n",
  "FANNYING": "FANNY, (vulgar) as in to fanny about, to procrastinate [v]\n",
  "FANO": "(Latin) a liturgical cape worn by the Pope when celebrating a solemn pontifical mass, also FANON, FANUM [n -S]\n",
  "FANON": "(Latin) a liturgical cape worn by the Pope when celebrating a solemn pontifical mass, also FANO, FANUM [n -S]\n",
  "FANONS": "FANON, (Latin) a liturgical cape worn by the Pope when celebrating a solemn pontifical mass, also FANO, FANUM [n]\n",
  "FANOS": "FANO, (Latin) a liturgical cape worn by the Pope when celebrating a solemn pontifical mass, also FANON, FANUM [n]\n",
  "FANS": "FAN, to cool with a device for circulating the air [v]\n",
  "FANSITE": "a website devoted to fans of a particular celebrity, TV programme, etc. [n -S]\n",
  "FANSITES": "FANSITE, a website devoted to fans of a particular celebrity, TV programme, etc. [n]\n",
  "FANSUB": "the subtitling of foreign, esp. animated, films by fans [n -S]\n",
  "FANSUBS": "FANSUB, the subtitling of foreign, esp. animated, films by fans [n]\n",
  "FANTABULOUS": "(slang) marvellously excellent [adj]\n",
  "FANTAD": "a fidgety state, also FANTOD [n -S]\n",
  "FANTADS": "FANTAD, a fidgety state, also FANTOD [n]\n",
  "FANTAIL": "a fan-shaped tail or end [n -S]\n",
  "FANTAILED": "having a fan-shaped tail [adj]\n",
  "FANTAILS": "FANTAIL, a fan-shaped tail or end [n]\n",
  "FANTASIA": "a musical or other composition not governed by the ordinary rules of form, also FANTASIE [n -S]\n",
  "FANTASIAS": "FANTASIA, a musical or other composition not governed by the ordinary rules of form, also FANTASIE [n]\n",
  "FANTASIE": "a free-form musical composition, also FANTASIA [n -S]\n",
  "FANTASIED": "FANTASY, to imagine, also PHANTASY [v]\n",
  "FANTASIES": "FANTASY, to imagine, also PHANTASY [v]\n",
  "FANTASISE": "to visualize in fantasy, also FANTASIZE [v FANTASISED, FANTASISING, FANTASISES]\n",
  "FANTASISED": "FANTASISE, to visualize in fantasy, also FANTASIZE [v]\n",
  "FANTASISER": "one who fantasises, also FANTASIZER [n -S]\n",
  "FANTASISERS": "FANTASISER, one who fantasises, also FANTASIZER [n]\n",
  "FANTASISES": "FANTASISE, to visualize in fantasy, also FANTASIZE [v]\n",
  "FANTASISING": "FANTASISE, to visualize in fantasy, also FANTASIZE [v]\n",
  "FANTASIST": "one who fantasises [n -S]\n",
  "FANTASISTS": "FANTASIST, one who fantasises [n]\n",
  "FANTASIZE": "to visualize in fantasy, also FANTASISE [v FANTASIZED, FANTASIZING, FANTASIZES]\n",
  "FANTASIZED": "FANTASIZE, to visualize in fantasy, also FANTASISE [v]\n",
  "FANTASIZER": "one who fantasises, also FANTASISER [n -S]\n",
  "FANTASIZERS": "FANTASIZER, one who fantasises, also FANTASISER [n]\n",
  "FANTASIZES": "FANTASIZE, to visualize in fantasy, also FANTASISE [v]\n",
  "FANTASIZING": "FANTASIZE, to visualize in fantasy, also FANTASISE [v]\n",
  "FANTASM": "a creation of the imagination [n -S]\n",
  "FANTASMAL": "like a fantasm, also FANTASMIC [adj FANTASMALLY]\n",
  "FANTASMALLY": "FANTASMAL, like a fantasm, also FANTASMIC [adv]\n",
  "FANTASMIC": "like a fantasm, also FANTASMAL [adj FANTASMICALLY]\n",
  "FANTASMICALLY": "FANTASMIC, like a fantasm, also FANTASMAL [adv]\n",
  "FANTASMS": "FANTASM, a creation of the imagination [n]\n",
  "FANTASQUE": "(obsolete) a fancy, a whim [n -S]\n",
  "FANTASQUES": "FANTASQUE, (obsolete) a fancy, a whim [n]\n",
  "FANTAST": "an impractical person, also PHANTAST [n -S]\n",
  "FANTASTIC": "unreal [adj FANTASTICALLY] / a person who has fanciful ideas or indulges in wild notions [n -S]\n",
  "FANTASTICAL": "unreal [adj FANTASTICALLY]\n",
  "FANTASTICALITY": "the state of being fantastical [n]\n",
  "FANTASTICALLY": "FANTASTICAL, unreal [adv]\n",
  "FANTASTICALNESS": "the state of being fantastical [n]\n",
  "FANTASTICATE": "to fantasize over something [v FANTASTICATED, FANTASTICATING, FANTASTICATES]\n",
  "FANTASTICATED": "FANTASTICATE, to fantasize over something [v]\n",
  "FANTASTICATES": "FANTASTICATE, to fantasize over something [v]\n",
  "FANTASTICATING": "FANTASTICATE, to fantasize over something [v]\n",
  "FANTASTICATION": "the act of fantasticating [n -S]\n",
  "FANTASTICATIONS": "FANTASTICATION, the act of fantasticating [n]\n",
  "FANTASTICISM": "being fantastic [n -S]\n",
  "FANTASTICISMS": "FANTASTICISM, being fantastic [n]\n",
  "FANTASTICO": "(Shakespeare) a dandy [n FANTASTICOES]\n",
  "FANTASTICOES": "FANTASTICO, (Shakespeare) a dandy [n]\n",
  "FANTASTICS": "FANTASTIC, a person who has fanciful ideas or indulges in wild notions [n]\n",
  "FANTASTRIES": "FANTASTRY, dandyism, also PHANTASTRY [n]\n",
  "FANTASTRY": "dandyism, also PHANTASTRY [n FANTASTRIES]\n",
  "FANTASTS": "FANTAST, an impractical person, also PHANTAST [n]\n",
  "FANTASY": "to imagine, also PHANTASY [v FANTASIED, FANTASYING, FANTASIES]\n",
  "FANTASYING": "FANTASY, to imagine, also PHANTASY [v]\n",
  "FANTASYLAND": "an imaginary or ideal place or situation [n -S]\n",
  "FANTASYLANDS": "FANTASYLAND, an imaginary or ideal place or situation [n]\n",
  "FANTEEG": "(slang) anxiety, agitation, also FANTIGUE [n -S]\n",
  "FANTEEGS": "FANTEEG, (slang) anxiety, agitation, also FANTIGUE [n]\n",
  "FANTIGUE": "anxiety, also FANTEEG [n -S]\n",
  "FANTIGUES": "FANTIGUE, anxiety, also FANTEEG [n]\n",
  "FANTOCCINI": "(Italian) mechanically worked puppets used in street theatre [n]\n",
  "FANTOD": "a fidgety state, also FANTAD [n -S]\n",
  "FANTODS": "FANTOD, a fidgety state, also FANTAD [n]\n",
  "FANTOM": "a phantom, something existing in appearance only [n -S]\n",
  "FANTOMS": "FANTOM, a phantom, something existing in appearance only [n]\n",
  "FANTOOSH": "(Scots) fashionable, pretentious [adj]\n",
  "FANUM": "(Latin) a cape worn by the pope, also FANO [n -S]\n",
  "FANUMS": "FANUM, (Latin) a cape worn by the pope, also FANO [n]\n",
  "FANWISE": "spread out like an open fan [adj]\n",
  "FANWORT": "an aquatic plant, aka cabomba [n -S]\n",
  "FANWORTS": "FANWORT, an aquatic plant, aka cabomba [n]\n",
  "FANZINE": "a magazine for fans [n -S]\n",
  "FANZINES": "FANZINE, a magazine for fans [n]\n",
  "FAP": "(Shakespeare) drunk or befuddled [adj]\n",
  "FAQIR": "(Arabic) a Hindu ascetic, also FAKEER, FAKIR, FAQUIR [n -S]\n",
  "FAQIRS": "FAQIR, (Arabic) a Hindu ascetic, also FAKEER, FAKIR, FAQUIR [n]\n",
  "FAQUIR": "(Arabic) a Hindu ascetic, also FAKEER, FAKIR, FAQIR [n -S]\n",
  "FAQUIRS": "FAQUIR, (Arabic) a Hindu ascetic, also FAKEER, FAKIR, FAQIR [n]\n",
  "FAR": "at a great distance [adj FARTHER or FURTHER, FARTHEST or FURTHEST] / to remove to a distance [v FARRED, FARRING, FARS]\n",
  "FARAD": "a unit of electrical capacitance [n -S]\n",
  "FARADAIC": "pertaining to a type of electric current, also FARADIC [adj]\n",
  "FARADAY": "a unit used in electrolysis [n -S]\n",
  "FARADAYS": "FARADAY, a unit used in electrolysis [n]\n",
  "FARADIC": "produced by or associated with electrical induction, also FARADAIC [adj]\n",
  "FARADISATION": "the act of faradising, also FARADIZATION [n -S]\n",
  "FARADISATIONS": "FARADISATION, the act of faradising, also FARADIZATION [n]\n",
  "FARADISE": "to treat by faradism, also FARADIZE [v FARADISED, FARADISING, FARADISES]\n",
  "FARADISED": "FARADISE, to treat by faradism, also FARADIZE [v]\n",
  "FARADISER": "one who faradises, stimulates by induced currents, also FARADIZER [n -S]\n",
  "FARADISERS": "FARADISER, one who faradises, stimulates by induced currents, also FARADIZER [n]\n",
  "FARADISES": "FARADISE, to treat by faradism, also FARADIZE [v]\n",
  "FARADISING": "FARADISE, to treat by faradism, also FARADIZE [v]\n",
  "FARADISM": "the use of faradic current for therapeutic purposes [n -S]\n",
  "FARADISMS": "FARADISM, the use of faradic current for therapeutic purposes [n]\n",
  "FARADIZATION": "the act of faradizing, also FARADISATION [n -S]\n",
  "FARADIZATIONS": "FARADIZATION, the act of faradizing, also FARADISATION [n]\n",
  "FARADIZE": "to treat by faradism, also FARADISE [v FARADIZED, FARADIZING, FARADIZES]\n",
  "FARADIZED": "FARADIZE, to treat by faradism, also FARADISE [v]\n",
  "FARADIZER": "one who faradises, stimulates by induced currents, also FARADISER [n -S]\n",
  "FARADIZERS": "FARADIZER, one who faradises, stimulates by induced currents, also FARADISER [n]\n",
  "FARADIZES": "FARADIZE, to treat by faradism, also FARADISE [v]\n",
  "FARADIZING": "FARADIZE, to treat by faradism, also FARADISE [v]\n",
  "FARADS": "FARAD, a unit of electrical capacitance [n]\n",
  "FARAND": "(Scots) having a certain manner or humour, also FARRAND, FARRANT [adj]\n",
  "FARANDINE": "(obsolete) a silk and wool cloth, also FARRANDINE, FERRANDINE [n -S]\n",
  "FARANDINES": "FARANDINE, (obsolete) a silk and wool cloth, also FARRANDINE, FERRANDINE [n]\n",
  "FARANDOLE": "(French) a lively Provencal dance in which men and women hold hands [n -S]\n",
  "FARANDOLES": "FARANDOLE, (French) a lively Provencal dance in which men and women hold hands [n]\n",
  "FARANG": "(Thai) a foreigner [n -S]\n",
  "FARANGS": "FARANG, (Thai) a foreigner [n]\n",
  "FARAWAY": "distant, abstracted [adj] / the distance [n -S]\n",
  "FARAWAYNESS": "the state of being faraway [n -ES]\n",
  "FARAWAYNESSES": "FARAWAYNESS, the state of being faraway [n]\n",
  "FARAWAYS": "FARAWAY, the distance [n]\n",
  "FARBOROUGH": "(Shakespeare) a mispronunciation of thirdborough, also THARBOROUGH [n -S]\n",
  "FARBOROUGHS": "FARBOROUGH, (Shakespeare) a mispronunciation of thirdborough, also THARBOROUGH [n]\n",
  "FARCE": "to fill with stuffing [v FARCED, FARCING, FARCES]\n",
  "FARCED": "FARCE, to fill with stuffing [v]\n",
  "FARCEMEAT": "meat chopped fine and highly seasoned, either served up alone, or used as a stuffing, also FORCEMEAT [n -S]\n",
  "FARCEMEATS": "FARCEMEAT, meat chopped fine and highly seasoned, either served up alone, or used as a stuffing, also FORCEMEAT [n]\n",
  "FARCER": "a performer in farces, also FARCEUR [n -S]\n",
  "FARCERS": "FARCER, a performer in farces, also FARCEUR [n]\n",
  "FARCES": "FARCE, to fill with stuffing [v]\n",
  "FARCEUR": "(French) a performer in farces, also FARCER [n -S]\n",
  "FARCEURS": "FARCEUR, (French) a performer in farces, also FARCER [n]\n",
  "FARCEUSE": "(French) a (female) writer of farces [n -S]\n",
  "FARCEUSES": "FARCEUSE, (French) a (female) writer of farces [n]\n",
  "FARCI": "(French) stuffed, as with ground meat, also FARCIE [adj]\n",
  "FARCICAL": "absurd [adj FARCICALLY]\n",
  "FARCICALITIES": "FARCICALITY, the state of being farcical [n]\n",
  "FARCICALITY": "the state of being farcical [n FARCICALITIES]\n",
  "FARCICALLY": "FARCICAL, absurd [adv]\n",
  "FARCICALNESS": "the state of being farcical [n -ES]\n",
  "FARCICALNESSES": "FARCICALNESS, the state of being farcical [n]\n",
  "FARCIE": "(French) stuffed, as with ground meat, also FARCI [adj]\n",
  "FARCIED": "afflicted with farcy, a disease of horses [adj]\n",
  "FARCIES": "FARCY, a chronic horse disease, also FARCIN [n]\n",
  "FARCIFIED": "FARCIFY, to turn into a farce [v]\n",
  "FARCIFIES": "FARCIFY, to turn into a farce [v]\n",
  "FARCIFY": "to turn into a farce [v FARCIFIED, FARCIFYING, FARCIFIES]\n",
  "FARCIFYING": "FARCIFY, to turn into a farce [v]\n",
  "FARCIN": "(obsolete) a disease of horses, also FARCY [n -S]\n",
  "FARCING": "in cookery, stuffing [n -S]\n",
  "FARCINGS": "FARCING, in cookery, stuffing [n]\n",
  "FARCINS": "FARCIN, (obsolete) a disease of horses, also FARCY [n]\n",
  "FARCY": "a chronic horse disease, also FARCIN [n FARCIES]\n",
  "FARD": "to paint with cosmetics [v -ED, -ING, -S]\n",
  "FARDAGE": "a bottom layer of wood to keep cargo from water [n -S]\n",
  "FARDAGES": "FARDAGE, a bottom layer of wood to keep cargo from water [n]\n",
  "FARDED": "FARD, to paint with cosmetics [v]\n",
  "FARDEL": "(obsolete) a burden [n -S]\n",
  "FARDELS": "FARDEL, (obsolete) a burden [n]\n",
  "FARDEN": "(dialect) a farthing, also FARDING [n -S]\n",
  "FARDENS": "FARDEN, (dialect) a farthing, also FARDING [n]\n",
  "FARDING": "a farthing [n -S]\n",
  "FARDINGS": "FARDING, a farthing [n]\n",
  "FARDS": "FARD, to paint with cosmetics [v]\n",
  "FARE": "to get on or succeed [v FARED, FARING, FARES]\n",
  "FAREBOX": "a receptacle for fares on a bus [n -ES]\n",
  "FAREBOXES": "FAREBOX, a receptacle for fares on a bus [n]\n",
  "FARED": "FARE, to get on or succeed [v]\n",
  "FARER": "a traveller [n -S]\n",
  "FARERS": "FARER, a traveller [n]\n",
  "FARES": "FARE, to get on or succeed [v]\n",
  "FAREWELL": "to say goodbye [v -ED, -ING, -S]\n",
  "FAREWELLED": "FAREWELL, to say goodbye [v]\n",
  "FAREWELLING": "FAREWELL, to say goodbye [v]\n",
  "FAREWELLS": "FAREWELL, to say goodbye [v]\n",
  "FARFAL": "(Yiddish) noodles in the form of small pellets or granules, also FARFEL [n -S]\n",
  "FARFALLE": "(Italian) pasta in the shape of bow ties or butterflies [n -S]\n",
  "FARFALLES": "FARFALLE, (Italian) pasta in the shape of bow ties or butterflies [n]\n",
  "FARFALS": "FARFAL, (Yiddish) noodles in the form of small pellets or granules, also FARFEL [n]\n",
  "FARFEL": "(Yiddish) noodles in the form of small pellets or granules, also FARFAL [n -S]\n",
  "FARFELS": "FARFEL, (Yiddish) noodles in the form of small pellets or granules, also FARFAL [n]\n",
  "FARFET": "far fetched [adj]\n",
  "FARFETCHEDNESS": "the state of being far-fetched [n]\n",
  "FARINA": "(Latin) a fine flour or meal made from cereal grains, also FARINHA [n -S]\n",
  "FARINACEOUS": "mealy; consisting of cereals [adj]\n",
  "FARINAS": "FARINA, (Latin) a fine flour or meal made from cereal grains, also FARINHA [n]\n",
  "FARING": "FARE, to get on or succeed [v]\n",
  "FARINHA": "(Latin) a fine flour or meal made from cereal grains, also FARINA [n -S]\n",
  "FARINHAS": "FARINHA, (Latin) a fine flour or meal made from cereal grains, also FARINA [n]\n",
  "FARINOSE": "resembling or yielding flour [adj FARINOSELY]\n",
  "FARINOSELY": "FARINOSE, resembling or yielding flour [adv]\n",
  "FARKLEBERRIES": "FARKLEBERRY, a shrub with hard, black berries [n]\n",
  "FARKLEBERRY": "a shrub with hard, black berries [n FARKLEBERRIES]\n",
  "FARL": "(Scots) an oatmeal cake, also FARLE, FARTHEL [n -S]\n",
  "FARLE": "(Scots) an oatmeal cake, also FARL, FARTHEL [n -S]\n",
  "FARLES": "FARLE, (Scots) an oatmeal cake, also FARL, FARTHEL [n]\n",
  "FARLS": "FARL, (Scots) an oatmeal cake, also FARLE, FARTHEL [n]\n",
  "FARM": "to practise the business of a farmer [v -ED, -ING, -S]\n",
  "FARMABLE": "able to be farmed [adj]\n",
  "FARMED": "FARM, to practise the business of a farmer [v]\n",
  "FARMER": "one who farms [n -S]\n",
  "FARMERESS": "a woman who farms [n -ES]\n",
  "FARMERESSES": "FARMERESS, a woman who farms [n]\n",
  "FARMERETTE": "a woman who is a farmer or a farmhand [n -S]\n",
  "FARMERETTES": "FARMERETTE, a woman who is a farmer or a farmhand [n]\n",
  "FARMERIES": "FARMERY, farm buildings [n]\n",
  "FARMERS": "FARMER, one who farms [n]\n",
  "FARMERY": "farm buildings [n FARMERIES]\n",
  "FARMHAND": "a farm laborer [n -S]\n",
  "FARMHANDS": "FARMHAND, a farm laborer [n]\n",
  "FARMHOUSE": "the farmer's house attached to a farm [n -S]\n",
  "FARMHOUSES": "FARMHOUSE, the farmer's house attached to a farm [n]\n",
  "FARMING": "the business of operating a farm [n -S]\n",
  "FARMINGS": "FARMING, the business of operating a farm [n]\n",
  "FARMLAND": "cultivated land [n -S]\n",
  "FARMLANDS": "FARMLAND, cultivated land [n]\n",
  "FARMOST": "most distant [adv]\n",
  "FARMS": "FARM, to practise the business of a farmer [v]\n",
  "FARMSTEAD": "a farmhouse with buildings belonging to it [n -S]\n",
  "FARMSTEADS": "FARMSTEAD, a farmhouse with buildings belonging to it [n]\n",
  "FARMWIFE": "the wife of a farmer [n FARMWIVES]\n",
  "FARMWIVES": "FARMWIFE, the wife of a farmer [n]\n",
  "FARMWORK": "the labor done on a farm [n -S]\n",
  "FARMWORKER": "one who works on a farm [n -S]\n",
  "FARMWORKERS": "FARMWORKER, one who works on a farm [n]\n",
  "FARMWORKS": "FARMWORK, the labor done on a farm [n]\n",
  "FARMYARD": "an area surrounding farm buildings [n -S]\n",
  "FARMYARDS": "FARMYARD, an area surrounding farm buildings [n]\n",
  "FARNARKEL": "(Australian slang) to waste time, mess about [v -ED, -ING, -S]\n",
  "FARNARKELED": "FARNARKEL, (Australian slang) to waste time, mess about [v]\n",
  "FARNARKELING": "wasting time, messing about [n -S]\n",
  "FARNARKELINGS": "FARNARKELING, wasting time, messing about [n]\n",
  "FARNARKELS": "FARNARKEL, (Australian slang) to waste time, mess about [v]\n",
  "FARNESOL": "(Italian) an alcohol found in various essential oils and used in perfumery [n -S]\n",
  "FARNESOLS": "FARNESOL, (Italian) an alcohol found in various essential oils and used in perfumery [n]\n",
  "FARNESS": "the state of being far away [n -ES]\n",
  "FARNESSES": "FARNESS, the state of being far away [n]\n",
  "FARO": "a card game [n -S]\n",
  "FAROLITO": "a paper lantern used by Hispanic people in Christmas processions [n -S]\n",
  "FAROLITOS": "FAROLITO, a paper lantern used by Hispanic people in Christmas processions [n]\n",
  "FAROS": "FARO, a card game [n]\n",
  "FAROUCHE": "(French) shy or ill at ease [adj]\n",
  "FARRAGINOUS": "like a farrago, miscellaneous, jumbled [adj]\n",
  "FARRAGO": "(Latin) a confused mixture [n -S or -ES]\n",
  "FARRAGOES": "FARRAGO, (Latin) a confused mixture [n]\n",
  "FARRAGOS": "FARRAGO, (Latin) a confused mixture [n]\n",
  "FARRAND": "(Scots) having a certain manner or humour, also FARAND, FARRANT [adj]\n",
  "FARRANDINE": "(obsolete) a silk and wool cloth, also FARANDINE, FERRANDINE [n -S]\n",
  "FARRANDINES": "FARRANDINE, (obsolete) a silk and wool cloth, also FARANDINE, FERRANDINE [n]\n",
  "FARRANT": "(Scots) having a certain manner or appearance, also FARAND, FARRAND [adj]\n",
  "FARRED": "FAR, to remove to a distance [v]\n",
  "FARREN": "a division of land [n -S]\n",
  "FARRENS": "FARREN, a division of land [n]\n",
  "FARRIER": "one who shoes horses [n -S]\n",
  "FARRIERIES": "FARRIERY, the trade of a farrier [n]\n",
  "FARRIERS": "FARRIER, one who shoes horses [n]\n",
  "FARRIERY": "the trade of a farrier [n FARRIERIES]\n",
  "FARRING": "FAR, to remove to a distance [v]\n",
  "FARRO": "a variety of wheat [n -S]\n",
  "FARROS": "FARRO, a variety of wheat [n]\n",
  "FARROW": "to give birth to a litter of pigs [v -ED, -ING, -S]\n",
  "FARROWED": "FARROW, to give birth to a litter of pigs [v]\n",
  "FARROWING": "the act of giving birth to piglets [n -S]\n",
  "FARROWINGS": "FARROWING, the act of giving birth to piglets [n]\n",
  "FARROWS": "FARROW, to give birth to a litter of pigs [v]\n",
  "FARRUCA": "(Spanish) a gypsy dance with sudden tempo and mood changes [n -S]\n",
  "FARRUCAS": "FARRUCA, (Spanish) a gypsy dance with sudden tempo and mood changes [n]\n",
  "FARS": "FAR, to remove to a distance [v]\n",
  "FARSE": "to expand a narrative by interpolation [v FARSED, FARSING, FARSES]\n",
  "FARSED": "FARSE, to expand a narrative by interpolation [v]\n",
  "FARSEEING": "seeing a long way [adj]\n",
  "FARSES": "FARSE, to expand a narrative by interpolation [v]\n",
  "FARSIDE": "the farther side [n -S]\n",
  "FARSIDES": "FARSIDE, the farther side [n]\n",
  "FARSIGHTED": "seeing or able to see to a great distance [adj FARSIGHTEDLY]\n",
  "FARSIGHTEDLY": "FARSIGHTED, seeing or able to see to a great distance [adv]\n",
  "FARSIGHTEDNESS": "the state of being farsighted [n]\n",
  "FARSING": "FARSE, to expand a narrative by interpolation [v]\n",
  "FART": "(vulgar) to expel gas through the anus [v -ED, -ING, -S]\n",
  "FARTED": "FART, (vulgar) to expel gas through the anus [v]\n",
  "FARTHEL": "(Scots) the quarter of a round cake of flour or oatmeal, also FARL, FARLE [n -S]\n",
  "FARTHELS": "FARTHEL, (Scots) the quarter of a round cake of flour or oatmeal, also FARL, FARLE [n]\n",
  "FARTHER": "to a greater distance, also FURTHER [adv]\n",
  "FARTHERMORE": "in addition, also FURTHERMORE [adv]\n",
  "FARTHERMOST": "most distant, also FURTHERMOST [adj]\n",
  "FARTHEST": "to the greatest distance, also FURTHEST [adv]\n",
  "FARTHING": "a former British coin, a quarter of a pre-decimal penny [n -S]\n",
  "FARTHINGALE": "a skirt spreader [n -S]\n",
  "FARTHINGALES": "FARTHINGALE, a skirt spreader [n]\n",
  "FARTHINGLAND": "a varying area of land [n -S]\n",
  "FARTHINGLANDS": "FARTHINGLAND, a varying area of land [n]\n",
  "FARTHINGLESS": "without a farthing [adj]\n",
  "FARTHINGS": "FARTHING, a former British coin, a quarter of a pre-decimal penny [n]\n",
  "FARTHINGSWORTH": "as much as a farthing will buy [n -S]\n",
  "FARTHINGSWORTHS": "FARTHINGSWORTH, as much as a farthing will buy [n]\n",
  "FARTING": "FART, (vulgar) to expel gas through the anus [v]\n",
  "FARTLEK": "(Swedish) a training technique, used esp. among runners, consisting of bursts of intense effort alternating with less strenuous activity [n -S]\n",
  "FARTLEKS": "FARTLEK, (Swedish) a training technique, used esp. among runners, consisting of bursts of intense effort alternating with less strenuous activity [n]\n",
  "FARTS": "FART, (vulgar) to expel gas through the anus [v]\n",
  "FAS": "FA, a musical note, also FAH [n]\n",
  "FASCES": "(Latin) an ancient Roman symbol of power [n FASCES]\n",
  "FASCI": "FASCIO, (Italian) an organized political group [n]\n",
  "FASCIA": "(Latin) an architectural band, also FACIA [n FASCIAS or FASCIAE]\n",
  "FASCIAE": "FASCIA, (Latin) an architectural band, also FACIA [n]\n",
  "FASCIAL": "of or like a fascia [adj]\n",
  "FASCIAS": "FASCIA, (Latin) an architectural band, also FACIA [n]\n",
  "FASCIATE": "exhibiting a flattened ribbonlike structure, also FASCIATED [adj]\n",
  "FASCIATED": "exhibiting a flattened ribbonlike structure, also FASCIATE [adj]\n",
  "FASCIATELY": "FASCIATE, exhibiting a flattened ribbonlike structure, also FASCIATED [adv]\n",
  "FASCIATION": "bandaging or becoming bound up [n -S]\n",
  "FASCIATIONS": "FASCIATION, bandaging or becoming bound up [n]\n",
  "FASCICLE": "a bundle; a division of book published in parts, also FASCICULE, FASCICULUS [n -S]\n",
  "FASCICLED": "arranged, growing, or occurring in a fascicle or fascicles [adj]\n",
  "FASCICLES": "FASCICLE, a bundle; a division of book published in parts, also FASCICULE, FASCICULUS [n]\n",
  "FASCICULAR": "in bundles, also FASCICULATE, FASCICULATED [adj FASCICULARLY]\n",
  "FASCICULARLY": "FASCICULAR, in bundles, also FASCICULATE, FASCICULATED [adv]\n",
  "FASCICULATE": "in bundles, also FASCICULAR, FASCICULATED [adj FASCICULATELY]\n",
  "FASCICULATED": "in bundles, also FASCICULAR, FASCICULATE [adj]\n",
  "FASCICULATELY": "FASCICULATE, in bundles, also FASCICULAR, FASCICULATED [adv]\n",
  "FASCICULATION": "muscular twitching involving the simultaneous contraction of contiguous groups of muscle fibers [n -S]\n",
  "FASCICULATIONS": "FASCICULATION, muscular twitching involving the simultaneous contraction of contiguous groups of muscle fibers [n]\n",
  "FASCICULE": "a bundle; a division of book published in parts, also FASCICLE, FASCICULUS [n -S]\n",
  "FASCICULES": "FASCICULE, a bundle; a division of book published in parts, also FASCICLE, FASCICULUS [n]\n",
  "FASCICULI": "FASCICULUS, (Latin) a little bundle; a fascicle, also FASCICLE, FASCICULE [n]\n",
  "FASCICULUS": "(Latin) a little bundle; a fascicle, also FASCICLE, FASCICULE [n FASCICULI]\n",
  "FASCIITIS": "inflammation of the fascia of a muscle, also FASCITIS [n -ES]\n",
  "FASCIITISES": "FASCIITIS, inflammation of the fascia of a muscle, also FASCITIS [n]\n",
  "FASCINATE": "to interest exceedingly, intrigue [v FASCINATED, FASCINATING, FASCINATES]\n",
  "FASCINATED": "FASCINATE, to interest exceedingly, intrigue [v]\n",
  "FASCINATEDLY": "FASCINATED, FASCINATE, to interest exceedingly, intrigue [adv]\n",
  "FASCINATES": "FASCINATE, to interest exceedingly, intrigue [v]\n",
  "FASCINATING": "intriguing [adj FASCINATINGLY]\n",
  "FASCINATINGLY": "FASCINATING, intriguing [adv]\n",
  "FASCINATION": "the quality of fascinating [n -S]\n",
  "FASCINATIONS": "FASCINATION, the quality of fascinating [n]\n",
  "FASCINATIVE": "related to fascination [adj]\n",
  "FASCINATOR": "a woman's light, soft, head-covering [n -S]\n",
  "FASCINATORS": "FASCINATOR, a woman's light, soft, head-covering [n]\n",
  "FASCINE": "a long faggot used for engineering purposes [n -S]\n",
  "FASCINES": "FASCINE, a long faggot used for engineering purposes [n]\n",
  "FASCIO": "(Italian) an organized political group [n FASCI]\n",
  "FASCIOLA": "(Latin) a band of colour, also FASCIOLE [n -S]\n",
  "FASCIOLAS": "FASCIOLA, (Latin) a band of colour, also FASCIOLE [n]\n",
  "FASCIOLE": "(Latin) a band of colour, also FASCIOLA [n -S]\n",
  "FASCIOLES": "FASCIOLE, (Latin) a band of colour, also FASCIOLA [n]\n",
  "FASCIOLIASES": "FASCIOLIASIS, nematode infestation [n]\n",
  "FASCIOLIASIS": "nematode infestation [n FASCIOLIASES]\n",
  "FASCIS": "(Latin) a bundle of rods with an axe used to symbolise authority [n FASCES]\n",
  "FASCISM": "an oppressive form of government, also FASCISMO [n -S]\n",
  "FASCISMI": "FASCISMO, (Italian) an oppressive form of government, also FASCISM [n]\n",
  "FASCISMO": "(Italian) an oppressive form of government, also FASCISM [n FASCISMI]\n",
  "FASCISMS": "FASCISM, an oppressive form of government, also FASCISMO [n]\n",
  "FASCIST": "a supporter of fascism, also FASCISTA [n -S]\n",
  "FASCISTA": "(Italian) a supporter of fascism, also FASCIST [n FASCISTI]\n",
  "FASCISTI": "FASCISTA, (Italian) a supporter of fascism, also FASCIST [n]\n",
  "FASCISTIC": "of or like a fascist [adj FASCISTICALLY]\n",
  "FASCISTICALLY": "FASCISTIC, of or like a fascist [adv]\n",
  "FASCISTS": "FASCIST, a supporter of fascism, also FASCISTA [n]\n",
  "FASCITIS": "inflammation of a connective tissue [n -ES]\n",
  "FASCITISES": "FASCITIS, inflammation of a connective tissue [n]\n",
  "FASH": "(Scots) to bother or annoy [v -ED, -ING, -ES]\n",
  "FASHED": "FASH, (Scots) to bother or annoy [v]\n",
  "FASHERIES": "FASHERY, annoyance [n]\n",
  "FASHERY": "annoyance [n FASHERIES]\n",
  "FASHES": "FASH, (Scots) to bother or annoy [v]\n",
  "FASHING": "FASH, (Scots) to bother or annoy [v]\n",
  "FASHION": "to give a particular shape or form to [v -ED, -ING, -S]\n",
  "FASHIONABILITY": "the state of being fashionable [n]\n",
  "FASHIONABLE": "according to fashion [adj FASHIONABLY] / a fashionable person [n -S]\n",
  "FASHIONABLENESS": "the state of being fashionable [n]\n",
  "FASHIONABLES": "FASHIONABLE, a fashionable person [n]\n",
  "FASHIONABLY": "FASHIONABLE, according to fashion [adv]\n",
  "FASHIONED": "FASHION, to give a particular shape or form to [v]\n",
  "FASHIONER": "one who fashions [n -S]\n",
  "FASHIONERS": "FASHIONER, one who fashions [n]\n",
  "FASHIONIER": "FASHIONY, fashionable [adj]\n",
  "FASHIONIEST": "FASHIONY, fashionable [adj]\n",
  "FASHIONING": "FASHION, to give a particular shape or form to [v]\n",
  "FASHIONIST": "a follower or setter of fashion, also FASHIONISTA [n -S]\n",
  "FASHIONISTA": "a follower or setter of fashion, also FASHIONIST [n -S]\n",
  "FASHIONISTAS": "FASHIONISTA, a follower or setter of fashion, also FASHIONIST [n]\n",
  "FASHIONISTS": "FASHIONIST, a follower or setter of fashion, also FASHIONISTA [n]\n",
  "FASHIONMONGER": "a fop [n -S]\n",
  "FASHIONMONGERS": "FASHIONMONGER, a fop [n]\n",
  "FASHIONMONGING": "(Shakespeare) behaving like a fop [adj]\n",
  "FASHIONS": "FASHION, to give a particular shape or form to [v]\n",
  "FASHIONY": "fashionable [adj FASHIONIER, FASHIONIEST]\n",
  "FASHIOUS": "troublesome [adj]\n",
  "FASHIOUSNESS": "the state of being fashious, troublesome [n -ES]\n",
  "FASHIOUSNESSES": "FASHIOUSNESS, the state of being fashious, troublesome [n]\n",
  "FAST": "to abstain from eating [v -ED, -ING, -S] / able to move quickly [adj FASTER, FASTEST, FASTLY]\n",
  "FASTBACK": "a type of automobile roof [n -S]\n",
  "FASTBACKS": "FASTBACK, a type of automobile roof [n]\n",
  "FASTBALL": "a type of pitch in baseball [n -S]\n",
  "FASTBALLER": "in baseball, one who delivers fastballs [n -S]\n",
  "FASTBALLERS": "FASTBALLER, in baseball, one who delivers fastballs [n]\n",
  "FASTBALLS": "FASTBALL, a type of pitch in baseball [n]\n",
  "FASTED": "FAST, to abstain from eating [v]\n",
  "FASTEN": "to secure [v -ED, -ING, -S]\n",
  "FASTENED": "FASTEN, to secure [v]\n",
  "FASTENER": "something that fastens [n -S]\n",
  "FASTENERS": "FASTENER, something that fastens [n]\n",
  "FASTENING": "something that secures [n -S]\n",
  "FASTENINGS": "FASTENING, something that secures [n]\n",
  "FASTENS": "FASTEN, to secure [v]\n",
  "FASTER": "one who fasts [n -S]\n",
  "FASTERS": "FASTER, one who fasts [n]\n",
  "FASTEST": "FAST, able to move quickly [adj]\n",
  "FASTI": "(Latin) those days among the ancient Romans on which it was lawful to transact legal or public business [n]\n",
  "FASTIDIOUS": "showing a meticulous or demanding attitude [adj FASTIDIOUSLY]\n",
  "FASTIDIOUSLY": "FASTIDIOUS, showing a meticulous or demanding attitude [adv]\n",
  "FASTIDIOUSNESS": "FASTIDIOUS, showing a meticulous or demanding attitude [n]\n",
  "FASTIE": "(Australian slang) a deceitful trick [n -S]\n",
  "FASTIES": "FASTIE, (Australian slang) a deceitful trick [n]\n",
  "FASTIGIATE": "pointed; conical, also FASTIGIATED [adj]\n",
  "FASTIGIATED": "pointed; conical, also FASTIGIATE [adj]\n",
  "FASTIGIUM": "(Latin) the apex of a building; a gable-end; a pediment [n -S]\n",
  "FASTIGIUMS": "FASTIGIUM, (Latin) the apex of a building; a gable-end; a pediment [n]\n",
  "FASTING": "abstaining from eating [n -S]\n",
  "FASTINGS": "FASTING, abstaining from eating [n]\n",
  "FASTISH": "somewhat fast [adj]\n",
  "FASTLY": "(Shakespeare) firmly [adv]\n",
  "FASTNESS": "the quality of being fast [n -ES]\n",
  "FASTNESSES": "FASTNESS, the quality of being fast [n]\n",
  "FASTS": "FAST, to abstain from eating [v]\n",
  "FASTUOUS": "(archaic) haughty, arrogant [adj]\n",
  "FAT": "to make plump [v FATTED, FATTING, FATS] / having an abundance of flesh [adj FATTER, FATTEST, FATLY]\n",
  "FATAL": "capable of causing death [adj FATALLY]\n",
  "FATALISM": "the doctrine that all events are predetermined [n -S]\n",
  "FATALISMS": "FATALISM, the doctrine that all events are predetermined [n]\n",
  "FATALIST": "a believer in fatalism [n -S]\n",
  "FATALISTIC": "related to fatalism [adj FATALISTICALLY]\n",
  "FATALISTICALLY": "FATALISTIC, related to fatalism [adv]\n",
  "FATALISTS": "FATALIST, a believer in fatalism [n]\n",
  "FATALITIES": "FATALITY, a person who has been killed in an accident [n]\n",
  "FATALITY": "a person who has been killed in an accident [n FATALITIES]\n",
  "FATALLY": "FATAL, capable of causing death [adv]\n",
  "FATALNESS": "the quality of being fatal [n -ES]\n",
  "FATALNESSES": "FATALNESS, the quality of being fatal [n]\n",
  "FATBACK": "a dried strip of fat from the back of a hog [n -S]\n",
  "FATBACKS": "FATBACK, a dried strip of fat from the back of a hog [n]\n",
  "FATBERG": "a large mass of fat and waste material in a sewerage system [n -S]\n",
  "FATBERGS": "FATBERG, a large mass of fat and waste material in a sewerage system [n]\n",
  "FATBIRD": "a wading bird [n -S]\n",
  "FATBIRDS": "FATBIRD, a wading bird [n]\n",
  "FATBRAINED": "(Shakespeare) stupid [adj]\n",
  "FATE": "to destine [v FATED, FATING, FATES]\n",
  "FATED": "FATE, to destine [v]\n",
  "FATEFUL": "critical, fraught with destiny [adj FATEFULLY]\n",
  "FATEFULLY": "FATEFUL, critical, fraught with destiny [adv]\n",
  "FATEFULNESS": "the state of being fateful [n -ES]\n",
  "FATEFULNESSES": "FATEFULNESS, the state of being fateful [n]\n",
  "FATES": "FATE, to destine [v]\n",
  "FATHEAD": "a dolt [n -S]\n",
  "FATHEADED": "stupid [adj FATHEADEDLY]\n",
  "FATHEADEDLY": "FATHEADED, stupid [adv]\n",
  "FATHEADEDNESS": "FATHEADED, stupid [n]\n",
  "FATHEADEDNESSES": "FATHEADEDNESS, FATHEADED, stupid [n]\n",
  "FATHEADS": "FATHEAD, a dolt [n]\n",
  "FATHER": "to be the male parent of [v -ED, -ING, -S]\n",
  "FATHERED": "FATHER, to be the male parent of [v]\n",
  "FATHERHOOD": "the state of being a father [n -S]\n",
  "FATHERHOODS": "FATHERHOOD, the state of being a father [n]\n",
  "FATHERING": "the male act of procreating [n -S]\n",
  "FATHERINGS": "FATHERING, the male act of procreating [n]\n",
  "FATHERLAND": "the native land or country of one's father or ancestors [n -S]\n",
  "FATHERLANDS": "FATHERLAND, the native land or country of one's father or ancestors [n]\n",
  "FATHERLESS": "without a father [adj]\n",
  "FATHERLESSNESS": "the state of being fatherless [n]\n",
  "FATHERLIER": "FATHERLY, like a father [adj]\n",
  "FATHERLIEST": "FATHERLY, like a father [adj]\n",
  "FATHERLIKE": "like a father [adj]\n",
  "FATHERLINESS": "the state of being fatherly [n -ES]\n",
  "FATHERLINESSES": "FATHERLINESS, the state of being fatherly [n]\n",
  "FATHERLY": "like a father [adj FATHERLIER, FATHERLIEST]\n",
  "FATHERS": "FATHER, to be the male parent of [v]\n",
  "FATHERSHIP": "the state of being a father [n -S]\n",
  "FATHERSHIPS": "FATHERSHIP, the state of being a father [n]\n",
  "FATHOM": "a measure of length, six feet [n -S] / to ascertain the depth of [v -ED, -ING, -S]\n",
  "FATHOMABLE": "that can be fathomed [adj]\n",
  "FATHOMED": "FATHOM, to ascertain the depth of [v]\n",
  "FATHOMER": "one who fathoms [n -S]\n",
  "FATHOMERS": "FATHOMER, one who fathoms [n]\n",
  "FATHOMETER": "an instrument for measuring underwater depth using sound [n -S]\n",
  "FATHOMETERS": "FATHOMETER, an instrument for measuring underwater depth using sound [n]\n",
  "FATHOMING": "FATHOM, to ascertain the depth of [v]\n",
  "FATHOMLESS": "incapable of being fathomed [adj FATHOMLESSLY]\n",
  "FATHOMLESSLY": "FATHOMLESS, incapable of being fathomed [adv]\n",
  "FATHOMLESSNESS": "FATHOMLESS, incapable of being fathomed [n]\n",
  "FATHOMS": "FATHOM, to ascertain the depth of [v]\n",
  "FATIDIC": "of or relating to prophesy, also FATIDICAL [adj FATIDICALLY]\n",
  "FATIDICAL": "of or relating to prophesy, also FATIDIC [adj FATIDICALLY]\n",
  "FATIDICALLY": "FATIDICAL, of or relating to prophesy, also FATIDIC [adv]\n",
  "FATIGABILITIES": "FATIGABILITY, the state of being fatigable, easily tired [n]\n",
  "FATIGABILITY": "the state of being fatigable, easily tired [n FATIGABILITIES]\n",
  "FATIGABLE": "easily tired, also FATIGUABLE [adj]\n",
  "FATIGABLENESS": "FATIGABLE, easily tired, also FATIGUABLE [n]\n",
  "FATIGABLENESSES": "FATIGABLENESS, FATIGABLE, easily tired, also FATIGUABLE [n]\n",
  "FATIGATE": "to weary, also FATIGUE [v FATIGATED, FATIGATING, FATIGATES]\n",
  "FATIGATED": "FATIGATE, to weary, also FATIGUE [v]\n",
  "FATIGATES": "FATIGATE, to weary, also FATIGUE [v]\n",
  "FATIGATING": "FATIGATE, to weary, also FATIGUE [v]\n",
  "FATIGUABLE": "easily tired, also FATIGABLE [adj]\n",
  "FATIGUABLENESS": "FATIGUABLE, easily tired, also FATIGABLE [n]\n",
  "FATIGUE": "to weary, also FATIGATE [v FATIGUED, FATIGUING, FATIGUES]\n",
  "FATIGUED": "FATIGUE, to weary, also FATIGATE [v]\n",
  "FATIGUELESS": "without fatigue [adj]\n",
  "FATIGUES": "FATIGUE, to weary, also FATIGATE [v]\n",
  "FATIGUING": "FATIGUE, to weary, also FATIGATE [v]\n",
  "FATIGUINGLY": "FATIGUING, FATIGUE, to weary, also FATIGATE [adv]\n",
  "FATING": "FATE, to destine [v]\n",
  "FATISCENCE": "the state of being fatiscent, having gaps [n -S]\n",
  "FATISCENCES": "FATISCENCE, the state of being fatiscent, having gaps [n]\n",
  "FATISCENT": "gaping with cracks [adj]\n",
  "FATLESS": "having no fat [adj]\n",
  "FATLIKE": "resembling fat [adj]\n",
  "FATLING": "a young animal fattened for slaughter [n -S]\n",
  "FATLINGS": "FATLING, a young animal fattened for slaughter [n]\n",
  "FATLY": "FAT, having an abundance of flesh [adv]\n",
  "FATNESS": "the state of being fat [n -ES]\n",
  "FATNESSES": "FATNESS, the state of being fat [n]\n",
  "FATS": "FAT, to make plump [v]\n",
  "FATSHEDERA": "an evergreen spreading shrub of the ivy family [n -S]\n",
  "FATSHEDERAS": "FATSHEDERA, an evergreen spreading shrub of the ivy family [n]\n",
  "FATSIA": "(Japanese) an evergreen spreading shrub of the ivy family [n -S]\n",
  "FATSIAS": "FATSIA, (Japanese) an evergreen spreading shrub of the ivy family [n]\n",
  "FATSO": "(offensive colloquial) a fat person [n -S or -ES]\n",
  "FATSOES": "FATSO, (offensive colloquial) a fat person [n]\n",
  "FATSOS": "FATSO, (offensive colloquial) a fat person [n]\n",
  "FATSTOCK": "livestock that is fat and ready for market [n -S]\n",
  "FATSTOCKS": "FATSTOCK, livestock that is fat and ready for market [n]\n",
  "FATTED": "FAT, to make plump [v]\n",
  "FATTEN": "to make fat [v -ED, -ING, -S]\n",
  "FATTENABLE": "capable of being fattened [adj]\n",
  "FATTENED": "FATTEN, to make fat [v]\n",
  "FATTENER": "one that fattens [n -S]\n",
  "FATTENERS": "FATTENER, one that fattens [n]\n",
  "FATTENING": "the act of making fat [n -S]\n",
  "FATTENINGS": "FATTENING, the act of making fat [n]\n",
  "FATTENS": "FATTEN, to make fat [v]\n",
  "FATTER": "FAT, having an abundance of flesh [adj]\n",
  "FATTEST": "FAT, having an abundance of flesh [adj]\n",
  "FATTIER": "FATTY, greasy or oily [adj]\n",
  "FATTIES": "FATTY, one that is fat [n]\n",
  "FATTIEST": "FATTY, greasy or oily [adj]\n",
  "FATTILY": "FATTY, greasy or oily [adv]\n",
  "FATTINESS": "the state of being fatty [n -ES]\n",
  "FATTINESSES": "FATTINESS, the state of being fatty [n]\n",
  "FATTING": "FAT, to make plump [v]\n",
  "FATTISH": "somewhat fat [adj]\n",
  "FATTISM": "discrimination against fat people [n -S]\n",
  "FATTISMS": "FATTISM, discrimination against fat people [n]\n",
  "FATTIST": "discriminating against fat people [adj] / someone who discriminates thus [n -S]\n",
  "FATTISTS": "FATTIST, someone who discriminates thus [n]\n",
  "FATTRELS": "(Scots) ends of ribbon [n]\n",
  "FATTY": "one that is fat [n FATTIES] / greasy or oily [adj FATTIER, FATTIEST, FATTILY]\n",
  "FATUITIES": "FATUITY, complacent stupidity [n]\n",
  "FATUITOUS": "stupid, fatuous, also FATUOUS [adj]\n",
  "FATUITY": "complacent stupidity [n FATUITIES]\n",
  "FATUOUS": "silly; purposeless, also FATUITOUS [adj FATUOUSLY]\n",
  "FATUOUSLY": "FATUOUS, silly; purposeless, also FATUITOUS [adv]\n",
  "FATUOUSNESS": "the state of being fatuous [n -ES]\n",
  "FATUOUSNESSES": "FATUOUSNESS, the state of being fatuous [n]\n",
  "FATWA": "(Arabic) an Islamic religious decree, also FATWAH, FETWA / to issue an Islamic religious decree, also FATWAH [v FATWAED, FATWAING, FATWAS]\n",
  "FATWAED": "FATWA, to issue an Islamic religious decree, also FATWAH [v]\n",
  "FATWAH": "(Arabic) to threaten death by religious decree, also FATWA, FETWA [v -ED, -ING, -S]\n",
  "FATWAHED": "FATWAH, (Arabic) to threaten death by religious decree, also FATWA, FETWA [v]\n",
  "FATWAHING": "FATWAH, (Arabic) to threaten death by religious decree, also FATWA, FETWA [v]\n",
  "FATWAHS": "FATWAH, (Arabic) to threaten death by religious decree, also FATWA, FETWA [v]\n",
  "FATWAING": "FATWA, to issue an Islamic religious decree, also FATWAH [v]\n",
  "FATWAS": "FATWA, to issue an Islamic religious decree, also FATWAH [v]\n",
  "FATWOOD": "wood used for kindling [n -S]\n",
  "FATWOODS": "FATWOOD, wood used for kindling [n]\n",
  "FAUBOURG": "(French) a suburb just beyond the walls or a district recently included within a city [n -S]\n",
  "FAUBOURGS": "FAUBOURG, (French) a suburb just beyond the walls or a district recently included within a city [n]\n",
  "FAUCAL": "a sound produced in the passage from the mouth [n -S]\n",
  "FAUCALS": "FAUCAL, a sound produced in the passage from the mouth [n]\n",
  "FAUCES": "(Latin) the passage from the mouth to the pharynx [n]\n",
  "FAUCET": "a pipe inserted in a barrel to draw off liquid; (US) a tap [n -S]\n",
  "FAUCETRIES": "FAUCETRY, an array of faucets [n]\n",
  "FAUCETRY": "an array of faucets [n FAUCETRIES]\n",
  "FAUCETS": "FAUCET, a pipe inserted in a barrel to draw off liquid; (US) a tap [n]\n",
  "FAUCHION": "a curved short sword with a broad blade, also FALCHION, FAUCHON, FAULCHION [n -S]\n",
  "FAUCHIONS": "FAUCHION, a curved short sword with a broad blade, also FALCHION, FAUCHON, FAULCHION [n]\n",
  "FAUCHON": "a curved short sword with a broad blade, also FALCHION, FAUCHION, FAULCHION [n -S]\n",
  "FAUCHONS": "FAUCHON, a curved short sword with a broad blade, also FALCHION, FAUCHION, FAULCHION [n]\n",
  "FAUCIAL": "pertaining to the fauces [adj]\n",
  "FAUGH": "used to express disgust [interj]\n",
  "FAULCHION": "a curved short sword with a broad blade, also FALCHION, FAUCHION, FAUCHON [n -S]\n",
  "FAULCHIONS": "FAULCHION, a curved short sword with a broad blade, also FALCHION, FAUCHION, FAUCHON [n]\n",
  "FAULD": "the arch over the dam of a blast furnace [n -S]\n",
  "FAULDS": "FAULD, the arch over the dam of a blast furnace [n]\n",
  "FAULT": "to criticize [v -ED, -ING, -S]\n",
  "FAULTED": "FAULT, to criticize [v]\n",
  "FAULTFINDER": "one given to faultfinding [n -S]\n",
  "FAULTFINDERS": "FAULTFINDER, one given to faultfinding [n]\n",
  "FAULTFINDING": "the act of finding fault [n -S]\n",
  "FAULTFINDINGS": "FAULTFINDING, the act of finding fault [n]\n",
  "FAULTFUL": "(Shakespeare) full of faults or sins [adj]\n",
  "FAULTIER": "FAULTY, imperfect [adj]\n",
  "FAULTIEST": "FAULTY, imperfect [adj]\n",
  "FAULTILY": "FAULTY, imperfect [adv]\n",
  "FAULTINESS": "the state of being faulty [n -ES]\n",
  "FAULTINESSES": "FAULTINESS, the state of being faulty [n]\n",
  "FAULTING": "FAULT, to criticize [v]\n",
  "FAULTLESS": "without fault [adj FAULTLESSLY]\n",
  "FAULTLESSLY": "FAULTLESS, without fault [adv]\n",
  "FAULTLESSNESS": "FAULTLESS, without fault [n]\n",
  "FAULTLESSNESSES": "FAULTLESSNESS, FAULTLESS, without fault [n]\n",
  "FAULTLINE": "a surface along which faults have occurred, or are likely to occur [n -S]\n",
  "FAULTLINES": "FAULTLINE, a surface along which faults have occurred, or are likely to occur [n]\n",
  "FAULTS": "FAULT, to criticize [v]\n",
  "FAULTY": "imperfect [adj FAULTIER, FAULTIEST, FAULTILY]\n",
  "FAUN": "a rural deity represented as a man with a goat's ears, horns, tail, and hind legs [n -S]\n",
  "FAUNA": "(Latin) the animal life of a particular region [n FAUNAS or FAUNAE]\n",
  "FAUNAE": "FAUNA, (Latin) the animal life of a particular region [n]\n",
  "FAUNAL": "relating to fauna, the animal life of a region [adj FAUNALLY]\n",
  "FAUNALLY": "FAUNAL, relating to fauna, the animal life of a region [adv]\n",
  "FAUNAS": "FAUNA, (Latin) the animal life of a particular region [n]\n",
  "FAUNIST": "one who describes the fauna of a country [n -S]\n",
  "FAUNISTIC": "relating to fauna [adj FAUNISTICALLY]\n",
  "FAUNISTICALLY": "FAUNISTIC, relating to fauna [adv]\n",
  "FAUNISTS": "FAUNIST, one who describes the fauna of a country [n]\n",
  "FAUNLIKE": "like a faun [adj]\n",
  "FAUNS": "FAUN, a rural deity represented as a man with a goat's ears, horns, tail, and hind legs [n]\n",
  "FAUNULA": "the fauna of a small single environment, also FAUNULE [n FAUNULAE]\n",
  "FAUNULAE": "FAUNULA, the fauna of a small single environment, also FAUNULE [n]\n",
  "FAUNULE": "the fauna of a small single environment, also FAUNULA [n -S]\n",
  "FAUNULES": "FAUNULE, the fauna of a small single environment, also FAUNULA [n]\n",
  "FAUR": "(Scots) far [adj FAURER, FAUREST]\n",
  "FAURD": "(Scots) favoured [adj]\n",
  "FAURER": "FAUR, (Scots) far [adj]\n",
  "FAUREST": "FAUR, (Scots) far [adj]\n",
  "FAUSTIAN": "in the manner of Faust [adj]\n",
  "FAUT": "(Scots) to fault [v -ED, -ING, -S]\n",
  "FAUTED": "FAUT, (Scots) to fault [v]\n",
  "FAUTEUIL": "(French) an enclosed seat in theatre [n -S]\n",
  "FAUTEUILS": "FAUTEUIL, (French) an enclosed seat in theatre [n]\n",
  "FAUTING": "FAUT, (Scots) to fault [v]\n",
  "FAUTOR": "a favorer, a patron [n -S]\n",
  "FAUTORS": "FAUTOR, a favorer, a patron [n]\n",
  "FAUTS": "FAUT, (Scots) to fault [v]\n",
  "FAUVE": "(French) a member of a group of expressionist painters, also FAUVIST [n -S]\n",
  "FAUVES": "FAUVE, (French) a member of a group of expressionist painters, also FAUVIST [n]\n",
  "FAUVETTE": "(French) a small singing bird, as the nightingale and warblers [n -S]\n",
  "FAUVETTES": "FAUVETTE, (French) a small singing bird, as the nightingale and warblers [n]\n",
  "FAUVISM": "(French) a school of art noted for bold, often distorted forms and vivid colors [n -S]\n",
  "FAUVISMS": "FAUVISM, (French) a school of art noted for bold, often distorted forms and vivid colors [n]\n",
  "FAUVIST": "a member of a group of expressionist painters, also FAUVE [n -S]\n",
  "FAUVISTS": "FAUVIST, a member of a group of expressionist painters, also FAUVE [n]\n",
  "FAUX": "(French) fake, as in faux naif, falsely simple or naive, feigning artlessness [adj]\n",
  "FAUXBOURDON": "(French) a type of improvised polyphony, popular in England from the 15th century to the Reformation, also FABURDEN [n -S]\n",
  "FAUXBOURDONS": "FAUXBOURDON, (French) a type of improvised polyphony, popular in England from the 15th century to the Reformation, also FABURDEN [n]\n",
  "FAUXMANCE": "(colloquial) a fake romance between two celebrities in order to gain press coverage [n -S]\n",
  "FAUXMANCES": "FAUXMANCE, (colloquial) a fake romance between two celebrities in order to gain press coverage [n]\n",
  "FAVA": "(Italian) a broad bean [n -S]\n",
  "FAVAS": "FAVA, (Italian) a broad bean [n]\n",
  "FAVE": "(slang) favourite [adj FAVER, FAVEST] / a favourite person or thing [n -S]\n",
  "FAVEL": "(obsolete) light-brown, chestnut [adj] / a horse of this colour, also FAVELL [n -S]\n",
  "FAVELA": "(Portuguese) a slum area, also FAVELLA [n -S]\n",
  "FAVELAS": "FAVELA, (Portuguese) a slum area, also FAVELLA [n]\n",
  "FAVELL": "(obsolete) light brown, also FAVEL [adj]\n",
  "FAVELLA": "(Portuguese) a slum area, also FAVELA [n -S]\n",
  "FAVELLAS": "FAVELLA, (Portuguese) a slum area, also FAVELA [n]\n",
  "FAVELS": "FAVEL, a horse of this colour, also FAVELL [n]\n",
  "FAVEOLATE": "honeycombed [adj]\n",
  "FAVER": "FAVE, (slang) favourite [adj]\n",
  "FAVES": "FAVE, a favourite person or thing [n]\n",
  "FAVEST": "FAVE, (slang) favourite [adj]\n",
  "FAVICON": "a 16 x 16 pixel square icon associated with a particular website or webpage [n -S]\n",
  "FAVICONS": "FAVICON, a 16 x 16 pixel square icon associated with a particular website or webpage [n]\n",
  "FAVISM": "an acute type of anaemia in which haemolysis is precipitated by contact with broad beans [n -S]\n",
  "FAVISMS": "FAVISM, an acute type of anaemia in which haemolysis is precipitated by contact with broad beans [n]\n",
  "FAVONIAN": "of or relating to the west wind; mild and favourable [adj]\n",
  "FAVOR": "to regard with goodwill, also FAVOUR [v -ED, -ING, -S]\n",
  "FAVORABLE": "(US) favourable, also FAVOURABLE [adj FAVORABLY]\n",
  "FAVORABLENESS": "FAVORABLE, (US) favourable, also FAVOURABLE [n]\n",
  "FAVORABLENESSES": "FAVORABLENESS, FAVORABLE, (US) favourable, also FAVOURABLE [n]\n",
  "FAVORABLY": "FAVORABLE, (US) favourable, also FAVOURABLE [adv]\n",
  "FAVORED": "FAVOR, to regard with goodwill, also FAVOUR [v]\n",
  "FAVOREDNESS": "the state of being favored [n -ES]\n",
  "FAVOREDNESSES": "FAVOREDNESS, the state of being favored [n]\n",
  "FAVORER": "one that favors, also FAVOURER [n -S]\n",
  "FAVORERS": "FAVORER, one that favors, also FAVOURER [n]\n",
  "FAVORING": "FAVOR, to regard with goodwill, also FAVOUR [v]\n",
  "FAVORINGLY": "FAVORING, FAVOR, to regard with goodwill, also FAVOUR [adv]\n",
  "FAVORITE": "(US) favourite, a person or thing preferred [n -S]\n",
  "FAVORITES": "FAVORITE, (US) favourite, a person or thing preferred [n]\n",
  "FAVORITISM": "the showing of special favor [n -S]\n",
  "FAVORITISMS": "FAVORITISM, the showing of special favor [n]\n",
  "FAVORLESS": "(US) without favor, also FAVOURLESS [adj]\n",
  "FAVORS": "FAVOR, to regard with goodwill, also FAVOUR [v]\n",
  "FAVOSE": "honeycombed [adj]\n",
  "FAVOUR": "to regard with goodwill, also FAVOR [v -ED, -ING, -S]\n",
  "FAVOURABLE": "conducive to, also FAVORABLE [adj FAVOURABLY]\n",
  "FAVOURABLENESS": "FAVOURABLE, conducive to, also FAVORABLE [n]\n",
  "FAVOURABLY": "FAVOURABLE, conducive to, also FAVORABLE [adv]\n",
  "FAVOURED": "FAVOUR, to regard with goodwill, also FAVOR [v]\n",
  "FAVOUREDNESS": "the state of being favoured [n -ES]\n",
  "FAVOUREDNESSES": "FAVOUREDNESS, the state of being favoured [n]\n",
  "FAVOURER": "one that favors, also FAVORER [n -S]\n",
  "FAVOURERS": "FAVOURER, one that favors, also FAVORER [n]\n",
  "FAVOURING": "FAVOUR, to regard with goodwill, also FAVOR [v]\n",
  "FAVOURINGLY": "FAVOURING, FAVOUR, to regard with goodwill, also FAVOR [adv]\n",
  "FAVOURITE": "a person or thing regarded with special preference, also FAVORITE [n -S]\n",
  "FAVOURITES": "FAVOURITE, a person or thing regarded with special preference, also FAVORITE [n]\n",
  "FAVOURITISM": "the state of having favourites [n -S]\n",
  "FAVOURITISMS": "FAVOURITISM, the state of having favourites [n]\n",
  "FAVOURLESS": "without favour, also FAVORLESS [adj]\n",
  "FAVOURS": "FAVOUR, to regard with goodwill, also FAVOR [v]\n",
  "FAVOUS": "like a honeycomb [adj]\n",
  "FAVRILE": "a type of iridescent glassware developed in America at the turn of the 20th century by L. C. Tiffany [n -S]\n",
  "FAVRILES": "FAVRILE, a type of iridescent glassware developed in America at the turn of the 20th century by L. C. Tiffany [n]\n",
  "FAVUS": "(Latin) a fungal skin disease, chiefly of the scalp [n -ES]\n",
  "FAVUSES": "FAVUS, (Latin) a fungal skin disease, chiefly of the scalp [n]\n",
  "FAW": "a gypsy [n -S]\n",
  "FAWN": "to please in a servile way [v -ED, -ING, -S]\n",
  "FAWNED": "FAWN, to please in a servile way [v]\n",
  "FAWNER": "one who fawns [n -S]\n",
  "FAWNERS": "FAWNER, one who fawns [n]\n",
  "FAWNIER": "FAWNY, yellowish-brown color [adj]\n",
  "FAWNIEST": "FAWNY, yellowish-brown color [adj]\n",
  "FAWNING": "ingratiating [adj FAWNINGLY] / the act of fawning [n -S]\n",
  "FAWNINGLY": "FAWNING, ingratiating [adv]\n",
  "FAWNINGNESS": "the state of being fawning [n -ES]\n",
  "FAWNINGNESSES": "FAWNINGNESS, the state of being fawning [n]\n",
  "FAWNINGS": "FAWNING, the act of fawning [n]\n",
  "FAWNLIKE": "like a young deer [adj]\n",
  "FAWNS": "FAWN, to please in a servile way [v]\n",
  "FAWNY": "yellowish-brown color [adj FAWNIER, FAWNIEST]\n",
  "FAWS": "FAW, a gypsy [n]\n",
  "FAX": "to send messages via a machine that scans electronically [v -ED, -ING, -ES]\n",
  "FAXABLE": "capable of being faxed [adj]\n",
  "FAXED": "FAX, to send messages via a machine that scans electronically [v]\n",
  "FAXES": "FAX, to send messages via a machine that scans electronically [v]\n",
  "FAXING": "FAX, to send messages via a machine that scans electronically [v]\n",
  "FAY": "whimsical, also FEY [adj FAYER, FAYEST] / to clean out esp. a ditch [v -ED, -ING, -S]\n",
  "FAYALITE": "a silicate of iron found in slag and occurring naturally [n -S]\n",
  "FAYALITES": "FAYALITE, a silicate of iron found in slag and occurring naturally [n]\n",
  "FAYED": "FAY, to clean out esp. a ditch [v]\n",
  "FAYENCE": "(French) a type of glazed pottery, also FAIENCE [n -S]\n",
  "FAYENCES": "FAYENCE, (French) a type of glazed pottery, also FAIENCE [n]\n",
  "FAYER": "FAY, whimsical, also FEY [adj]\n",
  "FAYEST": "FAY, whimsical, also FEY [adj]\n",
  "FAYING": "FAY, to clean out esp. a ditch [v]\n",
  "FAYNE": "(Spenser) to feign, also FAINE [v FAYNED, FAYNING, FAYNES]\n",
  "FAYNED": "FAYNE, (Spenser) to feign, also FAINE [v]\n",
  "FAYNES": "FAYNE, (Spenser) to feign, also FAINE [v]\n",
  "FAYNING": "FAYNE, (Spenser) to feign, also FAINE [v]\n",
  "FAYRE": "(archaic) a fair [n -S]\n",
  "FAYRES": "FAYRE, (archaic) a fair [n]\n",
  "FAYS": "FAY, to clean out esp. a ditch [v]\n",
  "FAZE": "to unsettle, also FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v FAZED, FAZING, FAZES]\n",
  "FAZED": "FAZE, to unsettle, also FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FAZENDA": "(Portuguese) a Brazilian plantation [n -S]\n",
  "FAZENDAS": "FAZENDA, (Portuguese) a Brazilian plantation [n]\n",
  "FAZENDEIRO": "a person who owns or runs a fazenda [n -S]\n",
  "FAZENDEIROS": "FAZENDEIRO, a person who owns or runs a fazenda [n]\n",
  "FAZES": "FAZE, to unsettle, also FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FAZING": "FAZE, to unsettle, also FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FE": "(Hebrew) a Hebrew letter, also FEH, PE, PEH [n -S]\n",
  "FEAGUE": "(obsolete) to beat, whip [v FEAGUED, FEAGUING, FEAGUES]\n",
  "FEAGUED": "FEAGUE, (obsolete) to beat, whip [v]\n",
  "FEAGUES": "FEAGUE, (obsolete) to beat, whip [v]\n",
  "FEAGUING": "FEAGUE, (obsolete) to beat, whip [v]\n",
  "FEAL": "to conceal [v -ED, -ING, -S]\n",
  "FEALED": "FEAL, to conceal [v]\n",
  "FEALING": "FEAL, to conceal [v]\n",
  "FEALS": "FEAL, to conceal [v]\n",
  "FEALTIES": "FEALTY, the vassal's obligation of loyalty to his feudal lord [n]\n",
  "FEALTY": "the vassal's obligation of loyalty to his feudal lord [n FEALTIES]\n",
  "FEAR": "to be afraid of [v -ED, -ING, -S]\n",
  "FEARE": "a companion, also FERE, FIER, FIERE, PHEER, PHEERE [n -S]\n",
  "FEARED": "FEAR, to be afraid of [v]\n",
  "FEARER": "one who fears [n -S]\n",
  "FEARERS": "FEARER, one who fears [n]\n",
  "FEARES": "FEARE, a companion, also FERE, FIER, FIERE, PHEER, PHEERE [n]\n",
  "FEARFUL": "full of fear [adj FEARFULLER, FEARFULLEST, FEARFULLY]\n",
  "FEARFULLER": "FEARFUL, full of fear [adj]\n",
  "FEARFULLEST": "FEARFUL, full of fear [adj]\n",
  "FEARFULLY": "FEARFUL, full of fear [adv]\n",
  "FEARFULNESS": "the state of being fearful [n -ES]\n",
  "FEARFULNESSES": "FEARFULNESS, the state of being fearful [n]\n",
  "FEARING": "FEAR, to be afraid of [v]\n",
  "FEARLESS": "without fear [adj FEARLESSLY]\n",
  "FEARLESSLY": "FEARLESS, without fear [adv]\n",
  "FEARLESSNESS": "the state of being fearless [n -ES]\n",
  "FEARLESSNESSES": "FEARLESSNESS, the state of being fearless [n]\n",
  "FEARMONGER": "one who spreads fear [n -S]\n",
  "FEARMONGERING": "the act of spreading fear [n -S]\n",
  "FEARMONGERINGS": "FEARMONGERING, the act of spreading fear [n]\n",
  "FEARMONGERS": "FEARMONGER, one who spreads fear [n]\n",
  "FEARNAUGHT": "a thick cloth used for overcoats etc., also FEARNOUGHT [n -S]\n",
  "FEARNAUGHTS": "FEARNAUGHT, a thick cloth used for overcoats etc., also FEARNOUGHT [n]\n",
  "FEARNOUGHT": "a thick cloth used for overcoats etc., also FEARNAUGHT [n -S]\n",
  "FEARNOUGHTS": "FEARNOUGHT, a thick cloth used for overcoats etc., also FEARNAUGHT [n]\n",
  "FEARS": "FEAR, to be afraid of [v]\n",
  "FEARSOME": "causing fear [adj FEARSOMELY]\n",
  "FEARSOMELY": "FEARSOME, causing fear [adv]\n",
  "FEARSOMENESS": "the state of being fearsome [n -ES]\n",
  "FEARSOMENESSES": "FEARSOMENESS, the state of being fearsome [n]\n",
  "FEART": "(Scots) afraid [adj]\n",
  "FEASANCE": "the performance of a condition, obligation or duty [n -S]\n",
  "FEASANCES": "FEASANCE, the performance of a condition, obligation or duty [n]\n",
  "FEASE": "to unsettle, also FAZE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v FEASED, FEASING, FEASES]\n",
  "FEASED": "FEASE, to unsettle, also FAZE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEASES": "FEASE, to unsettle, also FAZE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEASIBILITIES": "FEASIBILITY, the state of being feasible [n]\n",
  "FEASIBILITY": "the state of being feasible [n FEASIBILITIES]\n",
  "FEASIBLE": "capable of being done [adj FEASIBLY]\n",
  "FEASIBLENESS": "the state of being feasible [n -ES]\n",
  "FEASIBLENESSES": "FEASIBLENESS, the state of being feasible [n]\n",
  "FEASIBLY": "FEASIBLE, capable of being done [adv]\n",
  "FEASING": "FEASE, to unsettle, also FAZE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEAST": "to dine sumptuously [v -ED, -ING, -S]\n",
  "FEASTED": "FEAST, to dine sumptuously [v]\n",
  "FEASTER": "one who feasts [n -S]\n",
  "FEASTERS": "FEASTER, one who feasts [n]\n",
  "FEASTFUL": "(archaic) festive; joyful [adj]\n",
  "FEASTING": "the act of feasting [n -S]\n",
  "FEASTINGS": "FEASTING, the act of feasting [n]\n",
  "FEASTLESS": "without a feast [adj]\n",
  "FEASTS": "FEAST, to dine sumptuously [v]\n",
  "FEAT": "neat, deft [adj FEATER, FEATEST, FEATLY] / (Shakespeare) to fashion, make neat [v -ED, -ING, -S]\n",
  "FEATED": "FEAT, (Shakespeare) to fashion, make neat [v]\n",
  "FEATEOUS": "shapely, also FEATOUS, FEATUOUS [adj FEATEOUSLY]\n",
  "FEATEOUSLY": "FEATEOUS, shapely, also FEATOUS, FEATUOUS [adv]\n",
  "FEATER": "FEAT, neat, deft [adj]\n",
  "FEATEST": "FEAT, neat, deft [adj]\n",
  "FEATHER": "to cover with the plumage of birds [v -ED, -ING, -S]\n",
  "FEATHERBED": "a mattress filled with feathers or down [n -S] / to pamper; to protect (an industry, workers, etc.) by such practices as overmanning in order to save jobs [v FEATHERBEDDED, FEATHERBEDDING, FEATHERBEDS]\n",
  "FEATHERBEDDED": "FEATHERBED, to pamper; to protect (an industry, workers, etc.) by such practices as overmanning in order to save jobs [v]\n",
  "FEATHERBEDDING": "protecting (an industry, workers, etc.) by such practices as overmanning in order to save jobs [n -S]\n",
  "FEATHERBEDDINGS": "FEATHERBEDDING, protecting (an industry, workers, etc.) by such practices as overmanning in order to save jobs [n]\n",
  "FEATHERBEDS": "FEATHERBED, to pamper; to protect (an industry, workers, etc.) by such practices as overmanning in order to save jobs [v]\n",
  "FEATHERBRAIN": "a foolish scatterbrained person [n -S]\n",
  "FEATHERBRAINED": "foolish [adj]\n",
  "FEATHERBRAINS": "FEATHERBRAIN, a foolish scatterbrained person [n]\n",
  "FEATHERED": "FEATHER, to cover with the plumage of birds [v]\n",
  "FEATHEREDGE": "an edge of a board or plank thinner than the other edge [n -S] / to provide with feathered edge [v FEATHEREDGED, FEATHEREDGING, FEATHEREDGES]\n",
  "FEATHEREDGED": "FEATHEREDGE, to provide with feathered edge [v]\n",
  "FEATHEREDGES": "FEATHEREDGE, to provide with feathered edge [v]\n",
  "FEATHEREDGING": "FEATHEREDGE, to provide with feathered edge [v]\n",
  "FEATHERHEAD": "an empty-headed person [n -S]\n",
  "FEATHERHEADED": "foolish, empty-headed [adj]\n",
  "FEATHERHEADS": "FEATHERHEAD, an empty-headed person [n]\n",
  "FEATHERIER": "FEATHERY, resembling feathers [adj]\n",
  "FEATHERIEST": "FEATHERY, resembling feathers [adj]\n",
  "FEATHERINESS": "the state of being feathery [n -ES]\n",
  "FEATHERINESSES": "FEATHERINESS, the state of being feathery [n]\n",
  "FEATHERING": "the act of providing with feathers [n -S]\n",
  "FEATHERINGS": "FEATHERING, the act of providing with feathers [n]\n",
  "FEATHERLESS": "without feathers [adj]\n",
  "FEATHERLIGHT": "extremely light [adj]\n",
  "FEATHERS": "FEATHER, to cover with the plumage of birds [v]\n",
  "FEATHERSTITCH": "an embroidery stitch consisting of a line of diagonal blanket stitches worked alternately to the left and right [n -ES] / to stitch with featherstitch [v -ED, -ES]\n",
  "FEATHERSTITCHED": "FEATHERSTITCH, to stitch with featherstitch [v]\n",
  "FEATHERSTITCHES": "FEATHERSTITCH, an embroidery stitch consisting of a line of diagonal blanket stitches worked alternately to the left and right [n]\n",
  "FEATHERWEIGHT": "a weight division in boxing [n -S]\n",
  "FEATHERWEIGHTS": "FEATHERWEIGHT, a weight division in boxing [n]\n",
  "FEATHERY": "resembling feathers [adj FEATHERIER, FEATHERIEST]\n",
  "FEATING": "FEAT, (Shakespeare) to fashion, make neat [v]\n",
  "FEATLIER": "FEATLY, (Shakespeare) graceful [adj]\n",
  "FEATLIEST": "FEATLY, (Shakespeare) graceful [adj]\n",
  "FEATLINESS": "the state of being featly [n -ES]\n",
  "FEATLINESSES": "FEATLINESS, the state of being featly [n]\n",
  "FEATLY": "(Shakespeare) graceful [adj FEATLIER, FEATLIEST]\n",
  "FEATOUS": "shapely, also FEATEOUS, FEATUOUS [adj]\n",
  "FEATS": "FEAT, (Shakespeare) to fashion, make neat [v]\n",
  "FEATUOUS": "shapely, also FEATOUS, FEATEOUS [adj]\n",
  "FEATURE": "to present prominently [v FEATURED, FEATURING, FEATURES]\n",
  "FEATURED": "FEATURE, to present prominently [v]\n",
  "FEATURELESS": "without features [adj]\n",
  "FEATURELESSNESS": "FEATURELESS, without features [n]\n",
  "FEATURELY": "(archaic) handsome [adj]\n",
  "FEATURES": "FEATURE, to present prominently [v]\n",
  "FEATURETTE": "a brief feature, esp. a short documentary film dealing with an aspect of the making of a feature film and included on a DVD of the feature film [n -S]\n",
  "FEATURETTES": "FEATURETTE, a brief feature, esp. a short documentary film dealing with an aspect of the making of a feature film and included on a DVD of the feature film [n]\n",
  "FEATURING": "FEATURE, to present prominently [v]\n",
  "FEAZE": "to unsettle, also FAZE, FEASE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v FEAZED, FEAZING, FEAZES]\n",
  "FEAZED": "FEAZE, to unsettle, also FAZE, FEASE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEAZES": "FEAZE, to unsettle, also FAZE, FEASE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEAZING": "FEAZE, to unsettle, also FAZE, FEASE, FEESE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEBLESSE": "(Spenser) feebleness [n -S]\n",
  "FEBLESSES": "FEBLESSE, (Spenser) feebleness [n]\n",
  "FEBRICITIES": "FEBRICITY, feverishness [n]\n",
  "FEBRICITY": "feverishness [n FEBRICITIES]\n",
  "FEBRICULA": "a slight short fever, also FEBRICULE [n -S]\n",
  "FEBRICULAS": "FEBRICULA, a slight short fever, also FEBRICULE [n]\n",
  "FEBRICULE": "a slight short fever, also FEBRICULA [n -S]\n",
  "FEBRICULES": "FEBRICULE, a slight short fever, also FEBRICULA [n]\n",
  "FEBRIFACIENT": "causing fever [adj] / something causing fever [n -S]\n",
  "FEBRIFACIENTS": "FEBRIFACIENT, something causing fever [n]\n",
  "FEBRIFEROUS": "causing or having fever, also FEBRIFIC [adj]\n",
  "FEBRIFIC": "causing or having fever, also FEBRIFEROUS [adj]\n",
  "FEBRIFUGAL": "having the quality of mitigating or curing fever [adj]\n",
  "FEBRIFUGE": "something which reduces fever [n -S]\n",
  "FEBRIFUGES": "FEBRIFUGE, something which reduces fever [n]\n",
  "FEBRILE": "feverish [adj]\n",
  "FEBRILITIES": "FEBRILITY, feverishness [n]\n",
  "FEBRILITY": "feverishness [n FEBRILITIES]\n",
  "FECAL": "relating to feces, also FAECAL [adj]\n",
  "FECES": "(Latin) bodily waste discharged through the anus, also FAECES [n]\n",
  "FECHT": "(Scots) to fight [v FOUGHT, FECHTING, FECHTS]\n",
  "FECHTER": "(Scots) a fighter [n -S]\n",
  "FECHTERS": "FECHTER, (Scots) a fighter [n]\n",
  "FECHTING": "FECHT, (Scots) to fight [v]\n",
  "FECHTS": "FECHT, (Scots) to fight [v]\n",
  "FECIAL": "(Latin) a priest of ancient Rome, also FETIAL, FETIALIS [n -S]\n",
  "FECIALS": "FECIAL, (Latin) a priest of ancient Rome, also FETIAL, FETIALIS [n]\n",
  "FECIT": "(Latin) he/she made (it): formerly used on works of art after the name of the artist [v]\n",
  "FECK": "(vulgar Scots) to fuck [v -ED, -ING, -S]\n",
  "FECKED": "FECK, (vulgar Scots) to fuck [v]\n",
  "FECKIN": "(vulgar colloquial) fucking, also FECKING [adj]\n",
  "FECKING": "(vulgar slang) an intensive, also FECKIN [adj]\n",
  "FECKLESS": "worthless [adj FECKLESSLY]\n",
  "FECKLESSLY": "FECKLESS, worthless [adv]\n",
  "FECKLESSNESS": "the state of being feckless [n -ES]\n",
  "FECKLESSNESSES": "FECKLESSNESS, the state of being feckless [n]\n",
  "FECKLY": "(archaic) mostly, nearly [adv]\n",
  "FECKS": "FECK, (vulgar Scots) to fuck [v]\n",
  "FECULA": "(Latin) a fine flour usually extracted from potatoes [n FECULAE or FECULAS]\n",
  "FECULAE": "FECULA, (Latin) a fine flour usually extracted from potatoes [n]\n",
  "FECULAS": "FECULA, (Latin) a fine flour usually extracted from potatoes [n]\n",
  "FECULENCE": "the state of being feculent, also FECULENCY [n -S]\n",
  "FECULENCES": "FECULENCE, the state of being feculent, also FECULENCY [n]\n",
  "FECULENCIES": "FECULENCY, the state of being feculent, also FECULENCE [n]\n",
  "FECULENCY": "the state of being feculent, also FECULENCE [n FECULENCIES]\n",
  "FECULENT": "full of filth or waste matter [adj]\n",
  "FECUND": "fruitful in offspring or vegetation, prolific [adj]\n",
  "FECUNDATE": "to make fruitful or prolific [v FECUNDATED, FECUNDATING, FECUNDATES]\n",
  "FECUNDATED": "FECUNDATE, to make fruitful or prolific [v]\n",
  "FECUNDATES": "FECUNDATE, to make fruitful or prolific [v]\n",
  "FECUNDATING": "FECUNDATE, to make fruitful or prolific [v]\n",
  "FECUNDATION": "the act of making fecund [n -S]\n",
  "FECUNDATIONS": "FECUNDATION, the act of making fecund [n]\n",
  "FECUNDATOR": "one who fecundates [n -S]\n",
  "FECUNDATORS": "FECUNDATOR, one who fecundates [n]\n",
  "FECUNDATORY": "serving to fecundate [adj]\n",
  "FECUNDITIES": "FECUNDITY, fertility [n]\n",
  "FECUNDITY": "fertility [n FECUNDITIES]\n",
  "FED": "(short for) a federal agent [n -S]\n",
  "FEDARIE": "(Shakespeare) a confederate, also FEDERARIE, FEDERARY, FOEDARIE [n -S]\n",
  "FEDARIES": "FEDARIE, (Shakespeare) a confederate, also FEDERARIE, FEDERARY, FOEDARIE [n]\n",
  "FEDAYEE": "(Arabic) an Arab commando [n FEDAYEEN]\n",
  "FEDAYEEN": "FEDAYEE, (Arabic) an Arab commando [n]\n",
  "FEDELINI": "(Italian) pasta made in long thin cordlike strings [n -S]\n",
  "FEDELINIS": "FEDELINI, (Italian) pasta made in long thin cordlike strings [n]\n",
  "FEDERACIES": "FEDERACY, confederacy [n]\n",
  "FEDERACY": "confederacy [n FEDERACIES]\n",
  "FEDERAL": "relating to or consisting of a treaty or covenant [adj FEDERALLY] / a supporter of federation; a Unionist soldier in the American Civil War [n -S]\n",
  "FEDERALESE": "the language of bureaucrats, bureaucratese [n -S]\n",
  "FEDERALESES": "FEDERALESE, the language of bureaucrats, bureaucratese [n]\n",
  "FEDERALISATION": "the process of federalising, also FEDERALIZATION [n -S]\n",
  "FEDERALISATIONS": "FEDERALISATION, the process of federalising, also FEDERALIZATION [n]\n",
  "FEDERALISE": "to unite in a federation, also FEDERALIZE [v FEDERALISED, FEDERALISING, FEDERALISES]\n",
  "FEDERALISED": "FEDERALISE, to unite in a federation, also FEDERALIZE [v]\n",
  "FEDERALISES": "FEDERALISE, to unite in a federation, also FEDERALIZE [v]\n",
  "FEDERALISING": "FEDERALISE, to unite in a federation, also FEDERALIZE [v]\n",
  "FEDERALISM": "the principles of Federalists or of federal union [n -S]\n",
  "FEDERALISMS": "FEDERALISM, the principles of Federalists or of federal union [n]\n",
  "FEDERALIST": "a supporter of a federal constitution or union [n -S]\n",
  "FEDERALISTIC": "related to federalism, the principles of Federalists or of federal union [adj]\n",
  "FEDERALISTS": "FEDERALIST, a supporter of a federal constitution or union [n]\n",
  "FEDERALIZATION": "the process of federalizing, also FEDERALISATION [n -S]\n",
  "FEDERALIZATIONS": "FEDERALIZATION, the process of federalizing, also FEDERALISATION [n]\n",
  "FEDERALIZE": "to unite in a federation, also FEDERALISE [v FEDERALIZED, FEDERALIZING, FEDERALIZES]\n",
  "FEDERALIZED": "FEDERALIZE, to unite in a federation, also FEDERALISE [v]\n",
  "FEDERALIZES": "FEDERALIZE, to unite in a federation, also FEDERALISE [v]\n",
  "FEDERALIZING": "FEDERALIZE, to unite in a federation, also FEDERALISE [v]\n",
  "FEDERALLY": "FEDERAL, relating to or consisting of a treaty or covenant [adv]\n",
  "FEDERALS": "FEDERAL, a supporter of federation; a Unionist soldier in the American Civil War [n]\n",
  "FEDERARIE": "(Shakespeare) a confederate, also FEDARIE, FEDERARY, FOEDARIE [n -S]\n",
  "FEDERARIES": "FEDERARY, (Shakespeare) a confederate, also FEDARIE, FEDERARIE, FOEDARIE [n]\n",
  "FEDERARY": "(Shakespeare) a confederate, also FEDARIE, FEDERARIE, FOEDARIE [n FEDERARIES]\n",
  "FEDERATE": "to unite in an alliance [v FEDERATED, FEDERATING, FEDERATES]\n",
  "FEDERATED": "FEDERATE, to unite in an alliance [v]\n",
  "FEDERATES": "FEDERATE, to unite in an alliance [v]\n",
  "FEDERATING": "FEDERATE, to unite in an alliance [v]\n",
  "FEDERATION": "a federal government [n -S]\n",
  "FEDERATIONS": "FEDERATION, a federal government [n]\n",
  "FEDERATIVE": "uniting in a confederacy; federal [adj FEDERATIVELY]\n",
  "FEDERATIVELY": "FEDERATIVE, uniting in a confederacy; federal [adv]\n",
  "FEDERATOR": "one who federates [n -S]\n",
  "FEDERATORS": "FEDERATOR, one who federates [n]\n",
  "FEDEX": "to send by Federal Express [v -ED, -ING, -ES]\n",
  "FEDEXED": "FEDEX, to send by Federal Express [v]\n",
  "FEDEXES": "FEDEX, to send by Federal Express [v]\n",
  "FEDEXING": "FEDEX, to send by Federal Express [v]\n",
  "FEDORA": "a felt hat with a brim and a crease [n -S]\n",
  "FEDORAS": "FEDORA, a felt hat with a brim and a crease [n]\n",
  "FEDS": "FED, (short for) a federal agent [n]\n",
  "FEE": "to pay a fixed charge [v FEED, FEEING, FEES]\n",
  "FEEB": "(US) a weak ineffectual person, a wimp [n -S]\n",
  "FEEBLE": "very weak [adj FEEBLER, FEEBLEST, FEEBLY] / to make weak [v FEEBLED, FEEBLING, FEEBLES]\n",
  "FEEBLED": "FEEBLE, to make weak [v]\n",
  "FEEBLEMINDED": "mentally deficient [adj FEEBLEMINDEDLY]\n",
  "FEEBLEMINDEDLY": "FEEBLEMINDED, mentally deficient [adv]\n",
  "FEEBLENESS": "the state of being feeble, also FEBLESSE [n -ES]\n",
  "FEEBLENESSES": "FEEBLENESS, the state of being feeble, also FEBLESSE [n]\n",
  "FEEBLER": "FEEBLE, very weak [adj]\n",
  "FEEBLES": "FEEBLE, to make weak [v]\n",
  "FEEBLEST": "FEEBLE, very weak [adj]\n",
  "FEEBLING": "FEEBLE, to make weak [v]\n",
  "FEEBLISH": "somewhat feeble [adj]\n",
  "FEEBLY": "FEEBLE, very weak [adv]\n",
  "FEEBS": "FEEB, (US) a weak ineffectual person, a wimp [n]\n",
  "FEED": "to give food to [v FED, FEEDING, FEEDS]\n",
  "FEEDABLE": "able to be fed [adj]\n",
  "FEEDBACK": "a return of ideas for future development [n -S]\n",
  "FEEDBACKS": "FEEDBACK, a return of ideas for future development [n]\n",
  "FEEDBAG": "a nosebag for feeding horses [n -S]\n",
  "FEEDBAGS": "FEEDBAG, a nosebag for feeding horses [n]\n",
  "FEEDBOX": "a box for animal feed [n -ES]\n",
  "FEEDBOXES": "FEEDBOX, a box for animal feed [n]\n",
  "FEEDER": "one that feeds [n -S]\n",
  "FEEDERS": "FEEDER, one that feeds [n]\n",
  "FEEDGRAIN": "cereal grown to feed livestock [n -S]\n",
  "FEEDGRAINS": "FEEDGRAIN, cereal grown to feed livestock [n]\n",
  "FEEDHOLE": "one of a series of holes in paper tape [n -S]\n",
  "FEEDHOLES": "FEEDHOLE, one of a series of holes in paper tape [n]\n",
  "FEEDING": "a calculated amount of food [n -S]\n",
  "FEEDINGS": "FEEDING, a calculated amount of food [n]\n",
  "FEEDINGSTUFF": "stuff used to feed animals [n -S]\n",
  "FEEDINGSTUFFS": "FEEDINGSTUFF, stuff used to feed animals [n]\n",
  "FEEDLOT": "a plot of land in which livestock is fattened [n -S]\n",
  "FEEDLOTS": "FEEDLOT, a plot of land in which livestock is fattened [n]\n",
  "FEEDPIPE": "a pipe through which something is supplied to a machine or system, for instance steam to an engine, or oil to a tank [n -S]\n",
  "FEEDPIPES": "FEEDPIPE, a pipe through which something is supplied to a machine or system, for instance steam to an engine, or oil to a tank [n]\n",
  "FEEDS": "FEED, to give food to [v]\n",
  "FEEDSTOCK": "raw material used in an industrial process [n -S]\n",
  "FEEDSTOCKS": "FEEDSTOCK, raw material used in an industrial process [n]\n",
  "FEEDSTUFF": "material for feeding cattle [n -S]\n",
  "FEEDSTUFFS": "FEEDSTUFF, material for feeding cattle [n]\n",
  "FEEDTHROUGH": "a device for connecting two parts of an electronic circuit [n -S]\n",
  "FEEDTHROUGHS": "FEEDTHROUGH, a device for connecting two parts of an electronic circuit [n]\n",
  "FEEDWATER": "purified water used in boilers for steam generation [n -S]\n",
  "FEEDWATERS": "FEEDWATER, purified water used in boilers for steam generation [n]\n",
  "FEEDYARD": "a place where cattle are kept and fed [n -S]\n",
  "FEEDYARDS": "FEEDYARD, a place where cattle are kept and fed [n]\n",
  "FEEING": "FEE, to pay a fixed charge [v]\n",
  "FEEL": "to perceive by the sense of touch [v FELT, FEELING, FEELS]\n",
  "FEELBAD": "relating to a feeling of personal unease [adj]\n",
  "FEELER": "the antenna of insects [n -S]\n",
  "FEELERS": "FEELER, the antenna of insects [n]\n",
  "FEELESS": "requiring no fee [adj]\n",
  "FEELGOOD": "relating to a feeling of personal wellbeing [adj]\n",
  "FEELING": "the sense of touch [n -S]\n",
  "FEELINGLESS": "without feelings [adj]\n",
  "FEELINGLY": "FEELING [adv]\n",
  "FEELINGNESS": "sensibility [n -ES]\n",
  "FEELINGNESSES": "FEELINGNESS, sensibility [n]\n",
  "FEELINGS": "FEELING, the sense of touch [n]\n",
  "FEELS": "FEEL, to perceive by the sense of touch [v]\n",
  "FEEN": "(Irish) a man [n -S]\n",
  "FEENS": "FEEN, (Irish) a man [n]\n",
  "FEER": "(Scots) to draw the first furrow in ploughing, also FURR [v -ED, -ING, -S]\n",
  "FEERED": "FEER, (Scots) to draw the first furrow in ploughing, also FURR [v]\n",
  "FEERIE": "a theatrical extravaganza [n -S]\n",
  "FEERIES": "FEERIE, a theatrical extravaganza [n]\n",
  "FEERIN": "a first guiding furrow, also FEERING [n -S]\n",
  "FEERING": "a first guiding furrow, also FEERIN [n -S]\n",
  "FEERINGS": "FEERING, a first guiding furrow, also FEERIN [n]\n",
  "FEERINS": "FEERIN, a first guiding furrow, also FEERING [n]\n",
  "FEERS": "FEER, (Scots) to draw the first furrow in ploughing, also FURR [v]\n",
  "FEES": "FEE, to pay a fixed charge [v]\n",
  "FEESE": "to unsettle, also FAZE, FEASE, FEAZE, FEEZE, PHEESE, PHEEZE, PHESE [v FEESED, FEESING, FEESES]\n",
  "FEESED": "FEESE, to unsettle, also FAZE, FEASE, FEAZE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEESES": "FEESE, to unsettle, also FAZE, FEASE, FEAZE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEESING": "FEESE, to unsettle, also FAZE, FEASE, FEAZE, FEEZE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEET": "FOOT, the terminal part of the leg on which the body stands and moves [n]\n",
  "FEETFIRST": "with feet leading the way [adv]\n",
  "FEETLESS": "without feet [adj]\n",
  "FEEZE": "to unsettle, also FAZE, FEASE, FEAZE, FEESE, PHEESE, PHEEZE, PHESE [v FEEZED, FEEZING, FEEZES]\n",
  "FEEZED": "FEEZE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEEZES": "FEEZE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEEZING": "FEEZE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, PHEESE, PHEEZE, PHESE [v]\n",
  "FEG": "(dialect) a segment of an orange [n -S]\n",
  "FEGARIES": "FEGARY, a whim, also VAGARY [n]\n",
  "FEGARY": "a whim, also VAGARY [n FEGARIES]\n",
  "FEGS": "FEG, (dialect) a segment of an orange [n]\n",
  "FEH": "(Hebrew) a letter of the Hebrew alphabet, also FE, PE, PEH [n -S]\n",
  "FEHM": "(German) a mediaeval German court, also VEHM [n FEHME]\n",
  "FEHME": "FEHM, (German) a mediaeval German court, also VEHM [n]\n",
  "FEHMIC": "pertaining to a fehm, a mediaeval German court, also VEHMIC, VEHMIQUE [adj]\n",
  "FEHS": "FEH, (Hebrew) a letter of the Hebrew alphabet, also FE, PE, PEH [n]\n",
  "FEIGN": "to pretend, give a false impression, also FAINE, FAYNE [v -ED, -ING, -S]\n",
  "FEIGNED": "FEIGN, to pretend, give a false impression, also FAINE, FAYNE [v]\n",
  "FEIGNEDLY": "FEIGNED, FEIGN, to pretend, give a false impression, also FAINE, FAYNE [adv]\n",
  "FEIGNEDNESS": "the state of being feigned [n -ES]\n",
  "FEIGNEDNESSES": "FEIGNEDNESS, the state of being feigned [n]\n",
  "FEIGNER": "one who feigns or pretends [n -S]\n",
  "FEIGNERS": "FEIGNER, one who feigns or pretends [n]\n",
  "FEIGNING": "the act of feigning [n -S]\n",
  "FEIGNINGLY": "FEIGNING [adv]\n",
  "FEIGNINGS": "FEIGNING, the act of feigning [n]\n",
  "FEIGNS": "FEIGN, to pretend, give a false impression, also FAINE, FAYNE [v]\n",
  "FEIJOA": "(Portuguese) a tropical evergreen shrub or small tree of the myrtle family; the edible green fruit of this [n -S]\n",
  "FEIJOADA": "a Brazilian dish of black beans, meat and vegetables served with rice [n -S]\n",
  "FEIJOADAS": "FEIJOADA, a Brazilian dish of black beans, meat and vegetables served with rice [n]\n",
  "FEIJOAS": "FEIJOA, (Portuguese) a tropical evergreen shrub or small tree of the myrtle family; the edible green fruit of this [n]\n",
  "FEINT": "to make a pretence [v -ED, -ING, -S] / ruled with faint lines [adj FEINTER, FEINTEST]\n",
  "FEINTED": "FEINT, to make a pretence [v]\n",
  "FEINTER": "FEINT, ruled with faint lines [adj]\n",
  "FEINTEST": "FEINT, ruled with faint lines [adj]\n",
  "FEINTING": "FEINT, to make a pretence [v]\n",
  "FEINTS": "FEINT, to make a pretence [v]\n",
  "FEIRIE": "(Scots) nimble, fit to travel [adj FEIRIER, FEIRIEST]\n",
  "FEIRIER": "FEIRIE, (Scots) nimble, fit to travel [adj]\n",
  "FEIRIEST": "FEIRIE, (Scots) nimble, fit to travel [adj]\n",
  "FEIS": "(Irish) an ancient Irish assembly for the proclamation of laws etc. [n FEISEANNA]\n",
  "FEISEANNA": "FEIS, (Irish) an ancient Irish assembly for the proclamation of laws etc. [n]\n",
  "FEIST": "a small dog of mixed breed, also FICE, FYCE [n -S]\n",
  "FEISTIER": "FEISTY, spirited [adj]\n",
  "FEISTIEST": "FEISTY, spirited [adj]\n",
  "FEISTILY": "FEISTY, spirited [adv]\n",
  "FEISTINESS": "the state of being feisty [n -ES]\n",
  "FEISTINESSES": "FEISTINESS, the state of being feisty [n]\n",
  "FEISTS": "FEIST, a small dog of mixed breed, also FICE, FYCE [n]\n",
  "FEISTY": "spirited [adj FEISTIER, FEISTIEST, FEISTILY]\n",
  "FELAFEL": "(Arabic) a fried patty of ground vegetables, also FALAFEL [n -S]\n",
  "FELAFELS": "FELAFEL, (Arabic) a fried patty of ground vegetables, also FALAFEL [n]\n",
  "FELCH": "(vulgar) a type of sexual practice [v -ED, -ING, -ES]\n",
  "FELCHED": "FELCH, (vulgar) a type of sexual practice [v]\n",
  "FELCHES": "FELCH, (vulgar) a type of sexual practice [v]\n",
  "FELCHING": "FELCH, (vulgar) a type of sexual practice [v]\n",
  "FELDGRAU": "(German) the grey colour of German military uniforms [n -S]\n",
  "FELDGRAUS": "FELDGRAU, (German) the grey colour of German military uniforms [n]\n",
  "FELDSCHAR": "(Russian) in Russia and Eastern Europe, a partly trained doctor, or one who assists a doctor on the battlefield, also FELDSCHER, FELDSHER [n -S]\n",
  "FELDSCHARS": "FELDSCHAR, (Russian) in Russia and Eastern Europe, a partly trained doctor, or one who assists a doctor on the battlefield, also FELDSCHER, FELDSHER [n]\n",
  "FELDSCHER": "(Russian) in Russia and Eastern Europe, a partly trained doctor, or one who assists a doctor on the battlefield, also FELDSCHAR, FELDSHER [n -S]\n",
  "FELDSCHERS": "FELDSCHER, (Russian) in Russia and Eastern Europe, a partly trained doctor, or one who assists a doctor on the battlefield, also FELDSCHAR, FELDSHER [n]\n",
  "FELDSHER": "(Russian) a medical worker in Russia, also FELDSCHAR, FELDSCHER [n -S]\n",
  "FELDSHERS": "FELDSHER, (Russian) a medical worker in Russia, also FELDSCHAR, FELDSCHER [n]\n",
  "FELDSPAR": "a common rock-forming mineral, also FELDSPATH, FELSPAR [n -S]\n",
  "FELDSPARS": "FELDSPAR, a common rock-forming mineral, also FELDSPATH, FELSPAR [n]\n",
  "FELDSPATH": "(obsolete) a common rock-forming mineral, also FELDSPAR, FELSPAR [n -S]\n",
  "FELDSPATHIC": "of or like feldspar, also FELDSPATHOSE, FELSPATHIC, FELSPATHOSE [adj]\n",
  "FELDSPATHOID": "any mineral of a group related to feldspar, also FELSPATHOID, FOID [n -S]\n",
  "FELDSPATHOIDS": "FELDSPATHOID, any mineral of a group related to feldspar, also FELSPATHOID, FOID [n]\n",
  "FELDSPATHOSE": "of or like feldspar, also FELDSPATHIC, FELSPATHIC, FELSPATHOSE [adj]\n",
  "FELDSPATHS": "FELDSPATH, (obsolete) a common rock-forming mineral, also FELDSPAR, FELSPAR [n]\n",
  "FELICIA": "any member of a South African genus of herbs [n -S]\n",
  "FELICIAS": "FELICIA, any member of a South African genus of herbs [n]\n",
  "FELICIFIC": "producing happiness [adj]\n",
  "FELICITATE": "to congratulate [v FELICITATED, FELICITATING, FELICITATES]\n",
  "FELICITATED": "FELICITATE, to congratulate [v]\n",
  "FELICITATES": "FELICITATE, to congratulate [v]\n",
  "FELICITATING": "FELICITATE, to congratulate [v]\n",
  "FELICITATION": "the act of congratulating [n -S]\n",
  "FELICITATIONS": "FELICITATION, the act of congratulating [n]\n",
  "FELICITATOR": "one who felicitates [n -S]\n",
  "FELICITATORS": "FELICITATOR, one who felicitates [n]\n",
  "FELICITER": "(Latin) happily, successfully [adj]\n",
  "FELICITIES": "FELICITY, happiness [n]\n",
  "FELICITOUS": "happy; prosperous [adj FELICITOUSLY]\n",
  "FELICITOUSLY": "FELICITOUS, happy; prosperous [adv]\n",
  "FELICITOUSNESS": "FELICITOUS, happy; prosperous [n]\n",
  "FELICITY": "happiness [n FELICITIES]\n",
  "FELID": "(Latin) a member of the cat family, also FELINE [n -S]\n",
  "FELIDS": "FELID, (Latin) a member of the cat family, also FELINE [n]\n",
  "FELINE": "related to the cat family [adj FELINELY] / a member of the cat family [n -S]\n",
  "FELINELY": "FELINE, related to the cat family [adv]\n",
  "FELINENESS": "the state of being feline [n -ES]\n",
  "FELINENESSES": "FELINENESS, the state of being feline [n]\n",
  "FELINES": "FELINE, a member of the cat family [n]\n",
  "FELINITIES": "FELINITY, the quality of being catlike [n]\n",
  "FELINITY": "the quality of being catlike [n FELINITIES]\n",
  "FELL": "to cause to fall [v -ED, -ING, -S] / cruel [adj FELLER, FELLEST]\n",
  "FELLA": "(colloquial) fellow [n -S]\n",
  "FELLABLE": "capable of being felled [adj]\n",
  "FELLAH": "(Arabic) a peasant or labourer in Arab countries [n FELLAHS or FELLAHEEN or FELLAHIN]\n",
  "FELLAHEEN": "FELLAH, (Arabic) a peasant or labourer in Arab countries [n]\n",
  "FELLAHIN": "FELLAH, (Arabic) a peasant or labourer in Arab countries [n]\n",
  "FELLAHS": "FELLAH, (Arabic) a peasant or labourer in Arab countries [n]\n",
  "FELLAS": "FELLA, (colloquial) fellow [n]\n",
  "FELLATE": "to stimulate the penis orally [v FELLATED, FELLATING, FELLATES]\n",
  "FELLATED": "FELLATE, to stimulate the penis orally [v]\n",
  "FELLATES": "FELLATE, to stimulate the penis orally [v]\n",
  "FELLATING": "FELLATE, to stimulate the penis orally [v]\n",
  "FELLATIO": "oral stimulation of the penis, also FELLATION [n -S]\n",
  "FELLATION": "oral stimulation of the penis, also FELLATIO [n -S]\n",
  "FELLATIONS": "FELLATION, oral stimulation of the penis, also FELLATIO [n]\n",
  "FELLATIOS": "FELLATIO, oral stimulation of the penis, also FELLATION [n]\n",
  "FELLATOR": "a male who fellates [n -S]\n",
  "FELLATORS": "FELLATOR, a male who fellates [n]\n",
  "FELLATRICES": "FELLATRIX, a female who fellates [n]\n",
  "FELLATRIX": "a female who fellates [n FELLATRIXES or FELLATRICES]\n",
  "FELLATRIXES": "FELLATRIX, a female who fellates [n]\n",
  "FELLED": "FELL, to cause to fall [v]\n",
  "FELLER": "one that fells [n -S]\n",
  "FELLERS": "FELLER, one that fells [n]\n",
  "FELLEST": "FELL, cruel [adj]\n",
  "FELLFIELD": "a tundra area of frost-shattered stony debris with fine interstitial particles which supports sparse vegetation, usually algae, lichens, and mosses [n -S]\n",
  "FELLFIELDS": "FELLFIELD, a tundra area of frost-shattered stony debris with fine interstitial particles which supports sparse vegetation, usually algae, lichens, and mosses [n]\n",
  "FELLIES": "FELLY, the rim of a wheel, also FELLOE [n]\n",
  "FELLING": "the act of causing to fall [n -S]\n",
  "FELLINGS": "FELLING, the act of causing to fall [n]\n",
  "FELLMONGER": "a dealer in fells or sheepskins, who separates the wool from the pelts [n -S] / to sell skins [v -ED, -ING, -S]\n",
  "FELLMONGERED": "FELLMONGER, to sell skins [v]\n",
  "FELLMONGERIES": "FELLMONGERY, the preparation of skins for the tanner [n]\n",
  "FELLMONGERING": "the removal of hair or wool from hides in preparation for leather-making [n -S]\n",
  "FELLMONGERINGS": "FELLMONGERING, the removal of hair or wool from hides in preparation for leather-making [n]\n",
  "FELLMONGERS": "FELLMONGER, a dealer in fells or sheepskins, who separates the wool from the pelts [n]\n",
  "FELLMONGERY": "the preparation of skins for the tanner [n FELLMONGERIES]\n",
  "FELLNESS": "extreme cruelty [n -ES]\n",
  "FELLNESSES": "FELLNESS, extreme cruelty [n]\n",
  "FELLOE": "the rim of a wheel, also FELLY [n -S]\n",
  "FELLOES": "FELLOE, the rim of a wheel, also FELLY [n]\n",
  "FELLOW": "to produce an equal to [v -ED, -ING, -S]\n",
  "FELLOWED": "FELLOW, to produce an equal to [v]\n",
  "FELLOWING": "FELLOW, to produce an equal to [v]\n",
  "FELLOWLY": "(Shakespeare) companionable [adj]\n",
  "FELLOWMAN": "a human being like oneself [n FELLOWMEN]\n",
  "FELLOWMEN": "FELLOWMAN, a human being like oneself [n]\n",
  "FELLOWS": "FELLOW, to produce an equal to [v]\n",
  "FELLOWSHIP": "the state of being a fellow or partner [n -S] / to join in fellowship esp. with a church member [v FELLOWSHIPED or FELLOWSHIPPED, FELLOWSHIPING or FELLOWSHIPPING, FELLOWSHIPS]\n",
  "FELLOWSHIPED": "FELLOWSHIP, to join in fellowship esp. with a church member [v]\n",
  "FELLOWSHIPING": "FELLOWSHIP, to join in fellowship esp. with a church member [v]\n",
  "FELLOWSHIPPED": "FELLOWSHIP, to join in fellowship esp. with a church member [v]\n",
  "FELLOWSHIPPING": "FELLOWSHIP, to join in fellowship esp. with a church member [v]\n",
  "FELLOWSHIPS": "FELLOWSHIP, to join in fellowship esp. with a church member [v]\n",
  "FELLS": "FELL, to cause to fall [v]\n",
  "FELLWALKER": "one who engages in fell-walking [n -S]\n",
  "FELLWALKERS": "FELLWALKER, one who engages in fell-walking [n]\n",
  "FELLY": "the rim of a wheel, also FELLOE [n FELLIES]\n",
  "FELON": "a person guilty of a felony [n -S]\n",
  "FELONIES": "FELONY, a grave crime [n]\n",
  "FELONIOUS": "like a felon, wicked [adj FELONIOUSLY]\n",
  "FELONIOUSLY": "FELONIOUS, like a felon, wicked [adv]\n",
  "FELONIOUSNESS": "FELONIOUS, like a felon, wicked [n]\n",
  "FELONIOUSNESSES": "FELONIOUSNESS, FELONIOUS, like a felon, wicked [n]\n",
  "FELONOUS": "(Spenser) cruel, ruthless [adj]\n",
  "FELONRIES": "FELONRY, a body of felons [n]\n",
  "FELONRY": "a body of felons [n FELONRIES]\n",
  "FELONS": "FELON, a person guilty of a felony [n]\n",
  "FELONY": "a grave crime [n FELONIES]\n",
  "FELQUISTE": "(Canadian) a member of the FLQ, a separatist paramilitary group wanting independence for Quebec [n -S]\n",
  "FELQUISTES": "FELQUISTE, (Canadian) a member of the FLQ, a separatist paramilitary group wanting independence for Quebec [n]\n",
  "FELSIC": "having quartz and feldspar mixed, also FELSITIC [adj]\n",
  "FELSITE": "a fine-grained rock consisting essentially of orthoclase feldspar with occasional grains of quartz, also FELSTONE [n -S]\n",
  "FELSITES": "FELSITE, a fine-grained rock consisting essentially of orthoclase feldspar with occasional grains of quartz, also FELSTONE [n]\n",
  "FELSITIC": "having quartz and feldspar mixed, also FELSIC [adj]\n",
  "FELSPAR": "a common rock-forming mineral, also FELDSPAR, FELDSPATH [n -S]\n",
  "FELSPARS": "FELSPAR, a common rock-forming mineral, also FELDSPAR, FELDSPATH [n]\n",
  "FELSPATHIC": "of or like felspar, also FELDSPATHIC, FELDSPATHOSE, FELSPATHOSE [adj]\n",
  "FELSPATHOID": "any mineral of a group related to feldspar, also FELDSPATHOID, FOID [n -S]\n",
  "FELSPATHOIDS": "FELSPATHOID, any mineral of a group related to feldspar, also FELDSPATHOID, FOID [n]\n",
  "FELSPATHOSE": "of or like felspar, also FELDSPATHIC, FELDSPATHOSE, FELSPATHIC [adj]\n",
  "FELSTONE": "(obsolete) felsite, also FELSITE [n -S]\n",
  "FELSTONES": "FELSTONE, (obsolete) felsite, also FELSITE [n]\n",
  "FELT": "to mat together [v -ED, -ING, -S]\n",
  "FELTED": "FELT, to mat together [v]\n",
  "FELTER": "to mat together like felt [v -ED, -ING, -S]\n",
  "FELTERED": "FELTER, to mat together like felt [v]\n",
  "FELTERING": "FELTER, to mat together like felt [v]\n",
  "FELTERS": "FELTER, to mat together like felt [v]\n",
  "FELTIER": "FELTY, matted like felt [adj]\n",
  "FELTIEST": "FELTY, matted like felt [adj]\n",
  "FELTING": "felted material [n -S]\n",
  "FELTINGS": "FELTING, felted material [n]\n",
  "FELTLIKE": "like a cloth made from wool [adj]\n",
  "FELTS": "FELT, to mat together [v]\n",
  "FELTY": "matted like felt [adj FELTIER, FELTIEST]\n",
  "FELUCCA": "(Italian) a small sailing vessel [n -S]\n",
  "FELUCCAS": "FELUCCA, (Italian) a small sailing vessel [n]\n",
  "FELWORT": "a flowering plant, the gentian [n -S]\n",
  "FELWORTS": "FELWORT, a flowering plant, the gentian [n]\n",
  "FEM": "a passive homosexual [n -S]\n",
  "FEMAL": "(Milton) a female [n -S]\n",
  "FEMALE": "the sex that can bear offspring or produce eggs [n -S]\n",
  "FEMALENESS": "the state of being female [n -ES]\n",
  "FEMALENESSES": "FEMALENESS, the state of being female [n]\n",
  "FEMALES": "FEMALE, the sex that can bear offspring or produce eggs [n]\n",
  "FEMALITIES": "FEMALITY, the quality of being female [n]\n",
  "FEMALITY": "the quality of being female [n FEMALITIES]\n",
  "FEMALS": "FEMAL, (Milton) a female [n]\n",
  "FEME": "a legal term for a woman, as in feme covert, married woman, feme sole, unmarried woman or widow [n -S]\n",
  "FEMERALL": "an outlet for smoke in a roof, also FEMERELL [n -S]\n",
  "FEMERALLS": "FEMERALL, an outlet for smoke in a roof, also FEMERELL [n]\n",
  "FEMERELL": "a ventilator or smoke outlet in a roof, also FEMERALL [n -S]\n",
  "FEMERELLS": "FEMERELL, a ventilator or smoke outlet in a roof, also FEMERALL [n]\n",
  "FEMES": "FEME, a legal term for a woman, as in feme covert, married woman, feme sole, unmarried woman or widow [n]\n",
  "FEMETARIES": "FEMETARY, a plant once used to treat scurvy, also FUMITORY, FEMITER, FENITAR [n]\n",
  "FEMETARY": "a plant once used to treat scurvy, also FUMITORY, FEMITER, FENITAR [n FEMETARIES]\n",
  "FEMICIDAL": "relating to femicide, the killing of women and girls because of their gender [adj]\n",
  "FEMICIDE": "the killing of women and girls because of their gender [n -S]\n",
  "FEMICIDES": "FEMICIDE, the killing of women and girls because of their gender [n]\n",
  "FEMINACIES": "FEMINACY, the state of being a female [n]\n",
  "FEMINACY": "the state of being a female [n FEMINACIES]\n",
  "FEMINAL": "of a man, thinking like a woman [adj]\n",
  "FEMINALITIES": "FEMINALITY, feminity, also FEMALITY, FEMINACY, FEMINEITY, FEMININITY, FEMINITY [n]\n",
  "FEMINALITY": "feminity, also FEMALITY, FEMINACY, FEMINEITY, FEMININITY, FEMINITY [n FEMINALITIES]\n",
  "FEMINAZI": "(offensive) a militant feminist [n -S]\n",
  "FEMINAZIS": "FEMINAZI, (offensive) a militant feminist [n]\n",
  "FEMINEITIES": "FEMINEITY, womanliness, femininity, also FEMALITY, FEMINACY, FEMINALITY, FEMININITY, FEMINITY [n]\n",
  "FEMINEITY": "womanliness, femininity, also FEMALITY, FEMINACY, FEMINALITY, FEMININITY, FEMINITY [n FEMINEITIES]\n",
  "FEMINIE": "women collectively [n -S]\n",
  "FEMINIES": "FEMINIE, women collectively [n]\n",
  "FEMINILITIES": "FEMINILITY, the quality of being female, also FEMININITY [n]\n",
  "FEMINILITY": "the quality of being female, also FEMININITY [n FEMINILITIES]\n",
  "FEMININE": "female [adj FEMININELY] / a word of feminine gender [n -S]\n",
  "FEMININELY": "FEMININE, female [adv]\n",
  "FEMININENESS": "the state of being feminine [n -ES]\n",
  "FEMININENESSES": "FEMININENESS, the state of being feminine [n]\n",
  "FEMININES": "FEMININE, a word of feminine gender [n]\n",
  "FEMININISM": "an addiction to feminine ways [n -S]\n",
  "FEMININISMS": "FEMININISM, an addiction to feminine ways [n]\n",
  "FEMININITIES": "FEMININITY, the quality of being female, also FEMALITY, FEMINACY, FEMINALITY, FEMINEITY, FEMINITY [n]\n",
  "FEMININITY": "the quality of being female, also FEMALITY, FEMINACY, FEMINALITY, FEMINEITY, FEMINITY [n FEMININITIES]\n",
  "FEMINISATION": "the act of feminising, also FEMINIZATION [n -S]\n",
  "FEMINISATIONS": "FEMINISATION, the act of feminising, also FEMINIZATION [n]\n",
  "FEMINISE": "to make womanly, also FEMINIZE [v FEMINISED, FEMINISING, FEMINISES]\n",
  "FEMINISED": "FEMINISE, to make womanly, also FEMINIZE [v]\n",
  "FEMINISES": "FEMINISE, to make womanly, also FEMINIZE [v]\n",
  "FEMINISING": "FEMINISE, to make womanly, also FEMINIZE [v]\n",
  "FEMINISM": "advocacy of woman's rights [n -S]\n",
  "FEMINISMS": "FEMINISM, advocacy of woman's rights [n]\n",
  "FEMINIST": "a supporter of feminism [n -S]\n",
  "FEMINISTIC": "relating to feminism [adj]\n",
  "FEMINISTS": "FEMINIST, a supporter of feminism [n]\n",
  "FEMINITIES": "FEMINITY, the quality of being a woman [n]\n",
  "FEMINITY": "the quality of being a woman [n FEMINITIES]\n",
  "FEMINIZATION": "the act of feminizing, also FEMINISATION [n -S]\n",
  "FEMINIZATIONS": "FEMINIZATION, the act of feminizing, also FEMINISATION [n]\n",
  "FEMINIZE": "to make womanly, also FEMINISE [v FEMINIZED, FEMINIZING, FEMINIZES]\n",
  "FEMINIZED": "FEMINIZE, to make womanly, also FEMINISE [v]\n",
  "FEMINIZES": "FEMINIZE, to make womanly, also FEMINISE [v]\n",
  "FEMINIZING": "FEMINIZE, to make womanly, also FEMINISE [v]\n",
  "FEMITER": "(Shakespeare) a plant once used to treat scurvy, also FUMITORY, FEMETARY, FENITAR [n -S]\n",
  "FEMITERS": "FEMITER, (Shakespeare) a plant once used to treat scurvy, also FUMITORY, FEMETARY, FENITAR [n]\n",
  "FEMME": "(French) a woman [n -S]\n",
  "FEMMES": "FEMME, (French) a woman [n]\n",
  "FEMMIER": "FEMMY, markedly feminine in appearance [adj]\n",
  "FEMMIEST": "FEMMY, markedly feminine in appearance [adj]\n",
  "FEMMY": "markedly feminine in appearance [adj FEMMIER, FEMMIEST]\n",
  "FEMORA": "FEMUR, (Latin) a bone in the leg [n]\n",
  "FEMORAL": "pertaining to the femur [adj]\n",
  "FEMS": "FEM, a passive homosexual [n]\n",
  "FEMTOSECOND": "one quadrillionth part of a second [n -S]\n",
  "FEMTOSECONDS": "FEMTOSECOND, one quadrillionth part of a second [n]\n",
  "FEMUR": "(Latin) a bone in the leg [n FEMURS or FEMORA]\n",
  "FEMURS": "FEMUR, (Latin) a bone in the leg [n]\n",
  "FEN": "wet land with alkaline, neutral, or only slightly acid peaty soil [n -S]\n",
  "FENAGLE": "to obtain by trickery, also FINAGLE [v FENAGLED, FENAGLING, FENAGLES]\n",
  "FENAGLED": "FENAGLE, to obtain by trickery, also FINAGLE [v]\n",
  "FENAGLES": "FENAGLE, to obtain by trickery, also FINAGLE [v]\n",
  "FENAGLING": "FENAGLE, to obtain by trickery, also FINAGLE [v]\n",
  "FENCE": "to enclose with a barrier [v FENCED, FENCING, FENCES]\n",
  "FENCED": "FENCE, to enclose with a barrier [v]\n",
  "FENCELESS": "without a fence [adj]\n",
  "FENCELESSNESS": "FENCELESS, without a fence [n]\n",
  "FENCELESSNESSES": "FENCELESSNESS, FENCELESS, without a fence [n]\n",
  "FENCELIKE": "like a fence [adj]\n",
  "FENCELINE": "the continuous extent of fence encompassing a tract of land, especially on a ranch [n -S]\n",
  "FENCELINES": "FENCELINE, the continuous extent of fence encompassing a tract of land, especially on a ranch [n]\n",
  "FENCER": "one who fences [n -S]\n",
  "FENCEROW": "the land occupied by a fence [n -S]\n",
  "FENCEROWS": "FENCEROW, the land occupied by a fence [n]\n",
  "FENCERS": "FENCER, one who fences [n]\n",
  "FENCES": "FENCE, to enclose with a barrier [v]\n",
  "FENCEWIRE": "the wire used in making fences on farms, ranches [n -S]\n",
  "FENCEWIRES": "FENCEWIRE, the wire used in making fences on farms, ranches [n]\n",
  "FENCIBLE": "a soldier enlisted for home service only [n -S]\n",
  "FENCIBLES": "FENCIBLE, a soldier enlisted for home service only [n]\n",
  "FENCING": "the art of using a sword in attack and defense [n -S]\n",
  "FENCINGS": "FENCING, the art of using a sword in attack and defense [n]\n",
  "FEND": "to ward off [v -ED, -ING, -S]\n",
  "FENDED": "FEND, to ward off [v]\n",
  "FENDER": "a metal guard over a wheel [n -S]\n",
  "FENDERED": "having a fender [adj]\n",
  "FENDERLESS": "not having a fender [adj]\n",
  "FENDERS": "FENDER, a metal guard over a wheel [n]\n",
  "FENDIER": "FENDY, (Scots) resourceful, thrifty [adj]\n",
  "FENDIEST": "FENDY, (Scots) resourceful, thrifty [adj]\n",
  "FENDING": "FEND, to ward off [v]\n",
  "FENDS": "FEND, to ward off [v]\n",
  "FENDY": "(Scots) resourceful, thrifty [adj FENDIER, FENDIEST]\n",
  "FENESTELLA": "a recess in church wall for storing communion vessels [n FENESTELLAS or FENESTELLAE]\n",
  "FENESTELLAE": "FENESTELLA, a recess in church wall for storing communion vessels [n]\n",
  "FENESTELLAS": "FENESTELLA, a recess in church wall for storing communion vessels [n]\n",
  "FENESTRA": "(Latin) a perforation [n FENESTRAS or FENESTRAE]\n",
  "FENESTRAE": "FENESTRA, (Latin) a perforation [n]\n",
  "FENESTRAL": "of or pertaining to windows [adj] / a window with some other translucent material instead of glass [n -S]\n",
  "FENESTRALS": "FENESTRAL, a window with some other translucent material instead of glass [n]\n",
  "FENESTRAS": "FENESTRA, (Latin) a perforation [n]\n",
  "FENESTRATE": "to equip with windows [v FENESTRATED, FENESTRATING, FENESTRATES]\n",
  "FENESTRATED": "FENESTRATE, to equip with windows [v]\n",
  "FENESTRATES": "FENESTRATE, to equip with windows [v]\n",
  "FENESTRATING": "FENESTRATE, to equip with windows [v]\n",
  "FENESTRATION": "the arrangement, proportioning, and design of windows and doors in a building [n -S]\n",
  "FENESTRATIONS": "FENESTRATION, the arrangement, proportioning, and design of windows and doors in a building [n]\n",
  "FENI": "(Hindi) an alcoholic spirit made from coconuts, also FENNY [n -S]\n",
  "FENING": "a monetary unit of Bosnia and Herzegovina, also FENNING [n FENINGS or FENINGA]\n",
  "FENINGA": "FENING, a monetary unit of Bosnia and Herzegovina, also FENNING [n]\n",
  "FENINGS": "FENING, a monetary unit of Bosnia and Herzegovina, also FENNING [n]\n",
  "FENIS": "FENI, (Hindi) an alcoholic spirit made from coconuts, also FENNY [n]\n",
  "FENITAR": "a plant once used to treat scurvy, also FUMITORY, FEMETARY, FEMITER [n -S]\n",
  "FENITARS": "FENITAR, a plant once used to treat scurvy, also FUMITORY, FEMETARY, FEMITER [n]\n",
  "FENKS": "the refuse of whale-blubber [n FENKS]\n",
  "FENLAND": "a region with fens [n -S]\n",
  "FENLANDS": "FENLAND, a region with fens [n]\n",
  "FENMAN": "a fen country resident [n FENMEN]\n",
  "FENMEN": "FENMAN, a fen country resident [n]\n",
  "FENNEC": "(Arabic) the desert fox [n -S]\n",
  "FENNECS": "FENNEC, (Arabic) the desert fox [n]\n",
  "FENNEL": "a yellow-flowered umbelliferous plant [n -S]\n",
  "FENNELFLOWER": "any of various species of the plant nigella with finely-divided leaves [n -S]\n",
  "FENNELFLOWERS": "FENNELFLOWER, any of various species of the plant nigella with finely-divided leaves [n]\n",
  "FENNELS": "FENNEL, a yellow-flowered umbelliferous plant [n]\n",
  "FENNIER": "FENNY, having fens [adj]\n",
  "FENNIES": "FENNY, an alcoholic spirit made from coconuts, also FENI [n]\n",
  "FENNIEST": "FENNY, having fens [adj]\n",
  "FENNING": "a monetary unit of Bosnia and Herzegovina, equal to one-hundredth of a marka, also FENING [n FENNING]\n",
  "FENNISH": "abounding in fens; fenny [adj]\n",
  "FENNY": "an alcoholic spirit made from coconuts, also FENI [n FENNIES] / having fens [adj FENNIER, FENNIEST]\n",
  "FENS": "FEN, wet land with alkaline, neutral, or only slightly acid peaty soil [n]\n",
  "FENT": "a slit [n -S]\n",
  "FENTANYL": "a narcotic opioid [n -S]\n",
  "FENTANYLS": "FENTANYL, a narcotic opioid [n]\n",
  "FENTHION": "an insecticide [n -S]\n",
  "FENTHIONS": "FENTHION, an insecticide [n]\n",
  "FENTS": "FENT, a slit [n]\n",
  "FENUGREEK": "a kind of herb [n -S]\n",
  "FENUGREEKS": "FENUGREEK, a kind of herb [n]\n",
  "FENURON": "a herbicide [n -S]\n",
  "FENURONS": "FENURON, a herbicide [n]\n",
  "FEOD": "a fief or land held on condition of service [n -S]\n",
  "FEODAL": "relating to feuds or fiefs, also FEUDAL [adj]\n",
  "FEODARIES": "FEODARY, one holding lands or power by a feudal tenure, also FEUDARY, FEUDATORY [n]\n",
  "FEODARY": "one holding lands or power by a feudal tenure, also FEUDARY, FEUDATORY [n FEODARIES]\n",
  "FEODS": "FEOD, a fief or land held on condition of service [n]\n",
  "FEOFF": "to grant a feudal estate to [v -ED, -ING, -S]\n",
  "FEOFFED": "FEOFF, to grant a feudal estate to [v]\n",
  "FEOFFEE": "one to whom a feudal estate is granted [n -S]\n",
  "FEOFFEES": "FEOFFEE, one to whom a feudal estate is granted [n]\n",
  "FEOFFER": "one that grants a feudal estate to another, also FEOFFOR [n -S]\n",
  "FEOFFERS": "FEOFFER, one that grants a feudal estate to another, also FEOFFOR [n]\n",
  "FEOFFING": "FEOFF, to grant a feudal estate to [v]\n",
  "FEOFFMENT": "the gift of a fief [n -S]\n",
  "FEOFFMENTS": "FEOFFMENT, the gift of a fief [n]\n",
  "FEOFFOR": "one that grants a feudal estate to another, also FEOFFER [n -S]\n",
  "FEOFFORS": "FEOFFOR, one that grants a feudal estate to another, also FEOFFER [n]\n",
  "FEOFFS": "FEOFF, to grant a feudal estate to [v]\n",
  "FER": "(dialect) for [prep]\n",
  "FERACIOUS": "prolific, fruitful [adj]\n",
  "FERACITIES": "FERACITY, the state of being feracious, fruitful [n]\n",
  "FERACITY": "the state of being feracious, fruitful [n FERACITIES]\n",
  "FERAL": "of a species which breeds in the wild but is derived from domesticated stock [adj] / a person who displays wild tendencies [n -S]\n",
  "FERALISED": "run wild following domestication, also FERALIZED [adj]\n",
  "FERALIZED": "run wild following domestication, also FERALISED [adj]\n",
  "FERALS": "FERAL, a person who displays wild tendencies [n]\n",
  "FERBAM": "a fungicide [n -S]\n",
  "FERBAMS": "FERBAM, a fungicide [n]\n",
  "FERE": "(Scots) a companion, also FEARE, FIER, FIERE, PHEER, PHEERE [n -S] / able [adj FERER, FEREST]\n",
  "FERER": "FERE, able [adj]\n",
  "FERES": "FERE, (Scots) a companion, also FEARE, FIER, FIERE, PHEER, PHEERE [n]\n",
  "FEREST": "FERE, able [adj]\n",
  "FERETORIES": "FERETORY, a receptacle where sacred relics are stored [n]\n",
  "FERETORY": "a receptacle where sacred relics are stored [n FERETORIES]\n",
  "FERIA": "(Latin) a weekday which is neither a fast nor a festival [n FERIAS or FERIAE]\n",
  "FERIAE": "FERIA, (Latin) a weekday which is neither a fast nor a festival [n]\n",
  "FERIAL": "pertaining to holidays [adj]\n",
  "FERIAS": "FERIA, (Latin) a weekday which is neither a fast nor a festival [n]\n",
  "FERINE": "of a species which breeds in the wild but is derived from domesticated stock [adj]\n",
  "FERITIES": "FERITY, the state of being wild or savage [n]\n",
  "FERITY": "the state of being wild or savage [n FERITIES]\n",
  "FERLIE": "(archaic) a wonder, a marvel [n -S]\n",
  "FERLIED": "FERLY, to wonder [v]\n",
  "FERLIER": "FERLY, marvellous [adj]\n",
  "FERLIES": "FERLIE, (archaic) a wonder, a marvel [n]\n",
  "FERLIEST": "FERLY, marvellous [adj]\n",
  "FERLY": "marvellous [adj FERLIER, FERLIEST] / to wonder [v FERLIED, FERLYING, FERLIES]\n",
  "FERLYING": "FERLY, to wonder [v]\n",
  "FERM": "(Spenser) a farm, lodging [n -S]\n",
  "FERMATA": "(Italian) a pause in music [n FERMATAS or FERMATE]\n",
  "FERMATAS": "FERMATA, (Italian) a pause in music [n]\n",
  "FERMATE": "FERMATA, (Italian) a pause in music [n]\n",
  "FERMENT": "to undergo a type of chemical reaction [v -ED, -ING, -S]\n",
  "FERMENTABILITY": "the quality of being fermentable [n]\n",
  "FERMENTABLE": "that can be fermented [adj]\n",
  "FERMENTATION": "a chemical change with effervescence, as by the action of yeast [n -S]\n",
  "FERMENTATIONS": "FERMENTATION, a chemical change with effervescence, as by the action of yeast [n]\n",
  "FERMENTATIVE": "causing or consisting of fermentation [adj FERMENTATIVELY]\n",
  "FERMENTATIVELY": "FERMENTATIVE, causing or consisting of fermentation [adv]\n",
  "FERMENTED": "FERMENT, to undergo a type of chemical reaction [v]\n",
  "FERMENTER": "an agent that causes fermentation, also FERMENTOR [n -S]\n",
  "FERMENTERS": "FERMENTER, an agent that causes fermentation, also FERMENTOR [n]\n",
  "FERMENTESCIBLE": "capable of being fermented [adj]\n",
  "FERMENTING": "FERMENT, to undergo a type of chemical reaction [v]\n",
  "FERMENTITIOUS": "promoting fermentation [adj]\n",
  "FERMENTIVE": "relating to fermentation [adj]\n",
  "FERMENTOR": "an agent that causes fermentation, also FERMENTER [n -S]\n",
  "FERMENTORS": "FERMENTOR, an agent that causes fermentation, also FERMENTER [n]\n",
  "FERMENTS": "FERMENT, to undergo a type of chemical reaction [v]\n",
  "FERMI": "in physics, a unit of 10 to power of -15 m [n -S]\n",
  "FERMION": "a type of subatomic particle [n -S]\n",
  "FERMIONIC": "of or like a fermion [adj]\n",
  "FERMIONS": "FERMION, a type of subatomic particle [n]\n",
  "FERMIS": "FERMI, in physics, a unit of 10 to power of -15 m [n]\n",
  "FERMIUM": "a radioactive element [n -S]\n",
  "FERMIUMS": "FERMIUM, a radioactive element [n]\n",
  "FERMS": "FERM, (Spenser) a farm, lodging [n]\n",
  "FERN": "a flowerless vascular plant [n -S]\n",
  "FERNALLIES": "FERNALLY, a vascular flowerless plant, a pteridophyte, other than a fern [n]\n",
  "FERNALLY": "a vascular flowerless plant, a pteridophyte, other than a fern [n FERNALLIES]\n",
  "FERNBIRD": "a small New Zealand bird [n -S]\n",
  "FERNBIRDS": "FERNBIRD, a small New Zealand bird [n]\n",
  "FERNERIES": "FERNERY, a place where ferns are grown [n]\n",
  "FERNERY": "a place where ferns are grown [n FERNERIES]\n",
  "FERNIER": "FERNY, covered with ferns [adj]\n",
  "FERNIEST": "FERNY, covered with ferns [adj]\n",
  "FERNING": "a tendency for cervical mucus to become feathery [n -S]\n",
  "FERNINGS": "FERNING, a tendency for cervical mucus to become feathery [n]\n",
  "FERNINST": "right opposite to in location, also FOREANENT, FORNENST, FORNENT [adv]\n",
  "FERNITICKLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FERNITICKLES": "FERNITICKLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FERNITICLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FERNITICLES": "FERNITICLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNTICKLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FERNLESS": "without ferns [adj]\n",
  "FERNLIKE": "like a fern [adj]\n",
  "FERNS": "FERN, a flowerless vascular plant [n]\n",
  "FERNSHAW": "a thicket of ferns [n -S]\n",
  "FERNSHAWS": "FERNSHAW, a thicket of ferns [n]\n",
  "FERNTICKLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FERNTICKLED": "(Scots) freckled, also FERNTICLED [adj]\n",
  "FERNTICKLES": "FERNTICKLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FERNTICLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNYTICKLE, FERNYTICLE [n -S]\n",
  "FERNTICLED": "(Scots) freckled, also FERNTICKLED [adj]\n",
  "FERNTICLES": "FERNTICLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNYTICKLE, FERNYTICLE [n]\n",
  "FERNY": "covered with ferns [adj FERNIER, FERNIEST]\n",
  "FERNYTICKLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICLE [n -S]\n",
  "FERNYTICKLES": "FERNYTICKLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICLE [n]\n",
  "FERNYTICLE": "(Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE [n -S]\n",
  "FERNYTICLES": "FERNYTICLE, (Scots) a freckle, also FAIRNITICKLE, FAIRNITICLE, FAIRNYTICKLE, FAIRNYTICLE, FERNITICKLE, FERNITICLE, FERNTICKLE, FERNTICLE, FERNYTICKLE [n]\n",
  "FEROCIOUS": "fierce [adj FEROCIOUSLY]\n",
  "FEROCIOUSLY": "FEROCIOUS, fierce [adv]\n",
  "FEROCIOUSNESS": "FEROCIOUS, fierce [n]\n",
  "FEROCIOUSNESSES": "FEROCIOUSNESS, FEROCIOUS, fierce [n]\n",
  "FEROCITIES": "FEROCITY, fierceness [n]\n",
  "FEROCITY": "fierceness [n FEROCITIES]\n",
  "FERRANDINE": "(obsolete) a silk and wool cloth, also FARANDINE, FARRANDINE [n -S]\n",
  "FERRANDINES": "FERRANDINE, (obsolete) a silk and wool cloth, also FARANDINE, FARRANDINE [n]\n",
  "FERRATE": "a salt of ferric acid [n -S]\n",
  "FERRATES": "FERRATE, a salt of ferric acid [n]\n",
  "FERREDOXIN": "an iron-containing plant protein [n -S]\n",
  "FERREDOXINS": "FERREDOXIN, an iron-containing plant protein [n]\n",
  "FERREL": "to fit with a metal cap to prevent splitting, also FERRULE, FERULE [v FERRELLED or FERRELED, FERRELLING or FERRELING, FERRELS]\n",
  "FERRELED": "FERREL, to fit with a metal cap to prevent splitting, also FERRULE, FERULE [v]\n",
  "FERRELING": "FERREL, to fit with a metal cap to prevent splitting, also FERRULE, FERULE [v]\n",
  "FERRELLED": "FERREL, to fit with a metal cap to prevent splitting, also FERRULE, FERULE [v]\n",
  "FERRELLING": "FERREL, to fit with a metal cap to prevent splitting, also FERRULE, FERULE [v]\n",
  "FERRELS": "FERREL, to fit with a metal cap to prevent splitting, also FERRULE, FERULE [v]\n",
  "FERREOUS": "containing iron [adj]\n",
  "FERRET": "to search out persistently [v -ED, -ING, -S]\n",
  "FERRETED": "FERRET, to search out persistently [v]\n",
  "FERRETER": "one who ferrets [n -S]\n",
  "FERRETERS": "FERRETER, one who ferrets [n]\n",
  "FERRETIER": "FERRETY, like a ferret in appearance [adj]\n",
  "FERRETIEST": "FERRETY, like a ferret in appearance [adj]\n",
  "FERRETING": "rummaging about [n -S]\n",
  "FERRETINGS": "FERRETING, rummaging about [n]\n",
  "FERRETS": "FERRET, to search out persistently [v]\n",
  "FERRETY": "like a ferret in appearance [adj FERRETIER, FERRETIEST]\n",
  "FERRIAGE": "the fare paid for ferrying [n -S]\n",
  "FERRIAGES": "FERRIAGE, the fare paid for ferrying [n]\n",
  "FERRIC": "pertaining to iron [adj]\n",
  "FERRICYANIC": "pertaining to a ferricyanide [adj]\n",
  "FERRICYANIDE": "a salt of hydroferricyanic acid [n -S]\n",
  "FERRICYANIDES": "FERRICYANIDE, a salt of hydroferricyanic acid [n]\n",
  "FERRICYANOGEN": "the trivalent radical of the ferricyanides [n -S]\n",
  "FERRICYANOGENS": "FERRICYANOGEN, the trivalent radical of the ferricyanides [n]\n",
  "FERRIED": "FERRY, to transport by a type of boat [v]\n",
  "FERRIES": "FERRY, to transport by a type of boat [v]\n",
  "FERRIFEROUS": "bearing iron [adj]\n",
  "FERRIMAGNET": "an iron magnet in which the magnetic moments of neighbouring ions are nonparallel [n -S]\n",
  "FERRIMAGNETIC": "of or relating to a substance (as ferrite) characterized by magnetization in which two types of ions of unequal magnetic moment are polarized in opposite directions [adj]\n",
  "FERRIMAGNETISM": "the state of being ferrimagnetic [n -S]\n",
  "FERRIMAGNETISMS": "FERRIMAGNETISM, the state of being ferrimagnetic [n]\n",
  "FERRIMAGNETS": "FERRIMAGNET, an iron magnet in which the magnetic moments of neighbouring ions are nonparallel [n]\n",
  "FERRITE": "a form of pure iron [n -S]\n",
  "FERRITES": "FERRITE, a form of pure iron [n]\n",
  "FERRITIC": "consisting mainly of ferrite, a form of pure iron [adj]\n",
  "FERRITIN": "a protein in which iron is stored in the liver [n -S]\n",
  "FERRITINS": "FERRITIN, a protein in which iron is stored in the liver [n]\n",
  "FERROCENE": "an orange crystalline compound used as a fuel additive [n -S]\n",
  "FERROCENES": "FERROCENE, an orange crystalline compound used as a fuel additive [n]\n",
  "FERROCHROME": "an alloy of iron with chromium, also FERROCHROMIUM [n -S]\n",
  "FERROCHROMES": "FERROCHROME, an alloy of iron with chromium, also FERROCHROMIUM [n]\n",
  "FERROCHROMIUM": "an alloy of iron with chromium, also FERROCHROME [n -S]\n",
  "FERROCHROMIUMS": "FERROCHROMIUM, an alloy of iron with chromium, also FERROCHROME [n]\n",
  "FERROCONCRETE": "reinforced concrete [n -S]\n",
  "FERROCONCRETES": "FERROCONCRETE, reinforced concrete [n]\n",
  "FERROCYANIC": "pertaining to a ferrocyanide [adj]\n",
  "FERROCYANIDE": "a salt of hydroferrocyanic acid [n -S]\n",
  "FERROCYANIDES": "FERROCYANIDE, a salt of hydroferrocyanic acid [n]\n",
  "FERROCYANOGEN": "the quadrivalent radical of the ferricyanides [n -S]\n",
  "FERROCYANOGENS": "FERROCYANOGEN, the quadrivalent radical of the ferricyanides [n]\n",
  "FERROELECTRIC": "exhibiting electric polarization [adj] / a ferroelectric substance [n -S]\n",
  "FERROELECTRICS": "FERROELECTRIC, a ferroelectric substance [n]\n",
  "FERROGRAM": "a slide prepared to illustrate the suspended iron particles in the lubricant of a machine [n -S]\n",
  "FERROGRAMS": "FERROGRAM, a slide prepared to illustrate the suspended iron particles in the lubricant of a machine [n]\n",
  "FERROGRAPHIES": "FERROGRAPHY, a technique for measuring magnetically the wear on machinery [n]\n",
  "FERROGRAPHY": "a technique for measuring magnetically the wear on machinery [n FERROGRAPHIES]\n",
  "FERROMAGNESIAN": "containing iron and magnesium, as applied to the mafic minerals, e.g. olivine [adj]\n",
  "FERROMAGNET": "a type of strong magnet [n -S]\n",
  "FERROMAGNETIC": "of or relating to substances with an abnormally high magnetic permeability, a definite saturation point, and appreciable residual magnetism and hysteresis [adj]\n",
  "FERROMAGNETISM": "the state of being ferromagnetic [n -S]\n",
  "FERROMAGNETISMS": "FERROMAGNETISM, the state of being ferromagnetic [n]\n",
  "FERROMAGNETS": "FERROMAGNET, a type of strong magnet [n]\n",
  "FERROMANGANESE": "an alloy of iron and manganese used in the manufacture of steel [n -S]\n",
  "FERROMANGANESES": "FERROMANGANESE, an alloy of iron and manganese used in the manufacture of steel [n]\n",
  "FERROMOLYBDENUM": "an alloy of iron with molybdenum [n]\n",
  "FERRONICKEL": "an alloy of iron and nickel [n -S]\n",
  "FERRONICKELS": "FERRONICKEL, an alloy of iron and nickel [n]\n",
  "FERRONIERE": "(French) a jewel held on a forehead by a chain, also FERRONNIERE [n -S]\n",
  "FERRONIERES": "FERRONIERE, (French) a jewel held on a forehead by a chain, also FERRONNIERE [n]\n",
  "FERRONNIERE": "(French) a jewel held on a forehead by a chain, also FERRONIERE [n -S]\n",
  "FERRONNIERES": "FERRONNIERE, (French) a jewel held on a forehead by a chain, also FERRONIERE [n]\n",
  "FERROPRUSSIATE": "ferrocyanide [n -S]\n",
  "FERROPRUSSIATES": "FERROPRUSSIATE, ferrocyanide [n]\n",
  "FERROSILICON": "an alloy of iron and silicon, used in making cast iron and steel [n -S]\n",
  "FERROSILICONS": "FERROSILICON, an alloy of iron and silicon, used in making cast iron and steel [n]\n",
  "FERROSOFERRIC": "combining ferrous and ferric [adj]\n",
  "FERROTYPE": "an old form of photograph taken using a film on an iron plate [n -S] / to take a photograph by ferrotype [v FERROTYPED, FERROTYPING, FERROTYPES]\n",
  "FERROTYPED": "FERROTYPE, to take a photograph by ferrotype [v]\n",
  "FERROTYPES": "FERROTYPE, an old form of photograph taken using a film on an iron plate [n]\n",
  "FERROTYPING": "FERROTYPE, to take a photograph by ferrotype [v]\n",
  "FERROUS": "pertaining to iron [adj]\n",
  "FERRUGINEOUS": "of the colour of iron-rust, also FERRUGINOUS [adj]\n",
  "FERRUGINOUS": "of the colour of iron-rust, also FERRUGINEOUS [adj]\n",
  "FERRUGO": "(Latin) a disease of plants caused by fungi, commonly called the rust, from its resemblance to iron rust in color [n -S]\n",
  "FERRUGOS": "FERRUGO, (Latin) a disease of plants caused by fungi, commonly called the rust, from its resemblance to iron rust in color [n]\n",
  "FERRULE": "to fit with a metal cap to prevent splitting, also FERREL, FERULE [v FERRULED, FERRULING, FERRULES]\n",
  "FERRULED": "FERRULE, to fit with a metal cap to prevent splitting, also FERREL, FERULE [v]\n",
  "FERRULES": "FERRULE, to fit with a metal cap to prevent splitting, also FERREL, FERULE [v]\n",
  "FERRULING": "FERRULE, to fit with a metal cap to prevent splitting, also FERREL, FERULE [v]\n",
  "FERRUM": "(Latin) iron [n -S]\n",
  "FERRUMS": "FERRUM, (Latin) iron [n]\n",
  "FERRY": "to transport by a type of boat [v FERRIED, FERRYING, FERRIES]\n",
  "FERRYBOAT": "a boat used on a ferry [n -S]\n",
  "FERRYBOATS": "FERRYBOAT, a boat used on a ferry [n]\n",
  "FERRYING": "FERRY, to transport by a type of boat [v]\n",
  "FERRYMAN": "a man who operates a ferry [n FERRYMEN]\n",
  "FERRYMEN": "FERRYMAN, a man who operates a ferry [n]\n",
  "FERTIGATE": "to fertilize and irrigate at the same time [v FERTIGATED, FERTIGATING, FERTIGATES]\n",
  "FERTIGATED": "FERTIGATE, to fertilize and irrigate at the same time [v]\n",
  "FERTIGATES": "FERTIGATE, to fertilize and irrigate at the same time [v]\n",
  "FERTIGATING": "FERTIGATE, to fertilize and irrigate at the same time [v]\n",
  "FERTIGATION": "fertilisation and irrigation at the same time [n -S]\n",
  "FERTIGATIONS": "FERTIGATION, fertilisation and irrigation at the same time [n]\n",
  "FERTILE": "productive [adj FERTILER, FERTILEST, FERTILELY]\n",
  "FERTILELY": "FERTILE, productive [adv]\n",
  "FERTILENESS": "the state of being fertile [n -ES]\n",
  "FERTILENESSES": "FERTILENESS, the state of being fertile [n]\n",
  "FERTILER": "FERTILE, productive [adj]\n",
  "FERTILEST": "FERTILE, productive [adj]\n",
  "FERTILISABLE": "capable of being fertilised, also FERTILIZABLE [adj]\n",
  "FERTILISATION": "the process by which an egg is made capable of generating offspring, also FERTILIZATION [n -S]\n",
  "FERTILISATIONS": "FERTILISATION, the process by which an egg is made capable of generating offspring, also FERTILIZATION [n]\n",
  "FERTILISE": "to make fertile, also FERTILIZE [v FERTILISED, FERTILISING, FERTILISES]\n",
  "FERTILISED": "FERTILISE, to make fertile, also FERTILIZE [v]\n",
  "FERTILISER": "a person or thing that fertilizes, also FERTILIZER [n -S]\n",
  "FERTILISERS": "FERTILISER, a person or thing that fertilizes, also FERTILIZER [n]\n",
  "FERTILISES": "FERTILISE, to make fertile, also FERTILIZE [v]\n",
  "FERTILISING": "FERTILISE, to make fertile, also FERTILIZE [v]\n",
  "FERTILITIES": "FERTILITY, the state of being fertile [n]\n",
  "FERTILITY": "the state of being fertile [n FERTILITIES]\n",
  "FERTILIZABLE": "capable of being fertilized, also FERTILISABLE [adj]\n",
  "FERTILIZATION": "the process by which an egg is made capable of generating offspring, also FERTILISATION [n -S]\n",
  "FERTILIZATIONS": "FERTILIZATION, the process by which an egg is made capable of generating offspring, also FERTILISATION [n]\n",
  "FERTILIZE": "to make fertile, also FERTILISE [v FERTILIZED, FERTILIZING, FERTILIZES]\n",
  "FERTILIZED": "FERTILIZE, to make fertile, also FERTILISE [v]\n",
  "FERTILIZER": "a person or thing that fertilizes, also FERTILISER [n -S]\n",
  "FERTILIZERS": "FERTILIZER, a person or thing that fertilizes, also FERTILISER [n]\n",
  "FERTILIZES": "FERTILIZE, to make fertile, also FERTILISE [v]\n",
  "FERTILIZING": "FERTILIZE, to make fertile, also FERTILISE [v]\n",
  "FERULA": "(Latin) a flat piece of wood, also FERULE [n FERULAS or FERULAE]\n",
  "FERULACEOUS": "like a cane or reed [adj]\n",
  "FERULAE": "FERULA, (Latin) a flat piece of wood, also FERULE [n]\n",
  "FERULAS": "FERULA, (Latin) a flat piece of wood, also FERULE [n]\n",
  "FERULE": "to fit with a metal cap to prevent splitting, also FERREL, FERRULE [v FERULED, FERULING, FERULES]\n",
  "FERULED": "FERULE, to fit with a metal cap to prevent splitting, also FERREL, FERRULE [v]\n",
  "FERULES": "FERULE, to fit with a metal cap to prevent splitting, also FERREL, FERRULE [v]\n",
  "FERULING": "FERULE, to fit with a metal cap to prevent splitting, also FERREL, FERRULE [v]\n",
  "FERVENCIES": "FERVENCY, eagerness [n]\n",
  "FERVENCY": "eagerness [n FERVENCIES]\n",
  "FERVENT": "hot, glowing, zealous [adj FERVENTER, FERVENTEST, FERVENTLY]\n",
  "FERVENTER": "FERVENT, hot, glowing, zealous [adj]\n",
  "FERVENTEST": "FERVENT, hot, glowing, zealous [adj]\n",
  "FERVENTLY": "FERVENT, hot, glowing, zealous [adv]\n",
  "FERVENTNESS": "the quality of being fervent [n -ES]\n",
  "FERVENTNESSES": "FERVENTNESS, the quality of being fervent [n]\n",
  "FERVESCENT": "growing hot [adj]\n",
  "FERVID": "warm, ardent [adj FERVIDER, FERVIDEST, FERVIDLY]\n",
  "FERVIDER": "FERVID, warm, ardent [adj]\n",
  "FERVIDEST": "FERVID, warm, ardent [adj]\n",
  "FERVIDITIES": "FERVIDITY, the state of being fervid [n]\n",
  "FERVIDITY": "the state of being fervid [n FERVIDITIES]\n",
  "FERVIDLY": "FERVID, warm, ardent [adv]\n",
  "FERVIDNESS": "the state of being fervid [n -ES]\n",
  "FERVIDNESSES": "FERVIDNESS, the state of being fervid [n]\n",
  "FERVOR": "great intensity, also FERVOUR [n -S]\n",
  "FERVOROUS": "full of fervor [adj]\n",
  "FERVORS": "FERVOR, great intensity, also FERVOUR [n]\n",
  "FERVOUR": "great intensity, also FERVOR [n -S]\n",
  "FERVOURS": "FERVOUR, great intensity, also FERVOR [n]\n",
  "FES": "FE, (Hebrew) a Hebrew letter, also FEH, PE, PEH [n]\n",
  "FESCENNINE": "obscene or scurrilous [adj]\n",
  "FESCUE": "a kind of perennial grass [n -S]\n",
  "FESCUES": "FESCUE, a kind of perennial grass [n]\n",
  "FESS": "to confess [v -ED, -ING, -ES]\n",
  "FESSE": "a horizontal band across the middle of a shield [n -S]\n",
  "FESSED": "FESS, to confess [v]\n",
  "FESSES": "FESS, to confess [v]\n",
  "FESSING": "FESS, to confess [v]\n",
  "FESSWISE": "in the manner of a fess, a band over the middle of an escutcheon [adv]\n",
  "FEST": "a gathering of people for an activity [n -S]\n",
  "FESTA": "(Italian) a holiday [n -S]\n",
  "FESTAL": "of or pertaining to a holiday or a feast [adj FESTALLY] / a festivity [n -S]\n",
  "FESTALLY": "FESTAL, of or pertaining to a holiday or a feast [adv]\n",
  "FESTALS": "FESTAL, a festivity [n]\n",
  "FESTAS": "FESTA, (Italian) a holiday [n]\n",
  "FESTER": "to generate pus [v -ED, -ING, -S]\n",
  "FESTERED": "FESTER, to generate pus [v]\n",
  "FESTERING": "FESTER, to generate pus [v]\n",
  "FESTERS": "FESTER, to generate pus [v]\n",
  "FESTIER": "FESTY, (Australian slang) very bad [adj]\n",
  "FESTIEST": "FESTY, (Australian slang) very bad [adj]\n",
  "FESTILOGIES": "FESTILOGY, a treatise on ecclesiastical festivals, also FESTOLOGY [n]\n",
  "FESTILOGY": "a treatise on ecclesiastical festivals, also FESTOLOGY [n FESTILOGIES]\n",
  "FESTINATE": "quick [adj FESTINATELY] / to hasten [v FESTINATED, FESTINATING, FESTINATES]\n",
  "FESTINATED": "FESTINATE, to hasten [v]\n",
  "FESTINATELY": "FESTINATE, quick [adv]\n",
  "FESTINATES": "FESTINATE, to hasten [v]\n",
  "FESTINATING": "FESTINATE, to hasten [v]\n",
  "FESTINATION": "haste; hurrying walk, symptom of some nervous diseases [n -S]\n",
  "FESTINATIONS": "FESTINATION, haste; hurrying walk, symptom of some nervous diseases [n]\n",
  "FESTIVAL": "a time of celebration [n -S]\n",
  "FESTIVALGOER": "one who attends a festival [n -S]\n",
  "FESTIVALGOERS": "FESTIVALGOER, one who attends a festival [n]\n",
  "FESTIVALS": "FESTIVAL, a time of celebration [n]\n",
  "FESTIVE": "befitting a festival [adj FESTIVELY]\n",
  "FESTIVELY": "FESTIVE, befitting a festival [adv]\n",
  "FESTIVENESS": "the state of being festive [n -ES]\n",
  "FESTIVENESSES": "FESTIVENESS, the state of being festive [n]\n",
  "FESTIVITIES": "FESTIVITY, conviviality, joyfulness [n]\n",
  "FESTIVITY": "conviviality, joyfulness [n FESTIVITIES]\n",
  "FESTIVOUS": "(archaic) festive [adj]\n",
  "FESTOLOGIES": "FESTOLOGY, a treatise on ecclesiastical festivals, also FESTILOGY [n]\n",
  "FESTOLOGY": "a treatise on ecclesiastical festivals, also FESTILOGY [n FESTOLOGIES]\n",
  "FESTOON": "to adorn with garlands [v -ED, -ING, -S]\n",
  "FESTOONED": "FESTOON, to adorn with garlands [v]\n",
  "FESTOONERIES": "FESTOONERY, festoons collectively [n]\n",
  "FESTOONERY": "festoons collectively [n FESTOONERIES]\n",
  "FESTOONING": "FESTOON, to adorn with garlands [v]\n",
  "FESTOONS": "FESTOON, to adorn with garlands [v]\n",
  "FESTS": "FEST, a gathering of people for an activity [n]\n",
  "FESTSCHRIFT": "(German) a volume of writing by different authors presented as a tribute or memorial esp. to a scholar [n FESTSCHRIFTS or FESTSCHRIFTEN]\n",
  "FESTSCHRIFTEN": "FESTSCHRIFT, (German) a volume of writing by different authors presented as a tribute or memorial esp. to a scholar [n]\n",
  "FESTSCHRIFTS": "FESTSCHRIFT, (German) a volume of writing by different authors presented as a tribute or memorial esp. to a scholar [n]\n",
  "FESTY": "(Australian slang) very bad [adj FESTIER, FESTIEST]\n",
  "FET": "(obsolete) to fetch, also FETCH, FETT [v FETTED, FETTING, FETS]\n",
  "FETA": "(Modern Greek) a crumbly white cheese, also FETTA [n -S]\n",
  "FETAL": "pertaining to a fetus, also FOETAL [adj]\n",
  "FETAS": "FETA, (Modern Greek) a crumbly white cheese, also FETTA [n]\n",
  "FETATION": "the development of a fetus, also FOETATION [n -S]\n",
  "FETATIONS": "FETATION, the development of a fetus, also FOETATION [n]\n",
  "FETCH": "to go after and bring back [v -ED, -ING, -ES]\n",
  "FETCHED": "FETCH, to go after and bring back [v]\n",
  "FETCHER": "one who fetches [n -S]\n",
  "FETCHERS": "FETCHER, one who fetches [n]\n",
  "FETCHES": "FETCH, to go after and bring back [v]\n",
  "FETCHING": "attractive [adj FETCHINGLY]\n",
  "FETCHINGLY": "FETCHING, attractive [adv]\n",
  "FETE": "(French) to honour with festivities [v FETED, FETING, FETES]\n",
  "FETED": "FETE, (French) to honour with festivities [v]\n",
  "FETERITA": "(Spanish) a cereal grass [n -S]\n",
  "FETERITAS": "FETERITA, (Spanish) a cereal grass [n]\n",
  "FETES": "FETE, (French) to honour with festivities [v]\n",
  "FETIAL": "(Latin) a priest of ancient Rome, also FECIAL, FETIALIS [n -S]\n",
  "FETIALES": "FETIALIS, (Latin) a priest of ancient Rome, also FETIAL, FECIAL [n]\n",
  "FETIALIS": "(Latin) a priest of ancient Rome, also FETIAL, FECIAL [n FETIALES]\n",
  "FETIALS": "FETIAL, (Latin) a priest of ancient Rome, also FECIAL, FETIALIS [n]\n",
  "FETICH": "a fixation, also FETISH, FETICHE [n -ES]\n",
  "FETICHE": "a fixation, also FETISH, FETICH [n -S]\n",
  "FETICHES": "FETICH, a fixation, also FETISH, FETICHE [n]\n",
  "FETICHISE": "to make a fetish of, also FETICHIZE, FETISHISE, FETISHIZE [v FETICHISED, FETICHISING, FETICHISES]\n",
  "FETICHISED": "FETICHISE, to make a fetish of, also FETICHIZE, FETISHISE, FETISHIZE [v]\n",
  "FETICHISES": "FETICHISE, to make a fetish of, also FETICHIZE, FETISHISE, FETISHIZE [v]\n",
  "FETICHISING": "FETICHISE, to make a fetish of, also FETICHIZE, FETISHISE, FETISHIZE [v]\n",
  "FETICHISM": "devotion to or reverence for a fetish or fetishes, also FETISHISM [n -S]\n",
  "FETICHISMS": "FETICHISM, devotion to or reverence for a fetish or fetishes, also FETISHISM [n]\n",
  "FETICHIST": "one who worships a fetish, also FETISHIST [n -S]\n",
  "FETICHISTIC": "relating to or exhibiting fetichism, devotion to or reverence for a fetish or fetishes [adj]\n",
  "FETICHISTS": "FETICHIST, one who worships a fetish, also FETISHIST [n]\n",
  "FETICHIZE": "to make a fetish of, also FETICHISE, FETISHISE, FETISHIZE [v FETICHIZED, FETICHIZING, FETICHIZES]\n",
  "FETICHIZED": "FETICHIZE, to make a fetish of, also FETICHISE, FETISHISE, FETISHIZE [v]\n",
  "FETICHIZES": "FETICHIZE, to make a fetish of, also FETICHISE, FETISHISE, FETISHIZE [v]\n",
  "FETICHIZING": "FETICHIZE, to make a fetish of, also FETICHISE, FETISHISE, FETISHIZE [v]\n",
  "FETICIDAL": "relating to the killing of a fetus [adj]\n",
  "FETICIDE": "the killing of a fetus [n -S]\n",
  "FETICIDES": "FETICIDE, the killing of a fetus [n]\n",
  "FETID": "stinking, also FOETID [adj FETIDER, FETIDEST, FETIDLY]\n",
  "FETIDER": "FETID, stinking, also FOETID [adj]\n",
  "FETIDEST": "FETID, stinking, also FOETID [adj]\n",
  "FETIDITIES": "FETIDITY, the state of being fetid [n]\n",
  "FETIDITY": "the state of being fetid [n FETIDITIES]\n",
  "FETIDLY": "FETID, stinking, also FOETID [adv]\n",
  "FETIDNESS": "the state of being fetid [n -ES]\n",
  "FETIDNESSES": "FETIDNESS, the state of being fetid [n]\n",
  "FETING": "FETE, (French) to honour with festivities [v]\n",
  "FETIPAROUS": "of marsupials, such as the kangaroo, giving birth to incompletely developed offspring, also FOETIPAROUS [adj]\n",
  "FETISH": "a fixation, also FETICH, FETICHE [n -ES]\n",
  "FETISHES": "FETISH, a fixation, also FETICH, FETICHE [n]\n",
  "FETISHISATION": "the process of fetishising, also FETISHIZATION [n -S]\n",
  "FETISHISATIONS": "FETISHISATION, the process of fetishising, also FETISHIZATION [n]\n",
  "FETISHISE": "to make a fetish of, also FETICHISE, FETICHIZE, FETISHIZE [v FETISHISED, FETISHISING, FETISHISES]\n",
  "FETISHISED": "FETISHISE, to make a fetish of, also FETICHISE, FETICHIZE, FETISHIZE [v]\n",
  "FETISHISES": "FETISHISE, to make a fetish of, also FETICHISE, FETICHIZE, FETISHIZE [v]\n",
  "FETISHISING": "FETISHISE, to make a fetish of, also FETICHISE, FETICHIZE, FETISHIZE [v]\n",
  "FETISHISM": "devotion to or reverence for a fetish or fetishes, also FETICHISM [n -S]\n",
  "FETISHISMS": "FETISHISM, devotion to or reverence for a fetish or fetishes, also FETICHISM [n]\n",
  "FETISHIST": "one who worships a fetish, also FETICHIST [n -S]\n",
  "FETISHISTIC": "relating to or exhibiting fetishism, devotion to or reverence for a fetish or fetishes [adj FETISHISTICALLY]\n",
  "FETISHISTICALLY": "FETISHISTIC, relating to or exhibiting fetishism, devotion to or reverence for a fetish or fetishes [adv]\n",
  "FETISHISTS": "FETISHIST, one who worships a fetish, also FETICHIST [n]\n",
  "FETISHIZATION": "the process of fetishizing, also FETISHISATION [n -S]\n",
  "FETISHIZATIONS": "FETISHIZATION, the process of fetishizing, also FETISHISATION [n]\n",
  "FETISHIZE": "to make a fetish of, also FETICHISE, FETICHIZE, FETISHISE [v FETISHIZED, FETISHIZING, FETISHIZES]\n",
  "FETISHIZED": "FETISHIZE, to make a fetish of, also FETICHISE, FETICHIZE, FETISHISE [v]\n",
  "FETISHIZES": "FETISHIZE, to make a fetish of, also FETICHISE, FETICHIZE, FETISHISE [v]\n",
  "FETISHIZING": "FETISHIZE, to make a fetish of, also FETICHISE, FETICHIZE, FETISHISE [v]\n",
  "FETLOCK": "a joint of a horse's leg [n -S]\n",
  "FETLOCKED": "having fetlocks [adj]\n",
  "FETLOCKS": "FETLOCK, a joint of a horse's leg [n]\n",
  "FETOLOGIES": "FETOLOGY, a branch of medicine dealing with the fetus [n]\n",
  "FETOLOGIST": "one who studies the fetus [n -S]\n",
  "FETOLOGISTS": "FETOLOGIST, one who studies the fetus [n]\n",
  "FETOLOGY": "a branch of medicine dealing with the fetus [n FETOLOGIES]\n",
  "FETOPROTEIN": "any of several fetal antigens present in the adult in some abnormal conditions [n -S]\n",
  "FETOPROTEINS": "FETOPROTEIN, any of several fetal antigens present in the adult in some abnormal conditions [n]\n",
  "FETOR": "(Latin) a stench, also FOETOR [n -S]\n",
  "FETORS": "FETOR, (Latin) a stench, also FOETOR [n]\n",
  "FETOSCOPE": "an instrument used for looking at the fetus [n -S]\n",
  "FETOSCOPES": "FETOSCOPE, an instrument used for looking at the fetus [n]\n",
  "FETOSCOPIES": "FETOSCOPY, a procedure for viewing the fetus directly, within the uterus, also FOETOSCOPY [n]\n",
  "FETOSCOPY": "a procedure for viewing the fetus directly, within the uterus, also FOETOSCOPY [n FETOSCOPIES]\n",
  "FETS": "FET, (obsolete) to fetch, also FETCH, FETT [v]\n",
  "FETT": "(obsolete) to fetch, also FET [v -ED, -ING, -S]\n",
  "FETTA": "(Modern Greek) a crumbly white cheese, also FETA [n -S]\n",
  "FETTAS": "FETTA, (Modern Greek) a crumbly white cheese, also FETA [n]\n",
  "FETTED": "FETT, (obsolete) to fetch, also FET [v]\n",
  "FETTER": "to shackle [v -ED, -ING, -S]\n",
  "FETTERED": "FETTER, to shackle [v]\n",
  "FETTERER": "one who fetters [n -S]\n",
  "FETTERERS": "FETTERER, one who fetters [n]\n",
  "FETTERING": "FETTER, to shackle [v]\n",
  "FETTERLESS": "free from fetters [adj]\n",
  "FETTERLOCK": "a shackle for a horse, as a design on a shield [n -S]\n",
  "FETTERLOCKS": "FETTERLOCK, a shackle for a horse, as a design on a shield [n]\n",
  "FETTERS": "FETTER, to shackle [v]\n",
  "FETTING": "FETT, (obsolete) to fetch, also FET [v]\n",
  "FETTLE": "to potter fussily about [v FETTLED, FETTLING, FETTLES]\n",
  "FETTLED": "FETTLE, to potter fussily about [v]\n",
  "FETTLER": "a railway maintenance worker [n -S]\n",
  "FETTLERS": "FETTLER, a railway maintenance worker [n]\n",
  "FETTLES": "FETTLE, to potter fussily about [v]\n",
  "FETTLING": "loose material thrown on the hearth of a furnace to protect it [n -S]\n",
  "FETTLINGS": "FETTLING, loose material thrown on the hearth of a furnace to protect it [n]\n",
  "FETTS": "FETT, (obsolete) to fetch, also FET [v]\n",
  "FETTUCCINE": "(Italian) a pasta made in long ribbons, also FETTUCINE, FETTUCINI [n FETTUCCINI or FETTUCCINES]\n",
  "FETTUCCINES": "FETTUCCINE, (Italian) a pasta made in long ribbons, also FETTUCINE, FETTUCINI [n]\n",
  "FETTUCCINI": "a pasta made in long ribbons [n -S]\n",
  "FETTUCCINIS": "FETTUCCINI, a pasta made in long ribbons [n]\n",
  "FETTUCINE": "(Italian) a pasta made in long ribbons, also FETTUCCINE, FETTUCINI [n -S]\n",
  "FETTUCINES": "FETTUCINE, (Italian) a pasta made in long ribbons, also FETTUCCINE, FETTUCINI [n]\n",
  "FETTUCINI": "(Italian) a pasta made in long ribbons, also FETTUCCINE, FETTUCINE [n -S]\n",
  "FETTUCINIS": "FETTUCINI, (Italian) a pasta made in long ribbons, also FETTUCCINE, FETTUCINE [n]\n",
  "FETUS": "(Latin) the unborn in the womb with distinctly formed parts, also FOETUS [n -ES]\n",
  "FETUSES": "FETUS, (Latin) the unborn in the womb with distinctly formed parts, also FOETUS [n]\n",
  "FETWA": "(Arabic) an Islamic religious decree, also FATWA, FATWAH [n -S]\n",
  "FETWAS": "FETWA, (Arabic) an Islamic religious decree, also FATWA, FATWAH [n]\n",
  "FEU": "(Scots) to grant land to under Scottish feudal law [v -ED, -ING, -S]\n",
  "FEUAR": "(Scots) in law, the owner of a property in fee simple, also FIAR [n -S]\n",
  "FEUARS": "FEUAR, (Scots) in law, the owner of a property in fee simple, also FIAR [n]\n",
  "FEUD": "to engage in a persistent state of private enmity [v -ED, -ING, -S]\n",
  "FEUDAL": "pertaining to an ancient political and economic system [adj]\n",
  "FEUDALISATION": "the act of feudalising, also FEUDALIZATION [n -S]\n",
  "FEUDALISATIONS": "FEUDALISATION, the act of feudalising, also FEUDALIZATION [n]\n",
  "FEUDALISE": "to reduce to a feudal tenure, also FEUDALIZE [v FEUDALISED, FEUDALISING, FEUDALISES]\n",
  "FEUDALISED": "FEUDALISE, to reduce to a feudal tenure, also FEUDALIZE [v]\n",
  "FEUDALISES": "FEUDALISE, to reduce to a feudal tenure, also FEUDALIZE [v]\n",
  "FEUDALISING": "FEUDALISE, to reduce to a feudal tenure, also FEUDALIZE [v]\n",
  "FEUDALISM": "the feudal system; a system by which the holding of estates in land is made dependent upon an obligation to render military service to the king or feudal superior [n -S]\n",
  "FEUDALISMS": "FEUDALISM, the feudal system; a system by which the holding of estates in land is made dependent upon an obligation to render military service to the king or feudal superior [n]\n",
  "FEUDALIST": "an upholder of feudalism [n -S]\n",
  "FEUDALISTIC": "relating to feudalism [adj]\n",
  "FEUDALISTS": "FEUDALIST, an upholder of feudalism [n]\n",
  "FEUDALITIES": "FEUDALITY, the state of being feudal [n]\n",
  "FEUDALITY": "the state of being feudal [n FEUDALITIES]\n",
  "FEUDALIZATION": "the act of feudalizing, also FEUDALISATION [n -S]\n",
  "FEUDALIZATIONS": "FEUDALIZATION, the act of feudalizing, also FEUDALISATION [n]\n",
  "FEUDALIZE": "to reduce to a feudal tenure, also FEUDALISE [v FEUDALIZED, FEUDALIZING, FEUDALIZES]\n",
  "FEUDALIZED": "FEUDALIZE, to reduce to a feudal tenure, also FEUDALISE [v]\n",
  "FEUDALIZES": "FEUDALIZE, to reduce to a feudal tenure, also FEUDALISE [v]\n",
  "FEUDALIZING": "FEUDALIZE, to reduce to a feudal tenure, also FEUDALISE [v]\n",
  "FEUDALLY": "FEUDAL, pertaining to an ancient political and economic system [adv]\n",
  "FEUDARIES": "FEUDARY, a holder of land by feudal tenure for allegiance, also FEODARY [n]\n",
  "FEUDARY": "a holder of land by feudal tenure for allegiance, also FEODARY [n FEUDARIES]\n",
  "FEUDATORIES": "FEUDATORY, one holding lands or power by a feudal tenure, also FEODARY, FEUDARY [n]\n",
  "FEUDATORY": "one holding lands or power by a feudal tenure, also FEODARY, FEUDARY [n FEUDATORIES]\n",
  "FEUDED": "FEUD, to engage in a persistent state of private enmity [v]\n",
  "FEUDING": "the act of feuding [n -S]\n",
  "FEUDINGS": "FEUDING, the act of feuding [n]\n",
  "FEUDIST": "a writer on feuds; a person versed in feudal law [n -S]\n",
  "FEUDISTS": "FEUDIST, a writer on feuds; a person versed in feudal law [n]\n",
  "FEUDS": "FEUD, to engage in a persistent state of private enmity [v]\n",
  "FEUED": "FEU, (Scots) to grant land to under Scottish feudal law [v]\n",
  "FEUILLETE": "(French) a puff pastry [n -S]\n",
  "FEUILLETES": "FEUILLETE, (French) a puff pastry [n]\n",
  "FEUILLETON": "(French) in French and other newspapers, a part ruled off the bottom of a page for a serial story, critical article, etc.; a contribution of this kind [n -S]\n",
  "FEUILLETONISM": "the production of feuilletons [n -S]\n",
  "FEUILLETONISMS": "FEUILLETONISM, the production of feuilletons [n]\n",
  "FEUILLETONIST": "one who writes feuilletons [n -S]\n",
  "FEUILLETONISTIC": "related to feuilletonism [adj]\n",
  "FEUILLETONISTS": "FEUILLETONIST, one who writes feuilletons [n]\n",
  "FEUILLETONS": "FEUILLETON, (French) in French and other newspapers, a part ruled off the bottom of a page for a serial story, critical article, etc.; a contribution of this kind [n]\n",
  "FEUING": "FEU, (Scots) to grant land to under Scottish feudal law [v]\n",
  "FEUS": "FEU, (Scots) to grant land to under Scottish feudal law [v]\n",
  "FEUTRE": "(Spenser) to set a spear in a rest, also FEWTER [v FEUTRED, FEUTRING, FEUTRES]\n",
  "FEUTRED": "FEUTRE, (Spenser) to set a spear in a rest, also FEWTER [v]\n",
  "FEUTRES": "FEUTRE, (Spenser) to set a spear in a rest, also FEWTER [v]\n",
  "FEUTRING": "FEUTRE, (Spenser) to set a spear in a rest, also FEWTER [v]\n",
  "FEVER": "to affect with an abnormally high body temperature [v -ED, -ING, -S]\n",
  "FEVERED": "FEVER, to affect with an abnormally high body temperature [v]\n",
  "FEVERFEW": "a perennial herb [n -S]\n",
  "FEVERFEWS": "FEVERFEW, a perennial herb [n]\n",
  "FEVERING": "FEVER, to affect with an abnormally high body temperature [v]\n",
  "FEVERISH": "having a fever [adj FEVERISHLY]\n",
  "FEVERISHLY": "FEVERISH, having a fever [adv]\n",
  "FEVERISHNESS": "the state of being feverish [n -ES]\n",
  "FEVERISHNESSES": "FEVERISHNESS, the state of being feverish [n]\n",
  "FEVERLESS": "without a fever [adj]\n",
  "FEVEROUS": "affected with fever or ague; feverish [adj FEVEROUSLY]\n",
  "FEVEROUSLY": "FEVEROUS, affected with fever or ague; feverish [adv]\n",
  "FEVERROOT": "an American wild plant [n -S]\n",
  "FEVERROOTS": "FEVERROOT, an American wild plant [n]\n",
  "FEVERS": "FEVER, to affect with an abnormally high body temperature [v]\n",
  "FEVERWEED": "a plant thought to be medicinal [n -S]\n",
  "FEVERWEEDS": "FEVERWEED, a plant thought to be medicinal [n]\n",
  "FEVERWORT": "a coarse American herb of the honeysuckle family [n -S]\n",
  "FEVERWORTS": "FEVERWORT, a coarse American herb of the honeysuckle family [n]\n",
  "FEW": "a small number [n -S] / not many [adj FEWER, FEWEST]\n",
  "FEWER": "FEW, not many [adj]\n",
  "FEWEST": "FEW, not many [adj]\n",
  "FEWMET": "(archaic) the dung of deer, hares etc., also FUMET, FUMETTE [n -S]\n",
  "FEWMETS": "FEWMET, (archaic) the dung of deer, hares etc., also FUMET, FUMETTE [n]\n",
  "FEWNESS": "the state of being few [n -ES]\n",
  "FEWNESSES": "FEWNESS, the state of being few [n]\n",
  "FEWS": "FEW, a small number [n]\n",
  "FEWTER": "(Spenser) to set a spear in a rest, also FEUTRE [v -ED, -ING, -S]\n",
  "FEWTERED": "FEWTER, (Spenser) to set a spear in a rest, also FEUTRE [v]\n",
  "FEWTERING": "FEWTER, (Spenser) to set a spear in a rest, also FEUTRE [v]\n",
  "FEWTERS": "FEWTER, (Spenser) to set a spear in a rest, also FEUTRE [v]\n",
  "FEWTRILS": "trifles [n]\n",
  "FEY": "foreseeing the future, also FAY [adj FEYER, FEYEST, FEYLY] / to clean out, esp. a ditch [v -ED, -ING, -S]\n",
  "FEYED": "FEY, to clean out, esp. a ditch [v]\n",
  "FEYER": "FEY, foreseeing the future, also FAY [adj]\n",
  "FEYEST": "FEY, foreseeing the future, also FAY [adj]\n",
  "FEYING": "FEY, to clean out, esp. a ditch [v]\n",
  "FEYLY": "FEY, foreseeing the future, also FAY [adv]\n",
  "FEYNESS": "the state of being fey [n -ES]\n",
  "FEYNESSES": "FEYNESS, the state of being fey [n]\n",
  "FEYS": "FEY, to clean out, esp. a ditch [v]\n",
  "FEZ": "a red brimless cap of wool or felt [n FEZES or FEZZES]\n",
  "FEZES": "FEZ, a red brimless cap of wool or felt [n]\n",
  "FEZZED": "wearing a fez [adj]\n",
  "FEZZES": "FEZ, a red brimless cap of wool or felt [n]\n",
  "FEZZY": "like a fez, a red brimless cap [adj]\n",
  "FIACRE": "(French) a small hackney carriage [n -S]\n",
  "FIACRES": "FIACRE, (French) a small hackney carriage [n]\n",
  "FIANCAILLES": "(French) betrothal [n]\n",
  "FIANCE": "(French) a man engaged to be married [n -S]\n",
  "FIANCEE": "(French) a woman engaged to be married [n -S]\n",
  "FIANCEES": "FIANCEE, (French) a woman engaged to be married [n]\n",
  "FIANCES": "FIANCE, (French) a man engaged to be married [n]\n",
  "FIANCHETTI": "FIANCHETTO, (Italian) in chess, the development of bishop on the N2 diagonal [n]\n",
  "FIANCHETTO": "(Italian) in chess, the development of bishop on the N2 diagonal [n FIANCHETTOS or FIANCHETTI] / to develop the bishop [v -ED, -ING, -ES]\n",
  "FIANCHETTOED": "FIANCHETTO, to develop the bishop [v]\n",
  "FIANCHETTOES": "FIANCHETTO, to develop the bishop [v]\n",
  "FIANCHETTOING": "FIANCHETTO, to develop the bishop [v]\n",
  "FIANCHETTOS": "FIANCHETTO, (Italian) in chess, the development of bishop on the N2 diagonal [n]\n",
  "FIAR": "(Scots) the owner of the fee simple of a property [n -S]\n",
  "FIARS": "FIAR, (Scots) the owner of the fee simple of a property [n]\n",
  "FIASCHI": "FIASCO, (Italian) a wine bottle [n]\n",
  "FIASCO": "(Italian) a wine bottle [n FIASCOS or FIASCHI or FIASCOES] / a complete failure [n FIASCOS or FIASCOES]\n",
  "FIASCOES": "FIASCO, (Italian) a wine bottle [n]\n",
  "FIASCOS": "FIASCO, (Italian) a wine bottle [n]\n",
  "FIAT": "(Latin) a formal authorization for a proposed arrangement [n -S] / to sanction [v -ED, -ING, -S]\n",
  "FIATED": "FIAT, to sanction [v]\n",
  "FIATING": "FIAT, to sanction [v]\n",
  "FIATS": "FIAT, to sanction [v]\n",
  "FIAUNT": "(Spenser) a fiat [n -S]\n",
  "FIAUNTS": "FIAUNT, (Spenser) a fiat [n]\n",
  "FIB": "to tell a trivial lie [v FIBBED, FIBBING, FIBS]\n",
  "FIBBED": "FIB, to tell a trivial lie [v]\n",
  "FIBBER": "one who fibs [n -S]\n",
  "FIBBERIES": "FIBBERY, the habit of fibbing [n]\n",
  "FIBBERS": "FIBBER, one who fibs [n]\n",
  "FIBBERY": "the habit of fibbing [n FIBBERIES]\n",
  "FIBBING": "FIB, to tell a trivial lie [v]\n",
  "FIBER": "a threadlike cell or filament, also FIBRE [n -S]\n",
  "FIBERBOARD": "(US) a material made from compressed wood fibres, also FIBREBOARD [n -S]\n",
  "FIBERBOARDS": "FIBERBOARD, (US) a material made from compressed wood fibres, also FIBREBOARD [n]\n",
  "FIBERED": "having fibre, also FIBRED [adj]\n",
  "FIBERFILL": "(US) synthetic fibres used as a filling material, also FIBREFILL [n -S]\n",
  "FIBERFILLS": "FIBERFILL, (US) synthetic fibres used as a filling material, also FIBREFILL [n]\n",
  "FIBERGLASS": "(US) to coat with fiberglass, a synthetic fibre made of fine filaments of molten glass, also FIBREGLASS [v -ED, -ING, -ES]\n",
  "FIBERGLASSED": "FIBERGLASS, (US) to coat with fiberglass, a synthetic fibre made of fine filaments of molten glass, also FIBREGLASS [v]\n",
  "FIBERGLASSES": "FIBERGLASS, (US) to coat with fiberglass, a synthetic fibre made of fine filaments of molten glass, also FIBREGLASS [v]\n",
  "FIBERGLASSING": "FIBERGLASS, (US) to coat with fiberglass, a synthetic fibre made of fine filaments of molten glass, also FIBREGLASS [v]\n",
  "FIBERISATION": "the act of fiberising, also FIBERIZATION [n -S]\n",
  "FIBERISATIONS": "FIBERISATION, the act of fiberising, also FIBERIZATION [n]\n",
  "FIBERISE": "to break into fibers, also FIBERIZE [v FIBERISED, FIBERISING, FIBERISES]\n",
  "FIBERISED": "FIBERISE, to break into fibers, also FIBERIZE [v]\n",
  "FIBERISES": "FIBERISE, to break into fibers, also FIBERIZE [v]\n",
  "FIBERISING": "FIBERISE, to break into fibers, also FIBERIZE [v]\n",
  "FIBERIZATION": "the act of fiberizing, also FIBERISATION [n -S]\n",
  "FIBERIZATIONS": "FIBERIZATION, the act of fiberizing, also FIBERISATION [n]\n",
  "FIBERIZE": "to break into fibers, also FIBERISE [v FIBERIZED, FIBERIZING, FIBERIZES]\n",
  "FIBERIZED": "FIBERIZE, to break into fibers, also FIBERISE [v]\n",
  "FIBERIZES": "FIBERIZE, to break into fibers, also FIBERISE [v]\n",
  "FIBERIZING": "FIBERIZE, to break into fibers, also FIBERISE [v]\n",
  "FIBERLESS": "having no fibers, also FIBRELESS [adj]\n",
  "FIBERLIKE": "like a fiber, also FIBRELIKE [adj]\n",
  "FIBERS": "FIBER, a threadlike cell or filament, also FIBRE [n]\n",
  "FIBERSCOPE": "a medical instrument using fibre optic bundles, also FIBRESCOPE [n -S]\n",
  "FIBERSCOPES": "FIBERSCOPE, a medical instrument using fibre optic bundles, also FIBRESCOPE [n]\n",
  "FIBRANNE": "a fabric made of spun rayon yarn [n -S]\n",
  "FIBRANNES": "FIBRANNE, a fabric made of spun rayon yarn [n]\n",
  "FIBRATE": "any of a class of drugs used to reduce levels of fat in the body [n -S]\n",
  "FIBRATES": "FIBRATE, any of a class of drugs used to reduce levels of fat in the body [n]\n",
  "FIBRE": "a threadlike cell or filament, also FIBER [n -S]\n",
  "FIBREBOARD": "a material made from compressed wood fibres, also FIBERBOARD [n -S]\n",
  "FIBREBOARDS": "FIBREBOARD, a material made from compressed wood fibres, also FIBERBOARD [n]\n",
  "FIBRED": "having fibre, also FIBERED [adj]\n",
  "FIBREFILL": "synthetic fibres used as a filling material, also FIBERFILL [n -S]\n",
  "FIBREFILLS": "FIBREFILL, synthetic fibres used as a filling material, also FIBERFILL [n]\n",
  "FIBREGLASS": "to protect or repair by applying fibreglass [v -ED, -ING, -ES]\n",
  "FIBREGLASSED": "FIBREGLASS, to protect or repair by applying fibreglass [v]\n",
  "FIBREGLASSES": "FIBREGLASS, to protect or repair by applying fibreglass [v]\n",
  "FIBREGLASSING": "FIBREGLASS, to protect or repair by applying fibreglass [v]\n",
  "FIBRELESS": "having no fibers, also FIBERLESS [adj]\n",
  "FIBRELIKE": "like a fibre, also FIBERLIKE [adj]\n",
  "FIBREOPTIC": "relating to fibre optics [adj]\n",
  "FIBRES": "FIBRE, a threadlike cell or filament, also FIBER [n]\n",
  "FIBRESCOPE": "a medical instrument using fibre optic bundles, also FIBERSCOPE [n -S]\n",
  "FIBRESCOPES": "FIBRESCOPE, a medical instrument using fibre optic bundles, also FIBERSCOPE [n]\n",
  "FIBRIFORM": "shaped like a fibre [adj]\n",
  "FIBRIL": "a small fibre, also FIBRILLA [n -S]\n",
  "FIBRILAR": "relating to a fibril, also FIBRILLAR, FIBRILLARY [adj]\n",
  "FIBRILLA": "(Latin) a small fibre, also FIBRIL [n FIBRILLAE]\n",
  "FIBRILLAE": "FIBRILLA, (Latin) a small fibre, also FIBRIL [n]\n",
  "FIBRILLAR": "relating to a fibril, also FIBRILAR, FIBRILLARY [adj]\n",
  "FIBRILLARY": "of or pertaining to fibrils or fibers, also FIBRILAR, FIBRILLAR [adj]\n",
  "FIBRILLATE": "to undergo fibrillation [v FIBRILLATED, FIBRILLATING, FIBRILLATES]\n",
  "FIBRILLATED": "FIBRILLATE, to undergo fibrillation [v]\n",
  "FIBRILLATES": "FIBRILLATE, to undergo fibrillation [v]\n",
  "FIBRILLATING": "FIBRILLATE, to undergo fibrillation [v]\n",
  "FIBRILLATION": "uncoordinated contraction of muscle-fibres in the heart [n -S]\n",
  "FIBRILLATIONS": "FIBRILLATION, uncoordinated contraction of muscle-fibres in the heart [n]\n",
  "FIBRILLIFORM": "in the form of fibrils [adj]\n",
  "FIBRILLIN": "a protein found in connective tissue [n -S]\n",
  "FIBRILLINS": "FIBRILLIN, a protein found in connective tissue [n]\n",
  "FIBRILLOSE": "having, or covered with, small fibres or the appearance of small fibres [adj]\n",
  "FIBRILLOUS": "relating to or having small fibres [adj]\n",
  "FIBRILS": "FIBRIL, a small fibre, also FIBRILLA [n]\n",
  "FIBRIN": "an insoluble protein formed by enzyme action from fibrinogen when blood coagulates [n -S]\n",
  "FIBRINOGEN": "a soluble protein, a globulin, in blood plasma, converted to fibrin by the action of the enzyme thrombin when blood clots [n -S]\n",
  "FIBRINOGENIC": "of or like a fibrinogen, also FIBRINOGENOUS [adj]\n",
  "FIBRINOGENOUS": "of or like a fibrinogen, also FIBRINOGENIC [adj]\n",
  "FIBRINOGENS": "FIBRINOGEN, a soluble protein, a globulin, in blood plasma, converted to fibrin by the action of the enzyme thrombin when blood clots [n]\n",
  "FIBRINOID": "of or like fibrin [adj] / a natural material that resembles fibrin [n -S]\n",
  "FIBRINOIDS": "FIBRINOID, a natural material that resembles fibrin [n]\n",
  "FIBRINOLYSES": "FIBRINOLYSIS, the usually enzymatic breakdown of fibrin [n]\n",
  "FIBRINOLYSIN": "any of several proteolytic enzymes that promote the dissolution of blood clots [n -S]\n",
  "FIBRINOLYSINS": "FIBRINOLYSIN, any of several proteolytic enzymes that promote the dissolution of blood clots [n]\n",
  "FIBRINOLYSIS": "the usually enzymatic breakdown of fibrin [n FIBRINOLYSES]\n",
  "FIBRINOLYTIC": "relating to fibrinolysis [adj]\n",
  "FIBRINOPEPTIDE": "any of the vertebrate polypeptides that are cleaved from fibrinogen by thrombin during clot formation [n -S]\n",
  "FIBRINOPEPTIDES": "FIBRINOPEPTIDE, any of the vertebrate polypeptides that are cleaved from fibrinogen by thrombin during clot formation [n]\n",
  "FIBRINOUS": "having, or partaking of the properties of, fibrin; as, fibrinous exudation [adj]\n",
  "FIBRINS": "FIBRIN, an insoluble protein formed by enzyme action from fibrinogen when blood coagulates [n]\n",
  "FIBRO": "(tradename) a wall board of compressed asbestos and cement, also FIBROCEMENT, FIBROLITE [n -S]\n",
  "FIBROBLAST": "a cell in connective tissue from which connective tissue is formed [n -S]\n",
  "FIBROBLASTIC": "of or like a fibroblast [adj]\n",
  "FIBROBLASTS": "FIBROBLAST, a cell in connective tissue from which connective tissue is formed [n]\n",
  "FIBROCARTILAGE": "cartilage with embedded fibres [n -S]\n",
  "FIBROCARTILAGES": "FIBROCARTILAGE, cartilage with embedded fibres [n]\n",
  "FIBROCEMENT": "(tradename) a kind of wallboard, made of compressed asbestos and cement, also FIBRO, FIBROLITE [n -S]\n",
  "FIBROCEMENTS": "FIBROCEMENT, (tradename) a kind of wallboard, made of compressed asbestos and cement, also FIBRO, FIBROLITE [n]\n",
  "FIBROCYSTIC": "of or relating to growth of fibrous tissue with cystic spaces [adj]\n",
  "FIBROCYTE": "a normally inactive fibroblast which proliferates following tissue damage [n -S]\n",
  "FIBROCYTES": "FIBROCYTE, a normally inactive fibroblast which proliferates following tissue damage [n]\n",
  "FIBROID": "a benign tumor, also FIBROMA [n -S]\n",
  "FIBROIDS": "FIBROID, a benign tumor, also FIBROMA [n]\n",
  "FIBROIN": "an insoluble protein, also FIBRIN [n -S]\n",
  "FIBROINS": "FIBROIN, an insoluble protein, also FIBRIN [n]\n",
  "FIBROLINE": "a yarn of flax, jute and hemp waste [n -S]\n",
  "FIBROLINES": "FIBROLINE, a yarn of flax, jute and hemp waste [n]\n",
  "FIBROLITE": "(tradename) a type of building board containing asbestos and cement , also FIBRO, FIBROCEMENT [n -S]\n",
  "FIBROLITES": "FIBROLITE, (tradename) a type of building board containing asbestos and cement , also FIBRO, FIBROCEMENT [n]\n",
  "FIBROMA": "a benign tumor, also FIBROID [n FIBROMAS or FIBROMATA]\n",
  "FIBROMAS": "FIBROMA, a benign tumor, also FIBROID [n]\n",
  "FIBROMATA": "FIBROMA, a benign tumor, also FIBROID [n]\n",
  "FIBROMATOUS": "of or like a fibroma [adj]\n",
  "FIBROMYALGIA": "any of a group of rheumatic disorders affecting soft tissues [n -S]\n",
  "FIBROMYALGIAS": "FIBROMYALGIA, any of a group of rheumatic disorders affecting soft tissues [n]\n",
  "FIBRONECTIN": "a protein found in blood, important in cell growth [n -S]\n",
  "FIBRONECTINS": "FIBRONECTIN, a protein found in blood, important in cell growth [n]\n",
  "FIBROS": "FIBRO, (tradename) a wall board of compressed asbestos and cement, also FIBROCEMENT, FIBROLITE [n]\n",
  "FIBROSARCOMA": "a sarcoma formed of spindle-shaped cells in collagenous fibrils [n FIBROSARCOMAS or FIBROSARCOMATA]\n",
  "FIBROSARCOMAS": "FIBROSARCOMA, a sarcoma formed of spindle-shaped cells in collagenous fibrils [n]\n",
  "FIBROSARCOMATA": "FIBROSARCOMA, a sarcoma formed of spindle-shaped cells in collagenous fibrils [n]\n",
  "FIBROSE": "to form fibrous tissue [v FIBROSED, FIBROSING, FIBROSES]\n",
  "FIBROSED": "FIBROSE, to form fibrous tissue [v]\n",
  "FIBROSES": "FIBROSE, to form fibrous tissue [v]\n",
  "FIBROSING": "FIBROSE, to form fibrous tissue [v]\n",
  "FIBROSIS": "abnormal growth of fibrous tissue [n FIBROSES]\n",
  "FIBROSITIS": "inflammation of the nerve fibres [n -ES]\n",
  "FIBROSITISES": "FIBROSITIS, inflammation of the nerve fibres [n]\n",
  "FIBROTIC": "relating to fibrosis, inflammation of the nerve fibres [adj]\n",
  "FIBROUS": "containing, or consisting of, fibers [adj FIBROUSLY]\n",
  "FIBROUSLY": "FIBROUS, containing, or consisting of, fibers [adv]\n",
  "FIBROUSNESS": "the state of being fibrous [n -ES]\n",
  "FIBROUSNESSES": "FIBROUSNESS, the state of being fibrous [n]\n",
  "FIBROVASCULAR": "having or consisting of fibers and conducting cells [adj]\n",
  "FIBS": "FIB, to tell a trivial lie [v]\n",
  "FIBSTER": "one who tells fibs [n -S]\n",
  "FIBSTERS": "FIBSTER, one who tells fibs [n]\n",
  "FIBULA": "(Latin) a bone in the leg [n FIBULAS or FIBULAE]\n",
  "FIBULAE": "FIBULA, (Latin) a bone in the leg [n]\n",
  "FIBULAR": "pertaining to the fibula [adj]\n",
  "FIBULAS": "FIBULA, (Latin) a bone in the leg [n]\n",
  "FICAIN": "a cysteine proteinase isolated from the latex of figs, also FICIN [n -S]\n",
  "FICAINS": "FICAIN, a cysteine proteinase isolated from the latex of figs, also FICIN [n]\n",
  "FICE": "a small dog of mixed breed, also FEIST, FYCE [n -S]\n",
  "FICES": "FICE, a small dog of mixed breed, also FEIST, FYCE [n]\n",
  "FICHE": "(French) a card or strip of film containing miniaturized data [n -S]\n",
  "FICHES": "FICHE, (French) a card or strip of film containing miniaturized data [n]\n",
  "FICHU": "(French) a light cape, usually of lace, worn by women, to cover the neck and throat, and extending to the shoulders [n -S]\n",
  "FICHUS": "FICHU, (French) a light cape, usually of lace, worn by women, to cover the neck and throat, and extending to the shoulders [n]\n",
  "FICIN": "a cysteine proteinase isolated from the latex of figs, also FICAIN [n -S]\n",
  "FICINS": "FICIN, a cysteine proteinase isolated from the latex of figs, also FICAIN [n]\n",
  "FICKLE": "not loyal [adj FICKLER, FICKLEST, FICKLY] / to perplex [v FICKLED, FICKLING, FICKLES]\n",
  "FICKLED": "FICKLE, to perplex [v]\n",
  "FICKLENESS": "the quality of being fickle [n -ES]\n",
  "FICKLENESSES": "FICKLENESS, the quality of being fickle [n]\n",
  "FICKLER": "FICKLE, not loyal [adj]\n",
  "FICKLES": "FICKLE, to perplex [v]\n",
  "FICKLEST": "FICKLE, not loyal [adj]\n",
  "FICKLING": "FICKLE, to perplex [v]\n",
  "FICKLY": "FICKLE, not loyal [adv]\n",
  "FICO": "(Shakespeare) a fig, a gesture of contempt, also FIGO [n -S or -ES]\n",
  "FICOES": "FICO, (Shakespeare) a fig, a gesture of contempt, also FIGO [n]\n",
  "FICOS": "FICO, (Shakespeare) a fig, a gesture of contempt, also FIGO [n]\n",
  "FICTILE": "capable of being moulded [adj]\n",
  "FICTION": "an invented or false story [n -S]\n",
  "FICTIONAL": "relating to fiction [adj FICTIONALLY]\n",
  "FICTIONALISE": "to make fictional, also FICTIONALIZE [v FICTIONALISED, FICTIONALISING, FICTIONALISES]\n",
  "FICTIONALISED": "FICTIONALISE, to make fictional, also FICTIONALIZE [v]\n",
  "FICTIONALISES": "FICTIONALISE, to make fictional, also FICTIONALIZE [v]\n",
  "FICTIONALISING": "FICTIONALISE, to make fictional, also FICTIONALIZE [v]\n",
  "FICTIONALITIES": "FICTIONALITY, the state of being fictional [n]\n",
  "FICTIONALITY": "the state of being fictional [n FICTIONALITIES]\n",
  "FICTIONALIZE": "to make fictional, also FICTIONALISE [v FICTIONALIZED, FICTIONALIZING, FICTIONALIZES]\n",
  "FICTIONALIZED": "FICTIONALIZE, to make fictional, also FICTIONALISE [v]\n",
  "FICTIONALIZES": "FICTIONALIZE, to make fictional, also FICTIONALISE [v]\n",
  "FICTIONALIZING": "FICTIONALIZE, to make fictional, also FICTIONALISE [v]\n",
  "FICTIONALLY": "FICTIONAL, relating to fiction [adv]\n",
  "FICTIONEER": "one who writes fiction, esp. in quantity and of a low standard [n -S]\n",
  "FICTIONEERING": "the writing of fiction, esp. in quantity and of a low standard [n -S]\n",
  "FICTIONEERINGS": "FICTIONEERING, the writing of fiction, esp. in quantity and of a low standard [n]\n",
  "FICTIONEERS": "FICTIONEER, one who writes fiction, esp. in quantity and of a low standard [n]\n",
  "FICTIONISATION": "the process of fictionising, also FICTIONIZATION [n -S]\n",
  "FICTIONISATIONS": "FICTIONISATION, the process of fictionising, also FICTIONIZATION [n]\n",
  "FICTIONISE": "to make fictional, also FICTIONIZE [v FICTIONISED, FICTIONISING, FICTIONISES]\n",
  "FICTIONISED": "FICTIONISE, to make fictional, also FICTIONIZE [v]\n",
  "FICTIONISES": "FICTIONISE, to make fictional, also FICTIONIZE [v]\n",
  "FICTIONISING": "FICTIONISE, to make fictional, also FICTIONIZE [v]\n",
  "FICTIONIST": "a writer of fiction [n -S]\n",
  "FICTIONISTS": "FICTIONIST, a writer of fiction [n]\n",
  "FICTIONIZATION": "the process of fictionizing, also FICTIONISATION [n -S]\n",
  "FICTIONIZATIONS": "FICTIONIZATION, the process of fictionizing, also FICTIONISATION [n]\n",
  "FICTIONIZE": "to make fictional, also FICTIONISE [v FICTIONIZED, FICTIONIZING, FICTIONIZES]\n",
  "FICTIONIZED": "FICTIONIZE, to make fictional, also FICTIONISE [v]\n",
  "FICTIONIZES": "FICTIONIZE, to make fictional, also FICTIONISE [v]\n",
  "FICTIONIZING": "FICTIONIZE, to make fictional, also FICTIONISE [v]\n",
  "FICTIONS": "FICTION, an invented or false story [n]\n",
  "FICTITIOUS": "of, relating to, or characteristic of fiction, imaginary [adj FICTITIOUSLY]\n",
  "FICTITIOUSLY": "FICTITIOUS, of, relating to, or characteristic of fiction, imaginary [adv]\n",
  "FICTITIOUSNESS": "FICTITIOUS, of, relating to, or characteristic of fiction, imaginary [n]\n",
  "FICTIVE": "feigned; counterfeit [adj FICTIVELY]\n",
  "FICTIVELY": "FICTIVE, feigned; counterfeit [adv]\n",
  "FICTIVENESS": "the state of being fictive [n -ES]\n",
  "FICTIVENESSES": "FICTIVENESS, the state of being fictive [n]\n",
  "FICTOR": "a person who makes images from clay [n -S]\n",
  "FICTORS": "FICTOR, a person who makes images from clay [n]\n",
  "FICUS": "(Latin) a genus of plants including the figtree [n -ES]\n",
  "FICUSES": "FICUS, (Latin) a genus of plants including the figtree [n]\n",
  "FID": "a conical pin of hard wood [n -S]\n",
  "FIDDIOUS": "(Shakespeare) to treat as leniently as Coriolanus treated Aufidius [v -ED, -ING, -ES]\n",
  "FIDDIOUSED": "FIDDIOUS, (Shakespeare) to treat as leniently as Coriolanus treated Aufidius [v]\n",
  "FIDDIOUSES": "FIDDIOUS, (Shakespeare) to treat as leniently as Coriolanus treated Aufidius [v]\n",
  "FIDDIOUSING": "FIDDIOUS, (Shakespeare) to treat as leniently as Coriolanus treated Aufidius [v]\n",
  "FIDDLE": "to play a violin [v FIDDLED, FIDDLING, FIDDLES]\n",
  "FIDDLEBACK": "a wavy grain found in some woods commonly used for the manufacture of violins [n -S]\n",
  "FIDDLEBACKS": "FIDDLEBACK, a wavy grain found in some woods commonly used for the manufacture of violins [n]\n",
  "FIDDLED": "FIDDLE, to play a violin [v]\n",
  "FIDDLEDEDEE": "an exclamation of impatience, disbelief, or disagreement, also FIDDLEDEEDEE [interj]\n",
  "FIDDLEDEEDEE": "an exclamation of impatience, disbelief, or disagreement, also FIDDLEDEDEE [interj]\n",
  "FIDDLEHEAD": "one of the young unfurling fronds of ferns that are sometimes eaten, also FIDDLENECK [n -S]\n",
  "FIDDLEHEADS": "FIDDLEHEAD, one of the young unfurling fronds of ferns that are sometimes eaten, also FIDDLENECK [n]\n",
  "FIDDLENECK": "one of the young unfurling fronds of ferns that are sometimes eaten, also FIDDLEHEAD [n -S]\n",
  "FIDDLENECKS": "FIDDLENECK, one of the young unfurling fronds of ferns that are sometimes eaten, also FIDDLEHEAD [n]\n",
  "FIDDLER": "one who plays on a fiddle or violin [n -S]\n",
  "FIDDLERS": "FIDDLER, one who plays on a fiddle or violin [n]\n",
  "FIDDLES": "FIDDLE, to play a violin [v]\n",
  "FIDDLESTICK": "a violin bow [n -S]\n",
  "FIDDLESTICKS": "FIDDLESTICK, a violin bow [n]\n",
  "FIDDLEWOOD": "the wood of several West Indian trees [n -S]\n",
  "FIDDLEWOODS": "FIDDLEWOOD, the wood of several West Indian trees [n]\n",
  "FIDDLEY": "an iron framework around a hatchway opening [n -S]\n",
  "FIDDLEYS": "FIDDLEY, an iron framework around a hatchway opening [n]\n",
  "FIDDLIER": "FIDDLY, time consuming [adj]\n",
  "FIDDLIEST": "FIDDLY, time consuming [adj]\n",
  "FIDDLING": "the act of playing a fiddle [n -S]\n",
  "FIDDLINGS": "FIDDLING, the act of playing a fiddle [n]\n",
  "FIDDLY": "time consuming [adj FIDDLIER, FIDDLIEST]\n",
  "FIDEICOMMISSA": "FIDEICOMMISSUM, a request by a decedent that the heir or legatee to the estate convey a specified part of the estate to another person, or permit another person to enjoy such a part [n]\n",
  "FIDEICOMMISSARY": "relating to a fideicommissum [adj]\n",
  "FIDEICOMMISSUM": "a request by a decedent that the heir or legatee to the estate convey a specified part of the estate to another person, or permit another person to enjoy such a part [n FIDEICOMMISSA]\n",
  "FIDEISM": "the doctrine that relies on faith not reason [n -S]\n",
  "FIDEISMS": "FIDEISM, the doctrine that relies on faith not reason [n]\n",
  "FIDEIST": "a believer in fideism, the doctrine that knowledge depends on faith over reason [n -S]\n",
  "FIDEISTIC": "relating to fideism, the doctrine that knowledge depends on faith over reason [adj]\n",
  "FIDEISTS": "FIDEIST, a believer in fideism, the doctrine that knowledge depends on faith over reason [n]\n",
  "FIDELISMO": "belief in the principles of Fidel Castro [n -S]\n",
  "FIDELISMOS": "FIDELISMO, belief in the principles of Fidel Castro [n]\n",
  "FIDELISTA": "a believer in the principles of Fidel Castro [n -S]\n",
  "FIDELISTAS": "FIDELISTA, a believer in the principles of Fidel Castro [n]\n",
  "FIDELITIES": "FIDELITY, loyalty [n]\n",
  "FIDELITY": "loyalty [n FIDELITIES]\n",
  "FIDES": "(Latin) faith, trust [n FIDES]\n",
  "FIDGE": "(dialect) to fidget [v FIDGED, FIDGING, FIDGES]\n",
  "FIDGED": "FIDGE, (dialect) to fidget [v]\n",
  "FIDGES": "FIDGE, (dialect) to fidget [v]\n",
  "FIDGET": "to move about restlessly [v -ED, -ING, -S]\n",
  "FIDGETED": "FIDGET, to move about restlessly [v]\n",
  "FIDGETER": "one who fidgets [n -S]\n",
  "FIDGETERS": "FIDGETER, one who fidgets [n]\n",
  "FIDGETIER": "FIDGETY, restless, uneasy [adj]\n",
  "FIDGETIEST": "FIDGETY, restless, uneasy [adj]\n",
  "FIDGETINESS": "the state of being fidgety [n -ES]\n",
  "FIDGETINESSES": "FIDGETINESS, the state of being fidgety [n]\n",
  "FIDGETING": "FIDGET, to move about restlessly [v]\n",
  "FIDGETINGLY": "FIDGETING, FIDGET, to move about restlessly [adv]\n",
  "FIDGETS": "FIDGET, to move about restlessly [v]\n",
  "FIDGETY": "restless, uneasy [adj FIDGETIER, FIDGETIEST]\n",
  "FIDGING": "FIDGE, (dialect) to fidget [v]\n",
  "FIDIBUS": "a paper spill for lighting a pipe [n -ES]\n",
  "FIDIBUSES": "FIDIBUS, a paper spill for lighting a pipe [n]\n",
  "FIDO": "a coin having a minting error [n -S]\n",
  "FIDOS": "FIDO, a coin having a minting error [n]\n",
  "FIDS": "FID, a conical pin of hard wood [n]\n",
  "FIDUCIAL": "showing confidence or reliance [adj FIDUCIALLY]\n",
  "FIDUCIALLY": "FIDUCIAL, showing confidence or reliance [adv]\n",
  "FIDUCIARIES": "FIDUCIARY, one who holds in trust [n]\n",
  "FIDUCIARILY": "FIDUCIARY, holding in trust [adv]\n",
  "FIDUCIARY": "holding in trust [adj FIDUCIARILY] / one who holds in trust [n FIDUCIARIES]\n",
  "FIE": "whimsical, fey [adj FIER, FIEST]\n",
  "FIEF": "a feudal estate [n -S]\n",
  "FIEFDOM": "a piece of land held as a fief [n -S]\n",
  "FIEFDOMS": "FIEFDOM, a piece of land held as a fief [n]\n",
  "FIEFS": "FIEF, a feudal estate [n]\n",
  "FIELD": "to play as a fielder [v -ED, -ING, -S]\n",
  "FIELDBOOT": "a knee-length boot [n -S]\n",
  "FIELDBOOTS": "FIELDBOOT, a knee-length boot [n]\n",
  "FIELDCRAFT": "the knowledge and skill needed to live in the wild [n -S]\n",
  "FIELDCRAFTS": "FIELDCRAFT, the knowledge and skill needed to live in the wild [n]\n",
  "FIELDED": "FIELD, to play as a fielder [v]\n",
  "FIELDER": "one who catches or picks up a ball in play [n -S]\n",
  "FIELDERS": "FIELDER, one who catches or picks up a ball in play [n]\n",
  "FIELDFARE": "a species of thrush, having a reddish-yellow throat and breast spotted with black [n -S]\n",
  "FIELDFARES": "FIELDFARE, a species of thrush, having a reddish-yellow throat and breast spotted with black [n]\n",
  "FIELDING": "in cricket, waiting to catch the batsman's balls [n -S]\n",
  "FIELDINGS": "FIELDING, in cricket, waiting to catch the batsman's balls [n]\n",
  "FIELDMICE": "FIELDMOUSE, a mouse which lives in woodland, aka fieldvole [n]\n",
  "FIELDMOUSE": "a mouse which lives in woodland, aka fieldvole [n FIELDMICE]\n",
  "FIELDPIECE": "a cannon or piece of artillery used in the field of battle [n -S]\n",
  "FIELDPIECES": "FIELDPIECE, a cannon or piece of artillery used in the field of battle [n]\n",
  "FIELDS": "FIELD, to play as a fielder [v]\n",
  "FIELDSMAN": "a fielder (in cricket or baseball) [n FIELDSMEN]\n",
  "FIELDSMEN": "FIELDSMAN, a fielder (in cricket or baseball) [n]\n",
  "FIELDSTONE": "(US) stone for building, taken from a field [n -S]\n",
  "FIELDSTONES": "FIELDSTONE, (US) stone for building, taken from a field [n]\n",
  "FIELDSTRIP": "to take apart a weapon for routine cleaning etc. [v FIELDSTRIPPED, FIELDSTRIPPING, FIELDSTRIPS]\n",
  "FIELDSTRIPPED": "FIELDSTRIP, to take apart a weapon for routine cleaning etc. [v]\n",
  "FIELDSTRIPPING": "FIELDSTRIP, to take apart a weapon for routine cleaning etc. [v]\n",
  "FIELDSTRIPS": "FIELDSTRIP, to take apart a weapon for routine cleaning etc. [v]\n",
  "FIELDVOLE": "a mouse which lives in woodland, aka fieldmouse [n -S]\n",
  "FIELDVOLES": "FIELDVOLE, a mouse which lives in woodland, aka fieldmouse [n]\n",
  "FIELDWARD": "in the direction of a field, also FIELDWARDS [adv]\n",
  "FIELDWARDS": "in the direction of a field, also FIELDWARD [adv]\n",
  "FIELDWORK": "work (scientific surveying, etc.) in the field, as opposed to in a laboratory, office, etc. [n -S]\n",
  "FIELDWORKER": "one who works in the fields [n -S]\n",
  "FIELDWORKERS": "FIELDWORKER, one who works in the fields [n]\n",
  "FIELDWORKS": "FIELDWORK, work (scientific surveying, etc.) in the field, as opposed to in a laboratory, office, etc. [n]\n",
  "FIEND": "a devil; a person driven by the most intense wickedness or hate [n -S]\n",
  "FIENDISH": "devilishly cruel [adj FIENDISHLY]\n",
  "FIENDISHLY": "FIENDISH, devilishly cruel [adv]\n",
  "FIENDISHNESS": "the state of being fiendish [n -ES]\n",
  "FIENDISHNESSES": "FIENDISHNESS, the state of being fiendish [n]\n",
  "FIENDLIKE": "like a fiend [adj]\n",
  "FIENDS": "FIEND, a devil; a person driven by the most intense wickedness or hate [n]\n",
  "FIENT": "(Scots) a fiend, a devil [n -S]\n",
  "FIENTS": "FIENT, (Scots) a fiend, a devil [n]\n",
  "FIER": "a companion, also FERE, FEARE, FIERE, PHEER, PHEERE [n -S]\n",
  "FIERCE": "violently hostile or aggressive [adj FIERCER, FIERCEST, FIERCELY]\n",
  "FIERCELY": "FIERCE, violently hostile or aggressive [adv]\n",
  "FIERCENESS": "the quality of being fierce [n -ES]\n",
  "FIERCENESSES": "FIERCENESS, the quality of being fierce [n]\n",
  "FIERCER": "FIERCE, violently hostile or aggressive [adj]\n",
  "FIERCEST": "FIERCE, violently hostile or aggressive [adj]\n",
  "FIERE": "a companion, also FERE, FEARE, FIER, PHEER, PHEERE [n -S]\n",
  "FIERES": "FIERE, a companion, also FERE, FEARE, FIER, PHEER, PHEERE [n]\n",
  "FIERIER": "FIERY, intensely hot [adj]\n",
  "FIERIEST": "FIERY, intensely hot [adj]\n",
  "FIERILY": "FIERY, intensely hot [adv]\n",
  "FIERINESS": "the state of being fiery [n -ES]\n",
  "FIERINESSES": "FIERINESS, the state of being fiery [n]\n",
  "FIERS": "FIER, a companion, also FERE, FEARE, FIERE, PHEER, PHEERE [n]\n",
  "FIERY": "intensely hot [adj FIERIER, FIERIEST, FIERILY]\n",
  "FIEST": "FIE, whimsical, fey [adj]\n",
  "FIESTA": "(Spanish) in Spain or Spanish America, a religious festival; any festivity or holiday [n -S]\n",
  "FIESTAS": "FIESTA, (Spanish) in Spain or Spanish America, a religious festival; any festivity or holiday [n]\n",
  "FIFE": "to play a high-pitched flute [v FIFED, FIFING, FIFES]\n",
  "FIFED": "FIFE, to play a high-pitched flute [v]\n",
  "FIFER": "one who plays the fife [n -S]\n",
  "FIFERS": "FIFER, one who plays the fife [n]\n",
  "FIFES": "FIFE, to play a high-pitched flute [v]\n",
  "FIFI": "a kind of hook [n -S]\n",
  "FIFING": "FIFE, to play a high-pitched flute [v]\n",
  "FIFIS": "FIFI, a kind of hook [n]\n",
  "FIFTEEN": "a number, five and ten [n -S]\n",
  "FIFTEENER": "a verse of fifteen syllables [n -S]\n",
  "FIFTEENERS": "FIFTEENER, a verse of fifteen syllables [n]\n",
  "FIFTEENS": "FIFTEEN, a number, five and ten [n]\n",
  "FIFTEENTH": "number fifteen in sequence [adj FIFTEENTHLY] / one of fifteen equal parts [n -S]\n",
  "FIFTEENTHLY": "FIFTEENTH, number fifteen in sequence [adv]\n",
  "FIFTEENTHS": "FIFTEENTH, one of fifteen equal parts [n]\n",
  "FIFTH": "number five in sequence [adj FIFTHLY] / one of five equal parts [n -S]\n",
  "FIFTHLY": "in the fifth place [adv]\n",
  "FIFTHS": "FIFTH, one of five equal parts [n]\n",
  "FIFTIES": "FIFTY, a number [n]\n",
  "FIFTIETH": "one of fifty equal parts [n -S]\n",
  "FIFTIETHS": "FIFTIETH, one of fifty equal parts [n]\n",
  "FIFTY": "a number [n FIFTIES]\n",
  "FIFTYFOLD": "multiplied fifty times over [adj]\n",
  "FIFTYISH": "about fifty years old [adj]\n",
  "FIG": "to dress up [v FIGGED, FIGGING, FIGS]\n",
  "FIGEATER": "a large beetle which in the southern US destroys figs [n -S]\n",
  "FIGEATERS": "FIGEATER, a large beetle which in the southern US destroys figs [n]\n",
  "FIGGED": "FIG, to dress up [v]\n",
  "FIGGERIES": "FIGGERY, dressy ornamentation [n]\n",
  "FIGGERY": "dressy ornamentation [n FIGGERIES]\n",
  "FIGGIER": "FIGGY, resembling, containing, or tasting like figs [adj]\n",
  "FIGGIEST": "FIGGY, resembling, containing, or tasting like figs [adj]\n",
  "FIGGING": "FIG, to dress up [v]\n",
  "FIGGY": "resembling, containing, or tasting like figs [adj FIGGIER, FIGGIEST]\n",
  "FIGHT": "to contend in war, battle or single combat [v FOUGHT, FOUGHTEN, FIGHTING, FIGHTS]\n",
  "FIGHTABLE": "able to be fought [adj]\n",
  "FIGHTBACK": "a recovery [n -S]\n",
  "FIGHTBACKS": "FIGHTBACK, a recovery [n]\n",
  "FIGHTER": "one that fights [n -S]\n",
  "FIGHTERS": "FIGHTER, one that fights [n]\n",
  "FIGHTING": "the act of one that fights [n -S]\n",
  "FIGHTINGS": "FIGHTING, the act of one that fights [n]\n",
  "FIGHTS": "FIGHT, to contend in war, battle or single combat [v]\n",
  "FIGJAM": "(Australian slang) a conceited person [n -S]\n",
  "FIGJAMS": "FIGJAM, (Australian slang) a conceited person [n]\n",
  "FIGLIKE": "like a fig [adj]\n",
  "FIGMENT": "fabrication or invention [n -S]\n",
  "FIGMENTS": "FIGMENT, fabrication or invention [n]\n",
  "FIGO": "(Shakespeare) a fig, a gesture of contempt, also FICO [n -S]\n",
  "FIGOS": "FIGO, (Shakespeare) a fig, a gesture of contempt, also FICO [n]\n",
  "FIGS": "FIG, to dress up [v]\n",
  "FIGTREE": "a tree that bears figs [n -S]\n",
  "FIGTREES": "FIGTREE, a tree that bears figs [n]\n",
  "FIGULINE": "of or relating to earthenware [adj] / potter's clay, earthenware [n -S]\n",
  "FIGULINES": "FIGULINE, potter's clay, earthenware [n]\n",
  "FIGURABILITIES": "FIGURABILITY, the quality of being figurable [n]\n",
  "FIGURABILITY": "the quality of being figurable [n FIGURABILITIES]\n",
  "FIGURABLE": "capable of being brought to a fixed form or shape [adj]\n",
  "FIGURAL": "represented by a figure [adj FIGURALLY]\n",
  "FIGURALLY": "FIGURAL, represented by a figure [adv]\n",
  "FIGURANT": "(Italian) a ballet dancer who dances only in groups, also FIGURANTE [n -S]\n",
  "FIGURANTE": "(Italian) a ballet-dancer, one of those who form a background for the solo dancer, also FIGURANT [n -S]\n",
  "FIGURANTES": "FIGURANTE, (Italian) a ballet-dancer, one of those who form a background for the solo dancer, also FIGURANT [n]\n",
  "FIGURANTS": "FIGURANT, (Italian) a ballet dancer who dances only in groups, also FIGURANTE [n]\n",
  "FIGURATE": "having a definite shape [adj FIGURATELY]\n",
  "FIGURATELY": "FIGURATE, having a definite shape [adv]\n",
  "FIGURATION": "the act of giving figure or form [n -S]\n",
  "FIGURATIONS": "FIGURATION, the act of giving figure or form [n]\n",
  "FIGURATIVE": "representing by a figure or resemblance [adj FIGURATIVELY]\n",
  "FIGURATIVELY": "FIGURATIVE, representing by a figure or resemblance [adv]\n",
  "FIGURATIVENESS": "FIGURATIVE, representing by a figure or resemblance [n]\n",
  "FIGURE": "to compute [v FIGURED, FIGURING, FIGURES]\n",
  "FIGURED": "FIGURE, to compute [v]\n",
  "FIGUREDLY": "FIGURED, FIGURE, to compute [adv]\n",
  "FIGUREHEAD": "the figure, statue, or bust, on the prow of a ship [n -S]\n",
  "FIGUREHEADS": "FIGUREHEAD, the figure, statue, or bust, on the prow of a ship [n]\n",
  "FIGURELESS": "without a figure [adj]\n",
  "FIGURER": "one who figures [n -S]\n",
  "FIGURERS": "FIGURER, one who figures [n]\n",
  "FIGURES": "FIGURE, to compute [v]\n",
  "FIGUREWORK": "counting or calculation using numbers [n -S]\n",
  "FIGUREWORKS": "FIGUREWORK, counting or calculation using numbers [n]\n",
  "FIGURINE": "a small modelled or sculpted figure [n -S]\n",
  "FIGURINES": "FIGURINE, a small modelled or sculpted figure [n]\n",
  "FIGURING": "FIGURE, to compute [v]\n",
  "FIGURIST": "one who uses or interprets figurative expressions [n -S]\n",
  "FIGURISTS": "FIGURIST, one who uses or interprets figurative expressions [n]\n",
  "FIGWORT": "a plant of the snapdragon family [n -S]\n",
  "FIGWORTS": "FIGWORT, a plant of the snapdragon family [n]\n",
  "FIKE": "(Scots) to fidget restlessly, also FYKE [v FIKED, FIKING, FIKES]\n",
  "FIKED": "FIKE, (Scots) to fidget restlessly, also FYKE [v]\n",
  "FIKERIES": "FIKERY, (Scots) fuss, fidget [n]\n",
  "FIKERY": "(Scots) fuss, fidget [n FIKERIES]\n",
  "FIKES": "FIKE, (Scots) to fidget restlessly, also FYKE [v]\n",
  "FIKIER": "FIKY, (Scots) fidgeting and restless, also FIKISH [adj]\n",
  "FIKIEST": "FIKY, (Scots) fidgeting and restless, also FIKISH [adj]\n",
  "FIKING": "FIKE, (Scots) to fidget restlessly, also FYKE [v]\n",
  "FIKISH": "(Scots) fidgeting and restless, also FIKY [adj]\n",
  "FIKY": "(Scots) fidgeting and restless, also FIKISH [adj FIKIER, FIKIEST]\n",
  "FIL": "(Shakespeare) the shaft of a vehicle [n -S]\n",
  "FILA": "FILUM, (Latin) a threadlike anatomical structure [n]\n",
  "FILABEG": "(Gaelic) the kilt, also FILIBEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLABEG, PHILLIBEG [n -S]\n",
  "FILABEGS": "FILABEG, (Gaelic) the kilt, also FILIBEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLABEG, PHILLIBEG [n]\n",
  "FILACEOUS": "composed of threads [adj]\n",
  "FILACER": "an officer who files writs, also FILAZER [n -S]\n",
  "FILACERS": "FILACER, an officer who files writs, also FILAZER [n]\n",
  "FILAGGRIN": "a protein that helps the skin function as a protective barrier against foreign organisms [n -S]\n",
  "FILAGGRINS": "FILAGGRIN, a protein that helps the skin function as a protective barrier against foreign organisms [n]\n",
  "FILAGREE": "(French) to adorn with intricate ornamental work, also FILIGRAIN, FILIGRANE, FILIGREE, FILLAGREE [v FILAGREED, FILAGREEING, FILAGREES]\n",
  "FILAGREED": "FILAGREE, (French) to adorn with intricate ornamental work, also FILIGRAIN, FILIGRANE, FILIGREE, FILLAGREE [v]\n",
  "FILAGREEING": "FILAGREE, (French) to adorn with intricate ornamental work, also FILIGRAIN, FILIGRANE, FILIGREE, FILLAGREE [v]\n",
  "FILAGREES": "FILAGREE, (French) to adorn with intricate ornamental work, also FILIGRAIN, FILIGRANE, FILIGREE, FILLAGREE [v]\n",
  "FILAMENT": "a slender threadlike body, fibre [n -S]\n",
  "FILAMENTARY": "like a filament [adj]\n",
  "FILAMENTOUS": "threadlike; of some bacteria, viruses, etc., having long strands of similar cells [adj]\n",
  "FILAMENTS": "FILAMENT, a slender threadlike body, fibre [n]\n",
  "FILANDER": "a threadlike intestinal worm in hawks [n -S]\n",
  "FILANDERS": "FILANDER, a threadlike intestinal worm in hawks [n]\n",
  "FILAR": "pertaining to a thread [adj]\n",
  "FILAREE": "(Spanish) a Californian weed, aka pin grass or alfilaria [n -S]\n",
  "FILAREES": "FILAREE, (Spanish) a Californian weed, aka pin grass or alfilaria [n]\n",
  "FILARIA": "(Latin) a parasitic worm, also FILARIID [n FILARIAE]\n",
  "FILARIAE": "FILARIA, (Latin) a parasitic worm, also FILARIID [n]\n",
  "FILARIAL": "relating to a filaria, a parasitic worm, also FILARIAN [adj]\n",
  "FILARIAN": "relating to a filaria, a parasitic worm, also FILARIAL [adj]\n",
  "FILARIASES": "FILARIASIS, a disease caused by the presence of filaria in the blood [n]\n",
  "FILARIASIS": "a disease caused by the presence of filaria in the blood [n FILARIASES]\n",
  "FILARIID": "a parasitic worm, also FILARIA [n -S]\n",
  "FILARIIDS": "FILARIID, a parasitic worm, also FILARIA [n]\n",
  "FILASSE": "(French) vegetable fibre prepared for manufacture [n -S]\n",
  "FILASSES": "FILASSE, (French) vegetable fibre prepared for manufacture [n]\n",
  "FILATORIES": "FILATORY, a machine which makes threads [n]\n",
  "FILATORY": "a machine which makes threads [n FILATORIES]\n",
  "FILATURE": "(French) the reeling of silk from cocoons [n -S]\n",
  "FILATURES": "FILATURE, (French) the reeling of silk from cocoons [n]\n",
  "FILAZER": "an officer who files writs, also FILACER [n -S]\n",
  "FILAZERS": "FILAZER, an officer who files writs, also FILACER [n]\n",
  "FILBERD": "a hazel nut, also FILBERT [n -S]\n",
  "FILBERDS": "FILBERD, a hazel nut, also FILBERT [n]\n",
  "FILBERT": "a hazel nut, also FILBERD [n -S]\n",
  "FILBERTS": "FILBERT, a hazel nut, also FILBERD [n]\n",
  "FILCH": "to pilfer [v -ED, -ING, -ES]\n",
  "FILCHED": "FILCH, to pilfer [v]\n",
  "FILCHER": "someone who filches [n -S]\n",
  "FILCHERS": "FILCHER, someone who filches [n]\n",
  "FILCHES": "FILCH, to pilfer [v]\n",
  "FILCHING": "thieving [adj FILCHINGLY] / the act of filching [n -S]\n",
  "FILCHINGLY": "FILCHING, thieving [adv]\n",
  "FILCHINGS": "FILCHING, the act of filching [n]\n",
  "FILE": "to arrange in order for future reference [v FILED, FILING, FILES]\n",
  "FILEABLE": "able to be filed [adj]\n",
  "FILECARD": "a brush for cleaning a file [n -S]\n",
  "FILECARDS": "FILECARD, a brush for cleaning a file [n]\n",
  "FILED": "FILE, to arrange in order for future reference [v]\n",
  "FILEFISH": "a kind of fish with roughly granulated skin, which is sometimes used in place of sandpaper [n -ES]\n",
  "FILEFISHES": "FILEFISH, a kind of fish with roughly granulated skin, which is sometimes used in place of sandpaper [n]\n",
  "FILEMOT": "(French) a dull brown colour, also PHILAMOT, PHILOMOT [n -S]\n",
  "FILEMOTS": "FILEMOT, (French) a dull brown colour, also PHILAMOT, PHILOMOT [n]\n",
  "FILENAME": "the name of a computer file [n -S]\n",
  "FILENAMES": "FILENAME, the name of a computer file [n]\n",
  "FILER": "a person or thing that files [n -S]\n",
  "FILERS": "FILER, a person or thing that files [n]\n",
  "FILES": "FILE, to arrange in order for future reference [v]\n",
  "FILET": "to cut boneless slices from, also FILLET [v -ED, -ING, -S]\n",
  "FILETED": "FILET, to cut boneless slices from, also FILLET [v]\n",
  "FILETING": "FILET, to cut boneless slices from, also FILLET [v]\n",
  "FILETS": "FILET, to cut boneless slices from, also FILLET [v]\n",
  "FILFOT": "a swastika, also FYLFOT [n -S]\n",
  "FILFOTS": "FILFOT, a swastika, also FYLFOT [n]\n",
  "FILIAL": "pertaining to a son or daughter [adj FILIALLY]\n",
  "FILIALLY": "FILIAL, pertaining to a son or daughter [adv]\n",
  "FILIALNESS": "the state of being filial [n -ES]\n",
  "FILIALNESSES": "FILIALNESS, the state of being filial [n]\n",
  "FILIATE": "to bring into close association [v FILIATED, FILIATING, FILIATES]\n",
  "FILIATED": "FILIATE, to bring into close association [v]\n",
  "FILIATES": "FILIATE, to bring into close association [v]\n",
  "FILIATING": "FILIATE, to bring into close association [v]\n",
  "FILIATION": "the relationship of a son or child to a parent, esp. to a father [n -S]\n",
  "FILIATIONS": "FILIATION, the relationship of a son or child to a parent, esp. to a father [n]\n",
  "FILIBEG": "(Gaelic) the kilt, also FILABEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLABEG, PHILLIBEG [n -S]\n",
  "FILIBEGS": "FILIBEG, (Gaelic) the kilt, also FILABEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLABEG, PHILLIBEG [n]\n",
  "FILIBUSTER": "(Dutch) to obstructs legislation by making long speeches [v -ED, -ING, -S]\n",
  "FILIBUSTERED": "FILIBUSTER, (Dutch) to obstructs legislation by making long speeches [v]\n",
  "FILIBUSTERER": "one who filibusters [n -S]\n",
  "FILIBUSTERERS": "FILIBUSTERER, one who filibusters [n]\n",
  "FILIBUSTERING": "obstructing legislation by making long speeches [n -S]\n",
  "FILIBUSTERINGS": "FILIBUSTERING, obstructing legislation by making long speeches [n]\n",
  "FILIBUSTERISM": "the actions of a filibuster [n -S]\n",
  "FILIBUSTERISMS": "FILIBUSTERISM, the actions of a filibuster [n]\n",
  "FILIBUSTEROUS": "like a filibuster [adj]\n",
  "FILIBUSTERS": "FILIBUSTER, (Dutch) to obstructs legislation by making long speeches [v]\n",
  "FILICIDAL": "relating to filicide, the killing of one's own child [adj]\n",
  "FILICIDE": "the killing of one's child [n -S]\n",
  "FILICIDES": "FILICIDE, the killing of one's child [n]\n",
  "FILICINEAN": "relating to Filicineae, the ferns [adj]\n",
  "FILIFORM": "shaped like a filament [adj]\n",
  "FILIGRAIN": "(French) a kind of ornamental metallic lacework, also FILAGREE, FILIGRANE, FILIGREE, FILLAGREE [n -S]\n",
  "FILIGRAINS": "FILIGRAIN, (French) a kind of ornamental metallic lacework, also FILAGREE, FILIGRANE, FILIGREE, FILLAGREE [n]\n",
  "FILIGRANE": "(French) a kind of ornamental metallic lacework, also FILAGREE, FILIGRAIN, FILIGREE, FILLAGREE [n -S]\n",
  "FILIGRANES": "FILIGRANE, (French) a kind of ornamental metallic lacework, also FILAGREE, FILIGRAIN, FILIGREE, FILLAGREE [n]\n",
  "FILIGREE": "(French) to adorn with intricate ornamental work, also FILAGREE, FILLAGREE [v FILIGREED, FILIGREEING, FILIGREES]\n",
  "FILIGREED": "FILIGREE, (French) to adorn with intricate ornamental work, also FILAGREE, FILLAGREE [v]\n",
  "FILIGREEING": "FILIGREE, (French) to adorn with intricate ornamental work, also FILAGREE, FILLAGREE [v]\n",
  "FILIGREES": "FILIGREE, (French) to adorn with intricate ornamental work, also FILAGREE, FILLAGREE [v]\n",
  "FILII": "FILIUS, (Latin) a son [n]\n",
  "FILING": "a particle removed by a file [n -S]\n",
  "FILINGS": "FILING, a particle removed by a file [n]\n",
  "FILIOPIETISTIC": "marked by excessive veneration of ancestors [adj]\n",
  "FILIOQUE": "(Latin) a doctrine that the Holy Ghost proceeds from the Son [n -S]\n",
  "FILIOQUES": "FILIOQUE, (Latin) a doctrine that the Holy Ghost proceeds from the Son [n]\n",
  "FILIPENDULOUS": "hanging by or strung on a thread [adj]\n",
  "FILISTER": "a groove on a window frame, also FILLESTER, FILLISTER [n -S]\n",
  "FILISTERS": "FILISTER, a groove on a window frame, also FILLESTER, FILLISTER [n]\n",
  "FILIUS": "(Latin) a son [n FILII]\n",
  "FILK": "a type of popular music that parodies folk songs [n -S]\n",
  "FILKS": "FILK, a type of popular music that parodies folk songs [n]\n",
  "FILL": "to make full [v -ED, -ING, -S]\n",
  "FILLABLE": "capable of being filled [adj]\n",
  "FILLAGREE": "a kind of ornamental metallic lacework [n -S] / to execute this lacework, also FILAGREE, FILIGRAIN, FILIGRANE, FILIGREE [v FILLAGREED, FILLAGREEING, FILLAGREES]\n",
  "FILLAGREED": "FILLAGREE, to execute this lacework, also FILAGREE, FILIGRAIN, FILIGRANE, FILIGREE [v]\n",
  "FILLAGREEING": "FILLAGREE, to execute this lacework, also FILAGREE, FILIGRAIN, FILIGRANE, FILIGREE [v]\n",
  "FILLAGREES": "FILLAGREE, a kind of ornamental metallic lacework [n]\n",
  "FILLE": "(French) a girl [n -S]\n",
  "FILLED": "FILL, to make full [v]\n",
  "FILLER": "one that fills [n -S]\n",
  "FILLERS": "FILLER, one that fills [n]\n",
  "FILLES": "FILLE, (French) a girl [n]\n",
  "FILLESTER": "a rabbet plane used in making window sashes, also FILISTER, FILLISTER [n -S]\n",
  "FILLESTERS": "FILLESTER, a rabbet plane used in making window sashes, also FILISTER, FILLISTER [n]\n",
  "FILLET": "to cut boneless slices from, also FILET [v -ED, -ING, -S]\n",
  "FILLETED": "FILLET, to cut boneless slices from, also FILET [v]\n",
  "FILLETER": "one who fillets [n -S]\n",
  "FILLETERS": "FILLETER, one who fillets [n]\n",
  "FILLETING": "FILLET, to cut boneless slices from, also FILET [v]\n",
  "FILLETS": "FILLET, to cut boneless slices from, also FILET [v]\n",
  "FILLIBEG": "(Gaelic) the kilt, also FILABEG, FILIBEG, PHILABEG, PHILIBEG, PHILLABEG, PHILLIBEG [n -S]\n",
  "FILLIBEGS": "FILLIBEG, (Gaelic) the kilt, also FILABEG, FILIBEG, PHILABEG, PHILIBEG, PHILLABEG, PHILLIBEG [n]\n",
  "FILLIES": "FILLY, a female horse up to four years old [n]\n",
  "FILLING": "anything used to fill something [n -S]\n",
  "FILLINGS": "FILLING, anything used to fill something [n]\n",
  "FILLIP": "to strike sharply [v -ED, -ING, -S]\n",
  "FILLIPED": "FILLIP, to strike sharply [v]\n",
  "FILLIPEEN": "(US) a game in which each of two players eats a twin kernel of a nut, also PHILIPPINA, PHILIPPINE, PHILOPENA, PHILOPOENA [n -S]\n",
  "FILLIPEENS": "FILLIPEEN, (US) a game in which each of two players eats a twin kernel of a nut, also PHILIPPINA, PHILIPPINE, PHILOPENA, PHILOPOENA [n]\n",
  "FILLIPING": "FILLIP, to strike sharply [v]\n",
  "FILLIPS": "FILLIP, to strike sharply [v]\n",
  "FILLISTER": "a rabbet plane used in making window sashes, also FILISTER, FILLESTER [n -S]\n",
  "FILLISTERS": "FILLISTER, a rabbet plane used in making window sashes, also FILISTER, FILLESTER [n]\n",
  "FILLO": "(Greek) very thin pastry dough, also FILO, PHYLLO [n -S]\n",
  "FILLOS": "FILLO, (Greek) very thin pastry dough, also FILO, PHYLLO [n]\n",
  "FILLS": "FILL, to make full [v]\n",
  "FILLY": "a female horse up to four years old [n FILLIES]\n",
  "FILM": "to make a motion picture [v -ED, -ING, -S]\n",
  "FILMABLE": "able to be filmed [adj]\n",
  "FILMCARD": "a fiche, a card or strip of film containing miniaturized data [n -S]\n",
  "FILMCARDS": "FILMCARD, a fiche, a card or strip of film containing miniaturized data [n]\n",
  "FILMDOM": "the motion-picture industry, also FILMLAND [n -S]\n",
  "FILMDOMS": "FILMDOM, the motion-picture industry, also FILMLAND [n]\n",
  "FILMED": "FILM, to make a motion picture [v]\n",
  "FILMER": "one who films [n -S]\n",
  "FILMERS": "FILMER, one who films [n]\n",
  "FILMFEST": "a festival at which many films are shown [n -S]\n",
  "FILMFESTS": "FILMFEST, a festival at which many films are shown [n]\n",
  "FILMGOER": "one who goes to see motion pictures [n -S]\n",
  "FILMGOERS": "FILMGOER, one who goes to see motion pictures [n]\n",
  "FILMGOING": "the practice of going to films [n -S]\n",
  "FILMGOINGS": "FILMGOING, the practice of going to films [n]\n",
  "FILMI": "(Hinglish) relating to films or the cinema industry [n -S]\n",
  "FILMIC": "pertaining to motion pictures [adj FILMICALLY]\n",
  "FILMICALLY": "FILMIC, pertaining to motion pictures [adv]\n",
  "FILMIER": "FILMY, thin, delicate [adj]\n",
  "FILMIEST": "FILMY, thin, delicate [adj]\n",
  "FILMILY": "FILMY, thin, delicate [adv]\n",
  "FILMINESS": "the state of being filmy [n -ES]\n",
  "FILMINESSES": "FILMINESS, the state of being filmy [n]\n",
  "FILMING": "the act of making a motion picture [n -S]\n",
  "FILMINGS": "FILMING, the act of making a motion picture [n]\n",
  "FILMIS": "FILMI, (Hinglish) relating to films or the cinema industry [n]\n",
  "FILMISH": "in a style associated with films [adj]\n",
  "FILMLAND": "the motion-picture industry, also FILMDOM [n -S]\n",
  "FILMLANDS": "FILMLAND, the motion-picture industry, also FILMDOM [n]\n",
  "FILMLESS": "without film [adj]\n",
  "FILMLIKE": "like film [adj]\n",
  "FILMMAKER": "one who makes films [n -S]\n",
  "FILMMAKERS": "FILMMAKER, one who makes films [n]\n",
  "FILMMAKING": "the making of films [n -S]\n",
  "FILMMAKINGS": "FILMMAKING, the making of films [n]\n",
  "FILMOGRAPHIES": "FILMOGRAPHY, a list of the films of a particular actor or director [n]\n",
  "FILMOGRAPHY": "a list of the films of a particular actor or director [n FILMOGRAPHIES]\n",
  "FILMS": "FILM, to make a motion picture [v]\n",
  "FILMSET": "to set by a process of typesetting [v FILMSET, FILMSETTING, FILMSETS]\n",
  "FILMSETS": "FILMSET, to set by a process of typesetting [v]\n",
  "FILMSETTER": "a typesetter who uses filmsetting [n -S]\n",
  "FILMSETTERS": "FILMSETTER, a typesetter who uses filmsetting [n]\n",
  "FILMSETTING": "setting by a process of typesetting [n -S]\n",
  "FILMSETTINGS": "FILMSETTING, setting by a process of typesetting [n]\n",
  "FILMSTRIP": "a film consisting of a series of stills to be shown separately and consecutively [n -S]\n",
  "FILMSTRIPS": "FILMSTRIP, a film consisting of a series of stills to be shown separately and consecutively [n]\n",
  "FILMY": "thin, delicate [adj FILMIER, FILMIEST, FILMILY]\n",
  "FILO": "(Greek) very thin pastry dough, also FILLO, PHYLLO [n -S]\n",
  "FILOPLUME": "a slender hairlike feather [n -S]\n",
  "FILOPLUMES": "FILOPLUME, a slender hairlike feather [n]\n",
  "FILOPODIA": "FILOPODIUM, a threadlike pseudopodium consisting of ectoplasm [n]\n",
  "FILOPODIUM": "a threadlike pseudopodium consisting of ectoplasm [n FILOPODIA]\n",
  "FILOS": "FILO, (Greek) very thin pastry dough, also FILLO, PHYLLO [n]\n",
  "FILOSE": "resembling a thread [adj]\n",
  "FILOSELLE": "(French) floss silk, or a thread similar to this [n -S]\n",
  "FILOSELLES": "FILOSELLE, (French) floss silk, or a thread similar to this [n]\n",
  "FILOVIRUS": "any member of a family of viruses that includes the agents responsible for Ebola virus disease and Marburg disease [n -ES]\n",
  "FILOVIRUSES": "FILOVIRUS, any member of a family of viruses that includes the agents responsible for Ebola virus disease and Marburg disease [n]\n",
  "FILS": "FIL, (Shakespeare) the shaft of a vehicle [n]\n",
  "FILTER": "to purify a fluid of solid matter [v -ED, -ING, -S]\n",
  "FILTERABILITIES": "FILTERABILITY, the quality of being filterable, also FILTRABILITY [n]\n",
  "FILTERABILITY": "the quality of being filterable, also FILTRABILITY [n FILTERABILITIES]\n",
  "FILTERABLE": "capable of being filtered, also FILTRABLE [adj]\n",
  "FILTERABLENESS": "the state of being filterable, also FILTRABLENESS [n]\n",
  "FILTERED": "FILTER, to purify a fluid of solid matter [v]\n",
  "FILTERER": "one that filters [n -S]\n",
  "FILTERERS": "FILTERER, one that filters [n]\n",
  "FILTERING": "FILTER, to purify a fluid of solid matter [v]\n",
  "FILTERS": "FILTER, to purify a fluid of solid matter [v]\n",
  "FILTH": "foul or dirty matter [n -S]\n",
  "FILTHIER": "FILTHY, offensively dirty [adj]\n",
  "FILTHIEST": "FILTHY, offensively dirty [adj]\n",
  "FILTHILY": "FILTHY, offensively dirty [adv]\n",
  "FILTHINESS": "the quality of being filthy [n -ES]\n",
  "FILTHINESSES": "FILTHINESS, the quality of being filthy [n]\n",
  "FILTHS": "FILTH, foul or dirty matter [n]\n",
  "FILTHY": "offensively dirty [adj FILTHIER, FILTHIEST, FILTHILY]\n",
  "FILTRABILITIES": "FILTRABILITY, the quality of being filtrable, also FILTERABILITY [n]\n",
  "FILTRABILITY": "the quality of being filtrable, also FILTERABILITY [n FILTRABILITIES]\n",
  "FILTRABLE": "capable of being filtered, also FILTERABLE [adj]\n",
  "FILTRABLENESS": "the state of being filtrable, also FILTERABLENESS [n -ES]\n",
  "FILTRABLENESSES": "FILTRABLENESS, the state of being filtrable, also FILTERABLENESS [n]\n",
  "FILTRATABLE": "that can be filtrated [adj]\n",
  "FILTRATE": "to filter [v FILTRATED, FILTRATING, FILTRATES]\n",
  "FILTRATED": "FILTRATE, to filter [v]\n",
  "FILTRATES": "FILTRATE, to filter [v]\n",
  "FILTRATING": "FILTRATE, to filter [v]\n",
  "FILTRATION": "the act of filtering [n -S]\n",
  "FILTRATIONS": "FILTRATION, the act of filtering [n]\n",
  "FILTRE": "as in cafe filtre, a strong black filtered coffee [adj]\n",
  "FILUM": "(Latin) a threadlike anatomical structure [n FILA]\n",
  "FIMBLE": "the male plant of hemp [n -S]\n",
  "FIMBLES": "FIMBLE, the male plant of hemp [n]\n",
  "FIMBRIA": "(Latin) a fringing filament [n FIMBRIAE]\n",
  "FIMBRIAE": "FIMBRIA, (Latin) a fringing filament [n]\n",
  "FIMBRIAL": "pertaining to or having a fimbria, a fringe [adj]\n",
  "FIMBRIATE": "to border with a narrow band or edge [v FIMBRIATED, FIMBRIATING, FIMBRIATES]\n",
  "FIMBRIATED": "FIMBRIATE, to border with a narrow band or edge [v]\n",
  "FIMBRIATES": "FIMBRIATE, to border with a narrow band or edge [v]\n",
  "FIMBRIATING": "FIMBRIATE, to border with a narrow band or edge [v]\n",
  "FIMBRIATION": "the state of being fimbriate [n -S]\n",
  "FIMBRIATIONS": "FIMBRIATION, the state of being fimbriate [n]\n",
  "FIMBRILLATE": "having a fringed margin, also FIMBRIATE [adj]\n",
  "FIMICOLOUS": "living in or growing in animal excrement [adj]\n",
  "FIN": "to equip with paddle-like structures [v FINNED, FINNING, FINS]\n",
  "FINABLE": "subject to the payment of a fine, also FINEABLE [adj]\n",
  "FINABLENESS": "the state of being finable [n -ES]\n",
  "FINABLENESSES": "FINABLENESS, the state of being finable [n]\n",
  "FINAGLE": "to obtain by trickery, also FENAGLE [v FINAGLED, FINAGLING, FINAGLES]\n",
  "FINAGLED": "FINAGLE, to obtain by trickery, also FENAGLE [v]\n",
  "FINAGLER": "one who finagles, obtains by guile or swindling [n -S]\n",
  "FINAGLERS": "FINAGLER, one who finagles, obtains by guile or swindling [n]\n",
  "FINAGLES": "FINAGLE, to obtain by trickery, also FENAGLE [v]\n",
  "FINAGLING": "the act of obtaining by guile [n -S]\n",
  "FINAGLINGS": "FINAGLING, the act of obtaining by guile [n]\n",
  "FINAL": "last in sequence [adj FINALLY] / the last examination of an academic course [n -S]\n",
  "FINALE": "(Italian) a termination of something [n -S]\n",
  "FINALES": "FINALE, (Italian) a termination of something [n]\n",
  "FINALIS": "(Latin) a type of tone in medieval music [n -ES]\n",
  "FINALISATION": "the act of finalising, also FINALIZATION [n -S]\n",
  "FINALISATIONS": "FINALISATION, the act of finalising, also FINALIZATION [n]\n",
  "FINALISE": "to completely finish, also FINALIZE [v FINALISED, FINALISING, FINALISES]\n",
  "FINALISED": "FINALISE, to completely finish, also FINALIZE [v]\n",
  "FINALISER": "one who finalises, also FINALIZER [n -S]\n",
  "FINALISERS": "FINALISER, one who finalises, also FINALIZER [n]\n",
  "FINALISES": "FINALISE, to completely finish, also FINALIZE [v]\n",
  "FINALISING": "FINALISE, to completely finish, also FINALIZE [v]\n",
  "FINALISM": "belief that an end has been reached [n -S]\n",
  "FINALISMS": "FINALISM, belief that an end has been reached [n]\n",
  "FINALIST": "a contestant who reaches the last part of a competition [n -S]\n",
  "FINALISTIC": "relating to finalism, a belief in an inherent trend in the natural world towards some preordained final goal or purpose [adj]\n",
  "FINALISTS": "FINALIST, a contestant who reaches the last part of a competition [n]\n",
  "FINALITIES": "FINALITY, the state of being conclusive [n]\n",
  "FINALITY": "the state of being conclusive [n FINALITIES]\n",
  "FINALIZATION": "the act of finalising, also FINALISATION [n -S]\n",
  "FINALIZATIONS": "FINALIZATION, the act of finalising, also FINALISATION [n]\n",
  "FINALIZE": "to completely finish, also FINALISE [v FINALIZED, FINALIZING, FINALIZES]\n",
  "FINALIZED": "FINALIZE, to completely finish, also FINALISE [v]\n",
  "FINALIZER": "one who finalizes, also FINALISER [n -S]\n",
  "FINALIZERS": "FINALIZER, one who finalizes, also FINALISER [n]\n",
  "FINALIZES": "FINALIZE, to completely finish, also FINALISE [v]\n",
  "FINALIZING": "FINALIZE, to completely finish, also FINALISE [v]\n",
  "FINALLY": "FINAL, last in sequence [adv]\n",
  "FINALS": "FINAL, the last examination of an academic course [n]\n",
  "FINANCE": "to supply the money for [v FINANCED, FINANCING, FINANCES]\n",
  "FINANCED": "FINANCE, to supply the money for [v]\n",
  "FINANCES": "FINANCE, to supply the money for [v]\n",
  "FINANCIAL": "relating to finance [adj FINANCIALLY]\n",
  "FINANCIALIST": "a financier [n -S]\n",
  "FINANCIALISTS": "FINANCIALIST, a financier [n]\n",
  "FINANCIALLY": "FINANCIAL, relating to finance [adv]\n",
  "FINANCIALS": "reports and statements about the financial performance of a business [n]\n",
  "FINANCIER": "a person engaged in large financial transactions [n -S] / to conduct financial operations; to swindle [v -ED, -ING, -S]\n",
  "FINANCIERED": "FINANCIER, to conduct financial operations; to swindle [v]\n",
  "FINANCIERING": "FINANCIER, to conduct financial operations; to swindle [v]\n",
  "FINANCIERS": "FINANCIER, to conduct financial operations; to swindle [v]\n",
  "FINANCING": "the act of providing finance [n -S]\n",
  "FINANCINGS": "FINANCING, the act of providing finance [n]\n",
  "FINBACK": "a type of whale characterized by a prominent fin on the back, aka rorqual, also FINFISH, FINNER [n -S]\n",
  "FINBACKS": "FINBACK, a type of whale characterized by a prominent fin on the back, aka rorqual, also FINFISH, FINNER [n]\n",
  "FINCA": "(Spanish) a Spanish villa [n -S]\n",
  "FINCAS": "FINCA, (Spanish) a Spanish villa [n]\n",
  "FINCH": "a small bird [n -ES]\n",
  "FINCHED": "striped or spotted on the back [adj]\n",
  "FINCHES": "FINCH, a small bird [n]\n",
  "FINCHLIKE": "like a finch [adj]\n",
  "FIND": "to come upon after a search [v FOUND, FINDING, FINDS]\n",
  "FINDABLE": "able to be found [adj]\n",
  "FINDER": "one that finds [n -S]\n",
  "FINDERS": "FINDER, one that finds [n]\n",
  "FINDING": "something that is found [n -S]\n",
  "FINDINGS": "FINDING, something that is found [n]\n",
  "FINDRAM": "a kind of smoked haddock, also FINNAN [n -S]\n",
  "FINDRAMS": "FINDRAM, a kind of smoked haddock, also FINNAN [n]\n",
  "FINDS": "FIND, to come upon after a search [v]\n",
  "FINE": "to incur a monetary penalty [v FINED, FINING, FINES] / delicate [adj FINER, FINEST, FINELY]\n",
  "FINEABLE": "subject to the payment of a fine, also FINABLE [adj]\n",
  "FINEABLENESS": "the state of being fineable [n -ES]\n",
  "FINEABLENESSES": "FINEABLENESS, the state of being fineable [n]\n",
  "FINED": "FINE, to incur a monetary penalty [v]\n",
  "FINEER": "to get goods by fraud [v -ED, -ING, -S]\n",
  "FINEERED": "FINEER, to get goods by fraud [v]\n",
  "FINEERING": "FINEER, to get goods by fraud [v]\n",
  "FINEERS": "FINEER, to get goods by fraud [v]\n",
  "FINEISH": "somewhat fine [adj]\n",
  "FINELESS": "(Shakespeare) endless [adj]\n",
  "FINELY": "FINE, delicate [adv]\n",
  "FINENESS": "the quality of being fine [n -ES]\n",
  "FINENESSES": "FINENESS, the quality of being fine [n]\n",
  "FINER": "a refiner [n -S]\n",
  "FINERIES": "FINERY, elaborate adornment [n]\n",
  "FINERS": "FINER, a refiner [n]\n",
  "FINERY": "elaborate adornment [n FINERIES]\n",
  "FINES": "FINE, to incur a monetary penalty [v]\n",
  "FINESPUN": "developed with extreme care [adj]\n",
  "FINESSE": "to use cunning strategy [v FINESSED, FINESSING, FINESSES]\n",
  "FINESSED": "FINESSE, to use cunning strategy [v]\n",
  "FINESSER": "one who does something with finesse [n -S]\n",
  "FINESSERS": "FINESSER, one who does something with finesse [n]\n",
  "FINESSES": "FINESSE, to use cunning strategy [v]\n",
  "FINESSING": "the act of making a finesse [n -S]\n",
  "FINESSINGS": "FINESSING, the act of making a finesse [n]\n",
  "FINEST": "the worthiest citizens of a place [n -S]\n",
  "FINESTS": "FINEST, the worthiest citizens of a place [n]\n",
  "FINFISH": "a finback whale, also FINBACK, FINNER [n -ES]\n",
  "FINFISHES": "FINFISH, a finback whale, also FINBACK, FINNER [n]\n",
  "FINFOOT": "a South American bird allied to the grebes [n -S]\n",
  "FINFOOTS": "FINFOOT, a South American bird allied to the grebes [n]\n",
  "FINGAN": "(Arabic) the handleless coffee cup which fits within a zarf, also FINJAN [n -S]\n",
  "FINGANS": "FINGAN, (Arabic) the handleless coffee cup which fits within a zarf, also FINJAN [n]\n",
  "FINGER": "to touch with one of the five terminal parts of the hand [v -ED, -ING, -S]\n",
  "FINGERBOARD": "the part of a violin, etc. against which the strings are stopped by the fingers [n -S]\n",
  "FINGERBOARDS": "FINGERBOARD, the part of a violin, etc. against which the strings are stopped by the fingers [n]\n",
  "FINGERBOWL": "a bowl of water for washing the fingers in at table [n -S]\n",
  "FINGERBOWLS": "FINGERBOWL, a bowl of water for washing the fingers in at table [n]\n",
  "FINGERBREADTH": "the breadth of a finger [n -S]\n",
  "FINGERBREADTHS": "FINGERBREADTH, the breadth of a finger [n]\n",
  "FINGERED": "FINGER, to touch with one of the five terminal parts of the hand [v]\n",
  "FINGERER": "one that fingers [n -S]\n",
  "FINGERERS": "FINGERER, one that fingers [n]\n",
  "FINGERGLASS": "a bowl for water to clean the fingers at table [n -ES]\n",
  "FINGERGLASSES": "FINGERGLASS, a bowl for water to clean the fingers at table [n]\n",
  "FINGERGUARD": "the crosspiece of a sword-handle [n -S]\n",
  "FINGERGUARDS": "FINGERGUARD, the crosspiece of a sword-handle [n]\n",
  "FINGERHOLD": "a hold or place of support for the fingers [n -S]\n",
  "FINGERHOLDS": "FINGERHOLD, a hold or place of support for the fingers [n]\n",
  "FINGERHOLE": "a hole in a wind instrument for putting the fingers in to modify the pitch [n -S]\n",
  "FINGERHOLES": "FINGERHOLE, a hole in a wind instrument for putting the fingers in to modify the pitch [n]\n",
  "FINGERING": "the choice of fingers in playing a musical instrument [n -S]\n",
  "FINGERINGS": "FINGERING, the choice of fingers in playing a musical instrument [n]\n",
  "FINGERLESS": "without fingers [adj]\n",
  "FINGERLIKE": "like a finger [adj]\n",
  "FINGERLING": "a salmon parr or young trout less than a year old [n -S]\n",
  "FINGERLINGS": "FINGERLING, a salmon parr or young trout less than a year old [n]\n",
  "FINGERMARK": "a mark made by the fingers [n -S]\n",
  "FINGERMARKS": "FINGERMARK, a mark made by the fingers [n]\n",
  "FINGERNAIL": "the nail of a finger [n -S]\n",
  "FINGERNAILS": "FINGERNAIL, the nail of a finger [n]\n",
  "FINGERPICK": "to play the guitar with fingers rather than a plectrum [v -ED, -ING, -S]\n",
  "FINGERPICKED": "FINGERPICK, to play the guitar with fingers rather than a plectrum [v]\n",
  "FINGERPICKING": "playing the guitar with fingers rather than a plectrum [n -S]\n",
  "FINGERPICKINGS": "FINGERPICKING, playing the guitar with fingers rather than a plectrum [n]\n",
  "FINGERPICKS": "FINGERPICK, to play the guitar with fingers rather than a plectrum [v]\n",
  "FINGERPLATE": "a plate to protect a door from dirty fingers [n -S]\n",
  "FINGERPLATES": "FINGERPLATE, a plate to protect a door from dirty fingers [n]\n",
  "FINGERPOST": "a post with a finger pointing the way to a destination [n -S]\n",
  "FINGERPOSTS": "FINGERPOST, a post with a finger pointing the way to a destination [n]\n",
  "FINGERPRINT": "an impression of the ridges of the fingertip [n -S] / to take fingerprints [v -ED, -ING, -S]\n",
  "FINGERPRINTED": "FINGERPRINT, to take fingerprints [v]\n",
  "FINGERPRINTING": "the act of taking fingerprints [n -S]\n",
  "FINGERPRINTINGS": "FINGERPRINTING, the act of taking fingerprints [n]\n",
  "FINGERPRINTS": "FINGERPRINT, an impression of the ridges of the fingertip [n]\n",
  "FINGERS": "FINGER, to touch with one of the five terminal parts of the hand [v]\n",
  "FINGERSTALL": "a covering for protecting a finger [n -S]\n",
  "FINGERSTALLS": "FINGERSTALL, a covering for protecting a finger [n]\n",
  "FINGERTIP": "the end of the finger [n -S]\n",
  "FINGERTIPS": "FINGERTIP, the end of the finger [n]\n",
  "FINI": "(French) finished; ruined [adj]\n",
  "FINIAL": "a decorating on the top of a gable [n -S]\n",
  "FINIALED": "having a finial [adj]\n",
  "FINIALS": "FINIAL, a decorating on the top of a gable [n]\n",
  "FINICAL": "particular about unimportant matters, also FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING, FINNICKY [adj FINICALLY]\n",
  "FINICALITIES": "FINICALITY, the quality of being finical [n]\n",
  "FINICALITY": "the quality of being finical [n FINICALITIES]\n",
  "FINICALLY": "FINICAL, particular about unimportant matters, also FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING, FINNICKY [adv]\n",
  "FINICALNESS": "the state of being finical [n -ES]\n",
  "FINICALNESSES": "FINICALNESS, the state of being finical [n]\n",
  "FINICKETIER": "FINICKETY, particular about unimportant matters, also FINICAL, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING, FINNICKY [adj]\n",
  "FINICKETIEST": "FINICKETY, particular about unimportant matters, also FINICAL, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING, FINNICKY [adj]\n",
  "FINICKETY": "particular about unimportant matters, also FINICAL, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING, FINNICKY [adj FINICKETIER, FINICKETIEST]\n",
  "FINICKIER": "FINICKY, difficult to please, also FINNICKY [adj]\n",
  "FINICKIEST": "FINICKY, difficult to please, also FINNICKY [adj]\n",
  "FINICKIN": "particular about unimportant matters, also FINICAL, FINICKETY, FINICKING, FINICKY, FINIKIN, FINIKING, FINNICKY [adj]\n",
  "FINICKINESS": "the state of being finicky [n -ES]\n",
  "FINICKINESSES": "FINICKINESS, the state of being finicky [n]\n",
  "FINICKING": "particular about unimportant matters, also FINICAL, FINICKETY, FINICKIN, FINICKY, FINIKIN, FINIKING, FINNICKY [adj] / fussiness [n -S]\n",
  "FINICKINGS": "FINICKING, fussiness [n]\n",
  "FINICKY": "difficult to please, also FINNICKY [adj FINICKIER, FINICKIEST]\n",
  "FINIKIN": "particular about unimportant matters, also FINICAL, FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKING, FINNICKY [adj]\n",
  "FINIKING": "particular about unimportant matters, also FINICAL, FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKIN, FINNICKY [adj]\n",
  "FINING": "the process of refining of wines [n -S]\n",
  "FININGS": "FINING, the process of refining of wines [n]\n",
  "FINIS": "(Latin) the end, the conclusion [n -ES]\n",
  "FINISES": "FINIS, (Latin) the end, the conclusion [n]\n",
  "FINISH": "to bring to an end [v -ED, -ING, -ES]\n",
  "FINISHED": "FINISH, to bring to an end [v]\n",
  "FINISHER": "one that finishes [n -S]\n",
  "FINISHERS": "FINISHER, one that finishes [n]\n",
  "FINISHES": "FINISH, to bring to an end [v]\n",
  "FINISHING": "the act of making an end [n -S]\n",
  "FINISHINGS": "FINISHING, the act of making an end [n]\n",
  "FINITE": "limited [adj FINITELY] / a verb limited by person, number, tense or mood [n -S]\n",
  "FINITELY": "to a finite extent [adv]\n",
  "FINITENESS": "the state of being finite [n -ES]\n",
  "FINITENESSES": "FINITENESS, the state of being finite [n]\n",
  "FINITES": "FINITE, a verb limited by person, number, tense or mood [n]\n",
  "FINITISM": "a philosophical principle that limits mathematical entities to those constructible in a finite number of steps [n -S]\n",
  "FINITISMS": "FINITISM, a philosophical principle that limits mathematical entities to those constructible in a finite number of steps [n]\n",
  "FINITIST": "an advocate of finitism [n -S]\n",
  "FINITISTS": "FINITIST, an advocate of finitism [n]\n",
  "FINITO": "(Italian) finished [adj]\n",
  "FINITUDE": "the state of being finite [n -S]\n",
  "FINITUDES": "FINITUDE, the state of being finite [n]\n",
  "FINJAN": "(Arabic) the handleless coffee cup which fits within a zarf, also FINGAN [n -S]\n",
  "FINJANS": "FINJAN, (Arabic) the handleless coffee cup which fits within a zarf, also FINGAN [n]\n",
  "FINK": "to inform to the police [v -ED, -ING, -S]\n",
  "FINKED": "FINK, to inform to the police [v]\n",
  "FINKING": "FINK, to inform to the police [v]\n",
  "FINKS": "FINK, to inform to the police [v]\n",
  "FINLESS": "without fins [adj]\n",
  "FINLIKE": "like a fin [adj]\n",
  "FINLIT": "(colloquial) financial literacy [n -S]\n",
  "FINLITS": "FINLIT, (colloquial) financial literacy [n]\n",
  "FINMARK": "the monetary unit of Finland, also FINNMARK [n -S]\n",
  "FINMARKS": "FINMARK, the monetary unit of Finland, also FINNMARK [n]\n",
  "FINNAC": "(Gaelic) a young seatrout, also FINNACK, FINNOCK, PHINNOCK [n -S]\n",
  "FINNACK": "(Gaelic) a young seatrout, also FINNAC, FINNOCK, PHINNOCK [n -S]\n",
  "FINNACKS": "FINNACK, (Gaelic) a young seatrout, also FINNAC, FINNOCK, PHINNOCK [n]\n",
  "FINNACS": "FINNAC, (Gaelic) a young seatrout, also FINNACK, FINNOCK, PHINNOCK [n]\n",
  "FINNAN": "(Scots) haddock cured in peat smoke, also FINDRAM [n -S]\n",
  "FINNANS": "FINNAN, (Scots) haddock cured in peat smoke, also FINDRAM [n]\n",
  "FINNED": "FIN, to equip with paddle-like structures [v]\n",
  "FINNER": "a finback whale, also FINBACK, FINFISH [n -S]\n",
  "FINNERS": "FINNER, a finback whale, also FINBACK, FINFISH [n]\n",
  "FINNESKO": "(Norwegian) a reindeer-skin boot, also FINNSKO, FINSKO [n FINNESKO]\n",
  "FINNICKIER": "FINNICKY, particular about unimportant matters, also FINICAL, FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING [adj]\n",
  "FINNICKIEST": "FINNICKY, particular about unimportant matters, also FINICAL, FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING [adj]\n",
  "FINNICKY": "particular about unimportant matters, also FINICAL, FINICKETY, FINICKIN, FINICKING, FINICKY, FINIKIN, FINIKING [adj FINNICKIER, FINNICKIEST]\n",
  "FINNIER": "FINNY, having fins [adj]\n",
  "FINNIEST": "FINNY, having fins [adj]\n",
  "FINNING": "FIN, to equip with paddle-like structures [v]\n",
  "FINNMARK": "the monetary unit of Finland, also FINMARK [n -S]\n",
  "FINNMARKS": "FINNMARK, the monetary unit of Finland, also FINMARK [n]\n",
  "FINNOCHIO": "(Italian) a dwarf variety of fennel, also FINOCCHIO, FINOCHIO [n -S]\n",
  "FINNOCHIOS": "FINNOCHIO, (Italian) a dwarf variety of fennel, also FINOCCHIO, FINOCHIO [n]\n",
  "FINNOCK": "(Gaelic) a young seatrout, also FINNAC, FINNACK, PHINNOCK [n -S]\n",
  "FINNOCKS": "FINNOCK, (Gaelic) a young seatrout, also FINNAC, FINNACK, PHINNOCK [n]\n",
  "FINNSKO": "(Norwegian) a reindeer-skin boot, also FINNESKO, FINSKO [n FINNSKO]\n",
  "FINNY": "having fins [adj FINNIER, FINNIEST]\n",
  "FINO": "(Spanish) a type of light-coloured dry sherry [n -S]\n",
  "FINOCCHIO": "(Italian) a dwarf variety of fennel, also FINNOCHIO, FINOCHIO [n -S]\n",
  "FINOCCHIOS": "FINOCCHIO, (Italian) a dwarf variety of fennel, also FINNOCHIO, FINOCHIO [n]\n",
  "FINOCHIO": "(Italian) a dwarf variety of fennel, also FINNOCHIO, FINOCCHIO [n -S]\n",
  "FINOCHIOS": "FINOCHIO, (Italian) a dwarf variety of fennel, also FINNOCHIO, FINOCCHIO [n]\n",
  "FINOS": "FINO, (Spanish) a type of light-coloured dry sherry [n]\n",
  "FINS": "FIN, to equip with paddle-like structures [v]\n",
  "FINSKO": "(Norwegian) a reindeer-skin boot, also FINNESKO, FINNSKO [n FINSKO]\n",
  "FINTECH": "digital technology used to support banking and financial services [n -S]\n",
  "FINTECHS": "FINTECH, digital technology used to support banking and financial services [n]\n",
  "FIORATURA": "(Italian) a florid embellishment introduced into a melody by a singer or player, also FIORITURA [n FIORATURAE]\n",
  "FIORATURAE": "FIORATURA, (Italian) a florid embellishment introduced into a melody by a singer or player, also FIORITURA [n]\n",
  "FIORD": "(Norwegian) a narrow inlet of the sea between steep cliffs, also FJORD [n -S]\n",
  "FIORDS": "FIORD, (Norwegian) a narrow inlet of the sea between steep cliffs, also FJORD [n]\n",
  "FIORIN": "(Irish) a species of creeping bent grass [n -S]\n",
  "FIORINS": "FIORIN, (Irish) a species of creeping bent grass [n]\n",
  "FIORITURA": "(Italian) a florid embellishment introduced into a melody by a singer or player, also FIORATURA [n FIORITURE]\n",
  "FIORITURE": "FIORITURA, (Italian) a florid embellishment introduced into a melody by a singer or player, also FIORATURA [n]\n",
  "FIPPENCE": "(colloquial) fivepence, a coin worth five pence [n -S]\n",
  "FIPPENCES": "FIPPENCE, (colloquial) fivepence, a coin worth five pence [n]\n",
  "FIPPLE": "a plug at the end of a whistle, flute etc. [n -S]\n",
  "FIPPLES": "FIPPLE, a plug at the end of a whistle, flute etc. [n]\n",
  "FIQH": "Islamic jurisprudence, an expansion of the Sharia Islamic law [n -S]\n",
  "FIQHS": "FIQH, Islamic jurisprudence, an expansion of the Sharia Islamic law [n]\n",
  "FIQUE": "a tough natural fibre similar to hemp [n -S]\n",
  "FIQUES": "FIQUE, a tough natural fibre similar to hemp [n]\n",
  "FIR": "an evergreen tree [n -S]\n",
  "FIRE": "to project by discharging from a gun [v FIRED, FIRING, FIRES]\n",
  "FIREABLE": "able to be fired [adj]\n",
  "FIREARM": "a weapon e.g. a gun [n -S]\n",
  "FIREARMED": "carrying a firearm [adj]\n",
  "FIREARMS": "FIREARM, a weapon e.g. a gun [n]\n",
  "FIREBACK": "a cast-iron plate at the back of a fireplace [n -S]\n",
  "FIREBACKS": "FIREBACK, a cast-iron plate at the back of a fireplace [n]\n",
  "FIREBALL": "a luminous meteor [n -S]\n",
  "FIREBALLER": "a baseball pitcher known for throwing fastballs [n -S]\n",
  "FIREBALLERS": "FIREBALLER, a baseball pitcher known for throwing fastballs [n]\n",
  "FIREBALLING": "relating to the delivery of fireballs, fast balls in baseball [adj]\n",
  "FIREBALLS": "FIREBALL, a luminous meteor [n]\n",
  "FIREBASE": "a military base from which guns are fired [n -S]\n",
  "FIREBASES": "FIREBASE, a military base from which guns are fired [n]\n",
  "FIREBIRD": "a bird with bright plumage, aka Baltimore oriole [n -S]\n",
  "FIREBIRDS": "FIREBIRD, a bird with bright plumage, aka Baltimore oriole [n]\n",
  "FIREBOARD": "a mantelpiece [n -S]\n",
  "FIREBOARDS": "FIREBOARD, a mantelpiece [n]\n",
  "FIREBOAT": "a boat equipped with firefighting apparatus [n -S]\n",
  "FIREBOATS": "FIREBOAT, a boat equipped with firefighting apparatus [n]\n",
  "FIREBOMB": "to attack with incendiary bombs [v -ED, -ING, -S]\n",
  "FIREBOMBED": "FIREBOMB, to attack with incendiary bombs [v]\n",
  "FIREBOMBER": "one who uses FIREBOMBS [n -S]\n",
  "FIREBOMBERS": "FIREBOMBER, one who uses FIREBOMBS [n]\n",
  "FIREBOMBING": "the act of attacking with incendiary bombs [n -S]\n",
  "FIREBOMBINGS": "FIREBOMBING, the act of attacking with incendiary bombs [n]\n",
  "FIREBOMBS": "FIREBOMB, to attack with incendiary bombs [v]\n",
  "FIREBOX": "a chamber in which fuel is burned [n -ES]\n",
  "FIREBOXES": "FIREBOX, a chamber in which fuel is burned [n]\n",
  "FIREBRAND": "a flaming stick; a hot-tempered person [n -S]\n",
  "FIREBRANDS": "FIREBRAND, a flaming stick; a hot-tempered person [n]\n",
  "FIREBRAT": "a small insect found in bakehouses [n -S]\n",
  "FIREBRATS": "FIREBRAT, a small insect found in bakehouses [n]\n",
  "FIREBREAK": "a strip of land kept clear to stop the spread of a fire [n -S]\n",
  "FIREBREAKS": "FIREBREAK, a strip of land kept clear to stop the spread of a fire [n]\n",
  "FIREBRICK": "a brick resistant to fire, used for furnace linings, grates, etc. [n -S]\n",
  "FIREBRICKS": "FIREBRICK, a brick resistant to fire, used for furnace linings, grates, etc. [n]\n",
  "FIREBUG": "an arsonist [n -S]\n",
  "FIREBUGS": "FIREBUG, an arsonist [n]\n",
  "FIREBUSH": "as in Chilean firebush, a South American shrub with scarlet flowers [n -ES]\n",
  "FIREBUSHES": "FIREBUSH, as in Chilean firebush, a South American shrub with scarlet flowers [n]\n",
  "FIRECLAY": "a clay poor in lime and iron, suitable for making fire-resistant pottery [n -S]\n",
  "FIRECLAYS": "FIRECLAY, a clay poor in lime and iron, suitable for making fire-resistant pottery [n]\n",
  "FIRECRACKER": "a usually paper cylinder containing an explosive and a fuse and set off to make a noise [n -S]\n",
  "FIRECRACKERS": "FIRECRACKER, a usually paper cylinder containing an explosive and a fuse and set off to make a noise [n]\n",
  "FIRECREST": "a bird closely related to the goldcrest [n -S]\n",
  "FIRECRESTS": "FIRECREST, a bird closely related to the goldcrest [n]\n",
  "FIRED": "FIRE, to project by discharging from a gun [v]\n",
  "FIREDAMP": "a combustible mine gas, mainly methane, that can explode upon contact with a supply of oxygen [n -S]\n",
  "FIREDAMPS": "FIREDAMP, a combustible mine gas, mainly methane, that can explode upon contact with a supply of oxygen [n]\n",
  "FIREDOG": "a metal support for logs in a fireplace, also ANDIRON, ENDIRON [n -S]\n",
  "FIREDOGS": "FIREDOG, a metal support for logs in a fireplace, also ANDIRON, ENDIRON [n]\n",
  "FIREDRAGON": "a fire-breathing dragon, also FIREDRAKE [n -S]\n",
  "FIREDRAGONS": "FIREDRAGON, a fire-breathing dragon, also FIREDRAKE [n]\n",
  "FIREDRAKE": "(archaic) a fire-breathing dragon, also FIREDRAGON [n -S]\n",
  "FIREDRAKES": "FIREDRAKE, (archaic) a fire-breathing dragon, also FIREDRAGON [n]\n",
  "FIREFANG": "to scorch; to damage (esp. barley, oats) by overheating [v -ED, -ING, -S]\n",
  "FIREFANGED": "FIREFANG, to scorch; to damage (esp. barley, oats) by overheating [v]\n",
  "FIREFANGING": "FIREFANG, to scorch; to damage (esp. barley, oats) by overheating [v]\n",
  "FIREFANGS": "FIREFANG, to scorch; to damage (esp. barley, oats) by overheating [v]\n",
  "FIREFIGHT": "an intense exchange of gunfire [n -S]\n",
  "FIREFIGHTER": "a person who fights fires [n -S]\n",
  "FIREFIGHTERS": "FIREFIGHTER, a person who fights fires [n]\n",
  "FIREFIGHTING": "the business of putting out fires [n -S]\n",
  "FIREFIGHTINGS": "FIREFIGHTING, the business of putting out fires [n]\n",
  "FIREFIGHTS": "FIREFIGHT, an intense exchange of gunfire [n]\n",
  "FIREFLIES": "FIREFLY, any of various nocturnal insects which emit phosphorescent light [n]\n",
  "FIREFLOAT": "a boat or raft used in harbours for extinguishing fires [n -S]\n",
  "FIREFLOATS": "FIREFLOAT, a boat or raft used in harbours for extinguishing fires [n]\n",
  "FIREFLOOD": "a method of extracting oil from a well by burning some of the oil to increase the flow [n -S]\n",
  "FIREFLOODS": "FIREFLOOD, a method of extracting oil from a well by burning some of the oil to increase the flow [n]\n",
  "FIREFLY": "any of various nocturnal insects which emit phosphorescent light [n FIREFLIES]\n",
  "FIREGUARD": "a protective wire frame or railing in front of a fire [n -S]\n",
  "FIREGUARDS": "FIREGUARD, a protective wire frame or railing in front of a fire [n]\n",
  "FIREHALL": "a fire station [n -S]\n",
  "FIREHALLS": "FIREHALL, a fire station [n]\n",
  "FIREHOSE": "a hose used by firefighters [n -S]\n",
  "FIREHOSES": "FIREHOSE, a hose used by firefighters [n]\n",
  "FIREHOUSE": "(obsolete) a fire station; a house with a fireplace [n -S]\n",
  "FIREHOUSES": "FIREHOUSE, (obsolete) a fire station; a house with a fireplace [n]\n",
  "FIRELESS": "without a fire [adj]\n",
  "FIRELIGHT": "the light of a (usually domestic) fire [n -S]\n",
  "FIRELIGHTER": "a piece of readily flammable material or other means of lighting a fire [n -S]\n",
  "FIRELIGHTERS": "FIRELIGHTER, a piece of readily flammable material or other means of lighting a fire [n]\n",
  "FIRELIGHTS": "FIRELIGHT, the light of a (usually domestic) fire [n]\n",
  "FIRELIT": "lit by firelight [adj]\n",
  "FIRELOCK": "an old form of gunlock, as the flintlock, which ignites the priming by a spark [n -S]\n",
  "FIRELOCKS": "FIRELOCK, an old form of gunlock, as the flintlock, which ignites the priming by a spark [n]\n",
  "FIREMAN": "a man employed to extinguish fires [n FIREMEN]\n",
  "FIREMANIC": "of or relating to firemen or firefighting [adj]\n",
  "FIREMARK": "a metal plate formerly placed by insurance companies to mark an insured building [n -S]\n",
  "FIREMARKS": "FIREMARK, a metal plate formerly placed by insurance companies to mark an insured building [n]\n",
  "FIREMEN": "FIREMAN, a man employed to extinguish fires [n]\n",
  "FIREPAN": "a metal vessel for holding a fire [n -S]\n",
  "FIREPANS": "FIREPAN, a metal vessel for holding a fire [n]\n",
  "FIREPINK": "a flowering plant of the US [n -S]\n",
  "FIREPINKS": "FIREPINK, a flowering plant of the US [n]\n",
  "FIREPIT": "a depression dug in the ground in which a fire is made [n -S]\n",
  "FIREPITS": "FIREPIT, a depression dug in the ground in which a fire is made [n]\n",
  "FIREPLACE": "an open recess in a wall of a room, at the base of a chimney, etc., for a fire [n -S]\n",
  "FIREPLACED": "having a fireplace [adj]\n",
  "FIREPLACES": "FIREPLACE, an open recess in a wall of a room, at the base of a chimney, etc., for a fire [n]\n",
  "FIREPLUG": "a fire-hydrant [n -S]\n",
  "FIREPLUGS": "FIREPLUG, a fire-hydrant [n]\n",
  "FIREPOT": "a pot with burning contents used as a missile [n -S]\n",
  "FIREPOTS": "FIREPOT, a pot with burning contents used as a missile [n]\n",
  "FIREPOWER": "the amount of ammunition that can be fired with effect in a given time [n -S]\n",
  "FIREPOWERS": "FIREPOWER, the amount of ammunition that can be fired with effect in a given time [n]\n",
  "FIREPROOF": "resistant to fire [adj] / to make proof against fire [v -ED, -ING, -S]\n",
  "FIREPROOFED": "FIREPROOF, to make proof against fire [v]\n",
  "FIREPROOFING": "the act of making fireproof [n -S]\n",
  "FIREPROOFINGS": "FIREPROOFING, the act of making fireproof [n]\n",
  "FIREPROOFS": "FIREPROOF, to make proof against fire [v]\n",
  "FIRER": "a person who fires [n -S]\n",
  "FIREREEL": "a fire engine [n -S]\n",
  "FIREREELS": "FIREREEL, a fire engine [n]\n",
  "FIREROOM": "a room containing a ship's boilers [n -S]\n",
  "FIREROOMS": "FIREROOM, a room containing a ship's boilers [n]\n",
  "FIRERS": "FIRER, a person who fires [n]\n",
  "FIRES": "FIRE, to project by discharging from a gun [v]\n",
  "FIRESCAPE": "to arrange the features of (a garden or other area of land) in a way that inhibits the spread of fire [v FIRESCAPED, FIRESCAPING, FIRESCAPES]\n",
  "FIRESCAPED": "FIRESCAPE, to arrange the features of (a garden or other area of land) in a way that inhibits the spread of fire [v]\n",
  "FIRESCAPES": "FIRESCAPE, to arrange the features of (a garden or other area of land) in a way that inhibits the spread of fire [v]\n",
  "FIRESCAPING": "the act of arranging the features of (a garden or other area of land) in a way that inhibits the spread of fire [n -S]\n",
  "FIRESCAPINGS": "FIRESCAPING, the act of arranging the features of (a garden or other area of land) in a way that inhibits the spread of fire [n]\n",
  "FIRESCREEN": "a screen placed in front of a fire [n -S]\n",
  "FIRESCREENS": "FIRESCREEN, a screen placed in front of a fire [n]\n",
  "FIRESHIP": "a ship on fire set amongst enemy's ships [n -S]\n",
  "FIRESHIPS": "FIRESHIP, a ship on fire set amongst enemy's ships [n]\n",
  "FIRESIDE": "the area immediately surrounding a fireplace [n -S]\n",
  "FIRESIDES": "FIRESIDE, the area immediately surrounding a fireplace [n]\n",
  "FIRESTONE": "a rock, esp. sandstone, that can withstand great heat [n -S]\n",
  "FIRESTONES": "FIRESTONE, a rock, esp. sandstone, that can withstand great heat [n]\n",
  "FIRESTORM": "a huge blaze (especially a result of heavy bombing) which fans its own flames by creating its own draught [n -S]\n",
  "FIRESTORMS": "FIRESTORM, a huge blaze (especially a result of heavy bombing) which fans its own flames by creating its own draught [n]\n",
  "FIRETHORN": "a flowering shrub, aka pyracantha [n -S]\n",
  "FIRETHORNS": "FIRETHORN, a flowering shrub, aka pyracantha [n]\n",
  "FIRETRAP": "a building likely to catch fire [n -S]\n",
  "FIRETRAPS": "FIRETRAP, a building likely to catch fire [n]\n",
  "FIRETRUCK": "a fire engine [n -S]\n",
  "FIRETRUCKS": "FIRETRUCK, a fire engine [n]\n",
  "FIREWALL": "to install software that protects a network against unauthorized users [v -ED, -ING, -S]\n",
  "FIREWALLED": "FIREWALL, to install software that protects a network against unauthorized users [v]\n",
  "FIREWALLING": "FIREWALL, to install software that protects a network against unauthorized users [v]\n",
  "FIREWALLS": "FIREWALL, to install software that protects a network against unauthorized users [v]\n",
  "FIREWARDEN": "an officer responsible for fire prevention and control in an area, esp. in a forest [n -S]\n",
  "FIREWARDENS": "FIREWARDEN, an officer responsible for fire prevention and control in an area, esp. in a forest [n]\n",
  "FIREWATER": "strong alcoholic spirits [n -S]\n",
  "FIREWATERS": "FIREWATER, strong alcoholic spirits [n]\n",
  "FIREWEED": "a perennial herb [n -S]\n",
  "FIREWEEDS": "FIREWEED, a perennial herb [n]\n",
  "FIREWOMAN": "a female firefighter [n FIREWOMEN]\n",
  "FIREWOMEN": "FIREWOMAN, a female firefighter [n]\n",
  "FIREWOOD": "wood used as fuel [n -S]\n",
  "FIREWOODS": "FIREWOOD, wood used as fuel [n]\n",
  "FIREWORK": "a device which explodes with loud noise and colour [n -S]\n",
  "FIREWORKS": "FIREWORK, a device which explodes with loud noise and colour [n]\n",
  "FIREWORM": "a glowworm; a firefly [n -S]\n",
  "FIREWORMS": "FIREWORM, a glowworm; a firefly [n]\n",
  "FIRIE": "(Australian slang) a firefighter [n -S]\n",
  "FIRIES": "FIRIE, (Australian slang) a firefighter [n]\n",
  "FIRING": "the process of maturing ceramic products [n -S]\n",
  "FIRINGS": "FIRING, the process of maturing ceramic products [n]\n",
  "FIRK": "(Shakespeare) to drive or rouse; to speed along [v -ED, -ING, -S]\n",
  "FIRKED": "FIRK, (Shakespeare) to drive or rouse; to speed along [v]\n",
  "FIRKIN": "a small cask for liquids, butter or fish [n -S]\n",
  "FIRKING": "FIRK, (Shakespeare) to drive or rouse; to speed along [v]\n",
  "FIRKINS": "FIRKIN, a small cask for liquids, butter or fish [n]\n",
  "FIRKS": "FIRK, (Shakespeare) to drive or rouse; to speed along [v]\n",
  "FIRLOT": "(Scots) an old measure of grain etc. [n -S]\n",
  "FIRLOTS": "FIRLOT, (Scots) an old measure of grain etc. [n]\n",
  "FIRM": "unyielding to pressure [adj FIRMER, FIRMEST, FIRMLY] / to make firm [v -ED, -ING, -S]\n",
  "FIRMAMENT": "the sky [n -S]\n",
  "FIRMAMENTAL": "relating to the firmament [adj]\n",
  "FIRMAMENTS": "FIRMAMENT, the sky [n]\n",
  "FIRMAN": "(Persian) an Oriental sovereign's edict [n -S]\n",
  "FIRMANS": "FIRMAN, (Persian) an Oriental sovereign's edict [n]\n",
  "FIRMED": "FIRM, to make firm [v]\n",
  "FIRMER": "a carpenter's or woodworker's woodcutting chisel [n -S]\n",
  "FIRMERS": "FIRMER, a carpenter's or woodworker's woodcutting chisel [n]\n",
  "FIRMEST": "FIRM, unyielding to pressure [adj]\n",
  "FIRMING": "FIRM, to make firm [v]\n",
  "FIRMLESS": "(obsolete) wavering [adj]\n",
  "FIRMLY": "FIRM, unyielding to pressure [adv]\n",
  "FIRMNESS": "the state of being firm [n -ES]\n",
  "FIRMNESSES": "FIRMNESS, the state of being firm [n]\n",
  "FIRMS": "FIRM, to make firm [v]\n",
  "FIRMWARE": "computer programs permanently stored on a microchip [n -S]\n",
  "FIRMWARES": "FIRMWARE, computer programs permanently stored on a microchip [n]\n",
  "FIRN": "(German) granular ice formed by the recrystallization of snow, aka neve [n -S]\n",
  "FIRNS": "FIRN, (German) granular ice formed by the recrystallization of snow, aka neve [n]\n",
  "FIRRIER": "FIRRY, abounding in firs [adj]\n",
  "FIRRIEST": "FIRRY, abounding in firs [adj]\n",
  "FIRRING": "wooden strips attached to joists, also FURRING [n -S]\n",
  "FIRRINGS": "FIRRING, wooden strips attached to joists, also FURRING [n]\n",
  "FIRRY": "abounding in firs [adj FIRRIER, FIRRIEST]\n",
  "FIRS": "FIR, an evergreen tree [n]\n",
  "FIRST": "preceding all others [adj FIRSTLY] / something that precedes all others [n -S]\n",
  "FIRSTBORN": "the first in order of birth, the eldest child [n -S]\n",
  "FIRSTBORNS": "FIRSTBORN, the first in order of birth, the eldest child [n]\n",
  "FIRSTFRUITS": "the fruits first gathered in a season [n]\n",
  "FIRSTHAND": "obtained directly [adj]\n",
  "FIRSTLING": "the first produce or offspring, esp. of animals [n -S]\n",
  "FIRSTLINGS": "FIRSTLING, the first produce or offspring, esp. of animals [n]\n",
  "FIRSTLY": "FIRST, preceding all others [adv]\n",
  "FIRSTNESS": "the state of being first [n -ES]\n",
  "FIRSTNESSES": "FIRSTNESS, the state of being first [n]\n",
  "FIRSTS": "FIRST, something that precedes all others [n]\n",
  "FIRTH": "an inlet of the sea [n -S]\n",
  "FIRTHS": "FIRTH, an inlet of the sea [n]\n",
  "FIRWOOD": "the wood of the fir tree [n -S]\n",
  "FIRWOODS": "FIRWOOD, the wood of the fir tree [n]\n",
  "FISC": "(obsolete) the state treasury; the public revenue, also FISK [n -S]\n",
  "FISCAL": "relating to the public treasury or revenue [adj FISCALLY] / a treasurer; a public prosecutor [n -S]\n",
  "FISCALIST": "a public prosecutor [n -S]\n",
  "FISCALISTS": "FISCALIST, a public prosecutor [n]\n",
  "FISCALLY": "FISCAL, relating to the public treasury or revenue [adv]\n",
  "FISCALS": "FISCAL, a treasurer; a public prosecutor [n]\n",
  "FISCS": "FISC, (obsolete) the state treasury; the public revenue, also FISK [n]\n",
  "FISGIG": "a giddy girl, a firework of damp powder, also FISHGIG, FIZGIG, FIZZGIG [n -S]\n",
  "FISGIGS": "FISGIG, a giddy girl, a firework of damp powder, also FISHGIG, FIZGIG, FIZZGIG [n]\n",
  "FISH": "to try to catch cold-blooded aquatic vertebrates [v -ED, -ING, -ES]\n",
  "FISHABILITIES": "FISHABILITY, the state of being fishable [n]\n",
  "FISHABILITY": "the state of being fishable [n FISHABILITIES]\n",
  "FISHABLE": "suitable for fishing [adj]\n",
  "FISHBALL": "a fish cake [n -S]\n",
  "FISHBALLS": "FISHBALL, a fish cake [n]\n",
  "FISHBOAT": "a watercraft used for fishing [n -S]\n",
  "FISHBOATS": "FISHBOAT, a watercraft used for fishing [n]\n",
  "FISHBOLT": "a type of bolt [n -S]\n",
  "FISHBOLTS": "FISHBOLT, a type of bolt [n]\n",
  "FISHBONE": "a bone of a fish [n -S]\n",
  "FISHBONES": "FISHBONE, a bone of a fish [n]\n",
  "FISHBOWL": "a bowl in which live fish are kept [n -S]\n",
  "FISHBOWLS": "FISHBOWL, a bowl in which live fish are kept [n]\n",
  "FISHBURGER": "a hamburger made with fish [n -S]\n",
  "FISHBURGERS": "FISHBURGER, a hamburger made with fish [n]\n",
  "FISHCAKE": "a cake made of fish and potato [n -S]\n",
  "FISHCAKES": "FISHCAKE, a cake made of fish and potato [n]\n",
  "FISHED": "FISH, to try to catch cold-blooded aquatic vertebrates [v]\n",
  "FISHER": "one who catches fish [n -S]\n",
  "FISHERFOLK": "people who fish esp. for a living [n]\n",
  "FISHERIES": "FISHERY, a place for catching fish [n]\n",
  "FISHERMAN": "one who catches fish [n FISHERMEN]\n",
  "FISHERMEN": "FISHERMAN, one who catches fish [n]\n",
  "FISHERS": "FISHER, one who catches fish [n]\n",
  "FISHERWOMAN": "a woman who fishes as an occupation or for pleasure [n FISHERWOMEN]\n",
  "FISHERWOMEN": "FISHERWOMAN, a woman who fishes as an occupation or for pleasure [n]\n",
  "FISHERY": "a place for catching fish [n FISHERIES]\n",
  "FISHES": "FISH, to try to catch cold-blooded aquatic vertebrates [v]\n",
  "FISHEYE": "a suspicious stare [n -S]\n",
  "FISHEYES": "FISHEYE, a suspicious stare [n]\n",
  "FISHFINGER": "an oblong piece of filleted or minced fish coated in breadcrumbs [n -S]\n",
  "FISHFINGERS": "FISHFINGER, an oblong piece of filleted or minced fish coated in breadcrumbs [n]\n",
  "FISHFUL": "containing many fish [adj]\n",
  "FISHGIG": "a kind of harpoon, also FISGIG, FIZGIG, FIZZGIG [n -S]\n",
  "FISHGIGS": "FISHGIG, a kind of harpoon, also FISGIG, FIZGIG, FIZZGIG [n]\n",
  "FISHHOOK": "a barbed hook for catching fish [n -S]\n",
  "FISHHOOKS": "FISHHOOK, a barbed hook for catching fish [n]\n",
  "FISHIER": "FISHY, consisting of fish [adj]\n",
  "FISHIEST": "FISHY, consisting of fish [adj]\n",
  "FISHIFIED": "FISHIFY, (Shakespeare) to turn into fish [v]\n",
  "FISHIFIES": "FISHIFY, (Shakespeare) to turn into fish [v]\n",
  "FISHIFY": "(Shakespeare) to turn into fish [v FISHIFIED, FISHIFYING, FISHIFIES]\n",
  "FISHIFYING": "FISHIFY, (Shakespeare) to turn into fish [v]\n",
  "FISHILY": "FISHY, consisting of fish [adv]\n",
  "FISHINESS": "the state of being fishy [n -ES]\n",
  "FISHINESSES": "FISHINESS, the state of being fishy [n]\n",
  "FISHING": "the sport of catching fish [n -S]\n",
  "FISHINGS": "FISHING, the sport of catching fish [n]\n",
  "FISHKILL": "the sudden destruction of large numbers of fish [n -S]\n",
  "FISHKILLS": "FISHKILL, the sudden destruction of large numbers of fish [n]\n",
  "FISHLESS": "having no fish [adj]\n",
  "FISHLIKE": "like a fish [adj]\n",
  "FISHLINE": "a line used in fishing [n -S]\n",
  "FISHLINES": "FISHLINE, a line used in fishing [n]\n",
  "FISHMEAL": "ground dried fish [n -S]\n",
  "FISHMEALS": "FISHMEAL, ground dried fish [n]\n",
  "FISHMONGER": "a dealer in fish [n -S]\n",
  "FISHMONGERS": "FISHMONGER, a dealer in fish [n]\n",
  "FISHNET": "a net for catching fish [n -S]\n",
  "FISHNETS": "FISHNET, a net for catching fish [n]\n",
  "FISHPLATE": "an iron plate used to join railway lines [n -S]\n",
  "FISHPLATES": "FISHPLATE, an iron plate used to join railway lines [n]\n",
  "FISHPOLE": "a fishing rod [n -S]\n",
  "FISHPOLES": "FISHPOLE, a fishing rod [n]\n",
  "FISHPOND": "a pond for keeping fish [n -S]\n",
  "FISHPONDS": "FISHPOND, a pond for keeping fish [n]\n",
  "FISHSKIN": "the skin of a fish [n -S]\n",
  "FISHSKINS": "FISHSKIN, the skin of a fish [n]\n",
  "FISHTAIL": "to swing the tail of a moving vehicle from side to side [v -ED, -ING, -S]\n",
  "FISHTAILED": "FISHTAIL, to swing the tail of a moving vehicle from side to side [v]\n",
  "FISHTAILING": "FISHTAIL, to swing the tail of a moving vehicle from side to side [v]\n",
  "FISHTAILS": "FISHTAIL, to swing the tail of a moving vehicle from side to side [v]\n",
  "FISHWAY": "a device for enabling fish to pass around a dam [n -S]\n",
  "FISHWAYS": "FISHWAY, a device for enabling fish to pass around a dam [n]\n",
  "FISHWIFE": "a woman who sells fish [n FISHWIVES]\n",
  "FISHWIFELIER": "FISHWIFELY, like a fishwife, vituperative [adj]\n",
  "FISHWIFELIEST": "FISHWIFELY, like a fishwife, vituperative [adj]\n",
  "FISHWIFELY": "like a fishwife, vituperative [adj FISHWIFELIER, FISHWIFELIEST]\n",
  "FISHWIVES": "FISHWIFE, a woman who sells fish [n]\n",
  "FISHWORM": "a worm used as bait [n -S]\n",
  "FISHWORMS": "FISHWORM, a worm used as bait [n]\n",
  "FISHY": "consisting of fish [adj FISHIER, FISHIEST, FISHILY]\n",
  "FISHYBACK": "(US) transportation of freight containers and trailers by ship or barge [n -S]\n",
  "FISHYBACKS": "FISHYBACK, (US) transportation of freight containers and trailers by ship or barge [n]\n",
  "FISK": "to frisk, gad about [v -ED, -ING, -S]\n",
  "FISKED": "FISK, to frisk, gad about [v]\n",
  "FISKING": "FISK, to frisk, gad about [v]\n",
  "FISKS": "FISK, to frisk, gad about [v]\n",
  "FISNOMIE": "(Shakespeare) physiognomy, also PHISNOMY, PHYSIOGNOMY, VISNOMIE, VISNOMY [n -S]\n",
  "FISNOMIES": "FISNOMIE, (Shakespeare) physiognomy, also PHISNOMY, PHYSIOGNOMY, VISNOMIE, VISNOMY [n]\n",
  "FISSATE": "deeply split [adj]\n",
  "FISSICOSTATE": "having divided ribs [adj]\n",
  "FISSILE": "capable of being split [adj]\n",
  "FISSILINGUAL": "having a forked or cleft tongue [adj]\n",
  "FISSILITIES": "FISSILITY, the ability to be split [n]\n",
  "FISSILITY": "the ability to be split [n FISSILITIES]\n",
  "FISSION": "to split into parts [v -ED, -ING, -S]\n",
  "FISSIONABILITY": "the state of being fissionable [n]\n",
  "FISSIONABLE": "that can undergo fission [adj] / a fissionable material [n -S]\n",
  "FISSIONABLES": "FISSIONABLE, a fissionable material [n]\n",
  "FISSIONAL": "relating to fission [adj]\n",
  "FISSIONED": "FISSION, to split into parts [v]\n",
  "FISSIONING": "FISSION, to split into parts [v]\n",
  "FISSIONS": "FISSION, to split into parts [v]\n",
  "FISSIPALMATE": "of some birds' feet, partially webbed, having lobes and fringes on separate toes [adj]\n",
  "FISSIPARISM": "the state of being fissiparous [n -S]\n",
  "FISSIPARISMS": "FISSIPARISM, the state of being fissiparous [n]\n",
  "FISSIPARITIES": "FISSIPARITY, the state of being fissiparous [n]\n",
  "FISSIPARITY": "the state of being fissiparous [n FISSIPARITIES]\n",
  "FISSIPAROUS": "producing new biological units or individuals by fission, as with most strains of bacteria [adj FISSIPAROUSLY]\n",
  "FISSIPAROUSLY": "FISSIPAROUS, producing new biological units or individuals by fission, as with most strains of bacteria [adv]\n",
  "FISSIPAROUSNESS": "FISSIPAROUS, producing new biological units or individuals by fission, as with most strains of bacteria [n]\n",
  "FISSIPED": "an animal having separate digits, also FISSIPEDE [n -S]\n",
  "FISSIPEDAL": "having toes that are separated from one another, as dogs, cats, bears, and similar carnivores [adj]\n",
  "FISSIPEDE": "with digits separate [adj] / a fissipede animal, also FISSIPED [n -S]\n",
  "FISSIPEDES": "FISSIPEDE, a fissipede animal, also FISSIPED [n]\n",
  "FISSIPEDS": "FISSIPED, an animal having separate digits, also FISSIPEDE [n]\n",
  "FISSIROSTRAL": "having a divided beak [adj]\n",
  "FISSIVE": "pertaining to nuclear fission [adj]\n",
  "FISSLE": "(Scots) to rustle [v FISSLED, FISSLING, FISSLES]\n",
  "FISSLED": "FISSLE, (Scots) to rustle [v]\n",
  "FISSLES": "FISSLE, (Scots) to rustle [v]\n",
  "FISSLING": "FISSLE, (Scots) to rustle [v]\n",
  "FISSURAL": "like a fissure [adj]\n",
  "FISSURE": "to split, cleave [v FISSURED, FISSURING, FISSURES]\n",
  "FISSURED": "FISSURE, to split, cleave [v]\n",
  "FISSURES": "FISSURE, to split, cleave [v]\n",
  "FISSURING": "FISSURE, to split, cleave [v]\n",
  "FIST": "to strike with the tightly closed hand [v -ED, -ING, -S]\n",
  "FISTED": "FIST, to strike with the tightly closed hand [v]\n",
  "FISTFIGHT": "a fight with the fists [n -S]\n",
  "FISTFIGHTS": "FISTFIGHT, a fight with the fists [n]\n",
  "FISTFUL": "as much as a fist will hold [n -S]\n",
  "FISTFULS": "FISTFUL, as much as a fist will hold [n]\n",
  "FISTIANA": "(facetious) anecdotes about boxers and boxing [n -S]\n",
  "FISTIANAS": "FISTIANA, (facetious) anecdotes about boxers and boxing [n]\n",
  "FISTIC": "(facetious) relating to pugilism, also FISTICAL [adj]\n",
  "FISTICAL": "(facetious) related to pugilism, also FISTIC [adj]\n",
  "FISTICUFF": "to fight with the fists [v -ED, -ING, -S]\n",
  "FISTICUFFED": "FISTICUFF, to fight with the fists [v]\n",
  "FISTICUFFING": "FISTICUFF, to fight with the fists [v]\n",
  "FISTICUFFS": "FISTICUFF, to fight with the fists [v]\n",
  "FISTIER": "FISTY, like a fist [adj]\n",
  "FISTIEST": "FISTY, like a fist [adj]\n",
  "FISTING": "a homosexual erotic practice [n -S]\n",
  "FISTINGS": "FISTING, a homosexual erotic practice [n]\n",
  "FISTMELE": "a measure of length equal to the breadth of a fist [n -S]\n",
  "FISTMELES": "FISTMELE, a measure of length equal to the breadth of a fist [n]\n",
  "FISTNOTE": "an index mark which draws attention to part of the text [n -S]\n",
  "FISTNOTES": "FISTNOTE, an index mark which draws attention to part of the text [n]\n",
  "FISTS": "FIST, to strike with the tightly closed hand [v]\n",
  "FISTULA": "(Latin) a duct formed by the imperfect closing of a wound [n FISTULAS or FISTULAE]\n",
  "FISTULAE": "FISTULA, (Latin) a duct formed by the imperfect closing of a wound [n]\n",
  "FISTULAR": "hollow and cylindrical, like a pipe or reed, also FISTULATE, FISTULOSE, FISTULOUS [adj]\n",
  "FISTULAS": "FISTULA, (Latin) a duct formed by the imperfect closing of a wound [n]\n",
  "FISTULATE": "hollow and cylindrical, like a pipe or reed, also FISTULAR, FISTULOSE, FISTULOUS [adj]\n",
  "FISTULOSE": "hollow and cylindrical, like a pipe or reed, also FISTULAR, FISTULATE, FISTULOUS [adj]\n",
  "FISTULOUS": "hollow and cylindrical, like a pipe or reed, also FISTULAR, FISTULATE, FISTULOSE [adj]\n",
  "FISTY": "like a fist [adj FISTIER, FISTIEST]\n",
  "FIT": "in a good healthy condition [adj FITTER, FITTEST, FITLY] / to adjust to the right size [v FITTED, FITTING, FITS]\n",
  "FITCH": "a polecat, also FITCHET, FITCHEW [n -ES]\n",
  "FITCHE": "in heraldry, coming to a point, also FITCHY, FITCHEE [adj]\n",
  "FITCHEE": "in heraldry, coming to a point, also FITCHY, FITCHE [adj]\n",
  "FITCHES": "FITCH, a polecat, also FITCHET, FITCHEW [n]\n",
  "FITCHET": "a polecat, also FITCH, FITCHEW [n -S]\n",
  "FITCHETS": "FITCHET, a polecat, also FITCH, FITCHEW [n]\n",
  "FITCHEW": "a polecat, also FITCH, FITCHET [n -S]\n",
  "FITCHEWS": "FITCHEW, a polecat, also FITCH, FITCHET [n]\n",
  "FITCHY": "in heraldry, coming to a point, also FITCHE, FITCHEE [adj]\n",
  "FITFUL": "marked by sudden impulses [adj FITFULLY]\n",
  "FITFULLY": "FITFUL, marked by sudden impulses [adv]\n",
  "FITFULNESS": "the quality of being fitful [n -ES]\n",
  "FITFULNESSES": "FITFULNESS, the quality of being fitful [n]\n",
  "FITLIER": "FITLY, in a fit manner [adv]\n",
  "FITLIEST": "FITLY, in a fit manner [adv]\n",
  "FITLY": "in a fit manner [adv FITLIER, FITLIEST]\n",
  "FITMENT": "equipment [n -S]\n",
  "FITMENTS": "FITMENT, equipment [n]\n",
  "FITNA": "(Arabic) a state of trouble or chaos [n -S]\n",
  "FITNAS": "FITNA, (Arabic) a state of trouble or chaos [n]\n",
  "FITNESS": "the state of being fit [n -ES]\n",
  "FITNESSES": "FITNESS, the state of being fit [n]\n",
  "FITS": "FIT, to adjust to the right size [v]\n",
  "FITT": "(archaic) a division of a poem, also FITTE, FYTTE [n -S]\n",
  "FITTABLE": "able to be fitted [adj]\n",
  "FITTE": "(archaic) a division of a poem, also FITT, FYTTE [n -S]\n",
  "FITTED": "FIT, to adjust to the right size [v]\n",
  "FITTER": "one that fits [n -S]\n",
  "FITTERS": "FITTER, one that fits [n]\n",
  "FITTES": "FITTE, (archaic) a division of a poem, also FITT, FYTTE [n]\n",
  "FITTEST": "FIT, in a good healthy condition [adj]\n",
  "FITTING": "suitable [adj FITTINGLY] / a small often standardized accessory part [n -S]\n",
  "FITTINGLY": "FITTING, suitable [adv]\n",
  "FITTINGNESS": "the state of being fitting [n -ES]\n",
  "FITTINGNESSES": "FITTINGNESS, the state of being fitting [n]\n",
  "FITTINGS": "FITTING, a small often standardized accessory part [n]\n",
  "FITTS": "FITT, (archaic) a division of a poem, also FITTE, FYTTE [n]\n",
  "FIVE": "a number [n -S]\n",
  "FIVEFINGER": "a name for various plants, cinquefoil etc. [n -S]\n",
  "FIVEFINGERS": "FIVEFINGER, a name for various plants, cinquefoil etc. [n]\n",
  "FIVEFOLD": "five times as great [adj]\n",
  "FIVEPENCE": "a coin worth five pence, also FIPPENCE [n -S]\n",
  "FIVEPENCES": "FIVEPENCE, a coin worth five pence, also FIPPENCE [n]\n",
  "FIVEPENNY": "worth five pence [adj]\n",
  "FIVEPIN": "used for playing fivepins [adj]\n",
  "FIVEPINS": "a bowling game [n]\n",
  "FIVER": "a five dollar bill, a five pound note [n -S]\n",
  "FIVERS": "FIVER, a five dollar bill, a five pound note [n]\n",
  "FIVES": "FIVE, a number [n]\n",
  "FIX": "to make firm, repair [v FIXT or FIXED, FIXING, FIXES]\n",
  "FIXABLE": "able to be fixed [adj]\n",
  "FIXATE": "to make stable [v FIXATED, FIXATING, FIXATES]\n",
  "FIXATED": "FIXATE, to make stable [v]\n",
  "FIXATES": "FIXATE, to make stable [v]\n",
  "FIXATIF": "(French) a substance for preserving paintings or drawings, also FIXATIVE [n -S]\n",
  "FIXATIFS": "FIXATIF, (French) a substance for preserving paintings or drawings, also FIXATIVE [n]\n",
  "FIXATING": "FIXATE, to make stable [v]\n",
  "FIXATION": "the act of fixating [n -S]\n",
  "FIXATIONS": "FIXATION, the act of fixating [n]\n",
  "FIXATIVE": "a substance for preserving paintings or drawings, also FIXATIF [n -S]\n",
  "FIXATIVES": "FIXATIVE, a substance for preserving paintings or drawings, also FIXATIF [n]\n",
  "FIXATURE": "a hair fixing preparation [n -S]\n",
  "FIXATURES": "FIXATURE, a hair fixing preparation [n]\n",
  "FIXED": "FIX, to make firm, repair [v]\n",
  "FIXEDLY": "FIXED, FIX, to make firm, repair [adv]\n",
  "FIXEDNESS": "the state of being fixed [n -ES]\n",
  "FIXEDNESSES": "FIXEDNESS, the state of being fixed [n]\n",
  "FIXER": "one that fixes [n -S]\n",
  "FIXERS": "FIXER, one that fixes [n]\n",
  "FIXES": "FIX, to make firm, repair [v]\n",
  "FIXING": "the act or process of making fixed [n -S]\n",
  "FIXINGS": "FIXING, the act or process of making fixed [n]\n",
  "FIXIT": "a person known for fixing things [n -S]\n",
  "FIXITIES": "FIXITY, stability [n]\n",
  "FIXITS": "FIXIT, a person known for fixing things [n]\n",
  "FIXITY": "stability [n FIXITIES]\n",
  "FIXIVE": "acting to fix a photographic image [adj]\n",
  "FIXT": "FIX, to make firm, repair [v]\n",
  "FIXTURE": "a permanent part of a house [n -S]\n",
  "FIXTURELESS": "without a fixture [adj]\n",
  "FIXTURES": "FIXTURE, a permanent part of a house [n]\n",
  "FIXURE": "(Shakespeare) stability, firmness [n -S]\n",
  "FIXURES": "FIXURE, (Shakespeare) stability, firmness [n]\n",
  "FIZ": "a sputtering sound, also FIZZ [n FIZZES] / to make a hissing or sputtering sound [v FIZZED, FIZZING, FIZZES]\n",
  "FIZGIG": "a police informer [n -S] / to dob someone in to the police, also FISGIG, FISHGIG, FIZZGIG [v FIZGIGGED, FIZGIGGING, FIZGIGS]\n",
  "FIZGIGGED": "FIZGIG, to dob someone in to the police, also FISGIG, FISHGIG, FIZZGIG [v]\n",
  "FIZGIGGING": "FIZGIG, to dob someone in to the police, also FISGIG, FISHGIG, FIZZGIG [v]\n",
  "FIZGIGS": "FIZGIG, a police informer [n]\n",
  "FIZZ": "to make a hissing or sputtering sound, also FIZ [v -ED, -ING, -ES]\n",
  "FIZZED": "FIZZ, to make a hissing or sputtering sound, also FIZ [v]\n",
  "FIZZEN": "(Scots) physical energy or strength, also FOISON, FUSHION [n -S]\n",
  "FIZZENLESS": "(Scots) weak, feeble, also FOISONLESS, FUSHIONLESS, FUSIONLESS [adj]\n",
  "FIZZENS": "FIZZEN, (Scots) physical energy or strength, also FOISON, FUSHION [n]\n",
  "FIZZER": "(Australian slang) anything that disappoints; something which fizzes; a fast ball in cricket [n -S]\n",
  "FIZZERS": "FIZZER, (Australian slang) anything that disappoints; something which fizzes; a fast ball in cricket [n]\n",
  "FIZZES": "FIZZ, to make a hissing or sputtering sound, also FIZ [v]\n",
  "FIZZGIG": "a police informer, also FISGIG, FISHGIG, FIZGIG [n -S]\n",
  "FIZZGIGS": "FIZZGIG, a police informer, also FISGIG, FISHGIG, FIZGIG [n]\n",
  "FIZZIER": "FIZZY, fizzing [adj]\n",
  "FIZZIEST": "FIZZY, fizzing [adj]\n",
  "FIZZILY": "FIZZY, fizzing [adv]\n",
  "FIZZINESS": "the state of being fizzy [n -ES]\n",
  "FIZZINESSES": "FIZZINESS, the state of being fizzy [n]\n",
  "FIZZING": "the sound of something fizzing [n -S]\n",
  "FIZZINGS": "FIZZING, the sound of something fizzing [n]\n",
  "FIZZLE": "to come to nothing [v FIZZLED, FIZZLING, FIZZLES]\n",
  "FIZZLED": "FIZZLE, to come to nothing [v]\n",
  "FIZZLES": "FIZZLE, to come to nothing [v]\n",
  "FIZZLING": "FIZZLE, to come to nothing [v]\n",
  "FIZZY": "fizzing [adj FIZZIER, FIZZIEST, FIZZILY]\n",
  "FJELD": "(Norwegian) a high, barren Scandinavian plateau [n -S]\n",
  "FJELDS": "FJELD, (Norwegian) a high, barren Scandinavian plateau [n]\n",
  "FJORD": "(Norwegian) a narrow inlet of the sea between steep cliffs, also FIORD [n -S]\n",
  "FJORDIC": "of or like a fjord [adj]\n",
  "FJORDS": "FJORD, (Norwegian) a narrow inlet of the sea between steep cliffs, also FIORD [n]\n",
  "FLAB": "excess body fat [n -S]\n",
  "FLABBERGAST": "to overwhelm with shock, surprise, or wonder [v -ED, -ING, -S]\n",
  "FLABBERGASTED": "FLABBERGAST, to overwhelm with shock, surprise, or wonder [v]\n",
  "FLABBERGASTING": "FLABBERGAST, to overwhelm with shock, surprise, or wonder [v]\n",
  "FLABBERGASTS": "FLABBERGAST, to overwhelm with shock, surprise, or wonder [v]\n",
  "FLABBIER": "FLABBY, hanging loose [adj]\n",
  "FLABBIEST": "FLABBY, hanging loose [adj]\n",
  "FLABBILY": "FLABBY, hanging loose [adv]\n",
  "FLABBINESS": "the quality of being flabby [n -ES]\n",
  "FLABBINESSES": "FLABBINESS, the quality of being flabby [n]\n",
  "FLABBY": "hanging loose [adj FLABBIER, FLABBIEST, FLABBILY]\n",
  "FLABELLA": "FLABELLUM, (Latin) a fan; esp the fan carried before the pope on state occasions, made in ostrich and peacock feathers [n]\n",
  "FLABELLATE": "fan-shaped [adj]\n",
  "FLABELLATION": "the act of fanning [n -S]\n",
  "FLABELLATIONS": "FLABELLATION, the act of fanning [n]\n",
  "FLABELLIFORM": "shaped like a fan [adj]\n",
  "FLABELLUM": "(Latin) a fan; esp the fan carried before the pope on state occasions, made in ostrich and peacock feathers [n FLABELLA]\n",
  "FLABS": "FLAB, excess body fat [n]\n",
  "FLACCID": "limp [adj FLACCIDER, FLACCIDEST, FLACCIDLY]\n",
  "FLACCIDER": "FLACCID, limp [adj]\n",
  "FLACCIDEST": "FLACCID, limp [adj]\n",
  "FLACCIDITIES": "FLACCIDITY, the state of being flaccid [n]\n",
  "FLACCIDITY": "the state of being flaccid [n FLACCIDITIES]\n",
  "FLACCIDLY": "FLACCID, limp [adv]\n",
  "FLACCIDNESS": "the state of being flaccid [n -ES]\n",
  "FLACCIDNESSES": "FLACCIDNESS, the state of being flaccid [n]\n",
  "FLACK": "to work as a press agent [v -ED, -ING, -S]\n",
  "FLACKED": "FLACK, to work as a press agent [v]\n",
  "FLACKER": "(Scots) to flutter, also FLAFFER [v -ED, -ING, -S]\n",
  "FLACKERED": "FLACKER, (Scots) to flutter, also FLAFFER [v]\n",
  "FLACKERIES": "FLACKERY, publicity [n]\n",
  "FLACKERING": "FLACKER, (Scots) to flutter, also FLAFFER [v]\n",
  "FLACKERS": "FLACKER, (Scots) to flutter, also FLAFFER [v]\n",
  "FLACKERY": "publicity [n FLACKERIES]\n",
  "FLACKET": "to flap, flutter [v -ED, -ING, -S]\n",
  "FLACKETED": "FLACKET, to flap, flutter [v]\n",
  "FLACKETING": "FLACKET, to flap, flutter [v]\n",
  "FLACKETS": "FLACKET, to flap, flutter [v]\n",
  "FLACKING": "FLACK, to work as a press agent [v]\n",
  "FLACKS": "FLACK, to work as a press agent [v]\n",
  "FLACON": "(French) a small decorative flagon with a tight-fitting stopper [n -S]\n",
  "FLACONS": "FLACON, (French) a small decorative flagon with a tight-fitting stopper [n]\n",
  "FLAFF": "(Scots) to flap, to pant [v -ED, -ING, -S]\n",
  "FLAFFED": "FLAFF, (Scots) to flap, to pant [v]\n",
  "FLAFFER": "(Scots) to flutter, also FLACKER [v -ED, -ING, -S]\n",
  "FLAFFERED": "FLAFFER, (Scots) to flutter, also FLACKER [v]\n",
  "FLAFFERING": "FLAFFER, (Scots) to flutter, also FLACKER [v]\n",
  "FLAFFERS": "FLAFFER, (Scots) to flutter, also FLACKER [v]\n",
  "FLAFFING": "FLAFF, (Scots) to flap, to pant [v]\n",
  "FLAFFS": "FLAFF, (Scots) to flap, to pant [v]\n",
  "FLAG": "to mark with a cloth used as a symbol [v FLAGGED, FLAGGING, FLAGS]\n",
  "FLAGELLA": "FLAGELLUM, (Latin) a long slender plant shoot [n]\n",
  "FLAGELLANT": "a person who whips, esp. himself or herself in religious discipline or sexual gratification [n -S]\n",
  "FLAGELLANTISM": "the practice of whipping oneself or another [n -S]\n",
  "FLAGELLANTISMS": "FLAGELLANTISM, the practice of whipping oneself or another [n]\n",
  "FLAGELLANTS": "FLAGELLANT, a person who whips, esp. himself or herself in religious discipline or sexual gratification [n]\n",
  "FLAGELLAR": "of or relating to a flagellum, a whip, a whiplike organ [adj]\n",
  "FLAGELLATE": "to whip; to scourge [v FLAGELLATED, FLAGELLATING, FLAGELLATES]\n",
  "FLAGELLATED": "FLAGELLATE, to whip; to scourge [v]\n",
  "FLAGELLATES": "FLAGELLATE, to whip; to scourge [v]\n",
  "FLAGELLATING": "FLAGELLATE, to whip; to scourge [v]\n",
  "FLAGELLATION": "the act or practice of flagellating [n -S]\n",
  "FLAGELLATIONS": "FLAGELLATION, the act or practice of flagellating [n]\n",
  "FLAGELLATOR": "one who engages in flagellation [n -S]\n",
  "FLAGELLATORS": "FLAGELLATOR, one who engages in flagellation [n]\n",
  "FLAGELLATORY": "relating to flagellation [adj]\n",
  "FLAGELLIFEROUS": "bearing a whip or flagellum [adj]\n",
  "FLAGELLIFORM": "shaped like a whip [adj]\n",
  "FLAGELLIN": "a polymeric protein that is the chief constituent of bacterial flagella [n -S]\n",
  "FLAGELLINS": "FLAGELLIN, a polymeric protein that is the chief constituent of bacterial flagella [n]\n",
  "FLAGELLOMANIA": "an obsession with flogging [n -S]\n",
  "FLAGELLOMANIAC": "a sufferer from flagellomania [n -S]\n",
  "FLAGELLOMANIACS": "FLAGELLOMANIAC, a sufferer from flagellomania [n]\n",
  "FLAGELLOMANIAS": "FLAGELLOMANIA, an obsession with flogging [n]\n",
  "FLAGELLUM": "(Latin) a long slender plant shoot [n FLAGELLUMS or FLAGELLA]\n",
  "FLAGELLUMS": "FLAGELLUM, (Latin) a long slender plant shoot [n]\n",
  "FLAGEOLET": "a small flute or recorder with two thumb holes; a kind of bean [n -S]\n",
  "FLAGEOLETS": "FLAGEOLET, a small flute or recorder with two thumb holes; a kind of bean [n]\n",
  "FLAGGED": "FLAG, to mark with a cloth used as a symbol [v]\n",
  "FLAGGER": "a person who carries a flag before a traction-engine to warn of its approach [n -S]\n",
  "FLAGGERS": "FLAGGER, a person who carries a flag before a traction-engine to warn of its approach [n]\n",
  "FLAGGIER": "FLAGGY, drooping [adj]\n",
  "FLAGGIEST": "FLAGGY, drooping [adj]\n",
  "FLAGGINESS": "the condition of being flaggy, flabby [n -ES]\n",
  "FLAGGINESSES": "FLAGGINESS, the condition of being flaggy, flabby [n]\n",
  "FLAGGING": "a type of pavement [n -S]\n",
  "FLAGGINGLY": "FLAGGING [adv]\n",
  "FLAGGINGS": "FLAGGING, a type of pavement [n]\n",
  "FLAGGY": "drooping [adj FLAGGIER, FLAGGIEST]\n",
  "FLAGITATE": "to entreat or importune [v FLAGITATED, FLAGITATING, FLAGITATES]\n",
  "FLAGITATED": "FLAGITATE, to entreat or importune [v]\n",
  "FLAGITATES": "FLAGITATE, to entreat or importune [v]\n",
  "FLAGITATING": "FLAGITATE, to entreat or importune [v]\n",
  "FLAGITATION": "the action of asking or demanding with passion [n -S]\n",
  "FLAGITATIONS": "FLAGITATION, the action of asking or demanding with passion [n]\n",
  "FLAGITIOUS": "marked by scandalous crime or vice; villainous [adj FLAGITIOUSLY]\n",
  "FLAGITIOUSLY": "FLAGITIOUS, marked by scandalous crime or vice; villainous [adv]\n",
  "FLAGITIOUSNESS": "FLAGITIOUS, marked by scandalous crime or vice; villainous [n]\n",
  "FLAGLESS": "without a flag [adj]\n",
  "FLAGMAN": "a man who carries a flag [n FLAGMEN]\n",
  "FLAGMEN": "FLAGMAN, a man who carries a flag [n]\n",
  "FLAGON": "a large vessel containing drink for use at table, usually with a handle, spout, and lid [n -S]\n",
  "FLAGONS": "FLAGON, a large vessel containing drink for use at table, usually with a handle, spout, and lid [n]\n",
  "FLAGPOLE": "a pole on a which a flag is flown [n -S]\n",
  "FLAGPOLES": "FLAGPOLE, a pole on a which a flag is flown [n]\n",
  "FLAGRANCE": "a burning; notoriety, also FLAGRANCY [n -S]\n",
  "FLAGRANCES": "FLAGRANCE, a burning; notoriety, also FLAGRANCY [n]\n",
  "FLAGRANCIES": "FLAGRANCY, a burning; notoriety, also FLAGRANCE [n]\n",
  "FLAGRANCY": "a burning; notoriety, also FLAGRANCE [n FLAGRANCIES]\n",
  "FLAGRANT": "conspicuous [adj FLAGRANTLY]\n",
  "FLAGRANTLY": "FLAGRANT, conspicuous [adv]\n",
  "FLAGRANTNESS": "the state of being flagrant [n -ES]\n",
  "FLAGRANTNESSES": "FLAGRANTNESS, the state of being flagrant [n]\n",
  "FLAGS": "FLAG, to mark with a cloth used as a symbol [v]\n",
  "FLAGSHIP": "the ship carrying an admiral and flying his flag [n -S]\n",
  "FLAGSHIPS": "FLAGSHIP, the ship carrying an admiral and flying his flag [n]\n",
  "FLAGSTAFF": "a pole for displaying a flag, also FLAGPOLE, FLAGSTICK [n FLAGSTAFFS or FLAGSTAVES]\n",
  "FLAGSTAFFS": "FLAGSTAFF, a pole for displaying a flag, also FLAGPOLE, FLAGSTICK [n]\n",
  "FLAGSTAVES": "FLAGSTAFF, a pole for displaying a flag, also FLAGPOLE, FLAGSTICK [n]\n",
  "FLAGSTICK": "a pole for displaying a flag, also FLAGPOLE, FLAGSTAFF [n -S]\n",
  "FLAGSTICKS": "FLAGSTICK, a pole for displaying a flag, also FLAGPOLE, FLAGSTAFF [n]\n",
  "FLAGSTONE": "a large paving stone [n -S]\n",
  "FLAGSTONES": "FLAGSTONE, a large paving stone [n]\n",
  "FLAIL": "to thresh about [v -ED, -ING, -S]\n",
  "FLAILED": "FLAIL, to thresh about [v]\n",
  "FLAILING": "FLAIL, to thresh about [v]\n",
  "FLAILS": "FLAIL, to thresh about [v]\n",
  "FLAIR": "a natural skill [n -S]\n",
  "FLAIRS": "FLAIR, a natural skill [n]\n",
  "FLAK": "antiaircraft fire [n -S]\n",
  "FLAKE": "to peel off in thin flat pieces [v FLAKED, FLAKING, FLAKES]\n",
  "FLAKED": "FLAKE, to peel off in thin flat pieces [v]\n",
  "FLAKER": "someone or something that flakes [n -S]\n",
  "FLAKERS": "FLAKER, someone or something that flakes [n]\n",
  "FLAKES": "FLAKE, to peel off in thin flat pieces [v]\n",
  "FLAKEY": "in flakes; crazy, eccentric, also FLAKY [adj FLAKIER, FLAKIEST]\n",
  "FLAKIER": "FLAKEY, in flakes; crazy, eccentric, also FLAKY [adj]\n",
  "FLAKIES": "FLAKY, a fit of temper [n]\n",
  "FLAKIEST": "FLAKEY, in flakes; crazy, eccentric, also FLAKY [adj]\n",
  "FLAKILY": "FLAKY, tending to form flakes [adv]\n",
  "FLAKINESS": "the state of being flaky [n -ES]\n",
  "FLAKINESSES": "FLAKINESS, the state of being flaky [n]\n",
  "FLAKING": "FLAKE, to peel off in thin flat pieces [v]\n",
  "FLAKS": "FLAK, antiaircraft fire [n]\n",
  "FLAKY": "a fit of temper [n FLAKIES] / tending to form flakes [adj FLAKIER, FLAKIEST, FLAKILY]\n",
  "FLAM": "to deceive [v FLAMMED, FLAMMING, FLAMS]\n",
  "FLAMBE": "(French) to douse (e.g. a pancake) with a liqueur and ignite, also FLAMBEE [v -ED, -ING, -S]\n",
  "FLAMBEAU": "(French) a flaming torch [n FLAMBEAUS or FLAMBEAUX]\n",
  "FLAMBEAUS": "FLAMBEAU, (French) a flaming torch [n]\n",
  "FLAMBEAUX": "FLAMBEAU, (French) a flaming torch [n]\n",
  "FLAMBEE": "(French) to douse with liqueur and ignite, also FLAMBE [v FLAMBEED, FLAMBEEING, FLAMBEES]\n",
  "FLAMBEED": "FLAMBEE, (French) to douse with liqueur and ignite, also FLAMBE [v]\n",
  "FLAMBEEING": "FLAMBEE, (French) to douse with liqueur and ignite, also FLAMBE [v]\n",
  "FLAMBEES": "FLAMBEE, (French) to douse with liqueur and ignite, also FLAMBE [v]\n",
  "FLAMBEING": "FLAMBE, (French) to douse (e.g. a pancake) with a liqueur and ignite, also FLAMBEE [v]\n",
  "FLAMBES": "FLAMBE, (French) to douse (e.g. a pancake) with a liqueur and ignite, also FLAMBEE [v]\n",
  "FLAMBOYANCE": "the state of being flamboyant, also FLAMBOYANCY [n -S]\n",
  "FLAMBOYANCES": "FLAMBOYANCE, the state of being flamboyant, also FLAMBOYANCY [n]\n",
  "FLAMBOYANCIES": "FLAMBOYANCY, the state of being flamboyant, also FLAMBOYANCE [n]\n",
  "FLAMBOYANCY": "the state of being flamboyant, also FLAMBOYANCE [n FLAMBOYANCIES]\n",
  "FLAMBOYANT": "extravagant [adj FLAMBOYANTLY] / a tropical tree with flame-coloured flowers, also FLAMBOYANTE [n -S]\n",
  "FLAMBOYANTE": "a tropical tree with flame-coloured flowers, also FLAMBOYANT [n -S]\n",
  "FLAMBOYANTES": "FLAMBOYANTE, a tropical tree with flame-coloured flowers, also FLAMBOYANT [n]\n",
  "FLAMBOYANTLY": "FLAMBOYANT, extravagant [adv]\n",
  "FLAMBOYANTS": "FLAMBOYANT, a tropical tree with flame-coloured flowers, also FLAMBOYANTE [n]\n",
  "FLAME": "to burn brightly [v FLAMED, FLAMING, FLAMES]\n",
  "FLAMED": "FLAME, to burn brightly [v]\n",
  "FLAMELESS": "without a flame [adj]\n",
  "FLAMELET": "a small flame [n -S]\n",
  "FLAMELETS": "FLAMELET, a small flame [n]\n",
  "FLAMELIKE": "like a flame [adj]\n",
  "FLAMEN": "(Latin) a priest of ancient Rome [n FLAMENS or FLAMINES]\n",
  "FLAMENCO": "(Spanish) an emotionally intense gypsy song or dance [n -S]\n",
  "FLAMENCOS": "FLAMENCO, (Spanish) an emotionally intense gypsy song or dance [n]\n",
  "FLAMENS": "FLAMEN, (Latin) a priest of ancient Rome [n]\n",
  "FLAMEOUT": "a failure of a jet engine in flight [n -S]\n",
  "FLAMEOUTS": "FLAMEOUT, a failure of a jet engine in flight [n]\n",
  "FLAMEPROOF": "resistant to burning [adj] / to make resistant to damage or burning on contact with flame [v -ED, -ING, -S]\n",
  "FLAMEPROOFED": "FLAMEPROOF, to make resistant to damage or burning on contact with flame [v]\n",
  "FLAMEPROOFER": "one who flameproofs [n -S]\n",
  "FLAMEPROOFERS": "FLAMEPROOFER, one who flameproofs [n]\n",
  "FLAMEPROOFING": "FLAMEPROOF, to make resistant to damage or burning on contact with flame [v]\n",
  "FLAMEPROOFS": "FLAMEPROOF, to make resistant to damage or burning on contact with flame [v]\n",
  "FLAMER": "a person who or thing which flames [n -S]\n",
  "FLAMERS": "FLAMER, a person who or thing which flames [n]\n",
  "FLAMES": "FLAME, to burn brightly [v]\n",
  "FLAMETHROWER": "a device that expels from a nozzle a burning stream of liquid or semiliquid fuel under pressure [n -S]\n",
  "FLAMETHROWERS": "FLAMETHROWER, a device that expels from a nozzle a burning stream of liquid or semiliquid fuel under pressure [n]\n",
  "FLAMFEW": "a fantastic trifle [n -S]\n",
  "FLAMFEWS": "FLAMFEW, a fantastic trifle [n]\n",
  "FLAMIER": "FLAMY, flaming [adj]\n",
  "FLAMIEST": "FLAMY, flaming [adj]\n",
  "FLAMINES": "FLAMEN, (Latin) a priest of ancient Rome [n]\n",
  "FLAMING": "FLAME, to burn brightly [v]\n",
  "FLAMINGLY": "FLAMING, FLAME, to burn brightly [adv]\n",
  "FLAMINGO": "a long-legged tropical bird [n -ES or -S]\n",
  "FLAMINGOES": "FLAMINGO, a long-legged tropical bird [n]\n",
  "FLAMINGOS": "FLAMINGO, a long-legged tropical bird [n]\n",
  "FLAMINICAL": "pertaining to a flamen, a priest of a Roman deity [adj]\n",
  "FLAMM": "(archaic) a custard, also FLAN, FLAUNE, FLAWN [n -S]\n",
  "FLAMMABILITIES": "FLAMMABILITY, the ability to support combustion [n]\n",
  "FLAMMABILITY": "the ability to support combustion [n FLAMMABILITIES]\n",
  "FLAMMABLE": "easily able to catch fire, also INFLAMABLE, INFLAMMABLE [adj] / something flammable [n -S]\n",
  "FLAMMABLES": "FLAMMABLE, something flammable [n]\n",
  "FLAMMED": "FLAM, to deceive [v]\n",
  "FLAMMIFEROUS": "producing flame [adj]\n",
  "FLAMMING": "FLAM, to deceive [v]\n",
  "FLAMMS": "FLAMM, (archaic) a custard, also FLAN, FLAUNE, FLAWN [n]\n",
  "FLAMMULATED": "ruddy [adj]\n",
  "FLAMMULATION": "flamelike marking [n -S]\n",
  "FLAMMULATIONS": "FLAMMULATION, flamelike marking [n]\n",
  "FLAMMULE": "a little flame [n -S]\n",
  "FLAMMULES": "FLAMMULE, a little flame [n]\n",
  "FLAMS": "FLAM, to deceive [v]\n",
  "FLAMY": "flaming [adj FLAMIER, FLAMIEST]\n",
  "FLAN": "a type of custard, also FLAMM, FLAUNE, FLAWN [n FLAN or FLANES]\n",
  "FLANCARD": "a piece of armor for the side of a horse [n -S]\n",
  "FLANCARDS": "FLANCARD, a piece of armor for the side of a horse [n]\n",
  "FLANCH": "to widen into a flared shape, also FLAUNCH [v -ED, -ING, -ES]\n",
  "FLANCHED": "FLANCH, to widen into a flared shape, also FLAUNCH [v]\n",
  "FLANCHES": "FLANCH, to widen into a flared shape, also FLAUNCH [v]\n",
  "FLANCHING": "a sloping piece of cement, e.g. round the base of a chimneypot, also FLAUNCHING [n -S]\n",
  "FLANCHINGS": "FLANCHING, a sloping piece of cement, e.g. round the base of a chimneypot, also FLAUNCHING [n]\n",
  "FLANCONADE": "(French) a thrust in the side [n -S]\n",
  "FLANCONADES": "FLANCONADE, (French) a thrust in the side [n]\n",
  "FLANE": "to walk idly, saunter [v FLANED, FLANING, FLANES]\n",
  "FLANED": "FLANE, to walk idly, saunter [v]\n",
  "FLANERIE": "(French) commendable idleness or aimless wandering [n -S]\n",
  "FLANERIES": "FLANERIE, (French) commendable idleness or aimless wandering [n]\n",
  "FLANES": "FLANE, to walk idly, saunter [v]\n",
  "FLANEUR": "(French) an idle man-about-town; a lounger, gossiper [n -S]\n",
  "FLANEURS": "FLANEUR, (French) an idle man-about-town; a lounger, gossiper [n]\n",
  "FLANGE": "to provide with a protecting rim [v FLANGED, FLANGING, FLANGES]\n",
  "FLANGED": "FLANGE, to provide with a protecting rim [v]\n",
  "FLANGELESS": "without a flange [adj]\n",
  "FLANGER": "a vertical scraper for clearing snow from railway tracks to allow room for the wheel-flanges [n -S]\n",
  "FLANGERS": "FLANGER, a vertical scraper for clearing snow from railway tracks to allow room for the wheel-flanges [n]\n",
  "FLANGES": "FLANGE, to provide with a protecting rim [v]\n",
  "FLANGING": "an audio effect that results when the same signal is played from two sources with a minute but variable time delay between them [n -S]\n",
  "FLANGINGS": "FLANGING, an audio effect that results when the same signal is played from two sources with a minute but variable time delay between them [n]\n",
  "FLANING": "FLANE, to walk idly, saunter [v]\n",
  "FLANK": "to be situated to the side of [v -ED, -ING, -S]\n",
  "FLANKED": "FLANK, to be situated to the side of [v]\n",
  "FLANKEN": "beef cut from the side and boiled with vegetables [n -S]\n",
  "FLANKENS": "FLANKEN, beef cut from the side and boiled with vegetables [n]\n",
  "FLANKER": "to use flank defences [v -ED, -ING, -S]\n",
  "FLANKERED": "FLANKER, to use flank defences [v]\n",
  "FLANKERING": "FLANKER, to use flank defences [v]\n",
  "FLANKERS": "FLANKER, to use flank defences [v]\n",
  "FLANKING": "FLANK, to be situated to the side of [v]\n",
  "FLANKS": "FLANK, to be situated to the side of [v]\n",
  "FLANNEL": "to cover with a soft fabric [v FLANNELED or FLANNELLED, FLANNELING or FLANNELLING, FLANNELS]\n",
  "FLANNELBOARD": "a teaching aid consisting of a board covered with flannel [n -S]\n",
  "FLANNELBOARDS": "FLANNELBOARD, a teaching aid consisting of a board covered with flannel [n]\n",
  "FLANNELED": "FLANNEL, to cover with a soft fabric [v]\n",
  "FLANNELET": "a cotton imitation of flannel, also FLANNELETTE [n -S]\n",
  "FLANNELETS": "FLANNELET, a cotton imitation of flannel, also FLANNELETTE [n]\n",
  "FLANNELETTE": "a cotton imitation of flannel, also FLANNELET [n -S]\n",
  "FLANNELETTES": "FLANNELETTE, a cotton imitation of flannel, also FLANNELET [n]\n",
  "FLANNELGRAPH": "a display board covered with flannel or felt, on which letters, pictures, etc. backed with material will stick when pressed against it [n -S]\n",
  "FLANNELGRAPHS": "FLANNELGRAPH, a display board covered with flannel or felt, on which letters, pictures, etc. backed with material will stick when pressed against it [n]\n",
  "FLANNELING": "FLANNEL, to cover with a soft fabric [v]\n",
  "FLANNELLED": "FLANNEL, to cover with a soft fabric [v]\n",
  "FLANNELLIER": "FLANNELLY, like flannel [adj]\n",
  "FLANNELLIEST": "FLANNELLY, like flannel [adj]\n",
  "FLANNELLING": "FLANNEL, to cover with a soft fabric [v]\n",
  "FLANNELLY": "like flannel [adj FLANNELLIER, FLANNELLIEST]\n",
  "FLANNELMOUTHED": "speaking indistinctly [adj]\n",
  "FLANNELS": "FLANNEL, to cover with a soft fabric [v]\n",
  "FLANNEN": "(dialect) flannel [n -S]\n",
  "FLANNENS": "FLANNEN, (dialect) flannel [n]\n",
  "FLANNIE": "(Australian) a shirt made of flannel or flannelette, also FLANNY [n -S]\n",
  "FLANNIES": "FLANNY, (Australian) a shirt made of flannel or flannelette, also FLANNIE [n]\n",
  "FLANNY": "(Australian) a shirt made of flannel or flannelette, also FLANNIE [n FLANNIES]\n",
  "FLANS": "FLAN, a type of custard, also FLAMM, FLAUNE, FLAWN [n]\n",
  "FLAP": "to move, as of wings [v FLAPPED, FLAPPING, FLAPS]\n",
  "FLAPDOODLE": "gross flattery; nonsense [n -S]\n",
  "FLAPDOODLES": "FLAPDOODLE, gross flattery; nonsense [n]\n",
  "FLAPERON": "an airfoil that functions as a flap and an aileron [n -S]\n",
  "FLAPERONS": "FLAPERON, an airfoil that functions as a flap and an aileron [n]\n",
  "FLAPJACK": "a kind of biscuit, also SLAPJACK [n -S]\n",
  "FLAPJACKS": "FLAPJACK, a kind of biscuit, also SLAPJACK [n]\n",
  "FLAPLESS": "not having a piece hanging loose [adj]\n",
  "FLAPLIKE": "like a flap [adj]\n",
  "FLAPPABLE": "not unflappable, easily perturbed [adj]\n",
  "FLAPPED": "FLAP, to move, as of wings [v]\n",
  "FLAPPER": "a flighty young woman [n -S]\n",
  "FLAPPERHOOD": "the state of being a flapper [n -S]\n",
  "FLAPPERHOODS": "FLAPPERHOOD, the state of being a flapper [n]\n",
  "FLAPPERISH": "like a flapper, a young girl nearing womanhood [adj]\n",
  "FLAPPERS": "FLAPPER, a flighty young woman [n]\n",
  "FLAPPIER": "FLAPPY, flapping [adj]\n",
  "FLAPPIEST": "FLAPPY, flapping [adj]\n",
  "FLAPPING": "the act of flapping [n -S]\n",
  "FLAPPINGS": "FLAPPING, the act of flapping [n]\n",
  "FLAPPY": "flapping [adj FLAPPIER, FLAPPIEST]\n",
  "FLAPS": "FLAP, to move, as of wings [v]\n",
  "FLAPTRACK": "a racetrack for flapping i.e. unregistered horse-racing [n -S]\n",
  "FLAPTRACKS": "FLAPTRACK, a racetrack for flapping i.e. unregistered horse-racing [n]\n",
  "FLARE": "to display glaringly with a blaze [v FLARED, FLARING, FLARES]\n",
  "FLAREBACK": "a flame in the breech of a gun when fired [n -S]\n",
  "FLAREBACKS": "FLAREBACK, a flame in the breech of a gun when fired [n]\n",
  "FLARED": "FLARE, to display glaringly with a blaze [v]\n",
  "FLARES": "FLARE, to display glaringly with a blaze [v]\n",
  "FLAREUP": "a sudden outbreak [n -S]\n",
  "FLAREUPS": "FLAREUP, a sudden outbreak [n]\n",
  "FLARIER": "FLARY, tending to flare [adj]\n",
  "FLARIEST": "FLARY, tending to flare [adj]\n",
  "FLARING": "FLARE, to display glaringly with a blaze [v]\n",
  "FLARINGLY": "FLARING, FLARE, to display glaringly with a blaze [adv]\n",
  "FLARY": "tending to flare [adj FLARIER, FLARIEST]\n",
  "FLASER": "(German) a streaky appearance in rocks [n -S]\n",
  "FLASERS": "FLASER, (German) a streaky appearance in rocks [n]\n",
  "FLASH": "showy, vulgar [adj FLASHER, FLASHEST] / to shine briefly [v -ED, -ING, -ES]\n",
  "FLASHBACK": "in a film, novel, etc., a scene of the past, inserted as comment or explanation [n -S] / to show a flashback [v -ED, -ING, -S]\n",
  "FLASHBACKED": "FLASHBACK, to show a flashback [v]\n",
  "FLASHBACKING": "FLASHBACK, to show a flashback [v]\n",
  "FLASHBACKS": "FLASHBACK, to show a flashback [v]\n",
  "FLASHBANG": "a stun grenade [n -S]\n",
  "FLASHBANGS": "FLASHBANG, a stun grenade [n]\n",
  "FLASHBOARD": "one of a set of boards set up at the sides of a water channel to deepen it [n -S]\n",
  "FLASHBOARDS": "FLASHBOARD, one of a set of boards set up at the sides of a water channel to deepen it [n]\n",
  "FLASHBULB": "an oxygen-filled electric bulb in which aluminium or other foil or filament may be fired to provide a brilliant flash [n -S]\n",
  "FLASHBULBS": "FLASHBULB, an oxygen-filled electric bulb in which aluminium or other foil or filament may be fired to provide a brilliant flash [n]\n",
  "FLASHCARD": "a card shown briefly as a memory test [n -S]\n",
  "FLASHCARDS": "FLASHCARD, a card shown briefly as a memory test [n]\n",
  "FLASHCUBE": "a plastic cube containing four flashbulbs, rotated as the film is wound on [n -S]\n",
  "FLASHCUBES": "FLASHCUBE, a plastic cube containing four flashbulbs, rotated as the film is wound on [n]\n",
  "FLASHED": "FLASH, to shine briefly [v]\n",
  "FLASHER": "something or someone that flashes [n -S]\n",
  "FLASHERS": "FLASHER, something or someone that flashes [n]\n",
  "FLASHES": "FLASH, to shine briefly [v]\n",
  "FLASHEST": "FLASH, showy, vulgar [adj]\n",
  "FLASHFORWARD": "a transition in a novel, film, etc., to a scene or event in the future [n -S]\n",
  "FLASHFORWARDS": "FLASHFORWARD, a transition in a novel, film, etc., to a scene or event in the future [n]\n",
  "FLASHGUN": "a photographic apparatus [n -S]\n",
  "FLASHGUNS": "FLASHGUN, a photographic apparatus [n]\n",
  "FLASHIER": "FLASHY, showy, vulgar [adj]\n",
  "FLASHIEST": "FLASHY, showy, vulgar [adj]\n",
  "FLASHILY": "FLASHY, showy, vulgar [adv]\n",
  "FLASHINESS": "the quality of being flashy [n -ES]\n",
  "FLASHINESSES": "FLASHINESS, the quality of being flashy [n]\n",
  "FLASHING": "sheet metal used to waterproof a roof [n -S]\n",
  "FLASHINGS": "FLASHING, sheet metal used to waterproof a roof [n]\n",
  "FLASHLAMP": "an electric torch [n -S]\n",
  "FLASHLAMPS": "FLASHLAMP, an electric torch [n]\n",
  "FLASHLIGHT": "a sudden bright artificial light used in taking photographic pictures [n -S]\n",
  "FLASHLIGHTS": "FLASHLIGHT, a sudden bright artificial light used in taking photographic pictures [n]\n",
  "FLASHMOBBING": "the practice of gathering at a given place in response to a message [n -S]\n",
  "FLASHMOBBINGS": "FLASHMOBBING, the practice of gathering at a given place in response to a message [n]\n",
  "FLASHOVER": "an electric discharge over the surface of an insulator [n -S]\n",
  "FLASHOVERS": "FLASHOVER, an electric discharge over the surface of an insulator [n]\n",
  "FLASHPACKER": "a backpacker who has a considerable disposable income [n -S]\n",
  "FLASHPACKERS": "FLASHPACKER, a backpacker who has a considerable disposable income [n]\n",
  "FLASHPOINT": "a critical moment beyond which a situation will inevitably erupt into violence [n -S]\n",
  "FLASHPOINTS": "FLASHPOINT, a critical moment beyond which a situation will inevitably erupt into violence [n]\n",
  "FLASHTUBE": "a gas discharge tube that produces very brief intense flashes of light and is used esp. in photography [n -S]\n",
  "FLASHTUBES": "FLASHTUBE, a gas discharge tube that produces very brief intense flashes of light and is used esp. in photography [n]\n",
  "FLASHY": "showy, vulgar [adj FLASHIER, FLASHIEST, FLASHILY]\n",
  "FLASK": "a narrow-necked container [n -S]\n",
  "FLASKET": "(historical) a long, shallow basket, with two handles [n -S]\n",
  "FLASKETS": "FLASKET, (historical) a long, shallow basket, with two handles [n]\n",
  "FLASKS": "FLASK, a narrow-necked container [n]\n",
  "FLAT": "to make flat [v FLATTED, FLATTING, FLATS] / having a smooth level surface [adj FLATTER, FLATTEST, FLATLY]\n",
  "FLATBACK": "a pottery figure with a flat back [n -S]\n",
  "FLATBACKS": "FLATBACK, a pottery figure with a flat back [n]\n",
  "FLATBED": "a lorry with a flat sideless tray [n -S]\n",
  "FLATBEDS": "FLATBED, a lorry with a flat sideless tray [n]\n",
  "FLATBOAT": "a large flat-bottomed boat for transporting goods on a river, canal, etc. [n -S]\n",
  "FLATBOATS": "FLATBOAT, a large flat-bottomed boat for transporting goods on a river, canal, etc. [n]\n",
  "FLATBREAD": "a type of thin unleavened bread [n -S]\n",
  "FLATBREADS": "FLATBREAD, a type of thin unleavened bread [n]\n",
  "FLATBROD": "a flatbread made with rye [n -S]\n",
  "FLATBRODS": "FLATBROD, a flatbread made with rye [n]\n",
  "FLATCAP": "a low-crowned hat worn by London citizens in the 16th and 17th centuries [n -S]\n",
  "FLATCAPS": "FLATCAP, a low-crowned hat worn by London citizens in the 16th and 17th centuries [n]\n",
  "FLATCAR": "a railway car without sides or roof [n -S]\n",
  "FLATCARS": "FLATCAR, a railway car without sides or roof [n]\n",
  "FLATETTE": "(Australian slang) a small flat [n -S]\n",
  "FLATETTES": "FLATETTE, (Australian slang) a small flat [n]\n",
  "FLATFEET": "FLATFOOT, a foot condition [n]\n",
  "FLATFISH": "a marine fish that habitually lies on its side [n -ES]\n",
  "FLATFISHES": "FLATFISH, a marine fish that habitually lies on its side [n]\n",
  "FLATFOOT": "to walk with a dragging gait [v -ED, -ING, -S] / a foot condition [n FLATFOOTS or FLATFEET]\n",
  "FLATFOOTED": "FLATFOOT, to walk with a dragging gait [v]\n",
  "FLATFOOTING": "FLATFOOT, to walk with a dragging gait [v]\n",
  "FLATFOOTS": "FLATFOOT, to walk with a dragging gait [v]\n",
  "FLATFORM": "a thick, level sole on a shoe [n -S]\n",
  "FLATFORMS": "FLATFORM, a thick, level sole on a shoe [n]\n",
  "FLATHEAD": "any of various species of edible flat-skulled fish of the Pacific and Indian Oceans [n -S]\n",
  "FLATHEADS": "FLATHEAD, any of various species of edible flat-skulled fish of the Pacific and Indian Oceans [n]\n",
  "FLATIRON": "an iron for pressing clothes [n -S]\n",
  "FLATIRONS": "FLATIRON, an iron for pressing clothes [n]\n",
  "FLATLAND": "land lacking variation in elevation [n -S]\n",
  "FLATLANDER": "one who lives in flat country [n -S]\n",
  "FLATLANDERS": "FLATLANDER, one who lives in flat country [n]\n",
  "FLATLANDS": "FLATLAND, land lacking variation in elevation [n]\n",
  "FLATLET": "a type of apartment [n -S]\n",
  "FLATLETS": "FLATLET, a type of apartment [n]\n",
  "FLATLINE": "to register as having no brain waves or heartbeat [v FLATLINED, FLATLINING, FLATLINES]\n",
  "FLATLINED": "FLATLINE, to register as having no brain waves or heartbeat [v]\n",
  "FLATLINER": "one who flatlines [n -S]\n",
  "FLATLINERS": "FLATLINER, one who flatlines [n]\n",
  "FLATLINES": "FLATLINE, to register as having no brain waves or heartbeat [v]\n",
  "FLATLING": "(Spenser) with a flat side or edge, also FLATLINGS, FLATLONG [adv]\n",
  "FLATLINGS": "(Spenser) with a flat side or edge, also FLATLING, FLATLONG [adv]\n",
  "FLATLINING": "FLATLINE, to register as having no brain waves or heartbeat [v]\n",
  "FLATLONG": "(Spenser) with a flat side or edge, also FLATLING, FLATLINGS [adv]\n",
  "FLATLY": "FLAT, having a smooth level surface [adv]\n",
  "FLATMATE": "a person with whom one shares a flat [n -S]\n",
  "FLATMATES": "FLATMATE, a person with whom one shares a flat [n]\n",
  "FLATNESS": "the state of being flat [n -ES]\n",
  "FLATNESSES": "FLATNESS, the state of being flat [n]\n",
  "FLATPACK": "an item of furniture in a carton to be assembled [n -S]\n",
  "FLATPACKS": "FLATPACK, an item of furniture in a carton to be assembled [n]\n",
  "FLATPICK": "to play (a guitar, banjo, etc.) by plucking individual strings with a plectrum [v -ED, -ING, -S]\n",
  "FLATPICKED": "FLATPICK, to play (a guitar, banjo, etc.) by plucking individual strings with a plectrum [v]\n",
  "FLATPICKING": "FLATPICK, to play (a guitar, banjo, etc.) by plucking individual strings with a plectrum [v]\n",
  "FLATPICKS": "FLATPICK, to play (a guitar, banjo, etc.) by plucking individual strings with a plectrum [v]\n",
  "FLATS": "FLAT, to make flat [v]\n",
  "FLATSCREEN": "having a flat screen [adj] / a television with a flat screen [n -S]\n",
  "FLATSCREENS": "FLATSCREEN, a television with a flat screen [n]\n",
  "FLATSHARE": "an arrangement whereby a flat is shared [n -S]\n",
  "FLATSHARES": "FLATSHARE, an arrangement whereby a flat is shared [n]\n",
  "FLATSTICK": "(South African slang) with great speed or effort [adj]\n",
  "FLATTED": "FLAT, to make flat [v]\n",
  "FLATTEN": "to make or become flat [v -ED, -ING, -S]\n",
  "FLATTENED": "FLATTEN, to make or become flat [v]\n",
  "FLATTENER": "something that makes flat [n -S]\n",
  "FLATTENERS": "FLATTENER, something that makes flat [n]\n",
  "FLATTENING": "FLATTEN, to make or become flat [v]\n",
  "FLATTENS": "FLATTEN, to make or become flat [v]\n",
  "FLATTER": "to praise excessively [v -ED, -ING, -S]\n",
  "FLATTERABLE": "that can be flattered [adj]\n",
  "FLATTERED": "FLATTER, to praise excessively [v]\n",
  "FLATTERER": "one who flatters [n -S]\n",
  "FLATTERERS": "FLATTERER, one who flatters [n]\n",
  "FLATTERIES": "FLATTERY, the act of flattering [n]\n",
  "FLATTERING": "FLATTER, to praise excessively [v]\n",
  "FLATTERINGLY": "FLATTERING, FLATTER, to praise excessively [adv]\n",
  "FLATTEROUS": "(archaic) flattering [adj FLATTEROUSLY]\n",
  "FLATTEROUSLY": "FLATTEROUS, (archaic) flattering [adv]\n",
  "FLATTERS": "FLATTER, to praise excessively [v]\n",
  "FLATTERY": "the act of flattering [n FLATTERIES]\n",
  "FLATTEST": "FLAT, having a smooth level surface [adj]\n",
  "FLATTIE": "a light flat shoe, also FLATTY [n -S]\n",
  "FLATTIES": "FLATTY, a light flat shoe, also FLATTIE [n]\n",
  "FLATTING": "painting with a flat finish [n -S]\n",
  "FLATTINGS": "FLATTING, painting with a flat finish [n]\n",
  "FLATTISH": "somewhat flat [adj]\n",
  "FLATTOP": "an aircraft carrier [n -S]\n",
  "FLATTOPS": "FLATTOP, an aircraft carrier [n]\n",
  "FLATTY": "a light flat shoe, also FLATTIE [n FLATTIES]\n",
  "FLATULENCE": "distension of the stomach or bowels by gases formed during digestion, also FLATULENCY [n -S]\n",
  "FLATULENCES": "FLATULENCE, distension of the stomach or bowels by gases formed during digestion, also FLATULENCY [n]\n",
  "FLATULENCIES": "FLATULENCY, distension of the stomach or bowels by gases formed during digestion, also FLATULENCE [n]\n",
  "FLATULENCY": "distension of the stomach or bowels by gases formed during digestion, also FLATULENCE [n FLATULENCIES]\n",
  "FLATULENT": "suffering from flatulence [adj FLATULENTLY]\n",
  "FLATULENTLY": "FLATULENT, suffering from flatulence [adv]\n",
  "FLATUOUS": "flatulent [adj]\n",
  "FLATUS": "(Latin) intestinal gas [n -ES]\n",
  "FLATUSES": "FLATUS, (Latin) intestinal gas [n]\n",
  "FLATWARE": "tableware that is fairly flat [n -S]\n",
  "FLATWARES": "FLATWARE, tableware that is fairly flat [n]\n",
  "FLATWASH": "laundry that can be ironed mechanically, also FLATWORK [n -ES]\n",
  "FLATWASHES": "FLATWASH, laundry that can be ironed mechanically, also FLATWORK [n]\n",
  "FLATWATER": "slowly moving water in a river, as opposed to rapids [n -S]\n",
  "FLATWATERS": "FLATWATER, slowly moving water in a river, as opposed to rapids [n]\n",
  "FLATWAYS": "with or on the flat side, also FLATWISE [adv]\n",
  "FLATWISE": "with the flat side in a particular position [adv]\n",
  "FLATWORK": "laundry that can be ironed mechanically [n -S]\n",
  "FLATWORKS": "FLATWORK, laundry that can be ironed mechanically [n]\n",
  "FLATWORM": "a flat-bodied worm [n -S]\n",
  "FLATWORMS": "FLATWORM, a flat-bodied worm [n]\n",
  "FLAUGHT": "(Scots) to cut, pare [v -ED, -ING, -S]\n",
  "FLAUGHTED": "FLAUGHT, (Scots) to cut, pare [v]\n",
  "FLAUGHTER": "(Scots) to cut turfs [v -ED, -ING, -S]\n",
  "FLAUGHTERED": "FLAUGHTER, (Scots) to cut turfs [v]\n",
  "FLAUGHTERING": "FLAUGHTER, (Scots) to cut turfs [v]\n",
  "FLAUGHTERS": "FLAUGHTER, (Scots) to cut turfs [v]\n",
  "FLAUGHTING": "FLAUGHT, (Scots) to cut, pare [v]\n",
  "FLAUGHTS": "FLAUGHT, (Scots) to cut, pare [v]\n",
  "FLAUNCH": "to widen into a flared shape, also FLANCH [v -ED, -ING, -ES]\n",
  "FLAUNCHED": "FLAUNCH, to widen into a flared shape, also FLANCH [v]\n",
  "FLAUNCHES": "FLAUNCH, to widen into a flared shape, also FLANCH [v]\n",
  "FLAUNCHING": "a sloping piece of cement, e.g. round the base of a chimneypot, also FLANCHING [n -S]\n",
  "FLAUNCHINGS": "FLAUNCHING, a sloping piece of cement, e.g. round the base of a chimneypot, also FLANCHING [n]\n",
  "FLAUNE": "(archaic) a sort of flat custard or pie, also FLAMM, FLAN, FLAWN [n -S]\n",
  "FLAUNES": "FLAUNE, (archaic) a sort of flat custard or pie, also FLAMM, FLAN, FLAWN [n]\n",
  "FLAUNT": "to exhibit in a showy manner [v -ED, -ING, -S]\n",
  "FLAUNTED": "FLAUNT, to exhibit in a showy manner [v]\n",
  "FLAUNTER": "one who flaunts [n -S]\n",
  "FLAUNTERS": "FLAUNTER, one who flaunts [n]\n",
  "FLAUNTIER": "FLAUNTY, showy [adj]\n",
  "FLAUNTIEST": "FLAUNTY, showy [adj]\n",
  "FLAUNTILY": "FLAUNTY, showy [adv]\n",
  "FLAUNTINESS": "the state of being flaunty [n -ES]\n",
  "FLAUNTINESSES": "FLAUNTINESS, the state of being flaunty [n]\n",
  "FLAUNTING": "FLAUNT, to exhibit in a showy manner [v]\n",
  "FLAUNTINGLY": "FLAUNTING, FLAUNT, to exhibit in a showy manner [adv]\n",
  "FLAUNTS": "FLAUNT, to exhibit in a showy manner [v]\n",
  "FLAUNTY": "showy [adj FLAUNTIER, FLAUNTIEST, FLAUNTILY]\n",
  "FLAUTA": "(Spanish) a tortilla rolled around a filling of meat and fried [n -S]\n",
  "FLAUTAS": "FLAUTA, (Spanish) a tortilla rolled around a filling of meat and fried [n]\n",
  "FLAUTIST": "one who plays the flute, also FLUTIST, FLUTER [n -S]\n",
  "FLAUTISTS": "FLAUTIST, one who plays the flute, also FLUTIST, FLUTER [n]\n",
  "FLAVA": "(slang) a special style, flavour or feeling [n -S]\n",
  "FLAVANOL": "a derivative of flavone, also FLAVONOL [n -S]\n",
  "FLAVANOLS": "FLAVANOL, a derivative of flavone, also FLAVONOL [n]\n",
  "FLAVANONE": "a colourless crystalline ketone [n -S]\n",
  "FLAVANONES": "FLAVANONE, a colourless crystalline ketone [n]\n",
  "FLAVAS": "FLAVA, (slang) a special style, flavour or feeling [n]\n",
  "FLAVESCENT": "yellowish or turning yellow [adj]\n",
  "FLAVIN": "a yellow dye made from the bark of the dyer's oak, also FLAVINE [n -S]\n",
  "FLAVINE": "a yellow dye made from the bark of the dyer's oak, also FLAVIN [n -S]\n",
  "FLAVINES": "FLAVINE, a yellow dye made from the bark of the dyer's oak, also FLAVIN [n]\n",
  "FLAVINS": "FLAVIN, a yellow dye made from the bark of the dyer's oak, also FLAVINE [n]\n",
  "FLAVIVIRUS": "a virus of the Flaviridae family, which includes the virus responsible for yellow fever [n -ES]\n",
  "FLAVIVIRUSES": "FLAVIVIRUS, a virus of the Flaviridae family, which includes the virus responsible for yellow fever [n]\n",
  "FLAVONE": "a pigment derived from plants such as primrose [n -S]\n",
  "FLAVONES": "FLAVONE, a pigment derived from plants such as primrose [n]\n",
  "FLAVONOID": "a kind of aromatic compound including many common pigments [n -S]\n",
  "FLAVONOIDS": "FLAVONOID, a kind of aromatic compound including many common pigments [n]\n",
  "FLAVONOL": "a derivative of flavone, also FLAVANOL [n -S]\n",
  "FLAVONOLS": "FLAVONOL, a derivative of flavone, also FLAVANOL [n]\n",
  "FLAVOPROTEIN": "a protein which serves as an electron carrier in the electron transfer chain [n -S]\n",
  "FLAVOPROTEINS": "FLAVOPROTEIN, a protein which serves as an electron carrier in the electron transfer chain [n]\n",
  "FLAVOPURPURIN": "a yellow crystalline dye derived from anthraquinone [n -S]\n",
  "FLAVOPURPURINS": "FLAVOPURPURIN, a yellow crystalline dye derived from anthraquinone [n]\n",
  "FLAVOR": "to impart a special taste to, also FLAVOUR [v -ED, -ING, -S]\n",
  "FLAVORED": "FLAVOR, to impart a special taste to, also FLAVOUR [v]\n",
  "FLAVORER": "one that flavors, also FLAVOURER [n -S]\n",
  "FLAVORERS": "FLAVORER, one that flavors, also FLAVOURER [n]\n",
  "FLAVORFUL": "full of flavor, also FLAVOURFUL [adj FLAVORFULLY]\n",
  "FLAVORFULLY": "FLAVORFUL, full of flavor, also FLAVOURFUL [adv]\n",
  "FLAVORIER": "FLAVORY, full of flavor, also FLAVOURY [adj]\n",
  "FLAVORIEST": "FLAVORY, full of flavor, also FLAVOURY [adj]\n",
  "FLAVORING": "something that adds flavor [n -S]\n",
  "FLAVORINGS": "FLAVORING, something that adds flavor [n]\n",
  "FLAVORIST": "a person who creates flavourings for drinks, perfumes, etc., also FLAVOURIST [n -S]\n",
  "FLAVORISTS": "FLAVORIST, a person who creates flavourings for drinks, perfumes, etc., also FLAVOURIST [n]\n",
  "FLAVORLESS": "without flavor, also FLAVOURLESS [adj]\n",
  "FLAVOROUS": "full of flavor [adj]\n",
  "FLAVORS": "FLAVOR, to impart a special taste to, also FLAVOUR [v]\n",
  "FLAVORSOME": "full of flavor, also FLAVOURSOME [adj]\n",
  "FLAVORY": "full of flavor, also FLAVOURY [adj FLAVORIER, FLAVORIEST]\n",
  "FLAVOUR": "to impart a special taste to, also FLAVOR [v -ED, -ING, -S]\n",
  "FLAVOURDYNAMICS": "as in quantum flavourdynamics, a mathematical model used to describe the interaction of flavored particles (weak force) through the exchange of intermediate vector bosons [n]\n",
  "FLAVOURED": "FLAVOUR, to impart a special taste to, also FLAVOR [v]\n",
  "FLAVOURER": "one who flavours, also FLAVORER [n -S]\n",
  "FLAVOURERS": "FLAVOURER, one who flavours, also FLAVORER [n]\n",
  "FLAVOURFUL": "full of flavour, also FLAVORFUL [adj FLAVOURFULLY]\n",
  "FLAVOURFULLY": "FLAVOURFUL, full of flavour, also FLAVORFUL [adv]\n",
  "FLAVOURIER": "FLAVOURY, full of flavour, also FLAVORY [adj]\n",
  "FLAVOURIEST": "FLAVOURY, full of flavour, also FLAVORY [adj]\n",
  "FLAVOURING": "something that adds flavour [n -S]\n",
  "FLAVOURINGS": "FLAVOURING, something that adds flavour [n]\n",
  "FLAVOURIST": "a person who creates flavourings for drinks, perfumes, etc., also FLAVORIST [n -S]\n",
  "FLAVOURISTS": "FLAVOURIST, a person who creates flavourings for drinks, perfumes, etc., also FLAVORIST [n]\n",
  "FLAVOURLESS": "without flavour, also FLAVORLESS [adj]\n",
  "FLAVOURS": "FLAVOUR, to impart a special taste to, also FLAVOR [v]\n",
  "FLAVOURSOME": "full of flavour, also FLAVORSOME [adj]\n",
  "FLAVOURY": "full of flavour, also FLAVORY [adj FLAVOURIER, FLAVOURIEST]\n",
  "FLAW": "to make defective or imperfect [v -ED, -ING, -S]\n",
  "FLAWED": "FLAW, to make defective or imperfect [v]\n",
  "FLAWIER": "FLAWY, full of flaws [adj]\n",
  "FLAWIEST": "FLAWY, full of flaws [adj]\n",
  "FLAWING": "FLAW, to make defective or imperfect [v]\n",
  "FLAWLESS": "without flaws [adj FLAWLESSLY]\n",
  "FLAWLESSLY": "FLAWLESS, without flaws [adv]\n",
  "FLAWLESSNESS": "the state of being flawless [n -ES]\n",
  "FLAWLESSNESSES": "FLAWLESSNESS, the state of being flawless [n]\n",
  "FLAWN": "(archaic) a custard, also FLAMM, FLAN, FLAUNE [n -S]\n",
  "FLAWNS": "FLAWN, (archaic) a custard, also FLAMM, FLAN, FLAUNE [n]\n",
  "FLAWS": "FLAW, to make defective or imperfect [v]\n",
  "FLAWY": "full of flaws [adj FLAWIER, FLAWIEST]\n",
  "FLAX": "the fibres of the plant linum [n -ES]\n",
  "FLAXEN": "pale yellow [adj]\n",
  "FLAXES": "FLAX, the fibres of the plant linum [n]\n",
  "FLAXIER": "FLAXY, like flax; of a light colour [adj]\n",
  "FLAXIEST": "FLAXY, like flax; of a light colour [adj]\n",
  "FLAXLIKE": "like flax [adj]\n",
  "FLAXSEED": "the seed of flax [n -S]\n",
  "FLAXSEEDS": "FLAXSEED, the seed of flax [n]\n",
  "FLAXY": "like flax; of a light colour [adj FLAXIER, FLAXIEST]\n",
  "FLAY": "to strip off skin or hide [v -ED, -ING, -S]\n",
  "FLAYED": "FLAY, to strip off skin or hide [v]\n",
  "FLAYER": "one who flays [n -S]\n",
  "FLAYERS": "FLAYER, one who flays [n]\n",
  "FLAYING": "FLAY, to strip off skin or hide [v]\n",
  "FLAYS": "FLAY, to strip off skin or hide [v]\n",
  "FLAYSOME": "(dialect) frightening [adj]\n",
  "FLEA": "any of an order of wingless, very agile, parasitic, bloodsucking insects [n -S]\n",
  "FLEABAG": "an inferior hotel [n -S]\n",
  "FLEABAGS": "FLEABAG, an inferior hotel [n]\n",
  "FLEABANE": "a flowering plant supposed to repel fleas [n -S]\n",
  "FLEABANES": "FLEABANE, a flowering plant supposed to repel fleas [n]\n",
  "FLEABITE": "the bite of a flea [n -S]\n",
  "FLEABITES": "FLEABITE, the bite of a flea [n]\n",
  "FLEADH": "(Irish) a festival of Irish traditional music, dancing, etc. [n -S]\n",
  "FLEADHS": "FLEADH, (Irish) a festival of Irish traditional music, dancing, etc. [n]\n",
  "FLEAHOPPER": "any of various small jumping bugs that feed on certain plants [n -S]\n",
  "FLEAHOPPERS": "FLEAHOPPER, any of various small jumping bugs that feed on certain plants [n]\n",
  "FLEAM": "a lancet for bleeding horses [n -S]\n",
  "FLEAMS": "FLEAM, a lancet for bleeding horses [n]\n",
  "FLEAPIT": "(slang) a low-class cinema [n -S]\n",
  "FLEAPITS": "FLEAPIT, (slang) a low-class cinema [n]\n",
  "FLEAS": "FLEA, any of an order of wingless, very agile, parasitic, bloodsucking insects [n]\n",
  "FLEASOME": "full of fleas [adj]\n",
  "FLEAWORT": "a herb, formerly believed to destroy fleas [n -S]\n",
  "FLEAWORTS": "FLEAWORT, a herb, formerly believed to destroy fleas [n]\n",
  "FLECHE": "(French) a slender spire, usually of wood and rising from a roof [n -S]\n",
  "FLECHES": "FLECHE, (French) a slender spire, usually of wood and rising from a roof [n]\n",
  "FLECHETTE": "(French) a steel dart dropped from an aeroplane or fired from a gun [n -S]\n",
  "FLECHETTES": "FLECHETTE, (French) a steel dart dropped from an aeroplane or fired from a gun [n]\n",
  "FLECK": "to mark with tiny streaks or spots [v -ED, -ING, -S]\n",
  "FLECKED": "FLECK, to mark with tiny streaks or spots [v]\n",
  "FLECKER": "to mark with spots [v -ED, -ING, -S]\n",
  "FLECKERED": "FLECKER, to mark with spots [v]\n",
  "FLECKERING": "FLECKER, to mark with spots [v]\n",
  "FLECKERS": "FLECKER, to mark with spots [v]\n",
  "FLECKIER": "FLECKY, flecked [adj]\n",
  "FLECKIEST": "FLECKY, flecked [adj]\n",
  "FLECKING": "FLECK, to mark with tiny streaks or spots [v]\n",
  "FLECKLESS": "without spot or blame [adj]\n",
  "FLECKS": "FLECK, to mark with tiny streaks or spots [v]\n",
  "FLECKY": "flecked [adj FLECKIER, FLECKIEST]\n",
  "FLECTION": "a bend or a fold [n -S]\n",
  "FLECTIONAL": "relating to flection, the act of bending, or state of being bent [adj]\n",
  "FLECTIONLESS": "without flection, also FLEXIONLESS [adj]\n",
  "FLECTIONS": "FLECTION, a bend or a fold [n]\n",
  "FLED": "FLEE, to run away [v]\n",
  "FLEDGE": "to furnish with feathers [v FLEDGED, FLEDGING, FLEDGES]\n",
  "FLEDGED": "FLEDGE, to furnish with feathers [v]\n",
  "FLEDGELING": "a young bird just fledged, also FLEDGLING [n -S]\n",
  "FLEDGELINGS": "FLEDGELING, a young bird just fledged, also FLEDGLING [n]\n",
  "FLEDGES": "FLEDGE, to furnish with feathers [v]\n",
  "FLEDGIER": "FLEDGY, covered with feathers [adj]\n",
  "FLEDGIEST": "FLEDGY, covered with feathers [adj]\n",
  "FLEDGING": "FLEDGE, to furnish with feathers [v]\n",
  "FLEDGLING": "a young bird just fledged, also FLEDGELING [n -S]\n",
  "FLEDGLINGS": "FLEDGLING, a young bird just fledged, also FLEDGELING [n]\n",
  "FLEDGY": "covered with feathers [adj FLEDGIER, FLEDGIEST]\n",
  "FLEE": "to run away [v FLED, FLEEING, FLEES]\n",
  "FLEECE": "to remove the wool of a sheep [v FLEECED, FLEECING, FLEECES]\n",
  "FLEECED": "FLEECE, to remove the wool of a sheep [v]\n",
  "FLEECELESS": "without a fleece [adj]\n",
  "FLEECER": "a machine that fleeces [n -S]\n",
  "FLEECERS": "FLEECER, a machine that fleeces [n]\n",
  "FLEECES": "FLEECE, to remove the wool of a sheep [v]\n",
  "FLEECH": "(Scots) to flatter, coax, beg [v -ED, -ING, -ES]\n",
  "FLEECHED": "FLEECH, (Scots) to flatter, coax, beg [v]\n",
  "FLEECHES": "FLEECH, (Scots) to flatter, coax, beg [v]\n",
  "FLEECHING": "flattery, coaxing [n -S]\n",
  "FLEECHINGS": "FLEECHING, flattery, coaxing [n]\n",
  "FLEECHMENT": "(Scots) flattery [n -S]\n",
  "FLEECHMENTS": "FLEECHMENT, (Scots) flattery [n]\n",
  "FLEECIE": "(New Zealand) someone who collects fleeces in a shearing shed [n -S]\n",
  "FLEECIER": "FLEECY, like a fleece [adj]\n",
  "FLEECIES": "FLEECIE, (New Zealand) someone who collects fleeces in a shearing shed [n]\n",
  "FLEECIEST": "FLEECY, like a fleece [adj]\n",
  "FLEECILY": "FLEECY, like a fleece [adv]\n",
  "FLEECINESS": "the state of being fleecy [n -ES]\n",
  "FLEECINESSES": "FLEECINESS, the state of being fleecy [n]\n",
  "FLEECING": "FLEECE, to remove the wool of a sheep [v]\n",
  "FLEECY": "like a fleece [adj FLEECIER, FLEECIEST, FLEECILY]\n",
  "FLEEING": "FLEE, to run away [v]\n",
  "FLEEK": "stylishness, as in on fleek, stylish, chic [n -S]\n",
  "FLEEKS": "FLEEK, stylishness, as in on fleek, stylish, chic [n]\n",
  "FLEER": "to deride by making a face [v -ED, -ING, -S]\n",
  "FLEERED": "FLEER, to deride by making a face [v]\n",
  "FLEERER": "someone who fleers [n -S]\n",
  "FLEERERS": "FLEERER, someone who fleers [n]\n",
  "FLEERING": "sneering, jeering [adj FLEERINGLY] / the act of fleering [n -S]\n",
  "FLEERINGLY": "FLEERING, sneering, jeering [adv]\n",
  "FLEERINGS": "FLEERING, the act of fleering [n]\n",
  "FLEERS": "FLEER, to deride by making a face [v]\n",
  "FLEES": "FLEE, to run away [v]\n",
  "FLEET": "swift, also FLITT [adj FLEETER, FLEETEST, FLEETLY] / to move swiftly [v -ED, -ING, -S]\n",
  "FLEETED": "FLEET, to move swiftly [v]\n",
  "FLEETER": "a person who sails with a fleet of ships, esp those who sailed as colonists to Australia with the early fleets [n -S]\n",
  "FLEETERS": "FLEETER, a person who sails with a fleet of ships, esp those who sailed as colonists to Australia with the early fleets [n]\n",
  "FLEETEST": "FLEET, swift, also FLITT [adj]\n",
  "FLEETING": "moving swiftly, transient [adj FLEETINGLY]\n",
  "FLEETINGLY": "FLEETING, moving swiftly, transient [adv]\n",
  "FLEETINGNESS": "the state of being fleeting [n -ES]\n",
  "FLEETINGNESSES": "FLEETINGNESS, the state of being fleeting [n]\n",
  "FLEETLY": "FLEET, swift, also FLITT [adv]\n",
  "FLEETNESS": "the quality of being fleet [n -ES]\n",
  "FLEETNESSES": "FLEETNESS, the quality of being fleet [n]\n",
  "FLEETS": "FLEET, to move swiftly [v]\n",
  "FLEG": "(Scots) to frighten, also FLEY [v FLEGGED, FLEGGING, FLEGS]\n",
  "FLEGGED": "FLEG, (Scots) to frighten, also FLEY [v]\n",
  "FLEGGING": "FLEG, (Scots) to frighten, also FLEY [v]\n",
  "FLEGS": "FLEG, (Scots) to frighten, also FLEY [v]\n",
  "FLEHMEN": "of a mammal, to grimace with lips drawn back [v -ED, -ING, -S]\n",
  "FLEHMENED": "FLEHMEN, of a mammal, to grimace with lips drawn back [v]\n",
  "FLEHMENING": "FLEHMEN, of a mammal, to grimace with lips drawn back [v]\n",
  "FLEHMENS": "FLEHMEN, of a mammal, to grimace with lips drawn back [v]\n",
  "FLEISHIG": "(Yiddish) made of meat or meat products, also FLEISHIK [adj]\n",
  "FLEISHIK": "(Yiddish) made of meat or meat products, also FLEISHIG [adj]\n",
  "FLEME": "(Scots) to put to flight [v FLEMED, FLEMIT, FLEMING, FLEMES]\n",
  "FLEMED": "FLEME, (Scots) to put to flight [v]\n",
  "FLEMES": "FLEME, (Scots) to put to flight [v]\n",
  "FLEMING": "FLEME, (Scots) to put to flight [v]\n",
  "FLEMISH": "to coil a rope in a certain way [v -ED, -ING, -ES]\n",
  "FLEMISHED": "FLEMISH, to coil a rope in a certain way [v]\n",
  "FLEMISHES": "FLEMISH, to coil a rope in a certain way [v]\n",
  "FLEMISHING": "FLEMISH, to coil a rope in a certain way [v]\n",
  "FLEMIT": "FLEME, (Scots) to put to flight [v]\n",
  "FLENCH": "to strip the blubber or skin from, also FLENSE [v -ED, -ING, -ES]\n",
  "FLENCHED": "FLENCH, to strip the blubber or skin from, also FLENSE [v]\n",
  "FLENCHER": "one who flenches, also FLENSER [n -S]\n",
  "FLENCHERS": "FLENCHER, one who flenches, also FLENSER [n]\n",
  "FLENCHES": "FLENCH, to strip the blubber or skin from, also FLENSE [v]\n",
  "FLENCHING": "FLENCH, to strip the blubber or skin from, also FLENSE [v]\n",
  "FLENSE": "to strip the blubber or skin from, also FLENCH [v FLENSED, FLENSING, FLENSES]\n",
  "FLENSED": "FLENSE, to strip the blubber or skin from, also FLENCH [v]\n",
  "FLENSER": "one that flenses, also FLENCHER [n -S]\n",
  "FLENSERS": "FLENSER, one that flenses, also FLENCHER [n]\n",
  "FLENSES": "FLENSE, to strip the blubber or skin from, also FLENCH [v]\n",
  "FLENSING": "FLENSE, to strip the blubber or skin from, also FLENCH [v]\n",
  "FLEROVIUM": "an artificially produced radioactive transuranic element [n -S]\n",
  "FLEROVIUMS": "FLEROVIUM, an artificially produced radioactive transuranic element [n]\n",
  "FLESH": "to scrape soft body tissue from [v -ED, -ING, -ES]\n",
  "FLESHED": "FLESH, to scrape soft body tissue from [v]\n",
  "FLESHER": "an instrument for scraping hides [n -S]\n",
  "FLESHERS": "FLESHER, an instrument for scraping hides [n]\n",
  "FLESHES": "FLESH, to scrape soft body tissue from [v]\n",
  "FLESHHOOD": "the state of being in the flesh [n -S]\n",
  "FLESHHOODS": "FLESHHOOD, the state of being in the flesh [n]\n",
  "FLESHIER": "FLESHY, having much flesh [adj]\n",
  "FLESHIEST": "FLESHY, having much flesh [adj]\n",
  "FLESHILY": "FLESHY, having much flesh [adv]\n",
  "FLESHINESS": "the state of being fleshy [n -ES]\n",
  "FLESHINESSES": "FLESHINESS, the state of being fleshy [n]\n",
  "FLESHING": "the distribution of the lean and fat on animals [n -S]\n",
  "FLESHINGS": "FLESHING, the distribution of the lean and fat on animals [n]\n",
  "FLESHLESS": "without flesh; lean [adj]\n",
  "FLESHLIER": "FLESHLY, pertaining to the body [adj]\n",
  "FLESHLIEST": "FLESHLY, pertaining to the body [adj]\n",
  "FLESHLINESS": "the state of being fleshly [n -ES]\n",
  "FLESHLINESSES": "FLESHLINESS, the state of being fleshly [n]\n",
  "FLESHLING": "a sensualist [n -S]\n",
  "FLESHLINGS": "FLESHLING, a sensualist [n]\n",
  "FLESHLY": "pertaining to the body [adj FLESHLIER, FLESHLIEST]\n",
  "FLESHMENT": "(Shakespeare) the act of fleshing, or the excitement attending a successful beginning [n -S]\n",
  "FLESHMENTS": "FLESHMENT, (Shakespeare) the act of fleshing, or the excitement attending a successful beginning [n]\n",
  "FLESHMONGER": "a whoremonger; a procurer [n -S]\n",
  "FLESHMONGERS": "FLESHMONGER, a whoremonger; a procurer [n]\n",
  "FLESHPOT": "a pot for cooking meat [n -S]\n",
  "FLESHPOTS": "FLESHPOT, a pot for cooking meat [n]\n",
  "FLESHWORM": "(archaic) a worm or maggot that feeds on flesh [n -S]\n",
  "FLESHWORMS": "FLESHWORM, (archaic) a worm or maggot that feeds on flesh [n]\n",
  "FLESHY": "having much flesh [adj FLESHIER, FLESHIEST, FLESHILY]\n",
  "FLETCH": "to provide (an arrow) with feathers for flight [v -ED, -ING, -ES]\n",
  "FLETCHED": "FLETCH, to provide (an arrow) with feathers for flight [v]\n",
  "FLETCHER": "one who makes arrows [n -S]\n",
  "FLETCHERS": "FLETCHER, one who makes arrows [n]\n",
  "FLETCHES": "FLETCH, to provide (an arrow) with feathers for flight [v]\n",
  "FLETCHING": "the feathers of an arrow [n -S]\n",
  "FLETCHINGS": "FLETCHING, the feathers of an arrow [n]\n",
  "FLETTON": "a type of brick made near Fletton in Cambridgeshire, of a mottled yellow and pink colour [n -S]\n",
  "FLETTONS": "FLETTON, a type of brick made near Fletton in Cambridgeshire, of a mottled yellow and pink colour [n]\n",
  "FLEUR": "(French) a flower [n -S]\n",
  "FLEURET": "(French) an ornament in the shape of a small flower, also FLEURETTE [n -S]\n",
  "FLEURETS": "FLEURET, (French) an ornament in the shape of a small flower, also FLEURETTE [n]\n",
  "FLEURETTE": "(French) an ornament in the shape of a small flower, also FLEURET [n -S]\n",
  "FLEURETTES": "FLEURETTE, (French) an ornament in the shape of a small flower, also FLEURET [n]\n",
  "FLEURON": "(French) a decorative pastry motif [n -S]\n",
  "FLEURONS": "FLEURON, (French) a decorative pastry motif [n]\n",
  "FLEURS": "FLEUR, (French) a flower [n]\n",
  "FLEURY": "decorated with fleurs-de-lis [adj]\n",
  "FLEW": "the floppy upper lip of dogs such as bloodhounds [n -S]\n",
  "FLEWED": "(Shakespeare) furnished with hanging lips, as hounds are [adj]\n",
  "FLEWS": "FLEW, the floppy upper lip of dogs such as bloodhounds [n]\n",
  "FLEX": "to bend [v -ED, -ING, -ES]\n",
  "FLEXAGON": "a folded paper construction [n -S]\n",
  "FLEXAGONS": "FLEXAGON, a folded paper construction [n]\n",
  "FLEXECUTIVE": "a professional whose use of information technology allows them to be flexible in where and when they work [n -S]\n",
  "FLEXECUTIVES": "FLEXECUTIVE, a professional whose use of information technology allows them to be flexible in where and when they work [n]\n",
  "FLEXED": "FLEX, to bend [v]\n",
  "FLEXES": "FLEX, to bend [v]\n",
  "FLEXI": "(short for) flexitime [n -S]\n",
  "FLEXIBILITIES": "FLEXIBILITY, the state of being flexible [n]\n",
  "FLEXIBILITY": "the state of being flexible [n FLEXIBILITIES]\n",
  "FLEXIBLE": "able to be bent [adj FLEXIBLY]\n",
  "FLEXIBLENESS": "the state of being flexible [n -ES]\n",
  "FLEXIBLENESSES": "FLEXIBLENESS, the state of being flexible [n]\n",
  "FLEXIBLY": "FLEXIBLE, able to be bent [adv]\n",
  "FLEXICURITIES": "FLEXICURITY, labor practices that give companies the flexibility to fire workers as needed and offer fired workers the security of government-backed benefits and retraining opportunities [n]\n",
  "FLEXICURITY": "labor practices that give companies the flexibility to fire workers as needed and offer fired workers the security of government-backed benefits and retraining opportunities [n FLEXICURITIES]\n",
  "FLEXIHOURS": "flexible working time [n]\n",
  "FLEXILE": "flexible [adj]\n",
  "FLEXING": "FLEX, to bend [v]\n",
  "FLEXION": "the act of bending, or state of being bent, also FLECTION [n -S]\n",
  "FLEXIONAL": "relating to flexion, a bend, a fold [adj]\n",
  "FLEXIONLESS": "without flexion, also FLECTIONLESS [adj]\n",
  "FLEXIONS": "FLEXION, the act of bending, or state of being bent, also FLECTION [n]\n",
  "FLEXIS": "FLEXI, (short for) flexitime [n]\n",
  "FLEXITARIAN": "a vegetarian who is less than strict about what he or she eats [n -S]\n",
  "FLEXITARIANISM": "a semi-vegetarian diet involving the practice of eating mainly vegetarian food but making occasional exceptions for e.g. social reasons [n -S]\n",
  "FLEXITARIANISMS": "FLEXITARIANISM, a semi-vegetarian diet involving the practice of eating mainly vegetarian food but making occasional exceptions for e.g. social reasons [n]\n",
  "FLEXITARIANS": "FLEXITARIAN, a vegetarian who is less than strict about what he or she eats [n]\n",
  "FLEXITIME": "a system that allows flexible working hours, also FLEXTIME [n -S]\n",
  "FLEXITIMES": "FLEXITIME, a system that allows flexible working hours, also FLEXTIME [n]\n",
  "FLEXO": "a method of rotary letterpress printing, also FLEXOGRAPHY [n -S]\n",
  "FLEXOGRAPHIC": "relating to flexography [adj]\n",
  "FLEXOGRAPHIES": "FLEXOGRAPHY, a method of rotary letterpress printing using a resilient printing plate and solvent-based ink, used characteristically for printing on metal foil or plastic [n]\n",
  "FLEXOGRAPHY": "a method of rotary letterpress printing using a resilient printing plate and solvent-based ink, used characteristically for printing on metal foil or plastic [n FLEXOGRAPHIES]\n",
  "FLEXOR": "a muscle that bends part of the body [n -S]\n",
  "FLEXORS": "FLEXOR, a muscle that bends part of the body [n]\n",
  "FLEXOS": "FLEXO, a method of rotary letterpress printing, also FLEXOGRAPHY [n]\n",
  "FLEXTIME": "a system that allows flexible working hours, also FLEXITIME [n -S]\n",
  "FLEXTIMER": "one who works flextime [n -S]\n",
  "FLEXTIMERS": "FLEXTIMER, one who works flextime [n]\n",
  "FLEXTIMES": "FLEXTIME, a system that allows flexible working hours, also FLEXITIME [n]\n",
  "FLEXUOSE": "full of windings and turnings, also FLEXUOUS [adj]\n",
  "FLEXUOUS": "full of windings and turnings, also FLEXUOSE [adj FLEXUOUSLY]\n",
  "FLEXUOUSLY": "FLEXUOUS, full of windings and turnings, also FLEXUOSE [adv]\n",
  "FLEXURAL": "of, pertaining to, or resulting from, flexure [adj]\n",
  "FLEXURE": "the act of bending [n -S]\n",
  "FLEXURES": "FLEXURE, the act of bending [n]\n",
  "FLEXWING": "a collapsible fabric wing used in hang gliding [n -S]\n",
  "FLEXWINGS": "FLEXWING, a collapsible fabric wing used in hang gliding [n]\n",
  "FLEY": "(Scots) to frighten, also FLEG [v -ED, -ING, -S]\n",
  "FLEYED": "FLEY, (Scots) to frighten, also FLEG [v]\n",
  "FLEYING": "FLEY, (Scots) to frighten, also FLEG [v]\n",
  "FLEYS": "FLEY, (Scots) to frighten, also FLEG [v]\n",
  "FLIBBERT": "(dialect) a small piece [n -S]\n",
  "FLIBBERTIGIBBET": "a gossipy or flighty person [n]\n",
  "FLIBBERTS": "FLIBBERT, (dialect) a small piece [n]\n",
  "FLIC": "(French) slang for a French policeman [n -S]\n",
  "FLICHTER": "(Scots) to flutter and quiver [v -ED, -ING, -S]\n",
  "FLICHTERED": "FLICHTER, (Scots) to flutter and quiver [v]\n",
  "FLICHTERING": "FLICHTER, (Scots) to flutter and quiver [v]\n",
  "FLICHTERS": "FLICHTER, (Scots) to flutter and quiver [v]\n",
  "FLICK": "to strike lightly with a fingernail [v -ED, -ING, -S]\n",
  "FLICKABLE": "that can be flicked [adj]\n",
  "FLICKED": "FLICK, to strike lightly with a fingernail [v]\n",
  "FLICKER": "to burn unsteadily, as of a flame [v -ED, -ING, -S]\n",
  "FLICKERED": "FLICKER, to burn unsteadily, as of a flame [v]\n",
  "FLICKERIER": "FLICKERY, given to flickering [adj]\n",
  "FLICKERIEST": "FLICKERY, given to flickering [adj]\n",
  "FLICKERING": "FLICKER, to burn unsteadily, as of a flame [v]\n",
  "FLICKERINGLY": "FLICKERING, FLICKER, to burn unsteadily, as of a flame [adv]\n",
  "FLICKERS": "FLICKER, to burn unsteadily, as of a flame [v]\n",
  "FLICKERTAIL": "in North America, a ground-squirrel [n -S]\n",
  "FLICKERTAILS": "FLICKERTAIL, in North America, a ground-squirrel [n]\n",
  "FLICKERY": "given to flickering [adj FLICKERIER, FLICKERIEST]\n",
  "FLICKING": "FLICK, to strike lightly with a fingernail [v]\n",
  "FLICKS": "FLICK, to strike lightly with a fingernail [v]\n",
  "FLICS": "FLIC, (French) slang for a French policeman [n]\n",
  "FLIED": "FLY, to move through the air [v]\n",
  "FLIER": "one that flies, also FLYER [n -S]\n",
  "FLIERS": "FLIER, one that flies, also FLYER [n]\n",
  "FLIES": "FLY, to move through the air [v]\n",
  "FLIEST": "FLY, shrewd, knowing [adj]\n",
  "FLIGHT": "to migrate in a flock [v -ED, -ING, -S]\n",
  "FLIGHTED": "FLIGHT, to migrate in a flock [v]\n",
  "FLIGHTIER": "FLIGHTY, fickle [adj]\n",
  "FLIGHTIEST": "FLIGHTY, fickle [adj]\n",
  "FLIGHTILY": "FLIGHTY, fickle [adv]\n",
  "FLIGHTINESS": "the state of being flighty [n -ES]\n",
  "FLIGHTINESSES": "FLIGHTINESS, the state of being flighty [n]\n",
  "FLIGHTING": "FLIGHT, to migrate in a flock [v]\n",
  "FLIGHTLESS": "without flight [adj]\n",
  "FLIGHTS": "FLIGHT, to migrate in a flock [v]\n",
  "FLIGHTY": "fickle [adj FLIGHTIER, FLIGHTIEST, FLIGHTILY]\n",
  "FLIM": "(dialect) a five pound note [n -S]\n",
  "FLIMFLAM": "to engage in confidence trickery [v FLIMFLAMMED, FLIMFLAMMING, FLIMFLAMS]\n",
  "FLIMFLAMMED": "FLIMFLAM, to engage in confidence trickery [v]\n",
  "FLIMFLAMMER": "one who engages in flimflam [n -S]\n",
  "FLIMFLAMMERIES": "FLIMFLAMMERY, the act of engaging in flimflam [n]\n",
  "FLIMFLAMMERS": "FLIMFLAMMER, one who engages in flimflam [n]\n",
  "FLIMFLAMMERY": "the act of engaging in flimflam [n FLIMFLAMMERIES]\n",
  "FLIMFLAMMING": "FLIMFLAM, to engage in confidence trickery [v]\n",
  "FLIMFLAMS": "FLIMFLAM, to engage in confidence trickery [v]\n",
  "FLIMP": "to rob while diverted by an accomplice [v -ED, -ING, -S]\n",
  "FLIMPED": "FLIMP, to rob while diverted by an accomplice [v]\n",
  "FLIMPING": "FLIMP, to rob while diverted by an accomplice [v]\n",
  "FLIMPS": "FLIMP, to rob while diverted by an accomplice [v]\n",
  "FLIMS": "FLIM, (dialect) a five pound note [n]\n",
  "FLIMSIER": "FLIMSY, lacking strength [adj]\n",
  "FLIMSIES": "FLIMSY, a thin paper [n]\n",
  "FLIMSIEST": "FLIMSY, lacking strength [adj]\n",
  "FLIMSILY": "FLIMSY, lacking strength [adv]\n",
  "FLIMSINESS": "the state of being flimsy [n -ES]\n",
  "FLIMSINESSES": "FLIMSINESS, the state of being flimsy [n]\n",
  "FLIMSY": "a thin paper [n FLIMSIES] / lacking strength [adj FLIMSIER, FLIMSIEST, FLIMSILY]\n",
  "FLINCH": "to shrink back involuntarily [v -ED, -ING, -ES]\n",
  "FLINCHED": "FLINCH, to shrink back involuntarily [v]\n",
  "FLINCHER": "one who flinches [n -S]\n",
  "FLINCHERS": "FLINCHER, one who flinches [n]\n",
  "FLINCHES": "FLINCH, to shrink back involuntarily [v]\n",
  "FLINCHING": "shrinking [adj FLINCHINGLY] / the act of flinching [n -S]\n",
  "FLINCHINGLY": "FLINCHING, shrinking [adv]\n",
  "FLINCHINGS": "FLINCHING, the act of flinching [n]\n",
  "FLINDER": "to break to pieces [v -ED, -ING, -S]\n",
  "FLINDERED": "FLINDER, to break to pieces [v]\n",
  "FLINDERING": "FLINDER, to break to pieces [v]\n",
  "FLINDERS": "FLINDER, to break to pieces [v]\n",
  "FLINDERSIA": "any tree of the Australian genus Flindersia [n -S]\n",
  "FLINDERSIAS": "FLINDERSIA, any tree of the Australian genus Flindersia [n]\n",
  "FLING": "to throw with force [v FLUNG, FLINGING, FLINGS]\n",
  "FLINGER": "one who flings; one who jeers [n -S]\n",
  "FLINGERS": "FLINGER, one who flings; one who jeers [n]\n",
  "FLINGING": "FLING, to throw with force [v]\n",
  "FLINGS": "FLING, to throw with force [v]\n",
  "FLINKITE": "a brownish-green mineral, manganese arsenate [n -S]\n",
  "FLINKITES": "FLINKITE, a brownish-green mineral, manganese arsenate [n]\n",
  "FLINT": "to provide with a spark-producing rock [v -ED, -ING, -S]\n",
  "FLINTED": "FLINT, to provide with a spark-producing rock [v]\n",
  "FLINTHEAD": "an American wading bird, aka crested ibis [n -S]\n",
  "FLINTHEADS": "FLINTHEAD, an American wading bird, aka crested ibis [n]\n",
  "FLINTIER": "FLINTY, resembling flint [adj]\n",
  "FLINTIEST": "FLINTY, resembling flint [adj]\n",
  "FLINTIFIED": "FLINTIFY, to turn into flint [v]\n",
  "FLINTIFIES": "FLINTIFY, to turn into flint [v]\n",
  "FLINTIFY": "to turn into flint [v FLINTIFIED, FLINTIFYING, FLINTIFIES]\n",
  "FLINTIFYING": "FLINTIFY, to turn into flint [v]\n",
  "FLINTILY": "FLINTY, resembling flint [adv]\n",
  "FLINTINESS": "the state of being flinty [n -ES]\n",
  "FLINTINESSES": "FLINTINESS, the state of being flinty [n]\n",
  "FLINTING": "FLINT, to provide with a spark-producing rock [v]\n",
  "FLINTLIKE": "like flint [adj]\n",
  "FLINTLOCK": "an old-fashioned gun with spark provided by a hammer striking a flint [n -S]\n",
  "FLINTLOCKS": "FLINTLOCK, an old-fashioned gun with spark provided by a hammer striking a flint [n]\n",
  "FLINTS": "FLINT, to provide with a spark-producing rock [v]\n",
  "FLINTY": "resembling flint [adj FLINTIER, FLINTIEST, FLINTILY]\n",
  "FLIP": "to spin in the air [v FLIPPED, FLIPPING, FLIPS] / flippant [adj FLIPPER, FLIPPEST]\n",
  "FLIPBOARD": "a piece of office equipment consisting of a board to which a flip chart or some other pad can be attached [n -S]\n",
  "FLIPBOARDS": "FLIPBOARD, a piece of office equipment consisting of a board to which a flip chart or some other pad can be attached [n]\n",
  "FLIPBOOK": "a book of a series of images that when flipped give the illusion of movement [n -S]\n",
  "FLIPBOOKS": "FLIPBOOK, a book of a series of images that when flipped give the illusion of movement [n]\n",
  "FLIPCHART": "a pad, containing large sheets of paper that can be easily turned over, mounted on a stand and used to present reports, data, etc. [n -S]\n",
  "FLIPCHARTS": "FLIPCHART, a pad, containing large sheets of paper that can be easily turned over, mounted on a stand and used to present reports, data, etc. [n]\n",
  "FLIPFLOP": "to perform a backward somersault [v FLIPFLOPPED, FLIPFLOPPING, FLIPFLOPS]\n",
  "FLIPFLOPPED": "FLIPFLOP, to perform a backward somersault [v]\n",
  "FLIPFLOPPING": "FLIPFLOP, to perform a backward somersault [v]\n",
  "FLIPFLOPS": "FLIPFLOP, to perform a backward somersault [v]\n",
  "FLIPPANCIES": "FLIPPANCY, the state of being flippant [n]\n",
  "FLIPPANCY": "the state of being flippant [n FLIPPANCIES]\n",
  "FLIPPANT": "lacking proper respect or seriousness [adj FLIPPANTLY]\n",
  "FLIPPANTLY": "FLIPPANT, lacking proper respect or seriousness [adv]\n",
  "FLIPPANTNESS": "the state of being flippant [n -ES]\n",
  "FLIPPANTNESSES": "FLIPPANTNESS, the state of being flippant [n]\n",
  "FLIPPED": "FLIP, to spin in the air [v]\n",
  "FLIPPER": "a flat limb for swimming e.g. turtle or penguin [n -S]\n",
  "FLIPPERS": "FLIPPER, a flat limb for swimming e.g. turtle or penguin [n]\n",
  "FLIPPEST": "FLIP, flippant [adj]\n",
  "FLIPPIER": "FLIPPY, flaring at the bottom [adj]\n",
  "FLIPPIEST": "FLIPPY, flaring at the bottom [adj]\n",
  "FLIPPING": "the act of throwing with a brisk motion [n -S]\n",
  "FLIPPINGS": "FLIPPING, the act of throwing with a brisk motion [n]\n",
  "FLIPPY": "flaring at the bottom [adj FLIPPIER, FLIPPIEST]\n",
  "FLIPS": "FLIP, to spin in the air [v]\n",
  "FLIPSIDE": "the reverse of something; a less familiar aspect of anything [n -S]\n",
  "FLIPSIDES": "FLIPSIDE, the reverse of something; a less familiar aspect of anything [n]\n",
  "FLIR": "forward looking infrared radar, an electronic heat sensor able to detect and display on a TV.-like screen a distant scene despite darkness, smoke etc. used esp. in military aircraft [n -S]\n",
  "FLIRS": "FLIR, forward looking infrared radar, an electronic heat sensor able to detect and display on a TV.-like screen a distant scene despite darkness, smoke etc. used esp. in military aircraft [n]\n",
  "FLIRT": "to engage in amorous banter [v -ED, -ING, -S]\n",
  "FLIRTATION": "the act of flirting [n -S]\n",
  "FLIRTATIONS": "FLIRTATION, the act of flirting [n]\n",
  "FLIRTATIOUS": "given to flirting [adj FLIRTATIOUSLY]\n",
  "FLIRTATIOUSLY": "FLIRTATIOUS, given to flirting [adv]\n",
  "FLIRTATIOUSNESS": "FLIRTATIOUS, given to flirting [n]\n",
  "FLIRTED": "FLIRT, to engage in amorous banter [v]\n",
  "FLIRTER": "someone who flirts [n -S]\n",
  "FLIRTERS": "FLIRTER, someone who flirts [n]\n",
  "FLIRTIER": "FLIRTY, lightheartedly amorous, also FLIRTISH [adj]\n",
  "FLIRTIEST": "FLIRTY, lightheartedly amorous, also FLIRTISH [adj]\n",
  "FLIRTING": "the act of flirting [n -S]\n",
  "FLIRTINGLY": "FLIRTING [adv]\n",
  "FLIRTINGS": "FLIRTING, the act of flirting [n]\n",
  "FLIRTISH": "light-heartedly amorous, also FLIRTY [adj]\n",
  "FLIRTS": "FLIRT, to engage in amorous banter [v]\n",
  "FLIRTY": "lightheartedly amorous, also FLIRTISH [adj FLIRTIER, FLIRTIEST]\n",
  "FLISK": "(Scots) to caper about [v -ED, -ING, -S]\n",
  "FLISKED": "FLISK, (Scots) to caper about [v]\n",
  "FLISKIER": "FLISKY, (Scots) restive, whimsical [adj]\n",
  "FLISKIEST": "FLISKY, (Scots) restive, whimsical [adj]\n",
  "FLISKING": "FLISK, (Scots) to caper about [v]\n",
  "FLISKS": "FLISK, (Scots) to caper about [v]\n",
  "FLISKY": "(Scots) restive, whimsical [adj FLISKIER, FLISKIEST]\n",
  "FLIT": "to move lightly and swiftly [v FLITTED, FLITTING, FLITS]\n",
  "FLITCH": "to cut into strips [v -ED, -ING, -ES]\n",
  "FLITCHED": "FLITCH, to cut into strips [v]\n",
  "FLITCHES": "FLITCH, to cut into strips [v]\n",
  "FLITCHING": "FLITCH, to cut into strips [v]\n",
  "FLITE": "(Scots) to quarrel, brawl, also FLYTE [v FLITED, FLITING, FLITES]\n",
  "FLITED": "FLITE, (Scots) to quarrel, brawl, also FLYTE [v]\n",
  "FLITES": "FLITE, (Scots) to quarrel, brawl, also FLYTE [v]\n",
  "FLITING": "FLITE, (Scots) to quarrel, brawl, also FLYTE [v]\n",
  "FLITS": "FLIT, to move lightly and swiftly [v]\n",
  "FLITT": "(obsolete) to flit [v -ED, -ING, -S]\n",
  "FLITTED": "FLIT, to move lightly and swiftly [v]\n",
  "FLITTER": "to vibrate or move quickly, also FLUTTER [v -ED, -ING, -S]\n",
  "FLITTERED": "FLITTER, to vibrate or move quickly, also FLUTTER [v]\n",
  "FLITTERING": "FLITTER, to vibrate or move quickly, also FLUTTER [v]\n",
  "FLITTERMICE": "FLITTERMOUSE, (dialect) a bat [n]\n",
  "FLITTERMOUSE": "(dialect) a bat [n FLITTERMICE]\n",
  "FLITTERN": "bark obtained from young oak trees [n -S]\n",
  "FLITTERNS": "FLITTERN, bark obtained from young oak trees [n]\n",
  "FLITTERS": "FLITTER, to vibrate or move quickly, also FLUTTER [v]\n",
  "FLITTING": "the act of moving house [n -S]\n",
  "FLITTINGS": "FLITTING, the act of moving house [n]\n",
  "FLITTS": "FLITT, (obsolete) to flit [v]\n",
  "FLIVVER": "a small, cheap, usually old automobile [n -S]\n",
  "FLIVVERS": "FLIVVER, a small, cheap, usually old automobile [n]\n",
  "FLIX": "to melt, also FLUX [v -ED, -ING, -ES]\n",
  "FLIXED": "FLIX, to melt, also FLUX [v]\n",
  "FLIXES": "FLIX, to melt, also FLUX [v]\n",
  "FLIXING": "FLIX, to melt, also FLUX [v]\n",
  "FLIXWEED": "a plant of the mustard family [n -S]\n",
  "FLIXWEEDS": "FLIXWEED, a plant of the mustard family [n]\n",
  "FLOAT": "to rest or move on the surface of liquid [v -ED, -ING, -S]\n",
  "FLOATABILITIES": "FLOATABILITY, the quality of being floatable [n]\n",
  "FLOATABILITY": "the quality of being floatable [n FLOATABILITIES]\n",
  "FLOATABLE": "that may be floated [adj]\n",
  "FLOATAGE": "the act of floating, flotsam, also FLOTAGE [n -S]\n",
  "FLOATAGES": "FLOATAGE, the act of floating, flotsam, also FLOTAGE [n]\n",
  "FLOATANT": "something which makes things float [n -S]\n",
  "FLOATANTS": "FLOATANT, something which makes things float [n]\n",
  "FLOATATION": "the act of floating, also FLOTATION [n -S]\n",
  "FLOATATIONS": "FLOATATION, the act of floating, also FLOTATION [n]\n",
  "FLOATBASE": "a place on a river, lake, etc. where float planes dock [n -S]\n",
  "FLOATBASES": "FLOATBASE, a place on a river, lake, etc. where float planes dock [n]\n",
  "FLOATCUT": "as in floatcut file, a file with rows of parallel teeth [adj]\n",
  "FLOATED": "FLOAT, to rest or move on the surface of liquid [v]\n",
  "FLOATEL": "a floating hotel, also FLOTEL [n -S]\n",
  "FLOATELS": "FLOATEL, a floating hotel, also FLOTEL [n]\n",
  "FLOATER": "one who floats or swims [n -S]\n",
  "FLOATERS": "FLOATER, one who floats or swims [n]\n",
  "FLOATIER": "FLOATY, tending to float [adj]\n",
  "FLOATIEST": "FLOATY, tending to float [adj]\n",
  "FLOATING": "not fixed [adj FLOATINGLY] / the act of floating [n -S]\n",
  "FLOATINGLY": "FLOATING, not fixed [adv]\n",
  "FLOATINGS": "FLOATING, the act of floating [n]\n",
  "FLOATPLANE": "a seaplane [n -S]\n",
  "FLOATPLANES": "FLOATPLANE, a seaplane [n]\n",
  "FLOATS": "FLOAT, to rest or move on the surface of liquid [v]\n",
  "FLOATY": "tending to float [adj FLOATIER, FLOATIEST]\n",
  "FLOB": "(slang) to spit or gob [v FLOBBED, FLOBBING, FLOBS]\n",
  "FLOBBED": "FLOB, (slang) to spit or gob [v]\n",
  "FLOBBING": "FLOB, (slang) to spit or gob [v]\n",
  "FLOBS": "FLOB, (slang) to spit or gob [v]\n",
  "FLOC": "to aggregate into floccules [v FLOCCED, FLOCCING, FLOCS]\n",
  "FLOCCED": "FLOC, to aggregate into floccules [v]\n",
  "FLOCCI": "FLOCCUS, (Latin) the tuft of hair terminating the tail of mammals [n]\n",
  "FLOCCILLATION": "a picking or plucking at the bed clothes by a delirious patient [n -S]\n",
  "FLOCCILLATIONS": "FLOCCILLATION, a picking or plucking at the bed clothes by a delirious patient [n]\n",
  "FLOCCING": "FLOC, to aggregate into floccules [v]\n",
  "FLOCCOSE": "woolly [adj]\n",
  "FLOCCULANT": "clothed with small flocks or flakes [adj] / a flocculant mass [n -S]\n",
  "FLOCCULANTS": "FLOCCULANT, a flocculant mass [n]\n",
  "FLOCCULAR": "like a floccus, a flake [adj]\n",
  "FLOCCULATE": "to collect or mass together in tufts or masses [v FLOCCULATED, FLOCCULATING, FLOCCULATES]\n",
  "FLOCCULATED": "FLOCCULATE, to collect or mass together in tufts or masses [v]\n",
  "FLOCCULATES": "FLOCCULATE, to collect or mass together in tufts or masses [v]\n",
  "FLOCCULATING": "FLOCCULATE, to collect or mass together in tufts or masses [v]\n",
  "FLOCCULATION": "the act of flocculating [n -S]\n",
  "FLOCCULATIONS": "FLOCCULATION, the act of flocculating [n]\n",
  "FLOCCULATOR": "one who flocculates [n -S]\n",
  "FLOCCULATORS": "FLOCCULATOR, one who flocculates [n]\n",
  "FLOCCULE": "a small tuft, also FLOCCULUS [n -S]\n",
  "FLOCCULENCE": "the state of being flocculent [n -S]\n",
  "FLOCCULENCES": "FLOCCULENCE, the state of being flocculent [n]\n",
  "FLOCCULENCIES": "FLOCCULENCY, the state of being flocculent [n]\n",
  "FLOCCULENCY": "the state of being flocculent [n FLOCCULENCIES]\n",
  "FLOCCULENT": "clothed with small flocks or flakes; woolly [adj FLOCCULENTLY]\n",
  "FLOCCULENTLY": "FLOCCULENT, clothed with small flocks or flakes; woolly [adv]\n",
  "FLOCCULES": "FLOCCULE, a small tuft, also FLOCCULUS [n]\n",
  "FLOCCULI": "FLOCCULUS, (Latin) a small flock, tuft or flake, also FLOCCULE [n]\n",
  "FLOCCULUS": "(Latin) a small flock, tuft or flake, also FLOCCULE [n FLOCCULI]\n",
  "FLOCCUS": "(Latin) the tuft of hair terminating the tail of mammals [n FLOCCI]\n",
  "FLOCK": "to gather or move in crowds [v -ED, -ING, -S]\n",
  "FLOCKED": "FLOCK, to gather or move in crowds [v]\n",
  "FLOCKIER": "FLOCKY, abounding with flocks [adj]\n",
  "FLOCKIEST": "FLOCKY, abounding with flocks [adj]\n",
  "FLOCKING": "a velvety design on paper or cloth [n -S]\n",
  "FLOCKINGS": "FLOCKING, a velvety design on paper or cloth [n]\n",
  "FLOCKLESS": "without a flock [adj]\n",
  "FLOCKS": "FLOCK, to gather or move in crowds [v]\n",
  "FLOCKY": "abounding with flocks [adj FLOCKIER, FLOCKIEST]\n",
  "FLOCS": "FLOC, to aggregate into floccules [v]\n",
  "FLOE": "a large mass of floating ice [n -S]\n",
  "FLOES": "FLOE, a large mass of floating ice [n]\n",
  "FLOG": "to beat with a whip [v FLOGGED, FLOGGING, FLOGS]\n",
  "FLOGGABLE": "of an offence, punishable by flogging [adj]\n",
  "FLOGGED": "FLOG, to beat with a whip [v]\n",
  "FLOGGER": "one who flogs [n -S]\n",
  "FLOGGERS": "FLOGGER, one who flogs [n]\n",
  "FLOGGING": "a whipping [n -S]\n",
  "FLOGGINGS": "FLOGGING, a whipping [n]\n",
  "FLOGS": "FLOG, to beat with a whip [v]\n",
  "FLOKATI": "(Modern Greek) a handwoven Greek rug [n -S]\n",
  "FLOKATIS": "FLOKATI, (Modern Greek) a handwoven Greek rug [n]\n",
  "FLONG": "papier-mache for making stereotype moulds [n -S]\n",
  "FLONGS": "FLONG, papier-mache for making stereotype moulds [n]\n",
  "FLOOD": "to inundate [v -ED, -ING, -S]\n",
  "FLOODABLE": "that can be flooded [adj]\n",
  "FLOODED": "FLOOD, to inundate [v]\n",
  "FLOODER": "one who floods anything [n -S]\n",
  "FLOODERS": "FLOODER, one who floods anything [n]\n",
  "FLOODGATE": "a gate for allowing or stopping the flow of water, a sluice or lock gate [n -S]\n",
  "FLOODGATES": "FLOODGATE, a gate for allowing or stopping the flow of water, a sluice or lock gate [n]\n",
  "FLOODING": "the act of flooding [n -S]\n",
  "FLOODINGS": "FLOODING, the act of flooding [n]\n",
  "FLOODLESS": "without a flood [adj]\n",
  "FLOODLIGHT": "lighting of a large area or surface by illumination from lamps situated at some distance [n -S] / to illuminate by floodlighting [v FLOODLIT or FLOODLIGHTED, FLOODLIGHTING, FLOODLIGHTS]\n",
  "FLOODLIGHTED": "FLOODLIGHT, to illuminate by floodlighting [v]\n",
  "FLOODLIGHTING": "illumination by floodlights [n -S]\n",
  "FLOODLIGHTINGS": "FLOODLIGHTING, illumination by floodlights [n]\n",
  "FLOODLIGHTS": "FLOODLIGHT, to illuminate by floodlighting [v]\n",
  "FLOODLIT": "illuminated by floodlights [adj]\n",
  "FLOODMARK": "the mark or line to which a flood or tide has risen [n -S]\n",
  "FLOODMARKS": "FLOODMARK, the mark or line to which a flood or tide has risen [n]\n",
  "FLOODPLAIN": "an area bordering a stream over which water spreads when the stream tops its channel banks [n -S]\n",
  "FLOODPLAINS": "FLOODPLAIN, an area bordering a stream over which water spreads when the stream tops its channel banks [n]\n",
  "FLOODS": "FLOOD, to inundate [v]\n",
  "FLOODTIDE": "the flowing in of the tide [n -S]\n",
  "FLOODTIDES": "FLOODTIDE, the flowing in of the tide [n]\n",
  "FLOODWALL": "a wall built as a protection against floods etc. [n -S]\n",
  "FLOODWALLS": "FLOODWALL, a wall built as a protection against floods etc. [n]\n",
  "FLOODWATER": "the water of a flood [n -S]\n",
  "FLOODWATERS": "FLOODWATER, the water of a flood [n]\n",
  "FLOODWAY": "an artificial passage for floodwater [n -S]\n",
  "FLOODWAYS": "FLOODWAY, an artificial passage for floodwater [n]\n",
  "FLOOEY": "awry, also FLOOIE [adj]\n",
  "FLOOIE": "awry, also FLOOEY [adj]\n",
  "FLOOR": "to supply with the lower supporting surface of a room [v -ED, -ING, -S]\n",
  "FLOORAGE": "floor space [n -S]\n",
  "FLOORAGES": "FLOORAGE, floor space [n]\n",
  "FLOORBOARD": "a board in a floor [n -S]\n",
  "FLOORBOARDS": "FLOORBOARD, a board in a floor [n]\n",
  "FLOORCLOTH": "a usually decorated heavy cloth (as of canvas) used for a floor covering [n -S]\n",
  "FLOORCLOTHS": "FLOORCLOTH, a usually decorated heavy cloth (as of canvas) used for a floor covering [n]\n",
  "FLOORDROBE": "a pile of clothes left on the floor of a room [n -S]\n",
  "FLOORDROBES": "FLOORDROBE, a pile of clothes left on the floor of a room [n]\n",
  "FLOORED": "FLOOR, to supply with the lower supporting surface of a room [v]\n",
  "FLOORER": "a knockdown blow; a conclusive answer or retort [n -S]\n",
  "FLOORERS": "FLOORER, a knockdown blow; a conclusive answer or retort [n]\n",
  "FLOORHEAD": "the upper end of a ship's floor timber [n -S]\n",
  "FLOORHEADS": "FLOORHEAD, the upper end of a ship's floor timber [n]\n",
  "FLOORING": "a floor [n -S]\n",
  "FLOORINGS": "FLOORING, a floor [n]\n",
  "FLOORLESS": "without a floor [adj]\n",
  "FLOORPAN": "the bottom part of the interior of a motor vehicle [n -S]\n",
  "FLOORPANS": "FLOORPAN, the bottom part of the interior of a motor vehicle [n]\n",
  "FLOORS": "FLOOR, to supply with the lower supporting surface of a room [v]\n",
  "FLOORSHOW": "entertainment of the floor of a nightclub [n -S]\n",
  "FLOORSHOWS": "FLOORSHOW, entertainment of the floor of a nightclub [n]\n",
  "FLOORWALKER": "a person employed in a retail store to oversee the salespeople and aid customers [n -S]\n",
  "FLOORWALKERS": "FLOORWALKER, a person employed in a retail store to oversee the salespeople and aid customers [n]\n",
  "FLOOSIE": "a prostitute, also FLOOSY, FLOOZIE, FLOOZY, FLOSSIE [n -S]\n",
  "FLOOSIES": "FLOOSY, a prostitute, also FLOOSIE, FLOOZIE, FLOOZY, FLOSSIE [n]\n",
  "FLOOSY": "a prostitute, also FLOOSIE, FLOOZIE, FLOOZY, FLOSSIE [n FLOOSIES]\n",
  "FLOOZIE": "a prostitute, also FLOOSIE, FLOOSY, FLOOZY, FLOSSIE [n -S]\n",
  "FLOOZIES": "FLOOZIE, a prostitute, also FLOOSIE, FLOOSY, FLOOZY, FLOSSIE [n]\n",
  "FLOOZY": "a prostitute, also FLOOSIE, FLOOSY, FLOOZIE, FLOSSIE [n FLOOZIES]\n",
  "FLOP": "to drop heavily [v FLOPPED, FLOPPING, FLOPS]\n",
  "FLOPHOUSE": "(US) a cheap hotel, a dosshouse [n -S]\n",
  "FLOPHOUSES": "FLOPHOUSE, (US) a cheap hotel, a dosshouse [n]\n",
  "FLOPOVER": "a defect in television reception [n -S]\n",
  "FLOPOVERS": "FLOPOVER, a defect in television reception [n]\n",
  "FLOPPED": "FLOP, to drop heavily [v]\n",
  "FLOPPER": "something or someone that flops [n -S]\n",
  "FLOPPERS": "FLOPPER, something or someone that flops [n]\n",
  "FLOPPIER": "FLOPPY, soft and flexible [adj]\n",
  "FLOPPIES": "FLOPPY, a type of computer disk [n]\n",
  "FLOPPIEST": "FLOPPY, soft and flexible [adj]\n",
  "FLOPPILY": "FLOPPY, soft and flexible [adv]\n",
  "FLOPPINESS": "the state of being floppy [n -ES]\n",
  "FLOPPINESSES": "FLOPPINESS, the state of being floppy [n]\n",
  "FLOPPING": "FLOP, to drop heavily [v]\n",
  "FLOPPY": "a type of computer disk [n FLOPPIES] / soft and flexible [adj FLOPPIER, FLOPPIEST, FLOPPILY]\n",
  "FLOPS": "FLOP, to drop heavily [v]\n",
  "FLOPTICAL": "a type of read-write head using a laser device [n -S]\n",
  "FLOPTICALS": "FLOPTICAL, a type of read-write head using a laser device [n]\n",
  "FLOR": "a flavoursome yeast on sherry wines [n -S]\n",
  "FLORA": "(Latin) the plant life of a particular region [n FLORAS or FLORAE]\n",
  "FLORAE": "FLORA, (Latin) the plant life of a particular region [n]\n",
  "FLORAL": "relating to flowers [adj FLORALLY] / a design featuring flowers [n -S]\n",
  "FLORALLY": "FLORAL, relating to flowers [adv]\n",
  "FLORALS": "FLORAL, a design featuring flowers [n]\n",
  "FLORAS": "FLORA, (Latin) the plant life of a particular region [n]\n",
  "FLOREANT": "(Latin) may they flourish [v]\n",
  "FLOREAT": "(Latin) may it flourish [v]\n",
  "FLOREATED": "decorated with a floral ornament, also FLORIATED [adj]\n",
  "FLORENCE": "an ancient gold coin of the time of Edward III, of six shillings sterling value [n -S]\n",
  "FLORENCES": "FLORENCE, an ancient gold coin of the time of Edward III, of six shillings sterling value [n]\n",
  "FLORENTINE": "a kind of biscuit packed with nuts, glace cherries, and other preserved fruit, coated on one side with chocolate [n -S]\n",
  "FLORENTINES": "FLORENTINE, a kind of biscuit packed with nuts, glace cherries, and other preserved fruit, coated on one side with chocolate [n]\n",
  "FLORESCENCE": "the process of flowering or bursting into flower; the period of flowering [n -S]\n",
  "FLORESCENCES": "FLORESCENCE, the process of flowering or bursting into flower; the period of flowering [n]\n",
  "FLORESCENT": "expanding into flowers; blossoming [adj]\n",
  "FLORET": "a small flower, esp. of a composite plant, also FLOWERET [n -S]\n",
  "FLORETS": "FLORET, a small flower, esp. of a composite plant, also FLOWERET [n]\n",
  "FLORIATED": "decorated with a floral ornament, also FLOREATED [adj]\n",
  "FLORIATION": "decoration with floral ornament [n -S]\n",
  "FLORIATIONS": "FLORIATION, decoration with floral ornament [n]\n",
  "FLORIBUNDA": "a plant whose flowers grow in clusters [n -S]\n",
  "FLORIBUNDAS": "FLORIBUNDA, a plant whose flowers grow in clusters [n]\n",
  "FLORICANE": "the fruiting stem of a plant [n -S]\n",
  "FLORICANES": "FLORICANE, the fruiting stem of a plant [n]\n",
  "FLORICULTURAL": "relating to floriculture [adj]\n",
  "FLORICULTURE": "the cultivation and management of ornamental and esp. flowering plants [n -S]\n",
  "FLORICULTURES": "FLORICULTURE, the cultivation and management of ornamental and esp. flowering plants [n]\n",
  "FLORICULTURIST": "one who practises floriculture [n -S]\n",
  "FLORICULTURISTS": "FLORICULTURIST, one who practises floriculture [n]\n",
  "FLORID": "flowery; having a ruddy or highly coloured complexion [adj FLORIDER, FLORIDEST, FLORIDLY]\n",
  "FLORIDEAN": "any of a large subclass of red seaweeds [n -S]\n",
  "FLORIDEANS": "FLORIDEAN, any of a large subclass of red seaweeds [n]\n",
  "FLORIDEOUS": "relating to Floridae, a family of red seaweeds [adj]\n",
  "FLORIDER": "FLORID, flowery; having a ruddy or highly coloured complexion [adj]\n",
  "FLORIDEST": "FLORID, flowery; having a ruddy or highly coloured complexion [adj]\n",
  "FLORIDITIES": "FLORIDITY, the state of being florid, also FLORIDNESS [n]\n",
  "FLORIDITY": "the state of being florid, also FLORIDNESS [n FLORIDITIES]\n",
  "FLORIDLY": "FLORID, flowery; having a ruddy or highly coloured complexion [adv]\n",
  "FLORIDNESS": "the state of being florid, also FLORIDITY [n -ES]\n",
  "FLORIDNESSES": "FLORIDNESS, the state of being florid, also FLORIDITY [n]\n",
  "FLORIER": "FLORY, having fleur-de-lis [adj]\n",
  "FLORIEST": "FLORY, having fleur-de-lis [adj]\n",
  "FLORIFEROUS": "bearing flowers [adj]\n",
  "FLORIFEROUSNESS": "FLORIFEROUS, bearing flowers [n]\n",
  "FLORIFORM": "shaped like a flower [adj]\n",
  "FLORIGEN": "a plant hormone [n -S]\n",
  "FLORIGENIC": "relating to florigen, a postulated flower-forming hormone [adj]\n",
  "FLORIGENS": "FLORIGEN, a plant hormone [n]\n",
  "FLORILEGIA": "FLORILEGIUM, (Latin) a collection of literary pieces; an anthology [n]\n",
  "FLORILEGIUM": "(Latin) a collection of literary pieces; an anthology [n FLORILEGIA]\n",
  "FLORIN": "an obsolete British coin worth two shillings [n -S]\n",
  "FLORINS": "FLORIN, an obsolete British coin worth two shillings [n]\n",
  "FLORIST": "a grower or seller of flowers [n -S]\n",
  "FLORISTIC": "relating to flora [adj FLORISTICALLY]\n",
  "FLORISTICALLY": "FLORISTIC, relating to flora [adv]\n",
  "FLORISTICS": "the study of the numerical distributions of plants [n]\n",
  "FLORISTRIES": "FLORISTRY, the art of cultivating and selling flowers [n]\n",
  "FLORISTRY": "the art of cultivating and selling flowers [n FLORISTRIES]\n",
  "FLORISTS": "FLORIST, a grower or seller of flowers [n]\n",
  "FLORS": "FLOR, a flavoursome yeast on sherry wines [n]\n",
  "FLORUIT": "(Latin) the period during which a person, movement, etc. was active [n -S]\n",
  "FLORUITS": "FLORUIT, (Latin) the period during which a person, movement, etc. was active [n]\n",
  "FLORULA": "a fossil flower, also FLORULE [n FLORULAE]\n",
  "FLORULAE": "FLORULA, a fossil flower, also FLORULE [n]\n",
  "FLORULE": "a fossil flower, also FLORULA [n -S]\n",
  "FLORULES": "FLORULE, a fossil flower, also FLORULA [n]\n",
  "FLORY": "having fleur-de-lis [adj FLORIER, FLORIEST]\n",
  "FLOSCULAR": "composed of floscules, florets, also FLOSCULOUS [adj]\n",
  "FLOSCULE": "a small flower [n -S]\n",
  "FLOSCULES": "FLOSCULE, a small flower [n]\n",
  "FLOSCULOUS": "composed of floscules or florets, also FLOSCULAR [adj]\n",
  "FLOSH": "any loose downy stuff, floss [n -ES]\n",
  "FLOSHES": "FLOSH, any loose downy stuff, floss [n]\n",
  "FLOSS": "to clean between the teeth with strong thread [v -ED, -ING, -ES]\n",
  "FLOSSED": "FLOSS, to clean between the teeth with strong thread [v]\n",
  "FLOSSER": "one who flosses [n -S]\n",
  "FLOSSERS": "FLOSSER, one who flosses [n]\n",
  "FLOSSES": "FLOSS, to clean between the teeth with strong thread [v]\n",
  "FLOSSIE": "a prostitute, also FLOOSIE, FLOOSY, FLOOZIE, FLOOZY [n -S]\n",
  "FLOSSIER": "FLOSSY, resembling a light soft fibre [adj]\n",
  "FLOSSIES": "FLOSSIE, a prostitute, also FLOOSIE, FLOOSY, FLOOZIE, FLOOZY [n]\n",
  "FLOSSIEST": "FLOSSY, resembling a light soft fibre [adj]\n",
  "FLOSSILY": "FLOSSY, resembling a light soft fibre [adv]\n",
  "FLOSSING": "the application of dental floss [n -S]\n",
  "FLOSSINGS": "FLOSSING, the application of dental floss [n]\n",
  "FLOSSY": "resembling a light soft fibre [adj FLOSSIER, FLOSSIEST, FLOSSILY]\n",
  "FLOTA": "(Spanish) a commercial fleet; formerly, the fleet which annually conveyed the produce of America to Spain [n -S]\n",
  "FLOTAGE": "the act of floating, also FLOATAGE [n -S]\n",
  "FLOTAGES": "FLOTAGE, the act of floating, also FLOATAGE [n]\n",
  "FLOTANT": "in heraldry, represented as flying or streaming in the air; as, a banner flotant [adj]\n",
  "FLOTAS": "FLOTA, (Spanish) a commercial fleet; formerly, the fleet which annually conveyed the produce of America to Spain [n]\n",
  "FLOTATION": "the act of floating, also FLOATATION [n -S]\n",
  "FLOTATIONS": "FLOTATION, the act of floating, also FLOATATION [n]\n",
  "FLOTE": "to skim e.g. milk [v FLOTED, FLOTING, FLOTES]\n",
  "FLOTED": "FLOTE, to skim e.g. milk [v]\n",
  "FLOTEL": "a platform or boat containing the sleeping quarters for workers on an oil-rig, also FLOATEL [n -S]\n",
  "FLOTELS": "FLOTEL, a platform or boat containing the sleeping quarters for workers on an oil-rig, also FLOATEL [n]\n",
  "FLOTES": "FLOTE, to skim e.g. milk [v]\n",
  "FLOTILLA": "a fleet of ships [n -S]\n",
  "FLOTILLAS": "FLOTILLA, a fleet of ships [n]\n",
  "FLOTING": "FLOTE, to skim e.g. milk [v]\n",
  "FLOTSAM": "goods lost by shipwreck and found floating on the sea [n -S]\n",
  "FLOTSAMS": "FLOTSAM, goods lost by shipwreck and found floating on the sea [n]\n",
  "FLOUNCE": "to move with an impatient fling [v FLOUNCED, FLOUNCING, FLOUNCES]\n",
  "FLOUNCED": "FLOUNCE, to move with an impatient fling [v]\n",
  "FLOUNCES": "FLOUNCE, to move with an impatient fling [v]\n",
  "FLOUNCIER": "FLOUNCY, flouncing [adj]\n",
  "FLOUNCIEST": "FLOUNCY, flouncing [adj]\n",
  "FLOUNCING": "material for flounces [n -S]\n",
  "FLOUNCINGS": "FLOUNCING, material for flounces [n]\n",
  "FLOUNCY": "flouncing [adj FLOUNCIER, FLOUNCIEST]\n",
  "FLOUNDER": "to struggle clumsily [v -ED, -ING, -S]\n",
  "FLOUNDERED": "FLOUNDER, to struggle clumsily [v]\n",
  "FLOUNDERING": "FLOUNDER, to struggle clumsily [v]\n",
  "FLOUNDERS": "FLOUNDER, to struggle clumsily [v]\n",
  "FLOUR": "to cover with a finely ground meal or grain [v -ED, -ING, -S]\n",
  "FLOURED": "FLOUR, to cover with a finely ground meal or grain [v]\n",
  "FLOURIER": "FLOURY, fine-grained like flour [adj]\n",
  "FLOURIEST": "FLOURY, fine-grained like flour [adj]\n",
  "FLOURING": "FLOUR, to cover with a finely ground meal or grain [v]\n",
  "FLOURISH": "to thrive [v -ED, -ING, -ES]\n",
  "FLOURISHED": "FLOURISH, to thrive [v]\n",
  "FLOURISHER": "one who flourishes [n -S]\n",
  "FLOURISHERS": "FLOURISHER, one who flourishes [n]\n",
  "FLOURISHES": "FLOURISH, to thrive [v]\n",
  "FLOURISHIER": "FLOURISHY, full of flourishes [adj]\n",
  "FLOURISHIEST": "FLOURISHY, full of flourishes [adj]\n",
  "FLOURISHING": "FLOURISH, to thrive [v]\n",
  "FLOURISHINGLY": "FLOURISHING, FLOURISH, to thrive [adv]\n",
  "FLOURISHY": "full of flourishes [adj FLOURISHIER, FLOURISHIEST]\n",
  "FLOURLESS": "without flour [adj]\n",
  "FLOURS": "FLOUR, to cover with a finely ground meal or grain [v]\n",
  "FLOURY": "fine-grained like flour [adj FLOURIER, FLOURIEST]\n",
  "FLOUSE": "(dialect) to splash, also FLOUSH [v FLOUSED, FLOUSING, FLOUSES]\n",
  "FLOUSED": "FLOUSE, (dialect) to splash, also FLOUSH [v]\n",
  "FLOUSES": "FLOUSE, (dialect) to splash, also FLOUSH [v]\n",
  "FLOUSH": "(dialect) to splash, also FLOUSE [v -ED, -ING, -ES]\n",
  "FLOUSHED": "FLOUSH, (dialect) to splash, also FLOUSE [v]\n",
  "FLOUSHES": "FLOUSH, (dialect) to splash, also FLOUSE [v]\n",
  "FLOUSHING": "FLOUSH, (dialect) to splash, also FLOUSE [v]\n",
  "FLOUSING": "FLOUSE, (dialect) to splash, also FLOUSH [v]\n",
  "FLOUT": "to treat with contempt [v -ED, -ING, -S]\n",
  "FLOUTED": "FLOUT, to treat with contempt [v]\n",
  "FLOUTER": "one who flouts; a mocker [n -S]\n",
  "FLOUTERS": "FLOUTER, one who flouts; a mocker [n]\n",
  "FLOUTING": "FLOUT, to treat with contempt [v]\n",
  "FLOUTINGLY": "FLOUTING, FLOUT, to treat with contempt [adv]\n",
  "FLOUTINGSTOCK": "(Shakespeare) a person or thing that is flouted [n -S]\n",
  "FLOUTINGSTOCKS": "FLOUTINGSTOCK, (Shakespeare) a person or thing that is flouted [n]\n",
  "FLOUTS": "FLOUT, to treat with contempt [v]\n",
  "FLOW": "to move steadily and smoothly along [v -ED, -ING, -S]\n",
  "FLOWABLE": "capable of flowing [adj]\n",
  "FLOWAGE": "an overflowing with water; also, the water which thus overflows [n -S]\n",
  "FLOWAGES": "FLOWAGE, an overflowing with water; also, the water which thus overflows [n]\n",
  "FLOWCHART": "a chart pictorially representing the nature and sequence of operations to be carried out, e.g. in a computer program [n -S]\n",
  "FLOWCHARTING": "the act of making a flowchart [n -S]\n",
  "FLOWCHARTINGS": "FLOWCHARTING, the act of making a flowchart [n]\n",
  "FLOWCHARTS": "FLOWCHART, a chart pictorially representing the nature and sequence of operations to be carried out, e.g. in a computer program [n]\n",
  "FLOWED": "FLOW, to move steadily and smoothly along [v]\n",
  "FLOWER": "to blossom or flourish [v -ED, -ING, -S]\n",
  "FLOWERAGE": "the process or result of flowering; flowers collectively [n -S]\n",
  "FLOWERAGES": "FLOWERAGE, the process or result of flowering; flowers collectively [n]\n",
  "FLOWERBED": "a bed containing flowers [n -S]\n",
  "FLOWERBEDS": "FLOWERBED, a bed containing flowers [n]\n",
  "FLOWERED": "FLOWER, to blossom or flourish [v]\n",
  "FLOWERER": "a plant that flowers at a certain time [n -S]\n",
  "FLOWERERS": "FLOWERER, a plant that flowers at a certain time [n]\n",
  "FLOWERET": "a small flower, also FLORET [n -S]\n",
  "FLOWERETS": "FLOWERET, a small flower, also FLORET [n]\n",
  "FLOWERETTE": "a small flower; a floret, also FLOWERET [n -S]\n",
  "FLOWERETTES": "FLOWERETTE, a small flower; a floret, also FLOWERET [n]\n",
  "FLOWERFUL": "abounding with flowers [adj]\n",
  "FLOWERHORN": "as in flowerhorn fish, a brightly coloured cichlid fish with a large protuberance on the head [adj]\n",
  "FLOWERIER": "FLOWERY, abounding in flowers [adj]\n",
  "FLOWERIEST": "FLOWERY, abounding in flowers [adj]\n",
  "FLOWERILY": "FLOWERY, abounding in flowers [adv]\n",
  "FLOWERINESS": "the state of being flowery [n -ES]\n",
  "FLOWERINESSES": "FLOWERINESS, the state of being flowery [n]\n",
  "FLOWERING": "the act of flowering [n -S]\n",
  "FLOWERINGS": "FLOWERING, the act of flowering [n]\n",
  "FLOWERLESS": "without flowers [adj]\n",
  "FLOWERLIKE": "like a flower [adj]\n",
  "FLOWERPOT": "a pot for a flower [n -S]\n",
  "FLOWERPOTS": "FLOWERPOT, a pot for a flower [n]\n",
  "FLOWERS": "FLOWER, to blossom or flourish [v]\n",
  "FLOWERY": "abounding in flowers [adj FLOWERIER, FLOWERIEST, FLOWERILY]\n",
  "FLOWING": "FLOW, to move steadily and smoothly along [v]\n",
  "FLOWINGLY": "FLOWING, FLOW, to move steadily and smoothly along [adv]\n",
  "FLOWINGNESS": "the state of being flowing [n -ES]\n",
  "FLOWINGNESSES": "FLOWINGNESS, the state of being flowing [n]\n",
  "FLOWMETER": "an instrument for measuring the properties of flowing liquids [n -S]\n",
  "FLOWMETERS": "FLOWMETER, an instrument for measuring the properties of flowing liquids [n]\n",
  "FLOWN": "FLY, to move through the air [v]\n",
  "FLOWS": "FLOW, to move steadily and smoothly along [v]\n",
  "FLOWSTONE": "a general term for deposits formed by dripping and flowing water on walls and floors of caves [n -S]\n",
  "FLOWSTONES": "FLOWSTONE, a general term for deposits formed by dripping and flowing water on walls and floors of caves [n]\n",
  "FLOX": "as in flox silk, same as floss silk [adj]\n",
  "FLU": "a virus disease [n -S]\n",
  "FLUATE": "(obsolete) a fluoride [n -S]\n",
  "FLUATES": "FLUATE, (obsolete) a fluoride [n]\n",
  "FLUB": "to bungle, botch [v FLUBBED, FLUBBING, FLUBS]\n",
  "FLUBBED": "FLUB, to bungle, botch [v]\n",
  "FLUBBER": "one who flubs, makes a mistake [n -S]\n",
  "FLUBBERS": "FLUBBER, one who flubs, makes a mistake [n]\n",
  "FLUBBING": "FLUB, to bungle, botch [v]\n",
  "FLUBDUB": "pretentious nonsense [n -S]\n",
  "FLUBDUBS": "FLUBDUB, pretentious nonsense [n]\n",
  "FLUBS": "FLUB, to bungle, botch [v]\n",
  "FLUCTUANT": "moving like a wave [adj]\n",
  "FLUCTUATE": "to vary this way and that; to go up and down or to and fro [v FLUCTUATED, FLUCTUATING, FLUCTUATES]\n",
  "FLUCTUATED": "FLUCTUATE, to vary this way and that; to go up and down or to and fro [v]\n",
  "FLUCTUATES": "FLUCTUATE, to vary this way and that; to go up and down or to and fro [v]\n",
  "FLUCTUATING": "FLUCTUATE, to vary this way and that; to go up and down or to and fro [v]\n",
  "FLUCTUATION": "the act of fluctuating [n -S]\n",
  "FLUCTUATIONAL": "showing fluctuation [adj]\n",
  "FLUCTUATIONS": "FLUCTUATION, the act of fluctuating [n]\n",
  "FLUE": "a smoke-duct in a chimney [n -S]\n",
  "FLUED": "having a flue [adj]\n",
  "FLUEGELHORN": "(German) a bugle with valves, also FLUGELHORN [n -S]\n",
  "FLUEGELHORNS": "FLUEGELHORN, (German) a bugle with valves, also FLUGELHORN [n]\n",
  "FLUELLEN": "a weedy annual related to toadflax, also FLUELLIN [n -S]\n",
  "FLUELLENS": "FLUELLEN, a weedy annual related to toadflax, also FLUELLIN [n]\n",
  "FLUELLIN": "a weedy annual related to toadflax, also FLUELLEN [n -S]\n",
  "FLUELLINS": "FLUELLIN, a weedy annual related to toadflax, also FLUELLEN [n]\n",
  "FLUENCE": "the quality of being fluent, also FLUENCY [n -S]\n",
  "FLUENCES": "FLUENCE, the quality of being fluent, also FLUENCY [n]\n",
  "FLUENCIES": "FLUENCY, the quality of being fluent, also FLUENCE [n]\n",
  "FLUENCY": "the quality of being fluent, also FLUENCE [n FLUENCIES]\n",
  "FLUENT": "flowing [adj FLUENTLY] / the variable quantity in fluxions [n -S]\n",
  "FLUENTLY": "FLUENT, flowing [adv]\n",
  "FLUENTNESS": "the quality of being fluent [n -ES]\n",
  "FLUENTNESSES": "FLUENTNESS, the quality of being fluent [n]\n",
  "FLUENTS": "FLUENT, the variable quantity in fluxions [n]\n",
  "FLUERIC": "pertaining to a branch of mechanical engineering [adj]\n",
  "FLUERICS": "the technology of using fluid jets analogously to electricity, also FLUIDICS [n]\n",
  "FLUES": "FLUE, a smoke-duct in a chimney [n]\n",
  "FLUEWORK": "flue pipes [n -S]\n",
  "FLUEWORKS": "FLUEWORK, flue pipes [n]\n",
  "FLUEY": "infected with the flu [adj FLUIER, FLUIEST]\n",
  "FLUFF": "a soft down from cotton, etc. [n -S] / to make fluffy [v -ED, -ING, -S]\n",
  "FLUFFBALL": "a ball of fluff; something, e.g. a bird or small animal, resembling a ball of fluff [n -S]\n",
  "FLUFFBALLS": "FLUFFBALL, a ball of fluff; something, e.g. a bird or small animal, resembling a ball of fluff [n]\n",
  "FLUFFED": "FLUFF, to make fluffy [v]\n",
  "FLUFFER": "a person employed on a pornographic film to ensure that male actors are kept aroused [n -S]\n",
  "FLUFFERS": "FLUFFER, a person employed on a pornographic film to ensure that male actors are kept aroused [n]\n",
  "FLUFFIER": "FLUFFY, downy, light and soft [adj]\n",
  "FLUFFIEST": "FLUFFY, downy, light and soft [adj]\n",
  "FLUFFILY": "FLUFFY, downy, light and soft [adv]\n",
  "FLUFFINESS": "the state of being fluffy [n -ES]\n",
  "FLUFFINESSES": "FLUFFINESS, the state of being fluffy [n]\n",
  "FLUFFING": "FLUFF, to make fluffy [v]\n",
  "FLUFFS": "FLUFF, to make fluffy [v]\n",
  "FLUFFY": "downy, light and soft [adj FLUFFIER, FLUFFIEST, FLUFFILY]\n",
  "FLUGEL": "(German) a grand piano or a harpsichord, both being wing-shaped [n -S]\n",
  "FLUGELHORN": "(German) a bugle with valves, also FLUEGELHORN [n -S]\n",
  "FLUGELHORNIST": "one who plays the flugelhorn [n -S]\n",
  "FLUGELHORNISTS": "FLUGELHORNIST, one who plays the flugelhorn [n]\n",
  "FLUGELHORNS": "FLUGELHORN, (German) a bugle with valves, also FLUEGELHORN [n]\n",
  "FLUGELMAN": "(German) a leader (esp. political); the lead soldier for a company, also FUGLEMAN [n FLUGELMEN]\n",
  "FLUGELMEN": "FLUGELMAN, (German) a leader (esp. political); the lead soldier for a company, also FUGLEMAN [n]\n",
  "FLUGELS": "FLUGEL, (German) a grand piano or a harpsichord, both being wing-shaped [n]\n",
  "FLUID": "flowing [adj FLUIDLY] / a substance that tends to flow [n -S]\n",
  "FLUIDAL": "pertaining to a fluid, or to its flowing motion [adj FLUIDALLY]\n",
  "FLUIDALLY": "FLUIDAL, pertaining to a fluid, or to its flowing motion [adv]\n",
  "FLUIDEXTRACT": "an alcohol preparation of a plant-derived drug containing the active constituents of one gram of the dry drug in each milliliter [n -S]\n",
  "FLUIDEXTRACTS": "FLUIDEXTRACT, an alcohol preparation of a plant-derived drug containing the active constituents of one gram of the dry drug in each milliliter [n]\n",
  "FLUIDIC": "fluid, relating to fluidics [adj]\n",
  "FLUIDICS": "the technology of using fluid jets analogously to electricity, also FLUERICS [n]\n",
  "FLUIDIFIED": "FLUIDIFY, to make fluid, also FLUIDIZE, FLUIDISE [v]\n",
  "FLUIDIFIES": "FLUIDIFY, to make fluid, also FLUIDIZE, FLUIDISE [v]\n",
  "FLUIDIFY": "to make fluid, also FLUIDIZE, FLUIDISE [v FLUIDIFIED, FLUIDIFYING, FLUIDIFIES]\n",
  "FLUIDIFYING": "FLUIDIFY, to make fluid, also FLUIDIZE, FLUIDISE [v]\n",
  "FLUIDISATION": "the process of fluidising, also FLUIDIZATION [n -S]\n",
  "FLUIDISATIONS": "FLUIDISATION, the process of fluidising, also FLUIDIZATION [n]\n",
  "FLUIDISE": "to make fluid, also FLUIDIZE, FLUIDIFY [v FLUIDISED, FLUIDISING, FLUIDISES]\n",
  "FLUIDISED": "FLUIDISE, to make fluid, also FLUIDIZE, FLUIDIFY [v]\n",
  "FLUIDISER": "an apparatus in which fluidisation is carried out, also FLUIDIZER [n -S]\n",
  "FLUIDISERS": "FLUIDISER, an apparatus in which fluidisation is carried out, also FLUIDIZER [n]\n",
  "FLUIDISES": "FLUIDISE, to make fluid, also FLUIDIZE, FLUIDIFY [v]\n",
  "FLUIDISING": "FLUIDISE, to make fluid, also FLUIDIZE, FLUIDIFY [v]\n",
  "FLUIDITIES": "FLUIDITY, the quality of being able to flow [n]\n",
  "FLUIDITY": "the quality of being able to flow [n FLUIDITIES]\n",
  "FLUIDIZATION": "the act of fluidizing, also FLUIDISATION [n -S]\n",
  "FLUIDIZATIONS": "FLUIDIZATION, the act of fluidizing, also FLUIDISATION [n]\n",
  "FLUIDIZE": "to make fluid, also FLUIDIFY, FLUIDISE [v FLUIDIZED, FLUIDIZING, FLUIDIZES]\n",
  "FLUIDIZED": "FLUIDIZE, to make fluid, also FLUIDIFY, FLUIDISE [v]\n",
  "FLUIDIZER": "an apparatus in which fluidization is carried out, also FLUIDISER [n -S]\n",
  "FLUIDIZERS": "FLUIDIZER, an apparatus in which fluidization is carried out, also FLUIDISER [n]\n",
  "FLUIDIZES": "FLUIDIZE, to make fluid, also FLUIDIFY, FLUIDISE [v]\n",
  "FLUIDIZING": "FLUIDIZE, to make fluid, also FLUIDIFY, FLUIDISE [v]\n",
  "FLUIDLIKE": "like a fluid [adj]\n",
  "FLUIDLY": "FLUID, flowing [adv]\n",
  "FLUIDNESS": "the state of being fluid [n -ES]\n",
  "FLUIDNESSES": "FLUIDNESS, the state of being fluid [n]\n",
  "FLUIDRAM": "a unit of liquid capacity [n -S]\n",
  "FLUIDRAMS": "FLUIDRAM, a unit of liquid capacity [n]\n",
  "FLUIDS": "FLUID, a substance that tends to flow [n]\n",
  "FLUIER": "FLUEY, infected with the flu [adj]\n",
  "FLUIEST": "FLUEY, infected with the flu [adj]\n",
  "FLUISH": "having flu to some extent [adj]\n",
  "FLUKE": "to obtain by chance [v FLUKED, FLUKING, FLUKES]\n",
  "FLUKED": "FLUKE, to obtain by chance [v]\n",
  "FLUKES": "FLUKE, to obtain by chance [v]\n",
  "FLUKEY": "lucky, by accidental success, also FLUKY [adj]\n",
  "FLUKIER": "FLUKY, lucky, by accidental success, also FLUKEY [adj]\n",
  "FLUKIEST": "FLUKY, lucky, by accidental success, also FLUKEY [adj]\n",
  "FLUKILY": "FLUKY, lucky, by accidental success, also FLUKEY [adv]\n",
  "FLUKINESS": "the state of being fluky [n -ES]\n",
  "FLUKINESSES": "FLUKINESS, the state of being fluky [n]\n",
  "FLUKING": "FLUKE, to obtain by chance [v]\n",
  "FLUKY": "lucky, by accidental success, also FLUKEY [adj FLUKIER, FLUKIEST, FLUKILY]\n",
  "FLUME": "to convey by an artificial water channel [v FLUMED, FLUMING, FLUMES]\n",
  "FLUMED": "FLUME, to convey by an artificial water channel [v]\n",
  "FLUMES": "FLUME, to convey by an artificial water channel [v]\n",
  "FLUMING": "FLUME, to convey by an artificial water channel [v]\n",
  "FLUMMERIES": "FLUMMERY, (Welsh) a sweet dessert [n]\n",
  "FLUMMERY": "(Welsh) a sweet dessert [n FLUMMERIES]\n",
  "FLUMMOX": "to confuse [v FLUMMOXED, FLUMMOXING, FLUMMOXES]\n",
  "FLUMMOXED": "FLUMMOX, to confuse [v]\n",
  "FLUMMOXES": "FLUMMOX, to confuse [v]\n",
  "FLUMMOXING": "FLUMMOX, to confuse [v]\n",
  "FLUMP": "to fall or move heavily [v -ED, -ING, -S]\n",
  "FLUMPED": "FLUMP, to fall or move heavily [v]\n",
  "FLUMPING": "FLUMP, to fall or move heavily [v]\n",
  "FLUMPS": "FLUMP, to fall or move heavily [v]\n",
  "FLUNG": "FLING, to throw with force [v]\n",
  "FLUNITRAZEPAM": "a powerful hypnotic drug with relaxant properties [n -S]\n",
  "FLUNITRAZEPAMS": "FLUNITRAZEPAM, a powerful hypnotic drug with relaxant properties [n]\n",
  "FLUNK": "to fail in an examination [v -ED, -ING, -S]\n",
  "FLUNKED": "FLUNK, to fail in an examination [v]\n",
  "FLUNKER": "something or someone that flunks [n -S]\n",
  "FLUNKERS": "FLUNKER, something or someone that flunks [n]\n",
  "FLUNKEY": "a servile follower, also FLUNKIE, FLUNKY [n -S]\n",
  "FLUNKEYDOM": "the world of flunkeys [n -S]\n",
  "FLUNKEYDOMS": "FLUNKEYDOM, the world of flunkeys [n]\n",
  "FLUNKEYISH": "like a flunkey [adj]\n",
  "FLUNKEYISM": "the state of being a flunkey [n -S]\n",
  "FLUNKEYISMS": "FLUNKEYISM, the state of being a flunkey [n]\n",
  "FLUNKEYS": "FLUNKEY, a servile follower, also FLUNKIE, FLUNKY [n]\n",
  "FLUNKIE": "a servile follower, also FLUNKY, FLUNKEY [n -S]\n",
  "FLUNKIES": "FLUNKY, a servile follower, also FLUNKIE, FLUNKEY [n]\n",
  "FLUNKING": "FLUNK, to fail in an examination [v]\n",
  "FLUNKS": "FLUNK, to fail in an examination [v]\n",
  "FLUNKY": "a servile follower, also FLUNKIE, FLUNKEY [n FLUNKIES]\n",
  "FLUNKYISM": "the state of being a flunky [n -S]\n",
  "FLUNKYISMS": "FLUNKYISM, the state of being a flunky [n]\n",
  "FLUOR": "(Latin) a mineral form of calcium fluoride, also FLUORITE [n -S]\n",
  "FLUORAPATITE": "a mineral consisting of calcium phosphate fluoride, the most common form of apatite [n -S]\n",
  "FLUORAPATITES": "FLUORAPATITE, a mineral consisting of calcium phosphate fluoride, the most common form of apatite [n]\n",
  "FLUORENE": "a colorless, crystalline hydrocarbon, having a beautiful violet fluorescence [n -S]\n",
  "FLUORENES": "FLUORENE, a colorless, crystalline hydrocarbon, having a beautiful violet fluorescence [n]\n",
  "FLUORESCE": "to demonstrate fluorescence [v FLUORESCED, FLUORESCING, FLUORESCES]\n",
  "FLUORESCED": "FLUORESCE, to demonstrate fluorescence [v]\n",
  "FLUORESCEIN": "a fluorescent dyestuff, also FLUORESCEINE [n -S]\n",
  "FLUORESCEINE": "a fluorescent dyestuff, also FLUORESCEIN [n -S]\n",
  "FLUORESCEINES": "FLUORESCEINE, a fluorescent dyestuff, also FLUORESCEIN [n]\n",
  "FLUORESCEINS": "FLUORESCEIN, a fluorescent dyestuff, also FLUORESCEINE [n]\n",
  "FLUORESCENCE": "visible light emitted from a material while it is exposed to ultraviolet radiation, aka black light [n -S]\n",
  "FLUORESCENCES": "FLUORESCENCE, visible light emitted from a material while it is exposed to ultraviolet radiation, aka black light [n]\n",
  "FLUORESCENT": "showing fluorescence [adj] / a substance showing fluorescence [n -S]\n",
  "FLUORESCENTS": "FLUORESCENT, a substance showing fluorescence [n]\n",
  "FLUORESCER": "something e.g. a mineral that fluoresces [n -S]\n",
  "FLUORESCERS": "FLUORESCER, something e.g. a mineral that fluoresces [n]\n",
  "FLUORESCES": "FLUORESCE, to demonstrate fluorescence [v]\n",
  "FLUORESCING": "FLUORESCE, to demonstrate fluorescence [v]\n",
  "FLUORIC": "pertaining to, obtained from, or containing, fluorine [adj]\n",
  "FLUORID": "a compound of fluorine, also FLUORIDE [n -S]\n",
  "FLUORIDATE": "to add fluoride to drinking water [v FLUORIDATED, FLUORIDATING, FLUORIDATES]\n",
  "FLUORIDATED": "FLUORIDATE, to add fluoride to drinking water [v]\n",
  "FLUORIDATES": "FLUORIDATE, to add fluoride to drinking water [v]\n",
  "FLUORIDATING": "FLUORIDATE, to add fluoride to drinking water [v]\n",
  "FLUORIDATION": "the act of fluoridating [n -S]\n",
  "FLUORIDATIONS": "FLUORIDATION, the act of fluoridating [n]\n",
  "FLUORIDE": "a compound of fluorine, also FLUORID [n -S]\n",
  "FLUORIDES": "FLUORIDE, a compound of fluorine, also FLUORID [n]\n",
  "FLUORIDISE": "to add fluoride to drinking water, also FLUORIDIZE [v FLUORIDISED, FLUORIDISING, FLUORIDISES]\n",
  "FLUORIDISED": "FLUORIDISE, to add fluoride to drinking water, also FLUORIDIZE [v]\n",
  "FLUORIDISES": "FLUORIDISE, to add fluoride to drinking water, also FLUORIDIZE [v]\n",
  "FLUORIDISING": "FLUORIDISE, to add fluoride to drinking water, also FLUORIDIZE [v]\n",
  "FLUORIDIZE": "to add fluoride to drinking water, also FLUORIDISE [v FLUORIDIZED, FLUORIDIZING, FLUORIDIZES]\n",
  "FLUORIDIZED": "FLUORIDIZE, to add fluoride to drinking water, also FLUORIDISE [v]\n",
  "FLUORIDIZES": "FLUORIDIZE, to add fluoride to drinking water, also FLUORIDISE [v]\n",
  "FLUORIDIZING": "FLUORIDIZE, to add fluoride to drinking water, also FLUORIDISE [v]\n",
  "FLUORIDS": "FLUORID, a compound of fluorine, also FLUORIDE [n]\n",
  "FLUORIMETER": "an instrument for measuring fluorescence, also FLUOROMETER [n -S]\n",
  "FLUORIMETERS": "FLUORIMETER, an instrument for measuring fluorescence, also FLUOROMETER [n]\n",
  "FLUORIMETRIC": "relating to fluorometry [adj]\n",
  "FLUORIMETRIES": "FLUORIMETRY, measurement by fluorimeter, also FLUOROMETRY [n]\n",
  "FLUORIMETRY": "measurement by fluorimeter, also FLUOROMETRY [n FLUORIMETRIES]\n",
  "FLUORIN": "a gaseous element, also FLUORINE [n -S]\n",
  "FLUORINATE": "to introduce fluorine into a chemical compound [v FLUORINATED, FLUORINATING, FLUORINATES]\n",
  "FLUORINATED": "FLUORINATE, to introduce fluorine into a chemical compound [v]\n",
  "FLUORINATES": "FLUORINATE, to introduce fluorine into a chemical compound [v]\n",
  "FLUORINATING": "FLUORINATE, to introduce fluorine into a chemical compound [v]\n",
  "FLUORINATION": "the act of fluorinating [n -S]\n",
  "FLUORINATIONS": "FLUORINATION, the act of fluorinating [n]\n",
  "FLUORINE": "a gaseous element, also FLUORIN [n -S]\n",
  "FLUORINES": "FLUORINE, a gaseous element, also FLUORIN [n]\n",
  "FLUORINS": "FLUORIN, a gaseous element, also FLUORINE [n]\n",
  "FLUORITE": "a mineral form of calcium fluoride, also FLUOR [n -S]\n",
  "FLUORITES": "FLUORITE, a mineral form of calcium fluoride, also FLUOR [n]\n",
  "FLUOROACETATE": "an organofluorine compound [n -S]\n",
  "FLUOROACETATES": "FLUOROACETATE, an organofluorine compound [n]\n",
  "FLUOROCARBON": "any of a series of compounds of fluorine and carbon [n -S]\n",
  "FLUOROCARBONS": "FLUOROCARBON, any of a series of compounds of fluorine and carbon [n]\n",
  "FLUOROCHROME": "any of various fluorescent substances used in biological staining to produce fluorescence in a specimen [n -S]\n",
  "FLUOROCHROMES": "FLUOROCHROME, any of various fluorescent substances used in biological staining to produce fluorescence in a specimen [n]\n",
  "FLUOROGRAPHIC": "relating to fluorography [adj]\n",
  "FLUOROGRAPHIES": "FLUOROGRAPHY, the photography of the image produced on a fluorescent screen by X rays [n]\n",
  "FLUOROGRAPHY": "the photography of the image produced on a fluorescent screen by X rays [n FLUOROGRAPHIES]\n",
  "FLUOROMETER": "an instrument for measuring fluorescence, also FLUORIMETER [n -S]\n",
  "FLUOROMETERS": "FLUOROMETER, an instrument for measuring fluorescence, also FLUORIMETER [n]\n",
  "FLUOROMETRIC": "relating to fluorometry [adj]\n",
  "FLUOROMETRIES": "FLUOROMETRY, measurement by fluorometer, also FLUORIMETRY [n]\n",
  "FLUOROMETRY": "measurement by fluorometer, also FLUORIMETRY [n FLUOROMETRIES]\n",
  "FLUOROPHORE": "a chemical group responsible for fluorescence [n -S]\n",
  "FLUOROPHORES": "FLUOROPHORE, a chemical group responsible for fluorescence [n]\n",
  "FLUOROPHOSPHATE": "a mineral compound of fluorine and phosphorus [n]\n",
  "FLUOROSCOPE": "an instrument using X-rays to examine the internal structure of opaque object [n -S] / to examine by fluoroscope [v FLUOROSCOPED, FLUOROSCOPING, FLUOROSCOPES]\n",
  "FLUOROSCOPED": "FLUOROSCOPE, to examine by fluoroscope [v]\n",
  "FLUOROSCOPES": "FLUOROSCOPE, to examine by fluoroscope [v]\n",
  "FLUOROSCOPIC": "of or like a fluoroscope [adj]\n",
  "FLUOROSCOPIES": "FLUOROSCOPY, examination with a fluoroscope [n]\n",
  "FLUOROSCOPING": "FLUOROSCOPE, to examine by fluoroscope [v]\n",
  "FLUOROSCOPIST": "one who uses a fluoroscope [n -S]\n",
  "FLUOROSCOPISTS": "FLUOROSCOPIST, one who uses a fluoroscope [n]\n",
  "FLUOROSCOPY": "examination with a fluoroscope [n FLUOROSCOPIES]\n",
  "FLUOROSES": "FLUOROSIS, an abnormal condition due to excess fluoride, involving mottling of the teeth [n]\n",
  "FLUOROSIS": "an abnormal condition due to excess fluoride, involving mottling of the teeth [n FLUOROSES]\n",
  "FLUOROTIC": "relating to fluorosis, an abnormal condition due to excess fluoride, involving mottling of the teeth [adj]\n",
  "FLUOROTYPE": "(obsolete) photography by means of fluorides [n -S]\n",
  "FLUOROTYPES": "FLUOROTYPE, (obsolete) photography by means of fluorides [n]\n",
  "FLUOROURACIL": "a fluorine-containing pyrimidine base used as a neoplastic agent to treat some kinds of cancer [n -S]\n",
  "FLUOROURACILS": "FLUOROURACIL, a fluorine-containing pyrimidine base used as a neoplastic agent to treat some kinds of cancer [n]\n",
  "FLUORS": "FLUOR, (Latin) a mineral form of calcium fluoride, also FLUORITE [n]\n",
  "FLUORSPAR": "a mineral, calcium fluoride, also FLUOR, FLUORITE [n -S]\n",
  "FLUORSPARS": "FLUORSPAR, a mineral, calcium fluoride, also FLUOR, FLUORITE [n]\n",
  "FLUOXETINE": "an antidepressant drug that increases the levels of serotonin in the central nervous system [n -S]\n",
  "FLUOXETINES": "FLUOXETINE, an antidepressant drug that increases the levels of serotonin in the central nervous system [n]\n",
  "FLUPHENAZINE": "a tranquilizer used esp. in the form of its hydrochloride [n -S]\n",
  "FLUPHENAZINES": "FLUPHENAZINE, a tranquilizer used esp. in the form of its hydrochloride [n]\n",
  "FLURR": "to scatter [v -ED, -ING, -S]\n",
  "FLURRED": "FLURR, to scatter [v]\n",
  "FLURRIED": "FLURRY, to agitate [v]\n",
  "FLURRIES": "FLURRY, to agitate [v]\n",
  "FLURRING": "FLURR, to scatter [v]\n",
  "FLURRS": "FLURR, to scatter [v]\n",
  "FLURRY": "to agitate [v FLURRIED, FLURRYING, FLURRIES]\n",
  "FLURRYING": "FLURRY, to agitate [v]\n",
  "FLUS": "FLU, a virus disease [n]\n",
  "FLUSH": "to clean by a gush of water [v -ED, -ING, -ES] / with ample money [adj FLUSHER, FLUSHEST]\n",
  "FLUSHABLE": "that can be flushed [adj]\n",
  "FLUSHED": "FLUSH, to clean by a gush of water [v]\n",
  "FLUSHER": "someone who flushes sewers [n -S]\n",
  "FLUSHERS": "FLUSHER, someone who flushes sewers [n]\n",
  "FLUSHES": "FLUSH, to clean by a gush of water [v]\n",
  "FLUSHEST": "FLUSH, with ample money [adj]\n",
  "FLUSHIER": "FLUSHY, red-complexioned [adj]\n",
  "FLUSHIEST": "FLUSHY, red-complexioned [adj]\n",
  "FLUSHING": "an extra feeding given to ewes before mating to increase the lambing percentage [n -S]\n",
  "FLUSHINGS": "FLUSHING, an extra feeding given to ewes before mating to increase the lambing percentage [n]\n",
  "FLUSHNESS": "the state of being flush; abundance [n -ES]\n",
  "FLUSHNESSES": "FLUSHNESS, the state of being flush; abundance [n]\n",
  "FLUSHWORK": "decorative treatment of the surface of an outside wall with flints split to show their smooth black surface [n -S]\n",
  "FLUSHWORKS": "FLUSHWORK, decorative treatment of the surface of an outside wall with flints split to show their smooth black surface [n]\n",
  "FLUSHY": "red-complexioned [adj FLUSHIER, FLUSHIEST]\n",
  "FLUSTER": "to put into a state of nervous confusion [v -ED, -ING, -S]\n",
  "FLUSTERED": "FLUSTER, to put into a state of nervous confusion [v]\n",
  "FLUSTEREDLY": "FLUSTERED, FLUSTER, to put into a state of nervous confusion [adv]\n",
  "FLUSTERIER": "FLUSTERY, confused [adj]\n",
  "FLUSTERIEST": "FLUSTERY, confused [adj]\n",
  "FLUSTERING": "FLUSTER, to put into a state of nervous confusion [v]\n",
  "FLUSTERMENT": "the state of being flustered [n -S]\n",
  "FLUSTERMENTS": "FLUSTERMENT, the state of being flustered [n]\n",
  "FLUSTERS": "FLUSTER, to put into a state of nervous confusion [v]\n",
  "FLUSTERY": "confused [adj FLUSTERIER, FLUSTERIEST]\n",
  "FLUSTRATE": "(obsolete) to fluster [v FLUSTRATED, FLUSTRATING, FLUSTRATES]\n",
  "FLUSTRATED": "FLUSTRATE, (obsolete) to fluster [v]\n",
  "FLUSTRATES": "FLUSTRATE, (obsolete) to fluster [v]\n",
  "FLUSTRATING": "FLUSTRATE, (obsolete) to fluster [v]\n",
  "FLUSTRATION": "(obsolete) flustering [n -S]\n",
  "FLUSTRATIONS": "FLUSTRATION, (obsolete) flustering [n]\n",
  "FLUTE": "to play on a woodwind instrument [v FLUTED, FLUTING, FLUTES]\n",
  "FLUTED": "FLUTE, to play on a woodwind instrument [v]\n",
  "FLUTELIKE": "like a flute [adj]\n",
  "FLUTEMOUTH": "a fish of the genus Aulostoma, having a much elongated tubular snout [n -S]\n",
  "FLUTEMOUTHS": "FLUTEMOUTH, a fish of the genus Aulostoma, having a much elongated tubular snout [n]\n",
  "FLUTER": "one who plays the flute, also FLUTIST, FLAUTIST [n -S]\n",
  "FLUTERS": "FLUTER, one who plays the flute, also FLUTIST, FLAUTIST [n]\n",
  "FLUTES": "FLUTE, to play on a woodwind instrument [v]\n",
  "FLUTEY": "like a flute in tone, also FLUTY [adj FLUTEYER, FLUTEYEST]\n",
  "FLUTEYER": "FLUTEY, like a flute in tone, also FLUTY [adj]\n",
  "FLUTEYEST": "FLUTEY, like a flute in tone, also FLUTY [adj]\n",
  "FLUTIER": "FLUTY, resembling a flute in sound, also FLUTEY [adj]\n",
  "FLUTIEST": "FLUTY, resembling a flute in sound, also FLUTEY [adj]\n",
  "FLUTINA": "a type of accordion [n -S]\n",
  "FLUTINAS": "FLUTINA, a type of accordion [n]\n",
  "FLUTING": "a series of parallel grooves [n -S]\n",
  "FLUTINGS": "FLUTING, a series of parallel grooves [n]\n",
  "FLUTIST": "one who plays the flute, also FLAUTIST, FLUTER [n -S]\n",
  "FLUTISTS": "FLUTIST, one who plays the flute, also FLAUTIST, FLUTER [n]\n",
  "FLUTTER": "to move in quick motions, also FLITTER [v -ED, -ING, -S]\n",
  "FLUTTERBOARD": "a kind of swimming aid, a kickboard [n -S]\n",
  "FLUTTERBOARDS": "FLUTTERBOARD, a kind of swimming aid, a kickboard [n]\n",
  "FLUTTERED": "FLUTTER, to move in quick motions, also FLITTER [v]\n",
  "FLUTTERER": "one who flutters [n -S]\n",
  "FLUTTERERS": "FLUTTERER, one who flutters [n]\n",
  "FLUTTERIER": "FLUTTERY, marked by fluttering [adj]\n",
  "FLUTTERIEST": "FLUTTERY, marked by fluttering [adj]\n",
  "FLUTTERING": "vibrating or move quickly [adj FLUTTERINGLY] / the act of fluttering [n -S]\n",
  "FLUTTERINGLY": "FLUTTERING [adv]\n",
  "FLUTTERINGS": "FLUTTERING, the act of fluttering [n]\n",
  "FLUTTERS": "FLUTTER, to move in quick motions, also FLITTER [v]\n",
  "FLUTTERY": "marked by fluttering [adj FLUTTERIER, FLUTTERIEST]\n",
  "FLUTY": "resembling a flute in sound, also FLUTEY [adj FLUTIER, FLUTIEST]\n",
  "FLUVIAL": "of or relating to a river or stream [adj]\n",
  "FLUVIALIST": "one stressing the role of rivers in explanation [n -S]\n",
  "FLUVIALISTS": "FLUVIALIST, one stressing the role of rivers in explanation [n]\n",
  "FLUVIATIC": "belonging to or formed by rivers or streams, also FLUVIATILE [adj]\n",
  "FLUVIATILE": "belonging to or formed by rivers or streams, also FLUVIATIC [adj]\n",
  "FLUVIOMARINE": "of deposits, formed by joint action of the sea and a river or stream [adj]\n",
  "FLUVOXAMINE": "an antidepressant predominantly used to treat obsessive-compulsive disorder [n -S]\n",
  "FLUVOXAMINES": "FLUVOXAMINE, an antidepressant predominantly used to treat obsessive-compulsive disorder [n]\n",
  "FLUX": "to melt, also FLIX [v -ED, -ING, -ES]\n",
  "FLUXED": "FLUX, to melt, also FLIX [v]\n",
  "FLUXES": "FLUX, to melt, also FLIX [v]\n",
  "FLUXGATE": "a device for measuring a magnetic field [n -S]\n",
  "FLUXGATES": "FLUXGATE, a device for measuring a magnetic field [n]\n",
  "FLUXING": "FLUX, to melt, also FLIX [v]\n",
  "FLUXION": "the act of flowing [n -S]\n",
  "FLUXIONAL": "(archaic) variable; inconstant [adj FLUXIONALLY]\n",
  "FLUXIONALLY": "FLUXIONAL, (archaic) variable; inconstant [adv]\n",
  "FLUXIONARY": "(archaic) variable, inconstant [adj]\n",
  "FLUXIONIST": "one skilled in fluxions [n -S]\n",
  "FLUXIONISTS": "FLUXIONIST, one skilled in fluxions [n]\n",
  "FLUXIONS": "FLUXION, the act of flowing [n]\n",
  "FLUXIVE": "(Shakespeare) flowing with tears [adj]\n",
  "FLUXMETER": "any instrument for measuring magnetic flux [n -S]\n",
  "FLUXMETERS": "FLUXMETER, any instrument for measuring magnetic flux [n]\n",
  "FLUYT": "(Dutch) a small 17th century merchant ship [n -S]\n",
  "FLUYTS": "FLUYT, (Dutch) a small 17th century merchant ship [n]\n",
  "FLY": "shrewd, knowing [adj FLIER or FLYER, FLIEST or FLYEST] / to move through the air [v FLEW, FLOWN, FLYING, FLIES] / to hit a ball high in the air in baseball [v FLIED, FLYING, FLIES]\n",
  "FLYABLE": "suitable for flying [adj]\n",
  "FLYAWAY": "one that is elusive [n -S]\n",
  "FLYAWAYS": "FLYAWAY, one that is elusive [n]\n",
  "FLYBACK": "the rapid return of the spot on a cathode ray tube after it finishes a line [n -S]\n",
  "FLYBACKS": "FLYBACK, the rapid return of the spot on a cathode ray tube after it finishes a line [n]\n",
  "FLYBANE": "a name for various poisonous plants [n -S]\n",
  "FLYBANES": "FLYBANE, a name for various poisonous plants [n]\n",
  "FLYBELT": "an area infested with tsetse flies [n -S]\n",
  "FLYBELTS": "FLYBELT, an area infested with tsetse flies [n]\n",
  "FLYBLEW": "FLYBLOW, to taint with the egg of a fly [v]\n",
  "FLYBLOW": "to taint with the egg of a fly [v FLYBLEW, FLYBLOWN, FLYBLOWING, FLYBLOWS]\n",
  "FLYBLOWING": "FLYBLOW, to taint with the egg of a fly [v]\n",
  "FLYBLOWN": "FLYBLOW, to taint with the egg of a fly [v]\n",
  "FLYBLOWS": "FLYBLOW, to taint with the egg of a fly [v]\n",
  "FLYBOAT": "a small fast boat [n -S]\n",
  "FLYBOATS": "FLYBOAT, a small fast boat [n]\n",
  "FLYBOOK": "a case like a book used to hold fishing flies [n -S]\n",
  "FLYBOOKS": "FLYBOOK, a case like a book used to hold fishing flies [n]\n",
  "FLYBOY": "a pilot in the air force [n -S]\n",
  "FLYBOYS": "FLYBOY, a pilot in the air force [n]\n",
  "FLYBRIDGE": "an open deck on a cabin cruiser [n -S]\n",
  "FLYBRIDGES": "FLYBRIDGE, an open deck on a cabin cruiser [n]\n",
  "FLYBY": "a flight, at low altitude or close range, also FLYPAST [n -S]\n",
  "FLYBYS": "FLYBY, a flight, at low altitude or close range, also FLYPAST [n]\n",
  "FLYCATCHER": "one of numerous species of birds that feed upon insects, which they take on the wing [n -S]\n",
  "FLYCATCHERS": "FLYCATCHER, one of numerous species of birds that feed upon insects, which they take on the wing [n]\n",
  "FLYER": "one that flies, also FLIER [n -S]\n",
  "FLYERS": "FLYER, one that flies, also FLIER [n]\n",
  "FLYEST": "FLY, shrewd, knowing [adj]\n",
  "FLYFISHER": "an angler who fishes with a fly [n -S]\n",
  "FLYFISHERS": "FLYFISHER, an angler who fishes with a fly [n]\n",
  "FLYHAND": "a device for transferring printed sheets from the presses to a flat pile [n -S]\n",
  "FLYHANDS": "FLYHAND, a device for transferring printed sheets from the presses to a flat pile [n]\n",
  "FLYING": "the operation of an aircraft [n -S]\n",
  "FLYINGS": "FLYING, the operation of an aircraft [n]\n",
  "FLYLEAF": "a blank page at the beginning or end of a book [n FLYLEAVES]\n",
  "FLYLEAVES": "FLYLEAF, a blank page at the beginning or end of a book [n]\n",
  "FLYLESS": "free of flies (winged insects) [adj]\n",
  "FLYLINE": "a type of line used in fly fishing [n -S]\n",
  "FLYLINES": "FLYLINE, a type of line used in fly fishing [n]\n",
  "FLYMAKER": "one who ties flies for fishing [n -S]\n",
  "FLYMAKERS": "FLYMAKER, one who ties flies for fishing [n]\n",
  "FLYMAN": "the driver of a fly, or light public carriage [n FLYMEN]\n",
  "FLYMEN": "FLYMAN, the driver of a fly, or light public carriage [n]\n",
  "FLYOFF": "a competitive testing of model aircraft [n -S]\n",
  "FLYOFFS": "FLYOFF, a competitive testing of model aircraft [n]\n",
  "FLYOVER": "a flight of aircraft over a specific location [n -S]\n",
  "FLYOVERS": "FLYOVER, a flight of aircraft over a specific location [n]\n",
  "FLYPAPER": "a sticky paper designed to catch and imprison flies [n -S]\n",
  "FLYPAPERS": "FLYPAPER, a sticky paper designed to catch and imprison flies [n]\n",
  "FLYPAST": "a flight, at low altitude or close range, also FLYBY [n -S]\n",
  "FLYPASTS": "FLYPAST, a flight, at low altitude or close range, also FLYBY [n]\n",
  "FLYPE": "to strip back, to turn partly inside out e.g. a hat-brim [v FLYPED, FLYPING, FLYPES]\n",
  "FLYPED": "FLYPE, to strip back, to turn partly inside out e.g. a hat-brim [v]\n",
  "FLYPES": "FLYPE, to strip back, to turn partly inside out e.g. a hat-brim [v]\n",
  "FLYPING": "FLYPE, to strip back, to turn partly inside out e.g. a hat-brim [v]\n",
  "FLYPITCH": "an unlicensed market stall [n -ES]\n",
  "FLYPITCHER": "one who runs a flypitch, a market stall for which an operator has no licence [n -S]\n",
  "FLYPITCHERS": "FLYPITCHER, one who runs a flypitch, a market stall for which an operator has no licence [n]\n",
  "FLYPITCHES": "FLYPITCH, an unlicensed market stall [n]\n",
  "FLYPOSTER": "one who engages in FLYPOSTING [n -S]\n",
  "FLYPOSTERS": "FLYPOSTER, one who engages in FLYPOSTING [n]\n",
  "FLYPOSTING": "putting up advertising stickers without authorisation [n -S]\n",
  "FLYPOSTINGS": "FLYPOSTING, putting up advertising stickers without authorisation [n]\n",
  "FLYRODDER": "an angler using artificial fly [n -S]\n",
  "FLYRODDERS": "FLYRODDER, an angler using artificial fly [n]\n",
  "FLYSCH": "(German) a great Alpine mass of Cretaceous and Lower Tertiary sandstone with shales [n -ES]\n",
  "FLYSCHES": "FLYSCH, (German) a great Alpine mass of Cretaceous and Lower Tertiary sandstone with shales [n]\n",
  "FLYSCREEN": "a wire-mesh screen over a window to prevent flies from entering a room [n -S]\n",
  "FLYSCREENS": "FLYSCREEN, a wire-mesh screen over a window to prevent flies from entering a room [n]\n",
  "FLYSHEET": "part of a tent [n -S]\n",
  "FLYSHEETS": "FLYSHEET, part of a tent [n]\n",
  "FLYSPECK": "to mark with minute spots [v -ED, -ING, -S]\n",
  "FLYSPECKED": "FLYSPECK, to mark with minute spots [v]\n",
  "FLYSPECKING": "FLYSPECK, to mark with minute spots [v]\n",
  "FLYSPECKS": "FLYSPECK, to mark with minute spots [v]\n",
  "FLYSPRAY": "an insecticide, or the aerosol containing it [n -S]\n",
  "FLYSPRAYS": "FLYSPRAY, an insecticide, or the aerosol containing it [n]\n",
  "FLYSTRIKE": "the infestation of wounded sheep by blowflies or maggots [n -S]\n",
  "FLYSTRIKES": "FLYSTRIKE, the infestation of wounded sheep by blowflies or maggots [n]\n",
  "FLYSWATTER": "a device for killing insects that consists of a flat piece of perforated rubber or plastic or fine-mesh wire netting attached to a handle [n -S]\n",
  "FLYSWATTERS": "FLYSWATTER, a device for killing insects that consists of a flat piece of perforated rubber or plastic or fine-mesh wire netting attached to a handle [n]\n",
  "FLYTE": "(Scots) to quarrel, brawl, also FLITE [v FLYTED, FLYTING, FLYTES]\n",
  "FLYTED": "FLYTE, (Scots) to quarrel, brawl, also FLITE [v]\n",
  "FLYTES": "FLYTE, (Scots) to quarrel, brawl, also FLITE [v]\n",
  "FLYTIER": "a maker of fishing flies [n -S]\n",
  "FLYTIERS": "FLYTIER, a maker of fishing flies [n]\n",
  "FLYTING": "a dispute in verse form [n -S]\n",
  "FLYTINGS": "FLYTING, a dispute in verse form [n]\n",
  "FLYTRAP": "a trap for catching flies [n -S]\n",
  "FLYTRAPS": "FLYTRAP, a trap for catching flies [n]\n",
  "FLYWAY": "an established air route of migratory birds [n -S]\n",
  "FLYWAYS": "FLYWAY, an established air route of migratory birds [n]\n",
  "FLYWEIGHT": "in professional boxing, the lowest weight [n -S]\n",
  "FLYWEIGHTS": "FLYWEIGHT, in professional boxing, the lowest weight [n]\n",
  "FLYWHEEL": "a heavy disk used in machinery [n -S]\n",
  "FLYWHEELS": "FLYWHEEL, a heavy disk used in machinery [n]\n",
  "FOAL": "to give birth to a horse [v -ED, -ING, -S]\n",
  "FOALED": "FOAL, to give birth to a horse [v]\n",
  "FOALFOOT": "a plant with large soft leaves, aka coltsfoot [n -S]\n",
  "FOALFOOTS": "FOALFOOT, a plant with large soft leaves, aka coltsfoot [n]\n",
  "FOALING": "the act of giving birth to a foal [n -S]\n",
  "FOALINGS": "FOALING, the act of giving birth to a foal [n]\n",
  "FOALS": "FOAL, to give birth to a horse [v]\n",
  "FOAM": "to form froth or bubbles [v -ED, -ING, -S]\n",
  "FOAMABLE": "able to foam [adj]\n",
  "FOAMED": "FOAM, to form froth or bubbles [v]\n",
  "FOAMER": "something that foams [n -S]\n",
  "FOAMERS": "FOAMER, something that foams [n]\n",
  "FOAMFLOWER": "an American woodland spring-flowering herb [n -S]\n",
  "FOAMFLOWERS": "FOAMFLOWER, an American woodland spring-flowering herb [n]\n",
  "FOAMIER": "FOAMY, covered with foam [adj]\n",
  "FOAMIEST": "FOAMY, covered with foam [adj]\n",
  "FOAMILY": "FOAMY, covered with foam [adv]\n",
  "FOAMINESS": "being foamy [n -ES]\n",
  "FOAMINESSES": "FOAMINESS, being foamy [n]\n",
  "FOAMING": "the act of foaming [n -S]\n",
  "FOAMINGLY": "FOAMING [adv]\n",
  "FOAMINGS": "FOAMING, the act of foaming [n]\n",
  "FOAMLESS": "without foam [adj]\n",
  "FOAMLIKE": "like foam [adj]\n",
  "FOAMS": "FOAM, to form froth or bubbles [v]\n",
  "FOAMY": "covered with foam [adj FOAMIER, FOAMIEST, FOAMILY]\n",
  "FOB": "to cheat, also FUB [v FOBBED, FOBBING, FOBS]\n",
  "FOBBED": "FOB, to cheat, also FUB [v]\n",
  "FOBBING": "FOB, to cheat, also FUB [v]\n",
  "FOBS": "FOB, to cheat, also FUB [v]\n",
  "FOCACCIA": "(Italian) a flat Italian bread [n -S]\n",
  "FOCACCIAS": "FOCACCIA, (Italian) a flat Italian bread [n]\n",
  "FOCAL": "pertaining to a focus [adj FOCALLY]\n",
  "FOCALISATION": "the act of focalising, also FOCALIZATION [n -S]\n",
  "FOCALISATIONS": "FOCALISATION, the act of focalising, also FOCALIZATION [n]\n",
  "FOCALISE": "to focus, also FOCALIZE [v FOCALISED, FOCALISING, FOCALISES]\n",
  "FOCALISED": "FOCALISE, to focus, also FOCALIZE [v]\n",
  "FOCALISES": "FOCALISE, to focus, also FOCALIZE [v]\n",
  "FOCALISING": "FOCALISE, to focus, also FOCALIZE [v]\n",
  "FOCALIZATION": "the act of focalizing, also FOCALISATION [n -S]\n",
  "FOCALIZATIONS": "FOCALIZATION, the act of focalizing, also FOCALISATION [n]\n",
  "FOCALIZE": "to focus, also FOCALISE [v FOCALIZED, FOCALIZING, FOCALIZES]\n",
  "FOCALIZED": "FOCALIZE, to focus, also FOCALISE [v]\n",
  "FOCALIZES": "FOCALIZE, to focus, also FOCALISE [v]\n",
  "FOCALIZING": "FOCALIZE, to focus, also FOCALISE [v]\n",
  "FOCALLY": "FOCAL, pertaining to a focus [adv]\n",
  "FOCI": "FOCUS, (Latin) a point in which rays converge [n]\n",
  "FOCIMETER": "an instrument for measuring the focal length of a lens, also FOCOMETER [n -S]\n",
  "FOCIMETERS": "FOCIMETER, an instrument for measuring the focal length of a lens, also FOCOMETER [n]\n",
  "FOCOMETER": "an instrument for measuring the focal length of a lens, also FOCIMETER [n -S]\n",
  "FOCOMETERS": "FOCOMETER, an instrument for measuring the focal length of a lens, also FOCIMETER [n]\n",
  "FOCUS": "(Latin) a point in which rays converge [n FOCUSES or FOCI] / to bring or adjust to a point [v FOCUSED or FOCUSSED, FOCUSING or FOCUSSING, FOCUSES or FOCUSSES]\n",
  "FOCUSABLE": "able to be focused [adj]\n",
  "FOCUSED": "FOCUS, to bring or adjust to a point [v]\n",
  "FOCUSER": "a device to assist focussing [n -S]\n",
  "FOCUSERS": "FOCUSER, a device to assist focussing [n]\n",
  "FOCUSES": "FOCUS, to bring or adjust to a point [v]\n",
  "FOCUSING": "the act of bringing into focus [n -S]\n",
  "FOCUSINGS": "FOCUSING, the act of bringing into focus [n]\n",
  "FOCUSLESS": "without focus [adj]\n",
  "FOCUSSED": "FOCUS, to bring or adjust to a point [v]\n",
  "FOCUSSES": "FOCUS, to bring or adjust to a point [v]\n",
  "FOCUSSING": "FOCUS, to bring or adjust to a point [v]\n",
  "FODDER": "to feed cattle with dried food [v -ED, -ING, -S]\n",
  "FODDERED": "FODDER, to feed cattle with dried food [v]\n",
  "FODDERER": "someone who supplies fodder [n -S]\n",
  "FODDERERS": "FODDERER, someone who supplies fodder [n]\n",
  "FODDERING": "the act of providing fodder [n -S]\n",
  "FODDERINGS": "FODDERING, the act of providing fodder [n]\n",
  "FODDERS": "FODDER, to feed cattle with dried food [v]\n",
  "FODGEL": "(Scots) plump and solidly built; buxom [adj]\n",
  "FOE": "an enemy [n FOES or (Spenser) FOEN or FONE]\n",
  "FOEDARIE": "(Shakespeare) a confederate, also FEDARIE, FEDERARIE, FEDERARY [n -S]\n",
  "FOEDARIES": "FOEDARIE, (Shakespeare) a confederate, also FEDARIE, FEDERARIE, FEDERARY [n]\n",
  "FOEDERATI": "FOEDERATUS, (Latin) a conquered enemy of Rome; an auxiliary soldier fighting for the Romans [n]\n",
  "FOEDERATUS": "(Latin) a conquered enemy of Rome; an auxiliary soldier fighting for the Romans [n FOEDERATI]\n",
  "FOEFIE": "(South African) as in foefie slide, a rope, fixed at an incline, along which a person suspended on a pulley may traverse a space, esp. across a river [adj]\n",
  "FOEHN": "(German) a warm dry wind, also FOHN [n -S]\n",
  "FOEHNS": "FOEHN, (German) a warm dry wind, also FOHN [n]\n",
  "FOEMAN": "an enemy in war [n FOEMEN]\n",
  "FOEMEN": "FOEMAN, an enemy in war [n]\n",
  "FOEN": "FOE, an enemy [n]\n",
  "FOES": "FOE, an enemy [n]\n",
  "FOETAL": "pertaining to a fetus, also FETAL [adj]\n",
  "FOETATION": "the formation of a foetus in the womb, also FETATION [n -S]\n",
  "FOETATIONS": "FOETATION, the formation of a foetus in the womb, also FETATION [n]\n",
  "FOETICIDAL": "relating to foeticide [adj]\n",
  "FOETICIDE": "the killing of a foetus, also FETICIDE [n -S]\n",
  "FOETICIDES": "FOETICIDE, the killing of a foetus, also FETICIDE [n]\n",
  "FOETID": "stinking, also FETID [adj FOETIDER, FOETIDEST, FOETIDLY]\n",
  "FOETIDER": "FOETID, stinking, also FETID [adj]\n",
  "FOETIDEST": "FOETID, stinking, also FETID [adj]\n",
  "FOETIDLY": "FOETID, stinking, also FETID [adv]\n",
  "FOETIDNESS": "the state of being foetid [n -ES]\n",
  "FOETIDNESSES": "FOETIDNESS, the state of being foetid [n]\n",
  "FOETIPAROUS": "of marsupials, such as the kangaroo, giving birth to incompletely developed offspring, also FETIPAROUS [adj]\n",
  "FOETOR": "(Latin) a stench, also FETOR [n -S]\n",
  "FOETORS": "FOETOR, (Latin) a stench, also FETOR [n]\n",
  "FOETOSCOPIES": "FOETOSCOPY, a procedure for viewing the fetus directly, within the uterus, also FETOSCOPY [n]\n",
  "FOETOSCOPY": "a procedure for viewing the fetus directly, within the uterus, also FETOSCOPY [n FOETOSCOPIES]\n",
  "FOETUS": "(Latin) the unborn in the womb with distinctly formed parts, also FETUS [n -ES]\n",
  "FOETUSES": "FOETUS, (Latin) the unborn in the womb with distinctly formed parts, also FETUS [n]\n",
  "FOG": "to cover with condensed water vapor [v FOGGED, FOGGING, FOGS]\n",
  "FOGASH": "(Hungarian) a fish, the pikeperch [n -ES]\n",
  "FOGASHES": "FOGASH, (Hungarian) a fish, the pikeperch [n]\n",
  "FOGBOUND": "surrounded by fog [adj]\n",
  "FOGBOW": "a nebulous arc of light sometimes seen in fog, also FOGDOG [n -S]\n",
  "FOGBOWS": "FOGBOW, a nebulous arc of light sometimes seen in fog, also FOGDOG [n]\n",
  "FOGDOG": "a nebulous arc of light sometimes seen in fog, also FOGBOW [n -S]\n",
  "FOGDOGS": "FOGDOG, a nebulous arc of light sometimes seen in fog, also FOGBOW [n]\n",
  "FOGEY": "a person with an old-fashioned outlook, also FOGY, FOGIE, FOGRAM [n -S]\n",
  "FOGEYDOM": "the world of fogies, also FOGYDOM [n -S]\n",
  "FOGEYDOMS": "FOGEYDOM, the world of fogies, also FOGYDOM [n]\n",
  "FOGEYISH": "like a fogy, also FOGYISH [adj]\n",
  "FOGEYISM": "an outlook like a fogy, also FOGYISM [n -S]\n",
  "FOGEYISMS": "FOGEYISM, an outlook like a fogy, also FOGYISM [n]\n",
  "FOGEYS": "FOGEY, a person with an old-fashioned outlook, also FOGY, FOGIE, FOGRAM [n]\n",
  "FOGFRUIT": "an American flowering plant [n -S]\n",
  "FOGFRUITS": "FOGFRUIT, an American flowering plant [n]\n",
  "FOGGAGE": "(Scots) a grass that grows after the hay is cut [n -S]\n",
  "FOGGAGES": "FOGGAGE, (Scots) a grass that grows after the hay is cut [n]\n",
  "FOGGED": "FOG, to cover with condensed water vapor [v]\n",
  "FOGGER": "a person who sets railway fog-signals, also FOGMAN [n -S]\n",
  "FOGGERS": "FOGGER, a person who sets railway fog-signals, also FOGMAN [n]\n",
  "FOGGIER": "FOGGY, filled with fog [adj]\n",
  "FOGGIEST": "FOGGY, filled with fog [adj]\n",
  "FOGGILY": "FOGGY, filled with fog [adv]\n",
  "FOGGINESS": "the state of being foggy [n -ES]\n",
  "FOGGINESSES": "FOGGINESS, the state of being foggy [n]\n",
  "FOGGING": "the act of obscuring e.g. a lens with fog [n -S]\n",
  "FOGGINGS": "FOGGING, the act of obscuring e.g. a lens with fog [n]\n",
  "FOGGY": "filled with fog [adj FOGGIER, FOGGIEST, FOGGILY]\n",
  "FOGHORN": "a horn sounded in fog to give warning [n -S]\n",
  "FOGHORNS": "FOGHORN, a horn sounded in fog to give warning [n]\n",
  "FOGIE": "a person with an old-fashioned outlook, also FOGY, FOGEY, FOGRAM [n -S]\n",
  "FOGIES": "FOGIE, a person with an old-fashioned outlook, also FOGY, FOGEY, FOGRAM [n]\n",
  "FOGLE": "(slang) a silk handkerchief [n -S]\n",
  "FOGLES": "FOGLE, (slang) a silk handkerchief [n]\n",
  "FOGLESS": "having no fog [adj]\n",
  "FOGLIGHT": "a motor-vehicle light used in foggy conditions [n -S]\n",
  "FOGLIGHTS": "FOGLIGHT, a motor-vehicle light used in foggy conditions [n]\n",
  "FOGMAN": "a person who sets railway fog-signals, also FOGGER [n FOGMEN]\n",
  "FOGMEN": "FOGMAN, a person who sets railway fog-signals, also FOGGER [n]\n",
  "FOGOU": "a manmade underground passage or chamber, found in Cornwall [n -S]\n",
  "FOGOUS": "FOGOU, a manmade underground passage or chamber, found in Cornwall [n]\n",
  "FOGRAM": "a person with an old-fashioned outlook, also FOGY, FOGEY, FOGIE [n -S]\n",
  "FOGRAMITE": "an antiquated person or thing [n -S]\n",
  "FOGRAMITES": "FOGRAMITE, an antiquated person or thing [n]\n",
  "FOGRAMITIES": "FOGRAMITY, the state of being antiquated [n]\n",
  "FOGRAMITY": "the state of being antiquated [n FOGRAMITIES]\n",
  "FOGRAMS": "FOGRAM, a person with an old-fashioned outlook, also FOGY, FOGEY, FOGIE [n]\n",
  "FOGS": "FOG, to cover with condensed water vapor [v]\n",
  "FOGY": "a person with an old-fashioned outlook, also FOGEY, FOGIE, FOGRAM [n FOGIES]\n",
  "FOGYDOM": "the world of fogies, also FOGEYDOM [n -S]\n",
  "FOGYDOMS": "FOGYDOM, the world of fogies, also FOGEYDOM [n]\n",
  "FOGYISH": "like a fogy, also FOGEYISH [adj]\n",
  "FOGYISM": "an outlook like a fogy, also FOGEYISM [n -S]\n",
  "FOGYISMS": "FOGYISM, an outlook like a fogy, also FOGEYISM [n]\n",
  "FOH": "an expression of disgust, also PHOH [interj]\n",
  "FOHN": "(German) a hot dry wind that blows down Alpine valleys, also FOEHN [n -S]\n",
  "FOHNS": "FOHN, (German) a hot dry wind that blows down Alpine valleys, also FOEHN [n]\n",
  "FOIBLE": "(French) a minor weakness or failing [n -S]\n",
  "FOIBLES": "FOIBLE, (French) a minor weakness or failing [n]\n",
  "FOID": "any mineral of a group related to feldspar, also FELDSPATHOID, FELSPATHOID [n -S]\n",
  "FOIDS": "FOID, any mineral of a group related to feldspar, also FELDSPATHOID, FELSPATHOID [n]\n",
  "FOIL": "to defeat or baffle [v -ED, -ING, -S]\n",
  "FOILABLE": "able to be foiled [adj]\n",
  "FOILBORNE": "of a craft, travelling along the water on hydrofoils [adj]\n",
  "FOILED": "FOIL, to defeat or baffle [v]\n",
  "FOILING": "the act of frustrating [n -S]\n",
  "FOILINGS": "FOILING, the act of frustrating [n]\n",
  "FOILIST": "one who fences with a foil [n -S]\n",
  "FOILISTS": "FOILIST, one who fences with a foil [n]\n",
  "FOILS": "FOIL, to defeat or baffle [v]\n",
  "FOILSMAN": "a fencer [n FOILSMEN]\n",
  "FOILSMEN": "FOILSMAN, a fencer [n]\n",
  "FOILSWOMAN": "a woman who uses or specializes in using a foil [n FOILSWOMEN]\n",
  "FOILSWOMEN": "FOILSWOMAN, a woman who uses or specializes in using a foil [n]\n",
  "FOIN": "to thrust with a spear or sword, also FOYNE [v -ED, -ING, -S]\n",
  "FOINED": "FOIN, to thrust with a spear or sword, also FOYNE [v]\n",
  "FOINING": "FOIN, to thrust with a spear or sword, also FOYNE [v]\n",
  "FOININGLY": "FOINING, FOIN, to thrust with a spear or sword, also FOYNE [adv]\n",
  "FOINS": "FOIN, to thrust with a spear or sword, also FOYNE [v]\n",
  "FOISON": "(Scots) physical energy or strength, also FIZZEN, FUSHION, FUSION [n -S]\n",
  "FOISONLESS": "(Scots) weak, feeble, also FIZZENLESS, FUSHIONLESS, FUSIONLESS [adj]\n",
  "FOISONS": "FOISON, (Scots) physical energy or strength, also FIZZEN, FUSHION, FUSION [n]\n",
  "FOIST": "to pass off (on or upon) the person affected [v -ED, -ING, -S]\n",
  "FOISTED": "FOIST, to pass off (on or upon) the person affected [v]\n",
  "FOISTER": "one who foists [n -S]\n",
  "FOISTERS": "FOISTER, one who foists [n]\n",
  "FOISTING": "FOIST, to pass off (on or upon) the person affected [v]\n",
  "FOISTS": "FOIST, to pass off (on or upon) the person affected [v]\n",
  "FOLACIN": "a form of vitamin B [n -S]\n",
  "FOLACINS": "FOLACIN, a form of vitamin B [n]\n",
  "FOLATE": "a form of vitamin B [n -S]\n",
  "FOLATES": "FOLATE, a form of vitamin B [n]\n",
  "FOLD": "to double over [v -ED, -ING, -S]\n",
  "FOLDABLE": "able to be folded [adj]\n",
  "FOLDAWAY": "something which can be folded and put away [n -S]\n",
  "FOLDAWAYS": "FOLDAWAY, something which can be folded and put away [n]\n",
  "FOLDBACK": "in multitrack recording, a process for returning a signal to a performer instantly [n -S]\n",
  "FOLDBACKS": "FOLDBACK, in multitrack recording, a process for returning a signal to a performer instantly [n]\n",
  "FOLDBOAT": "a collapsible boat resembling a kayak, also FALTBOAT [n -S]\n",
  "FOLDBOATS": "FOLDBOAT, a collapsible boat resembling a kayak, also FALTBOAT [n]\n",
  "FOLDED": "FOLD, to double over [v]\n",
  "FOLDER": "one that folds [n -S]\n",
  "FOLDEROL": "nonsense, also FALDERAL, FALDEROL [n -S]\n",
  "FOLDEROLS": "FOLDEROL, nonsense, also FALDERAL, FALDEROL [n]\n",
  "FOLDERS": "FOLDER, one that folds [n]\n",
  "FOLDING": "a fold or pleat; the bending of strata [n -S]\n",
  "FOLDINGS": "FOLDING, a fold or pleat; the bending of strata [n]\n",
  "FOLDOUT": "a large page, e.g. a diagram, folded to fit into a book [n -S]\n",
  "FOLDOUTS": "FOLDOUT, a large page, e.g. a diagram, folded to fit into a book [n]\n",
  "FOLDS": "FOLD, to double over [v]\n",
  "FOLDUP": "an object that folds up [n -S]\n",
  "FOLDUPS": "FOLDUP, an object that folds up [n]\n",
  "FOLEY": "in filming, the footsteps editor [n -S]\n",
  "FOLEYS": "FOLEY, in filming, the footsteps editor [n]\n",
  "FOLIA": "FOLIUM, (Latin) a leaf, a thin layer [n]\n",
  "FOLIACEOUS": "bearing leaves; leaflike [adj]\n",
  "FOLIAGE": "the growth of leaves on a plant [n -S]\n",
  "FOLIAGED": "having foliage [adj]\n",
  "FOLIAGES": "FOLIAGE, the growth of leaves on a plant [n]\n",
  "FOLIAR": "relating to leaves, resembling leaves [adj]\n",
  "FOLIATE": "to number the leaves of [v FOLIATED, FOLIATING, FOLIATES]\n",
  "FOLIATED": "FOLIATE, to number the leaves of [v]\n",
  "FOLIATES": "FOLIATE, to number the leaves of [v]\n",
  "FOLIATING": "FOLIATE, to number the leaves of [v]\n",
  "FOLIATION": "the process of bursting into leaf [n -S]\n",
  "FOLIATIONS": "FOLIATION, the process of bursting into leaf [n]\n",
  "FOLIATURE": "a cluster of foliage [n -S]\n",
  "FOLIATURES": "FOLIATURE, a cluster of foliage [n]\n",
  "FOLIC": "designating a type of acid [adj]\n",
  "FOLIE": "(French) madness [n -S]\n",
  "FOLIES": "FOLIE, (French) madness [n]\n",
  "FOLIO": "to number the pages of [v -ED, -ING, -S]\n",
  "FOLIOED": "FOLIO, to number the pages of [v]\n",
  "FOLIOING": "FOLIO, to number the pages of [v]\n",
  "FOLIOLATE": "composed of or relating to leaflets, also FOLIOLOSE [adj]\n",
  "FOLIOLE": "a small structure like a leaf [n -S]\n",
  "FOLIOLES": "FOLIOLE, a small structure like a leaf [n]\n",
  "FOLIOLOSE": "composed of or relating to leaflets, also FOLIOLATE [adj]\n",
  "FOLIOS": "FOLIO, to number the pages of [v]\n",
  "FOLIOSE": "having leaves, also FOLIOUS [adj]\n",
  "FOLIOUS": "having leaves, also FOLIOSE [adj]\n",
  "FOLIUM": "(Latin) a leaf, a thin layer [n FOLIA or FOLIUMS]\n",
  "FOLIUMS": "FOLIUM, (Latin) a leaf, a thin layer [n]\n",
  "FOLK": "a people or tribe [n -S]\n",
  "FOLKIE": "a performer of folk music, also FOLKY [n -S]\n",
  "FOLKIER": "FOLKY, down to earth [adj]\n",
  "FOLKIES": "FOLKY, a performer of folk music, also FOLKIE [n]\n",
  "FOLKIEST": "FOLKY, down to earth [adj]\n",
  "FOLKINESS": "the quality of being folky [n -ES]\n",
  "FOLKINESSES": "FOLKINESS, the quality of being folky [n]\n",
  "FOLKISH": "characteristic of the common people [adj]\n",
  "FOLKISHNESS": "the state of being folkish [n -ES]\n",
  "FOLKISHNESSES": "FOLKISHNESS, the state of being folkish [n]\n",
  "FOLKLAND": "in Old English times, land held by folk-right, as opposed to bookland [n -S]\n",
  "FOLKLANDS": "FOLKLAND, in Old English times, land held by folk-right, as opposed to bookland [n]\n",
  "FOLKLIFE": "the traditions and activities of a certain population [n FOLKLIFES or FOLKLIVES]\n",
  "FOLKLIFES": "FOLKLIFE, the traditions and activities of a certain population [n]\n",
  "FOLKLIKE": "having the quality of the common people e.g. of music [adj]\n",
  "FOLKLIVES": "FOLKLIFE, the traditions and activities of a certain population [n]\n",
  "FOLKLORE": "the beliefs and traditions of a people [n -S]\n",
  "FOLKLORES": "FOLKLORE, the beliefs and traditions of a people [n]\n",
  "FOLKLORIC": "relating to folklore [adj]\n",
  "FOLKLORISH": "relating to folklore [adj]\n",
  "FOLKLORIST": "a student of folklore [n -S]\n",
  "FOLKLORISTIC": "relating to folklore [adj]\n",
  "FOLKLORISTS": "FOLKLORIST, a student of folklore [n]\n",
  "FOLKMOOT": "(Old English) a general assembly of the people in early England, also FOLKMOT, FOLKMOTE [n -S]\n",
  "FOLKMOOTS": "FOLKMOOT, (Old English) a general assembly of the people in early England, also FOLKMOT, FOLKMOTE [n]\n",
  "FOLKMOT": "(Old English) a general assembly of the people in early England, also FOLKMOOT, FOLKMOTE [n -S]\n",
  "FOLKMOTE": "(Old English) a general assembly of the people in early England, also FOLKMOOT, FOLKMOT [n -S]\n",
  "FOLKMOTES": "FOLKMOTE, (Old English) a general assembly of the people in early England, also FOLKMOOT, FOLKMOT [n]\n",
  "FOLKMOTS": "FOLKMOT, (Old English) a general assembly of the people in early England, also FOLKMOOT, FOLKMOTE [n]\n",
  "FOLKS": "FOLK, a people or tribe [n]\n",
  "FOLKSIER": "FOLKSY, having an affected folklike quality [adj]\n",
  "FOLKSIEST": "FOLKSY, having an affected folklike quality [adj]\n",
  "FOLKSILY": "FOLKSY, having an affected folklike quality [adv]\n",
  "FOLKSINESS": "the quality of being folksy [n -ES]\n",
  "FOLKSINESSES": "FOLKSINESS, the quality of being folksy [n]\n",
  "FOLKSINGER": "one who sings folk songs or sings in a style associated with folk songs [n -S]\n",
  "FOLKSINGERS": "FOLKSINGER, one who sings folk songs or sings in a style associated with folk songs [n]\n",
  "FOLKSINGING": "the singing of folksongs [n -S]\n",
  "FOLKSINGINGS": "FOLKSINGING, the singing of folksongs [n]\n",
  "FOLKSONG": "a song of the folk music of an area [n -S]\n",
  "FOLKSONGS": "FOLKSONG, a song of the folk music of an area [n]\n",
  "FOLKSONOMIES": "FOLKSONOMY, a system of classification that makes use of terms that occur naturally in the language of users of the system [n]\n",
  "FOLKSONOMY": "a system of classification that makes use of terms that occur naturally in the language of users of the system [n FOLKSONOMIES]\n",
  "FOLKSY": "having an affected folklike quality [adj FOLKSIER, FOLKSIEST, FOLKSILY]\n",
  "FOLKTALE": "a tale from the oral tradition of a people [n -S]\n",
  "FOLKTALES": "FOLKTALE, a tale from the oral tradition of a people [n]\n",
  "FOLKTRONICA": "a genre of music comprising various elements of folk music and electronic music [n -S]\n",
  "FOLKTRONICAS": "FOLKTRONICA, a genre of music comprising various elements of folk music and electronic music [n]\n",
  "FOLKWAY": "a traditional custom of a people [n -S]\n",
  "FOLKWAYS": "FOLKWAY, a traditional custom of a people [n]\n",
  "FOLKY": "a performer of folk music, also FOLKIE [n FOLKIES] / down to earth [adj FOLKIER, FOLKIEST]\n",
  "FOLLES": "FOLLIS, (Latin) a coin of ancient Rome [n]\n",
  "FOLLICLE": "a fruit which develops from a single ovary, dries out on ripening and splits on one side only to release its fruit [n -S]\n",
  "FOLLICLES": "FOLLICLE, a fruit which develops from a single ovary, dries out on ripening and splits on one side only to release its fruit [n]\n",
  "FOLLICULAR": "like, pertaining to, or consisting of, a follicles or follicles [adj]\n",
  "FOLLICULATE": "having follicles, also FOLLICULATED [adj]\n",
  "FOLLICULATED": "having follicles, also FOLLICULATE [adj]\n",
  "FOLLICULIN": "another name for oestrone [n -S]\n",
  "FOLLICULINS": "FOLLICULIN, another name for oestrone [n]\n",
  "FOLLICULITIS": "inflammation of the follicles [n -ES]\n",
  "FOLLICULITISES": "FOLLICULITIS, inflammation of the follicles [n]\n",
  "FOLLICULOSE": "like a follicle, also FOLLICULOUS [adj]\n",
  "FOLLICULOUS": "like a follicle, also FOLLICULOSE [adj]\n",
  "FOLLIED": "FOLLY, to act with folly [v]\n",
  "FOLLIES": "FOLLY, to act with folly [v]\n",
  "FOLLIS": "(Latin) a coin of ancient Rome [n FOLLES]\n",
  "FOLLOW": "to go after or behind [v -ED, -ING, -S]\n",
  "FOLLOWABLE": "that can be followed [adj]\n",
  "FOLLOWED": "FOLLOW, to go after or behind [v]\n",
  "FOLLOWER": "one that follows [n -S]\n",
  "FOLLOWERS": "FOLLOWER, one that follows [n]\n",
  "FOLLOWERSHIP": "being a follower [n -S]\n",
  "FOLLOWERSHIPS": "FOLLOWERSHIP, being a follower [n]\n",
  "FOLLOWING": "a body of supporters [n -S]\n",
  "FOLLOWINGS": "FOLLOWING, a body of supporters [n]\n",
  "FOLLOWS": "FOLLOW, to go after or behind [v]\n",
  "FOLLOWSHIP": "the practice of doing what other people suggest [n -S]\n",
  "FOLLOWSHIPS": "FOLLOWSHIP, the practice of doing what other people suggest [n]\n",
  "FOLLOWUP": "a news article that adds information to a previous article [n -S]\n",
  "FOLLOWUPS": "FOLLOWUP, a news article that adds information to a previous article [n]\n",
  "FOLLY": "to act with folly [v FOLLIED, FOLLYING, FOLLIES] / a foolish idea or action [n FOLLIES]\n",
  "FOLLYING": "FOLLY, to act with folly [v]\n",
  "FOMENT": "to foster or promote [v -ED, -ING, -S]\n",
  "FOMENTATION": "the application of warm substances to diseased parts [n -S]\n",
  "FOMENTATIONS": "FOMENTATION, the application of warm substances to diseased parts [n]\n",
  "FOMENTED": "FOMENT, to foster or promote [v]\n",
  "FOMENTER": "one who foments [n -S]\n",
  "FOMENTERS": "FOMENTER, one who foments [n]\n",
  "FOMENTING": "FOMENT, to foster or promote [v]\n",
  "FOMENTS": "FOMENT, to foster or promote [v]\n",
  "FOMES": "(Latin) a substance capable of carrying infection, also FOMITE [n FOMITES]\n",
  "FOMITE": "a substance capable of carrying infection, also FOMES [n -S]\n",
  "FOMITES": "FOMES, (Latin) a substance capable of carrying infection, also FOMITE [n]\n",
  "FON": "to fool, be foolish [v FONNED, FONNING, FONS]\n",
  "FONCTIONNAIRE": "(French) a civil servant [n -S]\n",
  "FONCTIONNAIRES": "FONCTIONNAIRE, (French) a civil servant [n]\n",
  "FOND": "to display affection [v -ED, -ING, -S] / having an affection for [adj FONDER, FONDEST, FONDLY]\n",
  "FONDA": "(Spanish) a tavern [n -S]\n",
  "FONDANT": "(French) a soft sweet made with flavoured sugar and water [n -S]\n",
  "FONDANTS": "FONDANT, (French) a soft sweet made with flavoured sugar and water [n]\n",
  "FONDAS": "FONDA, (Spanish) a tavern [n]\n",
  "FONDED": "FOND, to display affection [v]\n",
  "FONDER": "FOND, having an affection for [adj]\n",
  "FONDEST": "FOND, having an affection for [adj]\n",
  "FONDING": "FOND, to display affection [v]\n",
  "FONDLE": "to caress [v FONDLED, FONDLING, FONDLES]\n",
  "FONDLED": "FONDLE, to caress [v]\n",
  "FONDLER": "one who fondles [n -S]\n",
  "FONDLERS": "FONDLER, one who fondles [n]\n",
  "FONDLES": "FONDLE, to caress [v]\n",
  "FONDLING": "a pet, a fool [n -S]\n",
  "FONDLINGLY": "FONDLING [adv]\n",
  "FONDLINGS": "FONDLING, a pet, a fool [n]\n",
  "FONDLY": "FOND, having an affection for [adv]\n",
  "FONDNESS": "affection [n -ES]\n",
  "FONDNESSES": "FONDNESS, affection [n]\n",
  "FONDS": "FOND, to display affection [v]\n",
  "FONDU": "(French) to cook a dish of melted cheese, also FONDUE [v FONDUED, FONDUING, FONDUS]\n",
  "FONDUE": "(French) to cook a dish of melted cheese, also FONDU [v FONDUED, FONDUEING, FONDUES]\n",
  "FONDUED": "FONDU, (French) to cook a dish of melted cheese, also FONDUE [v]\n",
  "FONDUEING": "FONDUE, (French) to cook a dish of melted cheese, also FONDU [v]\n",
  "FONDUES": "FONDUE, (French) to cook a dish of melted cheese, also FONDU [v]\n",
  "FONDUING": "FONDU, (French) to cook a dish of melted cheese, also FONDUE [v]\n",
  "FONDUS": "FONDU, (French) to cook a dish of melted cheese, also FONDUE [v]\n",
  "FONE": "(colloq.) a phone [n -S]\n",
  "FONES": "FONE, (colloq.) a phone [n]\n",
  "FONLY": "foolishly [adv]\n",
  "FONNED": "FON, to fool, be foolish [v]\n",
  "FONNING": "FON, to fool, be foolish [v]\n",
  "FONS": "FON, to fool, be foolish [v]\n",
  "FONT": "a container for baptismal water [n -S]\n",
  "FONTAL": "pertaining to a font or origin [adj]\n",
  "FONTANEL": "a membrane-covered gap between the immature parietal bones in the skull of a foetus or infant, also FONTANELLE [n -S]\n",
  "FONTANELLE": "a membrane-covered gap between the immature parietal bones in the skull of a foetus or infant, also FONTANEL [n -S]\n",
  "FONTANELLES": "FONTANELLE, a membrane-covered gap between the immature parietal bones in the skull of a foetus or infant, also FONTANEL [n]\n",
  "FONTANELS": "FONTANEL, a membrane-covered gap between the immature parietal bones in the skull of a foetus or infant, also FONTANELLE [n]\n",
  "FONTANGE": "(French) a kind of tall headdress worn in the seventeenth century [n -S]\n",
  "FONTANGES": "FONTANGE, (French) a kind of tall headdress worn in the seventeenth century [n]\n",
  "FONTICULI": "FONTICULUS, (Latin) the depression just over the top of the breastbone [n]\n",
  "FONTICULUS": "(Latin) the depression just over the top of the breastbone [n FONTICULI]\n",
  "FONTINA": "(Italian) an Italian cheese [n -S]\n",
  "FONTINALIS": "a moss of the Fontinalis genus of aquatic mosses [n -ES]\n",
  "FONTINALISES": "FONTINALIS, a moss of the Fontinalis genus of aquatic mosses [n]\n",
  "FONTINAS": "FONTINA, (Italian) an Italian cheese [n]\n",
  "FONTLET": "a little font [n -S]\n",
  "FONTLETS": "FONTLET, a little font [n]\n",
  "FONTS": "FONT, a container for baptismal water [n]\n",
  "FOO": "a name for a temporary computer variable or file [n -S]\n",
  "FOOBAR": "Fucked Up Beyond All Repair, also FUBAR [adj]\n",
  "FOOD": "nourishment for the body to maintain life and growth [n -S]\n",
  "FOODBANK": "a charitable organization which distributes food aid to people in financial difficulty [n -S]\n",
  "FOODBANKS": "FOODBANK, a charitable organization which distributes food aid to people in financial difficulty [n]\n",
  "FOODBORNE": "of illness, caused by food contaminated with pathogenic microorganisms or toxic substances [adj]\n",
  "FOODERIES": "FOODERY, a restaurant [n]\n",
  "FOODERY": "a restaurant [n FOODERIES]\n",
  "FOODFUL": "able to supply food abundantly [adj]\n",
  "FOODIE": "an enthusiast for food and its preparation, also FOODY [n -S]\n",
  "FOODIES": "FOODIE, an enthusiast for food and its preparation, also FOODY [n]\n",
  "FOODISM": "avid interest in food [n -S]\n",
  "FOODISMS": "FOODISM, avid interest in food [n]\n",
  "FOODLAND": "land for the production of food [n -S]\n",
  "FOODLANDS": "FOODLAND, land for the production of food [n]\n",
  "FOODLESS": "without food [adj]\n",
  "FOODLESSNESS": "the state of being foodless [n -ES]\n",
  "FOODLESSNESSES": "FOODLESSNESS, the state of being foodless [n]\n",
  "FOODOIR": "a book or blog that combines a personal memoir with a series of recipes [n -S]\n",
  "FOODOIRS": "FOODOIR, a book or blog that combines a personal memoir with a series of recipes [n]\n",
  "FOODS": "FOOD, nourishment for the body to maintain life and growth [n]\n",
  "FOODSHED": "the area through which food is transported from farm to consumer [n -S]\n",
  "FOODSHEDS": "FOODSHED, the area through which food is transported from farm to consumer [n]\n",
  "FOODSTUFF": "a substance used as food [n -S]\n",
  "FOODSTUFFS": "FOODSTUFF, a substance used as food [n]\n",
  "FOODWAYS": "the eating habits of a people [n]\n",
  "FOODY": "an enthusiast for food and its preparation, also FOODIE [n FOODIES]\n",
  "FOOFARAW": "frills and flashy finery; much ado about nothing [n -S]\n",
  "FOOFARAWS": "FOOFARAW, frills and flashy finery; much ado about nothing [n]\n",
  "FOOL": "to deceive [v -ED, -ING, -S]\n",
  "FOOLBEGGED": "(Shakespeare) foolish enough to be begged for a fool (in allusion to the custom of seeking the administration of a lunatic's estate as one's own) [adj]\n",
  "FOOLED": "FOOL, to deceive [v]\n",
  "FOOLERIES": "FOOLERY, foolish behaviour or speech [n]\n",
  "FOOLERY": "foolish behaviour or speech [n FOOLERIES]\n",
  "FOOLFISH": "a marine fish, the orange filefish [n -ES]\n",
  "FOOLFISHES": "FOOLFISH, a marine fish, the orange filefish [n]\n",
  "FOOLHARDIER": "FOOLHARDY, recklessly brave [adj]\n",
  "FOOLHARDIEST": "FOOLHARDY, recklessly brave [adj]\n",
  "FOOLHARDILY": "FOOLHARDY, recklessly brave [adv]\n",
  "FOOLHARDINESS": "the state of being foolhardy [n -ES]\n",
  "FOOLHARDINESSES": "FOOLHARDINESS, the state of being foolhardy [n]\n",
  "FOOLHARDISE": "(Spenser) foolhardiness, also FOOLHARDIZE [n -S]\n",
  "FOOLHARDISES": "FOOLHARDISE, (Spenser) foolhardiness, also FOOLHARDIZE [n]\n",
  "FOOLHARDIZE": "(Spenser) foolhardiness, also FOOLHARDISE [n -S]\n",
  "FOOLHARDIZES": "FOOLHARDIZE, (Spenser) foolhardiness, also FOOLHARDISE [n]\n",
  "FOOLHARDY": "recklessly brave [adj FOOLHARDIER, FOOLHARDIEST, FOOLHARDILY]\n",
  "FOOLING": "playing the fool [n -S]\n",
  "FOOLINGS": "FOOLING, playing the fool [n]\n",
  "FOOLISH": "lacking good sense or judgement [adj FOOLISHER, FOOLISHEST, FOOLISHLY]\n",
  "FOOLISHER": "FOOLISH, lacking good sense or judgement [adj]\n",
  "FOOLISHEST": "FOOLISH, lacking good sense or judgement [adj]\n",
  "FOOLISHLY": "FOOLISH, lacking good sense or judgement [adv]\n",
  "FOOLISHNESS": "the state of being foolish [n -ES]\n",
  "FOOLISHNESSES": "FOOLISHNESS, the state of being foolish [n]\n",
  "FOOLPROOF": "infallible; guaranteed not to cause damage or injury if misused [adj]\n",
  "FOOLS": "FOOL, to deceive [v]\n",
  "FOOLSCAP": "a paper size [n -S]\n",
  "FOOLSCAPS": "FOOLSCAP, a paper size [n]\n",
  "FOOS": "FOO, a name for a temporary computer variable or file [n]\n",
  "FOOSBALL": "(US) table football, also FUSBALL, FUSSBALL [n -S]\n",
  "FOOSBALLS": "FOOSBALL, (US) table football, also FUSBALL, FUSSBALL [n]\n",
  "FOOT": "the terminal part of the leg on which the body stands and moves [n FEET] / to walk [v -ED, -ING, -S]\n",
  "FOOTAGE": "measurement of payment by the foot [n -S]\n",
  "FOOTAGES": "FOOTAGE, measurement of payment by the foot [n]\n",
  "FOOTBAG": "a small bag filled with pellets that is kept aloft with the feet [n -S]\n",
  "FOOTBAGS": "FOOTBAG, a small bag filled with pellets that is kept aloft with the feet [n]\n",
  "FOOTBALL": "a large ball for kicking about in sport [n -S]\n",
  "FOOTBALLENE": "buckminsterfullerene, a ball-shaped molecule containing 60 carbon atoms linked together in hexagons and pentagons to form a closed, near spherical and very stable structure [n -S]\n",
  "FOOTBALLENES": "FOOTBALLENE, buckminsterfullerene, a ball-shaped molecule containing 60 carbon atoms linked together in hexagons and pentagons to form a closed, near spherical and very stable structure [n]\n",
  "FOOTBALLER": "one who plays football, also FOOTBALLIST [n -S]\n",
  "FOOTBALLERS": "FOOTBALLER, one who plays football, also FOOTBALLIST [n]\n",
  "FOOTBALLING": "related to football [adj]\n",
  "FOOTBALLIST": "one who plays football, also FOOTBALLER [n -S]\n",
  "FOOTBALLISTS": "FOOTBALLIST, one who plays football, also FOOTBALLER [n]\n",
  "FOOTBALLS": "FOOTBALL, a large ball for kicking about in sport [n]\n",
  "FOOTBAR": "in an aeroplane, a bar operated by feet [n -S]\n",
  "FOOTBARS": "FOOTBAR, in an aeroplane, a bar operated by feet [n]\n",
  "FOOTBATH": "a bath for the feet [n -S]\n",
  "FOOTBATHS": "FOOTBATH, a bath for the feet [n]\n",
  "FOOTBED": "the insole in a boot or shoe [n -S]\n",
  "FOOTBEDS": "FOOTBED, the insole in a boot or shoe [n]\n",
  "FOOTBOARD": "a support for the feet in a carriage or elsewhere [n -S]\n",
  "FOOTBOARDS": "FOOTBOARD, a support for the feet in a carriage or elsewhere [n]\n",
  "FOOTBOY": "a page, an attendant, also FOOTPAGE [n -S]\n",
  "FOOTBOYS": "FOOTBOY, a page, an attendant, also FOOTPAGE [n]\n",
  "FOOTBRAKE": "a brake operated by the foot [n -S]\n",
  "FOOTBRAKES": "FOOTBRAKE, a brake operated by the foot [n]\n",
  "FOOTBREADTH": "the width of a foot [n -S]\n",
  "FOOTBREADTHS": "FOOTBREADTH, the width of a foot [n]\n",
  "FOOTBRIDGE": "a bridge for pedestrians [n -S]\n",
  "FOOTBRIDGES": "FOOTBRIDGE, a bridge for pedestrians [n]\n",
  "FOOTCLOTH": "a housing or caparison for a horse [n -S]\n",
  "FOOTCLOTHS": "FOOTCLOTH, a housing or caparison for a horse [n]\n",
  "FOOTDRAGGER": "one who engages in footdragging [n -S]\n",
  "FOOTDRAGGERS": "FOOTDRAGGER, one who engages in footdragging [n]\n",
  "FOOTDRAGGING": "the act or practice of acting with deliberate slowness [n -S]\n",
  "FOOTDRAGGINGS": "FOOTDRAGGING, the act or practice of acting with deliberate slowness [n]\n",
  "FOOTED": "FOOT, to walk [v]\n",
  "FOOTER": "to mess around aimlessly [v -ED, -ING, -S]\n",
  "FOOTERED": "FOOTER, to mess around aimlessly [v]\n",
  "FOOTERING": "FOOTER, to mess around aimlessly [v]\n",
  "FOOTERS": "FOOTER, to mess around aimlessly [v]\n",
  "FOOTFALL": "the sound of a footstep [n -S]\n",
  "FOOTFALLS": "FOOTFALL, the sound of a footstep [n]\n",
  "FOOTFAULT": "to commit a serving fault at tennis [v -ED, -ING, -S]\n",
  "FOOTFAULTED": "FOOTFAULT, to commit a serving fault at tennis [v]\n",
  "FOOTFAULTING": "FOOTFAULT, to commit a serving fault at tennis [v]\n",
  "FOOTFAULTS": "FOOTFAULT, to commit a serving fault at tennis [v]\n",
  "FOOTGEAR": "covering for the feet [n -S]\n",
  "FOOTGEARS": "FOOTGEAR, covering for the feet [n]\n",
  "FOOTGUARDS": "guards that serve on foot [n]\n",
  "FOOTHILL": "a low hill at the base of higher hills [n -S]\n",
  "FOOTHILLS": "FOOTHILL, a low hill at the base of higher hills [n]\n",
  "FOOTHOLD": "a secure support for the foot [n -S]\n",
  "FOOTHOLDS": "FOOTHOLD, a secure support for the foot [n]\n",
  "FOOTIE": "(slang) football [n -S]\n",
  "FOOTIER": "FOOTY, mean [adj]\n",
  "FOOTIES": "FOOTIE, (slang) football [n]\n",
  "FOOTIEST": "FOOTY, mean [adj]\n",
  "FOOTING": "a foundation [n -S]\n",
  "FOOTINGS": "FOOTING, a foundation [n]\n",
  "FOOTLAMBERT": "a unit of luminance of a surface emitting one lumen per square foot [n -S]\n",
  "FOOTLAMBERTS": "FOOTLAMBERT, a unit of luminance of a surface emitting one lumen per square foot [n]\n",
  "FOOTLE": "to potter about [v FOOTLED, FOOTLING, FOOTLES]\n",
  "FOOTLED": "FOOTLE, to potter about [v]\n",
  "FOOTLER": "someone who footles [n -S]\n",
  "FOOTLERS": "FOOTLER, someone who footles [n]\n",
  "FOOTLES": "FOOTLE, to potter about [v]\n",
  "FOOTLESS": "without feet [adj]\n",
  "FOOTLESSLY": "FOOTLESS, without feet [adv]\n",
  "FOOTLESSNESS": "the state of being footless [n -ES]\n",
  "FOOTLESSNESSES": "FOOTLESSNESS, the state of being footless [n]\n",
  "FOOTLIGHT": "one of a row of lights along the front of a theatre stage [n -S]\n",
  "FOOTLIGHTS": "FOOTLIGHT, one of a row of lights along the front of a theatre stage [n]\n",
  "FOOTLIKE": "resembling a foot [adj]\n",
  "FOOTLING": "the act of pottering about [n -S]\n",
  "FOOTLINGS": "FOOTLING, the act of pottering about [n]\n",
  "FOOTLOCKER": "a small trunk designed to be placed at the foot of a bed (as in a barracks) [n -S]\n",
  "FOOTLOCKERS": "FOOTLOCKER, a small trunk designed to be placed at the foot of a bed (as in a barracks) [n]\n",
  "FOOTLONG": "a hotdog one foot long [n -S]\n",
  "FOOTLONGS": "FOOTLONG, a hotdog one foot long [n]\n",
  "FOOTLOOSE": "free or unhampered by (e.g. family) ties [adj]\n",
  "FOOTMAN": "a male servant [n FOOTMEN]\n",
  "FOOTMARK": "a mark left by the foot [n -S]\n",
  "FOOTMARKS": "FOOTMARK, a mark left by the foot [n]\n",
  "FOOTMEN": "FOOTMAN, a male servant [n]\n",
  "FOOTMUFF": "a muff for keeping the feet warm [n -S]\n",
  "FOOTMUFFS": "FOOTMUFF, a muff for keeping the feet warm [n]\n",
  "FOOTNOTE": "to supply with an explanatory note [v FOOTNOTED, FOOTNOTING, FOOTNOTES]\n",
  "FOOTNOTED": "FOOTNOTE, to supply with an explanatory note [v]\n",
  "FOOTNOTES": "FOOTNOTE, to supply with an explanatory note [v]\n",
  "FOOTNOTING": "FOOTNOTE, to supply with an explanatory note [v]\n",
  "FOOTPACE": "(obsolete) a walking pace [n -S]\n",
  "FOOTPACES": "FOOTPACE, (obsolete) a walking pace [n]\n",
  "FOOTPAD": "one who robs a pedestrian [n -S]\n",
  "FOOTPADS": "FOOTPAD, one who robs a pedestrian [n]\n",
  "FOOTPAGE": "a page, an attendant, also FOOTBOY [n -S]\n",
  "FOOTPAGES": "FOOTPAGE, a page, an attendant, also FOOTBOY [n]\n",
  "FOOTPATH": "a path for pedestrians [n -S]\n",
  "FOOTPATHS": "FOOTPATH, a path for pedestrians [n]\n",
  "FOOTPLATE": "a platform for a footplateman, an assistant to a train driver [n -S]\n",
  "FOOTPLATEMAN": "a train driver or assistant [n FOOTPLATEMEN]\n",
  "FOOTPLATEMEN": "FOOTPLATEMAN, a train driver or assistant [n]\n",
  "FOOTPLATES": "FOOTPLATE, a platform for a footplateman, an assistant to a train driver [n]\n",
  "FOOTPLATEWOMAN": "a female train driver and assistant [n FOOTPLATEWOMEN]\n",
  "FOOTPLATEWOMEN": "FOOTPLATEWOMAN, a female train driver and assistant [n]\n",
  "FOOTPOST": "a messenger who travels on foot [n -S]\n",
  "FOOTPOSTS": "FOOTPOST, a messenger who travels on foot [n]\n",
  "FOOTPRINT": "the mark left on the ground or floor by a person's or animal's foot [n -S]\n",
  "FOOTPRINTS": "FOOTPRINT, the mark left on the ground or floor by a person's or animal's foot [n]\n",
  "FOOTPUMP": "a pump held or operated by the foot [n -S]\n",
  "FOOTPUMPS": "FOOTPUMP, a pump held or operated by the foot [n]\n",
  "FOOTRA": "(Shakespeare) a worthless fellow, also FOUTER, FOUTRA, FOUTRE [n -S]\n",
  "FOOTRACE": "a race run on foot [n -S]\n",
  "FOOTRACES": "FOOTRACE, a race run on foot [n]\n",
  "FOOTRAS": "FOOTRA, (Shakespeare) a worthless fellow, also FOUTER, FOUTRA, FOUTRE [n]\n",
  "FOOTREST": "a support for the feet [n -S]\n",
  "FOOTRESTS": "FOOTREST, a support for the feet [n]\n",
  "FOOTROPE": "a rope used in sailing [n -S]\n",
  "FOOTROPES": "FOOTROPE, a rope used in sailing [n]\n",
  "FOOTRULE": "a ruler which is a foot long [n -S]\n",
  "FOOTRULES": "FOOTRULE, a ruler which is a foot long [n]\n",
  "FOOTS": "FOOT, to walk [v]\n",
  "FOOTSAL": "a form of association football played indoors with five players on each side, also FUTSAL [n -S]\n",
  "FOOTSALS": "FOOTSAL, a form of association football played indoors with five players on each side, also FUTSAL [n]\n",
  "FOOTSIE": "flirtation involving the touching together of feet, also FOOTSY [n -S]\n",
  "FOOTSIES": "FOOTSY, a flirting game played with the feet, also FOOTSIE [n]\n",
  "FOOTSLOG": "to march or tramp [v FOOTSLOGGED, FOOTSLOGGING, FOOTSLOGS]\n",
  "FOOTSLOGGED": "FOOTSLOG, to march or tramp [v]\n",
  "FOOTSLOGGER": "a soldier serving on foot [n -S]\n",
  "FOOTSLOGGERS": "FOOTSLOGGER, a soldier serving on foot [n]\n",
  "FOOTSLOGGING": "tramping on foot [n -S]\n",
  "FOOTSLOGGINGS": "FOOTSLOGGING, tramping on foot [n]\n",
  "FOOTSLOGS": "FOOTSLOG, to march or tramp [v]\n",
  "FOOTSORE": "having sore or tired feet [adj]\n",
  "FOOTSORENESS": "the state of being footsore [n -ES]\n",
  "FOOTSORENESSES": "FOOTSORENESS, the state of being footsore [n]\n",
  "FOOTSTALK": "the stalk of a leaf or a flower [n -S]\n",
  "FOOTSTALKS": "FOOTSTALK, the stalk of a leaf or a flower [n]\n",
  "FOOTSTALL": "a pedestal or plinth [n -S]\n",
  "FOOTSTALLS": "FOOTSTALL, a pedestal or plinth [n]\n",
  "FOOTSTEP": "a step with the foot [n -S]\n",
  "FOOTSTEPS": "FOOTSTEP, a step with the foot [n]\n",
  "FOOTSTOCK": "a slidable casting mounted on a lathe, aligned with the headstock, used to support the free end of the piece being worked on [n -S]\n",
  "FOOTSTOCKS": "FOOTSTOCK, a slidable casting mounted on a lathe, aligned with the headstock, used to support the free end of the piece being worked on [n]\n",
  "FOOTSTONE": "a stone at the foot of a grave, as opposed to a headstone [n -S]\n",
  "FOOTSTONES": "FOOTSTONE, a stone at the foot of a grave, as opposed to a headstone [n]\n",
  "FOOTSTOOL": "a stool for placing one's feet on when sitting [n -S]\n",
  "FOOTSTOOLED": "with one's feet on a footstool [adv]\n",
  "FOOTSTOOLS": "FOOTSTOOL, a stool for placing one's feet on when sitting [n]\n",
  "FOOTSY": "a flirting game played with the feet, also FOOTSIE [n FOOTSIES]\n",
  "FOOTWALL": "the layer of rock beneath a vein of ore [n -S]\n",
  "FOOTWALLS": "FOOTWALL, the layer of rock beneath a vein of ore [n]\n",
  "FOOTWAY": "a passage for pedestrians only [n -S]\n",
  "FOOTWAYS": "FOOTWAY, a passage for pedestrians only [n]\n",
  "FOOTWEAR": "anything worn on the feet [n -S]\n",
  "FOOTWEARIER": "FOOTWEARY, weary from walking [adj]\n",
  "FOOTWEARIEST": "FOOTWEARY, weary from walking [adj]\n",
  "FOOTWEARS": "FOOTWEAR, anything worn on the feet [n]\n",
  "FOOTWEARY": "weary from walking [adj FOOTWEARIER, FOOTWEARIEST]\n",
  "FOOTWELL": "the area in front of a car seat where one's feet rest [n -S]\n",
  "FOOTWELLS": "FOOTWELL, the area in front of a car seat where one's feet rest [n]\n",
  "FOOTWORK": "the management of the feet, in sport [n -S]\n",
  "FOOTWORKS": "FOOTWORK, the management of the feet, in sport [n]\n",
  "FOOTWORN": "worn by the passing of feet [adj]\n",
  "FOOTY": "mean [adj FOOTIER, FOOTIEST] / football [n FOOTIES]\n",
  "FOOZLE": "to manage or play awkwardly, to bungle [v FOOZLED, FOOZLING, FOOZLES]\n",
  "FOOZLED": "FOOZLE, to manage or play awkwardly, to bungle [v]\n",
  "FOOZLER": "one who foozles, fools away his time [n -S]\n",
  "FOOZLERS": "FOOZLER, one who foozles, fools away his time [n]\n",
  "FOOZLES": "FOOZLE, to manage or play awkwardly, to bungle [v]\n",
  "FOOZLING": "the act of bungling [n -S]\n",
  "FOOZLINGS": "FOOZLING, the act of bungling [n]\n",
  "FOP": "to deceive [v FOPPED, FOPPING, FOPS]\n",
  "FOPLING": "a petty fop [n -S]\n",
  "FOPLINGS": "FOPLING, a petty fop [n]\n",
  "FOPPED": "FOP, to deceive [v]\n",
  "FOPPERIES": "FOPPERY, dandyish behaviour [n]\n",
  "FOPPERY": "dandyish behaviour [n FOPPERIES]\n",
  "FOPPING": "FOP, to deceive [v]\n",
  "FOPPISH": "characteristic of a dandy [adj FOPPISHLY]\n",
  "FOPPISHLY": "FOPPISH, characteristic of a dandy [adv]\n",
  "FOPPISHNESS": "the state of being foppish [n -ES]\n",
  "FOPPISHNESSES": "FOPPISHNESS, the state of being foppish [n]\n",
  "FOPS": "FOP, to deceive [v]\n",
  "FOR": "directed or sent to [prep]\n",
  "FORA": "FORUM, (Latin) a public meeting place [n]\n",
  "FORAGE": "to search about [v FORAGED, FORAGING, FORAGES]\n",
  "FORAGED": "FORAGE, to search about [v]\n",
  "FORAGER": "one who forages [n -S]\n",
  "FORAGERS": "FORAGER, one who forages [n]\n",
  "FORAGES": "FORAGE, to search about [v]\n",
  "FORAGING": "FORAGE, to search about [v]\n",
  "FORAM": "one of the Rhizopoda, amoebae moving and taking in food with pseudopods, also FORAMINIFER [n -S]\n",
  "FORAMEN": "(Latin) a small anatomical opening [n FORAMENS or FORAMINA]\n",
  "FORAMENS": "FORAMEN, (Latin) a small anatomical opening [n]\n",
  "FORAMINA": "FORAMEN, (Latin) a small anatomical opening [n]\n",
  "FORAMINAL": "relating to the foramen, a small opening, perforation, or orifice [adj]\n",
  "FORAMINATED": "perforated or pierced with small holes [adj]\n",
  "FORAMINIFER": "a unicellular microorganism with a calcareous shell through which pseudopods project, also FORAM [n -S]\n",
  "FORAMINIFERA": "an order of rhizopod protozoa [n]\n",
  "FORAMINIFERAL": "of or like a foraminifer [adj]\n",
  "FORAMINIFERAN": "a foraminifer [n -S]\n",
  "FORAMINIFERANS": "FORAMINIFERAN, a foraminifer [n]\n",
  "FORAMINIFEROUS": "bearing foramina [adj]\n",
  "FORAMINIFERS": "FORAMINIFER, a unicellular microorganism with a calcareous shell through which pseudopods project, also FORAM [n]\n",
  "FORAMINOUS": "having foramina; full of holes; porous [adj]\n",
  "FORAMS": "FORAM, one of the Rhizopoda, amoebae moving and taking in food with pseudopods, also FORAMINIFER [n]\n",
  "FORANE": "outlying or rural, as in vicar-forane [adj]\n",
  "FORASMUCH": "because or since [conj]\n",
  "FORAY": "to make a raid [v -ED, -ING, -S]\n",
  "FORAYED": "FORAY, to make a raid [v]\n",
  "FORAYER": "one who makes or joins in a foray [n -S]\n",
  "FORAYERS": "FORAYER, one who makes or joins in a foray [n]\n",
  "FORAYING": "FORAY, to make a raid [v]\n",
  "FORAYS": "FORAY, to make a raid [v]\n",
  "FORB": "(Greek) any herb which is not grass [n -S]\n",
  "FORBAD": "FORBID, to command not to do something [v]\n",
  "FORBADE": "FORBID, to command not to do something [v]\n",
  "FORBARE": "FORBEAR, to refrain from [v]\n",
  "FORBEAR": "to refrain from [v FORBARE or FORBORE, FORBORNE, FORBEARING, FORBEARS]\n",
  "FORBEARANCE": "tolerance [n -S]\n",
  "FORBEARANCES": "FORBEARANCE, tolerance [n]\n",
  "FORBEARANT": "(obsolete) forbearing [adj]\n",
  "FORBEARER": "one who forbears [n -S]\n",
  "FORBEARERS": "FORBEARER, one who forbears [n]\n",
  "FORBEARING": "FORBEAR, to refrain from [v]\n",
  "FORBEARINGLY": "FORBEARING, FORBEAR, to refrain from [adv]\n",
  "FORBEARS": "FORBEAR, to refrain from [v]\n",
  "FORBID": "to command not to do something [v FORBAD or FORBADE, FORBIDDEN, FORBIDDING, FORBIDS]\n",
  "FORBIDAL": "the act of forbidding, also FORBIDDAL [n -S]\n",
  "FORBIDALS": "FORBIDAL, the act of forbidding, also FORBIDDAL [n]\n",
  "FORBIDDAL": "the act of forbidding, also FORBIDAL [n -S]\n",
  "FORBIDDALS": "FORBIDDAL, the act of forbidding, also FORBIDAL [n]\n",
  "FORBIDDANCE": "(obsolete) the act of forbidding [n -S]\n",
  "FORBIDDANCES": "FORBIDDANCE, (obsolete) the act of forbidding [n]\n",
  "FORBIDDEN": "FORBID, to command not to do something [v]\n",
  "FORBIDDENLY": "(Shakespeare) in a forbidden manner [adv]\n",
  "FORBIDDER": "one who forbids [n -S]\n",
  "FORBIDDERS": "FORBIDDER, one who forbids [n]\n",
  "FORBIDDING": "the act of commanding not to do something [n -S]\n",
  "FORBIDDINGLY": "FORBIDDING [adv]\n",
  "FORBIDDINGNESS": "the state of being forbidding [n]\n",
  "FORBIDDINGS": "FORBIDDING, the act of commanding not to do something [n]\n",
  "FORBIDS": "FORBID, to command not to do something [v]\n",
  "FORBODE": "to indicate in advance, also FOREBODE [v FORBODED, FORBODING, FORBODES]\n",
  "FORBODED": "FORBODE, to indicate in advance, also FOREBODE [v]\n",
  "FORBODES": "FORBODE, to indicate in advance, also FOREBODE [v]\n",
  "FORBODING": "FORBODE, to indicate in advance, also FOREBODE [v]\n",
  "FORBORE": "FORBEAR, to refrain from [v]\n",
  "FORBORNE": "FORBEAR, to refrain from [v]\n",
  "FORBS": "FORB, (Greek) any herb which is not grass [n]\n",
  "FORBY": "(Scots) besides, also FORBYE, FOREBY, FOREBYE [adv]\n",
  "FORBYE": "(Scots) close by, also FORBY, FOREBY, FOREBYE [prep]\n",
  "FORCAT": "(French) a convict condemned to hard labour [n -S]\n",
  "FORCATS": "FORCAT, (French) a convict condemned to hard labour [n]\n",
  "FORCE": "to compel by strength [v FORCED, FORCING, FORCES]\n",
  "FORCEABLE": "that can be forced [adj FORCEABLY]\n",
  "FORCEABLY": "FORCEABLE, that can be forced [adv]\n",
  "FORCED": "FORCE, to compel by strength [v]\n",
  "FORCEDLY": "FORCED, FORCE, to compel by strength [adv]\n",
  "FORCEDNESS": "the state of being forced [n -ES]\n",
  "FORCEDNESSES": "FORCEDNESS, the state of being forced [n]\n",
  "FORCEFUL": "full of strength [adj FORCEFULLY]\n",
  "FORCEFULLY": "FORCEFUL, full of strength [adv]\n",
  "FORCEFULNESS": "the state of being forceful [n -ES]\n",
  "FORCEFULNESSES": "FORCEFULNESS, the state of being forceful [n]\n",
  "FORCELESS": "having little or no force [adj]\n",
  "FORCEMEAT": "meat chopped fine and highly seasoned, either served up alone, or used as a stuffing, also FARCEMEAT [n -S]\n",
  "FORCEMEATS": "FORCEMEAT, meat chopped fine and highly seasoned, either served up alone, or used as a stuffing, also FARCEMEAT [n]\n",
  "FORCEOUT": "a play by which a runner in baseball is forced out [n -S]\n",
  "FORCEOUTS": "FORCEOUT, a play by which a runner in baseball is forced out [n]\n",
  "FORCEPS": "(Latin) a pair of tongs used in surgery [n FORCEPSES or FORCIPES]\n",
  "FORCEPSES": "FORCEPS, (Latin) a pair of tongs used in surgery [n]\n",
  "FORCEPSLIKE": "like a forceps [adj]\n",
  "FORCER": "one who forces [n -S]\n",
  "FORCERS": "FORCER, one who forces [n]\n",
  "FORCES": "FORCE, to compel by strength [v]\n",
  "FORCIBILITIES": "FORCIBILITY, the quality of being forcible [n]\n",
  "FORCIBILITY": "the quality of being forcible [n FORCIBILITIES]\n",
  "FORCIBLE": "having force [adj FORCIBLY]\n",
  "FORCIBLENESS": "the state of being forcible [n -ES]\n",
  "FORCIBLENESSES": "FORCIBLENESS, the state of being forcible [n]\n",
  "FORCIBLY": "FORCIBLE, having force [adv]\n",
  "FORCING": "FORCE, to compel by strength [v]\n",
  "FORCINGLY": "FORCING, FORCE, to compel by strength [adv]\n",
  "FORCIPATE": "formed and opening like a forceps, also FORCIPATED [adj]\n",
  "FORCIPATED": "formed and opening like a forceps, also FORCIPATE [adj]\n",
  "FORCIPATION": "torture by pinching with forceps [n -S]\n",
  "FORCIPATIONS": "FORCIPATION, torture by pinching with forceps [n]\n",
  "FORCIPES": "FORCEPS, (Latin) a pair of tongs used in surgery [n]\n",
  "FORD": "to wade across [v -ED, -ING, -S]\n",
  "FORDABLE": "able to be forded [adj]\n",
  "FORDED": "FORD, to wade across [v]\n",
  "FORDID": "FORDO, to destroy, also FOREDO [v]\n",
  "FORDING": "FORD, to wade across [v]\n",
  "FORDLESS": "unable to be forded [adj]\n",
  "FORDO": "to destroy, also FOREDO [v FORDID, FORDONE, FORDOING, FORDOES]\n",
  "FORDOES": "FORDO, to destroy, also FOREDO [v]\n",
  "FORDOING": "FORDO, to destroy, also FOREDO [v]\n",
  "FORDONE": "FORDO, to destroy, also FOREDO [v]\n",
  "FORDONNE": "in Spenserian phrase from fordonne, from being fordone, exhausted [adj]\n",
  "FORDS": "FORD, to wade across [v]\n",
  "FORE": "the front part of something [n -S]\n",
  "FOREANENT": "(Scots) right opposite to in location, also FERNINST, FORNENST, FORNENT [adv]\n",
  "FOREARM": "to arm in advance [v -ED, -ING, -S]\n",
  "FOREARMED": "FOREARM, to arm in advance [v]\n",
  "FOREARMING": "FOREARM, to arm in advance [v]\n",
  "FOREARMS": "FOREARM, to arm in advance [v]\n",
  "FOREBAY": "a reservoir from which water is taken to run equipment [n -S]\n",
  "FOREBAYS": "FOREBAY, a reservoir from which water is taken to run equipment [n]\n",
  "FOREBEAR": "an ancestor [n -S]\n",
  "FOREBEARS": "FOREBEAR, an ancestor [n]\n",
  "FOREBITT": "a post for fastening cables at a ship's foremast [n -S]\n",
  "FOREBITTER": "a nautical ballad sung at the forebitts [n -S]\n",
  "FOREBITTERS": "FOREBITTER, a nautical ballad sung at the forebitts [n]\n",
  "FOREBITTS": "FOREBITT, a post for fastening cables at a ship's foremast [n]\n",
  "FOREBODE": "to indicate in advance, also FORBODE [v FOREBODED, FOREBODING, FOREBODES]\n",
  "FOREBODED": "FOREBODE, to indicate in advance, also FORBODE [v]\n",
  "FOREBODEMENT": "a feeling of coming evil [n -S]\n",
  "FOREBODEMENTS": "FOREBODEMENT, a feeling of coming evil [n]\n",
  "FOREBODER": "a person who or thing which forbodes [n -S]\n",
  "FOREBODERS": "FOREBODER, a person who or thing which forbodes [n]\n",
  "FOREBODES": "FOREBODE, to indicate in advance, also FORBODE [v]\n",
  "FOREBODIES": "FOREBODY, the forward part of a ship [n]\n",
  "FOREBODING": "a premonition [n -S]\n",
  "FOREBODINGLY": "FOREBODING [adv]\n",
  "FOREBODINGNESS": "the state of being foreboding [n]\n",
  "FOREBODINGS": "FOREBODING, a premonition [n]\n",
  "FOREBODY": "the forward part of a ship [n FOREBODIES]\n",
  "FOREBOOM": "the boom of a ship's foremast [n -S]\n",
  "FOREBOOMS": "FOREBOOM, the boom of a ship's foremast [n]\n",
  "FOREBRAIN": "the anterior region of the embryonic brain [n -S]\n",
  "FOREBRAINS": "FOREBRAIN, the anterior region of the embryonic brain [n]\n",
  "FOREBY": "(Spenser) close by, also FORBY, FORBYE, FOREBYE [prep]\n",
  "FOREBYE": "(Scots) close by, also FORBY, FORBYE, FOREBY [prep]\n",
  "FORECABIN": "a cabin in the fore part of a ship [n -S]\n",
  "FORECABINS": "FORECABIN, a cabin in the fore part of a ship [n]\n",
  "FORECADDIE": "a caddie posted up ahead to see where the balls go, also FORECADDY [n -S]\n",
  "FORECADDIES": "FORECADDY, a caddy posted up ahead so as to see where the balls go, also FORECADDIE [n]\n",
  "FORECADDY": "a caddy posted up ahead so as to see where the balls go, also FORECADDIE [n FORECADDIES]\n",
  "FORECAR": "a small passenger compartment in front of a motorcycle [n -S]\n",
  "FORECARRIAGE": "the front part of a carriage, with an arrangement for independent movement of the fore-wheels [n -S]\n",
  "FORECARRIAGES": "FORECARRIAGE, the front part of a carriage, with an arrangement for independent movement of the fore-wheels [n]\n",
  "FORECARS": "FORECAR, a small passenger compartment in front of a motorcycle [n]\n",
  "FORECAST": "to estimate in advance [v -ED, -ING, -S]\n",
  "FORECASTABLE": "that can be forecast [adj]\n",
  "FORECASTED": "FORECAST, to estimate in advance [v]\n",
  "FORECASTER": "one who forecasts [n -S]\n",
  "FORECASTERS": "FORECASTER, one who forecasts [n]\n",
  "FORECASTING": "the act of estimating in advance [n -S]\n",
  "FORECASTINGS": "FORECASTING, the act of estimating in advance [n]\n",
  "FORECASTLE": "a short raised deck at the fore end of ship [n -S]\n",
  "FORECASTLES": "FORECASTLE, a short raised deck at the fore end of ship [n]\n",
  "FORECASTS": "FORECAST, to estimate in advance [v]\n",
  "FORECHECK": "to check an opponent in ice hockey in his own defensive zone [v -ED, -ING, -S]\n",
  "FORECHECKED": "FORECHECK, to check an opponent in ice hockey in his own defensive zone [v]\n",
  "FORECHECKER": "one who delivers a forecheck [n -S]\n",
  "FORECHECKERS": "FORECHECKER, one who delivers a forecheck [n]\n",
  "FORECHECKING": "FORECHECK, to check an opponent in ice hockey in his own defensive zone [v]\n",
  "FORECHECKS": "FORECHECK, to check an opponent in ice hockey in his own defensive zone [v]\n",
  "FORECHOSEN": "chosen beforehand [adj]\n",
  "FORECLOSABLE": "that can be foreclosed [adj]\n",
  "FORECLOSE": "to bar (a right of redemption); to take away the power of redeeming (a mortgage) [v FORECLOSED, FORECLOSING, FORECLOSES]\n",
  "FORECLOSED": "FORECLOSE, to bar (a right of redemption); to take away the power of redeeming (a mortgage) [v]\n",
  "FORECLOSES": "FORECLOSE, to bar (a right of redemption); to take away the power of redeeming (a mortgage) [v]\n",
  "FORECLOSING": "FORECLOSE, to bar (a right of redemption); to take away the power of redeeming (a mortgage) [v]\n",
  "FORECLOSURE": "an act or instance of foreclosing [n -S]\n",
  "FORECLOSURES": "FORECLOSURE, an act or instance of foreclosing [n]\n",
  "FORECLOTH": "a cloth that hangs over the front of an altar [n -S]\n",
  "FORECLOTHS": "FORECLOTH, a cloth that hangs over the front of an altar [n]\n",
  "FORECOURSE": "a foresail [n -S]\n",
  "FORECOURSES": "FORECOURSE, a foresail [n]\n",
  "FORECOURT": "a court in front of a building [n -S]\n",
  "FORECOURTS": "FORECOURT, a court in front of a building [n]\n",
  "FOREDAMNED": "(obsolete) utterly damned [adj]\n",
  "FOREDATE": "to date before the true time; to antedate [v FOREDATED, FOREDATING, FOREDATES]\n",
  "FOREDATED": "FOREDATE, to date before the true time; to antedate [v]\n",
  "FOREDATES": "FOREDATE, to date before the true time; to antedate [v]\n",
  "FOREDATING": "FOREDATE, to date before the true time; to antedate [v]\n",
  "FOREDECK": "the forward part of a ship's deck [n -S]\n",
  "FOREDECKS": "FOREDECK, the forward part of a ship's deck [n]\n",
  "FOREDID": "FOREDO, to destroy, also FORDO [v]\n",
  "FOREDO": "to destroy, also FORDO [v FOREDID, FOREDONE, FOREDOING, FOREDOES]\n",
  "FOREDOES": "FOREDO, to destroy, also FORDO [v]\n",
  "FOREDOING": "FOREDO, to destroy, also FORDO [v]\n",
  "FOREDONE": "FOREDO, to destroy, also FORDO [v]\n",
  "FOREDOOM": "to doom in advance [v -ED, -ING, -S]\n",
  "FOREDOOMED": "FOREDOOM, to doom in advance [v]\n",
  "FOREDOOMING": "FOREDOOM, to doom in advance [v]\n",
  "FOREDOOMS": "FOREDOOM, to doom in advance [v]\n",
  "FOREFACE": "the front part of the face of a quadruped [n -S]\n",
  "FOREFACES": "FOREFACE, the front part of the face of a quadruped [n]\n",
  "FOREFATHER": "an ancestor [n -S]\n",
  "FOREFATHERLY": "like a forefather [adj]\n",
  "FOREFATHERS": "FOREFATHER, an ancestor [n]\n",
  "FOREFEEL": "to have a premonition of [v FOREFELT, FOREFEELING, FOREFEELS]\n",
  "FOREFEELING": "FOREFEEL, to have a premonition of [v]\n",
  "FOREFEELINGLY": "FOREFEELING, FOREFEEL, to have a premonition of [adv]\n",
  "FOREFEELS": "FOREFEEL, to have a premonition of [v]\n",
  "FOREFEET": "FOREFOOT, one of the front feet of an animal [n]\n",
  "FOREFELT": "FOREFEEL, to have a premonition of [v]\n",
  "FOREFEND": "to protect, also FORFEND [v -ED, -ING, -S]\n",
  "FOREFENDED": "FOREFEND, to protect, also FORFEND [v]\n",
  "FOREFENDING": "FOREFEND, to protect, also FORFEND [v]\n",
  "FOREFENDS": "FOREFEND, to protect, also FORFEND [v]\n",
  "FOREFINGER": "the finger next to the thumb [n -S]\n",
  "FOREFINGERS": "FOREFINGER, the finger next to the thumb [n]\n",
  "FOREFOOT": "one of the front feet of an animal [n FOREFEET]\n",
  "FOREFRONT": "the front or foremost part [n -S]\n",
  "FOREFRONTS": "FOREFRONT, the front or foremost part [n]\n",
  "FOREGATHER": "to gather together, assemble, also FORGATHER [v -ED, -ING, -S]\n",
  "FOREGATHERED": "FOREGATHER, to gather together, assemble, also FORGATHER [v]\n",
  "FOREGATHERING": "FOREGATHER, to gather together, assemble, also FORGATHER [v]\n",
  "FOREGATHERS": "FOREGATHER, to gather together, assemble, also FORGATHER [v]\n",
  "FOREGLEAM": "a glimpse into the future [n -S]\n",
  "FOREGLEAMS": "FOREGLEAM, a glimpse into the future [n]\n",
  "FOREGO": "to go before [v FOREWENT, FOREGONE, FOREGOING, FOREGOES]\n",
  "FOREGOER": "one who goes before another; a predecessor [n -S]\n",
  "FOREGOERS": "FOREGOER, one who goes before another; a predecessor [n]\n",
  "FOREGOES": "FOREGO, to go before [v]\n",
  "FOREGOING": "something that goes before [n -S]\n",
  "FOREGOINGS": "FOREGOING, something that goes before [n]\n",
  "FOREGONE": "FOREGO, to go before [v]\n",
  "FOREGONENESS": "the state of being foregone [n -ES]\n",
  "FOREGONENESSES": "FOREGONENESS, the state of being foregone [n]\n",
  "FOREGROUND": "to bring to the foreground, the part of a picture or field of view nearest the observer's eye [v -ED, -ING, -S]\n",
  "FOREGROUNDED": "FOREGROUND, to bring to the foreground, the part of a picture or field of view nearest the observer's eye [v]\n",
  "FOREGROUNDING": "FOREGROUND, to bring to the foreground, the part of a picture or field of view nearest the observer's eye [v]\n",
  "FOREGROUNDS": "FOREGROUND, to bring to the foreground, the part of a picture or field of view nearest the observer's eye [v]\n",
  "FOREGUT": "the front part of the embryonic alimentary canal [n -S]\n",
  "FOREGUTS": "FOREGUT, the front part of the embryonic alimentary canal [n]\n",
  "FOREHAND": "a type of tennis stroke [n -S] / to play a shot forehand [v -ED, -ING, -S]\n",
  "FOREHANDED": "FOREHAND, to play a shot forehand [v]\n",
  "FOREHANDEDLY": "providing for future needs [adv]\n",
  "FOREHANDEDNESS": "the state of being forehanded [n]\n",
  "FOREHANDING": "FOREHAND, to play a shot forehand [v]\n",
  "FOREHANDS": "FOREHAND, to play a shot forehand [v]\n",
  "FOREHEAD": "the part of the face above the eyes [n -S]\n",
  "FOREHEADS": "FOREHEAD, the part of the face above the eyes [n]\n",
  "FOREHENT": "to overtake, also FORHENT [v FOREHENT, FOREHENTING, FOREHENTS]\n",
  "FOREHENTING": "FOREHENT, to overtake, also FORHENT [v]\n",
  "FOREHENTS": "FOREHENT, to overtake, also FORHENT [v]\n",
  "FOREHOCK": "a foreleg cut of bacon or pork [n -S]\n",
  "FOREHOCKS": "FOREHOCK, a foreleg cut of bacon or pork [n]\n",
  "FOREHOOF": "the hoof of a forefoot [n FOREHOOFS or FOREHOOVES]\n",
  "FOREHOOFS": "FOREHOOF, the hoof of a forefoot [n]\n",
  "FOREHOOVES": "FOREHOOF, the hoof of a forefoot [n]\n",
  "FOREIGN": "situated outside a place or country [adj FOREIGNLY]\n",
  "FOREIGNER": "a person belonging to, or from, another country [n -S]\n",
  "FOREIGNERS": "FOREIGNER, a person belonging to, or from, another country [n]\n",
  "FOREIGNISM": "anything peculiar to a foreign language or people; a foreign idiom or custom [n -S]\n",
  "FOREIGNISMS": "FOREIGNISM, anything peculiar to a foreign language or people; a foreign idiom or custom [n]\n",
  "FOREIGNLY": "FOREIGN, situated outside a place or country [adv]\n",
  "FOREIGNNESS": "the state of being foreign [n -ES]\n",
  "FOREIGNNESSES": "FOREIGNNESS, the state of being foreign [n]\n",
  "FOREJUDGE": "to deprive of a right etc. by judgment, also FORJUDGE [v FOREJUDGED, FOREJUDGING, FOREJUDGES]\n",
  "FOREJUDGED": "FOREJUDGE, to deprive of a right etc. by judgment, also FORJUDGE [v]\n",
  "FOREJUDGEMENT": "an advance judgment, also FOREJUDGMENT [n -S]\n",
  "FOREJUDGEMENTS": "FOREJUDGEMENT, an advance judgment, also FOREJUDGMENT [n]\n",
  "FOREJUDGES": "FOREJUDGE, to deprive of a right etc. by judgment, also FORJUDGE [v]\n",
  "FOREJUDGING": "FOREJUDGE, to deprive of a right etc. by judgment, also FORJUDGE [v]\n",
  "FOREJUDGMENT": "an advance judgment, also FOREJUDGEMENT [n -S]\n",
  "FOREJUDGMENTS": "FOREJUDGMENT, an advance judgment, also FOREJUDGEMENT [n]\n",
  "FOREKING": "a preceding king [n -S]\n",
  "FOREKINGS": "FOREKING, a preceding king [n]\n",
  "FOREKNEW": "FOREKNOW, to know beforehand [v]\n",
  "FOREKNOW": "to know beforehand [v FOREKNEW, FOREKNOWN, FOREKNOWING, FOREKNOWS]\n",
  "FOREKNOWABLE": "that can be known in advance [adj]\n",
  "FOREKNOWING": "FOREKNOW, to know beforehand [v]\n",
  "FOREKNOWINGLY": "FOREKNOWING, FOREKNOW, to know beforehand [adv]\n",
  "FOREKNOWLEDGE": "knowledge in advance of the event [n -S]\n",
  "FOREKNOWLEDGES": "FOREKNOWLEDGE, knowledge in advance of the event [n]\n",
  "FOREKNOWN": "FOREKNOW, to know beforehand [v]\n",
  "FOREKNOWS": "FOREKNOW, to know beforehand [v]\n",
  "FOREL": "to bind books with a kind of parchment [v FORELLED, FORELLING, FORELS]\n",
  "FORELADIES": "FORELADY, a woman who supervises workers [n]\n",
  "FORELADY": "a woman who supervises workers [n FORELADIES]\n",
  "FORELAID": "FORELAY, to wait in ambush [v]\n",
  "FORELAIN": "FORELAY, to wait in ambush [v]\n",
  "FORELAND": "a projecting mass of land [n -S]\n",
  "FORELANDS": "FORELAND, a projecting mass of land [n]\n",
  "FORELAY": "to wait in ambush [v FORELAID, FORELAYING, FORELAYS]\n",
  "FORELAYING": "FORELAY, to wait in ambush [v]\n",
  "FORELAYS": "FORELAY, to wait in ambush [v]\n",
  "FORELEG": "one of the front legs of an animal [n -S]\n",
  "FORELEGS": "FORELEG, one of the front legs of an animal [n]\n",
  "FORELEND": "to grant beforehand, also FORLEND [v FORELENT, FORELENDING, FORELENDS]\n",
  "FORELENDING": "FORELEND, to grant beforehand, also FORLEND [v]\n",
  "FORELENDS": "FORELEND, to grant beforehand, also FORLEND [v]\n",
  "FORELENT": "FORELEND, to grant beforehand, also FORLEND [v]\n",
  "FORELIE": "(Spenser) to lie in front of [v FORELAY, FORELAIN, FORELYING, FORELIES]\n",
  "FORELIES": "FORELIE, (Spenser) to lie in front of [v]\n",
  "FORELIFT": "(Spenser) to lift up in front [v -ED, -ING, -S]\n",
  "FORELIFTED": "FORELIFT, (Spenser) to lift up in front [v]\n",
  "FORELIFTING": "FORELIFT, (Spenser) to lift up in front [v]\n",
  "FORELIFTS": "FORELIFT, (Spenser) to lift up in front [v]\n",
  "FORELIMB": "a front limb e.g. of a horse [n -S]\n",
  "FORELIMBS": "FORELIMB, a front limb e.g. of a horse [n]\n",
  "FORELLED": "FOREL, to bind books with a kind of parchment [v]\n",
  "FORELLING": "FOREL, to bind books with a kind of parchment [v]\n",
  "FORELOCK": "to fasten with a cotter-pin [v -ED, -ING, -S]\n",
  "FORELOCKED": "FORELOCK, to fasten with a cotter-pin [v]\n",
  "FORELOCKING": "FORELOCK, to fasten with a cotter-pin [v]\n",
  "FORELOCKS": "FORELOCK, to fasten with a cotter-pin [v]\n",
  "FORELS": "FOREL, to bind books with a kind of parchment [v]\n",
  "FORELYING": "FORELIE, (Spenser) to lie in front of [v]\n",
  "FOREMAN": "a man who supervises workers [n FOREMEN]\n",
  "FOREMANSHIP": "the office of foreman [n -S]\n",
  "FOREMANSHIPS": "FOREMANSHIP, the office of foreman [n]\n",
  "FOREMAST": "the forward mast of a ship [n -S]\n",
  "FOREMASTMAN": "any sailor below the rank of petty officer [n FOREMASTMEN]\n",
  "FOREMASTMEN": "FOREMASTMAN, any sailor below the rank of petty officer [n]\n",
  "FOREMASTS": "FOREMAST, the forward mast of a ship [n]\n",
  "FOREMEAN": "to intend beforehand [v FOREMEANT, FOREMEANING, FOREMEANS]\n",
  "FOREMEANING": "FOREMEAN, to intend beforehand [v]\n",
  "FOREMEANS": "FOREMEAN, to intend beforehand [v]\n",
  "FOREMEANT": "FOREMEAN, to intend beforehand [v]\n",
  "FOREMEN": "FOREMAN, a man who supervises workers [n]\n",
  "FOREMENTIONED": "mentioned before in writing or speech, also AFOREMENTIONED [adj]\n",
  "FOREMILK": "the milk secreted immediately after childbirth [n -S]\n",
  "FOREMILKS": "FOREMILK, the milk secreted immediately after childbirth [n]\n",
  "FOREMOST": "first in position [adj]\n",
  "FOREMOTHER": "a female ancestor [n -S]\n",
  "FOREMOTHERS": "FOREMOTHER, a female ancestor [n]\n",
  "FORENAME": "a first name [n -S]\n",
  "FORENAMED": "having a forename [adj]\n",
  "FORENAMES": "FORENAME, a first name [n]\n",
  "FORENIGHT": "the night before [n -S]\n",
  "FORENIGHTS": "FORENIGHT, the night before [n]\n",
  "FORENOON": "the period of daylight before noon [n -S]\n",
  "FORENOONS": "FORENOON, the period of daylight before noon [n]\n",
  "FORENSIC": "belonging to courts of law [adj FORENSICALLY]\n",
  "FORENSICALITIES": "FORENSICALITY, the state of being forensic [n]\n",
  "FORENSICALITY": "the state of being forensic [n FORENSICALITIES]\n",
  "FORENSICALLY": "FORENSIC, belonging to courts of law [adv]\n",
  "FORENSICS": "the art or study of public debate [n]\n",
  "FOREORDAIN": "to ordain or appoint beforehand [v -ED, -ING, -S]\n",
  "FOREORDAINED": "FOREORDAIN, to ordain or appoint beforehand [v]\n",
  "FOREORDAINING": "FOREORDAIN, to ordain or appoint beforehand [v]\n",
  "FOREORDAINMENT": "the state of being foreordained [n -S]\n",
  "FOREORDAINMENTS": "FOREORDAINMENT, the state of being foreordained [n]\n",
  "FOREORDAINS": "FOREORDAIN, to ordain or appoint beforehand [v]\n",
  "FOREORDINATION": "the act of foreordaining [n -S]\n",
  "FOREORDINATIONS": "FOREORDINATION, the act of foreordaining [n]\n",
  "FOREPART": "the front part [n -S]\n",
  "FOREPARTS": "FOREPART, the front part [n]\n",
  "FOREPASSED": "bygone, also FOREPAST [adj]\n",
  "FOREPAST": "(obsolete) former, bygone, also FOREPASSED [adj]\n",
  "FOREPAW": "the paw of a foreleg [n -S]\n",
  "FOREPAWS": "FOREPAW, the paw of a foreleg [n]\n",
  "FOREPAYMENT": "payment in advance [n -S]\n",
  "FOREPAYMENTS": "FOREPAYMENT, payment in advance [n]\n",
  "FOREPEAK": "the forward part of a ship's hold [n -S]\n",
  "FOREPEAKS": "FOREPEAK, the forward part of a ship's hold [n]\n",
  "FOREPLAN": "to plan beforehand [v FOREPLANNED, FOREPLANNING, FOREPLANS]\n",
  "FOREPLANNED": "FOREPLAN, to plan beforehand [v]\n",
  "FOREPLANNING": "FOREPLAN, to plan beforehand [v]\n",
  "FOREPLANS": "FOREPLAN, to plan beforehand [v]\n",
  "FOREPLAY": "erotic stimulation preceding sexual intercourse [n -S]\n",
  "FOREPLAYS": "FOREPLAY, erotic stimulation preceding sexual intercourse [n]\n",
  "FOREPOINT": "to foreshadow [v -ED, -ING, -S]\n",
  "FOREPOINTED": "FOREPOINT, to foreshadow [v]\n",
  "FOREPOINTING": "FOREPOINT, to foreshadow [v]\n",
  "FOREPOINTS": "FOREPOINT, to foreshadow [v]\n",
  "FOREQUARTER": "the front half of a lateral half of the body or carcass of a quadruped [n -S]\n",
  "FOREQUARTERS": "FOREQUARTER, the front half of a lateral half of the body or carcass of a quadruped [n]\n",
  "FORERAN": "FORERUN, to run in advance of [v]\n",
  "FORERANK": "the first rank [n -S]\n",
  "FORERANKS": "FORERANK, the first rank [n]\n",
  "FOREREACH": "to glide ahead, esp. when going in stay [v -ED, -ING, -ES]\n",
  "FOREREACHED": "FOREREACH, to glide ahead, esp. when going in stay [v]\n",
  "FOREREACHES": "FOREREACH, to glide ahead, esp. when going in stay [v]\n",
  "FOREREACHING": "FOREREACH, to glide ahead, esp. when going in stay [v]\n",
  "FOREREAD": "to foretell [v FOREREAD, FOREREADING, FOREREADS]\n",
  "FOREREADING": "a foretelling [n -S]\n",
  "FOREREADINGS": "FOREREADING, a foretelling [n]\n",
  "FOREREADS": "FOREREAD, to foretell [v]\n",
  "FORERUN": "to run in advance of [v FORERAN, FORERUN, FORERUNNING, FORERUNS]\n",
  "FORERUNNER": "a messenger sent before to give notice of the approach of others [n -S]\n",
  "FORERUNNERS": "FORERUNNER, a messenger sent before to give notice of the approach of others [n]\n",
  "FORERUNNING": "FORERUN, to run in advance of [v]\n",
  "FORERUNS": "FORERUN, to run in advance of [v]\n",
  "FORES": "FORE, the front part of something [n]\n",
  "FORESAID": "FORESAY, to foretell [v]\n",
  "FORESAIL": "the lowest sail set on the foremast of a square-rigged ship [n -S]\n",
  "FORESAILS": "FORESAIL, the lowest sail set on the foremast of a square-rigged ship [n]\n",
  "FORESAW": "FORESEE, to see in advance [v]\n",
  "FORESAY": "to foretell [v FORESAID, FORESAYING, FORESAYS]\n",
  "FORESAYING": "FORESAY, to foretell [v]\n",
  "FORESAYS": "FORESAY, to foretell [v]\n",
  "FORESEE": "to see in advance [v FORESAW, FORESEEN, FORESEEING, FORESEES]\n",
  "FORESEEABILITY": "the state of being foreseeable [n]\n",
  "FORESEEABLE": "being such as may be reasonably anticipated [adj]\n",
  "FORESEEING": "FORESEE, to see in advance [v]\n",
  "FORESEEINGLY": "FORESEEING, FORESEE, to see in advance [adv]\n",
  "FORESEEN": "FORESEE, to see in advance [v]\n",
  "FORESEER": "one who foresees [n -S]\n",
  "FORESEERS": "FORESEER, one who foresees [n]\n",
  "FORESEES": "FORESEE, to see in advance [v]\n",
  "FORESHADOW": "to represent, indicate, or typify beforehand [v -ED, -ING, -S]\n",
  "FORESHADOWED": "FORESHADOW, to represent, indicate, or typify beforehand [v]\n",
  "FORESHADOWER": "one who foreshadows [n -S]\n",
  "FORESHADOWERS": "FORESHADOWER, one who foreshadows [n]\n",
  "FORESHADOWING": "the act of foreshadowing [n -S]\n",
  "FORESHADOWINGS": "FORESHADOWING, the act of foreshadowing [n]\n",
  "FORESHADOWS": "FORESHADOW, to represent, indicate, or typify beforehand [v]\n",
  "FORESHANK": "the upper part of the foreleg of cattle [n -S]\n",
  "FORESHANKS": "FORESHANK, the upper part of the foreleg of cattle [n]\n",
  "FORESHEET": "a rope used for trimming the foresail; the space near bow of open boat [n -S]\n",
  "FORESHEETS": "FORESHEET, a rope used for trimming the foresail; the space near bow of open boat [n]\n",
  "FORESHEW": "to presage, also FORESHOW [v FORESHEWED, FORESHEWN, FORESHEWING, FORESHEWS]\n",
  "FORESHEWED": "FORESHEW, to presage, also FORESHOW [v]\n",
  "FORESHEWING": "FORESHEW, to presage, also FORESHOW [v]\n",
  "FORESHEWN": "FORESHEW, to presage, also FORESHOW [v]\n",
  "FORESHEWS": "FORESHEW, to presage, also FORESHOW [v]\n",
  "FORESHIP": "the front of a ship [n -S]\n",
  "FORESHIPS": "FORESHIP, the front of a ship [n]\n",
  "FORESHOCK": "a minor tremor that precedes an earthquake [n -S]\n",
  "FORESHOCKS": "FORESHOCK, a minor tremor that precedes an earthquake [n]\n",
  "FORESHORE": "that part of the shore that lies between the low and high tide marks [n -S]\n",
  "FORESHORES": "FORESHORE, that part of the shore that lies between the low and high tide marks [n]\n",
  "FORESHORTEN": "to shorten by proportionately contracting in the direction of depth so that an illusion of projection or extension in space is obtained [v -ED, -ING, -S]\n",
  "FORESHORTENED": "FORESHORTEN, to shorten by proportionately contracting in the direction of depth so that an illusion of projection or extension in space is obtained [v]\n",
  "FORESHORTENING": "a shortening by proportionately contracting in the direction of depth so that an illusion of projection or extension in space is obtained [n -S]\n",
  "FORESHORTENINGS": "FORESHORTENING, a shortening by proportionately contracting in the direction of depth so that an illusion of projection or extension in space is obtained [n]\n",
  "FORESHORTENS": "FORESHORTEN, to shorten by proportionately contracting in the direction of depth so that an illusion of projection or extension in space is obtained [v]\n",
  "FORESHOW": "to predict, also FORESHEW [v FORESHOWED, FORESHOWN, FORESHOWING, FORESHOWS]\n",
  "FORESHOWED": "FORESHOW, to predict, also FORESHEW [v]\n",
  "FORESHOWING": "FORESHOW, to predict, also FORESHEW [v]\n",
  "FORESHOWN": "FORESHOW, to predict, also FORESHEW [v]\n",
  "FORESHOWS": "FORESHOW, to predict, also FORESHEW [v]\n",
  "FORESIDE": "the front side [n -S]\n",
  "FORESIDES": "FORESIDE, the front side [n]\n",
  "FORESIGHT": "the act or power of foreseeing [n -S]\n",
  "FORESIGHTED": "having foresight [adj FORESIGHTEDLY]\n",
  "FORESIGHTEDLY": "FORESIGHTED, having foresight [adv]\n",
  "FORESIGHTEDNESS": "the state of being foresighted [n]\n",
  "FORESIGHTFUL": "full of foresight [adj]\n",
  "FORESIGHTLESS": "without foresight [adj]\n",
  "FORESIGHTS": "FORESIGHT, the act or power of foreseeing [n]\n",
  "FORESIGNIFIED": "FORESIGNIFY, (archaic) to signify in advance [v]\n",
  "FORESIGNIFIES": "FORESIGNIFY, (archaic) to signify in advance [v]\n",
  "FORESIGNIFY": "(archaic) to signify in advance [v FORESIGNIFIED, FORESIGNIFYING, FORESIGNIFIES]\n",
  "FORESIGNIFYING": "FORESIGNIFY, (archaic) to signify in advance [v]\n",
  "FORESKIN": "a fold of skin covering the penis [n -S]\n",
  "FORESKINS": "FORESKIN, a fold of skin covering the penis [n]\n",
  "FORESKIRT": "(Shakespeare) the front skirt of a garment, in distinction from the train [n -S]\n",
  "FORESKIRTS": "FORESKIRT, (Shakespeare) the front skirt of a garment, in distinction from the train [n]\n",
  "FORESLACK": "(obsolete) to become slack or neglectful, also FORSLACK [v -ED, -ING, -S]\n",
  "FORESLACKED": "FORESLACK, (obsolete) to become slack or neglectful, also FORSLACK [v]\n",
  "FORESLACKING": "FORESLACK, (obsolete) to become slack or neglectful, also FORSLACK [v]\n",
  "FORESLACKS": "FORESLACK, (obsolete) to become slack or neglectful, also FORSLACK [v]\n",
  "FORESLOW": "(Shakespeare) to delay, put off, also FORSLOW, FORSLOE [v -ED, -ING, -S]\n",
  "FORESLOWED": "FORESLOW, (Shakespeare) to delay, put off, also FORSLOW, FORSLOE [v]\n",
  "FORESLOWING": "FORESLOW, (Shakespeare) to delay, put off, also FORSLOW, FORSLOE [v]\n",
  "FORESLOWS": "FORESLOW, (Shakespeare) to delay, put off, also FORSLOW, FORSLOE [v]\n",
  "FORESPAKE": "FORESPEAK, to predict [v]\n",
  "FORESPEAK": "to predict [v FORESPOKE or FORESPAKE, FORESPOKEN, FORESPEAKING, FORESPEAKS]\n",
  "FORESPEAKING": "FORESPEAK, to predict [v]\n",
  "FORESPEAKS": "FORESPEAK, to predict [v]\n",
  "FORESPEND": "to wear out physically, also FORSPEND [v FORESPENT, FORESPENDING, FORESPENDS]\n",
  "FORESPENDING": "FORESPEND, to wear out physically, also FORSPEND [v]\n",
  "FORESPENDS": "FORESPEND, to wear out physically, also FORSPEND [v]\n",
  "FORESPENT": "FORESPEND, to wear out physically, also FORSPEND [v]\n",
  "FORESPOKE": "FORESPEAK, to predict [v]\n",
  "FORESPOKEN": "FORESPEAK, to predict [v]\n",
  "FOREST": "to convert into a densely wooded area [v -ED, -ING, -S]\n",
  "FORESTAGE": "a duty or tribute payable to the king's foresters [n -S]\n",
  "FORESTAGES": "FORESTAGE, a duty or tribute payable to the king's foresters [n]\n",
  "FORESTAIR": "(Scots) an outside stair at the front of a house [n -S]\n",
  "FORESTAIRS": "FORESTAIR, (Scots) an outside stair at the front of a house [n]\n",
  "FORESTAL": "of or pertaining to forests, also FORESTEAL, FORESTIAL, FORESTINE [adj]\n",
  "FORESTALL": "to prevent [v -ED, -ING, -S]\n",
  "FORESTALLED": "FORESTALL, to prevent [v]\n",
  "FORESTALLER": "one who forestalls [n -S]\n",
  "FORESTALLERS": "FORESTALLER, one who forestalls [n]\n",
  "FORESTALLING": "the act of forestalling [n -S]\n",
  "FORESTALLINGS": "FORESTALLING, the act of forestalling [n]\n",
  "FORESTALLMENT": "the act of forestalling [n -S]\n",
  "FORESTALLMENTS": "FORESTALLMENT, the act of forestalling [n]\n",
  "FORESTALLS": "FORESTALL, to prevent [v]\n",
  "FORESTALMENT": "the act of forestalling [n -S]\n",
  "FORESTALMENTS": "FORESTALMENT, the act of forestalling [n]\n",
  "FORESTATION": "the creation of forest [n -S]\n",
  "FORESTATIONS": "FORESTATION, the creation of forest [n]\n",
  "FORESTAY": "a rope or wire used to support a foremast [n -S]\n",
  "FORESTAYS": "FORESTAY, a rope or wire used to support a foremast [n]\n",
  "FORESTAYSAIL": "the sail attached to a forestay [n -S]\n",
  "FORESTAYSAILS": "FORESTAYSAIL, the sail attached to a forestay [n]\n",
  "FORESTEAL": "of or pertaining to forests, also FORESTAL, FORESTIAL, FORESTINE [adj]\n",
  "FORESTED": "FOREST, to convert into a densely wooded area [v]\n",
  "FORESTER": "one skilled in forestry [n -S]\n",
  "FORESTERS": "FORESTER, one skilled in forestry [n]\n",
  "FORESTIAL": "of or pertaining to forests, also FORESTAL, FORESTEAL, FORESTINE [adj]\n",
  "FORESTINE": "of or like a forest, also FORESTAL, FORESTEAL, FORESTIAL [adj]\n",
  "FORESTING": "FOREST, to convert into a densely wooded area [v]\n",
  "FORESTLAND": "land occupied by forest [n -S]\n",
  "FORESTLANDS": "FORESTLAND, land occupied by forest [n]\n",
  "FORESTLESS": "without a forest [adj]\n",
  "FORESTRIES": "FORESTRY, the science of planting and managing forests [n]\n",
  "FORESTRY": "the science of planting and managing forests [n FORESTRIES]\n",
  "FORESTS": "FOREST, to convert into a densely wooded area [v]\n",
  "FORESWEAR": "to renounce, also FORSWEAR [v FORESWORE, FORESWORN, FORESWEARING, FORESWEARS]\n",
  "FORESWEARING": "FORESWEAR, to renounce, also FORSWEAR [v]\n",
  "FORESWEARS": "FORESWEAR, to renounce, also FORSWEAR [v]\n",
  "FORESWORE": "FORESWEAR, to renounce, also FORSWEAR [v]\n",
  "FORESWORN": "FORESWEAR, to renounce, also FORSWEAR [v]\n",
  "FORETASTE": "to taste in advance [v FORETASTED, FORETASTING, FORETASTES]\n",
  "FORETASTED": "FORETASTE, to taste in advance [v]\n",
  "FORETASTES": "FORETASTE, to taste in advance [v]\n",
  "FORETASTING": "FORETASTE, to taste in advance [v]\n",
  "FORETAUGHT": "FORETEACH, to teach beforehand [v]\n",
  "FORETEACH": "to teach beforehand [v FORETAUGHT, FORETEACHING, FORETEACHES]\n",
  "FORETEACHES": "FORETEACH, to teach beforehand [v]\n",
  "FORETEACHING": "FORETEACH, to teach beforehand [v]\n",
  "FORETEETH": "FORETOOTH, a front tooth [n]\n",
  "FORETELL": "to tell about in advance [v FORETOLD, FORETELLING, FORETELLS]\n",
  "FORETELLER": "one who foretells [n -S]\n",
  "FORETELLERS": "FORETELLER, one who foretells [n]\n",
  "FORETELLING": "FORETELL, to tell about in advance [v]\n",
  "FORETELLS": "FORETELL, to tell about in advance [v]\n",
  "FORETHINK": "to think beforehand [v FORETHOUGHT, FORETHINKING, FORETHINKS]\n",
  "FORETHINKER": "one who forethinks [n -S]\n",
  "FORETHINKERS": "FORETHINKER, one who forethinks [n]\n",
  "FORETHINKING": "FORETHINK, to think beforehand [v]\n",
  "FORETHINKS": "FORETHINK, to think beforehand [v]\n",
  "FORETHOUGHT": "a thinking or planning out in advance [n -S]\n",
  "FORETHOUGHTFUL": "full of forethought [adj]\n",
  "FORETHOUGHTS": "FORETHOUGHT, a thinking or planning out in advance [n]\n",
  "FORETIME": "the past; the time before the present [n -S]\n",
  "FORETIMES": "FORETIME, the past; the time before the present [n]\n",
  "FORETOKEN": "to be a sign of, forebode [v -ED, -ING, -S]\n",
  "FORETOKENED": "FORETOKEN, to be a sign of, forebode [v]\n",
  "FORETOKENING": "the act of foretokening [n -S]\n",
  "FORETOKENINGS": "FORETOKENING, the act of foretokening [n]\n",
  "FORETOKENS": "FORETOKEN, to be a sign of, forebode [v]\n",
  "FORETOLD": "FORETELL, to tell about in advance [v]\n",
  "FORETOOTH": "a front tooth [n FORETEETH]\n",
  "FORETOP": "the platform at the head of the foremast [n -S]\n",
  "FORETOPMAN": "a sailor who works on the platform at the head of the foremast [n FORETOPMEN]\n",
  "FORETOPMAST": "the mast above the foretop platform [n -S]\n",
  "FORETOPMASTS": "FORETOPMAST, the mast above the foretop platform [n]\n",
  "FORETOPMEN": "FORETOPMAN, a sailor who works on the platform at the head of the foremast [n]\n",
  "FORETOPS": "FORETOP, the platform at the head of the foremast [n]\n",
  "FORETRIANGLE": "the triangular area formed by the deck, foremast, and headstay of a sailing vessel [n -S]\n",
  "FORETRIANGLES": "FORETRIANGLE, the triangular area formed by the deck, foremast, and headstay of a sailing vessel [n]\n",
  "FOREVER": "an indefinite length of time [n -S]\n",
  "FOREVERMORE": "forever [adj]\n",
  "FOREVERNESS": "the state of lasting forever [n -ES]\n",
  "FOREVERNESSES": "FOREVERNESS, the state of lasting forever [n]\n",
  "FOREVERS": "FOREVER, an indefinite length of time [n]\n",
  "FOREVOUCHED": "(Shakespeare) affirmed or held before [adj]\n",
  "FOREWARD": "(archaic) to guard (something) in front [v -ED, -ING, -S]\n",
  "FOREWARDED": "FOREWARD, (archaic) to guard (something) in front [v]\n",
  "FOREWARDING": "FOREWARD, (archaic) to guard (something) in front [v]\n",
  "FOREWARDS": "FOREWARD, (archaic) to guard (something) in front [v]\n",
  "FOREWARN": "to warn in advance, also FORWARN [v -ED, -ING, -S]\n",
  "FOREWARNED": "FOREWARN, to warn in advance, also FORWARN [v]\n",
  "FOREWARNER": "one who forewarns [n -S]\n",
  "FOREWARNERS": "FOREWARNER, one who forewarns [n]\n",
  "FOREWARNING": "warn in advance [adj FOREWARNINGLY] / the act of forewarning [n -S]\n",
  "FOREWARNINGLY": "FOREWARNING, warn in advance [adv]\n",
  "FOREWARNINGS": "FOREWARNING, the act of forewarning [n]\n",
  "FOREWARNS": "FOREWARN, to warn in advance, also FORWARN [v]\n",
  "FOREWEIGH": "(archaic) to estimate beforehand [v -ED, -ING, -S]\n",
  "FOREWEIGHED": "FOREWEIGH, (archaic) to estimate beforehand [v]\n",
  "FOREWEIGHING": "FOREWEIGH, (archaic) to estimate beforehand [v]\n",
  "FOREWEIGHS": "FOREWEIGH, (archaic) to estimate beforehand [v]\n",
  "FOREWENT": "FOREGO, to go before [v]\n",
  "FOREWIND": "a wind from the forequarter [n -S]\n",
  "FOREWINDS": "FOREWIND, a wind from the forequarter [n]\n",
  "FOREWING": "an anterior wing of an insect [n -S]\n",
  "FOREWINGS": "FOREWING, an anterior wing of an insect [n]\n",
  "FOREWOMAN": "a woman overseer [n FOREWOMEN]\n",
  "FOREWOMEN": "FOREWOMAN, a woman overseer [n]\n",
  "FOREWORD": "an introductory statement [n -S]\n",
  "FOREWORDS": "FOREWORD, an introductory statement [n]\n",
  "FOREWORN": "worn out, also FORWORN [adj]\n",
  "FOREX": "(short for) foreign exchange [n -ES]\n",
  "FOREXES": "FOREX, (short for) foreign exchange [n]\n",
  "FOREYARD": "the lowest yard on a foremast [n -S]\n",
  "FOREYARDS": "FOREYARD, the lowest yard on a foremast [n]\n",
  "FORFAIR": "(obsolete) to perish or decay [v FORFAIRED or (Scots) FORFAIRN, FORFAIRING, FORFAIRS]\n",
  "FORFAIRED": "FORFAIR, (obsolete) to perish or decay [v]\n",
  "FORFAIRING": "FORFAIR, (obsolete) to perish or decay [v]\n",
  "FORFAIRN": "FORFAIR, (obsolete) to perish or decay [v]\n",
  "FORFAIRS": "FORFAIR, (obsolete) to perish or decay [v]\n",
  "FORFAITER": "a person who, or company which, buys and sells debts arising from forfaiting [n -S]\n",
  "FORFAITERS": "FORFAITER, a person who, or company which, buys and sells debts arising from forfaiting [n]\n",
  "FORFAITING": "a method of export finance where debts on exported goods are bought and then sold on to banks etc. [n -S]\n",
  "FORFAITINGS": "FORFAITING, a method of export finance where debts on exported goods are bought and then sold on to banks etc. [n]\n",
  "FORFAULT": "forfeiture [n -S]\n",
  "FORFAULTS": "FORFAULT, forfeiture [n]\n",
  "FORFEIT": "to lose the right to by fault or penalty [v -ED, -ING, -S]\n",
  "FORFEITABLE": "that can be forfeited [adj]\n",
  "FORFEITED": "FORFEIT, to lose the right to by fault or penalty [v]\n",
  "FORFEITER": "(Shakespeare) one who forfeits his land [n -S]\n",
  "FORFEITERS": "FORFEITER, (Shakespeare) one who forfeits his land [n]\n",
  "FORFEITING": "FORFEIT, to lose the right to by fault or penalty [v]\n",
  "FORFEITS": "FORFEIT, to lose the right to by fault or penalty [v]\n",
  "FORFEITURE": "the act of forfeiting [n -S]\n",
  "FORFEITURES": "FORFEITURE, the act of forfeiting [n]\n",
  "FORFEND": "(archaic) to protect, also FOREFEND [v -ED, -ING, -S]\n",
  "FORFENDED": "FORFEND, (archaic) to protect, also FOREFEND [v]\n",
  "FORFENDING": "FORFEND, (archaic) to protect, also FOREFEND [v]\n",
  "FORFENDS": "FORFEND, (archaic) to protect, also FOREFEND [v]\n",
  "FORFEUCHEN": "(Scots) exhausted, also FORFOCHEN, FORFOUGHEN, FORFOUGHTEN [adj]\n",
  "FORFEX": "(Latin) a pair of scissors or pincers [n -ES]\n",
  "FORFEXES": "FORFEX, (Latin) a pair of scissors or pincers [n]\n",
  "FORFICATE": "deeply forked, esp. of certain birds' tails [adj]\n",
  "FORFICULATE": "like scissors [adj]\n",
  "FORFOCHEN": "(Scots) exhausted, also FORFEUCHEN, FORFOUGHEN, FORFOUGHTEN [adj]\n",
  "FORFOUGHEN": "(Scots) exhausted, also FORFEUCHEN, FORFOCHEN, FORFOUGHTEN [adj]\n",
  "FORFOUGHTEN": "(Scots) exhausted, also FORFEUCHEN, FORFOCHEN, FORFOUGHEN [adj]\n",
  "FORGAT": "FORGET, to fail to remember [v]\n",
  "FORGATHER": "to gather together, assemble, also FOREGATHER [v -ED, -ING, -S]\n",
  "FORGATHERED": "FORGATHER, to gather together, assemble, also FOREGATHER [v]\n",
  "FORGATHERING": "FORGATHER, to gather together, assemble, also FOREGATHER [v]\n",
  "FORGATHERS": "FORGATHER, to gather together, assemble, also FOREGATHER [v]\n",
  "FORGAVE": "FORGIVE, to pardon [v]\n",
  "FORGE": "to counterfeit for fraudulent purposes [v FORGED, FORGING, FORGES]\n",
  "FORGEABILITIES": "FORGEABILITY, the state of being forgeable [n]\n",
  "FORGEABILITY": "the state of being forgeable [n FORGEABILITIES]\n",
  "FORGEABLE": "that can be forged [adj]\n",
  "FORGED": "FORGE, to counterfeit for fraudulent purposes [v]\n",
  "FORGEMAN": "an iron worker [n FORGEMEN]\n",
  "FORGEMEN": "FORGEMAN, an iron worker [n]\n",
  "FORGER": "one that forges [n -S]\n",
  "FORGERIES": "FORGERY, the act of fraudulently making or altering anything, esp. anything printed [n]\n",
  "FORGERS": "FORGER, one that forges [n]\n",
  "FORGERY": "the act of fraudulently making or altering anything, esp. anything printed [n FORGERIES]\n",
  "FORGES": "FORGE, to counterfeit for fraudulent purposes [v]\n",
  "FORGET": "to fail to remember [v FORGAT or FORGOT, FORGOTTEN, FORGETTING, FORGETS]\n",
  "FORGETFUL": "inclined to forget [adj FORGETFULLY]\n",
  "FORGETFULLY": "FORGETFUL, inclined to forget [adv]\n",
  "FORGETFULNESS": "the state of being forgetful [n -ES]\n",
  "FORGETFULNESSES": "FORGETFULNESS, the state of being forgetful [n]\n",
  "FORGETIVE": "(Shakespeare) creative, inventive [adj]\n",
  "FORGETS": "FORGET, to fail to remember [v]\n",
  "FORGETTABLE": "fit or likely to be forgotten [adj]\n",
  "FORGETTER": "one who forgets [n -S]\n",
  "FORGETTERIES": "FORGETTERY, (colloquial) a capacity for forgetting [n]\n",
  "FORGETTERS": "FORGETTER, one who forgets [n]\n",
  "FORGETTERY": "(colloquial) a capacity for forgetting [n FORGETTERIES]\n",
  "FORGETTING": "failing to remember [adj FORGETTINGLY] / the act of not remembering [n -S]\n",
  "FORGETTINGLY": "FORGETTING [adv]\n",
  "FORGETTINGS": "FORGETTING, the act of not remembering [n]\n",
  "FORGING": "the act of forging, also FORGERY [n -S]\n",
  "FORGINGS": "FORGING, the act of forging, also FORGERY [n]\n",
  "FORGIVABLE": "that can be forgiven [adj FORGIVABLY]\n",
  "FORGIVABLY": "FORGIVABLE, that can be forgiven [adv]\n",
  "FORGIVE": "to pardon [v FORGAVE, FORGIVEN, FORGIVING, FORGIVES]\n",
  "FORGIVEN": "FORGIVE, to pardon [v]\n",
  "FORGIVENESS": "the act of forgiving [n -ES]\n",
  "FORGIVENESSES": "FORGIVENESS, the act of forgiving [n]\n",
  "FORGIVER": "one who forgives [n -S]\n",
  "FORGIVERS": "FORGIVER, one who forgives [n]\n",
  "FORGIVES": "FORGIVE, to pardon [v]\n",
  "FORGIVING": "FORGIVE, to pardon [v]\n",
  "FORGIVINGLY": "FORGIVING, FORGIVE, to pardon [adv]\n",
  "FORGIVINGNESS": "the state of being forgiving [n -ES]\n",
  "FORGIVINGNESSES": "FORGIVINGNESS, the state of being forgiving [n]\n",
  "FORGO": "to refrain from [v FORWENT, FORGONE, FORGOING, FORGOES]\n",
  "FORGOER": "one who forgoes [n -S]\n",
  "FORGOERS": "FORGOER, one who forgoes [n]\n",
  "FORGOES": "FORGO, to refrain from [v]\n",
  "FORGOING": "FORGO, to refrain from [v]\n",
  "FORGONE": "FORGO, to refrain from [v]\n",
  "FORGOT": "FORGET, to fail to remember [v]\n",
  "FORGOTTEN": "FORGET, to fail to remember [v]\n",
  "FORGOTTENNESS": "the state of being forgotten [n -ES]\n",
  "FORGOTTENNESSES": "FORGOTTENNESS, the state of being forgotten [n]\n",
  "FORHAILE": "(Spenser) to distract [v FORHAILED, FORHAILING, FORHAILES]\n",
  "FORHAILED": "FORHAILE, (Spenser) to distract [v]\n",
  "FORHAILES": "FORHAILE, (Spenser) to distract [v]\n",
  "FORHAILING": "FORHAILE, (Spenser) to distract [v]\n",
  "FORHENT": "to overtake, also FOREHENT [v FORHENT, FORHENTING, FORHENTS]\n",
  "FORHENTING": "FORHENT, to overtake, also FOREHENT [v]\n",
  "FORHENTS": "FORHENT, to overtake, also FOREHENT [v]\n",
  "FORHOO": "(Scots) to desert or abandon, also FORHOOIE, FORHOW [v -ED, -ING, -S]\n",
  "FORHOOED": "FORHOO, (Scots) to desert or abandon, also FORHOOIE, FORHOW [v]\n",
  "FORHOOIE": "(Scots) to desert or abandon, also FORHOW, FORHOO [v FORHOOIED, FORHOOIEING, FORHOOIES]\n",
  "FORHOOIED": "FORHOOIE, (Scots) to desert or abandon, also FORHOW, FORHOO [v]\n",
  "FORHOOIEING": "FORHOOIE, (Scots) to desert or abandon, also FORHOW, FORHOO [v]\n",
  "FORHOOIES": "FORHOOIE, (Scots) to desert or abandon, also FORHOW, FORHOO [v]\n",
  "FORHOOING": "FORHOO, (Scots) to desert or abandon, also FORHOOIE, FORHOW [v]\n",
  "FORHOOS": "FORHOO, (Scots) to desert or abandon, also FORHOOIE, FORHOW [v]\n",
  "FORHOW": "to desert or abandon, also FORHOO, FORHOOIE [v -ED, -ING, -S]\n",
  "FORHOWED": "FORHOW, to desert or abandon, also FORHOO, FORHOOIE [v]\n",
  "FORHOWING": "FORHOW, to desert or abandon, also FORHOO, FORHOOIE [v]\n",
  "FORHOWS": "FORHOW, to desert or abandon, also FORHOO, FORHOOIE [v]\n",
  "FORINSEC": "of service, due to the superior from whom one's lord held land [adj]\n",
  "FORINSECAL": "(obsolete) foreign, alien, extrinsic [adj]\n",
  "FORINT": "a monetary unit of Hungary [n -S]\n",
  "FORINTS": "FORINT, a monetary unit of Hungary [n]\n",
  "FORISFAMILIATE": "(Scots) to emancipate from parental authority [v FORISFAMILIATED, FORISFAMILIATES]\n",
  "FORISFAMILIATED": "FORISFAMILIATE, (Scots) to emancipate from parental authority [v]\n",
  "FORISFAMILIATES": "FORISFAMILIATE, (Scots) to emancipate from parental authority [v]\n",
  "FORJASKIT": "(Scots) tired out, also DISJASKIT, FORJESKIT [adj]\n",
  "FORJESKIT": "(Scots) tired out, also DISJASKIT, FORJASKIT [adj]\n",
  "FORJUDGE": "to judge before hearing the facts and proof, also FOREJUDGE [v FORJUDGED, FORJUDGING, FORJUDGES]\n",
  "FORJUDGED": "FORJUDGE, to judge before hearing the facts and proof, also FOREJUDGE [v]\n",
  "FORJUDGES": "FORJUDGE, to judge before hearing the facts and proof, also FOREJUDGE [v]\n",
  "FORJUDGING": "FORJUDGE, to judge before hearing the facts and proof, also FOREJUDGE [v]\n",
  "FORJUDGMENT": "the act of forjudging [n -S]\n",
  "FORJUDGMENTS": "FORJUDGMENT, the act of forjudging [n]\n",
  "FORK": "to work with a pronged implement [v -ED, -ING, -S]\n",
  "FORKBALL": "a breaking pitch in baseball [n -S]\n",
  "FORKBALLS": "FORKBALL, a breaking pitch in baseball [n]\n",
  "FORKED": "FORK, to work with a pronged implement [v]\n",
  "FORKEDLY": "FORKED, FORK, to work with a pronged implement [adv]\n",
  "FORKEDNESS": "the state of being forked [n -ES]\n",
  "FORKEDNESSES": "FORKEDNESS, the state of being forked [n]\n",
  "FORKER": "one who forks [n -S]\n",
  "FORKERS": "FORKER, one who forks [n]\n",
  "FORKFUL": "as much as a fork can hold [n FORKFULS or FORKSFUL]\n",
  "FORKFULS": "FORKFUL, as much as a fork can hold [n]\n",
  "FORKHEAD": "the forked end of a rod, holding a connecting pin [n -S]\n",
  "FORKHEADS": "FORKHEAD, the forked end of a rod, holding a connecting pin [n]\n",
  "FORKIER": "FORKY, resembling a fork [adj]\n",
  "FORKIEST": "FORKY, resembling a fork [adj]\n",
  "FORKINESS": "the state of dividing in a forklike manner [n -ES]\n",
  "FORKINESSES": "FORKINESS, the state of dividing in a forklike manner [n]\n",
  "FORKING": "FORK, to work with a pronged implement [v]\n",
  "FORKLESS": "without a fork [adj]\n",
  "FORKLIFT": "to raise or move by machine [v -ED, -ING, -S]\n",
  "FORKLIFTED": "FORKLIFT, to raise or move by machine [v]\n",
  "FORKLIFTING": "FORKLIFT, to raise or move by machine [v]\n",
  "FORKLIFTS": "FORKLIFT, to raise or move by machine [v]\n",
  "FORKLIKE": "like a fork [adj]\n",
  "FORKS": "FORK, to work with a pronged implement [v]\n",
  "FORKSFUL": "FORKFUL, as much as a fork can hold [n]\n",
  "FORKTAIL": "one of a group of birds including the kite [n -S]\n",
  "FORKTAILS": "FORKTAIL, one of a group of birds including the kite [n]\n",
  "FORKY": "resembling a fork [adj FORKIER, FORKIEST]\n",
  "FORLANA": "(Italian) a dance of old Venice, also FURLANA [n -S]\n",
  "FORLANAS": "FORLANA, (Italian) a dance of old Venice, also FURLANA [n]\n",
  "FORLEND": "(archaic) to grant or resign beforehand, also FORELEND [v FORLENT, FORLENDING, FORLENDS]\n",
  "FORLENDING": "FORLEND, (archaic) to grant or resign beforehand, also FORELEND [v]\n",
  "FORLENDS": "FORLEND, (archaic) to grant or resign beforehand, also FORELEND [v]\n",
  "FORLENT": "FORLEND, (archaic) to grant or resign beforehand, also FORELEND [v]\n",
  "FORLESE": "to lose, forsake [v FORLORE, FORLESING, FORLESES]\n",
  "FORLESES": "FORLESE, to lose, forsake [v]\n",
  "FORLESING": "FORLESE, to lose, forsake [v]\n",
  "FORLORE": "FORLESE, to lose, forsake [v]\n",
  "FORLORN": "forsaken [adj FORLORNER, FORLORNEST, FORLORNLY] / (Shakespeare) a forsaken person [n -S]\n",
  "FORLORNER": "FORLORN, forsaken [adj]\n",
  "FORLORNEST": "FORLORN, forsaken [adj]\n",
  "FORLORNLY": "FORLORN, forsaken [adv]\n",
  "FORLORNNESS": "the state of being forlorn [n -ES]\n",
  "FORLORNNESSES": "FORLORNNESS, the state of being forlorn [n]\n",
  "FORLORNS": "FORLORN, (Shakespeare) a forsaken person [n]\n",
  "FORM": "to shape or produce [v -ED, -ING, -S]\n",
  "FORMABILITIES": "FORMABILITY, the quality of being formable [n]\n",
  "FORMABILITY": "the quality of being formable [n FORMABILITIES]\n",
  "FORMABLE": "able to be formed [adj FORMABLY]\n",
  "FORMABLY": "FORMABLE, able to be formed [adv]\n",
  "FORMAL": "regulated, not casual [adj FORMALLY] / a social event that requires evening dress [n -S]\n",
  "FORMALDEHYDE": "a formic aldehyde, formalin [n -S]\n",
  "FORMALDEHYDES": "FORMALDEHYDE, a formic aldehyde, formalin [n]\n",
  "FORMALIN": "an aqueous solution of formaldehyde, used as a disinfectant, preservative for biological specimens, etc., also FORMALINE [n FORMALINS]\n",
  "FORMALINE": "a 40 per cent solution of formaldehyde in water, used as a disinfectant, also FORMALIN [n -S]\n",
  "FORMALINES": "FORMALINE, a 40 per cent solution of formaldehyde in water, used as a disinfectant, also FORMALIN [n]\n",
  "FORMALINS": "FORMALIN, an aqueous solution of formaldehyde, used as a disinfectant, preservative for biological specimens, etc., also FORMALINE [n]\n",
  "FORMALISABLE": "capable of being formalised, also FORMALIZABLE [adj]\n",
  "FORMALISATION": "the act of formalising, also FORMALIZATION [n -S]\n",
  "FORMALISATIONS": "FORMALISATION, the act of formalising, also FORMALIZATION [n]\n",
  "FORMALISE": "to make formal, also FORMALIZE [v FORMALISED, FORMALISING, FORMALISES]\n",
  "FORMALISED": "FORMALISE, to make formal, also FORMALIZE [v]\n",
  "FORMALISER": "one who formalises, also FORMALIZER [n -S]\n",
  "FORMALISERS": "FORMALISER, one who formalises, also FORMALIZER [n]\n",
  "FORMALISES": "FORMALISE, to make formal, also FORMALIZE [v]\n",
  "FORMALISING": "FORMALISE, to make formal, also FORMALIZE [v]\n",
  "FORMALISM": "the practice or the doctrine of strict adherence to, or dependence on, external forms, esp. in matters of religion [n -S]\n",
  "FORMALISMS": "FORMALISM, the practice or the doctrine of strict adherence to, or dependence on, external forms, esp. in matters of religion [n]\n",
  "FORMALIST": "a person having exaggerated regard to rules or established usages [n -S]\n",
  "FORMALISTIC": "relating to formalism [adj FORMALISTICALLY]\n",
  "FORMALISTICALLY": "FORMALISTIC, relating to formalism [adv]\n",
  "FORMALISTS": "FORMALIST, a person having exaggerated regard to rules or established usages [n]\n",
  "FORMALITER": "(Latin) formally or in respect of the formal element [adv]\n",
  "FORMALITIES": "FORMALITY, the condition of being formal [n]\n",
  "FORMALITY": "the condition of being formal [n FORMALITIES]\n",
  "FORMALIZABLE": "capable of being formalized, also FORMALISABLE [adj]\n",
  "FORMALIZATION": "the act of formalizing, also FORMALISATION [n -S]\n",
  "FORMALIZATIONS": "FORMALIZATION, the act of formalizing, also FORMALISATION [n]\n",
  "FORMALIZE": "to make formal, also FORMALISE [v FORMALIZED, FORMALIZING, FORMALIZES]\n",
  "FORMALIZED": "FORMALIZE, to make formal, also FORMALISE [v]\n",
  "FORMALIZER": "one who formalizes, also FORMALISER [n -S]\n",
  "FORMALIZERS": "FORMALIZER, one who formalizes, also FORMALISER [n]\n",
  "FORMALIZES": "FORMALIZE, to make formal, also FORMALISE [v]\n",
  "FORMALIZING": "FORMALIZE, to make formal, also FORMALISE [v]\n",
  "FORMALLY": "FORMAL, regulated, not casual [adv]\n",
  "FORMALNESS": "formality [n -ES]\n",
  "FORMALNESSES": "FORMALNESS, formality [n]\n",
  "FORMALS": "FORMAL, a social event that requires evening dress [n]\n",
  "FORMAMIDE": "a colourless hygroscopic liquid used as a solvent [n -S]\n",
  "FORMAMIDES": "FORMAMIDE, a colourless hygroscopic liquid used as a solvent [n]\n",
  "FORMANT": "(German) a component of a speech sound [n -S]\n",
  "FORMANTS": "FORMANT, (German) a component of a speech sound [n]\n",
  "FORMAT": "to follow the style or manner of procedure [v FORMATTED, FORMATTING, FORMATS]\n",
  "FORMATE": "to fly in formation [v FORMATED, FORMATING, FORMATES]\n",
  "FORMATED": "FORMATE, to fly in formation [v]\n",
  "FORMATES": "FORMATE, to fly in formation [v]\n",
  "FORMATING": "FORMATE, to fly in formation [v]\n",
  "FORMATION": "something formed or made [n -S]\n",
  "FORMATIONAL": "relating to formation [adj]\n",
  "FORMATIONS": "FORMATION, something formed or made [n]\n",
  "FORMATIVE": "tending to form [adj FORMATIVELY] / a formative element or agent [n -S]\n",
  "FORMATIVELY": "FORMATIVE, tending to form [adv]\n",
  "FORMATIVENESS": "FORMATIVE, tending to form [n]\n",
  "FORMATIVENESSES": "FORMATIVENESS, FORMATIVE, tending to form [n]\n",
  "FORMATIVES": "FORMATIVE, a formative element or agent [n]\n",
  "FORMATS": "FORMAT, to follow the style or manner of procedure [v]\n",
  "FORMATTED": "FORMAT, to follow the style or manner of procedure [v]\n",
  "FORMATTER": "a programme for formatting a disk etc. [n -S]\n",
  "FORMATTERS": "FORMATTER, a programme for formatting a disk etc. [n]\n",
  "FORMATTING": "the act of putting into a format [n -S]\n",
  "FORMATTINGS": "FORMATTING, the act of putting into a format [n]\n",
  "FORME": "a body of type secured for printing in chase [n -S]\n",
  "FORMED": "FORM, to shape or produce [v]\n",
  "FORMEE": "a kind of heraldic cross, having the arms narrow at the centre and expanding towards the ends [n -S]\n",
  "FORMEES": "FORMEE, a kind of heraldic cross, having the arms narrow at the centre and expanding towards the ends [n]\n",
  "FORMER": "preceding [adj FORMERLY] / someone or something who forms [n -S]\n",
  "FORMERLY": "previously [adv]\n",
  "FORMERS": "FORMER, someone or something who forms [n]\n",
  "FORMES": "FORME, a body of type secured for printing in chase [n]\n",
  "FORMFITTING": "fitting the form [adj]\n",
  "FORMFUL": "exhibiting good form [adj]\n",
  "FORMIATE": "a salt of formic acid [n -S]\n",
  "FORMIATES": "FORMIATE, a salt of formic acid [n]\n",
  "FORMIC": "of or pertaining to ants [adj]\n",
  "FORMICA": "any of various laminated products used especially for surface finish [n -S]\n",
  "FORMICANT": "crawling like an ant; (of a pulse) small and unequal [adj]\n",
  "FORMICARIA": "FORMICARIUM, an anthill, an ant colony, also FORMICARY [n]\n",
  "FORMICARIES": "FORMICARY, an anthill, also FORMICARIUM [n]\n",
  "FORMICARIUM": "an anthill, an ant colony, also FORMICARY [n FORMICARIA]\n",
  "FORMICARY": "an anthill, also FORMICARIUM [n FORMICARIES]\n",
  "FORMICAS": "FORMICA, any of various laminated products used especially for surface finish [n]\n",
  "FORMICATE": "resembling an ant [n -S] / to crawl around like an ant [v FORMICATED, FORMICATING, FORMICATES]\n",
  "FORMICATED": "FORMICATE, to crawl around like an ant [v]\n",
  "FORMICATES": "FORMICATE, to crawl around like an ant [v]\n",
  "FORMICATING": "FORMICATE, to crawl around like an ant [v]\n",
  "FORMICATION": "an abnormal feeling like the sensation of ants crawling on the skin [n -S]\n",
  "FORMICATIONS": "FORMICATION, an abnormal feeling like the sensation of ants crawling on the skin [n]\n",
  "FORMIDABILITIES": "FORMIDABILITY, the state of being formidable [n]\n",
  "FORMIDABILITY": "the state of being formidable [n FORMIDABILITIES]\n",
  "FORMIDABLE": "causing fear [adj FORMIDABLY]\n",
  "FORMIDABLENESS": "the state of being formidable [n]\n",
  "FORMIDABLY": "FORMIDABLE, causing fear [adv]\n",
  "FORMING": "the process of forming [n -S]\n",
  "FORMINGS": "FORMING, the process of forming [n]\n",
  "FORMLESS": "lacking structure [adj FORMLESSLY]\n",
  "FORMLESSLY": "FORMLESS, lacking structure [adv]\n",
  "FORMLESSNESS": "the state of being formless [n -ES]\n",
  "FORMLESSNESSES": "FORMLESSNESS, the state of being formless [n]\n",
  "FORMOL": "a formic aldehyde used as an antiseptic, also FORMALIN [n -S]\n",
  "FORMOLS": "FORMOL, a formic aldehyde used as an antiseptic, also FORMALIN [n]\n",
  "FORMS": "FORM, to shape or produce [v]\n",
  "FORMULA": "(Latin) a prescribed or set form [n FORMULAS or FORMULAE]\n",
  "FORMULAE": "FORMULA, (Latin) a prescribed or set form [n]\n",
  "FORMULAIC": "of the nature of a formula [adj FORMULAICALLY]\n",
  "FORMULAICALLY": "FORMULAIC, of the nature of a formula [adv]\n",
  "FORMULAR": "a model or set form [n -S]\n",
  "FORMULARIES": "FORMULARY, a book of formulae or precedents [n]\n",
  "FORMULARISATION": "the act of formularising, also FORMULARIZATION [n]\n",
  "FORMULARISE": "to state in or reduce to a formula, also FORMULARIZE [v FORMULARISED, FORMULARISING, FORMULARISES]\n",
  "FORMULARISED": "FORMULARISE, to state in or reduce to a formula, also FORMULARIZE [v]\n",
  "FORMULARISER": "one who formularises, also FORMULARIZER [n -S]\n",
  "FORMULARISERS": "FORMULARISER, one who formularises, also FORMULARIZER [n]\n",
  "FORMULARISES": "FORMULARISE, to state in or reduce to a formula, also FORMULARIZE [v]\n",
  "FORMULARISING": "FORMULARISE, to state in or reduce to a formula, also FORMULARIZE [v]\n",
  "FORMULARISTIC": "of or like a formula [adj]\n",
  "FORMULARIZATION": "the act of formularizing, also FORMULARISATION [n]\n",
  "FORMULARIZE": "to state in or reduce to a formula, also FORMULARISE [v FORMULARIZED, FORMULARIZING, FORMULARIZES]\n",
  "FORMULARIZED": "FORMULARIZE, to state in or reduce to a formula, also FORMULARISE [v]\n",
  "FORMULARIZER": "one who formularizes, also FORMULARISER [n -S]\n",
  "FORMULARIZERS": "FORMULARIZER, one who formularizes, also FORMULARISER [n]\n",
  "FORMULARIZES": "FORMULARIZE, to state in or reduce to a formula, also FORMULARISE [v]\n",
  "FORMULARIZING": "FORMULARIZE, to state in or reduce to a formula, also FORMULARISE [v]\n",
  "FORMULARS": "FORMULAR, a model or set form [n]\n",
  "FORMULARY": "a book of formulae or precedents [n FORMULARIES]\n",
  "FORMULAS": "FORMULA, (Latin) a prescribed or set form [n]\n",
  "FORMULATE": "to state or express in a clear definite form [v FORMULATED, FORMULATING, FORMULATES]\n",
  "FORMULATED": "FORMULATE, to state or express in a clear definite form [v]\n",
  "FORMULATES": "FORMULATE, to state or express in a clear definite form [v]\n",
  "FORMULATING": "FORMULATE, to state or express in a clear definite form [v]\n",
  "FORMULATION": "an act or the product of formulating [n -S]\n",
  "FORMULATIONS": "FORMULATION, an act or the product of formulating [n]\n",
  "FORMULATOR": "one who formulates [n -S]\n",
  "FORMULATORS": "FORMULATOR, one who formulates [n]\n",
  "FORMULISE": "to express in a formula, also FORMULIZE [v FORMULISED, FORMULISING, FORMULISES]\n",
  "FORMULISED": "FORMULISE, to express in a formula, also FORMULIZE [v]\n",
  "FORMULISES": "FORMULISE, to express in a formula, also FORMULIZE [v]\n",
  "FORMULISING": "FORMULISE, to express in a formula, also FORMULIZE [v]\n",
  "FORMULISM": "excessive use of, or dependence on, formulae [n -S]\n",
  "FORMULISMS": "FORMULISM, excessive use of, or dependence on, formulae [n]\n",
  "FORMULIST": "one who depends excessively on formulae [n -S]\n",
  "FORMULISTIC": "relating to formulism [adj]\n",
  "FORMULISTS": "FORMULIST, one who depends excessively on formulae [n]\n",
  "FORMULIZE": "to express in a formula, also FORMULISE [v FORMULIZED, FORMULIZING, FORMULIZES]\n",
  "FORMULIZED": "FORMULIZE, to express in a formula, also FORMULISE [v]\n",
  "FORMULIZES": "FORMULIZE, to express in a formula, also FORMULISE [v]\n",
  "FORMULIZING": "FORMULIZE, to express in a formula, also FORMULISE [v]\n",
  "FORMWORK": "boxes for holding setting concrete [n -S]\n",
  "FORMWORKS": "FORMWORK, boxes for holding setting concrete [n]\n",
  "FORMYL": "a radical derived from formic acid [n -S]\n",
  "FORMYLS": "FORMYL, a radical derived from formic acid [n]\n",
  "FORNENST": "(Scots) right opposite to in location, also FERNINST, FOREANENT, FORNENT [adv]\n",
  "FORNENT": "(Scots) right opposite to in location, also FERNINST, FOREANENT, FORNENST [adv]\n",
  "FORNICAL": "relating to a fornix, an arch or fold [adj]\n",
  "FORNICATE": "to have illicit sexual intercourse [v FORNICATED, FORNICATING, FORNICATES]\n",
  "FORNICATED": "FORNICATE, to have illicit sexual intercourse [v]\n",
  "FORNICATES": "FORNICATE, to have illicit sexual intercourse [v]\n",
  "FORNICATING": "FORNICATE, to have illicit sexual intercourse [v]\n",
  "FORNICATION": "consensual sexual intercourse between two persons not married to each other [n -S]\n",
  "FORNICATIONS": "FORNICATION, consensual sexual intercourse between two persons not married to each other [n]\n",
  "FORNICATOR": "one who fornicates [n -S]\n",
  "FORNICATORS": "FORNICATOR, one who fornicates [n]\n",
  "FORNICATRESS": "a female fornicator [n -ES]\n",
  "FORNICATRESSES": "FORNICATRESS, a female fornicator [n]\n",
  "FORNICES": "FORNIX, (Latin) an arched anatomical structure [n]\n",
  "FORNIX": "(Latin) an arched anatomical structure [n FORNICES]\n",
  "FORPET": "(Scots) a measure of grain, also FORPIT [n -S]\n",
  "FORPETS": "FORPET, (Scots) a measure of grain, also FORPIT [n]\n",
  "FORPINE": "(Spenser) to waste away [v FORPINED, FORPINING, FORPINES]\n",
  "FORPINED": "FORPINE, (Spenser) to waste away [v]\n",
  "FORPINES": "FORPINE, (Spenser) to waste away [v]\n",
  "FORPINING": "FORPINE, (Spenser) to waste away [v]\n",
  "FORPIT": "(Scots) a measure of grain, also FORPET [n -S]\n",
  "FORPITS": "FORPIT, (Scots) a measure of grain, also FORPET [n]\n",
  "FORRAD": "(Scots) forward, also FORRIT [adj] / a forward [n -S]\n",
  "FORRADER": "(Scots) forwards, also FORRARDER [adv]\n",
  "FORRADS": "FORRAD, a forward [n]\n",
  "FORRARDER": "(Scots dialect) further forward, also FORRADER [adj]\n",
  "FORRAY": "(Spenser) to foray; to ravage [v -ED, -ING, -S]\n",
  "FORRAYED": "FORRAY, (Spenser) to foray; to ravage [v]\n",
  "FORRAYING": "FORRAY, (Spenser) to foray; to ravage [v]\n",
  "FORRAYS": "FORRAY, (Spenser) to foray; to ravage [v]\n",
  "FORREN": "(Milton) foreign [adj]\n",
  "FORRIT": "(Scots) forward, also FORRAD [adv]\n",
  "FORSAID": "FORSAY, to forbid, to renounce [v]\n",
  "FORSAKE": "to quit or leave entirely [v FORSOOK, FORSAKEN, FORSAKING, FORSAKES]\n",
  "FORSAKEN": "FORSAKE, to quit or leave entirely [v]\n",
  "FORSAKENLY": "FORSAKEN, FORSAKE, to quit or leave entirely [adv]\n",
  "FORSAKENNESS": "the state of being forsaken [n -ES]\n",
  "FORSAKENNESSES": "FORSAKENNESS, the state of being forsaken [n]\n",
  "FORSAKER": "one who forsakes [n -S]\n",
  "FORSAKERS": "FORSAKER, one who forsakes [n]\n",
  "FORSAKES": "FORSAKE, to quit or leave entirely [v]\n",
  "FORSAKING": "abandonment [n -S]\n",
  "FORSAKINGS": "FORSAKING, abandonment [n]\n",
  "FORSAY": "to forbid, to renounce [v FORSAID, FORSAYING, FORSAYS]\n",
  "FORSAYING": "FORSAY, to forbid, to renounce [v]\n",
  "FORSAYS": "FORSAY, to forbid, to renounce [v]\n",
  "FORSLACK": "to be slack, also FORESLACK [v -ED, -ING, -S]\n",
  "FORSLACKED": "FORSLACK, to be slack, also FORESLACK [v]\n",
  "FORSLACKING": "FORSLACK, to be slack, also FORESLACK [v]\n",
  "FORSLACKS": "FORSLACK, to be slack, also FORESLACK [v]\n",
  "FORSLOE": "(Shakespeare) to delay, also FORSLOW, FORESLOW [v FORSLOED, FORSLOEING, FORSLOES]\n",
  "FORSLOED": "FORSLOE, (Shakespeare) to delay, also FORSLOW, FORESLOW [v]\n",
  "FORSLOEING": "FORSLOE, (Shakespeare) to delay, also FORSLOW, FORESLOW [v]\n",
  "FORSLOES": "FORSLOE, (Shakespeare) to delay, also FORSLOW, FORESLOW [v]\n",
  "FORSLOW": "(Shakespeare) to delay, also FORESLOW, FORSLOE [v -ED, -ING, -S]\n",
  "FORSLOWED": "FORSLOW, (Shakespeare) to delay, also FORESLOW, FORSLOE [v]\n",
  "FORSLOWING": "FORSLOW, (Shakespeare) to delay, also FORESLOW, FORSLOE [v]\n",
  "FORSLOWS": "FORSLOW, (Shakespeare) to delay, also FORESLOW, FORSLOE [v]\n",
  "FORSOOK": "FORSAKE, to quit or leave entirely [v]\n",
  "FORSOOTH": "(archaic) in truth; indeed [interj]\n",
  "FORSPEAK": "to speak against, also FORESPEAK [v FORSPOKE, FORSPOKEN, FORSPEAKING, FORSPEAKS]\n",
  "FORSPEAKING": "FORSPEAK, to speak against, also FORESPEAK [v]\n",
  "FORSPEAKS": "FORSPEAK, to speak against, also FORESPEAK [v]\n",
  "FORSPEND": "to wear out, also FORESPEND [v FORSPENT, FORSPENDING, FORSPENDS]\n",
  "FORSPENDING": "FORSPEND, to wear out, also FORESPEND [v]\n",
  "FORSPENDS": "FORSPEND, to wear out, also FORESPEND [v]\n",
  "FORSPENT": "FORSPEND, to wear out, also FORESPEND [v]\n",
  "FORSPOKE": "FORSPEAK, to speak against, also FORESPEAK [v]\n",
  "FORSPOKEN": "FORSPEAK, to speak against, also FORESPEAK [v]\n",
  "FORSTERITE": "a white, yellow, or green mineral of the olivine group consisting of magnesium silicate [n -S]\n",
  "FORSTERITES": "FORSTERITE, a white, yellow, or green mineral of the olivine group consisting of magnesium silicate [n]\n",
  "FORSWATT": "(Spenser) covered with sweat [adj]\n",
  "FORSWEAR": "to deny under oath, also FORESWEAR [v FORSWORE, FORSWORN, FORSWEARING, FORSWEARS]\n",
  "FORSWEARER": "one who forswears [n -S]\n",
  "FORSWEARERS": "FORSWEARER, one who forswears [n]\n",
  "FORSWEARING": "FORSWEAR, to deny under oath, also FORESWEAR [v]\n",
  "FORSWEARS": "FORSWEAR, to deny under oath, also FORESWEAR [v]\n",
  "FORSWINK": "(obsolete) to exhaust by labour [v FORSWUNK, FORSWONCK or FORSWINKED, FORSWINKING, FORSWINKS]\n",
  "FORSWINKED": "FORSWINK, (obsolete) to exhaust by labour [v]\n",
  "FORSWINKING": "FORSWINK, (obsolete) to exhaust by labour [v]\n",
  "FORSWINKS": "FORSWINK, (obsolete) to exhaust by labour [v]\n",
  "FORSWONCK": "(Spenser) overworked, also FORSWUNK [adj]\n",
  "FORSWORE": "FORSWEAR, to deny under oath, also FORESWEAR [v]\n",
  "FORSWORN": "FORSWEAR, to deny under oath, also FORESWEAR [v]\n",
  "FORSWORNNESS": "the state of being forsworn [n -ES]\n",
  "FORSWORNNESSES": "FORSWORNNESS, the state of being forsworn [n]\n",
  "FORSWUNK": "(Spenser) overworked, also FORSWONCK [adj]\n",
  "FORSYTHIA": "any shrub of the genus Forsythia, a popular garden plant producing clusters of yellow jasmine-like flowers in the spring [n -S]\n",
  "FORSYTHIAS": "FORSYTHIA, any shrub of the genus Forsythia, a popular garden plant producing clusters of yellow jasmine-like flowers in the spring [n]\n",
  "FORT": "to fortify [v -ED, -ING, -S]\n",
  "FORTALICE": "(historical) a fortress; a small outwork of a fortification [n -S]\n",
  "FORTALICES": "FORTALICE, (historical) a fortress; a small outwork of a fortification [n]\n",
  "FORTE": "(French) one's strong point [n -S]\n",
  "FORTED": "FORT, to fortify [v]\n",
  "FORTEPIANIST": "a player of the fortepiano [n -S]\n",
  "FORTEPIANISTS": "FORTEPIANIST, a player of the fortepiano [n]\n",
  "FORTEPIANO": "loud with immediate relapse into softness [adj] / the eighteenth century name for an early type of piano; a fortepiano note [n -S]\n",
  "FORTEPIANOS": "FORTEPIANO, the eighteenth century name for an early type of piano; a fortepiano note [n]\n",
  "FORTES": "FORTE, (French) one's strong point [n]\n",
  "FORTH": "onward in time [adv]\n",
  "FORTHCAME": "FORTHCOME, (obsolete) to come forth [v]\n",
  "FORTHCOME": "(obsolete) to come forth [v FORTHCAME, FORTHCOMING, FORTHCOMES]\n",
  "FORTHCOMES": "FORTHCOME, (obsolete) to come forth [v]\n",
  "FORTHCOMING": "FORTHCOME, (obsolete) to come forth [v]\n",
  "FORTHCOMINGNESS": "the state of being forthcoming [n]\n",
  "FORTHGOING": "(obsolete) a going forth [n -S]\n",
  "FORTHGOINGS": "FORTHGOING, (obsolete) a going forth [n]\n",
  "FORTHINK": "to repent; to regret [v FORTHOUGHT, FORTHINKING, FORTHINKS]\n",
  "FORTHINKING": "FORTHINK, to repent; to regret [v]\n",
  "FORTHINKS": "FORTHINK, to repent; to regret [v]\n",
  "FORTHOUGHT": "FORTHINK, to repent; to regret [v]\n",
  "FORTHRIGHT": "straightforward [adj FORTHRIGHTLY] / (Shakespeare) a straight path [n -S]\n",
  "FORTHRIGHTLY": "FORTHRIGHT, straightforward [adv]\n",
  "FORTHRIGHTNESS": "the state of being forthright [n]\n",
  "FORTHRIGHTS": "FORTHRIGHT, (Shakespeare) a straight path [n]\n",
  "FORTHWITH": "immediately [adv]\n",
  "FORTHY": "(Spenser) therefore, for that [adv]\n",
  "FORTIES": "FORTY, a number [n]\n",
  "FORTIETH": "one of forty equal parts [n -S]\n",
  "FORTIETHS": "FORTIETH, one of forty equal parts [n]\n",
  "FORTIFIABLE": "capable of being fortified [adj]\n",
  "FORTIFICATION": "an act of fortifying [n -S]\n",
  "FORTIFICATIONS": "FORTIFICATION, an act of fortifying [n]\n",
  "FORTIFIED": "FORTIFY, to strengthen against attack [v]\n",
  "FORTIFIER": "something that fortifies [n -S]\n",
  "FORTIFIERS": "FORTIFIER, something that fortifies [n]\n",
  "FORTIFIES": "FORTIFY, to strengthen against attack [v]\n",
  "FORTIFY": "to strengthen against attack [v FORTIFIED, FORTIFYING, FORTIFIES]\n",
  "FORTIFYING": "FORTIFY, to strengthen against attack [v]\n",
  "FORTIFYINGLY": "FORTIFYING, FORTIFY, to strengthen against attack [adv]\n",
  "FORTILAGE": "(Spenser) fortress, stronghold [n -S]\n",
  "FORTILAGES": "FORTILAGE, (Spenser) fortress, stronghold [n]\n",
  "FORTING": "FORT, to fortify [v]\n",
  "FORTIS": "a consonant, such as p or f, pronounced with tension and strong articulation [n FORTES]\n",
  "FORTISSIMI": "FORTISSIMO, a very loud passage in music [n]\n",
  "FORTISSIMO": "(Italian) very loud; with the utmost strength or loudness [adj] / a very loud passage in music [n FORTISSIMI or FORTISSIMOS]\n",
  "FORTISSIMOS": "FORTISSIMO, a very loud passage in music [n]\n",
  "FORTISSISSIMO": "(Italian) very very loud [adv]\n",
  "FORTITUDE": "strength of mind that enables a person to encounter danger or bear pain or adversity with courage [n -S]\n",
  "FORTITUDES": "FORTITUDE, strength of mind that enables a person to encounter danger or bear pain or adversity with courage [n]\n",
  "FORTITUDINOUS": "showing fortitude [adj]\n",
  "FORTLET": "a little fort [n -S]\n",
  "FORTLETS": "FORTLET, a little fort [n]\n",
  "FORTNIGHT": "a period of two weeks [n -S]\n",
  "FORTNIGHTLIES": "FORTNIGHTLY, a publication appearing once every two weeks [n]\n",
  "FORTNIGHTLY": "a publication appearing once every two weeks [n FORTNIGHTLIES]\n",
  "FORTNIGHTS": "FORTNIGHT, a period of two weeks [n]\n",
  "FORTRESS": "to strengthen with a fortress [v -ED, -ING, -ES]\n",
  "FORTRESSED": "FORTRESS, to strengthen with a fortress [v]\n",
  "FORTRESSES": "FORTRESS, to strengthen with a fortress [v]\n",
  "FORTRESSING": "FORTRESS, to strengthen with a fortress [v]\n",
  "FORTRESSLIKE": "like a fortress [adj]\n",
  "FORTS": "FORT, to fortify [v]\n",
  "FORTUITIES": "FORTUITY, an accidental occurrence [n]\n",
  "FORTUITISM": "belief in evolution by chance variation [n -S]\n",
  "FORTUITISMS": "FORTUITISM, belief in evolution by chance variation [n]\n",
  "FORTUITIST": "one who believes in evolution by chance variation [n -S]\n",
  "FORTUITISTS": "FORTUITIST, one who believes in evolution by chance variation [n]\n",
  "FORTUITOUS": "occurring by chance [adj FORTUITOUSLY]\n",
  "FORTUITOUSLY": "FORTUITOUS, occurring by chance [adv]\n",
  "FORTUITOUSNESS": "FORTUITOUS, occurring by chance [n]\n",
  "FORTUITY": "an accidental occurrence [n FORTUITIES]\n",
  "FORTUNATE": "happening by good fortune; lucky [adj FORTUNATELY] / a fortunate person [n -S]\n",
  "FORTUNATELY": "FORTUNATE, happening by good fortune; lucky [adv]\n",
  "FORTUNATENESS": "the state of being fortunate [n -ES]\n",
  "FORTUNATENESSES": "FORTUNATENESS, the state of being fortunate [n]\n",
  "FORTUNATES": "FORTUNATE, a fortunate person [n]\n",
  "FORTUNE": "to endow with wealth [v FORTUNED, FORTUNING, FORTUNES]\n",
  "FORTUNED": "FORTUNE, to endow with wealth [v]\n",
  "FORTUNELESS": "without fortune [adj]\n",
  "FORTUNES": "FORTUNE, to endow with wealth [v]\n",
  "FORTUNING": "FORTUNE, to endow with wealth [v]\n",
  "FORTUNISE": "to make happy or fortunate, also FORTUNIZE [v FORTUNISED, FORTUNISING, FORTUNISES]\n",
  "FORTUNISED": "FORTUNISE, to make happy or fortunate, also FORTUNIZE [v]\n",
  "FORTUNISES": "FORTUNISE, to make happy or fortunate, also FORTUNIZE [v]\n",
  "FORTUNISING": "FORTUNISE, to make happy or fortunate, also FORTUNIZE [v]\n",
  "FORTUNIZE": "(Spenser) to make fortunate or happy, also FORTUNISE [v FORTUNIZED, FORTUNIZING, FORTUNIZES]\n",
  "FORTUNIZED": "FORTUNIZE, (Spenser) to make fortunate or happy, also FORTUNISE [v]\n",
  "FORTUNIZES": "FORTUNIZE, (Spenser) to make fortunate or happy, also FORTUNISE [v]\n",
  "FORTUNIZING": "FORTUNIZE, (Spenser) to make fortunate or happy, also FORTUNISE [v]\n",
  "FORTY": "a number [n FORTIES]\n",
  "FORTYFOLD": "multiplied forty times over [adj]\n",
  "FORTYISH": "being about forty years old [adj]\n",
  "FORUM": "(Latin) a public meeting place [n FORUMS or FORA]\n",
  "FORUMS": "FORUM, (Latin) a public meeting place [n]\n",
  "FORWANDER": "(archaic) to wander away; to go astray [v -ED, -ING, -S]\n",
  "FORWANDERED": "FORWANDER, (archaic) to wander away; to go astray [v]\n",
  "FORWANDERING": "FORWANDER, (archaic) to wander away; to go astray [v]\n",
  "FORWANDERS": "FORWANDER, (archaic) to wander away; to go astray [v]\n",
  "FORWARD": "to help onward [v -ED, -ING, -S] / towards the future [adj FORWARDER, FORWARDEST, FORWARDLY]\n",
  "FORWARDED": "FORWARD, to help onward [v]\n",
  "FORWARDER": "one who forwards [n -S]\n",
  "FORWARDERS": "FORWARDER, one who forwards [n]\n",
  "FORWARDEST": "FORWARD, towards the future [adj]\n",
  "FORWARDING": "the act of sending on e.g. mail [n -S]\n",
  "FORWARDINGS": "FORWARDING, the act of sending on e.g. mail [n]\n",
  "FORWARDLY": "FORWARD, towards the future [adv]\n",
  "FORWARDNESS": "the state of being forward [n -ES]\n",
  "FORWARDNESSES": "FORWARDNESS, the state of being forward [n]\n",
  "FORWARDS": "FORWARD, to help onward [v]\n",
  "FORWARN": "to warn in advance, also FOREWARN [v -ED, -ING, -S]\n",
  "FORWARNED": "FORWARN, to warn in advance, also FOREWARN [v]\n",
  "FORWARNING": "FORWARN, to warn in advance, also FOREWARN [v]\n",
  "FORWARNS": "FORWARN, to warn in advance, also FOREWARN [v]\n",
  "FORWASTE": "(Spenser) to waste completely [v FORWASTED, FORWASTING, FORWASTES]\n",
  "FORWASTED": "FORWASTE, (Spenser) to waste completely [v]\n",
  "FORWASTES": "FORWASTE, (Spenser) to waste completely [v]\n",
  "FORWASTING": "FORWASTE, (Spenser) to waste completely [v]\n",
  "FORWEARIED": "FORWEARY, (Shakespeare) to weary, exhaust [v]\n",
  "FORWEARIES": "FORWEARY, (Shakespeare) to weary, exhaust [v]\n",
  "FORWEARY": "(Shakespeare) to weary, exhaust [v FORWEARIED, FORWEARYING, FORWEARIES]\n",
  "FORWEARYING": "FORWEARY, (Shakespeare) to weary, exhaust [v]\n",
  "FORWENT": "FORGO, to refrain from [v]\n",
  "FORWHY": "(archaic) wherefore; because [adv]\n",
  "FORWORN": "(Spenser) worn out, also FOREWORN [adj]\n",
  "FORZA": "(Italian) force, strength [n FORZE]\n",
  "FORZANDI": "FORZANDO, (Italian) a suddenly emphasised passage of music, also FORZATO, SFORZANDO, SFORZATO [n]\n",
  "FORZANDO": "(Italian) a suddenly emphasised passage of music, also FORZATO, SFORZANDO, SFORZATO [n FORZANDOS or FORZANDI]\n",
  "FORZANDOS": "FORZANDO, (Italian) a suddenly emphasised passage of music, also FORZATO, SFORZANDO, SFORZATO [n]\n",
  "FORZATI": "FORZATO, (Italian) a suddenly emphasised passage of music, also FORZANDO, SFORZANDO, SFORZATO [n]\n",
  "FORZATO": "(Italian) a suddenly emphasised passage of music, also FORZANDO, SFORZANDO, SFORZATO [n FORZATOS or FORZATI]\n",
  "FORZATOS": "FORZATO, (Italian) a suddenly emphasised passage of music, also FORZANDO, SFORZANDO, SFORZATO [n]\n",
  "FORZE": "FORZA, (Italian) force, strength [n]\n",
  "FOSCARNET": "a drug used to treat AIDS [n -S]\n",
  "FOSCARNETS": "FOSCARNET, a drug used to treat AIDS [n]\n",
  "FOSS": "a ditch, also FOSSE [n -ES]\n",
  "FOSSA": "(Latin) an anatomical depression [n -E] / a Madagascan animal resembling a civet, also FOUSSA [n -S]\n",
  "FOSSAE": "FOSSA, (Latin) an anatomical depression [n]\n",
  "FOSSAS": "FOSSA, (Latin) an anatomical depression [n]\n",
  "FOSSATE": "having a fossa, an anatomical depression [adj]\n",
  "FOSSE": "a ditch or moat, also FOSS [n -S]\n",
  "FOSSED": "having a fosse, a ditch or moat [adj]\n",
  "FOSSES": "FOSSE, a ditch or moat, also FOSS [n]\n",
  "FOSSETTE": "(French) a small hollow or depression, as in a bone or shell [n -S]\n",
  "FOSSETTES": "FOSSETTE, (French) a small hollow or depression, as in a bone or shell [n]\n",
  "FOSSICK": "(Australian slang) to search for gold (among tailings); to rummage (for profit) [v -ED, -ING, -S]\n",
  "FOSSICKED": "FOSSICK, (Australian slang) to search for gold (among tailings); to rummage (for profit) [v]\n",
  "FOSSICKER": "(Australian slang) one who fossicks, rummages about, or searches for gold near the surface of a mine [n -S]\n",
  "FOSSICKERS": "FOSSICKER, (Australian slang) one who fossicks, rummages about, or searches for gold near the surface of a mine [n]\n",
  "FOSSICKING": "the practice of searching for gold (among tailings) [n -S]\n",
  "FOSSICKINGS": "FOSSICKING, the practice of searching for gold (among tailings) [n]\n",
  "FOSSICKS": "FOSSICK, (Australian slang) to search for gold (among tailings); to rummage (for profit) [v]\n",
  "FOSSIL": "the preserved remains of a plant or animal [n -S]\n",
  "FOSSILIFEROUS": "bearing fossils [adj]\n",
  "FOSSILISABLE": "that can be fossilised, also FOSSILIZABLE [adj]\n",
  "FOSSILISATION": "the process of fossilising, also FOSSILIZATION [n -S]\n",
  "FOSSILISATIONS": "FOSSILISATION, the process of fossilising, also FOSSILIZATION [n]\n",
  "FOSSILISE": "to turn into a fossil, also FOSSILIZE [v FOSSILISED, FOSSILISING, FOSSILISES]\n",
  "FOSSILISED": "FOSSILISE, to turn into a fossil, also FOSSILIZE [v]\n",
  "FOSSILISES": "FOSSILISE, to turn into a fossil, also FOSSILIZE [v]\n",
  "FOSSILISING": "FOSSILISE, to turn into a fossil, also FOSSILIZE [v]\n",
  "FOSSILIZABLE": "that can be fossilized, also FOSSILISABLE [adj]\n",
  "FOSSILIZATION": "the process of fossilizing, also FOSSILISATION [n -S]\n",
  "FOSSILIZATIONS": "FOSSILIZATION, the process of fossilizing, also FOSSILISATION [n]\n",
  "FOSSILIZE": "to turn into a fossil, also FOSSILISE [v FOSSILIZED, FOSSILIZING, FOSSILIZES]\n",
  "FOSSILIZED": "FOSSILIZE, to turn into a fossil, also FOSSILISE [v]\n",
  "FOSSILIZES": "FOSSILIZE, to turn into a fossil, also FOSSILISE [v]\n",
  "FOSSILIZING": "FOSSILIZE, to turn into a fossil, also FOSSILISE [v]\n",
  "FOSSILS": "FOSSIL, the preserved remains of a plant or animal [n]\n",
  "FOSSOR": "(archaic) a gravedigger [n -S]\n",
  "FOSSORIAL": "adapted for burrowing or digging, e.g. of claws [adj]\n",
  "FOSSORS": "FOSSOR, (archaic) a gravedigger [n]\n",
  "FOSSULA": "(Latin) a small depression [n FOSSULAE]\n",
  "FOSSULAE": "FOSSULA, (Latin) a small depression [n]\n",
  "FOSSULATE": "grooved; pitted [adj]\n",
  "FOSTER": "to promote the growth of [v -ED, -ING, -S]\n",
  "FOSTERAGE": "the care of a foster child [n -S]\n",
  "FOSTERAGES": "FOSTERAGE, the care of a foster child [n]\n",
  "FOSTERED": "FOSTER, to promote the growth of [v]\n",
  "FOSTERER": "one that fosters [n -S]\n",
  "FOSTERERS": "FOSTERER, one that fosters [n]\n",
  "FOSTERING": "the act of nurturing [n -S]\n",
  "FOSTERINGS": "FOSTERING, the act of nurturing [n]\n",
  "FOSTERLING": "a foster child [n -S]\n",
  "FOSTERLINGS": "FOSTERLING, a foster child [n]\n",
  "FOSTERS": "FOSTER, to promote the growth of [v]\n",
  "FOSTRESS": "a woman who feeds and cherishes; a nurse [n -ES]\n",
  "FOSTRESSES": "FOSTRESS, a woman who feeds and cherishes; a nurse [n]\n",
  "FOTHER": "to protect a sail with tarred yarn [v -ED, -ING, -S]\n",
  "FOTHERED": "FOTHER, to protect a sail with tarred yarn [v]\n",
  "FOTHERGILLA": "any plant of the Fothergilla genus of North American deciduous shrubs of the witch-hazel family [n -S]\n",
  "FOTHERGILLAS": "FOTHERGILLA, any plant of the Fothergilla genus of North American deciduous shrubs of the witch-hazel family [n]\n",
  "FOTHERING": "FOTHER, to protect a sail with tarred yarn [v]\n",
  "FOTHERS": "FOTHER, to protect a sail with tarred yarn [v]\n",
  "FOU": "(Scots) drunk [adj FOUER, FOUEST] / a bushel [n -S]\n",
  "FOUAT": "(Scots) a leek, also FOUET [n -S]\n",
  "FOUATS": "FOUAT, (Scots) a leek, also FOUET [n]\n",
  "FOUD": "(Old Norse) a bailiff or magistrate in Orkney or Shetland [n -S]\n",
  "FOUDRIE": "the jurisdiction of a foud or bailiff in the Orkneys [n -S]\n",
  "FOUDRIES": "FOUDRIE, the jurisdiction of a foud or bailiff in the Orkneys [n]\n",
  "FOUDROYANT": "(French) sudden and overwhelming in effect; dazzling [adj]\n",
  "FOUDS": "FOUD, (Old Norse) a bailiff or magistrate in Orkney or Shetland [n]\n",
  "FOUER": "FOU, (Scots) drunk [adj]\n",
  "FOUEST": "FOU, (Scots) drunk [adj]\n",
  "FOUET": "(Scots) the houseleek, also FOUAT [n -S]\n",
  "FOUETS": "FOUET, (Scots) the houseleek, also FOUAT [n]\n",
  "FOUETTE": "(French) a ballet-step in which the foot makes a whiplike movement [n -S]\n",
  "FOUETTES": "FOUETTE, (French) a ballet-step in which the foot makes a whiplike movement [n]\n",
  "FOUGADE": "(French) a small mine, in the form of a well sunk from the surface of the ground, charged with explosive and projectiles, also FOUGASSE [n -S]\n",
  "FOUGADES": "FOUGADE, (French) a small mine, in the form of a well sunk from the surface of the ground, charged with explosive and projectiles, also FOUGASSE [n]\n",
  "FOUGASSE": "(French) a small mine, in the form of a well sunk from the surface of the ground, charged with explosive and projectiles, also FOUGADE [n -S]\n",
  "FOUGASSES": "FOUGASSE, (French) a small mine, in the form of a well sunk from the surface of the ground, charged with explosive and projectiles, also FOUGADE [n]\n",
  "FOUGHT": "FIGHT, to contend in war, battle or single combat [v]\n",
  "FOUGHTEN": "exhausted, especially from fighting [adj]\n",
  "FOUGHTIER": "FOUGHTY, (dialect) musty, mouldy [adj]\n",
  "FOUGHTIEST": "FOUGHTY, (dialect) musty, mouldy [adj]\n",
  "FOUGHTY": "(dialect) musty, mouldy [adj FOUGHTIER, FOUGHTIEST]\n",
  "FOUL": "offensive to the senses [adj FOULER, FOULEST, FOULLY] / to make dirty [v -ED, -ING, -S]\n",
  "FOULARD": "(French) a soft lightweight plain-woven or twilled silk fabric [n -S]\n",
  "FOULARDS": "FOULARD, (French) a soft lightweight plain-woven or twilled silk fabric [n]\n",
  "FOULBROOD": "a bacterial disease of bee larvae [n -S]\n",
  "FOULBROODS": "FOULBROOD, a bacterial disease of bee larvae [n]\n",
  "FOULDER": "(Spenser) to thunder [v -ED, -ING, -S]\n",
  "FOULDERED": "FOULDER, (Spenser) to thunder [v]\n",
  "FOULDERING": "FOULDER, (Spenser) to thunder [v]\n",
  "FOULDERS": "FOULDER, (Spenser) to thunder [v]\n",
  "FOULE": "(French) a fulled cloth, esp. a light woollen smooth-surfaced dress material [n -S]\n",
  "FOULED": "FOUL, to make dirty [v]\n",
  "FOULER": "FOUL, offensive to the senses [adj]\n",
  "FOULES": "FOULE, (French) a fulled cloth, esp. a light woollen smooth-surfaced dress material [n]\n",
  "FOULEST": "FOUL, offensive to the senses [adj]\n",
  "FOULIE": "(Australian slang) a bad mood [n -S]\n",
  "FOULIES": "FOULIE, (Australian slang) a bad mood [n]\n",
  "FOULING": "a deposit or crust [n -S]\n",
  "FOULINGS": "FOULING, a deposit or crust [n]\n",
  "FOULLY": "FOUL, offensive to the senses [adv]\n",
  "FOULMART": "a polecat, also FOUMART [n -S]\n",
  "FOULMARTS": "FOULMART, a polecat, also FOUMART [n]\n",
  "FOULMOUTHED": "given to the use of obscene, profane, or abusive language [adj]\n",
  "FOULNESS": "the state of being foul [n -ES]\n",
  "FOULNESSES": "FOULNESS, the state of being foul [n]\n",
  "FOULS": "FOUL, to make dirty [v]\n",
  "FOUMART": "a polecat, also FOULMART [n -S]\n",
  "FOUMARTS": "FOUMART, a polecat, also FOULMART [n]\n",
  "FOUND": "to establish [v -ED, -ING, -S]\n",
  "FOUNDATION": "the act of founding [n -S]\n",
  "FOUNDATIONAL": "of or like a foundation [adj FOUNDATIONALLY]\n",
  "FOUNDATIONALLY": "FOUNDATIONAL, of or like a foundation [adv]\n",
  "FOUNDATIONARY": "relating to a foundation [adj]\n",
  "FOUNDATIONER": "a person supported from the funds or foundation of an institution [n -S]\n",
  "FOUNDATIONERS": "FOUNDATIONER, a person supported from the funds or foundation of an institution [n]\n",
  "FOUNDATIONLESS": "without foundation [adj]\n",
  "FOUNDATIONS": "FOUNDATION, the act of founding [n]\n",
  "FOUNDED": "FOUND, to establish [v]\n",
  "FOUNDER": "to become disabled [v -ED, -ING, -S]\n",
  "FOUNDERED": "FOUNDER, to become disabled [v]\n",
  "FOUNDERING": "FOUNDER, to become disabled [v]\n",
  "FOUNDEROUS": "causing to founder [adj]\n",
  "FOUNDERS": "FOUNDER, to become disabled [v]\n",
  "FOUNDING": "the time of first establishment [n -S]\n",
  "FOUNDINGS": "FOUNDING, the time of first establishment [n]\n",
  "FOUNDLING": "an abandoned child of unknown parentage [n -S]\n",
  "FOUNDLINGS": "FOUNDLING, an abandoned child of unknown parentage [n]\n",
  "FOUNDRESS": "a female founder [n -ES]\n",
  "FOUNDRESSES": "FOUNDRESS, a female founder [n]\n",
  "FOUNDRIES": "FOUNDRY, a building where metal is cast [n]\n",
  "FOUNDRY": "a building where metal is cast [n FOUNDRIES]\n",
  "FOUNDS": "FOUND, to establish [v]\n",
  "FOUNT": "a fountain, a spring [n -S]\n",
  "FOUNTAIN": "to display water like small waterfalls [v -ED, -ING, -S]\n",
  "FOUNTAINED": "FOUNTAIN, to display water like small waterfalls [v]\n",
  "FOUNTAINHEAD": "a spring that is the source of a stream [n -S]\n",
  "FOUNTAINHEADS": "FOUNTAINHEAD, a spring that is the source of a stream [n]\n",
  "FOUNTAINING": "FOUNTAIN, to display water like small waterfalls [v]\n",
  "FOUNTAINLESS": "without a fountain [adj]\n",
  "FOUNTAINS": "FOUNTAIN, to display water like small waterfalls [v]\n",
  "FOUNTFUL": "full of springs [adj]\n",
  "FOUNTS": "FOUNT, a fountain, a spring [n]\n",
  "FOUR": "the cardinal number next above three [n -S]\n",
  "FOURBALL": "a golf game for four golfers in teams of two [n -S]\n",
  "FOURBALLS": "FOURBALL, a golf game for four golfers in teams of two [n]\n",
  "FOURCHEE": "a kind of heraldic cross having the end of each arm forked [n -S]\n",
  "FOURCHEES": "FOURCHEE, a kind of heraldic cross having the end of each arm forked [n]\n",
  "FOURCHETTE": "(French) a forked reinforcement on the backs of gloves [n -S]\n",
  "FOURCHETTES": "FOURCHETTE, (French) a forked reinforcement on the backs of gloves [n]\n",
  "FOURDRINIER": "a continuous paper roll machine [n -S]\n",
  "FOURDRINIERS": "FOURDRINIER, a continuous paper roll machine [n]\n",
  "FOUREYED": "wearing spectacles [adj]\n",
  "FOURFOLD": "four times as great [adj]\n",
  "FOURFOLDNESS": "the state of being fourfold [n -ES]\n",
  "FOURFOLDNESSES": "FOURFOLDNESS, the state of being fourfold [n]\n",
  "FOURGON": "(French) a baggage-wagon [n -S]\n",
  "FOURGONS": "FOURGON, (French) a baggage-wagon [n]\n",
  "FOURPENCE": "four pre-decimal pennies [n -S]\n",
  "FOURPENCES": "FOURPENCE, four pre-decimal pennies [n]\n",
  "FOURPENNIES": "FOURPENNY, a coin worth four pence [n]\n",
  "FOURPENNY": "a coin worth four pence [n FOURPENNIES]\n",
  "FOURPLAY": "the supply to a customer by one provider of television, internet, and both fixed-line and mobile telephony, also QUADPLAY [n -S]\n",
  "FOURPLAYS": "FOURPLAY, the supply to a customer by one provider of television, internet, and both fixed-line and mobile telephony, also QUADPLAY [n]\n",
  "FOURPLEX": "a building having four units, also QUADPLEX [n -ES]\n",
  "FOURPLEXES": "FOURPLEX, a building having four units, also QUADPLEX [n]\n",
  "FOURRAGERE": "a braided cord worn round the left shoulder, esp. as a military decoration [n -S]\n",
  "FOURRAGERES": "FOURRAGERE, a braided cord worn round the left shoulder, esp. as a military decoration [n]\n",
  "FOURS": "FOUR, the cardinal number next above three [n]\n",
  "FOURSCORE": "(archaic) four twenties, eighty [adj]\n",
  "FOURSCORTH": "(obsolete) eightieth [adj]\n",
  "FOURSES": "(dialect) a snack taken at four o'clock [n]\n",
  "FOURSOME": "a group of four [n -S]\n",
  "FOURSOMES": "FOURSOME, a group of four [n]\n",
  "FOURSQUARE": "forthright, marked by boldness and conviction [adj FOURSQUARELY]\n",
  "FOURSQUARELY": "FOURSQUARE, forthright, marked by boldness and conviction [adv]\n",
  "FOURSQUARENESS": "FOURSQUARE, forthright, marked by boldness and conviction [n]\n",
  "FOURTEEN": "a number, ten and four [n -S]\n",
  "FOURTEENER": "a verse line of fourteen syllables [n -S]\n",
  "FOURTEENERS": "FOURTEENER, a verse line of fourteen syllables [n]\n",
  "FOURTEENS": "FOURTEEN, a number, ten and four [n]\n",
  "FOURTEENTH": "number fourteen in sequence [adj FOURTEENTHLY] / a fourteenth part [n -S]\n",
  "FOURTEENTHLY": "FOURTEENTH, number fourteen in sequence [adv]\n",
  "FOURTEENTHS": "FOURTEENTH, a fourteenth part [n]\n",
  "FOURTH": "number four in sequence [adj FOURTHLY] / one of four equal parts [n -S]\n",
  "FOURTHLY": "in the fourth place [adv]\n",
  "FOURTHS": "FOURTH, one of four equal parts [n]\n",
  "FOUS": "FOU, a bushel [n]\n",
  "FOUSSA": "(Malagasy) a red-brown catlike viverrid mammal, the largest carnivore of Madagascar, also FOSSA [n -S]\n",
  "FOUSSAS": "FOUSSA, (Malagasy) a red-brown catlike viverrid mammal, the largest carnivore of Madagascar, also FOSSA [n]\n",
  "FOUSTIER": "FOUSTY, (Scots) mouldy, damp, also FUSTY [adj]\n",
  "FOUSTIEST": "FOUSTY, (Scots) mouldy, damp, also FUSTY [adj]\n",
  "FOUSTY": "(Scots) mouldy, damp, also FUSTY [adj FOUSTIER, FOUSTIEST]\n",
  "FOUTER": "(Scots) to mess around aimlessly, also FOOTRA, FOUTRA, FOUTRE [v -ED, -ING, -S]\n",
  "FOUTERED": "FOUTER, (Scots) to mess around aimlessly, also FOOTRA, FOUTRA, FOUTRE [v]\n",
  "FOUTERING": "FOUTER, (Scots) to mess around aimlessly, also FOOTRA, FOUTRA, FOUTRE [v]\n",
  "FOUTERS": "FOUTER, (Scots) to mess around aimlessly, also FOOTRA, FOUTRA, FOUTRE [v]\n",
  "FOUTH": "(Scots) abundance, also FOWTH [n -S]\n",
  "FOUTHS": "FOUTH, (Scots) abundance, also FOWTH [n]\n",
  "FOUTRA": "(Shakespeare) a worthless fellow, also FOOTRA, FOUTER, FOUTRE [n -S]\n",
  "FOUTRAS": "FOUTRA, (Shakespeare) a worthless fellow, also FOOTRA, FOUTER, FOUTRE [n]\n",
  "FOUTRE": "(Scots) to mess around aimlessly, also FOOTRA, FOUTER, FOUTRA [v FOUTRED, FOUTRING, FOUTRES]\n",
  "FOUTRED": "FOUTRE, (Scots) to mess around aimlessly, also FOOTRA, FOUTER, FOUTRA [v]\n",
  "FOUTRES": "FOUTRE, (Scots) to mess around aimlessly, also FOOTRA, FOUTER, FOUTRA [v]\n",
  "FOUTRING": "FOUTRE, (Scots) to mess around aimlessly, also FOOTRA, FOUTER, FOUTRA [v]\n",
  "FOVEA": "(Latin) a shallow anatomical depression [n FOVEAS or FOVEAE]\n",
  "FOVEAE": "FOVEA, (Latin) a shallow anatomical depression [n]\n",
  "FOVEAL": "relating to a fovea [adj]\n",
  "FOVEAS": "FOVEA, (Latin) a shallow anatomical depression [n]\n",
  "FOVEATE": "pitted, also FOVEATED [adj]\n",
  "FOVEATED": "having a fovea [adj]\n",
  "FOVEIFORM": "shaped like a small pit [adj]\n",
  "FOVEOLA": "(Latin) a small fovea, also FOVEOLE, FOVEOLET [n FOVEOLAS or FOVEOLAE]\n",
  "FOVEOLAE": "FOVEOLA, (Latin) a small fovea, also FOVEOLE, FOVEOLET [n]\n",
  "FOVEOLAR": "of or like a foveola, a small depression [adj]\n",
  "FOVEOLAS": "FOVEOLA, (Latin) a small fovea, also FOVEOLE, FOVEOLET [n]\n",
  "FOVEOLATE": "like a foveola, a small depression, also FOVEOLATED [adj]\n",
  "FOVEOLATED": "like a foveola, a small depression, also FOVEOLATE [adj]\n",
  "FOVEOLE": "a small fovea, also FOVEOLA, FOVEOLET [n -S]\n",
  "FOVEOLES": "FOVEOLE, a small fovea, also FOVEOLA, FOVEOLET [n]\n",
  "FOVEOLET": "a small fovea, also FOVEOLA, FOVEOLE [n -S]\n",
  "FOVEOLETS": "FOVEOLET, a small fovea, also FOVEOLA, FOVEOLE [n]\n",
  "FOWL": "to hunt birds [v -ED, -ING, -S]\n",
  "FOWLED": "FOWL, to hunt birds [v]\n",
  "FOWLER": "one that fowls [n -S]\n",
  "FOWLERS": "FOWLER, one that fowls [n]\n",
  "FOWLING": "the hunting of birds [n -S]\n",
  "FOWLINGS": "FOWLING, the hunting of birds [n]\n",
  "FOWLPOX": "a virus disease of poultry [n -ES]\n",
  "FOWLPOXES": "FOWLPOX, a virus disease of poultry [n]\n",
  "FOWLS": "FOWL, to hunt birds [v]\n",
  "FOWTH": "(Scots) abundance, also FOUTH [n -S]\n",
  "FOWTHS": "FOWTH, (Scots) abundance, also FOUTH [n]\n",
  "FOX": "to outwit [v -ED, -ING, -ES]\n",
  "FOXBERRIES": "FOXBERRY, the red whortleberry [n]\n",
  "FOXBERRY": "the red whortleberry [n FOXBERRIES]\n",
  "FOXED": "FOX, to outwit [v]\n",
  "FOXES": "FOX, to outwit [v]\n",
  "FOXFIRE": "a glow produced by certain fungi on decaying wood [n -S]\n",
  "FOXFIRES": "FOXFIRE, a glow produced by certain fungi on decaying wood [n]\n",
  "FOXFISH": "a large shark [n -ES]\n",
  "FOXFISHES": "FOXFISH, a large shark [n]\n",
  "FOXGLOVE": "a tall plant with drooping bell-shaped flowers [n -S]\n",
  "FOXGLOVES": "FOXGLOVE, a tall plant with drooping bell-shaped flowers [n]\n",
  "FOXHOLE": "a small battle entrenchment used for cover [n -S]\n",
  "FOXHOLES": "FOXHOLE, a small battle entrenchment used for cover [n]\n",
  "FOXHOUND": "a hunting dog [n -S]\n",
  "FOXHOUNDS": "FOXHOUND, a hunting dog [n]\n",
  "FOXHUNT": "to hunt foxes with hounds [v -ED, -ING, -S]\n",
  "FOXHUNTED": "FOXHUNT, to hunt foxes with hounds [v]\n",
  "FOXHUNTER": "one who hunts foxes [n -S]\n",
  "FOXHUNTERS": "FOXHUNTER, one who hunts foxes [n]\n",
  "FOXHUNTING": "the pastime of hunting foxes [n -S]\n",
  "FOXHUNTINGS": "FOXHUNTING, the pastime of hunting foxes [n]\n",
  "FOXHUNTS": "FOXHUNT, to hunt foxes with hounds [v]\n",
  "FOXIE": "(colloquial) a fox-terrier [n -S]\n",
  "FOXIER": "FOXY, like a fox, crafty [adj]\n",
  "FOXIES": "FOXIE, (colloquial) a fox-terrier [n]\n",
  "FOXIEST": "FOXY, like a fox, crafty [adj]\n",
  "FOXILY": "FOXY, like a fox, crafty [adv]\n",
  "FOXINESS": "the state of being foxy [n -ES]\n",
  "FOXINESSES": "FOXINESS, the state of being foxy [n]\n",
  "FOXING": "the act of a person who foxes [n -S]\n",
  "FOXINGS": "FOXING, the act of a person who foxes [n]\n",
  "FOXLIKE": "resembling a fox in his characteristic qualities; cunning [adj]\n",
  "FOXSHARK": "a large long-tailed shark, aka thresher [n -S]\n",
  "FOXSHARKS": "FOXSHARK, a large long-tailed shark, aka thresher [n]\n",
  "FOXSHIP": "(Shakespeare) craftiness [n -S]\n",
  "FOXSHIPS": "FOXSHIP, (Shakespeare) craftiness [n]\n",
  "FOXSKIN": "the skin of a fox [n -S]\n",
  "FOXSKINS": "FOXSKIN, the skin of a fox [n]\n",
  "FOXTAIL": "the tail of a fox [n -S]\n",
  "FOXTAILS": "FOXTAIL, the tail of a fox [n]\n",
  "FOXTROT": "to dance in a particular way with a partner [v FOXTROTTED, FOXTROTTING, FOXTROTS]\n",
  "FOXTROTS": "FOXTROT, to dance in a particular way with a partner [v]\n",
  "FOXTROTTED": "FOXTROT, to dance in a particular way with a partner [v]\n",
  "FOXTROTTING": "FOXTROT, to dance in a particular way with a partner [v]\n",
  "FOXY": "like a fox, crafty [adj FOXIER, FOXIEST, FOXILY]\n",
  "FOY": "(Spenser) a parting entertainment or gift [n -S]\n",
  "FOYBOAT": "on Tyneside, a small rowing boat [n -S]\n",
  "FOYBOATS": "FOYBOAT, on Tyneside, a small rowing boat [n]\n",
  "FOYER": "(French) a large room in a theatre or concert hall for the use of the audience during intervals [n -S]\n",
  "FOYERS": "FOYER, (French) a large room in a theatre or concert hall for the use of the audience during intervals [n]\n",
  "FOYLE": "(Spenser) to foil [v FOYLED, FOYLING, FOYLES]\n",
  "FOYLED": "FOYLE, (Spenser) to foil [v]\n",
  "FOYLES": "FOYLE, (Spenser) to foil [v]\n",
  "FOYLING": "FOYLE, (Spenser) to foil [v]\n",
  "FOYNE": "(Spenser) to thrust with a spear or sword, also FOIN [v FOYNED, FOYNING, FOYNES]\n",
  "FOYNED": "FOYNE, (Spenser) to thrust with a spear or sword, also FOIN [v]\n",
  "FOYNES": "FOYNE, (Spenser) to thrust with a spear or sword, also FOIN [v]\n",
  "FOYNING": "FOYNE, (Spenser) to thrust with a spear or sword, also FOIN [v]\n",
  "FOYS": "FOY, (Spenser) a parting entertainment or gift [n]\n",
  "FOZIER": "FOZY, (Scots) lacking in freshness [adj]\n",
  "FOZIEST": "FOZY, (Scots) lacking in freshness [adj]\n",
  "FOZINESS": "(Scots) lack of spirit [n -ES]\n",
  "FOZINESSES": "FOZINESS, (Scots) lack of spirit [n]\n",
  "FOZY": "(Scots) lacking in freshness [adj FOZIER, FOZIEST]\n",
  "FRA": "(Italian) brother [n -S]\n",
  "FRAB": "(dialect) to worry [v FRABBED, FRABBING, FRABS]\n",
  "FRABBED": "FRAB, (dialect) to worry [v]\n",
  "FRABBING": "FRAB, (dialect) to worry [v]\n",
  "FRABBIT": "(dialect) peevish [adj]\n",
  "FRABJOUS": "splendid, magnificent [adj FRABJOUSLY]\n",
  "FRABJOUSLY": "FRABJOUS, splendid, magnificent [adv]\n",
  "FRABS": "FRAB, (dialect) to worry [v]\n",
  "FRACAS": "(French) a brawl [n -ES]\n",
  "FRACASES": "FRACAS, (French) a brawl [n]\n",
  "FRACK": "to engage in fracking for shale oil [v -ED, -ING, -S]\n",
  "FRACKED": "FRACK, to engage in fracking for shale oil [v]\n",
  "FRACKER": "one who engages in fracking for shale oil [n -S]\n",
  "FRACKERS": "FRACKER, one who engages in fracking for shale oil [n]\n",
  "FRACKING": "the process of forcing liquid containing sand or other material into the strata round a well bottom to split them and prevent them closing [n -S]\n",
  "FRACKINGS": "FRACKING, the process of forcing liquid containing sand or other material into the strata round a well bottom to split them and prevent them closing [n]\n",
  "FRACKS": "FRACK, to engage in fracking for shale oil [v]\n",
  "FRACT": "to break; to violate [v -ED, -ING, -S]\n",
  "FRACTAL": "a complex geometric curve [n -S]\n",
  "FRACTALITIES": "FRACTALITY, the state of being fractal [n]\n",
  "FRACTALITY": "the state of being fractal [n FRACTALITIES]\n",
  "FRACTALS": "FRACTAL, a complex geometric curve [n]\n",
  "FRACTED": "FRACT, to break; to violate [v]\n",
  "FRACTI": "FRACTUS, (Latin) a ragged cloud [n]\n",
  "FRACTING": "FRACT, to break; to violate [v]\n",
  "FRACTION": "to divide into portions [v -ED, -ING, -S]\n",
  "FRACTIONAL": "of, relating to, or being a fraction [adj FRACTIONALLY]\n",
  "FRACTIONALISE": "to break up into parts, also FRACTIONALIZE [v FRACTIONALISED, FRACTIONALISING, FRACTIONALISES]\n",
  "FRACTIONALISED": "FRACTIONALISE, to break up into parts, also FRACTIONALIZE [v]\n",
  "FRACTIONALISES": "FRACTIONALISE, to break up into parts, also FRACTIONALIZE [v]\n",
  "FRACTIONALISING": "FRACTIONALISE, to break up into parts, also FRACTIONALIZE [v]\n",
  "FRACTIONALISM": "the state of consisting of discrete units [n -S]\n",
  "FRACTIONALISMS": "FRACTIONALISM, the state of consisting of discrete units [n]\n",
  "FRACTIONALIST": "a breaker-up of political unity [n -S]\n",
  "FRACTIONALISTS": "FRACTIONALIST, a breaker-up of political unity [n]\n",
  "FRACTIONALIZE": "to break up into parts, also FRACTIONALISE [v FRACTIONALIZED, FRACTIONALIZING, FRACTIONALIZES]\n",
  "FRACTIONALIZED": "FRACTIONALIZE, to break up into parts, also FRACTIONALISE [v]\n",
  "FRACTIONALIZES": "FRACTIONALIZE, to break up into parts, also FRACTIONALISE [v]\n",
  "FRACTIONALIZING": "FRACTIONALIZE, to break up into parts, also FRACTIONALISE [v]\n",
  "FRACTIONALLY": "FRACTIONAL, of, relating to, or being a fraction [adv]\n",
  "FRACTIONARY": "fractional, fragmentary [adj]\n",
  "FRACTIONATE": "to separate a mixture into different portions esp. by a fractional process [v FRACTIONATED, FRACTIONATING, FRACTIONATES]\n",
  "FRACTIONATED": "FRACTIONATE, to separate a mixture into different portions esp. by a fractional process [v]\n",
  "FRACTIONATES": "FRACTIONATE, to separate a mixture into different portions esp. by a fractional process [v]\n",
  "FRACTIONATING": "FRACTIONATE, to separate a mixture into different portions esp. by a fractional process [v]\n",
  "FRACTIONATION": "the act of fractionating [n -S]\n",
  "FRACTIONATIONS": "FRACTIONATION, the act of fractionating [n]\n",
  "FRACTIONATOR": "a plant for carrying out fractional distillation [n -S]\n",
  "FRACTIONATORS": "FRACTIONATOR, a plant for carrying out fractional distillation [n]\n",
  "FRACTIONED": "FRACTION, to divide into portions [v]\n",
  "FRACTIONING": "FRACTION, to divide into portions [v]\n",
  "FRACTIONISATION": "the process of fractionising, also FRACTIONIZATION [n]\n",
  "FRACTIONISE": "to break up into fractions, also FRACTIONIZE [v FRACTIONISED, FRACTIONISING, FRACTIONISES]\n",
  "FRACTIONISED": "FRACTIONISE, to break up into fractions, also FRACTIONIZE [v]\n",
  "FRACTIONISES": "FRACTIONISE, to break up into fractions, also FRACTIONIZE [v]\n",
  "FRACTIONISING": "FRACTIONISE, to break up into fractions, also FRACTIONIZE [v]\n",
  "FRACTIONIZATION": "the process of fractionizing, also FRACTIONISATION [n]\n",
  "FRACTIONIZE": "to break up into fractions, also FRACTIONISE [v FRACTIONIZED, FRACTIONIZING, FRACTIONIZES]\n",
  "FRACTIONIZED": "FRACTIONIZE, to break up into fractions, also FRACTIONISE [v]\n",
  "FRACTIONIZES": "FRACTIONIZE, to break up into fractions, also FRACTIONISE [v]\n",
  "FRACTIONIZING": "FRACTIONIZE, to break up into fractions, also FRACTIONISE [v]\n",
  "FRACTIONLET": "a small fraction [n -S]\n",
  "FRACTIONLETS": "FRACTIONLET, a small fraction [n]\n",
  "FRACTIONS": "FRACTION, to divide into portions [v]\n",
  "FRACTIOUS": "troublesome, irritable [adj FRACTIOUSLY]\n",
  "FRACTIOUSLY": "FRACTIOUS, troublesome, irritable [adv]\n",
  "FRACTIOUSNESS": "FRACTIOUS, troublesome, irritable [n]\n",
  "FRACTIOUSNESSES": "FRACTIOUSNESS, FRACTIOUS, troublesome, irritable [n]\n",
  "FRACTOCUMULI": "FRACTOCUMULUS, a type of cloud [n]\n",
  "FRACTOCUMULUS": "a type of cloud [n FRACTOCUMULI]\n",
  "FRACTOGRAPHIES": "FRACTOGRAPHY, the microscopic study of fractures in metal surfaces [n]\n",
  "FRACTOGRAPHY": "the microscopic study of fractures in metal surfaces [n FRACTOGRAPHIES]\n",
  "FRACTOSTRATI": "FRACTOSTRATUS, a type of cloud [n]\n",
  "FRACTOSTRATUS": "a type of cloud [n FRACTOSTRATI]\n",
  "FRACTS": "FRACT, to break; to violate [v]\n",
  "FRACTUR": "(German) a German style of black letter, the normal type used for printing German from the 16th to the mid 20th century, also FRAKTUR [n -S]\n",
  "FRACTURABLE": "that can be fractured [adj]\n",
  "FRACTURAL": "relating to a fracture [adj]\n",
  "FRACTURE": "to break [v FRACTURED, FRACTURING, FRACTURES]\n",
  "FRACTURED": "FRACTURE, to break [v]\n",
  "FRACTURER": "one who fractures [n -S]\n",
  "FRACTURERS": "FRACTURER, one who fractures [n]\n",
  "FRACTURES": "FRACTURE, to break [v]\n",
  "FRACTURING": "FRACTURE, to break [v]\n",
  "FRACTURS": "FRACTUR, (German) a German style of black letter, the normal type used for printing German from the 16th to the mid 20th century, also FRAKTUR [n]\n",
  "FRACTUS": "(Latin) a ragged cloud [n FRACTI]\n",
  "FRAE": "(Scots) from, also THRAE [prep]\n",
  "FRAENA": "FRAENUM, (Latin) a connecting fold of membrane, also FRENUM [n]\n",
  "FRAENUM": "(Latin) a connecting fold of membrane, also FRENUM [n FRAENUMS or FRAENA]\n",
  "FRAENUMS": "FRAENUM, (Latin) a connecting fold of membrane, also FRENUM [n]\n",
  "FRAG": "to kill with a fragmentation grenade [v FRAGGED, FRAGGING, FRAGS]\n",
  "FRAGGED": "FRAG, to kill with a fragmentation grenade [v]\n",
  "FRAGGING": "the act of blowing up an unpopular officer with a grenade [n -S]\n",
  "FRAGGINGS": "FRAGGING, the act of blowing up an unpopular officer with a grenade [n]\n",
  "FRAGILE": "easily broken [adj FRAGILER, FRAGILEST, FRAGILELY]\n",
  "FRAGILELY": "FRAGILE, easily broken [adv]\n",
  "FRAGILENESS": "the state of being fragile [n -ES]\n",
  "FRAGILENESSES": "FRAGILENESS, the state of being fragile [n]\n",
  "FRAGILER": "FRAGILE, easily broken [adj]\n",
  "FRAGILEST": "FRAGILE, easily broken [adj]\n",
  "FRAGILITIES": "FRAGILITY, the state of being fragile [n]\n",
  "FRAGILITY": "the state of being fragile [n FRAGILITIES]\n",
  "FRAGMENT": "to break into pieces [v -ED, -ING, -S]\n",
  "FRAGMENTAL": "composed of fragments of older rocks [adj FRAGMENTALLY]\n",
  "FRAGMENTALLY": "FRAGMENTAL, composed of fragments of older rocks [adv]\n",
  "FRAGMENTARILY": "FRAGMENTARY, consisting of fragments [adv]\n",
  "FRAGMENTARINESS": "the state of being fragmentary [n]\n",
  "FRAGMENTARY": "consisting of fragments [adj FRAGMENTARILY]\n",
  "FRAGMENTATE": "to reduce to fragments [v FRAGMENTATED, FRAGMENTATING, FRAGMENTATES]\n",
  "FRAGMENTATED": "FRAGMENTATE, to reduce to fragments [v]\n",
  "FRAGMENTATES": "FRAGMENTATE, to reduce to fragments [v]\n",
  "FRAGMENTATING": "FRAGMENTATE, to reduce to fragments [v]\n",
  "FRAGMENTATION": "the act of fragmenting [n -S]\n",
  "FRAGMENTATIONS": "FRAGMENTATION, the act of fragmenting [n]\n",
  "FRAGMENTED": "FRAGMENT, to break into pieces [v]\n",
  "FRAGMENTING": "FRAGMENT, to break into pieces [v]\n",
  "FRAGMENTISE": "to reduce to fragments, also FRAGMENTIZE [v FRAGMENTISED, FRAGMENTISING, FRAGMENTISES]\n",
  "FRAGMENTISED": "FRAGMENTISE, to reduce to fragments, also FRAGMENTIZE [v]\n",
  "FRAGMENTISES": "FRAGMENTISE, to reduce to fragments, also FRAGMENTIZE [v]\n",
  "FRAGMENTISING": "FRAGMENTISE, to reduce to fragments, also FRAGMENTIZE [v]\n",
  "FRAGMENTIZE": "to reduce to fragments, also FRAGMENTISE [v FRAGMENTIZED, FRAGMENTIZING, FRAGMENTIZES]\n",
  "FRAGMENTIZED": "FRAGMENTIZE, to reduce to fragments, also FRAGMENTISE [v]\n",
  "FRAGMENTIZES": "FRAGMENTIZE, to reduce to fragments, also FRAGMENTISE [v]\n",
  "FRAGMENTIZING": "FRAGMENTIZE, to reduce to fragments, also FRAGMENTISE [v]\n",
  "FRAGMENTS": "FRAGMENT, to break into pieces [v]\n",
  "FRAGOR": "a crash [n -S]\n",
  "FRAGORS": "FRAGOR, a crash [n]\n",
  "FRAGRANCE": "pleasantness of smell, also FRAGRANCY [n -S] / to perfume with a fragrance [v FRAGRANCED, FRAGRANCING, FRAGRANCES]\n",
  "FRAGRANCED": "FRAGRANCE, to perfume with a fragrance [v]\n",
  "FRAGRANCES": "FRAGRANCE, to perfume with a fragrance [v]\n",
  "FRAGRANCIES": "FRAGRANCY, pleasantness of smell, also FRAGRANCE [n]\n",
  "FRAGRANCING": "FRAGRANCE, to perfume with a fragrance [v]\n",
  "FRAGRANCY": "pleasantness of smell, also FRAGRANCE [n FRAGRANCIES]\n",
  "FRAGRANT": "having a pleasant perfume [adj FRAGRANTLY]\n",
  "FRAGRANTLY": "FRAGRANT, having a pleasant perfume [adv]\n",
  "FRAGRANTNESS": "the state of being fragrant [n -ES]\n",
  "FRAGRANTNESSES": "FRAGRANTNESS, the state of being fragrant [n]\n",
  "FRAGS": "FRAG, to kill with a fragmentation grenade [v]\n",
  "FRAICHEUR": "(French) freshness [n -S]\n",
  "FRAICHEURS": "FRAICHEUR, (French) freshness [n]\n",
  "FRAIL": "a basket for holding dried fruit [n -S] / weak, infirm [adj FRAILER, FRAILEST, FRAILLY]\n",
  "FRAILER": "FRAIL, weak, infirm [adj]\n",
  "FRAILEST": "FRAIL, weak, infirm [adj]\n",
  "FRAILISH": "somewhat frail [adj]\n",
  "FRAILLY": "FRAIL, weak, infirm [adv]\n",
  "FRAILNESS": "the state of being frail [n -ES]\n",
  "FRAILNESSES": "FRAILNESS, the state of being frail [n]\n",
  "FRAILS": "FRAIL, a basket for holding dried fruit [n]\n",
  "FRAILTEE": "(Spenser) frailty [n -S]\n",
  "FRAILTEES": "FRAILTEE, (Spenser) frailty [n]\n",
  "FRAILTIES": "FRAILTY, a weakness of character [n]\n",
  "FRAILTY": "a weakness of character [n FRAILTIES]\n",
  "FRAIM": "(Scots) a stranger, also FREMD, FREMIT [n -S]\n",
  "FRAIMS": "FRAIM, (Scots) a stranger, also FREMD, FREMIT [n]\n",
  "FRAISE": "(French) to fortify with a horizontal palisade [v FRAISED, FRAISING, FRAISES]\n",
  "FRAISED": "FRAISE, (French) to fortify with a horizontal palisade [v]\n",
  "FRAISES": "FRAISE, (French) to fortify with a horizontal palisade [v]\n",
  "FRAISING": "FRAISE, (French) to fortify with a horizontal palisade [v]\n",
  "FRAKTUR": "(German) a German style of black letter, the normal type used for printing German from the 16th to the mid 20th cent, also FRACTUR [n -S]\n",
  "FRAKTURS": "FRAKTUR, (German) a German style of black letter, the normal type used for printing German from the 16th to the mid 20th cent, also FRACTUR [n]\n",
  "FRAMABLE": "that can be framed, also FRAMEABLE [adj]\n",
  "FRAMBESIA": "a tropical skin disease, aka yaws, also FRAMBOESIA [n -S]\n",
  "FRAMBESIAS": "FRAMBESIA, a tropical skin disease, aka yaws, also FRAMBOESIA [n]\n",
  "FRAMBOESIA": "a tropical skin disease, aka yaws, also FRAMBESIA [n -S]\n",
  "FRAMBOESIAS": "FRAMBOESIA, a tropical skin disease, aka yaws, also FRAMBESIA [n]\n",
  "FRAMBOISE": "(French) a brandy distilled from raspberries in the Alsace-Lorraine region [n -S]\n",
  "FRAMBOISES": "FRAMBOISE, (French) a brandy distilled from raspberries in the Alsace-Lorraine region [n]\n",
  "FRAME": "to enclose in a border [v FRAMED, FRAMING, FRAMES]\n",
  "FRAMEABLE": "that can be framed, also FRAMABLE [adj]\n",
  "FRAMED": "FRAME, to enclose in a border [v]\n",
  "FRAMELESS": "without a frame [adj]\n",
  "FRAMER": "one who frames [n -S]\n",
  "FRAMERS": "FRAMER, one who frames [n]\n",
  "FRAMES": "FRAME, to enclose in a border [v]\n",
  "FRAMESHIFT": "a term in genetic manipulation, a type of mutation [n -S]\n",
  "FRAMESHIFTS": "FRAMESHIFT, a term in genetic manipulation, a type of mutation [n]\n",
  "FRAMEWORK": "the skeleton or outline of anything [n -S]\n",
  "FRAMEWORKS": "FRAMEWORK, the skeleton or outline of anything [n]\n",
  "FRAMING": "framework [n -S]\n",
  "FRAMINGS": "FRAMING, framework [n]\n",
  "FRAMPAL": "(Scott) peevish, intractable, also FRAMPOLD [adj]\n",
  "FRAMPLER": "(Scott) a brawler [n -S]\n",
  "FRAMPLERS": "FRAMPLER, (Scott) a brawler [n]\n",
  "FRAMPOLD": "(obsolete) peevish, intractable, also FRAMPAL [adj]\n",
  "FRANC": "(French) a monetary unit of France [n -S]\n",
  "FRANCHISE": "liberty; the right to vote [n -S] / to grant a franchise to [v FRANCHISED, FRANCHISING, FRANCHISES]\n",
  "FRANCHISED": "FRANCHISE, to grant a franchise to [v]\n",
  "FRANCHISEE": "one who receives a franchise [n -S]\n",
  "FRANCHISEES": "FRANCHISEE, one who receives a franchise [n]\n",
  "FRANCHISEMENT": "liberation [n -S]\n",
  "FRANCHISEMENTS": "FRANCHISEMENT, liberation [n]\n",
  "FRANCHISER": "one who grants a franchise, also FRANCHISOR [n -S]\n",
  "FRANCHISERS": "FRANCHISER, one who grants a franchise, also FRANCHISOR [n]\n",
  "FRANCHISES": "FRANCHISE, to grant a franchise to [v]\n",
  "FRANCHISING": "FRANCHISE, to grant a franchise to [v]\n",
  "FRANCHISOR": "one who grants a franchise, also FRANCHISER [n -S]\n",
  "FRANCHISORS": "FRANCHISOR, one who grants a franchise, also FRANCHISER [n]\n",
  "FRANCISATION": "the act of making French, also FRANCIZATION [n -S]\n",
  "FRANCISATIONS": "FRANCISATION, the act of making French, also FRANCIZATION [n]\n",
  "FRANCISE": "(Canadian) to make or become French-speaking, also FRANCIZE [v FRANCISED, FRANCISING, FRANCISES]\n",
  "FRANCISED": "FRANCISE, (Canadian) to make or become French-speaking, also FRANCIZE [v]\n",
  "FRANCISES": "FRANCISE, (Canadian) to make or become French-speaking, also FRANCIZE [v]\n",
  "FRANCISING": "FRANCISE, (Canadian) to make or become French-speaking, also FRANCIZE [v]\n",
  "FRANCIUM": "a radioactive element [n -S]\n",
  "FRANCIUMS": "FRANCIUM, a radioactive element [n]\n",
  "FRANCIZATION": "the act of making French, also FRANCISATION [n -S]\n",
  "FRANCIZATIONS": "FRANCIZATION, the act of making French, also FRANCISATION [n]\n",
  "FRANCIZE": "(Canadian) to make or become French-speaking, also FRANCISE [v FRANCIZED, FRANCIZING, FRANCIZES]\n",
  "FRANCIZED": "FRANCIZE, (Canadian) to make or become French-speaking, also FRANCISE [v]\n",
  "FRANCIZES": "FRANCIZE, (Canadian) to make or become French-speaking, also FRANCISE [v]\n",
  "FRANCIZING": "FRANCIZE, (Canadian) to make or become French-speaking, also FRANCISE [v]\n",
  "FRANCO": "(Italian) post-free [adj]\n",
  "FRANCOLIN": "(French) a bird of the Francolinus genus of partridges [n -S]\n",
  "FRANCOLINS": "FRANCOLIN, (French) a bird of the Francolinus genus of partridges [n]\n",
  "FRANCOMANIA": "an obsession with France and the French [n -S]\n",
  "FRANCOMANIAS": "FRANCOMANIA, an obsession with France and the French [n]\n",
  "FRANCOPHIL": "a lover of France and French things, also FRANCOPHILE [n -S]\n",
  "FRANCOPHILE": "a lover of France and French things, also FRANCOPHIL [n -S]\n",
  "FRANCOPHILES": "FRANCOPHILE, a lover of France and French things, also FRANCOPHIL [n]\n",
  "FRANCOPHILS": "FRANCOPHIL, a lover of France and French things, also FRANCOPHILE [n]\n",
  "FRANCOPHOBE": "a hater of things French [n -S]\n",
  "FRANCOPHOBES": "FRANCOPHOBE, a hater of things French [n]\n",
  "FRANCOPHOBIA": "fear of France or the French [n -S]\n",
  "FRANCOPHOBIAS": "FRANCOPHOBIA, fear of France or the French [n]\n",
  "FRANCOPHONE": "a French speaker [n -S]\n",
  "FRANCOPHONES": "FRANCOPHONE, a French speaker [n]\n",
  "FRANCS": "FRANC, (French) a monetary unit of France [n]\n",
  "FRANGER": "(Australian slang) a condom [n -S]\n",
  "FRANGERS": "FRANGER, (Australian slang) a condom [n]\n",
  "FRANGIBILITIES": "FRANGIBILITY, the state of being frangible [n]\n",
  "FRANGIBILITY": "the state of being frangible [n FRANGIBILITIES]\n",
  "FRANGIBLE": "readily broken; breakable [adj]\n",
  "FRANGIBLENESS": "FRANGIBLE, readily broken; breakable [n]\n",
  "FRANGIBLENESSES": "FRANGIBLENESS, FRANGIBLE, readily broken; breakable [n]\n",
  "FRANGIPANE": "a perfume of jasmine, also FRANGIPANI, FRANGIPANNI [n -S]\n",
  "FRANGIPANES": "FRANGIPANE, a perfume of jasmine, also FRANGIPANI, FRANGIPANNI [n]\n",
  "FRANGIPANI": "a showy, fragrant shrub; a perfume; an almond-filled pastry, also FRANGIPANE, FRANGIPANNI [n -S]\n",
  "FRANGIPANIS": "FRANGIPANI, a showy, fragrant shrub; a perfume; an almond-filled pastry, also FRANGIPANE, FRANGIPANNI [n]\n",
  "FRANGIPANNI": "a showy, fragrant shrub; a perfume; an almond-filled pastry, also FRANGIPANE, FRANGIPANI [n]\n",
  "FRANGLAIS": "(French) a mixture of French and English [n]\n",
  "FRANION": "(obsolete) a loose woman [n -S]\n",
  "FRANIONS": "FRANION, (obsolete) a loose woman [n]\n",
  "FRANK": "to mark mail for postage [v -ED, -ING, -S] / free and open [adj FRANKER, FRANKEST, FRANKLY]\n",
  "FRANKABLE": "that can be franked [adj]\n",
  "FRANKALMOIGN": "land tenure requiring religious obligations on part of tenant [n -S]\n",
  "FRANKALMOIGNS": "FRANKALMOIGN, land tenure requiring religious obligations on part of tenant [n]\n",
  "FRANKED": "FRANK, to mark mail for postage [v]\n",
  "FRANKER": "one that franks [n -S]\n",
  "FRANKERS": "FRANKER, one that franks [n]\n",
  "FRANKEST": "FRANK, free and open [adj]\n",
  "FRANKFORT": "(German) a small smoked sausage, also FRANKFURT, FRANKFURTER [n -S]\n",
  "FRANKFORTS": "FRANKFORT, (German) a small smoked sausage, also FRANKFURT, FRANKFURTER [n]\n",
  "FRANKFURT": "(German) a small smoked sausage, also FRANKFORT, FRANKFURTER [n -S]\n",
  "FRANKFURTER": "(German) a small smoked sausage, also FRANKFORT, FRANKFURT [n -S]\n",
  "FRANKFURTERS": "FRANKFURTER, (German) a small smoked sausage, also FRANKFORT, FRANKFURT [n]\n",
  "FRANKFURTS": "FRANKFURT, (German) a small smoked sausage, also FRANKFORT, FRANKFURTER [n]\n",
  "FRANKINCENSE": "a sweet-smelling resin from Arabia, used as incense, aka olibanum [n -S]\n",
  "FRANKINCENSES": "FRANKINCENSE, a sweet-smelling resin from Arabia, used as incense, aka olibanum [n]\n",
  "FRANKING": "FRANK, to mark mail for postage [v]\n",
  "FRANKLIN": "a medieval English landowner [n -S]\n",
  "FRANKLINITE": "a zinc-manganese mineral, mined at Franklin Forge, New Jersey, USA [n -S]\n",
  "FRANKLINITES": "FRANKLINITE, a zinc-manganese mineral, mined at Franklin Forge, New Jersey, USA [n]\n",
  "FRANKLINS": "FRANKLIN, a medieval English landowner [n]\n",
  "FRANKLY": "FRANK, free and open [adv]\n",
  "FRANKNESS": "the quality of being frank [n -ES]\n",
  "FRANKNESSES": "FRANKNESS, the quality of being frank [n]\n",
  "FRANKPLEDGE": "a system of sureties under Old English law by which each adult member of a tithing was held responsible for the good conduct of the others [n -S]\n",
  "FRANKPLEDGES": "FRANKPLEDGE, a system of sureties under Old English law by which each adult member of a tithing was held responsible for the good conduct of the others [n]\n",
  "FRANKS": "FRANK, to mark mail for postage [v]\n",
  "FRANKUM": "the hardened resin of a spruce tree [n -S]\n",
  "FRANKUMS": "FRANKUM, the hardened resin of a spruce tree [n]\n",
  "FRANSERIA": "any of a genus of West American plants of the composite family [n -S]\n",
  "FRANSERIAS": "FRANSERIA, any of a genus of West American plants of the composite family [n]\n",
  "FRANTIC": "wild with anxiety [adj FRANTICLY or FRANTICALLY]\n",
  "FRANTICALLY": "FRANTIC, wild with anxiety [adv]\n",
  "FRANTICLY": "(Shakespeare) frantically, also FRANTICALLY [adv]\n",
  "FRANTICNESS": "the state of being frantic [n -ES]\n",
  "FRANTICNESSES": "FRANTICNESS, the state of being frantic [n]\n",
  "FRANZIER": "FRANZY, (dialect) cross and peevish [adj]\n",
  "FRANZIEST": "FRANZY, (dialect) cross and peevish [adj]\n",
  "FRANZY": "(dialect) cross and peevish [adj FRANZIER, FRANZIEST]\n",
  "FRAP": "to draw tight (as with ropes or cables) [v FRAPPED, FRAPPING, FRAPS]\n",
  "FRAPE": "to alter the personal details on a social website without the owner's consent [v FRAPED, FRAPING, FRAPES]\n",
  "FRAPEAGE": "the practice of altering information in a person's profile on a social networking website without his or her permission [n -S]\n",
  "FRAPEAGES": "FRAPEAGE, the practice of altering information in a person's profile on a social networking website without his or her permission [n]\n",
  "FRAPED": "FRAPE, to alter the personal details on a social website without the owner's consent [v]\n",
  "FRAPES": "FRAPE, to alter the personal details on a social website without the owner's consent [v]\n",
  "FRAPING": "FRAPE, to alter the personal details on a social website without the owner's consent [v]\n",
  "FRAPPANT": "(French) striking [adj]\n",
  "FRAPPE": "(French) an iced drink, also FRAPPEE [n -S]\n",
  "FRAPPED": "FRAP, to draw tight (as with ropes or cables) [v]\n",
  "FRAPPEE": "(French) of drinks like coffee, iced [adj]\n",
  "FRAPPES": "FRAPPE, (French) an iced drink, also FRAPPEE [n]\n",
  "FRAPPING": "FRAP, to draw tight (as with ropes or cables) [v]\n",
  "FRAPS": "FRAP, to draw tight (as with ropes or cables) [v]\n",
  "FRAS": "FRA, (Italian) brother [n]\n",
  "FRASCATI": "(Italian) a type of white wine [n -S]\n",
  "FRASCATIS": "FRASCATI, (Italian) a type of white wine [n]\n",
  "FRASS": "debris or excrement produced by insects [n -ES]\n",
  "FRASSES": "FRASS, debris or excrement produced by insects [n]\n",
  "FRAT": "(short for) a college fraternity [n -S]\n",
  "FRATCH": "a brawl [n -ES]\n",
  "FRATCHES": "FRATCH, a brawl [n]\n",
  "FRATCHETIER": "FRATCHETY, quarrelsome, also FRATCHING, FRATCHY [adj]\n",
  "FRATCHETIEST": "FRATCHETY, quarrelsome, also FRATCHING, FRATCHY [adj]\n",
  "FRATCHETY": "quarrelsome, also FRATCHING, FRATCHY [adj FRATCHETIER, FRATCHETIEST]\n",
  "FRATCHIER": "FRATCHY, quarrelsome [adj]\n",
  "FRATCHIEST": "FRATCHY, quarrelsome [adj]\n",
  "FRATCHING": "quarrelsome, also FRATCHETY, FRATCHY [adj]\n",
  "FRATCHY": "quarrelsome [adj FRATCHIER, FRATCHIEST]\n",
  "FRATE": "(Italian) a Franciscan friar [n FRATI]\n",
  "FRATER": "(Latin) a monk, a house for monks [n -S]\n",
  "FRATERIES": "FRATERY, a convent of friars, also FRATRY [n]\n",
  "FRATERNAL": "belonging to a brother or brethren [adj FRATERNALLY]\n",
  "FRATERNALISM": "being fraternal [n -S]\n",
  "FRATERNALISMS": "FRATERNALISM, being fraternal [n]\n",
  "FRATERNALLY": "FRATERNAL, belonging to a brother or brethren [adv]\n",
  "FRATERNISATION": "the act of fraternising, also FRATERNIZATION [n -S]\n",
  "FRATERNISATIONS": "FRATERNISATION, the act of fraternising, also FRATERNIZATION [n]\n",
  "FRATERNISE": "to associate with, also FRATERNIZE [v FRATERNISED, FRATERNISING, FRATERNISES]\n",
  "FRATERNISED": "FRATERNISE, to associate with, also FRATERNIZE [v]\n",
  "FRATERNISER": "one who fraternises, also FRATERNIZER [n -S]\n",
  "FRATERNISERS": "FRATERNISER, one who fraternises, also FRATERNIZER [n]\n",
  "FRATERNISES": "FRATERNISE, to associate with, also FRATERNIZE [v]\n",
  "FRATERNISING": "FRATERNISE, to associate with, also FRATERNIZE [v]\n",
  "FRATERNITIES": "FRATERNITY, brotherhood [n]\n",
  "FRATERNITY": "brotherhood [n FRATERNITIES]\n",
  "FRATERNIZATION": "the act of fraternizing, also FRATERNISATION [n -S]\n",
  "FRATERNIZATIONS": "FRATERNIZATION, the act of fraternizing, also FRATERNISATION [n]\n",
  "FRATERNIZE": "to associate or mingle as brothers or on fraternal terms, also FRATERNISE [v FRATERNIZED, FRATERNIZING, FRATERNIZES]\n",
  "FRATERNIZED": "FRATERNIZE, to associate or mingle as brothers or on fraternal terms, also FRATERNISE [v]\n",
  "FRATERNIZER": "one who fraternizes, also FRATERNISER [n -S]\n",
  "FRATERNIZERS": "FRATERNIZER, one who fraternizes, also FRATERNISER [n]\n",
  "FRATERNIZES": "FRATERNIZE, to associate or mingle as brothers or on fraternal terms, also FRATERNISE [v]\n",
  "FRATERNIZING": "FRATERNIZE, to associate or mingle as brothers or on fraternal terms, also FRATERNISE [v]\n",
  "FRATERS": "FRATER, (Latin) a monk, a house for monks [n]\n",
  "FRATERY": "a convent of friars, also FRATRY [n FRATERIES]\n",
  "FRATI": "FRATE, (Italian) a Franciscan friar [n]\n",
  "FRATRICIDAL": "relating to fratricide [adj]\n",
  "FRATRICIDE": "the killing of a brother [n -S]\n",
  "FRATRICIDES": "FRATRICIDE, the killing of a brother [n]\n",
  "FRATRIES": "FRATRY, a convent of friars, also FRATERY [n]\n",
  "FRATRY": "a convent of friars, also FRATERY [n FRATRIES]\n",
  "FRATS": "FRAT, (short for) a college fraternity [n]\n",
  "FRAU": "(German) a woman, housewife [n -S]\n",
  "FRAUD": "criminal deception [n -S]\n",
  "FRAUDFUL": "deceptive [adj FRAUDFULLY]\n",
  "FRAUDFULLY": "FRAUDFUL, deceptive [adv]\n",
  "FRAUDS": "FRAUD, criminal deception [n]\n",
  "FRAUDSMAN": "a person involved in criminal fraud [n FRAUDSMEN]\n",
  "FRAUDSMEN": "FRAUDSMAN, a person involved in criminal fraud [n]\n",
  "FRAUDSTER": "one who practises fraud [n -S]\n",
  "FRAUDSTERS": "FRAUDSTER, one who practises fraud [n]\n",
  "FRAUDULENCE": "the state of being fraudulent, also FRAUDULENCY [n -S]\n",
  "FRAUDULENCES": "FRAUDULENCE, the state of being fraudulent, also FRAUDULENCY [n]\n",
  "FRAUDULENCIES": "FRAUDULENCY, the state of being fraudulent, also FRAUDULENCE [n]\n",
  "FRAUDULENCY": "the state of being fraudulent, also FRAUDULENCE [n FRAUDULENCIES]\n",
  "FRAUDULENT": "characterized by fraud [adj FRAUDULENTLY]\n",
  "FRAUDULENTLY": "FRAUDULENT, characterized by fraud [adv]\n",
  "FRAUDULENTNESS": "FRAUDULENT, characterized by fraud [n]\n",
  "FRAUGHAN": "(Irish) the whortleberry [n -S]\n",
  "FRAUGHANS": "FRAUGHAN, (Irish) the whortleberry [n]\n",
  "FRAUGHT": "to load with tension [v -ED, -ING, -S] / laden with tension [adj FRAUGHTER, FRAUGHTEST]\n",
  "FRAUGHTAGE": "(Shakespeare) loading, cargo, also FRAUTAGE [n -S]\n",
  "FRAUGHTAGES": "FRAUGHTAGE, (Shakespeare) loading, cargo, also FRAUTAGE [n]\n",
  "FRAUGHTED": "FRAUGHT, to load with tension [v]\n",
  "FRAUGHTER": "FRAUGHT, laden with tension [adj]\n",
  "FRAUGHTEST": "FRAUGHT, laden with tension [adj]\n",
  "FRAUGHTING": "FRAUGHT, to load with tension [v]\n",
  "FRAUGHTS": "FRAUGHT, to load with tension [v]\n",
  "FRAULEIN": "(German) a German governess [n -S]\n",
  "FRAULEINS": "FRAULEIN, (German) a German governess [n]\n",
  "FRAUS": "FRAU, (German) a woman, housewife [n]\n",
  "FRAUTAGE": "(Shakespeare) loading, cargo, also FRAUGHTAGE [n -S]\n",
  "FRAUTAGES": "FRAUTAGE, (Shakespeare) loading, cargo, also FRAUGHTAGE [n]\n",
  "FRAWZEY": "(dialect) a treat [n -S]\n",
  "FRAWZEYS": "FRAWZEY, (dialect) a treat [n]\n",
  "FRAXINELLA": "a perennial herb of the rue family [n -S]\n",
  "FRAXINELLAS": "FRAXINELLA, a perennial herb of the rue family [n]\n",
  "FRAY": "to wear by rubbing [v -ED, -ING, -S]\n",
  "FRAYED": "FRAY, to wear by rubbing [v]\n",
  "FRAYING": "something worn off by rubbing [n -S]\n",
  "FRAYINGS": "FRAYING, something worn off by rubbing [n]\n",
  "FRAYS": "FRAY, to wear by rubbing [v]\n",
  "FRAZIL": "ice crystals in streams [n -S]\n",
  "FRAZILS": "FRAZIL, ice crystals in streams [n]\n",
  "FRAZZLE": "to fray [v FRAZZLED, FRAZZLING, FRAZZLES]\n",
  "FRAZZLED": "FRAZZLE, to fray [v]\n",
  "FRAZZLES": "FRAZZLE, to fray [v]\n",
  "FRAZZLING": "FRAZZLE, to fray [v]\n",
  "FREAK": "to spot or streak [v -ED, -ING, -S]\n",
  "FREAKED": "FREAK, to spot or streak [v]\n",
  "FREAKERIES": "FREAKERY, an obsession with freaks [n]\n",
  "FREAKERY": "an obsession with freaks [n FREAKERIES]\n",
  "FREAKFUL": "quirkily unusual, also FREAKISH, FREAKY [adj]\n",
  "FREAKIER": "FREAKY, quirkily unusual, also FREAKISH, FREAKFUL [adj]\n",
  "FREAKIEST": "FREAKY, quirkily unusual, also FREAKISH, FREAKFUL [adj]\n",
  "FREAKILY": "FREAKY, quirkily unusual, also FREAKISH, FREAKFUL [adv]\n",
  "FREAKINESS": "the state of being freaky [n -ES]\n",
  "FREAKINESSES": "FREAKINESS, the state of being freaky [n]\n",
  "FREAKING": "FREAK, to spot or streak [v]\n",
  "FREAKISH": "quirkily unusual, also FREAKFUL, FREAKY [adj FREAKISHLY]\n",
  "FREAKISHLY": "FREAKISH, quirkily unusual, also FREAKFUL, FREAKY [adv]\n",
  "FREAKISHNESS": "the state of being freakish [n -ES]\n",
  "FREAKISHNESSES": "FREAKISHNESS, the state of being freakish [n]\n",
  "FREAKOUT": "an event marked by wild excitement [n -S]\n",
  "FREAKOUTS": "FREAKOUT, an event marked by wild excitement [n]\n",
  "FREAKS": "FREAK, to spot or streak [v]\n",
  "FREAKY": "quirkily unusual, also FREAKISH, FREAKFUL [adj FREAKIER, FREAKIEST, FREAKILY]\n",
  "FRECKLE": "to mark with small brown spots [v FRECKLED, FRECKLING, FRECKLES]\n",
  "FRECKLED": "FRECKLE, to mark with small brown spots [v]\n",
  "FRECKLES": "FRECKLE, to mark with small brown spots [v]\n",
  "FRECKLIER": "FRECKLY, marked with freckles [adj]\n",
  "FRECKLIEST": "FRECKLY, marked with freckles [adj]\n",
  "FRECKLING": "a collection of little spots [n -S]\n",
  "FRECKLINGS": "FRECKLING, a collection of little spots [n]\n",
  "FRECKLY": "marked with freckles [adj FRECKLIER, FRECKLIEST]\n",
  "FREDAINE": "(French) an escapade or prank [n -S]\n",
  "FREDAINES": "FREDAINE, (French) an escapade or prank [n]\n",
  "FREE": "to set at liberty [v FREED, FREEING, FREES] / not subject to restrictions [adj FREER, FREEST, FREELY]\n",
  "FREEBASE": "to refine cocaine by heating it with ether [v FREEBASED, FREEBASING, FREEBASES]\n",
  "FREEBASED": "FREEBASE, to refine cocaine by heating it with ether [v]\n",
  "FREEBASER": "one who smokes freebase, cocaine refined with ether [n -S]\n",
  "FREEBASERS": "FREEBASER, one who smokes freebase, cocaine refined with ether [n]\n",
  "FREEBASES": "FREEBASE, to refine cocaine by heating it with ether [v]\n",
  "FREEBASING": "FREEBASE, to refine cocaine by heating it with ether [v]\n",
  "FREEBEE": "something given or received without charge, also FREEBIE [n -S]\n",
  "FREEBEES": "FREEBEE, something given or received without charge, also FREEBIE [n]\n",
  "FREEBIE": "something given or received without charge, also FREEBEE [n -S]\n",
  "FREEBIES": "FREEBIE, something given or received without charge, also FREEBEE [n]\n",
  "FREEBOARD": "the distance between the waterline and main deck of a ship [n -S]\n",
  "FREEBOARDS": "FREEBOARD, the distance between the waterline and main deck of a ship [n]\n",
  "FREEBOOT": "to plunder [v -ED, -ING, -S]\n",
  "FREEBOOTED": "FREEBOOT, to plunder [v]\n",
  "FREEBOOTER": "a person who roves about freely in search of booty, a pirate [n -S]\n",
  "FREEBOOTERIES": "FREEBOOTERY, piracy, also FREEBOOTY [n]\n",
  "FREEBOOTERS": "FREEBOOTER, a person who roves about freely in search of booty, a pirate [n]\n",
  "FREEBOOTERY": "piracy, also FREEBOOTY [n FREEBOOTERIES]\n",
  "FREEBOOTIES": "FREEBOOTY, piracy, also FREEBOOTERY [n]\n",
  "FREEBOOTING": "piracy [n -S]\n",
  "FREEBOOTINGS": "FREEBOOTING, piracy [n]\n",
  "FREEBOOTS": "FREEBOOT, to plunder [v]\n",
  "FREEBOOTY": "piracy, also FREEBOOTERY [n FREEBOOTIES]\n",
  "FREEBORN": "born free [adj]\n",
  "FREECOOLING": "a system that uses low ambient air temperature to chill water, esp. for use in air conditioning [n -S]\n",
  "FREECOOLINGS": "FREECOOLING, a system that uses low ambient air temperature to chill water, esp. for use in air conditioning [n]\n",
  "FREECYCLE": "to recycle used goods making them freely available [v FREECYCLED, FREECYCLING, FREECYCLES]\n",
  "FREECYCLED": "FREECYCLE, to recycle used goods making them freely available [v]\n",
  "FREECYCLES": "FREECYCLE, to recycle used goods making them freely available [v]\n",
  "FREECYCLING": "FREECYCLE, to recycle used goods making them freely available [v]\n",
  "FREED": "FREE, to set at liberty [v]\n",
  "FREEDIVER": "one who engages in freediving [n -S]\n",
  "FREEDIVERS": "FREEDIVER, one who engages in freediving [n]\n",
  "FREEDIVING": "the sport of diving for depth without apparatus [n -S]\n",
  "FREEDIVINGS": "FREEDIVING, the sport of diving for depth without apparatus [n]\n",
  "FREEDMAN": "a man who has been freed from slavery [n FREEDMEN]\n",
  "FREEDMEN": "FREEDMAN, a man who has been freed from slavery [n]\n",
  "FREEDOM": "the state of being free, also FREENESS [n -S]\n",
  "FREEDOMS": "FREEDOM, the state of being free, also FREENESS [n]\n",
  "FREEDWOMAN": "a woman freed from slavery [n FREEDWOMEN]\n",
  "FREEDWOMEN": "FREEDWOMAN, a woman freed from slavery [n]\n",
  "FREEFALL": "as in freefall parachuting, a variety of parachuting in which the jumper manoeuvres in free fall before opening the parachute [adj]\n",
  "FREEFORM": "having a free flowing design or shape [adj]\n",
  "FREEGAN": "an opponent of consumerism who survives using recycled goods [n -S]\n",
  "FREEGANISM": "the policy of being a freegan [n -S]\n",
  "FREEGANISMS": "FREEGANISM, the policy of being a freegan [n]\n",
  "FREEGANS": "FREEGAN, an opponent of consumerism who survives using recycled goods [n]\n",
  "FREEHAND": "drawn by hand without mechanical aids [adj]\n",
  "FREEHANDED": "openhanded, liberal [adj FREEHANDEDLY]\n",
  "FREEHANDEDLY": "FREEHANDED, openhanded, liberal [adv]\n",
  "FREEHANDEDNESS": "FREEHANDED, openhanded, liberal [n]\n",
  "FREEHEARTED": "generous, open [adj FREEHEARTEDLY]\n",
  "FREEHEARTEDLY": "FREEHEARTED, generous, open [adv]\n",
  "FREEHOLD": "a property held by fee simple [n -S]\n",
  "FREEHOLDER": "a person who possesses a freehold [n -S]\n",
  "FREEHOLDERS": "FREEHOLDER, a person who possesses a freehold [n]\n",
  "FREEHOLDS": "FREEHOLD, a property held by fee simple [n]\n",
  "FREEING": "FREE, to set at liberty [v]\n",
  "FREEKEH": "a cereal prepared by roasting wheat that has been harvested while the grains are still green [n -S]\n",
  "FREEKEHS": "FREEKEH, a cereal prepared by roasting wheat that has been harvested while the grains are still green [n]\n",
  "FREELANCE": "one who works for his or her self, hiring out services [n -S] / to work for one's self, also FREELANCER [v FREELANCED, FREELANCING, FREELANCES]\n",
  "FREELANCED": "FREELANCE, to work for one's self, also FREELANCER [v]\n",
  "FREELANCER": "one who works for his or her self, hiring out services, also FREELANCE [n -S]\n",
  "FREELANCERS": "FREELANCER, one who works for his or her self, hiring out services, also FREELANCE [n]\n",
  "FREELANCES": "FREELANCE, one who works for his or her self, hiring out services [n]\n",
  "FREELANCING": "FREELANCE, to work for one's self, also FREELANCER [v]\n",
  "FREELOAD": "to live at the expense of others [v -ED, -ING, -S]\n",
  "FREELOADED": "FREELOAD, to live at the expense of others [v]\n",
  "FREELOADER": "one who freeloads [n -S]\n",
  "FREELOADERS": "FREELOADER, one who freeloads [n]\n",
  "FREELOADING": "eating at someone else's expense, gaining from someone else's efforts [n -S]\n",
  "FREELOADINGS": "FREELOADING, eating at someone else's expense, gaining from someone else's efforts [n]\n",
  "FREELOADS": "FREELOAD, to live at the expense of others [v]\n",
  "FREELY": "FREE, not subject to restrictions [adv]\n",
  "FREEMAN": "one who is free [n FREEMEN]\n",
  "FREEMARTIN": "a sexually deficient female calf born as a bull calf's twin [n -S]\n",
  "FREEMARTINS": "FREEMARTIN, a sexually deficient female calf born as a bull calf's twin [n]\n",
  "FREEMASON": "in the Middle Ages, a stonemason of a superior grade [n -S]\n",
  "FREEMASONIC": "relating to freemasons [adj]\n",
  "FREEMASONRIES": "FREEMASONRY, spontaneous fellowship and sympathy among a number of people [n]\n",
  "FREEMASONRY": "spontaneous fellowship and sympathy among a number of people [n FREEMASONRIES]\n",
  "FREEMASONS": "FREEMASON, in the Middle Ages, a stonemason of a superior grade [n]\n",
  "FREEMEN": "FREEMAN, one who is free [n]\n",
  "FREEMIUM": "a business model in which a basic service is provided free of charge, with extra services available to paying subscribers [n -S]\n",
  "FREEMIUMS": "FREEMIUM, a business model in which a basic service is provided free of charge, with extra services available to paying subscribers [n]\n",
  "FREENESS": "the state of being free, also FREEDOM [n -ES]\n",
  "FREENESSES": "FREENESS, the state of being free, also FREEDOM [n]\n",
  "FREEPHONE": "a telephone service whereby an organization pays the cost of certain incoming calls [n -S]\n",
  "FREEPHONES": "FREEPHONE, a telephone service whereby an organization pays the cost of certain incoming calls [n]\n",
  "FREEPOST": "free of charge mail [n -S]\n",
  "FREEPOSTS": "FREEPOST, free of charge mail [n]\n",
  "FREER": "one who frees [n -S]\n",
  "FREERIDE": "an extreme form of skiing in which participants attempt difficult jumps and turns [n -S]\n",
  "FREERIDES": "FREERIDE, an extreme form of skiing in which participants attempt difficult jumps and turns [n]\n",
  "FREERS": "FREER, one who frees [n]\n",
  "FREES": "FREE, to set at liberty [v]\n",
  "FREESHEET": "a newspaper distributed free [n -S]\n",
  "FREESHEETS": "FREESHEET, a newspaper distributed free [n]\n",
  "FREESIA": "a scented garden flower [n -S]\n",
  "FREESIAS": "FREESIA, a scented garden flower [n]\n",
  "FREEST": "FREE, not subject to restrictions [adj]\n",
  "FREESTANDING": "independent [adj]\n",
  "FREESTONE": "a type of building stone that can be cut and sawn with little risk of fracturing [n -S]\n",
  "FREESTONES": "FREESTONE, a type of building stone that can be cut and sawn with little risk of fracturing [n]\n",
  "FREESTYLE": "to perform freestyle rap [v FREESTYLED, FREESTYLING, FREESTYLES]\n",
  "FREESTYLED": "FREESTYLE, to perform freestyle rap [v]\n",
  "FREESTYLER": "a swimmer who swims freestyle [n -S]\n",
  "FREESTYLERS": "FREESTYLER, a swimmer who swims freestyle [n]\n",
  "FREESTYLES": "FREESTYLE, to perform freestyle rap [v]\n",
  "FREESTYLING": "the act of swimming freestyle [n -S]\n",
  "FREESTYLINGS": "FREESTYLING, the act of swimming freestyle [n]\n",
  "FREET": "(Scots) an omen, also FREIT [n -S]\n",
  "FREETHINKER": "one who forms opinions on the basis of reason independently of authority [n -S]\n",
  "FREETHINKERS": "FREETHINKER, one who forms opinions on the basis of reason independently of authority [n]\n",
  "FREETHINKING": "thought not tied to any doctrine [n -S]\n",
  "FREETHINKINGS": "FREETHINKING, thought not tied to any doctrine [n]\n",
  "FREETIER": "FREETY, (Scots) superstitious, also FREITY [adj]\n",
  "FREETIEST": "FREETY, (Scots) superstitious, also FREITY [adj]\n",
  "FREETS": "FREET, (Scots) an omen, also FREIT [n]\n",
  "FREETY": "(Scots) superstitious, also FREITY [adj FREETIER, FREETIEST]\n",
  "FREEWARE": "a free computer program [n -S]\n",
  "FREEWARES": "FREEWARE, a free computer program [n]\n",
  "FREEWAY": "an express highway [n -S]\n",
  "FREEWAYS": "FREEWAY, an express highway [n]\n",
  "FREEWHEEL": "to coast without the use of gears [v -ED, -ING, -S]\n",
  "FREEWHEELED": "FREEWHEEL, to coast without the use of gears [v]\n",
  "FREEWHEELER": "one who freewheels [n -S]\n",
  "FREEWHEELERS": "FREEWHEELER, one who freewheels [n]\n",
  "FREEWHEELING": "coasting [adj FREEWHEELINGLY] / the act of freewheeling [n -S]\n",
  "FREEWHEELINGLY": "FREEWHEELING, coasting [adv]\n",
  "FREEWHEELINGS": "FREEWHEELING, the act of freewheeling [n]\n",
  "FREEWHEELS": "FREEWHEEL, to coast without the use of gears [v]\n",
  "FREEWILL": "having the right to choose [adj]\n",
  "FREEWOMAN": "a woman who is free or enjoys liberty [n FREEWOMEN]\n",
  "FREEWOMEN": "FREEWOMAN, a woman who is free or enjoys liberty [n]\n",
  "FREEWRITE": "to write freely without stopping or thinking [v FREEWROTE, FREEWRITTEN, FREEWRITING, FREEWRITES]\n",
  "FREEWRITES": "FREEWRITE, to write freely without stopping or thinking [v]\n",
  "FREEWRITING": "writing without the constraint of form [n -S]\n",
  "FREEWRITINGS": "FREEWRITING, writing without the constraint of form [n]\n",
  "FREEWRITTEN": "FREEWRITE, to write freely without stopping or thinking [v]\n",
  "FREEWROTE": "FREEWRITE, to write freely without stopping or thinking [v]\n",
  "FREEZABLE": "capable of being frozen [adj]\n",
  "FREEZE": "to turn into a solid by lowering the temperature [v FROZE, FROZEN, FREEZING, FREEZES]\n",
  "FREEZER": "an appliance for freezing food [n -S]\n",
  "FREEZERS": "FREEZER, an appliance for freezing food [n]\n",
  "FREEZES": "FREEZE, to turn into a solid by lowering the temperature [v]\n",
  "FREEZING": "very cold [adj FREEZINGLY] / the act of freezing [n -S]\n",
  "FREEZINGLY": "FREEZING, very cold [adv]\n",
  "FREEZINGS": "FREEZING, the act of freezing [n]\n",
  "FREIGHT": "to load with goods for transportation [v -ED, -ING, -S]\n",
  "FREIGHTAGE": "money paid for freight; freighted goods [n -S]\n",
  "FREIGHTAGES": "FREIGHTAGE, money paid for freight; freighted goods [n]\n",
  "FREIGHTED": "FREIGHT, to load with goods for transportation [v]\n",
  "FREIGHTER": "a ship or aircraft for transporting freight [n -S]\n",
  "FREIGHTERS": "FREIGHTER, a ship or aircraft for transporting freight [n]\n",
  "FREIGHTING": "FREIGHT, to load with goods for transportation [v]\n",
  "FREIGHTLESS": "without freight [adj]\n",
  "FREIGHTS": "FREIGHT, to load with goods for transportation [v]\n",
  "FREIT": "(Scots) an omen, also FREET [n -S]\n",
  "FREITIER": "FREITY, (Scots) superstitious, also FREETY [adj]\n",
  "FREITIEST": "FREITY, (Scots) superstitious, also FREETY [adj]\n",
  "FREITS": "FREIT, (Scots) an omen, also FREET [n]\n",
  "FREITY": "(Scots) superstitious, also FREETY [adj FREITIER, FREITIEST]\n",
  "FREMD": "(Scots) a stranger, also FRAIM, FREMIT [n -S]\n",
  "FREMDS": "FREMD, (Scots) a stranger, also FRAIM, FREMIT [n]\n",
  "FREMESCENCE": "growling or muttering [n -S]\n",
  "FREMESCENCES": "FREMESCENCE, growling or muttering [n]\n",
  "FREMESCENT": "growling or muttering [adj]\n",
  "FREMIT": "(Scots) a stranger, also FREMD, FRAIM [n -S]\n",
  "FREMITS": "FREMIT, (Scots) a stranger, also FREMD, FRAIM [n]\n",
  "FREMITUS": "(Latin) a vibration capable of being felt [n -ES]\n",
  "FREMITUSES": "FREMITUS, (Latin) a vibration capable of being felt [n]\n",
  "FRENA": "FRENUM, (Latin) a connecting fold of membrane, also FRAENUM, FRENULUM [n]\n",
  "FRENCH": "to cut into thin strips before cooking [v -ED, -ING, -ES]\n",
  "FRENCHED": "FRENCH, to cut into thin strips before cooking [v]\n",
  "FRENCHES": "FRENCH, to cut into thin strips before cooking [v]\n",
  "FRENCHIFICATION": "the act of frenchifying [n]\n",
  "FRENCHIFIED": "FRENCHIFY, to make French; to imbue with the manners of the French [v]\n",
  "FRENCHIFIES": "FRENCHIFY, to make French; to imbue with the manners of the French [v]\n",
  "FRENCHIFY": "to make French; to imbue with the manners of the French [v FRENCHIFIED, FRENCHIFYING, FRENCHIFIES]\n",
  "FRENCHIFYING": "FRENCHIFY, to make French; to imbue with the manners of the French [v]\n",
  "FRENCHING": "FRENCH, to cut into thin strips before cooking [v]\n",
  "FRENEMIES": "FRENEMY, a person who pretends to be a friend but is actually an enemy [n]\n",
  "FRENEMY": "a person who pretends to be a friend but is actually an enemy [n FRENEMIES]\n",
  "FRENETIC": "frantic, also FRENETICAL [adj FRENETICALLY] / a madman [n -S]\n",
  "FRENETICAL": "frenetic, frantic, also FRENETIC [adj FRENETICALLY]\n",
  "FRENETICALLY": "FRENETICAL, frenetic, frantic, also FRENETIC [adv]\n",
  "FRENETICISM": "the state of being frenetic [n -S]\n",
  "FRENETICISMS": "FRENETICISM, the state of being frenetic [n]\n",
  "FRENETICNESS": "the state of being frenetic [n -ES]\n",
  "FRENETICNESSES": "FRENETICNESS, the state of being frenetic [n]\n",
  "FRENETICS": "FRENETIC, a madman [n]\n",
  "FRENNE": "(Spenser) a stranger [n -S]\n",
  "FRENNES": "FRENNE, (Spenser) a stranger [n]\n",
  "FRENULA": "FRENULUM, (Latin) a connecting fold of membrane, also FRENUM, FRAENUM [n]\n",
  "FRENULAR": "of or relating to a frenulum, a small stiff hair on the hindwings of some insects [adj]\n",
  "FRENULUM": "(Latin) a connecting fold of membrane, also FRENUM, FRAENUM [n FRENULUMS or FRENULA]\n",
  "FRENULUMS": "FRENULUM, (Latin) a connecting fold of membrane, also FRENUM, FRAENUM [n]\n",
  "FRENUM": "(Latin) a connecting fold of membrane, also FRAENUM, FRENULUM [n FRENUMS or FRENA]\n",
  "FRENUMS": "FRENUM, (Latin) a connecting fold of membrane, also FRAENUM, FRENULUM [n]\n",
  "FRENZICAL": "frantic, also PHRENSICAL [adj]\n",
  "FRENZIED": "FRENZY, to make frantic, also PHRENSY [v]\n",
  "FRENZIEDLY": "FRENZIED, FRENZY, to make frantic, also PHRENSY [adv]\n",
  "FRENZIES": "FRENZY, to make frantic, also PHRENSY [v]\n",
  "FRENZILY": "in a frenzy, frantically [adv]\n",
  "FRENZY": "to make frantic, also PHRENSY [v FRENZIED, FRENZYING, FRENZIES]\n",
  "FRENZYING": "FRENZY, to make frantic, also PHRENSY [v]\n",
  "FREON": "(tradename) an aerosol propellant [n -S]\n",
  "FREONS": "FREON, (tradename) an aerosol propellant [n]\n",
  "FREQUENCE": "commonness of recurrence, also FREQUENCY [n -S]\n",
  "FREQUENCES": "FREQUENCE, commonness of recurrence, also FREQUENCY [n]\n",
  "FREQUENCIES": "FREQUENCY, commonness of recurrence, also FREQUENCE [n]\n",
  "FREQUENCY": "commonness of recurrence, also FREQUENCE [n FREQUENCIES]\n",
  "FREQUENT": "to go to habitually [v -ED, -ING, -S] / occurring often [adj FREQUENTER, FREQUENTEST, FREQUENTLY]\n",
  "FREQUENTABLE": "that can be frequented [adj]\n",
  "FREQUENTATION": "the act of frequenting [n -S]\n",
  "FREQUENTATIONS": "FREQUENTATION, the act of frequenting [n]\n",
  "FREQUENTATIVE": "a tense of a verb denoting a repeated or recurrent action or state [n -S]\n",
  "FREQUENTATIVES": "FREQUENTATIVE, a tense of a verb denoting a repeated or recurrent action or state [n]\n",
  "FREQUENTED": "FREQUENT, to go to habitually [v]\n",
  "FREQUENTER": "one who frequents [n -S]\n",
  "FREQUENTERS": "FREQUENTER, one who frequents [n]\n",
  "FREQUENTEST": "FREQUENT, occurring often [adj]\n",
  "FREQUENTING": "FREQUENT, to go to habitually [v]\n",
  "FREQUENTLY": "FREQUENT, occurring often [adv]\n",
  "FREQUENTNESS": "the state of being frequent [n -ES]\n",
  "FREQUENTNESSES": "FREQUENTNESS, the state of being frequent [n]\n",
  "FREQUENTS": "FREQUENT, to go to habitually [v]\n",
  "FRERE": "a friar [n -S]\n",
  "FRERES": "FRERE, a friar [n]\n",
  "FRESCADE": "(French) a cool walk [n -S]\n",
  "FRESCADES": "FRESCADE, (French) a cool walk [n]\n",
  "FRESCO": "(Italian) to paint on plaster [v FRESCOED, FRESCOING, FRESCOES or FRESCOS]\n",
  "FRESCOED": "FRESCO, (Italian) to paint on plaster [v]\n",
  "FRESCOER": "one who paints frescos, also FRESCOIST [n -S]\n",
  "FRESCOERS": "FRESCOER, one who paints frescos, also FRESCOIST [n]\n",
  "FRESCOES": "FRESCO, (Italian) to paint on plaster [v]\n",
  "FRESCOING": "the act of painting on fresh moist plaster [n -S]\n",
  "FRESCOINGS": "FRESCOING, the act of painting on fresh moist plaster [n]\n",
  "FRESCOIST": "one who paints frescos, also FRESCOER [n -S]\n",
  "FRESCOISTS": "FRESCOIST, one who paints frescos, also FRESCOER [n]\n",
  "FRESCOS": "FRESCO, (Italian) to paint on plaster [v]\n",
  "FRESH": "to improve the condition of, also FRESHEN [v -ED, -ING, -ES] / new [adj FRESHER, FRESHEST, FRESHLY]\n",
  "FRESHED": "FRESH, to improve the condition of, also FRESHEN [v]\n",
  "FRESHEN": "to improve the condition of, also FRESH [v -ED, -ING, -S]\n",
  "FRESHENED": "FRESHEN, to improve the condition of, also FRESH [v]\n",
  "FRESHENER": "something that freshens [n -S]\n",
  "FRESHENERS": "FRESHENER, something that freshens [n]\n",
  "FRESHENING": "FRESHEN, to improve the condition of, also FRESH [v]\n",
  "FRESHENS": "FRESHEN, to improve the condition of, also FRESH [v]\n",
  "FRESHER": "a first year college or university student [n -S]\n",
  "FRESHERDOM": "the state of being a fresher [n -S]\n",
  "FRESHERDOMS": "FRESHERDOM, the state of being a fresher [n]\n",
  "FRESHERS": "FRESHER, a first year college or university student [n]\n",
  "FRESHES": "FRESH, to improve the condition of, also FRESHEN [v]\n",
  "FRESHEST": "FRESH, new [adj]\n",
  "FRESHET": "a stream of fresh water [n -S]\n",
  "FRESHETS": "FRESHET, a stream of fresh water [n]\n",
  "FRESHIE": "(Hinglish) a new immigrant to the UK from Asian countries [n -S]\n",
  "FRESHIES": "FRESHIE, (Hinglish) a new immigrant to the UK from Asian countries [n]\n",
  "FRESHING": "FRESH, to improve the condition of, also FRESHEN [v]\n",
  "FRESHISH": "somewhat fresh [adj]\n",
  "FRESHLY": "FRESH, new [adv]\n",
  "FRESHMAN": "a first-year student [n FRESHMEN]\n",
  "FRESHMANSHIP": "the state of being a freshman [n -S]\n",
  "FRESHMANSHIPS": "FRESHMANSHIP, the state of being a freshman [n]\n",
  "FRESHMEN": "FRESHMAN, a first-year student [n]\n",
  "FRESHNESS": "the state of being fresh [n -ES]\n",
  "FRESHNESSES": "FRESHNESS, the state of being fresh [n]\n",
  "FRESHWATER": "fresh water, not salt [n -S]\n",
  "FRESHWATERS": "FRESHWATER, fresh water, not salt [n]\n",
  "FRESNEL": "a unit of optical frequency equal to one terahertz [n -S]\n",
  "FRESNELS": "FRESNEL, a unit of optical frequency equal to one terahertz [n]\n",
  "FRET": "to worry [v FRETTED, FRETTING, FRETS]\n",
  "FRETBOARD": "a fingerboard with frets on a stringed musical instrument [n -S]\n",
  "FRETBOARDS": "FRETBOARD, a fingerboard with frets on a stringed musical instrument [n]\n",
  "FRETFUL": "inclined to fret [adj FRETFULLY]\n",
  "FRETFULLY": "FRETFUL, inclined to fret [adv]\n",
  "FRETFULNESS": "the state of being fretful [n -ES]\n",
  "FRETFULNESSES": "FRETFULNESS, the state of being fretful [n]\n",
  "FRETLESS": "of a musical instrument, without frets [adj]\n",
  "FRETS": "FRET, to worry [v]\n",
  "FRETSAW": "a narrow-bladed saw [n -S]\n",
  "FRETSAWS": "FRETSAW, a narrow-bladed saw [n]\n",
  "FRETSOME": "fretful [adj]\n",
  "FRETTED": "FRET, to worry [v]\n",
  "FRETTER": "one who, or that which, frets [n -S]\n",
  "FRETTERS": "FRETTER, one who, or that which, frets [n]\n",
  "FRETTIER": "FRETTY, adorned with fretwork [adj]\n",
  "FRETTIEST": "FRETTY, adorned with fretwork [adj]\n",
  "FRETTING": "peevishness [n -S]\n",
  "FRETTINGS": "FRETTING, peevishness [n]\n",
  "FRETTY": "adorned with fretwork [adj FRETTIER, FRETTIEST]\n",
  "FRETWORK": "perforated ornamental woodwork [n -S]\n",
  "FRETWORKS": "FRETWORK, perforated ornamental woodwork [n]\n",
  "FRIABILITIES": "FRIABILITY, the state of being friable [n]\n",
  "FRIABILITY": "the state of being friable [n FRIABILITIES]\n",
  "FRIABLE": "easily crumbled [adj]\n",
  "FRIABLENESS": "the state of being friable [n -ES]\n",
  "FRIABLENESSES": "FRIABLENESS, the state of being friable [n]\n",
  "FRIAND": "(French) a (male) epicure [n -S]\n",
  "FRIANDE": "(French) a (female) epicure [n -S]\n",
  "FRIANDES": "FRIANDE, (French) a (female) epicure [n]\n",
  "FRIANDS": "FRIAND, (French) a (male) epicure [n]\n",
  "FRIAR": "a member of a religious order [n -S]\n",
  "FRIARBIRD": "an Australian honeyeater with featherless head [n -S]\n",
  "FRIARBIRDS": "FRIARBIRD, an Australian honeyeater with featherless head [n]\n",
  "FRIARIES": "FRIARY, a monastery of friars [n]\n",
  "FRIARLY": "resembling or characteristic of a friar [adj]\n",
  "FRIARS": "FRIAR, a member of a religious order [n]\n",
  "FRIARY": "a monastery of friars [n FRIARIES]\n",
  "FRIB": "(Australian slang) a short heavy-conditioned piece of wool removed from a fleece during classing [n -S]\n",
  "FRIBBLE": "to be frivolous, trifle [v FRIBBLED, FRIBBLING, FRIBBLES]\n",
  "FRIBBLED": "FRIBBLE, to be frivolous, trifle [v]\n",
  "FRIBBLER": "(obsolete) a trifler [n -S]\n",
  "FRIBBLERS": "FRIBBLER, (obsolete) a trifler [n]\n",
  "FRIBBLES": "FRIBBLE, to be frivolous, trifle [v]\n",
  "FRIBBLING": "FRIBBLE, to be frivolous, trifle [v]\n",
  "FRIBBLISH": "(obsolete) trifling [adj]\n",
  "FRIBS": "FRIB, (Australian slang) a short heavy-conditioned piece of wool removed from a fleece during classing [n]\n",
  "FRICADEL": "(South African) a fried ball of mincemeat, also FRIKKADEL [n -S]\n",
  "FRICADELS": "FRICADEL, (South African) a fried ball of mincemeat, also FRIKKADEL [n]\n",
  "FRICANDEAU": "(French) a thick slice of veal or similar meat, also FRICANDO [n FRICANDEAUS or FRICANDEAUX]\n",
  "FRICANDEAUS": "FRICANDEAU, (French) a thick slice of veal or similar meat, also FRICANDO [n]\n",
  "FRICANDEAUX": "FRICANDEAU, (French) a thick slice of veal or similar meat, also FRICANDO [n]\n",
  "FRICANDO": "a roasted loin of veal, also FRICANDEAU [n -ES]\n",
  "FRICANDOES": "FRICANDO, a roasted loin of veal, also FRICANDEAU [n]\n",
  "FRICASSEE": "(French) a dish made of fowls, veal, or other meat of small animals cut into pieces, and stewed in a gravy [n -S] / to cook as a fricassee [v FRICASSEED, FRICASSEEING, FRICASSEES]\n",
  "FRICASSEED": "FRICASSEE, to cook as a fricassee [v]\n",
  "FRICASSEEING": "FRICASSEE, to cook as a fricassee [v]\n",
  "FRICASSEES": "FRICASSEE, (French) a dish made of fowls, veal, or other meat of small animals cut into pieces, and stewed in a gravy [n]\n",
  "FRICATIVE": "a sound produced by the forcing of air through a restricted passage, as with 'f' [n -S]\n",
  "FRICATIVES": "FRICATIVE, a sound produced by the forcing of air through a restricted passage, as with 'f' [n]\n",
  "FRICHT": "(Scots) to frighten [v -ED, -ING, -S]\n",
  "FRICHTED": "FRICHT, (Scots) to frighten [v]\n",
  "FRICHTING": "FRICHT, (Scots) to frighten [v]\n",
  "FRICHTS": "FRICHT, (Scots) to frighten [v]\n",
  "FRICKING": "(vulgar) an intensive, fucking [adj]\n",
  "FRICOT": "an Acadian stew with potatoes and meat or fish [n -S]\n",
  "FRICOTS": "FRICOT, an Acadian stew with potatoes and meat or fish [n]\n",
  "FRICTION": "the rubbing of two bodies together [n -S]\n",
  "FRICTIONAL": "relating to friction [adj FRICTIONALLY]\n",
  "FRICTIONALLY": "FRICTIONAL, relating to friction [adv]\n",
  "FRICTIONLESS": "without friction [adj FRICTIONLESSLY]\n",
  "FRICTIONLESSLY": "FRICTIONLESS, without friction [adv]\n",
  "FRICTIONS": "FRICTION, the rubbing of two bodies together [n]\n",
  "FRIDGE": "to rub or fray [v FRIDGED, FRIDGING, FRIDGES]\n",
  "FRIDGED": "FRIDGE, to rub or fray [v]\n",
  "FRIDGES": "FRIDGE, to rub or fray [v]\n",
  "FRIDGING": "FRIDGE, to rub or fray [v]\n",
  "FRIED": "FRY, to cook in fat or oil [v]\n",
  "FRIEDCAKE": "(US) a doughnut, a cruller [n -S]\n",
  "FRIEDCAKES": "FRIEDCAKE, (US) a doughnut, a cruller [n]\n",
  "FRIEND": "to enter into a warm association with [v -ED, -ING, -S]\n",
  "FRIENDED": "FRIEND, to enter into a warm association with [v]\n",
  "FRIENDING": "the act of making a friend [n -S]\n",
  "FRIENDINGS": "FRIENDING, the act of making a friend [n]\n",
  "FRIENDLESS": "without a friend [adj]\n",
  "FRIENDLESSNESS": "FRIENDLESS, without a friend [n]\n",
  "FRIENDLIER": "FRIENDLY, amicable [adj]\n",
  "FRIENDLIES": "FRIENDLY, one who is friendly [n]\n",
  "FRIENDLIEST": "FRIENDLY, amicable [adj]\n",
  "FRIENDLILY": "FRIENDLY, amicable [adv]\n",
  "FRIENDLINESS": "the state of being friendly [n -ES]\n",
  "FRIENDLINESSES": "FRIENDLINESS, the state of being friendly [n]\n",
  "FRIENDLY": "one who is friendly [n FRIENDLIES] / amicable [adj FRIENDLIER, FRIENDLIEST, FRIENDLILY]\n",
  "FRIENDS": "FRIEND, to enter into a warm association with [v]\n",
  "FRIENDSHIP": "the state of being friends [n -S]\n",
  "FRIENDSHIPS": "FRIENDSHIP, the state of being friends [n]\n",
  "FRIER": "a pan or container for frying, also FRYER [n -S]\n",
  "FRIERS": "FRIER, a pan or container for frying, also FRYER [n]\n",
  "FRIES": "FRY, to cook in fat or oil [v]\n",
  "FRIEZE": "to put a decorative band on the top edge of a wall [v FRIEZED, FRIEZING, FRIEZES]\n",
  "FRIEZED": "FRIEZE, to put a decorative band on the top edge of a wall [v]\n",
  "FRIEZELIKE": "like a frieze [adj]\n",
  "FRIEZES": "FRIEZE, to put a decorative band on the top edge of a wall [v]\n",
  "FRIEZING": "FRIEZE, to put a decorative band on the top edge of a wall [v]\n",
  "FRIG": "to potter about [v FRIGGED, FRIGGING, FRIGS] / a refrigerator [n -ES]\n",
  "FRIGATE": "a class of war vessels intermediate between corvettes and ships of the line [n -S]\n",
  "FRIGATES": "FRIGATE, a class of war vessels intermediate between corvettes and ships of the line [n]\n",
  "FRIGATOON": "a small Venetian vessel with a square stern and two masts [n -S]\n",
  "FRIGATOONS": "FRIGATOON, a small Venetian vessel with a square stern and two masts [n]\n",
  "FRIGES": "FRIG, a refrigerator [n]\n",
  "FRIGGED": "FRIG, to potter about [v]\n",
  "FRIGGER": "a glass ornament [n -S]\n",
  "FRIGGERS": "FRIGGER, a glass ornament [n]\n",
  "FRIGGING": "pottering about [n -S]\n",
  "FRIGGINGS": "FRIGGING, pottering about [n]\n",
  "FRIGHT": "to make afraid, to scare, also FRIGHTEN [v -ED, -ING, -S]\n",
  "FRIGHTED": "FRIGHT, to make afraid, to scare, also FRIGHTEN [v]\n",
  "FRIGHTEN": "to make afraid, to scare, also FRIGHT [v -ED, -ING, -S]\n",
  "FRIGHTENED": "FRIGHTEN, to make afraid, to scare, also FRIGHT [v]\n",
  "FRIGHTENER": "something or someone who frightens [n -S]\n",
  "FRIGHTENERS": "FRIGHTENER, something or someone who frightens [n]\n",
  "FRIGHTENING": "FRIGHTEN, to make afraid, to scare, also FRIGHT [v]\n",
  "FRIGHTENINGLY": "FRIGHTENING, FRIGHTEN, to make afraid, to scare, also FRIGHT [adv]\n",
  "FRIGHTENS": "FRIGHTEN, to make afraid, to scare, also FRIGHT [v]\n",
  "FRIGHTFUL": "terrible, horrible [adj FRIGHTFULLY]\n",
  "FRIGHTFULLY": "FRIGHTFUL, terrible, horrible [adv]\n",
  "FRIGHTFULNESS": "the state of being frightful [n -ES]\n",
  "FRIGHTFULNESSES": "FRIGHTFULNESS, the state of being frightful [n]\n",
  "FRIGHTING": "FRIGHT, to make afraid, to scare, also FRIGHTEN [v]\n",
  "FRIGHTS": "FRIGHT, to make afraid, to scare, also FRIGHTEN [v]\n",
  "FRIGHTSOME": "frightful [adj]\n",
  "FRIGID": "chillingly stiff [adj FRIGIDER, FRIGIDEST, FRIGIDLY]\n",
  "FRIGIDARIA": "FRIGIDARIUM, (Latin) the room in Roman baths containing the final, cold, bath [n]\n",
  "FRIGIDARIUM": "(Latin) the room in Roman baths containing the final, cold, bath [n FRIGIDARIA]\n",
  "FRIGIDER": "FRIGID, chillingly stiff [adj]\n",
  "FRIGIDEST": "FRIGID, chillingly stiff [adj]\n",
  "FRIGIDITIES": "FRIGIDITY, the state of being frigid [n]\n",
  "FRIGIDITY": "the state of being frigid [n FRIGIDITIES]\n",
  "FRIGIDLY": "FRIGID, chillingly stiff [adv]\n",
  "FRIGIDNESS": "the state of being frigid [n -ES]\n",
  "FRIGIDNESSES": "FRIGIDNESS, the state of being frigid [n]\n",
  "FRIGORIFIC": "causing cold, chilling [adj]\n",
  "FRIGORIFICO": "(Spanish) a slaughtering and meat-freezing establishment [n -S]\n",
  "FRIGORIFICOS": "FRIGORIFICO, (Spanish) a slaughtering and meat-freezing establishment [n]\n",
  "FRIGOT": "(Spenser) a frigate [n -S]\n",
  "FRIGOTS": "FRIGOT, (Spenser) a frigate [n]\n",
  "FRIGS": "FRIG, to potter about [v]\n",
  "FRIJOL": "(Spanish) a bean used as food, the kidney bean, also FRIJOLE [n FRIJOLES]\n",
  "FRIJOLE": "(Spanish) a bean used as food, the kidney bean, also FRIJOL [n -S]\n",
  "FRIJOLES": "FRIJOL, (Spanish) a bean used as food, the kidney bean, also FRIJOLE [n]\n",
  "FRIKKADEL": "(South African) a fried ball of mincemeat, also FRICADEL [n -S]\n",
  "FRIKKADELS": "FRIKKADEL, (South African) a fried ball of mincemeat, also FRICADEL [n]\n",
  "FRILL": "to provide with a ruffled edge [v -ED, -ING, -S]\n",
  "FRILLED": "FRILL, to provide with a ruffled edge [v]\n",
  "FRILLER": "one that frills [n -S]\n",
  "FRILLERIES": "FRILLERY, an arrangement of frills [n]\n",
  "FRILLERS": "FRILLER, one that frills [n]\n",
  "FRILLERY": "an arrangement of frills [n FRILLERIES]\n",
  "FRILLIER": "FRILLY, having frills [adj]\n",
  "FRILLIES": "FRILLY, a frilly garment [n]\n",
  "FRILLIEST": "FRILLY, having frills [adj]\n",
  "FRILLINESS": "the state of being frilly [n -ES]\n",
  "FRILLINESSES": "FRILLINESS, the state of being frilly [n]\n",
  "FRILLING": "an arrangement of frills [n -S]\n",
  "FRILLINGS": "FRILLING, an arrangement of frills [n]\n",
  "FRILLS": "FRILL, to provide with a ruffled edge [v]\n",
  "FRILLY": "having frills [adj FRILLIER, FRILLIEST] / a frilly garment [n FRILLIES]\n",
  "FRINGE": "to provide with an ornamental border [v FRINGED, FRINGING, FRINGES]\n",
  "FRINGED": "FRINGE, to provide with an ornamental border [v]\n",
  "FRINGELESS": "having no fringe [adj]\n",
  "FRINGELIKE": "like a fringe [adj]\n",
  "FRINGES": "FRINGE, to provide with an ornamental border [v]\n",
  "FRINGIER": "FRINGY, resembling a fringe [adj]\n",
  "FRINGIEST": "FRINGY, resembling a fringe [adj]\n",
  "FRINGILLACEOUS": "relating to the finches [adj]\n",
  "FRINGILLID": "related to the finches [adj]\n",
  "FRINGILLIFORM": "resembling a finch [adj]\n",
  "FRINGILLINE": "relating to the finches [adj]\n",
  "FRINGING": "the act of providing with a fringe [n -S]\n",
  "FRINGINGS": "FRINGING, the act of providing with a fringe [n]\n",
  "FRINGY": "resembling a fringe [adj FRINGIER, FRINGIEST]\n",
  "FRIPON": "(French) a knave or scamp [n -S]\n",
  "FRIPONNERIE": "(French) knavery [n -S]\n",
  "FRIPONNERIES": "FRIPONNERIE, (French) knavery [n]\n",
  "FRIPONS": "FRIPON, (French) a knave or scamp [n]\n",
  "FRIPPER": "(archaic) one who deals in frippery or in old clothes, also FRIPPERER [n -S]\n",
  "FRIPPERER": "(archaic) one who deals in frippery or in old clothes, also FRIPPER [n -S]\n",
  "FRIPPERERS": "FRIPPERER, (archaic) one who deals in frippery or in old clothes, also FRIPPER [n]\n",
  "FRIPPERIES": "FRIPPERY, excessive ornamentation [n]\n",
  "FRIPPERS": "FRIPPER, (archaic) one who deals in frippery or in old clothes, also FRIPPERER [n]\n",
  "FRIPPERY": "excessive ornamentation [n FRIPPERIES]\n",
  "FRIPPET": "a frivolous or flamboyant young woman [n -S]\n",
  "FRIPPETS": "FRIPPET, a frivolous or flamboyant young woman [n]\n",
  "FRIS": "(Hungarian) the fast section of a Hungarian dance, also FRISKA [n -ES]\n",
  "FRISBEE": "a plastic disk several inches in diameter sailed between players by a flip of the wrist [n -S]\n",
  "FRISBEES": "FRISBEE, a plastic disk several inches in diameter sailed between players by a flip of the wrist [n]\n",
  "FRISE": "(French) a decorated strip between architrave and cornice, also FRIEZE [n -S]\n",
  "FRISEE": "(French) a variety of curly endive [n -S]\n",
  "FRISEES": "FRISEE, (French) a variety of curly endive [n]\n",
  "FRISES": "FRISE, (French) a decorated strip between architrave and cornice, also FRIEZE [n]\n",
  "FRISETTE": "(French) a frizzed fringe of hair, also FRIZETTE [n -S]\n",
  "FRISETTES": "FRISETTE, (French) a frizzed fringe of hair, also FRIZETTE [n]\n",
  "FRISEUR": "(French) a hairdresser [n -S]\n",
  "FRISEURS": "FRISEUR, (French) a hairdresser [n]\n",
  "FRISK": "to gambol, or leap playfully [v -ED, -ING, -S]\n",
  "FRISKA": "(Hungarian) the fast section of a Hungarian dance, also FRIS [n -S]\n",
  "FRISKAS": "FRISKA, (Hungarian) the fast section of a Hungarian dance, also FRIS [n]\n",
  "FRISKED": "FRISK, to gambol, or leap playfully [v]\n",
  "FRISKER": "one who frisks; one who leaps or gambols [n -S]\n",
  "FRISKERS": "FRISKER, one who frisks; one who leaps or gambols [n]\n",
  "FRISKET": "a frame used to protect paper in a printing press [n -S]\n",
  "FRISKETS": "FRISKET, a frame used to protect paper in a printing press [n]\n",
  "FRISKFUL": "brisk; lively; frolicsome [adj]\n",
  "FRISKIER": "FRISKY, lively and playful [adj]\n",
  "FRISKIEST": "FRISKY, lively and playful [adj]\n",
  "FRISKILY": "FRISKY, lively and playful [adv]\n",
  "FRISKINESS": "the state of being frisky [n -ES]\n",
  "FRISKINESSES": "FRISKINESS, the state of being frisky [n]\n",
  "FRISKING": "gambolling [adj FRISKINGLY] / the act of frisking [n -S]\n",
  "FRISKINGLY": "FRISKING, gambolling [adv]\n",
  "FRISKINGS": "FRISKING, the act of frisking [n]\n",
  "FRISKS": "FRISK, to gambol, or leap playfully [v]\n",
  "FRISKY": "lively and playful [adj FRISKIER, FRISKIEST, FRISKILY]\n",
  "FRISSON": "(French) an emotional thrill; a shudder of emotion [n -S]\n",
  "FRISSONS": "FRISSON, (French) an emotional thrill; a shudder of emotion [n]\n",
  "FRIST": "to postpone, grant time [v -ED, -ING, -S]\n",
  "FRISTED": "FRIST, to postpone, grant time [v]\n",
  "FRISTING": "FRIST, to postpone, grant time [v]\n",
  "FRISTS": "FRIST, to postpone, grant time [v]\n",
  "FRISURE": "(French) the dressing of the hair by crisping or curling [n -S]\n",
  "FRISURES": "FRISURE, (French) the dressing of the hair by crisping or curling [n]\n",
  "FRIT": "to fuse into a vitreous substance, also FRITT [v FRITTED, FRITTING, FRITS]\n",
  "FRITES": "chipped potatoes [n]\n",
  "FRITFLIES": "FRITFLY, a small fly [n]\n",
  "FRITFLY": "a small fly [n FRITFLIES]\n",
  "FRITH": "an inlet of the sea, also FIRTH [n -S]\n",
  "FRITHBORH": "(Old English) a surety for keeping the peace, aka frankpledge [n -S]\n",
  "FRITHBORHS": "FRITHBORH, (Old English) a surety for keeping the peace, aka frankpledge [n]\n",
  "FRITHS": "FRITH, an inlet of the sea, also FIRTH [n]\n",
  "FRITHSOKEN": "(Old English) sanctuary or asylum [n -S]\n",
  "FRITHSOKENS": "FRITHSOKEN, (Old English) sanctuary or asylum [n]\n",
  "FRITHSTOOL": "a seat in churches near the altar, to which offenders formerly fled for sanctuary [n -S]\n",
  "FRITHSTOOLS": "FRITHSTOOL, a seat in churches near the altar, to which offenders formerly fled for sanctuary [n]\n",
  "FRITILLARIA": "any of a widespread genus of bulbous herbs of the lily family with variably colored and often mottled or checkered flowers [n -S]\n",
  "FRITILLARIAS": "FRITILLARIA, any of a widespread genus of bulbous herbs of the lily family with variably colored and often mottled or checkered flowers [n]\n",
  "FRITILLARIES": "FRITILLARY, several kinds of spotted butterfly and bulbous plant [n]\n",
  "FRITILLARY": "several kinds of spotted butterfly and bulbous plant [n FRITILLARIES]\n",
  "FRITS": "FRIT, to fuse into a vitreous substance, also FRITT [v]\n",
  "FRITT": "to fuse into a vitreous substance, also FRIT [v -ED, -ING, -S]\n",
  "FRITTATA": "(Italian) an unfolded omelet with chopped meat or vegetables [n -S]\n",
  "FRITTATAS": "FRITTATA, (Italian) an unfolded omelet with chopped meat or vegetables [n]\n",
  "FRITTED": "FRIT, to fuse into a vitreous substance, also FRITT [v]\n",
  "FRITTER": "to squander little by little [v -ED, -ING, -S]\n",
  "FRITTERED": "FRITTER, to squander little by little [v]\n",
  "FRITTERER": "one who fritters [n -S]\n",
  "FRITTERERS": "FRITTERER, one who fritters [n]\n",
  "FRITTERING": "FRITTER, to squander little by little [v]\n",
  "FRITTERS": "FRITTER, to squander little by little [v]\n",
  "FRITTING": "FRIT, to fuse into a vitreous substance, also FRITT [v]\n",
  "FRITTS": "FRITT, to fuse into a vitreous substance, also FRIT [v]\n",
  "FRITURE": "(French) a dish of fried food [n -S]\n",
  "FRITURES": "FRITURE, (French) a dish of fried food [n]\n",
  "FRITZ": "(of an appliance, etc.) to become broken or start malfunctioning [v -ED, -ING, -ES]\n",
  "FRITZED": "FRITZ, (of an appliance, etc.) to become broken or start malfunctioning [v]\n",
  "FRITZES": "FRITZ, (of an appliance, etc.) to become broken or start malfunctioning [v]\n",
  "FRITZING": "FRITZ, (of an appliance, etc.) to become broken or start malfunctioning [v]\n",
  "FRIULANO": "(Italian) a cow's-milk cheese with firm pale-yellow flesh, and a mild flavour, originating in Friuli, Italy [n -S]\n",
  "FRIULANOS": "FRIULANO, (Italian) a cow's-milk cheese with firm pale-yellow flesh, and a mild flavour, originating in Friuli, Italy [n]\n",
  "FRIVOL": "to behave playfully [v FRIVOLED or FRIVOLLED, FRIVOLING or FRIVOLLING, FRIVOLS]\n",
  "FRIVOLED": "FRIVOL, to behave playfully [v]\n",
  "FRIVOLER": "one who frivols, also FRIVOLLER [n -S]\n",
  "FRIVOLERS": "FRIVOLER, one who frivols, also FRIVOLLER [n]\n",
  "FRIVOLING": "FRIVOL, to behave playfully [v]\n",
  "FRIVOLITIES": "FRIVOLITY, a trifling habit or nature [n]\n",
  "FRIVOLITY": "a trifling habit or nature [n FRIVOLITIES]\n",
  "FRIVOLLED": "FRIVOL, to behave playfully [v]\n",
  "FRIVOLLER": "one who frivols, also FRIVOLER [n -S]\n",
  "FRIVOLLERS": "FRIVOLLER, one who frivols, also FRIVOLER [n]\n",
  "FRIVOLLING": "FRIVOL, to behave playfully [v]\n",
  "FRIVOLOUS": "lacking seriousness [adj FRIVOLOUSLY]\n",
  "FRIVOLOUSLY": "FRIVOLOUS, lacking seriousness [adv]\n",
  "FRIVOLOUSNESS": "FRIVOLOUS, lacking seriousness [n]\n",
  "FRIVOLOUSNESSES": "FRIVOLOUSNESS, FRIVOLOUS, lacking seriousness [n]\n",
  "FRIVOLS": "FRIVOL, to behave playfully [v]\n",
  "FRIZ": "to curl hair tightly, also FRIZZ, FRIZZLE [v -ED, -ING, -ES]\n",
  "FRIZADO": "(Spanish) a fine friezelike fabric [n -S]\n",
  "FRIZADOS": "FRIZADO, (Spanish) a fine friezelike fabric [n]\n",
  "FRIZE": "(obsolete) to freeze [v FRIZED, FRIZING, FRIZES]\n",
  "FRIZED": "FRIZ, to curl hair tightly, also FRIZZ, FRIZZLE [v]\n",
  "FRIZER": "one that frizzes, also FRIZZER [n -S]\n",
  "FRIZERS": "FRIZER, one that frizzes, also FRIZZER [n]\n",
  "FRIZES": "FRIZ, to curl hair tightly, also FRIZZ, FRIZZLE [v]\n",
  "FRIZETTE": "(French) a frizzed fringe of hair, also FRISETTE [n -S]\n",
  "FRIZETTES": "FRIZETTE, (French) a frizzed fringe of hair, also FRISETTE [n]\n",
  "FRIZING": "FRIZ, to curl hair tightly, also FRIZZ, FRIZZLE [v]\n",
  "FRIZZ": "to curl hair tightly, also FRIZ, FRIZZLE [v -ED, -ING, -ES]\n",
  "FRIZZANTE": "(Italian) of wine, sparkling [adj]\n",
  "FRIZZED": "FRIZZ, to curl hair tightly, also FRIZ, FRIZZLE [v]\n",
  "FRIZZER": "one that frizzes, also FRIZER [n -S]\n",
  "FRIZZERS": "FRIZZER, one that frizzes, also FRIZER [n]\n",
  "FRIZZES": "FRIZZ, to curl hair tightly, also FRIZ, FRIZZLE [v]\n",
  "FRIZZIER": "FRIZZY, of hair, tightly curled [adj]\n",
  "FRIZZIES": "frizzy hair, as in 'a bad case of the frizzies' [n]\n",
  "FRIZZIEST": "FRIZZY, of hair, tightly curled [adj]\n",
  "FRIZZILY": "FRIZZY, of hair, tightly curled [adv]\n",
  "FRIZZINESS": "the state of being frizzy [n -ES]\n",
  "FRIZZINESSES": "FRIZZINESS, the state of being frizzy [n]\n",
  "FRIZZING": "FRIZZ, to curl hair tightly, also FRIZ, FRIZZLE [v]\n",
  "FRIZZLE": "to curl hair tightly, also FRIZZ, FRIZ [v FRIZZLED, FRIZZLING, FRIZZLES]\n",
  "FRIZZLED": "FRIZZLE, to curl hair tightly, also FRIZZ, FRIZ [v]\n",
  "FRIZZLER": "one who frizzles [n -S]\n",
  "FRIZZLERS": "FRIZZLER, one who frizzles [n]\n",
  "FRIZZLES": "FRIZZLE, to curl hair tightly, also FRIZZ, FRIZ [v]\n",
  "FRIZZLIER": "FRIZZLY, of hair, tightly curled, also FRIZZY [adj]\n",
  "FRIZZLIEST": "FRIZZLY, of hair, tightly curled, also FRIZZY [adj]\n",
  "FRIZZLINESS": "the state of being frizzly [n -ES]\n",
  "FRIZZLINESSES": "FRIZZLINESS, the state of being frizzly [n]\n",
  "FRIZZLING": "FRIZZLE, to curl hair tightly, also FRIZZ, FRIZ [v]\n",
  "FRIZZLY": "of hair, tightly curled, also FRIZZY [adj FRIZZLIER, FRIZZLIEST]\n",
  "FRIZZY": "of hair, tightly curled [adj FRIZZIER, FRIZZIEST, FRIZZILY] / a frizzy hairdo [n FRIZZIES]\n",
  "FRO": "an African hairstyle, also AFRO [n -S]\n",
  "FROCK": "to invest with priestly office [v -ED, -ING, -S]\n",
  "FROCKED": "FROCK, to invest with priestly office [v]\n",
  "FROCKING": "cloth suitable for frocks [n -S]\n",
  "FROCKINGS": "FROCKING, cloth suitable for frocks [n]\n",
  "FROCKLESS": "destitute of a frock [adj]\n",
  "FROCKS": "FROCK, to invest with priestly office [v]\n",
  "FROE": "a cleaving tool with its blade at right angles to its handle [n -S]\n",
  "FROES": "FROE, a cleaving tool with its blade at right angles to its handle [n]\n",
  "FROG": "to hunt for frogs, webfooted, tailless amphibians [v FROGGED, FROGGING, FROGS]\n",
  "FROGBIT": "a kind of water-plant with roundish leaves and small white flowers [n -S]\n",
  "FROGBITS": "FROGBIT, a kind of water-plant with roundish leaves and small white flowers [n]\n",
  "FROGEYE": "a plant disease [n -S]\n",
  "FROGEYED": "having frog eyes [adj]\n",
  "FROGEYES": "FROGEYE, a plant disease [n]\n",
  "FROGFISH": "a marine fish [n -ES]\n",
  "FROGFISHES": "FROGFISH, a marine fish [n]\n",
  "FROGGED": "FROG, to hunt for frogs, webfooted, tailless amphibians [v]\n",
  "FROGGERIES": "FROGGERY, a place where frogs are kept [n]\n",
  "FROGGERY": "a place where frogs are kept [n FROGGERIES]\n",
  "FROGGIER": "FROGGY, abounding in frogs [adj]\n",
  "FROGGIEST": "FROGGY, abounding in frogs [adj]\n",
  "FROGGING": "a decoration of braid or lace [n -S]\n",
  "FROGGINGS": "FROGGING, a decoration of braid or lace [n]\n",
  "FROGGY": "abounding in frogs [adj FROGGIER, FROGGIEST]\n",
  "FROGHOPPER": "a froth-fly, aka spittlebug [n -S]\n",
  "FROGHOPPERS": "FROGHOPPER, a froth-fly, aka spittlebug [n]\n",
  "FROGLET": "a small frog, also FROGLING [n -S]\n",
  "FROGLETS": "FROGLET, a small frog, also FROGLING [n]\n",
  "FROGLIKE": "like a frog [adj]\n",
  "FROGLING": "a small frog, also FROGLET [n -S]\n",
  "FROGLINGS": "FROGLING, a small frog, also FROGLET [n]\n",
  "FROGMAN": "a person equipped for extended periods of underwater swimming [n FROGMEN]\n",
  "FROGMARCH": "to force a person to walk with arms pinned behind the back [v -ED, -ING, -ES]\n",
  "FROGMARCHED": "FROGMARCH, to force a person to walk with arms pinned behind the back [v]\n",
  "FROGMARCHES": "FROGMARCH, to force a person to walk with arms pinned behind the back [v]\n",
  "FROGMARCHING": "FROGMARCH, to force a person to walk with arms pinned behind the back [v]\n",
  "FROGMEN": "FROGMAN, a person equipped for extended periods of underwater swimming [n]\n",
  "FROGMOUTH": "one of several species of Asiatic and East Indian birds, so called from their very broad, flat bills [n -S]\n",
  "FROGMOUTHS": "FROGMOUTH, one of several species of Asiatic and East Indian birds, so called from their very broad, flat bills [n]\n",
  "FROGS": "FROG, to hunt for frogs, webfooted, tailless amphibians [v]\n",
  "FROGSPAWN": "the gelatinous egg mass of a frog [n -S]\n",
  "FROGSPAWNS": "FROGSPAWN, the gelatinous egg mass of a frog [n]\n",
  "FROIDEUR": "(French) coolness in personal relationships [n -S]\n",
  "FROIDEURS": "FROIDEUR, (French) coolness in personal relationships [n]\n",
  "FROING": "as in toing and froing, going back and forth [n -S]\n",
  "FROINGS": "FROING, as in toing and froing, going back and forth [n]\n",
  "FROISE": "a thick pancake, with slices of bacon [n -S]\n",
  "FROISES": "FROISE, a thick pancake, with slices of bacon [n]\n",
  "FROLIC": "to play and run about merrily [v FROLICKED, FROLICKING, FROLICS]\n",
  "FROLICKED": "FROLIC, to play and run about merrily [v]\n",
  "FROLICKER": "one who frolics [n -S]\n",
  "FROLICKERS": "FROLICKER, one who frolics [n]\n",
  "FROLICKIER": "FROLICKY, frolicsome [adj]\n",
  "FROLICKIEST": "FROLICKY, frolicsome [adj]\n",
  "FROLICKING": "FROLIC, to play and run about merrily [v]\n",
  "FROLICKY": "frolicsome [adj FROLICKIER, FROLICKIEST]\n",
  "FROLICS": "FROLIC, to play and run about merrily [v]\n",
  "FROLICSOME": "given to pranks; sportive [adj FROLICSOMELY]\n",
  "FROLICSOMELY": "FROLICSOME, given to pranks; sportive [adv]\n",
  "FROLICSOMENESS": "FROLICSOME, given to pranks; sportive [n]\n",
  "FROM": "starting at [prep]\n",
  "FROMAGE": "(French) cheese [n -S]\n",
  "FROMAGES": "FROMAGE, (French) cheese [n]\n",
  "FROMENTIES": "FROMENTY, a wheat dish boiled in milk and sweetened, also FRUMENTY, FURMENTY, FURMETY, FURMITY [n]\n",
  "FROMENTY": "a wheat dish boiled in milk and sweetened, also FRUMENTY, FURMENTY, FURMETY, FURMITY [n FROMENTIES]\n",
  "FROND": "a type of leaf [n -S]\n",
  "FRONDAGE": "fronds collectively [n -S]\n",
  "FRONDAGES": "FRONDAGE, fronds collectively [n]\n",
  "FRONDED": "having a frond [adj]\n",
  "FRONDENT": "leafy [adj]\n",
  "FRONDESCENCE": "the formation of leaves [n -S]\n",
  "FRONDESCENCES": "FRONDESCENCE, the formation of leaves [n]\n",
  "FRONDESCENT": "leafy, having a profusion of fronds [adj]\n",
  "FRONDEUR": "(French) a member of the Fronde, a rebellious movement established in France during the reign of Louis XIV [n -S]\n",
  "FRONDEURS": "FRONDEUR, (French) a member of the Fronde, a rebellious movement established in France during the reign of Louis XIV [n]\n",
  "FRONDIFEROUS": "bearing or producing fronds [adj]\n",
  "FRONDLESS": "without fronds [adj]\n",
  "FRONDOSE": "having fronds, also FRONDOUS [adj]\n",
  "FRONDOUS": "having fronds, also FRONDOSE [adj]\n",
  "FRONDS": "FROND, a type of leaf [n]\n",
  "FRONS": "(Latin) the forehead; the part of the cranium between the orbits and the vertex [n FRONTES]\n",
  "FRONT": "to the fore [adj FRONTER, FRONTEST] / to present [v -ED, -ING, -S]\n",
  "FRONTAGE": "the front of a building [n -S]\n",
  "FRONTAGER": "a person who owns or occupies property along a road or river [n -S]\n",
  "FRONTAGERS": "FRONTAGER, a person who owns or occupies property along a road or river [n]\n",
  "FRONTAGES": "FRONTAGE, the front of a building [n]\n",
  "FRONTAL": "at the front [adj FRONTALLY] / a cloth hanging over front of altar [n -S]\n",
  "FRONTALITIES": "FRONTALITY, the state of being frontal [n]\n",
  "FRONTALITY": "the state of being frontal [n FRONTALITIES]\n",
  "FRONTALLY": "FRONTAL, at the front [adv]\n",
  "FRONTALS": "FRONTAL, a cloth hanging over front of altar [n]\n",
  "FRONTBENCHER": "one who sits on the front benches in Parliament [n -S]\n",
  "FRONTBENCHERS": "FRONTBENCHER, one who sits on the front benches in Parliament [n]\n",
  "FRONTCOURT": "a basketball team's offensive half of the court [n -S]\n",
  "FRONTCOURTS": "FRONTCOURT, a basketball team's offensive half of the court [n]\n",
  "FRONTED": "FRONT, to present [v]\n",
  "FRONTENIS": "a racket used in a Basque ball game [n -ES]\n",
  "FRONTENISES": "FRONTENIS, a racket used in a Basque ball game [n]\n",
  "FRONTER": "a three-year-old animal, esp. a sheep [n -S]\n",
  "FRONTERS": "FRONTER, a three-year-old animal, esp. a sheep [n]\n",
  "FRONTES": "FRONS, (Latin) the forehead; the part of the cranium between the orbits and the vertex [n]\n",
  "FRONTEST": "FRONT, to the fore [adj]\n",
  "FRONTIER": "a border between two countries [n -S] / (Spenser) to border [v -ED, -ING, -S]\n",
  "FRONTIERED": "FRONTIER, (Spenser) to border [v]\n",
  "FRONTIERING": "FRONTIER, (Spenser) to border [v]\n",
  "FRONTIERS": "FRONTIER, (Spenser) to border [v]\n",
  "FRONTIERSMAN": "a person who lives or works on a frontier [n FRONTIERSMEN]\n",
  "FRONTIERSMEN": "FRONTIERSMAN, a person who lives or works on a frontier [n]\n",
  "FRONTIERSWOMAN": "a female person who lives or works on a frontier [n FRONTIERSWOMEN]\n",
  "FRONTIERSWOMEN": "FRONTIERSWOMAN, a female person who lives or works on a frontier [n]\n",
  "FRONTING": "FRONT, to present [v]\n",
  "FRONTISPIECE": "an illustration at the front of a book facing the title-page [n -S] / to provide with a frontispiece [v FRONTISPIECED, FRONTISPIECING, FRONTISPIECES]\n",
  "FRONTISPIECED": "FRONTISPIECE, to provide with a frontispiece [v]\n",
  "FRONTISPIECES": "FRONTISPIECE, an illustration at the front of a book facing the title-page [n]\n",
  "FRONTISPIECING": "FRONTISPIECE, to provide with a frontispiece [v]\n",
  "FRONTLESS": "shameless, brazen [adj FRONTLESSLY]\n",
  "FRONTLESSLY": "FRONTLESS, shameless, brazen [adv]\n",
  "FRONTLET": "a forehead ornament worn as a phylacteric, defending against disease [n -S]\n",
  "FRONTLETS": "FRONTLET, a forehead ornament worn as a phylacteric, defending against disease [n]\n",
  "FRONTLINE": "of or relating to the front line [adj] / a front line [n -S]\n",
  "FRONTLINES": "FRONTLINE, a front line [n]\n",
  "FRONTLIST": "a list of books about to be published [n -S]\n",
  "FRONTLISTS": "FRONTLIST, a list of books about to be published [n]\n",
  "FRONTMAN": "the presenter of a TV program [n FRONTMEN]\n",
  "FRONTMEN": "FRONTMAN, the presenter of a TV program [n]\n",
  "FRONTOGENESES": "FRONTOGENESIS, the creation of a weather front by the meeting of air currents [n]\n",
  "FRONTOGENESIS": "the creation of a weather front by the meeting of air currents [n FRONTOGENESES]\n",
  "FRONTOGENETIC": "relating to the creation of a weather front by the meeting of air currents [adj]\n",
  "FRONTOLYSES": "FRONTOLYSIS, the weakening or disappearance of a weather front [n]\n",
  "FRONTOLYSIS": "the weakening or disappearance of a weather front [n FRONTOLYSES]\n",
  "FRONTON": "(French) an area used for jai alai (a form of handball) [n -S]\n",
  "FRONTONS": "FRONTON, (French) an area used for jai alai (a form of handball) [n]\n",
  "FRONTOON": "(French) a pediment [n -S]\n",
  "FRONTOONS": "FRONTOON, (French) a pediment [n]\n",
  "FRONTPAGE": "to put on the front page of a newspaper [v FRONTPAGED, FRONTPAGING, FRONTPAGES]\n",
  "FRONTPAGED": "FRONTPAGE, to put on the front page of a newspaper [v]\n",
  "FRONTPAGES": "FRONTPAGE, to put on the front page of a newspaper [v]\n",
  "FRONTPAGING": "FRONTPAGE, to put on the front page of a newspaper [v]\n",
  "FRONTRUNNER": "the leader in an event [n -S]\n",
  "FRONTRUNNERS": "FRONTRUNNER, the leader in an event [n]\n",
  "FRONTRUNNING": "the act of being a frontrunner, the leader in an event [n -S]\n",
  "FRONTRUNNINGS": "FRONTRUNNING, the act of being a frontrunner, the leader in an event [n]\n",
  "FRONTS": "FRONT, to present [v]\n",
  "FRONTWARD": "towards the front, also FRONTWARDS [adv]\n",
  "FRONTWARDS": "towards the front, also FRONTWARD [adv]\n",
  "FRONTWAYS": "towards the front, also FRONTWISE [adv]\n",
  "FRONTWISE": "towards the front, also FRONTWAYS [adv]\n",
  "FRORE": "frozen, also FROREN, FRORN, FRORNE, FRORY [adj]\n",
  "FROREN": "frozen, also FRORE, FRORN, FRORNE, FRORY [adj]\n",
  "FRORN": "frozen, also FRORE, FROREN, FRORNE, FRORY [adj]\n",
  "FRORNE": "frozen, also FRORE, FROREN, FRORN, FRORY [adj]\n",
  "FRORY": "(Spenser) frozen, also FRORE, FROREN, FRORN, FRORNE [adj]\n",
  "FROS": "FRO, an African hairstyle, also AFRO [n]\n",
  "FROSH": "(US) a freshman [n -ES]\n",
  "FROSHES": "FROSH, (US) a freshman [n]\n",
  "FROST": "to cover with a deposit of minute ice crystals [v -ED, -ING, -S]\n",
  "FROSTBIT": "FROSTBITE, to affect with frostbite [v]\n",
  "FROSTBITE": "inflammation, sometimes leading to gangrene, in a part of the body, caused by exposure to cold [n -S] / to affect with frostbite [v FROSTBIT, FROSTBITTEN, FROSTBITING, FROSTBITES]\n",
  "FROSTBITES": "FROSTBITE, to affect with frostbite [v]\n",
  "FROSTBITING": "the act of frostbiting [n -S]\n",
  "FROSTBITINGS": "FROSTBITING, the act of frostbiting [n]\n",
  "FROSTBITTEN": "FROSTBITE, to affect with frostbite [v]\n",
  "FROSTBOUND": "bound or confined by frost [adj]\n",
  "FROSTED": "a type of milk shake [n -S]\n",
  "FROSTEDS": "FROSTED, a type of milk shake [n]\n",
  "FROSTFISH": "an American fish appearing in frosty weather [n -ES]\n",
  "FROSTFISHES": "FROSTFISH, an American fish appearing in frosty weather [n]\n",
  "FROSTIER": "FROSTY, covered with frost [adj]\n",
  "FROSTIEST": "FROSTY, covered with frost [adj]\n",
  "FROSTILY": "FROSTY, covered with frost [adv]\n",
  "FROSTINESS": "the state of being frosty [n -ES]\n",
  "FROSTINESSES": "FROSTINESS, the state of being frosty [n]\n",
  "FROSTING": "icing [n -S]\n",
  "FROSTINGS": "FROSTING, icing [n]\n",
  "FROSTLESS": "without frost [adj]\n",
  "FROSTLIKE": "like frost [adj]\n",
  "FROSTLINE": "the depth to which the ground freezes in winter [n -S]\n",
  "FROSTLINES": "FROSTLINE, the depth to which the ground freezes in winter [n]\n",
  "FROSTNIP": "the freezing of outer skin layers [n -S]\n",
  "FROSTNIPS": "FROSTNIP, the freezing of outer skin layers [n]\n",
  "FROSTS": "FROST, to cover with a deposit of minute ice crystals [v]\n",
  "FROSTWORK": "tracery made by frost, e.g. on windows [n -S]\n",
  "FROSTWORKS": "FROSTWORK, tracery made by frost, e.g. on windows [n]\n",
  "FROSTY": "covered with frost [adj FROSTIER, FROSTIEST, FROSTILY]\n",
  "FROTH": "to foam [v -ED, -ING, -S]\n",
  "FROTHED": "FROTH, to foam [v]\n",
  "FROTHER": "one who froths [n -S]\n",
  "FROTHERIES": "FROTHERY, mere froth [n]\n",
  "FROTHERS": "FROTHER, one who froths [n]\n",
  "FROTHERY": "mere froth [n FROTHERIES]\n",
  "FROTHIER": "FROTHY, covered with froth [adj]\n",
  "FROTHIEST": "FROTHY, covered with froth [adj]\n",
  "FROTHILY": "FROTHY, covered with froth [adv]\n",
  "FROTHINESS": "the state of being frothy [n -ES]\n",
  "FROTHINESSES": "FROTHINESS, the state of being frothy [n]\n",
  "FROTHING": "the act of making a froth [n -S]\n",
  "FROTHINGS": "FROTHING, the act of making a froth [n]\n",
  "FROTHLESS": "without froth [adj]\n",
  "FROTHS": "FROTH, to foam [v]\n",
  "FROTHY": "covered with froth [adj FROTHIER, FROTHIEST, FROTHILY]\n",
  "FROTTAGE": "(French) masturbation by rubbing against another person [n -S]\n",
  "FROTTAGES": "FROTTAGE, (French) masturbation by rubbing against another person [n]\n",
  "FROTTEUR": "(French) the active participant in frottage, in the sexual sense [n -S]\n",
  "FROTTEURS": "FROTTEUR, (French) the active participant in frottage, in the sexual sense [n]\n",
  "FROUFROU": "(French) the rustling of silk; frills or decoration [n -S]\n",
  "FROUFROUS": "FROUFROU, (French) the rustling of silk; frills or decoration [n]\n",
  "FROUGHIER": "FROUGHY, of timber, soft and brittle, also FROWY [adj]\n",
  "FROUGHIEST": "FROUGHY, of timber, soft and brittle, also FROWY [adj]\n",
  "FROUGHY": "of timber, soft and brittle, also FROWY [adj FROUGHIER, FROUGHIEST]\n",
  "FROUNCE": "to wrinkle or frown [v FROUNCED, FROUNCING, FROUNCES]\n",
  "FROUNCED": "FROUNCE, to wrinkle or frown [v]\n",
  "FROUNCES": "FROUNCE, to wrinkle or frown [v]\n",
  "FROUNCING": "FROUNCE, to wrinkle or frown [v]\n",
  "FROUZIER": "FROUZY, fusty, stuffy, also FROWSTY, FROWSY, FROWZY [adj]\n",
  "FROUZIEST": "FROUZY, fusty, stuffy, also FROWSTY, FROWSY, FROWZY [adj]\n",
  "FROUZILY": "FROUZY, fusty, stuffy, also FROWSTY, FROWSY, FROWZY [adv]\n",
  "FROUZINESS": "the state of being frouzy, fusty, stuffy [n -ES]\n",
  "FROUZINESSES": "FROUZINESS, the state of being frouzy, fusty, stuffy [n]\n",
  "FROUZY": "fusty, stuffy, also FROWSTY, FROWSY, FROWZY [adj FROUZIER, FROUZIEST; FROUZILY]\n",
  "FROW": "(Dutch) a woman, goodwife, also VROU, VROUW, VROW [n -S]\n",
  "FROWARD": "(archaic) habitually disposed to disobedience and opposition [adj FROWARDLY]\n",
  "FROWARDLY": "FROWARD, (archaic) habitually disposed to disobedience and opposition [adv]\n",
  "FROWARDNESS": "the state of being froward [n -ES]\n",
  "FROWARDNESSES": "FROWARDNESS, the state of being froward [n]\n",
  "FROWARDS": "away from [prep]\n",
  "FROWIE": "(Spenser) musty, rancid, also FROUGHY, FROWY [adj FROWIER, FROWIEST]\n",
  "FROWIER": "FROWIE, (Spenser) musty, rancid, also FROUGHY, FROWY [adj]\n",
  "FROWIEST": "FROWIE, (Spenser) musty, rancid, also FROUGHY, FROWY [adj]\n",
  "FROWN": "to wrinkle the brow with displeasure [v -ED, -ING, -S]\n",
  "FROWNED": "FROWN, to wrinkle the brow with displeasure [v]\n",
  "FROWNER": "one who frowns [n -S]\n",
  "FROWNERS": "FROWNER, one who frowns [n]\n",
  "FROWNIER": "FROWNY, showing a frown [adj]\n",
  "FROWNIEST": "FROWNY, showing a frown [adj]\n",
  "FROWNING": "FROWN, to wrinkle the brow with displeasure [v]\n",
  "FROWNINGLY": "FROWNING, FROWN, to wrinkle the brow with displeasure [adv]\n",
  "FROWNS": "FROWN, to wrinkle the brow with displeasure [v]\n",
  "FROWNY": "showing a frown [adj FROWNIER, FROWNIEST]\n",
  "FROWS": "FROW, (Dutch) a woman, goodwife, also VROU, VROUW, VROW [n]\n",
  "FROWSIER": "FROWSY, fusty, stuffy, also FROUZY, FROWSTY, FROWZY [adj]\n",
  "FROWSIEST": "FROWSY, fusty, stuffy, also FROUZY, FROWSTY, FROWZY [adj]\n",
  "FROWSILY": "FROWSY, fusty, stuffy, also FROUZY, FROWSTY, FROWZY [adv]\n",
  "FROWSINESS": "the state of being frowsy, fusty, stuffy [n -ES]\n",
  "FROWSINESSES": "FROWSINESS, the state of being frowsy, fusty, stuffy [n]\n",
  "FROWST": "to luxuriate in hot stuffiness [v -ED, -ING, -S]\n",
  "FROWSTED": "FROWST, to luxuriate in hot stuffiness [v]\n",
  "FROWSTER": "(obsolete) one who frowsts [n -S]\n",
  "FROWSTERS": "FROWSTER, (obsolete) one who frowsts [n]\n",
  "FROWSTIER": "FROWSTY, fusty, stuffy, also FROUZY, FROWSY, FROWZY [adj]\n",
  "FROWSTIEST": "FROWSTY, fusty, stuffy, also FROUZY, FROWSY, FROWZY [adj]\n",
  "FROWSTINESS": "the state of being frowsty [n -ES]\n",
  "FROWSTINESSES": "FROWSTINESS, the state of being frowsty [n]\n",
  "FROWSTING": "FROWST, to luxuriate in hot stuffiness [v]\n",
  "FROWSTS": "FROWST, to luxuriate in hot stuffiness [v]\n",
  "FROWSTY": "fusty, stuffy, also FROUZY, FROWSY, FROWZY [adj FROWSTIER, FROWSTIEST]\n",
  "FROWSY": "fusty, stuffy, also FROUZY, FROWSTY, FROWZY [adj FROWSIER, FROWSIEST; FROWSILY]\n",
  "FROWY": "musty, rancid, also FROUGHY, FROWIE [adj FROWIER, FROWIEST]\n",
  "FROWZIER": "FROWZY, fusty, stuffy, also FROUZY, FROWSTY, FROWSY [adj]\n",
  "FROWZIEST": "FROWZY, fusty, stuffy, also FROUZY, FROWSTY, FROWSY [adj]\n",
  "FROWZILY": "FROWZY, fusty, stuffy, also FROUZY, FROWSTY, FROWSY [adv]\n",
  "FROWZINESS": "the state of being frowzy, fusty, stuffy [n -ES]\n",
  "FROWZINESSES": "FROWZINESS, the state of being frowzy, fusty, stuffy [n]\n",
  "FROWZY": "fusty, stuffy, also FROUZY, FROWSTY, FROWSY [adj FROWZIER, FROWZIEST, FROWZILY]\n",
  "FROZE": "FREEZE, to turn into a solid by lowering the temperature [v]\n",
  "FROZEN": "FREEZE, to turn into a solid by lowering the temperature [v]\n",
  "FROZENLY": "FROZEN, FREEZE, to turn into a solid by lowering the temperature [adv]\n",
  "FROZENNESS": "the state of being frozen [n -ES]\n",
  "FROZENNESSES": "FROZENNESS, the state of being frozen [n]\n",
  "FRUCTAN": "a type of polymer of fructose, present in certain fruits [n -S]\n",
  "FRUCTANS": "FRUCTAN, a type of polymer of fructose, present in certain fruits [n]\n",
  "FRUCTED": "bearing fruit, said of a tree or plant so represented upon an escutcheon [adj]\n",
  "FRUCTIFEROUS": "bearing fruit [adj FRUCTIFEROUSLY]\n",
  "FRUCTIFEROUSLY": "FRUCTIFEROUS, bearing fruit [adv]\n",
  "FRUCTIFICATION": "the reproductive organs or fruit of a plant [n -S]\n",
  "FRUCTIFICATIONS": "FRUCTIFICATION, the reproductive organs or fruit of a plant [n]\n",
  "FRUCTIFIED": "FRUCTIFY, to bear fruit [v]\n",
  "FRUCTIFIER": "one who fructifies [n -S]\n",
  "FRUCTIFIERS": "FRUCTIFIER, one who fructifies [n]\n",
  "FRUCTIFIES": "FRUCTIFY, to bear fruit [v]\n",
  "FRUCTIFY": "to bear fruit [v FRUCTIFIED, FRUCTIFYING, FRUCTIFIES]\n",
  "FRUCTIFYING": "FRUCTIFY, to bear fruit [v]\n",
  "FRUCTIVE": "productive or fruitful [adj]\n",
  "FRUCTIVOROUS": "feeding on fruit [adj]\n",
  "FRUCTOSE": "a sugar found in various fruits [n -S]\n",
  "FRUCTOSES": "FRUCTOSE, a sugar found in various fruits [n]\n",
  "FRUCTUARIES": "FRUCTUARY, a person enjoying the fruits of anything [n]\n",
  "FRUCTUARY": "a person enjoying the fruits of anything [n FRUCTUARIES]\n",
  "FRUCTUATE": "to come to fruit, to fructify [v FRUCTUATED, FRUCTUATING, FRUCTUATES]\n",
  "FRUCTUATED": "FRUCTUATE, to come to fruit, to fructify [v]\n",
  "FRUCTUATES": "FRUCTUATE, to come to fruit, to fructify [v]\n",
  "FRUCTUATING": "FRUCTUATE, to come to fruit, to fructify [v]\n",
  "FRUCTUATION": "coming to fruit or bearing of fruit [n -S]\n",
  "FRUCTUATIONS": "FRUCTUATION, coming to fruit or bearing of fruit [n]\n",
  "FRUCTUOUS": "fruitful [adj FRUCTUOUSLY]\n",
  "FRUCTUOUSLY": "FRUCTUOUS, fruitful [adv]\n",
  "FRUCTUOUSNESS": "FRUCTUOUS, fruitful [n]\n",
  "FRUCTUOUSNESSES": "FRUCTUOUSNESS, FRUCTUOUS, fruitful [n]\n",
  "FRUG": "to perform a type of vigorous dance [v FRUGGED, FRUGGING, FRUGS]\n",
  "FRUGAL": "characterized by or reflecting economy in the use of resources [adj FRUGALLY]\n",
  "FRUGALIST": "a person who is frugal [n -S]\n",
  "FRUGALISTA": "a person who tries to stay fashionably dressed on a budget [n -S]\n",
  "FRUGALISTAS": "FRUGALISTA, a person who tries to stay fashionably dressed on a budget [n]\n",
  "FRUGALISTS": "FRUGALIST, a person who is frugal [n]\n",
  "FRUGALITIES": "FRUGALITY, the state of being frugal [n]\n",
  "FRUGALITY": "the state of being frugal [n FRUGALITIES]\n",
  "FRUGALLY": "FRUGAL, characterized by or reflecting economy in the use of resources [adv]\n",
  "FRUGALNESS": "the state of being frugal [n -ES]\n",
  "FRUGALNESSES": "FRUGALNESS, the state of being frugal [n]\n",
  "FRUGGED": "FRUG, to perform a type of vigorous dance [v]\n",
  "FRUGGING": "FRUG, to perform a type of vigorous dance [v]\n",
  "FRUGIFEROUS": "bearing fruit [adj]\n",
  "FRUGIVORE": "an animal which primarily eats fruit [n -S]\n",
  "FRUGIVORES": "FRUGIVORE, an animal which primarily eats fruit [n]\n",
  "FRUGIVOROUS": "eating fruit [adj]\n",
  "FRUGS": "FRUG, to perform a type of vigorous dance [v]\n",
  "FRUICT": "(obsolete) fruit [n -S]\n",
  "FRUICTS": "FRUICT, (obsolete) fruit [n]\n",
  "FRUIT": "to produce an edible part of a plant [v -ED, -ING, -S]\n",
  "FRUITAGE": "the process of bearing fruit [n -S]\n",
  "FRUITAGES": "FRUITAGE, the process of bearing fruit [n]\n",
  "FRUITARIAN": "a person who lives on fruit [n -S]\n",
  "FRUITARIANISM": "the state of being a fruitarian, eating only fruit [n -S]\n",
  "FRUITARIANISMS": "FRUITARIANISM, the state of being a fruitarian, eating only fruit [n]\n",
  "FRUITARIANS": "FRUITARIAN, a person who lives on fruit [n]\n",
  "FRUITCAKE": "(colloquial) a slightly mad person [n -S]\n",
  "FRUITCAKES": "FRUITCAKE, (colloquial) a slightly mad person [n]\n",
  "FRUITED": "FRUIT, to produce an edible part of a plant [v]\n",
  "FRUITER": "one who grows or sells fruit [n -S]\n",
  "FRUITERER": "one who sells fruit [n -S]\n",
  "FRUITERERS": "FRUITERER, one who sells fruit [n]\n",
  "FRUITERESS": "a woman who sells fruit [n -ES]\n",
  "FRUITERESSES": "FRUITERESS, a woman who sells fruit [n]\n",
  "FRUITERIES": "FRUITERY, a place for storing fruit [n]\n",
  "FRUITERS": "FRUITER, one who grows or sells fruit [n]\n",
  "FRUITERY": "a place for storing fruit [n FRUITERIES]\n",
  "FRUITFUL": "productive [adj FRUITFULLER, FRUITFULLEST, FRUITFULLY]\n",
  "FRUITFULLER": "FRUITFUL, productive [adj]\n",
  "FRUITFULLEST": "FRUITFUL, productive [adj]\n",
  "FRUITFULLY": "FRUITFUL, productive [adv]\n",
  "FRUITFULNESS": "the state of being fruitful [n -ES]\n",
  "FRUITFULNESSES": "FRUITFULNESS, the state of being fruitful [n]\n",
  "FRUITIER": "FRUITY, tasting of fruit [adj]\n",
  "FRUITIEST": "FRUITY, tasting of fruit [adj]\n",
  "FRUITILY": "FRUITY, tasting of fruit [adv]\n",
  "FRUITINESS": "the state of being fruity [n -ES]\n",
  "FRUITINESSES": "FRUITINESS, the state of being fruity [n]\n",
  "FRUITING": "the stage of producing fruit [n -S]\n",
  "FRUITINGS": "FRUITING, the stage of producing fruit [n]\n",
  "FRUITION": "a fulfilment of something desired [n -S]\n",
  "FRUITIONS": "FRUITION, a fulfilment of something desired [n]\n",
  "FRUITIVE": "coming to fruition [adj]\n",
  "FRUITLESS": "futile [adj FRUITLESSLY]\n",
  "FRUITLESSLY": "FRUITLESS, futile [adv]\n",
  "FRUITLESSNESS": "FRUITLESS, futile [n]\n",
  "FRUITLESSNESSES": "FRUITLESSNESS, FRUITLESS, futile [n]\n",
  "FRUITLET": "a small fruit [n -S]\n",
  "FRUITLETS": "FRUITLET, a small fruit [n]\n",
  "FRUITLIKE": "like a fruit [adj]\n",
  "FRUITS": "FRUIT, to produce an edible part of a plant [v]\n",
  "FRUITWOOD": "the wood of a fruit tree [n -S]\n",
  "FRUITWOODS": "FRUITWOOD, the wood of a fruit tree [n]\n",
  "FRUITWORM": "any of numerous insect larvae mainly of the orders Diptera and Lepidoptera that feed on or in fruits [n -S]\n",
  "FRUITWORMS": "FRUITWORM, any of numerous insect larvae mainly of the orders Diptera and Lepidoptera that feed on or in fruits [n]\n",
  "FRUITY": "tasting of fruit [adj FRUITIER, FRUITIEST, FRUITILY]\n",
  "FRUMENTACEOUS": "resembling wheat or other grain [adj]\n",
  "FRUMENTARIOUS": "of or pertaining to corn [adj]\n",
  "FRUMENTATION": "a gift of grain bestowed on starving or rebellious people in ancient Rome [n -S]\n",
  "FRUMENTATIONS": "FRUMENTATION, a gift of grain bestowed on starving or rebellious people in ancient Rome [n]\n",
  "FRUMENTIES": "FRUMENTY, a wheat dish boiled in milk and sweetened, also FROMENTY, FURMENTY, FURMETY, FURMITY [n]\n",
  "FRUMENTY": "a wheat dish boiled in milk and sweetened, also FROMENTY, FURMENTY, FURMETY, FURMITY [n FRUMENTIES]\n",
  "FRUMP": "(obsolete) to snub [v -ED, -ING, -S]\n",
  "FRUMPED": "FRUMP, (obsolete) to snub [v]\n",
  "FRUMPIER": "FRUMPY, ill-dressed or dowdy [adj]\n",
  "FRUMPIEST": "FRUMPY, ill-dressed or dowdy [adj]\n",
  "FRUMPILY": "FRUMPY, ill-dressed or dowdy [adv]\n",
  "FRUMPINESS": "the state of being frumpy [n -ES]\n",
  "FRUMPINESSES": "FRUMPINESS, the state of being frumpy [n]\n",
  "FRUMPING": "FRUMP, (obsolete) to snub [v]\n",
  "FRUMPISH": "somewhat like a frump [adj FRUMPISHLY]\n",
  "FRUMPISHLY": "FRUMPISH, somewhat like a frump [adv]\n",
  "FRUMPISHNESS": "the state of being frumpish [n -ES]\n",
  "FRUMPISHNESSES": "FRUMPISHNESS, the state of being frumpish [n]\n",
  "FRUMPLE": "(dialect) to wrinkle [v FRUMPLED, FRUMPLING, FRUMPLES]\n",
  "FRUMPLED": "FRUMPLE, (dialect) to wrinkle [v]\n",
  "FRUMPLES": "FRUMPLE, (dialect) to wrinkle [v]\n",
  "FRUMPLING": "FRUMPLE, (dialect) to wrinkle [v]\n",
  "FRUMPS": "FRUMP, (obsolete) to snub [v]\n",
  "FRUMPY": "ill-dressed or dowdy [adj FRUMPIER, FRUMPIEST, FRUMPILY]\n",
  "FRUSEMIDE": "a synthetic diuretic drug used esp. in treating oedema, also FUROSEMIDE [n -S]\n",
  "FRUSEMIDES": "FRUSEMIDE, a synthetic diuretic drug used esp. in treating oedema, also FUROSEMIDE [n]\n",
  "FRUSH": "(Scots) to break or bruise [v -ED, -ING, -ES]\n",
  "FRUSHED": "FRUSH, (Scots) to break or bruise [v]\n",
  "FRUSHES": "FRUSH, (Scots) to break or bruise [v]\n",
  "FRUSHING": "FRUSH, (Scots) to break or bruise [v]\n",
  "FRUST": "a fragment [n -S]\n",
  "FRUSTA": "FRUSTUM, (Latin) a cone with its top cut of [n]\n",
  "FRUSTRATE": "to thwart [v FRUSTRATED, FRUSTRATING, FRUSTRATES]\n",
  "FRUSTRATED": "FRUSTRATE, to thwart [v]\n",
  "FRUSTRATER": "one who frustrates [n -S]\n",
  "FRUSTRATERS": "FRUSTRATER, one who frustrates [n]\n",
  "FRUSTRATES": "FRUSTRATE, to thwart [v]\n",
  "FRUSTRATING": "FRUSTRATE, to thwart [v]\n",
  "FRUSTRATINGLY": "FRUSTRATING, FRUSTRATE, to thwart [adv]\n",
  "FRUSTRATION": "the act of frustrating [n -S]\n",
  "FRUSTRATIONS": "FRUSTRATION, the act of frustrating [n]\n",
  "FRUSTS": "FRUST, a fragment [n]\n",
  "FRUSTULE": "the siliceous two-valved shell of a diatom [n -S]\n",
  "FRUSTULES": "FRUSTULE, the siliceous two-valved shell of a diatom [n]\n",
  "FRUSTUM": "(Latin) a cone with its top cut of [n FRUSTUMS or FRUSTA]\n",
  "FRUSTUMS": "FRUSTUM, (Latin) a cone with its top cut of [n]\n",
  "FRUTESCENCE": "the appearance or habit of a shrub [n -S]\n",
  "FRUTESCENCES": "FRUTESCENCE, the appearance or habit of a shrub [n]\n",
  "FRUTESCENT": "like or resembling a shrub [adj]\n",
  "FRUTEX": "(Latin) a shrub [n FRUTICES]\n",
  "FRUTICES": "FRUTEX, (Latin) a shrub [n]\n",
  "FRUTICOSE": "shrubby [adj]\n",
  "FRUTIFIED": "FRUTIFY, (Shakespeare) Launcelot Gobbo's blunder for notify [v]\n",
  "FRUTIFIES": "FRUTIFY, (Shakespeare) Launcelot Gobbo's blunder for notify [v]\n",
  "FRUTIFY": "(Shakespeare) Launcelot Gobbo's blunder for notify [v FRUTIFIED, FRUTIFYING, FRUTIFIES]\n",
  "FRUTIFYING": "FRUTIFY, (Shakespeare) Launcelot Gobbo's blunder for notify [v]\n",
  "FRY": "to cook in fat or oil [v FRIED, FRYING, FRIES]\n",
  "FRYABLE": "able to be fried [adj]\n",
  "FRYBREAD": "native American fried bread [n -S]\n",
  "FRYBREADS": "FRYBREAD, native American fried bread [n]\n",
  "FRYER": "a pan or container for frying, also FRIER [n -S]\n",
  "FRYERS": "FRYER, a pan or container for frying, also FRIER [n]\n",
  "FRYING": "the process of frying [n -S]\n",
  "FRYINGS": "FRYING, the process of frying [n]\n",
  "FRYPAN": "a pan for frying food [n -S]\n",
  "FRYPANS": "FRYPAN, a pan for frying food [n]\n",
  "FUB": "to cheat, also FOB [v FUBBED, FUBBING, FUBS]\n",
  "FUBAR": "(vulgar) totally messed up, also FOOBAR [adj]\n",
  "FUBBED": "FUB, to cheat, also FOB [v]\n",
  "FUBBERIES": "FUBBERY, a deception [n]\n",
  "FUBBERY": "a deception [n FUBBERIES]\n",
  "FUBBIER": "FUBBY, chubby and squat, also FUBSY [adj]\n",
  "FUBBIEST": "FUBBY, chubby and squat, also FUBSY [adj]\n",
  "FUBBING": "FUB, to cheat, also FOB [v]\n",
  "FUBBY": "chubby and squat, also FUBSY [adj FUBBIER, FUBBIEST]\n",
  "FUBS": "FUB, to cheat, also FOB [v]\n",
  "FUBSIER": "FUBSY, chubby, also FUBBY [adj]\n",
  "FUBSIEST": "FUBSY, chubby, also FUBBY [adj]\n",
  "FUBSY": "chubby, also FUBBY [adj FUBSIER, FUBSIEST]\n",
  "FUCHSIA": "a flowering shrub [n -S]\n",
  "FUCHSIAS": "FUCHSIA, a flowering shrub [n]\n",
  "FUCHSIN": "a red dye, also FUCHSINE [n -S]\n",
  "FUCHSINE": "a red dye, also FUCHSIN [n -S]\n",
  "FUCHSINES": "FUCHSINE, a red dye, also FUCHSIN [n]\n",
  "FUCHSINS": "FUCHSIN, a red dye, also FUCHSINE [n]\n",
  "FUCHSITE": "a brilliant green chromium mica [n -S]\n",
  "FUCHSITES": "FUCHSITE, a brilliant green chromium mica [n]\n",
  "FUCI": "FUCUS, (Latin) any of a genus of brown algae [n]\n",
  "FUCIVOROUS": "feeding on seaweed [adj]\n",
  "FUCK": "(vulgar) to copulate, also FECK [v -ED, -ING, -S]\n",
  "FUCKED": "FUCK, (vulgar) to copulate, also FECK [v]\n",
  "FUCKER": "a contemptible person [n -S]\n",
  "FUCKERS": "FUCKER, a contemptible person [n]\n",
  "FUCKFACE": "a contemptibly stupid person [n -S]\n",
  "FUCKFACES": "FUCKFACE, a contemptibly stupid person [n]\n",
  "FUCKHEAD": "(offensive) a contemptibly stupid person [n -S]\n",
  "FUCKHEADS": "FUCKHEAD, (offensive) a contemptibly stupid person [n]\n",
  "FUCKING": "sexual intercourse [n -S]\n",
  "FUCKINGS": "FUCKING, sexual intercourse [n]\n",
  "FUCKOFF": "(offensive) a time waster or shirker [n -S]\n",
  "FUCKOFFS": "FUCKOFF, (offensive) a time waster or shirker [n]\n",
  "FUCKS": "FUCK, (vulgar) to copulate, also FECK [v]\n",
  "FUCKUP": "(vulgar) something incompetently managed, a disaster [n -S]\n",
  "FUCKUPS": "FUCKUP, (vulgar) something incompetently managed, a disaster [n]\n",
  "FUCKWIT": "(offensive) a fool, an idiot [n -S]\n",
  "FUCKWITS": "FUCKWIT, (offensive) a fool, an idiot [n]\n",
  "FUCOID": "relating to seaweed, also FUCOIDAL [adj] / a seaweed of the genus Fucus, also FUCOIDAL [n -S]\n",
  "FUCOIDAL": "relating to seaweed, also FUCOID [adj]\n",
  "FUCOIDS": "FUCOID, a seaweed of the genus Fucus, also FUCOIDAL [n]\n",
  "FUCOSE": "a type of sugar [n -S]\n",
  "FUCOSES": "FUCOSE, a type of sugar [n]\n",
  "FUCOUS": "of or pertaining to fucoids, seaweeds of the genus Fucus [adj]\n",
  "FUCOXANTHIN": "a brown carotenoid pigment occurring esp. in the chloroplasts of brown algae [n -S]\n",
  "FUCOXANTHINS": "FUCOXANTHIN, a brown carotenoid pigment occurring esp. in the chloroplasts of brown algae [n]\n",
  "FUCUS": "(Latin) any of a genus of brown algae [n FUCUSES or FUCI]\n",
  "FUCUSED": "painted [adj]\n",
  "FUCUSES": "FUCUS, (Latin) any of a genus of brown algae [n]\n",
  "FUD": "a rabbit's or hare's tail [n -S]\n",
  "FUDDIER": "FUDDY, old-fashioned, dull [adj]\n",
  "FUDDIES": "FUDDY, an old-fashioned person [n]\n",
  "FUDDIEST": "FUDDY, old-fashioned, dull [adj]\n",
  "FUDDLE": "to confuse, muddle [v FUDDLED, FUDDLING, FUDDLES]\n",
  "FUDDLED": "FUDDLE, to confuse, muddle [v]\n",
  "FUDDLER": "a drunkard [n -S]\n",
  "FUDDLERS": "FUDDLER, a drunkard [n]\n",
  "FUDDLES": "FUDDLE, to confuse, muddle [v]\n",
  "FUDDLING": "the act of tippling [n -S]\n",
  "FUDDLINGS": "FUDDLING, the act of tippling [n]\n",
  "FUDDY": "old-fashioned, dull [adj FUDDIER, FUDDIEST] / an old-fashioned person [n FUDDIES]\n",
  "FUDGE": "to falsify [v FUDGED, FUDGING, FUDGES]\n",
  "FUDGED": "FUDGE, to falsify [v]\n",
  "FUDGES": "FUDGE, to falsify [v]\n",
  "FUDGIER": "FUDGY, resembling fudge (a soft, sweet candy) [adj]\n",
  "FUDGIEST": "FUDGY, resembling fudge (a soft, sweet candy) [adj]\n",
  "FUDGING": "FUDGE, to falsify [v]\n",
  "FUDGY": "resembling fudge (a soft, sweet candy) [adj FUDGIER, FUDGIEST]\n",
  "FUDS": "FUD, a rabbit's or hare's tail [n]\n",
  "FUEHRER": "(German) a leader, also FUHRER [n -S]\n",
  "FUEHRERS": "FUEHRER, (German) a leader, also FUHRER [n]\n",
  "FUEL": "to provide with an energy-producing material [v FUELED or FUELLED, FUELING or FUELLING, FUELS]\n",
  "FUELED": "FUEL, to provide with an energy-producing material [v]\n",
  "FUELER": "one who fuels, also FUELLER [n -S]\n",
  "FUELERS": "FUELER, one who fuels, also FUELLER [n]\n",
  "FUELING": "FUEL, to provide with an energy-producing material [v]\n",
  "FUELLED": "FUEL, to provide with an energy-producing material [v]\n",
  "FUELLER": "one who fuels, also FUELER [n -S]\n",
  "FUELLERS": "FUELLER, one who fuels, also FUELER [n]\n",
  "FUELLING": "FUEL, to provide with an energy-producing material [v]\n",
  "FUELS": "FUEL, to provide with an energy-producing material [v]\n",
  "FUELWOOD": "wood suitable for fuel [n -S]\n",
  "FUELWOODS": "FUELWOOD, wood suitable for fuel [n]\n",
  "FUERO": "(Spanish) a Basque law code [n -S]\n",
  "FUEROS": "FUERO, (Spanish) a Basque law code [n]\n",
  "FUFF": "to spit like a cat [v -ED, -ING, -S]\n",
  "FUFFED": "FUFF, to spit like a cat [v]\n",
  "FUFFIER": "FUFFY, (Scots) light and soft [adj]\n",
  "FUFFIEST": "FUFFY, (Scots) light and soft [adj]\n",
  "FUFFING": "FUFF, to spit like a cat [v]\n",
  "FUFFS": "FUFF, to spit like a cat [v]\n",
  "FUFFY": "(Scots) light and soft [adj FUFFIER, FUFFIEST]\n",
  "FUG": "to make hot, stuffy and close [v FUGGED, FUGGING, FUGS]\n",
  "FUGACIOUS": "lasting a short time, evanescent [adj FUGACIOUSLY]\n",
  "FUGACIOUSLY": "FUGACIOUS, lasting a short time, evanescent [adv]\n",
  "FUGACIOUSNESS": "the state of being fugacious [n -ES]\n",
  "FUGACIOUSNESSES": "FUGACIOUSNESS, the state of being fugacious [n]\n",
  "FUGACITIES": "FUGACITY, lack of enduring qualities [n]\n",
  "FUGACITY": "lack of enduring qualities [n FUGACITIES]\n",
  "FUGAL": "being in the state of a fugue [adj]\n",
  "FUGALLY": "FUGAL, being in the state of a fugue [adv]\n",
  "FUGATO": "(Italian) a fugal composition [n -S]\n",
  "FUGATOS": "FUGATO, (Italian) a fugal composition [n]\n",
  "FUGGED": "FUG, to make hot, stuffy and close [v]\n",
  "FUGGIER": "FUGGY, close, stuffy [adj]\n",
  "FUGGIEST": "FUGGY, close, stuffy [adj]\n",
  "FUGGILY": "FUGGY, close, stuffy [adv]\n",
  "FUGGINESS": "the state of being fuggy [n -ES]\n",
  "FUGGINESSES": "FUGGINESS, the state of being fuggy [n]\n",
  "FUGGING": "FUG, to make hot, stuffy and close [v]\n",
  "FUGGY": "close, stuffy [adj FUGGIER, FUGGIEST, FUGGILY]\n",
  "FUGHETTA": "(Italian) a short fugue [n -S]\n",
  "FUGHETTAS": "FUGHETTA, (Italian) a short fugue [n]\n",
  "FUGIE": "(Scots) a cock that will not fight, a runaway [n -S]\n",
  "FUGIES": "FUGIE, (Scots) a cock that will not fight, a runaway [n]\n",
  "FUGIO": "a former coin of the United States [n -S]\n",
  "FUGIOS": "FUGIO, a former coin of the United States [n]\n",
  "FUGITATION": "in Scots law, absconding from justice [n -S]\n",
  "FUGITATIONS": "FUGITATION, in Scots law, absconding from justice [n]\n",
  "FUGITIVE": "fleeing [adj FUGITIVELY] / one who flees [n -S]\n",
  "FUGITIVELY": "FUGITIVE, fleeing [adv]\n",
  "FUGITIVENESS": "the state of being fugitive [n -ES]\n",
  "FUGITIVENESSES": "FUGITIVENESS, the state of being fugitive [n]\n",
  "FUGITIVES": "FUGITIVE, one who flees [n]\n",
  "FUGITOMETER": "an instrument used for measuring the fastness to light of dyed materials [n -S]\n",
  "FUGITOMETERS": "FUGITOMETER, an instrument used for measuring the fastness to light of dyed materials [n]\n",
  "FUGLE": "(Carlyle) to act like a fugleman [v FUGLED, FUGLING, FUGLES]\n",
  "FUGLED": "FUGLE, (Carlyle) to act like a fugleman [v]\n",
  "FUGLEMAN": "(German) a soldier placed in front of the regiment while drilling to demonstrate motions and time, also FLUGELMAN [n FUGLEMEN]\n",
  "FUGLEMEN": "FUGLEMAN, (German) a soldier placed in front of the regiment while drilling to demonstrate motions and time, also FLUGELMAN [n]\n",
  "FUGLES": "FUGLE, (Carlyle) to act like a fugleman [v]\n",
  "FUGLIER": "FUGLY, (offensive) very ugly [adj]\n",
  "FUGLIEST": "FUGLY, (offensive) very ugly [adj]\n",
  "FUGLING": "FUGLE, (Carlyle) to act like a fugleman [v]\n",
  "FUGLY": "(offensive) very ugly [adj FUGLIER, FUGLIEST]\n",
  "FUGS": "FUG, to make hot, stuffy and close [v]\n",
  "FUGU": "(Japanese) a toxin-containing fish [n -S]\n",
  "FUGUE": "to compose a type of musical composition [v FUGUED, FUGUING, FUGUES]\n",
  "FUGUED": "FUGUE, to compose a type of musical composition [v]\n",
  "FUGUELIKE": "like a fugue [adj]\n",
  "FUGUES": "FUGUE, to compose a type of musical composition [v]\n",
  "FUGUING": "FUGUE, to compose a type of musical composition [v]\n",
  "FUGUIST": "one who composes fugues [n -S]\n",
  "FUGUISTS": "FUGUIST, one who composes fugues [n]\n",
  "FUGUS": "FUGU, (Japanese) a toxin-containing fish [n]\n",
  "FUHRER": "(German) a leader, also FUEHRER [n -S]\n",
  "FUHRERS": "FUHRER, (German) a leader, also FUEHRER [n]\n",
  "FUJI": "(Japanese) a silk fabric [n -S]\n",
  "FUJIS": "FUJI, (Japanese) a silk fabric [n]\n",
  "FULCRA": "FULCRUM, (Latin) a support for a lever [n]\n",
  "FULCRATE": "supported by fulcrums [adj]\n",
  "FULCRUM": "(Latin) a support for a lever [n FULCRUMS or FULCRA]\n",
  "FULCRUMS": "FULCRUM, (Latin) a support for a lever [n]\n",
  "FULFIL": "to bring about the accomplishment of, also FULFILL [v FULFILLED, FULFILLING, FULFILS]\n",
  "FULFILL": "to bring about the accomplishment of, also FULFIL [v -ED, -ING, -S]\n",
  "FULFILLED": "FULFILL, to bring about the accomplishment of, also FULFIL [v]\n",
  "FULFILLER": "one who fulfils [n -S]\n",
  "FULFILLERS": "FULFILLER, one who fulfils [n]\n",
  "FULFILLING": "the act of bringing to fulfilment [n -S]\n",
  "FULFILLINGS": "FULFILLING, the act of bringing to fulfilment [n]\n",
  "FULFILLMENT": "completion, also FULFILMENT [n -S]\n",
  "FULFILLMENTS": "FULFILLMENT, completion, also FULFILMENT [n]\n",
  "FULFILLS": "FULFILL, to bring about the accomplishment of, also FULFIL [v]\n",
  "FULFILMENT": "completion, also FULFILLMENT [n -S]\n",
  "FULFILMENTS": "FULFILMENT, completion, also FULFILLMENT [n]\n",
  "FULFILS": "FULFIL, to bring about the accomplishment of, also FULFILL [v]\n",
  "FULGENCIES": "FULGENCY, brightness [n]\n",
  "FULGENCY": "brightness [n FULGENCIES]\n",
  "FULGENT": "shining brightly, also FULGID [adj FULGENTLY]\n",
  "FULGENTLY": "FULGENT, shining brightly, also FULGID [adv]\n",
  "FULGID": "shining brightly, also FULGENT [adj]\n",
  "FULGOR": "splendour, also FULGOUR [n -S]\n",
  "FULGOROUS": "flashing like lightning, also FULGUROUS, FULGURANT [adj]\n",
  "FULGORS": "FULGOR, splendour, also FULGOUR [n]\n",
  "FULGOUR": "splendour, also FULGOR [n -S]\n",
  "FULGOURS": "FULGOUR, splendour, also FULGOR [n]\n",
  "FULGURAL": "pertaining to lightning [adj]\n",
  "FULGURANT": "flashing like lightning, also FULGOROUS, FULGUROUS [adj]\n",
  "FULGURATE": "to flash like lightning [v FULGURATED, FULGURATING, FULGURATES]\n",
  "FULGURATED": "FULGURATE, to flash like lightning [v]\n",
  "FULGURATES": "FULGURATE, to flash like lightning [v]\n",
  "FULGURATING": "FULGURATE, to flash like lightning [v]\n",
  "FULGURATION": "the act of flashing like lightning [n -S]\n",
  "FULGURATIONS": "FULGURATION, the act of flashing like lightning [n]\n",
  "FULGURITE": "a vitrified sand tube produced by the striking of lightning on sand [n -S]\n",
  "FULGURITES": "FULGURITE, a vitrified sand tube produced by the striking of lightning on sand [n]\n",
  "FULGUROUS": "flashing like lightning, also FULGOROUS, FULGURANT [adj]\n",
  "FULHAM": "a loaded die, also FULLAM, FULLAN [n -S]\n",
  "FULHAMS": "FULHAM, a loaded die, also FULLAM, FULLAN [n]\n",
  "FULIGINOSITIES": "FULIGINOSITY, the state of being fuliginous [n]\n",
  "FULIGINOSITY": "the state of being fuliginous [n FULIGINOSITIES]\n",
  "FULIGINOUS": "sooty; having a dark or dusky color [adj FULIGINOUSLY]\n",
  "FULIGINOUSLY": "FULIGINOUS, sooty; having a dark or dusky color [adv]\n",
  "FULIGINOUSNESS": "FULIGINOUS, sooty; having a dark or dusky color [n]\n",
  "FULL": "to shrink and thicken, as cloth [v -ED, -ING, -S] / filled completely [adj FULLER, FULLEST, FULLY]\n",
  "FULLAGE": "a charge for fulling cloth [n -S]\n",
  "FULLAGES": "FULLAGE, a charge for fulling cloth [n]\n",
  "FULLAM": "a loaded die, also FULHAM, FULLAN [n -S]\n",
  "FULLAMS": "FULLAM, a loaded die, also FULHAM, FULLAN [n]\n",
  "FULLAN": "a loaded die, also FULHAM, FULLAM [n -S]\n",
  "FULLANS": "FULLAN, a loaded die, also FULHAM, FULLAM [n]\n",
  "FULLBACK": "an offensive back in football [n -S]\n",
  "FULLBACKS": "FULLBACK, an offensive back in football [n]\n",
  "FULLBLOOD": "a person of unmixed race [n -S]\n",
  "FULLBLOODS": "FULLBLOOD, a person of unmixed race [n]\n",
  "FULLED": "FULL, to shrink and thicken, as cloth [v]\n",
  "FULLER": "to groove with a type of hammer [v -ED, -ING, -S]\n",
  "FULLERED": "FULLER, to groove with a type of hammer [v]\n",
  "FULLERENE": "a ball-shaped molecule consisting of carbon atoms [n -S]\n",
  "FULLERENES": "FULLERENE, a ball-shaped molecule consisting of carbon atoms [n]\n",
  "FULLERIDE": "a compound of a fullerene in which atoms are trapped inside the cage of carbon atoms [n -S]\n",
  "FULLERIDES": "FULLERIDE, a compound of a fullerene in which atoms are trapped inside the cage of carbon atoms [n]\n",
  "FULLERIES": "FULLERY, a place for fulling cloth [n]\n",
  "FULLERING": "FULLER, to groove with a type of hammer [v]\n",
  "FULLERITE": "a crystalline form of a fullerene [n -S]\n",
  "FULLERITES": "FULLERITE, a crystalline form of a fullerene [n]\n",
  "FULLERS": "FULLER, to groove with a type of hammer [v]\n",
  "FULLERY": "a place for fulling cloth [n FULLERIES]\n",
  "FULLEST": "FULL, filled completely [adj]\n",
  "FULLFACE": "a portrait or photograph where the subject faces straight towards the viewer [n -S]\n",
  "FULLFACES": "FULLFACE, a portrait or photograph where the subject faces straight towards the viewer [n]\n",
  "FULLING": "FULL, to shrink and thicken, as cloth [v]\n",
  "FULLISH": "somewhat full [adj]\n",
  "FULLMOUTHED": "having a full complement of teeth [adj]\n",
  "FULLNESS": "the state of being full, also FULNESS [n -ES]\n",
  "FULLNESSES": "FULLNESS, the state of being full, also FULNESS [n]\n",
  "FULLS": "FULL, to shrink and thicken, as cloth [v]\n",
  "FULLY": "FULL, filled completely [adv]\n",
  "FULMAR": "(Old Norse) an arctic seabird [n -S]\n",
  "FULMARS": "FULMAR, (Old Norse) an arctic seabird [n]\n",
  "FULMINANT": "fulminating [adj] / a thunderbolt; an explosive [n -S]\n",
  "FULMINANTS": "FULMINANT, a thunderbolt; an explosive [n]\n",
  "FULMINATE": "to send forth censures or invectives [v FULMINATED, FULMINATING, FULMINATES]\n",
  "FULMINATED": "FULMINATE, to send forth censures or invectives [v]\n",
  "FULMINATES": "FULMINATE, to send forth censures or invectives [v]\n",
  "FULMINATING": "FULMINATE, to send forth censures or invectives [v]\n",
  "FULMINATION": "a loud and violent explosion, either literally or figuratively [n -S]\n",
  "FULMINATIONS": "FULMINATION, a loud and violent explosion, either literally or figuratively [n]\n",
  "FULMINATOR": "one who fulminates [n -S]\n",
  "FULMINATORS": "FULMINATOR, one who fulminates [n]\n",
  "FULMINATORY": "serving to fulminate [adj]\n",
  "FULMINE": "(Spenser) to explode loudly [v FULMINED, FULMINING, FULMINES]\n",
  "FULMINED": "FULMINE, (Spenser) to explode loudly [v]\n",
  "FULMINEOUS": "pertaining to thunder and lightning, also FULMINOUS [adj]\n",
  "FULMINES": "FULMINE, (Spenser) to explode loudly [v]\n",
  "FULMINIC": "highly explosive [adj]\n",
  "FULMINING": "FULMINE, (Spenser) to explode loudly [v]\n",
  "FULMINOUS": "relating to thunder and lightning, also FULMINEOUS [adj]\n",
  "FULNESS": "the state of being full, also FULLNESS [n -ES]\n",
  "FULNESSES": "FULNESS, the state of being full, also FULLNESS [n]\n",
  "FULSOME": "cloying [adj FULSOMER, FULSOMEST, FULSOMELY]\n",
  "FULSOMELY": "FULSOME, cloying [adv]\n",
  "FULSOMENESS": "the state of being fulsome [n -ES]\n",
  "FULSOMENESSES": "FULSOMENESS, the state of being fulsome [n]\n",
  "FULSOMER": "FULSOME, cloying [adj]\n",
  "FULSOMEST": "FULSOME, cloying [adj]\n",
  "FULVID": "dull yellow, also FULVOUS [adj]\n",
  "FULVOUS": "dull yellow, also FULVID [adj]\n",
  "FUM": "(Chinese) the fabled Chinese phoenix, also FUNG [n -S]\n",
  "FUMADO": "(Spanish) a salted and smoked fish, as the pilchard [n -ES or -S]\n",
  "FUMADOES": "FUMADO, (Spanish) a salted and smoked fish, as the pilchard [n]\n",
  "FUMADOS": "FUMADO, (Spanish) a salted and smoked fish, as the pilchard [n]\n",
  "FUMAGE": "hearth-tax [n -S]\n",
  "FUMAGES": "FUMAGE, hearth-tax [n]\n",
  "FUMARASE": "an enzyme that catalyses the interconversion of fumaric or malic acid and their salts [n -S]\n",
  "FUMARASES": "FUMARASE, an enzyme that catalyses the interconversion of fumaric or malic acid and their salts [n]\n",
  "FUMARATE": "a salt of fumaric acid [n -S]\n",
  "FUMARATES": "FUMARATE, a salt of fumaric acid [n]\n",
  "FUMARIC": "pertaining to a certain acid [adj]\n",
  "FUMAROLE": "a hole which emits volcanic vapours, also FUMEROLE [n -S]\n",
  "FUMAROLES": "FUMAROLE, a hole which emits volcanic vapours, also FUMEROLE [n]\n",
  "FUMAROLIC": "of or like a fumarole, a hole in a volcanic region from which hot gases and vapors issue [adj]\n",
  "FUMATORIA": "FUMATORIUM, (Latin) a place for smoking or fumigation, also FUMATORY [n]\n",
  "FUMATORIES": "FUMATORY, a place for smoking or fumigation, also FUMATORIUM [n]\n",
  "FUMATORIUM": "(Latin) a place for smoking or fumigation, also FUMATORY [n FUMATORIUMS or FUMATORIA]\n",
  "FUMATORIUMS": "FUMATORIUM, (Latin) a place for smoking or fumigation, also FUMATORY [n]\n",
  "FUMATORY": "a place for smoking or fumigation, also FUMATORIUM [n FUMATORIES]\n",
  "FUMBLE": "to handle clumsily [v FUMBLED, FUMBLING, FUMBLES]\n",
  "FUMBLED": "FUMBLE, to handle clumsily [v]\n",
  "FUMBLER": "one who fumbles [n -S]\n",
  "FUMBLERS": "FUMBLER, one who fumbles [n]\n",
  "FUMBLES": "FUMBLE, to handle clumsily [v]\n",
  "FUMBLING": "FUMBLE, to handle clumsily [v]\n",
  "FUMBLINGLY": "FUMBLING, FUMBLE, to handle clumsily [adv]\n",
  "FUMBLINGNESS": "the state of being fumbling [n -ES]\n",
  "FUMBLINGNESSES": "FUMBLINGNESS, the state of being fumbling [n]\n",
  "FUME": "to give off smoke or vapour [v FUMED, FUMING, FUMES]\n",
  "FUMED": "FUME, to give off smoke or vapour [v]\n",
  "FUMELESS": "without fumes [adj]\n",
  "FUMELIKE": "like fumes [adj]\n",
  "FUMER": "one that fumes [n -S]\n",
  "FUMEROLE": "a hole in a volcanic region from which hot gases and vapors issue, also FUMAROLE [n -S]\n",
  "FUMEROLES": "FUMEROLE, a hole in a volcanic region from which hot gases and vapors issue, also FUMAROLE [n]\n",
  "FUMERS": "FUMER, one that fumes [n]\n",
  "FUMES": "FUME, to give off smoke or vapour [v]\n",
  "FUMET": "(archaic) the dung of deer, hares etc.; the scent of game when high, also FEWMET, FUMETTE [n -S]\n",
  "FUMETS": "FUMET, (archaic) the dung of deer, hares etc.; the scent of game when high, also FEWMET, FUMETTE [n]\n",
  "FUMETTE": "(French) the scent of game when high, also FEWMET, FUMET [n -S]\n",
  "FUMETTES": "FUMETTE, (French) the scent of game when high, also FEWMET, FUMET [n]\n",
  "FUMETTI": "FUMETTO, (Italian) a cartoon or comic strip [n]\n",
  "FUMETTO": "(Italian) a cartoon or comic strip [n FUMETTI or FUMETTOS]\n",
  "FUMETTOS": "FUMETTO, (Italian) a cartoon or comic strip [n]\n",
  "FUMIER": "FUMY, full of fumes, also FUMOUS [adj]\n",
  "FUMIEST": "FUMY, full of fumes, also FUMOUS [adj]\n",
  "FUMIGANT": "a source of fumes, esp. a substance used for fumigation [n -S]\n",
  "FUMIGANTS": "FUMIGANT, a source of fumes, esp. a substance used for fumigation [n]\n",
  "FUMIGATE": "to subject to fumes to kill pests [v FUMIGATED, FUMIGATING, FUMIGATES]\n",
  "FUMIGATED": "FUMIGATE, to subject to fumes to kill pests [v]\n",
  "FUMIGATES": "FUMIGATE, to subject to fumes to kill pests [v]\n",
  "FUMIGATING": "FUMIGATE, to subject to fumes to kill pests [v]\n",
  "FUMIGATION": "the act of fumigating [n -S]\n",
  "FUMIGATIONS": "FUMIGATION, the act of fumigating [n]\n",
  "FUMIGATOR": "one who fumigates [n -S]\n",
  "FUMIGATORS": "FUMIGATOR, one who fumigates [n]\n",
  "FUMIGATORY": "having the quality of purifying by smoke [adj]\n",
  "FUMING": "FUME, to give off smoke or vapour [v]\n",
  "FUMINGLY": "FUMING, FUME, to give off smoke or vapour [adv]\n",
  "FUMITORIES": "FUMITORY, a plant once used to treat scurvy, also FEMETARY, FEMITER, FENITAR [n]\n",
  "FUMITORY": "a plant once used to treat scurvy, also FEMETARY, FEMITER, FENITAR [n FUMITORIES]\n",
  "FUMOSITIES": "FUMOSITY, a fuming condition [n]\n",
  "FUMOSITY": "a fuming condition [n FUMOSITIES]\n",
  "FUMOUS": "full of fumes [adj]\n",
  "FUMS": "FUM, (Chinese) the fabled Chinese phoenix, also FUNG [n]\n",
  "FUMULI": "FUMULUS, (Latin) a thin cloud [n]\n",
  "FUMULUS": "(Latin) a thin cloud [n FUMULI]\n",
  "FUMY": "full of fumes, also FUMOUS [adj FUMIER, FUMIEST]\n",
  "FUN": "to act playfully [v FUNNED, FUNNING, FUNS] / providing enjoyment [adj FUNNER, FUNNEST]\n",
  "FUNAMBULATE": "to walk the tightrope [v FUNAMBULATED, FUNAMBULATING, FUNAMBULATES]\n",
  "FUNAMBULATED": "FUNAMBULATE, to walk the tightrope [v]\n",
  "FUNAMBULATES": "FUNAMBULATE, to walk the tightrope [v]\n",
  "FUNAMBULATING": "FUNAMBULATE, to walk the tightrope [v]\n",
  "FUNAMBULATION": "tightrope-walking [n -S]\n",
  "FUNAMBULATIONS": "FUNAMBULATION, tightrope-walking [n]\n",
  "FUNAMBULATOR": "a tightrope walker [n -S]\n",
  "FUNAMBULATORS": "FUNAMBULATOR, a tightrope walker [n]\n",
  "FUNAMBULATORY": "related to funambulation, tightrope-walking [adj]\n",
  "FUNAMBULISM": "tightrope walking [n -S]\n",
  "FUNAMBULISMS": "FUNAMBULISM, tightrope walking [n]\n",
  "FUNAMBULIST": "a tightrope walker [n -S]\n",
  "FUNAMBULISTS": "FUNAMBULIST, a tightrope walker [n]\n",
  "FUNBOARD": "a special fast windsurfing board [n -S]\n",
  "FUNBOARDS": "FUNBOARD, a special fast windsurfing board [n]\n",
  "FUNCKIA": "(German) any plant of an East Asiatic genus allied to the day lilies, now called Hosta, also FUNKIA [n -S]\n",
  "FUNCKIAS": "FUNCKIA, (German) any plant of an East Asiatic genus allied to the day lilies, now called Hosta, also FUNKIA [n]\n",
  "FUNCTION": "to perform or act [v -ED, -ING, -S]\n",
  "FUNCTIONAL": "serving a function [adj FUNCTIONALLY] / something that serves a function [n -S]\n",
  "FUNCTIONALISM": "a doctrine emphasising utility and function [n -S]\n",
  "FUNCTIONALISMS": "FUNCTIONALISM, a doctrine emphasising utility and function [n]\n",
  "FUNCTIONALIST": "an exponent of functionalism [n -S]\n",
  "FUNCTIONALISTIC": "relating to functionalism [adj]\n",
  "FUNCTIONALISTS": "FUNCTIONALIST, an exponent of functionalism [n]\n",
  "FUNCTIONALITIES": "FUNCTIONALITY, the state of being functional [n]\n",
  "FUNCTIONALITY": "the state of being functional [n FUNCTIONALITIES]\n",
  "FUNCTIONALLY": "FUNCTIONAL, serving a function [adv]\n",
  "FUNCTIONALS": "FUNCTIONAL, something that serves a function [n]\n",
  "FUNCTIONARIES": "FUNCTIONARY, one who serves in a certain function [n]\n",
  "FUNCTIONARY": "one who serves in a certain function [n FUNCTIONARIES]\n",
  "FUNCTIONATE": "to perform a function [v FUNCTIONATED, FUNCTIONATING, FUNCTIONATES]\n",
  "FUNCTIONATED": "FUNCTIONATE, to perform a function [v]\n",
  "FUNCTIONATES": "FUNCTIONATE, to perform a function [v]\n",
  "FUNCTIONATING": "FUNCTIONATE, to perform a function [v]\n",
  "FUNCTIONED": "FUNCTION, to perform or act [v]\n",
  "FUNCTIONING": "FUNCTION, to perform or act [v]\n",
  "FUNCTIONLESS": "without function [adj]\n",
  "FUNCTIONS": "FUNCTION, to perform or act [v]\n",
  "FUNCTOR": "one that functions [n -S]\n",
  "FUNCTORS": "FUNCTOR, one that functions [n]\n",
  "FUND": "to provide money for [v -ED, -ING, -S]\n",
  "FUNDABLE": "able to be funded [adj]\n",
  "FUNDAMENT": "the buttocks or anus [n -S]\n",
  "FUNDAMENTAL": "basic [adj FUNDAMENTALLY] / something fundamental [n -S]\n",
  "FUNDAMENTALISM": "a movement in 20th century Protestantism emphasizing the literally interpreted Bible as fundamental to Christian life and teaching [n -S]\n",
  "FUNDAMENTALISMS": "FUNDAMENTALISM, a movement in 20th century Protestantism emphasizing the literally interpreted Bible as fundamental to Christian life and teaching [n]\n",
  "FUNDAMENTALIST": "an exponent of fundamentalism [n -S]\n",
  "FUNDAMENTALISTS": "FUNDAMENTALIST, an exponent of fundamentalism [n]\n",
  "FUNDAMENTALITY": "the state of being fundamental [n]\n",
  "FUNDAMENTALLY": "FUNDAMENTAL, basic [adv]\n",
  "FUNDAMENTALNESS": "FUNDAMENTAL, basic [n]\n",
  "FUNDAMENTALS": "FUNDAMENTAL, something fundamental [n]\n",
  "FUNDAMENTS": "FUNDAMENT, the buttocks or anus [n]\n",
  "FUNDED": "FUND, to provide money for [v]\n",
  "FUNDER": "a financial backer [n -S]\n",
  "FUNDERS": "FUNDER, a financial backer [n]\n",
  "FUNDHOLDER": "a person who has money in public funds [n -S]\n",
  "FUNDHOLDERS": "FUNDHOLDER, a person who has money in public funds [n]\n",
  "FUNDHOLDING": "under the NHS, the system enabling general practitioners to receive a fixed budget [n -S]\n",
  "FUNDHOLDINGS": "FUNDHOLDING, under the NHS, the system enabling general practitioners to receive a fixed budget [n]\n",
  "FUNDI": "in South Africa, an expert [n -S]\n",
  "FUNDIC": "relating to the fundus, the inner basal surface farthest from the opening (as in the eye) [adj]\n",
  "FUNDIE": "(Australian slang) a fundamental Christian [n -S]\n",
  "FUNDIES": "FUNDY, (German) a member of the radical wing of the German Green party, also FUNDIE [n]\n",
  "FUNDING": "financial backing [n -S]\n",
  "FUNDINGS": "FUNDING, financial backing [n]\n",
  "FUNDIS": "FUNDI, in South Africa, an expert [n]\n",
  "FUNDLESS": "without funds [adj]\n",
  "FUNDRAISE": "to raise funds [v FUNDRAISED, FUNDRAISING, FUNDRAISES]\n",
  "FUNDRAISED": "FUNDRAISE, to raise funds [v]\n",
  "FUNDRAISER": "one who raises funds [n -S]\n",
  "FUNDRAISERS": "FUNDRAISER, one who raises funds [n]\n",
  "FUNDRAISES": "FUNDRAISE, to raise funds [v]\n",
  "FUNDRAISING": "the act of raising funds [n -S]\n",
  "FUNDRAISINGS": "FUNDRAISING, the act of raising funds [n]\n",
  "FUNDS": "FUND, to provide money for [v]\n",
  "FUNDUS": "(Latin) the inner basal surface of a bodily organ [n FUNDI]\n",
  "FUNDY": "(German) a member of the radical wing of the German Green party, also FUNDIE [n FUNDIES]\n",
  "FUNEBRAL": "of or pertaining to a funeral, also FUNEBRIAL [adj]\n",
  "FUNEBRE": "(French) mournful [adj]\n",
  "FUNEBRIAL": "of or pertaining to a funeral, also FUNEBRAL [adj]\n",
  "FUNERAL": "a ceremony held to honour a dead person [n -S]\n",
  "FUNERALS": "FUNERAL, a ceremony held to honour a dead person [n]\n",
  "FUNERARY": "pertaining to or suiting a funeral [adj]\n",
  "FUNEREAL": "pertaining to a funeral; mournful [adj FUNEREALLY]\n",
  "FUNEREALLY": "FUNEREAL, pertaining to a funeral; mournful [adv]\n",
  "FUNEST": "portending death or evil [adj]\n",
  "FUNFAIR": "an amusement park [n -S]\n",
  "FUNFAIRS": "FUNFAIR, an amusement park [n]\n",
  "FUNFEST": "a party for fun [n -S]\n",
  "FUNFESTS": "FUNFEST, a party for fun [n]\n",
  "FUNG": "(Chinese) the fabled Chinese phoenix, also FUM [n -S]\n",
  "FUNGAL": "relating to fungi e.g. a fungal infection [adj] / a fungus [n -S]\n",
  "FUNGALS": "FUNGAL, a fungus [n]\n",
  "FUNGI": "FUNGUS, (Latin) any of the major group of lower plants [n]\n",
  "FUNGIBILITIES": "FUNGIBILITY, the state of being fungible [n]\n",
  "FUNGIBILITY": "the state of being fungible [n FUNGIBILITIES]\n",
  "FUNGIBLE": "something that may be exchanged for a similar unit [n -S]\n",
  "FUNGIBLES": "FUNGIBLE, something that may be exchanged for a similar unit [n]\n",
  "FUNGIC": "pertaining to a fungus, also FUNGOUS [adj]\n",
  "FUNGICIDAL": "having the properties of a fungicide [adj FUNGICIDALLY]\n",
  "FUNGICIDALLY": "FUNGICIDAL, having the properties of a fungicide [adv]\n",
  "FUNGICIDE": "an agent that kills fungi [n -S]\n",
  "FUNGICIDES": "FUNGICIDE, an agent that kills fungi [n]\n",
  "FUNGIFORM": "shaped like a fungus [adj]\n",
  "FUNGISTAT": "a substance that inhibits the growth of a fungus [n -S]\n",
  "FUNGISTATIC": "inhibiting the growth of fungi [adj FUNGISTATICALLY]\n",
  "FUNGISTATICALLY": "FUNGISTATIC, inhibiting the growth of fungi [adv]\n",
  "FUNGISTATS": "FUNGISTAT, a substance that inhibits the growth of a fungus [n]\n",
  "FUNGO": "a fly ball hit to a fielder for practice in baseball [n FUNGOES] / to toss (a ball) upwards and hit it as it descends [v -ED, -ING, -S]\n",
  "FUNGOED": "FUNGO, to toss (a ball) upwards and hit it as it descends [v]\n",
  "FUNGOES": "FUNGO, a fly ball hit to a fielder for practice in baseball [n]\n",
  "FUNGOID": "of or like fungus, also FUNGOIDAL, FUNGOUS [adj] / a fungus [n -S]\n",
  "FUNGOIDAL": "of or like fungus, also FUNGOID, FUNGOUS [adj]\n",
  "FUNGOIDS": "FUNGOID, a fungus [n]\n",
  "FUNGOING": "FUNGO, to toss (a ball) upwards and hit it as it descends [v]\n",
  "FUNGOS": "FUNGO, a fly ball hit to a fielder for practice in baseball [n]\n",
  "FUNGOSITIES": "FUNGOSITY, the quality of being fungous [n]\n",
  "FUNGOSITY": "the quality of being fungous [n FUNGOSITIES]\n",
  "FUNGOUS": "pertaining to a fungus, also FUNGIC [adj]\n",
  "FUNGS": "FUNG, (Chinese) the fabled Chinese phoenix, also FUM [n]\n",
  "FUNGUS": "(Latin) any of the major group of lower plants [n FUNGUSES or FUNGI]\n",
  "FUNGUSES": "FUNGUS, (Latin) any of the major group of lower plants [n]\n",
  "FUNHOUSE": "an amusement park attraction [n -S]\n",
  "FUNHOUSES": "FUNHOUSE, an amusement park attraction [n]\n",
  "FUNICLE": "a cordlike anatomical structure [n -S]\n",
  "FUNICLES": "FUNICLE, a cordlike anatomical structure [n]\n",
  "FUNICULAR": "relating to a string or cable [adj] / a cable railway ascending a mountain [n -S]\n",
  "FUNICULARS": "FUNICULAR, a cable railway ascending a mountain [n]\n",
  "FUNICULATE": "forming a narrow ridge [adj]\n",
  "FUNICULI": "FUNICULUS, (Latin) the umbilical cord [n]\n",
  "FUNICULUS": "(Latin) the umbilical cord [n FUNICULI]\n",
  "FUNK": "to shrink back in fear [v -ED, -ING, -S]\n",
  "FUNKED": "FUNK, to shrink back in fear [v]\n",
  "FUNKER": "one who funks [n -S]\n",
  "FUNKERS": "FUNKER, one who funks [n]\n",
  "FUNKHOLE": "a place of retreat for shelter or refuge [n -S]\n",
  "FUNKHOLES": "FUNKHOLE, a place of retreat for shelter or refuge [n]\n",
  "FUNKIA": "(German) any plant of an East Asiatic genus allied to the daylilies, now called hosta, also FUNCKIA [n -S]\n",
  "FUNKIAS": "FUNKIA, (German) any plant of an East Asiatic genus allied to the daylilies, now called hosta, also FUNCKIA [n]\n",
  "FUNKIER": "FUNKY, of jazz, pop music etc., earthy, soulful [adj]\n",
  "FUNKIEST": "FUNKY, of jazz, pop music etc., earthy, soulful [adj]\n",
  "FUNKILY": "FUNKY, of jazz, pop music etc., earthy, soulful [adv]\n",
  "FUNKINESS": "trendiness [n -ES]\n",
  "FUNKINESSES": "FUNKINESS, trendiness [n]\n",
  "FUNKING": "FUNK, to shrink back in fear [v]\n",
  "FUNKS": "FUNK, to shrink back in fear [v]\n",
  "FUNKSTER": "a performer or fan of pop music [n -S]\n",
  "FUNKSTERS": "FUNKSTER, a performer or fan of pop music [n]\n",
  "FUNKY": "of jazz, pop music etc., earthy, soulful [adj FUNKIER, FUNKIEST, FUNKILY]\n",
  "FUNNED": "FUN, to act playfully [v]\n",
  "FUNNEL": "to pass through a cone-shaped utensil [v FUNNELLED or FUNNELED, FUNNELLING or FUNNELING, FUNNELS]\n",
  "FUNNELED": "FUNNEL, to pass through a cone-shaped utensil [v]\n",
  "FUNNELFORM": "having the form of a funnel [adj]\n",
  "FUNNELING": "FUNNEL, to pass through a cone-shaped utensil [v]\n",
  "FUNNELLED": "FUNNEL, to pass through a cone-shaped utensil [v]\n",
  "FUNNELLING": "FUNNEL, to pass through a cone-shaped utensil [v]\n",
  "FUNNELS": "FUNNEL, to pass through a cone-shaped utensil [v]\n",
  "FUNNER": "FUN, providing enjoyment [adj]\n",
  "FUNNEST": "FUN, providing enjoyment [adj]\n",
  "FUNNIER": "FUNNY, amusing [adj]\n",
  "FUNNIES": "FUNNY, a comic strip [n]\n",
  "FUNNIEST": "FUNNY, amusing [adj]\n",
  "FUNNILY": "FUNNY, amusing [adv]\n",
  "FUNNINESS": "the state of being funny [n -ES]\n",
  "FUNNINESSES": "FUNNINESS, the state of being funny [n]\n",
  "FUNNING": "FUN, to act playfully [v]\n",
  "FUNNY": "a comic strip [n FUNNIES] / amusing [adj FUNNIER, FUNNIEST, FUNNILY]\n",
  "FUNNYMAN": "a comedian [n FUNNYMEN]\n",
  "FUNNYMEN": "FUNNYMAN, a comedian [n]\n",
  "FUNPLEX": "a building with facilities for sports and games [n -ES]\n",
  "FUNPLEXES": "FUNPLEX, a building with facilities for sports and games [n]\n",
  "FUNS": "FUN, to act playfully [v]\n",
  "FUNSTER": "a prankster; a person who causes merriment [n -S]\n",
  "FUNSTERS": "FUNSTER, a prankster; a person who causes merriment [n]\n",
  "FUR": "to cover with a dressed animal pelt [v FURRED, FURRING, FURS]\n",
  "FURACIOUS": "(obsolete) given to thieving; thievish [adj]\n",
  "FURACIOUSNESS": "FURACIOUS, (obsolete) given to thieving; thievish [n]\n",
  "FURACIOUSNESSES": "FURACIOUSNESS, FURACIOUS, (obsolete) given to thieving; thievish [n]\n",
  "FURACITIES": "FURACITY, a thievish disposition [n]\n",
  "FURACITY": "a thievish disposition [n FURACITIES]\n",
  "FURAL": "a liquid obtained by heating bran with dilute sulphuric acid, also FURFURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROL, FUROLE [n -S]\n",
  "FURALDEHYDE": "either of two aldehydes derived from furan [n -S]\n",
  "FURALDEHYDES": "FURALDEHYDE, either of two aldehydes derived from furan [n]\n",
  "FURALS": "FURAL, a liquid obtained by heating bran with dilute sulphuric acid, also FURFURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROL, FUROLE [n]\n",
  "FURAN": "a chemical used in tanning, also FURANE, FURFURAN [n -S]\n",
  "FURANE": "a chemical used in tanning, also FURAN, FURFURAN [n -S]\n",
  "FURANES": "FURANE, a chemical used in tanning, also FURAN, FURFURAN [n]\n",
  "FURANOSE": "a sugar having four carbon atoms and one oxygen [n -S]\n",
  "FURANOSES": "FURANOSE, a sugar having four carbon atoms and one oxygen [n]\n",
  "FURANOSIDE": "a glycoside containing the ring characteristic of furanose [n -S]\n",
  "FURANOSIDES": "FURANOSIDE, a glycoside containing the ring characteristic of furanose [n]\n",
  "FURANS": "FURAN, a chemical used in tanning, also FURANE, FURFURAN [n]\n",
  "FURAZOLIDONE": "an antimicrobial drug used against bacteria and some protozoa esp. in infections of the gastrointestinal tract [n -S]\n",
  "FURAZOLIDONES": "FURAZOLIDONE, an antimicrobial drug used against bacteria and some protozoa esp. in infections of the gastrointestinal tract [n]\n",
  "FURBALL": "a ball of fur regurgitated by a cat [n -S]\n",
  "FURBALLS": "FURBALL, a ball of fur regurgitated by a cat [n]\n",
  "FURBEARER": "an animal with fur [n -S]\n",
  "FURBEARERS": "FURBEARER, an animal with fur [n]\n",
  "FURBELOW": "to decorate with ruffles [v -ED, -ING, -S]\n",
  "FURBELOWED": "FURBELOW, to decorate with ruffles [v]\n",
  "FURBELOWING": "FURBELOW, to decorate with ruffles [v]\n",
  "FURBELOWS": "FURBELOW, to decorate with ruffles [v]\n",
  "FURBISH": "to rub or scour to brightness [v -ED, -ING, -ES]\n",
  "FURBISHED": "FURBISH, to rub or scour to brightness [v]\n",
  "FURBISHER": "one who furbishes; esp. a sword cutler, who finishes sword blades and similar weapons [n -S]\n",
  "FURBISHERS": "FURBISHER, one who furbishes; esp. a sword cutler, who finishes sword blades and similar weapons [n]\n",
  "FURBISHES": "FURBISH, to rub or scour to brightness [v]\n",
  "FURBISHING": "FURBISH, to rub or scour to brightness [v]\n",
  "FURCA": "any forklike structure esp. in insects [n FURCAE]\n",
  "FURCAE": "FURCA, any forklike structure esp. in insects [n]\n",
  "FURCAL": "forked [adj]\n",
  "FURCATE": "forked [adj FURCATELY] / to divide into branches [v FURCATED, FURCATING, FURCATES]\n",
  "FURCATED": "FURCATE, to divide into branches [v]\n",
  "FURCATELY": "FURCATE, forked [adv]\n",
  "FURCATES": "FURCATE, to divide into branches [v]\n",
  "FURCATING": "FURCATE, to divide into branches [v]\n",
  "FURCATION": "a branching like a fork [n -S]\n",
  "FURCATIONS": "FURCATION, a branching like a fork [n]\n",
  "FURCIFEROUS": "bearing a forked appendage; rascally [adj]\n",
  "FURCRAEA": "a tropical American genus of plants related to the agave [n -S]\n",
  "FURCRAEAS": "FURCRAEA, a tropical American genus of plants related to the agave [n]\n",
  "FURCULA": "(Latin) the jointed clavicles of a bird, aka wishbone, also FURCULUM [n FURCULAE]\n",
  "FURCULAE": "FURCULA, (Latin) the jointed clavicles of a bird, aka wishbone, also FURCULUM [n]\n",
  "FURCULAR": "shaped like a fork [adj]\n",
  "FURCULUM": "(Latin) the jointed clavicles of a bird, aka wishbone, also FURCULA [n FURCULA]\n",
  "FURDER": "further [adv]\n",
  "FUREUR": "(French) an extravagant admiration [n -S]\n",
  "FUREURS": "FUREUR, (French) an extravagant admiration [n]\n",
  "FURFAIR": "dandruff, also FURFUR [n -S]\n",
  "FURFAIRS": "FURFAIR, dandruff, also FURFUR [n]\n",
  "FURFUR": "(Latin) dandruff, also FURFAIR [n FURFURS or FURFURES]\n",
  "FURFURACEOUS": "containing bran or particles resembling bran, also FURFUROUS [adj FURFURACEOUSLY]\n",
  "FURFURACEOUSLY": "FURFURACEOUS, containing bran or particles resembling bran, also FURFUROUS [adv]\n",
  "FURFURAL": "a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROL, FUROLE [n -S]\n",
  "FURFURALDEHYDE": "a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFUROL, FURFUROLE, FUROL, FUROLE [n -S]\n",
  "FURFURALDEHYDES": "FURFURALDEHYDE, a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFUROL, FURFUROLE, FUROL, FUROLE [n]\n",
  "FURFURALS": "FURFURAL, a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROL, FUROLE [n]\n",
  "FURFURAN": "a chemical used in tanning, also FURAN, FURANE [n -S]\n",
  "FURFURANS": "FURFURAN, a chemical used in tanning, also FURAN, FURANE [n]\n",
  "FURFURES": "FURFUR, (Latin) dandruff, also FURFAIR [n]\n",
  "FURFUROL": "a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROLE, FUROL, FUROLE [n -S]\n",
  "FURFUROLE": "a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROL, FUROL, FUROLE [n -S]\n",
  "FURFUROLES": "FURFUROLE, a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROL, FUROL, FUROLE [n]\n",
  "FURFUROLS": "FURFUROL, a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROLE, FUROL, FUROLE [n]\n",
  "FURFUROUS": "containing bran or particles resembling bran, also FURFURACEOUS [adj]\n",
  "FURFURS": "FURFUR, (Latin) dandruff, also FURFAIR [n]\n",
  "FURIBUND": "(obsolete) raging [adj]\n",
  "FURIES": "FURY, violent anger [n]\n",
  "FURIOSITIES": "FURIOSITY, madness [n]\n",
  "FURIOSITY": "madness [n FURIOSITIES]\n",
  "FURIOSO": "(Italian) a mad person [n -S]\n",
  "FURIOSOS": "FURIOSO, (Italian) a mad person [n]\n",
  "FURIOUS": "extremely angry [adj FURIOUSLY]\n",
  "FURIOUSLY": "FURIOUS, extremely angry [adv]\n",
  "FURIOUSNESS": "the state of being furious [n -ES]\n",
  "FURIOUSNESSES": "FURIOUSNESS, the state of being furious [n]\n",
  "FURKID": "an animal kept as a companion [n -S]\n",
  "FURKIDS": "FURKID, an animal kept as a companion [n]\n",
  "FURL": "to roll up [v -ED, -ING, -S]\n",
  "FURLABLE": "able to be furled [adj]\n",
  "FURLANA": "(Italian) a dance of old Venice, also FORLANA [n -S]\n",
  "FURLANAS": "FURLANA, (Italian) a dance of old Venice, also FORLANA [n]\n",
  "FURLED": "FURL, to roll up [v]\n",
  "FURLER": "one that furls [n -S]\n",
  "FURLERS": "FURLER, one that furls [n]\n",
  "FURLESS": "without fur [adj]\n",
  "FURLIKE": "like fur [adj]\n",
  "FURLING": "FURL, to roll up [v]\n",
  "FURLONG": "one eighth of a mile [n -S]\n",
  "FURLONGS": "FURLONG, one eighth of a mile [n]\n",
  "FURLOUGH": "to grant a leave of absence to [v -ED, -ING, -S]\n",
  "FURLOUGHED": "FURLOUGH, to grant a leave of absence to [v]\n",
  "FURLOUGHING": "FURLOUGH, to grant a leave of absence to [v]\n",
  "FURLOUGHS": "FURLOUGH, to grant a leave of absence to [v]\n",
  "FURLS": "FURL, to roll up [v]\n",
  "FURMENTIES": "FURMENTY, a wheat dish boiled in milk and sweetened, also FRUMENTY, FROMENTY, FURMETY, FURMITY [n]\n",
  "FURMENTY": "a wheat dish boiled in milk and sweetened, also FRUMENTY, FROMENTY, FURMETY, FURMITY [n FURMENTIES]\n",
  "FURMETIES": "FURMETY, a wheat dish boiled in milk and sweetened, also FRUMENTY, FROMENTY, FURMENTY, FURMITY [n]\n",
  "FURMETY": "a wheat dish boiled in milk and sweetened, also FRUMENTY, FROMENTY, FURMENTY, FURMITY [n FURMETIES]\n",
  "FURMITIES": "FURMITY, a wheat dish boiled in milk and sweetened, also FRUMENTY, FROMENTY, FURMENTY, FURMETY [n]\n",
  "FURMITY": "a wheat dish boiled in milk and sweetened, also FRUMENTY, FROMENTY, FURMENTY, FURMETY [n FURMITIES]\n",
  "FURNACE": "to subject to heat [v FURNACED, FURNACING, FURNACES]\n",
  "FURNACED": "FURNACE, to subject to heat [v]\n",
  "FURNACES": "FURNACE, to subject to heat [v]\n",
  "FURNACING": "FURNACE, to subject to heat [v]\n",
  "FURNIMENT": "(Spenser) furnishing [n -S]\n",
  "FURNIMENTS": "FURNIMENT, (Spenser) furnishing [n]\n",
  "FURNISH": "to equip [v -ED, -ING, -ES]\n",
  "FURNISHED": "FURNISH, to equip [v]\n",
  "FURNISHER": "one who furnishes [n -S]\n",
  "FURNISHERS": "FURNISHER, one who furnishes [n]\n",
  "FURNISHES": "FURNISH, to equip [v]\n",
  "FURNISHING": "furniture [n -S]\n",
  "FURNISHINGS": "FURNISHING, furniture [n]\n",
  "FURNISHMENT": "the act of furnishing [n -S]\n",
  "FURNISHMENTS": "FURNISHMENT, the act of furnishing [n]\n",
  "FURNITURE": "movables, either for use or ornament, with which a house is equipped [n -S]\n",
  "FURNITURES": "FURNITURE, movables, either for use or ornament, with which a house is equipped [n]\n",
  "FUROL": "a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROLE [n -S]\n",
  "FUROLE": "a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROL [n -S]\n",
  "FUROLES": "FUROLE, a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROL [n]\n",
  "FUROLS": "FUROL, a liquid obtained by heating bran with dilute sulphuric acid, also FURAL, FURFURAL, FURFURALDEHYDE, FURFUROL, FURFUROLE, FUROLE [n]\n",
  "FUROR": "an outburst of public indignation, also FURORE [n -S]\n",
  "FURORE": "(Italian) an outburst of public indignation, also FUROR [n -S]\n",
  "FURORES": "FURORE, (Italian) an outburst of public indignation, also FUROR [n]\n",
  "FURORS": "FUROR, an outburst of public indignation, also FURORE [n]\n",
  "FUROSEMIDE": "a synthetic diuretic drug used esp. in treating oedema, also FRUSEMIDE [n -S]\n",
  "FUROSEMIDES": "FUROSEMIDE, a synthetic diuretic drug used esp. in treating oedema, also FRUSEMIDE [n]\n",
  "FURPHIES": "FURPHY, (Australian slang) a rumour [n]\n",
  "FURPHY": "(Australian slang) a rumour [n FURPHIES]\n",
  "FURPIECE": "an item of clothing made out of fur [n -S]\n",
  "FURPIECES": "FURPIECE, an item of clothing made out of fur [n]\n",
  "FURR": "(Scots) a furrow, also FEER [n -S]\n",
  "FURRED": "FUR, to cover with a dressed animal pelt [v]\n",
  "FURRIER": "one who deals in furs [n -S]\n",
  "FURRIERIES": "FURRIERY, the business of a furrier [n]\n",
  "FURRIERS": "FURRIER, one who deals in furs [n]\n",
  "FURRIERY": "the business of a furrier [n FURRIERIES]\n",
  "FURRIES": "FURRY, a Cornish dance [n]\n",
  "FURRIEST": "FURRY, covered in fur [adj]\n",
  "FURRILY": "FURRY, covered in fur [adv]\n",
  "FURRINER": "a foreigner [n -S]\n",
  "FURRINERS": "FURRINER, a foreigner [n]\n",
  "FURRINESS": "the state of being furry [n -ES]\n",
  "FURRINESSES": "FURRINESS, the state of being furry [n]\n",
  "FURRING": "wooden strips attached to joists, also FIRRING [n -S]\n",
  "FURRINGS": "FURRING, wooden strips attached to joists, also FIRRING [n]\n",
  "FURROW": "to make narrow depressions in [v -ED, -ING, -S]\n",
  "FURROWED": "FURROW, to make narrow depressions in [v]\n",
  "FURROWER": "one that makes furrows [n -S]\n",
  "FURROWERS": "FURROWER, one that makes furrows [n]\n",
  "FURROWIER": "FURROWY, furrowed [adj]\n",
  "FURROWIEST": "FURROWY, furrowed [adj]\n",
  "FURROWING": "FURROW, to make narrow depressions in [v]\n",
  "FURROWLESS": "without a furrow [adj]\n",
  "FURROWS": "FURROW, to make narrow depressions in [v]\n",
  "FURROWY": "furrowed [adj FURROWIER, FURROWIEST]\n",
  "FURRS": "FURR, (Scots) a furrow, also FEER [n]\n",
  "FURRY": "covered in fur [adj FURRIER, FURRIEST, FURRILY] / a Cornish dance [n FURRIES]\n",
  "FURS": "FUR, to cover with a dressed animal pelt [v]\n",
  "FURSHLUGGINER": "(Yiddish) well-worn, beat-up [adj]\n",
  "FURTH": "(Scots) forth, outside of [adv]\n",
  "FURTHCOMING": "in Scots law, an action brought by an arrester against the arrestee and the common debtor after an arrestment in order that the arrested money or property be delivered to the arrester [n -S]\n",
  "FURTHCOMINGS": "FURTHCOMING, in Scots law, an action brought by an arrester against the arrestee and the common debtor after an arrestment in order that the arrested money or property be delivered to the arrester [n]\n",
  "FURTHER": "to help forward [v -ED, -ING, -S]\n",
  "FURTHERANCE": "the act of furthering [n -S]\n",
  "FURTHERANCES": "FURTHERANCE, the act of furthering [n]\n",
  "FURTHERED": "FURTHER, to help forward [v]\n",
  "FURTHERER": "one who furthers [n -S]\n",
  "FURTHERERS": "FURTHERER, one who furthers [n]\n",
  "FURTHERING": "FURTHER, to help forward [v]\n",
  "FURTHERMORE": "in addition, also FARTHERMORE [adv]\n",
  "FURTHERMOST": "most distant, also FARTHERMOST [adj]\n",
  "FURTHERS": "FURTHER, to help forward [v]\n",
  "FURTHERSOME": "helpful; advantageous; rash [adj]\n",
  "FURTHEST": "FAR, at a great distance [adj]\n",
  "FURTIVE": "stolen; obtained or characterized by stealth [adj FURTIVELY]\n",
  "FURTIVELY": "FURTIVE, stolen; obtained or characterized by stealth [adv]\n",
  "FURTIVENESS": "the state of being furtive [n -ES]\n",
  "FURTIVENESSES": "FURTIVENESS, the state of being furtive [n]\n",
  "FURUNCLE": "a painful swelling of the skin [n -S]\n",
  "FURUNCLES": "FURUNCLE, a painful swelling of the skin [n]\n",
  "FURUNCULAR": "of or pertaining to boils, also FURUNCULOUS [adj]\n",
  "FURUNCULOSES": "FURUNCULOSIS, an affliction of boils [n]\n",
  "FURUNCULOSIS": "an affliction of boils [n FURUNCULOSES]\n",
  "FURUNCULOUS": "of or pertaining to boils, also FURUNCULAR [adj]\n",
  "FURY": "violent anger [n FURIES]\n",
  "FURZE": "a spiny shrub, aka gorse or whin [n -S]\n",
  "FURZES": "FURZE, a spiny shrub, aka gorse or whin [n]\n",
  "FURZIER": "FURZY, abounding in furze [adj]\n",
  "FURZIEST": "FURZY, abounding in furze [adj]\n",
  "FURZY": "abounding in furze [adj FURZIER, FURZIEST]\n",
  "FUSAIN": "(French) a fine charcoal used in drawing [n -S]\n",
  "FUSAINS": "FUSAIN, (French) a fine charcoal used in drawing [n]\n",
  "FUSARIA": "FUSARIUM, a type of fungus, causing plant disease [n]\n",
  "FUSARIUM": "a type of fungus, causing plant disease [n FUSARIA or FUSARIUMS]\n",
  "FUSARIUMS": "FUSARIUM, a type of fungus, causing plant disease [n]\n",
  "FUSAROL": "(French) a semicircular moulding around a column, also FUSAROLE [n -S]\n",
  "FUSAROLE": "(French) a semicircular moulding around a column, also FUSAROL [n -S]\n",
  "FUSAROLES": "FUSAROLE, (French) a semicircular moulding around a column, also FUSAROL [n]\n",
  "FUSAROLS": "FUSAROL, (French) a semicircular moulding around a column, also FUSAROLE [n]\n",
  "FUSBALL": "(US) table football, also FUSSBALL, FOOSBALL [n -S]\n",
  "FUSBALLS": "FUSBALL, (US) table football, also FUSSBALL, FOOSBALL [n]\n",
  "FUSC": "dusky brown, also FUSCOUS [adj]\n",
  "FUSCOUS": "dusky brown, also FUSC [adj]\n",
  "FUSE": "to equip with a detonating device, also FUZE [v FUSED, FUSING, FUSES]\n",
  "FUSED": "FUSE, to equip with a detonating device, also FUZE [v]\n",
  "FUSEE": "(French) a large-headed friction match, also FUZEE [n -S]\n",
  "FUSEES": "FUSEE, (French) a large-headed friction match, also FUZEE [n]\n",
  "FUSEL": "a nauseous mixture of alcohols in spirits distilled from potatoes, grain etc. [n -S]\n",
  "FUSELAGE": "(French) the elongated body section of an aeroplane, containing the crew and passengers or cargo [n -S]\n",
  "FUSELAGES": "FUSELAGE, (French) the elongated body section of an aeroplane, containing the crew and passengers or cargo [n]\n",
  "FUSELESS": "without a fuse, also FUZELESS [adj]\n",
  "FUSELIKE": "like a fuse [adj]\n",
  "FUSELS": "FUSEL, a nauseous mixture of alcohols in spirits distilled from potatoes, grain etc. [n]\n",
  "FUSES": "FUSE, to equip with a detonating device, also FUZE [v]\n",
  "FUSHION": "(Scots) physical energy or strength, also FIZZEN, FOISON, FUSION [n -S]\n",
  "FUSHIONLESS": "(Scots) weak, feeble, also FIZZENLESS, FOISONLESS, FUSIONLESS [adj]\n",
  "FUSHIONS": "FUSHION, (Scots) physical energy or strength, also FIZZEN, FOISON, FUSION [n]\n",
  "FUSIBILITIES": "FUSIBILITY, the quality of being fusible [n]\n",
  "FUSIBILITY": "the quality of being fusible [n FUSIBILITIES]\n",
  "FUSIBLE": "capable of being fused [adj]\n",
  "FUSIBLENESS": "the quality of being fusible [n -ES]\n",
  "FUSIBLENESSES": "FUSIBLENESS, the quality of being fusible [n]\n",
  "FUSIBLY": "FUSIBLE, capable of being fused [adv]\n",
  "FUSIDIC": "as in fusidic acid [adj]\n",
  "FUSIFORM": "tapering toward each end [adj]\n",
  "FUSIL": "a type of flintlock musket, also FUZIL [n -S]\n",
  "FUSILE": "formed by melting [adj]\n",
  "FUSILEER": "a soldier armed with a fusil, also FUSILIER [n -S]\n",
  "FUSILEERS": "FUSILEER, a soldier armed with a fusil, also FUSILIER [n]\n",
  "FUSILIER": "a soldier armed with a fusil, also FUSILEER [n -S]\n",
  "FUSILIERS": "FUSILIER, a soldier armed with a fusil, also FUSILEER [n]\n",
  "FUSILLADE": "(French) a simultaneous or successive discharge of firearms [n -S] / to discharge firearms simultaneously [v FUSILLADED, FUSILLADING, FUSILLADES]\n",
  "FUSILLADED": "FUSILLADE, to discharge firearms simultaneously [v]\n",
  "FUSILLADES": "FUSILLADE, (French) a simultaneous or successive discharge of firearms [n]\n",
  "FUSILLADING": "FUSILLADE, to discharge firearms simultaneously [v]\n",
  "FUSILLATION": "(obsolete) death by shooting [n -S]\n",
  "FUSILLATIONS": "FUSILLATION, (obsolete) death by shooting [n]\n",
  "FUSILLI": "(Italian) pasta in the form of short thick spirals [n -S]\n",
  "FUSILLIS": "FUSILLI, (Italian) pasta in the form of short thick spirals [n]\n",
  "FUSILS": "FUSIL, a type of flintlock musket, also FUZIL [n]\n",
  "FUSING": "FUSE, to equip with a detonating device, also FUZE [v]\n",
  "FUSION": "(Scots) physical energy or strength, also FIZZEN, FOISON, FUSHION [n -S]\n",
  "FUSIONAL": "relating to fusion [adj]\n",
  "FUSIONISM": "a policy that favours unionism or coalition [n -S]\n",
  "FUSIONISMS": "FUSIONISM, a policy that favours unionism or coalition [n]\n",
  "FUSIONIST": "an advocate of fusionism, a policy that favours unionism or coalition [n -S]\n",
  "FUSIONISTS": "FUSIONIST, an advocate of fusionism, a policy that favours unionism or coalition [n]\n",
  "FUSIONLESS": "(Scots) weak, feeble, also FIZZENLESS, FOISONLESS, FUSHIONLESS [adj]\n",
  "FUSIONS": "FUSION, (Scots) physical energy or strength, also FIZZEN, FOISON, FUSHION [n]\n",
  "FUSK": "to obtain data from (a website) by using a fusker [v -ED, -ING, -S]\n",
  "FUSKED": "FUSK, to obtain data from (a website) by using a fusker [v]\n",
  "FUSKER": "to generates obvious passwords and filenames in order to extract data that is held on free websites [v -ED, -ING, -S]\n",
  "FUSKERED": "FUSKER, to generates obvious passwords and filenames in order to extract data that is held on free websites [v]\n",
  "FUSKERING": "FUSKER, to generates obvious passwords and filenames in order to extract data that is held on free websites [v]\n",
  "FUSKERS": "FUSKER [n]\n",
  "FUSKING": "FUSK, to obtain data from (a website) by using a fusker [v]\n",
  "FUSKS": "FUSK, to obtain data from (a website) by using a fusker [v]\n",
  "FUSS": "to be overly concerned with small details [v -ED, -ING, -ES]\n",
  "FUSSBALL": "(US) table football, also FUSBALL, FOOSBALL [n -S]\n",
  "FUSSBALLS": "FUSSBALL, (US) table football, also FUSBALL, FOOSBALL [n]\n",
  "FUSSBUDGET": "(US) one who is fussy about unimportant things [n -S]\n",
  "FUSSBUDGETIER": "FUSSBUDGETY, like a fussbudget, a person who fusses about unimportant things [adj]\n",
  "FUSSBUDGETIEST": "FUSSBUDGETY, like a fussbudget, a person who fusses about unimportant things [adj]\n",
  "FUSSBUDGETS": "FUSSBUDGET, (US) one who is fussy about unimportant things [n]\n",
  "FUSSBUDGETY": "like a fussbudget, a person who fusses about unimportant things [adj FUSSBUDGETIER, FUSSBUDGETIEST]\n",
  "FUSSED": "FUSS, to be overly concerned with small details [v]\n",
  "FUSSER": "one that fusses [n -S]\n",
  "FUSSERS": "FUSSER, one that fusses [n]\n",
  "FUSSES": "FUSS, to be overly concerned with small details [v]\n",
  "FUSSIER": "FUSSY, overly concerned with small details [adj]\n",
  "FUSSIEST": "FUSSY, overly concerned with small details [adj]\n",
  "FUSSILY": "FUSSY, overly concerned with small details [adv]\n",
  "FUSSINESS": "the state of being fussy [n -ES]\n",
  "FUSSINESSES": "FUSSINESS, the state of being fussy [n]\n",
  "FUSSING": "FUSS, to be overly concerned with small details [v]\n",
  "FUSSPOT": "a fussy person [n -S]\n",
  "FUSSPOTS": "FUSSPOT, a fussy person [n]\n",
  "FUSSY": "overly concerned with small details [adj FUSSIER, FUSSIEST, FUSSILY]\n",
  "FUST": "to smell mouldy [v -ED, -ING, -S]\n",
  "FUSTANELLA": "(Italian) a white kilt worn by Greek and Albanian men, also FUSTANELLE [n -S]\n",
  "FUSTANELLAS": "FUSTANELLA, (Italian) a white kilt worn by Greek and Albanian men, also FUSTANELLE [n]\n",
  "FUSTANELLE": "a white kilt worn by Greek and Albanian men, also FUSTANELLA [n -S]\n",
  "FUSTANELLES": "FUSTANELLE, a white kilt worn by Greek and Albanian men, also FUSTANELLA [n]\n",
  "FUSTED": "FUST, to smell mouldy [v]\n",
  "FUSTET": "(French) the wood of a tree growing in the West Indies, used in dyeing yellow, also FUSTIC, FUSTOC [n -S]\n",
  "FUSTETS": "FUSTET, (French) the wood of a tree growing in the West Indies, used in dyeing yellow, also FUSTIC, FUSTOC [n]\n",
  "FUSTIAN": "a coarse, sturdy cloth of cotton and flax [n -S]\n",
  "FUSTIANISE": "to write bombastically, also FUSTIANIZE [v FUSTIANISED, FUSTIANISING, FUSTIANISES]\n",
  "FUSTIANISED": "FUSTIANISE, to write bombastically, also FUSTIANIZE [v]\n",
  "FUSTIANISES": "FUSTIANISE, to write bombastically, also FUSTIANIZE [v]\n",
  "FUSTIANISING": "FUSTIANISE, to write bombastically, also FUSTIANIZE [v]\n",
  "FUSTIANIST": "a writer of fustian [n -S]\n",
  "FUSTIANISTS": "FUSTIANIST, a writer of fustian [n]\n",
  "FUSTIANIZE": "to write bombastically, also FUSTIANISE [v FUSTIANIZED, FUSTIANIZING, FUSTIANIZES]\n",
  "FUSTIANIZED": "FUSTIANIZE, to write bombastically, also FUSTIANISE [v]\n",
  "FUSTIANIZES": "FUSTIANIZE, to write bombastically, also FUSTIANISE [v]\n",
  "FUSTIANIZING": "FUSTIANIZE, to write bombastically, also FUSTIANISE [v]\n",
  "FUSTIANS": "FUSTIAN, a coarse, sturdy cloth of cotton and flax [n]\n",
  "FUSTIC": "(French) the wood of a tree growing in the West Indies, used in dyeing yellow, also FUSTET, FUSTOC [n -S]\n",
  "FUSTICS": "FUSTIC, (French) the wood of a tree growing in the West Indies, used in dyeing yellow, also FUSTET, FUSTOC [n]\n",
  "FUSTIER": "FUSTY, old-fashioned; musty, also FOUSTY [adj]\n",
  "FUSTIEST": "FUSTY, old-fashioned; musty, also FOUSTY [adj]\n",
  "FUSTIGATE": "(obsolete) to beat with a club [v FUSTIGATED, FUSTIGATING, FUSTIGATES]\n",
  "FUSTIGATED": "FUSTIGATE, (obsolete) to beat with a club [v]\n",
  "FUSTIGATES": "FUSTIGATE, (obsolete) to beat with a club [v]\n",
  "FUSTIGATING": "FUSTIGATE, (obsolete) to beat with a club [v]\n",
  "FUSTIGATION": "beating with a club [n -S]\n",
  "FUSTIGATIONS": "FUSTIGATION, beating with a club [n]\n",
  "FUSTIGATOR": "one who fustigates, beats with a club [n -S]\n",
  "FUSTIGATORS": "FUSTIGATOR, one who fustigates, beats with a club [n]\n",
  "FUSTIGATORY": "relating to fustigation, beating with a club [adj]\n",
  "FUSTILARIAN": "(Shakespeare) a fat and slovenly person, also FUSTILIRIAN, FUSTILLIRIAN [n -S]\n",
  "FUSTILARIANS": "FUSTILARIAN, (Shakespeare) a fat and slovenly person, also FUSTILIRIAN, FUSTILLIRIAN [n]\n",
  "FUSTILIRIAN": "(Shakespeare) a term of abuse, also FUSTILARIAN, FUSTILLIRIAN [n -S]\n",
  "FUSTILIRIANS": "FUSTILIRIAN, (Shakespeare) a term of abuse, also FUSTILARIAN, FUSTILLIRIAN [n]\n",
  "FUSTILLIRIAN": "(Shakespeare) a term of abuse, also FUSTILARIAN, FUSTILIRIAN [n -S]\n",
  "FUSTILLIRIANS": "FUSTILLIRIAN, (Shakespeare) a term of abuse, also FUSTILARIAN, FUSTILIRIAN [n]\n",
  "FUSTILUGS": "(obsolete) a fat and slovenly person [n FUSTILUGS]\n",
  "FUSTILY": "FUSTY, old-fashioned; musty, also FOUSTY [adv]\n",
  "FUSTINESS": "the state of being fusty [n -ES]\n",
  "FUSTINESSES": "FUSTINESS, the state of being fusty [n]\n",
  "FUSTING": "FUST, to smell mouldy [v]\n",
  "FUSTOC": "(French) the wood of a tree growing in the West Indies, used in dyeing yellow, also FUSTET, FUSTIC [n -S]\n",
  "FUSTOCS": "FUSTOC, (French) the wood of a tree growing in the West Indies, used in dyeing yellow, also FUSTET, FUSTIC [n]\n",
  "FUSTS": "FUST, to smell mouldy [v]\n",
  "FUSTY": "old-fashioned; musty, also FOUSTY [adj FUSTIER, FUSTIEST, FUSTILY]\n",
  "FUSULINID": "any of a family of extinct marine foraminifera [n -S]\n",
  "FUSULINIDS": "FUSULINID, any of a family of extinct marine foraminifera [n]\n",
  "FUSUMA": "(Japanese) a sliding door [n -S]\n",
  "FUSUMAS": "FUSUMA, (Japanese) a sliding door [n]\n",
  "FUTCHEL": "a support in a carriage [n -S]\n",
  "FUTCHELS": "FUTCHEL, a support in a carriage [n]\n",
  "FUTHARC": "the runic alphabet, also FUTHARK, FUTHORC, FUTHORK [n -S]\n",
  "FUTHARCS": "FUTHARC, the runic alphabet, also FUTHARK, FUTHORC, FUTHORK [n]\n",
  "FUTHARK": "the runic alphabet, also FUTHARC, FUTHORC, FUTHORK [n -S]\n",
  "FUTHARKS": "FUTHARK, the runic alphabet, also FUTHARC, FUTHORC, FUTHORK [n]\n",
  "FUTHORC": "the runic alphabet, also FUTHARC, FUTHARK, FUTHORK [n -S]\n",
  "FUTHORCS": "FUTHORC, the runic alphabet, also FUTHARC, FUTHARK, FUTHORK [n]\n",
  "FUTHORK": "the runic alphabet, also FUTHARC, FUTHARK, FUTHORC [n -S]\n",
  "FUTHORKS": "FUTHORK, the runic alphabet, also FUTHARC, FUTHARK, FUTHORC [n]\n",
  "FUTILE": "ineffective [adj FUTILER, FUTILEST, FUTILELY]\n",
  "FUTILELY": "FUTILE, ineffective [adv]\n",
  "FUTILENESS": "futility [n -ES]\n",
  "FUTILENESSES": "FUTILENESS, futility [n]\n",
  "FUTILER": "FUTILE, ineffective [adj]\n",
  "FUTILEST": "FUTILE, ineffective [adj]\n",
  "FUTILITARIAN": "one who believes that human striving is futile [n -S]\n",
  "FUTILITARIANISM": "the belief that human striving is futile [n]\n",
  "FUTILITARIANS": "FUTILITARIAN, one who believes that human striving is futile [n]\n",
  "FUTILITIES": "FUTILITY, uselessness [n]\n",
  "FUTILITY": "uselessness [n FUTILITIES]\n",
  "FUTON": "(Japanese) a cotton filled mattress used as a bed [n -S]\n",
  "FUTONS": "FUTON, (Japanese) a cotton filled mattress used as a bed [n]\n",
  "FUTSAL": "a form of association football, played indoors with five a side, also FOOTSAL [n -S]\n",
  "FUTSALS": "FUTSAL, a form of association football, played indoors with five a side, also FOOTSAL [n]\n",
  "FUTTOCK": "one of the curved timbers scarfed together to form the lower part of a compound rib of a ship [n -S]\n",
  "FUTTOCKS": "FUTTOCK, one of the curved timbers scarfed together to form the lower part of a compound rib of a ship [n]\n",
  "FUTURAL": "of the future [adj]\n",
  "FUTURE": "the time yet to come [n -S]\n",
  "FUTURELESS": "without prospect of betterment in the future [adj]\n",
  "FUTURELESSNESS": "FUTURELESS, without prospect of betterment in the future [n]\n",
  "FUTURES": "FUTURE, the time yet to come [n]\n",
  "FUTURISM": "an artistic and literary movement [n -S]\n",
  "FUTURISMS": "FUTURISM, an artistic and literary movement [n]\n",
  "FUTURIST": "a proponent of futurism [n -S]\n",
  "FUTURISTIC": "of or relating to futurism, an artistic movement [adj FUTURISTICALLY]\n",
  "FUTURISTICALLY": "FUTURISTIC, of or relating to futurism, an artistic movement [adv]\n",
  "FUTURISTICS": "futurology [n]\n",
  "FUTURISTS": "FUTURIST, a proponent of futurism [n]\n",
  "FUTURITIES": "FUTURITY, the state of being in the future [n]\n",
  "FUTURITION": "future existence; time to come [n -S]\n",
  "FUTURITIONS": "FUTURITION, future existence; time to come [n]\n",
  "FUTURITY": "the state of being in the future [n FUTURITIES]\n",
  "FUTUROLOGICAL": "relating to futurology [adj]\n",
  "FUTUROLOGIES": "FUTUROLOGY, the study of the future [n]\n",
  "FUTUROLOGIST": "a student of futurology [n -S]\n",
  "FUTUROLOGISTS": "FUTUROLOGIST, a student of futurology [n]\n",
  "FUTUROLOGY": "the study of the future [n FUTUROLOGIES]\n",
  "FUTZ": "(Yiddish) to spend time aimlessly [v -ED, -ING, -ES]\n",
  "FUTZED": "FUTZ, (Yiddish) to spend time aimlessly [v]\n",
  "FUTZES": "FUTZ, (Yiddish) to spend time aimlessly [v]\n",
  "FUTZING": "FUTZ, (Yiddish) to spend time aimlessly [v]\n",
  "FUZE": "to equip with a detonating device, also FUSE [v FUZED, FUZING, FUZES]\n",
  "FUZED": "FUZE, to equip with a detonating device, also FUSE [v]\n",
  "FUZEE": "(French) a match with a long oval head for outdoor use, also FUSEE [n -S]\n",
  "FUZEES": "FUZEE, (French) a match with a long oval head for outdoor use, also FUSEE [n]\n",
  "FUZELESS": "without a fuze, also FUSELESS [adj]\n",
  "FUZES": "FUZE, to equip with a detonating device, also FUSE [v]\n",
  "FUZIL": "a type of flintlock musket, also FUSIL [n -S]\n",
  "FUZILS": "FUZIL, a type of flintlock musket, also FUSIL [n]\n",
  "FUZING": "FUZE, to equip with a detonating device, also FUSE [v]\n",
  "FUZZ": "to become fuzzy [v -ED, -ING, -ES]\n",
  "FUZZBALL": "a ball of fuzz [n -S]\n",
  "FUZZBALLS": "FUZZBALL, a ball of fuzz [n]\n",
  "FUZZBOX": "an electronic device used to distort the sound of e.g. an electric guitar [n -ES]\n",
  "FUZZBOXES": "FUZZBOX, an electronic device used to distort the sound of e.g. an electric guitar [n]\n",
  "FUZZED": "FUZZ, to become fuzzy [v]\n",
  "FUZZES": "FUZZ, to become fuzzy [v]\n",
  "FUZZIER": "FUZZY, covered with fuzz [adj]\n",
  "FUZZIEST": "FUZZY, covered with fuzz [adj]\n",
  "FUZZILY": "FUZZY, covered with fuzz [adv]\n",
  "FUZZINESS": "the state of being fuzzy [n -ES]\n",
  "FUZZINESSES": "FUZZINESS, the state of being fuzzy [n]\n",
  "FUZZING": "FUZZ, to become fuzzy [v]\n",
  "FUZZLE": "(dialect) to intoxicate, confuse, muddle [v FUZZLED, FUZZLING, FUZZLES]\n",
  "FUZZLED": "FUZZLE, (dialect) to intoxicate, confuse, muddle [v]\n",
  "FUZZLES": "FUZZLE, (dialect) to intoxicate, confuse, muddle [v]\n",
  "FUZZLING": "FUZZLE, (dialect) to intoxicate, confuse, muddle [v]\n",
  "FUZZTONE": "a device for distorting the sound of an electric guitar [n -S]\n",
  "FUZZTONES": "FUZZTONE, a device for distorting the sound of an electric guitar [n]\n",
  "FUZZY": "covered with fuzz [adj FUZZIER, FUZZIEST, FUZZILY]\n",
  "FY": "expressing disapproval, also FIE [interj]\n",
  "FYCE": "a small dog of mixed breed, also FEIST, FICE [n -S]\n",
  "FYCES": "FYCE, a small dog of mixed breed, also FEIST, FICE [n]\n",
  "FYKE": "(Scots) to fidget restlessly, also FIKE [v FYKED, FYKING, FYKES]\n",
  "FYKED": "FYKE, (Scots) to fidget restlessly, also FIKE [v]\n",
  "FYKES": "FYKE, (Scots) to fidget restlessly, also FIKE [v]\n",
  "FYKING": "FYKE, (Scots) to fidget restlessly, also FIKE [v]\n",
  "FYLE": "(Spenser) a line (file) of soldiers [n -S]\n",
  "FYLES": "FYLE, (Spenser) a line (file) of soldiers [n]\n",
  "FYLFOT": "a form of cross like a swastika, also FILFOT [n -S]\n",
  "FYLFOTS": "FYLFOT, a form of cross like a swastika, also FILFOT [n]\n",
  "FYNBOS": "(South African) in South Africa, an area of low shrubs [n -ES]\n",
  "FYNBOSES": "FYNBOS, (South African) in South Africa, an area of low shrubs [n]\n",
  "FYRD": "(Old English) a local militia in Anglo-Saxon times [n -S]\n",
  "FYRDS": "FYRD, (Old English) a local militia in Anglo-Saxon times [n]\n",
  "FYTTE": "(archaic) a division of a poem, also FITT, FITTE [n -S]\n",
  "FYTTES": "FYTTE, (archaic) a division of a poem, also FITT, FITTE [n]\n",
  "GAB": "to chatter [v GABBED, GABBING, GABS]\n",
  "GABAPENTIN": "an antiepileptic drug [n -S]\n",
  "GABAPENTINS": "GABAPENTIN, an antiepileptic drug [n]\n",
  "GABARDINE": "a closely woven twill fabric; a coat of this material, also GABERDINE [n -S]\n",
  "GABARDINES": "GABARDINE, a closely woven twill fabric; a coat of this material, also GABERDINE [n]\n",
  "GABBA": "a style of electronic dance music with a very fast heavy rhythm [n -S]\n",
  "GABBARD": "(Scots) a kind of barge, also GABBART [n -S]\n",
  "GABBARDS": "GABBARD, (Scots) a kind of barge, also GABBART [n]\n",
  "GABBART": "(Scots) a kind of barge, also GABBARD [n -S]\n",
  "GABBARTS": "GABBART, (Scots) a kind of barge, also GABBARD [n]\n",
  "GABBAS": "GABBA, a style of electronic dance music with a very fast heavy rhythm [n]\n",
  "GABBED": "GAB, to chatter [v]\n",
  "GABBER": "a chatterbox [n -S]\n",
  "GABBERS": "GABBER, a chatterbox [n]\n",
  "GABBIER": "GABBY, talkative [adj]\n",
  "GABBIEST": "GABBY, talkative [adj]\n",
  "GABBINESS": "the state of being gabby, loquacious [n -ES]\n",
  "GABBINESSES": "GABBINESS, the state of being gabby, loquacious [n]\n",
  "GABBING": "GAB, to chatter [v]\n",
  "GABBLE": "to chatter or talk inarticulately [v GABBLED, GABBLING, GABBLES]\n",
  "GABBLED": "GABBLE, to chatter or talk inarticulately [v]\n",
  "GABBLEMENT": "gabbling [n -S]\n",
  "GABBLEMENTS": "GABBLEMENT, gabbling [n]\n",
  "GABBLER": "one who gabbles [n -S]\n",
  "GABBLERS": "GABBLER, one who gabbles [n]\n",
  "GABBLES": "GABBLE, to chatter or talk inarticulately [v]\n",
  "GABBLING": "talking inarticulately [n -S]\n",
  "GABBLINGS": "GABBLING, talking inarticulately [n]\n",
  "GABBRO": "(Italian) a coarsely crystalline igneous rock [n -S]\n",
  "GABBROIC": "of or like gabbro, also GABBROID, GABBROITIC [adj]\n",
  "GABBROID": "like gabbro [adj]\n",
  "GABBROITIC": "of or like gabbro, also GABBROIC, GABBROID [adj]\n",
  "GABBROS": "GABBRO, (Italian) a coarsely crystalline igneous rock [n]\n",
  "GABBY": "talkative [adj GABBIER, GABBIEST]\n",
  "GABELLE": "(French) a tax on salt [n -S]\n",
  "GABELLED": "subject to gabelle, a salt tax [adj]\n",
  "GABELLER": "a collector of gabelle, a tax on salt [n -S]\n",
  "GABELLERS": "GABELLER, a collector of gabelle, a tax on salt [n]\n",
  "GABELLES": "GABELLE, (French) a tax on salt [n]\n",
  "GABERDINE": "a closely woven twill fabric, also GABARDINE [n -S]\n",
  "GABERDINES": "GABERDINE, a closely woven twill fabric, also GABARDINE [n]\n",
  "GABERLUNZIE": "(Scots) a wandering beggar or a harmless hobo [n -S]\n",
  "GABERLUNZIES": "GABERLUNZIE, (Scots) a wandering beggar or a harmless hobo [n]\n",
  "GABFEST": "(slang) a gathering characterised by much talk and gossip [n -S]\n",
  "GABFESTS": "GABFEST, (slang) a gathering characterised by much talk and gossip [n]\n",
  "GABIES": "GABY, (dialect) a simpleton [n]\n",
  "GABION": "(French) a basket of earth or stones used for fortification [n -S]\n",
  "GABIONADE": "(French) a traverse made with gabions between guns or on their flanks, protecting them from enfilading fire, also GABIONNADE [n -S]\n",
  "GABIONADES": "GABIONADE, (French) a traverse made with gabions between guns or on their flanks, protecting them from enfilading fire, also GABIONNADE [n]\n",
  "GABIONAGE": "the part of a fortification built of gabions [n -S]\n",
  "GABIONAGES": "GABIONAGE, the part of a fortification built of gabions [n]\n",
  "GABIONED": "furnished with gabions, wicker or wire baskets of earth or rock [adj]\n",
  "GABIONNADE": "a traverse made with gabions between guns or on their flanks, protecting them from enfilading fire, also GABIONADE [n -S]\n",
  "GABIONNADES": "GABIONNADE, a traverse made with gabions between guns or on their flanks, protecting them from enfilading fire, also GABIONADE [n]\n",
  "GABIONS": "GABION, (French) a basket of earth or stones used for fortification [n]\n",
  "GABLE": "to form a gable (a triangular section of wall) [v GABLED, GABLING, GABLES]\n",
  "GABLED": "GABLE, to form a gable (a triangular section of wall) [v]\n",
  "GABLELIKE": "like a gable [adj]\n",
  "GABLES": "GABLE, to form a gable (a triangular section of wall) [v]\n",
  "GABLET": "a small gable [n -S]\n",
  "GABLETS": "GABLET, a small gable [n]\n",
  "GABLING": "GABLE, to form a gable (a triangular section of wall) [v]\n",
  "GABNASH": "(Scots) chatter, prattle, also NASHGAB [n -ES]\n",
  "GABNASHES": "GABNASH, (Scots) chatter, prattle, also NASHGAB [n]\n",
  "GABOON": "a West African hardwood [n -S]\n",
  "GABOONS": "GABOON, a West African hardwood [n]\n",
  "GABS": "GAB, to chatter [v]\n",
  "GABY": "(dialect) a simpleton [n GABIES]\n",
  "GACH": "to behave boastfully, also GATCH, GAUCH [v -ED, -ING, -ES]\n",
  "GACHED": "GACH, to behave boastfully, also GATCH, GAUCH [v]\n",
  "GACHER": "one that gaches, a boaster [n -S]\n",
  "GACHERS": "GACHER, one that gaches, a boaster [n]\n",
  "GACHES": "GACH, to behave boastfully, also GATCH, GAUCH [v]\n",
  "GACHING": "GACH, to behave boastfully, also GATCH, GAUCH [v]\n",
  "GAD": "to roam about restlessly [v GADDED, GADDING, GADS]\n",
  "GADABOUT": "one that gads about [n -S]\n",
  "GADABOUTS": "GADABOUT, one that gads about [n]\n",
  "GADARENE": "headlong; precipitate [adj]\n",
  "GADDED": "GAD, to roam about restlessly [v]\n",
  "GADDER": "one that gads about [n -S]\n",
  "GADDERS": "GADDER, one that gads about [n]\n",
  "GADDI": "(Marathi) the cushioned throne of an Indian ruler, also GADI [n -S]\n",
  "GADDING": "GAD, to roam about restlessly [v]\n",
  "GADDIS": "GADDI, (Marathi) the cushioned throne of an Indian ruler, also GADI [n]\n",
  "GADE": "a miner's wedge, also GAID [n -S]\n",
  "GADES": "GADE, a miner's wedge, also GAID [n]\n",
  "GADFLIES": "GADFLY, any of various flies (as a horsefly, botfly, or warble fly) that bite or annoy livestock [n]\n",
  "GADFLY": "any of various flies (as a horsefly, botfly, or warble fly) that bite or annoy livestock [n GADFLIES]\n",
  "GADGE": "an instrument of torture [n -S]\n",
  "GADGES": "GADGE, an instrument of torture [n]\n",
  "GADGET": "a mechanical device [n -S]\n",
  "GADGETEER": "someone who delights in gadgets [n -S]\n",
  "GADGETEERS": "GADGETEER, someone who delights in gadgets [n]\n",
  "GADGETIER": "GADGETY, of or like a gadget [adj]\n",
  "GADGETIEST": "GADGETY, of or like a gadget [adj]\n",
  "GADGETRIES": "GADGETRY, the devising or construction of gadgets [n]\n",
  "GADGETRY": "the devising or construction of gadgets [n GADGETRIES]\n",
  "GADGETS": "GADGET, a mechanical device [n]\n",
  "GADGETY": "of or like a gadget [adj GADGETIER, GADGETIEST]\n",
  "GADGIE": "(Romany) a fellow, also GADJE, GADJO, GAJO, GAUDGIE, GAUJE, GORGIO [n -S]\n",
  "GADGIES": "GADGIE, (Romany) a fellow, also GADJE, GADJO, GAJO, GAUDGIE, GAUJE, GORGIO [n]\n",
  "GADI": "(Marathi) the cushioned throne of an Indian ruler, also GADDI [n -S]\n",
  "GADID": "a type of fish, also GADOID [n -S]\n",
  "GADIDS": "GADID, a type of fish, also GADOID [n]\n",
  "GADIS": "GADI, (Marathi) the cushioned throne of an Indian ruler, also GADDI [n]\n",
  "GADJE": "(Romany) a fellow, also GADGIE, GAUDGIE, GAUJE [n -S]\n",
  "GADJES": "GADJE, (Romany) a fellow, also GADGIE, GAUDGIE, GAUJE [n]\n",
  "GADJO": "(Romany) a non-gypsy, also GADGIE, GADJE, GAJO, GAUDGIE, GAUJE, GORGIO [n -S]\n",
  "GADJOS": "GADJO, (Romany) a non-gypsy, also GADGIE, GADJE, GAJO, GAUDGIE, GAUJE, GORGIO [n]\n",
  "GADLING": "(obsolete) a vagabond [n -S]\n",
  "GADLINGS": "GADLING, (obsolete) a vagabond [n]\n",
  "GADMAN": "(Scots) a person who drives horses at the plough, also GADSMAN [n GADMEN]\n",
  "GADMEN": "GADMAN, (Scots) a person who drives horses at the plough, also GADSMAN [n]\n",
  "GADOID": "a member of the cod family, also GADID [n -S]\n",
  "GADOIDS": "GADOID, a member of the cod family, also GADID [n]\n",
  "GADOLINIC": "of or like gadolinium [adj]\n",
  "GADOLINITE": "a mineral of a nearly black color and vitreous luster, and consisting principally of the silicates of yttrium, cerium, and iron [n -S]\n",
  "GADOLINITES": "GADOLINITE, a mineral of a nearly black color and vitreous luster, and consisting principally of the silicates of yttrium, cerium, and iron [n]\n",
  "GADOLINIUM": "a rare metallic element found associated with yttrium and other rare metals [n -S]\n",
  "GADOLINIUMS": "GADOLINIUM, a rare metallic element found associated with yttrium and other rare metals [n]\n",
  "GADROON": "to decorate with moulding bands [v -ED, -ING, -S]\n",
  "GADROONED": "GADROON, to decorate with moulding bands [v]\n",
  "GADROONING": "ornamentation with gadroons [n -S]\n",
  "GADROONINGS": "GADROONING, ornamentation with gadroons [n]\n",
  "GADROONS": "GADROON, to decorate with moulding bands [v]\n",
  "GADS": "GAD, to roam about restlessly [v]\n",
  "GADSMAN": "(Scots) a person who drives horses at the plough, also GADMAN [n GADSMEN]\n",
  "GADSMEN": "GADSMAN, (Scots) a person who drives horses at the plough, also GADMAN [n]\n",
  "GADSO": "(archaic) expressing surprise, also GODSO [interj]\n",
  "GADWALL": "a large duck, found in the northern parts of Europe and America [n -S]\n",
  "GADWALLS": "GADWALL, a large duck, found in the northern parts of Europe and America [n]\n",
  "GADZOOKERIES": "GADZOOKERY, the use of archaisms (as in a historical novel) [n]\n",
  "GADZOOKERY": "the use of archaisms (as in a historical novel) [n GADZOOKERIES]\n",
  "GADZOOKS": "(archaic) a mild oath, also ODZOOKS, ZOOKS [interj]\n",
  "GAE": "(Scots) to go [v GAED, GANE, GAUN or GAEING, GAEN or GAES]\n",
  "GAED": "GAE, (Scots) to go [v]\n",
  "GAEING": "GAE, (Scots) to go [v]\n",
  "GAELICISE": "to render into Gaelic, also GAELICIZE [v GAELICISED, GAELICISING, GAELICISES]\n",
  "GAELICISED": "GAELICISE, to render into Gaelic, also GAELICIZE [v]\n",
  "GAELICISES": "GAELICISE, to render into Gaelic, also GAELICIZE [v]\n",
  "GAELICISING": "GAELICISE, to render into Gaelic, also GAELICIZE [v]\n",
  "GAELICISM": "the Gaelic world [n -S]\n",
  "GAELICISMS": "GAELICISM, the Gaelic world [n]\n",
  "GAELICIZE": "to render into Gaelic, also GAELICISE [v GAELICIZED, GAELICIZING, GAELICIZES]\n",
  "GAELICIZED": "GAELICIZE, to render into Gaelic, also GAELICISE [v]\n",
  "GAELICIZES": "GAELICIZE, to render into Gaelic, also GAELICISE [v]\n",
  "GAELICIZING": "GAELICIZE, to render into Gaelic, also GAELICISE [v]\n",
  "GAEN": "GAE, (Scots) to go [v]\n",
  "GAES": "GAE, (Scots) to go [v]\n",
  "GAFF": "to catch a fish with a sharp hook [v -ED, -ING, -S]\n",
  "GAFFE": "(French) a social blunder [n -S]\n",
  "GAFFED": "GAFF, to catch a fish with a sharp hook [v]\n",
  "GAFFER": "an old man; a TV lighting technician [n -S]\n",
  "GAFFERS": "GAFFER, an old man; a TV lighting technician [n]\n",
  "GAFFES": "GAFFE, (French) a social blunder [n]\n",
  "GAFFING": "the act of gambling [n -S]\n",
  "GAFFINGS": "GAFFING, the act of gambling [n]\n",
  "GAFFS": "GAFF, to catch a fish with a sharp hook [v]\n",
  "GAFFSAIL": "a quadrilateral foresail [n -S]\n",
  "GAFFSAILS": "GAFFSAIL, a quadrilateral foresail [n]\n",
  "GAG": "to stop up the mouth [v GAGGED, GAGGING, GAGS]\n",
  "GAGA": "(French) in senile dotage [adj]\n",
  "GAGAKU": "(Japanese) a type of Japanese classical music [n -S]\n",
  "GAGAKUS": "GAGAKU, (Japanese) a type of Japanese classical music [n]\n",
  "GAGE": "to pledge as security [v GAGED, GAGING, GAGES]\n",
  "GAGEABLE": "able to be gaged, also GAUGEABLE [adj GAGEABLY]\n",
  "GAGEABLY": "GAGEABLE, able to be gaged, also GAUGEABLE [adv]\n",
  "GAGED": "GAGE, to pledge as security [v]\n",
  "GAGER": "one who gauges; an officer whose business it is to ascertain the contents of casks, also GAUGER [n -S]\n",
  "GAGERS": "GAGER, one who gauges; an officer whose business it is to ascertain the contents of casks, also GAUGER [n]\n",
  "GAGES": "GAGE, to pledge as security [v]\n",
  "GAGGED": "GAG, to stop up the mouth [v]\n",
  "GAGGER": "one who gags [n -S]\n",
  "GAGGERIES": "GAGGERY, the practice of telling jokes [n]\n",
  "GAGGERS": "GAGGER, one who gags [n]\n",
  "GAGGERY": "the practice of telling jokes [n GAGGERIES]\n",
  "GAGGING": "GAG, to stop up the mouth [v]\n",
  "GAGGLE": "to cackle [v GAGGLED, GAGGLING, GAGGLES]\n",
  "GAGGLED": "GAGGLE, to cackle [v]\n",
  "GAGGLES": "GAGGLE, to cackle [v]\n",
  "GAGGLING": "making a cackling sound [n -S]\n",
  "GAGGLINGS": "GAGGLING, making a cackling sound [n]\n",
  "GAGING": "GAGE, to pledge as security [v]\n",
  "GAGMAN": "one who writes jokes [n GAGMEN]\n",
  "GAGMEN": "GAGMAN, one who writes jokes [n]\n",
  "GAGS": "GAG, to stop up the mouth [v]\n",
  "GAGSTER": "one who writes jokes [n -S]\n",
  "GAGSTERS": "GAGSTER, one who writes jokes [n]\n",
  "GAHNITE": "(Swedish) a mineral, zinc spinel [n -S]\n",
  "GAHNITES": "GAHNITE, (Swedish) a mineral, zinc spinel [n]\n",
  "GAID": "a miner's wedge, also GADE [n -S]\n",
  "GAIDS": "GAID, a miner's wedge, also GADE [n]\n",
  "GAIETIES": "GAIETY, festive activity, also GAYETY [n]\n",
  "GAIETY": "festive activity, also GAYETY [n GAIETIES]\n",
  "GAIJIN": "(Japanese) a foreigner in Japan [n GAIJIN]\n",
  "GAILLARD": "(obsolete) brisk, lively, also GAILLARDE [adj]\n",
  "GAILLARDE": "(obsolete) brisk, lively, also GAILLARD [adj]\n",
  "GAILLARDIA": "a North American garden flower [n -S]\n",
  "GAILLARDIAS": "GAILLARDIA, a North American garden flower [n]\n",
  "GAILY": "GAY, cheerful [adv]\n",
  "GAIN": "to acquire [v -ED, -ING, -S] / near, convenient [adj GAINER, GAINEST]\n",
  "GAINABLE": "able to be gained [adj]\n",
  "GAINED": "GAIN, to acquire [v]\n",
  "GAINER": "one who gains [n -S]\n",
  "GAINERS": "GAINER, one who gains [n]\n",
  "GAINEST": "GAIN, near, convenient [adj]\n",
  "GAINFUL": "profitable [adj GAINFULLY]\n",
  "GAINFULLY": "GAINFUL, profitable [adv]\n",
  "GAINFULNESS": "the state of being gainful [n -ES]\n",
  "GAINFULNESSES": "GAINFULNESS, the state of being gainful [n]\n",
  "GAINGIVING": "(Shakespeare) a misgiving [n -S]\n",
  "GAINGIVINGS": "GAINGIVING, (Shakespeare) a misgiving [n]\n",
  "GAINING": "a thing gained, profit [n -S]\n",
  "GAININGS": "things which are gained [n]\n",
  "GAINLESS": "profitless [adj]\n",
  "GAINLESSNESS": "the state of being gainless [n -ES]\n",
  "GAINLESSNESSES": "GAINLESSNESS, the state of being gainless [n]\n",
  "GAINLIER": "GAINLY, shapely, comely [adj]\n",
  "GAINLIEST": "GAINLY, shapely, comely [adj]\n",
  "GAINLINESS": "the state of being gainly [n -ES]\n",
  "GAINLINESSES": "GAINLINESS, the state of being gainly [n]\n",
  "GAINLY": "shapely, comely [adj GAINLIER, GAINLIEST]\n",
  "GAINS": "GAIN, to acquire [v]\n",
  "GAINSAID": "GAINSAY, to deny or contradict [v]\n",
  "GAINSAY": "to deny or contradict [v GAINSAID, GAINSAYING, GAINSAYS]\n",
  "GAINSAYER": "one who gainsays, contradicts [n -S]\n",
  "GAINSAYERS": "GAINSAYER, one who gainsays, contradicts [n]\n",
  "GAINSAYING": "the act of gainsaying [n -S]\n",
  "GAINSAYINGS": "GAINSAYING, the act of gainsaying [n]\n",
  "GAINSAYS": "GAINSAY, to deny or contradict [v]\n",
  "GAINSHARING": "a system in which employees are financially rewarded for reducing operating costs and working more efficiently [n -S]\n",
  "GAINSHARINGS": "GAINSHARING, a system in which employees are financially rewarded for reducing operating costs and working more efficiently [n]\n",
  "GAINST": "(archaic) against [prep]\n",
  "GAINSTRIVE": "(obsolete) to strive or struggle against [v GAINSTRIVED or GAINSTROVE, GAINSTRIVEN, GAINSTRIVING, GAINSTRIVES]\n",
  "GAINSTRIVED": "GAINSTRIVE, (obsolete) to strive or struggle against [v]\n",
  "GAINSTRIVEN": "GAINSTRIVE, (obsolete) to strive or struggle against [v]\n",
  "GAINSTRIVES": "GAINSTRIVE, (obsolete) to strive or struggle against [v]\n",
  "GAINSTRIVING": "GAINSTRIVE, (obsolete) to strive or struggle against [v]\n",
  "GAINSTROVE": "GAINSTRIVE, (obsolete) to strive or struggle against [v]\n",
  "GAIR": "(Scots) a triangular piece (of cloth or land), also GORE [n -S]\n",
  "GAIRFOWL": "(Old Norse) the great auk, also GAREFOWL [n -S]\n",
  "GAIRFOWLS": "GAIRFOWL, (Old Norse) the great auk, also GAREFOWL [n]\n",
  "GAIRS": "GAIR, (Scots) a triangular piece (of cloth or land), also GORE [n]\n",
  "GAIT": "to train a horse to move in a certain way [v -ED, -ING, -S]\n",
  "GAITA": "(Spanish) a Spanish bagpipe [n -S]\n",
  "GAITAS": "GAITA, (Spanish) a Spanish bagpipe [n]\n",
  "GAITED": "GAIT, to train a horse to move in a certain way [v]\n",
  "GAITER": "a covering for the lower leg [n -S]\n",
  "GAITERED": "wearing gaiters [adj]\n",
  "GAITERLESS": "without gaiters [adj]\n",
  "GAITERS": "GAITER, a covering for the lower leg [n]\n",
  "GAITING": "GAIT, to train a horse to move in a certain way [v]\n",
  "GAITS": "GAIT, to train a horse to move in a certain way [v]\n",
  "GAITT": "(Scots) a child, also GEIT, GYTE [n -S]\n",
  "GAITTS": "GAITT, (Scots) a child, also GEIT, GYTE [n]\n",
  "GAJO": "(Romany) a non-gypsy, also GADGIE, GADJE, GADJO, GAUDGIE, GAUJE, GORGIO [n -S]\n",
  "GAJOS": "GAJO, (Romany) a non-gypsy, also GADGIE, GADJE, GADJO, GAUDGIE, GAUJE, GORGIO [n]\n",
  "GAK": "(slang) cocaine [n -S]\n",
  "GAKS": "GAK, (slang) cocaine [n]\n",
  "GAL": "a girl [n -S]\n",
  "GALA": "a celebration [n -S]\n",
  "GALABEA": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABEAH": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABEAHS": "GALABEAH, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALABEAS": "GALABEA, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALABIA": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABIAH": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEAH, GALABIA, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABIAHS": "GALABIAH, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEAH, GALABIA, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALABIAS": "GALABIA, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALABIEH": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABIEHS": "GALABIEH, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALABIYA": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEAH, GALABEA, GALABIA, GALABIAH, GALABIEH, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABIYAH": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALABIYAHS": "GALABIYAH, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALABIYAS": "GALABIYA, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEAH, GALABEA, GALABIA, GALABIAH, GALABIEH, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALACTAGOGUE": "a medicine that promotes secretion of milk [n -S]\n",
  "GALACTAGOGUES": "GALACTAGOGUE, a medicine that promotes secretion of milk [n]\n",
  "GALACTIC": "relating to or obtained from milk [adj]\n",
  "GALACTICO": "an internationally famous footballer [n -S]\n",
  "GALACTICOS": "GALACTICO, an internationally famous footballer [n]\n",
  "GALACTOMETER": "an instrument for measuring the specific gravity of milk [n -S]\n",
  "GALACTOMETERS": "GALACTOMETER, an instrument for measuring the specific gravity of milk [n]\n",
  "GALACTOMETRIES": "GALACTOMETRY, the measurement of the relative density of milk [n]\n",
  "GALACTOMETRY": "the measurement of the relative density of milk [n GALACTOMETRIES]\n",
  "GALACTOPHOROUS": "bearing milk [adj]\n",
  "GALACTOPOIESES": "GALACTOPOIESIS, the process of increasing the secretion of milk [n]\n",
  "GALACTOPOIESIS": "the process of increasing the secretion of milk [n GALACTOPOIESES]\n",
  "GALACTOPOIETIC": "milk-producing [adj] / a milk-producing agent [n -S]\n",
  "GALACTOPOIETICS": "GALACTOPOIETIC, a milk-producing agent [n]\n",
  "GALACTORRHEA": "a too abundant flow of milk, also GALACTORRHOEA [n -S]\n",
  "GALACTORRHEAS": "GALACTORRHEA, a too abundant flow of milk, also GALACTORRHOEA [n]\n",
  "GALACTORRHOEA": "a too abundant flow of milk, also GALACTORRHEA [n -S]\n",
  "GALACTORRHOEAS": "GALACTORRHOEA, a too abundant flow of milk, also GALACTORRHEA [n]\n",
  "GALACTOSAEMIA": "the presence of galactose in the blood, also GALACTOSEMIA [n -S]\n",
  "GALACTOSAEMIAS": "GALACTOSAEMIA, the presence of galactose in the blood, also GALACTOSEMIA [n]\n",
  "GALACTOSAEMIC": "relating to galactosaemia, the presence of galactose in the blood, also GALACTOSEMIC [adj]\n",
  "GALACTOSAMINE": "an amino derivative of galactose that occurs in cartilage [n -S]\n",
  "GALACTOSAMINES": "GALACTOSAMINE, an amino derivative of galactose that occurs in cartilage [n]\n",
  "GALACTOSE": "a sugar obtained by hydrolysis from lactose [n -S]\n",
  "GALACTOSEMIA": "the presence of galactose in the blood, also GALACTOSAEMIA [n -S]\n",
  "GALACTOSEMIAS": "GALACTOSEMIA, the presence of galactose in the blood, also GALACTOSAEMIA [n]\n",
  "GALACTOSEMIC": "relating to galactosemia, the presence of galactose in the blood, also GALACTOSAEMIC [adj]\n",
  "GALACTOSES": "GALACTOSE, a sugar obtained by hydrolysis from lactose [n]\n",
  "GALACTOSIDASE": "an enzyme (as lactase) that hydrolyzes a galactoside [n -S]\n",
  "GALACTOSIDASES": "GALACTOSIDASE, an enzyme (as lactase) that hydrolyzes a galactoside [n]\n",
  "GALACTOSIDE": "a glycoside that yields galactose on hydrolysis [n -S]\n",
  "GALACTOSIDES": "GALACTOSIDE, a glycoside that yields galactose on hydrolysis [n]\n",
  "GALACTOSYL": "a glycosyl radical derived from galactose [n -S]\n",
  "GALACTOSYLS": "GALACTOSYL, a glycosyl radical derived from galactose [n]\n",
  "GALAGE": "(obsolete) an overshoe, also GALOCHE, GALOSH, GALOSHE, GOLOSH, GOLOSHE [n -S]\n",
  "GALAGES": "GALAGE, (obsolete) an overshoe, also GALOCHE, GALOSH, GALOSHE, GOLOSH, GOLOSHE [n]\n",
  "GALAGO": "(Wolof) a kind of African lemur [n -S]\n",
  "GALAGOS": "GALAGO, (Wolof) a kind of African lemur [n]\n",
  "GALAH": "(Native Australian) an Australian bird of the parrot family; (figurative) a loud, rude person [n -S]\n",
  "GALAHS": "GALAH, (Native Australian) an Australian bird of the parrot family; (figurative) a loud, rude person [n]\n",
  "GALANGA": "the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGAL, GALENGALE, GALINGALE [n -S]\n",
  "GALANGAL": "the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGA, GALENGALE, GALINGALE [n -S]\n",
  "GALANGALS": "GALANGAL, the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGA, GALENGALE, GALINGALE [n]\n",
  "GALANGAS": "GALANGA, the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGAL, GALENGALE, GALINGALE [n]\n",
  "GALANT": "(French) an 18th-century style of music characterized by homophony and elaborate ornamentation [n -S]\n",
  "GALANTAMINE": "a compound, originally derived from flowers, especially daffodils and snowdrops, used as a drug in treating dementia [n -S]\n",
  "GALANTAMINES": "GALANTAMINE, a compound, originally derived from flowers, especially daffodils and snowdrops, used as a drug in treating dementia [n]\n",
  "GALANTINE": "(French) a preparation of jellied fowl [n -S]\n",
  "GALANTINES": "GALANTINE, (French) a preparation of jellied fowl [n]\n",
  "GALANTS": "GALANT, (French) an 18th-century style of music characterized by homophony and elaborate ornamentation [n]\n",
  "GALANTY": "as in galanty show, a pantomime shadow play [adj]\n",
  "GALAPAGO": "(Spanish) a kind of tortoise [n -S]\n",
  "GALAPAGOS": "GALAPAGO, (Spanish) a kind of tortoise [n]\n",
  "GALAS": "GALA, a celebration [n]\n",
  "GALATEA": "a durable cotton cloth, often striped [n -S]\n",
  "GALATEAS": "GALATEA, a durable cotton cloth, often striped [n]\n",
  "GALAVANT": "to roam about for pleasure without any definite plan, also GALIVANT, GALLIVANT [v -ED, -ING, -S]\n",
  "GALAVANTED": "GALAVANT, to roam about for pleasure without any definite plan, also GALIVANT, GALLIVANT [v]\n",
  "GALAVANTING": "GALAVANT, to roam about for pleasure without any definite plan, also GALIVANT, GALLIVANT [v]\n",
  "GALAVANTS": "GALAVANT, to roam about for pleasure without any definite plan, also GALIVANT, GALLIVANT [v]\n",
  "GALAX": "a heathlike evergreen plant of the southwestern US [n -ES]\n",
  "GALAXES": "GALAX, a heathlike evergreen plant of the southwestern US [n]\n",
  "GALAXIES": "GALAXY, a large system of celestial bodies [n]\n",
  "GALAXY": "a large system of celestial bodies [n GALAXIES]\n",
  "GALBANUM": "(Latin) a gum resin exuding from the stems of certain Asiatic umbelliferous plants [n -S]\n",
  "GALBANUMS": "GALBANUM, (Latin) a gum resin exuding from the stems of certain Asiatic umbelliferous plants [n]\n",
  "GALDRAGON": "(obsolete) a Shetland word for a sorceress or witch [n -S]\n",
  "GALDRAGONS": "GALDRAGON, (obsolete) a Shetland word for a sorceress or witch [n]\n",
  "GALE": "a strong wind [n -S] / to frolic playfully [v GALED, GALING, GALES]\n",
  "GALEA": "(Latin) a helmet-shaped anatomical part [n GALEAS or GALEAE]\n",
  "GALEAE": "GALEA, (Latin) a helmet-shaped anatomical part [n]\n",
  "GALEAS": "GALEA, (Latin) a helmet-shaped anatomical part [n]\n",
  "GALEATE": "helmet-shaped, also GALEATED [adj]\n",
  "GALEATED": "helmet-shaped, also GALEATE [adj]\n",
  "GALED": "GALE, to frolic playfully [v]\n",
  "GALEIFORM": "helmet-shaped [adj]\n",
  "GALENA": "(Latin) the principal ore of lead, also GALENITE [n -S]\n",
  "GALENAS": "GALENA, (Latin) the principal ore of lead, also GALENITE [n]\n",
  "GALENGALE": "the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGA, GALANGAL, GALINGALE [n -S]\n",
  "GALENGALES": "GALENGALE, the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGA, GALANGAL, GALINGALE [n]\n",
  "GALENIC": "pertaining to galena, an ore of lead [adj]\n",
  "GALENICAL": "a remedy of the kind prescribed by Galen, a vegetable simple [n -S]\n",
  "GALENICALS": "GALENICAL, a remedy of the kind prescribed by Galen, a vegetable simple [n]\n",
  "GALENITE": "the principal ore of lead, also GALENA [n -S]\n",
  "GALENITES": "GALENITE, the principal ore of lead, also GALENA [n]\n",
  "GALENOID": "of or like galena, a lead ore [adj]\n",
  "GALEOPITHECINE": "like a flying lemur, also GALEOPITHECOID [adj]\n",
  "GALEOPITHECOID": "like a flying lemur, also GALEOPITHECINE [adj]\n",
  "GALERE": "(French) a group of esp. undesirable people; an unpleasant situation [n -S]\n",
  "GALERES": "GALERE, (French) a group of esp. undesirable people; an unpleasant situation [n]\n",
  "GALES": "GALE, to frolic playfully [v]\n",
  "GALETTE": "(French) a round, flat, sweet or savoury cake [n -S]\n",
  "GALETTES": "GALETTE, (French) a round, flat, sweet or savoury cake [n]\n",
  "GALILEE": "a small chapel or porch at western end of some medieval English churches [n -S]\n",
  "GALILEES": "GALILEE, a small chapel or porch at western end of some medieval English churches [n]\n",
  "GALIMATIAS": "(French) nonsensical talk; gibberish [n -ES]\n",
  "GALIMATIASES": "GALIMATIAS, (French) nonsensical talk; gibberish [n]\n",
  "GALING": "GALE, to frolic playfully [v]\n",
  "GALINGALE": "the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGA, GALANGAL, GALENGALE [n -S]\n",
  "GALINGALES": "GALINGALE, the aromatic rootstock of certain East Indian plants of the ginger family, also GALANGA, GALANGAL, GALENGALE [n]\n",
  "GALIONGEE": "(Turkish) a Turkish sailor [n -S]\n",
  "GALIONGEES": "GALIONGEE, (Turkish) a Turkish sailor [n]\n",
  "GALIOT": "(French) a small galley, formerly used in the Mediterranean, also GALLIOT [n -S]\n",
  "GALIOTS": "GALIOT, (French) a small galley, formerly used in the Mediterranean, also GALLIOT [n]\n",
  "GALIPOT": "(French) the turpentine that exudes from the cluster pine, also GALLIPOT [n -S]\n",
  "GALIPOTS": "GALIPOT, (French) the turpentine that exudes from the cluster pine, also GALLIPOT [n]\n",
  "GALIVANT": "to roam about for pleasure without any definite plan, also GALAVANT, GALLIVANT [v -ED, -ING, -S]\n",
  "GALIVANTED": "GALIVANT, to roam about for pleasure without any definite plan, also GALAVANT, GALLIVANT [v]\n",
  "GALIVANTING": "GALIVANT, to roam about for pleasure without any definite plan, also GALAVANT, GALLIVANT [v]\n",
  "GALIVANTS": "GALIVANT, to roam about for pleasure without any definite plan, also GALAVANT, GALLIVANT [v]\n",
  "GALL": "to make sore by rubbing [v -ED, -ING, -S]\n",
  "GALLABEA": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABEAH": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABEAHS": "GALLABEAH, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABEAS": "GALLABEA, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABIA": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABIAH": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABIAHS": "GALLABIAH, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABIAS": "GALLABIA, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABIEH": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABIEHS": "GALLABIEH, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABIYA": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABIYAH": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYEH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABIYAHS": "GALLABIYAH, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABIYAS": "GALLABIYA, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYAH, GALLABIYEH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLABIYEH": "(Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, JELAB, JELLABA, JELLABAH [n -S]\n",
  "GALLABIYEHS": "GALLABIYEH, (Arabic) a cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, JELAB, JELLABA, JELLABAH [n]\n",
  "GALLAMINE": "an ammonium salt used to promote muscle relaxation [n -S]\n",
  "GALLAMINES": "GALLAMINE, an ammonium salt used to promote muscle relaxation [n]\n",
  "GALLANT": "to court a woman [v -ED, -ING, -S] / chivalrous [adj GALLANTER, GALLANTEST, GALLANTLY]\n",
  "GALLANTED": "GALLANT, to court a woman [v]\n",
  "GALLANTER": "GALLANT, chivalrous [adj]\n",
  "GALLANTEST": "GALLANT, chivalrous [adj]\n",
  "GALLANTING": "GALLANT, to court a woman [v]\n",
  "GALLANTLY": "GALLANT, chivalrous [adv]\n",
  "GALLANTNESS": "the quality of being gallant [n -ES]\n",
  "GALLANTNESSES": "GALLANTNESS, the quality of being gallant [n]\n",
  "GALLANTRIES": "GALLANTRY, bravery; attention or devotion to ladies [n]\n",
  "GALLANTRY": "bravery; attention or devotion to ladies [n GALLANTRIES]\n",
  "GALLANTS": "GALLANT, to court a woman [v]\n",
  "GALLATE": "a salt of gallic acid [n -S]\n",
  "GALLATES": "GALLATE, a salt of gallic acid [n]\n",
  "GALLBLADDER": "a membranous muscular sac in which bile from the liver is stored [n -S]\n",
  "GALLBLADDERS": "GALLBLADDER, a membranous muscular sac in which bile from the liver is stored [n]\n",
  "GALLEASS": "a large war galley, also GALLIASS [n -ES]\n",
  "GALLEASSES": "GALLEASS, a large war galley, also GALLIASS [n]\n",
  "GALLED": "GALL, to make sore by rubbing [v]\n",
  "GALLEIN": "a red crystalline dyestuff, obtained by heating together pyrogallic and phthalic acids [n -S]\n",
  "GALLEINS": "GALLEIN, a red crystalline dyestuff, obtained by heating together pyrogallic and phthalic acids [n]\n",
  "GALLEON": "a sailing vessel of the 15th and following centuries, often having three or four decks, and used for war or commerce [n -S]\n",
  "GALLEONS": "GALLEON, a sailing vessel of the 15th and following centuries, often having three or four decks, and used for war or commerce [n]\n",
  "GALLERIA": "(Italian) a shopping arcade [n -S]\n",
  "GALLERIAS": "GALLERIA, (Italian) a shopping arcade [n]\n",
  "GALLERIED": "GALLERY, to provide with a long covered area [v]\n",
  "GALLERIES": "GALLERY, to provide with a long covered area [v]\n",
  "GALLERIST": "a person who owns or runs an art gallery [n -S]\n",
  "GALLERISTS": "GALLERIST, a person who owns or runs an art gallery [n]\n",
  "GALLERY": "to provide with a long covered area [v GALLERIED, GALLERYING, GALLERIES]\n",
  "GALLERYGOER": "one who frequently goes to art galleries [n -S]\n",
  "GALLERYGOERS": "GALLERYGOER, one who frequently goes to art galleries [n]\n",
  "GALLERYING": "GALLERY, to provide with a long covered area [v]\n",
  "GALLERYITE": "a person who frequents the gallery in the theatre [n -S]\n",
  "GALLERYITES": "GALLERYITE, a person who frequents the gallery in the theatre [n]\n",
  "GALLET": "(French) to fill in mortar joints with stone chips [v -ED, -ING, -S]\n",
  "GALLETA": "(Spanish) a perennial grass [n -S]\n",
  "GALLETAS": "GALLETA, (Spanish) a perennial grass [n]\n",
  "GALLETED": "GALLET, (French) to fill in mortar joints with stone chips [v]\n",
  "GALLETING": "GALLET, (French) to fill in mortar joints with stone chips [v]\n",
  "GALLETS": "GALLET, (French) to fill in mortar joints with stone chips [v]\n",
  "GALLEY": "any of various kinds of ship propelled by oars or sails used in ancient or medieval times as a warship or as a trader [n -S]\n",
  "GALLEYS": "GALLEY, any of various kinds of ship propelled by oars or sails used in ancient or medieval times as a warship or as a trader [n]\n",
  "GALLFLIES": "GALLFLY, an insect that causes galls by depositing its eggs in plants [n]\n",
  "GALLFLY": "an insect that causes galls by depositing its eggs in plants [n GALLFLIES]\n",
  "GALLIAMBIC": "a classical metre [n -S]\n",
  "GALLIAMBICS": "GALLIAMBIC, a classical metre [n]\n",
  "GALLIARD": "a sprightly Renaissance and Baroque dance [n -S]\n",
  "GALLIARDISE": "(archaic) gaiety [n -S]\n",
  "GALLIARDISES": "GALLIARDISE, (archaic) gaiety [n]\n",
  "GALLIARDS": "GALLIARD, a sprightly Renaissance and Baroque dance [n]\n",
  "GALLIASS": "a large war galley, also GALLEASS [n -ES]\n",
  "GALLIASSES": "GALLIASS, a large war galley, also GALLEASS [n]\n",
  "GALLIC": "as in gallic acid, a crystalline substance present in gallnuts, tea, and various plants [adj]\n",
  "GALLICA": "a variety of rose [n -S]\n",
  "GALLICAN": "pertaining to a French religious movement [adj]\n",
  "GALLICAS": "GALLICA, a variety of rose [n]\n",
  "GALLICISATION": "the process of gallicising, also GALLICIZATION [n -S]\n",
  "GALLICISATIONS": "GALLICISATION, the process of gallicising, also GALLICIZATION [n]\n",
  "GALLICISE": "to make French, also GALLICIZE [v GALLICISED, GALLICISING, GALLICISES]\n",
  "GALLICISED": "GALLICISE, to make French, also GALLICIZE [v]\n",
  "GALLICISES": "GALLICISE, to make French, also GALLICIZE [v]\n",
  "GALLICISING": "GALLICISE, to make French, also GALLICIZE [v]\n",
  "GALLICISM": "a French turn of expression [n -S]\n",
  "GALLICISMS": "GALLICISM, a French turn of expression [n]\n",
  "GALLICIZATION": "the process of gallicizing, also GALLICISATION [n -S]\n",
  "GALLICIZATIONS": "GALLICIZATION, the process of gallicizing, also GALLICISATION [n]\n",
  "GALLICIZE": "to make French, also GALLICISE [v GALLICIZED, GALLICIZING, GALLICIZES]\n",
  "GALLICIZED": "GALLICIZE, to make French, also GALLICISE [v]\n",
  "GALLICIZES": "GALLICIZE, to make French, also GALLICISE [v]\n",
  "GALLICIZING": "GALLICIZE, to make French, also GALLICISE [v]\n",
  "GALLIED": "GALLY, to scare, daze [v]\n",
  "GALLIER": "GALLY, gall-like, bitter [adj]\n",
  "GALLIES": "GALLY, to scare, daze [v]\n",
  "GALLIEST": "GALLY, gall-like, bitter [adj]\n",
  "GALLIGASKINS": "wide hose or breeches worn in the 16th century, also GALLYGASKINS, GASKINS [n]\n",
  "GALLIMAUFRIES": "GALLIMAUFRY, (French) a hash of liver and other organs; a hotchpotch [n]\n",
  "GALLIMAUFRY": "(French) a hash of liver and other organs; a hotchpotch [n GALLIMAUFRIES]\n",
  "GALLINACEAN": "any gallinaceous bird, such as a pheasant [n -S]\n",
  "GALLINACEANS": "GALLINACEAN, any gallinaceous bird, such as a pheasant [n]\n",
  "GALLINACEOUS": "of or resembling pheasants and other domestic birds [adj]\n",
  "GALLINAZO": "(Spanish) a turkey-buzzard or other vulture [n -S]\n",
  "GALLINAZOS": "GALLINAZO, (Spanish) a turkey-buzzard or other vulture [n]\n",
  "GALLING": "GALL, to make sore by rubbing [v]\n",
  "GALLINGLY": "GALLING, GALL, to make sore by rubbing [adv]\n",
  "GALLINIPPER": "a large mosquito capable of inflicting painful bite [n -S]\n",
  "GALLINIPPERS": "GALLINIPPER, a large mosquito capable of inflicting painful bite [n]\n",
  "GALLINULE": "any of various aquatic birds of the rail family [n -S]\n",
  "GALLINULES": "GALLINULE, any of various aquatic birds of the rail family [n]\n",
  "GALLIOT": "(French) a small galley, formerly used in the Mediterranean, also GALIOT [n -S]\n",
  "GALLIOTS": "GALLIOT, (French) a small galley, formerly used in the Mediterranean, also GALIOT [n]\n",
  "GALLIPOT": "a small glazed earthenware jar used by druggists, also GALIPOT [n -S]\n",
  "GALLIPOTS": "GALLIPOT, a small glazed earthenware jar used by druggists, also GALIPOT [n]\n",
  "GALLISE": "in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISISE, GALLISIZE, GALLIZE [v GALLISED, GALLISING, GALLISES]\n",
  "GALLISED": "GALLISE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISISE, GALLISIZE, GALLIZE [v]\n",
  "GALLISES": "GALLISE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISISE, GALLISIZE, GALLIZE [v]\n",
  "GALLISING": "GALLISE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISISE, GALLISIZE, GALLIZE [v]\n",
  "GALLISISE": "in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISIZE, GALLIZE [v GALLISISED, GALLISISING, GALLISISES]\n",
  "GALLISISED": "GALLISISE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISIZE, GALLIZE [v]\n",
  "GALLISISES": "GALLISISE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISIZE, GALLIZE [v]\n",
  "GALLISISING": "GALLISISE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISIZE, GALLIZE [v]\n",
  "GALLISIZE": "in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLIZE [v GALLISIZED, GALLISIZING, GALLISIZES]\n",
  "GALLISIZED": "GALLISIZE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLIZE [v]\n",
  "GALLISIZES": "GALLISIZE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLIZE [v]\n",
  "GALLISIZING": "GALLISIZE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLIZE [v]\n",
  "GALLIUM": "a rare metallic element, found in certain zinc ores [n -S]\n",
  "GALLIUMS": "GALLIUM, a rare metallic element, found in certain zinc ores [n]\n",
  "GALLIVANT": "to roam about for pleasure without any definite plan, also GALAVANT, GALIVANT [v -ED, -ING, -S]\n",
  "GALLIVANTED": "GALLIVANT, to roam about for pleasure without any definite plan, also GALAVANT, GALIVANT [v]\n",
  "GALLIVANTING": "GALLIVANT, to roam about for pleasure without any definite plan, also GALAVANT, GALIVANT [v]\n",
  "GALLIVANTS": "GALLIVANT, to roam about for pleasure without any definite plan, also GALAVANT, GALIVANT [v]\n",
  "GALLIVAT": "(Portuguese) a large two-masted Malay boat [n -S]\n",
  "GALLIVATS": "GALLIVAT, (Portuguese) a large two-masted Malay boat [n]\n",
  "GALLIWASP": "a West Indian lizard, about a foot long, imagined by the natives to be venomous [n -S]\n",
  "GALLIWASPS": "GALLIWASP, a West Indian lizard, about a foot long, imagined by the natives to be venomous [n]\n",
  "GALLIZE": "in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLISIZE [v GALLIZED, GALLIZING, GALLIZES]\n",
  "GALLIZED": "GALLIZE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLISIZE [v]\n",
  "GALLIZES": "GALLIZE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLISIZE [v]\n",
  "GALLIZING": "GALLIZE, in winemaking, to bring to standard proportions by adding water and sugar to an inferior must, also GALLISE, GALLISISE, GALLISIZE [v]\n",
  "GALLNUT": "a round gall produced on the leaves and shoots of various species of the oak tree, also NUTGALL [n -S]\n",
  "GALLNUTS": "GALLNUT, a round gall produced on the leaves and shoots of various species of the oak tree, also NUTGALL [n]\n",
  "GALLOCK": "(dialect) left-handed [adj]\n",
  "GALLOGLASS": "(Irish) the irregular infantry of Ireland, and the Highlands of Scotland, also GALLOWGLASS [n -ES]\n",
  "GALLOGLASSES": "GALLOGLASS, (Irish) the irregular infantry of Ireland, and the Highlands of Scotland, also GALLOWGLASS [n]\n",
  "GALLON": "a unit of liquid measure [n -S]\n",
  "GALLONAGE": "an amount in gallons; the rate of use in gallons [n -S]\n",
  "GALLONAGES": "GALLONAGE, an amount in gallons; the rate of use in gallons [n]\n",
  "GALLONS": "GALLON, a unit of liquid measure [n]\n",
  "GALLOON": "an ornamental braid [n -S]\n",
  "GALLOONED": "decorated with galloon, a lace trim [adj]\n",
  "GALLOONS": "GALLOON, an ornamental braid [n]\n",
  "GALLOOT": "an awkward or uncouth person, also GALOOT [n -S]\n",
  "GALLOOTS": "GALLOOT, an awkward or uncouth person, also GALOOT [n]\n",
  "GALLOP": "to ride a horse at full speed [v -ED, -ING, -S]\n",
  "GALLOPADE": "(French) a lively ballroom dance in 2/4 time; a piece of music for this dance [n -S] / to dance a gallopade, also GALOPADE [v GALLOPADED, GALLOPADING, GALLOPADES]\n",
  "GALLOPADED": "GALLOPADE, to dance a gallopade, also GALOPADE [v]\n",
  "GALLOPADES": "GALLOPADE, (French) a lively ballroom dance in 2/4 time; a piece of music for this dance [n]\n",
  "GALLOPADING": "GALLOPADE, to dance a gallopade, also GALOPADE [v]\n",
  "GALLOPED": "GALLOP, to ride a horse at full speed [v]\n",
  "GALLOPER": "a rider, esp. a huntsman, who gallops [n -S]\n",
  "GALLOPERS": "GALLOPER, a rider, esp. a huntsman, who gallops [n]\n",
  "GALLOPING": "GALLOP, to ride a horse at full speed [v]\n",
  "GALLOPS": "GALLOP, to ride a horse at full speed [v]\n",
  "GALLOUS": "containing gallium [adj]\n",
  "GALLOW": "(Shakespeare) to frighten [v -ED, -ING, -S]\n",
  "GALLOWAY": "a breed of hornless cattle [n -S]\n",
  "GALLOWAYS": "GALLOWAY, a breed of hornless cattle [n]\n",
  "GALLOWED": "GALLOW, (Shakespeare) to frighten [v]\n",
  "GALLOWGLASS": "(Irish) the irregular infantry of Ireland, and the Highlands of Scotland, also GALLOGLASS [n -ES]\n",
  "GALLOWGLASSES": "GALLOWGLASS, (Irish) the irregular infantry of Ireland, and the Highlands of Scotland, also GALLOGLASS [n]\n",
  "GALLOWING": "GALLOW, (Shakespeare) to frighten [v]\n",
  "GALLOWS": "a structure used to hang a condemn person [n -ES]\n",
  "GALLOWSES": "GALLOWS, a structure used to hang a condemn person [n]\n",
  "GALLOWSNESS": "recklessness, perversity [n -ES]\n",
  "GALLOWSNESSES": "GALLOWSNESS, recklessness, perversity [n]\n",
  "GALLS": "GALL, to make sore by rubbing [v]\n",
  "GALLSICKNESS": "a tick-borne disease affecting the livers of cattle, sheep and goats [n -ES]\n",
  "GALLSICKNESSES": "GALLSICKNESS, a tick-borne disease affecting the livers of cattle, sheep and goats [n]\n",
  "GALLSTONE": "a concretion, or calculus, formed in the gall bladder or biliary passages [n -S]\n",
  "GALLSTONES": "GALLSTONE, a concretion, or calculus, formed in the gall bladder or biliary passages [n]\n",
  "GALLUMPH": "to move with a clumsy heavy tread, also GALUMPH [v -ED, -ING, -S]\n",
  "GALLUMPHED": "GALLUMPH, to move with a clumsy heavy tread, also GALUMPH [v]\n",
  "GALLUMPHING": "GALLUMPH, to move with a clumsy heavy tread, also GALUMPH [v]\n",
  "GALLUMPHS": "GALLUMPH, to move with a clumsy heavy tread, also GALUMPH [v]\n",
  "GALLUS": "bold, daring, fit for the gallows [adj]\n",
  "GALLUSED": "suspended by galluses [adj]\n",
  "GALLUSES": "(dialect) braces for trousers [n]\n",
  "GALLY": "gall-like, bitter [adj GALLIER, GALLIEST] / to scare, daze [v GALLIED, GALLYING, GALLIES]\n",
  "GALLYGASKINS": "wide hose or breeches worn in the 16th century, also GALLIGASKINS, GASKINS [n]\n",
  "GALLYING": "GALLY, to scare, daze [v]\n",
  "GALOCHE": "(French) an overshoe, also GALAGE, GALOSH, GALOSHE, GOLOSH, GOLOSHE [n -S] / to provide (a shoe, etc.) with a galosh [v GALOCHED, GALOCHING, GALOCHES]\n",
  "GALOCHED": "GALOCHE, to provide (a shoe, etc.) with a galosh [v]\n",
  "GALOCHES": "GALOCHE, to provide (a shoe, etc.) with a galosh [v]\n",
  "GALOCHING": "GALOCHE, to provide (a shoe, etc.) with a galosh [v]\n",
  "GALOOT": "an awkward or uncouth person, also GALLOOT [n -S]\n",
  "GALOOTS": "GALOOT, an awkward or uncouth person, also GALLOOT [n]\n",
  "GALOP": "(French) to dance a galop (a lively round dance) [v GALOPED or GALOPPED, GALOPING or GALOPPING, GALOPS]\n",
  "GALOPADE": "(French) a lively ballroom dance, also GALLOPADE [n -S]\n",
  "GALOPADES": "GALOPADE, (French) a lively ballroom dance, also GALLOPADE [n]\n",
  "GALOPED": "GALOP, (French) to dance a galop (a lively round dance) [v]\n",
  "GALOPIN": "(obsolete) an errand boy, kitchen boy [n -S]\n",
  "GALOPING": "GALOP, (French) to dance a galop (a lively round dance) [v]\n",
  "GALOPINS": "GALOPIN, (obsolete) an errand boy, kitchen boy [n]\n",
  "GALOPPED": "GALOP, (French) to dance a galop (a lively round dance) [v]\n",
  "GALOPPING": "GALOP, (French) to dance a galop (a lively round dance) [v]\n",
  "GALOPS": "GALOP, (French) to dance a galop (a lively round dance) [v]\n",
  "GALORE": "(Irish) an abundance [n -S]\n",
  "GALORES": "GALORE, (Irish) an abundance [n]\n",
  "GALOSH": "(French) an overshoe, also GALAGE, GALOCHE, GALOSHE, GOLOSH, GOLOSHE [n -ES] / to put a galosh on [v -ED, -ING, -ES]\n",
  "GALOSHE": "(French) an overshoe, also GALAGE, GALOCHE, GALOSH, GOLOSH, GOLOSHE [n -S]\n",
  "GALOSHED": "GALOSH, to put a galosh on [v]\n",
  "GALOSHES": "GALOSH, (French) an overshoe, also GALAGE, GALOCHE, GALOSHE, GOLOSH, GOLOSHE [n]\n",
  "GALOSHING": "GALOSH, to put a galosh on [v]\n",
  "GALOWSES": "(Shakespeare) gallows [n]\n",
  "GALRAVAGE": "(Scots) to behave riotously, also GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v GALRAVAGED, GALRAVAGING, GALRAVAGES]\n",
  "GALRAVAGED": "GALRAVAGE, (Scots) to behave riotously, also GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GALRAVAGES": "GALRAVAGE, (Scots) to behave riotously, also GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GALRAVAGING": "GALRAVAGE, (Scots) to behave riotously, also GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GALRAVITCH": "(Scots) to behave riotously, also GALRAVAGE, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v -ED, -ING, -ES]\n",
  "GALRAVITCHED": "GALRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GALRAVITCHES": "GALRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GALRAVITCHING": "GALRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GILLRAVAGE, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GALS": "GAL, a girl [n]\n",
  "GALTONIA": "a bulbous plant of the lily family native to southern Africa [n -S]\n",
  "GALTONIAS": "GALTONIA, a bulbous plant of the lily family native to southern Africa [n]\n",
  "GALUMPH": "to move with a clumsy heavy tread, also GALLUMPH [v -ED, -ING, -S]\n",
  "GALUMPHED": "GALUMPH, to move with a clumsy heavy tread, also GALLUMPH [v]\n",
  "GALUMPHER": "one who galumphs, moves with a clumsy heavy tread [n -S]\n",
  "GALUMPHERS": "GALUMPHER, one who galumphs, moves with a clumsy heavy tread [n]\n",
  "GALUMPHING": "GALUMPH, to move with a clumsy heavy tread, also GALLUMPH [v]\n",
  "GALUMPHS": "GALUMPH, to move with a clumsy heavy tread, also GALLUMPH [v]\n",
  "GALUT": "(Hebrew) the forced exile of Jews, the diaspora, also GALUTH [n -S]\n",
  "GALUTH": "(Hebrew) the forced exile of Jews, the diaspora, also GALUT [n -S]\n",
  "GALUTHS": "GALUTH, (Hebrew) the forced exile of Jews, the diaspora, also GALUT [n]\n",
  "GALUTS": "GALUT, (Hebrew) the forced exile of Jews, the diaspora, also GALUTH [n]\n",
  "GALVANIC": "pertaining to direct current from an electric battery, also GALVANICAL [adj GALVANICALLY]\n",
  "GALVANICAL": "pertaining to direct current from an electric battery, also GALVANIC [adj GALVANICALLY]\n",
  "GALVANICALLY": "GALVANICAL, pertaining to direct current from an electric battery, also GALVANIC [adv]\n",
  "GALVANISATION": "the process of galvanising, also GALVANIZATION [n -S]\n",
  "GALVANISATIONS": "GALVANISATION, the process of galvanising, also GALVANIZATION [n]\n",
  "GALVANISE": "to subject to the action of an electric current, also GALVANIZE [v GALVANISED, GALVANISING, GALVANISES]\n",
  "GALVANISED": "GALVANISE, to subject to the action of an electric current, also GALVANIZE [v]\n",
  "GALVANISER": "a galvanising agent, also GALVANIZER [n -S]\n",
  "GALVANISERS": "GALVANISER, a galvanising agent, also GALVANIZER [n]\n",
  "GALVANISES": "GALVANISE, to subject to the action of an electric current, also GALVANIZE [v]\n",
  "GALVANISING": "GALVANISE, to subject to the action of an electric current, also GALVANIZE [v]\n",
  "GALVANISM": "the production of an electric current by chemical means, as in a battery [n -S]\n",
  "GALVANISMS": "GALVANISM, the production of an electric current by chemical means, as in a battery [n]\n",
  "GALVANIST": "one who engages in galvanism [n -S]\n",
  "GALVANISTS": "GALVANIST, one who engages in galvanism [n]\n",
  "GALVANIZATION": "the process of galvanizing, also GALVANISATION [n -S]\n",
  "GALVANIZATIONS": "GALVANIZATION, the process of galvanizing, also GALVANISATION [n]\n",
  "GALVANIZE": "to subject to the action of an electric current, also GALVANISE [v GALVANIZED, GALVANIZING, GALVANIZES]\n",
  "GALVANIZED": "GALVANIZE, to subject to the action of an electric current, also GALVANISE [v]\n",
  "GALVANIZER": "a galvanising agent, also GALVANISER [n -S]\n",
  "GALVANIZERS": "GALVANIZER, a galvanising agent, also GALVANISER [n]\n",
  "GALVANIZES": "GALVANIZE, to subject to the action of an electric current, also GALVANISE [v]\n",
  "GALVANIZING": "GALVANIZE, to subject to the action of an electric current, also GALVANISE [v]\n",
  "GALVANOMETER": "an instrument for measuring electrical current [n -S]\n",
  "GALVANOMETERS": "GALVANOMETER, an instrument for measuring electrical current [n]\n",
  "GALVANOMETRIC": "relating to galvanometry, the measurement of electric currents, also GALVANOMETRICAL [adj]\n",
  "GALVANOMETRICAL": "relating to galvanometry, the measurement of electric currents, also GALVANOMETRIC [adj]\n",
  "GALVANOMETRIES": "GALVANOMETRY, the measurement of electric currents [n]\n",
  "GALVANOMETRY": "the measurement of electric currents [n GALVANOMETRIES]\n",
  "GALVANOPLASTIC": "(obsolete) relating to galvanoplasty, electrodeposition [adj]\n",
  "GALVANOPLASTIES": "GALVANOPLASTY, (obsolete) electrodeposition [n]\n",
  "GALVANOPLASTY": "(obsolete) electrodeposition [n GALVANOPLASTIES]\n",
  "GALVANOSCOPE": "an instrument for detecting the presence and direction of an electric current [n -S]\n",
  "GALVANOSCOPES": "GALVANOSCOPE, an instrument for detecting the presence and direction of an electric current [n]\n",
  "GALVANOSCOPIC": "relating to a galvanoscope, an instrument for detecting the presence and direction of an electric current [adj]\n",
  "GALVANOSCOPIES": "GALVANOSCOPY, the use of a galvanoscope, an instrument for detecting the presence and direction of an electric current [n]\n",
  "GALVANOSCOPY": "the use of a galvanoscope, an instrument for detecting the presence and direction of an electric current [n GALVANOSCOPIES]\n",
  "GALVANOTROPIC": "relating to galvanotropism, the directional growth of an organism [adj]\n",
  "GALVANOTROPISM": "the directional growth of an organism, esp. a plant, in response to an electrical stimulus [n -S]\n",
  "GALVANOTROPISMS": "GALVANOTROPISM, the directional growth of an organism, esp. a plant, in response to an electrical stimulus [n]\n",
  "GALVO": "an instrument for measuring electric current [n -S]\n",
  "GALVOS": "GALVO, an instrument for measuring electric current [n]\n",
  "GALYAC": "(Russian) a soft glossy fur from a stillborn lamb or kid, also GALYAK [n -S]\n",
  "GALYACS": "GALYAC, (Russian) a soft glossy fur from a stillborn lamb or kid, also GALYAK [n]\n",
  "GALYAK": "(Russian) a soft glossy fur from a stillborn lamb or kid, also GALYAC [n -S]\n",
  "GALYAKS": "GALYAK, (Russian) a soft glossy fur from a stillborn lamb or kid, also GALYAC [n]\n",
  "GAM": "to visit socially between whaling ships [v GAMMED, GAMMING, GAMS]\n",
  "GAMA": "(Spanish) a kind of pasture grass found in the Western United States [n -S]\n",
  "GAMAHUCHE": "to practise cunnilingus or fellatio, also GAMARUCHE [v GAMAHUCHED, GAMAHUCHING, GAMAHUCHES]\n",
  "GAMAHUCHED": "GAMAHUCHE, to practise cunnilingus or fellatio, also GAMARUCHE [v]\n",
  "GAMAHUCHES": "GAMAHUCHE, to practise cunnilingus or fellatio, also GAMARUCHE [v]\n",
  "GAMAHUCHING": "GAMAHUCHE, to practise cunnilingus or fellatio, also GAMARUCHE [v]\n",
  "GAMARUCHE": "to practise cunnilingus or fellatio, also GAMAHUCHE [v GAMARUCHED, GAMARUCHING, GAMARUCHES]\n",
  "GAMARUCHED": "GAMARUCHE, to practise cunnilingus or fellatio, also GAMAHUCHE [v]\n",
  "GAMARUCHES": "GAMARUCHE, to practise cunnilingus or fellatio, also GAMAHUCHE [v]\n",
  "GAMARUCHING": "GAMARUCHE, to practise cunnilingus or fellatio, also GAMAHUCHE [v]\n",
  "GAMAS": "GAMA, (Spanish) a kind of pasture grass found in the Western United States [n]\n",
  "GAMASH": "a type of legging, also GRAMASH, GRAMOCHE [n -ES]\n",
  "GAMASHES": "GAMASH, a type of legging, also GRAMASH, GRAMOCHE [n]\n",
  "GAMAY": "(French) a variety of red grape; a dry red wine made from this [n -S]\n",
  "GAMAYS": "GAMAY, (French) a variety of red grape; a dry red wine made from this [n]\n",
  "GAMB": "in heraldry, a beast's whole leg, also GAMBE [n -S]\n",
  "GAMBA": "(Italian) a bass viol [n -S]\n",
  "GAMBADE": "(French) a leap made by a horse, also GAMBADO [n -S]\n",
  "GAMBADES": "GAMBADE, (French) a leap made by a horse, also GAMBADO [n]\n",
  "GAMBADO": "(Italian) to frolic [v -ED, -ING, -S] / a leap made by a horse, also GAMBADE [n -ES or -S]\n",
  "GAMBADOED": "GAMBADO, (Italian) to frolic [v]\n",
  "GAMBADOES": "GAMBADO, a leap made by a horse, also GAMBADE [n]\n",
  "GAMBADOING": "GAMBADO, (Italian) to frolic [v]\n",
  "GAMBADOS": "GAMBADO, (Italian) to frolic [v]\n",
  "GAMBAS": "GAMBA, (Italian) a bass viol [n]\n",
  "GAMBE": "in heraldry, a beast's whole leg, also GAMB [n -S]\n",
  "GAMBES": "GAMBE, in heraldry, a beast's whole leg, also GAMB [n]\n",
  "GAMBESON": "(historical) a leather or quilted coat worn as armour [n -S]\n",
  "GAMBESONS": "GAMBESON, (historical) a leather or quilted coat worn as armour [n]\n",
  "GAMBET": "(Italian) a red-legged wading bird, the redshank, also GAMBETTA [n -S]\n",
  "GAMBETS": "GAMBET, (Italian) a red-legged wading bird, the redshank, also GAMBETTA [n]\n",
  "GAMBETTA": "(Italian) a red-legged wading bird, the redshank, also GAMBET [n -S]\n",
  "GAMBETTAS": "GAMBETTA, (Italian) a red-legged wading bird, the redshank, also GAMBET [n]\n",
  "GAMBIA": "(Malay) the inspissated juice of a plant growing in Malacca, used for tanning and dyeing, also GAMBIER, GAMBIR [n -S]\n",
  "GAMBIAS": "GAMBIA, (Malay) the inspissated juice of a plant growing in Malacca, used for tanning and dyeing, also GAMBIER, GAMBIR [n]\n",
  "GAMBIER": "(Malay) the inspissated juice of a plant growing in Malacca, used for tanning and dyeing, also GAMBIA, GAMBIR [n -S]\n",
  "GAMBIERS": "GAMBIER, (Malay) the inspissated juice of a plant growing in Malacca, used for tanning and dyeing, also GAMBIA, GAMBIR [n]\n",
  "GAMBIR": "(Malay) the inspissated juice of a plant growing in Malacca, used for tanning and dyeing, also GAMBIA, GAMBIER [n -S]\n",
  "GAMBIRS": "GAMBIR, (Malay) the inspissated juice of a plant growing in Malacca, used for tanning and dyeing, also GAMBIA, GAMBIER [n]\n",
  "GAMBIST": "a performer upon the viola di gamba [n -S]\n",
  "GAMBISTS": "GAMBIST, a performer upon the viola di gamba [n]\n",
  "GAMBIT": "to sacrifice in order to gain [v -ED, -ING, -S]\n",
  "GAMBITED": "GAMBIT, to sacrifice in order to gain [v]\n",
  "GAMBITING": "GAMBIT, to sacrifice in order to gain [v]\n",
  "GAMBITS": "GAMBIT, to sacrifice in order to gain [v]\n",
  "GAMBLE": "to play a game of chance [v GAMBLED, GAMBLING, GAMBLES]\n",
  "GAMBLED": "GAMBLE, to play a game of chance [v]\n",
  "GAMBLER": "one that gambles [n -S]\n",
  "GAMBLERS": "GAMBLER, one that gambles [n]\n",
  "GAMBLES": "GAMBLE, to play a game of chance [v]\n",
  "GAMBLING": "the act of taking a chance [n -S]\n",
  "GAMBLINGS": "GAMBLING, the act of taking a chance [n]\n",
  "GAMBO": "(Welsh) a simple farm cart or hay-wagon [n -ES or -S]\n",
  "GAMBOES": "GAMBO, (Welsh) a simple farm cart or hay-wagon [n]\n",
  "GAMBOGE": "a kind of gum resin, used as a yellow pigment and as a cathartic, also CAMBOGE, CAMBOGIA [n -S]\n",
  "GAMBOGES": "GAMBOGE, a kind of gum resin, used as a yellow pigment and as a cathartic, also CAMBOGE, CAMBOGIA [n]\n",
  "GAMBOGIAN": "pertaining to, resembling, or containing, gamboge, also GAMBOGIC [adj]\n",
  "GAMBOGIC": "of gamboge [adj]\n",
  "GAMBOL": "to leap about playfully [v GAMBOLED or GAMBOLLED, GAMBOLING or GAMBOLLING, GAMBOLS]\n",
  "GAMBOLED": "GAMBOL, to leap about playfully [v]\n",
  "GAMBOLING": "GAMBOL, to leap about playfully [v]\n",
  "GAMBOLLED": "GAMBOL, to leap about playfully [v]\n",
  "GAMBOLLING": "GAMBOL, to leap about playfully [v]\n",
  "GAMBOLS": "GAMBOL, to leap about playfully [v]\n",
  "GAMBOS": "GAMBO, (Welsh) a simple farm cart or hay-wagon [n]\n",
  "GAMBREL": "the joint in the upper part of a horse's hind leg, the hock, also CAMBREL [n -S]\n",
  "GAMBRELS": "GAMBREL, the joint in the upper part of a horse's hind leg, the hock, also CAMBREL [n]\n",
  "GAMBROON": "(Persian) a twilled cloth of worsted and cotton [n -S]\n",
  "GAMBROONS": "GAMBROON, (Persian) a twilled cloth of worsted and cotton [n]\n",
  "GAMBS": "GAMB, in heraldry, a beast's whole leg, also GAMBE [n]\n",
  "GAMBUSIA": "(Spanish) a fish of the genus Gambusia, members of which give birth to live young and feed on mosquito larvae [n -S]\n",
  "GAMBUSIAS": "GAMBUSIA, (Spanish) a fish of the genus Gambusia, members of which give birth to live young and feed on mosquito larvae [n]\n",
  "GAME": "plucky [adj GAMER, GAMEST, GAMELY] / to gamble [v GAMED, GAMING, GAMES]\n",
  "GAMEBAG": "a leather or canvas bag for carrying hunted game (esp. birds) [n -S]\n",
  "GAMEBAGS": "GAMEBAG, a leather or canvas bag for carrying hunted game (esp. birds) [n]\n",
  "GAMEBOOK": "a book of strategies used by a sports team [n -S]\n",
  "GAMEBOOKS": "GAMEBOOK, a book of strategies used by a sports team [n]\n",
  "GAMEBREAKER": "a term used esp. in hockey to describe a player who can dominate and change a game single-handed [n -S]\n",
  "GAMEBREAKERS": "GAMEBREAKER, a term used esp. in hockey to describe a player who can dominate and change a game single-handed [n]\n",
  "GAMECOCK": "a rooster trained for fighting [n -S]\n",
  "GAMECOCKS": "GAMECOCK, a rooster trained for fighting [n]\n",
  "GAMED": "GAME, to gamble [v]\n",
  "GAMEFISH": "a fish caught for sport [n -ES]\n",
  "GAMEFISHES": "GAMEFISH, a fish caught for sport [n]\n",
  "GAMEFOWL": "a gamecock [n -S]\n",
  "GAMEFOWLS": "GAMEFOWL, a gamecock [n]\n",
  "GAMEKEEPER": "a person in charge of the breeding and protection of game animals or birds on a private preserve [n -S]\n",
  "GAMEKEEPERS": "GAMEKEEPER, a person in charge of the breeding and protection of game animals or birds on a private preserve [n]\n",
  "GAMEKEEPING": "the job of a gamekeeper [n -S]\n",
  "GAMEKEEPINGS": "GAMEKEEPING, the job of a gamekeeper [n]\n",
  "GAMELAN": "(Javanese) a Javanese instrument resembling a xylophone [n -S]\n",
  "GAMELANS": "GAMELAN, (Javanese) a Javanese instrument resembling a xylophone [n]\n",
  "GAMELIKE": "similar to a game [adj]\n",
  "GAMELY": "GAME, plucky [adv]\n",
  "GAMENESS": "the quality of being game [n -ES]\n",
  "GAMENESSES": "GAMENESS, the quality of being game [n]\n",
  "GAMEPLAY": "the plan of action of a computer game [n -S]\n",
  "GAMEPLAYS": "GAMEPLAY, the plan of action of a computer game [n]\n",
  "GAMER": "a player who relishes competition [n -S]\n",
  "GAMERS": "GAMER, a player who relishes competition [n]\n",
  "GAMES": "GAME, to gamble [v]\n",
  "GAMESHOW": "a television show involving game play [n -S]\n",
  "GAMESHOWS": "GAMESHOW, a television show involving game play [n]\n",
  "GAMESIER": "GAMESY, keen on sports [adj]\n",
  "GAMESIEST": "GAMESY, keen on sports [adj]\n",
  "GAMESMAN": "one who plays games [n GAMESMEN]\n",
  "GAMESMANSHIP": "the art or practice of winning games by questionable expedients without actually violating the rules [n -S]\n",
  "GAMESMANSHIPS": "GAMESMANSHIP, the art or practice of winning games by questionable expedients without actually violating the rules [n]\n",
  "GAMESMEN": "GAMESMAN, one who plays games [n]\n",
  "GAMESOME": "playful, merry, sportive [adj GAMESOMELY]\n",
  "GAMESOMELY": "GAMESOME, playful, merry, sportive [adv]\n",
  "GAMESOMENESS": "the state of being gamesome [n -ES]\n",
  "GAMESOMENESSES": "GAMESOMENESS, the state of being gamesome [n]\n",
  "GAMEST": "GAME, plucky [adj]\n",
  "GAMESTER": "a gambler [n -S]\n",
  "GAMESTERS": "GAMESTER, a gambler [n]\n",
  "GAMESY": "keen on sports [adj GAMESIER, GAMESIEST]\n",
  "GAMETAL": "of egg cells [adj]\n",
  "GAMETANGIA": "GAMETANGIUM, an organ or cell in which gametes are produced [n]\n",
  "GAMETANGIAL": "relating to a gametangium, an organ or cell in which gametes are produced [adj]\n",
  "GAMETANGIUM": "an organ or cell in which gametes are produced [n GAMETANGIA]\n",
  "GAMETE": "a mature reproductive cell [n -S]\n",
  "GAMETES": "GAMETE, a mature reproductive cell [n]\n",
  "GAMETIC": "of or like a gamete, also GAMETAL [adj GAMETICALLY]\n",
  "GAMETICALLY": "GAMETIC, of or like a gamete, also GAMETAL [adv]\n",
  "GAMETOCYTE": "a cell that divides to produce gametes [n -S]\n",
  "GAMETOCYTES": "GAMETOCYTE, a cell that divides to produce gametes [n]\n",
  "GAMETOGENESES": "GAMETOGENESIS, the formation of gametes, also GAMETOGENY [n]\n",
  "GAMETOGENESIS": "the formation of gametes, also GAMETOGENY [n GAMETOGENESES]\n",
  "GAMETOGENIC": "relating to gametogenesis, also GAMETOGENOUS [adj]\n",
  "GAMETOGENIES": "GAMETOGENY, the formation and maturation of gametes, also GAMETOGENESIS [n]\n",
  "GAMETOGENOUS": "relating to gametogenesis, also GAMETOGENIC [adj]\n",
  "GAMETOGENY": "the formation and maturation of gametes, also GAMETOGENESIS [n GAMETOGENIES]\n",
  "GAMETOPHORE": "the part of a plant that bears the reproductive organs [n -S]\n",
  "GAMETOPHORES": "GAMETOPHORE, the part of a plant that bears the reproductive organs [n]\n",
  "GAMETOPHORIC": "of or like a gametophore, the part of a plant that bears the reproductive organs [adj]\n",
  "GAMETOPHYTE": "the haploid stage in the life cycle of an organism undergoing alternations of generations [n -S]\n",
  "GAMETOPHYTES": "GAMETOPHYTE, the haploid stage in the life cycle of an organism undergoing alternations of generations [n]\n",
  "GAMETOPHYTIC": "of or like a gametophyte [adj]\n",
  "GAMEY": "tasting like game, highly flavoured, also GAMY [adj GAMIER, GAMIEST]\n",
  "GAMEYNESS": "the condition or quality of being gamey, also GAMINESS, GAMYNESS [n -ES]\n",
  "GAMEYNESSES": "GAMEYNESS, the condition or quality of being gamey, also GAMINESS, GAMYNESS [n]\n",
  "GAMGEE": "as in gamgee tissue, a type of wound-dressing consisting of cotton wool between two layers of gauze [adj]\n",
  "GAMIC": "requiring fertilisation [adj]\n",
  "GAMIER": "GAMY, tasting like game, highly flavoured, also GAMEY [adj]\n",
  "GAMIEST": "GAMY, tasting like game, highly flavoured, also GAMEY [adj]\n",
  "GAMIFICATION": "the process of adding games or gamelike elements to something (as a task) so as to encourage participation [n -S]\n",
  "GAMIFICATIONS": "GAMIFICATION, the process of adding games or gamelike elements to something (as a task) so as to encourage participation [n]\n",
  "GAMIFIED": "GAMIFY, to adapt (a task) so that it takes on the form of a game [v]\n",
  "GAMIFIES": "GAMIFY, to adapt (a task) so that it takes on the form of a game [v]\n",
  "GAMIFY": "to adapt (a task) so that it takes on the form of a game [v GAMIFIED, GAMIFYING, GAMIFIES]\n",
  "GAMIFYING": "GAMIFY, to adapt (a task) so that it takes on the form of a game [v]\n",
  "GAMILY": "GAMY, tasting like game, highly flavoured, also GAMEY [adv]\n",
  "GAMIN": "(French) a street urchin; a precocious imp [n -S]\n",
  "GAMINE": "(French) a homeless girl, a (female) urchin [n -S]\n",
  "GAMINERIE": "(French) impishness, boyishness (in a girl) [n -S]\n",
  "GAMINERIES": "GAMINERIE, (French) impishness, boyishness (in a girl) [n]\n",
  "GAMINES": "GAMINE, (French) a homeless girl, a (female) urchin [n]\n",
  "GAMINESQUE": "playful; impish; boyish [adj]\n",
  "GAMINESS": "the condition of being gamy, also GAMEYNESS, GAMYNESS [n -ES]\n",
  "GAMINESSES": "GAMINESS, the condition of being gamy, also GAMEYNESS, GAMYNESS [n]\n",
  "GAMING": "the practice of gambling [n -S]\n",
  "GAMINGS": "GAMING, the practice of gambling [n]\n",
  "GAMINS": "GAMIN, (French) a street urchin; a precocious imp [n]\n",
  "GAMMA": "(Greek) the third letter of the Greek alphabet [n -S]\n",
  "GAMMADIA": "GAMMADION, (Greek) a Greek ornamental design, also GAMMATION [n]\n",
  "GAMMADION": "(Greek) a Greek ornamental design, also GAMMATION [n GAMMADIA]\n",
  "GAMMAS": "GAMMA, (Greek) the third letter of the Greek alphabet [n]\n",
  "GAMMAT": "(South African) an offensive term for the accent of a Cape Coloured person [n -S]\n",
  "GAMMATIA": "GAMMATION, a Greek ornamental design, also GAMMADION [n]\n",
  "GAMMATION": "a Greek ornamental design, also GAMMADION [n GAMMATIA]\n",
  "GAMMATS": "GAMMAT, (South African) an offensive term for the accent of a Cape Coloured person [n]\n",
  "GAMME": "a musical scale [n -S]\n",
  "GAMMED": "GAM, to visit socially between whaling ships [v]\n",
  "GAMMER": "an old woman [n -S]\n",
  "GAMMERS": "GAMMER, an old woman [n]\n",
  "GAMMERSTANG": "(dialect) a tall, awkward person, usually a woman [n -S]\n",
  "GAMMERSTANGS": "GAMMERSTANG, (dialect) a tall, awkward person, usually a woman [n]\n",
  "GAMMES": "GAMME, a musical scale [n]\n",
  "GAMMIER": "GAMMY, lame, maimed [adj]\n",
  "GAMMIEST": "GAMMY, lame, maimed [adj]\n",
  "GAMMING": "GAM, to visit socially between whaling ships [v]\n",
  "GAMMOCK": "(dialect) to frolic [v -ED, -ING, -S]\n",
  "GAMMOCKED": "GAMMOCK, (dialect) to frolic [v]\n",
  "GAMMOCKING": "GAMMOCK, (dialect) to frolic [v]\n",
  "GAMMOCKS": "GAMMOCK, (dialect) to frolic [v]\n",
  "GAMMON": "to mislead by deceptive talk [v -ED, -ING, -S]\n",
  "GAMMONED": "GAMMON, to mislead by deceptive talk [v]\n",
  "GAMMONER": "one who misleads by deceptive talk [n -S]\n",
  "GAMMONERS": "GAMMONER, one who misleads by deceptive talk [n]\n",
  "GAMMONING": "the act of hoaxing [n -S]\n",
  "GAMMONINGS": "GAMMONING, the act of hoaxing [n]\n",
  "GAMMONS": "GAMMON, to mislead by deceptive talk [v]\n",
  "GAMMY": "lame, maimed [adj GAMMIER, GAMMIEST]\n",
  "GAMODEME": "a somewhat isolated breeding community of organisms [n -S]\n",
  "GAMODEMES": "GAMODEME, a somewhat isolated breeding community of organisms [n]\n",
  "GAMOGENESES": "GAMOGENESIS, sexual reproduction [n]\n",
  "GAMOGENESIS": "sexual reproduction [n GAMOGENESES]\n",
  "GAMOGENETIC": "relating to gamogenesis, sexual reproduction, also GAMOGENETICAL [adj GAMOGENETICALLY]\n",
  "GAMOGENETICAL": "relating to gamogenesis, sexual reproduction, also GAMOGENETIC [adj GAMOGENETICALLY]\n",
  "GAMOGENETICALLY": "GAMOGENETICAL, relating to gamogenesis, sexual reproduction, also GAMOGENETIC [adv]\n",
  "GAMONE": "any chemical substance secreted by a gamete that attracts another gamete during sexual reproduction [n -S]\n",
  "GAMONES": "GAMONE, any chemical substance secreted by a gamete that attracts another gamete during sexual reproduction [n]\n",
  "GAMOPETALOUS": "petals partially fused [adj]\n",
  "GAMOPHYLLOUS": "with perianth leaves united [adj]\n",
  "GAMOSEPALOUS": "with sepals partly united [adj]\n",
  "GAMOTROPIC": "relating to gamotropism, the tendency of gametes to attract one another [adj]\n",
  "GAMOTROPISM": "the tendency of gametes to attract each other [n -S]\n",
  "GAMOTROPISMS": "GAMOTROPISM, the tendency of gametes to attract each other [n]\n",
  "GAMP": "a large umbrella [n -S]\n",
  "GAMPISH": "like Mrs Gamp's umbrella -- bulging [adj]\n",
  "GAMPS": "GAMP, a large umbrella [n]\n",
  "GAMS": "GAM, to visit socially between whaling ships [v]\n",
  "GAMUT": "the complete range of something, e.g. the full range of notes which a voice or instrument can produce [n -S]\n",
  "GAMUTS": "GAMUT, the complete range of something, e.g. the full range of notes which a voice or instrument can produce [n]\n",
  "GAMY": "tasting like game, highly flavoured, also GAMEY [adj GAMIER, GAMIEST, GAMILY]\n",
  "GAMYNESS": "the condition of being gamy, also GAMEYNESS, GAMINESS [n -ES]\n",
  "GAMYNESSES": "GAMYNESS, the condition of being gamy, also GAMEYNESS, GAMINESS [n]\n",
  "GAN": "(dialect) to go [v GANNED, GANNING, GANS]\n",
  "GANACHE": "(French) a sweet creamy chocolate mixture [n -S]\n",
  "GANACHES": "GANACHE, (French) a sweet creamy chocolate mixture [n]\n",
  "GANCH": "to impale, also GAUNCH [v -ED, -ING, -ES]\n",
  "GANCHED": "GANCH, to impale, also GAUNCH [v]\n",
  "GANCHES": "GANCH, to impale, also GAUNCH [v]\n",
  "GANCHING": "GANCH, to impale, also GAUNCH [v]\n",
  "GANDER": "a male goose [n -S] / to wander [v -ED, -ING, -S]\n",
  "GANDERED": "GANDER, to wander [v]\n",
  "GANDERING": "GANDER, to wander [v]\n",
  "GANDERISM": "foolish behaviour, as suited to a gander [n -S]\n",
  "GANDERISMS": "GANDERISM, foolish behaviour, as suited to a gander [n]\n",
  "GANDERS": "GANDER, to wander [v]\n",
  "GANDY": "as in gandy dancer, a railway track maintenance worker [adj]\n",
  "GANE": "GAE, (Scots) to go [v]\n",
  "GANEF": "(Yiddish) a thief, also GANEV, GANOF, GONEF, GONIF, GONIFF, GONOF, GONOPH [n -S]\n",
  "GANEFS": "GANEF, (Yiddish) a thief, also GANEV, GANOF, GONEF, GONIF, GONIFF, GONOF, GONOPH [n]\n",
  "GANEV": "(Yiddish) a thief, also GANEF, GANOF, GONEF, GONIF, GONIFF, GONOF, GONOPH [n -S]\n",
  "GANEVS": "GANEV, (Yiddish) a thief, also GANEF, GANOF, GONEF, GONIF, GONIFF, GONOF, GONOPH [n]\n",
  "GANG": "to form into a gang (group) [v -ED, -ING, -S]\n",
  "GANGBANG": "(vulgar) successive copulations of one person by many others [n -S] / to carry out a gangbang, also GANGSHAG [v -ED, -ING, -S]\n",
  "GANGBANGED": "GANGBANG, to carry out a gangbang, also GANGSHAG [v]\n",
  "GANGBANGER": "(vulgar) one involved in a gangbang [n -S]\n",
  "GANGBANGERS": "GANGBANGER, (vulgar) one involved in a gangbang [n]\n",
  "GANGBANGING": "GANGBANG, to carry out a gangbang, also GANGSHAG [v]\n",
  "GANGBANGS": "GANGBANG, (vulgar) successive copulations of one person by many others [n]\n",
  "GANGBO": "a civil order restricting the activities of a gang member [n -S]\n",
  "GANGBOARD": "a gangway, a plank for walking on [n -S]\n",
  "GANGBOARDS": "GANGBOARD, a gangway, a plank for walking on [n]\n",
  "GANGBOS": "GANGBO, a civil order restricting the activities of a gang member [n]\n",
  "GANGBUSTER": "a special police agent working to combat criminal gangs [n -S]\n",
  "GANGBUSTERS": "GANGBUSTER, a special police agent working to combat criminal gangs [n]\n",
  "GANGBUSTING": "breaking up gangs [n -S]\n",
  "GANGBUSTINGS": "GANGBUSTING, breaking up gangs [n]\n",
  "GANGED": "GANG, to form into a gang (group) [v]\n",
  "GANGER": "a foreman of a group of labourers [n -S]\n",
  "GANGERS": "GANGER, a foreman of a group of labourers [n]\n",
  "GANGING": "the act of associating in a gang [n -S]\n",
  "GANGINGS": "GANGING, the act of associating in a gang [n]\n",
  "GANGLAND": "the criminal underworld [n -S]\n",
  "GANGLANDS": "GANGLAND, the criminal underworld [n]\n",
  "GANGLE": "to move awkwardly [v GANGLED, GANGLING, GANGLES]\n",
  "GANGLED": "GANGLE, to move awkwardly [v]\n",
  "GANGLES": "GANGLE, to move awkwardly [v]\n",
  "GANGLIA": "GANGLION, (Greek) a group of nerve cells [n]\n",
  "GANGLIAL": "pertaining to a ganglion, also GANGLIAR [adj]\n",
  "GANGLIAR": "pertaining to a ganglion, also GANGLIAL [adj]\n",
  "GANGLIATE": "having a ganglion or ganglia, also GANGLIATED [adj]\n",
  "GANGLIATED": "having a ganglion or ganglia, also GANGLIATE [adj]\n",
  "GANGLIER": "GANGLY, awkwardly tall and lanky, also GANGLING [adj]\n",
  "GANGLIEST": "GANGLY, awkwardly tall and lanky, also GANGLING [adj]\n",
  "GANGLIFORM": "in the form of a ganglion, a nerve centre, a tumour in a tendon sheath [adj]\n",
  "GANGLING": "awkwardly tall and lanky [adj]\n",
  "GANGLION": "(Greek) a group of nerve cells [n GANGLIONS or GANGLIA]\n",
  "GANGLIONATED": "having a ganglion or ganglia [adj]\n",
  "GANGLIONIC": "pertaining to, containing, or consisting of, ganglia or ganglion cells [adj]\n",
  "GANGLIONS": "GANGLION, (Greek) a group of nerve cells [n]\n",
  "GANGLIOSIDE": "any of a group of glycolipids that yield a hexose sugar on hydrolysis [n -S]\n",
  "GANGLIOSIDES": "GANGLIOSIDE, any of a group of glycolipids that yield a hexose sugar on hydrolysis [n]\n",
  "GANGLY": "awkwardly tall and lanky, also GANGLING [adj GANGLIER, GANGLIEST]\n",
  "GANGMASTER": "a person who recruits and manages temporary or migratory labourers, esp. for seasonal agricultural work [n -S]\n",
  "GANGMASTERS": "GANGMASTER, a person who recruits and manages temporary or migratory labourers, esp. for seasonal agricultural work [n]\n",
  "GANGPLANK": "a plank by which a boat can be boarded [n -S]\n",
  "GANGPLANKS": "GANGPLANK, a plank by which a boat can be boarded [n]\n",
  "GANGPLOW": "an agricultural implement [n -S]\n",
  "GANGPLOWS": "GANGPLOW, an agricultural implement [n]\n",
  "GANGREL": "a vagabond [n -S]\n",
  "GANGRELS": "GANGREL, a vagabond [n]\n",
  "GANGRENE": "to suffer loss of tissue in part of the body [v GANGRENED, GANGRENING, GANGRENES]\n",
  "GANGRENED": "GANGRENE, to suffer loss of tissue in part of the body [v]\n",
  "GANGRENES": "GANGRENE, to suffer loss of tissue in part of the body [v]\n",
  "GANGRENING": "GANGRENE, to suffer loss of tissue in part of the body [v]\n",
  "GANGRENOUS": "of or like gangrene [adj]\n",
  "GANGS": "GANG, to form into a gang (group) [v]\n",
  "GANGSHAG": "(vulgar) successive copulations of one person by many others [n -S] / to carry out a gangshag, also GANGBANG [v GANGSHAGGED, GANGSHAGGING, GANGSHAGS]\n",
  "GANGSHAGGED": "GANGSHAG, to carry out a gangshag, also GANGBANG [v]\n",
  "GANGSHAGGING": "GANGSHAG, to carry out a gangshag, also GANGBANG [v]\n",
  "GANGSHAGS": "GANGSHAG, to carry out a gangshag, also GANGBANG [v]\n",
  "GANGSMAN": "a foreman of a gang [n GANGSMEN]\n",
  "GANGSMEN": "GANGSMAN, a foreman of a gang [n]\n",
  "GANGSTA": "an aggressive, misogynistic style of rap music [n -S]\n",
  "GANGSTAS": "GANGSTA, an aggressive, misogynistic style of rap music [n]\n",
  "GANGSTER": "a member of a criminal gang [n -S]\n",
  "GANGSTERDOM": "the world of gangsters [n -S]\n",
  "GANGSTERDOMS": "GANGSTERDOM, the world of gangsters [n]\n",
  "GANGSTERISH": "like a gangster [adj]\n",
  "GANGSTERISM": "the ethos of the gangster [n -S]\n",
  "GANGSTERISMS": "GANGSTERISM, the ethos of the gangster [n]\n",
  "GANGSTERLAND": "the world of gangsters [n -S]\n",
  "GANGSTERLANDS": "GANGSTERLAND, the world of gangsters [n]\n",
  "GANGSTERS": "GANGSTER, a member of a criminal gang [n]\n",
  "GANGUE": "(French) the worthless rock in which valuable minerals are found [n -S]\n",
  "GANGUES": "GANGUE, (French) the worthless rock in which valuable minerals are found [n]\n",
  "GANGWAY": "either of the sides of the upper deck of a ship [n -S]\n",
  "GANGWAYS": "GANGWAY, either of the sides of the upper deck of a ship [n]\n",
  "GANISTER": "a flintlike rock used for surfacing roads, also GANNISTER [n -S]\n",
  "GANISTERS": "GANISTER, a flintlike rock used for surfacing roads, also GANNISTER [n]\n",
  "GANJA": "(Hindi) cannabis used for smoking, also GANJAH [n -S]\n",
  "GANJAH": "(Hindi) cannabis used for smoking, also GANJA [n -S]\n",
  "GANJAHS": "GANJAH, (Hindi) cannabis used for smoking, also GANJA [n]\n",
  "GANJAS": "GANJA, (Hindi) cannabis used for smoking, also GANJAH [n]\n",
  "GANNED": "GAN, (dialect) to go [v]\n",
  "GANNET": "a large seabird [n -S]\n",
  "GANNETRIES": "GANNETRY, a breeding place for gannets [n]\n",
  "GANNETRY": "a breeding place for gannets [n GANNETRIES]\n",
  "GANNETS": "GANNET, a large seabird [n]\n",
  "GANNING": "GAN, (dialect) to go [v]\n",
  "GANNISTER": "a flintlike rock used for lining Bessemer converters and for surfacing roads, also GANISTER [n -S]\n",
  "GANNISTERS": "GANNISTER, a flintlike rock used for lining Bessemer converters and for surfacing roads, also GANISTER [n]\n",
  "GANOF": "(Yiddish) a thief, also GANEF, GANEV, GONEF, GONIF, GONIFF, GONOF, GONOPH [n -S]\n",
  "GANOFS": "GANOF, (Yiddish) a thief, also GANEF, GANEV, GONEF, GONIF, GONIFF, GONOF, GONOPH [n]\n",
  "GANOID": "a type of fish with shiny smooth scales, such as sturgeon and gar [n -S]\n",
  "GANOIDS": "GANOID, a type of fish with shiny smooth scales, such as sturgeon and gar [n]\n",
  "GANOIN": "the hard shiny substance resembling enamel which forms the outer layer of ganoid fish-scales, also GANOINE [n -S]\n",
  "GANOINE": "the hard shiny substance resembling enamel which forms the outer layer of ganoid fish-scales, also GANOIN [n -S]\n",
  "GANOINES": "GANOINE, the hard shiny substance resembling enamel which forms the outer layer of ganoid fish-scales, also GANOIN [n]\n",
  "GANOINS": "GANOIN, the hard shiny substance resembling enamel which forms the outer layer of ganoid fish-scales, also GANOINE [n]\n",
  "GANS": "GAN, (dialect) to go [v]\n",
  "GANSEY": "a woollen sweater [n -S]\n",
  "GANSEYS": "GANSEY, a woollen sweater [n]\n",
  "GANT": "(Scots) to yawn, also GAUNT [v -ED, -ING, -S]\n",
  "GANTED": "GANT, (Scots) to yawn, also GAUNT [v]\n",
  "GANTELOPE": "an armoured glove, also GANTLET, GANTLOPE, GAUNTLET [n -S]\n",
  "GANTELOPES": "GANTELOPE, an armoured glove, also GANTLET, GANTLOPE, GAUNTLET [n]\n",
  "GANTING": "GANT, (Scots) to yawn, also GAUNT [v]\n",
  "GANTLET": "(obsolete) an armoured glove, also GANTELOPE, GANTLOPE, GAUNTLET [n -S] / to protect with an armoured glove [v -ED, -ING, -S]\n",
  "GANTLETED": "GANTLET, to protect with an armoured glove [v]\n",
  "GANTLETING": "GANTLET, to protect with an armoured glove [v]\n",
  "GANTLETS": "GANTLET, to protect with an armoured glove [v]\n",
  "GANTLINE": "a rope used in single-block hoist [n -S]\n",
  "GANTLINES": "GANTLINE, a rope used in single-block hoist [n]\n",
  "GANTLOPE": "an armoured glove, also GANTELOPE, GANTLET, GAUNTLET [n -S]\n",
  "GANTLOPES": "GANTLOPE, an armoured glove, also GANTELOPE, GANTLET, GAUNTLET [n]\n",
  "GANTRIES": "GANTRY, a structure for supporting railroad signals, also GAUNTRY [n]\n",
  "GANTRY": "a structure for supporting railroad signals, also GAUNTRY [n GANTRIES]\n",
  "GANTS": "GANT, (Scots) to yawn, also GAUNT [v]\n",
  "GANYMEDE": "(Greek) a catamite, a boy kept for purposes of sexual perversion [n -S]\n",
  "GANYMEDES": "GANYMEDE, (Greek) a catamite, a boy kept for purposes of sexual perversion [n]\n",
  "GANZFELD": "a technique of controlled sensory input used in parapsychology [n -S]\n",
  "GANZFELDS": "GANZFELD, a technique of controlled sensory input used in parapsychology [n]\n",
  "GAOL": "to imprison, also JAIL [v GAOLED, GAOLING, GAOLS]\n",
  "GAOLBIRD": "an inveterate convict, also JAILBIRD [n -S]\n",
  "GAOLBIRDS": "GAOLBIRD, an inveterate convict, also JAILBIRD [n]\n",
  "GAOLBREAK": "to break out of gaol, also JAILBREAK [v GAOLBROKE, GAOLBROKEN, GAOLBREAKING, GAOLBREAKS]\n",
  "GAOLBREAKING": "GAOLBREAK, to break out of gaol, also JAILBREAK [v]\n",
  "GAOLBREAKS": "GAOLBREAK, to break out of gaol, also JAILBREAK [v]\n",
  "GAOLBROKE": "GAOLBREAK, to break out of gaol, also JAILBREAK [v]\n",
  "GAOLBROKEN": "GAOLBREAK, to break out of gaol, also JAILBREAK [v]\n",
  "GAOLED": "GAOL, to imprison, also JAIL [v]\n",
  "GAOLER": "one who keeps a gaol, also JAILER, JAILOR [n -S]\n",
  "GAOLERESS": "a female gaoler, also JAILERESS, JAILORESS [n -ES]\n",
  "GAOLERESSES": "GAOLERESS, a female gaoler, also JAILERESS, JAILORESS [n]\n",
  "GAOLERS": "GAOLER, one who keeps a gaol, also JAILER, JAILOR [n]\n",
  "GAOLING": "GAOL, to imprison, also JAIL [v]\n",
  "GAOLLESS": "having no gaol, also JAILLESS [adj]\n",
  "GAOLS": "GAOL, to imprison, also JAIL [v]\n",
  "GAP": "to make an opening in [v GAPPED, GAPPING, GAPS]\n",
  "GAPE": "to stare with open mouth [v GAPED, GAPING, GAPES]\n",
  "GAPED": "GAPE, to stare with open mouth [v]\n",
  "GAPER": "a mollusc with a shell gaping at each end [n -S]\n",
  "GAPERS": "GAPER, a mollusc with a shell gaping at each end [n]\n",
  "GAPES": "GAPE, to stare with open mouth [v]\n",
  "GAPESEED": "anything that causes stares; or someone who stares [n -S]\n",
  "GAPESEEDS": "GAPESEED, anything that causes stares; or someone who stares [n]\n",
  "GAPEWORM": "a worm that causes a disease of young birds [n -S]\n",
  "GAPEWORMS": "GAPEWORM, a worm that causes a disease of young birds [n]\n",
  "GAPIER": "GAPY, infested with gapeworms [adj]\n",
  "GAPIEST": "GAPY, infested with gapeworms [adj]\n",
  "GAPING": "wide open [adj GAPINGLY] / the act of gaping [n -S]\n",
  "GAPINGLY": "GAPING, wide open [adv]\n",
  "GAPINGS": "GAPING, the act of gaping [n]\n",
  "GAPLESS": "without a gap [adj]\n",
  "GAPO": "(Tupi) in Peru, a riverside forest periodically flooded, also IGAPO [n -S]\n",
  "GAPOS": "GAPO, (Tupi) in Peru, a riverside forest periodically flooded, also IGAPO [n]\n",
  "GAPOSIS": "a gap between buttoned buttons or closed snaps on a garment [n -ES]\n",
  "GAPOSISES": "GAPOSIS, a gap between buttoned buttons or closed snaps on a garment [n]\n",
  "GAPPED": "GAP, to make an opening in [v]\n",
  "GAPPER": "a person taking a year out between school and further education [n -S]\n",
  "GAPPERS": "GAPPER, a person taking a year out between school and further education [n]\n",
  "GAPPIER": "GAPPY, full of gaps [adj]\n",
  "GAPPIEST": "GAPPY, full of gaps [adj]\n",
  "GAPPING": "as in call gapping [n -S]\n",
  "GAPPINGS": "GAPPING, as in call gapping [n]\n",
  "GAPPY": "full of gaps [adj GAPPIER, GAPPIEST]\n",
  "GAPS": "GAP, to make an opening in [v]\n",
  "GAPY": "infested with gapeworms [adj GAPIER, GAPIEST]\n",
  "GAR": "(Scots) to cause or compel [v GART or GARRED, GARRING, GARS]\n",
  "GARAGE": "to put in a garage (a car shelter) [v GARAGED, GARAGING, GARAGES]\n",
  "GARAGED": "GARAGE, to put in a garage (a car shelter) [v]\n",
  "GARAGEMAN": "one who works at a garage [n GARAGEMEN]\n",
  "GARAGEMEN": "GARAGEMAN, one who works at a garage [n]\n",
  "GARAGES": "GARAGE, to put in a garage (a car shelter) [v]\n",
  "GARAGEY": "in the garage style of music [adj GARAGIER, GARAGIEST]\n",
  "GARAGIER": "GARAGEY, in the garage style of music [adj]\n",
  "GARAGIEST": "GARAGEY, in the garage style of music [adj]\n",
  "GARAGING": "the placing of a vehicle in a garage [n -S]\n",
  "GARAGINGS": "GARAGING, the placing of a vehicle in a garage [n]\n",
  "GARAGIST": "a garage proprietor or owner, also GARAGISTE [n -S]\n",
  "GARAGISTE": "a garage proprietor or owner, also GARAGIST [n -S]\n",
  "GARAGISTES": "GARAGISTE, a garage proprietor or owner, also GARAGIST [n]\n",
  "GARAGISTS": "GARAGIST, a garage proprietor or owner, also GARAGISTE [n]\n",
  "GARB": "to clothe [v -ED, -ING, -S]\n",
  "GARBAGE": "food waste [n -S]\n",
  "GARBAGEMAN": "one who collects and hauls away garbage [n GARBAGEMEN]\n",
  "GARBAGEMEN": "GARBAGEMAN, one who collects and hauls away garbage [n]\n",
  "GARBAGES": "GARBAGE, food waste [n]\n",
  "GARBAGEY": "like garbage, also GARBAGY [adj GARBAGIER, GARBAGIEST]\n",
  "GARBAGIER": "GARBAGY, like garbage, also GARBAGEY [adj]\n",
  "GARBAGIEST": "GARBAGY, like garbage, also GARBAGEY [adj]\n",
  "GARBAGY": "like garbage, also GARBAGEY [adj GARBAGIER, GARBAGIEST]\n",
  "GARBANZO": "(Spanish) a chickpea [n -S]\n",
  "GARBANZOS": "GARBANZO, (Spanish) a chickpea [n]\n",
  "GARBE": "(French) a (heraldic) sheaf of wheat, also GERBE [n -S]\n",
  "GARBED": "GARB, to clothe [v]\n",
  "GARBES": "GARBE, (French) a (heraldic) sheaf of wheat, also GERBE [n]\n",
  "GARBING": "GARB, to clothe [v]\n",
  "GARBLE": "to distort the meaning of [v GARBLED, GARBLING, GARBLES]\n",
  "GARBLED": "GARBLE, to distort the meaning of [v]\n",
  "GARBLER": "one who garbles [n -S]\n",
  "GARBLERS": "GARBLER, one who garbles [n]\n",
  "GARBLES": "GARBLE, to distort the meaning of [v]\n",
  "GARBLESS": "without clothing [adj]\n",
  "GARBLING": "a distortion of meaning [n -S]\n",
  "GARBLINGS": "GARBLING, a distortion of meaning [n]\n",
  "GARBO": "(Australian slang) a garbage collector [n -S]\n",
  "GARBOARD": "(Dutch) a plank on a ship's bottom next to the keel [n -S]\n",
  "GARBOARDS": "GARBOARD, (Dutch) a plank on a ship's bottom next to the keel [n]\n",
  "GARBOIL": "(obsolete) a confused disordered state, turmoil [n -S]\n",
  "GARBOILS": "GARBOIL, (obsolete) a confused disordered state, turmoil [n]\n",
  "GARBOLOGIES": "GARBOLOGY, the study of society or culture by examining or analyzing its refuse [n]\n",
  "GARBOLOGIST": "a person who studies a society's waste materials [n -S]\n",
  "GARBOLOGISTS": "GARBOLOGIST, a person who studies a society's waste materials [n]\n",
  "GARBOLOGY": "the study of society or culture by examining or analyzing its refuse [n GARBOLOGIES]\n",
  "GARBOS": "GARBO, (Australian slang) a garbage collector [n]\n",
  "GARBS": "GARB, to clothe [v]\n",
  "GARBURATOR": "(Canadian) an electrically operated device in the plughole of a kitchen sink that breaks up food refuse so that it can travel down the waste pipe [n -S]\n",
  "GARBURATORS": "GARBURATOR, (Canadian) an electrically operated device in the plughole of a kitchen sink that breaks up food refuse so that it can travel down the waste pipe [n]\n",
  "GARBURE": "(French) a kind of Basque soup [n -S]\n",
  "GARBURES": "GARBURE, (French) a kind of Basque soup [n]\n",
  "GARCINIA": "a tropical evergreen tree [n -S]\n",
  "GARCINIAS": "GARCINIA, a tropical evergreen tree [n]\n",
  "GARCON": "(French) a waiter [n -S]\n",
  "GARCONS": "GARCON, (French) a waiter [n]\n",
  "GARDA": "(Irish) an Irish policeman [n GARDAI]\n",
  "GARDAI": "GARDA, (Irish) an Irish policeman [n]\n",
  "GARDANT": "a guardian, also GUARDANT [n -S]\n",
  "GARDANTS": "GARDANT, a guardian, also GUARDANT [n]\n",
  "GARDEN": "to cultivate a plot of land [v -ED, -ING, -S]\n",
  "GARDENED": "GARDEN, to cultivate a plot of land [v]\n",
  "GARDENER": "one that gardens [n -S]\n",
  "GARDENERS": "GARDENER, one that gardens [n]\n",
  "GARDENFUL": "the contents of a garden [n -S]\n",
  "GARDENFULS": "GARDENFUL, the contents of a garden [n]\n",
  "GARDENIA": "a tropical shrub or tree with fragrant flowers of a waxy appearance [n -S]\n",
  "GARDENIAS": "GARDENIA, a tropical shrub or tree with fragrant flowers of a waxy appearance [n]\n",
  "GARDENING": "the activity of tending a garden [n -S]\n",
  "GARDENINGS": "GARDENING, the activity of tending a garden [n]\n",
  "GARDENLESS": "without a garden [adj]\n",
  "GARDENS": "GARDEN, to cultivate a plot of land [v]\n",
  "GARDEROBE": "(historical) a chamber for storing clothes; a private chamber, a privy [n -S]\n",
  "GARDEROBES": "GARDEROBE, (historical) a chamber for storing clothes; a private chamber, a privy [n]\n",
  "GARDYLOO": "(Scots) a warning cry when slops are thrown from a window, also JORDELOO [n -S]\n",
  "GARDYLOOS": "GARDYLOO, (Scots) a warning cry when slops are thrown from a window, also JORDELOO [n]\n",
  "GARE": "(Scots) a dock-basin on a waterway [n -S]\n",
  "GAREFOWL": "(Old Norse) the great auk, also GAIRFOWL [n -S]\n",
  "GAREFOWLS": "GAREFOWL, (Old Norse) the great auk, also GAIRFOWL [n]\n",
  "GARES": "GARE, (Scots) a dock-basin on a waterway [n]\n",
  "GARFISH": "any of various fishes with slender bodies and long spearlike snouts, aka needlefish, also GARPIKE [n -ES]\n",
  "GARFISHES": "GARFISH, any of various fishes with slender bodies and long spearlike snouts, aka needlefish, also GARPIKE [n]\n",
  "GARGANEY": "(Italian) a kind of teal [n -S]\n",
  "GARGANEYS": "GARGANEY, (Italian) a kind of teal [n]\n",
  "GARGANTUA": "a monster in a Japanese film [n -S]\n",
  "GARGANTUAN": "very large [adj]\n",
  "GARGANTUAS": "GARGANTUA, a monster in a Japanese film [n]\n",
  "GARGARISE": "(obsolete) to gargle, also GARGARIZE [v GARGARISED, GARGARISING, GARGARISES]\n",
  "GARGARISED": "GARGARISE, (obsolete) to gargle, also GARGARIZE [v]\n",
  "GARGARISES": "GARGARISE, (obsolete) to gargle, also GARGARIZE [v]\n",
  "GARGARISING": "GARGARISE, (obsolete) to gargle, also GARGARIZE [v]\n",
  "GARGARISM": "(obsolete) a gargle [n -S]\n",
  "GARGARISMS": "GARGARISM, (obsolete) a gargle [n]\n",
  "GARGARIZE": "(obsolete) to gargle, also GARGARISE [v GARGARIZED, GARGARIZING, GARGARIZES]\n",
  "GARGARIZED": "GARGARIZE, (obsolete) to gargle, also GARGARISE [v]\n",
  "GARGARIZES": "GARGARIZE, (obsolete) to gargle, also GARGARISE [v]\n",
  "GARGARIZING": "GARGARIZE, (obsolete) to gargle, also GARGARISE [v]\n",
  "GARGET": "an inflammation of the throat or udder in cows, swine, etc. [n -S]\n",
  "GARGETS": "GARGET, an inflammation of the throat or udder in cows, swine, etc. [n]\n",
  "GARGETY": "suffering from garget (animal mastitis) [adj]\n",
  "GARGLE": "to rinse the mouth or throat [v GARGLED, GARGLING, GARGLES]\n",
  "GARGLED": "GARGLE, to rinse the mouth or throat [v]\n",
  "GARGLER": "one who garglers [n -S]\n",
  "GARGLERS": "GARGLER, one who garglers [n]\n",
  "GARGLES": "GARGLE, to rinse the mouth or throat [v]\n",
  "GARGLING": "GARGLE, to rinse the mouth or throat [v]\n",
  "GARGOYLE": "an ornamental figure, also GURGOYLE [n -S]\n",
  "GARGOYLED": "fitted with gargoyles [adj]\n",
  "GARGOYLES": "GARGOYLE, an ornamental figure, also GURGOYLE [n]\n",
  "GARGOYLISM": "a rare condition characterised by grotesque physical deformity and severe mental disablement [n -S]\n",
  "GARGOYLISMS": "GARGOYLISM, a rare condition characterised by grotesque physical deformity and severe mental disablement [n]\n",
  "GARI": "(Japanese) thinly sliced pickled ginger, served with sushi [n -S]\n",
  "GARIAL": "(Hindi) an Indian crocodile, also GAVIAL, GHARIAL [n -S]\n",
  "GARIALS": "GARIAL, (Hindi) an Indian crocodile, also GAVIAL, GHARIAL [n]\n",
  "GARIBALDI": "(Italian) a biscuit with a layer of currants [n -S]\n",
  "GARIBALDIS": "GARIBALDI, (Italian) a biscuit with a layer of currants [n]\n",
  "GARIGUE": "(French) an uncultivated open scrubland of the Mediterranean region, also GARRIGUE [n -S]\n",
  "GARIGUES": "GARIGUE, (French) an uncultivated open scrubland of the Mediterranean region, also GARRIGUE [n]\n",
  "GARIS": "GARI, (Japanese) thinly sliced pickled ginger, served with sushi [n]\n",
  "GARISH": "glaring [adj GARISHLY] / to heal, also GUARISH [v -ED, -ING, -ES]\n",
  "GARISHED": "GARISH, to heal, also GUARISH [v]\n",
  "GARISHES": "GARISH, to heal, also GUARISH [v]\n",
  "GARISHING": "GARISH, to heal, also GUARISH [v]\n",
  "GARISHLY": "GARISH, glaring [adv]\n",
  "GARISHNESS": "the quality of being garish [n -ES]\n",
  "GARISHNESSES": "GARISHNESS, the quality of being garish [n]\n",
  "GARJAN": "(Hindi) a thin balsam or wood oil derived from an East Indian tree, also GURJUN [n -S]\n",
  "GARJANS": "GARJAN, (Hindi) a thin balsam or wood oil derived from an East Indian tree, also GURJUN [n]\n",
  "GARLAND": "a wreath of flowers or leaves, also GIRLOND [n -S] / to crown with a garland [v -ED, -ING, -S]\n",
  "GARLANDAGE": "(Tennyson) a decoration of garlands [n -S]\n",
  "GARLANDAGES": "GARLANDAGE, (Tennyson) a decoration of garlands [n]\n",
  "GARLANDED": "GARLAND, to crown with a garland [v]\n",
  "GARLANDING": "GARLAND, to crown with a garland [v]\n",
  "GARLANDLESS": "without a garland [adj]\n",
  "GARLANDRIES": "GARLANDRY, garlands collectively [n]\n",
  "GARLANDRY": "garlands collectively [n GARLANDRIES]\n",
  "GARLANDS": "GARLAND, to crown with a garland [v]\n",
  "GARLIC": "a cooking herb [n -S] / to flavour with garlic [v GARLICKED, GARLICKING, GARLICS]\n",
  "GARLICKED": "GARLIC, to flavour with garlic [v]\n",
  "GARLICKIER": "GARLICKY, tasting or smelling of garlic [adj]\n",
  "GARLICKIEST": "GARLICKY, tasting or smelling of garlic [adj]\n",
  "GARLICKING": "GARLIC, to flavour with garlic [v]\n",
  "GARLICKY": "tasting or smelling of garlic [adj GARLICKIER, GARLICKIEST]\n",
  "GARLICS": "GARLIC, to flavour with garlic [v]\n",
  "GARMENT": "any article of clothing [n -S] / to dress in a garment [v -ED, -ING, -S]\n",
  "GARMENTED": "GARMENT, to dress in a garment [v]\n",
  "GARMENTING": "GARMENT, to dress in a garment [v]\n",
  "GARMENTLESS": "without garments [adj]\n",
  "GARMENTS": "GARMENT, to dress in a garment [v]\n",
  "GARMENTURE": "clothing, dress [n -S]\n",
  "GARMENTURES": "GARMENTURE, clothing, dress [n]\n",
  "GARMS": "(slang) clothes [n]\n",
  "GARNER": "to gather and store [v -ED, -ING, -S]\n",
  "GARNERED": "GARNER, to gather and store [v]\n",
  "GARNERING": "GARNER, to gather and store [v]\n",
  "GARNERS": "GARNER, to gather and store [v]\n",
  "GARNET": "a name given to various silicates, some semiprecious [n -S]\n",
  "GARNETIFEROUS": "bearing garnets [adj]\n",
  "GARNETS": "GARNET, a name given to various silicates, some semiprecious [n]\n",
  "GARNI": "(French) garnished [adj]\n",
  "GARNIERITE": "a hydrous silicate of nickel and magnesia, an important ore of nickel [n -S]\n",
  "GARNIERITES": "GARNIERITE, a hydrous silicate of nickel and magnesia, an important ore of nickel [n]\n",
  "GARNISH": "to decorate with ornamental appendages; to embellish [v -ED, -ING, -ES]\n",
  "GARNISHED": "GARNISH, to decorate with ornamental appendages; to embellish [v]\n",
  "GARNISHEE": "a person warned not to pay money owed to another, because the latter is indebted to the garnisher who gives the warning [n -S] / to make someone a garnishee [v GARNISHEED, GARNISHEEING, GARNISHEES]\n",
  "GARNISHEED": "GARNISHEE, to make someone a garnishee [v]\n",
  "GARNISHEEING": "GARNISHEE, to make someone a garnishee [v]\n",
  "GARNISHEEMENT": "the act of garnisheeing [n -S]\n",
  "GARNISHEEMENTS": "GARNISHEEMENT, the act of garnisheeing [n]\n",
  "GARNISHEES": "GARNISHEE, to make someone a garnishee [v]\n",
  "GARNISHER": "one who, or that which, garnishes, also GARNISHOR [n -S]\n",
  "GARNISHERS": "GARNISHER, one who, or that which, garnishes, also GARNISHOR [n]\n",
  "GARNISHES": "GARNISH, to decorate with ornamental appendages; to embellish [v]\n",
  "GARNISHING": "decoration with ornamental appendages [n -S]\n",
  "GARNISHINGS": "GARNISHING, decoration with ornamental appendages [n]\n",
  "GARNISHMENT": "garnish, ornament [n -S]\n",
  "GARNISHMENTS": "GARNISHMENT, garnish, ornament [n]\n",
  "GARNISHOR": "one who, or that which, garnishes, also GARNISHER [n -S]\n",
  "GARNISHORS": "GARNISHOR, one who, or that which, garnishes, also GARNISHER [n]\n",
  "GARNISHRIES": "GARNISHRY, (Browning) adornment [n]\n",
  "GARNISHRY": "(Browning) adornment [n GARNISHRIES]\n",
  "GARNITURE": "(French) embellishment, trimming; a set of decorative objects [n -S]\n",
  "GARNITURES": "GARNITURE, (French) embellishment, trimming; a set of decorative objects [n]\n",
  "GAROTE": "to execute by strangling, also GARROTE, GAROTTE, GARROTTE [v GAROTED, GAROTING, GAROTES]\n",
  "GAROTED": "GAROTE, to execute by strangling, also GARROTE, GAROTTE, GARROTTE [v]\n",
  "GAROTES": "GAROTE, to execute by strangling, also GARROTE, GAROTTE, GARROTTE [v]\n",
  "GAROTING": "GAROTE, to execute by strangling, also GARROTE, GAROTTE, GARROTTE [v]\n",
  "GAROTTE": "to execute by strangling, also GARROTE, GAROTE, GARROTTE [v GAROTTED, GAROTTING, GAROTTES]\n",
  "GAROTTED": "GAROTTE, to execute by strangling, also GARROTE, GAROTE, GARROTTE [v]\n",
  "GAROTTER": "one who executes by strangling, also GARROTER [n -S]\n",
  "GAROTTERS": "GAROTTER, one who executes by strangling, also GARROTER [n]\n",
  "GAROTTES": "GAROTTE, to execute by strangling, also GARROTE, GAROTE, GARROTTE [v]\n",
  "GAROTTING": "the act of strangling [n -S]\n",
  "GAROTTINGS": "GAROTTING, the act of strangling [n]\n",
  "GAROUPA": "(Chinese) in Chinese cookery, another name for the grouper fish [n -S]\n",
  "GAROUPAS": "GAROUPA, (Chinese) in Chinese cookery, another name for the grouper fish [n]\n",
  "GARPIKE": "any of various fishes with slender bodies and long spearlike snouts, aka needlefish, also GARFISH [n -S]\n",
  "GARPIKES": "GARPIKE, any of various fishes with slender bodies and long spearlike snouts, aka needlefish, also GARFISH [n]\n",
  "GARRAN": "(Irish) a small sturdy horse, also GARRON [n -S]\n",
  "GARRANS": "GARRAN, (Irish) a small sturdy horse, also GARRON [n]\n",
  "GARRE": "(Spenser) to make, compel [v GARRED, GARRING, GARRES]\n",
  "GARRED": "GARRE, (Spenser) to make, compel [v]\n",
  "GARRES": "GARRE, (Spenser) to make, compel [v]\n",
  "GARRET": "a room just under the roof of a house; an attic [n -S]\n",
  "GARRETED": "lodged in a garret [adj]\n",
  "GARRETEER": "(archaic) one who lives in a garret esp. a poor author [n -S]\n",
  "GARRETEERS": "GARRETEER, (archaic) one who lives in a garret esp. a poor author [n]\n",
  "GARRETS": "GARRET, a room just under the roof of a house; an attic [n]\n",
  "GARRIGUE": "(French) an uncultivated open scrubland of the Mediterranean region, also GARIGUE [n -S]\n",
  "GARRIGUES": "GARRIGUE, (French) an uncultivated open scrubland of the Mediterranean region, also GARIGUE [n]\n",
  "GARRING": "GARRE, (Spenser) to make, compel [v]\n",
  "GARRISON": "a body of troops stationed in a town, fortress, etc. to defend it [n -S] / to assign to a military post [v -ED, -ING, -S]\n",
  "GARRISONED": "GARRISON, to assign to a military post [v]\n",
  "GARRISONING": "GARRISON, to assign to a military post [v]\n",
  "GARRISONS": "GARRISON, to assign to a military post [v]\n",
  "GARRON": "a small sturdy horse, also GARRAN [n -S]\n",
  "GARRONS": "GARRON, a small sturdy horse, also GARRAN [n]\n",
  "GARROT": "a stick or small wooden cylinder used for tightening a bandage, in order to compress the arteries of a limb [n -S] / to constrict with a garrot [v -ED, -ING, -S]\n",
  "GARROTE": "to execute by strangling, also GAROTE, GAROTTE, GARROTTE [v GARROTED, GARROTING, GARROTES]\n",
  "GARROTED": "GARROTE, to execute by strangling, also GAROTE, GAROTTE, GARROTTE [v]\n",
  "GARROTER": "one who executes by strangling, also GAROTTER [n -S]\n",
  "GARROTERS": "GARROTER, one who executes by strangling, also GAROTTER [n]\n",
  "GARROTES": "GARROTE, to execute by strangling, also GAROTE, GAROTTE, GARROTTE [v]\n",
  "GARROTING": "GARROTE, to execute by strangling, also GAROTE, GAROTTE, GARROTTE [v]\n",
  "GARROTS": "GARROT, a stick or small wooden cylinder used for tightening a bandage, in order to compress the arteries of a limb [n]\n",
  "GARROTTE": "to execute by strangling, also GARROTE, GAROTE, GAROTTE [v GARROTTED, GARROTTING, GARROTTES]\n",
  "GARROTTED": "GARROTTE, to execute by strangling, also GARROTE, GAROTE, GAROTTE [v]\n",
  "GARROTTER": "one who garrottes [n -S]\n",
  "GARROTTERS": "GARROTTER, one who garrottes [n]\n",
  "GARROTTES": "GARROTTE, to execute by strangling, also GARROTE, GAROTE, GAROTTE [v]\n",
  "GARROTTING": "the act of strangling [n -S]\n",
  "GARROTTINGS": "GARROTTING, the act of strangling [n]\n",
  "GARRULITIES": "GARRULITY, talkativeness [n]\n",
  "GARRULITY": "talkativeness [n GARRULITIES]\n",
  "GARRULOUS": "talkative [adj GARRULOUSLY]\n",
  "GARRULOUSLY": "GARRULOUS, talkative [adv]\n",
  "GARRULOUSNESS": "GARRULOUS, talkative [n]\n",
  "GARRULOUSNESSES": "GARRULOUSNESS, GARRULOUS, talkative [n]\n",
  "GARRYA": "a North American ornamental catkin-bearing evergreen shrub [n -S]\n",
  "GARRYAS": "GARRYA, a North American ornamental catkin-bearing evergreen shrub [n]\n",
  "GARRYOWEN": "in rugby, a high kick forward followed by a rush towards the landing place of the ball [n -S]\n",
  "GARRYOWENS": "GARRYOWEN, in rugby, a high kick forward followed by a rush towards the landing place of the ball [n]\n",
  "GARS": "GAR, (Scots) to cause or compel [v]\n",
  "GART": "GAR, (Scots) to cause or compel [v]\n",
  "GARTER": "a band used to support a stocking [n -S] / to support with a garter [v -ED, -ING, -S]\n",
  "GARTERED": "GARTER, to support with a garter [v]\n",
  "GARTERING": "GARTER, to support with a garter [v]\n",
  "GARTERS": "GARTER, to support with a garter [v]\n",
  "GARTH": "(Old Norse) a small yard surrounded by a cloister [n -S]\n",
  "GARTHS": "GARTH, (Old Norse) a small yard surrounded by a cloister [n]\n",
  "GARUDA": "(Sanskrit) a Hindu demigod, part man, part bird [n -S]\n",
  "GARUDAS": "GARUDA, (Sanskrit) a Hindu demigod, part man, part bird [n]\n",
  "GARUM": "(Latin) a thick fish sauce [n -S]\n",
  "GARUMS": "GARUM, (Latin) a thick fish sauce [n]\n",
  "GARVEY": "a small flat-bottomed boat [n -S]\n",
  "GARVEYS": "GARVEY, a small flat-bottomed boat [n]\n",
  "GARVIE": "(Scots) a sprat, also GARVOCK [n -S]\n",
  "GARVIES": "GARVIE, (Scots) a sprat, also GARVOCK [n]\n",
  "GARVOCK": "(Scots) a sprat, also GARVIE [n -S]\n",
  "GARVOCKS": "GARVOCK, (Scots) a sprat, also GARVIE [n]\n",
  "GAS": "a state of matter [n GASES or GASSES] / to poison with gas [v GASSED, GASSING, GASSES]\n",
  "GASAHOL": "a mixture of 8 or 9 parts petrol and 1 or 2 parts alcohol, used as a fuel, also GASOHOL [n -S]\n",
  "GASAHOLS": "GASAHOL, a mixture of 8 or 9 parts petrol and 1 or 2 parts alcohol, used as a fuel, also GASOHOL [n]\n",
  "GASALIER": "a gaslight chandelier, also GASELIER, GASOLIER [n -S]\n",
  "GASALIERS": "GASALIER, a gaslight chandelier, also GASELIER, GASOLIER [n]\n",
  "GASBAG": "a bag for holding gas [n -S] / to talk a lot [v GASBAGGED, GASBAGGING, GASBAGS]\n",
  "GASBAGGED": "GASBAG, to talk a lot [v]\n",
  "GASBAGGING": "GASBAG, to talk a lot [v]\n",
  "GASBAGS": "GASBAG, to talk a lot [v]\n",
  "GASCON": "(French) a braggart [n -S]\n",
  "GASCONADE": "(French) boasting, bravado [n -S] / to boast [v GASCONADED, GASCONADING, GASCONADES]\n",
  "GASCONADED": "GASCONADE, to boast [v]\n",
  "GASCONADER": "a great boaster; a blusterer [n -S]\n",
  "GASCONADERS": "GASCONADER, a great boaster; a blusterer [n]\n",
  "GASCONADES": "GASCONADE, (French) boasting, bravado [n]\n",
  "GASCONADING": "GASCONADE, to boast [v]\n",
  "GASCONISM": "boastfulness [n -S]\n",
  "GASCONISMS": "GASCONISM, boastfulness [n]\n",
  "GASCONS": "GASCON, (French) a braggart [n]\n",
  "GASEITIES": "GASEITY, the state of being gaseous [n]\n",
  "GASEITY": "the state of being gaseous [n GASEITIES]\n",
  "GASELIER": "a gaslight chandelier, also GASALIER, GASOLIER [n -S]\n",
  "GASELIERS": "GASELIER, a gaslight chandelier, also GASALIER, GASOLIER [n]\n",
  "GASEOUS": "in the form of gas [adj]\n",
  "GASEOUSNESS": "the state of being gaseous [n -ES]\n",
  "GASEOUSNESSES": "GASEOUSNESS, the state of being gaseous [n]\n",
  "GASES": "GAS, to poison with gas [v]\n",
  "GASFIELD": "an area with natural gas [n -S]\n",
  "GASFIELDS": "GASFIELD, an area with natural gas [n]\n",
  "GASH": "to make a long deep cut in [v -ED, -ING, -ES] / ghastly [adj GASHER, GASHEST, GASHLY]\n",
  "GASHED": "GASH, to make a long deep cut in [v]\n",
  "GASHER": "GASH, ghastly [adj]\n",
  "GASHES": "GASH, to make a long deep cut in [v]\n",
  "GASHEST": "GASH, ghastly [adj]\n",
  "GASHFUL": "full of gashes; hideous; frightful [adj]\n",
  "GASHING": "GASH, to make a long deep cut in [v]\n",
  "GASHLIER": "GASHLY, ghastly [adj]\n",
  "GASHLIEST": "GASHLY, ghastly [adj]\n",
  "GASHLINESS": "ghastliness [n -ES]\n",
  "GASHLINESSES": "GASHLINESS, ghastliness [n]\n",
  "GASHLY": "ghastly [adj GASHLIER, GASHLIEST]\n",
  "GASHOLDER": "a storage tank for storing gas, also GASOMETER [n -S]\n",
  "GASHOLDERS": "GASHOLDER, a storage tank for storing gas, also GASOMETER [n]\n",
  "GASHOUSE": "a gasworks [n -S]\n",
  "GASHOUSES": "GASHOUSE, a gasworks [n]\n",
  "GASIFIABLE": "that can be gasified [adj]\n",
  "GASIFICATION": "conversion into gas [n -S]\n",
  "GASIFICATIONS": "GASIFICATION, conversion into gas [n]\n",
  "GASIFIED": "GASIFY, to convert into gas [v]\n",
  "GASIFIER": "a device for gasifying, converting into gas [n -S]\n",
  "GASIFIERS": "GASIFIER, a device for gasifying, converting into gas [n]\n",
  "GASIFIES": "GASIFY, to convert into gas [v]\n",
  "GASIFORM": "having the form of gas [adj]\n",
  "GASIFY": "to convert into gas [v GASIFIED, GASIFYING, GASIFIES]\n",
  "GASIFYING": "GASIFY, to convert into gas [v]\n",
  "GASKET": "a flat sheet or ring of rubber, asbestos, etc., inserted between two adjoining metal surfaces [n -S]\n",
  "GASKETED": "equipped with a gasket [adj]\n",
  "GASKETS": "GASKET, a flat sheet or ring of rubber, asbestos, etc., inserted between two adjoining metal surfaces [n]\n",
  "GASKIN": "a part of a horse's leg [n -S]\n",
  "GASKING": "a gasket [n -S]\n",
  "GASKINGS": "GASKING, a gasket [n]\n",
  "GASKINS": "GASKIN, a part of a horse's leg [n]\n",
  "GASLESS": "having no gas [adj]\n",
  "GASLIGHT": "to attempt to manipulate (a person) by continually presenting them with false information until they doubt their sanity [v -ED, -ING, -S]\n",
  "GASLIGHTED": "GASLIGHT, to attempt to manipulate (a person) by continually presenting them with false information until they doubt their sanity [v]\n",
  "GASLIGHTING": "GASLIGHT, to attempt to manipulate (a person) by continually presenting them with false information until they doubt their sanity [v]\n",
  "GASLIGHTS": "GASLIGHT, to attempt to manipulate (a person) by continually presenting them with false information until they doubt their sanity [v]\n",
  "GASLIT": "illuminated by gaslight [adj]\n",
  "GASMAN": "an employee of a gas company [n GASMEN]\n",
  "GASMEN": "GASMAN, an employee of a gas company [n]\n",
  "GASOGENE": "an apparatus for carbonating liquids, also GAZOGENE [n -S]\n",
  "GASOGENES": "GASOGENE, an apparatus for carbonating liquids, also GAZOGENE [n]\n",
  "GASOHOL": "a mixture of 8 or 9 parts petrol and 1 or 2 parts alcohol, used as a fuel, also GASAHOL [n -S]\n",
  "GASOHOLS": "GASOHOL, a mixture of 8 or 9 parts petrol and 1 or 2 parts alcohol, used as a fuel, also GASAHOL [n]\n",
  "GASOLENE": "a liquid fuel, also GASOLINE [n -S]\n",
  "GASOLENES": "GASOLENE, a liquid fuel, also GASOLINE [n]\n",
  "GASOLIER": "a gaslight chandelier, also GASELIER, GASALIER [n -S]\n",
  "GASOLIERS": "GASOLIER, a gaslight chandelier, also GASELIER, GASALIER [n]\n",
  "GASOLINE": "a liquid fuel, also GASOLENE [n -S]\n",
  "GASOLINES": "GASOLINE, a liquid fuel, also GASOLENE [n]\n",
  "GASOLINIC": "of or like gasoline [adj]\n",
  "GASOMETER": "an instrument for holding and measuring gases, also GASHOLDER [n -S]\n",
  "GASOMETERS": "GASOMETER, an instrument for holding and measuring gases, also GASHOLDER [n]\n",
  "GASOMETRIC": "relating to the measurement of gas, also GASOMETRICAL [adj]\n",
  "GASOMETRICAL": "relating to the measurement of gas, also GASOMETRIC [adj]\n",
  "GASOMETRIES": "GASOMETRY, the measurement of amounts of gas [n]\n",
  "GASOMETRY": "the measurement of amounts of gas [n GASOMETRIES]\n",
  "GASP": "to breathe convulsively [v -ED, -ING, -S]\n",
  "GASPED": "GASP, to breathe convulsively [v]\n",
  "GASPER": "(slang) a cheap cigarette [n -S]\n",
  "GASPEREAU": "(French) a fish of the herring family found on the Atlantic coast of North America, aka alewife [n GASPEREAUS or GASPEREAUX]\n",
  "GASPEREAUS": "GASPEREAU, (French) a fish of the herring family found on the Atlantic coast of North America, aka alewife [n]\n",
  "GASPEREAUX": "GASPEREAU, (French) a fish of the herring family found on the Atlantic coast of North America, aka alewife [n]\n",
  "GASPERS": "GASPER, (slang) a cheap cigarette [n]\n",
  "GASPIER": "GASPY, gasping [adj]\n",
  "GASPIEST": "GASPY, gasping [adj]\n",
  "GASPINESS": "the state of being gaspy [n -ES]\n",
  "GASPINESSES": "GASPINESS, the state of being gaspy [n]\n",
  "GASPING": "breathless [adj GASPINGLY] / the act of gasping [n -S]\n",
  "GASPINGLY": "GASPING, breathless [adv]\n",
  "GASPINGS": "GASPING, the act of gasping [n]\n",
  "GASPS": "GASP, to breathe convulsively [v]\n",
  "GASPY": "gasping [adj GASPIER, GASPIEST]\n",
  "GASSED": "GAS, to poison with gas [v]\n",
  "GASSER": "an oil well yielding natural gas [n -S]\n",
  "GASSERS": "GASSER, an oil well yielding natural gas [n]\n",
  "GASSES": "GAS, to poison with gas [v]\n",
  "GASSIER": "GASSY, containing gas [adj]\n",
  "GASSIEST": "GASSY, containing gas [adj]\n",
  "GASSILY": "GASSY, containing gas [adv]\n",
  "GASSINESS": "the state of being gassy [n -ES]\n",
  "GASSINESSES": "GASSINESS, the state of being gassy [n]\n",
  "GASSING": "a poisoning by noxious gases [n -S]\n",
  "GASSINGS": "GASSING, a poisoning by noxious gases [n]\n",
  "GASSY": "containing gas [adj GASSIER, GASSIEST, GASSILY]\n",
  "GAST": "(Shakespeare) to frighten, also GHAST [v -ED, -ING, -S]\n",
  "GASTED": "GAST, (Shakespeare) to frighten, also GHAST [v]\n",
  "GASTER": "to frighten, scare [v -ED, -ING, -S]\n",
  "GASTERED": "GASTER, to frighten, scare [v]\n",
  "GASTERING": "GASTER, to frighten, scare [v]\n",
  "GASTEROPOD": "any mollusc of the class Gastropoda, that includes the snails, whelks, limpets, and slugs, also GASTROPOD [n -S]\n",
  "GASTEROPODOUS": "like a gasteropod [adj]\n",
  "GASTEROPODS": "GASTEROPOD, any mollusc of the class Gastropoda, that includes the snails, whelks, limpets, and slugs, also GASTROPOD [n]\n",
  "GASTERS": "GASTER, to frighten, scare [v]\n",
  "GASTFULL": "(Spenser) terrifying; full of fear, also GHASTFUL [adj]\n",
  "GASTHAUS": "(German) a small hotel in Germany [n GASTHAUSER or GASTHAUSES]\n",
  "GASTHAUSER": "GASTHAUS, (German) a small hotel in Germany [n]\n",
  "GASTHAUSES": "GASTHAUS, (German) a small hotel in Germany [n]\n",
  "GASTIGHT": "not allowing gas in or out [adj]\n",
  "GASTIGHTNESS": "the state of being gastight [n -ES]\n",
  "GASTIGHTNESSES": "GASTIGHTNESS, the state of being gastight [n]\n",
  "GASTING": "GAST, (Shakespeare) to frighten, also GHAST [v]\n",
  "GASTNESS": "(Shakespeare) dread, also GASTNESSE, GHASTNESS [n -ES]\n",
  "GASTNESSE": "(Shakespeare) dread, also GASTNESS, GHASTNESS [n -S]\n",
  "GASTNESSES": "GASTNESS, (Shakespeare) dread, also GASTNESSE, GHASTNESS [n]\n",
  "GASTRAEA": "a hypothetical ancestor of the Metazoa, sponges etc., also GASTREA [n -S]\n",
  "GASTRAEAS": "GASTRAEA, a hypothetical ancestor of the Metazoa, sponges etc., also GASTREA [n]\n",
  "GASTRAEUM": "the undersurface of the body, esp. in birds [n -S]\n",
  "GASTRAEUMS": "GASTRAEUM, the undersurface of the body, esp. in birds [n]\n",
  "GASTRAL": "pertaining to the stomach [adj]\n",
  "GASTRALGIA": "pain in the stomach or epigastrium, as in gastric disorders [n -S]\n",
  "GASTRALGIAS": "GASTRALGIA, pain in the stomach or epigastrium, as in gastric disorders [n]\n",
  "GASTRALGIC": "relating to gastralgia, pain in the stomach [adj]\n",
  "GASTREA": "a hypothetical ancestor of the Metazoa, sponges etc., also GASTRAEA [n -S]\n",
  "GASTREAS": "GASTREA, a hypothetical ancestor of the Metazoa, sponges etc., also GASTRAEA [n]\n",
  "GASTRECTOMIES": "GASTRECTOMY, surgical removal of the stomach [n]\n",
  "GASTRECTOMY": "surgical removal of the stomach [n GASTRECTOMIES]\n",
  "GASTRIC": "pertaining to the stomach [adj]\n",
  "GASTRIN": "a hormone which stimulates production of gastric juice [n -S]\n",
  "GASTRINS": "GASTRIN, a hormone which stimulates production of gastric juice [n]\n",
  "GASTRITIC": "of or like gastritis [adj]\n",
  "GASTRITIDES": "GASTRITIS, inflammation of the stomach [n]\n",
  "GASTRITIS": "inflammation of the stomach [n GASTRITIDES or GASTRITISES]\n",
  "GASTRITISES": "GASTRITIS, inflammation of the stomach [n]\n",
  "GASTROCNEMII": "GASTROCNEMIUS, the muscle that bulges the calf of the leg [n]\n",
  "GASTROCNEMIUS": "the muscle that bulges the calf of the leg [n GASTROCNEMII]\n",
  "GASTROCOLIC": "of or relating to the stomach and colon [adj]\n",
  "GASTRODUODENAL": "of, relating to, or involving the stomach and the duodenum [adj]\n",
  "GASTROENTERIC": "gastrointestinal [adj]\n",
  "GASTROENTERITIC": "relating to gastroenteritis [adj]\n",
  "GASTROENTERITIS": "inflammation of the lining membrane of the stomach and the intestines characterized esp. by nausea, vomiting, diarrhea, and cramps [n]\n",
  "GASTROLITH": "a stone ingested by an animal to aid in digestion [n -S]\n",
  "GASTROLITHS": "GASTROLITH, a stone ingested by an animal to aid in digestion [n]\n",
  "GASTROLOGER": "a connoisseur of good eating and drinking, also GASTRONOME, GASTRONOMER [n -S]\n",
  "GASTROLOGERS": "GASTROLOGER, a connoisseur of good eating and drinking, also GASTRONOME, GASTRONOMER [n]\n",
  "GASTROLOGICAL": "related to gastrology [adj]\n",
  "GASTROLOGIES": "GASTROLOGY, good eating; cookery [n]\n",
  "GASTROLOGIST": "a student of gastrology [n -S]\n",
  "GASTROLOGISTS": "GASTROLOGIST, a student of gastrology [n]\n",
  "GASTROLOGY": "good eating; cookery [n GASTROLOGIES]\n",
  "GASTROMANCIES": "GASTROMANCY, divination by sounds from the belly [n]\n",
  "GASTROMANCY": "divination by sounds from the belly [n GASTROMANCIES]\n",
  "GASTRONOME": "a connoisseur of good eating and drinking; a gourmet, also GASTROLOGER, GASTRONOMER [n -S]\n",
  "GASTRONOMER": "a connoisseur of good eating and drinking; a gourmet, also GASTROLOGER, GASTRONOME [n -S]\n",
  "GASTRONOMERS": "GASTRONOMER, a connoisseur of good eating and drinking; a gourmet, also GASTROLOGER, GASTRONOME [n]\n",
  "GASTRONOMES": "GASTRONOME, a connoisseur of good eating and drinking; a gourmet, also GASTROLOGER, GASTRONOMER [n]\n",
  "GASTRONOMIC": "relating to gastronomy, also GASTRONOMICAL [adj GASTRONOMICALLY]\n",
  "GASTRONOMICAL": "relating to gastronomy, also GASTRONOMIC [adj GASTRONOMICALLY]\n",
  "GASTRONOMICALLY": "GASTRONOMICAL, relating to gastronomy, also GASTRONOMIC [adv]\n",
  "GASTRONOMICS": "the style of cooking typical of a country or region [n]\n",
  "GASTRONOMIES": "GASTRONOMY, the study of fine dining [n]\n",
  "GASTRONOMIST": "one versed in gastronomy, the art of good eating [n -S]\n",
  "GASTRONOMISTS": "GASTRONOMIST, one versed in gastronomy, the art of good eating [n]\n",
  "GASTRONOMY": "the study of fine dining [n GASTRONOMIES]\n",
  "GASTROPOD": "a class of asymmetrical molluscs, including limpets, whelks, snails and slugs, also GASTEROPOD [n -S]\n",
  "GASTROPODAN": "a gastropod [n -S]\n",
  "GASTROPODANS": "GASTROPODAN, a gastropod [n]\n",
  "GASTROPODOUS": "like a gastropod [adj]\n",
  "GASTROPODS": "GASTROPOD, a class of asymmetrical molluscs, including limpets, whelks, snails and slugs, also GASTEROPOD [n]\n",
  "GASTROPORN": "the representation of food in a highly sensual manner [n -S]\n",
  "GASTROPORNS": "GASTROPORN, the representation of food in a highly sensual manner [n]\n",
  "GASTROPUB": "a pub that specializes in providing food and wine of a standard more typical of a fine restaurant than a traditional pub [n -S]\n",
  "GASTROPUBS": "GASTROPUB, a pub that specializes in providing food and wine of a standard more typical of a fine restaurant than a traditional pub [n]\n",
  "GASTROSCOPE": "an instrument for examining interior of the stomach [n -S]\n",
  "GASTROSCOPES": "GASTROSCOPE, an instrument for examining interior of the stomach [n]\n",
  "GASTROSCOPIC": "relating to the gastroscope, an instrument for examining interior of the stomach [adj]\n",
  "GASTROSCOPIES": "GASTROSCOPY, examination with a gastroscope [n]\n",
  "GASTROSCOPIST": "one who uses a gastroscope [n -S]\n",
  "GASTROSCOPISTS": "GASTROSCOPIST, one who uses a gastroscope [n]\n",
  "GASTROSCOPY": "examination with a gastroscope [n GASTROSCOPIES]\n",
  "GASTROSOPH": "a person skilled in matters of eating, also GASTROSOPHER [n -S]\n",
  "GASTROSOPHER": "a person skilled in matters of eating, also GASTROSOPH [n -S]\n",
  "GASTROSOPHERS": "GASTROSOPHER, a person skilled in matters of eating, also GASTROSOPH [n]\n",
  "GASTROSOPHIES": "GASTROSOPHY, the art of eating [n]\n",
  "GASTROSOPHS": "GASTROSOPH, a person skilled in matters of eating, also GASTROSOPHER [n]\n",
  "GASTROSOPHY": "the art of eating [n GASTROSOPHIES]\n",
  "GASTROSTOMIES": "GASTROSTOMY, a cutting into, or opening of, the abdomen or the stomach, also GASTROTOMY [n]\n",
  "GASTROSTOMY": "a cutting into, or opening of, the abdomen or the stomach, also GASTROTOMY [n GASTROSTOMIES]\n",
  "GASTROTOMIES": "GASTROTOMY, a cutting into, or opening of, the abdomen or the stomach, also GASTROSTOMY [n]\n",
  "GASTROTOMY": "a cutting into, or opening of, the abdomen or the stomach, also GASTROSTOMY [n GASTROTOMIES]\n",
  "GASTROTRICH": "any minute aquatic multicellular animal of the phylum Gastrotricha [n -S]\n",
  "GASTROTRICHS": "GASTROTRICH, any minute aquatic multicellular animal of the phylum Gastrotricha [n]\n",
  "GASTROVASCULAR": "functioning in both digestion and circulation [adj]\n",
  "GASTRULA": "(Latin) a metazoan embryo [n GASTRULAS or GASTRULAE]\n",
  "GASTRULAE": "GASTRULA, (Latin) a metazoan embryo [n]\n",
  "GASTRULAR": "of or like a gastrula, an embryo at the stage in which it forms a two-layered cup by the invagination of its wall [adj]\n",
  "GASTRULAS": "GASTRULA, (Latin) a metazoan embryo [n]\n",
  "GASTRULATE": "relating to a gastrula, an embryonic form [n -S] / to form a gastrula [v GASTRULATED, GASTRULATING, GASTRULATES]\n",
  "GASTRULATED": "GASTRULATE, to form a gastrula [v]\n",
  "GASTRULATES": "GASTRULATE, to form a gastrula [v]\n",
  "GASTRULATING": "GASTRULATE, to form a gastrula [v]\n",
  "GASTRULATION": "the formation of a gastrula [n -S]\n",
  "GASTRULATIONS": "GASTRULATION, the formation of a gastrula [n]\n",
  "GASTS": "GAST, (Shakespeare) to frighten, also GHAST [v]\n",
  "GASWORKS": "a factory where gas is produced [n GASWORKS]\n",
  "GAT": "a pistol [n -S]\n",
  "GATCH": "to behave boastfully, also GACH, GAUCH [v -ED, -ING, -ES]\n",
  "GATCHED": "GATCH, to behave boastfully, also GACH, GAUCH [v]\n",
  "GATCHER": "one that gatches, boasts [n -S]\n",
  "GATCHERS": "GATCHER, one that gatches, boasts [n]\n",
  "GATCHES": "GATCH, to behave boastfully, also GACH, GAUCH [v]\n",
  "GATCHING": "GATCH, to behave boastfully, also GACH, GAUCH [v]\n",
  "GATE": "to supply with a gate [v GATED, GATING, GATES]\n",
  "GATEAU": "(French) a rich layer cake [n GATEAUS or GATEAUX]\n",
  "GATEAUS": "GATEAU, (French) a rich layer cake [n]\n",
  "GATEAUX": "GATEAU, (French) a rich layer cake [n]\n",
  "GATECRASH": "to attend a social event uninvited [v -ED, -ING, -ES]\n",
  "GATECRASHED": "GATECRASH, to attend a social event uninvited [v]\n",
  "GATECRASHER": "one who attends parties uninvited [n -S]\n",
  "GATECRASHERS": "GATECRASHER, one who attends parties uninvited [n]\n",
  "GATECRASHES": "GATECRASH, to attend a social event uninvited [v]\n",
  "GATECRASHING": "GATECRASH, to attend a social event uninvited [v]\n",
  "GATED": "GATE, to supply with a gate [v]\n",
  "GATEFOLD": "a folded insert in a magazine or book, also FOLDOUT [n -S]\n",
  "GATEFOLDS": "GATEFOLD, a folded insert in a magazine or book, also FOLDOUT [n]\n",
  "GATEHOUSE": "a building over or at a gate [n -S]\n",
  "GATEHOUSES": "GATEHOUSE, a building over or at a gate [n]\n",
  "GATEKEEPER": "any of several Eurasian butterflies of the genus Pyronia [n -S]\n",
  "GATEKEEPERS": "GATEKEEPER, any of several Eurasian butterflies of the genus Pyronia [n]\n",
  "GATEKEEPING": "the practice of controlling access to information, advanced levels of study, elite sections of society, etc. [n -S]\n",
  "GATEKEEPINGS": "GATEKEEPING, the practice of controlling access to information, advanced levels of study, elite sections of society, etc. [n]\n",
  "GATELEG": "a table with extensions supported by movable legs [n -S]\n",
  "GATELEGS": "GATELEG, a table with extensions supported by movable legs [n]\n",
  "GATELESS": "lacking a gate [adj]\n",
  "GATELIKE": "resembling a gate [adj]\n",
  "GATEMAN": "a person in charge of a gate [n GATEMEN]\n",
  "GATEMEN": "GATEMAN, a person in charge of a gate [n]\n",
  "GATEPOST": "a post from which a gate is hung [n -S]\n",
  "GATEPOSTS": "GATEPOST, a post from which a gate is hung [n]\n",
  "GATER": "an alligator, also GATOR [n -S]\n",
  "GATERS": "GATER, an alligator, also GATOR [n]\n",
  "GATES": "GATE, to supply with a gate [v]\n",
  "GATEWAY": "a passage that may be closed by a gate [n -S]\n",
  "GATEWAYS": "GATEWAY, a passage that may be closed by a gate [n]\n",
  "GATH": "in Indian music, the second section of a raga [n -S]\n",
  "GATHER": "to bring together in one place or group [v -ED, -ING, -S]\n",
  "GATHERABLE": "that can be gathered [adj]\n",
  "GATHERED": "GATHER, to bring together in one place or group [v]\n",
  "GATHERER": "one that gathers [n -S]\n",
  "GATHERERS": "GATHERER, one that gathers [n]\n",
  "GATHERING": "a coming together [n -S]\n",
  "GATHERINGS": "GATHERING, a coming together [n]\n",
  "GATHERS": "GATHER, to bring together in one place or group [v]\n",
  "GATHS": "GATH, in Indian music, the second section of a raga [n]\n",
  "GATING": "punishment by gating, keeping in [n -S]\n",
  "GATINGS": "GATING, punishment by gating, keeping in [n]\n",
  "GATLING": "as in gatling gun, a machinegun with a cluster of rotating barrels [adj]\n",
  "GATOR": "an alligator, also GATER [n -S]\n",
  "GATORS": "GATOR, an alligator, also GATER [n]\n",
  "GATS": "GAT, a pistol [n]\n",
  "GATVOL": "(South African) annoyed, fed up [adj]\n",
  "GAU": "(German) a German political district of the Nazi regime [n -S]\n",
  "GAUCH": "to behave boastfully, also GACH, GATCH [v -ED, -ING, -ES]\n",
  "GAUCHE": "(French) awkward, clumsy [adj GAUCHER, GAUCHEST, GAUCHELY]\n",
  "GAUCHED": "GAUCH, to behave boastfully, also GACH, GATCH [v]\n",
  "GAUCHELY": "GAUCHE, (French) awkward, clumsy [adv]\n",
  "GAUCHENESS": "the quality of being gauche [n -ES]\n",
  "GAUCHENESSES": "GAUCHENESS, the quality of being gauche [n]\n",
  "GAUCHER": "one that gauches, boasts [n -S]\n",
  "GAUCHERIE": "(French) an awkward or socially unacceptable remark [n -S]\n",
  "GAUCHERIES": "GAUCHERIE, (French) an awkward or socially unacceptable remark [n]\n",
  "GAUCHERS": "GAUCHER, one that gauches, boasts [n]\n",
  "GAUCHES": "GAUCH, to behave boastfully, also GACH, GATCH [v]\n",
  "GAUCHESCO": "(Spanish) of a type of Spanish poetry inspired by the life, language and customs of the gaucho [adj]\n",
  "GAUCHEST": "GAUCHE, (French) awkward, clumsy [adj]\n",
  "GAUCHING": "GAUCH, to behave boastfully, also GACH, GATCH [v]\n",
  "GAUCHO": "(Spanish) a cowboy of the South American pampas [n -S]\n",
  "GAUCHOS": "GAUCHO, (Spanish) a cowboy of the South American pampas [n]\n",
  "GAUCIE": "(Scots) portly, jolly, also GAUCY, GAWCY, GAWSIE, GAWSY [adj GAUCIER, GAUCIEST]\n",
  "GAUCIER": "GAUCY, (Scots) portly, jolly, also GAUCIE, GAWCY, GAWSIE, GAWSY [adj]\n",
  "GAUCIEST": "GAUCY, (Scots) portly, jolly, also GAUCIE, GAWCY, GAWSIE, GAWSY [adj]\n",
  "GAUCY": "(Scots) portly, jolly, also GAUCIE, GAWCY, GAWSIE, GAWSY [adj GAUCIER, GAUCIEST]\n",
  "GAUD": "a piece of finery [n -S] / to adorn with gauds [v -ED, -ING, -S]\n",
  "GAUDEAMUS": "(Latin) a convivial gathering, esp. of college or university students [n -ES]\n",
  "GAUDEAMUSES": "GAUDEAMUS, (Latin) a convivial gathering, esp. of college or university students [n]\n",
  "GAUDED": "GAUD, to adorn with gauds [v]\n",
  "GAUDERIES": "GAUDERY, finery [n]\n",
  "GAUDERY": "finery [n GAUDERIES]\n",
  "GAUDGIE": "(Romany) a fellow, also GADGIE, GADJE, GADJO, GAJO, GAUJE, GORGIO [n -S]\n",
  "GAUDGIES": "GAUDGIE, (Romany) a fellow, also GADGIE, GADJE, GADJO, GAJO, GAUJE, GORGIO [n]\n",
  "GAUDIER": "GAUDY, tastelessly showy [adj]\n",
  "GAUDIES": "GAUDY, an entertainment or feast, esp. in certain English colleges [n]\n",
  "GAUDIEST": "GAUDY, tastelessly showy [adj]\n",
  "GAUDILY": "GAUDY, tastelessly showy [adv]\n",
  "GAUDINESS": "the state of being gaudy [n -ES]\n",
  "GAUDINESSES": "GAUDINESS, the state of being gaudy [n]\n",
  "GAUDING": "GAUD, to adorn with gauds [v]\n",
  "GAUDS": "GAUD, to adorn with gauds [v]\n",
  "GAUDY": "tastelessly showy [adj GAUDIER, GAUDIEST, GAUDILY] / an entertainment or feast, esp. in certain English colleges [n GAUDIES]\n",
  "GAUFER": "a waffle, also GAUFRE [n -S]\n",
  "GAUFERS": "GAUFER, a waffle, also GAUFRE [n]\n",
  "GAUFFER": "to press ridges or pleats into, also GOFFER [v -ED, -ING, -S]\n",
  "GAUFFERED": "GAUFFER, to press ridges or pleats into, also GOFFER [v]\n",
  "GAUFFERING": "make pleats with a gauffering iron, also GOFFERING [n -S]\n",
  "GAUFFERINGS": "GAUFFERING, make pleats with a gauffering iron, also GOFFERING [n]\n",
  "GAUFFERS": "GAUFFER, to press ridges or pleats into, also GOFFER [v]\n",
  "GAUFRE": "a waffle, also GAUFER [n -S]\n",
  "GAUFRES": "GAUFRE, a waffle, also GAUFER [n]\n",
  "GAUGE": "to measure precisely [v GAUGED, GAUGING, GAUGES]\n",
  "GAUGEABLE": "capable of being gauged, also GAGEABLE [adj GAUGEABLY]\n",
  "GAUGEABLY": "GAUGEABLE, capable of being gauged, also GAGEABLE [adv]\n",
  "GAUGED": "GAUGE, to measure precisely [v]\n",
  "GAUGER": "one who gauges; an officer whose business it is to ascertain the contents of casks, also GAGER [n -S]\n",
  "GAUGERS": "GAUGER, one who gauges; an officer whose business it is to ascertain the contents of casks, also GAGER [n]\n",
  "GAUGES": "GAUGE, to measure precisely [v]\n",
  "GAUGING": "the measuring of casks holding excisable liquor [n -S]\n",
  "GAUGINGS": "GAUGING, the measuring of casks holding excisable liquor [n]\n",
  "GAUJE": "(Romany) a fellow, also GADGIE, GADJE, GADJO, GAJO, GAUDGIE, GORGIO [n -S]\n",
  "GAUJES": "GAUJE, (Romany) a fellow, also GADGIE, GADJE, GADJO, GAJO, GAUDGIE, GORGIO [n]\n",
  "GAULEITER": "(German) an overbearing wielder of petty authority [n -S]\n",
  "GAULEITERS": "GAULEITER, (German) an overbearing wielder of petty authority [n]\n",
  "GAULT": "a heavy thick clay soil [n -S]\n",
  "GAULTER": "a person who digs gault, a heavy clay used for bricks [n -S]\n",
  "GAULTERS": "GAULTER, a person who digs gault, a heavy clay used for bricks [n]\n",
  "GAULTHERIA": "a genus of ericaceous shrubs with evergreen foliage, and, often, edible berries [n -S]\n",
  "GAULTHERIAS": "GAULTHERIA, a genus of ericaceous shrubs with evergreen foliage, and, often, edible berries [n]\n",
  "GAULTS": "GAULT, a heavy thick clay soil [n]\n",
  "GAUM": "(Old Norse) to smear, daub [v -ED, -ING, -S]\n",
  "GAUMED": "GAUM, (Old Norse) to smear, daub [v]\n",
  "GAUMIER": "GAUMY, dauby, smeary, also GORMY [adj]\n",
  "GAUMIEST": "GAUMY, dauby, smeary, also GORMY [adj]\n",
  "GAUMING": "GAUM, (Old Norse) to smear, daub [v]\n",
  "GAUMLESS": "(Scots) stupid, also GORMLESS [adj]\n",
  "GAUMS": "GAUM, (Old Norse) to smear, daub [v]\n",
  "GAUMY": "dauby, smeary, also GORMY [adj GAUMIER, GAUMIEST]\n",
  "GAUN": "(Scots) going [v]\n",
  "GAUNCH": "to impale, also GANCH [v -ED, -ING, -ES]\n",
  "GAUNCHED": "GAUNCH, to impale, also GANCH [v]\n",
  "GAUNCHES": "GAUNCH, to impale, also GANCH [v]\n",
  "GAUNCHING": "GAUNCH, to impale, also GANCH [v]\n",
  "GAUNT": "to yawn, also GANT [v -ED, -ING, -S] / emaciated [adj GAUNTER, GAUNTEST, GAUNTLY]\n",
  "GAUNTED": "GAUNT, to yawn, also GANT [v]\n",
  "GAUNTER": "GAUNT, emaciated [adj]\n",
  "GAUNTEST": "GAUNT, emaciated [adj]\n",
  "GAUNTING": "GAUNT, to yawn, also GANT [v]\n",
  "GAUNTLET": "an armoured glove, also GANTELOPE, GANTLET, GANTLOPE [n -S] / to protect with an armoured glove [v -ED, -ING, -S]\n",
  "GAUNTLETED": "GAUNTLET, to protect with an armoured glove [v]\n",
  "GAUNTLETING": "GAUNTLET, to protect with an armoured glove [v]\n",
  "GAUNTLETS": "GAUNTLET, to protect with an armoured glove [v]\n",
  "GAUNTLY": "GAUNT, emaciated [adv]\n",
  "GAUNTNESS": "the state of being gaunt [n -ES]\n",
  "GAUNTNESSES": "GAUNTNESS, the state of being gaunt [n]\n",
  "GAUNTREE": "a stand for barrels, also GANTRY, GAUNTRY [n -S]\n",
  "GAUNTREES": "GAUNTREE, a stand for barrels, also GANTRY, GAUNTRY [n]\n",
  "GAUNTRIES": "GAUNTRY, a frame for supporting barrels, also GANTRY, GAUNTREE [n]\n",
  "GAUNTRY": "a frame for supporting barrels, also GANTRY, GAUNTREE [n GAUNTRIES]\n",
  "GAUNTS": "GAUNT, to yawn, also GANT [v]\n",
  "GAUP": "to stare stupidly, also GAWP, GORP [v -ED, -ING, -S]\n",
  "GAUPED": "GAUP, to stare stupidly, also GAWP, GORP [v]\n",
  "GAUPER": "one that gaups, also GAWPER [n -S]\n",
  "GAUPERS": "GAUPER, one that gaups, also GAWPER [n]\n",
  "GAUPING": "GAUP, to stare stupidly, also GAWP, GORP [v]\n",
  "GAUPS": "GAUP, to stare stupidly, also GAWP, GORP [v]\n",
  "GAUPUS": "(dialect) a silly person, also GAWPUS [n -ES]\n",
  "GAUPUSES": "GAUPUS, (dialect) a silly person, also GAWPUS [n]\n",
  "GAUR": "(Hindi) a kind of wild ox, aka seladang [n -S]\n",
  "GAURS": "GAUR, (Hindi) a kind of wild ox, aka seladang [n]\n",
  "GAUS": "GAU, (German) a German political district of the Nazi regime [n]\n",
  "GAUSS": "(German) a unit of magnetic flux density equal to 1/10000 tesla [n -ES]\n",
  "GAUSSES": "GAUSS, (German) a unit of magnetic flux density equal to 1/10000 tesla [n]\n",
  "GAUSSIAN": "due to the mathematician Gauss [adj]\n",
  "GAUSSMETER": "an instrument for measuring the intensity of a magnetic field [n -S]\n",
  "GAUSSMETERS": "GAUSSMETER, an instrument for measuring the intensity of a magnetic field [n]\n",
  "GAUZE": "a transparent fabric [n -S]\n",
  "GAUZELIKE": "like gauze [adj]\n",
  "GAUZES": "GAUZE, a transparent fabric [n]\n",
  "GAUZIER": "GAUZY, resembling gauze [adj]\n",
  "GAUZIEST": "GAUZY, resembling gauze [adj]\n",
  "GAUZILY": "GAUZY, resembling gauze [adv]\n",
  "GAUZINESS": "the state of being gauzy [n -ES]\n",
  "GAUZINESSES": "GAUZINESS, the state of being gauzy [n]\n",
  "GAUZY": "resembling gauze [adj GAUZIER, GAUZIEST, GAUZILY]\n",
  "GAVAGE": "(French) the introduction of material into the stomach by a tube [n -S]\n",
  "GAVAGES": "GAVAGE, (French) the introduction of material into the stomach by a tube [n]\n",
  "GAVE": "GIVE, to transfer freely to another's possession [v]\n",
  "GAVEL": "to signal for attention with a gavel (a small mallet) [v GAVELLED or GAVELED, GAVELLING or GAVELING, GAVELS]\n",
  "GAVELED": "GAVEL, to signal for attention with a gavel (a small mallet) [v]\n",
  "GAVELING": "GAVEL, to signal for attention with a gavel (a small mallet) [v]\n",
  "GAVELKIND": "(archaic) a system of land inheritance by all sons equally, rather than by the eldest son [n -S]\n",
  "GAVELKINDS": "GAVELKIND, (archaic) a system of land inheritance by all sons equally, rather than by the eldest son [n]\n",
  "GAVELLED": "GAVEL, to signal for attention with a gavel (a small mallet) [v]\n",
  "GAVELLING": "GAVEL, to signal for attention with a gavel (a small mallet) [v]\n",
  "GAVELMAN": "a tenant holding land in gavelkind [n GAVELMEN]\n",
  "GAVELMEN": "GAVELMAN, a tenant holding land in gavelkind [n]\n",
  "GAVELOCK": "(historical) a javelin; a crowbar [n -S]\n",
  "GAVELOCKS": "GAVELOCK, (historical) a javelin; a crowbar [n]\n",
  "GAVELS": "GAVEL, to signal for attention with a gavel (a small mallet) [v]\n",
  "GAVIAL": "(Hindi) an Indian crocodile with a long snout, also GARIAL, GHARIAL [n -S]\n",
  "GAVIALOID": "of or like gavials [adj]\n",
  "GAVIALS": "GAVIAL, (Hindi) an Indian crocodile with a long snout, also GARIAL, GHARIAL [n]\n",
  "GAVOT": "(French) a kind of French country dance, also GAVOTTE [n -S]\n",
  "GAVOTS": "GAVOT, (French) a kind of French country dance, also GAVOTTE [n]\n",
  "GAVOTTE": "(French) a kind of French country dance, also GAVOT [n -S] / to dance a gavotte [v GAVOTTED, GAVOTTING, GAVOTTES]\n",
  "GAVOTTED": "GAVOTTE, to dance a gavotte [v]\n",
  "GAVOTTES": "GAVOTTE, to dance a gavotte [v]\n",
  "GAVOTTING": "GAVOTTE, to dance a gavotte [v]\n",
  "GAW": "an imperfect rainbow or other supposed sign of coming weather [n -S]\n",
  "GAWCIER": "GAWCY, (Scots) portly, jolly, also GAUCIE, GAUCY, GAWSIE, GAWSY [adj]\n",
  "GAWCIEST": "GAWCY, (Scots) portly, jolly, also GAUCIE, GAUCY, GAWSIE, GAWSY [adj]\n",
  "GAWCY": "(Scots) portly, jolly, also GAUCIE, GAUCY, GAWSIE, GAWSY [adj GAWCIER, GAWCIEST]\n",
  "GAWD": "(Shakespeare) a gaud [n -S]\n",
  "GAWDS": "GAWD, (Shakespeare) a gaud [n]\n",
  "GAWK": "to stare and gape [v -ED, -ING, -S]\n",
  "GAWKED": "GAWK, to stare and gape [v]\n",
  "GAWKER": "one who gawks, stands and gapes [n -S]\n",
  "GAWKERS": "GAWKER, one who gawks, stands and gapes [n]\n",
  "GAWKIER": "GAWKY, awkward [adj]\n",
  "GAWKIES": "GAWKY, a tall awkward person [n]\n",
  "GAWKIEST": "GAWKY, awkward [adj]\n",
  "GAWKIHOOD": "ungainliness, gawkiness [n -S]\n",
  "GAWKIHOODS": "GAWKIHOOD, ungainliness, gawkiness [n]\n",
  "GAWKILY": "GAWKY, awkward [adv]\n",
  "GAWKINESS": "awkwardness, foolishness [n -ES]\n",
  "GAWKINESSES": "GAWKINESS, awkwardness, foolishness [n]\n",
  "GAWKING": "GAWK, to stare and gape [v]\n",
  "GAWKISH": "gawky, awkward [adj GAWKISHLY]\n",
  "GAWKISHLY": "GAWKISH, gawky, awkward [adv]\n",
  "GAWKISHNESS": "the state of being gawkish [n -ES]\n",
  "GAWKISHNESSES": "GAWKISHNESS, the state of being gawkish [n]\n",
  "GAWKS": "GAWK, to stare and gape [v]\n",
  "GAWKY": "awkward [adj GAWKIER, GAWKIEST, GAWKILY] / a tall awkward person [n GAWKIES]\n",
  "GAWMOGE": "a clownish person [n -S]\n",
  "GAWMOGES": "GAWMOGE, a clownish person [n]\n",
  "GAWP": "to stare stupidly, also GAUP, GORP [v -ED, -ING, -S]\n",
  "GAWPED": "GAWP, to stare stupidly, also GAUP, GORP [v]\n",
  "GAWPER": "one that gawps, also GAUPER [n -S]\n",
  "GAWPERS": "GAWPER, one that gawps, also GAUPER [n]\n",
  "GAWPING": "GAWP, to stare stupidly, also GAUP, GORP [v]\n",
  "GAWPS": "GAWP, to stare stupidly, also GAUP, GORP [v]\n",
  "GAWPUS": "(dialect) a silly person, also GAUPUS [n -ES]\n",
  "GAWPUSES": "GAWPUS, (dialect) a silly person, also GAUPUS [n]\n",
  "GAWS": "GAW, an imperfect rainbow or other supposed sign of coming weather [n]\n",
  "GAWSIE": "(Scots) portly, jolly, also GAUCIE, GAUCY, GAWCY, GAWSY [adj GAWSIER, GAWSIEST]\n",
  "GAWSIER": "GAWSIE, (Scots) portly, jolly, also GAUCIE, GAUCY, GAWCY, GAWSY [adj]\n",
  "GAWSIEST": "GAWSIE, (Scots) portly, jolly, also GAUCIE, GAUCY, GAWCY, GAWSY [adj]\n",
  "GAWSY": "(Scots) portly, jolly, also GAUCIE, GAUCY, GAWCY, GAWSIE [adj GAWSIER, GAWSIEST]\n",
  "GAY": "a homosexual [n -S] / cheerful [adj GAYER, GAYEST, GAILY or GAYLY]\n",
  "GAYAL": "(Hindi) an Indian domesticated ox, also GYAL [n -S]\n",
  "GAYALS": "GAYAL, (Hindi) an Indian domesticated ox, also GYAL [n]\n",
  "GAYCATION": "a holiday specifically designed for the gay market [n -S]\n",
  "GAYCATIONS": "GAYCATION, a holiday specifically designed for the gay market [n]\n",
  "GAYDAR": "the supposed ability of a homosexual to determine whether another person is homosexual or not [n -S]\n",
  "GAYDARS": "GAYDAR, the supposed ability of a homosexual to determine whether another person is homosexual or not [n]\n",
  "GAYER": "GAY, cheerful [adj]\n",
  "GAYEST": "GAY, cheerful [adj]\n",
  "GAYETIES": "GAYETY, festive activity, also GAIETY [n]\n",
  "GAYETY": "festive activity, also GAIETY [n GAYETIES]\n",
  "GAYLY": "GAY, cheerful [adv]\n",
  "GAYNESS": "gaiety, finery [n -ES]\n",
  "GAYNESSES": "GAYNESS, gaiety, finery [n]\n",
  "GAYS": "GAY, a homosexual [n]\n",
  "GAYSOME": "full of gaiety [adj]\n",
  "GAYWINGS": "a perennial herb [n GAYWINGS]\n",
  "GAZABO": "a fellow [n -ES or -S]\n",
  "GAZABOES": "GAZABO, a fellow [n]\n",
  "GAZABOS": "GAZABO, a fellow [n]\n",
  "GAZAL": "(Arabic) a Persian or Arabic verse form, also GHAZAL, GHAZEL [n -S]\n",
  "GAZALS": "GAZAL, (Arabic) a Persian or Arabic verse form, also GHAZAL, GHAZEL [n]\n",
  "GAZANG": "(of the seller of a house) to inconvenience (a potential buyer) by withdrawing from an agreement to sell shortly before the purchase is completed [v -ED, -ING, -S]\n",
  "GAZANGED": "GAZANG, (of the seller of a house) to inconvenience (a potential buyer) by withdrawing from an agreement to sell shortly before the purchase is completed [v]\n",
  "GAZANGING": "GAZANG, (of the seller of a house) to inconvenience (a potential buyer) by withdrawing from an agreement to sell shortly before the purchase is completed [v]\n",
  "GAZANGS": "GAZANG, (of the seller of a house) to inconvenience (a potential buyer) by withdrawing from an agreement to sell shortly before the purchase is completed [v]\n",
  "GAZANIA": "any plant of the genus Gazania, with bright orange or yellow flowers [n -S]\n",
  "GAZANIAS": "GAZANIA, any plant of the genus Gazania, with bright orange or yellow flowers [n]\n",
  "GAZAR": "(French) a stiff silk fabric, silk organza [n -S]\n",
  "GAZARS": "GAZAR, (French) a stiff silk fabric, silk organza [n]\n",
  "GAZE": "to look intently [v GAZED, GAZING, GAZES]\n",
  "GAZEBO": "a roofed structure open at the sides [n -ES or -S]\n",
  "GAZEBOES": "GAZEBO, a roofed structure open at the sides [n]\n",
  "GAZEBOS": "GAZEBO, a roofed structure open at the sides [n]\n",
  "GAZED": "GAZE, to look intently [v]\n",
  "GAZEFUL": "(Spenser) looking intently [adj]\n",
  "GAZEHOUND": "a hound that pursues by the sight rather than by the scent [n -S]\n",
  "GAZEHOUNDS": "GAZEHOUND, a hound that pursues by the sight rather than by the scent [n]\n",
  "GAZELLE": "one of several small, swift, elegantly formed species of antelope [n -S]\n",
  "GAZELLES": "GAZELLE, one of several small, swift, elegantly formed species of antelope [n]\n",
  "GAZEMENT": "(Spenser) a stare, look [n -S]\n",
  "GAZEMENTS": "GAZEMENT, (Spenser) a stare, look [n]\n",
  "GAZER": "one who gazes [n -S]\n",
  "GAZERS": "GAZER, one who gazes [n]\n",
  "GAZES": "GAZE, to look intently [v]\n",
  "GAZETTE": "to announce in an official journal [v GAZETTED, GAZETTING, GAZETTES]\n",
  "GAZETTED": "GAZETTE, to announce in an official journal [v]\n",
  "GAZETTEER": "a writer of news, or an officer appointed to publish news by authority [n -S] / to mention in a gazette [v -ED, -ING, -S]\n",
  "GAZETTEERED": "GAZETTEER, to mention in a gazette [v]\n",
  "GAZETTEERING": "GAZETTEER, to mention in a gazette [v]\n",
  "GAZETTEERISH": "appropriate to a gazetteer [adj]\n",
  "GAZETTEERS": "GAZETTEER, a writer of news, or an officer appointed to publish news by authority [n]\n",
  "GAZETTES": "GAZETTE, to announce in an official journal [v]\n",
  "GAZETTING": "GAZETTE, to announce in an official journal [v]\n",
  "GAZIER": "GAZY, given to gazing [adj]\n",
  "GAZIEST": "GAZY, given to gazing [adj]\n",
  "GAZILLION": "an indefinitely large number, also KAZILLION [n -S]\n",
  "GAZILLIONAIRE": "a very rich person [n -S]\n",
  "GAZILLIONAIRES": "GAZILLIONAIRE, a very rich person [n]\n",
  "GAZILLIONS": "GAZILLION, an indefinitely large number, also KAZILLION [n]\n",
  "GAZING": "the act of gazing [n -S]\n",
  "GAZINGS": "GAZING, the act of gazing [n]\n",
  "GAZOGENE": "an apparatus for carbonating liquids, also GASOGENE [n -S]\n",
  "GAZOGENES": "GAZOGENE, an apparatus for carbonating liquids, also GASOGENE [n]\n",
  "GAZON": "(obsolete) one of the pieces of sod used to line or cover parapets and the faces of earthworks, also GAZOON [n -S]\n",
  "GAZONS": "GAZON, (obsolete) one of the pieces of sod used to line or cover parapets and the faces of earthworks, also GAZOON [n]\n",
  "GAZOO": "a toy musical instrument, also KAZOO, GAZOOKA [n -S]\n",
  "GAZOOKA": "a toy musical instrument, also KAZOO, GAZOO [n -S]\n",
  "GAZOOKAS": "GAZOOKA, a toy musical instrument, also KAZOO, GAZOO [n]\n",
  "GAZOON": "(obsolete) one of the pieces of sod used to line or cover parapets and the faces of earthworks, also GAZON [n -S]\n",
  "GAZOONS": "GAZOON, (obsolete) one of the pieces of sod used to line or cover parapets and the faces of earthworks, also GAZON [n]\n",
  "GAZOOS": "GAZOO, a toy musical instrument, also KAZOO, GAZOOKA [n]\n",
  "GAZPACHO": "(Spanish) a chilled soup with tomatoes, onion, green pepper, and herbs [n -S]\n",
  "GAZPACHOS": "GAZPACHO, (Spanish) a chilled soup with tomatoes, onion, green pepper, and herbs [n]\n",
  "GAZUMP": "(colloquial) to unfairly acquire a property by bidding more than an offer that has already been accepted [v -ED, -ING, -S]\n",
  "GAZUMPED": "GAZUMP, (colloquial) to unfairly acquire a property by bidding more than an offer that has already been accepted [v]\n",
  "GAZUMPER": "one that gazumps (cheats by raising the agreed price) [n -S]\n",
  "GAZUMPERS": "GAZUMPER, one that gazumps (cheats by raising the agreed price) [n]\n",
  "GAZUMPING": "the act of unfairly acquiring a property by bidding more than an offer that has already been accepted [n -S]\n",
  "GAZUMPINGS": "GAZUMPING, the act of unfairly acquiring a property by bidding more than an offer that has already been accepted [n]\n",
  "GAZUMPS": "GAZUMP, (colloquial) to unfairly acquire a property by bidding more than an offer that has already been accepted [v]\n",
  "GAZUNDER": "to lower the sum offered for a property just before signing a contract [v -ED, -ING, -S]\n",
  "GAZUNDERED": "GAZUNDER, to lower the sum offered for a property just before signing a contract [v]\n",
  "GAZUNDERER": "one who gazunders [n -S]\n",
  "GAZUNDERERS": "GAZUNDERER, one who gazunders [n]\n",
  "GAZUNDERING": "GAZUNDER, to lower the sum offered for a property just before signing a contract [v]\n",
  "GAZUNDERS": "GAZUNDER, to lower the sum offered for a property just before signing a contract [v]\n",
  "GAZY": "given to gazing [adj GAZIER, GAZIEST]\n",
  "GEAL": "(dialect) to congeal [v -ED, -ING, -S]\n",
  "GEALED": "GEAL, (dialect) to congeal [v]\n",
  "GEALING": "GEAL, (dialect) to congeal [v]\n",
  "GEALOUS": "(Spenser) jealous [adj]\n",
  "GEALOUSIES": "GEALOUSY, (Spenser) jealousy, also GELOSY [n]\n",
  "GEALOUSY": "(Spenser) jealousy, also GELOSY [n GEALOUSIES]\n",
  "GEALS": "GEAL, (dialect) to congeal [v]\n",
  "GEAN": "a European wild cherry [n -S]\n",
  "GEANS": "GEAN, a European wild cherry [n]\n",
  "GEANTICLINAL": "of or like a geanticline, a large upward fold [adj]\n",
  "GEANTICLINE": "a large upward fold [n -S]\n",
  "GEANTICLINES": "GEANTICLINE, a large upward fold [n]\n",
  "GEAR": "to provide with gears (toothed machine parts) [v -ED, -ING, -S] / equipment, also GERE [n -S]\n",
  "GEARBOX": "an automotive transmission [n -ES]\n",
  "GEARBOXES": "GEARBOX, an automotive transmission [n]\n",
  "GEARCASE": "a casing for gears [n -S]\n",
  "GEARCASES": "GEARCASE, a casing for gears [n]\n",
  "GEARCHANGE": "a change of gears [n -S]\n",
  "GEARCHANGES": "GEARCHANGE, a change of gears [n]\n",
  "GEARE": "(Spenser) to jeer [v GEARED, GEARING, GEARES]\n",
  "GEARED": "GEARE, (Spenser) to jeer [v]\n",
  "GEARES": "GEARE, (Spenser) to jeer [v]\n",
  "GEARHEAD": "a mechanically inclined person [n -S]\n",
  "GEARHEADS": "GEARHEAD, a mechanically inclined person [n]\n",
  "GEARING": "a system of gears [n -S]\n",
  "GEARINGS": "GEARING, a system of gears [n]\n",
  "GEARLESS": "being without gears [adj]\n",
  "GEARS": "GEAR, to provide with gears (toothed machine parts) [v]\n",
  "GEARSHIFT": "a device for selecting or engaging and disengaging gears [n -S]\n",
  "GEARSHIFTS": "GEARSHIFT, a device for selecting or engaging and disengaging gears [n]\n",
  "GEARSTICK": "a lever used to operate gears [n -S]\n",
  "GEARSTICKS": "GEARSTICK, a lever used to operate gears [n]\n",
  "GEARWHEEL": "a wheel with teeth or cogs which impart or transmit motion by acting on a similar wheel or a chain [n -S]\n",
  "GEARWHEELS": "GEARWHEEL, a wheel with teeth or cogs which impart or transmit motion by acting on a similar wheel or a chain [n]\n",
  "GEASON": "(obsolete) rare; wonderful [adj]\n",
  "GEAT": "the channel or spout through which molten metal runs into a mold in casting [n -S]\n",
  "GEATS": "GEAT, the channel or spout through which molten metal runs into a mold in casting [n]\n",
  "GEBUR": "(historical) a tenant-farmer in the pre-Conquest English community [n -S]\n",
  "GEBURS": "GEBUR, (historical) a tenant-farmer in the pre-Conquest English community [n]\n",
  "GECK": "to mock, dupe [v -ED, -ING, -S]\n",
  "GECKED": "GECK, to mock, dupe [v]\n",
  "GECKING": "GECK, to mock, dupe [v]\n",
  "GECKO": "(Malay) a kind of small lizard [n -ES or -S]\n",
  "GECKOES": "GECKO, (Malay) a kind of small lizard [n]\n",
  "GECKOS": "GECKO, (Malay) a kind of small lizard [n]\n",
  "GECKS": "GECK, to mock, dupe [v]\n",
  "GED": "(dialect) a pike [n -S]\n",
  "GEDACT": "a flutelike organ stop, also GEDECKT [n -S]\n",
  "GEDACTS": "GEDACT, a flutelike organ stop, also GEDECKT [n]\n",
  "GEDDIT": "(slang) do you get it [interj]\n",
  "GEDECKT": "a flutelike organ stop, also GEDACT [n -S]\n",
  "GEDECKTS": "GEDECKT, a flutelike organ stop, also GEDACT [n]\n",
  "GEDS": "GED, (dialect) a pike [n]\n",
  "GEE": "of horses, to urge on, also JEE [v GEED, GEEING, GEES]\n",
  "GEEBAG": "(offensive Irish slang) a disagreeable woman [n -S]\n",
  "GEEBAGS": "GEEBAG, (offensive Irish slang) a disagreeable woman [n]\n",
  "GEEBUNG": "(Native Australian) an Australian tree [n -S]\n",
  "GEEBUNGS": "GEEBUNG, (Native Australian) an Australian tree [n]\n",
  "GEECHEE": "(US slang) a rural southern black [n -S]\n",
  "GEECHEES": "GEECHEE, (US slang) a rural southern black [n]\n",
  "GEED": "GEE, of horses, to urge on, also JEE [v]\n",
  "GEEGAW": "a toy; a bauble, also GEWGAW [n -S]\n",
  "GEEGAWS": "GEEGAW, a toy; a bauble, also GEWGAW [n]\n",
  "GEEING": "GEE, of horses, to urge on, also JEE [v]\n",
  "GEEK": "a weirdo, a nerd [n -S]\n",
  "GEEKDOM": "the world of geeks [n -S]\n",
  "GEEKDOMS": "GEEKDOM, the world of geeks [n]\n",
  "GEEKED": "hyped up, excited [adj]\n",
  "GEEKERIES": "GEEKERY, preoccupation with, or great knowledge about, a subject, esp. a very specialized one [n]\n",
  "GEEKERY": "preoccupation with, or great knowledge about, a subject, esp. a very specialized one [n GEEKERIES]\n",
  "GEEKIER": "GEEKY, socially awkward or unappealing [adj]\n",
  "GEEKIEST": "GEEKY, socially awkward or unappealing [adj]\n",
  "GEEKINESS": "the quality of being geeky [n -ES]\n",
  "GEEKINESSES": "GEEKINESS, the quality of being geeky [n]\n",
  "GEEKISH": "somewhat like a geek [adj]\n",
  "GEEKISM": "a preoccupation with subjects that are generally considered as unfashionable or boring [n -S]\n",
  "GEEKISMS": "GEEKISM, a preoccupation with subjects that are generally considered as unfashionable or boring [n]\n",
  "GEEKS": "GEEK, a weirdo, a nerd [n]\n",
  "GEEKSPEAK": "the jargon used by geeks [n -S]\n",
  "GEEKSPEAKS": "GEEKSPEAK, the jargon used by geeks [n]\n",
  "GEEKY": "socially awkward or unappealing [adj GEEKIER, GEEKIEST]\n",
  "GEELBEK": "(South African) a yellow-jawed fish [n -S]\n",
  "GEELBEKS": "GEELBEK, (South African) a yellow-jawed fish [n]\n",
  "GEEP": "an artificial cross of a sheep and a goat [n -S]\n",
  "GEEPOUND": "a unit of mass [n -S]\n",
  "GEEPOUNDS": "GEEPOUND, a unit of mass [n]\n",
  "GEEPS": "GEEP, an artificial cross of a sheep and a goat [n]\n",
  "GEES": "GEE, of horses, to urge on, also JEE [v]\n",
  "GEESE": "GOOSE, a swimming bird [n]\n",
  "GEEST": "alluvial matter on the surface of land, not of recent origin [n -S]\n",
  "GEESTS": "GEEST, alluvial matter on the surface of land, not of recent origin [n]\n",
  "GEEZ": "an interjection expressing consternation, also JEEZ, JEEZE [interj]\n",
  "GEEZAH": "(colloquial) an eccentric old man, also GEEZER [n -S]\n",
  "GEEZAHS": "GEEZAH, (colloquial) an eccentric old man, also GEEZER [n]\n",
  "GEEZER": "(slang) an eccentric old man, also GEEZAH [n -S]\n",
  "GEEZERS": "GEEZER, (slang) an eccentric old man, also GEEZAH [n]\n",
  "GEFILTE": "(Yiddish) as in gefilte fish, a dish of fish stuffed with various ingredients, also GEFULLTE [adj]\n",
  "GEFUFFLE": "to make a commotion, also CARFUFFLE, CURFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v GEFUFFLED, GEFUFFLING, GEFUFFLES]\n",
  "GEFUFFLED": "GEFUFFLE, to make a commotion, also CARFUFFLE, CURFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "GEFUFFLES": "GEFUFFLE, to make a commotion, also CARFUFFLE, CURFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "GEFUFFLING": "GEFUFFLE, to make a commotion, also CARFUFFLE, CURFUFFLE, KEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "GEFULLTE": "(Yiddish) as in gefullte fish, a dish of fish stuffed with various ingredients, also GEFILTE [adj]\n",
  "GEGENSCHEIN": "(German) a faint oval patch of light directly opposite the sun in the night sky, caused by reflection of sunlight by dust particles [n -S]\n",
  "GEGENSCHEINS": "GEGENSCHEIN, (German) a faint oval patch of light directly opposite the sun in the night sky, caused by reflection of sunlight by dust particles [n]\n",
  "GEGGIE": "(Scots) the mouth [n -S]\n",
  "GEGGIES": "GEGGIE, (Scots) the mouth [n]\n",
  "GEHLENITE": "a mineral, calcium aluminum silicate [n -S]\n",
  "GEHLENITES": "GEHLENITE, a mineral, calcium aluminum silicate [n]\n",
  "GEISHA": "(Japanese) a Japanese girl trained to entertain [n -S]\n",
  "GEISHAS": "GEISHA, (Japanese) a Japanese girl trained to entertain [n]\n",
  "GEIST": "(German) spirit; intellectual inclination [n -S]\n",
  "GEISTS": "GEIST, (German) spirit; intellectual inclination [n]\n",
  "GEIT": "(Scots) a child, also GAITT, GYTE [n -S] / to put a border on (an article of clothing) [v -ED, -ING, -S]\n",
  "GEITED": "GEIT, to put a border on (an article of clothing) [v]\n",
  "GEITING": "GEIT, to put a border on (an article of clothing) [v]\n",
  "GEITONOGAMIES": "GEITONOGAMY, pollination of a flower by another flower on the same plant [n]\n",
  "GEITONOGAMOUS": "relating to geitonogamy, pollination of a flower by another flower on the same plant [adj]\n",
  "GEITONOGAMY": "pollination of a flower by another flower on the same plant [n GEITONOGAMIES]\n",
  "GEITS": "GEIT, to put a border on (an article of clothing) [v]\n",
  "GEL": "to become like a jelly [v GELLED, GELLING, GELS]\n",
  "GELABLE": "able to set like a jelly [adj]\n",
  "GELADA": "(Arabic) an Ethiopian baboon, with a long mane [n -S]\n",
  "GELADAS": "GELADA, (Arabic) an Ethiopian baboon, with a long mane [n]\n",
  "GELANDE": "(German) as in gelande jump, a jump made in downhill skiing [adj]\n",
  "GELANDESPRUNG": "a skiing jump from a crouch using both poles [n -S]\n",
  "GELANDESPRUNGS": "GELANDESPRUNG, a skiing jump from a crouch using both poles [n]\n",
  "GELANT": "a substance used to make things gel, also GELLANT [n -S]\n",
  "GELANTS": "GELANT, a substance used to make things gel, also GELLANT [n]\n",
  "GELASTIC": "relating to laughter [adj]\n",
  "GELATE": "to form a gel [v GELATED, GELATING, GELATES]\n",
  "GELATED": "GELATE, to form a gel [v]\n",
  "GELATES": "GELATE, to form a gel [v]\n",
  "GELATI": "(Italian) an Italian ice cream, also GELATO [n GELATIS]\n",
  "GELATIN": "a glutinous substance, also GELATINE [n -S]\n",
  "GELATINATE": "to convert into gelatin, or into a substance resembling jelly [v GELATINATED, GELATINATING, GELATINATES]\n",
  "GELATINATED": "GELATINATE, to convert into gelatin, or into a substance resembling jelly [v]\n",
  "GELATINATES": "GELATINATE, to convert into gelatin, or into a substance resembling jelly [v]\n",
  "GELATINATING": "GELATINATE, to convert into gelatin, or into a substance resembling jelly [v]\n",
  "GELATINATION": "conversion into gelatine [n -S]\n",
  "GELATINATIONS": "GELATINATION, conversion into gelatine [n]\n",
  "GELATINE": "a colourless, odourless and tasteless glue prepared from albuminous matter e.g. bones and hides, also GELATIN [n -S]\n",
  "GELATINES": "GELATINE, a colourless, odourless and tasteless glue prepared from albuminous matter e.g. bones and hides, also GELATIN [n]\n",
  "GELATING": "GELATE, to form a gel [v]\n",
  "GELATINISATION": "the process of gelatinising, also GELATINIZATION [n -S]\n",
  "GELATINISATIONS": "GELATINISATION, the process of gelatinising, also GELATINIZATION [n]\n",
  "GELATINISE": "to make into gelatine or jelly, also GELATINIZE [v GELATINISED, GELATINISING, GELATINISES]\n",
  "GELATINISED": "GELATINISE, to make into gelatine or jelly, also GELATINIZE [v]\n",
  "GELATINISER": "a gelatinising agent, also GELATINIZER [n -S]\n",
  "GELATINISERS": "GELATINISER, a gelatinising agent, also GELATINIZER [n]\n",
  "GELATINISES": "GELATINISE, to make into gelatine or jelly, also GELATINIZE [v]\n",
  "GELATINISING": "GELATINISE, to make into gelatine or jelly, also GELATINIZE [v]\n",
  "GELATINIZATION": "the process of gelatinizing, also GELATINISATION [n -S]\n",
  "GELATINIZATIONS": "GELATINIZATION, the process of gelatinizing, also GELATINISATION [n]\n",
  "GELATINIZE": "to convert into gelatin or jelly, also GELATINISE [v GELATINIZED, GELATINIZING, GELATINIZES]\n",
  "GELATINIZED": "GELATINIZE, to convert into gelatin or jelly, also GELATINISE [v]\n",
  "GELATINIZER": "a gelatinizing agent, also GELATINISER [n -S]\n",
  "GELATINIZERS": "GELATINIZER, a gelatinizing agent, also GELATINISER [n]\n",
  "GELATINIZES": "GELATINIZE, to convert into gelatin or jelly, also GELATINISE [v]\n",
  "GELATINIZING": "GELATINIZE, to convert into gelatin or jelly, also GELATINISE [v]\n",
  "GELATINOID": "a substance resembling gelatine [n -S]\n",
  "GELATINOIDS": "GELATINOID, a substance resembling gelatine [n]\n",
  "GELATINOUS": "of a slimy, clear sticky nature, water soluble, like gelatine [adj GELATINOUSLY]\n",
  "GELATINOUSLY": "GELATINOUS, of a slimy, clear sticky nature, water soluble, like gelatine [adv]\n",
  "GELATINOUSNESS": "GELATINOUS, of a slimy, clear sticky nature, water soluble, like gelatine [n]\n",
  "GELATINS": "GELATIN, a glutinous substance, also GELATINE [n]\n",
  "GELATION": "the process of gelling [n -S]\n",
  "GELATIONS": "GELATION, the process of gelling [n]\n",
  "GELATIS": "GELATI, (Italian) an Italian ice cream, also GELATO [n]\n",
  "GELATO": "(Italian) an Italian ice cream, also GELATI [n GELATOS or GELATI]\n",
  "GELATOS": "GELATO, (Italian) an Italian ice cream, also GELATI [n]\n",
  "GELCAP": "a dose of medicine enclosed in a soluble cap of gelatine [n -S]\n",
  "GELCAPS": "GELCAP, a dose of medicine enclosed in a soluble cap of gelatine [n]\n",
  "GELCOAT": "a surface layer of polyester resin [n -S]\n",
  "GELCOATS": "GELCOAT, a surface layer of polyester resin [n]\n",
  "GELD": "to castrate an animal, esp. a horse [v -ED, -ING, -S]\n",
  "GELDED": "GELD, to castrate an animal, esp. a horse [v]\n",
  "GELDER": "one who gelds or castrates [n -S]\n",
  "GELDERS": "GELDER, one who gelds or castrates [n]\n",
  "GELDING": "a castrated stallion [n -S]\n",
  "GELDINGS": "GELDING, a castrated stallion [n]\n",
  "GELDS": "GELD, to castrate an animal, esp. a horse [v]\n",
  "GELEE": "(French) a cosmetic gel [n -S]\n",
  "GELEES": "GELEE, (French) a cosmetic gel [n]\n",
  "GELID": "extremely cold, icy [adj GELIDER, GELIDEST, GELIDLY]\n",
  "GELIDER": "GELID, extremely cold, icy [adj]\n",
  "GELIDEST": "GELID, extremely cold, icy [adj]\n",
  "GELIDITIES": "GELIDITY, (obsolete) the state of being gelid, also GELIDNESS [n]\n",
  "GELIDITY": "(obsolete) the state of being gelid, also GELIDNESS [n GELIDITIES]\n",
  "GELIDLY": "GELID, extremely cold, icy [adv]\n",
  "GELIDNESS": "the state of being gelid, also GELIDITY [n -ES]\n",
  "GELIDNESSES": "GELIDNESS, the state of being gelid, also GELIDITY [n]\n",
  "GELIGNITE": "a powerful explosive used in mining, made from nitroglycerine, nitrocotton, potassium nitrate and wood-pulp [n -S]\n",
  "GELIGNITES": "GELIGNITE, a powerful explosive used in mining, made from nitroglycerine, nitrocotton, potassium nitrate and wood-pulp [n]\n",
  "GELLANT": "a substance used to make things gel, also GELANT [n -S]\n",
  "GELLANTS": "GELLANT, a substance used to make things gel, also GELANT [n]\n",
  "GELLED": "GEL, to become like a jelly [v]\n",
  "GELLIES": "GELLY, (slang) gelignite [n]\n",
  "GELLIFLOWRE": "(Spenser) gillyflower, also GILLIFLOWER, GILLYFLOWER, GILLYVOR [n -S]\n",
  "GELLIFLOWRES": "GELLIFLOWRE, (Spenser) gillyflower, also GILLIFLOWER, GILLYFLOWER, GILLYVOR [n]\n",
  "GELLING": "GEL, to become like a jelly [v]\n",
  "GELLY": "(slang) gelignite [n GELLIES]\n",
  "GELOSIES": "GELOSY, (Spenser) being resentful of another's advantages, also JEALOUSY, GEALOUSY [n]\n",
  "GELOSY": "(Spenser) being resentful of another's advantages, also JEALOUSY, GEALOUSY [n GELOSIES]\n",
  "GELS": "GEL, to become like a jelly [v]\n",
  "GELSEMIA": "GELSEMIUM, a climbing plant [n]\n",
  "GELSEMINE": "an alkaloid obtained from the yellow jasmine [n -S]\n",
  "GELSEMINES": "GELSEMINE, an alkaloid obtained from the yellow jasmine [n]\n",
  "GELSEMININE": "an alkaloid yielded by the gelsemium rhizome and rootlets [n -S]\n",
  "GELSEMININES": "GELSEMININE, an alkaloid yielded by the gelsemium rhizome and rootlets [n]\n",
  "GELSEMIUM": "a climbing plant [n GELSEMIUMS or GELSEMIA]\n",
  "GELSEMIUMS": "GELSEMIUM, a climbing plant [n]\n",
  "GELT": "(slang) money, profit [n -S]\n",
  "GELTS": "GELT, (slang) money, profit [n]\n",
  "GEM": "to adorn with gems [v GEMMED, GEMMING, GEMS]\n",
  "GEMATRIA": "a numerical method of interpreting Hebrew scriptures [n -S]\n",
  "GEMATRIAS": "GEMATRIA, a numerical method of interpreting Hebrew scriptures [n]\n",
  "GEMCLIP": "(tradename) in South Africa, a paper clip [n -S]\n",
  "GEMCLIPS": "GEMCLIP, (tradename) in South Africa, a paper clip [n]\n",
  "GEMEINSCHAFT": "(German) a spontaneous social relationship characterized by strong reciprocal bonds of sentiment and kinship within a common tradition [n GEMEINSCHAFTS or GEMEINSCHAFTEN]\n",
  "GEMEINSCHAFTEN": "GEMEINSCHAFT, (German) a spontaneous social relationship characterized by strong reciprocal bonds of sentiment and kinship within a common tradition [n]\n",
  "GEMEINSCHAFTS": "GEMEINSCHAFT, (German) a spontaneous social relationship characterized by strong reciprocal bonds of sentiment and kinship within a common tradition [n]\n",
  "GEMEL": "in heraldry, a pair of bars placed close together [n -S]\n",
  "GEMELS": "GEMEL, in heraldry, a pair of bars placed close together [n]\n",
  "GEMFIBROZIL": "a drug that lowers the level of low-density lipoproteins in the blood and is therefore used to treat patients with hypercholesterolaemia [n -S]\n",
  "GEMFIBROZILS": "GEMFIBROZIL, a drug that lowers the level of low-density lipoproteins in the blood and is therefore used to treat patients with hypercholesterolaemia [n]\n",
  "GEMFISH": "an American marine food fish of the Atlantic coast, aka kingfish [n -ES]\n",
  "GEMFISHES": "GEMFISH, an American marine food fish of the Atlantic coast, aka kingfish [n]\n",
  "GEMINAL": "having two matching substituted groups on the same atom [adj GEMINALLY]\n",
  "GEMINALLY": "GEMINAL, having two matching substituted groups on the same atom [adv]\n",
  "GEMINATE": "twinned [adj GEMINATELY] / to arrange in pairs [v GEMINATED, GEMINATING, GEMINATES]\n",
  "GEMINATED": "GEMINATE, to arrange in pairs [v]\n",
  "GEMINATELY": "GEMINATE, twinned [adv]\n",
  "GEMINATES": "GEMINATE, to arrange in pairs [v]\n",
  "GEMINATING": "GEMINATE, to arrange in pairs [v]\n",
  "GEMINATION": "the act of geminating [n -S]\n",
  "GEMINATIONS": "GEMINATION, the act of geminating [n]\n",
  "GEMINI": "(obsolete) expressing surprise, also JIMINY, JIMMINY, GEMONY [interj]\n",
  "GEMINIES": "GEMINY, (Shakespeare) a pair, esp. of eyes [n]\n",
  "GEMINOUS": "double [adj]\n",
  "GEMINY": "(Shakespeare) a pair, esp. of eyes [n GEMINIES]\n",
  "GEMLIKE": "resembling a gem [adj]\n",
  "GEMMA": "(Latin) a bud from which a new plant can grow [n GEMMAE]\n",
  "GEMMACEOUS": "budlike, relating to gemmae [adj]\n",
  "GEMMAE": "GEMMA, (Latin) a bud from which a new plant can grow [n]\n",
  "GEMMAN": "(archaic) a gentleman [n GEMMEN]\n",
  "GEMMATE": "to reproduce by gemmae [v GEMMATED, GEMMATING, GEMMATES]\n",
  "GEMMATED": "GEMMATE, to reproduce by gemmae [v]\n",
  "GEMMATES": "GEMMATE, to reproduce by gemmae [v]\n",
  "GEMMATING": "GEMMATE, to reproduce by gemmae [v]\n",
  "GEMMATION": "budding or gemma-formation [n -S]\n",
  "GEMMATIONS": "GEMMATION, budding or gemma-formation [n]\n",
  "GEMMATIVE": "relating to gemmation, the action of putting out buds [adj]\n",
  "GEMMED": "GEM, to adorn with gems [v]\n",
  "GEMMEN": "GEMMAN, (archaic) a gentleman [n]\n",
  "GEMMEOUS": "like a gem [adj]\n",
  "GEMMERIES": "GEMMERY, gems generally [n]\n",
  "GEMMERY": "gems generally [n GEMMERIES]\n",
  "GEMMIER": "GEMMY, resembling a gem [adj]\n",
  "GEMMIEST": "GEMMY, resembling a gem [adj]\n",
  "GEMMIFEROUS": "bearing gemmae [adj]\n",
  "GEMMILY": "GEMMY, resembling a gem [adv]\n",
  "GEMMINESS": "the state of being gemmy, full of gems [n -ES]\n",
  "GEMMINESSES": "GEMMINESS, the state of being gemmy, full of gems [n]\n",
  "GEMMING": "GEM, to adorn with gems [v]\n",
  "GEMMIPAROUS": "reproducing by gemmae [adj GEMMIPAROUSLY]\n",
  "GEMMIPAROUSLY": "GEMMIPAROUS, reproducing by gemmae [adv]\n",
  "GEMMOLOGICAL": "related to gemmology, also GEMOLOGICAL [adj]\n",
  "GEMMOLOGIES": "GEMMOLOGY, the study of gems, also GEMOLOGY [n]\n",
  "GEMMOLOGIST": "a student of precious stones, also GEMOLOGIST [n -S]\n",
  "GEMMOLOGISTS": "GEMMOLOGIST, a student of precious stones, also GEMOLOGIST [n]\n",
  "GEMMOLOGY": "the study of gems, also GEMOLOGY [n GEMMOLOGIES]\n",
  "GEMMULATION": "formation of gemmules [n -S]\n",
  "GEMMULATIONS": "GEMMULATION, formation of gemmules [n]\n",
  "GEMMULE": "a small asexual reproductive structure [n -S]\n",
  "GEMMULES": "GEMMULE, a small asexual reproductive structure [n]\n",
  "GEMMY": "resembling a gem [adj GEMMIER, GEMMIEST, GEMMILY]\n",
  "GEMOLOGICAL": "relating to gemology, the study of gems, also GEMMOLOGICAL [adj]\n",
  "GEMOLOGIES": "GEMOLOGY, the study of gems, also GEMMOLOGY [n]\n",
  "GEMOLOGIST": "one who studies gems, also GEMMOLOGIST [n -S]\n",
  "GEMOLOGISTS": "GEMOLOGIST, one who studies gems, also GEMMOLOGIST [n]\n",
  "GEMOLOGY": "the study of gems, also GEMMOLOGY [n GEMOLOGIES]\n",
  "GEMONY": "(obsolete) expressing surprise, also JIMINY, JIMMINY, GEMINI [interj]\n",
  "GEMOT": "(historical) a public meeting in Anglo-Saxon England, also GEMOTE [n -S]\n",
  "GEMOTE": "(Old English) an Anglo-Saxon legislative assembly, also GEMOT [n -S]\n",
  "GEMOTES": "GEMOTE, (Old English) an Anglo-Saxon legislative assembly, also GEMOT [n]\n",
  "GEMOTS": "GEMOT, (historical) a public meeting in Anglo-Saxon England, also GEMOTE [n]\n",
  "GEMS": "GEM, to adorn with gems [v]\n",
  "GEMSBOK": "(South African) a kind of antelope, having long, sharp, nearly straight horns, also GEMSBUCK [n -S]\n",
  "GEMSBOKS": "GEMSBOK, (South African) a kind of antelope, having long, sharp, nearly straight horns, also GEMSBUCK [n]\n",
  "GEMSBUCK": "(South African) a kind of antelope, having long, sharp, nearly straight horns, also GEMSBOK [n -S]\n",
  "GEMSBUCKS": "GEMSBUCK, (South African) a kind of antelope, having long, sharp, nearly straight horns, also GEMSBOK [n]\n",
  "GEMSHORN": "(German) a chamois horn used as a wind instrument [n -S]\n",
  "GEMSHORNS": "GEMSHORN, (German) a chamois horn used as a wind instrument [n]\n",
  "GEMSTONE": "a precious or semiprecious stone, esp. one cut and polished for setting in jewellery [n -S]\n",
  "GEMSTONES": "GEMSTONE, a precious or semiprecious stone, esp. one cut and polished for setting in jewellery [n]\n",
  "GEMUTLICH": "(German) agreeably pleasant, comfortable [adj]\n",
  "GEMUTLICHKEIT": "(German) the quality of being gemutlich; geniality; cosiness [n -S]\n",
  "GEMUTLICHKEITS": "GEMUTLICHKEIT, (German) the quality of being gemutlich; geniality; cosiness [n]\n",
  "GEN": "as in gen up, to brief [v GENNED, GENNING, GENS]\n",
  "GENA": "(Latin) the cheek [n -S]\n",
  "GENAL": "of the cheek [adj]\n",
  "GENAPPE": "a smooth worsted yarn [n -S]\n",
  "GENAPPES": "GENAPPE, a smooth worsted yarn [n]\n",
  "GENAS": "GENA, (Latin) the cheek [n]\n",
  "GENDARME": "(French) a French policeman [n GENDARMES or GENSDARMES]\n",
  "GENDARMERIE": "(French) the French police, also GENDARMERY [n -S]\n",
  "GENDARMERIES": "GENDARMERIE, (French) the French police, also GENDARMERY [n]\n",
  "GENDARMERY": "the body of gendarmes, also GENDARMERIE [n GENDARMERIES]\n",
  "GENDARMES": "GENDARME, (French) a French policeman [n]\n",
  "GENDER": "a distinction of words roughly corresponding to the sex to which they refer [n -S] / (archaic) to beget [v -ED, -ING, -S]\n",
  "GENDERED": "GENDER, (archaic) to beget [v]\n",
  "GENDERING": "GENDER, (archaic) to beget [v]\n",
  "GENDERISE": "to make distinctions according to gender, also GENDERIZE [v GENDERISED, GENDERISING, GENDERISES]\n",
  "GENDERISED": "GENDERISE, to make distinctions according to gender, also GENDERIZE [v]\n",
  "GENDERISES": "GENDERISE, to make distinctions according to gender, also GENDERIZE [v]\n",
  "GENDERISING": "GENDERISE, to make distinctions according to gender, also GENDERIZE [v]\n",
  "GENDERIZE": "to make distinctions according to gender, also GENDERISE [v GENDERIZED, GENDERIZING, GENDERIZES]\n",
  "GENDERIZED": "GENDERIZE, to make distinctions according to gender, also GENDERISE [v]\n",
  "GENDERIZES": "GENDERIZE, to make distinctions according to gender, also GENDERISE [v]\n",
  "GENDERIZING": "GENDERIZE, to make distinctions according to gender, also GENDERISE [v]\n",
  "GENDERLESS": "having no gender [adj]\n",
  "GENDERQUEER": "a person who does not subscribe to traditional gender differences but identifies with both, neither, or a mixture of female and male genders [n -S]\n",
  "GENDERQUEERS": "GENDERQUEER, a person who does not subscribe to traditional gender differences but identifies with both, neither, or a mixture of female and male genders [n]\n",
  "GENDERS": "GENDER, (archaic) to beget [v]\n",
  "GENE": "a hereditary unit [n -S]\n",
  "GENEALOGIC": "relating to genealogy, also GENEALOGICAL [adj GENEALOGICALLY]\n",
  "GENEALOGICAL": "relating to genealogy, also GENEALOGIC [adj GENEALOGICALLY]\n",
  "GENEALOGICALLY": "GENEALOGICAL, relating to genealogy, also GENEALOGIC [adv]\n",
  "GENEALOGIES": "GENEALOGY, the history of the descent of families [n]\n",
  "GENEALOGISE": "to investigate or discuss genealogy, also GENEALOGIZE [v GENEALOGISED, GENEALOGISING, GENEALOGISES]\n",
  "GENEALOGISED": "GENEALOGISE, to investigate or discuss genealogy, also GENEALOGIZE [v]\n",
  "GENEALOGISES": "GENEALOGISE, to investigate or discuss genealogy, also GENEALOGIZE [v]\n",
  "GENEALOGISING": "GENEALOGISE, to investigate or discuss genealogy, also GENEALOGIZE [v]\n",
  "GENEALOGIST": "a person who traces or studies the descent of persons or families [n -S]\n",
  "GENEALOGISTS": "GENEALOGIST, a person who traces or studies the descent of persons or families [n]\n",
  "GENEALOGIZE": "to investigate or discuss genealogy, also GENEALOGISE [v GENEALOGIZED, GENEALOGIZING, GENEALOGIZES]\n",
  "GENEALOGIZED": "GENEALOGIZE, to investigate or discuss genealogy, also GENEALOGISE [v]\n",
  "GENEALOGIZES": "GENEALOGIZE, to investigate or discuss genealogy, also GENEALOGISE [v]\n",
  "GENEALOGIZING": "GENEALOGIZE, to investigate or discuss genealogy, also GENEALOGISE [v]\n",
  "GENEALOGY": "the history of the descent of families [n GENEALOGIES]\n",
  "GENECOLOGIES": "GENECOLOGY, the study of the gene frequency of a species in relation to its population distribution within a particular environment [n]\n",
  "GENECOLOGY": "the study of the gene frequency of a species in relation to its population distribution within a particular environment [n GENECOLOGIES]\n",
  "GENERA": "GENUS, (Latin) a taxonomic group of lower rank than a family [n]\n",
  "GENERABLE": "that may be generated or produced [adj]\n",
  "GENERAL": "widespread [adj GENERALLY] / to act as a military officer [v GENERALLED, GENERALLING, GENERALS]\n",
  "GENERALATE": "the office of a general [n -S]\n",
  "GENERALATES": "GENERALATE, the office of a general [n]\n",
  "GENERALCIES": "GENERALCY, the rank of general [n]\n",
  "GENERALCY": "the rank of general [n GENERALCIES]\n",
  "GENERALE": "(Latin) a general principle [n GENERALIA]\n",
  "GENERALIA": "GENERALE, (Latin) a general principle [n]\n",
  "GENERALISABLE": "that can be generalised, also GENERALIZABLE [adj]\n",
  "GENERALISATION": "the process of generalising, also GENERALIZATION [n -S]\n",
  "GENERALISATIONS": "GENERALISATION, the process of generalising, also GENERALIZATION [n]\n",
  "GENERALISE": "to make a general statement, also GENERALIZE [v GENERALISED, GENERALISING, GENERALISES]\n",
  "GENERALISED": "GENERALISE, to make a general statement, also GENERALIZE [v]\n",
  "GENERALISER": "one who generalises, also GENERALIZER [n -S]\n",
  "GENERALISERS": "GENERALISER, one who generalises, also GENERALIZER [n]\n",
  "GENERALISES": "GENERALISE, to make a general statement, also GENERALIZE [v]\n",
  "GENERALISING": "GENERALISE, to make a general statement, also GENERALIZE [v]\n",
  "GENERALISM": "the practice of studying many different things rather than specializing in one subject [n -S]\n",
  "GENERALISMS": "GENERALISM, the practice of studying many different things rather than specializing in one subject [n]\n",
  "GENERALISSIMO": "the chief commander of an army [n -S]\n",
  "GENERALISSIMOS": "GENERALISSIMO, the chief commander of an army [n]\n",
  "GENERALIST": "a person whose knowledge and skills are not restricted to one particular field [n -S]\n",
  "GENERALISTS": "GENERALIST, a person whose knowledge and skills are not restricted to one particular field [n]\n",
  "GENERALITIES": "GENERALITY, the state of being general [n]\n",
  "GENERALITY": "the state of being general [n GENERALITIES]\n",
  "GENERALIZABLE": "capable of being generalized, also GENERALISABLE [adj]\n",
  "GENERALIZATION": "the act of generalizing, also GENERALISATION [n -S]\n",
  "GENERALIZATIONS": "GENERALIZATION, the act of generalizing, also GENERALISATION [n]\n",
  "GENERALIZE": "to give a general form to, also GENERALISE [v GENERALIZED, GENERALIZING, GENERALIZES]\n",
  "GENERALIZED": "GENERALIZE, to give a general form to, also GENERALISE [v]\n",
  "GENERALIZER": "one who generalizes, also GENERALISER [n -S]\n",
  "GENERALIZERS": "GENERALIZER, one who generalizes, also GENERALISER [n]\n",
  "GENERALIZES": "GENERALIZE, to give a general form to, also GENERALISE [v]\n",
  "GENERALIZING": "GENERALIZE, to give a general form to, also GENERALISE [v]\n",
  "GENERALLED": "GENERAL, to act as a military officer [v]\n",
  "GENERALLING": "GENERAL, to act as a military officer [v]\n",
  "GENERALLY": "GENERAL, widespread [adv]\n",
  "GENERALNESS": "the quality of being general [n -ES]\n",
  "GENERALNESSES": "GENERALNESS, the quality of being general [n]\n",
  "GENERALS": "GENERAL, to act as a military officer [v]\n",
  "GENERALSHIP": "the office of a general [n -S]\n",
  "GENERALSHIPS": "GENERALSHIP, the office of a general [n]\n",
  "GENERANT": "a line which traces out a figure [n -S]\n",
  "GENERANTS": "GENERANT, a line which traces out a figure [n]\n",
  "GENERATE": "to bring into existence [v GENERATED, GENERATING, GENERATES]\n",
  "GENERATED": "GENERATE, to bring into existence [v]\n",
  "GENERATES": "GENERATE, to bring into existence [v]\n",
  "GENERATING": "GENERATE, to bring into existence [v]\n",
  "GENERATION": "a body of living beings constituting a single step in the line of descent from an ancestor [n -S]\n",
  "GENERATIONAL": "relating to generation [adj GENERATIONALLY]\n",
  "GENERATIONALLY": "GENERATIONAL, relating to generation [adv]\n",
  "GENERATIONISM": "the theory that the soul is transmitted to a child in the act of generation or concomitantly with its body [n -S]\n",
  "GENERATIONISMS": "GENERATIONISM, the theory that the soul is transmitted to a child in the act of generation or concomitantly with its body [n]\n",
  "GENERATIONS": "GENERATION, a body of living beings constituting a single step in the line of descent from an ancestor [n]\n",
  "GENERATIVE": "having the power or function of generating [adj]\n",
  "GENERATOR": "an apparatus for turning mechanical into electrical energy [n -S]\n",
  "GENERATORS": "GENERATOR, an apparatus for turning mechanical into electrical energy [n]\n",
  "GENERATRICES": "GENERATRIX, a line, point or figure that traces out another figure by its motion [n]\n",
  "GENERATRIX": "a line, point or figure that traces out another figure by its motion [n GENERATRICES]\n",
  "GENERIC": "general; applicable to any of a group or class, also GENERICAL [adj GENERICALLY] / a generic drug [n -S]\n",
  "GENERICAL": "general; applicable to any of a group or class, also GENERIC [adj GENERICALLY]\n",
  "GENERICALLY": "GENERICAL, general; applicable to any of a group or class, also GENERIC [adv]\n",
  "GENERICNESS": "the state of being generic [n -ES]\n",
  "GENERICNESSES": "GENERICNESS, the state of being generic [n]\n",
  "GENERICS": "GENERIC, a generic drug [n]\n",
  "GENEROSITIES": "GENEROSITY, the quality or fact of being generous [n]\n",
  "GENEROSITY": "the quality or fact of being generous [n GENEROSITIES]\n",
  "GENEROUS": "willing to give [adj GENEROUSLY]\n",
  "GENEROUSLY": "GENEROUS, willing to give [adv]\n",
  "GENEROUSNESS": "the state of being generous [n -ES]\n",
  "GENEROUSNESSES": "GENEROUSNESS, the state of being generous [n]\n",
  "GENES": "GENE, a hereditary unit [n]\n",
  "GENESES": "GENESIS, (Greek) the act of producing, or giving birth or origin to anything [n]\n",
  "GENESIS": "(Greek) the act of producing, or giving birth or origin to anything [n GENESES]\n",
  "GENET": "a carnivorous mammal, also GENETTE [n -S] / a small Spanish horse, also GENNET, JENNET [n -S]\n",
  "GENETHLIAC": "(obsolete) pertaining to nativities [adj] / a caster of horoscopes [n -S]\n",
  "GENETHLIACAL": "(obsolete) pertaining to nativities; showing position of stars at one's birth [adj]\n",
  "GENETHLIACALLY": "GENETHLIACAL, (obsolete) pertaining to nativities; showing position of stars at one's birth [adv]\n",
  "GENETHLIACON": "a birthday ode [n -S]\n",
  "GENETHLIACONS": "GENETHLIACON, a birthday ode [n]\n",
  "GENETHLIACS": "GENETHLIAC, a caster of horoscopes [n]\n",
  "GENETHLIALOGIC": "related to the casting of horoscopes [adj]\n",
  "GENETHLIALOGIES": "GENETHLIALOGY, the art of casting horoscopes [n]\n",
  "GENETHLIALOGY": "the art of casting horoscopes [n GENETHLIALOGIES]\n",
  "GENETIC": "relating to genes, also GENETICAL [adj GENETICALLY]\n",
  "GENETICAL": "relating to genes, also GENETIC [adj GENETICALLY]\n",
  "GENETICALLY": "GENETICAL, relating to genes, also GENETIC [adv]\n",
  "GENETICIST": "a student of genetics [n -S]\n",
  "GENETICISTS": "GENETICIST, a student of genetics [n]\n",
  "GENETICS": "the science of heredity [n]\n",
  "GENETOTROPHIC": "denoting a defect in metabolism which prevents the normal assimilation of essential food elements [adj]\n",
  "GENETRICES": "GENETRIX, (Latin) a mother, also GENITRIX [n]\n",
  "GENETRIX": "(Latin) a mother, also GENITRIX [n GENETRIXES or GENETRICES]\n",
  "GENETRIXES": "GENETRIX, (Latin) a mother, also GENITRIX [n]\n",
  "GENETS": "GENET, a carnivorous mammal, also GENETTE [n]\n",
  "GENETTE": "one of several species of small carnivore allied to the civets, also GENET [n -S]\n",
  "GENETTES": "GENETTE, one of several species of small carnivore allied to the civets, also GENET [n]\n",
  "GENEVA": "a spirit distilled from grain and flavoured with juniper berries [n -S]\n",
  "GENEVAS": "GENEVA, a spirit distilled from grain and flavoured with juniper berries [n]\n",
  "GENEVRETTE": "a wine made from wild fruits flavoured with juniper berries [n -S]\n",
  "GENEVRETTES": "GENEVRETTE, a wine made from wild fruits flavoured with juniper berries [n]\n",
  "GENIAL": "having a pleasant or friendly manner [adj GENIALLY]\n",
  "GENIALISE": "to impart geniality to, also GENIALIZE [v GENIALISED, GENIALISING, GENIALISES]\n",
  "GENIALISED": "GENIALISE, to impart geniality to, also GENIALIZE [v]\n",
  "GENIALISES": "GENIALISE, to impart geniality to, also GENIALIZE [v]\n",
  "GENIALISING": "GENIALISE, to impart geniality to, also GENIALIZE [v]\n",
  "GENIALITIES": "GENIALITY, the quality of being genial [n]\n",
  "GENIALITY": "the quality of being genial [n GENIALITIES]\n",
  "GENIALIZE": "to impart geniality to, also GENIALISE [v GENIALIZED, GENIALIZING, GENIALIZES]\n",
  "GENIALIZED": "GENIALIZE, to impart geniality to, also GENIALISE [v]\n",
  "GENIALIZES": "GENIALIZE, to impart geniality to, also GENIALISE [v]\n",
  "GENIALIZING": "GENIALIZE, to impart geniality to, also GENIALISE [v]\n",
  "GENIALLY": "GENIAL, having a pleasant or friendly manner [adv]\n",
  "GENIALNESS": "the quality of being genial [n -ES]\n",
  "GENIALNESSES": "GENIALNESS, the quality of being genial [n]\n",
  "GENIC": "of or relating to a gene [adj GENICALLY]\n",
  "GENICALLY": "GENIC, of or relating to a gene [adv]\n",
  "GENICULAR": "relating to the knee [adj]\n",
  "GENICULATE": "jointed like a knee [adj GENICULATELY] / to form joints in [v GENICULATED, GENICULATING, GENICULATES]\n",
  "GENICULATED": "GENICULATE, to form joints in [v]\n",
  "GENICULATELY": "GENICULATE, jointed like a knee [adv]\n",
  "GENICULATES": "GENICULATE, to form joints in [v]\n",
  "GENICULATING": "GENICULATE, to form joints in [v]\n",
  "GENICULATION": "being jointed, like a knee [n -S]\n",
  "GENICULATIONS": "GENICULATION, being jointed, like a knee [n]\n",
  "GENIE": "(Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, JANN, JIN, JINN, JINNEE, JINNI [n -S]\n",
  "GENIES": "GENIE, (Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, JANN, JIN, JINN, JINNEE, JINNI [n]\n",
  "GENII": "GENIUS, (Latin) an exceptional natural aptitude [n]\n",
  "GENIP": "(Tupi) a tropical American tree; its orange-like fruit, also GENIPAP, GENIPAPO, GUINEP [n -S]\n",
  "GENIPAP": "(Tupi) a tropical American tree; its orange-like fruit, also GENIP, GENIPAPO, GUINEP [n -S]\n",
  "GENIPAPO": "(Tupi) a tropical American tree; its orange-like fruit, also GENIP, GENIPAP, GUINEP [n -S]\n",
  "GENIPAPOS": "GENIPAPO, (Tupi) a tropical American tree; its orange-like fruit, also GENIP, GENIPAP, GUINEP [n]\n",
  "GENIPAPS": "GENIPAP, (Tupi) a tropical American tree; its orange-like fruit, also GENIP, GENIPAPO, GUINEP [n]\n",
  "GENIPS": "GENIP, (Tupi) a tropical American tree; its orange-like fruit, also GENIPAP, GENIPAPO, GUINEP [n]\n",
  "GENISTA": "(Latin) a genus of plants including the common broom of Western Europe [n -S]\n",
  "GENISTAS": "GENISTA, (Latin) a genus of plants including the common broom of Western Europe [n]\n",
  "GENISTEIN": "a plant oestrogen found in soya, thought to be effective in fighting cancer [n -S]\n",
  "GENISTEINS": "GENISTEIN, a plant oestrogen found in soya, thought to be effective in fighting cancer [n]\n",
  "GENITAL": "pertaining to reproduction [adj GENITALLY]\n",
  "GENITALIA": "the reproductive parts [n]\n",
  "GENITALIAL": "relating to the genitalia, also GENITALIC [adj]\n",
  "GENITALIC": "relating to the genitalia, also GENITALIAL [adj]\n",
  "GENITALLY": "GENITAL, pertaining to reproduction [adv]\n",
  "GENITALS": "the sexual organs [n]\n",
  "GENITIVAL": "relating to the genitive case [adj GENITIVALLY]\n",
  "GENITIVALLY": "GENITIVAL, relating to the genitive case [adv]\n",
  "GENITIVE": "indicating possession, origin or relation [adj GENITIVELY] / a grammatical case indicating possession, origin or relation [n -S]\n",
  "GENITIVELY": "GENITIVE, indicating possession, origin or relation [adv]\n",
  "GENITIVES": "GENITIVE, a grammatical case indicating possession, origin or relation [n]\n",
  "GENITOR": "(Latin) a male parent [n -S]\n",
  "GENITORS": "GENITOR, (Latin) a male parent [n]\n",
  "GENITOURINARY": "of or relating to the genital and urinary organs or functions [adj]\n",
  "GENITRICES": "GENITRIX, (Latin) a mother, also GENETRIX [n]\n",
  "GENITRIX": "(Latin) a mother, also GENETRIX [n GENITRIXES or GENITRICES]\n",
  "GENITRIXES": "GENITRIX, (Latin) a mother, also GENETRIX [n]\n",
  "GENITURE": "birth [n -S]\n",
  "GENITURES": "GENITURE, birth [n]\n",
  "GENIUS": "(Latin) an exceptional natural aptitude [n GENIUSES or GENII]\n",
  "GENIUSES": "GENIUS, (Latin) an exceptional natural aptitude [n]\n",
  "GENIZAH": "(Hebrew) a room in a synagogue [n GENIZAHS or GENIZOT or GENIZOTH]\n",
  "GENIZAHS": "GENIZAH, (Hebrew) a room in a synagogue [n]\n",
  "GENIZOT": "GENIZAH, (Hebrew) a room in a synagogue [n]\n",
  "GENIZOTH": "GENIZAH, (Hebrew) a room in a synagogue [n]\n",
  "GENLOCK": "to maintain synchronization between two signals using the genlock technique [v -ED, -ING, -S]\n",
  "GENLOCKED": "GENLOCK, to maintain synchronization between two signals using the genlock technique [v]\n",
  "GENLOCKING": "maintaining synchronization between two signals using the genlock technique [n -S]\n",
  "GENLOCKINGS": "GENLOCKING, maintaining synchronization between two signals using the genlock technique [n]\n",
  "GENLOCKS": "GENLOCK, to maintain synchronization between two signals using the genlock technique [v]\n",
  "GENNAKER": "a type of sail for boats [n -S]\n",
  "GENNAKERS": "GENNAKER, a type of sail for boats [n]\n",
  "GENNED": "GEN, as in gen up, to brief [v]\n",
  "GENNEL": "a narrow alley between high buildings, also GINNEL [n -S]\n",
  "GENNELS": "GENNEL, a narrow alley between high buildings, also GINNEL [n]\n",
  "GENNET": "a small Spanish horse, also JENNET [n -S]\n",
  "GENNETS": "GENNET, a small Spanish horse, also JENNET [n]\n",
  "GENNIES": "GENNY, a large triangular sail, also GENOA [n]\n",
  "GENNING": "GEN, as in gen up, to brief [v]\n",
  "GENNY": "a large triangular sail, also GENOA [n GENNIES]\n",
  "GENOA": "(Italian) a large triangular sail, also GENNY [n -S]\n",
  "GENOAS": "GENOA, (Italian) a large triangular sail, also GENNY [n]\n",
  "GENOCIDAIRE": "a person who is guilty of genocide [n -S]\n",
  "GENOCIDAIRES": "GENOCIDAIRE, a person who is guilty of genocide [n]\n",
  "GENOCIDAL": "relating to genocide [adj]\n",
  "GENOCIDE": "the deliberate extermination of a nation or race [n -S]\n",
  "GENOCIDES": "GENOCIDE, the deliberate extermination of a nation or race [n]\n",
  "GENOGRAM": "a diagram of the history of behavior patterns of a family [n -S]\n",
  "GENOGRAMS": "GENOGRAM, a diagram of the history of behavior patterns of a family [n]\n",
  "GENOISE": "(French) a rich sponge cake [n -S]\n",
  "GENOISES": "GENOISE, (French) a rich sponge cake [n]\n",
  "GENOM": "a haploid set of chromosomes, also GENOME [n -S]\n",
  "GENOME": "a haploid set of chromosomes, also GENOM [n -S]\n",
  "GENOMES": "GENOME, a haploid set of chromosomes, also GENOM [n]\n",
  "GENOMIC": "relating to a genome (a haploid set of chromosomes) [adj]\n",
  "GENOMICS": "the branch of molecular genetics concerned with the study of genomes [n]\n",
  "GENOMS": "GENOM, a haploid set of chromosomes, also GENOME [n]\n",
  "GENOPHOBIA": "the morbid fear of sex [n -S]\n",
  "GENOPHOBIAS": "GENOPHOBIA, the morbid fear of sex [n]\n",
  "GENOTOXIC": "harmful to genetic material esp. in causing genetic mutation [adj]\n",
  "GENOTYPE": "to determine all or part of the genetic constitution of [v GENOTYPED, GENOTYPING, GENOTYPES]\n",
  "GENOTYPED": "GENOTYPE, to determine all or part of the genetic constitution of [v]\n",
  "GENOTYPES": "GENOTYPE, to determine all or part of the genetic constitution of [v]\n",
  "GENOTYPIC": "relating to a genotype, the set of genes of an individual [adj GENOTYPICALLY]\n",
  "GENOTYPICAL": "relating to a genotype [adj GENOTYPICALLY]\n",
  "GENOTYPICALLY": "GENOTYPICAL, relating to a genotype [adv]\n",
  "GENOTYPICITIES": "GENOTYPICITY, the state of being genotypic [n]\n",
  "GENOTYPICITY": "the state of being genotypic [n GENOTYPICITIES]\n",
  "GENOTYPING": "GENOTYPE, to determine all or part of the genetic constitution of [v]\n",
  "GENOUILLERE": "(French) a jointed kneepiece in armour [n -S]\n",
  "GENOUILLERES": "GENOUILLERE, (French) a jointed kneepiece in armour [n]\n",
  "GENRE": "(French) a literary or artistic type or style [n -S]\n",
  "GENRES": "GENRE, (French) a literary or artistic type or style [n]\n",
  "GENRO": "(Japanese) a group of elder statesmen in Japan [n -S]\n",
  "GENROS": "GENRO, (Japanese) a group of elder statesmen in Japan [n]\n",
  "GENS": "(Latin) in ancient Rome a clan including several families descending from a common ancestor [n GENTES]\n",
  "GENSDARMES": "GENDARME, (French) a French policeman [n]\n",
  "GENSENG": "(Chinese) a plant of the genus Aralia, the root of which is highly valued as a medicine among the Chinese, also GINSENG [n -S]\n",
  "GENSENGS": "GENSENG, (Chinese) a plant of the genus Aralia, the root of which is highly valued as a medicine among the Chinese, also GINSENG [n]\n",
  "GENT": "(short for) gentleman [n -S]\n",
  "GENTAMICIN": "a broad-spectrum antibiotic derived from an actinomycete [n -S]\n",
  "GENTAMICINS": "GENTAMICIN, a broad-spectrum antibiotic derived from an actinomycete [n]\n",
  "GENTEEL": "well-bred or refined [adj GENTEELER, GENTEELEST, GENTEELLY]\n",
  "GENTEELER": "GENTEEL, well-bred or refined [adj]\n",
  "GENTEELEST": "GENTEEL, well-bred or refined [adj]\n",
  "GENTEELISE": "to make genteel or falsely refined, also GENTEELIZE [v GENTEELISED, GENTEELISING, GENTEELISES]\n",
  "GENTEELISED": "GENTEELISE, to make genteel or falsely refined, also GENTEELIZE [v]\n",
  "GENTEELISES": "GENTEELISE, to make genteel or falsely refined, also GENTEELIZE [v]\n",
  "GENTEELISH": "somewhat genteel [adj]\n",
  "GENTEELISING": "GENTEELISE, to make genteel or falsely refined, also GENTEELIZE [v]\n",
  "GENTEELISM": "being genteel [n -S]\n",
  "GENTEELISMS": "GENTEELISM, being genteel [n]\n",
  "GENTEELIZE": "to make genteel or falsely refined, also GENTEELISE [v GENTEELIZED, GENTEELIZING, GENTEELIZES]\n",
  "GENTEELIZED": "GENTEELIZE, to make genteel or falsely refined, also GENTEELISE [v]\n",
  "GENTEELIZES": "GENTEELIZE, to make genteel or falsely refined, also GENTEELISE [v]\n",
  "GENTEELIZING": "GENTEELIZE, to make genteel or falsely refined, also GENTEELISE [v]\n",
  "GENTEELLY": "GENTEEL, well-bred or refined [adv]\n",
  "GENTEELNESS": "the state of being genteel [n -ES]\n",
  "GENTEELNESSES": "GENTEELNESS, the state of being genteel [n]\n",
  "GENTES": "GENS, (Latin) in ancient Rome a clan including several families descending from a common ancestor [n]\n",
  "GENTIAN": "any plant of the genus Gentiana, herbs, usually blue-flowered, abounding chiefly in alpine regions [n -S]\n",
  "GENTIANACEOUS": "belonging to the gentian family [adj]\n",
  "GENTIANELLA": "a name for several species of gentian, esp. Gentiana acaulis, with deep-blue flowers [n -S]\n",
  "GENTIANELLAS": "GENTIANELLA, a name for several species of gentian, esp. Gentiana acaulis, with deep-blue flowers [n]\n",
  "GENTIANS": "GENTIAN, any plant of the genus Gentiana, herbs, usually blue-flowered, abounding chiefly in alpine regions [n]\n",
  "GENTIER": "GENTY, neat, trim [adj]\n",
  "GENTIEST": "GENTY, neat, trim [adj]\n",
  "GENTIL": "kind [adj]\n",
  "GENTILE": "a non-Jewish person [n -S]\n",
  "GENTILES": "GENTILE, a non-Jewish person [n]\n",
  "GENTILESSE": "(obsolete) gentleness, courtesy [n -S]\n",
  "GENTILESSES": "GENTILESSE, (obsolete) gentleness, courtesy [n]\n",
  "GENTILHOMME": "(French) a nobleman, a gentleman [n GENTILSHOMMES]\n",
  "GENTILIC": "belonging to a tribe or nation [adj]\n",
  "GENTILISE": "(archaic) to raise to the class of gentleman [v GENTILISED, GENTILISING, GENTILISES]\n",
  "GENTILISED": "GENTILISE, (archaic) to raise to the class of gentleman [v]\n",
  "GENTILISES": "GENTILISE, (archaic) to raise to the class of gentleman [v]\n",
  "GENTILISH": "heathenish, pagan [adj]\n",
  "GENTILISING": "GENTILISE, (archaic) to raise to the class of gentleman [v]\n",
  "GENTILISM": "paganism, the quality of being a gentile [n -S]\n",
  "GENTILISMS": "GENTILISM, paganism, the quality of being a gentile [n]\n",
  "GENTILITIAL": "relating to a gens, also GENTILITIAN, GENTILITIOUS [adj]\n",
  "GENTILITIAN": "relating to a gens, also GENTILITIAL, GENTILITIOUS [adj]\n",
  "GENTILITIES": "GENTILITY, good birth or extraction [n]\n",
  "GENTILITIOUS": "relating to a gens, also GENTILITIAL, GENTILITIAN [adj]\n",
  "GENTILITY": "good birth or extraction [n GENTILITIES]\n",
  "GENTILIZE": "(archaic) to raise to the class of gentleman, also GENTILISE [v GENTILIZED, GENTILIZING, GENTILIZES]\n",
  "GENTILIZED": "GENTILIZE, (archaic) to raise to the class of gentleman, also GENTILISE [v]\n",
  "GENTILIZES": "GENTILIZE, (archaic) to raise to the class of gentleman, also GENTILISE [v]\n",
  "GENTILIZING": "GENTILIZE, (archaic) to raise to the class of gentleman, also GENTILISE [v]\n",
  "GENTILSHOMMES": "GENTILHOMME, (French) a nobleman, a gentleman [n]\n",
  "GENTLE": "to tame [v GENTLED, GENTLING, GENTLES] / mild and refined in manners [adj GENTLER, GENTLEST, GENTLY]\n",
  "GENTLED": "GENTLE, to tame [v]\n",
  "GENTLEFOLK": "persons of gentle or good family and breeding [n -S]\n",
  "GENTLEFOLKS": "GENTLEFOLK, persons of gentle or good family and breeding [n]\n",
  "GENTLEHOOD": "(archaic) position or character attaching to gentle birth [n -S]\n",
  "GENTLEHOODS": "GENTLEHOOD, (archaic) position or character attaching to gentle birth [n]\n",
  "GENTLEMAN": "a man of good birth or high social standing, also GEMMAN [n GENTLEMEN]\n",
  "GENTLEMANHOOD": "the state of being a gentleman [n -S]\n",
  "GENTLEMANHOODS": "GENTLEMANHOOD, the state of being a gentleman [n]\n",
  "GENTLEMANLIER": "GENTLEMANLY, like a gentleman [adj]\n",
  "GENTLEMANLIEST": "GENTLEMANLY, like a gentleman [adj]\n",
  "GENTLEMANLIKE": "like a gentleman [adj]\n",
  "GENTLEMANLINESS": "the state of being gentlemanly [n]\n",
  "GENTLEMANLY": "like a gentleman [adj GENTLEMANLIER, GENTLEMANLIEST]\n",
  "GENTLEMANSHIP": "the state of being a gentleman [n -S]\n",
  "GENTLEMANSHIPS": "GENTLEMANSHIP, the state of being a gentleman [n]\n",
  "GENTLEMEN": "GENTLEMAN, a man of good birth or high social standing, also GEMMAN [n]\n",
  "GENTLENESS": "the state of being gentle, also GENTLENESSE [n -ES]\n",
  "GENTLENESSE": "(archaic) gentleness, also GENTLENESS [n -S]\n",
  "GENTLENESSES": "GENTLENESSE, (archaic) gentleness, also GENTLENESS [n]\n",
  "GENTLEPERSON": "a gentleman or lady [n -S]\n",
  "GENTLEPERSONS": "GENTLEPERSON, a gentleman or lady [n]\n",
  "GENTLER": "GENTLE, mild and refined in manners [adj]\n",
  "GENTLES": "GENTLE, to tame [v]\n",
  "GENTLEST": "GENTLE, mild and refined in manners [adj]\n",
  "GENTLEWOMAN": "a woman of good breeding and refinement, a lady [n GENTLEWOMEN]\n",
  "GENTLEWOMANLIER": "GENTLEWOMANLY, like a gentlewoman [adj]\n",
  "GENTLEWOMANLY": "like a gentlewoman [adj GENTLEWOMANLIER]\n",
  "GENTLEWOMEN": "GENTLEWOMAN, a woman of good breeding and refinement, a lady [n]\n",
  "GENTLING": "GENTLE, to tame [v]\n",
  "GENTLY": "GENTLE, mild and refined in manners [adv]\n",
  "GENTOO": "(Portuguese) a Falkland Island penguin [n -S]\n",
  "GENTOOS": "GENTOO, (Portuguese) a Falkland Island penguin [n]\n",
  "GENTRICE": "(archaic) gentle birth, breeding [n -S]\n",
  "GENTRICES": "GENTRICE, (archaic) gentle birth, breeding [n]\n",
  "GENTRIES": "GENTRY, the class of people next below the rank of nobility [n]\n",
  "GENTRIFICATION": "the movement of the middle class to a working class area [n -S]\n",
  "GENTRIFICATIONS": "GENTRIFICATION, the movement of the middle class to a working class area [n]\n",
  "GENTRIFIED": "GENTRIFY, to renew an area to attract middle-class residents [v]\n",
  "GENTRIFIER": "one who gentrifies [n -S]\n",
  "GENTRIFIERS": "GENTRIFIER, one who gentrifies [n]\n",
  "GENTRIFIES": "GENTRIFY, to renew an area to attract middle-class residents [v]\n",
  "GENTRIFY": "to renew an area to attract middle-class residents [v GENTRIFIED, GENTRIFYING, GENTRIFIES]\n",
  "GENTRIFYING": "GENTRIFY, to renew an area to attract middle-class residents [v]\n",
  "GENTRY": "the class of people next below the rank of nobility [n GENTRIES]\n",
  "GENTS": "GENT, (short for) gentleman [n]\n",
  "GENTY": "neat, trim [adj GENTIER, GENTIEST]\n",
  "GENU": "(Latin) the knee [n GENUS or GENUA]\n",
  "GENUA": "GENU, (Latin) the knee [n]\n",
  "GENUFLECT": "to bend the knee and lower the body, esp. in reverence [v -ED, -ING, -S]\n",
  "GENUFLECTED": "GENUFLECT, to bend the knee and lower the body, esp. in reverence [v]\n",
  "GENUFLECTING": "GENUFLECT, to bend the knee and lower the body, esp. in reverence [v]\n",
  "GENUFLECTION": "the act of bending the knee, also GENUFLEXION [n -S]\n",
  "GENUFLECTIONS": "GENUFLECTION, the act of bending the knee, also GENUFLEXION [n]\n",
  "GENUFLECTOR": "one who genuflects [n -S]\n",
  "GENUFLECTORS": "GENUFLECTOR, one who genuflects [n]\n",
  "GENUFLECTS": "GENUFLECT, to bend the knee and lower the body, esp. in reverence [v]\n",
  "GENUFLEXION": "the bending of the knees in respect or worship, also GENUFLECTION [n -S]\n",
  "GENUFLEXIONS": "GENUFLEXION, the bending of the knees in respect or worship, also GENUFLECTION [n]\n",
  "GENUINE": "authentic [adj]\n",
  "GENUINELY": "GENUINE, authentic [adv]\n",
  "GENUINENESS": "the state of being genuine [n -ES]\n",
  "GENUINENESSES": "GENUINENESS, the state of being genuine [n]\n",
  "GENUS": "(Latin) a taxonomic group of lower rank than a family [n GENERA or GENUSES]\n",
  "GENUSES": "GENUS, (Latin) a taxonomic group of lower rank than a family [n]\n",
  "GEO": "a gully or creek, also GIO, GOE [n -S]\n",
  "GEOBOTANIC": "relating to geobotany, the geographical study of plant distribution, also GEOBOTANICAL [adj]\n",
  "GEOBOTANICAL": "relating to geobotany, the geographical study of plant distribution, also GEOBOTANIC [adj]\n",
  "GEOBOTANIES": "GEOBOTANY, the geographical study of plant distribution, aka phytogeography [n]\n",
  "GEOBOTANIST": "a student of geobotany [n -S]\n",
  "GEOBOTANISTS": "GEOBOTANIST, a student of geobotany [n]\n",
  "GEOBOTANY": "the geographical study of plant distribution, aka phytogeography [n GEOBOTANIES]\n",
  "GEOCACHE": "to search for hidden objects using GPS [v GEOCACHED, GEOCACHING, GEOCACHES]\n",
  "GEOCACHED": "GEOCACHE, to search for hidden objects using GPS [v]\n",
  "GEOCACHER": "one who engages in geocaching [n -S]\n",
  "GEOCACHERS": "GEOCACHER, one who engages in geocaching [n]\n",
  "GEOCACHES": "GEOCACHE, to search for hidden objects using GPS [v]\n",
  "GEOCACHING": "a treasure hunting game where you use a GPS to hide and seek containers with other participants in the activity [n -S]\n",
  "GEOCACHINGS": "GEOCACHING, a treasure hunting game where you use a GPS to hide and seek containers with other participants in the activity [n]\n",
  "GEOCARPIC": "of fruit, ripening underground [adj]\n",
  "GEOCARPIES": "GEOCARPY, a ripening of fruit underground [n]\n",
  "GEOCARPY": "a ripening of fruit underground [n GEOCARPIES]\n",
  "GEOCENTRIC": "having the earth for centre, also GEOCENTRICAL [adj GEOCENTRICALLY]\n",
  "GEOCENTRICAL": "having the earth for centre, also GEOCENTRIC [adj GEOCENTRICALLY]\n",
  "GEOCENTRICALLY": "GEOCENTRICAL, having the earth for centre, also GEOCENTRIC [adv]\n",
  "GEOCENTRICISM": "the belief that the earth is the centre of the universe [n -S]\n",
  "GEOCENTRICISMS": "GEOCENTRICISM, the belief that the earth is the centre of the universe [n]\n",
  "GEOCHEMICAL": "relating to geochemistry [adj GEOCHEMICALLY]\n",
  "GEOCHEMICALLY": "GEOCHEMICAL, relating to geochemistry [adv]\n",
  "GEOCHEMIST": "one who studies the chemistry of the earth's crust [n -S]\n",
  "GEOCHEMISTRIES": "GEOCHEMISTRY, the study of the chemistry of the earth's crust [n]\n",
  "GEOCHEMISTRY": "the study of the chemistry of the earth's crust [n GEOCHEMISTRIES]\n",
  "GEOCHEMISTS": "GEOCHEMIST, one who studies the chemistry of the earth's crust [n]\n",
  "GEOCHRONOLOGIC": "relating to geochronology [adj]\n",
  "GEOCHRONOLOGIES": "GEOCHRONOLOGY, the study of measuring geological time [n]\n",
  "GEOCHRONOLOGIST": "one who studies geochronology [n]\n",
  "GEOCHRONOLOGY": "the study of measuring geological time [n GEOCHRONOLOGIES]\n",
  "GEOCODE": "to assign geographical coordinates to (a digital data set) [v GEOCODED, GEOCODING, GEOCODES]\n",
  "GEOCODED": "GEOCODE, to assign geographical coordinates to (a digital data set) [v]\n",
  "GEOCODES": "GEOCODE, to assign geographical coordinates to (a digital data set) [v]\n",
  "GEOCODING": "GEOCODE, to assign geographical coordinates to (a digital data set) [v]\n",
  "GEOCORONA": "an outer layer of the earth's atmosphere [n GEOCORONAS or GEOCORONAE]\n",
  "GEOCORONAE": "GEOCORONA, an outer layer of the earth's atmosphere [n]\n",
  "GEOCORONAS": "GEOCORONA, an outer layer of the earth's atmosphere [n]\n",
  "GEODATA": "information about the geographical location of objects [n]\n",
  "GEODE": "a roughly spherical stone, hollow or partially hollow, containing an accumulation of mineral matter [n -S]\n",
  "GEODEMOGRAPHICS": "the study and grouping of the people in a geographical area according to socioeconomic criteria, esp. for market research [n]\n",
  "GEODES": "GEODE, a roughly spherical stone, hollow or partially hollow, containing an accumulation of mineral matter [n]\n",
  "GEODESIC": "allowing for the earth's curvature [adj] / a geodesic line [n -S]\n",
  "GEODESICAL": "of or pertaining to geodesy, also GEODETIC, GEODETICAL [adj]\n",
  "GEODESICS": "GEODESIC, a geodesic line [n]\n",
  "GEODESIES": "GEODESY, the branch of mathematics that deals with the shape and area of the earth [n]\n",
  "GEODESIST": "one versed in geodesy, the branch of mathematics that deals with the shape and area of the earth [n -S]\n",
  "GEODESISTS": "GEODESIST, one versed in geodesy, the branch of mathematics that deals with the shape and area of the earth [n]\n",
  "GEODESY": "the branch of mathematics that deals with the shape and area of the earth [n GEODESIES]\n",
  "GEODETIC": "of or pertaining to geodesy, also GEODESICAL, GEODETICAL [adj GEODETICALLY] / a geodesic line [n -S]\n",
  "GEODETICAL": "of or pertaining to geodesy, also GEODESICAL, GEODETIC [adj GEODETICALLY]\n",
  "GEODETICALLY": "GEODETICAL, of or pertaining to geodesy, also GEODESICAL, GEODETIC [adv]\n",
  "GEODETICS": "GEODETIC, a geodesic line [n]\n",
  "GEODIC": "pertaining to a geode (a type of rock) [adj]\n",
  "GEODUCK": "(Native American) a large edible clam, also GWEDUC, GWEDUCK [n -S]\n",
  "GEODUCKS": "GEODUCK, (Native American) a large edible clam, also GWEDUC, GWEDUCK [n]\n",
  "GEODYNAMIC": "related to geodynamics, the study of the dynamic processes and forces within the earth [adj]\n",
  "GEODYNAMICAL": "related to geodynamics, the study of the dynamic processes and forces within the earth [adj]\n",
  "GEODYNAMICIST": "a student of geodynamics, the study of the dynamic processes and forces within the earth [n -S]\n",
  "GEODYNAMICISTS": "GEODYNAMICIST, a student of geodynamics, the study of the dynamic processes and forces within the earth [n]\n",
  "GEODYNAMICS": "the study of the dynamic processes and forces within the earth [n]\n",
  "GEOENGINEERING": "the application of scientific processes to affect the global environment, esp. in order to counter the effects of climate change [n -S]\n",
  "GEOENGINEERINGS": "GEOENGINEERING, the application of scientific processes to affect the global environment, esp. in order to counter the effects of climate change [n]\n",
  "GEOFACT": "a rock chipped naturally that looks like a manmade artifact [n -S]\n",
  "GEOFACTS": "GEOFACT, a rock chipped naturally that looks like a manmade artifact [n]\n",
  "GEOGENIES": "GEOGENY, the science of the formation of the earth's crust, also GEOGONY [n]\n",
  "GEOGENY": "the science of the formation of the earth's crust, also GEOGONY [n GEOGENIES]\n",
  "GEOGNOSES": "GEOGNOSIS, knowledge of the earth [n]\n",
  "GEOGNOSIES": "GEOGNOSY, a branch of geology, knowledge of the general structure of the earth [n]\n",
  "GEOGNOSIS": "knowledge of the earth [n GEOGNOSES]\n",
  "GEOGNOST": "one versed in geognosy, knowledge of the general structure of the earth [n -S]\n",
  "GEOGNOSTIC": "relating to geognosy, knowledge of the structure of the earth, also GEOGNOSTICAL [adj GEOGNOSTICALLY]\n",
  "GEOGNOSTICAL": "relating to geognosy, knowledge of the structure of the earth, also GEOGNOSTIC [adj GEOGNOSTICALLY]\n",
  "GEOGNOSTICALLY": "GEOGNOSTICAL, relating to geognosy, knowledge of the structure of the earth, also GEOGNOSTIC [adv]\n",
  "GEOGNOSTS": "GEOGNOST, one versed in geognosy, knowledge of the general structure of the earth [n]\n",
  "GEOGNOSY": "a branch of geology, knowledge of the general structure of the earth [n GEOGNOSIES]\n",
  "GEOGONIC": "relating to geogony, the study of formation of the earth [adj]\n",
  "GEOGONIES": "GEOGONY, the theory of the formation of the earth [n]\n",
  "GEOGONY": "the theory of the formation of the earth [n GEOGONIES]\n",
  "GEOGRAPHER": "a specialist in geography [n -S]\n",
  "GEOGRAPHERS": "GEOGRAPHER, a specialist in geography [n]\n",
  "GEOGRAPHIC": "of or relating to geography, also GEOGRAPHICAL [adj GEOGRAPHICALLY]\n",
  "GEOGRAPHICAL": "of or relating to geography, also GEOGRAPHIC [adj GEOGRAPHICALLY]\n",
  "GEOGRAPHICALLY": "GEOGRAPHICAL, of or relating to geography, also GEOGRAPHIC [adv]\n",
  "GEOGRAPHIES": "GEOGRAPHY, the study of the earth's physical and human features [n]\n",
  "GEOGRAPHY": "the study of the earth's physical and human features [n GEOGRAPHIES]\n",
  "GEOHYDROLOGIC": "relating to geohydrology [adj]\n",
  "GEOHYDROLOGIES": "GEOHYDROLOGY, a science that deals with the character, source, and mode of occurrence of underground water [n]\n",
  "GEOHYDROLOGIST": "one who studies geohydrology [n -S]\n",
  "GEOHYDROLOGISTS": "GEOHYDROLOGIST, one who studies geohydrology [n]\n",
  "GEOHYDROLOGY": "a science that deals with the character, source, and mode of occurrence of underground water [n GEOHYDROLOGIES]\n",
  "GEOID": "the figure of the earth's mean sea-level surface assumed to be continued under the land [n -S]\n",
  "GEOIDAL": "relating to a geoid, the figure of the earth's mean sea-level surface assumed to be continued under the land [adj]\n",
  "GEOIDS": "GEOID, the figure of the earth's mean sea-level surface assumed to be continued under the land [n]\n",
  "GEOLATRIES": "GEOLATRY, earth-worship [n]\n",
  "GEOLATRY": "earth-worship [n GEOLATRIES]\n",
  "GEOLINGUISTICS": "the study of language in relation to geography [n]\n",
  "GEOLOCATION": "the use of technology to identify the geographical location of an internet user [n -S]\n",
  "GEOLOCATIONS": "GEOLOCATION, the use of technology to identify the geographical location of an internet user [n]\n",
  "GEOLOGER": "a geologist, also GEOLOGIAN [n -S]\n",
  "GEOLOGERS": "GEOLOGER, a geologist, also GEOLOGIAN [n]\n",
  "GEOLOGIAN": "a geologist, also GEOLOGER [n -S]\n",
  "GEOLOGIANS": "GEOLOGIAN, a geologist, also GEOLOGER [n]\n",
  "GEOLOGIC": "relating to geology, also GEOLOGICAL [adj GEOLOGICALLY]\n",
  "GEOLOGICAL": "relating to geology, also GEOLOGIC [adj GEOLOGICALLY]\n",
  "GEOLOGICALLY": "GEOLOGICAL, relating to geology, also GEOLOGIC [adv]\n",
  "GEOLOGIES": "GEOLOGY, the science of the origin and structure of the earth [n]\n",
  "GEOLOGISE": "to engage in geology, also GEOLOGIZE [v GEOLOGISED, GEOLOGISING, GEOLOGISES]\n",
  "GEOLOGISED": "GEOLOGISE, to engage in geology, also GEOLOGIZE [v]\n",
  "GEOLOGISES": "GEOLOGISE, to engage in geology, also GEOLOGIZE [v]\n",
  "GEOLOGISING": "GEOLOGISE, to engage in geology, also GEOLOGIZE [v]\n",
  "GEOLOGIST": "one who studies geology [n -S]\n",
  "GEOLOGISTS": "GEOLOGIST, one who studies geology [n]\n",
  "GEOLOGIZE": "to engage in geology, also GEOLOGISE [v GEOLOGIZED, GEOLOGIZING, GEOLOGIZES]\n",
  "GEOLOGIZED": "GEOLOGIZE, to engage in geology, also GEOLOGISE [v]\n",
  "GEOLOGIZES": "GEOLOGIZE, to engage in geology, also GEOLOGISE [v]\n",
  "GEOLOGIZING": "GEOLOGIZE, to engage in geology, also GEOLOGISE [v]\n",
  "GEOLOGY": "the science of the origin and structure of the earth [n GEOLOGIES]\n",
  "GEOMAGNETIC": "of or relating to terrestrial magnetism [adj GEOMAGNETICALLY]\n",
  "GEOMAGNETICALLY": "GEOMAGNETIC, of or relating to terrestrial magnetism [adv]\n",
  "GEOMAGNETISM": "the state of being geomagnetic [n -S]\n",
  "GEOMAGNETISMS": "GEOMAGNETISM, the state of being geomagnetic [n]\n",
  "GEOMAGNETIST": "a student of geomagnetism [n -S]\n",
  "GEOMAGNETISTS": "GEOMAGNETIST, a student of geomagnetism [n]\n",
  "GEOMANCER": "one who practises geomancy, also GEOMANT [n -S]\n",
  "GEOMANCERS": "GEOMANCER, one who practises geomancy, also GEOMANT [n]\n",
  "GEOMANCIES": "GEOMANCY, telling the future from geographical features [n]\n",
  "GEOMANCY": "telling the future from geographical features [n GEOMANCIES]\n",
  "GEOMANT": "one who practises geomancy, also GEOMANCER [n -S]\n",
  "GEOMANTIC": "relating to geomancy, divination by casting earth onto a surface [adj]\n",
  "GEOMANTS": "GEOMANT, one who practises geomancy, also GEOMANCER [n]\n",
  "GEOMATICS": "the mathematical study of geographical data [n]\n",
  "GEOMECHANICS": "the study and application of rock and soil mechanics [n]\n",
  "GEOMEDICAL": "relating to geomedicine, the study of diseases as influenced by the geographical environment [adj]\n",
  "GEOMEDICINE": "the study of diseases as influenced by the geographical environment [n -S]\n",
  "GEOMEDICINES": "GEOMEDICINE, the study of diseases as influenced by the geographical environment [n]\n",
  "GEOMETER": "a specialist in geometry [n -S]\n",
  "GEOMETERS": "GEOMETER, a specialist in geometry [n]\n",
  "GEOMETRIC": "related to geometry, also GEOMETRICAL [adj GEOMETRICALLY]\n",
  "GEOMETRICAL": "related to geometry, also GEOMETRIC [adj GEOMETRICALLY]\n",
  "GEOMETRICALLY": "GEOMETRICAL, related to geometry, also GEOMETRIC [adv]\n",
  "GEOMETRICIAN": "a geometer [n -S]\n",
  "GEOMETRICIANS": "GEOMETRICIAN, a geometer [n]\n",
  "GEOMETRICS": "the study of simple figures [n]\n",
  "GEOMETRID": "any moth of the Geometridae, whose caterpillars are loopers [n -S]\n",
  "GEOMETRIDS": "GEOMETRID, any moth of the Geometridae, whose caterpillars are loopers [n]\n",
  "GEOMETRIES": "GEOMETRY, a branch of mathematics [n]\n",
  "GEOMETRISATION": "the process of geometrising, also GEOMETRIZATION [n -S]\n",
  "GEOMETRISATIONS": "GEOMETRISATION, the process of geometrising, also GEOMETRIZATION [n]\n",
  "GEOMETRISE": "to work geometrically; to show in geometric form, also GEOMETRIZE [v GEOMETRISED, GEOMETRISING, GEOMETRISES]\n",
  "GEOMETRISED": "GEOMETRISE, to work geometrically; to show in geometric form, also GEOMETRIZE [v]\n",
  "GEOMETRISES": "GEOMETRISE, to work geometrically; to show in geometric form, also GEOMETRIZE [v]\n",
  "GEOMETRISING": "GEOMETRISE, to work geometrically; to show in geometric form, also GEOMETRIZE [v]\n",
  "GEOMETRIST": "one who practises geometry [n -S]\n",
  "GEOMETRISTS": "GEOMETRIST, one who practises geometry [n]\n",
  "GEOMETRIZATION": "the act of geometrizing, also GEOMETRISATION [n -S]\n",
  "GEOMETRIZATIONS": "GEOMETRIZATION, the act of geometrizing, also GEOMETRISATION [n]\n",
  "GEOMETRIZE": "to work geometrically; to show in geometric form, also GEOMETRISE [v GEOMETRIZED, GEOMETRIZING, GEOMETRIZES]\n",
  "GEOMETRIZED": "GEOMETRIZE, to work geometrically; to show in geometric form, also GEOMETRISE [v]\n",
  "GEOMETRIZES": "GEOMETRIZE, to work geometrically; to show in geometric form, also GEOMETRISE [v]\n",
  "GEOMETRIZING": "GEOMETRIZE, to work geometrically; to show in geometric form, also GEOMETRISE [v]\n",
  "GEOMETRY": "a branch of mathematics [n GEOMETRIES]\n",
  "GEOMORPHIC": "earth-shaped [adj]\n",
  "GEOMORPHOGENIC": "related to geomorphogeny, the study of the origins of land forms [adj]\n",
  "GEOMORPHOGENIES": "GEOMORPHOGENY, the study of the origins of land forms [n]\n",
  "GEOMORPHOGENIST": "a student of geomorphogeny, the study of the origins of land forms [n]\n",
  "GEOMORPHOGENY": "the study of the origins of land forms [n GEOMORPHOGENIES]\n",
  "GEOMORPHOLOGIC": "related to geomorphology, the study of the landscapes of the earth and their development [adj]\n",
  "GEOMORPHOLOGIES": "GEOMORPHOLOGY, the study of the landscapes of the earth and their development [n]\n",
  "GEOMORPHOLOGIST": "one who studies geomorphology [n]\n",
  "GEOMORPHOLOGY": "the study of the landscapes of the earth and their development [n GEOMORPHOLOGIES]\n",
  "GEOMYOID": "pertaining to American pouched rats [adj]\n",
  "GEONOMICS": "a doctrine holding that humans own what is created by them, but that those things found in nature, such as land, belong to no one person but instead belong equally to all mankind [n]\n",
  "GEOPHAGIA": "the practice of feeding on soil, also GEOPHAGY [n -S]\n",
  "GEOPHAGIAS": "GEOPHAGIA, the practice of feeding on soil, also GEOPHAGY [n]\n",
  "GEOPHAGIES": "GEOPHAGY, the practice of eating earthy substances, also GEOPHAGIA [n]\n",
  "GEOPHAGISM": "the act or habit of eating earth [n -S]\n",
  "GEOPHAGISMS": "GEOPHAGISM, the act or habit of eating earth [n]\n",
  "GEOPHAGIST": "one who eats earth, as dirt, clay, chalk, etc. [n -S]\n",
  "GEOPHAGISTS": "GEOPHAGIST, one who eats earth, as dirt, clay, chalk, etc. [n]\n",
  "GEOPHAGOUS": "earth-eating [adj]\n",
  "GEOPHAGY": "the practice of eating earthy substances, also GEOPHAGIA [n GEOPHAGIES]\n",
  "GEOPHILIC": "loving the earth [adj]\n",
  "GEOPHILOUS": "living in or near the ground [adj]\n",
  "GEOPHONE": "(tradename) an instrument used to pick up vibrations passing through soil, rocks or ice [n -S]\n",
  "GEOPHONES": "GEOPHONE, (tradename) an instrument used to pick up vibrations passing through soil, rocks or ice [n]\n",
  "GEOPHYSICAL": "relating to geophysics [adj GEOPHYSICALLY]\n",
  "GEOPHYSICALLY": "GEOPHYSICAL, relating to geophysics [adv]\n",
  "GEOPHYSICIST": "a student of geophysics [n -S]\n",
  "GEOPHYSICISTS": "GEOPHYSICIST, a student of geophysics [n]\n",
  "GEOPHYSICS": "the study of the earth's physical properties [n]\n",
  "GEOPHYTE": "a plant that survives the winter by having subterranean buds e.g. bulbs, corms or rhizomes [n -S]\n",
  "GEOPHYTES": "GEOPHYTE, a plant that survives the winter by having subterranean buds e.g. bulbs, corms or rhizomes [n]\n",
  "GEOPHYTIC": "of or like a geophyte, a plant that survives the winter by having subterranean buds [adj]\n",
  "GEOPOLITICAL": "relating to geopolitics [adj GEOPOLITICALLY]\n",
  "GEOPOLITICALLY": "GEOPOLITICAL, relating to geopolitics [adv]\n",
  "GEOPOLITICIAN": "a specialist in geopolitics [n -S]\n",
  "GEOPOLITICIANS": "GEOPOLITICIAN, a specialist in geopolitics [n]\n",
  "GEOPOLITICS": "the study of the relationship between the geographical situation and the politics of a nation [n]\n",
  "GEOPONIC": "of or relating to agriculture, also GEOPONICAL [adj]\n",
  "GEOPONICAL": "of or relating to agriculture, also GEOPONIC [adj]\n",
  "GEOPONICS": "the study of agriculture [n]\n",
  "GEOPRESSURED": "subjected to great pressure from geologic forces [adj]\n",
  "GEOPROBE": "a spacecraft which explores space near the earth [n -S]\n",
  "GEOPROBES": "GEOPROBE, a spacecraft which explores space near the earth [n]\n",
  "GEORGETTE": "(French) a kind of thin silk [n -S]\n",
  "GEORGETTES": "GEORGETTE, (French) a kind of thin silk [n]\n",
  "GEORGIC": "(Latin) a poem on husbandry or rural affairs [n -S]\n",
  "GEORGICAL": "agricultural [adj]\n",
  "GEORGICS": "GEORGIC, (Latin) a poem on husbandry or rural affairs [n]\n",
  "GEOS": "GEO, a gully or creek, also GIO, GOE [n]\n",
  "GEOSCIENCE": "a science, such as geology, which deals with some aspect of the earth [n -S]\n",
  "GEOSCIENCES": "GEOSCIENCE, a science, such as geology, which deals with some aspect of the earth [n]\n",
  "GEOSCIENTIFIC": "related to geoscience [adj]\n",
  "GEOSCIENTIST": "a student of geoscience [n -S]\n",
  "GEOSCIENTISTS": "GEOSCIENTIST, a student of geoscience [n]\n",
  "GEOSPATIAL": "of or relating to the relative position of things on the earth's surface [adj]\n",
  "GEOSPHERE": "the solid part of the earth, as opposed to atmosphere and hydrosphere [n -S]\n",
  "GEOSPHERES": "GEOSPHERE, the solid part of the earth, as opposed to atmosphere and hydrosphere [n]\n",
  "GEOSTATIC": "relating to the pressure exerted by earth or similar substance [adj]\n",
  "GEOSTATICS": "the statics of rigid bodies [n]\n",
  "GEOSTATIONARY": "of or pertaining to a satellite that travels about the earth's equator at an altitude of at least 35,000 kilometers at a speed matching that of the earth's rotation, thus maintaining a constant relation to points on the earth [adj]\n",
  "GEOSTRATEGIC": "related to geostrategy, a branch of geopolitics that deals with strategy, also GEOSTRATEGICAL [adj]\n",
  "GEOSTRATEGICAL": "related to geostrategy, a branch of geopolitics that deals with strategy, also GEOSTRATEGIC [adj]\n",
  "GEOSTRATEGIES": "GEOSTRATEGY, a branch of geopolitics that deals with strategy [n]\n",
  "GEOSTRATEGIST": "one who studies geostrategy [n -S]\n",
  "GEOSTRATEGISTS": "GEOSTRATEGIST, one who studies geostrategy [n]\n",
  "GEOSTRATEGY": "a branch of geopolitics that deals with strategy [n GEOSTRATEGIES]\n",
  "GEOSTROPHIC": "relating to deflection due to effects of Earth's rotation [adj GEOSTROPHICALLY]\n",
  "GEOSTROPHICALLY": "GEOSTROPHIC, relating to deflection due to effects of Earth's rotation [adv]\n",
  "GEOSYNCHRONOUS": "of a satellite, etc., geostationary [adj]\n",
  "GEOSYNCLINAL": "of or like a geosyncline [adj]\n",
  "GEOSYNCLINE": "a down-warping of the Earth's crust [n -S]\n",
  "GEOSYNCLINES": "GEOSYNCLINE, a down-warping of the Earth's crust [n]\n",
  "GEOTACTIC": "relating to geotaxis, the response of an organism to gravity, also GEOTACTICAL [adj GEOTACTICALLY]\n",
  "GEOTACTICAL": "relating to geotaxis, the response of an organism to gravity, also GEOTACTIC [adj GEOTACTICALLY]\n",
  "GEOTACTICALLY": "GEOTACTICAL, relating to geotaxis, the response of an organism to gravity, also GEOTACTIC [adv]\n",
  "GEOTAG": "a digital code that assigns geographical co-ordinates to an item of data [n -S] / to assign a geotag to [v GEOTAGGED, GEOTAGGING, GEOTAGS]\n",
  "GEOTAGGED": "GEOTAG, to assign a geotag to [v]\n",
  "GEOTAGGING": "GEOTAG, to assign a geotag to [v]\n",
  "GEOTAGS": "GEOTAG, to assign a geotag to [v]\n",
  "GEOTAXES": "GEOTAXIS, (Greek) the movement of an organism in response to gravity [n]\n",
  "GEOTAXIS": "(Greek) the movement of an organism in response to gravity [n GEOTAXES]\n",
  "GEOTECHNIC": "relating to geotechnics, the application of scientific and engineering principles to the solution of problems related to the nature and constitution of the earth's crust, also GEOTECHNICAL [adj]\n",
  "GEOTECHNICAL": "relating to geotechnics, the application of scientific and engineering principles to the solution of problems related to the nature and constitution of the earth's crust, also GEOTECHNIC [adj]\n",
  "GEOTECHNICS": "the application of scientific and engineering principles to the solution of problems related to the nature and constitution of the earth's crust [n]\n",
  "GEOTECHNOLOGIES": "GEOTECHNOLOGY, the application of science and technology to the extraction and use of the earth's natural resources [n]\n",
  "GEOTECHNOLOGY": "the application of science and technology to the extraction and use of the earth's natural resources [n GEOTECHNOLOGIES]\n",
  "GEOTECTONIC": "relating to the structure of rock masses of the earth's crust resulting from folding or faulting [adj GEOTECTONICALLY]\n",
  "GEOTECTONICALLY": "GEOTECTONIC, relating to the structure of rock masses of the earth's crust resulting from folding or faulting [adv]\n",
  "GEOTECTONICS": "structural geology [n]\n",
  "GEOTEXTILE": "any strong synthetic fabric used in civil engineering, as to retain an embankment [n -S]\n",
  "GEOTEXTILES": "GEOTEXTILE, any strong synthetic fabric used in civil engineering, as to retain an embankment [n]\n",
  "GEOTHERM": "a line on the earth connecting points of equal temperature [n -S]\n",
  "GEOTHERMAL": "relating to the internal heat of the earth, also GEOTHERMIC [adj GEOTHERMALLY]\n",
  "GEOTHERMALLY": "GEOTHERMAL, relating to the internal heat of the earth, also GEOTHERMIC [adv]\n",
  "GEOTHERMIC": "related to the internal heat of the earth, also GEOTHERMAL [adj]\n",
  "GEOTHERMOMETER": "instrument for measuring subterranean temperatures [n -S]\n",
  "GEOTHERMOMETERS": "GEOTHERMOMETER, instrument for measuring subterranean temperatures [n]\n",
  "GEOTHERMS": "GEOTHERM, a line on the earth connecting points of equal temperature [n]\n",
  "GEOTROPIC": "showing geotropism, a disposition to turn or incline towards the earth [adj GEOTROPICALLY]\n",
  "GEOTROPICALLY": "GEOTROPIC, showing geotropism, a disposition to turn or incline towards the earth [adv]\n",
  "GEOTROPISM": "a disposition to turn or incline towards the earth; the influence of gravity in determining the direction of growth of an organ [n -S]\n",
  "GEOTROPISMS": "GEOTROPISM, a disposition to turn or incline towards the earth; the influence of gravity in determining the direction of growth of an organ [n]\n",
  "GER": "in Mongolia, another name for a yurt, a felt tent [n -S]\n",
  "GERAH": "(Hebrew) a Hebrew unit of weight [n -S]\n",
  "GERAHS": "GERAH, (Hebrew) a Hebrew unit of weight [n]\n",
  "GERANIACEOUS": "belonging to the Geraniaceae, a family of plants with typically hairy stems and beaklike fruits that includes the geranium [adj]\n",
  "GERANIAL": "an alcohol forming a constituent of many of the esters used in perfumery, also GERANIOL [n -S]\n",
  "GERANIALS": "GERANIAL, an alcohol forming a constituent of many of the esters used in perfumery, also GERANIOL [n]\n",
  "GERANIOL": "an alcohol forming a constituent of many of the esters used in perfumery, also GERANIAL [n -S]\n",
  "GERANIOLS": "GERANIOL, an alcohol forming a constituent of many of the esters used in perfumery, also GERANIAL [n]\n",
  "GERANIUM": "a plant of the genus Geranium with seed vessels like a crane's bill [n -S]\n",
  "GERANIUMS": "GERANIUM, a plant of the genus Geranium with seed vessels like a crane's bill [n]\n",
  "GERARDIA": "any of a genus of often root-parasitic herbs of the snapdragon family [n -S]\n",
  "GERARDIAS": "GERARDIA, any of a genus of often root-parasitic herbs of the snapdragon family [n]\n",
  "GERATOLOGICAL": "related to geratology, the branch of medicine concerned with the elderly [adj]\n",
  "GERATOLOGIES": "GERATOLOGY, the branch of medicine concerned with the elderly and the phenomena associated with ageing, also GERONTOLOGY [n]\n",
  "GERATOLOGIST": "a student of geratology [n -S]\n",
  "GERATOLOGISTS": "GERATOLOGIST, a student of geratology [n]\n",
  "GERATOLOGY": "the branch of medicine concerned with the elderly and the phenomena associated with ageing, also GERONTOLOGY [n GERATOLOGIES]\n",
  "GERBE": "(French) a (heraldic) sheaf of wheat, also GARBE [n -S]\n",
  "GERBERA": "a genus of South African plants [n -S]\n",
  "GERBERAS": "GERBERA, a genus of South African plants [n]\n",
  "GERBES": "GERBE, (French) a (heraldic) sheaf of wheat, also GARBE [n]\n",
  "GERBIL": "(French) a desert rodent, also GERBILLE, JERBIL [n -S]\n",
  "GERBILLE": "(French) a desert rodent, also GERBIL, JERBIL [n -S]\n",
  "GERBILLES": "GERBILLE, (French) a desert rodent, also GERBIL, JERBIL [n]\n",
  "GERBILS": "GERBIL, (French) a desert rodent, also GERBILLE, JERBIL [n]\n",
  "GERE": "(Spenser) gear, equipment [n -S]\n",
  "GERENT": "a ruler or manager [n -S]\n",
  "GERENTS": "GERENT, a ruler or manager [n]\n",
  "GERENUK": "(Somali) a long-legged antelope of East Africa [n -S]\n",
  "GERENUKS": "GERENUK, (Somali) a long-legged antelope of East Africa [n]\n",
  "GERES": "GERE, (Spenser) gear, equipment [n]\n",
  "GERFALCON": "a heavy, powerful falcon of cold northerly regions, also GYRFALCON, JERFALCON [n -S]\n",
  "GERFALCONS": "GERFALCON, a heavy, powerful falcon of cold northerly regions, also GYRFALCON, JERFALCON [n]\n",
  "GERIATRIC": "relating to old people [adj] / an old person [n -S]\n",
  "GERIATRICIAN": "a specialist in geriatrics [n -S]\n",
  "GERIATRICIANS": "GERIATRICIAN, a specialist in geriatrics [n]\n",
  "GERIATRICS": "GERIATRIC, an old person [n]\n",
  "GERIATRIST": "one specialising in the care of the elderly, a geriatrician [n -S]\n",
  "GERIATRISTS": "GERIATRIST, one specialising in the care of the elderly, a geriatrician [n]\n",
  "GERLE": "(Spenser) a girl [n -S]\n",
  "GERLES": "GERLE, (Spenser) a girl [n]\n",
  "GERM": "to put forth buds, sprout [v -ED, -ING, -S]\n",
  "GERMAIN": "(Shakespeare) a germ, shoot, also GERMAINE, GERMEN, GERMIN [n -S]\n",
  "GERMAINE": "(Shakespeare) a germ, shoot, also GERMAIN, GERMEN, GERMIN [n -S]\n",
  "GERMAINES": "GERMAINE, (Shakespeare) a germ, shoot, also GERMAIN, GERMEN, GERMIN [n]\n",
  "GERMAINS": "GERMAIN, (Shakespeare) a germ, shoot, also GERMAINE, GERMEN, GERMIN [n]\n",
  "GERMAN": "an elaborate dance [n -S]\n",
  "GERMANDER": "a plant of the genus Teucrium, of mint-like herbs and low shrubs [n -S]\n",
  "GERMANDERS": "GERMANDER, a plant of the genus Teucrium, of mint-like herbs and low shrubs [n]\n",
  "GERMANE": "closely related to; relevant [adj GERMANELY]\n",
  "GERMANELY": "GERMANE, closely related to; relevant [adv]\n",
  "GERMANENESS": "the quality of being germane [n -ES]\n",
  "GERMANENESSES": "GERMANENESS, the quality of being germane [n]\n",
  "GERMANIC": "containing germanium (a metallic element) [adj]\n",
  "GERMANISATION": "the act of germanising, also GERMANIZATION [n -S]\n",
  "GERMANISATIONS": "GERMANISATION, the act of germanising, also GERMANIZATION [n]\n",
  "GERMANISE": "to make German, also GERMANIZE [v GERMANISED, GERMANISING, GERMANISES]\n",
  "GERMANISED": "GERMANISE, to make German, also GERMANIZE [v]\n",
  "GERMANISES": "GERMANISE, to make German, also GERMANIZE [v]\n",
  "GERMANISING": "GERMANISE, to make German, also GERMANIZE [v]\n",
  "GERMANITE": "a complex mineral, basically copper arsenic sulphide [n -S]\n",
  "GERMANITES": "GERMANITE, a complex mineral, basically copper arsenic sulphide [n]\n",
  "GERMANIUM": "a metallic element, much used in diodes and transistors as a semiconductor [n -S]\n",
  "GERMANIUMS": "GERMANIUM, a metallic element, much used in diodes and transistors as a semiconductor [n]\n",
  "GERMANIZATION": "the act of germanizing, also GERMANISATION [n -S]\n",
  "GERMANIZATIONS": "GERMANIZATION, the act of germanizing, also GERMANISATION [n]\n",
  "GERMANIZE": "to make German, also GERMANISE [v GERMANIZED, GERMANIZING, GERMANIZES]\n",
  "GERMANIZED": "GERMANIZE, to make German, also GERMANISE [v]\n",
  "GERMANIZES": "GERMANIZE, to make German, also GERMANISE [v]\n",
  "GERMANIZING": "GERMANIZE, to make German, also GERMANISE [v]\n",
  "GERMANOUS": "of or containing germanium in the divalent state [adj]\n",
  "GERMANS": "GERMAN, an elaborate dance [n]\n",
  "GERMED": "GERM, to put forth buds, sprout [v]\n",
  "GERMEN": "something that serves as an origin, also GERMAIN, GERMAINE, GERMIN [n GERMENS or GERMINA]\n",
  "GERMENS": "GERMEN, something that serves as an origin, also GERMAIN, GERMAINE, GERMIN [n]\n",
  "GERMFREE": "free of germs [adj]\n",
  "GERMICIDAL": "of or relating to a germicide [adj]\n",
  "GERMICIDE": "a substance that kills germs [n -S]\n",
  "GERMICIDES": "GERMICIDE, a substance that kills germs [n]\n",
  "GERMIER": "GERMY, full of germs [adj]\n",
  "GERMIEST": "GERMY, full of germs [adj]\n",
  "GERMIN": "something that serves as an origin, also GERMEN, GERMAIN, GERMAINE [n -S]\n",
  "GERMINA": "GERMEN, something that serves as an origin, also GERMAIN, GERMAINE, GERMIN [n]\n",
  "GERMINABILITIES": "GERMINABILITY, the capacity to germinate [n]\n",
  "GERMINABILITY": "the capacity to germinate [n GERMINABILITIES]\n",
  "GERMINABLE": "capable of being germinated [adj]\n",
  "GERMINAL": "being in the highest stage of development [adj GERMINALLY]\n",
  "GERMINALLY": "GERMINAL, being in the highest stage of development [adv]\n",
  "GERMINANT": "sprouting; sending forth germs or buds [adj]\n",
  "GERMINATE": "to sprout, to cause to sprout [v GERMINATED, GERMINATING, GERMINATES]\n",
  "GERMINATED": "GERMINATE, to sprout, to cause to sprout [v]\n",
  "GERMINATES": "GERMINATE, to sprout, to cause to sprout [v]\n",
  "GERMINATING": "GERMINATE, to sprout, to cause to sprout [v]\n",
  "GERMINATION": "the process by which a seedling emerges and develops from a seed [n -S]\n",
  "GERMINATIONS": "GERMINATION, the process by which a seedling emerges and develops from a seed [n]\n",
  "GERMINATIVE": "serving to germinate [adj]\n",
  "GERMINATOR": "one who germinates [n -S]\n",
  "GERMINATORS": "GERMINATOR, one who germinates [n]\n",
  "GERMINESS": "the state of being germy [n -ES]\n",
  "GERMINESSES": "GERMINESS, the state of being germy [n]\n",
  "GERMING": "GERM, to put forth buds, sprout [v]\n",
  "GERMINS": "GERMIN, something that serves as an origin, also GERMEN, GERMAIN, GERMAINE [n]\n",
  "GERMLIKE": "like a germ [adj]\n",
  "GERMPLASM": "plant genetic material [n -S]\n",
  "GERMPLASMS": "GERMPLASM, plant genetic material [n]\n",
  "GERMPROOF": "proof against germs [adj]\n",
  "GERMS": "GERM, to put forth buds, sprout [v]\n",
  "GERMY": "full of germs [adj GERMIER, GERMIEST]\n",
  "GERNE": "(Spenser) to grin or gape, also GIRN, GURN [v GERNED, GERNING, GERNES]\n",
  "GERNED": "GERNE, (Spenser) to grin or gape, also GIRN, GURN [v]\n",
  "GERNES": "GERNE, (Spenser) to grin or gape, also GIRN, GURN [v]\n",
  "GERNING": "GERNE, (Spenser) to grin or gape, also GIRN, GURN [v]\n",
  "GERONIMO": "a shout given by US paratroopers as they jump into battle [interj]\n",
  "GERONTIC": "pertaining to old age [adj]\n",
  "GERONTOCRACIES": "GERONTOCRACY, government by the aged [n]\n",
  "GERONTOCRACY": "government by the aged [n GERONTOCRACIES]\n",
  "GERONTOCRAT": "a member of a gerontocracy, government by the aged [n -S]\n",
  "GERONTOCRATIC": "relating to gerontocracy [adj]\n",
  "GERONTOCRATS": "GERONTOCRAT, a member of a gerontocracy, government by the aged [n]\n",
  "GERONTOLOGIC": "relating to gerontology, also GERONTOLOGICAL [adj]\n",
  "GERONTOLOGICAL": "relating to gerontology, also GERONTOLOGIC [adj]\n",
  "GERONTOLOGIES": "GERONTOLOGY, the scientific study of aging, also GERATOLOGY [n]\n",
  "GERONTOLOGIST": "one who studies gerontology [n -S]\n",
  "GERONTOLOGISTS": "GERONTOLOGIST, one who studies gerontology [n]\n",
  "GERONTOLOGY": "the scientific study of aging, also GERATOLOGY [n GERONTOLOGIES]\n",
  "GERONTOMORPHIC": "of, pertaining to, or designating anatomical specialization most fully represented in the mature male of a species [adj]\n",
  "GERONTOPHIL": "a person who experiences gerontophilia, a sexual attraction towards old people, also GERONTOPHILE [n -S]\n",
  "GERONTOPHILE": "a person who experiences gerontophilia, a sexual attraction towards old people, also GERONTOPHIL [n -S]\n",
  "GERONTOPHILES": "GERONTOPHILE, a person who experiences gerontophilia, a sexual attraction towards old people, also GERONTOPHIL [n]\n",
  "GERONTOPHILIA": "sexual attraction towards the elderly [n -S]\n",
  "GERONTOPHILIAS": "GERONTOPHILIA, sexual attraction towards the elderly [n]\n",
  "GERONTOPHILS": "GERONTOPHIL, a person who experiences gerontophilia, a sexual attraction towards old people, also GERONTOPHILE [n]\n",
  "GERONTOPHOBE": "one with a morbid fear of old age [n -S]\n",
  "GERONTOPHOBES": "GERONTOPHOBE, one with a morbid fear of old age [n]\n",
  "GERONTOPHOBIA": "a fear of old age or of growing old [n -S]\n",
  "GERONTOPHOBIAS": "GERONTOPHOBIA, a fear of old age or of growing old [n]\n",
  "GEROPIGA": "(Portuguese) a sweet fortified wine similar to port, also JEREPIGO [n -S]\n",
  "GEROPIGAS": "GEROPIGA, (Portuguese) a sweet fortified wine similar to port, also JEREPIGO [n]\n",
  "GERRYMANDER": "to rearrange (voting districts) in the interests of a particular party or candidate, also JERRYMANDER [v -ED, -ING, -S]\n",
  "GERRYMANDERED": "GERRYMANDER, to rearrange (voting districts) in the interests of a particular party or candidate, also JERRYMANDER [v]\n",
  "GERRYMANDERER": "one who gerrymanders [n -S]\n",
  "GERRYMANDERERS": "GERRYMANDERER, one who gerrymanders [n]\n",
  "GERRYMANDERING": "the process of redistricting voting boundaries to benefit one group over another [n -S]\n",
  "GERRYMANDERINGS": "GERRYMANDERING, the process of redistricting voting boundaries to benefit one group over another [n]\n",
  "GERRYMANDERS": "GERRYMANDER, to rearrange (voting districts) in the interests of a particular party or candidate, also JERRYMANDER [v]\n",
  "GERS": "GER, in Mongolia, another name for a yurt, a felt tent [n]\n",
  "GERT": "(dialect) very big [adj]\n",
  "GERTCHA": "(slang) get away, get along [interj]\n",
  "GERUND": "a verbal form such as 'cooking' that functions as a noun [n -S]\n",
  "GERUNDIAL": "relating to a gerundive, also GERUNDIVAL [adj]\n",
  "GERUNDIVAL": "relating to a gerundive, also GERUNDIAL [adj]\n",
  "GERUNDIVE": "relating to a gerund [adj GERUNDIVELY] / a Latin verbal adjective expressing necessity [n -S]\n",
  "GERUNDIVELY": "GERUNDIVE, relating to a gerund [adv]\n",
  "GERUNDIVES": "GERUNDIVE, a Latin verbal adjective expressing necessity [n]\n",
  "GERUNDS": "GERUND, a verbal form such as 'cooking' that functions as a noun [n]\n",
  "GESELLSCHAFT": "(German) a rationally developed mechanistic type of social relationship characterized by impersonally contracted associations between persons [n GESELLSCHAFTEN or GESELLSCHAFTS]\n",
  "GESELLSCHAFTEN": "GESELLSCHAFT, (German) a rationally developed mechanistic type of social relationship characterized by impersonally contracted associations between persons [n]\n",
  "GESELLSCHAFTS": "GESELLSCHAFT, (German) a rationally developed mechanistic type of social relationship characterized by impersonally contracted associations between persons [n]\n",
  "GESNERIA": "a plant of a tropical American genus Gesneria, also GESNERIAD [n -S]\n",
  "GESNERIAD": "a plant of a tropical American genus Gesneria, also GESNERIA [n -S]\n",
  "GESNERIADS": "GESNERIAD, a plant of a tropical American genus Gesneria, also GESNERIA [n]\n",
  "GESNERIAS": "GESNERIA, a plant of a tropical American genus Gesneria, also GESNERIAD [n]\n",
  "GESSAMINE": "(Milton) jasmine, also JASMIN, JASMINE, JESSAMINE, JESSAMY [n -S]\n",
  "GESSAMINES": "GESSAMINE, (Milton) jasmine, also JASMIN, JASMINE, JESSAMINE, JESSAMY [n]\n",
  "GESSE": "(Spenser) to guess, also GHESSE [v GESSED, GESSING, GESSES]\n",
  "GESSED": "GESSE, (Spenser) to guess, also GHESSE [v]\n",
  "GESSES": "GESSE, (Spenser) to guess, also GHESSE [v]\n",
  "GESSING": "GESSE, (Spenser) to guess, also GHESSE [v]\n",
  "GESSO": "(Italian) plaster of Paris used in painting [n -ES]\n",
  "GESSOED": "having gesso as a coating or as a constituent part [adj]\n",
  "GESSOES": "GESSO, (Italian) plaster of Paris used in painting [n]\n",
  "GEST": "(obsolete) an exploit; a tale of adventure, also GESTE [n -S]\n",
  "GESTALT": "(German) a shape or pattern; most often used in psychology to describe a theory or approach which aims to see something as a whole rather than breaking it into separate parts [n GESTALTS or GESTALTEN]\n",
  "GESTALTEN": "GESTALT, (German) a shape or pattern; most often used in psychology to describe a theory or approach which aims to see something as a whole rather than breaking it into separate parts [n]\n",
  "GESTALTISM": "gestalt psychology [n -S]\n",
  "GESTALTISMS": "GESTALTISM, gestalt psychology [n]\n",
  "GESTALTIST": "an adherent of gestaltism [n -S]\n",
  "GESTALTISTS": "GESTALTIST, an adherent of gestaltism [n]\n",
  "GESTALTS": "GESTALT, (German) a shape or pattern; most often used in psychology to describe a theory or approach which aims to see something as a whole rather than breaking it into separate parts [n]\n",
  "GESTANT": "laden; pregnant [adj]\n",
  "GESTAPO": "(German) a secret police organisation [n -S]\n",
  "GESTAPOS": "GESTAPO, (German) a secret police organisation [n]\n",
  "GESTATE": "to carry in the uterus during pregnancy [v GESTATED, GESTATING, GESTATES]\n",
  "GESTATED": "GESTATE, to carry in the uterus during pregnancy [v]\n",
  "GESTATES": "GESTATE, to carry in the uterus during pregnancy [v]\n",
  "GESTATING": "GESTATE, to carry in the uterus during pregnancy [v]\n",
  "GESTATION": "the process of gestating, bearing in the womb [n -S]\n",
  "GESTATIONAL": "relating to gestation, the process of gestating, bearing in the womb, also GESTATIVE [adj]\n",
  "GESTATIONS": "GESTATION, the process of gestating, bearing in the womb [n]\n",
  "GESTATIVE": "relating to gestation, the process of gestating, bearing in the womb, also GESTATIONAL [adj]\n",
  "GESTATORIAL": "(archaic) related to carrying, also GESTATORY [adj]\n",
  "GESTATORY": "(archaic) relating to carrying, also GESTATORIAL [adj]\n",
  "GESTE": "(obsolete) an exploit; a tale of adventure, also GEST [n -S]\n",
  "GESTES": "GESTE, (obsolete) an exploit; a tale of adventure, also GEST [n]\n",
  "GESTIC": "pertaining to bodily motion, also GESTICAL [adj]\n",
  "GESTICAL": "pertaining to bodily motion, also GESTIC [adj]\n",
  "GESTICULANT": "making gesticulations [adj]\n",
  "GESTICULATE": "to make gestures esp. when speaking [v GESTICULATED, GESTICULATING, GESTICULATES]\n",
  "GESTICULATED": "GESTICULATE, to make gestures esp. when speaking [v]\n",
  "GESTICULATES": "GESTICULATE, to make gestures esp. when speaking [v]\n",
  "GESTICULATING": "GESTICULATE, to make gestures esp. when speaking [v]\n",
  "GESTICULATION": "the act of making gestures [n -S]\n",
  "GESTICULATIONS": "GESTICULATION, the act of making gestures [n]\n",
  "GESTICULATIVE": "relating to gesticulation [adj]\n",
  "GESTICULATOR": "one who gesticulates [n -S]\n",
  "GESTICULATORS": "GESTICULATOR, one who gesticulates [n]\n",
  "GESTICULATORY": "relating to gesticulation [adj]\n",
  "GESTS": "GEST, (obsolete) an exploit; a tale of adventure, also GESTE [n]\n",
  "GESTURAL": "of or relating to gesture, also GESTIC, GESTICAL [adj GESTURALLY]\n",
  "GESTURALLY": "GESTURAL, of or relating to gesture, also GESTIC, GESTICAL [adv]\n",
  "GESTURE": "to express by bodily motion [v GESTURED, GESTURING, GESTURES]\n",
  "GESTURED": "GESTURE, to express by bodily motion [v]\n",
  "GESTURER": "one who gestures [n -S]\n",
  "GESTURERS": "GESTURER, one who gestures [n]\n",
  "GESTURES": "GESTURE, to express by bodily motion [v]\n",
  "GESTURING": "GESTURE, to express by bodily motion [v]\n",
  "GESUNDHEIT": "(German) your health (said to someone who has just sneezed) [interj]\n",
  "GET": "to obtain or acquire [v GOT, GOTTEN, GETTING, GETS] / a Jewish divorce [n GITTIN]\n",
  "GETA": "(Japanese) a Japanese wooden sandal with a thong between the toe [n -S]\n",
  "GETABLE": "able to be got [adj]\n",
  "GETAS": "GETA, (Japanese) a Japanese wooden sandal with a thong between the toe [n]\n",
  "GETATABLE": "(slang) accessible [adj]\n",
  "GETAWAY": "an escape [n -S]\n",
  "GETAWAYS": "GETAWAY, an escape [n]\n",
  "GETOUT": "an excuse to avoid doing something [n -S]\n",
  "GETOUTS": "GETOUT, an excuse to avoid doing something [n]\n",
  "GETS": "GET, to obtain or acquire [v]\n",
  "GETTABLE": "able to be got [adj]\n",
  "GETTER": "to remove traces of gas from a vacuum tube [v -ED, -ING, -S]\n",
  "GETTERED": "GETTER, to remove traces of gas from a vacuum tube [v]\n",
  "GETTERING": "the act of removing traces of gas from a vacuum tube [n -S]\n",
  "GETTERINGS": "GETTERING, the act of removing traces of gas from a vacuum tube [n]\n",
  "GETTERS": "GETTER, to remove traces of gas from a vacuum tube [v]\n",
  "GETTING": "begetting, procreation [n -S]\n",
  "GETTINGS": "GETTING, begetting, procreation [n]\n",
  "GETUP": "a costume [n -S]\n",
  "GETUPS": "GETUP, a costume [n]\n",
  "GEUM": "(Latin) a plant of the Geum genus of the rose family, aka avens [n -S]\n",
  "GEUMS": "GEUM, (Latin) a plant of the Geum genus of the rose family, aka avens [n]\n",
  "GEWGAW": "a showy trinket, also GEEGAW [n -S]\n",
  "GEWGAWED": "decorated in a showy way [adj]\n",
  "GEWGAWS": "GEWGAW, a showy trinket, also GEEGAW [n]\n",
  "GEWURZTRAMINER": "(German) a variety of Traminer grape grown esp. in the Rhine valley, Alsace, and Austria; the mildly spicy white wine made from this grape [n -S]\n",
  "GEWURZTRAMINERS": "GEWURZTRAMINER, (German) a variety of Traminer grape grown esp. in the Rhine valley, Alsace, and Austria; the mildly spicy white wine made from this grape [n]\n",
  "GEY": "considerable [adj GEYER, GEYEST]\n",
  "GEYAN": "(Scots) gey and easy, that is, easy enough [adv]\n",
  "GEYER": "GEY, considerable [adj]\n",
  "GEYEST": "GEY, considerable [adj]\n",
  "GEYSER": "(Icelandic) a type of thermal spring which ejects water intermittently with considerable force [n -S] / to eject jets of water and steam [v -ED, -ING, -S]\n",
  "GEYSERED": "GEYSER, to eject jets of water and steam [v]\n",
  "GEYSERING": "GEYSER, to eject jets of water and steam [v]\n",
  "GEYSERITE": "a deposit from hot springs, aka sinter [n -S]\n",
  "GEYSERITES": "GEYSERITE, a deposit from hot springs, aka sinter [n]\n",
  "GEYSERS": "GEYSER, (Icelandic) a type of thermal spring which ejects water intermittently with considerable force [n]\n",
  "GHARIAL": "(Hindi) an Indian crocodile, also GAVIAL, GARIAL [n -S]\n",
  "GHARIALS": "GHARIAL, (Hindi) an Indian crocodile, also GAVIAL, GARIAL [n]\n",
  "GHARRI": "(Hindi) in India, a wheeled vehicle for hire, also GHARRY [n -S]\n",
  "GHARRIES": "GHARRY, (Hindi) in India, a wheeled vehicle for hire, also GHARRI [n]\n",
  "GHARRIS": "GHARRI, (Hindi) in India, a wheeled vehicle for hire, also GHARRY [n]\n",
  "GHARRY": "(Hindi) in India, a wheeled vehicle for hire, also GHARRI [n GHARRIES]\n",
  "GHAST": "(Shakespeare) to frighten, also GAST [v -ED, -ING, -S]\n",
  "GHASTED": "GHAST, (Shakespeare) to frighten, also GAST [v]\n",
  "GHASTFUL": "(Spenser) terrifying; full of fear, also GASTFULL [adj]\n",
  "GHASTFULLY": "GHASTFUL, (Spenser) terrifying; full of fear, also GASTFULL [adv]\n",
  "GHASTING": "GHAST, (Shakespeare) to frighten, also GAST [v]\n",
  "GHASTLIER": "GHASTLY, like a ghost in appearance; deathlike; pale [adj]\n",
  "GHASTLIEST": "GHASTLY, like a ghost in appearance; deathlike; pale [adj]\n",
  "GHASTLINESS": "the state of being ghastly [n -ES]\n",
  "GHASTLINESSES": "GHASTLINESS, the state of being ghastly [n]\n",
  "GHASTLY": "like a ghost in appearance; deathlike; pale [adj GHASTLIER, GHASTLIEST]\n",
  "GHASTNESS": "ghastliness, also GASTNESS, GASTNESSE [n -ES]\n",
  "GHASTNESSES": "GHASTNESS, ghastliness, also GASTNESS, GASTNESSE [n]\n",
  "GHASTS": "GHAST, (Shakespeare) to frighten, also GAST [v]\n",
  "GHAT": "(Hindi) in India, a landing stage; a place for cremation, also GHAUT [n -S]\n",
  "GHATS": "GHAT, (Hindi) in India, a landing stage; a place for cremation, also GHAUT [n]\n",
  "GHAUT": "(Hindi) in India, a landing stage; a place for cremation, also GHAT [n -S]\n",
  "GHAUTS": "GHAUT, (Hindi) in India, a landing stage; a place for cremation, also GHAT [n]\n",
  "GHAZAL": "(Arabic) a Persian verse form, also GAZAL, GHAZEL [n -S]\n",
  "GHAZALS": "GHAZAL, (Arabic) a Persian verse form, also GAZAL, GHAZEL [n]\n",
  "GHAZEL": "(Arabic) a Persian verse form, also GHAZAL, GAZAL [n -S]\n",
  "GHAZELS": "GHAZEL, (Arabic) a Persian verse form, also GHAZAL, GAZAL [n]\n",
  "GHAZI": "(Arabic) a Muslim warrior who has fought the infidel [n GHAZIS or GHAZIES]\n",
  "GHAZIES": "GHAZI, (Arabic) a Muslim warrior who has fought the infidel [n]\n",
  "GHAZIS": "GHAZI, (Arabic) a Muslim warrior who has fought the infidel [n]\n",
  "GHEE": "(Hindi) a kind of liquid butter, also GHI [n -S]\n",
  "GHEES": "GHEE, (Hindi) a kind of liquid butter, also GHI [n]\n",
  "GHERAO": "(Hindi) in India, the surrounding or trapping of a person, e.g. an employer in a room or building, till demands are met [n -S] / to carry out such an action [v GHERAOED, GHERAOING, GHERAOES or GHERAOS]\n",
  "GHERAOED": "GHERAO, to carry out such an action [v]\n",
  "GHERAOES": "GHERAO, to carry out such an action [v]\n",
  "GHERAOING": "GHERAO, to carry out such an action [v]\n",
  "GHERAOS": "GHERAO, to carry out such an action [v]\n",
  "GHERKIN": "(Dutch) a kind of small, prickly cucumber, much used for pickles, also GIRKIN [n -S]\n",
  "GHERKINS": "GHERKIN, (Dutch) a kind of small, prickly cucumber, much used for pickles, also GIRKIN [n]\n",
  "GHESSE": "(Spenser) to guess, also GESSE [v GHEST or GHESSED, GHESSING, GHESSES]\n",
  "GHESSED": "GHESSE, (Spenser) to guess, also GESSE [v]\n",
  "GHESSES": "GHESSE, (Spenser) to guess, also GESSE [v]\n",
  "GHESSING": "GHESSE, (Spenser) to guess, also GESSE [v]\n",
  "GHEST": "GHESSE, (Spenser) to guess, also GESSE [v]\n",
  "GHETTO": "the Jews' quarter in a city; any poor quarter inhabited by a racial or other group [n GHETTOES or GHETTOS] / to confine to a ghetto [v GHETTOED, GHETTOING, GHETTOES or GHETTOS]\n",
  "GHETTOED": "GHETTO, to confine to a ghetto [v]\n",
  "GHETTOES": "GHETTO, to confine to a ghetto [v]\n",
  "GHETTOING": "GHETTO, to confine to a ghetto [v]\n",
  "GHETTOISATION": "the process of ghettoising, also GHETTOIZATION [n -S]\n",
  "GHETTOISATIONS": "GHETTOISATION, the process of ghettoising, also GHETTOIZATION [n]\n",
  "GHETTOISE": "to confine to a ghetto, also GHETTOIZE [v GHETTOISED, GHETTOISING, GHETTOISES]\n",
  "GHETTOISED": "GHETTOISE, to confine to a ghetto, also GHETTOIZE [v]\n",
  "GHETTOISES": "GHETTOISE, to confine to a ghetto, also GHETTOIZE [v]\n",
  "GHETTOISING": "GHETTOISE, to confine to a ghetto, also GHETTOIZE [v]\n",
  "GHETTOIZATION": "the process of ghettoizing, also GHETTOISATION [n -S]\n",
  "GHETTOIZATIONS": "GHETTOIZATION, the process of ghettoizing, also GHETTOISATION [n]\n",
  "GHETTOIZE": "to confine to a ghetto, also GHETTOISE [v GHETTOIZED, GHETTOIZING, GHETTOIZES]\n",
  "GHETTOIZED": "GHETTOIZE, to confine to a ghetto, also GHETTOISE [v]\n",
  "GHETTOIZES": "GHETTOIZE, to confine to a ghetto, also GHETTOISE [v]\n",
  "GHETTOIZING": "GHETTOIZE, to confine to a ghetto, also GHETTOISE [v]\n",
  "GHETTOS": "GHETTO, to confine to a ghetto [v]\n",
  "GHI": "a kind of liquid butter, also GHEE [n -S]\n",
  "GHIBLI": "(Arabic) the name in Libya of the scirocco, a hot, dry, dusty wind, also GIBLI [n -S]\n",
  "GHIBLIS": "GHIBLI, (Arabic) the name in Libya of the scirocco, a hot, dry, dusty wind, also GIBLI [n]\n",
  "GHILGAI": "(Native Australian) a saucer-shaped depression forming a natural reservoir, also GILGAI [n -S]\n",
  "GHILGAIS": "GHILGAI, (Native Australian) a saucer-shaped depression forming a natural reservoir, also GILGAI [n]\n",
  "GHILLIE": "a Highland chief's attendant, also GILLIE, GILLY [n -S] / to act as a ghillie [v GHILLIED, GHILLYING, GHILLIES]\n",
  "GHILLIED": "GHILLIE, to act as a ghillie [v]\n",
  "GHILLIES": "GHILLIE, to act as a ghillie [v]\n",
  "GHILLYING": "GHILLIE, to act as a ghillie [v]\n",
  "GHIS": "GHI, a kind of liquid butter, also GHEE [n]\n",
  "GHOST": "a spirit, the soul of a person [n -S] / to ghostwrite [v -ED, -ING, -S]\n",
  "GHOSTED": "GHOST, to ghostwrite [v]\n",
  "GHOSTIER": "GHOSTY, like a ghost [adj]\n",
  "GHOSTIEST": "GHOSTY, like a ghost [adj]\n",
  "GHOSTING": "a false image on a TV screen [n -S]\n",
  "GHOSTINGS": "GHOSTING, a false image on a TV screen [n]\n",
  "GHOSTLIER": "GHOSTLY, relating to the soul; spiritual; as, a ghostly confessor [adj]\n",
  "GHOSTLIEST": "GHOSTLY, relating to the soul; spiritual; as, a ghostly confessor [adj]\n",
  "GHOSTLIKE": "like a ghost [adj]\n",
  "GHOSTLINESS": "the state of being ghostly [n -ES]\n",
  "GHOSTLINESSES": "GHOSTLINESS, the state of being ghostly [n]\n",
  "GHOSTLY": "relating to the soul; spiritual; as, a ghostly confessor [adj GHOSTLIER, GHOSTLIEST]\n",
  "GHOSTS": "GHOST, to ghostwrite [v]\n",
  "GHOSTWRITE": "to write on behalf of someone else [v GHOSTWROTE, GHOSTWRITTEN, GHOSTWRITING, GHOSTWRITES]\n",
  "GHOSTWRITER": "one who ghostwrites [n -S]\n",
  "GHOSTWRITERS": "GHOSTWRITER, one who ghostwrites [n]\n",
  "GHOSTWRITES": "GHOSTWRITE, to write on behalf of someone else [v]\n",
  "GHOSTWRITING": "GHOSTWRITE, to write on behalf of someone else [v]\n",
  "GHOSTWRITTEN": "GHOSTWRITE, to write on behalf of someone else [v]\n",
  "GHOSTWROTE": "GHOSTWRITE, to write on behalf of someone else [v]\n",
  "GHOSTY": "like a ghost [adj GHOSTIER, GHOSTIEST]\n",
  "GHOUL": "(Arabic) in Arabic mythology, a desert demon preying on travellers, also GHOULIE [n -S]\n",
  "GHOULIE": "a demon, also GHOUL [n -S]\n",
  "GHOULIES": "GHOULIE, a demon, also GHOUL [n]\n",
  "GHOULISH": "like a ghoul [adj GHOULISHLY]\n",
  "GHOULISHLY": "GHOULISH, like a ghoul [adv]\n",
  "GHOULISHNESS": "the state of being ghoulish [n -ES]\n",
  "GHOULISHNESSES": "GHOULISHNESS, the state of being ghoulish [n]\n",
  "GHOULS": "GHOUL, (Arabic) in Arabic mythology, a desert demon preying on travellers, also GHOULIE [n]\n",
  "GHRELIN": "a gastrointestinal hormone produced by epithelial cells lining the fundus of the stomach [n -S]\n",
  "GHRELINS": "GHRELIN, a gastrointestinal hormone produced by epithelial cells lining the fundus of the stomach [n]\n",
  "GHUBAR": "as in ghubar numeral, any of a set of numerals forming the stage between ancient Hindu numerals and present-day Arabic numerals, also GOBAR [adj]\n",
  "GHYLL": "a narrow ravine [n -S]\n",
  "GHYLLS": "GHYLL, a narrow ravine [n]\n",
  "GI": "(Japanese) a loose-fitting white suit worn in judo, karate, and other martial arts [n -S]\n",
  "GIAMBEUX": "(Spenser) leg-armour, greaves [adj]\n",
  "GIANT": "a person or thing of great size [n -S]\n",
  "GIANTESS": "a female giant [n -ES]\n",
  "GIANTESSES": "GIANTESS, a female giant [n]\n",
  "GIANTHOOD": "the state of being a giant [n -S]\n",
  "GIANTHOODS": "GIANTHOOD, the state of being a giant [n]\n",
  "GIANTISM": "a tendency to abnormally large size, also GIGANTISM [n -S]\n",
  "GIANTISMS": "GIANTISM, a tendency to abnormally large size, also GIGANTISM [n]\n",
  "GIANTLIER": "GIANTLY, like a giant [adj]\n",
  "GIANTLIEST": "GIANTLY, like a giant [adj]\n",
  "GIANTLIKE": "like a giant [adj]\n",
  "GIANTLY": "like a giant [adj GIANTLIER, GIANTLIEST]\n",
  "GIANTRIES": "GIANTRY, the race of giants [n]\n",
  "GIANTRY": "the race of giants [n GIANTRIES]\n",
  "GIANTS": "GIANT, a person or thing of great size [n]\n",
  "GIANTSHIP": "the state, personality, or character, of a giant [n -S]\n",
  "GIANTSHIPS": "GIANTSHIP, the state, personality, or character, of a giant [n]\n",
  "GIAOUR": "(archaic) a term used by Turks for an infidel, one not of their religion [n -S]\n",
  "GIAOURS": "GIAOUR, (archaic) a term used by Turks for an infidel, one not of their religion [n]\n",
  "GIARDIA": "a parasitic protozoan inhabiting the intestines [n -S]\n",
  "GIARDIAS": "GIARDIA, a parasitic protozoan inhabiting the intestines [n]\n",
  "GIARDIASES": "GIARDIASIS, a disease spread by fecal-oral means [n]\n",
  "GIARDIASIS": "a disease spread by fecal-oral means [n GIARDIASES]\n",
  "GIB": "a wedge-shaped piece of metal [n -S] / to fasten with a gib [v GIBBED, GIBBING, GIBS]\n",
  "GIBBED": "GIB, to fasten with a gib [v]\n",
  "GIBBER": "to utter senseless or inarticulate sounds, also JIBBER [v -ED, -ING, -S]\n",
  "GIBBERED": "GIBBER, to utter senseless or inarticulate sounds, also JIBBER [v]\n",
  "GIBBERELLIC": "denoting a type of acid [adj]\n",
  "GIBBERELLIN": "any of several plant-growth regulators produced by a fungus of the genus Gibberella [n -S]\n",
  "GIBBERELLINS": "GIBBERELLIN, any of several plant-growth regulators produced by a fungus of the genus Gibberella [n]\n",
  "GIBBERING": "the act of uttering senseless or inarticulate sounds [n -S]\n",
  "GIBBERINGS": "GIBBERING, the act of uttering senseless or inarticulate sounds [n]\n",
  "GIBBERISH": "rapid, gabbling talk; meaningless words [n -ES]\n",
  "GIBBERISHES": "GIBBERISH, rapid, gabbling talk; meaningless words [n]\n",
  "GIBBERS": "GIBBER, to utter senseless or inarticulate sounds, also JIBBER [v]\n",
  "GIBBET": "to execute by hanging [v GIBBETTED or GIBBETED, GIBBETTING or GIBBETING, GIBBETS]\n",
  "GIBBETED": "GIBBET, to execute by hanging [v]\n",
  "GIBBETING": "GIBBET, to execute by hanging [v]\n",
  "GIBBETS": "GIBBET, to execute by hanging [v]\n",
  "GIBBETTED": "GIBBET, to execute by hanging [v]\n",
  "GIBBETTING": "GIBBET, to execute by hanging [v]\n",
  "GIBBING": "GIB, to fasten with a gib [v]\n",
  "GIBBON": "any of various small long-armed tailless arboreal apes of SE Asia [n -S]\n",
  "GIBBONS": "GIBBON, any of various small long-armed tailless arboreal apes of SE Asia [n]\n",
  "GIBBOSE": "humpbacked, humped; (of a moon) between half and full, also GIBBOUS [adj]\n",
  "GIBBOSITIES": "GIBBOSITY, the state of being gibbose, of a moon, between half and full [n]\n",
  "GIBBOSITY": "the state of being gibbose, of a moon, between half and full [n GIBBOSITIES]\n",
  "GIBBOUS": "humpbacked, humped; (of a moon) between half and full, also GIBBOSE [adj GIBBOUSLY]\n",
  "GIBBOUSLY": "GIBBOUS, humpbacked, humped; (of a moon) between half and full, also GIBBOSE [adv]\n",
  "GIBBOUSNESS": "the state of being gibbous [n -ES]\n",
  "GIBBOUSNESSES": "GIBBOUSNESS, the state of being gibbous [n]\n",
  "GIBBSITE": "a mineral, a hydrate of alumina [n -S]\n",
  "GIBBSITES": "GIBBSITE, a mineral, a hydrate of alumina [n]\n",
  "GIBE": "to scoff, mock, also JIBE [v GIBED, GIBING, GIBES]\n",
  "GIBED": "GIBE, to scoff, mock, also JIBE [v]\n",
  "GIBEL": "(German) a kind of carp, aka crucian carp [n -S]\n",
  "GIBELS": "GIBEL, (German) a kind of carp, aka crucian carp [n]\n",
  "GIBER": "one who gibes, also JIBER [n -S]\n",
  "GIBERS": "GIBER, one who gibes, also JIBER [n]\n",
  "GIBES": "GIBE, to scoff, mock, also JIBE [v]\n",
  "GIBING": "GIBE, to scoff, mock, also JIBE [v]\n",
  "GIBINGLY": "GIBING, GIBE, to scoff, mock, also JIBE [adv]\n",
  "GIBLET": "made of giblets e.g. giblet soup [adj]\n",
  "GIBLETS": "the edible viscera (heart, gizzard, liver, etc.), of poultry [n]\n",
  "GIBLI": "(Arabic) the name in Libya of the scirocco, a hot, dry, dusty wind, also GHIBLI [n -S]\n",
  "GIBLIS": "GIBLI, (Arabic) the name in Libya of the scirocco, a hot, dry, dusty wind, also GHIBLI [n]\n",
  "GIBS": "GIB, to fasten with a gib [v]\n",
  "GIBSON": "a martini served with a tiny onion [n -S]\n",
  "GIBSONS": "GIBSON, a martini served with a tiny onion [n]\n",
  "GIBUS": "(French) an opera hat [n -ES]\n",
  "GIBUSES": "GIBUS, (French) an opera hat [n]\n",
  "GID": "a disease of sheep [n -S]\n",
  "GIDDAP": "used to tell a horse to go faster, also GIDDUP, GIDDYAP, GIDDYUP [interj]\n",
  "GIDDAY": "(Australian slang) an expression of greeting [interj]\n",
  "GIDDIED": "GIDDY, to make dizzy [v]\n",
  "GIDDIER": "GIDDY, dizzy [adj]\n",
  "GIDDIES": "GIDDY, to make dizzy [v]\n",
  "GIDDIEST": "GIDDY, dizzy [adj]\n",
  "GIDDILY": "GIDDY, dizzy [adv]\n",
  "GIDDINESS": "the state of being giddy [n -ES]\n",
  "GIDDINESSES": "GIDDINESS, the state of being giddy [n]\n",
  "GIDDUP": "to a horse to go faster, also GIDDAP, GIDDYAP, GIDDYUP [interj]\n",
  "GIDDY": "to make dizzy [v GIDDIED, GIDDYING, GIDDIES] / dizzy [adj GIDDIER, GIDDIEST, GIDDILY]\n",
  "GIDDYAP": "used to tell a horse to go faster, also GIDDAP, GIDDUP, GIDDYUP [interj]\n",
  "GIDDYING": "GIDDY, to make dizzy [v]\n",
  "GIDDYUP": "used to tell a horse to go faster, also GIDDAP, GIDDUP, GIDDYAP [interj]\n",
  "GIDGEE": "(Native Australian) a small Australian acacia tree, also GIDJEE [n -S]\n",
  "GIDGEES": "GIDGEE, (Native Australian) a small Australian acacia tree, also GIDJEE [n]\n",
  "GIDJEE": "(Native Australian) a small Australian acacia tree, also GIDGEE [n -S]\n",
  "GIDJEES": "GIDJEE, (Native Australian) a small Australian acacia tree, also GIDGEE [n]\n",
  "GIDS": "GID, a disease of sheep [n]\n",
  "GIE": "(Scots) to give [v GIED, GIEN, GIEING, GIES]\n",
  "GIED": "GIE, (Scots) to give [v]\n",
  "GIEING": "GIE, (Scots) to give [v]\n",
  "GIEN": "GIE, (Scots) to give [v]\n",
  "GIES": "GIE, (Scots) to give [v]\n",
  "GIF": "a type of computer image [n -S]\n",
  "GIFS": "GIF, a type of computer image [n]\n",
  "GIFT": "to give without charge [v -ED, -ING, -S]\n",
  "GIFTABLE": "something appropriate for a gift [n -S]\n",
  "GIFTABLES": "GIFTABLE, something appropriate for a gift [n]\n",
  "GIFTED": "GIFT, to give without charge [v]\n",
  "GIFTEDLY": "GIFTED, GIFT, to give without charge [adv]\n",
  "GIFTEDNESS": "the state of being gifted [n -ES]\n",
  "GIFTEDNESSES": "GIFTEDNESS, the state of being gifted [n]\n",
  "GIFTEE": "one that receives a gift [n -S]\n",
  "GIFTEES": "GIFTEE, one that receives a gift [n]\n",
  "GIFTING": "the act of making a gift [n -S]\n",
  "GIFTINGS": "GIFTING, the act of making a gift [n]\n",
  "GIFTLESS": "being without a gift [adj]\n",
  "GIFTS": "GIFT, to give without charge [v]\n",
  "GIFTSHOP": "a shop selling presents [n -S]\n",
  "GIFTSHOPS": "GIFTSHOP, a shop selling presents [n]\n",
  "GIFTWARE": "wares suitable for gifting [n -S]\n",
  "GIFTWARES": "GIFTWARE, wares suitable for gifting [n]\n",
  "GIFTWRAP": "to wrap with decorative paper [v GIFTWRAPPED, GIFTWRAPPING, GIFTWRAPS]\n",
  "GIFTWRAPPED": "GIFTWRAP, to wrap with decorative paper [v]\n",
  "GIFTWRAPPING": "the wrapping of a present [n -S]\n",
  "GIFTWRAPPINGS": "GIFTWRAPPING, the wrapping of a present [n]\n",
  "GIFTWRAPS": "GIFTWRAP, to wrap with decorative paper [v]\n",
  "GIG": "to catch fish with a pronged spear [v GIGGED, GIGGING, GIGS]\n",
  "GIGA": "(Italian) a lively Italian dance, also GIGUE [n GIGAS or GIGHE]\n",
  "GIGABIT": "a unit of information, a thousand million bits [n -S]\n",
  "GIGABITS": "GIGABIT, a unit of information, a thousand million bits [n]\n",
  "GIGABYTE": "a unit of information, a thousand million bytes [n -S]\n",
  "GIGABYTES": "GIGABYTE, a unit of information, a thousand million bytes [n]\n",
  "GIGACYCLE": "one billion hertz [n -S]\n",
  "GIGACYCLES": "GIGACYCLE, one billion hertz [n]\n",
  "GIGAFLOP": "a measure of computing speed (a billion floating point operations per second) [n -S]\n",
  "GIGAFLOPS": "GIGAFLOP, a measure of computing speed (a billion floating point operations per second) [n]\n",
  "GIGAHERTZ": "one billion hertz [n -ES]\n",
  "GIGAHERTZES": "GIGAHERTZ, one billion hertz [n]\n",
  "GIGANTEAN": "like a giant, also GIGANTIC [adj]\n",
  "GIGANTESQUE": "of enormous or grotesquely large proportions [adj]\n",
  "GIGANTIC": "huge, also GIGANTEAN [adj GIGANTICALLY]\n",
  "GIGANTICALLY": "GIGANTIC, huge, also GIGANTEAN [adv]\n",
  "GIGANTICIDE": "the killing of a giant [n -S]\n",
  "GIGANTICIDES": "GIGANTICIDE, the killing of a giant [n]\n",
  "GIGANTICNESS": "the state of being gigantic [n -ES]\n",
  "GIGANTICNESSES": "GIGANTICNESS, the state of being gigantic [n]\n",
  "GIGANTISM": "a tendency to abnormally large size, also GIANTISM [n -S]\n",
  "GIGANTISMS": "GIGANTISM, a tendency to abnormally large size, also GIANTISM [n]\n",
  "GIGANTOLOGIES": "GIGANTOLOGY, the study of giants [n]\n",
  "GIGANTOLOGY": "the study of giants [n GIGANTOLOGIES]\n",
  "GIGANTOMACHIA": "a war of giants, esp. against the gods, also GIGANTOMACHY [n -S]\n",
  "GIGANTOMACHIAS": "GIGANTOMACHIA, a war of giants, esp. against the gods, also GIGANTOMACHY [n]\n",
  "GIGANTOMACHIES": "GIGANTOMACHY, a war of giants esp. against the gods, also GIGANTOMACHIA [n]\n",
  "GIGANTOMACHY": "a war of giants esp. against the gods, also GIGANTOMACHIA [n GIGANTOMACHIES]\n",
  "GIGAS": "GIGA, (Italian) a lively Italian dance, also GIGUE [n]\n",
  "GIGATON": "a unit of weight, a thousand million tons [n -S]\n",
  "GIGATONS": "GIGATON, a unit of weight, a thousand million tons [n]\n",
  "GIGAVOLT": "a billion volts [n -S]\n",
  "GIGAVOLTS": "GIGAVOLT, a billion volts [n]\n",
  "GIGAWATT": "a unit of power, a thousand million watts [n -S]\n",
  "GIGAWATTS": "GIGAWATT, a unit of power, a thousand million watts [n]\n",
  "GIGGED": "GIG, to catch fish with a pronged spear [v]\n",
  "GIGGING": "GIG, to catch fish with a pronged spear [v]\n",
  "GIGGIT": "(US archaic) to convey or move rapidly [v -ED, -ING, -S]\n",
  "GIGGITED": "GIGGIT, (US archaic) to convey or move rapidly [v]\n",
  "GIGGITING": "GIGGIT, (US archaic) to convey or move rapidly [v]\n",
  "GIGGITS": "GIGGIT, (US archaic) to convey or move rapidly [v]\n",
  "GIGGLE": "to laugh in a silly manner [v GIGGLED, GIGGLING, GIGGLES]\n",
  "GIGGLED": "GIGGLE, to laugh in a silly manner [v]\n",
  "GIGGLER": "one who giggles [n -S]\n",
  "GIGGLERS": "GIGGLER, one who giggles [n]\n",
  "GIGGLES": "GIGGLE, to laugh in a silly manner [v]\n",
  "GIGGLESOME": "inclined to giggle, giggly [adj]\n",
  "GIGGLIER": "GIGGLY, tending to giggle [adj]\n",
  "GIGGLIEST": "GIGGLY, tending to giggle [adj]\n",
  "GIGGLING": "the act of laughing in a silly manner [n -S]\n",
  "GIGGLINGLY": "GIGGLING [adv]\n",
  "GIGGLINGS": "GIGGLING, the act of laughing in a silly manner [n]\n",
  "GIGGLY": "tending to giggle [adj GIGGLIER, GIGGLIEST]\n",
  "GIGHE": "GIGA, (Italian) a lively Italian dance, also GIGUE [n]\n",
  "GIGLET": "(obsolete) a giddy girl, a wanton, also GIGLOT, GILLET, JILLET [n -S]\n",
  "GIGLETS": "GIGLET, (obsolete) a giddy girl, a wanton, also GIGLOT, GILLET, JILLET [n]\n",
  "GIGLOT": "(obsolete) a giddy girl, a wanton, also GIGLET, GILLET, JILLET [n -S]\n",
  "GIGLOTS": "GIGLOT, (obsolete) a giddy girl, a wanton, also GIGLET, GILLET, JILLET [n]\n",
  "GIGMAN": "a gig driver [n GIGMEN]\n",
  "GIGMANITIES": "GIGMANITY, narrow middle-class Philistinism [n]\n",
  "GIGMANITY": "narrow middle-class Philistinism [n GIGMANITIES]\n",
  "GIGMEN": "GIGMAN, a gig driver [n]\n",
  "GIGOLO": "(French) a man supported financially by a woman [n -S]\n",
  "GIGOLOS": "GIGOLO, (French) a man supported financially by a woman [n]\n",
  "GIGOT": "(French) a leg of lamb, also JIGOT [n -S]\n",
  "GIGOTS": "GIGOT, (French) a leg of lamb, also JIGOT [n]\n",
  "GIGS": "GIG, to catch fish with a pronged spear [v]\n",
  "GIGUE": "(French) a lively Baroque dance in triple time, also GIGA [n -S]\n",
  "GIGUES": "GIGUE, (French) a lively Baroque dance in triple time, also GIGA [n]\n",
  "GILA": "a large lizard native to Arizona, New Mexico, etc. [n -S]\n",
  "GILAS": "GILA, a large lizard native to Arizona, New Mexico, etc. [n]\n",
  "GILBERT": "an electrical unit of induced magnetic force [n -S]\n",
  "GILBERTS": "GILBERT, an electrical unit of induced magnetic force [n]\n",
  "GILCUP": "(dialect) a buttercup, also GILTCUP [n -S]\n",
  "GILCUPS": "GILCUP, (dialect) a buttercup, also GILTCUP [n]\n",
  "GILD": "to cover with a thin layer of gold [v GILT or GILDED, GILDING, GILDS]\n",
  "GILDED": "GILD, to cover with a thin layer of gold [v]\n",
  "GILDEN": "(Spenser) golden, gilded, also GYLDEN [adj]\n",
  "GILDER": "one who gilds [n -S]\n",
  "GILDERS": "GILDER, one who gilds [n]\n",
  "GILDHALL": "a town hall, also GUILDHALL [n -S]\n",
  "GILDHALLS": "GILDHALL, a town hall, also GUILDHALL [n]\n",
  "GILDING": "the act of covering with gilt [n -S]\n",
  "GILDINGS": "GILDING, the act of covering with gilt [n]\n",
  "GILDS": "GILD, to cover with a thin layer of gold [v]\n",
  "GILDSMAN": "a male member of a guild, also GUILDSMAN [n GILDSMEN]\n",
  "GILDSMEN": "GILDSMAN, a male member of a guild, also GUILDSMAN [n]\n",
  "GILDSWOMAN": "a female member of a guild, also GUILDSWOMAN [n GILDSWOMEN]\n",
  "GILDSWOMEN": "GILDSWOMAN, a female member of a guild, also GUILDSWOMAN [n]\n",
  "GILET": "(French) a light often padded waistcoat, usually worn for warmth by women [n -S]\n",
  "GILETS": "GILET, (French) a light often padded waistcoat, usually worn for warmth by women [n]\n",
  "GILGAI": "(Native Australian) a saucer-shaped depression forming a natural reservoir, also GHILGAI [n -S]\n",
  "GILGAIS": "GILGAI, (Native Australian) a saucer-shaped depression forming a natural reservoir, also GHILGAI [n]\n",
  "GILGIE": "(Native Australian) a small freshwater crayfish, aka yabby, also JILGIE [n -S]\n",
  "GILGIES": "GILGIE, (Native Australian) a small freshwater crayfish, aka yabby, also JILGIE [n]\n",
  "GILL": "a membranous organ for breathing in water [n -S] / to catch fish in a gillnet [v -ED, -ING, -S]\n",
  "GILLAROO": "(Irish) an Irish trout with a thickened muscular stomach [n -S]\n",
  "GILLAROOS": "GILLAROO, (Irish) an Irish trout with a thickened muscular stomach [n]\n",
  "GILLED": "GILL, to catch fish in a gillnet [v]\n",
  "GILLER": "one that gills, catches fish with a gillnet [n -S]\n",
  "GILLERS": "GILLER, one that gills, catches fish with a gillnet [n]\n",
  "GILLET": "(Scots) a skittish, flighty girl, also GIGLET, GIGLOT, JILLET [n -S]\n",
  "GILLETS": "GILLET, (Scots) a skittish, flighty girl, also GIGLET, GIGLOT, JILLET [n]\n",
  "GILLFLIRT": "(archaic) a wanton girl, also JILLFLIRT [n -S]\n",
  "GILLFLIRTS": "GILLFLIRT, (archaic) a wanton girl, also JILLFLIRT [n]\n",
  "GILLIE": "a Highland chief's attendant, also GHILLIE, GILLY [n -S] / to act as a gillie [v GILLIED, GILLYING, GILLIES]\n",
  "GILLIED": "GILLY, to act as a gilly [v]\n",
  "GILLIES": "GILLIE, to act as a gillie [v]\n",
  "GILLIFLOWER": "a carnation, also GELLIFLOWRE, GILLYFLOWER, GILLYVOR [n -S]\n",
  "GILLIFLOWERS": "GILLIFLOWER, a carnation, also GELLIFLOWRE, GILLYFLOWER, GILLYVOR [n]\n",
  "GILLING": "GILL, to catch fish in a gillnet [v]\n",
  "GILLION": "a thousand million [n -S]\n",
  "GILLIONS": "GILLION, a thousand million [n]\n",
  "GILLNET": "to catch fish in a gillnet [v GILLNETTED, GILLNETTING, GILLNETS]\n",
  "GILLNETS": "GILLNET, to catch fish in a gillnet [v]\n",
  "GILLNETTED": "GILLNET, to catch fish in a gillnet [v]\n",
  "GILLNETTER": "a fisherman who uses a gillnet [n -S]\n",
  "GILLNETTERS": "GILLNETTER, a fisherman who uses a gillnet [n]\n",
  "GILLNETTING": "GILLNET, to catch fish in a gillnet [v]\n",
  "GILLRAVAGE": "(Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v GILLRAVAGED, GILLRAVAGING, GILLRAVAGES]\n",
  "GILLRAVAGED": "GILLRAVAGE, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GILLRAVAGES": "GILLRAVAGE, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GILLRAVAGING": "GILLRAVAGE, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVITCH, GILRAVAGE, GILRAVITCH [v]\n",
  "GILLRAVITCH": "(Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILRAVAGE, GILRAVITCH [v -ED, -ING, -ES]\n",
  "GILLRAVITCHED": "GILLRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILRAVAGE, GILRAVITCH [v]\n",
  "GILLRAVITCHES": "GILLRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILRAVAGE, GILRAVITCH [v]\n",
  "GILLRAVITCHING": "GILLRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILRAVAGE, GILRAVITCH [v]\n",
  "GILLS": "GILL, to catch fish in a gillnet [v]\n",
  "GILLY": "a Highland chief's attendant, also GHILLIE, GILLIE [n GILLIES] / to act as a gilly [v GILLIED, GILLYING, GILLIES]\n",
  "GILLYFLOWER": "a carnation, also GELLIFLOWRE, GILLIFLOWER, GILLYVOR [n -S]\n",
  "GILLYFLOWERS": "GILLYFLOWER, a carnation, also GELLIFLOWRE, GILLIFLOWER, GILLYVOR [n]\n",
  "GILLYING": "GILLY, to act as a gilly [v]\n",
  "GILLYVOR": "(Shakespeare) a gillyflower, a carnation, also GELLIFLOWRE, GILLIFLOWER, GILLYFLOWER [n -S]\n",
  "GILLYVORS": "GILLYVOR, (Shakespeare) a gillyflower, a carnation, also GELLIFLOWRE, GILLIFLOWER, GILLYFLOWER [n]\n",
  "GILPEY": "(Scots) a boisterous girl, also GILPY [n -S]\n",
  "GILPEYS": "GILPEY, (Scots) a boisterous girl, also GILPY [n]\n",
  "GILPIES": "GILPY, (Scots) a boisterous girl, also GILPEY [n]\n",
  "GILPY": "(Scots) a boisterous girl, also GILPEY [n GILPIES]\n",
  "GILRAVAGE": "(Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVITCH [v GILRAVAGED, GILRAVAGING, GILRAVAGES]\n",
  "GILRAVAGED": "GILRAVAGE, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVITCH [v]\n",
  "GILRAVAGER": "(Scots) a riotous person [n -S]\n",
  "GILRAVAGERS": "GILRAVAGER, (Scots) a riotous person [n]\n",
  "GILRAVAGES": "GILRAVAGE, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVITCH [v]\n",
  "GILRAVAGING": "GILRAVAGE, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVITCH [v]\n",
  "GILRAVITCH": "(Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE [v -ED, -ING, -ES]\n",
  "GILRAVITCHED": "GILRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE [v]\n",
  "GILRAVITCHES": "GILRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE [v]\n",
  "GILRAVITCHING": "GILRAVITCH, (Scots) to behave riotously, also GALRAVAGE, GALRAVITCH, GILLRAVAGE, GILLRAVITCH, GILRAVAGE [v]\n",
  "GILSONITE": "(tradename) a proprietary name for the mineral uintaite [n -S]\n",
  "GILSONITES": "GILSONITE, (tradename) a proprietary name for the mineral uintaite [n]\n",
  "GILT": "a young sow, also ELT, YELT [n -S]\n",
  "GILTCUP": "(dialect) a buttercup, also GILCUP [n -S]\n",
  "GILTCUPS": "GILTCUP, (dialect) a buttercup, also GILCUP [n]\n",
  "GILTHEAD": "a kind of fish with a gold half-moon between the eyes [n -S]\n",
  "GILTHEADS": "GILTHEAD, a kind of fish with a gold half-moon between the eyes [n]\n",
  "GILTS": "GILT, a young sow, also ELT, YELT [n]\n",
  "GILTWOOD": "made of wood covered with gilt [adj]\n",
  "GIMBAL": "to support on a set of rings allowing free movement, also GYMBAL [v GIMBALLED or GIMBALED, GIMBALLING or GIMBALING, GIMBALS]\n",
  "GIMBALED": "GIMBAL, to support on a set of rings allowing free movement, also GYMBAL [v]\n",
  "GIMBALING": "GIMBAL, to support on a set of rings allowing free movement, also GYMBAL [v]\n",
  "GIMBALLED": "GIMBAL, to support on a set of rings allowing free movement, also GYMBAL [v]\n",
  "GIMBALLING": "GIMBAL, to support on a set of rings allowing free movement, also GYMBAL [v]\n",
  "GIMBALS": "GIMBAL, to support on a set of rings allowing free movement, also GYMBAL [v]\n",
  "GIMCRACK": "cheap and showy [adj] / something cheap and showy, of little use, also JIMCRACK [n -S]\n",
  "GIMCRACKERIES": "GIMCRACKERY, the state of being gimcrack [n]\n",
  "GIMCRACKERY": "the state of being gimcrack [n GIMCRACKERIES]\n",
  "GIMCRACKS": "GIMCRACK, something cheap and showy, of little use, also JIMCRACK [n]\n",
  "GIMEL": "(Hebrew) the third letter of the Hebrew alphabet [n -S]\n",
  "GIMELS": "GIMEL, (Hebrew) the third letter of the Hebrew alphabet [n]\n",
  "GIMLET": "a small hand tool with a pointed screw-tip for boring holes in wood [n -S] / to pierce as with a gimlet [v -ED, -ING, -S]\n",
  "GIMLETED": "GIMLET, to pierce as with a gimlet [v]\n",
  "GIMLETING": "GIMLET, to pierce as with a gimlet [v]\n",
  "GIMLETS": "GIMLET, to pierce as with a gimlet [v]\n",
  "GIMMAL": "a pair of interlocked rings, also GIMMOR, GYMMAL [n -S]\n",
  "GIMMALLED": "jointed, hinged, like a gimmal, also JYMOLD [adj]\n",
  "GIMMALS": "GIMMAL, a pair of interlocked rings, also GIMMOR, GYMMAL [n]\n",
  "GIMME": "an easy golf putt conceded to an opponent, also GIMMIE [n -S]\n",
  "GIMMER": "(Scots) a young ewe [n -S]\n",
  "GIMMERS": "GIMMER, (Scots) a young ewe [n]\n",
  "GIMMES": "GIMME, an easy golf putt conceded to an opponent, also GIMMIE [n]\n",
  "GIMMICK": "to provide with a gimmick (a tricky feature) [v -ED, -ING, -S]\n",
  "GIMMICKED": "GIMMICK, to provide with a gimmick (a tricky feature) [v]\n",
  "GIMMICKIER": "GIMMICKY, having or being like a gimmick [adj]\n",
  "GIMMICKIEST": "GIMMICKY, having or being like a gimmick [adj]\n",
  "GIMMICKING": "GIMMICK, to provide with a gimmick (a tricky feature) [v]\n",
  "GIMMICKRIES": "GIMMICKRY, the use of gimmicks [n]\n",
  "GIMMICKRY": "the use of gimmicks [n GIMMICKRIES]\n",
  "GIMMICKS": "GIMMICK, to provide with a gimmick (a tricky feature) [v]\n",
  "GIMMICKY": "having or being like a gimmick [adj GIMMICKIER, GIMMICKIEST]\n",
  "GIMMIE": "an easy golf putt conceded to an opponent, also GIMME [n -S]\n",
  "GIMMIES": "GIMMIE, an easy golf putt conceded to an opponent, also GIMME [n]\n",
  "GIMMOR": "(Shakespeare) a pair of interlocked rings, also GIMMAL, GYMMAL [n -S]\n",
  "GIMMORS": "GIMMOR, (Shakespeare) a pair of interlocked rings, also GIMMAL, GYMMAL [n]\n",
  "GIMP": "a yarn with a hard core, also GUIMP, GYMP [n -S] / to make or furnish with gimp [v -ED, -ING, -S]\n",
  "GIMPED": "GIMP, to make or furnish with gimp [v]\n",
  "GIMPIER": "GIMPY, limping [adj]\n",
  "GIMPIEST": "GIMPY, limping [adj]\n",
  "GIMPING": "GIMP, to make or furnish with gimp [v]\n",
  "GIMPS": "GIMP, to make or furnish with gimp [v]\n",
  "GIMPY": "limping [adj GIMPIER, GIMPIEST]\n",
  "GIN": "to process cotton [v GINNED, GINNING, GINS] / (archaic) to begin [v GAN or (US) GUNNEN, GINNING, GINS]\n",
  "GINCH": "(Canadian) underpants, also GITCH, GONCH, GOTCH [n -ES]\n",
  "GINCHES": "GINCH, (Canadian) underpants, also GITCH, GONCH, GOTCH [n]\n",
  "GING": "(Australian slang) a child's catapult [n -S]\n",
  "GINGAL": "(Hindi) a large Chinese or Indian swivel-musket, also GINGALL, JINGAL, JINGALL [n -S]\n",
  "GINGALL": "(Hindi) a large Chinese or Indian swivel-musket, also GINGAL, JINGAL, JINGALL [n -S]\n",
  "GINGALLS": "GINGALL, (Hindi) a large Chinese or Indian swivel-musket, also GINGAL, JINGAL, JINGALL [n]\n",
  "GINGALS": "GINGAL, (Hindi) a large Chinese or Indian swivel-musket, also GINGALL, JINGAL, JINGALL [n]\n",
  "GINGE": "(colloquial) someone with ginger hair [n -S]\n",
  "GINGELEY": "the sesame seed or its oil, also GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILI, GINGILLI, JINJILI [n -S]\n",
  "GINGELEYS": "GINGELEY, the sesame seed or its oil, also GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILI, GINGILLI, JINJILI [n]\n",
  "GINGELI": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELLI, GINGELLY, GINGELY, GINGILI, GINGILLI, JINJILI [n GINGELIS or GINGELIES]\n",
  "GINGELIES": "GINGELY, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGILI, GINGILLI, JINJILI [n]\n",
  "GINGELIS": "GINGELI, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELLI, GINGELLY, GINGELY, GINGILI, GINGILLI, JINJILI [n]\n",
  "GINGELLI": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLY, GINGELY, GINGILI, GINGILLI, JINJILI [n -S]\n",
  "GINGELLIES": "GINGELLY, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELY, GINGILI, GINGILLI, JINJILI [n]\n",
  "GINGELLIS": "GINGELLI, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLY, GINGELY, GINGILI, GINGILLI, JINJILI [n]\n",
  "GINGELLY": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELY, GINGILI, GINGILLI, JINJILI [n GINGELLIES]\n",
  "GINGELY": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGILI, GINGILLI, JINJILI [n GINGELIES]\n",
  "GINGER": "(Malay) to spice up, make spirited [v -ED, -ING, -S]\n",
  "GINGERADE": "a carbonated soft drink flavoured with ginger [n -S]\n",
  "GINGERADES": "GINGERADE, a carbonated soft drink flavoured with ginger [n]\n",
  "GINGERBREAD": "a cake flavoured with treacle and usually ginger [n -S]\n",
  "GINGERBREADED": "flavoured with gingerbread [adj]\n",
  "GINGERBREADIER": "GINGERBREADY, like gingerbread [adj]\n",
  "GINGERBREADIEST": "GINGERBREADY, like gingerbread [adj]\n",
  "GINGERBREADS": "GINGERBREAD, a cake flavoured with treacle and usually ginger [n]\n",
  "GINGERBREADY": "like gingerbread [adj GINGERBREADIER, GINGERBREADIEST]\n",
  "GINGERED": "GINGER, (Malay) to spice up, make spirited [v]\n",
  "GINGERIER": "GINGERY, of or like ginger; sandy in colour [adj]\n",
  "GINGERIEST": "GINGERY, of or like ginger; sandy in colour [adj]\n",
  "GINGERING": "GINGER, (Malay) to spice up, make spirited [v]\n",
  "GINGERLIER": "GINGERLY [adj]\n",
  "GINGERLIEST": "GINGERLY [adj]\n",
  "GINGERLINESS": "the state of being gingerly [n -ES]\n",
  "GINGERLINESSES": "GINGERLINESS, the state of being gingerly [n]\n",
  "GINGERLY": "in a careful manner [adv GINGERLIER, GINGERLIEST]\n",
  "GINGEROUS": "(Dickens) sandy, reddish [adj]\n",
  "GINGERROOT": "the root of the ginger plant [n -S]\n",
  "GINGERROOTS": "GINGERROOT, the root of the ginger plant [n]\n",
  "GINGERS": "GINGER, (Malay) to spice up, make spirited [v]\n",
  "GINGERSNAP": "a gingerbread biscuit [n -S]\n",
  "GINGERSNAPS": "GINGERSNAP, a gingerbread biscuit [n]\n",
  "GINGERY": "of or like ginger; sandy in colour [adj GINGERIER, GINGERIEST]\n",
  "GINGES": "GINGE, (colloquial) someone with ginger hair [n]\n",
  "GINGHAM": "(Malay) a striped cotton fabric [n -S]\n",
  "GINGHAMS": "GINGHAM, (Malay) a striped cotton fabric [n]\n",
  "GINGILI": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILLI, JINJILI [n -S]\n",
  "GINGILIS": "GINGILI, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILLI, JINJILI [n]\n",
  "GINGILLI": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILI, JINJILI [n -S]\n",
  "GINGILLIS": "GINGILLI, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILI, JINJILI [n]\n",
  "GINGIVA": "(Latin) the fleshy tissue surrounding the teeth [n GINGIVAE]\n",
  "GINGIVAE": "GINGIVA, (Latin) the fleshy tissue surrounding the teeth [n]\n",
  "GINGIVAL": "(Latin) pertaining to the fleshy tissue surrounding the teeth [adj]\n",
  "GINGIVECTOMIES": "GINGIVECTOMY, a surgical incision of the gums [n]\n",
  "GINGIVECTOMY": "a surgical incision of the gums [n GINGIVECTOMIES]\n",
  "GINGIVITIS": "inflammation of the gums [n -ES]\n",
  "GINGIVITISES": "GINGIVITIS, inflammation of the gums [n]\n",
  "GINGKO": "(Japanese) an ornamental tree, also GINKGO, JINGKO [n -ES or -S]\n",
  "GINGKOES": "GINGKO, (Japanese) an ornamental tree, also GINKGO, JINGKO [n]\n",
  "GINGKOS": "GINGKO, (Japanese) an ornamental tree, also GINKGO, JINGKO [n]\n",
  "GINGLE": "(obsolete) a jingling sound [n -S]\n",
  "GINGLES": "GINGLE, (obsolete) a jingling sound [n]\n",
  "GINGLIMOID": "of or like a ginglymus, a joint that permits movement in one plane only, a hinge joint [adj]\n",
  "GINGLYMI": "GINGLYMUS, (Greek) a joint that permits movement in one plane only, a hinge joint [n]\n",
  "GINGLYMUS": "(Greek) a joint that permits movement in one plane only, a hinge joint [n GINGLYMI]\n",
  "GINGS": "GING, (Australian slang) a child's catapult [n]\n",
  "GINHOUSE": "a place where cotton is ginned, also GINNERY [n -S]\n",
  "GINHOUSES": "GINHOUSE, a place where cotton is ginned, also GINNERY [n]\n",
  "GINK": "(slang) a fellow [n -S]\n",
  "GINKGO": "(Japanese) an ornamental tree, also GINGKO, JINGKO [n -ES or -S]\n",
  "GINKGOES": "GINKGO, (Japanese) an ornamental tree, also GINGKO, JINGKO [n]\n",
  "GINKGOS": "GINKGO, (Japanese) an ornamental tree, also GINGKO, JINGKO [n]\n",
  "GINKS": "GINK, (slang) a fellow [n]\n",
  "GINN": "a class of spirits in Muslim folklore [n]\n",
  "GINNED": "GIN, to process cotton [v]\n",
  "GINNEL": "a narrow alley, also GENNEL [n -S]\n",
  "GINNELS": "GINNEL, a narrow alley, also GENNEL [n]\n",
  "GINNER": "one that gins cotton [n -S]\n",
  "GINNERIES": "GINNERY, a place where cotton is ginned, also GINHOUSE [n]\n",
  "GINNERS": "GINNER, one that gins cotton [n]\n",
  "GINNERY": "a place where cotton is ginned, also GINHOUSE [n GINNERIES]\n",
  "GINNIER": "GINNY, affected with gin (a strong liquor) [adj]\n",
  "GINNIEST": "GINNY, affected with gin (a strong liquor) [adj]\n",
  "GINNING": "cotton as it comes from the cotton-gin [n -S]\n",
  "GINNINGS": "GINNING, cotton as it comes from the cotton-gin [n]\n",
  "GINNY": "affected with gin (a strong liquor) [adj GINNIER, GINNIEST]\n",
  "GINORMOUS": "(jocular) gigantic, enormous [adj]\n",
  "GINS": "GIN, to process cotton [v]\n",
  "GINSENG": "(Chinese) a plant of the genus Aralia, the root of which is highly valued as a medicine among the Chinese, also GENSENG [n -S]\n",
  "GINSENGS": "GINSENG, (Chinese) a plant of the genus Aralia, the root of which is highly valued as a medicine among the Chinese, also GENSENG [n]\n",
  "GINSHOP": "a shop that sells gin [n -S]\n",
  "GINSHOPS": "GINSHOP, a shop that sells gin [n]\n",
  "GINZO": "(offensive) a person of Italian descent [n -ES or -S]\n",
  "GINZOES": "GINZO, (offensive) a person of Italian descent [n]\n",
  "GINZOS": "GINZO, (offensive) a person of Italian descent [n]\n",
  "GIO": "a gully or creek, also GEO, GOE [n -S]\n",
  "GIOCOSO": "played in a lively manner [adj]\n",
  "GIOS": "GIO, a gully or creek, also GEO, GOE [n]\n",
  "GIP": "to swindle, also GYP [v GIPPED, GIPPING, GIPS]\n",
  "GIPON": "a sleeveless jacket worn beneath a hauberk, also JUPON [n -S]\n",
  "GIPONS": "GIPON, a sleeveless jacket worn beneath a hauberk, also JUPON [n]\n",
  "GIPPED": "GIP, to swindle, also GYP [v]\n",
  "GIPPER": "one who gips, a swindler [n -S]\n",
  "GIPPERS": "GIPPER, one who gips, a swindler [n]\n",
  "GIPPIES": "GIPPY, (offensive) a gypsy, also GIPPO, GYPPIE, GYPPO, GYPPY [n]\n",
  "GIPPING": "GIP, to swindle, also GYP [v]\n",
  "GIPPO": "(offensive) a gypsy, also GIPPY, GYPPIE, GYPPO, GYPPY [n -ES or -S]\n",
  "GIPPOES": "GIPPO, (offensive) a gypsy, also GIPPY, GYPPIE, GYPPO, GYPPY [n]\n",
  "GIPPOS": "GIPPO, (offensive) a gypsy, also GIPPY, GYPPIE, GYPPO, GYPPY [n]\n",
  "GIPPY": "(offensive) a gypsy, also GIPPO, GYPPIE, GYPPO, GYPPY [n GIPPIES]\n",
  "GIPS": "GIP, to swindle, also GYP [v]\n",
  "GIPSEN": "(Spenser) a gypsy [n -S]\n",
  "GIPSENS": "GIPSEN, (Spenser) a gypsy [n]\n",
  "GIPSIED": "GIPSY, to live like a gypsy (a wanderer), also GYPSY [v]\n",
  "GIPSIES": "GIPSY, to live like a gypsy (a wanderer), also GYPSY [v]\n",
  "GIPSY": "to live like a gypsy (a wanderer), also GYPSY [v GIPSIED, GIPSYING, GIPSIES]\n",
  "GIPSYDOM": "the world of gypsies, also GYPSYDOM [n -S]\n",
  "GIPSYDOMS": "GIPSYDOM, the world of gypsies, also GYPSYDOM [n]\n",
  "GIPSYHOOD": "the state of being a gypsy, also GYPSYHOOD [n -S]\n",
  "GIPSYHOODS": "GIPSYHOOD, the state of being a gypsy, also GYPSYHOOD [n]\n",
  "GIPSYING": "GIPSY, to live like a gypsy (a wanderer), also GYPSY [v]\n",
  "GIPSYISH": "like a gypsy, also GYPSYISH [adj]\n",
  "GIPSYISM": "the arts and practices or habits of gypsies; deception, also GYPSYISM [n -S]\n",
  "GIPSYISMS": "GIPSYISM, the arts and practices or habits of gypsies; deception, also GYPSYISM [n]\n",
  "GIPSYWORT": "a hairy Eurasian plant, having two-lipped white flowers with purple dots on the lower lip, also GYPSYWORT [n -S]\n",
  "GIPSYWORTS": "GIPSYWORT, a hairy Eurasian plant, having two-lipped white flowers with purple dots on the lower lip, also GYPSYWORT [n]\n",
  "GIRAFFE": "a long-necked mammal [n -S]\n",
  "GIRAFFES": "GIRAFFE, a long-necked mammal [n]\n",
  "GIRAFFID": "a member of the giraffe family (giraffes and okapis) [n -S]\n",
  "GIRAFFIDS": "GIRAFFID, a member of the giraffe family (giraffes and okapis) [n]\n",
  "GIRAFFINE": "of or like a giraffe, also GIRAFFISH, GIRAFFOID [adj]\n",
  "GIRAFFISH": "of or like a giraffe, also GIRAFFINE, GIRAFFOID [adj]\n",
  "GIRAFFOID": "of or like a giraffe, also GIRAFFINE, GIRAFFISH [adj]\n",
  "GIRANDOLA": "(Italian) a branched chandelier or similar structure, also GIRANDOLE [n -S]\n",
  "GIRANDOLAS": "GIRANDOLA, (Italian) a branched chandelier or similar structure, also GIRANDOLE [n]\n",
  "GIRANDOLE": "(French) a branched chandelier or similar structure, also GIRANDOLA [n -S]\n",
  "GIRANDOLES": "GIRANDOLE, (French) a branched chandelier or similar structure, also GIRANDOLA [n]\n",
  "GIRASOL": "(Italian) a variety of opal, also GIRASOLE, GIROSOL [n -S]\n",
  "GIRASOLE": "(Italian) a variety of opal, also GIRASOL, GIROSOL [n -S]\n",
  "GIRASOLES": "GIRASOLE, (Italian) a variety of opal, also GIRASOL, GIROSOL [n]\n",
  "GIRASOLS": "GIRASOL, (Italian) a variety of opal, also GIRASOLE, GIROSOL [n]\n",
  "GIRD": "to surround [v GIRDED or GIRT, GIRDING, GIRDS]\n",
  "GIRDED": "GIRD, to surround [v]\n",
  "GIRDER": "a large beam, esp. one made of steel, used in the construction of bridges, buildings, etc. [n -S]\n",
  "GIRDERS": "GIRDER, a large beam, esp. one made of steel, used in the construction of bridges, buildings, etc. [n]\n",
  "GIRDING": "that which girds, specifically a saddle-girth [n -S]\n",
  "GIRDINGLY": "GIRDING [adv]\n",
  "GIRDINGS": "GIRDING, that which girds, specifically a saddle-girth [n]\n",
  "GIRDLE": "to encircle with a belt [v GIRDLED, GIRDLING, GIRDLES]\n",
  "GIRDLECAKE": "a kind of scone, aka drop scone, also GIRDLESCONE [n -S]\n",
  "GIRDLECAKES": "GIRDLECAKE, a kind of scone, aka drop scone, also GIRDLESCONE [n]\n",
  "GIRDLED": "GIRDLE, to encircle with a belt [v]\n",
  "GIRDLER": "one who girdles [n -S]\n",
  "GIRDLERS": "GIRDLER, one who girdles [n]\n",
  "GIRDLES": "GIRDLE, to encircle with a belt [v]\n",
  "GIRDLESCONE": "a kind of scone, aka drop scone, also GIRDLECAKE [n -S]\n",
  "GIRDLESCONES": "GIRDLESCONE, a kind of scone, aka drop scone, also GIRDLECAKE [n]\n",
  "GIRDLESTEAD": "(obsolete) the waist [n -S]\n",
  "GIRDLESTEADS": "GIRDLESTEAD, (obsolete) the waist [n]\n",
  "GIRDLING": "GIRDLE, to encircle with a belt [v]\n",
  "GIRDS": "GIRD, to surround [v]\n",
  "GIRKIN": "(obsolete) a gherkin, also GHERKIN [n -S]\n",
  "GIRKINS": "GIRKIN, (obsolete) a gherkin, also GHERKIN [n]\n",
  "GIRL": "a female child [n -S]\n",
  "GIRLFRIEND": "a female friend [n -S]\n",
  "GIRLFRIENDS": "GIRLFRIEND, a female friend [n]\n",
  "GIRLHOOD": "the state of being a girl [n -S]\n",
  "GIRLHOODS": "GIRLHOOD, the state of being a girl [n]\n",
  "GIRLIE": "a girl, also GIRLY [n -S]\n",
  "GIRLIER": "GIRLY, like a girl [adj]\n",
  "GIRLIES": "GIRLIE, a girl, also GIRLY [n]\n",
  "GIRLIEST": "GIRLY, like a girl [adj]\n",
  "GIRLISH": "like a girl, or suitable for a girl [adj GIRLISHLY]\n",
  "GIRLISHLY": "GIRLISH, like a girl, or suitable for a girl [adv]\n",
  "GIRLISHNESS": "the state of being girlish [n -ES]\n",
  "GIRLISHNESSES": "GIRLISHNESS, the state of being girlish [n]\n",
  "GIRLOND": "a garland [n -S]\n",
  "GIRLONDS": "GIRLOND, a garland [n]\n",
  "GIRLS": "GIRL, a female child [n]\n",
  "GIRLY": "a girl, also GIRLIE [n GIRLIES] / like a girl [adj GIRLIER, GIRLIEST]\n",
  "GIRN": "(dialect) to grin, make faces, also GERNE, GURN [v -ED, -ING, -S]\n",
  "GIRNED": "GIRN, (dialect) to grin, make faces, also GERNE, GURN [v]\n",
  "GIRNEL": "(Scots) a granary; a large chest or vat for storing grain [n -S]\n",
  "GIRNELS": "GIRNEL, (Scots) a granary; a large chest or vat for storing grain [n]\n",
  "GIRNER": "one who girns, makes faces [n -S]\n",
  "GIRNERS": "GIRNER, one who girns, makes faces [n]\n",
  "GIRNIE": "ill-tempered [adj GIRNIER, GIRNIEST]\n",
  "GIRNIER": "GIRNIE, ill-tempered [adj]\n",
  "GIRNIEST": "GIRNIE, ill-tempered [adj]\n",
  "GIRNING": "GIRN, (dialect) to grin, make faces, also GERNE, GURN [v]\n",
  "GIRNS": "GIRN, (dialect) to grin, make faces, also GERNE, GURN [v]\n",
  "GIRO": "a system of credit transfer between banks, post offices, etc. [n -S]\n",
  "GIROLLE": "an edible mushroom, aka chanterelle [n -S]\n",
  "GIROLLES": "GIROLLE, an edible mushroom, aka chanterelle [n]\n",
  "GIRON": "a heraldic inverted vee, also GYRON [n -S]\n",
  "GIRONIC": "in the shape of a gyron, also GIRONNY, GYRONIC, GYRONNY [adj]\n",
  "GIRONNY": "in the shape of a gyron, also GIRONIC, GYRONIC, GYRONNY [adj]\n",
  "GIRONS": "GIRON, a heraldic inverted vee, also GYRON [n]\n",
  "GIROS": "GIRO, a system of credit transfer between banks, post offices, etc. [n]\n",
  "GIROSOL": "(Italian) a variety of opal, also GIRASOL, GIRASOLE [n -S]\n",
  "GIROSOLS": "GIROSOL, (Italian) a variety of opal, also GIRASOL, GIRASOLE [n]\n",
  "GIRR": "(Scots) a hoop, for a barrel or used as a child's plaything [n -S]\n",
  "GIRRS": "GIRR, (Scots) a hoop, for a barrel or used as a child's plaything [n]\n",
  "GIRSH": "(Arabic) a monetary unit of Saudi Arabia, also QURSH, GURSH, QURUSH [n -ES]\n",
  "GIRSHES": "GIRSH, (Arabic) a monetary unit of Saudi Arabia, also QURSH, GURSH, QURUSH [n]\n",
  "GIRT": "to gird, girth [v -ED, -ING, -S]\n",
  "GIRTED": "GIRT, to gird, girth [v]\n",
  "GIRTH": "the bellyband of a saddle [n -S] / to put a girth on [v -ED, -ING, -S]\n",
  "GIRTHED": "GIRTH, to put a girth on [v]\n",
  "GIRTHING": "GIRTH, to put a girth on [v]\n",
  "GIRTHLINE": "a gantline, a rope used in single-block hoist, also GIRTLINE [n -S]\n",
  "GIRTHLINES": "GIRTHLINE, a gantline, a rope used in single-block hoist, also GIRTLINE [n]\n",
  "GIRTHS": "GIRTH, to put a girth on [v]\n",
  "GIRTING": "GIRT, to gird, girth [v]\n",
  "GIRTLINE": "a gantline, a rope used in single-block hoist, also GIRTHLINE [n -S]\n",
  "GIRTLINES": "GIRTLINE, a gantline, a rope used in single-block hoist, also GIRTHLINE [n]\n",
  "GIRTS": "GIRT, to gird, girth [v]\n",
  "GIS": "GI, (Japanese) a loose-fitting white suit worn in judo, karate, and other martial arts [n]\n",
  "GISARME": "(historical) a long-shafted halberd with two-edged axe carried by a medieval foot soldier [n -S]\n",
  "GISARMES": "GISARME, (historical) a long-shafted halberd with two-edged axe carried by a medieval foot soldier [n]\n",
  "GISM": "(colloquial) energy, force; semen, also JISM, JISSOM [n -S]\n",
  "GISMO": "a gadget, also GIZMO [n -S]\n",
  "GISMOLOGIES": "GISMOLOGY, gadgetry, technology involving strange, baffling devices, also GIZMOLOGY [n]\n",
  "GISMOLOGY": "gadgetry, technology involving strange, baffling devices, also GIZMOLOGY [n GISMOLOGIES]\n",
  "GISMOS": "GISMO, a gadget, also GIZMO [n]\n",
  "GISMS": "GISM, (colloquial) energy, force; semen, also JISM, JISSOM [n]\n",
  "GIST": "the main point of a matter [n -S]\n",
  "GISTS": "GIST, the main point of a matter [n]\n",
  "GIT": "to get [v GITTED, GITTING, GITS]\n",
  "GITANA": "(Spanish) a female gypsy [n -S]\n",
  "GITANAS": "GITANA, (Spanish) a female gypsy [n]\n",
  "GITANO": "(Spanish) a male gypsy [n -S]\n",
  "GITANOS": "GITANO, (Spanish) a male gypsy [n]\n",
  "GITCH": "(Canadian) underpants, also GINCH, GONCH, GOTCH [n -ES]\n",
  "GITCHES": "GITCH, (Canadian) underpants, also GINCH, GONCH, GOTCH [n]\n",
  "GITE": "(French) in France, a farmhouse offering holiday accommodation [n -S]\n",
  "GITES": "GITE, (French) in France, a farmhouse offering holiday accommodation [n]\n",
  "GITS": "GIT [n]\n",
  "GITTARONE": "(Italian) an acoustic bass guitar [n -S]\n",
  "GITTARONES": "GITTARONE, (Italian) an acoustic bass guitar [n]\n",
  "GITTED": "GIT, to get [v]\n",
  "GITTERN": "to play a medieval guitar [v -ED, -ING, -S]\n",
  "GITTERNED": "GITTERN, to play a medieval guitar [v]\n",
  "GITTERNING": "GITTERN, to play a medieval guitar [v]\n",
  "GITTERNS": "GITTERN, to play a medieval guitar [v]\n",
  "GITTIN": "GET, a Jewish divorce [n]\n",
  "GITTING": "GIT, to get [v]\n",
  "GIUST": "(Spenser) to tilt with lances, also JOUST, JUST [v -ED, -ING, -S]\n",
  "GIUSTED": "GIUST, (Spenser) to tilt with lances, also JOUST, JUST [v]\n",
  "GIUSTING": "GIUST, (Spenser) to tilt with lances, also JOUST, JUST [v]\n",
  "GIUSTO": "(Italian) in just, correct, or suitable time [adv]\n",
  "GIUSTS": "GIUST, (Spenser) to tilt with lances, also JOUST, JUST [v]\n",
  "GIVABLE": "able to be given, also GIVEABLE [adj]\n",
  "GIVE": "to transfer freely to another's possession [v GAVE, GIVEN, GIVING, GIVES] / to put gyves on [v GIVED, GIVING, GIVES]\n",
  "GIVEABLE": "able to be given, also GIVABLE [adj]\n",
  "GIVEAWAY": "something given away for free [n -S]\n",
  "GIVEAWAYS": "GIVEAWAY, something given away for free [n]\n",
  "GIVEBACK": "a worker's benefit given back to management [n -S]\n",
  "GIVEBACKS": "GIVEBACK, a worker's benefit given back to management [n]\n",
  "GIVED": "GIVE, to transfer freely to another's possession [v]\n",
  "GIVEN": "something assigned as a basis for calculation [n -S]\n",
  "GIVENNESS": "the state of being given [n -ES]\n",
  "GIVENNESSES": "GIVENNESS, the state of being given [n]\n",
  "GIVENS": "GIVEN, something assigned as a basis for calculation [n]\n",
  "GIVER": "one that gives [n -S]\n",
  "GIVERS": "GIVER, one that gives [n]\n",
  "GIVES": "GIVE, to transfer freely to another's possession [v]\n",
  "GIVING": "the act of giving [n -S]\n",
  "GIVINGS": "GIVING, the act of giving [n]\n",
  "GIZMO": "a gadget, also GISMO [n -S]\n",
  "GIZMOLOGIES": "GIZMOLOGY, gadgetry, technology involving strange, baffling devices, also GISMOLOGY [n]\n",
  "GIZMOLOGY": "gadgetry, technology involving strange, baffling devices, also GISMOLOGY [n GIZMOLOGIES]\n",
  "GIZMOS": "GIZMO, a gadget, also GISMO [n]\n",
  "GIZZ": "(Scots) a wig, also JIZ [n -ES]\n",
  "GIZZARD": "the second, or true, muscular stomach of birds, in which the food is crushed and ground [n -S]\n",
  "GIZZARDS": "GIZZARD, the second, or true, muscular stomach of birds, in which the food is crushed and ground [n]\n",
  "GIZZEN": "(Scots) to shrink from dryness so as to leak [v -ED, -ING, -S]\n",
  "GIZZENED": "GIZZEN, (Scots) to shrink from dryness so as to leak [v]\n",
  "GIZZENING": "GIZZEN, (Scots) to shrink from dryness so as to leak [v]\n",
  "GIZZENS": "GIZZEN, (Scots) to shrink from dryness so as to leak [v]\n",
  "GIZZES": "GIZZ, (Scots) a wig, also JIZ [n]\n",
  "GJETOST": "(Norwegian) a hard brown Norwegian cheese made from goat's milk [n -S]\n",
  "GJETOSTS": "GJETOST, (Norwegian) a hard brown Norwegian cheese made from goat's milk [n]\n",
  "GJU": "an old Shetland viol, also GUE, GU [n -S]\n",
  "GJUS": "GJU, an old Shetland viol, also GUE, GU [n]\n",
  "GLABELLA": "(Latin) the smooth area between the eyebrows [n GLABELLAE]\n",
  "GLABELLAE": "GLABELLA, (Latin) the smooth area between the eyebrows [n]\n",
  "GLABELLAR": "relating to the glabella, the space between the eyebrows, just above the nose [adj]\n",
  "GLABRATE": "smooth, also GLABROUS [adj]\n",
  "GLABRESCENT": "becoming naked or devoid of covering at maturity [adj]\n",
  "GLABROUS": "smooth, also GLABRATE [adj]\n",
  "GLABROUSNESS": "the state of being glabrous [n -ES]\n",
  "GLABROUSNESSES": "GLABROUSNESS, the state of being glabrous [n]\n",
  "GLACE": "(French) to ice with sugar, candy [v GLACEED or GLACED, GLACEING, GLACES]\n",
  "GLACED": "GLACE, (French) to ice with sugar, candy [v]\n",
  "GLACEED": "GLACE, (French) to ice with sugar, candy [v]\n",
  "GLACEING": "GLACE, (French) to ice with sugar, candy [v]\n",
  "GLACES": "GLACE, (French) to ice with sugar, candy [v]\n",
  "GLACIAL": "very cold [adj GLACIALLY] / a glacial period [n -S]\n",
  "GLACIALIST": "a person who studies the geological effect of ice, also GLACIOLOGIST [n -S]\n",
  "GLACIALISTS": "GLACIALIST, a person who studies the geological effect of ice, also GLACIOLOGIST [n]\n",
  "GLACIALLY": "GLACIAL, very cold [adv]\n",
  "GLACIALS": "GLACIAL, a glacial period [n]\n",
  "GLACIATE": "to cover with glaciers [v GLACIATED, GLACIATING, GLACIATES]\n",
  "GLACIATED": "GLACIATE, to cover with glaciers [v]\n",
  "GLACIATES": "GLACIATE, to cover with glaciers [v]\n",
  "GLACIATING": "GLACIATE, to cover with glaciers [v]\n",
  "GLACIATION": "the formation, advance and retreat of glaciers and the results of these activities [n -S]\n",
  "GLACIATIONS": "GLACIATION, the formation, advance and retreat of glaciers and the results of these activities [n]\n",
  "GLACIER": "a huge mass of ice [n -S]\n",
  "GLACIERED": "having a glacier or glaciers [adj]\n",
  "GLACIERS": "GLACIER, a huge mass of ice [n]\n",
  "GLACIOLOGIC": "relating to glaciology, also GLACIOLOGICAL [adj]\n",
  "GLACIOLOGICAL": "relating to glaciology, also GLACIOLOGIC [adj]\n",
  "GLACIOLOGIES": "GLACIOLOGY, the study of ice ages and glaciation [n]\n",
  "GLACIOLOGIST": "a person who studies the geological effect of ice, also GLACIALIST [n -S]\n",
  "GLACIOLOGISTS": "GLACIOLOGIST, a person who studies the geological effect of ice, also GLACIALIST [n]\n",
  "GLACIOLOGY": "the study of ice ages and glaciation [n GLACIOLOGIES]\n",
  "GLACIS": "(French) a slope [n -ES]\n",
  "GLACISES": "GLACIS, (French) a slope [n]\n",
  "GLAD": "feeling pleasure [adj GLADDER, GLADDEST, GLADLY] / to make happy [v GLADDED, GLADDING, GLADS]\n",
  "GLADDED": "GLAD, to make happy [v]\n",
  "GLADDEN": "to make glad [v -ED, -ING, -S]\n",
  "GLADDENED": "GLADDEN, to make glad [v]\n",
  "GLADDENER": "one who gladdens [n -S]\n",
  "GLADDENERS": "GLADDENER, one who gladdens [n]\n",
  "GLADDENING": "GLADDEN, to make glad [v]\n",
  "GLADDENS": "GLADDEN, to make glad [v]\n",
  "GLADDER": "GLAD, feeling pleasure [adj]\n",
  "GLADDEST": "GLAD, feeling pleasure [adj]\n",
  "GLADDIE": "(short for) a gladiolus [n -S]\n",
  "GLADDIES": "GLADDIE, (short for) a gladiolus [n]\n",
  "GLADDING": "GLAD, to make happy [v]\n",
  "GLADDON": "(dialect) an iris [n -S]\n",
  "GLADDONS": "GLADDON, (dialect) an iris [n]\n",
  "GLADE": "an open space in a forest [n -S]\n",
  "GLADELIKE": "like a glade [adj]\n",
  "GLADES": "GLADE, an open space in a forest [n]\n",
  "GLADFUL": "(archaic) full of gladness; joyful [adj]\n",
  "GLADFULNESS": "(archaic) the quality of being gladful [n -ES]\n",
  "GLADFULNESSES": "GLADFULNESS, (archaic) the quality of being gladful [n]\n",
  "GLADIATE": "shaped like a sword [adj]\n",
  "GLADIATOR": "in ancient Rome, a professional combatant with men or wild animals in the arena [n -S]\n",
  "GLADIATORIAL": "of or like a gladiator, also GLADIATORIAN, GLADIATORY [adj]\n",
  "GLADIATORIAN": "(obsolete) of or like a gladiator, also GLADIATORIAL, GLADIATORY [adj]\n",
  "GLADIATORS": "GLADIATOR, in ancient Rome, a professional combatant with men or wild animals in the arena [n]\n",
  "GLADIATORSHIP": "the state of being a gladiator [n -S]\n",
  "GLADIATORSHIPS": "GLADIATORSHIP, the state of being a gladiator [n]\n",
  "GLADIATORY": "(obsolete) of or like a gladiator, also GLADIATORIAL, GLADIATORIAN [adj]\n",
  "GLADIER": "GLADY, full of glades [adj]\n",
  "GLADIEST": "GLADY, full of glades [adj]\n",
  "GLADIOLA": "a lilylike plant of the genus Gladiolus, also GLADIOLE, GLADIOLUS [n -S]\n",
  "GLADIOLAR": "like a gladiolus [adj]\n",
  "GLADIOLAS": "GLADIOLA, a lilylike plant of the genus Gladiolus, also GLADIOLE, GLADIOLUS [n]\n",
  "GLADIOLE": "a lilylike plant of the genus Gladiolus, also GLADIOLA, GLADIOLUS [n -S]\n",
  "GLADIOLES": "GLADIOLE, a lilylike plant of the genus Gladiolus, also GLADIOLA, GLADIOLUS [n]\n",
  "GLADIOLI": "GLADIOLUS, (Latin) a lilylike plant of the genus Gladiolus, also GLADIOLA, GLADIOLE [n]\n",
  "GLADIOLUS": "(Latin) a lilylike plant of the genus Gladiolus, also GLADIOLA, GLADIOLE [n GLADIOLUSES or GLADIOLI]\n",
  "GLADIOLUSES": "GLADIOLUS, (Latin) a lilylike plant of the genus Gladiolus, also GLADIOLA, GLADIOLE [n]\n",
  "GLADIUS": "(Latin) the internal shell, or pen, of cephalopods [n -ES]\n",
  "GLADIUSES": "GLADIUS, (Latin) the internal shell, or pen, of cephalopods [n]\n",
  "GLADLIER": "GLADLY, in a glad manner [adv]\n",
  "GLADLIEST": "GLADLY, in a glad manner [adv]\n",
  "GLADLY": "in a glad manner [adv GLADLIER, GLADLIEST]\n",
  "GLADNESS": "the state of being glad [n -ES]\n",
  "GLADNESSES": "GLADNESS, the state of being glad [n]\n",
  "GLADS": "GLAD, to make happy [v]\n",
  "GLADSOME": "feeling pleasure [adj GLADSOMER, GLADSOMEST, GLADSOMELY]\n",
  "GLADSOMELY": "GLADSOME, feeling pleasure [adv]\n",
  "GLADSOMENESS": "(archaic) the state of being gladsome [n -ES]\n",
  "GLADSOMENESSES": "GLADSOMENESS, (archaic) the state of being gladsome [n]\n",
  "GLADSOMER": "GLADSOME, feeling pleasure [adj]\n",
  "GLADSOMEST": "GLADSOME, feeling pleasure [adj]\n",
  "GLADSTONE": "a four-wheeled pleasure carriage with two inside seats, calash top, and seats for driver and footman [n -S]\n",
  "GLADSTONES": "GLADSTONE, a four-wheeled pleasure carriage with two inside seats, calash top, and seats for driver and footman [n]\n",
  "GLADWRAP": "a thin film to wrap in food [n -S] / to cover with gladwrap [v GLADWRAPPED, GLADWRAPPING, GLADWRAPS]\n",
  "GLADWRAPPED": "GLADWRAP, to cover with gladwrap [v]\n",
  "GLADWRAPPING": "GLADWRAP, to cover with gladwrap [v]\n",
  "GLADWRAPS": "GLADWRAP, to cover with gladwrap [v]\n",
  "GLADY": "full of glades [adj GLADIER, GLADIEST]\n",
  "GLAIK": "(Scots) a flash, a dazzle [n -S]\n",
  "GLAIKET": "(Scots) giddy, foolish, also GLAIKIT [adj]\n",
  "GLAIKETNESS": "the quality of being glaiket, giddy, foolish, also GLAIKITNESS [n -ES]\n",
  "GLAIKETNESSES": "GLAIKETNESS, the quality of being glaiket, giddy, foolish, also GLAIKITNESS [n]\n",
  "GLAIKIT": "(Scots) giddy, foolish, also GLAIKET [adj]\n",
  "GLAIKITNESS": "the quality of being glaikit, giddy, foolish, also GLAIKETNESS [n -ES]\n",
  "GLAIKITNESSES": "GLAIKITNESS, the quality of being glaikit, giddy, foolish, also GLAIKETNESS [n]\n",
  "GLAIKS": "GLAIK, (Scots) a flash, a dazzle [n]\n",
  "GLAIR": "to coat with egg white, also GLAIRE [v -ED, -ING, -S]\n",
  "GLAIRE": "to coat with egg white, also GLAIR [v GLAIRED, GLAIRING, GLAIRES]\n",
  "GLAIRED": "GLAIRE, to coat with egg white, also GLAIR [v]\n",
  "GLAIREOUS": "(archaic) slimy, viscous, also GLAREOUS [adj]\n",
  "GLAIRES": "GLAIRE, to coat with egg white, also GLAIR [v]\n",
  "GLAIRIER": "GLAIRY, resembling egg white [adj]\n",
  "GLAIRIEST": "GLAIRY, resembling egg white [adj]\n",
  "GLAIRIN": "a glairy viscous substance, which forms on the surface of certain mineral waters [n -S]\n",
  "GLAIRINESS": "the state of being glairy [n -ES]\n",
  "GLAIRINESSES": "GLAIRINESS, the state of being glairy [n]\n",
  "GLAIRING": "GLAIRE, to coat with egg white, also GLAIR [v]\n",
  "GLAIRINS": "GLAIRIN, a glairy viscous substance, which forms on the surface of certain mineral waters [n]\n",
  "GLAIRS": "GLAIR, to coat with egg white, also GLAIRE [v]\n",
  "GLAIRY": "resembling egg white [adj GLAIRIER, GLAIRIEST]\n",
  "GLAIVE": "(obsolete) a broadsword, also GLEAVE [n -S]\n",
  "GLAIVED": "provided with a glaive (a sword) [adj]\n",
  "GLAIVES": "GLAIVE, (obsolete) a broadsword, also GLEAVE [n]\n",
  "GLAM": "characterised by extravagant glamour [adj GLAMMER, GLAMMEST] / to glamourise [v GLAMMED, GLAMMING, GLAMS]\n",
  "GLAMMED": "GLAM, to glamourise [v]\n",
  "GLAMMER": "GLAM, characterised by extravagant glamour [adj]\n",
  "GLAMMEST": "GLAM, characterised by extravagant glamour [adj]\n",
  "GLAMMIER": "GLAMMY, glamorous [adj]\n",
  "GLAMMIEST": "GLAMMY, glamorous [adj]\n",
  "GLAMMING": "GLAM, to glamourise [v]\n",
  "GLAMMY": "glamorous [adj GLAMMIER, GLAMMIEST]\n",
  "GLAMOR": "to bewitch, also GLAMOUR [v -ED, -ING, -S]\n",
  "GLAMORED": "GLAMOR, to bewitch, also GLAMOUR [v]\n",
  "GLAMORING": "GLAMOR, to bewitch, also GLAMOUR [v]\n",
  "GLAMORISATION": "the process of glamorising, also GLAMORIZATION [n -S]\n",
  "GLAMORISATIONS": "GLAMORISATION, the process of glamorising, also GLAMORIZATION [n]\n",
  "GLAMORISE": "to make glamorous, also GLAMORIZE, GLAMOURISE, GLAMOURIZE [v GLAMORISED, GLAMORISING, GLAMORISES]\n",
  "GLAMORISED": "GLAMORISE, to make glamorous, also GLAMORIZE, GLAMOURISE, GLAMOURIZE [v]\n",
  "GLAMORISER": "one who glamorises, also GLAMORIZER [n -S]\n",
  "GLAMORISERS": "GLAMORISER, one who glamorises, also GLAMORIZER [n]\n",
  "GLAMORISES": "GLAMORISE, to make glamorous, also GLAMORIZE, GLAMOURISE, GLAMOURIZE [v]\n",
  "GLAMORISING": "GLAMORISE, to make glamorous, also GLAMORIZE, GLAMOURISE, GLAMOURIZE [v]\n",
  "GLAMORIZATION": "the process of glamorizing, also GLAMORISATION [n -S]\n",
  "GLAMORIZATIONS": "GLAMORIZATION, the process of glamorizing, also GLAMORISATION [n]\n",
  "GLAMORIZE": "to make glamorous, also GLAMORISE, GLAMOURISE, GLAMOURIZE [v GLAMORIZED, GLAMORIZING, GLAMORIZES]\n",
  "GLAMORIZED": "GLAMORIZE, to make glamorous, also GLAMORISE, GLAMOURISE, GLAMOURIZE [v]\n",
  "GLAMORIZER": "one who glamorizes, also GLAMORISER [n -S]\n",
  "GLAMORIZERS": "GLAMORIZER, one who glamorizes, also GLAMORISER [n]\n",
  "GLAMORIZES": "GLAMORIZE, to make glamorous, also GLAMORISE, GLAMOURISE, GLAMOURIZE [v]\n",
  "GLAMORIZING": "GLAMORIZE, to make glamorous, also GLAMORISE, GLAMOURISE, GLAMOURIZE [v]\n",
  "GLAMOROUS": "having glamour, also GLAMOUROUS [adj GLAMOROUSLY]\n",
  "GLAMOROUSLY": "GLAMOROUS, having glamour, also GLAMOUROUS [adv]\n",
  "GLAMOROUSNESS": "the state of being glamorous [n -ES]\n",
  "GLAMOROUSNESSES": "GLAMOROUSNESS, the state of being glamorous [n]\n",
  "GLAMORS": "GLAMOR, to bewitch, also GLAMOUR [v]\n",
  "GLAMOUR": "to bewitch, also GLAMOR [v -ED, -ING, -S]\n",
  "GLAMOURED": "GLAMOUR, to bewitch, also GLAMOR [v]\n",
  "GLAMOURING": "GLAMOUR, to bewitch, also GLAMOR [v]\n",
  "GLAMOURISE": "to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURIZE [v GLAMOURISED, GLAMOURISING, GLAMOURISES]\n",
  "GLAMOURISED": "GLAMOURISE, to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURIZE [v]\n",
  "GLAMOURISES": "GLAMOURISE, to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURIZE [v]\n",
  "GLAMOURISING": "GLAMOURISE, to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURIZE [v]\n",
  "GLAMOURIZE": "to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURISE [v GLAMOURIZED, GLAMOURIZING, GLAMOURIZES]\n",
  "GLAMOURIZED": "GLAMOURIZE, to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURISE [v]\n",
  "GLAMOURIZES": "GLAMOURIZE, to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURISE [v]\n",
  "GLAMOURIZING": "GLAMOURIZE, to make glamorous, also GLAMORISE, GLAMORIZE, GLAMOURISE [v]\n",
  "GLAMOURLESS": "without glamour [adj]\n",
  "GLAMOUROUS": "having glamour, also GLAMOROUS [adj GLAMOUROUSLY]\n",
  "GLAMOUROUSLY": "GLAMOUROUS, having glamour, also GLAMOROUS [adv]\n",
  "GLAMOUROUSNESS": "GLAMOUROUS, having glamour, also GLAMOROUS [n]\n",
  "GLAMOURPUSS": "a glamorous person, esp. female [n -ES]\n",
  "GLAMOURPUSSES": "GLAMOURPUSS, a glamorous person, esp. female [n]\n",
  "GLAMOURS": "GLAMOUR, to bewitch, also GLAMOR [v]\n",
  "GLAMPING": "a form of camping in which participants enjoy physical comforts associated with more luxurious types of holiday [n -S]\n",
  "GLAMPINGS": "GLAMPING, a form of camping in which participants enjoy physical comforts associated with more luxurious types of holiday [n]\n",
  "GLAMS": "GLAM, to glamourise [v]\n",
  "GLANCE": "to look quickly [v GLANCED or (obsolete) YGLAUNST, GLANCING, GLANCES]\n",
  "GLANCED": "GLANCE, to look quickly [v]\n",
  "GLANCER": "one who glances [n -S]\n",
  "GLANCERS": "GLANCER, one who glances [n]\n",
  "GLANCES": "GLANCE, to look quickly [v]\n",
  "GLANCING": "sliding off [adj GLANCINGLY] / the act of glancing [n -S]\n",
  "GLANCINGLY": "GLANCING, sliding off [adv]\n",
  "GLANCINGS": "GLANCING, the act of glancing [n]\n",
  "GLAND": "a secreting organ [n -S]\n",
  "GLANDERED": "affected with glanders [adj]\n",
  "GLANDEROUS": "of or pertaining to glanders, a disease of horses [adj]\n",
  "GLANDERS": "a disease of horses [n]\n",
  "GLANDES": "GLANS, (Latin) the tip of the penis or clitoris [n]\n",
  "GLANDIFEROUS": "bearing acorns or nuts [adj]\n",
  "GLANDIFORM": "gland-shaped; acorn-shaped [adj]\n",
  "GLANDLESS": "without glands [adj]\n",
  "GLANDLIKE": "like a gland [adj]\n",
  "GLANDS": "GLAND, a secreting organ [n]\n",
  "GLANDULAR": "of or relating to glands [adj GLANDULARLY]\n",
  "GLANDULARLY": "GLANDULAR, of or relating to glands [adv]\n",
  "GLANDULE": "a small gland or secreting vessel [n -S]\n",
  "GLANDULES": "GLANDULE, a small gland or secreting vessel [n]\n",
  "GLANDULIFEROUS": "bearing small glands [adj]\n",
  "GLANDULOUS": "containing glands; pertaining to glands [adj GLANDULOUSLY]\n",
  "GLANDULOUSLY": "GLANDULOUS, containing glands; pertaining to glands [adv]\n",
  "GLANS": "(Latin) the tip of the penis or clitoris [n GLANDES]\n",
  "GLARE": "to shine with a harshly brilliant light [v GLARED, GLARING, GLARES]\n",
  "GLAREAL": "growing on exposed dry land [adj]\n",
  "GLARED": "GLARE, to shine with a harshly brilliant light [v]\n",
  "GLARELESS": "without glare [adj]\n",
  "GLAREOUS": "growing on gravel; (archaic) slimy, viscous, also GLAIREOUS [adj]\n",
  "GLARES": "GLARE, to shine with a harshly brilliant light [v]\n",
  "GLARIER": "GLARY, glaring [adj]\n",
  "GLARIEST": "GLARY, glaring [adj]\n",
  "GLARINESS": "the state of being glary [n -ES]\n",
  "GLARINESSES": "GLARINESS, the state of being glary [n]\n",
  "GLARING": "GLARE, to shine with a harshly brilliant light [v]\n",
  "GLARINGLY": "GLARING, GLARE, to shine with a harshly brilliant light [adv]\n",
  "GLARINGNESS": "the quality of being glaring; obviousness [n -ES]\n",
  "GLARINGNESSES": "GLARINGNESS, the quality of being glaring; obviousness [n]\n",
  "GLARY": "glaring [adj GLARIER, GLARIEST]\n",
  "GLASNOST": "(Russian) the policy of openness and forthrightness under the premiership of Mikhail Gorbachev [n -S]\n",
  "GLASNOSTIAN": "in the spirit of glasnost, the policy of openness and forthrightness under the premiership of Mikhail Gorbachev, also GLASNOSTIC [adj]\n",
  "GLASNOSTIC": "in the spirit of glasnost, the policy of openness and forthrightness under the premiership of Mikhail Gorbachev, also GLASNOSTIAN [adj]\n",
  "GLASNOSTS": "GLASNOST, (Russian) the policy of openness and forthrightness under the premiership of Mikhail Gorbachev [n]\n",
  "GLASS": "to encase in glass (a transparent material) [v -ED, -ING, -ES]\n",
  "GLASSBLOWER": "one who blows glass [n -S]\n",
  "GLASSBLOWERS": "GLASSBLOWER, one who blows glass [n]\n",
  "GLASSBLOWING": "a process used in making glass [n -S]\n",
  "GLASSBLOWINGS": "GLASSBLOWING, a process used in making glass [n]\n",
  "GLASSCLOTH": "a cloth for cleaning glass, which does not leave fibres behind [n -S]\n",
  "GLASSCLOTHS": "GLASSCLOTH, a cloth for cleaning glass, which does not leave fibres behind [n]\n",
  "GLASSCUTTER": "a small hand tool that is specially designed for cutting sheets of glass [n -S]\n",
  "GLASSCUTTERS": "GLASSCUTTER, a small hand tool that is specially designed for cutting sheets of glass [n]\n",
  "GLASSED": "GLASS, to encase in glass (a transparent material) [v]\n",
  "GLASSEN": "like glass [adj]\n",
  "GLASSES": "GLASS, to encase in glass (a transparent material) [v]\n",
  "GLASSFUL": "as much as a drinking glass would hold [n -S]\n",
  "GLASSFULS": "GLASSFUL, as much as a drinking glass would hold [n]\n",
  "GLASSHOUSE": "a military detention barracks [n -S]\n",
  "GLASSHOUSES": "GLASSHOUSE, a military detention barracks [n]\n",
  "GLASSIE": "a type of playing marble [n -S]\n",
  "GLASSIER": "GLASSY, resembling glass [adj]\n",
  "GLASSIES": "GLASSIE, a type of playing marble [n]\n",
  "GLASSIEST": "GLASSY, resembling glass [adj]\n",
  "GLASSIFIED": "GLASSIFY, to become like glass [v]\n",
  "GLASSIFIES": "GLASSIFY, to become like glass [v]\n",
  "GLASSIFY": "to become like glass [v GLASSIFIED, GLASSIFYING, GLASSIFIES]\n",
  "GLASSIFYING": "GLASSIFY, to become like glass [v]\n",
  "GLASSILY": "GLASSY, resembling glass [adv]\n",
  "GLASSINE": "a transparent, glazed greaseproof paper [n -S]\n",
  "GLASSINES": "GLASSINE, a transparent, glazed greaseproof paper [n]\n",
  "GLASSINESS": "the state of being glassy [n -ES]\n",
  "GLASSINESSES": "GLASSINESS, the state of being glassy [n]\n",
  "GLASSING": "GLASS, to encase in glass (a transparent material) [v]\n",
  "GLASSLESS": "without glass [adj]\n",
  "GLASSLIKE": "like glass [adj]\n",
  "GLASSMAKER": "one that makes glass [n -S]\n",
  "GLASSMAKERS": "GLASSMAKER, one that makes glass [n]\n",
  "GLASSMAKING": "the act of making glass [n -S]\n",
  "GLASSMAKINGS": "GLASSMAKING, the act of making glass [n]\n",
  "GLASSMAN": "a maker or seller of glass [n GLASSMEN]\n",
  "GLASSMEN": "GLASSMAN, a maker or seller of glass [n]\n",
  "GLASSPAPER": "to sand with glasspaper (an abrasive composed of quartz granules on a paper backing) [v -ED, -ING, -S]\n",
  "GLASSPAPERED": "GLASSPAPER, to sand with glasspaper (an abrasive composed of quartz granules on a paper backing) [v]\n",
  "GLASSPAPERING": "GLASSPAPER, to sand with glasspaper (an abrasive composed of quartz granules on a paper backing) [v]\n",
  "GLASSPAPERS": "GLASSPAPER, to sand with glasspaper (an abrasive composed of quartz granules on a paper backing) [v]\n",
  "GLASSWARE": "ware, or articles collectively, made of glass [n -S]\n",
  "GLASSWARES": "GLASSWARE, ware, or articles collectively, made of glass [n]\n",
  "GLASSWORK": "articles or ornamentation made of glass [n -S]\n",
  "GLASSWORKER": "one who works with glass [n -S]\n",
  "GLASSWORKERS": "GLASSWORKER, one who works with glass [n]\n",
  "GLASSWORKS": "GLASSWORK, articles or ornamentation made of glass [n]\n",
  "GLASSWORM": "the larva of a gnat [n -S]\n",
  "GLASSWORMS": "GLASSWORM, the larva of a gnat [n]\n",
  "GLASSWORT": "a spinachlike plant of salt marshes, formerly burned for its ashes which yield soda [n -S]\n",
  "GLASSWORTS": "GLASSWORT, a spinachlike plant of salt marshes, formerly burned for its ashes which yield soda [n]\n",
  "GLASSY": "resembling glass [adj GLASSIER, GLASSIEST, GLASSILY]\n",
  "GLASSYHEADED": "(Tennyson) with a shiny bald head [adj]\n",
  "GLAUBERITE": "a greyish-white mineral, sodium calcium sulphate, found chiefly in rock salt [n -S]\n",
  "GLAUBERITES": "GLAUBERITE, a greyish-white mineral, sodium calcium sulphate, found chiefly in rock salt [n]\n",
  "GLAUCESCENCE": "the state of being glaucescent, somewhat glaucous [n -S]\n",
  "GLAUCESCENCES": "GLAUCESCENCE, the state of being glaucescent, somewhat glaucous [n]\n",
  "GLAUCESCENT": "slightly glaucous [adj]\n",
  "GLAUCOMA": "a disease of the eye, marked by increased pressure within the eyeball and growing dimness of vision [n -S]\n",
  "GLAUCOMAS": "GLAUCOMA, a disease of the eye, marked by increased pressure within the eyeball and growing dimness of vision [n]\n",
  "GLAUCOMATOUS": "affected by glaucoma [adj]\n",
  "GLAUCONITE": "a mineral now forming in the sea, a hydrated potassium iron and aluminium silicate, which gives a green colour to some of the beds of the Greensand [n -S]\n",
  "GLAUCONITES": "GLAUCONITE, a mineral now forming in the sea, a hydrated potassium iron and aluminium silicate, which gives a green colour to some of the beds of the Greensand [n]\n",
  "GLAUCONITIC": "of or like glauconite, a hydrated potassium iron and aluminium silicate [adj]\n",
  "GLAUCOUS": "sea-green; greyish-blue; covered with a powdery greenish or bluish bloom [adj GLAUCOUSLY]\n",
  "GLAUCOUSLY": "GLAUCOUS, sea-green; greyish-blue; covered with a powdery greenish or bluish bloom [adv]\n",
  "GLAUCOUSNESS": "the state of being glaucous [n -ES]\n",
  "GLAUCOUSNESSES": "GLAUCOUSNESS, the state of being glaucous [n]\n",
  "GLAUM": "(Scots) to clutch or grab, also GLOM [v -ED, -ING, -S]\n",
  "GLAUMED": "GLAUM, (Scots) to clutch or grab, also GLOM [v]\n",
  "GLAUMING": "GLAUM, (Scots) to clutch or grab, also GLOM [v]\n",
  "GLAUMS": "GLAUM, (Scots) to clutch or grab, also GLOM [v]\n",
  "GLAUR": "(Scots) mire [n -S]\n",
  "GLAURIER": "GLAURY, (Scots) miry [adj]\n",
  "GLAURIEST": "GLAURY, (Scots) miry [adj]\n",
  "GLAURS": "GLAUR, (Scots) mire [n]\n",
  "GLAURY": "(Scots) miry [adj GLAURIER, GLAURIEST]\n",
  "GLAZE": "to fit windows with glass panes [v GLAZED, GLAZING, GLAZES]\n",
  "GLAZED": "GLAZE, to fit windows with glass panes [v]\n",
  "GLAZEN": "(obsolete) resembling glass; glazed [adj]\n",
  "GLAZER": "one who applies glazing, as in pottery manufacture, etc. [n -S]\n",
  "GLAZERS": "GLAZER, one who applies glazing, as in pottery manufacture, etc. [n]\n",
  "GLAZES": "GLAZE, to fit windows with glass panes [v]\n",
  "GLAZIER": "one whose business is to set glass [n -S]\n",
  "GLAZIERIES": "GLAZIERY, the work of a glazier [n]\n",
  "GLAZIERS": "GLAZIER, one whose business is to set glass [n]\n",
  "GLAZIERY": "the work of a glazier [n GLAZIERIES]\n",
  "GLAZIEST": "GLAZY, covered with a smooth, glossy coating [adj]\n",
  "GLAZILY": "GLAZY, covered with a smooth, glossy coating [adv]\n",
  "GLAZINESS": "the state of being glazy [n -ES]\n",
  "GLAZINESSES": "GLAZINESS, the state of being glazy [n]\n",
  "GLAZING": "the work of a glazier [n -S]\n",
  "GLAZINGS": "GLAZING, the work of a glazier [n]\n",
  "GLAZY": "covered with a smooth, glossy coating [adj GLAZIER, GLAZIEST, GLAZILY]\n",
  "GLEAM": "to shine with a soft radiance [v -ED, -ING, -S]\n",
  "GLEAMED": "GLEAM, to shine with a soft radiance [v]\n",
  "GLEAMER": "one who gleams [n -S]\n",
  "GLEAMERS": "GLEAMER, one who gleams [n]\n",
  "GLEAMIER": "GLEAMY, gleaming [adj]\n",
  "GLEAMIEST": "GLEAMY, gleaming [adj]\n",
  "GLEAMING": "shining [adj GLEAMINGLY] / a shining [n -S]\n",
  "GLEAMINGLY": "GLEAMING, shining [adv]\n",
  "GLEAMINGS": "GLEAMING, a shining [n]\n",
  "GLEAMS": "GLEAM, to shine with a soft radiance [v]\n",
  "GLEAMY": "gleaming [adj GLEAMIER, GLEAMIEST]\n",
  "GLEAN": "to gather little by little [v -ED, -ING, -S]\n",
  "GLEANABLE": "that can be gleaned [adj]\n",
  "GLEANED": "GLEAN, to gather little by little [v]\n",
  "GLEANER": "one who gleans, gathers after reapers [n -S]\n",
  "GLEANERS": "GLEANER, one who gleans, gathers after reapers [n]\n",
  "GLEANING": "the residue of the harvest [n -S]\n",
  "GLEANINGS": "GLEANING, the residue of the harvest [n]\n",
  "GLEANS": "GLEAN, to gather little by little [v]\n",
  "GLEAVE": "a broadsword, also GLAIVE [n -S]\n",
  "GLEAVES": "GLEAVE, a broadsword, also GLAIVE [n]\n",
  "GLEBA": "(Latin) spore-bearing mass of some fungi [n GLEBAE]\n",
  "GLEBAE": "GLEBA, (Latin) spore-bearing mass of some fungi [n]\n",
  "GLEBE": "the land belonging to a parish church or ecclesiastical benefice [n -S]\n",
  "GLEBELESS": "without a glebe, the land belonging to a parish church or ecclesiastical benefice [adj]\n",
  "GLEBES": "GLEBE, the land belonging to a parish church or ecclesiastical benefice [n]\n",
  "GLEBIER": "GLEBY, (archaic) cloddy, turfy, also GLEBOUS [adj]\n",
  "GLEBIEST": "GLEBY, (archaic) cloddy, turfy, also GLEBOUS [adj]\n",
  "GLEBOUS": "(archaic) cloddy, turfy, also GLEBY [adj]\n",
  "GLEBY": "(archaic) cloddy, turfy, also GLEBOUS [adj GLEBIER, GLEBIEST]\n",
  "GLED": "a bird of prey, also GLEDE [n -S]\n",
  "GLEDE": "a bird of prey, also GLED [n -S]\n",
  "GLEDES": "GLEDE, a bird of prey, also GLED [n]\n",
  "GLEDGE": "to squint the eyes [v GLEDGED, GLEDGING, GLEDGES]\n",
  "GLEDGED": "GLEDGE, to squint the eyes [v]\n",
  "GLEDGES": "GLEDGE, to squint the eyes [v]\n",
  "GLEDGING": "GLEDGE, to squint the eyes [v]\n",
  "GLEDS": "GLED, a bird of prey, also GLEDE [n]\n",
  "GLEE": "(Scots) to squint [v GLEED, GLEEING, GLEES]\n",
  "GLEED": "a glowing coal [n -S]\n",
  "GLEEDS": "GLEED, a glowing coal [n]\n",
  "GLEEFUL": "merry, also GLEESOME [adj GLEEFULLY]\n",
  "GLEEFULLY": "GLEEFUL, merry, also GLEESOME [adv]\n",
  "GLEEFULNESS": "the state of being gleeful [n -ES]\n",
  "GLEEFULNESSES": "GLEEFULNESS, the state of being gleeful [n]\n",
  "GLEEING": "GLEE, (Scots) to squint [v]\n",
  "GLEEK": "to jest, gibe [v -ED, -ING, -S]\n",
  "GLEEKED": "GLEEK, to jest, gibe [v]\n",
  "GLEEKING": "GLEEK, to jest, gibe [v]\n",
  "GLEEKS": "GLEEK, to jest, gibe [v]\n",
  "GLEEMAIDEN": "(obsolete) a female gleeman or minstrel [n -S]\n",
  "GLEEMAIDENS": "GLEEMAIDEN, (obsolete) a female gleeman or minstrel [n]\n",
  "GLEEMAN": "(obsolete) an itinerant minstrel or musician [n GLEEMEN]\n",
  "GLEEMEN": "GLEEMAN, (obsolete) an itinerant minstrel or musician [n]\n",
  "GLEENIE": "(dialect) a guinea fowl [n -S]\n",
  "GLEENIES": "GLEENIE, (dialect) a guinea fowl [n]\n",
  "GLEES": "GLEE, (Scots) to squint [v]\n",
  "GLEESOME": "merry, also GLEEFUL [adj]\n",
  "GLEET": "to discharge mucus from the urethra [v -ED, -ING, -S]\n",
  "GLEETED": "GLEET, to discharge mucus from the urethra [v]\n",
  "GLEETIER": "GLEETY, resembling mucus, slimy [adj]\n",
  "GLEETIEST": "GLEETY, resembling mucus, slimy [adj]\n",
  "GLEETING": "GLEET, to discharge mucus from the urethra [v]\n",
  "GLEETS": "GLEET, to discharge mucus from the urethra [v]\n",
  "GLEETY": "resembling mucus, slimy [adj GLEETIER, GLEETIEST]\n",
  "GLEG": "(Scots) quick, sharp [adj GLEGGER, GLEGGEST, GLEGLY]\n",
  "GLEGGER": "GLEG, (Scots) quick, sharp [adj]\n",
  "GLEGGEST": "GLEG, (Scots) quick, sharp [adj]\n",
  "GLEGLY": "GLEG, (Scots) quick, sharp [adv]\n",
  "GLEGNESS": "alertness [n -ES]\n",
  "GLEGNESSES": "GLEGNESS, alertness [n]\n",
  "GLEI": "(Russian) a sticky clay soil [n -S]\n",
  "GLEIS": "GLEI, (Russian) a sticky clay soil [n]\n",
  "GLEISATION": "the process of forming a glei, a sticky clay soil, also GLEIZATION [n -S]\n",
  "GLEISATIONS": "GLEISATION, the process of forming a glei, a sticky clay soil, also GLEIZATION [n]\n",
  "GLEIZATION": "the process of forming a glei, a sticky clay soil, also GLEISATION [n -S]\n",
  "GLEIZATIONS": "GLEIZATION, the process of forming a glei, a sticky clay soil, also GLEISATION [n]\n",
  "GLEN": "a narrow valley with a stream, often with trees [n -S]\n",
  "GLENDOVEER": "(Southey) a heavenly spirit [n -S]\n",
  "GLENDOVEERS": "GLENDOVEER, (Southey) a heavenly spirit [n]\n",
  "GLENGARRIES": "GLENGARRY, a Highlander's cap of woollen cloth [n]\n",
  "GLENGARRY": "a Highlander's cap of woollen cloth [n GLENGARRIES]\n",
  "GLENLIKE": "like a glen [adj]\n",
  "GLENOID": "slightly cupped; socket-shaped, also GLENOIDAL [adj] / a cup-shaped socket [n -S]\n",
  "GLENOIDAL": "slightly cupped; socket-shaped, also GLENOID [adj]\n",
  "GLENOIDS": "GLENOID, a cup-shaped socket [n]\n",
  "GLENS": "GLEN, a narrow valley with a stream, often with trees [n]\n",
  "GLENT": "to glint [v -ED, -ING, -S]\n",
  "GLENTED": "GLENT, to glint [v]\n",
  "GLENTING": "GLENT, to glint [v]\n",
  "GLENTS": "GLENT, to glint [v]\n",
  "GLEY": "(Scots) to squint [v -ED, -ING, -S]\n",
  "GLEYED": "GLEY, (Scots) to squint [v]\n",
  "GLEYING": "the development of gley, a sticky clay soil [n -S]\n",
  "GLEYINGS": "GLEYING, the development of gley, a sticky clay soil [n]\n",
  "GLEYS": "GLEY, (Scots) to squint [v]\n",
  "GLIA": "(Greek) the supporting tissue of the brain and spinal cord, also NEUROGLIA [n -S]\n",
  "GLIADIN": "one of a group of proteins found in wheat and rye, aka prolamine, also GLIADINE [n -S]\n",
  "GLIADINE": "one of a group of proteins found in wheat and rye, aka prolamine, also GLIADIN [n -S]\n",
  "GLIADINES": "GLIADINE, one of a group of proteins found in wheat and rye, aka prolamine, also GLIADIN [n]\n",
  "GLIADINS": "GLIADIN, one of a group of proteins found in wheat and rye, aka prolamine, also GLIADINE [n]\n",
  "GLIAL": "like a glia, the connective tissue framework which supports the nervous matter and blood vessels of the brain and spinal cord [adj]\n",
  "GLIAS": "GLIA, (Greek) the supporting tissue of the brain and spinal cord, also NEUROGLIA [n]\n",
  "GLIB": "to make plausible [v GLIBBED, GLIBBING, GLIBS] / fluent and plausible [adj GLIBBER, GLIBBEST, GLIBLY]\n",
  "GLIBBED": "GLIB, to make plausible [v]\n",
  "GLIBBER": "GLIB, fluent and plausible [adj]\n",
  "GLIBBERY": "(obsolete) slippery [adj]\n",
  "GLIBBEST": "GLIB, fluent and plausible [adj]\n",
  "GLIBBING": "GLIB, to make plausible [v]\n",
  "GLIBLY": "GLIB, fluent and plausible [adv]\n",
  "GLIBNESS": "the quality of being glib [n -ES]\n",
  "GLIBNESSES": "GLIBNESS, the quality of being glib [n]\n",
  "GLIBS": "GLIB, to make plausible [v]\n",
  "GLID": "(Scots) slippery, also GLIDDERY [adj GLIDDER, GLIDDEST]\n",
  "GLIDDER": "GLID, (Scots) slippery, also GLIDDERY [adj]\n",
  "GLIDDERY": "(Scots) slippery, also GLID [adj]\n",
  "GLIDDEST": "GLID, (Scots) slippery, also GLIDDERY [adj]\n",
  "GLIDE": "to move effortlessly [v GLIDED or (obsolete) GLODE, GLIDING, GLIDES]\n",
  "GLIDED": "GLIDE, to move effortlessly [v]\n",
  "GLIDEPATH": "the path followed by an aircraft coming in to land [n -S]\n",
  "GLIDEPATHS": "GLIDEPATH, the path followed by an aircraft coming in to land [n]\n",
  "GLIDER": "a type of aircraft [n -S]\n",
  "GLIDERS": "GLIDER, a type of aircraft [n]\n",
  "GLIDES": "GLIDE, to move effortlessly [v]\n",
  "GLIDING": "the act of gliding [n -S]\n",
  "GLIDINGLY": "GLIDING [adv]\n",
  "GLIDINGS": "GLIDING, the act of gliding [n]\n",
  "GLIFF": "an unexpected view of something that startles one; a sudden fear, also GLIFT [n -S]\n",
  "GLIFFING": "the time required to give a glance, an instant [n -S]\n",
  "GLIFFINGS": "GLIFFING, the time required to give a glance, an instant [n]\n",
  "GLIFFS": "GLIFF, an unexpected view of something that startles one; a sudden fear, also GLIFT [n]\n",
  "GLIFT": "(obsolete) an unexpected view of something that startles one; a sudden fear, also GLIFF [n -S]\n",
  "GLIFTS": "GLIFT, (obsolete) an unexpected view of something that startles one; a sudden fear, also GLIFF [n]\n",
  "GLIKE": "(Shakespeare) a sneer; a flout [n -S]\n",
  "GLIKES": "GLIKE, (Shakespeare) a sneer; a flout [n]\n",
  "GLIM": "a light or lamp [n -S]\n",
  "GLIME": "to glance slyly [v GLIMED, GLIMING, GLIMES]\n",
  "GLIMED": "GLIME, to glance slyly [v]\n",
  "GLIMES": "GLIME, to glance slyly [v]\n",
  "GLIMING": "GLIME, to glance slyly [v]\n",
  "GLIMMER": "to shine faintly or unsteadily [v -ED, -ING, -S]\n",
  "GLIMMERED": "GLIMMER, to shine faintly or unsteadily [v]\n",
  "GLIMMERIER": "GLIMMERY, glimmering [adj]\n",
  "GLIMMERIEST": "GLIMMERY, glimmering [adj]\n",
  "GLIMMERING": "shining faintly [adj GLIMMERINGLY] / a faint shining [n -S]\n",
  "GLIMMERINGLY": "GLIMMERING, shining faintly [adv]\n",
  "GLIMMERINGS": "GLIMMERING, a faint shining [n]\n",
  "GLIMMERS": "GLIMMER, to shine faintly or unsteadily [v]\n",
  "GLIMMERY": "glimmering [adj GLIMMERIER, GLIMMERIEST]\n",
  "GLIMPSE": "to see for an instant [v GLIMPSED, GLIMPSING, GLIMPSES]\n",
  "GLIMPSED": "GLIMPSE, to see for an instant [v]\n",
  "GLIMPSER": "one who glimpses [n -S]\n",
  "GLIMPSERS": "GLIMPSER, one who glimpses [n]\n",
  "GLIMPSES": "GLIMPSE, to see for an instant [v]\n",
  "GLIMPSING": "GLIMPSE, to see for an instant [v]\n",
  "GLIMS": "GLIM, a light or lamp [n]\n",
  "GLINT": "to glitter, also GLENT [v -ED, -ING, -S]\n",
  "GLINTED": "GLINT, to glitter, also GLENT [v]\n",
  "GLINTIER": "GLINTY, glittering [adj]\n",
  "GLINTIEST": "GLINTY, glittering [adj]\n",
  "GLINTING": "GLINT, to glitter, also GLENT [v]\n",
  "GLINTS": "GLINT, to glitter, also GLENT [v]\n",
  "GLINTY": "glittering [adj GLINTIER, GLINTIEST]\n",
  "GLIOBLASTOMA": "a malignant tumour of the central nervous system [n GLIOBLASTOMAS or GLIOBLASTOMATA]\n",
  "GLIOBLASTOMAS": "GLIOBLASTOMA, a malignant tumour of the central nervous system [n]\n",
  "GLIOBLASTOMATA": "GLIOBLASTOMA, a malignant tumour of the central nervous system [n]\n",
  "GLIOMA": "a tumour of the neuroglia in the brain [n GLIOMAS or GLIOMATA]\n",
  "GLIOMAS": "GLIOMA, a tumour of the neuroglia in the brain [n]\n",
  "GLIOMATA": "GLIOMA, a tumour of the neuroglia in the brain [n]\n",
  "GLIOMATOSES": "GLIOMATOSIS, diffuse overgrowth of neuroglia in the brain or spinal cord [n]\n",
  "GLIOMATOSIS": "diffuse overgrowth of neuroglia in the brain or spinal cord [n GLIOMATOSES]\n",
  "GLIOMATOUS": "relating to a glioma, a tumour of the neuroglia in the brain [adj]\n",
  "GLIOSES": "GLIOSIS, excessive growth of fibrous tissues in the neuroglia [n]\n",
  "GLIOSIS": "excessive growth of fibrous tissues in the neuroglia [n GLIOSES]\n",
  "GLISK": "(Scots) a glimpse [n -S]\n",
  "GLISKS": "GLISK, (Scots) a glimpse [n]\n",
  "GLISSADE": "(French) to perform a gliding dance step [v GLISSADED, GLISSADING, GLISSADES]\n",
  "GLISSADED": "GLISSADE, (French) to perform a gliding dance step [v]\n",
  "GLISSADER": "one who glissades [n -S]\n",
  "GLISSADERS": "GLISSADER, one who glissades [n]\n",
  "GLISSADES": "GLISSADE, (French) to perform a gliding dance step [v]\n",
  "GLISSADING": "GLISSADE, (French) to perform a gliding dance step [v]\n",
  "GLISSANDI": "GLISSANDO, (Italian) a gliding effect [n]\n",
  "GLISSANDO": "(Italian) a gliding effect [n GLISSANDOS or GLISSANDI]\n",
  "GLISSANDOS": "GLISSANDO, (Italian) a gliding effect [n]\n",
  "GLISSE": "a kind of gliding dance step [n -S]\n",
  "GLISSES": "GLISSE, a kind of gliding dance step [n]\n",
  "GLISTEN": "to sparkle or shine; esp. to shine with a mild and fitful luster [v -ED, -ING, -S]\n",
  "GLISTENED": "GLISTEN, to sparkle or shine; esp. to shine with a mild and fitful luster [v]\n",
  "GLISTENING": "GLISTEN, to sparkle or shine; esp. to shine with a mild and fitful luster [v]\n",
  "GLISTENINGLY": "GLISTENING, GLISTEN, to sparkle or shine; esp. to shine with a mild and fitful luster [adv]\n",
  "GLISTENS": "GLISTEN, to sparkle or shine; esp. to shine with a mild and fitful luster [v]\n",
  "GLISTER": "(archaic) to be bright; to sparkle [v -ED, -ING, -S]\n",
  "GLISTERED": "GLISTER, (archaic) to be bright; to sparkle [v]\n",
  "GLISTERING": "GLISTER, (archaic) to be bright; to sparkle [v]\n",
  "GLISTERINGLY": "GLISTERING, GLISTER, (archaic) to be bright; to sparkle [adv]\n",
  "GLISTERS": "GLISTER, (archaic) to be bright; to sparkle [v]\n",
  "GLIT": "(obsolete) sticky, slimy or greasy material [n -S]\n",
  "GLITCH": "(Yiddish) a malfunction [n -ES]\n",
  "GLITCHES": "GLITCH, (Yiddish) a malfunction [n]\n",
  "GLITCHIER": "GLITCHY, characterised by glitches [adj]\n",
  "GLITCHIEST": "GLITCHY, characterised by glitches [adj]\n",
  "GLITCHY": "characterised by glitches [adj GLITCHIER, GLITCHIEST]\n",
  "GLITS": "GLIT, (obsolete) sticky, slimy or greasy material [n]\n",
  "GLITTER": "to sparkle [v -ED, -ING, -S]\n",
  "GLITTERAND": "(Spenser) glittering [adj]\n",
  "GLITTERATI": "the society lions of the day [n]\n",
  "GLITTERED": "GLITTER, to sparkle [v]\n",
  "GLITTERIER": "GLITTERY, glittering [adj]\n",
  "GLITTERIEST": "GLITTERY, glittering [adj]\n",
  "GLITTERING": "sparkling with light, also GLITTERAND [adj GLITTERINGLY] / a glitter [n -S]\n",
  "GLITTERINGLY": "GLITTERING [adv]\n",
  "GLITTERINGS": "GLITTERING, a glitter [n]\n",
  "GLITTERS": "GLITTER, to sparkle [v]\n",
  "GLITTERY": "glittering [adj GLITTERIER, GLITTERIEST]\n",
  "GLITZ": "to make something glitzy, more attractive [v -ED, -ING, -ES]\n",
  "GLITZED": "GLITZ, to make something glitzy, more attractive [v]\n",
  "GLITZES": "GLITZ, to make something glitzy, more attractive [v]\n",
  "GLITZIER": "GLITZY, showy, garish [adj]\n",
  "GLITZIEST": "GLITZY, showy, garish [adj]\n",
  "GLITZILY": "GLITZY, showy, garish [adv]\n",
  "GLITZINESS": "the quality of being glitzy [n -ES]\n",
  "GLITZINESSES": "GLITZINESS, the quality of being glitzy [n]\n",
  "GLITZING": "GLITZ, to make something glitzy, more attractive [v]\n",
  "GLITZY": "showy, garish [adj GLITZIER, GLITZIEST, GLITZILY]\n",
  "GLOAM": "twilight, also GLOAMING, GLOOMING [n -S]\n",
  "GLOAMING": "twilight, also GLOAM, GLOOMING [n -S]\n",
  "GLOAMINGS": "GLOAMING, twilight, also GLOAM, GLOOMING [n]\n",
  "GLOAMS": "GLOAM, twilight, also GLOAMING, GLOOMING [n]\n",
  "GLOAT": "to regard with great or excessive satisfaction [v -ED, -ING, -S]\n",
  "GLOATED": "GLOAT, to regard with great or excessive satisfaction [v]\n",
  "GLOATER": "one who gloats [n -S]\n",
  "GLOATERS": "GLOATER, one who gloats [n]\n",
  "GLOATING": "the act of exulting [n -S]\n",
  "GLOATINGLY": "GLOATING [adv]\n",
  "GLOATINGS": "GLOATING, the act of exulting [n]\n",
  "GLOATS": "GLOAT, to regard with great or excessive satisfaction [v]\n",
  "GLOB": "a roundish drop or dollop of a semiliquid substance, esp. mucus [n -S]\n",
  "GLOBAL": "worldwide or comprehensive [adj GLOBALLY]\n",
  "GLOBALISATION": "the process of globalising, also GLOBALIZATION [n -S]\n",
  "GLOBALISATIONS": "GLOBALISATION, the process of globalising, also GLOBALIZATION [n]\n",
  "GLOBALISE": "to make global, also GLOBALIZE [v GLOBALISED, GLOBALISING, GLOBALISES]\n",
  "GLOBALISED": "GLOBALISE, to make global, also GLOBALIZE [v]\n",
  "GLOBALISES": "GLOBALISE, to make global, also GLOBALIZE [v]\n",
  "GLOBALISING": "GLOBALISE, to make global, also GLOBALIZE [v]\n",
  "GLOBALISM": "internationalism [n -S]\n",
  "GLOBALISMS": "GLOBALISM, internationalism [n]\n",
  "GLOBALIST": "relating to a global approach to economic etc. issues [adj] / a person advocating a global approach [n -S]\n",
  "GLOBALISTS": "GLOBALIST, a person advocating a global approach [n]\n",
  "GLOBALIZATION": "the process of globalizing, also GLOBALISATION [n -S]\n",
  "GLOBALIZATIONS": "GLOBALIZATION, the process of globalizing, also GLOBALISATION [n]\n",
  "GLOBALIZE": "to make global, also GLOBALISE [v GLOBALIZED, GLOBALIZING, GLOBALIZES]\n",
  "GLOBALIZED": "GLOBALIZE, to make global, also GLOBALISE [v]\n",
  "GLOBALIZES": "GLOBALIZE, to make global, also GLOBALISE [v]\n",
  "GLOBALIZING": "GLOBALIZE, to make global, also GLOBALISE [v]\n",
  "GLOBALLY": "GLOBAL, worldwide or comprehensive [adv]\n",
  "GLOBATE": "having the form of a globe, also GLOBATED [adj]\n",
  "GLOBATED": "spherical, also GLOBATE [adj]\n",
  "GLOBBIER": "GLOBBY, full of globs [adj]\n",
  "GLOBBIEST": "GLOBBY, full of globs [adj]\n",
  "GLOBBY": "full of globs [adj GLOBBIER, GLOBBIEST]\n",
  "GLOBE": "to form into a spherical body [v GLOBED, GLOBING, GLOBES]\n",
  "GLOBED": "GLOBE, to form into a spherical body [v]\n",
  "GLOBEFISH": "a fish that can suck in water or air and distend the body to a more or less globular form [n -ES]\n",
  "GLOBEFISHES": "GLOBEFISH, a fish that can suck in water or air and distend the body to a more or less globular form [n]\n",
  "GLOBEFLOWER": "a plant of damp places, with a round yellow head [n -S]\n",
  "GLOBEFLOWERS": "GLOBEFLOWER, a plant of damp places, with a round yellow head [n]\n",
  "GLOBELIKE": "like a globe [adj]\n",
  "GLOBES": "GLOBE, to form into a spherical body [v]\n",
  "GLOBESITIES": "GLOBESITY, obesity seen as a worldwide social problem [n]\n",
  "GLOBESITY": "obesity seen as a worldwide social problem [n GLOBESITIES]\n",
  "GLOBETROT": "to travel the world [v GLOBETROTTED, GLOBETROTTING, GLOBETROTS]\n",
  "GLOBETROTS": "GLOBETROT, to travel the world [v]\n",
  "GLOBETROTTED": "GLOBETROT, to travel the world [v]\n",
  "GLOBETROTTER": "one who travels the world [n -S]\n",
  "GLOBETROTTERS": "GLOBETROTTER, one who travels the world [n]\n",
  "GLOBETROTTING": "travelling the world [n -S]\n",
  "GLOBETROTTINGS": "GLOBETROTTING, travelling the world [n]\n",
  "GLOBI": "GLOBUS, (Latin) any spherelike structure [n]\n",
  "GLOBIER": "GLOBY, (Milton) round [adj]\n",
  "GLOBIEST": "GLOBY, (Milton) round [adj]\n",
  "GLOBIGERINA": "a minute marine invertebrate of the genus Globigerina, with a calcareous shell of globose chambers in a spiral [n GLOBIGERINAE or GLOBIGERINAS]\n",
  "GLOBIGERINAE": "GLOBIGERINA, a minute marine invertebrate of the genus Globigerina, with a calcareous shell of globose chambers in a spiral [n]\n",
  "GLOBIGERINAS": "GLOBIGERINA, a minute marine invertebrate of the genus Globigerina, with a calcareous shell of globose chambers in a spiral [n]\n",
  "GLOBIN": "a protein constituent of haemoglobin [n -S]\n",
  "GLOBING": "GLOBE, to form into a spherical body [v]\n",
  "GLOBINS": "GLOBIN, a protein constituent of haemoglobin [n]\n",
  "GLOBOID": "a globelike shape [n -S]\n",
  "GLOBOIDS": "GLOBOID, a globelike shape [n]\n",
  "GLOBOSE": "shaped like a globe, also GLOBOUS [adj GLOBOSELY]\n",
  "GLOBOSELY": "GLOBOSE, shaped like a globe, also GLOBOUS [adv]\n",
  "GLOBOSENESS": "the state of being globose [n -ES]\n",
  "GLOBOSENESSES": "GLOBOSENESS, the state of being globose [n]\n",
  "GLOBOSITIES": "GLOBOSITY, sphericity [n]\n",
  "GLOBOSITY": "sphericity [n GLOBOSITIES]\n",
  "GLOBOUS": "having a rounded form resembling that of a globe, also GLOBOSE [adj]\n",
  "GLOBS": "GLOB, a roundish drop or dollop of a semiliquid substance, esp. mucus [n]\n",
  "GLOBULAR": "spherical [adj GLOBULARLY] / a globular star cluster [n -S]\n",
  "GLOBULARITIES": "GLOBULARITY, the quality of being globular [n]\n",
  "GLOBULARITY": "the quality of being globular [n GLOBULARITIES]\n",
  "GLOBULARLY": "GLOBULAR, spherical [adv]\n",
  "GLOBULARNESS": "the state of being globular [n -ES]\n",
  "GLOBULARNESSES": "GLOBULARNESS, the state of being globular [n]\n",
  "GLOBULARS": "GLOBULAR, a globular star cluster [n]\n",
  "GLOBULE": "a small spherical mass [n -S]\n",
  "GLOBULES": "GLOBULE, a small spherical mass [n]\n",
  "GLOBULET": "a little globule [n -S]\n",
  "GLOBULETS": "GLOBULET, a little globule [n]\n",
  "GLOBULIFEROUS": "bearing globules [adj]\n",
  "GLOBULIN": "any of a group of simple proteins, including gamma globulin [n -S]\n",
  "GLOBULINS": "GLOBULIN, any of a group of simple proteins, including gamma globulin [n]\n",
  "GLOBULITE": "a rudimentary form of crystallite, spherical in shape [n -S]\n",
  "GLOBULITES": "GLOBULITE, a rudimentary form of crystallite, spherical in shape [n]\n",
  "GLOBULOUS": "globular, spherical [adj]\n",
  "GLOBUS": "(Latin) any spherelike structure [n GLOBI]\n",
  "GLOBY": "(Milton) round [adj GLOBIER, GLOBIEST]\n",
  "GLOCHID": "(Greek) a barbed hair on some plants, like cactus [n -S]\n",
  "GLOCHIDIA": "GLOCHIDIUM, (Latin) the larva of a freshwater mussel that develops as a parasite on fish [n]\n",
  "GLOCHIDIATE": "like a glochidium, the larva of a freshwater mussel that develops as a parasite on fish [adj]\n",
  "GLOCHIDIUM": "(Latin) the larva of a freshwater mussel that develops as a parasite on fish [n GLOCHIDIA]\n",
  "GLOCHIDS": "GLOCHID, (Greek) a barbed hair on some plants, like cactus [n]\n",
  "GLOCKENSPIEL": "(German) a musical instrument, a set of bells [n -S]\n",
  "GLOCKENSPIELS": "GLOCKENSPIEL, (German) a musical instrument, a set of bells [n]\n",
  "GLODE": "GLIDE, to move effortlessly [v]\n",
  "GLOGG": "(Swedish) a hot spiced wine and liquor punch served in Scandinavian countries as a Christmas drink [n -S]\n",
  "GLOGGS": "GLOGG, (Swedish) a hot spiced wine and liquor punch served in Scandinavian countries as a Christmas drink [n]\n",
  "GLOIRE": "(French) glory [n -S]\n",
  "GLOIRES": "GLOIRE, (French) glory [n]\n",
  "GLOM": "to steal, take a look, also GLAUM [v GLOMMED, GLOMMING, GLOMS]\n",
  "GLOMERA": "GLOMUS, (Latin) a small body consisting of blood-vessels and associated tissue; esp. any of numerous small structures in the skin of the hands and feet functioning in temperature regulation [n]\n",
  "GLOMERATE": "to gather into a ball [v GLOMERATED, GLOMERATING, GLOMERATES]\n",
  "GLOMERATED": "GLOMERATE, to gather into a ball [v]\n",
  "GLOMERATES": "GLOMERATE, to gather into a ball [v]\n",
  "GLOMERATING": "GLOMERATE, to gather into a ball [v]\n",
  "GLOMERATION": "the act of gathering into a ball [n -S]\n",
  "GLOMERATIONS": "GLOMERATION, the act of gathering into a ball [n]\n",
  "GLOMERULAR": "like a glomerulus, the bunch of looped capillary blood vessels in the kidney [adj]\n",
  "GLOMERULATE": "of a glomerule, a cluster of short-stalked flowers [adj]\n",
  "GLOMERULE": "a cluster of short-stalked flowers [n -S]\n",
  "GLOMERULES": "GLOMERULE, a cluster of short-stalked flowers [n]\n",
  "GLOMERULI": "GLOMERULUS, the bunch of looped capillary blood vessels in a Malpighian capsule of the kidney [n]\n",
  "GLOMERULUS": "the bunch of looped capillary blood vessels in a Malpighian capsule of the kidney [n GLOMERULI]\n",
  "GLOMMED": "GLOM, to steal, take a look, also GLAUM [v]\n",
  "GLOMMING": "GLOM, to steal, take a look, also GLAUM [v]\n",
  "GLOMS": "GLOM, to steal, take a look, also GLAUM [v]\n",
  "GLOMUS": "(Latin) a small body consisting of blood-vessels and associated tissue; esp. any of numerous small structures in the skin of the hands and feet functioning in temperature regulation [n GLOMERA]\n",
  "GLONOIN": "a name for nitroglycerine, as used in medicine [n -S]\n",
  "GLONOINS": "GLONOIN, a name for nitroglycerine, as used in medicine [n]\n",
  "GLOOM": "to become dark [v -ED, -ING, -S]\n",
  "GLOOMED": "GLOOM, to become dark [v]\n",
  "GLOOMFUL": "full of gloom [adj GLOOMFULLY]\n",
  "GLOOMFULLY": "GLOOMFUL, full of gloom [adv]\n",
  "GLOOMIER": "GLOOMY, dismally dark [adj]\n",
  "GLOOMIEST": "GLOOMY, dismally dark [adj]\n",
  "GLOOMILY": "GLOOMY, dismally dark [adv]\n",
  "GLOOMINESS": "the state of being gloomy [n -ES]\n",
  "GLOOMINESSES": "GLOOMINESS, the state of being gloomy [n]\n",
  "GLOOMING": "twilight, also GLOAMING, GLOAM [n -S]\n",
  "GLOOMINGS": "GLOOMING, twilight, also GLOAMING, GLOAM [n]\n",
  "GLOOMLESS": "without gloom [adj]\n",
  "GLOOMS": "GLOOM, to become dark [v]\n",
  "GLOOMSTER": "a person who habitually predicts dire consequences [n -S]\n",
  "GLOOMSTERS": "GLOOMSTER, a person who habitually predicts dire consequences [n]\n",
  "GLOOMY": "dismally dark [adj GLOOMIER, GLOOMIEST, GLOOMILY]\n",
  "GLOOP": "to plop slowly and heavily [v -ED, -ING, -S]\n",
  "GLOOPED": "GLOOP, to plop slowly and heavily [v]\n",
  "GLOOPIER": "GLOOPY, thickly viscid [adj]\n",
  "GLOOPIEST": "GLOOPY, thickly viscid [adj]\n",
  "GLOOPING": "GLOOP, to plop slowly and heavily [v]\n",
  "GLOOPS": "GLOOP, to plop slowly and heavily [v]\n",
  "GLOOPY": "thickly viscid [adj GLOOPIER, GLOOPIEST]\n",
  "GLOP": "to cover with glop (a messy mass or mixture) [v GLOPPED, GLOPPING, GLOPS]\n",
  "GLOPPED": "GLOP, to cover with glop (a messy mass or mixture) [v]\n",
  "GLOPPIER": "GLOPPY, being or resembling glop [adj]\n",
  "GLOPPIEST": "GLOPPY, being or resembling glop [adj]\n",
  "GLOPPING": "GLOP, to cover with glop (a messy mass or mixture) [v]\n",
  "GLOPPY": "being or resembling glop [adj GLOPPIER, GLOPPIEST]\n",
  "GLOPS": "GLOP, to cover with glop (a messy mass or mixture) [v]\n",
  "GLORIA": "(Latin) a type of very closely woven fabric, usually of a mixture of silk or nylon and wool or cotton, often used for umbrellas [n -S]\n",
  "GLORIAS": "GLORIA, (Latin) a type of very closely woven fabric, usually of a mixture of silk or nylon and wool or cotton, often used for umbrellas [n]\n",
  "GLORIED": "GLORY, to rejoice proudly [v]\n",
  "GLORIES": "GLORY, to rejoice proudly [v]\n",
  "GLORIFIABLE": "that can be glorified [adj]\n",
  "GLORIFICATION": "the act of glorifying [n -S]\n",
  "GLORIFICATIONS": "GLORIFICATION, the act of glorifying [n]\n",
  "GLORIFIED": "GLORIFY, to bestow honour or praise on [v]\n",
  "GLORIFIER": "one who glorifies [n -S]\n",
  "GLORIFIERS": "GLORIFIER, one who glorifies [n]\n",
  "GLORIFIES": "GLORIFY, to bestow honour or praise on [v]\n",
  "GLORIFY": "to bestow honour or praise on [v GLORIFIED, GLORIFYING, GLORIFIES]\n",
  "GLORIFYING": "GLORIFY, to bestow honour or praise on [v]\n",
  "GLORIOLE": "(French) a halo [n -S]\n",
  "GLORIOLES": "GLORIOLE, (French) a halo [n]\n",
  "GLORIOSA": "a genus of climbing plants with showy lilylike blossoms [n -S]\n",
  "GLORIOSAS": "GLORIOSA, a genus of climbing plants with showy lilylike blossoms [n]\n",
  "GLORIOUS": "magnificent [adj GLORIOUSLY]\n",
  "GLORIOUSLY": "GLORIOUS, magnificent [adv]\n",
  "GLORIOUSNESS": "the state of being glorious [n -ES]\n",
  "GLORIOUSNESSES": "GLORIOUSNESS, the state of being glorious [n]\n",
  "GLORY": "to rejoice proudly [v GLORIED, GLORYING, GLORIES]\n",
  "GLORYING": "GLORY, to rejoice proudly [v]\n",
  "GLOSS": "to make lustrous [v -ED, -ING, -ES]\n",
  "GLOSSA": "(Latin) the tongue [n GLOSSAS or GLOSSAE]\n",
  "GLOSSAE": "GLOSSA, (Latin) the tongue [n]\n",
  "GLOSSAL": "relating to the tongue [adj]\n",
  "GLOSSARIAL": "of or pertaining to glosses or to a glossary [adj GLOSSARIALLY]\n",
  "GLOSSARIALLY": "GLOSSARIAL, of or pertaining to glosses or to a glossary [adv]\n",
  "GLOSSARIES": "GLOSSARY, a list of terms and their definitions [n]\n",
  "GLOSSARIST": "a writer of glosses or of a glossary [n -S]\n",
  "GLOSSARISTS": "GLOSSARIST, a writer of glosses or of a glossary [n]\n",
  "GLOSSARY": "a list of terms and their definitions [n GLOSSARIES]\n",
  "GLOSSAS": "GLOSSA, (Latin) the tongue [n]\n",
  "GLOSSATOR": "a writer of glosses or comments [n -S]\n",
  "GLOSSATORS": "GLOSSATOR, a writer of glosses or comments [n]\n",
  "GLOSSECTOMIES": "GLOSSECTOMY, the surgical removal of the tongue [n]\n",
  "GLOSSECTOMY": "the surgical removal of the tongue [n GLOSSECTOMIES]\n",
  "GLOSSED": "GLOSS, to make lustrous [v]\n",
  "GLOSSEMATICS": "the study of glossemes [n]\n",
  "GLOSSEME": "the smallest linguistic unit that signals a meaning [n -S]\n",
  "GLOSSEMES": "GLOSSEME, the smallest linguistic unit that signals a meaning [n]\n",
  "GLOSSER": "a polisher; one who gives a luster [n -S]\n",
  "GLOSSERS": "GLOSSER, a polisher; one who gives a luster [n]\n",
  "GLOSSES": "GLOSS, to make lustrous [v]\n",
  "GLOSSIER": "GLOSSY, with a surface shine [adj]\n",
  "GLOSSIES": "GLOSSY, a quality magazine, with a glossy cover [n]\n",
  "GLOSSIEST": "GLOSSY, with a surface shine [adj]\n",
  "GLOSSILY": "GLOSSY, with a surface shine [adv]\n",
  "GLOSSINA": "an insect of the tsetse fly genus [n -S]\n",
  "GLOSSINAS": "GLOSSINA, an insect of the tsetse fly genus [n]\n",
  "GLOSSINESS": "the state of being glossy [n -ES]\n",
  "GLOSSINESSES": "GLOSSINESS, the state of being glossy [n]\n",
  "GLOSSING": "GLOSS, to make lustrous [v]\n",
  "GLOSSINGLY": "GLOSSING, GLOSS, to make lustrous [adv]\n",
  "GLOSSIST": "a writer of glosses (comments on text) [n -S]\n",
  "GLOSSISTS": "GLOSSIST, a writer of glosses (comments on text) [n]\n",
  "GLOSSITIC": "relating to glossitis, inflammation of the tongue [adj]\n",
  "GLOSSITIS": "inflammation of the tongue [n -ES]\n",
  "GLOSSITISES": "GLOSSITIS, inflammation of the tongue [n]\n",
  "GLOSSLESS": "without gloss [adj]\n",
  "GLOSSODYNIA": "pain in the tongue [n -S]\n",
  "GLOSSODYNIAS": "GLOSSODYNIA, pain in the tongue [n]\n",
  "GLOSSOGRAPHER": "a writer of short explanatory notes or glosses [n -S]\n",
  "GLOSSOGRAPHERS": "GLOSSOGRAPHER, a writer of short explanatory notes or glosses [n]\n",
  "GLOSSOGRAPHICAL": "relating to glossography, the compilation of glossaries [adj]\n",
  "GLOSSOGRAPHIES": "GLOSSOGRAPHY, the compilation of glossaries [n]\n",
  "GLOSSOGRAPHY": "the compilation of glossaries [n GLOSSOGRAPHIES]\n",
  "GLOSSOLALIA": "speaking in tongues [n -S]\n",
  "GLOSSOLALIAS": "GLOSSOLALIA, speaking in tongues [n]\n",
  "GLOSSOLALIST": "one who studies glossolalia [n -S]\n",
  "GLOSSOLALISTS": "GLOSSOLALIST, one who studies glossolalia [n]\n",
  "GLOSSOLARYNGEAL": "pertaining to the tongue and to the larynx [adj]\n",
  "GLOSSOLOGICAL": "related to glossology, the study of language; study of the tongue [adj]\n",
  "GLOSSOLOGIES": "GLOSSOLOGY, (obsolete) the study of language; study of the tongue [n]\n",
  "GLOSSOLOGIST": "a student of glossology [n -S]\n",
  "GLOSSOLOGISTS": "GLOSSOLOGIST, a student of glossology [n]\n",
  "GLOSSOLOGY": "(obsolete) the study of language; study of the tongue [n GLOSSOLOGIES]\n",
  "GLOSSY": "with a surface shine [adj GLOSSIER, GLOSSIEST, GLOSSILY] / a quality magazine, with a glossy cover [n GLOSSIES]\n",
  "GLOST": "an oven in which glazed pottery is fired [n -S]\n",
  "GLOSTS": "GLOST, an oven in which glazed pottery is fired [n]\n",
  "GLOTTAL": "of or pertaining to, or produced by, the glottis, also GLOTTIC [adj]\n",
  "GLOTTIC": "of or pertaining to, or produced by, the glottis, also GLOTTAL [adj]\n",
  "GLOTTIDEAN": "of or pertaining to the glottis [adj]\n",
  "GLOTTIDES": "GLOTTIS, (Greek) the opening between the vocal chords [n]\n",
  "GLOTTIS": "(Greek) the opening between the vocal chords [n GLOTTISES or GLOTTIDES]\n",
  "GLOTTISES": "GLOTTIS, (Greek) the opening between the vocal chords [n]\n",
  "GLOTTOGONIC": "relating to the origins of language [adj]\n",
  "GLOTTOLOGIES": "GLOTTOLOGY, the science of tongues or languages [n]\n",
  "GLOTTOLOGY": "the science of tongues or languages [n GLOTTOLOGIES]\n",
  "GLOUT": "(archaic) to be sulky [v -ED, -ING, -S]\n",
  "GLOUTED": "GLOUT, (archaic) to be sulky [v]\n",
  "GLOUTING": "GLOUT, (archaic) to be sulky [v]\n",
  "GLOUTS": "GLOUT, (archaic) to be sulky [v]\n",
  "GLOVE": "to furnish with gloves (hand coverings) [v GLOVED, GLOVING, GLOVES]\n",
  "GLOVEBOX": "a compartment in a car for gloves etc. [n -ES]\n",
  "GLOVEBOXES": "GLOVEBOX, a compartment in a car for gloves etc. [n]\n",
  "GLOVED": "GLOVE, to furnish with gloves (hand coverings) [v]\n",
  "GLOVELESS": "without gloves [adj]\n",
  "GLOVELIKE": "resembling a glove [adj]\n",
  "GLOVER": "a maker or seller of gloves [n -S]\n",
  "GLOVERS": "GLOVER, a maker or seller of gloves [n]\n",
  "GLOVES": "GLOVE, to furnish with gloves (hand coverings) [v]\n",
  "GLOVING": "the craft of making gloves [n -S]\n",
  "GLOVINGS": "GLOVING, the craft of making gloves [n]\n",
  "GLOW": "to emit light and heat [v -ED, -ING, -S]\n",
  "GLOWED": "GLOW, to emit light and heat [v]\n",
  "GLOWER": "to look or stare with sullen annoyance or anger [v -ED, -ING, -S]\n",
  "GLOWERED": "GLOWER, to look or stare with sullen annoyance or anger [v]\n",
  "GLOWERING": "GLOWER, to look or stare with sullen annoyance or anger [v]\n",
  "GLOWERINGLY": "GLOWERING, GLOWER, to look or stare with sullen annoyance or anger [adv]\n",
  "GLOWERS": "GLOWER, to look or stare with sullen annoyance or anger [v]\n",
  "GLOWFLIES": "GLOWFLY, a glowworm [n]\n",
  "GLOWFLY": "a glowworm [n GLOWFLIES]\n",
  "GLOWING": "GLOW, to emit light and heat [v]\n",
  "GLOWINGLY": "GLOWING, GLOW, to emit light and heat [adv]\n",
  "GLOWLAMP": "an incandescent lamp, usually electric [n -S]\n",
  "GLOWLAMPS": "GLOWLAMP, an incandescent lamp, usually electric [n]\n",
  "GLOWS": "GLOW, to emit light and heat [v]\n",
  "GLOWSTICK": "a plastic tube containing a luminescent material, waved or held aloft at gigs, raves etc. [n -S]\n",
  "GLOWSTICKS": "GLOWSTICK, a plastic tube containing a luminescent material, waved or held aloft at gigs, raves etc. [n]\n",
  "GLOWWORM": "a beetle, the wingless female and other stages of which emit light from the abdomen [n -S]\n",
  "GLOWWORMS": "GLOWWORM, a beetle, the wingless female and other stages of which emit light from the abdomen [n]\n",
  "GLOXINIA": "a house plant with bright bell-shaped flowers [n -S]\n",
  "GLOXINIAS": "GLOXINIA, a house plant with bright bell-shaped flowers [n]\n",
  "GLOZE": "(archaic) to flatter [v GLOZED, GLOZING, GLOZES]\n",
  "GLOZED": "GLOZE, (archaic) to flatter [v]\n",
  "GLOZES": "GLOZE, (archaic) to flatter [v]\n",
  "GLOZING": "flattery, deceit [n -S]\n",
  "GLOZINGS": "GLOZING, flattery, deceit [n]\n",
  "GLUCAGON": "a pancreatic hormone which raises blood-sugar level and reduces appetite [n -S]\n",
  "GLUCAGONS": "GLUCAGON, a pancreatic hormone which raises blood-sugar level and reduces appetite [n]\n",
  "GLUCAN": "a polymer of glucose [n -S]\n",
  "GLUCANS": "GLUCAN, a polymer of glucose [n]\n",
  "GLUCINA": "an oxide of beryllium used as a hardener, also BERYLLIA [n -S]\n",
  "GLUCINAS": "GLUCINA, an oxide of beryllium used as a hardener, also BERYLLIA [n]\n",
  "GLUCINIC": "pertaining to, derived from, or containing, glucinum (beryllium); as, glucinic oxide [adj]\n",
  "GLUCINIUM": "a former name for beryllium, also GLUCINUM [n -S]\n",
  "GLUCINIUMS": "GLUCINIUM, a former name for beryllium, also GLUCINUM [n]\n",
  "GLUCINUM": "a former name for beryllium, also GLUCINIUM [n -S]\n",
  "GLUCINUMS": "GLUCINUM, a former name for beryllium, also GLUCINIUM [n]\n",
  "GLUCOCORTICOID": "any of a group of steroid hormones which affect glucose metabolism, having an anti-inflammatory effect [n -S]\n",
  "GLUCOCORTICOIDS": "GLUCOCORTICOID, any of a group of steroid hormones which affect glucose metabolism, having an anti-inflammatory effect [n]\n",
  "GLUCOKINASE": "a hexokinase found esp. in the liver that catalyzes the phosphorylation of glucose [n -S]\n",
  "GLUCOKINASES": "GLUCOKINASE, a hexokinase found esp. in the liver that catalyzes the phosphorylation of glucose [n]\n",
  "GLUCONATE": "a salt or ester of gluconic acid [n -S]\n",
  "GLUCONATES": "GLUCONATE, a salt or ester of gluconic acid [n]\n",
  "GLUCONEOGENESES": "GLUCONEOGENESIS, the conversion of non-carbohydrate substances, e.g. amino acids, into glucose, also GLYCONEOGENESIS [n]\n",
  "GLUCONEOGENESIS": "the conversion of non-carbohydrate substances, e.g. amino acids, into glucose, also GLYCONEOGENESIS [n GLUCONEOGENESES]\n",
  "GLUCONEOGENIC": "relating to gluconeogenesis, the conversion of non-carbohydrate substances, e.g. amino acids, into glucose [adj]\n",
  "GLUCONIC": "as in gluconic acid, an acid that occurs naturally in fruit and wine [adj]\n",
  "GLUCOPHORE": "a chemical group responsible for sweetness of taste [n -S]\n",
  "GLUCOPHORES": "GLUCOPHORE, a chemical group responsible for sweetness of taste [n]\n",
  "GLUCOPROTEIN": "any of the compounds formed by the conjugation of a protein with a substance containing a carbohydrate group other than a nucleic acid, also GLYCOPROTEIN [n -S]\n",
  "GLUCOPROTEINS": "GLUCOPROTEIN, any of the compounds formed by the conjugation of a protein with a substance containing a carbohydrate group other than a nucleic acid, also GLYCOPROTEIN [n]\n",
  "GLUCOSAMINE": "an amino derivative of glucose that occurs esp. as a constituent of various polysaccharides that are components of structural substances, such as chitin and cartilage [n -S]\n",
  "GLUCOSAMINES": "GLUCOSAMINE, an amino derivative of glucose that occurs esp. as a constituent of various polysaccharides that are components of structural substances, such as chitin and cartilage [n]\n",
  "GLUCOSE": "a hexose sugar, found e.g. in ripe fruit, also GLYCOSE [n -S]\n",
  "GLUCOSES": "GLUCOSE, a hexose sugar, found e.g. in ripe fruit, also GLYCOSE [n]\n",
  "GLUCOSIC": "relating to glucose [adj]\n",
  "GLUCOSIDAL": "of or like a glucoside, a glycoside in which the sugar is glucose, also GLUCOSIDIC [adj]\n",
  "GLUCOSIDASE": "an enzyme, such as maltase, that hydrolyzes a glucoside [n -S]\n",
  "GLUCOSIDASES": "GLUCOSIDASE, an enzyme, such as maltase, that hydrolyzes a glucoside [n]\n",
  "GLUCOSIDE": "a glycoside in which the sugar is glucose [n -S]\n",
  "GLUCOSIDES": "GLUCOSIDE, a glycoside in which the sugar is glucose [n]\n",
  "GLUCOSIDIC": "of or like a glucoside, a glycoside in which the sugar is glucose, also GLUCOSIDAL [adj]\n",
  "GLUCOSURIA": "a condition in which glucose is discharged in the urine, also GLYCOSURIA [n -S]\n",
  "GLUCOSURIAS": "GLUCOSURIA, a condition in which glucose is discharged in the urine, also GLYCOSURIA [n]\n",
  "GLUCOSURIC": "relating to glucosuria, a condition in which glucose is discharged in the urine [adj]\n",
  "GLUCURONIC": "as in glucuronic acid, a soluble compound derived from glucose [adj]\n",
  "GLUCURONIDASE": "an enzyme that hydrolyzes a glucuronide [n -S]\n",
  "GLUCURONIDASES": "GLUCURONIDASE, an enzyme that hydrolyzes a glucuronide [n]\n",
  "GLUCURONIDE": "any of various derivatives of glucuronic acid [n -S]\n",
  "GLUCURONIDES": "GLUCURONIDE, any of various derivatives of glucuronic acid [n]\n",
  "GLUE": "to fasten with glue (an adhesive substance) [v GLUED, GLUEING or GLUING, GLUES]\n",
  "GLUEBALL": "a hypothetical subatomic particle consisting exclusively of gluons bound together [n -S]\n",
  "GLUEBALLS": "GLUEBALL, a hypothetical subatomic particle consisting exclusively of gluons bound together [n]\n",
  "GLUED": "GLUE, to fasten with glue (an adhesive substance) [v]\n",
  "GLUEING": "GLUE, to fasten with glue (an adhesive substance) [v]\n",
  "GLUEISH": "(obsolete) somewhat gluey, also GLUISH [adj]\n",
  "GLUELIKE": "resembling glue [adj]\n",
  "GLUEPOT": "a pot for melting glue [n -S]\n",
  "GLUEPOTS": "GLUEPOT, a pot for melting glue [n]\n",
  "GLUER": "one who glues [n -S]\n",
  "GLUERS": "GLUER, one who glues [n]\n",
  "GLUES": "GLUE, to fasten with glue (an adhesive substance) [v]\n",
  "GLUEY": "resembling glue [adj GLUIER, GLUIEST, GLUILY]\n",
  "GLUEYNESS": "the state of being gluey, also GLUINESS [n -ES]\n",
  "GLUEYNESSES": "GLUEYNESS, the state of being gluey, also GLUINESS [n]\n",
  "GLUG": "to make a gurgling sound [v GLUGGED, GLUGGING, GLUGS]\n",
  "GLUGGABLE": "of wine, easy and pleasant to drink [adj]\n",
  "GLUGGED": "GLUG, to make a gurgling sound [v]\n",
  "GLUGGING": "GLUG, to make a gurgling sound [v]\n",
  "GLUGS": "GLUG, to make a gurgling sound [v]\n",
  "GLUHWEIN": "(German) a hot sweetened spiced red wine [n -S]\n",
  "GLUHWEINS": "GLUHWEIN, (German) a hot sweetened spiced red wine [n]\n",
  "GLUIER": "GLUEY, resembling glue [adj]\n",
  "GLUIEST": "GLUEY, resembling glue [adj]\n",
  "GLUILY": "GLUEY, resembling glue [adv]\n",
  "GLUINESS": "the state of being gluey, also GLUEYNESS [n -ES]\n",
  "GLUINESSES": "GLUINESS, the state of being gluey, also GLUEYNESS [n]\n",
  "GLUING": "GLUE, to fasten with glue (an adhesive substance) [v]\n",
  "GLUISH": "(obsolete) somewhat gluey, also GLUEISH [adj]\n",
  "GLUM": "low in spirits [adj GLUMMER, GLUMMEST, GLUMLY]\n",
  "GLUMACEOUS": "like a glume, thin, brownish and papery [adj]\n",
  "GLUME": "an outer sterile bract enclosing the spikelet in grasses [n -S]\n",
  "GLUMELIKE": "like a glume, an outer sterile bract enclosing the spikelet in grasses [adj]\n",
  "GLUMELLA": "the membranous inner bract of a grass flower, aka the palea [n -S]\n",
  "GLUMELLAS": "GLUMELLA, the membranous inner bract of a grass flower, aka the palea [n]\n",
  "GLUMES": "GLUME, an outer sterile bract enclosing the spikelet in grasses [n]\n",
  "GLUMIFEROUS": "bearing glumes [adj]\n",
  "GLUMLY": "GLUM, low in spirits [adv]\n",
  "GLUMMER": "GLUM, low in spirits [adj]\n",
  "GLUMMEST": "GLUM, low in spirits [adj]\n",
  "GLUMNESS": "the state of being glum [n -ES]\n",
  "GLUMNESSES": "GLUMNESS, the state of being glum [n]\n",
  "GLUMPIER": "GLUMPY, (dialect) sulky [adj]\n",
  "GLUMPIEST": "GLUMPY, (dialect) sulky [adj]\n",
  "GLUMPILY": "GLUMPY, (dialect) sulky [adv]\n",
  "GLUMPISH": "glum [adj]\n",
  "GLUMPS": "the sulks [n]\n",
  "GLUMPY": "(dialect) sulky [adj GLUMPIER, GLUMPIEST, GLUMPILY]\n",
  "GLUMS": "gloomy feelings [n]\n",
  "GLUNCH": "to frown [v -ED, -ING, -ES]\n",
  "GLUNCHED": "GLUNCH, to frown [v]\n",
  "GLUNCHES": "GLUNCH, to frown [v]\n",
  "GLUNCHING": "GLUNCH, to frown [v]\n",
  "GLUON": "the name given to a hypothetical particle thought of as passing between quarks and so signifying the force that holds them together [n -S]\n",
  "GLUONS": "GLUON, the name given to a hypothetical particle thought of as passing between quarks and so signifying the force that holds them together [n]\n",
  "GLURGE": "supposedly factual stories sent by email, often mawkish and fabricated [n -S]\n",
  "GLURGES": "GLURGE, supposedly factual stories sent by email, often mawkish and fabricated [n]\n",
  "GLUT": "to feed or fill to excess [v GLUTTED, GLUTTING, GLUTS]\n",
  "GLUTAEAL": "relating to the glutaeus, any of the three large muscles of the buttock, also GLUTEAL [adj]\n",
  "GLUTAEI": "GLUTAEUS, (Greek) any of the three large muscles of the buttock, also GLUTE [n]\n",
  "GLUTAEUS": "(Greek) any of the three large muscles of the buttock, also GLUTE [n GLUTAEI]\n",
  "GLUTAMATE": "a salt of glutamic acid [n -S]\n",
  "GLUTAMATES": "GLUTAMATE, a salt of glutamic acid [n]\n",
  "GLUTAMIC": "as in glutamic acid, an amino acid in proteins, also GLUTAMINIC [adj]\n",
  "GLUTAMINASE": "an enzyme that hydrolyzes glutamine to glutamic acid and ammonia [n -S]\n",
  "GLUTAMINASES": "GLUTAMINASE, an enzyme that hydrolyzes glutamine to glutamic acid and ammonia [n]\n",
  "GLUTAMINE": "a neutral amino acid found in proteins [n -S]\n",
  "GLUTAMINES": "GLUTAMINE, a neutral amino acid found in proteins [n]\n",
  "GLUTAMINIC": "as in glutamic acid, an important amino acid, a constituent of most proteins, also GLUTAMIC [adj]\n",
  "GLUTARALDEHYDE": "a compound that contains two aldehyde groups and is used esp. in tanning leather and in the fixation of biological tissues [n -S]\n",
  "GLUTARALDEHYDES": "GLUTARALDEHYDE, a compound that contains two aldehyde groups and is used esp. in tanning leather and in the fixation of biological tissues [n]\n",
  "GLUTATHIONE": "an antioxidant, found in the body's airways and nose, that protects the lungs from the effects of pollutants [n -S]\n",
  "GLUTATHIONES": "GLUTATHIONE, an antioxidant, found in the body's airways and nose, that protects the lungs from the effects of pollutants [n]\n",
  "GLUTCH": "to gulp or swallow [v -ED, -ING, -ES]\n",
  "GLUTCHED": "GLUTCH, to gulp or swallow [v]\n",
  "GLUTCHES": "GLUTCH, to gulp or swallow [v]\n",
  "GLUTCHING": "GLUTCH, to gulp or swallow [v]\n",
  "GLUTE": "any of the three large muscles of the buttocks, also GLUTAEUS [n -S]\n",
  "GLUTEAL": "relating to the glutaeus, the muscle of the buttock, also GLUTAEAL [adj]\n",
  "GLUTEI": "GLUTEUS, (Greek) a buttock muscle, also GLUTAEUS [n]\n",
  "GLUTELIN": "a simple plant protein found in cereals [n -S]\n",
  "GLUTELINS": "GLUTELIN, a simple plant protein found in cereals [n]\n",
  "GLUTEN": "a tough elastic plant protein substance [n -S]\n",
  "GLUTENIN": "a protein of cereal grains that gives adhesiveness to bread dough [n -S]\n",
  "GLUTENINS": "GLUTENIN, a protein of cereal grains that gives adhesiveness to bread dough [n]\n",
  "GLUTENOUS": "containing gluten, the viscid, tenacious substance which gives adhesiveness to dough [adj]\n",
  "GLUTENS": "GLUTEN, a tough elastic plant protein substance [n]\n",
  "GLUTES": "GLUTE, any of the three large muscles of the buttocks, also GLUTAEUS [n]\n",
  "GLUTETHIMIDE": "a sedative drug with pharmacological properties similar to those of barbiturates [n -S]\n",
  "GLUTETHIMIDES": "GLUTETHIMIDE, a sedative drug with pharmacological properties similar to those of barbiturates [n]\n",
  "GLUTEUS": "(Greek) a buttock muscle, also GLUTAEUS [n GLUTEI]\n",
  "GLUTINOSITIES": "GLUTINOSITY, the state of being glutinous [n]\n",
  "GLUTINOSITY": "the state of being glutinous [n GLUTINOSITIES]\n",
  "GLUTINOUS": "gluey; sticky [adj GLUTINOUSLY]\n",
  "GLUTINOUSLY": "GLUTINOUS, gluey; sticky [adv]\n",
  "GLUTINOUSNESS": "the state of being glutinous [n -ES]\n",
  "GLUTINOUSNESSES": "GLUTINOUSNESS, the state of being glutinous [n]\n",
  "GLUTS": "GLUT, to feed or fill to excess [v]\n",
  "GLUTTED": "GLUT, to feed or fill to excess [v]\n",
  "GLUTTING": "GLUT, to feed or fill to excess [v]\n",
  "GLUTTINGLY": "GLUTTING, GLUT, to feed or fill to excess [adv]\n",
  "GLUTTON": "a person who feeds to excess [n -S]\n",
  "GLUTTONIES": "GLUTTONY, excessive eating [n]\n",
  "GLUTTONISE": "to eat to excess, also GLUTTONIZE [v GLUTTONISED, GLUTTONISING, GLUTTONISES]\n",
  "GLUTTONISED": "GLUTTONISE, to eat to excess, also GLUTTONIZE [v]\n",
  "GLUTTONISES": "GLUTTONISE, to eat to excess, also GLUTTONIZE [v]\n",
  "GLUTTONISH": "gluttonous, greedy [adj]\n",
  "GLUTTONISING": "GLUTTONISE, to eat to excess, also GLUTTONIZE [v]\n",
  "GLUTTONIZE": "to eat to excess, also GLUTTONISE [v GLUTTONIZED, GLUTTONIZING, GLUTTONIZES]\n",
  "GLUTTONIZED": "GLUTTONIZE, to eat to excess, also GLUTTONISE [v]\n",
  "GLUTTONIZES": "GLUTTONIZE, to eat to excess, also GLUTTONISE [v]\n",
  "GLUTTONIZING": "GLUTTONIZE, to eat to excess, also GLUTTONISE [v]\n",
  "GLUTTONOUS": "marked by or given to gluttony [adj GLUTTONOUSLY]\n",
  "GLUTTONOUSLY": "GLUTTONOUS, marked by or given to gluttony [adv]\n",
  "GLUTTONOUSNESS": "GLUTTONOUS, marked by or given to gluttony [n]\n",
  "GLUTTONS": "GLUTTON, a person who feeds to excess [n]\n",
  "GLUTTONY": "excessive eating [n GLUTTONIES]\n",
  "GLYCAEMIA": "an excessive level of glucose in the blood, also GLYCEMIA [n -S]\n",
  "GLYCAEMIAS": "GLYCAEMIA, an excessive level of glucose in the blood, also GLYCEMIA [n]\n",
  "GLYCAEMIC": "of or like glycaemia, excessive sugar in the blood, also GLYCEMIC [adj]\n",
  "GLYCAN": "a carbohydrate whose molecules consist of a number of monosaccharide residues bonded together [n -S]\n",
  "GLYCANS": "GLYCAN, a carbohydrate whose molecules consist of a number of monosaccharide residues bonded together [n]\n",
  "GLYCATION": "the bonding of a sugar molecule to a protein [n -S]\n",
  "GLYCATIONS": "GLYCATION, the bonding of a sugar molecule to a protein [n]\n",
  "GLYCEMIA": "an excessive level of glucose in the blood, also GLYCAEMIA [n -S]\n",
  "GLYCEMIAS": "GLYCEMIA, an excessive level of glucose in the blood, also GLYCAEMIA [n]\n",
  "GLYCEMIC": "having glucose in the blood, also GLYCAEMIC [adj]\n",
  "GLYCERALDEHYDE": "a sweet crystalline compound that is formed as an intermediate in carbohydrate metabolism [n -S]\n",
  "GLYCERALDEHYDES": "GLYCERALDEHYDE, a sweet crystalline compound that is formed as an intermediate in carbohydrate metabolism [n]\n",
  "GLYCERIA": "an aquatic grass [n -S]\n",
  "GLYCERIAS": "GLYCERIA, an aquatic grass [n]\n",
  "GLYCERIC": "pertaining to, or derived from, glycerin [adj]\n",
  "GLYCERIDE": "an ester of glycerol [n -S]\n",
  "GLYCERIDES": "GLYCERIDE, an ester of glycerol [n]\n",
  "GLYCERIDIC": "like a glyceride, an ester of glycerol [adj]\n",
  "GLYCERIN": "a nontechnical name for glycerol, also GLYCERINE [n -S]\n",
  "GLYCERINATE": "to treat with or preserve in glycerin [v GLYCERINATED, GLYCERINATING, GLYCERINATES]\n",
  "GLYCERINATED": "GLYCERINATE, to treat with or preserve in glycerin [v]\n",
  "GLYCERINATES": "GLYCERINATE, to treat with or preserve in glycerin [v]\n",
  "GLYCERINATING": "GLYCERINATE, to treat with or preserve in glycerin [v]\n",
  "GLYCERINE": "a nontechnical name for glycerol, also GLYCERIN [n -S]\n",
  "GLYCERINES": "GLYCERINE, a nontechnical name for glycerol, also GLYCERIN [n]\n",
  "GLYCERINS": "GLYCERIN, a nontechnical name for glycerol, also GLYCERINE [n]\n",
  "GLYCEROL": "a syrupy alcohol [n -S]\n",
  "GLYCEROLS": "GLYCEROL, a syrupy alcohol [n]\n",
  "GLYCERYL": "a radical derived from glycerol [n -S]\n",
  "GLYCERYLS": "GLYCERYL, a radical derived from glycerol [n]\n",
  "GLYCIN": "the simplest amino acid, present in proteins, formerly known as glycocoll, also GLYCINE [n -S]\n",
  "GLYCINE": "the simplest amino acid, present in proteins, formerly known as glycocoll, also GLYCIN [n -S]\n",
  "GLYCINES": "GLYCINE, the simplest amino acid, present in proteins, formerly known as glycocoll, also GLYCIN [n]\n",
  "GLYCINS": "GLYCIN, the simplest amino acid, present in proteins, formerly known as glycocoll, also GLYCINE [n]\n",
  "GLYCOCOLL": "another name for glycine [n -S]\n",
  "GLYCOCOLLS": "GLYCOCOLL, another name for glycine [n]\n",
  "GLYCOGEN": "animal starch, as found in the liver [n -S]\n",
  "GLYCOGENESES": "GLYCOGENESIS, the synthesis of glycogen [n]\n",
  "GLYCOGENESIS": "the synthesis of glycogen [n GLYCOGENESES]\n",
  "GLYCOGENETIC": "of or containing glycogen, also GLYCOGENIC [adj]\n",
  "GLYCOGENIC": "of or containing glycogen, also GLYCOGENETIC [adj]\n",
  "GLYCOGENOLYSES": "GLYCOGENOLYSIS, the breakdown of glycogen esp. to glucose in the animal body [n]\n",
  "GLYCOGENOLYSIS": "the breakdown of glycogen esp. to glucose in the animal body [n GLYCOGENOLYSES]\n",
  "GLYCOGENOLYTIC": "relating to glycogenolysis [adj]\n",
  "GLYCOGENS": "GLYCOGEN, animal starch, as found in the liver [n]\n",
  "GLYCOL": "a thick, colourless liquid, of a sweetish taste, produced artificially from certain ethylene compounds [n -S]\n",
  "GLYCOLIC": "pertaining to, or derived from, glycol; as glycolic acid, also GLYCOLLIC [adj]\n",
  "GLYCOLIPID": "a lipid that contains a carbohydrate radical [n -S]\n",
  "GLYCOLIPIDS": "GLYCOLIPID, a lipid that contains a carbohydrate radical [n]\n",
  "GLYCOLLIC": "pertaining to, or derived from, glycol; as glycollic acid, also GLYCOLIC [adj]\n",
  "GLYCOLS": "GLYCOL, a thick, colourless liquid, of a sweetish taste, produced artificially from certain ethylene compounds [n]\n",
  "GLYCOLYSES": "GLYCOLYSIS, the breaking down of glucose into acids [n]\n",
  "GLYCOLYSIS": "the breaking down of glucose into acids [n GLYCOLYSES]\n",
  "GLYCOLYTIC": "relating to glycolysis [adj]\n",
  "GLYCONEOGENESES": "GLYCONEOGENESIS, the conversion of non-carbohydrate substances, e.g. amino acids, into glucose, also GLUCONEOGENESIS [n]\n",
  "GLYCONEOGENESIS": "the conversion of non-carbohydrate substances, e.g. amino acids, into glucose, also GLUCONEOGENESIS [n GLYCONEOGENESES]\n",
  "GLYCONIC": "a type of verse line consisting of a spondee, a choriamb, and a pyrrhic [n -S]\n",
  "GLYCONICS": "GLYCONIC, a type of verse line consisting of a spondee, a choriamb, and a pyrrhic [n]\n",
  "GLYCOPEPTIDE": "any of the compounds formed by the conjugation of a protein with a substance containing a carbohydrate group other than a nucleic acid [n -S]\n",
  "GLYCOPEPTIDES": "GLYCOPEPTIDE, any of the compounds formed by the conjugation of a protein with a substance containing a carbohydrate group other than a nucleic acid [n]\n",
  "GLYCOPHYTE": "any plant that will only grow healthily in soils with a low content of sodium salts [n -S]\n",
  "GLYCOPHYTES": "GLYCOPHYTE, any plant that will only grow healthily in soils with a low content of sodium salts [n]\n",
  "GLYCOPHYTIC": "like a glycophyte, any plant that will only grow healthily in soils with a low content of sodium salts [adj]\n",
  "GLYCOPROTEIN": "any of the compounds formed by the conjugation of a protein with a substance containing a carbohydrate group other than a nucleic acid, also GLUCOPROTEIN [n -S]\n",
  "GLYCOPROTEINS": "GLYCOPROTEIN, any of the compounds formed by the conjugation of a protein with a substance containing a carbohydrate group other than a nucleic acid, also GLUCOPROTEIN [n]\n",
  "GLYCOSE": "a hexose sugar, found e.g. in ripe fruit, also GLUCOSE [n -S]\n",
  "GLYCOSES": "GLYCOSE, a hexose sugar, found e.g. in ripe fruit, also GLUCOSE [n]\n",
  "GLYCOSIDASE": "an enzyme that catalyzes the hydrolysis of a bond joining a sugar of a glycoside to an alcohol or another sugar unit [n -S]\n",
  "GLYCOSIDASES": "GLYCOSIDASE, an enzyme that catalyzes the hydrolysis of a bond joining a sugar of a glycoside to an alcohol or another sugar unit [n]\n",
  "GLYCOSIDE": "any of a group of compounds derived from monosaccharides [n -S]\n",
  "GLYCOSIDES": "GLYCOSIDE, any of a group of compounds derived from monosaccharides [n]\n",
  "GLYCOSIDIC": "of or like a glycoside [adj GLYCOSIDICALLY]\n",
  "GLYCOSIDICALLY": "GLYCOSIDIC, of or like a glycoside [adv]\n",
  "GLYCOSURIA": "a condition in which glucose is discharged in the urine, also GLUCOSURIA [n -S]\n",
  "GLYCOSURIAS": "GLYCOSURIA, a condition in which glucose is discharged in the urine, also GLUCOSURIA [n]\n",
  "GLYCOSURIC": "relating to glycosuria, the presence of sugar in the urine [adj]\n",
  "GLYCOSYL": "a radical derived from glucose [n -S]\n",
  "GLYCOSYLATE": "to attach sugar to proteins to make glycoproteins [v GLYCOSYLATED, GLYCOSYLATING, GLYCOSYLATES]\n",
  "GLYCOSYLATED": "GLYCOSYLATE, to attach sugar to proteins to make glycoproteins [v]\n",
  "GLYCOSYLATES": "GLYCOSYLATE, to attach sugar to proteins to make glycoproteins [v]\n",
  "GLYCOSYLATING": "GLYCOSYLATE, to attach sugar to proteins to make glycoproteins [v]\n",
  "GLYCOSYLATION": "the process of adding glycosyl radicals to a protein to form a glycoprotein [n -S]\n",
  "GLYCOSYLATIONS": "GLYCOSYLATION, the process of adding glycosyl radicals to a protein to form a glycoprotein [n]\n",
  "GLYCOSYLS": "GLYCOSYL, a radical derived from glucose [n]\n",
  "GLYCYL": "a radical derived from glucose [n -S]\n",
  "GLYCYLS": "GLYCYL, a radical derived from glucose [n]\n",
  "GLYOXALINE": "any of a group of heterocyclic compounds produced by substitution in a five-membered ring containing two nitrogen atoms on either side of a carbon atom [n -S]\n",
  "GLYOXALINES": "GLYOXALINE, any of a group of heterocyclic compounds produced by substitution in a five-membered ring containing two nitrogen atoms on either side of a carbon atom [n]\n",
  "GLYPH": "a sunken channel or groove, usually vertical [n -S]\n",
  "GLYPHIC": "of or pertaining to carving, esp. to glyphs [adj]\n",
  "GLYPHOGRAPH": "a plate formed by glyphography [n -S]\n",
  "GLYPHOGRAPHER": "one who practises glyphography [n -S]\n",
  "GLYPHOGRAPHERS": "GLYPHOGRAPHER, one who practises glyphography [n]\n",
  "GLYPHOGRAPHIC": "relating to glyphography, also GLYPHOGRAPHICAL [adj]\n",
  "GLYPHOGRAPHICAL": "relating to glyphography, also GLYPHOGRAPHIC [adj]\n",
  "GLYPHOGRAPHIES": "GLYPHOGRAPHY, a process of taking a raised copy of an engraved plate by electrotype [n]\n",
  "GLYPHOGRAPHS": "GLYPHOGRAPH, a plate formed by glyphography [n]\n",
  "GLYPHOGRAPHY": "a process of taking a raised copy of an engraved plate by electrotype [n GLYPHOGRAPHIES]\n",
  "GLYPHOSATE": "a synthetic compound widely used as a herbicide [n -S]\n",
  "GLYPHOSATES": "GLYPHOSATE, a synthetic compound widely used as a herbicide [n]\n",
  "GLYPHS": "GLYPH, a sunken channel or groove, usually vertical [n]\n",
  "GLYPTAL": "a kind of alkyd resin [n -S]\n",
  "GLYPTALS": "GLYPTAL, a kind of alkyd resin [n]\n",
  "GLYPTIC": "the art or process of engraving on gems [n -S]\n",
  "GLYPTICS": "GLYPTIC, the art or process of engraving on gems [n]\n",
  "GLYPTODONT": "any of a family of extinct South American edentates [n -S]\n",
  "GLYPTODONTS": "GLYPTODONT, any of a family of extinct South American edentates [n]\n",
  "GLYPTOGRAPHER": "one who practises glyptography, the art of engraving on gems [n -S]\n",
  "GLYPTOGRAPHERS": "GLYPTOGRAPHER, one who practises glyptography, the art of engraving on gems [n]\n",
  "GLYPTOGRAPHIC": "relating to glyptography, the art of engraving on gems, also GLYPTOGRAPHICAL [adj]\n",
  "GLYPTOGRAPHICAL": "relating to glyptography, the art of engraving on gems, also GLYPTOGRAPHIC [adj]\n",
  "GLYPTOGRAPHIES": "GLYPTOGRAPHY, the art of engraving on gems [n]\n",
  "GLYPTOGRAPHY": "the art of engraving on gems [n GLYPTOGRAPHIES]\n",
  "GLYPTOTHECA": "a place for keeping sculpture [n GLYPTOTHECAE]\n",
  "GLYPTOTHECAE": "GLYPTOTHECA, a place for keeping sculpture [n]\n",
  "GMELINITE": "a rhombohedral zeolitic mineral, related in form and composition to chabazite [n -S]\n",
  "GMELINITES": "GMELINITE, a rhombohedral zeolitic mineral, related in form and composition to chabazite [n]\n",
  "GNAMMA": "as in gnamma hole, an Australian term for a natural well in rock, also GNAMMA [adj]\n",
  "GNAPHALIUM": "a genus of composite plants with white or colored dry and persistent involucres [n -S]\n",
  "GNAPHALIUMS": "GNAPHALIUM, a genus of composite plants with white or colored dry and persistent involucres [n]\n",
  "GNAR": "to snarl, also GNARR, KNAR [v GNARRED, GNARRING, GNARS]\n",
  "GNARL": "to twist into a state of deformity, also KNARL [v -ED, -ING, -S]\n",
  "GNARLED": "GNARL, to twist into a state of deformity, also KNARL [v]\n",
  "GNARLIER": "GNARLY, gnarled [adj]\n",
  "GNARLIEST": "GNARLY, gnarled [adj]\n",
  "GNARLING": "GNARL, to twist into a state of deformity, also KNARL [v]\n",
  "GNARLS": "GNARL, to twist into a state of deformity, also KNARL [v]\n",
  "GNARLY": "gnarled [adj GNARLIER, GNARLIEST]\n",
  "GNARR": "to snarl, also GNAR, KNAR [v -ED, -ING, -S]\n",
  "GNARRED": "GNAR, to snarl, also GNARR, KNAR [v]\n",
  "GNARRING": "GNAR, to snarl, also GNARR, KNAR [v]\n",
  "GNARRS": "GNARR, to snarl, also GNAR, KNAR [v]\n",
  "GNARS": "GNAR, to snarl, also GNARR, KNAR [v]\n",
  "GNASH": "to grind the teeth together [v -ED, -ING, -ES]\n",
  "GNASHED": "GNASH, to grind the teeth together [v]\n",
  "GNASHER": "(colloquial) a tooth [n -S]\n",
  "GNASHERS": "GNASHER, (colloquial) a tooth [n]\n",
  "GNASHES": "GNASH, to grind the teeth together [v]\n",
  "GNASHING": "grinding [adj GNASHINGLY] / the act of grinding the teeth together [n -S]\n",
  "GNASHINGLY": "GNASHING, grinding [adv]\n",
  "GNASHINGS": "GNASHING, the act of grinding the teeth together [n]\n",
  "GNAT": "any small fly of the family Culicidae, of which the females are commonly bloodsuckers [n -S]\n",
  "GNATCATCHER": "any of the insectivorous American songbirds of the genus Polioptila [n -S]\n",
  "GNATCATCHERS": "GNATCATCHER, any of the insectivorous American songbirds of the genus Polioptila [n]\n",
  "GNATHAL": "of or pertaining to the jaw, also GNATHIC [adj]\n",
  "GNATHIC": "of or pertaining to the jaw, also GNATHAL [adj]\n",
  "GNATHION": "(Greek) the tip of the chin [n -S]\n",
  "GNATHIONS": "GNATHION, (Greek) the tip of the chin [n]\n",
  "GNATHITE": "a jawlike appendage of an insect [n -S]\n",
  "GNATHITES": "GNATHITE, a jawlike appendage of an insect [n]\n",
  "GNATHONIC": "(obsolete) flattering, also GNATHONICAL [adj GNATHONICALLY]\n",
  "GNATHONICAL": "(obsolete) flattering, also GNATHONIC [adj GNATHONICALLY]\n",
  "GNATHONICALLY": "GNATHONICAL, (obsolete) flattering, also GNATHONIC [adv]\n",
  "GNATHOSTOMATOUS": "of or like a gnathostome [adj]\n",
  "GNATHOSTOME": "any vertebrate of the superclass Gnathostomata, having a mouth with jaws, including all vertebrates except the agnathans [n -S]\n",
  "GNATHOSTOMES": "GNATHOSTOME, any vertebrate of the superclass Gnathostomata, having a mouth with jaws, including all vertebrates except the agnathans [n]\n",
  "GNATLIKE": "like a gnat [adj]\n",
  "GNATLING": "a little gnat [n -S]\n",
  "GNATLINGS": "GNATLING, a little gnat [n]\n",
  "GNATS": "GNAT, any small fly of the family Culicidae, of which the females are commonly bloodsuckers [n]\n",
  "GNATTIER": "GNATTY, infested with gnats [adj]\n",
  "GNATTIEST": "GNATTY, infested with gnats [adj]\n",
  "GNATTY": "infested with gnats [adj GNATTIER, GNATTIEST]\n",
  "GNATWREN": "any of various species of small bird of the gnatcatcher family [n -S]\n",
  "GNATWRENS": "GNATWREN, any of various species of small bird of the gnatcatcher family [n]\n",
  "GNAW": "to wear away by persistent biting [v GNAWED, GNAWN, GNAWING, GNAWS]\n",
  "GNAWABLE": "able to be gnawed [adj]\n",
  "GNAWED": "GNAW, to wear away by persistent biting [v]\n",
  "GNAWER": "one who, or that which, gnaws [n -S]\n",
  "GNAWERS": "GNAWER, one who, or that which, gnaws [n]\n",
  "GNAWING": "of a pain, eating away [adj GNAWINGLY] / a persistent dull pain [n -S]\n",
  "GNAWINGLY": "GNAWING, of a pain, eating away [adv]\n",
  "GNAWINGS": "GNAWING, a persistent dull pain [n]\n",
  "GNAWN": "GNAW, to wear away by persistent biting [v]\n",
  "GNAWS": "GNAW, to wear away by persistent biting [v]\n",
  "GNEISS": "(German) a foliated usually coarse-grained metamorphic rock typically consisting of feldspar, quartz, and mica [n -ES]\n",
  "GNEISSES": "GNEISS, (German) a foliated usually coarse-grained metamorphic rock typically consisting of feldspar, quartz, and mica [n]\n",
  "GNEISSIC": "of or like gneiss, also GNEISSITIC [adj]\n",
  "GNEISSITIC": "of or like gneiss, also GNEISSIC [adj]\n",
  "GNEISSOID": "like gneiss [adj]\n",
  "GNEISSOSE": "having the structure of gneiss [adj]\n",
  "GNETOPHYTE": "a type of plant including welwitschia [n -S]\n",
  "GNETOPHYTES": "GNETOPHYTE, a type of plant including welwitschia [n]\n",
  "GNOCCHI": "(Italian) dumplings made of semolina or potato served with grated cheese and sauces [n]\n",
  "GNOMAE": "GNOME, a fabled little person [n]\n",
  "GNOME": "a fabled little person [n -S] / a pithy saying [n GNOMAE]\n",
  "GNOMELIKE": "like a gnome [adj]\n",
  "GNOMES": "GNOME, a fabled little person [n]\n",
  "GNOMIC": "resembling or containing aphorisms, also GNOMICAL [adj GNOMICALLY]\n",
  "GNOMICAL": "resembling or containing aphorisms, also GNOMIC [adj GNOMICALLY]\n",
  "GNOMICALLY": "GNOMICAL, resembling or containing aphorisms, also GNOMIC [adv]\n",
  "GNOMISH": "like a gnome [adj]\n",
  "GNOMIST": "a writer of aphorisms [n -S]\n",
  "GNOMISTS": "GNOMIST, a writer of aphorisms [n]\n",
  "GNOMON": "(Greek) the pointer of a sundial [n -S]\n",
  "GNOMONIC": "of or pertaining to a gnomon, a sundial, also GNOMONICAL [adj GNOMONICALLY]\n",
  "GNOMONICAL": "of or pertaining to a gnomon, a sundial, also GNOMONIC [adj GNOMONICALLY]\n",
  "GNOMONICALLY": "GNOMONICAL, of or pertaining to a gnomon, a sundial, also GNOMONIC [adv]\n",
  "GNOMONICS": "the science of making sundials [n GNOMONICS]\n",
  "GNOMONOLOGIES": "GNOMONOLOGY, a treatise on gnomonics [n]\n",
  "GNOMONOLOGY": "a treatise on gnomonics [n GNOMONOLOGIES]\n",
  "GNOMONS": "GNOMON, (Greek) the pointer of a sundial [n]\n",
  "GNOSEOLOGIES": "GNOSEOLOGY, the philosophy of knowledge, also GNOSIOLOGY [n]\n",
  "GNOSEOLOGY": "the philosophy of knowledge, also GNOSIOLOGY [n GNOSEOLOGIES]\n",
  "GNOSES": "GNOSIS, (Greek) mystical knowledge [n]\n",
  "GNOSIOLOGIES": "GNOSIOLOGY, the philosophy of knowledge, also GNOSEOLOGY [n]\n",
  "GNOSIOLOGY": "the philosophy of knowledge, also GNOSEOLOGY [n GNOSIOLOGIES]\n",
  "GNOSIS": "(Greek) mystical knowledge [n GNOSES]\n",
  "GNOSTIC": "knowing; wise; shrewd, also GNOSTICAL [adj GNOSTICALLY] / one who knows [n -S]\n",
  "GNOSTICAL": "having knowledge, also GNOSTIC [adj GNOSTICALLY]\n",
  "GNOSTICALLY": "GNOSTICAL, having knowledge, also GNOSTIC [adv]\n",
  "GNOSTICISM": "the belief that freedom derives solely from knowledge [n -S]\n",
  "GNOSTICISMS": "GNOSTICISM, the belief that freedom derives solely from knowledge [n]\n",
  "GNOSTICS": "GNOSTIC, one who knows [n]\n",
  "GNOTOBIOLOGICAL": "related to gnotobiology [adj]\n",
  "GNOTOBIOLOGIES": "GNOTOBIOLOGY, the study of life in germfree conditions [n]\n",
  "GNOTOBIOLOGY": "the study of life in germfree conditions [n GNOTOBIOLOGIES]\n",
  "GNOTOBIOSES": "GNOTOBIOSIS, the rearing of organisms in a germfree environment [n]\n",
  "GNOTOBIOSIS": "the rearing of organisms in a germfree environment [n GNOTOBIOSES]\n",
  "GNOTOBIOTE": "a germfree animal [n -S]\n",
  "GNOTOBIOTES": "GNOTOBIOTE, a germfree animal [n]\n",
  "GNOTOBIOTIC": "relating to gnotobiotics, the study of organisms in germfree conditions [adj GNOTOBIOTICALLY]\n",
  "GNOTOBIOTICALLY": "GNOTOBIOTIC, relating to gnotobiotics, the study of organisms in germfree conditions [adv]\n",
  "GNOTOBIOTICS": "the study of organisms living in germfree conditions or when inoculated with known microorganisms [n]\n",
  "GNOW": "the mallee fowl [n -S]\n",
  "GNOWS": "GNOW, the mallee fowl [n]\n",
  "GNU": "a kind of African antelope [n -S]\n",
  "GNUS": "GNU, a kind of African antelope [n]\n",
  "GO": "to move along [v GONE, GOING, GOES] / a Japanese board game [n -S]\n",
  "GOA": "a kind of Tibetan gazelle, grey-brown with backward-curving horns [n -S]\n",
  "GOAD": "to drive animals with a goad (a pointed stick) [v -ED, -ING, -S]\n",
  "GOADED": "GOAD, to drive animals with a goad (a pointed stick) [v]\n",
  "GOADING": "GOAD, to drive animals with a goad (a pointed stick) [v]\n",
  "GOADLIKE": "resembling a goad [adj]\n",
  "GOADS": "GOAD, to drive animals with a goad (a pointed stick) [v]\n",
  "GOADSMAN": "a man who uses a goad, also GOADSTER [n GOADSMEN]\n",
  "GOADSMEN": "GOADSMAN, a man who uses a goad, also GOADSTER [n]\n",
  "GOADSTER": "a man who uses a goad, also GOADSMAN [n -S]\n",
  "GOADSTERS": "GOADSTER, a man who uses a goad, also GOADSMAN [n]\n",
  "GOAF": "a space in a coal-seam, into which waste is packed [n -S]\n",
  "GOAFS": "GOAF, a space in a coal-seam, into which waste is packed [n]\n",
  "GOAL": "a point-scoring play in some games [n -S] / to score a goal [v -ED, -ING, -S]\n",
  "GOALBALL": "a game for the sight impaired [n -S]\n",
  "GOALBALLS": "GOALBALL, a game for the sight impaired [n]\n",
  "GOALED": "GOAL, to score a goal [v]\n",
  "GOALIE": "a player who defends against goals [n -S]\n",
  "GOALIES": "GOALIE, a player who defends against goals [n]\n",
  "GOALING": "GOAL, to score a goal [v]\n",
  "GOALKEEPER": "a player who defends the goal in any of various games (as hockey, lacrosse, or soccer) [n -S]\n",
  "GOALKEEPERS": "GOALKEEPER, a player who defends the goal in any of various games (as hockey, lacrosse, or soccer) [n]\n",
  "GOALKEEPING": "the activities of a goalkeeper [n -S]\n",
  "GOALKEEPINGS": "GOALKEEPING, the activities of a goalkeeper [n]\n",
  "GOALKICKER": "a player who kicks a goal, or does a goal kick [n -S]\n",
  "GOALKICKERS": "GOALKICKER, a player who kicks a goal, or does a goal kick [n]\n",
  "GOALKICKING": "the kicking of a goal [n -S]\n",
  "GOALKICKINGS": "GOALKICKING, the kicking of a goal [n]\n",
  "GOALLESS": "having no goal [adj]\n",
  "GOALMOUTH": "the space between the goalposts and immediately in front of the goal [n -S]\n",
  "GOALMOUTHS": "GOALMOUTH, the space between the goalposts and immediately in front of the goal [n]\n",
  "GOALPOST": "a post marking a boundary of a scoring area [n -S]\n",
  "GOALPOSTS": "GOALPOST, a post marking a boundary of a scoring area [n]\n",
  "GOALS": "GOAL, to score a goal [v]\n",
  "GOALSCORER": "one who scores goals [n -S]\n",
  "GOALSCORERS": "GOALSCORER, one who scores goals [n]\n",
  "GOALTENDER": "in some games, esp. ice-hockey, a goalkeeper [n -S]\n",
  "GOALTENDERS": "GOALTENDER, in some games, esp. ice-hockey, a goalkeeper [n]\n",
  "GOALTENDING": "the act of minding the goal [n -S]\n",
  "GOALTENDINGS": "GOALTENDING, the act of minding the goal [n]\n",
  "GOALWARD": "toward or in the direction of the opposing team's goal, also GOALWARDS [adv]\n",
  "GOALWARDS": "toward or in the direction of the opposing team's goal, also GOALWARD [adv]\n",
  "GOANNA": "a large monitor lizard [n -S]\n",
  "GOANNAS": "GOANNA, a large monitor lizard [n]\n",
  "GOARY": "(Milton) gory, bloody [adj]\n",
  "GOAS": "GOA, a kind of Tibetan gazelle, grey-brown with backward-curving horns [n]\n",
  "GOAT": "a horned mammal [n -S]\n",
  "GOATEE": "a small pointed beard, also GOATY [n -S]\n",
  "GOATEED": "having a goatee [adj]\n",
  "GOATEES": "GOATEE, a small pointed beard, also GOATY [n]\n",
  "GOATFISH": "a tropical fish inhabiting the Gulf of Mexico, allied to the surmullet [n -ES]\n",
  "GOATFISHES": "GOATFISH, a tropical fish inhabiting the Gulf of Mexico, allied to the surmullet [n]\n",
  "GOATHERD": "one who tends goats [n -S]\n",
  "GOATHERDS": "GOATHERD, one who tends goats [n]\n",
  "GOATIER": "GOATY, like a goat, smelling of goat [adj]\n",
  "GOATIES": "GOATY, a goatee beard, also GOATEE [n]\n",
  "GOATIEST": "GOATY, like a goat, smelling of goat [adj]\n",
  "GOATISH": "lustful [adj GOATISHLY]\n",
  "GOATISHLY": "GOATISH, lustful [adv]\n",
  "GOATISHNESS": "the state of being goatish, lustful [n -ES]\n",
  "GOATISHNESSES": "GOATISHNESS, the state of being goatish, lustful [n]\n",
  "GOATLIKE": "resembling a goat [adj]\n",
  "GOATLING": "a young goat [n -S]\n",
  "GOATLINGS": "GOATLING, a young goat [n]\n",
  "GOATS": "GOAT, a horned mammal [n]\n",
  "GOATSBEARD": "a plant with woolly stems and large heads of yellow rayed flowers surrounded by large green bracts [n -S]\n",
  "GOATSBEARDS": "GOATSBEARD, a plant with woolly stems and large heads of yellow rayed flowers surrounded by large green bracts [n]\n",
  "GOATSE": "a deliberately shocking and offensive, usually pornographic, image placed maliciously by someone into a website [n -S]\n",
  "GOATSES": "GOATSE, a deliberately shocking and offensive, usually pornographic, image placed maliciously by someone into a website [n]\n",
  "GOATSKIN": "the hide of a goat [n -S]\n",
  "GOATSKINS": "GOATSKIN, the hide of a goat [n]\n",
  "GOATSUCKER": "the nightjar, a bird similar to the swift, falsely thought to suck goats' udders for milk [n -S]\n",
  "GOATSUCKERS": "GOATSUCKER, the nightjar, a bird similar to the swift, falsely thought to suck goats' udders for milk [n]\n",
  "GOATWEED": "an umbelliferous weed, long supposed to be good for gout, also GOUTWEED, GOUTWORT [n -S]\n",
  "GOATWEEDS": "GOATWEED, an umbelliferous weed, long supposed to be good for gout, also GOUTWEED, GOUTWORT [n]\n",
  "GOATY": "like a goat, smelling of goat [adj GOATIER, GOATIEST] / a goatee beard, also GOATEE [n GOATIES]\n",
  "GOB": "to spit [v GOBBED, GOBBING, GOBS]\n",
  "GOBAN": "(Japanese) a Japanese board game, also GOBANG, GOMOKU [n -S]\n",
  "GOBANG": "(Japanese) a Japanese board game, also GOBAN, GOMOKU [n -S]\n",
  "GOBANGS": "GOBANG, (Japanese) a Japanese board game, also GOBAN, GOMOKU [n]\n",
  "GOBANS": "GOBAN, (Japanese) a Japanese board game, also GOBANG, GOMOKU [n]\n",
  "GOBAR": "as in gobar numeral, any of a set of numerals forming the stage between ancient Hindu numerals and present-day Arabic numerals, also GHUBAR [adj]\n",
  "GOBBED": "GOB, to spit [v]\n",
  "GOBBELINE": "(Spenser) a goblin [n -S]\n",
  "GOBBELINES": "GOBBELINE, (Spenser) a goblin [n]\n",
  "GOBBET": "a piece of raw meat [n -S]\n",
  "GOBBETS": "GOBBET, a piece of raw meat [n]\n",
  "GOBBI": "GOBBO, (Italian) a hunchback [n]\n",
  "GOBBIER": "GOBBY, (colloquial) loudmouthed [adj]\n",
  "GOBBIEST": "GOBBY, (colloquial) loudmouthed [adj]\n",
  "GOBBING": "GOB, to spit [v]\n",
  "GOBBLE": "to eat hastily [v GOBBLED, GOBBLING, GOBBLES]\n",
  "GOBBLED": "GOBBLE, to eat hastily [v]\n",
  "GOBBLEDEGOOK": "unintelligible official jargon, also GOBBLEDYGOOK [n -S]\n",
  "GOBBLEDEGOOKS": "GOBBLEDEGOOK, unintelligible official jargon, also GOBBLEDYGOOK [n]\n",
  "GOBBLEDYGOOK": "unintelligible official jargon, also GOBBLEDEGOOK [n -S]\n",
  "GOBBLEDYGOOKS": "GOBBLEDYGOOK, unintelligible official jargon, also GOBBLEDEGOOK [n]\n",
  "GOBBLER": "(US) a turkey cock [n -S]\n",
  "GOBBLERS": "GOBBLER, (US) a turkey cock [n]\n",
  "GOBBLES": "GOBBLE, to eat hastily [v]\n",
  "GOBBLING": "GOBBLE, to eat hastily [v]\n",
  "GOBBO": "(Italian) a hunchback [n GOBBI]\n",
  "GOBBY": "(colloquial) loudmouthed [adj GOBBIER, GOBBIEST]\n",
  "GOBI": "(Hindi) a cabbage or cauliflower [n -S]\n",
  "GOBIES": "GOBY, any fish of the genus Gobius with ventral fins forming a sucker [n]\n",
  "GOBIID": "a fish of the goby family, also GOBIOID [n -S]\n",
  "GOBIIDS": "GOBIID, a fish of the goby family, also GOBIOID [n]\n",
  "GOBIOID": "a fish of the goby family, also GOBIID [n -S]\n",
  "GOBIOIDS": "GOBIOID, a fish of the goby family, also GOBIID [n]\n",
  "GOBIS": "GOBI, (Hindi) a cabbage or cauliflower [n]\n",
  "GOBLET": "a drinking vessel [n -S]\n",
  "GOBLETS": "GOBLET, a drinking vessel [n]\n",
  "GOBLIN": "an unpleasant or mischievous sprite in the form of an old man, also GOBBELINE [n -S]\n",
  "GOBLINS": "GOBLIN, an unpleasant or mischievous sprite in the form of an old man, also GOBBELINE [n]\n",
  "GOBO": "a device to shield a microphone [n -ES or -S]\n",
  "GOBOES": "GOBO, a device to shield a microphone [n]\n",
  "GOBONEE": "composed of squares of alternating colours, also GOBONY [adj]\n",
  "GOBONY": "composed of squares of alternating colours, also GOBONEE [adj]\n",
  "GOBOS": "GOBO, a device to shield a microphone [n]\n",
  "GOBS": "GOB, to spit [v]\n",
  "GOBSHITE": "(offensive) a garrulous stupid idiot [n -S]\n",
  "GOBSHITES": "GOBSHITE, (offensive) a garrulous stupid idiot [n]\n",
  "GOBSMACKED": "(colloquial) taken aback, speechless [adj]\n",
  "GOBSTOPPER": "(colloquial) a large sweet that is sucked [n -S]\n",
  "GOBSTOPPERS": "GOBSTOPPER, (colloquial) a large sweet that is sucked [n]\n",
  "GOBURRA": "(Native Australian) a large Australian kingfisher, whose call sounds like a raucous laugh, also KOOKABURRA [n -S]\n",
  "GOBURRAS": "GOBURRA, (Native Australian) a large Australian kingfisher, whose call sounds like a raucous laugh, also KOOKABURRA [n]\n",
  "GOBY": "any fish of the genus Gobius with ventral fins forming a sucker [n GOBIES]\n",
  "GOCHUJANG": "a spicy paste used in Korean cuisine that is made from red chili peppers, glutinous rice, and fermented soybeans [n -S]\n",
  "GOCHUJANGS": "GOCHUJANG, a spicy paste used in Korean cuisine that is made from red chili peppers, glutinous rice, and fermented soybeans [n]\n",
  "GOD": "to treat as a god (a supernatural being) [v GODDED, GODDING, GODS]\n",
  "GODAMNDEST": "GODDAMNED, damned [adj]\n",
  "GODAWFUL": "extremely unpleasant [adj]\n",
  "GODCHILD": "one whom a person sponsors at baptism [n GODCHILDREN]\n",
  "GODCHILDREN": "GODCHILD, one whom a person sponsors at baptism [n]\n",
  "GODDAM": "to damn, also GODDAMN [v GODDAMMED, GODDAMMING, GODDAMS]\n",
  "GODDAMMED": "GODDAM, to damn, also GODDAMN [v]\n",
  "GODDAMMING": "GODDAM, to damn, also GODDAMN [v]\n",
  "GODDAMMIT": "an oath expressing anger, surprise, irritation, etc. [interj]\n",
  "GODDAMN": "to damn, also GODDAM [v -ED, -ING, -S]\n",
  "GODDAMNDEST": "GODDAMNED, damned [adj]\n",
  "GODDAMNED": "damned [adj GODDAMNDEST or GODDAMNEDEST or GODAMNDEST]\n",
  "GODDAMNEDEST": "GODDAMNED, damned [adj]\n",
  "GODDAMNING": "GODDAMN, to damn, also GODDAM [v]\n",
  "GODDAMNIT": "an imprecation, God damn it [interj]\n",
  "GODDAMNS": "GODDAMN, to damn, also GODDAM [v]\n",
  "GODDAMS": "GODDAM, to damn, also GODDAMN [v]\n",
  "GODDAUGHTER": "a female godchild [n -S]\n",
  "GODDAUGHTERS": "GODDAUGHTER, a female godchild [n]\n",
  "GODDED": "GOD, to treat as a god (a supernatural being) [v]\n",
  "GODDEN": "a dialect variant of good evening [n -S]\n",
  "GODDENS": "GODDEN, a dialect variant of good evening [n]\n",
  "GODDESS": "a female god [n -ES]\n",
  "GODDESSES": "GODDESS, a female god [n]\n",
  "GODDESSHOOD": "the state of being a goddess [n -S]\n",
  "GODDESSHOODS": "GODDESSHOOD, the state of being a goddess [n]\n",
  "GODDING": "GOD, to treat as a god (a supernatural being) [v]\n",
  "GODET": "(French) a triangular piece of cloth inserted in a skirt [n -S]\n",
  "GODETIA": "any plant of an American genus, closely related to the evening primrose [n -S]\n",
  "GODETIAS": "GODETIA, any plant of an American genus, closely related to the evening primrose [n]\n",
  "GODETS": "GODET, (French) a triangular piece of cloth inserted in a skirt [n]\n",
  "GODFATHER": "a male godparent [n -S] / to be a godfather to [v -ED, -ING, -S]\n",
  "GODFATHERED": "GODFATHER, to be a godfather to [v]\n",
  "GODFATHERING": "GODFATHER, to be a godfather to [v]\n",
  "GODFATHERS": "GODFATHER, to be a godfather to [v]\n",
  "GODFORSAKEN": "remote, desolate [adj]\n",
  "GODHEAD": "the state of being a god, also GODHOOD [n -S]\n",
  "GODHEADS": "GODHEAD, the state of being a god, also GODHOOD [n]\n",
  "GODHOOD": "the state of being a god, also GODHEAD [n -S]\n",
  "GODHOODS": "GODHOOD, the state of being a god, also GODHEAD [n]\n",
  "GODLESS": "worshipping no god [adj GODLESSLY]\n",
  "GODLESSLY": "GODLESS, worshipping no god [adv]\n",
  "GODLESSNESS": "the state of being godless [n -ES]\n",
  "GODLESSNESSES": "GODLESSNESS, the state of being godless [n]\n",
  "GODLIER": "GODLY, like a god [adj]\n",
  "GODLIEST": "GODLY, like a god [adj]\n",
  "GODLIKE": "resembling a god [adj]\n",
  "GODLIKENESS": "the state of being godlike [n -ES]\n",
  "GODLIKENESSES": "GODLIKENESS, the state of being godlike [n]\n",
  "GODLILY": "GODLY, like a god [adv]\n",
  "GODLINESS": "the quality of being godly [n -ES]\n",
  "GODLINESSES": "GODLINESS, the quality of being godly [n]\n",
  "GODLING": "a lesser god [n -S]\n",
  "GODLINGS": "GODLING, a lesser god [n]\n",
  "GODLY": "like a god [adj GODLIER, GODLIEST, GODLILY]\n",
  "GODMOTHER": "a female godparent [n -S] / to act as a godmother [v -ED, -ING, -S]\n",
  "GODMOTHERED": "GODMOTHER, to act as a godmother [v]\n",
  "GODMOTHERING": "GODMOTHER, to act as a godmother [v]\n",
  "GODMOTHERS": "GODMOTHER, to act as a godmother [v]\n",
  "GODOWN": "(Malay) an oriental warehouse [n -S]\n",
  "GODOWNS": "GODOWN, (Malay) an oriental warehouse [n]\n",
  "GODPARENT": "a person who, at baptism, guarantees a child's religious education [n -S]\n",
  "GODPARENTS": "GODPARENT, a person who, at baptism, guarantees a child's religious education [n]\n",
  "GODROON": "a moulding band [n -S] / to ornament with godroons [v -ED, -ING, -S]\n",
  "GODROONED": "GODROON, to ornament with godroons [v]\n",
  "GODROONING": "ornamentation with godroons [n -S]\n",
  "GODROONINGS": "GODROONING, ornamentation with godroons [n]\n",
  "GODROONS": "GODROON, to ornament with godroons [v]\n",
  "GODS": "GOD, to treat as a god (a supernatural being) [v]\n",
  "GODSEND": "an unexpected boon [n -S]\n",
  "GODSENDS": "GODSEND, an unexpected boon [n]\n",
  "GODSHIP": "the rank of a god [n -S]\n",
  "GODSHIPS": "GODSHIP, the rank of a god [n]\n",
  "GODSLOT": "a slot in a television schedule for religious broadcasts [n -S]\n",
  "GODSLOTS": "GODSLOT, a slot in a television schedule for religious broadcasts [n]\n",
  "GODSO": "expressing surprise, also GADSO [interj]\n",
  "GODSON": "a male godchild [n -S]\n",
  "GODSONS": "GODSON, a male godchild [n]\n",
  "GODSPEED": "a wish for good fortune [n -S]\n",
  "GODSPEEDS": "GODSPEED, a wish for good fortune [n]\n",
  "GODSQUAD": "(offensive) evangelical Christians as a group [n -S]\n",
  "GODSQUADS": "GODSQUAD, (offensive) evangelical Christians as a group [n]\n",
  "GODWARD": "towards God, also GODWARDS [adv]\n",
  "GODWARDS": "towards God, also GODWARD [adv]\n",
  "GODWIT": "a bird of the plover family, with a long slightly upcurved bill and long slender legs [n -S]\n",
  "GODWITS": "GODWIT, a bird of the plover family, with a long slightly upcurved bill and long slender legs [n]\n",
  "GOE": "a gully or creek, also GEO, GIO [n -S]\n",
  "GOEL": "the avenger of blood among the Hebrews, the next of kin whose job it was to hunt down a murderer [n -S]\n",
  "GOELS": "GOEL, the avenger of blood among the Hebrews, the next of kin whose job it was to hunt down a murderer [n]\n",
  "GOER": "one that goes [n -S]\n",
  "GOERS": "GOER, one that goes [n]\n",
  "GOES": "GO, to move along [v]\n",
  "GOEST": "(archaic) 2nd person singular present tense of GO [v]\n",
  "GOETH": "(archaic) 3rd person singular present of GO [v]\n",
  "GOETHITE": "a hydrous oxide of iron, occurring in prismatic crystals, also GOTHITE [n -S]\n",
  "GOETHITES": "GOETHITE, a hydrous oxide of iron, occurring in prismatic crystals, also GOTHITE [n]\n",
  "GOETIC": "pertaining to goety, black magic [adj]\n",
  "GOETIES": "GOETY, (obsolete) black magic [n]\n",
  "GOETY": "(obsolete) black magic [n GOETIES]\n",
  "GOEY": "anxious to go [adj GOIER, GOIEST]\n",
  "GOFER": "a waffle with a pattern of crossed lines, also GAUFER, GAUFRE [n -S]\n",
  "GOFERS": "GOFER, a waffle with a pattern of crossed lines, also GAUFER, GAUFRE [n]\n",
  "GOFF": "to play golf (a ball game), also GOLF, GOWF [v -ED, -ING, -S]\n",
  "GOFFED": "GOFF, to play golf (a ball game), also GOLF, GOWF [v]\n",
  "GOFFER": "to press ridges or pleats into, also GAUFFER [v -ED, -ING, -S]\n",
  "GOFFERED": "GOFFER, to press ridges or pleats into, also GAUFFER [v]\n",
  "GOFFERING": "make pleats with a goffering iron, also GAUFFERING [n -S]\n",
  "GOFFERINGS": "GOFFERING, make pleats with a goffering iron, also GAUFFERING [n]\n",
  "GOFFERS": "GOFFER, to press ridges or pleats into, also GAUFFER [v]\n",
  "GOFFING": "GOFF, to play golf (a ball game), also GOLF, GOWF [v]\n",
  "GOFFS": "GOFF, to play golf (a ball game), also GOLF, GOWF [v]\n",
  "GOGGA": "(South African) an insect, a creepy-crawly [n -S]\n",
  "GOGGAS": "GOGGA, (South African) an insect, a creepy-crawly [n]\n",
  "GOGGLE": "to stare with wide eyes [v GOGGLED, GOGGLING, GOGGLES]\n",
  "GOGGLEBOX": "(colloquial) the television [n -ES]\n",
  "GOGGLEBOXES": "GOGGLEBOX, (colloquial) the television [n]\n",
  "GOGGLED": "GOGGLE, to stare with wide eyes [v]\n",
  "GOGGLER": "a kind of oceanic fish, having very large and prominent eyes [n -S]\n",
  "GOGGLERS": "GOGGLER, a kind of oceanic fish, having very large and prominent eyes [n]\n",
  "GOGGLES": "GOGGLE, to stare with wide eyes [v]\n",
  "GOGGLIER": "GOGGLY, wide-eyed [adj]\n",
  "GOGGLIEST": "GOGGLY, wide-eyed [adj]\n",
  "GOGGLING": "the act of staring with wide eyes [n -S]\n",
  "GOGGLINGS": "GOGGLING, the act of staring with wide eyes [n]\n",
  "GOGGLY": "wide-eyed [adj GOGGLIER, GOGGLIEST]\n",
  "GOGLET": "(Portuguese) a porous earthen jar for cooling water by evaporation, also GUGLET, GURGLET [n -S]\n",
  "GOGLETS": "GOGLET, (Portuguese) a porous earthen jar for cooling water by evaporation, also GUGLET, GURGLET [n]\n",
  "GOGO": "(Zulu) a grandmother [n -S]\n",
  "GOGOS": "GOGO, (Zulu) a grandmother [n]\n",
  "GOHONZON": "(Japanese) a Buddhist paper scroll to which devotional chanting is directed [n -S]\n",
  "GOHONZONS": "GOHONZON, (Japanese) a Buddhist paper scroll to which devotional chanting is directed [n]\n",
  "GOIER": "GOEY, anxious to go [adj]\n",
  "GOIEST": "GOEY, anxious to go [adj]\n",
  "GOING": "an advance toward an objective [n -S]\n",
  "GOINGS": "GOING, an advance toward an objective [n]\n",
  "GOITER": "an enlargement of the thyroid gland, also GOITRE [n -S]\n",
  "GOITERED": "afflicted with a goiter, also GOITRED [adj]\n",
  "GOITERS": "GOITER, an enlargement of the thyroid gland, also GOITRE [n]\n",
  "GOITRE": "an enlargement of the thyroid gland, also GOITER [n -S]\n",
  "GOITRED": "afflicted with a goiter, also GOITERED [adj]\n",
  "GOITRES": "GOITRE, an enlargement of the thyroid gland, also GOITER [n]\n",
  "GOITROGEN": "a substance (such as thiourea or thiouracil) that induces goiter formation [n -S]\n",
  "GOITROGENIC": "producing or tending to produce goiter [adj]\n",
  "GOITROGENICITY": "the state of being goitrogenic [n]\n",
  "GOITROGENS": "GOITROGEN, a substance (such as thiourea or thiouracil) that induces goiter formation [n]\n",
  "GOITROUS": "having a goiter [adj]\n",
  "GOJI": "(Chinese) the vitamin-rich berry of a solanaceous Chinese plant, aka WOLFBERRY [n -S]\n",
  "GOJIS": "GOJI, (Chinese) the vitamin-rich berry of a solanaceous Chinese plant, aka WOLFBERRY [n]\n",
  "GOLCONDA": "(Hindi) a source of great wealth [n -S]\n",
  "GOLCONDAS": "GOLCONDA, (Hindi) a source of great wealth [n]\n",
  "GOLD": "a precious metallic element [n -S] / of the colour of gold [adj GOLDER, GOLDEST]\n",
  "GOLDARN": "(colloquial) to damn, also GOLDURN [v -ED, -ING, -S]\n",
  "GOLDARNED": "GOLDARN, (colloquial) to damn, also GOLDURN [v]\n",
  "GOLDARNING": "GOLDARN, (colloquial) to damn, also GOLDURN [v]\n",
  "GOLDARNS": "GOLDARN, (colloquial) to damn, also GOLDURN [v]\n",
  "GOLDBEATER": "one who beats gold into gold leaf [n -S]\n",
  "GOLDBEATERS": "GOLDBEATER, one who beats gold into gold leaf [n]\n",
  "GOLDBRICK": "a person who shirks duties or responsibilities [n -S] / to shirk duties [v -ED, -ING, -S]\n",
  "GOLDBRICKED": "GOLDBRICK, to shirk duties [v]\n",
  "GOLDBRICKING": "GOLDBRICK, to shirk duties [v]\n",
  "GOLDBRICKS": "GOLDBRICK, a person who shirks duties or responsibilities [n]\n",
  "GOLDBUG": "a gold beetle [n -S]\n",
  "GOLDBUGS": "GOLDBUG, a gold beetle [n]\n",
  "GOLDCREST": "a small bird of the wren family, with a golden streak on its head [n -S]\n",
  "GOLDCRESTS": "GOLDCREST, a small bird of the wren family, with a golden streak on its head [n]\n",
  "GOLDEN": "of the colour of gold [adj GOLDENER, GOLDENEST, GOLDENLY] / to become like gold [v -ED, -ING, -S]\n",
  "GOLDENBERRIES": "GOLDENBERRY, the Cape gooseberry [n]\n",
  "GOLDENBERRY": "the Cape gooseberry [n GOLDENBERRIES]\n",
  "GOLDENED": "GOLDEN, to become like gold [v]\n",
  "GOLDENER": "GOLDEN, of the colour of gold [adj]\n",
  "GOLDENEST": "GOLDEN, of the colour of gold [adj]\n",
  "GOLDENEYE": "a kind of duck [n -S]\n",
  "GOLDENEYES": "GOLDENEYE, a kind of duck [n]\n",
  "GOLDENING": "GOLDEN, to become like gold [v]\n",
  "GOLDENLY": "GOLDEN, of the colour of gold [adv]\n",
  "GOLDENNESS": "the state of being golden [n -ES]\n",
  "GOLDENNESSES": "GOLDENNESS, the state of being golden [n]\n",
  "GOLDENROD": "a dark golden yellow flower [n -S]\n",
  "GOLDENRODS": "GOLDENROD, a dark golden yellow flower [n]\n",
  "GOLDENS": "GOLDEN, to become like gold [v]\n",
  "GOLDENSEAL": "a North American plant of the buttercup family, with a yellow rhizome used in medicine [n -S]\n",
  "GOLDENSEALS": "GOLDENSEAL, a North American plant of the buttercup family, with a yellow rhizome used in medicine [n]\n",
  "GOLDER": "GOLD, of the colour of gold [adj]\n",
  "GOLDEST": "GOLD, of the colour of gold [adj]\n",
  "GOLDEYE": "a freshwater fish [n -S]\n",
  "GOLDEYES": "GOLDEYE, a freshwater fish [n]\n",
  "GOLDFIELD": "a gold-producing region [n -S]\n",
  "GOLDFIELDS": "GOLDFIELD, a gold-producing region [n]\n",
  "GOLDFINCH": "a small gold-coloured bird of the finch family [n -ES]\n",
  "GOLDFINCHES": "GOLDFINCH, a small gold-coloured bird of the finch family [n]\n",
  "GOLDFINNIES": "GOLDFINNY, one of two or more species of European labroid fishes, also GOLDSINNY [n]\n",
  "GOLDFINNY": "one of two or more species of European labroid fishes, also GOLDSINNY [n GOLDFINNIES]\n",
  "GOLDFISH": "a freshwater cyprinid fish of East Europe and Asia, esp. China, widely introduced as a pond or aquarium fish [n -ES]\n",
  "GOLDFISHES": "GOLDFISH, a freshwater cyprinid fish of East Europe and Asia, esp. China, widely introduced as a pond or aquarium fish [n]\n",
  "GOLDIER": "GOLDY, somewhat like gold [adj]\n",
  "GOLDIES": "GOLDY, a goldfinch [n]\n",
  "GOLDIEST": "GOLDY, somewhat like gold [adj]\n",
  "GOLDILOCKS": "a species of buttercup [n -ES]\n",
  "GOLDILOCKSES": "GOLDILOCKS, a species of buttercup [n]\n",
  "GOLDISH": "somewhat gold [adj]\n",
  "GOLDLESS": "having no gold [adj]\n",
  "GOLDMINER": "one who mines for gold [n -S]\n",
  "GOLDMINERS": "GOLDMINER, one who mines for gold [n]\n",
  "GOLDS": "GOLD, a precious metallic element [n]\n",
  "GOLDSINNIES": "GOLDSINNY, one of two or more species of European labroid fishes, also GOLDFINNY [n]\n",
  "GOLDSINNY": "one of two or more species of European labroid fishes, also GOLDFINNY [n GOLDSINNIES]\n",
  "GOLDSIZE": "an adhesive used to attach gold leaf to a surface [n -S]\n",
  "GOLDSIZES": "GOLDSIZE, an adhesive used to attach gold leaf to a surface [n]\n",
  "GOLDSMITH": "a worker in gold and silver [n -S]\n",
  "GOLDSMITHERIES": "GOLDSMITHERY, the craft of a goldsmith, also GOLDSMITHRY [n]\n",
  "GOLDSMITHERY": "the craft of a goldsmith, also GOLDSMITHRY [n GOLDSMITHERIES]\n",
  "GOLDSMITHRIES": "GOLDSMITHRY, the craft of a goldsmith, also GOLDSMITHERY [n]\n",
  "GOLDSMITHRY": "the craft of a goldsmith, also GOLDSMITHERY [n GOLDSMITHRIES]\n",
  "GOLDSMITHS": "GOLDSMITH, a worker in gold and silver [n]\n",
  "GOLDSPINK": "(Scots) the goldfinch, also GOWDSPINK [n -S]\n",
  "GOLDSPINKS": "GOLDSPINK, (Scots) the goldfinch, also GOWDSPINK [n]\n",
  "GOLDSTICK": "a colonel of the Life Guards, who carries a gilded wand before his sovereign [n -S]\n",
  "GOLDSTICKS": "GOLDSTICK, a colonel of the Life Guards, who carries a gilded wand before his sovereign [n]\n",
  "GOLDSTONE": "a mineral, aventurine with gold-colored inclusions [n -S]\n",
  "GOLDSTONES": "GOLDSTONE, a mineral, aventurine with gold-colored inclusions [n]\n",
  "GOLDTAIL": "as in goldtail moth, a European moth with a yellow tail tuft [adj]\n",
  "GOLDTHREAD": "a North American woodland ranunculaceous plant, with slender yellow roots that yield a medicinal tonic and a dye [n -S]\n",
  "GOLDTHREADS": "GOLDTHREAD, a North American woodland ranunculaceous plant, with slender yellow roots that yield a medicinal tonic and a dye [n]\n",
  "GOLDTONE": "a photographic image printed on a glass-plate with a painted golden backing [n -S]\n",
  "GOLDTONES": "GOLDTONE, a photographic image printed on a glass-plate with a painted golden backing [n]\n",
  "GOLDURN": "an expression of anger, also GOLDARN [n -S]\n",
  "GOLDURNS": "GOLDURN, an expression of anger, also GOLDARN [n]\n",
  "GOLDWORK": "gold articles collectively [n -S]\n",
  "GOLDWORKS": "GOLDWORK, gold articles collectively [n]\n",
  "GOLDY": "somewhat like gold [adj GOLDIER, GOLDIEST] / a goldfinch [n GOLDIES]\n",
  "GOLE": "a goal, a target [n -S]\n",
  "GOLEM": "(Yiddish) an artificial human endowed with life by supernatural means [n -S]\n",
  "GOLEMS": "GOLEM, (Yiddish) an artificial human endowed with life by supernatural means [n]\n",
  "GOLES": "GOLE, a goal, a target [n]\n",
  "GOLF": "to play golf (a ball game), also GOFF, GOWF [v -ED, -ING, -S]\n",
  "GOLFED": "GOLF, to play golf (a ball game), also GOFF, GOWF [v]\n",
  "GOLFER": "one that golfs, also GOWFER [n -S]\n",
  "GOLFERS": "GOLFER, one that golfs, also GOWFER [n]\n",
  "GOLFIANA": "golfing items [n -S]\n",
  "GOLFIANAS": "GOLFIANA, golfing items [n]\n",
  "GOLFING": "the game of golf [n -S]\n",
  "GOLFINGS": "GOLFING, the game of golf [n]\n",
  "GOLFS": "GOLF, to play golf (a ball game), also GOFF, GOWF [v]\n",
  "GOLGOTHA": "a place of suffering, a calvary [n -S]\n",
  "GOLGOTHAS": "GOLGOTHA, a place of suffering, a calvary [n]\n",
  "GOLIARD": "(historical) a wandering scholar in the Middle Ages, known for riotous behaviour and satirical Latin poems lampooning the church [n -S]\n",
  "GOLIARDERIES": "GOLIARDERY, the satirical or ribald poetry of the Goliards, also GOLIARDY [n]\n",
  "GOLIARDERY": "the satirical or ribald poetry of the Goliards, also GOLIARDY [n GOLIARDERIES]\n",
  "GOLIARDIC": "of or like a goliard, a wandering scholar in the Middle Ages [adj]\n",
  "GOLIARDIES": "GOLIARDY, boisterous, irreverent behaviour [n]\n",
  "GOLIARDS": "GOLIARD, (historical) a wandering scholar in the Middle Ages, known for riotous behaviour and satirical Latin poems lampooning the church [n]\n",
  "GOLIARDY": "boisterous, irreverent behaviour [n GOLIARDIES]\n",
  "GOLIAS": "to behave irreverently [v -ED, -ING, -ES]\n",
  "GOLIASED": "GOLIAS, to behave irreverently [v]\n",
  "GOLIASES": "GOLIAS, to behave irreverently [v]\n",
  "GOLIASING": "GOLIAS, to behave irreverently [v]\n",
  "GOLIATH": "a person considered to be a giant [n -S]\n",
  "GOLIATHISE": "to play Goliath, exaggerate extravagantly, also GOLIATHIZE [v GOLIATHISED, GOLIATHISING, GOLIATHISES]\n",
  "GOLIATHISED": "GOLIATHISE, to play Goliath, exaggerate extravagantly, also GOLIATHIZE [v]\n",
  "GOLIATHISES": "GOLIATHISE, to play Goliath, exaggerate extravagantly, also GOLIATHIZE [v]\n",
  "GOLIATHISING": "GOLIATHISE, to play Goliath, exaggerate extravagantly, also GOLIATHIZE [v]\n",
  "GOLIATHIZE": "to play Goliath, exaggerate extravagantly, also GOLIATHISE [v GOLIATHIZED, GOLIATHIZING, GOLIATHIZES]\n",
  "GOLIATHIZED": "GOLIATHIZE, to play Goliath, exaggerate extravagantly, also GOLIATHISE [v]\n",
  "GOLIATHIZES": "GOLIATHIZE, to play Goliath, exaggerate extravagantly, also GOLIATHISE [v]\n",
  "GOLIATHIZING": "GOLIATHIZE, to play Goliath, exaggerate extravagantly, also GOLIATHISE [v]\n",
  "GOLIATHS": "GOLIATH, a person considered to be a giant [n]\n",
  "GOLLAN": "(dialect) a name for various yellow flowers including marigold, also GOLLAND, GOWLAN, GOWLAND [n -S]\n",
  "GOLLAND": "(dialect) a name for various yellow flowers including marigold, also GOLLAN, GOWLAN, GOWLAND [n -S]\n",
  "GOLLANDS": "GOLLAND, (dialect) a name for various yellow flowers including marigold, also GOLLAN, GOWLAN, GOWLAND [n]\n",
  "GOLLANS": "GOLLAN, (dialect) a name for various yellow flowers including marigold, also GOLLAND, GOWLAN, GOWLAND [n]\n",
  "GOLLAR": "(Scots) to make a loud gurgling sound, also GOLLER [v -ED, -ING, -S]\n",
  "GOLLARED": "GOLLAR, (Scots) to make a loud gurgling sound, also GOLLER [v]\n",
  "GOLLARING": "GOLLAR, (Scots) to make a loud gurgling sound, also GOLLER [v]\n",
  "GOLLARS": "GOLLAR, (Scots) to make a loud gurgling sound, also GOLLER [v]\n",
  "GOLLER": "(Scots) to make a loud gurgling sound, also GOLLAR [v -ED, -ING, -S]\n",
  "GOLLERED": "GOLLER, (Scots) to make a loud gurgling sound, also GOLLAR [v]\n",
  "GOLLERING": "GOLLER, (Scots) to make a loud gurgling sound, also GOLLAR [v]\n",
  "GOLLERS": "GOLLER, (Scots) to make a loud gurgling sound, also GOLLAR [v]\n",
  "GOLLIED": "GOLLY, to spit [v]\n",
  "GOLLIES": "GOLLY, to spit [v]\n",
  "GOLLIWOG": "a grotesque black male doll; a grotesque person, also GOLLY, GOLLIWOGG, GOLLYWOG [n -S]\n",
  "GOLLIWOGG": "a grotesque black male doll; a grotesque person, also GOLLY, GOLLIWOG, GOLLYWOG [n -S]\n",
  "GOLLIWOGGS": "GOLLIWOGG, a grotesque black male doll; a grotesque person, also GOLLY, GOLLIWOG, GOLLYWOG [n]\n",
  "GOLLIWOGS": "GOLLIWOG, a grotesque black male doll; a grotesque person, also GOLLY, GOLLIWOGG, GOLLYWOG [n]\n",
  "GOLLOP": "to gulp hastily [v -ED, -ING, -S]\n",
  "GOLLOPED": "GOLLOP, to gulp hastily [v]\n",
  "GOLLOPER": "one who gollops [n -S]\n",
  "GOLLOPERS": "GOLLOPER, one who gollops [n]\n",
  "GOLLOPING": "GOLLOP, to gulp hastily [v]\n",
  "GOLLOPS": "GOLLOP, to gulp hastily [v]\n",
  "GOLLY": "a grotesque black doll, also GOLLIWOG, GOLLIWOGG, GOLLYWOG [n GOLLIES] / to spit [v GOLLIED, GOLLYING, GOLLIES]\n",
  "GOLLYING": "GOLLY, to spit [v]\n",
  "GOLLYWOG": "a grotesque black doll, also GOLLIWOG, GOLLIWOGG, GOLLY [n -S]\n",
  "GOLLYWOGS": "GOLLYWOG, a grotesque black doll, also GOLLIWOG, GOLLIWOGG, GOLLY [n]\n",
  "GOLOMYNKA": "(Russian) a very oily fish found in Lake Baikal [n -S]\n",
  "GOLOMYNKAS": "GOLOMYNKA, (Russian) a very oily fish found in Lake Baikal [n]\n",
  "GOLOPTIOUS": "(slang) delicious, voluptuous, also GOLUPTIOUS [adj]\n",
  "GOLOSH": "(French) an overshoe, also GALOSH, GALOCHE, GALOSHE [n -ES] / to put an overshoe over [v -ED, -ING, -ES]\n",
  "GOLOSHE": "(French) an overshoe, also GALAGE, GALOCHE, GALOSH, GALOSHE, GOLOSH [n -S]\n",
  "GOLOSHED": "GOLOSH, to put an overshoe over [v]\n",
  "GOLOSHES": "GOLOSHE, (French) an overshoe, also GALAGE, GALOCHE, GALOSH, GALOSHE, GOLOSH [n]\n",
  "GOLOSHING": "GOLOSH, to put an overshoe over [v]\n",
  "GOLOSHOES": "(obsolete) goloshes [n]\n",
  "GOLP": "in heraldry, a purple roundel, also GOLPE [n -S]\n",
  "GOLPE": "in heraldry, a purple roundel, also GOLP [n -S]\n",
  "GOLPES": "GOLPE, in heraldry, a purple roundel, also GOLP [n]\n",
  "GOLPS": "GOLP, in heraldry, a purple roundel, also GOLPE [n]\n",
  "GOLUPTIOUS": "(slang) delicious, voluptuous, also GOLOPTIOUS [adj]\n",
  "GOMBEEN": "(Irish) usury; chiefly used attributively as gombeen-man, a moneylender, usurer [n -S]\n",
  "GOMBEENISM": "the state of being a gombeen [n -S]\n",
  "GOMBEENISMS": "GOMBEENISM, the state of being a gombeen [n]\n",
  "GOMBEENS": "GOMBEEN, (Irish) usury; chiefly used attributively as gombeen-man, a moneylender, usurer [n]\n",
  "GOMBO": "(Bantu) a soup thickened with okra, also GOMBRO, GUMBO [n -S]\n",
  "GOMBOS": "GOMBO, (Bantu) a soup thickened with okra, also GOMBRO, GUMBO [n]\n",
  "GOMBRO": "(Bantu) a soup thickened with okra, also GOMBO, GUMBO [n -S]\n",
  "GOMBROON": "a type of Persian pottery [n -S]\n",
  "GOMBROONS": "GOMBROON, a type of Persian pottery [n]\n",
  "GOMBROS": "GOMBRO, (Bantu) a soup thickened with okra, also GOMBO, GUMBO [n]\n",
  "GOMER": "an unwanted hospital patient [n -S]\n",
  "GOMERAL": "(Scots) a simpleton, also GOMEREL, GOMERIL [n -S]\n",
  "GOMERALS": "GOMERAL, (Scots) a simpleton, also GOMEREL, GOMERIL [n]\n",
  "GOMEREL": "(Scots) a simpleton, also GOMERAL, GOMERIL [n -S]\n",
  "GOMERELS": "GOMEREL, (Scots) a simpleton, also GOMERAL, GOMERIL [n]\n",
  "GOMERIL": "(Scots) a simpleton, also GOMERAL, GOMEREL [n -S]\n",
  "GOMERILS": "GOMERIL, (Scots) a simpleton, also GOMERAL, GOMEREL [n]\n",
  "GOMERS": "GOMER, an unwanted hospital patient [n]\n",
  "GOMOKU": "(Japanese) a game played on a board of 256 squares, with fifty counters [n -S]\n",
  "GOMOKUS": "GOMOKU, (Japanese) a game played on a board of 256 squares, with fifty counters [n]\n",
  "GOMPA": "(Tibetan) a Buddhist temple or monastery in Tibet [n -S]\n",
  "GOMPAS": "GOMPA, (Tibetan) a Buddhist temple or monastery in Tibet [n]\n",
  "GOMPHOSES": "GOMPHOSIS, the growth of teeth into the bone cavity [n]\n",
  "GOMPHOSIS": "the growth of teeth into the bone cavity [n GOMPHOSES]\n",
  "GOMUTI": "(Malay) a Malayan palm tree, yielding a black fibre, also GOMUTO [n -S]\n",
  "GOMUTIS": "GOMUTI, (Malay) a Malayan palm tree, yielding a black fibre, also GOMUTO [n]\n",
  "GOMUTO": "(Malay) a Malayan palm tree, yielding a black fibre, also GOMUTI [n -S]\n",
  "GOMUTOS": "GOMUTO, (Malay) a Malayan palm tree, yielding a black fibre, also GOMUTI [n]\n",
  "GON": "a geometrical grade [n -S]\n",
  "GONAD": "an organ in an animal (as a testis or an ovary) that produces gametes [n -S]\n",
  "GONADAL": "pertaining to the gonad, also GONADIAL, GONADIC [adj]\n",
  "GONADECTOMIES": "GONADECTOMY, the surgical removal of a gonad [n]\n",
  "GONADECTOMISED": "having undergone a gonadectomy, removal of the gonads, also GONADECTOMIZED [adj]\n",
  "GONADECTOMIZED": "having undergone a gonadectomy, removal of the gonads, also GONADECTOMISED [adj]\n",
  "GONADECTOMY": "the surgical removal of a gonad [n GONADECTOMIES]\n",
  "GONADIAL": "pertaining to the gonad, also GONADAL, GONADIC [adj]\n",
  "GONADIC": "pertaining to the gonad, also GONADAL, GONADIAL [adj]\n",
  "GONADOTROPHIC": "stimulating the gonads, also GONADOTROPIC [adj]\n",
  "GONADOTROPHIN": "a substance that stimulates the gonads [n -S]\n",
  "GONADOTROPHINS": "GONADOTROPHIN, a substance that stimulates the gonads [n]\n",
  "GONADOTROPIC": "stimulating the gonads, also GONADOTROPHIC [adj]\n",
  "GONADOTROPIN": "a gonadotropic hormone, as follicle-stimulating hormone [n -S]\n",
  "GONADOTROPINS": "GONADOTROPIN, a gonadotropic hormone, as follicle-stimulating hormone [n]\n",
  "GONADS": "GONAD, an organ in an animal (as a testis or an ovary) that produces gametes [n]\n",
  "GONCH": "(Canadian) underpants, also GINCH, GITCH, GOTCH [n -ES]\n",
  "GONCHES": "GONCH, (Canadian) underpants, also GINCH, GITCH, GOTCH [n]\n",
  "GONDELAY": "(Spenser) a gondola [n -S]\n",
  "GONDELAYS": "GONDELAY, (Spenser) a gondola [n]\n",
  "GONDOLA": "(Italian) a long, narrow boat with a high prow and stern, used in the canals of Venice, also GONDELAY [n -S]\n",
  "GONDOLAS": "GONDOLA, (Italian) a long, narrow boat with a high prow and stern, used in the canals of Venice, also GONDELAY [n]\n",
  "GONDOLIER": "one who operates a gondola [n -S]\n",
  "GONDOLIERS": "GONDOLIER, one who operates a gondola [n]\n",
  "GONE": "GO, to move along [v]\n",
  "GONEF": "(Yiddish) a thief, also GANEF, GANEV, GANOF, GONIF, GONIFF, GONOF, GONOPH [n -S]\n",
  "GONEFS": "GONEF, (Yiddish) a thief, also GANEF, GANEV, GANOF, GONIF, GONIFF, GONOF, GONOPH [n]\n",
  "GONENESS": "a state of exhaustion [n -ES]\n",
  "GONENESSES": "GONENESS, a state of exhaustion [n]\n",
  "GONER": "one who is in a hopeless situation [n -S]\n",
  "GONERS": "GONER, one who is in a hopeless situation [n]\n",
  "GONFALON": "a small flag or pennant immediately below the head of a knight's lance, also GONFANON [n -S]\n",
  "GONFALONIER": "a person who carries a gonfalon; the chief magistrate in some medieval Italian republics [n -S]\n",
  "GONFALONIERS": "GONFALONIER, a person who carries a gonfalon; the chief magistrate in some medieval Italian republics [n]\n",
  "GONFALONS": "GONFALON, a small flag or pennant immediately below the head of a knight's lance, also GONFANON [n]\n",
  "GONFANON": "(historical) a small flag or pennant immediately below the head of a knight's lance, also GONFALON [n -S]\n",
  "GONFANONS": "GONFANON, (historical) a small flag or pennant immediately below the head of a knight's lance, also GONFALON [n]\n",
  "GONG": "a metal disc, usually rimmed, that sounds when struck or rubbed with a drumstick [n -S] / to summon by sounding a gong [v -ED, -ING, -S]\n",
  "GONGED": "GONG, to summon by sounding a gong [v]\n",
  "GONGING": "GONG, to summon by sounding a gong [v]\n",
  "GONGLIKE": "resembling a gong [adj]\n",
  "GONGORISTIC": "relating to Gongorism, a florid, inverted and pedantic style of writing, introduced by the Spanish poet Luis de Gongora y Argote [adj]\n",
  "GONGS": "GONG, to summon by sounding a gong [v]\n",
  "GONGSTER": "a person who strikes a gong [n -S]\n",
  "GONGSTERS": "GONGSTER, a person who strikes a gong [n]\n",
  "GONGYO": "(Japanese) a Buddhist ceremony [n -S]\n",
  "GONGYOS": "GONGYO, (Japanese) a Buddhist ceremony [n]\n",
  "GONIA": "GONION, a part of the lower jaw [n]\n",
  "GONIATITE": "one of an extinct genus of fossil cephalopods, allied to the Ammonites [n -S]\n",
  "GONIATITES": "GONIATITE, one of an extinct genus of fossil cephalopods, allied to the Ammonites [n]\n",
  "GONIATITOID": "having the form of a goniatite [adj] / a fossil like a goniatite [n -S]\n",
  "GONIATITOIDS": "GONIATITOID, a fossil like a goniatite [n]\n",
  "GONIDIA": "GONIDIUM, an algal cell in a lichen [n]\n",
  "GONIDIAL": "pertaining to gonidia, algal cells in lichen, also GONIDIC [adj]\n",
  "GONIDIC": "pertaining to gonidia, algal cells in lichen, also GONIDIAL [adj]\n",
  "GONIDIUM": "an algal cell in a lichen [n GONIDIA]\n",
  "GONIF": "(Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIFF, GONOF, GONOPH [n -S]\n",
  "GONIFF": "(Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIF, GONOF, GONOPH [n -S]\n",
  "GONIFFS": "GONIFF, (Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIF, GONOF, GONOPH [n]\n",
  "GONIFS": "GONIF, (Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIFF, GONOF, GONOPH [n]\n",
  "GONIMOBLAST": "in the red seaweeds, a spore-bearing filament that springs from the fertilized carpogonium [n -S]\n",
  "GONIMOBLASTS": "GONIMOBLAST, in the red seaweeds, a spore-bearing filament that springs from the fertilized carpogonium [n]\n",
  "GONIOMETER": "an instrument for measuring angles; direction finder [n -S]\n",
  "GONIOMETERS": "GONIOMETER, an instrument for measuring angles; direction finder [n]\n",
  "GONIOMETRIC": "relating to measurement by goniometer [adj GONIOMETRICALLY]\n",
  "GONIOMETRICAL": "relating to the measurement of angles [adj GONIOMETRICALLY]\n",
  "GONIOMETRICALLY": "GONIOMETRICAL, relating to the measurement of angles [adv]\n",
  "GONIOMETRIES": "GONIOMETRY, the art of measuring angles; trigonometry [n]\n",
  "GONIOMETRY": "the art of measuring angles; trigonometry [n GONIOMETRIES]\n",
  "GONION": "a part of the lower jaw [n GONIA]\n",
  "GONIOSCOPE": "an instrument used for examining the structures of the eye between the cornea and the lens that are not directly visible [n -S]\n",
  "GONIOSCOPES": "GONIOSCOPE, an instrument used for examining the structures of the eye between the cornea and the lens that are not directly visible [n]\n",
  "GONIUM": "an immature reproductive cell [n GONIA]\n",
  "GONK": "(tradename) the proprietary name of an egg-shaped doll [n -S]\n",
  "GONKS": "GONK, (tradename) the proprietary name of an egg-shaped doll [n]\n",
  "GONNA": "(colloquial) going to [v]\n",
  "GONOCOCCAL": "relating to gonococci [adj]\n",
  "GONOCOCCI": "GONOCOCCUS, the bacterium that causes gonorrhoea [n]\n",
  "GONOCOCCIC": "relating to gonococci [adj]\n",
  "GONOCOCCOID": "having the shape of a gonococcus [adj]\n",
  "GONOCOCCUS": "the bacterium that causes gonorrhoea [n GONOCOCCI]\n",
  "GONOCYTE": "a cell that produces gametes [n -S]\n",
  "GONOCYTES": "GONOCYTE, a cell that produces gametes [n]\n",
  "GONODUCT": "a duct leading from a gonad to the exterior, through which gametes pass [n -S]\n",
  "GONODUCTS": "GONODUCT, a duct leading from a gonad to the exterior, through which gametes pass [n]\n",
  "GONOF": "(Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIF, GONIFF, GONOPH [n -S]\n",
  "GONOFS": "GONOF, (Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIF, GONIFF, GONOPH [n]\n",
  "GONOPH": "(Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIF, GONIFF, GONOF [n -S]\n",
  "GONOPHORE": "in certain flowers, an elongate structure bearing the stamens and pistil [n -S]\n",
  "GONOPHORES": "GONOPHORE, in certain flowers, an elongate structure bearing the stamens and pistil [n]\n",
  "GONOPHORIC": "relating to a gonophore, in certain flowers, an elongate structure bearing the stamens and pistil, also GONOPHOROUS [adj]\n",
  "GONOPHOROUS": "relating to a gonophore, in certain flowers, an elongate structure bearing the stamens and pistil, also GONOPHORIC [adj]\n",
  "GONOPHS": "GONOPH, (Yiddish) a thief, also GANEF, GANEV, GANOF, GONEF, GONIF, GONIFF, GONOF [n]\n",
  "GONOPOD": "either of a pair of appendages that are the external reproductive organs of insects [n -S]\n",
  "GONOPODS": "GONOPOD, either of a pair of appendages that are the external reproductive organs of insects [n]\n",
  "GONOPORE": "a genital pore [n -S]\n",
  "GONOPORES": "GONOPORE, a genital pore [n]\n",
  "GONORRHEA": "a sexually transmitted contagious infection of the mucous membrane of the genital tract, also GONORRHOEA [n -S]\n",
  "GONORRHEAL": "relating to gonorrhoea, also GONORRHEIC, GONORRHOEAL, GONORRHOEIC [adj]\n",
  "GONORRHEAS": "GONORRHEA, a sexually transmitted contagious infection of the mucous membrane of the genital tract, also GONORRHOEA [n]\n",
  "GONORRHEIC": "relating to gonorrhoea, also GONORRHEAL, GONORRHOEAL, GONORRHOEIC [adj]\n",
  "GONORRHOEA": "a sexually transmitted contagious infection of the mucous membrane of the genital tract, also GONORRHEA [n -S]\n",
  "GONORRHOEAL": "relating to gonorrhoea, also GONORRHEAL, GONORRHEIC, GONORRHOEIC [adj]\n",
  "GONORRHOEAS": "GONORRHOEA, a sexually transmitted contagious infection of the mucous membrane of the genital tract, also GONORRHEA [n]\n",
  "GONORRHOEIC": "relating to gonorrhoea, also GONORRHEAL, GONORRHEIC, GONORRHOEAL [adj]\n",
  "GONOSOME": "the group of individuals in a colony who reproduce [n -S]\n",
  "GONOSOMES": "GONOSOME, the group of individuals in a colony who reproduce [n]\n",
  "GONS": "GON, a geometrical grade [n]\n",
  "GONYS": "the ridge along and towards the tip of the lower mandible, formed by the junction of its two halves or rami (as in gulls) [n -ES]\n",
  "GONYSES": "GONYS, the ridge along and towards the tip of the lower mandible, formed by the junction of its two halves or rami (as in gulls) [n]\n",
  "GONZO": "(US slang) a wild, crazy person [n -S]\n",
  "GONZOS": "GONZO, (US slang) a wild, crazy person [n]\n",
  "GOO": "a sticky or viscous substance, also GOOK [n -S]\n",
  "GOOBER": "(US) a peanut [n -S]\n",
  "GOOBERS": "GOOBER, (US) a peanut [n]\n",
  "GOOBIES": "GOOBY, (New Zealand) spittle [n]\n",
  "GOOBY": "(New Zealand) spittle [n GOOBIES]\n",
  "GOOD": "something that is good [n -S] / having positive or desirable properties, also GUDE, GUID [adj BETTER, BEST]\n",
  "GOODBY": "a remark or gesture on parting, also GOODBYE [n -S]\n",
  "GOODBYE": "a remark or gesture on parting, also GOODBY [n -S]\n",
  "GOODBYES": "GOODBYE, a remark or gesture on parting, also GOODBY [n]\n",
  "GOODBYS": "GOODBY, a remark or gesture on parting, also GOODBYE [n]\n",
  "GOODFACED": "(Shakespeare) having a handsome face [adj]\n",
  "GOODFELLA": "a gangster, esp. a member of the Mafia [n -S]\n",
  "GOODFELLAS": "GOODFELLA, a gangster, esp. a member of the Mafia [n]\n",
  "GOODFELLOW": "a jolly or boon companion [n -S]\n",
  "GOODFELLOWS": "GOODFELLOW, a jolly or boon companion [n]\n",
  "GOODFELLOWSHIP": "the office of goodfellow [n -S]\n",
  "GOODFELLOWSHIPS": "GOODFELLOWSHIP, the office of goodfellow [n]\n",
  "GOODIE": "a free gift [n -S]\n",
  "GOODIER": "GOODY, affectedly virtuous [adj]\n",
  "GOODIES": "GOODY, an archaic title for a goodwife [n]\n",
  "GOODIEST": "GOODY, affectedly virtuous [adj]\n",
  "GOODINESS": "weak, priggish or canting goodness [n -ES]\n",
  "GOODINESSES": "GOODINESS, weak, priggish or canting goodness [n]\n",
  "GOODISH": "somewhat good [adj]\n",
  "GOODLIER": "GOODLY, of pleasing appearance [adj]\n",
  "GOODLIEST": "GOODLY, of pleasing appearance [adj]\n",
  "GOODLIHEAD": "(Spenser) goodness, also GOODLYHEAD [n -S]\n",
  "GOODLIHEADS": "GOODLIHEAD, (Spenser) goodness, also GOODLYHEAD [n]\n",
  "GOODLINESS": "beauty of form; comeliness [n -ES]\n",
  "GOODLINESSES": "GOODLINESS, beauty of form; comeliness [n]\n",
  "GOODLY": "of pleasing appearance [adj GOODLIER, GOODLIEST]\n",
  "GOODLYHEAD": "(Spenser) goodness, also GOODLIHEAD [n -S]\n",
  "GOODLYHEADS": "GOODLYHEAD, (Spenser) goodness, also GOODLIHEAD [n]\n",
  "GOODMAN": "the master of a household, also GUDEMAN [n GOODMEN]\n",
  "GOODMEN": "GOODMAN, the master of a household, also GUDEMAN [n]\n",
  "GOODNESS": "the state of being good [n -ES]\n",
  "GOODNESSES": "GOODNESS, the state of being good [n]\n",
  "GOODNIGHT": "a common salutation on parting at night [n -S]\n",
  "GOODNIGHTS": "GOODNIGHT, a common salutation on parting at night [n]\n",
  "GOODS": "GOOD, something that is good [n]\n",
  "GOODSIRE": "(Scots) a grandfather, also GUDESIRE, GUTCHER [n -S]\n",
  "GOODSIRES": "GOODSIRE, (Scots) a grandfather, also GUDESIRE, GUTCHER [n]\n",
  "GOODTIME": "pleasure seeking [adj]\n",
  "GOODWIFE": "the mistress of a household, also GUDEWIFE [n GOODWIVES]\n",
  "GOODWILL": "an attitude of friendliness [n -S]\n",
  "GOODWILLED": "possessed of goodwill [adj]\n",
  "GOODWILLS": "GOODWILL, an attitude of friendliness [n]\n",
  "GOODWIVES": "GOODWIFE, the mistress of a household, also GUDEWIFE [n]\n",
  "GOODY": "an archaic title for a goodwife [n GOODIES] / affectedly virtuous [adj GOODIER, GOODIEST]\n",
  "GOODYEAR": "(Shakespeare) the devil, the plague, or the like (a meaningless imprecation), also GOODYEARS [interj]\n",
  "GOODYEARS": "(Shakespeare) the devil, the plague, or the like (a meaningless imprecation), also GOODYEAR [interj]\n",
  "GOOEY": "sticky or viscid [adj GOOIER, GOOIEST, GOOILY]\n",
  "GOOEYNESS": "stickiness [n -ES]\n",
  "GOOEYNESSES": "GOOEYNESS, stickiness [n]\n",
  "GOOF": "to blunder [v -ED, -ING, -S]\n",
  "GOOFBALL": "(US) a barbiturate pill used as an exhilarant; a goofy person [n -S]\n",
  "GOOFBALLS": "GOOFBALL, (US) a barbiturate pill used as an exhilarant; a goofy person [n]\n",
  "GOOFED": "GOOF, to blunder [v]\n",
  "GOOFIER": "GOOFY, foolish, stupid; (of teeth) protruding [adj]\n",
  "GOOFIEST": "GOOFY, foolish, stupid; (of teeth) protruding [adj]\n",
  "GOOFILY": "GOOFY, foolish, stupid; (of teeth) protruding [adv]\n",
  "GOOFINESS": "the state of being goofy [n -ES]\n",
  "GOOFINESSES": "GOOFINESS, the state of being goofy [n]\n",
  "GOOFING": "GOOF, to blunder [v]\n",
  "GOOFS": "GOOF, to blunder [v]\n",
  "GOOFUS": "a foolish or stupid person [n -ES]\n",
  "GOOFUSES": "GOOFUS, a foolish or stupid person [n]\n",
  "GOOFY": "foolish, stupid; (of teeth) protruding [adj GOOFIER, GOOFIEST, GOOFILY]\n",
  "GOOG": "(Australian slang) an egg; full as a goog means drunk [n -S]\n",
  "GOOGLE": "to look for information using the web search engine Google [v GOOGLED, GOOGLING, GOOGLES]\n",
  "GOOGLED": "GOOGLE, to look for information using the web search engine Google [v]\n",
  "GOOGLES": "GOOGLE, to look for information using the web search engine Google [v]\n",
  "GOOGLEWHACK": "an Internet search that produces one hit only [n -S]\n",
  "GOOGLEWHACKS": "GOOGLEWHACK, an Internet search that produces one hit only [n]\n",
  "GOOGLIES": "GOOGLY, a type of bowled ball in cricket [n]\n",
  "GOOGLING": "GOOGLE, to look for information using the web search engine Google [v]\n",
  "GOOGLY": "a type of bowled ball in cricket [n GOOGLIES]\n",
  "GOOGOL": "the figure 1 followed by 100 zeroes (10 raised to the hundredth power) [n -S]\n",
  "GOOGOLPLEX": "the figure 1 followed by a googol of zeroes (10 raised to the googol power) [n -ES]\n",
  "GOOGOLPLEXES": "GOOGOLPLEX, the figure 1 followed by a googol of zeroes (10 raised to the googol power) [n]\n",
  "GOOGOLS": "GOOGOL, the figure 1 followed by 100 zeroes (10 raised to the hundredth power) [n]\n",
  "GOOGS": "GOOG, (Australian slang) an egg; full as a goog means drunk [n]\n",
  "GOOIER": "GOOEY, sticky or viscid [adj]\n",
  "GOOIEST": "GOOEY, sticky or viscid [adj]\n",
  "GOOILY": "GOOEY, sticky or viscid [adv]\n",
  "GOOINESS": "the state of being gooey [n -ES]\n",
  "GOOINESSES": "GOOINESS, the state of being gooey [n]\n",
  "GOOK": "(offensive) a native of an occupied country [n -S]\n",
  "GOOKIER": "GOOKY, sticky, messy [adj]\n",
  "GOOKIEST": "GOOKY, sticky, messy [adj]\n",
  "GOOKS": "GOOK, (offensive) a native of an occupied country [n]\n",
  "GOOKY": "sticky, messy [adj GOOKIER, GOOKIEST]\n",
  "GOOL": "(Scots) a marigold, also GULE [n -S]\n",
  "GOOLD": "(Spenser) a flower, also GOOL [n -S]\n",
  "GOOLDS": "GOOLD, (Spenser) a flower, also GOOL [n]\n",
  "GOOLEY": "(Australian) a small stone; (plural) testicles, also GOOLIE, GOOLY [n -S]\n",
  "GOOLEYS": "GOOLEY, (Australian) a small stone; (plural) testicles, also GOOLIE, GOOLY [n]\n",
  "GOOLIE": "(Australian) a small stone; (plural) testicles, also GOOLEY, GOOLY [n -S]\n",
  "GOOLIES": "GOOLIE, (Australian) a small stone; (plural) testicles, also GOOLEY, GOOLY [n]\n",
  "GOOLS": "GOOL, (Scots) a marigold, also GULE [n]\n",
  "GOOLY": "(Australian) a small stone; (plural) testicles, also GOOLEY, GOOLIE [n GOOLIES]\n",
  "GOOMBAH": "an older man who is a friend [n -S]\n",
  "GOOMBAHS": "GOOMBAH, an older man who is a friend [n]\n",
  "GOOMBAY": "calypso music of the Bahamas [n -S]\n",
  "GOOMBAYS": "GOOMBAY, calypso music of the Bahamas [n]\n",
  "GOON": "a hired thug [n -S]\n",
  "GOONDA": "(Hindi) a hired thug, esp. one in the hire of a political party [n -S]\n",
  "GOONDAS": "GOONDA, (Hindi) a hired thug, esp. one in the hire of a political party [n]\n",
  "GOONERIES": "GOONERY, thuggish behaviour [n]\n",
  "GOONERY": "thuggish behaviour [n GOONERIES]\n",
  "GOONEY": "an albatross, also GOONIE, GOONY [n -S]\n",
  "GOONEYBIRD": "an albatross [n -S]\n",
  "GOONEYBIRDS": "GOONEYBIRD, an albatross [n]\n",
  "GOONEYS": "GOONEY, an albatross, also GOONIE, GOONY [n]\n",
  "GOONIE": "an albatross, also GOONEY, GOONY [n -S]\n",
  "GOONIER": "GOONY, stupid [adj]\n",
  "GOONIES": "GOONY, an albatross, also GOONEY, GOONIE [n]\n",
  "GOONIEST": "GOONY, stupid [adj]\n",
  "GOONS": "GOON, a hired thug [n]\n",
  "GOONY": "an albatross, also GOONEY, GOONIE [n GOONIES] / stupid [adj GOONIER, GOONIEST]\n",
  "GOOP": "sticky stuff, goo or gunk [n -S]\n",
  "GOOPED": "as in gooped up, sticky with goop [adj]\n",
  "GOOPIER": "GOOPY, sticky or gooey [adj]\n",
  "GOOPIEST": "GOOPY, sticky or gooey [adj]\n",
  "GOOPINESS": "the state of being goopy [n -ES]\n",
  "GOOPINESSES": "GOOPINESS, the state of being goopy [n]\n",
  "GOOPS": "GOOP, sticky stuff, goo or gunk [n]\n",
  "GOOPY": "sticky or gooey [adj GOOPIER, GOOPIEST]\n",
  "GOOR": "(Hindi) an unrefined cane sugar, also GUR [n -S]\n",
  "GOORAL": "an Indian goat antelope resembling the chamois, also GORAL [n -S]\n",
  "GOORALS": "GOORAL, an Indian goat antelope resembling the chamois, also GORAL [n]\n",
  "GOORIE": "(New Zealand) a mongrel, an extinct native dog, also GOORY, KURI [n -S]\n",
  "GOORIES": "GOORY, (New Zealand) a mongrel, an extinct native dog, also GOORIE, KURI [n]\n",
  "GOOROO": "(Hindi) a Hindu spiritual teacher, also GURU [n -S]\n",
  "GOOROOS": "GOOROO, (Hindi) a Hindu spiritual teacher, also GURU [n]\n",
  "GOORS": "GOOR, (Hindi) an unrefined cane sugar, also GUR [n]\n",
  "GOORY": "(New Zealand) a mongrel, an extinct native dog, also GOORIE, KURI [n GOORIES]\n",
  "GOOS": "GOO, a sticky or viscous substance, also GOOK [n]\n",
  "GOOSANDER": "a large duck of the merganser genus [n -S]\n",
  "GOOSANDERS": "GOOSANDER, a large duck of the merganser genus [n]\n",
  "GOOSE": "to poke between the buttocks [v GOOSED, GOOSING, GOOSES] / a swimming bird [n GEESE]\n",
  "GOOSEBERRIES": "GOOSEBERRY, the small oval fruit (usually green) of the gooseberry-bush, a prickly shrub of the saxifrage family [n]\n",
  "GOOSEBERRY": "the small oval fruit (usually green) of the gooseberry-bush, a prickly shrub of the saxifrage family [n GOOSEBERRIES]\n",
  "GOOSED": "GOOSE, to poke between the buttocks [v]\n",
  "GOOSEFISH": "an American fish, the anglerfish [n -ES]\n",
  "GOOSEFISHES": "GOOSEFISH, an American fish, the anglerfish [n]\n",
  "GOOSEFLESH": "a knobbly, pimply condition of the skin, like that of a plucked goose or other fowl due to erection of hairs through cold, horror, etc. [n -ES]\n",
  "GOOSEFLESHES": "GOOSEFLESH, a knobbly, pimply condition of the skin, like that of a plucked goose or other fowl due to erection of hairs through cold, horror, etc. [n]\n",
  "GOOSEFOOT": "a genus of herbs, mostly annual weeds [n -S]\n",
  "GOOSEFOOTS": "GOOSEFOOT, a genus of herbs, mostly annual weeds [n]\n",
  "GOOSEGOB": "gooseberry, also GOOSEGOG [n -S]\n",
  "GOOSEGOBS": "GOOSEGOB, gooseberry, also GOOSEGOG [n]\n",
  "GOOSEGOG": "gooseberry, also GOOSEGOB [n -S]\n",
  "GOOSEGOGS": "GOOSEGOG, gooseberry, also GOOSEGOB [n]\n",
  "GOOSEGRASS": "a Eurasian plant with a bristly stem and fruits that cling to clothes etc., aka cleavers [n -ES]\n",
  "GOOSEGRASSES": "GOOSEGRASS, a Eurasian plant with a bristly stem and fruits that cling to clothes etc., aka cleavers [n]\n",
  "GOOSEHERD": "one who looks after geese [n -S]\n",
  "GOOSEHERDS": "GOOSEHERD, one who looks after geese [n]\n",
  "GOOSELIKE": "like a goose [adj]\n",
  "GOOSENECK": "a hook, bracket or pipe etc. bent like a goose's neck [n -S]\n",
  "GOOSENECKED": "having a neck like a goose [adj]\n",
  "GOOSENECKS": "GOOSENECK, a hook, bracket or pipe etc. bent like a goose's neck [n]\n",
  "GOOSERIES": "GOOSERY, a place for geese [n]\n",
  "GOOSERY": "a place for geese [n GOOSERIES]\n",
  "GOOSES": "GOOSE, to poke between the buttocks [v]\n",
  "GOOSEY": "a goose, a blockhead [n -S]\n",
  "GOOSEYS": "GOOSEY, a goose, a blockhead [n]\n",
  "GOOSIER": "GOOSY, resembling a goose [adj]\n",
  "GOOSIES": "GOOSY, a goose, a blockhead, also GOOSEY [n]\n",
  "GOOSIEST": "GOOSY, resembling a goose [adj]\n",
  "GOOSINESS": "the state of being goosy, simpleminded [n -ES]\n",
  "GOOSINESSES": "GOOSINESS, the state of being goosy, simpleminded [n]\n",
  "GOOSING": "GOOSE, to poke between the buttocks [v]\n",
  "GOOSY": "a goose, a blockhead, also GOOSEY [n GOOSIES] / resembling a goose [adj GOOSIER, GOOSIEST]\n",
  "GOPAK": "(Russian) a high-leaping folk-dance from the Ukraine, also HOPAK [n -S]\n",
  "GOPAKS": "GOPAK, (Russian) a high-leaping folk-dance from the Ukraine, also HOPAK [n]\n",
  "GOPHER": "a name applied to various burrowing animals [n -S] / to burrow, mine [v -ED, -ING, -S]\n",
  "GOPHERED": "GOPHER, to burrow, mine [v]\n",
  "GOPHERING": "GOPHER, to burrow, mine [v]\n",
  "GOPHERS": "GOPHER, to burrow, mine [v]\n",
  "GOPHERWOOD": "another name for yellowwood [n -S]\n",
  "GOPHERWOODS": "GOPHERWOOD, another name for yellowwood [n]\n",
  "GOPIK": "a monetary unit of Azerbaijan, one hundredth of a manat, also QAPIK [n -S]\n",
  "GOPIKS": "GOPIK, a monetary unit of Azerbaijan, one hundredth of a manat, also QAPIK [n]\n",
  "GOPURA": "(Sanskrit) in South India, a pyramidal tower over the gateway of a temple, also GOPURAM [n -S]\n",
  "GOPURAM": "(Sanskrit) in South India, a pyramidal tower over the gateway of a temple, also GOPURA [n -S]\n",
  "GOPURAMS": "GOPURAM, (Sanskrit) in South India, a pyramidal tower over the gateway of a temple, also GOPURA [n]\n",
  "GOPURAS": "GOPURA, (Sanskrit) in South India, a pyramidal tower over the gateway of a temple, also GOPURAM [n]\n",
  "GOR": "a seagull [n -S]\n",
  "GORA": "(Hinglish) a white or fair-skinned male [n -S]\n",
  "GORAL": "an Indian goat antelope resembling the chamois, also GOORAL [n -S]\n",
  "GORALS": "GORAL, an Indian goat antelope resembling the chamois, also GOORAL [n]\n",
  "GORAMIES": "GORAMY, (Malay) a large freshwater food fish of Asia, also GOURAMI, GURAMI [n]\n",
  "GORAMY": "(Malay) a large freshwater food fish of Asia, also GOURAMI, GURAMI [n GORAMIES]\n",
  "GORAS": "GORA, (Hinglish) a white or fair-skinned male [n]\n",
  "GORBELLIES": "GORBELLY, (obsolete) a big belly; a big-bellied person [n]\n",
  "GORBELLY": "(obsolete) a big belly; a big-bellied person [n GORBELLIES]\n",
  "GORBLIMEY": "a kind of flat army cap, also GORBLIMY [n -S]\n",
  "GORBLIMEYS": "GORBLIMEY, a kind of flat army cap, also GORBLIMY [n]\n",
  "GORBLIMIES": "GORBLIMY, a kind of flat army cap, also GORBLIMEY [n]\n",
  "GORBLIMY": "a kind of flat army cap, also GORBLIMEY [n GORBLIMIES]\n",
  "GORCOCK": "(Scots) the male red grouse [n -S]\n",
  "GORCOCKS": "GORCOCK, (Scots) the male red grouse [n]\n",
  "GORCROW": "(dialect) the carrion crow [n -S]\n",
  "GORCROWS": "GORCROW, (dialect) the carrion crow [n]\n",
  "GORDITA": "(Spanish) a small thick tortilla [n -S]\n",
  "GORDITAS": "GORDITA, (Spanish) a small thick tortilla [n]\n",
  "GORE": "to pierce with a horn or tusk [v GORED, GORING, GORES]\n",
  "GORED": "GORE, to pierce with a horn or tusk [v]\n",
  "GOREFEST": "a movie featuring much bloodshed [n -S]\n",
  "GOREFESTS": "GOREFEST, a movie featuring much bloodshed [n]\n",
  "GOREHOUND": "an enthusiast of gory horror films [n -S]\n",
  "GOREHOUNDS": "GOREHOUND, an enthusiast of gory horror films [n]\n",
  "GORES": "GORE, to pierce with a horn or tusk [v]\n",
  "GORGE": "to stuff with food [v GORGED, GORGING, GORGES]\n",
  "GORGEABLE": "that can be gorged [adj]\n",
  "GORGED": "GORGE, to stuff with food [v]\n",
  "GORGEDLY": "GORGED, GORGE, to stuff with food [adv]\n",
  "GORGEOUS": "beautiful [adj GORGEOUSLY]\n",
  "GORGEOUSLY": "GORGEOUS, beautiful [adv]\n",
  "GORGEOUSNESS": "the state of being gorgeous [n -ES]\n",
  "GORGEOUSNESSES": "GORGEOUSNESS, the state of being gorgeous [n]\n",
  "GORGER": "one who gorges [n -S]\n",
  "GORGERIN": "(French) a part of a column [n -S]\n",
  "GORGERINS": "GORGERIN, (French) a part of a column [n]\n",
  "GORGERS": "GORGER, one who gorges [n]\n",
  "GORGES": "GORGE, to stuff with food [v]\n",
  "GORGET": "a piece of armour for the throat [n -S]\n",
  "GORGETED": "wearing a gorget, a piece of armour for the throat [adj]\n",
  "GORGETS": "GORGET, a piece of armour for the throat [n]\n",
  "GORGIA": "(Italian) an improvised virtuoso passage in sixteenth century singing [n -S]\n",
  "GORGIAS": "GORGIA, (Italian) an improvised virtuoso passage in sixteenth century singing [n]\n",
  "GORGING": "GORGE, to stuff with food [v]\n",
  "GORGIO": "(Romany) a non-gypsy, also GADGIE, GADJE, GADJO, GAJO, GAUDGIE, GAUJE [n -S]\n",
  "GORGIOS": "GORGIO, (Romany) a non-gypsy, also GADGIE, GADJE, GADJO, GAJO, GAUDGIE, GAUJE [n]\n",
  "GORGON": "(Greek) a very ugly or formidable woman [n -S]\n",
  "GORGONEIA": "GORGONEION, (Greek) a mask carved in imitation of a Gorgon's head [n]\n",
  "GORGONEION": "(Greek) a mask carved in imitation of a Gorgon's head [n GORGONEIA]\n",
  "GORGONIAN": "any of various horny corals of the order Gorgonacea, with upright, plantlike forms [n -S]\n",
  "GORGONIANS": "GORGONIAN, any of various horny corals of the order Gorgonacea, with upright, plantlike forms [n]\n",
  "GORGONISE": "to have a paralyzing or mesmerizing effect on, to petrify, also GORGONIZE [v GORGONISED, GORGONISING, GORGONISES]\n",
  "GORGONISED": "GORGONISE, to have a paralyzing or mesmerizing effect on, to petrify, also GORGONIZE [v]\n",
  "GORGONISES": "GORGONISE, to have a paralyzing or mesmerizing effect on, to petrify, also GORGONIZE [v]\n",
  "GORGONISING": "GORGONISE, to have a paralyzing or mesmerizing effect on, to petrify, also GORGONIZE [v]\n",
  "GORGONIZE": "to have a paralyzing or mesmerizing effect on, to petrify, also GORGONISE [v GORGONIZED, GORGONIZING, GORGONIZES]\n",
  "GORGONIZED": "GORGONIZE, to have a paralyzing or mesmerizing effect on, to petrify, also GORGONISE [v]\n",
  "GORGONIZES": "GORGONIZE, to have a paralyzing or mesmerizing effect on, to petrify, also GORGONISE [v]\n",
  "GORGONIZING": "GORGONIZE, to have a paralyzing or mesmerizing effect on, to petrify, also GORGONISE [v]\n",
  "GORGONS": "GORGON, (Greek) a very ugly or formidable woman [n]\n",
  "GORHEN": "(Scots) the female red grouse [n -S]\n",
  "GORHENS": "GORHEN, (Scots) the female red grouse [n]\n",
  "GORI": "(Hinglish) a white or fair-skinned female [n -S]\n",
  "GORIER": "GORY, bloody, also GOARY [adj]\n",
  "GORIEST": "GORY, bloody, also GOARY [adj]\n",
  "GORILLA": "a large ape [n -S]\n",
  "GORILLAGRAM": "a greetings telegram delivered by a person dressed in a gorilla suit [n -S]\n",
  "GORILLAGRAMS": "GORILLAGRAM, a greetings telegram delivered by a person dressed in a gorilla suit [n]\n",
  "GORILLAS": "GORILLA, a large ape [n]\n",
  "GORILLIAN": "of or like a gorilla, also GORILLINE, GORILLOID [adj]\n",
  "GORILLINE": "of or like a gorilla, also GORILLIAN, GORILLOID [adj]\n",
  "GORILLOID": "of or like a gorilla, also GORILLIAN, GORILLINE [adj]\n",
  "GORILY": "GORY, bloody, also GOARY [adv]\n",
  "GORINESS": "the state of being gory [n -ES]\n",
  "GORINESSES": "GORINESS, the state of being gory [n]\n",
  "GORING": "a tapering insert of cloth [n -S]\n",
  "GORINGS": "GORING, a tapering insert of cloth [n]\n",
  "GORIS": "GORI, (Hinglish) a white or fair-skinned female [n]\n",
  "GORM": "(Old Norse) to stare vacantly or handle in a clumsy manner, also GAUM [v -ED, -ING, -S]\n",
  "GORMAND": "one who loves to eat, also GOURMAND [n -S]\n",
  "GORMANDISE": "to indulge a taste for good food to excess, also GORMANDIZE, GOURMANDISE, GOURMANDIZE [v GORMANDISED, GORMANDISING, GORMANDISES]\n",
  "GORMANDISED": "GORMANDISE, to indulge a taste for good food to excess, also GORMANDIZE, GOURMANDISE, GOURMANDIZE [v]\n",
  "GORMANDISER": "one who eats to excess, also GORMANDIZER [n -S]\n",
  "GORMANDISERS": "GORMANDISER, one who eats to excess, also GORMANDIZER [n]\n",
  "GORMANDISES": "GORMANDISE, to indulge a taste for good food to excess, also GORMANDIZE, GOURMANDISE, GOURMANDIZE [v]\n",
  "GORMANDISING": "indulging in food to excess [n -S]\n",
  "GORMANDISINGS": "GORMANDISING, indulging in food to excess [n]\n",
  "GORMANDISM": "gluttony [n -S]\n",
  "GORMANDISMS": "GORMANDISM, gluttony [n]\n",
  "GORMANDIZE": "to indulge a taste for good food to excess, also GORMANDISE, GOURMANDISE, GOURMANDIZE [v GORMANDIZED, GORMANDIZING, GORMANDIZES]\n",
  "GORMANDIZED": "GORMANDIZE, to indulge a taste for good food to excess, also GORMANDISE, GOURMANDISE, GOURMANDIZE [v]\n",
  "GORMANDIZER": "one who eats to excess, also GORMANDISER [n -S]\n",
  "GORMANDIZERS": "GORMANDIZER, one who eats to excess, also GORMANDISER [n]\n",
  "GORMANDIZES": "GORMANDIZE, to indulge a taste for good food to excess, also GORMANDISE, GOURMANDISE, GOURMANDIZE [v]\n",
  "GORMANDIZING": "indulging in food to excess, also GORMANDISING [n -S]\n",
  "GORMANDIZINGS": "GORMANDIZING, indulging in food to excess, also GORMANDISING [n]\n",
  "GORMANDS": "GORMAND, one who loves to eat, also GOURMAND [n]\n",
  "GORMED": "GORM, (Old Norse) to stare vacantly or handle in a clumsy manner, also GAUM [v]\n",
  "GORMIER": "GORMY, dauby, smeary, also GAUMY [adj]\n",
  "GORMIEST": "GORMY, dauby, smeary, also GAUMY [adj]\n",
  "GORMING": "GORM, (Old Norse) to stare vacantly or handle in a clumsy manner, also GAUM [v]\n",
  "GORMLESS": "stupid, witless, vacant, also GAUMLESS [adj]\n",
  "GORMS": "GORM, (Old Norse) to stare vacantly or handle in a clumsy manner, also GAUM [v]\n",
  "GORMY": "dauby, smeary, also GAUMY [adj GORMIER, GORMIEST]\n",
  "GORP": "to stare stupidly, also GAWP, GAUP [v -ED, -ING, -S]\n",
  "GORPED": "GORP, to stare stupidly, also GAWP, GAUP [v]\n",
  "GORPING": "GORP, to stare stupidly, also GAWP, GAUP [v]\n",
  "GORPS": "GORP, to stare stupidly, also GAWP, GAUP [v]\n",
  "GORS": "GOR, a seagull [n]\n",
  "GORSE": "any prickly papilionaceous shrub of the genus Ulex, with yellow flowers, also GOSSE [n -S]\n",
  "GORSEDD": "(Welsh) an assembly for granting awards to Welsh bards [n -S]\n",
  "GORSEDDS": "GORSEDD, (Welsh) an assembly for granting awards to Welsh bards [n]\n",
  "GORSES": "GORSE, any prickly papilionaceous shrub of the genus Ulex, with yellow flowers, also GOSSE [n]\n",
  "GORSIER": "GORSY, covered with gorse [adj]\n",
  "GORSIEST": "GORSY, covered with gorse [adj]\n",
  "GORSOON": "a boy or boy-servant, also GOSSOON [n -S]\n",
  "GORSOONS": "GORSOON, a boy or boy-servant, also GOSSOON [n]\n",
  "GORSY": "covered with gorse [adj GORSIER, GORSIEST]\n",
  "GORY": "bloody, also GOARY [adj GORIER, GORIEST, GORILY]\n",
  "GOS": "GO, a Japanese board game [n]\n",
  "GOSH": "used as an exclamation of surprise [interj]\n",
  "GOSHAWK": "a large hawk [n -S]\n",
  "GOSHAWKS": "GOSHAWK, a large hawk [n]\n",
  "GOSHT": "(Hindi) in Indian cookery, meat [n -S]\n",
  "GOSHTS": "GOSHT, (Hindi) in Indian cookery, meat [n]\n",
  "GOSLARITE": "a rare mineral, hydrated zinc sulphate [n -S]\n",
  "GOSLARITES": "GOSLARITE, a rare mineral, hydrated zinc sulphate [n]\n",
  "GOSLET": "a species of dwarf goose [n -S]\n",
  "GOSLETS": "GOSLET, a species of dwarf goose [n]\n",
  "GOSLING": "a young goose [n -S]\n",
  "GOSLINGS": "GOSLING, a young goose [n]\n",
  "GOSPEL": "to teach about the life of Christ [v GOSPELLED, GOSPELLING, GOSPELS]\n",
  "GOSPELER": "one that teaches the gospel, also GOSPELLER [n -S]\n",
  "GOSPELERS": "GOSPELER, one that teaches the gospel, also GOSPELLER [n]\n",
  "GOSPELISE": "to evangelize; to square with gospel, also GOSPELIZE, GOSPELLISE, GOSPELLIZE [v GOSPELISED, GOSPELISING, GOSPELISES]\n",
  "GOSPELISED": "GOSPELISE, to evangelize; to square with gospel, also GOSPELIZE, GOSPELLISE, GOSPELLIZE [v]\n",
  "GOSPELISES": "GOSPELISE, to evangelize; to square with gospel, also GOSPELIZE, GOSPELLISE, GOSPELLIZE [v]\n",
  "GOSPELISING": "GOSPELISE, to evangelize; to square with gospel, also GOSPELIZE, GOSPELLISE, GOSPELLIZE [v]\n",
  "GOSPELIZE": "to evangelize; to square with gospel, also GOSPELISE, GOSPELLISE, GOSPELLIZE [v GOSPELIZED, GOSPELIZING, GOSPELIZES]\n",
  "GOSPELIZED": "GOSPELIZE, to evangelize; to square with gospel, also GOSPELISE, GOSPELLISE, GOSPELLIZE [v]\n",
  "GOSPELIZES": "GOSPELIZE, to evangelize; to square with gospel, also GOSPELISE, GOSPELLISE, GOSPELLIZE [v]\n",
  "GOSPELIZING": "GOSPELIZE, to evangelize; to square with gospel, also GOSPELISE, GOSPELLISE, GOSPELLIZE [v]\n",
  "GOSPELLED": "GOSPEL, to teach about the life of Christ [v]\n",
  "GOSPELLER": "one of the four evangelists, also GOSPELER [n -S]\n",
  "GOSPELLERS": "GOSPELLER, one of the four evangelists, also GOSPELER [n]\n",
  "GOSPELLIER": "GOSPELLY, like gospel music [adj]\n",
  "GOSPELLIEST": "GOSPELLY, like gospel music [adj]\n",
  "GOSPELLING": "the act of teaching about the life of Christ [n -S]\n",
  "GOSPELLINGS": "GOSPELLING, the act of teaching about the life of Christ [n]\n",
  "GOSPELLISE": "to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLIZE [v GOSPELLISED, GOSPELLISING, GOSPELLISES]\n",
  "GOSPELLISED": "GOSPELLISE, to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLIZE [v]\n",
  "GOSPELLISES": "GOSPELLISE, to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLIZE [v]\n",
  "GOSPELLISING": "GOSPELLISE, to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLIZE [v]\n",
  "GOSPELLIZE": "to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLISE [v GOSPELLIZED, GOSPELLIZING, GOSPELLIZES]\n",
  "GOSPELLIZED": "GOSPELLIZE, to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLISE [v]\n",
  "GOSPELLIZES": "GOSPELLIZE, to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLISE [v]\n",
  "GOSPELLIZING": "GOSPELLIZE, to evangelize; to square with gospel, also GOSPELISE, GOSPELIZE, GOSPELLISE [v]\n",
  "GOSPELLY": "like gospel music [adj GOSPELLIER, GOSPELLIEST]\n",
  "GOSPELS": "GOSPEL, to teach about the life of Christ [v]\n",
  "GOSPODA": "(Romanian) a Russian title of address, equivalent to Mr, also GOSPODIN [n]\n",
  "GOSPODAR": "(historical) a prince or governor, especially of Moldavia or Wallachia, also HOSPODAR [n -S]\n",
  "GOSPODARS": "GOSPODAR, (historical) a prince or governor, especially of Moldavia or Wallachia, also HOSPODAR [n]\n",
  "GOSPODIN": "(Russian) a Russian title of address, equivalent to Mr, also GOSPODA [n]\n",
  "GOSPORT": "a communication device in an airplane [n -S]\n",
  "GOSPORTS": "GOSPORT, a communication device in an airplane [n]\n",
  "GOSS": "(dialect) to spit [v GOSSED, GOSSING, GOSSES]\n",
  "GOSSAMER": "a fine film of cobwebs [n -S]\n",
  "GOSSAMERIER": "GOSSAMERY, of or like gossamer, the filmy cobwebs that often float in the autumn air [adj]\n",
  "GOSSAMERIEST": "GOSSAMERY, of or like gossamer, the filmy cobwebs that often float in the autumn air [adj]\n",
  "GOSSAMERS": "GOSSAMER, a fine film of cobwebs [n]\n",
  "GOSSAMERY": "of or like gossamer, the filmy cobwebs that often float in the autumn air [adj GOSSAMERIER, GOSSAMERIEST]\n",
  "GOSSAN": "a type of decomposed rock, also GOZZAN [n -S]\n",
  "GOSSANS": "GOSSAN, a type of decomposed rock, also GOZZAN [n]\n",
  "GOSSE": "(Shakespeare) gorse [n -S]\n",
  "GOSSED": "GOSS, (dialect) to spit [v]\n",
  "GOSSES": "GOSS, (dialect) to spit [v]\n",
  "GOSSIB": "a gossip, someone who talks idly about others' affairs [n -S]\n",
  "GOSSIBS": "GOSSIB, a gossip, someone who talks idly about others' affairs [n]\n",
  "GOSSING": "GOSS, (dialect) to spit [v]\n",
  "GOSSIP": "to talk idly about others' affairs [v GOSSIPPED or GOSSIPED, GOSSIPPING or GOSSIPING, GOSSIPS]\n",
  "GOSSIPED": "GOSSIP, to talk idly about others' affairs [v]\n",
  "GOSSIPER": "one that gossips, also GOSSIPPER [n -S]\n",
  "GOSSIPERS": "GOSSIPER, one that gossips, also GOSSIPPER [n]\n",
  "GOSSIPIER": "GOSSIPY, full of, or given to, gossip [adj]\n",
  "GOSSIPIEST": "GOSSIPY, full of, or given to, gossip [adj]\n",
  "GOSSIPING": "telling idle or malicious tales [adj GOSSIPINGLY] / the act of gossiping [n -S]\n",
  "GOSSIPINGLY": "GOSSIPING [adv]\n",
  "GOSSIPINGS": "GOSSIPING, the act of gossiping [n]\n",
  "GOSSIPMONGER": "one who spreads gossip [n -S]\n",
  "GOSSIPMONGERS": "GOSSIPMONGER, one who spreads gossip [n]\n",
  "GOSSIPPED": "GOSSIP, to talk idly about others' affairs [v]\n",
  "GOSSIPPER": "one who gossips, also GOSSIPER [n -S]\n",
  "GOSSIPPERS": "GOSSIPPER, one who gossips, also GOSSIPER [n]\n",
  "GOSSIPPING": "GOSSIP, to talk idly about others' affairs [v]\n",
  "GOSSIPRIES": "GOSSIPRY, the practice of gossiping [n]\n",
  "GOSSIPRY": "the practice of gossiping [n GOSSIPRIES]\n",
  "GOSSIPS": "GOSSIP, to talk idly about others' affairs [v]\n",
  "GOSSIPY": "full of, or given to, gossip [adj GOSSIPIER, GOSSIPIEST]\n",
  "GOSSOON": "a boy or boy-servant, also GORSOON [n -S]\n",
  "GOSSOONS": "GOSSOON, a boy or boy-servant, also GORSOON [n]\n",
  "GOSSYPINE": "(Latin) cottony [adj]\n",
  "GOSSYPOL": "a toxic pigment [n -S]\n",
  "GOSSYPOLS": "GOSSYPOL, a toxic pigment [n]\n",
  "GOSTER": "(dialect) to laugh uncontrollably [v -ED, -ING, -S]\n",
  "GOSTERED": "GOSTER, (dialect) to laugh uncontrollably [v]\n",
  "GOSTERING": "GOSTER, (dialect) to laugh uncontrollably [v]\n",
  "GOSTERS": "GOSTER, (dialect) to laugh uncontrollably [v]\n",
  "GOT": "GET, to obtain or acquire [v]\n",
  "GOTCH": "(Canadian) underpants, also GINCH, GITCH, GONCH [n -ES]\n",
  "GOTCHA": "an instance of catching a person out in a deceit or wrongdoing [n -S]\n",
  "GOTCHAS": "GOTCHA, an instance of catching a person out in a deceit or wrongdoing [n]\n",
  "GOTCHES": "GOTCH, (Canadian) underpants, also GINCH, GITCH, GONCH [n]\n",
  "GOTCHIES": "underpants [n]\n",
  "GOTH": "someone into gothic music or fashion [n -S]\n",
  "GOTHIC": "lurid, macabre [adj GOTHICALLY] / a style of printing [n -S]\n",
  "GOTHICALLY": "GOTHIC, lurid, macabre [adv]\n",
  "GOTHICISE": "to make Gothic, also GOTHICIZE [v GOTHICISED, GOTHICISING, GOTHICISES]\n",
  "GOTHICISED": "GOTHICISE, to make Gothic, also GOTHICIZE [v]\n",
  "GOTHICISES": "GOTHICISE, to make Gothic, also GOTHICIZE [v]\n",
  "GOTHICISING": "GOTHICISE, to make Gothic, also GOTHICIZE [v]\n",
  "GOTHICISM": "the quality of being gothic, characterized by gloom and the grotesque [n -S]\n",
  "GOTHICISMS": "GOTHICISM, the quality of being gothic, characterized by gloom and the grotesque [n]\n",
  "GOTHICIZE": "to make Gothic, also GOTHICISE [v GOTHICIZED, GOTHICIZING, GOTHICIZES]\n",
  "GOTHICIZED": "GOTHICIZE, to make Gothic, also GOTHICISE [v]\n",
  "GOTHICIZES": "GOTHICIZE, to make Gothic, also GOTHICISE [v]\n",
  "GOTHICIZING": "GOTHICIZE, to make Gothic, also GOTHICISE [v]\n",
  "GOTHICS": "GOTHIC, a style of printing [n]\n",
  "GOTHIER": "GOTHY, (colloquial) relating to Gothic music or fashion [adj]\n",
  "GOTHIEST": "GOTHY, (colloquial) relating to Gothic music or fashion [adj]\n",
  "GOTHITE": "an ore of iron, also GOETHITE [n -S]\n",
  "GOTHITES": "GOTHITE, an ore of iron, also GOETHITE [n]\n",
  "GOTHS": "GOTH, someone into gothic music or fashion [n]\n",
  "GOTHY": "(colloquial) relating to Gothic music or fashion [adj GOTHIER, GOTHIEST]\n",
  "GOTTA": "(colloquial) got to [v]\n",
  "GOTTEN": "GET, to obtain or acquire [v]\n",
  "GOUACHE": "(French) a method of painting with gum-based opaque water colors [n -S]\n",
  "GOUACHES": "GOUACHE, (French) a method of painting with gum-based opaque water colors [n]\n",
  "GOUCH": "(slang) to enter a state of torpor, esp. under the influence of a narcotic [v -ED, -ING, -ES]\n",
  "GOUCHED": "GOUCH, (slang) to enter a state of torpor, esp. under the influence of a narcotic [v]\n",
  "GOUCHES": "GOUCH, (slang) to enter a state of torpor, esp. under the influence of a narcotic [v]\n",
  "GOUCHING": "GOUCH, (slang) to enter a state of torpor, esp. under the influence of a narcotic [v]\n",
  "GOUGE": "to cut or scoop out [v GOUGED, GOUGING, GOUGES]\n",
  "GOUGED": "GOUGE, to cut or scoop out [v]\n",
  "GOUGER": "one that gouges [n -S]\n",
  "GOUGERE": "(French) a kind of choux pastry, the dough of which has been mixed with grated cheese prior to baking [n -S]\n",
  "GOUGERES": "GOUGERE, (French) a kind of choux pastry, the dough of which has been mixed with grated cheese prior to baking [n]\n",
  "GOUGERS": "GOUGER, one that gouges [n]\n",
  "GOUGES": "GOUGE, to cut or scoop out [v]\n",
  "GOUGING": "GOUGE, to cut or scoop out [v]\n",
  "GOUJEERS": "an editor's spurious improvement on goodyear, venereal disease [n]\n",
  "GOUJON": "(French) a small strip of fish coated with flour and deep-fried [n -S]\n",
  "GOUJONS": "GOUJON, (French) a small strip of fish coated with flour and deep-fried [n]\n",
  "GOUK": "(Scots) a cuckoo; a fool, an April fool, also GOWK [n -S]\n",
  "GOUKS": "GOUK, (Scots) a cuckoo; a fool, an April fool, also GOWK [n]\n",
  "GOULASH": "(Hungarian) a stew or ragout of meat and vegetables highly seasoned [n -ES]\n",
  "GOULASHES": "GOULASH, (Hungarian) a stew or ragout of meat and vegetables highly seasoned [n]\n",
  "GOURA": "a large, crested ground pigeon inhabiting New Guinea and adjacent islands [n -S]\n",
  "GOURAMI": "(Malay) a large East Indian freshwater fish, also GORAMY, GURAMI [n GOURAMIES or GOURAMIS]\n",
  "GOURAMIES": "GOURAMI, (Malay) a large East Indian freshwater fish, also GORAMY, GURAMI [n]\n",
  "GOURAMIS": "GOURAMI, (Malay) a large East Indian freshwater fish, also GORAMY, GURAMI [n]\n",
  "GOURAS": "GOURA, a large, crested ground pigeon inhabiting New Guinea and adjacent islands [n]\n",
  "GOURD": "a large hard-rinded fleshy fruit characteristic of the cucumber family [n -S]\n",
  "GOURDE": "(French) a monetary unit of Haiti [n -S]\n",
  "GOURDES": "GOURDE, (French) a monetary unit of Haiti [n]\n",
  "GOURDFUL": "the contents of a gourd [n -S]\n",
  "GOURDFULS": "GOURDFUL, the contents of a gourd [n]\n",
  "GOURDIER": "GOURDY, of a horse, swollen in the legs [adj]\n",
  "GOURDIEST": "GOURDY, of a horse, swollen in the legs [adj]\n",
  "GOURDINESS": "the state of being gourdy [n -ES]\n",
  "GOURDINESSES": "GOURDINESS, the state of being gourdy [n]\n",
  "GOURDLIKE": "like a gourd, a large hard-rinded fleshy fruit characteristic of the cucumber family [adj]\n",
  "GOURDS": "GOURD, a large hard-rinded fleshy fruit characteristic of the cucumber family [n]\n",
  "GOURDY": "of a horse, swollen in the legs [adj GOURDIER, GOURDIEST]\n",
  "GOURMAND": "one who loves to eat, also GORMAND [n -S]\n",
  "GOURMANDISE": "to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDIZE [v GOURMANDISED, GOURMANDISING, GOURMANDISES]\n",
  "GOURMANDISED": "GOURMANDISE, to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDIZE [v]\n",
  "GOURMANDISES": "GOURMANDISE, to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDIZE [v]\n",
  "GOURMANDISING": "GOURMANDISE, to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDIZE [v]\n",
  "GOURMANDISM": "the state of being a gourmand [n -S]\n",
  "GOURMANDISMS": "GOURMANDISM, the state of being a gourmand [n]\n",
  "GOURMANDIZE": "to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDISE [v GOURMANDIZED, GOURMANDIZING, GOURMANDIZES]\n",
  "GOURMANDIZED": "GOURMANDIZE, to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDISE [v]\n",
  "GOURMANDIZES": "GOURMANDIZE, to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDISE [v]\n",
  "GOURMANDIZING": "GOURMANDIZE, to indulge a taste for good food to excess, also GORMANDISE, GORMANDIZE, GOURMANDISE [v]\n",
  "GOURMANDS": "GOURMAND, one who loves to eat, also GORMAND [n]\n",
  "GOURMET": "(French) a connoisseur of fine food and drink [n -S]\n",
  "GOURMETS": "GOURMET, (French) a connoisseur of fine food and drink [n]\n",
  "GOUSTIER": "GOUSTY, (Scots) desolate, dreary [adj]\n",
  "GOUSTIEST": "GOUSTY, (Scots) desolate, dreary [adj]\n",
  "GOUSTROUS": "(Scots) boisterous, rude [adj]\n",
  "GOUSTY": "(Scots) desolate, dreary [adj GOUSTIER, GOUSTIEST]\n",
  "GOUT": "a metabolic disease [n -S]\n",
  "GOUTFLIES": "GOUTFLY, a fly whose larvae cause gout [n]\n",
  "GOUTFLY": "a fly whose larvae cause gout [n GOUTFLIES]\n",
  "GOUTIER": "GOUTY, affected with gout [adj]\n",
  "GOUTIEST": "GOUTY, affected with gout [adj]\n",
  "GOUTILY": "GOUTY, affected with gout [adv]\n",
  "GOUTINESS": "the state of being gouty [n -ES]\n",
  "GOUTINESSES": "GOUTINESS, the state of being gouty [n]\n",
  "GOUTS": "GOUT, a metabolic disease [n]\n",
  "GOUTTE": "(French) a drop [n -S]\n",
  "GOUTTES": "GOUTTE, (French) a drop [n]\n",
  "GOUTWEED": "an umbelliferous weed, long supposed to be good for gout, also GOATWEED, GOUTWORT [n -S]\n",
  "GOUTWEEDS": "GOUTWEED, an umbelliferous weed, long supposed to be good for gout, also GOATWEED, GOUTWORT [n]\n",
  "GOUTWORT": "an umbelliferous weed, long supposed to be good for gout, also GOATWEED, GOUTWEED [n -S]\n",
  "GOUTWORTS": "GOUTWORT, an umbelliferous weed, long supposed to be good for gout, also GOATWEED, GOUTWEED [n]\n",
  "GOUTY": "affected with gout [adj GOUTIER, GOUTIEST, GOUTILY]\n",
  "GOUVERNANTE": "(archaic) a governess, also GOVERNANTE [n -S]\n",
  "GOUVERNANTES": "GOUVERNANTE, (archaic) a governess, also GOVERNANTE [n]\n",
  "GOV": "(short for) governor, also GUV [n -S]\n",
  "GOVERN": "to rule or direct [v -ED, -ING, -S]\n",
  "GOVERNABILITIES": "GOVERNABILITY, the quality of being governable [n]\n",
  "GOVERNABILITY": "the quality of being governable [n GOVERNABILITIES]\n",
  "GOVERNABLE": "that can be governed [adj]\n",
  "GOVERNABLENESS": "the state of being governable [n]\n",
  "GOVERNALL": "(Spenser) government [n -S]\n",
  "GOVERNALLS": "GOVERNALL, (Spenser) government [n]\n",
  "GOVERNANCE": "exercise of authority; government [n -S]\n",
  "GOVERNANCES": "GOVERNANCE, exercise of authority; government [n]\n",
  "GOVERNANTE": "a female governor or ruler, also GOUVERNANTE [n -S]\n",
  "GOVERNANTES": "GOVERNANTE, a female governor or ruler, also GOUVERNANTE [n]\n",
  "GOVERNED": "GOVERN, to rule or direct [v]\n",
  "GOVERNESS": "a woman entrusted with the care and education of a child or children [n -ES] / to act as a governess [v -ED, -ING, -ES]\n",
  "GOVERNESSED": "GOVERNESS, to act as a governess [v]\n",
  "GOVERNESSES": "GOVERNESS, to act as a governess [v]\n",
  "GOVERNESSIER": "GOVERNESSY, like a governess [adj]\n",
  "GOVERNESSIEST": "GOVERNESSY, like a governess [adj]\n",
  "GOVERNESSING": "GOVERNESS, to act as a governess [v]\n",
  "GOVERNESSY": "like a governess [adj GOVERNESSIER, GOVERNESSIEST]\n",
  "GOVERNING": "GOVERN, to rule or direct [v]\n",
  "GOVERNMENT": "a group in a parliamentary system constituted by the cabinet or by the ministry [n -S]\n",
  "GOVERNMENTAL": "relating to government [adj GOVERNMENTALLY]\n",
  "GOVERNMENTALISE": "to make governmental, also GOVERNMENTALIZE [v]\n",
  "GOVERNMENTALISM": "a theory advocating extension of the sphere and degree of government activity [n]\n",
  "GOVERNMENTALIST": "an exponent of governmentalism [n]\n",
  "GOVERNMENTALIZE": "to make governmental, also GOVERNMENTALISE [v]\n",
  "GOVERNMENTALLY": "GOVERNMENTAL, relating to government [adv]\n",
  "GOVERNMENTESE": "jargon held to be characteristic of government officials [n -S]\n",
  "GOVERNMENTESES": "GOVERNMENTESE, jargon held to be characteristic of government officials [n]\n",
  "GOVERNMENTS": "GOVERNMENT, a group in a parliamentary system constituted by the cabinet or by the ministry [n]\n",
  "GOVERNOR": "one that governs [n -S]\n",
  "GOVERNORATE": "the office of governor [n -S]\n",
  "GOVERNORATES": "GOVERNORATE, the office of governor [n]\n",
  "GOVERNORS": "GOVERNOR, one that governs [n]\n",
  "GOVERNORSHIP": "the office of governor [n -S]\n",
  "GOVERNORSHIPS": "GOVERNORSHIP, the office of governor [n]\n",
  "GOVERNS": "GOVERN, to rule or direct [v]\n",
  "GOVS": "GOV, (short for) governor, also GUV [n]\n",
  "GOWAN": "(Scots) a daisy [n -S]\n",
  "GOWANED": "covered with gowans (daisies) [adj]\n",
  "GOWANS": "GOWAN, (Scots) a daisy [n]\n",
  "GOWANY": "covered with gowans (daisies) [adj]\n",
  "GOWD": "(Scots) gold [n -S] / golden [adj GOWDER, GOWDEST]\n",
  "GOWDER": "GOWD, golden [adj]\n",
  "GOWDEST": "GOWD, golden [adj]\n",
  "GOWDS": "GOWD, (Scots) gold [n]\n",
  "GOWDSPINK": "(Scots) the goldfinch, also GOLDSPINK [n -S]\n",
  "GOWDSPINKS": "GOWDSPINK, (Scots) the goldfinch, also GOLDSPINK [n]\n",
  "GOWF": "(Scots) to play golf (a ball game), also GOLF, GOFF [v -ED, -ING, -S]\n",
  "GOWFED": "GOWF, (Scots) to play golf (a ball game), also GOLF, GOFF [v]\n",
  "GOWFER": "(Scots) one that golfs, also GOLFER [n -S]\n",
  "GOWFERS": "GOWFER, (Scots) one that golfs, also GOLFER [n]\n",
  "GOWFING": "GOWF, (Scots) to play golf (a ball game), also GOLF, GOFF [v]\n",
  "GOWFS": "GOWF, (Scots) to play golf (a ball game), also GOLF, GOFF [v]\n",
  "GOWK": "(Scots) a cuckoo, a fool, also GOUK [n -S]\n",
  "GOWKS": "GOWK, (Scots) a cuckoo, a fool, also GOUK [n]\n",
  "GOWL": "(Scots) to cry or howl [v -ED, -ING, -S]\n",
  "GOWLAN": "(dialect) a name for various yellow flowers including marigold, also GOLLAN, GOLLAND, GOWLAND [n -S]\n",
  "GOWLAND": "(dialect) a name for various yellow flowers including marigold, also GOLLAN, GOLLAND, GOWLAN [n -S]\n",
  "GOWLANDS": "GOWLAND, (dialect) a name for various yellow flowers including marigold, also GOLLAN, GOLLAND, GOWLAN [n]\n",
  "GOWLANS": "GOWLAN, (dialect) a name for various yellow flowers including marigold, also GOLLAN, GOLLAND, GOWLAND [n]\n",
  "GOWLED": "GOWL, (Scots) to cry or howl [v]\n",
  "GOWLING": "GOWL, (Scots) to cry or howl [v]\n",
  "GOWLS": "GOWL, (Scots) to cry or howl [v]\n",
  "GOWN": "to dress in a gown (a long, loose outer garment) [v -ED, -ING, -S]\n",
  "GOWNBOY": "a school foundationer who wears a gown [n -S]\n",
  "GOWNBOYS": "GOWNBOY, a school foundationer who wears a gown [n]\n",
  "GOWNED": "GOWN, to dress in a gown (a long, loose outer garment) [v]\n",
  "GOWNING": "GOWN, to dress in a gown (a long, loose outer garment) [v]\n",
  "GOWNMAN": "one whose professional habit is a gown, as a divine or lawyer, also GOWNSMAN [n GOWNMEN]\n",
  "GOWNMEN": "GOWNMAN, one whose professional habit is a gown, as a divine or lawyer, also GOWNSMAN [n]\n",
  "GOWNS": "GOWN, to dress in a gown (a long, loose outer garment) [v]\n",
  "GOWNSMAN": "one whose professional habit is a gown, as a divine or lawyer, also GOWNMAN [n GOWNSMEN]\n",
  "GOWNSMEN": "GOWNSMAN, one whose professional habit is a gown, as a divine or lawyer, also GOWNMAN [n]\n",
  "GOWPEN": "(Old Norse) the hollow of the two hands held together; a double handful [n -S]\n",
  "GOWPENFUL": "(Scots) a double handful [n -S]\n",
  "GOWPENFULS": "GOWPENFUL, (Scots) a double handful [n]\n",
  "GOWPENS": "GOWPEN, (Old Norse) the hollow of the two hands held together; a double handful [n]\n",
  "GOX": "gaseous oxygen [n -ES]\n",
  "GOXES": "GOX, gaseous oxygen [n]\n",
  "GOY": "(offensive) a Jewish word for a non-Jew [n GOYIM or GOYS]\n",
  "GOYIM": "GOY, (offensive) a Jewish word for a non-Jew [n]\n",
  "GOYISCH": "like a goy, non-Jew, Gentile, also GOYISH, GOYISHE [adj]\n",
  "GOYISH": "like a goy, non-Jew, Gentile, also GOYISCH, GOYISHE [adj]\n",
  "GOYISHE": "(Yiddish) like a goy, non-Jew, Gentile, also GOYISCH, GOYISH [adj]\n",
  "GOYLE": "(dialect) a ravine [n -S]\n",
  "GOYLES": "GOYLE, (dialect) a ravine [n]\n",
  "GOYS": "GOY, (offensive) a Jewish word for a non-Jew [n]\n",
  "GOZZAN": "a type of decomposed rock, also GOSSAN [n -S]\n",
  "GOZZANS": "GOZZAN, a type of decomposed rock, also GOSSAN [n]\n",
  "GRAAL": "the cup used by Christ at the Last Supper, also GRAIL, GRAYLE [n -S]\n",
  "GRAALS": "GRAAL, the cup used by Christ at the Last Supper, also GRAIL, GRAYLE [n]\n",
  "GRAB": "to grasp suddenly [v GRABBED, GRABBING, GRABS]\n",
  "GRABBABLE": "that can be grabbed [adj]\n",
  "GRABBED": "GRAB, to grasp suddenly [v]\n",
  "GRABBER": "one who seizes or grabs [n -S]\n",
  "GRABBERS": "GRABBER, one who seizes or grabs [n]\n",
  "GRABBIER": "GRABBY, tending to grab [adj]\n",
  "GRABBIEST": "GRABBY, tending to grab [adj]\n",
  "GRABBING": "GRAB, to grasp suddenly [v]\n",
  "GRABBLE": "to grope, also GRUBBLE [v GRABBLED, GRABBLING, GRABBLES]\n",
  "GRABBLED": "GRABBLE, to grope, also GRUBBLE [v]\n",
  "GRABBLER": "one who grabbles, gropes [n -S]\n",
  "GRABBLERS": "GRABBLER, one who grabbles, gropes [n]\n",
  "GRABBLES": "GRABBLE, to grope, also GRUBBLE [v]\n",
  "GRABBLING": "GRABBLE, to grope, also GRUBBLE [v]\n",
  "GRABBY": "tending to grab [adj GRABBIER, GRABBIEST]\n",
  "GRABEN": "(German) a rift valley [n -S]\n",
  "GRABENS": "GRABEN, (German) a rift valley [n]\n",
  "GRABS": "GRAB, to grasp suddenly [v]\n",
  "GRACE": "beauty [n -S] / to give beauty to [v GRACED or (obsolete) GRASTE, GRACING, GRACES]\n",
  "GRACED": "GRACE, to give beauty to [v]\n",
  "GRACEFUL": "having beauty of form or movement [adj GRACEFULLER, GRACEFULLEST, GRACEFULLY]\n",
  "GRACEFULLER": "GRACEFUL, having beauty of form or movement [adj]\n",
  "GRACEFULLEST": "GRACEFUL, having beauty of form or movement [adj]\n",
  "GRACEFULLY": "GRACEFUL, having beauty of form or movement [adv]\n",
  "GRACEFULNESS": "the state of being graceful [n -ES]\n",
  "GRACEFULNESSES": "GRACEFULNESS, the state of being graceful [n]\n",
  "GRACELESS": "without grace [adj GRACELESSLY]\n",
  "GRACELESSLY": "GRACELESS, without grace [adv]\n",
  "GRACELESSNESS": "GRACELESS, without grace [n]\n",
  "GRACELESSNESSES": "GRACELESSNESS, GRACELESS, without grace [n]\n",
  "GRACES": "GRACE, to give beauty to [v]\n",
  "GRACILE": "gracefully slender [adj]\n",
  "GRACILENESS": "slenderness [n -ES]\n",
  "GRACILENESSES": "GRACILENESS, slenderness [n]\n",
  "GRACILES": "GRACILIS, (Latin) a thigh muscle [n]\n",
  "GRACILIS": "(Latin) a thigh muscle [n GRACILES]\n",
  "GRACILITIES": "GRACILITY, slenderness [n]\n",
  "GRACILITY": "slenderness [n GRACILITIES]\n",
  "GRACING": "GRACE, to give beauty to [v]\n",
  "GRACIOSITIES": "GRACIOSITY, graciousness [n]\n",
  "GRACIOSITY": "graciousness [n GRACIOSITIES]\n",
  "GRACIOSO": "(Spanish) a clown in Spanish comedy [n -S]\n",
  "GRACIOSOS": "GRACIOSO, (Spanish) a clown in Spanish comedy [n]\n",
  "GRACIOUS": "marked by kindness and courtesy [adj GRACIOUSLY]\n",
  "GRACIOUSLY": "GRACIOUS, marked by kindness and courtesy [adv]\n",
  "GRACIOUSNESS": "the state of being gracious [n -ES]\n",
  "GRACIOUSNESSES": "GRACIOUSNESS, the state of being gracious [n]\n",
  "GRACKLE": "a kind of American blackbird, also GRAKLE [n -S]\n",
  "GRACKLES": "GRACKLE, a kind of American blackbird, also GRAKLE [n]\n",
  "GRAD": "(colloquial) a graduate [n -S]\n",
  "GRADABILITIES": "GRADABILITY, the quality of being gradable [n]\n",
  "GRADABILITY": "the quality of being gradable [n GRADABILITIES]\n",
  "GRADABLE": "things that are graded [n -S]\n",
  "GRADABLENESS": "the state of being gradable [n -ES]\n",
  "GRADABLENESSES": "GRADABLENESS, the state of being gradable [n]\n",
  "GRADABLES": "GRADABLE, things that are graded [n]\n",
  "GRADATE": "to change by degrees [v GRADATED, GRADATING, GRADATES]\n",
  "GRADATED": "GRADATE, to change by degrees [v]\n",
  "GRADATES": "GRADATE, to change by degrees [v]\n",
  "GRADATIM": "(Latin) step-by-step [adv]\n",
  "GRADATING": "GRADATE, to change by degrees [v]\n",
  "GRADATION": "progress from one degree or state to another [n -S]\n",
  "GRADATIONAL": "relating to gradation [adj GRADATIONALLY]\n",
  "GRADATIONALLY": "GRADATIONAL, relating to gradation [adv]\n",
  "GRADATIONED": "formed by gradations or stages [adj]\n",
  "GRADATIONS": "GRADATION, progress from one degree or state to another [n]\n",
  "GRADATORIES": "GRADATORY, a flight of stairs [n]\n",
  "GRADATORY": "a flight of stairs [n GRADATORIES]\n",
  "GRADDAN": "(Gaelic) to parch in the husk [v -ED, -ING, -S]\n",
  "GRADDANED": "GRADDAN, (Gaelic) to parch in the husk [v]\n",
  "GRADDANING": "GRADDAN, (Gaelic) to parch in the husk [v]\n",
  "GRADDANS": "GRADDAN, (Gaelic) to parch in the husk [v]\n",
  "GRADE": "to arrange in steps or degrees [v GRADED, GRADING, GRADES]\n",
  "GRADED": "GRADE, to arrange in steps or degrees [v]\n",
  "GRADELESS": "without a grade [adj]\n",
  "GRADELIER": "GRADELY, decent, orderly, also GRAITHLY [adj]\n",
  "GRADELIEST": "GRADELY, decent, orderly, also GRAITHLY [adj]\n",
  "GRADELY": "decent, orderly, also GRAITHLY [adj GRADELIER, GRADELIEST]\n",
  "GRADER": "a machine used to create a flat surface for road grading [n -S]\n",
  "GRADERS": "GRADER, a machine used to create a flat surface for road grading [n]\n",
  "GRADES": "GRADE, to arrange in steps or degrees [v]\n",
  "GRADIENT": "a rate of inclination [n -S]\n",
  "GRADIENTER": "a surveyor's instrument for determining gradients [n -S]\n",
  "GRADIENTERS": "GRADIENTER, a surveyor's instrument for determining gradients [n]\n",
  "GRADIENTS": "GRADIENT, a rate of inclination [n]\n",
  "GRADIN": "anything like a step, as the raised back of an altar, also GRADINE [n -S]\n",
  "GRADINE": "one of a series of steps, also GRADIN [n -S]\n",
  "GRADINES": "GRADINE, one of a series of steps, also GRADIN [n]\n",
  "GRADING": "the act of arranging in steps or degrees [n -S]\n",
  "GRADINGS": "GRADING, the act of arranging in steps or degrees [n]\n",
  "GRADINI": "GRADINO, (Italian) a decoration for an altar gradin [n]\n",
  "GRADINO": "(Italian) a decoration for an altar gradin [n GRADINI]\n",
  "GRADINS": "GRADIN, anything like a step, as the raised back of an altar, also GRADINE [n]\n",
  "GRADIOMETER": "an instrument for measuring gradient of a physical quantity [n -S]\n",
  "GRADIOMETERS": "GRADIOMETER, an instrument for measuring gradient of a physical quantity [n]\n",
  "GRADS": "GRAD, (colloquial) a graduate [n]\n",
  "GRADUAL": "happening by degrees [adj GRADUALLY] / the part of mass between epistle and gospel [n -S]\n",
  "GRADUALISM": "the belief that things proceed by degrees [n -S]\n",
  "GRADUALISMS": "GRADUALISM, the belief that things proceed by degrees [n]\n",
  "GRADUALIST": "one who adheres to the doctrine of gradualism [n -S]\n",
  "GRADUALISTIC": "relating to gradualism, the belief that things proceed by degrees [adj]\n",
  "GRADUALISTS": "GRADUALIST, one who adheres to the doctrine of gradualism [n]\n",
  "GRADUALITIES": "GRADUALITY, the state of being gradual [n]\n",
  "GRADUALITY": "the state of being gradual [n GRADUALITIES]\n",
  "GRADUALLY": "GRADUAL, happening by degrees [adv]\n",
  "GRADUALNESS": "the state of being gradual [n -ES]\n",
  "GRADUALNESSES": "GRADUALNESS, the state of being gradual [n]\n",
  "GRADUALS": "GRADUAL, the part of mass between epistle and gospel [n]\n",
  "GRADUAND": "one who is about to graduate [n -S]\n",
  "GRADUANDS": "GRADUAND, one who is about to graduate [n]\n",
  "GRADUATE": "to receive an academic degree or diploma [v GRADUATED, GRADUATING, GRADUATES]\n",
  "GRADUATED": "GRADUATE, to receive an academic degree or diploma [v]\n",
  "GRADUATES": "GRADUATE, to receive an academic degree or diploma [v]\n",
  "GRADUATESHIP": "the state of being a graduate [n -S]\n",
  "GRADUATESHIPS": "GRADUATESHIP, the state of being a graduate [n]\n",
  "GRADUATING": "GRADUATE, to receive an academic degree or diploma [v]\n",
  "GRADUATION": "a mark on an instrument or vessel indicating degrees or quantity [n -S]\n",
  "GRADUATIONS": "GRADUATION, a mark on an instrument or vessel indicating degrees or quantity [n]\n",
  "GRADUATOR": "one who determines or indicates graduation; as, a graduator of instruments [n -S]\n",
  "GRADUATORS": "GRADUATOR, one who determines or indicates graduation; as, a graduator of instruments [n]\n",
  "GRADUS": "(Latin) a dictionary of prosody, designed as an aid in writing Greek or Latin poetry [n -ES]\n",
  "GRADUSES": "GRADUS, (Latin) a dictionary of prosody, designed as an aid in writing Greek or Latin poetry [n]\n",
  "GRAECISE": "to provide with a Greek style, also GRECISE, GRECIZE, GRAECIZE [v GRAECISED, GRAECISING, GRAECISES]\n",
  "GRAECISED": "GRAECISE, to provide with a Greek style, also GRECISE, GRECIZE, GRAECIZE [v]\n",
  "GRAECISES": "GRAECISE, to provide with a Greek style, also GRECISE, GRECIZE, GRAECIZE [v]\n",
  "GRAECISING": "GRAECISE, to provide with a Greek style, also GRECISE, GRECIZE, GRAECIZE [v]\n",
  "GRAECIZE": "to provide with a Greek style, also GRECISE, GRECIZE, GRAECISE [v GRAECIZED, GRAECIZING, GRAECIZES]\n",
  "GRAECIZED": "GRAECIZE, to provide with a Greek style, also GRECISE, GRECIZE, GRAECISE [v]\n",
  "GRAECIZES": "GRAECIZE, to provide with a Greek style, also GRECISE, GRECIZE, GRAECISE [v]\n",
  "GRAECIZING": "GRAECIZE, to provide with a Greek style, also GRECISE, GRECIZE, GRAECISE [v]\n",
  "GRAFF": "to unite with a growing plant by insertion, also GRAFT [v -ED, -ING, -S]\n",
  "GRAFFED": "GRAFF, to unite with a growing plant by insertion, also GRAFT [v]\n",
  "GRAFFING": "GRAFF, to unite with a growing plant by insertion, also GRAFT [v]\n",
  "GRAFFITI": "a piece of scribbling on a wall [n -S] / to deface with graffiti [v GRAFFITIED, GRAFFITING or GRAFFITIING, GRAFFITIS]\n",
  "GRAFFITIED": "GRAFFITI, to deface with graffiti [v]\n",
  "GRAFFITIING": "GRAFFITI, to deface with graffiti [v]\n",
  "GRAFFITING": "GRAFFITI, to deface with graffiti [v]\n",
  "GRAFFITIS": "GRAFFITI, to deface with graffiti [v]\n",
  "GRAFFITIST": "one who draws graffiti [n -S]\n",
  "GRAFFITISTS": "GRAFFITIST, one who draws graffiti [n]\n",
  "GRAFFITO": "(Italian) a scribble on a wall [n GRAFFITI]\n",
  "GRAFFS": "GRAFF, to unite with a growing plant by insertion, also GRAFT [v]\n",
  "GRAFT": "to unite with a growing plant by insertion, also GRAFF [v -ED, -ING, -S]\n",
  "GRAFTAGE": "the process of grafting [n -S]\n",
  "GRAFTAGES": "GRAFTAGE, the process of grafting [n]\n",
  "GRAFTED": "GRAFT, to unite with a growing plant by insertion, also GRAFF [v]\n",
  "GRAFTER": "one who grafts [n -S]\n",
  "GRAFTERS": "GRAFTER, one who grafts [n]\n",
  "GRAFTING": "the act of making a graft [n -S]\n",
  "GRAFTINGS": "GRAFTING, the act of making a graft [n]\n",
  "GRAFTS": "GRAFT, to unite with a growing plant by insertion, also GRAFF [v]\n",
  "GRAHAM": "bread made of unbolted wheat flour [n -S]\n",
  "GRAHAMS": "GRAHAM, bread made of unbolted wheat flour [n]\n",
  "GRAIL": "the cup used by Christ at the Last Supper, also GRAAL, GRAYLE [n -S]\n",
  "GRAILE": "(Spenser) gravel [n -S]\n",
  "GRAILES": "GRAILE, (Spenser) gravel [n]\n",
  "GRAILS": "GRAIL, the cup used by Christ at the Last Supper, also GRAAL, GRAYLE [n]\n",
  "GRAIN": "to form into small particles [v -ED, -ING, -S]\n",
  "GRAINAGE": "duties on grain [n -S]\n",
  "GRAINAGES": "GRAINAGE, duties on grain [n]\n",
  "GRAINE": "silkworm eggs [n -S]\n",
  "GRAINED": "GRAIN, to form into small particles [v]\n",
  "GRAINER": "a person who grains; a paintbrush for graining [n -S]\n",
  "GRAINERS": "GRAINER, a person who grains; a paintbrush for graining [n]\n",
  "GRAINES": "GRAINE, silkworm eggs [n]\n",
  "GRAINFIELD": "a field where grain is grown [n -S]\n",
  "GRAINFIELDS": "GRAINFIELD, a field where grain is grown [n]\n",
  "GRAINIER": "GRAINY, having a grain [adj]\n",
  "GRAINIEST": "GRAINY, having a grain [adj]\n",
  "GRAININESS": "the state of being grainy [n -ES]\n",
  "GRAININESSES": "GRAININESS, the state of being grainy [n]\n",
  "GRAINING": "a process in tanning in which the grain of the leather is raised [n -S]\n",
  "GRAININGS": "GRAINING, a process in tanning in which the grain of the leather is raised [n]\n",
  "GRAINLESS": "without grain [adj]\n",
  "GRAINS": "GRAIN, to form into small particles [v]\n",
  "GRAINY": "having a grain [adj GRAINIER, GRAINIEST]\n",
  "GRAIP": "a pitchfork used for hurling manure or digging potatoes [n -S]\n",
  "GRAIPS": "GRAIP, a pitchfork used for hurling manure or digging potatoes [n]\n",
  "GRAITH": "(Scots) to dress, prepare [v -ED, -ING, -S]\n",
  "GRAITHED": "GRAITH, (Scots) to dress, prepare [v]\n",
  "GRAITHING": "GRAITH, (Scots) to dress, prepare [v]\n",
  "GRAITHLY": "(dialect) decent, orderly, also GRADELY [adj]\n",
  "GRAITHS": "GRAITH, (Scots) to dress, prepare [v]\n",
  "GRAKLE": "a kind of American blackbird, also GRACKLE [n -S]\n",
  "GRAKLES": "GRAKLE, a kind of American blackbird, also GRACKLE [n]\n",
  "GRALLATORIAL": "relating to wading birds [adj]\n",
  "GRALLOCH": "(Gaelic) to gut, especially a deer [v -ED, -ING, -S]\n",
  "GRALLOCHED": "GRALLOCH, (Gaelic) to gut, especially a deer [v]\n",
  "GRALLOCHING": "GRALLOCH, (Gaelic) to gut, especially a deer [v]\n",
  "GRALLOCHS": "GRALLOCH, (Gaelic) to gut, especially a deer [v]\n",
  "GRAM": "a unit of mass in the metric system, also GRAMME [n -S]\n",
  "GRAMA": "(Spanish) a kind of pasture grass found in the Western United States, also GRAMMA [n -S]\n",
  "GRAMARIES": "GRAMARY, occult learning or magic, also GRAMARYE [n]\n",
  "GRAMARY": "occult learning or magic, also GRAMARYE [n GRAMARIES]\n",
  "GRAMARYE": "occult learning or magic, also GRAMARY [n -S]\n",
  "GRAMARYES": "GRAMARYE, occult learning or magic, also GRAMARY [n]\n",
  "GRAMAS": "GRAMA, (Spanish) a kind of pasture grass found in the Western United States, also GRAMMA [n]\n",
  "GRAMASH": "a type of legging, also GAMASH, GRAMOCHE [n -ES]\n",
  "GRAMASHES": "GRAMASH, a type of legging, also GAMASH, GRAMOCHE [n]\n",
  "GRAME": "(obsolete) anger, wrath [n -S]\n",
  "GRAMERCIES": "GRAMERCY, an expression of gratitude [n]\n",
  "GRAMERCY": "an expression of gratitude [n GRAMERCIES]\n",
  "GRAMES": "GRAME, (obsolete) anger, wrath [n]\n",
  "GRAMICIDIN": "an antibiotic obtained from certain bacteria [n -S]\n",
  "GRAMICIDINS": "GRAMICIDIN, an antibiotic obtained from certain bacteria [n]\n",
  "GRAMINACEOUS": "grasslike; pertaining to grass family of plants [adj]\n",
  "GRAMINEOUS": "of or relating to grass [adj]\n",
  "GRAMINICOLOUS": "esp. of parasitic fungi, living on grass [adj]\n",
  "GRAMINIVOROUS": "feeding on grass or cereals [adj]\n",
  "GRAMINOLOGIES": "GRAMINOLOGY, the study of grasses [n]\n",
  "GRAMINOLOGY": "the study of grasses [n GRAMINOLOGIES]\n",
  "GRAMMA": "(Spanish) a kind of pasture grass found in the Western United States, also GRAMA [n -S]\n",
  "GRAMMAGE": "a weight of paper expressed as grams per square metre [n -S]\n",
  "GRAMMAGES": "GRAMMAGE, a weight of paper expressed as grams per square metre [n]\n",
  "GRAMMALOGUE": "a word represented by a single sign [n -S]\n",
  "GRAMMALOGUES": "GRAMMALOGUE, a word represented by a single sign [n]\n",
  "GRAMMAR": "the study of the formal features of a language [n -S]\n",
  "GRAMMARIAN": "one versed in grammar; a philologist [n -S]\n",
  "GRAMMARIANS": "GRAMMARIAN, one versed in grammar; a philologist [n]\n",
  "GRAMMARLESS": "without grammar [adj]\n",
  "GRAMMARS": "GRAMMAR, the study of the formal features of a language [n]\n",
  "GRAMMAS": "GRAMMA, (Spanish) a kind of pasture grass found in the Western United States, also GRAMA [n]\n",
  "GRAMMATIC": "belonging to, or according to the rules of, grammar, also GRAMMATICAL [adj GRAMMATICALLY]\n",
  "GRAMMATICAL": "belonging to, or according to the rules of, grammar, also GRAMMATIC [adj GRAMMATICALLY]\n",
  "GRAMMATICALITY": "the state of being grammatical [n]\n",
  "GRAMMATICALLY": "GRAMMATICAL, belonging to, or according to the rules of, grammar, also GRAMMATIC [adv]\n",
  "GRAMMATICALNESS": "GRAMMATICAL, belonging to, or according to the rules of, grammar, also GRAMMATIC [n]\n",
  "GRAMMATICASTER": "(archaic) a petty grammarian [n -S]\n",
  "GRAMMATICASTERS": "GRAMMATICASTER, (archaic) a petty grammarian [n]\n",
  "GRAMMATICISE": "to make grammatical, also GRAMMATICIZE [v GRAMMATICISED, GRAMMATICISING, GRAMMATICISES]\n",
  "GRAMMATICISED": "GRAMMATICISE, to make grammatical, also GRAMMATICIZE [v]\n",
  "GRAMMATICISES": "GRAMMATICISE, to make grammatical, also GRAMMATICIZE [v]\n",
  "GRAMMATICISING": "GRAMMATICISE, to make grammatical, also GRAMMATICIZE [v]\n",
  "GRAMMATICISM": "a point of grammar [n -S]\n",
  "GRAMMATICISMS": "GRAMMATICISM, a point of grammar [n]\n",
  "GRAMMATICIZE": "to make grammatical, also GRAMMATICISE [v GRAMMATICIZED, GRAMMATICIZING, GRAMMATICIZES]\n",
  "GRAMMATICIZED": "GRAMMATICIZE, to make grammatical, also GRAMMATICISE [v]\n",
  "GRAMMATICIZES": "GRAMMATICIZE, to make grammatical, also GRAMMATICISE [v]\n",
  "GRAMMATICIZING": "GRAMMATICIZE, to make grammatical, also GRAMMATICISE [v]\n",
  "GRAMMATIST": "a petty grammarian [n -S]\n",
  "GRAMMATISTS": "GRAMMATIST, a petty grammarian [n]\n",
  "GRAMMATOLOGIES": "GRAMMATOLOGY, the study of systems of writing [n]\n",
  "GRAMMATOLOGIST": "a specialist in grammatology [n -S]\n",
  "GRAMMATOLOGISTS": "GRAMMATOLOGIST, a specialist in grammatology [n]\n",
  "GRAMMATOLOGY": "the study of systems of writing [n GRAMMATOLOGIES]\n",
  "GRAMME": "a unit of mass in the metric system, also GRAM [n -S]\n",
  "GRAMMES": "GRAMME, a unit of mass in the metric system, also GRAM [n]\n",
  "GRAMOCHE": "(Scots) a type of legging, also GAMASH, GRAMASH [n -S]\n",
  "GRAMOCHES": "GRAMOCHE, (Scots) a type of legging, also GAMASH, GRAMASH [n]\n",
  "GRAMOPHONE": "(tradename) an instrument for reproducing sounds by means of a needle moving along the grooves of a revolving disc [n -S]\n",
  "GRAMOPHONES": "GRAMOPHONE, (tradename) an instrument for reproducing sounds by means of a needle moving along the grooves of a revolving disc [n]\n",
  "GRAMOPHONIC": "relating to gramophones [adj GRAMOPHONICALLY]\n",
  "GRAMOPHONICALLY": "GRAMOPHONIC, relating to gramophones [adv]\n",
  "GRAMOPHONIES": "GRAMOPHONY, (obsolete) the use of the gramophone [n]\n",
  "GRAMOPHONIST": "one who plays a gramophone [n -S]\n",
  "GRAMOPHONISTS": "GRAMOPHONIST, one who plays a gramophone [n]\n",
  "GRAMOPHONY": "(obsolete) the use of the gramophone [n GRAMOPHONIES]\n",
  "GRAMP": "grandfather [n -S]\n",
  "GRAMPA": "(colloquial) a grandfather, also GRAMP [n -S]\n",
  "GRAMPAS": "GRAMPA, (colloquial) a grandfather, also GRAMP [n]\n",
  "GRAMPIES": "GRAMPY, a grandfather [n]\n",
  "GRAMPS": "GRAMP, grandfather [n]\n",
  "GRAMPUS": "Risso's dolphin; also, a popular name for many whales, especially the killer whale [n -ES]\n",
  "GRAMPUSES": "GRAMPUS, Risso's dolphin; also, a popular name for many whales, especially the killer whale [n]\n",
  "GRAMPY": "a grandfather [n GRAMPIES]\n",
  "GRAMS": "GRAM, a unit of mass in the metric system, also GRAMME [n]\n",
  "GRAN": "(short for) a grandmother [n -S]\n",
  "GRANA": "GRANUM, (Latin) a part of a plant chloroplast [n]\n",
  "GRANADILLA": "(Spanish) the fruit of certain species of passion flower found in Brazil and the West Indies, also GRENADILLA [n -S]\n",
  "GRANADILLAS": "GRANADILLA, (Spanish) the fruit of certain species of passion flower found in Brazil and the West Indies, also GRENADILLA [n]\n",
  "GRANARIES": "GRANARY, a storehouse for grain [n]\n",
  "GRANARY": "a storehouse for grain [n GRANARIES]\n",
  "GRAND": "large and impressive [adj GRANDER, GRANDEST, GRANDLY] / a type of piano [n -S]\n",
  "GRANDAD": "a grandfather, also GRANDDAD [n -S]\n",
  "GRANDADDIES": "GRANDADDY, (colloquial) grandfather, also GRANDDADDY [n]\n",
  "GRANDADDY": "(colloquial) grandfather, also GRANDDADDY [n GRANDADDIES]\n",
  "GRANDADS": "GRANDAD, a grandfather, also GRANDDAD [n]\n",
  "GRANDAM": "(archaic) a grandmother, also GRANDAME, GRANNAM [n -S]\n",
  "GRANDAME": "a dam's or sire's dam, also GRANDAM, GRANDDAM [n -S]\n",
  "GRANDAMES": "GRANDAME, a dam's or sire's dam, also GRANDAM, GRANDDAM [n]\n",
  "GRANDAMS": "GRANDAM, (archaic) a grandmother, also GRANDAME, GRANNAM [n]\n",
  "GRANDAUNT": "the aunt of one's father or mother [n -S]\n",
  "GRANDAUNTS": "GRANDAUNT, the aunt of one's father or mother [n]\n",
  "GRANDBABIES": "GRANDBABY, an infant grandchild [n]\n",
  "GRANDBABY": "an infant grandchild [n GRANDBABIES]\n",
  "GRANDCHILD": "the child of one's son or daughter [n GRANDCHILDREN]\n",
  "GRANDCHILDREN": "GRANDCHILD, the child of one's son or daughter [n]\n",
  "GRANDDAD": "a grandfather, also GRANDAD [n -S]\n",
  "GRANDDADDIES": "GRANDDADDY, a grandfather, also GRANDADDY [n]\n",
  "GRANDDADDY": "a grandfather, also GRANDADDY [n GRANDDADDIES]\n",
  "GRANDDADS": "GRANDDAD, a grandfather, also GRANDAD [n]\n",
  "GRANDDAM": "dam's or sire's dam, also GRANDAM, GRANDAME [n -S]\n",
  "GRANDDAMS": "GRANDDAM, dam's or sire's dam, also GRANDAM, GRANDAME [n]\n",
  "GRANDDAUGHTER": "the daughter of one's son or daughter [n -S]\n",
  "GRANDDAUGHTERS": "GRANDDAUGHTER, the daughter of one's son or daughter [n]\n",
  "GRANDE": "(French) grand, big [adj]\n",
  "GRANDEE": "a man of high rank [n -S]\n",
  "GRANDEES": "GRANDEE, a man of high rank [n]\n",
  "GRANDEESHIP": "the state of being a grandee [n -S]\n",
  "GRANDEESHIPS": "GRANDEESHIP, the state of being a grandee [n]\n",
  "GRANDER": "GRAND, large and impressive [adj]\n",
  "GRANDEST": "GRAND, large and impressive [adj]\n",
  "GRANDEUR": "(French) impressive size [n -S]\n",
  "GRANDEURS": "GRANDEUR, (French) impressive size [n]\n",
  "GRANDFATHER": "the father of one's mother or father [n -S] / to exempt (an activity, person, etc.) from a new piece of legislation, restriction or the like [v -ED, -ING, -S]\n",
  "GRANDFATHERED": "GRANDFATHER, to exempt (an activity, person, etc.) from a new piece of legislation, restriction or the like [v]\n",
  "GRANDFATHERING": "GRANDFATHER, to exempt (an activity, person, etc.) from a new piece of legislation, restriction or the like [v]\n",
  "GRANDFATHERLIER": "GRANDFATHERLY, like a grandfather [adj]\n",
  "GRANDFATHERLY": "like a grandfather [adj GRANDFATHERLIER]\n",
  "GRANDFATHERS": "GRANDFATHER, the father of one's mother or father [n]\n",
  "GRANDIFLORA": "(Latin) a large-flowered plant [n -S]\n",
  "GRANDIFLORAS": "GRANDIFLORA, (Latin) a large-flowered plant [n]\n",
  "GRANDILOQUENCE": "lofty or pompous eloquence, bombast [n -S]\n",
  "GRANDILOQUENCES": "GRANDILOQUENCE, lofty or pompous eloquence, bombast [n]\n",
  "GRANDILOQUENT": "bombastic, also GRANDILOQUOUS [adj GRANDILOQUENTLY]\n",
  "GRANDILOQUENTLY": "GRANDILOQUENT, bombastic, also GRANDILOQUOUS [adv]\n",
  "GRANDILOQUOUS": "(archaic) grandiloquent, also GRANDILOQUENT [adj]\n",
  "GRANDIOSE": "imposing; bombastic [adj GRANDIOSELY]\n",
  "GRANDIOSELY": "GRANDIOSE, imposing; bombastic [adv]\n",
  "GRANDIOSENESS": "GRANDIOSE, imposing; bombastic [n]\n",
  "GRANDIOSENESSES": "GRANDIOSENESS, GRANDIOSE, imposing; bombastic [n]\n",
  "GRANDIOSITIES": "GRANDIOSITY, the state of being grandiose [n]\n",
  "GRANDIOSITY": "the state of being grandiose [n GRANDIOSITIES]\n",
  "GRANDIOSO": "(Italian) in a broad or noble style [adv]\n",
  "GRANDKID": "grandchild [n -S]\n",
  "GRANDKIDS": "GRANDKID, grandchild [n]\n",
  "GRANDLY": "GRAND, large and impressive [adv]\n",
  "GRANDMA": "a grandmother [n -S]\n",
  "GRANDMAMA": "a grandmother [n -S]\n",
  "GRANDMAMAS": "GRANDMAMA, a grandmother [n]\n",
  "GRANDMAMMA": "a grandmother [n -S]\n",
  "GRANDMAMMAS": "GRANDMAMMA, a grandmother [n]\n",
  "GRANDMAS": "GRANDMA, a grandmother [n]\n",
  "GRANDMASTER": "a high-ranking chessplayer [n -S]\n",
  "GRANDMASTERS": "GRANDMASTER, a high-ranking chessplayer [n]\n",
  "GRANDMOTHER": "the mother of one's mother or father [n -S]\n",
  "GRANDMOTHERLIER": "GRANDMOTHERLY, like a grandmother [adj]\n",
  "GRANDMOTHERLY": "like a grandmother [adj GRANDMOTHERLIER]\n",
  "GRANDMOTHERS": "GRANDMOTHER, the mother of one's mother or father [n]\n",
  "GRANDNEPHEW": "a grandson of one's brother or sister [n -S]\n",
  "GRANDNEPHEWS": "GRANDNEPHEW, a grandson of one's brother or sister [n]\n",
  "GRANDNESS": "the state of being grand [n -ES]\n",
  "GRANDNESSES": "GRANDNESS, the state of being grand [n]\n",
  "GRANDNIECE": "the granddaughter of one's brother or sister [n -S]\n",
  "GRANDNIECES": "GRANDNIECE, the granddaughter of one's brother or sister [n]\n",
  "GRANDPA": "a grandfather [n -S]\n",
  "GRANDPAPA": "a grandfather [n -S]\n",
  "GRANDPAPAS": "GRANDPAPA, a grandfather [n]\n",
  "GRANDPARENT": "a parent of one's father or mother [n -S]\n",
  "GRANDPARENTAL": "of or like a grandparent [adj]\n",
  "GRANDPARENTHOOD": "the state of being a grandparent [n]\n",
  "GRANDPARENTS": "GRANDPARENT, a parent of one's father or mother [n]\n",
  "GRANDPAS": "GRANDPA, a grandfather [n]\n",
  "GRANDS": "GRAND, a type of piano [n]\n",
  "GRANDSIR": "a grandfather [n -S]\n",
  "GRANDSIRE": "a grandfather, also GRANDSIR [n -S]\n",
  "GRANDSIRES": "GRANDSIRE, a grandfather, also GRANDSIR [n]\n",
  "GRANDSIRS": "GRANDSIR, a grandfather [n]\n",
  "GRANDSON": "the son of one's son or daughter [n -S]\n",
  "GRANDSONS": "GRANDSON, the son of one's son or daughter [n]\n",
  "GRANDSTAND": "an elevated structure on a racecourse, etc., affording a good view for spectators [n -S] / to show off [v GRANDSTANDED or GRANDSTOOD, GRANDSTANDING, GRANDSTANDS]\n",
  "GRANDSTANDED": "GRANDSTAND, to show off [v]\n",
  "GRANDSTANDER": "one who grandstands [n -S]\n",
  "GRANDSTANDERS": "GRANDSTANDER, one who grandstands [n]\n",
  "GRANDSTANDING": "the act of putting on a show, playing to the crowd [n -S]\n",
  "GRANDSTANDINGS": "GRANDSTANDING, the act of putting on a show, playing to the crowd [n]\n",
  "GRANDSTANDS": "GRANDSTAND, to show off [v]\n",
  "GRANDSTOOD": "GRANDSTAND, to show off [v]\n",
  "GRANDUNCLE": "a father's or mother's uncle [n -S]\n",
  "GRANDUNCLES": "GRANDUNCLE, a father's or mother's uncle [n]\n",
  "GRANFER": "(dialect) a grandfather [n -S]\n",
  "GRANFERS": "GRANFER, (dialect) a grandfather [n]\n",
  "GRANGE": "a farmhouse [n -S]\n",
  "GRANGER": "a farm steward [n -S]\n",
  "GRANGERISATION": "the process of grangerising, also GRANGERIZATION [n -S]\n",
  "GRANGERISATIONS": "GRANGERISATION, the process of grangerising, also GRANGERIZATION [n]\n",
  "GRANGERISE": "to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERIZE [v GRANGERISED, GRANGERISING, GRANGERISES]\n",
  "GRANGERISED": "GRANGERISE, to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERIZE [v]\n",
  "GRANGERISER": "one who grangerises, also GRANGERIZER [n -S]\n",
  "GRANGERISERS": "GRANGERISER, one who grangerises, also GRANGERIZER [n]\n",
  "GRANGERISES": "GRANGERISE, to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERIZE [v]\n",
  "GRANGERISING": "GRANGERISE, to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERIZE [v]\n",
  "GRANGERISM": "the practice of illustrating a particular book by engravings collected from other books [n -S]\n",
  "GRANGERISMS": "GRANGERISM, the practice of illustrating a particular book by engravings collected from other books [n]\n",
  "GRANGERIZATION": "the process of grangerizing, also GRANGERISATION [n -S]\n",
  "GRANGERIZATIONS": "GRANGERIZATION, the process of grangerizing, also GRANGERISATION [n]\n",
  "GRANGERIZE": "to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERISE [v GRANGERIZED, GRANGERIZING, GRANGERIZES]\n",
  "GRANGERIZED": "GRANGERIZE, to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERISE [v]\n",
  "GRANGERIZER": "one who grangerizes, also GRANGERISER [n -S]\n",
  "GRANGERIZERS": "GRANGERIZER, one who grangerizes, also GRANGERISER [n]\n",
  "GRANGERIZES": "GRANGERIZE, to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERISE [v]\n",
  "GRANGERIZING": "GRANGERIZE, to illustrate a book with illustrations from other books; to mutilate a book by stealing its illustrations, also GRANGERISE [v]\n",
  "GRANGERS": "GRANGER, a farm steward [n]\n",
  "GRANGES": "GRANGE, a farmhouse [n]\n",
  "GRANITA": "(Italian) an ice confection typically made from fruit [n -S]\n",
  "GRANITAS": "GRANITA, (Italian) an ice confection typically made from fruit [n]\n",
  "GRANITE": "a highly felsic igneous rock [n -S]\n",
  "GRANITELIKE": "like granite [adj]\n",
  "GRANITES": "GRANITE, a highly felsic igneous rock [n]\n",
  "GRANITEWARE": "goods made from granite [n -S]\n",
  "GRANITEWARES": "GRANITEWARE, goods made from granite [n]\n",
  "GRANITIC": "containing granite [adj]\n",
  "GRANITIFICATION": "the process of turning into granite [n]\n",
  "GRANITIFORM": "having the form of granite [adj]\n",
  "GRANITISATION": "a metamorphic process by which solid rock is converted into granite without passing through a magmatic stage, also GRANITIZATION [n -S]\n",
  "GRANITISATIONS": "GRANITISATION, a metamorphic process by which solid rock is converted into granite without passing through a magmatic stage, also GRANITIZATION [n]\n",
  "GRANITISE": "to make like granite, also GRANITIZE [v GRANITISED, GRANITISING, GRANITISES]\n",
  "GRANITISED": "GRANITISE, to make like granite, also GRANITIZE [v]\n",
  "GRANITISES": "GRANITISE, to make like granite, also GRANITIZE [v]\n",
  "GRANITISING": "GRANITISE, to make like granite, also GRANITIZE [v]\n",
  "GRANITITE": "biotite granite [n -S]\n",
  "GRANITITES": "GRANITITE, biotite granite [n]\n",
  "GRANITIZATION": "a metamorphic process by which solid rock is converted into granite without passing through a magmatic stage, also GRANITISATION [n -S]\n",
  "GRANITIZATIONS": "GRANITIZATION, a metamorphic process by which solid rock is converted into granite without passing through a magmatic stage, also GRANITISATION [n]\n",
  "GRANITIZE": "to make like granite, also GRANITISE [v GRANITIZED, GRANITIZING, GRANITIZES]\n",
  "GRANITIZED": "GRANITIZE, to make like granite, also GRANITISE [v]\n",
  "GRANITIZES": "GRANITIZE, to make like granite, also GRANITISE [v]\n",
  "GRANITIZING": "GRANITIZE, to make like granite, also GRANITISE [v]\n",
  "GRANITOID": "a variety of coarse grained plutonic rock similar to granite which mineralogically is composed predominantly of feldspar and quartz [n -S]\n",
  "GRANITOIDS": "GRANITOID, a variety of coarse grained plutonic rock similar to granite which mineralogically is composed predominantly of feldspar and quartz [n]\n",
  "GRANIVORE": "an eater of grain [n -S]\n",
  "GRANIVORES": "GRANIVORE, an eater of grain [n]\n",
  "GRANIVOROUS": "feeding on seeds [adj]\n",
  "GRANNAM": "(archaic) a grandmother, also GRANDAM, GRANDAME [n -S]\n",
  "GRANNAMS": "GRANNAM, (archaic) a grandmother, also GRANDAM, GRANDAME [n]\n",
  "GRANNIE": "to defeat totally, also GRANNY [v GRANNIED, GRANNIEING or GRANNYING, GRANNIES]\n",
  "GRANNIED": "GRANNIE, to defeat totally, also GRANNY [v]\n",
  "GRANNIEING": "GRANNIE, to defeat totally, also GRANNY [v]\n",
  "GRANNIES": "GRANNIE, to defeat totally, also GRANNY [v]\n",
  "GRANNOM": "a type of caddis fly used in angling [n -S]\n",
  "GRANNOMS": "GRANNOM, a type of caddis fly used in angling [n]\n",
  "GRANNY": "to defeat totally [v GRANNIED, GRANNYING, GRANNIES]\n",
  "GRANNYING": "GRANNY, to defeat totally [v]\n",
  "GRANNYISH": "like a granny [adj]\n",
  "GRANODIORITE": "an igneous plutonic rock, less felsic than granite [n -S]\n",
  "GRANODIORITES": "GRANODIORITE, an igneous plutonic rock, less felsic than granite [n]\n",
  "GRANODIORITIC": "relating to granodiorite [adj]\n",
  "GRANOLA": "(tradename) a type of crunchy breakfast cereal made with mixed grain, oats, dried fruit, nuts, etc., and honey or brown sugar [n -S]\n",
  "GRANOLAS": "GRANOLA, (tradename) a type of crunchy breakfast cereal made with mixed grain, oats, dried fruit, nuts, etc., and honey or brown sugar [n]\n",
  "GRANOLITH": "a paving material consisting of a mixture of cement and crushed granite or granite chippings [n -S]\n",
  "GRANOLITHIC": "a stone composed of cement and granite chips [n -S]\n",
  "GRANOLITHICS": "GRANOLITHIC, a stone composed of cement and granite chips [n]\n",
  "GRANOLITHS": "GRANOLITH, a paving material consisting of a mixture of cement and crushed granite or granite chippings [n]\n",
  "GRANOPHYRE": "a kind of quartz-porphyry [n -S]\n",
  "GRANOPHYRES": "GRANOPHYRE, a kind of quartz-porphyry [n]\n",
  "GRANOPHYRIC": "of or like a granophyre [adj]\n",
  "GRANS": "GRAN, (short for) a grandmother [n]\n",
  "GRANT": "to bestow upon [v -ED, -ING, -S]\n",
  "GRANTABLE": "capable of being granted [adj]\n",
  "GRANTED": "GRANT, to bestow upon [v]\n",
  "GRANTEE": "one to whom something is granted [n -S]\n",
  "GRANTEES": "GRANTEE, one to whom something is granted [n]\n",
  "GRANTER": "the person by whom a grant or conveyance is made, also GRANTOR [n -S]\n",
  "GRANTERS": "GRANTER, the person by whom a grant or conveyance is made, also GRANTOR [n]\n",
  "GRANTING": "GRANT, to bestow upon [v]\n",
  "GRANTOR": "the person by whom a grant or conveyance is made, also GRANTER [n -S]\n",
  "GRANTORS": "GRANTOR, the person by whom a grant or conveyance is made, also GRANTER [n]\n",
  "GRANTS": "GRANT, to bestow upon [v]\n",
  "GRANTSMAN": "a specialist in grantsmanship, the art of obtaining grants for research [n GRANTSMEN]\n",
  "GRANTSMANSHIP": "the art of obtaining grants for research [n -S]\n",
  "GRANTSMANSHIPS": "GRANTSMANSHIP, the art of obtaining grants for research [n]\n",
  "GRANTSMEN": "GRANTSMAN, a specialist in grantsmanship, the art of obtaining grants for research [n]\n",
  "GRANULAR": "consisting of or like grains or granules, also GRANULARY [adj GRANULARLY]\n",
  "GRANULARITIES": "GRANULARITY, the state of being granular [n]\n",
  "GRANULARITY": "the state of being granular [n GRANULARITIES]\n",
  "GRANULARLY": "GRANULAR, consisting of or like grains or granules, also GRANULARY [adv]\n",
  "GRANULARY": "(archaic) granular, also GRANULAR [adj]\n",
  "GRANULATE": "to form or break into grains or small masses [v GRANULATED, GRANULATING, GRANULATES]\n",
  "GRANULATED": "GRANULATE, to form or break into grains or small masses [v]\n",
  "GRANULATER": "something that granulates, also GRANULATOR [n -S]\n",
  "GRANULATERS": "GRANULATER, something that granulates, also GRANULATOR [n]\n",
  "GRANULATES": "GRANULATE, to form or break into grains or small masses [v]\n",
  "GRANULATING": "GRANULATE, to form or break into grains or small masses [v]\n",
  "GRANULATION": "the act of granulating [n -S]\n",
  "GRANULATIONS": "GRANULATION, the act of granulating [n]\n",
  "GRANULATIVE": "related to granulation [adj]\n",
  "GRANULATOR": "something that granulates, also GRANULATER [n -S]\n",
  "GRANULATORS": "GRANULATOR, something that granulates, also GRANULATER [n]\n",
  "GRANULE": "a little grain [n -S]\n",
  "GRANULES": "GRANULE, a little grain [n]\n",
  "GRANULIFEROUS": "bearing granules [adj]\n",
  "GRANULIFORM": "having the form of a granule [adj]\n",
  "GRANULITE": "a whitish, granular rock, consisting of feldspar and quartz intimately mixed [n -S]\n",
  "GRANULITES": "GRANULITE, a whitish, granular rock, consisting of feldspar and quartz intimately mixed [n]\n",
  "GRANULITIC": "of the texture of granite [adj]\n",
  "GRANULITISATION": "the reduction of the components of a rock to crystalline grains by regional metamorphism, also GRANULITIZATION [n]\n",
  "GRANULITIZATION": "the reduction of the components of a rock to crystalline grains by regional metamorphism, also GRANULITISATION [n]\n",
  "GRANULOCYTE": "a kind of white blood cell [n -S]\n",
  "GRANULOCYTES": "GRANULOCYTE, a kind of white blood cell [n]\n",
  "GRANULOCYTIC": "of or like a granulocyte, a kind of white blood cell [adj]\n",
  "GRANULOMA": "a localized collection of granulation tissue [n GRANULOMAS or GRANULOMATA]\n",
  "GRANULOMAS": "GRANULOMA, a localized collection of granulation tissue [n]\n",
  "GRANULOMATA": "GRANULOMA, a localized collection of granulation tissue [n]\n",
  "GRANULOMATOUS": "of or like a granuloma, a localized collection of granulation tissue [adj]\n",
  "GRANULOSE": "consisting of or like grains or granules, also GRANULOUS [adj]\n",
  "GRANULOSES": "GRANULOSIS, any of numerous diseases of insect larvae marked by minute granular inclusions in infected cells and caused by viruses [n]\n",
  "GRANULOSIS": "any of numerous diseases of insect larvae marked by minute granular inclusions in infected cells and caused by viruses [n GRANULOSES]\n",
  "GRANULOUS": "consisting of or like grains or granules, also GRANULOSE [adj]\n",
  "GRANUM": "(Latin) a part of a plant chloroplast [n GRANA or GRANUMS]\n",
  "GRANUMS": "GRANUM, (Latin) a part of a plant chloroplast [n]\n",
  "GRAPE": "(Scots) to grope [v GRAPED, GRAPING, GRAPES]\n",
  "GRAPED": "GRAPE, (Scots) to grope [v]\n",
  "GRAPEFRUIT": "a large, round, yellow-skinned citrus fruit, so called because it grows in large bunches like grapes [n -S]\n",
  "GRAPEFRUITS": "GRAPEFRUIT, a large, round, yellow-skinned citrus fruit, so called because it grows in large bunches like grapes [n]\n",
  "GRAPELESS": "wanting grapes or the flavor of grapes [adj]\n",
  "GRAPELICE": "GRAPELOUSE, an insect of the genus Phylloxera, that attacks vines [n]\n",
  "GRAPELIKE": "like a grape [adj]\n",
  "GRAPELOUSE": "an insect of the genus Phylloxera, that attacks vines [n GRAPELICE]\n",
  "GRAPERIES": "GRAPERY, a building or inclosure used for the cultivation of grapes [n]\n",
  "GRAPERY": "a building or inclosure used for the cultivation of grapes [n GRAPERIES]\n",
  "GRAPES": "GRAPE, (Scots) to grope [v]\n",
  "GRAPESEED": "the seed of the vine [n -S]\n",
  "GRAPESEEDS": "GRAPESEED, the seed of the vine [n]\n",
  "GRAPESHOT": "clustered iron shot that scatters when fired [n -S]\n",
  "GRAPESHOTS": "GRAPESHOT, clustered iron shot that scatters when fired [n]\n",
  "GRAPESTONE": "a seed of the grape [n -S]\n",
  "GRAPESTONES": "GRAPESTONE, a seed of the grape [n]\n",
  "GRAPETREE": "a tropical American tree [n -S]\n",
  "GRAPETREES": "GRAPETREE, a tropical American tree [n]\n",
  "GRAPEVINE": "a grape-bearing vine [n -S]\n",
  "GRAPEVINES": "GRAPEVINE, a grape-bearing vine [n]\n",
  "GRAPEY": "resembling grapes, also GRAPY [adj GRAPIER, GRAPIEST]\n",
  "GRAPH": "to represent by a diagram [v -ED, -ING, -S]\n",
  "GRAPHED": "GRAPH, to represent by a diagram [v]\n",
  "GRAPHEME": "a unit of a writing system [n -S]\n",
  "GRAPHEMES": "GRAPHEME, a unit of a writing system [n]\n",
  "GRAPHEMIC": "of or like a grapheme, a letter of the alphabet [adj GRAPHEMICALLY]\n",
  "GRAPHEMICALLY": "GRAPHEMIC, of or like a grapheme, a letter of the alphabet [adv]\n",
  "GRAPHEMICS": "the study of systems of representing speech in writing [n]\n",
  "GRAPHENE": "a film of graphite with a thickness of one atom [n -S]\n",
  "GRAPHENES": "GRAPHENE, a film of graphite with a thickness of one atom [n]\n",
  "GRAPHIC": "of or pertaining to the arts of painting and drawing, also GRAPHICAL [adj GRAPHICLY or GRAPHICALLY] / a painting or drawing [n -S]\n",
  "GRAPHICACIES": "GRAPHICACY, accurate understanding and use of visual information [n]\n",
  "GRAPHICACY": "accurate understanding and use of visual information [n GRAPHICACIES]\n",
  "GRAPHICAL": "of or pertaining to the arts of painting and drawing, also GRAPHIC [adj GRAPHICALLY]\n",
  "GRAPHICALLY": "GRAPHICAL, of or pertaining to the arts of painting and drawing, also GRAPHIC [adv]\n",
  "GRAPHICALNESS": "GRAPHICAL, of or pertaining to the arts of painting and drawing, also GRAPHIC [n]\n",
  "GRAPHICALNESSES": "GRAPHICALNESS, GRAPHICAL, of or pertaining to the arts of painting and drawing, also GRAPHIC [n]\n",
  "GRAPHICLY": "GRAPHIC, of or pertaining to the arts of painting and drawing, also GRAPHICAL [adv]\n",
  "GRAPHICNESS": "the state of being graphic, also GRAPHICALNESS [n -ES]\n",
  "GRAPHICNESSES": "GRAPHICNESS, the state of being graphic, also GRAPHICALNESS [n]\n",
  "GRAPHICS": "GRAPHIC, a painting or drawing [n]\n",
  "GRAPHING": "GRAPH, to represent by a diagram [v]\n",
  "GRAPHITE": "a soft variety of carbon [n -S]\n",
  "GRAPHITES": "GRAPHITE, a soft variety of carbon [n]\n",
  "GRAPHITIC": "pertaining to graphite [adj]\n",
  "GRAPHITISABLE": "capable of being graphitised, converted into graphite, also GRAPHITIZABLE [adj]\n",
  "GRAPHITISATION": "the act of graphitising, also GRAPHITIZATION [n -S]\n",
  "GRAPHITISATIONS": "GRAPHITISATION, the act of graphitising, also GRAPHITIZATION [n]\n",
  "GRAPHITISE": "to convert wholly or partly into graphite, also GRAPHITIZE [v GRAPHITISED, GRAPHITISING, GRAPHITISES]\n",
  "GRAPHITISED": "GRAPHITISE, to convert wholly or partly into graphite, also GRAPHITIZE [v]\n",
  "GRAPHITISES": "GRAPHITISE, to convert wholly or partly into graphite, also GRAPHITIZE [v]\n",
  "GRAPHITISING": "GRAPHITISE, to convert wholly or partly into graphite, also GRAPHITIZE [v]\n",
  "GRAPHITIZABLE": "capable of being graphitized, also GRAPHITISABLE [adj]\n",
  "GRAPHITIZATION": "the act of graphitizing, also GRAPHITISATION [n -S]\n",
  "GRAPHITIZATIONS": "GRAPHITIZATION, the act of graphitizing, also GRAPHITISATION [n]\n",
  "GRAPHITIZE": "to convert wholly or partly into graphite, also GRAPHITISE [v GRAPHITIZED, GRAPHITIZING, GRAPHITIZES]\n",
  "GRAPHITIZED": "GRAPHITIZE, to convert wholly or partly into graphite, also GRAPHITISE [v]\n",
  "GRAPHITIZES": "GRAPHITIZE, to convert wholly or partly into graphite, also GRAPHITISE [v]\n",
  "GRAPHITIZING": "GRAPHITIZE, to convert wholly or partly into graphite, also GRAPHITISE [v]\n",
  "GRAPHITOID": "of or like graphite [adj]\n",
  "GRAPHIUM": "(Latin) a stylus [n -S]\n",
  "GRAPHIUMS": "GRAPHIUM, (Latin) a stylus [n]\n",
  "GRAPHOLECT": "a standard written language [n -S]\n",
  "GRAPHOLECTS": "GRAPHOLECT, a standard written language [n]\n",
  "GRAPHOLOGIC": "related to graphology, also GRAPHOLOGICAL [adj]\n",
  "GRAPHOLOGICAL": "related to graphology, also GRAPHOLOGIC [adj]\n",
  "GRAPHOLOGIES": "GRAPHOLOGY, the study of handwriting [n]\n",
  "GRAPHOLOGIST": "a specialist in graphology [n -S]\n",
  "GRAPHOLOGISTS": "GRAPHOLOGIST, a specialist in graphology [n]\n",
  "GRAPHOLOGY": "the study of handwriting [n GRAPHOLOGIES]\n",
  "GRAPHOMANIA": "an obsession with writing [n -S]\n",
  "GRAPHOMANIAS": "GRAPHOMANIA, an obsession with writing [n]\n",
  "GRAPHOMOTOR": "pertaining to the muscular movements in writing [adj]\n",
  "GRAPHOPHOBIA": "fear of writing [n -S]\n",
  "GRAPHOPHOBIAS": "GRAPHOPHOBIA, fear of writing [n]\n",
  "GRAPHS": "GRAPH, to represent by a diagram [v]\n",
  "GRAPIER": "GRAPY, resembling grapes, also GRAPEY [adj]\n",
  "GRAPIEST": "GRAPY, resembling grapes, also GRAPEY [adj]\n",
  "GRAPINESS": "the quality of being grapelike [n -ES]\n",
  "GRAPINESSES": "GRAPINESS, the quality of being grapelike [n]\n",
  "GRAPING": "GRAPE, (Scots) to grope [v]\n",
  "GRAPLE": "(Spenser) a grapple, also CRAPLE [n -S]\n",
  "GRAPLEMENT": "(Spenser) a close fight [n -S]\n",
  "GRAPLEMENTS": "GRAPLEMENT, (Spenser) a close fight [n]\n",
  "GRAPLES": "GRAPLE, (Spenser) a grapple, also CRAPLE [n]\n",
  "GRAPLIN": "a type of anchor, also GRAPLINE [n -S]\n",
  "GRAPLINE": "a type of anchor, also GRAPLIN [n -S]\n",
  "GRAPLINES": "GRAPLINE, a type of anchor, also GRAPLIN [n]\n",
  "GRAPLINS": "GRAPLIN, a type of anchor, also GRAPLINE [n]\n",
  "GRAPNEL": "a small anchor used for dragging or grappling [n -S]\n",
  "GRAPNELS": "GRAPNEL, a small anchor used for dragging or grappling [n]\n",
  "GRAPPA": "(Italian) an Italian brandy [n -S]\n",
  "GRAPPAS": "GRAPPA, (Italian) an Italian brandy [n]\n",
  "GRAPPLE": "to struggle or contend [v GRAPPLED, GRAPPLING, GRAPPLES]\n",
  "GRAPPLED": "GRAPPLE, to struggle or contend [v]\n",
  "GRAPPLER": "one who grapples [n -S]\n",
  "GRAPPLERS": "GRAPPLER, one who grapples [n]\n",
  "GRAPPLES": "GRAPPLE, to struggle or contend [v]\n",
  "GRAPPLING": "the act of seizing hold of [n -S]\n",
  "GRAPPLINGS": "GRAPPLING, the act of seizing hold of [n]\n",
  "GRAPTOLITE": "a characteristic Silurian fossil with an appearance almost like writing upon shales [n -S]\n",
  "GRAPTOLITES": "GRAPTOLITE, a characteristic Silurian fossil with an appearance almost like writing upon shales [n]\n",
  "GRAPTOLITIC": "related to a graptolite [adj]\n",
  "GRAPY": "resembling grapes, also GRAPEY [adj GRAPIER, GRAPIEST]\n",
  "GRASP": "to seize firmly with the hand [v -ED, -ING, -S]\n",
  "GRASPABLE": "capable of being grasped [adj]\n",
  "GRASPED": "GRASP, to seize firmly with the hand [v]\n",
  "GRASPER": "one who grasps [n -S]\n",
  "GRASPERS": "GRASPER, one who grasps [n]\n",
  "GRASPING": "GRASP, to seize firmly with the hand [v]\n",
  "GRASPINGLY": "GRASPING, GRASP, to seize firmly with the hand [adv]\n",
  "GRASPINGNESS": "the state of being grasping [n -ES]\n",
  "GRASPINGNESSES": "GRASPINGNESS, the state of being grasping [n]\n",
  "GRASPLESS": "without a grasp; relaxed [adj]\n",
  "GRASPS": "GRASP, to seize firmly with the hand [v]\n",
  "GRASS": "to cover with grass (herbaceous plants) [v -ED, -ING, -ES]\n",
  "GRASSBIRD": "an Australasian warbler with streaked brown plumage [n -S]\n",
  "GRASSBIRDS": "GRASSBIRD, an Australasian warbler with streaked brown plumage [n]\n",
  "GRASSED": "GRASS, to cover with grass (herbaceous plants) [v]\n",
  "GRASSER": "(slang) a grass, an informer [n -S]\n",
  "GRASSERS": "GRASSER, (slang) a grass, an informer [n]\n",
  "GRASSES": "GRASS, to cover with grass (herbaceous plants) [v]\n",
  "GRASSFINCH": "an Australian weaverbird, brightly coloured and kept as a cage-bird [n -ES]\n",
  "GRASSFINCHES": "GRASSFINCH, an Australian weaverbird, brightly coloured and kept as a cage-bird [n]\n",
  "GRASSHOOK": "a sickle; a kind of tropical finch [n -S]\n",
  "GRASSHOOKS": "GRASSHOOK, a sickle; a kind of tropical finch [n]\n",
  "GRASSHOPPER": "a name for various herbivorous jumping insects of the order Orthoptera, related to locusts and crickets, that chirp by rubbing their wing-covers [n -S]\n",
  "GRASSHOPPERS": "GRASSHOPPER, a name for various herbivorous jumping insects of the order Orthoptera, related to locusts and crickets, that chirp by rubbing their wing-covers [n]\n",
  "GRASSIER": "GRASSY, resembling or pertaining to grass [adj]\n",
  "GRASSIEST": "GRASSY, resembling or pertaining to grass [adj]\n",
  "GRASSILY": "GRASSY, resembling or pertaining to grass [adv]\n",
  "GRASSINESS": "the state of being grassy [n -ES]\n",
  "GRASSINESSES": "GRASSINESS, the state of being grassy [n]\n",
  "GRASSING": "placing on grass to bleach [n -S]\n",
  "GRASSINGS": "GRASSING, placing on grass to bleach [n]\n",
  "GRASSLAND": "a habitat dominated by grass [n -S]\n",
  "GRASSLANDS": "GRASSLAND, a habitat dominated by grass [n]\n",
  "GRASSLESS": "destitute of grass [adj]\n",
  "GRASSLIKE": "like grass [adj]\n",
  "GRASSPLOT": "a plot of ground overgrown with grass [n -S]\n",
  "GRASSPLOTS": "GRASSPLOT, a plot of ground overgrown with grass [n]\n",
  "GRASSQUIT": "a tropical American finch [n -S]\n",
  "GRASSQUITS": "GRASSQUIT, a tropical American finch [n]\n",
  "GRASSROOT": "relating to the ordinary people, the rank and file [n -S]\n",
  "GRASSROOTS": "GRASSROOT, relating to the ordinary people, the rank and file [n]\n",
  "GRASSUM": "in Scots law, a lump sum paid in addition to rent by a person taking a lease of landed property [n -S]\n",
  "GRASSUMS": "GRASSUM, in Scots law, a lump sum paid in addition to rent by a person taking a lease of landed property [n]\n",
  "GRASSWRACK": "eelgrass [n -S]\n",
  "GRASSWRACKS": "GRASSWRACK, eelgrass [n]\n",
  "GRASSY": "resembling or pertaining to grass [adj GRASSIER, GRASSIEST, GRASSILY]\n",
  "GRASTE": "GRACE, to give beauty to [v]\n",
  "GRAT": "GREET, to address in a friendly and courteous way [v]\n",
  "GRATE": "to reduce to shreds by rubbing [v GRATED, GRATING, GRATES]\n",
  "GRATED": "GRATE, to reduce to shreds by rubbing [v]\n",
  "GRATEFUL": "deeply thankful [adj GRATEFULLER, GRATEFULLEST, GRATEFULLY]\n",
  "GRATEFULLER": "GRATEFUL, deeply thankful [adj]\n",
  "GRATEFULLEST": "GRATEFUL, deeply thankful [adj]\n",
  "GRATEFULLY": "GRATEFUL, deeply thankful [adv]\n",
  "GRATEFULNESS": "the state of being grateful [n -ES]\n",
  "GRATEFULNESSES": "GRATEFULNESS, the state of being grateful [n]\n",
  "GRATELESS": "without a grate [adj]\n",
  "GRATER": "one that grates [n -S]\n",
  "GRATERS": "GRATER, one that grates [n]\n",
  "GRATES": "GRATE, to reduce to shreds by rubbing [v]\n",
  "GRATICULATION": "division of design into squares when scaling [n -S]\n",
  "GRATICULATIONS": "GRATICULATION, division of design into squares when scaling [n]\n",
  "GRATICULE": "a design or draught which has been divided into squares, in order to reproduce it in other dimensions [n -S]\n",
  "GRATICULES": "GRATICULE, a design or draught which has been divided into squares, in order to reproduce it in other dimensions [n]\n",
  "GRATIFICATION": "the act of gratifying [n -S]\n",
  "GRATIFICATIONS": "GRATIFICATION, the act of gratifying [n]\n",
  "GRATIFIED": "GRATIFY, to satisfy [v]\n",
  "GRATIFIER": "one who gratifies [n -S]\n",
  "GRATIFIERS": "GRATIFIER, one who gratifies [n]\n",
  "GRATIFIES": "GRATIFY, to satisfy [v]\n",
  "GRATIFY": "to satisfy [v GRATIFIED, GRATIFYING, GRATIFIES]\n",
  "GRATIFYING": "GRATIFY, to satisfy [v]\n",
  "GRATIFYINGLY": "GRATIFYING, GRATIFY, to satisfy [adv]\n",
  "GRATILLITIES": "GRATILLITY, (Shakespeare) a small gratuity [n]\n",
  "GRATILLITY": "(Shakespeare) a small gratuity [n GRATILLITIES]\n",
  "GRATIN": "(French) the golden-brown crust covering a gratinated food or dish [n -S]\n",
  "GRATINATE": "to cook with a topping of buttered breadcrumbs [v GRATINATED, GRATINATING, GRATINATES]\n",
  "GRATINATED": "GRATINATE, to cook with a topping of buttered breadcrumbs [v]\n",
  "GRATINATES": "GRATINATE, to cook with a topping of buttered breadcrumbs [v]\n",
  "GRATINATING": "GRATINATE, to cook with a topping of buttered breadcrumbs [v]\n",
  "GRATINE": "(French) cooked or served au gratin, also GRATINEE [adj]\n",
  "GRATINEE": "(French) to cook or serve au gratin [v GRATINEED, GRATINEEING, GRATINEES]\n",
  "GRATINEED": "GRATINEE, (French) to cook or serve au gratin [v]\n",
  "GRATINEEING": "GRATINEE, (French) to cook or serve au gratin [v]\n",
  "GRATINEES": "GRATINEE, (French) to cook or serve au gratin [v]\n",
  "GRATING": "rasping [adj GRATINGLY] / a network of bars covering an opening [n -S]\n",
  "GRATINGLY": "GRATING, rasping [adv]\n",
  "GRATINGS": "GRATING, a network of bars covering an opening [n]\n",
  "GRATINS": "GRATIN, (French) the golden-brown crust covering a gratinated food or dish [n]\n",
  "GRATIS": "(Latin) free of charge [adj]\n",
  "GRATITUDE": "the state of being grateful [n -S]\n",
  "GRATITUDES": "GRATITUDE, the state of being grateful [n]\n",
  "GRATTOIR": "(French) a scraper made of flint [n -S]\n",
  "GRATTOIRS": "GRATTOIR, (French) a scraper made of flint [n]\n",
  "GRATUITIES": "GRATUITY, a gift of money [n]\n",
  "GRATUITOUS": "done freely; needless [adj GRATUITOUSLY]\n",
  "GRATUITOUSLY": "GRATUITOUS, done freely; needless [adv]\n",
  "GRATUITOUSNESS": "GRATUITOUS, done freely; needless [n]\n",
  "GRATUITY": "a gift of money [n GRATUITIES]\n",
  "GRATULANT": "expressing joy or satisfaction; congratulatory [adj]\n",
  "GRATULATE": "(archaic) to congratulate [v GRATULATED, GRATULATING, GRATULATES]\n",
  "GRATULATED": "GRATULATE, (archaic) to congratulate [v]\n",
  "GRATULATES": "GRATULATE, (archaic) to congratulate [v]\n",
  "GRATULATING": "GRATULATE, (archaic) to congratulate [v]\n",
  "GRATULATION": "congratulation [n -S]\n",
  "GRATULATIONS": "GRATULATION, congratulation [n]\n",
  "GRATULATORY": "congratulatory [adj]\n",
  "GRAUNCH": "(New Zealand) to crush or destroy [v GRAUNCHED, GRAUNCHING, GRAUNCHES]\n",
  "GRAUNCHED": "GRAUNCH, (New Zealand) to crush or destroy [v]\n",
  "GRAUNCHER": "(New Zealand) a clumsy and incompetent mechanic [n -S]\n",
  "GRAUNCHERS": "GRAUNCHER, (New Zealand) a clumsy and incompetent mechanic [n]\n",
  "GRAUNCHES": "GRAUNCH, (New Zealand) to crush or destroy [v]\n",
  "GRAUNCHING": "GRAUNCH, (New Zealand) to crush or destroy [v]\n",
  "GRAUPEL": "(German) precipitation consisting of granular snow pellets [n -S]\n",
  "GRAUPELS": "GRAUPEL, (German) precipitation consisting of granular snow pellets [n]\n",
  "GRAV": "a unit of acceleration [n -S]\n",
  "GRAVADLAX": "(Swedish) a Scandinavian dish of salmon with spices and salad, also GRAVLAKS, GRAVLAX [n -ES]\n",
  "GRAVADLAXES": "GRAVADLAX, (Swedish) a Scandinavian dish of salmon with spices and salad, also GRAVLAKS, GRAVLAX [n]\n",
  "GRAVAMEN": "(Latin) the most serious part of an accusation [n GRAVAMENS or GRAVAMINA]\n",
  "GRAVAMENS": "GRAVAMEN, (Latin) the most serious part of an accusation [n]\n",
  "GRAVAMINA": "GRAVAMEN, (Latin) the most serious part of an accusation [n]\n",
  "GRAVE": "to engrave [v GRAVED, GRAVEN, GRAVING, GRAVES] / extremely serious [adj GRAVER, GRAVEST, GRAVELY]\n",
  "GRAVED": "GRAVE, to engrave [v]\n",
  "GRAVEDIGGER": "one who digs graves [n -S]\n",
  "GRAVEDIGGERS": "GRAVEDIGGER, one who digs graves [n]\n",
  "GRAVEL": "to pave with gravel (rock fragments) [v GRAVELED or GRAVELLED, GRAVELING or GRAVELLING, GRAVELS]\n",
  "GRAVELED": "GRAVEL, to pave with gravel (rock fragments) [v]\n",
  "GRAVELESS": "(Shakespeare) without a grave; unburied [adj]\n",
  "GRAVELIKE": "like a grave [adj]\n",
  "GRAVELING": "GRAVEL, to pave with gravel (rock fragments) [v]\n",
  "GRAVELISH": "like gravel [adj]\n",
  "GRAVELLED": "GRAVEL, to pave with gravel (rock fragments) [v]\n",
  "GRAVELLIER": "GRAVELLY, of or like gravel [adj]\n",
  "GRAVELLIEST": "GRAVELLY, of or like gravel [adj]\n",
  "GRAVELLING": "GRAVEL, to pave with gravel (rock fragments) [v]\n",
  "GRAVELLY": "of or like gravel [adj GRAVELLIER, GRAVELLIEST]\n",
  "GRAVELS": "GRAVEL, to pave with gravel (rock fragments) [v]\n",
  "GRAVELY": "GRAVE, extremely serious [adv]\n",
  "GRAVEN": "GRAVE, to engrave [v]\n",
  "GRAVENESS": "the state of being grave [n -ES]\n",
  "GRAVENESSES": "GRAVENESS, the state of being grave [n]\n",
  "GRAVEOLENT": "having a rank smell [adj]\n",
  "GRAVER": "an engraving tool, a burin [n -S]\n",
  "GRAVEROBBER": "one who robs graves [n -S]\n",
  "GRAVEROBBERS": "GRAVEROBBER, one who robs graves [n]\n",
  "GRAVERS": "GRAVER, an engraving tool, a burin [n]\n",
  "GRAVES": "GRAVE, to engrave [v]\n",
  "GRAVESIDE": "the area around a grave [n -S]\n",
  "GRAVESIDES": "GRAVESIDE, the area around a grave [n]\n",
  "GRAVESITE": "the site of a grave [n -S]\n",
  "GRAVESITES": "GRAVESITE, the site of a grave [n]\n",
  "GRAVEST": "GRAVE, extremely serious [adj]\n",
  "GRAVESTONE": "a burial monument [n -S]\n",
  "GRAVESTONES": "GRAVESTONE, a burial monument [n]\n",
  "GRAVEWARD": "in the direction of the grave [adv]\n",
  "GRAVEYARD": "a burial ground [n -S]\n",
  "GRAVEYARDS": "GRAVEYARD, a burial ground [n]\n",
  "GRAVID": "pregnant [adj GRAVIDLY]\n",
  "GRAVIDA": "(Latin) a pregnant woman [n GRAVIDAS or GRAVIDAE]\n",
  "GRAVIDAE": "GRAVIDA, (Latin) a pregnant woman [n]\n",
  "GRAVIDAS": "GRAVIDA, (Latin) a pregnant woman [n]\n",
  "GRAVIDITIES": "GRAVIDITY, the state of being gravid; pregnancy [n]\n",
  "GRAVIDITY": "the state of being gravid; pregnancy [n GRAVIDITIES]\n",
  "GRAVIDLY": "GRAVID, pregnant [adv]\n",
  "GRAVIDNESS": "the state of being gravid [n -ES]\n",
  "GRAVIDNESSES": "GRAVIDNESS, the state of being gravid [n]\n",
  "GRAVIES": "GRAVY, a sauce of the fat and juices from cooked meat [n]\n",
  "GRAVIMETER": "an instrument for measuring variations in gravitational fields [n -S]\n",
  "GRAVIMETERS": "GRAVIMETER, an instrument for measuring variations in gravitational fields [n]\n",
  "GRAVIMETRIC": "of or relating to measurement by weight, also GRAVIMETRICAL [adj GRAVIMETRICALLY]\n",
  "GRAVIMETRICAL": "of or relating to measurement by weight, also GRAVIMETRIC [adj GRAVIMETRICALLY]\n",
  "GRAVIMETRICALLY": "GRAVIMETRICAL, of or relating to measurement by weight, also GRAVIMETRIC [adv]\n",
  "GRAVIMETRIES": "GRAVIMETRY, the measurement of variations in gravity [n]\n",
  "GRAVIMETRY": "the measurement of variations in gravity [n GRAVIMETRIES]\n",
  "GRAVING": "an engraving [n -S]\n",
  "GRAVINGS": "GRAVING, an engraving [n]\n",
  "GRAVIPERCEPTION": "the perception of gravity by plants [n]\n",
  "GRAVIS": "(Latin) as in myasthenia gravis, a wasting disease [adj]\n",
  "GRAVITAS": "(Latin) reserved, dignified behaviour [n -ES]\n",
  "GRAVITASES": "GRAVITAS, (Latin) reserved, dignified behaviour [n]\n",
  "GRAVITATE": "to move under the influence of gravitation [v GRAVITATED, GRAVITATING, GRAVITATES]\n",
  "GRAVITATED": "GRAVITATE, to move under the influence of gravitation [v]\n",
  "GRAVITATER": "one who gravitates [n -S]\n",
  "GRAVITATERS": "GRAVITATER, one who gravitates [n]\n",
  "GRAVITATES": "GRAVITATE, to move under the influence of gravitation [v]\n",
  "GRAVITATING": "GRAVITATE, to move under the influence of gravitation [v]\n",
  "GRAVITATION": "the force of attraction between masses [n -S]\n",
  "GRAVITATIONAL": "relating to gravitation [adj GRAVITATIONALLY]\n",
  "GRAVITATIONALLY": "GRAVITATIONAL, relating to gravitation [adv]\n",
  "GRAVITATIONS": "GRAVITATION, the force of attraction between masses [n]\n",
  "GRAVITATIVE": "relating to gravitation [adj]\n",
  "GRAVITIES": "GRAVITY, the force of attraction toward the earth [n]\n",
  "GRAVITINO": "a hypothetical particle associated with the gravitational force [n -S]\n",
  "GRAVITINOS": "GRAVITINO, a hypothetical particle associated with the gravitational force [n]\n",
  "GRAVITOMETER": "an instrument for measuring specific gravities [n -S]\n",
  "GRAVITOMETERS": "GRAVITOMETER, an instrument for measuring specific gravities [n]\n",
  "GRAVITON": "a hypothetical particle carrying the gravitational force [n -S]\n",
  "GRAVITONS": "GRAVITON, a hypothetical particle carrying the gravitational force [n]\n",
  "GRAVITY": "the force of attraction toward the earth [n GRAVITIES]\n",
  "GRAVLAKS": "(Swedish) a Scandinavian dish of salmon with spices and salad, also GRAVADLAX, GRAVLAX [n GRAVLAKS]\n",
  "GRAVLAX": "(Swedish) a Scandinavian dish of salmon with spices and salad, also GRAVADLAX, GRAVLAKS [n -ES]\n",
  "GRAVLAXES": "GRAVLAX, (Swedish) a Scandinavian dish of salmon with spices and salad, also GRAVADLAX, GRAVLAKS [n]\n",
  "GRAVS": "GRAV, a unit of acceleration [n]\n",
  "GRAVURE": "any process of making an intaglio printing plate [n -S]\n",
  "GRAVURES": "GRAVURE, any process of making an intaglio printing plate [n]\n",
  "GRAVY": "a sauce of the fat and juices from cooked meat [n GRAVIES]\n",
  "GRAWLIX": "a series of typographical symbols (such as $#!) used in text as a replacement for profanity [n -ES]\n",
  "GRAWLIXES": "GRAWLIX, a series of typographical symbols (such as $#!) used in text as a replacement for profanity [n]\n",
  "GRAY": "between black and white, also GREY [adj GRAYER, GRAYEST, GRAYLY] / to make grey [v -ED, -ING, -S]\n",
  "GRAYBACK": "any of various animals having a grey back, such as the grey whale, also GREYBACK [n -S]\n",
  "GRAYBACKS": "GRAYBACK, any of various animals having a grey back, such as the grey whale, also GREYBACK [n]\n",
  "GRAYBEARD": "an old man, also GREYBEARD [n -S]\n",
  "GRAYBEARDED": "having a grey beard, also GREYBEARDED [adj]\n",
  "GRAYBEARDS": "GRAYBEARD, an old man, also GREYBEARD [n]\n",
  "GRAYED": "GRAY, to make grey [v]\n",
  "GRAYER": "GRAY, between black and white, also GREY [adj]\n",
  "GRAYEST": "GRAY, between black and white, also GREY [adj]\n",
  "GRAYFISH": "a dogfish [n -ES]\n",
  "GRAYFISHES": "GRAYFISH, a dogfish [n]\n",
  "GRAYFLIES": "GRAYFLY, (Milton) an unidentified insect [n]\n",
  "GRAYFLY": "(Milton) an unidentified insect [n GRAYFLIES]\n",
  "GRAYHEAD": "one with grey hair, also GREYHEAD [n -S]\n",
  "GRAYHEADED": "having gray hair, also GREYHEADED [adj]\n",
  "GRAYHEADS": "GRAYHEAD, one with grey hair, also GREYHEAD [n]\n",
  "GRAYHEN": "the female of the blackcock, also GREYHEN [n -S]\n",
  "GRAYHENS": "GRAYHEN, the female of the blackcock, also GREYHEN [n]\n",
  "GRAYHOUND": "a tall slender fast-moving dog of an ancient breed originally used for coursing, also GREYHOUND [n -S]\n",
  "GRAYHOUNDS": "GRAYHOUND, a tall slender fast-moving dog of an ancient breed originally used for coursing, also GREYHOUND [n]\n",
  "GRAYING": "GRAY, to make grey [v]\n",
  "GRAYISH": "somewhat gray, also GREYISH [adj]\n",
  "GRAYLAG": "a species of wild goose, also GREYLAG [n -S]\n",
  "GRAYLAGS": "GRAYLAG, a species of wild goose, also GREYLAG [n]\n",
  "GRAYLE": "(archaic) a dish, a platter, also GRAAL, GRAIL [n -S]\n",
  "GRAYLES": "GRAYLE, (archaic) a dish, a platter, also GRAAL, GRAIL [n]\n",
  "GRAYLING": "a European fish, allied to the trout [n -S]\n",
  "GRAYLINGS": "GRAYLING, a European fish, allied to the trout [n]\n",
  "GRAYLIST": "to hold (someone) in suspicion, without actually excluding him or her from a particular activity, also GREYLIST [v -ED, -ING, -S]\n",
  "GRAYLISTED": "GRAYLIST, to hold (someone) in suspicion, without actually excluding him or her from a particular activity, also GREYLIST [v]\n",
  "GRAYLISTING": "GRAYLIST, to hold (someone) in suspicion, without actually excluding him or her from a particular activity, also GREYLIST [v]\n",
  "GRAYLISTS": "GRAYLIST, to hold (someone) in suspicion, without actually excluding him or her from a particular activity, also GREYLIST [v]\n",
  "GRAYLY": "GRAY, between black and white, also GREY [adv]\n",
  "GRAYMAIL": "pressure on an official to reveal information [n -S]\n",
  "GRAYMAILS": "GRAYMAIL, pressure on an official to reveal information [n]\n",
  "GRAYNESS": "the state of being gray, also GREYNESS [n -ES]\n",
  "GRAYNESSES": "GRAYNESS, the state of being gray, also GREYNESS [n]\n",
  "GRAYOUT": "temporary blurring of vision [n -S]\n",
  "GRAYOUTS": "GRAYOUT, temporary blurring of vision [n]\n",
  "GRAYS": "GRAY, to make grey [v]\n",
  "GRAYSCALE": "in shades of grey, also GREYSCALE [adj]\n",
  "GRAYSTONE": "a grey igneous rock of volcanic origin, also GREYSTONE [n -S]\n",
  "GRAYSTONES": "GRAYSTONE, a grey igneous rock of volcanic origin, also GREYSTONE [n]\n",
  "GRAYWACKE": "any coarse-grained, usually dark sandstone containing angular mineral and rock fragments in a fine-grained clayey matrix, also GREYWACKE [n -S]\n",
  "GRAYWACKES": "GRAYWACKE, any coarse-grained, usually dark sandstone containing angular mineral and rock fragments in a fine-grained clayey matrix, also GREYWACKE [n]\n",
  "GRAYWATER": "water that has been used [n -S]\n",
  "GRAYWATERS": "GRAYWATER, water that has been used [n]\n",
  "GRAYWETHER": "a sandstone boulder of South England, also GREYWETHER [n -S]\n",
  "GRAYWETHERS": "GRAYWETHER, a sandstone boulder of South England, also GREYWETHER [n]\n",
  "GRAZABLE": "able to be grazed, also GRAZEABLE [adj]\n",
  "GRAZE": "to feed on growing grass [v GRAZED, GRAZING, GRAZES]\n",
  "GRAZEABLE": "that can be grazed, also GRAZABLE [adj]\n",
  "GRAZED": "GRAZE, to feed on growing grass [v]\n",
  "GRAZER": "an animal that grazes [n -S]\n",
  "GRAZERS": "GRAZER, an animal that grazes [n]\n",
  "GRAZES": "GRAZE, to feed on growing grass [v]\n",
  "GRAZIER": "one who pastures cattle, and rears them for market [n -S]\n",
  "GRAZIERS": "GRAZIER, one who pastures cattle, and rears them for market [n]\n",
  "GRAZING": "land used for feeding animals [n -S]\n",
  "GRAZINGLY": "GRAZING [adv]\n",
  "GRAZINGS": "GRAZING, land used for feeding animals [n]\n",
  "GRAZIOSO": "(Italian) gracefully; smoothly; elegantly [adv]\n",
  "GREASE": "to smear with grease (a lubricant) [v GREASED, GREASING, GREASES]\n",
  "GREASEBALL": "(offensive US slang) a person of Latin racial origin [n -S]\n",
  "GREASEBALLS": "GREASEBALL, (offensive US slang) a person of Latin racial origin [n]\n",
  "GREASEBAND": "a band put round the trunks of trees to stop infestation by parasites [n -S]\n",
  "GREASEBANDS": "GREASEBAND, a band put round the trunks of trees to stop infestation by parasites [n]\n",
  "GREASEBUSH": "a name for various oily American shrubs of the goosefoot family, also GREASEWOOD [n -ES]\n",
  "GREASEBUSHES": "GREASEBUSH, a name for various oily American shrubs of the goosefoot family, also GREASEWOOD [n]\n",
  "GREASED": "GREASE, to smear with grease (a lubricant) [v]\n",
  "GREASELESS": "without grease [adj]\n",
  "GREASEPAINT": "a melted tallow or grease used in theater makeup [n -S]\n",
  "GREASEPAINTS": "GREASEPAINT, a melted tallow or grease used in theater makeup [n]\n",
  "GREASEPROOF": "resistant or impermeable to grease [adj] / paper proof against grease [n -S]\n",
  "GREASEPROOFS": "GREASEPROOF, paper proof against grease [n]\n",
  "GREASER": "one who, or that which, greases; specifically, a person employed to lubricate the working parts of machinery, engines, carriages, etc. [n -S]\n",
  "GREASERS": "GREASER, one who, or that which, greases; specifically, a person employed to lubricate the working parts of machinery, engines, carriages, etc. [n]\n",
  "GREASES": "GREASE, to smear with grease (a lubricant) [v]\n",
  "GREASEWOOD": "a name for various oily American shrubs of the goosefoot family, also GREASEBUSH [n -S]\n",
  "GREASEWOODS": "GREASEWOOD, a name for various oily American shrubs of the goosefoot family, also GREASEBUSH [n]\n",
  "GREASIER": "GREASY, containing or resembling grease [adj]\n",
  "GREASIES": "GREASY, (Australian slang) a sheepshearer; a camp-cook in the outback [n]\n",
  "GREASIEST": "GREASY, containing or resembling grease [adj]\n",
  "GREASILY": "GREASY, containing or resembling grease [adv]\n",
  "GREASINESS": "the state of being greasy [n -ES]\n",
  "GREASINESSES": "GREASINESS, the state of being greasy [n]\n",
  "GREASING": "GREASE, to smear with grease (a lubricant) [v]\n",
  "GREASY": "containing or resembling grease [adj GREASIER, GREASIEST, GREASILY] / (Australian slang) a sheepshearer; a camp-cook in the outback [n GREASIES]\n",
  "GREAT": "a distinguished or outstanding person [n -S] / large, exalted [adj GREATER, GREATEST, GREATLY]\n",
  "GREATCOAT": "an overcoat [n -S]\n",
  "GREATCOATED": "wearing a greatcoat [adj]\n",
  "GREATCOATS": "GREATCOAT, an overcoat [n]\n",
  "GREATEN": "to make great [v -ED, -ING, -S]\n",
  "GREATENED": "GREATEN, to make great [v]\n",
  "GREATENING": "GREATEN, to make great [v]\n",
  "GREATENS": "GREATEN, to make great [v]\n",
  "GREATER": "GREAT, large, exalted [adj]\n",
  "GREATEST": "the greatest person in some field [n -S]\n",
  "GREATESTS": "GREATEST, the greatest person in some field [n]\n",
  "GREATHEARTED": "characterized by bravery [adj GREATHEARTEDLY]\n",
  "GREATHEARTEDLY": "GREATHEARTED, characterized by bravery [adv]\n",
  "GREATLY": "GREAT, large, exalted [adv]\n",
  "GREATNESS": "the state of being great [n -ES]\n",
  "GREATNESSES": "GREATNESS, the state of being great [n]\n",
  "GREATS": "GREAT, a distinguished or outstanding person [n]\n",
  "GREAVE": "to feel grief, also GRIEVE [v GREAVED, GREAVING, GREAVES]\n",
  "GREAVED": "GREAVE, to feel grief, also GRIEVE [v]\n",
  "GREAVES": "GREAVE, to feel grief, also GRIEVE [v]\n",
  "GREAVING": "GREAVE, to feel grief, also GRIEVE [v]\n",
  "GREBE": "a diving bird [n -S]\n",
  "GREBES": "GREBE, a diving bird [n]\n",
  "GREBO": "a devotee of heavy metal or grunge music, with unkempt hair and clothes, also GREEBO [n GREBOES or GREBOS]\n",
  "GREBOES": "GREBO, a devotee of heavy metal or grunge music, with unkempt hair and clothes, also GREEBO [n]\n",
  "GREBOS": "GREBO, a devotee of heavy metal or grunge music, with unkempt hair and clothes, also GREEBO [n]\n",
  "GRECE": "a flight of steps, also GREES, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIS, GRIZE [n -S]\n",
  "GRECES": "GRECE, a flight of steps, also GREES, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIS, GRIZE [n]\n",
  "GRECIAN": "a step, also GRECE, GREECE, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIZE [n -S]\n",
  "GRECIANISE": "to conform to the Greek custom, esp. in speech, also GRECIANIZE [v GRECIANISED, GRECIANISING, GRECIANISES]\n",
  "GRECIANISED": "GRECIANISE, to conform to the Greek custom, esp. in speech, also GRECIANIZE [v]\n",
  "GRECIANISES": "GRECIANISE, to conform to the Greek custom, esp. in speech, also GRECIANIZE [v]\n",
  "GRECIANISING": "GRECIANISE, to conform to the Greek custom, esp. in speech, also GRECIANIZE [v]\n",
  "GRECIANIZE": "to conform to the Greek custom, esp. in speech, also GRECIANISE [v GRECIANIZED, GRECIANIZING, GRECIANIZES]\n",
  "GRECIANIZED": "GRECIANIZE, to conform to the Greek custom, esp. in speech, also GRECIANISE [v]\n",
  "GRECIANIZES": "GRECIANIZE, to conform to the Greek custom, esp. in speech, also GRECIANISE [v]\n",
  "GRECIANIZING": "GRECIANIZE, to conform to the Greek custom, esp. in speech, also GRECIANISE [v]\n",
  "GRECIANS": "GRECIAN, a step, also GRECE, GREECE, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIZE [n]\n",
  "GRECISE": "to provide with a Greek style, also GRECIZE, GRAECIZE, GRAECISE [v GRECISED, GRECISING, GRECISES]\n",
  "GRECISED": "GRECISE, to provide with a Greek style, also GRECIZE, GRAECIZE, GRAECISE [v]\n",
  "GRECISES": "GRECISE, to provide with a Greek style, also GRECIZE, GRAECIZE, GRAECISE [v]\n",
  "GRECISING": "GRECISE, to provide with a Greek style, also GRECIZE, GRAECIZE, GRAECISE [v]\n",
  "GRECIZE": "to provide with a Greek style, also GRECISE, GRAECIZE, GRAECISE [v GRECIZED, GRECIZING, GRECIZES]\n",
  "GRECIZED": "GRECIZE, to provide with a Greek style, also GRECISE, GRAECIZE, GRAECISE [v]\n",
  "GRECIZES": "GRECIZE, to provide with a Greek style, also GRECISE, GRAECIZE, GRAECISE [v]\n",
  "GRECIZING": "GRECIZE, to provide with a Greek style, also GRECISE, GRAECIZE, GRAECISE [v]\n",
  "GRECQUE": "(French) a fret pattern in architecture [n -S]\n",
  "GRECQUES": "GRECQUE, (French) a fret pattern in architecture [n]\n",
  "GREE": "(archaic) to agree [v GREED, GREEING, GREES]\n",
  "GREEBO": "an unkempt young man, also GREBO [n GREEBOES or GREEBOS]\n",
  "GREEBOES": "GREEBO, an unkempt young man, also GREBO [n]\n",
  "GREEBOS": "GREEBO, an unkempt young man, also GREBO [n]\n",
  "GREECE": "a step, also GRECE, GRECIAN, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIZE [n -S]\n",
  "GREECES": "GREECE, a step, also GRECE, GRECIAN, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIZE [n]\n",
  "GREED": "excessive desire for gain or wealth [n -S]\n",
  "GREEDHEAD": "(Canadian) an avaricious person [n -S]\n",
  "GREEDHEADS": "GREEDHEAD, (Canadian) an avaricious person [n]\n",
  "GREEDIER": "GREEDY, marked by greed [adj]\n",
  "GREEDIEST": "GREEDY, marked by greed [adj]\n",
  "GREEDILY": "GREEDY, marked by greed [adv]\n",
  "GREEDINESS": "the state of being greedy [n -ES]\n",
  "GREEDINESSES": "GREEDINESS, the state of being greedy [n]\n",
  "GREEDLESS": "without greed [adj]\n",
  "GREEDS": "GREED, excessive desire for gain or wealth [n]\n",
  "GREEDSOME": "greedy [adj]\n",
  "GREEDY": "marked by greed [adj GREEDIER, GREEDIEST, GREEDILY]\n",
  "GREEGREE": "an African talisman or spell, also GRIGRI, GRISGRIS [n -S]\n",
  "GREEGREES": "GREEGREE, an African talisman or spell, also GRIGRI, GRISGRIS [n]\n",
  "GREEING": "GREE, (archaic) to agree [v]\n",
  "GREEK": "something unintelligible [n GREEK]\n",
  "GREEKED": "of text, represented by blotches [adj]\n",
  "GREEKING": "showing low resolution text as gibberish [n -S]\n",
  "GREEKINGS": "GREEKING, showing low resolution text as gibberish [n]\n",
  "GREEN": "of the colour of growing foliage [adj GREENER, GREENEST, GREENLY] / to become green [v -ED, -ING, -S]\n",
  "GREENBACK": "a monetary note issued by the US Government; generically. the US dollar [n -S]\n",
  "GREENBACKER": "a member of a post-Civil War American political party opposing reduction in the amount of paper money in circulation [n -S]\n",
  "GREENBACKERS": "GREENBACKER, a member of a post-Civil War American political party opposing reduction in the amount of paper money in circulation [n]\n",
  "GREENBACKISM": "the advocation of a paper currency backed only by the United States government [n -S]\n",
  "GREENBACKISMS": "GREENBACKISM, the advocation of a paper currency backed only by the United States government [n]\n",
  "GREENBACKS": "GREENBACK, a monetary note issued by the US Government; generically. the US dollar [n]\n",
  "GREENBELT": "a strip of open land surrounding a town [n -S]\n",
  "GREENBELTS": "GREENBELT, a strip of open land surrounding a town [n]\n",
  "GREENBONE": "a garfish; a viviparous blenny [n -S]\n",
  "GREENBONES": "GREENBONE, a garfish; a viviparous blenny [n]\n",
  "GREENBOTTLE": "a metallic-green fly [n -S]\n",
  "GREENBOTTLES": "GREENBOTTLE, a metallic-green fly [n]\n",
  "GREENBRIER": "any of a genus of woody or herbaceous vines of the lily family [n -S]\n",
  "GREENBRIERS": "GREENBRIER, any of a genus of woody or herbaceous vines of the lily family [n]\n",
  "GREENBUG": "a green aphid [n -S]\n",
  "GREENBUGS": "GREENBUG, a green aphid [n]\n",
  "GREENCLOTH": "a department of the royal household chiefly concerned with the commissariat [n -S]\n",
  "GREENCLOTHS": "GREENCLOTH, a department of the royal household chiefly concerned with the commissariat [n]\n",
  "GREENED": "GREEN, to become green [v]\n",
  "GREENER": "a newly-arrived immigrant [n -S]\n",
  "GREENERIES": "GREENERY, green vegetation [n]\n",
  "GREENERS": "GREENER, a newly-arrived immigrant [n]\n",
  "GREENERY": "green vegetation [n GREENERIES]\n",
  "GREENEST": "GREEN, of the colour of growing foliage [adj]\n",
  "GREENEYE": "a small West Atlantic fish with pale green eyes [n -S]\n",
  "GREENEYES": "GREENEYE, a small West Atlantic fish with pale green eyes [n]\n",
  "GREENFIELD": "a site free from existing developments [n -S]\n",
  "GREENFIELDS": "GREENFIELD, a site free from existing developments [n]\n",
  "GREENFINCH": "a common European finch having olive-green and yellow plumage [n -ES]\n",
  "GREENFINCHES": "GREENFINCH, a common European finch having olive-green and yellow plumage [n]\n",
  "GREENFLIES": "GREENFLY, a green aphid [n]\n",
  "GREENFLY": "a green aphid [n GREENFLIES]\n",
  "GREENGAGE": "a green and very sweet variety of plum, or the tree producing it [n -S]\n",
  "GREENGAGES": "GREENGAGE, a green and very sweet variety of plum, or the tree producing it [n]\n",
  "GREENGROCER": "a retailer of fresh vegetables and fruit [n -S]\n",
  "GREENGROCERIES": "GREENGROCERY, fresh fruit and vegetables, as sold by a greengrocer [n]\n",
  "GREENGROCERS": "GREENGROCER, a retailer of fresh vegetables and fruit [n]\n",
  "GREENGROCERY": "fresh fruit and vegetables, as sold by a greengrocer [n GREENGROCERIES]\n",
  "GREENHAND": "an inferior sailor [n -S]\n",
  "GREENHANDS": "GREENHAND, an inferior sailor [n]\n",
  "GREENHEAD": "a male mallard [n -S]\n",
  "GREENHEADS": "GREENHEAD, a male mallard [n]\n",
  "GREENHEART": "a South American tree of the laurel family, with very hard wood, aka bebeeru [n -S]\n",
  "GREENHEARTS": "GREENHEART, a South American tree of the laurel family, with very hard wood, aka bebeeru [n]\n",
  "GREENHORN": "a novice, a tenderfoot [n -S]\n",
  "GREENHORNS": "GREENHORN, a novice, a tenderfoot [n]\n",
  "GREENHOUSE": "a structure enclosed (as by glass) and used for the cultivation or protection of tender plants [n -S]\n",
  "GREENHOUSES": "GREENHOUSE, a structure enclosed (as by glass) and used for the cultivation or protection of tender plants [n]\n",
  "GREENIE": "(colloquial) a pound-note; a conservationist [n -S]\n",
  "GREENIER": "GREENY, somewhat green [adj]\n",
  "GREENIES": "GREENIE, (colloquial) a pound-note; a conservationist [n]\n",
  "GREENIEST": "GREENY, somewhat green [adj]\n",
  "GREENING": "a variety of apple [n -S]\n",
  "GREENINGS": "GREENING, a variety of apple [n]\n",
  "GREENISH": "somewhat green [adj]\n",
  "GREENISHNESS": "the state of being greenish [n -ES]\n",
  "GREENISHNESSES": "GREENISHNESS, the state of being greenish [n]\n",
  "GREENKEEPER": "a person responsible for the care and upkeep of a golf course, also GREENSKEEPER [n -S]\n",
  "GREENKEEPERS": "GREENKEEPER, a person responsible for the care and upkeep of a golf course, also GREENSKEEPER [n]\n",
  "GREENLET": "any of various small greenish American songbirds of the genus Vireo [n -S]\n",
  "GREENLETS": "GREENLET, any of various small greenish American songbirds of the genus Vireo [n]\n",
  "GREENLIGHT": "to give the go-ahead [v GREENLIT or GREENLIGHTED, GREENLIGHTING, GREENLIGHTS]\n",
  "GREENLIGHTED": "GREENLIGHT, to give the go-ahead [v]\n",
  "GREENLIGHTING": "GREENLIGHT, to give the go-ahead [v]\n",
  "GREENLIGHTS": "GREENLIGHT, to give the go-ahead [v]\n",
  "GREENLING": "a kind of fish with a greenish hue [n -S]\n",
  "GREENLINGS": "GREENLING, a kind of fish with a greenish hue [n]\n",
  "GREENLIT": "GREENLIGHT, to give the go-ahead [v]\n",
  "GREENLY": "GREEN, of the colour of growing foliage [adv]\n",
  "GREENMAIL": "to buy a large quantity of a company's stock as a hostile takeover measure, and then sell it to the company at a higher price [v -ED, -ING, -S]\n",
  "GREENMAILED": "GREENMAIL, to buy a large quantity of a company's stock as a hostile takeover measure, and then sell it to the company at a higher price [v]\n",
  "GREENMAILER": "one who engages in greenmail [n -S]\n",
  "GREENMAILERS": "GREENMAILER, one who engages in greenmail [n]\n",
  "GREENMAILING": "GREENMAIL, to buy a large quantity of a company's stock as a hostile takeover measure, and then sell it to the company at a higher price [v]\n",
  "GREENMAILS": "GREENMAIL, to buy a large quantity of a company's stock as a hostile takeover measure, and then sell it to the company at a higher price [v]\n",
  "GREENNESS": "the state of being green [n -ES]\n",
  "GREENNESSES": "GREENNESS, the state of being green [n]\n",
  "GREENOCKITE": "a rare mineral, cadmium sulphide, discovered by Lord Greenock (1783-1859) [n -S]\n",
  "GREENOCKITES": "GREENOCKITE, a rare mineral, cadmium sulphide, discovered by Lord Greenock (1783-1859) [n]\n",
  "GREENROOM": "a room in a studio or theatre for performers to relax in before or after their appearances [n -S]\n",
  "GREENROOMS": "GREENROOM, a room in a studio or theatre for performers to relax in before or after their appearances [n]\n",
  "GREENS": "GREEN, to become green [v]\n",
  "GREENSAND": "a kind of sandstone consisting largely of grains of quartz and glauconite [n -S]\n",
  "GREENSANDS": "GREENSAND, a kind of sandstone consisting largely of grains of quartz and glauconite [n]\n",
  "GREENSHANK": "a large sandpiper with long, somewhat greenish legs [n -S]\n",
  "GREENSHANKS": "GREENSHANK, a large sandpiper with long, somewhat greenish legs [n]\n",
  "GREENSICK": "suffering from chlorosis [adj]\n",
  "GREENSICKNESS": "GREENSICK, suffering from chlorosis [n]\n",
  "GREENSICKNESSES": "GREENSICKNESS, GREENSICK, suffering from chlorosis [n]\n",
  "GREENSKEEPER": "a person responsible for the care and upkeep of a golf course, also GREENKEEPER [n -S]\n",
  "GREENSKEEPERS": "GREENSKEEPER, a person responsible for the care and upkeep of a golf course, also GREENKEEPER [n]\n",
  "GREENSOME": "a type of golf match between two pairs in which partners play the ball alternately [n -S]\n",
  "GREENSOMES": "GREENSOME, a type of golf match between two pairs in which partners play the ball alternately [n]\n",
  "GREENSPEAK": "(US) ecological jargon [n -S]\n",
  "GREENSPEAKS": "GREENSPEAK, (US) ecological jargon [n]\n",
  "GREENSTICK": "designating a bone fracture in a young person in which the bone is partly bent and partly broken [adj]\n",
  "GREENSTONE": "a vague name for any basic or intermediate igneous rock [n -S]\n",
  "GREENSTONES": "GREENSTONE, a vague name for any basic or intermediate igneous rock [n]\n",
  "GREENSTUFF": "green vegetables [n -S]\n",
  "GREENSTUFFS": "GREENSTUFF, green vegetables [n]\n",
  "GREENSWARD": "turf green with grass [n -S]\n",
  "GREENSWARDS": "GREENSWARD, turf green with grass [n]\n",
  "GREENTH": "the state of being green [n -S]\n",
  "GREENTHS": "GREENTH, the state of being green [n]\n",
  "GREENWASH": "to cover with a specious overlay of concern for the environment [v -ED, -ING, -ES]\n",
  "GREENWASHED": "GREENWASH, to cover with a specious overlay of concern for the environment [v]\n",
  "GREENWASHES": "GREENWASH, to cover with a specious overlay of concern for the environment [v]\n",
  "GREENWASHING": "the act of covering with a specious overlay of concern for the environment [n -S]\n",
  "GREENWASHINGS": "GREENWASHING, the act of covering with a specious overlay of concern for the environment [n]\n",
  "GREENWAY": "a corridor of undeveloped land in or near a city [n -S]\n",
  "GREENWAYS": "GREENWAY, a corridor of undeveloped land in or near a city [n]\n",
  "GREENWEED": "a name given to certain half-shrubby species of Genista [n -S]\n",
  "GREENWEEDS": "GREENWEED, a name given to certain half-shrubby species of Genista [n]\n",
  "GREENWING": "a green-winged teal [n -S]\n",
  "GREENWINGS": "GREENWING, a green-winged teal [n]\n",
  "GREENWOOD": "a leafy wood or forest [n -S]\n",
  "GREENWOODS": "GREENWOOD, a leafy wood or forest [n]\n",
  "GREENY": "somewhat green [adj GREENIER, GREENIEST] / a pound-note [n GREENIES]\n",
  "GREES": "GREE, (archaic) to agree [v]\n",
  "GREESE": "a flight of steps, also GRECE, GREES, GREESING, GRESE, GRESSING, GRIECE, GRIS, GRIZE [n -S]\n",
  "GREESES": "GREESE, a flight of steps, also GRECE, GREES, GREESING, GRESE, GRESSING, GRIECE, GRIS, GRIZE [n]\n",
  "GREESING": "a flight of steps, also GRECE, GREES, GREESE, GRESE, GRESSING, GRIECE, GRIS, GRIZE [n -S]\n",
  "GREESINGS": "GREESING, a flight of steps, also GRECE, GREES, GREESE, GRESE, GRESSING, GRIECE, GRIS, GRIZE [n]\n",
  "GREET": "to address in a friendly and courteous way [v -ED, -ING, -S] / to weep, also GREETE [v GREETED, GRAT, GRUTTEN, GREETING, GREETS]\n",
  "GREETE": "(Spenser) to weep [v GRAT, GRUTTEN, GREETING, GREETES]\n",
  "GREETED": "GREET, to address in a friendly and courteous way [v]\n",
  "GREETER": "one who greets another [n -S]\n",
  "GREETERS": "GREETER, one who greets another [n]\n",
  "GREETES": "GREETE, (Spenser) to weep [v]\n",
  "GREETING": "a salutation [n -S]\n",
  "GREETINGS": "GREETING, a salutation [n]\n",
  "GREETS": "GREET, to address in a friendly and courteous way [v]\n",
  "GREFFIER": "(French) in the Channel Isles, a registrar, a notary [n -S]\n",
  "GREFFIERS": "GREFFIER, (French) in the Channel Isles, a registrar, a notary [n]\n",
  "GREGALE": "(Italian) a northeast wind in the Mediterranean [n -S]\n",
  "GREGALES": "GREGALE, (Italian) a northeast wind in the Mediterranean [n]\n",
  "GREGARIAN": "of a soldier, belonging to the common rank [adj]\n",
  "GREGARIANISM": "gregariousness [n -S]\n",
  "GREGARIANISMS": "GREGARIANISM, gregariousness [n]\n",
  "GREGARINE": "a member of the Gregarinida, a group of parasitic insects, molluscs and crustaceans [n -S]\n",
  "GREGARINES": "GREGARINE, a member of the Gregarinida, a group of parasitic insects, molluscs and crustaceans [n]\n",
  "GREGARINIAN": "of or like a gregarine [adj]\n",
  "GREGARIOUS": "tending to associate with others of one's kind [adj GREGARIOUSLY]\n",
  "GREGARIOUSLY": "GREGARIOUS, tending to associate with others of one's kind [adv]\n",
  "GREGARIOUSNESS": "GREGARIOUS, tending to associate with others of one's kind [n]\n",
  "GREGATIM": "(Latin) in flocks [adv]\n",
  "GREGE": "(French) of a grey-beige colour, also GREIGE [n -S] / (obsolete) to aggravate [v GREGED, GREGING, GREGES]\n",
  "GREGED": "GREGE, (obsolete) to aggravate [v]\n",
  "GREGES": "GREGE, (obsolete) to aggravate [v]\n",
  "GREGING": "GREGE, (obsolete) to aggravate [v]\n",
  "GREGO": "(Portuguese) a hooded jacket or cloak worn in East Mediterranean countries [n -S]\n",
  "GREGOS": "GREGO, (Portuguese) a hooded jacket or cloak worn in East Mediterranean countries [n]\n",
  "GREIGE": "(French) of a grey-beige colour [adj] / an unfinished fabric of this colour [n -S]\n",
  "GREIGES": "GREIGE, an unfinished fabric of this colour [n]\n",
  "GREIN": "(Scots) to long, yearn [v -ED, -ING, -S]\n",
  "GREINED": "GREIN, (Scots) to long, yearn [v]\n",
  "GREINING": "GREIN, (Scots) to long, yearn [v]\n",
  "GREINS": "GREIN, (Scots) to long, yearn [v]\n",
  "GREISEN": "(German) a rock composed of quartz and mica [n -S]\n",
  "GREISENISATION": "the process by which granite is converted to greisen, also GREISENIZATION [n -S]\n",
  "GREISENISATIONS": "GREISENISATION, the process by which granite is converted to greisen, also GREISENIZATION [n]\n",
  "GREISENISE": "to convert granite to greisen, also GREISENIZE [v GREISENISED, GREISENISING, GREISENISES]\n",
  "GREISENISED": "GREISENISE, to convert granite to greisen, also GREISENIZE [v]\n",
  "GREISENISES": "GREISENISE, to convert granite to greisen, also GREISENIZE [v]\n",
  "GREISENISING": "GREISENISE, to convert granite to greisen, also GREISENIZE [v]\n",
  "GREISENIZATION": "the process by which granite is converted to greisen, also GREISENISATION [n -S]\n",
  "GREISENIZATIONS": "GREISENIZATION, the process by which granite is converted to greisen, also GREISENISATION [n]\n",
  "GREISENIZE": "to convert granite to greisen, also GREISENISE [v GREISENIZED, GREISENIZING, GREISENIZES]\n",
  "GREISENIZED": "GREISENIZE, to convert granite to greisen, also GREISENISE [v]\n",
  "GREISENIZES": "GREISENIZE, to convert granite to greisen, also GREISENISE [v]\n",
  "GREISENIZING": "GREISENIZE, to convert granite to greisen, also GREISENISE [v]\n",
  "GREISENS": "GREISEN, (German) a rock composed of quartz and mica [n]\n",
  "GREISLY": "(Spenser) grisly, also GRIESLY, GRISELY, GRISLY, GRYSELY [adj]\n",
  "GREMIAL": "a cloth laid on a bishop's knees to keep his vestments clean from oil at ordination [n -S]\n",
  "GREMIALS": "GREMIAL, a cloth laid on a bishop's knees to keep his vestments clean from oil at ordination [n]\n",
  "GREMLIN": "a goblin accused of vexing airmen, causing mischief and mechanical trouble to aircraft [n -S]\n",
  "GREMLINS": "GREMLIN, a goblin accused of vexing airmen, causing mischief and mechanical trouble to aircraft [n]\n",
  "GREMMIE": "an inexperienced surfer, also GREMMY [n -S]\n",
  "GREMMIES": "GREMMIE, an inexperienced surfer, also GREMMY [n]\n",
  "GREMMY": "an inexperienced surfer, also GREMMIE [n GREMMIES]\n",
  "GREMOLATA": "(Italian) a colourful, flavorsome garnish, as of chopped parsley, lemon or orange peel etc. [n -S]\n",
  "GREMOLATAS": "GREMOLATA, (Italian) a colourful, flavorsome garnish, as of chopped parsley, lemon or orange peel etc. [n]\n",
  "GREN": "(Spenser) to grin [v GRENNED, GRENNING, GRENS]\n",
  "GRENACHE": "a kind of black grape; a red wine made from this [n -S]\n",
  "GRENACHES": "GRENACHE, a kind of black grape; a red wine made from this [n]\n",
  "GRENADE": "a small explosive shell designed to be thrown by hand or launched mechanically [n -S]\n",
  "GRENADES": "GRENADE, a small explosive shell designed to be thrown by hand or launched mechanically [n]\n",
  "GRENADIER": "originally, a soldier who threw grenades; then, a member of the first company of every battalion of foot-soldiers [n -S]\n",
  "GRENADIERS": "GRENADIER, originally, a soldier who threw grenades; then, a member of the first company of every battalion of foot-soldiers [n]\n",
  "GRENADILLA": "(Spanish) the fruit of certain species of passion flower found in Brazil and the West Indies, also GRANADILLA [n -S]\n",
  "GRENADILLAS": "GRENADILLA, (Spanish) the fruit of certain species of passion flower found in Brazil and the West Indies, also GRANADILLA [n]\n",
  "GRENADINE": "a pomegranate syrup, or similar, used in certain drinks [n -S]\n",
  "GRENADINES": "GRENADINE, a pomegranate syrup, or similar, used in certain drinks [n]\n",
  "GRENNED": "GREN, (Spenser) to grin [v]\n",
  "GRENNING": "GREN, (Spenser) to grin [v]\n",
  "GRENS": "GREN, (Spenser) to grin [v]\n",
  "GRESE": "a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESSING, GRIECE, GRIS, GRIZE [n -S]\n",
  "GRESES": "GRESE, a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESSING, GRIECE, GRIS, GRIZE [n]\n",
  "GRESSING": "a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESE, GRIECE, GRIS, GRIZE [n -S]\n",
  "GRESSINGS": "GRESSING, a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESE, GRIECE, GRIS, GRIZE [n]\n",
  "GRESSORIAL": "adapted for walking, also GRESSORIOUS [adj]\n",
  "GRESSORIOUS": "adapted for walking, also GRESSORIAL [adj]\n",
  "GREVE": "(obsolete) armour covering the lower leg, also GREAVE [n -S]\n",
  "GREVES": "GREVE, (obsolete) armour covering the lower leg, also GREAVE [n]\n",
  "GREVILLEA": "any of various Australian evergreen trees and shrubs [n -S]\n",
  "GREVILLEAS": "GREVILLEA, any of various Australian evergreen trees and shrubs [n]\n",
  "GREW": "to shudder, to make the flesh creep, also GRUE [v -ED, -ING, -S]\n",
  "GREWED": "GREW, to shudder, to make the flesh creep, also GRUE [v]\n",
  "GREWHOUND": "(dialect) a greyhound [n -S]\n",
  "GREWHOUNDS": "GREWHOUND, (dialect) a greyhound [n]\n",
  "GREWING": "GREW, to shudder, to make the flesh creep, also GRUE [v]\n",
  "GREWS": "GREW, to shudder, to make the flesh creep, also GRUE [v]\n",
  "GREWSOME": "repugnant, also GRUESOME [adj GREWSOMER, GREWSOMEST]\n",
  "GREWSOMER": "GREWSOME, repugnant, also GRUESOME [adj]\n",
  "GREWSOMEST": "GREWSOME, repugnant, also GRUESOME [adj]\n",
  "GREX": "(Latin) a group of plants with a common hybrid ancestor [n -ES]\n",
  "GREXES": "GREX, (Latin) a group of plants with a common hybrid ancestor [n]\n",
  "GREY": "between black and white, also GRAY [adj GREYER, GREYEST, GREYLY] / to make grey [v -ED, -ING, -S]\n",
  "GREYBACK": "any of various animals having a grey back, such as the grey whale, also GRAYBACK [n -S]\n",
  "GREYBACKS": "GREYBACK, any of various animals having a grey back, such as the grey whale, also GRAYBACK [n]\n",
  "GREYBEARD": "an old man, also GRAYBEARD [n -S]\n",
  "GREYBEARDED": "having a grey beard, also GRAYBEARDED [adj]\n",
  "GREYBEARDS": "GREYBEARD, an old man, also GRAYBEARD [n]\n",
  "GREYED": "GREY, to make grey [v]\n",
  "GREYER": "GREY, between black and white, also GRAY [adj]\n",
  "GREYEST": "GREY, between black and white, also GRAY [adj]\n",
  "GREYHEAD": "one having grey hair, also GRAYHEAD [n -S]\n",
  "GREYHEADED": "having grey hair, also GRAYHEADED [adj]\n",
  "GREYHEADS": "GREYHEAD, one having grey hair, also GRAYHEAD [n]\n",
  "GREYHEN": "the female of the blackcock, also GRAYHEN [n -S]\n",
  "GREYHENS": "GREYHEN, the female of the blackcock, also GRAYHEN [n]\n",
  "GREYHOUND": "a tall slender fast-moving dog of an ancient breed originally used for coursing, also GRAYHOUND [n -S]\n",
  "GREYHOUNDS": "GREYHOUND, a tall slender fast-moving dog of an ancient breed originally used for coursing, also GRAYHOUND [n]\n",
  "GREYING": "the process of greying [n -S]\n",
  "GREYINGS": "GREYING, the process of greying [n]\n",
  "GREYISH": "somewhat grey [adj]\n",
  "GREYLAG": "a species of wild goose, also GRAYLAG [n -S]\n",
  "GREYLAGS": "GREYLAG, a species of wild goose, also GRAYLAG [n]\n",
  "GREYLIST": "to put people on a form of blacklist on which people are merely objected to rather than banned, also GRAYLIST [v -ED, -ING, -S]\n",
  "GREYLISTED": "GREYLIST, to put people on a form of blacklist on which people are merely objected to rather than banned, also GRAYLIST [v]\n",
  "GREYLISTING": "GREYLIST, to put people on a form of blacklist on which people are merely objected to rather than banned, also GRAYLIST [v]\n",
  "GREYLISTS": "GREYLIST, to put people on a form of blacklist on which people are merely objected to rather than banned, also GRAYLIST [v]\n",
  "GREYLY": "GREY, between black and white, also GRAY [adv]\n",
  "GREYNESS": "the state of being gray, also GRAYNESS [n -ES]\n",
  "GREYNESSES": "GREYNESS, the state of being gray, also GRAYNESS [n]\n",
  "GREYS": "GREY, to make grey [v]\n",
  "GREYSCALE": "a scale consisting of different shades of the colour grey, also GRAYSCALE [n -S]\n",
  "GREYSCALES": "GREYSCALE, a scale consisting of different shades of the colour grey, also GRAYSCALE [n]\n",
  "GREYSTONE": "a grey volcanic rock, also GRAYSTONE [n -S]\n",
  "GREYSTONES": "GREYSTONE, a grey volcanic rock, also GRAYSTONE [n]\n",
  "GREYWACKE": "any coarse-grained, usually dark sandstone containing angular mineral and rock fragments in a fine-grained clayey matrix, also GRAYWACKE [n -S]\n",
  "GREYWACKES": "GREYWACKE, any coarse-grained, usually dark sandstone containing angular mineral and rock fragments in a fine-grained clayey matrix, also GRAYWACKE [n]\n",
  "GREYWETHER": "a sandstone boulder of South England, also GRAYWETHER [n -S]\n",
  "GREYWETHERS": "GREYWETHER, a sandstone boulder of South England, also GRAYWETHER [n]\n",
  "GRIBBLE": "a small crustacean which destroys submerged timber [n -S]\n",
  "GRIBBLES": "GRIBBLE, a small crustacean which destroys submerged timber [n]\n",
  "GRICE": "to collect objects or visit places connected with rails or railways [v GRICED, GRICING, GRICES]\n",
  "GRICED": "GRICE, to collect objects or visit places connected with rails or railways [v]\n",
  "GRICER": "a trainspotter or railway enthusiast [n -S]\n",
  "GRICERS": "GRICER, a trainspotter or railway enthusiast [n]\n",
  "GRICES": "GRICE, to collect objects or visit places connected with rails or railways [v]\n",
  "GRICING": "train-spotting as a hobby [n -S]\n",
  "GRICINGS": "GRICING, train-spotting as a hobby [n]\n",
  "GRID": "a grating, network [n -S] / to set out in a grid [v GRIDDED, GRIDDING, GRIDS]\n",
  "GRIDDED": "GRID, to set out in a grid [v]\n",
  "GRIDDER": "(US) an American football player [n -S]\n",
  "GRIDDERS": "GRIDDER, (US) an American football player [n]\n",
  "GRIDDING": "GRID, to set out in a grid [v]\n",
  "GRIDDLE": "to cook on a flat pan [v GRIDDLED, GRIDDLING, GRIDDLES]\n",
  "GRIDDLEBREAD": "bread made on a griddle [n -S]\n",
  "GRIDDLEBREADS": "GRIDDLEBREAD, bread made on a griddle [n]\n",
  "GRIDDLECAKE": "a cake made on a griddle [n -S]\n",
  "GRIDDLECAKES": "GRIDDLECAKE, a cake made on a griddle [n]\n",
  "GRIDDLED": "GRIDDLE, to cook on a flat pan [v]\n",
  "GRIDDLES": "GRIDDLE, to cook on a flat pan [v]\n",
  "GRIDDLING": "GRIDDLE, to cook on a flat pan [v]\n",
  "GRIDE": "to pierce; to scrape harshly, also GRYDE [v GRIDED, GRIDING, GRIDES]\n",
  "GRIDED": "GRIDE, to pierce; to scrape harshly, also GRYDE [v]\n",
  "GRIDELIN": "(French) a colour, pale purple and red [n -S]\n",
  "GRIDELINS": "GRIDELIN, (French) a colour, pale purple and red [n]\n",
  "GRIDES": "GRIDE, to pierce; to scrape harshly, also GRYDE [v]\n",
  "GRIDING": "GRIDE, to pierce; to scrape harshly, also GRYDE [v]\n",
  "GRIDIRON": "a frame of iron bars for broiling over a fire [n -S] / to mark with parallel lines or bars [v -ED, -ING, -S]\n",
  "GRIDIRONED": "GRIDIRON, to mark with parallel lines or bars [v]\n",
  "GRIDIRONING": "GRIDIRON, to mark with parallel lines or bars [v]\n",
  "GRIDIRONS": "GRIDIRON, to mark with parallel lines or bars [v]\n",
  "GRIDLOCK": "to cause a severe traffic jam [v -ED, -ING, -S]\n",
  "GRIDLOCKED": "GRIDLOCK, to cause a severe traffic jam [v]\n",
  "GRIDLOCKING": "GRIDLOCK, to cause a severe traffic jam [v]\n",
  "GRIDLOCKS": "GRIDLOCK, to cause a severe traffic jam [v]\n",
  "GRIDS": "GRID, a grating, network [n]\n",
  "GRIECE": "a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESE, GRESSING, GRIS, GRIZE [n -S]\n",
  "GRIECED": "in heraldry, placed upon steps [adj]\n",
  "GRIECES": "GRIECE, a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESE, GRESSING, GRIS, GRIZE [n]\n",
  "GRIEF": "intense mental stress [n -S]\n",
  "GRIEFER": "an online games player who intentionally spoils the game for other players [n -S]\n",
  "GRIEFERS": "GRIEFER, an online games player who intentionally spoils the game for other players [n]\n",
  "GRIEFFUL": "full of grief [adj]\n",
  "GRIEFLESS": "without grief [adj]\n",
  "GRIEFS": "GRIEF, intense mental stress [n]\n",
  "GRIESIE": "(Spenser) grey, also GRYESY [adj]\n",
  "GRIESLY": "(Spenser) grisly, also GREISLY, GRISELY, GRISLY, GRYSELY [adj]\n",
  "GRIESY": "(Spenser) grisly, also GRYSIE [adj]\n",
  "GRIEVANCE": "a cause or source of grief [n -S]\n",
  "GRIEVANCES": "GRIEVANCE, a cause or source of grief [n]\n",
  "GRIEVANT": "one that submits a complaint for arbitration [n -S]\n",
  "GRIEVANTS": "GRIEVANT, one that submits a complaint for arbitration [n]\n",
  "GRIEVE": "to feel grief, also GREAVE [v GRIEVED, GRIEVING, GRIEVES]\n",
  "GRIEVED": "GRIEVE, to feel grief, also GREAVE [v]\n",
  "GRIEVER": "one who grieves [n -S]\n",
  "GRIEVERS": "GRIEVER, one who grieves [n]\n",
  "GRIEVES": "GRIEVE, to feel grief, also GREAVE [v]\n",
  "GRIEVING": "in a state of grief [adj GRIEVINGLY] / a state of grief [n -S]\n",
  "GRIEVINGLY": "GRIEVING, in a state of grief [adv]\n",
  "GRIEVINGS": "GRIEVING, a state of grief [n]\n",
  "GRIEVOUS": "causing grief [adj GRIEVOUSLY]\n",
  "GRIEVOUSLY": "GRIEVOUS, causing grief [adv]\n",
  "GRIEVOUSNESS": "the state of being grievous [n -ES]\n",
  "GRIEVOUSNESSES": "GRIEVOUSNESS, the state of being grievous [n]\n",
  "GRIFF": "(French) a claw-shaped decoration at the base of a column, also GRIFFE [n -S]\n",
  "GRIFFE": "(French) a claw-shaped decoration at the base of a column, also GRIFF [n -S]\n",
  "GRIFFES": "GRIFFE, (French) a claw-shaped decoration at the base of a column, also GRIFF [n]\n",
  "GRIFFIN": "an imaginary animal with a lion's body and an eagle's head, also GRYFON, GRYPHON [n -S]\n",
  "GRIFFINISH": "like a griffin [adj]\n",
  "GRIFFINISM": "being like a griffin, in the sense of greenhorn [n -S]\n",
  "GRIFFINISMS": "GRIFFINISM, being like a griffin, in the sense of greenhorn [n]\n",
  "GRIFFINS": "GRIFFIN, an imaginary animal with a lion's body and an eagle's head, also GRYFON, GRYPHON [n]\n",
  "GRIFFON": "a dog like a coarse-haired terrier [n -S]\n",
  "GRIFFONS": "GRIFFON, a dog like a coarse-haired terrier [n]\n",
  "GRIFFS": "GRIFF, (French) a claw-shaped decoration at the base of a column, also GRIFFE [n]\n",
  "GRIFT": "(US) to swindle [v -ED, -ING, -S]\n",
  "GRIFTED": "GRIFT, (US) to swindle [v]\n",
  "GRIFTER": "(US) a swindler [n -S]\n",
  "GRIFTERS": "GRIFTER, (US) a swindler [n]\n",
  "GRIFTING": "GRIFT, (US) to swindle [v]\n",
  "GRIFTS": "GRIFT, (US) to swindle [v]\n",
  "GRIG": "to fish for grigs (sand-eels) [v GRIGGED, GRIGGING, GRIGS]\n",
  "GRIGGED": "GRIG, to fish for grigs (sand-eels) [v]\n",
  "GRIGGING": "GRIG, to fish for grigs (sand-eels) [v]\n",
  "GRIGRI": "an African charm or amulet, also GREEGREE, GRISGRIS [n -S]\n",
  "GRIGRIS": "GRIGRI, an African charm or amulet, also GREEGREE, GRISGRIS [n]\n",
  "GRIGS": "GRIG, to fish for grigs (sand-eels) [v]\n",
  "GRIKE": "(Old Norse) a crevice in a limestone pavement, also GRYKE [n -S]\n",
  "GRIKES": "GRIKE, (Old Norse) a crevice in a limestone pavement, also GRYKE [n]\n",
  "GRILL": "to broil on a gridiron [v -ED, -ING, -S]\n",
  "GRILLADE": "(French) a dish of grilled meat [n -S]\n",
  "GRILLADES": "GRILLADE, (French) a dish of grilled meat [n]\n",
  "GRILLAGE": "a framework of timber [n -S]\n",
  "GRILLAGES": "GRILLAGE, a framework of timber [n]\n",
  "GRILLE": "a lattice, grating, screen or openwork of metal, also GRILL [n -S]\n",
  "GRILLED": "GRILL, to broil on a gridiron [v]\n",
  "GRILLER": "a person who or thing which grills [n -S]\n",
  "GRILLERIES": "GRILLERY, a place where grilled foods are served [n]\n",
  "GRILLERS": "GRILLER, a person who or thing which grills [n]\n",
  "GRILLERY": "a place where grilled foods are served [n GRILLERIES]\n",
  "GRILLES": "GRILLE, a lattice, grating, screen or openwork of metal, also GRILL [n]\n",
  "GRILLING": "an interrogation [n -S]\n",
  "GRILLINGS": "GRILLING, an interrogation [n]\n",
  "GRILLION": "an indefinitely large number [n -S]\n",
  "GRILLIONS": "GRILLION, an indefinitely large number [n]\n",
  "GRILLROOM": "a room where grills are prepared [n -S]\n",
  "GRILLROOMS": "GRILLROOM, a room where grills are prepared [n]\n",
  "GRILLS": "GRILL, to broil on a gridiron [v]\n",
  "GRILLSTEAK": "a large steak-shaped burger of minced lamb etc. [n -S]\n",
  "GRILLSTEAKS": "GRILLSTEAK, a large steak-shaped burger of minced lamb etc. [n]\n",
  "GRILLWORK": "something wrought in the form of a grill [n -S]\n",
  "GRILLWORKS": "GRILLWORK, something wrought in the form of a grill [n]\n",
  "GRILSE": "a young salmon [n -S]\n",
  "GRILSES": "GRILSE, a young salmon [n]\n",
  "GRIM": "stern and unrelenting [adj GRIMMER, GRIMMEST, GRIMLY]\n",
  "GRIMACE": "to contort the facial features [v GRIMACED, GRIMACING, GRIMACES]\n",
  "GRIMACED": "GRIMACE, to contort the facial features [v]\n",
  "GRIMACER": "one who grimaces [n -S]\n",
  "GRIMACERS": "GRIMACER, one who grimaces [n]\n",
  "GRIMACES": "GRIMACE, to contort the facial features [v]\n",
  "GRIMACING": "GRIMACE, to contort the facial features [v]\n",
  "GRIMACINGLY": "GRIMACING, GRIMACE, to contort the facial features [adv]\n",
  "GRIMALKIN": "a cat; esp. an old female cat, also MALKIN, MAWKIN [n -S]\n",
  "GRIMALKINS": "GRIMALKIN, a cat; esp. an old female cat, also MALKIN, MAWKIN [n]\n",
  "GRIME": "to make dirty [v GRIMED, GRIMING, GRIMES]\n",
  "GRIMED": "GRIME, to make dirty [v]\n",
  "GRIMES": "GRIME, to make dirty [v]\n",
  "GRIMIER": "GRIMY, dirty, covered with grime [adj]\n",
  "GRIMIEST": "GRIMY, dirty, covered with grime [adj]\n",
  "GRIMILY": "GRIMY, dirty, covered with grime [adv]\n",
  "GRIMINESS": "the state of being grimy [n -ES]\n",
  "GRIMINESSES": "GRIMINESS, the state of being grimy [n]\n",
  "GRIMING": "GRIME, to make dirty [v]\n",
  "GRIMLOOKED": "(Shakespeare) having a grim or dismal aspect [adj]\n",
  "GRIMLY": "GRIM, stern and unrelenting [adv]\n",
  "GRIMMER": "GRIM, stern and unrelenting [adj]\n",
  "GRIMMEST": "GRIM, stern and unrelenting [adj]\n",
  "GRIMNESS": "the quality of being grim [n -ES]\n",
  "GRIMNESSES": "GRIMNESS, the quality of being grim [n]\n",
  "GRIMOIRE": "(French) a book of magical lore [n -S]\n",
  "GRIMOIRES": "GRIMOIRE, (French) a book of magical lore [n]\n",
  "GRIMY": "dirty, covered with grime [adj GRIMIER, GRIMIEST, GRIMILY]\n",
  "GRIN": "to smile broadly, also GREN [v GRINNED, GRINNING, GRINS]\n",
  "GRINCH": "someone who ruins others' enjoyment [n -ES]\n",
  "GRINCHES": "GRINCH, someone who ruins others' enjoyment [n]\n",
  "GRIND": "to wear, smooth or sharpen by friction [v GROUND or GRINDED, GROUNDEN, GRINDING, GRINDS]\n",
  "GRINDED": "GRIND, to wear, smooth or sharpen by friction [v]\n",
  "GRINDELIA": "any coarse plant of the American genus Grindelia, with yellow daisy-like flower-heads [n -S]\n",
  "GRINDELIAS": "GRINDELIA, any coarse plant of the American genus Grindelia, with yellow daisy-like flower-heads [n]\n",
  "GRINDER": "one who, or that which, grinds [n -S]\n",
  "GRINDERIES": "GRINDERY, a place where tools are ground [n]\n",
  "GRINDERS": "GRINDER, one who, or that which, grinds [n]\n",
  "GRINDERY": "a place where tools are ground [n GRINDERIES]\n",
  "GRINDHOUSE": "a type of cinema that deals with sleazy dancing [n -S]\n",
  "GRINDHOUSES": "GRINDHOUSE, a type of cinema that deals with sleazy dancing [n]\n",
  "GRINDING": "of poverty, very severe [adj GRINDINGLY] / the act of grinding [n -S]\n",
  "GRINDINGLY": "GRINDING, of poverty, very severe [adv]\n",
  "GRINDINGS": "GRINDING, the act of grinding [n]\n",
  "GRINDS": "GRIND, to wear, smooth or sharpen by friction [v]\n",
  "GRINDSTONE": "a millstone [n -S]\n",
  "GRINDSTONES": "GRINDSTONE, a millstone [n]\n",
  "GRINGA": "(Spanish) a female foreigner in Latin America [n -S]\n",
  "GRINGAS": "GRINGA, (Spanish) a female foreigner in Latin America [n]\n",
  "GRINGO": "(Spanish) a male foreigner in Latin America [n -S]\n",
  "GRINGOS": "GRINGO, (Spanish) a male foreigner in Latin America [n]\n",
  "GRINNED": "GRIN, to smile broadly, also GREN [v]\n",
  "GRINNER": "one who grins [n -S]\n",
  "GRINNERS": "GRINNER, one who grins [n]\n",
  "GRINNING": "showing a grin [adj GRINNINGLY] / the act of grinning [n -S]\n",
  "GRINNINGLY": "GRINNING, showing a grin [adv]\n",
  "GRINNINGS": "GRINNING, the act of grinning [n]\n",
  "GRINS": "GRIN, to smile broadly, also GREN [v]\n",
  "GRIOT": "(French) a tribal entertainer in West Africa [n -S]\n",
  "GRIOTS": "GRIOT, (French) a tribal entertainer in West Africa [n]\n",
  "GRIP": "to take hold of [v GRIPT or GRIPPED, GRIPPING, GRIPS]\n",
  "GRIPE": "to keep on complaining [v GRIPED, GRIPING, GRIPES] / (archaic) to pierce [v GRYPT, GRIPING, GRIPES]\n",
  "GRIPED": "GRIPE, to keep on complaining [v]\n",
  "GRIPER": "one who gripes [n -S]\n",
  "GRIPERS": "GRIPER, one who gripes [n]\n",
  "GRIPES": "GRIPE, to keep on complaining [v]\n",
  "GRIPEY": "causing sharp pains in the bowels, also GRIPY [adj GRIPIER, GRIPIEST]\n",
  "GRIPIER": "GRIPEY, causing sharp pains in the bowels, also GRIPY [adj]\n",
  "GRIPIEST": "GRIPEY, causing sharp pains in the bowels, also GRIPY [adj]\n",
  "GRIPING": "the act of grumbling [n -S]\n",
  "GRIPINGLY": "GRIPING [adv]\n",
  "GRIPINGS": "GRIPING, the act of grumbling [n]\n",
  "GRIPLE": "(Spenser) grasping, also GRIPPLE [adj]\n",
  "GRIPMAN": "a cable car operator [n GRIPMEN]\n",
  "GRIPMEN": "GRIPMAN, a cable car operator [n]\n",
  "GRIPPE": "an old term for influenza [n -S]\n",
  "GRIPPED": "GRIP, to take hold of [v]\n",
  "GRIPPER": "one who, or that which, grips or seizes [n -S]\n",
  "GRIPPERS": "GRIPPER, one who, or that which, grips or seizes [n]\n",
  "GRIPPES": "GRIPPE, an old term for influenza [n]\n",
  "GRIPPIER": "GRIPPY, (Scots) inclined to avarice [adj]\n",
  "GRIPPIEST": "GRIPPY, (Scots) inclined to avarice [adj]\n",
  "GRIPPING": "GRIP, to take hold of [v]\n",
  "GRIPPINGLY": "GRIPPING, GRIP, to take hold of [adv]\n",
  "GRIPPLE": "greedy, grasping, also GRIPLE [adj] / (obsolete) a grasp; a gripe [n -S]\n",
  "GRIPPLES": "GRIPPLE, (obsolete) a grasp; a gripe [n]\n",
  "GRIPPY": "(Scots) inclined to avarice [adj GRIPPIER, GRIPPIEST]\n",
  "GRIPS": "GRIP, to take hold of [v]\n",
  "GRIPSACK": "a traveller's handbag [n -S]\n",
  "GRIPSACKS": "GRIPSACK, a traveller's handbag [n]\n",
  "GRIPT": "GRIP, to take hold of [v]\n",
  "GRIPTAPE": "a rough adhesive tape, as used on skateboarding equipment [n -S]\n",
  "GRIPTAPES": "GRIPTAPE, a rough adhesive tape, as used on skateboarding equipment [n]\n",
  "GRIPY": "causing sharp pains in the bowels, also GRIPEY [adj GRIPIER, GRIPIEST]\n",
  "GRIS": "a flight of steps, also GRECE, GREES, GREESE, GREESING, GRESE, GRESSING, GRIECE, GRIZE [n -ES]\n",
  "GRISAILLE": "(French) a painting in tones of a single color, esp. gray, to represent objects in relief [n -S]\n",
  "GRISAILLES": "GRISAILLE, (French) a painting in tones of a single color, esp. gray, to represent objects in relief [n]\n",
  "GRISE": "to shudder at, to terrify [v GRISED, GRISING, GRISES]\n",
  "GRISED": "GRISE, to shudder at, to terrify [v]\n",
  "GRISELY": "(Spenser) grisly, also GREISLY, GRIESLY, GRISLY, GRYSELY [adj]\n",
  "GRISEOFULVIN": "an oral antibiotic used as a treatment for fungal infections of the skin and hair [n -S]\n",
  "GRISEOFULVINS": "GRISEOFULVIN, an oral antibiotic used as a treatment for fungal infections of the skin and hair [n]\n",
  "GRISEOUS": "pearl-grey or blue-grey; grizzled [adj]\n",
  "GRISES": "GRISE, to shudder at, to terrify [v]\n",
  "GRISETTE": "(French) a young French working-class girl [n -S]\n",
  "GRISETTES": "GRISETTE, (French) a young French working-class girl [n]\n",
  "GRISGRIS": "an African charm or amulet, also GREEGREE, GRIGRI [n GRISGRIS]\n",
  "GRISING": "GRISE, to shudder at, to terrify [v]\n",
  "GRISKIN": "the lean part of a loin of pork [n -S]\n",
  "GRISKINS": "GRISKIN, the lean part of a loin of pork [n]\n",
  "GRISLED": "grizzled [adj]\n",
  "GRISLIER": "GRISLY, horrifying, also GREISLY, GRIESLY, GRYSELY [adj]\n",
  "GRISLIES": "GRISLY, a grizzly bear [n]\n",
  "GRISLIEST": "GRISLY, horrifying, also GREISLY, GRIESLY, GRYSELY [adj]\n",
  "GRISLINESS": "the state of being grisly [n -ES]\n",
  "GRISLINESSES": "GRISLINESS, the state of being grisly [n]\n",
  "GRISLY": "horrifying, also GREISLY, GRIESLY, GRYSELY [adj GRISLIER, GRISLIEST] / a grizzly bear [n GRISLIES]\n",
  "GRISON": "(French) a carnivorous mustelid mammal of Central and South America [n -S]\n",
  "GRISONS": "GRISON, (French) a carnivorous mustelid mammal of Central and South America [n]\n",
  "GRISSINI": "GRISSINO, (Italian) a long, cylindrical Italian breadstick [n]\n",
  "GRISSINO": "(Italian) a long, cylindrical Italian breadstick [n GRISSINI]\n",
  "GRIST": "grain for grinding [n -S]\n",
  "GRISTER": "a device for grinding grain [n -S]\n",
  "GRISTERS": "GRISTER, a device for grinding grain [n]\n",
  "GRISTLE": "the tough part of meat [n -S]\n",
  "GRISTLES": "GRISTLE, the tough part of meat [n]\n",
  "GRISTLIER": "GRISTLY, containing gristle [adj]\n",
  "GRISTLIEST": "GRISTLY, containing gristle [adj]\n",
  "GRISTLINESS": "the state of being gristly [n -ES]\n",
  "GRISTLINESSES": "GRISTLINESS, the state of being gristly [n]\n",
  "GRISTLY": "containing gristle [adj GRISTLIER, GRISTLIEST]\n",
  "GRISTMILL": "a mill for grinding grain; esp. grists, or portions of grain brought by different customers [n -S]\n",
  "GRISTMILLS": "GRISTMILL, a mill for grinding grain; esp. grists, or portions of grain brought by different customers [n]\n",
  "GRISTS": "GRIST, grain for grinding [n]\n",
  "GRISY": "(obsolete) grim, grisly, also GRIESIE, GRIESY, GRYESY, GRYSIE [adj]\n",
  "GRIT": "to press the teeth together [v GRITTED, GRITTING, GRITS] / (Scots) great [adj GRITTER, GRITTEST]\n",
  "GRITH": "(historical) sanctuary, asylum [n -S]\n",
  "GRITHS": "GRITH, (historical) sanctuary, asylum [n]\n",
  "GRITLESS": "without grit [adj]\n",
  "GRITS": "GRIT, to press the teeth together [v]\n",
  "GRITSTONE": "a type of coarse sandstone [n -S]\n",
  "GRITSTONES": "GRITSTONE, a type of coarse sandstone [n]\n",
  "GRITTED": "GRIT, to press the teeth together [v]\n",
  "GRITTER": "a vehicle for spreading grit [n -S]\n",
  "GRITTERS": "GRITTER, a vehicle for spreading grit [n]\n",
  "GRITTEST": "GRIT, (Scots) great [adj]\n",
  "GRITTIER": "GRITTY, plucky [adj]\n",
  "GRITTIEST": "GRITTY, plucky [adj]\n",
  "GRITTILY": "GRITTY, plucky [adv]\n",
  "GRITTINESS": "the state of being gritty [n -ES]\n",
  "GRITTINESSES": "GRITTINESS, the state of being gritty [n]\n",
  "GRITTING": "the act of pressing the teeth together [n -S]\n",
  "GRITTINGS": "GRITTING, the act of pressing the teeth together [n]\n",
  "GRITTY": "plucky [adj GRITTIER, GRITTIEST, GRITTILY]\n",
  "GRIVATION": "grid variation [n -S]\n",
  "GRIVATIONS": "GRIVATION, grid variation [n]\n",
  "GRIVET": "(French) a long-tailed African monkey [n -S]\n",
  "GRIVETS": "GRIVET, (French) a long-tailed African monkey [n]\n",
  "GRIZ": "a grizzly bear [n GRIZZES]\n",
  "GRIZE": "a flight of steps, also GRECE, GRECIAN, GREECE, GREESE, GREESING, GRESE, GRESSING, GRIECE [n -S]\n",
  "GRIZES": "GRIZE, a flight of steps, also GRECE, GRECIAN, GREECE, GREESE, GREESING, GRESE, GRESSING, GRIECE [n]\n",
  "GRIZZES": "GRIZ, a grizzly bear [n]\n",
  "GRIZZLE": "to become grey-haired, to complain [v GRIZZLED, GRIZZLING, GRIZZLES]\n",
  "GRIZZLED": "GRIZZLE, to become grey-haired, to complain [v]\n",
  "GRIZZLER": "a grumbler [n -S]\n",
  "GRIZZLERS": "GRIZZLER, a grumbler [n]\n",
  "GRIZZLES": "GRIZZLE, to become grey-haired, to complain [v]\n",
  "GRIZZLIER": "GRIZZLY, greyish [adj]\n",
  "GRIZZLIES": "GRIZZLY, a kind of large bear [n]\n",
  "GRIZZLIEST": "GRIZZLY, greyish [adj]\n",
  "GRIZZLING": "GRIZZLE, to become grey-haired, to complain [v]\n",
  "GRIZZLY": "greyish [adj GRIZZLIER, GRIZZLIEST] / a kind of large bear [n GRIZZLIES]\n",
  "GROAN": "to utter a low mournful sound, also GRONE [v -ED, -ING, -S]\n",
  "GROANED": "GROAN, to utter a low mournful sound, also GRONE [v]\n",
  "GROANER": "one who groans [n -S]\n",
  "GROANERS": "GROANER, one who groans [n]\n",
  "GROANFUL": "(archaic) full of groans, also GRONEFULL [adj]\n",
  "GROANING": "with a groan [adj GROANINGLY] / the act of groaning [n -S]\n",
  "GROANINGLY": "GROANING, with a groan [adv]\n",
  "GROANINGS": "GROANING, the act of groaning [n]\n",
  "GROANS": "GROAN, to utter a low mournful sound, also GRONE [v]\n",
  "GROAT": "an old English coin [n -S]\n",
  "GROATS": "GROAT, an old English coin [n]\n",
  "GROATSWORTH": "(obsolete) the value of a groat [n -S]\n",
  "GROATSWORTHS": "GROATSWORTH, (obsolete) the value of a groat [n]\n",
  "GROCER": "a dealer in food and household supplies [n -S]\n",
  "GROCERIES": "GROCERY, a grocer's store [n]\n",
  "GROCERS": "GROCER, a dealer in food and household supplies [n]\n",
  "GROCERY": "a grocer's store [n GROCERIES]\n",
  "GROCETERIA": "(US) a self-service grocery store [n -S]\n",
  "GROCETERIAS": "GROCETERIA, (US) a self-service grocery store [n]\n",
  "GROCKED": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROCKING": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROCKLE": "a tourist or incomer in a holiday area [n -S]\n",
  "GROCKLES": "GROCKLE, a tourist or incomer in a holiday area [n]\n",
  "GRODIER": "GRODY, (US slang) sleazy, grotty [adj]\n",
  "GRODIEST": "GRODY, (US slang) sleazy, grotty [adj]\n",
  "GRODY": "(US slang) sleazy, grotty [adj GRODIER, GRODIEST]\n",
  "GROG": "diluted spirit, usually rum, as an alcoholic drink [n -S] / to extract the spirit from the wood of casks by soaking it in hot water [v GROGGED, GROGGING, GROGS]\n",
  "GROGGED": "GROG, to extract the spirit from the wood of casks by soaking it in hot water [v]\n",
  "GROGGERIES": "GROGGERY, a low public-house [n]\n",
  "GROGGERY": "a low public-house [n GROGGERIES]\n",
  "GROGGIER": "GROGGY, dazed [adj]\n",
  "GROGGIEST": "GROGGY, dazed [adj]\n",
  "GROGGILY": "GROGGY, dazed [adv]\n",
  "GROGGINESS": "the state of being groggy [n -ES]\n",
  "GROGGINESSES": "GROGGINESS, the state of being groggy [n]\n",
  "GROGGING": "GROG, to extract the spirit from the wood of casks by soaking it in hot water [v]\n",
  "GROGGY": "dazed [adj GROGGIER, GROGGIEST, GROGGILY]\n",
  "GROGRAM": "a coarse loosely woven silk and mohair fabric, also GROSGRAIN [n -S]\n",
  "GROGRAMS": "GROGRAM, a coarse loosely woven silk and mohair fabric, also GROSGRAIN [n]\n",
  "GROGS": "GROG, to extract the spirit from the wood of casks by soaking it in hot water [v]\n",
  "GROGSHOP": "a place where grog is sold [n -S]\n",
  "GROGSHOPS": "GROGSHOP, a place where grog is sold [n]\n",
  "GROIN": "to build with groins, intersecting arches [v -ED, -ING, -S]\n",
  "GROINED": "GROIN, to build with groins, intersecting arches [v]\n",
  "GROINING": "a ribbed effect on a vault [n -S]\n",
  "GROININGS": "GROINING, a ribbed effect on a vault [n]\n",
  "GROINS": "GROIN, to build with groins, intersecting arches [v]\n",
  "GROK": "(colloquial) to understand deeply by intuition [v GROKKED or GROCKED or GROKED, GROKKING or GROCKING or GROKING, GROKS]\n",
  "GROKED": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROKING": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROKKED": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROKKING": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROKS": "GROK, (colloquial) to understand deeply by intuition [v]\n",
  "GROMA": "(Latin) a Roman surveying instrument [n -S]\n",
  "GROMAS": "GROMA, (Latin) a Roman surveying instrument [n]\n",
  "GROMET": "a reinforcing ring of metal, also GROMMET, GRUMMET [n -S]\n",
  "GROMETS": "GROMET, a reinforcing ring of metal, also GROMMET, GRUMMET [n]\n",
  "GROMMET": "a reinforcing ring of metal, also GROMET, GRUMMET [n -S] / to fit with grommets [v -ED, -ING, -S]\n",
  "GROMMETED": "GROMMET, to fit with grommets [v]\n",
  "GROMMETING": "GROMMET, to fit with grommets [v]\n",
  "GROMMETS": "GROMMET, to fit with grommets [v]\n",
  "GROMWELL": "a wild flower of the borage family, aka SALFERN [n -S]\n",
  "GROMWELLS": "GROMWELL, a wild flower of the borage family, aka SALFERN [n]\n",
  "GRONE": "to utter a low mournful sound, also GROAN [v GRONED, GRONING, GRONES]\n",
  "GRONED": "GRONE, to utter a low mournful sound, also GROAN [v]\n",
  "GRONEFULL": "(Spenser) groanful, also GROANFUL [adj]\n",
  "GRONES": "GRONE, to utter a low mournful sound, also GROAN [v]\n",
  "GRONING": "GRONE, to utter a low mournful sound, also GROAN [v]\n",
  "GROOF": "(Scots) the front of one's body, one's face, also GROUF, GRUFE [n -S]\n",
  "GROOFS": "GROOF, (Scots) the front of one's body, one's face, also GROUF, GRUFE [n]\n",
  "GROOLIER": "GROOLY, (slang) gruesome [adj]\n",
  "GROOLIEST": "GROOLY, (slang) gruesome [adj]\n",
  "GROOLY": "(slang) gruesome [adj GROOLIER, GROOLIEST]\n",
  "GROOM": "to clean and care for [v -ED, -ING, -S]\n",
  "GROOMED": "GROOM, to clean and care for [v]\n",
  "GROOMER": "one that grooms [n -S]\n",
  "GROOMERS": "GROOMER, one that grooms [n]\n",
  "GROOMING": "the act of grooming [n -S]\n",
  "GROOMINGS": "GROOMING, the act of grooming [n]\n",
  "GROOMS": "GROOM, to clean and care for [v]\n",
  "GROOMSMAN": "the attendant on a bridegroom [n GROOMSMEN]\n",
  "GROOMSMEN": "GROOMSMAN, the attendant on a bridegroom [n]\n",
  "GROOVE": "to form a groove (a long narrow depression) [v GROOVED, GROOVING, GROOVES]\n",
  "GROOVED": "GROOVE, to form a groove (a long narrow depression) [v]\n",
  "GROOVELESS": "without grooves [adj]\n",
  "GROOVELIKE": "like a groove [adj]\n",
  "GROOVER": "one who or that which grooves [n -S]\n",
  "GROOVERS": "GROOVER, one who or that which grooves [n]\n",
  "GROOVES": "GROOVE, to form a groove (a long narrow depression) [v]\n",
  "GROOVIER": "GROOVY, trendy [adj]\n",
  "GROOVIEST": "GROOVY, trendy [adj]\n",
  "GROOVILY": "GROOVY, trendy [adv]\n",
  "GROOVINESS": "the state of being groovy [n -ES]\n",
  "GROOVINESSES": "GROOVINESS, the state of being groovy [n]\n",
  "GROOVING": "GROOVE, to form a groove (a long narrow depression) [v]\n",
  "GROOVY": "trendy [adj GROOVIER, GROOVIEST, GROOVILY]\n",
  "GROPE": "to feel about with the hands [v GROPED, GROPING, GROPES]\n",
  "GROPED": "GROPE, to feel about with the hands [v]\n",
  "GROPER": "one who gropes [n -S]\n",
  "GROPERS": "GROPER, one who gropes [n]\n",
  "GROPES": "GROPE, to feel about with the hands [v]\n",
  "GROPING": "GROPE, to feel about with the hands [v]\n",
  "GROPINGLY": "GROPING, GROPE, to feel about with the hands [adv]\n",
  "GROSBEAK": "any of various finches or finch-like birds with heavy bills [n -S]\n",
  "GROSBEAKS": "GROSBEAK, any of various finches or finch-like birds with heavy bills [n]\n",
  "GROSCHEN": "(German) a small German monetary unit [n -S]\n",
  "GROSCHENS": "GROSCHEN, (German) a small German monetary unit [n]\n",
  "GROSER": "(Scots) a gooseberry, also GROSERT, GROSET, GROSSART [n -S]\n",
  "GROSERS": "GROSER, (Scots) a gooseberry, also GROSERT, GROSET, GROSSART [n]\n",
  "GROSERT": "(Scots) a gooseberry, also GROSER, GROSET, GROSSART [n -S]\n",
  "GROSERTS": "GROSERT, (Scots) a gooseberry, also GROSER, GROSET, GROSSART [n]\n",
  "GROSET": "(Scots) a gooseberry, also GROSER, GROSERT, GROSSART [n -S]\n",
  "GROSETS": "GROSET, (Scots) a gooseberry, also GROSER, GROSERT, GROSSART [n]\n",
  "GROSGRAIN": "(French) a heavy close-woven corded silk, also GROGRAM [n -S]\n",
  "GROSGRAINS": "GROSGRAIN, (French) a heavy close-woven corded silk, also GROGRAM [n]\n",
  "GROSS": "to earn exclusive of deductions [v -ED, -ING, -ES] / flagrant [adj GROSSER, GROSSEST, GROSSLY]\n",
  "GROSSART": "(Scots) a gooseberry, also GROSER, GROSERT, GROSET [n -S]\n",
  "GROSSARTS": "GROSSART, (Scots) a gooseberry, also GROSER, GROSERT, GROSET [n]\n",
  "GROSSED": "GROSS, to earn exclusive of deductions [v]\n",
  "GROSSER": "a product that yields much business [n -S]\n",
  "GROSSERS": "GROSSER, a product that yields much business [n]\n",
  "GROSSES": "GROSS, to earn exclusive of deductions [v]\n",
  "GROSSEST": "GROSS, flagrant [adj]\n",
  "GROSSIERETE": "(French) coarseness [n -S]\n",
  "GROSSIERETES": "GROSSIERETE, (French) coarseness [n]\n",
  "GROSSING": "GROSS, to earn exclusive of deductions [v]\n",
  "GROSSLY": "GROSS, flagrant [adv]\n",
  "GROSSNESS": "the state of being gross [n -ES]\n",
  "GROSSNESSES": "GROSSNESS, the state of being gross [n]\n",
  "GROSSULAR": "a garnet containing calcium and aluminium, occurring in grey, pinkish, or yellow-green crystals and used as a gemstone, also GROSSULARITE [n -S]\n",
  "GROSSULARITE": "a garnet containing calcium and aluminium, occurring in grey, pinkish, or yellow-green crystals and used as a gemstone, also GROSSULAR [n -S]\n",
  "GROSSULARITES": "GROSSULARITE, a garnet containing calcium and aluminium, occurring in grey, pinkish, or yellow-green crystals and used as a gemstone, also GROSSULAR [n]\n",
  "GROSSULARS": "GROSSULAR, a garnet containing calcium and aluminium, occurring in grey, pinkish, or yellow-green crystals and used as a gemstone, also GROSSULARITE [n]\n",
  "GROSZ": "(Polish) a Polish monetary unit, 1/100 of a zloty [n GROSZE or GROSZY]\n",
  "GROSZE": "GROSZ, (Polish) a Polish monetary unit, 1/100 of a zloty [n]\n",
  "GROSZY": "GROSZ, (Polish) a Polish monetary unit, 1/100 of a zloty [n]\n",
  "GROT": "a grotto [n -S]\n",
  "GROTESQUE": "(French) extravagantly formed, fantastic; bizarre [adj GROTESQUER, GROTESQUEST, GROTESQUELY] / an extravagant piece of art [n -S]\n",
  "GROTESQUELY": "GROTESQUE, (French) extravagantly formed, fantastic; bizarre [adv]\n",
  "GROTESQUENESS": "the state of being grotesque [n -ES]\n",
  "GROTESQUENESSES": "GROTESQUENESS, the state of being grotesque [n]\n",
  "GROTESQUER": "GROTESQUE, (French) extravagantly formed, fantastic; bizarre [adj]\n",
  "GROTESQUERIE": "(French) grotesque objects collectively; grotesque quality, also GROTESQUERY [n -S]\n",
  "GROTESQUERIES": "GROTESQUERIE, (French) grotesque objects collectively; grotesque quality, also GROTESQUERY [n]\n",
  "GROTESQUERY": "grotesque objects collectively; grotesque quality, also GROTESQUERIE [n GROTESQUERIES]\n",
  "GROTESQUES": "GROTESQUE, an extravagant piece of art [n]\n",
  "GROTESQUEST": "GROTESQUE, (French) extravagantly formed, fantastic; bizarre [adj]\n",
  "GROTS": "GROT, a grotto [n]\n",
  "GROTTIER": "GROTTY, wretchedly shabby; of a poor quality [adj]\n",
  "GROTTIEST": "GROTTY, wretchedly shabby; of a poor quality [adj]\n",
  "GROTTINESS": "the state of being grotty [n -ES]\n",
  "GROTTINESSES": "GROTTINESS, the state of being grotty [n]\n",
  "GROTTO": "a cave [n -ES or -S]\n",
  "GROTTOED": "having a grotto [adj]\n",
  "GROTTOES": "GROTTO, a cave [n]\n",
  "GROTTOS": "GROTTO, a cave [n]\n",
  "GROTTY": "wretchedly shabby; of a poor quality [adj GROTTIER, GROTTIEST]\n",
  "GROUCH": "to grumble [v -ED, -ING, -ES]\n",
  "GROUCHED": "GROUCH, to grumble [v]\n",
  "GROUCHES": "GROUCH, to grumble [v]\n",
  "GROUCHIER": "GROUCHY, ill-tempered [adj]\n",
  "GROUCHIEST": "GROUCHY, ill-tempered [adj]\n",
  "GROUCHILY": "GROUCHY, ill-tempered [adv]\n",
  "GROUCHINESS": "the state of being grouchy [n -ES]\n",
  "GROUCHINESSES": "GROUCHINESS, the state of being grouchy [n]\n",
  "GROUCHING": "GROUCH, to grumble [v]\n",
  "GROUCHY": "ill-tempered [adj GROUCHIER, GROUCHIEST, GROUCHILY]\n",
  "GROUF": "(obsolete) the front of one's body, one's face, also GROOF, GRUFE [n -S]\n",
  "GROUFS": "GROUF, (obsolete) the front of one's body, one's face, also GROOF, GRUFE [n]\n",
  "GROUGH": "a deep gully in a peat moor area [n -S]\n",
  "GROUGHS": "GROUGH, a deep gully in a peat moor area [n]\n",
  "GROUND": "to place on a foundation [v -ED, -ING, -S]\n",
  "GROUNDAGE": "a charge on a ship in port [n -S]\n",
  "GROUNDAGES": "GROUNDAGE, a charge on a ship in port [n]\n",
  "GROUNDBAIT": "bait dropped to the bottom to bring fish to the neighbourhood [n -S] / to bait with groundbait [v -ED, -ING, -S]\n",
  "GROUNDBAITED": "GROUNDBAIT, to bait with groundbait [v]\n",
  "GROUNDBAITING": "GROUNDBAIT, to bait with groundbait [v]\n",
  "GROUNDBAITS": "GROUNDBAIT, bait dropped to the bottom to bring fish to the neighbourhood [n]\n",
  "GROUNDBREAKER": "one that innovates [n -S]\n",
  "GROUNDBREAKERS": "GROUNDBREAKER, one that innovates [n]\n",
  "GROUNDBREAKING": "the breaking of ground at the beginning of a construction project [n -S]\n",
  "GROUNDBREAKINGS": "GROUNDBREAKING, the breaking of ground at the beginning of a construction project [n]\n",
  "GROUNDBURST": "the detonation of a nuclear warhead at ground level [n -S]\n",
  "GROUNDBURSTS": "GROUNDBURST, the detonation of a nuclear warhead at ground level [n]\n",
  "GROUNDED": "GROUND, to place on a foundation [v]\n",
  "GROUNDEDLY": "GROUNDED, GROUND, to place on a foundation [adv]\n",
  "GROUNDEN": "GRIND, to wear, smooth or sharpen by friction [v]\n",
  "GROUNDER": "in baseball, a ball that keeps low [n -S]\n",
  "GROUNDERS": "GROUNDER, in baseball, a ball that keeps low [n]\n",
  "GROUNDFISH": "a marine fish that is found at the bottom e.g. cod, haddock [n -ES]\n",
  "GROUNDFISHES": "GROUNDFISH, a marine fish that is found at the bottom e.g. cod, haddock [n]\n",
  "GROUNDHOG": "a woodchuck [n -S]\n",
  "GROUNDHOGS": "GROUNDHOG, a woodchuck [n]\n",
  "GROUNDING": "a foundation [n -S]\n",
  "GROUNDINGS": "GROUNDING, a foundation [n]\n",
  "GROUNDLESS": "having no ground or foundation [adj GROUNDLESSLY]\n",
  "GROUNDLESSLY": "GROUNDLESS, having no ground or foundation [adv]\n",
  "GROUNDLESSNESS": "GROUNDLESS, having no ground or foundation [n]\n",
  "GROUNDLING": "a spectator who stood in the pit of an Elizabethan theater; a person of unsophisticated taste [n -S]\n",
  "GROUNDLINGS": "GROUNDLING, a spectator who stood in the pit of an Elizabethan theater; a person of unsophisticated taste [n]\n",
  "GROUNDMAN": "one who takes care of a (sports) ground, also GROUNDSMAN [n GROUNDMEN]\n",
  "GROUNDMASS": "the fine-grained part of an igneous rock, in which the larger crystals are embedded [n -ES]\n",
  "GROUNDMASSES": "GROUNDMASS, the fine-grained part of an igneous rock, in which the larger crystals are embedded [n]\n",
  "GROUNDMEN": "GROUNDMAN, one who takes care of a (sports) ground, also GROUNDSMAN [n]\n",
  "GROUNDNUT": "the peanut or monkey-nut [n -S]\n",
  "GROUNDNUTS": "GROUNDNUT, the peanut or monkey-nut [n]\n",
  "GROUNDOUT": "a play in baseball in which a batter is given out after hitting a grounder to an infielder [n -S]\n",
  "GROUNDOUTS": "GROUNDOUT, a play in baseball in which a batter is given out after hitting a grounder to an infielder [n]\n",
  "GROUNDPLOT": "the plot of ground on which a building stands [n -S]\n",
  "GROUNDPLOTS": "GROUNDPLOT, the plot of ground on which a building stands [n]\n",
  "GROUNDPROX": "an altitude warning system in aircraft [n -ES]\n",
  "GROUNDPROXES": "GROUNDPROX, an altitude warning system in aircraft [n]\n",
  "GROUNDS": "GROUND, to place on a foundation [v]\n",
  "GROUNDSEL": "the lowest timber of a structure, also GROUNDSELL, GROUNDSILL [n -S]\n",
  "GROUNDSELL": "the lowest timber of a structure, also GROUNDSEL, GROUNDSILL [n -S]\n",
  "GROUNDSELLS": "GROUNDSELL, the lowest timber of a structure, also GROUNDSEL, GROUNDSILL [n]\n",
  "GROUNDSELS": "GROUNDSEL, the lowest timber of a structure, also GROUNDSELL, GROUNDSILL [n]\n",
  "GROUNDSHARE": "to share a sports stadium with another team [v GROUNDSHARED, GROUNDSHARING, GROUNDSHARES]\n",
  "GROUNDSHARED": "GROUNDSHARE, to share a sports stadium with another team [v]\n",
  "GROUNDSHARES": "GROUNDSHARE, to share a sports stadium with another team [v]\n",
  "GROUNDSHARING": "GROUNDSHARE, to share a sports stadium with another team [v]\n",
  "GROUNDSHEET": "a waterproof sheet spread on the ground in a tent etc. [n -S]\n",
  "GROUNDSHEETS": "GROUNDSHEET, a waterproof sheet spread on the ground in a tent etc. [n]\n",
  "GROUNDSILL": "the lowest timber of a structure, also GROUNDSEL, GROUNDSELL [n -S]\n",
  "GROUNDSILLS": "GROUNDSILL, the lowest timber of a structure, also GROUNDSEL, GROUNDSELL [n]\n",
  "GROUNDSKEEPER": "a person who cares for the grounds of a usually large property (as a sports field) [n -S]\n",
  "GROUNDSKEEPERS": "GROUNDSKEEPER, a person who cares for the grounds of a usually large property (as a sports field) [n]\n",
  "GROUNDSMAN": "one who takes care of a (sports) ground, also GROUNDMAN [n GROUNDSMEN]\n",
  "GROUNDSMEN": "GROUNDSMAN, one who takes care of a (sports) ground, also GROUNDMAN [n]\n",
  "GROUNDSPEED": "the speed of an aircraft relative to the ground [n -S]\n",
  "GROUNDSPEEDS": "GROUNDSPEED, the speed of an aircraft relative to the ground [n]\n",
  "GROUNDSWELL": "a broad, deep undulation of the ocean caused by a distant gale or earthquake [n -S]\n",
  "GROUNDSWELLS": "GROUNDSWELL, a broad, deep undulation of the ocean caused by a distant gale or earthquake [n]\n",
  "GROUNDWATER": "water within the earth esp. that supplies wells and springs [n -S]\n",
  "GROUNDWATERS": "GROUNDWATER, water within the earth esp. that supplies wells and springs [n]\n",
  "GROUNDWOOD": "wood found lying on the ground [n -S]\n",
  "GROUNDWOODS": "GROUNDWOOD, wood found lying on the ground [n]\n",
  "GROUNDWORK": "that which forms the ground or foundation of anything [n -S]\n",
  "GROUNDWORKS": "GROUNDWORK, that which forms the ground or foundation of anything [n]\n",
  "GROUP": "to arrange in a group (a collection) [v -ED, -ING, -S]\n",
  "GROUPABLE": "that can be grouped [adj]\n",
  "GROUPAGE": "collection of objects into groups [n -S]\n",
  "GROUPAGES": "GROUPAGE, collection of objects into groups [n]\n",
  "GROUPED": "GROUP, to arrange in a group (a collection) [v]\n",
  "GROUPER": "one of several species of valuable food fishes, found esp. round Florida and the Gulf of Mexico [n -S]\n",
  "GROUPERS": "GROUPER, one of several species of valuable food fishes, found esp. round Florida and the Gulf of Mexico [n]\n",
  "GROUPIE": "a female follower of rock groups, also GROUPY [n -S]\n",
  "GROUPIES": "GROUPY, a follower of a pop group, also GROUPIE [n]\n",
  "GROUPING": "a set of objects [n -S]\n",
  "GROUPINGS": "GROUPING, a set of objects [n]\n",
  "GROUPIST": "someone who belongs to a group [n -S]\n",
  "GROUPISTS": "GROUPIST, someone who belongs to a group [n]\n",
  "GROUPLET": "a small group, a clique [n -S]\n",
  "GROUPLETS": "GROUPLET, a small group, a clique [n]\n",
  "GROUPOID": "a type of mathematical set [n -S]\n",
  "GROUPOIDS": "GROUPOID, a type of mathematical set [n]\n",
  "GROUPS": "GROUP, to arrange in a group (a collection) [v]\n",
  "GROUPTHINK": "a pattern of thought characterized by self-deception and conformity to group values [n -S]\n",
  "GROUPTHINKS": "GROUPTHINK, a pattern of thought characterized by self-deception and conformity to group values [n]\n",
  "GROUPUSCULE": "a small clique or faction [n -S]\n",
  "GROUPUSCULES": "GROUPUSCULE, a small clique or faction [n]\n",
  "GROUPWARE": "software that supports group activity [n -S]\n",
  "GROUPWARES": "GROUPWARE, software that supports group activity [n]\n",
  "GROUPWORK": "work carried out by a number of people acting together [n -S]\n",
  "GROUPWORKS": "GROUPWORK, work carried out by a number of people acting together [n]\n",
  "GROUPY": "a follower of a pop group, also GROUPIE [n GROUPIES]\n",
  "GROUSE": "to complain [v GROUSED, GROUSING, GROUSES] / very good [adj GROUSER, GROUSEST]\n",
  "GROUSED": "GROUSE, to complain [v]\n",
  "GROUSELIKE": "like a grouse [adj]\n",
  "GROUSER": "one who grouses [n -S]\n",
  "GROUSERS": "GROUSER, one who grouses [n]\n",
  "GROUSES": "GROUSE, to complain [v]\n",
  "GROUSEST": "GROUSE, very good [adj]\n",
  "GROUSING": "GROUSE, to complain [v]\n",
  "GROUT": "to fill a crack with thin mortar [v -ED, -ING, -S]\n",
  "GROUTED": "GROUT, to fill a crack with thin mortar [v]\n",
  "GROUTER": "an instrument or tool for grouting a wall etc. [n -S]\n",
  "GROUTERS": "GROUTER, an instrument or tool for grouting a wall etc. [n]\n",
  "GROUTIER": "GROUTY, sulky [adj]\n",
  "GROUTIEST": "GROUTY, sulky [adj]\n",
  "GROUTING": "thin mortar used to fill cracks [n -S]\n",
  "GROUTINGS": "GROUTING, thin mortar used to fill cracks [n]\n",
  "GROUTS": "GROUT, to fill a crack with thin mortar [v]\n",
  "GROUTY": "sulky [adj GROUTIER, GROUTIEST]\n",
  "GROVE": "a small forested area [n -S]\n",
  "GROVED": "covered with a grove [adj]\n",
  "GROVEL": "to crawl in an abject manner [v GROVELED or GROVELLED, GROVELING or GROVELLING, GROVELS]\n",
  "GROVELED": "GROVEL, to crawl in an abject manner [v]\n",
  "GROVELER": "(US) one who grovels, also GROVELLER [n -S]\n",
  "GROVELERS": "GROVELER, (US) one who grovels, also GROVELLER [n]\n",
  "GROVELESS": "without groves [adj]\n",
  "GROVELING": "the act of humbling oneself [n -S]\n",
  "GROVELINGLY": "GROVELING [adv]\n",
  "GROVELINGS": "GROVELING, the act of humbling oneself [n]\n",
  "GROVELLED": "GROVEL, to crawl in an abject manner [v]\n",
  "GROVELLER": "one who grovels, also GROVELER [n -S]\n",
  "GROVELLERS": "GROVELLER, one who grovels, also GROVELER [n]\n",
  "GROVELLING": "the act of humbling oneself [n -S]\n",
  "GROVELLINGLY": "in a grovelling way [adv]\n",
  "GROVELLINGS": "GROVELLING, the act of humbling oneself [n]\n",
  "GROVELS": "GROVEL, to crawl in an abject manner [v]\n",
  "GROVES": "GROVE, a small forested area [n]\n",
  "GROVET": "a wrestling hold where the head is gripped and forced to the floor [n -S]\n",
  "GROVETS": "GROVET, a wrestling hold where the head is gripped and forced to the floor [n]\n",
  "GROVIER": "GROVY, like a grove [adj]\n",
  "GROVIEST": "GROVY, like a grove [adj]\n",
  "GROVY": "like a grove [adj GROVIER, GROVIEST]\n",
  "GROW": "to cultivate [v GREW, GROWN, GROWING, GROWS]\n",
  "GROWABLE": "able to be grown [adj]\n",
  "GROWER": "one that grows [n -S]\n",
  "GROWERS": "GROWER, one that grows [n]\n",
  "GROWING": "increasing [adj GROWINGLY] / the act of growing [n -S]\n",
  "GROWINGLY": "GROWING, increasing [adv]\n",
  "GROWINGS": "GROWING, the act of growing [n]\n",
  "GROWL": "to utter a deep harsh sound [v -ED, -ING, -S]\n",
  "GROWLED": "GROWL, to utter a deep harsh sound [v]\n",
  "GROWLER": "one who growls; a small iceberg [n -S]\n",
  "GROWLERIES": "GROWLERY, a retreat for times of ill-humour [n]\n",
  "GROWLERS": "GROWLER, one who growls; a small iceberg [n]\n",
  "GROWLERY": "a retreat for times of ill-humour [n GROWLERIES]\n",
  "GROWLIER": "GROWLY, deep and harsh in speech [adj]\n",
  "GROWLIEST": "GROWLY, deep and harsh in speech [adj]\n",
  "GROWLINESS": "the state of being growly [n -ES]\n",
  "GROWLINESSES": "GROWLINESS, the state of being growly [n]\n",
  "GROWLING": "with a growl [adj GROWLINGLY] / the act of growling [n -S]\n",
  "GROWLINGLY": "GROWLING, with a growl [adv]\n",
  "GROWLINGS": "GROWLING, the act of growling [n]\n",
  "GROWLS": "GROWL, to utter a deep harsh sound [v]\n",
  "GROWLY": "deep and harsh in speech [adj GROWLIER, GROWLIEST]\n",
  "GROWN": "GROW, to cultivate [v]\n",
  "GROWNUP": "a mature person [n -S]\n",
  "GROWNUPS": "GROWNUP, a mature person [n]\n",
  "GROWS": "GROW, to cultivate [v]\n",
  "GROWTH": "development [n -S]\n",
  "GROWTHIER": "GROWTHY, exceptionally fast in growing [adj]\n",
  "GROWTHIEST": "GROWTHY, exceptionally fast in growing [adj]\n",
  "GROWTHINESS": "the state of being growthy, very fast in growing [n -ES]\n",
  "GROWTHINESSES": "GROWTHINESS, the state of being growthy, very fast in growing [n]\n",
  "GROWTHIST": "a person who is committed to growth, esp. economic [n -S]\n",
  "GROWTHISTS": "GROWTHIST, a person who is committed to growth, esp. economic [n]\n",
  "GROWTHS": "GROWTH, development [n]\n",
  "GROWTHY": "exceptionally fast in growing [adj GROWTHIER, GROWTHIEST]\n",
  "GROYNE": "a breakwater, a structure which protects a shore from erosion [n -S]\n",
  "GROYNES": "GROYNE, a breakwater, a structure which protects a shore from erosion [n]\n",
  "GROZING": "as in grozing iron, a plumber's tool for soldering lead pipes [adj]\n",
  "GRR": "an interjection used to express anger or annoyance [interj]\n",
  "GRRL": "as in riot grrl, a young woman who plays or enjoys an aggressively feminist style of punk rock music, also GRRRL [n -S]\n",
  "GRRLS": "GRRL, as in riot grrl, a young woman who plays or enjoys an aggressively feminist style of punk rock music, also GRRRL [n]\n",
  "GRRRL": "as in riot grrrl, a young woman who plays or enjoys an aggressively feminist style of punk rock music, also GRRL [n -S]\n",
  "GRRRLS": "GRRRL, as in riot grrrl, a young woman who plays or enjoys an aggressively feminist style of punk rock music, also GRRL [n]\n",
  "GRUB": "to dig around in the dirt [v GRUBBED, GRUBBING, GRUBS]\n",
  "GRUBBED": "GRUB, to dig around in the dirt [v]\n",
  "GRUBBER": "an implement for grubbing or stirring the soil [n -S]\n",
  "GRUBBERS": "GRUBBER, an implement for grubbing or stirring the soil [n]\n",
  "GRUBBIER": "GRUBBY, dirty [adj]\n",
  "GRUBBIEST": "GRUBBY, dirty [adj]\n",
  "GRUBBILY": "GRUBBY, dirty [adv]\n",
  "GRUBBINESS": "the state of being grubby [n -ES]\n",
  "GRUBBINESSES": "GRUBBINESS, the state of being grubby [n]\n",
  "GRUBBING": "GRUB, to dig around in the dirt [v]\n",
  "GRUBBLE": "to grope, also GRABBLE [v GRUBBLED, GRUBBLING, GRUBBLES]\n",
  "GRUBBLED": "GRUBBLE, to grope, also GRABBLE [v]\n",
  "GRUBBLES": "GRUBBLE, to grope, also GRABBLE [v]\n",
  "GRUBBLING": "GRUBBLE, to grope, also GRABBLE [v]\n",
  "GRUBBY": "dirty [adj GRUBBIER, GRUBBIEST, GRUBBILY]\n",
  "GRUBS": "GRUB, to dig around in the dirt [v]\n",
  "GRUBSTAKE": "to provide with funds for an enterprise [v GRUBSTAKED, GRUBSTAKING, GRUBSTAKES]\n",
  "GRUBSTAKED": "GRUBSTAKE, to provide with funds for an enterprise [v]\n",
  "GRUBSTAKER": "one who provides a grubstake [n -S]\n",
  "GRUBSTAKERS": "GRUBSTAKER, one who provides a grubstake [n]\n",
  "GRUBSTAKES": "GRUBSTAKE, to provide with funds for an enterprise [v]\n",
  "GRUBSTAKING": "GRUBSTAKE, to provide with funds for an enterprise [v]\n",
  "GRUBSTREET": "relating to or characteristic of hack literature [adj]\n",
  "GRUBWORM": "the larva of some insects [n -S]\n",
  "GRUBWORMS": "GRUBWORM, the larva of some insects [n]\n",
  "GRUDGE": "to be unwilling to give or admit, also GRUTCH [v GRUDGED, GRUDGING, GRUDGES]\n",
  "GRUDGED": "GRUDGE, to be unwilling to give or admit, also GRUTCH [v]\n",
  "GRUDGEFUL": "(Spenser) full of grudge; envious [adj]\n",
  "GRUDGELESS": "without a grudge [adj]\n",
  "GRUDGER": "one who grudges [n -S]\n",
  "GRUDGERS": "GRUDGER, one who grudges [n]\n",
  "GRUDGES": "GRUDGE, to be unwilling to give or admit, also GRUTCH [v]\n",
  "GRUDGING": "reluctant [adj GRUDGINGLY] / the act of grudging [n -S]\n",
  "GRUDGINGLY": "GRUDGING, reluctant [adv]\n",
  "GRUDGINGS": "GRUDGING, the act of grudging [n]\n",
  "GRUE": "to shudder, feel the flesh creep, also GREW [v GRUED, GRUEING or GRUING, GRUES]\n",
  "GRUED": "GRUE, to shudder, feel the flesh creep, also GREW [v]\n",
  "GRUEING": "GRUE, to shudder, feel the flesh creep, also GREW [v]\n",
  "GRUEL": "to disable by hard work [v GRUELED or GRUELLED, GRUELING or GRUELLING, GRUELS]\n",
  "GRUELED": "GRUEL, to disable by hard work [v]\n",
  "GRUELER": "one that gruels, also GRUELLER [n -S]\n",
  "GRUELERS": "GRUELER, one that gruels, also GRUELLER [n]\n",
  "GRUELING": "exhausting [adj GRUELINGLY] / an exhausting experience [n -S]\n",
  "GRUELINGLY": "GRUELING, exhausting [adv]\n",
  "GRUELINGS": "GRUELING, an exhausting experience [n]\n",
  "GRUELLED": "GRUEL, to disable by hard work [v]\n",
  "GRUELLER": "one that gruels, also GRUELER [n -S]\n",
  "GRUELLERS": "GRUELLER, one that gruels, also GRUELER [n]\n",
  "GRUELLING": "exhausting [adj GRUELLINGLY] / the act of gruelling [n -S]\n",
  "GRUELLINGLY": "in the manner of being disabled by hard work [adv]\n",
  "GRUELLINGS": "GRUELLING, the act of gruelling [n]\n",
  "GRUELS": "GRUEL, to disable by hard work [v]\n",
  "GRUES": "GRUE, to shudder, feel the flesh creep, also GREW [v]\n",
  "GRUESOME": "repugnant, also GREWSOME [adj GRUESOMER, GRUESOMEST, GRUESOMELY]\n",
  "GRUESOMELY": "GRUESOME, repugnant, also GREWSOME [adv]\n",
  "GRUESOMENESS": "the state of being gruesome [n -ES]\n",
  "GRUESOMENESSES": "GRUESOMENESS, the state of being gruesome [n]\n",
  "GRUESOMER": "GRUESOME, repugnant, also GREWSOME [adj]\n",
  "GRUESOMEST": "GRUESOME, repugnant, also GREWSOME [adj]\n",
  "GRUFE": "(Scots) the face, also GROOF, GROUF [n -S]\n",
  "GRUFES": "GRUFE, (Scots) the face, also GROOF, GROUF [n]\n",
  "GRUFF": "to utter in a gruff voice [v -ED, -ING, -S] / low and harsh in speech [adj GRUFFER, GRUFFEST, GRUFFLY]\n",
  "GRUFFED": "GRUFF, to utter in a gruff voice [v]\n",
  "GRUFFER": "GRUFF, low and harsh in speech [adj]\n",
  "GRUFFEST": "GRUFF, low and harsh in speech [adj]\n",
  "GRUFFIER": "GRUFFY, low and harsh in speech [adj]\n",
  "GRUFFIEST": "GRUFFY, low and harsh in speech [adj]\n",
  "GRUFFILY": "GRUFFY, low and harsh in speech [adv]\n",
  "GRUFFING": "GRUFF, to utter in a gruff voice [v]\n",
  "GRUFFISH": "somewhat gruff [adj]\n",
  "GRUFFLY": "GRUFF, low and harsh in speech [adv]\n",
  "GRUFFNESS": "the state of being gruff [n -ES]\n",
  "GRUFFNESSES": "GRUFFNESS, the state of being gruff [n]\n",
  "GRUFFS": "GRUFF, to utter in a gruff voice [v]\n",
  "GRUFFY": "low and harsh in speech [adj GRUFFIER, GRUFFIEST, GRUFFILY]\n",
  "GRUFTED": "(dialect) dirty; begrimed [adj]\n",
  "GRUGRU": "(Caribbean) a West Indian name for several kinds of palm [n -S]\n",
  "GRUGRUS": "GRUGRU, (Caribbean) a West Indian name for several kinds of palm [n]\n",
  "GRUIFORM": "designating an order of birds [adj]\n",
  "GRUING": "GRUE, to shudder, feel the flesh creep, also GREW [v]\n",
  "GRUM": "glum, morose [adj GRUMMER, GRUMMEST, GRUMLY]\n",
  "GRUMBLE": "to mutter in discontent [v GRUMBLED, GRUMBLING, GRUMBLES]\n",
  "GRUMBLED": "GRUMBLE, to mutter in discontent [v]\n",
  "GRUMBLER": "one that grumbles [n -S]\n",
  "GRUMBLERS": "GRUMBLER, one that grumbles [n]\n",
  "GRUMBLES": "GRUMBLE, to mutter in discontent [v]\n",
  "GRUMBLIER": "GRUMBLY, muttering in discontent [adj]\n",
  "GRUMBLIEST": "GRUMBLY, muttering in discontent [adj]\n",
  "GRUMBLING": "muttering in discontent [adj GRUMBLINGLY] / the act of grumbling [n -S]\n",
  "GRUMBLINGLY": "GRUMBLING, muttering in discontent [adv]\n",
  "GRUMBLINGS": "GRUMBLING, the act of grumbling [n]\n",
  "GRUMBLY": "muttering in discontent [adj GRUMBLIER, GRUMBLIEST]\n",
  "GRUME": "a thick viscid substance; a clot, as of blood [n -S]\n",
  "GRUMES": "GRUME, a thick viscid substance; a clot, as of blood [n]\n",
  "GRUMLY": "GRUM, glum, morose [adv]\n",
  "GRUMMER": "GRUM, glum, morose [adj]\n",
  "GRUMMEST": "GRUM, glum, morose [adj]\n",
  "GRUMMET": "a reinforcing ring of metal [n -S] / to fit with grummets, also GROMMET, GROMET [v -ED, -ING, -S]\n",
  "GRUMMETED": "GRUMMET, to fit with grummets, also GROMMET, GROMET [v]\n",
  "GRUMMETING": "GRUMMET, to fit with grummets, also GROMMET, GROMET [v]\n",
  "GRUMMETS": "GRUMMET, to fit with grummets, also GROMMET, GROMET [v]\n",
  "GRUMNESS": "the quality of being grum, glum, morose [n -ES]\n",
  "GRUMNESSES": "GRUMNESS, the quality of being grum, glum, morose [n]\n",
  "GRUMOSE": "consisting of clustered grains, also GRUMOUS [adj]\n",
  "GRUMOUS": "consisting of clustered grains, also GRUMOSE [adj]\n",
  "GRUMP": "to grumble [v -ED, -ING, -S]\n",
  "GRUMPED": "GRUMP, to grumble [v]\n",
  "GRUMPH": "(Scots) to grunt [v -ED, -ING, -S]\n",
  "GRUMPHED": "GRUMPH, (Scots) to grunt [v]\n",
  "GRUMPHIE": "(Scots) a pig, also GRUMPHY [n -S]\n",
  "GRUMPHIES": "GRUMPHY, (Scots) a pig, also GRUMPHIE [n]\n",
  "GRUMPHING": "GRUMPH, (Scots) to grunt [v]\n",
  "GRUMPHS": "GRUMPH, (Scots) to grunt [v]\n",
  "GRUMPHY": "(Scots) a pig, also GRUMPHIE [n GRUMPHIES]\n",
  "GRUMPIER": "GRUMPY, bad-tempered [adj]\n",
  "GRUMPIES": "GRUMPY, a bad-tempered person [n]\n",
  "GRUMPIEST": "GRUMPY, bad-tempered [adj]\n",
  "GRUMPILY": "GRUMPY, bad-tempered [adv]\n",
  "GRUMPINESS": "the state of being grumpy [n -ES]\n",
  "GRUMPINESSES": "GRUMPINESS, the state of being grumpy [n]\n",
  "GRUMPING": "GRUMP, to grumble [v]\n",
  "GRUMPISH": "grumpy [adj GRUMPISHLY]\n",
  "GRUMPISHLY": "GRUMPISH, grumpy [adv]\n",
  "GRUMPISHNESS": "the state of being grumpish [n -ES]\n",
  "GRUMPISHNESSES": "GRUMPISHNESS, the state of being grumpish [n]\n",
  "GRUMPS": "GRUMP, to grumble [v]\n",
  "GRUMPY": "bad-tempered [adj GRUMPIER, GRUMPIEST, GRUMPILY] / a bad-tempered person [n GRUMPIES]\n",
  "GRUND": "as in Scots grund mail, payment for right of burial [adj]\n",
  "GRUNDIES": "(New Zealand colloquial) men's underpants [n]\n",
  "GRUNDLE": "(US slang) the perineum [n -S]\n",
  "GRUNDLES": "GRUNDLE, (US slang) the perineum [n]\n",
  "GRUNGE": "dirt, grime [n -S]\n",
  "GRUNGER": "a fan of a style of rock music and associated fashions [n -S]\n",
  "GRUNGERS": "GRUNGER, a fan of a style of rock music and associated fashions [n]\n",
  "GRUNGES": "GRUNGE, dirt, grime [n]\n",
  "GRUNGEY": "dirty, messy; unattractive, also GRUNGY [adj GRUNGIER, GRUNGIEST]\n",
  "GRUNGIER": "GRUNGEY, dirty, messy; unattractive, also GRUNGY [adj]\n",
  "GRUNGIEST": "GRUNGEY, dirty, messy; unattractive, also GRUNGY [adj]\n",
  "GRUNGY": "dirty, messy, also GRUNGEY [adj GRUNGIER, GRUNGIEST]\n",
  "GRUNION": "a small Californian sea-fish which spawns on shore [n -S]\n",
  "GRUNIONS": "GRUNION, a small Californian sea-fish which spawns on shore [n]\n",
  "GRUNT": "to utter a deep guttural sound [v -ED, -ING, -S]\n",
  "GRUNTED": "GRUNT, to utter a deep guttural sound [v]\n",
  "GRUNTER": "one who, or that which, grunts; specifically, a hog [n -S]\n",
  "GRUNTERS": "GRUNTER, one who, or that which, grunts; specifically, a hog [n]\n",
  "GRUNTING": "making a grunt [adj GRUNTINGLY] / the act of making deep guttural sounds [n -S]\n",
  "GRUNTINGLY": "GRUNTING, making a grunt [adv]\n",
  "GRUNTINGS": "GRUNTING, the act of making deep guttural sounds [n]\n",
  "GRUNTLE": "(dialect) to put in good humour [v GRUNTLED, GRUNTLING, GRUNTLES]\n",
  "GRUNTLED": "GRUNTLE, (dialect) to put in good humour [v]\n",
  "GRUNTLES": "GRUNTLE, (dialect) to put in good humour [v]\n",
  "GRUNTLING": "GRUNTLE, (dialect) to put in good humour [v]\n",
  "GRUNTS": "GRUNT, to utter a deep guttural sound [v]\n",
  "GRUPPETTI": "GRUPPETTO, (Italian) a turn [n]\n",
  "GRUPPETTO": "(Italian) a turn [n GRUPPETTI]\n",
  "GRUSHIE": "(Scots) healthy, thriving [adj]\n",
  "GRUTCH": "(Spenser) to grudge [v -ED, -ING, -ES]\n",
  "GRUTCHED": "GRUTCH, (Spenser) to grudge [v]\n",
  "GRUTCHES": "GRUTCH, (Spenser) to grudge [v]\n",
  "GRUTCHING": "GRUTCH, (Spenser) to grudge [v]\n",
  "GRUTTEN": "GREET, to address in a friendly and courteous way [v]\n",
  "GRUYERE": "(French) a kind of cheese made at Gruyere, Switzerland [n -S]\n",
  "GRUYERES": "GRUYERE, (French) a kind of cheese made at Gruyere, Switzerland [n]\n",
  "GRYCE": "a young boar [n -S]\n",
  "GRYCES": "GRYCE, a young boar [n]\n",
  "GRYDE": "to scrape harshly, also GRIDE [v GRYDED, GRYDING, GRYDES]\n",
  "GRYDED": "GRYDE, to scrape harshly, also GRIDE [v]\n",
  "GRYDES": "GRYDE, to scrape harshly, also GRIDE [v]\n",
  "GRYDING": "GRYDE, to scrape harshly, also GRIDE [v]\n",
  "GRYESY": "(Spenser) grim, also GRISY, GRIESIE, GRIESY, GRYSIE [adj]\n",
  "GRYFON": "a fabled animal part lion and part eagle, also GRIFFIN, GRYPHON [n -S]\n",
  "GRYFONS": "GRYFON, a fabled animal part lion and part eagle, also GRIFFIN, GRYPHON [n]\n",
  "GRYKE": "(Old Norse) a crevice in a limestone pavement, also GRIKE [n -S]\n",
  "GRYKES": "GRYKE, (Old Norse) a crevice in a limestone pavement, also GRIKE [n]\n",
  "GRYPE": "(archaic) a griffin [n -S]\n",
  "GRYPES": "GRYPE, (archaic) a griffin [n]\n",
  "GRYPHON": "a fabled animal part lion and part eagle, also GRIFFIN, GRYFON [n -S]\n",
  "GRYPHONS": "GRYPHON, a fabled animal part lion and part eagle, also GRIFFIN, GRYFON [n]\n",
  "GRYPT": "GRIPE, to keep on complaining [v]\n",
  "GRYSBOK": "(South African) a small South African antelope, speckled with gray and chestnut [n -S]\n",
  "GRYSBOKS": "GRYSBOK, (South African) a small South African antelope, speckled with gray and chestnut [n]\n",
  "GRYSELY": "(Spenser) grisly, also GREISLY, GRIESLY, GRISELY, GRISLY [adj]\n",
  "GRYSIE": "(Spenser) grim, also GRISY, GRIESIE, GRIESY, GRYESY [adj]\n",
  "GU": "(Old Norse) an old Shetland viol, also GUE, GJU [n -S]\n",
  "GUACAMOLE": "(Nahuatl) a kind of dip, also GUACHAMOLE [n -S]\n",
  "GUACAMOLES": "GUACAMOLE, (Nahuatl) a kind of dip, also GUACHAMOLE [n]\n",
  "GUACHAMOLE": "(Nahuatl) a kind of dip, also GUACAMOLE [n -S]\n",
  "GUACHAMOLES": "GUACHAMOLE, (Nahuatl) a kind of dip, also GUACAMOLE [n]\n",
  "GUACHARO": "(Spanish) a nocturnal bird of South America and Trinidad, aka oilbird [n -ES or -S]\n",
  "GUACHAROES": "GUACHARO, (Spanish) a nocturnal bird of South America and Trinidad, aka oilbird [n]\n",
  "GUACHAROS": "GUACHARO, (Spanish) a nocturnal bird of South America and Trinidad, aka oilbird [n]\n",
  "GUACO": "(Spanish) any of several tropical American plants used as antidotes to snakebites [n -S]\n",
  "GUACOS": "GUACO, (Spanish) any of several tropical American plants used as antidotes to snakebites [n]\n",
  "GUAIAC": "a medicinal resin obtained from a South American tree, also GUAIACUM, GUAIOCUM [n -S]\n",
  "GUAIACOL": "an expectorant and local anaesthetic [n -S]\n",
  "GUAIACOLS": "GUAIACOL, an expectorant and local anaesthetic [n]\n",
  "GUAIACS": "GUAIAC, a medicinal resin obtained from a South American tree, also GUAIACUM, GUAIOCUM [n]\n",
  "GUAIACUM": "a medicinal resin, also GUAIAC, GUAIOCUM [n -S]\n",
  "GUAIACUMS": "GUAIACUM, a medicinal resin, also GUAIAC, GUAIOCUM [n]\n",
  "GUAIOCUM": "a medicinal resin, also GUAIACUM, GUAIAC [n -S]\n",
  "GUAIOCUMS": "GUAIOCUM, a medicinal resin, also GUAIACUM, GUAIAC [n]\n",
  "GUAN": "(Spanish) any of several tropical American plants used as antidotes to snakebites [n -S]\n",
  "GUANA": "any large lizard [n -S]\n",
  "GUANABANA": "a tropical tree or its fruit [n -S]\n",
  "GUANABANAS": "GUANABANA, a tropical tree or its fruit [n]\n",
  "GUANACO": "(Quechua) a South American mammal, allied to the llama, also HUANACO [n -S]\n",
  "GUANACOS": "GUANACO, (Quechua) a South American mammal, allied to the llama, also HUANACO [n]\n",
  "GUANAS": "GUANA, any large lizard [n]\n",
  "GUANASE": "an enzyme [n -S]\n",
  "GUANASES": "GUANASE, an enzyme [n]\n",
  "GUANAY": "a Peruvian cormorant [n -S]\n",
  "GUANAYS": "GUANAY, a Peruvian cormorant [n]\n",
  "GUANAZOLO": "a synthetic substance resembling guanine, used in the treatment of cancer [n -S]\n",
  "GUANAZOLOS": "GUANAZOLO, a synthetic substance resembling guanine, used in the treatment of cancer [n]\n",
  "GUANETHIDINE": "a drug used in the treatment of hypertension [n -S]\n",
  "GUANETHIDINES": "GUANETHIDINE, a drug used in the treatment of hypertension [n]\n",
  "GUANGO": "(Spanish) the rain tree [n -S]\n",
  "GUANGOS": "GUANGO, (Spanish) the rain tree [n]\n",
  "GUANIDIN": "a strongly basic compound used in organic synthesis, also GUANIDINE [n -S]\n",
  "GUANIDINE": "a strongly basic compound used in organic synthesis, also GUANIDIN [n -S]\n",
  "GUANIDINES": "GUANIDINE, a strongly basic compound used in organic synthesis, also GUANIDIN [n]\n",
  "GUANIDINS": "GUANIDIN, a strongly basic compound used in organic synthesis, also GUANIDINE [n]\n",
  "GUANIFEROUS": "bearing guano [adj]\n",
  "GUANIN": "a yellowish-white, amorphous substance, forming a constituent of nucleic acids, also GUANINE [n -S]\n",
  "GUANINE": "a yellowish-white, amorphous substance, forming a constituent of nucleic acids, also GUANIN [n -S]\n",
  "GUANINES": "GUANINE, a yellowish-white, amorphous substance, forming a constituent of nucleic acids, also GUANIN [n]\n",
  "GUANINS": "GUANIN, a yellowish-white, amorphous substance, forming a constituent of nucleic acids, also GUANINE [n]\n",
  "GUANO": "(Quechua) the accumulated excrement of sea birds [n -S]\n",
  "GUANOS": "GUANO, (Quechua) the accumulated excrement of sea birds [n]\n",
  "GUANOSINE": "a nucleoside composed of guanine and ribose [n -S]\n",
  "GUANOSINES": "GUANOSINE, a nucleoside composed of guanine and ribose [n]\n",
  "GUANS": "GUAN, (Spanish) any of several tropical American plants used as antidotes to snakebites [n]\n",
  "GUANXI": "(Chinese) a Chinese social concept based on the exchange of favours [n -S]\n",
  "GUANXIS": "GUANXI, (Chinese) a Chinese social concept based on the exchange of favours [n]\n",
  "GUANYLIC": "as in guanylic acid, a nucleotide that is a constituent of DNA [adj]\n",
  "GUAR": "(Hindi) a legume grown for forage and its seeds which yield guar gum [n -S]\n",
  "GUARACHA": "(Spanish) a flat-heeled sandal, also GUARACHE, GUARACHI, HUARACHE, HUARACHO [n -S]\n",
  "GUARACHAS": "GUARACHA, (Spanish) a flat-heeled sandal, also GUARACHE, GUARACHI, HUARACHE, HUARACHO [n]\n",
  "GUARACHE": "(Spanish) a flat-heeled sandal, also GUARACHA, GUARACHI, HUARACHE, HUARACHO [n -S]\n",
  "GUARACHES": "GUARACHE, (Spanish) a flat-heeled sandal, also GUARACHA, GUARACHI, HUARACHE, HUARACHO [n]\n",
  "GUARACHI": "(Spanish) a flat-heeled sandal, also GUARACHA, GUARACHE, HUARACHE, HUARACHO [n -S]\n",
  "GUARACHIS": "GUARACHI, (Spanish) a flat-heeled sandal, also GUARACHA, GUARACHE, HUARACHE, HUARACHO [n]\n",
  "GUARANA": "(Tupi) a caffeine-rich drink made from a Brazilian plant [n -S]\n",
  "GUARANAS": "GUARANA, (Tupi) a caffeine-rich drink made from a Brazilian plant [n]\n",
  "GUARANI": "(Tupi) a monetary unit of Paraguay [n GUARANIS or GUARANIES]\n",
  "GUARANIES": "GUARANI, (Tupi) a monetary unit of Paraguay [n]\n",
  "GUARANIS": "GUARANI, (Tupi) a monetary unit of Paraguay [n]\n",
  "GUARANTEE": "to give a formal promise that something will be done [v GUARANTEED, GUARANTEEING, GUARANTEES]\n",
  "GUARANTEED": "GUARANTEE, to give a formal promise that something will be done [v]\n",
  "GUARANTEEING": "GUARANTEE, to give a formal promise that something will be done [v]\n",
  "GUARANTEES": "GUARANTEE, to give a formal promise that something will be done [v]\n",
  "GUARANTIED": "GUARANTY, to assume responsibility for the quality of, also GUARANTEE [v]\n",
  "GUARANTIES": "GUARANTY, to assume responsibility for the quality of, also GUARANTEE [v]\n",
  "GUARANTOR": "one who makes or gives a guarantee [n -S]\n",
  "GUARANTORS": "GUARANTOR, one who makes or gives a guarantee [n]\n",
  "GUARANTY": "to assume responsibility for the quality of, also GUARANTEE [v GUARANTIED, GUARANTYING, GUARANTIES]\n",
  "GUARANTYING": "GUARANTY, to assume responsibility for the quality of, also GUARANTEE [v]\n",
  "GUARD": "to protect [v -ED, -ING, -S]\n",
  "GUARDABLE": "capable of being guarded or protected [adj]\n",
  "GUARDAGE": "(Shakespeare) the state of being under a guardian [n -S]\n",
  "GUARDAGES": "GUARDAGE, (Shakespeare) the state of being under a guardian [n]\n",
  "GUARDANT": "a guardian, also GARDANT [n -S]\n",
  "GUARDANTS": "GUARDANT, a guardian, also GARDANT [n]\n",
  "GUARDDOG": "a dog trained to guard persons or property [n -S]\n",
  "GUARDDOGS": "GUARDDOG, a dog trained to guard persons or property [n]\n",
  "GUARDED": "GUARD, to protect [v]\n",
  "GUARDEDLY": "GUARDED, GUARD, to protect [adv]\n",
  "GUARDEDNESS": "the state of being guarded [n -ES]\n",
  "GUARDEDNESSES": "GUARDEDNESS, the state of being guarded [n]\n",
  "GUARDEE": "a guardsman [n -S]\n",
  "GUARDEES": "GUARDEE, a guardsman [n]\n",
  "GUARDER": "one who guards [n -S]\n",
  "GUARDERS": "GUARDER, one who guards [n]\n",
  "GUARDHOUSE": "a building for the accommodation of a military guard, and where prisoners are confined [n -S]\n",
  "GUARDHOUSES": "GUARDHOUSE, a building for the accommodation of a military guard, and where prisoners are confined [n]\n",
  "GUARDIAN": "one that guards [n -S]\n",
  "GUARDIANS": "GUARDIAN, one that guards [n]\n",
  "GUARDIANSHIP": "the office of guardian [n -S]\n",
  "GUARDIANSHIPS": "GUARDIANSHIP, the office of guardian [n]\n",
  "GUARDING": "GUARD, to protect [v]\n",
  "GUARDLESS": "without a guard or defense [adj]\n",
  "GUARDLIKE": "like a guard [adj]\n",
  "GUARDRAIL": "a rail to prevent falling [n -S]\n",
  "GUARDRAILS": "GUARDRAIL, a rail to prevent falling [n]\n",
  "GUARDROOM": "a room having the same function as a guardhouse [n -S]\n",
  "GUARDROOMS": "GUARDROOM, a room having the same function as a guardhouse [n]\n",
  "GUARDS": "GUARD, to protect [v]\n",
  "GUARDSHIP": "guardianship [n -S]\n",
  "GUARDSHIPS": "GUARDSHIP, guardianship [n]\n",
  "GUARDSMAN": "a soldier of the Guards [n GUARDSMEN]\n",
  "GUARDSMEN": "GUARDSMAN, a soldier of the Guards [n]\n",
  "GUARISH": "(obsolete) to cure, heal, also GARISH [v -ED, -ING, -ES]\n",
  "GUARISHED": "GUARISH, (obsolete) to cure, heal, also GARISH [v]\n",
  "GUARISHES": "GUARISH, (obsolete) to cure, heal, also GARISH [v]\n",
  "GUARISHING": "GUARISH, (obsolete) to cure, heal, also GARISH [v]\n",
  "GUARS": "GUAR, (Hindi) a legume grown for forage and its seeds which yield guar gum [n]\n",
  "GUAVA": "(Spanish) a small tropical myrtaceous tree; its yellow, pear-shaped fruit [n -S]\n",
  "GUAVAS": "GUAVA, (Spanish) a small tropical myrtaceous tree; its yellow, pear-shaped fruit [n]\n",
  "GUAYABERA": "(Spanish) a short-sleeved, lightweight sports shirt designed to be worn untucked [n -S]\n",
  "GUAYABERAS": "GUAYABERA, (Spanish) a short-sleeved, lightweight sports shirt designed to be worn untucked [n]\n",
  "GUAYULE": "(Nahuatl) a silver-leaved shrub of the daisy family [n -S]\n",
  "GUAYULES": "GUAYULE, (Nahuatl) a silver-leaved shrub of the daisy family [n]\n",
  "GUB": "to strike on the mouth [v GUBBED, GUBBING, GUBS]\n",
  "GUBBAH": "(Native Australian) a white man, also GUB [n -S]\n",
  "GUBBAHS": "GUBBAH, (Native Australian) a white man, also GUB [n]\n",
  "GUBBED": "GUB, to strike on the mouth [v]\n",
  "GUBBING": "GUB, to strike on the mouth [v]\n",
  "GUBBINS": "(colloquial) a trivial object; a device, gadget [n -ES]\n",
  "GUBBINSES": "GUBBINS, (colloquial) a trivial object; a device, gadget [n]\n",
  "GUBERNACULA": "GUBERNACULUM, in mammals, the cord supporting the testicles in the scrotal sac [n]\n",
  "GUBERNACULAR": "relating to the gubernaculum, in mammals, the cord supporting the testicles in the scrotal sac [adj]\n",
  "GUBERNACULUM": "in mammals, the cord supporting the testicles in the scrotal sac [n GUBERNACULA]\n",
  "GUBERNATION": "control, rule [n -S]\n",
  "GUBERNATIONS": "GUBERNATION, control, rule [n]\n",
  "GUBERNATOR": "(Latin) a powerful man in government [n -S]\n",
  "GUBERNATORIAL": "belonging to a governor (esp. the Governor of an American state) or the office of governor [adj]\n",
  "GUBERNATORS": "GUBERNATOR, (Latin) a powerful man in government [n]\n",
  "GUBERNIYA": "(Russian) a territorial division of imperial Russia [n -S]\n",
  "GUBERNIYAS": "GUBERNIYA, (Russian) a territorial division of imperial Russia [n]\n",
  "GUBS": "GUB, to strike on the mouth [v]\n",
  "GUCK": "a messy substance [n -S]\n",
  "GUCKIER": "GUCKY, slimy, mucky [adj]\n",
  "GUCKIEST": "GUCKY, slimy, mucky [adj]\n",
  "GUCKS": "GUCK, a messy substance [n]\n",
  "GUCKY": "slimy, mucky [adj GUCKIER, GUCKIEST]\n",
  "GUDDLE": "(Scots) to catch fish by hand, also GUMP [v GUDDLED, GUDDLING, GUDDLES]\n",
  "GUDDLED": "GUDDLE, (Scots) to catch fish by hand, also GUMP [v]\n",
  "GUDDLES": "GUDDLE, (Scots) to catch fish by hand, also GUMP [v]\n",
  "GUDDLING": "GUDDLE, (Scots) to catch fish by hand, also GUMP [v]\n",
  "GUDE": "(Scots) good, also GUID [adj] / something that is good [n -S]\n",
  "GUDEMAN": "(Scots) the master of a household, also GOODMAN [n GUDEMEN]\n",
  "GUDEMEN": "GUDEMAN, (Scots) the master of a household, also GOODMAN [n]\n",
  "GUDES": "GUDE, something that is good [n]\n",
  "GUDESIRE": "(Scots) a grandfather, also GOODSIRE, GUTCHER [n -S]\n",
  "GUDESIRES": "GUDESIRE, (Scots) a grandfather, also GOODSIRE, GUTCHER [n]\n",
  "GUDEWIFE": "(Scots) the mistress of a household, also GOODWIFE [n GUDEWIVES]\n",
  "GUDEWIVES": "GUDEWIFE, (Scots) the mistress of a household, also GOODWIFE [n]\n",
  "GUDGEON": "to defraud, dupe [v -ED, -ING, -S]\n",
  "GUDGEONED": "GUDGEON, to defraud, dupe [v]\n",
  "GUDGEONING": "GUDGEON, to defraud, dupe [v]\n",
  "GUDGEONS": "GUDGEON, to defraud, dupe [v]\n",
  "GUE": "an old Shetland viol, also GJU, GU [n -S]\n",
  "GUELDER": "as in guelder rose, a shrub of the genus Viburnum with large white balls of flowers [adj]\n",
  "GUENON": "(French) a long-tailed monkey [n -S]\n",
  "GUENONS": "GUENON, (French) a long-tailed monkey [n]\n",
  "GUERDON": "a reward, a recompense [n -S] / to reward [v -ED, -ING, -S]\n",
  "GUERDONED": "GUERDON, to reward [v]\n",
  "GUERDONER": "one who guerdons, rewards [n -S]\n",
  "GUERDONERS": "GUERDONER, one who guerdons, rewards [n]\n",
  "GUERDONING": "GUERDON, to reward [v]\n",
  "GUERDONS": "GUERDON, to reward [v]\n",
  "GUEREZA": "(Somali) a large, longhaired, black-and-white African monkey, with a bushy tail [n -S]\n",
  "GUEREZAS": "GUEREZA, (Somali) a large, longhaired, black-and-white African monkey, with a bushy tail [n]\n",
  "GUERIDON": "(French) a small ornate stand or table [n -S]\n",
  "GUERIDONS": "GUERIDON, (French) a small ornate stand or table [n]\n",
  "GUERILLA": "a member of an irregular force engaging in warfare or in the harassment of an army, also GUERRILLA [n -S]\n",
  "GUERILLAISM": "the activities of guerillas, also GUERRILLAISM [n -S]\n",
  "GUERILLAISMS": "GUERILLAISM, the activities of guerillas, also GUERRILLAISM [n]\n",
  "GUERILLAS": "GUERILLA, a member of an irregular force engaging in warfare or in the harassment of an army, also GUERRILLA [n]\n",
  "GUERITE": "(French) a projecting turret for a sentry, as at the salient angles of works, or the acute angles of bastions [n -S]\n",
  "GUERITES": "GUERITE, (French) a projecting turret for a sentry, as at the salient angles of works, or the acute angles of bastions [n]\n",
  "GUERNSEY": "a close-fitting knitted woollen jersey [n -S]\n",
  "GUERNSEYS": "GUERNSEY, a close-fitting knitted woollen jersey [n]\n",
  "GUERRILLA": "a member of an irregular force engaging in warfare or in the harassment of an army, also GUERILLA [n -S]\n",
  "GUERRILLAISM": "the activities of guerrillas, also GUERILLAISM [n -S]\n",
  "GUERRILLAISMS": "GUERRILLAISM, the activities of guerrillas, also GUERILLAISM [n]\n",
  "GUERRILLAS": "GUERRILLA, a member of an irregular force engaging in warfare or in the harassment of an army, also GUERILLA [n]\n",
  "GUERRILLERO": "a guerrilla, someone who takes part in guerrilla warfare [n -S]\n",
  "GUERRILLEROS": "GUERRILLERO, a guerrilla, someone who takes part in guerrilla warfare [n]\n",
  "GUES": "GUE, an old Shetland viol, also GJU, GU [n]\n",
  "GUESS": "to form an opinion from little or no evidence [v -ED, -ING, -ES]\n",
  "GUESSABLE": "that can be guessed [adj]\n",
  "GUESSED": "GUESS, to form an opinion from little or no evidence [v]\n",
  "GUESSER": "one who guesses [n -S]\n",
  "GUESSERS": "GUESSER, one who guesses [n]\n",
  "GUESSES": "GUESS, to form an opinion from little or no evidence [v]\n",
  "GUESSING": "the process of making guesses [n -S]\n",
  "GUESSINGLY": "GUESSING [adv]\n",
  "GUESSINGS": "GUESSING, the process of making guesses [n]\n",
  "GUESSTIMATE": "to estimate without adequate information, also GUESTIMATE [v GUESSTIMATED, GUESSTIMATING, GUESSTIMATES]\n",
  "GUESSTIMATED": "GUESSTIMATE, to estimate without adequate information, also GUESTIMATE [v]\n",
  "GUESSTIMATES": "GUESSTIMATE, to estimate without adequate information, also GUESTIMATE [v]\n",
  "GUESSTIMATING": "GUESSTIMATE, to estimate without adequate information, also GUESTIMATE [v]\n",
  "GUESSWORK": "the process or result of guessing [n -S]\n",
  "GUESSWORKS": "GUESSWORK, the process or result of guessing [n]\n",
  "GUEST": "to appear as a visitor [v -ED, -ING, -S]\n",
  "GUESTBOOK": "a book in a museum, hotel etc. in which a visitor can comment on his or her visit to that place [n -S]\n",
  "GUESTBOOKS": "GUESTBOOK, a book in a museum, hotel etc. in which a visitor can comment on his or her visit to that place [n]\n",
  "GUESTED": "GUEST, to appear as a visitor [v]\n",
  "GUESTEN": "(obsolete) to stay as a guest [v -ED, -ING, -S]\n",
  "GUESTENED": "GUESTEN, (obsolete) to stay as a guest [v]\n",
  "GUESTENING": "GUESTEN, (obsolete) to stay as a guest [v]\n",
  "GUESTENS": "GUESTEN, (obsolete) to stay as a guest [v]\n",
  "GUESTHOUSE": "a private home or boarding house offering accommodation, esp. to travellers [n -S]\n",
  "GUESTHOUSES": "GUESTHOUSE, a private home or boarding house offering accommodation, esp. to travellers [n]\n",
  "GUESTIMATE": "to make an intuitive estimate, also GUESSTIMATE [v GUESTIMATED, GUESTIMATING, GUESTIMATES]\n",
  "GUESTIMATED": "GUESTIMATE, to make an intuitive estimate, also GUESSTIMATE [v]\n",
  "GUESTIMATES": "GUESTIMATE, to make an intuitive estimate, also GUESSTIMATE [v]\n",
  "GUESTIMATING": "GUESTIMATE, to make an intuitive estimate, also GUESSTIMATE [v]\n",
  "GUESTING": "GUEST, to appear as a visitor [v]\n",
  "GUESTS": "GUEST, to appear as a visitor [v]\n",
  "GUESTWISE": "(obsolete) in the manner of a guest [adv]\n",
  "GUFF": "foolish talk [n -S]\n",
  "GUFFAW": "to laugh loudly [v -ED, -ING, -S]\n",
  "GUFFAWED": "GUFFAW, to laugh loudly [v]\n",
  "GUFFAWING": "GUFFAW, to laugh loudly [v]\n",
  "GUFFAWS": "GUFFAW, to laugh loudly [v]\n",
  "GUFFIE": "(Scots) a pig [n -S]\n",
  "GUFFIES": "GUFFIE, (Scots) a pig [n]\n",
  "GUFFS": "GUFF, foolish talk [n]\n",
  "GUGA": "(Gaelic) a young gannet, eaten as a delicacy in the Hebrides [n -S]\n",
  "GUGAS": "GUGA, (Gaelic) a young gannet, eaten as a delicacy in the Hebrides [n]\n",
  "GUGGLE": "to gurgle [v GUGGLED, GUGGLING, GUGGLES]\n",
  "GUGGLED": "GUGGLE, to gurgle [v]\n",
  "GUGGLES": "GUGGLE, to gurgle [v]\n",
  "GUGGLING": "GUGGLE, to gurgle [v]\n",
  "GUGLET": "a porous earthen jar for cooling water by evaporation, also GOGLET, GURGLET [n -S]\n",
  "GUGLETS": "GUGLET, a porous earthen jar for cooling water by evaporation, also GOGLET, GURGLET [n]\n",
  "GUICHET": "(French) a ticket window or similar small opening [n -S]\n",
  "GUICHETS": "GUICHET, (French) a ticket window or similar small opening [n]\n",
  "GUID": "(Scots) good, also GUDE [adj] / something good [n -S]\n",
  "GUIDABLE": "able to be guided [adj]\n",
  "GUIDAGE": "(obsolete) the reward given to a guide for services [n -S]\n",
  "GUIDAGES": "GUIDAGE, (obsolete) the reward given to a guide for services [n]\n",
  "GUIDANCE": "advice [n -S]\n",
  "GUIDANCES": "GUIDANCE, advice [n]\n",
  "GUIDE": "to show the way [v GUIDED, GUIDING, GUIDES]\n",
  "GUIDEBOOK": "a book of information for tourists [n -S]\n",
  "GUIDEBOOKS": "GUIDEBOOK, a book of information for tourists [n]\n",
  "GUIDED": "GUIDE, to show the way [v]\n",
  "GUIDELESS": "without a guide [adj]\n",
  "GUIDELINE": "a line drawn, or a rope, etc. fixed, to act as a guide [n -S]\n",
  "GUIDELINES": "GUIDELINE, a line drawn, or a rope, etc. fixed, to act as a guide [n]\n",
  "GUIDEPOST": "a post to guide the traveller [n -S]\n",
  "GUIDEPOSTS": "GUIDEPOST, a post to guide the traveller [n]\n",
  "GUIDER": "a member of the Girl Guide movement [n -S]\n",
  "GUIDERS": "GUIDER, a member of the Girl Guide movement [n]\n",
  "GUIDES": "GUIDE, to show the way [v]\n",
  "GUIDESHIP": "the state of being a Girl Guide [n -S]\n",
  "GUIDESHIPS": "GUIDESHIP, the state of being a Girl Guide [n]\n",
  "GUIDEWAY": "a track for controlling the line of motion of something [n -S]\n",
  "GUIDEWAYS": "GUIDEWAY, a track for controlling the line of motion of something [n]\n",
  "GUIDEWORD": "a word at the top of a dictionary page indicating the first word on the page [n -S]\n",
  "GUIDEWORDS": "GUIDEWORD, a word at the top of a dictionary page indicating the first word on the page [n]\n",
  "GUIDING": "the act of guiding [n -S]\n",
  "GUIDINGS": "GUIDING, the act of guiding [n]\n",
  "GUIDON": "(French) a small flag [n -S]\n",
  "GUIDONS": "GUIDON, (French) a small flag [n]\n",
  "GUIDS": "GUID, something good [n]\n",
  "GUIDWILLIE": "(Scots) cordial, cheering [adj]\n",
  "GUILD": "an association of people of the same trade, also GYELD [n -S]\n",
  "GUILDER": "(Dutch) a monetary unit of the Netherlands, also GULDEN [n -S]\n",
  "GUILDERS": "GUILDER, (Dutch) a monetary unit of the Netherlands, also GULDEN [n]\n",
  "GUILDHALL": "a town hall, also GILDHALL [n -S]\n",
  "GUILDHALLS": "GUILDHALL, a town hall, also GILDHALL [n]\n",
  "GUILDRIES": "GUILDRY, (Scots) membership of a guild [n]\n",
  "GUILDRY": "(Scots) membership of a guild [n GUILDRIES]\n",
  "GUILDS": "GUILD, an association of people of the same trade, also GYELD [n]\n",
  "GUILDSHIP": "membership of a guild [n -S]\n",
  "GUILDSHIPS": "GUILDSHIP, membership of a guild [n]\n",
  "GUILDSMAN": "a member of a guild, also GILDSMAN [n GUILDSMEN]\n",
  "GUILDSMEN": "GUILDSMAN, a member of a guild, also GILDSMAN [n]\n",
  "GUILDSWOMAN": "a female member of a guild, also GILDSWOMAN [n GUILDSWOMEN]\n",
  "GUILDSWOMEN": "GUILDSWOMAN, a female member of a guild, also GILDSWOMAN [n]\n",
  "GUILE": "cunning [adj] / to beguile, also GUYLE [v GUILED, GUILING, GUILES]\n",
  "GUILED": "GUILE, to beguile, also GUYLE [v]\n",
  "GUILEFUL": "deceitful [adj GUILEFULLY]\n",
  "GUILEFULLY": "GUILEFUL, deceitful [adv]\n",
  "GUILEFULNESS": "the state of being guileful [n -ES]\n",
  "GUILEFULNESSES": "GUILEFULNESS, the state of being guileful [n]\n",
  "GUILELESS": "without guile [adj GUILELESSLY]\n",
  "GUILELESSLY": "GUILELESS, without guile [adv]\n",
  "GUILELESSNESS": "GUILELESS, without guile [n]\n",
  "GUILELESSNESSES": "GUILELESSNESS, GUILELESS, without guile [n]\n",
  "GUILER": "(Spenser) a deceiver, also GUYLER [n -S]\n",
  "GUILERS": "GUILER, (Spenser) a deceiver, also GUYLER [n]\n",
  "GUILES": "GUILE, to beguile, also GUYLE [v]\n",
  "GUILING": "GUILE, to beguile, also GUYLE [v]\n",
  "GUILLEMET": "(French) a quotation mark [n -S]\n",
  "GUILLEMETS": "GUILLEMET, (French) a quotation mark [n]\n",
  "GUILLEMOT": "(French) a northern black-and-white sea bird [n -S]\n",
  "GUILLEMOTS": "GUILLEMOT, (French) a northern black-and-white sea bird [n]\n",
  "GUILLOCHE": "(French) to decorate with intersecting curved lines [v GUILLOCHED, GUILLOCHING, GUILLOCHES]\n",
  "GUILLOCHED": "GUILLOCHE, (French) to decorate with intersecting curved lines [v]\n",
  "GUILLOCHES": "GUILLOCHE, (French) to decorate with intersecting curved lines [v]\n",
  "GUILLOCHING": "GUILLOCHE, (French) to decorate with intersecting curved lines [v]\n",
  "GUILLOTINE": "(French) an instrument for beheading consisting of a weighted blade allowed to drop between two tall grooved uprights [n -S] / to behead with a guillotine [v GUILLOTINED, GUILLOTINING, GUILLOTINES]\n",
  "GUILLOTINED": "GUILLOTINE, to behead with a guillotine [v]\n",
  "GUILLOTINER": "one who guillotines [n -S]\n",
  "GUILLOTINERS": "GUILLOTINER, one who guillotines [n]\n",
  "GUILLOTINES": "GUILLOTINE, to behead with a guillotine [v]\n",
  "GUILLOTINING": "GUILLOTINE, to behead with a guillotine [v]\n",
  "GUILT": "to cause someone to feel guilty [v -ED, -ING, -S]\n",
  "GUILTED": "GUILT, to cause someone to feel guilty [v]\n",
  "GUILTIER": "GUILTY, worthy of blame for an offence [adj]\n",
  "GUILTIEST": "GUILTY, worthy of blame for an offence [adj]\n",
  "GUILTILY": "GUILTY, worthy of blame for an offence [adv]\n",
  "GUILTINESS": "the state of being guilty [n -ES]\n",
  "GUILTINESSES": "GUILTINESS, the state of being guilty [n]\n",
  "GUILTING": "GUILT, to cause someone to feel guilty [v]\n",
  "GUILTLESS": "without guilt [adj GUILTLESSLY]\n",
  "GUILTLESSLY": "GUILTLESS, without guilt [adv]\n",
  "GUILTLESSNESS": "GUILTLESS, without guilt [n]\n",
  "GUILTLESSNESSES": "GUILTLESSNESS, GUILTLESS, without guilt [n]\n",
  "GUILTS": "GUILT, to cause someone to feel guilty [v]\n",
  "GUILTY": "worthy of blame for an offence [adj GUILTIER, GUILTIEST, GUILTILY]\n",
  "GUIMBARD": "a Jew's-harp [n -S]\n",
  "GUIMBARDS": "GUIMBARD, a Jew's-harp [n]\n",
  "GUIMP": "to trim with yarn, also GIMP, GYMP [v -ED, -ING, -S]\n",
  "GUIMPE": "(French) a wide cloth covering neck and shoulders worn by nuns [n -S]\n",
  "GUIMPED": "GUIMP, to trim with yarn, also GIMP, GYMP [v]\n",
  "GUIMPES": "GUIMPE, (French) a wide cloth covering neck and shoulders worn by nuns [n]\n",
  "GUIMPING": "GUIMP, to trim with yarn, also GIMP, GYMP [v]\n",
  "GUIMPS": "GUIMP, to trim with yarn, also GIMP, GYMP [v]\n",
  "GUINEA": "a former British coin, one pound and one shilling [n -S]\n",
  "GUINEAS": "GUINEA, a former British coin, one pound and one shilling [n]\n",
  "GUINEP": "(Tupi) a tropical American tree; its orange-like fruit, also GENIP, GENIPAP, GENIPAPO [n -S]\n",
  "GUINEPS": "GUINEP, (Tupi) a tropical American tree; its orange-like fruit, also GENIP, GENIPAP, GENIPAPO [n]\n",
  "GUIPURE": "(French) a kind of lace having no ground or mesh [n -S]\n",
  "GUIPURES": "GUIPURE, (French) a kind of lace having no ground or mesh [n]\n",
  "GUIRO": "(Spanish) a notched gourd used as a percussion instrument in Latin America [n -S]\n",
  "GUIROS": "GUIRO, (Spanish) a notched gourd used as a percussion instrument in Latin America [n]\n",
  "GUISARD": "a person in disguise; a masker; a mummer, also GUISER, GUIZER [n -S]\n",
  "GUISARDS": "GUISARD, a person in disguise; a masker; a mummer, also GUISER, GUIZER [n]\n",
  "GUISE": "a semblance, seeming [n -S] / to dress [v GUISED, GUISING, GUISES]\n",
  "GUISED": "GUISE, to dress [v]\n",
  "GUISER": "a person in disguise; a masker; a mummer, also GUISARD, GUIZER [n -S]\n",
  "GUISERS": "GUISER, a person in disguise; a masker; a mummer, also GUISARD, GUIZER [n]\n",
  "GUISES": "GUISE, to dress [v]\n",
  "GUISING": "(Scots) a survival of mumming, where children dress up and go from house to house [n -S]\n",
  "GUISINGS": "GUISING, (Scots) a survival of mumming, where children dress up and go from house to house [n]\n",
  "GUITAR": "a fretted musical instrument, usually six-stringed with a waisted body and a flat back [n -S]\n",
  "GUITARFISH": "a kind of ray, somewhat guitar-like in shape [n -ES]\n",
  "GUITARFISHES": "GUITARFISH, a kind of ray, somewhat guitar-like in shape [n]\n",
  "GUITARIST": "one who plays the guitar [n -S]\n",
  "GUITARISTS": "GUITARIST, one who plays the guitar [n]\n",
  "GUITARS": "GUITAR, a fretted musical instrument, usually six-stringed with a waisted body and a flat back [n]\n",
  "GUITGUIT": "one of several species of small tropical American birds, allied to the creepers [n -S]\n",
  "GUITGUITS": "GUITGUIT, one of several species of small tropical American birds, allied to the creepers [n]\n",
  "GUIZER": "a person in disguise, also GUISER [n -S]\n",
  "GUIZERS": "GUIZER, a person in disguise, also GUISER [n]\n",
  "GUL": "a design in oriental carpets [n -S]\n",
  "GULA": "(Latin) the upper part of the throat [n -S]\n",
  "GULAG": "a forced-labour camp in the Soviet Union [n -S]\n",
  "GULAGS": "GULAG, a forced-labour camp in the Soviet Union [n]\n",
  "GULAR": "a scale on the throat of a reptile or fish [n -S]\n",
  "GULARS": "GULAR, a scale on the throat of a reptile or fish [n]\n",
  "GULAS": "GULA, (Latin) the upper part of the throat [n]\n",
  "GULCH": "to swallow greedily [v -ED, -ING, -ES]\n",
  "GULCHED": "GULCH, to swallow greedily [v]\n",
  "GULCHES": "GULCH, to swallow greedily [v]\n",
  "GULCHING": "GULCH, to swallow greedily [v]\n",
  "GULDEN": "(Dutch) a monetary unit of the Netherlands, also GUILDER [n -S]\n",
  "GULDENS": "GULDEN, (Dutch) a monetary unit of the Netherlands, also GUILDER [n]\n",
  "GULE": "(Scots) a marigold, also GOOL [n -S]\n",
  "GULES": "the colour red [n GULES]\n",
  "GULET": "a wooden Turkish sailing boat, traditionally used to carry freight, now used for pleasure trips [n -S]\n",
  "GULETS": "GULET, a wooden Turkish sailing boat, traditionally used to carry freight, now used for pleasure trips [n]\n",
  "GULF": "a deep chasm, also GULPH [n -S] / to swallow up [v -ED, -ING, -S]\n",
  "GULFED": "GULF, to swallow up [v]\n",
  "GULFIER": "GULFY, full of whirlpools [adj]\n",
  "GULFIEST": "GULFY, full of whirlpools [adj]\n",
  "GULFING": "GULF, to swallow up [v]\n",
  "GULFLIKE": "resembling a deep chasm [adj]\n",
  "GULFS": "GULF, to swallow up [v]\n",
  "GULFWEED": "a brownish seaweed [n -S]\n",
  "GULFWEEDS": "GULFWEED, a brownish seaweed [n]\n",
  "GULFY": "full of whirlpools [adj GULFIER, GULFIEST]\n",
  "GULL": "to dupe, deceive [v -ED, -ING, -S]\n",
  "GULLABLE": "easily deceived, also GULLIBLE [adj GULLABLY]\n",
  "GULLABLY": "GULLABLE, easily deceived, also GULLIBLE [adv]\n",
  "GULLED": "GULL, to dupe, deceive [v]\n",
  "GULLER": "someone who deceives [n -S]\n",
  "GULLERIES": "GULLERY, a deception [n]\n",
  "GULLERS": "GULLER, someone who deceives [n]\n",
  "GULLERY": "a deception [n GULLERIES]\n",
  "GULLET": "the throat [n -S]\n",
  "GULLETS": "GULLET, the throat [n]\n",
  "GULLEY": "to wear a channel, also GULLY [v -ED, -ING, -S]\n",
  "GULLEYED": "GULLEY, to wear a channel, also GULLY [v]\n",
  "GULLEYING": "GULLEY, to wear a channel, also GULLY [v]\n",
  "GULLEYS": "GULLEY, to wear a channel, also GULLY [v]\n",
  "GULLIBILITIES": "GULLIBILITY, the state of being gullible [n]\n",
  "GULLIBILITY": "the state of being gullible [n GULLIBILITIES]\n",
  "GULLIBLE": "easily deceived, also GULLABLE [adj GULLIBLY]\n",
  "GULLIBLY": "in a way so as to be easily deceived, also GULLABLY [adv]\n",
  "GULLIED": "GULLY, to form ravines by the action of water, also GULLEY [v]\n",
  "GULLIES": "GULLY, to form ravines by the action of water, also GULLEY [v]\n",
  "GULLING": "GULL, to dupe, deceive [v]\n",
  "GULLISH": "foolish; stupid [adj]\n",
  "GULLS": "GULL, to dupe, deceive [v]\n",
  "GULLWING": "of a vehicle door, opening upwards [adj]\n",
  "GULLY": "to form ravines by the action of water, also GULLEY [v GULLIED, GULLYING, GULLIES]\n",
  "GULLYING": "GULLY, to form ravines by the action of water, also GULLEY [v]\n",
  "GULOSITIES": "GULOSITY, (archaic) enormous appetite; greediness [n]\n",
  "GULOSITY": "(archaic) enormous appetite; greediness [n GULOSITIES]\n",
  "GULP": "to swallow rapidly [v -ED, -ING, -S]\n",
  "GULPED": "GULP, to swallow rapidly [v]\n",
  "GULPER": "one who gulps [n -S]\n",
  "GULPERS": "GULPER, one who gulps [n]\n",
  "GULPH": "a deep chasm, also GULF [n -S]\n",
  "GULPHS": "GULPH, a deep chasm, also GULF [n]\n",
  "GULPIER": "GULPY, marked by gulping [adj]\n",
  "GULPIEST": "GULPY, marked by gulping [adj]\n",
  "GULPING": "GULP, to swallow rapidly [v]\n",
  "GULPINGLY": "GULPING, GULP, to swallow rapidly [adv]\n",
  "GULPS": "GULP, to swallow rapidly [v]\n",
  "GULPY": "marked by gulping [adj GULPIER, GULPIEST]\n",
  "GULS": "GUL, a design in oriental carpets [n]\n",
  "GULY": "(obsolete) of colour gules (heraldic red) [adj]\n",
  "GUM": "to smear with gum (a sticky substance) [v GUMMED, GUMMING, GUMS]\n",
  "GUMBALL": "a small ball of chewing gum [n -S]\n",
  "GUMBALLS": "GUMBALL, a small ball of chewing gum [n]\n",
  "GUMBO": "(Bantu) a soup thickened with okra, also GOMBO, GOMBRO [n -S]\n",
  "GUMBOIL": "an abscess in the gums [n -S]\n",
  "GUMBOILS": "GUMBOIL, an abscess in the gums [n]\n",
  "GUMBOOT": "a rubber boot [n -S]\n",
  "GUMBOOTS": "GUMBOOT, a rubber boot [n]\n",
  "GUMBOS": "GUMBO, (Bantu) a soup thickened with okra, also GOMBO, GOMBRO [n]\n",
  "GUMBOTIL": "a dark sticky clay, formed by the weathering of boulder clay or glacial drift [n -S]\n",
  "GUMBOTILS": "GUMBOTIL, a dark sticky clay, formed by the weathering of boulder clay or glacial drift [n]\n",
  "GUMDROP": "a type of chewy candy [n -S]\n",
  "GUMDROPS": "GUMDROP, a type of chewy candy [n]\n",
  "GUMLANDS": "in Australia, infertile land from which the original kauri gum has been removed or burnt [n]\n",
  "GUMLESS": "having no gum [adj]\n",
  "GUMLIKE": "resembling gum [adj]\n",
  "GUMLINE": "the edge of the gums meeting the teeth [n -S]\n",
  "GUMLINES": "GUMLINE, the edge of the gums meeting the teeth [n]\n",
  "GUMMA": "(Latin) a syphilitic tumour [n GUMMATA or GUMMAS]\n",
  "GUMMAS": "GUMMA, (Latin) a syphilitic tumour [n]\n",
  "GUMMATA": "GUMMA, (Latin) a syphilitic tumour [n]\n",
  "GUMMATOUS": "of the nature of or resembling a gumma, a syphilitic sore [adj]\n",
  "GUMMED": "GUM, to smear with gum (a sticky substance) [v]\n",
  "GUMMER": "one that gums [n -S]\n",
  "GUMMERS": "GUMMER, one that gums [n]\n",
  "GUMMI": "a rubbery, flavored candy [n -S]\n",
  "GUMMIER": "GUMMY, resembling gum [adj]\n",
  "GUMMIES": "GUMMY, a kind of small shark [n]\n",
  "GUMMIEST": "GUMMY, resembling gum [adj]\n",
  "GUMMIFEROUS": "producing gum [adj]\n",
  "GUMMILY": "GUMMY, resembling gum [adv]\n",
  "GUMMINESS": "the state of being gummy [n -ES]\n",
  "GUMMINESSES": "GUMMINESS, the state of being gummy [n]\n",
  "GUMMING": "the use of gum [n -S]\n",
  "GUMMINGS": "GUMMING, the use of gum [n]\n",
  "GUMMIS": "GUMMI, a rubbery, flavored candy [n]\n",
  "GUMMITE": "a hydrated oxide of uranium and lead, like gum in appearance [n -S]\n",
  "GUMMITES": "GUMMITE, a hydrated oxide of uranium and lead, like gum in appearance [n]\n",
  "GUMMOSE": "gumlike, or composed of gum, also GUMMOUS [adj]\n",
  "GUMMOSES": "GUMMOSIS, patches of gum on fruit trees resulting from severe weather or infestation [n]\n",
  "GUMMOSIS": "patches of gum on fruit trees resulting from severe weather or infestation [n GUMMOSES]\n",
  "GUMMOSITIES": "GUMMOSITY, gumminess [n]\n",
  "GUMMOSITY": "gumminess [n GUMMOSITIES]\n",
  "GUMMOUS": "gumlike, or composed of gum, also GUMMOSE [adj]\n",
  "GUMMY": "resembling gum [adj GUMMIER, GUMMIEST, GUMMILY] / a kind of small shark [n GUMMIES]\n",
  "GUMNUT": "the woody fruit of the eucalyptus [n -S]\n",
  "GUMNUTS": "GUMNUT, the woody fruit of the eucalyptus [n]\n",
  "GUMP": "to catch fish by hand, also GUDDLE [v -ED, -ING, -S]\n",
  "GUMPED": "GUMP, to catch fish by hand, also GUDDLE [v]\n",
  "GUMPHION": "(Scots) a kind of banner formerly carried in a funeral procession [n -S]\n",
  "GUMPHIONS": "GUMPHION, (Scots) a kind of banner formerly carried in a funeral procession [n]\n",
  "GUMPING": "GUMP, to catch fish by hand, also GUDDLE [v]\n",
  "GUMPS": "GUMP, to catch fish by hand, also GUDDLE [v]\n",
  "GUMPTION": "shrewdness [n -S]\n",
  "GUMPTIONS": "GUMPTION, shrewdness [n]\n",
  "GUMPTIOUS": "possessing gumption [adj]\n",
  "GUMS": "GUM, to smear with gum (a sticky substance) [v]\n",
  "GUMSHIELD": "a protective shield for the teeth [n -S]\n",
  "GUMSHIELDS": "GUMSHIELD, a protective shield for the teeth [n]\n",
  "GUMSHOE": "to investigate stealthily [v GUMSHOED, GUMSHOEING, GUMSHOES]\n",
  "GUMSHOED": "GUMSHOE, to investigate stealthily [v]\n",
  "GUMSHOEING": "GUMSHOE, to investigate stealthily [v]\n",
  "GUMSHOES": "GUMSHOE, to investigate stealthily [v]\n",
  "GUMSUCKER": "(Australian slang) a native-born Australian [n -S]\n",
  "GUMSUCKERS": "GUMSUCKER, (Australian slang) a native-born Australian [n]\n",
  "GUMTREE": "a tree that exudes gum, esp. a eucalyptus [n -S]\n",
  "GUMTREES": "GUMTREE, a tree that exudes gum, esp. a eucalyptus [n]\n",
  "GUMWEED": "a plant covered with a gummy substance [n -S]\n",
  "GUMWEEDS": "GUMWEED, a plant covered with a gummy substance [n]\n",
  "GUMWOOD": "the wood of a gumtree [n -S]\n",
  "GUMWOODS": "GUMWOOD, the wood of a gumtree [n]\n",
  "GUN": "to shoot with a gun (a portable firearm) [v GUNNED, GUNNING, GUNS]\n",
  "GUNBOAT": "an armed vessel [n -S]\n",
  "GUNBOATS": "GUNBOAT, an armed vessel [n]\n",
  "GUNCOTTON": "an explosive made by saturating cotton in nitric and sulphuric acids [n -S]\n",
  "GUNCOTTONS": "GUNCOTTON, an explosive made by saturating cotton in nitric and sulphuric acids [n]\n",
  "GUNDIES": "GUNDY, (Scots) a toffee made of treacle and spices [n]\n",
  "GUNDOG": "a dog trained to work with a hunter or gamekeeper [n -S]\n",
  "GUNDOGS": "GUNDOG, a dog trained to work with a hunter or gamekeeper [n]\n",
  "GUNDY": "(Scots) a toffee made of treacle and spices [n GUNDIES]\n",
  "GUNFIGHT": "to fight with guns [v GUNFOUGHT, GUNFIGHTING, GUNFIGHTS]\n",
  "GUNFIGHTER": "one who fights with guns [n -S]\n",
  "GUNFIGHTERS": "GUNFIGHTER, one who fights with guns [n]\n",
  "GUNFIGHTING": "the act of fighting with guns [n -S]\n",
  "GUNFIGHTINGS": "GUNFIGHTING, the act of fighting with guns [n]\n",
  "GUNFIGHTS": "GUNFIGHT, to fight with guns [v]\n",
  "GUNFIRE": "the firing of guns [n -S]\n",
  "GUNFIRES": "GUNFIRE, the firing of guns [n]\n",
  "GUNFLINT": "the flint in a flintlock [n -S]\n",
  "GUNFLINTS": "GUNFLINT, the flint in a flintlock [n]\n",
  "GUNFOUGHT": "GUNFIGHT, to fight with guns [v]\n",
  "GUNG": "as in gung ho, enthusiastically involved [adj]\n",
  "GUNGE": "any dirty, messy or sticky substance [n -S] / to block or crust with gunge [v GUNGED, GUNGING, GUNGES]\n",
  "GUNGED": "GUNGE, to block or crust with gunge [v]\n",
  "GUNGES": "GUNGE, to block or crust with gunge [v]\n",
  "GUNGIER": "GUNGY, sticky and messy [adj]\n",
  "GUNGIEST": "GUNGY, sticky and messy [adj]\n",
  "GUNGING": "GUNGE, to block or crust with gunge [v]\n",
  "GUNGY": "sticky and messy [adj GUNGIER, GUNGIEST]\n",
  "GUNHOUSE": "a shelter for a gun [n -S]\n",
  "GUNHOUSES": "GUNHOUSE, a shelter for a gun [n]\n",
  "GUNITE": "a fine grained mixture of cement, sand and water [n -S]\n",
  "GUNITES": "GUNITE, a fine grained mixture of cement, sand and water [n]\n",
  "GUNK": "to cause something to be gunky, sticky [v -ED, -ING, -S]\n",
  "GUNKED": "GUNK, to cause something to be gunky, sticky [v]\n",
  "GUNKHOLE": "a slimy bay or anchorage [n -S] / to cruise around gunkholes [v GUNKHOLED, GUNKHOLING, GUNKHOLES]\n",
  "GUNKHOLED": "GUNKHOLE, to cruise around gunkholes [v]\n",
  "GUNKHOLES": "GUNKHOLE, to cruise around gunkholes [v]\n",
  "GUNKHOLING": "GUNKHOLE, to cruise around gunkholes [v]\n",
  "GUNKIER": "GUNKY, covered in gunk [adj]\n",
  "GUNKIEST": "GUNKY, covered in gunk [adj]\n",
  "GUNKING": "GUNK, to cause something to be gunky, sticky [v]\n",
  "GUNKS": "GUNK, to cause something to be gunky, sticky [v]\n",
  "GUNKY": "covered in gunk [adj GUNKIER, GUNKIEST]\n",
  "GUNLAYER": "one who sights a gun [n -S]\n",
  "GUNLAYERS": "GUNLAYER, one who sights a gun [n]\n",
  "GUNLESS": "having no gun [adj]\n",
  "GUNLOCK": "the mechanism which ignites the charge of a gun [n -S]\n",
  "GUNLOCKS": "GUNLOCK, the mechanism which ignites the charge of a gun [n]\n",
  "GUNMAKER": "a maker of guns [n -S]\n",
  "GUNMAKERS": "GUNMAKER, a maker of guns [n]\n",
  "GUNMAN": "one who is armed with a gun [n GUNMEN]\n",
  "GUNMANSHIP": "the state of being a gunman [n -S]\n",
  "GUNMANSHIPS": "GUNMANSHIP, the state of being a gunman [n]\n",
  "GUNMEN": "GUNMAN, one who is armed with a gun [n]\n",
  "GUNMETAL": "an alloy of copper and tin or zinc, once used in making cannon [n -S]\n",
  "GUNMETALS": "GUNMETAL, an alloy of copper and tin or zinc, once used in making cannon [n]\n",
  "GUNNAGE": "the total number of guns carried on a warship [n -S]\n",
  "GUNNAGES": "GUNNAGE, the total number of guns carried on a warship [n]\n",
  "GUNNED": "GUN, to shoot with a gun (a portable firearm) [v]\n",
  "GUNNEL": "a small eellike coast fish of the blenny family [n -S]\n",
  "GUNNELS": "GUNNEL, a small eellike coast fish of the blenny family [n]\n",
  "GUNNEN": "GIN, to process cotton [v]\n",
  "GUNNER": "one that operates a gun [n -S]\n",
  "GUNNERA": "a large-leaved ornamental herb of the mare's-tail family [n -S]\n",
  "GUNNERAS": "GUNNERA, a large-leaved ornamental herb of the mare's-tail family [n]\n",
  "GUNNERIES": "GUNNERY, the use of guns [n]\n",
  "GUNNERS": "GUNNER, one that operates a gun [n]\n",
  "GUNNERSHIP": "the office of gunner [n -S]\n",
  "GUNNERSHIPS": "GUNNERSHIP, the office of gunner [n]\n",
  "GUNNERY": "the use of guns [n GUNNERIES]\n",
  "GUNNIES": "GUNNY, (Hindi) a coarse jute fabric [n]\n",
  "GUNNING": "the sport of hunting with a gun [n -S]\n",
  "GUNNINGS": "GUNNING, the sport of hunting with a gun [n]\n",
  "GUNNY": "(Hindi) a coarse jute fabric [n GUNNIES]\n",
  "GUNNYBAG": "a bag made of gunny, a coarse jute fabric [n -S]\n",
  "GUNNYBAGS": "GUNNYBAG, a bag made of gunny, a coarse jute fabric [n]\n",
  "GUNNYSACK": "a sack made of a coarse heavy material, such as burlap [n -S]\n",
  "GUNNYSACKS": "GUNNYSACK, a sack made of a coarse heavy material, such as burlap [n]\n",
  "GUNPAPER": "a type of explosive paper [n -S]\n",
  "GUNPAPERS": "GUNPAPER, a type of explosive paper [n]\n",
  "GUNPLAY": "the shooting of guns [n -S]\n",
  "GUNPLAYS": "GUNPLAY, the shooting of guns [n]\n",
  "GUNPOINT": "the point or aim of a gun [n -S]\n",
  "GUNPOINTS": "GUNPOINT, the point or aim of a gun [n]\n",
  "GUNPORT": "a porthole for a gun [n -S]\n",
  "GUNPORTS": "GUNPORT, a porthole for a gun [n]\n",
  "GUNPOWDER": "an explosive mixture of saltpetre, sulphur and charcoal [n -S]\n",
  "GUNPOWDERIER": "GUNPOWDERY, like gunpowder [adj]\n",
  "GUNPOWDERIEST": "GUNPOWDERY, like gunpowder [adj]\n",
  "GUNPOWDERS": "GUNPOWDER, an explosive mixture of saltpetre, sulphur and charcoal [n]\n",
  "GUNPOWDERY": "like gunpowder [adj GUNPOWDERIER, GUNPOWDERIEST]\n",
  "GUNROOM": "a room on a British warship [n -S]\n",
  "GUNROOMS": "GUNROOM, a room on a British warship [n]\n",
  "GUNRUNNER": "one who smuggles guns [n -S]\n",
  "GUNRUNNERS": "GUNRUNNER, one who smuggles guns [n]\n",
  "GUNRUNNING": "smuggling guns into a country [n -S]\n",
  "GUNRUNNINGS": "GUNRUNNING, smuggling guns into a country [n]\n",
  "GUNS": "GUN, to shoot with a gun (a portable firearm) [v]\n",
  "GUNSEL": "(US slang) a stupid youth; a gunman [n -S]\n",
  "GUNSELS": "GUNSEL, (US slang) a stupid youth; a gunman [n]\n",
  "GUNSHIP": "an armed helicopter [n -S]\n",
  "GUNSHIPS": "GUNSHIP, an armed helicopter [n]\n",
  "GUNSHOT": "a projectile fired from a gun [n -S]\n",
  "GUNSHOTS": "GUNSHOT, a projectile fired from a gun [n]\n",
  "GUNSIGHT": "a device helping the user of a gun to aim at a target [n -S]\n",
  "GUNSIGHTS": "GUNSIGHT, a device helping the user of a gun to aim at a target [n]\n",
  "GUNSLINGER": "a person noted for speed and skill in handling and shooting a gun esp. in the American West [n -S]\n",
  "GUNSLINGERS": "GUNSLINGER, a person noted for speed and skill in handling and shooting a gun esp. in the American West [n]\n",
  "GUNSLINGING": "the act of wearing a gun [n -S]\n",
  "GUNSLINGINGS": "GUNSLINGING, the act of wearing a gun [n]\n",
  "GUNSMITH": "one who makes or repairs firearms [n -S]\n",
  "GUNSMITHING": "the work of a gunsmith [n -S]\n",
  "GUNSMITHINGS": "GUNSMITHING, the work of a gunsmith [n]\n",
  "GUNSMITHS": "GUNSMITH, one who makes or repairs firearms [n]\n",
  "GUNSTICK": "a stick to ram down the charge of a musket, etc. [n -S]\n",
  "GUNSTICKS": "GUNSTICK, a stick to ram down the charge of a musket, etc. [n]\n",
  "GUNSTOCK": "the stock or wood to which the barrel of a hand gun is fastened [n -S]\n",
  "GUNSTOCKS": "GUNSTOCK, the stock or wood to which the barrel of a hand gun is fastened [n]\n",
  "GUNSTONE": "(Shakespeare) a stone shot [n -S]\n",
  "GUNSTONES": "GUNSTONE, (Shakespeare) a stone shot [n]\n",
  "GUNTER": "a topmast arranged with metal bands so that it will readily slide up and down the lower mast [n -S]\n",
  "GUNTERS": "GUNTER, a topmast arranged with metal bands so that it will readily slide up and down the lower mast [n]\n",
  "GUNWALE": "the upper edge of a ship's side [n -S]\n",
  "GUNWALES": "GUNWALE, the upper edge of a ship's side [n]\n",
  "GUNYAH": "(Native Australian) an Australian aborigine's hut [n -S]\n",
  "GUNYAHS": "GUNYAH, (Native Australian) an Australian aborigine's hut [n]\n",
  "GUP": "gossip [n -S]\n",
  "GUPPIES": "GUPPY, a small brightly-coloured West Indian fish [n]\n",
  "GUPPY": "a small brightly-coloured West Indian fish [n GUPPIES]\n",
  "GUPS": "GUP, gossip [n]\n",
  "GUQIN": "(Chinese) a kind of Chinese zither with silken strings, also QIN [n -S]\n",
  "GUQINS": "GUQIN, (Chinese) a kind of Chinese zither with silken strings, also QIN [n]\n",
  "GUR": "an unrefined, sweet cane sugar, also GOOR [n -S]\n",
  "GURAMI": "(Malay) a large freshwater food fish of Asia, also GORAMY, GOURAMI [n -S]\n",
  "GURAMIS": "GURAMI, (Malay) a large freshwater food fish of Asia, also GORAMY, GOURAMI [n]\n",
  "GURDIES": "GURDY, a winch on a fishing boat [n]\n",
  "GURDWARA": "(Punjabi) a Sikh place of worship which includes a place where the scripture is housed [n -S]\n",
  "GURDWARAS": "GURDWARA, (Punjabi) a Sikh place of worship which includes a place where the scripture is housed [n]\n",
  "GURDY": "a winch on a fishing boat [n GURDIES]\n",
  "GURGE": "to swirl [v GURGED, GURGING, GURGES]\n",
  "GURGED": "GURGE, to swirl [v]\n",
  "GURGES": "GURGE, to swirl [v]\n",
  "GURGING": "GURGE, to swirl [v]\n",
  "GURGITATION": "surging [n -S]\n",
  "GURGITATIONS": "GURGITATION, surging [n]\n",
  "GURGLE": "to flow unevenly [v GURGLED, GURGLING, GURGLES]\n",
  "GURGLED": "GURGLE, to flow unevenly [v]\n",
  "GURGLES": "GURGLE, to flow unevenly [v]\n",
  "GURGLET": "a porous earthen jar for cooling water by evaporation, also GOGLET, GUGLET [n -S]\n",
  "GURGLETS": "GURGLET, a porous earthen jar for cooling water by evaporation, also GOGLET, GUGLET [n]\n",
  "GURGLIER": "GURGLY, making bubbling sounds [adj]\n",
  "GURGLIEST": "GURGLY, making bubbling sounds [adj]\n",
  "GURGLING": "GURGLE, to flow unevenly [v]\n",
  "GURGLY": "making bubbling sounds [adj GURGLIER, GURGLIEST]\n",
  "GURGOYLE": "an ornamental figure, also GARGOYLE [n -S]\n",
  "GURGOYLES": "GURGOYLE, an ornamental figure, also GARGOYLE [n]\n",
  "GURJUN": "(Hindi) a thin balsam or wood oil derived from an East Indian tree, also GARJAN [n -S]\n",
  "GURJUNS": "GURJUN, (Hindi) a thin balsam or wood oil derived from an East Indian tree, also GARJAN [n]\n",
  "GURL": "(Scots) to growl [v -ED, -ING, -S]\n",
  "GURLED": "GURL, (Scots) to growl [v]\n",
  "GURLET": "(French) a pickaxe with one pointed and one bladed end [n -S]\n",
  "GURLETS": "GURLET, (French) a pickaxe with one pointed and one bladed end [n]\n",
  "GURLIER": "GURLY, grim [adj]\n",
  "GURLIEST": "GURLY, grim [adj]\n",
  "GURLING": "GURL, (Scots) to growl [v]\n",
  "GURLS": "GURL, (Scots) to growl [v]\n",
  "GURLY": "grim [adj GURLIER, GURLIEST]\n",
  "GURN": "(dialect) to grin, make faces, also GERNE, GIRN [v -ED, -ING, -S]\n",
  "GURNARD": "a marine fish with a large, bony-plated angular head, also GURNET [n -S]\n",
  "GURNARDS": "GURNARD, a marine fish with a large, bony-plated angular head, also GURNET [n]\n",
  "GURNED": "GURN, (dialect) to grin, make faces, also GERNE, GIRN [v]\n",
  "GURNET": "a marine fish with a large, bony-plated angular head, also GURNARD [n -S]\n",
  "GURNETS": "GURNET, a marine fish with a large, bony-plated angular head, also GURNARD [n]\n",
  "GURNEY": "a wheeled stretcher or cart used in a hospital etc. [n -S]\n",
  "GURNEYS": "GURNEY, a wheeled stretcher or cart used in a hospital etc. [n]\n",
  "GURNING": "GURN, (dialect) to grin, make faces, also GERNE, GIRN [v]\n",
  "GURNS": "GURN, (dialect) to grin, make faces, also GERNE, GIRN [v]\n",
  "GURRAH": "(Hindi) a coarse Indian muslin [n -S]\n",
  "GURRAHS": "GURRAH, (Hindi) a coarse Indian muslin [n]\n",
  "GURRIER": "in Dublin, a low-class tough ill-mannered person [n -S]\n",
  "GURRIERS": "GURRIER, in Dublin, a low-class tough ill-mannered person [n]\n",
  "GURRIES": "GURRY, fish offal [n]\n",
  "GURRY": "fish offal [n GURRIES]\n",
  "GURS": "GUR, an unrefined, sweet cane sugar, also GOOR [n]\n",
  "GURSH": "(Arabic) a monetary unit of Saudi Arabia, also GIRSH, KURUSH, QURSH, QURUSH [n -ES]\n",
  "GURSHES": "GURSH, (Arabic) a monetary unit of Saudi Arabia, also GIRSH, KURUSH, QURSH, QURUSH [n]\n",
  "GURU": "(Hindi) a Hindu spiritual teacher, also GOOROO [n -S]\n",
  "GURUDOM": "the state of being a guru, also GURUISM [n -S]\n",
  "GURUDOMS": "GURUDOM, the state of being a guru, also GURUISM [n]\n",
  "GURUISM": "the state of being a guru, also GURUDOM [n -S]\n",
  "GURUISMS": "GURUISM, the state of being a guru, also GURUDOM [n]\n",
  "GURUS": "GURU, (Hindi) a Hindu spiritual teacher, also GOOROO [n]\n",
  "GURUSHIP": "the office of a guru [n -S]\n",
  "GURUSHIPS": "GURUSHIP, the office of a guru [n]\n",
  "GUS": "GU, (Old Norse) an old Shetland viol, also GUE, GJU [n]\n",
  "GUSH": "to flow forth forcefully [v -ED, -ING, -ES]\n",
  "GUSHED": "GUSH, to flow forth forcefully [v]\n",
  "GUSHER": "a gushing oil well [n -S]\n",
  "GUSHERS": "GUSHER, a gushing oil well [n]\n",
  "GUSHES": "GUSH, to flow forth forcefully [v]\n",
  "GUSHIER": "GUSHY, overly sentimental [adj]\n",
  "GUSHIEST": "GUSHY, overly sentimental [adj]\n",
  "GUSHILY": "GUSHY, overly sentimental [adv]\n",
  "GUSHINESS": "the state of being gushy [n -ES]\n",
  "GUSHINESSES": "GUSHINESS, the state of being gushy [n]\n",
  "GUSHING": "GUSH, to flow forth forcefully [v]\n",
  "GUSHINGLY": "GUSHING, GUSH, to flow forth forcefully [adv]\n",
  "GUSHY": "overly sentimental [adj GUSHIER, GUSHIEST, GUSHILY]\n",
  "GUSLA": "a one-stringed Balkan musical instrument, also GUSLE, GUSLI [n -S]\n",
  "GUSLAR": "a performer on the gusla, a one-stringed Balkan musical instrument [n -S]\n",
  "GUSLARS": "GUSLAR, a performer on the gusla, a one-stringed Balkan musical instrument [n]\n",
  "GUSLAS": "GUSLA, a one-stringed Balkan musical instrument, also GUSLE, GUSLI [n]\n",
  "GUSLE": "(Serbo-Croat) a one-stringed Balkan musical instrument, also GUSLA, GUSLI [n -S]\n",
  "GUSLES": "GUSLE, (Serbo-Croat) a one-stringed Balkan musical instrument, also GUSLA, GUSLI [n]\n",
  "GUSLI": "a one-stringed Balkan musical instrument, also GUSLA, GUSLE [n -S]\n",
  "GUSLIS": "GUSLI, a one-stringed Balkan musical instrument, also GUSLA, GUSLE [n]\n",
  "GUSSET": "to furnish with a reinforcing piece of material [v -ED, -ING, -S]\n",
  "GUSSETED": "GUSSET, to furnish with a reinforcing piece of material [v]\n",
  "GUSSETING": "the act of furnishing with a reinforcing piece of material [n -S]\n",
  "GUSSETINGS": "GUSSETING, the act of furnishing with a reinforcing piece of material [n]\n",
  "GUSSETS": "GUSSET, to furnish with a reinforcing piece of material [v]\n",
  "GUSSIE": "to dress up in fine or showy clothes, also GUSSY [v GUSSIED, GUSSYING, GUSSIES]\n",
  "GUSSIED": "GUSSIE, to dress up in fine or showy clothes, also GUSSY [v]\n",
  "GUSSIES": "GUSSIE, to dress up in fine or showy clothes, also GUSSY [v]\n",
  "GUSSY": "to dress up in fine or showy clothes, also GUSSIE [v GUSSIED, GUSSYING, GUSSIES]\n",
  "GUSSYING": "GUSSY, to dress up in fine or showy clothes, also GUSSIE [v]\n",
  "GUST": "to blow in gusts (sudden blasts of wind) [v -ED, -ING, -S]\n",
  "GUSTABLE": "something capable of being tasted [n -S]\n",
  "GUSTABLES": "GUSTABLE, something capable of being tasted [n]\n",
  "GUSTATION": "the act of tasting [n -S]\n",
  "GUSTATIONS": "GUSTATION, the act of tasting [n]\n",
  "GUSTATIVE": "relating to gustation, tasting [adj]\n",
  "GUSTATORILY": "GUSTATORY, pertaining to the sense of taste [adv]\n",
  "GUSTATORY": "pertaining to the sense of taste [adj GUSTATORILY]\n",
  "GUSTED": "GUST, to blow in gusts (sudden blasts of wind) [v]\n",
  "GUSTFUL": "(archaic) savoury [adj]\n",
  "GUSTIE": "(Scots) savoury [adj]\n",
  "GUSTIER": "GUSTY, blowing in gusts [adj]\n",
  "GUSTIEST": "GUSTY, blowing in gusts [adj]\n",
  "GUSTILY": "GUSTY, blowing in gusts [adv]\n",
  "GUSTINESS": "the state of being gusty [n -ES]\n",
  "GUSTINESSES": "GUSTINESS, the state of being gusty [n]\n",
  "GUSTING": "GUST, to blow in gusts (sudden blasts of wind) [v]\n",
  "GUSTLESS": "having no gusts [adj]\n",
  "GUSTO": "(Italian) vigorous enjoyment [n -ES or -S]\n",
  "GUSTOES": "GUSTO, (Italian) vigorous enjoyment [n]\n",
  "GUSTOS": "GUSTO, (Italian) vigorous enjoyment [n]\n",
  "GUSTS": "GUST, to blow in gusts (sudden blasts of wind) [v]\n",
  "GUSTY": "blowing in gusts [adj GUSTIER, GUSTIEST, GUSTILY]\n",
  "GUT": "to remove the guts (intestines) of [v GUTTED, GUTTING, GUTS]\n",
  "GUTBUCKET": "a homemade bass fiddle with a single string [n -S]\n",
  "GUTBUCKETS": "GUTBUCKET, a homemade bass fiddle with a single string [n]\n",
  "GUTCHER": "(Scots) a grandfather, also GOODSIRE, GUDESIRE [n -S]\n",
  "GUTCHERS": "GUTCHER, (Scots) a grandfather, also GOODSIRE, GUDESIRE [n]\n",
  "GUTFUL": "(colloquial) one's fill, more than enough, also GUTSFUL [n -S]\n",
  "GUTFULS": "GUTFUL, (colloquial) one's fill, more than enough, also GUTSFUL [n]\n",
  "GUTLESS": "lacking courage [adj GUTLESSLY]\n",
  "GUTLESSLY": "GUTLESS, lacking courage [adv]\n",
  "GUTLESSNESS": "the state of being gutless [n -ES]\n",
  "GUTLESSNESSES": "GUTLESSNESS, the state of being gutless [n]\n",
  "GUTLIKE": "resembling guts [adj]\n",
  "GUTROT": "(colloquial) rough, cheap alcohol, also ROTGUT [n -S]\n",
  "GUTROTS": "GUTROT, (colloquial) rough, cheap alcohol, also ROTGUT [n]\n",
  "GUTS": "to eat greedily [v -ED, -ING, -ES]\n",
  "GUTSED": "GUTS, to eat greedily [v]\n",
  "GUTSER": "a greedy person, also GUTZER [n -S]\n",
  "GUTSERS": "GUTSER, a greedy person, also GUTZER [n]\n",
  "GUTSES": "GUTS, to eat greedily [v]\n",
  "GUTSFUL": "one's fill, more than enough, also GUTFUL [n -S]\n",
  "GUTSFULS": "GUTSFUL, one's fill, more than enough, also GUTFUL [n]\n",
  "GUTSIER": "GUTSY, (colloquial) courageous [adj]\n",
  "GUTSIEST": "GUTSY, (colloquial) courageous [adj]\n",
  "GUTSILY": "GUTSY, (colloquial) courageous [adv]\n",
  "GUTSINESS": "guts, courage [n -ES]\n",
  "GUTSINESSES": "GUTSINESS, guts, courage [n]\n",
  "GUTSING": "GUTS, to eat greedily [v]\n",
  "GUTSY": "(colloquial) courageous [adj GUTSIER, GUTSIEST, GUTSILY]\n",
  "GUTTA": "latex, also GUTTY [n GUTTAS] / a small, drop-like ornament on a Doric entablature [n GUTTAE]\n",
  "GUTTAE": "GUTTA, latex, also GUTTY [n]\n",
  "GUTTAS": "GUTTA, latex, also GUTTY [n]\n",
  "GUTTATE": "to exude liquid [v GUTTATED, GUTTATING, GUTTATES]\n",
  "GUTTATED": "GUTTATE, to exude liquid [v]\n",
  "GUTTATES": "GUTTATE, to exude liquid [v]\n",
  "GUTTATING": "GUTTATE, to exude liquid [v]\n",
  "GUTTATION": "the release of drops of moisture [n -S]\n",
  "GUTTATIONS": "GUTTATION, the release of drops of moisture [n]\n",
  "GUTTED": "GUT, to remove the guts (intestines) of [v]\n",
  "GUTTER": "to form channels for draining off water [v -ED, -ING, -S]\n",
  "GUTTERBLOOD": "(Scots) a lowborn person [n -S]\n",
  "GUTTERBLOODS": "GUTTERBLOOD, (Scots) a lowborn person [n]\n",
  "GUTTERED": "GUTTER, to form channels for draining off water [v]\n",
  "GUTTERIER": "GUTTERY, marked by extreme vulgarity or indecency [adj]\n",
  "GUTTERIEST": "GUTTERY, marked by extreme vulgarity or indecency [adj]\n",
  "GUTTERING": "gutters collectively [n -S]\n",
  "GUTTERINGS": "GUTTERING, gutters collectively [n]\n",
  "GUTTERS": "GUTTER, to form channels for draining off water [v]\n",
  "GUTTERSNIPE": "a member of the lowest class in society or a street person [n -S]\n",
  "GUTTERSNIPES": "GUTTERSNIPE, a member of the lowest class in society or a street person [n]\n",
  "GUTTERSNIPISH": "like a guttersnipe [adj]\n",
  "GUTTERY": "marked by extreme vulgarity or indecency [adj GUTTERIER, GUTTERIEST]\n",
  "GUTTIER": "GUTTY, marked by courage [adj]\n",
  "GUTTIES": "GUTTY, a solid gutta-percha golf-ball [n]\n",
  "GUTTIEST": "GUTTY, marked by courage [adj]\n",
  "GUTTIFEROUS": "exuding drops [adj]\n",
  "GUTTING": "GUT, to remove the guts (intestines) of [v]\n",
  "GUTTLE": "to eat rapidly [v GUTTLED, GUTTLING, GUTTLES]\n",
  "GUTTLED": "GUTTLE, to eat rapidly [v]\n",
  "GUTTLER": "a greedy eater; a glutton [n -S]\n",
  "GUTTLERS": "GUTTLER, a greedy eater; a glutton [n]\n",
  "GUTTLES": "GUTTLE, to eat rapidly [v]\n",
  "GUTTLING": "GUTTLE, to eat rapidly [v]\n",
  "GUTTURAL": "relating to the throat [adj GUTTURALLY] / a sound produced in the throat, or by the back of the tongue and the (soft) palate [n -S]\n",
  "GUTTURALISATION": "the process of gutturalising, also GUTTURALIZATION [n]\n",
  "GUTTURALISE": "to make guttural, also GUTTURALIZE [v GUTTURALISED, GUTTURALISING, GUTTURALISES]\n",
  "GUTTURALISED": "GUTTURALISE, to make guttural, also GUTTURALIZE [v]\n",
  "GUTTURALISES": "GUTTURALISE, to make guttural, also GUTTURALIZE [v]\n",
  "GUTTURALISING": "GUTTURALISE, to make guttural, also GUTTURALIZE [v]\n",
  "GUTTURALISM": "the quality of being guttural [n -S]\n",
  "GUTTURALISMS": "GUTTURALISM, the quality of being guttural [n]\n",
  "GUTTURALITIES": "GUTTURALITY, the quality of being guttural [n]\n",
  "GUTTURALITY": "the quality of being guttural [n GUTTURALITIES]\n",
  "GUTTURALIZATION": "the process of gutturalizing, also GUTTURALISATION [n]\n",
  "GUTTURALIZE": "to make guttural, also GUTTURALISE [v GUTTURALIZED, GUTTURALIZING, GUTTURALIZES]\n",
  "GUTTURALIZED": "GUTTURALIZE, to make guttural, also GUTTURALISE [v]\n",
  "GUTTURALIZES": "GUTTURALIZE, to make guttural, also GUTTURALISE [v]\n",
  "GUTTURALIZING": "GUTTURALIZE, to make guttural, also GUTTURALISE [v]\n",
  "GUTTURALLY": "GUTTURAL, relating to the throat [adv]\n",
  "GUTTURALNESS": "the state of being guttural [n -ES]\n",
  "GUTTURALNESSES": "GUTTURALNESS, the state of being guttural [n]\n",
  "GUTTURALS": "GUTTURAL, a sound produced in the throat, or by the back of the tongue and the (soft) palate [n]\n",
  "GUTTY": "a solid gutta-percha golf-ball [n GUTTIES] / marked by courage [adj GUTTIER, GUTTIEST]\n",
  "GUTZER": "a greedy person, also GUTSER [n -S]\n",
  "GUTZERS": "GUTZER, a greedy person, also GUTSER [n]\n",
  "GUV": "(short for) governor, also GOV [n -S]\n",
  "GUVS": "GUV, (short for) governor, also GOV [n]\n",
  "GUY": "to make fun of [v -ED, -ING, -S]\n",
  "GUYED": "GUY, to make fun of [v]\n",
  "GUYING": "GUY, to make fun of [v]\n",
  "GUYLE": "(Spenser) to beguile [v GUYLED, GUYLING, GUYLES]\n",
  "GUYLED": "GUYLE, (Spenser) to beguile [v]\n",
  "GUYLER": "(Spenser) a deceiver, also GUILER [n -S]\n",
  "GUYLERS": "GUYLER, (Spenser) a deceiver, also GUILER [n]\n",
  "GUYLES": "GUYLE, (Spenser) to beguile [v]\n",
  "GUYLINE": "a wire used to support a radio tower [n -S]\n",
  "GUYLINER": "eyeliner when worn by a man or boy [n -S]\n",
  "GUYLINERS": "GUYLINER, eyeliner when worn by a man or boy [n]\n",
  "GUYLINES": "GUYLINE, a wire used to support a radio tower [n]\n",
  "GUYLING": "GUYLE, (Spenser) to beguile [v]\n",
  "GUYOT": "a flat-topped underwater mountain of volcanic origin [n -S]\n",
  "GUYOTS": "GUYOT, a flat-topped underwater mountain of volcanic origin [n]\n",
  "GUYS": "GUY, to make fun of [v]\n",
  "GUYSE": "(Spenser) guise [n -S]\n",
  "GUYSES": "GUYSE, (Spenser) guise [n]\n",
  "GUZZLE": "to drink rapidly [v GUZZLED, GUZZLING, GUZZLES]\n",
  "GUZZLED": "GUZZLE, to drink rapidly [v]\n",
  "GUZZLER": "an immoderate eater or drinker [n -S]\n",
  "GUZZLERS": "GUZZLER, an immoderate eater or drinker [n]\n",
  "GUZZLES": "GUZZLE, to drink rapidly [v]\n",
  "GUZZLING": "GUZZLE, to drink rapidly [v]\n",
  "GWEDUC": "(Native American) a large edible clam, also GEODUCK, GWEDUCK [n -S]\n",
  "GWEDUCK": "(Native American) a large edible clam, also GEODUCK, GWEDUC [n -S]\n",
  "GWEDUCKS": "GWEDUCK, (Native American) a large edible clam, also GEODUCK, GWEDUC [n]\n",
  "GWEDUCS": "GWEDUC, (Native American) a large edible clam, also GEODUCK, GWEDUCK [n]\n",
  "GWINE": "(dialect) going [v]\n",
  "GWINIAD": "(Welsh) a fish of North Wales and northern Europe, aka powan, allied to the lake whitefish, also GWYNIAD [n -S]\n",
  "GWINIADS": "GWINIAD, (Welsh) a fish of North Wales and northern Europe, aka powan, allied to the lake whitefish, also GWYNIAD [n]\n",
  "GWYNIAD": "(Welsh) a fish of North Wales and northern Europe, aka powan, allied to the lake whitefish, also GWINIAD [n -S]\n",
  "GWYNIADS": "GWYNIAD, (Welsh) a fish of North Wales and northern Europe, aka powan, allied to the lake whitefish, also GWINIAD [n]\n",
  "GYAL": "(Hindi) an Indian domesticated ox, also GAYAL [n -S]\n",
  "GYALS": "GYAL, (Hindi) an Indian domesticated ox, also GAYAL [n]\n",
  "GYAN": "(Hindi) knowledge [n -S]\n",
  "GYANS": "GYAN, (Hindi) knowledge [n]\n",
  "GYBE": "in sailing, to shift from side to side, also JIBB [v GYBED, GYBING, GYBES]\n",
  "GYBED": "GYBE, in sailing, to shift from side to side, also JIBB [v]\n",
  "GYBES": "GYBE, in sailing, to shift from side to side, also JIBB [v]\n",
  "GYBING": "GYBE, in sailing, to shift from side to side, also JIBB [v]\n",
  "GYELD": "(Spenser) a guild [n -S]\n",
  "GYELDS": "GYELD, (Spenser) a guild [n]\n",
  "GYLDEN": "(Spenser) golden, gilded, also GILDEN [adj]\n",
  "GYM": "(short for) a gymnasium [n -S]\n",
  "GYMBAL": "a contrivance with self-aligning bearings for keeping e.g. ship's instruments horizontal, also GIMBAL [n -S]\n",
  "GYMBALS": "GYMBAL, a contrivance with self-aligning bearings for keeping e.g. ship's instruments horizontal, also GIMBAL [n]\n",
  "GYMKHANA": "(Urdu) a sporting contest, esp. one involving riding or driving skills [n -S]\n",
  "GYMKHANAS": "GYMKHANA, (Urdu) a sporting contest, esp. one involving riding or driving skills [n]\n",
  "GYMMAL": "a ring that can be divided into two or three rings, also GIMMAL, GIMMOR [n -S]\n",
  "GYMMALS": "GYMMAL, a ring that can be divided into two or three rings, also GIMMAL, GIMMOR [n]\n",
  "GYMNASIA": "GYMNASIUM, a room for athletic activities [n]\n",
  "GYMNASIAL": "relating to a gymnasium, also GYMNASIC [adj]\n",
  "GYMNASIARCH": "the head of a gymnasium [n -S]\n",
  "GYMNASIARCHS": "GYMNASIARCH, the head of a gymnasium [n]\n",
  "GYMNASIAST": "a pupil in a gymnasium [n -S]\n",
  "GYMNASIASTS": "GYMNASIAST, a pupil in a gymnasium [n]\n",
  "GYMNASIC": "relating to a gymnasium, also GYMNASIAL [adj]\n",
  "GYMNASIEN": "GYMNASIUM, a room for athletic activities [n]\n",
  "GYMNASIUM": "a room for athletic activities [n GYMNASIUMS or GYMNASIA] / a continental school [n GYMNASIEN]\n",
  "GYMNASIUMS": "GYMNASIUM, a room for athletic activities [n]\n",
  "GYMNAST": "one who is skilled in physical exercises [n -S]\n",
  "GYMNASTIC": "a system of training by exercise [adj GYMNASTICALLY]\n",
  "GYMNASTICAL": "related to gymnastics [adj GYMNASTICALLY]\n",
  "GYMNASTICALLY": "GYMNASTICAL, related to gymnastics [adv]\n",
  "GYMNASTICS": "exercises and activities devised to strengthen the body and improve agility and coordination [n]\n",
  "GYMNASTS": "GYMNAST, one who is skilled in physical exercises [n]\n",
  "GYMNIC": "(archaic) gymnastic [adj]\n",
  "GYMNORHINAL": "with unfeathered nostril [adj]\n",
  "GYMNOSOPH": "one of a sect of naked ascetics of ancient India, also GYMNOSOPHIST [n -S]\n",
  "GYMNOSOPHIES": "GYMNOSOPHY, deep contemplation performed while naked [n]\n",
  "GYMNOSOPHIST": "one of a sect of naked ascetics of ancient India, also GYMNOSOPH [n -S]\n",
  "GYMNOSOPHISTS": "GYMNOSOPHIST, one of a sect of naked ascetics of ancient India, also GYMNOSOPH [n]\n",
  "GYMNOSOPHS": "GYMNOSOPH, one of a sect of naked ascetics of ancient India, also GYMNOSOPHIST [n]\n",
  "GYMNOSOPHY": "deep contemplation performed while naked [n GYMNOSOPHIES]\n",
  "GYMNOSPERM": "a plant with the ovules borne naked or unprotected, the conifers or cone-bearing plants and their allies [n -S]\n",
  "GYMNOSPERMIES": "GYMNOSPERMY, the state of being gymnospermous, having a naked seed [n]\n",
  "GYMNOSPERMOUS": "having a naked seed [adj]\n",
  "GYMNOSPERMS": "GYMNOSPERM, a plant with the ovules borne naked or unprotected, the conifers or cone-bearing plants and their allies [n]\n",
  "GYMNOSPERMY": "the state of being gymnospermous, having a naked seed [n GYMNOSPERMIES]\n",
  "GYMP": "to trim with gimp, a kind of yarn, also GIMP, GUIMP [v -ED, -ING, -S]\n",
  "GYMPED": "GYMP, to trim with gimp, a kind of yarn, also GIMP, GUIMP [v]\n",
  "GYMPIE": "(Native Australian) a tall tree with stinging hairs [n -S]\n",
  "GYMPIES": "GYMPIE, (Native Australian) a tall tree with stinging hairs [n]\n",
  "GYMPING": "GYMP, to trim with gimp, a kind of yarn, also GIMP, GUIMP [v]\n",
  "GYMPS": "GYMP, to trim with gimp, a kind of yarn, also GIMP, GUIMP [v]\n",
  "GYMS": "GYM, (short for) a gymnasium [n]\n",
  "GYMSLIP": "a schoolgirl's belted tunic [n -S]\n",
  "GYMSLIPS": "GYMSLIP, a schoolgirl's belted tunic [n]\n",
  "GYMSUIT": "a costume worn for gymnastics [n -S]\n",
  "GYMSUITS": "GYMSUIT, a costume worn for gymnastics [n]\n",
  "GYNAE": "(colloquial) gynaecology, also GYNIE, GYNY [n -S]\n",
  "GYNAECEA": "GYNAECEUM, the pistil of a flower, also GYNECIUM, GYNAECIUM [n]\n",
  "GYNAECEUM": "the pistil of a flower, also GYNECIUM, GYNAECIUM [n GYNAECEUMS or GYNAECEA]\n",
  "GYNAECEUMS": "GYNAECEUM, the pistil of a flower, also GYNECIUM, GYNAECIUM [n]\n",
  "GYNAECIA": "GYNAECIUM, the pistil of a flower, also GYNECIUM, GYNAECEUM [n]\n",
  "GYNAECIUM": "the pistil of a flower, also GYNECIUM, GYNAECEUM [n GYNAECIA]\n",
  "GYNAECOCRACIES": "GYNAECOCRACY, government by women, also GYNECOCRACY [n]\n",
  "GYNAECOCRACY": "government by women, also GYNECOCRACY [n GYNAECOCRACIES]\n",
  "GYNAECOCRATIC": "relating to a gynaecocracy [adj]\n",
  "GYNAECOID": "of or like a woman, also GYNECOID [adj]\n",
  "GYNAECOLOGIC": "relating to gynaecology, also GYNAECOLOGICAL, GYNECOLOGIC [adj]\n",
  "GYNAECOLOGICAL": "related to gynaecology, also GYNAECOLOGIC, GYNECOLOGIC [adj]\n",
  "GYNAECOLOGIES": "GYNAECOLOGY, the study of women's physiology, also GYNECOLOGY [n]\n",
  "GYNAECOLOGIST": "a specialist in gynaecology, also GYNECOLOGIST [n -S]\n",
  "GYNAECOLOGISTS": "GYNAECOLOGIST, a specialist in gynaecology, also GYNECOLOGIST [n]\n",
  "GYNAECOLOGY": "the study of women's physiology, also GYNECOLOGY [n GYNAECOLOGIES]\n",
  "GYNAECOMAST": "a man suffering from gynaecomastia [n -S]\n",
  "GYNAECOMASTIA": "the abnormal enlargement of a man's breast, also GYNAECOMASTY, GYNECOMASTIA [n -S]\n",
  "GYNAECOMASTIAS": "GYNAECOMASTIA, the abnormal enlargement of a man's breast, also GYNAECOMASTY, GYNECOMASTIA [n]\n",
  "GYNAECOMASTIES": "GYNAECOMASTY, the abnormal enlargement of a man's breast, also GYNAECOMASTIA, GYNECOMASTIA [n]\n",
  "GYNAECOMASTS": "GYNAECOMAST, a man suffering from gynaecomastia [n]\n",
  "GYNAECOMASTY": "the abnormal enlargement of a man's breast, also GYNAECOMASTIA, GYNECOMASTIA [n GYNAECOMASTIES]\n",
  "GYNAES": "GYNAE, (colloquial) gynaecology, also GYNIE, GYNY [n]\n",
  "GYNANDRIES": "GYNANDRY, the condition of having both male and female sexual organs [n]\n",
  "GYNANDRISM": "the state of being gynandrous, also GYNANDRY [n -S]\n",
  "GYNANDRISMS": "GYNANDRISM, the state of being gynandrous, also GYNANDRY [n]\n",
  "GYNANDROMORPH": "an animal having both male and female characteristics [n -S]\n",
  "GYNANDROMORPHIC": "of or like a gynandromorph, an animal having both male and female characteristics [adj]\n",
  "GYNANDROMORPHS": "GYNANDROMORPH, an animal having both male and female characteristics [n]\n",
  "GYNANDROMORPHY": "the state of being gynandromorph, an animal having both male and female characteristics [n]\n",
  "GYNANDROUS": "with stamen concrescent with the carpel, as in orchids [adj]\n",
  "GYNANDRY": "the condition of having both male and female sexual organs [n GYNANDRIES]\n",
  "GYNARCHIC": "relating to gynarchy, government by women [adj]\n",
  "GYNARCHIES": "GYNARCHY, government by women [n]\n",
  "GYNARCHY": "government by women [n GYNARCHIES]\n",
  "GYNECIA": "GYNECIUM, the pistil of a flower, also GYNAECEUM, GYNAECIUM, GYNOECIUM [n]\n",
  "GYNECIC": "relating to a gynecium, the pistil of a flower [adj]\n",
  "GYNECIUM": "the pistil of a flower, also GYNAECEUM, GYNAECIUM, GYNOECIUM [n GYNECIA]\n",
  "GYNECOCRACIES": "GYNECOCRACY, government by women, also GYNAECOCRACY [n]\n",
  "GYNECOCRACY": "government by women, also GYNAECOCRACY [n GYNECOCRACIES]\n",
  "GYNECOCRATIC": "relating to gynecocracy [adj]\n",
  "GYNECOID": "of or like a woman, also GYNAECOID [adj]\n",
  "GYNECOLOGIC": "relating to gynecology, also GYNAECOLOGIC, GYNAECOLOGICAL [adj]\n",
  "GYNECOLOGICAL": "relating to gynecology [adj]\n",
  "GYNECOLOGIES": "GYNECOLOGY, the study of women's physiology, also GYNAECOLOGY [n]\n",
  "GYNECOLOGIST": "a specialist in gynecology, also GYNAECOLOGIST [n -S]\n",
  "GYNECOLOGISTS": "GYNECOLOGIST, a specialist in gynecology, also GYNAECOLOGIST [n]\n",
  "GYNECOLOGY": "the study of women's physiology, also GYNAECOLOGY [n GYNECOLOGIES]\n",
  "GYNECOMASTIA": "excessive development of the breast in the male, also GYNAECOMASTIA, GYNAECOMASTY [n -S]\n",
  "GYNECOMASTIAS": "GYNECOMASTIA, excessive development of the breast in the male, also GYNAECOMASTIA, GYNAECOMASTY [n]\n",
  "GYNIATRICS": "the treatment of women's diseases [n]\n",
  "GYNIATRIES": "GYNIATRY, the treatment of women's diseases [n]\n",
  "GYNIATRY": "the treatment of women's diseases [n GYNIATRIES]\n",
  "GYNIE": "(colloquial) gynaecology, also GYNAE, GYNY [n -S]\n",
  "GYNIES": "GYNY, (colloquial) gynaecology, also GYNAE, GYNIE [n]\n",
  "GYNIOLATRIES": "GYNIOLATRY, deep respect or devotion for women [n]\n",
  "GYNIOLATRY": "deep respect or devotion for women [n GYNIOLATRIES]\n",
  "GYNNEY": "(Shakespeare) a guinea hen, also GYNNY [n -S]\n",
  "GYNNEYS": "GYNNEY, (Shakespeare) a guinea hen, also GYNNY [n]\n",
  "GYNNIES": "GYNNY, (Shakespeare) a guinea hen, also GYNNEY [n]\n",
  "GYNNY": "(Shakespeare) a guinea hen, also GYNNEY [n GYNNIES]\n",
  "GYNO": "(short for) a gynaecologist [n -S]\n",
  "GYNOCRACIES": "GYNOCRACY, government by women [n]\n",
  "GYNOCRACY": "government by women [n GYNOCRACIES]\n",
  "GYNOCRATIC": "relating to gynocracy, female rule [adj]\n",
  "GYNODIOECIOUS": "having hermaphrodite and female flowers on different plants [adj]\n",
  "GYNODIOECISM": "the state of being gynodioecious [n -S]\n",
  "GYNODIOECISMS": "GYNODIOECISM, the state of being gynodioecious [n]\n",
  "GYNOECIA": "GYNOECIUM, the pistil of a flower, also GYNAECEUM, GYNAECIUM, GYNECIUM [n]\n",
  "GYNOECIUM": "the pistil of a flower, also GYNAECEUM, GYNAECIUM, GYNECIUM [n GYNOECIA]\n",
  "GYNOGENESES": "GYNOGENESIS, reproduction in which a sperm penetrates an ovum but their nuclei do not fuse, and the embryo develops with maternal chromosomes only [n]\n",
  "GYNOGENESIS": "reproduction in which a sperm penetrates an ovum but their nuclei do not fuse, and the embryo develops with maternal chromosomes only [n GYNOGENESES]\n",
  "GYNOGENETIC": "relating to gynogenesis, reproduction in which a sperm penetrates an ovum but their nuclei do not fuse [adj]\n",
  "GYNOMONOECIOUS": "having hermaphrodite and female flowers on the same plant [adj]\n",
  "GYNOMONOECISM": "the state of being gynomonoecious [n -S]\n",
  "GYNOMONOECISMS": "GYNOMONOECISM, the state of being gynomonoecious [n]\n",
  "GYNOPHOBE": "a person who hates or fears women [n -S]\n",
  "GYNOPHOBES": "GYNOPHOBE, a person who hates or fears women [n]\n",
  "GYNOPHOBIA": "a morbid fear of women [n -S]\n",
  "GYNOPHOBIAS": "GYNOPHOBIA, a morbid fear of women [n]\n",
  "GYNOPHOBIC": "one who hates women [n -S]\n",
  "GYNOPHOBICS": "GYNOPHOBIC, one who hates women [n]\n",
  "GYNOPHORE": "the pedicel raising the pistil or ovary above the stamens, as in the passion flower [n -S]\n",
  "GYNOPHORES": "GYNOPHORE, the pedicel raising the pistil or ovary above the stamens, as in the passion flower [n]\n",
  "GYNOPHORIC": "of or like a gynophore, a pedicel raising the pistil or ovary above the stamens [adj]\n",
  "GYNOS": "GYNO, (short for) a gynaecologist [n]\n",
  "GYNOSTEMIA": "GYNOSTEMIUM, the central reproductive stalk of an orchid, which consists of a stamen and pistil fused together [n]\n",
  "GYNOSTEMIUM": "the central reproductive stalk of an orchid, which consists of a stamen and pistil fused together [n GYNOSTEMIA]\n",
  "GYNY": "(colloquial) gynaecology, also GYNAE, GYNIE [n GYNIES]\n",
  "GYOZA": "(Japanese) a fried dumpling [n -S]\n",
  "GYOZAS": "GYOZA, (Japanese) a fried dumpling [n]\n",
  "GYP": "to swindle, also GIP [v GYPPED, GYPPING, GYPS]\n",
  "GYPLURE": "a synthetic attractant to trap gypsy moths [n -S]\n",
  "GYPLURES": "GYPLURE, a synthetic attractant to trap gypsy moths [n]\n",
  "GYPO": "a smalltime logging operator [n -S]\n",
  "GYPOS": "GYPO, a smalltime logging operator [n]\n",
  "GYPPED": "GYP, to swindle, also GIP [v]\n",
  "GYPPER": "one that gyps, swindles [n -S]\n",
  "GYPPERS": "GYPPER, one that gyps, swindles [n]\n",
  "GYPPIE": "a gypsy (offensive slang), also GIPPO, GIPPY, GYPPO, GYPPY [n -S]\n",
  "GYPPIES": "GYPPIE, a gypsy (offensive slang), also GIPPO, GIPPY, GYPPO, GYPPY [n]\n",
  "GYPPING": "GYP, to swindle, also GIP [v]\n",
  "GYPPO": "(offensive slang) a gypsy, also GIPPO, GIPPY, GYPPIE, GYPPY [n -S]\n",
  "GYPPOS": "GYPPO, (offensive slang) a gypsy, also GIPPO, GIPPY, GYPPIE, GYPPY [n]\n",
  "GYPPY": "(offensive slang) a gypsy, also GIPPO, GIPPY, GYPPIE, GYPPO [n GYPPIES]\n",
  "GYPS": "GYP, to swindle, also GIP [v]\n",
  "GYPSEIAN": "of or pertaining to gypsies [adj]\n",
  "GYPSEOUS": "containing gypsum [adj]\n",
  "GYPSIED": "GYPSY, to live like a gypsy (a wanderer), also GIPSY [v]\n",
  "GYPSIES": "GYPSY, to live like a gypsy (a wanderer), also GIPSY [v]\n",
  "GYPSIFEROUS": "bearing gypsum [adj]\n",
  "GYPSOPHILA": "a garden flower [n -S]\n",
  "GYPSOPHILAS": "GYPSOPHILA, a garden flower [n]\n",
  "GYPSTER": "one that gyps, cheats [n -S]\n",
  "GYPSTERS": "GYPSTER, one that gyps, cheats [n]\n",
  "GYPSUM": "hydrated calcium sulphate, a soft mineral used for making plaster of Paris and as a fertilizer [n -S]\n",
  "GYPSUMS": "GYPSUM, hydrated calcium sulphate, a soft mineral used for making plaster of Paris and as a fertilizer [n]\n",
  "GYPSY": "to live like a gypsy (a wanderer), also GIPSY [v GYPSIED, GYPSYING, GYPSIES]\n",
  "GYPSYDOM": "the world of the gypsy, also GIPSYDOM [n -S]\n",
  "GYPSYDOMS": "GYPSYDOM, the world of the gypsy, also GIPSYDOM [n]\n",
  "GYPSYHOOD": "the state of being a gypsy, also GIPSYHOOD [n -S]\n",
  "GYPSYHOODS": "GYPSYHOOD, the state of being a gypsy, also GIPSYHOOD [n]\n",
  "GYPSYING": "GYPSY, to live like a gypsy (a wanderer), also GIPSY [v]\n",
  "GYPSYISH": "resembling a gypsy, also GIPSYISH [adj]\n",
  "GYPSYISM": "the arts and practices or habits of gypsies; deception, also GIPSYISM [n -S]\n",
  "GYPSYISMS": "GYPSYISM, the arts and practices or habits of gypsies; deception, also GIPSYISM [n]\n",
  "GYPSYWORT": "a labiate plant of watersides, with deeply cut leaves and whorls of small white flowers, also GIPSYWORT [n -S]\n",
  "GYPSYWORTS": "GYPSYWORT, a labiate plant of watersides, with deeply cut leaves and whorls of small white flowers, also GIPSYWORT [n]\n",
  "GYRAL": "moving in a circular path or way; gyratory [adj GYRALLY]\n",
  "GYRALLY": "GYRAL, moving in a circular path or way; gyratory [adv]\n",
  "GYRANT": "spinning around [adj]\n",
  "GYRASE": "an enzyme catalyst which acts on DNA [n -S]\n",
  "GYRASES": "GYRASE, an enzyme catalyst which acts on DNA [n]\n",
  "GYRATE": "to revolve or rotate [v GYRATED, GYRATING, GYRATES]\n",
  "GYRATED": "GYRATE, to revolve or rotate [v]\n",
  "GYRATES": "GYRATE, to revolve or rotate [v]\n",
  "GYRATING": "GYRATE, to revolve or rotate [v]\n",
  "GYRATION": "the act of gyrating [n -S]\n",
  "GYRATIONAL": "relating to gyration [adj]\n",
  "GYRATIONS": "GYRATION, the act of gyrating [n]\n",
  "GYRATOR": "one who gyrates [n -S]\n",
  "GYRATORS": "GYRATOR, one who gyrates [n]\n",
  "GYRATORY": "moving in a circle or spiral [adj]\n",
  "GYRE": "to move in a circle or spiral [v GYRED, GYRING, GYRES]\n",
  "GYRED": "GYRE, to move in a circle or spiral [v]\n",
  "GYRENE": "(archaic) a US marine [n -S]\n",
  "GYRENES": "GYRENE, (archaic) a US marine [n]\n",
  "GYRES": "GYRE, to move in a circle or spiral [v]\n",
  "GYRFALCON": "a heavy, powerful falcon of cold northerly regions, also GERFALCON, JERFALCON [n -S]\n",
  "GYRFALCONS": "GYRFALCON, a heavy, powerful falcon of cold northerly regions, also GERFALCON, JERFALCON [n]\n",
  "GYRI": "GYRUS, (Latin) a ridge in the brain [n]\n",
  "GYRING": "GYRE, to move in a circle or spiral [v]\n",
  "GYRO": "(short for) a gyroscope [n -S]\n",
  "GYROCAR": "a monorail car balanced by a gyroscope [n -S]\n",
  "GYROCARS": "GYROCAR, a monorail car balanced by a gyroscope [n]\n",
  "GYROCOMPASS": "a compass which indicates direction by the freely moving axis of a rapidly spinning wheel [n -ES]\n",
  "GYROCOMPASSES": "GYROCOMPASS, a compass which indicates direction by the freely moving axis of a rapidly spinning wheel [n]\n",
  "GYROCOPTER": "an airplane balanced and supported by the aerodynamic forces acting on rapidly rotating horizontal or slightly inclined airfoils, also GYROPLANE [n -S]\n",
  "GYROCOPTERS": "GYROCOPTER, an airplane balanced and supported by the aerodynamic forces acting on rapidly rotating horizontal or slightly inclined airfoils, also GYROPLANE [n]\n",
  "GYRODYNE": "a rotorcraft in which the rotors are powered only for takeoff and landing, not for cruising flight [n -S]\n",
  "GYRODYNES": "GYRODYNE, a rotorcraft in which the rotors are powered only for takeoff and landing, not for cruising flight [n]\n",
  "GYROFREQUENCIES": "GYROFREQUENCY, the frequency with which a charged particle (as an electron) executes spiral gyrations in moving obliquely across a magnetic field [n]\n",
  "GYROFREQUENCY": "the frequency with which a charged particle (as an electron) executes spiral gyrations in moving obliquely across a magnetic field [n GYROFREQUENCIES]\n",
  "GYROIDAL": "spiral in arrangement [adj]\n",
  "GYROLITE": "a mineral, hydrated calcium silicate [n -S]\n",
  "GYROLITES": "GYROLITE, a mineral, hydrated calcium silicate [n]\n",
  "GYROMAGNETIC": "denoting the magnetic properties of the spinning electron in an atom [adj]\n",
  "GYROMAGNETISM": "the magnetic properties of rotating electric charges [n -S]\n",
  "GYROMAGNETISMS": "GYROMAGNETISM, the magnetic properties of rotating electric charges [n]\n",
  "GYROMANCIES": "GYROMANCY, divination by walking in a circle until dizzy; the fortune is determined by where the person falls [n]\n",
  "GYROMANCY": "divination by walking in a circle until dizzy; the fortune is determined by where the person falls [n GYROMANCIES]\n",
  "GYRON": "a heraldic inverted vee, also GIRON [n -S]\n",
  "GYRONIC": "in the shape of a gyron, also GIRONIC, GYRONNY [adj]\n",
  "GYRONNY": "in the shape of a gyron, also GIRONIC, GYRONNY, GYRONIC [adj]\n",
  "GYRONS": "GYRON, a heraldic inverted vee, also GIRON [n]\n",
  "GYROPILOT": "a type of automatic pilot [n -S]\n",
  "GYROPILOTS": "GYROPILOT, a type of automatic pilot [n]\n",
  "GYROPLANE": "an airplane balanced and supported by the aerodynamic forces acting on rapidly rotating horizontal or slightly inclined airfoils, also GYROCOPTER [n -S]\n",
  "GYROPLANES": "GYROPLANE, an airplane balanced and supported by the aerodynamic forces acting on rapidly rotating horizontal or slightly inclined airfoils, also GYROCOPTER [n]\n",
  "GYROS": "GYRO, (short for) a gyroscope [n]\n",
  "GYROSCOPE": "a wheel or disc mounted so that it can spin rapidly about an axis which itself can rotate about either of two other axes perpendicular to it and to each other [n -S]\n",
  "GYROSCOPES": "GYROSCOPE, a wheel or disc mounted so that it can spin rapidly about an axis which itself can rotate about either of two other axes perpendicular to it and to each other [n]\n",
  "GYROSCOPIC": "pertaining to the gyroscope [adj GYROSCOPICALLY]\n",
  "GYROSCOPICALLY": "GYROSCOPIC, pertaining to the gyroscope [adv]\n",
  "GYROSCOPICS": "the science of the gyroscope [n]\n",
  "GYROSE": "marked with wavy lines, also GYROUS [adj]\n",
  "GYROSTABILISER": "a gyroscopic device for countering the roll of a ship, etc., also GYROSTABILIZER [n -S]\n",
  "GYROSTABILISERS": "GYROSTABILISER, a gyroscopic device for countering the roll of a ship, etc., also GYROSTABILIZER [n]\n",
  "GYROSTABILIZER": "a gyroscopic device for countering the roll of a ship, etc., also GYROSTABILISER [n -S]\n",
  "GYROSTABILIZERS": "GYROSTABILIZER, a gyroscopic device for countering the roll of a ship, etc., also GYROSTABILISER [n]\n",
  "GYROSTAT": "a type of stabilising device [n -S]\n",
  "GYROSTATIC": "of or pertaining to the gyrostat or to gyrostatics [adj GYROSTATICALLY]\n",
  "GYROSTATICALLY": "GYROSTATIC, of or pertaining to the gyrostat or to gyrostatics [adv]\n",
  "GYROSTATICS": "the study of rotating bodies [n]\n",
  "GYROSTATS": "GYROSTAT, a type of stabilising device [n]\n",
  "GYROUS": "in botany, marked with wavy lines, also GYROSE [adj]\n",
  "GYROVAGUE": "a monk who travels from one place to another [n -S]\n",
  "GYROVAGUES": "GYROVAGUE, a monk who travels from one place to another [n]\n",
  "GYRUS": "(Latin) a ridge in the brain [n GYRUSES or GYRI]\n",
  "GYRUSES": "GYRUS, (Latin) a ridge in the brain [n]\n",
  "GYTE": "(Scots) a child, a brat, also GAITT, GEIT [n -S]\n",
  "GYTES": "GYTE, (Scots) a child, a brat, also GAITT, GEIT [n]\n",
  "GYTRASH": "(dialect) a ghost or apparition [n -ES]\n",
  "GYTRASHES": "GYTRASH, (dialect) a ghost or apparition [n]\n",
  "GYTTJA": "(Swedish) an organically rich sediment on a lake bottom [n -S]\n",
  "GYTTJAS": "GYTTJA, (Swedish) an organically rich sediment on a lake bottom [n]\n",
  "GYVE": "to fetter, also GIVE [v GYVED, GYVING, GYVES]\n",
  "GYVED": "GYVE, to fetter, also GIVE [v]\n",
  "GYVES": "GYVE, to fetter, also GIVE [v]\n",
  "GYVING": "GYVE, to fetter, also GIVE [v]\n",
  "HA": "expressing surprise [interj]\n",
  "HAAF": "(Old Norse) a deep sea fishing region [n -S]\n",
  "HAAFS": "HAAF, (Old Norse) a deep sea fishing region [n]\n",
  "HAANEPOOT": "(South African) a kind of grape, also HANEPOOT, HONEYPOT [n -S]\n",
  "HAANEPOOTS": "HAANEPOOT, (South African) a kind of grape, also HANEPOOT, HONEYPOT [n]\n",
  "HAAR": "(Old Norse) a cold sea-mist [n -S]\n",
  "HAARS": "HAAR, (Old Norse) a cold sea-mist [n]\n",
  "HABANERA": "(Spanish) a slow and seductive Cuban dance [n -S]\n",
  "HABANERAS": "HABANERA, (Spanish) a slow and seductive Cuban dance [n]\n",
  "HABANERO": "(Spanish) a hot chili pepper [n -S]\n",
  "HABANEROS": "HABANERO, (Spanish) a hot chili pepper [n]\n",
  "HABDABS": "a state of extreme nervousness, also ABDABS [n]\n",
  "HABDALAH": "(Hebrew) a Jewish ceremony or prayer marking the close of a Sabbath, also HAVDALAH, HAVDOLOH [n -S]\n",
  "HABDALAHS": "HABDALAH, (Hebrew) a Jewish ceremony or prayer marking the close of a Sabbath, also HAVDALAH, HAVDOLOH [n]\n",
  "HABENDUM": "the part of a deed that limits the extent of ownership [n -S]\n",
  "HABENDUMS": "HABENDUM, the part of a deed that limits the extent of ownership [n]\n",
  "HABERDASHER": "a dealer in men's clothing; a dealer in small sewing articles [n -S]\n",
  "HABERDASHERIES": "HABERDASHERY, a shop selling small sewing articles [n]\n",
  "HABERDASHERS": "HABERDASHER, a dealer in men's clothing; a dealer in small sewing articles [n]\n",
  "HABERDASHERY": "a shop selling small sewing articles [n HABERDASHERIES]\n",
  "HABERDINE": "a cod salted and dried [n -S]\n",
  "HABERDINES": "HABERDINE, a cod salted and dried [n]\n",
  "HABERGEON": "(historical) a sleeveless mail coat, shorter than a hauberk, also HAUBERGEON [n -S]\n",
  "HABERGEONS": "HABERGEON, (historical) a sleeveless mail coat, shorter than a hauberk, also HAUBERGEON [n]\n",
  "HABILABLE": "(Carlyle) capable of being clothed [adj]\n",
  "HABILATORY": "of or relating to clothes or dressing [adj]\n",
  "HABILE": "(French) dexterous; adroit [adj]\n",
  "HABILIMENT": "clothing, esp. for a particular purpose [n -S]\n",
  "HABILIMENTS": "HABILIMENT, clothing, esp. for a particular purpose [n]\n",
  "HABILITATE": "to endow with ability or capacity [v HABILITATED, HABILITATING, HABILITATES]\n",
  "HABILITATED": "HABILITATE, to endow with ability or capacity [v]\n",
  "HABILITATES": "HABILITATE, to endow with ability or capacity [v]\n",
  "HABILITATING": "HABILITATE, to endow with ability or capacity [v]\n",
  "HABILITATION": "the act of habilitating [n -S]\n",
  "HABILITATIONS": "HABILITATION, the act of habilitating [n]\n",
  "HABILITATOR": "one who habilitates [n -S]\n",
  "HABILITATORS": "HABILITATOR, one who habilitates [n]\n",
  "HABIT": "to clothe [v -ED, -ING, -S]\n",
  "HABITABILITIES": "HABITABILITY, the state of being habitable [n]\n",
  "HABITABILITY": "the state of being habitable [n HABITABILITIES]\n",
  "HABITABLE": "that can be inhabited [adj HABITABLY]\n",
  "HABITABLENESS": "HABITABLE, that can be inhabited [n]\n",
  "HABITABLENESSES": "HABITABLENESS, HABITABLE, that can be inhabited [n]\n",
  "HABITABLY": "HABITABLE, that can be inhabited [adv]\n",
  "HABITAN": "(French) a French native of Louisiana or Carolina, also HABITANT [n -S]\n",
  "HABITANS": "HABITAN, (French) a French native of Louisiana or Carolina, also HABITANT [n]\n",
  "HABITANT": "(French) a French native of Louisiana or Carolina, also HABITAN [n -S]\n",
  "HABITANTS": "HABITANT, (French) a French native of Louisiana or Carolina, also HABITAN [n]\n",
  "HABITAT": "the natural environment of a plant or animal [n -S]\n",
  "HABITATION": "the act of inhabiting [n -S]\n",
  "HABITATIONAL": "relating to habitation [adj]\n",
  "HABITATIONS": "HABITATION, the act of inhabiting [n]\n",
  "HABITATS": "HABITAT, the natural environment of a plant or animal [n]\n",
  "HABITAUNCE": "(Spenser) dwelling-place [n -S]\n",
  "HABITAUNCES": "HABITAUNCE, (Spenser) dwelling-place [n]\n",
  "HABITED": "HABIT, to clothe [v]\n",
  "HABITING": "HABIT, to clothe [v]\n",
  "HABITS": "HABIT, to clothe [v]\n",
  "HABITUAL": "according to habit [adj HABITUALLY] / someone who has a habit e.g. a drunkard, a drug-taker [n -S]\n",
  "HABITUALLY": "HABITUAL, according to habit [adv]\n",
  "HABITUALNESS": "the state of being habitual [n -ES]\n",
  "HABITUALNESSES": "HABITUALNESS, the state of being habitual [n]\n",
  "HABITUALS": "HABITUAL, someone who has a habit e.g. a drunkard, a drug-taker [n]\n",
  "HABITUATE": "to accustom to [v HABITUATED, HABITUATING, HABITUATES]\n",
  "HABITUATED": "HABITUATE, to accustom to [v]\n",
  "HABITUATES": "HABITUATE, to accustom to [v]\n",
  "HABITUATING": "HABITUATE, to accustom to [v]\n",
  "HABITUATION": "the process of habituating [n -S]\n",
  "HABITUATIONS": "HABITUATION, the process of habituating [n]\n",
  "HABITUDE": "a usual course of action [n -S]\n",
  "HABITUDES": "HABITUDE, a usual course of action [n]\n",
  "HABITUDINAL": "(obsolete) related to habitude [adj]\n",
  "HABITUE": "(French) one who habitually frequents a place [n -S]\n",
  "HABITUES": "HABITUE, (French) one who habitually frequents a place [n]\n",
  "HABITUS": "(Latin) the characteristic appearance, manner of growth, etc. of a plant or animal [n -ES]\n",
  "HABITUSES": "HABITUS, (Latin) the characteristic appearance, manner of growth, etc. of a plant or animal [n]\n",
  "HABLE": "(Spenser) able [adj]\n",
  "HABOOB": "(Arabic) a violent dust storm or sandstorm, esp. in Sudan along the southern edges of the Sahara [n -S]\n",
  "HABOOBS": "HABOOB, (Arabic) a violent dust storm or sandstorm, esp. in Sudan along the southern edges of the Sahara [n]\n",
  "HABU": "(Japanese) a venomous snake found in Japan [n -S]\n",
  "HABUS": "HABU, (Japanese) a venomous snake found in Japan [n]\n",
  "HACEK": "(Czech) in Slavonic languages, a diacritic [n -S]\n",
  "HACEKS": "HACEK, (Czech) in Slavonic languages, a diacritic [n]\n",
  "HACENDADO": "(Spanish) the owner or proprietor of a hacienda, also HACIENDADO [n -S]\n",
  "HACENDADOS": "HACENDADO, (Spanish) the owner or proprietor of a hacienda, also HACIENDADO [n]\n",
  "HACHIS": "(French) a hash, a mess [n HACHIS]\n",
  "HACHURE": "(French) to make a hatching on a map [v HACHURED, HACHURING, HACHURES]\n",
  "HACHURED": "HACHURE, (French) to make a hatching on a map [v]\n",
  "HACHURES": "HACHURE, (French) to make a hatching on a map [v]\n",
  "HACHURING": "HACHURE, (French) to make a hatching on a map [v]\n",
  "HACIENDA": "(Spanish) a landed estate, a ranch [n -S]\n",
  "HACIENDADO": "the owner of a hacienda, also HACENDADO [n -S]\n",
  "HACIENDADOS": "HACIENDADO, the owner of a hacienda, also HACENDADO [n]\n",
  "HACIENDAS": "HACIENDA, (Spanish) a landed estate, a ranch [n]\n",
  "HACK": "to cut or chop roughly [v -ED, -ING, -S]\n",
  "HACKABLE": "that can be hacked e.g. of a computer system [adj]\n",
  "HACKAMORE": "(Spanish) a halter consisting of a long leather or rope strap and headstall, used for leading a pack animal [n -S]\n",
  "HACKAMORES": "HACKAMORE, (Spanish) a halter consisting of a long leather or rope strap and headstall, used for leading a pack animal [n]\n",
  "HACKBERRIES": "HACKBERRY, a genus of trees related to the elm, but bearing drupes with scanty, but often edible, pulp, also HAGBERRY [n]\n",
  "HACKBERRY": "a genus of trees related to the elm, but bearing drupes with scanty, but often edible, pulp, also HAGBERRY [n HACKBERRIES]\n",
  "HACKBOLT": "a sea bird, the greater shearwater, also HAGBOLT, HAGDEN, HAGDON, HAGDOWN [n -S]\n",
  "HACKBOLTS": "HACKBOLT, a sea bird, the greater shearwater, also HAGBOLT, HAGDEN, HAGDON, HAGDOWN [n]\n",
  "HACKBUT": "(historical) a harquebus; a matchlock gun invented in the 15th century, also HAGBUT [n -S]\n",
  "HACKBUTEER": "one who uses a hackbut, an arquebus, also HACKBUTTER, HAGBUTEER, HAGBUTTER [n -S]\n",
  "HACKBUTEERS": "HACKBUTEER, one who uses a hackbut, an arquebus, also HACKBUTTER, HAGBUTEER, HAGBUTTER [n]\n",
  "HACKBUTS": "HACKBUT, (historical) a harquebus; a matchlock gun invented in the 15th century, also HAGBUT [n]\n",
  "HACKBUTTER": "one who uses a hackbut, also HACKBUTEER, HAGBUTEER, HAGBUTTER [n -S]\n",
  "HACKBUTTERS": "HACKBUTTER, one who uses a hackbut, also HACKBUTEER, HAGBUTEER, HAGBUTTER [n]\n",
  "HACKED": "HACK, to cut or chop roughly [v]\n",
  "HACKEE": "the chipmunk [n -S]\n",
  "HACKEES": "HACKEE, the chipmunk [n]\n",
  "HACKER": "one that hacks [n -S]\n",
  "HACKERAZZI": "a person who hacks into the personal computer of a celebrity in order to gain information about them [n -S]\n",
  "HACKERAZZIS": "HACKERAZZI, a person who hacks into the personal computer of a celebrity in order to gain information about them [n]\n",
  "HACKERAZZO": "a person who hacks into the personal computer of a celebrity in order to gain information about them [n HACKERAZZI]\n",
  "HACKERIES": "HACKERY, an ox-drawn cart for moving goods [n]\n",
  "HACKERS": "HACKER, one that hacks [n]\n",
  "HACKERY": "an ox-drawn cart for moving goods [n HACKERIES]\n",
  "HACKETTE": "a woman journalist [n -S]\n",
  "HACKETTES": "HACKETTE, a woman journalist [n]\n",
  "HACKIE": "a taxicab driver [n -S]\n",
  "HACKIES": "HACKIE, a taxicab driver [n]\n",
  "HACKING": "horseback riding [n -S]\n",
  "HACKINGS": "HACKING, horseback riding [n]\n",
  "HACKLE": "a comb for flax or hemp, also HATCHEL, HECKLE [n -S] / to comb with a hackle [v HACKLED, HACKLING, HACKLES]\n",
  "HACKLED": "HACKLE, to comb with a hackle [v]\n",
  "HACKLER": "a device for hackling, combing flax [n -S]\n",
  "HACKLERS": "HACKLER, a device for hackling, combing flax [n]\n",
  "HACKLES": "HACKLE, to comb with a hackle [v]\n",
  "HACKLET": "the kittiwake or shearwater, also HAGLET [n -S]\n",
  "HACKLETS": "HACKLET, the kittiwake or shearwater, also HAGLET [n]\n",
  "HACKLIER": "HACKLY, rough or broken, as if hacked, esp. of the surface of a mineral [adj]\n",
  "HACKLIEST": "HACKLY, rough or broken, as if hacked, esp. of the surface of a mineral [adj]\n",
  "HACKLING": "HACKLE, to comb with a hackle [v]\n",
  "HACKLY": "rough or broken, as if hacked, esp. of the surface of a mineral [adj HACKLIER, HACKLIEST]\n",
  "HACKMAN": "the driver of a hack or carriage for public hire [n HACKMEN]\n",
  "HACKMATACK": "(Native American) the American larch, a coniferous tree with slender deciduous leaves [n -S]\n",
  "HACKMATACKS": "HACKMATACK, (Native American) the American larch, a coniferous tree with slender deciduous leaves [n]\n",
  "HACKMEN": "HACKMAN, the driver of a hack or carriage for public hire [n]\n",
  "HACKNEY": "a four-wheeled two-horse carriage [n -S] / to make trite [v -ED, -ING, -S]\n",
  "HACKNEYED": "HACKNEY, to make trite [v]\n",
  "HACKNEYING": "HACKNEY, to make trite [v]\n",
  "HACKNEYISM": "the quality of being hackneyed [n -S]\n",
  "HACKNEYISMS": "HACKNEYISM, the quality of being hackneyed [n]\n",
  "HACKNEYMAN": "a man who lets horses and carriages for hire [n HACKNEYMEN]\n",
  "HACKNEYMEN": "HACKNEYMAN, a man who lets horses and carriages for hire [n]\n",
  "HACKNEYS": "HACKNEY, to make trite [v]\n",
  "HACKS": "HACK, to cut or chop roughly [v]\n",
  "HACKSAW": "to cut with a type of saw [v HACKSAWED, HACKSAWN, HACKSAWING, HACKSAWS]\n",
  "HACKSAWED": "HACKSAW, to cut with a type of saw [v]\n",
  "HACKSAWING": "HACKSAW, to cut with a type of saw [v]\n",
  "HACKSAWN": "HACKSAW, to cut with a type of saw [v]\n",
  "HACKSAWS": "HACKSAW, to cut with a type of saw [v]\n",
  "HACKTIVISM": "the act of breaking into a computer system in order to pursue a political or social aim [n -S]\n",
  "HACKTIVISMS": "HACKTIVISM, the act of breaking into a computer system in order to pursue a political or social aim [n]\n",
  "HACKTIVIST": "someone who hacks into computer systems as a form of protest [n -S]\n",
  "HACKTIVISTS": "HACKTIVIST, someone who hacks into computer systems as a form of protest [n]\n",
  "HACKWORK": "artistic work done according to formula [n -S]\n",
  "HACKWORKS": "HACKWORK, artistic work done according to formula [n]\n",
  "HACQUETON": "a stuffed jacket worn under mail, also ACTON, HAQUETON [n -S]\n",
  "HACQUETONS": "HACQUETON, a stuffed jacket worn under mail, also ACTON, HAQUETON [n]\n",
  "HAD": "(Scots) to hold [v HAD, HADDEN, HADDING, HADS]\n",
  "HADAL": "of, relating to or being parts of the ocean below 6000 meters, below abyssal [adj]\n",
  "HADARIM": "HEDER, (Hebrew) a Jewish school, also CHEDER [n]\n",
  "HADAWAY": "an interjection urging someone on [interj]\n",
  "HADDEN": "HAD, (Scots) to hold [v]\n",
  "HADDEST": "(archaic) 2nd person past singular of have, to possess [v]\n",
  "HADDIE": "(Scots) a haddock [n -S]\n",
  "HADDIES": "HADDIE, (Scots) a haddock [n]\n",
  "HADDING": "HAD, (Scots) to hold [v]\n",
  "HADDOCK": "a North Atlantic food fish, similar to but smaller than the cod, also HADDIE [n -S]\n",
  "HADDOCKS": "HADDOCK, a North Atlantic food fish, similar to but smaller than the cod, also HADDIE [n]\n",
  "HADE": "to incline from the vertical [v HADED, HADING, HADES]\n",
  "HADED": "HADE, to incline from the vertical [v]\n",
  "HADEDAH": "(South African) a large greyish-green ibis [n -S]\n",
  "HADEDAHS": "HADEDAH, (South African) a large greyish-green ibis [n]\n",
  "HADES": "HADE, to incline from the vertical [v]\n",
  "HADING": "HADE, to incline from the vertical [v]\n",
  "HADITH": "(Arabic) a record of the sayings of Mohammed [n -S]\n",
  "HADITHS": "HADITH, (Arabic) a record of the sayings of Mohammed [n]\n",
  "HADJ": "(Arabic) a pilgrimage to Mecca, also HAJ, HAJJ [n -ES]\n",
  "HADJEE": "(Arabic) a person who has made a hadj, also HADJI, HAJI, HAJJI [n -S]\n",
  "HADJEES": "HADJEE, (Arabic) a person who has made a hadj, also HADJI, HAJI, HAJJI [n]\n",
  "HADJES": "HADJ, (Arabic) a pilgrimage to Mecca, also HAJ, HAJJ [n]\n",
  "HADJI": "(Arabic) a person who has made a hadj, also HADJEE, HAJI, HAJJI [n -S]\n",
  "HADJIS": "HADJI, (Arabic) a person who has made a hadj, also HADJEE, HAJI, HAJJI [n]\n",
  "HADROME": "the conducting tissue of the xylem [n -S]\n",
  "HADROMES": "HADROME, the conducting tissue of the xylem [n]\n",
  "HADRON": "one of a class of subatomic particles, including baryons and mesons [n -S]\n",
  "HADRONIC": "relating to a hadron [adj]\n",
  "HADRONS": "HADRON, one of a class of subatomic particles, including baryons and mesons [n]\n",
  "HADROSAUR": "a bird-hipped dinosaur of the Cretaceous [n -S]\n",
  "HADROSAURS": "HADROSAUR, a bird-hipped dinosaur of the Cretaceous [n]\n",
  "HADROSAURUS": "a large dinosaur [n -ES]\n",
  "HADROSAURUSES": "HADROSAURUS, a large dinosaur [n]\n",
  "HADS": "HAD, (Scots) to hold [v]\n",
  "HADST": "(archaic) 2nd person past singular of have, to possess, also HADDEST [v]\n",
  "HAE": "(Scots) to have [v HAED, HAEN, HAEING, HAES]\n",
  "HAECCEITIES": "HAECCEITY, the quality that makes a thing describable as 'this'; particular character, individuality [n]\n",
  "HAECCEITY": "the quality that makes a thing describable as 'this'; particular character, individuality [n HAECCEITIES]\n",
  "HAED": "HAE, (Scots) to have [v]\n",
  "HAEING": "HAE, (Scots) to have [v]\n",
  "HAEM": "the pigment combined with protein in haemoglobin, also HEME [n -S]\n",
  "HAEMACHROME": "a blood pigment, such as haemoglobin, that carries oxygen, also HEMACHROME [n -S]\n",
  "HAEMACHROMES": "HAEMACHROME, a blood pigment, such as haemoglobin, that carries oxygen, also HEMACHROME [n]\n",
  "HAEMACYTOMETER": "an apparatus for counting the number of cells in a quantity of blood, typically consisting of a graduated pipette for drawing and diluting, also HEMACYTOMETER [n -S]\n",
  "HAEMACYTOMETERS": "HAEMACYTOMETER, an apparatus for counting the number of cells in a quantity of blood, typically consisting of a graduated pipette for drawing and diluting, also HEMACYTOMETER [n]\n",
  "HAEMAGGLUTINATE": "to cause the clumping of red blood cells in (a blood sample), also HEMAGGLUTINATE [v]\n",
  "HAEMAGGLUTININ": "a virus, antibody or other agent causing haemagglutination, also HEMAGGLUTININ [n -S]\n",
  "HAEMAGGLUTININS": "HAEMAGGLUTININ, a virus, antibody or other agent causing haemagglutination, also HEMAGGLUTININ [n]\n",
  "HAEMAGOGUE": "a drug that promotes the flow of blood, also HEMAGOG, HEMAGOGUE [n -S]\n",
  "HAEMAGOGUES": "HAEMAGOGUE, a drug that promotes the flow of blood, also HEMAGOG, HEMAGOGUE [n]\n",
  "HAEMAL": "pertaining to the blood, also HAEMATAL, HAEMIC, HAEMOID, HEMAL, HEMATAL, HEMIC, HEMOID [adj]\n",
  "HAEMANGIOMA": "a usually benign tumour made up of blood vessels, also HEMANGIOMA [n HAEMANGIOMAS or HAEMANGIOMATA]\n",
  "HAEMANGIOMAS": "HAEMANGIOMA, a usually benign tumour made up of blood vessels, also HEMANGIOMA [n]\n",
  "HAEMANGIOMATA": "HAEMANGIOMA, a usually benign tumour made up of blood vessels, also HEMANGIOMA [n]\n",
  "HAEMATAL": "pertaining to the blood, also HAEMAL, HAEMIC, HAEMOID, HEMAL, HEMATAL, HEMIC, HEMOID [adj]\n",
  "HAEMATEIN": "a dark purple crystalline substance obtained from logwood and used as an indicator and biological stain, also HEMATEIN [n -S]\n",
  "HAEMATEINS": "HAEMATEIN, a dark purple crystalline substance obtained from logwood and used as an indicator and biological stain, also HEMATEIN [n]\n",
  "HAEMATEMESES": "HAEMATEMESIS, vomiting of blood from the stomach, also HEMATEMESIS [n]\n",
  "HAEMATEMESIS": "vomiting of blood from the stomach, also HEMATEMESIS [n HAEMATEMESES]\n",
  "HAEMATIC": "a medicine for a blood disease, also HEMATIC [n -S]\n",
  "HAEMATICS": "HAEMATIC, a medicine for a blood disease, also HEMATIC [n]\n",
  "HAEMATIN": "a brown substance containing ferric iron obtained from dried blood, also HEMATIN, HEMATINE [n -S]\n",
  "HAEMATINIC": "having the effect of increasing the haemoglobin or of stimulating the production of red blood cells [adj] / a drug that stimulates the production of red blood cells, also HEMATINIC [n -S]\n",
  "HAEMATINICS": "HAEMATINIC, a drug that stimulates the production of red blood cells, also HEMATINIC [n]\n",
  "HAEMATINS": "HAEMATIN, a brown substance containing ferric iron obtained from dried blood, also HEMATIN, HEMATINE [n]\n",
  "HAEMATITE": "an ore of iron, also HEMATITE [n -S]\n",
  "HAEMATITES": "HAEMATITE, an ore of iron, also HEMATITE [n]\n",
  "HAEMATITIC": "of or like haematite, an ore of iron, also HEMATITIC [adj]\n",
  "HAEMATOBLAST": "a blood platelet, also HEMATOBLAST [n -S]\n",
  "HAEMATOBLASTIC": "of or like haematoblast, a blood platelet, also HEMATOBLASTIC [adj]\n",
  "HAEMATOBLASTS": "HAEMATOBLAST, a blood platelet, also HEMATOBLAST [n]\n",
  "HAEMATOCELE": "a cavity containing blood, also HEMATOCELE [n -S]\n",
  "HAEMATOCELES": "HAEMATOCELE, a cavity containing blood, also HEMATOCELE [n]\n",
  "HAEMATOCRIT": "a graduated capillary tube in which the blood is centrifuged, to determine the ratio, by volume, of blood cells to plasma, also HEMATOCRIT [n -S]\n",
  "HAEMATOCRITS": "HAEMATOCRIT, a graduated capillary tube in which the blood is centrifuged, to determine the ratio, by volume, of blood cells to plasma, also HEMATOCRIT [n]\n",
  "HAEMATOCRYAL": "of all animals except birds and mammals, having a body temperature that varies with the temperature of the surroundings, also HEMATOCRYAL [adj]\n",
  "HAEMATOGENESES": "HAEMATOGENESIS, the production of blood, also HEMATOGENESIS [n]\n",
  "HAEMATOGENESIS": "the production of blood, also HEMATOGENESIS [n HAEMATOGENESES]\n",
  "HAEMATOGENETIC": "relating to haematogenesis, the production of blood [adj]\n",
  "HAEMATOGENIC": "relating to haematogenesis, the production of blood, also HEMATOGENIC [adj]\n",
  "HAEMATOGENOUS": "relating to haematogenesis, the production of blood, also HEMATOGENOUS [adj]\n",
  "HAEMATOID": "resembling blood, also HEMATOID [adj]\n",
  "HAEMATOLOGIC": "relating to haematology, also HAEMATOLOGICAL, HEMATOLOGIC, HEMATOLOGICAL [adj]\n",
  "HAEMATOLOGICAL": "related to haematology, also HAEMATOLOGIC, HEMATOLOGIC, HEMATOLOGICAL [adj]\n",
  "HAEMATOLOGIES": "HAEMATOLOGY, the study of blood, diseases of blood, and blood-forming tissues, also HEMATOLOGY [n]\n",
  "HAEMATOLOGIST": "a specialist in haematology, also HEMATOLOGIST [n -S]\n",
  "HAEMATOLOGISTS": "HAEMATOLOGIST, a specialist in haematology, also HEMATOLOGIST [n]\n",
  "HAEMATOLOGY": "the study of blood, diseases of blood, and blood-forming tissues, also HEMATOLOGY [n HAEMATOLOGIES]\n",
  "HAEMATOLYSES": "HAEMATOLYSIS, breaking up of red blood corpuscles, also HEMATOLYSIS [n]\n",
  "HAEMATOLYSIS": "breaking up of red blood corpuscles, also HEMATOLYSIS [n HAEMATOLYSES]\n",
  "HAEMATOMA": "a swelling composed of blood effused into tissues, also HEMATOMA [n HAEMATOMAS or HAEMATOMATA]\n",
  "HAEMATOMAS": "HAEMATOMA, a swelling composed of blood effused into tissues, also HEMATOMA [n]\n",
  "HAEMATOMATA": "HAEMATOMA, a swelling composed of blood effused into tissues, also HEMATOMA [n]\n",
  "HAEMATOPHAGOUS": "of certain animals, feeding on blood, also HEMATOPHAGOUS [adj]\n",
  "HAEMATOPOIESES": "HAEMATOPOIESIS, the formation of blood, also HAEMOPOIESIS, HEMATOPOIESIS, HEMOPOIESIS [n]\n",
  "HAEMATOPOIESIS": "the formation of blood, also HAEMOPOIESIS, HEMATOPOIESIS, HEMOPOIESIS [n HAEMATOPOIESES]\n",
  "HAEMATOPOIETIC": "relating to haematopoiesis, the formation of blood, also HEMATOPOIETIC [adj]\n",
  "HAEMATOSES": "HAEMATOSIS, the formation of blood; conversion of venous into arterial blood, also HEMATOSIS [n]\n",
  "HAEMATOSIS": "the formation of blood; conversion of venous into arterial blood, also HEMATOSIS [n HAEMATOSES]\n",
  "HAEMATOTHERMAL": "of birds and mammals, having a constant body temperature, usually higher than the temperature of the surroundings, also HEMATOTHERMAL [adj]\n",
  "HAEMATOXYLIC": "of or like haematoxylin [adj]\n",
  "HAEMATOXYLIN": "a dye obtained from logwood, also HEMATOXYLIN [n -S]\n",
  "HAEMATOXYLINS": "HAEMATOXYLIN, a dye obtained from logwood, also HEMATOXYLIN [n]\n",
  "HAEMATOXYLON": "any thorny leguminous tree of the genus Haematoxylon, esp. the logwood, of tropical America and SW Africa, the heartwood of which yields the dye haematoxylin [n -S]\n",
  "HAEMATOXYLONS": "HAEMATOXYLON, any thorny leguminous tree of the genus Haematoxylon, esp. the logwood, of tropical America and SW Africa, the heartwood of which yields the dye haematoxylin [n]\n",
  "HAEMATOZOA": "HAEMATOZOON, any microorganism, esp. a protozoan, that is parasitic in the blood, also HEMATOZOON [n]\n",
  "HAEMATOZOON": "any microorganism, esp. a protozoan, that is parasitic in the blood, also HEMATOZOON [n HAEMATOZOA]\n",
  "HAEMATURIA": "the presence of blood in the urine, also HEMATURIA [n -S]\n",
  "HAEMATURIAS": "HAEMATURIA, the presence of blood in the urine, also HEMATURIA [n]\n",
  "HAEMATURIC": "relating to haematuria, the presence of blood in urine, also HEMATURIC [adj]\n",
  "HAEMIC": "pertaining to the blood, also HAEMAL, HAEMATAL, HAEMOID, HEMAL, HEMATAL, HEMIC, HEMOID [adj]\n",
  "HAEMIN": "the red, crystalline salt of haematin with hydrochloric acid, also HEMIN [n -S]\n",
  "HAEMINS": "HAEMIN, the red, crystalline salt of haematin with hydrochloric acid, also HEMIN [n]\n",
  "HAEMOCHROME": "a blood pigment, such as haemoglobin, that carries oxygen, also HEMOCHROME [n -S]\n",
  "HAEMOCHROMES": "HAEMOCHROME, a blood pigment, such as haemoglobin, that carries oxygen, also HEMOCHROME [n]\n",
  "HAEMOCOEL": "the central body cavity of many invertebrates, also HEMOCOEL [n -S]\n",
  "HAEMOCOELS": "HAEMOCOEL, the central body cavity of many invertebrates, also HEMOCOEL [n]\n",
  "HAEMOCONIA": "small colourless granules in the blood, aka blood-dust, also HEMOCONIA [n HAEMOCONIAS]\n",
  "HAEMOCONIAS": "HAEMOCONIA, small colourless granules in the blood, aka blood-dust, also HEMOCONIA [n]\n",
  "HAEMOCYANIN": "an oxygen-carrying pigment in arachnids, equivalent to haemoglobin in mammals [n -S]\n",
  "HAEMOCYANINS": "HAEMOCYANIN, an oxygen-carrying pigment in arachnids, equivalent to haemoglobin in mammals [n]\n",
  "HAEMOCYTE": "a blood cell, esp. a red cell, also HEMOCYTE [n -S]\n",
  "HAEMOCYTES": "HAEMOCYTE, a blood cell, esp. a red cell, also HEMOCYTE [n]\n",
  "HAEMOCYTOMETER": "an apparatus for counting the number of cells in a quantity of blood, typically consisting of a graduated pipette for drawing and diluting, also HEMOCYTOMETER [n -S]\n",
  "HAEMOCYTOMETERS": "HAEMOCYTOMETER, an apparatus for counting the number of cells in a quantity of blood, typically consisting of a graduated pipette for drawing and diluting, also HEMOCYTOMETER [n]\n",
  "HAEMODIALYSER": "an artificial kidney, also HAEMODIALYZER, HEMODIALYZER [n -S]\n",
  "HAEMODIALYSERS": "HAEMODIALYSER, an artificial kidney, also HAEMODIALYZER, HEMODIALYZER [n]\n",
  "HAEMODIALYSES": "HAEMODIALYSIS, dialysis of the blood using a kidney machine, also HEMODIALYSIS [n]\n",
  "HAEMODIALYSIS": "dialysis of the blood using a kidney machine, also HEMODIALYSIS [n HAEMODIALYSES]\n",
  "HAEMODIALYZER": "an artificial kidney, also HAEMODIALYSER, HEMODIALYZER [n -S]\n",
  "HAEMODIALYZERS": "HAEMODIALYZER, an artificial kidney, also HAEMODIALYSER, HEMODIALYZER [n]\n",
  "HAEMODILUTION": "an increase in the fluid content of blood leading to a lower concentration of red blood cells, also HEMODILUTION [n -S]\n",
  "HAEMODILUTIONS": "HAEMODILUTION, an increase in the fluid content of blood leading to a lower concentration of red blood cells, also HEMODILUTION [n]\n",
  "HAEMODYNAMIC": "of or relating to blood circulation, also HEMODYNAMIC [adj]\n",
  "HAEMODYNAMICS": "a branch of physiology that deals with the circulation of the blood, also HEMODYNAMICS [n]\n",
  "HAEMOFLAGELLATE": "a flagellate protozoan, such as a trypanosome, that is parasitic in the blood, also HEMOFLAGELLATE [n]\n",
  "HAEMOGLOBIN": "the iron-containing pigment which is the oxygen-carrying substance present in the red blood cells of vertebrates, also HEMOGLOBIN [n -S]\n",
  "HAEMOGLOBINS": "HAEMOGLOBIN, the iron-containing pigment which is the oxygen-carrying substance present in the red blood cells of vertebrates, also HEMOGLOBIN [n]\n",
  "HAEMOGLOBINURIA": "the presence of haemoglobin in the urine, also HEMOGLOBINURIA [n]\n",
  "HAEMOGLOBINURIC": "relating to the presence of haemoglobin in the urine, also HEMOGLOBINURIC [adj]\n",
  "HAEMOID": "pertaining to the blood, also HAEMAL, HAEMATAL, HAEMIC, HEMAL, HEMATAL, HEMIC, HEMOID [adj]\n",
  "HAEMOLYMPH": "the bloodlike fluid of invertebrates, also HEMOLYMPH [n -S]\n",
  "HAEMOLYMPHS": "HAEMOLYMPH, the bloodlike fluid of invertebrates, also HEMOLYMPH [n]\n",
  "HAEMOLYSE": "to break down red blood cells, also HAEMOLYZE, HEMOLYSE, HEMOLYZE [v HAEMOLYSED, HAEMOLYSING, HAEMOLYSES]\n",
  "HAEMOLYSED": "HAEMOLYSE, to break down red blood cells, also HAEMOLYZE, HEMOLYSE, HEMOLYZE [v]\n",
  "HAEMOLYSES": "HAEMOLYSIS, breaking up of red blood-corpuscles [n]\n",
  "HAEMOLYSIN": "any substance, esp. an antibody, that causes the breakdown of red blood cells, also HEMOLYSIN [n -S]\n",
  "HAEMOLYSING": "HAEMOLYSE, to break down red blood cells, also HAEMOLYZE, HEMOLYSE, HEMOLYZE [v]\n",
  "HAEMOLYSINS": "HAEMOLYSIN, any substance, esp. an antibody, that causes the breakdown of red blood cells, also HEMOLYSIN [n]\n",
  "HAEMOLYSIS": "breaking up of red blood-corpuscles [n HAEMOLYSES]\n",
  "HAEMOLYTIC": "relating to haemolysis, the breaking up of red blood-corpuscles, also HEMOLYTIC [adj]\n",
  "HAEMOLYZE": "to break down red blood cells, also HAEMOLYSE, HEMOLYSE, HEMOLYZE [v HAEMOLYZED, HAEMOLYZING, HAEMOLYZES]\n",
  "HAEMOLYZED": "HAEMOLYZE, to break down red blood cells, also HAEMOLYSE, HEMOLYSE, HEMOLYZE [v]\n",
  "HAEMOLYZES": "HAEMOLYZE, to break down red blood cells, also HAEMOLYSE, HEMOLYSE, HEMOLYZE [v]\n",
  "HAEMOLYZING": "HAEMOLYZE, to break down red blood cells, also HAEMOLYSE, HEMOLYSE, HEMOLYZE [v]\n",
  "HAEMONIES": "HAEMONY, a plant which could act against magic [n]\n",
  "HAEMONY": "a plant which could act against magic [n HAEMONIES]\n",
  "HAEMOPHILE": "a person with haemophilia, also HEMOPHILE [n -S]\n",
  "HAEMOPHILES": "HAEMOPHILE, a person with haemophilia, also HEMOPHILE [n]\n",
  "HAEMOPHILIA": "a hereditary disease causing excessive bleeding when any blood vessel is even slightly injured [n -S]\n",
  "HAEMOPHILIAC": "one suffering from haemophilia [n -S]\n",
  "HAEMOPHILIACS": "HAEMOPHILIAC, one suffering from haemophilia [n]\n",
  "HAEMOPHILIAS": "HAEMOPHILIA, a hereditary disease causing excessive bleeding when any blood vessel is even slightly injured [n]\n",
  "HAEMOPHILIC": "suffering from haemophilia, also HEMOPHILIC [adj]\n",
  "HAEMOPHILIOID": "relating to haemophilia, also HEMOPHILIOID [adj]\n",
  "HAEMOPHOBIA": "an irrational fear of blood [n -S]\n",
  "HAEMOPHOBIAS": "HAEMOPHOBIA, an irrational fear of blood [n]\n",
  "HAEMOPOIESES": "HAEMOPOIESIS, the formation of blood, also HAEMATOPOIESIS, HEMATOPOIESIS, HEMOPOIESIS [n]\n",
  "HAEMOPOIESIS": "the formation of blood, also HAEMATOPOIESIS, HEMATOPOIESIS, HEMOPOIESIS [n HAEMOPOIESES]\n",
  "HAEMOPOIETIC": "relating to haemopoiesis, the formation of blood [adj]\n",
  "HAEMOPROTEIN": "a conjugated protein, such as hemoglobin or cytochrome, whose prosthetic group is a porphyrin combined with iron, also HEMOPROTEIN [n -S]\n",
  "HAEMOPROTEINS": "HAEMOPROTEIN, a conjugated protein, such as hemoglobin or cytochrome, whose prosthetic group is a porphyrin combined with iron, also HEMOPROTEIN [n]\n",
  "HAEMOPTYSES": "HAEMOPTYSIS, the spitting or coughing up of blood from the lungs [n]\n",
  "HAEMOPTYSIS": "the spitting or coughing up of blood from the lungs [n HAEMOPTYSES]\n",
  "HAEMORRHAGE": "a discharge of blood from the blood vessels [n -S] / to lose blood from the blood vessels, also HEMORRHAGE [v HAEMORRHAGED, HAEMORRHAGING, HAEMORRHAGES]\n",
  "HAEMORRHAGED": "HAEMORRHAGE, to lose blood from the blood vessels, also HEMORRHAGE [v]\n",
  "HAEMORRHAGES": "HAEMORRHAGE, to lose blood from the blood vessels, also HEMORRHAGE [v]\n",
  "HAEMORRHAGIC": "relating to haemorrhage, also HEMORRHAGIC [adj]\n",
  "HAEMORRHAGING": "loss of blood from the blood vessels, also HEMORRHAGING [n -S]\n",
  "HAEMORRHAGINGS": "HAEMORRHAGING, loss of blood from the blood vessels, also HEMORRHAGING [n]\n",
  "HAEMORRHOID": "dilatation of a vein around the anus, also HEMORRHOID [n -S]\n",
  "HAEMORRHOIDAL": "relating to haemorrhoids, also HEMORRHOIDAL [adj]\n",
  "HAEMORRHOIDS": "HAEMORRHOID, dilatation of a vein around the anus, also HEMORRHOID [n]\n",
  "HAEMOSIDERIN": "a pigment that is formed in some phagocytic cells by the breakdown of hemoglobin and is probably essentially a denatured form of ferritin, also HEMOSIDERIN [n -S]\n",
  "HAEMOSIDERINS": "HAEMOSIDERIN, a pigment that is formed in some phagocytic cells by the breakdown of hemoglobin and is probably essentially a denatured form of ferritin, also HEMOSIDERIN [n]\n",
  "HAEMOSTASES": "HAEMOSTASIS, stoppage of bleeding or the circulation, also HAEMOSTASIA, HEMOSTASIA, HEMOSTASIS [n]\n",
  "HAEMOSTASIA": "the stoppage of bleeding or the circulation, also HAEMOSTASIS, HEMOSTASIA, HEMOSTASIS [n -S]\n",
  "HAEMOSTASIAS": "HAEMOSTASIA, the stoppage of bleeding or the circulation, also HAEMOSTASIS, HEMOSTASIA, HEMOSTASIS [n]\n",
  "HAEMOSTASIS": "stoppage of bleeding or the circulation, also HAEMOSTASIA, HEMOSTASIA, HEMOSTASIS [n HAEMOSTASES]\n",
  "HAEMOSTAT": "an instrument for stopping bleeding, also HEMOSTAT [n -S]\n",
  "HAEMOSTATIC": "a styptic, also HEMOSTATIC [n -S]\n",
  "HAEMOSTATICS": "HAEMOSTATIC, a styptic, also HEMOSTATIC [n]\n",
  "HAEMOSTATS": "HAEMOSTAT, an instrument for stopping bleeding, also HEMOSTAT [n]\n",
  "HAEMOTOXIC": "of or like a haemotoxin, a substance that destroys red blood cells, also HEMOTOXIC [adj]\n",
  "HAEMOTOXIN": "a substance that destroys red blood cells, also HEMOTOXIN [n -S]\n",
  "HAEMOTOXINS": "HAEMOTOXIN, a substance that destroys red blood cells, also HEMOTOXIN [n]\n",
  "HAEMS": "HAEM, the pigment combined with protein in haemoglobin, also HEME [n]\n",
  "HAEN": "HAE, (Scots) to have [v]\n",
  "HAEREDES": "HAERES, (Latin) an heir, also HERES [n]\n",
  "HAEREMAI": "(Maori) welcome [n -S]\n",
  "HAEREMAIS": "HAEREMAI, (Maori) welcome [n]\n",
  "HAERES": "(Latin) an heir, also HERES [n HAEREDES]\n",
  "HAES": "HAE, (Scots) to have [v]\n",
  "HAET": "(Scots) a small amount [n -S]\n",
  "HAETS": "HAET, (Scots) a small amount [n]\n",
  "HAFF": "(German) a lagoon separated from the sea by a long sandbar [n -S]\n",
  "HAFFET": "(Scots) the cheekbone and temple, also HAFFIT [n -S]\n",
  "HAFFETS": "HAFFET, (Scots) the cheekbone and temple, also HAFFIT [n]\n",
  "HAFFIT": "(Scots) the cheekbone and temple, also HAFFET [n -S]\n",
  "HAFFITS": "HAFFIT, (Scots) the cheekbone and temple, also HAFFET [n]\n",
  "HAFFLIN": "(Scots) a half-grown person, also HALFLING, HALFLIN [n -S]\n",
  "HAFFLINS": "HAFFLIN, (Scots) a half-grown person, also HALFLING, HALFLIN [n]\n",
  "HAFFS": "HAFF, (German) a lagoon separated from the sea by a long sandbar [n]\n",
  "HAFIZ": "(Arabic) a Muslim who knows the Koran by heart [n -ES]\n",
  "HAFIZES": "HAFIZ, (Arabic) a Muslim who knows the Koran by heart [n]\n",
  "HAFNIUM": "a metallic element [n -S]\n",
  "HAFNIUMS": "HAFNIUM, a metallic element [n]\n",
  "HAFT": "a handle, esp. of an axe or knife [n -S] / to set in a haft; to establish firmly [v -ED, -ING, -S]\n",
  "HAFTARA": "(Hebrew) a Biblical selection, also HAFTARAH, HAFTORAH, HAPHTARA, HAPHTARAH [n HAFTARAS or HAFTAROT or HAFTAROTH]\n",
  "HAFTARAH": "(Hebrew) a Biblical selection, also HAFTARA, HAFTORAH, HAPHTARA, HAPHTARAH [n HAFTARAHS, HAFTAROT, HAFTAROTH or HAFTAROS]\n",
  "HAFTARAHS": "HAFTARAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTORAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTARAS": "HAFTARA, (Hebrew) a Biblical selection, also HAFTARAH, HAFTORAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTAROS": "HAFTARAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTORAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTAROT": "HAFTARA, (Hebrew) a Biblical selection, also HAFTARAH, HAFTORAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTAROTH": "HAFTARA, (Hebrew) a Biblical selection, also HAFTARAH, HAFTORAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTED": "HAFT, to set in a haft; to establish firmly [v]\n",
  "HAFTER": "a caviler, a wrangler [n -S]\n",
  "HAFTERS": "HAFTER, a caviler, a wrangler [n]\n",
  "HAFTING": "HAFT, to set in a haft; to establish firmly [v]\n",
  "HAFTORAH": "(Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAPHTARA, HAPHTARAH [n HAFTORAHS, HAFTOROT, HAFTOROTH or HAFTOROS]\n",
  "HAFTORAHS": "HAFTORAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTOROS": "HAFTORAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTOROT": "HAFTORAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTOROTH": "HAFTORAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAPHTARA, HAPHTARAH [n]\n",
  "HAFTS": "HAFT, to set in a haft; to establish firmly [v]\n",
  "HAG": "(Scots) to hack [v HAGGED, HAGGING, HAGS]\n",
  "HAGADIC": "(Hebrew) relating to the haggadah, the Pesach guidebook, used during Seder, also AGGADIC, HAGGADIC, HAGGADICAL [adj]\n",
  "HAGADIST": "(Hebrew) a scholar versed in the haggadah, the Pesach guidebook, used during Seder, also HAGGADIST [n -S]\n",
  "HAGADISTS": "HAGADIST, (Hebrew) a scholar versed in the haggadah, the Pesach guidebook, used during Seder, also HAGGADIST [n]\n",
  "HAGBERRIES": "HAGBERRY, a genus of trees related to the elm, but bearing drupes with scanty, but often edible, pulp, also HACKBERRY [n]\n",
  "HAGBERRY": "a genus of trees related to the elm, but bearing drupes with scanty, but often edible, pulp, also HACKBERRY [n HAGBERRIES]\n",
  "HAGBOLT": "a sea bird, the greater shearwater, also HACKBOLT, HAGDEN, HAGDON, HAGDOWN [n -S]\n",
  "HAGBOLTS": "HAGBOLT, a sea bird, the greater shearwater, also HACKBOLT, HAGDEN, HAGDON, HAGDOWN [n]\n",
  "HAGBORN": "born of a witch [adj]\n",
  "HAGBUSH": "a large tree [n -ES]\n",
  "HAGBUSHES": "HAGBUSH, a large tree [n]\n",
  "HAGBUT": "(historical) a harquebus; a matchlock gun invented in the 15th century, also HACKBUT [n -S]\n",
  "HAGBUTEER": "one who uses a hagbut, also HACKBUTEER, HACKBUTTER, HAGBUTTER [n -S]\n",
  "HAGBUTEERS": "HAGBUTEER, one who uses a hagbut, also HACKBUTEER, HACKBUTTER, HAGBUTTER [n]\n",
  "HAGBUTS": "HAGBUT, (historical) a harquebus; a matchlock gun invented in the 15th century, also HACKBUT [n]\n",
  "HAGBUTTER": "one who uses a hagbut, also HACKBUTEER, HACKBUTTER, HAGBUTEER [n -S]\n",
  "HAGBUTTERS": "HAGBUTTER, one who uses a hagbut, also HACKBUTEER, HACKBUTTER, HAGBUTEER [n]\n",
  "HAGDEN": "a sea bird, the greater shearwater, also HACKBOLT, HAGBOLT, HAGDON, HAGDOWN [n -S]\n",
  "HAGDENS": "HAGDEN, a sea bird, the greater shearwater, also HACKBOLT, HAGBOLT, HAGDON, HAGDOWN [n]\n",
  "HAGDON": "a sea bird, the greater shearwater, also HACKBOLT, HAGBOLT, HAGDEN, HAGDOWN [n -S]\n",
  "HAGDONS": "HAGDON, a sea bird, the greater shearwater, also HACKBOLT, HAGBOLT, HAGDEN, HAGDOWN [n]\n",
  "HAGDOWN": "a sea bird, the greater shearwater, also HACKBOLT, HAGBOLT, HAGDEN, HAGDON [n -S]\n",
  "HAGDOWNS": "HAGDOWN, a sea bird, the greater shearwater, also HACKBOLT, HAGBOLT, HAGDEN, HAGDON [n]\n",
  "HAGFISH": "a scavenging fish which resembles an eel [n -ES]\n",
  "HAGFISHES": "HAGFISH, a scavenging fish which resembles an eel [n]\n",
  "HAGG": "(Scots) broken ground in a moss or bog, a place from which peat has been dug [n -S]\n",
  "HAGGADA": "(Hebrew) the homiletic part of the Jewish scripture, also AGGADA, AGGADAH, HAGGADAH [n HAGGADAS or HAGGADOT or HAGGADOTH]\n",
  "HAGGADAH": "(Hebrew) the homiletic part of the Jewish scripture, also AGGADA, AGGADAH, HAGGADA [n HAGGADAHS, HAGGADOT or HAGGADOTH]\n",
  "HAGGADAHS": "HAGGADAH, (Hebrew) the homiletic part of the Jewish scripture, also AGGADA, AGGADAH, HAGGADA [n]\n",
  "HAGGADAS": "HAGGADA, (Hebrew) the homiletic part of the Jewish scripture, also AGGADA, AGGADAH, HAGGADAH [n]\n",
  "HAGGADIC": "(Hebrew) relating to the haggadah, the Pesach guidebook, used during Seder, also AGGADIC, HAGADIC, HAGGADICAL [adj]\n",
  "HAGGADICAL": "relating to the haggadah, the Pesach guidebook, used during Seder, also AGGADIC, HAGADIC, HAGGADIC [adj]\n",
  "HAGGADIST": "a scholar versed in the haggadah, also HAGADIST [n -S]\n",
  "HAGGADISTIC": "relating to the haggadah [adj]\n",
  "HAGGADISTS": "HAGGADIST, a scholar versed in the haggadah, also HAGADIST [n]\n",
  "HAGGADOT": "HAGGADA, (Hebrew) the homiletic part of the Jewish scripture, also AGGADA, AGGADAH, HAGGADAH [n]\n",
  "HAGGADOTH": "HAGGADAH, (Hebrew) the homiletic part of the Jewish scripture, also AGGADA, AGGADAH, HAGGADA [n]\n",
  "HAGGARD": "hollow-eyed and gaunt [adj HAGGARDLY] / an adult hawk [n -S]\n",
  "HAGGARDLY": "HAGGARD, hollow-eyed and gaunt [adv]\n",
  "HAGGARDNESS": "the state of being haggard [n -ES]\n",
  "HAGGARDNESSES": "HAGGARDNESS, the state of being haggard [n]\n",
  "HAGGARDS": "HAGGARD, an adult hawk [n]\n",
  "HAGGED": "HAG, (Scots) to hack [v]\n",
  "HAGGING": "HAG, (Scots) to hack [v]\n",
  "HAGGIS": "(Scots) a Scottish dish consisting of the heart, lungs, and liver of a sheep etc. minced with suet, oatmeal, and onions [n -ES]\n",
  "HAGGISES": "HAGGIS, (Scots) a Scottish dish consisting of the heart, lungs, and liver of a sheep etc. minced with suet, oatmeal, and onions [n]\n",
  "HAGGISH": "resembling a hag [adj HAGGISHLY]\n",
  "HAGGISHLY": "HAGGISH, resembling a hag [adv]\n",
  "HAGGISHNESS": "the state of being haggish [n -ES]\n",
  "HAGGISHNESSES": "HAGGISHNESS, the state of being haggish [n]\n",
  "HAGGLE": "to bargain [v HAGGLED, HAGGLING, HAGGLES]\n",
  "HAGGLED": "HAGGLE, to bargain [v]\n",
  "HAGGLER": "one who haggles [n -S]\n",
  "HAGGLERS": "HAGGLER, one who haggles [n]\n",
  "HAGGLES": "HAGGLE, to bargain [v]\n",
  "HAGGLING": "the act of arguing about price [n -S]\n",
  "HAGGLINGS": "HAGGLING, the act of arguing about price [n]\n",
  "HAGGS": "HAGG, (Scots) broken ground in a moss or bog, a place from which peat has been dug [n]\n",
  "HAGIARCHIES": "HAGIARCHY, government by holy persons, also HAGIOCRACY [n]\n",
  "HAGIARCHY": "government by holy persons, also HAGIOCRACY [n HAGIARCHIES]\n",
  "HAGIOCRACIES": "HAGIOCRACY, government by holy persons, also HAGIARCHY [n]\n",
  "HAGIOCRACY": "government by holy persons, also HAGIARCHY [n HAGIOCRACIES]\n",
  "HAGIOGRAPHER": "a writer of hagiography [n -S]\n",
  "HAGIOGRAPHERS": "HAGIOGRAPHER, a writer of hagiography [n]\n",
  "HAGIOGRAPHIC": "relating to hagiography, also HAGIOGRAPHICAL [adj]\n",
  "HAGIOGRAPHICAL": "relating to hagiography, also HAGIOGRAPHIC [adj]\n",
  "HAGIOGRAPHIES": "HAGIOGRAPHY, a biography of saints; an idealizing or idolizing biography [n]\n",
  "HAGIOGRAPHIST": "one who writes the lives of saints [n -S]\n",
  "HAGIOGRAPHISTS": "HAGIOGRAPHIST, one who writes the lives of saints [n]\n",
  "HAGIOGRAPHY": "a biography of saints; an idealizing or idolizing biography [n HAGIOGRAPHIES]\n",
  "HAGIOLATER": "a worshipper of saints [n -S]\n",
  "HAGIOLATERS": "HAGIOLATER, a worshipper of saints [n]\n",
  "HAGIOLATRIES": "HAGIOLATRY, worship or reverence for saints [n]\n",
  "HAGIOLATROUS": "relating to hagiolatry, worship or reverence for saints [adj]\n",
  "HAGIOLATRY": "worship or reverence for saints [n HAGIOLATRIES]\n",
  "HAGIOLOGIC": "relating to hagiology, the study of saints' lives, also HAGIOLOGICAL [adj]\n",
  "HAGIOLOGICAL": "relating to hagiology, the study of saints' lives, also HAGIOLOGIC [adj]\n",
  "HAGIOLOGIES": "HAGIOLOGY, the literature dealing with the lives and legends of saints [n]\n",
  "HAGIOLOGIST": "one who writes saints' lives [n -S]\n",
  "HAGIOLOGISTS": "HAGIOLOGIST, one who writes saints' lives [n]\n",
  "HAGIOLOGY": "the literature dealing with the lives and legends of saints [n HAGIOLOGIES]\n",
  "HAGIOSCOPE": "an opening cut in the wall of a church to enable viewing of the altar [n -S]\n",
  "HAGIOSCOPES": "HAGIOSCOPE, an opening cut in the wall of a church to enable viewing of the altar [n]\n",
  "HAGIOSCOPIC": "relating to a hagioscope [adj]\n",
  "HAGLET": "the kittiwake or shearwater, also HACKLET [n -S]\n",
  "HAGLETS": "HAGLET, the kittiwake or shearwater, also HACKLET [n]\n",
  "HAGLIKE": "like a hag [adj]\n",
  "HAGRIDDEN": "HAGRIDE, to drive as though possessed by a witch [v]\n",
  "HAGRIDE": "to drive as though possessed by a witch [v HAGRODE, HAGRIDDEN, HAGRIDING, HAGRIDES]\n",
  "HAGRIDER": "one who hagrides [n -S]\n",
  "HAGRIDERS": "HAGRIDER, one who hagrides [n]\n",
  "HAGRIDES": "HAGRIDE, to drive as though possessed by a witch [v]\n",
  "HAGRIDING": "HAGRIDE, to drive as though possessed by a witch [v]\n",
  "HAGRODE": "HAGRIDE, to drive as though possessed by a witch [v]\n",
  "HAGS": "HAG, (Scots) to hack [v]\n",
  "HAH": "a sound of surprise [n -S]\n",
  "HAHA": "a fence set in a ditch [n -S]\n",
  "HAHAS": "HAHA, a fence set in a ditch [n]\n",
  "HAHNIUM": "an artificially produced transuranic element [n -S]\n",
  "HAHNIUMS": "HAHNIUM, an artificially produced transuranic element [n]\n",
  "HAHS": "HAH, a sound of surprise [n]\n",
  "HAICK": "(Arabic) an Arab head covering, also HAIK, HAIQUE, HYKE [n -S]\n",
  "HAICKS": "HAICK, (Arabic) an Arab head covering, also HAIK, HAIQUE, HYKE [n]\n",
  "HAIDUK": "(Hungarian) a brigand, a guerilla warrior, also HEIDUC, HEYDUCK [n -S]\n",
  "HAIDUKS": "HAIDUK, (Hungarian) a brigand, a guerilla warrior, also HEIDUC, HEYDUCK [n]\n",
  "HAIK": "(Arabic) an Arab head covering, also HAICK, HAIQUE, HYKE [n HAIKS or HAIKA]\n",
  "HAIKA": "HAIK, (Arabic) an Arab head covering, also HAICK, HAIQUE, HYKE [n]\n",
  "HAIKAI": "(Japanese) a series of linked haiku [n HAIKAI]\n",
  "HAIKS": "HAIK, (Arabic) an Arab head covering, also HAICK, HAIQUE, HYKE [n]\n",
  "HAIKU": "(Japanese) a Japanese poem, also HOKKU [n -S]\n",
  "HAIKUS": "HAIKU, (Japanese) a Japanese poem, also HOKKU [n]\n",
  "HAIL": "to greet [v -ED, -ING, -S]\n",
  "HAILED": "HAIL, to greet [v]\n",
  "HAILER": "one that hails [n -S]\n",
  "HAILERS": "HAILER, one that hails [n]\n",
  "HAILIER": "HAILY, with hail falling [adj]\n",
  "HAILIEST": "HAILY, with hail falling [adj]\n",
  "HAILING": "HAIL, to greet [v]\n",
  "HAILS": "HAIL, to greet [v]\n",
  "HAILSHOT": "small shot which scatters like hailstones [n -S]\n",
  "HAILSHOTS": "HAILSHOT, small shot which scatters like hailstones [n]\n",
  "HAILSTONE": "a ball of hail [n -S]\n",
  "HAILSTONES": "HAILSTONE, a ball of hail [n]\n",
  "HAILSTORM": "a storm of hail [n -S]\n",
  "HAILSTORMS": "HAILSTORM, a storm of hail [n]\n",
  "HAILY": "with hail falling [adj HAILIER, HAILIEST]\n",
  "HAIMISH": "homelike, cosy, also HEIMISH [adj]\n",
  "HAIN": "(Scots) to save, preserve [v -ED, -ING, -S]\n",
  "HAINCH": "(Scots) to throw with an underhand motion, also HAUNCH [v -ED, -ING, -ES]\n",
  "HAINCHED": "HAINCH, (Scots) to throw with an underhand motion, also HAUNCH [v]\n",
  "HAINCHES": "HAINCH, (Scots) to throw with an underhand motion, also HAUNCH [v]\n",
  "HAINCHING": "HAINCH, (Scots) to throw with an underhand motion, also HAUNCH [v]\n",
  "HAINED": "HAIN, (Scots) to save, preserve [v]\n",
  "HAINING": "an enclosure [n -S]\n",
  "HAININGS": "HAINING, an enclosure [n]\n",
  "HAINS": "HAIN, (Scots) to save, preserve [v]\n",
  "HAINT": "(Southern US dialect) a ghost [n -S]\n",
  "HAINTS": "HAINT, (Southern US dialect) a ghost [n]\n",
  "HAIQUE": "(Arabic) an Arab head covering, also HAIK, HAICK, HYKE [n -S]\n",
  "HAIQUES": "HAIQUE, (Arabic) an Arab head covering, also HAIK, HAICK, HYKE [n]\n",
  "HAIR": "to free from hair [v -ED, -ING, -S]\n",
  "HAIRBALL": "a concretion of hair in the stomach, e.g. in cats as a result of swallowing fur, etc. during grooming [n -S]\n",
  "HAIRBALLS": "HAIRBALL, a concretion of hair in the stomach, e.g. in cats as a result of swallowing fur, etc. during grooming [n]\n",
  "HAIRBAND": "a band for the hair [n -S]\n",
  "HAIRBANDS": "HAIRBAND, a band for the hair [n]\n",
  "HAIRBELL": "the Scottish bluebell, also HAREBELL [n -S]\n",
  "HAIRBELLS": "HAIRBELL, the Scottish bluebell, also HAREBELL [n]\n",
  "HAIRBRAINED": "crazy, crackpot, also HAREBRAINED [adj]\n",
  "HAIRBREADTH": "the breadth of a hair; a minute distance, also HAIRSBREADTH [n -S]\n",
  "HAIRBREADTHS": "HAIRBREADTH, the breadth of a hair; a minute distance, also HAIRSBREADTH [n]\n",
  "HAIRBRUSH": "a brush for the hair [n -ES]\n",
  "HAIRBRUSHES": "HAIRBRUSH, a brush for the hair [n]\n",
  "HAIRCAP": "a hat [n -S]\n",
  "HAIRCAPS": "HAIRCAP, a hat [n]\n",
  "HAIRCLOTH": "stuff or cloth made wholly or in part of hair [n -S]\n",
  "HAIRCLOTHS": "HAIRCLOTH, stuff or cloth made wholly or in part of hair [n]\n",
  "HAIRCUT": "a cutting of the hair [n -S]\n",
  "HAIRCUTS": "HAIRCUT, a cutting of the hair [n]\n",
  "HAIRCUTTER": "one who cuts hair [n -S]\n",
  "HAIRCUTTERS": "HAIRCUTTER, one who cuts hair [n]\n",
  "HAIRCUTTING": "the act of cutting hair [n -S]\n",
  "HAIRCUTTINGS": "HAIRCUTTING, the act of cutting hair [n]\n",
  "HAIRDO": "a style of wearing the hair [n -S]\n",
  "HAIRDOS": "HAIRDO, a style of wearing the hair [n]\n",
  "HAIRDRESSER": "a person whose occupation is the dressing or cutting of hair [n -S]\n",
  "HAIRDRESSERS": "HAIRDRESSER, a person whose occupation is the dressing or cutting of hair [n]\n",
  "HAIRDRESSING": "the act of washing, cutting, curling, or arranging the hair [n -S]\n",
  "HAIRDRESSINGS": "HAIRDRESSING, the act of washing, cutting, curling, or arranging the hair [n]\n",
  "HAIRDRIER": "a device for drying hair, also HAIRDRYER [n -S]\n",
  "HAIRDRIERS": "HAIRDRIER, a device for drying hair, also HAIRDRYER [n]\n",
  "HAIRDRYER": "a device for drying hair, also HAIRDRIER [n -S]\n",
  "HAIRDRYERS": "HAIRDRYER, a device for drying hair, also HAIRDRIER [n]\n",
  "HAIRED": "HAIR, to free from hair [v]\n",
  "HAIRGRIP": "a device to keep hair in place [n -S]\n",
  "HAIRGRIPS": "HAIRGRIP, a device to keep hair in place [n]\n",
  "HAIRIER": "HAIRY, covered with hair [adj]\n",
  "HAIRIEST": "HAIRY, covered with hair [adj]\n",
  "HAIRIF": "the plant cleavers [n -S]\n",
  "HAIRIFS": "HAIRIF, the plant cleavers [n]\n",
  "HAIRILY": "HAIRY, covered with hair [adv]\n",
  "HAIRINESS": "the state of being hairy [n -ES]\n",
  "HAIRINESSES": "HAIRINESS, the state of being hairy [n]\n",
  "HAIRING": "HAIR, to free from hair [v]\n",
  "HAIRLESS": "a hairless dog [n -ES]\n",
  "HAIRLESSES": "HAIRLESS, a hairless dog [n]\n",
  "HAIRLESSNESS": "the state of being hairless [n -ES]\n",
  "HAIRLESSNESSES": "HAIRLESSNESS, the state of being hairless [n]\n",
  "HAIRLIKE": "resembling a hair [adj]\n",
  "HAIRLINE": "the edge of the hair on the forehead [n -S]\n",
  "HAIRLINES": "HAIRLINE, the edge of the hair on the forehead [n]\n",
  "HAIRLOCK": "a lock of hair [n -S]\n",
  "HAIRLOCKS": "HAIRLOCK, a lock of hair [n]\n",
  "HAIRNET": "a net worn to keep the hair in place [n -S]\n",
  "HAIRNETS": "HAIRNET, a net worn to keep the hair in place [n]\n",
  "HAIRPIECE": "an artificial extension to the hair [n -S]\n",
  "HAIRPIECES": "HAIRPIECE, an artificial extension to the hair [n]\n",
  "HAIRPIN": "a hair fastener [n -S]\n",
  "HAIRPINS": "HAIRPIN, a hair fastener [n]\n",
  "HAIRS": "HAIR, to free from hair [v]\n",
  "HAIRSBREADTH": "the breadth of a hair; a minute distance, also HAIRBREADTH [n -S]\n",
  "HAIRSBREADTHS": "HAIRSBREADTH, the breadth of a hair; a minute distance, also HAIRBREADTH [n]\n",
  "HAIRSPLITTER": "one that makes excessively fine distinctions in reasoning [n -S]\n",
  "HAIRSPLITTERS": "HAIRSPLITTER, one that makes excessively fine distinctions in reasoning [n]\n",
  "HAIRSPLITTING": "the making of trifling distinctions [n -S]\n",
  "HAIRSPLITTINGS": "HAIRSPLITTING, the making of trifling distinctions [n]\n",
  "HAIRSPRAY": "lacquer sprayed on the hair to hold it in place [n -S]\n",
  "HAIRSPRAYS": "HAIRSPRAY, lacquer sprayed on the hair to hold it in place [n]\n",
  "HAIRSPRING": "the slender recoil spring which regulates the motion of the balance in a timepiece [n -S]\n",
  "HAIRSPRINGS": "HAIRSPRING, the slender recoil spring which regulates the motion of the balance in a timepiece [n]\n",
  "HAIRST": "(Scots) to gather in a crop, also HARVEST [v -ED, -ING, -S]\n",
  "HAIRSTED": "HAIRST, (Scots) to gather in a crop, also HARVEST [v]\n",
  "HAIRSTING": "HAIRST, (Scots) to gather in a crop, also HARVEST [v]\n",
  "HAIRSTREAK": "a butterfly of the genus Thecla [n -S]\n",
  "HAIRSTREAKS": "HAIRSTREAK, a butterfly of the genus Thecla [n]\n",
  "HAIRSTS": "HAIRST, (Scots) to gather in a crop, also HARVEST [v]\n",
  "HAIRSTYLE": "a particular way of cutting and arranging the hair [n -S]\n",
  "HAIRSTYLES": "HAIRSTYLE, a particular way of cutting and arranging the hair [n]\n",
  "HAIRSTYLING": "a styling of the hair [n -S]\n",
  "HAIRSTYLINGS": "HAIRSTYLING, a styling of the hair [n]\n",
  "HAIRSTYLIST": "a hairdresser [n -S]\n",
  "HAIRSTYLISTS": "HAIRSTYLIST, a hairdresser [n]\n",
  "HAIRTAIL": "any of various marine fish with long whiplike scaleless bodies [n -S]\n",
  "HAIRTAILS": "HAIRTAIL, any of various marine fish with long whiplike scaleless bodies [n]\n",
  "HAIRWEAVING": "the interweaving of false hair with real on a bald person's head [n -S]\n",
  "HAIRWEAVINGS": "HAIRWEAVING, the interweaving of false hair with real on a bald person's head [n]\n",
  "HAIRWING": "a fishing lure tied with hair [n -S]\n",
  "HAIRWINGS": "HAIRWING, a fishing lure tied with hair [n]\n",
  "HAIRWORK": "the making of articles from hair [n -S]\n",
  "HAIRWORKS": "HAIRWORK, the making of articles from hair [n]\n",
  "HAIRWORM": "a kind of parasitic worm [n -S]\n",
  "HAIRWORMS": "HAIRWORM, a kind of parasitic worm [n]\n",
  "HAIRY": "covered with hair [adj HAIRIER, HAIRIEST, HAIRILY]\n",
  "HAIRYBACK": "(offensive South African) an Afrikaaner [n -S]\n",
  "HAIRYBACKS": "HAIRYBACK, (offensive South African) an Afrikaaner [n]\n",
  "HAITH": "(Scots) an interjection meaning by my faith! [interj]\n",
  "HAJ": "a pilgrimage to Mecca, also HADJ, HAJJ [n -ES]\n",
  "HAJES": "HAJ, a pilgrimage to Mecca, also HADJ, HAJJ [n]\n",
  "HAJI": "(Arabic) a person who has made a hadj, a pilgrimage to Mecca, also HADJI, HADJEE, HAJJI [n -S]\n",
  "HAJIS": "HAJI, (Arabic) a person who has made a hadj, a pilgrimage to Mecca, also HADJI, HADJEE, HAJJI [n]\n",
  "HAJJ": "(Arabic) a pilgrimage to Mecca, also HADJ, HAJ [n -ES]\n",
  "HAJJAH": "(Arabic) a Muslim woman who has made a pilgrimage to Mecca [n -S]\n",
  "HAJJAHS": "HAJJAH, (Arabic) a Muslim woman who has made a pilgrimage to Mecca [n]\n",
  "HAJJES": "HAJJ, (Arabic) a pilgrimage to Mecca, also HADJ, HAJ [n]\n",
  "HAJJI": "(Arabic) a person who has made a hadj, a pilgrimage to Mecca, also HADJI, HADJEE, HAJI [n -S]\n",
  "HAJJIS": "HAJJI, (Arabic) a person who has made a hadj, a pilgrimage to Mecca, also HADJI, HADJEE, HAJI [n]\n",
  "HAKA": "(Maori) a ceremonial war-dance [n -S]\n",
  "HAKAM": "(Hebrew) a sage, a rabbinical commentator [n -S]\n",
  "HAKAMS": "HAKAM, (Hebrew) a sage, a rabbinical commentator [n]\n",
  "HAKARI": "(Maori) a ritual feast [n -S]\n",
  "HAKARIS": "HAKARI, (Maori) a ritual feast [n]\n",
  "HAKAS": "HAKA, (Maori) a ceremonial war-dance [n]\n",
  "HAKE": "a fish of the cod family [n -S]\n",
  "HAKEA": "an Australian shrub [n -S]\n",
  "HAKEAS": "HAKEA, an Australian shrub [n]\n",
  "HAKEEM": "(Arabic) a Muslim physician, also HAKIM [n -S]\n",
  "HAKEEMS": "HAKEEM, (Arabic) a Muslim physician, also HAKIM [n]\n",
  "HAKES": "HAKE, a fish of the cod family [n]\n",
  "HAKIM": "(Arabic) a Muslim physician, also HAKEEM [n -S]\n",
  "HAKIMS": "HAKIM, (Arabic) a Muslim physician, also HAKEEM [n]\n",
  "HAKU": "(Maori) the kingfish [n -S]\n",
  "HAKUS": "HAKU, (Maori) the kingfish [n]\n",
  "HALACHA": "(Hebrew) the legal part of the Talmud, also HALAKAH, HALAKHA, HALAKHAH [n HALACHAS or HALACHOT or HALACHOTH]\n",
  "HALACHAS": "HALACHA, (Hebrew) the legal part of the Talmud, also HALAKAH, HALAKHA, HALAKHAH [n]\n",
  "HALACHIC": "(Hebrew) relating to halacha, the legal component of the Jewish oral tradition, also HALAKHIC, HALAKIC [adj]\n",
  "HALACHIST": "a practitioner of Jewish religious law, also HALAKHIST [n -S]\n",
  "HALACHISTS": "HALACHIST, a practitioner of Jewish religious law, also HALAKHIST [n]\n",
  "HALACHOT": "HALACHA, (Hebrew) the legal part of the Talmud, also HALAKAH, HALAKHA, HALAKHAH [n]\n",
  "HALACHOTH": "HALACHA, (Hebrew) the legal part of the Talmud, also HALAKAH, HALAKHA, HALAKHAH [n]\n",
  "HALAKAH": "(Hebrew) the legal part of the Talmud, also HALACHA, HALAKHA, HALAKHAH [n HALAKAHS or HALAKOTH]\n",
  "HALAKAHS": "HALAKAH, (Hebrew) the legal part of the Talmud, also HALACHA, HALAKHA, HALAKHAH [n]\n",
  "HALAKHA": "(Hebrew) the legal part of the Talmud, also HALACHA, HALAKAH, HALAKHAH [n HALAKHAS or HALAKHOT]\n",
  "HALAKHAH": "(Hebrew) the legal part of the Talmud, also HALACHA, HALAKAH, HALAKHA [n HALAKHAHS or HALAKHOT]\n",
  "HALAKHAHS": "HALAKHAH, (Hebrew) the legal part of the Talmud, also HALACHA, HALAKAH, HALAKHA [n]\n",
  "HALAKHAS": "HALAKHA, (Hebrew) the legal part of the Talmud, also HALACHA, HALAKAH, HALAKHAH [n]\n",
  "HALAKHIC": "(Hebrew) pertaining to the halakha, the legal component of the Jewish oral tradition, also HALACHIC, HALAKIC [adj]\n",
  "HALAKHIST": "a practitioner of Jewish religious law, also HALACHIST [n -S]\n",
  "HALAKHISTS": "HALAKHIST, a practitioner of Jewish religious law, also HALACHIST [n]\n",
  "HALAKHOT": "HALAKHA, (Hebrew) the legal part of the Talmud, also HALACHA, HALAKAH, HALAKHAH [n]\n",
  "HALAKHOTH": "HALAKHAH, (Hebrew) the legal part of the Talmud, also HALACHA, HALAKAH, HALAKHA [n]\n",
  "HALAKIC": "(Hebrew) pertaining to the halakah, also HALACHIC, HALAKHIC [adj]\n",
  "HALAKIST": "(Hebrew) a halakic writer [n -S]\n",
  "HALAKISTS": "HALAKIST, (Hebrew) a halakic writer [n]\n",
  "HALAKOTH": "HALAKAH, (Hebrew) the legal part of the Talmud, also HALACHA, HALAKHA, HALAKHAH [n]\n",
  "HALAL": "(Arabic) to slaughter according to Muslim law, also HALLAL [v HALALLED, HALALLING, HALALS]\n",
  "HALALA": "(Arabic) a Saudi Arabian coin, also HALALAH [n -S]\n",
  "HALALAH": "(Arabic) a Saudi Arabian coin, also HALALA [n -S]\n",
  "HALALAHS": "HALALAH, (Arabic) a Saudi Arabian coin, also HALALA [n]\n",
  "HALALAS": "HALALA, (Arabic) a Saudi Arabian coin, also HALALAH [n]\n",
  "HALALLED": "HALAL, (Arabic) to slaughter according to Muslim law, also HALLAL [v]\n",
  "HALALLING": "HALAL, (Arabic) to slaughter according to Muslim law, also HALLAL [v]\n",
  "HALALS": "HALAL, (Arabic) to slaughter according to Muslim law, also HALLAL [v]\n",
  "HALATION": "a blurring of light in photographs [n -S]\n",
  "HALATIONS": "HALATION, a blurring of light in photographs [n]\n",
  "HALAVAH": "(Yiddish) a sweetmeat, originally Turkish, containing sesame seeds, honey, nuts and saffron, also HALVA, HALVAH [n -S]\n",
  "HALAVAHS": "HALAVAH, (Yiddish) a sweetmeat, originally Turkish, containing sesame seeds, honey, nuts and saffron, also HALVA, HALVAH [n]\n",
  "HALAZONE": "a disinfectant for drinking water [n -S]\n",
  "HALAZONES": "HALAZONE, a disinfectant for drinking water [n]\n",
  "HALBERD": "an ancient axelike weapon, also HALBERT [n -S]\n",
  "HALBERDIER": "one who is armed with a halberd [n -S]\n",
  "HALBERDIERS": "HALBERDIER, one who is armed with a halberd [n]\n",
  "HALBERDS": "HALBERD, an ancient axelike weapon, also HALBERT [n]\n",
  "HALBERT": "an ancient axelike weapon, also HALBERD [n -S]\n",
  "HALBERTS": "HALBERT, an ancient axelike weapon, also HALBERD [n]\n",
  "HALCYON": "a mythical bird that calmed the sea on the winter solstice [n -S]\n",
  "HALCYONIAN": "peaceful and happy, also HALCYONIC [adj]\n",
  "HALCYONIC": "peaceful and happy, also HALCYONIAN [adj]\n",
  "HALCYONS": "HALCYON, a mythical bird that calmed the sea on the winter solstice [n]\n",
  "HALE": "to compel to go [v HALED, HALING, HALES] / healthy [adj HALER, HALEST]\n",
  "HALED": "HALE, to compel to go [v]\n",
  "HALENESS": "the state of being hale [n -ES]\n",
  "HALENESSES": "HALENESS, the state of being hale [n]\n",
  "HALER": "(Czech) a monetary unit of the Czech republic, also HELLER [n HALERS or HALERU]\n",
  "HALERS": "HALER, (Czech) a monetary unit of the Czech republic, also HELLER [n]\n",
  "HALERU": "HALER, (Czech) a monetary unit of the Czech republic, also HELLER [n]\n",
  "HALES": "HALE, to compel to go [v]\n",
  "HALEST": "HALE, healthy [adj]\n",
  "HALF": "one of two equal parts [n HALVES] / a measure of whiskey [n HALFS]\n",
  "HALFA": "(Arabic) a North African esparto grass, also ALFA [n -S]\n",
  "HALFAS": "HALFA, (Arabic) a North African esparto grass, also ALFA [n]\n",
  "HALFBACK": "a position in football [n -S]\n",
  "HALFBACKS": "HALFBACK, a position in football [n]\n",
  "HALFBEAK": "a fish with a spearlike underjaw [n -S]\n",
  "HALFBEAKS": "HALFBEAK, a fish with a spearlike underjaw [n]\n",
  "HALFEN": "(Spenser) half [adj]\n",
  "HALFENDEALE": "(Spenser) half [n -S]\n",
  "HALFENDEALES": "HALFENDEALE, (Spenser) half [n]\n",
  "HALFHEARTED": "lacking heart, spirit, or interest [adj HALFHEARTEDLY]\n",
  "HALFHEARTEDLY": "HALFHEARTED, lacking heart, spirit, or interest [adv]\n",
  "HALFHEARTEDNESS": "HALFHEARTED, lacking heart, spirit, or interest [n]\n",
  "HALFLIFE": "the time taken for half a sample of radioactive material to decay [n HALFLIVES]\n",
  "HALFLIN": "a half-grown person, also HALFLING, HAFFLIN [n -S]\n",
  "HALFLING": "a half-grown person, also HAFFLIN, HALFLIN [n -S]\n",
  "HALFLINGS": "HALFLING, a half-grown person, also HAFFLIN, HALFLIN [n]\n",
  "HALFLINS": "HALFLIN, a half-grown person, also HALFLING, HAFFLIN [n]\n",
  "HALFLIVES": "HALFLIFE, the time taken for half a sample of radioactive material to decay [n]\n",
  "HALFNESS": "the state of being half [n -ES]\n",
  "HALFNESSES": "HALFNESS, the state of being half [n]\n",
  "HALFPACE": "a dais; a small landing on staircase [n -S]\n",
  "HALFPACES": "HALFPACE, a dais; a small landing on staircase [n]\n",
  "HALFPENCE": "HALFPENNY, a coin worth half a pre-decimal penny [n]\n",
  "HALFPENNIES": "HALFPENNY, a coin worth half a pre-decimal penny [n]\n",
  "HALFPENNY": "a coin worth half a pre-decimal penny [n HALFPENCE or HALFPENNIES]\n",
  "HALFPENNYWORTH": "as much as is sold for a halfpenny or is worth a halfpenny [n -S]\n",
  "HALFPENNYWORTHS": "HALFPENNYWORTH, as much as is sold for a halfpenny or is worth a halfpenny [n]\n",
  "HALFPIPE": "a U-shaped course used for skateboarding [n -S]\n",
  "HALFPIPES": "HALFPIPE, a U-shaped course used for skateboarding [n]\n",
  "HALFS": "plural of half in the sense of a measure of drink [n]\n",
  "HALFSERIOUSLY": "in a partially joking way [adv]\n",
  "HALFTIME": "an intermission at a football game [n -S]\n",
  "HALFTIMES": "HALFTIME, an intermission at a football game [n]\n",
  "HALFTONE": "a shade between light and dark [n -S]\n",
  "HALFTONES": "HALFTONE, a shade between light and dark [n]\n",
  "HALFTRACK": "a vehicle with caterpillar tracks and wheels [n -S]\n",
  "HALFTRACKS": "HALFTRACK, a vehicle with caterpillar tracks and wheels [n]\n",
  "HALFWAY": "being in the middle [adj]\n",
  "HALFWIT": "an idiot [n -S]\n",
  "HALFWITS": "HALFWIT, an idiot [n]\n",
  "HALFWITTED": "feebleminded [adj HALFWITTEDLY]\n",
  "HALFWITTEDLY": "HALFWITTED, feebleminded [adv]\n",
  "HALFWITTEDNESS": "HALFWITTED, feebleminded [n]\n",
  "HALIBUT": "a kind of large flatfish, also HOLIBUT [n -S]\n",
  "HALIBUTS": "HALIBUT, a kind of large flatfish, also HOLIBUT [n]\n",
  "HALICORE": "(Greek) the dugong, a manatee or sea-cow [n -S]\n",
  "HALICORES": "HALICORE, (Greek) the dugong, a manatee or sea-cow [n]\n",
  "HALID": "a compound of a halogen with a metal or radical, also HALIDE, HALOID [n -S]\n",
  "HALIDE": "a compound of a halogen with a metal or radical, also HALID, HALOID [n -S]\n",
  "HALIDES": "HALIDE, a compound of a halogen with a metal or radical, also HALID, HALOID [n]\n",
  "HALIDOM": "(archaic) holiness, a holy place, esp. in an oath, also HALIDOME, HOLLIDAM, HOLYDAM, HOLYDAME [n -S]\n",
  "HALIDOME": "(archaic) holiness, a holy place, esp. in an oath, also HALIDOM, HOLLIDAM, HOLYDAM, HOLYDAME [n -S]\n",
  "HALIDOMES": "HALIDOME, (archaic) holiness, a holy place, esp. in an oath, also HALIDOM, HOLLIDAM, HOLYDAM, HOLYDAME [n]\n",
  "HALIDOMS": "HALIDOM, (archaic) holiness, a holy place, esp. in an oath, also HALIDOME, HOLLIDAM, HOLYDAM, HOLYDAME [n]\n",
  "HALIDS": "HALID, a compound of a halogen with a metal or radical, also HALIDE, HALOID [n]\n",
  "HALIER": "a former monetary unit of Slovakia [n HALIERS or HALIEROV]\n",
  "HALIEROV": "HALIER, a former monetary unit of Slovakia [n]\n",
  "HALIERS": "HALIER, a former monetary unit of Slovakia [n]\n",
  "HALIEUTIC": "pertaining to fishing [adj]\n",
  "HALIEUTICS": "the art or practice of fishing [n]\n",
  "HALIMOT": "an erroneous form of hall-moot, the court of a lord of the manor or of a guild, also HALIMOTE [n -S]\n",
  "HALIMOTE": "an erroneous form of hall-moot, the court of a lord of the manor or of a guild, also HALIMOT [n -S]\n",
  "HALIMOTES": "HALIMOTE, an erroneous form of hall-moot, the court of a lord of the manor or of a guild, also HALIMOT [n]\n",
  "HALIMOTS": "HALIMOT, an erroneous form of hall-moot, the court of a lord of the manor or of a guild, also HALIMOTE [n]\n",
  "HALING": "HALE, to compel to go [v]\n",
  "HALIOTIS": "(Greek) a genus of molluscs [n HALIOTIS]\n",
  "HALIPLANKTON": "plankton living in sea water [n -S]\n",
  "HALIPLANKTONS": "HALIPLANKTON, plankton living in sea water [n]\n",
  "HALITE": "a native salt; sodium chloride [n -S]\n",
  "HALITES": "HALITE, a native salt; sodium chloride [n]\n",
  "HALITOSES": "HALITOSIS, bad breath [n]\n",
  "HALITOSIS": "bad breath [n HALITOSES]\n",
  "HALITOTIC": "relating to halitosis, bad breath [adj]\n",
  "HALITOUS": "vaporous [adj]\n",
  "HALITUS": "(Latin) an exhalation [n -ES]\n",
  "HALITUSES": "HALITUS, (Latin) an exhalation [n]\n",
  "HALL": "a large room for assembly [n -S]\n",
  "HALLAH": "(Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, CHALLAH [n HALLAHS, HALLOT or HALLOTH]\n",
  "HALLAHS": "HALLAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, CHALLAH [n]\n",
  "HALLAL": "(Arabic) to slaughter according to Muslim law, also HALAL [v HALLALLED, HALLALLING, HALLALS]\n",
  "HALLALI": "a bugle-call [n -S]\n",
  "HALLALIS": "HALLALI, a bugle-call [n]\n",
  "HALLALLED": "HALLAL, (Arabic) to slaughter according to Muslim law, also HALAL [v]\n",
  "HALLALLING": "HALLAL, (Arabic) to slaughter according to Muslim law, also HALAL [v]\n",
  "HALLALOO": "a hunting cry [n -S]\n",
  "HALLALOOS": "HALLALOO, a hunting cry [n]\n",
  "HALLALS": "HALLAL, (Arabic) to slaughter according to Muslim law, also HALAL [v]\n",
  "HALLAN": "(Scots) a partition or screen between the door and a fireplace in a cottage [n -S]\n",
  "HALLANS": "HALLAN, (Scots) a partition or screen between the door and a fireplace in a cottage [n]\n",
  "HALLEFLINTA": "(Swedish) a dense rock containing quartz and feldspar [n -S]\n",
  "HALLEFLINTAS": "HALLEFLINTA, (Swedish) a dense rock containing quartz and feldspar [n]\n",
  "HALLEL": "(Hebrew) a holiday prayer of thanksgiving Psalms [n -S]\n",
  "HALLELS": "HALLEL, (Hebrew) a holiday prayer of thanksgiving Psalms [n]\n",
  "HALLELUIAH": "(Hebrew) a song of praise to God, also ALLELUIA, ALLELUIAH, HALLELUJAH [n -S]\n",
  "HALLELUIAHS": "HALLELUIAH, (Hebrew) a song of praise to God, also ALLELUIA, ALLELUIAH, HALLELUJAH [n]\n",
  "HALLELUJAH": "(Hebrew) a song of praise to God, also ALLELUIA, ALLELUIAH, HALLELUIAH [n -S]\n",
  "HALLELUJAHS": "HALLELUJAH, (Hebrew) a song of praise to God, also ALLELUIA, ALLELUIAH, HALLELUIAH [n]\n",
  "HALLIAN": "(Scots) a lout or lazy rascal, also HALLION, HALLYON [n -S]\n",
  "HALLIANS": "HALLIAN, (Scots) a lout or lazy rascal, also HALLION, HALLYON [n]\n",
  "HALLIARD": "a line used to hoist a sail, also HALYARD, HAULYARD [n -S]\n",
  "HALLIARDS": "HALLIARD, a line used to hoist a sail, also HALYARD, HAULYARD [n]\n",
  "HALLING": "(Norwegian) a Norwegian country dance [n -S]\n",
  "HALLINGS": "HALLING, (Norwegian) a Norwegian country dance [n]\n",
  "HALLION": "(Scots) a lout or lazy rascal, also HALLIAN, HALLYON [n -S]\n",
  "HALLIONS": "HALLION, (Scots) a lout or lazy rascal, also HALLIAN, HALLYON [n]\n",
  "HALLMARK": "to mark with an official stamp [v -ED, -ING, -S]\n",
  "HALLMARKED": "HALLMARK, to mark with an official stamp [v]\n",
  "HALLMARKING": "HALLMARK, to mark with an official stamp [v]\n",
  "HALLMARKS": "HALLMARK, to mark with an official stamp [v]\n",
  "HALLO": "to shout out a greeting, also HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S or -ES]\n",
  "HALLOA": "to shout out a greeting, also HALLO, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S]\n",
  "HALLOAED": "HALLOA, to shout out a greeting, also HALLO, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOAING": "HALLOA, to shout out a greeting, also HALLO, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOAS": "HALLOA, to shout out a greeting, also HALLO, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOED": "HALLO, to shout out a greeting, also HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOES": "HALLO, to shout out a greeting, also HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOING": "HALLO, to shout out a greeting, also HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOO": "to shout out a greeting, also HALLO, HALLOA, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S]\n",
  "HALLOOED": "HALLOO, to shout out a greeting, also HALLO, HALLOA, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOOING": "HALLOO, to shout out a greeting, also HALLO, HALLOA, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOOS": "HALLOO, to shout out a greeting, also HALLO, HALLOA, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOS": "HALLO, to shout out a greeting, also HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HALLOT": "HALLAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, CHALLAH [n]\n",
  "HALLOTH": "HALLAH, (Hebrew) a loaf of white leavened bread, often plaited in form, traditionally baked to celebrate the Jewish Sabbath, also CHALAH, CHALEH, CHALLA, CHALLAH [n]\n",
  "HALLOUMI": "(Modern Greek) a Greek dish of goat's cheese, also HALOUMI [n -S]\n",
  "HALLOUMIS": "HALLOUMI, (Modern Greek) a Greek dish of goat's cheese, also HALOUMI [n]\n",
  "HALLOW": "to make holy [v -ED, -ING, -S]\n",
  "HALLOWED": "HALLOW, to make holy [v]\n",
  "HALLOWEDNESS": "the state of being hallowed [n -ES]\n",
  "HALLOWEDNESSES": "HALLOWEDNESS, the state of being hallowed [n]\n",
  "HALLOWER": "one who hallows [n -S]\n",
  "HALLOWERS": "HALLOWER, one who hallows [n]\n",
  "HALLOWING": "HALLOW, to make holy [v]\n",
  "HALLOWS": "HALLOW, to make holy [v]\n",
  "HALLOYSITE": "a claylike mineral, a hydrated aluminium silicate [n -S]\n",
  "HALLOYSITES": "HALLOYSITE, a claylike mineral, a hydrated aluminium silicate [n]\n",
  "HALLS": "HALL, a large room for assembly [n]\n",
  "HALLSTAND": "a stand in a hall for umbrellas etc. [n -S]\n",
  "HALLSTANDS": "HALLSTAND, a stand in a hall for umbrellas etc. [n]\n",
  "HALLUCAL": "relating to the hallux, the big toe [adj]\n",
  "HALLUCES": "HALLUX, (Latin) the big toe; the hind toe of birds [n]\n",
  "HALLUCINANT": "a person who experiences hallucinations; a drug that causes a person to experience hallucinations [n -S]\n",
  "HALLUCINANTS": "HALLUCINANT, a person who experiences hallucinations; a drug that causes a person to experience hallucinations [n]\n",
  "HALLUCINATE": "to affect with visions or imaginary perceptions [v HALLUCINATED, HALLUCINATING, HALLUCINATES]\n",
  "HALLUCINATED": "HALLUCINATE, to affect with visions or imaginary perceptions [v]\n",
  "HALLUCINATES": "HALLUCINATE, to affect with visions or imaginary perceptions [v]\n",
  "HALLUCINATING": "HALLUCINATE, to affect with visions or imaginary perceptions [v]\n",
  "HALLUCINATION": "perception of objects with no reality usually arising from disorder of the nervous system or in response to drugs [n -S]\n",
  "HALLUCINATIONAL": "of the nature of a hallucination [adj]\n",
  "HALLUCINATIONS": "HALLUCINATION, perception of objects with no reality usually arising from disorder of the nervous system or in response to drugs [n]\n",
  "HALLUCINATIVE": "tending to produce hallucination, also HALLUCINATORY [adj]\n",
  "HALLUCINATOR": "one who hallucinates [n -S]\n",
  "HALLUCINATORS": "HALLUCINATOR, one who hallucinates [n]\n",
  "HALLUCINATORY": "tending to produce hallucination, also HALLUCINATIVE [adj]\n",
  "HALLUCINOGEN": "a substance that induces hallucinations, also HALLUCINOGENIC [n -S]\n",
  "HALLUCINOGENIC": "a substance that induces hallucinations, also HALLUCINOGEN [n -S]\n",
  "HALLUCINOGENICS": "HALLUCINOGENIC, a substance that induces hallucinations, also HALLUCINOGEN [n]\n",
  "HALLUCINOGENS": "HALLUCINOGEN, a substance that induces hallucinations, also HALLUCINOGENIC [n]\n",
  "HALLUCINOSES": "HALLUCINOSIS, a pathological mental state characterized by hallucinations [n]\n",
  "HALLUCINOSIS": "a pathological mental state characterized by hallucinations [n HALLUCINOSES]\n",
  "HALLUX": "(Latin) the big toe; the hind toe of birds [n HALLUCES]\n",
  "HALLWAY": "a hall or corridor [n -S]\n",
  "HALLWAYS": "HALLWAY, a hall or corridor [n]\n",
  "HALLYON": "(Scots) a lout or lazy rascal, also HALLIAN, HALLION [n -S]\n",
  "HALLYONS": "HALLYON, (Scots) a lout or lazy rascal, also HALLIAN, HALLION [n]\n",
  "HALM": "a plant stem, also HAULM [n -S]\n",
  "HALMA": "(Greek) a board game played with pegs [n -S]\n",
  "HALMAS": "HALMA, (Greek) a board game played with pegs [n]\n",
  "HALMS": "HALM, a plant stem, also HAULM [n]\n",
  "HALO": "to form a ring of light [v HALOED, HALOING, HALOES or HALOS]\n",
  "HALOBIONT": "an organism living in a salt environment [n -S]\n",
  "HALOBIONTIC": "living in the sea, also HALOBIOTIC [adj]\n",
  "HALOBIONTS": "HALOBIONT, an organism living in a salt environment [n]\n",
  "HALOBIOTIC": "living in the sea, also HALOBIONTIC [adj]\n",
  "HALOCARBON": "a compound consisting of carbon and one or more halogens [n -S]\n",
  "HALOCARBONS": "HALOCARBON, a compound consisting of carbon and one or more halogens [n]\n",
  "HALOCLINE": "a vertical gradient in ocean salinity [n -S]\n",
  "HALOCLINES": "HALOCLINE, a vertical gradient in ocean salinity [n]\n",
  "HALOED": "HALO, to form a ring of light [v]\n",
  "HALOES": "HALO, to form a ring of light [v]\n",
  "HALOGEN": "any of the group of elements fluorine, chlorine, bromine, iodine, and astatine [n -S]\n",
  "HALOGENATE": "to combine with a halogen [v HALOGENATED, HALOGENATING, HALOGENATES]\n",
  "HALOGENATED": "HALOGENATE, to combine with a halogen [v]\n",
  "HALOGENATES": "HALOGENATE, to combine with a halogen [v]\n",
  "HALOGENATING": "HALOGENATE, to combine with a halogen [v]\n",
  "HALOGENATION": "the act of halogenating [n -S]\n",
  "HALOGENATIONS": "HALOGENATION, the act of halogenating [n]\n",
  "HALOGENIC": "pertaining to halogens, a group of elements including chlorine, fluorine etc [adj]\n",
  "HALOGENOID": "like a halogen [adj]\n",
  "HALOGENOUS": "of the nature of a halogen [adj]\n",
  "HALOGENS": "HALOGEN, any of the group of elements fluorine, chlorine, bromine, iodine, and astatine [n]\n",
  "HALOGETON": "a coarse annual herb of the goosefoot family [n -S]\n",
  "HALOGETONS": "HALOGETON, a coarse annual herb of the goosefoot family [n]\n",
  "HALOID": "a compound of a halogen with a metal or radical, also HALID, HALIDE [n -S]\n",
  "HALOIDS": "HALOID, a compound of a halogen with a metal or radical, also HALID, HALIDE [n]\n",
  "HALOING": "HALO, to form a ring of light [v]\n",
  "HALOLIKE": "resembling a halo [adj]\n",
  "HALOMORPHIC": "developed in the presence of neutral or alkali salts or both [adj]\n",
  "HALON": "any one of a class of halogenated hydrocarbons, used esp. in fire extinguishers [n -S]\n",
  "HALONS": "HALON, any one of a class of halogenated hydrocarbons, used esp. in fire extinguishers [n]\n",
  "HALOPERIDOL": "a synthetic tranquillizing drug used in treating psychiatric illnesses [n -S]\n",
  "HALOPERIDOLS": "HALOPERIDOL, a synthetic tranquillizing drug used in treating psychiatric illnesses [n]\n",
  "HALOPHILE": "a plant that is adapted to survive in salty soil [n -S]\n",
  "HALOPHILES": "HALOPHILE, a plant that is adapted to survive in salty soil [n]\n",
  "HALOPHILIC": "salt-loving [adj]\n",
  "HALOPHILIES": "HALOPHILY, being adapted to salt conditions [n]\n",
  "HALOPHILOUS": "tolerant of salt or saltwater [adj]\n",
  "HALOPHILY": "being adapted to salt conditions [n HALOPHILIES]\n",
  "HALOPHOBE": "a plant that cannot survive in salty soil [n -S]\n",
  "HALOPHOBES": "HALOPHOBE, a plant that cannot survive in salty soil [n]\n",
  "HALOPHYTE": "a plant found growing in salt marshes, or in the sea [n -S]\n",
  "HALOPHYTES": "HALOPHYTE, a plant found growing in salt marshes, or in the sea [n]\n",
  "HALOPHYTIC": "growing in a salty environment [adj]\n",
  "HALOPHYTISM": "the state of being a halophyte [n -S]\n",
  "HALOPHYTISMS": "HALOPHYTISM, the state of being a halophyte [n]\n",
  "HALOS": "HALO, to form a ring of light [v]\n",
  "HALOSERE": "a plant community that develops in highly saline conditions [n -S]\n",
  "HALOSERES": "HALOSERE, a plant community that develops in highly saline conditions [n]\n",
  "HALOTHANE": "an inhalation anaesthetic [n -S]\n",
  "HALOTHANES": "HALOTHANE, an inhalation anaesthetic [n]\n",
  "HALOUMI": "(Modern Greek) a Greek dish of goat's cheese, also HALLOUMI [n -S]\n",
  "HALOUMIS": "HALOUMI, (Modern Greek) a Greek dish of goat's cheese, also HALLOUMI [n]\n",
  "HALSE": "(Spenser) to embrace, also HAUSE, HAWSE [v HALSED or (Spenser) HAULST, HALSING, HALSES]\n",
  "HALSED": "HALSE, (Spenser) to embrace, also HAUSE, HAWSE [v]\n",
  "HALSER": "a large rope for mooring or towing a ship, also HAWSER [n -S]\n",
  "HALSERS": "HALSER, a large rope for mooring or towing a ship, also HAWSER [n]\n",
  "HALSES": "HALSE, (Spenser) to embrace, also HAUSE, HAWSE [v]\n",
  "HALSING": "HALSE, (Spenser) to embrace, also HAUSE, HAWSE [v]\n",
  "HALT": "to stop [v -ED, -ING, -S]\n",
  "HALTED": "HALT, to stop [v]\n",
  "HALTER": "to put restraint upon [v -ED, -ING, -S]\n",
  "HALTERBREAK": "to break (as a colt) to a halter [v HALTERBROKE, HALTERBROKEN, HALTERBREAKING, HALTERBREAKS]\n",
  "HALTERBREAKING": "HALTERBREAK, to break (as a colt) to a halter [v]\n",
  "HALTERBREAKS": "HALTERBREAK, to break (as a colt) to a halter [v]\n",
  "HALTERBROKE": "HALTERBREAK, to break (as a colt) to a halter [v]\n",
  "HALTERBROKEN": "HALTERBREAK, to break (as a colt) to a halter [v]\n",
  "HALTERE": "(Greek) the rudimentary hindwing of a fly [n -S]\n",
  "HALTERED": "HALTER, to put restraint upon [v]\n",
  "HALTERES": "HALTERE, (Greek) the rudimentary hindwing of a fly [n]\n",
  "HALTERING": "HALTER, to put restraint upon [v]\n",
  "HALTERNECK": "a type of women's clothing with one strap around the back of the neck instead of two over the shoulder [n -S]\n",
  "HALTERNECKS": "HALTERNECK, a type of women's clothing with one strap around the back of the neck instead of two over the shoulder [n]\n",
  "HALTERS": "HALTER, to put restraint upon [v]\n",
  "HALTING": "stopping [adj HALTINGLY] / a stopping, a limping [n -S]\n",
  "HALTINGLY": "HALTING, stopping [adv]\n",
  "HALTINGNESS": "the state of being halting [n -ES]\n",
  "HALTINGNESSES": "HALTINGNESS, the state of being halting [n]\n",
  "HALTINGS": "HALTING, a stopping, a limping [n]\n",
  "HALTLESS": "not hesitant [adj]\n",
  "HALTS": "HALT, to stop [v]\n",
  "HALUTZ": "(Hebrew) an early immigrant to Israel, who worked the first kibbutzim, also CHALUTZ [n HALUTZIM]\n",
  "HALUTZIM": "HALUTZ, (Hebrew) an early immigrant to Israel, who worked the first kibbutzim, also CHALUTZ [n]\n",
  "HALVA": "(Yiddish) a sweetmeat containing sesame seeds, honey, nuts and saffron, also HALAVAH, HALVAH [n -S]\n",
  "HALVAH": "(Yiddish) a Turkish confection, also HALVA, HALAVAH [n -S]\n",
  "HALVAHS": "HALVAH, (Yiddish) a Turkish confection, also HALVA, HALAVAH [n]\n",
  "HALVAS": "HALVA, (Yiddish) a sweetmeat containing sesame seeds, honey, nuts and saffron, also HALAVAH, HALVAH [n]\n",
  "HALVE": "to divide into two equal parts [v HALVED, HALVING, HALVES]\n",
  "HALVED": "HALVE, to divide into two equal parts [v]\n",
  "HALVER": "(Scots) a half-share [n -S]\n",
  "HALVERS": "HALVER, (Scots) a half-share [n]\n",
  "HALVES": "HALVE, to divide into two equal parts [v]\n",
  "HALVING": "the act of dividing into two [n -S]\n",
  "HALVINGS": "HALVING, the act of dividing into two [n]\n",
  "HALWA": "(Hindi) a sweet Indian dish [n -S]\n",
  "HALWAS": "HALWA, (Hindi) a sweet Indian dish [n]\n",
  "HALYARD": "a line used to hoist a sail, also HALLIARD, HAULYARD [n -S]\n",
  "HALYARDS": "HALYARD, a line used to hoist a sail, also HALLIARD, HAULYARD [n]\n",
  "HAM": "to overact, also HAMBONE [v HAMMED, HAMMING, HAMS]\n",
  "HAMADA": "(Arabic) a desert plateau of bedrock, also HAMMADA [n -S]\n",
  "HAMADAS": "HAMADA, (Arabic) a desert plateau of bedrock, also HAMMADA [n]\n",
  "HAMADRYAD": "(Greek) a wood nymph associated with one particular tree; a king cobra [n HAMADRYADES or HAMADRYADS]\n",
  "HAMADRYADES": "HAMADRYAD, (Greek) a wood nymph associated with one particular tree; a king cobra [n]\n",
  "HAMADRYADS": "HAMADRYAD, (Greek) a wood nymph associated with one particular tree; a king cobra [n]\n",
  "HAMADRYAS": "(Greek) a type of baboon [n -ES]\n",
  "HAMADRYASES": "HAMADRYAS, (Greek) a type of baboon [n]\n",
  "HAMAL": "(Arabic) a porter in eastern countries, also HAMAUL, HAMMAL [n -S]\n",
  "HAMALS": "HAMAL, (Arabic) a porter in eastern countries, also HAMAUL, HAMMAL [n]\n",
  "HAMAMELIDACEOUS": "belonging to the witch-hazel family [adj]\n",
  "HAMAMELIS": "a winter-flowering shrub [n -ES]\n",
  "HAMAMELISES": "HAMAMELIS, a winter-flowering shrub [n]\n",
  "HAMANTASCH": "(Yiddish) a three-cornered pastry traditionally eaten during the Jewish festival Purim [n HAMANTASCHEN]\n",
  "HAMANTASCHEN": "HAMANTASCH, (Yiddish) a three-cornered pastry traditionally eaten during the Jewish festival Purim [n]\n",
  "HAMARTHRITIS": "gout in all the joints [n -ES]\n",
  "HAMARTHRITISES": "HAMARTHRITIS, gout in all the joints [n]\n",
  "HAMARTIA": "(Greek) in tragedy, the character flaw that leads to downfall [n -S]\n",
  "HAMARTIAS": "HAMARTIA, (Greek) in tragedy, the character flaw that leads to downfall [n]\n",
  "HAMARTIOLOGIES": "HAMARTIOLOGY, a part of theology treating the doctrine of sin [n]\n",
  "HAMARTIOLOGY": "a part of theology treating the doctrine of sin [n HAMARTIOLOGIES]\n",
  "HAMATE": "the wrist bone [n -S]\n",
  "HAMATES": "HAMATE, the wrist bone [n]\n",
  "HAMATSA": "a dance inspired by the spirit of a man-eating monster [n -S]\n",
  "HAMATSAS": "HAMATSA, a dance inspired by the spirit of a man-eating monster [n]\n",
  "HAMAUL": "(Arabic) a porter in eastern countries, also HAMAL, HAMMAL [n -S]\n",
  "HAMAULS": "HAMAUL, (Arabic) a porter in eastern countries, also HAMAL, HAMMAL [n]\n",
  "HAMBA": "(South African) go away [interj]\n",
  "HAMBLE": "to mutilate a dog by cutting off the balls of its feet [v HAMBLED, HAMBLING, HAMBLES]\n",
  "HAMBLED": "HAMBLE, to mutilate a dog by cutting off the balls of its feet [v]\n",
  "HAMBLES": "HAMBLE, to mutilate a dog by cutting off the balls of its feet [v]\n",
  "HAMBLING": "HAMBLE, to mutilate a dog by cutting off the balls of its feet [v]\n",
  "HAMBONE": "to overact, also HAM [v HAMBONED, HAMBONING, HAMBONES]\n",
  "HAMBONED": "HAMBONE, to overact, also HAM [v]\n",
  "HAMBONES": "HAMBONE, to overact, also HAM [v]\n",
  "HAMBONING": "HAMBONE, to overact, also HAM [v]\n",
  "HAMBURG": "(German) a patty of ground beef, also HAMBURGER [n -S]\n",
  "HAMBURGER": "(German) a patty of ground beef, also HAMBURG [n -S]\n",
  "HAMBURGERS": "HAMBURGER, (German) a patty of ground beef, also HAMBURG [n]\n",
  "HAMBURGS": "HAMBURG, (German) a patty of ground beef, also HAMBURGER [n]\n",
  "HAME": "(Scots) to go home [v HAMED, HAMING, HAMES]\n",
  "HAMED": "HAME, (Scots) to go home [v]\n",
  "HAMES": "HAME, (Scots) to go home [v]\n",
  "HAMESUCKEN": "(Scots) the assaulting of a man in his own house [n -S]\n",
  "HAMESUCKENS": "HAMESUCKEN, (Scots) the assaulting of a man in his own house [n]\n",
  "HAMEWITH": "(Scots) homewards [adv]\n",
  "HAMFAT": "an amateurish performer [n -S]\n",
  "HAMFATS": "HAMFAT, an amateurish performer [n]\n",
  "HAMFATTER": "a third-rate minstrel or variety actor [n -S] / to perform as a third-rate minstrel [v -ED, -ING, -S]\n",
  "HAMFATTERED": "HAMFATTER, to perform as a third-rate minstrel [v]\n",
  "HAMFATTERING": "HAMFATTER, to perform as a third-rate minstrel [v]\n",
  "HAMFATTERS": "HAMFATTER, to perform as a third-rate minstrel [v]\n",
  "HAMING": "HAME, (Scots) to go home [v]\n",
  "HAMLET": "a small town [n -S]\n",
  "HAMLETS": "HAMLET, a small town [n]\n",
  "HAMMADA": "(Arabic) a desert plateau of bedrock, also HAMADA [n -S]\n",
  "HAMMADAS": "HAMMADA, (Arabic) a desert plateau of bedrock, also HAMADA [n]\n",
  "HAMMAL": "(Arabic) a porter in eastern countries, also HAMAL, HAMAUL [n -S]\n",
  "HAMMALS": "HAMMAL, (Arabic) a porter in eastern countries, also HAMAL, HAMAUL [n]\n",
  "HAMMAM": "(Arabic) a Turkish bath, also HUMMAUM, HUMMUM [n -S]\n",
  "HAMMAMS": "HAMMAM, (Arabic) a Turkish bath, also HUMMAUM, HUMMUM [n]\n",
  "HAMMED": "HAM, to overact, also HAMBONE [v]\n",
  "HAMMER": "to strike repeatedly [v -ED, -ING, -S]\n",
  "HAMMERCLOTH": "a cloth covering a coach box [n -S]\n",
  "HAMMERCLOTHS": "HAMMERCLOTH, a cloth covering a coach box [n]\n",
  "HAMMERED": "HAMMER, to strike repeatedly [v]\n",
  "HAMMERER": "one who hammers [n -S]\n",
  "HAMMERERS": "HAMMERER, one who hammers [n]\n",
  "HAMMERHEAD": "a type of shark [n -S]\n",
  "HAMMERHEADED": "having a hammer-shaped head [adj]\n",
  "HAMMERHEADS": "HAMMERHEAD, a type of shark [n]\n",
  "HAMMERING": "the act of striking with a hammer [n -S]\n",
  "HAMMERINGS": "HAMMERING, the act of striking with a hammer [n]\n",
  "HAMMERKOP": "(South African) a bird of the heron family [n -S]\n",
  "HAMMERKOPS": "HAMMERKOP, (South African) a bird of the heron family [n]\n",
  "HAMMERLESS": "without a hammer (e.g. of a gun) [adj]\n",
  "HAMMERLOCK": "a wrestling hold [n -S]\n",
  "HAMMERLOCKS": "HAMMERLOCK, a wrestling hold [n]\n",
  "HAMMERMAN": "a man who operates a hammer [n HAMMERMEN]\n",
  "HAMMERMEN": "HAMMERMAN, a man who operates a hammer [n]\n",
  "HAMMERS": "HAMMER, to strike repeatedly [v]\n",
  "HAMMERSTONE": "a stone used as a hammer in the production of tools during the Acheulian period [n -S]\n",
  "HAMMERSTONES": "HAMMERSTONE, a stone used as a hammer in the production of tools during the Acheulian period [n]\n",
  "HAMMERTOE": "a deformity of the toes [n -S]\n",
  "HAMMERTOES": "HAMMERTOE, a deformity of the toes [n]\n",
  "HAMMIER": "HAMMY, overacted [adj]\n",
  "HAMMIES": "HAMMY, a hamstring [n]\n",
  "HAMMIEST": "HAMMY, overacted [adj]\n",
  "HAMMILY": "HAMMY, overacted [adv]\n",
  "HAMMINESS": "the quality of being hammy, overacted [n -ES]\n",
  "HAMMINESSES": "HAMMINESS, the quality of being hammy, overacted [n]\n",
  "HAMMING": "HAM, to overact, also HAMBONE [v]\n",
  "HAMMOCK": "a hanging cot [n -S]\n",
  "HAMMOCKS": "HAMMOCK, a hanging cot [n]\n",
  "HAMMY": "overacted [adj HAMMIER, HAMMIEST, HAMMILY] / a hamstring [n HAMMIES]\n",
  "HAMOSE": "hooked, also HAMOUS [adj]\n",
  "HAMOUS": "hooked, also HAMOSE [adj]\n",
  "HAMPER": "to hinder, obstruct [v -ED, -ING, -S]\n",
  "HAMPERED": "HAMPER, to hinder, obstruct [v]\n",
  "HAMPEREDNESS": "the state of being hampered [n -ES]\n",
  "HAMPEREDNESSES": "HAMPEREDNESS, the state of being hampered [n]\n",
  "HAMPERER": "one who hampers [n -S]\n",
  "HAMPERERS": "HAMPERER, one who hampers [n]\n",
  "HAMPERING": "HAMPER, to hinder, obstruct [v]\n",
  "HAMPERS": "HAMPER, to hinder, obstruct [v]\n",
  "HAMPSTER": "a small rodent with large cheeks, also HAMSTER [n -S]\n",
  "HAMPSTERS": "HAMPSTER, a small rodent with large cheeks, also HAMSTER [n]\n",
  "HAMS": "HAM, to overact, also HAMBONE [v]\n",
  "HAMSHACKLE": "to fetter; to restrain [v HAMSHACKLED, HAMSHACKLING, HAMSHACKLES]\n",
  "HAMSHACKLED": "HAMSHACKLE, to fetter; to restrain [v]\n",
  "HAMSHACKLES": "HAMSHACKLE, to fetter; to restrain [v]\n",
  "HAMSHACKLING": "HAMSHACKLE, to fetter; to restrain [v]\n",
  "HAMSTER": "a small rodent with large cheeks, also HAMPSTER [n -S]\n",
  "HAMSTERS": "HAMSTER, a small rodent with large cheeks, also HAMPSTER [n]\n",
  "HAMSTRING": "a tendon at the back of the knee [n -S] / to disable by severing the hamstrings [v HAMSTRINGED or HAMSTRUNG, HAMSTRINGING, HAMSTRINGS]\n",
  "HAMSTRINGED": "HAMSTRING, to disable by severing the hamstrings [v]\n",
  "HAMSTRINGING": "HAMSTRING, to disable by severing the hamstrings [v]\n",
  "HAMSTRINGS": "HAMSTRING, to disable by severing the hamstrings [v]\n",
  "HAMSTRUNG": "HAMSTRING, to disable by severing the hamstrings [v]\n",
  "HAMULAR": "relating to a small hook, also HAMULATE, HAMULOSE, HAMULOUS [adj]\n",
  "HAMULATE": "relating to a small hook, also HAMULAR, HAMULOSE, HAMULOUS [adj]\n",
  "HAMULI": "HAMULUS, (Latin) a small hook [n]\n",
  "HAMULOSE": "relating to a small hook, also HAMULAR, HAMULATE, HAMULOUS [adj]\n",
  "HAMULOUS": "relating to a small hook, also HAMULAR, HAMULATE, HAMULOSE [adj]\n",
  "HAMULUS": "(Latin) a small hook [n HAMULI]\n",
  "HAMZA": "(Arabic) an Arab diacritical mark, also HAMZAH [n -S]\n",
  "HAMZAH": "(Arabic) an Arab diacritical mark, also HAMZA [n -S]\n",
  "HAMZAHS": "HAMZAH, (Arabic) an Arab diacritical mark, also HAMZA [n]\n",
  "HAMZAS": "HAMZA, (Arabic) an Arab diacritical mark, also HAMZAH [n]\n",
  "HAN": "(Spenser) 3rd person plural of HAVE, to possess [v]\n",
  "HANAP": "an ornate mediaeval drinking goblet, often having a cover [n -S]\n",
  "HANAPER": "a wicker receptacle [n -S]\n",
  "HANAPERS": "HANAPER, a wicker receptacle [n]\n",
  "HANAPS": "HANAP, an ornate mediaeval drinking goblet, often having a cover [n]\n",
  "HANCE": "a curved rise from a lower to a higher part [n -S]\n",
  "HANCES": "HANCE, a curved rise from a lower to a higher part [n]\n",
  "HANCH": "(Scots) to snap with the jaws [v -ED, -ING, -ES]\n",
  "HANCHED": "HANCH, (Scots) to snap with the jaws [v]\n",
  "HANCHES": "HANCH, (Scots) to snap with the jaws [v]\n",
  "HANCHING": "HANCH, (Scots) to snap with the jaws [v]\n",
  "HAND": "to present with the extremity of the arm below the wrist [v -ED, -ING, -S]\n",
  "HANDAX": "a stone axe shaped to fit the hand, also HANDAXE [n -ES]\n",
  "HANDAXE": "a stone axe shaped to fit the hand, also HANDAX [n -S]\n",
  "HANDAXES": "HANDAX, a stone axe shaped to fit the hand, also HANDAXE [n]\n",
  "HANDBAG": "a bag for small articles, carried esp. by women [n -S] / to strike with a handbag [v HANDBAGGED, HANDBAGGING, HANDBAGS]\n",
  "HANDBAGGED": "HANDBAG, to strike with a handbag [v]\n",
  "HANDBAGGING": "an attack with a handbag [n -S]\n",
  "HANDBAGGINGS": "HANDBAGGING, an attack with a handbag [n]\n",
  "HANDBAGS": "HANDBAG, to strike with a handbag [v]\n",
  "HANDBALL": "to handle the ball in football [v -ED, -ING, -S]\n",
  "HANDBALLED": "HANDBALL, to handle the ball in football [v]\n",
  "HANDBALLER": "one who plays handball [n -S]\n",
  "HANDBALLERS": "HANDBALLER, one who plays handball [n]\n",
  "HANDBALLING": "HANDBALL, to handle the ball in football [v]\n",
  "HANDBALLS": "HANDBALL, to handle the ball in football [v]\n",
  "HANDBARROW": "a frame or barrow, without a wheel, carried by hand [n -S]\n",
  "HANDBARROWS": "HANDBARROW, a frame or barrow, without a wheel, carried by hand [n]\n",
  "HANDBASKET": "a basket carried in the hand [n -S]\n",
  "HANDBASKETS": "HANDBASKET, a basket carried in the hand [n]\n",
  "HANDBELL": "a bell held in the hand and played by shaking [n -S]\n",
  "HANDBELLS": "HANDBELL, a bell held in the hand and played by shaking [n]\n",
  "HANDBILL": "a small printed notice for distribution by hand [n -S]\n",
  "HANDBILLS": "HANDBILL, a small printed notice for distribution by hand [n]\n",
  "HANDBLOWN": "made by glassblowing and moulded by hand [adj]\n",
  "HANDBOOK": "a manual [n -S]\n",
  "HANDBOOKS": "HANDBOOK, a manual [n]\n",
  "HANDBRAKE": "a brake applied by a hand-operated lever [n -S]\n",
  "HANDBRAKES": "HANDBRAKE, a brake applied by a hand-operated lever [n]\n",
  "HANDBREADTH": "the breadth of a hand, also HANDSBREADTH [n -S]\n",
  "HANDBREADTHS": "HANDBREADTH, the breadth of a hand, also HANDSBREADTH [n]\n",
  "HANDCAR": "a hand-operated railroad car [n -S]\n",
  "HANDCARS": "HANDCAR, a hand-operated railroad car [n]\n",
  "HANDCART": "a cart for transporting small loads, pushed by hand [n -S]\n",
  "HANDCARTS": "HANDCART, a cart for transporting small loads, pushed by hand [n]\n",
  "HANDCLAP": "a sound made by striking the hands together [n -S]\n",
  "HANDCLAPS": "HANDCLAP, a sound made by striking the hands together [n]\n",
  "HANDCLASP": "a handshake [n -S]\n",
  "HANDCLASPS": "HANDCLASP, a handshake [n]\n",
  "HANDCRAFT": "handicraft [n -S] / to fashion by hand [v -ED, -ING, -S]\n",
  "HANDCRAFTED": "HANDCRAFT, to fashion by hand [v]\n",
  "HANDCRAFTING": "HANDCRAFT, to fashion by hand [v]\n",
  "HANDCRAFTS": "HANDCRAFT, to fashion by hand [v]\n",
  "HANDCRAFTSMAN": "a person who is skilled in handicraft [n HANDCRAFTSMEN]\n",
  "HANDCRAFTSMEN": "HANDCRAFTSMAN, a person who is skilled in handicraft [n]\n",
  "HANDCUFF": "to fetter with restraining cuffs [v -ED, -ING, -S]\n",
  "HANDCUFFED": "HANDCUFF, to fetter with restraining cuffs [v]\n",
  "HANDCUFFING": "HANDCUFF, to fetter with restraining cuffs [v]\n",
  "HANDCUFFS": "HANDCUFF, to fetter with restraining cuffs [v]\n",
  "HANDED": "HAND, to present with the extremity of the arm below the wrist [v]\n",
  "HANDEDNESS": "a tendency to use one hand rather than the other [n -ES]\n",
  "HANDEDNESSES": "HANDEDNESS, a tendency to use one hand rather than the other [n]\n",
  "HANDER": "one who hands over or transmits; a conveyer in succession [n -S]\n",
  "HANDERS": "HANDER, one who hands over or transmits; a conveyer in succession [n]\n",
  "HANDFAST": "to betroth [v -ED, -ING, -S]\n",
  "HANDFASTED": "HANDFAST, to betroth [v]\n",
  "HANDFASTING": "a betrothal [n -S]\n",
  "HANDFASTINGS": "HANDFASTING, a betrothal [n]\n",
  "HANDFASTS": "HANDFAST, to betroth [v]\n",
  "HANDFED": "HANDFEED, to feed with the hand [v]\n",
  "HANDFEED": "to feed with the hand [v HANDFED, HANDFEEDING, HANDFEEDS]\n",
  "HANDFEEDING": "HANDFEED, to feed with the hand [v]\n",
  "HANDFEEDS": "HANDFEED, to feed with the hand [v]\n",
  "HANDFUL": "as much as the hand can hold [n HANDFULS or HANDSFUL]\n",
  "HANDFULS": "HANDFUL, as much as the hand can hold [n]\n",
  "HANDGLASS": "a magnifying glass held in the hand [n -ES]\n",
  "HANDGLASSES": "HANDGLASS, a magnifying glass held in the hand [n]\n",
  "HANDGRIP": "a grasp with the hand [n -S]\n",
  "HANDGRIPS": "HANDGRIP, a grasp with the hand [n]\n",
  "HANDGUN": "a gun that can be held and fired in one hand [n -S]\n",
  "HANDGUNS": "HANDGUN, a gun that can be held and fired in one hand [n]\n",
  "HANDHELD": "something, e.g. a computer, held in the hand and operated from there [n -S]\n",
  "HANDHELDS": "HANDHELD, something, e.g. a computer, held in the hand and operated from there [n]\n",
  "HANDHOLD": "a handgrip [n -S]\n",
  "HANDHOLDS": "HANDHOLD, a handgrip [n]\n",
  "HANDICAP": "to impose special disadvantages on [v HANDICAPPED, HANDICAPPING, HANDICAPS]\n",
  "HANDICAPPED": "HANDICAP, to impose special disadvantages on [v]\n",
  "HANDICAPPER": "a person who assigns handicaps [n -S]\n",
  "HANDICAPPERS": "HANDICAPPER, a person who assigns handicaps [n]\n",
  "HANDICAPPING": "HANDICAP, to impose special disadvantages on [v]\n",
  "HANDICAPS": "HANDICAP, to impose special disadvantages on [v]\n",
  "HANDICRAFT": "a trade requiring skill of hand [n -S]\n",
  "HANDICRAFTER": "one who practises handicrafts [n -S]\n",
  "HANDICRAFTERS": "HANDICRAFTER, one who practises handicrafts [n]\n",
  "HANDICRAFTS": "HANDICRAFT, a trade requiring skill of hand [n]\n",
  "HANDICRAFTSMAN": "a person who engages in a handicraft [n HANDICRAFTSMEN]\n",
  "HANDICRAFTSMEN": "HANDICRAFTSMAN, a person who engages in a handicraft [n]\n",
  "HANDICUFFS": "fisticuffs [n]\n",
  "HANDIER": "HANDY, convenient [adj]\n",
  "HANDIEST": "HANDY, convenient [adj]\n",
  "HANDILY": "HANDY, convenient [adv]\n",
  "HANDINESS": "the state of being handy [n -ES]\n",
  "HANDINESSES": "HANDINESS, the state of being handy [n]\n",
  "HANDING": "HAND, to present with the extremity of the arm below the wrist [v]\n",
  "HANDISM": "discrimination against people on the grounds of whether they are left- or right-handed [n -S]\n",
  "HANDISMS": "HANDISM, discrimination against people on the grounds of whether they are left- or right-handed [n]\n",
  "HANDIWORK": "work done by the hands or by direct personal agency, also HANDWORK, HANDYWORK [n -S]\n",
  "HANDIWORKS": "HANDIWORK, work done by the hands or by direct personal agency, also HANDWORK, HANDYWORK [n]\n",
  "HANDJAR": "(Persian) a Persian dagger, also HANJAR, KHANJAR [n -S]\n",
  "HANDJARS": "HANDJAR, (Persian) a Persian dagger, also HANJAR, KHANJAR [n]\n",
  "HANDJOB": "(vulgar) an act of manually stimulating the penis of another person [n -S]\n",
  "HANDJOBS": "HANDJOB, (vulgar) an act of manually stimulating the penis of another person [n]\n",
  "HANDKERCHER": "a handkerchief, also HANDKERCHIEF [n -S]\n",
  "HANDKERCHERS": "HANDKERCHER, a handkerchief, also HANDKERCHIEF [n]\n",
  "HANDKERCHIEF": "a small usually square piece of cloth used for usually personal purposes (as blowing the nose) or as a clothing accessory, also HANDKERCHER [n HANDKERCHIEFS or HANDKERCHIEVES]\n",
  "HANDKERCHIEFS": "HANDKERCHIEF, a small usually square piece of cloth used for usually personal purposes (as blowing the nose) or as a clothing accessory, also HANDKERCHER [n]\n",
  "HANDKERCHIEVES": "HANDKERCHIEF, a small usually square piece of cloth used for usually personal purposes (as blowing the nose) or as a clothing accessory, also HANDKERCHER [n]\n",
  "HANDKNIT": "a garment knitted by hand [n -S]\n",
  "HANDKNITS": "HANDKNIT, a garment knitted by hand [n]\n",
  "HANDLANGER": "(South African) an unskilled assistant to a tradesman [n -S]\n",
  "HANDLANGERS": "HANDLANGER, (South African) an unskilled assistant to a tradesman [n]\n",
  "HANDLE": "to touch with the hands [v HANDLED, HANDLING, HANDLES]\n",
  "HANDLEABLE": "capable of being handled [adj]\n",
  "HANDLEBAR": "the steering-bar of a cycle, or one half of it [n -S]\n",
  "HANDLEBARS": "HANDLEBAR, the steering-bar of a cycle, or one half of it [n]\n",
  "HANDLED": "HANDLE, to touch with the hands [v]\n",
  "HANDLELESS": "without a handle [adj]\n",
  "HANDLER": "one who handles [n -S]\n",
  "HANDLERS": "HANDLER, one who handles [n]\n",
  "HANDLES": "HANDLE, to touch with the hands [v]\n",
  "HANDLESS": "without hands [adj]\n",
  "HANDLIKE": "resembling a hand [adj]\n",
  "HANDLINE": "a fishing line worked by hand [n -S]\n",
  "HANDLINER": "one who fishes with a handline [n -S]\n",
  "HANDLINERS": "HANDLINER, one who fishes with a handline [n]\n",
  "HANDLINES": "HANDLINE, a fishing line worked by hand [n]\n",
  "HANDLING": "the manner in which something is handled [n -S]\n",
  "HANDLINGS": "HANDLING, the manner in which something is handled [n]\n",
  "HANDLIST": "a reference list [n -S]\n",
  "HANDLISTS": "HANDLIST, a reference list [n]\n",
  "HANDLOOM": "a manually operated loom [n -S]\n",
  "HANDLOOMS": "HANDLOOM, a manually operated loom [n]\n",
  "HANDMADE": "made by hand [adj]\n",
  "HANDMAID": "a female servant [n -S]\n",
  "HANDMAIDEN": "a personal maid or female servant [n -S]\n",
  "HANDMAIDENS": "HANDMAIDEN, a personal maid or female servant [n]\n",
  "HANDMAIDS": "HANDMAID, a female servant [n]\n",
  "HANDOFF": "the act of pushing off an opponent e.g. in rugby [n -S]\n",
  "HANDOFFS": "HANDOFF, the act of pushing off an opponent e.g. in rugby [n]\n",
  "HANDOUT": "something given out free [n -S]\n",
  "HANDOUTS": "HANDOUT, something given out free [n]\n",
  "HANDOVER": "a transfer [n -S]\n",
  "HANDOVERS": "HANDOVER, a transfer [n]\n",
  "HANDPASS": "(in Australian Rules and Gaelic football) to pass the ball by striking it with one hand while it is held in the other [v -ED, -ING, -ES]\n",
  "HANDPASSED": "HANDPASS, (in Australian Rules and Gaelic football) to pass the ball by striking it with one hand while it is held in the other [v]\n",
  "HANDPASSES": "HANDPASS, (in Australian Rules and Gaelic football) to pass the ball by striking it with one hand while it is held in the other [v]\n",
  "HANDPASSING": "HANDPASS, (in Australian Rules and Gaelic football) to pass the ball by striking it with one hand while it is held in the other [v]\n",
  "HANDPHONE": "in SE Asia, a mobile phone [n -S]\n",
  "HANDPHONES": "HANDPHONE, in SE Asia, a mobile phone [n]\n",
  "HANDPICK": "to choose carefully [v -ED, -ING, -S]\n",
  "HANDPICKED": "HANDPICK, to choose carefully [v]\n",
  "HANDPICKING": "HANDPICK, to choose carefully [v]\n",
  "HANDPICKS": "HANDPICK, to choose carefully [v]\n",
  "HANDPLAY": "a dealing of blows [n -S]\n",
  "HANDPLAYS": "HANDPLAY, a dealing of blows [n]\n",
  "HANDPRESS": "a press operated by hand [n -ES]\n",
  "HANDPRESSES": "HANDPRESS, a press operated by hand [n]\n",
  "HANDPRINT": "the mark of a hand [n -S]\n",
  "HANDPRINTS": "HANDPRINT, the mark of a hand [n]\n",
  "HANDRAIL": "a railing used for support [n -S]\n",
  "HANDRAILS": "HANDRAIL, a railing used for support [n]\n",
  "HANDROLL": "a cigarette rolled by hand [n -S]\n",
  "HANDROLLS": "HANDROLL, a cigarette rolled by hand [n]\n",
  "HANDS": "HAND, to present with the extremity of the arm below the wrist [v]\n",
  "HANDSAW": "a saw used manually [n -S]\n",
  "HANDSAWS": "HANDSAW, a saw used manually [n]\n",
  "HANDSBREADTH": "the breadth of a hand, also HANDBREADTH [n -S]\n",
  "HANDSBREADTHS": "HANDSBREADTH, the breadth of a hand, also HANDBREADTH [n]\n",
  "HANDSEL": "to give a good luck gift to, also HANSEL [v HANDSELED or HANDSELLED, HANDSELING or HANDSELLING, HANDSELS]\n",
  "HANDSELED": "HANDSEL, to give a good luck gift to, also HANSEL [v]\n",
  "HANDSELING": "HANDSEL, to give a good luck gift to, also HANSEL [v]\n",
  "HANDSELLED": "HANDSEL, to give a good luck gift to, also HANSEL [v]\n",
  "HANDSELLING": "HANDSEL, to give a good luck gift to, also HANSEL [v]\n",
  "HANDSELS": "HANDSEL, to give a good luck gift to, also HANSEL [v]\n",
  "HANDSET": "a device for e.g. operating a video recorder remotely [n -S]\n",
  "HANDSETS": "HANDSET, a device for e.g. operating a video recorder remotely [n]\n",
  "HANDSEWN": "sewn by hand [adj]\n",
  "HANDSFUL": "HANDFUL, as much as the hand can hold [n]\n",
  "HANDSHAKE": "a shaking of hands in greeting [n -S]\n",
  "HANDSHAKES": "HANDSHAKE, a shaking of hands in greeting [n]\n",
  "HANDSHAKING": "communication between a computer system and an external device, by which each tells the other that data is ready to be transferred, and that the receiver is ready to accept it [n -S]\n",
  "HANDSHAKINGS": "HANDSHAKING, communication between a computer system and an external device, by which each tells the other that data is ready to be transferred, and that the receiver is ready to accept it [n]\n",
  "HANDSIER": "HANDSY, tending to engage in excessive or unwanted physical contact [adj]\n",
  "HANDSIEST": "HANDSY, tending to engage in excessive or unwanted physical contact [adj]\n",
  "HANDSOME": "attractive [adj HANDSOMER, HANDSOMEST, HANDSOMELY] / a handsome person [n -S]\n",
  "HANDSOMELY": "HANDSOME, attractive [adv]\n",
  "HANDSOMENESS": "the state of being handsome [n -ES]\n",
  "HANDSOMENESSES": "HANDSOMENESS, the state of being handsome [n]\n",
  "HANDSOMER": "HANDSOME, attractive [adj]\n",
  "HANDSOMES": "HANDSOME, a handsome person [n]\n",
  "HANDSOMEST": "HANDSOME, attractive [adj]\n",
  "HANDSPIKE": "a bar used as a lever [n -S]\n",
  "HANDSPIKES": "HANDSPIKE, a bar used as a lever [n]\n",
  "HANDSPRING": "a somersault made with the assistance of the hands placed upon the ground [n -S]\n",
  "HANDSPRINGS": "HANDSPRING, a somersault made with the assistance of the hands placed upon the ground [n]\n",
  "HANDSTAFF": "a staff-like handle e.g. of a flail [n HANDSTAFFS or HANDSTAVES]\n",
  "HANDSTAFFS": "HANDSTAFF, a staff-like handle e.g. of a flail [n]\n",
  "HANDSTAMP": "to stamp by hand [v -ED, -ING, -S]\n",
  "HANDSTAMPED": "HANDSTAMP, to stamp by hand [v]\n",
  "HANDSTAMPING": "HANDSTAMP, to stamp by hand [v]\n",
  "HANDSTAMPS": "HANDSTAMP, to stamp by hand [v]\n",
  "HANDSTAND": "an act of balancing one's body on the palms of one's hands with one's trunk and legs in the air [n -S]\n",
  "HANDSTANDS": "HANDSTAND, an act of balancing one's body on the palms of one's hands with one's trunk and legs in the air [n]\n",
  "HANDSTAVES": "HANDSTAFF, a staff-like handle e.g. of a flail [n]\n",
  "HANDSTROKE": "the downward movement of the bell rope as the bell swings around allowing the ringer to grasp and pull it [n -S]\n",
  "HANDSTROKES": "HANDSTROKE, the downward movement of the bell rope as the bell swings around allowing the ringer to grasp and pull it [n]\n",
  "HANDSTURN": "the single or least act of work, he never does a handsturn [n -S]\n",
  "HANDSTURNS": "HANDSTURN, the single or least act of work, he never does a handsturn [n]\n",
  "HANDSY": "tending to engage in excessive or unwanted physical contact [adj HANDSIER, HANDSIEST]\n",
  "HANDTOWEL": "a towel for wiping the hands [n -S]\n",
  "HANDTOWELS": "HANDTOWEL, a towel for wiping the hands [n]\n",
  "HANDWHEEL": "any wheel worked by hand; esp. one the rim of which serves as the handle by which a valve, car brake, or other part is adjusted [n -S]\n",
  "HANDWHEELS": "HANDWHEEL, any wheel worked by hand; esp. one the rim of which serves as the handle by which a valve, car brake, or other part is adjusted [n]\n",
  "HANDWORK": "work done by the hands or by direct personal agency, also HANDIWORK, HANDYWORK [n -S]\n",
  "HANDWORKED": "crafted by hand [adj]\n",
  "HANDWORKER": "one who does handwork [n -S]\n",
  "HANDWORKERS": "HANDWORKER, one who does handwork [n]\n",
  "HANDWORKS": "HANDWORK, work done by the hands or by direct personal agency, also HANDIWORK, HANDYWORK [n]\n",
  "HANDWOVEN": "woven by hand [adj]\n",
  "HANDWRINGER": "one who wrings his hands [n -S]\n",
  "HANDWRINGERS": "HANDWRINGER, one who wrings his hands [n]\n",
  "HANDWRIT": "written by hand [adj]\n",
  "HANDWRITE": "to write by hand [v HANDWROTE, HANDWRITTEN, HANDWRIT, HANDWRITING, HANDWRITES]\n",
  "HANDWRITES": "HANDWRITE, to write by hand [v]\n",
  "HANDWRITING": "writing, script; one's style of writing [n -S]\n",
  "HANDWRITINGS": "HANDWRITING, writing, script; one's style of writing [n]\n",
  "HANDWRITTEN": "HANDWRITE, to write by hand [v]\n",
  "HANDWROTE": "HANDWRITE, to write by hand [v]\n",
  "HANDWROUGHT": "fashioned by hand or chiefly by hand processes [adj]\n",
  "HANDY": "convenient [adj HANDIER, HANDIEST, HANDILY]\n",
  "HANDYMAN": "a man who does odd jobs [n HANDYMEN]\n",
  "HANDYMEN": "HANDYMAN, a man who does odd jobs [n]\n",
  "HANDYPERSON": "a person good at manual crafts [n -S]\n",
  "HANDYPERSONS": "HANDYPERSON, a person good at manual crafts [n]\n",
  "HANDYWORK": "work done by the hands or by direct personal agency, also HANDIWORK, HANDWORK [n -S]\n",
  "HANDYWORKS": "HANDYWORK, work done by the hands or by direct personal agency, also HANDIWORK, HANDWORK [n]\n",
  "HANEPOOT": "(South African) a kind of grape, also HAANEPOOT, HONEYPOT [n -S]\n",
  "HANEPOOTS": "HANEPOOT, (South African) a kind of grape, also HAANEPOOT, HONEYPOT [n]\n",
  "HANG": "to attach from above, suspend [v HUNG or HANGED, HANGING, HANGS]\n",
  "HANGABILITIES": "HANGABILITY, the quality of being hangable [n]\n",
  "HANGABILITY": "the quality of being hangable [n HANGABILITIES]\n",
  "HANGABLE": "able to be hung [adj]\n",
  "HANGAR": "to place in an aircraft shelter [v -ED, -ING, -S]\n",
  "HANGARAGE": "a combined hangar and garage [n -S]\n",
  "HANGARAGES": "HANGARAGE, a combined hangar and garage [n]\n",
  "HANGARED": "HANGAR, to place in an aircraft shelter [v]\n",
  "HANGARING": "HANGAR, to place in an aircraft shelter [v]\n",
  "HANGARS": "HANGAR, to place in an aircraft shelter [v]\n",
  "HANGBIRD": "the Baltimore oriole, so called because its nest is suspended from the limb of a tree, also HANGNEST [n -S]\n",
  "HANGBIRDS": "HANGBIRD, the Baltimore oriole, so called because its nest is suspended from the limb of a tree, also HANGNEST [n]\n",
  "HANGDOG": "a contemptible person [n -S]\n",
  "HANGDOGS": "HANGDOG, a contemptible person [n]\n",
  "HANGED": "HANG, to attach from above, suspend [v]\n",
  "HANGER": "a wood on a hillside, typically beech on chalk [n -S]\n",
  "HANGERS": "HANGER, a wood on a hillside, typically beech on chalk [n]\n",
  "HANGFIRE": "a delay in explosion [n -S]\n",
  "HANGFIRES": "HANGFIRE, a delay in explosion [n]\n",
  "HANGI": "(Maori) an open air cooking pit [n -S]\n",
  "HANGING": "execution by strangling with a suspended noose [n -S]\n",
  "HANGINGS": "HANGING, execution by strangling with a suspended noose [n]\n",
  "HANGIS": "HANGI, (Maori) an open air cooking pit [n]\n",
  "HANGMAN": "an executioner [n HANGMEN]\n",
  "HANGMEN": "HANGMAN, an executioner [n]\n",
  "HANGNAIL": "a piece of loose skin at the base of a fingernail [n -S]\n",
  "HANGNAILS": "HANGNAIL, a piece of loose skin at the base of a fingernail [n]\n",
  "HANGNEST": "the Baltimore oriole, so called because its nest is suspended from the limb of a tree, also HANGBIRD [n -S]\n",
  "HANGNESTS": "HANGNEST, the Baltimore oriole, so called because its nest is suspended from the limb of a tree, also HANGBIRD [n]\n",
  "HANGOUT": "(colloquial) a place often visited [n -S]\n",
  "HANGOUTS": "HANGOUT, (colloquial) a place often visited [n]\n",
  "HANGOVER": "the physical effects of a drinking binge [n -S]\n",
  "HANGOVERS": "HANGOVER, the physical effects of a drinking binge [n]\n",
  "HANGRIER": "HANGRY, irritable as a result of feeling hungry [adj]\n",
  "HANGRIEST": "HANGRY, irritable as a result of feeling hungry [adj]\n",
  "HANGRY": "irritable as a result of feeling hungry [adj HANGRIER, HANGRIEST]\n",
  "HANGS": "HANG, to attach from above, suspend [v]\n",
  "HANGTAG": "a type of tag used commercially [n -S]\n",
  "HANGTAGS": "HANGTAG, a type of tag used commercially [n]\n",
  "HANGUL": "(Korean) an alphabetic script for Korean [n -S]\n",
  "HANGULS": "HANGUL, (Korean) an alphabetic script for Korean [n]\n",
  "HANGUP": "an inhibition or obsession [n -S]\n",
  "HANGUPS": "HANGUP, an inhibition or obsession [n]\n",
  "HANIWA": "(Japanese) japanese clay sculptures [n -S]\n",
  "HANIWAS": "HANIWA, (Japanese) japanese clay sculptures [n]\n",
  "HANJAR": "(Persian) a Persian dagger, also HANDJAR, KHANJAR [n -S]\n",
  "HANJARS": "HANJAR, (Persian) a Persian dagger, also HANDJAR, KHANJAR [n]\n",
  "HANK": "to catch, as on a loop [v -ED, -ING, -S]\n",
  "HANKED": "HANK, to catch, as on a loop [v]\n",
  "HANKER": "to long for [v -ED, -ING, -S]\n",
  "HANKERED": "HANKER, to long for [v]\n",
  "HANKERER": "one who hankers [n -S]\n",
  "HANKERERS": "HANKERER, one who hankers [n]\n",
  "HANKERING": "a yearning [n -S]\n",
  "HANKERINGS": "HANKERING, a yearning [n]\n",
  "HANKERS": "HANKER, to long for [v]\n",
  "HANKIE": "a square piece of material for wiping the nose, also HANKY [n -S]\n",
  "HANKIES": "HANKY, (colloquial) handkerchief, also HANKIE [n]\n",
  "HANKING": "HANK, to catch, as on a loop [v]\n",
  "HANKS": "HANK, to catch, as on a loop [v]\n",
  "HANKY": "(colloquial) handkerchief, also HANKIE [n HANKIES]\n",
  "HANSA": "a guild of merchants, also HANSE [n -S]\n",
  "HANSARDISE": "to confront someone with his or her previously recorded opinions, also HANSARDIZE [v HANSARDISED, HANSARDISING, HANSARDISES]\n",
  "HANSARDISED": "HANSARDISE, to confront someone with his or her previously recorded opinions, also HANSARDIZE [v]\n",
  "HANSARDISES": "HANSARDISE, to confront someone with his or her previously recorded opinions, also HANSARDIZE [v]\n",
  "HANSARDISING": "HANSARDISE, to confront someone with his or her previously recorded opinions, also HANSARDIZE [v]\n",
  "HANSARDIZE": "to confront someone with his or her previously recorded opinions, also HANSARDISE [v HANSARDIZED, HANSARDIZING, HANSARDIZES]\n",
  "HANSARDIZED": "HANSARDIZE, to confront someone with his or her previously recorded opinions, also HANSARDISE [v]\n",
  "HANSARDIZES": "HANSARDIZE, to confront someone with his or her previously recorded opinions, also HANSARDISE [v]\n",
  "HANSARDIZING": "HANSARDIZE, to confront someone with his or her previously recorded opinions, also HANSARDISE [v]\n",
  "HANSAS": "HANSA, a guild of merchants, also HANSE [n]\n",
  "HANSE": "a guild of merchants, also HANSA [n -S]\n",
  "HANSEATIC": "relating to the hansa, a guild of merchants [adj]\n",
  "HANSEL": "to give a good luck gift to, also HANDSEL [v HANSELLED or HANSELED, HANSELLING or HANSELING, HANSELS]\n",
  "HANSELED": "HANSEL, to give a good luck gift to, also HANDSEL [v]\n",
  "HANSELING": "HANSEL, to give a good luck gift to, also HANDSEL [v]\n",
  "HANSELLED": "HANSEL, to give a good luck gift to, also HANDSEL [v]\n",
  "HANSELLING": "HANSEL, to give a good luck gift to, also HANDSEL [v]\n",
  "HANSELS": "HANSEL, to give a good luck gift to, also HANDSEL [v]\n",
  "HANSES": "HANSE, a guild of merchants, also HANSA [n]\n",
  "HANSOM": "a light two-wheeled cab [n -S]\n",
  "HANSOMS": "HANSOM, a light two-wheeled cab [n]\n",
  "HANT": "to haunt [v -ED, -ING, -S]\n",
  "HANTAVIRUS": "an often fatal virus with flu-like symptoms [n -ES]\n",
  "HANTAVIRUSES": "HANTAVIRUS, an often fatal virus with flu-like symptoms [n]\n",
  "HANTED": "HANT, to haunt [v]\n",
  "HANTING": "HANT, to haunt [v]\n",
  "HANTLE": "(Scots) a lot [n -S]\n",
  "HANTLES": "HANTLE, (Scots) a lot [n]\n",
  "HANTS": "HANT, to haunt [v]\n",
  "HANUKIAH": "(Hebrew) a candelabrum having nine branches that is lit during the festival of Hanukkah, also CHANUKIAH [n -S]\n",
  "HANUKIAHS": "HANUKIAH, (Hebrew) a candelabrum having nine branches that is lit during the festival of Hanukkah, also CHANUKIAH [n]\n",
  "HANUMAN": "(Hindi) an East Indian monkey with a bristly face [n -S]\n",
  "HANUMANS": "HANUMAN, (Hindi) an East Indian monkey with a bristly face [n]\n",
  "HAO": "(Vietnamese) a monetary unit of Vietnam, also CHAO [n -S]\n",
  "HAOLE": "(Hawaiian) one who is not a native Hawaiian [n -S]\n",
  "HAOLES": "HAOLE, (Hawaiian) one who is not a native Hawaiian [n]\n",
  "HAOMA": "a drink made from the haoma vine, used in Zoroastrian ritual, also HOM, HOMA [n -S]\n",
  "HAOMAS": "HAOMA, a drink made from the haoma vine, used in Zoroastrian ritual, also HOM, HOMA [n]\n",
  "HAOS": "HAO, (Vietnamese) a monetary unit of Vietnam, also CHAO [n]\n",
  "HAP": "to happen by chance [v HAPPED, HAPPING, HAPS]\n",
  "HAPAX": "(Greek) a word that occurs only once [n -ES]\n",
  "HAPAXANTHIC": "monocarpous, also HAPAXANTHOUS [adj]\n",
  "HAPAXANTHOUS": "monocarpous, also HAPAXANTHIC [adj]\n",
  "HAPAXES": "HAPAX, (Greek) a word that occurs only once [n]\n",
  "HAPHAZARD": "marked by lack of plan, order, or direction [adj HAPHAZARDLY] / mere chance, fortuitousness [n -S]\n",
  "HAPHAZARDLY": "HAPHAZARD, marked by lack of plan, order, or direction [adv]\n",
  "HAPHAZARDNESS": "HAPHAZARD, marked by lack of plan, order, or direction [n]\n",
  "HAPHAZARDNESSES": "HAPHAZARDNESS, HAPHAZARD, marked by lack of plan, order, or direction [n]\n",
  "HAPHAZARDRIES": "HAPHAZARDRY, the quality of being haphazard [n]\n",
  "HAPHAZARDRY": "the quality of being haphazard [n HAPHAZARDRIES]\n",
  "HAPHAZARDS": "HAPHAZARD, mere chance, fortuitousness [n]\n",
  "HAPHTARA": "(Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAFTORAH, HAPHTARAH [n HAPHTARAS or HAPHTAROT or HAPHTAROTH]\n",
  "HAPHTARAH": "(Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAFTORAH, HAPHTARA [n -S]\n",
  "HAPHTARAHS": "HAPHTARAH, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAFTORAH, HAPHTARA [n]\n",
  "HAPHTARAS": "HAPHTARA, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAFTORAH, HAPHTARAH [n]\n",
  "HAPHTAROT": "HAPHTARA, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAFTORAH, HAPHTARAH [n]\n",
  "HAPHTAROTH": "HAPHTARA, (Hebrew) a Biblical selection, also HAFTARA, HAFTARAH, HAFTORAH, HAPHTARAH [n]\n",
  "HAPKIDO": "(Japanese) a Korean martial art [n -S]\n",
  "HAPKIDOS": "HAPKIDO, (Japanese) a Korean martial art [n]\n",
  "HAPLESS": "luckless [adj HAPLESSLY]\n",
  "HAPLESSLY": "HAPLESS, luckless [adv]\n",
  "HAPLESSNESS": "the state of being hapless [n -ES]\n",
  "HAPLESSNESSES": "HAPLESSNESS, the state of being hapless [n]\n",
  "HAPLITE": "a fine-grained, light-coloured igneous rock, also APLITE [n -S]\n",
  "HAPLITES": "HAPLITE, a fine-grained, light-coloured igneous rock, also APLITE [n]\n",
  "HAPLITIC": "of or like haplite, a fine-grained, light-coloured rock [adj]\n",
  "HAPLOBIONT": "an organism living in a salt environment [n -S]\n",
  "HAPLOBIONTIC": "of or like a haplobiont, an organism living in a salt environment [adj]\n",
  "HAPLOBIONTS": "HAPLOBIONT, an organism living in a salt environment [n]\n",
  "HAPLOGRAPHIES": "HAPLOGRAPHY, the accidental omission of letters, words or lines in copying [n]\n",
  "HAPLOGRAPHY": "the accidental omission of letters, words or lines in copying [n HAPLOGRAPHIES]\n",
  "HAPLOID": "a cell having only one set of chromosomes [n -S]\n",
  "HAPLOIDIC": "denoting a cell or organism with unpaired chromosomes [adj]\n",
  "HAPLOIDIES": "HAPLOIDY, the state of being a haploid [n]\n",
  "HAPLOIDS": "HAPLOID, a cell having only one set of chromosomes [n]\n",
  "HAPLOIDY": "the state of being a haploid [n HAPLOIDIES]\n",
  "HAPLOLOGIC": "showing haplology, the contraction of a word by the omission of one or more similar sounds or syllables [adj]\n",
  "HAPLOLOGIES": "HAPLOLOGY, the contraction of a word by the omission of one or more similar sounds or syllables (as in mineralogy for mineralology or prob-ly for probably) [n]\n",
  "HAPLOLOGY": "the contraction of a word by the omission of one or more similar sounds or syllables (as in mineralogy for mineralology or prob-ly for probably) [n HAPLOLOGIES]\n",
  "HAPLONT": "an organism with a particular chromosomal structure [n -S]\n",
  "HAPLONTIC": "of or like a haplont, an organism having a particular chromosomal structure [adj]\n",
  "HAPLONTS": "HAPLONT, an organism with a particular chromosomal structure [n]\n",
  "HAPLOPIA": "normal vision [n -S]\n",
  "HAPLOPIAS": "HAPLOPIA, normal vision [n]\n",
  "HAPLOSES": "HAPLOSIS, the halving of the chromosome number [n]\n",
  "HAPLOSIS": "the halving of the chromosome number [n HAPLOSES]\n",
  "HAPLOSTEMONOUS": "with one whorl of stamens [adj]\n",
  "HAPLOTYPE": "a single species contained in a genus [n -S]\n",
  "HAPLOTYPES": "HAPLOTYPE, a single species contained in a genus [n]\n",
  "HAPLY": "by chance [adv]\n",
  "HAPPED": "HAP, to happen by chance [v]\n",
  "HAPPEN": "to occur [v -ED, -ING, -S]\n",
  "HAPPENCHANCE": "a circumstance esp. that is due to chance, also HAPPENSTANCE [n -S]\n",
  "HAPPENCHANCES": "HAPPENCHANCE, a circumstance esp. that is due to chance, also HAPPENSTANCE [n]\n",
  "HAPPENED": "HAPPEN, to occur [v]\n",
  "HAPPENING": "an occurrence [n -S]\n",
  "HAPPENINGS": "HAPPENING, an occurrence [n]\n",
  "HAPPENS": "HAPPEN, to occur [v]\n",
  "HAPPENSTANCE": "a circumstance esp. that is due to chance, also HAPPENCHANCE [n -S]\n",
  "HAPPENSTANCES": "HAPPENSTANCE, a circumstance esp. that is due to chance, also HAPPENCHANCE [n]\n",
  "HAPPI": "(Japanese) a loose Japanese coat [n -S]\n",
  "HAPPIED": "HAPPY, to make content [v]\n",
  "HAPPIER": "HAPPY, marked by joy [adj]\n",
  "HAPPIES": "HAPPY, to make content [v]\n",
  "HAPPIEST": "HAPPY, marked by joy [adj]\n",
  "HAPPILY": "HAPPY, marked by joy [adv]\n",
  "HAPPINESS": "the state of being happy [n -ES]\n",
  "HAPPINESSES": "HAPPINESS, the state of being happy [n]\n",
  "HAPPING": "HAP, to happen by chance [v]\n",
  "HAPPIS": "HAPPI, (Japanese) a loose Japanese coat [n]\n",
  "HAPPOSHU": "(Japanese) a Japanese drink, similar to beer [n -S]\n",
  "HAPPOSHUS": "HAPPOSHU, (Japanese) a Japanese drink, similar to beer [n]\n",
  "HAPPY": "marked by joy [adj HAPPIER, HAPPIEST, HAPPILY] / to make content [v HAPPIED, HAPPYING, HAPPIES]\n",
  "HAPPYING": "HAPPY, to make content [v]\n",
  "HAPS": "HAP, to happen by chance [v]\n",
  "HAPTEN": "a substance similar to an antigen, also HAPTENE [n -S]\n",
  "HAPTENE": "a substance similar to an antigen, also HAPTEN [n -S]\n",
  "HAPTENES": "HAPTENE, a substance similar to an antigen, also HAPTEN [n]\n",
  "HAPTENIC": "of or like a haptene, an incomplete antigen that cannot stimulate antibodies in vivo but can in vitro [adj]\n",
  "HAPTENS": "HAPTEN, a substance similar to an antigen, also HAPTENE [n]\n",
  "HAPTERON": "a holdfast or attachment organ of a plant thallus [n -S]\n",
  "HAPTERONS": "HAPTERON, a holdfast or attachment organ of a plant thallus [n]\n",
  "HAPTIC": "pertaining to the sense of touch, also HAPTICAL [adj]\n",
  "HAPTICAL": "pertaining to the sense of touch, also HAPTIC [adj]\n",
  "HAPTICS": "the science of studying data obtained through touch [n]\n",
  "HAPTOGLOBIN": "a protein that combines with free haemoglobin in the blood and prevents its filtration through the kidney [n -S]\n",
  "HAPTOGLOBINS": "HAPTOGLOBIN, a protein that combines with free haemoglobin in the blood and prevents its filtration through the kidney [n]\n",
  "HAPTOTROPIC": "curving in response to touch [adj]\n",
  "HAPTOTROPISM": "curving in response to touch, as a tendril [n -S]\n",
  "HAPTOTROPISMS": "HAPTOTROPISM, curving in response to touch, as a tendril [n]\n",
  "HAPU": "(Maori) a Maori subtribe (a subdivision of an iwi) [n -S]\n",
  "HAPUKA": "(Maori) the groper, also HAPUKU [n -S]\n",
  "HAPUKAS": "HAPUKA, (Maori) the groper, also HAPUKU [n]\n",
  "HAPUKU": "(Maori) the groper, also HAPUKA [n -S]\n",
  "HAPUKUS": "HAPUKU, (Maori) the groper, also HAPUKA [n]\n",
  "HAPUS": "HAPU, (Maori) a Maori subtribe (a subdivision of an iwi) [n]\n",
  "HAQUETON": "a stuffed jacket worn under mail, also ACTON, HACQUETON [n -S]\n",
  "HAQUETONS": "HAQUETON, a stuffed jacket worn under mail, also ACTON, HACQUETON [n]\n",
  "HARAAM": "forbidden under Islamic law [adj]\n",
  "HARAKEKE": "(Maori) flax [n -S]\n",
  "HARAKEKES": "HARAKEKE, (Maori) flax [n]\n",
  "HARAM": "(Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HAREEM, HAREM, HARIM [n -S]\n",
  "HARAMBEE": "(Swahili) a Swahili rallying cry, 'let's organize together' [n -S]\n",
  "HARAMBEES": "HARAMBEE, (Swahili) a Swahili rallying cry, 'let's organize together' [n]\n",
  "HARAMDA": "(Hindi) an illegitimate male, also HARAMZADA [n -S]\n",
  "HARAMDAS": "HARAMDA, (Hindi) an illegitimate male, also HARAMZADA [n]\n",
  "HARAMDI": "(Hindi) an illegitimate female, also HARAMZADI [n -S]\n",
  "HARAMDIS": "HARAMDI, (Hindi) an illegitimate female, also HARAMZADI [n]\n",
  "HARAMS": "HARAM, (Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HAREEM, HAREM, HARIM [n]\n",
  "HARAMZADA": "(Hinglish) an illegitimate male, also HARAMDA [n -S]\n",
  "HARAMZADAS": "HARAMZADA, (Hinglish) an illegitimate male, also HARAMDA [n]\n",
  "HARAMZADI": "(Hinglish) an illegitimate female, also HARAMDI [n -S]\n",
  "HARAMZADIS": "HARAMZADI, (Hinglish) an illegitimate female, also HARAMDI [n]\n",
  "HARANGUE": "to deliver a tirade to [v HARANGUED, HARANGUING, HARANGUES]\n",
  "HARANGUED": "HARANGUE, to deliver a tirade to [v]\n",
  "HARANGUER": "one who harangues [n -S]\n",
  "HARANGUERS": "HARANGUER, one who harangues [n]\n",
  "HARANGUES": "HARANGUE, to deliver a tirade to [v]\n",
  "HARANGUING": "HARANGUE, to deliver a tirade to [v]\n",
  "HARASS": "to bother persistently [v -ED, -ING, -ES]\n",
  "HARASSED": "HARASS, to bother persistently [v]\n",
  "HARASSEDLY": "HARASSED, HARASS, to bother persistently [adv]\n",
  "HARASSER": "one who harasses [n -S]\n",
  "HARASSERS": "HARASSER, one who harasses [n]\n",
  "HARASSES": "HARASS, to bother persistently [v]\n",
  "HARASSING": "persistently bothering [adj HARASSINGLY] / the act of harassing [n -S]\n",
  "HARASSINGLY": "HARASSING, persistently bothering [adv]\n",
  "HARASSINGS": "HARASSING, the act of harassing [n]\n",
  "HARASSMENT": "the act of harassing [n -S]\n",
  "HARASSMENTS": "HARASSMENT, the act of harassing [n]\n",
  "HARBINGER": "a forerunner; something that indicates what is to come [n -S] / to foreshadow [v -ED, -ING, -S]\n",
  "HARBINGERED": "HARBINGER, to foreshadow [v]\n",
  "HARBINGERING": "HARBINGER, to foreshadow [v]\n",
  "HARBINGERS": "HARBINGER, a forerunner; something that indicates what is to come [n]\n",
  "HARBOR": "to shelter, also HARBOUR [v -ED, -ING, -S]\n",
  "HARBORAGE": "(US) shelter, harbour, also HARBOURAGE [n -S]\n",
  "HARBORAGES": "HARBORAGE, (US) shelter, harbour, also HARBOURAGE [n]\n",
  "HARBORED": "HARBOR, to shelter, also HARBOUR [v]\n",
  "HARBORER": "(US) one who, or that which, harbors, also HARBOURER [n -S]\n",
  "HARBORERS": "HARBORER, (US) one who, or that which, harbors, also HARBOURER [n]\n",
  "HARBORFUL": "the contents of a harbor, also HARBOURFUL [n -S]\n",
  "HARBORFULS": "HARBORFUL, the contents of a harbor, also HARBOURFUL [n]\n",
  "HARBORING": "HARBOR, to shelter, also HARBOUR [v]\n",
  "HARBORLESS": "(US) without a harbor, also HARBOURLESS [adj]\n",
  "HARBORMASTER": "one in charge of a harbour [n -S]\n",
  "HARBORMASTERS": "HARBORMASTER, one in charge of a harbour [n]\n",
  "HARBOROUS": "hospitable [adj]\n",
  "HARBORS": "HARBOR, to shelter, also HARBOUR [v]\n",
  "HARBORSIDE": "(US) located next to a harbor, also HARBOURSIDE [adj]\n",
  "HARBOUR": "to shelter, also HARBOR [v -ED, -ING, -S]\n",
  "HARBOURAGE": "shelter, harbour, also HARBORAGE [n -S]\n",
  "HARBOURAGES": "HARBOURAGE, shelter, harbour, also HARBORAGE [n]\n",
  "HARBOURED": "HARBOUR, to shelter, also HARBOR [v]\n",
  "HARBOURER": "one who or that which harbours, also HARBORER [n -S]\n",
  "HARBOURERS": "HARBOURER, one who or that which harbours, also HARBORER [n]\n",
  "HARBOURFUL": "the contents of a harbour, also HARBORFUL [n -S]\n",
  "HARBOURFULS": "HARBOURFUL, the contents of a harbour, also HARBORFUL [n]\n",
  "HARBOURING": "HARBOUR, to shelter, also HARBOR [v]\n",
  "HARBOURLESS": "without a harbour, also HARBORLESS [adj]\n",
  "HARBOURS": "HARBOUR, to shelter, also HARBOR [v]\n",
  "HARBOURSIDE": "the land that is situated next to a harbour, also HARBORSIDE [n -S]\n",
  "HARBOURSIDES": "HARBOURSIDE, the land that is situated next to a harbour, also HARBORSIDE [n]\n",
  "HARD": "firm and unyielding [adj HARDER, HARDEST, HARDLY] / a hard place [n -S]\n",
  "HARDASS": "someone who sticks rigidly to rules and procedures [n -ES]\n",
  "HARDASSES": "HARDASS, someone who sticks rigidly to rules and procedures [n]\n",
  "HARDBACK": "a book with a hard cover [n -S]\n",
  "HARDBACKED": "of a book, having hard covers [adj]\n",
  "HARDBACKS": "HARDBACK, a book with a hard cover [n]\n",
  "HARDBAG": "a rigid container on a motorcycle; a type of electronically generated dance music [n -S]\n",
  "HARDBAGS": "HARDBAG, a rigid container on a motorcycle; a type of electronically generated dance music [n]\n",
  "HARDBAKE": "a sweetmeat of boiled brown sugar or molasses made with almonds etc. [n -S]\n",
  "HARDBAKES": "HARDBAKE, a sweetmeat of boiled brown sugar or molasses made with almonds etc. [n]\n",
  "HARDBALL": "baseball [n -S]\n",
  "HARDBALLS": "HARDBALL, baseball [n]\n",
  "HARDBEAM": "a small hardwood tree of compact, horny texture, also HORNBEAM [n -S]\n",
  "HARDBEAMS": "HARDBEAM, a small hardwood tree of compact, horny texture, also HORNBEAM [n]\n",
  "HARDBOARD": "compressed board made from wood fibre [n -S]\n",
  "HARDBOARDS": "HARDBOARD, compressed board made from wood fibre [n]\n",
  "HARDBODIES": "HARDBODY, an attractive person with a muscular body [n]\n",
  "HARDBODY": "an attractive person with a muscular body [n HARDBODIES]\n",
  "HARDBOOT": "a type of computer startup [n -S]\n",
  "HARDBOOTS": "HARDBOOT, a type of computer startup [n]\n",
  "HARDBOUND": "bound in hard covers [adj] / a book bound in hard covers [n -S]\n",
  "HARDBOUNDS": "HARDBOUND, a book bound in hard covers [n]\n",
  "HARDCASE": "a person difficult to deal with or reform [n -S]\n",
  "HARDCASES": "HARDCASE, a person difficult to deal with or reform [n]\n",
  "HARDCORE": "unyielding [adj] / a style of rock music [n -S]\n",
  "HARDCORES": "HARDCORE, a style of rock music [n]\n",
  "HARDCOURT": "of tennis, played on a hard surface [adj]\n",
  "HARDCOVER": "a book in hard covers, as opposed to a paperback [n -S]\n",
  "HARDCOVERS": "HARDCOVER, a book in hard covers, as opposed to a paperback [n]\n",
  "HARDEDGE": "in art, the use of bright areas of colour with sharp defined edges [n -S]\n",
  "HARDEDGES": "HARDEDGE, in art, the use of bright areas of colour with sharp defined edges [n]\n",
  "HARDEN": "to make hard [v -ED, -ING, -S]\n",
  "HARDENED": "HARDEN, to make hard [v]\n",
  "HARDENER": "one that hardens [n -S]\n",
  "HARDENERS": "HARDENER, one that hardens [n]\n",
  "HARDENING": "the act of making hard [n HARDENINGS]\n",
  "HARDENINGS": "HARDENING, the act of making hard [n]\n",
  "HARDENS": "HARDEN, to make hard [v]\n",
  "HARDER": "HARD, firm and unyielding [adj]\n",
  "HARDEST": "HARD, firm and unyielding [adj]\n",
  "HARDFACE": "a relentless and uncaring person [n -S]\n",
  "HARDFACES": "HARDFACE, a relentless and uncaring person [n]\n",
  "HARDFISTED": "having hard or strong fists or hands [adj]\n",
  "HARDGOODS": "hardware [n]\n",
  "HARDGRASS": "cocksfoot or other coarse grass [n -ES]\n",
  "HARDGRASSES": "HARDGRASS, cocksfoot or other coarse grass [n]\n",
  "HARDHACK": "a very astringent shrub, common in pastures [n -S]\n",
  "HARDHACKS": "HARDHACK, a very astringent shrub, common in pastures [n]\n",
  "HARDHANDED": "having hard hands, rough, severe [adj]\n",
  "HARDHANDEDNESS": "HARDHANDED, having hard hands, rough, severe [n]\n",
  "HARDHAT": "a protective helmet worn by building workers [n -S]\n",
  "HARDHATS": "HARDHAT, a protective helmet worn by building workers [n]\n",
  "HARDHEAD": "any of several fishes with armoured heads [n -S]\n",
  "HARDHEADED": "stubborn, willful [adj HARDHEADEDLY]\n",
  "HARDHEADEDLY": "HARDHEADED, stubborn, willful [adv]\n",
  "HARDHEADEDNESS": "HARDHEADED, stubborn, willful [n]\n",
  "HARDHEADS": "HARDHEAD, any of several fishes with armoured heads [n]\n",
  "HARDHEARTED": "lacking compassion [adj HARDHEARTEDLY]\n",
  "HARDHEARTEDLY": "HARDHEARTED, lacking compassion [adv]\n",
  "HARDHEARTEDNESS": "HARDHEARTED, lacking compassion [n]\n",
  "HARDIER": "HARDY, very sturdy [adj]\n",
  "HARDIES": "HARDY, a blacksmith's chisel [n]\n",
  "HARDIEST": "HARDY, very sturdy [adj]\n",
  "HARDIHEAD": "(archaic) hardihood, boldness, also HARDIHOOD, HARDIMENT [n -S]\n",
  "HARDIHEADS": "HARDIHEAD, (archaic) hardihood, boldness, also HARDIHOOD, HARDIMENT [n]\n",
  "HARDIHOOD": "boldness; audacity, also HARDIHEAD, HARDIMENT [n -S]\n",
  "HARDIHOODS": "HARDIHOOD, boldness; audacity, also HARDIHEAD, HARDIMENT [n]\n",
  "HARDILY": "HARDY, very sturdy [adv]\n",
  "HARDIMENT": "(archaic) hardihood, boldness, also HARDIHEAD, HARDIHOOD [n -S]\n",
  "HARDIMENTS": "HARDIMENT, (archaic) hardihood, boldness, also HARDIHEAD, HARDIHOOD [n]\n",
  "HARDINESS": "the state of being hardy [n -ES]\n",
  "HARDINESSES": "HARDINESS, the state of being hardy [n]\n",
  "HARDINGGRASS": "a perennial forage grass of the US [n -ES]\n",
  "HARDINGGRASSES": "HARDINGGRASS, a perennial forage grass of the US [n]\n",
  "HARDISH": "somewhat hard [adj]\n",
  "HARDLINE": "of an attitude or policy, definite and unyielding [adj]\n",
  "HARDLINER": "one who takes a hardline [n -S]\n",
  "HARDLINERS": "HARDLINER, one who takes a hardline [n]\n",
  "HARDLY": "HARD, firm and unyielding [adv]\n",
  "HARDMAN": "a tough, ruthless man [n HARDMEN]\n",
  "HARDMEN": "HARDMAN, a tough, ruthless man [n]\n",
  "HARDMOUTHED": "of a horse, with a mouth insensible to the bit; not easily managed [adj]\n",
  "HARDNESS": "the state of being hard [n -ES]\n",
  "HARDNESSES": "HARDNESS, the state of being hard [n]\n",
  "HARDNOSE": "a tough, unsentimental person [n -S]\n",
  "HARDNOSED": "tough, unsentimental [adj]\n",
  "HARDNOSES": "HARDNOSE, a tough, unsentimental person [n]\n",
  "HARDOKE": "(Shakespeare) an unidentified plant, perhaps burdock, also HORDOCK [n -S]\n",
  "HARDOKES": "HARDOKE, (Shakespeare) an unidentified plant, perhaps burdock, also HORDOCK [n]\n",
  "HARDPACK": "a rigid backpack [n -S]\n",
  "HARDPACKS": "HARDPACK, a rigid backpack [n]\n",
  "HARDPAN": "a layer of hard subsoil [n -S]\n",
  "HARDPANS": "HARDPAN, a layer of hard subsoil [n]\n",
  "HARDPARTS": "the skeletal parts of an organism [n]\n",
  "HARDROCK": "(colloquial) a tough, uncompromising man [n -S]\n",
  "HARDROCKS": "HARDROCK, (colloquial) a tough, uncompromising man [n]\n",
  "HARDS": "the coarse refuse of flax, also HURDS [n]\n",
  "HARDSCAPE": "in the practice of landscaping, the built environment including paved areas like streets and sidewalks, structures, walls etc. [n -S]\n",
  "HARDSCAPES": "HARDSCAPE, in the practice of landscaping, the built environment including paved areas like streets and sidewalks, structures, walls etc. [n]\n",
  "HARDSCRABBLE": "a great effort made in the face of difficulties [n -S]\n",
  "HARDSCRABBLES": "HARDSCRABBLE, a great effort made in the face of difficulties [n]\n",
  "HARDSET": "beset by difficulty [adj]\n",
  "HARDSHELL": "having a hard shell; rigidly orthodox [adj]\n",
  "HARDSHIP": "a difficult, painful condition [n -S]\n",
  "HARDSHIPS": "HARDSHIP, a difficult, painful condition [n]\n",
  "HARDSTAND": "a hard surface on which cars, aircraft etc. may stand, also HARDSTANDING [n -S]\n",
  "HARDSTANDING": "a hard surface on which cars, aircraft etc. may stand, also HARDSTAND [n -S]\n",
  "HARDSTANDINGS": "HARDSTANDING, a hard surface on which cars, aircraft etc. may stand, also HARDSTAND [n]\n",
  "HARDSTANDS": "HARDSTAND, a hard surface on which cars, aircraft etc. may stand, also HARDSTANDING [n]\n",
  "HARDTACK": "a hard biscuit [n -S]\n",
  "HARDTACKS": "HARDTACK, a hard biscuit [n]\n",
  "HARDTAIL": "a motorcycle or bicycle with no suspension at the rear [n -S]\n",
  "HARDTAILS": "HARDTAIL, a motorcycle or bicycle with no suspension at the rear [n]\n",
  "HARDTOP": "a rigid roof on a motor car [n -S]\n",
  "HARDTOPS": "HARDTOP, a rigid roof on a motor car [n]\n",
  "HARDWARE": "metal goods [n -S]\n",
  "HARDWAREMAN": "one who sells hardware [n HARDWAREMEN]\n",
  "HARDWAREMEN": "HARDWAREMAN, one who sells hardware [n]\n",
  "HARDWARES": "HARDWARE, metal goods [n]\n",
  "HARDWIRE": "to permanently connect electronic components [v HARDWIRED, HARDWIRING, HARDWIRES]\n",
  "HARDWIRED": "HARDWIRE, to permanently connect electronic components [v]\n",
  "HARDWIRES": "HARDWIRE, to permanently connect electronic components [v]\n",
  "HARDWIRING": "HARDWIRE, to permanently connect electronic components [v]\n",
  "HARDWOOD": "the timber of deciduous trees, whose comparatively slow growth produces compact hard wood [n -S]\n",
  "HARDWOODS": "HARDWOOD, the timber of deciduous trees, whose comparatively slow growth produces compact hard wood [n]\n",
  "HARDWORKING": "industrious, diligent [adj]\n",
  "HARDY": "very sturdy [adj HARDIER, HARDIEST, HARDILY] / a blacksmith's chisel [n HARDIES]\n",
  "HARE": "a very swift mammal like a large rabbit [n -S] / to run like a hare [v HARED, HARING, HARES]\n",
  "HAREBELL": "the Scottish bluebell, also HAIRBELL [n -S]\n",
  "HAREBELLS": "HAREBELL, the Scottish bluebell, also HAIRBELL [n]\n",
  "HAREBRAINED": "crazy, crackpot, also HAIRBRAINED [adj]\n",
  "HARED": "HARE, to run like a hare [v]\n",
  "HAREEM": "(Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HARAM, HAREM, HARIM [n -S]\n",
  "HAREEMS": "HAREEM, (Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HARAM, HAREM, HARIM [n]\n",
  "HARELD": "(Icelandic) a North American duck, aka oldsquaw or oldwife [n -S]\n",
  "HARELDS": "HARELD, (Icelandic) a North American duck, aka oldsquaw or oldwife [n]\n",
  "HARELIKE": "resembling a long-eared mammal [adj]\n",
  "HARELIP": "a deformity of the upper lip [n -S]\n",
  "HARELIPPED": "having a harelip [adj]\n",
  "HARELIPS": "HARELIP, a deformity of the upper lip [n]\n",
  "HAREM": "(Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HARAM, HAREEM, HARIM [n -S]\n",
  "HAREMS": "HAREM, (Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HARAM, HAREEM, HARIM [n]\n",
  "HARES": "HARE, to run like a hare [v]\n",
  "HARESTAIL": "a species of cotton grass [n -S]\n",
  "HARESTAILS": "HARESTAIL, a species of cotton grass [n]\n",
  "HAREWOOD": "stained sycamore wood, used for making furniture [n -S]\n",
  "HAREWOODS": "HAREWOOD, stained sycamore wood, used for making furniture [n]\n",
  "HARIANA": "(Punjabi) a breed of Indian cattle [n -S]\n",
  "HARIANAS": "HARIANA, (Punjabi) a breed of Indian cattle [n]\n",
  "HARICOT": "(French) a kind of bean or pea [n -S]\n",
  "HARICOTS": "HARICOT, (French) a kind of bean or pea [n]\n",
  "HARIGALDS": "(Scots) viscera, also HARIGALS [n]\n",
  "HARIGALS": "(Scots) viscera, also HARIGALDS [n]\n",
  "HARIJAN": "(Sanskrit) in India, a member of the untouchable caste [n -S]\n",
  "HARIJANS": "HARIJAN, (Sanskrit) in India, a member of the untouchable caste [n]\n",
  "HARIM": "(Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HARAM, HAREEM, HAREM [n -S]\n",
  "HARIMS": "HARIM, (Arabic) a women's quarters in a Muslim house; a set of wives and concubines, also HARAM, HAREEM, HAREM [n]\n",
  "HARING": "HARE, to run like a hare [v]\n",
  "HARIOLATE": "to prophesy, soothsay [v HARIOLATED, HARIOLATING, HARIOLATES]\n",
  "HARIOLATED": "HARIOLATE, to prophesy, soothsay [v]\n",
  "HARIOLATES": "HARIOLATE, to prophesy, soothsay [v]\n",
  "HARIOLATING": "HARIOLATE, to prophesy, soothsay [v]\n",
  "HARIOLATION": "prophesy [n -S]\n",
  "HARIOLATIONS": "HARIOLATION, prophesy [n]\n",
  "HARIRA": "(Arabic) a kind of Moroccan soup [n -S]\n",
  "HARIRAS": "HARIRA, (Arabic) a kind of Moroccan soup [n]\n",
  "HARISH": "somewhat like a hare [adj]\n",
  "HARISSA": "(Arabic) a hot paste made from chilli peppers, spices, tomatoes and olive oil [n -S]\n",
  "HARISSAS": "HARISSA, (Arabic) a hot paste made from chilli peppers, spices, tomatoes and olive oil [n]\n",
  "HARK": "to listen, also HARKEN, HEARKEN [v -ED, -ING, -S]\n",
  "HARKED": "HARK, to listen, also HARKEN, HEARKEN [v]\n",
  "HARKEN": "to listen, also HARK, HEARKEN [v -ED, -ING, -S]\n",
  "HARKENED": "HARKEN, to listen, also HARK, HEARKEN [v]\n",
  "HARKENER": "one who harkens, also HEARKENER [n -S]\n",
  "HARKENERS": "HARKENER, one who harkens, also HEARKENER [n]\n",
  "HARKENING": "HARKEN, to listen, also HARK, HEARKEN [v]\n",
  "HARKENS": "HARKEN, to listen, also HARK, HEARKEN [v]\n",
  "HARKING": "HARK, to listen, also HARKEN, HEARKEN [v]\n",
  "HARKS": "HARK, to listen, also HARKEN, HEARKEN [v]\n",
  "HARL": "(Scots) to drag along the ground [v -ED, -ING, -S]\n",
  "HARLED": "HARL, (Scots) to drag along the ground [v]\n",
  "HARLEQUIN": "a stock comic character, masked, and dressed in a diamond-patterned multicolored costume [n -S] / to play a harlequin [v -ED, -ING, -S]\n",
  "HARLEQUINADE": "(French) part of a pantomime in which a harlequin plays a chief part [n -S]\n",
  "HARLEQUINADES": "HARLEQUINADE, (French) part of a pantomime in which a harlequin plays a chief part [n]\n",
  "HARLEQUINED": "HARLEQUIN, to play a harlequin [v]\n",
  "HARLEQUINING": "HARLEQUIN, to play a harlequin [v]\n",
  "HARLEQUINS": "HARLEQUIN, to play a harlequin [v]\n",
  "HARLING": "a scraping or small quantity of anything [n -S]\n",
  "HARLINGS": "HARLING, a scraping or small quantity of anything [n]\n",
  "HARLOT": "a prostitute [n -S]\n",
  "HARLOTRIES": "HARLOTRY, the behaviour of a harlot [n]\n",
  "HARLOTRY": "the behaviour of a harlot [n HARLOTRIES]\n",
  "HARLOTS": "HARLOT, a prostitute [n]\n",
  "HARLS": "HARL, (Scots) to drag along the ground [v]\n",
  "HARM": "to injure [v -ED, -ING, -S]\n",
  "HARMALA": "an African bean plant, also HARMEL [n -S]\n",
  "HARMALAS": "HARMALA, an African bean plant, also HARMEL [n]\n",
  "HARMALIN": "an alkaloid derived from harmala seeds, also HARMALINE, HARMIN, HARMINE [n -S]\n",
  "HARMALINE": "an alkaloid derived from harmala seeds, also HARMALIN, HARMIN, HARMINE [n -S]\n",
  "HARMALINES": "HARMALINE, an alkaloid derived from harmala seeds, also HARMALIN, HARMIN, HARMINE [n]\n",
  "HARMALINS": "HARMALIN, an alkaloid derived from harmala seeds, also HARMALINE, HARMIN, HARMINE [n]\n",
  "HARMAN": "in thieves' slang, a constable; (plural) the stocks [n -S]\n",
  "HARMANS": "HARMAN, in thieves' slang, a constable; (plural) the stocks [n]\n",
  "HARMATTAN": "(Fanti) a dry dusty wind from the Sahara blowing towards the West African coast [n -S]\n",
  "HARMATTANS": "HARMATTAN, (Fanti) a dry dusty wind from the Sahara blowing towards the West African coast [n]\n",
  "HARMDOING": "the doing of harm [n -S]\n",
  "HARMDOINGS": "HARMDOING, the doing of harm [n]\n",
  "HARMED": "HARM, to injure [v]\n",
  "HARMEL": "an African bean plant, also HARMALA [n -S]\n",
  "HARMELS": "HARMEL, an African bean plant, also HARMALA [n]\n",
  "HARMER": "one who harms [n -S]\n",
  "HARMERS": "HARMER, one who harms [n]\n",
  "HARMFUL": "capable of harming [adj HARMFULLY]\n",
  "HARMFULLY": "HARMFUL, capable of harming [adv]\n",
  "HARMFULNESS": "the state of being harmful [n -ES]\n",
  "HARMFULNESSES": "HARMFULNESS, the state of being harmful [n]\n",
  "HARMIN": "an alkaloid derived from harmala seeds, also HARMINE, HARMALIN [n -S]\n",
  "HARMINE": "an alkaloid derived from harmala seeds, also HARMALIN, HARMIN [n -S]\n",
  "HARMINES": "HARMINE, an alkaloid derived from harmala seeds, also HARMALIN, HARMIN [n]\n",
  "HARMING": "HARM, to injure [v]\n",
  "HARMINS": "HARMIN, an alkaloid derived from harmala seeds, also HARMINE, HARMALIN [n]\n",
  "HARMLESS": "not harmful [adj HARMLESSLY]\n",
  "HARMLESSLY": "HARMLESS, not harmful [adv]\n",
  "HARMLESSNESS": "the state of being harmless [n -ES]\n",
  "HARMLESSNESSES": "HARMLESSNESS, the state of being harmless [n]\n",
  "HARMOLODIC": "relating to a jazz technique where each musician in a group simultaneously improvising around the melodic and rhythmic patterns in a tune [adj]\n",
  "HARMOLODICS": "a technique in jazz [n]\n",
  "HARMONIC": "in harmony [adj HARMONICALLY] / a musical tone with a frequency that is a multiple of the fundamental frequency [n -S]\n",
  "HARMONICA": "a mouth-organ; also, an instrument composed of a soundbox and hanging strips of glass or metal, struck by a hammer, also ARMONICA, HARMONICON [n -S]\n",
  "HARMONICAL": "concordant; musical; as, harmonic sounds [adj HARMONICALLY]\n",
  "HARMONICALLY": "HARMONICAL, concordant; musical; as, harmonic sounds [adv]\n",
  "HARMONICAS": "HARMONICA, a mouth-organ; also, an instrument composed of a soundbox and hanging strips of glass or metal, struck by a hammer, also ARMONICA, HARMONICON [n]\n",
  "HARMONICHORD": "a keyboard instrument of violin tone, in which the strings are rubbed by rosined wheels [n -S]\n",
  "HARMONICHORDS": "HARMONICHORD, a keyboard instrument of violin tone, in which the strings are rubbed by rosined wheels [n]\n",
  "HARMONICIST": "one who plays a harmonica [n -S]\n",
  "HARMONICISTS": "HARMONICIST, one who plays a harmonica [n]\n",
  "HARMONICON": "a harmonica, also ARMONICA, HARMONICA [n -S]\n",
  "HARMONICONS": "HARMONICON, a harmonica, also ARMONICA, HARMONICA [n]\n",
  "HARMONICS": "HARMONIC, a musical tone with a frequency that is a multiple of the fundamental frequency [n]\n",
  "HARMONIES": "HARMONY, agreement [n]\n",
  "HARMONIOUS": "musically concordant [adj HARMONIOUSLY]\n",
  "HARMONIOUSLY": "HARMONIOUS, musically concordant [adv]\n",
  "HARMONIOUSNESS": "HARMONIOUS, musically concordant [n]\n",
  "HARMONIPHON": "a keyboard wind instrument with reeds, also HARMONIPHONE [n -S]\n",
  "HARMONIPHONE": "a keyboard wind instrument with reeds, also HARMONIPHON [n -S]\n",
  "HARMONIPHONES": "HARMONIPHONE, a keyboard wind instrument with reeds, also HARMONIPHON [n]\n",
  "HARMONIPHONS": "HARMONIPHON, a keyboard wind instrument with reeds, also HARMONIPHONE [n]\n",
  "HARMONISABLE": "that can be harmonised, also HARMONIZABLE [adj]\n",
  "HARMONISATION": "the act of harmonising, also HARMONIZATION [n -S]\n",
  "HARMONISATIONS": "HARMONISATION, the act of harmonising, also HARMONIZATION [n]\n",
  "HARMONISE": "to bring into harmony, also HARMONIZE [v HARMONISED, HARMONISING, HARMONISES]\n",
  "HARMONISED": "HARMONISE, to bring into harmony, also HARMONIZE [v]\n",
  "HARMONISER": "one who harmonises, also HARMONIZER [n -S]\n",
  "HARMONISERS": "HARMONISER, one who harmonises, also HARMONIZER [n]\n",
  "HARMONISES": "HARMONISE, to bring into harmony, also HARMONIZE [v]\n",
  "HARMONISING": "HARMONISE, to bring into harmony, also HARMONIZE [v]\n",
  "HARMONIST": "a person skilled in harmony [n -S]\n",
  "HARMONISTIC": "relating to harmony [adj HARMONISTICALLY]\n",
  "HARMONISTICALLY": "HARMONISTIC, relating to harmony [adv]\n",
  "HARMONISTS": "HARMONIST, a person skilled in harmony [n]\n",
  "HARMONIUM": "a keyboard instrument in which reeds are made to vibrate by air from a pedal-operated bellows [n -S]\n",
  "HARMONIUMIST": "one who plays the harmonium [n -S]\n",
  "HARMONIUMISTS": "HARMONIUMIST, one who plays the harmonium [n]\n",
  "HARMONIUMS": "HARMONIUM, a keyboard instrument in which reeds are made to vibrate by air from a pedal-operated bellows [n]\n",
  "HARMONIZABLE": "capable of being harmonized, also HARMONISABLE [adj]\n",
  "HARMONIZATION": "the act of harmonising, also HARMONISATION [n -S]\n",
  "HARMONIZATIONS": "HARMONIZATION, the act of harmonising, also HARMONISATION [n]\n",
  "HARMONIZE": "to bring into harmony, also HARMONISE [v HARMONIZED, HARMONIZING, HARMONIZES]\n",
  "HARMONIZED": "HARMONIZE, to bring into harmony, also HARMONISE [v]\n",
  "HARMONIZER": "one who harmonizes, also HARMONISER [n -S]\n",
  "HARMONIZERS": "HARMONIZER, one who harmonizes, also HARMONISER [n]\n",
  "HARMONIZES": "HARMONIZE, to bring into harmony, also HARMONISE [v]\n",
  "HARMONIZING": "HARMONIZE, to bring into harmony, also HARMONISE [v]\n",
  "HARMONOGRAM": "a curve drawn by a harmonograph [n -S]\n",
  "HARMONOGRAMS": "HARMONOGRAM, a curve drawn by a harmonograph [n]\n",
  "HARMONOGRAPH": "an instrument for drawing curves representing vibrations [n -S]\n",
  "HARMONOGRAPHS": "HARMONOGRAPH, an instrument for drawing curves representing vibrations [n]\n",
  "HARMONOMETER": "an instrument for measuring the harmonic relations of sounds [n -S]\n",
  "HARMONOMETERS": "HARMONOMETER, an instrument for measuring the harmonic relations of sounds [n]\n",
  "HARMONY": "agreement [n HARMONIES]\n",
  "HARMOST": "(Greek) a Spartan governor of a subject province [n -S]\n",
  "HARMOSTIES": "HARMOSTY, (Greek) the office of harmost, a Spartan governor of a subject city or province [n]\n",
  "HARMOSTS": "HARMOST, (Greek) a Spartan governor of a subject province [n]\n",
  "HARMOSTY": "(Greek) the office of harmost, a Spartan governor of a subject city or province [n HARMOSTIES]\n",
  "HARMOTOME": "a zeolite, a hydrated silicate of aluminium and barium [n -S]\n",
  "HARMOTOMES": "HARMOTOME, a zeolite, a hydrated silicate of aluminium and barium [n]\n",
  "HARMS": "HARM, to injure [v]\n",
  "HARN": "a coarse linen fabric [n -S]\n",
  "HARNESS": "to equip with gear [v -ED, -ING, -ES]\n",
  "HARNESSED": "HARNESS, to equip with gear [v]\n",
  "HARNESSER": "one who harnesses [n -S]\n",
  "HARNESSERS": "HARNESSER, one who harnesses [n]\n",
  "HARNESSES": "HARNESS, to equip with gear [v]\n",
  "HARNESSING": "HARNESS, to equip with gear [v]\n",
  "HARNESSLESS": "without a harness [adj]\n",
  "HARNS": "HARN, a coarse linen fabric [n]\n",
  "HARO": "in the Channel Islands, a cry announcing legal redress [n -S]\n",
  "HAROS": "HARO, in the Channel Islands, a cry announcing legal redress [n]\n",
  "HAROSET": "(Hebrew) a condiment of chopped apples, walnuts, and wine; recalls mortar made by Hebrew slaves in Egypt, also CHAROSET, CHAROSETH, HAROSETH [n -S]\n",
  "HAROSETH": "(Hebrew) a condiment of chopped apples, walnuts, and wine; recalls mortar made by Hebrew slaves in Egypt, also CHAROSET, CHAROSETH, HAROSET [n -S]\n",
  "HAROSETHS": "HAROSETH, (Hebrew) a condiment of chopped apples, walnuts, and wine; recalls mortar made by Hebrew slaves in Egypt, also CHAROSET, CHAROSETH, HAROSET [n]\n",
  "HAROSETS": "HAROSET, (Hebrew) a condiment of chopped apples, walnuts, and wine; recalls mortar made by Hebrew slaves in Egypt, also CHAROSET, CHAROSETH, HAROSETH [n]\n",
  "HARP": "to play on a type of stringed musical instrument [v -ED, -ING, -S]\n",
  "HARPED": "HARP, to play on a type of stringed musical instrument [v]\n",
  "HARPER": "one who plays the harp, also HARPIST [n -S]\n",
  "HARPERS": "HARPER, one who plays the harp, also HARPIST [n]\n",
  "HARPIES": "HARPY, a shrewish person [n]\n",
  "HARPIN": "a wooden plank used in shipbuilding, also HARPING [n -S]\n",
  "HARPING": "a wooden plank used in shipbuilding, also HARPIN [n -S]\n",
  "HARPINGS": "HARPING, a wooden plank used in shipbuilding, also HARPIN [n]\n",
  "HARPINS": "HARPIN, a wooden plank used in shipbuilding, also HARPING [n]\n",
  "HARPIST": "one who plays the harp, also HARPER [n -S]\n",
  "HARPISTS": "HARPIST, one who plays the harp, also HARPER [n]\n",
  "HARPOON": "to strike with a barbed spear [v -ED, -ING, -S]\n",
  "HARPOONED": "HARPOON, to strike with a barbed spear [v]\n",
  "HARPOONEER": "one who uses a harpoon, also HARPOONER [n -S]\n",
  "HARPOONEERS": "HARPOONEER, one who uses a harpoon, also HARPOONER [n]\n",
  "HARPOONER": "one who uses a harpoon, also HARPOONEER [n -S]\n",
  "HARPOONERS": "HARPOONER, one who uses a harpoon, also HARPOONEER [n]\n",
  "HARPOONING": "HARPOON, to strike with a barbed spear [v]\n",
  "HARPOONS": "HARPOON, to strike with a barbed spear [v]\n",
  "HARPS": "HARP, to play on a type of stringed musical instrument [v]\n",
  "HARPSICHORD": "a keyboard instrument with horizontal strings that run perpendicular to the keyboard in a long tapering case and are plucked by points of quill, leather, or plastic operated by depressing the keys [n -S]\n",
  "HARPSICHORDIST": "one who plays the harpsichord [n -S]\n",
  "HARPSICHORDISTS": "HARPSICHORDIST, one who plays the harpsichord [n]\n",
  "HARPSICHORDS": "HARPSICHORD, a keyboard instrument with horizontal strings that run perpendicular to the keyboard in a long tapering case and are plucked by points of quill, leather, or plastic operated by depressing the keys [n]\n",
  "HARPY": "a shrewish person [n HARPIES]\n",
  "HARPYLIKE": "like a harpy [adj]\n",
  "HARQUEBUS": "(historical) a portable long-barrelled gun, also ARQUEBUS, HARQUEBUSE, HARQUEBUSS [n -ES]\n",
  "HARQUEBUSE": "an early type of portable firearm; specifically one supported on a tripod by a hook or on a forked rest, also ARQUEBUS, HARQUEBUS, HARQUEBUSS [n -S]\n",
  "HARQUEBUSES": "HARQUEBUSE, an early type of portable firearm; specifically one supported on a tripod by a hook or on a forked rest, also ARQUEBUS, HARQUEBUS, HARQUEBUSS [n]\n",
  "HARQUEBUSIER": "a soldier armed with an arquebus [n -S]\n",
  "HARQUEBUSIERS": "HARQUEBUSIER, a soldier armed with an arquebus [n]\n",
  "HARQUEBUSS": "an early type of portable firearm; spec. one supported on a tripod by a hook or on a forked rest, also ARQUEBUS, HARQUEBUS, HARQUEBUSE [n -ES]\n",
  "HARQUEBUSSES": "HARQUEBUSS, an early type of portable firearm; spec. one supported on a tripod by a hook or on a forked rest, also ARQUEBUS, HARQUEBUS, HARQUEBUSE [n]\n",
  "HARRIDAN": "a sharp-tongued woman [n -S]\n",
  "HARRIDANS": "HARRIDAN, a sharp-tongued woman [n]\n",
  "HARRIED": "HARRY, to plunder, ravage [v]\n",
  "HARRIER": "a medium-sized scenting dog for hunting hares [n -S]\n",
  "HARRIERS": "HARRIER, a medium-sized scenting dog for hunting hares [n]\n",
  "HARRIES": "HARRY, to plunder, ravage [v]\n",
  "HARROW": "to break up and level soil [v -ED, -ING, -S]\n",
  "HARROWED": "HARROW, to break up and level soil [v]\n",
  "HARROWER": "one that harrows [n -S]\n",
  "HARROWERS": "HARROWER, one that harrows [n]\n",
  "HARROWING": "acutely distressing [adj HARROWINGLY] / the act of causing acute distress [n -S]\n",
  "HARROWINGLY": "HARROWING, acutely distressing [adv]\n",
  "HARROWINGS": "HARROWING, the act of causing acute distress [n]\n",
  "HARROWMENT": "the act of harrowing (the soil) [n -S]\n",
  "HARROWMENTS": "HARROWMENT, the act of harrowing (the soil) [n]\n",
  "HARROWS": "HARROW, to break up and level soil [v]\n",
  "HARRUMPH": "to clear one's throat noisily in annoyance, also HARUMPH [v -ED, -ING, -S]\n",
  "HARRUMPHED": "HARRUMPH, to clear one's throat noisily in annoyance, also HARUMPH [v]\n",
  "HARRUMPHING": "HARRUMPH, to clear one's throat noisily in annoyance, also HARUMPH [v]\n",
  "HARRUMPHS": "HARRUMPH, to clear one's throat noisily in annoyance, also HARUMPH [v]\n",
  "HARRY": "to plunder, ravage [v HARRIED, HARRYING, HARRIES]\n",
  "HARRYING": "HARRY, to plunder, ravage [v]\n",
  "HARSH": "severe [adj HARSHER, HARSHEST, HARSHLY] / to cause (a state of elation) to be diminished or ended [v -ED, -ING, -ES]\n",
  "HARSHED": "HARSH, to cause (a state of elation) to be diminished or ended [v]\n",
  "HARSHEN": "to make harsh [v -ED, -ING, -S]\n",
  "HARSHENED": "HARSHEN, to make harsh [v]\n",
  "HARSHENING": "HARSHEN, to make harsh [v]\n",
  "HARSHENS": "HARSHEN, to make harsh [v]\n",
  "HARSHER": "HARSH, severe [adj]\n",
  "HARSHES": "HARSH, to cause (a state of elation) to be diminished or ended [v]\n",
  "HARSHEST": "HARSH, severe [adj]\n",
  "HARSHING": "HARSH, to cause (a state of elation) to be diminished or ended [v]\n",
  "HARSHLY": "HARSH, severe [adv]\n",
  "HARSHNESS": "the state of being harsh [n -ES]\n",
  "HARSHNESSES": "HARSHNESS, the state of being harsh [n]\n",
  "HARSLET": "a pressed meat made from pig offal, also HASLET [n -S]\n",
  "HARSLETS": "HARSLET, a pressed meat made from pig offal, also HASLET [n]\n",
  "HART": "the male of the red deer esp. when over five years old [n -S]\n",
  "HARTAL": "(Hindi) in India, a general strike [n -S]\n",
  "HARTALS": "HARTAL, (Hindi) in India, a general strike [n]\n",
  "HARTBEES": "(South African) a large South African antelope, also HARTBEEST, HARTEBEEST [n -ES]\n",
  "HARTBEESES": "HARTBEES, (South African) a large South African antelope, also HARTBEEST, HARTEBEEST [n]\n",
  "HARTBEEST": "(South African) a large South African antelope, also HARTBEES, HARTEBEEST [n -S]\n",
  "HARTBEESTS": "HARTBEEST, (South African) a large South African antelope, also HARTBEES, HARTEBEEST [n]\n",
  "HARTEBEEST": "(South African) a large South African antelope, also HARTBEES, HARTBEEST [n -S]\n",
  "HARTEBEESTS": "HARTEBEEST, (South African) a large South African antelope, also HARTBEES, HARTBEEST [n]\n",
  "HARTELY": "(Spenser) heartily, also HEARTILY, HEARTLY [adv]\n",
  "HARTEN": "(Spenser) to give courage to, also HEARTEN [v -ED, -ING, -S]\n",
  "HARTENED": "HARTEN, (Spenser) to give courage to, also HEARTEN [v]\n",
  "HARTENING": "HARTEN, (Spenser) to give courage to, also HEARTEN [v]\n",
  "HARTENS": "HARTEN, (Spenser) to give courage to, also HEARTEN [v]\n",
  "HARTLESSE": "(Spenser) heartless [adj]\n",
  "HARTS": "HART, the male of the red deer esp. when over five years old [n]\n",
  "HARTSHORN": "the horn or antler of a hart; the substance obtained by rasping, slicing, or calcining this, formerly the chief source of ammonia [n -S]\n",
  "HARTSHORNS": "HARTSHORN, the horn or antler of a hart; the substance obtained by rasping, slicing, or calcining this, formerly the chief source of ammonia [n]\n",
  "HARUMPH": "to clear one's throat noisily in annoyance, also HARRUMPH [v -ED, -ING, -S]\n",
  "HARUMPHED": "HARUMPH, to clear one's throat noisily in annoyance, also HARRUMPH [v]\n",
  "HARUMPHING": "HARUMPH, to clear one's throat noisily in annoyance, also HARRUMPH [v]\n",
  "HARUMPHS": "HARUMPH, to clear one's throat noisily in annoyance, also HARRUMPH [v]\n",
  "HARUSPEX": "(Latin) a soothsayer of ancient Rome, also ARUSPEX [n HARUSPICES]\n",
  "HARUSPICAL": "relating to haruspication, divination by the liver [adj]\n",
  "HARUSPICATE": "to foretell by inspection of animals' entrails [v HARUSPICATED, HARUSPICATING, HARUSPICATES]\n",
  "HARUSPICATED": "HARUSPICATE, to foretell by inspection of animals' entrails [v]\n",
  "HARUSPICATES": "HARUSPICATE, to foretell by inspection of animals' entrails [v]\n",
  "HARUSPICATING": "HARUSPICATE, to foretell by inspection of animals' entrails [v]\n",
  "HARUSPICATION": "divination by inspecting animal entrails [n -S]\n",
  "HARUSPICATIONS": "HARUSPICATION, divination by inspecting animal entrails [n]\n",
  "HARUSPICES": "HARUSPEX, (Latin) a soothsayer of ancient Rome, also ARUSPEX [n]\n",
  "HARUSPICIES": "HARUSPICY, divination by inspection of the entrails of sacrificed animals [n]\n",
  "HARUSPICY": "divination by inspection of the entrails of sacrificed animals [n HARUSPICIES]\n",
  "HARVEST": "to gather in a crop, also HAIRST [v -ED, -ING, -S]\n",
  "HARVESTABLE": "that can be harvested [adj]\n",
  "HARVESTED": "HARVEST, to gather in a crop, also HAIRST [v]\n",
  "HARVESTER": "any member of the Opiliones, a class of Arachnida with very long legs, also HARVESTMAN [n -S]\n",
  "HARVESTERS": "HARVESTER, any member of the Opiliones, a class of Arachnida with very long legs, also HARVESTMAN [n]\n",
  "HARVESTING": "the act of gathering in a cop [n -S]\n",
  "HARVESTINGS": "HARVESTING, the act of gathering in a cop [n]\n",
  "HARVESTLESS": "without a harvest [adj]\n",
  "HARVESTMAN": "any member of the Opiliones, a class of Arachnida with very long legs, also HARVESTER [n HARVESTMEN]\n",
  "HARVESTMEN": "HARVESTMAN, any member of the Opiliones, a class of Arachnida with very long legs, also HARVESTER [n]\n",
  "HARVESTS": "HARVEST, to gather in a crop, also HAIRST [v]\n",
  "HARVESTTIME": "the time during which an annual crop is harvested [n -S]\n",
  "HARVESTTIMES": "HARVESTTIME, the time during which an annual crop is harvested [n]\n",
  "HAS": "HAVE, to possess [v]\n",
  "HASBIAN": "a former lesbian who has changed her sexual orientation [n -S]\n",
  "HASBIANS": "HASBIAN, a former lesbian who has changed her sexual orientation [n]\n",
  "HASENPFEFFER": "(German) a well seasoned rabbit stew [n -S]\n",
  "HASENPFEFFERS": "HASENPFEFFER, (German) a well seasoned rabbit stew [n]\n",
  "HASH": "a mixed dish of meat and vegetables in small pieces [n -ES] / to make a hash [v -ED, -ING, -ES]\n",
  "HASHED": "HASH, to make a hash [v]\n",
  "HASHEESH": "(Arabic) the leaves, shoots and resin of hemp, smoked as an intoxicant, also HASHISH [n -ES]\n",
  "HASHEESHES": "HASHEESH, (Arabic) the leaves, shoots and resin of hemp, smoked as an intoxicant, also HASHISH [n]\n",
  "HASHES": "HASH, to make a hash [v]\n",
  "HASHHEAD": "a hashish addict [n -S]\n",
  "HASHHEADS": "HASHHEAD, a hashish addict [n]\n",
  "HASHIER": "HASHY, thrown together in a mess [adj]\n",
  "HASHIEST": "HASHY, thrown together in a mess [adj]\n",
  "HASHING": "the process of converting items of data into numbers (hash totals) which are then used as index numbers [n -S]\n",
  "HASHINGS": "HASHING, the process of converting items of data into numbers (hash totals) which are then used as index numbers [n]\n",
  "HASHISH": "(Arabic) the leaves, shoots and resin of hemp, smoked as an intoxicant, also HASHEESH [n -ES]\n",
  "HASHISHES": "HASHISH, (Arabic) the leaves, shoots and resin of hemp, smoked as an intoxicant, also HASHEESH [n]\n",
  "HASHMARK": "a proofreading symbol # [n -S]\n",
  "HASHMARKS": "HASHMARK, a proofreading symbol # [n]\n",
  "HASHTAG": "a word or name preceded by a hash symbol used to indicate the contents of a message on a social media site [n -S]\n",
  "HASHTAGS": "HASHTAG, a word or name preceded by a hash symbol used to indicate the contents of a message on a social media site [n]\n",
  "HASHY": "thrown together in a mess [adj HASHIER, HASHIEST]\n",
  "HASK": "(Spenser) a fish-basket [n -S]\n",
  "HASKS": "HASK, (Spenser) a fish-basket [n]\n",
  "HASLET": "a pressed meat made from pig offal, also HARSLET [n -S]\n",
  "HASLETS": "HASLET, a pressed meat made from pig offal, also HARSLET [n]\n",
  "HASP": "to fasten with a clasp, also HESP [v -ED, -ING, -S]\n",
  "HASPED": "HASP, to fasten with a clasp, also HESP [v]\n",
  "HASPING": "HASP, to fasten with a clasp, also HESP [v]\n",
  "HASPS": "HASP, to fasten with a clasp, also HESP [v]\n",
  "HASS": "as in white hass, an oatmeal pudding made with sheep's gullet [n -ES]\n",
  "HASSAR": "a kind of South American catfish [n -S]\n",
  "HASSARS": "HASSAR, a kind of South American catfish [n]\n",
  "HASSEL": "an argument, also HASSLE [n -S]\n",
  "HASSELS": "HASSEL, an argument, also HASSLE [n]\n",
  "HASSES": "HASS, as in white hass, an oatmeal pudding made with sheep's gullet [n]\n",
  "HASSIUM": "a radioactive element synthetically produced by high-energy ion bombardment [n -S]\n",
  "HASSIUMS": "HASSIUM, a radioactive element synthetically produced by high-energy ion bombardment [n]\n",
  "HASSLE": "to harass [v HASSLED, HASSLING, HASSLES]\n",
  "HASSLED": "HASSLE, to harass [v]\n",
  "HASSLES": "HASSLE, to harass [v]\n",
  "HASSLING": "HASSLE, to harass [v]\n",
  "HASSOCK": "a kneeling cushion in a church [n -S]\n",
  "HASSOCKIER": "HASSOCKY, soft and cushiony [adj]\n",
  "HASSOCKIEST": "HASSOCKY, soft and cushiony [adj]\n",
  "HASSOCKS": "HASSOCK, a kneeling cushion in a church [n]\n",
  "HASSOCKY": "soft and cushiony [adj HASSOCKIER, HASSOCKIEST]\n",
  "HAST": "(archaic) 2nd person singular of have, to possess [v]\n",
  "HASTA": "(Spanish) until [prep]\n",
  "HASTATE": "spear-shaped, also HASTATED [adj HASTATELY]\n",
  "HASTATED": "spear-shaped, also HASTATE [adj]\n",
  "HASTATELY": "HASTATE, spear-shaped, also HASTATED [adv]\n",
  "HASTE": "to hurry, also HASTEN [v HASTED, HASTING, HASTES]\n",
  "HASTED": "HASTE, to hurry, also HASTEN [v]\n",
  "HASTEFUL": "hasty, hurried [adj HASTEFULLY]\n",
  "HASTEFULLY": "HASTEFUL, hasty, hurried [adv]\n",
  "HASTEN": "to hurry, also HASTE [v -ED, -ING, -S]\n",
  "HASTENED": "HASTEN, to hurry, also HASTE [v]\n",
  "HASTENER": "one who hastens [n -S]\n",
  "HASTENERS": "HASTENER, one who hastens [n]\n",
  "HASTENING": "HASTEN, to hurry, also HASTE [v]\n",
  "HASTENS": "HASTEN, to hurry, also HASTE [v]\n",
  "HASTES": "HASTE, to hurry, also HASTEN [v]\n",
  "HASTIER": "HASTY, speedy [adj]\n",
  "HASTIEST": "HASTY, speedy [adj]\n",
  "HASTILY": "HASTY, speedy [adv]\n",
  "HASTINESS": "the state of being hasty [n -ES]\n",
  "HASTINESSES": "HASTINESS, the state of being hasty [n]\n",
  "HASTING": "HASTE, to hurry, also HASTEN [v]\n",
  "HASTINGS": "(dialect) early fruit or vegetables, esp. peas [n]\n",
  "HASTY": "speedy [adj HASTIER, HASTIEST, HASTILY]\n",
  "HAT": "to provide with a covering for the head [v HATTED, HATTING, HATS]\n",
  "HATABLE": "capable of being, or deserving to be, hated, also HATEABLE [adj]\n",
  "HATBAND": "a band worn on a hat [n -S]\n",
  "HATBANDS": "HATBAND, a band worn on a hat [n]\n",
  "HATBOX": "a box for a hat [n -ES]\n",
  "HATBOXES": "HATBOX, a box for a hat [n]\n",
  "HATBRUSH": "a brush for cleaning hats [n -ES]\n",
  "HATBRUSHES": "HATBRUSH, a brush for cleaning hats [n]\n",
  "HATCH": "to bring forth young from an egg [v -ED, -ING, -ES]\n",
  "HATCHABILITIES": "HATCHABILITY, the capacity for being hatched [n]\n",
  "HATCHABILITY": "the capacity for being hatched [n HATCHABILITIES]\n",
  "HATCHABLE": "that can be hatched [adj]\n",
  "HATCHBACK": "a car with a certain type of liftable back [n -S]\n",
  "HATCHBACKS": "HATCHBACK, a car with a certain type of liftable back [n]\n",
  "HATCHECK": "the receiving of hats for safekeeping [n -S]\n",
  "HATCHECKS": "HATCHECK, the receiving of hats for safekeeping [n]\n",
  "HATCHED": "HATCH, to bring forth young from an egg [v]\n",
  "HATCHEL": "to separate flax fibres with a comb, also HACKLE, HECKLE [v HATCHELED or HATCHELLED, HATCHELING or HATCHELLING, HATCHELS]\n",
  "HATCHELED": "HATCHEL, to separate flax fibres with a comb, also HACKLE, HECKLE [v]\n",
  "HATCHELING": "HATCHEL, to separate flax fibres with a comb, also HACKLE, HECKLE [v]\n",
  "HATCHELLED": "HATCHEL, to separate flax fibres with a comb, also HACKLE, HECKLE [v]\n",
  "HATCHELLER": "a flax-dresser [n -S]\n",
  "HATCHELLERS": "HATCHELLER, a flax-dresser [n]\n",
  "HATCHELLING": "HATCHEL, to separate flax fibres with a comb, also HACKLE, HECKLE [v]\n",
  "HATCHELS": "HATCHEL, to separate flax fibres with a comb, also HACKLE, HECKLE [v]\n",
  "HATCHER": "one who hatches [n -S]\n",
  "HATCHERIES": "HATCHERY, a place for hatching eggs [n]\n",
  "HATCHERS": "HATCHER, one who hatches [n]\n",
  "HATCHERY": "a place for hatching eggs [n HATCHERIES]\n",
  "HATCHES": "HATCH, to bring forth young from an egg [v]\n",
  "HATCHET": "a small axe for use in one hand [n -S]\n",
  "HATCHETIER": "HATCHETY, like a hatchet [adj]\n",
  "HATCHETIEST": "HATCHETY, like a hatchet [adj]\n",
  "HATCHETS": "HATCHET, a small axe for use in one hand [n]\n",
  "HATCHETTITE": "naturally occurring paraffin wax or mineral tallow [n -S]\n",
  "HATCHETTITES": "HATCHETTITE, naturally occurring paraffin wax or mineral tallow [n]\n",
  "HATCHETY": "like a hatchet [adj HATCHETIER, HATCHETIEST]\n",
  "HATCHING": "shading in fine lines [n -S]\n",
  "HATCHINGS": "HATCHING, shading in fine lines [n]\n",
  "HATCHLING": "a creature just hatched [n -S]\n",
  "HATCHLINGS": "HATCHLING, a creature just hatched [n]\n",
  "HATCHMENT": "a diamond-shaped escutcheon bearing a deceased person's arms [n -S]\n",
  "HATCHMENTS": "HATCHMENT, a diamond-shaped escutcheon bearing a deceased person's arms [n]\n",
  "HATCHWAY": "an opening in the deck of a ship [n -S]\n",
  "HATCHWAYS": "HATCHWAY, an opening in the deck of a ship [n]\n",
  "HATE": "to loathe [v HATED, HATING, HATES]\n",
  "HATEABLE": "capable of being, or deserving to be, hated, also HATABLE [adj]\n",
  "HATED": "HATE, to loathe [v]\n",
  "HATEFUL": "detestable [adj HATEFULLY]\n",
  "HATEFULLY": "HATEFUL, detestable [adv]\n",
  "HATEFULNESS": "the state of being hateful [n -ES]\n",
  "HATEFULNESSES": "HATEFULNESS, the state of being hateful [n]\n",
  "HATELESS": "not hating [adj]\n",
  "HATELESSNESS": "the state of being hateless [n -ES]\n",
  "HATELESSNESSES": "HATELESSNESS, the state of being hateless [n]\n",
  "HATER": "one who hates [n -S]\n",
  "HATERENT": "(Scots) hatred [n -S]\n",
  "HATERENTS": "HATERENT, (Scots) hatred [n]\n",
  "HATERS": "HATER, one who hates [n]\n",
  "HATES": "HATE, to loathe [v]\n",
  "HATEWORTHIER": "HATEWORTHY, worthy of hate [adj]\n",
  "HATEWORTHIEST": "HATEWORTHY, worthy of hate [adj]\n",
  "HATEWORTHY": "worthy of hate [adj HATEWORTHIER, HATEWORTHIEST]\n",
  "HATFUL": "as much as a hat can hold [n HATFULS or HATSFUL]\n",
  "HATFULS": "HATFUL, as much as a hat can hold [n]\n",
  "HATGUARD": "a string for keeping a hat from being blown away [n -S]\n",
  "HATGUARDS": "HATGUARD, a string for keeping a hat from being blown away [n]\n",
  "HATH": "(archaic) 3rd person singular of have, to possess [v]\n",
  "HATHA": "(Sanskrit) as in hatha yoga, a form of yoga [adj]\n",
  "HATINATOR": "a small decorative hat, worn on social occasions [n -S]\n",
  "HATINATORS": "HATINATOR, a small decorative hat, worn on social occasions [n]\n",
  "HATING": "HATE, to loathe [v]\n",
  "HATLESS": "without a hat [adj]\n",
  "HATLESSNESS": "the state of being without a hat [n -ES]\n",
  "HATLESSNESSES": "HATLESSNESS, the state of being without a hat [n]\n",
  "HATLIKE": "resembling a hat [adj]\n",
  "HATMAKER": "one that makes hats [n -S]\n",
  "HATMAKERS": "HATMAKER, one that makes hats [n]\n",
  "HATPEG": "a peg on which to hang a hat [n -S]\n",
  "HATPEGS": "HATPEG, a peg on which to hang a hat [n]\n",
  "HATPIN": "a pin for securing a hat [n -S]\n",
  "HATPINS": "HATPIN, a pin for securing a hat [n]\n",
  "HATRACK": "a board with pegs for hanging hats on [n -S]\n",
  "HATRACKS": "HATRACK, a board with pegs for hanging hats on [n]\n",
  "HATRED": "an intense dislike or aversion [n -S]\n",
  "HATREDS": "HATRED, an intense dislike or aversion [n]\n",
  "HATS": "HAT, to provide with a covering for the head [v]\n",
  "HATSFUL": "HATFUL, as much as a hat can hold [n]\n",
  "HATSTAND": "a stand on which to hang hats [n -S]\n",
  "HATSTANDS": "HATSTAND, a stand on which to hang hats [n]\n",
  "HATTED": "HAT, to provide with a covering for the head [v]\n",
  "HATTER": "to trouble, annoy [v -ED, -ING, -S]\n",
  "HATTERED": "HATTER, to trouble, annoy [v]\n",
  "HATTERIA": "a kind of New Zealand lizard, aka sphenodon or tuatera [n -S]\n",
  "HATTERIAS": "HATTERIA, a kind of New Zealand lizard, aka sphenodon or tuatera [n]\n",
  "HATTERING": "HATTER, to trouble, annoy [v]\n",
  "HATTERS": "HATTER, to trouble, annoy [v]\n",
  "HATTING": "material for hats [n -S]\n",
  "HATTINGS": "HATTING, material for hats [n]\n",
  "HATTOCK": "(Scots) a little hat [n -S]\n",
  "HATTOCKS": "HATTOCK, (Scots) a little hat [n]\n",
  "HAUBERGEON": "a sleeveless mail coat, shorter than a hauberk, also HABERGEON [n -S]\n",
  "HAUBERGEONS": "HAUBERGEON, a sleeveless mail coat, shorter than a hauberk, also HABERGEON [n]\n",
  "HAUBERK": "a tunic-like coat of mail [n -S]\n",
  "HAUBERKS": "HAUBERK, a tunic-like coat of mail [n]\n",
  "HAUBOIS": "a large kind of strawberry, also HAUTBOIS, HAUTBOY [n HAUBOIS]\n",
  "HAUD": "(Scots) to hold [v HELD or HUDDEN, HAUDING, HAUDS]\n",
  "HAUDING": "HAUD, (Scots) to hold [v]\n",
  "HAUDS": "HAUD, (Scots) to hold [v]\n",
  "HAUF": "(Scots) half [n -S]\n",
  "HAUFS": "HAUF, (Scots) half [n]\n",
  "HAUGH": "(Scots) a low-lying meadow by the side of a river [n -S]\n",
  "HAUGHS": "HAUGH, (Scots) a low-lying meadow by the side of a river [n]\n",
  "HAUGHT": "(Shakespeare) haughty, exalted, also HAULT, HAUT [adj]\n",
  "HAUGHTIER": "HAUGHTY, arrogant [adj]\n",
  "HAUGHTIEST": "HAUGHTY, arrogant [adj]\n",
  "HAUGHTILY": "HAUGHTY, arrogant [adv]\n",
  "HAUGHTINESS": "the state of being haughty [n -ES]\n",
  "HAUGHTINESSES": "HAUGHTINESS, the state of being haughty [n]\n",
  "HAUGHTY": "arrogant [adj HAUGHTIER, HAUGHTIEST, HAUGHTILY]\n",
  "HAUL": "to pull with force [v -ED, -ING, -S]\n",
  "HAULAGE": "the act of hauling [n -S]\n",
  "HAULAGES": "HAULAGE, the act of hauling [n]\n",
  "HAULBACK": "a line for drawing a cable back [n -S]\n",
  "HAULBACKS": "HAULBACK, a line for drawing a cable back [n]\n",
  "HAULD": "(Scots) tenancy, as in out of house and hauld i.e. homeless [n -S]\n",
  "HAULDS": "HAULD, (Scots) tenancy, as in out of house and hauld i.e. homeless [n]\n",
  "HAULED": "HAUL, to pull with force [v]\n",
  "HAULER": "one who hauls [n -S]\n",
  "HAULERS": "HAULER, one who hauls [n]\n",
  "HAULIER": "a person or firm employed in transporting goods, esp. by road [n -S]\n",
  "HAULIERS": "HAULIER, a person or firm employed in transporting goods, esp. by road [n]\n",
  "HAULING": "the act of dragging [n -S]\n",
  "HAULINGS": "HAULING, the act of dragging [n]\n",
  "HAULM": "a plant stem, also HALM [n -S]\n",
  "HAULMIER": "HAULMY, of or like haulms, stems [adj]\n",
  "HAULMIEST": "HAULMY, of or like haulms, stems [adj]\n",
  "HAULMS": "HAULM, a plant stem, also HALM [n]\n",
  "HAULMY": "of or like haulms, stems [adj HAULMIER, HAULMIEST]\n",
  "HAULOUT": "the action of hauling a boat out of water [n -S]\n",
  "HAULOUTS": "HAULOUT, the action of hauling a boat out of water [n]\n",
  "HAULS": "HAUL, to pull with force [v]\n",
  "HAULST": "HALSE, (Spenser) to embrace, also HAUSE, HAWSE [v]\n",
  "HAULT": "(Shakespeare) haughty, exalted, also HAUGHT, HAUT [adj]\n",
  "HAULYARD": "a line used to hoist a sail, also HALYARD, HALLIARD [n -S]\n",
  "HAULYARDS": "HAULYARD, a line used to hoist a sail, also HALYARD, HALLIARD [n]\n",
  "HAUN": "(Scots) a hand [n -S]\n",
  "HAUNCH": "to throw with an underhand motion, also HAINCH [v -ED, -ING, -ES]\n",
  "HAUNCHED": "HAUNCH, to throw with an underhand motion, also HAINCH [v]\n",
  "HAUNCHES": "HAUNCH, to throw with an underhand motion, also HAINCH [v]\n",
  "HAUNCHING": "HAUNCH, to throw with an underhand motion, also HAINCH [v]\n",
  "HAUNS": "HAUN, (Scots) a hand [n]\n",
  "HAUNT": "to visit frequently [v -ED, -ING, -S]\n",
  "HAUNTED": "HAUNT, to visit frequently [v]\n",
  "HAUNTER": "one who haunts [n -S]\n",
  "HAUNTERS": "HAUNTER, one who haunts [n]\n",
  "HAUNTING": "making a moving and lasting impression [adj HAUNTINGLY] / the act of haunting [n -S]\n",
  "HAUNTINGLY": "HAUNTING, making a moving and lasting impression [adv]\n",
  "HAUNTINGS": "HAUNTING, the act of haunting [n]\n",
  "HAUNTS": "HAUNT, to visit frequently [v]\n",
  "HAURIANT": "in heraldry, with head up, as rising to the surface to breathe, also HAURIENT [adj]\n",
  "HAURIENT": "in heraldry, with head up, as rising to the surface to breathe, also HAURIANT [adj]\n",
  "HAUSE": "(archaic) to embrace, also HALSE, HAWSE [v HAUSED, HAUSING, HAUSES]\n",
  "HAUSED": "HAUSE, (archaic) to embrace, also HALSE, HAWSE [v]\n",
  "HAUSEN": "(German) a large sturgeon from the region of the Black Sea, aka beluga [n -S]\n",
  "HAUSENS": "HAUSEN, (German) a large sturgeon from the region of the Black Sea, aka beluga [n]\n",
  "HAUSES": "HAUSE, (archaic) to embrace, also HALSE, HAWSE [v]\n",
  "HAUSFRAU": "(German) housewife [n HAUSFRAUS or HAUSFRAUEN]\n",
  "HAUSFRAUEN": "HAUSFRAU, (German) housewife [n]\n",
  "HAUSFRAUS": "HAUSFRAU, (German) housewife [n]\n",
  "HAUSING": "HAUSE, (archaic) to embrace, also HALSE, HAWSE [v]\n",
  "HAUSSMANNISE": "to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNIZE [v HAUSSMANNISED, HAUSSMANNISING, HAUSSMANNISES]\n",
  "HAUSSMANNISED": "HAUSSMANNISE, to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNIZE [v]\n",
  "HAUSSMANNISES": "HAUSSMANNISE, to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNIZE [v]\n",
  "HAUSSMANNISING": "HAUSSMANNISE, to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNIZE [v]\n",
  "HAUSSMANNIZE": "to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNISE [v HAUSSMANNIZED, HAUSSMANNIZING, HAUSSMANNIZES]\n",
  "HAUSSMANNIZED": "HAUSSMANNIZE, to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNISE [v]\n",
  "HAUSSMANNIZES": "HAUSSMANNIZE, to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNISE [v]\n",
  "HAUSSMANNIZING": "HAUSSMANNIZE, to open out, generally to rebuild, as Baron Haussmann did in Paris as prefect of the Seine (1853-70), also HAUSSMANNISE [v]\n",
  "HAUSTELLA": "HAUSTELLUM, the sucking organ or proboscis of an insect or crustacean [n]\n",
  "HAUSTELLATE": "having a haustellum, a proboscis, as a fly [adj]\n",
  "HAUSTELLUM": "the sucking organ or proboscis of an insect or crustacean [n HAUSTELLA]\n",
  "HAUSTORIA": "HAUSTORIUM, (Latin) one of the sucker-like rootlets of such plants as the dodder and ivy [n]\n",
  "HAUSTORIAL": "having a haustorium, a sucker-like rootlet [adj]\n",
  "HAUSTORIUM": "(Latin) one of the sucker-like rootlets of such plants as the dodder and ivy [n HAUSTORIA]\n",
  "HAUT": "(French) high; (Shakespeare) haughty, exalted, also HAUGHT, HAULT [adj HAUTER, HAUTEST]\n",
  "HAUTBOIS": "(French) a large kind of strawberry, also HAUBOIS, HAUTBOY [n]\n",
  "HAUTBOY": "(archaic) an old name for oboe [n -S]\n",
  "HAUTBOYS": "HAUTBOY, (archaic) an old name for oboe [n]\n",
  "HAUTE": "(French) feminine of haut, haughty, high [adj]\n",
  "HAUTER": "HAUT, (French) high; (Shakespeare) haughty, exalted, also HAUGHT, HAULT [adj]\n",
  "HAUTEST": "HAUT, (French) high; (Shakespeare) haughty, exalted, also HAUGHT, HAULT [adj]\n",
  "HAUTEUR": "(French) haughtiness; arrogance [n -S]\n",
  "HAUTEURS": "HAUTEUR, (French) haughtiness; arrogance [n]\n",
  "HAUYNE": "a blue mineral, found in lapis lazuli [n -S]\n",
  "HAUYNES": "HAUYNE, a blue mineral, found in lapis lazuli [n]\n",
  "HAVARTI": "(Danish) a semisoft Danish cheese [n -S]\n",
  "HAVARTIS": "HAVARTI, (Danish) a semisoft Danish cheese [n]\n",
  "HAVDALAH": "(Hebrew) a Jewish ceremony or prayer that marks the end of the Sabbath, also HABDALAH, HAVDOLOH [n -S]\n",
  "HAVDALAHS": "HAVDALAH, (Hebrew) a Jewish ceremony or prayer that marks the end of the Sabbath, also HABDALAH, HAVDOLOH [n]\n",
  "HAVDOLOH": "(Hebrew) a Jewish ceremony or prayer that marks the end of the Sabbath, also HABDALAH, HAVDALAH [n -S]\n",
  "HAVDOLOHS": "HAVDOLOH, (Hebrew) a Jewish ceremony or prayer that marks the end of the Sabbath, also HABDALAH, HAVDALAH [n]\n",
  "HAVE": "to possess [v HAD, HADST, HADDEST, HAVING, HAS, HAST, HATH] / a wealthy person [n -S]\n",
  "HAVELOCK": "a cloth hanging from back of a soldier's cap as protection against sun [n -S]\n",
  "HAVELOCKS": "HAVELOCK, a cloth hanging from back of a soldier's cap as protection against sun [n]\n",
  "HAVEN": "to shelter [v -ED, -ING, -S]\n",
  "HAVENED": "HAVEN, to shelter [v]\n",
  "HAVENING": "HAVEN, to shelter [v]\n",
  "HAVENLESS": "without a haven [adj]\n",
  "HAVENS": "HAVEN, to shelter [v]\n",
  "HAVEOUR": "(obsolete) behaviour, demeanour, also HAVIOR, HAVIOUR [n -S]\n",
  "HAVEOURS": "HAVEOUR, (obsolete) behaviour, demeanour, also HAVIOR, HAVIOUR [n]\n",
  "HAVER": "to hem and haw [v -ED, -ING, -S]\n",
  "HAVERED": "HAVER, to hem and haw [v]\n",
  "HAVEREL": "(Scots) a foolish person [n -S]\n",
  "HAVERELS": "HAVEREL, (Scots) a foolish person [n]\n",
  "HAVERING": "nonsensical talk [n -S]\n",
  "HAVERINGS": "HAVERING, nonsensical talk [n]\n",
  "HAVERS": "HAVER, to hem and haw [v]\n",
  "HAVERSACK": "a bag worn over the shoulder for carrying provisions [n -S]\n",
  "HAVERSACKS": "HAVERSACK, a bag worn over the shoulder for carrying provisions [n]\n",
  "HAVERSINE": "half the versed sine of an angle [n -S]\n",
  "HAVERSINES": "HAVERSINE, half the versed sine of an angle [n]\n",
  "HAVES": "HAVE, a wealthy person [n]\n",
  "HAVILDAR": "(Urdu) the rank of sergeant in the Indian army [n -S]\n",
  "HAVILDARS": "HAVILDAR, (Urdu) the rank of sergeant in the Indian army [n]\n",
  "HAVING": "possession [n -S]\n",
  "HAVINGS": "HAVING, possession [n]\n",
  "HAVIOR": "(obsolete) behavior, demeanor, also HAVEOUR, HAVIOUR [n -S]\n",
  "HAVIORS": "HAVIOR, (obsolete) behavior, demeanor, also HAVEOUR, HAVIOUR [n]\n",
  "HAVIOUR": "(obsolete) behaviour, demeanour, also HAVEOUR, HAVIOR [n -S]\n",
  "HAVIOURS": "HAVIOUR, (obsolete) behaviour, demeanour, also HAVEOUR, HAVIOR [n]\n",
  "HAVOC": "to lay waste [v HAVOCKED, HAVOCKING, HAVOCS]\n",
  "HAVOCKED": "HAVOC, to lay waste [v]\n",
  "HAVOCKER": "one who wreaks havoc [n -S]\n",
  "HAVOCKERS": "HAVOCKER, one who wreaks havoc [n]\n",
  "HAVOCKING": "HAVOC, to lay waste [v]\n",
  "HAVOCS": "HAVOC, to lay waste [v]\n",
  "HAW": "to make indecisive noises [v -ED, -ING, -S]\n",
  "HAWALA": "(Arabic) a type of financial arrangement in Islamic societies [n -S]\n",
  "HAWALAS": "HAWALA, (Arabic) a type of financial arrangement in Islamic societies [n]\n",
  "HAWBUCK": "a bumpkin [n -S]\n",
  "HAWBUCKS": "HAWBUCK, a bumpkin [n]\n",
  "HAWEATER": "a resident of Manitoulin Island, Ontario [n -S]\n",
  "HAWEATERS": "HAWEATER, a resident of Manitoulin Island, Ontario [n]\n",
  "HAWED": "HAW, to make indecisive noises [v]\n",
  "HAWFINCH": "a Eurasian finch [n -ES]\n",
  "HAWFINCHES": "HAWFINCH, a Eurasian finch [n]\n",
  "HAWING": "HAW, to make indecisive noises [v]\n",
  "HAWK": "to peddle [v -ED, -ING, -S]\n",
  "HAWKBELL": "a small bell attached to a hawk's leg [n -S]\n",
  "HAWKBELLS": "HAWKBELL, a small bell attached to a hawk's leg [n]\n",
  "HAWKBILL": "a kind of sea turtle, also HAWKSBILL [n -S]\n",
  "HAWKBILLS": "HAWKBILL, a kind of sea turtle, also HAWKSBILL [n]\n",
  "HAWKBIT": "a flower of the dandelion family [n -S]\n",
  "HAWKBITS": "HAWKBIT, a flower of the dandelion family [n]\n",
  "HAWKED": "HAWK, to peddle [v]\n",
  "HAWKER": "a peddler [n -S]\n",
  "HAWKERS": "HAWKER, a peddler [n]\n",
  "HAWKEY": "harvest-home, the harvest supper, also HORKEY [n -S]\n",
  "HAWKEYED": "having keen sight [adj]\n",
  "HAWKEYS": "HAWKEY, harvest-home, the harvest supper, also HORKEY [n]\n",
  "HAWKIE": "a cow with a white-striped face [n -S]\n",
  "HAWKIES": "HAWKIE, a cow with a white-striped face [n]\n",
  "HAWKING": "falconry [n -S]\n",
  "HAWKINGS": "HAWKING, falconry [n]\n",
  "HAWKISH": "like a hawk, warlike [adj HAWKISHLY]\n",
  "HAWKISHLY": "HAWKISH, like a hawk, warlike [adv]\n",
  "HAWKISHNESS": "the state of being hawkish [n -ES]\n",
  "HAWKISHNESSES": "HAWKISHNESS, the state of being hawkish [n]\n",
  "HAWKIT": "(Scots) streaked, white-faced [adj]\n",
  "HAWKLIKE": "resembling a bird of prey [adj]\n",
  "HAWKMOTH": "a kind of large moth [n -S]\n",
  "HAWKMOTHS": "HAWKMOTH, a kind of large moth [n]\n",
  "HAWKNOSE": "a large curved nose [n -S]\n",
  "HAWKNOSES": "HAWKNOSE, a large curved nose [n]\n",
  "HAWKS": "HAWK, to peddle [v]\n",
  "HAWKSBEARD": "a flower of the dandelion family [n -S]\n",
  "HAWKSBEARDS": "HAWKSBEARD, a flower of the dandelion family [n]\n",
  "HAWKSBILL": "a kind of sea turtle, also HAWKBILL [n -S]\n",
  "HAWKSBILLS": "HAWKSBILL, a kind of sea turtle, also HAWKBILL [n]\n",
  "HAWKSHAW": "a detective [n -S]\n",
  "HAWKSHAWS": "HAWKSHAW, a detective [n]\n",
  "HAWKWEED": "a weedlike herb [n -S]\n",
  "HAWKWEEDS": "HAWKWEED, a weedlike herb [n]\n",
  "HAWM": "(dialect) to lounge about [v -ED, -ING, -S]\n",
  "HAWMED": "HAWM, (dialect) to lounge about [v]\n",
  "HAWMING": "HAWM, (dialect) to lounge about [v]\n",
  "HAWMS": "HAWM, (dialect) to lounge about [v]\n",
  "HAWS": "HAW, to make indecisive noises [v]\n",
  "HAWSE": "to salute, greet, also HALSE, HAUSE [v HAWSED, HAWSING, HAWSES]\n",
  "HAWSED": "HAWSE, to salute, greet, also HALSE, HAUSE [v]\n",
  "HAWSEHOLE": "a hole for a ship's cable [n -S]\n",
  "HAWSEHOLES": "HAWSEHOLE, a hole for a ship's cable [n]\n",
  "HAWSEPIPE": "a tubular casting, fitted to a ship's bow, through which the anchor chain passes [n -S]\n",
  "HAWSEPIPES": "HAWSEPIPE, a tubular casting, fitted to a ship's bow, through which the anchor chain passes [n]\n",
  "HAWSER": "a large rope for mooring or towing a ship, also HALSER [n -S]\n",
  "HAWSERS": "HAWSER, a large rope for mooring or towing a ship, also HALSER [n]\n",
  "HAWSES": "HAWSE, to salute, greet, also HALSE, HAUSE [v]\n",
  "HAWSING": "HAWSE, to salute, greet, also HALSE, HAUSE [v]\n",
  "HAWTHORN": "a small tree of the rose family, widely used for hedges [n -S]\n",
  "HAWTHORNIER": "HAWTHORNY, like hawthorn [adj]\n",
  "HAWTHORNIEST": "HAWTHORNY, like hawthorn [adj]\n",
  "HAWTHORNS": "HAWTHORN, a small tree of the rose family, widely used for hedges [n]\n",
  "HAWTHORNY": "like hawthorn [adj HAWTHORNIER, HAWTHORNIEST]\n",
  "HAY": "to convert cut dried grass into fodder [v -ED, -ING, -S]\n",
  "HAYBAND": "a rope of twisted hay [n -S]\n",
  "HAYBANDS": "HAYBAND, a rope of twisted hay [n]\n",
  "HAYBOX": "a box for keeping hay in, for animals to eat from [n -ES]\n",
  "HAYBOXES": "HAYBOX, a box for keeping hay in, for animals to eat from [n]\n",
  "HAYCATION": "a working holiday at a farm or similar business [n -S]\n",
  "HAYCATIONS": "HAYCATION, a working holiday at a farm or similar business [n]\n",
  "HAYCOCK": "a conical pile of hay in a field [n -S]\n",
  "HAYCOCKS": "HAYCOCK, a conical pile of hay in a field [n]\n",
  "HAYED": "HAY, to convert cut dried grass into fodder [v]\n",
  "HAYER": "one who makes hay [n -S]\n",
  "HAYERS": "HAYER, one who makes hay [n]\n",
  "HAYEY": "like hay [adj HAYIER, HAYIEST]\n",
  "HAYFIELD": "a field where grasses are grown for hay [n -S]\n",
  "HAYFIELDS": "HAYFIELD, a field where grasses are grown for hay [n]\n",
  "HAYFORK": "a tool for pitching hay [n -S]\n",
  "HAYFORKS": "HAYFORK, a tool for pitching hay [n]\n",
  "HAYIER": "HAYEY, like hay [adj]\n",
  "HAYIEST": "HAYEY, like hay [adj]\n",
  "HAYING": "the season for harvesting hay [n -S]\n",
  "HAYINGS": "HAYING, the season for harvesting hay [n]\n",
  "HAYLAGE": "silage made from partially dried grass [n -S]\n",
  "HAYLAGES": "HAYLAGE, silage made from partially dried grass [n]\n",
  "HAYLE": "(Spenser) welfare [n -S]\n",
  "HAYLES": "HAYLE, (Spenser) welfare [n]\n",
  "HAYLOFT": "a loft for storing hay [n -S]\n",
  "HAYLOFTS": "HAYLOFT, a loft for storing hay [n]\n",
  "HAYMAKER": "one that makes hay; a wild swinging punch [n -S]\n",
  "HAYMAKERS": "HAYMAKER, one that makes hay; a wild swinging punch [n]\n",
  "HAYMAKING": "the harvesting of hay [n -S]\n",
  "HAYMAKINGS": "HAYMAKING, the harvesting of hay [n]\n",
  "HAYMOW": "a mow or mass of hay laid up in a barn for preservation [n -S]\n",
  "HAYMOWS": "HAYMOW, a mow or mass of hay laid up in a barn for preservation [n]\n",
  "HAYRACK": "a frame used in hauling hay [n -S]\n",
  "HAYRACKS": "HAYRACK, a frame used in hauling hay [n]\n",
  "HAYRAKE": "a large rake for collecting hay [n -S]\n",
  "HAYRAKES": "HAYRAKE, a large rake for collecting hay [n]\n",
  "HAYRICK": "a haystack [n -S]\n",
  "HAYRICKS": "HAYRICK, a haystack [n]\n",
  "HAYRIDE": "a pleasure ride in a hay wagon [n -S]\n",
  "HAYRIDES": "HAYRIDE, a pleasure ride in a hay wagon [n]\n",
  "HAYS": "HAY, to convert cut dried grass into fodder [v]\n",
  "HAYSEED": "a country bumpkin [n -S]\n",
  "HAYSEEDS": "HAYSEED, a country bumpkin [n]\n",
  "HAYSEL": "the haymaking season [n -S]\n",
  "HAYSELS": "HAYSEL, the haymaking season [n]\n",
  "HAYSTACK": "a pile of hay [n -S]\n",
  "HAYSTACKS": "HAYSTACK, a pile of hay [n]\n",
  "HAYWARD": "a parish officer in charge of enclosures and fences [n -S]\n",
  "HAYWARDS": "HAYWARD, a parish officer in charge of enclosures and fences [n]\n",
  "HAYWIRE": "wire used in baling hay [n -S]\n",
  "HAYWIRES": "HAYWIRE, wire used in baling hay [n]\n",
  "HAZAN": "(Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZZAN, KHAZEN [n HAZANIM or HAZANS]\n",
  "HAZANIM": "HAZAN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZZAN, KHAZEN [n]\n",
  "HAZANS": "HAZAN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZZAN, KHAZEN [n]\n",
  "HAZARD": "to venture [v -ED, -ING, -S]\n",
  "HAZARDABLE": "liable to hazard or chance; uncertain; risky [adj]\n",
  "HAZARDED": "HAZARD, to venture [v]\n",
  "HAZARDER": "one who hazards [n -S]\n",
  "HAZARDERS": "HAZARDER, one who hazards [n]\n",
  "HAZARDING": "HAZARD, to venture [v]\n",
  "HAZARDIZE": "(Spenser) a hazardous position, a condition of peril or risk [n -S]\n",
  "HAZARDIZES": "HAZARDIZE, (Spenser) a hazardous position, a condition of peril or risk [n]\n",
  "HAZARDOUS": "dangerous [adj HAZARDOUSLY]\n",
  "HAZARDOUSLY": "HAZARDOUS, dangerous [adv]\n",
  "HAZARDOUSNESS": "HAZARDOUS, dangerous [n]\n",
  "HAZARDOUSNESSES": "HAZARDOUSNESS, HAZARDOUS, dangerous [n]\n",
  "HAZARDRIES": "HAZARDRY, (Spenser) playing at games of hazard [n]\n",
  "HAZARDRY": "(Spenser) playing at games of hazard [n HAZARDRIES]\n",
  "HAZARDS": "HAZARD, to venture [v]\n",
  "HAZE": "to make a shimmering vapour [v HAZED, HAZING, HAZES]\n",
  "HAZED": "HAZE, to make a shimmering vapour [v]\n",
  "HAZEL": "a tree of the birch family [n -S]\n",
  "HAZELHEN": "a European grouse [n -S]\n",
  "HAZELHENS": "HAZELHEN, a European grouse [n]\n",
  "HAZELLY": "of the color of the hazelnut; of a light brown [adj]\n",
  "HAZELNUT": "an edible nut [n -S]\n",
  "HAZELNUTS": "HAZELNUT, an edible nut [n]\n",
  "HAZELS": "HAZEL, a tree of the birch family [n]\n",
  "HAZELWOOD": "the wood of the hazel [n -S]\n",
  "HAZELWOODS": "HAZELWOOD, the wood of the hazel [n]\n",
  "HAZER": "one who hazes, a tease [n -S]\n",
  "HAZERS": "HAZER, one who hazes, a tease [n]\n",
  "HAZES": "HAZE, to make a shimmering vapour [v]\n",
  "HAZIER": "HAZY, like a haze, unclear [adj]\n",
  "HAZIEST": "HAZY, like a haze, unclear [adj]\n",
  "HAZILY": "HAZY, like a haze, unclear [adv]\n",
  "HAZINESS": "the state of being hazy [n -ES]\n",
  "HAZINESSES": "HAZINESS, the state of being hazy [n]\n",
  "HAZING": "an attempt to embarrass or ridicule [n -S]\n",
  "HAZINGS": "HAZING, an attempt to embarrass or ridicule [n]\n",
  "HAZMAT": "hazardous material [n -S]\n",
  "HAZMATS": "HAZMAT, hazardous material [n]\n",
  "HAZY": "like a haze, unclear [adj HAZIER, HAZIEST, HAZILY]\n",
  "HAZZAN": "(Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZAN, KHAZEN [n HAZZANS or HAZZANIM]\n",
  "HAZZANIM": "HAZZAN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZAN, KHAZEN [n]\n",
  "HAZZANS": "HAZZAN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZAN, KHAZEN [n]\n",
  "HE": "a male person or animal [n -S]\n",
  "HEAD": "to be chief of [v -ED, -ING, -S]\n",
  "HEADACHE": "a pain inside the head [n -S]\n",
  "HEADACHES": "HEADACHE, a pain inside the head [n]\n",
  "HEADACHEY": "afflicted with a headache, also HEADACHY [adj]\n",
  "HEADACHIER": "HEADACHY, having a headache, also HEADACHEY [adj]\n",
  "HEADACHIEST": "HEADACHY, having a headache, also HEADACHEY [adj]\n",
  "HEADACHY": "having a headache, also HEADACHEY [adj HEADACHIER, HEADACHIEST]\n",
  "HEADAGE": "a subsidy payable to farmers, based on the number of animals kept [n -S]\n",
  "HEADAGES": "HEADAGE, a subsidy payable to farmers, based on the number of animals kept [n]\n",
  "HEADBAND": "a band worn on the head [n -S]\n",
  "HEADBANDS": "HEADBAND, a band worn on the head [n]\n",
  "HEADBANG": "to nod one's head violently to the beat of loud music [v -ED, -ING, -S]\n",
  "HEADBANGED": "HEADBANG, to nod one's head violently to the beat of loud music [v]\n",
  "HEADBANGING": "the act of shaking the head vigorously in time with loud rock music [n -S]\n",
  "HEADBANGINGS": "HEADBANGING, the act of shaking the head vigorously in time with loud rock music [n]\n",
  "HEADBANGS": "HEADBANG, to nod one's head violently to the beat of loud music [v]\n",
  "HEADBOARD": "a board at the head of a bed [n -S]\n",
  "HEADBOARDS": "HEADBOARD, a board at the head of a bed [n]\n",
  "HEADBOROUGH": "(historical) the head of a frankpledge, tithing, or decennary; a petty constable [n -S]\n",
  "HEADBOROUGHS": "HEADBOROUGH, (historical) the head of a frankpledge, tithing, or decennary; a petty constable [n]\n",
  "HEADCASE": "(colloquial) a person whose behaviour is violent and unpredictable, or markedly eccentric [n -S]\n",
  "HEADCASES": "HEADCASE, (colloquial) a person whose behaviour is violent and unpredictable, or markedly eccentric [n]\n",
  "HEADCHAIR": "a high-backed chair with a headrest [n -S]\n",
  "HEADCHAIRS": "HEADCHAIR, a high-backed chair with a headrest [n]\n",
  "HEADCHEESE": "(US) brawn [n -S]\n",
  "HEADCHEESES": "HEADCHEESE, (US) brawn [n]\n",
  "HEADCLOTH": "a kerchief worn instead of a hat [n -S]\n",
  "HEADCLOTHS": "HEADCLOTH, a kerchief worn instead of a hat [n]\n",
  "HEADCOUNT": "a count of people present [n -S]\n",
  "HEADCOUNTS": "HEADCOUNT, a count of people present [n]\n",
  "HEADDRESS": "a (sometimes ceremonial) covering for the head [n -ES]\n",
  "HEADDRESSES": "HEADDRESS, a (sometimes ceremonial) covering for the head [n]\n",
  "HEADED": "HEAD, to be chief of [v]\n",
  "HEADEND": "a facility that receives and distributes communications signals [n -S]\n",
  "HEADENDS": "HEADEND, a facility that receives and distributes communications signals [n]\n",
  "HEADER": "a dive head foremost [n -S]\n",
  "HEADERS": "HEADER, a dive head foremost [n]\n",
  "HEADFAST": "a mooring rope [n -S]\n",
  "HEADFASTS": "HEADFAST, a mooring rope [n]\n",
  "HEADFIRST": "with the head in front [adj]\n",
  "HEADFISH": "a marine fish, the sunfish [n -ES]\n",
  "HEADFISHES": "HEADFISH, a marine fish, the sunfish [n]\n",
  "HEADFOREMOST": "headfirst [adv]\n",
  "HEADFRAME": "the structure over a mine shaft supporting the machinery [n -S]\n",
  "HEADFRAMES": "HEADFRAME, the structure over a mine shaft supporting the machinery [n]\n",
  "HEADFUCK": "(vulgar) a wildly exciting experience [n -S]\n",
  "HEADFUCKS": "HEADFUCK, (vulgar) a wildly exciting experience [n]\n",
  "HEADFUL": "the contents of a head; a great amount of knowledge [n -S]\n",
  "HEADFULS": "HEADFUL, the contents of a head; a great amount of knowledge [n]\n",
  "HEADGATE": "a gate to control the flow of water [n -S]\n",
  "HEADGATES": "HEADGATE, a gate to control the flow of water [n]\n",
  "HEADGEAR": "a covering for the head [n -S]\n",
  "HEADGEARS": "HEADGEAR, a covering for the head [n]\n",
  "HEADGUARD": "a padded helmet worn to protect the head in contact sports [n -S]\n",
  "HEADGUARDS": "HEADGUARD, a padded helmet worn to protect the head in contact sports [n]\n",
  "HEADHUNT": "to seek out and recruit executives for business [v -ED, -ING, -S]\n",
  "HEADHUNTED": "HEADHUNT, to seek out and recruit executives for business [v]\n",
  "HEADHUNTER": "one that engages in headhunting [n -S]\n",
  "HEADHUNTERS": "HEADHUNTER, one that engages in headhunting [n]\n",
  "HEADHUNTING": "the practice of collecting human heads [n -S]\n",
  "HEADHUNTINGS": "HEADHUNTING, the practice of collecting human heads [n]\n",
  "HEADHUNTS": "HEADHUNT, to seek out and recruit executives for business [v]\n",
  "HEADIER": "HEADY, intoxicating [adj]\n",
  "HEADIEST": "HEADY, intoxicating [adj]\n",
  "HEADILY": "HEADY, intoxicating [adv]\n",
  "HEADINESS": "the state of being heady [n -ES]\n",
  "HEADINESSES": "HEADINESS, the state of being heady [n]\n",
  "HEADING": "a title [n -S]\n",
  "HEADINGS": "HEADING, a title [n]\n",
  "HEADLAMP": "a light on the front of a car [n -S]\n",
  "HEADLAMPS": "HEADLAMP, a light on the front of a car [n]\n",
  "HEADLAND": "a point of land running out into the sea [n -S]\n",
  "HEADLANDS": "HEADLAND, a point of land running out into the sea [n]\n",
  "HEADLEASE": "a main or original lease, that can be divided into subleases [n -S]\n",
  "HEADLEASES": "HEADLEASE, a main or original lease, that can be divided into subleases [n]\n",
  "HEADLESS": "without a head [adj]\n",
  "HEADLESSNESS": "the state of being headless [n -ES]\n",
  "HEADLESSNESSES": "HEADLESSNESS, the state of being headless [n]\n",
  "HEADLIGHT": "a strong light on the front of a vehicle [n -S]\n",
  "HEADLIGHTS": "HEADLIGHT, a strong light on the front of a vehicle [n]\n",
  "HEADLIKE": "like a head [adj]\n",
  "HEADLINE": "to provide with a title [v HEADLINED, HEADLINING, HEADLINES]\n",
  "HEADLINED": "HEADLINE, to provide with a title [v]\n",
  "HEADLINER": "the person whose name is made most prominent in a playbill or programme [n -S]\n",
  "HEADLINERS": "HEADLINER, the person whose name is made most prominent in a playbill or programme [n]\n",
  "HEADLINES": "HEADLINE, to provide with a title [v]\n",
  "HEADLINING": "HEADLINE, to provide with a title [v]\n",
  "HEADLOCK": "a wrestling hold [n -S]\n",
  "HEADLOCKS": "HEADLOCK, a wrestling hold [n]\n",
  "HEADLONG": "at full tilt [adj]\n",
  "HEADMAN": "a foreman [n HEADMEN]\n",
  "HEADMARK": "a peculiar characteristic [n -S]\n",
  "HEADMARKS": "HEADMARK, a peculiar characteristic [n]\n",
  "HEADMASTER": "a man heading the staff of a school [n -S]\n",
  "HEADMASTERLIER": "HEADMASTERLY, like a headmaster [adj]\n",
  "HEADMASTERLIEST": "HEADMASTERLY, like a headmaster [adj]\n",
  "HEADMASTERLY": "like a headmaster [adj HEADMASTERLIER, HEADMASTERLIEST]\n",
  "HEADMASTERS": "HEADMASTER, a man heading the staff of a school [n]\n",
  "HEADMASTERSHIP": "the office of headmaster [n -S]\n",
  "HEADMASTERSHIPS": "HEADMASTERSHIP, the office of headmaster [n]\n",
  "HEADMEN": "HEADMAN, a foreman [n]\n",
  "HEADMISTRESS": "a woman heading the staff of a private school [n -ES]\n",
  "HEADMISTRESSES": "HEADMISTRESS, a woman heading the staff of a private school [n]\n",
  "HEADMISTRESSIER": "HEADMISTRESSY, like a headmistress, bossy [adj]\n",
  "HEADMISTRESSY": "like a headmistress, bossy [adj HEADMISTRESSIER]\n",
  "HEADMOST": "with head first [adj]\n",
  "HEADNOTE": "a note at the head of a page or chapter [n -S]\n",
  "HEADNOTES": "HEADNOTE, a note at the head of a page or chapter [n]\n",
  "HEADPEACE": "(archaic) a helmet, also HEADPIECE [n -S]\n",
  "HEADPEACES": "HEADPEACE, (archaic) a helmet, also HEADPIECE [n]\n",
  "HEADPHONE": "an audio receiver worn in pairs over the ears, esp. for listening to a radio, cassette player, etc. [n -S]\n",
  "HEADPHONES": "HEADPHONE, an audio receiver worn in pairs over the ears, esp. for listening to a radio, cassette player, etc. [n]\n",
  "HEADPIECE": "any covering for the head, esp. a helmet, also HEADPEACE [n -S]\n",
  "HEADPIECES": "HEADPIECE, any covering for the head, esp. a helmet, also HEADPEACE [n]\n",
  "HEADPIN": "a bowling pin [n -S]\n",
  "HEADPINS": "HEADPIN, a bowling pin [n]\n",
  "HEADPOND": "a pond created behind a dam [n -S]\n",
  "HEADPONDS": "HEADPOND, a pond created behind a dam [n]\n",
  "HEADQUARTER": "to make one's headquarters [v -ED, -ING, -S]\n",
  "HEADQUARTERED": "HEADQUARTER, to make one's headquarters [v]\n",
  "HEADQUARTERING": "HEADQUARTER, to make one's headquarters [v]\n",
  "HEADQUARTERS": "HEADQUARTER, to make one's headquarters [v]\n",
  "HEADRACE": "the channel leading to a waterwheel [n -S]\n",
  "HEADRACES": "HEADRACE, the channel leading to a waterwheel [n]\n",
  "HEADRAIL": "a rail on the head of a ship [n -S]\n",
  "HEADRAILS": "HEADRAIL, a rail on the head of a ship [n]\n",
  "HEADREACH": "to make distance to windward in tacking [v -ED, -ING, -ES]\n",
  "HEADREACHED": "HEADREACH, to make distance to windward in tacking [v]\n",
  "HEADREACHES": "HEADREACH, to make distance to windward in tacking [v]\n",
  "HEADREACHING": "HEADREACH, to make distance to windward in tacking [v]\n",
  "HEADREST": "a support for the head [n -S]\n",
  "HEADRESTS": "HEADREST, a support for the head [n]\n",
  "HEADRIG": "(Scots) a headland in a ploughed field [n -S]\n",
  "HEADRIGS": "HEADRIG, (Scots) a headland in a ploughed field [n]\n",
  "HEADRING": "a palm-leaf ornament worn in the hair by South African men after marriage [n -S]\n",
  "HEADRINGS": "HEADRING, a palm-leaf ornament worn in the hair by South African men after marriage [n]\n",
  "HEADROOM": "clear vertical space [n -S]\n",
  "HEADROOMS": "HEADROOM, clear vertical space [n]\n",
  "HEADROPE": "that part of a boltrope which is sewed to the upper edge or head of a sail [n -S]\n",
  "HEADROPES": "HEADROPE, that part of a boltrope which is sewed to the upper edge or head of a sail [n]\n",
  "HEADS": "HEAD, to be chief of [v]\n",
  "HEADSAIL": "a sail set forward of the foremast of a ship [n -S]\n",
  "HEADSAILS": "HEADSAIL, a sail set forward of the foremast of a ship [n]\n",
  "HEADSCARF": "a scarf worn over the head [n HEADSCARVES]\n",
  "HEADSCARVES": "HEADSCARF, a scarf worn over the head [n]\n",
  "HEADSET": "a set of headphones [n -S]\n",
  "HEADSETS": "HEADSET, a set of headphones [n]\n",
  "HEADSHAKE": "a shake of the head [n -S]\n",
  "HEADSHAKES": "HEADSHAKE, a shake of the head [n]\n",
  "HEADSHEETS": "the forepart of a small vessel or craft [n]\n",
  "HEADSHIP": "the position of a leader [n -S]\n",
  "HEADSHIPS": "HEADSHIP, the position of a leader [n]\n",
  "HEADSHOT": "a photograph of someone's head (and shoulders) only [n -S]\n",
  "HEADSHOTS": "HEADSHOT, a photograph of someone's head (and shoulders) only [n]\n",
  "HEADSHRINKER": "(colloquial) a psychiatrist [n -S]\n",
  "HEADSHRINKERS": "HEADSHRINKER, (colloquial) a psychiatrist [n]\n",
  "HEADSMAN": "an executioner [n HEADSMEN]\n",
  "HEADSMEN": "HEADSMAN, an executioner [n]\n",
  "HEADSPACE": "room for one's head [n -S]\n",
  "HEADSPACES": "HEADSPACE, room for one's head [n]\n",
  "HEADSPRING": "a fountain, a source [n -S]\n",
  "HEADSPRINGS": "HEADSPRING, a fountain, a source [n]\n",
  "HEADSQUARE": "a square of material used as a covering for the head [n -S]\n",
  "HEADSQUARES": "HEADSQUARE, a square of material used as a covering for the head [n]\n",
  "HEADSTALL": "that part of a bridle or halter which encompasses the head [n -S]\n",
  "HEADSTALLS": "HEADSTALL, that part of a bridle or halter which encompasses the head [n]\n",
  "HEADSTAND": "a gymnastic standing on one's head [n -S]\n",
  "HEADSTANDS": "HEADSTAND, a gymnastic standing on one's head [n]\n",
  "HEADSTAY": "a support for a ship's foremast [n -S]\n",
  "HEADSTAYS": "HEADSTAY, a support for a ship's foremast [n]\n",
  "HEADSTICK": "in printing, a straight piece of furniture placed at the head of a form [n -S]\n",
  "HEADSTICKS": "HEADSTICK, in printing, a straight piece of furniture placed at the head of a form [n]\n",
  "HEADSTOCK": "the bearings or supports of revolving parts in various machines [n -S]\n",
  "HEADSTOCKS": "HEADSTOCK, the bearings or supports of revolving parts in various machines [n]\n",
  "HEADSTONE": "the principal stone in a foundation; the chief or corner stone [n -S]\n",
  "HEADSTONES": "HEADSTONE, the principal stone in a foundation; the chief or corner stone [n]\n",
  "HEADSTREAM": "the stream forming the highest, most remote source of a river [n -S]\n",
  "HEADSTREAMS": "HEADSTREAM, the stream forming the highest, most remote source of a river [n]\n",
  "HEADSTRONG": "impetuous [adj HEADSTRONGLY]\n",
  "HEADSTRONGLY": "HEADSTRONG, impetuous [adv]\n",
  "HEADSTRONGNESS": "the state of being headstrong [n]\n",
  "HEADTEACHER": "a teacher in charge of a school [n -S]\n",
  "HEADTEACHERS": "HEADTEACHER, a teacher in charge of a school [n]\n",
  "HEADWAITER": "the head of the dining-room staff of a restaurant or hotel [n -S]\n",
  "HEADWAITERS": "HEADWAITER, the head of the dining-room staff of a restaurant or hotel [n]\n",
  "HEADWALL": "a steep rock-face at the end of a cirque [n -S]\n",
  "HEADWALLS": "HEADWALL, a steep rock-face at the end of a cirque [n]\n",
  "HEADWARD": "backwards beyond the original source, also HEADWARDS [adv]\n",
  "HEADWARDS": "backwards beyond the original source, also HEADWARD [adv]\n",
  "HEADWATER": "the highest part of a stream or river before receiving tributaries [n -S]\n",
  "HEADWATERS": "HEADWATER, the highest part of a stream or river before receiving tributaries [n]\n",
  "HEADWAY": "forward movement [n -S]\n",
  "HEADWAYS": "HEADWAY, forward movement [n]\n",
  "HEADWIND": "a wind blowing contrary to one's direction of travel [n -S]\n",
  "HEADWINDS": "HEADWIND, a wind blowing contrary to one's direction of travel [n]\n",
  "HEADWORD": "a word appearing at the beginning [n -S]\n",
  "HEADWORDS": "HEADWORD, a word appearing at the beginning [n]\n",
  "HEADWORK": "mental work [n -S]\n",
  "HEADWORKER": "one who does headwork, mental work [n -S]\n",
  "HEADWORKERS": "HEADWORKER, one who does headwork, mental work [n]\n",
  "HEADWORKS": "HEADWORK, mental work [n]\n",
  "HEADY": "intoxicating [adj HEADIER, HEADIEST, HEADILY]\n",
  "HEAL": "to make sound again [v -ED, -ING, -S]\n",
  "HEALABLE": "able to be healed [adj]\n",
  "HEALD": "(obsolete) to heel, incline on one side [v -ED, -ING, -S]\n",
  "HEALDED": "HEALD, (obsolete) to heel, incline on one side [v]\n",
  "HEALDING": "HEALD, (obsolete) to heel, incline on one side [v]\n",
  "HEALDS": "HEALD, (obsolete) to heel, incline on one side [v]\n",
  "HEALED": "HEAL, to make sound again [v]\n",
  "HEALEE": "someone who is being healed [n -S]\n",
  "HEALEES": "HEALEE, someone who is being healed [n]\n",
  "HEALER": "one that heals [n -S]\n",
  "HEALERS": "HEALER, one that heals [n]\n",
  "HEALING": "curative [adj HEALINGLY] / the act of healing [n -S]\n",
  "HEALINGLY": "HEALING, curative [adv]\n",
  "HEALINGS": "HEALING, the act of healing [n]\n",
  "HEALS": "HEAL, to make sound again [v]\n",
  "HEALSOME": "(Scots) wholesome, also HOLESOM, HOLESOME [adj]\n",
  "HEALTH": "sound physical or mental condition [n -S]\n",
  "HEALTHCARE": "the provision of health care [n -S]\n",
  "HEALTHCARES": "HEALTHCARE, the provision of health care [n]\n",
  "HEALTHFUL": "giving health [adj HEALTHFULLY]\n",
  "HEALTHFULLY": "HEALTHFUL, giving health [adv]\n",
  "HEALTHFULNESS": "the state of being healthful [n -ES]\n",
  "HEALTHFULNESSES": "HEALTHFULNESS, the state of being healthful [n]\n",
  "HEALTHIER": "HEALTHY, wholesome [adj]\n",
  "HEALTHIEST": "HEALTHY, wholesome [adj]\n",
  "HEALTHILY": "HEALTHY, wholesome [adv]\n",
  "HEALTHINESS": "the state of being healthy [n -ES]\n",
  "HEALTHINESSES": "HEALTHINESS, the state of being healthy [n]\n",
  "HEALTHISM": "a lifestyle that prioritises health and fitness over anything else [n -S]\n",
  "HEALTHISMS": "HEALTHISM, a lifestyle that prioritises health and fitness over anything else [n]\n",
  "HEALTHLESS": "without health [adj]\n",
  "HEALTHLESSNESS": "the state of being healthless [n]\n",
  "HEALTHS": "HEALTH, sound physical or mental condition [n]\n",
  "HEALTHSOME": "wholesome, salubrious [adj]\n",
  "HEALTHY": "wholesome [adj HEALTHIER, HEALTHIEST, HEALTHILY]\n",
  "HEAME": "(Spenser) home [adv]\n",
  "HEAP": "to pile up [v -ED, -ING, -S]\n",
  "HEAPED": "HEAP, to pile up [v]\n",
  "HEAPER": "one who heaps [n -S]\n",
  "HEAPERS": "HEAPER, one who heaps [n]\n",
  "HEAPIER": "HEAPY, full of heaps [adj]\n",
  "HEAPIEST": "HEAPY, full of heaps [adj]\n",
  "HEAPING": "HEAP, to pile up [v]\n",
  "HEAPS": "HEAP, to pile up [v]\n",
  "HEAPSTEAD": "the buildings and places around a mine shaft [n -S]\n",
  "HEAPSTEADS": "HEAPSTEAD, the buildings and places around a mine shaft [n]\n",
  "HEAPY": "full of heaps [adj HEAPIER, HEAPIEST]\n",
  "HEAR": "to perceive by the ear [v HEARD, HEARING, HEARS]\n",
  "HEARABLE": "able to be heard [adj]\n",
  "HEARD": "herd [n -S]\n",
  "HEARDS": "HEARD, herd [n]\n",
  "HEARE": "(Spenser) hair [n -S]\n",
  "HEARER": "one that hears [n -S]\n",
  "HEARERS": "HEARER, one that hears [n]\n",
  "HEARES": "HEARE, (Spenser) hair [n]\n",
  "HEARIE": "(Spenser) hairy [adj]\n",
  "HEARING": "a preliminary examination [n -S]\n",
  "HEARINGS": "HEARING, a preliminary examination [n]\n",
  "HEARKEN": "to listen to, also HARK, HARKEN [v -ED, -ING, -S]\n",
  "HEARKENED": "HEARKEN, to listen to, also HARK, HARKEN [v]\n",
  "HEARKENER": "one who hearkens, also HARKENER [n -S]\n",
  "HEARKENERS": "HEARKENER, one who hearkens, also HARKENER [n]\n",
  "HEARKENING": "HEARKEN, to listen to, also HARK, HARKEN [v]\n",
  "HEARKENS": "HEARKEN, to listen to, also HARK, HARKEN [v]\n",
  "HEARS": "HEAR, to perceive by the ear [v]\n",
  "HEARSAY": "secondhand information [n -S]\n",
  "HEARSAYS": "HEARSAY, secondhand information [n]\n",
  "HEARSE": "to transport in a vehicle for carrying corpses [v HEARSED, HEARSING, HEARSES]\n",
  "HEARSED": "HEARSE, to transport in a vehicle for carrying corpses [v]\n",
  "HEARSES": "HEARSE, to transport in a vehicle for carrying corpses [v]\n",
  "HEARSIER": "HEARSY, resembling a hearse [adj]\n",
  "HEARSIEST": "HEARSY, resembling a hearse [adj]\n",
  "HEARSING": "HEARSE, to transport in a vehicle for carrying corpses [v]\n",
  "HEARSY": "resembling a hearse [adj HEARSIER, HEARSIEST]\n",
  "HEART": "to hearten, encourage [v -ED, -ING, -S]\n",
  "HEARTACHE": "sorrow, anguish [n -S]\n",
  "HEARTACHES": "HEARTACHE, sorrow, anguish [n]\n",
  "HEARTBEAT": "a pulsation of the heart [n -S]\n",
  "HEARTBEATS": "HEARTBEAT, a pulsation of the heart [n]\n",
  "HEARTBREAK": "crushing grief, anguish, or distress [n -S] / to cause intense grief to [v HEARTBROKE, HEARTBROKEN, HEARTBREAKING, HEARTBREAKS]\n",
  "HEARTBREAKER": "one that causes heartbreak [n -S]\n",
  "HEARTBREAKERS": "HEARTBREAKER, one that causes heartbreak [n]\n",
  "HEARTBREAKING": "causing intense sorrow or distress [adj HEARTBREAKINGLY]\n",
  "HEARTBREAKINGLY": "HEARTBREAKING, causing intense sorrow or distress [adv]\n",
  "HEARTBREAKS": "HEARTBREAK, crushing grief, anguish, or distress [n]\n",
  "HEARTBROKE": "HEARTBREAK, to cause intense grief to [v]\n",
  "HEARTBROKEN": "having a broken heart [adj HEARTBROKENLY]\n",
  "HEARTBROKENLY": "HEARTBROKEN, having a broken heart [adv]\n",
  "HEARTBROKENNESS": "HEARTBROKEN, having a broken heart [n]\n",
  "HEARTBURN": "a burning, acrid feeling in the throat or breast, severe indigestion, cardialgia [n -S]\n",
  "HEARTBURNING": "intense or rancorous jealousy or resentment [n -S]\n",
  "HEARTBURNINGS": "HEARTBURNING, intense or rancorous jealousy or resentment [n]\n",
  "HEARTBURNS": "HEARTBURN, a burning, acrid feeling in the throat or breast, severe indigestion, cardialgia [n]\n",
  "HEARTED": "HEART, to hearten, encourage [v]\n",
  "HEARTEN": "to give courage to, also HARTEN [v -ED, -ING, -S]\n",
  "HEARTENED": "HEARTEN, to give courage to, also HARTEN [v]\n",
  "HEARTENER": "one who heartens [n -S]\n",
  "HEARTENERS": "HEARTENER, one who heartens [n]\n",
  "HEARTENING": "HEARTEN, to give courage to, also HARTEN [v]\n",
  "HEARTENINGLY": "HEARTENING, HEARTEN, to give courage to, also HARTEN [adv]\n",
  "HEARTENS": "HEARTEN, to give courage to, also HARTEN [v]\n",
  "HEARTFELT": "deeply felt [adj]\n",
  "HEARTFREE": "not in love [adj]\n",
  "HEARTH": "the floor of a fireplace [n -S]\n",
  "HEARTHRUG": "a rug spread in front of a hearth [n -S]\n",
  "HEARTHRUGS": "HEARTHRUG, a rug spread in front of a hearth [n]\n",
  "HEARTHS": "HEARTH, the floor of a fireplace [n]\n",
  "HEARTHSTONE": "a stone forming a hearth [n -S]\n",
  "HEARTHSTONES": "HEARTHSTONE, a stone forming a hearth [n]\n",
  "HEARTIER": "HEARTY, very friendly [adj]\n",
  "HEARTIES": "HEARTY, a comrade [n]\n",
  "HEARTIEST": "HEARTY, very friendly [adj]\n",
  "HEARTIKIN": "(obsolete) a little heart (used euphemistically in an oath) [n -S]\n",
  "HEARTIKINS": "HEARTIKIN, (obsolete) a little heart (used euphemistically in an oath) [n]\n",
  "HEARTILY": "HEARTY, very friendly [adv]\n",
  "HEARTINESS": "the state of being hearty [n -ES]\n",
  "HEARTINESSES": "HEARTINESS, the state of being hearty [n]\n",
  "HEARTING": "HEART, to hearten, encourage [v]\n",
  "HEARTLAND": "an area of a country that is centrally situated and/or vitally important [n -S]\n",
  "HEARTLANDS": "HEARTLAND, an area of a country that is centrally situated and/or vitally important [n]\n",
  "HEARTLESS": "callous, uncaring, also HARTLESSE [adj HEARTLESSLY]\n",
  "HEARTLESSLY": "HEARTLESS, callous, uncaring, also HARTLESSE [adv]\n",
  "HEARTLESSNESS": "HEARTLESS, callous, uncaring, also HARTLESSE [n]\n",
  "HEARTLESSNESSES": "HEARTLESSNESS, HEARTLESS, callous, uncaring, also HARTLESSE [n]\n",
  "HEARTLET": "a little heart [n -S]\n",
  "HEARTLETS": "HEARTLET, a little heart [n]\n",
  "HEARTLING": "(Shakespeare) little heart, used in the oath ods heartling [n -S]\n",
  "HEARTLINGS": "HEARTLING, (Shakespeare) little heart, used in the oath ods heartling [n]\n",
  "HEARTLY": "with heart, energetically, also HARTELY, HEARTILY [adv]\n",
  "HEARTPEA": "the balloon-vine, also HEARTSEED [n -S]\n",
  "HEARTPEAS": "HEARTPEA, the balloon-vine, also HEARTSEED [n]\n",
  "HEARTRENDING": "causing great grief [adj HEARTRENDINGLY]\n",
  "HEARTRENDINGLY": "HEARTRENDING, causing great grief [adv]\n",
  "HEARTS": "HEART, to hearten, encourage [v]\n",
  "HEARTSEASE": "a wild pansy [n -S]\n",
  "HEARTSEASES": "HEARTSEASE, a wild pansy [n]\n",
  "HEARTSEED": "the balloon vine, also HEARTPEA [n -S]\n",
  "HEARTSEEDS": "HEARTSEED, the balloon vine, also HEARTPEA [n]\n",
  "HEARTSICK": "very sad [adj]\n",
  "HEARTSICKNESS": "HEARTSICK, very sad [n]\n",
  "HEARTSICKNESSES": "HEARTSICKNESS, HEARTSICK, very sad [n]\n",
  "HEARTSINK": "a patient who repeatedly visits his or her doctor's surgery, often with multiple or nonspecific symptoms, and whose complaints are impossible to treat [n -S]\n",
  "HEARTSINKS": "HEARTSINK, a patient who repeatedly visits his or her doctor's surgery, often with multiple or nonspecific symptoms, and whose complaints are impossible to treat [n]\n",
  "HEARTSOME": "exhilarating; merry [adj HEARTSOMELY]\n",
  "HEARTSOMELY": "HEARTSOME, exhilarating; merry [adv]\n",
  "HEARTSOMENESS": "HEARTSOME, exhilarating; merry [n]\n",
  "HEARTSOMENESSES": "HEARTSOMENESS, HEARTSOME, exhilarating; merry [n]\n",
  "HEARTSORE": "the cause of pain in the heart or the pain itself [n -S]\n",
  "HEARTSORES": "HEARTSORE, the cause of pain in the heart or the pain itself [n]\n",
  "HEARTSTRING": "a nerve or tendon imagined to brace and sustain the heart; (in plural) affections [n -S]\n",
  "HEARTSTRINGS": "HEARTSTRING, a nerve or tendon imagined to brace and sustain the heart; (in plural) affections [n]\n",
  "HEARTTHROB": "an object of affection [n -S]\n",
  "HEARTTHROBS": "HEARTTHROB, an object of affection [n]\n",
  "HEARTWARMING": "inspiring sympathetic feeling [adj]\n",
  "HEARTWATER": "a fatal tick-borne viral disease of cattle, sheep and goats [n -S]\n",
  "HEARTWATERS": "HEARTWATER, a fatal tick-borne viral disease of cattle, sheep and goats [n]\n",
  "HEARTWOOD": "the inner wood of a tree, harder than the sapwood [n -S]\n",
  "HEARTWOODS": "HEARTWOOD, the inner wood of a tree, harder than the sapwood [n]\n",
  "HEARTWORM": "a filarial worm that is a parasite esp. in the hearts of dogs [n -S]\n",
  "HEARTWORMS": "HEARTWORM, a filarial worm that is a parasite esp. in the hearts of dogs [n]\n",
  "HEARTY": "very friendly [adj HEARTIER, HEARTIEST, HEARTILY] / a comrade [n HEARTIES]\n",
  "HEAST": "(Spenser) behest, command, also HEASTE, HEST [n -S]\n",
  "HEASTE": "(Spenser) behest, command, also HEAST, HEST [n -S]\n",
  "HEASTES": "HEASTE, (Spenser) behest, command, also HEAST, HEST [n]\n",
  "HEASTS": "HEAST, (Spenser) behest, command, also HEASTE, HEST [n]\n",
  "HEAT": "to make hot [v -ED, -ING, -S]\n",
  "HEATABLE": "able to be heated [adj]\n",
  "HEATED": "HEAT, to make hot [v]\n",
  "HEATEDLY": "HEATED, HEAT, to make hot [adv]\n",
  "HEATEDNESS": "the state of being heated [n -ES]\n",
  "HEATEDNESSES": "HEATEDNESS, the state of being heated [n]\n",
  "HEATER": "an apparatus for heating [n -S]\n",
  "HEATERS": "HEATER, an apparatus for heating [n]\n",
  "HEATH": "an evergreen shrub [n -S]\n",
  "HEATHBERRIES": "HEATHBERRY, any of various plants that have berrylike fruits and grow on heaths, such as the bilberry and crowberry [n]\n",
  "HEATHBERRY": "any of various plants that have berrylike fruits and grow on heaths, such as the bilberry and crowberry [n HEATHBERRIES]\n",
  "HEATHBIRD": "the black grouse [n -S]\n",
  "HEATHBIRDS": "HEATHBIRD, the black grouse [n]\n",
  "HEATHCOCK": "the male black grouse [n -S]\n",
  "HEATHCOCKS": "HEATHCOCK, the male black grouse [n]\n",
  "HEATHEN": "an uncivilized person [n -S]\n",
  "HEATHENDOM": "(archaic) heathenism, also HEATHENESSE, HEATHENISM [n -S]\n",
  "HEATHENDOMS": "HEATHENDOM, (archaic) heathenism, also HEATHENESSE, HEATHENISM [n]\n",
  "HEATHENESSE": "(archaic) heathenism, also HEATHENDOM, HEATHENISM [n -S]\n",
  "HEATHENESSES": "HEATHENESSE, (archaic) heathenism, also HEATHENDOM, HEATHENISM [n]\n",
  "HEATHENISE": "to make heathen, also HEATHENIZE [v HEATHENISED, HEATHENISING, HEATHENISES]\n",
  "HEATHENISED": "HEATHENISE, to make heathen, also HEATHENIZE [v]\n",
  "HEATHENISES": "HEATHENISE, to make heathen, also HEATHENIZE [v]\n",
  "HEATHENISH": "resembling or characteristic of heathens [adj HEATHENISHLY]\n",
  "HEATHENISHLY": "HEATHENISH, resembling or characteristic of heathens [adv]\n",
  "HEATHENISHNESS": "the state of being heathenish [n]\n",
  "HEATHENISING": "HEATHENISE, to make heathen, also HEATHENIZE [v]\n",
  "HEATHENISM": "the state of being heathen, also HEATHENDOM, HEATHENESSE [n -S]\n",
  "HEATHENISMS": "HEATHENISM, the state of being heathen, also HEATHENDOM, HEATHENESSE [n]\n",
  "HEATHENIZE": "to render heathen or heathenish, also HEATHENISE [v HEATHENIZED, HEATHENIZING, HEATHENIZES]\n",
  "HEATHENIZED": "HEATHENIZE, to render heathen or heathenish, also HEATHENISE [v]\n",
  "HEATHENIZES": "HEATHENIZE, to render heathen or heathenish, also HEATHENISE [v]\n",
  "HEATHENIZING": "HEATHENIZE, to render heathen or heathenish, also HEATHENISE [v]\n",
  "HEATHENNESS": "the state of being heathen [n -ES]\n",
  "HEATHENNESSES": "HEATHENNESS, the state of being heathen [n]\n",
  "HEATHENRIES": "HEATHENRY, the state, quality, or character of the heathen [n]\n",
  "HEATHENRY": "the state, quality, or character of the heathen [n HEATHENRIES]\n",
  "HEATHENS": "HEATHEN, an uncivilized person [n]\n",
  "HEATHER": "a common low-growing shrub of the heath family, aka ling [n -S]\n",
  "HEATHERED": "covered with heather [adj]\n",
  "HEATHERIER": "HEATHERY, like heather [adj]\n",
  "HEATHERIEST": "HEATHERY, like heather [adj]\n",
  "HEATHERS": "HEATHER, a common low-growing shrub of the heath family, aka ling [n]\n",
  "HEATHERY": "like heather [adj HEATHERIER, HEATHERIEST]\n",
  "HEATHFOWL": "a red, or black, grouse [n -S]\n",
  "HEATHFOWLS": "HEATHFOWL, a red, or black, grouse [n]\n",
  "HEATHIER": "HEATHY, abounding in heath [adj]\n",
  "HEATHIEST": "HEATHY, abounding in heath [adj]\n",
  "HEATHLAND": "barren open country, esp. covered with ericaceous and other low shrubs [n -S]\n",
  "HEATHLANDS": "HEATHLAND, barren open country, esp. covered with ericaceous and other low shrubs [n]\n",
  "HEATHLESS": "without heath [adj]\n",
  "HEATHLIKE": "like a heath [adj]\n",
  "HEATHS": "HEATH, an evergreen shrub [n]\n",
  "HEATHY": "abounding in heath [adj HEATHIER, HEATHIEST]\n",
  "HEATING": "the provision of heat for a building [n -S]\n",
  "HEATINGS": "HEATING, the provision of heat for a building [n]\n",
  "HEATLESS": "having no heat [adj]\n",
  "HEATPROOF": "resistant to heat [adj]\n",
  "HEATS": "HEAT, to make hot [v]\n",
  "HEATSPOT": "a spot or blotch on the skin caused by heat [n -S]\n",
  "HEATSPOTS": "HEATSPOT, a spot or blotch on the skin caused by heat [n]\n",
  "HEATSTROKE": "a condition marked esp. by cessation of sweating, extremely high body temperature, and collapse that results from prolonged exposure to high temperature [n -S]\n",
  "HEATSTROKES": "HEATSTROKE, a condition marked esp. by cessation of sweating, extremely high body temperature, and collapse that results from prolonged exposure to high temperature [n]\n",
  "HEATWAVE": "a spell of unusually hot weather [n -S]\n",
  "HEATWAVES": "HEATWAVE, a spell of unusually hot weather [n]\n",
  "HEAUME": "(archaic) a massive helmet [n -S]\n",
  "HEAUMES": "HEAUME, (archaic) a massive helmet [n]\n",
  "HEAVE": "to lift forcefully [v HEAVED or HOVE, HEAVING, HEAVES]\n",
  "HEAVED": "HEAVE, to lift forcefully [v]\n",
  "HEAVEN": "the sky [n -S]\n",
  "HEAVENLIER": "HEAVENLY, full of beauty and peace [adj]\n",
  "HEAVENLIEST": "HEAVENLY, full of beauty and peace [adj]\n",
  "HEAVENLINESS": "the state of being heavenly [n -ES]\n",
  "HEAVENLINESSES": "HEAVENLINESS, the state of being heavenly [n]\n",
  "HEAVENLY": "full of beauty and peace [adj HEAVENLIER, HEAVENLIEST]\n",
  "HEAVENS": "HEAVEN, the sky [n]\n",
  "HEAVENWARD": "towards heaven, also HEAVENWARDS [adv]\n",
  "HEAVENWARDS": "towards heaven, also HEAVENWARD [adv]\n",
  "HEAVER": "one who heaves [n -S]\n",
  "HEAVERS": "HEAVER, one who heaves [n]\n",
  "HEAVES": "HEAVE, to lift forcefully [v]\n",
  "HEAVIER": "HEAVY, of great weight [adj]\n",
  "HEAVIES": "HEAVY, a large strong person [n]\n",
  "HEAVIEST": "HEAVY, of great weight [adj]\n",
  "HEAVILY": "HEAVY, of great weight [adv]\n",
  "HEAVINESS": "the state of being heavy [n -ES]\n",
  "HEAVINESSES": "HEAVINESS, the state of being heavy [n]\n",
  "HEAVING": "turmoil of waves [n -S]\n",
  "HEAVINGS": "HEAVING, turmoil of waves [n]\n",
  "HEAVY": "of great weight [adj HEAVIER, HEAVIEST, HEAVILY] / a large strong person [n HEAVIES]\n",
  "HEAVYHEARTED": "despondent, saddened [adj HEAVYHEARTEDLY]\n",
  "HEAVYHEARTEDLY": "HEAVYHEARTED, despondent, saddened [adv]\n",
  "HEAVYISH": "somewhat heavy [adj]\n",
  "HEAVYSET": "solidly built; stocky [adj]\n",
  "HEAVYWEIGHT": "a boxer fighting at a heavy weight [n -S]\n",
  "HEAVYWEIGHTS": "HEAVYWEIGHT, a boxer fighting at a heavy weight [n]\n",
  "HEBDOMAD": "the number seven [n -S]\n",
  "HEBDOMADAL": "occurring, appearing, or done every seven days; weekly [adj HEBDOMADALLY]\n",
  "HEBDOMADALLY": "HEBDOMADAL, occurring, appearing, or done every seven days; weekly [adv]\n",
  "HEBDOMADAR": "in Scottish universities, a senior member appointed weekly for the supervision of student discipline, also HEBDOMADER [n -S]\n",
  "HEBDOMADARIES": "HEBDOMADARY, a member of a chapter or convent, who takes his or her weekly turn in performing the sacred offices of the Church [n]\n",
  "HEBDOMADARS": "HEBDOMADAR, in Scottish universities, a senior member appointed weekly for the supervision of student discipline, also HEBDOMADER [n]\n",
  "HEBDOMADARY": "a member of a chapter or convent, who takes his or her weekly turn in performing the sacred offices of the Church [n HEBDOMADARIES]\n",
  "HEBDOMADER": "in Scottish universities, a senior member appointed weekly for the supervision of student discipline, also HEBDOMADAR [n -S]\n",
  "HEBDOMADERS": "HEBDOMADER, in Scottish universities, a senior member appointed weekly for the supervision of student discipline, also HEBDOMADAR [n]\n",
  "HEBDOMADS": "HEBDOMAD, the number seven [n]\n",
  "HEBE": "(Greek) a member of a genus of shrubby plants [n -S]\n",
  "HEBEN": "(obsolete) a hard wood like stone, also EBON, EBONY [n -S]\n",
  "HEBENON": "anything with a poisonous juice, also HEBONA [n -S]\n",
  "HEBENONS": "HEBENON, anything with a poisonous juice, also HEBONA [n]\n",
  "HEBENS": "HEBEN, (obsolete) a hard wood like stone, also EBON, EBONY [n]\n",
  "HEBEPHRENIA": "a form of dementia occurring at puberty [n -S]\n",
  "HEBEPHRENIAC": "one suffering from hebephrenia, a form of dementia occurring at puberty, also HEBEPHRENIC [n -S]\n",
  "HEBEPHRENIACS": "HEBEPHRENIAC, one suffering from hebephrenia, a form of dementia occurring at puberty, also HEBEPHRENIC [n]\n",
  "HEBEPHRENIAS": "HEBEPHRENIA, a form of dementia occurring at puberty [n]\n",
  "HEBEPHRENIC": "one suffering from hebephrenia, a form of dementia occurring at puberty, also HEBEPHRENIAC [n -S]\n",
  "HEBEPHRENICS": "HEBEPHRENIC, one suffering from hebephrenia, a form of dementia occurring at puberty, also HEBEPHRENIAC [n]\n",
  "HEBES": "HEBE, (Greek) a member of a genus of shrubby plants [n]\n",
  "HEBETANT": "making dull [adj]\n",
  "HEBETATE": "to make dull or obtuse [v HEBETATED, HEBETATING, HEBETATES]\n",
  "HEBETATED": "HEBETATE, to make dull or obtuse [v]\n",
  "HEBETATES": "HEBETATE, to make dull or obtuse [v]\n",
  "HEBETATING": "HEBETATE, to make dull or obtuse [v]\n",
  "HEBETATION": "the act of making blunt, dull, or stupid [n -S]\n",
  "HEBETATIONS": "HEBETATION, the act of making blunt, dull, or stupid [n]\n",
  "HEBETATIVE": "making blunt or dull [adj]\n",
  "HEBETIC": "of or pertaining to puberty [adj]\n",
  "HEBETUDE": "mental dullness [n -S]\n",
  "HEBETUDES": "HEBETUDE, mental dullness [n]\n",
  "HEBETUDINOSITY": "the state of being hebetudinous, dull or lethargic [n]\n",
  "HEBETUDINOUS": "dull or lethargic, esp. relating to the mind [adj]\n",
  "HEBONA": "anything with a poisonous juice, also HEBENON [n -S]\n",
  "HEBONAS": "HEBONA, anything with a poisonous juice, also HEBENON [n]\n",
  "HEBRAISATION": "the act of hebraising, also HEBRAIZATION [n -S]\n",
  "HEBRAISATIONS": "HEBRAISATION, the act of hebraising, also HEBRAIZATION [n]\n",
  "HEBRAISE": "to make Hebrew, also HEBRAIZE [v HEBRAISED, HEBRAISING, HEBRAISES]\n",
  "HEBRAISED": "HEBRAISE, to make Hebrew, also HEBRAIZE [v]\n",
  "HEBRAISES": "HEBRAISE, to make Hebrew, also HEBRAIZE [v]\n",
  "HEBRAISING": "HEBRAISE, to make Hebrew, also HEBRAIZE [v]\n",
  "HEBRAIZATION": "the act of hebraizing, also HEBRAISATION [n -S]\n",
  "HEBRAIZATIONS": "HEBRAIZATION, the act of hebraizing, also HEBRAISATION [n]\n",
  "HEBRAIZE": "to make Hebrew, also HEBRAISE [v HEBRAIZED, HEBRAIZING, HEBRAIZES]\n",
  "HEBRAIZED": "HEBRAIZE, to make Hebrew, also HEBRAISE [v]\n",
  "HEBRAIZES": "HEBRAIZE, to make Hebrew, also HEBRAISE [v]\n",
  "HEBRAIZING": "HEBRAIZE, to make Hebrew, also HEBRAISE [v]\n",
  "HECATOMB": "a great public sacrifice [n -S]\n",
  "HECATOMBS": "HECATOMB, a great public sacrifice [n]\n",
  "HECH": "an exclamation of surprise [interj]\n",
  "HECHT": "(Scots) to command, also HIGHT, HETE [v HECHT, HOTEN, HECHTING, HECHTS]\n",
  "HECHTING": "HECHT, (Scots) to command, also HIGHT, HETE [v]\n",
  "HECHTS": "HECHT, (Scots) to command, also HIGHT, HETE [v]\n",
  "HECK": "the lower part of a door, an inner door, a grating [n -S]\n",
  "HECKELPHONE": "an instrument of the oboe family [n -S]\n",
  "HECKELPHONES": "HECKELPHONE, an instrument of the oboe family [n]\n",
  "HECKLE": "a comb for flax or hemp, also HACKLE, HATCHEL [n -S] / to harass a speaker [v HECKLED, HECKLING, HECKLES]\n",
  "HECKLED": "HECKLE, to harass a speaker [v]\n",
  "HECKLER": "one that heckles [n -S]\n",
  "HECKLERS": "HECKLER, one that heckles [n]\n",
  "HECKLES": "HECKLE, to harass a speaker [v]\n",
  "HECKLING": "the act of disrupting a speaker [n -S]\n",
  "HECKLINGS": "HECKLING, the act of disrupting a speaker [n]\n",
  "HECKS": "HECK, the lower part of a door, an inner door, a grating [n]\n",
  "HECKUVA": "a heck of a [adj]\n",
  "HECOGENIN": "a chemical obtained from various plants, esp. sisal, used in the manufacture of cortisone [n -S]\n",
  "HECOGENINS": "HECOGENIN, a chemical obtained from various plants, esp. sisal, used in the manufacture of cortisone [n]\n",
  "HECTARE": "a measure of area, 100 ares or 10000 square metres, also HEKTARE [n -S]\n",
  "HECTARES": "HECTARE, a measure of area, 100 ares or 10000 square metres, also HEKTARE [n]\n",
  "HECTIC": "habitual, esp. in wasting diseases, feverish [adj HECTICLY or HECTICALLY] / a hectic fever [n -S]\n",
  "HECTICAL": "hectic, flushed [adj HECTICALLY]\n",
  "HECTICALLY": "HECTICAL, hectic, flushed [adv]\n",
  "HECTICLY": "HECTIC, habitual, esp. in wasting diseases, feverish [adv]\n",
  "HECTICS": "HECTIC, a hectic fever [n]\n",
  "HECTOCOTYLI": "HECTOCOTYLUS, a tentacle in certain male cephalopod molluscs, such as the octopus, that is specialized for transferring spermatozoa to the female [n]\n",
  "HECTOCOTYLUS": "a tentacle in certain male cephalopod molluscs, such as the octopus, that is specialized for transferring spermatozoa to the female [n HECTOCOTYLI]\n",
  "HECTOGRAM": "a measure of weight, containing a hundred grams, also HECTOGRAMME, HEKTOGRAM [n -S]\n",
  "HECTOGRAMME": "a measure of weight, containing a hundred grams, also HECTOGRAM, HEKTOGRAM [n -S]\n",
  "HECTOGRAMMES": "HECTOGRAMME, a measure of weight, containing a hundred grams, also HECTOGRAM, HEKTOGRAM [n]\n",
  "HECTOGRAMS": "HECTOGRAM, a measure of weight, containing a hundred grams, also HECTOGRAMME, HEKTOGRAM [n]\n",
  "HECTOGRAPH": "a contrivance for multiple copying, by means of a surface of gelatin softened with glycerin [n -S] / to copy by hectograph [v -ED, -ING, -S]\n",
  "HECTOGRAPHED": "HECTOGRAPH, to copy by hectograph [v]\n",
  "HECTOGRAPHIC": "relating to a hectograph [adj]\n",
  "HECTOGRAPHIES": "HECTOGRAPHY, the process of copying using a hectograph [n]\n",
  "HECTOGRAPHING": "HECTOGRAPH, to copy by hectograph [v]\n",
  "HECTOGRAPHS": "HECTOGRAPH, to copy by hectograph [v]\n",
  "HECTOGRAPHY": "the process of copying using a hectograph [n HECTOGRAPHIES]\n",
  "HECTOLITER": "a measure of liquids, containing a hundred liters, also HECTOLITRE [n -S]\n",
  "HECTOLITERS": "HECTOLITER, a measure of liquids, containing a hundred liters, also HECTOLITRE [n]\n",
  "HECTOLITRE": "a measure of liquids, containing a hundred liters, also HECTOLITER [n -S]\n",
  "HECTOLITRES": "HECTOLITRE, a measure of liquids, containing a hundred liters, also HECTOLITER [n]\n",
  "HECTOMETER": "a measure of length, equal to a hundred meters, also HECTOMETRE [n -S]\n",
  "HECTOMETERS": "HECTOMETER, a measure of length, equal to a hundred meters, also HECTOMETRE [n]\n",
  "HECTOMETRE": "a measure of length, equal to a hundred meters, also HECTOMETER [n -S]\n",
  "HECTOMETRES": "HECTOMETRE, a measure of length, equal to a hundred meters, also HECTOMETER [n]\n",
  "HECTOR": "to intimidate or harass by bluster or personal pressure [v -ED, -ING, -S]\n",
  "HECTORED": "HECTOR, to intimidate or harass by bluster or personal pressure [v]\n",
  "HECTORER": "one who hectors [n -S]\n",
  "HECTORERS": "HECTORER, one who hectors [n]\n",
  "HECTORING": "intimidating [adj HECTORINGLY] / the act of hectoring [n -S]\n",
  "HECTORINGLY": "HECTORING, intimidating [adv]\n",
  "HECTORINGS": "HECTORING, the act of hectoring [n]\n",
  "HECTORISM": "the disposition or the practice of a hector [n -S]\n",
  "HECTORISMS": "HECTORISM, the disposition or the practice of a hector [n]\n",
  "HECTORLY": "blustering, insolent [adj]\n",
  "HECTORS": "HECTOR, to intimidate or harass by bluster or personal pressure [v]\n",
  "HECTORSHIP": "blustering, bullying [n -S]\n",
  "HECTORSHIPS": "HECTORSHIP, blustering, bullying [n]\n",
  "HECTOSTERE": "a measure of solidity, containing one hundred cubic meters [n -S]\n",
  "HECTOSTERES": "HECTOSTERE, a measure of solidity, containing one hundred cubic meters [n]\n",
  "HEDARIM": "HEDER, (Hebrew) a Jewish school, also CHEDER [n]\n",
  "HEDDLE": "to draw thread through eyes of a loom [v HEDDLED, HEDDLING, HEDDLES]\n",
  "HEDDLED": "HEDDLE, to draw thread through eyes of a loom [v]\n",
  "HEDDLES": "HEDDLE, to draw thread through eyes of a loom [v]\n",
  "HEDDLING": "HEDDLE, to draw thread through eyes of a loom [v]\n",
  "HEDER": "(Hebrew) a Jewish school, also CHEDER [n HEDERS, HADARIM or HEDARIM]\n",
  "HEDERA": "(Latin) ivy [n -S]\n",
  "HEDERAL": "pertaining to a particular ivy genus [adj]\n",
  "HEDERAS": "HEDERA, (Latin) ivy [n]\n",
  "HEDERATED": "crowned with a wreath of ivy, also HEDERAL [adj]\n",
  "HEDERS": "HEDER, (Hebrew) a Jewish school, also CHEDER [n]\n",
  "HEDGE": "to enclose with a dense row of bushes [v HEDGED, HEDGING, HEDGES]\n",
  "HEDGEBILL": "a bill for dressing hedges, a kind of long-handled hatchet [n -S]\n",
  "HEDGEBILLS": "HEDGEBILL, a bill for dressing hedges, a kind of long-handled hatchet [n]\n",
  "HEDGED": "HEDGE, to enclose with a dense row of bushes [v]\n",
  "HEDGEHOG": "a small spiny mammal, also HEDGEPIG [n -S]\n",
  "HEDGEHOGS": "HEDGEHOG, a small spiny mammal, also HEDGEPIG [n]\n",
  "HEDGEHOP": "of a plane, to fly at ground level [v HEDGEHOPPED, HEDGEHOPPING, HEDGEHOPS]\n",
  "HEDGEHOPPED": "HEDGEHOP, of a plane, to fly at ground level [v]\n",
  "HEDGEHOPPER": "a pilot who hedgehops, flies low [n -S]\n",
  "HEDGEHOPPERS": "HEDGEHOPPER, a pilot who hedgehops, flies low [n]\n",
  "HEDGEHOPPING": "flying a plane at ground level [n -S]\n",
  "HEDGEHOPPINGS": "HEDGEHOPPING, flying a plane at ground level [n]\n",
  "HEDGEHOPS": "HEDGEHOP, of a plane, to fly at ground level [v]\n",
  "HEDGEPIG": "a small spiny mammal, also HEDGEHOG [n -S]\n",
  "HEDGEPIGS": "HEDGEPIG, a small spiny mammal, also HEDGEHOG [n]\n",
  "HEDGER": "one that hedges [n -S]\n",
  "HEDGEROW": "a row of bushes [n -S]\n",
  "HEDGEROWS": "HEDGEROW, a row of bushes [n]\n",
  "HEDGERS": "HEDGER, one that hedges [n]\n",
  "HEDGES": "HEDGE, to enclose with a dense row of bushes [v]\n",
  "HEDGIER": "HEDGY, abounding in hedges [adj]\n",
  "HEDGIEST": "HEDGY, abounding in hedges [adj]\n",
  "HEDGING": "the work of a hedger [n -S]\n",
  "HEDGINGLY": "HEDGING [adv]\n",
  "HEDGINGS": "HEDGING, the work of a hedger [n]\n",
  "HEDGY": "abounding in hedges [adj HEDGIER, HEDGIEST]\n",
  "HEDONIC": "pertaining to pleasure [adj HEDONICALLY]\n",
  "HEDONICALLY": "HEDONIC, pertaining to pleasure [adv]\n",
  "HEDONICS": "the doctrine of pleasure; that part of ethics which treats of pleasure [n]\n",
  "HEDONISM": "the pursuit of pleasure [n -S]\n",
  "HEDONISMS": "HEDONISM, the pursuit of pleasure [n]\n",
  "HEDONIST": "one who believes that pleasure is the chief good in life [n -S]\n",
  "HEDONISTIC": "following the doctrines of hedonism, that avoidance of pain is the supreme good [adj HEDONISTICALLY]\n",
  "HEDONISTICALLY": "HEDONISTIC, following the doctrines of hedonism, that avoidance of pain is the supreme good [adv]\n",
  "HEDONISTS": "HEDONIST, one who believes that pleasure is the chief good in life [n]\n",
  "HEDYPHANE": "a white variety of green lead ore, arsenate, phosphate and chlorate of lead and calcium with barium [n -S]\n",
  "HEDYPHANES": "HEDYPHANE, a white variety of green lead ore, arsenate, phosphate and chlorate of lead and calcium with barium [n]\n",
  "HEDYSARUM": "a leguminous plant of the genus Hedysarum including both poisonous species and those with edible roots, e.g. licorice root [n -S]\n",
  "HEDYSARUMS": "HEDYSARUM, a leguminous plant of the genus Hedysarum including both poisonous species and those with edible roots, e.g. licorice root [n]\n",
  "HEED": "to pay attention to [v -ED, -ING, -S]\n",
  "HEEDED": "HEED, to pay attention to [v]\n",
  "HEEDER": "one who heeds [n -S]\n",
  "HEEDERS": "HEEDER, one who heeds [n]\n",
  "HEEDFUL": "paying close attention [adj HEEDFULLY]\n",
  "HEEDFULLY": "HEEDFUL, paying close attention [adv]\n",
  "HEEDFULNESS": "the state of being heedful [n -ES]\n",
  "HEEDFULNESSES": "HEEDFULNESS, the state of being heedful [n]\n",
  "HEEDIER": "HEEDY, (Spenser) heedful, careful [adj]\n",
  "HEEDIEST": "HEEDY, (Spenser) heedful, careful [adj]\n",
  "HEEDINESS": "the state of being heedy, heedful [n -ES]\n",
  "HEEDINESSES": "HEEDINESS, the state of being heedy, heedful [n]\n",
  "HEEDING": "HEED, to pay attention to [v]\n",
  "HEEDLESS": "paying little of no attention [adj HEEDLESSLY]\n",
  "HEEDLESSLY": "HEEDLESS, paying little of no attention [adv]\n",
  "HEEDLESSNESS": "the state of being heedless [n -ES]\n",
  "HEEDLESSNESSES": "HEEDLESSNESS, the state of being heedless [n]\n",
  "HEEDS": "HEED, to pay attention to [v]\n",
  "HEEDY": "(Spenser) heedful, careful [adj HEEDIER, HEEDIEST]\n",
  "HEEHAW": "to bray like a donkey [v -ED, -ING, -S]\n",
  "HEEHAWED": "HEEHAW, to bray like a donkey [v]\n",
  "HEEHAWING": "HEEHAW, to bray like a donkey [v]\n",
  "HEEHAWS": "HEEHAW, to bray like a donkey [v]\n",
  "HEEL": "to supply with the raised part of a shoe [v -ED, -ING, -S]\n",
  "HEELBALL": "a composition of wax and lampblack, used by shoemakers for polishing, and by antiquaries in copying inscriptions [n -S]\n",
  "HEELBALLS": "HEELBALL, a composition of wax and lampblack, used by shoemakers for polishing, and by antiquaries in copying inscriptions [n]\n",
  "HEELBAR": "a shop or counter where shoes, etc. are repaired [n -S]\n",
  "HEELBARS": "HEELBAR, a shop or counter where shoes, etc. are repaired [n]\n",
  "HEELED": "HEEL, to supply with the raised part of a shoe [v]\n",
  "HEELER": "a dog that herds cattle by biting at their heels [n -S]\n",
  "HEELERS": "HEELER, a dog that herds cattle by biting at their heels [n]\n",
  "HEELING": "the act of inclining laterally [n -S]\n",
  "HEELINGS": "HEELING, the act of inclining laterally [n]\n",
  "HEELLESS": "without heels [adj]\n",
  "HEELPIECE": "a piece of armor to protect the heels [n -S]\n",
  "HEELPIECES": "HEELPIECE, a piece of armor to protect the heels [n]\n",
  "HEELPLATE": "a reinforcing piece of metal for a shoe [n -S]\n",
  "HEELPLATES": "HEELPLATE, a reinforcing piece of metal for a shoe [n]\n",
  "HEELPOST": "the post supporting the outer end of a propeller shaft [n -S]\n",
  "HEELPOSTS": "HEELPOST, the post supporting the outer end of a propeller shaft [n]\n",
  "HEELS": "HEEL, to supply with the raised part of a shoe [v]\n",
  "HEELTAP": "a small amount of liquor left in the glass after drinking [n -S]\n",
  "HEELTAPS": "HEELTAP, a small amount of liquor left in the glass after drinking [n]\n",
  "HEEZE": "(Scots) to lift, hoist [v HEEZED, HEEZING, HEEZES]\n",
  "HEEZED": "HEEZE, (Scots) to lift, hoist [v]\n",
  "HEEZES": "HEEZE, (Scots) to lift, hoist [v]\n",
  "HEEZIE": "(Scots) a lift [n -S]\n",
  "HEEZIES": "HEEZIE, (Scots) a lift [n]\n",
  "HEEZING": "HEEZE, (Scots) to lift, hoist [v]\n",
  "HEFT": "to lift up, feel the weight of [v -ED, -ING, -S]\n",
  "HEFTE": "(Spenser) heaved [v]\n",
  "HEFTED": "HEFT, to lift up, feel the weight of [v]\n",
  "HEFTER": "one who hefts, lifts up [n -S]\n",
  "HEFTERS": "HEFTER, one who hefts, lifts up [n]\n",
  "HEFTIER": "HEFTY, big of build [adj]\n",
  "HEFTIEST": "HEFTY, big of build [adj]\n",
  "HEFTILY": "HEFTY, big of build [adv]\n",
  "HEFTINESS": "the state of being hefty [n -ES]\n",
  "HEFTINESSES": "HEFTINESS, the state of being hefty [n]\n",
  "HEFTING": "HEFT, to lift up, feel the weight of [v]\n",
  "HEFTS": "HEFT, to lift up, feel the weight of [v]\n",
  "HEFTY": "big of build [adj HEFTIER, HEFTIEST, HEFTILY]\n",
  "HEGARI": "a kind of sorghum grain [n -S]\n",
  "HEGARIS": "HEGARI, a kind of sorghum grain [n]\n",
  "HEGEMON": "a political state having hegemony [n -S]\n",
  "HEGEMONIAL": "relating to a hegemony, also HEGEMONIC, HEGEMONICAL [adj]\n",
  "HEGEMONIC": "relating to a hegemony, also HEGEMONIAL, HEGEMONICAL [adj]\n",
  "HEGEMONICAL": "relating to a hegemony, also HEGEMONIAL, HEGEMONIC [adj]\n",
  "HEGEMONIES": "HEGEMONY, (Greek) leadership [n]\n",
  "HEGEMONISM": "the state of being a hegemony [n -S]\n",
  "HEGEMONISMS": "HEGEMONISM, the state of being a hegemony [n]\n",
  "HEGEMONIST": "one who exercises a hegemony [n -S]\n",
  "HEGEMONISTS": "HEGEMONIST, one who exercises a hegemony [n]\n",
  "HEGEMONS": "HEGEMON, a political state having hegemony [n]\n",
  "HEGEMONY": "(Greek) leadership [n HEGEMONIES]\n",
  "HEGIRA": "(Arabic) the flight of Mohammed from Mecca, also HEJIRA, HEJRA, HIJRA, HIJRAH [n -S]\n",
  "HEGIRAS": "HEGIRA, (Arabic) the flight of Mohammed from Mecca, also HEJIRA, HEJRA, HIJRA, HIJRAH [n]\n",
  "HEGUMEN": "the head of a monastery, also HEGUMENOS [n -S]\n",
  "HEGUMENE": "the head of a nunnery [n -S]\n",
  "HEGUMENES": "HEGUMENE, the head of a nunnery [n]\n",
  "HEGUMENIES": "HEGUMENY, the office of hegumen, the head of a monastery [n]\n",
  "HEGUMENOI": "HEGUMENOS, (Greek) the head of a monastery, also HEGUMEN [n]\n",
  "HEGUMENOS": "(Greek) the head of a monastery, also HEGUMEN [n HEGUMENOI or HEGUMENOSES]\n",
  "HEGUMENOSES": "HEGUMENOS, (Greek) the head of a monastery, also HEGUMEN [n]\n",
  "HEGUMENS": "HEGUMEN, the head of a monastery, also HEGUMENOS [n]\n",
  "HEGUMENY": "the office of hegumen, the head of a monastery [n HEGUMENIES]\n",
  "HEH": "a Hebrew letter [n -S]\n",
  "HEHS": "HEH, a Hebrew letter [n]\n",
  "HEID": "(Scots) head [n -S]\n",
  "HEIDS": "HEID, (Scots) head [n]\n",
  "HEIDUC": "(Hungarian) a brigand, a guerilla warrior, also HAIDUK, HEYDUCK [n -S]\n",
  "HEIDUCS": "HEIDUC, (Hungarian) a brigand, a guerilla warrior, also HAIDUK, HEYDUCK [n]\n",
  "HEIFER": "a young cow that has had no more than one calf [n -S]\n",
  "HEIFERS": "HEIFER, a young cow that has had no more than one calf [n]\n",
  "HEIGH": "a cry used to attract attention [interj]\n",
  "HEIGHT": "the highest point, also HEIGHTH, HIGHTH [n -S]\n",
  "HEIGHTEN": "to raise [v -ED, -ING, -S]\n",
  "HEIGHTENED": "HEIGHTEN, to raise [v]\n",
  "HEIGHTENER": "something that heightens [n -S]\n",
  "HEIGHTENERS": "HEIGHTENER, something that heightens [n]\n",
  "HEIGHTENING": "HEIGHTEN, to raise [v]\n",
  "HEIGHTENS": "HEIGHTEN, to raise [v]\n",
  "HEIGHTH": "(archaic) height, also HIGHTH [n -S]\n",
  "HEIGHTHS": "HEIGHTH, (archaic) height, also HIGHTH [n]\n",
  "HEIGHTISM": "discrimination on grounds of height [n -S]\n",
  "HEIGHTISMS": "HEIGHTISM, discrimination on grounds of height [n]\n",
  "HEIGHTS": "HEIGHT, the highest point, also HEIGHTH, HIGHTH [n]\n",
  "HEIL": "(German) to salute [v -ED, -ING, -S]\n",
  "HEILED": "HEIL, (German) to salute [v]\n",
  "HEILING": "HEIL, (German) to salute [v]\n",
  "HEILS": "HEIL, (German) to salute [v]\n",
  "HEIMISH": "(German) homelike, also HAIMISH [adj]\n",
  "HEINIE": "the buttocks [n -S]\n",
  "HEINIES": "HEINIE, the buttocks [n]\n",
  "HEINOUS": "very wicked [adj HEINOUSLY]\n",
  "HEINOUSLY": "HEINOUS, very wicked [adv]\n",
  "HEINOUSNESS": "hateful or shocking evil [n -ES]\n",
  "HEINOUSNESSES": "HEINOUSNESS, hateful or shocking evil [n]\n",
  "HEIR": "a person who actually succeeds to property, title, etc. on the death of its previous holder [n -S] / to inherit [v -ED, -ING, -S]\n",
  "HEIRDOM": "the state of an heir; succession by inheritance [n -S]\n",
  "HEIRDOMS": "HEIRDOM, the state of an heir; succession by inheritance [n]\n",
  "HEIRED": "HEIR, to inherit [v]\n",
  "HEIRESS": "a female inheritor [n -ES]\n",
  "HEIRESSES": "HEIRESS, a female inheritor [n]\n",
  "HEIRING": "HEIR, to inherit [v]\n",
  "HEIRLESS": "without an heir [adj]\n",
  "HEIRLOOM": "an inherited possession [n -S]\n",
  "HEIRLOOMS": "HEIRLOOM, an inherited possession [n]\n",
  "HEIRS": "HEIR, to inherit [v]\n",
  "HEIRSHIP": "the right of inheritance [n -S]\n",
  "HEIRSHIPS": "HEIRSHIP, the right of inheritance [n]\n",
  "HEISHI": "(Japanese) tiny beads made from shells [n]\n",
  "HEIST": "to steal, rob [v -ED, -ING, -S]\n",
  "HEISTED": "HEIST, to steal, rob [v]\n",
  "HEISTER": "one who heists, carries out armed holdups [n -S]\n",
  "HEISTERS": "HEISTER, one who heists, carries out armed holdups [n]\n",
  "HEISTING": "HEIST, to steal, rob [v]\n",
  "HEISTS": "HEIST, to steal, rob [v]\n",
  "HEITIKI": "(Maori) a neck ornament made from greenstone [n -S]\n",
  "HEITIKIS": "HEITIKI, (Maori) a neck ornament made from greenstone [n]\n",
  "HEJAB": "(Arabic) a covering for a Muslim woman's head and face, also HIJAB [n -S]\n",
  "HEJABS": "HEJAB, (Arabic) a covering for a Muslim woman's head and face, also HIJAB [n]\n",
  "HEJIRA": "(Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJRA, HIJRA, HIJRAH [n -S]\n",
  "HEJIRAS": "HEJIRA, (Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJRA, HIJRA, HIJRAH [n]\n",
  "HEJRA": "(Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJIRA, HIJRA, HIJRAH [n -S]\n",
  "HEJRAS": "HEJRA, (Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJIRA, HIJRA, HIJRAH [n]\n",
  "HEKETARA": "(Maori) a small shrub that has flowers with white petals and yellow centres [n -S]\n",
  "HEKETARAS": "HEKETARA, (Maori) a small shrub that has flowers with white petals and yellow centres [n]\n",
  "HEKTARE": "a measure of area, 100 ares or 10000 square metres, also HECTARE [n -S]\n",
  "HEKTARES": "HEKTARE, a measure of area, 100 ares or 10000 square metres, also HECTARE [n]\n",
  "HEKTOGRAM": "a measure of weight, containing a hundred grams, also HECTOGRAM, HECTOGRAMME [n -S]\n",
  "HEKTOGRAMS": "HEKTOGRAM, a measure of weight, containing a hundred grams, also HECTOGRAM, HECTOGRAMME [n]\n",
  "HELCOID": "(Greek) ulcerous [adj]\n",
  "HELD": "HOLD, to keep possession of [v]\n",
  "HELDENTENOR": "(German) a tenor with striking dramatic quality suitable for heroic roles [n -S]\n",
  "HELDENTENORS": "HELDENTENOR, (German) a tenor with striking dramatic quality suitable for heroic roles [n]\n",
  "HELE": "(dialect) to hide [v HELED, HELING, HELES]\n",
  "HELED": "HELE, (dialect) to hide [v]\n",
  "HELENIUM": "a type of daisy-like flower [n -S]\n",
  "HELENIUMS": "HELENIUM, a type of daisy-like flower [n]\n",
  "HELES": "HELE, (dialect) to hide [v]\n",
  "HELIAC": "pertaining to the sun, also HELIACAL [adj HELIACALLY]\n",
  "HELIACAL": "pertaining to the sun, also HELIAC [adj HELIACALLY]\n",
  "HELIACALLY": "HELIACAL, pertaining to the sun, also HELIAC [adv]\n",
  "HELIANTHEMUM": "a garden flower with papery yellow or orange flowers, aka rockrose [n -S]\n",
  "HELIANTHEMUMS": "HELIANTHEMUM, a garden flower with papery yellow or orange flowers, aka rockrose [n]\n",
  "HELIANTHUS": "any plant of the genus Helianthus, such as the sunflower and Jerusalem artichoke [n -ES]\n",
  "HELIANTHUSES": "HELIANTHUS, any plant of the genus Helianthus, such as the sunflower and Jerusalem artichoke [n]\n",
  "HELIAST": "(Greek) an Athenian judge [n -S]\n",
  "HELIASTS": "HELIAST, (Greek) an Athenian judge [n]\n",
  "HELIBORNE": "carried by helicopter [adj]\n",
  "HELIBUS": "a scheduled helicopter service [n HELIBUSES or HELIBUSSES]\n",
  "HELIBUSES": "HELIBUS, a scheduled helicopter service [n]\n",
  "HELIBUSSES": "HELIBUS, a scheduled helicopter service [n]\n",
  "HELICAL": "shaped like a helix [adj HELICALLY]\n",
  "HELICALLY": "HELICAL, shaped like a helix [adv]\n",
  "HELICASE": "any of a group of enzymes that are able to separate the strands of the double-helix of a DNA molecule [n -S]\n",
  "HELICASES": "HELICASE, any of a group of enzymes that are able to separate the strands of the double-helix of a DNA molecule [n]\n",
  "HELICES": "HELIX, (Greek) something spiral in form [n]\n",
  "HELICHRYSUM": "a genus of composite plants, the flowers of which keep their colour and shape when dried [n -S]\n",
  "HELICHRYSUMS": "HELICHRYSUM, a genus of composite plants, the flowers of which keep their colour and shape when dried [n]\n",
  "HELICITIES": "HELICITY, a component of a particle's spin [n]\n",
  "HELICITY": "a component of a particle's spin [n HELICITIES]\n",
  "HELICLINE": "a spiral-shaped ramp [n -S]\n",
  "HELICLINES": "HELICLINE, a spiral-shaped ramp [n]\n",
  "HELICOGRAPH": "an instrument for drawing spirals on a plane [n -S]\n",
  "HELICOGRAPHS": "HELICOGRAPH, an instrument for drawing spirals on a plane [n]\n",
  "HELICOID": "a type of geometrical curve, a flattened spiral [n -S]\n",
  "HELICOIDAL": "relating to a helicoid, a flattened spiral [adj HELICOIDALLY]\n",
  "HELICOIDALLY": "HELICOIDAL, relating to a helicoid, a flattened spiral [adv]\n",
  "HELICOIDS": "HELICOID, a type of geometrical curve, a flattened spiral [n]\n",
  "HELICON": "a large circular brass tuba that fits around the player's shoulder [n -S]\n",
  "HELICONIA": "a tropical flowering plant [n -S]\n",
  "HELICONIAS": "HELICONIA, a tropical flowering plant [n]\n",
  "HELICONS": "HELICON, a large circular brass tuba that fits around the player's shoulder [n]\n",
  "HELICOPT": "to travel by helicopter [v -ED, -ING, -S]\n",
  "HELICOPTED": "HELICOPT, to travel by helicopter [v]\n",
  "HELICOPTER": "a flying machine sustained by rotating blades revolving on a vertical axis above the machine [n -S] / to travel by helicopter [v -ED, -ING, -S]\n",
  "HELICOPTERED": "HELICOPTER, to travel by helicopter [v]\n",
  "HELICOPTERING": "HELICOPTER, to travel by helicopter [v]\n",
  "HELICOPTERS": "HELICOPTER, to travel by helicopter [v]\n",
  "HELICOPTING": "HELICOPT, to travel by helicopter [v]\n",
  "HELICOPTS": "HELICOPT, to travel by helicopter [v]\n",
  "HELICTITE": "a distorted form of stalactite resembling a twig [n -S]\n",
  "HELICTITES": "HELICTITE, a distorted form of stalactite resembling a twig [n]\n",
  "HELIDECK": "a landing deck for helicopters on a ship [n -S]\n",
  "HELIDECKS": "HELIDECK, a landing deck for helicopters on a ship [n]\n",
  "HELIDROME": "an airport for helicopters [n -S]\n",
  "HELIDROMES": "HELIDROME, an airport for helicopters [n]\n",
  "HELILIFT": "to transport by helicopter [v -ED, -ING, -S]\n",
  "HELILIFTED": "HELILIFT, to transport by helicopter [v]\n",
  "HELILIFTING": "HELILIFT, to transport by helicopter [v]\n",
  "HELILIFTS": "HELILIFT, to transport by helicopter [v]\n",
  "HELIMAN": "a helicopter operator [n HELIMEN]\n",
  "HELIMEN": "HELIMAN, a helicopter operator [n]\n",
  "HELING": "HELE, (dialect) to hide [v]\n",
  "HELIO": "a signalling mirror [n -S]\n",
  "HELIOCENTRIC": "referred to or measured from the sun's center or appearing as if seen from it [adj]\n",
  "HELIOCENTRICISM": "the state of being heliocentric [n]\n",
  "HELIOCENTRICITY": "the state of being heliocentric [n]\n",
  "HELIOCHROME": "(tradename) a photograph in natural colours [n -S]\n",
  "HELIOCHROMES": "HELIOCHROME, (tradename) a photograph in natural colours [n]\n",
  "HELIOCHROMIC": "like a heliochrome, a photograph that reproduces the natural colours of the subject [adj]\n",
  "HELIOCHROMIES": "HELIOCHROMY, photography in natural colours [n]\n",
  "HELIOCHROMY": "photography in natural colours [n HELIOCHROMIES]\n",
  "HELIODOR": "(Greek) a variety of clear yellow beryl occurring in SW Africa [n -S]\n",
  "HELIODORS": "HELIODOR, (Greek) a variety of clear yellow beryl occurring in SW Africa [n]\n",
  "HELIOGRAM": "a message sent by reflecting the sun's rays with a mirror [n -S]\n",
  "HELIOGRAMS": "HELIOGRAM, a message sent by reflecting the sun's rays with a mirror [n]\n",
  "HELIOGRAPH": "an apparatus for signalling by means of a movable mirror which reflects flashes of sunshine [n -S] / to signal by heliograph [v -ED, -ING, -S]\n",
  "HELIOGRAPHED": "HELIOGRAPH, to signal by heliograph [v]\n",
  "HELIOGRAPHER": "one who uses a heliograph [n -S]\n",
  "HELIOGRAPHERS": "HELIOGRAPHER, one who uses a heliograph [n]\n",
  "HELIOGRAPHIC": "relating to heliography, also HELIOGRAPHICAL [adj]\n",
  "HELIOGRAPHICAL": "relating to heliography, also HELIOGRAPHIC [adj]\n",
  "HELIOGRAPHIES": "HELIOGRAPHY, the practice of signalling by heliograph [n]\n",
  "HELIOGRAPHING": "HELIOGRAPH, to signal by heliograph [v]\n",
  "HELIOGRAPHS": "HELIOGRAPH, to signal by heliograph [v]\n",
  "HELIOGRAPHY": "the practice of signalling by heliograph [n HELIOGRAPHIES]\n",
  "HELIOGRAVURE": "photogravure [n -S]\n",
  "HELIOGRAVURES": "HELIOGRAVURE, photogravure [n]\n",
  "HELIOLATER": "a sun worshipper [n -S]\n",
  "HELIOLATERS": "HELIOLATER, a sun worshipper [n]\n",
  "HELIOLATRIES": "HELIOLATRY, sun worship [n]\n",
  "HELIOLATROUS": "relating to heliolatry [adj]\n",
  "HELIOLATRY": "sun worship [n HELIOLATRIES]\n",
  "HELIOLITHIC": "of or relating to a civilization characterized by sun worship and megaliths [adj]\n",
  "HELIOLOGIES": "HELIOLOGY, the science of the sun [n]\n",
  "HELIOLOGY": "the science of the sun [n HELIOLOGIES]\n",
  "HELIOMETER": "instrument for measuring apparent diameter of the sun [n -S]\n",
  "HELIOMETERS": "HELIOMETER, instrument for measuring apparent diameter of the sun [n]\n",
  "HELIOMETRIC": "relating to heliometry, also HELIOMETRICAL [adj HELIOMETRICALLY]\n",
  "HELIOMETRICAL": "relating to heliometry, also HELIOMETRIC [adj HELIOMETRICALLY]\n",
  "HELIOMETRICALLY": "HELIOMETRICAL, relating to heliometry, also HELIOMETRIC [adv]\n",
  "HELIOMETRIES": "HELIOMETRY, measurement by use of a heliometer, an instrument for measuring apparent diameter of the sun [n]\n",
  "HELIOMETRY": "measurement by use of a heliometer, an instrument for measuring apparent diameter of the sun [n HELIOMETRIES]\n",
  "HELIOPAUSE": "the upper limit of the earth's atmosphere [n -S]\n",
  "HELIOPAUSES": "HELIOPAUSE, the upper limit of the earth's atmosphere [n]\n",
  "HELIOPHILOUS": "attracted by sunlight [adj]\n",
  "HELIOPHOBIC": "afflicted with a morbid fear of the sun [adj]\n",
  "HELIOPHYTE": "a plant flourishing in sunlight [n -S]\n",
  "HELIOPHYTES": "HELIOPHYTE, a plant flourishing in sunlight [n]\n",
  "HELIOPSES": "HELIOPSIS, a genus of herbaceous flowering plants in the daisy family [n]\n",
  "HELIOPSIS": "a genus of herbaceous flowering plants in the daisy family [n HELIOPSES]\n",
  "HELIOS": "HELIO, a signalling mirror [n]\n",
  "HELIOSCIOPHYTE": "a plant that thrives in sun better than shade [n -S]\n",
  "HELIOSCIOPHYTES": "HELIOSCIOPHYTE, a plant that thrives in sun better than shade [n]\n",
  "HELIOSCOPE": "an instrument for observing the sun without injury to the eyes [n -S]\n",
  "HELIOSCOPES": "HELIOSCOPE, an instrument for observing the sun without injury to the eyes [n]\n",
  "HELIOSCOPIC": "related to a helioscope [adj]\n",
  "HELIOSES": "HELIOSIS, exposure to the sun [n]\n",
  "HELIOSIS": "exposure to the sun [n HELIOSES]\n",
  "HELIOSPHERE": "the region in space influenced by the sun or solar wind [n -S]\n",
  "HELIOSPHERES": "HELIOSPHERE, the region in space influenced by the sun or solar wind [n]\n",
  "HELIOSTAT": "an instrument using a mirror to reflect sunlight in a fixed direction, used for studying the sun or signalling messages [n -S]\n",
  "HELIOSTATIC": "relating to a heliostat [adj]\n",
  "HELIOSTATS": "HELIOSTAT, an instrument using a mirror to reflect sunlight in a fixed direction, used for studying the sun or signalling messages [n]\n",
  "HELIOTACTIC": "relating to heliotaxis, the response of an organism to the sun's rays [adj]\n",
  "HELIOTAXES": "HELIOTAXIS, the response of an organism to the sun's rays [n]\n",
  "HELIOTAXIS": "the response of an organism to the sun's rays [n HELIOTAXES]\n",
  "HELIOTHERAPIES": "HELIOTHERAPY, medical treatment by exposure to the sun's rays [n]\n",
  "HELIOTHERAPY": "medical treatment by exposure to the sun's rays [n HELIOTHERAPIES]\n",
  "HELIOTROPE": "any of a genus of herbs or shrubs of the borage family [n -S]\n",
  "HELIOTROPES": "HELIOTROPE, any of a genus of herbs or shrubs of the borage family [n]\n",
  "HELIOTROPIC": "turning towards the sun, also HELIOTROPICAL [adj HELIOTROPICALLY]\n",
  "HELIOTROPICAL": "turning towards the sun, also HELIOTROPIC [adj HELIOTROPICALLY]\n",
  "HELIOTROPICALLY": "HELIOTROPICAL, turning towards the sun, also HELIOTROPIC [adv]\n",
  "HELIOTROPIES": "HELIOTROPY, the tendency of stems and leaves to bend towards the sun [n]\n",
  "HELIOTROPIN": "a phenolic aldehyde of very pleasant odour, used as a perfume and in flavourings, etc., aka piperonal [n -S]\n",
  "HELIOTROPINS": "HELIOTROPIN, a phenolic aldehyde of very pleasant odour, used as a perfume and in flavourings, etc., aka piperonal [n]\n",
  "HELIOTROPISM": "the movement of plants towards sunlight [n -S]\n",
  "HELIOTROPISMS": "HELIOTROPISM, the movement of plants towards sunlight [n]\n",
  "HELIOTROPY": "the tendency of stems and leaves to bend towards the sun [n HELIOTROPIES]\n",
  "HELIOTYPE": "a picture obtained by the process of heliotypy [n -S] / to obtain such a picture [v HELIOTYPED, HELIOTYPING, HELIOTYPES]\n",
  "HELIOTYPED": "HELIOTYPE, to obtain such a picture [v]\n",
  "HELIOTYPES": "HELIOTYPE, a picture obtained by the process of heliotypy [n]\n",
  "HELIOTYPIC": "relating to, or obtained by, heliotypy [adj]\n",
  "HELIOTYPIES": "HELIOTYPY, a photomechanical process in which the gelatine relief is itself used to print from [n]\n",
  "HELIOTYPING": "HELIOTYPE, to obtain such a picture [v]\n",
  "HELIOTYPY": "a photomechanical process in which the gelatine relief is itself used to print from [n HELIOTYPIES]\n",
  "HELIOZOAN": "related to the Heliozoa, sun-animalcules, an order of Protozoa, also HELIOZOIC [adj] / a member of the Heliozoa [n -S]\n",
  "HELIOZOANS": "HELIOZOAN, a member of the Heliozoa [n]\n",
  "HELIOZOIC": "relating to the Heliozoa, sun-animalcules, an order of Protozoa, also HELIOZOAN [adj]\n",
  "HELIPAD": "a landing pad for helicopters [n -S]\n",
  "HELIPADS": "HELIPAD, a landing pad for helicopters [n]\n",
  "HELIPILOT": "the pilot of a helicopter [n -S]\n",
  "HELIPILOTS": "HELIPILOT, the pilot of a helicopter [n]\n",
  "HELIPORT": "an airport for helicopters, also HELISTOP [n -S]\n",
  "HELIPORTS": "HELIPORT, an airport for helicopters, also HELISTOP [n]\n",
  "HELISKI": "to ski down mountains reached by helicopter [v HELISKIED, HELISKIING, HELISKIS]\n",
  "HELISKIED": "HELISKI, to ski down mountains reached by helicopter [v]\n",
  "HELISKIING": "the sport of skiing down mountains reached by helicopter [n -S]\n",
  "HELISKIINGS": "HELISKIING, the sport of skiing down mountains reached by helicopter [n]\n",
  "HELISKIS": "HELISKI, to ski down mountains reached by helicopter [v]\n",
  "HELISPHERIC": "pertaining to rhumb lines, loxodromic, also HELISPHERICAL [adj]\n",
  "HELISPHERICAL": "pertaining to rhumb lines, loxodromic, also HELISPHERIC [adj]\n",
  "HELISTOP": "an airport for helicopters, also HELIPORT [n -S]\n",
  "HELISTOPS": "HELISTOP, an airport for helicopters, also HELIPORT [n]\n",
  "HELITACK": "the use of helicopters to fight forest fires [n -S]\n",
  "HELITACKS": "HELITACK, the use of helicopters to fight forest fires [n]\n",
  "HELIUM": "a gaseous element [n -S]\n",
  "HELIUMS": "HELIUM, a gaseous element [n]\n",
  "HELIX": "(Greek) something spiral in form [n HELIXES or HELICES]\n",
  "HELIXES": "HELIX, (Greek) something spiral in form [n]\n",
  "HELL": "to hide, conceal [v -ED, -ING, -S]\n",
  "HELLACIOUS": "exceptionally powerful or violent [adj HELLACIOUSLY]\n",
  "HELLACIOUSLY": "HELLACIOUS, exceptionally powerful or violent [adv]\n",
  "HELLBENDER": "a large North American aquatic salamander [n -S]\n",
  "HELLBENDERS": "HELLBENDER, a large North American aquatic salamander [n]\n",
  "HELLBENT": "stubbornly determined [adj]\n",
  "HELLBOX": "a printer's receptacle for broken type [n -ES]\n",
  "HELLBOXES": "HELLBOX, a printer's receptacle for broken type [n]\n",
  "HELLBROTH": "a composition for infernal purposes; a magical preparation [n -S]\n",
  "HELLBROTHS": "HELLBROTH, a composition for infernal purposes; a magical preparation [n]\n",
  "HELLCAT": "a spiteful or furious (esp. female) person, also HELLICAT [n -S]\n",
  "HELLCATS": "HELLCAT, a spiteful or furious (esp. female) person, also HELLICAT [n]\n",
  "HELLDIVER": "a small greyish-brown North American grebe [n -S]\n",
  "HELLDIVERS": "HELLDIVER, a small greyish-brown North American grebe [n]\n",
  "HELLEBORE": "any of various early-flowering plants constituting the genus Helleborus, of the buttercup family [n -S]\n",
  "HELLEBORES": "HELLEBORE, any of various early-flowering plants constituting the genus Helleborus, of the buttercup family [n]\n",
  "HELLEBORINE": "a kind of orchid [n -S]\n",
  "HELLEBORINES": "HELLEBORINE, a kind of orchid [n]\n",
  "HELLED": "HELL, to hide, conceal [v]\n",
  "HELLENISATION": "the act of hellenising, also HELLENIZATION [n -S]\n",
  "HELLENISATIONS": "HELLENISATION, the act of hellenising, also HELLENIZATION [n]\n",
  "HELLENISE": "to use the Greek language; to play the Greek, also HELLENIZE [v HELLENISED, HELLENISING, HELLENISES]\n",
  "HELLENISED": "HELLENISE, to use the Greek language; to play the Greek, also HELLENIZE [v]\n",
  "HELLENISES": "HELLENISE, to use the Greek language; to play the Greek, also HELLENIZE [v]\n",
  "HELLENISING": "HELLENISE, to use the Greek language; to play the Greek, also HELLENIZE [v]\n",
  "HELLENIZATION": "the act of hellenizing, also HELLENISATION [n -S]\n",
  "HELLENIZATIONS": "HELLENIZATION, the act of hellenizing, also HELLENISATION [n]\n",
  "HELLENIZE": "to use the Greek language; to play the Greek; to Grecize, also HELLENISE [v HELLENIZED, HELLENIZING, HELLENIZES]\n",
  "HELLENIZED": "HELLENIZE, to use the Greek language; to play the Greek; to Grecize, also HELLENISE [v]\n",
  "HELLENIZES": "HELLENIZE, to use the Greek language; to play the Greek; to Grecize, also HELLENISE [v]\n",
  "HELLENIZING": "HELLENIZE, to use the Greek language; to play the Greek; to Grecize, also HELLENISE [v]\n",
  "HELLER": "(Czech) a Czech monetary unit, also HALER [n -S]\n",
  "HELLERI": "a tropical fish [n HELLERIS or HELLERIES]\n",
  "HELLERIES": "HELLERI, a tropical fish [n]\n",
  "HELLERIS": "HELLERI, a tropical fish [n]\n",
  "HELLERS": "HELLER, (Czech) a Czech monetary unit, also HALER [n]\n",
  "HELLERY": "(Canadian) wild or mischievous behaviour [n HELLERIES]\n",
  "HELLFIRE": "the torment of hell [n -S]\n",
  "HELLFIRES": "HELLFIRE, the torment of hell [n]\n",
  "HELLGRAMITE": "the large brown aquatic larva of the Dobson fly, also HELLGRAMMITE [n -S]\n",
  "HELLGRAMITES": "HELLGRAMITE, the large brown aquatic larva of the Dobson fly, also HELLGRAMMITE [n]\n",
  "HELLGRAMMITE": "the large brown aquatic larva of the Dobson fly, also HELLGRAMITE [n -S]\n",
  "HELLGRAMMITES": "HELLGRAMMITE, the large brown aquatic larva of the Dobson fly, also HELLGRAMITE [n]\n",
  "HELLHOLE": "a horrible place [n -S]\n",
  "HELLHOLES": "HELLHOLE, a horrible place [n]\n",
  "HELLHOUND": "a devilish dog [n -S]\n",
  "HELLHOUNDS": "HELLHOUND, a devilish dog [n]\n",
  "HELLICAT": "(Scots) a wicked creature, also HELLCAT [n -S]\n",
  "HELLICATS": "HELLICAT, (Scots) a wicked creature, also HELLCAT [n]\n",
  "HELLIER": "a slater, a tiler, a thatcher [n -S]\n",
  "HELLIERS": "HELLIER, a slater, a tiler, a thatcher [n]\n",
  "HELLING": "HELL, to hide, conceal [v]\n",
  "HELLION": "a troublesome person, also HELLER [n -S]\n",
  "HELLIONS": "HELLION, a troublesome person, also HELLER [n]\n",
  "HELLISH": "horrible [adj HELLISHLY]\n",
  "HELLISHLY": "HELLISH, horrible [adv]\n",
  "HELLISHNESS": "the state of being hellish [n -ES]\n",
  "HELLISHNESSES": "HELLISHNESS, the state of being hellish [n]\n",
  "HELLKITE": "an extremely cruel person [n -S]\n",
  "HELLKITES": "HELLKITE, an extremely cruel person [n]\n",
  "HELLO": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S or -ES]\n",
  "HELLOED": "HELLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HELLOES": "HELLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HELLOING": "HELLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HELLOS": "HELLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HELLOVA": "hell of a, also HELLUVA [adj]\n",
  "HELLS": "HELL, to hide, conceal [v]\n",
  "HELLSCAPE": "a hellish landscape : a harshly unpleasant place or environment [n -S]\n",
  "HELLSCAPES": "HELLSCAPE, a hellish landscape : a harshly unpleasant place or environment [n]\n",
  "HELLUVA": "hell of a, also HELLOVA [adj]\n",
  "HELLWARD": "towards hell [adv]\n",
  "HELLWARDS": "in the direction of hell, also HELLWARD [adv]\n",
  "HELM": "to steer a ship [v -ED, -ING, -S]\n",
  "HELMED": "HELM, to steer a ship [v]\n",
  "HELMER": "a film director [n -S]\n",
  "HELMERS": "HELMER, a film director [n]\n",
  "HELMET": "to supply with a protective covering for the head [v -ED, -ING, -S]\n",
  "HELMETED": "HELMET, to supply with a protective covering for the head [v]\n",
  "HELMETING": "the act of fitting with a helmet [n -S]\n",
  "HELMETINGS": "HELMETING, the act of fitting with a helmet [n]\n",
  "HELMETLIKE": "like a helmet [adj]\n",
  "HELMETS": "HELMET, to supply with a protective covering for the head [v]\n",
  "HELMING": "HELM, to steer a ship [v]\n",
  "HELMINTH": "a parasitic intestinal nematode [n -S]\n",
  "HELMINTHIASES": "HELMINTHIASIS, infestation with worms [n]\n",
  "HELMINTHIASIS": "infestation with worms [n HELMINTHIASES]\n",
  "HELMINTHIC": "of or relating to worms, or Helminthes [adj] / a drug for expelling worms [n -S]\n",
  "HELMINTHICS": "HELMINTHIC, a drug for expelling worms [n]\n",
  "HELMINTHOID": "worm-shaped [adj]\n",
  "HELMINTHOLOGIC": "relating to helminthology [adj]\n",
  "HELMINTHOLOGIES": "HELMINTHOLOGY, the study of parasitic worms [n]\n",
  "HELMINTHOLOGIST": "a specialist in helminthology [n]\n",
  "HELMINTHOLOGY": "the study of parasitic worms [n HELMINTHOLOGIES]\n",
  "HELMINTHOUS": "infested with intestinal worms [adj]\n",
  "HELMINTHS": "HELMINTH, a parasitic intestinal nematode [n]\n",
  "HELMLESS": "without a helm [adj]\n",
  "HELMS": "HELM, to steer a ship [v]\n",
  "HELMSMAN": "one who steer a ship [n HELMSMEN]\n",
  "HELMSMANSHIP": "the role or skill of helmsman [n -S]\n",
  "HELMSMANSHIPS": "HELMSMANSHIP, the role or skill of helmsman [n]\n",
  "HELMSMEN": "HELMSMAN, one who steer a ship [n]\n",
  "HELO": "(short for) a helicopter [n -S]\n",
  "HELOPHYTE": "any perennial marsh plant that bears its overwintering buds in the mud below the surface [n -S]\n",
  "HELOPHYTES": "HELOPHYTE, any perennial marsh plant that bears its overwintering buds in the mud below the surface [n]\n",
  "HELOS": "HELO, (short for) a helicopter [n]\n",
  "HELOT": "a slave or serf [n -S]\n",
  "HELOTAGE": "the state of helots or being enslaved [n -S]\n",
  "HELOTAGES": "HELOTAGE, the state of helots or being enslaved [n]\n",
  "HELOTISM": "slavery or serfdom, also HELOTAGE, HELOTRY [n -S]\n",
  "HELOTISMS": "HELOTISM, slavery or serfdom, also HELOTAGE, HELOTRY [n]\n",
  "HELOTRIES": "HELOTRY, slavery or serfdom, also HELOTAGE, HELOTISM [n]\n",
  "HELOTRY": "slavery or serfdom, also HELOTAGE, HELOTISM [n HELOTRIES]\n",
  "HELOTS": "HELOT, a slave or serf [n]\n",
  "HELP": "to give aid [v HOLP or HELPED, HOLPEN, HELPING, HELPS]\n",
  "HELPABLE": "able to be helped [adj]\n",
  "HELPDESK": "a service which provides computer support [n -S]\n",
  "HELPDESKS": "HELPDESK, a service which provides computer support [n]\n",
  "HELPED": "HELP, to give aid [v]\n",
  "HELPER": "one who helps [n -S]\n",
  "HELPERS": "HELPER, one who helps [n]\n",
  "HELPFUL": "giving help [adj HELPFULLY]\n",
  "HELPFULLY": "HELPFUL, giving help [adv]\n",
  "HELPFULNESS": "the state of being helpful [n -ES]\n",
  "HELPFULNESSES": "HELPFULNESS, the state of being helpful [n]\n",
  "HELPING": "a portion of food [n -S]\n",
  "HELPINGS": "HELPING, a portion of food [n]\n",
  "HELPLESS": "defenceless [adj HELPLESSLY]\n",
  "HELPLESSLY": "HELPLESS, defenceless [adv]\n",
  "HELPLESSNESS": "the state of being helpless [n -ES]\n",
  "HELPLESSNESSES": "HELPLESSNESS, the state of being helpless [n]\n",
  "HELPLINE": "an often free telephone line by means of which people with a particular problem may contact advisers who will help them deal with it [n -S]\n",
  "HELPLINES": "HELPLINE, an often free telephone line by means of which people with a particular problem may contact advisers who will help them deal with it [n]\n",
  "HELPMATE": "a friend, companion, also HELPMEET [n -S]\n",
  "HELPMATES": "HELPMATE, a friend, companion, also HELPMEET [n]\n",
  "HELPMEET": "a friend, companion, also HELPMATE [n -S]\n",
  "HELPMEETS": "HELPMEET, a friend, companion, also HELPMATE [n]\n",
  "HELPS": "HELP, to give aid [v]\n",
  "HELVE": "to provide with a handle [v HELVED, HELVING, HELVES]\n",
  "HELVED": "HELVE, to provide with a handle [v]\n",
  "HELVES": "HELVE, to provide with a handle [v]\n",
  "HELVETIUM": "a superseded name for the element astatine [n -S]\n",
  "HELVETIUMS": "HELVETIUM, a superseded name for the element astatine [n]\n",
  "HELVING": "HELVE, to provide with a handle [v]\n",
  "HEM": "to provide with an edge [v HEMMED, HEMMING, HEMS]\n",
  "HEMACHROME": "a blood pigment, such as haemoglobin, that carries oxygen, also HAEMACHROME [n -S]\n",
  "HEMACHROMES": "HEMACHROME, a blood pigment, such as haemoglobin, that carries oxygen, also HAEMACHROME [n]\n",
  "HEMACYTOMETER": "an instrument for counting blood cells, also HAEMACYTOMETER, HAEMOCYTOMETER, HEMOCYTOMETER [n -S]\n",
  "HEMACYTOMETERS": "HEMACYTOMETER, an instrument for counting blood cells, also HAEMACYTOMETER, HAEMOCYTOMETER, HEMOCYTOMETER [n]\n",
  "HEMAGGLUTINATE": "to cause the clumping of red blood cells in (a blood sample), also HAEMAGGLUTINATE [v HEMAGGLUTINATED, HEMAGGLUTINATES]\n",
  "HEMAGGLUTINATED": "HEMAGGLUTINATE, to cause the clumping of red blood cells in (a blood sample), also HAEMAGGLUTINATE [v]\n",
  "HEMAGGLUTINATES": "HEMAGGLUTINATE, to cause the clumping of red blood cells in (a blood sample), also HAEMAGGLUTINATE [v]\n",
  "HEMAGGLUTININ": "a virus, antibody or other agent causing haemagglutination, also HAEMAGGLUTININ [n -S]\n",
  "HEMAGGLUTININS": "HEMAGGLUTININ, a virus, antibody or other agent causing haemagglutination, also HAEMAGGLUTININ [n]\n",
  "HEMAGOG": "an agent that promotes blood flow [n -S]\n",
  "HEMAGOGS": "HEMAGOG, an agent that promotes blood flow [n]\n",
  "HEMAGOGUE": "a drug that promotes the flow of blood, also HAEMAGOGUE, HEMAGOG [n -S]\n",
  "HEMAGOGUES": "HEMAGOGUE, a drug that promotes the flow of blood, also HAEMAGOGUE, HEMAGOG [n]\n",
  "HEMAL": "pertaining to the blood, also HAEMAL, HAEMATAL, HAEMIC, HAEMOID, HEMATAL, HEMIC, HEMOID [adj]\n",
  "HEMANGIOMA": "a usually benign tumour made up of blood vessels, also HAEMANGIOMA [n HEMANGIOMAS or HEMANGIOMATA]\n",
  "HEMANGIOMAS": "HEMANGIOMA, a usually benign tumour made up of blood vessels, also HAEMANGIOMA [n]\n",
  "HEMANGIOMATA": "HEMANGIOMA, a usually benign tumour made up of blood vessels, also HAEMANGIOMA [n]\n",
  "HEMATAL": "pertaining to the blood, also HAEMAL, HAEMATAL, HAEMIC, HAEMOID, HEMAL, HEMIC, HEMOID [adj]\n",
  "HEMATEIN": "a reddish brown or violet crystalline substance got from hematoxylin by partial oxidation, also HAEMATEIN [n -S]\n",
  "HEMATEINS": "HEMATEIN, a reddish brown or violet crystalline substance got from hematoxylin by partial oxidation, also HAEMATEIN [n]\n",
  "HEMATEMESES": "HEMATEMESIS, vomiting of blood, esp. as the result of a bleeding ulcer, also HAEMATEMESIS [n]\n",
  "HEMATEMESIS": "vomiting of blood, esp. as the result of a bleeding ulcer, also HAEMATEMESIS [n HEMATEMESES]\n",
  "HEMATIC": "a medicine for a blood disease, also HAEMATIC [n -S]\n",
  "HEMATICS": "HEMATIC, a medicine for a blood disease, also HAEMATIC [n]\n",
  "HEMATIN": "a compound of hemoglobin, also HEMATINE [n -S]\n",
  "HEMATINE": "a compound of hemoglobin, also HEMATIN [n -S]\n",
  "HEMATINES": "HEMATINE, a compound of hemoglobin, also HEMATIN [n]\n",
  "HEMATINIC": "a substance having the effect of increasing the haemoglobin or of stimulating the production of red blood cells, also HAEMATINIC [n -S]\n",
  "HEMATINICS": "HEMATINIC, a substance having the effect of increasing the haemoglobin or of stimulating the production of red blood cells, also HAEMATINIC [n]\n",
  "HEMATINS": "HEMATIN, a compound of hemoglobin, also HEMATINE [n]\n",
  "HEMATITE": "an ore of iron, also HAEMATITE [n -S]\n",
  "HEMATITES": "HEMATITE, an ore of iron, also HAEMATITE [n]\n",
  "HEMATITIC": "of or pertaining to hematite, or resembling it, also HAEMATITIC [adj]\n",
  "HEMATOBLAST": "a blood platelet, also HAEMATOBLAST [n -S]\n",
  "HEMATOBLASTIC": "of or like hematoblast, a blood platelet, also HAEMATOBLASTIC [adj]\n",
  "HEMATOBLASTS": "HEMATOBLAST, a blood platelet, also HAEMATOBLAST [n]\n",
  "HEMATOCELE": "a cavity containing blood, also HAEMATOCELE [n -S]\n",
  "HEMATOCELES": "HEMATOCELE, a cavity containing blood, also HAEMATOCELE [n]\n",
  "HEMATOCRIT": "a graduated capillary tube in which the blood is centrifuged, to determine the ratio, by volume, of blood cells to plasma, also HAEMATOCRIT [n -S]\n",
  "HEMATOCRITS": "HEMATOCRIT, a graduated capillary tube in which the blood is centrifuged, to determine the ratio, by volume, of blood cells to plasma, also HAEMATOCRIT [n]\n",
  "HEMATOCRYAL": "of all animals except birds and mammals, having a body temperature that varies with the temperature of the surroundings, also HAEMATOCRYAL [adj]\n",
  "HEMATOGENESES": "HEMATOGENESIS, the production of blood, also HAEMATOGENESIS [n]\n",
  "HEMATOGENESIS": "the production of blood, also HAEMATOGENESIS [n HEMATOGENESES]\n",
  "HEMATOGENETIC": "relating to hematogenesis, the production of blood, also HAEMATOGENETIC [adj]\n",
  "HEMATOGENIC": "(US) forming blood, also HAEMATOGENIC [adj]\n",
  "HEMATOGENOUS": "producing blood, also HAEMATOGENOUS [adj]\n",
  "HEMATOID": "resembling blood, also HAEMATOID [adj]\n",
  "HEMATOLOGIC": "of or relating to blood or to hematology, also HAEMATOLOGIC, HAEMATOLOGICAL, HEMATOLOGICAL [adj]\n",
  "HEMATOLOGICAL": "of or relating to blood or to hematology, also HAEMATOLOGIC, HAEMATOLOGICAL, HEMATOLOGIC [adj]\n",
  "HEMATOLOGIES": "HEMATOLOGY, the study of blood, also HAEMATOLOGY [n]\n",
  "HEMATOLOGIST": "a specialist in hematology, also HAEMATOLOGIST [n -S]\n",
  "HEMATOLOGISTS": "HEMATOLOGIST, a specialist in hematology, also HAEMATOLOGIST [n]\n",
  "HEMATOLOGY": "the study of blood, also HAEMATOLOGY [n HEMATOLOGIES]\n",
  "HEMATOLYSES": "HEMATOLYSIS, the disintegration of red blood cells, with the release of haemoglobin, occurring in the living organism or in a blood sample, also HAEMATOLYSIS [n]\n",
  "HEMATOLYSIS": "the disintegration of red blood cells, with the release of haemoglobin, occurring in the living organism or in a blood sample, also HAEMATOLYSIS [n HEMATOLYSES]\n",
  "HEMATOMA": "swelling filled with blood [n HEMATOMAS or HEMATOMATA]\n",
  "HEMATOMAS": "HEMATOMA, swelling filled with blood [n]\n",
  "HEMATOMATA": "HEMATOMA, swelling filled with blood [n]\n",
  "HEMATOPHAGOUS": "of certain animals, feeding on blood, also HAEMATOPHAGOUS [adj]\n",
  "HEMATOPOIESES": "HEMATOPOIESIS, the formation of blood, also HAEMATOPOIESIS, HAEMOPOIESIS, HEMOPOIESIS [n]\n",
  "HEMATOPOIESIS": "the formation of blood, also HAEMATOPOIESIS, HAEMOPOIESIS, HEMOPOIESIS [n HEMATOPOIESES]\n",
  "HEMATOPOIETIC": "relating to hematopoiesis, the formation of blood, also HAEMATOPOIETIC [adj]\n",
  "HEMATOPORPHYRIN": "any of several porphyrins that are hydrated derivatives of protoporphyrins [n]\n",
  "HEMATOSES": "HEMATOSIS, the formation of blood; conversion of venous into arterial blood, also HAEMATOSIS [n]\n",
  "HEMATOSIS": "the formation of blood; conversion of venous into arterial blood, also HAEMATOSIS [n HEMATOSES]\n",
  "HEMATOTHERMAL": "of birds and mammals, having a constant body temperature, usually higher than the temperature of the surroundings, also HAEMATOTHERMAL [adj]\n",
  "HEMATOXYLIN": "a dye obtained from logwood, also HAEMATOXYLIN [n -S]\n",
  "HEMATOXYLINS": "HEMATOXYLIN, a dye obtained from logwood, also HAEMATOXYLIN [n]\n",
  "HEMATOZOA": "HEMATOZOON, a protozoan that is parasitic in the blood, also HAEMATOZOON [n]\n",
  "HEMATOZOON": "a protozoan that is parasitic in the blood, also HAEMATOZOON [n HEMATOZOA]\n",
  "HEMATURIA": "the presence of blood in urine, also HAEMATURIA [n -S]\n",
  "HEMATURIAS": "HEMATURIA, the presence of blood in urine, also HAEMATURIA [n]\n",
  "HEMATURIC": "relating to hematuria, the presence of blood in urine, also HAEMATURIC [adj]\n",
  "HEME": "a component of hemoglobin, also HAEM [n -S]\n",
  "HEMELYTRA": "HEMELYTRON, an insect forewing thickened at the base, membranous at the apex, also HEMELYTRUM, HEMIELYTRON [n]\n",
  "HEMELYTRAL": "relating to the hemelytron, the insect forewing, also HEMIELYTRAL [adj]\n",
  "HEMELYTRON": "an insect forewing thickened at the base, membranous at the apex, also HEMELYTRUM, HEMIELYTRON [n HEMELYTRA]\n",
  "HEMELYTRUM": "an insect forewing thickened at the base, membranous at the apex, also HEMELYTRON, HEMIELYTRON [n HEMELYTRA]\n",
  "HEMERALOPIA": "the condition of seeing well at night or in partial darkness, while the day sight is poor [n -S]\n",
  "HEMERALOPIAS": "HEMERALOPIA, the condition of seeing well at night or in partial darkness, while the day sight is poor [n]\n",
  "HEMERALOPIC": "relating to hemeralopia [adj]\n",
  "HEMEROCALLIS": "the daylily [n -ES]\n",
  "HEMEROCALLISES": "HEMEROCALLIS, the daylily [n]\n",
  "HEMERYTHRIN": "an iron-containing respiratory pigment in the blood of various chiefly marine invertebrates [n -S]\n",
  "HEMERYTHRINS": "HEMERYTHRIN, an iron-containing respiratory pigment in the blood of various chiefly marine invertebrates [n]\n",
  "HEMES": "HEME, a component of hemoglobin, also HAEM [n]\n",
  "HEMIACETAL": "any of a class of alkyl compounds [n -S]\n",
  "HEMIACETALS": "HEMIACETAL, any of a class of alkyl compounds [n]\n",
  "HEMIALGIA": "pain in one side of the body alone [n -S]\n",
  "HEMIALGIAS": "HEMIALGIA, pain in one side of the body alone [n]\n",
  "HEMIANOPIA": "a defect of vision in consequence of which a person sees but half of an object looked at, also HEMIANOPSIA, HEMIOPIA, HEMIOPSIA [n -S]\n",
  "HEMIANOPIAS": "HEMIANOPIA, a defect of vision in consequence of which a person sees but half of an object looked at, also HEMIANOPSIA, HEMIOPIA, HEMIOPSIA [n]\n",
  "HEMIANOPIC": "having or relating to hemianopia, also HEMIANOPTIC, HEMIOPIC [adj]\n",
  "HEMIANOPSIA": "a defect of vision in consequence of which a person sees but half of an object looked at, also HEMIANOPIA, HEMIOPIA, HEMIOPSIA [n -S]\n",
  "HEMIANOPSIAS": "HEMIANOPSIA, a defect of vision in consequence of which a person sees but half of an object looked at, also HEMIANOPIA, HEMIOPIA, HEMIOPSIA [n]\n",
  "HEMIANOPTIC": "suffering from hemiopia, blind in half the field of vision, also HEMIANOPIC, HEMIOPIC [adj]\n",
  "HEMIC": "pertaining to the blood, also HAEMAL, HAEMATAL, HAEMIC, HAEMOID, HEMAL, HEMATAL, HEMOID [adj]\n",
  "HEMICELLULOSE": "a type of polysaccharide, found in plant cell walls, which can be more easily broken down than cellulose [n -S]\n",
  "HEMICELLULOSES": "HEMICELLULOSE, a type of polysaccharide, found in plant cell walls, which can be more easily broken down than cellulose [n]\n",
  "HEMICHORDATE": "a kind of marine worm [n -S]\n",
  "HEMICHORDATES": "HEMICHORDATE, a kind of marine worm [n]\n",
  "HEMICRANIA": "a pain that affects only one side of the head [n -S]\n",
  "HEMICRANIAS": "HEMICRANIA, a pain that affects only one side of the head [n]\n",
  "HEMICRYPTOPHYTE": "any perennial plant that bears its overwintering buds at soil level, where they are often partly covered by surface debris [n]\n",
  "HEMICRYSTALLINE": "consisting of crystals in a glassy or partly glassy groundmass [adj]\n",
  "HEMICYCLE": "a half circle; a semicircle [n -S]\n",
  "HEMICYCLES": "HEMICYCLE, a half circle; a semicircle [n]\n",
  "HEMICYCLIC": "of or like a hemicycle, a half circle; a semicircle [adj]\n",
  "HEMIELYTRA": "HEMIELYTRON, the forewing of plant bugs and related insects, having a thickened base and a membranous apex, also HEMELYTRON, HEMELYTRUM [n]\n",
  "HEMIELYTRAL": "relating to the hemielytron, the insect forewing, also HEMELYTRAL [adj]\n",
  "HEMIELYTRON": "the forewing of plant bugs and related insects, having a thickened base and a membranous apex, also HEMELYTRON, HEMELYTRUM [n HEMIELYTRA]\n",
  "HEMIHEDRA": "HEMIHEDRON, a solid derived in a hemihedral way, such as a tetrahedron [n]\n",
  "HEMIHEDRAL": "of a crystal or crystal class, having half of the maximum number of faces or symmetry planes possible for a given crystal system [adj]\n",
  "HEMIHEDRIES": "HEMIHEDRY, a property of crystals of being hemihedral [n]\n",
  "HEMIHEDRISM": "a property of crystals of being hemihedral, or having half the number of symmetrically arranged planes occurring on a holohedron [n -S]\n",
  "HEMIHEDRISMS": "HEMIHEDRISM, a property of crystals of being hemihedral, or having half the number of symmetrically arranged planes occurring on a holohedron [n]\n",
  "HEMIHEDRON": "a solid derived in a hemihedral way, such as a tetrahedron [n HEMIHEDRA or HEMIHEDRONS]\n",
  "HEMIHEDRONS": "HEMIHEDRON, a solid derived in a hemihedral way, such as a tetrahedron [n]\n",
  "HEMIHEDRY": "a property of crystals of being hemihedral [n HEMIHEDRIES]\n",
  "HEMIHYDRATE": "a hydrate, such as plaster of paris, containing half a mole of water to one mole of the compound forming the hydrate [n -S]\n",
  "HEMIHYDRATED": "in the form of a hemihydrate [adj]\n",
  "HEMIHYDRATES": "HEMIHYDRATE, a hydrate, such as plaster of paris, containing half a mole of water to one mole of the compound forming the hydrate [n]\n",
  "HEMIMETABOLOUS": "characterized by incomplete metamorphosis [adj]\n",
  "HEMIMORPHIC": "asymmetric at the axial ends [adj]\n",
  "HEMIMORPHIES": "HEMIMORPHY, the state of having a polar axis, dissimilar at the two ends [n]\n",
  "HEMIMORPHISM": "the state of being hemimorphic [n -S]\n",
  "HEMIMORPHISMS": "HEMIMORPHISM, the state of being hemimorphic [n]\n",
  "HEMIMORPHITE": "an orthorhombic hydrated zinc silicate, usually occurring as white flattened prisms, one of the forms of calamine [n -S]\n",
  "HEMIMORPHITES": "HEMIMORPHITE, an orthorhombic hydrated zinc silicate, usually occurring as white flattened prisms, one of the forms of calamine [n]\n",
  "HEMIMORPHY": "the state of having a polar axis, dissimilar at the two ends [n HEMIMORPHIES]\n",
  "HEMIN": "the red, crystalline salt of haematin with hydrochloric acid, also HAEMIN [n -S]\n",
  "HEMINA": "(obsolete) an obsolete corn measure [n -S]\n",
  "HEMINAS": "HEMINA, (obsolete) an obsolete corn measure [n]\n",
  "HEMINS": "HEMIN, the red, crystalline salt of haematin with hydrochloric acid, also HAEMIN [n]\n",
  "HEMIOLA": "(Greek) in mediaeval music, a perfect fifth, also HEMIOLIA [n -S]\n",
  "HEMIOLAS": "HEMIOLA, (Greek) in mediaeval music, a perfect fifth, also HEMIOLIA [n]\n",
  "HEMIOLIA": "(Greek) in mediaeval music, a perfect fifth, also HEMIOLA [n -S]\n",
  "HEMIOLIAS": "HEMIOLIA, (Greek) in mediaeval music, a perfect fifth, also HEMIOLA [n]\n",
  "HEMIOLIC": "in poetic rhythms, based on the ratio 3 to 2 [adj]\n",
  "HEMIONE": "an Asiatic wild ass, aka kiang or dziggetai, also HEMIONUS [n -S]\n",
  "HEMIONES": "HEMIONE, an Asiatic wild ass, aka kiang or dziggetai, also HEMIONUS [n]\n",
  "HEMIONUS": "(Greek) an Asiatic wild ass, aka kiang or dziggetai, also HEMIONE [n -ES]\n",
  "HEMIONUSES": "HEMIONUS, (Greek) an Asiatic wild ass, aka kiang or dziggetai, also HEMIONE [n]\n",
  "HEMIOPIA": "a defect of vision in consequence of which a person sees only half of an object looked at, also HEMIANOPIA, HEMIANOPSIA, HEMIOPSIA [n -S]\n",
  "HEMIOPIAS": "HEMIOPIA, a defect of vision in consequence of which a person sees only half of an object looked at, also HEMIANOPIA, HEMIANOPSIA, HEMIOPSIA [n]\n",
  "HEMIOPIC": "suffering from hemiopia, blind in half the field of vision, also HEMIANOPIC, HEMIANOPTIC [adj]\n",
  "HEMIOPSIA": "a defect of vision in consequence of which a person sees but half of an object looked at, also HEMIANOPIA, HEMIANOPSIA, HEMIOPIA [n -S]\n",
  "HEMIOPSIAS": "HEMIOPSIA, a defect of vision in consequence of which a person sees but half of an object looked at, also HEMIANOPIA, HEMIANOPSIA, HEMIOPIA [n]\n",
  "HEMIPARASITE": "a parasitic plant capable of limited photosynthetic production of sugars etc. [n -S]\n",
  "HEMIPARASITES": "HEMIPARASITE, a parasitic plant capable of limited photosynthetic production of sugars etc. [n]\n",
  "HEMIPARASITIC": "of or like a hemiparasite [adj]\n",
  "HEMIPLEGIA": "a palsy that affects one side only of the body [n -S]\n",
  "HEMIPLEGIAS": "HEMIPLEGIA, a palsy that affects one side only of the body [n]\n",
  "HEMIPLEGIC": "paralyzed on one side only [adj] / someone paralyzed on one side only [n -S]\n",
  "HEMIPLEGICS": "HEMIPLEGIC, someone paralyzed on one side only [n]\n",
  "HEMIPOD": "the button quail, also HEMIPODE [n -S]\n",
  "HEMIPODE": "the button quail, also HEMIPOD [n -S]\n",
  "HEMIPODES": "HEMIPODE, the button quail, also HEMIPOD [n]\n",
  "HEMIPODS": "HEMIPOD, the button quail, also HEMIPODE [n]\n",
  "HEMIPTER": "(Greek) one of the Hemiptera, an order of insects including bugs and cicadas, also HEMIPTERAN, HEMIPTERON [n -S]\n",
  "HEMIPTERAL": "relating to the Hemiptera, an order of insects including bugs and cicadas [adj]\n",
  "HEMIPTERAN": "(Greek) one of the Hemiptera, an order of insects including bugs and cicadas, also HEMIPTER, HEMIPTERON [n -S]\n",
  "HEMIPTERANS": "HEMIPTERAN, (Greek) one of the Hemiptera, an order of insects including bugs and cicadas, also HEMIPTER, HEMIPTERON [n]\n",
  "HEMIPTERON": "(Greek) one of the Hemiptera, an order of insects including bugs and cicadas, also HEMIPTER, HEMIPTERAN [n -S]\n",
  "HEMIPTERONS": "HEMIPTERON, (Greek) one of the Hemiptera, an order of insects including bugs and cicadas, also HEMIPTER, HEMIPTERAN [n]\n",
  "HEMIPTEROUS": "of, pertaining to, or characteristic of the Hemiptera, an order of insects including the bugs [adj]\n",
  "HEMIPTERS": "HEMIPTER, (Greek) one of the Hemiptera, an order of insects including bugs and cicadas, also HEMIPTERAN, HEMIPTERON [n]\n",
  "HEMISPACE": "the area to one side, either left or right, of the body [n -S]\n",
  "HEMISPACES": "HEMISPACE, the area to one side, either left or right, of the body [n]\n",
  "HEMISPHERE": "half of a sphere [n -S]\n",
  "HEMISPHERES": "HEMISPHERE, half of a sphere [n]\n",
  "HEMISPHERIC": "like a hemisphere, also HEMISPHERICAL [adj]\n",
  "HEMISPHERICAL": "like a hemisphere, also HEMISPHERIC [adj]\n",
  "HEMISPHEROID": "the half of a spheroid [n -S]\n",
  "HEMISPHEROIDAL": "in the form of a half-sphere [adj]\n",
  "HEMISPHEROIDS": "HEMISPHEROID, the half of a spheroid [n]\n",
  "HEMISTICH": "half a verse line [n -S]\n",
  "HEMISTICHAL": "related to a hemistich [adj]\n",
  "HEMISTICHS": "HEMISTICH, half a verse line [n]\n",
  "HEMITERPENE": "any of a class of simple unsaturated hydrocarbons, such as isoprene [n -S]\n",
  "HEMITERPENES": "HEMITERPENE, any of a class of simple unsaturated hydrocarbons, such as isoprene [n]\n",
  "HEMITROPAL": "of a crystal, having a twinned structure, also HEMITROPE, HEMITROPIC, HEMITROPOUS [adj]\n",
  "HEMITROPE": "of a crystal, twinned, also HEMITROPAL, HEMITROPIC, HEMITROPOUS [adj] / a twinned crystal [n -S]\n",
  "HEMITROPES": "HEMITROPE, a twinned crystal [n]\n",
  "HEMITROPIC": "of a crystal, having a twinned structure, also HEMITROPAL, HEMITROPE, HEMITROPOUS [adj]\n",
  "HEMITROPIES": "HEMITROPY, the state of being a twin [n]\n",
  "HEMITROPISM": "the state of being a hemitrope, a twinned crystal [n -S]\n",
  "HEMITROPISMS": "HEMITROPISM, the state of being a hemitrope, a twinned crystal [n]\n",
  "HEMITROPOUS": "of a crystal, having a twinned structure, also HEMITROPAL, HEMITROPE, HEMITROPIC [adj]\n",
  "HEMITROPY": "the state of being a twin [n HEMITROPIES]\n",
  "HEMIZYGOUS": "having one or more genes that have no allelic counterparts [adj]\n",
  "HEMLINE": "the bottom edge of a garment [n -S]\n",
  "HEMLINES": "HEMLINE, the bottom edge of a garment [n]\n",
  "HEMLOCK": "a highly poisonous umbelliferous plant with glaucous spotted stems, white flowers, and finely divided leaves [n -S]\n",
  "HEMLOCKS": "HEMLOCK, a highly poisonous umbelliferous plant with glaucous spotted stems, white flowers, and finely divided leaves [n]\n",
  "HEMMED": "HEM, to provide with an edge [v]\n",
  "HEMMER": "one who, or that which, hems with a needle [n -S]\n",
  "HEMMERS": "HEMMER, one who, or that which, hems with a needle [n]\n",
  "HEMMING": "HEM, to provide with an edge [v]\n",
  "HEMOCHROMATOSES": "HEMOCHROMATOSIS, a disease of the liver characterized by an excessive accumulation of iron [n]\n",
  "HEMOCHROMATOSIS": "a disease of the liver characterized by an excessive accumulation of iron [n HEMOCHROMATOSES]\n",
  "HEMOCHROME": "a blood pigment, such as haemoglobin, that carries oxygen, also HAEMOCHROME [n -S]\n",
  "HEMOCHROMES": "HEMOCHROME, a blood pigment, such as haemoglobin, that carries oxygen, also HAEMOCHROME [n]\n",
  "HEMOCOEL": "the central body cavity of many invertebrates, also HAEMOCOEL [n -S]\n",
  "HEMOCOELS": "HEMOCOEL, the central body cavity of many invertebrates, also HAEMOCOEL [n]\n",
  "HEMOCONIA": "the small particles of matter, thought to be particles of the structure of red blood cells, that are present in blood that is flowing around the body, also HAEMOCONIA [n -S]\n",
  "HEMOCONIAS": "HEMOCONIA, the small particles of matter, thought to be particles of the structure of red blood cells, that are present in blood that is flowing around the body, also HAEMOCONIA [n]\n",
  "HEMOCYANIN": "a colourless copper-containing respiratory pigment in the circulatory fluid of various arthropods and mollusks, also HAEMOCYANIN [n -S]\n",
  "HEMOCYANINS": "HEMOCYANIN, a colourless copper-containing respiratory pigment in the circulatory fluid of various arthropods and mollusks, also HAEMOCYANIN [n]\n",
  "HEMOCYTE": "a blood cell [n -S]\n",
  "HEMOCYTES": "HEMOCYTE, a blood cell [n]\n",
  "HEMOCYTOMETER": "an instrument for counting blood cells, also HAEMACYTOMETER, HAEMOCYTOMETER, HEMACYTOMETER [n -S]\n",
  "HEMOCYTOMETERS": "HEMOCYTOMETER, an instrument for counting blood cells, also HAEMACYTOMETER, HAEMOCYTOMETER, HEMACYTOMETER [n]\n",
  "HEMODIALYSES": "HEMODIALYSIS, dialysis, also HAEMODIALYSIS [n]\n",
  "HEMODIALYSIS": "dialysis, also HAEMODIALYSIS [n HEMODIALYSES]\n",
  "HEMODIALYZER": "an artificial kidney [n -S]\n",
  "HEMODIALYZERS": "HEMODIALYZER, an artificial kidney [n]\n",
  "HEMODILUTION": "decreased concentration of cells and solids in the blood resulting from gain of fluid, also HAEMODILUTION [n HEMODILUTIONS]\n",
  "HEMODILUTIONS": "HEMODILUTION, decreased concentration of cells and solids in the blood resulting from gain of fluid, also HAEMODILUTION [n]\n",
  "HEMODYNAMIC": "relating to hemodynamics, also HAEMODYNAMIC [adj]\n",
  "HEMODYNAMICALLY": "HEMODYNAMIC, relating to hemodynamics, also HAEMODYNAMIC [adv]\n",
  "HEMODYNAMICS": "a branch of physiology that deals with the circulation of the blood, also HAEMODYNAMICS [n]\n",
  "HEMOFLAGELLATE": "a flagellate (as a trypanosome) that is a blood parasite, also HAEMOFLAGELLATE [n -S]\n",
  "HEMOFLAGELLATES": "HEMOFLAGELLATE, a flagellate (as a trypanosome) that is a blood parasite, also HAEMOFLAGELLATE [n]\n",
  "HEMOGLOBIN": "the iron-containing pigment which is the oxygen-carrying substance present in the red blood cells of vertebrates, also HAEMOGLOBIN [n -S]\n",
  "HEMOGLOBINS": "HEMOGLOBIN, the iron-containing pigment which is the oxygen-carrying substance present in the red blood cells of vertebrates, also HAEMOGLOBIN [n]\n",
  "HEMOGLOBINURIA": "the presence of free hemoglobin in the urine, also HAEMOGLOBINURIA [n -S]\n",
  "HEMOGLOBINURIAS": "HEMOGLOBINURIA, the presence of free hemoglobin in the urine, also HAEMOGLOBINURIA [n]\n",
  "HEMOGLOBINURIC": "relating to hemoglobinuria, the presence of free hemoglobin in the urine, also HAEMOGLOBINURIC [adj]\n",
  "HEMOID": "pertaining to the blood, also HAEMAL, HAEMATAL, HAEMIC, HAEMOID, HEMAL, HEMATAL, HEMIC [adj]\n",
  "HEMOLYMPH": "the circulatory fluid of various invertebrate animals, also HAEMOLYMPH [n -S]\n",
  "HEMOLYMPHS": "HEMOLYMPH, the circulatory fluid of various invertebrate animals, also HAEMOLYMPH [n]\n",
  "HEMOLYSE": "to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYZE [v HEMOLYSED, HEMOLYSING, HEMOLYSES]\n",
  "HEMOLYSED": "HEMOLYSE, to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYZE [v]\n",
  "HEMOLYSES": "HEMOLYSE, to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYZE [v]\n",
  "HEMOLYSIN": "a substance that causes the dissolution of red blood cells, also HAEMOLYSIN [n -S]\n",
  "HEMOLYSING": "HEMOLYSE, to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYZE [v]\n",
  "HEMOLYSINS": "HEMOLYSIN, a substance that causes the dissolution of red blood cells, also HAEMOLYSIN [n]\n",
  "HEMOLYSIS": "destruction of red blood corpuscles [n HEMOLYSES]\n",
  "HEMOLYTIC": "destroying red blood corpuscles, also HAEMOLYTIC [adj]\n",
  "HEMOLYZE": "to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYSE [v HEMOLYZED, HEMOLYZING, HEMOLYZES]\n",
  "HEMOLYZED": "HEMOLYZE, to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYSE [v]\n",
  "HEMOLYZES": "HEMOLYZE, to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYSE [v]\n",
  "HEMOLYZING": "HEMOLYZE, to break down red blood cells, also HAEMOLYSE, HAEMOLYZE, HEMOLYSE [v]\n",
  "HEMOPHILE": "a person with hemophilia, also HAEMOPHILE [n -S]\n",
  "HEMOPHILES": "HEMOPHILE, a person with hemophilia, also HAEMOPHILE [n]\n",
  "HEMOPHILIA": "a hereditary disease causing excessive bleeding when any blood vessel is even slightly damaged [n -S]\n",
  "HEMOPHILIAC": "one affected with hemophilia [n -S]\n",
  "HEMOPHILIACS": "HEMOPHILIAC, one affected with hemophilia [n]\n",
  "HEMOPHILIAS": "HEMOPHILIA, a hereditary disease causing excessive bleeding when any blood vessel is even slightly damaged [n]\n",
  "HEMOPHILIC": "relating to hemophilia, also HAEMOPHILIC [adj] / one affected with hemophilia [n -S]\n",
  "HEMOPHILICS": "HEMOPHILIC, one affected with hemophilia [n]\n",
  "HEMOPHILIOID": "relating to haemophilia, also HAEMOPHILIOID [adj]\n",
  "HEMOPOIESES": "HEMOPOIESIS, the formation of blood, also HAEMATOPOIESIS, HAEMOPOIESIS, HEMATOPOIESIS [n]\n",
  "HEMOPOIESIS": "the formation of blood, also HAEMATOPOIESIS, HAEMOPOIESIS, HEMATOPOIESIS [n HEMOPOIESES]\n",
  "HEMOPOIETIC": "relating to hemopoiesis [adj]\n",
  "HEMOPROTEIN": "a conjugated protein, such as hemoglobin or cytochrome, whose prosthetic group is a porphyrin combined with iron, also HAEMOPROTEIN [n -S]\n",
  "HEMOPROTEINS": "HEMOPROTEIN, a conjugated protein, such as hemoglobin or cytochrome, whose prosthetic group is a porphyrin combined with iron, also HAEMOPROTEIN [n]\n",
  "HEMOPTYSES": "HEMOPTYSIS, the expectoration of blood, due usually to hemorrhage from the mucous membrane of the lungs [n]\n",
  "HEMOPTYSIS": "the expectoration of blood, due usually to hemorrhage from the mucous membrane of the lungs [n HEMOPTYSES]\n",
  "HEMORRHAGE": "any discharge of blood from the blood vessels [n -S] / to bleed excessively, also HAEMORRHAGE [v HEMORRHAGED, HEMORRHAGING, HEMORRHAGES]\n",
  "HEMORRHAGED": "HEMORRHAGE, to bleed excessively, also HAEMORRHAGE [v]\n",
  "HEMORRHAGES": "HEMORRHAGE, any discharge of blood from the blood vessels [n]\n",
  "HEMORRHAGIC": "of the nature of hemorrhage [adj]\n",
  "HEMORRHAGING": "excessive loss of blood from blood vessels, also HAEMORRHAGING [n -S]\n",
  "HEMORRHAGINGS": "HEMORRHAGING, excessive loss of blood from blood vessels, also HAEMORRHAGING [n]\n",
  "HEMORRHOID": "the dilatation of a vein around the anus, piles, also HAEMORRHOID [n -S]\n",
  "HEMORRHOIDAL": "of or like a haemorrhoid [adj] / a hemorrhoidal part (as an artery or vein) [n -S]\n",
  "HEMORRHOIDALS": "HEMORRHOIDAL, a hemorrhoidal part (as an artery or vein) [n]\n",
  "HEMORRHOIDS": "HEMORRHOID, the dilatation of a vein around the anus, piles, also HAEMORRHOID [n]\n",
  "HEMOSIDERIN": "a pigment that is formed in some phagocytic cells by the breakdown of hemoglobin and is probably essentially a denatured form of ferritin, also HAEMOSIDERIN [n -S]\n",
  "HEMOSIDERINS": "HEMOSIDERIN, a pigment that is formed in some phagocytic cells by the breakdown of hemoglobin and is probably essentially a denatured form of ferritin, also HAEMOSIDERIN [n]\n",
  "HEMOSTASES": "HEMOSTASIS, stoppage of bleeding or circulation, also HAEMOSTASIA, HAEMOSTASIS, HEMOSTASIA [n]\n",
  "HEMOSTASIA": "the stopping of bleeding or arrest of blood circulation in an organ or part, as during a surgical operation, also HAEMOSTASIA, HAEMOSTASIS, HEMOSTASIS [n -S]\n",
  "HEMOSTASIAS": "HEMOSTASIA, the stopping of bleeding or arrest of blood circulation in an organ or part, as during a surgical operation, also HAEMOSTASIA, HAEMOSTASIS, HEMOSTASIS [n]\n",
  "HEMOSTASIS": "stoppage of bleeding or circulation, also HAEMOSTASIA, HAEMOSTASIS, HEMOSTASIA [n HEMOSTASES]\n",
  "HEMOSTAT": "an instrument for stopping bleeding, also HAEMOSTAT [n -S]\n",
  "HEMOSTATIC": "capable of slowing down or stopping hemorrhage [adj] / a hemostatic substance [n -S]\n",
  "HEMOSTATICS": "HEMOSTATIC, a hemostatic substance [n]\n",
  "HEMOSTATS": "HEMOSTAT, an instrument for stopping bleeding, also HAEMOSTAT [n]\n",
  "HEMOTOXIC": "of or like a hemotoxin, a substance that destroys red blood cells, also HAEMOTOXIC [adj]\n",
  "HEMOTOXIN": "a substance that destroys red blood cells [n -S]\n",
  "HEMOTOXINS": "HEMOTOXIN, a substance that destroys red blood cells [n]\n",
  "HEMP": "a plant yielding a coarse fibre and an oil [n -S]\n",
  "HEMPEN": "made of hemp [adj]\n",
  "HEMPIE": "mischievous, also HEMPY [adj HEMPIER, HEMPIEST]\n",
  "HEMPIER": "HEMPY, mischievous, also HEMPIE [adj]\n",
  "HEMPIES": "HEMPY, a rogue, a tomboy [n]\n",
  "HEMPIEST": "HEMPY, mischievous, also HEMPIE [adj]\n",
  "HEMPLIKE": "like hemp [adj]\n",
  "HEMPS": "HEMP, a plant yielding a coarse fibre and an oil [n]\n",
  "HEMPSEED": "the seed of hemp [n -S]\n",
  "HEMPSEEDS": "HEMPSEED, the seed of hemp [n]\n",
  "HEMPWEED": "a climbing plant [n -S]\n",
  "HEMPWEEDS": "HEMPWEED, a climbing plant [n]\n",
  "HEMPY": "a rogue, a tomboy [n HEMPIES] / mischievous, also HEMPIE [adj HEMPIER, HEMPIEST]\n",
  "HEMS": "HEM, to provide with an edge [v]\n",
  "HEMSTITCH": "to stitch using the hem of a garment [v -ED, -ING, -ES]\n",
  "HEMSTITCHED": "HEMSTITCH, to stitch using the hem of a garment [v]\n",
  "HEMSTITCHER": "one who stitches hems [n -S]\n",
  "HEMSTITCHERS": "HEMSTITCHER, one who stitches hems [n]\n",
  "HEMSTITCHES": "HEMSTITCH, to stitch using the hem of a garment [v]\n",
  "HEMSTITCHING": "HEMSTITCH, to stitch using the hem of a garment [v]\n",
  "HEN": "to lose courage [v HENNED, HENNING, HENS]\n",
  "HENBANE": "a plant of the nightshade family, noted for its poisonous and narcotic properties [n -S]\n",
  "HENBANES": "HENBANE, a plant of the nightshade family, noted for its poisonous and narcotic properties [n]\n",
  "HENBIT": "either of two low-growing weeds with roundish shallowly lobed leaves [n -S]\n",
  "HENBITS": "HENBIT, either of two low-growing weeds with roundish shallowly lobed leaves [n]\n",
  "HENCE": "consequently [adv]\n",
  "HENCEFORTH": "from this point on [adj]\n",
  "HENCEFORWARD": "from this time on, also HENCEFORWARDS [adv]\n",
  "HENCEFORWARDS": "from this time on, also HENCEFORWARD [adv]\n",
  "HENCH": "(of a man) fit and having well-developed muscles [adj HENCHER, HENCHEST]\n",
  "HENCHER": "HENCH, (of a man) fit and having well-developed muscles [adj]\n",
  "HENCHEST": "HENCH, (of a man) fit and having well-developed muscles [adj]\n",
  "HENCHMAN": "an unscrupulous supporter [n HENCHMEN]\n",
  "HENCHMEN": "HENCHMAN, an unscrupulous supporter [n]\n",
  "HENCHPERSON": "a henchman or henchwoman [n -S]\n",
  "HENCHPERSONS": "HENCHPERSON, a henchman or henchwoman [n]\n",
  "HENCHWOMAN": "a female henchman [n HENCHWOMEN]\n",
  "HENCHWOMEN": "HENCHWOMAN, a female henchman [n]\n",
  "HENCOOP": "an enclosure in which hens are kept [n -S]\n",
  "HENCOOPS": "HENCOOP, an enclosure in which hens are kept [n]\n",
  "HEND": "(obsolete) to seize, grasp, also HENT [v -ED, -ING, -S]\n",
  "HENDECAGON": "an eleven-sided polygon, also ENDECAGON [n -S]\n",
  "HENDECAGONAL": "of or like a hendecagon, an eleven-sided polygon [adj]\n",
  "HENDECAGONS": "HENDECAGON, an eleven-sided polygon, also ENDECAGON [n]\n",
  "HENDECAHEDRA": "HENDECAHEDRON, a solid figure having 11 plane faces [n]\n",
  "HENDECAHEDRON": "a solid figure having 11 plane faces [n HENDECAHEDRA or HENDECAHEDRONS]\n",
  "HENDECAHEDRONS": "HENDECAHEDRON, a solid figure having 11 plane faces [n]\n",
  "HENDECASYLLABIC": "of a line of verse, having eleven syllables [adj]\n",
  "HENDECASYLLABLE": "a metrical line of eleven syllables [n]\n",
  "HENDED": "HEND, (obsolete) to seize, grasp, also HENT [v]\n",
  "HENDIADYS": "the expression of an idea by two nouns connected by and (as cups and gold) instead of by a noun and an adjective (as golden cups) [n -ES]\n",
  "HENDIADYSES": "HENDIADYS, the expression of an idea by two nouns connected by and (as cups and gold) instead of by a noun and an adjective (as golden cups) [n]\n",
  "HENDING": "HEND, (obsolete) to seize, grasp, also HENT [v]\n",
  "HENDS": "HEND, (obsolete) to seize, grasp, also HENT [v]\n",
  "HENEQUEN": "(Spanish) a fibre used to make ropes, also HENEQUIN, HENIQUEN, HENIQUIN [n -S]\n",
  "HENEQUENS": "HENEQUEN, (Spanish) a fibre used to make ropes, also HENEQUIN, HENIQUEN, HENIQUIN [n]\n",
  "HENEQUIN": "(Spanish) a fibre used to make ropes, also HENEQUEN, HENIQUEN, HENIQUIN [n -S]\n",
  "HENEQUINS": "HENEQUIN, (Spanish) a fibre used to make ropes, also HENEQUEN, HENIQUEN, HENIQUIN [n]\n",
  "HENGE": "a circle of stones or wooden posts [n -S]\n",
  "HENGES": "HENGE, a circle of stones or wooden posts [n]\n",
  "HENHOUSE": "a shelter for poultry [n -S]\n",
  "HENHOUSES": "HENHOUSE, a shelter for poultry [n]\n",
  "HENIQUEN": "(Spanish) a fibre used to make ropes, also HENEQUEN, HENEQUIN, HENIQUIN [n -S]\n",
  "HENIQUENS": "HENIQUEN, (Spanish) a fibre used to make ropes, also HENEQUEN, HENEQUIN, HENIQUIN [n]\n",
  "HENIQUIN": "(Spanish) a fibre used to make ropes, also HENEQUEN, HENEQUIN, HENIQUEN [n -S]\n",
  "HENIQUINS": "HENIQUIN, (Spanish) a fibre used to make ropes, also HENEQUEN, HENEQUIN, HENIQUEN [n]\n",
  "HENLEY": "a type of sweater [n -S]\n",
  "HENLEYS": "HENLEY, a type of sweater [n]\n",
  "HENLIKE": "like a hen [adj]\n",
  "HENNA": "(Arabic) to dye with a reddish colouring [v -ED, -ING, -S]\n",
  "HENNAED": "HENNA, (Arabic) to dye with a reddish colouring [v]\n",
  "HENNAING": "HENNA, (Arabic) to dye with a reddish colouring [v]\n",
  "HENNAS": "HENNA, (Arabic) to dye with a reddish colouring [v]\n",
  "HENNED": "HEN, to lose courage [v]\n",
  "HENNER": "(Scots) a challenge to an act of daring [n -S]\n",
  "HENNERIES": "HENNERY, a poultry farm [n]\n",
  "HENNERS": "HENNER, (Scots) a challenge to an act of daring [n]\n",
  "HENNERY": "a poultry farm [n HENNERIES]\n",
  "HENNIER": "HENNY, henlike [adj]\n",
  "HENNIES": "HENNY, a henlike cock [n]\n",
  "HENNIEST": "HENNY, henlike [adj]\n",
  "HENNIN": "(French) a steeple-hat with a veil hanging from it, worn by French women in the fifteenth century [n -S]\n",
  "HENNING": "HEN, to lose courage [v]\n",
  "HENNINS": "HENNIN, (French) a steeple-hat with a veil hanging from it, worn by French women in the fifteenth century [n]\n",
  "HENNISH": "like a hen [adj HENNISHLY]\n",
  "HENNISHLY": "HENNISH, like a hen [adv]\n",
  "HENNY": "a henlike cock [n HENNIES] / henlike [adj HENNIER, HENNIEST]\n",
  "HENOTHEISM": "the worship of one god, without denying the existence of others [n -S]\n",
  "HENOTHEISMS": "HENOTHEISM, the worship of one god, without denying the existence of others [n]\n",
  "HENOTHEIST": "a believer in one god as supreme, but not the the only god [n -S]\n",
  "HENOTHEISTIC": "relating to henotheism [adj]\n",
  "HENOTHEISTS": "HENOTHEIST, a believer in one god as supreme, but not the the only god [n]\n",
  "HENOTIC": "(Greek) tending to unify [adj]\n",
  "HENPECK": "to dominate by nagging [v -ED, -ING, -S]\n",
  "HENPECKED": "HENPECK, to dominate by nagging [v]\n",
  "HENPECKERIES": "HENPECKERY, the practice of henpecking, nagging [n]\n",
  "HENPECKERY": "the practice of henpecking, nagging [n HENPECKERIES]\n",
  "HENPECKING": "HENPECK, to dominate by nagging [v]\n",
  "HENPECKS": "HENPECK, to dominate by nagging [v]\n",
  "HENRIES": "HENRY, a unit of inductance [n]\n",
  "HENRY": "a unit of inductance [n HENRIES or HENRYS]\n",
  "HENRYS": "HENRY, a unit of inductance [n]\n",
  "HENS": "HEN, to lose courage [v]\n",
  "HENT": "(obsolete) to seize, take, also HEND [v -ED, -ING, -S]\n",
  "HENTED": "HENT, (obsolete) to seize, take, also HEND [v]\n",
  "HENTING": "HENT, (obsolete) to seize, take, also HEND [v]\n",
  "HENTS": "HENT, (obsolete) to seize, take, also HEND [v]\n",
  "HEORTOLOGICAL": "relating to heortology, the study of religious feasts [adj]\n",
  "HEORTOLOGIES": "HEORTOLOGY, the study of religious feasts [n]\n",
  "HEORTOLOGIST": "one who practises heortology, the study of religious feasts [n -S]\n",
  "HEORTOLOGISTS": "HEORTOLOGIST, one who practises heortology, the study of religious feasts [n]\n",
  "HEORTOLOGY": "the study of religious feasts [n HEORTOLOGIES]\n",
  "HEP": "well abreast of fashionable knowledge [adj HEPPER, HEPPEST] / the fruit of a rose [n -S]\n",
  "HEPAR": "any of various sulphur compounds, generally of a reddish-brown colour and often in (former) medicinal use [n -S]\n",
  "HEPARIN": "a complex substance formed in the liver that delays clotting of blood [n -S]\n",
  "HEPARINISED": "of blood, treated with heparin to stop clotting, also HEPARINIZED [adj]\n",
  "HEPARINIZED": "of blood, treated with heparin to stop clotting, also HEPARINISED [adj]\n",
  "HEPARINOID": "of or like heparin, a complex substance formed in the liver that delays clotting of blood [adj]\n",
  "HEPARINS": "HEPARIN, a complex substance formed in the liver that delays clotting of blood [n]\n",
  "HEPARS": "HEPAR, any of various sulphur compounds, generally of a reddish-brown colour and often in (former) medicinal use [n]\n",
  "HEPATECTOMIES": "HEPATECTOMY, the surgical removal of the liver [n]\n",
  "HEPATECTOMISED": "having undergone a hepatectomy, the surgical removal of the liver, also HEPATECTOMIZED [adj]\n",
  "HEPATECTOMIZED": "having undergone a hepatectomy, the surgical removal of the liver, also HEPATECTOMISED [adj]\n",
  "HEPATECTOMY": "the surgical removal of the liver [n HEPATECTOMIES]\n",
  "HEPATIC": "pertaining to or acting upon the liver, also HEPATICAL [adj] / a medicine for the liver [n -S]\n",
  "HEPATICA": "(Greek) a flower, aka liverwort [n HEPATICAE or HEPATICAS]\n",
  "HEPATICAE": "HEPATICA, (Greek) a flower, aka liverwort [n]\n",
  "HEPATICAL": "pertaining to or acting upon the liver, also HEPATIC [adj]\n",
  "HEPATICAS": "HEPATICA, (Greek) a flower, aka liverwort [n]\n",
  "HEPATICOLOGICAL": "related to hepaticology [adj]\n",
  "HEPATICOLOGIES": "HEPATICOLOGY, the study of liverworts [n]\n",
  "HEPATICOLOGIST": "one who studies liverworts [n -S]\n",
  "HEPATICOLOGISTS": "HEPATICOLOGIST, one who studies liverworts [n]\n",
  "HEPATICOLOGY": "the study of liverworts [n HEPATICOLOGIES]\n",
  "HEPATICS": "HEPATIC, a medicine for the liver [n]\n",
  "HEPATISATION": "the act of hepatising, also HEPATIZATION [n -S]\n",
  "HEPATISATIONS": "HEPATISATION, the act of hepatising, also HEPATIZATION [n]\n",
  "HEPATISE": "to convert into a liver-like substance, also HEPATIZE [v HEPATISED, HEPATISING, HEPATISES]\n",
  "HEPATISED": "HEPATISE, to convert into a liver-like substance, also HEPATIZE [v]\n",
  "HEPATISES": "HEPATISE, to convert into a liver-like substance, also HEPATIZE [v]\n",
  "HEPATISING": "HEPATISE, to convert into a liver-like substance, also HEPATIZE [v]\n",
  "HEPATITE": "a variety of barite emitting a fetid odor when rubbed or heated [n -S]\n",
  "HEPATITES": "HEPATITE, a variety of barite emitting a fetid odor when rubbed or heated [n]\n",
  "HEPATITIDES": "HEPATITIS, inflammation of the liver [n]\n",
  "HEPATITIS": "inflammation of the liver [n HEPATITIDES or HEPATITISES]\n",
  "HEPATITISES": "HEPATITIS, inflammation of the liver [n]\n",
  "HEPATIZATION": "the act of hepatizing, also HEPATISATION [n -S]\n",
  "HEPATIZATIONS": "HEPATIZATION, the act of hepatizing, also HEPATISATION [n]\n",
  "HEPATIZE": "to convert into a liver-like substance, also HEPATISE [v HEPATIZED, HEPATIZING, HEPATIZES]\n",
  "HEPATIZED": "HEPATIZE, to convert into a liver-like substance, also HEPATISE [v]\n",
  "HEPATIZES": "HEPATIZE, to convert into a liver-like substance, also HEPATISE [v]\n",
  "HEPATIZING": "HEPATIZE, to convert into a liver-like substance, also HEPATISE [v]\n",
  "HEPATOCELLULAR": "of or involving hepatocytes [adj]\n",
  "HEPATOCYTE": "an epithelial parenchymatous cell of the liver [n -S]\n",
  "HEPATOCYTES": "HEPATOCYTE, an epithelial parenchymatous cell of the liver [n]\n",
  "HEPATOGENOUS": "originating in the liver [adj]\n",
  "HEPATOLOGIES": "HEPATOLOGY, the study of the liver [n]\n",
  "HEPATOLOGIST": "a specialist in liver diseases [n -S]\n",
  "HEPATOLOGISTS": "HEPATOLOGIST, a specialist in liver diseases [n]\n",
  "HEPATOLOGY": "the study of the liver [n HEPATOLOGIES]\n",
  "HEPATOMA": "a tumor on the liver [n HEPATOMAS or HEPATOMATA]\n",
  "HEPATOMAS": "HEPATOMA, a tumor on the liver [n]\n",
  "HEPATOMATA": "HEPATOMA, a tumor on the liver [n]\n",
  "HEPATOMEGALIES": "HEPATOMEGALY, enlargement of the liver [n]\n",
  "HEPATOMEGALY": "enlargement of the liver [n HEPATOMEGALIES]\n",
  "HEPATOPANCREAS": "a glandular structure (as of a crustacean) that combines the digestive functions of the vertebrate liver and pancreas [n]\n",
  "HEPATOSCOPIES": "HEPATOSCOPY, divination by examining animal livers [n]\n",
  "HEPATOSCOPY": "divination by examining animal livers [n HEPATOSCOPIES]\n",
  "HEPATOTOXIC": "relating to or causing injury to the liver [adj]\n",
  "HEPATOTOXICITY": "a state of toxic damage to the liver [n]\n",
  "HEPCAT": "(slang) a jazz enthusiast [n -S]\n",
  "HEPCATS": "HEPCAT, (slang) a jazz enthusiast [n]\n",
  "HEPHTHEMIMER": "in Greek and Latin prosody, seven half-feet [n -S]\n",
  "HEPHTHEMIMERAL": "relating to a hephthemimer [adj]\n",
  "HEPHTHEMIMERS": "HEPHTHEMIMER, in Greek and Latin prosody, seven half-feet [n]\n",
  "HEPPER": "HEP, well abreast of fashionable knowledge [adj]\n",
  "HEPPEST": "HEP, well abreast of fashionable knowledge [adj]\n",
  "HEPS": "HEP, the fruit of a rose [n]\n",
  "HEPSTER": "(slang) one who is hep, streetwise, also HIPSTER [n -S]\n",
  "HEPSTERS": "HEPSTER, (slang) one who is hep, streetwise, also HIPSTER [n]\n",
  "HEPT": "(Spenser) heaped [adj]\n",
  "HEPTACHLOR": "a very toxic pesticide [n -S]\n",
  "HEPTACHLORS": "HEPTACHLOR, a very toxic pesticide [n]\n",
  "HEPTACHORD": "a system of seven sounds [n -S]\n",
  "HEPTACHORDS": "HEPTACHORD, a system of seven sounds [n]\n",
  "HEPTAD": "a group of seven [n -S]\n",
  "HEPTADECANOIC": "as in heptadecanoic acid, a saturated fatty acid, aka margaric acid [adj]\n",
  "HEPTADS": "HEPTAD, a group of seven [n]\n",
  "HEPTAGLOT": "a book written in seven languages [n -S]\n",
  "HEPTAGLOTS": "HEPTAGLOT, a book written in seven languages [n]\n",
  "HEPTAGON": "a seven-sided polygon [n -S]\n",
  "HEPTAGONAL": "having seven angles or sides [adj]\n",
  "HEPTAGONS": "HEPTAGON, a seven-sided polygon [n]\n",
  "HEPTAGYNOUS": "belonging to the Heptagynia, having seven styles [adj]\n",
  "HEPTAHEDRA": "HEPTAHEDRON, a solid figure having several plane faces [n]\n",
  "HEPTAHEDRAL": "like a heptahedron [adj]\n",
  "HEPTAHEDRON": "a solid figure having several plane faces [n HEPTAHEDRA or HEPTAHEDRONS]\n",
  "HEPTAHEDRONS": "HEPTAHEDRON, a solid figure having several plane faces [n]\n",
  "HEPTAMEROUS": "having seven divisions; having the parts of flower in sevens [adj]\n",
  "HEPTAMETER": "a verse line of seven feet [n -S]\n",
  "HEPTAMETERS": "HEPTAMETER, a verse line of seven feet [n]\n",
  "HEPTAMETRICAL": "of or like a heptameter [adj]\n",
  "HEPTANDROUS": "having seven stamens [adj]\n",
  "HEPTANE": "a saturated hydrocarbon with seven carbon atoms, found as a constituent of petroleum or tar oil [n -S]\n",
  "HEPTANES": "HEPTANE, a saturated hydrocarbon with seven carbon atoms, found as a constituent of petroleum or tar oil [n]\n",
  "HEPTANGULAR": "having seven angles [adj]\n",
  "HEPTAPODIC": "of a verse, having seven feet [adj]\n",
  "HEPTAPODIES": "HEPTAPODY, the state of having seven feet [n]\n",
  "HEPTAPODY": "the state of having seven feet [n HEPTAPODIES]\n",
  "HEPTARCH": "a member of a heptarchy, government by seven persons [n -S]\n",
  "HEPTARCHAL": "of or like a heptarchy, government by seven persons, also HEPTARCHIC [adj]\n",
  "HEPTARCHIC": "of or like a heptarchy, government by seven persons, also HEPTARCHAL [adj]\n",
  "HEPTARCHIES": "HEPTARCHY, government by seven persons; a group of seven allied but independent kingdoms, esp. of Anglo-Saxon England [n]\n",
  "HEPTARCHIST": "a ruler in a heptarchy [n -S]\n",
  "HEPTARCHISTS": "HEPTARCHIST, a ruler in a heptarchy [n]\n",
  "HEPTARCHS": "HEPTARCH, a member of a heptarchy, government by seven persons [n]\n",
  "HEPTARCHY": "government by seven persons; a group of seven allied but independent kingdoms, esp. of Anglo-Saxon England [n HEPTARCHIES]\n",
  "HEPTASTICH": "a poem, strophe, or stanza that consists of seven lines [n -S]\n",
  "HEPTASTICHS": "HEPTASTICH, a poem, strophe, or stanza that consists of seven lines [n]\n",
  "HEPTASYLLABIC": "having seven syllables [adj]\n",
  "HEPTATHLETE": "an athlete who takes part in heptathlons [n -S]\n",
  "HEPTATHLETES": "HEPTATHLETE, an athlete who takes part in heptathlons [n]\n",
  "HEPTATHLON": "an athletic competition with seven events [n -S]\n",
  "HEPTATHLONS": "HEPTATHLON, an athletic competition with seven events [n]\n",
  "HEPTATONIC": "of a musical scale, containing seven notes [adj]\n",
  "HEPTAVALENT": "having a valency of seven, also SEPTAVALENT, SEPTIVALENT [adj]\n",
  "HEPTOSE": "any monosaccharide sugar with seven carbon atoms in its molecule [n -S]\n",
  "HEPTOSES": "HEPTOSE, any monosaccharide sugar with seven carbon atoms in its molecule [n]\n",
  "HER": "a pronoun or possessive adjective representing a female person or thing [adj]\n",
  "HERALD": "to proclaim, announce [v -ED, -ING, -S]\n",
  "HERALDED": "HERALD, to proclaim, announce [v]\n",
  "HERALDIC": "pertaining to heraldry [adj HERALDICALLY]\n",
  "HERALDICALLY": "HERALDIC, pertaining to heraldry [adv]\n",
  "HERALDING": "HERALD, to proclaim, announce [v]\n",
  "HERALDIST": "a student of heraldry [n -S]\n",
  "HERALDISTS": "HERALDIST, a student of heraldry [n]\n",
  "HERALDRIES": "HERALDRY, the science of armorial bearings [n]\n",
  "HERALDRY": "the science of armorial bearings [n HERALDRIES]\n",
  "HERALDS": "HERALD, to proclaim, announce [v]\n",
  "HERALDSHIP": "the office of a herald [n -S]\n",
  "HERALDSHIPS": "HERALDSHIP, the office of a herald [n]\n",
  "HERB": "a seed-bearing plant whose aerial parts do not persist above ground at the end of the growing season [n -S]\n",
  "HERBACEOUS": "of, relating to, or having the characteristics of a herb [adj HERBACEOUSLY]\n",
  "HERBACEOUSLY": "HERBACEOUS, of, relating to, or having the characteristics of a herb [adv]\n",
  "HERBAGE": "herbs collectively [n -S]\n",
  "HERBAGED": "covered with grass [adj]\n",
  "HERBAGES": "HERBAGE, herbs collectively [n]\n",
  "HERBAL": "a book about herbs and plants [n -S]\n",
  "HERBALISM": "the practice of herbal medicine [n -S]\n",
  "HERBALISMS": "HERBALISM, the practice of herbal medicine [n]\n",
  "HERBALIST": "a person who practises herbalism, also HERBIST [n -S]\n",
  "HERBALISTS": "HERBALIST, a person who practises herbalism, also HERBIST [n]\n",
  "HERBALS": "HERBAL, a book about herbs and plants [n]\n",
  "HERBAR": "(Spenser) a herb-garden, also HERBARY [n -S]\n",
  "HERBARIA": "HERBARIUM, a collection of preserved plants and herbs [n]\n",
  "HERBARIAL": "relating to a herbarium, a collection of preserved plants and herbs [adj]\n",
  "HERBARIAN": "a herbalist [n -S]\n",
  "HERBARIANS": "HERBARIAN, a herbalist [n]\n",
  "HERBARIES": "HERBARY, a garden of herbs [n]\n",
  "HERBARIUM": "a collection of preserved plants and herbs [n HERBARIA or HERBARIUMS]\n",
  "HERBARIUMS": "HERBARIUM, a collection of preserved plants and herbs [n]\n",
  "HERBARS": "HERBAR, (Spenser) a herb-garden, also HERBARY [n]\n",
  "HERBARY": "a garden of herbs [n HERBARIES]\n",
  "HERBED": "flavoured with herbs [adj]\n",
  "HERBELET": "(Shakespeare) a small herb, also HERBLET [n -S]\n",
  "HERBELETS": "HERBELET, (Shakespeare) a small herb, also HERBLET [n]\n",
  "HERBICIDAL": "having the properties of a herbicide, killing grass [adj HERBICIDALLY]\n",
  "HERBICIDALLY": "HERBICIDAL, having the properties of a herbicide, killing grass [adv]\n",
  "HERBICIDE": "a weedkiller [n -S]\n",
  "HERBICIDES": "HERBICIDE, a weedkiller [n]\n",
  "HERBIER": "HERBY, abounding with herbs [adj]\n",
  "HERBIEST": "HERBY, abounding with herbs [adj]\n",
  "HERBIST": "a person who practises herbalism, also HERBALIST [n -S]\n",
  "HERBISTS": "HERBIST, a person who practises herbalism, also HERBALIST [n]\n",
  "HERBIVORA": "an extensive division of Mammalia, comprising animals that feed almost exclusively upon vegetation [n]\n",
  "HERBIVORE": "an organism that eats plants or other autotrophic organisms [n -S]\n",
  "HERBIVORES": "HERBIVORE, an organism that eats plants or other autotrophic organisms [n]\n",
  "HERBIVORIES": "HERBIVORY, the eating of grass [n]\n",
  "HERBIVOROUS": "eating plants [adj HERBIVOROUSLY]\n",
  "HERBIVOROUSLY": "HERBIVOROUS, eating plants [adv]\n",
  "HERBIVOROUSNESS": "HERBIVOROUS, eating plants [n]\n",
  "HERBIVORY": "the eating of grass [n HERBIVORIES]\n",
  "HERBLESS": "destitute of herbs or of vegetation [adj]\n",
  "HERBLET": "(Shakespeare) a small herb, also HERBELET [n -S]\n",
  "HERBLETS": "HERBLET, (Shakespeare) a small herb, also HERBELET [n]\n",
  "HERBLIKE": "like a herb [adj]\n",
  "HERBOLOGIES": "HERBOLOGY, the use or study of herbal medicine [n]\n",
  "HERBOLOGY": "the use or study of herbal medicine [n HERBOLOGIES]\n",
  "HERBORISATION": "botanising, also HERBORIZATION [n -S]\n",
  "HERBORISATIONS": "HERBORISATION, botanising, also HERBORIZATION [n]\n",
  "HERBORISE": "to search for plants, or new species of plants, with a view to classifying them, also HERBORIZE [v HERBORISED, HERBORISING, HERBORISES]\n",
  "HERBORISED": "HERBORISE, to search for plants, or new species of plants, with a view to classifying them, also HERBORIZE [v]\n",
  "HERBORISES": "HERBORISE, to search for plants, or new species of plants, with a view to classifying them, also HERBORIZE [v]\n",
  "HERBORISING": "HERBORISE, to search for plants, or new species of plants, with a view to classifying them, also HERBORIZE [v]\n",
  "HERBORIST": "a herbalist [n -S]\n",
  "HERBORISTS": "HERBORIST, a herbalist [n]\n",
  "HERBORIZATION": "botanising, also HERBORISATION [n -S]\n",
  "HERBORIZATIONS": "HERBORIZATION, botanising, also HERBORISATION [n]\n",
  "HERBORIZE": "to search for plants, or new species of plants, with a view to classifying them, also HERBORISE [v HERBORIZED, HERBORIZING, HERBORIZES]\n",
  "HERBORIZED": "HERBORIZE, to search for plants, or new species of plants, with a view to classifying them, also HERBORISE [v]\n",
  "HERBORIZES": "HERBORIZE, to search for plants, or new species of plants, with a view to classifying them, also HERBORISE [v]\n",
  "HERBORIZING": "HERBORIZE, to search for plants, or new species of plants, with a view to classifying them, also HERBORISE [v]\n",
  "HERBOSE": "abounding with herbs, also HERBOUS [adj]\n",
  "HERBOUS": "abounding with herbs, also HERBOSE [adj]\n",
  "HERBS": "HERB, a seed-bearing plant whose aerial parts do not persist above ground at the end of the growing season [n]\n",
  "HERBY": "abounding with herbs [adj HERBIER, HERBIEST]\n",
  "HERCOGAMIES": "HERCOGAMY, the prevention of self-pollination in plants, also HERKOGAMY [n]\n",
  "HERCOGAMOUS": "related to hercogamy, the prevention of self-pollination in plants [adj]\n",
  "HERCOGAMY": "the prevention of self-pollination in plants, also HERKOGAMY [n HERCOGAMIES]\n",
  "HERCULEAN": "of extraordinary strength and size [adj]\n",
  "HERCULES": "(Latin) any man of great size and strength [n -ES]\n",
  "HERCULESES": "HERCULES, (Latin) any man of great size and strength [n]\n",
  "HERCYNITE": "black spinel, an aluminate of iron [n -S]\n",
  "HERCYNITES": "HERCYNITE, black spinel, an aluminate of iron [n]\n",
  "HERD": "to bring together a group of animals [v -ED, -ING, -S]\n",
  "HERDBOY": "a boy who acts as a shepherd [n -S]\n",
  "HERDBOYS": "HERDBOY, a boy who acts as a shepherd [n]\n",
  "HERDED": "HERD, to bring together a group of animals [v]\n",
  "HERDEN": "a coarse fabric made from herds, the refuse of hemp, also HURDEN [n -S]\n",
  "HERDENS": "HERDEN, a coarse fabric made from herds, the refuse of hemp, also HURDEN [n]\n",
  "HERDER": "one who tends a herd [n -S]\n",
  "HERDERS": "HERDER, one who tends a herd [n]\n",
  "HERDESS": "a female keeper of a herd [n -ES]\n",
  "HERDESSES": "HERDESS, a female keeper of a herd [n]\n",
  "HERDIC": "a low-hung carriage with a back entrance [n -S]\n",
  "HERDICS": "HERDIC, a low-hung carriage with a back entrance [n]\n",
  "HERDING": "the act of forming into a herd [n -S]\n",
  "HERDINGS": "HERDING, the act of forming into a herd [n]\n",
  "HERDLIKE": "resembling a herd [adj]\n",
  "HERDMAN": "a keeper of a herd, also HERDSMAN [n HERDMEN]\n",
  "HERDMEN": "HERDMAN, a keeper of a herd, also HERDSMAN [n]\n",
  "HERDS": "HERD, to bring together a group of animals [v]\n",
  "HERDSMAN": "a keeper of a herd, also HERDMAN [n HERDSMEN]\n",
  "HERDSMEN": "HERDSMAN, a keeper of a herd, also HERDMAN [n]\n",
  "HERDWICK": "a breed of sheep [n -S]\n",
  "HERDWICKS": "HERDWICK, a breed of sheep [n]\n",
  "HERE": "this place [n -S]\n",
  "HEREABOUT": "in the local area, also HEREABOUTS [adv]\n",
  "HEREABOUTS": "in the local area, also HEREABOUT [adv]\n",
  "HEREAFTER": "from this time on [adv] / the afterlife [n -S]\n",
  "HEREAFTERS": "HEREAFTER, the afterlife [n]\n",
  "HEREAT": "at this time [adj]\n",
  "HEREAWAY": "hereabout, in this vicinity, also HEREAWAYS [adv]\n",
  "HEREAWAYS": "hereabout, in this vicinity, also HEREAWAY [adv]\n",
  "HEREBY": "not far off [adj]\n",
  "HEREDES": "HERES, (Latin) an heir, also HAERES [n]\n",
  "HEREDITABILITY": "the quality of being hereditable [n]\n",
  "HEREDITABLE": "capable of being inherited [adj HEREDITABLY]\n",
  "HEREDITABLY": "HEREDITABLE, capable of being inherited [adv]\n",
  "HEREDITAMENT": "inheritance; hereditable property [n -S]\n",
  "HEREDITAMENTS": "HEREDITAMENT, inheritance; hereditable property [n]\n",
  "HEREDITARIAN": "an adherent of hereditarianism, the view that heredity is the major factor in determining human and animal behaviour, also HEREDITIST [n -S]\n",
  "HEREDITARIANISM": "the view that heredity is the major factor in determining human and animal behaviour [n]\n",
  "HEREDITARIANIST": "a proponent of hereditarianism [n]\n",
  "HEREDITARIANS": "HEREDITARIAN, an adherent of hereditarianism, the view that heredity is the major factor in determining human and animal behaviour, also HEREDITIST [n]\n",
  "HEREDITARILY": "HEREDITARY, genetically transmitted or transmittable from parent to offspring [adv]\n",
  "HEREDITARINESS": "the state of being hereditary [n]\n",
  "HEREDITARY": "genetically transmitted or transmittable from parent to offspring [adj HEREDITARILY]\n",
  "HEREDITIES": "HEREDITY, the genetic transmission of characteristics [n]\n",
  "HEREDITIST": "an adherent of hereditarianism, the view that heredity is the major factor in determining human and animal behaviour, also HEREDITARIANIST [n -S]\n",
  "HEREDITISTS": "HEREDITIST, an adherent of hereditarianism, the view that heredity is the major factor in determining human and animal behaviour, also HEREDITARIANIST [n]\n",
  "HEREDITY": "the genetic transmission of characteristics [n HEREDITIES]\n",
  "HEREFROM": "from this [adv]\n",
  "HEREIN": "contained in this [adv]\n",
  "HEREINABOVE": "at a prior point in this writing or document [adv]\n",
  "HEREINAFTER": "in the following part of this writing or document [adv]\n",
  "HEREINBEFORE": "in the preceding part of this writing or document [adv]\n",
  "HEREINBELOW": "at a subsequent point in this writing or document [adv]\n",
  "HEREINTO": "into this place [adv]\n",
  "HERENESS": "the fact of being here [n -ES]\n",
  "HERENESSES": "HERENESS, the fact of being here [n]\n",
  "HEREOF": "concerning this [adv]\n",
  "HEREON": "upon this [adv]\n",
  "HERES": "(Latin) an heir, also HAERES [n HEREDES]\n",
  "HERESIARCH": "the leader of a heretical movement [n -S]\n",
  "HERESIARCHS": "HERESIARCH, the leader of a heretical movement [n]\n",
  "HERESIES": "HERESY, a belief contrary to church doctrine [n]\n",
  "HERESIOGRAPHER": "a person who writes about heresies [n -S]\n",
  "HERESIOGRAPHERS": "HERESIOGRAPHER, a person who writes about heresies [n]\n",
  "HERESIOGRAPHIES": "HERESIOGRAPHY, a study of or treatise on heresies [n]\n",
  "HERESIOGRAPHY": "a study of or treatise on heresies [n HERESIOGRAPHIES]\n",
  "HERESIOLOGIES": "HERESIOLOGY, the study of heresies [n]\n",
  "HERESIOLOGIST": "a student of, or writer on, heresies [n -S]\n",
  "HERESIOLOGISTS": "HERESIOLOGIST, a student of, or writer on, heresies [n]\n",
  "HERESIOLOGY": "the study of heresies [n HERESIOLOGIES]\n",
  "HERESTHETIC": "the art of political manipulation, esp. by the use of language [n -S]\n",
  "HERESTHETICAL": "relating to heresthetics, a political theory that involves structuring the world so you can win [adj]\n",
  "HERESTHETICIAN": "one who practises heresthetics [n -S]\n",
  "HERESTHETICIANS": "HERESTHETICIAN, one who practises heresthetics [n]\n",
  "HERESTHETICS": "HERESTHETIC, the art of political manipulation, esp. by the use of language [n]\n",
  "HERESY": "a belief contrary to church doctrine [n HERESIES]\n",
  "HERETIC": "pertaining to heresy [adj HERETICALLY] / one that upholds heresy [n -S]\n",
  "HERETICAL": "like a heretic, also HERETIC [adj HERETICALLY]\n",
  "HERETICALLY": "HERETICAL, like a heretic, also HERETIC [adv]\n",
  "HERETICATE": "to denounce as heretical [v HERETICATED, HERETICATING, HERETICATES]\n",
  "HERETICATED": "HERETICATE, to denounce as heretical [v]\n",
  "HERETICATES": "HERETICATE, to denounce as heretical [v]\n",
  "HERETICATING": "HERETICATE, to denounce as heretical [v]\n",
  "HERETICS": "HERETIC, one that upholds heresy [n]\n",
  "HERETO": "to this matter, also HEREUNTO [adv]\n",
  "HERETOFORE": "the past [n -S]\n",
  "HERETOFORES": "HERETOFORE, the past [n]\n",
  "HERETRICES": "HERITRIX, a female heritor, also HERETRIX [n]\n",
  "HERETRIX": "(Latin) a female heritor, also HERITRIX [n HERETRIXES or HERETRICES]\n",
  "HERETRIXES": "HERETRIX, (Latin) a female heritor, also HERITRIX [n]\n",
  "HEREUNDER": "under this; below [adv]\n",
  "HEREUNTO": "to this matter, also HERETO [adv]\n",
  "HEREUPON": "immediately following this [adv]\n",
  "HEREWITH": "along with this [adv]\n",
  "HERIED": "HERY, (Spenser) to praise, regard as holy, also HERRY, HERYE [v]\n",
  "HERIES": "HERY, (Spenser) to praise, regard as holy, also HERRY, HERYE [v]\n",
  "HERIOT": "(historical) a payment to a feudal lord upon the death of a tenant farmer [n -S]\n",
  "HERIOTABLE": "subject to the payment of a heriot [adj]\n",
  "HERIOTS": "HERIOT, (historical) a payment to a feudal lord upon the death of a tenant farmer [n]\n",
  "HERISSE": "(French) in heraldry, bristled [adj]\n",
  "HERISSON": "(French) a pivoted beam with iron spikes, protecting wall, passage, etc. [n -S]\n",
  "HERISSONS": "HERISSON, (French) a pivoted beam with iron spikes, protecting wall, passage, etc. [n]\n",
  "HERITABILITIES": "HERITABILITY, the state of being heritable [n]\n",
  "HERITABILITY": "the state of being heritable [n HERITABILITIES]\n",
  "HERITABLE": "capable of being inherited or of passing by inheritance, also INHERITABLE [adj HERITABLY]\n",
  "HERITABLY": "HERITABLE, capable of being inherited or of passing by inheritance, also INHERITABLE [adv]\n",
  "HERITAGE": "something that is inherited [n -S]\n",
  "HERITAGES": "HERITAGE, something that is inherited [n]\n",
  "HERITOR": "a proprietor or landholder in a parish [n -S]\n",
  "HERITORS": "HERITOR, a proprietor or landholder in a parish [n]\n",
  "HERITRESS": "a female heir [n -ES]\n",
  "HERITRESSES": "HERITRESS, a female heir [n]\n",
  "HERITRICES": "HERITRIX, a female heritor, also HERETRIX [n]\n",
  "HERITRIX": "a female heritor, also HERETRIX [n HERITRIXES or HERITRICES]\n",
  "HERITRIXES": "HERITRIX, a female heritor, also HERETRIX [n]\n",
  "HERKOGAMIES": "HERKOGAMY, the prevention of self-pollination in plants, also HERCOGAMY [n]\n",
  "HERKOGAMY": "the prevention of self-pollination in plants, also HERCOGAMY [n HERKOGAMIES]\n",
  "HERL": "a feathered fishing lure [n -S]\n",
  "HERLING": "a young seatrout, a finnock, also HIRLING [n -S]\n",
  "HERLINGS": "HERLING, a young seatrout, a finnock, also HIRLING [n]\n",
  "HERLS": "HERL, a feathered fishing lure [n]\n",
  "HERM": "a type of statue, also HERMA [n -S]\n",
  "HERMA": "(Latin) a type of statue, also HERM [n HERMAE or HERMAI]\n",
  "HERMAE": "HERMA, (Latin) a type of statue, also HERM [n]\n",
  "HERMAEAN": "of or like a herma, a head or bust of Hermes [adj]\n",
  "HERMAI": "HERMA, (Latin) a type of statue, also HERM [n]\n",
  "HERMANDAD": "(Spanish) a confederation of the entire burgher class of Spain for police and judicial purposes [n -S]\n",
  "HERMANDADS": "HERMANDAD, (Spanish) a confederation of the entire burgher class of Spain for police and judicial purposes [n]\n",
  "HERMAPHRODITE": "a human being, animal or plant with the organs of both sexes [n -S]\n",
  "HERMAPHRODITES": "HERMAPHRODITE, a human being, animal or plant with the organs of both sexes [n]\n",
  "HERMAPHRODITIC": "of or like a hermaphrodite, bearing both sexes, e.g. of plants usually in the same flower [adj]\n",
  "HERMAPHRODITISM": "the state of being hermaphrodite, bearing both sexes, usually in the same flower [n]\n",
  "HERMATYPIC": "building reefs (as of corals) [adj]\n",
  "HERMENEUTIC": "interpretive or explanatory, also HERMENEUTICAL [adj]\n",
  "HERMENEUTICAL": "interpretive or explanatory, also HERMENEUTIC [adj]\n",
  "HERMENEUTICALLY": "HERMENEUTICAL, interpretive or explanatory, also HERMENEUTIC [adv]\n",
  "HERMENEUTICS": "the study of the methodological principles of interpretation [n]\n",
  "HERMENEUTIST": "an exponent of hermeneutics, an interpreter [n -S]\n",
  "HERMENEUTISTS": "HERMENEUTIST, an exponent of hermeneutics, an interpreter [n]\n",
  "HERMETIC": "of or relating to sorcery or alchemy, also HERMETICAL [adj HERMETICALLY]\n",
  "HERMETICAL": "of or relating to sorcery or alchemy, also HERMETIC [adj HERMETICALLY]\n",
  "HERMETICALLY": "HERMETICAL, of or relating to sorcery or alchemy, also HERMETIC [adv]\n",
  "HERMETICISM": "a system of ideas based on hermetic teachings, also HERMETISM [n -S]\n",
  "HERMETICISMS": "HERMETICISM, a system of ideas based on hermetic teachings, also HERMETISM [n]\n",
  "HERMETICITIES": "HERMETICITY, the state of being hermetic [n]\n",
  "HERMETICITY": "the state of being hermetic [n HERMETICITIES]\n",
  "HERMETICS": "the philosophy contained in the Hermetic Books, esoteric alchemy [n]\n",
  "HERMETISM": "a system of ideas based on hermetic teachings, also HERMETICISM [n -S]\n",
  "HERMETISMS": "HERMETISM, a system of ideas based on hermetic teachings, also HERMETICISM [n]\n",
  "HERMETIST": "an adherent of hermetism, a system of ideas based on hermetic teachings [n -S]\n",
  "HERMETISTS": "HERMETIST, an adherent of hermetism, a system of ideas based on hermetic teachings [n]\n",
  "HERMIT": "a recluse [n -S]\n",
  "HERMITAGE": "a hermit's abode [n -S]\n",
  "HERMITAGES": "HERMITAGE, a hermit's abode [n]\n",
  "HERMITESS": "a female hermit [n -ES]\n",
  "HERMITESSES": "HERMITESS, a female hermit [n]\n",
  "HERMITIC": "of or like a hermit, also HERMITICAL [adj HERMITICALLY]\n",
  "HERMITICAL": "of or like a hermit, also HERMITIC [adj HERMITICALLY]\n",
  "HERMITICALLY": "HERMITICAL, of or like a hermit, also HERMITIC [adv]\n",
  "HERMITISM": "the state of being a hermit [n -S]\n",
  "HERMITISMS": "HERMITISM, the state of being a hermit [n]\n",
  "HERMITRIES": "HERMITRY, the state of being a hermit [n]\n",
  "HERMITRY": "the state of being a hermit [n HERMITRIES]\n",
  "HERMITS": "HERMIT, a recluse [n]\n",
  "HERMS": "HERM, a type of statue, also HERMA [n]\n",
  "HERN": "(dialect) a heron [n -S]\n",
  "HERNIA": "(Latin) the protrusion of an organ through its wall [n HERNIAS or HERNIAE]\n",
  "HERNIAE": "HERNIA, (Latin) the protrusion of an organ through its wall [n]\n",
  "HERNIAL": "relating to a hernia [adj]\n",
  "HERNIAS": "HERNIA, (Latin) the protrusion of an organ through its wall [n]\n",
  "HERNIATE": "to protrude through an abnormal body opening [v HERNIATED, HERNIATING, HERNIATES]\n",
  "HERNIATED": "HERNIATE, to protrude through an abnormal body opening [v]\n",
  "HERNIATES": "HERNIATE, to protrude through an abnormal body opening [v]\n",
  "HERNIATING": "HERNIATE, to protrude through an abnormal body opening [v]\n",
  "HERNIATION": "the state of being herniated [n -S]\n",
  "HERNIATIONS": "HERNIATION, the state of being herniated [n]\n",
  "HERNIORRHAPHIES": "HERNIORRHAPHY, the surgical repair of a hernia by an operation involving suturing [n]\n",
  "HERNIORRHAPHY": "the surgical repair of a hernia by an operation involving suturing [n HERNIORRHAPHIES]\n",
  "HERNIOTOMIES": "HERNIOTOMY, a cutting for the cure or relief of hernia [n]\n",
  "HERNIOTOMY": "a cutting for the cure or relief of hernia [n HERNIOTOMIES]\n",
  "HERNS": "HERN, (dialect) a heron [n]\n",
  "HERNSHAW": "a heron, also HERONSEW, HERONSHAW [n -S]\n",
  "HERNSHAWS": "HERNSHAW, a heron, also HERONSEW, HERONSHAW [n]\n",
  "HERO": "a brave man [n HEROES] / a sandwich or hoagie [n HEROS]\n",
  "HEROES": "HERO, a brave man [n]\n",
  "HEROIC": "brave, also HEROICAL [adj HEROICLY or HEROICALLY] / an epic verse [n -S]\n",
  "HEROICAL": "courageous [adj HEROICALLY]\n",
  "HEROICALLY": "HEROICAL, courageous [adv]\n",
  "HEROICALNESS": "the state of being heroical [n -ES]\n",
  "HEROICALNESSES": "HEROICALNESS, the state of being heroical [n]\n",
  "HEROICISE": "to make heroic, also HEROICIZE [v HEROICISED, HEROICISING, HEROICISES]\n",
  "HEROICISED": "HEROICISE, to make heroic, also HEROICIZE [v]\n",
  "HEROICISES": "HEROICISE, to make heroic, also HEROICIZE [v]\n",
  "HEROICISING": "HEROICISE, to make heroic, also HEROICIZE [v]\n",
  "HEROICIZE": "to make heroic, also HEROICISE [v HEROICIZED, HEROICIZING, HEROICIZES]\n",
  "HEROICIZED": "HEROICIZE, to make heroic, also HEROICISE [v]\n",
  "HEROICIZES": "HEROICIZE, to make heroic, also HEROICISE [v]\n",
  "HEROICIZING": "HEROICIZE, to make heroic, also HEROICISE [v]\n",
  "HEROICLY": "(Milton) heroically [adj]\n",
  "HEROICNESS": "heroism [n -ES]\n",
  "HEROICNESSES": "HEROICNESS, heroism [n]\n",
  "HEROICOMIC": "of a style that mixes the heroic and comic, also HEROICOMICAL [adj]\n",
  "HEROICOMICAL": "of a style that mixes the heroic and comic, also HEROICOMIC [adj]\n",
  "HEROICS": "HEROIC, an epic verse [n]\n",
  "HEROIN": "an addictive narcotic [n -S]\n",
  "HEROINE": "a brave woman [n -S]\n",
  "HEROINES": "HEROINE, a brave woman [n]\n",
  "HEROINISM": "addiction to heroin [n -S]\n",
  "HEROINISMS": "HEROINISM, addiction to heroin [n]\n",
  "HEROINS": "HEROIN, an addictive narcotic [n]\n",
  "HEROISE": "to make heroic, also HEROIZE [v HEROISED, HEROISING, HEROISES]\n",
  "HEROISED": "HEROISE, to make heroic, also HEROIZE [v]\n",
  "HEROISES": "HEROISE, to make heroic, also HEROIZE [v]\n",
  "HEROISING": "HEROISE, to make heroic, also HEROIZE [v]\n",
  "HEROISM": "heroic behaviour [n -S]\n",
  "HEROISMS": "HEROISM, heroic behaviour [n]\n",
  "HEROIZE": "to make heroic, also HEROISE [v HEROIZED, HEROIZING, HEROIZES]\n",
  "HEROIZED": "HEROIZE, to make heroic, also HEROISE [v]\n",
  "HEROIZES": "HEROIZE, to make heroic, also HEROISE [v]\n",
  "HEROIZING": "HEROIZE, to make heroic, also HEROISE [v]\n",
  "HERON": "a wading bird [n -S]\n",
  "HERONRIES": "HERONRY, a breeding place for herons [n]\n",
  "HERONRY": "a breeding place for herons [n HERONRIES]\n",
  "HERONS": "HERON, a wading bird [n]\n",
  "HERONSEW": "a heron, also HERNSHAW, HERONSHAW [n -S]\n",
  "HERONSEWS": "HERONSEW, a heron, also HERNSHAW, HERONSHAW [n]\n",
  "HERONSHAW": "a heron, also HERNSHAW, HERONSEW [n -S]\n",
  "HERONSHAWS": "HERONSHAW, a heron, also HERNSHAW, HERONSEW [n]\n",
  "HEROON": "(Greek) a temple to a hero; a temple-shaped tomb [n -S]\n",
  "HEROONS": "HEROON, (Greek) a temple to a hero; a temple-shaped tomb [n]\n",
  "HEROS": "HERO, a brave man [n]\n",
  "HEROSHIP": "the state of being a hero [n -S]\n",
  "HEROSHIPS": "HEROSHIP, the state of being a hero [n]\n",
  "HERPES": "(Greek) a skin infection [n -ES]\n",
  "HERPESES": "HERPES, (Greek) a skin infection [n]\n",
  "HERPESVIRUS": "the virus responsible for herpes [n -ES]\n",
  "HERPESVIRUSES": "HERPESVIRUS, the virus responsible for herpes [n]\n",
  "HERPETIC": "relating to herpes [adj] / a person suffering from herpes [n -S]\n",
  "HERPETICS": "HERPETIC, a person suffering from herpes [n]\n",
  "HERPETOFAUNA": "(Latin) snake life [n HERPETOFAUNAE or HERPETOFAUNAS]\n",
  "HERPETOFAUNAE": "HERPETOFAUNA, (Latin) snake life [n]\n",
  "HERPETOFAUNAS": "HERPETOFAUNA, (Latin) snake life [n]\n",
  "HERPETOID": "of or relating to snakes [adj]\n",
  "HERPETOLOGIC": "relating to herpetology, also HERPETOLOGICAL [adj]\n",
  "HERPETOLOGICAL": "relating to herpetology, also HERPETOLOGIC [adj]\n",
  "HERPETOLOGIES": "HERPETOLOGY, the study of reptiles and amphibians [n]\n",
  "HERPETOLOGIST": "one who studies snakes [n -S]\n",
  "HERPETOLOGISTS": "HERPETOLOGIST, one who studies snakes [n]\n",
  "HERPETOLOGY": "the study of reptiles and amphibians [n HERPETOLOGIES]\n",
  "HERPTILE": "relating to both reptiles and amphibians [adj]\n",
  "HERRENVOLK": "(German) a master race, a race believing themselves to be fitted to rule the world [n -S]\n",
  "HERRENVOLKS": "HERRENVOLK, (German) a master race, a race believing themselves to be fitted to rule the world [n]\n",
  "HERRIED": "HERRY, (Spenser) to praise, regard as holy, also HERY, HERYE [v]\n",
  "HERRIES": "HERRY, (Spenser) to praise, regard as holy, also HERY, HERYE [v]\n",
  "HERRIMENT": "(Scots) spoliation, plunder, also HERRYMENT [n -S]\n",
  "HERRIMENTS": "HERRIMENT, (Scots) spoliation, plunder, also HERRYMENT [n]\n",
  "HERRING": "any marine soft-finned teleost fish of the family Clupeidae [n -S]\n",
  "HERRINGBONE": "twilled fabric woven in rows of parallel sloping lines [n -S] / to make or mark with a herringbone pattern [v HERRINGBONED, HERRINGBONING, HERRINGBONES]\n",
  "HERRINGBONED": "HERRINGBONE, to make or mark with a herringbone pattern [v]\n",
  "HERRINGBONES": "HERRINGBONE, twilled fabric woven in rows of parallel sloping lines [n]\n",
  "HERRINGBONING": "HERRINGBONE, to make or mark with a herringbone pattern [v]\n",
  "HERRINGER": "a man or boat employed in herring fishing [n -S]\n",
  "HERRINGERS": "HERRINGER, a man or boat employed in herring fishing [n]\n",
  "HERRINGS": "HERRING, any marine soft-finned teleost fish of the family Clupeidae [n]\n",
  "HERRY": "(Spenser) to praise, regard as holy, also HERY, HERYE [v HERRIED, HERRYING, HERRIES]\n",
  "HERRYING": "HERRY, (Spenser) to praise, regard as holy, also HERY, HERYE [v]\n",
  "HERRYMENT": "(Scots) spoliation, plunder, also HERRIMENT [n -S]\n",
  "HERRYMENTS": "HERRYMENT, (Scots) spoliation, plunder, also HERRIMENT [n]\n",
  "HERS": "the possessive case of the pronoun she [pron]\n",
  "HERSALL": "(Spenser) a rehearsal [n -S]\n",
  "HERSALLS": "HERSALL, (Spenser) a rehearsal [n]\n",
  "HERSE": "(obsolete) a harrow [n -S]\n",
  "HERSED": "(obsolete) arranged like a herse, in harrow form [adj]\n",
  "HERSELF": "a form of the 3rd person singular feminine pronoun [pron]\n",
  "HERSES": "HERSE, (obsolete) a harrow [n]\n",
  "HERSHIP": "(Scots) plundering, plunder, esp. cattle [n -S]\n",
  "HERSHIPS": "HERSHIP, (Scots) plundering, plunder, esp. cattle [n]\n",
  "HERSTORIES": "HERSTORY, history with a feminist viewpoint [n]\n",
  "HERSTORY": "history with a feminist viewpoint [n HERSTORIES]\n",
  "HERTZ": "a unit of electromagnetic frequency [n -ES]\n",
  "HERTZES": "HERTZ, a unit of electromagnetic frequency [n]\n",
  "HERY": "(Spenser) to praise, regard as holy, also HERRY, HERYE [v HERIED, HERYING, HERIES]\n",
  "HERYE": "(Spenser) to praise, regard as holy, also HERRY, HERY [v HERYED, HERYING, HERYES]\n",
  "HERYED": "HERYE, (Spenser) to praise, regard as holy, also HERRY, HERY [v]\n",
  "HERYES": "HERYE, (Spenser) to praise, regard as holy, also HERRY, HERY [v]\n",
  "HERYING": "HERYE, (Spenser) to praise, regard as holy, also HERRY, HERY [v]\n",
  "HES": "HE, a male person or animal [n]\n",
  "HESITANCE": "wavering, doubt, also HESITANCY [n -S]\n",
  "HESITANCES": "HESITANCE, wavering, doubt, also HESITANCY [n]\n",
  "HESITANCIES": "HESITANCY, wavering, doubt, also HESITANCE [n]\n",
  "HESITANCY": "wavering, doubt, also HESITANCE [n HESITANCIES]\n",
  "HESITANT": "tending to hold back [adj HESITANTLY]\n",
  "HESITANTLY": "HESITANT, tending to hold back [adv]\n",
  "HESITATE": "to hold back or delay [v HESITATED, HESITATING, HESITATES]\n",
  "HESITATED": "HESITATE, to hold back or delay [v]\n",
  "HESITATER": "one who hesitates, also HESITATOR [n -S]\n",
  "HESITATERS": "HESITATER, one who hesitates, also HESITATOR [n]\n",
  "HESITATES": "HESITATE, to hold back or delay [v]\n",
  "HESITATING": "HESITATE, to hold back or delay [v]\n",
  "HESITATINGLY": "HESITATING, HESITATE, to hold back or delay [adv]\n",
  "HESITATION": "the action of hesitating [n -S]\n",
  "HESITATIONS": "HESITATION, the action of hesitating [n]\n",
  "HESITATIVE": "showing, or characterized by, hesitation [adj]\n",
  "HESITATOR": "one who hesitates, also HESITATER [n -S]\n",
  "HESITATORS": "HESITATOR, one who hesitates, also HESITATER [n]\n",
  "HESITATORY": "hesitating [adj]\n",
  "HESP": "(Scots) to fasten with a clasp, also HASP [v -ED, -ING, -S]\n",
  "HESPED": "HESP, (Scots) to fasten with a clasp, also HASP [v]\n",
  "HESPERID": "a skipper butterfly [n -S]\n",
  "HESPERIDIA": "HESPERIDIUM, a plant with a berry like a citrus fruit [n]\n",
  "HESPERIDIN": "a glucoside found in ripe and unripe fruit (as the orange), and extracted as a white crystalline substance [n -S]\n",
  "HESPERIDINS": "HESPERIDIN, a glucoside found in ripe and unripe fruit (as the orange), and extracted as a white crystalline substance [n]\n",
  "HESPERIDIUM": "a plant with a berry like a citrus fruit [n HESPERIDIA]\n",
  "HESPERIDS": "HESPERID, a skipper butterfly [n]\n",
  "HESPING": "HESP, (Scots) to fasten with a clasp, also HASP [v]\n",
  "HESPS": "HESP, (Scots) to fasten with a clasp, also HASP [v]\n",
  "HESSIAN": "a strong coarse cloth made of hemp or jute [n -S]\n",
  "HESSIANS": "HESSIAN, a strong coarse cloth made of hemp or jute [n]\n",
  "HESSITE": "a lead-gray sectile mineral, a telluride of silver [n -S]\n",
  "HESSITES": "HESSITE, a lead-gray sectile mineral, a telluride of silver [n]\n",
  "HESSONITE": "cinnamon stone, a variety of garnet, also ESSONITE [n -S]\n",
  "HESSONITES": "HESSONITE, cinnamon stone, a variety of garnet, also ESSONITE [n]\n",
  "HEST": "(archaic) behest, command, also HEAST, HEASTE [n -S]\n",
  "HESTERNAL": "of or relating to yesterday [adj]\n",
  "HESTS": "HEST, (archaic) behest, command, also HEAST, HEASTE [n]\n",
  "HET": "(colloquial) a heterosexual [n -S]\n",
  "HETAERA": "(Greek) a Greek courtesan, also HETAIRA [n HETAERAS or HETAERAE]\n",
  "HETAERAE": "HETAERA, (Greek) a Greek courtesan, also HETAIRA [n]\n",
  "HETAERAS": "HETAERA, (Greek) a Greek courtesan, also HETAIRA [n]\n",
  "HETAERIC": "like a hetaera, also HETAIRIC [adj]\n",
  "HETAERISM": "concubinage; a system of communal marriage, also HETAIRISM [n -S]\n",
  "HETAERISMIC": "relating to hetaerism, concubinage, also HETAERISTIC, HETAIRISTIC [adj]\n",
  "HETAERISMS": "HETAERISM, concubinage; a system of communal marriage, also HETAIRISM [n]\n",
  "HETAERIST": "an advocate of hetaerism, concubinage, also HETAIRIST [n -S]\n",
  "HETAERISTIC": "relating to hetaerism, concubinage, also HETAERISMIC, HETAIRISTIC [adj]\n",
  "HETAERISTS": "HETAERIST, an advocate of hetaerism, concubinage, also HETAIRIST [n]\n",
  "HETAIRA": "a Greek courtesan, also HETAERA [n HETAIRAS or HETAIRAI]\n",
  "HETAIRAI": "HETAIRA, a Greek courtesan, also HETAERA [n]\n",
  "HETAIRAS": "HETAIRA, a Greek courtesan, also HETAERA [n]\n",
  "HETAIRIA": "(historical) a club or society [n -S]\n",
  "HETAIRIAS": "HETAIRIA, (historical) a club or society [n]\n",
  "HETAIRIC": "like a hetaira, also HETAERIC [adj]\n",
  "HETAIRISM": "concubinage; a system of communal marriage, also HETAERISM [n -S]\n",
  "HETAIRISMIC": "relating to hetairism, concubinage [adj]\n",
  "HETAIRISMS": "HETAIRISM, concubinage; a system of communal marriage, also HETAERISM [n]\n",
  "HETAIRIST": "an advocate of hetairism, concubinage, also HETAERIST [n -S]\n",
  "HETAIRISTIC": "relating to hetairism, concubinage, also HETAERISMIC, HETAERISTIC [adj]\n",
  "HETAIRISTS": "HETAIRIST, an advocate of hetairism, concubinage, also HETAERIST [n]\n",
  "HETE": "(obsolete) to command, also HIGHT, HECHT [v HOTE, HOTEN, HETING, HETES]\n",
  "HETERARCHIES": "HETERARCHY, a formal structure, usually represented by a diagram of connected nodes, without any single permanent uppermost node [n]\n",
  "HETERARCHY": "a formal structure, usually represented by a diagram of connected nodes, without any single permanent uppermost node [n HETERARCHIES]\n",
  "HETERAUXESES": "HETERAUXESIS, unsymmetrical growth [n]\n",
  "HETERAUXESIS": "unsymmetrical growth [n HETERAUXESES]\n",
  "HETERO": "a heterosexual [n -S]\n",
  "HETEROAROMATIC": "heterocyclic and aromatic [adj]\n",
  "HETEROATOM": "an atom other than carbon in the ring of a heterocyclic compound [n -S]\n",
  "HETEROATOMS": "HETEROATOM, an atom other than carbon in the ring of a heterocyclic compound [n]\n",
  "HETEROAUXIN": "a natural plant hormone, used esp. for stimulating growth and root formation in plant cutting [n -S]\n",
  "HETEROAUXINS": "HETEROAUXIN, a natural plant hormone, used esp. for stimulating growth and root formation in plant cutting [n]\n",
  "HETEROBLASTIC": "derived from different kinds of cells; showing indirect development [adj]\n",
  "HETEROBLASTIES": "HETEROBLASTY, the state of being heteroblastic [n]\n",
  "HETEROBLASTY": "the state of being heteroblastic [n HETEROBLASTIES]\n",
  "HETEROCARPOUS": "bearing fruit of more than kind [adj]\n",
  "HETEROCERCAL": "having the vertebral column passing into the upper lobe of the tail, which is usually larger than the lower, as in sharks [adj]\n",
  "HETEROCERCALITY": "the state of being heterocercal, also HETEROCERCY [n]\n",
  "HETEROCERCIES": "HETEROCERCY, the state of being heterocercal, also HETEROCERCALITY [n]\n",
  "HETEROCERCY": "the state of being heterocercal, also HETEROCERCALITY [n HETEROCERCIES]\n",
  "HETEROCHROMATIC": "pertaining to or having different colors [adj]\n",
  "HETEROCHROMATIN": "densely staining chromatin that appears as nodules in or along chromosomes and contains relatively few genes [n]\n",
  "HETEROCHROMOUS": "having different colors [adj]\n",
  "HETEROCHRONIC": "showing divergence from the normal time sequence in development [adj]\n",
  "HETEROCHRONIES": "HETEROCHRONY, divergence from normal time sequence in development, also HETEROCHRONISM [n]\n",
  "HETEROCHRONISM": "divergence from the normal time sequence in development, also HETEROCHRONY [n -S]\n",
  "HETEROCHRONISMS": "HETEROCHRONISM, divergence from the normal time sequence in development, also HETEROCHRONY [n]\n",
  "HETEROCHRONOUS": "divergent from the normal time sequence [adj]\n",
  "HETEROCHRONY": "divergence from normal time sequence in development, also HETEROCHRONISM [n HETEROCHRONIES]\n",
  "HETEROCLITE": "deviating from the ordinary rule; eccentric; (in grammar) irregularly inflected [adj] / an irregularly inflected word [n -S]\n",
  "HETEROCLITES": "HETEROCLITE, an irregularly inflected word [n]\n",
  "HETEROCLITIC": "irregularly inflected, also HETEROCLITOUS [adj]\n",
  "HETEROCLITOUS": "irregularly inflected, also HETEROCLITIC [adj]\n",
  "HETEROCONT": "a kind of yellow-green alga, also HETEROKONT [n -S]\n",
  "HETEROCONTS": "HETEROCONT, a kind of yellow-green alga, also HETEROKONT [n]\n",
  "HETEROCYCLE": "a ring composed of atoms of more than one kind [n -S]\n",
  "HETEROCYCLES": "HETEROCYCLE, a ring composed of atoms of more than one kind [n]\n",
  "HETEROCYCLIC": "a ring composed of atoms of more than one kind [n -S]\n",
  "HETEROCYCLICS": "HETEROCYCLIC, a ring composed of atoms of more than one kind [n]\n",
  "HETEROCYST": "a cell larger than the others, and of different appearance, occurring in certain algae related to nostoc [n -S]\n",
  "HETEROCYSTOUS": "of or like a heterocyst [adj]\n",
  "HETEROCYSTS": "HETEROCYST, a cell larger than the others, and of different appearance, occurring in certain algae related to nostoc [n]\n",
  "HETERODACTYL": "a heterodactylous bird [n -S]\n",
  "HETERODACTYLOUS": "having the first and second toes turned backwards, as in trogons, and not the first and fourth as in parrots [adj]\n",
  "HETERODACTYLS": "HETERODACTYL, a heterodactylous bird [n]\n",
  "HETERODONT": "having the teeth differentiated into incisors, canines, and molars, as in man [adj]\n",
  "HETERODOX": "holding unorthodox opinions or doctrines [adj]\n",
  "HETERODOXIES": "HETERODOXY, a heterodox opinion [n]\n",
  "HETERODOXY": "a heterodox opinion [n HETERODOXIES]\n",
  "HETERODUPLEX": "a nucleic-acid molecule, such as DNA, composed of two chains with each derived from a different parent molecule [n -ES]\n",
  "HETERODUPLEXES": "HETERODUPLEX, a nucleic-acid molecule, such as DNA, composed of two chains with each derived from a different parent molecule [n]\n",
  "HETERODYNE": "to change the frequency of (a signal) by imposing on a continuous wave another of slightly different length to produce beats [v HETERODYNED, HETERODYNING, HETERODYNES]\n",
  "HETERODYNED": "HETERODYNE, to change the frequency of (a signal) by imposing on a continuous wave another of slightly different length to produce beats [v]\n",
  "HETERODYNES": "HETERODYNE, to change the frequency of (a signal) by imposing on a continuous wave another of slightly different length to produce beats [v]\n",
  "HETERODYNING": "HETERODYNE, to change the frequency of (a signal) by imposing on a continuous wave another of slightly different length to produce beats [v]\n",
  "HETEROECIOUS": "parasitism upon several hosts [adj]\n",
  "HETEROECISM": "a form of parasitism that requires two (usually unrelated) host species to complete its life-cycle [n -S]\n",
  "HETEROECISMS": "HETEROECISM, a form of parasitism that requires two (usually unrelated) host species to complete its life-cycle [n]\n",
  "HETEROFLEXIBLE": "one of flexible sexual orientation [n -S]\n",
  "HETEROFLEXIBLES": "HETEROFLEXIBLE, one of flexible sexual orientation [n]\n",
  "HETEROGAMETE": "male and female sex cells are different [n -S]\n",
  "HETEROGAMETES": "HETEROGAMETE, male and female sex cells are different [n]\n",
  "HETEROGAMETIC": "having a dissimilar pair of sex chromosomes [adj]\n",
  "HETEROGAMETIES": "HETEROGAMETY, the state of being heterogametic [n]\n",
  "HETEROGAMETY": "the state of being heterogametic [n HETEROGAMETIES]\n",
  "HETEROGAMIES": "HETEROGAMY, the process of fertilization in plants by an indirect or circuitous method [n]\n",
  "HETEROGAMOUS": "relating to heterogamy, the process of fertilization in plants by an indirect or circuitous method [adj]\n",
  "HETEROGAMY": "the process of fertilization in plants by an indirect or circuitous method [n HETEROGAMIES]\n",
  "HETEROGENEITIES": "HETEROGENEITY, the state of being heterogeneous [n]\n",
  "HETEROGENEITY": "the state of being heterogeneous [n HETEROGENEITIES]\n",
  "HETEROGENEOUS": "consisting of dissimilar or diverse ingredients or constituents [adj]\n",
  "HETEROGENEOUSLY": "HETEROGENEOUS, consisting of dissimilar or diverse ingredients or constituents [adv]\n",
  "HETEROGENESES": "HETEROGENESIS, spontaneous or alternate generation, also HETEROGENY [n]\n",
  "HETEROGENESIS": "spontaneous or alternate generation, also HETEROGENY [n HETEROGENESES]\n",
  "HETEROGENETIC": "relating to heterogenesis, also HETEROGENIC [adj]\n",
  "HETEROGENIC": "relating to heterogenesis, also HETEROGENETIC [adj]\n",
  "HETEROGENIES": "HETEROGENY, spontaneous or alternate generation, also HETEROGENESIS [n]\n",
  "HETEROGENOUS": "originating outside the body [adj]\n",
  "HETEROGENY": "spontaneous or alternate generation, also HETEROGENESIS [n HETEROGENIES]\n",
  "HETEROGONIC": "relating to heterogony [adj]\n",
  "HETEROGONIES": "HETEROGONY, the condition of having two or more kinds of flowers, different as to the length of their stamens and pistils [n]\n",
  "HETEROGONOUS": "reproducing both sexually and asexually [adj HETEROGONOUSLY]\n",
  "HETEROGONOUSLY": "HETEROGONOUS, reproducing both sexually and asexually [adv]\n",
  "HETEROGONY": "the condition of having two or more kinds of flowers, different as to the length of their stamens and pistils [n HETEROGONIES]\n",
  "HETEROGRAFT": "a graft of tissue between individuals of different species, a xenograft [n -S]\n",
  "HETEROGRAFTS": "HETEROGRAFT, a graft of tissue between individuals of different species, a xenograft [n]\n",
  "HETEROGRAPHIC": "relating to heterography, incorrect spelling, also HETEROGRAPHICAL [adj]\n",
  "HETEROGRAPHICAL": "relating to heterography, incorrect spelling, also HETEROGRAPHIC [adj]\n",
  "HETEROGRAPHIES": "HETEROGRAPHY, incorrect spelling [n]\n",
  "HETEROGRAPHY": "incorrect spelling [n HETEROGRAPHIES]\n",
  "HETEROGYNOUS": "of ants, bees, etc., having two types of female, one fertile and the other infertile [adj]\n",
  "HETEROKARYON": "a cell, as in the mycelium of a fungus, that contains two or more genetically unlike nuclei [n -S]\n",
  "HETEROKARYONS": "HETEROKARYON, a cell, as in the mycelium of a fungus, that contains two or more genetically unlike nuclei [n]\n",
  "HETEROKARYOSES": "HETEROKARYOSIS, the condition of having cells that are heterokaryons [n]\n",
  "HETEROKARYOSIS": "the condition of having cells that are heterokaryons [n HETEROKARYOSES]\n",
  "HETEROKARYOTIC": "relating to heterokaryosis [adj]\n",
  "HETEROKONT": "a kind of yellow-green alga, also HETEROCONT [n -S]\n",
  "HETEROKONTAN": "of or like a heterokont, a kind of yellow-green alga [adj]\n",
  "HETEROKONTS": "HETEROKONT, a kind of yellow-green alga, also HETEROCONT [n]\n",
  "HETEROLECITHAL": "of the eggs of birds, having an unequally distributed yolk [adj]\n",
  "HETEROLOGIES": "HETEROLOGY, the study of differences [n]\n",
  "HETEROLOGOUS": "differing; comprising different parts or parts in different proportions [adj HETEROLOGOUSLY]\n",
  "HETEROLOGOUSLY": "HETEROLOGOUS, differing; comprising different parts or parts in different proportions [adv]\n",
  "HETEROLOGY": "the study of differences [n HETEROLOGIES]\n",
  "HETEROLYSES": "HETEROLYSIS, the decomposition of a compound into two oppositely charged particles or ions [n]\n",
  "HETEROLYSIS": "the decomposition of a compound into two oppositely charged particles or ions [n HETEROLYSES]\n",
  "HETEROLYTIC": "relating to heterolysis [adj]\n",
  "HETEROMEROUS": "unequal or different parts within the same structure [adj]\n",
  "HETEROMORPHIC": "having different forms, also HETEROMORPHOUS [adj]\n",
  "HETEROMORPHIES": "HETEROMORPHY, dissimilarity in shape, structure, or magnitude [n]\n",
  "HETEROMORPHISM": "the state of having different forms [n -S]\n",
  "HETEROMORPHISMS": "HETEROMORPHISM, the state of having different forms [n]\n",
  "HETEROMORPHOUS": "having different forms, also HETEROMORPHIC [adj]\n",
  "HETEROMORPHY": "dissimilarity in shape, structure, or magnitude [n HETEROMORPHIES]\n",
  "HETERONOMIES": "HETERONOMY, subordination or subjection to the law of another, as opposed to autonomy [n]\n",
  "HETERONOMOUS": "subject to different or foreign laws [adj HETERONOMOUSLY]\n",
  "HETERONOMOUSLY": "HETERONOMOUS, subject to different or foreign laws [adv]\n",
  "HETERONOMY": "subordination or subjection to the law of another, as opposed to autonomy [n HETERONOMIES]\n",
  "HETERONORMATIVE": "regarding heterosexual relationships as the social norm [adj]\n",
  "HETERONYM": "a word having same spelling but different sound and meaning e.g. lead/lead [n -S]\n",
  "HETERONYMOUS": "like a heteronym, a word having same spelling but different sound and meaning [adj HETERONYMOUSLY]\n",
  "HETERONYMOUSLY": "HETERONYMOUS, like a heteronym, a word having same spelling but different sound and meaning [adv]\n",
  "HETERONYMS": "HETERONYM, a word having same spelling but different sound and meaning e.g. lead/lead [n]\n",
  "HETEROOUSIAN": "one who believes that the Son is of a different substance from the Father [n -S]\n",
  "HETEROOUSIANS": "HETEROOUSIAN, one who believes that the Son is of a different substance from the Father [n]\n",
  "HETEROPHIL": "a polymorphonuclear leukocyte in humans that may be stained with dyes, also HETEROPHILE [n -S]\n",
  "HETEROPHILE": "a polymorphonuclear leukocyte in humans that may be stained with dyes, also HETEROPHIL [n -S]\n",
  "HETEROPHILES": "HETEROPHILE, a polymorphonuclear leukocyte in humans that may be stained with dyes, also HETEROPHIL [n]\n",
  "HETEROPHILS": "HETEROPHIL, a polymorphonuclear leukocyte in humans that may be stained with dyes, also HETEROPHILE [n]\n",
  "HETEROPHONIES": "HETEROPHONY, an independent variation on a single melody by two or more voices [n]\n",
  "HETEROPHONY": "an independent variation on a single melody by two or more voices [n HETEROPHONIES]\n",
  "HETEROPHYLLIES": "HETEROPHYLLY, the state of being heterophyllous [n]\n",
  "HETEROPHYLLOUS": "having the foliage leaves of more than one form on the same plant or stem [adj]\n",
  "HETEROPHYLLY": "the state of being heterophyllous [n HETEROPHYLLIES]\n",
  "HETEROPLASIA": "the development of abnormal tissue or tissue in an abnormal place [n -S]\n",
  "HETEROPLASIAS": "HETEROPLASIA, the development of abnormal tissue or tissue in an abnormal place [n]\n",
  "HETEROPLASTIC": "relating to heteroplasia, the development of abnormal tissue or tissue in an abnormal place [adj]\n",
  "HETEROPLASTIES": "HETEROPLASTY, grafting of foreign tissue [n]\n",
  "HETEROPLASTY": "grafting of foreign tissue [n HETEROPLASTIES]\n",
  "HETEROPLOID": "an organism having a chromosome number that is not an integral multiple of the haploid [n -S]\n",
  "HETEROPLOIDIES": "HETEROPLOIDY, the state of being heteroploid [n]\n",
  "HETEROPLOIDS": "HETEROPLOID, an organism having a chromosome number that is not an integral multiple of the haploid [n]\n",
  "HETEROPLOIDY": "the state of being heteroploid [n HETEROPLOIDIES]\n",
  "HETEROPOD": "any of a group of free-swimming prosobranch gastropods having the foot adapted for swimming [n -S]\n",
  "HETEROPODS": "HETEROPOD, any of a group of free-swimming prosobranch gastropods having the foot adapted for swimming [n]\n",
  "HETEROPOLAR": "polar, in the chemical sense [adj]\n",
  "HETEROPOLARITY": "the state of being heteropolar [n]\n",
  "HETEROPTERAN": "relating to the Heteroptera, a suborder of hemipterous insects, including bedbugs, water bugs, etc., also HETEROPTEROUS [adj] / a member of the Heteroptera [n -S]\n",
  "HETEROPTERANS": "HETEROPTERAN, a member of the Heteroptera [n]\n",
  "HETEROPTEROUS": "of, relating to, or belonging to the Heteroptera, a suborder of hemipterous insects, including bedbugs, water bugs, etc., also HETEROPTERAN [adj]\n",
  "HETEROS": "HETERO, a heterosexual [n]\n",
  "HETEROSCEDASTIC": "of several distributions, having different variances [adj]\n",
  "HETEROSCIAN": "a dweller in a temperate zone [n -S]\n",
  "HETEROSCIANS": "HETEROSCIAN, a dweller in a temperate zone [n]\n",
  "HETEROSES": "HETEROSIS, the increased size and vigor attributable to hybridization [n]\n",
  "HETEROSEXISM": "the belief that homosexuality is a perversion [n -S]\n",
  "HETEROSEXISMS": "HETEROSEXISM, the belief that homosexuality is a perversion [n]\n",
  "HETEROSEXIST": "one who believes that homosexuality is a perversion [n -S]\n",
  "HETEROSEXISTS": "HETEROSEXIST, one who believes that homosexuality is a perversion [n]\n",
  "HETEROSEXUAL": "attracted to the opposite sex [adj HETEROSEXUALLY] / a heterosexual person [n -S]\n",
  "HETEROSEXUALITY": "the state of being heterosexual [n]\n",
  "HETEROSEXUALLY": "HETEROSEXUAL, attracted to the opposite sex [adv]\n",
  "HETEROSEXUALS": "HETEROSEXUAL, a heterosexual person [n]\n",
  "HETEROSIS": "the increased size and vigor attributable to hybridization [n HETEROSES]\n",
  "HETEROSOCIAL": "relating to social relations (or preference for such relations) with the opposite sex of the nonsexual nature [adj]\n",
  "HETEROSOCIALITY": "the state of being heterosocial [n]\n",
  "HETEROSOMATOUS": "of or like the Heterosomata, the flatfishes [adj]\n",
  "HETEROSPECIFIC": "an organism of a different species or group [n -S]\n",
  "HETEROSPECIFICS": "HETEROSPECIFIC, an organism of a different species or group [n]\n",
  "HETEROSPORIES": "HETEROSPORY, the production of microspores and megaspores, as in seed plants [n]\n",
  "HETEROSPOROUS": "producing two different sizes or kinds of spores [adj]\n",
  "HETEROSPORY": "the production of microspores and megaspores, as in seed plants [n HETEROSPORIES]\n",
  "HETEROSTROPHIC": "consisting of unequal strophes; coiled contrary to the usual direction [adj]\n",
  "HETEROSTROPHIES": "HETEROSTROPHY, the state of being heterostrophic, consisting of unequal strophes [n]\n",
  "HETEROSTROPHY": "the state of being heterostrophic, consisting of unequal strophes [n HETEROSTROPHIES]\n",
  "HETEROSTYLED": "having styles of different length in different flowers, also HETEROSTYLOUS [adj]\n",
  "HETEROSTYLIES": "HETEROSTYLY, the state of having styles of different length in different flowers, also HETEROSTYLISM [n]\n",
  "HETEROSTYLISM": "the state of having styles of different lengths in different flowers, also HETEROSTYLY [n -S]\n",
  "HETEROSTYLISMS": "HETEROSTYLISM, the state of having styles of different lengths in different flowers, also HETEROSTYLY [n]\n",
  "HETEROSTYLOUS": "having styles of different length in different flowers, also HETEROSTYLED [adj]\n",
  "HETEROSTYLY": "the state of having styles of different length in different flowers, also HETEROSTYLISM [n HETEROSTYLIES]\n",
  "HETEROTACTIC": "abnormally arranged [adj]\n",
  "HETEROTACTOUS": "relating to heterotaxis, the anomalous arrangement of body parts [adj]\n",
  "HETEROTAXES": "HETEROTAXIS, the anomalous arrangement of body parts [n]\n",
  "HETEROTAXIA": "the abnormal disposition of organs or parts, also HETEROTAXY [n -S]\n",
  "HETEROTAXIAS": "HETEROTAXIA, the abnormal disposition of organs or parts, also HETEROTAXY [n]\n",
  "HETEROTAXIC": "relating to heterotaxy [adj]\n",
  "HETEROTAXIES": "HETEROTAXY, the abnormal disposition of organs or parts, also HETEROTAXIA [n]\n",
  "HETEROTAXIS": "the anomalous arrangement of body parts [n HETEROTAXES]\n",
  "HETEROTAXY": "the abnormal disposition of organs or parts, also HETEROTAXIA [n HETEROTAXIES]\n",
  "HETEROTHALLIC": "of certain fungi, having two physiologically different types of mycelium, comparable to male and female [adj]\n",
  "HETEROTHALLIES": "HETEROTHALLY, the state of being heterothallic, also HETEROTHALLISM [n]\n",
  "HETEROTHALLISM": "the state of being heterothallic, also HETEROTHALLY [n -S]\n",
  "HETEROTHALLISMS": "HETEROTHALLISM, the state of being heterothallic, also HETEROTHALLY [n]\n",
  "HETEROTHALLY": "the state of being heterothallic, also HETEROTHALLISM [n HETEROTHALLIES]\n",
  "HETEROTHERMAL": "taking the temperature of the surroundings [adj]\n",
  "HETEROTIC": "relating to heterosis, the increased size and vigor attributable to hybridization [adj]\n",
  "HETEROTOPIA": "displacement of an organ from its normal position in the body, also HETEROTOPY [n -S]\n",
  "HETEROTOPIAS": "HETEROTOPIA, displacement of an organ from its normal position in the body, also HETEROTOPY [n]\n",
  "HETEROTOPIC": "relating to heterotopy, displacement of an organ of the body, also HETEROTOPOUS [adj]\n",
  "HETEROTOPIES": "HETEROTOPY, displacement of an organ of the body, also HETEROTOPIA [n]\n",
  "HETEROTOPOUS": "relating to heterotopy, displacement of an organ of the body, also HETEROTOPIC [adj]\n",
  "HETEROTOPY": "displacement of an organ of the body, also HETEROTOPIA [n HETEROTOPIES]\n",
  "HETEROTROPH": "a secondary feeder eating plants or other animals [n -S]\n",
  "HETEROTROPHIC": "dependent on external sources of organic nutrients [adj]\n",
  "HETEROTROPHIES": "HETEROTROPHY, the state of being a heterotroph, a secondary feeder eating plants or other animals [n]\n",
  "HETEROTROPHS": "HETEROTROPH, a secondary feeder eating plants or other animals [n]\n",
  "HETEROTROPHY": "the state of being a heterotroph, a secondary feeder eating plants or other animals [n HETEROTROPHIES]\n",
  "HETEROTYPIC": "denoting or relating to the first nuclear division of meiosis, in which the chromosome number is halved, also HETEROTYPICAL [adj]\n",
  "HETEROTYPICAL": "denoting or relating to the first nuclear division of meiosis, in which the chromosome number is halved, also HETEROTYPIC [adj]\n",
  "HETEROUSIAN": "one who believes the Father and Son to be of different essences [n -S]\n",
  "HETEROUSIANS": "HETEROUSIAN, one who believes the Father and Son to be of different essences [n]\n",
  "HETEROZYGOSES": "HETEROZYGOSIS, the mixed ancestry of heterozygotes [n]\n",
  "HETEROZYGOSIS": "the mixed ancestry of heterozygotes [n HETEROZYGOSES]\n",
  "HETEROZYGOSITY": "the state of being heterozygous [n]\n",
  "HETEROZYGOTE": "a heterozygous individual [n -S]\n",
  "HETEROZYGOTES": "HETEROZYGOTE, a heterozygous individual [n]\n",
  "HETEROZYGOUS": "having the two alleles at corresponding loci on homologous chromosomes different for one or more loci [adj]\n",
  "HETES": "HETE, (obsolete) to command, also HIGHT, HECHT [v]\n",
  "HETH": "(Hebrew) the eighth letter of the Hebrew alphabet, also CHETH, KHET, KHETH [n -S]\n",
  "HETHER": "(Spenser) hither, also HITHER [adj]\n",
  "HETHERWARD": "(Spenser) hitherward, also HITHERWARD, HITHERWARDS [adv]\n",
  "HETHS": "HETH, (Hebrew) the eighth letter of the Hebrew alphabet, also CHETH, KHET, KHETH [n]\n",
  "HETING": "HETE, (obsolete) to command, also HIGHT, HECHT [v]\n",
  "HETMAN": "(historical) a Cossack headman or general, also ATAMAN [n HETMEN or HETMANS]\n",
  "HETMANATE": "the office of hetman, the head or general of the Cossacks [n -S]\n",
  "HETMANATES": "HETMANATE, the office of hetman, the head or general of the Cossacks [n]\n",
  "HETMANS": "HETMAN, (historical) a Cossack headman or general, also ATAMAN [n]\n",
  "HETMANSHIP": "the office of a hetman [n -S]\n",
  "HETMANSHIPS": "HETMANSHIP, the office of a hetman [n]\n",
  "HETMEN": "HETMAN, (historical) a Cossack headman or general, also ATAMAN [n]\n",
  "HETS": "HET, (colloquial) a heterosexual [n]\n",
  "HETTIE": "a heterosexual person [n -S]\n",
  "HETTIES": "HETTIE, a heterosexual person [n]\n",
  "HEUCH": "(Scots) a crag, a steep-sided valley, also HEUGH [n -S]\n",
  "HEUCHERA": "a North American plant with heart-shaped leaves and mostly red flowers [n -S]\n",
  "HEUCHERAS": "HEUCHERA, a North American plant with heart-shaped leaves and mostly red flowers [n]\n",
  "HEUCHS": "HEUCH, (Scots) a crag, a steep-sided valley, also HEUGH [n]\n",
  "HEUGH": "(Scots) a crag, a steep-sided valley, also HEUCH [n -S]\n",
  "HEUGHS": "HEUGH, (Scots) a crag, a steep-sided valley, also HEUCH [n]\n",
  "HEULANDITE": "a mineral of the zeolite family, a hydrous silicate of alumina and lime [n -S]\n",
  "HEULANDITES": "HEULANDITE, a mineral of the zeolite family, a hydrous silicate of alumina and lime [n]\n",
  "HEUREKA": "(Greek) a brilliant discovery, also EUREKA [n -S]\n",
  "HEUREKAS": "HEUREKA, (Greek) a brilliant discovery, also EUREKA [n]\n",
  "HEURETIC": "of or relating to exploratory problem-solving methods that utilize self-educating techniques to improve performance, also HEURISTIC [adj]\n",
  "HEURETICS": "the art of discovery in logic; education by encouraging pupils to learn for themselves, also HEURISTICS [n]\n",
  "HEURISM": "the heuristic method or principle in education [n -S]\n",
  "HEURISMS": "HEURISM, the heuristic method or principle in education [n]\n",
  "HEURISTIC": "of or relating to exploratory problem-solving methods that utilize self-educating techniques to improve performance, also HEURETIC [adj HEURISTICALLY]\n",
  "HEURISTICALLY": "HEURISTIC, of or relating to exploratory problem-solving methods that utilize self-educating techniques to improve performance, also HEURETIC [adv]\n",
  "HEURISTICS": "the art of discovery in logic; education by encouraging pupils to learn for themselves, also HEURETICS [n]\n",
  "HEVEA": "(Quechua) any of various South American trees of the spurge family, whose milky sap is a major source of rubber [n -S]\n",
  "HEVEAS": "HEVEA, (Quechua) any of various South American trees of the spurge family, whose milky sap is a major source of rubber [n]\n",
  "HEW": "to cut with an ax [v HEWED, HEWN, HEWING, HEWS]\n",
  "HEWABLE": "able to be hewed [adj]\n",
  "HEWED": "HEW, to cut with an ax [v]\n",
  "HEWER": "one that hews [n -S]\n",
  "HEWERS": "HEWER, one that hews [n]\n",
  "HEWGH": "(Shakespeare) imitating the whistling of an arrow [interj]\n",
  "HEWING": "the process of cutting e.g. a tree [n -S]\n",
  "HEWINGS": "HEWING, the process of cutting e.g. a tree [n]\n",
  "HEWN": "HEW, to cut with an ax [v]\n",
  "HEWS": "HEW, to cut with an ax [v]\n",
  "HEX": "to cast an evil spell upon [v -ED, -ING, -ES]\n",
  "HEXACHLORETHANE": "a toxic crystalline compound used in smoke bombs [n]\n",
  "HEXACHLORIDE": "a chloride containing six atoms of chlorine [n -S]\n",
  "HEXACHLORIDES": "HEXACHLORIDE, a chloride containing six atoms of chlorine [n]\n",
  "HEXACHLOROPHANE": "a bactericide used in antiseptic soaps, deodorants etc., also HEXACHLOROPHENE [n]\n",
  "HEXACHLOROPHENE": "a bactericide used in antiseptic soaps, deodorants etc., also HEXACHLOROPHANE [n]\n",
  "HEXACHORD": "a series of six notes, with a semitone between the third and fourth, the other intervals being whole tones [n -S]\n",
  "HEXACHORDS": "HEXACHORD, a series of six notes, with a semitone between the third and fourth, the other intervals being whole tones [n]\n",
  "HEXACOSANOIC": "as in hexacosanoic acid [adj]\n",
  "HEXACT": "a six-rayed sponge spicule [n -S]\n",
  "HEXACTINAL": "having six rays [adj]\n",
  "HEXACTINELLID": "a kind of six-rayed sponge [n -S]\n",
  "HEXACTINELLIDS": "HEXACTINELLID, a kind of six-rayed sponge [n]\n",
  "HEXACTS": "HEXACT, a six-rayed sponge spicule [n]\n",
  "HEXAD": "(Greek) a group of six, also HEXADE [n -S]\n",
  "HEXADACTYLIC": "having six fingers, also HEXADACTYLOUS [adj]\n",
  "HEXADACTYLOUS": "having six fingers, also HEXADACTYLIC [adj]\n",
  "HEXADE": "a group of six, also HEXAD [n -S]\n",
  "HEXADECANE": "the systematic name for cetane, a colourless liquid hydrocarbon [n -S]\n",
  "HEXADECANES": "HEXADECANE, the systematic name for cetane, a colourless liquid hydrocarbon [n]\n",
  "HEXADECANOIC": "as in hexadecanoic acid, a fatty acid, aka palmitic acid [adj]\n",
  "HEXADECIMAL": "a number system with a base of 16 [n -S]\n",
  "HEXADECIMALS": "HEXADECIMAL, a number system with a base of 16 [n]\n",
  "HEXADECYL": "another name for the radical cetyl [n -S]\n",
  "HEXADECYLS": "HEXADECYL, another name for the radical cetyl [n]\n",
  "HEXADES": "HEXADE, a group of six, also HEXAD [n]\n",
  "HEXADIC": "relating to a hexad [adj]\n",
  "HEXADS": "HEXAD, (Greek) a group of six, also HEXADE [n]\n",
  "HEXAEMERIC": "relating to a hexaemeron, the biblical six days of creation, also HEXAHEMERIC [adj]\n",
  "HEXAEMERON": "the (biblical) six days of creation, also HEXAHEMERON [n -S]\n",
  "HEXAEMERONS": "HEXAEMERON, the (biblical) six days of creation, also HEXAHEMERON [n]\n",
  "HEXAFLUORIDE": "a chemical compound with the general formula XF6 [n -S]\n",
  "HEXAFLUORIDES": "HEXAFLUORIDE, a chemical compound with the general formula XF6 [n]\n",
  "HEXAFOIL": "a pattern with six leaflike lobes [n -S]\n",
  "HEXAFOILS": "HEXAFOIL, a pattern with six leaflike lobes [n]\n",
  "HEXAGLOT": "a book written in six languages [n -S]\n",
  "HEXAGLOTS": "HEXAGLOT, a book written in six languages [n]\n",
  "HEXAGON": "a polygon having six sides [n -S]\n",
  "HEXAGONAL": "having six sides and six angles [adj HEXAGONALLY]\n",
  "HEXAGONALLY": "HEXAGONAL, having six sides and six angles [adv]\n",
  "HEXAGONS": "HEXAGON, a polygon having six sides [n]\n",
  "HEXAGRAM": "a six-pointed star [n -S]\n",
  "HEXAGRAMMOID": "a hexagram shape [n -S]\n",
  "HEXAGRAMMOIDS": "HEXAGRAMMOID, a hexagram shape [n]\n",
  "HEXAGRAMS": "HEXAGRAM, a six-pointed star [n]\n",
  "HEXAGYNIAN": "having six pistils, also HEXAGYNOUS [adj]\n",
  "HEXAGYNOUS": "having six pistils, also HEXAGYNIAN [adj]\n",
  "HEXAHEDRA": "HEXAHEDRON, a solid body of six sides or faces [n]\n",
  "HEXAHEDRAL": "in the form of a hexahedron [adj]\n",
  "HEXAHEDRON": "a solid body of six sides or faces [n HEXAHEDRA or HEXAHEDRONS]\n",
  "HEXAHEDRONS": "HEXAHEDRON, a solid body of six sides or faces [n]\n",
  "HEXAHEMERIC": "relating to a hexaemeron, the biblical six days of creation, also HEXAEMERIC [adj]\n",
  "HEXAHEMERON": "the (biblical) six days of creation, also HEXAEMERON [n -S]\n",
  "HEXAHEMERONS": "HEXAHEMERON, the (biblical) six days of creation, also HEXAEMERON [n]\n",
  "HEXAHYDRATE": "a chemical compound with six molecules of water [n -S]\n",
  "HEXAHYDRATED": "like a hexahydrate, a chemical compound with six molecules of water [adj]\n",
  "HEXAHYDRATES": "HEXAHYDRATE, a chemical compound with six molecules of water [n]\n",
  "HEXAMERAL": "arranged in six groups [adj]\n",
  "HEXAMERISM": "the state of being hexamerous [n -S]\n",
  "HEXAMERISMS": "HEXAMERISM, the state of being hexamerous [n]\n",
  "HEXAMEROUS": "having six parts [adj]\n",
  "HEXAMETER": "a verse line of six feet [n -S]\n",
  "HEXAMETERS": "HEXAMETER, a verse line of six feet [n]\n",
  "HEXAMETHONIUM": "either of two compounds used as ganglionic blocking agents in the treatment of hypertension [n -S]\n",
  "HEXAMETHONIUMS": "HEXAMETHONIUM, either of two compounds used as ganglionic blocking agents in the treatment of hypertension [n]\n",
  "HEXAMETRAL": "like a hexameter, also HEXAMETRIC, HEXAMETRICAL [adj]\n",
  "HEXAMETRIC": "of verse, written in hexameters, also HEXAMETRAL, HEXAMETRICAL [adj]\n",
  "HEXAMETRICAL": "of verse, written in hexameters, also HEXAMETRAL, HEXAMETRIC [adj]\n",
  "HEXAMETRISE": "to put into hexameters, also HEXAMETRIZE [v HEXAMETRISED, HEXAMETRISING, HEXAMETRISES]\n",
  "HEXAMETRISED": "HEXAMETRISE, to put into hexameters, also HEXAMETRIZE [v]\n",
  "HEXAMETRISES": "HEXAMETRISE, to put into hexameters, also HEXAMETRIZE [v]\n",
  "HEXAMETRISING": "HEXAMETRISE, to put into hexameters, also HEXAMETRIZE [v]\n",
  "HEXAMETRIST": "a writer of hexameters [n -S]\n",
  "HEXAMETRISTS": "HEXAMETRIST, a writer of hexameters [n]\n",
  "HEXAMETRIZE": "to put into hexameters, also HEXAMETRISE [v HEXAMETRIZED, HEXAMETRIZING, HEXAMETRIZES]\n",
  "HEXAMETRIZED": "HEXAMETRIZE, to put into hexameters, also HEXAMETRISE [v]\n",
  "HEXAMETRIZES": "HEXAMETRIZE, to put into hexameters, also HEXAMETRISE [v]\n",
  "HEXAMETRIZING": "HEXAMETRIZE, to put into hexameters, also HEXAMETRISE [v]\n",
  "HEXAMINE": "a chemical compound, used as a solid fuel [n -S]\n",
  "HEXAMINES": "HEXAMINE, a chemical compound, used as a solid fuel [n]\n",
  "HEXANDRIAN": "having six stamens, also HEXANDROUS [adj]\n",
  "HEXANDROUS": "having six stamens, also HEXANDRIAN [adj]\n",
  "HEXANE": "any one of five hydrocarbons of the paraffin series, so called because the molecule has six carbon atoms [n -S]\n",
  "HEXANES": "HEXANE, any one of five hydrocarbons of the paraffin series, so called because the molecule has six carbon atoms [n]\n",
  "HEXANGULAR": "having six angles [adj]\n",
  "HEXANOIC": "as in hexanoic acid, a component of palm oil [adj]\n",
  "HEXAPLA": "(Greek) a book of six (especially Biblical) parallel texts [n -S]\n",
  "HEXAPLAR": "relating to a hexapla, an edition of the bible in six languages, also HEXAPLARIAN, HEXAPLARIC [adj]\n",
  "HEXAPLARIAN": "relating to a hexapla, an edition of the bible in six languages, also HEXAPLAR, HEXAPLARIC [adj]\n",
  "HEXAPLARIC": "relating to a hexapla, an edition of the bible in six languages, also HEXAPLAR, HEXAPLARIAN [adj]\n",
  "HEXAPLAS": "HEXAPLA, (Greek) a book of six (especially Biblical) parallel texts [n]\n",
  "HEXAPLOID": "a cell having six times the ordinary number of chromosomes [n -S]\n",
  "HEXAPLOIDIES": "HEXAPLOIDY, the state of having six times the normal number of chromosomes [n]\n",
  "HEXAPLOIDS": "HEXAPLOID, a cell having six times the ordinary number of chromosomes [n]\n",
  "HEXAPLOIDY": "the state of having six times the normal number of chromosomes [n HEXAPLOIDIES]\n",
  "HEXAPOD": "an animal with six feet, an insect [n -S]\n",
  "HEXAPODAL": "relating to Hexapoda, insects [adj]\n",
  "HEXAPODIC": "of a line or verse, having six feet [adj]\n",
  "HEXAPODIES": "HEXAPODY, a line of verse with six feet [n]\n",
  "HEXAPODS": "HEXAPOD, an animal with six feet, an insect [n]\n",
  "HEXAPODY": "a line of verse with six feet [n HEXAPODIES]\n",
  "HEXARCH": "of a vascular bundle, having six strands of xylem, formed from six points of origin [adj]\n",
  "HEXARCHIES": "HEXARCHY, a group of six separate states [n]\n",
  "HEXARCHY": "a group of six separate states [n HEXARCHIES]\n",
  "HEXASTICH": "a poem or stanza of six lines, also HEXASTICHON [n -S]\n",
  "HEXASTICHAL": "having six lines or rows, also HEXASTICHIC [adj]\n",
  "HEXASTICHIC": "having six lines or rows, also HEXASTICHAL [adj]\n",
  "HEXASTICHON": "a poem or stanza of six lines, also HEXASTICH [n -S]\n",
  "HEXASTICHONS": "HEXASTICHON, a poem or stanza of six lines, also HEXASTICH [n]\n",
  "HEXASTICHS": "HEXASTICH, a poem or stanza of six lines, also HEXASTICHON [n]\n",
  "HEXASTYLE": "having six columns in front [adj] / a portico having six columns in front [n -S]\n",
  "HEXASTYLES": "HEXASTYLE, a portico having six columns in front [n]\n",
  "HEXATEUCHAL": "relating to the Hexateuch, the first six books of the Old Testament [adj]\n",
  "HEXATHLON": "an athletic contest comprising six events [n -S]\n",
  "HEXATHLONS": "HEXATHLON, an athletic contest comprising six events [n]\n",
  "HEXAVALENT": "having a valency of six [adj]\n",
  "HEXED": "HEX, to cast an evil spell upon [v]\n",
  "HEXENE": "a colorless, liquid hydrocarbon of the ethylene series, also HEXYLENE [n -S]\n",
  "HEXENES": "HEXENE, a colorless, liquid hydrocarbon of the ethylene series, also HEXYLENE [n]\n",
  "HEXER": "one who hexes, casts malevolent spells [n -S]\n",
  "HEXEREI": "(German) witchcraft [n -S]\n",
  "HEXEREIS": "HEXEREI, (German) witchcraft [n]\n",
  "HEXERS": "HEXER, one who hexes, casts malevolent spells [n]\n",
  "HEXES": "HEX, to cast an evil spell upon [v]\n",
  "HEXING": "the casting of an evil spell [n -S]\n",
  "HEXINGS": "HEXING, the casting of an evil spell [n]\n",
  "HEXOBARBITAL": "a barbiturate used as a sedative and hypnotic [n -S]\n",
  "HEXOBARBITALS": "HEXOBARBITAL, a barbiturate used as a sedative and hypnotic [n]\n",
  "HEXOKINASE": "an enzyme [n -S]\n",
  "HEXOKINASES": "HEXOKINASE, an enzyme [n]\n",
  "HEXONE": "a hydrocarbon solvent [n -S]\n",
  "HEXONES": "HEXONE, a hydrocarbon solvent [n]\n",
  "HEXOSAMINIDASE": "either of two hydrolytic enzymes that catalyze the splitting off of a hexose from a ganglioside and are deficient in some metabolic diseases [n -S]\n",
  "HEXOSAMINIDASES": "HEXOSAMINIDASE, either of two hydrolytic enzymes that catalyze the splitting off of a hexose from a ganglioside and are deficient in some metabolic diseases [n]\n",
  "HEXOSAN": "a polysaccharide that yields hexose on hydrolysis [n -S]\n",
  "HEXOSANS": "HEXOSAN, a polysaccharide that yields hexose on hydrolysis [n]\n",
  "HEXOSE": "a sugar with six carbon atoms to the molecule [n -S]\n",
  "HEXOSES": "HEXOSE, a sugar with six carbon atoms to the molecule [n]\n",
  "HEXYL": "a radical derived from a hexose [n -S]\n",
  "HEXYLENE": "a colorless, liquid hydrocarbon of the ethylene series, also HEXENE [n -S]\n",
  "HEXYLENES": "HEXYLENE, a colorless, liquid hydrocarbon of the ethylene series, also HEXENE [n]\n",
  "HEXYLIC": "relating to a hexyl radical [adj]\n",
  "HEXYLRESORCINOL": "a crystalline phenol used as an antiseptic and anthelmintic [n]\n",
  "HEXYLS": "HEXYL, a radical derived from a hexose [n]\n",
  "HEY": "a winding country dance [n -S] / to dance the hey [v -ED, -ING, -S]\n",
  "HEYDAY": "the period of one's greatest success, also HEYDEY [n -S]\n",
  "HEYDAYS": "HEYDAY, the period of one's greatest success, also HEYDEY [n]\n",
  "HEYDEY": "the period of one's greatest success, also HEYDAY [n -S]\n",
  "HEYDEYS": "HEYDEY, the period of one's greatest success, also HEYDAY [n]\n",
  "HEYDUCK": "(Hungarian) a brigand, a guerilla warrior, also HAIDUK, HEIDUC [n -S]\n",
  "HEYDUCKS": "HEYDUCK, (Hungarian) a brigand, a guerilla warrior, also HAIDUK, HEIDUC [n]\n",
  "HEYED": "HEY, to dance the hey [v]\n",
  "HEYING": "HEY, to dance the hey [v]\n",
  "HEYS": "HEY, to dance the hey [v]\n",
  "HI": "an interjection used as a greeting [interj]\n",
  "HIANT": "(Latin) gaping [adj]\n",
  "HIATAL": "pertaining to a hiatus [adj]\n",
  "HIATUS": "(Latin) a gap or missing section [n -ES]\n",
  "HIATUSES": "HIATUS, (Latin) a gap or missing section [n]\n",
  "HIBACHI": "(Japanese) a portable barbecue for cooking food out of doors [n -S]\n",
  "HIBACHIS": "HIBACHI, (Japanese) a portable barbecue for cooking food out of doors [n]\n",
  "HIBAKUSHA": "(Japanese) a survivor of the 1945 atomic bombings of Hiroshima and Nagasaki [n -S]\n",
  "HIBAKUSHAS": "HIBAKUSHA, (Japanese) a survivor of the 1945 atomic bombings of Hiroshima and Nagasaki [n]\n",
  "HIBERNACLE": "that which serves for protection or shelter in winter [n -S]\n",
  "HIBERNACLES": "HIBERNACLE, that which serves for protection or shelter in winter [n]\n",
  "HIBERNACULA": "HIBERNACULUM, (Latin) a shelter occupied during the winter by a dormant animal (as an insect or reptile) [n]\n",
  "HIBERNACULUM": "(Latin) a shelter occupied during the winter by a dormant animal (as an insect or reptile) [n HIBERNACULA]\n",
  "HIBERNAL": "pertaining to winter [adj]\n",
  "HIBERNATE": "to pass the winter in a dormant state [v HIBERNATED, HIBERNATING, HIBERNATES]\n",
  "HIBERNATED": "HIBERNATE, to pass the winter in a dormant state [v]\n",
  "HIBERNATES": "HIBERNATE, to pass the winter in a dormant state [v]\n",
  "HIBERNATING": "HIBERNATE, to pass the winter in a dormant state [v]\n",
  "HIBERNATION": "the act of hibernating [n -S]\n",
  "HIBERNATIONS": "HIBERNATION, the act of hibernating [n]\n",
  "HIBERNATOR": "one who hibernates [n -S]\n",
  "HIBERNATORS": "HIBERNATOR, one who hibernates [n]\n",
  "HIBERNICISATION": "the process or act of making Irish, also HIBERNICIZATION, HIBERNISATION, HIBERNIZATION [n]\n",
  "HIBERNICISE": "to render Irish, also HIBERNICIZE, HIBERNISE, HIBERNIZE [v HIBERNICISED, HIBERNICISING, HIBERNICISES]\n",
  "HIBERNICISED": "HIBERNICISE, to render Irish, also HIBERNICIZE, HIBERNISE, HIBERNIZE [v]\n",
  "HIBERNICISES": "HIBERNICISE, to render Irish, also HIBERNICIZE, HIBERNISE, HIBERNIZE [v]\n",
  "HIBERNICISING": "HIBERNICISE, to render Irish, also HIBERNICIZE, HIBERNISE, HIBERNIZE [v]\n",
  "HIBERNICIZATION": "the process or act of making Irish, also HIBERNICISATION, HIBERNISATION, HIBERNIZATION [n]\n",
  "HIBERNICIZE": "to render Irish, also HIBERNICISE, HIBERNISE, HIBERNIZE [v HIBERNICIZED, HIBERNICIZING, HIBERNICIZES]\n",
  "HIBERNICIZED": "HIBERNICIZE, to render Irish, also HIBERNICISE, HIBERNISE, HIBERNIZE [v]\n",
  "HIBERNICIZES": "HIBERNICIZE, to render Irish, also HIBERNICISE, HIBERNISE, HIBERNIZE [v]\n",
  "HIBERNICIZING": "HIBERNICIZE, to render Irish, also HIBERNICISE, HIBERNISE, HIBERNIZE [v]\n",
  "HIBERNISATION": "the act of hibernising, also HIBERNICISATION, HIBERNICIZATION, HIBERNIZATION [n -S]\n",
  "HIBERNISATIONS": "HIBERNISATION, the act of hibernising, also HIBERNICISATION, HIBERNICIZATION, HIBERNIZATION [n]\n",
  "HIBERNISE": "to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNIZE [v HIBERNISED, HIBERNISING, HIBERNISES]\n",
  "HIBERNISED": "HIBERNISE, to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNIZE [v]\n",
  "HIBERNISES": "HIBERNISE, to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNIZE [v]\n",
  "HIBERNISING": "HIBERNISE, to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNIZE [v]\n",
  "HIBERNIZATION": "the act of hibernizing, also HIBERNICISATION, HIBERNICIZATION, HIBERNISATION [n -S]\n",
  "HIBERNIZATIONS": "HIBERNIZATION, the act of hibernizing, also HIBERNICISATION, HIBERNICIZATION, HIBERNISATION [n]\n",
  "HIBERNIZE": "to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNISE [v HIBERNIZED, HIBERNIZING, HIBERNIZES]\n",
  "HIBERNIZED": "HIBERNIZE, to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNISE [v]\n",
  "HIBERNIZES": "HIBERNIZE, to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNISE [v]\n",
  "HIBERNIZING": "HIBERNIZE, to render Irish, also HIBERNICISE, HIBERNICIZE, HIBERNISE [v]\n",
  "HIBISCUS": "(Latin) any of numerous chiefly tropical herbaceous plants, shrubs, and trees of the genus Hibiscus [n -ES]\n",
  "HIBISCUSES": "HIBISCUS, (Latin) any of numerous chiefly tropical herbaceous plants, shrubs, and trees of the genus Hibiscus [n]\n",
  "HIC": "used to represent a hiccup [interj]\n",
  "HICATEE": "a West Indian freshwater tortoise, also HICCATEE [n -S]\n",
  "HICATEES": "HICATEE, a West Indian freshwater tortoise, also HICCATEE [n]\n",
  "HICCATEE": "a West Indian freshwater tortoise, also HICATEE [n -S]\n",
  "HICCATEES": "HICCATEE, a West Indian freshwater tortoise, also HICATEE [n]\n",
  "HICCOUGH": "to make a peculiar-sounding spasmodic inhalation, also HICCUP [v -ED, -ING, -S]\n",
  "HICCOUGHED": "HICCOUGH, to make a peculiar-sounding spasmodic inhalation, also HICCUP [v]\n",
  "HICCOUGHING": "HICCOUGH, to make a peculiar-sounding spasmodic inhalation, also HICCUP [v]\n",
  "HICCOUGHS": "HICCOUGH, to make a peculiar-sounding spasmodic inhalation, also HICCUP [v]\n",
  "HICCUP": "to make a peculiar-sounding spasmodic inhalation, also HICCOUGH [v HICCUPPED or HICCUPED, HICCUPPING or HICCUPING, HICCUPS]\n",
  "HICCUPED": "HICCUP, to make a peculiar-sounding spasmodic inhalation, also HICCOUGH [v]\n",
  "HICCUPIER": "HICCUPY, given to hiccuping [adj]\n",
  "HICCUPIEST": "HICCUPY, given to hiccuping [adj]\n",
  "HICCUPING": "HICCUP, to make a peculiar-sounding spasmodic inhalation, also HICCOUGH [v]\n",
  "HICCUPPED": "HICCUP, to make a peculiar-sounding spasmodic inhalation, also HICCOUGH [v]\n",
  "HICCUPPING": "HICCUP, to make a peculiar-sounding spasmodic inhalation, also HICCOUGH [v]\n",
  "HICCUPS": "HICCUP, to make a peculiar-sounding spasmodic inhalation, also HICCOUGH [v]\n",
  "HICCUPY": "given to hiccuping [adj HICCUPIER, HICCUPIEST]\n",
  "HICK": "characteristic of rural people [adj HICKER, HICKEST] / a person from the country, a yokel [n -S]\n",
  "HICKER": "HICK, characteristic of rural people [adj]\n",
  "HICKEST": "HICK, characteristic of rural people [adj]\n",
  "HICKEY": "a gadget, also HICKIE [n -S]\n",
  "HICKEYS": "HICKEY, a gadget, also HICKIE [n]\n",
  "HICKIE": "a gadget, also HICKEY [n -S]\n",
  "HICKIES": "HICKIE, a gadget, also HICKEY [n]\n",
  "HICKISH": "like a hick, rustic [adj]\n",
  "HICKORIES": "HICKORY, a hardwood tree [n]\n",
  "HICKORY": "a hardwood tree [n HICKORIES]\n",
  "HICKS": "HICK, a person from the country, a yokel [n]\n",
  "HICKWALL": "(dialect) the green woodpecker [n -S]\n",
  "HICKWALLS": "HICKWALL, (dialect) the green woodpecker [n]\n",
  "HICKYMAL": "(dialect) a titmouse [n -S]\n",
  "HICKYMALS": "HICKYMAL, (dialect) a titmouse [n]\n",
  "HID": "HIDE, to conceal [v]\n",
  "HIDABLE": "able to be hidden [adj]\n",
  "HIDAGE": "a tax formerly paid to the kings of England for every hide of land [n -S]\n",
  "HIDAGES": "HIDAGE, a tax formerly paid to the kings of England for every hide of land [n]\n",
  "HIDALGA": "(Spanish) a title denoting a Spanish noblewoman of the lower class [n -S]\n",
  "HIDALGAS": "HIDALGA, (Spanish) a title denoting a Spanish noblewoman of the lower class [n]\n",
  "HIDALGO": "(Spanish) a title denoting a Spanish nobleman of the lower class [n -S]\n",
  "HIDALGOISH": "like a hidalgo, a Spanish nobleman of the lower class [adj]\n",
  "HIDALGOISM": "the state of being a hidalgo, a Spanish nobleman of the lower class [n -S]\n",
  "HIDALGOISMS": "HIDALGOISM, the state of being a hidalgo, a Spanish nobleman of the lower class [n]\n",
  "HIDALGOS": "HIDALGO, (Spanish) a title denoting a Spanish nobleman of the lower class [n]\n",
  "HIDDEN": "concealed [adj HIDDENLY]\n",
  "HIDDENITE": "an emerald-green variety of spodumene found in Carolina [n -S]\n",
  "HIDDENITES": "HIDDENITE, an emerald-green variety of spodumene found in Carolina [n]\n",
  "HIDDENLY": "HIDDEN, concealed [adv]\n",
  "HIDDENMOST": "most tucked away, most hidden [adj]\n",
  "HIDDENNESS": "the state of being hidden [n -ES]\n",
  "HIDDENNESSES": "HIDDENNESS, the state of being hidden [n]\n",
  "HIDDER": "(Spenser) a young male sheep [n -S]\n",
  "HIDDERS": "HIDDER, (Spenser) a young male sheep [n]\n",
  "HIDE": "to conceal [v HID, HIDDEN, HIDING, HIDES] / to remove the hide (animal's skin) from [v HIDED, HIDING, HIDES]\n",
  "HIDEAWAY": "a hideout [n -S]\n",
  "HIDEAWAYS": "HIDEAWAY, a hideout [n]\n",
  "HIDEBOUND": "having an inflexible or ultraconservative character [adj]\n",
  "HIDED": "HIDE, to conceal [v]\n",
  "HIDELESS": "without a skin [adj]\n",
  "HIDEOSITIES": "HIDEOSITY, hideousness [n]\n",
  "HIDEOSITY": "hideousness [n HIDEOSITIES]\n",
  "HIDEOUS": "very ugly [adj HIDEOUSLY]\n",
  "HIDEOUSLY": "HIDEOUS, very ugly [adv]\n",
  "HIDEOUSNESS": "the state of being hideous [n -ES]\n",
  "HIDEOUSNESSES": "HIDEOUSNESS, the state of being hideous [n]\n",
  "HIDEOUT": "a place of refuge [n -S]\n",
  "HIDEOUTS": "HIDEOUT, a place of refuge [n]\n",
  "HIDER": "one who hides [n -S]\n",
  "HIDERS": "HIDER, one who hides [n]\n",
  "HIDES": "HIDE, to conceal [v]\n",
  "HIDING": "a beating [n -S]\n",
  "HIDINGS": "HIDING, a beating [n]\n",
  "HIDLING": "(Scots) in secret, also HIDLINGS, HIDLINS [adv]\n",
  "HIDLINGS": "(Scots) in secret, also HIDLING, HIDLINS [adv]\n",
  "HIDLINS": "(Scots) in secret, also HIDLING, HIDLINGS [adv]\n",
  "HIDROSES": "HIDROSIS, abnormal perspiration [n]\n",
  "HIDROSIS": "abnormal perspiration [n HIDROSES]\n",
  "HIDROTIC": "a drug that induces perspiration [n -S]\n",
  "HIDROTICS": "HIDROTIC, a drug that induces perspiration [n]\n",
  "HIE": "to hurry along, also HYE [v HIED, HIEING or HYING, HIES]\n",
  "HIED": "HIE, to hurry along, also HYE [v]\n",
  "HIEING": "HIE, to hurry along, also HYE [v]\n",
  "HIELAMAN": "(Native Australian) an Australian Aboriginal narrow shield of bark and wood [n -S]\n",
  "HIELAMANS": "HIELAMAN, (Native Australian) an Australian Aboriginal narrow shield of bark and wood [n]\n",
  "HIELAND": "characteristic of Highlanders esp. in respect of supposed gullibility [adj]\n",
  "HIEMAL": "pertaining to winter [adj]\n",
  "HIEMS": "(Shakespeare) winter [n HIEMS]\n",
  "HIERACIUM": "any plant of the genus Hieracium, the hawkweeds [n -S]\n",
  "HIERACIUMS": "HIERACIUM, any plant of the genus Hieracium, the hawkweeds [n]\n",
  "HIERACOSPHINGES": "HIERACOSPHINX, in ancient Egyptian art, a hawk-headed sphinx [n]\n",
  "HIERACOSPHINX": "in ancient Egyptian art, a hawk-headed sphinx [n HIERACOSPHINGES or HIERACOSPHINXES]\n",
  "HIERACOSPHINXES": "HIERACOSPHINX, in ancient Egyptian art, a hawk-headed sphinx [n]\n",
  "HIERARCH": "a high-ranking person esp. an ecclesiastical ruler or potentate [n -S]\n",
  "HIERARCHAL": "of or like a hierarch [adj]\n",
  "HIERARCHIC": "of, relating to, or arranged in a hierarchy, also HIERARCHICAL [adj HIERARCHICALLY]\n",
  "HIERARCHICAL": "of, relating to, or arranged in a hierarchy, also HIERARCHIC [adj HIERARCHICALLY]\n",
  "HIERARCHICALLY": "HIERARCHICAL, of, relating to, or arranged in a hierarchy, also HIERARCHIC [adv]\n",
  "HIERARCHIES": "HIERARCHY, a body or organization classified in successively subordinate grades [n]\n",
  "HIERARCHISE": "to make hierarchical, also HIERARCHIZE [v HIERARCHISED, HIERARCHISING, HIERARCHISES]\n",
  "HIERARCHISED": "HIERARCHISE, to make hierarchical, also HIERARCHIZE [v]\n",
  "HIERARCHISES": "HIERARCHISE, to make hierarchical, also HIERARCHIZE [v]\n",
  "HIERARCHISING": "HIERARCHISE, to make hierarchical, also HIERARCHIZE [v]\n",
  "HIERARCHISM": "a hierarchical system [n -S]\n",
  "HIERARCHISMS": "HIERARCHISM, a hierarchical system [n]\n",
  "HIERARCHIZE": "to make hierarchical, also HIERARCHISE [v HIERARCHIZED, HIERARCHIZING, HIERARCHIZES]\n",
  "HIERARCHIZED": "HIERARCHIZE, to make hierarchical, also HIERARCHISE [v]\n",
  "HIERARCHIZES": "HIERARCHIZE, to make hierarchical, also HIERARCHISE [v]\n",
  "HIERARCHIZING": "HIERARCHIZE, to make hierarchical, also HIERARCHISE [v]\n",
  "HIERARCHS": "HIERARCH, a high-ranking person esp. an ecclesiastical ruler or potentate [n]\n",
  "HIERARCHY": "a body or organization classified in successively subordinate grades [n HIERARCHIES]\n",
  "HIERATIC": "the sacred script of ancient Egypt [n -S]\n",
  "HIERATICA": "(Latin) the finest papyrus, used for Egyptian sacred writings [n -S]\n",
  "HIERATICAL": "pertaining to priests, also HIERATIC [adj HIERATICALLY]\n",
  "HIERATICALLY": "HIERATICAL, pertaining to priests, also HIERATIC [adv]\n",
  "HIERATICAS": "HIERATICA, (Latin) the finest papyrus, used for Egyptian sacred writings [n]\n",
  "HIERATICS": "HIERATIC, the sacred script of ancient Egypt [n]\n",
  "HIEROCRACIES": "HIEROCRACY, government by priests or religious ministers [n]\n",
  "HIEROCRACY": "government by priests or religious ministers [n HIEROCRACIES]\n",
  "HIEROCRAT": "a governing priest [n -S]\n",
  "HIEROCRATIC": "of or like a hierocracy, government by priests or religious ministers, also HIEROCRATICAL [adj]\n",
  "HIEROCRATICAL": "of or like a hierocracy, government by priests or religious ministers, also HIEROCRATIC [adj]\n",
  "HIEROCRATS": "HIEROCRAT, a governing priest [n]\n",
  "HIERODULE": "a temple slave in the service of a specified deity [n -S]\n",
  "HIERODULES": "HIERODULE, a temple slave in the service of a specified deity [n]\n",
  "HIERODULIC": "relating to a hierodule, a temple slave in the service of a specified deity [adj]\n",
  "HIEROGLYPH": "a character used in a system of hieroglyphic writing, also HIEROGLYPHIC [n -S] / to represent by hieroglyphs [v -ED, -ING, -S]\n",
  "HIEROGLYPHED": "HIEROGLYPH, to represent by hieroglyphs [v]\n",
  "HIEROGLYPHIC": "relating to hieroglyphs [adj] / a hieroglyph, also HIEROGLYPH [n -S]\n",
  "HIEROGLYPHICAL": "relating to hieroglyphics [adj]\n",
  "HIEROGLYPHICS": "HIEROGLYPHIC, a hieroglyph, also HIEROGLYPH [n]\n",
  "HIEROGLYPHING": "HIEROGLYPH, to represent by hieroglyphs [v]\n",
  "HIEROGLYPHIST": "a person skilled in hieroglyphics [n -S]\n",
  "HIEROGLYPHISTS": "HIEROGLYPHIST, a person skilled in hieroglyphics [n]\n",
  "HIEROGLYPHS": "HIEROGLYPH, a character used in a system of hieroglyphic writing, also HIEROGLYPHIC [n]\n",
  "HIEROGRAM": "a sacred or hieroglyphic symbol [n -S]\n",
  "HIEROGRAMMAT": "a writer of sacred records, also HIEROGRAMMATE [n -S]\n",
  "HIEROGRAMMATE": "a writer of sacred records, also HIEROGRAMMAT [n -S]\n",
  "HIEROGRAMMATES": "HIEROGRAMMATE, a writer of sacred records, also HIEROGRAMMAT [n]\n",
  "HIEROGRAMMATIC": "relating to the writing of sacred records [adj]\n",
  "HIEROGRAMMATIST": "a writer of sacred records [n]\n",
  "HIEROGRAMMATS": "HIEROGRAMMAT, a writer of sacred records, also HIEROGRAMMATE [n]\n",
  "HIEROGRAMS": "HIEROGRAM, a sacred or hieroglyphic symbol [n]\n",
  "HIEROGRAPH": "a sacred symbol [n -S]\n",
  "HIEROGRAPHER": "a sacred scribe [n -S]\n",
  "HIEROGRAPHERS": "HIEROGRAPHER, a sacred scribe [n]\n",
  "HIEROGRAPHIC": "related to sacred writing, also HIEROGRAPHICAL [adj]\n",
  "HIEROGRAPHICAL": "related to sacred writing, also HIEROGRAPHIC [adj]\n",
  "HIEROGRAPHIES": "HIEROGRAPHY, the description of sacred things [n]\n",
  "HIEROGRAPHS": "HIEROGRAPH, a sacred symbol [n]\n",
  "HIEROGRAPHY": "the description of sacred things [n HIEROGRAPHIES]\n",
  "HIEROLATRIES": "HIEROLATRY, worship of saints or sacred things [n]\n",
  "HIEROLATRY": "worship of saints or sacred things [n HIEROLATRIES]\n",
  "HIEROLOGIC": "relating to hierology, the science of sacred matters, also HIEROLOGICAL [adj]\n",
  "HIEROLOGICAL": "relating to hierology, the science of sacred matters, also HIEROLOGIC [adj]\n",
  "HIEROLOGIES": "HIEROLOGY, the science of sacred matters [n]\n",
  "HIEROLOGIST": "a student of hierology, the science of sacred matters [n -S]\n",
  "HIEROLOGISTS": "HIEROLOGIST, a student of hierology, the science of sacred matters [n]\n",
  "HIEROLOGY": "the science of sacred matters [n HIEROLOGIES]\n",
  "HIEROMANCIES": "HIEROMANCY, divination by studying objects offered in sacrifice [n]\n",
  "HIEROMANCY": "divination by studying objects offered in sacrifice [n HIEROMANCIES]\n",
  "HIEROPHANT": "one who shows or reveals sacred things; a priest [n -S]\n",
  "HIEROPHANTIC": "of or like a hierophant [adj]\n",
  "HIEROPHANTS": "HIEROPHANT, one who shows or reveals sacred things; a priest [n]\n",
  "HIEROPHOBIA": "a morbid fear of sacred things [n -S]\n",
  "HIEROPHOBIAS": "HIEROPHOBIA, a morbid fear of sacred things [n]\n",
  "HIEROPHOBIC": "someone having a fear of sacred things [n -S]\n",
  "HIEROPHOBICS": "HIEROPHOBIC, someone having a fear of sacred things [n]\n",
  "HIEROSCOPIES": "HIEROSCOPY, divination using entrails [n]\n",
  "HIEROSCOPY": "divination using entrails [n HIEROSCOPIES]\n",
  "HIERURGICAL": "relating to hierurgy [adj]\n",
  "HIERURGIES": "HIERURGY, a sacred performance [n]\n",
  "HIERURGY": "a sacred performance [n HIERURGIES]\n",
  "HIES": "HIE, to hurry along, also HYE [v]\n",
  "HIFALUTIN": "pretentious, affected, also HIGHFALUTIN, HIGHFALUTING [adj]\n",
  "HIGGLE": "to hawk or peddle provisions [v HIGGLED, HIGGLING, HIGGLES]\n",
  "HIGGLED": "HIGGLE, to hawk or peddle provisions [v]\n",
  "HIGGLER": "a salesperson who insists on a certain price [n -S]\n",
  "HIGGLERS": "HIGGLER, a salesperson who insists on a certain price [n]\n",
  "HIGGLES": "HIGGLE, to hawk or peddle provisions [v]\n",
  "HIGGLING": "hawking provisions [n -S]\n",
  "HIGGLINGS": "HIGGLING, hawking provisions [n]\n",
  "HIGH": "to turn to the left [v -ED, -ING, -S] / reaching far upward [adj HIGHER, HIGHEST, HIGHLY]\n",
  "HIGHBALL": "to go at great speed [v -ED, -ING, -S]\n",
  "HIGHBALLED": "HIGHBALL, to go at great speed [v]\n",
  "HIGHBALLING": "HIGHBALL, to go at great speed [v]\n",
  "HIGHBALLS": "HIGHBALL, to go at great speed [v]\n",
  "HIGHBINDER": "a swindler, gangster or corrupt politician [n -S]\n",
  "HIGHBINDERS": "HIGHBINDER, a swindler, gangster or corrupt politician [n]\n",
  "HIGHBLOODED": "of noble lineage [adj]\n",
  "HIGHBORN": "of noble birth [adj]\n",
  "HIGHBOY": "a tall chest of drawers [n -S]\n",
  "HIGHBOYS": "HIGHBOY, a tall chest of drawers [n]\n",
  "HIGHBRED": "of noble breed [adj]\n",
  "HIGHBROW": "an intellectual [n -S]\n",
  "HIGHBROWED": "being of a highbrow disposition [adj]\n",
  "HIGHBROWISM": "the state of being a highbrow [n -S]\n",
  "HIGHBROWISMS": "HIGHBROWISM, the state of being a highbrow [n]\n",
  "HIGHBROWS": "HIGHBROW, an intellectual [n]\n",
  "HIGHBUSH": "a shrub of the genus Vaccinium of eastern North America [n -ES]\n",
  "HIGHBUSHES": "HIGHBUSH, a shrub of the genus Vaccinium of eastern North America [n]\n",
  "HIGHCHAIR": "a chair for a child to sit at table [n -S]\n",
  "HIGHCHAIRS": "HIGHCHAIR, a chair for a child to sit at table [n]\n",
  "HIGHED": "HIGH, to turn to the left [v]\n",
  "HIGHER": "to raise, make higher [v -ED, -ING, -S]\n",
  "HIGHERED": "HIGHER, to raise, make higher [v]\n",
  "HIGHERING": "HIGHER, to raise, make higher [v]\n",
  "HIGHERMOST": "highest, also HIGHMOST [adj]\n",
  "HIGHERS": "HIGHER, to raise, make higher [v]\n",
  "HIGHEST": "HIGH, reaching far upward [adj]\n",
  "HIGHFALUTIN": "pretentious, affected, also HIFALUTIN, HIGHFALUTING [adj] / bombastic discourse [n -S]\n",
  "HIGHFALUTING": "pretentious, affected, also HIFALUTIN, HIGHFALUTIN [adj] / bombastic discourse [n -S]\n",
  "HIGHFALUTINGS": "HIGHFALUTING, bombastic discourse [n]\n",
  "HIGHFALUTINS": "HIGHFALUTIN, bombastic discourse [n]\n",
  "HIGHFLIER": "a bird that flies high; a high achiever, also HIGHFLYER [n -S]\n",
  "HIGHFLIERS": "HIGHFLIER, a bird that flies high; a high achiever, also HIGHFLYER [n]\n",
  "HIGHFLYER": "a bird that flies high; a high achiever, also HIGHFLIER [n -S]\n",
  "HIGHFLYERS": "HIGHFLYER, a bird that flies high; a high achiever, also HIGHFLIER [n]\n",
  "HIGHING": "HIGH, to turn to the left [v]\n",
  "HIGHISH": "somewhat high [adj]\n",
  "HIGHJACK": "to steal in transit, also HIJACK [v -ED, -ING, -S]\n",
  "HIGHJACKED": "HIGHJACK, to steal in transit, also HIJACK [v]\n",
  "HIGHJACKER": "one that highjacks, also HIJACKER [n -S]\n",
  "HIGHJACKERS": "HIGHJACKER, one that highjacks, also HIJACKER [n]\n",
  "HIGHJACKING": "the seizing of a vehicle in transit, also HIJACKING [n -S]\n",
  "HIGHJACKINGS": "HIGHJACKING, the seizing of a vehicle in transit, also HIJACKING [n]\n",
  "HIGHJACKS": "HIGHJACK, to steal in transit, also HIJACK [v]\n",
  "HIGHJINKS": "frolics, also HIJINKS [n]\n",
  "HIGHLAND": "an elevated region [n -S]\n",
  "HIGHLANDER": "an inhabitant of a highland [n -S]\n",
  "HIGHLANDERS": "HIGHLANDER, an inhabitant of a highland [n]\n",
  "HIGHLANDS": "HIGHLAND, an elevated region [n]\n",
  "HIGHLIFE": "the lifestyle of fashionable society [n -S]\n",
  "HIGHLIFES": "HIGHLIFE, the lifestyle of fashionable society [n]\n",
  "HIGHLIGHT": "to throw into relief by strong light [v -ED, -ING, -S]\n",
  "HIGHLIGHTED": "HIGHLIGHT, to throw into relief by strong light [v]\n",
  "HIGHLIGHTER": "a broad-tipped felt pen for highlighting parts of a text, etc.; a cosmetic used to emphasize features on the face [n -S]\n",
  "HIGHLIGHTERS": "HIGHLIGHTER, a broad-tipped felt pen for highlighting parts of a text, etc.; a cosmetic used to emphasize features on the face [n]\n",
  "HIGHLIGHTING": "HIGHLIGHT, to throw into relief by strong light [v]\n",
  "HIGHLIGHTS": "HIGHLIGHT, to throw into relief by strong light [v]\n",
  "HIGHLY": "HIGH, reaching far upward [adv]\n",
  "HIGHMAN": "a loaded die [n HIGHMEN]\n",
  "HIGHMEN": "HIGHMAN, a loaded die [n]\n",
  "HIGHMOST": "highest, also HIGHERMOST [adj]\n",
  "HIGHNESS": "the state of being high [n -ES]\n",
  "HIGHNESSES": "HIGHNESS, the state of being high [n]\n",
  "HIGHRISE": "a building with many stories [n -S]\n",
  "HIGHRISES": "HIGHRISE, a building with many stories [n]\n",
  "HIGHROAD": "a highway; a much travelled or main road [n -S]\n",
  "HIGHROADS": "HIGHROAD, a highway; a much travelled or main road [n]\n",
  "HIGHS": "HIGH, to turn to the left [v]\n",
  "HIGHSPOT": "a high point [n -S]\n",
  "HIGHSPOTS": "HIGHSPOT, a high point [n]\n",
  "HIGHT": "(archaic) to command, also HECHT, HETE [v -ED, -ING, -S]\n",
  "HIGHTAIL": "to retreat rapidly [v -ED, -ING, -S]\n",
  "HIGHTAILED": "HIGHTAIL, to retreat rapidly [v]\n",
  "HIGHTAILING": "HIGHTAIL, to retreat rapidly [v]\n",
  "HIGHTAILS": "HIGHTAIL, to retreat rapidly [v]\n",
  "HIGHTED": "HIGHT, (archaic) to command, also HECHT, HETE [v]\n",
  "HIGHTH": "(archaic) height, also HEIGHTH [n -S]\n",
  "HIGHTHS": "HIGHTH, (archaic) height, also HEIGHTH [n]\n",
  "HIGHTING": "the act of commanding or calling [n -S]\n",
  "HIGHTINGS": "HIGHTING, the act of commanding or calling [n]\n",
  "HIGHTOP": "the top of a ship's mast [n -S]\n",
  "HIGHTOPS": "HIGHTOP, the top of a ship's mast [n]\n",
  "HIGHTS": "HIGHT, (archaic) to command, also HECHT, HETE [v]\n",
  "HIGHVELD": "(South African) a high altitude grassland region of East South Africa [n -S]\n",
  "HIGHVELDS": "HIGHVELD, (South African) a high altitude grassland region of East South Africa [n]\n",
  "HIGHWAY": "a major road [n -S]\n",
  "HIGHWAYMAN": "a thief who robs travellers on a road [n HIGHWAYMEN]\n",
  "HIGHWAYMEN": "HIGHWAYMAN, a thief who robs travellers on a road [n]\n",
  "HIGHWAYS": "HIGHWAY, a major road [n]\n",
  "HIGHWROUGHT": "wrought with skill; elaborate [adj]\n",
  "HIJAB": "(Arabic) a covering for a Muslim woman's head and face, also HEJAB [n -S]\n",
  "HIJABS": "HIJAB, (Arabic) a covering for a Muslim woman's head and face, also HEJAB [n]\n",
  "HIJACK": "to steal in transit, also HIGHJACK [v -ED, -ING, -S]\n",
  "HIJACKED": "HIJACK, to steal in transit, also HIGHJACK [v]\n",
  "HIJACKER": "one that hijacks, also HIGHJACKER [n -S]\n",
  "HIJACKERS": "HIJACKER, one that hijacks, also HIGHJACKER [n]\n",
  "HIJACKING": "the act of stealing in transit, also HIGHJACKING [n -S]\n",
  "HIJACKINGS": "HIJACKING, the act of stealing in transit, also HIGHJACKING [n]\n",
  "HIJACKS": "HIJACK, to steal in transit, also HIGHJACK [v]\n",
  "HIJINKS": "frolics, also HIGHJINKS [n]\n",
  "HIJRA": "(Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJIRA, HEJRA, HIJRAH [n -S]\n",
  "HIJRAH": "(Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJIRA, HEJRA, HIJRA [n -S]\n",
  "HIJRAHS": "HIJRAH, (Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJIRA, HEJRA, HIJRA [n]\n",
  "HIJRAS": "HIJRA, (Arabic) the flight of Mohammed from Mecca, also HEGIRA, HEJIRA, HEJRA, HIJRAH [n]\n",
  "HIKE": "to go walking [v HIKED, HIKING, HIKES]\n",
  "HIKED": "HIKE, to go walking [v]\n",
  "HIKER": "one who hikes [n -S]\n",
  "HIKERS": "HIKER, one who hikes [n]\n",
  "HIKES": "HIKE, to go walking [v]\n",
  "HIKING": "the act of walking a long distance [n -S]\n",
  "HIKINGS": "HIKING, the act of walking a long distance [n]\n",
  "HIKOI": "(Maori) to take part in a protest march [v -ED, -ING, -S]\n",
  "HIKOIED": "HIKOI, (Maori) to take part in a protest march [v]\n",
  "HIKOIING": "HIKOI, (Maori) to take part in a protest march [v]\n",
  "HIKOIS": "HIKOI, (Maori) to take part in a protest march [v]\n",
  "HILA": "HILUM, (Latin) the scar on a seed where it joined its stalk, also HILUS [n]\n",
  "HILAR": "belonging to the hilum, a mark where seed was attached to its stalk [adj]\n",
  "HILARIOUS": "very amusing [adj HILARIOUSLY]\n",
  "HILARIOUSLY": "HILARIOUS, very amusing [adv]\n",
  "HILARIOUSNESS": "HILARIOUS, very amusing [n]\n",
  "HILARIOUSNESSES": "HILARIOUSNESS, HILARIOUS, very amusing [n]\n",
  "HILARITIES": "HILARITY, noisy merriment [n]\n",
  "HILARITY": "noisy merriment [n HILARITIES]\n",
  "HILCH": "(Scots) to hobble [v -ED, -ING, -ES]\n",
  "HILCHED": "HILCH, (Scots) to hobble [v]\n",
  "HILCHES": "HILCH, (Scots) to hobble [v]\n",
  "HILCHING": "HILCH, (Scots) to hobble [v]\n",
  "HILD": "(Spenser) held [v]\n",
  "HILDING": "(archaic) a mean cowardly person, also HYLDING [n -S]\n",
  "HILDINGS": "HILDING, (archaic) a mean cowardly person, also HYLDING [n]\n",
  "HILI": "HILUS, (Latin) the scar on a seed where it joined its stalk, also HILUM [n]\n",
  "HILL": "to form into banked up land [v -ED, -ING, -S]\n",
  "HILLBILLIES": "HILLBILLY, a simple rustic, a yokel [n]\n",
  "HILLBILLY": "a simple rustic, a yokel [n HILLBILLIES]\n",
  "HILLCREST": "the top of a hill [n -S]\n",
  "HILLCRESTS": "HILLCREST, the top of a hill [n]\n",
  "HILLED": "HILL, to form into banked up land [v]\n",
  "HILLER": "something that hills [n -S]\n",
  "HILLERS": "HILLER, something that hills [n]\n",
  "HILLFOLK": "people living among the hills [n]\n",
  "HILLFORT": "a fort built on a hill [n -S]\n",
  "HILLFORTS": "HILLFORT, a fort built on a hill [n]\n",
  "HILLIER": "HILLY, abounding in hills [adj]\n",
  "HILLIEST": "HILLY, abounding in hills [adj]\n",
  "HILLINESS": "the state of being hilly [n -ES]\n",
  "HILLINESSES": "HILLINESS, the state of being hilly [n]\n",
  "HILLING": "tobogganing down a slope of ice [n -S]\n",
  "HILLINGS": "HILLING, tobogganing down a slope of ice [n]\n",
  "HILLMEN": "people living among the hills [n]\n",
  "HILLO": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S or -ES]\n",
  "HILLOA": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S]\n",
  "HILLOAED": "HILLOA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLOAING": "HILLOA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLOAS": "HILLOA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLOCK": "a small hill [n -S]\n",
  "HILLOCKED": "having hillocks [adj]\n",
  "HILLOCKIER": "HILLOCKY, full of hillocks [adj]\n",
  "HILLOCKIEST": "HILLOCKY, full of hillocks [adj]\n",
  "HILLOCKS": "HILLOCK, a small hill [n]\n",
  "HILLOCKY": "full of hillocks [adj HILLOCKIER, HILLOCKIEST]\n",
  "HILLOED": "HILLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLOES": "HILLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLOING": "HILLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLOS": "HILLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HILLS": "HILL, to form into banked up land [v]\n",
  "HILLSIDE": "the side of a hill [n -S]\n",
  "HILLSIDES": "HILLSIDE, the side of a hill [n]\n",
  "HILLSLOPE": "the slope of a hill [n -S]\n",
  "HILLSLOPES": "HILLSLOPE, the slope of a hill [n]\n",
  "HILLTOP": "the top of a hill [n -S]\n",
  "HILLTOPS": "HILLTOP, the top of a hill [n]\n",
  "HILLWALKER": "one who likes walking in the hills [n -S]\n",
  "HILLWALKERS": "HILLWALKER, one who likes walking in the hills [n]\n",
  "HILLWALKING": "the pastime of walking in the hills [n -S]\n",
  "HILLWALKINGS": "HILLWALKING, the pastime of walking in the hills [n]\n",
  "HILLY": "abounding in hills [adj HILLIER, HILLIEST]\n",
  "HILT": "to provide a handle for a weapon [v -ED, -ING, -S]\n",
  "HILTED": "HILT, to provide a handle for a weapon [v]\n",
  "HILTING": "HILT, to provide a handle for a weapon [v]\n",
  "HILTLESS": "without a hilt [adj]\n",
  "HILTS": "HILT, to provide a handle for a weapon [v]\n",
  "HILUM": "(Latin) the scar on a seed where it joined its stalk, also HILUS [n HILA]\n",
  "HILUS": "(Latin) the scar on a seed where it joined its stalk, also HILUM [n HILI]\n",
  "HIM": "a pronoun representing a male person or thing [pron -S]\n",
  "HIMATIA": "HIMATION, (Greek) a rectangular garment of ancient Greece, worn draped over left shoulder and wrapped around the body [n]\n",
  "HIMATION": "(Greek) a rectangular garment of ancient Greece, worn draped over left shoulder and wrapped around the body [n HIMATIONS or HIMATIA]\n",
  "HIMATIONS": "HIMATION, (Greek) a rectangular garment of ancient Greece, worn draped over left shoulder and wrapped around the body [n]\n",
  "HIMBO": "(offensive) a male bimbo, a superficial, stupid man, who is overly concerned with his looks [n -S]\n",
  "HIMBOS": "HIMBO, (offensive) a male bimbo, a superficial, stupid man, who is overly concerned with his looks [n]\n",
  "HIMS": "HIM [n]\n",
  "HIMSELF": "the reflexive form of the 3rd person singular masculine pronoun [pron]\n",
  "HIN": "a Hebrew unit of liquid measure [n -S]\n",
  "HINAHINA": "(Maori) a small, bushy white-barked tree of New Zealand [n -S]\n",
  "HINAHINAS": "HINAHINA, (Maori) a small, bushy white-barked tree of New Zealand [n]\n",
  "HINAU": "(Maori) a New Zealand tree [n -S]\n",
  "HINAUS": "HINAU, (Maori) a New Zealand tree [n]\n",
  "HIND": "the female of the red deer in or after its third year, also HYNDE [n -S]\n",
  "HINDBERRIES": "HINDBERRY, the raspberry [n]\n",
  "HINDBERRY": "the raspberry [n HINDBERRIES]\n",
  "HINDBRAIN": "the posterior of the three principal divisions of the brain [n -S]\n",
  "HINDBRAINS": "HINDBRAIN, the posterior of the three principal divisions of the brain [n]\n",
  "HINDCAST": "to test a mathematical model by inputting known or closely estimated data for past events to see how well the output matches the known results [v -ED, -ING, -S]\n",
  "HINDCASTED": "HINDCAST, to test a mathematical model by inputting known or closely estimated data for past events to see how well the output matches the known results [v]\n",
  "HINDCASTING": "HINDCAST, to test a mathematical model by inputting known or closely estimated data for past events to see how well the output matches the known results [v]\n",
  "HINDCASTS": "HINDCAST, to test a mathematical model by inputting known or closely estimated data for past events to see how well the output matches the known results [v]\n",
  "HINDER": "to impede [v -ED, -ING, -S]\n",
  "HINDERANCE": "an act of hindering; that which hinders, also HINDRANCE [n -S]\n",
  "HINDERANCES": "HINDERANCE, an act of hindering; that which hinders, also HINDRANCE [n]\n",
  "HINDERED": "HINDER, to impede [v]\n",
  "HINDERER": "one who hinders [n -S]\n",
  "HINDERERS": "HINDERER, one who hinders [n]\n",
  "HINDERING": "impeding [adj HINDERINGLY] / the act of hindering [n -S]\n",
  "HINDERINGLY": "HINDERING, impeding [adv]\n",
  "HINDERINGS": "HINDERING, the act of hindering [n]\n",
  "HINDERLAND": "a type of linen cloth from Europe [n -S]\n",
  "HINDERLANDS": "(Scots) the buttocks, also HINDERLANS, HINDERLINGS, HINDERLINS [n]\n",
  "HINDERLANS": "(Scots) the buttocks, also HINDERLANDS, HINDERLINGS, HINDERLINS [n]\n",
  "HINDERLINGS": "(Scots) the buttocks, also HINDERLANDS, HINDERLANS, HINDERLINS [n]\n",
  "HINDERLINS": "(Scots) the buttocks, also HINDERLANDS, HINDERLANS, HINDERLINGS [n]\n",
  "HINDERMOST": "furthest to the rear, also HINDMOST [adj]\n",
  "HINDERS": "HINDER, to impede [v]\n",
  "HINDFEET": "HINDFOOT, a rear foot [n]\n",
  "HINDFOOT": "a rear foot [n HINDFEET]\n",
  "HINDFOREMOST": "with the back part in the front place [adv]\n",
  "HINDGUT": "the rear part of the alimentary canal [n -S]\n",
  "HINDGUTS": "HINDGUT, the rear part of the alimentary canal [n]\n",
  "HINDHEAD": "the back of the head [n -S]\n",
  "HINDHEADS": "HINDHEAD, the back of the head [n]\n",
  "HINDLEG": "a rear leg [n -S]\n",
  "HINDLEGS": "HINDLEG, a rear leg [n]\n",
  "HINDMILK": "breast milk exuded after the first part of a feeding [n -S]\n",
  "HINDMILKS": "HINDMILK, breast milk exuded after the first part of a feeding [n]\n",
  "HINDMOST": "farthest to the rear, also HINDERMOST [adj]\n",
  "HINDQUARTER": "the back half of a side of beef, including one or two ribs [n -S]\n",
  "HINDQUARTERS": "HINDQUARTER, the back half of a side of beef, including one or two ribs [n]\n",
  "HINDRANCE": "an act of hindering; that which hinders, also HINDERANCE [n -S]\n",
  "HINDRANCES": "HINDRANCE, an act of hindering; that which hinders, also HINDERANCE [n]\n",
  "HINDS": "HIND, the female of the red deer in or after its third year, also HYNDE [n]\n",
  "HINDSHANK": "meat from an animal's hind leg [n -S]\n",
  "HINDSHANKS": "HINDSHANK, meat from an animal's hind leg [n]\n",
  "HINDSIGHT": "the ability or opportunity to understand and explain an event after it has happened [n -S]\n",
  "HINDSIGHTS": "HINDSIGHT, the ability or opportunity to understand and explain an event after it has happened [n]\n",
  "HINDWARD": "towards the rear [adv]\n",
  "HINDWING": "a rear wing [n -S]\n",
  "HINDWINGS": "HINDWING, a rear wing [n]\n",
  "HING": "(Hindi) a foul-smelling gum resin [n -S]\n",
  "HINGE": "to attach a jointed device [v HINGED, HINGING, HINGES]\n",
  "HINGED": "HINGE, to attach a jointed device [v]\n",
  "HINGELESS": "without hinges [adj]\n",
  "HINGELIKE": "like a hinge [adj]\n",
  "HINGER": "one that hinges [n -S]\n",
  "HINGERS": "HINGER, one that hinges [n]\n",
  "HINGES": "HINGE, to attach a jointed device [v]\n",
  "HINGING": "HINGE, to attach a jointed device [v]\n",
  "HINGS": "HING, (Hindi) a foul-smelling gum resin [n]\n",
  "HINKIER": "HINKY, strange, unreliable [adj]\n",
  "HINKIEST": "HINKY, strange, unreliable [adj]\n",
  "HINKY": "strange, unreliable [adj HINKIER, HINKIEST]\n",
  "HINNIE": "a darling, sweetheart, also HINNY [n -S]\n",
  "HINNIED": "HINNY, to neigh, whinny, also HINNIE [v]\n",
  "HINNIES": "HINNY, to neigh, whinny, also HINNIE [v]\n",
  "HINNY": "to neigh, whinny, also HINNIE [v HINNIED, HINNYING, HINNIES]\n",
  "HINNYING": "HINNY, to neigh, whinny, also HINNIE [v]\n",
  "HINS": "HIN, a Hebrew unit of liquid measure [n]\n",
  "HINT": "to suggest indirectly [v -ED, -ING, -S]\n",
  "HINTED": "HINT, to suggest indirectly [v]\n",
  "HINTER": "one that hints [n -S]\n",
  "HINTERLAND": "the inland area behind coast or coastal town [n -S]\n",
  "HINTERLANDS": "HINTERLAND, the inland area behind coast or coastal town [n]\n",
  "HINTERS": "HINTER, one that hints [n]\n",
  "HINTING": "suggestive [adj HINTINGLY] / the act of hinting [n -S]\n",
  "HINTINGLY": "HINTING, suggestive [adv]\n",
  "HINTINGS": "HINTING, the act of hinting [n]\n",
  "HINTS": "HINT, to suggest indirectly [v]\n",
  "HIOI": "(Maori) a New Zealand plant of the mint family [n -S]\n",
  "HIOIS": "HIOI, (Maori) a New Zealand plant of the mint family [n]\n",
  "HIP": "to build a type of roof [v HIPT or HIPPED, HIPPING, HIPS] / aware of the latest styles and trends [adj HIPPER, HIPPEST, HIPLY]\n",
  "HIPBONE": "a pelvic bone [n -S]\n",
  "HIPBONES": "HIPBONE, a pelvic bone [n]\n",
  "HIPHUGGER": "of trousers, having a low waist [adj]\n",
  "HIPLESS": "lacking a pelvic joint [adj]\n",
  "HIPLIKE": "resembling a hip [adj]\n",
  "HIPLINE": "the distance around the hips [n -S]\n",
  "HIPLINES": "HIPLINE, the distance around the hips [n]\n",
  "HIPLY": "HIP, aware of the latest styles and trends [adv]\n",
  "HIPNESS": "the state of being hip [n -ES]\n",
  "HIPNESSES": "HIPNESS, the state of being hip [n]\n",
  "HIPPARCH": "(Greek) a cavalry commander in ancient Greece [n -S]\n",
  "HIPPARCHS": "HIPPARCH, (Greek) a cavalry commander in ancient Greece [n]\n",
  "HIPPEASTRUM": "any plant of the South American genus Hippeastrum, bulbous, with white or red flowers [n -S]\n",
  "HIPPEASTRUMS": "HIPPEASTRUM, any plant of the South American genus Hippeastrum, bulbous, with white or red flowers [n]\n",
  "HIPPED": "HIP, to build a type of roof [v]\n",
  "HIPPEN": "a baby's nappy wrapped around the hips, also HIPPIN, HIPPING [n -S]\n",
  "HIPPENS": "HIPPEN, a baby's nappy wrapped around the hips, also HIPPIN, HIPPING [n]\n",
  "HIPPER": "HIP, aware of the latest styles and trends [adj]\n",
  "HIPPEST": "HIP, aware of the latest styles and trends [adj]\n",
  "HIPPIATRIC": "relating to the treatment of horses' diseases [adj]\n",
  "HIPPIATRICS": "the study of the diseases of horses [n]\n",
  "HIPPIATRIES": "HIPPIATRY, the treatment of diseases of horses [n]\n",
  "HIPPIATRIST": "a vet specialising in horses [n -S]\n",
  "HIPPIATRISTS": "HIPPIATRIST, a vet specialising in horses [n]\n",
  "HIPPIATRY": "the treatment of diseases of horses [n HIPPIATRIES]\n",
  "HIPPIC": "about horses [adj]\n",
  "HIPPIE": "a nonconformist, also HIPPY [n -S]\n",
  "HIPPIEDOM": "the world of the hippie, also HIPPYDOM [n -S]\n",
  "HIPPIEDOMS": "HIPPIEDOM, the world of the hippie, also HIPPYDOM [n]\n",
  "HIPPIEISH": "like a hippie [adj]\n",
  "HIPPIENESS": "the state of being a hippie [n -ES]\n",
  "HIPPIENESSES": "HIPPIENESS, the state of being a hippie [n]\n",
  "HIPPIER": "HIPPY, having big hips [adj]\n",
  "HIPPIES": "HIPPIE, a nonconformist, also HIPPY [n]\n",
  "HIPPIEST": "HIPPY, having big hips [adj]\n",
  "HIPPIN": "a baby's nappy wrapped around the hips, also HIPPEN, HIPPING [n -S]\n",
  "HIPPINESS": "the state of being a hippy [n -ES]\n",
  "HIPPINESSES": "HIPPINESS, the state of being a hippy [n]\n",
  "HIPPING": "(Scots) a baby's nappy wrapped around the hips, also HIPPIN, HIPPEN [n -S]\n",
  "HIPPINGS": "HIPPING, (Scots) a baby's nappy wrapped around the hips, also HIPPIN, HIPPEN [n]\n",
  "HIPPINS": "HIPPIN, a baby's nappy wrapped around the hips, also HIPPEN, HIPPING [n]\n",
  "HIPPISH": "melancholy [adj]\n",
  "HIPPO": "(short for) a hippopotamus [n -S]\n",
  "HIPPOCAMPAL": "relating to the hippocampus [adj]\n",
  "HIPPOCAMPI": "HIPPOCAMPUS, one of two ridges along each lateral ventricle of the brain [n]\n",
  "HIPPOCAMPUS": "one of two ridges along each lateral ventricle of the brain [n HIPPOCAMPI]\n",
  "HIPPOCENTAUR": "a mythical creature, half man and half horse [n -S]\n",
  "HIPPOCENTAURS": "HIPPOCENTAUR, a mythical creature, half man and half horse [n]\n",
  "HIPPOCRAS": "a kind of medieval hot spiced wine [n -ES]\n",
  "HIPPOCRASES": "HIPPOCRAS, a kind of medieval hot spiced wine [n]\n",
  "HIPPOCREPIAN": "a type of bryozoan that has a lophophore shaped like a horseshoe [n -S]\n",
  "HIPPOCREPIANS": "HIPPOCREPIAN, a type of bryozoan that has a lophophore shaped like a horseshoe [n]\n",
  "HIPPODAME": "(Spenser) a fabulous sea monster [n -S]\n",
  "HIPPODAMES": "HIPPODAME, (Spenser) a fabulous sea monster [n]\n",
  "HIPPODAMIST": "a horse-tamer [n -S]\n",
  "HIPPODAMISTS": "HIPPODAMIST, a horse-tamer [n]\n",
  "HIPPODAMOUS": "horse-taming [adj]\n",
  "HIPPODROME": "a place set apart for equestrian and chariot races [n -S]\n",
  "HIPPODROMES": "HIPPODROME, a place set apart for equestrian and chariot races [n]\n",
  "HIPPODROMIC": "relating to a hippodrome [adj]\n",
  "HIPPOGRIFF": "a fabulous winged animal, half horse and half griffin, also HIPPOGRYPH [n -S]\n",
  "HIPPOGRIFFS": "HIPPOGRIFF, a fabulous winged animal, half horse and half griffin, also HIPPOGRYPH [n]\n",
  "HIPPOGRYPH": "a fabulous winged animal, half horse and half griffin, also HIPPOGRIFF [n -S]\n",
  "HIPPOGRYPHS": "HIPPOGRYPH, a fabulous winged animal, half horse and half griffin, also HIPPOGRIFF [n]\n",
  "HIPPOLOGIES": "HIPPOLOGY, the study of horses [n]\n",
  "HIPPOLOGIST": "a student of horses [n -S]\n",
  "HIPPOLOGISTS": "HIPPOLOGIST, a student of horses [n]\n",
  "HIPPOLOGY": "the study of horses [n HIPPOLOGIES]\n",
  "HIPPOMANES": "an ancient philtre obtained from a mare or foal [n]\n",
  "HIPPOPHAGIES": "HIPPOPHAGY, feeding on horses [n]\n",
  "HIPPOPHAGIST": "one who eats horseflesh [n -S]\n",
  "HIPPOPHAGISTS": "HIPPOPHAGIST, one who eats horseflesh [n]\n",
  "HIPPOPHAGOUS": "eating horseflesh [adj]\n",
  "HIPPOPHAGY": "feeding on horses [n HIPPOPHAGIES]\n",
  "HIPPOPHILE": "a lover of horses [n -S]\n",
  "HIPPOPHILES": "HIPPOPHILE, a lover of horses [n]\n",
  "HIPPOPHOBE": "a hater of horses [n -S]\n",
  "HIPPOPHOBES": "HIPPOPHOBE, a hater of horses [n]\n",
  "HIPPOPOTAMI": "HIPPOPOTAMUS, a large African artiodactyl ungulate of aquatic habits [n]\n",
  "HIPPOPOTAMIAN": "like a hippopotamus, clumsy, also HIPPOPOTAMIC [adj]\n",
  "HIPPOPOTAMIC": "like a hippopotamus, clumsy, also HIPPOPOTAMIAN [adj]\n",
  "HIPPOPOTAMUS": "a large African artiodactyl ungulate of aquatic habits [n HIPPOPOTAMI or HIPPOPOTAMUSES]\n",
  "HIPPOPOTAMUSES": "HIPPOPOTAMUS, a large African artiodactyl ungulate of aquatic habits [n]\n",
  "HIPPOS": "HIPPO, (short for) a hippopotamus [n]\n",
  "HIPPURIC": "denoting an acid [adj]\n",
  "HIPPURITE": "a Cretaceous fossil lamellibranch with one conical valve and one flat one [n -S]\n",
  "HIPPURITES": "HIPPURITE, a Cretaceous fossil lamellibranch with one conical valve and one flat one [n]\n",
  "HIPPURITIC": "of or like a hippurite, a cone-shaped fossil bivalve mollusc [adj]\n",
  "HIPPUS": "(Greek) a clonic spasm of the iris [n -ES]\n",
  "HIPPUSES": "HIPPUS, (Greek) a clonic spasm of the iris [n]\n",
  "HIPPY": "having big hips [adj HIPPIER, HIPPIEST] / a nonconformist [n HIPPIES]\n",
  "HIPPYDOM": "the world of the hippy, also HIPPIEDOM [n -S]\n",
  "HIPPYDOMS": "HIPPYDOM, the world of the hippy, also HIPPIEDOM [n]\n",
  "HIPPYISH": "relating to or resembling a hippy [adj]\n",
  "HIPS": "HIP, to build a type of roof [v]\n",
  "HIPSHOT": "having the hip out of joint [adj]\n",
  "HIPSTER": "a person who knows and appreciates up-to-date jazz, also HEPSTER [n -S]\n",
  "HIPSTERISM": "the state of being a hipster, a person who knows and appreciates up-to-date jazz [n -S]\n",
  "HIPSTERISMS": "HIPSTERISM, the state of being a hipster, a person who knows and appreciates up-to-date jazz [n]\n",
  "HIPSTERS": "HIPSTER, a person who knows and appreciates up-to-date jazz, also HEPSTER [n]\n",
  "HIPT": "HIP, to build a type of roof [v]\n",
  "HIRABLE": "available for hire, also HIREABLE [adj]\n",
  "HIRAGANA": "(Japanese) a Japanese cursive script [n -S]\n",
  "HIRAGANAS": "HIRAGANA, (Japanese) a Japanese cursive script [n]\n",
  "HIRAGE": "(New Zealand) the fee for hiring something, also HIREAGE [n -S]\n",
  "HIRAGES": "HIRAGE, (New Zealand) the fee for hiring something, also HIREAGE [n]\n",
  "HIRCINE": "characteristic of a goat, esp. its odor [adj]\n",
  "HIRCOCERVUS": "a fabulous creature, half goat, half stag [n -ES]\n",
  "HIRCOCERVUSES": "HIRCOCERVUS, a fabulous creature, half goat, half stag [n]\n",
  "HIRCOSITIES": "HIRCOSITY, goatishness, lewdness [n]\n",
  "HIRCOSITY": "goatishness, lewdness [n HIRCOSITIES]\n",
  "HIRE": "to use for a price [v HIRED, HIRING, HIRES]\n",
  "HIREABLE": "available for hire, also HIRABLE [adj]\n",
  "HIREAGE": "(New Zealand) the fee for hiring something, also HIRAGE [n -S]\n",
  "HIREAGES": "HIREAGE, (New Zealand) the fee for hiring something, also HIRAGE [n]\n",
  "HIRED": "HIRE, to use for a price [v]\n",
  "HIREE": "one who is hired [n -S]\n",
  "HIREES": "HIREE, one who is hired [n]\n",
  "HIRELING": "one that works for money only [n -S]\n",
  "HIRELINGS": "HIRELING, one that works for money only [n]\n",
  "HIRER": "one who hires [n -S]\n",
  "HIRERS": "HIRER, one who hires [n]\n",
  "HIRES": "HIRE, to use for a price [v]\n",
  "HIRING": "the act by which an article is hired [n -S]\n",
  "HIRINGS": "HIRING, the act by which an article is hired [n]\n",
  "HIRLING": "a young seatrout, a finnock, also HERLING [n -S]\n",
  "HIRLINGS": "HIRLING, a young seatrout, a finnock, also HERLING [n]\n",
  "HIRPLE": "(Scots) to walk lamely [v HIRPLED, HIRPLING, HIRPLES]\n",
  "HIRPLED": "HIRPLE, (Scots) to walk lamely [v]\n",
  "HIRPLES": "HIRPLE, (Scots) to walk lamely [v]\n",
  "HIRPLING": "HIRPLE, (Scots) to walk lamely [v]\n",
  "HIRRIENT": "a roughly trilled sound [n -S]\n",
  "HIRRIENTS": "HIRRIENT, a roughly trilled sound [n]\n",
  "HIRSEL": "(Scots) to herd sheep [v HIRSELED or HIRSELLED, HIRSELING or HIRSELLING, HIRSELS]\n",
  "HIRSELED": "HIRSEL, (Scots) to herd sheep [v]\n",
  "HIRSELING": "HIRSEL, (Scots) to herd sheep [v]\n",
  "HIRSELLED": "HIRSEL, (Scots) to herd sheep [v]\n",
  "HIRSELLING": "the act of putting into different groups [n -S]\n",
  "HIRSELLINGS": "HIRSELLING, the act of putting into different groups [n]\n",
  "HIRSELS": "HIRSEL, (Scots) to herd sheep [v]\n",
  "HIRSLE": "(Scots) to slide along [v HIRSLED, HIRSLING, HIRSLES]\n",
  "HIRSLED": "HIRSLE, (Scots) to slide along [v]\n",
  "HIRSLES": "HIRSLE, (Scots) to slide along [v]\n",
  "HIRSLING": "HIRSLE, (Scots) to slide along [v]\n",
  "HIRSTIE": "(Scots) dry, barren, also HISTIE [adj]\n",
  "HIRSUTE": "roughly hairy [adj]\n",
  "HIRSUTENESS": "the state of being hirsute [n -ES]\n",
  "HIRSUTENESSES": "HIRSUTENESS, the state of being hirsute [n]\n",
  "HIRSUTISM": "the state of being hirsute, hairy [n -S]\n",
  "HIRSUTISMS": "HIRSUTISM, the state of being hirsute, hairy [n]\n",
  "HIRUDIN": "a substance present in the salivary glands of leeches, used as an anticoagulant [n -S]\n",
  "HIRUDINEAN": "relating to the leech family [adj] / a member of the leech family [n -S]\n",
  "HIRUDINEANS": "HIRUDINEAN, a member of the leech family [n]\n",
  "HIRUDINOID": "like a leech [adj]\n",
  "HIRUDINOUS": "of or like hirudin, a substance present in the salivary glands of leeches, used as an anticoagulant [adj]\n",
  "HIRUDINS": "HIRUDIN, a substance present in the salivary glands of leeches, used as an anticoagulant [n]\n",
  "HIRUNDINE": "of or pertaining to swallows [adj]\n",
  "HIS": "of or belonging to a male person or thing [adj]\n",
  "HISH": "to hiss [v -ED, -ING, -ES]\n",
  "HISHED": "HISH, to hiss [v]\n",
  "HISHES": "HISH, to hiss [v]\n",
  "HISHING": "HISH, to hiss [v]\n",
  "HISN": "(dialect) his [pron]\n",
  "HISPANICISE": "to render Hispanic, also HISPANICIZE [v HISPANICISED, HISPANICISING, HISPANICISES]\n",
  "HISPANICISED": "HISPANICISE, to render Hispanic, also HISPANICIZE [v]\n",
  "HISPANICISES": "HISPANICISE, to render Hispanic, also HISPANICIZE [v]\n",
  "HISPANICISING": "HISPANICISE, to render Hispanic, also HISPANICIZE [v]\n",
  "HISPANICISM": "a Spanish phrase [n -S]\n",
  "HISPANICISMS": "HISPANICISM, a Spanish phrase [n]\n",
  "HISPANICIZE": "to render Hispanic, also HISPANICISE [v HISPANICIZED, HISPANICIZING, HISPANICIZES]\n",
  "HISPANICIZED": "HISPANICIZE, to render Hispanic, also HISPANICISE [v]\n",
  "HISPANICIZES": "HISPANICIZE, to render Hispanic, also HISPANICISE [v]\n",
  "HISPANICIZING": "HISPANICIZE, to render Hispanic, also HISPANICISE [v]\n",
  "HISPANIDAD": "a movement asserting the cultural unity of Spain and Latin America, also HISPANISM [n -S]\n",
  "HISPANIDADS": "HISPANIDAD, a movement asserting the cultural unity of Spain and Latin America, also HISPANISM [n]\n",
  "HISPANIOLISE": "to make Spanish, also HISPANIOLIZE [v HISPANIOLISED, HISPANIOLISING, HISPANIOLISES]\n",
  "HISPANIOLISED": "HISPANIOLISE, to make Spanish, also HISPANIOLIZE [v]\n",
  "HISPANIOLISES": "HISPANIOLISE, to make Spanish, also HISPANIOLIZE [v]\n",
  "HISPANIOLISING": "HISPANIOLISE, to make Spanish, also HISPANIOLIZE [v]\n",
  "HISPANIOLIZE": "to make Spanish, also HISPANIOLISE [v HISPANIOLIZED, HISPANIOLIZING, HISPANIOLIZES]\n",
  "HISPANIOLIZED": "HISPANIOLIZE, to make Spanish, also HISPANIOLISE [v]\n",
  "HISPANIOLIZES": "HISPANIOLIZE, to make Spanish, also HISPANIOLISE [v]\n",
  "HISPANIOLIZING": "HISPANIOLIZE, to make Spanish, also HISPANIOLISE [v]\n",
  "HISPANISM": "a movement asserting the cultural unity of Spain and Latin America, also HISPANIDAD [n -S]\n",
  "HISPANISMS": "HISPANISM, a movement asserting the cultural unity of Spain and Latin America, also HISPANIDAD [n]\n",
  "HISPID": "covered with stiff hairs [adj]\n",
  "HISPIDITIES": "HISPIDITY, shagginess [n]\n",
  "HISPIDITY": "shagginess [n HISPIDITIES]\n",
  "HISS": "to make a sibilant sound, also HIZZ [v -ED, -ING, -ES]\n",
  "HISSED": "HISS, to make a sibilant sound, also HIZZ [v]\n",
  "HISSELF": "(dialect) himself [pron]\n",
  "HISSER": "one who hisses [n -S]\n",
  "HISSERS": "HISSER, one who hisses [n]\n",
  "HISSES": "HISS, to make a sibilant sound, also HIZZ [v]\n",
  "HISSIER": "HISSY, temperamental [adj]\n",
  "HISSIES": "HISSY, a tantrum [n]\n",
  "HISSIEST": "HISSY, temperamental [adj]\n",
  "HISSING": "making a hiss [adj HISSINGLY] / an object of scorn [n -S]\n",
  "HISSINGLY": "HISSING, making a hiss [adv]\n",
  "HISSINGS": "HISSING, an object of scorn [n]\n",
  "HISSY": "a tantrum [n HISSIES] / temperamental [adj HISSIER, HISSIEST]\n",
  "HIST": "(archaic) an expression used to attract attention [interj] / to urge or summon with such an interjection [v -ED, -ING, -S]\n",
  "HISTAMIN": "a base used in medicine obtained from ergot and present in all the tissues of the body, also HISTAMINE [n -S]\n",
  "HISTAMINASE": "a digestive enzyme that converts histidine to histamine [n -S]\n",
  "HISTAMINASES": "HISTAMINASE, a digestive enzyme that converts histidine to histamine [n]\n",
  "HISTAMINE": "a base used in medicine obtained from ergot and present in all the tissues of the body, also HISTAMIN [n -S]\n",
  "HISTAMINERGIC": "liberating or activated by histamine [adj]\n",
  "HISTAMINES": "HISTAMINE, a base used in medicine obtained from ergot and present in all the tissues of the body, also HISTAMIN [n]\n",
  "HISTAMINIC": "relating to a histamine [adj]\n",
  "HISTAMINS": "HISTAMIN, a base used in medicine obtained from ergot and present in all the tissues of the body, also HISTAMINE [n]\n",
  "HISTED": "HIST, to urge or summon with such an interjection [v]\n",
  "HISTIDIN": "an amino acid found in proteins, also HISTIDINE [n -S]\n",
  "HISTIDINE": "an amino acid found in proteins, also HISTIDIN [n -S]\n",
  "HISTIDINES": "HISTIDINE, an amino acid found in proteins, also HISTIDIN [n]\n",
  "HISTIDINS": "HISTIDIN, an amino acid found in proteins, also HISTIDINE [n]\n",
  "HISTIE": "(Scots) dry, barren, also HIRSTIE [adj]\n",
  "HISTING": "HIST, to urge or summon with such an interjection [v]\n",
  "HISTIOCYTE": "a macrophage [n -S]\n",
  "HISTIOCYTES": "HISTIOCYTE, a macrophage [n]\n",
  "HISTIOCYTIC": "relating to a histiocyte [adj]\n",
  "HISTIOID": "resembling the normal tissues; as, histioid tumors, also HISTOID [adj]\n",
  "HISTIOLOGIES": "HISTIOLOGY, the study of the tissues of organisms, also HISTOLOGY [n]\n",
  "HISTIOLOGY": "the study of the tissues of organisms, also HISTOLOGY [n HISTIOLOGIES]\n",
  "HISTIOPHOROID": "related to a genus of swordfish [adj]\n",
  "HISTOBLAST": "a cell or group of cells forming the primary element or unit of tissue [n -S]\n",
  "HISTOBLASTS": "HISTOBLAST, a cell or group of cells forming the primary element or unit of tissue [n]\n",
  "HISTOCHEMICAL": "relating to histochemistry, the chemistry of living tissues [adj HISTOCHEMICALLY]\n",
  "HISTOCHEMICALLY": "HISTOCHEMICAL, relating to histochemistry, the chemistry of living tissues [adv]\n",
  "HISTOCHEMIST": "one who studies the chemistry of living tissue [n -S]\n",
  "HISTOCHEMISTRY": "the chemistry of living tissues [n]\n",
  "HISTOCHEMISTS": "HISTOCHEMIST, one who studies the chemistry of living tissue [n]\n",
  "HISTOCOMPATIBLE": "referring to the degree of similarity between the histocompatibility antigens of two individuals, which determines whether an organ transplant will be tolerated [adj]\n",
  "HISTOGEN": "a more or less well-defined region within a plant where tissues undergo differentiation [n -S]\n",
  "HISTOGENESES": "HISTOGENESIS, the formation or differentiation of tissues, also HISTOGENY [n]\n",
  "HISTOGENESIS": "the formation or differentiation of tissues, also HISTOGENY [n HISTOGENESES]\n",
  "HISTOGENETIC": "relating to histogenesis [adj]\n",
  "HISTOGENIC": "of or like a histogen, a more or less well-defined region within a plant where tissues undergo differentiation [adj HISTOGENICALLY]\n",
  "HISTOGENICALLY": "HISTOGENIC, of or like a histogen, a more or less well-defined region within a plant where tissues undergo differentiation [adv]\n",
  "HISTOGENIES": "HISTOGENY, the formation or differentiation of tissues, also HISTOGENESIS [n]\n",
  "HISTOGENS": "HISTOGEN, a more or less well-defined region within a plant where tissues undergo differentiation [n]\n",
  "HISTOGENY": "the formation or differentiation of tissues, also HISTOGENESIS [n HISTOGENIES]\n",
  "HISTOGRAM": "a diagram consisting of a number of rectangles or lines drawn (usually upwards) from a base line, their heights representing frequencies of a series of values (or value-ranges) of a quantity [n -S]\n",
  "HISTOGRAMS": "HISTOGRAM, a diagram consisting of a number of rectangles or lines drawn (usually upwards) from a base line, their heights representing frequencies of a series of values (or value-ranges) of a quantity [n]\n",
  "HISTOID": "pertaining to connective tissue [adj]\n",
  "HISTOLOGIC": "relating to histology, the study of organic tissue, also HISTOLOGICAL [adj HISTOLOGICALLY]\n",
  "HISTOLOGICAL": "relating to histology, the study of organic tissue, also HISTOLOGIC [adj HISTOLOGICALLY]\n",
  "HISTOLOGICALLY": "HISTOLOGICAL, relating to histology, the study of organic tissue, also HISTOLOGIC [adv]\n",
  "HISTOLOGIES": "HISTOLOGY, the study of the tissues of organisms, also HISTIOLOGY [n]\n",
  "HISTOLOGIST": "one who studies organic tissue [n -S]\n",
  "HISTOLOGISTS": "HISTOLOGIST, one who studies organic tissue [n]\n",
  "HISTOLOGY": "the study of the tissues of organisms, also HISTIOLOGY [n HISTOLOGIES]\n",
  "HISTOLYSES": "HISTOLYSIS, the decay and dissolution of the organic tissues and of the blood [n]\n",
  "HISTOLYSIS": "the decay and dissolution of the organic tissues and of the blood [n HISTOLYSES]\n",
  "HISTOLYTIC": "of or pertaining to histolysis, or the degeneration of tissues [adj HISTOLYTICALLY]\n",
  "HISTOLYTICALLY": "HISTOLYTIC, of or pertaining to histolysis, or the degeneration of tissues [adv]\n",
  "HISTONE": "any of a group of simple proteins present in chromosomes and believed to act as gene inhibitors [n -S]\n",
  "HISTONES": "HISTONE, any of a group of simple proteins present in chromosomes and believed to act as gene inhibitors [n]\n",
  "HISTOPATHOLOGIC": "relating to histopathology [adj]\n",
  "HISTOPATHOLOGY": "the study of the effects of disease on tissues [n]\n",
  "HISTOPHYSIOLOGY": "a branch of physiology concerned with the function and activities of tissues [n]\n",
  "HISTOPLASMOSES": "HISTOPLASMOSIS, a disease of animals and man due to infection by the fungal organism Histoplasma capsulatum [n]\n",
  "HISTOPLASMOSIS": "a disease of animals and man due to infection by the fungal organism Histoplasma capsulatum [n HISTOPLASMOSES]\n",
  "HISTORIAN": "a student of history [n -S]\n",
  "HISTORIANS": "HISTORIAN, a student of history [n]\n",
  "HISTORIATED": "decorated with elaborate ornamental designs and figures, also STORIATED [adj]\n",
  "HISTORIC": "important in history [adj HISTORICALLY]\n",
  "HISTORICAL": "of, relating to, or having the character of history [adj HISTORICALLY]\n",
  "HISTORICALLY": "HISTORICAL, of, relating to, or having the character of history [adv]\n",
  "HISTORICALNESS": "HISTORICAL, of, relating to, or having the character of history [n]\n",
  "HISTORICISE": "to make or represent as historic, also HISTORICIZE [v HISTORICISED, HISTORICISING, HISTORICISES]\n",
  "HISTORICISED": "HISTORICISE, to make or represent as historic, also HISTORICIZE [v]\n",
  "HISTORICISES": "HISTORICISE, to make or represent as historic, also HISTORICIZE [v]\n",
  "HISTORICISING": "HISTORICISE, to make or represent as historic, also HISTORICIZE [v]\n",
  "HISTORICISM": "the belief that all phenomena are historically determined, also HISTORISM [n -S]\n",
  "HISTORICISMS": "HISTORICISM, the belief that all phenomena are historically determined, also HISTORISM [n]\n",
  "HISTORICIST": "a believer in historicism [n -S]\n",
  "HISTORICISTS": "HISTORICIST, a believer in historicism [n]\n",
  "HISTORICITIES": "HISTORICITY, historical actuality [n]\n",
  "HISTORICITY": "historical actuality [n HISTORICITIES]\n",
  "HISTORICIZE": "to make or represent as historic, also HISTORICISE [v HISTORICIZED, HISTORICIZING, HISTORICIZES]\n",
  "HISTORICIZED": "HISTORICIZE, to make or represent as historic, also HISTORICISE [v]\n",
  "HISTORICIZES": "HISTORICIZE, to make or represent as historic, also HISTORICISE [v]\n",
  "HISTORICIZING": "HISTORICIZE, to make or represent as historic, also HISTORICISE [v]\n",
  "HISTORIED": "HISTORY, to relate in a history or narrative [v]\n",
  "HISTORIES": "HISTORY, to relate in a history or narrative [v]\n",
  "HISTORIETTE": "a short history or story [n -S]\n",
  "HISTORIETTES": "HISTORIETTE, a short history or story [n]\n",
  "HISTORIFIED": "HISTORIFY, to record in history [v]\n",
  "HISTORIFIES": "HISTORIFY, to record in history [v]\n",
  "HISTORIFY": "to record in history [v HISTORIFIED, HISTORIFYING, HISTORIFIES]\n",
  "HISTORIFYING": "HISTORIFY, to record in history [v]\n",
  "HISTORIOGRAPHER": "one who practises historiography, the study of writing history [n]\n",
  "HISTORIOGRAPHIC": "relating to historiography [adj]\n",
  "HISTORIOGRAPHY": "the study of writing history [n]\n",
  "HISTORIOLOGIES": "HISTORIOLOGY, the study of history [n]\n",
  "HISTORIOLOGY": "the study of history [n HISTORIOLOGIES]\n",
  "HISTORISM": "the belief that all phenomena are historically determined, also HISTORICISM [n -S]\n",
  "HISTORISMS": "HISTORISM, the belief that all phenomena are historically determined, also HISTORICISM [n]\n",
  "HISTORY": "to relate in a history or narrative [v HISTORIED, HISTORYING, HISTORIES]\n",
  "HISTORYING": "HISTORY, to relate in a history or narrative [v]\n",
  "HISTRIO": "(archaic) an actor, also HISTRION [n -S]\n",
  "HISTRION": "(archaic) an actor, also HISTRIO [n -S]\n",
  "HISTRIONIC": "relating to the stage or actors, also HISTRIONICAL [adj]\n",
  "HISTRIONICAL": "relating to the stage or actors, also HISTRIONIC [adj HISTRIONICALLY]\n",
  "HISTRIONICALLY": "HISTRIONICAL, relating to the stage or actors, also HISTRIONIC [adv]\n",
  "HISTRIONICISM": "acting, theatricality, also HISTRIONISM [n -S]\n",
  "HISTRIONICISMS": "HISTRIONICISM, acting, theatricality, also HISTRIONISM [n]\n",
  "HISTRIONICS": "playacting; stagy action or speech [n]\n",
  "HISTRIONISM": "acting, theatricality, also HISTRIONICISM [n -S]\n",
  "HISTRIONISMS": "HISTRIONISM, acting, theatricality, also HISTRIONICISM [n]\n",
  "HISTRIONS": "HISTRION, (archaic) an actor, also HISTRIO [n]\n",
  "HISTRIOS": "HISTRIO, (archaic) an actor, also HISTRION [n]\n",
  "HISTS": "HIST, to urge or summon with such an interjection [v]\n",
  "HIT": "to strike forcibly [v HIT, HITTING, HITS]\n",
  "HITCH": "to fasten with a knot or hook [v -ED, -ING, -ES]\n",
  "HITCHED": "HITCH, to fasten with a knot or hook [v]\n",
  "HITCHER": "one that hitches [n -S]\n",
  "HITCHERS": "HITCHER, one that hitches [n]\n",
  "HITCHES": "HITCH, to fasten with a knot or hook [v]\n",
  "HITCHHIKE": "to hike with the help of lifts in vehicles [v HITCHHIKED, HITCHHIKING, HITCHHIKES]\n",
  "HITCHHIKED": "HITCHHIKE, to hike with the help of lifts in vehicles [v]\n",
  "HITCHHIKER": "one who hitchhikes [n -S]\n",
  "HITCHHIKERS": "HITCHHIKER, one who hitchhikes [n]\n",
  "HITCHHIKES": "HITCHHIKE, to hike with the help of lifts in vehicles [v]\n",
  "HITCHHIKING": "the act of travelling by requesting lifts from passing vehicles [n -S]\n",
  "HITCHHIKINGS": "HITCHHIKING, the act of travelling by requesting lifts from passing vehicles [n]\n",
  "HITCHIER": "HITCHY, inclined to catch [adj]\n",
  "HITCHIEST": "HITCHY, inclined to catch [adj]\n",
  "HITCHILY": "HITCHY, inclined to catch [adv]\n",
  "HITCHING": "HITCH, to fasten with a knot or hook [v]\n",
  "HITCHY": "inclined to catch [adj HITCHIER, HITCHIEST, HITCHILY]\n",
  "HITHE": "a port or small haven, also HYTHE [n -S]\n",
  "HITHER": "to come this way [v -ED, -ING, -S]\n",
  "HITHERED": "HITHER, to come this way [v]\n",
  "HITHERING": "HITHER, to come this way [v]\n",
  "HITHERMOST": "nearest on this side [adj]\n",
  "HITHERS": "HITHER, to come this way [v]\n",
  "HITHERSIDE": "the nearest side [n -S]\n",
  "HITHERSIDES": "HITHERSIDE, the nearest side [n]\n",
  "HITHERTO": "up to now [adv]\n",
  "HITHERWARD": "(archaic) toward this place; hither, also HETHERWARD, HITHERWARDS [adv]\n",
  "HITHERWARDS": "(archaic) toward this place; hither, also HETHERWARD, HITHERWARD [adv]\n",
  "HITHES": "HITHE, a port or small haven, also HYTHE [n]\n",
  "HITLESS": "being without a hit [adj]\n",
  "HITMAKER": "a musician who produces bestselling records [n -S]\n",
  "HITMAKERS": "HITMAKER, a musician who produces bestselling records [n]\n",
  "HITMAN": "a professional killer [n HITMEN]\n",
  "HITMEN": "HITMAN, a professional killer [n]\n",
  "HITS": "HIT, to strike forcibly [v]\n",
  "HITTABLE": "able to be hit [adj]\n",
  "HITTER": "one that hits [n -S]\n",
  "HITTERS": "HITTER, one that hits [n]\n",
  "HITTING": "HIT, to strike forcibly [v]\n",
  "HIVE": "to enter a bee's nest [v HIVED, HIVING, HIVES]\n",
  "HIVED": "HIVE, to enter a bee's nest [v]\n",
  "HIVELESS": "without a hive [adj]\n",
  "HIVELIKE": "resembling a beehive [adj]\n",
  "HIVEMIND": "the shared mind of a group [n -S]\n",
  "HIVEMINDS": "HIVEMIND, the shared mind of a group [n]\n",
  "HIVER": "someone who hives [n -S]\n",
  "HIVERS": "HIVER, someone who hives [n]\n",
  "HIVES": "HIVE, to enter a bee's nest [v]\n",
  "HIVEWARD": "in the direction of a hive, also HIVEWARDS [adv]\n",
  "HIVEWARDS": "in the direction of the hive, also HIVEWARD [adv]\n",
  "HIVING": "HIVE, to enter a bee's nest [v]\n",
  "HIYA": "(colloquial) a greeting [interj]\n",
  "HIZEN": "(Japanese) a type of richly decorated Japanese porcelain [n -S]\n",
  "HIZENS": "HIZEN, (Japanese) a type of richly decorated Japanese porcelain [n]\n",
  "HIZZ": "(Shakespeare) to hiss [v -ED, -ING, -ES]\n",
  "HIZZED": "HIZZ, (Shakespeare) to hiss [v]\n",
  "HIZZES": "HIZZ, (Shakespeare) to hiss [v]\n",
  "HIZZING": "HIZZ, (Shakespeare) to hiss [v]\n",
  "HIZZONER": "his honour, used as a title for a mayor [n -S]\n",
  "HIZZONERS": "HIZZONER, his honour, used as a title for a mayor [n]\n",
  "HM": "an interjection expressing thoughtful consideration, also HMM, HMMM [interj]\n",
  "HMM": "used to express thoughtful consideration, also HM [interj]\n",
  "HMMM": "an interjection expressing thoughtful consideration, also HM, HMM [interj]\n",
  "HO": "to stop [v -ED, -ING, -S]\n",
  "HOA": "to stop [v -ED, -ING, -S]\n",
  "HOACTZIN": "(Nahuatl) a South American bird; the young have clawed wings, also HOATZIN [n -ES or -S]\n",
  "HOACTZINES": "HOACTZIN, (Nahuatl) a South American bird; the young have clawed wings, also HOATZIN [n]\n",
  "HOACTZINS": "HOACTZIN, (Nahuatl) a South American bird; the young have clawed wings, also HOATZIN [n]\n",
  "HOAED": "HOA, to stop [v]\n",
  "HOAGIE": "a long sandwich, also HOAGY [n -S]\n",
  "HOAGIES": "HOAGIE, a long sandwich, also HOAGY [n]\n",
  "HOAGY": "a long sandwich, also HOAGIE [n HOAGIES]\n",
  "HOAING": "HOA, to stop [v]\n",
  "HOAR": "to make hoary, grey with frost or age [v -ED, -ING, -S]\n",
  "HOARD": "to gather and store away [v -ED, -ING, -S]\n",
  "HOARDED": "HOARD, to gather and store away [v]\n",
  "HOARDER": "one that hoards [n -S]\n",
  "HOARDERS": "HOARDER, one that hoards [n]\n",
  "HOARDING": "a billboard [n -S]\n",
  "HOARDINGS": "HOARDING, a billboard [n]\n",
  "HOARDS": "HOARD, to gather and store away [v]\n",
  "HOARED": "HOAR, to make hoary, grey with frost or age [v]\n",
  "HOARFROST": "rime or white frost, the white particles formed by the freezing of the dew [n -S]\n",
  "HOARFROSTS": "HOARFROST, rime or white frost, the white particles formed by the freezing of the dew [n]\n",
  "HOARHEAD": "a hoary-headed old man [n -S]\n",
  "HOARHEADS": "HOARHEAD, a hoary-headed old man [n]\n",
  "HOARHOUND": "a kind of wild flower, also HOREHOUND [n -S]\n",
  "HOARHOUNDS": "HOARHOUND, a kind of wild flower, also HOREHOUND [n]\n",
  "HOARIER": "HOARY, white with age [adj]\n",
  "HOARIEST": "HOARY, white with age [adj]\n",
  "HOARILY": "HOARY, white with age [adv]\n",
  "HOARINESS": "the state of being hoary [n -ES]\n",
  "HOARINESSES": "HOARINESS, the state of being hoary [n]\n",
  "HOARING": "HOAR, to make hoary, grey with frost or age [v]\n",
  "HOARS": "HOAR, to make hoary, grey with frost or age [v]\n",
  "HOARSE": "rough and husky in sound [adj HOARSER, HOARSEST, HOARSELY]\n",
  "HOARSELY": "HOARSE, rough and husky in sound [adv]\n",
  "HOARSEN": "to make hoarse [v -ED, -ING, -S]\n",
  "HOARSENED": "HOARSEN, to make hoarse [v]\n",
  "HOARSENESS": "the state of being hoarse [n -ES]\n",
  "HOARSENESSES": "HOARSENESS, the state of being hoarse [n]\n",
  "HOARSENING": "HOARSEN, to make hoarse [v]\n",
  "HOARSENS": "HOARSEN, to make hoarse [v]\n",
  "HOARSER": "HOARSE, rough and husky in sound [adj]\n",
  "HOARSEST": "HOARSE, rough and husky in sound [adj]\n",
  "HOARY": "white with age [adj HOARIER, HOARIEST, HOARILY]\n",
  "HOAS": "HOA, to stop [v]\n",
  "HOAST": "(dialect) to cough [v -ED, -ING, -S]\n",
  "HOASTED": "HOAST, (dialect) to cough [v]\n",
  "HOASTING": "HOAST, (dialect) to cough [v]\n",
  "HOASTMAN": "a member of an old merchant guild [n HOASTMEN]\n",
  "HOASTMEN": "HOASTMAN, a member of an old merchant guild [n]\n",
  "HOASTS": "HOAST, (dialect) to cough [v]\n",
  "HOATCHING": "(Scots) infested, swarming e.g. with flies [adj]\n",
  "HOATZIN": "(Nahuatl) a South American bird; the young have clawed wings, also HOACTZIN [n -ES or -S]\n",
  "HOATZINES": "HOATZIN, (Nahuatl) a South American bird; the young have clawed wings, also HOACTZIN [n]\n",
  "HOATZINS": "HOATZIN, (Nahuatl) a South American bird; the young have clawed wings, also HOACTZIN [n]\n",
  "HOAX": "to deceive [v -ED, -ING, -ES]\n",
  "HOAXED": "HOAX, to deceive [v]\n",
  "HOAXER": "one that hoaxes [n -S]\n",
  "HOAXERS": "HOAXER, one that hoaxes [n]\n",
  "HOAXES": "HOAX, to deceive [v]\n",
  "HOAXING": "HOAX, to deceive [v]\n",
  "HOB": "to furnish with hobnails [v HOBBED, HOBBING, HOBS]\n",
  "HOBBED": "HOB, to furnish with hobnails [v]\n",
  "HOBBER": "a machine used in making gears [n -S]\n",
  "HOBBERS": "HOBBER, a machine used in making gears [n]\n",
  "HOBBIES": "HOBBY, a recreational pastime [n]\n",
  "HOBBING": "HOB, to furnish with hobnails [v]\n",
  "HOBBISH": "clownish [adj]\n",
  "HOBBIT": "one of a race of imaginary beings, half human size, hole-dwelling and hairy-footed, invented by JRR Tolkien in his novel 'The Hobbit' [n -S]\n",
  "HOBBITRIES": "HOBBITRY, the lore of hobbits [n]\n",
  "HOBBITRY": "the lore of hobbits [n HOBBITRIES]\n",
  "HOBBITS": "HOBBIT, one of a race of imaginary beings, half human size, hole-dwelling and hairy-footed, invented by JRR Tolkien in his novel 'The Hobbit' [n]\n",
  "HOBBLE": "to limp [v HOBBLED, HOBBLING, HOBBLES]\n",
  "HOBBLEBUSH": "a low American bush having long, straggling branches and handsome flowers [n -ES]\n",
  "HOBBLEBUSHES": "HOBBLEBUSH, a low American bush having long, straggling branches and handsome flowers [n]\n",
  "HOBBLED": "HOBBLE, to limp [v]\n",
  "HOBBLEDEHOY": "an awkward young fellow [n -S]\n",
  "HOBBLEDEHOYDOM": "the state of being a hobbledehoy, an awkward young fellow, also HOBBLEDEHOYHOOD, HOBBLEDEHOYISM [n -S]\n",
  "HOBBLEDEHOYDOMS": "HOBBLEDEHOYDOM, the state of being a hobbledehoy, an awkward young fellow, also HOBBLEDEHOYHOOD, HOBBLEDEHOYISM [n]\n",
  "HOBBLEDEHOYHOOD": "the state of being a hobbledehoy, an awkward young fellow, also HOBBLEDEHOYDOM, HOBBLEDEHOYISM [n]\n",
  "HOBBLEDEHOYISH": "like a hobbledehoy, an awkward young fellow [adj]\n",
  "HOBBLEDEHOYISM": "the state of being a hobbledehoy, also HOBBLEDEHOYDOM, HOBBLEDEHOYHOOD [n -S]\n",
  "HOBBLEDEHOYISMS": "HOBBLEDEHOYISM, the state of being a hobbledehoy, also HOBBLEDEHOYDOM, HOBBLEDEHOYHOOD [n]\n",
  "HOBBLEDEHOYS": "HOBBLEDEHOY, an awkward young fellow [n]\n",
  "HOBBLER": "(obsolete) a person required to keep a horse for military service [n -S]\n",
  "HOBBLERS": "HOBBLER, (obsolete) a person required to keep a horse for military service [n]\n",
  "HOBBLES": "HOBBLE, to limp [v]\n",
  "HOBBLING": "limping [adj HOBBLINGLY] / the act of fastening the legs [n -S]\n",
  "HOBBLINGLY": "HOBBLING, limping [adv]\n",
  "HOBBLINGS": "HOBBLING, the act of fastening the legs [n]\n",
  "HOBBY": "a recreational pastime [n HOBBIES]\n",
  "HOBBYHORSE": "a strong, active horse, of a middle size, said to have been originally from Ireland; an ambling nag [n -S] / of a vessel, to pitch violently [v HOBBYHORSED, HOBBYHORSING, HOBBYHORSES]\n",
  "HOBBYHORSED": "HOBBYHORSE, of a vessel, to pitch violently [v]\n",
  "HOBBYHORSES": "HOBBYHORSE, of a vessel, to pitch violently [v]\n",
  "HOBBYHORSING": "HOBBYHORSE, of a vessel, to pitch violently [v]\n",
  "HOBBYISM": "the pursuit of hobbies [n -S]\n",
  "HOBBYISMS": "HOBBYISM, the pursuit of hobbies [n]\n",
  "HOBBYIST": "one who pursues a hobby [n -S]\n",
  "HOBBYISTS": "HOBBYIST, one who pursues a hobby [n]\n",
  "HOBBYLESS": "having no hobbies [adj]\n",
  "HOBDAY": "to cure a horse's breathing impediment [v -ED, -ING, -S]\n",
  "HOBDAYED": "HOBDAY, to cure a horse's breathing impediment [v]\n",
  "HOBDAYING": "HOBDAY, to cure a horse's breathing impediment [v]\n",
  "HOBDAYS": "HOBDAY, to cure a horse's breathing impediment [v]\n",
  "HOBGOBLIN": "a mischievous fairy; a frightful apparition [n -S]\n",
  "HOBGOBLINISM": "the state of being a hobgoblin, also HOBGOBLINRY [n -S]\n",
  "HOBGOBLINISMS": "HOBGOBLINISM, the state of being a hobgoblin, also HOBGOBLINRY [n]\n",
  "HOBGOBLINRIES": "HOBGOBLINRY, the state of being a hobgoblin, also HOBGOBLINISM [n]\n",
  "HOBGOBLINRY": "the state of being a hobgoblin, also HOBGOBLINISM [n HOBGOBLINRIES]\n",
  "HOBGOBLINS": "HOBGOBLIN, a mischievous fairy; a frightful apparition [n]\n",
  "HOBJOB": "(dialect) to do odd jobs [v HOBJOBBED, HOBJOBBING, HOBJOBS]\n",
  "HOBJOBBED": "HOBJOB, (dialect) to do odd jobs [v]\n",
  "HOBJOBBER": "one who does odd jobs [n -S]\n",
  "HOBJOBBERS": "HOBJOBBER, one who does odd jobs [n]\n",
  "HOBJOBBING": "doing odd jobs [n -S]\n",
  "HOBJOBBINGS": "HOBJOBBING, doing odd jobs [n]\n",
  "HOBJOBS": "HOBJOB, (dialect) to do odd jobs [v]\n",
  "HOBLIKE": "like an elf [adj]\n",
  "HOBNAIL": "to furnish with broad headed short nails [v -ED, -ING, -S]\n",
  "HOBNAILED": "HOBNAIL, to furnish with broad headed short nails [v]\n",
  "HOBNAILING": "HOBNAIL, to furnish with broad headed short nails [v]\n",
  "HOBNAILS": "HOBNAIL, to furnish with broad headed short nails [v]\n",
  "HOBNOB": "to associate with in a friendly way [v HOBNOBBED, HOBNOBBING, HOBNOBS]\n",
  "HOBNOBBED": "HOBNOB, to associate with in a friendly way [v]\n",
  "HOBNOBBER": "one who hobnobs [n -S]\n",
  "HOBNOBBERS": "HOBNOBBER, one who hobnobs [n]\n",
  "HOBNOBBIER": "HOBNOBBY, sociable, given to hobnobbing [adj]\n",
  "HOBNOBBIEST": "HOBNOBBY, sociable, given to hobnobbing [adj]\n",
  "HOBNOBBING": "HOBNOB, to associate with in a friendly way [v]\n",
  "HOBNOBBY": "sociable, given to hobnobbing [adj HOBNOBBIER, HOBNOBBIEST]\n",
  "HOBNOBS": "HOBNOB, to associate with in a friendly way [v]\n",
  "HOBO": "to live like a tramp [v -ED, -ING, -S or -ES]\n",
  "HOBODOM": "the world of hobos [n -S]\n",
  "HOBODOMS": "HOBODOM, the world of hobos [n]\n",
  "HOBOED": "HOBO, to live like a tramp [v]\n",
  "HOBOES": "HOBO, to live like a tramp [v]\n",
  "HOBOING": "HOBO, to live like a tramp [v]\n",
  "HOBOISM": "the state of being a hobo [n -S]\n",
  "HOBOISMS": "HOBOISM, the state of being a hobo [n]\n",
  "HOBOS": "HOBO, to live like a tramp [v]\n",
  "HOBS": "HOB, to furnish with hobnails [v]\n",
  "HOC": "(Latin) this [adj]\n",
  "HOCHMAGANDIES": "HOCHMAGANDY, (Scots) fornication, also HOUGHMAGANDIE [n]\n",
  "HOCHMAGANDY": "(Scots) fornication, also HOUGHMAGANDIE [n HOCHMAGANDIES]\n",
  "HOCK": "to pawn [v -ED, -ING, -S]\n",
  "HOCKED": "HOCK, to pawn [v]\n",
  "HOCKER": "one who hocks, pawns [n -S]\n",
  "HOCKERS": "HOCKER, one who hocks, pawns [n]\n",
  "HOCKEY": "a ball game [n -S]\n",
  "HOCKEYS": "HOCKEY, a ball game [n]\n",
  "HOCKING": "HOCK, to pawn [v]\n",
  "HOCKLE": "(dialect) to spit [v HOCKLED, HOCKLING, HOCKLES]\n",
  "HOCKLED": "HOCKLE, (dialect) to spit [v]\n",
  "HOCKLES": "HOCKLE, (dialect) to spit [v]\n",
  "HOCKLING": "HOCKLE, (dialect) to spit [v]\n",
  "HOCKS": "HOCK, to pawn [v]\n",
  "HOCKSHOP": "a pawn shop [n -S]\n",
  "HOCKSHOPS": "HOCKSHOP, a pawn shop [n]\n",
  "HOCUS": "to deceive or cheat [v HOCUSSED or HOCUSED, HOCUSSING or HOCUSING, HOCUSSES or HOCUSES]\n",
  "HOCUSED": "HOCUS, to deceive or cheat [v]\n",
  "HOCUSES": "HOCUS, to deceive or cheat [v]\n",
  "HOCUSING": "HOCUS, to deceive or cheat [v]\n",
  "HOCUSSED": "HOCUS, to deceive or cheat [v]\n",
  "HOCUSSES": "HOCUS, to deceive or cheat [v]\n",
  "HOCUSSING": "HOCUS, to deceive or cheat [v]\n",
  "HOD": "to bob or jog [v HODDED, HODDING, HODS]\n",
  "HODAD": "a non-surfer, also HODADDY [n -S]\n",
  "HODADDIES": "HODADDY, a non-surfer, also HODAD [n]\n",
  "HODADDY": "a non-surfer, also HODAD [n HODADDIES]\n",
  "HODADS": "HODAD, a non-surfer, also HODADDY [n]\n",
  "HODDED": "HOD, to bob or jog [v]\n",
  "HODDEN": "(Scots) a coarse undyed homespun woollen cloth, also HODDIN [n -S]\n",
  "HODDENS": "HODDEN, (Scots) a coarse undyed homespun woollen cloth, also HODDIN [n]\n",
  "HODDIN": "(Scots) a coarse undyed homespun woollen cloth, also HODDEN [n -S]\n",
  "HODDING": "HOD, to bob or jog [v]\n",
  "HODDINS": "HODDIN, (Scots) a coarse undyed homespun woollen cloth, also HODDEN [n]\n",
  "HODDLE": "(Scots) to waddle [v HODDLED, HODDLING, HODDLES]\n",
  "HODDLED": "HODDLE, (Scots) to waddle [v]\n",
  "HODDLES": "HODDLE, (Scots) to waddle [v]\n",
  "HODDLING": "HODDLE, (Scots) to waddle [v]\n",
  "HODGEPODGE": "a confused mass of ingredients shaken or mixed together in the same pot, also HOTCHPOT, HOTCHPOTCH [n -S]\n",
  "HODGEPODGES": "HODGEPODGE, a confused mass of ingredients shaken or mixed together in the same pot, also HOTCHPOT, HOTCHPOTCH [n]\n",
  "HODIERNAL": "of or pertaining to the present day [adj]\n",
  "HODJA": "(Turkish) an Eastern term of respect, a Muslim teacher or professor, also KHODJA, KHOJA [n -S]\n",
  "HODJAS": "HODJA, (Turkish) an Eastern term of respect, a Muslim teacher or professor, also KHODJA, KHOJA [n]\n",
  "HODMAN": "a bricklayer's labourer [n HODMEN]\n",
  "HODMANDOD": "a snail; a snail shell; (figurative) a strange person, also DODMAN [n -S]\n",
  "HODMANDODS": "HODMANDOD, a snail; a snail shell; (figurative) a strange person, also DODMAN [n]\n",
  "HODMEN": "HODMAN, a bricklayer's labourer [n]\n",
  "HODOGRAPH": "a curve of which the radius vector represents the velocity of a moving particle [n -S]\n",
  "HODOGRAPHIC": "relating to a hodograph [adj]\n",
  "HODOGRAPHS": "HODOGRAPH, a curve of which the radius vector represents the velocity of a moving particle [n]\n",
  "HODOMETER": "an instrument for measuring distance travelled, also ODOGRAPH, ODOMETER [n -S]\n",
  "HODOMETERS": "HODOMETER, an instrument for measuring distance travelled, also ODOGRAPH, ODOMETER [n]\n",
  "HODOMETRIES": "HODOMETRY, the measurement of distance by use of a hodometer, also ODOMETRY [n]\n",
  "HODOMETRY": "the measurement of distance by use of a hodometer, also ODOMETRY [n HODOMETRIES]\n",
  "HODOSCOPE": "an instrument for tracing paths of ionizing particles [n -S]\n",
  "HODOSCOPES": "HODOSCOPE, an instrument for tracing paths of ionizing particles [n]\n",
  "HODS": "HOD, to bob or jog [v]\n",
  "HOE": "to garden with a hoe [v HOED, HOEING, HOES]\n",
  "HOECAKE": "a thin cake of ground maize, often baked on a hoe-blade [n -S]\n",
  "HOECAKES": "HOECAKE, a thin cake of ground maize, often baked on a hoe-blade [n]\n",
  "HOED": "HOE, to garden with a hoe [v]\n",
  "HOEDOWN": "(US) a country dance [n -S]\n",
  "HOEDOWNS": "HOEDOWN, (US) a country dance [n]\n",
  "HOEING": "HOE, to garden with a hoe [v]\n",
  "HOELIKE": "like a hoe [adj]\n",
  "HOER": "one who hoes [n -S]\n",
  "HOERS": "HOER, one who hoes [n]\n",
  "HOES": "HOE, to garden with a hoe [v]\n",
  "HOG": "to eat hoggishly [v HOGGED, HOGGING, HOGS]\n",
  "HOGAN": "a wooden dwelling covered with earth, typical of the Navajo Indians of North America [n -S]\n",
  "HOGANS": "HOGAN, a wooden dwelling covered with earth, typical of the Navajo Indians of North America [n]\n",
  "HOGBACK": "an eroded, steeply tilted ridge of resistant rocks with equal slopes on the sides, also SOWBACK [n -S]\n",
  "HOGBACKS": "HOGBACK, an eroded, steeply tilted ridge of resistant rocks with equal slopes on the sides, also SOWBACK [n]\n",
  "HOGEN": "(Dutch) strong liquor [n -S]\n",
  "HOGENS": "HOGEN, (Dutch) strong liquor [n]\n",
  "HOGFISH": "a large West Indian and Florida food fish, aka pigfish [n -ES]\n",
  "HOGFISHES": "HOGFISH, a large West Indian and Florida food fish, aka pigfish [n]\n",
  "HOGG": "a yearling sheep, also HOGGEREL, HOGGET [n -S]\n",
  "HOGGED": "HOG, to eat hoggishly [v]\n",
  "HOGGER": "a stocking without a foot, worn by coal miners at work [n -S]\n",
  "HOGGEREL": "(dialect) a young sheep, also HOGG, HOGGET [n -S]\n",
  "HOGGERELS": "HOGGEREL, (dialect) a young sheep, also HOGG, HOGGET [n]\n",
  "HOGGERIES": "HOGGERY, hogs collectively [n]\n",
  "HOGGERS": "HOGGER, a stocking without a foot, worn by coal miners at work [n]\n",
  "HOGGERY": "hogs collectively [n HOGGERIES]\n",
  "HOGGET": "a yearling sheep, also HOGG, HOGGEREL [n -S]\n",
  "HOGGETS": "HOGGET, a yearling sheep, also HOGG, HOGGEREL [n]\n",
  "HOGGIN": "sifted gravel, also HOGGING [n -S]\n",
  "HOGGING": "a mixture containing gravel, also HOGGIN [n -S]\n",
  "HOGGINGS": "HOGGING, a mixture containing gravel, also HOGGIN [n]\n",
  "HOGGINS": "HOGGIN, sifted gravel, also HOGGING [n]\n",
  "HOGGISH": "coarsely selfish, also HOGLIKE [adj HOGGISHLY]\n",
  "HOGGISHLY": "HOGGISH, coarsely selfish, also HOGLIKE [adv]\n",
  "HOGGISHNESS": "the state of being hoggish [n -ES]\n",
  "HOGGISHNESSES": "HOGGISHNESS, the state of being hoggish [n]\n",
  "HOGGS": "HOGG, a yearling sheep, also HOGGEREL, HOGGET [n]\n",
  "HOGH": "(Spenser) a hoe, a promontory [n -S]\n",
  "HOGHOOD": "the nature of a hog [n -S]\n",
  "HOGHOODS": "HOGHOOD, the nature of a hog [n]\n",
  "HOGHS": "HOGH, (Spenser) a hoe, a promontory [n]\n",
  "HOGLIKE": "coarsely selfish, also HOGGISH [adj]\n",
  "HOGMANAY": "(Scots) a Scottish celebration, also HOGMANE, HOGMENAY [n -S]\n",
  "HOGMANAYS": "HOGMANAY, (Scots) a Scottish celebration, also HOGMANE, HOGMENAY [n]\n",
  "HOGMANE": "(Scots) a Scottish celebration, also HOGMANAY, HOGMENAY [n -S]\n",
  "HOGMANES": "HOGMANE, (Scots) a Scottish celebration, also HOGMANAY, HOGMENAY [n]\n",
  "HOGMENAY": "(Scots) a Scottish celebration, also HOGMANAY, HOGMANE [n -S]\n",
  "HOGMENAYS": "HOGMENAY, (Scots) a Scottish celebration, also HOGMANAY, HOGMANE [n]\n",
  "HOGNOSE": "a type of snake with an upturned snout [n -S]\n",
  "HOGNOSED": "as in hognosed skunk, any of several American skunks with a broad snoutlike nose [adj]\n",
  "HOGNOSES": "HOGNOSE, a type of snake with an upturned snout [n]\n",
  "HOGNUT": "another name for pignut [n -S]\n",
  "HOGNUTS": "HOGNUT, another name for pignut [n]\n",
  "HOGS": "HOG, to eat hoggishly [v]\n",
  "HOGSHEAD": "a large cask [n -S]\n",
  "HOGSHEADS": "HOGSHEAD, a large cask [n]\n",
  "HOGTIE": "to tie the legs together [v HOGTIED, HOGTIEING or HOGTYING, HOGTIES]\n",
  "HOGTIED": "HOGTIE, to tie the legs together [v]\n",
  "HOGTIEING": "HOGTIE, to tie the legs together [v]\n",
  "HOGTIES": "HOGTIE, to tie the legs together [v]\n",
  "HOGTYING": "HOGTIE, to tie the legs together [v]\n",
  "HOGWARD": "a swineherd [n -S]\n",
  "HOGWARDS": "HOGWARD, a swineherd [n]\n",
  "HOGWASH": "meaningless talk [n -ES]\n",
  "HOGWASHES": "HOGWASH, meaningless talk [n]\n",
  "HOGWEED": "a coarse umbelliferous plant [n -S]\n",
  "HOGWEEDS": "HOGWEED, a coarse umbelliferous plant [n]\n",
  "HOH": "to stop, also HO, HOA [v -ED, -ING, -S]\n",
  "HOHA": "(Maori) bored, annoyed [adj]\n",
  "HOHED": "HOH, to stop, also HO, HOA [v]\n",
  "HOHING": "HOH, to stop, also HO, HOA [v]\n",
  "HOHS": "HOH, to stop, also HO, HOA [v]\n",
  "HOI": "to urge, incite [v -ED, -ING, -S]\n",
  "HOICK": "to hitch up, also HOIK [v -ED, -ING, -S]\n",
  "HOICKED": "HOICK, to hitch up, also HOIK [v]\n",
  "HOICKING": "HOICK, to hitch up, also HOIK [v]\n",
  "HOICKS": "to hark back [v -ED, -ING, -ES]\n",
  "HOICKSED": "HOICKS, to hark back [v]\n",
  "HOICKSES": "HOICKS, to hark back [v]\n",
  "HOICKSING": "HOICKS, to hark back [v]\n",
  "HOIDEN": "to act like a tomboy, also HOYDEN [v -ED, -ING, -S]\n",
  "HOIDENED": "HOIDEN, to act like a tomboy, also HOYDEN [v]\n",
  "HOIDENING": "HOIDEN, to act like a tomboy, also HOYDEN [v]\n",
  "HOIDENISH": "like a hoiden, a woman of saucy, boisterous or carefree behavior, also HOYDENISH [adj]\n",
  "HOIDENISHNESS": "HOIDENISH, like a hoiden, a woman of saucy, boisterous or carefree behavior, also HOYDENISH [n]\n",
  "HOIDENISHNESSES": "HOIDENISHNESS, HOIDENISH, like a hoiden, a woman of saucy, boisterous or carefree behavior, also HOYDENISH [n]\n",
  "HOIDENS": "HOIDEN, to act like a tomboy, also HOYDEN [v]\n",
  "HOIED": "HOI, to urge, incite [v]\n",
  "HOIING": "HOI, to urge, incite [v]\n",
  "HOIK": "to hitch up, also HOICK [v -ED, -ING, -S]\n",
  "HOIKED": "HOIK, to hitch up, also HOICK [v]\n",
  "HOIKING": "HOIK, to hitch up, also HOICK [v]\n",
  "HOIKS": "HOIK, to hitch up, also HOICK [v]\n",
  "HOING": "HO, to stop [v]\n",
  "HOIS": "HOI, to urge, incite [v]\n",
  "HOISE": "to hoist [v HOISED, HOISING, HOISES]\n",
  "HOISED": "HOISE, to hoist [v]\n",
  "HOISES": "HOISE, to hoist [v]\n",
  "HOISIN": "(Chinese) a sweet spice reddish-brown sauce [n -S]\n",
  "HOISING": "HOISE, to hoist [v]\n",
  "HOISINS": "HOISIN, (Chinese) a sweet spice reddish-brown sauce [n]\n",
  "HOIST": "to raise with tackle [v -ED, -ING, -S]\n",
  "HOISTED": "HOIST, to raise with tackle [v]\n",
  "HOISTER": "one who hoists [n -S]\n",
  "HOISTERS": "HOISTER, one who hoists [n]\n",
  "HOISTING": "(Scott) a hosting [n -S]\n",
  "HOISTINGS": "HOISTING, (Scott) a hosting [n]\n",
  "HOISTMAN": "a person who works a hoist [n HOISTMEN]\n",
  "HOISTMEN": "HOISTMAN, a person who works a hoist [n]\n",
  "HOISTS": "HOIST, to raise with tackle [v]\n",
  "HOISTWAY": "an opening for the hoist, or elevator, in the floor of a wareroom [n -S]\n",
  "HOISTWAYS": "HOISTWAY, an opening for the hoist, or elevator, in the floor of a wareroom [n]\n",
  "HOJATOLESLAM": "an Iranian cleric below the rank of ayatollah, also HOJATOLISLAM [n -S]\n",
  "HOJATOLESLAMS": "HOJATOLESLAM, an Iranian cleric below the rank of ayatollah, also HOJATOLISLAM [n]\n",
  "HOJATOLISLAM": "an Iranian cleric below the rank of ayatollah, also HOJATOLESLAM [n -S]\n",
  "HOJATOLISLAMS": "HOJATOLISLAM, an Iranian cleric below the rank of ayatollah, also HOJATOLESLAM [n]\n",
  "HOKA": "(Maori) red cod [n -S]\n",
  "HOKAS": "HOKA, (Maori) red cod [n]\n",
  "HOKE": "to give false value to [v HOKED, HOKING, HOKES]\n",
  "HOKED": "HOKE, to give false value to [v]\n",
  "HOKES": "HOKE, to give false value to [v]\n",
  "HOKEY": "overdone, contrived, bogus [adj HOKIER, HOKIEST, HOKILY]\n",
  "HOKEYNESS": "the state of being hokey, overdone, contrived, bogus, also HOKINESS [n -ES]\n",
  "HOKEYNESSES": "HOKEYNESS, the state of being hokey, overdone, contrived, bogus, also HOKINESS [n]\n",
  "HOKEYPOKEY": "hocus-pocus; a kind of ice-cream sold on the streets, also HOKYPOKY [n -S]\n",
  "HOKEYPOKEYS": "HOKEYPOKEY, hocus-pocus; a kind of ice-cream sold on the streets, also HOKYPOKY [n]\n",
  "HOKI": "(Maori) a type of fish with white flesh [n -S]\n",
  "HOKIER": "HOKEY, overdone, contrived, bogus [adj]\n",
  "HOKIEST": "HOKEY, overdone, contrived, bogus [adj]\n",
  "HOKILY": "HOKEY, overdone, contrived, bogus [adv]\n",
  "HOKINESS": "the state of being hokey, also HOKEYNESS [n -ES]\n",
  "HOKINESSES": "HOKINESS, the state of being hokey, also HOKEYNESS [n]\n",
  "HOKING": "HOKE, to give false value to [v]\n",
  "HOKIS": "HOKI, (Maori) a type of fish with white flesh [n]\n",
  "HOKKU": "(Japanese) the first half-line of a linked series of haiku; a haiku [n HOKKU]\n",
  "HOKONUI": "(Maori) illicit whiskey [n -S]\n",
  "HOKONUIS": "HOKONUI, (Maori) illicit whiskey [n]\n",
  "HOKUM": "nonsense [n -S]\n",
  "HOKUMS": "HOKUM, nonsense [n]\n",
  "HOKYPOKIES": "HOKYPOKY, hocus-pocus; a kind of ice-cream sold on the streets, also HOKEYPOKEY [n]\n",
  "HOKYPOKY": "hocus-pocus; a kind of ice-cream sold on the streets, also HOKEYPOKEY [n HOKYPOKIES]\n",
  "HOLANDRIC": "transmitted by a gene in the nonhomologous portion of the Y chromosome [adj]\n",
  "HOLARCHIES": "HOLARCHY, a system of interacting holons [n]\n",
  "HOLARCHY": "a system of interacting holons [n HOLARCHIES]\n",
  "HOLARD": "the total amount of water in the soil [n -S]\n",
  "HOLARDS": "HOLARD, the total amount of water in the soil [n]\n",
  "HOLD": "to keep possession of [v HELD, HOLDEN, HOLDING, HOLDS]\n",
  "HOLDABLE": "able to be held [adj]\n",
  "HOLDALL": "a carrying case [n -S]\n",
  "HOLDALLS": "HOLDALL, a carrying case [n]\n",
  "HOLDBACK": "a restraining device [n -S]\n",
  "HOLDBACKS": "HOLDBACK, a restraining device [n]\n",
  "HOLDDOWN": "a clamp for holding an object in place [n -S]\n",
  "HOLDDOWNS": "HOLDDOWN, a clamp for holding an object in place [n]\n",
  "HOLDEN": "HOLD, to keep possession of [v]\n",
  "HOLDER": "one that holds [n -S]\n",
  "HOLDERBAT": "a clamp fixed around the sides of a pipe [n -S]\n",
  "HOLDERBATS": "HOLDERBAT, a clamp fixed around the sides of a pipe [n]\n",
  "HOLDERS": "HOLDER, one that holds [n]\n",
  "HOLDERSHIP": "the state of being a holder e.g. of a bill [n -S]\n",
  "HOLDERSHIPS": "HOLDERSHIP, the state of being a holder e.g. of a bill [n]\n",
  "HOLDFAST": "the anchoring base of an alga [n -S]\n",
  "HOLDFASTS": "HOLDFAST, the anchoring base of an alga [n]\n",
  "HOLDING": "something held [n -S]\n",
  "HOLDINGS": "HOLDING, something held [n]\n",
  "HOLDOUT": "one who delays signing a contract [n -S]\n",
  "HOLDOUTS": "HOLDOUT, one who delays signing a contract [n]\n",
  "HOLDOVER": "something left over [n -S]\n",
  "HOLDOVERS": "HOLDOVER, something left over [n]\n",
  "HOLDS": "HOLD, to keep possession of [v]\n",
  "HOLDUP": "a delay [n -S]\n",
  "HOLDUPS": "HOLDUP, a delay [n]\n",
  "HOLE": "to make a cavity in [v HOLED, HOLING, HOLES]\n",
  "HOLED": "HOLE, to make a cavity in [v]\n",
  "HOLELESS": "without a hole [adj]\n",
  "HOLES": "HOLE, to make a cavity in [v]\n",
  "HOLESOM": "(Spenser) wholesome, also HEALSOME, HOLESOME [adj]\n",
  "HOLESOME": "(Spenser) wholesome, also HEALSOME, HOLESOM [adj]\n",
  "HOLEY": "full of holes [adj HOLEYER, HOLEYEST]\n",
  "HOLEYER": "HOLEY, full of holes [adj]\n",
  "HOLEYEST": "HOLEY, full of holes [adj]\n",
  "HOLIBUT": "a flatfish, also HALIBUT [n -S]\n",
  "HOLIBUTS": "HOLIBUT, a flatfish, also HALIBUT [n]\n",
  "HOLIDAY": "to take a vacation [v -ED, -ING, -S]\n",
  "HOLIDAYED": "HOLIDAY, to take a vacation [v]\n",
  "HOLIDAYER": "a holidaymaker [n -S]\n",
  "HOLIDAYERS": "HOLIDAYER, a holidaymaker [n]\n",
  "HOLIDAYING": "HOLIDAY, to take a vacation [v]\n",
  "HOLIDAYMAKER": "someone on holiday [n -S]\n",
  "HOLIDAYMAKERS": "HOLIDAYMAKER, someone on holiday [n]\n",
  "HOLIDAYS": "HOLIDAY, to take a vacation [v]\n",
  "HOLIER": "HOLY, perfect in a moral sense [adj]\n",
  "HOLIES": "HOLY, a sacred place [n]\n",
  "HOLIEST": "HOLY, perfect in a moral sense [adj]\n",
  "HOLILY": "HOLY, perfect in a moral sense [adv]\n",
  "HOLINESS": "the state of being holy [n -ES]\n",
  "HOLINESSES": "HOLINESS, the state of being holy [n]\n",
  "HOLING": "the process of making a hole [n -S]\n",
  "HOLINGS": "HOLING, the process of making a hole [n]\n",
  "HOLISM": "the philosophical theory that a complex system is more than the sum of its parts, also WHOLISM [n -S]\n",
  "HOLISMS": "HOLISM, the philosophical theory that a complex system is more than the sum of its parts, also WHOLISM [n]\n",
  "HOLIST": "a believer in holism, also WHOLIST [n -S]\n",
  "HOLISTIC": "considering the whole e.g. holistic medicine, also WHOLISTIC [adj HOLISTICALLY]\n",
  "HOLISTICALLY": "HOLISTIC, considering the whole e.g. holistic medicine, also WHOLISTIC [adv]\n",
  "HOLISTS": "HOLIST, a believer in holism, also WHOLIST [n]\n",
  "HOLK": "(Scots) to dig, burrow, also HOWK [v -ED, -ING, -S]\n",
  "HOLKED": "HOLK, (Scots) to dig, burrow, also HOWK [v]\n",
  "HOLKING": "HOLK, (Scots) to dig, burrow, also HOWK [v]\n",
  "HOLKS": "HOLK, (Scots) to dig, burrow, also HOWK [v]\n",
  "HOLLA": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLO, HOLLOA, HOLLOO, HULLO [v -ED, -ING, -S]\n",
  "HOLLAED": "HOLLA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLAING": "HOLLA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLAND": "a coarse plain-woven cotton or linen [n -S]\n",
  "HOLLANDAISE": "(French) a sauce made with butter, egg-yolks, vinegar or white wine, and lemon juice, usually served with fish [n -S]\n",
  "HOLLANDAISES": "HOLLANDAISE, (French) a sauce made with butter, egg-yolks, vinegar or white wine, and lemon juice, usually served with fish [n]\n",
  "HOLLANDS": "HOLLAND, a coarse plain-woven cotton or linen [n]\n",
  "HOLLAS": "HOLLA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLO, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLER": "to call out or yell to attract attention [v -ED, -ING, -S]\n",
  "HOLLERED": "HOLLER, to call out or yell to attract attention [v]\n",
  "HOLLERING": "HOLLER, to call out or yell to attract attention [v]\n",
  "HOLLERS": "HOLLER, to call out or yell to attract attention [v]\n",
  "HOLLIDAM": "(Shakespeare) holiness, a holy place, esp. in an oath, also HALIDOM, HALIDOME, HOLYDAM, HOLYDAME [n -S]\n",
  "HOLLIDAMS": "HOLLIDAM, (Shakespeare) holiness, a holy place, esp. in an oath, also HALIDOM, HALIDOME, HOLYDAM, HOLYDAME [n]\n",
  "HOLLIES": "HOLLY, an evergreen shrub having leathery, shining, spinous leaves and red berries [n]\n",
  "HOLLO": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLOA, HOLLOO, HULLO [v HOLLOED, HOLLOING, HOLLOES or HOLLOS]\n",
  "HOLLOA": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOO, HULLO [v -ED, -ING, -S]\n",
  "HOLLOAED": "HOLLOA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOO, HULLO [v]\n",
  "HOLLOAING": "HOLLOA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOO, HULLO [v]\n",
  "HOLLOAS": "HOLLOA, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOO, HULLO [v]\n",
  "HOLLOED": "HOLLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLOES": "HOLLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLOING": "HOLLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLOO": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HULLO [v -ED, -ING, -S]\n",
  "HOLLOOED": "HOLLOO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HULLO [v]\n",
  "HOLLOOING": "HOLLOO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HULLO [v]\n",
  "HOLLOOS": "HOLLOO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HULLO [v]\n",
  "HOLLOS": "HOLLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLOA, HOLLOO, HULLO [v]\n",
  "HOLLOW": "to remove the interior [v -ED, -ING, -S] / not solid [adj HOLLOWER, HOLLOWEST, HOLLOWLY]\n",
  "HOLLOWARE": "hollow articles of china, iron etc. e.g. pots and kettles [n -S]\n",
  "HOLLOWARES": "HOLLOWARE, hollow articles of china, iron etc. e.g. pots and kettles [n]\n",
  "HOLLOWED": "HOLLOW, to remove the interior [v]\n",
  "HOLLOWER": "HOLLOW, not solid [adj]\n",
  "HOLLOWEST": "HOLLOW, not solid [adj]\n",
  "HOLLOWING": "HOLLOW, to remove the interior [v]\n",
  "HOLLOWLY": "HOLLOW, not solid [adv]\n",
  "HOLLOWNESS": "the state of being hollow [n -ES]\n",
  "HOLLOWNESSES": "HOLLOWNESS, the state of being hollow [n]\n",
  "HOLLOWS": "HOLLOW, to remove the interior [v]\n",
  "HOLLOWWARE": "hollow articles of china, iron etc. e.g. pots and kettles [n -S]\n",
  "HOLLOWWARES": "HOLLOWWARE, hollow articles of china, iron etc. e.g. pots and kettles [n]\n",
  "HOLLY": "an evergreen shrub having leathery, shining, spinous leaves and red berries [n HOLLIES]\n",
  "HOLLYHOCK": "a plant of the mallow family [n -S]\n",
  "HOLLYHOCKS": "HOLLYHOCK, a plant of the mallow family [n]\n",
  "HOLM": "a river island, also HOLME [n -S]\n",
  "HOLME": "an island in a river, also HOLM [n -S]\n",
  "HOLMES": "HOLME, an island in a river, also HOLM [n]\n",
  "HOLMIA": "an oxide of holmium [n -S]\n",
  "HOLMIAS": "HOLMIA, an oxide of holmium [n]\n",
  "HOLMIC": "relating to holmium, a metallic element [adj]\n",
  "HOLMIUM": "a metallic element [n -S]\n",
  "HOLMIUMS": "HOLMIUM, a metallic element [n]\n",
  "HOLMS": "HOLM, a river island, also HOLME [n]\n",
  "HOLO": "(short for) hologram [n -S]\n",
  "HOLOBENTHIC": "passing the entire life in the deep ocean [adj]\n",
  "HOLOBLASTIC": "of an entire egg, separated into individual blastomeres [adj HOLOBLASTICALLY]\n",
  "HOLOBLASTICALLY": "HOLOBLASTIC, of an entire egg, separated into individual blastomeres [adv]\n",
  "HOLOCAINE": "a kind of surface anaesthetic for the eye [n -S]\n",
  "HOLOCAINES": "HOLOCAINE, a kind of surface anaesthetic for the eye [n]\n",
  "HOLOCAUST": "a complete or wholesale destruction, esp. by fire [n -S]\n",
  "HOLOCAUSTAL": "relating to a holocaust, also HOLOCAUSTIC [adj]\n",
  "HOLOCAUSTIC": "relating to a holocaust, also HOLOCAUSTAL [adj]\n",
  "HOLOCAUSTS": "HOLOCAUST, a complete or wholesale destruction, esp. by fire [n]\n",
  "HOLOCENE": "relating to the second and most recent epoch of the Quaternary period [adj]\n",
  "HOLOCRINE": "applied to a gland whose secretion is composed of its own disintegrated cells [adj]\n",
  "HOLOCRYSTALLINE": "wholly crystalline in structure, without glass [adj]\n",
  "HOLODISCUS": "a genus of deciduous shrubs grown for their summer flowers [n -ES]\n",
  "HOLODISCUSES": "HOLODISCUS, a genus of deciduous shrubs grown for their summer flowers [n]\n",
  "HOLOENZYME": "an enzyme which has a protein and nonprotein ingredient [n -S]\n",
  "HOLOENZYMES": "HOLOENZYME, an enzyme which has a protein and nonprotein ingredient [n]\n",
  "HOLOGAMIES": "HOLOGAMY, the state of having gametes like other cells [n]\n",
  "HOLOGAMY": "the state of having gametes like other cells [n HOLOGAMIES]\n",
  "HOLOGRAM": "a three-dimensional photograph [n -S]\n",
  "HOLOGRAMS": "HOLOGRAM, a three-dimensional photograph [n]\n",
  "HOLOGRAPH": "a text written entirely in its author's handwriting [n -S] / to write a text in one's own handwriting [v -ED, -ING, -S]\n",
  "HOLOGRAPHED": "HOLOGRAPH, to write a text in one's own handwriting [v]\n",
  "HOLOGRAPHER": "one who makes holographs [n -S]\n",
  "HOLOGRAPHERS": "HOLOGRAPHER, one who makes holographs [n]\n",
  "HOLOGRAPHIC": "relating to holographs [adj HOLOGRAPHICALLY]\n",
  "HOLOGRAPHICALLY": "HOLOGRAPHIC, relating to holographs [adv]\n",
  "HOLOGRAPHIES": "HOLOGRAPHY, the technique or process of making or using holograms [n]\n",
  "HOLOGRAPHING": "HOLOGRAPH, to write a text in one's own handwriting [v]\n",
  "HOLOGRAPHS": "HOLOGRAPH, a text written entirely in its author's handwriting [n]\n",
  "HOLOGRAPHY": "the technique or process of making or using holograms [n HOLOGRAPHIES]\n",
  "HOLOGYNIC": "passed down through females [adj]\n",
  "HOLOGYNIES": "HOLOGYNY, a trait transmitted only in the female line [n]\n",
  "HOLOGYNY": "a trait transmitted only in the female line [n HOLOGYNIES]\n",
  "HOLOHEDRA": "HOLOHEDRON, a geometrical form possessing the property of holohedrism [n]\n",
  "HOLOHEDRAL": "having all the planes required by complete symmetry, as opposed to hemihedral [adj]\n",
  "HOLOHEDRISM": "the property of having the full number of symmetrically arranged planes crystallographically possible [n -S]\n",
  "HOLOHEDRISMS": "HOLOHEDRISM, the property of having the full number of symmetrically arranged planes crystallographically possible [n]\n",
  "HOLOHEDRON": "a geometrical form possessing the property of holohedrism [n HOLOHEDRA or HOLOHEDRONS]\n",
  "HOLOHEDRONS": "HOLOHEDRON, a geometrical form possessing the property of holohedrism [n]\n",
  "HOLOMETABOLIC": "exhibiting holometabolism, complete metamorphosis [adj]\n",
  "HOLOMETABOLISM": "of an insect, complete metabolism [n -S]\n",
  "HOLOMETABOLISMS": "HOLOMETABOLISM, of an insect, complete metabolism [n]\n",
  "HOLOMETABOLOUS": "characterized by complete metamorphosis [adj]\n",
  "HOLOMORPHIC": "of a function of a complex variable, having a derivative at each point of its domain [adj]\n",
  "HOLON": "an autonomous self-reliant unit, esp. in manufacturing [n -S]\n",
  "HOLONIC": "relating to a holon [adj]\n",
  "HOLONS": "HOLON, an autonomous self-reliant unit, esp. in manufacturing [n]\n",
  "HOLOPHOTAL": "of reflectors, throwing back the rays of light without perceptible loss [adj]\n",
  "HOLOPHOTE": "an apparatus by which all the light from a lighthouse is thrown in the required direction [n -S]\n",
  "HOLOPHOTES": "HOLOPHOTE, an apparatus by which all the light from a lighthouse is thrown in the required direction [n]\n",
  "HOLOPHRASE": "a single word expressing a sentence or phrase [n -S]\n",
  "HOLOPHRASES": "HOLOPHRASE, a single word expressing a sentence or phrase [n]\n",
  "HOLOPHRASTIC": "of or like a holophrase, a single word expressing a sentence or phrase [adj]\n",
  "HOLOPHYTE": "a plant maintained entirely by its own organs [n -S]\n",
  "HOLOPHYTES": "HOLOPHYTE, a plant maintained entirely by its own organs [n]\n",
  "HOLOPHYTIC": "obtaining food by photosynthesis [adj]\n",
  "HOLOPHYTISM": "the property of being holophytic, obtaining food by photosynthesis [n -S]\n",
  "HOLOPHYTISMS": "HOLOPHYTISM, the property of being holophytic, obtaining food by photosynthesis [n]\n",
  "HOLOPLANKTON": "organisms which remain as plankton throughout their whole life cycle [n -S]\n",
  "HOLOPLANKTONS": "HOLOPLANKTON, organisms which remain as plankton throughout their whole life cycle [n]\n",
  "HOLOPTIC": "having eyes meeting in front [adj]\n",
  "HOLOS": "HOLO, (short for) hologram [n]\n",
  "HOLOSTERIC": "totally solid [adj]\n",
  "HOLOTHURIAN": "any member of a class of wormlike unarmoured echinoderms, aka sea cucumbers [n -S]\n",
  "HOLOTHURIANS": "HOLOTHURIAN, any member of a class of wormlike unarmoured echinoderms, aka sea cucumbers [n]\n",
  "HOLOTYPE": "the original type specimen of an animal or plant [n -S]\n",
  "HOLOTYPES": "HOLOTYPE, the original type specimen of an animal or plant [n]\n",
  "HOLOTYPIC": "relating to a holotype, an original type specimen used in defining and describing a species or variety [adj]\n",
  "HOLOZOIC": "obtaining food by eating complex matter, in the manner of an animal [adj]\n",
  "HOLP": "HELP, to give aid [v]\n",
  "HOLPEN": "HELP, to give aid [v]\n",
  "HOLS": "(colloquial) holidays [n]\n",
  "HOLSTEIN": "(German) a breed of cattle [n -S]\n",
  "HOLSTEINS": "HOLSTEIN, (German) a breed of cattle [n]\n",
  "HOLSTER": "a case for a gun [n -S] / to place in a holster [v -ED, -ING, -S]\n",
  "HOLSTERED": "HOLSTER, to place in a holster [v]\n",
  "HOLSTERING": "HOLSTER, to place in a holster [v]\n",
  "HOLSTERS": "HOLSTER, to place in a holster [v]\n",
  "HOLT": "the lair or den of an animal, esp. an otter [n -S]\n",
  "HOLTS": "HOLT, the lair or den of an animal, esp. an otter [n]\n",
  "HOLUBTSI": "(Polish) cabbage rolls [n]\n",
  "HOLY": "perfect in a moral sense [adj HOLIER, HOLIEST, HOLILY] / a sacred place [n HOLIES]\n",
  "HOLYDAM": "(Shakespeare) holiness, a holy place, esp. in an oath, also HALIDOM, HALIDOME, HOLLIDAM, HOLYDAME [n -S]\n",
  "HOLYDAME": "(Shakespeare) holiness, a holy place, esp. in an oath, also HALIDOM, HALIDOME, HOLLIDAM, HOLYDAM [n -S]\n",
  "HOLYDAMES": "HOLYDAME, (Shakespeare) holiness, a holy place, esp. in an oath, also HALIDOM, HALIDOME, HOLLIDAM, HOLYDAM [n]\n",
  "HOLYDAMS": "HOLYDAM, (Shakespeare) holiness, a holy place, esp. in an oath, also HALIDOM, HALIDOME, HOLLIDAM, HOLYDAME [n]\n",
  "HOLYDAY": "a religious holiday [n -S]\n",
  "HOLYDAYS": "HOLYDAY, a religious holiday [n]\n",
  "HOLYSTONE": "a sandstone material used to scrape ships' decks [n -S] / to scrape a deck with holystone [v HOLYSTONED, HOLYSTONING, HOLYSTONES]\n",
  "HOLYSTONED": "HOLYSTONE, to scrape a deck with holystone [v]\n",
  "HOLYSTONES": "HOLYSTONE, a sandstone material used to scrape ships' decks [n]\n",
  "HOLYSTONING": "HOLYSTONE, to scrape a deck with holystone [v]\n",
  "HOLYTIDE": "a time of religious observance [n -S]\n",
  "HOLYTIDES": "HOLYTIDE, a time of religious observance [n]\n",
  "HOM": "(Persian) a sacred plant of the ancient Persians, also HAOMA, HOMA [n -S]\n",
  "HOMA": "(Persian) a sacred plant of the ancient Persians, also HOM [n -S]\n",
  "HOMAGE": "to pay tribute to [v HOMAGED, HOMAGING, HOMAGES]\n",
  "HOMAGED": "HOMAGE, to pay tribute to [v]\n",
  "HOMAGER": "a feudal vassal [n -S]\n",
  "HOMAGERS": "HOMAGER, a feudal vassal [n]\n",
  "HOMAGES": "HOMAGE, to pay tribute to [v]\n",
  "HOMAGING": "HOMAGE, to pay tribute to [v]\n",
  "HOMALOGRAPHIC": "of a map projection, showing area accurately and therefore distorting shape and direction, also HOMOLOGRAPHIC [adj]\n",
  "HOMALOID": "a Euclidean space, analogous to a plane [n -S]\n",
  "HOMALOIDAL": "of the nature of a homaloid; flat; plane-shaped [adj]\n",
  "HOMALOIDS": "HOMALOID, a Euclidean space, analogous to a plane [n]\n",
  "HOMAS": "HOMA, (Persian) a sacred plant of the ancient Persians, also HOM [n]\n",
  "HOMBRE": "(Spanish) a fellow [n -S]\n",
  "HOMBRES": "HOMBRE, (Spanish) a fellow [n]\n",
  "HOMBURG": "(German) a felt hat [n -S]\n",
  "HOMBURGS": "HOMBURG, (German) a felt hat [n]\n",
  "HOME": "to return to a place of residence [v HOMED, HOMING, HOMES]\n",
  "HOMEBIRD": "a person who is reluctant to leave their hometown or their childhood home [n -S]\n",
  "HOMEBIRDS": "HOMEBIRD, a person who is reluctant to leave their hometown or their childhood home [n]\n",
  "HOMEBIRTH": "the act of giving birth to a child in one's own home [n -S]\n",
  "HOMEBIRTHS": "HOMEBIRTH, the act of giving birth to a child in one's own home [n]\n",
  "HOMEBODIES": "HOMEBODY, one who likes to stay at home [n]\n",
  "HOMEBODY": "one who likes to stay at home [n HOMEBODIES]\n",
  "HOMEBOUND": "stuck at home [adj]\n",
  "HOMEBOY": "a member of a youth gang, also HOMEY, HOMIE [n -S]\n",
  "HOMEBOYS": "HOMEBOY, a member of a youth gang, also HOMEY, HOMIE [n]\n",
  "HOMEBRED": "a home-brewed beer [n -S]\n",
  "HOMEBREDS": "HOMEBRED, a home-brewed beer [n]\n",
  "HOMEBREW": "an alcoholic beverage made at home [n -S]\n",
  "HOMEBREWS": "HOMEBREW, an alcoholic beverage made at home [n]\n",
  "HOMEBUILT": "built at home [adj]\n",
  "HOMEBUYER": "one who is buying a home [n -S]\n",
  "HOMEBUYERS": "HOMEBUYER, one who is buying a home [n]\n",
  "HOMECOMER": "a person coming home [n -S]\n",
  "HOMECOMERS": "HOMECOMER, a person coming home [n]\n",
  "HOMECOMING": "a return home [n -S]\n",
  "HOMECOMINGS": "HOMECOMING, a return home [n]\n",
  "HOMECRAFT": "a craft practised at home [n -S]\n",
  "HOMECRAFTS": "HOMECRAFT, a craft practised at home [n]\n",
  "HOMED": "HOME, to return to a place of residence [v]\n",
  "HOMEFELT": "felt in one's breast, inward [adj]\n",
  "HOMEGIRL": "a girl or woman from one's neighborhood [n -S]\n",
  "HOMEGIRLS": "HOMEGIRL, a girl or woman from one's neighborhood [n]\n",
  "HOMEGROWN": "produced in one's own country, or garden [adj]\n",
  "HOMELAND": "one's native land [n -S]\n",
  "HOMELANDS": "HOMELAND, one's native land [n]\n",
  "HOMELESS": "without a home [adj]\n",
  "HOMELESSNESS": "the state of being homeless [n -ES]\n",
  "HOMELESSNESSES": "HOMELESSNESS, the state of being homeless [n]\n",
  "HOMELIER": "HOMELY, unattractive [adj]\n",
  "HOMELIEST": "HOMELY, unattractive [adj]\n",
  "HOMELIKE": "like a home [adj]\n",
  "HOMELILY": "HOMELY, unattractive [adv]\n",
  "HOMELINESS": "the state of being homely [n -ES]\n",
  "HOMELINESSES": "HOMELINESS, the state of being homely [n]\n",
  "HOMELY": "unattractive [adj HOMELIER, HOMELIEST, HOMELILY]\n",
  "HOMELYN": "the spotted ray [n -S]\n",
  "HOMELYNS": "HOMELYN, the spotted ray [n]\n",
  "HOMEMADE": "made at home [adj]\n",
  "HOMEMAKER": "a housewife or househusband [n -S]\n",
  "HOMEMAKERS": "HOMEMAKER, a housewife or househusband [n]\n",
  "HOMEMAKING": "the making of a home [n -S]\n",
  "HOMEMAKINGS": "HOMEMAKING, the making of a home [n]\n",
  "HOMEOBOX": "a short DNA sequence, also HOMOEOBOX [n -ES]\n",
  "HOMEOBOXES": "HOMEOBOX, a short DNA sequence, also HOMOEOBOX [n]\n",
  "HOMEOMERIC": "having all the somites alike, also HOMEOMEROUS, HOMOEOMERIC, HOMOEOMEROUS, HOMOIOMEROUS [adj]\n",
  "HOMEOMERIES": "HOMEOMERY, the state of being homoeomeric, having all the somites alike, also HOMOEOMERY [n]\n",
  "HOMEOMEROUS": "having all the somites alike, also HOMEOMERIC, HOMOEOMERIC, HOMOEOMEROUS, HOMOIOMEROUS [adj]\n",
  "HOMEOMERY": "the state of being homoeomeric, having all the somites alike, also HOMOEOMERY [n HOMEOMERIES]\n",
  "HOMEOMORPH": "a thing similar in form from another but essentially different, also HOMOEOMORPH [n -S]\n",
  "HOMEOMORPHIC": "relating to homeomorphism [adj]\n",
  "HOMEOMORPHIES": "HOMEOMORPHY, the state of being homeomorphic, also HOMOMORPHY [n]\n",
  "HOMEOMORPHISM": "one-to-one correspondence of two geometric figures that is continuous in both directions [n -S]\n",
  "HOMEOMORPHISMS": "HOMEOMORPHISM, one-to-one correspondence of two geometric figures that is continuous in both directions [n]\n",
  "HOMEOMORPHOUS": "like a homeomorph [adj]\n",
  "HOMEOMORPHS": "HOMEOMORPH, a thing similar in form from another but essentially different, also HOMOEOMORPH [n]\n",
  "HOMEOMORPHY": "the state of being homeomorphic, also HOMOMORPHY [n HOMEOMORPHIES]\n",
  "HOMEOPATH": "a practitioner of homeopathy, also HOMEOPATHIST, HOMOEOPATH, HOMOEOPATHIST [n -S]\n",
  "HOMEOPATHIC": "of or relating to homeopathy [adj HOMEOPATHICALLY]\n",
  "HOMEOPATHICALLY": "HOMEOPATHIC, of or relating to homeopathy [adv]\n",
  "HOMEOPATHIES": "HOMEOPATHY, the use of minute quantities of medications that in large amounts, produce symptoms like those of the disease being treated, also HOMOEOPATHY [n]\n",
  "HOMEOPATHIST": "one who practises homeopathy, also HOMEOPATH, HOMOEOPATH, HOMOEOPATHIST [n -S]\n",
  "HOMEOPATHISTS": "HOMEOPATHIST, one who practises homeopathy, also HOMEOPATH, HOMOEOPATH, HOMOEOPATHIST [n]\n",
  "HOMEOPATHS": "HOMEOPATH, a practitioner of homeopathy, also HOMEOPATHIST, HOMOEOPATH, HOMOEOPATHIST [n]\n",
  "HOMEOPATHY": "the use of minute quantities of medications that in large amounts, produce symptoms like those of the disease being treated, also HOMOEOPATHY [n HOMEOPATHIES]\n",
  "HOMEOSES": "HOMEOSIS, the assumption of the character of a corresponding member of another whorl or somite, also HOMOEOSIS [n]\n",
  "HOMEOSIS": "the assumption of the character of a corresponding member of another whorl or somite, also HOMOEOSIS [n HOMEOSES]\n",
  "HOMEOSTASES": "HOMEOSTASIS, a tendency towards health or stable physical conditions, also HOMOEOSTASIS [n]\n",
  "HOMEOSTASIS": "a tendency towards health or stable physical conditions, also HOMOEOSTASIS [n HOMEOSTASES]\n",
  "HOMEOSTATIC": "relating to homeostasis, a tendency towards health or stable physical conditions, also HOMOEOSTATIC [adj]\n",
  "HOMEOTELEUTON": "the use or occurrence of similar endings [n -S]\n",
  "HOMEOTELEUTONS": "HOMEOTELEUTON, the use or occurrence of similar endings [n]\n",
  "HOMEOTHERM": "an organism that maintains the same temperature [n -S]\n",
  "HOMEOTHERMAL": "keeping the same temperature, warm-blooded, also HOMOEOTHERMAL, HOMOEOTHERMIC, HOMOEOTHERMOUS, HOMOIOTHERMAL, HOMOTHERMAL, HOMOTHERMIC [adj]\n",
  "HOMEOTHERMIC": "keeping the same temperature, warm-blooded, also HOMOIOTHERMIC [adj]\n",
  "HOMEOTHERMIES": "HOMEOTHERMY, the maintenance of a constant body temperature, also HOMEOTHERMISM, HOMOIOTHERMY, HOMOTHERMY [n]\n",
  "HOMEOTHERMISM": "the maintenance of a constant body temperature, also HOMEOTHERMY, HOMOIOTHERMY, HOMOTHERMY [n -S]\n",
  "HOMEOTHERMISMS": "HOMEOTHERMISM, the maintenance of a constant body temperature, also HOMEOTHERMY, HOMOIOTHERMY, HOMOTHERMY [n]\n",
  "HOMEOTHERMOUS": "keeping the same temperature, warm-blooded [adj]\n",
  "HOMEOTHERMS": "HOMEOTHERM, an organism that maintains the same temperature [n]\n",
  "HOMEOTHERMY": "the maintenance of a constant body temperature, also HOMEOTHERMISM, HOMOIOTHERMY, HOMOTHERMY [n HOMEOTHERMIES]\n",
  "HOMEOTIC": "showing, depending on, or characterized by homeosis, also HOMOEOTIC [adj]\n",
  "HOMEOTYPIC": "denoting or relating to the second nuclear division of meiosis, which resembles mitosis, also HOMOEOTYPIC [adj]\n",
  "HOMEOTYPICAL": "denoting or relating to the second nuclear division of meiosis, which resembles mitosis, also HOMOEOTYPICAL [adj]\n",
  "HOMEOWNER": "one who owns a home [n -S]\n",
  "HOMEOWNERS": "HOMEOWNER, one who owns a home [n]\n",
  "HOMEOWNERSHIP": "the fact of being a homeowner [n -S]\n",
  "HOMEOWNERSHIPS": "HOMEOWNERSHIP, the fact of being a homeowner [n]\n",
  "HOMEPAGE": "the main page of a website [n -S]\n",
  "HOMEPAGES": "HOMEPAGE, the main page of a website [n]\n",
  "HOMEPLACE": "a person's home [n -S]\n",
  "HOMEPLACES": "HOMEPLACE, a person's home [n]\n",
  "HOMEPORT": "to assign a ship to a port [v -ED, -ING, -S]\n",
  "HOMEPORTED": "HOMEPORT, to assign a ship to a port [v]\n",
  "HOMEPORTING": "HOMEPORT, to assign a ship to a port [v]\n",
  "HOMEPORTS": "HOMEPORT, to assign a ship to a port [v]\n",
  "HOMER": "to hit a home run [v -ED, -ING, -S]\n",
  "HOMERED": "HOMER, to hit a home run [v]\n",
  "HOMERIC": "grand, imposing [adj]\n",
  "HOMERING": "HOMER, to hit a home run [v]\n",
  "HOMEROOM": "the classroom where pupils gather before class [n -S]\n",
  "HOMEROOMS": "HOMEROOM, the classroom where pupils gather before class [n]\n",
  "HOMERS": "HOMER, to hit a home run [v]\n",
  "HOMES": "HOME, to return to a place of residence [v]\n",
  "HOMESCHOOL": "to teach school subjects to one's children at home [v -ED, -ING, -S]\n",
  "HOMESCHOOLED": "HOMESCHOOL, to teach school subjects to one's children at home [v]\n",
  "HOMESCHOOLER": "one that homeschools [n -S]\n",
  "HOMESCHOOLERS": "HOMESCHOOLER, one that homeschools [n]\n",
  "HOMESCHOOLING": "HOMESCHOOL, to teach school subjects to one's children at home [v]\n",
  "HOMESCHOOLS": "HOMESCHOOL, to teach school subjects to one's children at home [v]\n",
  "HOMESCREETCH": "the mistle thrush [n -ES]\n",
  "HOMESCREETCHES": "HOMESCREETCH, the mistle thrush [n]\n",
  "HOMESHORING": "the transfer of service industry employment from offices to home-based employees with appropriate telephone and Internet facilities, also HOMESOURCING [n -S]\n",
  "HOMESHORINGS": "HOMESHORING, the transfer of service industry employment from offices to home-based employees with appropriate telephone and Internet facilities, also HOMESOURCING [n]\n",
  "HOMESICK": "longing for home [adj]\n",
  "HOMESICKNESS": "the state of being homesick [n -ES]\n",
  "HOMESICKNESSES": "HOMESICKNESS, the state of being homesick [n]\n",
  "HOMESITE": "one's own site on the Internet [n -S]\n",
  "HOMESITES": "HOMESITE, one's own site on the Internet [n]\n",
  "HOMESOURCING": "the transfer of service industry employment from offices to home-based employees with appropriate telephone and Internet facilities, also HOMESHORING [n -S]\n",
  "HOMESOURCINGS": "HOMESOURCING, the transfer of service industry employment from offices to home-based employees with appropriate telephone and Internet facilities, also HOMESHORING [n]\n",
  "HOMESPUN": "cloth made of yarn spun at home; a material resembling this [n -S]\n",
  "HOMESPUNS": "HOMESPUN, cloth made of yarn spun at home; a material resembling this [n]\n",
  "HOMESTALL": "a homestead [n -S]\n",
  "HOMESTALLS": "HOMESTALL, a homestead [n]\n",
  "HOMESTAND": "a series of games played at a team's home ground [n -S]\n",
  "HOMESTANDS": "HOMESTAND, a series of games played at a team's home ground [n]\n",
  "HOMESTAY": "the time during which a foreigner lives with a local family [n -S]\n",
  "HOMESTAYS": "HOMESTAY, the time during which a foreigner lives with a local family [n]\n",
  "HOMESTEAD": "a dwelling-house with outhouses and enclosures immediately connected with it [n -S] / to acquire a homestead [v -ED, -ING, -S]\n",
  "HOMESTEADED": "HOMESTEAD, to acquire a homestead [v]\n",
  "HOMESTEADER": "one who occupies a homestead [n -S]\n",
  "HOMESTEADERS": "HOMESTEADER, one who occupies a homestead [n]\n",
  "HOMESTEADING": "(US) a scheme by which people are permitted to buy, or live rent-free in, semi-derelict buildings and improve them with the help of Government grants, etc. [n -S]\n",
  "HOMESTEADINGS": "HOMESTEADING, (US) a scheme by which people are permitted to buy, or live rent-free in, semi-derelict buildings and improve them with the help of Government grants, etc. [n]\n",
  "HOMESTEADS": "HOMESTEAD, a dwelling-house with outhouses and enclosures immediately connected with it [n]\n",
  "HOMESTRETCH": "the part of a racecourse between the last turn and the winning post [n -ES]\n",
  "HOMESTRETCHES": "HOMESTRETCH, the part of a racecourse between the last turn and the winning post [n]\n",
  "HOMESTYLE": "(especially of food) such as would be made or provided at home [adj]\n",
  "HOMETOWN": "the town of one's birth or residence [n -S]\n",
  "HOMETOWNS": "HOMETOWN, the town of one's birth or residence [n]\n",
  "HOMEWARD": "in the direction of home, also HAMEWITH, HOMEWARDS [adv]\n",
  "HOMEWARDS": "in the direction of home, also HAMEWITH, HOMEWARD [adv]\n",
  "HOMEWARE": "the things that furnish a home [n -S]\n",
  "HOMEWARES": "HOMEWARE, the things that furnish a home [n]\n",
  "HOMEWORK": "work done at home [n -S]\n",
  "HOMEWORKER": "a worker who works from home [n -S]\n",
  "HOMEWORKERS": "HOMEWORKER, a worker who works from home [n]\n",
  "HOMEWORKING": "working from home [n -S]\n",
  "HOMEWORKINGS": "HOMEWORKING, working from home [n]\n",
  "HOMEWORKS": "HOMEWORK, work done at home [n]\n",
  "HOMEY": "home-loving [adj HOMIER, HOMIEST] / (colloquial) a member of a youth gang, also HOMEBOY, HOMIE [n -S]\n",
  "HOMEYNESS": "being homey, also HOMINESS [n -ES]\n",
  "HOMEYNESSES": "HOMEYNESS, being homey, also HOMINESS [n]\n",
  "HOMEYS": "HOMEY, (colloquial) a member of a youth gang, also HOMEBOY, HOMIE [n]\n",
  "HOMICIDAL": "related to homicide [adj HOMICIDALLY]\n",
  "HOMICIDALLY": "HOMICIDAL, related to homicide [adv]\n",
  "HOMICIDE": "the killing of one person by another [n -S]\n",
  "HOMICIDES": "HOMICIDE, the killing of one person by another [n]\n",
  "HOMIE": "a member of a youth gang, also HOMEY, HOMEBOY [n -S]\n",
  "HOMIER": "HOMY, homelike, also HOMEY [adj]\n",
  "HOMIES": "HOMIE, a member of a youth gang, also HOMEY, HOMEBOY [n]\n",
  "HOMIEST": "HOMY, homelike, also HOMEY [adj]\n",
  "HOMILETIC": "relating to homily or the art of preaching, also HOMILETICAL [adj HOMILETICALLY]\n",
  "HOMILETICAL": "relating to homily or the art of preaching, also HOMILETIC [adj HOMILETICALLY]\n",
  "HOMILETICALLY": "HOMILETICAL, relating to homily or the art of preaching, also HOMILETIC [adv]\n",
  "HOMILETICS": "the art of preaching [n]\n",
  "HOMILIES": "HOMILY, a sermon [n]\n",
  "HOMILIST": "one who delivers a sermon [n -S]\n",
  "HOMILISTS": "HOMILIST, one who delivers a sermon [n]\n",
  "HOMILY": "a sermon [n HOMILIES]\n",
  "HOMINES": "HOMO, (Latin) man generically [n]\n",
  "HOMINESS": "the quality of being homey [n -ES]\n",
  "HOMINESSES": "HOMINESS, the quality of being homey [n]\n",
  "HOMING": "the way missiles guide themselves to a target [n -S]\n",
  "HOMINGS": "HOMING, the way missiles guide themselves to a target [n]\n",
  "HOMINIAN": "a manlike creature, also HOMINID [n -S]\n",
  "HOMINIANS": "HOMINIAN, a manlike creature, also HOMINID [n]\n",
  "HOMINID": "a manlike creature, also HOMINIAN [n -S]\n",
  "HOMINIDS": "HOMINID, a manlike creature, also HOMINIAN [n]\n",
  "HOMINIES": "HOMINY, hulled, dry corn [n]\n",
  "HOMININ": "any member of the taxonomic tribe Hominini, usually taken to comprise humans and their direct ancestors, but sometimes taken also to include chimpanzees [n -S]\n",
  "HOMININE": "characteristic of man [adj]\n",
  "HOMININS": "HOMININ, any member of the taxonomic tribe Hominini, usually taken to comprise humans and their direct ancestors, but sometimes taken also to include chimpanzees [n]\n",
  "HOMINISATION": "the evolutionary development of human characteristics that differentiate hominids from their primate ancestors, also HOMINIZATION [n -S]\n",
  "HOMINISATIONS": "HOMINISATION, the evolutionary development of human characteristics that differentiate hominids from their primate ancestors, also HOMINIZATION [n]\n",
  "HOMINISE": "to alter the environment to conform with evolving man, also HOMINIZE [v HOMINISED, HOMINISING, HOMINISES]\n",
  "HOMINISED": "HOMINISE, to alter the environment to conform with evolving man, also HOMINIZE [v]\n",
  "HOMINISES": "HOMINISE, to alter the environment to conform with evolving man, also HOMINIZE [v]\n",
  "HOMINISING": "HOMINISE, to alter the environment to conform with evolving man, also HOMINIZE [v]\n",
  "HOMINIZATION": "the evolutionary development of human characteristics that differentiate hominids from their primate ancestors, also HOMINISATION [n -S]\n",
  "HOMINIZATIONS": "HOMINIZATION, the evolutionary development of human characteristics that differentiate hominids from their primate ancestors, also HOMINISATION [n]\n",
  "HOMINIZE": "to alter the environment to conform with evolving man, also HOMINISE [v HOMINIZED, HOMINIZING, HOMINIZES]\n",
  "HOMINIZED": "HOMINIZE, to alter the environment to conform with evolving man, also HOMINISE [v]\n",
  "HOMINIZES": "HOMINIZE, to alter the environment to conform with evolving man, also HOMINISE [v]\n",
  "HOMINIZING": "HOMINIZE, to alter the environment to conform with evolving man, also HOMINISE [v]\n",
  "HOMINOID": "a member of the superfamily Hominoidea, comprising man and modern apes and their extinct ancestors, also HOMINIAN [n -S]\n",
  "HOMINOIDS": "HOMINOID, a member of the superfamily Hominoidea, comprising man and modern apes and their extinct ancestors, also HOMINIAN [n]\n",
  "HOMINY": "hulled, dry corn [n HOMINIES]\n",
  "HOMME": "(French) a man [n -S]\n",
  "HOMMES": "HOMME, (French) a man [n]\n",
  "HOMMOCK": "(archaic) a ridge in an ice field, also HUMMOCK [n -S]\n",
  "HOMMOCKS": "HOMMOCK, (archaic) a ridge in an ice field, also HUMMOCK [n]\n",
  "HOMMOS": "(Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOUMMOS, HOUMOUS, HOUMUS, HUMMUS, HUMOUSES [n -ES]\n",
  "HOMMOSES": "HOMMOS, (Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOUMMOS, HOUMOUS, HOUMUS, HUMMUS, HUMOUSES [n]\n",
  "HOMO": "(Latin) man generically [n HOMINES] / (slang) a homosexual [n -S]\n",
  "HOMOBLASTIC": "derived from similar cells; showing direct embryonic development [adj]\n",
  "HOMOBLASTIES": "HOMOBLASTY, the state of being homoblastic, derived from similar cells [n]\n",
  "HOMOBLASTY": "the state of being homoblastic, derived from similar cells [n HOMOBLASTIES]\n",
  "HOMOCENTRIC": "having the same central or focal point [adj HOMOCENTRICALLY]\n",
  "HOMOCENTRICALLY": "HOMOCENTRIC, having the same central or focal point [adv]\n",
  "HOMOCERCAL": "of fishes, having the upper and lower lobes of the tailfin alike [adj]\n",
  "HOMOCERCIES": "HOMOCERCY, the condition in fish of having a symmetrical tail [n]\n",
  "HOMOCERCY": "the condition in fish of having a symmetrical tail [n HOMOCERCIES]\n",
  "HOMOCHLAMYDEOUS": "with calyx and corolla similar [adj]\n",
  "HOMOCHROMATIC": "monochromatic [adj]\n",
  "HOMOCHROMATISM": "the state of being homochromatic [n -S]\n",
  "HOMOCHROMATISMS": "HOMOCHROMATISM, the state of being homochromatic [n]\n",
  "HOMOCHROMIES": "HOMOCHROMY, protective coloration [n]\n",
  "HOMOCHROMOUS": "monochromatic [adj]\n",
  "HOMOCHROMY": "protective coloration [n HOMOCHROMIES]\n",
  "HOMOCYCLIC": "having a closed chain of similar atoms [adj]\n",
  "HOMOCYSTEINE": "a kind of amino acid [n -S]\n",
  "HOMOCYSTEINES": "HOMOCYSTEINE, a kind of amino acid [n]\n",
  "HOMODONT": "having teeth all alike [adj]\n",
  "HOMODYNE": "describing a boosted radio reception [adj]\n",
  "HOMOEOBOX": "of genes, that regulate the development of multicellular animals and plants, also HOMEOBOX [adj]\n",
  "HOMOEOMERIC": "having all the somites alike, also HOMEOMERIC, HOMEOMEROUS, HOMOEOMEROUS, HOMOIOMEROUS [adj]\n",
  "HOMOEOMERIES": "HOMOEOMERY, the state of being homoeomeric, having all the somites alike, also HOMEOMERY [n]\n",
  "HOMOEOMEROUS": "having all the somites alike, also HOMEOMERIC, HOMEOMEROUS, HOMOEOMERIC, HOMOIOMEROUS [adj]\n",
  "HOMOEOMERY": "the state of being homoeomeric, having all the somites alike, also HOMEOMERY [n HOMOEOMERIES]\n",
  "HOMOEOMORPH": "a thing similar in form from another but essentially different, also HOMEOMORPH [n -S]\n",
  "HOMOEOMORPHIC": "of two geometrical figures, such that one can be converted into the other by distortion [adj]\n",
  "HOMOEOMORPHIES": "HOMOEOMORPHY, the state of being homoeomorphy [n]\n",
  "HOMOEOMORPHISM": "the state of being homoeomorphic [n -S]\n",
  "HOMOEOMORPHISMS": "HOMOEOMORPHISM, the state of being homoeomorphic [n]\n",
  "HOMOEOMORPHOUS": "of two geometrical figures, such that one can be converted into the other by distortion [adj]\n",
  "HOMOEOMORPHS": "HOMOEOMORPH, a thing similar in form from another but essentially different, also HOMEOMORPH [n]\n",
  "HOMOEOMORPHY": "the state of being homoeomorphy [n HOMOEOMORPHIES]\n",
  "HOMOEOPATH": "a person who believes in or practises homoeopathy, also HOMEOPATH, HOMEOPATHIST, HOMOEOPATHIST [n -S]\n",
  "HOMOEOPATHIC": "related to homoeopathy, also HOMEOPATHIC [adj]\n",
  "HOMOEOPATHIES": "HOMOEOPATHY, the use of minute quantities of medications that in large amounts, produce symptoms like those of the disease being treated, also HOMEOPATHY [n]\n",
  "HOMOEOPATHIST": "one who practises homoeopathy, also HOMEOPATH, HOMEOPATHIST, HOMOEOPATH [n -S]\n",
  "HOMOEOPATHISTS": "HOMOEOPATHIST, one who practises homoeopathy, also HOMEOPATH, HOMEOPATHIST, HOMOEOPATH [n]\n",
  "HOMOEOPATHS": "HOMOEOPATH, a person who believes in or practises homoeopathy, also HOMEOPATH, HOMEOPATHIST, HOMOEOPATHIST [n]\n",
  "HOMOEOPATHY": "the use of minute quantities of medications that in large amounts, produce symptoms like those of the disease being treated, also HOMEOPATHY [n HOMOEOPATHIES]\n",
  "HOMOEOSES": "HOMOEOSIS, the assumption of the character of a corresponding member of another whorl or somite, also HOMEOSIS [n]\n",
  "HOMOEOSIS": "the assumption of the character of a corresponding member of another whorl or somite, also HOMEOSIS [n HOMOEOSES]\n",
  "HOMOEOSTASES": "HOMOEOSTASIS, a tendency towards health or stable physical conditions, also HOMEOSTASIS [n]\n",
  "HOMOEOSTASIS": "a tendency towards health or stable physical conditions, also HOMEOSTASIS [n HOMOEOSTASES]\n",
  "HOMOEOSTATIC": "relating to homoeostasis [adj]\n",
  "HOMOEOTELEUTON": "the use of words with similar endings in close proximity, also HOMEOTELEUTON [n -S]\n",
  "HOMOEOTELEUTONS": "HOMOEOTELEUTON, the use of words with similar endings in close proximity, also HOMEOTELEUTON [n]\n",
  "HOMOEOTHERM": "an animal or organism that keeps its body at an almost constant temperature, also HOMEOTHERM, HOMOIOTHERM [n -S]\n",
  "HOMOEOTHERMAL": "keeping the same temperature, warm-blooded, also HOMEOTHERMAL, HOMOEOTHERMIC, HOMOEOTHERMOUS, HOMOIOTHERMAL, HOMOTHERMAL, HOMOTHERMIC [adj]\n",
  "HOMOEOTHERMIC": "keeping the same temperature, warm-blooded, also HOMEOTHERMAL, HOMOEOTHERMAL, HOMOEOTHERMOUS, HOMOIOTHERMAL, HOMOTHERMAL, HOMOTHERMIC [adj]\n",
  "HOMOEOTHERMOUS": "keeping the same temperature, warm-blooded, also HOMEOTHERMAL, HOMOEOTHERMAL, HOMOEOTHERMIC, HOMOIOTHERMAL, HOMOTHERMAL, HOMOTHERMIC [adj]\n",
  "HOMOEOTHERMS": "HOMOEOTHERM, an animal or organism that keeps its body at an almost constant temperature, also HOMEOTHERM, HOMOIOTHERM [n]\n",
  "HOMOEOTIC": "showing, depending on, or characterized by homeosis, also HOMEOTIC [adj]\n",
  "HOMOEOTYPIC": "denoting or relating to the second nuclear division of meiosis, which resembles mitosis, also HOMEOTYPIC [adj]\n",
  "HOMOEOTYPICAL": "denoting or relating to the second nuclear division of meiosis, which resembles mitosis, also HOMEOTYPICAL [adj]\n",
  "HOMOEROTIC": "loving one of the same sex [adj]\n",
  "HOMOEROTICISM": "homosexuality, also HOMOEROTISM [n -S]\n",
  "HOMOEROTICISMS": "HOMOEROTICISM, homosexuality, also HOMOEROTISM [n]\n",
  "HOMOEROTISM": "homosexuality, also HOMOEROTICISM [n -S]\n",
  "HOMOEROTISMS": "HOMOEROTISM, homosexuality, also HOMOEROTICISM [n]\n",
  "HOMOGAMETIC": "forming gametes which all have the same type of sex chromosome [adj]\n",
  "HOMOGAMIC": "breeding like with like, inbreeding [adj]\n",
  "HOMOGAMIES": "HOMOGAMY, breeding of like with like [n]\n",
  "HOMOGAMOUS": "of a flower, having the anthers and stigmas maturing together, so as to permit self-fertilization [adj]\n",
  "HOMOGAMY": "breeding of like with like [n HOMOGAMIES]\n",
  "HOMOGENATE": "a substance produced by homogenization [n -S]\n",
  "HOMOGENATES": "HOMOGENATE, a substance produced by homogenization [n]\n",
  "HOMOGENEITIES": "HOMOGENEITY, the state of being homogeneous [n]\n",
  "HOMOGENEITY": "the state of being homogeneous [n HOMOGENEITIES]\n",
  "HOMOGENEOUS": "of a uniform consistency [adj HOMOGENEOUSLY]\n",
  "HOMOGENEOUSLY": "HOMOGENEOUS, of a uniform consistency [adv]\n",
  "HOMOGENEOUSNESS": "the state of being homogeneous [n]\n",
  "HOMOGENESES": "HOMOGENESIS, a mode of reproduction in which the offspring is like the parent, and passes through the same cycle of existence [n]\n",
  "HOMOGENESIS": "a mode of reproduction in which the offspring is like the parent, and passes through the same cycle of existence [n HOMOGENESES]\n",
  "HOMOGENETIC": "homogeneous, also HOMOGENETICAL [adj]\n",
  "HOMOGENETICAL": "homogeneous, also HOMOGENETIC [adj]\n",
  "HOMOGENIES": "HOMOGENY, similarity due to origin [n]\n",
  "HOMOGENISATION": "the act of homogenising, also HOMOGENIZATION [n -S]\n",
  "HOMOGENISATIONS": "HOMOGENISATION, the act of homogenising, also HOMOGENIZATION [n]\n",
  "HOMOGENISE": "to make homogeneous, also HOMOGENIZE [v HOMOGENISED, HOMOGENISING, HOMOGENISES]\n",
  "HOMOGENISED": "HOMOGENISE, to make homogeneous, also HOMOGENIZE [v]\n",
  "HOMOGENISER": "an agent that homogenises, also HOMOGENIZER [n -S]\n",
  "HOMOGENISERS": "HOMOGENISER, an agent that homogenises, also HOMOGENIZER [n]\n",
  "HOMOGENISES": "HOMOGENISE, to make homogeneous, also HOMOGENIZE [v]\n",
  "HOMOGENISING": "HOMOGENISE, to make homogeneous, also HOMOGENIZE [v]\n",
  "HOMOGENIZATION": "the act of homogenizing, also HOMOGENISATION [n -S]\n",
  "HOMOGENIZATIONS": "HOMOGENIZATION, the act of homogenizing, also HOMOGENISATION [n]\n",
  "HOMOGENIZE": "to make homogeneous, also HOMOGENISE [v HOMOGENIZED, HOMOGENIZING, HOMOGENIZES]\n",
  "HOMOGENIZED": "HOMOGENIZE, to make homogeneous, also HOMOGENISE [v]\n",
  "HOMOGENIZER": "an agent that homogenizes, also HOMOGENISER [n -S]\n",
  "HOMOGENIZERS": "HOMOGENIZER, an agent that homogenizes, also HOMOGENISER [n]\n",
  "HOMOGENIZES": "HOMOGENIZE, to make homogeneous, also HOMOGENISE [v]\n",
  "HOMOGENIZING": "HOMOGENIZE, to make homogeneous, also HOMOGENISE [v]\n",
  "HOMOGENOUS": "having a resemblance in structure, due to descent from a common progenitor with subsequent modification [adj]\n",
  "HOMOGENY": "similarity due to origin [n HOMOGENIES]\n",
  "HOMOGONIES": "HOMOGONY, the condition of having flowers with uniform stamens and pistils [n]\n",
  "HOMOGONOUS": "exhibiting homogony, the condition of having flowers of equal size [adj HOMOGONOUSLY]\n",
  "HOMOGONOUSLY": "HOMOGONOUS, exhibiting homogony, the condition of having flowers of equal size [adv]\n",
  "HOMOGONY": "the condition of having flowers with uniform stamens and pistils [n HOMOGONIES]\n",
  "HOMOGRAFT": "a graft from one individual to another unrelated individual of the same species [n -S]\n",
  "HOMOGRAFTS": "HOMOGRAFT, a graft from one individual to another unrelated individual of the same species [n]\n",
  "HOMOGRAPH": "one of two or more words that have the same spelling but differ in origin, meaning, and sometimes pronunciation e.g. bow (in hair) and bow (of a ship) [n -S]\n",
  "HOMOGRAPHIC": "having a different symbol for each sound [adj]\n",
  "HOMOGRAPHIES": "HOMOGRAPHY, a type of transformation that maps straight lines onto another plane [n]\n",
  "HOMOGRAPHS": "HOMOGRAPH, one of two or more words that have the same spelling but differ in origin, meaning, and sometimes pronunciation e.g. bow (in hair) and bow (of a ship) [n]\n",
  "HOMOGRAPHY": "a type of transformation that maps straight lines onto another plane [n HOMOGRAPHIES]\n",
  "HOMOIOMEROUS": "having all the somites alike, also HOMEOMERIC, HOMEOMEROUS, HOMOEOMERIC, HOMOEOMEROUS [adj]\n",
  "HOMOIOTHERM": "a warm-blooded animal, also HOMEOTHERM, HOMOEOTHERM [n -S]\n",
  "HOMOIOTHERMAL": "keeping the same temperature, warm-blooded, also HOMEOTHERMAL, HOMOEOTHERMAL, HOMOEOTHERMIC, HOMOEOTHERMOUS, HOMOTHERMAL, HOMOTHERMIC [adj]\n",
  "HOMOIOTHERMIC": "keeping the same temperature, warm-blooded, also HOMEOTHERMIC, HOMOEOTHERMIC [adj]\n",
  "HOMOIOTHERMIES": "HOMOIOTHERMY, the maintenance of a constant body temperature, also HOMEOTHERMISM, HOMEOTHERMY, HOMOTHERMY [n]\n",
  "HOMOIOTHERMS": "HOMOIOTHERM, a warm-blooded animal, also HOMEOTHERM, HOMOEOTHERM [n]\n",
  "HOMOIOTHERMY": "the maintenance of a constant body temperature, also HOMEOTHERMISM, HOMEOTHERMY, HOMOTHERMY [n HOMOIOTHERMIES]\n",
  "HOMOIOUSIAN": "one of those, in the 4th century maintained that the Son had a like but not the same essence or substance with the Father [n -S]\n",
  "HOMOIOUSIANS": "HOMOIOUSIAN, one of those, in the 4th century maintained that the Son had a like but not the same essence or substance with the Father [n]\n",
  "HOMOLOG": "anything that is homologous to something else [n -S]\n",
  "HOMOLOGATE": "to sanction, allow esp. officially [v HOMOLOGATED, HOMOLOGATING, HOMOLOGATES]\n",
  "HOMOLOGATED": "HOMOLOGATE, to sanction, allow esp. officially [v]\n",
  "HOMOLOGATES": "HOMOLOGATE, to sanction, allow esp. officially [v]\n",
  "HOMOLOGATING": "HOMOLOGATE, to sanction, allow esp. officially [v]\n",
  "HOMOLOGATION": "confirmation, agreement [n -S]\n",
  "HOMOLOGATIONS": "HOMOLOGATION, confirmation, agreement [n]\n",
  "HOMOLOGIC": "relating to homology [adj HOMOLOGICALLY]\n",
  "HOMOLOGICAL": "having the same relative structure, also HOMOLOGOUS [adj HOMOLOGICALLY]\n",
  "HOMOLOGICALLY": "HOMOLOGICAL, having the same relative structure, also HOMOLOGOUS [adv]\n",
  "HOMOLOGIES": "HOMOLOGY, similarity in structure and origin [n]\n",
  "HOMOLOGISE": "to determine the homologies or structural relations of, also HOMOLOGIZE [v HOMOLOGISED, HOMOLOGISING, HOMOLOGISES]\n",
  "HOMOLOGISED": "HOMOLOGISE, to determine the homologies or structural relations of, also HOMOLOGIZE [v]\n",
  "HOMOLOGISER": "one who homologises, also HOMOLOGIZER [n -S]\n",
  "HOMOLOGISERS": "HOMOLOGISER, one who homologises, also HOMOLOGIZER [n]\n",
  "HOMOLOGISES": "HOMOLOGISE, to determine the homologies or structural relations of, also HOMOLOGIZE [v]\n",
  "HOMOLOGISING": "HOMOLOGISE, to determine the homologies or structural relations of, also HOMOLOGIZE [v]\n",
  "HOMOLOGIZE": "to determine the homologies or structural relations of, also HOMOLOGISE [v HOMOLOGIZED, HOMOLOGIZING, HOMOLOGIZES]\n",
  "HOMOLOGIZED": "HOMOLOGIZE, to determine the homologies or structural relations of, also HOMOLOGISE [v]\n",
  "HOMOLOGIZER": "one who homologizes, also HOMOLOGISER [n -S]\n",
  "HOMOLOGIZERS": "HOMOLOGIZER, one who homologizes, also HOMOLOGISER [n]\n",
  "HOMOLOGIZES": "HOMOLOGIZE, to determine the homologies or structural relations of, also HOMOLOGISE [v]\n",
  "HOMOLOGIZING": "HOMOLOGIZE, to determine the homologies or structural relations of, also HOMOLOGISE [v]\n",
  "HOMOLOGOUMENA": "the books of the New Testament whose authenticity was universally acknowledged in the early Church, also HOMOLOGUMENA [n]\n",
  "HOMOLOGOUS": "having the same relative structure, also HOMOLOGICAL [adj]\n",
  "HOMOLOGRAPHIC": "of a map projection, showing area accurately and therefore distorting shape and direction, also HOMALOGRAPHIC [adj]\n",
  "HOMOLOGS": "HOMOLOG, anything that is homologous to something else [n]\n",
  "HOMOLOGUE": "a thing exactly or relatively corresponding in structure [n -S]\n",
  "HOMOLOGUES": "HOMOLOGUE, a thing exactly or relatively corresponding in structure [n]\n",
  "HOMOLOGUMENA": "the books of the New Testament whose authenticity was universally acknowledged in the early Church, also HOMOLOGOUMENA [n]\n",
  "HOMOLOGY": "similarity in structure and origin [n HOMOLOGIES]\n",
  "HOMOLOSINE": "as in homolosine projection, an equal-area projection map of the globe [adj]\n",
  "HOMOLYSES": "HOMOLYSIS, decomposition into two uncharged atoms or radicals [n]\n",
  "HOMOLYSIS": "decomposition into two uncharged atoms or radicals [n HOMOLYSES]\n",
  "HOMOLYTIC": "decomposing into two uncharged atoms or radicals [adj]\n",
  "HOMOMORPH": "a thing having the same form as another [n -S]\n",
  "HOMOMORPHIC": "relating to homomorphism [adj]\n",
  "HOMOMORPHIES": "HOMOMORPHY, similarity in form, as of the flowers of a plant, also HOMEOMORPHY [n]\n",
  "HOMOMORPHISM": "similarity of external form, appearance, or size [n -S]\n",
  "HOMOMORPHISMS": "HOMOMORPHISM, similarity of external form, appearance, or size [n]\n",
  "HOMOMORPHOSES": "HOMOMORPHOSIS, regeneration of a lost part in the original form [n]\n",
  "HOMOMORPHOSIS": "regeneration of a lost part in the original form [n HOMOMORPHOSES]\n",
  "HOMOMORPHOUS": "alike in form, esp. if essentially different otherwise [adj]\n",
  "HOMOMORPHS": "HOMOMORPH, a thing having the same form as another [n]\n",
  "HOMOMORPHY": "similarity in form, as of the flowers of a plant, also HOMEOMORPHY [n HOMOMORPHIES]\n",
  "HOMONUCLEAR": "of or relating to a molecule composed of identical nuclei [adj]\n",
  "HOMONYM": "a word similar in structure to another [n -S]\n",
  "HOMONYMIC": "relating to homonyms, words having the same sound but different meanings [adj]\n",
  "HOMONYMIES": "HOMONYMY, the state of being a homonym [n]\n",
  "HOMONYMITIES": "HOMONYMITY, the state of being homonymous, having the same name or designation [n]\n",
  "HOMONYMITY": "the state of being homonymous, having the same name or designation [n HOMONYMITIES]\n",
  "HOMONYMOUS": "of the nature of homonyms, said of words identical in sound but different in sense [adj HOMONYMOUSLY]\n",
  "HOMONYMOUSLY": "HOMONYMOUS, of the nature of homonyms, said of words identical in sound but different in sense [adv]\n",
  "HOMONYMS": "HOMONYM, a word similar in structure to another [n]\n",
  "HOMONYMY": "the state of being a homonym [n HOMONYMIES]\n",
  "HOMOOUSIAN": "one of those, in the 4th century, who accepted the Nicene creed, and maintained that the Son had the same essence or substance with the Father [n -S]\n",
  "HOMOOUSIANS": "HOMOOUSIAN, one of those, in the 4th century, who accepted the Nicene creed, and maintained that the Son had the same essence or substance with the Father [n]\n",
  "HOMOPHILE": "a homosexual [n -S]\n",
  "HOMOPHILES": "HOMOPHILE, a homosexual [n]\n",
  "HOMOPHOBE": "one who dislikes homosexuals [n -S]\n",
  "HOMOPHOBES": "HOMOPHOBE, one who dislikes homosexuals [n]\n",
  "HOMOPHOBIA": "fear of homosexuals [n -S]\n",
  "HOMOPHOBIAS": "HOMOPHOBIA, fear of homosexuals [n]\n",
  "HOMOPHOBIC": "having a morbid fear of homosexuals [adj]\n",
  "HOMOPHONE": "a word that sounds the same as another but is spelt differently e.g. 'to', 'too' and 'two' [n -S]\n",
  "HOMOPHONES": "HOMOPHONE, a word that sounds the same as another but is spelt differently e.g. 'to', 'too' and 'two' [n]\n",
  "HOMOPHONIC": "in a single melodic line with accompaniment [adj HOMOPHONICALLY]\n",
  "HOMOPHONICALLY": "HOMOPHONIC, in a single melodic line with accompaniment [adv]\n",
  "HOMOPHONIES": "HOMOPHONY, sameness of sound [n]\n",
  "HOMOPHONOUS": "exhibiting homophonous, sameness of sound [adj]\n",
  "HOMOPHONY": "sameness of sound [n HOMOPHONIES]\n",
  "HOMOPHYLIES": "HOMOPHYLY, resemblance due to common ancestry [n]\n",
  "HOMOPHYLLIC": "exhibiting homophyly, resemblance due to common ancestry [adj]\n",
  "HOMOPHYLY": "resemblance due to common ancestry [n HOMOPHYLIES]\n",
  "HOMOPLASIES": "HOMOPLASY, the quality or fact of being homoplastic, also HOMOPLASTY [n]\n",
  "HOMOPLASMIES": "HOMOPLASMY, the quality or fact of being homoplastic [n]\n",
  "HOMOPLASMY": "the quality or fact of being homoplastic [n HOMOPLASMIES]\n",
  "HOMOPLASTIC": "similar in structure and development but not descended from a recent common source [adj HOMOPLASTICALLY]\n",
  "HOMOPLASTICALLY": "HOMOPLASTIC, similar in structure and development but not descended from a recent common source [adv]\n",
  "HOMOPLASTIES": "HOMOPLASTY, the quality or fact of being homoplastic, also HOMOPLASY [n]\n",
  "HOMOPLASTY": "the quality or fact of being homoplastic, also HOMOPLASY [n HOMOPLASTIES]\n",
  "HOMOPLASY": "the quality or fact of being homoplastic, also HOMOPLASTY [n HOMOPLASIES]\n",
  "HOMOPOLAR": "having an equal distribution of charge, as in a covalent bond [adj]\n",
  "HOMOPOLARITIES": "HOMOPOLARITY, the state of being homopolar [n]\n",
  "HOMOPOLARITY": "the state of being homopolar [n HOMOPOLARITIES]\n",
  "HOMOPOLYMER": "a DNA or RNA strand whose nucleotides are all of the same kind [n -S]\n",
  "HOMOPOLYMERIC": "of or like a homopolymer [adj]\n",
  "HOMOPOLYMERS": "HOMOPOLYMER, a DNA or RNA strand whose nucleotides are all of the same kind [n]\n",
  "HOMOPTERAN": "a member of the Homoptera, cicadas, froghoppers etc. [n -S]\n",
  "HOMOPTERANS": "HOMOPTERAN, a member of the Homoptera, cicadas, froghoppers etc. [n]\n",
  "HOMOPTEROUS": "relating to the Homoptera, aphids, cicadas, and scale insects [adj]\n",
  "HOMORGANIC": "of a consonant, articulated at the same point in the vocal tract as a consonant in a different class [adj]\n",
  "HOMOS": "HOMO, (Latin) man generically [n]\n",
  "HOMOSCEDASTIC": "of equal scatter or variation; having equal variances [adj]\n",
  "HOMOSEX": "(short for) homosexuality [n -ES]\n",
  "HOMOSEXES": "HOMOSEX, (short for) homosexuality [n]\n",
  "HOMOSEXUAL": "attracted to the same sex [adj HOMOSEXUALLY] / a homosexual person and esp. a male [n -S]\n",
  "HOMOSEXUALISM": "being homosexual [n -S]\n",
  "HOMOSEXUALISMS": "HOMOSEXUALISM, being homosexual [n]\n",
  "HOMOSEXUALIST": "a homosexual [n -S]\n",
  "HOMOSEXUALISTS": "HOMOSEXUALIST, a homosexual [n]\n",
  "HOMOSEXUALITIES": "HOMOSEXUALITY, the state of being homosexual [n]\n",
  "HOMOSEXUALITY": "the state of being homosexual [n HOMOSEXUALITIES]\n",
  "HOMOSEXUALLY": "HOMOSEXUAL, attracted to the same sex [adv]\n",
  "HOMOSEXUALS": "HOMOSEXUAL, a homosexual person and esp. a male [n]\n",
  "HOMOSOCIAL": "of, relating to, or involving social relationships between persons of the same sex and esp. between men [adj]\n",
  "HOMOSOCIALITIES": "HOMOSOCIALITY, the state of being homosocial [n]\n",
  "HOMOSOCIALITY": "the state of being homosocial [n HOMOSOCIALITIES]\n",
  "HOMOSPORIES": "HOMOSPORY, having spores all of one kind [n]\n",
  "HOMOSPOROUS": "producing only one size or kind of spore, as opposed to heterosporous [adj]\n",
  "HOMOSPORY": "having spores all of one kind [n HOMOSPORIES]\n",
  "HOMOSTYLIES": "HOMOSTYLY, in flowers, the existence of styles of only one length [n]\n",
  "HOMOSTYLY": "in flowers, the existence of styles of only one length [n HOMOSTYLIES]\n",
  "HOMOTAXES": "HOMOTAXIS, coincidence in order of organic succession but not necessarily in time [n]\n",
  "HOMOTAXIAL": "showing homotaxis, also HOMOTAXIC [adj HOMOTAXIALLY]\n",
  "HOMOTAXIALLY": "HOMOTAXIAL, showing homotaxis, also HOMOTAXIC [adv]\n",
  "HOMOTAXIC": "showing homotaxis, also HOMOTAXIAL [adj]\n",
  "HOMOTAXIS": "coincidence in order of organic succession but not necessarily in time [n HOMOTAXES]\n",
  "HOMOTHALLIC": "male and female organs in the same thallus [adj]\n",
  "HOMOTHALLIES": "HOMOTHALLY, the state of having only one type of mycelium, also HOMOTHALLISM [n]\n",
  "HOMOTHALLISM": "the state of having only one type of mycelium, also HOMOTHALLY [n -S]\n",
  "HOMOTHALLISMS": "HOMOTHALLISM, the state of having only one type of mycelium, also HOMOTHALLY [n]\n",
  "HOMOTHALLY": "the state of having only one type of mycelium, also HOMOTHALLISM [n HOMOTHALLIES]\n",
  "HOMOTHERMAL": "keeping the same temperature, warm-blooded, also HOMEOTHERMAL, HOMOEOTHERMAL, HOMOEOTHERMIC, HOMOEOTHERMOUS, HOMOIOTHERMAL, HOMOTHERMIC [adj]\n",
  "HOMOTHERMIC": "keeping the same temperature, warm-blooded, also HOMEOTHERMAL, HOMOEOTHERMAL, HOMOEOTHERMIC, HOMOEOTHERMOUS, HOMOIOTHERMAL, HOMOTHERMAL [adj]\n",
  "HOMOTHERMIES": "HOMOTHERMY, the maintenance of a constant body temperature, also HOMEOTHERMISM, HOMEOTHERMY, HOMOIOTHERMY [n]\n",
  "HOMOTHERMOUS": "keeping the same temperature, warm-blooded [adj]\n",
  "HOMOTHERMY": "the maintenance of a constant body temperature, also HOMEOTHERMISM, HOMEOTHERMY, HOMOIOTHERMY [n HOMOTHERMIES]\n",
  "HOMOTONIC": "of the same tenor or tone, also HOMOTONOUS [adj]\n",
  "HOMOTONIES": "HOMOTONY, harmony of tone [n]\n",
  "HOMOTONOUS": "of the same tenor or tone, also HOMOTONIC [adj]\n",
  "HOMOTONY": "harmony of tone [n HOMOTONIES]\n",
  "HOMOTRANSPLANT": "a graft of tissue from one individual to another of the same species [n -S]\n",
  "HOMOTRANSPLANTS": "HOMOTRANSPLANT, a graft of tissue from one individual to another of the same species [n]\n",
  "HOMOTYPAL": "of the same type of structure; pertaining to a homotype; as, homotypal parts [adj]\n",
  "HOMOTYPE": "something with the same basic structure as another [n -S]\n",
  "HOMOTYPES": "HOMOTYPE, something with the same basic structure as another [n]\n",
  "HOMOTYPIC": "conforming to normal type [adj]\n",
  "HOMOTYPIES": "HOMOTYPY, the relation of homotypes [n]\n",
  "HOMOTYPY": "the relation of homotypes [n HOMOTYPIES]\n",
  "HOMOUSIAN": "one who believes God the Son to be the same as God the Father [n -S]\n",
  "HOMOUSIANS": "HOMOUSIAN, one who believes God the Son to be the same as God the Father [n]\n",
  "HOMOZYGOSES": "HOMOZYGOSIS, the condition of being a homozygote [n]\n",
  "HOMOZYGOSIS": "the condition of being a homozygote [n HOMOZYGOSES]\n",
  "HOMOZYGOSITIES": "HOMOZYGOSITY, the state of being homozygous, inheriting a given genetic factor from both parents [n]\n",
  "HOMOZYGOSITY": "the state of being homozygous, inheriting a given genetic factor from both parents [n HOMOZYGOSITIES]\n",
  "HOMOZYGOTE": "an organism or cell having the same alleles for a particular inherited characteristic [n -S]\n",
  "HOMOZYGOTES": "HOMOZYGOTE, an organism or cell having the same alleles for a particular inherited characteristic [n]\n",
  "HOMOZYGOTIC": "relating to a homozygote [adj]\n",
  "HOMOZYGOUS": "inheriting a given genetic factor from both parents [adj HOMOZYGOUSLY]\n",
  "HOMOZYGOUSLY": "HOMOZYGOUS, inheriting a given genetic factor from both parents [adv]\n",
  "HOMS": "HOM, (Persian) a sacred plant of the ancient Persians, also HAOMA, HOMA [n]\n",
  "HOMUNCLE": "a little man, a manikin, also HOMUNCULE, HOMUNCULUS [n -S]\n",
  "HOMUNCLES": "HOMUNCLE, a little man, a manikin, also HOMUNCULE, HOMUNCULUS [n]\n",
  "HOMUNCULAR": "of or like a homunculus [adj]\n",
  "HOMUNCULE": "a little man; a manikin, also HOMUNCLE, HOMUNCULUS [n -S]\n",
  "HOMUNCULES": "HOMUNCULE, a little man; a manikin, also HOMUNCLE, HOMUNCULUS [n]\n",
  "HOMUNCULI": "HOMUNCULUS, a little man; a manikin, also HOMUNCLE, HOMUNCULE [n]\n",
  "HOMUNCULUS": "a little man; a manikin, also HOMUNCLE, HOMUNCULE [n HOMUNCULI]\n",
  "HOMY": "homelike, also HOMEY [adj HOMIER, HOMIEST]\n",
  "HON": "(short for) honey, as a term of endearment [n -S]\n",
  "HONAN": "(Chinese) a pongee fabric of even color made originally by silkworms from Honan province, China [n -S]\n",
  "HONANS": "HONAN, (Chinese) a pongee fabric of even color made originally by silkworms from Honan province, China [n]\n",
  "HONCHO": "(Japanese) to take charge of [v HONCHOED, HONCHOING, HONCHOS or HONCHOES]\n",
  "HONCHOED": "HONCHO, (Japanese) to take charge of [v]\n",
  "HONCHOES": "HONCHO, (Japanese) to take charge of [v]\n",
  "HONCHOING": "HONCHO, (Japanese) to take charge of [v]\n",
  "HONCHOS": "HONCHO, (Japanese) to take charge of [v]\n",
  "HOND": "(obsolete) hand [n -S]\n",
  "HONDA": "(Spanish) a part of a lariat [n -S]\n",
  "HONDAS": "HONDA, (Spanish) a part of a lariat [n]\n",
  "HONDLE": "to haggle [v HONDLED, HONDLING, HONDLES]\n",
  "HONDLED": "HONDLE, to haggle [v]\n",
  "HONDLES": "HONDLE, to haggle [v]\n",
  "HONDLING": "HONDLE, to haggle [v]\n",
  "HONDS": "HOND, (obsolete) hand [n]\n",
  "HONE": "to whet [v HONED, HONING, HONES]\n",
  "HONED": "HONE, to whet [v]\n",
  "HONER": "a tool for honing [n -S]\n",
  "HONERS": "HONER, a tool for honing [n]\n",
  "HONES": "HONE, to whet [v]\n",
  "HONEST": "truthful [adj HONESTER, HONESTEST, HONESTLY]\n",
  "HONESTER": "HONEST, truthful [adj]\n",
  "HONESTEST": "HONEST, truthful [adj]\n",
  "HONESTIES": "HONESTY, the quality of being honest [n]\n",
  "HONESTLY": "HONEST, truthful [adv]\n",
  "HONESTNESS": "the state of being honest [n -ES]\n",
  "HONESTNESSES": "HONESTNESS, the state of being honest [n]\n",
  "HONESTY": "the quality of being honest [n HONESTIES]\n",
  "HONEWORT": "a perennial herb [n -S]\n",
  "HONEWORTS": "HONEWORT, a perennial herb [n]\n",
  "HONEY": "to sweeten with a sweet thick fluid [v HONIED or HONEYED, HONEYING, HONEYS]\n",
  "HONEYBEE": "any bee of the genus Apis, which lives in communities and collects honey [n -S]\n",
  "HONEYBEES": "HONEYBEE, any bee of the genus Apis, which lives in communities and collects honey [n]\n",
  "HONEYBELL": "a hybrid of a tangerine and a pomelo, or grapefruit [n -S]\n",
  "HONEYBELLS": "HONEYBELL, a hybrid of a tangerine and a pomelo, or grapefruit [n]\n",
  "HONEYBUN": "a sweetheart [n -S]\n",
  "HONEYBUNCH": "(colloquial) a term of endearment [n -ES]\n",
  "HONEYBUNCHES": "HONEYBUNCH, (colloquial) a term of endearment [n]\n",
  "HONEYBUNS": "HONEYBUN, a sweetheart [n]\n",
  "HONEYCOMB": "a comb or mass of waxy cells formed by bees in which they rear their young and store honey [n -S] / to make like a honeycomb [v -ED, -ING, -S]\n",
  "HONEYCOMBED": "HONEYCOMB, to make like a honeycomb [v]\n",
  "HONEYCOMBING": "honeycomb stitch [n -S]\n",
  "HONEYCOMBINGS": "HONEYCOMBING, honeycomb stitch [n]\n",
  "HONEYCOMBS": "HONEYCOMB, to make like a honeycomb [v]\n",
  "HONEYCREEPER": "a kind of tropical bird [n -S]\n",
  "HONEYCREEPERS": "HONEYCREEPER, a kind of tropical bird [n]\n",
  "HONEYDEW": "a sweet fluid [n -S]\n",
  "HONEYDEWED": "covered with honeydew, a sugary substance excreted by aphids and other insects [adj]\n",
  "HONEYDEWS": "HONEYDEW, a sweet fluid [n]\n",
  "HONEYEATER": "any bird of a large Australian family [n -S]\n",
  "HONEYEATERS": "HONEYEATER, any bird of a large Australian family [n]\n",
  "HONEYED": "HONEY, to sweeten with a sweet thick fluid [v]\n",
  "HONEYEDLY": "HONEYED, HONEY, to sweeten with a sweet thick fluid [adv]\n",
  "HONEYFUL": "containing much honey [adj]\n",
  "HONEYGUIDE": "an African bird that guides men and ratels to honey [n -S]\n",
  "HONEYGUIDES": "HONEYGUIDE, an African bird that guides men and ratels to honey [n]\n",
  "HONEYING": "HONEY, to sweeten with a sweet thick fluid [v]\n",
  "HONEYLESS": "destitute of honey [adj]\n",
  "HONEYMONTH": "(obsolete) to spend one's honeymoon, also HONEYMOON [v -ED, -ING, -S]\n",
  "HONEYMONTHED": "HONEYMONTH, (obsolete) to spend one's honeymoon, also HONEYMOON [v]\n",
  "HONEYMONTHING": "HONEYMONTH, (obsolete) to spend one's honeymoon, also HONEYMOON [v]\n",
  "HONEYMONTHS": "HONEYMONTH, (obsolete) to spend one's honeymoon, also HONEYMOON [v]\n",
  "HONEYMOON": "the first weeks after marriage, commonly spent on holiday [n -S] / to go on honeymoon, also HONEYMONTH [v -ED, -ING, -S]\n",
  "HONEYMOONED": "HONEYMOON, to go on honeymoon, also HONEYMONTH [v]\n",
  "HONEYMOONER": "one who is on honeymoon [n -S]\n",
  "HONEYMOONERS": "HONEYMOONER, one who is on honeymoon [n]\n",
  "HONEYMOONING": "HONEYMOON, to go on honeymoon, also HONEYMONTH [v]\n",
  "HONEYMOONS": "HONEYMOON, the first weeks after marriage, commonly spent on holiday [n]\n",
  "HONEYPOT": "(South African) a kind of grape, also HAANEPOOT, HANEPOOT [n -S]\n",
  "HONEYPOTS": "HONEYPOT, (South African) a kind of grape, also HAANEPOOT, HANEPOOT [n]\n",
  "HONEYS": "HONEY, to sweeten with a sweet thick fluid [v]\n",
  "HONEYSUCKER": "another name for the honeyeater [n -S]\n",
  "HONEYSUCKERS": "HONEYSUCKER, another name for the honeyeater [n]\n",
  "HONEYSUCKLE": "any of a genus of shrubs with opposite leaves and fragrant tubular flowers rich in nectar [n -S]\n",
  "HONEYSUCKLED": "sweetened with honeysuckle [adj]\n",
  "HONEYSUCKLES": "HONEYSUCKLE, any of a genus of shrubs with opposite leaves and fragrant tubular flowers rich in nectar [n]\n",
  "HONEYTRAP": "a scheme in which a victim is lured into a compromising sexual situation giving opportunities for blackmail [n -S]\n",
  "HONEYTRAPS": "HONEYTRAP, a scheme in which a victim is lured into a compromising sexual situation giving opportunities for blackmail [n]\n",
  "HONG": "(obsolete) to hang [v HUNG, HONGING, HONGS]\n",
  "HONGI": "(Maori) a traditional greeting, touching nose to nose [n HONGIS] / to greet by touching nose to nose [v -ED, -ING, -ES]\n",
  "HONGIED": "HONGI, to greet by touching nose to nose [v]\n",
  "HONGIES": "HONGI, to greet by touching nose to nose [v]\n",
  "HONGIING": "HONGI, to greet by touching nose to nose [v]\n",
  "HONGING": "HONG, (obsolete) to hang [v]\n",
  "HONGIS": "HONGI, (Maori) a traditional greeting, touching nose to nose [n]\n",
  "HONGS": "HONG, (obsolete) to hang [v]\n",
  "HONIED": "sweetened with or as with honey, also HONEYED [adj HONIEDLY]\n",
  "HONIEDLY": "HONIED, sweetened with or as with honey, also HONEYED [adv]\n",
  "HONING": "HONE, to whet [v]\n",
  "HONK": "to cry like a goose [v -ED, -ING, -S]\n",
  "HONKED": "HONK, to cry like a goose [v]\n",
  "HONKER": "a wild goose [n -S]\n",
  "HONKERS": "HONKER, a wild goose [n]\n",
  "HONKEY": "(offensive slang) a white man, also HONKIE, HONKY [n -S]\n",
  "HONKEYS": "HONKEY, (offensive slang) a white man, also HONKIE, HONKY [n]\n",
  "HONKIE": "(offensive slang) a white man, also HONKEY, HONKY [n -S]\n",
  "HONKIES": "HONKIE, (offensive slang) a white man, also HONKEY, HONKY [n]\n",
  "HONKING": "HONK, to cry like a goose [v]\n",
  "HONKS": "HONK, to cry like a goose [v]\n",
  "HONKY": "(offensive slang) a white man, also HONKEY, HONKIE [n HONKIES]\n",
  "HONOR": "to treat with respect, also HONOUR [v -ED, -ING, -S]\n",
  "HONORABILITIES": "HONORABILITY, being honorable, also HONOURABILITY [n]\n",
  "HONORABILITY": "being honorable, also HONOURABILITY [n HONORABILITIES]\n",
  "HONORABLE": "(US) honourable, also HONOURABLE [adj HONORABLY]\n",
  "HONORABLENESS": "the state of being honorable, also HONOURABLENESS [n -ES]\n",
  "HONORABLENESSES": "HONORABLENESS, the state of being honorable, also HONOURABLENESS [n]\n",
  "HONORABLY": "HONORABLE, (US) honourable, also HONOURABLE [adv]\n",
  "HONORAND": "a person receiving an honour, esp. an honorary degree, also HONOREE, HONOUREE [n -S]\n",
  "HONORANDS": "HONORAND, a person receiving an honour, esp. an honorary degree, also HONOREE, HONOUREE [n]\n",
  "HONORARIA": "HONORARIUM, a voluntary fee paid esp. to a professional person for their services [n]\n",
  "HONORARIES": "HONORARY, an honorarium [n]\n",
  "HONORARILY": "HONORARY, conferring honour [adv]\n",
  "HONORARIUM": "a voluntary fee paid esp. to a professional person for their services [n HONORARIA or HONORARIUMS]\n",
  "HONORARIUMS": "HONORARIUM, a voluntary fee paid esp. to a professional person for their services [n]\n",
  "HONORARY": "conferring honour [adj HONORARILY] / an honorarium [n HONORARIES]\n",
  "HONORED": "HONOR, to treat with respect, also HONOUR [v]\n",
  "HONOREE": "a person receiving an honor, also HONORAND [n -S]\n",
  "HONOREES": "HONOREE, a person receiving an honor, also HONORAND [n]\n",
  "HONORER": "one who honors, also HONOURER [n -S]\n",
  "HONORERS": "HONORER, one who honors, also HONOURER [n]\n",
  "HONORIFIC": "attributing or giving honour, also HONORIFICAL [adj HONORIFICALLY] / an honorific time of title [n -S]\n",
  "HONORIFICAL": "attributing or giving honour, also HONORIFIC [adj HONORIFICALLY]\n",
  "HONORIFICALLY": "HONORIFICAL, attributing or giving honour, also HONORIFIC [adv]\n",
  "HONORIFICS": "HONORIFIC, an honorific time of title [n]\n",
  "HONORING": "HONOR, to treat with respect, also HONOUR [v]\n",
  "HONORLESS": "without honour, also HONOURLESS [adj]\n",
  "HONORS": "HONOR, to treat with respect, also HONOUR [v]\n",
  "HONOUR": "to treat with respect, also HONOR [v -ED, -ING, -S]\n",
  "HONOURABILITIES": "HONOURABILITY, the quality of being honourable, also HONORABILITY [n]\n",
  "HONOURABILITY": "the quality of being honourable, also HONORABILITY [n HONOURABILITIES]\n",
  "HONOURABLE": "worthy of honour, also HONORABLE [adj HONOURABLY]\n",
  "HONOURABLENESS": "HONOURABLE, worthy of honour, also HONORABLE [n]\n",
  "HONOURABLY": "HONOURABLE, worthy of honour, also HONORABLE [adv]\n",
  "HONOURARY": "conferring honour, also HONORARY [adj]\n",
  "HONOURED": "HONOUR, to treat with respect, also HONOR [v]\n",
  "HONOUREE": "a person who is honoured, also HONOREE, HONORAND [n -S]\n",
  "HONOUREES": "HONOUREE, a person who is honoured, also HONOREE, HONORAND [n]\n",
  "HONOURER": "one who honours, also HONORER [n -S]\n",
  "HONOURERS": "HONOURER, one who honours, also HONORER [n]\n",
  "HONOURING": "HONOUR, to treat with respect, also HONOR [v]\n",
  "HONOURLESS": "without honour, also HONORLESS [adj]\n",
  "HONOURS": "HONOUR, to treat with respect, also HONOR [v]\n",
  "HONS": "HON, (short for) honey, as a term of endearment [n]\n",
  "HOO": "(Shakespeare) an interjection expressing boisterous emotion [interj]\n",
  "HOOCH": "whisky or any strong liquor, esp. if illicitly acquired, also HOOTCH [n -ES]\n",
  "HOOCHES": "HOOCH, whisky or any strong liquor, esp. if illicitly acquired, also HOOTCH [n]\n",
  "HOOCHIE": "(colloquial) a promiscuous young woman [n -S]\n",
  "HOOCHIES": "HOOCHIE, (colloquial) a promiscuous young woman [n]\n",
  "HOOD": "to furnish with a covering for the head [v -ED, -ING, -S]\n",
  "HOODED": "HOOD, to furnish with a covering for the head [v]\n",
  "HOODEDNESS": "the state of being hooded [n -ES]\n",
  "HOODEDNESSES": "HOODEDNESS, the state of being hooded [n]\n",
  "HOODIA": "an African plant whose sap suppresses appetite [n -S]\n",
  "HOODIAS": "HOODIA, an African plant whose sap suppresses appetite [n]\n",
  "HOODIE": "a hooded crow [n -S]\n",
  "HOODIER": "HOODY, resembling a hoodlum [adj]\n",
  "HOODIES": "HOODIE, a hooded crow [n]\n",
  "HOODIEST": "HOODY, resembling a hoodlum [adj]\n",
  "HOODING": "HOOD, to furnish with a covering for the head [v]\n",
  "HOODLESS": "without a hood [adj]\n",
  "HOODLIKE": "like a hood [adj]\n",
  "HOODLUM": "a smalltime criminal or gangster [n -S]\n",
  "HOODLUMISH": "like a hoodlum [adj]\n",
  "HOODLUMISM": "being a hoodlum [n -S]\n",
  "HOODLUMISMS": "HOODLUMISM, being a hoodlum [n]\n",
  "HOODLUMS": "HOODLUM, a smalltime criminal or gangster [n]\n",
  "HOODMAN": "the person blindfolded in the game called hoodman-blind [n HOODMEN]\n",
  "HOODMEN": "HOODMAN, the person blindfolded in the game called hoodman-blind [n]\n",
  "HOODMOLD": "a protective projection on a cornice [n -S]\n",
  "HOODMOLDS": "HOODMOLD, a protective projection on a cornice [n]\n",
  "HOODOO": "to bring bad luck to [v -ED, -ING, -S]\n",
  "HOODOOED": "HOODOO, to bring bad luck to [v]\n",
  "HOODOOING": "HOODOO, to bring bad luck to [v]\n",
  "HOODOOISM": "the bringing of bad luck [n -S]\n",
  "HOODOOISMS": "HOODOOISM, the bringing of bad luck [n]\n",
  "HOODOOS": "HOODOO, to bring bad luck to [v]\n",
  "HOODS": "HOOD, to furnish with a covering for the head [v]\n",
  "HOODWINK": "to deceive [v -ED, -ING, -S]\n",
  "HOODWINKED": "HOODWINK, to deceive [v]\n",
  "HOODWINKER": "one who hoodwinks [n -S]\n",
  "HOODWINKERS": "HOODWINKER, one who hoodwinks [n]\n",
  "HOODWINKING": "HOODWINK, to deceive [v]\n",
  "HOODWINKS": "HOODWINK, to deceive [v]\n",
  "HOODY": "resembling a hoodlum [adj HOODIER, HOODIEST]\n",
  "HOOEY": "nonsense [n -S]\n",
  "HOOEYS": "HOOEY, nonsense [n]\n",
  "HOOF": "the horny part of the feet of animals [n HOOVES] / to dance [v -ED, -ING, -S]\n",
  "HOOFBEAT": "the sound of hooves striking the ground [n -S]\n",
  "HOOFBEATS": "HOOFBEAT, the sound of hooves striking the ground [n]\n",
  "HOOFBOUND": "of a horse, having dry contracted hooves, with resultant pain and lameness [adj]\n",
  "HOOFED": "HOOF, to dance [v]\n",
  "HOOFER": "a professional dancer [n -S]\n",
  "HOOFERS": "HOOFER, a professional dancer [n]\n",
  "HOOFING": "HOOF, to dance [v]\n",
  "HOOFLESS": "without hoofs [adj]\n",
  "HOOFLIKE": "like a hoof [adj]\n",
  "HOOFPRINT": "the mark of a hoof [n -S]\n",
  "HOOFPRINTS": "HOOFPRINT, the mark of a hoof [n]\n",
  "HOOFROT": "foot-rot [n -S]\n",
  "HOOFROTS": "HOOFROT, foot-rot [n]\n",
  "HOOFS": "HOOF, to dance [v]\n",
  "HOOK": "to catch with a bent piece of metal [v -ED, -ING, -S]\n",
  "HOOKA": "(Urdu) a pipe with a long, flexible stem, so arranged that the smoke is cooled by being made to pass through water, also HOOKAH [n -S]\n",
  "HOOKAH": "(Urdu) a pipe with a long, flexible stem, so arranged that the smoke is cooled by being made to pass through water, also HOOKA [n -S]\n",
  "HOOKAHS": "HOOKAH, (Urdu) a pipe with a long, flexible stem, so arranged that the smoke is cooled by being made to pass through water, also HOOKA [n]\n",
  "HOOKAS": "HOOKA, (Urdu) a pipe with a long, flexible stem, so arranged that the smoke is cooled by being made to pass through water, also HOOKAH [n]\n",
  "HOOKCHECK": "in ice hockey, the acting of hooking an opposing player [n -S]\n",
  "HOOKCHECKS": "HOOKCHECK, in ice hockey, the acting of hooking an opposing player [n]\n",
  "HOOKED": "HOOK, to catch with a bent piece of metal [v]\n",
  "HOOKEDNESS": "the state of being bent like a hook [n -ES]\n",
  "HOOKEDNESSES": "HOOKEDNESS, the state of being bent like a hook [n]\n",
  "HOOKER": "(offensive slang) a prostitute [n -S]\n",
  "HOOKERS": "HOOKER, (offensive slang) a prostitute [n]\n",
  "HOOKEY": "truanting, as in to play hookey, to play truant [n -S]\n",
  "HOOKEYS": "HOOKEY, truanting, as in to play hookey, to play truant [n]\n",
  "HOOKIER": "HOOKY, full of hooks [adj]\n",
  "HOOKIES": "HOOKY, truancy [n]\n",
  "HOOKIEST": "HOOKY, full of hooks [adj]\n",
  "HOOKING": "an illegal move in hockey involving the blade of a stick [n -S]\n",
  "HOOKINGS": "HOOKING, an illegal move in hockey involving the blade of a stick [n]\n",
  "HOOKLESS": "without hooks [adj]\n",
  "HOOKLET": "a small hook [n -S]\n",
  "HOOKLETS": "HOOKLET, a small hook [n]\n",
  "HOOKLIKE": "like a hook [adj]\n",
  "HOOKNOSE": "a strongly curved nose [n -S]\n",
  "HOOKNOSED": "having a hook-shaped nose [adj]\n",
  "HOOKNOSES": "HOOKNOSE, a strongly curved nose [n]\n",
  "HOOKS": "HOOK, to catch with a bent piece of metal [v]\n",
  "HOOKUP": "an electrical assemblage [n -S]\n",
  "HOOKUPS": "HOOKUP, an electrical assemblage [n]\n",
  "HOOKWORM": "a parasitic worm [n -S]\n",
  "HOOKWORMS": "HOOKWORM, a parasitic worm [n]\n",
  "HOOKY": "truancy [n HOOKIES] / full of hooks [adj HOOKIER, HOOKIEST]\n",
  "HOOLACHAN": "(Gaelic) a Highland reel, esp. the reel of Tulloch, also HOOLICAN [n -S]\n",
  "HOOLACHANS": "HOOLACHAN, (Gaelic) a Highland reel, esp. the reel of Tulloch, also HOOLICAN [n]\n",
  "HOOLEY": "(Irish) a boisterous party, also HOOLIE, HOOLY [n -S]\n",
  "HOOLEYS": "HOOLEY, (Irish) a boisterous party, also HOOLIE, HOOLY [n]\n",
  "HOOLICAN": "(Gaelic) a Highland reel, esp. the reel of Tulloch, also HOOLACHAN [n -S]\n",
  "HOOLICANS": "HOOLICAN, (Gaelic) a Highland reel, esp. the reel of Tulloch, also HOOLACHAN [n]\n",
  "HOOLIE": "(Scots) easy, slow [adj HOOLIER, HOOLIEST] / a lively party, also HOOLEY, HOOLY [n HOOLIES]\n",
  "HOOLIER": "HOOLY, soft and careful [adj]\n",
  "HOOLIES": "HOOLIE, a lively party, also HOOLEY, HOOLY [n]\n",
  "HOOLIEST": "HOOLY, soft and careful [adj]\n",
  "HOOLIGAN": "a street tough [n -S]\n",
  "HOOLIGANISM": "rowdy, violent, or destructive behavior [n -S]\n",
  "HOOLIGANISMS": "HOOLIGANISM, rowdy, violent, or destructive behavior [n]\n",
  "HOOLIGANS": "HOOLIGAN, a street tough [n]\n",
  "HOOLOCK": "a small black gibbon found in the mountains of Assam [n -S]\n",
  "HOOLOCKS": "HOOLOCK, a small black gibbon found in the mountains of Assam [n]\n",
  "HOOLY": "soft and careful [adj HOOLIER, HOOLIEST]\n",
  "HOON": "(Australian slang) to act loutishly [v -ED, -ING, -S]\n",
  "HOONED": "HOON, (Australian slang) to act loutishly [v]\n",
  "HOONING": "HOON, (Australian slang) to act loutishly [v]\n",
  "HOONS": "HOON, (Australian slang) to act loutishly [v]\n",
  "HOOP": "to fasten with a circular band of metal [v -ED, -ING, -S]\n",
  "HOOPED": "HOOP, to fasten with a circular band of metal [v]\n",
  "HOOPER": "one who hoops casks or tubs; a cooper [n -S]\n",
  "HOOPERS": "HOOPER, one who hoops casks or tubs; a cooper [n]\n",
  "HOOPING": "HOOP, to fasten with a circular band of metal [v]\n",
  "HOOPLA": "a fairground game of throwing hoops on to pegs [n -S]\n",
  "HOOPLAS": "HOOPLA, a fairground game of throwing hoops on to pegs [n]\n",
  "HOOPLESS": "without a hoop [adj]\n",
  "HOOPLIKE": "like a hoop [adj]\n",
  "HOOPOE": "a short-legged perching bird of Africa and Eurasia, having a prominent crest, also HOOPOO [n -S]\n",
  "HOOPOES": "HOOPOE, a short-legged perching bird of Africa and Eurasia, having a prominent crest, also HOOPOO [n]\n",
  "HOOPOO": "a short-legged perching bird of Africa and Eurasia, having a prominent crest, also HOOPOE [n -S]\n",
  "HOOPOOS": "HOOPOO, a short-legged perching bird of Africa and Eurasia, having a prominent crest, also HOOPOE [n]\n",
  "HOOPS": "HOOP, to fasten with a circular band of metal [v]\n",
  "HOOPSKIRT": "a skirt stiffened with or as if with a hoop [n -S]\n",
  "HOOPSKIRTS": "HOOPSKIRT, a skirt stiffened with or as if with a hoop [n]\n",
  "HOOPSTER": "a basketball player [n -S]\n",
  "HOOPSTERS": "HOOPSTER, a basketball player [n]\n",
  "HOOR": "a Scots and Irish form of WHORE; a difficult or unpleasant thing [n -S]\n",
  "HOORAH": "(obsolete) an exclamation of approbation or joy [n -S] / to shout hooray, also HOORAY, HURRA, HURRAH, HURRAY [v -ED, -ING, -S]\n",
  "HOORAHED": "HOORAH, to shout hooray, also HOORAY, HURRA, HURRAH, HURRAY [v]\n",
  "HOORAHING": "HOORAH, to shout hooray, also HOORAY, HURRA, HURRAH, HURRAY [v]\n",
  "HOORAHS": "HOORAH, to shout hooray, also HOORAY, HURRA, HURRAH, HURRAY [v]\n",
  "HOORAY": "an exclamation of approbation and joy [n -S] / to shout hooray, also HOORAH, HURRA, HURRAH, HURRAY [v -ED, -ING, -S]\n",
  "HOORAYED": "HOORAY, to shout hooray, also HOORAH, HURRA, HURRAH, HURRAY [v]\n",
  "HOORAYING": "HOORAY, to shout hooray, also HOORAH, HURRA, HURRAH, HURRAY [v]\n",
  "HOORAYS": "HOORAY, to shout hooray, also HOORAH, HURRA, HURRAH, HURRAY [v]\n",
  "HOORD": "(obsolete) a hoard [n -S]\n",
  "HOORDS": "HOORD, (obsolete) a hoard [n]\n",
  "HOOROO": "(Australian) to say goodbye, cheerio [v -ED, -ING, -S]\n",
  "HOOROOED": "HOOROO, (Australian) to say goodbye, cheerio [v]\n",
  "HOOROOING": "HOOROO, (Australian) to say goodbye, cheerio [v]\n",
  "HOOROOS": "HOOROO, (Australian) to say goodbye, cheerio [v]\n",
  "HOORS": "HOOR, a Scots and Irish form of WHORE; a difficult or unpleasant thing [n]\n",
  "HOOSEGOW": "(US slang) a prison, jail, also HOOSGOW [n -S]\n",
  "HOOSEGOWS": "HOOSEGOW, (US slang) a prison, jail, also HOOSGOW [n]\n",
  "HOOSGOW": "(US slang) a prison, jail, also HOOSEGOW [n -S]\n",
  "HOOSGOWS": "HOOSGOW, (US slang) a prison, jail, also HOOSEGOW [n]\n",
  "HOOSH": "to shoo away [v -ED, -ING, -ES]\n",
  "HOOSHED": "HOOSH, to shoo away [v]\n",
  "HOOSHES": "HOOSH, to shoo away [v]\n",
  "HOOSHING": "HOOSH, to shoo away [v]\n",
  "HOOT": "to cry like an owl, also HOUT, WHOOT [v -ED, -ING, -S]\n",
  "HOOTANANNIE": "(US) a party with folksinging and sometimes dancing, also HOOTANANNY, HOOTENANNIE, HOOTENANNY, HOOTNANNIE, HOOTNANNY [n -S]\n",
  "HOOTANANNIES": "HOOTANANNIE, (US) a party with folksinging and sometimes dancing, also HOOTANANNY, HOOTENANNIE, HOOTENANNY, HOOTNANNIE, HOOTNANNY [n]\n",
  "HOOTANANNY": "(US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTENANNIE, HOOTENANNY, HOOTNANNIE, HOOTNANNY [n HOOTANANNIES]\n",
  "HOOTCH": "whisky or any strong liquor, esp. if illicitly acquired, also HOOCH [n -ES]\n",
  "HOOTCHES": "HOOTCH, whisky or any strong liquor, esp. if illicitly acquired, also HOOCH [n]\n",
  "HOOTED": "HOOT, to cry like an owl, also HOUT, WHOOT [v]\n",
  "HOOTENANNIE": "(US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTANANNY, HOOTENANNY, HOOTNANNIE, HOOTNANNY [n -S]\n",
  "HOOTENANNIES": "HOOTENANNIE, (US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTANANNY, HOOTENANNY, HOOTNANNIE, HOOTNANNY [n]\n",
  "HOOTENANNY": "(US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTANANNY, HOOTENANNIE, HOOTNANNIE, HOOTNANNY [n HOOTENANNIES]\n",
  "HOOTER": "one that hoots [n -S]\n",
  "HOOTERS": "HOOTER, one that hoots [n]\n",
  "HOOTIER": "HOOTY, sounding like the cry of an owl [adj]\n",
  "HOOTIEST": "HOOTY, sounding like the cry of an owl [adj]\n",
  "HOOTING": "HOOT, to cry like an owl, also HOUT, WHOOT [v]\n",
  "HOOTNANNIE": "(US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTANANNY, HOOTENANNIE, HOOTENANNY, HOOTNANNY [n -S]\n",
  "HOOTNANNIES": "HOOTNANNIE, (US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTANANNY, HOOTENANNIE, HOOTENANNY, HOOTNANNY [n]\n",
  "HOOTNANNY": "(US) a party with folksinging and sometimes dancing, also HOOTANANNIE, HOOTANANNY, HOOTENANNIE, HOOTENANNY, HOOTNANNIE [n HOOTNANNIES]\n",
  "HOOTS": "HOOT, to cry like an owl, also HOUT, WHOOT [v]\n",
  "HOOTY": "sounding like the cry of an owl [adj HOOTIER, HOOTIEST]\n",
  "HOOVE": "(Spenser) to hover, loiter [v HOOVED, HOOVING, HOOVES]\n",
  "HOOVED": "HOOVE, (Spenser) to hover, loiter [v]\n",
  "HOOVEN": "having hoove, a disease of cattle and sheep, also HOVEN [adj]\n",
  "HOOVER": "to vacuum clean using a Hoover [v -ED, -ING, -S]\n",
  "HOOVERED": "HOOVER, to vacuum clean using a Hoover [v]\n",
  "HOOVERING": "the act of using a hoover [n -S]\n",
  "HOOVERINGS": "HOOVERING, the act of using a hoover [n]\n",
  "HOOVERS": "HOOVER, to vacuum clean using a Hoover [v]\n",
  "HOOVES": "HOOVE, (Spenser) to hover, loiter [v]\n",
  "HOOVING": "HOOVE, (Spenser) to hover, loiter [v]\n",
  "HOP": "to move by jumping on one foot [v HOPPED, HOPPING, HOPS]\n",
  "HOPAK": "(Russian) a Ukrainian dance, also GOPAK [n -S]\n",
  "HOPAKS": "HOPAK, (Russian) a Ukrainian dance, also GOPAK [n]\n",
  "HOPBIND": "the stalk of the hop, also HOPBINE [n -S]\n",
  "HOPBINDS": "HOPBIND, the stalk of the hop, also HOPBINE [n]\n",
  "HOPBINE": "the stalk of the hop, also HOPBIND [n -S]\n",
  "HOPBINES": "HOPBINE, the stalk of the hop, also HOPBIND [n]\n",
  "HOPDOG": "the tussock-moth caterpillar [n -S]\n",
  "HOPDOGS": "HOPDOG, the tussock-moth caterpillar [n]\n",
  "HOPE": "to have a desire or expectation [v HOPED, HOPING, HOPES]\n",
  "HOPED": "HOPE, to have a desire or expectation [v]\n",
  "HOPEFUL": "full of hope [adj HOPEFULLY] / one that seems promising [n -S]\n",
  "HOPEFULLY": "HOPEFUL, full of hope [adv]\n",
  "HOPEFULNESS": "the state of being hopeful [n -ES]\n",
  "HOPEFULNESSES": "HOPEFULNESS, the state of being hopeful [n]\n",
  "HOPEFULS": "HOPEFUL, one that seems promising [n]\n",
  "HOPELESS": "without hope [adj HOPELESSLY]\n",
  "HOPELESSLY": "HOPELESS, without hope [adv]\n",
  "HOPELESSNESS": "the state of being hopeless [n -ES]\n",
  "HOPELESSNESSES": "HOPELESSNESS, the state of being hopeless [n]\n",
  "HOPER": "one who hopes [n -S]\n",
  "HOPERS": "HOPER, one who hopes [n]\n",
  "HOPES": "HOPE, to have a desire or expectation [v]\n",
  "HOPFIELD": "a field where hops are grown [n -S]\n",
  "HOPFIELDS": "HOPFIELD, a field where hops are grown [n]\n",
  "HOPHEAD": "a drug addict [n -S]\n",
  "HOPHEADS": "HOPHEAD, a drug addict [n]\n",
  "HOPING": "HOPE, to have a desire or expectation [v]\n",
  "HOPINGLY": "HOPING, HOPE, to have a desire or expectation [adv]\n",
  "HOPLITE": "(Greek) a heavily armed Greek foot soldier [n -S]\n",
  "HOPLITES": "HOPLITE, (Greek) a heavily armed Greek foot soldier [n]\n",
  "HOPLITIC": "of or like a hoplite, a heavily armed Greek foot soldier [adj]\n",
  "HOPLOLOGIES": "HOPLOLOGY, the study of weapons [n]\n",
  "HOPLOLOGIST": "a student of hoplology, the study of weapons [n -S]\n",
  "HOPLOLOGISTS": "HOPLOLOGIST, a student of hoplology, the study of weapons [n]\n",
  "HOPLOLOGY": "the study of weapons [n HOPLOLOGIES]\n",
  "HOPPED": "HOP, to move by jumping on one foot [v]\n",
  "HOPPER": "a container for grain, also HOPPERCAR [n -S]\n",
  "HOPPERCAR": "a container for grain, also HOPPER [n -S]\n",
  "HOPPERCARS": "HOPPERCAR, a container for grain, also HOPPER [n]\n",
  "HOPPERS": "HOPPER, a container for grain, also HOPPERCAR [n]\n",
  "HOPPIER": "HOPPY, tasting of hops [adj]\n",
  "HOPPIEST": "HOPPY, tasting of hops [adj]\n",
  "HOPPINESS": "the state of being hoppy, tasting of hops [n -ES]\n",
  "HOPPINESSES": "HOPPINESS, the state of being hoppy, tasting of hops [n]\n",
  "HOPPING": "the harvesting of hops [n -S]\n",
  "HOPPINGS": "HOPPING, the harvesting of hops [n]\n",
  "HOPPLE": "to restrain by tying the feet together, also HOBBLE [v HOPPLED, HOPPLING, HOPPLES]\n",
  "HOPPLED": "HOPPLE, to restrain by tying the feet together, also HOBBLE [v]\n",
  "HOPPLER": "one who hopples [n -S]\n",
  "HOPPLERS": "HOPPLER, one who hopples [n]\n",
  "HOPPLES": "HOPPLE, to restrain by tying the feet together, also HOBBLE [v]\n",
  "HOPPLING": "HOPPLE, to restrain by tying the feet together, also HOBBLE [v]\n",
  "HOPPUS": "as in hoppus foot, a unit of volume for round timber [adj]\n",
  "HOPPY": "tasting of hops [adj HOPPIER, HOPPIEST]\n",
  "HOPS": "HOP, to move by jumping on one foot [v]\n",
  "HOPSACK": "a rough-surfaced loose fabric, also HOPSACKING [n -S]\n",
  "HOPSACKING": "a rough-surfaced loose fabric, also HOPSACK [n -S]\n",
  "HOPSACKINGS": "HOPSACKING, a rough-surfaced loose fabric, also HOPSACK [n]\n",
  "HOPSACKS": "HOPSACK, a rough-surfaced loose fabric, also HOPSACKING [n]\n",
  "HOPSCOTCH": "a game in which children hop over lines scotched or scored on the ground [n -ES] / to play hopscotch [v -ED, -ING, -ES]\n",
  "HOPSCOTCHED": "HOPSCOTCH, to play hopscotch [v]\n",
  "HOPSCOTCHES": "HOPSCOTCH, to play hopscotch [v]\n",
  "HOPSCOTCHING": "HOPSCOTCH, to play hopscotch [v]\n",
  "HOPTOAD": "a kind of toad [n -S]\n",
  "HOPTOADS": "HOPTOAD, a kind of toad [n]\n",
  "HORA": "(Hebrew) an Israeli dance, also HORAH [n -S]\n",
  "HORAH": "(Hebrew) an Israeli dance, also HORA [n -S]\n",
  "HORAHS": "HORAH, (Hebrew) an Israeli dance, also HORA [n]\n",
  "HORAL": "relating to hours; hourly [adj]\n",
  "HORARY": "pertaining to an hour; hourly [adj]\n",
  "HORAS": "HORA, (Hebrew) an Israeli dance, also HORAH [n]\n",
  "HORDE": "to gather in a large group [v HORDED, HORDING, HORDES]\n",
  "HORDED": "HORDE, to gather in a large group [v]\n",
  "HORDEIN": "a protein found in barley grain [n -S]\n",
  "HORDEINS": "HORDEIN, a protein found in barley grain [n]\n",
  "HORDEOLA": "HORDEOLUM, a small tumor upon the eyelid, resembling a grain of barley [n]\n",
  "HORDEOLUM": "a small tumor upon the eyelid, resembling a grain of barley [n HORDEOLA]\n",
  "HORDES": "HORDE, to gather in a large group [v]\n",
  "HORDING": "HORDE, to gather in a large group [v]\n",
  "HORDOCK": "(Shakespeare) an unidentified plant, perhaps burdock, also HARDOKE [n -S]\n",
  "HORDOCKS": "HORDOCK, (Shakespeare) an unidentified plant, perhaps burdock, also HARDOKE [n]\n",
  "HORE": "(Spenser) grey, esp. with age, also HOAR [adj]\n",
  "HOREHOUND": "a kind of wild flower, also HOARHOUND [n -S]\n",
  "HOREHOUNDS": "HOREHOUND, a kind of wild flower, also HOARHOUND [n]\n",
  "HORI": "(Maori) a Maori; falsehood [n -S]\n",
  "HORIATIKI": "(Modern Greek) a traditional Greek salad [n -S]\n",
  "HORIATIKIS": "HORIATIKI, (Modern Greek) a traditional Greek salad [n]\n",
  "HORIS": "HORI, (Maori) a Maori; falsehood [n]\n",
  "HORIZON": "the line where earth and sky seem to meet [n -S]\n",
  "HORIZONAL": "of the horizon [adj]\n",
  "HORIZONLESS": "with no horizon [adj]\n",
  "HORIZONS": "HORIZON, the line where earth and sky seem to meet [n]\n",
  "HORIZONTAL": "parallel to the horizon [adj HORIZONTALLY] / a horizontal line [n -S]\n",
  "HORIZONTALITIES": "HORIZONTALITY, the state of being horizontal [n]\n",
  "HORIZONTALITY": "the state of being horizontal [n HORIZONTALITIES]\n",
  "HORIZONTALLY": "HORIZONTAL, parallel to the horizon [adv]\n",
  "HORIZONTALNESS": "HORIZONTAL, parallel to the horizon [n]\n",
  "HORIZONTALS": "HORIZONTAL, a horizontal line [n]\n",
  "HORK": "to spit [v -ED, -ING, -S]\n",
  "HORKED": "HORK, to spit [v]\n",
  "HORKEY": "harvest-home, the harvest supper, also HAWKEY [n -S]\n",
  "HORKEYS": "HORKEY, harvest-home, the harvest supper, also HAWKEY [n]\n",
  "HORKING": "HORK, to spit [v]\n",
  "HORKS": "HORK, to spit [v]\n",
  "HORLICKS": "(tradename) a mess, as in to make a horlicks of [n]\n",
  "HORME": "goal-directed or purposive behaviour [n -S]\n",
  "HORMES": "HORME, goal-directed or purposive behaviour [n]\n",
  "HORMESES": "HORMESIS, a phenomenon whereby substances that are toxic in large doses have a beneficial effect when absorbed in very small doses [n]\n",
  "HORMESIS": "a phenomenon whereby substances that are toxic in large doses have a beneficial effect when absorbed in very small doses [n HORMESES]\n",
  "HORMETIC": "relating to hormesis, a phenomenon whereby substances that are toxic in large doses have a beneficial effect when absorbed in very small doses [adj]\n",
  "HORMIC": "exhibiting purposeful behaviour [adj]\n",
  "HORMOGONIA": "HORMOGONIUM, a portion of a filament in many cyanobacteria that becomes detached as a reproductive body [n]\n",
  "HORMOGONIUM": "a portion of a filament in many cyanobacteria that becomes detached as a reproductive body [n HORMOGONIA]\n",
  "HORMONAL": "relating to hormones, also HORMONIC [adj HORMONALLY]\n",
  "HORMONALLY": "HORMONAL, relating to hormones, also HORMONIC [adv]\n",
  "HORMONE": "a secretion of the endocrine organs [n -S]\n",
  "HORMONELIKE": "like a hormone [adj]\n",
  "HORMONES": "HORMONE, a secretion of the endocrine organs [n]\n",
  "HORMONIC": "relating to hormones [adj]\n",
  "HORN": "to form a hard bone-like projection on the head [v -ED, -ING, -S]\n",
  "HORNBAG": "(offensive Australian slang) a promiscuous woman [n -S]\n",
  "HORNBAGS": "HORNBAG, (offensive Australian slang) a promiscuous woman [n]\n",
  "HORNBEAK": "a dialect name for the garfish [n -S]\n",
  "HORNBEAKS": "HORNBEAK, a dialect name for the garfish [n]\n",
  "HORNBEAM": "a small hardwood tree, also HARDBEAM [n -S]\n",
  "HORNBEAMS": "HORNBEAM, a small hardwood tree, also HARDBEAM [n]\n",
  "HORNBILL": "a bird with a horny excrescence on its bill [n -S]\n",
  "HORNBILLS": "HORNBILL, a bird with a horny excrescence on its bill [n]\n",
  "HORNBLENDE": "the common black, or dark green or brown, variety of amphibole [n -S]\n",
  "HORNBLENDES": "HORNBLENDE, the common black, or dark green or brown, variety of amphibole [n]\n",
  "HORNBLENDIC": "of or like hornblende [adj]\n",
  "HORNBOOK": "an ancient child's schoolbook comprising alphabet, digits, etc. on parchment covered with sheet of horn [n -S]\n",
  "HORNBOOKS": "HORNBOOK, an ancient child's schoolbook comprising alphabet, digits, etc. on parchment covered with sheet of horn [n]\n",
  "HORNBUG": "a stag-beetle [n -S]\n",
  "HORNBUGS": "HORNBUG, a stag-beetle [n]\n",
  "HORNDOG": "a sexually aggressive man [n -S]\n",
  "HORNDOGS": "HORNDOG, a sexually aggressive man [n]\n",
  "HORNED": "HORN, to form a hard bone-like projection on the head [v]\n",
  "HORNEDNESS": "the condition of being horned [n -ES]\n",
  "HORNEDNESSES": "HORNEDNESS, the condition of being horned [n]\n",
  "HORNER": "a person who deals in horns [n -S]\n",
  "HORNERS": "HORNER, a person who deals in horns [n]\n",
  "HORNET": "a stinging insect [n -S]\n",
  "HORNETS": "HORNET, a stinging insect [n]\n",
  "HORNFELS": "(German) a compact type of rock composed of lime silicates [n -ES]\n",
  "HORNFELSES": "HORNFELS, (German) a compact type of rock composed of lime silicates [n]\n",
  "HORNFISH": "another name for the garfish [n -ES]\n",
  "HORNFISHES": "HORNFISH, another name for the garfish [n]\n",
  "HORNFUL": "the capacity of a drinking horn [n -S]\n",
  "HORNFULS": "HORNFUL, the capacity of a drinking horn [n]\n",
  "HORNGELD": "a feudal rent based upon the number of horned cattle [n -S]\n",
  "HORNGELDS": "HORNGELD, a feudal rent based upon the number of horned cattle [n]\n",
  "HORNIER": "HORNY, like horn [adj]\n",
  "HORNIEST": "HORNY, like horn [adj]\n",
  "HORNILY": "HORNY, like horn [adv]\n",
  "HORNINESS": "the state of being horny [n -ES]\n",
  "HORNINESSES": "HORNINESS, the state of being horny [n]\n",
  "HORNING": "a mock serenade to newlyweds [n -S]\n",
  "HORNINGS": "HORNING, a mock serenade to newlyweds [n]\n",
  "HORNISH": "like horn [adj]\n",
  "HORNIST": "a horn-player [n -S]\n",
  "HORNISTS": "HORNIST, a horn-player [n]\n",
  "HORNITO": "(Spanish) a mound of volcanic matter [n -S]\n",
  "HORNITOS": "HORNITO, (Spanish) a mound of volcanic matter [n]\n",
  "HORNLESS": "without horns [adj]\n",
  "HORNLESSNESS": "the state of being hornless [n -ES]\n",
  "HORNLESSNESSES": "HORNLESSNESS, the state of being hornless [n]\n",
  "HORNLET": "a little horn [n -S]\n",
  "HORNLETS": "HORNLET, a little horn [n]\n",
  "HORNLIKE": "like horn [adj]\n",
  "HORNPIPE": "a lively British folk dance [n -S]\n",
  "HORNPIPES": "HORNPIPE, a lively British folk dance [n]\n",
  "HORNPOUT": "a kind of catfish [n -S]\n",
  "HORNPOUTS": "HORNPOUT, a kind of catfish [n]\n",
  "HORNS": "HORN, to form a hard bone-like projection on the head [v]\n",
  "HORNSTONE": "an alternative name sometimes given to chert [n -S]\n",
  "HORNSTONES": "HORNSTONE, an alternative name sometimes given to chert [n]\n",
  "HORNSWOGGLE": "(slang) to cheat or trick; bamboozle [v HORNSWOGGLED, HORNSWOGGLING, HORNSWOGGLES]\n",
  "HORNSWOGGLED": "HORNSWOGGLE, (slang) to cheat or trick; bamboozle [v]\n",
  "HORNSWOGGLES": "HORNSWOGGLE, (slang) to cheat or trick; bamboozle [v]\n",
  "HORNSWOGGLING": "HORNSWOGGLE, (slang) to cheat or trick; bamboozle [v]\n",
  "HORNTAIL": "a hymenopterous insect with a stout ovipositor, aka wood wasp [n -S]\n",
  "HORNTAILS": "HORNTAIL, a hymenopterous insect with a stout ovipositor, aka wood wasp [n]\n",
  "HORNWORK": "work in horn [n -S]\n",
  "HORNWORKS": "HORNWORK, work in horn [n]\n",
  "HORNWORM": "the lava of a hawkmoth [n -S]\n",
  "HORNWORMS": "HORNWORM, the lava of a hawkmoth [n]\n",
  "HORNWORT": "an aquatic herb [n -S]\n",
  "HORNWORTS": "HORNWORT, an aquatic herb [n]\n",
  "HORNWRACK": "a bryozoan of the genus Flustra [n -S]\n",
  "HORNWRACKS": "HORNWRACK, a bryozoan of the genus Flustra [n]\n",
  "HORNY": "like horn [adj HORNIER, HORNIEST, HORNILY]\n",
  "HORNYHEAD": "a North American river chub [n -S]\n",
  "HORNYHEADS": "HORNYHEAD, a North American river chub [n]\n",
  "HORNYWINK": "(dialect) a lapwing [n -S]\n",
  "HORNYWINKS": "HORNYWINK, (dialect) a lapwing [n]\n",
  "HOROEKA": "(Maori) a New Zealand tree, aka lancewood [n -S]\n",
  "HOROEKAS": "HOROEKA, (Maori) a New Zealand tree, aka lancewood [n]\n",
  "HOROGRAPHER": "one who constructs timepieces [n -S]\n",
  "HOROGRAPHERS": "HOROGRAPHER, one who constructs timepieces [n]\n",
  "HOROGRAPHIES": "HOROGRAPHY, the art of constructing sundials or clocks [n]\n",
  "HOROGRAPHY": "the art of constructing sundials or clocks [n HOROGRAPHIES]\n",
  "HOROKAKA": "(Maori) a low-growing New Zealand plant with fleshy leaves and pink or white flowers [n -S]\n",
  "HOROKAKAS": "HOROKAKA, (Maori) a low-growing New Zealand plant with fleshy leaves and pink or white flowers [n]\n",
  "HOROLOGE": "any instrument for telling the time, also HOROLOGION, HOROLOGIUM [n -S]\n",
  "HOROLOGER": "a watchmaker [n -S]\n",
  "HOROLOGERS": "HOROLOGER, a watchmaker [n]\n",
  "HOROLOGES": "HOROLOGE, any instrument for telling the time, also HOROLOGION, HOROLOGIUM [n]\n",
  "HOROLOGIA": "HOROLOGIUM, (obsolete) an instrument for telling the time, also HOROLOGE, HOROLOGION [n]\n",
  "HOROLOGIC": "relating to horology, the science of measuring time, also HOROLOGICAL [adj]\n",
  "HOROLOGICAL": "relating to horology, the science of measuring time, also HOROLOGIC [adj]\n",
  "HOROLOGIES": "HOROLOGY, the science of measuring time [n]\n",
  "HOROLOGION": "a horologe, also HOROLOGE, HOROLOGIUM [n -S]\n",
  "HOROLOGIONS": "HOROLOGION, a horologe, also HOROLOGE, HOROLOGIUM [n]\n",
  "HOROLOGIST": "one versed in horology [n -S]\n",
  "HOROLOGISTS": "HOROLOGIST, one versed in horology [n]\n",
  "HOROLOGIUM": "(obsolete) an instrument for telling the time, also HOROLOGE, HOROLOGION [n HOROLOGIA]\n",
  "HOROLOGY": "the science of measuring time [n HOROLOGIES]\n",
  "HOROMETRICAL": "relating to horometry [adj]\n",
  "HOROMETRIES": "HOROMETRY, the science of time measurement [n]\n",
  "HOROMETRY": "the science of time measurement [n HOROMETRIES]\n",
  "HOROPITO": "(Maori) a bushy New Zealand shrub, with red aromatic peppery leaves [n -S]\n",
  "HOROPITOS": "HOROPITO, (Maori) a bushy New Zealand shrub, with red aromatic peppery leaves [n]\n",
  "HOROPTER": "a set of points which have the same visual angle [n -S]\n",
  "HOROPTERS": "HOROPTER, a set of points which have the same visual angle [n]\n",
  "HOROSCOPE": "a map of the heavens at the hour or on the day of a person's birth, by which an astrologer predicts the events of a person's life [n -S]\n",
  "HOROSCOPES": "HOROSCOPE, a map of the heavens at the hour or on the day of a person's birth, by which an astrologer predicts the events of a person's life [n]\n",
  "HOROSCOPIC": "relating to a horoscope [adj]\n",
  "HOROSCOPIES": "HOROSCOPY, the art or practice of casting horoscopes [n]\n",
  "HOROSCOPIST": "one who casts horoscopes, an astrologer [n -S]\n",
  "HOROSCOPISTS": "HOROSCOPIST, one who casts horoscopes, an astrologer [n]\n",
  "HOROSCOPY": "the art or practice of casting horoscopes [n HOROSCOPIES]\n",
  "HORRENDOUS": "fearful; frightful [adj HORRENDOUSLY]\n",
  "HORRENDOUSLY": "HORRENDOUS, fearful; frightful [adv]\n",
  "HORRENDOUSNESS": "HORRENDOUS, fearful; frightful [n]\n",
  "HORRENT": "bristling [adj]\n",
  "HORRIBLE": "dreadful [adj HORRIBLY] / something horrible [n -S]\n",
  "HORRIBLENESS": "the state of being horrible [n -ES]\n",
  "HORRIBLENESSES": "HORRIBLENESS, the state of being horrible [n]\n",
  "HORRIBLES": "HORRIBLE, something horrible [n]\n",
  "HORRIBLY": "HORRIBLE, dreadful [adv]\n",
  "HORRID": "nasty, repellent [adj HORRIDER, HORRIDEST, HORRIDLY]\n",
  "HORRIDER": "HORRID, nasty, repellent [adj]\n",
  "HORRIDEST": "HORRID, nasty, repellent [adj]\n",
  "HORRIDLY": "HORRID, nasty, repellent [adv]\n",
  "HORRIDNESS": "the quality of being horrid [n -ES]\n",
  "HORRIDNESSES": "HORRIDNESS, the quality of being horrid [n]\n",
  "HORRIFIC": "causing horror [adj HORRIFICALLY]\n",
  "HORRIFICALLY": "HORRIFIC, causing horror [adv]\n",
  "HORRIFICATION": "the act of causing horror [n -S]\n",
  "HORRIFICATIONS": "HORRIFICATION, the act of causing horror [n]\n",
  "HORRIFIED": "HORRIFY, to cause a reaction of horror [v]\n",
  "HORRIFIES": "HORRIFY, to cause a reaction of horror [v]\n",
  "HORRIFY": "to cause a reaction of horror [v HORRIFIED, HORRIFYING, HORRIFIES]\n",
  "HORRIFYING": "HORRIFY, to cause a reaction of horror [v]\n",
  "HORRIFYINGLY": "HORRIFYING, HORRIFY, to cause a reaction of horror [adv]\n",
  "HORRIPILANT": "causing horripilation, the erection of the hair of the head or body from fear or cold [adj]\n",
  "HORRIPILATE": "to produce the erection of hairs on the head or body [v HORRIPILATED, HORRIPILATING, HORRIPILATES]\n",
  "HORRIPILATED": "HORRIPILATE, to produce the erection of hairs on the head or body [v]\n",
  "HORRIPILATES": "HORRIPILATE, to produce the erection of hairs on the head or body [v]\n",
  "HORRIPILATING": "HORRIPILATE, to produce the erection of hairs on the head or body [v]\n",
  "HORRIPILATION": "the erection of the hair of the head or body from fear or cold [n -S]\n",
  "HORRIPILATIONS": "HORRIPILATION, the erection of the hair of the head or body from fear or cold [n]\n",
  "HORRISONANT": "dreadful-sounding, also HORRISONOUS [adj]\n",
  "HORRISONOUS": "(archaic) dreadful-sounding, also HORRISONANT [adj]\n",
  "HORROR": "intense repugnance or fear [n -S]\n",
  "HORRORS": "HORROR, intense repugnance or fear [n]\n",
  "HORS": "(French) out of the combat; disabled from fighting [prep]\n",
  "HORSE": "to provide with a large hoofed mammal [v HORSED, HORSING, HORSES]\n",
  "HORSEBACK": "the back of a horse [n -S]\n",
  "HORSEBACKS": "HORSEBACK, the back of a horse [n]\n",
  "HORSEBEAN": "a variety of broad bean [n -S]\n",
  "HORSEBEANS": "HORSEBEAN, a variety of broad bean [n]\n",
  "HORSEBOX": "a float for carrying a horse [n -ES]\n",
  "HORSEBOXES": "HORSEBOX, a float for carrying a horse [n]\n",
  "HORSECAR": "a streetcar drawn by a horse [n -S]\n",
  "HORSECARS": "HORSECAR, a streetcar drawn by a horse [n]\n",
  "HORSED": "HORSE, to provide with a large hoofed mammal [v]\n",
  "HORSEFEATHERS": "nonsense [interj]\n",
  "HORSEFLESH": "horses considered esp. with reference to riding, driving, or racing [n -ES]\n",
  "HORSEFLESHES": "HORSEFLESH, horses considered esp. with reference to riding, driving, or racing [n]\n",
  "HORSEFLIES": "HORSEFLY, a large fly [n]\n",
  "HORSEFLY": "a large fly [n HORSEFLIES]\n",
  "HORSEHAIR": "the hair of a horse used e.g. to stuff sofas [n -S]\n",
  "HORSEHAIRS": "HORSEHAIR, the hair of a horse used e.g. to stuff sofas [n]\n",
  "HORSEHEAD": "the head of a horse [n -S]\n",
  "HORSEHEADS": "HORSEHEAD, the head of a horse [n]\n",
  "HORSEHIDE": "the hide of a horse; the ball used in the game of baseball [n -S]\n",
  "HORSEHIDES": "HORSEHIDE, the hide of a horse; the ball used in the game of baseball [n]\n",
  "HORSELAUGH": "a loud, boisterous laugh [n -S]\n",
  "HORSELAUGHS": "HORSELAUGH, a loud, boisterous laugh [n]\n",
  "HORSELEECH": "a large species of leech, supposed to fasten on horses [n -ES]\n",
  "HORSELEECHES": "HORSELEECH, a large species of leech, supposed to fasten on horses [n]\n",
  "HORSELESS": "without a horse [adj]\n",
  "HORSELIKE": "like a horse [adj]\n",
  "HORSEMAN": "one who rides a horse [n HORSEMEN]\n",
  "HORSEMANSHIP": "the art of riding [n -S]\n",
  "HORSEMANSHIPS": "HORSEMANSHIP, the art of riding [n]\n",
  "HORSEMEAT": "the meat of the horse [n -S]\n",
  "HORSEMEATS": "HORSEMEAT, the meat of the horse [n]\n",
  "HORSEMEN": "HORSEMAN, one who rides a horse [n]\n",
  "HORSEMINT": "a coarse American plant of the Mint family [n -S]\n",
  "HORSEMINTS": "HORSEMINT, a coarse American plant of the Mint family [n]\n",
  "HORSEPLAY": "rough, boisterous play [n -S]\n",
  "HORSEPLAYER": "one who habitually bets on horse races [n -S]\n",
  "HORSEPLAYERS": "HORSEPLAYER, one who habitually bets on horse races [n]\n",
  "HORSEPLAYS": "HORSEPLAY, rough, boisterous play [n]\n",
  "HORSEPOND": "a pond for horses to drink from [n -S]\n",
  "HORSEPONDS": "HORSEPOND, a pond for horses to drink from [n]\n",
  "HORSEPOWER": "the power that a horse exerts in pulling [n -S]\n",
  "HORSEPOWERS": "HORSEPOWER, the power that a horse exerts in pulling [n]\n",
  "HORSEPOX": "a skin disease of horses [n -ES]\n",
  "HORSEPOXES": "HORSEPOX, a skin disease of horses [n]\n",
  "HORSERACE": "a race for horses [n -S]\n",
  "HORSERACES": "HORSERACE, a race for horses [n]\n",
  "HORSERADISH": "a tall coarse white-flowered herb of the mustard family [n -ES]\n",
  "HORSERADISHES": "HORSERADISH, a tall coarse white-flowered herb of the mustard family [n]\n",
  "HORSES": "HORSE, to provide with a large hoofed mammal [v]\n",
  "HORSESHIT": "(vulgar) horse droppings [n -S]\n",
  "HORSESHITS": "HORSESHIT, (vulgar) horse droppings [n]\n",
  "HORSESHOD": "shod with horseshoes [adj]\n",
  "HORSESHOE": "a shoe for a horse [n -S] / to put horseshoes on [v HORSESHOED or HORSESHOD, HORSESHOEING, HORSESHOES]\n",
  "HORSESHOED": "HORSESHOE, to put horseshoes on [v]\n",
  "HORSESHOEING": "the act of shoeing a horse [n -S]\n",
  "HORSESHOEINGS": "HORSESHOEING, the act of shoeing a horse [n]\n",
  "HORSESHOER": "one who shoes horses [n -S]\n",
  "HORSESHOERS": "HORSESHOER, one who shoes horses [n]\n",
  "HORSESHOES": "HORSESHOE, to put horseshoes on [v]\n",
  "HORSETAIL": "a waterside plant [n -S]\n",
  "HORSETAILS": "HORSETAIL, a waterside plant [n]\n",
  "HORSEWAY": "a road for horses [n -S]\n",
  "HORSEWAYS": "HORSEWAY, a road for horses [n]\n",
  "HORSEWEED": "a common American weed of the composite family [n -S]\n",
  "HORSEWEEDS": "HORSEWEED, a common American weed of the composite family [n]\n",
  "HORSEWHIP": "a whip for driving horses [n -S] / to beat with a horsewhip [v HORSEWHIPPED, HORSEWHIPPING, HORSEWHIPS]\n",
  "HORSEWHIPPED": "HORSEWHIP, to beat with a horsewhip [v]\n",
  "HORSEWHIPPER": "one who uses a horsewhip [n -S]\n",
  "HORSEWHIPPERS": "HORSEWHIPPER, one who uses a horsewhip [n]\n",
  "HORSEWHIPPING": "HORSEWHIP, to beat with a horsewhip [v]\n",
  "HORSEWHIPS": "HORSEWHIP, to beat with a horsewhip [v]\n",
  "HORSEWOMAN": "a woman who is a rider or a driver of horses [n HORSEWOMEN]\n",
  "HORSEWOMEN": "HORSEWOMAN, a woman who is a rider or a driver of horses [n]\n",
  "HORSEY": "like a horse, also HORSY [adj HORSIER, HORSIEST]\n",
  "HORSIE": "a child's name for a horse [n HORSIES]\n",
  "HORSIER": "HORSEY, like a horse, also HORSY [adj]\n",
  "HORSIES": "HORSIE, a child's name for a horse [n]\n",
  "HORSIEST": "HORSEY, like a horse, also HORSY [adj]\n",
  "HORSILY": "HORSY, like a horse, also HORSEY [adv]\n",
  "HORSINESS": "the state of being horsy [n -ES]\n",
  "HORSINESSES": "HORSINESS, the state of being horsy [n]\n",
  "HORSING": "the birching of a person mounted on another's back [n -S]\n",
  "HORSINGS": "HORSING, the birching of a person mounted on another's back [n]\n",
  "HORSON": "(Shakespeare) a whoreson, a son of a whore [n -S]\n",
  "HORSONS": "HORSON, (Shakespeare) a whoreson, a son of a whore [n]\n",
  "HORST": "(German) a mass of the earth's crust that lies between two faults and is higher than the surrounding land, also HORSTE [n -S]\n",
  "HORSTE": "(German) a mass of the earth's crust that lies between two faults and is higher than the surrounding land, also HORST [n -S]\n",
  "HORSTES": "HORSTE, (German) a mass of the earth's crust that lies between two faults and is higher than the surrounding land, also HORST [n]\n",
  "HORSTS": "HORST, (German) a mass of the earth's crust that lies between two faults and is higher than the surrounding land, also HORSTE [n]\n",
  "HORSY": "like a horse, also HORSEY [adj HORSIER, HORSIEST, HORSILY]\n",
  "HORTATION": "the act of exhorting [n -S]\n",
  "HORTATIONS": "HORTATION, the act of exhorting [n]\n",
  "HORTATIVE": "giving exhortation; advisory, also HORTATORY [adj HORTATIVELY]\n",
  "HORTATIVELY": "HORTATIVE, giving exhortation; advisory, also HORTATORY [adv]\n",
  "HORTATORILY": "HORTATORY, giving exhortation; advisory, also HORTATIVE [adv]\n",
  "HORTATORY": "giving exhortation; advisory, also HORTATIVE [adj HORTATORILY]\n",
  "HORTENSIA": "a hydrangea of a group of varieties that have large rounded flower heads composed chiefly of sterile florets [n -S]\n",
  "HORTENSIAS": "HORTENSIA, a hydrangea of a group of varieties that have large rounded flower heads composed chiefly of sterile florets [n]\n",
  "HORTICULTURAL": "relating to horticulture [adj HORTICULTURALLY]\n",
  "HORTICULTURALLY": "HORTICULTURAL, relating to horticulture [adv]\n",
  "HORTICULTURE": "the science and art of growing fruits, vegetables, flowers, or ornamental plants [n -S]\n",
  "HORTICULTURES": "HORTICULTURE, the science and art of growing fruits, vegetables, flowers, or ornamental plants [n]\n",
  "HORTICULTURIST": "one who practises horticulture [n -S]\n",
  "HORTICULTURISTS": "HORTICULTURIST, one who practises horticulture [n]\n",
  "HOS": "HO, to stop [v]\n",
  "HOSANNA": "(Hebrew) a shout of praise or adoration [n -S] / to shout with praise and adoration, also HOSANNAH [v -ED, -ING, -S]\n",
  "HOSANNAED": "HOSANNA, to shout with praise and adoration, also HOSANNAH [v]\n",
  "HOSANNAH": "a shout of praise [n -S]\n",
  "HOSANNAHS": "HOSANNAH, a shout of praise [n]\n",
  "HOSANNAING": "HOSANNA, to shout with praise and adoration, also HOSANNAH [v]\n",
  "HOSANNAS": "HOSANNA, to shout with praise and adoration, also HOSANNAH [v]\n",
  "HOSE": "to spray with water [v HOSED, HOSING, HOSES] / stockings or socks [n HOSEN]\n",
  "HOSED": "HOSE, to spray with water [v]\n",
  "HOSEL": "a socket in the head of a golf club into which the shaft is inserted [n -S]\n",
  "HOSELIKE": "like a hose [adj]\n",
  "HOSELS": "HOSEL, a socket in the head of a golf club into which the shaft is inserted [n]\n",
  "HOSEMAN": "a fireman who directs the stream of water [n HOSEMEN]\n",
  "HOSEMEN": "HOSEMAN, a fireman who directs the stream of water [n]\n",
  "HOSEN": "HOSE, stockings or socks [n]\n",
  "HOSEPIPE": "a flexible water pipe [n -S]\n",
  "HOSEPIPES": "HOSEPIPE, a flexible water pipe [n]\n",
  "HOSER": "a person who deceives or swindles others [n -S]\n",
  "HOSERS": "HOSER, a person who deceives or swindles others [n]\n",
  "HOSES": "HOSE, to spray with water [v]\n",
  "HOSEY": "to choose sides in a child's game [v -ED, -ING, -S]\n",
  "HOSEYED": "HOSEY, to choose sides in a child's game [v]\n",
  "HOSEYING": "HOSEY, to choose sides in a child's game [v]\n",
  "HOSEYS": "HOSEY, to choose sides in a child's game [v]\n",
  "HOSIER": "a person who makes or deals in hose or stockings, or in these and knitted or woven underwear [n -S]\n",
  "HOSIERIES": "HOSIERY, stockings or socks [n]\n",
  "HOSIERS": "HOSIER, a person who makes or deals in hose or stockings, or in these and knitted or woven underwear [n]\n",
  "HOSIERY": "stockings or socks [n HOSIERIES]\n",
  "HOSING": "HOSE, to spray with water [v]\n",
  "HOSPICE": "a shelter [n -S]\n",
  "HOSPICES": "HOSPICE, a shelter [n]\n",
  "HOSPITABLE": "kind to strangers [adj HOSPITABLY]\n",
  "HOSPITABLENESS": "the state of being hospitable [n]\n",
  "HOSPITABLY": "HOSPITABLE, kind to strangers [adv]\n",
  "HOSPITAGE": "(Spenser) hospitality [n -S]\n",
  "HOSPITAGES": "HOSPITAGE, (Spenser) hospitality [n]\n",
  "HOSPITAL": "a medical institution [n -S]\n",
  "HOSPITALE": "(Spenser) lodging [n -S]\n",
  "HOSPITALER": "(US) a member of a charitable brotherhood for the care of the sick in hospitals, also HOSPITALLER [n -S]\n",
  "HOSPITALERS": "HOSPITALER, (US) a member of a charitable brotherhood for the care of the sick in hospitals, also HOSPITALLER [n]\n",
  "HOSPITALES": "HOSPITALE, (Spenser) lodging [n]\n",
  "HOSPITALISATION": "the act of admitting to hospital, also HOSPITALIZATION [n]\n",
  "HOSPITALISE": "to put into hospital, also HOSPITALIZE [v HOSPITALISED, HOSPITALISING, HOSPITALISES]\n",
  "HOSPITALISED": "HOSPITALISE, to put into hospital, also HOSPITALIZE [v]\n",
  "HOSPITALISES": "HOSPITALISE, to put into hospital, also HOSPITALIZE [v]\n",
  "HOSPITALISING": "HOSPITALISE, to put into hospital, also HOSPITALIZE [v]\n",
  "HOSPITALIST": "a physician who primarily dedicates his or her practice to the care of hospitalized patients [n -S]\n",
  "HOSPITALISTS": "HOSPITALIST, a physician who primarily dedicates his or her practice to the care of hospitalized patients [n]\n",
  "HOSPITALITIES": "HOSPITALITY, hospitable treatment [n]\n",
  "HOSPITALITY": "hospitable treatment [n HOSPITALITIES]\n",
  "HOSPITALIZATION": "the act of admitting to hospital, also HOSPITALISATION [n]\n",
  "HOSPITALIZE": "to place in a hospital as a patient, also HOSPITALISE [v HOSPITALIZED, HOSPITALIZING, HOSPITALIZES]\n",
  "HOSPITALIZED": "HOSPITALIZE, to place in a hospital as a patient, also HOSPITALISE [v]\n",
  "HOSPITALIZES": "HOSPITALIZE, to place in a hospital as a patient, also HOSPITALISE [v]\n",
  "HOSPITALIZING": "HOSPITALIZE, to place in a hospital as a patient, also HOSPITALISE [v]\n",
  "HOSPITALLER": "a member of a charitable brotherhood for the care of the sick in hospitals, also HOSPITALER [n -S]\n",
  "HOSPITALLERS": "HOSPITALLER, a member of a charitable brotherhood for the care of the sick in hospitals, also HOSPITALER [n]\n",
  "HOSPITALS": "HOSPITAL, a medical institution [n]\n",
  "HOSPITIA": "HOSPITIUM, (Latin) a nursing home for the terminally ill [n]\n",
  "HOSPITIUM": "(Latin) a nursing home for the terminally ill [n HOSPITIA]\n",
  "HOSPODAR": "(historical) a prince or governor, esp. of Moldavia or Wallachia, also GOSPODAR [n -S]\n",
  "HOSPODARS": "HOSPODAR, (historical) a prince or governor, esp. of Moldavia or Wallachia, also GOSPODAR [n]\n",
  "HOSS": "(slang) a horse [n -ES]\n",
  "HOSSES": "HOSS, (slang) a horse [n]\n",
  "HOST": "to entertain socially [v -ED, -ING, -S]\n",
  "HOSTA": "any plant of the liliaceous genus Hosta [n -S]\n",
  "HOSTAGE": "a person held as security [n -S]\n",
  "HOSTAGES": "HOSTAGE, a person held as security [n]\n",
  "HOSTAS": "HOSTA, any plant of the liliaceous genus Hosta [n]\n",
  "HOSTED": "HOST, to entertain socially [v]\n",
  "HOSTEL": "to stay overnight in hostels when travelling [v HOSTELED or HOSTELLED, HOSTELING or HOSTELLING, HOSTELS]\n",
  "HOSTELED": "HOSTEL, to stay overnight in hostels when travelling [v]\n",
  "HOSTELER": "a person who lives in or uses a hostel, esp. a youth hostel, also HOSTELLER [n -S]\n",
  "HOSTELERS": "HOSTELER, a person who lives in or uses a hostel, esp. a youth hostel, also HOSTELLER [n]\n",
  "HOSTELING": "the act of staying overnight in hostels when travelling, also HOSTELLING [n -S]\n",
  "HOSTELINGS": "HOSTELING, the act of staying overnight in hostels when travelling, also HOSTELLING [n]\n",
  "HOSTELLED": "HOSTEL, to stay overnight in hostels when travelling [v]\n",
  "HOSTELLER": "a person who lives in or uses a hostel, esp. a youth hostel, also HOSTELER [n -S]\n",
  "HOSTELLERS": "HOSTELLER, a person who lives in or uses a hostel, esp. a youth hostel, also HOSTELER [n]\n",
  "HOSTELLING": "the act of staying overnight in hostels when travelling, also HOSTELING [n -S]\n",
  "HOSTELLINGS": "HOSTELLING, the act of staying overnight in hostels when travelling, also HOSTELING [n]\n",
  "HOSTELRIES": "HOSTELRY, an inn [n]\n",
  "HOSTELRY": "an inn [n HOSTELRIES]\n",
  "HOSTELS": "HOSTEL, to stay overnight in hostels when travelling [v]\n",
  "HOSTESS": "to act as a woman who entertains socially [v -ED, -ING, -ES]\n",
  "HOSTESSED": "HOSTESS, to act as a woman who entertains socially [v]\n",
  "HOSTESSES": "HOSTESS, to act as a woman who entertains socially [v]\n",
  "HOSTESSING": "HOSTESS, to act as a woman who entertains socially [v]\n",
  "HOSTIE": "(Australian slang) an air hostess [n -S]\n",
  "HOSTIES": "HOSTIE, (Australian slang) an air hostess [n]\n",
  "HOSTILE": "like an enemy [adj HOSTILELY] / an enemy [n -S]\n",
  "HOSTILELY": "HOSTILE, like an enemy [adv]\n",
  "HOSTILES": "HOSTILE, an enemy [n]\n",
  "HOSTILITIES": "HOSTILITY, the state of being hostile [n]\n",
  "HOSTILITY": "the state of being hostile [n HOSTILITIES]\n",
  "HOSTING": "a battle, a muster [n -S]\n",
  "HOSTINGS": "HOSTING, a battle, a muster [n]\n",
  "HOSTLER": "one who tends horses at an inn, also OSTLER [n -S]\n",
  "HOSTLERS": "HOSTLER, one who tends horses at an inn, also OSTLER [n]\n",
  "HOSTLESS": "lacking a host, also HOSTLESSE [adj]\n",
  "HOSTLESSE": "(Spenser) inhospitable, also HOSTLESS [adj]\n",
  "HOSTLY": "pertaining to one who hosts [adj]\n",
  "HOSTRIES": "HOSTRY, (Spenser) a hostelry; an inn or lodging house [n]\n",
  "HOSTRY": "(Spenser) a hostelry; an inn or lodging house [n HOSTRIES]\n",
  "HOSTS": "HOST, to entertain socially [v]\n",
  "HOT": "having a high temperature [adj HOTTER, HOTTEST] / to heat [v HOTTED, HOTTING, HOTS]\n",
  "HOTBED": "a place favourable to rapid growth [n -S]\n",
  "HOTBEDS": "HOTBED, a place favourable to rapid growth [n]\n",
  "HOTBLOOD": "a reckless person [n -S]\n",
  "HOTBLOODS": "HOTBLOOD, a reckless person [n]\n",
  "HOTBOX": "to smoke marijuana in a small confined area until it is full of smoke [v -ED, -ING, -ES]\n",
  "HOTBOXED": "HOTBOX, to smoke marijuana in a small confined area until it is full of smoke [v]\n",
  "HOTBOXES": "HOTBOX, to smoke marijuana in a small confined area until it is full of smoke [v]\n",
  "HOTBOXING": "HOTBOX, to smoke marijuana in a small confined area until it is full of smoke [v]\n",
  "HOTCAKE": "(US) a griddlecake [n -S]\n",
  "HOTCAKES": "HOTCAKE, (US) a griddlecake [n]\n",
  "HOTCH": "(Scots) to hitch, jog [v -ED, -ING, -ES]\n",
  "HOTCHED": "HOTCH, (Scots) to hitch, jog [v]\n",
  "HOTCHES": "HOTCH, (Scots) to hitch, jog [v]\n",
  "HOTCHING": "HOTCH, (Scots) to hitch, jog [v]\n",
  "HOTCHPOT": "a confused mass of ingredients shaken or mixed together in the same pot, also HODGEPODGE, HOTCHPOTCH [n -S]\n",
  "HOTCHPOTCH": "a confused mass of ingredients shaken or mixed together in the same pot, also HODGEPODGE, HOTCHPOT [n -ES]\n",
  "HOTCHPOTCHES": "HOTCHPOTCH, a confused mass of ingredients shaken or mixed together in the same pot, also HODGEPODGE, HOTCHPOT [n]\n",
  "HOTCHPOTS": "HOTCHPOT, a confused mass of ingredients shaken or mixed together in the same pot, also HODGEPODGE, HOTCHPOTCH [n]\n",
  "HOTDOG": "to perform in a showy manner [v HOTDOGGED, HOTDOGGING, HOTDOGS]\n",
  "HOTDOGGED": "HOTDOG, to perform in a showy manner [v]\n",
  "HOTDOGGER": "one who hotdogs, shows off [n -S]\n",
  "HOTDOGGERS": "HOTDOGGER, one who hotdogs, shows off [n]\n",
  "HOTDOGGING": "HOTDOG, to perform in a showy manner [v]\n",
  "HOTDOGS": "HOTDOG, to perform in a showy manner [v]\n",
  "HOTE": "HIGHT, (archaic) to command, also HECHT, HETE [v]\n",
  "HOTEL": "an inn [n -S]\n",
  "HOTELDOM": "hotels and hotel workers [n -S]\n",
  "HOTELDOMS": "HOTELDOM, hotels and hotel workers [n]\n",
  "HOTELIER": "(French) a hotel manager, also HOTELMAN [n -S]\n",
  "HOTELIERS": "HOTELIER, (French) a hotel manager, also HOTELMAN [n]\n",
  "HOTELING": "(in an office where hot-desking is practised) the advance booking of a desk by an employee [n -S]\n",
  "HOTELINGS": "HOTELING, (in an office where hot-desking is practised) the advance booking of a desk by an employee [n]\n",
  "HOTELLING": "(in an office where hot-desking is practised) the advance booking of a desk by an employee, also HOTELING [n -S]\n",
  "HOTELLINGS": "HOTELLING, (in an office where hot-desking is practised) the advance booking of a desk by an employee, also HOTELING [n]\n",
  "HOTELMAN": "a hotel manager, also HOTELIER [n HOTELMEN]\n",
  "HOTELMEN": "HOTELMAN, a hotel manager, also HOTELIER [n]\n",
  "HOTELS": "HOTEL, an inn [n]\n",
  "HOTEN": "HIGHT, (archaic) to command, also HECHT, HETE [v]\n",
  "HOTFOOT": "to hurry [v -ED, -ING, -S]\n",
  "HOTFOOTED": "HOTFOOT, to hurry [v]\n",
  "HOTFOOTING": "HOTFOOT, to hurry [v]\n",
  "HOTFOOTS": "HOTFOOT, to hurry [v]\n",
  "HOTHEAD": "an impetuous person [n -S]\n",
  "HOTHEADED": "rash, impetuous [adj HOTHEADEDLY]\n",
  "HOTHEADEDLY": "HOTHEADED, rash, impetuous [adv]\n",
  "HOTHEADEDNESS": "HOTHEADED, rash, impetuous [n]\n",
  "HOTHEADEDNESSES": "HOTHEADEDNESS, HOTHEADED, rash, impetuous [n]\n",
  "HOTHEADS": "HOTHEAD, an impetuous person [n]\n",
  "HOTHOUSE": "to rear intensively [v HOTHOUSED, HOTHOUSING, HOTHOUSES]\n",
  "HOTHOUSED": "HOTHOUSE, to rear intensively [v]\n",
  "HOTHOUSES": "HOTHOUSE, to rear intensively [v]\n",
  "HOTHOUSING": "the act of rearing intensively [n -S]\n",
  "HOTHOUSINGS": "HOTHOUSING, the act of rearing intensively [n]\n",
  "HOTLINE": "a direct communications system for immediate contact [n -S]\n",
  "HOTLINER": "someone running a radio call-in show [n -S]\n",
  "HOTLINERS": "HOTLINER, someone running a radio call-in show [n]\n",
  "HOTLINES": "HOTLINE, a direct communications system for immediate contact [n]\n",
  "HOTLINK": "an area on a website connecting to another site [n -S]\n",
  "HOTLINKS": "HOTLINK, an area on a website connecting to another site [n]\n",
  "HOTLY": "HOT, having a high temperature [adv]\n",
  "HOTNESS": "the state of being hot [n -ES]\n",
  "HOTNESSES": "HOTNESS, the state of being hot [n]\n",
  "HOTPLATE": "an electrically heated cooking plate [n -S]\n",
  "HOTPLATES": "HOTPLATE, an electrically heated cooking plate [n]\n",
  "HOTPOT": "a stewed dish of chopped meat and potatoes [n -S]\n",
  "HOTPOTS": "HOTPOT, a stewed dish of chopped meat and potatoes [n]\n",
  "HOTPRESS": "to subject to heat and pressure, e.g. for the purpose of giving a smooth and glossy surface [v -ED, -ING, -ES]\n",
  "HOTPRESSED": "HOTPRESS, to subject to heat and pressure, e.g. for the purpose of giving a smooth and glossy surface [v]\n",
  "HOTPRESSES": "HOTPRESS, to subject to heat and pressure, e.g. for the purpose of giving a smooth and glossy surface [v]\n",
  "HOTPRESSING": "HOTPRESS, to subject to heat and pressure, e.g. for the purpose of giving a smooth and glossy surface [v]\n",
  "HOTROD": "a motorcar converted for speed by stripping off inessentials [n -S]\n",
  "HOTRODS": "HOTROD, a motorcar converted for speed by stripping off inessentials [n]\n",
  "HOTS": "HOT, to heat [v]\n",
  "HOTSHOT": "an important or exceptionally able person [n -S]\n",
  "HOTSHOTS": "HOTSHOT, an important or exceptionally able person [n]\n",
  "HOTSPOT": "an area known for violence or unrest [n -S]\n",
  "HOTSPOTS": "HOTSPOT, an area known for violence or unrest [n]\n",
  "HOTSPUR": "a rash, hotheaded man [n -S]\n",
  "HOTSPURS": "HOTSPUR, a rash, hotheaded man [n]\n",
  "HOTTED": "HOT, to heat [v]\n",
  "HOTTENTOT": "a small fish [n -S]\n",
  "HOTTENTOTS": "HOTTENTOT, a small fish [n]\n",
  "HOTTER": "to vibrate, to tremble [v -ED, -ING, -S]\n",
  "HOTTERED": "HOTTER, to vibrate, to tremble [v]\n",
  "HOTTERING": "HOTTER, to vibrate, to tremble [v]\n",
  "HOTTERS": "HOTTER, to vibrate, to tremble [v]\n",
  "HOTTEST": "HOT, having a high temperature [adj]\n",
  "HOTTIE": "a hot-water bottle, a sexually attractive person, also HOTTY [n -S]\n",
  "HOTTIES": "HOTTIE, a hot-water bottle, a sexually attractive person, also HOTTY [n]\n",
  "HOTTING": "attempting stunts in stolen powerful cars [n -S]\n",
  "HOTTINGS": "HOTTING, attempting stunts in stolen powerful cars [n]\n",
  "HOTTISH": "somewhat hot [adj]\n",
  "HOTTY": "a hot-water bottle, a sexually attractive person, also HOTTIE [n HOTTIES]\n",
  "HOUDAH": "(Arabic) a seat on an elephant's back, also HOWDAH [n -S]\n",
  "HOUDAHS": "HOUDAH, (Arabic) a seat on an elephant's back, also HOWDAH [n]\n",
  "HOUDAN": "(French) a type of domestic fowl [n -S]\n",
  "HOUDANS": "HOUDAN, (French) a type of domestic fowl [n]\n",
  "HOUF": "(Scots) a place where one is often found, a haunt [n -S] / to haunt, frequent, also HOUFF, HOWF, HOWFF [v -ED, -ING, -S]\n",
  "HOUFED": "HOUF, to haunt, frequent, also HOUFF, HOWF, HOWFF [v]\n",
  "HOUFF": "(Scots) a place where one is often found, a haunt [n -S] / to haunt, frequent, also HOUF, HOWF, HOWFF [v -ED, -ING, -S]\n",
  "HOUFFED": "HOUFF, to haunt, frequent, also HOUF, HOWF, HOWFF [v]\n",
  "HOUFFING": "HOUFF, to haunt, frequent, also HOUF, HOWF, HOWFF [v]\n",
  "HOUFFS": "HOUFF, to haunt, frequent, also HOUF, HOWF, HOWFF [v]\n",
  "HOUFING": "HOUF, to haunt, frequent, also HOUFF, HOWF, HOWFF [v]\n",
  "HOUFS": "HOUF, to haunt, frequent, also HOUFF, HOWF, HOWFF [v]\n",
  "HOUGH": "to hamstring [v -ED, -ING, -S]\n",
  "HOUGHED": "HOUGH, to hamstring [v]\n",
  "HOUGHING": "HOUGH, to hamstring [v]\n",
  "HOUGHMAGANDIE": "fornication, also HOCHMAGANDY [n -S]\n",
  "HOUGHMAGANDIES": "HOUGHMAGANDIE, fornication, also HOCHMAGANDY [n]\n",
  "HOUGHS": "HOUGH, to hamstring [v]\n",
  "HOUHERE": "(Maori) a small evergreen New Zealand tree [n -S]\n",
  "HOUHERES": "HOUHERE, (Maori) a small evergreen New Zealand tree [n]\n",
  "HOUMMOS": "(Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMOUS, HOUMUS, HUMMUS, HUMOUSES [n -ES]\n",
  "HOUMMOSES": "HOUMMOS, (Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMOUS, HOUMUS, HUMMUS, HUMOUSES [n]\n",
  "HOUMOUS": "(Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMMOS, HOUMUS, HUMMUS, HUMOUSES [n -ES]\n",
  "HOUMOUSES": "HOUMOUS, (Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMMOS, HOUMUS, HUMMUS, HUMOUSES [n]\n",
  "HOUMUS": "(Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMMOS, HOUMOUS, HUMMUS, HUMOUSES [n -ES]\n",
  "HOUMUSES": "HOUMUS, (Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMMOS, HOUMOUS, HUMMUS, HUMOUSES [n]\n",
  "HOUND": "to pursue relentlessly [v -ED, -ING, -S]\n",
  "HOUNDED": "HOUND, to pursue relentlessly [v]\n",
  "HOUNDER": "one who hounds [n -S]\n",
  "HOUNDERS": "HOUNDER, one who hounds [n]\n",
  "HOUNDFISH": "a name given to various species of small shark or dogfish [n -ES]\n",
  "HOUNDFISHES": "HOUNDFISH, a name given to various species of small shark or dogfish [n]\n",
  "HOUNDING": "HOUND, to pursue relentlessly [v]\n",
  "HOUNDS": "HOUND, to pursue relentlessly [v]\n",
  "HOUNGAN": "a voodoo priest, also HUNGAN [n -S]\n",
  "HOUNGANS": "HOUNGAN, a voodoo priest, also HUNGAN [n]\n",
  "HOUR": "a period of sixty minutes, also HOWRE [n -S]\n",
  "HOURGLASS": "an instrument for measuring the hours by the running of sand through a narrow neck [n -ES]\n",
  "HOURGLASSES": "HOURGLASS, an instrument for measuring the hours by the running of sand through a narrow neck [n]\n",
  "HOURI": "(Persian) any of the virgins of the Muslim paradise, promised as wives to believers [n -S]\n",
  "HOURIS": "HOURI, (Persian) any of the virgins of the Muslim paradise, promised as wives to believers [n]\n",
  "HOURLIES": "HOURLY, something done every hour [n]\n",
  "HOURLONG": "lasting an hour [adj]\n",
  "HOURLY": "every hour [adj] / something done every hour [n HOURLIES]\n",
  "HOURPLATE": "a timepiece dial [n -S]\n",
  "HOURPLATES": "HOURPLATE, a timepiece dial [n]\n",
  "HOURS": "HOUR, a period of sixty minutes, also HOWRE [n]\n",
  "HOUSE": "to reside in a building [v HOUSED, HOUSING, HOUSES]\n",
  "HOUSEBOAT": "a boat moored and used as a permanent residence [n -S]\n",
  "HOUSEBOATER": "one who lives on a houseboat [n -S]\n",
  "HOUSEBOATERS": "HOUSEBOATER, one who lives on a houseboat [n]\n",
  "HOUSEBOATS": "HOUSEBOAT, a boat moored and used as a permanent residence [n]\n",
  "HOUSEBOUND": "confined to the house [adj]\n",
  "HOUSEBOY": "a male servant [n -S]\n",
  "HOUSEBOYS": "HOUSEBOY, a male servant [n]\n",
  "HOUSEBREAK": "to train a pet not to relieve itself indoors [v HOUSEBROKE, HOUSEBROKEN, HOUSEBREAKING, HOUSEBREAKS]\n",
  "HOUSEBREAKER": "a person who breaks into and enters a house for the purpose of stealing [n -S]\n",
  "HOUSEBREAKERS": "HOUSEBREAKER, a person who breaks into and enters a house for the purpose of stealing [n]\n",
  "HOUSEBREAKING": "the act of breaking into a house for the purpose of stealing [n -S]\n",
  "HOUSEBREAKINGS": "HOUSEBREAKING, the act of breaking into a house for the purpose of stealing [n]\n",
  "HOUSEBREAKS": "HOUSEBREAK, to train a pet not to relieve itself indoors [v]\n",
  "HOUSEBROKE": "HOUSEBREAK, to train a pet not to relieve itself indoors [v]\n",
  "HOUSEBROKEN": "HOUSEBREAK, to train a pet not to relieve itself indoors [v]\n",
  "HOUSECARL": "(Old English) a household retainer of an Anglo-Saxon leader [n -S]\n",
  "HOUSECARLS": "HOUSECARL, (Old English) a household retainer of an Anglo-Saxon leader [n]\n",
  "HOUSECLEAN": "to clean a house and its furniture [v -ED, -ING, -S]\n",
  "HOUSECLEANED": "HOUSECLEAN, to clean a house and its furniture [v]\n",
  "HOUSECLEANING": "the act of cleaning house [n -S]\n",
  "HOUSECLEANINGS": "HOUSECLEANING, the act of cleaning house [n]\n",
  "HOUSECLEANS": "HOUSECLEAN, to clean a house and its furniture [v]\n",
  "HOUSECOAT": "a woman's usually long coat-like dressing-gown, worn at home [n -S]\n",
  "HOUSECOATS": "HOUSECOAT, a woman's usually long coat-like dressing-gown, worn at home [n]\n",
  "HOUSECRAFT": "the craft of looking after a house [n -S]\n",
  "HOUSECRAFTS": "HOUSECRAFT, the craft of looking after a house [n]\n",
  "HOUSED": "HOUSE, to reside in a building [v]\n",
  "HOUSEDRESS": "a dress with simple lines that is suitable for housework and is made usually of a washable fabric [n -ES]\n",
  "HOUSEDRESSES": "HOUSEDRESS, a dress with simple lines that is suitable for housework and is made usually of a washable fabric [n]\n",
  "HOUSEFATHER": "a man in charge of a dormitory, hall, or hostel [n -S]\n",
  "HOUSEFATHERS": "HOUSEFATHER, a man in charge of a dormitory, hall, or hostel [n]\n",
  "HOUSEFLIES": "HOUSEFLY, a common fly [n]\n",
  "HOUSEFLY": "a common fly [n HOUSEFLIES]\n",
  "HOUSEFRONT": "the facade of a house [n -S]\n",
  "HOUSEFRONTS": "HOUSEFRONT, the facade of a house [n]\n",
  "HOUSEFUL": "as much as a house can hold [n -S]\n",
  "HOUSEFULS": "HOUSEFUL, as much as a house can hold [n]\n",
  "HOUSEGUEST": "a guest in a private house [n -S]\n",
  "HOUSEGUESTS": "HOUSEGUEST, a guest in a private house [n]\n",
  "HOUSEHOLD": "those who are held together in the same house, and compose a family [n -S]\n",
  "HOUSEHOLDER": "a person who occupies a house or tenement alone or as the head of a household [n -S]\n",
  "HOUSEHOLDERS": "HOUSEHOLDER, a person who occupies a house or tenement alone or as the head of a household [n]\n",
  "HOUSEHOLDERSHIP": "the office of householder [n]\n",
  "HOUSEHOLDS": "HOUSEHOLD, those who are held together in the same house, and compose a family [n]\n",
  "HOUSEHUSBAND": "a husband who does housekeeping usually while his wife earns the family income [n -S]\n",
  "HOUSEHUSBANDS": "HOUSEHUSBAND, a husband who does housekeeping usually while his wife earns the family income [n]\n",
  "HOUSEKEEP": "to keep house [v HOUSEKEPT, HOUSEKEEPING, HOUSEKEEPS]\n",
  "HOUSEKEEPER": "a woman employed to keep house [n -S]\n",
  "HOUSEKEEPERS": "HOUSEKEEPER, a woman employed to keep house [n]\n",
  "HOUSEKEEPING": "the business of keeping house [n -S]\n",
  "HOUSEKEEPINGS": "HOUSEKEEPING, the business of keeping house [n]\n",
  "HOUSEKEEPS": "HOUSEKEEP, to keep house [v]\n",
  "HOUSEKEPT": "HOUSEKEEP, to keep house [v]\n",
  "HOUSEL": "to administer the Eucharist to [v HOUSELED or HOUSELLED, HOUSELING or HOUSELLING, HOUSELS]\n",
  "HOUSELED": "HOUSEL, to administer the Eucharist to [v]\n",
  "HOUSELEEK": "a plant of the leek family [n -S]\n",
  "HOUSELEEKS": "HOUSELEEK, a plant of the leek family [n]\n",
  "HOUSELESS": "without a house [adj]\n",
  "HOUSELESSNESS": "the state of being houseless [n -ES]\n",
  "HOUSELESSNESSES": "HOUSELESSNESS, the state of being houseless [n]\n",
  "HOUSELIGHTS": "in a theatre, the lights illuminating the auditorium [n]\n",
  "HOUSELIKE": "like a house [adj]\n",
  "HOUSELINE": "tarred marline, a line of two loosely twisted strands [n -S]\n",
  "HOUSELINES": "HOUSELINE, tarred marline, a line of two loosely twisted strands [n]\n",
  "HOUSELING": "the act of administering the Eucharist, also HOUSLING, HOUSELLING [n -S]\n",
  "HOUSELINGS": "HOUSELING, the act of administering the Eucharist, also HOUSLING, HOUSELLING [n]\n",
  "HOUSELLED": "HOUSEL, to administer the Eucharist to [v]\n",
  "HOUSELLING": "the act of administering the Eucharist, also HOUSELING, HOUSLING [n -S]\n",
  "HOUSELLINGS": "HOUSELLING, the act of administering the Eucharist, also HOUSELING, HOUSLING [n]\n",
  "HOUSELS": "HOUSEL, to administer the Eucharist to [v]\n",
  "HOUSEMAID": "a maid employed to keep a house clean, etc. [n -S]\n",
  "HOUSEMAIDS": "HOUSEMAID, a maid employed to keep a house clean, etc. [n]\n",
  "HOUSEMAN": "a male servant [n HOUSEMEN]\n",
  "HOUSEMASTER": "a master in charge of a house in a boy's boarding school [n -S]\n",
  "HOUSEMASTERS": "HOUSEMASTER, a master in charge of a house in a boy's boarding school [n]\n",
  "HOUSEMATE": "one who dwells in the same house with another [n -S]\n",
  "HOUSEMATES": "HOUSEMATE, one who dwells in the same house with another [n]\n",
  "HOUSEMEN": "HOUSEMAN, a male servant [n]\n",
  "HOUSEMISTRESS": "the female head of a (boarding-)house, esp. in connection with a public school [n -ES]\n",
  "HOUSEMISTRESSES": "HOUSEMISTRESS, the female head of a (boarding-)house, esp. in connection with a public school [n]\n",
  "HOUSEMOTHER": "a woman in charge of children in an institution [n -S]\n",
  "HOUSEMOTHERS": "HOUSEMOTHER, a woman in charge of children in an institution [n]\n",
  "HOUSEPAINTER": "one whose business or occupation is painting houses [n -S]\n",
  "HOUSEPAINTERS": "HOUSEPAINTER, one whose business or occupation is painting houses [n]\n",
  "HOUSEPARENT": "a man or woman in charge of children in an institution [n -S]\n",
  "HOUSEPARENTS": "HOUSEPARENT, a man or woman in charge of children in an institution [n]\n",
  "HOUSEPERSON": "a person who does housekeeping [n -S]\n",
  "HOUSEPERSONS": "HOUSEPERSON, a person who does housekeeping [n]\n",
  "HOUSEPLANT": "a plant grown or kept indoors [n -S]\n",
  "HOUSEPLANTS": "HOUSEPLANT, a plant grown or kept indoors [n]\n",
  "HOUSER": "one who organizes housing projects [n -S]\n",
  "HOUSEROOM": "room or place in a house; as, to give any one houseroom [n -S]\n",
  "HOUSEROOMS": "HOUSEROOM, room or place in a house; as, to give any one houseroom [n]\n",
  "HOUSERS": "HOUSER, one who organizes housing projects [n]\n",
  "HOUSES": "HOUSE, to reside in a building [v]\n",
  "HOUSESAT": "HOUSESIT, to look after someone's house in their absence [v]\n",
  "HOUSESIT": "to look after someone's house in their absence [v HOUSESAT, HOUSESITTING, HOUSESITS]\n",
  "HOUSESITS": "HOUSESIT, to look after someone's house in their absence [v]\n",
  "HOUSESITTING": "HOUSESIT, to look after someone's house in their absence [v]\n",
  "HOUSETOP": "the roof of a house [n -S]\n",
  "HOUSETOPS": "HOUSETOP, the roof of a house [n]\n",
  "HOUSEWARES": "wares used in the house [n]\n",
  "HOUSEWARMING": "a party to celebrate the taking possession of a house or premises [n -S]\n",
  "HOUSEWARMINGS": "HOUSEWARMING, a party to celebrate the taking possession of a house or premises [n]\n",
  "HOUSEWIFE": "a married woman who looks after the house and family and does not have a paid job, also HUSSIF, HUSWIFE [n HOUSEWIVES]\n",
  "HOUSEWIFELIER": "HOUSEWIFELY, like a housewife, also HOUSEWIFEY [adj]\n",
  "HOUSEWIFELIEST": "HOUSEWIFELY, like a housewife, also HOUSEWIFEY [adj]\n",
  "HOUSEWIFELINESS": "HOUSEWIFEY, like a housewife, also HOUSEWIFELY [adj]\n",
  "HOUSEWIFELY": "like a housewife, also HOUSEWIFEY [adj HOUSEWIFELIER, HOUSEWIFELIEST]\n",
  "HOUSEWIFERIES": "HOUSEWIFERY, the work of a housewife [n]\n",
  "HOUSEWIFERY": "the work of a housewife [n HOUSEWIFERIES]\n",
  "HOUSEWIFESHIP": "being a housewife [n -S]\n",
  "HOUSEWIFESHIPS": "HOUSEWIFESHIP, being a housewife [n]\n",
  "HOUSEWIFESKEP": "(Scots) being a housewife [n -S]\n",
  "HOUSEWIFESKEPS": "HOUSEWIFESKEP, (Scots) being a housewife [n]\n",
  "HOUSEWIFEY": "like a housewife, also HOUSEWIFELY [adj HOUSEWIFIER, HOUSEWIFIEST]\n",
  "HOUSEWIFIER": "HOUSEWIFEY, like a housewife, also HOUSEWIFELY [adj]\n",
  "HOUSEWIFIEST": "HOUSEWIFEY, like a housewife, also HOUSEWIFELY [adj]\n",
  "HOUSEWIVES": "HOUSEWIFE, a married woman who looks after the house and family and does not have a paid job, also HUSSIF, HUSWIFE [n]\n",
  "HOUSEWORK": "the work of looking after a house [n -S]\n",
  "HOUSEWORKER": "one who does housework [n -S]\n",
  "HOUSEWORKERS": "HOUSEWORKER, one who does housework [n]\n",
  "HOUSEWORKS": "HOUSEWORK, the work of looking after a house [n]\n",
  "HOUSEWRAP": "a shawl or loose robe worn in the house [n -S]\n",
  "HOUSEWRAPS": "HOUSEWRAP, a shawl or loose robe worn in the house [n]\n",
  "HOUSEY": "typical of house music (disco mixes) [adj HOUSIER, HOUSIEST]\n",
  "HOUSIER": "HOUSEY, typical of house music (disco mixes) [adj]\n",
  "HOUSIEST": "HOUSEY, typical of house music (disco mixes) [adj]\n",
  "HOUSING": "any dwelling house [n -S]\n",
  "HOUSINGS": "HOUSING, any dwelling house [n]\n",
  "HOUSLING": "the act of administering the Eucharist, also HOUSELING, HOUSELLING [n -S]\n",
  "HOUSLINGS": "HOUSLING, the act of administering the Eucharist, also HOUSELING, HOUSELLING [n]\n",
  "HOUSTONIA": "a small North American plant with blue, white or purple flowers [n -S]\n",
  "HOUSTONIAS": "HOUSTONIA, a small North American plant with blue, white or purple flowers [n]\n",
  "HOUT": "to make a sound like an owl, also HOOT, WHOOT [v -ED, -ING, -S]\n",
  "HOUTED": "HOUT, to make a sound like an owl, also HOOT, WHOOT [v]\n",
  "HOUTING": "(Dutch) a European food fish with white flesh [n -S]\n",
  "HOUTINGS": "HOUTING, (Dutch) a European food fish with white flesh [n]\n",
  "HOUTS": "HOUT, to make a sound like an owl, also HOOT, WHOOT [v]\n",
  "HOVE": "to swell [v HOVED, HOVEN, HOVING, HOVES]\n",
  "HOVEA": "an Australian shrub with purple flowers [n -S]\n",
  "HOVEAS": "HOVEA, an Australian shrub with purple flowers [n]\n",
  "HOVED": "HOVE, to swell [v]\n",
  "HOVEL": "to live in a wretched dwelling [v HOVELED or HOVELLED, HOVELING or HOVELLING, HOVELS]\n",
  "HOVELED": "HOVEL, to live in a wretched dwelling [v]\n",
  "HOVELING": "HOVEL, to live in a wretched dwelling [v]\n",
  "HOVELLED": "HOVEL, to live in a wretched dwelling [v]\n",
  "HOVELLER": "a small coasting-vessel [n -S]\n",
  "HOVELLERS": "HOVELLER, a small coasting-vessel [n]\n",
  "HOVELLING": "HOVEL, to live in a wretched dwelling [v]\n",
  "HOVELS": "HOVEL, to live in a wretched dwelling [v]\n",
  "HOVEN": "having hoove, a disease of cattle and sheep, also HOOVEN [adj]\n",
  "HOVER": "to hang suspended in the air [v -ED, -ING, -S]\n",
  "HOVERBOARD": "a narrow horizontal board with wheels at each end, on which a person may stand upright and move by leaning forwards [n -S]\n",
  "HOVERBOARDS": "HOVERBOARD, a narrow horizontal board with wheels at each end, on which a person may stand upright and move by leaning forwards [n]\n",
  "HOVERCRAFT": "a vehicle that is able to travel across both land and water on a cushion of air [n -S]\n",
  "HOVERCRAFTS": "HOVERCRAFT, a vehicle that is able to travel across both land and water on a cushion of air [n]\n",
  "HOVERED": "HOVER, to hang suspended in the air [v]\n",
  "HOVERER": "that which hovers [n -S]\n",
  "HOVERERS": "HOVERER, that which hovers [n]\n",
  "HOVERFLIES": "HOVERFLY, a fly noted for hovering [n]\n",
  "HOVERFLY": "a fly noted for hovering [n HOVERFLIES]\n",
  "HOVERING": "HOVER, to hang suspended in the air [v]\n",
  "HOVERINGLY": "HOVERING, HOVER, to hang suspended in the air [adv]\n",
  "HOVERPORT": "a port for hovercraft [n -S]\n",
  "HOVERPORTS": "HOVERPORT, a port for hovercraft [n]\n",
  "HOVERS": "HOVER, to hang suspended in the air [v]\n",
  "HOVERTRAIN": "a train that moves supported by a cushion of air, like a hovercraft [n -S]\n",
  "HOVERTRAINS": "HOVERTRAIN, a train that moves supported by a cushion of air, like a hovercraft [n]\n",
  "HOVES": "HOVE, to swell [v]\n",
  "HOVING": "HOVE, to swell [v]\n",
  "HOW": "a low hill, also HOWE [n -S]\n",
  "HOWBE": "(Spenser) be it how it may, also HOWBEIT [conj]\n",
  "HOWBEIT": "notwithstanding [conj]\n",
  "HOWDAH": "(Arabic) a seat on an elephant's back, also HOUDAH [n -S]\n",
  "HOWDAHS": "HOWDAH, (Arabic) a seat on an elephant's back, also HOUDAH [n]\n",
  "HOWDIE": "to greet (= how do you do'), also HOWDY [v HOWDIED, HOWDYING, HOWDIES]\n",
  "HOWDIED": "HOWDY, to greet (= how do you do), also HOWDIE [v]\n",
  "HOWDIES": "HOWDY, to greet (= how do you do), also HOWDIE [v]\n",
  "HOWDY": "to greet (= how do you do), also HOWDIE [v HOWDIED, HOWDYING, HOWDIES]\n",
  "HOWDYING": "HOWDY, to greet (= how do you do), also HOWDIE [v]\n",
  "HOWE": "a hill, a burial-mound, also HOW [n -S]\n",
  "HOWES": "HOWE, a hill, a burial-mound, also HOW [n]\n",
  "HOWEVER": "nevertheless [adv]\n",
  "HOWF": "(Scots) a place where one is often found, a haunt [n -S] / to haunt, frequent, also HOUF, HOUFF, HOWFF [v -ED, -ING, -S]\n",
  "HOWFED": "HOWF, to haunt, frequent, also HOUF, HOUFF, HOWFF [v]\n",
  "HOWFF": "(Scots) a place where one is often found, a haunt [n -S] / to haunt, frequent, also HOUF, HOUFF, HOWF [v -ED, -ING, -S]\n",
  "HOWFFED": "HOWFF, to haunt, frequent, also HOUF, HOUFF, HOWF [v]\n",
  "HOWFFING": "HOWFF, to haunt, frequent, also HOUF, HOUFF, HOWF [v]\n",
  "HOWFFS": "HOWFF, to haunt, frequent, also HOUF, HOUFF, HOWF [v]\n",
  "HOWFING": "HOWF, to haunt, frequent, also HOUF, HOUFF, HOWFF [v]\n",
  "HOWFS": "HOWF, to haunt, frequent, also HOUF, HOUFF, HOWFF [v]\n",
  "HOWITZER": "(German) a short relatively light gun for the high-angle firing of shells at a low velocity [n -S]\n",
  "HOWITZERS": "HOWITZER, (German) a short relatively light gun for the high-angle firing of shells at a low velocity [n]\n",
  "HOWK": "(Scots) to dig, burrow, also HOLK [v -ED, -ING, -S]\n",
  "HOWKED": "HOWK, (Scots) to dig, burrow, also HOLK [v]\n",
  "HOWKER": "a two-masted Dutch or Irish fishing-vessel [n -S]\n",
  "HOWKERS": "HOWKER, a two-masted Dutch or Irish fishing-vessel [n]\n",
  "HOWKING": "HOWK, (Scots) to dig, burrow, also HOLK [v]\n",
  "HOWKS": "HOWK, (Scots) to dig, burrow, also HOLK [v]\n",
  "HOWL": "to cry like a dog [v -ED, -ING, -S]\n",
  "HOWLBACK": "a condition resulting in a howling noise when recording from a mike, also HOWLROUND [n -S]\n",
  "HOWLBACKS": "HOWLBACK, a condition resulting in a howling noise when recording from a mike, also HOWLROUND [n]\n",
  "HOWLED": "HOWL, to cry like a dog [v]\n",
  "HOWLER": "a kind of monkey [n -S]\n",
  "HOWLERS": "HOWLER, a kind of monkey [n]\n",
  "HOWLET": "a young owl, also OWLET [n -S]\n",
  "HOWLETS": "HOWLET, a young owl, also OWLET [n]\n",
  "HOWLING": "making a howl [adj HOWLINGLY] / the act of howling [n -S]\n",
  "HOWLINGLY": "HOWLING, making a howl [adv]\n",
  "HOWLINGS": "HOWLING, the act of howling [n]\n",
  "HOWLROUND": "a condition resulting in a howling noise when recording from a mike, also HOWLBACK [n -S]\n",
  "HOWLROUNDS": "HOWLROUND, a condition resulting in a howling noise when recording from a mike, also HOWLBACK [n]\n",
  "HOWLS": "HOWL, to cry like a dog [v]\n",
  "HOWRE": "(obsolete) an hour [n -S]\n",
  "HOWRES": "HOWRE, (obsolete) an hour [n]\n",
  "HOWS": "HOW, a low hill, also HOWE [n]\n",
  "HOWSO": "(obsolete) in what way soever, also HOWSOEVER [adv]\n",
  "HOWSOEVER": "in what way soever, also HOWSO [adv]\n",
  "HOWSOMDEVER": "in whatever manner, also HOWSOMEVER [adv]\n",
  "HOWSOMEVER": "in whatever manner, also HOWSOMDEVER [adv]\n",
  "HOWTOWDIE": "(Scots) a dish of boiled chicken [n -S]\n",
  "HOWTOWDIES": "HOWTOWDIE, (Scots) a dish of boiled chicken [n]\n",
  "HOWZAT": "a cry in cricket appealing for dismissal of batsman [interj]\n",
  "HOWZIT": "(South African) how is it (going)? [interj]\n",
  "HOX": "(Shakespeare) to hamstring [v -ED, -ING, -ES]\n",
  "HOXED": "HOX, (Shakespeare) to hamstring [v]\n",
  "HOXES": "HOX, (Shakespeare) to hamstring [v]\n",
  "HOXING": "HOX, (Shakespeare) to hamstring [v]\n",
  "HOY": "to incite [v -ED, -ING, -S]\n",
  "HOYA": "a plant of genus Hoya, the waxplant [n -S]\n",
  "HOYAS": "HOYA, a plant of genus Hoya, the waxplant [n]\n",
  "HOYDEN": "to act like a tomboy, also HOIDEN [v -ED, -ING, -S]\n",
  "HOYDENED": "HOYDEN, to act like a tomboy, also HOIDEN [v]\n",
  "HOYDENHOOD": "the state of being a hoyden [n -S]\n",
  "HOYDENHOODS": "HOYDENHOOD, the state of being a hoyden [n]\n",
  "HOYDENING": "HOYDEN, to act like a tomboy, also HOIDEN [v]\n",
  "HOYDENISH": "like a hoyden, also HOIDENISH [adj]\n",
  "HOYDENISHNESS": "HOYDENISH, like a hoyden, also HOIDENISH [n]\n",
  "HOYDENISHNESSES": "HOYDENISHNESS, HOYDENISH, like a hoyden, also HOIDENISH [n]\n",
  "HOYDENISM": "the behaviour of a hoyden [n -S]\n",
  "HOYDENISMS": "HOYDENISM, the behaviour of a hoyden [n]\n",
  "HOYDENS": "HOYDEN, to act like a tomboy, also HOIDEN [v]\n",
  "HOYED": "HOY, to incite [v]\n",
  "HOYING": "HOY, to incite [v]\n",
  "HOYLE": "a rule book [n -S]\n",
  "HOYLES": "HOYLE, a rule book [n]\n",
  "HOYS": "HOY, to incite [v]\n",
  "HRYVNA": "a monetary unit of Ukraine, also HRYVNIA, HRYVNYA [n -S]\n",
  "HRYVNAS": "HRYVNA, a monetary unit of Ukraine, also HRYVNIA, HRYVNYA [n]\n",
  "HRYVNIA": "a monetary unit of Ukraine, also HRYVNA, HRYVNYA [n -S]\n",
  "HRYVNIAS": "HRYVNIA, a monetary unit of Ukraine, also HRYVNA, HRYVNYA [n]\n",
  "HRYVNYA": "a monetary unit of Ukraine, also HRYVNA, HRYVNIA [n -S]\n",
  "HRYVNYAS": "HRYVNYA, a monetary unit of Ukraine, also HRYVNA, HRYVNIA [n]\n",
  "HUANACO": "(Quechua) a South American mammal allied to the llama, also GUANACO [n -S]\n",
  "HUANACOS": "HUANACO, (Quechua) a South American mammal allied to the llama, also GUANACO [n]\n",
  "HUAQUERO": "(Spanish) in Latin America, a person who steals antiquities and relics from tombs [n -S]\n",
  "HUAQUEROS": "HUAQUERO, (Spanish) in Latin America, a person who steals antiquities and relics from tombs [n]\n",
  "HUARACHE": "(Spanish) a flat-heeled sandal, also GUARACHA, GUARACHE, GUARACHI, HUARACHO [n -S]\n",
  "HUARACHES": "HUARACHE, (Spanish) a flat-heeled sandal, also GUARACHA, GUARACHE, GUARACHI, HUARACHO [n]\n",
  "HUARACHO": "(Spanish) a flat-heeled sandal, also GUARACHA, GUARACHE, GUARACHI, HUARACHE [n -S]\n",
  "HUARACHOS": "HUARACHO, (Spanish) a flat-heeled sandal, also GUARACHA, GUARACHE, GUARACHI, HUARACHE [n]\n",
  "HUB": "the centre of a wheel [n -S]\n",
  "HUBBIES": "HUBBY, (colloquial) husband [n]\n",
  "HUBBLIER": "HUBBLY, having an uneven surface [adj]\n",
  "HUBBLIEST": "HUBBLY, having an uneven surface [adj]\n",
  "HUBBLY": "having an uneven surface [adj HUBBLIER, HUBBLIEST]\n",
  "HUBBUB": "a confused sound of many voices, also HUBBUBOO, WHOOBUB [n -S]\n",
  "HUBBUBOO": "a confused sound of many voices, also HUBBUB, WHOOBUB [n -S]\n",
  "HUBBUBOOS": "HUBBUBOO, a confused sound of many voices, also HUBBUB, WHOOBUB [n]\n",
  "HUBBUBS": "HUBBUB, a confused sound of many voices, also HUBBUBOO, WHOOBUB [n]\n",
  "HUBBY": "(colloquial) husband [n HUBBIES]\n",
  "HUBCAP": "a covering for the hub of a wheel [n -S]\n",
  "HUBCAPS": "HUBCAP, a covering for the hub of a wheel [n]\n",
  "HUBLESS": "lacking a hub [adj]\n",
  "HUBRIS": "(Greek) overbearing pride, also HYBRIS [n -ES]\n",
  "HUBRISES": "HUBRIS, (Greek) overbearing pride, also HYBRIS [n]\n",
  "HUBRISTIC": "having hubris, overwhelming pride, also HYBRISTIC [adj HUBRISTICALLY]\n",
  "HUBRISTICALLY": "HUBRISTIC, having hubris, overwhelming pride, also HYBRISTIC [adv]\n",
  "HUBS": "HUB, the centre of a wheel [n]\n",
  "HUCK": "to force roughly, also HUCKLE [v -ED, -ING, -S]\n",
  "HUCKABACK": "an absorbent cotton or linen used for towels [n -S]\n",
  "HUCKABACKS": "HUCKABACK, an absorbent cotton or linen used for towels [n]\n",
  "HUCKED": "HUCK, to force roughly, also HUCKLE [v]\n",
  "HUCKERY": "(New Zealand colloquial) ugly [adj]\n",
  "HUCKING": "HUCK, to force roughly, also HUCKLE [v]\n",
  "HUCKLE": "to force roughly, also HUCK [v HUCKLED, HUCKLING, HUCKLES]\n",
  "HUCKLEBERRIES": "HUCKLEBERRY, an American shrub of the heath family; its edible blue-black fruit [n]\n",
  "HUCKLEBERRY": "an American shrub of the heath family; its edible blue-black fruit [n HUCKLEBERRIES]\n",
  "HUCKLEBERRYING": "gathering huckleberries [n -S]\n",
  "HUCKLEBERRYINGS": "HUCKLEBERRYING, gathering huckleberries [n]\n",
  "HUCKLEBONE": "the ankle bone, or talus [n -S]\n",
  "HUCKLEBONES": "HUCKLEBONE, the ankle bone, or talus [n]\n",
  "HUCKLED": "HUCKLE, to force roughly, also HUCK [v]\n",
  "HUCKLES": "HUCKLE, to force roughly, also HUCK [v]\n",
  "HUCKLING": "HUCKLE, to force roughly, also HUCK [v]\n",
  "HUCKS": "HUCK, to force roughly, also HUCKLE [v]\n",
  "HUCKSTER": "a pedlar, a hawker [n -S] / to peddle [v -ED, -ING, -S]\n",
  "HUCKSTERAGE": "the state of being a huckster [n -S]\n",
  "HUCKSTERAGES": "HUCKSTERAGE, the state of being a huckster [n]\n",
  "HUCKSTERED": "HUCKSTER, to peddle [v]\n",
  "HUCKSTERESS": "a female huckster, also HUCKSTRESS [n -ES]\n",
  "HUCKSTERESSES": "HUCKSTERESS, a female huckster, also HUCKSTRESS [n]\n",
  "HUCKSTERIES": "HUCKSTERY, the business of a huckster [n]\n",
  "HUCKSTERING": "HUCKSTER, to peddle [v]\n",
  "HUCKSTERISM": "being a huckster [n -S]\n",
  "HUCKSTERISMS": "HUCKSTERISM, being a huckster [n]\n",
  "HUCKSTERS": "HUCKSTER, to peddle [v]\n",
  "HUCKSTERY": "the business of a huckster [n HUCKSTERIES]\n",
  "HUCKSTRESS": "a female huckster, also HUCKSTERESS [n -ES]\n",
  "HUCKSTRESSES": "HUCKSTRESS, a female huckster, also HUCKSTERESS [n]\n",
  "HUDDEN": "HAUD, (Scots) to hold [v]\n",
  "HUDDLE": "to press closely together [v HUDDLED, HUDDLING, HUDDLES]\n",
  "HUDDLED": "HUDDLE, to press closely together [v]\n",
  "HUDDLER": "one who huddles things together [n -S]\n",
  "HUDDLERS": "HUDDLER, one who huddles things together [n]\n",
  "HUDDLES": "HUDDLE, to press closely together [v]\n",
  "HUDDLING": "HUDDLE, to press closely together [v]\n",
  "HUDDUP": "get up (to a horse) [interj]\n",
  "HUDIBRASTIC": "boastful [adj]\n",
  "HUDNA": "(Arabic) in Islam, a truce or ceasefire for an agreed duration [n -S]\n",
  "HUDNAS": "HUDNA, (Arabic) in Islam, a truce or ceasefire for an agreed duration [n]\n",
  "HUDUD": "(Arabic) a set of laws and punishments specified in the Koran [n -S]\n",
  "HUDUDS": "HUDUD, (Arabic) a set of laws and punishments specified in the Koran [n]\n",
  "HUE": "colour [n -S]\n",
  "HUED": "having colour [adj]\n",
  "HUELESS": "without colour [adj]\n",
  "HUER": "a pilchard fishermen's lookout man [n -S]\n",
  "HUERS": "HUER, a pilchard fishermen's lookout man [n]\n",
  "HUES": "HUE, colour [n]\n",
  "HUFF": "to breathe heavily [v -ED, -ING, -S]\n",
  "HUFFED": "HUFF, to breathe heavily [v]\n",
  "HUFFER": "a blustering bully [n -S]\n",
  "HUFFERS": "HUFFER, a blustering bully [n]\n",
  "HUFFIER": "HUFFY, easily offended [adj]\n",
  "HUFFIEST": "HUFFY, easily offended [adj]\n",
  "HUFFILY": "HUFFY, easily offended [adv]\n",
  "HUFFINESS": "the state of being huffy [n -ES]\n",
  "HUFFINESSES": "HUFFINESS, the state of being huffy [n]\n",
  "HUFFING": "as in huffing and puffing, loud talk, noisy objections [n -S]\n",
  "HUFFINGS": "HUFFING, as in huffing and puffing, loud talk, noisy objections [n]\n",
  "HUFFISH": "given to huff, touchy [adj HUFFISHLY]\n",
  "HUFFISHLY": "HUFFISH, given to huff, touchy [adv]\n",
  "HUFFISHNESS": "the state of being huffish [n -ES]\n",
  "HUFFISHNESSES": "HUFFISHNESS, the state of being huffish [n]\n",
  "HUFFKIN": "a bun made of bread dough with extra lard [n -S]\n",
  "HUFFKINS": "HUFFKIN, a bun made of bread dough with extra lard [n]\n",
  "HUFFS": "HUFF, to breathe heavily [v]\n",
  "HUFFY": "easily offended [adj HUFFIER, HUFFIEST, HUFFILY]\n",
  "HUG": "to clasp tightly in the arms [v HUGGED, HUGGING, HUGS]\n",
  "HUGE": "very large [adj HUGER, HUGEST, HUGELY]\n",
  "HUGELY": "HUGE, very large [adv]\n",
  "HUGENESS": "the quality of being huge [n -ES]\n",
  "HUGENESSES": "HUGENESS, the quality of being huge [n]\n",
  "HUGEOUS": "(archaic) huge [adj HUGEOUSLY]\n",
  "HUGEOUSLY": "HUGEOUS, (archaic) huge [adv]\n",
  "HUGEOUSNESS": "(archaic) the state of being hugeous [n -ES]\n",
  "HUGEOUSNESSES": "HUGEOUSNESS, (archaic) the state of being hugeous [n]\n",
  "HUGER": "HUGE, very large [adj]\n",
  "HUGEST": "HUGE, very large [adj]\n",
  "HUGGABLE": "cuddlesome [adj]\n",
  "HUGGED": "HUG, to clasp tightly in the arms [v]\n",
  "HUGGER": "one who hugs [n -S]\n",
  "HUGGERS": "HUGGER, one who hugs [n]\n",
  "HUGGIER": "HUGGY, sensitive and caring [adj]\n",
  "HUGGIEST": "HUGGY, sensitive and caring [adj]\n",
  "HUGGING": "HUG, to clasp tightly in the arms [v]\n",
  "HUGGY": "sensitive and caring [adj HUGGIER, HUGGIEST]\n",
  "HUGS": "HUG, to clasp tightly in the arms [v]\n",
  "HUGY": "(archaic) huge, vast [adj]\n",
  "HUH": "used to express surprise [interj]\n",
  "HUHU": "(Maori) a hairy New Zealand beetle [n -S]\n",
  "HUHUS": "HUHU, (Maori) a hairy New Zealand beetle [n]\n",
  "HUI": "a Maori gathering [n -S]\n",
  "HUIA": "(Maori) a New Zealand bird akin to a crow [n -S]\n",
  "HUIAS": "HUIA, (Maori) a New Zealand bird akin to a crow [n]\n",
  "HUIC": "used to encourage hunting hounds [interj]\n",
  "HUIPIL": "(Spanish) a Mexican embroidered blouse or dress [n HUIPILS or HUIPILES]\n",
  "HUIPILES": "HUIPIL, (Spanish) a Mexican embroidered blouse or dress [n]\n",
  "HUIPILS": "HUIPIL, (Spanish) a Mexican embroidered blouse or dress [n]\n",
  "HUIS": "HUI, a Maori gathering [n]\n",
  "HUISACHE": "(Nahuatl) a thorny, scrubby acacia [n -S]\n",
  "HUISACHES": "HUISACHE, (Nahuatl) a thorny, scrubby acacia [n]\n",
  "HUISSIER": "(French) a doorkeeper [n -S]\n",
  "HUISSIERS": "HUISSIER, (French) a doorkeeper [n]\n",
  "HUITAIN": "(French) a group of eight lines of verse [n -S]\n",
  "HUITAINS": "HUITAIN, (French) a group of eight lines of verse [n]\n",
  "HULA": "(Hawaiian) a sinuous Polynesian dance with rhythmic hip movements [n -S]\n",
  "HULAS": "HULA, (Hawaiian) a sinuous Polynesian dance with rhythmic hip movements [n]\n",
  "HULE": "(Nahuatl) a Central American rubber tree, also ULE [n -S]\n",
  "HULES": "HULE, (Nahuatl) a Central American rubber tree, also ULE [n]\n",
  "HULK": "to appear impressively large [v -ED, -ING, -S]\n",
  "HULKED": "HULK, to appear impressively large [v]\n",
  "HULKIER": "HULKY, bulky, unwieldy [adj]\n",
  "HULKIEST": "HULKY, bulky, unwieldy [adj]\n",
  "HULKING": "HULK, to appear impressively large [v]\n",
  "HULKS": "HULK, to appear impressively large [v]\n",
  "HULKY": "bulky, unwieldy [adj HULKIER, HULKIEST]\n",
  "HULL": "to separate the shell from the seed [v -ED, -ING, -S]\n",
  "HULLABALLOO": "a confused noise; an uproar, also HULLABALOO [n -S]\n",
  "HULLABALLOOS": "HULLABALLOO, a confused noise; an uproar, also HULLABALOO [n]\n",
  "HULLABALOO": "a confused noise; an uproar, also HULLABALLOO [n -S]\n",
  "HULLABALOOS": "HULLABALOO, a confused noise; an uproar, also HULLABALLOO [n]\n",
  "HULLED": "HULL, to separate the shell from the seed [v]\n",
  "HULLER": "one who, or that which, hulls; esp. an agricultural machine for removing the hulls from grain [n -S]\n",
  "HULLERS": "HULLER, one who, or that which, hulls; esp. an agricultural machine for removing the hulls from grain [n]\n",
  "HULLIER": "HULLY, having husks [adj]\n",
  "HULLIEST": "HULLY, having husks [adj]\n",
  "HULLING": "HULL, to separate the shell from the seed [v]\n",
  "HULLO": "to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO [v -ED, -ING, -S or -ES]\n",
  "HULLOA": "to hallo [v -ED, -ING, -S]\n",
  "HULLOAED": "HULLOA, to hallo [v]\n",
  "HULLOAING": "HULLOA, to hallo [v]\n",
  "HULLOAS": "HULLOA, to hallo [v]\n",
  "HULLOED": "HULLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO [v]\n",
  "HULLOES": "HULLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO [v]\n",
  "HULLOING": "HULLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO [v]\n",
  "HULLOO": "to hail, also HALLOA, HALLOO [v -ED, -ING, -S]\n",
  "HULLOOED": "HULLOO, to hail, also HALLOA, HALLOO [v]\n",
  "HULLOOING": "HULLOO, to hail, also HALLOA, HALLOO [v]\n",
  "HULLOOS": "HULLOO, to hail, also HALLOA, HALLOO [v]\n",
  "HULLOS": "HULLO, to shout out a greeting, also HALLO, HALLOA, HALLOO, HELLO, HILLO, HILLOA, HOLLA, HOLLO, HOLLOA, HOLLOO [v]\n",
  "HULLS": "HULL, to separate the shell from the seed [v]\n",
  "HULLY": "having husks [adj HULLIER, HULLIEST]\n",
  "HUM": "to make a sound like bees [v HUMMED, HUMMING, HUMS]\n",
  "HUMA": "(Urdu) a mythical bird similar to the phoenix, supposed to bring luck to any person over whom it hovers on its restless flights [n -S]\n",
  "HUMAN": "like a human being [adj HUMANLY] / a person [n -S]\n",
  "HUMANE": "compassionate [adj HUMANER, HUMANEST, HUMANELY]\n",
  "HUMANELY": "HUMANE, compassionate [adv]\n",
  "HUMANENESS": "the quality of being humane [n -ES]\n",
  "HUMANENESSES": "HUMANENESS, the quality of being humane [n]\n",
  "HUMANER": "HUMANE, compassionate [adj]\n",
  "HUMANEST": "HUMANE, compassionate [adj]\n",
  "HUMANHOOD": "the state of being human [n -S]\n",
  "HUMANHOODS": "HUMANHOOD, the state of being human [n]\n",
  "HUMANISATION": "the act of humanising, also HUMANIZATION [n -S]\n",
  "HUMANISATIONS": "HUMANISATION, the act of humanising, also HUMANIZATION [n]\n",
  "HUMANISE": "to make human, also HUMANIZE [v HUMANISED, HUMANISING, HUMANISES]\n",
  "HUMANISED": "HUMANISE, to make human, also HUMANIZE [v]\n",
  "HUMANISER": "something or someone that humanises, also HUMANIZER [n -S]\n",
  "HUMANISERS": "HUMANISER, something or someone that humanises, also HUMANIZER [n]\n",
  "HUMANISES": "HUMANISE, to make human, also HUMANIZE [v]\n",
  "HUMANISING": "HUMANISE, to make human, also HUMANIZE [v]\n",
  "HUMANISM": "the belief that human interests and mind are paramount [n -S]\n",
  "HUMANISMS": "HUMANISM, the belief that human interests and mind are paramount [n]\n",
  "HUMANIST": "one who studies human nature [n -S]\n",
  "HUMANISTIC": "relating to humanism [adj HUMANISTICALLY]\n",
  "HUMANISTICALLY": "HUMANISTIC, relating to humanism [adv]\n",
  "HUMANISTS": "HUMANIST, one who studies human nature [n]\n",
  "HUMANITARIAN": "a person promoting human welfare and social reform [n -S]\n",
  "HUMANITARIANISM": "the state of being humanitarian [n]\n",
  "HUMANITARIANIST": "a proponent of humanitarianism [n]\n",
  "HUMANITARIANS": "HUMANITARIAN, a person promoting human welfare and social reform [n]\n",
  "HUMANITIES": "HUMANITY, the human race [n]\n",
  "HUMANITY": "the human race [n HUMANITIES]\n",
  "HUMANIZATION": "the act of humanizing, also HUMANISATION [n -S]\n",
  "HUMANIZATIONS": "HUMANIZATION, the act of humanizing, also HUMANISATION [n]\n",
  "HUMANIZE": "to make human, also HUMANISE [v HUMANIZED, HUMANIZING, HUMANIZES]\n",
  "HUMANIZED": "HUMANIZE, to make human, also HUMANISE [v]\n",
  "HUMANIZER": "one who humanizes, also HUMANISER [n -S]\n",
  "HUMANIZERS": "HUMANIZER, one who humanizes, also HUMANISER [n]\n",
  "HUMANIZES": "HUMANIZE, to make human, also HUMANISE [v]\n",
  "HUMANIZING": "HUMANIZE, to make human, also HUMANISE [v]\n",
  "HUMANKIND": "humanity, the human race [n -S]\n",
  "HUMANKINDS": "HUMANKIND, humanity, the human race [n]\n",
  "HUMANLIKE": "like a human being [adj]\n",
  "HUMANLY": "HUMAN, like a human being [adv]\n",
  "HUMANNESS": "the state of being human [n -ES]\n",
  "HUMANNESSES": "HUMANNESS, the state of being human [n]\n",
  "HUMANOID": "something having human form [n -S]\n",
  "HUMANOIDS": "HUMANOID, something having human form [n]\n",
  "HUMANS": "HUMAN, a person [n]\n",
  "HUMAS": "HUMA, (Urdu) a mythical bird similar to the phoenix, supposed to bring luck to any person over whom it hovers on its restless flights [n]\n",
  "HUMATE": "a salt of humic acid [n -S]\n",
  "HUMATES": "HUMATE, a salt of humic acid [n]\n",
  "HUMBLE": "to abase [v HUMBLED, HUMBLING, HUMBLES] / modest [adj HUMBLER, HUMBLEST, HUMBLY]\n",
  "HUMBLEBEE": "a bumblebee [n -S]\n",
  "HUMBLEBEES": "HUMBLEBEE, a bumblebee [n]\n",
  "HUMBLEBRAG": "to make a statement that purports to be self-effacing but in fact reveals a person's wealth or importance [v HUMBLEBRAGGED, HUMBLEBRAGGING, HUMBLEBRAGS]\n",
  "HUMBLEBRAGGED": "HUMBLEBRAG, to make a statement that purports to be self-effacing but in fact reveals a person's wealth or importance [v]\n",
  "HUMBLEBRAGGING": "HUMBLEBRAG, to make a statement that purports to be self-effacing but in fact reveals a person's wealth or importance [v]\n",
  "HUMBLEBRAGS": "HUMBLEBRAG, to make a statement that purports to be self-effacing but in fact reveals a person's wealth or importance [v]\n",
  "HUMBLED": "HUMBLE, to abase [v]\n",
  "HUMBLENESS": "the quality of being humble [n -ES]\n",
  "HUMBLENESSES": "HUMBLENESS, the quality of being humble [n]\n",
  "HUMBLER": "one that humbles [n -S]\n",
  "HUMBLERS": "HUMBLER, one that humbles [n]\n",
  "HUMBLES": "HUMBLE, to abase [v]\n",
  "HUMBLESSE": "(Spenser) humility [n -S]\n",
  "HUMBLESSES": "HUMBLESSE, (Spenser) humility [n]\n",
  "HUMBLEST": "HUMBLE, modest [adj]\n",
  "HUMBLING": "making humble [adj HUMBLINGLY] / the act of humbling [n -S]\n",
  "HUMBLINGLY": "HUMBLING, making humble [adv]\n",
  "HUMBLINGS": "HUMBLING, the act of humbling [n]\n",
  "HUMBLY": "HUMBLE, modest [adv]\n",
  "HUMBUCKER": "a twin-coil guitar pickup [n -S]\n",
  "HUMBUCKERS": "HUMBUCKER, a twin-coil guitar pickup [n]\n",
  "HUMBUG": "to deceive [v HUMBUGGED, HUMBUGGING, HUMBUGS]\n",
  "HUMBUGGABLE": "capable of being humbugged [adj]\n",
  "HUMBUGGED": "HUMBUG, to deceive [v]\n",
  "HUMBUGGER": "one who humbugs, deceives [n -S]\n",
  "HUMBUGGERIES": "HUMBUGGERY, deception [n]\n",
  "HUMBUGGERS": "HUMBUGGER, one who humbugs, deceives [n]\n",
  "HUMBUGGERY": "deception [n HUMBUGGERIES]\n",
  "HUMBUGGING": "HUMBUG, to deceive [v]\n",
  "HUMBUGS": "HUMBUG, to deceive [v]\n",
  "HUMBUZZ": "(dialect) a cockchafer [n -ES]\n",
  "HUMBUZZES": "HUMBUZZ, (dialect) a cockchafer [n]\n",
  "HUMDINGER": "a person or thing of striking excellence [n -S]\n",
  "HUMDINGERS": "HUMDINGER, a person or thing of striking excellence [n]\n",
  "HUMDRUM": "a dull boring person [n -S]\n",
  "HUMDRUMNESS": "the state of being humdrum [n -ES]\n",
  "HUMDRUMNESSES": "HUMDRUMNESS, the state of being humdrum [n]\n",
  "HUMDRUMS": "HUMDRUM, a dull boring person [n]\n",
  "HUMDUDGEON": "(Scots) low spirits [n -S]\n",
  "HUMDUDGEONS": "HUMDUDGEON, (Scots) low spirits [n]\n",
  "HUMDURGEON": "an imaginary illness [n -S]\n",
  "HUMDURGEONS": "HUMDURGEON, an imaginary illness [n]\n",
  "HUMECT": "to moisten, also HUMECTATE [v -ED, -ING, -S]\n",
  "HUMECTANT": "absorbing moisture [adj] / a substance that absorbs moisture [n -S]\n",
  "HUMECTANTS": "HUMECTANT, a substance that absorbs moisture [n]\n",
  "HUMECTATE": "to moisten; to wet, also HUMECT [v HUMECTATED, HUMECTATING, HUMECTATES]\n",
  "HUMECTATED": "HUMECTATE, to moisten; to wet, also HUMECT [v]\n",
  "HUMECTATES": "HUMECTATE, to moisten; to wet, also HUMECT [v]\n",
  "HUMECTATING": "HUMECTATE, to moisten; to wet, also HUMECT [v]\n",
  "HUMECTATION": "the act of moistening [n -S]\n",
  "HUMECTATIONS": "HUMECTATION, the act of moistening [n]\n",
  "HUMECTED": "HUMECT, to moisten, also HUMECTATE [v]\n",
  "HUMECTING": "HUMECT, to moisten, also HUMECTATE [v]\n",
  "HUMECTIVE": "something tending to moisten [n -S]\n",
  "HUMECTIVES": "HUMECTIVE, something tending to moisten [n]\n",
  "HUMECTS": "HUMECT, to moisten, also HUMECTATE [v]\n",
  "HUMEFIED": "HUMEFY, (obsolete) to moisten, also HUMIFY [v]\n",
  "HUMEFIES": "HUMEFY, (obsolete) to moisten, also HUMIFY [v]\n",
  "HUMEFY": "(obsolete) to moisten, also HUMIFY [v HUMEFIED, HUMEFYING, HUMEFIES]\n",
  "HUMEFYING": "HUMEFY, (obsolete) to moisten, also HUMIFY [v]\n",
  "HUMERAL": "a bone of the shoulder [n -S]\n",
  "HUMERALS": "HUMERAL, a bone of the shoulder [n]\n",
  "HUMERI": "HUMERUS, (Latin) the large bone of the upper arm [n]\n",
  "HUMERUS": "(Latin) the large bone of the upper arm [n HUMERI]\n",
  "HUMF": "(Scots) to carry something awkward, also HUMPH [v -ED, -ING, -S]\n",
  "HUMFED": "HUMF, (Scots) to carry something awkward, also HUMPH [v]\n",
  "HUMFING": "HUMF, (Scots) to carry something awkward, also HUMPH [v]\n",
  "HUMFS": "HUMF, (Scots) to carry something awkward, also HUMPH [v]\n",
  "HUMGRUFFIAN": "a terrible person, also HUMGRUFFIN [n -S]\n",
  "HUMGRUFFIANS": "HUMGRUFFIAN, a terrible person, also HUMGRUFFIN [n]\n",
  "HUMGRUFFIN": "a terrible person, also HUMGRUFFIAN [n -S]\n",
  "HUMGRUFFINS": "HUMGRUFFIN, a terrible person, also HUMGRUFFIAN [n]\n",
  "HUMHUM": "a kind of plain, coarse cotton cloth used in the East Indies [n -S]\n",
  "HUMHUMS": "HUMHUM, a kind of plain, coarse cotton cloth used in the East Indies [n]\n",
  "HUMIC": "pertaining to, or derived from, vegetable mould; as, humic acid [adj]\n",
  "HUMICOLE": "any plant that thrives on humus [n -S]\n",
  "HUMICOLES": "HUMICOLE, any plant that thrives on humus [n]\n",
  "HUMICOLOUS": "living in the soil [adj]\n",
  "HUMID": "moist, having much humidity [adj HUMIDER, HUMIDEST, HUMIDLY]\n",
  "HUMIDER": "HUMID, moist, having much humidity [adj]\n",
  "HUMIDEST": "HUMID, moist, having much humidity [adj]\n",
  "HUMIDEX": "(Canadian) a system of measuring discomfort showing the combined effects of humidity and temperature [n HUMIDEXES or HUMIDICES]\n",
  "HUMIDEXES": "HUMIDEX, (Canadian) a system of measuring discomfort showing the combined effects of humidity and temperature [n]\n",
  "HUMIDICES": "HUMIDEX, (Canadian) a system of measuring discomfort showing the combined effects of humidity and temperature [n]\n",
  "HUMIDIFICATION": "the act of humidifying [n -S]\n",
  "HUMIDIFICATIONS": "HUMIDIFICATION, the act of humidifying [n]\n",
  "HUMIDIFIED": "HUMIDIFY, to make humid [v]\n",
  "HUMIDIFIER": "a device for supplying or maintaining humidity [n -S]\n",
  "HUMIDIFIERS": "HUMIDIFIER, a device for supplying or maintaining humidity [n]\n",
  "HUMIDIFIES": "HUMIDIFY, to make humid [v]\n",
  "HUMIDIFY": "to make humid [v HUMIDIFIED, HUMIDIFYING, HUMIDIFIES]\n",
  "HUMIDIFYING": "HUMIDIFY, to make humid [v]\n",
  "HUMIDISTAT": "a device for controlling security [n -S]\n",
  "HUMIDISTATS": "HUMIDISTAT, a device for controlling security [n]\n",
  "HUMIDITIES": "HUMIDITY, the amount of moisture in the air [n]\n",
  "HUMIDITY": "the amount of moisture in the air [n HUMIDITIES]\n",
  "HUMIDLY": "HUMID, moist, having much humidity [adv]\n",
  "HUMIDNESS": "the state of being humid [n -ES]\n",
  "HUMIDNESSES": "HUMIDNESS, the state of being humid [n]\n",
  "HUMIDOR": "(Latin) a humid place for storing cigars etc. [n -S]\n",
  "HUMIDORS": "HUMIDOR, (Latin) a humid place for storing cigars etc. [n]\n",
  "HUMIFICATION": "formation of or conversion into humus [n -S]\n",
  "HUMIFICATIONS": "HUMIFICATION, formation of or conversion into humus [n]\n",
  "HUMIFIED": "HUMIFY, to moisten, also HUMEFY [v]\n",
  "HUMIFIES": "HUMIFY, to moisten, also HUMEFY [v]\n",
  "HUMIFY": "to moisten, also HUMEFY [v HUMIFIED, HUMIFYING, HUMIFIES]\n",
  "HUMIFYING": "HUMIFY, to moisten, also HUMEFY [v]\n",
  "HUMILIANT": "humiliating; humbling [adj]\n",
  "HUMILIATE": "to humble, to mortify [v HUMILIATED, HUMILIATING, HUMILIATES]\n",
  "HUMILIATED": "HUMILIATE, to humble, to mortify [v]\n",
  "HUMILIATES": "HUMILIATE, to humble, to mortify [v]\n",
  "HUMILIATING": "HUMILIATE, to humble, to mortify [v]\n",
  "HUMILIATINGLY": "HUMILIATING, HUMILIATE, to humble, to mortify [adv]\n",
  "HUMILIATION": "the act of humiliating [n -S]\n",
  "HUMILIATIONS": "HUMILIATION, the act of humiliating [n]\n",
  "HUMILIATIVE": "serving to humiliate, also HUMILIATORY [adj]\n",
  "HUMILIATOR": "one who humiliates [n -S]\n",
  "HUMILIATORS": "HUMILIATOR, one who humiliates [n]\n",
  "HUMILIATORY": "serving to humiliate, also HUMILIATIVE [adj]\n",
  "HUMILITIES": "HUMILITY, the quality of being humble [n]\n",
  "HUMILITY": "the quality of being humble [n HUMILITIES]\n",
  "HUMINT": "human intelligence [n -S]\n",
  "HUMINTS": "HUMINT, human intelligence [n]\n",
  "HUMITE": "a magnesium orthosilicate that occurs as an impurity in marble [n -S]\n",
  "HUMITES": "HUMITE, a magnesium orthosilicate that occurs as an impurity in marble [n]\n",
  "HUMITURE": "a combined measurement of temperature and humidity [n -S]\n",
  "HUMITURES": "HUMITURE, a combined measurement of temperature and humidity [n]\n",
  "HUMLIE": "(Scots) a pollarded or hornless cow [n -S]\n",
  "HUMLIES": "HUMLIE, (Scots) a pollarded or hornless cow [n]\n",
  "HUMMABLE": "able to be hummed [adj]\n",
  "HUMMAUM": "(Arabic) a Turkish bath, also HAMMAM, HUMMUM [n -S]\n",
  "HUMMAUMS": "HUMMAUM, (Arabic) a Turkish bath, also HAMMAM, HUMMUM [n]\n",
  "HUMMED": "HUM, to make a sound like bees [v]\n",
  "HUMMEL": "to make hornless [v HUMMELLED, HUMMELLING, HUMMELS]\n",
  "HUMMELLED": "HUMMEL, to make hornless [v]\n",
  "HUMMELLER": "(dialect) a machine for removing barley awns [n -S]\n",
  "HUMMELLERS": "HUMMELLER, (dialect) a machine for removing barley awns [n]\n",
  "HUMMELLING": "the act of making hornless [n -S]\n",
  "HUMMELLINGS": "HUMMELLING, the act of making hornless [n]\n",
  "HUMMELS": "HUMMEL, to make hornless [v]\n",
  "HUMMER": "one who, or that which, hums [n -S]\n",
  "HUMMERS": "HUMMER, one who, or that which, hums [n]\n",
  "HUMMING": "the noise of bees [n -S]\n",
  "HUMMINGBIRD": "any member of the tropical family Trochilidae, very small birds of brilliant plumage and rapid flight [n -S]\n",
  "HUMMINGBIRDS": "HUMMINGBIRD, any member of the tropical family Trochilidae, very small birds of brilliant plumage and rapid flight [n]\n",
  "HUMMINGS": "HUMMING, the noise of bees [n]\n",
  "HUMMLE": "as in hummle bonnet, a type of Scottish cap [adj]\n",
  "HUMMOCK": "a small hill, also HOMMOCK [n -S] / to form into small rounded hills [v -ED, -ING, -S]\n",
  "HUMMOCKED": "HUMMOCK, to form into small rounded hills [v]\n",
  "HUMMOCKIER": "HUMMOCKY, abounding in hummocks [adj]\n",
  "HUMMOCKIEST": "HUMMOCKY, abounding in hummocks [adj]\n",
  "HUMMOCKING": "HUMMOCK, to form into small rounded hills [v]\n",
  "HUMMOCKS": "HUMMOCK, to form into small rounded hills [v]\n",
  "HUMMOCKY": "abounding in hummocks [adj HUMMOCKIER, HUMMOCKIEST]\n",
  "HUMMUM": "(Arabic) a Turkish bath, also HAMMAM, HUMMAUM [n -S]\n",
  "HUMMUMS": "HUMMUM, (Arabic) a Turkish bath, also HAMMAM, HUMMAUM [n]\n",
  "HUMMUS": "(Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMMOS, HOUMOUS, HOUMUS, HUMOUSES [n -ES]\n",
  "HUMMUSES": "HUMMUS, (Turkish) a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil, also HOMMOS, HOUMMOS, HOUMOUS, HOUMUS, HUMOUSES [n]\n",
  "HUMOGEN": "a fertilizer composed of peat treated with a culture of nitrogen-fixing bacteria [n -S]\n",
  "HUMOGENS": "HUMOGEN, a fertilizer composed of peat treated with a culture of nitrogen-fixing bacteria [n]\n",
  "HUMONGOUS": "jocular for huge, also HUMUNGOUS [adj]\n",
  "HUMOR": "(US) humour [n -S] / to humour, also HUMOUR [v -ED, -ING, -S]\n",
  "HUMORAL": "of diseases, caused by or attributed to a disordered state of body fluids or (formerly) the bodily humours [adj HUMORALLY]\n",
  "HUMORALISM": "the state of being humoral [n -S]\n",
  "HUMORALISMS": "HUMORALISM, the state of being humoral [n]\n",
  "HUMORALIST": "one who favors the humoral pathology or believes in humoralism [n -S]\n",
  "HUMORALISTS": "HUMORALIST, one who favors the humoral pathology or believes in humoralism [n]\n",
  "HUMORALLY": "HUMORAL, of diseases, caused by or attributed to a disordered state of body fluids or (formerly) the bodily humours [adv]\n",
  "HUMORED": "HUMOR, to humour, also HUMOUR [v]\n",
  "HUMORESK": "a musical caprice, also HUMORESQUE [n -S]\n",
  "HUMORESKS": "HUMORESK, a musical caprice, also HUMORESQUE [n]\n",
  "HUMORESQUE": "a musical caprice, also HUMORESK [n -S]\n",
  "HUMORESQUES": "HUMORESQUE, a musical caprice, also HUMORESK [n]\n",
  "HUMORFUL": "full of humor, also HUMOURFUL [adj]\n",
  "HUMORING": "HUMOR, to humour, also HUMOUR [v]\n",
  "HUMORIST": "someone with a sense of humor [n -S]\n",
  "HUMORISTIC": "of, pertaining to, or resembling, a humorist [adj]\n",
  "HUMORISTS": "HUMORIST, someone with a sense of humor [n]\n",
  "HUMORLESS": "(US) without humor, also HUMOURLESS [adj HUMORLESSLY]\n",
  "HUMORLESSLY": "HUMORLESS, (US) without humor, also HUMOURLESS [adv]\n",
  "HUMORLESSNESS": "the state of being humorless, also HUMOURLESSNESS [n -ES]\n",
  "HUMORLESSNESSES": "HUMORLESSNESS, the state of being humorless, also HUMOURLESSNESS [n]\n",
  "HUMOROUS": "funny; witty [adj HUMOROUSLY]\n",
  "HUMOROUSLY": "HUMOROUS, funny; witty [adv]\n",
  "HUMOROUSNESS": "the state of being humorous [n -ES]\n",
  "HUMOROUSNESSES": "HUMOROUSNESS, the state of being humorous [n]\n",
  "HUMORS": "HUMOR, to humour, also HUMOUR [v]\n",
  "HUMORSOME": "full of humor, also HUMOURSOME [adj]\n",
  "HUMORSOMENESS": "the state of being humorsome [n -ES]\n",
  "HUMORSOMENESSES": "HUMORSOMENESS, the state of being humorsome [n]\n",
  "HUMOUR": "to indulge, also HUMOR [v -ED, -ING, -S]\n",
  "HUMOURED": "HUMOUR, to indulge, also HUMOR [v]\n",
  "HUMOURFUL": "full of humour, also HUMORFUL [adj]\n",
  "HUMOURING": "HUMOUR, to indulge, also HUMOR [v]\n",
  "HUMOURLESS": "without humour, also HUMORLESS [adj]\n",
  "HUMOURLESSLY": "HUMOURLESS, without humour, also HUMORLESS [adv]\n",
  "HUMOURLESSNESS": "the state of being humourless, also HUMORLESSNESS [n]\n",
  "HUMOURS": "HUMOUR, to indulge, also HUMOR [v]\n",
  "HUMOURSOME": "capricious, petulant, also HUMORSOME [adj]\n",
  "HUMOURSOMENESS": "HUMOURSOME, capricious, petulant, also HUMORSOME [n]\n",
  "HUMOUS": "a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil [n -ES]\n",
  "HUMOUSES": "HUMOUS, a Middle Eastern hors d'oeuvre of pureed chickpea and sesame oil [n]\n",
  "HUMP": "to bend into a rounded projection [v -ED, -ING, -S]\n",
  "HUMPBACK": "a kind of whale [n -S]\n",
  "HUMPBACKED": "having a humped back [adj]\n",
  "HUMPBACKS": "HUMPBACK, a kind of whale [n]\n",
  "HUMPED": "HUMP, to bend into a rounded projection [v]\n",
  "HUMPEN": "(German) a type of enamelled or painted glass drinking vessel made in Germany [n -S]\n",
  "HUMPENS": "HUMPEN, (German) a type of enamelled or painted glass drinking vessel made in Germany [n]\n",
  "HUMPER": "someone who carries heavy loads [n -S]\n",
  "HUMPERS": "HUMPER, someone who carries heavy loads [n]\n",
  "HUMPH": "to carry (something cumbersome, heavy or awkward), also HUMF [v -ED, -ING, -S]\n",
  "HUMPHED": "HUMPH, to carry (something cumbersome, heavy or awkward), also HUMF [v]\n",
  "HUMPHING": "HUMPH, to carry (something cumbersome, heavy or awkward), also HUMF [v]\n",
  "HUMPHS": "HUMPH, to carry (something cumbersome, heavy or awkward), also HUMF [v]\n",
  "HUMPIER": "HUMPY, full of humps [adj]\n",
  "HUMPIES": "HUMPY, an Aboriginal hut [n]\n",
  "HUMPIEST": "HUMPY, full of humps [adj]\n",
  "HUMPINESS": "the state of being humpy [n -ES]\n",
  "HUMPINESSES": "HUMPINESS, the state of being humpy [n]\n",
  "HUMPING": "HUMP, to bend into a rounded projection [v]\n",
  "HUMPLESS": "without a hump [adj]\n",
  "HUMPLIKE": "like a hump [adj]\n",
  "HUMPS": "HUMP, to bend into a rounded projection [v]\n",
  "HUMPTIES": "HUMPTY, a low padded seat [n]\n",
  "HUMPTY": "a low padded seat [n HUMPTIES]\n",
  "HUMPY": "an Aboriginal hut [n HUMPIES] / full of humps [adj HUMPIER, HUMPIEST]\n",
  "HUMS": "HUM, to make a sound like bees [v]\n",
  "HUMSTRUM": "a hurdy-gurdy [n -S]\n",
  "HUMSTRUMS": "HUMSTRUM, a hurdy-gurdy [n]\n",
  "HUMUNGOUS": "jocular for huge, also HUMONGOUS [adj]\n",
  "HUMUS": "decomposed organic matter in the soil [n -ES]\n",
  "HUMUSES": "HUMUS, decomposed organic matter in the soil [n]\n",
  "HUMUSIER": "HUMUSY, having much humus [adj]\n",
  "HUMUSIEST": "HUMUSY, having much humus [adj]\n",
  "HUMUSY": "having much humus [adj HUMUSIER, HUMUSIEST]\n",
  "HUMVEE": "(tradename) a high mobility multipurpose military wheeled vehicle [n -S]\n",
  "HUMVEES": "HUMVEE, (tradename) a high mobility multipurpose military wheeled vehicle [n]\n",
  "HUN": "a barbarous, destructive person [n -S]\n",
  "HUNCH": "to arch forward [v -ED, -ING, -ES]\n",
  "HUNCHBACK": "a person whose spine is convexly curved to an abnormal degree [n -S]\n",
  "HUNCHBACKED": "having a hunchback [adj]\n",
  "HUNCHBACKS": "HUNCHBACK, a person whose spine is convexly curved to an abnormal degree [n]\n",
  "HUNCHED": "HUNCH, to arch forward [v]\n",
  "HUNCHES": "HUNCH, to arch forward [v]\n",
  "HUNCHING": "HUNCH, to arch forward [v]\n",
  "HUNDRED": "a number, ten times ten [n -S]\n",
  "HUNDREDER": "an inhabitant or freeholder of a hundred, also HUNDREDOR [n -S]\n",
  "HUNDREDERS": "HUNDREDER, an inhabitant or freeholder of a hundred, also HUNDREDOR [n]\n",
  "HUNDREDFOLD": "multiplied by one hundred [adv] / a multiplication by one hundred [n -S]\n",
  "HUNDREDFOLDS": "HUNDREDFOLD, a multiplication by one hundred [n]\n",
  "HUNDREDOR": "an inhabitant or freeholder of a hundred, also HUNDREDER [n -S]\n",
  "HUNDREDORS": "HUNDREDOR, an inhabitant or freeholder of a hundred, also HUNDREDER [n]\n",
  "HUNDREDS": "HUNDRED, a number, ten times ten [n]\n",
  "HUNDREDTH": "the ordinal of hundred [adj] / a hundredth part [n -S]\n",
  "HUNDREDTHS": "HUNDREDTH, a hundredth part [n]\n",
  "HUNDREDWEIGHT": "1/20 of a ton, or 112lb. avoirdupois [n -S]\n",
  "HUNDREDWEIGHTS": "HUNDREDWEIGHT, 1/20 of a ton, or 112lb. avoirdupois [n]\n",
  "HUNG": "HANG, to attach from above, suspend [v]\n",
  "HUNGAN": "a voodoo priest, also HOUNGAN [n -S]\n",
  "HUNGANS": "HUNGAN, a voodoo priest, also HOUNGAN [n]\n",
  "HUNGER": "to crave [v -ED, -ING, -S]\n",
  "HUNGERED": "HUNGER, to crave [v]\n",
  "HUNGERFUL": "hungry [adj]\n",
  "HUNGERING": "HUNGER, to crave [v]\n",
  "HUNGERINGLY": "HUNGERING, HUNGER, to crave [adv]\n",
  "HUNGERLY": "(Shakespeare) hungry, hungrily [adj]\n",
  "HUNGERS": "HUNGER, to crave [v]\n",
  "HUNGOVER": "suffering from a hangover [adj]\n",
  "HUNGRIER": "HUNGRY, having a craving desire [adj]\n",
  "HUNGRIEST": "HUNGRY, having a craving desire [adj]\n",
  "HUNGRILY": "HUNGRY, having a craving desire [adv]\n",
  "HUNGRINESS": "hunger [n -ES]\n",
  "HUNGRINESSES": "HUNGRINESS, hunger [n]\n",
  "HUNGRY": "having a craving desire [adj HUNGRIER, HUNGRIEST, HUNGRILY]\n",
  "HUNH": "used to ask for a repetition of an utterance [interj]\n",
  "HUNK": "a large piece [n -S]\n",
  "HUNKER": "to squat [v -ED, -ING, -S]\n",
  "HUNKERED": "HUNKER, to squat [v]\n",
  "HUNKERING": "HUNKER, to squat [v]\n",
  "HUNKERS": "HUNKER, to squat [v]\n",
  "HUNKEY": "(colloquial) a person of Hungarian descent, also HUNKIE [n -S]\n",
  "HUNKEYS": "HUNKEY, (colloquial) a person of Hungarian descent, also HUNKIE [n]\n",
  "HUNKIE": "(colloquial) a person of Hungarian descent, also HUNKEY [n -S]\n",
  "HUNKIER": "HUNKY, strongly built [adj]\n",
  "HUNKIES": "HUNKY, a derogatory name for a worker of East European descent, esp. an unskilled worker, also HUNKEY, HUNKIE [n]\n",
  "HUNKIEST": "HUNKY, strongly built [adj]\n",
  "HUNKS": "a surly old man [n -ES]\n",
  "HUNKSES": "HUNKS, a surly old man [n]\n",
  "HUNKY": "strongly built [adj HUNKIER, HUNKIEST] / a derogatory name for a worker of East European descent, esp. an unskilled worker, also HUNKEY, HUNKIE [n HUNKIES]\n",
  "HUNNISH": "like a hun [adj]\n",
  "HUNS": "HUN, a barbarous, destructive person [n]\n",
  "HUNT": "to pursue for food or sport [v -ED, -ING, -S]\n",
  "HUNTABLE": "able to be hunted [adj]\n",
  "HUNTAWAY": "a dog trained to drive sheep at some distance from the shepherd [n -S]\n",
  "HUNTAWAYS": "HUNTAWAY, a dog trained to drive sheep at some distance from the shepherd [n]\n",
  "HUNTED": "HUNT, to pursue for food or sport [v]\n",
  "HUNTEDLY": "HUNTED, HUNT, to pursue for food or sport [adv]\n",
  "HUNTER": "one that hunts [n -S]\n",
  "HUNTERS": "HUNTER, one that hunts [n]\n",
  "HUNTIEGOWK": "(Scots) a fools' errand, appropriate to the first of April [n -S] / to go on a fool's errand [v -ED, -ING, -S]\n",
  "HUNTIEGOWKED": "HUNTIEGOWK, to go on a fool's errand [v]\n",
  "HUNTIEGOWKING": "HUNTIEGOWK, to go on a fool's errand [v]\n",
  "HUNTIEGOWKS": "HUNTIEGOWK, (Scots) a fools' errand, appropriate to the first of April [n]\n",
  "HUNTING": "an instance of searching [n -S]\n",
  "HUNTINGS": "HUNTING, an instance of searching [n]\n",
  "HUNTRESS": "a female hunter [n -ES]\n",
  "HUNTRESSES": "HUNTRESS, a female hunter [n]\n",
  "HUNTS": "HUNT, to pursue for food or sport [v]\n",
  "HUNTSMAN": "a hunter [n HUNTSMEN]\n",
  "HUNTSMANSHIP": "the craft of hunting [n -S]\n",
  "HUNTSMANSHIPS": "HUNTSMANSHIP, the craft of hunting [n]\n",
  "HUNTSMEN": "HUNTSMAN, a hunter [n]\n",
  "HUP": "to quicken the pace of a horse or turn a horse to the right (by shouting hup to it) [v HUPPED, HUPPING, HUPS]\n",
  "HUPAITHRIC": "roofless; open to the sky (usually intentionally, so as to see the stars), also HYPAETHRAL, HYPETHRAL, UPAITHRIC [adj]\n",
  "HUPIRO": "(Maori) a New Zealand name for stinkwood [n -S]\n",
  "HUPIROS": "HUPIRO, (Maori) a New Zealand name for stinkwood [n]\n",
  "HUPPAH": "(Hebrew) a wedding canopy, also CHUPPA, CHUPPAH [n HUPPAHS, HUPPOT or HUPPOTH]\n",
  "HUPPAHS": "HUPPAH, (Hebrew) a wedding canopy, also CHUPPA, CHUPPAH [n]\n",
  "HUPPED": "HUP, to quicken the pace of a horse or turn a horse to the right (by shouting hup to it) [v]\n",
  "HUPPING": "HUP, to quicken the pace of a horse or turn a horse to the right (by shouting hup to it) [v]\n",
  "HUPPOT": "HUPPAH, (Hebrew) a wedding canopy, also CHUPPA, CHUPPAH [n]\n",
  "HUPPOTH": "HUPPAH, (Hebrew) a wedding canopy, also CHUPPA, CHUPPAH [n]\n",
  "HUPS": "HUP, to quicken the pace of a horse or turn a horse to the right (by shouting hup to it) [v]\n",
  "HURCHEON": "(Scots) an urchin, a hedgehog [n -S]\n",
  "HURCHEONS": "HURCHEON, (Scots) an urchin, a hedgehog [n]\n",
  "HURDEN": "a coarse fabric made from hards, the refuse of hemp, also HERDEN [n -S]\n",
  "HURDENS": "HURDEN, a coarse fabric made from hards, the refuse of hemp, also HERDEN [n]\n",
  "HURDIES": "(Scots) the buttocks, the thighs [n]\n",
  "HURDLE": "to jump over [v HURDLED, HURDLING, HURDLES]\n",
  "HURDLED": "HURDLE, to jump over [v]\n",
  "HURDLER": "one that hurdles [n -S]\n",
  "HURDLERS": "HURDLER, one that hurdles [n]\n",
  "HURDLES": "HURDLE, to jump over [v]\n",
  "HURDLING": "the act of jumping over hurdles [n -S]\n",
  "HURDLINGS": "HURDLING, the act of jumping over hurdles [n]\n",
  "HURDS": "the coarse refuse of flax, also HARDS [n]\n",
  "HURL": "to throw with great force [v -ED, -ING, -S]\n",
  "HURLBARROW": "(Scots) a wheelbarrow, also WHEELBARROW [n -S]\n",
  "HURLBARROWS": "HURLBARROW, (Scots) a wheelbarrow, also WHEELBARROW [n]\n",
  "HURLBAT": "(obsolete) an ancient Roman boxing glove loaded with metal, aka cestus, also WHIRLBAT, WHORLBAT [n -S]\n",
  "HURLBATS": "HURLBAT, (obsolete) an ancient Roman boxing glove loaded with metal, aka cestus, also WHIRLBAT, WHORLBAT [n]\n",
  "HURLED": "HURL, to throw with great force [v]\n",
  "HURLER": "one who hurls [n -S]\n",
  "HURLERS": "HURLER, one who hurls [n]\n",
  "HURLEY": "a ball game similar to hockey, also HURLING [n -S]\n",
  "HURLEYS": "HURLEY, a ball game similar to hockey, also HURLING [n]\n",
  "HURLIES": "HURLY, a large two-wheeled barrow [n]\n",
  "HURLING": "a ball game similar to hockey, also HURLEY [n -S]\n",
  "HURLINGS": "HURLING, a ball game similar to hockey, also HURLEY [n]\n",
  "HURLS": "HURL, to throw with great force [v]\n",
  "HURLY": "a large two-wheeled barrow [n HURLIES]\n",
  "HURRA": "to shout hurra, also HOORAH, HOORAY, HURRAH, HURRAY [v -ED, -ING, -S]\n",
  "HURRAED": "HURRA, to shout hurra, also HOORAH, HOORAY, HURRAH, HURRAY [v]\n",
  "HURRAH": "to shout hurrah, also HOORAH, HOORAY, HURRA, HURRAY [v -ED, -ING, -S]\n",
  "HURRAHED": "HURRAH, to shout hurrah, also HOORAH, HOORAY, HURRA, HURRAY [v]\n",
  "HURRAHING": "HURRAH, to shout hurrah, also HOORAH, HOORAY, HURRA, HURRAY [v]\n",
  "HURRAHS": "HURRAH, to shout hurrah, also HOORAH, HOORAY, HURRA, HURRAY [v]\n",
  "HURRAING": "HURRA, to shout hurra, also HOORAH, HOORAY, HURRAH, HURRAY [v]\n",
  "HURRAS": "HURRA, to shout hurra, also HOORAH, HOORAY, HURRAH, HURRAY [v]\n",
  "HURRAY": "to shout hurray, also HOORAH, HOORAY, HURRA, HURRAH [v -ED, -ING, -S]\n",
  "HURRAYED": "HURRAY, to shout hurray, also HOORAH, HOORAY, HURRA, HURRAH [v]\n",
  "HURRAYING": "HURRAY, to shout hurray, also HOORAH, HOORAY, HURRA, HURRAH [v]\n",
  "HURRAYS": "HURRAY, to shout hurray, also HOORAH, HOORAY, HURRA, HURRAH [v]\n",
  "HURRICANE": "a violent tropical storm, also HURRICANO [n -S]\n",
  "HURRICANES": "HURRICANE, a violent tropical storm, also HURRICANO [n]\n",
  "HURRICANO": "(Shakespeare) a hurricane [n -ES]\n",
  "HURRICANOES": "HURRICANO, (Shakespeare) a hurricane [n]\n",
  "HURRIED": "HURRY, to move swiftly [v]\n",
  "HURRIEDLY": "HURRIED, HURRY, to move swiftly [adv]\n",
  "HURRIEDNESS": "the state of being hurried [n -ES]\n",
  "HURRIEDNESSES": "HURRIEDNESS, the state of being hurried [n]\n",
  "HURRIER": "one who hurries [n -S]\n",
  "HURRIERS": "HURRIER, one who hurries [n]\n",
  "HURRIES": "HURRY, to move swiftly [v]\n",
  "HURRY": "to move swiftly [v HURRIED, HURRYING, HURRIES]\n",
  "HURRYING": "the act of hurrying [n -S]\n",
  "HURRYINGLY": "HURRYING [adv]\n",
  "HURRYINGS": "HURRYING, the act of hurrying [n]\n",
  "HURST": "a wood or grove [n -S]\n",
  "HURSTS": "HURST, a wood or grove [n]\n",
  "HURT": "to cause pain to, injure [v HURT, HURTING, HURTS]\n",
  "HURTER": "a beam, block, etc. to protect a wall from wheels [n -S]\n",
  "HURTERS": "HURTER, a beam, block, etc. to protect a wall from wheels [n]\n",
  "HURTFUL": "causing injury [adj HURTFULLY]\n",
  "HURTFULLY": "HURTFUL, causing injury [adv]\n",
  "HURTFULNESS": "the state of being hurtful [n -ES]\n",
  "HURTFULNESSES": "HURTFULNESS, the state of being hurtful [n]\n",
  "HURTING": "HURT, to cause pain to, injure [v]\n",
  "HURTLE": "to rush violently [v HURTLED, HURTLING, HURTLES]\n",
  "HURTLEBERRIES": "HURTLEBERRY, another name for whortleberry, also WHORT, WHORTLE, WHORTLEBERRY [n]\n",
  "HURTLEBERRY": "another name for whortleberry, also WHORT, WHORTLE, WHORTLEBERRY [n HURTLEBERRIES]\n",
  "HURTLED": "HURTLE, to rush violently [v]\n",
  "HURTLES": "HURTLE, to rush violently [v]\n",
  "HURTLESS": "without hurt [adj HURTLESSLY]\n",
  "HURTLESSLY": "HURTLESS, without hurt [adv]\n",
  "HURTLESSNESS": "the state of being hurtless [n -ES]\n",
  "HURTLESSNESSES": "HURTLESSNESS, the state of being hurtless [n]\n",
  "HURTLING": "HURTLE, to rush violently [v]\n",
  "HURTS": "HURT, to cause pain to, injure [v]\n",
  "HUSBAND": "to be a thrifty manager [v -ED, -ING, -S]\n",
  "HUSBANDAGE": "the commission or compensation allowed to a ship's husband [n -S]\n",
  "HUSBANDAGES": "HUSBANDAGE, the commission or compensation allowed to a ship's husband [n]\n",
  "HUSBANDED": "HUSBAND, to be a thrifty manager [v]\n",
  "HUSBANDER": "one who husbands [n -S]\n",
  "HUSBANDERS": "HUSBANDER, one who husbands [n]\n",
  "HUSBANDING": "HUSBAND, to be a thrifty manager [v]\n",
  "HUSBANDLAND": "a manorial tenant's holding; two oxgangs [n -S]\n",
  "HUSBANDLANDS": "HUSBANDLAND, a manorial tenant's holding; two oxgangs [n]\n",
  "HUSBANDLESS": "without a husband [adj]\n",
  "HUSBANDLIER": "HUSBANDLY, of or like a husband [adj]\n",
  "HUSBANDLIEST": "HUSBANDLY, of or like a husband [adj]\n",
  "HUSBANDLIKE": "like a husband [adj]\n",
  "HUSBANDLY": "of or like a husband [adj HUSBANDLIER, HUSBANDLIEST]\n",
  "HUSBANDMAN": "the master of a family [n HUSBANDMEN]\n",
  "HUSBANDMEN": "HUSBANDMAN, the master of a family [n]\n",
  "HUSBANDRIES": "HUSBANDRY, the business of a farmer; economical management [n]\n",
  "HUSBANDRY": "the business of a farmer; economical management [n HUSBANDRIES]\n",
  "HUSBANDS": "HUSBAND, to be a thrifty manager [v]\n",
  "HUSH": "to quiet [v -ED, -ING, -ES]\n",
  "HUSHABIED": "HUSHABY, to sing a lullaby, also HUSHABYE [v]\n",
  "HUSHABIES": "HUSHABY, to sing a lullaby, also HUSHABYE [v]\n",
  "HUSHABY": "to sing a lullaby, also HUSHABYE [v HUSHABIED, HUSHABYING, HUSHABIES]\n",
  "HUSHABYE": "go to sleep, also HUSHABY [interj]\n",
  "HUSHABYING": "HUSHABY, to sing a lullaby, also HUSHABYE [v]\n",
  "HUSHED": "HUSH, to quiet [v]\n",
  "HUSHEDLY": "HUSHED, HUSH, to quiet [adv]\n",
  "HUSHER": "to usher, escort people to heir seats [v -ED, -ING, -S]\n",
  "HUSHERED": "HUSHER, to usher, escort people to heir seats [v]\n",
  "HUSHERING": "HUSHER, to usher, escort people to heir seats [v]\n",
  "HUSHERS": "HUSHER, to usher, escort people to heir seats [v]\n",
  "HUSHES": "HUSH, to quiet [v]\n",
  "HUSHFUL": "quiet [adj]\n",
  "HUSHIER": "HUSHY, hush-hush, secret [adj]\n",
  "HUSHIEST": "HUSHY, hush-hush, secret [adj]\n",
  "HUSHING": "HUSH, to quiet [v]\n",
  "HUSHPUPPIES": "HUSHPUPPY, a snack of deep-fried cornmeal bread [n]\n",
  "HUSHPUPPY": "a snack of deep-fried cornmeal bread [n HUSHPUPPIES]\n",
  "HUSHY": "hush-hush, secret [adj HUSHIER, HUSHIEST]\n",
  "HUSK": "to remove the outer covering [v -ED, -ING, -S]\n",
  "HUSKED": "HUSK, to remove the outer covering [v]\n",
  "HUSKER": "someone who husks maize, esp. at a husking bee [n -S]\n",
  "HUSKERS": "HUSKER, someone who husks maize, esp. at a husking bee [n]\n",
  "HUSKIER": "HUSKY, hoarse [adj]\n",
  "HUSKIES": "HUSKY, a breed of dog used to pull sledges [n]\n",
  "HUSKIEST": "HUSKY, hoarse [adj]\n",
  "HUSKILY": "HUSKY, hoarse [adv]\n",
  "HUSKINESS": "the state of being husky [n -ES]\n",
  "HUSKINESSES": "HUSKINESS, the state of being husky [n]\n",
  "HUSKING": "a festive gathering to assist in husking maize [n -S]\n",
  "HUSKINGS": "HUSKING, a festive gathering to assist in husking maize [n]\n",
  "HUSKLIKE": "like a husk [adj]\n",
  "HUSKS": "HUSK, to remove the outer covering [v]\n",
  "HUSKY": "a breed of dog used to pull sledges [n HUSKIES] / hoarse [adj HUSKIER, HUSKIEST, HUSKILY]\n",
  "HUSO": "(German) the great sturgeon [n -S]\n",
  "HUSOS": "HUSO, (German) the great sturgeon [n]\n",
  "HUSS": "a type of dogfish used as food [n -ES]\n",
  "HUSSAR": "(Hungarian) a kind of cavalry soldier [n -S]\n",
  "HUSSARS": "HUSSAR, (Hungarian) a kind of cavalry soldier [n]\n",
  "HUSSES": "HUSS, a type of dogfish used as food [n]\n",
  "HUSSIES": "HUSSY, a brazen girl, also HUZZY [n]\n",
  "HUSSIF": "(dialect) a housewife, a pocket sewing-kit. also HUSWIFE [n -S]\n",
  "HUSSIFS": "HUSSIF, (dialect) a housewife, a pocket sewing-kit. also HUSWIFE [n]\n",
  "HUSSY": "a brazen girl, also HUZZY [n HUSSIES]\n",
  "HUSTINGS": "a political platform [n]\n",
  "HUSTLE": "to hurry [v HUSTLED, HUSTLING, HUSTLES]\n",
  "HUSTLED": "HUSTLE, to hurry [v]\n",
  "HUSTLER": "one who hustles [n -S]\n",
  "HUSTLERS": "HUSTLER, one who hustles [n]\n",
  "HUSTLES": "HUSTLE, to hurry [v]\n",
  "HUSTLING": "the act of hustling [n -S]\n",
  "HUSTLINGS": "HUSTLING, the act of hustling [n]\n",
  "HUSWIFE": "a sewing kit [n HUSWIFES or HUSWIVES]\n",
  "HUSWIFES": "HUSWIFE, a sewing kit [n]\n",
  "HUSWIVES": "HUSWIFE, a sewing kit [n]\n",
  "HUT": "a small, mean or crudely built house [n -S] / to settle in a hut [v HUTTED, HUTTING, HUTS]\n",
  "HUTCH": "a coop or cage for small animals [n -ES] / to hoard up [v -ED, -ING, -ES]\n",
  "HUTCHED": "HUTCH, to hoard up [v]\n",
  "HUTCHES": "HUTCH, to hoard up [v]\n",
  "HUTCHIE": "(Australian) a groundsheet draped over a stick as makeshift shelter [n -S]\n",
  "HUTCHIES": "HUTCHIE, (Australian) a groundsheet draped over a stick as makeshift shelter [n]\n",
  "HUTCHING": "HUTCH, to hoard up [v]\n",
  "HUTIA": "(Spanish) a West Indian rodent, aka hog-rat [n -S]\n",
  "HUTIAS": "HUTIA, (Spanish) a West Indian rodent, aka hog-rat [n]\n",
  "HUTLIKE": "like a hut [adj]\n",
  "HUTMENT": "a group of huts [n -S]\n",
  "HUTMENTS": "HUTMENT, a group of huts [n]\n",
  "HUTS": "HUT, to settle in a hut [v]\n",
  "HUTTED": "HUT, to settle in a hut [v]\n",
  "HUTTING": "material for making huts [n -S]\n",
  "HUTTINGS": "HUTTING, material for making huts [n]\n",
  "HUTZPA": "(Yiddish) sass, moxie, also CHUTZPA, CHUTZPAH, HUTZPAH [n -S]\n",
  "HUTZPAH": "(Yiddish) sass, moxie, also CHUTZPA, CHUTZPAH, HUTZPA [n -S]\n",
  "HUTZPAHS": "HUTZPAH, (Yiddish) sass, moxie, also CHUTZPA, CHUTZPAH, HUTZPA [n]\n",
  "HUTZPAS": "HUTZPA, (Yiddish) sass, moxie, also CHUTZPA, CHUTZPAH, HUTZPAH [n]\n",
  "HUZOOR": "(Urdu) an Indian potentate, a title used by Indians in respectful address [n -S]\n",
  "HUZOORS": "HUZOOR, (Urdu) an Indian potentate, a title used by Indians in respectful address [n]\n",
  "HUZZA": "to cheer [v -ED, -ING, -S]\n",
  "HUZZAED": "HUZZA, to cheer [v]\n",
  "HUZZAH": "a word used as a shout of joy or encouragement [n -S] / to give a shout of huzzah, also HUZZA [v -ED, -ING, -S]\n",
  "HUZZAHED": "HUZZAH, to give a shout of huzzah, also HUZZA [v]\n",
  "HUZZAHING": "HUZZAH, to give a shout of huzzah, also HUZZA [v]\n",
  "HUZZAHS": "HUZZAH, to give a shout of huzzah, also HUZZA [v]\n",
  "HUZZAING": "HUZZA, to cheer [v]\n",
  "HUZZAS": "HUZZA, to cheer [v]\n",
  "HUZZIES": "HUZZY, (dialect) a brazen girl, also HUSSY [n]\n",
  "HUZZY": "(dialect) a brazen girl, also HUSSY [n HUZZIES]\n",
  "HWAN": "a monetary unit of South Korea [n HWAN]\n",
  "HWYL": "(Welsh) divine inspiration in oratory [n -S]\n",
  "HWYLS": "HWYL, (Welsh) divine inspiration in oratory [n]\n",
  "HYACINE": "(Spenser) a blue gemstone, hyacinth [n -S]\n",
  "HYACINES": "HYACINE, (Spenser) a blue gemstone, hyacinth [n]\n",
  "HYACINTH": "a bulbous genus of the lily family [n -S]\n",
  "HYACINTHINE": "of a blue or purple colour [adj]\n",
  "HYACINTHS": "HYACINTH, a bulbous genus of the lily family [n]\n",
  "HYAENA": "a carrion-feeding carnivore of the family Hyaenidae, also HYEN, HYENA [n -S]\n",
  "HYAENAS": "HYAENA, a carrion-feeding carnivore of the family Hyaenidae, also HYEN, HYENA [n]\n",
  "HYAENIC": "of or like a hyaena, also HYENIC, HYENINE, HYENOID [adj]\n",
  "HYALIN": "a clear translucent substance, such as that in hydatid cysts [n -S]\n",
  "HYALINE": "glassy, of or like glass, transparent [adj] / (Milton) a glassy transparent surface [n -S]\n",
  "HYALINES": "HYALINE, (Milton) a glassy transparent surface [n]\n",
  "HYALINISATION": "the process of hyalinising, also HYALINIZATION [n -S]\n",
  "HYALINISATIONS": "HYALINISATION, the process of hyalinising, also HYALINIZATION [n]\n",
  "HYALINISE": "of tissue, to change to a firm, glassy consistency, also HYALINIZE [v HYALINISED, HYALINISING, HYALINISES]\n",
  "HYALINISED": "HYALINISE, of tissue, to change to a firm, glassy consistency, also HYALINIZE [v]\n",
  "HYALINISES": "HYALINISE, of tissue, to change to a firm, glassy consistency, also HYALINIZE [v]\n",
  "HYALINISING": "HYALINISE, of tissue, to change to a firm, glassy consistency, also HYALINIZE [v]\n",
  "HYALINIZATION": "the process of hyalinizing, also HYALINISATION [n -S]\n",
  "HYALINIZATIONS": "HYALINIZATION, the process of hyalinizing, also HYALINISATION [n]\n",
  "HYALINIZE": "of tissue, to change to a firm, glassy consistency, also HYALINISE [v HYALINIZED, HYALINIZING, HYALINIZES]\n",
  "HYALINIZED": "HYALINIZE, of tissue, to change to a firm, glassy consistency, also HYALINISE [v]\n",
  "HYALINIZES": "HYALINIZE, of tissue, to change to a firm, glassy consistency, also HYALINISE [v]\n",
  "HYALINIZING": "HYALINIZE, of tissue, to change to a firm, glassy consistency, also HYALINISE [v]\n",
  "HYALINS": "HYALIN, a clear translucent substance, such as that in hydatid cysts [n]\n",
  "HYALITE": "a pellucid variety of opal in globules looking like colorless gum or resin [n -S]\n",
  "HYALITES": "HYALITE, a pellucid variety of opal in globules looking like colorless gum or resin [n]\n",
  "HYALOGEN": "a substance found in animal cells [n -S]\n",
  "HYALOGENS": "HYALOGEN, a substance found in animal cells [n]\n",
  "HYALOID": "a thin transparent membrane enclosing the vitreous humour of the eye [n -S]\n",
  "HYALOIDS": "HYALOID, a thin transparent membrane enclosing the vitreous humour of the eye [n]\n",
  "HYALOMELAN": "a vitreous form of basalt, aka tachylite, also HYALOMELANE [n -S]\n",
  "HYALOMELANE": "a vitreous form of basalt, aka tachylite, also HYALOMELAN [n -S]\n",
  "HYALOMELANES": "HYALOMELANE, a vitreous form of basalt, aka tachylite, also HYALOMELAN [n]\n",
  "HYALOMELANS": "HYALOMELAN, a vitreous form of basalt, aka tachylite, also HYALOMELANE [n]\n",
  "HYALONEMA": "a genus of sponges, aka glass-rope sponge [n -S]\n",
  "HYALONEMAS": "HYALONEMA, a genus of sponges, aka glass-rope sponge [n]\n",
  "HYALOPHANE": "a species of the feldspar group containing barium [n -S]\n",
  "HYALOPHANES": "HYALOPHANE, a species of the feldspar group containing barium [n]\n",
  "HYALOPLASM": "the clear fluid part of protoplasm [n -S]\n",
  "HYALOPLASMIC": "of or like hyaloplasm, the clear fluid part of protoplasm [adj]\n",
  "HYALOPLASMS": "HYALOPLASM, the clear fluid part of protoplasm [n]\n",
  "HYALURONIC": "as in hyaluronic acid, a viscous polysaccharide with important lubricating properties, present, for example, in the synovial fluid in joints [adj]\n",
  "HYALURONIDASE": "a mucolytic enzyme that facilitates the spread of fluids through tissues by lowering the viscosity of hyaluronic acid [n -S]\n",
  "HYALURONIDASES": "HYALURONIDASE, a mucolytic enzyme that facilitates the spread of fluids through tissues by lowering the viscosity of hyaluronic acid [n]\n",
  "HYBRID": "the offspring of genetically dissimilar parents [n -S]\n",
  "HYBRIDISABLE": "capable of being hybridised, also HYBRIDIZABLE [adj]\n",
  "HYBRIDISATION": "the process of hybridising, also HYBRIDIZATION [n -S]\n",
  "HYBRIDISATIONS": "HYBRIDISATION, the process of hybridising, also HYBRIDIZATION [n]\n",
  "HYBRIDISE": "to create a hybrid, also HYBRIDIZE [v HYBRIDISED, HYBRIDISING, HYBRIDISES]\n",
  "HYBRIDISED": "HYBRIDISE, to create a hybrid, also HYBRIDIZE [v]\n",
  "HYBRIDISER": "one who hybridises, also HYBRIDIZER [n -S]\n",
  "HYBRIDISERS": "HYBRIDISER, one who hybridises, also HYBRIDIZER [n]\n",
  "HYBRIDISES": "HYBRIDISE, to create a hybrid, also HYBRIDIZE [v]\n",
  "HYBRIDISING": "HYBRIDISE, to create a hybrid, also HYBRIDIZE [v]\n",
  "HYBRIDISM": "the state of being hybrid, also HYBRIDITY [n -S]\n",
  "HYBRIDISMS": "HYBRIDISM, the state of being hybrid, also HYBRIDITY [n]\n",
  "HYBRIDIST": "a practitioner of hybridism [n -S]\n",
  "HYBRIDISTS": "HYBRIDIST, a practitioner of hybridism [n]\n",
  "HYBRIDITIES": "HYBRIDITY, the state of being hybrid, also HYBRIDISM [n]\n",
  "HYBRIDITY": "the state of being hybrid, also HYBRIDISM [n HYBRIDITIES]\n",
  "HYBRIDIZABLE": "capable of being hybridized, also HYBRIDISABLE [adj]\n",
  "HYBRIDIZATION": "the act of hybridizing, also HYBRIDISATION [n -S]\n",
  "HYBRIDIZATIONS": "HYBRIDIZATION, the act of hybridizing, also HYBRIDISATION [n]\n",
  "HYBRIDIZE": "to create a hybrid, also HYBRIDISE [v HYBRIDIZED, HYBRIDIZING, HYBRIDIZES]\n",
  "HYBRIDIZED": "HYBRIDIZE, to create a hybrid, also HYBRIDISE [v]\n",
  "HYBRIDIZER": "one who hybridizes, also HYBRIDISER [n -S]\n",
  "HYBRIDIZERS": "HYBRIDIZER, one who hybridizes, also HYBRIDISER [n]\n",
  "HYBRIDIZES": "HYBRIDIZE, to create a hybrid, also HYBRIDISE [v]\n",
  "HYBRIDIZING": "HYBRIDIZE, to create a hybrid, also HYBRIDISE [v]\n",
  "HYBRIDOMA": "a hybrid cell produced by the fusion of an antibody-producing lymphocyte with a tumor cell [n HYBRIDOMAS or HYBRIDOMATA]\n",
  "HYBRIDOMAS": "HYBRIDOMA, a hybrid cell produced by the fusion of an antibody-producing lymphocyte with a tumor cell [n]\n",
  "HYBRIDOMATA": "HYBRIDOMA, a hybrid cell produced by the fusion of an antibody-producing lymphocyte with a tumor cell [n]\n",
  "HYBRIDOUS": "hybrid [adj]\n",
  "HYBRIDS": "HYBRID, the offspring of genetically dissimilar parents [n]\n",
  "HYBRIS": "(Greek) overbearing pride, also HUBRIS [n -ES]\n",
  "HYBRISES": "HYBRIS, (Greek) overbearing pride, also HUBRIS [n]\n",
  "HYBRISTIC": "having hubris, overwhelming pride, also HUBRISTIC [adj]\n",
  "HYDANTOIN": "a colourless odourless crystalline compound found in beet molasses and used in the manufacture of pharmaceuticals [n -S]\n",
  "HYDANTOINS": "HYDANTOIN, a colourless odourless crystalline compound found in beet molasses and used in the manufacture of pharmaceuticals [n]\n",
  "HYDATHODE": "an epidermal water-excreting organ [n -S]\n",
  "HYDATHODES": "HYDATHODE, an epidermal water-excreting organ [n]\n",
  "HYDATID": "a fluid-filled cyst, esp. one containing tapeworm larva [n -S]\n",
  "HYDATIDIFORM": "having the shape of a hydatid, a fluid-filled cyst, esp. one containing tapeworm larva [adj]\n",
  "HYDATIDS": "HYDATID, a fluid-filled cyst, esp. one containing tapeworm larva [n]\n",
  "HYDATOID": "watery [adj]\n",
  "HYDNOCARPATE": "any salt or ester of hydnocarpic acid [n -S]\n",
  "HYDNOCARPATES": "HYDNOCARPATE, any salt or ester of hydnocarpic acid [n]\n",
  "HYDNOCARPIC": "denoting a type of acid [adj]\n",
  "HYDRA": "(Greek) a kind of freshwater polyp [n HYDRAS or HYDRAE]\n",
  "HYDRACID": "an oxygenless acid [n -S]\n",
  "HYDRACIDS": "HYDRACID, an oxygenless acid [n]\n",
  "HYDRAE": "HYDRA, (Greek) a kind of freshwater polyp [n]\n",
  "HYDRAEMIA": "an abnormally watery state of the blood, also HYDREMIA [n -S]\n",
  "HYDRAEMIAS": "HYDRAEMIA, an abnormally watery state of the blood, also HYDREMIA [n]\n",
  "HYDRAGOG": "a purgative causing watery discharges [n -S]\n",
  "HYDRAGOGS": "HYDRAGOG, a purgative causing watery discharges [n]\n",
  "HYDRAGOGUE": "causing discharge of water [adj] / a drug that causes discharge of water, also HYDRAGOG [n -S]\n",
  "HYDRAGOGUES": "HYDRAGOGUE, a drug that causes discharge of water, also HYDRAGOG [n]\n",
  "HYDRALAZINE": "a vasodilator used in the form of its hydrochloride to treat hypertension [n -S]\n",
  "HYDRALAZINES": "HYDRALAZINE, a vasodilator used in the form of its hydrochloride to treat hypertension [n]\n",
  "HYDRANGEA": "a plant of the Hydrangea genus of shrubby plants [n -S]\n",
  "HYDRANGEAS": "HYDRANGEA, a plant of the Hydrangea genus of shrubby plants [n]\n",
  "HYDRANT": "an outlet from a water main [n -S]\n",
  "HYDRANTH": "a nutritive zooid in a colony of hydrozoans [n -S]\n",
  "HYDRANTHS": "HYDRANTH, a nutritive zooid in a colony of hydrozoans [n]\n",
  "HYDRANTS": "HYDRANT, an outlet from a water main [n]\n",
  "HYDRARGYRAL": "relating to hydrargyrum, mercury [adj]\n",
  "HYDRARGYRIA": "mercury poisoning, also HYDRARGYRISM [n -S]\n",
  "HYDRARGYRIAS": "HYDRARGYRIA, mercury poisoning, also HYDRARGYRISM [n]\n",
  "HYDRARGYRIC": "relating to hydrargyria [adj]\n",
  "HYDRARGYRISM": "mercury poisoning, also HYDRARGYRIA [n -S]\n",
  "HYDRARGYRISMS": "HYDRARGYRISM, mercury poisoning, also HYDRARGYRIA [n]\n",
  "HYDRARGYRUM": "an obsolete name for mercury [n -S]\n",
  "HYDRARGYRUMS": "HYDRARGYRUM, an obsolete name for mercury [n]\n",
  "HYDRARTHROSES": "HYDRARTHROSIS, swelling of a joint caused by the accumulation in it of watery fluid [n]\n",
  "HYDRARTHROSIS": "swelling of a joint caused by the accumulation in it of watery fluid [n HYDRARTHROSES]\n",
  "HYDRAS": "HYDRA, (Greek) a kind of freshwater polyp [n]\n",
  "HYDRASE": "an enzyme that speeds up the removal or addition of water in a chemical reaction [n -S]\n",
  "HYDRASES": "HYDRASE, an enzyme that speeds up the removal or addition of water in a chemical reaction [n]\n",
  "HYDRASTINE": "a white poisonous alkaloid extracted from the roots of the goldenseal, which has been used in medicine to contract the uterus and arrest haemorrhage [n -S]\n",
  "HYDRASTINES": "HYDRASTINE, a white poisonous alkaloid extracted from the roots of the goldenseal, which has been used in medicine to contract the uterus and arrest haemorrhage [n]\n",
  "HYDRASTININE": "a colourless crystalline water-soluble compound whose pharmacological action resembles that of hydrastine [n -S]\n",
  "HYDRASTININES": "HYDRASTININE, a colourless crystalline water-soluble compound whose pharmacological action resembles that of hydrastine [n]\n",
  "HYDRASTIS": "any of various Japanese and North American plants, such as goldenseal, having showy foliage and ornamental red fruits [n HYDRASTISES]\n",
  "HYDRASTISES": "HYDRASTIS, any of various Japanese and North American plants, such as goldenseal, having showy foliage and ornamental red fruits [n]\n",
  "HYDRATE": "to combine with water [v HYDRATED, HYDRATING, HYDRATES]\n",
  "HYDRATED": "HYDRATE, to combine with water [v]\n",
  "HYDRATES": "HYDRATE, to combine with water [v]\n",
  "HYDRATING": "HYDRATE, to combine with water [v]\n",
  "HYDRATION": "the act of combining with water [n -S]\n",
  "HYDRATIONS": "HYDRATION, the act of combining with water [n]\n",
  "HYDRATOR": "something that hydrates [n -S]\n",
  "HYDRATORS": "HYDRATOR, something that hydrates [n]\n",
  "HYDRAULIC": "relating to water [adj HYDRAULICALLY] / to excavate and wash out with powerful jets of water [v HYDRAULICKED, HYDRAULICKING, HYDRAULICS]\n",
  "HYDRAULICALLY": "HYDRAULIC, relating to water [adv]\n",
  "HYDRAULICKED": "HYDRAULIC, to excavate and wash out with powerful jets of water [v]\n",
  "HYDRAULICKING": "the act of excavating with powerful jets of water [n -S]\n",
  "HYDRAULICKINGS": "HYDRAULICKING, the act of excavating with powerful jets of water [n]\n",
  "HYDRAULICS": "HYDRAULIC, to excavate and wash out with powerful jets of water [v]\n",
  "HYDRAZIDE": "any of a class of compounds resulting from the replacement of hydrogen by an acid group or in one of its derivatives [n -S]\n",
  "HYDRAZIDES": "HYDRAZIDE, any of a class of compounds resulting from the replacement of hydrogen by an acid group or in one of its derivatives [n]\n",
  "HYDRAZINE": "a colourless basic liquid made from sodium hypochlorite and ammonia, used chiefly as a rocket fuel [n -S]\n",
  "HYDRAZINES": "HYDRAZINE, a colourless basic liquid made from sodium hypochlorite and ammonia, used chiefly as a rocket fuel [n]\n",
  "HYDRAZOIC": "as in hydrazoic acid, a colourless highly explosive liquid [adj]\n",
  "HYDREMIA": "an excessively watery condition of the blood, also HYDRAEMIA [n -S]\n",
  "HYDREMIAS": "HYDREMIA, an excessively watery condition of the blood, also HYDRAEMIA [n]\n",
  "HYDRIA": "(Greek) a large Greek water-vase [n HYDRIAE]\n",
  "HYDRIAE": "HYDRIA, (Greek) a large Greek water-vase [n]\n",
  "HYDRIC": "adapted to life with an abundance of moisture [adj HYDRICALLY]\n",
  "HYDRICALLY": "HYDRIC, adapted to life with an abundance of moisture [adv]\n",
  "HYDRID": "any compound of hydrogen with another element, also HYDRIDE [n -S]\n",
  "HYDRIDE": "any compound of hydrogen with another element, also HYDRID [n -S]\n",
  "HYDRIDES": "HYDRIDE, any compound of hydrogen with another element, also HYDRID [n]\n",
  "HYDRIDS": "HYDRID, any compound of hydrogen with another element, also HYDRIDE [n]\n",
  "HYDRILLA": "an aquatic plant used as an oxygenator in aquaria and pools [n -S]\n",
  "HYDRILLAS": "HYDRILLA, an aquatic plant used as an oxygenator in aquaria and pools [n]\n",
  "HYDRIODIC": "pertaining to, or derived from, hydrogen and iodine, esp. of hydriodic acid [adj]\n",
  "HYDRO": "(short for) a hydropathic establishment [n -S]\n",
  "HYDROACOUSTICS": "the study of sound travelling through water [n]\n",
  "HYDROBIOLOGICAL": "relating to hydrobiology, the study of aquatic organisms [adj]\n",
  "HYDROBIOLOGIES": "HYDROBIOLOGY, the study of aquatic organisms [n]\n",
  "HYDROBIOLOGIST": "a student of hydrobiology [n -S]\n",
  "HYDROBIOLOGISTS": "HYDROBIOLOGIST, a student of hydrobiology [n]\n",
  "HYDROBIOLOGY": "the study of aquatic organisms [n HYDROBIOLOGIES]\n",
  "HYDROBROMIC": "applied to an acid composed of hydrogen and bromine, hydrogen bromide [adj]\n",
  "HYDROCARBON": "a compound of hydrogen and carbon with nothing else, occurring notably in oil, natural gas and coal [n -S]\n",
  "HYDROCARBONS": "HYDROCARBON, a compound of hydrogen and carbon with nothing else, occurring notably in oil, natural gas and coal [n]\n",
  "HYDROCAST": "a gathering of water samples for analysis [n -S]\n",
  "HYDROCASTS": "HYDROCAST, a gathering of water samples for analysis [n]\n",
  "HYDROCELE": "an abnormal collection of fluid in any saclike space, esp. around the testicles [n -S]\n",
  "HYDROCELES": "HYDROCELE, an abnormal collection of fluid in any saclike space, esp. around the testicles [n]\n",
  "HYDROCELLULOSE": "a gelatinous material obtained by hydration of cellulose, used in papermaking, etc. [n -S]\n",
  "HYDROCELLULOSES": "HYDROCELLULOSE, a gelatinous material obtained by hydration of cellulose, used in papermaking, etc. [n]\n",
  "HYDROCEPHALI": "HYDROCEPHALUS, an accumulation of serous fluid within the cranial cavity, also HYDROCEPHALY [n]\n",
  "HYDROCEPHALIC": "relating to hydrocephaly, also HYDROCEPHALOUS [adj] / one suffering from hydrocephaly [n -S]\n",
  "HYDROCEPHALICS": "HYDROCEPHALIC, one suffering from hydrocephaly [n]\n",
  "HYDROCEPHALIES": "HYDROCEPHALY, an accumulation of serous fluid within the cranial cavity, also HYDROCEPHALUS [n]\n",
  "HYDROCEPHALOID": "suffering from hydrocephalus, an accumulation of serous fluid within the cranial cavity [adj]\n",
  "HYDROCEPHALOUS": "suffering from hydrocephaly, also HYDROCEPHALIC [adj]\n",
  "HYDROCEPHALUS": "an accumulation of serous fluid within the cranial cavity, also HYDROCEPHALY [n HYDROCEPHALI or HYDROCEPHALUSES]\n",
  "HYDROCEPHALUSES": "HYDROCEPHALUS, an accumulation of serous fluid within the cranial cavity, also HYDROCEPHALY [n]\n",
  "HYDROCEPHALY": "an accumulation of serous fluid within the cranial cavity, also HYDROCEPHALUS [n HYDROCEPHALIES]\n",
  "HYDROCHLORIC": "applied to an acid composed of hydrogen and chlorine, hydrogen chloride, still sometimes called muriatic acid [adj]\n",
  "HYDROCHLORIDE": "a chemical complex composed of an organic base in association with hydrogen chloride [n -S]\n",
  "HYDROCHLORIDES": "HYDROCHLORIDE, a chemical complex composed of an organic base in association with hydrogen chloride [n]\n",
  "HYDROCHORE": "a plant disseminated by water [n -S]\n",
  "HYDROCHORES": "HYDROCHORE, a plant disseminated by water [n]\n",
  "HYDROCHORIC": "of or like a hydrochore, a plant disseminated by water [adj]\n",
  "HYDROCODONE": "a semisynthetic opioid drug derived from codeine and thebaine [n -S]\n",
  "HYDROCODONES": "HYDROCODONE, a semisynthetic opioid drug derived from codeine and thebaine [n]\n",
  "HYDROCOLLOID": "a substance that yields a gel with water [n -S]\n",
  "HYDROCOLLOIDAL": "of or like a hydrocolloid [adj]\n",
  "HYDROCOLLOIDS": "HYDROCOLLOID, a substance that yields a gel with water [n]\n",
  "HYDROCORAL": "any hydrozoan coelenterate of an order which includes the millepores [n -S]\n",
  "HYDROCORALLINE": "a member the Hydrozoa, which includes millepores etc. [n -S]\n",
  "HYDROCORALLINES": "HYDROCORALLINE, a member the Hydrozoa, which includes millepores etc. [n]\n",
  "HYDROCORALS": "HYDROCORAL, any hydrozoan coelenterate of an order which includes the millepores [n]\n",
  "HYDROCORTISONE": "a glucocorticoid hormone that is used to treat inflammatory and allergic conditions, aka cortisol [n -S]\n",
  "HYDROCORTISONES": "HYDROCORTISONE, a glucocorticoid hormone that is used to treat inflammatory and allergic conditions, aka cortisol [n]\n",
  "HYDROCRACK": "to crack hydrocarbons in the presence of hydrogen [v -ED, -ING, -S]\n",
  "HYDROCRACKED": "HYDROCRACK, to crack hydrocarbons in the presence of hydrogen [v]\n",
  "HYDROCRACKER": "one engaged in hydrocracking [n -S]\n",
  "HYDROCRACKERS": "HYDROCRACKER, one engaged in hydrocracking [n]\n",
  "HYDROCRACKING": "the process of cracking hydrocarbons in the presence of hydrogen [n -S]\n",
  "HYDROCRACKINGS": "HYDROCRACKING, the process of cracking hydrocarbons in the presence of hydrogen [n]\n",
  "HYDROCRACKS": "HYDROCRACK, to crack hydrocarbons in the presence of hydrogen [v]\n",
  "HYDROCYANIC": "denoting an acid (prussic acid) composed of hydrogen and cyanogen [adj]\n",
  "HYDRODYNAMIC": "of, relating to, or involving principles of hydrodynamics, also HYDRODYNAMICAL [adj]\n",
  "HYDRODYNAMICAL": "of, relating to, or involving principles of hydrodynamics, also HYDRODYNAMIC [adj]\n",
  "HYDRODYNAMICIST": "a student of hydrodynamics [n]\n",
  "HYDRODYNAMICS": "the study of movement in liquids, also HYDROMECHANICS [n]\n",
  "HYDROELASTIC": "as in hydroelastic suspension, a system of car suspension in which a fluid provides interconnection between the front and rear suspension units [adj]\n",
  "HYDROELECTRIC": "of or relating to production of electricity by waterpower [adj]\n",
  "HYDROEXTRACTOR": "a drying machine that works centrifugally [n -S]\n",
  "HYDROEXTRACTORS": "HYDROEXTRACTOR, a drying machine that works centrifugally [n]\n",
  "HYDROFLUORIC": "as in hydrofluoric acid, a strong acid used for etching glass [adj]\n",
  "HYDROFOIL": "a boat fitted with hydrofoils to lift its hull clear of the water at speed [n -S]\n",
  "HYDROFOILS": "HYDROFOIL, a boat fitted with hydrofoils to lift its hull clear of the water at speed [n]\n",
  "HYDROFORMING": "the catalytic reforming of petroleum to increase the proportion of aromatic and branched-chain hydrocarbons [n -S]\n",
  "HYDROFORMINGS": "HYDROFORMING, the catalytic reforming of petroleum to increase the proportion of aromatic and branched-chain hydrocarbons [n]\n",
  "HYDROGEL": "a gel or gelatinous precipitate in which the liquid constituent is water [n -S]\n",
  "HYDROGELS": "HYDROGEL, a gel or gelatinous precipitate in which the liquid constituent is water [n]\n",
  "HYDROGEN": "a gaseous element [n -S]\n",
  "HYDROGENASE": "an enzyme that catalyzes hydrogen formation in certain microorganisms [n -S]\n",
  "HYDROGENASES": "HYDROGENASE, an enzyme that catalyzes hydrogen formation in certain microorganisms [n]\n",
  "HYDROGENATE": "to combine or treat with hydrogen [v HYDROGENATED, HYDROGENATING, HYDROGENATES]\n",
  "HYDROGENATED": "HYDROGENATE, to combine or treat with hydrogen [v]\n",
  "HYDROGENATES": "HYDROGENATE, to combine or treat with hydrogen [v]\n",
  "HYDROGENATING": "HYDROGENATE, to combine or treat with hydrogen [v]\n",
  "HYDROGENATION": "the act of hydrogenating [n -S]\n",
  "HYDROGENATIONS": "HYDROGENATION, the act of hydrogenating [n]\n",
  "HYDROGENATOR": "an agent that hydrogenates [n -S]\n",
  "HYDROGENATORS": "HYDROGENATOR, an agent that hydrogenates [n]\n",
  "HYDROGENISATION": "the process of hydrogenising, also HYDROGENIZATION [n]\n",
  "HYDROGENISE": "to hydrogenate, also HYDROGENIZE [v HYDROGENISED, HYDROGENISING, HYDROGENISES]\n",
  "HYDROGENISED": "HYDROGENISE, to hydrogenate, also HYDROGENIZE [v]\n",
  "HYDROGENISES": "HYDROGENISE, to hydrogenate, also HYDROGENIZE [v]\n",
  "HYDROGENISING": "HYDROGENISE, to hydrogenate, also HYDROGENIZE [v]\n",
  "HYDROGENIZATION": "the process of hydrogenizing, also HYDROGENISATION [n]\n",
  "HYDROGENIZE": "to hydrogenate, also HYDROGENISE [v HYDROGENIZED, HYDROGENIZING, HYDROGENIZES]\n",
  "HYDROGENIZED": "HYDROGENIZE, to hydrogenate, also HYDROGENISE [v]\n",
  "HYDROGENIZES": "HYDROGENIZE, to hydrogenate, also HYDROGENISE [v]\n",
  "HYDROGENIZING": "HYDROGENIZE, to hydrogenate, also HYDROGENISE [v]\n",
  "HYDROGENOLYSES": "HYDROGENOLYSIS, a chemical reaction in which a compound is decomposed by hydrogen [n]\n",
  "HYDROGENOLYSIS": "a chemical reaction in which a compound is decomposed by hydrogen [n HYDROGENOLYSES]\n",
  "HYDROGENOUS": "containing hydrogen [adj]\n",
  "HYDROGENS": "HYDROGEN, a gaseous element [n]\n",
  "HYDROGEOLOGICAL": "related to hydrogeology [adj]\n",
  "HYDROGEOLOGIES": "HYDROGEOLOGY, the study of the geological action of water [n]\n",
  "HYDROGEOLOGIST": "a student of hydrogeology [n -S]\n",
  "HYDROGEOLOGISTS": "HYDROGEOLOGIST, a student of hydrogeology [n]\n",
  "HYDROGEOLOGY": "the study of the geological action of water [n HYDROGEOLOGIES]\n",
  "HYDROGRAPH": "a graph of variation of stream flow over time [n -S]\n",
  "HYDROGRAPHER": "a student of hydrography [n -S]\n",
  "HYDROGRAPHERS": "HYDROGRAPHER, a student of hydrography [n]\n",
  "HYDROGRAPHIC": "relating to hydrography, the study of bodies of water, also HYDROGRAPHICAL [adj]\n",
  "HYDROGRAPHICAL": "relating to hydrography, the study of bodies of water, also HYDROGRAPHIC [adj]\n",
  "HYDROGRAPHIES": "HYDROGRAPHY, the study of bodies of water [n]\n",
  "HYDROGRAPHS": "HYDROGRAPH, a graph of variation of stream flow over time [n]\n",
  "HYDROGRAPHY": "the study of bodies of water [n HYDROGRAPHIES]\n",
  "HYDROID": "a marine creature related to, or resembling, the hydra [n -S]\n",
  "HYDROIDS": "HYDROID, a marine creature related to, or resembling, the hydra [n]\n",
  "HYDROKINETIC": "of or relating to the motions of fluids or the forces which produce or affect such motions, also HYDROKINETICAL [adj]\n",
  "HYDROKINETICAL": "of or relating to the motions of fluids or the forces which produce or affect such motions, also HYDROKINETIC [adj]\n",
  "HYDROKINETICS": "the study of the motion of fluids [n]\n",
  "HYDROLASE": "a hydrolytic enzyme [n -S]\n",
  "HYDROLASES": "HYDROLASE, a hydrolytic enzyme [n]\n",
  "HYDROLOGIC": "relating to hydrology, also HYDROLOGICAL [adj HYDROLOGICALLY]\n",
  "HYDROLOGICAL": "relating to hydrology, also HYDROLOGIC [adj HYDROLOGICALLY]\n",
  "HYDROLOGICALLY": "HYDROLOGICAL, relating to hydrology, also HYDROLOGIC [adv]\n",
  "HYDROLOGIES": "HYDROLOGY, the study of water resources [n]\n",
  "HYDROLOGIST": "an expert in hydrology [n -S]\n",
  "HYDROLOGISTS": "HYDROLOGIST, an expert in hydrology [n]\n",
  "HYDROLOGY": "the study of water resources [n HYDROLOGIES]\n",
  "HYDROLYSABLE": "that can be hydrolysed, also HYDROLYZABLE [adj]\n",
  "HYDROLYSATE": "a product of hydrolysis, also HYDROLYZATE [n -S]\n",
  "HYDROLYSATES": "HYDROLYSATE, a product of hydrolysis, also HYDROLYZATE [n]\n",
  "HYDROLYSATION": "the process of hydrolysing, also HYDROLYZATION [n -S]\n",
  "HYDROLYSATIONS": "HYDROLYSATION, the process of hydrolysing, also HYDROLYZATION [n]\n",
  "HYDROLYSE": "to subject to hydrolysis, also HYDROLYZE [v HYDROLYSED, HYDROLYSING, HYDROLYSES]\n",
  "HYDROLYSED": "HYDROLYSE, to subject to hydrolysis, also HYDROLYZE [v]\n",
  "HYDROLYSER": "an agent that hydrolyses, also HYDROLYZER [n -S]\n",
  "HYDROLYSERS": "HYDROLYSER, an agent that hydrolyses, also HYDROLYZER [n]\n",
  "HYDROLYSES": "HYDROLYSE, to subject to hydrolysis, also HYDROLYZE [v]\n",
  "HYDROLYSING": "HYDROLYSE, to subject to hydrolysis, also HYDROLYZE [v]\n",
  "HYDROLYSIS": "a decomposition reaction involving water, in which hydrogen ions replace other ions [n HYDROLYSES]\n",
  "HYDROLYTE": "a body subjected to hydrolysis [n -S]\n",
  "HYDROLYTES": "HYDROLYTE, a body subjected to hydrolysis [n]\n",
  "HYDROLYTIC": "tending to remove or separate water [adj HYDROLYTICALLY]\n",
  "HYDROLYTICALLY": "HYDROLYTIC, tending to remove or separate water [adv]\n",
  "HYDROLYZABLE": "that can be hydrolyzed, also HYDROLYSABLE [adj]\n",
  "HYDROLYZATE": "a product of hydrolysis, also HYDROLYSATE [n -S]\n",
  "HYDROLYZATES": "HYDROLYZATE, a product of hydrolysis, also HYDROLYSATE [n]\n",
  "HYDROLYZATION": "the process of hydrolyzing, also HYDROLYSATION [n -S]\n",
  "HYDROLYZATIONS": "HYDROLYZATION, the process of hydrolyzing, also HYDROLYSATION [n]\n",
  "HYDROLYZE": "to subject to hydrolysis, also HYDROLYSE [v HYDROLYZED, HYDROLYZING, HYDROLYZES]\n",
  "HYDROLYZED": "HYDROLYZE, to subject to hydrolysis, also HYDROLYSE [v]\n",
  "HYDROLYZER": "an agent that hydrolyzes, also HYDROLYSER [n -S]\n",
  "HYDROLYZERS": "HYDROLYZER, an agent that hydrolyzes, also HYDROLYSER [n]\n",
  "HYDROLYZES": "HYDROLYZE, to subject to hydrolysis, also HYDROLYSE [v]\n",
  "HYDROLYZING": "HYDROLYZE, to subject to hydrolysis, also HYDROLYSE [v]\n",
  "HYDROMA": "a watery swelling over a joint, e.g. water on the knee, also HYGROMA [n HYDROMAS or HYDROMATA]\n",
  "HYDROMAGNETIC": "relating to hydromagnetics, a branch of mathematical physics dealing with interactions between an electricity-conducting fluid (such as an ionized gas) and a magnetic field [adj]\n",
  "HYDROMAGNETICS": "a branch of mathematical physics dealing with interactions between an electricity-conducting fluid (such as an ionized gas) and a magnetic field [n]\n",
  "HYDROMANCER": "one who practises hydromancy [n -S]\n",
  "HYDROMANCERS": "HYDROMANCER, one who practises hydromancy [n]\n",
  "HYDROMANCIES": "HYDROMANCY, divination by the appearance or motion of liquids (as water) [n]\n",
  "HYDROMANCY": "divination by the appearance or motion of liquids (as water) [n HYDROMANCIES]\n",
  "HYDROMANIA": "an irrational craving for water [n -S]\n",
  "HYDROMANIAS": "HYDROMANIA, an irrational craving for water [n]\n",
  "HYDROMANTIC": "related to hydromancy, divination by water [adj]\n",
  "HYDROMAS": "HYDROMA, a watery swelling over a joint, e.g. water on the knee, also HYGROMA [n]\n",
  "HYDROMATA": "HYDROMA, a watery swelling over a joint, e.g. water on the knee, also HYGROMA [n]\n",
  "HYDROMECHANICAL": "relating to a branch of mechanics that deals with the equilibrium and motion of fluids and of solid bodies immersed in them [adj]\n",
  "HYDROMECHANICS": "the study of movement in liquids, also HYDRODYNAMICS [n]\n",
  "HYDROMEDUSA": "a hydrozoan in its medusoid stage, also HYDROMEDUSAN, HYDROMEDUSOID [n HYDROMEDUSAE or HYDROMEDUSAS]\n",
  "HYDROMEDUSAE": "HYDROMEDUSA, a hydrozoan in its medusoid stage, also HYDROMEDUSAN, HYDROMEDUSOID [n]\n",
  "HYDROMEDUSAN": "a hydromedusa, also HYDROMEDUSA, HYDROMEDUSOID [n -S]\n",
  "HYDROMEDUSANS": "HYDROMEDUSAN, a hydromedusa, also HYDROMEDUSA, HYDROMEDUSOID [n]\n",
  "HYDROMEDUSAS": "HYDROMEDUSA, a hydrozoan in its medusoid stage, also HYDROMEDUSAN, HYDROMEDUSOID [n]\n",
  "HYDROMEDUSOID": "a hydromedusa, also HYDROMEDUSA, HYDROMEDUSAN [n -S]\n",
  "HYDROMEDUSOIDS": "HYDROMEDUSOID, a hydromedusa, also HYDROMEDUSA, HYDROMEDUSAN [n]\n",
  "HYDROMEL": "a drink made with honey, water, herbs and spices [n -S]\n",
  "HYDROMELS": "HYDROMEL, a drink made with honey, water, herbs and spices [n]\n",
  "HYDROMETALLURGY": "the treatment of ores by wet processes (as leaching) [n]\n",
  "HYDROMETEOR": "a general term for the aqueous phenomena of the atmosphere, as rain, snow, sleet, hail [n -S]\n",
  "HYDROMETEORS": "HYDROMETEOR, a general term for the aqueous phenomena of the atmosphere, as rain, snow, sleet, hail [n]\n",
  "HYDROMETER": "an instrument for measuring the specific gravity of liquids [n -S]\n",
  "HYDROMETERS": "HYDROMETER, an instrument for measuring the specific gravity of liquids [n]\n",
  "HYDROMETRIC": "relating to measurement by hydrometer, also HYDROMETRICAL [adj HYDROMETRICALLY]\n",
  "HYDROMETRICAL": "relating to measurement by hydrometer, also HYDROMETRIC [adj HYDROMETRICALLY]\n",
  "HYDROMETRICALLY": "HYDROMETRICAL, relating to measurement by hydrometer, also HYDROMETRIC [adv]\n",
  "HYDROMETRIES": "HYDROMETRY, the art of determining the specific gravity of liquids, and thence the strength of spirituous liquors, saline solutions, etc. [n]\n",
  "HYDROMETRY": "the art of determining the specific gravity of liquids, and thence the strength of spirituous liquors, saline solutions, etc. [n HYDROMETRIES]\n",
  "HYDROMORPHIC": "developed in the presence of an excess of moisture which tends to suppress aerobic factors in soil-building [adj]\n",
  "HYDRONAUT": "a person trained to work in an underwater vessel [n -S]\n",
  "HYDRONAUTS": "HYDRONAUT, a person trained to work in an underwater vessel [n]\n",
  "HYDRONEPHROSES": "HYDRONEPHROSIS, distension of the kidney with urine held up as a result of obstruction in the urinary tract [n]\n",
  "HYDRONEPHROSIS": "distension of the kidney with urine held up as a result of obstruction in the urinary tract [n HYDRONEPHROSES]\n",
  "HYDRONEPHROTIC": "relating to hydronephrosis, distension of the kidney with urine [adj]\n",
  "HYDRONIC": "pertaining to heating and cooling by water [adj HYDRONICALLY]\n",
  "HYDRONICALLY": "HYDRONIC, pertaining to heating and cooling by water [adv]\n",
  "HYDRONIUM": "the hydrated hydrogen ion, H3O+ [n -S]\n",
  "HYDRONIUMS": "HYDRONIUM, the hydrated hydrogen ion, H3O+ [n]\n",
  "HYDROPATH": "a practitioner of hydropathy, the study of treating diseases with water [n -S]\n",
  "HYDROPATHIC": "relating to hydropathy, also HYDROPATHICAL [adj HYDROPATHICALLY] / a hotel (with special baths, etc., and often situated near a spa) where guests can have hydropathic treatment [n -S]\n",
  "HYDROPATHICAL": "relating to hydropathy, also HYDROPATHIC [adj HYDROPATHICALLY]\n",
  "HYDROPATHICALLY": "HYDROPATHICAL, relating to hydropathy, also HYDROPATHIC [adv]\n",
  "HYDROPATHICS": "HYDROPATHIC, a hotel (with special baths, etc., and often situated near a spa) where guests can have hydropathic treatment [n]\n",
  "HYDROPATHIES": "HYDROPATHY, the study of treating diseases with water [n]\n",
  "HYDROPATHIST": "one who treats with hydropathy [n -S]\n",
  "HYDROPATHISTS": "HYDROPATHIST, one who treats with hydropathy [n]\n",
  "HYDROPATHS": "HYDROPATH, a practitioner of hydropathy, the study of treating diseases with water [n]\n",
  "HYDROPATHY": "the study of treating diseases with water [n HYDROPATHIES]\n",
  "HYDROPEROXIDE": "a compound containing an O2H group [n -S]\n",
  "HYDROPEROXIDES": "HYDROPEROXIDE, a compound containing an O2H group [n]\n",
  "HYDROPHANE": "a semitranslucent variety of opal that becomes translucent or transparent on immersion in water [n -S]\n",
  "HYDROPHANES": "HYDROPHANE, a semitranslucent variety of opal that becomes translucent or transparent on immersion in water [n]\n",
  "HYDROPHANOUS": "becoming transparent when placed in water [adj]\n",
  "HYDROPHILE": "a plant loving moist places, also HYGROPHILE [n -S]\n",
  "HYDROPHILES": "HYDROPHILE, a plant loving moist places, also HYGROPHILE [n]\n",
  "HYDROPHILIC": "of, relating to, or having a strong affinity for water [adj]\n",
  "HYDROPHILICITY": "the state of being hydrophilic [n]\n",
  "HYDROPHILIES": "HYDROPHILY, an affinity for water [n]\n",
  "HYDROPHILITE": "native calcium chloride [n -S]\n",
  "HYDROPHILITES": "HYDROPHILITE, native calcium chloride [n]\n",
  "HYDROPHILOUS": "water-loving; pollinated by agency of water [adj]\n",
  "HYDROPHILY": "an affinity for water [n HYDROPHILIES]\n",
  "HYDROPHOBIA": "the morbid fear of water, as in rabies victims [n -S]\n",
  "HYDROPHOBIAS": "HYDROPHOBIA, the morbid fear of water, as in rabies victims [n]\n",
  "HYDROPHOBIC": "having a morbid fear of water [adj]\n",
  "HYDROPHOBICITY": "the state of being hydrophobic [n]\n",
  "HYDROPHOBOUS": "(obsolete) water-repellent [adj]\n",
  "HYDROPHONE": "an apparatus for listening to sounds conveyed by water [n -S]\n",
  "HYDROPHONES": "HYDROPHONE, an apparatus for listening to sounds conveyed by water [n]\n",
  "HYDROPHYTE": "an aquatic plant; an alga [n -S]\n",
  "HYDROPHYTES": "HYDROPHYTE, an aquatic plant; an alga [n]\n",
  "HYDROPHYTIC": "growing in or by water, also HYDROPHYTOUS [adj]\n",
  "HYDROPHYTON": "the coenosarc of a hydroid colony [n -S]\n",
  "HYDROPHYTONS": "HYDROPHYTON, the coenosarc of a hydroid colony [n]\n",
  "HYDROPHYTOUS": "like a hydrophyte, also HYDROPHYTIC [adj]\n",
  "HYDROPIC": "dropsical; thirsty, also HYDROPTIC [adj]\n",
  "HYDROPLANE": "to travel by hydroplane, a light, flat-bottomed motorboat [v HYDROPLANED, HYDROPLANING, HYDROPLANES]\n",
  "HYDROPLANED": "HYDROPLANE, to travel by hydroplane, a light, flat-bottomed motorboat [v]\n",
  "HYDROPLANES": "HYDROPLANE, to travel by hydroplane, a light, flat-bottomed motorboat [v]\n",
  "HYDROPLANING": "HYDROPLANE, to travel by hydroplane, a light, flat-bottomed motorboat [v]\n",
  "HYDROPNEUMATIC": "utilizing water and air acting together [adj]\n",
  "HYDROPOLYP": "a hydrozoan polyp [n -S]\n",
  "HYDROPOLYPS": "HYDROPOLYP, a hydrozoan polyp [n]\n",
  "HYDROPONIC": "relating to hydroponics, the practice of growing plants in a chemical solution without soil [adj]\n",
  "HYDROPONICALLY": "HYDROPONIC, relating to hydroponics, the practice of growing plants in a chemical solution without soil [adv]\n",
  "HYDROPONICS": "the practice of growing plants in a chemical solution without soil [n]\n",
  "HYDROPOWER": "water power [n -S]\n",
  "HYDROPOWERS": "HYDROPOWER, water power [n]\n",
  "HYDROPS": "(Greek) dropsy, also HYDROPSY [n -ES]\n",
  "HYDROPSES": "HYDROPS, (Greek) dropsy, also HYDROPSY [n]\n",
  "HYDROPSIES": "HYDROPSY, (archaic) dropsy, also HYDROPS [n]\n",
  "HYDROPSY": "(archaic) dropsy, also HYDROPS [n HYDROPSIES]\n",
  "HYDROPTIC": "dropsical, thirsty, also HYDROPIC [adj]\n",
  "HYDROPULT": "a machine for throwing water by hand power, as a garden engine, a fire extinguisher, etc. [n -S]\n",
  "HYDROPULTS": "HYDROPULT, a machine for throwing water by hand power, as a garden engine, a fire extinguisher, etc. [n]\n",
  "HYDROQUINOL": "a white crystalline soluble phenol used as a photographic developer [n -S]\n",
  "HYDROQUINOLS": "HYDROQUINOL, a white crystalline soluble phenol used as a photographic developer [n]\n",
  "HYDROQUINONE": "another name for quinol [n -S]\n",
  "HYDROQUINONES": "HYDROQUINONE, another name for quinol [n]\n",
  "HYDROS": "HYDRO, (short for) a hydropathic establishment [n]\n",
  "HYDROSCOPE": "an instrument for viewing under water [n -S]\n",
  "HYDROSCOPES": "HYDROSCOPE, an instrument for viewing under water [n]\n",
  "HYDROSCOPIC": "relating to a hydroscope, also HYDROSCOPICAL [adj]\n",
  "HYDROSCOPICAL": "relating to a hydroscope, also HYDROSCOPIC [adj]\n",
  "HYDROSERE": "an ecological sere originating in an aquatic habitat [n -S]\n",
  "HYDROSERES": "HYDROSERE, an ecological sere originating in an aquatic habitat [n]\n",
  "HYDROSKI": "a plate attached to a seaplane to facilitate takeoff and landings [n -S]\n",
  "HYDROSKIS": "HYDROSKI, a plate attached to a seaplane to facilitate takeoff and landings [n]\n",
  "HYDROSOL": "an aqueous solution of a colloid [n -S]\n",
  "HYDROSOLIC": "relating to a hydrosol, an aqueous solution of a colloid [adj]\n",
  "HYDROSOLS": "HYDROSOL, an aqueous solution of a colloid [n]\n",
  "HYDROSOMA": "all the zooids of a hydroid colony collectively, also HYDROSOME [n HYDROSOMATA]\n",
  "HYDROSOMAL": "relating to a hydrosoma, a hydroid colony [adj]\n",
  "HYDROSOMATA": "HYDROSOMA, all the zooids of a hydroid colony collectively, also HYDROSOME [n]\n",
  "HYDROSOMATOUS": "of or like hydrosomata [adj]\n",
  "HYDROSOME": "all the zooids of a hydroid colony collectively, also HYDROSOMA [n -S]\n",
  "HYDROSOMES": "HYDROSOME, all the zooids of a hydroid colony collectively, also HYDROSOMA [n]\n",
  "HYDROSPACE": "the regions beneath the oceans' surface [n -S]\n",
  "HYDROSPACES": "HYDROSPACE, the regions beneath the oceans' surface [n]\n",
  "HYDROSPHERE": "the water of the earth [n -S]\n",
  "HYDROSPHERES": "HYDROSPHERE, the water of the earth [n]\n",
  "HYDROSPHERIC": "relating to the hydrosphere [adj]\n",
  "HYDROSTAT": "a contrivance or apparatus to prevent the explosion of steam boilers [n -S]\n",
  "HYDROSTATIC": "of or relating to fluids at rest or to the pressures they exert or transmit, also HYDROSTATICAL [adj HYDROSTATICALLY]\n",
  "HYDROSTATICAL": "of or relating to fluids at rest or to the pressures they exert or transmit, also HYDROSTATIC [adj HYDROSTATICALLY]\n",
  "HYDROSTATICALLY": "HYDROSTATICAL, of or relating to fluids at rest or to the pressures they exert or transmit, also HYDROSTATIC [adv]\n",
  "HYDROSTATICS": "a branch of physics that deals with the characteristics of fluids at rest and esp. with the pressure in a fluid or exerted by a fluid on an immersed body [n]\n",
  "HYDROSTATS": "HYDROSTAT, a contrivance or apparatus to prevent the explosion of steam boilers [n]\n",
  "HYDROSULPHATE": "any quaternary acid salt formed by addition of an organic base to sulphuric acid, such as aniline hydrosulphate [n -S]\n",
  "HYDROSULPHATES": "HYDROSULPHATE, any quaternary acid salt formed by addition of an organic base to sulphuric acid, such as aniline hydrosulphate [n]\n",
  "HYDROSULPHIDE": "a compound formed by action of hydrogen sulphide on a hydroxide [n -S]\n",
  "HYDROSULPHIDES": "HYDROSULPHIDE, a compound formed by action of hydrogen sulphide on a hydroxide [n]\n",
  "HYDROSULPHITE": "a salt of hydrosulphurous acid; esp. the sodium salt, used as a reagent [n -S]\n",
  "HYDROSULPHITES": "HYDROSULPHITE, a salt of hydrosulphurous acid; esp. the sodium salt, used as a reagent [n]\n",
  "HYDROSULPHURIC": "formed by a combination of hydrogen and sulphur [adj]\n",
  "HYDROSULPHUROUS": "as in hydrosulphurous acid [adj]\n",
  "HYDROTACTIC": "relating to hydrotaxis, movement towards or away from water [adj]\n",
  "HYDROTAXES": "HYDROTAXIS, movement towards or away from water [n]\n",
  "HYDROTAXIS": "movement towards or away from water [n HYDROTAXES]\n",
  "HYDROTHECA": "the horny cup of a hydranth [n HYDROTHECAE]\n",
  "HYDROTHECAE": "HYDROTHECA, the horny cup of a hydranth [n]\n",
  "HYDROTHERAPIC": "relating to hydrotherapy, therapy involving the use of water [adj]\n",
  "HYDROTHERAPIES": "HYDROTHERAPY, therapy involving the use of water [n]\n",
  "HYDROTHERAPIST": "a practitioner of hydrotherapy [n -S]\n",
  "HYDROTHERAPISTS": "HYDROTHERAPIST, a practitioner of hydrotherapy [n]\n",
  "HYDROTHERAPY": "therapy involving the use of water [n HYDROTHERAPIES]\n",
  "HYDROTHERMAL": "designating naturally hot underground water that has geological effects [adj HYDROTHERMALLY]\n",
  "HYDROTHERMALLY": "HYDROTHERMAL, designating naturally hot underground water that has geological effects [adv]\n",
  "HYDROTHORACES": "HYDROTHORAX, water liquid in the pleural cavity [n]\n",
  "HYDROTHORACIC": "of or like hydrothorax, water liquid in the pleural cavity [adj]\n",
  "HYDROTHORAX": "water liquid in the pleural cavity [n HYDROTHORACES or HYDROTHORAXES]\n",
  "HYDROTHORAXES": "HYDROTHORAX, water liquid in the pleural cavity [n]\n",
  "HYDROTROPIC": "exhibiting hydrotropism, i.e. growth in the direction of water [adj HYDROTROPICALLY]\n",
  "HYDROTROPICALLY": "HYDROTROPIC, exhibiting hydrotropism, i.e. growth in the direction of water [adv]\n",
  "HYDROTROPISM": "growth in the direction of water [n -S]\n",
  "HYDROTROPISMS": "HYDROTROPISM, growth in the direction of water [n]\n",
  "HYDROUS": "containing water [adj]\n",
  "HYDROVANE": "a hydrofoil [n -S]\n",
  "HYDROVANES": "HYDROVANE, a hydrofoil [n]\n",
  "HYDROXIDE": "any compound containing an -OH group [n -S]\n",
  "HYDROXIDES": "HYDROXIDE, any compound containing an -OH group [n]\n",
  "HYDROXIUM": "a positive ion, H3O+, formed by the attachment of a proton to a water molecule [n -S]\n",
  "HYDROXIUMS": "HYDROXIUM, a positive ion, H3O+, formed by the attachment of a proton to a water molecule [n]\n",
  "HYDROXONIUM": "the obsolete name for the cation H3O+ derived from protonation of water [n -S]\n",
  "HYDROXONIUMS": "HYDROXONIUM, the obsolete name for the cation H3O+ derived from protonation of water [n]\n",
  "HYDROXY": "of a compound, containing one or more hydroxyl groups [adj]\n",
  "HYDROXYACETIC": "as in hydroxyacetic acid, another name for glycolic acid [adj]\n",
  "HYDROXYAPATITE": "a complex phosphate of calcium that occurs as a mineral and is the chief structural element of vertebrate bone [n -S]\n",
  "HYDROXYAPATITES": "HYDROXYAPATITE, a complex phosphate of calcium that occurs as a mineral and is the chief structural element of vertebrate bone [n]\n",
  "HYDROXYBUTYRATE": "as in gamma hydroxybutyrate, a substance that occurs naturally in the brain, used medically as a sedative but also as a recreational drug and alleged aphrodisiac [n]\n",
  "HYDROXYCITRIC": "as in hydroxycitric acid, an extract of the plant garcinia [adj]\n",
  "HYDROXYL": "the group containing oxygen and hydrogen [n -S]\n",
  "HYDROXYLAMINE": "a colorless odorless nitrogenous base that resembles ammonia in its reactions [n -S]\n",
  "HYDROXYLAMINES": "HYDROXYLAMINE, a colorless odorless nitrogenous base that resembles ammonia in its reactions [n]\n",
  "HYDROXYLAPATITE": "a mineral of the apatite group that is rare in the ground but is the principal inorganic constituent of tooth enamel and bone [n]\n",
  "HYDROXYLASE": "any of a group of enzymes that catalyze oxidation reactions [n -S]\n",
  "HYDROXYLASES": "HYDROXYLASE, any of a group of enzymes that catalyze oxidation reactions [n]\n",
  "HYDROXYLATE": "to introduce hydroxyl into [v HYDROXYLATED, HYDROXYLATING, HYDROXYLATES]\n",
  "HYDROXYLATED": "HYDROXYLATE, to introduce hydroxyl into [v]\n",
  "HYDROXYLATES": "HYDROXYLATE, to introduce hydroxyl into [v]\n",
  "HYDROXYLATING": "HYDROXYLATE, to introduce hydroxyl into [v]\n",
  "HYDROXYLATION": "the act of hydroxylating [n -S]\n",
  "HYDROXYLATIONS": "HYDROXYLATION, the act of hydroxylating [n]\n",
  "HYDROXYLIC": "pertaining to a hydroxyl [adj]\n",
  "HYDROXYLS": "HYDROXYL, the group containing oxygen and hydrogen [n]\n",
  "HYDROXYPROLINE": "an amino acid [n -S]\n",
  "HYDROXYPROLINES": "HYDROXYPROLINE, an amino acid [n]\n",
  "HYDROXYUREA": "a drug used to treat some forms of leukemia, melanoma, and malignant tumors [n -S]\n",
  "HYDROXYUREAS": "HYDROXYUREA, a drug used to treat some forms of leukemia, melanoma, and malignant tumors [n]\n",
  "HYDROXYZINE": "a compound used as an antihistamine and tranquilizer [n -S]\n",
  "HYDROXYZINES": "HYDROXYZINE, a compound used as an antihistamine and tranquilizer [n]\n",
  "HYDROZINCITE": "a monoclinic basic carbonate of zinc that is a secondary mineral occurring as light-coloured crusts on zinc deposits [n -S]\n",
  "HYDROZINCITES": "HYDROZINCITE, a monoclinic basic carbonate of zinc that is a secondary mineral occurring as light-coloured crusts on zinc deposits [n]\n",
  "HYDROZOA": "HYDROZOON, any coelenterate of the class Hydrozoa, comprising organisms that are mostly marine and colonial with polyp and medusoid stages in the life cycle, also HYDROZOAN [n]\n",
  "HYDROZOAN": "any coelenterate of the class Hydrozoa, comprising organisms that are mostly marine and colonial with polyp and medusoid stages in the life cycle, also HYDROZOON [n -S]\n",
  "HYDROZOANS": "HYDROZOAN, any coelenterate of the class Hydrozoa, comprising organisms that are mostly marine and colonial with polyp and medusoid stages in the life cycle, also HYDROZOON [n]\n",
  "HYDROZOON": "any coelenterate of the class Hydrozoa, comprising organisms that are mostly marine and colonial with polyp and medusoid stages in the life cycle, also HYDROZOAN [n HYDROZOA]\n",
  "HYDYNE": "a rocket-launching fuel [n -S]\n",
  "HYDYNES": "HYDYNE, a rocket-launching fuel [n]\n",
  "HYE": "(obsolete) to hasten [v HYED, HYEING or HYING, HYES]\n",
  "HYED": "HYE, (obsolete) to hasten [v]\n",
  "HYEING": "HYE, (obsolete) to hasten [v]\n",
  "HYEN": "(Shakespeare) a hyena, also HYAENA, HYENA [n -S]\n",
  "HYENA": "a carrion-feeding carnivore of the family Hyaenidae, also HYAENA, HYEN [n -S]\n",
  "HYENAS": "HYENA, a carrion-feeding carnivore of the family Hyaenidae, also HYAENA, HYEN [n]\n",
  "HYENIC": "of or like a hyaena, also HYAENIC, HYENINE, HYENOID [adj]\n",
  "HYENINE": "of or like a hyena, also HYAENIC, HYENIC, HYENOID [adj]\n",
  "HYENOID": "of or like a hyena, also HYAENIC, HYENIC, HYENINE [adj]\n",
  "HYENS": "HYEN, (Shakespeare) a hyena, also HYAENA, HYENA [n]\n",
  "HYES": "HYE, (obsolete) to hasten [v]\n",
  "HYETAL": "pertaining to rain [adj]\n",
  "HYETOGRAPH": "an instrument for recording rainfall [n -S]\n",
  "HYETOGRAPHIC": "relating to the measurement of rainfall, also HYETOGRAPHICAL [adj]\n",
  "HYETOGRAPHICAL": "relating to the measurement of rainfall, also HYETOGRAPHIC [adj]\n",
  "HYETOGRAPHIES": "HYETOGRAPHY, the study of rainfall distribution [n]\n",
  "HYETOGRAPHS": "HYETOGRAPH, an instrument for recording rainfall [n]\n",
  "HYETOGRAPHY": "the study of rainfall distribution [n HYETOGRAPHIES]\n",
  "HYETOLOGIES": "HYETOLOGY, the science of rainfall [n]\n",
  "HYETOLOGY": "the science of rainfall [n HYETOLOGIES]\n",
  "HYETOMETER": "an instrument for measuring rainfall [n -S]\n",
  "HYETOMETERS": "HYETOMETER, an instrument for measuring rainfall [n]\n",
  "HYETOMETROGRAPH": "an instrument for recording rainfall [n]\n",
  "HYGEIST": "one skilled in hygiene, also HYGIEIST, HYGIENIST [n -S]\n",
  "HYGEISTS": "HYGEIST, one skilled in hygiene, also HYGIEIST, HYGIENIST [n]\n",
  "HYGGE": "(Danish) the practice of creating cosy and congenial environments that promote emotional wellbeing [n -S]\n",
  "HYGGES": "HYGGE, (Danish) the practice of creating cosy and congenial environments that promote emotional wellbeing [n]\n",
  "HYGIEIST": "one skilled in hygiene, also HYGEIST, HYGIENIST [n -S]\n",
  "HYGIEISTS": "HYGIEIST, one skilled in hygiene, also HYGEIST, HYGIENIST [n]\n",
  "HYGIENE": "the science of preserving health [n -S]\n",
  "HYGIENES": "HYGIENE, the science of preserving health [n]\n",
  "HYGIENIC": "relating to hygiene [adj HYGIENICALLY]\n",
  "HYGIENICALLY": "HYGIENIC, relating to hygiene [adv]\n",
  "HYGIENICS": "the principles of hygiene [n]\n",
  "HYGIENIST": "one skilled in hygiene, also HYGEIST, HYGIEIST [n -S]\n",
  "HYGIENISTS": "HYGIENIST, one skilled in hygiene, also HYGEIST, HYGIEIST [n]\n",
  "HYGRISTOR": "an electronic component whose resistance varies with humidity [n -S]\n",
  "HYGRISTORS": "HYGRISTOR, an electronic component whose resistance varies with humidity [n]\n",
  "HYGROCHASIES": "HYGROCHASY, dehiscence on moistening [n]\n",
  "HYGROCHASTIC": "showing hygrochasy, dehiscence on moistening [adj]\n",
  "HYGROCHASY": "dehiscence on moistening [n HYGROCHASIES]\n",
  "HYGRODEIK": "a form of hygrometer having wet and dry bulb thermometers [n -S]\n",
  "HYGRODEIKS": "HYGRODEIK, a form of hygrometer having wet and dry bulb thermometers [n]\n",
  "HYGROGRAPH": "an instrument for recording variations in atmospheric humidity [n -S]\n",
  "HYGROGRAPHIC": "relating to the measurement of the air's humidity, also HYGROGRAPHICAL [adj]\n",
  "HYGROGRAPHICAL": "relating to the measurement of the air's humidity, also HYGROGRAPHIC [adj]\n",
  "HYGROGRAPHS": "HYGROGRAPH, an instrument for recording variations in atmospheric humidity [n]\n",
  "HYGROLOGIES": "HYGROLOGY, the study of humidity [n]\n",
  "HYGROLOGY": "the study of humidity [n HYGROLOGIES]\n",
  "HYGROMA": "a watery swelling over a joint, e.g. water on the knee, also HYDROMA [n HYGROMAS or HYGROMATA]\n",
  "HYGROMAS": "HYGROMA, a watery swelling over a joint, e.g. water on the knee, also HYDROMA [n]\n",
  "HYGROMATA": "HYGROMA, a watery swelling over a joint, e.g. water on the knee, also HYDROMA [n]\n",
  "HYGROMETER": "an instrument for measuring air moisture [n -S]\n",
  "HYGROMETERS": "HYGROMETER, an instrument for measuring air moisture [n]\n",
  "HYGROMETRIC": "relating to measurement by hygrometer, also HYGROMETRICAL [adj HYGROMETRICALLY]\n",
  "HYGROMETRICAL": "relating to hygrometry, also HYGROMETRIC [adj HYGROMETRICALLY]\n",
  "HYGROMETRICALLY": "HYGROMETRICAL, relating to hygrometry, also HYGROMETRIC [adv]\n",
  "HYGROMETRIES": "HYGROMETRY, the science of humidity [n]\n",
  "HYGROMETRY": "the science of humidity [n HYGROMETRIES]\n",
  "HYGROPHIL": "moisture-loving; living where there is much moisture, also HYGROPHILOUS [adj]\n",
  "HYGROPHILE": "a plant loving moist places, also HYDROPHILE [n -S]\n",
  "HYGROPHILES": "HYGROPHILE, a plant loving moist places, also HYDROPHILE [n]\n",
  "HYGROPHILOUS": "living in water or moist places, also HYGROPHIL [adj]\n",
  "HYGROPHOBE": "a plant growing best where moisture is scanty [n -S]\n",
  "HYGROPHOBES": "HYGROPHOBE, a plant growing best where moisture is scanty [n]\n",
  "HYGROPHYTE": "a plant adapted to a plentiful water-supply [n -S]\n",
  "HYGROPHYTES": "HYGROPHYTE, a plant adapted to a plentiful water-supply [n]\n",
  "HYGROPHYTIC": "of or like a hygrophyte, a plant adapted to a plentiful water-supply [adj]\n",
  "HYGROSCOPE": "an instrument for displaying changes in air humidity [n -S]\n",
  "HYGROSCOPES": "HYGROSCOPE, an instrument for displaying changes in air humidity [n]\n",
  "HYGROSCOPIC": "readily absorbing moisture from the air, also HYGROSCOPICAL [adj HYGROSCOPICALLY]\n",
  "HYGROSCOPICAL": "readily absorbing moisture from the air, also HYGROSCOPIC [adj HYGROSCOPICALLY]\n",
  "HYGROSCOPICALLY": "HYGROSCOPICAL, readily absorbing moisture from the air, also HYGROSCOPIC [adv]\n",
  "HYGROSCOPICITY": "the state of being hygroscopic [n]\n",
  "HYGROSTAT": "a machine for regulating the humidity of air [n -S]\n",
  "HYGROSTATS": "HYGROSTAT, a machine for regulating the humidity of air [n]\n",
  "HYING": "HYE, (obsolete) to hasten [v]\n",
  "HYKE": "(Arabic) an Arab head covering, also HAIK, HAICK, HAIQUE [n -S]\n",
  "HYKES": "HYKE, (Arabic) an Arab head covering, also HAIK, HAICK, HAIQUE [n]\n",
  "HYLA": "a kind of tree frog [n -S]\n",
  "HYLAS": "HYLA, a kind of tree frog [n]\n",
  "HYLDING": "(Spenser) a mean cowardly person, also HILDING [n -S]\n",
  "HYLDINGS": "HYLDING, (Spenser) a mean cowardly person, also HILDING [n]\n",
  "HYLE": "(Greek) wood; matter [n -S]\n",
  "HYLEG": "the ruling planet at the hour of one's birth [n -S]\n",
  "HYLEGS": "HYLEG, the ruling planet at the hour of one's birth [n]\n",
  "HYLES": "HYLE, (Greek) wood; matter [n]\n",
  "HYLIC": "material, corporeal [adj]\n",
  "HYLICISM": "materialism, also HYLISM [n -S]\n",
  "HYLICISMS": "HYLICISM, materialism, also HYLISM [n]\n",
  "HYLICIST": "one who holds the doctrine of hylism, materialism, also HYLIST, HYLOIST [n -S]\n",
  "HYLICISTS": "HYLICIST, one who holds the doctrine of hylism, materialism, also HYLIST, HYLOIST [n]\n",
  "HYLISM": "materialism, also HYLICISM [n -S]\n",
  "HYLISMS": "HYLISM, materialism, also HYLICISM [n]\n",
  "HYLIST": "a materialist, also HYLICIST, HYLOIST [n -S]\n",
  "HYLISTS": "HYLIST, a materialist, also HYLICIST, HYLOIST [n]\n",
  "HYLOBATE": "any species of the genus Hylobates; a gibbon, or long-armed ape [n -S]\n",
  "HYLOBATES": "HYLOBATE, any species of the genus Hylobates; a gibbon, or long-armed ape [n]\n",
  "HYLOGENESES": "HYLOGENESIS, the origin of matter [n]\n",
  "HYLOGENESIS": "the origin of matter [n HYLOGENESES]\n",
  "HYLOIST": "one who holds the doctrine of hylism, materialism, also HYLICIST, HYLIST [n -S]\n",
  "HYLOISTS": "HYLOIST, one who holds the doctrine of hylism, materialism, also HYLICIST, HYLIST [n]\n",
  "HYLOMORPHIC": "relating to a materialist conception of universe [adj]\n",
  "HYLOMORPHISM": "the belief that matter is the cause of the universe [n -S]\n",
  "HYLOMORPHISMS": "HYLOMORPHISM, the belief that matter is the cause of the universe [n]\n",
  "HYLOPATHISM": "belief in ability of matter to affect the spiritual world [n -S]\n",
  "HYLOPATHISMS": "HYLOPATHISM, belief in ability of matter to affect the spiritual world [n]\n",
  "HYLOPATHIST": "a believer in the capability of matter to affect spirit [n -S]\n",
  "HYLOPATHISTS": "HYLOPATHIST, a believer in the capability of matter to affect spirit [n]\n",
  "HYLOPHAGOUS": "eating wood [adj]\n",
  "HYLOPHYTE": "a woodland plant [n -S]\n",
  "HYLOPHYTES": "HYLOPHYTE, a woodland plant [n]\n",
  "HYLOTHEISM": "the doctrine that there is no God but matter and the universe [n -S]\n",
  "HYLOTHEISMS": "HYLOTHEISM, the doctrine that there is no God but matter and the universe [n]\n",
  "HYLOTHEIST": "one who identifies God with matter or universe [n -S]\n",
  "HYLOTHEISTS": "HYLOTHEIST, one who identifies God with matter or universe [n]\n",
  "HYLOTOMOUS": "of insects, cutting or boring wood [adj]\n",
  "HYLOZOIC": "relating to hylozoism, the doctrine that all matter is endowed with life, also HYLOZOICAL [adj]\n",
  "HYLOZOICAL": "relating to hylozoism, the doctrine that all matter is endowed with life, also HYLOZOIC [adj]\n",
  "HYLOZOISM": "the doctrine that all matter is endowed with life [n -S]\n",
  "HYLOZOISMS": "HYLOZOISM, the doctrine that all matter is endowed with life [n]\n",
  "HYLOZOIST": "one who maintains the doctrine of hylozoism, that all matter is endowed with life [n -S]\n",
  "HYLOZOISTIC": "relating to the belief that all matter has life [adj HYLOZOISTICALLY]\n",
  "HYLOZOISTICALLY": "HYLOZOISTIC, relating to the belief that all matter has life [adv]\n",
  "HYLOZOISTS": "HYLOZOIST, one who maintains the doctrine of hylozoism, that all matter is endowed with life [n]\n",
  "HYMEN": "(Greek) the membrane across the vagina [n -S]\n",
  "HYMENAEAL": "of or relating to marriage, also HYMENAEAN, HYMENEAL, HYMENEAN [adj]\n",
  "HYMENAEAN": "of or relating to marriage, also HYMENAEAL, HYMENEAL, HYMENEAN [adj] / a wedding song [n -S]\n",
  "HYMENAEANS": "HYMENAEAN, a wedding song [n]\n",
  "HYMENAL": "pertaining to the hymen [adj]\n",
  "HYMENEAL": "of or relating to marriage, also HYMENAEAL, HYMENAEAN, HYMENEAN [adj HYMENEALLY] / (archaic) a marriage-hymn [n -S]\n",
  "HYMENEALLY": "HYMENEAL, of or relating to marriage, also HYMENAEAL, HYMENAEAN, HYMENEAN [adv]\n",
  "HYMENEALS": "HYMENEAL, (archaic) a marriage-hymn [n]\n",
  "HYMENEAN": "of or relating to marriage, also HYMENAEAL, HYMENAEAN, HYMENEAL [adj] / a wedding song [n -S]\n",
  "HYMENEANS": "HYMENEAN, a wedding song [n]\n",
  "HYMENIA": "HYMENIUM, the spore-bearing surface of certain fungi, as that on the gills of a mushroom [n]\n",
  "HYMENIAL": "relating to the hymenium, the spore-bearing surface of certain fungi, as that on the gills of a mushroom [adj]\n",
  "HYMENIUM": "the spore-bearing surface of certain fungi, as that on the gills of a mushroom [n HYMENIA or HYMENIUMS]\n",
  "HYMENIUMS": "HYMENIUM, the spore-bearing surface of certain fungi, as that on the gills of a mushroom [n]\n",
  "HYMENOPHORE": "the fruiting body of some basidiomycetous fungi [n -S]\n",
  "HYMENOPHORES": "HYMENOPHORE, the fruiting body of some basidiomycetous fungi [n]\n",
  "HYMENOPLASTIES": "HYMENOPLASTY, surgical reconstruction of the hymen to give the appearance of virginity, usually for religious or cultural reasons [n]\n",
  "HYMENOPLASTY": "surgical reconstruction of the hymen to give the appearance of virginity, usually for religious or cultural reasons [n HYMENOPLASTIES]\n",
  "HYMENOPTERA": "HYMENOPTERON, an order of insect having four membranous wings, e.g. ants, bees, wasps, also HYMENOPTERAN [n]\n",
  "HYMENOPTERAN": "an order of insect having four membranous wings, e.g. ants, bees, wasps, also HYMENOPTERON [n -S]\n",
  "HYMENOPTERANS": "HYMENOPTERAN, an order of insect having four membranous wings, e.g. ants, bees, wasps, also HYMENOPTERON [n]\n",
  "HYMENOPTERON": "an order of insect having four membranous wings, e.g. ants, bees, wasps, also HYMENOPTERAN [n HYMENOPTERONS or HYMENOPTERA]\n",
  "HYMENOPTERONS": "HYMENOPTERON, an order of insect having four membranous wings, e.g. ants, bees, wasps, also HYMENOPTERAN [n]\n",
  "HYMENOPTEROUS": "having four membranous wings, as do ants, bees and wasps [adj]\n",
  "HYMENS": "HYMEN, (Greek) the membrane across the vagina [n]\n",
  "HYMN": "to sing a song of praise to god [v -ED, -ING, -S]\n",
  "HYMNAL": "a hymn book, also HYMNARY, HYMNBOOK [n -S]\n",
  "HYMNALS": "HYMNAL, a hymn book, also HYMNARY, HYMNBOOK [n]\n",
  "HYMNARIES": "HYMNARY, a hymn book, also HYMNAL, HYMNBOOK [n]\n",
  "HYMNARY": "a hymn book, also HYMNAL, HYMNBOOK [n HYMNARIES]\n",
  "HYMNBOOK": "a hymn book, also HYMNAL, HYMNARY [n -S]\n",
  "HYMNBOOKS": "HYMNBOOK, a hymn book, also HYMNAL, HYMNARY [n]\n",
  "HYMNED": "HYMN, to sing a song of praise to god [v]\n",
  "HYMNIC": "pertaining to hymns [adj]\n",
  "HYMNING": "HYMN, to sing a song of praise to god [v]\n",
  "HYMNIST": "a person who composes hymns, also HYMNODIST [n -S]\n",
  "HYMNISTS": "HYMNIST, a person who composes hymns, also HYMNODIST [n]\n",
  "HYMNLESS": "without hymns [adj]\n",
  "HYMNLIKE": "like a hymn [adj]\n",
  "HYMNODICAL": "relating to a hymnody [adj]\n",
  "HYMNODIES": "HYMNODY, the singing of hymns [n]\n",
  "HYMNODIST": "a person who composes hymns, also HYMNIST [n -S]\n",
  "HYMNODISTS": "HYMNODIST, a person who composes hymns, also HYMNIST [n]\n",
  "HYMNODY": "the singing of hymns [n HYMNODIES]\n",
  "HYMNOGRAPHER": "one who writes hymns [n -S]\n",
  "HYMNOGRAPHERS": "HYMNOGRAPHER, one who writes hymns [n]\n",
  "HYMNOGRAPHIES": "HYMNOGRAPHY, the study of writing hymns [n]\n",
  "HYMNOGRAPHY": "the study of writing hymns [n HYMNOGRAPHIES]\n",
  "HYMNOLOGIC": "relating to hymnology, the study of hymns, also HYMNOLOGICAL [adj]\n",
  "HYMNOLOGICAL": "related to hymnology, the study of hymns, also HYMNOLOGIC [adj]\n",
  "HYMNOLOGIES": "HYMNOLOGY, the study of hymns [n]\n",
  "HYMNOLOGIST": "a student of hymnology [n -S]\n",
  "HYMNOLOGISTS": "HYMNOLOGIST, a student of hymnology [n]\n",
  "HYMNOLOGY": "the study of hymns [n HYMNOLOGIES]\n",
  "HYMNS": "HYMN, to sing a song of praise to god [v]\n",
  "HYNDE": "(Spenser) a hind, a female deer [n -S]\n",
  "HYNDES": "HYNDE, (Spenser) a hind, a female deer [n]\n",
  "HYOID": "a bone at the base of the tongue [n -S]\n",
  "HYOIDAL": "pertaining to the hyoid, a U-shaped bone at the base of the tongue, also HYOIDEAN [adj]\n",
  "HYOIDEAN": "pertaining to the hyoid, a U-shaped bone at the base of the tongue, also HYOIDAL [adj]\n",
  "HYOIDS": "HYOID, a bone at the base of the tongue [n]\n",
  "HYOPLASTRA": "HYOPLASTRON, in a turtle's plastron, a plate between the hypoplastron and the entoplastron [n]\n",
  "HYOPLASTRAL": "of or like a hyoplastron [adj]\n",
  "HYOPLASTRON": "in a turtle's plastron, a plate between the hypoplastron and the entoplastron [n HYOPLASTRA]\n",
  "HYOSCINE": "a sleep-inducing drug obtained from plants of the nightshade family [n -S]\n",
  "HYOSCINES": "HYOSCINE, a sleep-inducing drug obtained from plants of the nightshade family [n]\n",
  "HYOSCYAMINE": "a drug obtained from henbane [n -S]\n",
  "HYOSCYAMINES": "HYOSCYAMINE, a drug obtained from henbane [n]\n",
  "HYOSCYAMUS": "any plant of the solanaceous genus Hyoscyamus, including henbane [n -ES]\n",
  "HYOSCYAMUSES": "HYOSCYAMUS, any plant of the solanaceous genus Hyoscyamus, including henbane [n]\n",
  "HYP": "to offend [v HYPPED, HYPPING, HYPS]\n",
  "HYPABYSSAL": "in petrology, moderately deep-seated, not quite abyssal [adj HYPABYSSALLY]\n",
  "HYPABYSSALLY": "HYPABYSSAL, in petrology, moderately deep-seated, not quite abyssal [adv]\n",
  "HYPAESTHESIA": "a reduced sensibility to touch, also HYPESTHESIA [n -S]\n",
  "HYPAESTHESIAS": "HYPAESTHESIA, a reduced sensibility to touch, also HYPESTHESIA [n]\n",
  "HYPAESTHESIC": "suffering from hypaesthesia, a reduced sensibility to touch [adj]\n",
  "HYPAETHRAL": "roofless; open to the sky (usually intentionally, so as to see the stars), also HUPAITHRIC, HYPETHRAL, UPAITHRIC [adj]\n",
  "HYPAETHRON": "an open court [n -S]\n",
  "HYPAETHRONS": "HYPAETHRON, an open court [n]\n",
  "HYPALGESIA": "diminished susceptibility to pain, also HYPALGIA [n -S]\n",
  "HYPALGESIAS": "HYPALGESIA, diminished susceptibility to pain, also HYPALGIA [n]\n",
  "HYPALGESIC": "relating to hypalgesia, diminished susceptibility to pain [adj]\n",
  "HYPALGIA": "diminished susceptibility to pain, also HYPALGESIA [n -S]\n",
  "HYPALGIAS": "HYPALGIA, diminished susceptibility to pain, also HYPALGESIA [n]\n",
  "HYPALLACTIC": "related to hypallage [adj]\n",
  "HYPALLAGE": "a rhetorical figure in which relations between words are changed [n -S]\n",
  "HYPALLAGES": "HYPALLAGE, a rhetorical figure in which relations between words are changed [n]\n",
  "HYPANTHIA": "HYPANTHIUM, a fruit consisting in large part of a receptacle, enlarged below the calyx, as in the rose hip and the pear [n]\n",
  "HYPANTHIAL": "of or like a hypanthium [adj]\n",
  "HYPANTHIUM": "a fruit consisting in large part of a receptacle, enlarged below the calyx, as in the rose hip and the pear [n HYPANTHIA]\n",
  "HYPATE": "(Greek) in Greek music, the lowest string of the lyre, or its tone [n -S]\n",
  "HYPATES": "HYPATE, (Greek) in Greek music, the lowest string of the lyre, or its tone [n]\n",
  "HYPE": "to stimulate artificially [v HYPED, HYPING, HYPES]\n",
  "HYPED": "HYPE, to stimulate artificially [v]\n",
  "HYPER": "excitable [adj HYPERER, HYPEREST] / an excitable person [n -S]\n",
  "HYPERACID": "excessively acid [adj]\n",
  "HYPERACIDITIES": "HYPERACIDITY, the condition of containing more than the normal amount of acid [n]\n",
  "HYPERACIDITY": "the condition of containing more than the normal amount of acid [n HYPERACIDITIES]\n",
  "HYPERACTION": "abnormally high activity [n -S]\n",
  "HYPERACTIONS": "HYPERACTION, abnormally high activity [n]\n",
  "HYPERACTIVE": "affected with or exhibiting hyperactivity [adj] / one who is hyperactive [n -S]\n",
  "HYPERACTIVES": "HYPERACTIVE, one who is hyperactive [n]\n",
  "HYPERACTIVITIES": "HYPERACTIVITY, the state of being excessively or pathologically active [n]\n",
  "HYPERACTIVITY": "the state of being excessively or pathologically active [n HYPERACTIVITIES]\n",
  "HYPERACUITIES": "HYPERACUITY, the state of being hyperacute [n]\n",
  "HYPERACUITY": "the state of being hyperacute [n HYPERACUITIES]\n",
  "HYPERACUSES": "HYPERACUSIS, an abnormally good sense of hearing [n]\n",
  "HYPERACUSIS": "an abnormally good sense of hearing [n HYPERACUSES]\n",
  "HYPERACUTE": "excessively acute [adj]\n",
  "HYPERACUTENESS": "HYPERACUTE, excessively acute [n]\n",
  "HYPERADRENALISM": "excessive activity of the adrenal gland [n]\n",
  "HYPERAEMIA": "an excess or congestion of blood in an organ or part of the body, also HYPEREMIA [n -S]\n",
  "HYPERAEMIAS": "HYPERAEMIA, an excess or congestion of blood in an organ or part of the body, also HYPEREMIA [n]\n",
  "HYPERAEMIC": "suffering from hyperaemia, also HYPEREMIC [adj]\n",
  "HYPERAESTHESIA": "excessive sensitivity, also HYPERESTHESIA [n -S]\n",
  "HYPERAESTHESIAS": "HYPERAESTHESIA, excessive sensitivity, also HYPERESTHESIA [n]\n",
  "HYPERAESTHESIC": "excessively sensitive, also HYPERAESTHETIC [adj]\n",
  "HYPERAESTHETIC": "excessively sensitive, also HYPERAESTHESIC [adj]\n",
  "HYPERAGGRESSIVE": "excessively aggressive [adj]\n",
  "HYPERALERT": "excessively alert [adj]\n",
  "HYPERALGESIA": "undue sensitiveness to pain [n -S]\n",
  "HYPERALGESIAS": "HYPERALGESIA, undue sensitiveness to pain [n]\n",
  "HYPERALGESIC": "relating to hyperalgesia, undue sensitiveness to pain [adj]\n",
  "HYPERARID": "excessively arid [adj]\n",
  "HYPERAROUSAL": "a state of extreme arousal [n -S]\n",
  "HYPERAROUSALS": "HYPERAROUSAL, a state of extreme arousal [n]\n",
  "HYPERAWARE": "excessively aware [adj]\n",
  "HYPERAWARENESS": "the state of being hyperaware [n]\n",
  "HYPERBARIC": "having specific gravity greater than that of cerebrospinal fluid [adj HYPERBARICALLY]\n",
  "HYPERBARICALLY": "HYPERBARIC, having specific gravity greater than that of cerebrospinal fluid [adv]\n",
  "HYPERBATIC": "of or pertaining to a hyperbaton [adj HYPERBATICALLY]\n",
  "HYPERBATICALLY": "HYPERBATIC, of or pertaining to a hyperbaton [adv]\n",
  "HYPERBATON": "the use, esp. for emphasis, of a word order other than the expected or usual one, as in 'Bird thou never wert' [n -S]\n",
  "HYPERBATONS": "HYPERBATON, the use, esp. for emphasis, of a word order other than the expected or usual one, as in 'Bird thou never wert' [n]\n",
  "HYPERBOLA": "a type of mathematical curve [n HYPERBOLAE or HYPERBOLAS]\n",
  "HYPERBOLAE": "HYPERBOLA, a type of mathematical curve [n]\n",
  "HYPERBOLAEON": "a term in in Greek prosody [n -S]\n",
  "HYPERBOLAEONS": "HYPERBOLAEON, a term in in Greek prosody [n]\n",
  "HYPERBOLAS": "HYPERBOLA, a type of mathematical curve [n]\n",
  "HYPERBOLE": "(Greek) impression by extravagant exaggeration [n -S]\n",
  "HYPERBOLES": "HYPERBOLE, (Greek) impression by extravagant exaggeration [n]\n",
  "HYPERBOLIC": "relating to a kind of mathematical curve, also HYPERBOLICAL [adj HYPERBOLICALLY]\n",
  "HYPERBOLICAL": "relating to a kind of mathematical curve, also HYPERBOLIC [adj HYPERBOLICALLY]\n",
  "HYPERBOLICALLY": "HYPERBOLICAL, relating to a kind of mathematical curve, also HYPERBOLIC [adv]\n",
  "HYPERBOLISE": "to indulge in hyperbole, also HYPERBOLIZE [v HYPERBOLISED, HYPERBOLISING, HYPERBOLISES]\n",
  "HYPERBOLISED": "HYPERBOLISE, to indulge in hyperbole, also HYPERBOLIZE [v]\n",
  "HYPERBOLISES": "HYPERBOLISE, to indulge in hyperbole, also HYPERBOLIZE [v]\n",
  "HYPERBOLISING": "HYPERBOLISE, to indulge in hyperbole, also HYPERBOLIZE [v]\n",
  "HYPERBOLISM": "use of hyperbole [n -S]\n",
  "HYPERBOLISMS": "HYPERBOLISM, use of hyperbole [n]\n",
  "HYPERBOLIST": "one who resorts to hyperbole [n -S]\n",
  "HYPERBOLISTS": "HYPERBOLIST, one who resorts to hyperbole [n]\n",
  "HYPERBOLIZE": "to indulge in hyperbole, also HYPERBOLISE [v HYPERBOLIZED, HYPERBOLIZING, HYPERBOLIZES]\n",
  "HYPERBOLIZED": "HYPERBOLIZE, to indulge in hyperbole, also HYPERBOLISE [v]\n",
  "HYPERBOLIZES": "HYPERBOLIZE, to indulge in hyperbole, also HYPERBOLISE [v]\n",
  "HYPERBOLIZING": "HYPERBOLIZE, to indulge in hyperbole, also HYPERBOLISE [v]\n",
  "HYPERBOLOID": "a solid figure in which some of the plane sections are hyperbolas [n -S]\n",
  "HYPERBOLOIDAL": "of or like a hyperboloid [adj]\n",
  "HYPERBOLOIDS": "HYPERBOLOID, a solid figure in which some of the plane sections are hyperbolas [n]\n",
  "HYPERBOREAN": "relating to the extreme northern regions [adj] / an inhabitant of the extreme norther regions [n -S]\n",
  "HYPERBOREANS": "HYPERBOREAN, an inhabitant of the extreme norther regions [n]\n",
  "HYPERCALCAEMIA": "an excess of calcium in the blood, also HYPERCALCEMIA [n -S]\n",
  "HYPERCALCAEMIAS": "HYPERCALCAEMIA, an excess of calcium in the blood, also HYPERCALCEMIA [n]\n",
  "HYPERCALCAEMIC": "relating to hypercalcaemia, an excess of calcium in the blood [adj]\n",
  "HYPERCALCEMIA": "an excess of calcium in the blood, also HYPERCALCAEMIA [n -S]\n",
  "HYPERCALCEMIAS": "HYPERCALCEMIA, an excess of calcium in the blood, also HYPERCALCAEMIA [n]\n",
  "HYPERCALCEMIC": "relating to hypercalcemia [adj]\n",
  "HYPERCAPNIA": "the presence of excessive amounts of carbon dioxide in the blood, also HYPERCARBIA [n -S]\n",
  "HYPERCAPNIAS": "HYPERCAPNIA, the presence of excessive amounts of carbon dioxide in the blood, also HYPERCARBIA [n]\n",
  "HYPERCAPNIC": "relating to hypercapnia [adj]\n",
  "HYPERCARBIA": "hypercapnia, also HYPERCAPNIA [n -S]\n",
  "HYPERCARBIAS": "HYPERCARBIA, hypercapnia, also HYPERCAPNIA [n]\n",
  "HYPERCATABOLISM": "an abnormally high rate of catabolism [n]\n",
  "HYPERCATALECTIC": "having an additional syllable or half-foot after the last complete dipody [adj]\n",
  "HYPERCATALEXES": "HYPERCATALEXIS, the state of being hypercatalectic [n]\n",
  "HYPERCATALEXIS": "the state of being hypercatalectic [n HYPERCATALEXES]\n",
  "HYPERCAUTIOUS": "excessively cautious [adj]\n",
  "HYPERCHARGE": "to charge excessively, to overload [v HYPERCHARGED, HYPERCHARGING, HYPERCHARGES]\n",
  "HYPERCHARGED": "HYPERCHARGE, to charge excessively, to overload [v]\n",
  "HYPERCHARGES": "HYPERCHARGE, to charge excessively, to overload [v]\n",
  "HYPERCHARGING": "HYPERCHARGE, to charge excessively, to overload [v]\n",
  "HYPERCIVILISED": "excessively civilised, also HYPERCIVILIZED [adj]\n",
  "HYPERCIVILIZED": "excessively civilized, also HYPERCIVILISED [adj]\n",
  "HYPERCOAGULABLE": "excessively coagulable [adj]\n",
  "HYPERCOLOUR": "a dye that causes a fabric to change colour with a change of temperature [n -S]\n",
  "HYPERCOLOURS": "HYPERCOLOUR, a dye that causes a fabric to change colour with a change of temperature [n]\n",
  "HYPERCOMPLEX": "excessively complex [adj]\n",
  "HYPERCONSCIOUS": "excessively conscious [adj]\n",
  "HYPERCORRECT": "refers to a linguistic construction or pronunciation produced by mistaken analogy with standard usage out of a desire to be correct, such as \"open widely\" or \"on behalf of my wife and I\" [adj HYPERCORRECTLY]\n",
  "HYPERCORRECTION": "a grammatical, usage or pronunciation mistake made by 'correcting' something that's right to begin with [n]\n",
  "HYPERCORRECTLY": "HYPERCORRECT, refers to a linguistic construction or pronunciation produced by mistaken analogy with standard usage out of a desire to be correct, such as \"open widely\" or \"on behalf of my wife and I\" [adv]\n",
  "HYPERCRITIC": "one who is hypercritical [n -S]\n",
  "HYPERCRITICAL": "meticulously or excessively critical [adj HYPERCRITICALLY]\n",
  "HYPERCRITICALLY": "HYPERCRITICAL, meticulously or excessively critical [adv]\n",
  "HYPERCRITICISE": "to criticise excessively, also HYPERCRITICIZE [v HYPERCRITICISED, HYPERCRITICISES]\n",
  "HYPERCRITICISED": "HYPERCRITICISE, to criticise excessively, also HYPERCRITICIZE [v]\n",
  "HYPERCRITICISES": "HYPERCRITICISE, to criticise excessively, also HYPERCRITICIZE [v]\n",
  "HYPERCRITICISM": "an instance of being hypercritical [n -S]\n",
  "HYPERCRITICISMS": "HYPERCRITICISM, an instance of being hypercritical [n]\n",
  "HYPERCRITICIZE": "to criticise excessively, also HYPERCRITICISE [v HYPERCRITICIZED, HYPERCRITICIZES]\n",
  "HYPERCRITICIZED": "HYPERCRITICIZE, to criticise excessively, also HYPERCRITICISE [v]\n",
  "HYPERCRITICIZES": "HYPERCRITICIZE, to criticise excessively, also HYPERCRITICISE [v]\n",
  "HYPERCRITICS": "HYPERCRITIC, one who is hypercritical [n]\n",
  "HYPERCUBE": "a figure in a space of four or more dimensions having all its sides equal and all its angles right angles [n -S]\n",
  "HYPERCUBES": "HYPERCUBE, a figure in a space of four or more dimensions having all its sides equal and all its angles right angles [n]\n",
  "HYPERDACTYL": "having more than five fingers or toes [adj]\n",
  "HYPERDACTYLIES": "HYPERDACTYLY, the state of having more than five fingers and toes [n]\n",
  "HYPERDACTYLY": "the state of having more than five fingers and toes [n HYPERDACTYLIES]\n",
  "HYPERDORIAN": "in Greek music, above the Dorian mode [adj]\n",
  "HYPERDULIA": "in Roman Catholicism, the veneration accorded to the Virgin Mary [n -S]\n",
  "HYPERDULIAS": "HYPERDULIA, in Roman Catholicism, the veneration accorded to the Virgin Mary [n]\n",
  "HYPERDULIC": "of or like hyperdulia, the veneration accorded to the Virgin Mary, also HYPERDULICAL [adj]\n",
  "HYPERDULICAL": "of or like hyperdulia, the veneration accorded to the Virgin Mary, also HYPERDULIC [adj]\n",
  "HYPEREFFICIENT": "excessively efficient [adj]\n",
  "HYPEREMESES": "HYPEREMESIS, excessive vomiting [n]\n",
  "HYPEREMESIS": "excessive vomiting [n HYPEREMESES]\n",
  "HYPEREMETIC": "causing hyperemesis, excessive vomiting [adj]\n",
  "HYPEREMIA": "an excess or congestion of blood in an organ or part of the body, also HYPERAEMIA [n -S]\n",
  "HYPEREMIAS": "HYPEREMIA, an excess or congestion of blood in an organ or part of the body, also HYPERAEMIA [n]\n",
  "HYPEREMIC": "relating to hyperemia, an abnormally large blood supply, also HYPERAEMIC [adj]\n",
  "HYPEREMOTIONAL": "excessively emotional [adj]\n",
  "HYPERENDEMIC": "extremely endemic [adj]\n",
  "HYPERENERGETIC": "excessively energetic [adj]\n",
  "HYPERER": "HYPER, excitable [adj]\n",
  "HYPEREST": "HYPER, excitable [adj]\n",
  "HYPERESTHESIA": "excessive sensitivity, also HYPERAESTHESIA [n -S]\n",
  "HYPERESTHESIAS": "HYPERESTHESIA, excessive sensitivity, also HYPERAESTHESIA [n]\n",
  "HYPERESTHETIC": "relating to hyperesthesia [adj]\n",
  "HYPEREUTECTIC": "of a compound, containing more of the minor component than a eutectic compound [adj]\n",
  "HYPEREUTECTOID": "containing the minor component in excess of that contained in the eutectoid [adj]\n",
  "HYPEREXCITABLE": "excessively excitable [adj]\n",
  "HYPEREXCITED": "excessively excited [adj]\n",
  "HYPEREXCITEMENT": "the state of being hyperexcited [n]\n",
  "HYPEREXCRETION": "excessive excretion [n -S]\n",
  "HYPEREXCRETIONS": "HYPEREXCRETION, excessive excretion [n]\n",
  "HYPEREXTEND": "to extend so that the angle between bones of a joint is greater than normal [v -ED, -ING, -S]\n",
  "HYPEREXTENDED": "HYPEREXTEND, to extend so that the angle between bones of a joint is greater than normal [v]\n",
  "HYPEREXTENDING": "HYPEREXTEND, to extend so that the angle between bones of a joint is greater than normal [v]\n",
  "HYPEREXTENDS": "HYPEREXTEND, to extend so that the angle between bones of a joint is greater than normal [v]\n",
  "HYPEREXTENSION": "the extension of a joint beyond its normal range [n -S]\n",
  "HYPEREXTENSIONS": "HYPEREXTENSION, the extension of a joint beyond its normal range [n]\n",
  "HYPERFASTIDIOUS": "excessively fastidious [adj]\n",
  "HYPERFINE": "excessively fine [adj]\n",
  "HYPERFOCAL": "referring to the minimum distance from a lens at which all objects can be focussed clearly [adj]\n",
  "HYPERFUNCTION": "the overactivity of a gland or other bodily organ [n -S]\n",
  "HYPERFUNCTIONAL": "relating to hyperfunction, the overactivity of a gland or other bodily organ [adj]\n",
  "HYPERFUNCTIONS": "HYPERFUNCTION, the overactivity of a gland or other bodily organ [n]\n",
  "HYPERGAMIES": "HYPERGAMY, the marriage of a man to a woman of lower status [n]\n",
  "HYPERGAMOUS": "relating to hypergamy, the marriage of a man to a woman of lower status [adj]\n",
  "HYPERGAMY": "the marriage of a man to a woman of lower status [n HYPERGAMIES]\n",
  "HYPERGEOMETRIC": "of or relating to operations or series that transcend ordinary geometrical operations or series [adj]\n",
  "HYPERGLYCAEMIA": "an excess of sugar in the blood, also HYPERGLYCEMIA [n -S]\n",
  "HYPERGLYCAEMIAS": "HYPERGLYCAEMIA, an excess of sugar in the blood, also HYPERGLYCEMIA [n]\n",
  "HYPERGLYCAEMIC": "suffering from hyperglycaemia, an excess of sugar in the blood [adj]\n",
  "HYPERGLYCEMIA": "an excess of sugar in the blood, also HYPERGLYCAEMIA [n -S]\n",
  "HYPERGLYCEMIAS": "HYPERGLYCEMIA, an excess of sugar in the blood, also HYPERGLYCAEMIA [n]\n",
  "HYPERGLYCEMIC": "relating to hyperglycemia [adj]\n",
  "HYPERGOL": "a rocket fuel [n -S]\n",
  "HYPERGOLIC": "igniting on contact, applied e.g. to rocket fuel which ignites spontaneously on contact with an oxidizing agent [adj HYPERGOLICALLY]\n",
  "HYPERGOLICALLY": "HYPERGOLIC, igniting on contact, applied e.g. to rocket fuel which ignites spontaneously on contact with an oxidizing agent [adv]\n",
  "HYPERGOLS": "HYPERGOL, a rocket fuel [n]\n",
  "HYPERHIDROSES": "HYPERHIDROSIS, excessive sweating, also HYPERIDROSIS [n]\n",
  "HYPERHIDROSIS": "excessive sweating, also HYPERIDROSIS [n HYPERHIDROSES]\n",
  "HYPERICIN": "a compound with antidepressant properties, found in St John's wort [n -S]\n",
  "HYPERICINS": "HYPERICIN, a compound with antidepressant properties, found in St John's wort [n]\n",
  "HYPERICUM": "a herbaceous plant or shrub [n -S]\n",
  "HYPERICUMS": "HYPERICUM, a herbaceous plant or shrub [n]\n",
  "HYPERIDROSES": "HYPERIDROSIS, excessive sweating, also HYPERHIDROSIS [n]\n",
  "HYPERIDROSIS": "excessive sweating, also HYPERHIDROSIS [n HYPERIDROSES]\n",
  "HYPERIMMUNE": "having a very high degree of immunity [adj]\n",
  "HYPERIMMUNISE": "to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNIZE [v HYPERIMMUNISED, HYPERIMMUNISING, HYPERIMMUNISES]\n",
  "HYPERIMMUNISED": "HYPERIMMUNISE, to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNIZE [v]\n",
  "HYPERIMMUNISES": "HYPERIMMUNISE, to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNIZE [v]\n",
  "HYPERIMMUNISING": "HYPERIMMUNISE, to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNIZE [v]\n",
  "HYPERIMMUNIZE": "to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNISE [v HYPERIMMUNIZED, HYPERIMMUNIZING, HYPERIMMUNIZES]\n",
  "HYPERIMMUNIZED": "HYPERIMMUNIZE, to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNISE [v]\n",
  "HYPERIMMUNIZES": "HYPERIMMUNIZE, to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNISE [v]\n",
  "HYPERIMMUNIZING": "HYPERIMMUNIZE, to induce a high level of immunity or of circulating antibodies in, as by a long course of injections of antigen, also HYPERIMMUNISE [v]\n",
  "HYPERINFLATED": "excessively inflated [adj]\n",
  "HYPERINFLATION": "inflation growing at a very high rate in a very short time [n -S]\n",
  "HYPERINFLATIONS": "HYPERINFLATION, inflation growing at a very high rate in a very short time [n]\n",
  "HYPERINOSES": "HYPERINOSIS, excess of fibrin in the blood [n]\n",
  "HYPERINOSIS": "excess of fibrin in the blood [n HYPERINOSES]\n",
  "HYPERINOTIC": "relating to hyperinosis, excess of fibrin in the blood [adj]\n",
  "HYPERINSULINISM": "the presence of excess insulin in the body resulting in hypoglycemia [n]\n",
  "HYPERINTENSE": "excessively intense [adj]\n",
  "HYPERINVOLUTION": "extreme involution [n]\n",
  "HYPERIRRITABLE": "extremely irritable [adj]\n",
  "HYPERKERATOSES": "HYPERKERATOSIS, hypertrophy of the horny layer of the skin [n]\n",
  "HYPERKERATOSIS": "hypertrophy of the horny layer of the skin [n HYPERKERATOSES]\n",
  "HYPERKERATOTIC": "suffering from hyperkeratosis [adj]\n",
  "HYPERKINESES": "HYPERKINESIS, muscle spasm; a hyperactive condition of children, also HYPERKINESIA [n]\n",
  "HYPERKINESIA": "muscle spasm, a hyperactive condition of children, also HYPERKINESIS [n -S]\n",
  "HYPERKINESIAS": "HYPERKINESIA, muscle spasm, a hyperactive condition of children, also HYPERKINESIS [n]\n",
  "HYPERKINESIS": "muscle spasm; a hyperactive condition of children, also HYPERKINESIA [n HYPERKINESES]\n",
  "HYPERKINETIC": "of, relating to, or affected with hyperkinesis or hyperactivity [adj]\n",
  "HYPERLINK": "a form of cross-reference in computer-readable text which allows instant access to related material [n -S] / to connect by hyperlink [v -ED, -ING, -S]\n",
  "HYPERLINKED": "HYPERLINK, to connect by hyperlink [v]\n",
  "HYPERLINKING": "HYPERLINK, to connect by hyperlink [v]\n",
  "HYPERLINKS": "HYPERLINK, to connect by hyperlink [v]\n",
  "HYPERLIPEMIA": "an abnormally high level of fat in the blood, also HYPERLIPIDAEMIA, HYPERLIPIDEMIA [n -S]\n",
  "HYPERLIPEMIAS": "HYPERLIPEMIA, an abnormally high level of fat in the blood, also HYPERLIPIDAEMIA, HYPERLIPIDEMIA [n]\n",
  "HYPERLIPEMIC": "relating to hyperlipemia [adj]\n",
  "HYPERLIPIDAEMIA": "an abnormally high level of fat in the blood, also HYPERLIPEMIA, HYPERLIPIDEMIA [n]\n",
  "HYPERLIPIDEMIA": "an abnormally high level of fat in the blood, also HYPERLIPEMIA, HYPERLIPIDAEMIA [n -S]\n",
  "HYPERLIPIDEMIAS": "HYPERLIPIDEMIA, an abnormally high level of fat in the blood, also HYPERLIPEMIA, HYPERLIPIDAEMIA [n]\n",
  "HYPERLYDIAN": "in Greek music, above the Lydian mode [adj]\n",
  "HYPERMANIA": "an extreme form of mania [n -S]\n",
  "HYPERMANIAS": "HYPERMANIA, an extreme form of mania [n]\n",
  "HYPERMANIC": "suffering from hypermania, an extreme form of mania [adj]\n",
  "HYPERMARKET": "a very large self-service store, also HYPERMART [n -S]\n",
  "HYPERMARKETS": "HYPERMARKET, a very large self-service store, also HYPERMART [n]\n",
  "HYPERMART": "a very large self-service store, also HYPERMARKET [n -S]\n",
  "HYPERMARTS": "HYPERMART, a very large self-service store, also HYPERMARKET [n]\n",
  "HYPERMASCULINE": "excessively masculine [adj]\n",
  "HYPERMEDIA": "a system linking information stored as text, graphics, audio and video [n -S]\n",
  "HYPERMEDIAS": "HYPERMEDIA, a system linking information stored as text, graphics, audio and video [n]\n",
  "HYPERMETABOLIC": "relating to hypermetabolism, the physiological state of increased rate of metabolic activity [adj]\n",
  "HYPERMETABOLISM": "the physiological state of increased rate of metabolic activity [n]\n",
  "HYPERMETER": "a verse which has a redundant syllable or foot; a hypercatalectic verse [n -S]\n",
  "HYPERMETERS": "HYPERMETER, a verse which has a redundant syllable or foot; a hypercatalectic verse [n]\n",
  "HYPERMETRIC": "above average height [adj]\n",
  "HYPERMETRICAL": "of or like hypermeter [adj]\n",
  "HYPERMETROPIA": "longsightedness, aka hyperopia, also HYPERMETROPY [n -S]\n",
  "HYPERMETROPIAS": "HYPERMETROPIA, longsightedness, aka hyperopia, also HYPERMETROPY [n]\n",
  "HYPERMETROPIC": "longsighted, also HYPERMETROPICAL [adj]\n",
  "HYPERMETROPICAL": "longsighted, also HYPERMETROPIC [adj]\n",
  "HYPERMETROPIES": "HYPERMETROPY, an inability to see near objects clearly because the images received by the eye are focused behind the retina, also HYPERMETROPIA [n]\n",
  "HYPERMETROPY": "an inability to see near objects clearly because the images received by the eye are focused behind the retina, also HYPERMETROPIA [n HYPERMETROPIES]\n",
  "HYPERMILING": "the practice of maximizing the fuel economy of a motor vehicle, especially through driving technique and vehicle maintenance [n -S]\n",
  "HYPERMILINGS": "HYPERMILING, the practice of maximizing the fuel economy of a motor vehicle, especially through driving technique and vehicle maintenance [n]\n",
  "HYPERMNESIA": "abnormally vivid or complete memory or recall of the past [n -S]\n",
  "HYPERMNESIAS": "HYPERMNESIA, abnormally vivid or complete memory or recall of the past [n]\n",
  "HYPERMNESIC": "relating to hypermnesia [adj]\n",
  "HYPERMOBILITIES": "HYPERMOBILITY, extreme mobility [n]\n",
  "HYPERMOBILITY": "extreme mobility [n HYPERMOBILITIES]\n",
  "HYPERMODERN": "very modern [adj]\n",
  "HYPERMODERNISM": "a hypermodern approach or theory [n -S]\n",
  "HYPERMODERNISMS": "HYPERMODERNISM, a hypermodern approach or theory [n]\n",
  "HYPERMODERNIST": "a practitioner of a hypermodernist style in art [n -S]\n",
  "HYPERMODERNISTS": "HYPERMODERNIST, a practitioner of a hypermodernist style in art [n]\n",
  "HYPERMUTABILITY": "the state of being hypermutable [n]\n",
  "HYPERMUTABLE": "excessively mutable [adj]\n",
  "HYPERNATRAEMIA": "an abnormally high concentration of sodium chloride (salt) in the blood, esp. in infants [n -S]\n",
  "HYPERNATRAEMIAS": "HYPERNATRAEMIA, an abnormally high concentration of sodium chloride (salt) in the blood, esp. in infants [n]\n",
  "HYPERNOVA": "an exploding star than produces even more energy and light than a supernova [n HYPERNOVAE or HYPERNOVAS]\n",
  "HYPERNOVAE": "HYPERNOVA, an exploding star than produces even more energy and light than a supernova [n]\n",
  "HYPERNOVAS": "HYPERNOVA, an exploding star than produces even more energy and light than a supernova [n]\n",
  "HYPERNYM": "a word representing a class of words or things, e.g. dog [n -S]\n",
  "HYPERNYMIES": "HYPERNYMY, the state of being a hypernym, a word representing a class of words or things [n]\n",
  "HYPERNYMS": "HYPERNYM, a word representing a class of words or things, e.g. dog [n]\n",
  "HYPERNYMY": "the state of being a hypernym, a word representing a class of words or things [n HYPERNYMIES]\n",
  "HYPERON": "a class of atomic particle, any baryon that is not a neutron [n -S]\n",
  "HYPERONS": "HYPERON, a class of atomic particle, any baryon that is not a neutron [n]\n",
  "HYPEROPE": "a farsighted person [n -S]\n",
  "HYPEROPES": "HYPEROPE, a farsighted person [n]\n",
  "HYPEROPIA": "longsightedness, aka hypermetropia [n -S]\n",
  "HYPEROPIAS": "HYPEROPIA, longsightedness, aka hypermetropia [n]\n",
  "HYPEROPIC": "suffering from hyperopia, longsightedness [adj]\n",
  "HYPEROREXIA": "compulsive overeating [n -S]\n",
  "HYPEROREXIAS": "HYPEROREXIA, compulsive overeating [n]\n",
  "HYPEROSMIA": "an abnormally acute sense of smell [n -S]\n",
  "HYPEROSMIAS": "HYPEROSMIA, an abnormally acute sense of smell [n]\n",
  "HYPEROSTOSES": "HYPEROSTOSIS, abnormal growth of bone tissue [n]\n",
  "HYPEROSTOSIS": "abnormal growth of bone tissue [n HYPEROSTOSES or HYPEROSTOSISES]\n",
  "HYPEROSTOSISES": "HYPEROSTOSIS, abnormal growth of bone tissue [n]\n",
  "HYPEROSTOTIC": "relating to hyperostosis, abnormal growth of bone tissue [adj]\n",
  "HYPEROXIDE": "a compound containing a relatively large proportion of oxygen [adj HYPEROXIDES]\n",
  "HYPEROXIDES": "HYPEROXIDE [n]\n",
  "HYPERPARASITE": "a parasite that is parasitic upon another parasite [n -S]\n",
  "HYPERPARASITES": "HYPERPARASITE, a parasite that is parasitic upon another parasite [n]\n",
  "HYPERPARASITIC": "of or like a hyperparasite [adj]\n",
  "HYPERPARASITISM": "the state of being a hyperparasite, a parasite that is parasitic upon another parasite [n]\n",
  "HYPERPHAGIA": "eating too much [n -S]\n",
  "HYPERPHAGIAS": "HYPERPHAGIA, eating too much [n]\n",
  "HYPERPHAGIC": "relating to hyperphagia, eating too much [adj]\n",
  "HYPERPHRYGIAN": "above the Phrygian; applied to a mode of ancient Greek music having as its lower tetrachord the upper tetrachord of the Phrygian [adj]\n",
  "HYPERPHYSICAL": "supernatural [adj HYPERPHYSICALLY]\n",
  "HYPERPHYSICALLY": "HYPERPHYSICAL, supernatural [adv]\n",
  "HYPERPIGMENTED": "excessively pigmented [adj]\n",
  "HYPERPITUITARY": "relating to increased hormone secretion by the pituitary body [adj]\n",
  "HYPERPLANE": "a figure in hyperspace corresponding to a plane in ordinary space [n -S]\n",
  "HYPERPLANES": "HYPERPLANE, a figure in hyperspace corresponding to a plane in ordinary space [n]\n",
  "HYPERPLASIA": "an abnormal or unusual increase in the elements composing a part, such as cells composing a tissue [n -S]\n",
  "HYPERPLASIAS": "HYPERPLASIA, an abnormal or unusual increase in the elements composing a part, such as cells composing a tissue [n]\n",
  "HYPERPLASTIC": "relating to hyperplasia [adj]\n",
  "HYPERPLOID": "in excess of but not exact multiple of diploid [adj] / a hyperploid organism [n -S]\n",
  "HYPERPLOIDIES": "HYPERPLOIDY, the state of being hyperploid, in excess of but not exact multiple of diploid [n]\n",
  "HYPERPLOIDS": "HYPERPLOID, a hyperploid organism [n]\n",
  "HYPERPLOIDY": "the state of being hyperploid, in excess of but not exact multiple of diploid [n HYPERPLOIDIES]\n",
  "HYPERPNEA": "abnormally fast breathing, also HYPERPNOEA [n -S]\n",
  "HYPERPNEAS": "HYPERPNEA, abnormally fast breathing, also HYPERPNOEA [n]\n",
  "HYPERPNEIC": "relating to hyperpnea, abnormally fast breathing [adj]\n",
  "HYPERPNOEA": "abnormally fast breathing, also HYPERPNEA [n -S]\n",
  "HYPERPNOEAS": "HYPERPNOEA, abnormally fast breathing, also HYPERPNEA [n]\n",
  "HYPERPOLARISE": "to increase the difference in electric potential across a cell membrane, also HYPERPOLARIZE [v HYPERPOLARISED, HYPERPOLARISING, HYPERPOLARISES]\n",
  "HYPERPOLARISED": "HYPERPOLARISE, to increase the difference in electric potential across a cell membrane, also HYPERPOLARIZE [v]\n",
  "HYPERPOLARISES": "HYPERPOLARISE, to increase the difference in electric potential across a cell membrane, also HYPERPOLARIZE [v]\n",
  "HYPERPOLARISING": "HYPERPOLARISE, to increase the difference in electric potential across a cell membrane, also HYPERPOLARIZE [v]\n",
  "HYPERPOLARIZE": "to produce an increase in potential difference across a biological membrane, also HYPERPOLARISE [v HYPERPOLARIZED, HYPERPOLARIZING, HYPERPOLARIZES]\n",
  "HYPERPOLARIZED": "HYPERPOLARIZE, to produce an increase in potential difference across a biological membrane, also HYPERPOLARISE [v]\n",
  "HYPERPOLARIZES": "HYPERPOLARIZE, to produce an increase in potential difference across a biological membrane, also HYPERPOLARISE [v]\n",
  "HYPERPOLARIZING": "HYPERPOLARIZE, to produce an increase in potential difference across a biological membrane, also HYPERPOLARISE [v]\n",
  "HYPERPOWER": "a state that is vastly stronger than any potential rival [n -S]\n",
  "HYPERPOWERS": "HYPERPOWER, a state that is vastly stronger than any potential rival [n]\n",
  "HYPERPRODUCER": "an agent causing hyperproduction [n -S]\n",
  "HYPERPRODUCERS": "HYPERPRODUCER, an agent causing hyperproduction [n]\n",
  "HYPERPRODUCTION": "excessive production [n]\n",
  "HYPERPROSEXIA": "abnormal powers of perception, as in Australian aboriginal trackers [n -S]\n",
  "HYPERPROSEXIAS": "HYPERPROSEXIA, abnormal powers of perception, as in Australian aboriginal trackers [n]\n",
  "HYPERPURE": "excessively pure [adj]\n",
  "HYPERPYRETIC": "suffering from hyperpyrexia, an extremely high fever [adj]\n",
  "HYPERPYREXIA": "an extremely high fever, with a temperature of 41 degrees Centigrade or above, also HYPERTHERMY [n -S]\n",
  "HYPERPYREXIAL": "showing hyperpyrexia, an extremely high fever [adj]\n",
  "HYPERPYREXIAS": "HYPERPYREXIA, an extremely high fever, with a temperature of 41 degrees Centigrade or above, also HYPERTHERMY [n]\n",
  "HYPERRATIONAL": "excessively rational [adj]\n",
  "HYPERREACTIVE": "excessively reactive [adj]\n",
  "HYPERREACTIVITY": "the state of being hyperreactive [n]\n",
  "HYPERREACTOR": "one who reacts in the extreme [n -S]\n",
  "HYPERREACTORS": "HYPERREACTOR, one who reacts in the extreme [n]\n",
  "HYPERREAL": "involving particularly graphical representation [adj] / that which constitutes hyperreality [n -S]\n",
  "HYPERREALISM": "realism in art characterized by depiction of real life in an unusual or striking manner [n -S]\n",
  "HYPERREALISMS": "HYPERREALISM, realism in art characterized by depiction of real life in an unusual or striking manner [n]\n",
  "HYPERREALIST": "related to hyperrealism [adj] / a practitioner of hyperrealism [n -S]\n",
  "HYPERREALISTIC": "relating to hyperrealism [adj]\n",
  "HYPERREALISTS": "HYPERREALIST, a practitioner of hyperrealism [n]\n",
  "HYPERREALITIES": "HYPERREALITY, the state of being hyperreal [n]\n",
  "HYPERREALITY": "the state of being hyperreal [n HYPERREALITIES]\n",
  "HYPERREALS": "HYPERREAL, that which constitutes hyperreality [n]\n",
  "HYPERRESPONSIVE": "excessively responsive [adj]\n",
  "HYPERROMANTIC": "one who is excessively romantic [n -S]\n",
  "HYPERROMANTICS": "HYPERROMANTIC, one who is excessively romantic [n]\n",
  "HYPERS": "HYPER, an excitable person [n]\n",
  "HYPERSALINE": "excessively saline [adj]\n",
  "HYPERSALINITIES": "HYPERSALINITY, excessive salinity [n]\n",
  "HYPERSALINITY": "excessive salinity [n HYPERSALINITIES]\n",
  "HYPERSALIVATION": "excessive salivation [n]\n",
  "HYPERSARCOMA": "proud or fungous flesh [n HYPERSARCOMAS or HYPERSARCOMATA]\n",
  "HYPERSARCOMAS": "HYPERSARCOMA, proud or fungous flesh [n]\n",
  "HYPERSARCOMATA": "HYPERSARCOMA, proud or fungous flesh [n]\n",
  "HYPERSARCOSES": "HYPERSARCOSIS, proud or fungous flesh [n]\n",
  "HYPERSARCOSIS": "proud or fungous flesh [n HYPERSARCOSES]\n",
  "HYPERSECRETION": "excessive secretion [n -S]\n",
  "HYPERSECRETIONS": "HYPERSECRETION, excessive secretion [n]\n",
  "HYPERSENSITISE": "to make hypersensitive, also HYPERSENSITIZE [v HYPERSENSITISED, HYPERSENSITISES]\n",
  "HYPERSENSITISED": "HYPERSENSITISE, to make hypersensitive, also HYPERSENSITIZE [v]\n",
  "HYPERSENSITISES": "HYPERSENSITISE, to make hypersensitive, also HYPERSENSITIZE [v]\n",
  "HYPERSENSITIVE": "excessively or abnormally sensitive [adj]\n",
  "HYPERSENSITIZE": "to make hypersensitive, also HYPERSENSITISE [v HYPERSENSITIZED, HYPERSENSITIZES]\n",
  "HYPERSENSITIZED": "HYPERSENSITIZE, to make hypersensitive, also HYPERSENSITISE [v]\n",
  "HYPERSENSITIZES": "HYPERSENSITIZE, to make hypersensitive, also HYPERSENSITISE [v]\n",
  "HYPERSENSUAL": "excessively sensual [adj]\n",
  "HYPERSEXUAL": "excessively sexed [adj]\n",
  "HYPERSEXUALITY": "the state of being hypersexual [n]\n",
  "HYPERSOMNIA": "a pathological tendency to sleep excessively [n -S]\n",
  "HYPERSOMNIAS": "HYPERSOMNIA, a pathological tendency to sleep excessively [n]\n",
  "HYPERSOMNOLENCE": "the state of being excessively sleepy [n]\n",
  "HYPERSONIC": "flying at more than five times the speed of sound [adj HYPERSONICALLY]\n",
  "HYPERSONICALLY": "HYPERSONIC, flying at more than five times the speed of sound [adv]\n",
  "HYPERSONICS": "the study of aircraft behaviour at speeds above Mach 5 [n]\n",
  "HYPERSPACE": "an imagined space having more than three dimensions [n -S]\n",
  "HYPERSPACES": "HYPERSPACE, an imagined space having more than three dimensions [n]\n",
  "HYPERSPATIAL": "relating to hyperspace, an imagined space having more than three dimensions [adj]\n",
  "HYPERSTATIC": "excessively static [adj]\n",
  "HYPERSTHENE": "a rock-forming orthorhombic silicate of magnesium and ferrous iron [n -S]\n",
  "HYPERSTHENES": "HYPERSTHENE, a rock-forming orthorhombic silicate of magnesium and ferrous iron [n]\n",
  "HYPERSTHENIA": "a morbid condition marked by excessive excitement of all the vital phenomena [n -S]\n",
  "HYPERSTHENIAS": "HYPERSTHENIA, a morbid condition marked by excessive excitement of all the vital phenomena [n]\n",
  "HYPERSTHENIC": "of or like hypersthene [adj]\n",
  "HYPERSTHENITE": "a pyroxenite composed almost wholly of hypersthene [n -S]\n",
  "HYPERSTHENITES": "HYPERSTHENITE, a pyroxenite composed almost wholly of hypersthene [n]\n",
  "HYPERSTIMULATE": "to stimulate excessively [v HYPERSTIMULATED, HYPERSTIMULATES]\n",
  "HYPERSTIMULATED": "HYPERSTIMULATE, to stimulate excessively [v]\n",
  "HYPERSTIMULATES": "HYPERSTIMULATE, to stimulate excessively [v]\n",
  "HYPERSTRESS": "excessive stress [n -ES]\n",
  "HYPERSTRESSES": "HYPERSTRESS, excessive stress [n]\n",
  "HYPERSURFACE": "a figure that is the analogue in hyperspace of a surface in three-dimensional space [n -S]\n",
  "HYPERSURFACES": "HYPERSURFACE, a figure that is the analogue in hyperspace of a surface in three-dimensional space [n]\n",
  "HYPERTENSE": "excessively tense [adj]\n",
  "HYPERTENSION": "abnormally or excessively high pressure of arterial blood [n -S]\n",
  "HYPERTENSIONS": "HYPERTENSION, abnormally or excessively high pressure of arterial blood [n]\n",
  "HYPERTENSIVE": "suffering from or causing hypertension [adj] / someone suffering from hypertension [n -S]\n",
  "HYPERTENSIVES": "HYPERTENSIVE, someone suffering from hypertension [n]\n",
  "HYPERTEXT": "computer software and hardware that allows users to create, store, and view text and move between related items easily and in a nonsequential way [n -S]\n",
  "HYPERTEXTS": "HYPERTEXT, computer software and hardware that allows users to create, store, and view text and move between related items easily and in a nonsequential way [n]\n",
  "HYPERTHERMAL": "suffering from hyperthermia [adj]\n",
  "HYPERTHERMIA": "exceptionally high fever esp. when induced artificially for therapeutic purposes [n -S]\n",
  "HYPERTHERMIAS": "HYPERTHERMIA, exceptionally high fever esp. when induced artificially for therapeutic purposes [n]\n",
  "HYPERTHERMIC": "relating to hyperthermia [adj]\n",
  "HYPERTHERMIES": "HYPERTHERMY, an extremely high fever, with a temperature of 41 degrees Centigrade or above, also HYPERPYREXIA [n]\n",
  "HYPERTHERMY": "an extremely high fever, with a temperature of 41 degrees Centigrade or above, also HYPERPYREXIA [n HYPERTHERMIES]\n",
  "HYPERTHYMIA": "excessive emotionalism [n -S]\n",
  "HYPERTHYMIAS": "HYPERTHYMIA, excessive emotionalism [n]\n",
  "HYPERTHYROID": "one affected with hyperthyroidism [n -S]\n",
  "HYPERTHYROIDISM": "excessive functional activity of the thyroid gland [n]\n",
  "HYPERTHYROIDS": "HYPERTHYROID, one affected with hyperthyroidism [n]\n",
  "HYPERTONIA": "excessive (muscle) tone [n -S]\n",
  "HYPERTONIAS": "HYPERTONIA, excessive (muscle) tone [n]\n",
  "HYPERTONIC": "having excessive muscle tone [adj]\n",
  "HYPERTONICITIES": "HYPERTONICITY, the condition of being hypertonic [n]\n",
  "HYPERTONICITY": "the condition of being hypertonic [n HYPERTONICITIES]\n",
  "HYPERTROPHIC": "grown to an abnormal size, also HYPERTROPHICAL [adj]\n",
  "HYPERTROPHICAL": "grown to an abnormal size, also HYPERTROPHIC [adj]\n",
  "HYPERTROPHIED": "grown to an abnormal size [adj]\n",
  "HYPERTROPHIES": "HYPERTROPHY, excessive growth of a part [n]\n",
  "HYPERTROPHOUS": "of an organ, abnormally enlarged [adj]\n",
  "HYPERTROPHY": "excessive growth of a part [n HYPERTROPHIES] / to grow to abnormal size [v HYPERTROPHIED, HYPERTROPHYING, HYPERTROPHIES]\n",
  "HYPERTROPHYING": "HYPERTROPHY, to grow to abnormal size [v]\n",
  "HYPERTYPICAL": "excessively typical [adj]\n",
  "HYPERURBANISM": "use of hypercorrect forms in language [n -S]\n",
  "HYPERURBANISMS": "HYPERURBANISM, use of hypercorrect forms in language [n]\n",
  "HYPERURICAEMIA": "an abnormal elevation of uric acid in the blood, also HYPERURICEMIA [n -S]\n",
  "HYPERURICAEMIAS": "HYPERURICAEMIA, an abnormal elevation of uric acid in the blood, also HYPERURICEMIA [n]\n",
  "HYPERURICEMIA": "excess uric acid in the blood, also HYPERURICAEMIA [n -S]\n",
  "HYPERURICEMIAS": "HYPERURICEMIA, excess uric acid in the blood, also HYPERURICAEMIA [n]\n",
  "HYPERVELOCITIES": "HYPERVELOCITY, a high or relatively high velocity, as thousands of feet or meters per second [n]\n",
  "HYPERVELOCITY": "a high or relatively high velocity, as thousands of feet or meters per second [n HYPERVELOCITIES]\n",
  "HYPERVENTILATE": "to breathe rapidly and deeply [v HYPERVENTILATED, HYPERVENTILATES]\n",
  "HYPERVENTILATED": "HYPERVENTILATE, to breathe rapidly and deeply [v]\n",
  "HYPERVENTILATES": "HYPERVENTILATE, to breathe rapidly and deeply [v]\n",
  "HYPERVIGILANCE": "extreme vigilance [n -S]\n",
  "HYPERVIGILANCES": "HYPERVIGILANCE, extreme vigilance [n]\n",
  "HYPERVIGILANT": "extremely vigilant [adj]\n",
  "HYPERVIRULENT": "extremely virulent [adj]\n",
  "HYPERVISCOSITY": "extreme viscosity [n]\n",
  "HYPES": "HYPE, to stimulate artificially [v]\n",
  "HYPESTER": "a person or organisation that gives a product intense publicity in order to promote it [n -S]\n",
  "HYPESTERS": "HYPESTER, a person or organisation that gives a product intense publicity in order to promote it [n]\n",
  "HYPESTHESIA": "a reduced sensibility to touch, also HYPAESTHESIA [n -S]\n",
  "HYPESTHESIAS": "HYPESTHESIA, a reduced sensibility to touch, also HYPAESTHESIA [n]\n",
  "HYPESTHESIC": "showing hypesthesia, a reduced sensibility to touch [adj]\n",
  "HYPETHRAL": "roofless; open to the sky (usually intentionally, so as to see the stars), also HUPAITHRIC, HYPAETHRAL, UPAITHRIC [adj]\n",
  "HYPHA": "(Greek) a threadlike element of a fungus [n HYPHAE]\n",
  "HYPHAE": "HYPHA, (Greek) a threadlike element of a fungus [n]\n",
  "HYPHAL": "of or like hyphae, threadlike elements forming the mycelium of a fungus [adj]\n",
  "HYPHEMIA": "a blood deficiency [n -S]\n",
  "HYPHEMIAS": "HYPHEMIA, a blood deficiency [n]\n",
  "HYPHEN": "to connect words with a punctuation mark [v -ED, -ING, -S]\n",
  "HYPHENATE": "to insert a hyphen into [v HYPHENATED, HYPHENATING, HYPHENATES]\n",
  "HYPHENATED": "HYPHENATE, to insert a hyphen into [v]\n",
  "HYPHENATES": "HYPHENATE, to insert a hyphen into [v]\n",
  "HYPHENATING": "HYPHENATE, to insert a hyphen into [v]\n",
  "HYPHENATION": "the act of hyphenating [n -S]\n",
  "HYPHENATIONS": "HYPHENATION, the act of hyphenating [n]\n",
  "HYPHENED": "HYPHEN, to connect words with a punctuation mark [v]\n",
  "HYPHENIC": "pertaining to a hyphen [adj]\n",
  "HYPHENING": "HYPHEN, to connect words with a punctuation mark [v]\n",
  "HYPHENISATION": "the process of hyphenising, also HYPHENIZATION [n -S]\n",
  "HYPHENISATIONS": "HYPHENISATION, the process of hyphenising, also HYPHENIZATION [n]\n",
  "HYPHENISE": "to put a hyphen in, also HYPHENIZE [v HYPHENISED, HYPHENISING, HYPHENISES]\n",
  "HYPHENISED": "HYPHENISE, to put a hyphen in, also HYPHENIZE [v]\n",
  "HYPHENISES": "HYPHENISE, to put a hyphen in, also HYPHENIZE [v]\n",
  "HYPHENISING": "HYPHENISE, to put a hyphen in, also HYPHENIZE [v]\n",
  "HYPHENISM": "the practice of inserting hyphens [n -S]\n",
  "HYPHENISMS": "HYPHENISM, the practice of inserting hyphens [n]\n",
  "HYPHENIZATION": "the process of hyphenizing, also HYPHENISATION [n -S]\n",
  "HYPHENIZATIONS": "HYPHENIZATION, the process of hyphenizing, also HYPHENISATION [n]\n",
  "HYPHENIZE": "to put a hyphen in, also HYPHENISE [v HYPHENIZED, HYPHENIZING, HYPHENIZES]\n",
  "HYPHENIZED": "HYPHENIZE, to put a hyphen in, also HYPHENISE [v]\n",
  "HYPHENIZES": "HYPHENIZE, to put a hyphen in, also HYPHENISE [v]\n",
  "HYPHENIZING": "HYPHENIZE, to put a hyphen in, also HYPHENISE [v]\n",
  "HYPHENLESS": "without a hyphen [adj]\n",
  "HYPHENS": "HYPHEN, to connect words with a punctuation mark [v]\n",
  "HYPHIES": "HYPHY, a style of hip-hop music originating in the Bay Area of San Francisco [n]\n",
  "HYPHY": "a style of hip-hop music originating in the Bay Area of San Francisco [n HYPHIES]\n",
  "HYPING": "the act of hyping [n -S]\n",
  "HYPINGS": "HYPING, the act of hyping [n]\n",
  "HYPINOSES": "HYPINOSIS, a diminution in the normal amount of fibrin present in the blood [n]\n",
  "HYPINOSIS": "a diminution in the normal amount of fibrin present in the blood [n HYPINOSES]\n",
  "HYPNAGOGIC": "of, relating to, or occurring in the period of drowsiness immediately preceding sleep, also HYPNOGOGIC [adj]\n",
  "HYPNIC": "a soporific [n -S]\n",
  "HYPNICS": "HYPNIC, a soporific [n]\n",
  "HYPNOANALYSES": "HYPNOANALYSIS, psychoanalysis conducted on a hypnotized person [n]\n",
  "HYPNOANALYSIS": "psychoanalysis conducted on a hypnotized person [n HYPNOANALYSES]\n",
  "HYPNOANALYTIC": "related to hypnoanalysis, psychoanalysis conducted on a hypnotized person [adj]\n",
  "HYPNOBIRTHING": "the use of hypnotic technique during labour by an expectant mother to reduce the pain and emotional stress of delivery [n -S]\n",
  "HYPNOBIRTHINGS": "HYPNOBIRTHING, the use of hypnotic technique during labour by an expectant mother to reduce the pain and emotional stress of delivery [n]\n",
  "HYPNOGENESES": "HYPNOGENESIS, production of the hypnotic state, also HYPNOGENY [n]\n",
  "HYPNOGENESIS": "production of the hypnotic state, also HYPNOGENY [n HYPNOGENESES]\n",
  "HYPNOGENETIC": "relating to the production of hypnotic sleep, also HYPNOGENIC, HYPNOGENOUS [adj]\n",
  "HYPNOGENIC": "relating to the production of hypnotic sleep, also HYPNOGENETIC, HYPNOGENOUS [adj]\n",
  "HYPNOGENIES": "HYPNOGENY, production of the hypnotic state, also HYPNOGENESIS [n]\n",
  "HYPNOGENOUS": "relating to the production of hypnotic sleep, also HYPNOGENETIC, HYPNOGENIC [adj]\n",
  "HYPNOGENY": "production of the hypnotic state, also HYPNOGENESIS [n HYPNOGENIES]\n",
  "HYPNOGOGIC": "of, relating to, or occurring in the period of drowsiness immediately preceding sleep, also HYPNAGOGIC [adj]\n",
  "HYPNOID": "like sleep or hypnosis, also HYPNOIDAL [adj]\n",
  "HYPNOIDAL": "like sleep or hypnosis, also HYPNOID [adj]\n",
  "HYPNOIDISE": "to put in the hypnoidal state, also HYPNOIDIZE [v HYPNOIDISED, HYPNOIDISING, HYPNOIDISES]\n",
  "HYPNOIDISED": "HYPNOIDISE, to put in the hypnoidal state, also HYPNOIDIZE [v]\n",
  "HYPNOIDISES": "HYPNOIDISE, to put in the hypnoidal state, also HYPNOIDIZE [v]\n",
  "HYPNOIDISING": "HYPNOIDISE, to put in the hypnoidal state, also HYPNOIDIZE [v]\n",
  "HYPNOIDIZE": "to put in the hypnoidal state, also HYPNOIDISE [v HYPNOIDIZED, HYPNOIDIZING, HYPNOIDIZES]\n",
  "HYPNOIDIZED": "HYPNOIDIZE, to put in the hypnoidal state, also HYPNOIDISE [v]\n",
  "HYPNOIDIZES": "HYPNOIDIZE, to put in the hypnoidal state, also HYPNOIDISE [v]\n",
  "HYPNOIDIZING": "HYPNOIDIZE, to put in the hypnoidal state, also HYPNOIDISE [v]\n",
  "HYPNOLOGIC": "relating to hypnology, the study of sleep or hypnosis, also HYPNOLOGICAL [adj]\n",
  "HYPNOLOGICAL": "relating to hypnology, the study of sleep or hypnosis, also HYPNOLOGIC [adj]\n",
  "HYPNOLOGIES": "HYPNOLOGY, the study of sleep or hypnosis [n]\n",
  "HYPNOLOGIST": "one who studies sleep [n -S]\n",
  "HYPNOLOGISTS": "HYPNOLOGIST, one who studies sleep [n]\n",
  "HYPNOLOGY": "the study of sleep or hypnosis [n HYPNOLOGIES]\n",
  "HYPNONE": "an aromatic ketone used as a hypnotic [n -S]\n",
  "HYPNONES": "HYPNONE, an aromatic ketone used as a hypnotic [n]\n",
  "HYPNOPAEDIA": "training or instruction during sleep [n -S]\n",
  "HYPNOPAEDIAS": "HYPNOPAEDIA, training or instruction during sleep [n]\n",
  "HYPNOPHOBIA": "an irrational fear of sleep [n -S]\n",
  "HYPNOPHOBIAS": "HYPNOPHOBIA, an irrational fear of sleep [n]\n",
  "HYPNOPOMPIC": "pertaining to the semiconscious state before waking [adj]\n",
  "HYPNOSES": "HYPNOSIS, an artificially induced state resembling sleep [n]\n",
  "HYPNOSIS": "an artificially induced state resembling sleep [n HYPNOSES]\n",
  "HYPNOTEE": "a hypnotized person [n -S]\n",
  "HYPNOTEES": "HYPNOTEE, a hypnotized person [n]\n",
  "HYPNOTHERAPIES": "HYPNOTHERAPY, therapy involving the use of hypnotism [n]\n",
  "HYPNOTHERAPIST": "one who practises hypnotherapy [n -S]\n",
  "HYPNOTHERAPISTS": "HYPNOTHERAPIST, one who practises hypnotherapy [n]\n",
  "HYPNOTHERAPY": "therapy involving the use of hypnotism [n HYPNOTHERAPIES]\n",
  "HYPNOTIC": "relating to hypnosis [adj HYPNOTICALLY] / a soporific; a person in a state of hypnosis [n -S]\n",
  "HYPNOTICALLY": "HYPNOTIC, relating to hypnosis [adv]\n",
  "HYPNOTICS": "HYPNOTIC, a soporific; a person in a state of hypnosis [n]\n",
  "HYPNOTISABILITY": "the quality of being hypnotisable, also HYPNOTIZABILITY [n]\n",
  "HYPNOTISABLE": "capable of being hypnotised, also HYPNOTIZABLE [adj]\n",
  "HYPNOTISATION": "the process of hypnotising, also HYPNOTIZATION [n -S]\n",
  "HYPNOTISATIONS": "HYPNOTISATION, the process of hypnotising, also HYPNOTIZATION [n]\n",
  "HYPNOTISE": "to put in a state of hypnosis, also HYPNOTIZE [v HYPNOTISED, HYPNOTISING, HYPNOTISES]\n",
  "HYPNOTISED": "HYPNOTISE, to put in a state of hypnosis, also HYPNOTIZE [v]\n",
  "HYPNOTISER": "one who hypnotises, also HYPNOTIZER [n -S]\n",
  "HYPNOTISERS": "HYPNOTISER, one who hypnotises, also HYPNOTIZER [n]\n",
  "HYPNOTISES": "HYPNOTISE, to put in a state of hypnosis, also HYPNOTIZE [v]\n",
  "HYPNOTISING": "HYPNOTISE, to put in a state of hypnosis, also HYPNOTIZE [v]\n",
  "HYPNOTISM": "the science or practice of hypnosis [n -S]\n",
  "HYPNOTISMS": "HYPNOTISM, the science or practice of hypnosis [n]\n",
  "HYPNOTIST": "one who practises hypnotism [n -S]\n",
  "HYPNOTISTIC": "relating to a hypnotist [adj]\n",
  "HYPNOTISTS": "HYPNOTIST, one who practises hypnotism [n]\n",
  "HYPNOTIZABILITY": "the state of being hypnotizable, also HYPNOTISABILITY [n]\n",
  "HYPNOTIZABLE": "capable of being hypnotized, also HYPNOTISABLE [adj]\n",
  "HYPNOTIZATION": "the process of hypnotizing, also HYPNOTISATION [n -S]\n",
  "HYPNOTIZATIONS": "HYPNOTIZATION, the process of hypnotizing, also HYPNOTISATION [n]\n",
  "HYPNOTIZE": "to put in a state of hypnosis, also HYPNOTISE [v HYPNOTIZED, HYPNOTIZING, HYPNOTIZES]\n",
  "HYPNOTIZED": "HYPNOTIZE, to put in a state of hypnosis, also HYPNOTISE [v]\n",
  "HYPNOTIZER": "one who hypnotizes, also HYPNOTISER [n -S]\n",
  "HYPNOTIZERS": "HYPNOTIZER, one who hypnotizes, also HYPNOTISER [n]\n",
  "HYPNOTIZES": "HYPNOTIZE, to put in a state of hypnosis, also HYPNOTISE [v]\n",
  "HYPNOTIZING": "HYPNOTIZE, to put in a state of hypnosis, also HYPNOTISE [v]\n",
  "HYPNOTOID": "like hypnosis [adj]\n",
  "HYPNUM": "(Greek) a type of moss [n HYPNUMS]\n",
  "HYPNUMS": "HYPNUM, (Greek) a type of moss [n]\n",
  "HYPO": "(colloquial) to inject with a hypodermic needle [v -ED, -ING, -S]\n",
  "HYPOACID": "having a lower than normal degree of acidity [adj]\n",
  "HYPOACIDITIES": "HYPOACIDITY, abnormally low acidity, as of the contents of the stomach [n]\n",
  "HYPOACIDITY": "abnormally low acidity, as of the contents of the stomach [n HYPOACIDITIES]\n",
  "HYPOAEOLIAN": "in Greek music, below the Aeolian mode [adj]\n",
  "HYPOALLERGENIC": "having little likelihood of causing an allergic response [adj]\n",
  "HYPOBARIC": "below normal pressure [adj]\n",
  "HYPOBLAST": "the inner or lower layer of the blastoderm [n -S]\n",
  "HYPOBLASTIC": "relating to the hypoblast, the inner or lower layer of the blastoderm [adj]\n",
  "HYPOBLASTS": "HYPOBLAST, the inner or lower layer of the blastoderm [n]\n",
  "HYPOBOLE": "the anticipation and refutal of objections to an argument [n -S]\n",
  "HYPOBOLES": "HYPOBOLE, the anticipation and refutal of objections to an argument [n]\n",
  "HYPOCALCAEMIA": "a deficiency of calcium in the blood, also HYPOCALCEMIA [n -S]\n",
  "HYPOCALCAEMIAS": "HYPOCALCAEMIA, a deficiency of calcium in the blood, also HYPOCALCEMIA [n]\n",
  "HYPOCALCAEMIC": "relating to hypocalcaemia, a deficiency of calcium in the blood, also HYPOCALCEMIC [adj]\n",
  "HYPOCALCEMIA": "a deficiency of calcium in the blood, also HYPOCALCAEMIA [n -S]\n",
  "HYPOCALCEMIAS": "HYPOCALCEMIA, a deficiency of calcium in the blood, also HYPOCALCAEMIA [n]\n",
  "HYPOCALCEMIC": "relating to hypocalcemia, also HYPOCALCAEMIC [adj]\n",
  "HYPOCAUST": "an ancient air chamber or series of chambers for heating rooms [n -S]\n",
  "HYPOCAUSTS": "HYPOCAUST, an ancient air chamber or series of chambers for heating rooms [n]\n",
  "HYPOCENTER": "the point under the earth's surface where the energy of an earthquake is first released [n -S]\n",
  "HYPOCENTERS": "HYPOCENTER, the point under the earth's surface where the energy of an earthquake is first released [n]\n",
  "HYPOCENTRAL": "relating to a hypocenter [adj]\n",
  "HYPOCENTRE": "the point on the earth directly below the centre of a nuclear explosion [n -S]\n",
  "HYPOCENTRES": "HYPOCENTRE, the point on the earth directly below the centre of a nuclear explosion [n]\n",
  "HYPOCHLORITE": "a salt of hypochlorous acid [n -S]\n",
  "HYPOCHLORITES": "HYPOCHLORITE, a salt of hypochlorous acid [n]\n",
  "HYPOCHLOROUS": "of or derived from hypochlorous acid [adj]\n",
  "HYPOCHONDRIA": "suffering from imaginary illness [n -S]\n",
  "HYPOCHONDRIAC": "one who suffers from hypochondria [n -S]\n",
  "HYPOCHONDRIACAL": "affected or produced by hypochondria [adj]\n",
  "HYPOCHONDRIACS": "HYPOCHONDRIAC, one who suffers from hypochondria [n]\n",
  "HYPOCHONDRIAS": "HYPOCHONDRIA, suffering from imaginary illness [n]\n",
  "HYPOCHONDRIASES": "HYPOCHONDRIASIS, morbid concern about one's health esp. when accompanied by delusions of physical disease [n]\n",
  "HYPOCHONDRIASIS": "morbid concern about one's health esp. when accompanied by delusions of physical disease [n HYPOCHONDRIASES]\n",
  "HYPOCHONDRIASM": "hypochondria [n -S]\n",
  "HYPOCHONDRIASMS": "HYPOCHONDRIASM, hypochondria [n]\n",
  "HYPOCHONDRIAST": "a hypochondriac [n -S]\n",
  "HYPOCHONDRIASTS": "HYPOCHONDRIAST, a hypochondriac [n]\n",
  "HYPOCHONDRIUM": "either of two regions of the upper part of the abdomen [n HYPOCHONDRIA]\n",
  "HYPOCIST": "a plant parasitic on cistus roots [n -S]\n",
  "HYPOCISTS": "HYPOCIST, a plant parasitic on cistus roots [n]\n",
  "HYPOCORISM": "the use of a pet name or nickname, also HYPOCORISMA [n -S]\n",
  "HYPOCORISMA": "the use of a pet name or nickname, also HYPOCORISM [n -S]\n",
  "HYPOCORISMAS": "HYPOCORISMA, the use of a pet name or nickname, also HYPOCORISM [n]\n",
  "HYPOCORISMS": "HYPOCORISM, the use of a pet name or nickname, also HYPOCORISMA [n]\n",
  "HYPOCORISTIC": "of or like hypocorism, also HYPOCORISTICAL [adj]\n",
  "HYPOCORISTICAL": "of or like hypocorism, also HYPOCORISTIC [adj]\n",
  "HYPOCOTYL": "the stem of a plant below the cotyledons [n -S]\n",
  "HYPOCOTYLOUS": "of or like a hypocotyl, the stem of a plant below the cotyledons [adj]\n",
  "HYPOCOTYLS": "HYPOCOTYL, the stem of a plant below the cotyledons [n]\n",
  "HYPOCRISIES": "HYPOCRISY, a feigning to be better than one is, or to be what one is not [n]\n",
  "HYPOCRISY": "a feigning to be better than one is, or to be what one is not [n HYPOCRISIES]\n",
  "HYPOCRITE": "one who pretends to be better or other than they are [n -S]\n",
  "HYPOCRITES": "HYPOCRITE, one who pretends to be better or other than they are [n]\n",
  "HYPOCRITIC": "characterized by hypocrisy, also HYPOCRITICAL [adj HYPOCRITICALLY]\n",
  "HYPOCRITICAL": "characterized by hypocrisy, also HYPOCRITIC [adj HYPOCRITICALLY]\n",
  "HYPOCRITICALLY": "HYPOCRITICAL, characterized by hypocrisy, also HYPOCRITIC [adv]\n",
  "HYPOCRYSTALLINE": "of igneous rocks, having both glass and crystalline components [adj]\n",
  "HYPOCYCLOID": "a curve generated by a point on the circumference of a circle which rolls on the inside of another circle [n -S]\n",
  "HYPOCYCLOIDAL": "of or like a hypocycloid [adj]\n",
  "HYPOCYCLOIDS": "HYPOCYCLOID, a curve generated by a point on the circumference of a circle which rolls on the inside of another circle [n]\n",
  "HYPODERM": "the tissue next under the epidermis, also HYPODERMIS [n -S]\n",
  "HYPODERMA": "a layer of tissue beneath the epidermis in plants, and performing the physiological function of strengthening the epidermal tissue [n -S]\n",
  "HYPODERMAL": "relating to the hypodermis, the layer of skin just below the epidermis [adj]\n",
  "HYPODERMAS": "HYPODERMA, a layer of tissue beneath the epidermis in plants, and performing the physiological function of strengthening the epidermal tissue [n]\n",
  "HYPODERMIC": "of or pertaining to the parts under the skin [adj HYPODERMICALLY] / a drug so injected [n -S]\n",
  "HYPODERMICALLY": "HYPODERMIC, of or pertaining to the parts under the skin [adv]\n",
  "HYPODERMICS": "HYPODERMIC, a drug so injected [n]\n",
  "HYPODERMIS": "the layer of skin just below the epidermis, also HYPODERM [n -ES]\n",
  "HYPODERMISES": "HYPODERMIS, the layer of skin just below the epidermis, also HYPODERM [n]\n",
  "HYPODERMS": "HYPODERM, the tissue next under the epidermis, also HYPODERMIS [n]\n",
  "HYPODIPLOID": "having slightly fewer than the diploid number of chromosomes [adj]\n",
  "HYPODIPLOIDIES": "HYPODIPLOIDY, the state of being hypodiploid, having slightly fewer than the diploid number of chromosomes [n]\n",
  "HYPODIPLOIDY": "the state of being hypodiploid, having slightly fewer than the diploid number of chromosomes [n HYPODIPLOIDIES]\n",
  "HYPODORIAN": "relating to a mode in ancient Greek music [adj]\n",
  "HYPOED": "HYPO, (colloquial) to inject with a hypodermic needle [v]\n",
  "HYPOEUTECTIC": "of a compound, containing less of the minor component than a eutectic compound [adj]\n",
  "HYPOEUTECTOID": "of a compound, containing less of the minor component than a eutectic compound [adj]\n",
  "HYPOGAEA": "HYPOGAEUM, (Greek) an underground chamber, also HYPOGEUM [n]\n",
  "HYPOGAEAL": "germinating with cotyledons underground, also HYPOGAEAN, HYPOGAEOUS, HYPOGEAL, HYPOGEAN, HYPOGEOUS [adj]\n",
  "HYPOGAEAN": "germinating with cotyledons underground, also HYPOGAEAL, HYPOGAEOUS, HYPOGEAL, HYPOGEAN, HYPOGEOUS [adj]\n",
  "HYPOGAEOUS": "germinating with cotyledons underground, also HYPOGAEAL, HYPOGAEAN, HYPOGEAL, HYPOGEAN, HYPOGEOUS [adj]\n",
  "HYPOGAEUM": "(Greek) an underground chamber, also HYPOGEUM [n HYPOGAEA]\n",
  "HYPOGASTRIA": "HYPOGASTRIUM, (Latin) the lower middle abdominal region [n]\n",
  "HYPOGASTRIC": "pertaining to lower middle abdominal region [adj]\n",
  "HYPOGASTRIUM": "(Latin) the lower middle abdominal region [n HYPOGASTRIA]\n",
  "HYPOGEA": "HYPOGEUM, (Greek) an underground chamber, also HYPOGAEUM [n]\n",
  "HYPOGEAL": "germinating with cotyledons underground, also HYPOGAEAL, HYPOGAEAN, HYPOGAEOUS, HYPOGEAN, HYPOGEOUS [adj]\n",
  "HYPOGEAN": "germinating with cotyledons underground, also HYPOGAEAL, HYPOGAEAN, HYPOGAEOUS, HYPOGEAL, HYPOGEOUS [adj]\n",
  "HYPOGENE": "formed or occurring beneath the surface of the earth, as opposed to epigene, also HYPOGENIC [adj]\n",
  "HYPOGENIC": "formed or occurring beneath the surface of the earth, also HYPOGENE [adj]\n",
  "HYPOGENOUS": "produced or growing on the undersurface, esp. (of fern spores) growing on the undersurface of the leaves [adj]\n",
  "HYPOGEOUS": "germinating with cotyledons underground, also HYPOGAEAL, HYPOGAEAN, HYPOGAEOUS, HYPOGEAL, HYPOGEAN [adj]\n",
  "HYPOGEUM": "(Greek) an underground chamber, also HYPOGAEUM [n HYPOGEA]\n",
  "HYPOGLOSSAL": "of or relating to the hypoglossal nerves [adj] / the hypoglossal nerve [n -S]\n",
  "HYPOGLOSSALS": "HYPOGLOSSAL, the hypoglossal nerve [n]\n",
  "HYPOGLYCAEMIA": "abnormal decrease of sugar in the blood, also HYPOGLYCEMIA [n -S]\n",
  "HYPOGLYCAEMIAS": "HYPOGLYCAEMIA, abnormal decrease of sugar in the blood, also HYPOGLYCEMIA [n]\n",
  "HYPOGLYCAEMIC": "pertaining to or characterized by hypoglycaemia; (of a drug etc.) promoting the reduction of blood-sugar levels, also HYPOGLYCEMIC [adj]\n",
  "HYPOGLYCEMIA": "abnormal decrease of sugar in the blood, also HYPOGLYCAEMIA [n -S]\n",
  "HYPOGLYCEMIAS": "HYPOGLYCEMIA, abnormal decrease of sugar in the blood, also HYPOGLYCAEMIA [n]\n",
  "HYPOGLYCEMIC": "having low blood-sugar [adj] / someone with low blood sugar, also HYPOGLYCAEMIC [n -S]\n",
  "HYPOGLYCEMICS": "HYPOGLYCEMIC, someone with low blood sugar, also HYPOGLYCAEMIC [n]\n",
  "HYPOGNATHISM": "the state of being hypognathous [n -S]\n",
  "HYPOGNATHISMS": "HYPOGNATHISM, the state of being hypognathous [n]\n",
  "HYPOGNATHOUS": "having the lower jaw or mandible protruding [adj]\n",
  "HYPOGYNIES": "HYPOGYNY, the condition of having flowers with organs below the ovary [n]\n",
  "HYPOGYNOUS": "growing from beneath the ovary; having the other floral parts below the ovary [adj]\n",
  "HYPOGYNY": "the condition of having flowers with organs below the ovary [n HYPOGYNIES]\n",
  "HYPOID": "a type of bevel gear in which driving and driven shafts are at right angles but not in the same plane [n -S]\n",
  "HYPOIDS": "HYPOID, a type of bevel gear in which driving and driven shafts are at right angles but not in the same plane [n]\n",
  "HYPOING": "HYPO, (colloquial) to inject with a hypodermic needle [v]\n",
  "HYPOKALEMIA": "a deficiency of potassium in the blood [n -S]\n",
  "HYPOKALEMIAS": "HYPOKALEMIA, a deficiency of potassium in the blood [n]\n",
  "HYPOKALEMIC": "relating to hypokalemia, a deficiency of potassium in the blood [adj]\n",
  "HYPOLIMNIA": "HYPOLIMNION, a lower and colder layer of water in a lake [n]\n",
  "HYPOLIMNION": "a lower and colder layer of water in a lake [n HYPOLIMNIONS or HYPOLIMNIA]\n",
  "HYPOLIMNIONS": "HYPOLIMNION, a lower and colder layer of water in a lake [n]\n",
  "HYPOLYDIAN": "relating to a mode in ancient Greek music [adj]\n",
  "HYPOMAGNESAEMIA": "a deficiency of magnesium in the blood, also HYPOMAGNESEMIA [n]\n",
  "HYPOMAGNESEMIA": "a deficiency of magnesium in the blood, also HYPOMAGNESAEMIA [n -S]\n",
  "HYPOMAGNESEMIAS": "HYPOMAGNESEMIA, a deficiency of magnesium in the blood, also HYPOMAGNESAEMIA [n]\n",
  "HYPOMANIA": "slightly abnormal overactivity and elation [n -S]\n",
  "HYPOMANIAS": "HYPOMANIA, slightly abnormal overactivity and elation [n]\n",
  "HYPOMANIC": "relating to hypomania, a mild form of mania [adj] / one afflicted with hypomania [n -S]\n",
  "HYPOMANICS": "HYPOMANIC, one afflicted with hypomania [n]\n",
  "HYPOMENORRHEA": "the condition in which the interval between two menstrual periods is increased to between 35 and 42 days, also HYPOMENORRHOEA [n -S]\n",
  "HYPOMENORRHEAS": "HYPOMENORRHEA, the condition in which the interval between two menstrual periods is increased to between 35 and 42 days, also HYPOMENORRHOEA [n]\n",
  "HYPOMENORRHOEA": "the condition in which the interval between two menstrual periods is increased to between 35 and 42 days, also HYPOMENORRHEA [n -S]\n",
  "HYPOMENORRHOEAS": "HYPOMENORRHOEA, the condition in which the interval between two menstrual periods is increased to between 35 and 42 days, also HYPOMENORRHEA [n]\n",
  "HYPOMIXOLYDIAN": "applied in old church music to a mode extending from d to d with g as its final [adj]\n",
  "HYPOMORPH": "a mutant gene but having a similar but weaker effect than the corresponding wild-type gene [n -S]\n",
  "HYPOMORPHIC": "of a mutation, causing a partial loss of gene function [adj]\n",
  "HYPOMORPHS": "HYPOMORPH, a mutant gene but having a similar but weaker effect than the corresponding wild-type gene [n]\n",
  "HYPONASTIC": "relating to hyponasty, a tendency in part of a plant to grow more rapidly on the underside [adj HYPONASTICALLY]\n",
  "HYPONASTICALLY": "HYPONASTIC, relating to hyponasty, a tendency in part of a plant to grow more rapidly on the underside [adv]\n",
  "HYPONASTIES": "HYPONASTY, a tendency in part of a plant to grow more rapidly on the underside, so that it curves upwards [n]\n",
  "HYPONASTY": "a tendency in part of a plant to grow more rapidly on the underside, so that it curves upwards [n HYPONASTIES]\n",
  "HYPONATRAEMIA": "deficiency of sodium in the blood [n -S]\n",
  "HYPONATRAEMIAS": "HYPONATRAEMIA, deficiency of sodium in the blood [n]\n",
  "HYPONEA": "a dulled mental activity, also HYPONOIA [n -S]\n",
  "HYPONEAS": "HYPONEA, a dulled mental activity, also HYPONOIA [n]\n",
  "HYPONITRITE": "a salt or ester of hyponitrous acid [n -S]\n",
  "HYPONITRITES": "HYPONITRITE, a salt or ester of hyponitrous acid [n]\n",
  "HYPONITROUS": "containing or derived from nitrogen having a lower valence than in nitrous compounds [adj]\n",
  "HYPONOIA": "a dulled mental activity, also HYPONEA [n -S]\n",
  "HYPONOIAS": "HYPONOIA, a dulled mental activity, also HYPONEA [n]\n",
  "HYPONYM": "one of several terms subsumed under another [n -S]\n",
  "HYPONYMIES": "HYPONYMY, the formation of hyponyms [n]\n",
  "HYPONYMS": "HYPONYM, one of several terms subsumed under another [n]\n",
  "HYPONYMY": "the formation of hyponyms [n HYPONYMIES]\n",
  "HYPOPHARYNGES": "HYPOPHARYNX, an appendage or thickened fold on the floor of the mouth of many insects that resembles a tongue [n]\n",
  "HYPOPHARYNX": "an appendage or thickened fold on the floor of the mouth of many insects that resembles a tongue [n HYPOPHARYNGES or HYPOPHARYNXES]\n",
  "HYPOPHARYNXES": "HYPOPHARYNX, an appendage or thickened fold on the floor of the mouth of many insects that resembles a tongue [n]\n",
  "HYPOPHOSPHATE": "any salt or ester of hypophosphoric acid [n -S]\n",
  "HYPOPHOSPHATES": "HYPOPHOSPHATE, any salt or ester of hypophosphoric acid [n]\n",
  "HYPOPHOSPHITE": "a salt of hypophosphorous acid [n -S]\n",
  "HYPOPHOSPHITES": "HYPOPHOSPHITE, a salt of hypophosphorous acid [n]\n",
  "HYPOPHOSPHORIC": "as in hypophosphoric acid, a tetrabasic acid produced by the slow oxidation of phosphorus in moist ai [adj]\n",
  "HYPOPHOSPHOROUS": "as in hypophosphorous acid, a monobasic acid and a reducing agent [adj]\n",
  "HYPOPHRYGIAN": "below the Phrygian mode; applied in ancient Greek music to a mode having as its upper tetrachord the lower tetrachord of the Phrygian [adj]\n",
  "HYPOPHYGE": "the curve where a column merges in its base or capital [n -S]\n",
  "HYPOPHYGES": "HYPOPHYGE, the curve where a column merges in its base or capital [n]\n",
  "HYPOPHYSEAL": "relating to the pituitary gland [adj]\n",
  "HYPOPHYSECTOMY": "the removal of the pituitary gland [n]\n",
  "HYPOPHYSES": "HYPOPHYSIS, the pituitary gland [n]\n",
  "HYPOPHYSIAL": "relating to the pituitary gland [adj]\n",
  "HYPOPHYSIS": "the pituitary gland [n HYPOPHYSES]\n",
  "HYPOPITUITARISM": "deficient production of growth hormones by the pituitary gland [n]\n",
  "HYPOPITUITARY": "relating to hypopituitarism [adj]\n",
  "HYPOPLASIA": "the incomplete development of an organ or part, also HYPOPLASTY [n -S]\n",
  "HYPOPLASIAS": "HYPOPLASIA, the incomplete development of an organ or part, also HYPOPLASTY [n]\n",
  "HYPOPLASTIC": "relating to hypoplasia [adj]\n",
  "HYPOPLASTIES": "HYPOPLASTY, incomplete development of a part or organ, also HYPOPLASIA [n]\n",
  "HYPOPLASTRA": "HYPOPLASTRON, the plate behind the hyoplastron in a turtle's plastron [n]\n",
  "HYPOPLASTRON": "the plate behind the hyoplastron in a turtle's plastron [n HYPOPLASTRA]\n",
  "HYPOPLASTY": "incomplete development of a part or organ, also HYPOPLASIA [n HYPOPLASTIES]\n",
  "HYPOPLOID": "a chromosome number a few below the normal diploid number [n -S]\n",
  "HYPOPLOIDIES": "HYPOPLOIDY, the state of being hypoploid, having a chromosome number a few below the normal diploid number [n]\n",
  "HYPOPLOIDS": "HYPOPLOID, a chromosome number a few below the normal diploid number [n]\n",
  "HYPOPLOIDY": "the state of being hypoploid, having a chromosome number a few below the normal diploid number [n HYPOPLOIDIES]\n",
  "HYPOPNEA": "abnormally shallow breathing, also HYPOPNOEA [n -S]\n",
  "HYPOPNEAS": "HYPOPNEA, abnormally shallow breathing, also HYPOPNOEA [n]\n",
  "HYPOPNEIC": "related to hypopnea, abnormally shallow breathing [adj]\n",
  "HYPOPNOEA": "abnormally shallow breathing, also HYPOPNEA [n -S]\n",
  "HYPOPNOEAS": "HYPOPNOEA, abnormally shallow breathing, also HYPOPNEA [n]\n",
  "HYPOPYON": "an accumulation of pus in the eye [n -S]\n",
  "HYPOPYONS": "HYPOPYON, an accumulation of pus in the eye [n]\n",
  "HYPOS": "HYPO, (colloquial) to inject with a hypodermic needle [v]\n",
  "HYPOSENSITISE": "to cause (a person) to become less sensitive to (a substance producing an allergic reaction), also HYPOSENSITIZE [v HYPOSENSITISED, HYPOSENSITISING, HYPOSENSITISES]\n",
  "HYPOSENSITISED": "HYPOSENSITISE, to cause (a person) to become less sensitive to (a substance producing an allergic reaction), also HYPOSENSITIZE [v]\n",
  "HYPOSENSITISES": "HYPOSENSITISE, to cause (a person) to become less sensitive to (a substance producing an allergic reaction), also HYPOSENSITIZE [v]\n",
  "HYPOSENSITISING": "HYPOSENSITISE, to cause (a person) to become less sensitive to (a substance producing an allergic reaction), also HYPOSENSITIZE [v]\n",
  "HYPOSENSITIZE": "to lower the sensitivity of, also HYPOSENSITISE [v HYPOSENSITIZED, HYPOSENSITIZING, HYPOSENSITIZES]\n",
  "HYPOSENSITIZED": "HYPOSENSITIZE, to lower the sensitivity of, also HYPOSENSITISE [v]\n",
  "HYPOSENSITIZES": "HYPOSENSITIZE, to lower the sensitivity of, also HYPOSENSITISE [v]\n",
  "HYPOSENSITIZING": "HYPOSENSITIZE, to lower the sensitivity of, also HYPOSENSITISE [v]\n",
  "HYPOSPADIAS": "a malformation of the penis [n HYPOSPADIASES]\n",
  "HYPOSPADIASES": "HYPOSPADIAS, a malformation of the penis [n]\n",
  "HYPOSTASES": "HYPOSTASIS, an underlying reality, substance, as opposed to attributes ('accidents') or as distinguished from what is unsubstantial [n]\n",
  "HYPOSTASIS": "an underlying reality, substance, as opposed to attributes ('accidents') or as distinguished from what is unsubstantial [n HYPOSTASES]\n",
  "HYPOSTASISATION": "the process of hypostasising, also HYPOSTASIZATION [n]\n",
  "HYPOSTASISE": "to treat as hypostasis, to personify, also HYPOSTASIZE, HYPOSTATISE, HYPOSTATIZE [v HYPOSTASISED, HYPOSTASISING, HYPOSTASISES]\n",
  "HYPOSTASISED": "HYPOSTASISE, to treat as hypostasis, to personify, also HYPOSTASIZE, HYPOSTATISE, HYPOSTATIZE [v]\n",
  "HYPOSTASISES": "HYPOSTASISE, to treat as hypostasis, to personify, also HYPOSTASIZE, HYPOSTATISE, HYPOSTATIZE [v]\n",
  "HYPOSTASISING": "HYPOSTASISE, to treat as hypostasis, to personify, also HYPOSTASIZE, HYPOSTATISE, HYPOSTATIZE [v]\n",
  "HYPOSTASIZATION": "the process of hypostasizing, also HYPOSTASISATION [n]\n",
  "HYPOSTASIZE": "to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTATISE, HYPOSTATIZE [v HYPOSTASIZED, HYPOSTASIZING, HYPOSTASIZES]\n",
  "HYPOSTASIZED": "HYPOSTASIZE, to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTATISE, HYPOSTATIZE [v]\n",
  "HYPOSTASIZES": "HYPOSTASIZE, to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTATISE, HYPOSTATIZE [v]\n",
  "HYPOSTASIZING": "HYPOSTASIZE, to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTATISE, HYPOSTATIZE [v]\n",
  "HYPOSTATIC": "relating to hypostasis, also HYPOSTATICAL [adj HYPOSTATICALLY]\n",
  "HYPOSTATICAL": "relating to hypostasis, also HYPOSTATIC [adj HYPOSTATICALLY]\n",
  "HYPOSTATICALLY": "HYPOSTATICAL, relating to hypostasis, also HYPOSTATIC [adv]\n",
  "HYPOSTATISATION": "the process of hypostatising, also HYPOSTATIZATION [n]\n",
  "HYPOSTATISE": "to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATIZE [v HYPOSTATISED, HYPOSTATISING, HYPOSTATISES]\n",
  "HYPOSTATISED": "HYPOSTATISE, to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATIZE [v]\n",
  "HYPOSTATISES": "HYPOSTATISE, to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATIZE [v]\n",
  "HYPOSTATISING": "HYPOSTATISE, to treat as hypostasis; to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATIZE [v]\n",
  "HYPOSTATIZATION": "the act of hypostatizing, also HYPOSTATISATION [n]\n",
  "HYPOSTATIZE": "to treat as hypostasis, to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATISE [v HYPOSTATIZED, HYPOSTATIZING, HYPOSTATIZES]\n",
  "HYPOSTATIZED": "HYPOSTATIZE, to treat as hypostasis, to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATISE [v]\n",
  "HYPOSTATIZES": "HYPOSTATIZE, to treat as hypostasis, to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATISE [v]\n",
  "HYPOSTATIZING": "HYPOSTATIZE, to treat as hypostasis, to personify, also HYPOSTASISE, HYPOSTASIZE, HYPOSTATISE [v]\n",
  "HYPOSTHENIA": "lack of strength [n -S]\n",
  "HYPOSTHENIAS": "HYPOSTHENIA, lack of strength [n]\n",
  "HYPOSTHENIC": "suffering from hyposthenia, lack of strength [adj]\n",
  "HYPOSTOME": "any of several structures associated with the mouth in different invertebrates [n -S]\n",
  "HYPOSTOMES": "HYPOSTOME, any of several structures associated with the mouth in different invertebrates [n]\n",
  "HYPOSTRESS": "insufficient stress [n -ES]\n",
  "HYPOSTRESSES": "HYPOSTRESS, insufficient stress [n]\n",
  "HYPOSTROPHE": "a return to the primary argument after digression [n -S]\n",
  "HYPOSTROPHES": "HYPOSTROPHE, a return to the primary argument after digression [n]\n",
  "HYPOSTYLE": "having a roof supported by columns [adj] / a building with a roof supported by columns [n -S]\n",
  "HYPOSTYLES": "HYPOSTYLE, a building with a roof supported by columns [n]\n",
  "HYPOSULPHATE": "a dithionate [n -S]\n",
  "HYPOSULPHATES": "HYPOSULPHATE, a dithionate [n]\n",
  "HYPOSULPHITE": "a salt of hyposulphurous acid [n -S]\n",
  "HYPOSULPHITES": "HYPOSULPHITE, a salt of hyposulphurous acid [n]\n",
  "HYPOSULPHURIC": "denoting a kind of acid [adj]\n",
  "HYPOSULPHUROUS": "of or derived from hyposulphurous acid [adj]\n",
  "HYPOTACTIC": "relating to hypotaxis, a dependent or subordinate relationship of clauses with conjunctions [adj]\n",
  "HYPOTAXES": "HYPOTAXIS, a dependent or subordinate relationship of clauses with conjunctions [n]\n",
  "HYPOTAXIS": "a dependent or subordinate relationship of clauses with conjunctions [n HYPOTAXES]\n",
  "HYPOTENSION": "abnormally low blood pressure [n -S]\n",
  "HYPOTENSIONS": "HYPOTENSION, abnormally low blood pressure [n]\n",
  "HYPOTENSIVE": "a person with hypotension [n -S]\n",
  "HYPOTENSIVES": "HYPOTENSIVE, a person with hypotension [n]\n",
  "HYPOTENUSE": "the longest side of a right-angled triangle, also HYPOTHENUSE [n -S]\n",
  "HYPOTENUSES": "HYPOTENUSE, the longest side of a right-angled triangle, also HYPOTHENUSE [n]\n",
  "HYPOTHALAMI": "HYPOTHALAMUS, a part of the brain [n]\n",
  "HYPOTHALAMIC": "of or relating to the hypothalamus [adj]\n",
  "HYPOTHALAMUS": "a part of the brain [n HYPOTHALAMI]\n",
  "HYPOTHEC": "in the law of Scotland, the Channel Islands, and ancient Rome, a creditor's right established over a debtor's property that continues in the debtor's possession [n -S]\n",
  "HYPOTHECA": "the inner and younger layer of the cell wall of a diatom [n HYPOTHECAE]\n",
  "HYPOTHECAE": "HYPOTHECA, the inner and younger layer of the cell wall of a diatom [n]\n",
  "HYPOTHECARY": "of or pertaining to mortgages [adj]\n",
  "HYPOTHECATE": "to pledge as security without title or possession [v HYPOTHECATED, HYPOTHECATING, HYPOTHECATES]\n",
  "HYPOTHECATED": "HYPOTHECATE, to pledge as security without title or possession [v]\n",
  "HYPOTHECATES": "HYPOTHECATE, to pledge as security without title or possession [v]\n",
  "HYPOTHECATING": "HYPOTHECATE, to pledge as security without title or possession [v]\n",
  "HYPOTHECATION": "the act of taking a mortgage [n -S]\n",
  "HYPOTHECATIONS": "HYPOTHECATION, the act of taking a mortgage [n]\n",
  "HYPOTHECATOR": "one who hypothecates [n -S]\n",
  "HYPOTHECATORS": "HYPOTHECATOR, one who hypothecates [n]\n",
  "HYPOTHECS": "HYPOTHEC, in the law of Scotland, the Channel Islands, and ancient Rome, a creditor's right established over a debtor's property that continues in the debtor's possession [n]\n",
  "HYPOTHENUSE": "the longest side of a right-angled triangle, also HYPOTENUSE [n -S]\n",
  "HYPOTHENUSES": "HYPOTHENUSE, the longest side of a right-angled triangle, also HYPOTENUSE [n]\n",
  "HYPOTHERMAL": "of or relating to a hydrothermal metalliferous ore vein deposited at high temperature [adj]\n",
  "HYPOTHERMIA": "subnormal temperature of the body [n -S]\n",
  "HYPOTHERMIAS": "HYPOTHERMIA, subnormal temperature of the body [n]\n",
  "HYPOTHERMIC": "relating to hypothermia [adj]\n",
  "HYPOTHESES": "HYPOTHESIS, a supposition, an assumption [n]\n",
  "HYPOTHESIS": "a supposition, an assumption [n HYPOTHESES]\n",
  "HYPOTHESISE": "to form a hypothesis, also HYPOTHESIZE, HYPOTHETISE, HYPOTHETIZE [v HYPOTHESISED, HYPOTHESISING, HYPOTHESISES]\n",
  "HYPOTHESISED": "HYPOTHESISE, to form a hypothesis, also HYPOTHESIZE, HYPOTHETISE, HYPOTHETIZE [v]\n",
  "HYPOTHESISER": "one who hypothesises, also HYPOTHESIZER [n -S]\n",
  "HYPOTHESISERS": "HYPOTHESISER, one who hypothesises, also HYPOTHESIZER [n]\n",
  "HYPOTHESISES": "HYPOTHESISE, to form a hypothesis, also HYPOTHESIZE, HYPOTHETISE, HYPOTHETIZE [v]\n",
  "HYPOTHESISING": "HYPOTHESISE, to form a hypothesis, also HYPOTHESIZE, HYPOTHETISE, HYPOTHETIZE [v]\n",
  "HYPOTHESIST": "one who forms a hypothesis [n -S]\n",
  "HYPOTHESISTS": "HYPOTHESIST, one who forms a hypothesis [n]\n",
  "HYPOTHESIZE": "to make a hypothesis, also HYPOTHESISE, HYPOTHETISE, HYPOTHETIZE [v HYPOTHESIZED, HYPOTHESIZING, HYPOTHESIZES]\n",
  "HYPOTHESIZED": "HYPOTHESIZE, to make a hypothesis, also HYPOTHESISE, HYPOTHETISE, HYPOTHETIZE [v]\n",
  "HYPOTHESIZER": "one who hypothesizes, also HYPOTHESISER [n -S]\n",
  "HYPOTHESIZERS": "HYPOTHESIZER, one who hypothesizes, also HYPOTHESISER [n]\n",
  "HYPOTHESIZES": "HYPOTHESIZE, to make a hypothesis, also HYPOTHESISE, HYPOTHETISE, HYPOTHETIZE [v]\n",
  "HYPOTHESIZING": "HYPOTHESIZE, to make a hypothesis, also HYPOTHESISE, HYPOTHETISE, HYPOTHETIZE [v]\n",
  "HYPOTHETIC": "of the nature of a hypothesis, also HYPOTHETICAL [adj HYPOTHETICALLY]\n",
  "HYPOTHETICAL": "being or involving a hypothesis [adj HYPOTHETICALLY]\n",
  "HYPOTHETICALLY": "HYPOTHETICAL, being or involving a hypothesis [adv]\n",
  "HYPOTHETISE": "to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETIZE [v HYPOTHETISED, HYPOTHETISING, HYPOTHETISES]\n",
  "HYPOTHETISED": "HYPOTHETISE, to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETIZE [v]\n",
  "HYPOTHETISES": "HYPOTHETISE, to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETIZE [v]\n",
  "HYPOTHETISING": "HYPOTHETISE, to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETIZE [v]\n",
  "HYPOTHETIZE": "to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETISE [v HYPOTHETIZED, HYPOTHETIZING, HYPOTHETIZES]\n",
  "HYPOTHETIZED": "HYPOTHETIZE, to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETISE [v]\n",
  "HYPOTHETIZES": "HYPOTHETIZE, to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETISE [v]\n",
  "HYPOTHETIZING": "HYPOTHETIZE, to form a hypothesis, also HYPOTHESISE, HYPOTHESIZE, HYPOTHETISE [v]\n",
  "HYPOTHYMIA": "a state of depression; a diminished emotional response [n -S]\n",
  "HYPOTHYMIAS": "HYPOTHYMIA, a state of depression; a diminished emotional response [n]\n",
  "HYPOTHYROID": "affected with hypothyroidism [adj] / someone suffering from hypothyroidism [n -S]\n",
  "HYPOTHYROIDISM": "deficient activity of the thyroid gland [n -S]\n",
  "HYPOTHYROIDISMS": "HYPOTHYROIDISM, deficient activity of the thyroid gland [n]\n",
  "HYPOTHYROIDS": "HYPOTHYROID, someone suffering from hypothyroidism [n]\n",
  "HYPOTONIA": "a hypnotic condition [n -S]\n",
  "HYPOTONIAS": "HYPOTONIA, a hypnotic condition [n]\n",
  "HYPOTONIC": "of muscles, lacking normal tone [adj]\n",
  "HYPOTONICITIES": "HYPOTONICITY, the state of being hypotonic [n]\n",
  "HYPOTONICITY": "the state of being hypotonic [n HYPOTONICITIES]\n",
  "HYPOTROCHOID": "the curve traced by a point on the radius, or radius produced, of a circle rolling within another circle [n -S]\n",
  "HYPOTROCHOIDS": "HYPOTROCHOID, the curve traced by a point on the radius, or radius produced, of a circle rolling within another circle [n]\n",
  "HYPOTYPOSES": "HYPOTYPOSIS, a vivid description of a scene [n]\n",
  "HYPOTYPOSIS": "a vivid description of a scene [n HYPOTYPOSES]\n",
  "HYPOVENTILATION": "abnormally decreased speed and depth of breathing [n]\n",
  "HYPOXAEMIA": "a deficiency of oxygenation of the blood, also HYPOXEMIA, HYPOXIA [n -S]\n",
  "HYPOXAEMIAS": "HYPOXAEMIA, a deficiency of oxygenation of the blood, also HYPOXEMIA, HYPOXIA [n]\n",
  "HYPOXAEMIC": "relating to hypoxaemia, a deficiency of oxygenation of the blood [adj]\n",
  "HYPOXANTHINE": "a purine base found in plant and animal tissues that yields xanthine on oxidation [n -S]\n",
  "HYPOXANTHINES": "HYPOXANTHINE, a purine base found in plant and animal tissues that yields xanthine on oxidation [n]\n",
  "HYPOXEMIA": "deficiency of oxygenation of the blood, also HYPOXAEMIA, HYPOXIA [n -S]\n",
  "HYPOXEMIAS": "HYPOXEMIA, deficiency of oxygenation of the blood, also HYPOXAEMIA, HYPOXIA [n]\n",
  "HYPOXEMIC": "suffering from hypoxemia, deficiency of oxygenation of the blood [adj]\n",
  "HYPOXIA": "a deficiency of oxygen in the body tissues, also HYPOXAEMIA, HYPOXEMIA [n -S]\n",
  "HYPOXIAS": "HYPOXIA, a deficiency of oxygen in the body tissues, also HYPOXAEMIA, HYPOXEMIA [n]\n",
  "HYPOXIC": "relating to hypoxia, a deficiency of oxygen in the body tissues [adj]\n",
  "HYPPED": "HYP, to offend [v]\n",
  "HYPPING": "HYP, to offend [v]\n",
  "HYPS": "HYP, to offend [v]\n",
  "HYPSOCHROME": "a shift to a shorter wavelength in the absorption spectrum of a compound [n -S]\n",
  "HYPSOCHROMES": "HYPSOCHROME, a shift to a shorter wavelength in the absorption spectrum of a compound [n]\n",
  "HYPSOCHROMIC": "relating to a hypsochrome, a shift to a shorter wavelength in the absorption spectrum of a compound [adj]\n",
  "HYPSOGRAPHIC": "relating to hypsography, the branch of geography dealing with the measurement and mapping of heights above sea level, also HYPSOGRAPHICAL [adj]\n",
  "HYPSOGRAPHICAL": "relating to hypsography, the branch of geography dealing with the measurement and mapping of heights above sea level, also HYPSOGRAPHIC [adj]\n",
  "HYPSOGRAPHIES": "HYPSOGRAPHY, the branch of geography dealing with the measurement and mapping of heights above sea level [n]\n",
  "HYPSOGRAPHY": "the branch of geography dealing with the measurement and mapping of heights above sea level [n HYPSOGRAPHIES]\n",
  "HYPSOMETER": "an instrument for measuring height of trees through triangulation [n -S]\n",
  "HYPSOMETERS": "HYPSOMETER, an instrument for measuring height of trees through triangulation [n]\n",
  "HYPSOMETRIC": "of, relating to, or indicating elevation (as on a map), also HYPSOMETRICAL [adj HYPSOMETRICALLY]\n",
  "HYPSOMETRICAL": "of, relating to, or indicating elevation (as on a map), also HYPSOMETRIC [adj HYPSOMETRICALLY]\n",
  "HYPSOMETRICALLY": "HYPSOMETRICAL, of, relating to, or indicating elevation (as on a map), also HYPSOMETRIC [adv]\n",
  "HYPSOMETRIES": "HYPSOMETRY, the art of measuring the heights of places on the earth's surface [n]\n",
  "HYPSOMETRIST": "a practitioner of hypsometry, the measuring the heights of places on the earth's surface [n -S]\n",
  "HYPSOMETRISTS": "HYPSOMETRIST, a practitioner of hypsometry, the measuring the heights of places on the earth's surface [n]\n",
  "HYPSOMETRY": "the art of measuring the heights of places on the earth's surface [n HYPSOMETRIES]\n",
  "HYPSOPHOBE": "a person suffering from hypsophobia, a fear of falling from high places [n -S]\n",
  "HYPSOPHOBES": "HYPSOPHOBE, a person suffering from hypsophobia, a fear of falling from high places [n]\n",
  "HYPSOPHOBIA": "a fear of falling from high places [n -S]\n",
  "HYPSOPHOBIAS": "HYPSOPHOBIA, a fear of falling from high places [n]\n",
  "HYPSOPHYLL": "a bract [n -S]\n",
  "HYPSOPHYLLARY": "of or like a hypsophyll, a bract [adj]\n",
  "HYPSOPHYLLS": "HYPSOPHYLL, a bract [n]\n",
  "HYPURAL": "situated beneath the tail [adj]\n",
  "HYRACES": "HYRAX, (Greek) a small, harelike mammal, also HYRACOID [n]\n",
  "HYRACOID": "any member of a genus of mammals including the daman and the dassie or hyrax, also HYRACOIDEAN [n -S]\n",
  "HYRACOIDEAN": "any member of a genus of mammals including the daman and the dassie or hyrax, also HYRACOID [n -S]\n",
  "HYRACOIDEANS": "HYRACOIDEAN, any member of a genus of mammals including the daman and the dassie or hyrax, also HYRACOID [n]\n",
  "HYRACOIDS": "HYRACOID, any member of a genus of mammals including the daman and the dassie or hyrax, also HYRACOIDEAN [n]\n",
  "HYRAX": "(Greek) a small, harelike mammal, also HYRACOID [n HYRAXES or HYRACES]\n",
  "HYRAXES": "HYRAX, (Greek) a small, harelike mammal, also HYRACOID [n]\n",
  "HYSON": "(Chinese) a fine sort of green tea [n -S]\n",
  "HYSONS": "HYSON, (Chinese) a fine sort of green tea [n]\n",
  "HYSSOP": "an aromatic bitter-tasting labiate herb native to the Mediterranean region [n -S]\n",
  "HYSSOPS": "HYSSOP, an aromatic bitter-tasting labiate herb native to the Mediterranean region [n]\n",
  "HYSTERANTHOUS": "having the leaves appearing after the flowers [adj]\n",
  "HYSTERECTOMIES": "HYSTERECTOMY, the surgical removal of the womb [n]\n",
  "HYSTERECTOMISE": "to remove the womb, also HYSTERECTOMIZE [v HYSTERECTOMISED, HYSTERECTOMISES]\n",
  "HYSTERECTOMISED": "HYSTERECTOMISE, to remove the womb, also HYSTERECTOMIZE [v]\n",
  "HYSTERECTOMISES": "HYSTERECTOMISE, to remove the womb, also HYSTERECTOMIZE [v]\n",
  "HYSTERECTOMIZE": "to remove the womb, also HYSTERECTOMISE [v HYSTERECTOMIZED, HYSTERECTOMIZES]\n",
  "HYSTERECTOMIZED": "HYSTERECTOMIZE, to remove the womb, also HYSTERECTOMISE [v]\n",
  "HYSTERECTOMIZES": "HYSTERECTOMIZE, to remove the womb, also HYSTERECTOMISE [v]\n",
  "HYSTERECTOMY": "the surgical removal of the womb [n HYSTERECTOMIES]\n",
  "HYSTERESES": "HYSTERESIS, the retardation or lagging of an effect behind the cause of the effect [n]\n",
  "HYSTERESIAL": "pertaining to hysteresis [adj]\n",
  "HYSTERESIS": "the retardation or lagging of an effect behind the cause of the effect [n HYSTERESES]\n",
  "HYSTERETIC": "pertaining to hysteresis, the retardation or lagging of an effect behind the cause of the effect [adj HYSTERETICALLY]\n",
  "HYSTERETICALLY": "HYSTERETIC, pertaining to hysteresis, the retardation or lagging of an effect behind the cause of the effect [adv]\n",
  "HYSTERIA": "uncontrollable excitement or fear [n -S]\n",
  "HYSTERIAS": "HYSTERIA, uncontrollable excitement or fear [n]\n",
  "HYSTERIC": "related to hysteria, also HYSTERICAL [adj HYSTERICALLY] / one who is subject to fits of hysteria [n -S]\n",
  "HYSTERICAL": "relating to hysteria, also HYSTERIC [adj HYSTERICALLY]\n",
  "HYSTERICALLY": "HYSTERICAL, relating to hysteria, also HYSTERIC [adv]\n",
  "HYSTERICKY": "(colloquial) hysterical [adj]\n",
  "HYSTERICS": "HYSTERIC, one who is subject to fits of hysteria [n]\n",
  "HYSTERITIS": "inflammation of the uterus [n -ES]\n",
  "HYSTERITISES": "HYSTERITIS, inflammation of the uterus [n]\n",
  "HYSTEROGENIC": "causing hysteria [adj]\n",
  "HYSTEROGENIES": "HYSTEROGENY, the generation of hysteria [n]\n",
  "HYSTEROGENY": "the generation of hysteria [n HYSTEROGENIES]\n",
  "HYSTEROID": "like hysteria, also HYSTEROIDAL [adj]\n",
  "HYSTEROIDAL": "like hysteria, also HYSTEROID [adj]\n",
  "HYSTEROMANIA": "hysterical mania, often marked by erotic delusions and an excessive desire to attract attention [n -S]\n",
  "HYSTEROMANIAS": "HYSTEROMANIA, hysterical mania, often marked by erotic delusions and an excessive desire to attract attention [n]\n",
  "HYSTEROTOMIES": "HYSTEROTOMY, a Caesarean cut [n]\n",
  "HYSTEROTOMY": "a Caesarean cut [n HYSTEROTOMIES]\n",
  "HYSTRICOMORPH": "any rodent of a suborder which includes porcupines, cavies, agoutis, and chinchillas [n -S]\n",
  "HYSTRICOMORPHIC": "belonging to the rodent suborder Hystricomorpha, which includes porcupines, cavies, agoutis, and chinchillas [adj]\n",
  "HYSTRICOMORPHS": "HYSTRICOMORPH, any rodent of a suborder which includes porcupines, cavies, agoutis, and chinchillas [n]\n",
  "HYTE": "(Scots) insane [adj]\n",
  "HYTHE": "a small port [n -S]\n",
  "HYTHES": "HYTHE, a small port [n]\n",
  "IAMB": "a poetic foot consisting of a short then a long syllable, also IAMBIC, IAMBUS [n -S]\n",
  "IAMBI": "IAMBUS, (Latin) a type of metrical foot, also IAMB, IAMBIC [n]\n",
  "IAMBIC": "consisting of iambs [adj IAMBICALLY] / a poetic foot consisting of a short then a long syllable, also IAMB, IAMBUS [n -S]\n",
  "IAMBICALLY": "IAMBIC, consisting of iambs [adv]\n",
  "IAMBICS": "IAMBIC, a poetic foot consisting of a short then a long syllable, also IAMB, IAMBUS [n]\n",
  "IAMBIST": "a poet who writes iambic verse [n -S]\n",
  "IAMBISTS": "IAMBIST, a poet who writes iambic verse [n]\n",
  "IAMBOGRAPHER": "one who writes in iambics [n -S]\n",
  "IAMBOGRAPHERS": "IAMBOGRAPHER, one who writes in iambics [n]\n",
  "IAMBS": "IAMB, a poetic foot consisting of a short then a long syllable, also IAMBIC, IAMBUS [n]\n",
  "IAMBUS": "(Latin) a type of metrical foot, also IAMB, IAMBIC [n IAMBUSES or IAMBI]\n",
  "IAMBUSES": "IAMBUS, (Latin) a type of metrical foot, also IAMB, IAMBIC [n]\n",
  "IANTHINE": "violet-coloured [adj]\n",
  "IATRIC": "pertaining to medicine, also IATRICAL [adj]\n",
  "IATRICAL": "pertaining to medicine, also IATRIC [adj]\n",
  "IATROCHEMICAL": "relating to iatrochemistry [adj]\n",
  "IATROCHEMIST": "a practitioner of iatrochemistry [n -S]\n",
  "IATROCHEMISTRY": "the application of chemistry to medical theory and treatment [n]\n",
  "IATROCHEMISTS": "IATROCHEMIST, a practitioner of iatrochemistry [n]\n",
  "IATROGENIC": "caused inadvertently by medical treatment, such as an infection or a complication [adj IATROGENICALLY]\n",
  "IATROGENICALLY": "IATROGENIC, caused inadvertently by medical treatment, such as an infection or a complication [adv]\n",
  "IATROGENICITIES": "IATROGENICITY, the state of being iatrogenic [n]\n",
  "IATROGENICITY": "the state of being iatrogenic [n IATROGENICITIES]\n",
  "IATROGENIES": "IATROGENY, the study of diseases or conditions induced in a patient by a doctor or medical treatment [n]\n",
  "IATROGENY": "the study of diseases or conditions induced in a patient by a doctor or medical treatment [n IATROGENIES]\n",
  "IBADAH": "(Arabic) in Islam, service, worship [n IBADAT]\n",
  "IBADAT": "IBADAH, (Arabic) in Islam, service, worship [n]\n",
  "IBERIS": "the candytuft plant [n -ES]\n",
  "IBERISES": "IBERIS, the candytuft plant [n]\n",
  "IBEX": "a wild mountain-goat [n IBEXES or IBICES]\n",
  "IBEXES": "IBEX, a wild mountain-goat [n]\n",
  "IBICES": "IBEX, a wild mountain-goat [n]\n",
  "IBIDEM": "(Latin) in the same place [adv]\n",
  "IBIS": "any of a group of gregarious wading birds of warm and tropical climates [n -ES]\n",
  "IBISES": "IBIS, any of a group of gregarious wading birds of warm and tropical climates [n]\n",
  "IBOGAINE": "an alkaloid used as an antidepressant [n -S]\n",
  "IBOGAINES": "IBOGAINE, an alkaloid used as an antidepressant [n]\n",
  "IBRIK": "the Arabic name for a cezve, a small metal pot used for preparing coffee [n -S]\n",
  "IBRIKS": "IBRIK, the Arabic name for a cezve, a small metal pot used for preparing coffee [n]\n",
  "IBUPROFEN": "an anti-inflammatory drug [n -S]\n",
  "IBUPROFENS": "IBUPROFEN, an anti-inflammatory drug [n]\n",
  "ICE": "to cover with frozen water [v ICED, ICING, ICES]\n",
  "ICEBALL": "a ball game played on ice [n -S]\n",
  "ICEBALLS": "ICEBALL, a ball game played on ice [n]\n",
  "ICEBERG": "a large floating body of ice [n -S]\n",
  "ICEBERGS": "ICEBERG, a large floating body of ice [n]\n",
  "ICEBLINK": "a glare in the sky caused by light reflected off ice [n -S]\n",
  "ICEBLINKS": "ICEBLINK, a glare in the sky caused by light reflected off ice [n]\n",
  "ICEBOAT": "a boat adapted to travelling through ice [n -S] / to travel by iceboat [v -ED, -ING, -S]\n",
  "ICEBOATED": "ICEBOAT, to travel by iceboat [v]\n",
  "ICEBOATER": "one who travels by iceboat [n -S]\n",
  "ICEBOATERS": "ICEBOATER, one who travels by iceboat [n]\n",
  "ICEBOATING": "the sport of using an iceboat [n -S]\n",
  "ICEBOATINGS": "ICEBOATING, the sport of using an iceboat [n]\n",
  "ICEBOATS": "ICEBOAT, a boat adapted to travelling through ice [n]\n",
  "ICEBOUND": "surrounded by ice [adj]\n",
  "ICEBOX": "a cabinet for keeping food cool [n -ES]\n",
  "ICEBOXES": "ICEBOX, a cabinet for keeping food cool [n]\n",
  "ICEBREAKER": "a boat for making a passage through ice [n -S]\n",
  "ICEBREAKERS": "ICEBREAKER, a boat for making a passage through ice [n]\n",
  "ICEBREAKING": "of a vessel, designed to break ice [adj]\n",
  "ICECAP": "a covering of ice and snow [n -S]\n",
  "ICECAPPED": "covered with caps of ice and snow [adj]\n",
  "ICECAPS": "ICECAP, a covering of ice and snow [n]\n",
  "ICED": "ICE, to cover with frozen water [v]\n",
  "ICEFALL": "a steep part of a glacier resembling a frozen waterfall [n -S]\n",
  "ICEFALLS": "ICEFALL, a steep part of a glacier resembling a frozen waterfall [n]\n",
  "ICEFIELD": "a large ice covered area [n -S]\n",
  "ICEFIELDS": "ICEFIELD, a large ice covered area [n]\n",
  "ICEFISH": "to fish through a hole in the ice on lake or river [v -ED, -ING, -ES]\n",
  "ICEFISHED": "ICEFISH, to fish through a hole in the ice on lake or river [v]\n",
  "ICEFISHES": "ICEFISH, to fish through a hole in the ice on lake or river [v]\n",
  "ICEFISHING": "ICEFISH, to fish through a hole in the ice on lake or river [v]\n",
  "ICEHOUSE": "an underground cellar lined with ice, used as an early form of refrigerator [n -S]\n",
  "ICEHOUSES": "ICEHOUSE, an underground cellar lined with ice, used as an early form of refrigerator [n]\n",
  "ICEKHANA": "an automotive event held on a frozen lake [n -S]\n",
  "ICEKHANAS": "ICEKHANA, an automotive event held on a frozen lake [n]\n",
  "ICELESS": "without ice [adj]\n",
  "ICELIKE": "like ice [adj]\n",
  "ICEMAKER": "an appliance that makes ice [n -S]\n",
  "ICEMAKERS": "ICEMAKER, an appliance that makes ice [n]\n",
  "ICEMAN": "a man who supplies ice [n ICEMEN]\n",
  "ICEMEN": "ICEMAN, a man who supplies ice [n]\n",
  "ICEPACK": "packed ice used to reduce swelling in sports injuries [n -S]\n",
  "ICEPACKS": "ICEPACK, packed ice used to reduce swelling in sports injuries [n]\n",
  "ICER": "a person who makes or applies icing [n -S]\n",
  "ICERS": "ICER, a person who makes or applies icing [n]\n",
  "ICES": "ICE, to cover with frozen water [v]\n",
  "ICESCAPE": "a landscape covered in ice [n -S]\n",
  "ICESCAPES": "ICESCAPE, a landscape covered in ice [n]\n",
  "ICESTONE": "another name for cryolite, an aluminum ore [n -S]\n",
  "ICESTONES": "ICESTONE, another name for cryolite, an aluminum ore [n]\n",
  "ICEWINE": "(Canadian) a dessert wine made from grapes frozen before harvesting, also EISWEIN [n -S]\n",
  "ICEWINES": "ICEWINE, (Canadian) a dessert wine made from grapes frozen before harvesting, also EISWEIN [n]\n",
  "ICEWORM": "a small worm found in glaciers [n -S]\n",
  "ICEWORMS": "ICEWORM, a small worm found in glaciers [n]\n",
  "ICH": "(Shakespeare) to eke, also ECH, ECHE, EECH, EIK, EKE [v ICHED, ICHING, ICHS or ICHES]\n",
  "ICHABOD": "(Hebrew) 'the glory is departed', expressing regret at former glories or higher standards [interj]\n",
  "ICHED": "ICH, (Shakespeare) to eke, also ECH, ECHE, EECH, EIK, EKE [v]\n",
  "ICHES": "ICH, (Shakespeare) to eke, also ECH, ECHE, EECH, EIK, EKE [v]\n",
  "ICHING": "ICH, (Shakespeare) to eke, also ECH, ECHE, EECH, EIK, EKE [v]\n",
  "ICHNEUMON": "(Greek) the Egyptian mongoose, found over much of Africa and parts of southern Europe [n -S]\n",
  "ICHNEUMONS": "ICHNEUMON, (Greek) the Egyptian mongoose, found over much of Africa and parts of southern Europe [n]\n",
  "ICHNITE": "a fossil footprint, also ICHNOLITE [n -S]\n",
  "ICHNITES": "ICHNITE, a fossil footprint, also ICHNOLITE [n]\n",
  "ICHNOFOSSIL": "a fossil footprint [n -S]\n",
  "ICHNOFOSSILS": "ICHNOFOSSIL, a fossil footprint [n]\n",
  "ICHNOGRAPHIC": "relating to the ichnography, the making of ground plans, also ICHNOGRAPHICAL [adj]\n",
  "ICHNOGRAPHICAL": "relating to the ichnography, the making of ground plans, also ICHNOGRAPHIC [adj]\n",
  "ICHNOGRAPHIES": "ICHNOGRAPHY, the art of drawing ground plans [n]\n",
  "ICHNOGRAPHY": "the art of drawing ground plans [n ICHNOGRAPHIES]\n",
  "ICHNOLITE": "a fossil footprint, also ICHNITE [n -S]\n",
  "ICHNOLITES": "ICHNOLITE, a fossil footprint, also ICHNITE [n]\n",
  "ICHNOLOGICAL": "related to ichnology [adj]\n",
  "ICHNOLOGIES": "ICHNOLOGY, a branch of paleontology dealing with the study of fossilized footprints, tracks, traces, etc. [n]\n",
  "ICHNOLOGY": "a branch of paleontology dealing with the study of fossilized footprints, tracks, traces, etc. [n ICHNOLOGIES]\n",
  "ICHOR": "(Greek) a watery discharge from a wound [n -S]\n",
  "ICHOROUS": "of or like ichor, serous [adj]\n",
  "ICHORS": "ICHOR, (Greek) a watery discharge from a wound [n]\n",
  "ICHS": "ICH, (Shakespeare) to eke, also ECH, ECHE, EECH, EIK, EKE [v]\n",
  "ICHTHIC": "relating to fish [adj]\n",
  "ICHTHYIC": "pertaining to fish [adj]\n",
  "ICHTHYOCOLLA": "fish-glue; isinglass [n -S]\n",
  "ICHTHYOCOLLAS": "ICHTHYOCOLLA, fish-glue; isinglass [n]\n",
  "ICHTHYODORULITE": "a fossilised fish-spine, also ICHTHYODORYLITE [n]\n",
  "ICHTHYODORYLITE": "a fossilised fish-spine, also ICHTHYODORULITE [n]\n",
  "ICHTHYOFAUNA": "the fish life of region [n ICHTHYOFAUNAE or ICHTHYOFAUNAS]\n",
  "ICHTHYOFAUNAE": "ICHTHYOFAUNA, the fish life of region [n]\n",
  "ICHTHYOFAUNAL": "of or relating to ichthyofauna [adj]\n",
  "ICHTHYOFAUNAS": "ICHTHYOFAUNA, the fish life of region [n]\n",
  "ICHTHYOID": "fishlike, also ICHTHYOIDAL [adj] / any fishlike creature [n -S]\n",
  "ICHTHYOIDAL": "fishlike, also ICHTHYOID [adj]\n",
  "ICHTHYOIDS": "ICHTHYOID, any fishlike creature [n]\n",
  "ICHTHYOLATRIES": "ICHTHYOLATRY, the worship of fish [n]\n",
  "ICHTHYOLATROUS": "worshipping fish [adj]\n",
  "ICHTHYOLATRY": "the worship of fish [n ICHTHYOLATRIES]\n",
  "ICHTHYOLITE": "a fossil fish [n -S]\n",
  "ICHTHYOLITES": "ICHTHYOLITE, a fossil fish [n]\n",
  "ICHTHYOLITIC": "of or like an ichthyolite, a fossil fish [adj]\n",
  "ICHTHYOLOGIC": "relating to ichthyology, also ICHTHYOLOGICAL [adj]\n",
  "ICHTHYOLOGICAL": "relating to ichthyology, also ICHTHYOLOGIC [adj]\n",
  "ICHTHYOLOGIES": "ICHTHYOLOGY, the study of fish [n]\n",
  "ICHTHYOLOGIST": "one who studies ichthyology [n -S]\n",
  "ICHTHYOLOGISTS": "ICHTHYOLOGIST, one who studies ichthyology [n]\n",
  "ICHTHYOLOGY": "the study of fish [n ICHTHYOLOGIES]\n",
  "ICHTHYOPHAGIES": "ICHTHYOPHAGY, the eating of fish [n]\n",
  "ICHTHYOPHAGIST": "one who eats fish [n -S]\n",
  "ICHTHYOPHAGISTS": "ICHTHYOPHAGIST, one who eats fish [n]\n",
  "ICHTHYOPHAGOUS": "fish-eating [adj]\n",
  "ICHTHYOPHAGY": "the eating of fish [n ICHTHYOPHAGIES]\n",
  "ICHTHYOPSID": "a member of the Ichthyopsida, amphibians, fishes and fishlike vertebrates, also ICHTHYOPSIDAN [n -S]\n",
  "ICHTHYOPSIDAN": "a member of the Ichthyopsida, amphibians, fishes and fishlike vertebrates, also ICHTHYOPSID [n -S]\n",
  "ICHTHYOPSIDANS": "ICHTHYOPSIDAN, a member of the Ichthyopsida, amphibians, fishes and fishlike vertebrates, also ICHTHYOPSID [n]\n",
  "ICHTHYOPSIDS": "ICHTHYOPSID, a member of the Ichthyopsida, amphibians, fishes and fishlike vertebrates, also ICHTHYOPSIDAN [n]\n",
  "ICHTHYORNIS": "a toothed fossil bird of America [n -ES]\n",
  "ICHTHYORNISES": "ICHTHYORNIS, a toothed fossil bird of America [n]\n",
  "ICHTHYOSAUR": "a large fossil marine reptile, also ICHTHYOSAURIAN, ICHTHYOSAURUS [n -S]\n",
  "ICHTHYOSAURI": "ICHTHYOSAURUS, a large fossil marine reptile, also ICHTHYOSAUR, ICHTHYOSAURIAN [n]\n",
  "ICHTHYOSAURIAN": "a large fossil marine reptile, also ICHTHYOSAUR, ICHTHYOSAURUS [n -S]\n",
  "ICHTHYOSAURIANS": "ICHTHYOSAURIAN, a large fossil marine reptile, also ICHTHYOSAUR, ICHTHYOSAURUS [n]\n",
  "ICHTHYOSAURS": "ICHTHYOSAUR, a large fossil marine reptile, also ICHTHYOSAURIAN, ICHTHYOSAURUS [n]\n",
  "ICHTHYOSAURUS": "a large fossil marine reptile, also ICHTHYOSAUR, ICHTHYOSAURIAN [n ICHTHYOSAURI or ICHTHYOSAURUSES]\n",
  "ICHTHYOSAURUSES": "ICHTHYOSAURUS, a large fossil marine reptile, also ICHTHYOSAUR, ICHTHYOSAURIAN [n]\n",
  "ICHTHYOSES": "ICHTHYOSIS, a disease in which the skin is thick, rough, and scaly [n]\n",
  "ICHTHYOSIS": "a disease in which the skin is thick, rough, and scaly [n ICHTHYOSES]\n",
  "ICHTHYOTIC": "relating to ichthyosis, a disease in which the skin is thick, rough, and scaly [adj]\n",
  "ICHTHYS": "(Greek) an emblematic fish symbolizing Christ, believed to have mystical qualities [n -ES]\n",
  "ICHTHYSES": "ICHTHYS, (Greek) an emblematic fish symbolizing Christ, believed to have mystical qualities [n]\n",
  "ICICLE": "a hanging spike of ice [n -S]\n",
  "ICICLED": "having an icicle [adj]\n",
  "ICICLES": "ICICLE, a hanging spike of ice [n]\n",
  "ICIER": "ICY, covered with ice [adj]\n",
  "ICIEST": "ICY, covered with ice [adj]\n",
  "ICILY": "ICY, covered with ice [adv]\n",
  "ICINESS": "the state of being icy [n -ES]\n",
  "ICINESSES": "ICINESS, the state of being icy [n]\n",
  "ICING": "a sweet mixture for covering cakes [n -S]\n",
  "ICINGS": "ICING, a sweet mixture for covering cakes [n]\n",
  "ICK": "something sticky or disgusting [n -S]\n",
  "ICKER": "(Scots) a single ear of corn [n -S]\n",
  "ICKERS": "ICKER, (Scots) a single ear of corn [n]\n",
  "ICKIER": "ICKY, repulsive [adj]\n",
  "ICKIEST": "ICKY, repulsive [adj]\n",
  "ICKILY": "ICKY, repulsive [adv]\n",
  "ICKINESS": "the state of being icky [n -ES]\n",
  "ICKINESSES": "ICKINESS, the state of being icky [n]\n",
  "ICKLE": "(colloquial) little [adj ICKLER, ICKLEST]\n",
  "ICKLER": "ICKLE, (colloquial) little [adj]\n",
  "ICKLEST": "ICKLE, (colloquial) little [adj]\n",
  "ICKS": "ICK, something sticky or disgusting [n]\n",
  "ICKY": "repulsive [adj ICKIER, ICKIEST, ICKILY]\n",
  "ICON": "a symbol or image, also IKON, EIKON [n ICONS or ICONES]\n",
  "ICONES": "ICON, a symbol or image, also IKON, EIKON [n]\n",
  "ICONIC": "pertaining to an icon, also ICONICAL [adj ICONICALLY]\n",
  "ICONICAL": "pertaining to an icon, also ICONIC [adj ICONICALLY]\n",
  "ICONICALLY": "ICONICAL, pertaining to an icon, also ICONIC [adv]\n",
  "ICONICITIES": "ICONICITY, the state of being iconic [n]\n",
  "ICONICITY": "the state of being iconic [n ICONICITIES]\n",
  "ICONIFIED": "ICONIFY, to reduce to an icon on a computer screen [v]\n",
  "ICONIFIES": "ICONIFY, to reduce to an icon on a computer screen [v]\n",
  "ICONIFY": "to reduce to an icon on a computer screen [v ICONIFIED, ICONIFYING, ICONIFIES]\n",
  "ICONIFYING": "ICONIFY, to reduce to an icon on a computer screen [v]\n",
  "ICONISE": "to venerate, also ICONIZE [v ICONISED, ICONISING, ICONISES]\n",
  "ICONISED": "ICONISE, to venerate, also ICONIZE [v]\n",
  "ICONISES": "ICONISE, to venerate, also ICONIZE [v]\n",
  "ICONISING": "ICONISE, to venerate, also ICONIZE [v]\n",
  "ICONIZE": "to venerate, also ICONISE [v ICONIZED, ICONIZING, ICONIZES]\n",
  "ICONIZED": "ICONIZE, to venerate, also ICONISE [v]\n",
  "ICONIZES": "ICONIZE, to venerate, also ICONISE [v]\n",
  "ICONIZING": "ICONIZE, to venerate, also ICONISE [v]\n",
  "ICONOCLASM": "attacking of established beliefs [n -S]\n",
  "ICONOCLASMS": "ICONOCLASM, attacking of established beliefs [n]\n",
  "ICONOCLAST": "a breaker or destroyer of images or idols [n -S]\n",
  "ICONOCLASTIC": "like an iconoclast [adj]\n",
  "ICONOCLASTS": "ICONOCLAST, a breaker or destroyer of images or idols [n]\n",
  "ICONOGRAPHER": "a maker of figures or drawings esp. of a conventional type [n -S]\n",
  "ICONOGRAPHERS": "ICONOGRAPHER, a maker of figures or drawings esp. of a conventional type [n]\n",
  "ICONOGRAPHIC": "of or relating to iconography, also ICONOGRAPHICAL [adj]\n",
  "ICONOGRAPHICAL": "of or relating to iconography, also ICONOGRAPHIC [adj]\n",
  "ICONOGRAPHIES": "ICONOGRAPHY, the study of drawing symbols [n]\n",
  "ICONOGRAPHY": "the study of drawing symbols [n ICONOGRAPHIES]\n",
  "ICONOLATER": "one who worships images [n -S]\n",
  "ICONOLATERS": "ICONOLATER, one who worships images [n]\n",
  "ICONOLATRIES": "ICONOLATRY, image-worship [n]\n",
  "ICONOLATROUS": "worshipping images [adj]\n",
  "ICONOLATRY": "image-worship [n ICONOLATRIES]\n",
  "ICONOLOGICAL": "relating to iconology [adj]\n",
  "ICONOLOGIES": "ICONOLOGY, a branch of art history dealing with iconic representations [n]\n",
  "ICONOLOGIST": "a student of iconology [n -S]\n",
  "ICONOLOGISTS": "ICONOLOGIST, a student of iconology [n]\n",
  "ICONOLOGY": "a branch of art history dealing with iconic representations [n ICONOLOGIES]\n",
  "ICONOMACHIES": "ICONOMACHY, opposition to the worship of images or icons [n]\n",
  "ICONOMACHIST": "a person who contends against the use of icons in worship [n -S]\n",
  "ICONOMACHISTS": "ICONOMACHIST, a person who contends against the use of icons in worship [n]\n",
  "ICONOMACHY": "opposition to the worship of images or icons [n ICONOMACHIES]\n",
  "ICONOMATIC": "using pictures to represent sounds of words [adj]\n",
  "ICONOMATICISM": "the quality of being iconomatic [n -S]\n",
  "ICONOMATICISMS": "ICONOMATICISM, the quality of being iconomatic [n]\n",
  "ICONOMETER": "an instrument for finding the size of an object by measuring its image [n -S]\n",
  "ICONOMETERS": "ICONOMETER, an instrument for finding the size of an object by measuring its image [n]\n",
  "ICONOMETRIES": "ICONOMETRY, measurement by iconometer [n]\n",
  "ICONOMETRY": "measurement by iconometer [n ICONOMETRIES]\n",
  "ICONOPHILISM": "a taste for pictures and symbols [n -S]\n",
  "ICONOPHILISMS": "ICONOPHILISM, a taste for pictures and symbols [n]\n",
  "ICONOPHILIST": "one with a taste for pictures and symbols [n -S]\n",
  "ICONOPHILISTS": "ICONOPHILIST, one with a taste for pictures and symbols [n]\n",
  "ICONOSCOPE": "an early form of electron camera [n -S]\n",
  "ICONOSCOPES": "ICONOSCOPE, an early form of electron camera [n]\n",
  "ICONOSTAS": "(Greek) in Eastern churches, a screen separating the sanctuary from the nave, also ICONOSTASIS [n ICONOSTASES]\n",
  "ICONOSTASES": "ICONOSTAS, (Greek) in Eastern churches, a screen separating the sanctuary from the nave, also ICONOSTASIS [n]\n",
  "ICONOSTASIS": "(Greek) in Eastern churches, a screen separating the sanctuary from the nave, also ICONOSTAS [n ICONOSTASES]\n",
  "ICONS": "ICON, a symbol or image, also IKON, EIKON [n]\n",
  "ICOSAHEDRA": "ICOSAHEDRON, a polyhedron having 20 faces [n]\n",
  "ICOSAHEDRAL": "of or having the form of an icosahedron [adj]\n",
  "ICOSAHEDRON": "a polyhedron having 20 faces [n ICOSAHEDRA or ICOSAHEDRONS]\n",
  "ICOSAHEDRONS": "ICOSAHEDRON, a polyhedron having 20 faces [n]\n",
  "ICOSANDRIAN": "belonging to the Icosandria, a class of plants, also ICOSANDROUS [adj]\n",
  "ICOSANDROUS": "belonging to the Icosandria, a class of plants, also ICOSANDRIAN [adj]\n",
  "ICOSITETRAHEDRA": "solid figures with twenty-four plane faces (plural of 16-letter word) [n]\n",
  "ICTAL": "relating to an ictus, a rhythmical or metrical stress, also ICTIC [adj]\n",
  "ICTERIC": "relating to or suffering from jaundice [adj] / a remedy for icterus, jaundice, also ICTERICAL [n -S]\n",
  "ICTERICAL": "a remedy for icterus, jaundice, also ICTERIC [n -S]\n",
  "ICTERICALS": "ICTERICAL, a remedy for icterus, jaundice, also ICTERIC [n]\n",
  "ICTERICS": "ICTERIC, a remedy for icterus, jaundice, also ICTERICAL [n]\n",
  "ICTERID": "an American oriole [n -S]\n",
  "ICTERIDS": "ICTERID, an American oriole [n]\n",
  "ICTERINE": "marked yellow [adj]\n",
  "ICTERITIOUS": "jaundiced; yellow [adj]\n",
  "ICTERUS": "(Greek) a diseased condition of the liver, jaundice [n -ES]\n",
  "ICTERUSES": "ICTERUS, (Greek) a diseased condition of the liver, jaundice [n]\n",
  "ICTIC": "relating to an ictus, a rhythmical or metrical stress, also ICTAL [adj]\n",
  "ICTUS": "(Latin) a recurring stress/accent in a rhythmic/metrical series of sounds [n -ES]\n",
  "ICTUSES": "ICTUS, (Latin) a recurring stress/accent in a rhythmic/metrical series of sounds [n]\n",
  "ICY": "covered with ice [adj ICIER, ICIEST, ICILY]\n",
  "ID": "a fish of the carp family, aka silver orfe, also IDE [n -S]\n",
  "IDANT": "a chromosome which is an agregation of ids [n -S]\n",
  "IDANTS": "IDANT, a chromosome which is an agregation of ids [n]\n",
  "IDE": "a fish of the carp family, aka silver orfe, also ID [n -S]\n",
  "IDEA": "a conception or a plan [n -S]\n",
  "IDEAED": "provided with ideas [adj]\n",
  "IDEAL": "leaving nothing to be desired [adj IDEALLY] / a standard of perfection [n -S]\n",
  "IDEALESS": "without ideas [adj]\n",
  "IDEALISATION": "the act of idealising, also IDEALIZATION [n -S]\n",
  "IDEALISATIONS": "IDEALISATION, the act of idealising, also IDEALIZATION [n]\n",
  "IDEALISE": "to regard as perfect, also IDEALIZE [v IDEALISED, IDEALISING, IDEALISES]\n",
  "IDEALISED": "IDEALISE, to regard as perfect, also IDEALIZE [v]\n",
  "IDEALISER": "one who idealises, also IDEALIZER [n -S]\n",
  "IDEALISERS": "IDEALISER, one who idealises, also IDEALIZER [n]\n",
  "IDEALISES": "IDEALISE, to regard as perfect, also IDEALIZE [v]\n",
  "IDEALISING": "IDEALISE, to regard as perfect, also IDEALIZE [v]\n",
  "IDEALISM": "the pursuit of noble goals [n -S]\n",
  "IDEALISMS": "IDEALISM, the pursuit of noble goals [n]\n",
  "IDEALIST": "an adherent of idealism [n -S]\n",
  "IDEALISTIC": "of or relating to idealists or idealism [adj IDEALISTICALLY]\n",
  "IDEALISTICALLY": "IDEALISTIC, of or relating to idealists or idealism [adv]\n",
  "IDEALISTS": "IDEALIST, an adherent of idealism [n]\n",
  "IDEALITIES": "IDEALITY, the state of being ideal [n]\n",
  "IDEALITY": "the state of being ideal [n IDEALITIES]\n",
  "IDEALIZATION": "the act of idealizing, also IDEALISATION [n -S]\n",
  "IDEALIZATIONS": "IDEALIZATION, the act of idealizing, also IDEALISATION [n]\n",
  "IDEALIZE": "to regard as perfect, also IDEALISE [v IDEALIZED, IDEALIZING, IDEALIZES]\n",
  "IDEALIZED": "IDEALIZE, to regard as perfect, also IDEALISE [v]\n",
  "IDEALIZER": "one who idealizes, also IDEALISER [n -S]\n",
  "IDEALIZERS": "IDEALIZER, one who idealizes, also IDEALISER [n]\n",
  "IDEALIZES": "IDEALIZE, to regard as perfect, also IDEALISE [v]\n",
  "IDEALIZING": "IDEALIZE, to regard as perfect, also IDEALISE [v]\n",
  "IDEALLESS": "without ideals [adj]\n",
  "IDEALLY": "IDEAL, leaving nothing to be desired [adv]\n",
  "IDEALNESS": "the state of being ideal [n -ES]\n",
  "IDEALNESSES": "IDEALNESS, the state of being ideal [n]\n",
  "IDEALOGIES": "IDEALOGY, a belief system, also IDEOLOGY [n]\n",
  "IDEALOGUE": "a doctrinaire adherent of an ideology, also IDEOLOGUE [n -S]\n",
  "IDEALOGUES": "IDEALOGUE, a doctrinaire adherent of an ideology, also IDEOLOGUE [n]\n",
  "IDEALOGY": "a belief system, also IDEOLOGY [n IDEALOGIES]\n",
  "IDEALS": "IDEAL, a standard of perfection [n]\n",
  "IDEAS": "IDEA, a conception or a plan [n]\n",
  "IDEATA": "IDEATUM, the real object of an idea [n]\n",
  "IDEATE": "to form an idea or conception of [v IDEATED, IDEATING, IDEATES]\n",
  "IDEATED": "IDEATE, to form an idea or conception of [v]\n",
  "IDEATES": "IDEATE, to form an idea or conception of [v]\n",
  "IDEATING": "IDEATE, to form an idea or conception of [v]\n",
  "IDEATION": "the power of the mind to form images [n -S]\n",
  "IDEATIONAL": "pertaining to, or characterized by, ideation [adj IDEATIONALLY]\n",
  "IDEATIONALLY": "IDEATIONAL, pertaining to, or characterized by, ideation [adv]\n",
  "IDEATIONS": "IDEATION, the power of the mind to form images [n]\n",
  "IDEATIVE": "relating to ideation, the power of the mind to form images [adj]\n",
  "IDEATUM": "the real object of an idea [n IDEATA]\n",
  "IDEE": "(French) an idea [n -S]\n",
  "IDEES": "IDEE, (French) an idea [n]\n",
  "IDEM": "(Latin) the same; the same as above [pron]\n",
  "IDEMPOTENCIES": "IDEMPOTENCY, the state of being idempotent [n]\n",
  "IDEMPOTENCY": "the state of being idempotent [n IDEMPOTENCIES]\n",
  "IDEMPOTENT": "relating to a quantity which does not change when squared [adj] / a quantity that does not change when squared [n -S]\n",
  "IDEMPOTENTS": "IDEMPOTENT, a quantity that does not change when squared [n]\n",
  "IDENT": "a short visual image displayed between television programs that works as a logo to locate the viewer to the channel [n -S]\n",
  "IDENTIC": "identical [adj]\n",
  "IDENTICAL": "exactly the same, also IDENTIC [adj IDENTICALLY]\n",
  "IDENTICALLY": "IDENTICAL, exactly the same, also IDENTIC [adv]\n",
  "IDENTICALNESS": "the state of being identical [n -ES]\n",
  "IDENTICALNESSES": "IDENTICALNESS, the state of being identical [n]\n",
  "IDENTIFIABLE": "that can be identified [adj IDENTIFIABLY]\n",
  "IDENTIFIABLY": "IDENTIFIABLE, that can be identified [adv]\n",
  "IDENTIFICATION": "an act of identifying [n -S]\n",
  "IDENTIFICATIONS": "IDENTIFICATION, an act of identifying [n]\n",
  "IDENTIFIED": "IDENTIFY, to establish the identity of [v]\n",
  "IDENTIFIER": "one that identifies [n -S]\n",
  "IDENTIFIERS": "IDENTIFIER, one that identifies [n]\n",
  "IDENTIFIES": "IDENTIFY, to establish the identity of [v]\n",
  "IDENTIFY": "to establish the identity of [v IDENTIFIED, IDENTIFYING, IDENTIFIES]\n",
  "IDENTIFYING": "IDENTIFY, to establish the identity of [v]\n",
  "IDENTIKIT": "a reconstructed picture of a person (esp. a suspect sought by police) assembled from features described by a witness or witnesses [n -S]\n",
  "IDENTIKITS": "IDENTIKIT, a reconstructed picture of a person (esp. a suspect sought by police) assembled from features described by a witness or witnesses [n]\n",
  "IDENTITIES": "IDENTITY, the essential character of a person or thing [n]\n",
  "IDENTITY": "the essential character of a person or thing [n IDENTITIES]\n",
  "IDENTS": "IDENT, a short visual image displayed between television programs that works as a logo to locate the viewer to the channel [n]\n",
  "IDEOGRAM": "a symbol that stands for a concept rather than a word [n -S]\n",
  "IDEOGRAMIC": "of or like an ideogram, also IDEOGRAMMATIC, IDEOGRAMMIC [adj]\n",
  "IDEOGRAMMATIC": "of or like an ideogram, also IDEOGRAMIC, IDEOGRAMMIC [adj]\n",
  "IDEOGRAMMIC": "of or like an ideogram, also IDEOGRAMIC, IDEOGRAMMATIC [adj]\n",
  "IDEOGRAMS": "IDEOGRAM, a symbol that stands for a concept rather than a word [n]\n",
  "IDEOGRAPH": "a symbol in picture-writing representing the idea of a thing [n -S]\n",
  "IDEOGRAPHIC": "in the form of an ideograph, a symbol in picture-writing representing the idea of a thing, also IDEOGRAPHICAL [adj IDEOGRAPHICALLY]\n",
  "IDEOGRAPHICAL": "in the form of an ideograph, a symbol in picture-writing representing the idea of a thing, also IDEOGRAPHIC [adj]\n",
  "IDEOGRAPHICALLY": "IDEOGRAPHICAL, in the form of an ideograph, a symbol in picture-writing representing the idea of a thing, also IDEOGRAPHIC [adv]\n",
  "IDEOGRAPHIES": "IDEOGRAPHY, the representation of ideas independently of sounds, or in an ideographic manner, as sometimes is done in shorthand writing, etc. [n]\n",
  "IDEOGRAPHS": "IDEOGRAPH, a symbol in picture-writing representing the idea of a thing [n]\n",
  "IDEOGRAPHY": "the representation of ideas independently of sounds, or in an ideographic manner, as sometimes is done in shorthand writing, etc. [n IDEOGRAPHIES]\n",
  "IDEOLOGIC": "relating to or concerned with ideology, also IDEOLOGICAL [adj IDEOLOGICALLY]\n",
  "IDEOLOGICAL": "relating to or concerned with ideology, also IDEOLOGIC [adj IDEOLOGICALLY]\n",
  "IDEOLOGICALLY": "IDEOLOGICAL, relating to or concerned with ideology, also IDEOLOGIC [adv]\n",
  "IDEOLOGIES": "IDEOLOGY, the science of ideas [n]\n",
  "IDEOLOGISE": "to render ideological, also IDEOLOGIZE [v IDEOLOGISED, IDEOLOGISING, IDEOLOGISES]\n",
  "IDEOLOGISED": "IDEOLOGISE, to render ideological, also IDEOLOGIZE [v]\n",
  "IDEOLOGISES": "IDEOLOGISE, to render ideological, also IDEOLOGIZE [v]\n",
  "IDEOLOGISING": "IDEOLOGISE, to render ideological, also IDEOLOGIZE [v]\n",
  "IDEOLOGIST": "a supporter of a particular ideology [n -S]\n",
  "IDEOLOGISTS": "IDEOLOGIST, a supporter of a particular ideology [n]\n",
  "IDEOLOGIZE": "to render ideological, also IDEOLOGISE [v IDEOLOGIZED, IDEOLOGIZING, IDEOLOGIZES]\n",
  "IDEOLOGIZED": "IDEOLOGIZE, to render ideological, also IDEOLOGISE [v]\n",
  "IDEOLOGIZES": "IDEOLOGIZE, to render ideological, also IDEOLOGISE [v]\n",
  "IDEOLOGIZING": "IDEOLOGIZE, to render ideological, also IDEOLOGISE [v]\n",
  "IDEOLOGUE": "a doctrinaire adherent of an ideology, also IDEALOGUE [n -S]\n",
  "IDEOLOGUES": "IDEOLOGUE, a doctrinaire adherent of an ideology, also IDEALOGUE [n]\n",
  "IDEOLOGY": "the science of ideas [n IDEOLOGIES]\n",
  "IDEOMOTOR": "describing or relating to a muscular action that is evoked by an idea [adj]\n",
  "IDEOPHONE": "a word that is spoken but not written [n -S]\n",
  "IDEOPHONES": "IDEOPHONE, a word that is spoken but not written [n]\n",
  "IDEOPOLIS": "a city that is sustained primarily by intellectual enterprises such as education, the media, advertising and design, with a highly educated workforce [n -ES]\n",
  "IDEOPOLISES": "IDEOPOLIS, a city that is sustained primarily by intellectual enterprises such as education, the media, advertising and design, with a highly educated workforce [n]\n",
  "IDEOPRAXIST": "one who is impelled to carry out an idea [n -S]\n",
  "IDEOPRAXISTS": "IDEOPRAXIST, one who is impelled to carry out an idea [n]\n",
  "IDES": "IDE, a fish of the carp family, aka silver orfe, also ID [n]\n",
  "IDIOBLAST": "a plant cell that differs from neighbouring cells in the same tissue [n -S]\n",
  "IDIOBLASTIC": "relating to an idioblast [adj]\n",
  "IDIOBLASTS": "IDIOBLAST, a plant cell that differs from neighbouring cells in the same tissue [n]\n",
  "IDIOCIES": "IDIOCY, the state of being an idiot, also IDIOTCY, IDIOTISM [n]\n",
  "IDIOCY": "the state of being an idiot, also IDIOTCY, IDIOTISM [n IDIOCIES]\n",
  "IDIOGLOSSIA": "secret speech or language, esp. invented by children [n -S]\n",
  "IDIOGLOSSIAS": "IDIOGLOSSIA, secret speech or language, esp. invented by children [n]\n",
  "IDIOGRAM": "a diagram of chromosomes in pairs [n -S]\n",
  "IDIOGRAMS": "IDIOGRAM, a diagram of chromosomes in pairs [n]\n",
  "IDIOGRAPH": "a private mark, a trademark [n -S]\n",
  "IDIOGRAPHIC": "pertaining to or dealing with the individual or unique [adj]\n",
  "IDIOGRAPHS": "IDIOGRAPH, a private mark, a trademark [n]\n",
  "IDIOLECT": "an individual's distinctive form of speech [n -S]\n",
  "IDIOLECTAL": "of or like an idiolect, a distinctive individual form of speech, also IDIOLECTIC [adj]\n",
  "IDIOLECTIC": "of or like an idiolect, a distinctive individual form of speech, also IDIOLECTAL [adj]\n",
  "IDIOLECTS": "IDIOLECT, an individual's distinctive form of speech [n]\n",
  "IDIOM": "a mode of expression peculiar to a language [n -S]\n",
  "IDIOMATIC": "peculiar to or of the nature of an idiom, also IDIOMATICAL [adj IDIOMATICALLY]\n",
  "IDIOMATICAL": "peculiar to or of the nature of an idiom, also IDIOMATIC [adj IDIOMATICALLY]\n",
  "IDIOMATICALLY": "IDIOMATICAL, peculiar to or of the nature of an idiom, also IDIOMATIC [adv]\n",
  "IDIOMATICALNESS": "IDIOMATICAL, peculiar to or of the nature of an idiom, also IDIOMATIC [n]\n",
  "IDIOMATICNESS": "the state of being idiomatic [n -ES]\n",
  "IDIOMATICNESSES": "IDIOMATICNESS, the state of being idiomatic [n]\n",
  "IDIOMORPHIC": "of well-crystallized minerals, having a characteristic shape [adj IDIOMORPHICALLY]\n",
  "IDIOMORPHICALLY": "IDIOMORPHIC, of well-crystallized minerals, having a characteristic shape [adv]\n",
  "IDIOMORPHISM": "the state of being idiomorphic [n -S]\n",
  "IDIOMORPHISMS": "IDIOMORPHISM, the state of being idiomorphic [n]\n",
  "IDIOMS": "IDIOM, a mode of expression peculiar to a language [n]\n",
  "IDIOPATHIC": "of a disease, etc. arising spontaneously from some unknown cause, primary [adj IDIOPATHICALLY]\n",
  "IDIOPATHICALLY": "IDIOPATHIC, of a disease, etc. arising spontaneously from some unknown cause, primary [adv]\n",
  "IDIOPATHIES": "IDIOPATHY, a disease of unknown origin or one having no apparent cause [n]\n",
  "IDIOPATHY": "a disease of unknown origin or one having no apparent cause [n IDIOPATHIES]\n",
  "IDIOPHONE": "a percussion instrument made of naturally resonant material [n -S]\n",
  "IDIOPHONES": "IDIOPHONE, a percussion instrument made of naturally resonant material [n]\n",
  "IDIOPHONIC": "relating to an idiophone [adj]\n",
  "IDIOPLASM": "the part of the protoplasm bearing hereditary characteristics [n -S]\n",
  "IDIOPLASMATIC": "of or like idioplasm, the part of the protoplasm bearing hereditary characteristics, also IDIOPLASMIC [adj]\n",
  "IDIOPLASMIC": "of or like idioplasm, the part of the protoplasm bearing hereditary characteristics, also IDIOPLASMATIC [adj]\n",
  "IDIOPLASMS": "IDIOPLASM, the part of the protoplasm bearing hereditary characteristics [n]\n",
  "IDIORHYTHMIC": "self-regulating; allowing each member to regulate his or her own life, also IDIORRHYTHMIC [adj]\n",
  "IDIORRHYTHMIC": "self-regulating; allowing each member to regulate his or her own life, also IDIORHYTHMIC [adj]\n",
  "IDIOSYNCRASIES": "IDIOSYNCRASY, a peculiarity of constitution or temperament [n]\n",
  "IDIOSYNCRASY": "a peculiarity of constitution or temperament [n IDIOSYNCRASIES]\n",
  "IDIOSYNCRATIC": "showing idiosyncrasy, also IDIOSYNCRATICAL [adj]\n",
  "IDIOSYNCRATICAL": "showing idiosyncrasy, also IDIOSYNCRATIC [adj]\n",
  "IDIOT": "a mentally deficient person [n -S]\n",
  "IDIOTCIES": "IDIOTCY, the state of being an idiot, also IDIOCY, IDIOTISM [n]\n",
  "IDIOTCY": "the state of being an idiot, also IDIOCY, IDIOTISM [n IDIOTCIES]\n",
  "IDIOTHERMOUS": "warm-blooded [adj]\n",
  "IDIOTIC": "relating to or like an idiot, also IDIOTICAL [adj IDIOTICALLY]\n",
  "IDIOTICAL": "relating to or like an idiot, also IDIOTIC [adj IDIOTICALLY]\n",
  "IDIOTICALLY": "IDIOTICAL, relating to or like an idiot, also IDIOTIC [adv]\n",
  "IDIOTICALNESS": "IDIOTICAL, relating to or like an idiot, also IDIOTIC [n]\n",
  "IDIOTICALNESSES": "IDIOTICALNESS, IDIOTICAL, relating to or like an idiot, also IDIOTIC [n]\n",
  "IDIOTICON": "a dialect dictionary [n -S]\n",
  "IDIOTICONS": "IDIOTICON, a dialect dictionary [n]\n",
  "IDIOTISH": "like an idiot [adj]\n",
  "IDIOTISM": "the state of being an idiot, also IDIOCY, IDIOTCY [n -S]\n",
  "IDIOTISMS": "IDIOTISM, the state of being an idiot, also IDIOCY, IDIOTCY [n]\n",
  "IDIOTS": "IDIOT, a mentally deficient person [n]\n",
  "IDIOTYPE": "the unique part of an antibody [n -S]\n",
  "IDIOTYPES": "IDIOTYPE, the unique part of an antibody [n]\n",
  "IDIOTYPIC": "of or like an idiotype, the unique part of an antibody [adj]\n",
  "IDLE": "inactive [adj IDLER, IDLEST, IDLY] / to be unoccupied [v IDLED, IDLING, IDLES]\n",
  "IDLED": "IDLE, to be unoccupied [v]\n",
  "IDLEHOOD": "(archaic) idleness [n -S]\n",
  "IDLEHOODS": "IDLEHOOD, (archaic) idleness [n]\n",
  "IDLENESS": "the state of being idle [n -ES]\n",
  "IDLENESSES": "IDLENESS, the state of being idle [n]\n",
  "IDLER": "one that idles [n -S]\n",
  "IDLERS": "IDLER, one that idles [n]\n",
  "IDLES": "IDLE, to be unoccupied [v]\n",
  "IDLESSE": "idleness [n -S]\n",
  "IDLESSES": "IDLESSE, idleness [n]\n",
  "IDLEST": "IDLE, inactive [adj]\n",
  "IDLING": "IDLE, to be unoccupied [v]\n",
  "IDLY": "IDLE, inactive [adv]\n",
  "IDOCRASE": "another name for the mineral vesuvianite [n -S]\n",
  "IDOCRASES": "IDOCRASE, another name for the mineral vesuvianite [n]\n",
  "IDOL": "an object of worship [n -S]\n",
  "IDOLA": "IDOLON, a mental image, a fallacy, also EIDOLON, IDOLUM [n]\n",
  "IDOLATER": "one that worships idols, also IDOLATOR [n -S]\n",
  "IDOLATERS": "IDOLATER, one that worships idols, also IDOLATOR [n]\n",
  "IDOLATOR": "one that worships idols, also IDOLATER [n -S]\n",
  "IDOLATORS": "IDOLATOR, one that worships idols, also IDOLATER [n]\n",
  "IDOLATRESS": "a female worshipper of idols [n -ES]\n",
  "IDOLATRESSES": "IDOLATRESS, a female worshipper of idols [n]\n",
  "IDOLATRIES": "IDOLATRY, the worship of idols [n]\n",
  "IDOLATRISE": "to worship as an idol, to adore, also IDOLATRIZE [v IDOLATRISED, IDOLATRISING, IDOLATRISES]\n",
  "IDOLATRISED": "IDOLATRISE, to worship as an idol, to adore, also IDOLATRIZE [v]\n",
  "IDOLATRISER": "one who commits idolatry, also IDOLATRIZER [n -S]\n",
  "IDOLATRISERS": "IDOLATRISER, one who commits idolatry, also IDOLATRIZER [n]\n",
  "IDOLATRISES": "IDOLATRISE, to worship as an idol, to adore, also IDOLATRIZE [v]\n",
  "IDOLATRISING": "IDOLATRISE, to worship as an idol, to adore, also IDOLATRIZE [v]\n",
  "IDOLATRIZE": "to worship idols; to pay idolatrous worship, also IDOLATRISE [v IDOLATRIZED, IDOLATRIZING, IDOLATRIZES]\n",
  "IDOLATRIZED": "IDOLATRIZE, to worship idols; to pay idolatrous worship, also IDOLATRISE [v]\n",
  "IDOLATRIZER": "one who commits idolatry, also IDOLATRISER [n -S]\n",
  "IDOLATRIZERS": "IDOLATRIZER, one who commits idolatry, also IDOLATRISER [n]\n",
  "IDOLATRIZES": "IDOLATRIZE, to worship idols; to pay idolatrous worship, also IDOLATRISE [v]\n",
  "IDOLATRIZING": "IDOLATRIZE, to worship idols; to pay idolatrous worship, also IDOLATRISE [v]\n",
  "IDOLATROUS": "of or pertaining to idolatry [adj IDOLATROUSLY]\n",
  "IDOLATROUSLY": "IDOLATROUS, of or pertaining to idolatry [adv]\n",
  "IDOLATROUSNESS": "IDOLATROUS, of or pertaining to idolatry [n]\n",
  "IDOLATRY": "the worship of idols [n IDOLATRIES]\n",
  "IDOLISATION": "the act of idolising, also IDOLIZATION [n -S]\n",
  "IDOLISATIONS": "IDOLISATION, the act of idolising, also IDOLIZATION [n]\n",
  "IDOLISE": "to worship, also IDOLIZE [v IDOLISED, IDOLISING, IDOLISES]\n",
  "IDOLISED": "IDOLISE, to worship, also IDOLIZE [v]\n",
  "IDOLISER": "one who idolises, also IDOLIZER [n -S]\n",
  "IDOLISERS": "IDOLISER, one who idolises, also IDOLIZER [n]\n",
  "IDOLISES": "IDOLISE, to worship, also IDOLIZE [v]\n",
  "IDOLISING": "IDOLISE, to worship, also IDOLIZE [v]\n",
  "IDOLISM": "worship of idols [n -S]\n",
  "IDOLISMS": "IDOLISM, worship of idols [n]\n",
  "IDOLIST": "someone who worships idols [n -S]\n",
  "IDOLISTS": "IDOLIST, someone who worships idols [n]\n",
  "IDOLIZATION": "the act of idolizing, also IDOLISATION [n -S]\n",
  "IDOLIZATIONS": "IDOLIZATION, the act of idolizing, also IDOLISATION [n]\n",
  "IDOLIZE": "to worship, also IDOLISE [v IDOLIZED, IDOLIZING, IDOLIZES]\n",
  "IDOLIZED": "IDOLIZE, to worship, also IDOLISE [v]\n",
  "IDOLIZER": "one who idolises, also IDOLISER [n -S]\n",
  "IDOLIZERS": "IDOLIZER, one who idolises, also IDOLISER [n]\n",
  "IDOLIZES": "IDOLIZE, to worship, also IDOLISE [v]\n",
  "IDOLIZING": "IDOLIZE, to worship, also IDOLISE [v]\n",
  "IDOLOCLAST": "a breaker of idols; an iconoclast [n -S]\n",
  "IDOLOCLASTS": "IDOLOCLAST, a breaker of idols; an iconoclast [n]\n",
  "IDOLON": "a mental image, a fallacy, also EIDOLON, IDOLUM [n IDOLA]\n",
  "IDOLS": "IDOL, an object of worship [n]\n",
  "IDOLUM": "(Latin) a mental image; a logical fallacy, also EIDOLON, IDOLON [n IDOLA]\n",
  "IDONEITIES": "IDONEITY, the state of being suitable [n]\n",
  "IDONEITY": "the state of being suitable [n IDONEITIES]\n",
  "IDONEOUS": "appropriate, suitable [adj]\n",
  "IDOXURIDINE": "a drug containing iodine used to treat viral infections of the eye [n -S]\n",
  "IDOXURIDINES": "IDOXURIDINE, a drug containing iodine used to treat viral infections of the eye [n]\n",
  "IDS": "ID, a fish of the carp family, aka silver orfe, also IDE [n]\n",
  "IDYL": "a description in verse of country life, also IDYLL [n -S]\n",
  "IDYLIST": "a writer of idyls, also IDYLLIST [n -S]\n",
  "IDYLISTS": "IDYLIST, a writer of idyls, also IDYLLIST [n]\n",
  "IDYLL": "a description in verse of country life, also IDYL [n -S]\n",
  "IDYLLIAN": "simple and happy, also IDYLLIC [adj]\n",
  "IDYLLIC": "of or like an idyll [adj IDYLLICALLY]\n",
  "IDYLLICALLY": "IDYLLIC, of or like an idyll [adv]\n",
  "IDYLLIST": "a writer of idyls, also IDYLIST [n -S]\n",
  "IDYLLISTS": "IDYLLIST, a writer of idyls, also IDYLIST [n]\n",
  "IDYLLS": "IDYLL, a description in verse of country life, also IDYL [n]\n",
  "IDYLS": "IDYL, a description in verse of country life, also IDYLL [n]\n",
  "IF": "a condition [n -S]\n",
  "IFF": "if and only if [conj]\n",
  "IFFIER": "IFFY, full of uncertainty [adj]\n",
  "IFFIEST": "IFFY, full of uncertainty [adj]\n",
  "IFFILY": "IFFY, full of uncertainty [adv]\n",
  "IFFINESS": "the state of being iffy [n -ES]\n",
  "IFFINESSES": "IFFINESS, the state of being iffy [n]\n",
  "IFFY": "full of uncertainty [adj IFFIER, IFFIEST, IFFILY]\n",
  "IFS": "IF, a condition [n]\n",
  "IFTAR": "(Arabic) a meal eaten by Muslims to break their fast after sunset during Ramadan [n -S]\n",
  "IFTARS": "IFTAR, (Arabic) a meal eaten by Muslims to break their fast after sunset during Ramadan [n]\n",
  "IGAD": "a mild oath, also EGAD, ECOD, EGADS [interj]\n",
  "IGAPO": "(Tupi) in Peru, a riverside forest periodically flooded, also GAPO [n -S]\n",
  "IGAPOS": "IGAPO, (Tupi) in Peru, a riverside forest periodically flooded, also GAPO [n]\n",
  "IGARAPE": "(Tupi) a canoe waterway in Brazil [n -S]\n",
  "IGARAPES": "IGARAPE, (Tupi) a canoe waterway in Brazil [n]\n",
  "IGG": "(slang) to ignore [v -ED, -ING, -S]\n",
  "IGGED": "IGG, (slang) to ignore [v]\n",
  "IGGING": "IGG, (slang) to ignore [v]\n",
  "IGGS": "IGG, (slang) to ignore [v]\n",
  "IGLOO": "(Inuit) a snow house, also IGLU [n -S]\n",
  "IGLOOS": "IGLOO, (Inuit) a snow house, also IGLU [n]\n",
  "IGLU": "(Inuit) a snow house, also IGLOO [n -S]\n",
  "IGLUS": "IGLU, (Inuit) a snow house, also IGLOO [n]\n",
  "IGNARO": "(archaic) an ignorant person [n -ES or -S]\n",
  "IGNAROES": "IGNARO, (archaic) an ignorant person [n]\n",
  "IGNAROS": "IGNARO, (archaic) an ignorant person [n]\n",
  "IGNATIA": "a medicinal seed [n -S]\n",
  "IGNATIAS": "IGNATIA, a medicinal seed [n]\n",
  "IGNEOUS": "of rock, formed by cooling and consolidation of magma [adj]\n",
  "IGNESCENT": "capable of emitting sparks [adj] / an ignescent substance [n -S]\n",
  "IGNESCENTS": "IGNESCENT, an ignescent substance [n]\n",
  "IGNIFIED": "IGNIFY, to burn [v]\n",
  "IGNIFIES": "IGNIFY, to burn [v]\n",
  "IGNIFY": "to burn [v IGNIFIED, IGNIFYING, IGNIFIES]\n",
  "IGNIFYING": "IGNIFY, to burn [v]\n",
  "IGNIMBRITE": "a hard rock formed by fusion of the volcanic fragments and dust of a nuee ardente [n -S]\n",
  "IGNIMBRITES": "IGNIMBRITE, a hard rock formed by fusion of the volcanic fragments and dust of a nuee ardente [n]\n",
  "IGNIPOTENT": "presiding over fire [adj]\n",
  "IGNITABILITIES": "IGNITABILITY, the state of being ignitable [n]\n",
  "IGNITABILITY": "the state of being ignitable [n IGNITABILITIES]\n",
  "IGNITABLE": "that can be ignited, also IGNITIBLE [adj]\n",
  "IGNITE": "to set on fire [v IGNITED, IGNITING, IGNITES]\n",
  "IGNITED": "IGNITE, to set on fire [v]\n",
  "IGNITER": "someone who or something that ignites, e.g. an apparatus for firing an explosive or explosive mixture, also IGNITOR [n -S]\n",
  "IGNITERS": "IGNITER, someone who or something that ignites, e.g. an apparatus for firing an explosive or explosive mixture, also IGNITOR [n]\n",
  "IGNITES": "IGNITE, to set on fire [v]\n",
  "IGNITIBILITIES": "IGNITIBILITY, the state of being ignitible [n]\n",
  "IGNITIBILITY": "the state of being ignitible [n IGNITIBILITIES]\n",
  "IGNITIBLE": "that can be ignited, also IGNITABLE [adj]\n",
  "IGNITING": "IGNITE, to set on fire [v]\n",
  "IGNITION": "the act of igniting [n -S]\n",
  "IGNITIONS": "IGNITION, the act of igniting [n]\n",
  "IGNITOR": "someone who or something that ignites, e.g. an apparatus for firing an explosive or explosive mixture, also IGNITER [n -S]\n",
  "IGNITORS": "IGNITOR, someone who or something that ignites, e.g. an apparatus for firing an explosive or explosive mixture, also IGNITER [n]\n",
  "IGNITRON": "a device for conducting current in which an electrode dips into a pool of mercury and draws up an arc to start ionization [n -S]\n",
  "IGNITRONS": "IGNITRON, a device for conducting current in which an electrode dips into a pool of mercury and draws up an arc to start ionization [n]\n",
  "IGNOBILITIES": "IGNOBILITY, the state of being ignoble [n]\n",
  "IGNOBILITY": "the state of being ignoble [n IGNOBILITIES]\n",
  "IGNOBLE": "not noble, unworthy [adj IGNOBLER, IGNOBLEST, IGNOBLY]\n",
  "IGNOBLENESS": "the state of being ignoble [n -ES]\n",
  "IGNOBLENESSES": "IGNOBLENESS, the state of being ignoble [n]\n",
  "IGNOBLER": "IGNOBLE, not noble, unworthy [adj]\n",
  "IGNOBLEST": "IGNOBLE, not noble, unworthy [adj]\n",
  "IGNOBLY": "IGNOBLE, not noble, unworthy [adv]\n",
  "IGNOMIES": "IGNOMY, (Shakespeare) deep personal humiliation and disgrace, also IGNOMINY [n]\n",
  "IGNOMINIES": "IGNOMINY, deep personal humiliation and disgrace, also IGNOMY [n]\n",
  "IGNOMINIOUS": "marked by disgrace or shame [adj IGNOMINIOUSLY]\n",
  "IGNOMINIOUSLY": "IGNOMINIOUS, marked by disgrace or shame [adv]\n",
  "IGNOMINIOUSNESS": "IGNOMINIOUS, marked by disgrace or shame [n]\n",
  "IGNOMINY": "deep personal humiliation and disgrace, also IGNOMY [n IGNOMINIES]\n",
  "IGNOMY": "(Shakespeare) deep personal humiliation and disgrace, also IGNOMINY [n IGNOMIES]\n",
  "IGNORABLE": "that can be ignored [adj]\n",
  "IGNORAMI": "IGNORAMUS, an ignorant person [n]\n",
  "IGNORAMUS": "an ignorant person [n IGNORAMUSES or (wrongly) IGNORAMI]\n",
  "IGNORAMUSES": "IGNORAMUS, an ignorant person [n]\n",
  "IGNORANCE": "lack of knowledge [n -S]\n",
  "IGNORANCES": "IGNORANCE, lack of knowledge [n]\n",
  "IGNORANT": "not knowing things [adj IGNORANTLY] / an ignorant person [n -S]\n",
  "IGNORANTLY": "IGNORANT, not knowing things [adv]\n",
  "IGNORANTNESS": "the state of being ignorant [n -ES]\n",
  "IGNORANTNESSES": "IGNORANTNESS, the state of being ignorant [n]\n",
  "IGNORANTS": "IGNORANT, an ignorant person [n]\n",
  "IGNORATION": "the act of ignoring [n -S]\n",
  "IGNORATIONS": "IGNORATION, the act of ignoring [n]\n",
  "IGNORE": "to intentionally disregard [v IGNORED, IGNORING, IGNORES]\n",
  "IGNORED": "IGNORE, to intentionally disregard [v]\n",
  "IGNORER": "one who ignores [n -S]\n",
  "IGNORERS": "IGNORER, one who ignores [n]\n",
  "IGNORES": "IGNORE, to intentionally disregard [v]\n",
  "IGNORING": "IGNORE, to intentionally disregard [v]\n",
  "IGUANA": "a large tropical lizard, also IGUANID [n -S]\n",
  "IGUANAS": "IGUANA, a large tropical lizard, also IGUANID [n]\n",
  "IGUANIAN": "resembling, or pertaining to, the iguana [adj] / an animal of the iguana family [n -S]\n",
  "IGUANIANS": "IGUANIAN, an animal of the iguana family [n]\n",
  "IGUANID": "any member of the iguana family [n -S]\n",
  "IGUANIDS": "IGUANID, any member of the iguana family [n]\n",
  "IGUANODON": "a genus of gigantic herbivorous dinosaurs having a birdlike pelvis and large hind legs [n -S]\n",
  "IGUANODONS": "IGUANODON, a genus of gigantic herbivorous dinosaurs having a birdlike pelvis and large hind legs [n]\n",
  "IHRAM": "(Arabic) the white cotton garment worn by Muslim pilgrims to Mecca [n -S]\n",
  "IHRAMS": "IHRAM, (Arabic) the white cotton garment worn by Muslim pilgrims to Mecca [n]\n",
  "IJTIHAD": "(Arabic) the use of reasoning in Islamic law [n -S]\n",
  "IJTIHADS": "IJTIHAD, (Arabic) the use of reasoning in Islamic law [n]\n",
  "IKAN": "(Malay) fish esp. in names of cooked dishes e.g. assam ikan [n -S]\n",
  "IKANS": "IKAN, (Malay) fish esp. in names of cooked dishes e.g. assam ikan [n]\n",
  "IKAT": "(Malay) a technique of dyeing yarn and tying it, thus giving geometric patterns [n -S]\n",
  "IKATS": "IKAT, (Malay) a technique of dyeing yarn and tying it, thus giving geometric patterns [n]\n",
  "IKEBANA": "(Japanese) the art of formal flower arrangement [n -S]\n",
  "IKEBANAS": "IKEBANA, (Japanese) the art of formal flower arrangement [n]\n",
  "IKON": "a religious carving of a saint etc., also EIKON, ICON [n -S]\n",
  "IKONS": "IKON, a religious carving of a saint etc., also EIKON, ICON [n]\n",
  "ILEA": "ILEUM, (Latin) a part of the small intestine [n]\n",
  "ILEAC": "pertaining to the ileum, the lowest part of the small intestine. also ILEAL [adj]\n",
  "ILEAL": "pertaining to the ileum, the lowest part of the small intestine, also ILEAC [adj]\n",
  "ILEITIDES": "ILEITIS, inflammation of the ileum [n]\n",
  "ILEITIS": "inflammation of the ileum [n ILEITISES or ILEITIDES]\n",
  "ILEITISES": "ILEITIS, inflammation of the ileum [n]\n",
  "ILEOSTOMIES": "ILEOSTOMY, removal of the ileum, the anterior or superior bone of the pelvis [n]\n",
  "ILEOSTOMY": "removal of the ileum, the anterior or superior bone of the pelvis [n ILEOSTOMIES]\n",
  "ILEUM": "(Latin) a part of the small intestine [n ILEA]\n",
  "ILEUS": "(Latin) an intestinal obstruction [n -ES]\n",
  "ILEUSES": "ILEUS, (Latin) an intestinal obstruction [n]\n",
  "ILEX": "(Latin) a tree or shrub of the holly family; the holm oak [n ILEXES or ILICES]\n",
  "ILEXES": "ILEX, (Latin) a tree or shrub of the holly family; the holm oak [n]\n",
  "ILIA": "ILIUM, (Latin) the anterior or superior bone of the pelvis [n]\n",
  "ILIAC": "pertaining to the ilium, the anterior or superior bone of the pelvis, also ILIAL [adj]\n",
  "ILIACI": "ILIACUS, (Latin) the flexor muscle of the thigh [n]\n",
  "ILIACUS": "(Latin) the flexor muscle of the thigh [n ILIACI or ILIACUSES]\n",
  "ILIACUSES": "ILIACUS, (Latin) the flexor muscle of the thigh [n]\n",
  "ILIAD": "a long poem [n -S]\n",
  "ILIADS": "ILIAD, a long poem [n]\n",
  "ILIAL": "pertaining to the ilium, the anterior or superior bone of the pelvis, also ILIAC [adj]\n",
  "ILICES": "ILEX, (Latin) a tree or shrub of the holly family; the holm oak [n]\n",
  "ILIUM": "(Latin) the anterior or superior bone of the pelvis [n ILIA]\n",
  "ILK": "a type or kind, also YLKE [n -S]\n",
  "ILKA": "(Scots) every [adj]\n",
  "ILKADAY": "every day [n -S]\n",
  "ILKADAYS": "every day, every day but Sunday, also ILKADAY [adv]\n",
  "ILKS": "ILK, a type or kind, also YLKE [n]\n",
  "ILL": "unwell [adj ILLER, ILLEST, ILLY] / harm, misfortune [n -S]\n",
  "ILLAPSE": "to glide in [v ILLAPSED, ILLAPSING, ILLAPSES]\n",
  "ILLAPSED": "ILLAPSE, to glide in [v]\n",
  "ILLAPSES": "ILLAPSE, to glide in [v]\n",
  "ILLAPSING": "ILLAPSE, to glide in [v]\n",
  "ILLAQUEABLE": "capable of being ensnared [adj]\n",
  "ILLAQUEATE": "to ensnare [v ILLAQUEATED, ILLAQUEATING, ILLAQUEATES]\n",
  "ILLAQUEATED": "ILLAQUEATE, to ensnare [v]\n",
  "ILLAQUEATES": "ILLAQUEATE, to ensnare [v]\n",
  "ILLAQUEATING": "ILLAQUEATE, to ensnare [v]\n",
  "ILLAQUEATION": "the act of ensnaring [n -S]\n",
  "ILLAQUEATIONS": "ILLAQUEATION, the act of ensnaring [n]\n",
  "ILLATION": "the act of inferring from premises [n -S]\n",
  "ILLATIONS": "ILLATION, the act of inferring from premises [n]\n",
  "ILLATIVE": "indicating movement into or toward [adj ILLATIVELY] / a grammatical case indicating movement into or toward [n -S]\n",
  "ILLATIVELY": "ILLATIVE, indicating movement into or toward [adv]\n",
  "ILLATIVES": "ILLATIVE, a grammatical case indicating movement into or toward [n]\n",
  "ILLAUDABLE": "not praiseworthy [adj ILLAUDABLY]\n",
  "ILLAUDABLY": "ILLAUDABLE, not praiseworthy [adv]\n",
  "ILLAWARRA": "a breed of shorthorn dairy cattle [n -S]\n",
  "ILLAWARRAS": "ILLAWARRA, a breed of shorthorn dairy cattle [n]\n",
  "ILLEGAL": "not legal [adj ILLEGALLY] / a person who enters a country without authorization [n -S]\n",
  "ILLEGALISATION": "the process of illegalising, also ILLEGALIZATION [n -S]\n",
  "ILLEGALISATIONS": "ILLEGALISATION, the process of illegalising, also ILLEGALIZATION [n]\n",
  "ILLEGALISE": "to make or declare illegal, also ILLEGALIZE [v ILLEGALISED, ILLEGALISING, ILLEGALISES]\n",
  "ILLEGALISED": "ILLEGALISE, to make or declare illegal, also ILLEGALIZE [v]\n",
  "ILLEGALISES": "ILLEGALISE, to make or declare illegal, also ILLEGALIZE [v]\n",
  "ILLEGALISING": "ILLEGALISE, to make or declare illegal, also ILLEGALIZE [v]\n",
  "ILLEGALITIES": "ILLEGALITY, the state of being illegal [n]\n",
  "ILLEGALITY": "the state of being illegal [n ILLEGALITIES]\n",
  "ILLEGALIZATION": "the process of illegalizing, also ILLEGALISATION [n -S]\n",
  "ILLEGALIZATIONS": "ILLEGALIZATION, the process of illegalizing, also ILLEGALISATION [n]\n",
  "ILLEGALIZE": "to make or declare illegal, also ILLEGALISE [v ILLEGALIZED, ILLEGALIZING, ILLEGALIZES]\n",
  "ILLEGALIZED": "ILLEGALIZE, to make or declare illegal, also ILLEGALISE [v]\n",
  "ILLEGALIZES": "ILLEGALIZE, to make or declare illegal, also ILLEGALISE [v]\n",
  "ILLEGALIZING": "ILLEGALIZE, to make or declare illegal, also ILLEGALISE [v]\n",
  "ILLEGALLY": "ILLEGAL, not legal [adv]\n",
  "ILLEGALS": "ILLEGAL, a person who enters a country without authorization [n]\n",
  "ILLEGIBILITIES": "ILLEGIBILITY, the state of being illegible [n]\n",
  "ILLEGIBILITY": "the state of being illegible [n ILLEGIBILITIES]\n",
  "ILLEGIBLE": "not legible [adj ILLEGIBLY]\n",
  "ILLEGIBLENESS": "ILLEGIBLE, not legible [n]\n",
  "ILLEGIBLENESSES": "ILLEGIBLENESS, ILLEGIBLE, not legible [n]\n",
  "ILLEGIBLY": "ILLEGIBLE, not legible [adv]\n",
  "ILLEGITIMACIES": "ILLEGITIMACY, the state of being illegitimate [n]\n",
  "ILLEGITIMACY": "the state of being illegitimate [n ILLEGITIMACIES]\n",
  "ILLEGITIMATE": "not recognized as lawful offspring [adj ILLEGITIMATELY] / to pronounce illegitimate [v ILLEGITIMATED, ILLEGITIMATING, ILLEGITIMATES]\n",
  "ILLEGITIMATED": "ILLEGITIMATE, to pronounce illegitimate [v]\n",
  "ILLEGITIMATELY": "ILLEGITIMATE, not recognized as lawful offspring [adv]\n",
  "ILLEGITIMATES": "ILLEGITIMATE, to pronounce illegitimate [v]\n",
  "ILLEGITIMATING": "ILLEGITIMATE, to pronounce illegitimate [v]\n",
  "ILLEGITIMATION": "the process of making illegitimate [n -S]\n",
  "ILLEGITIMATIONS": "ILLEGITIMATION, the process of making illegitimate [n]\n",
  "ILLER": "ILL, unwell [adj]\n",
  "ILLEST": "ILL, unwell [adj]\n",
  "ILLIAD": "(Shakespeare) an amorous glance, also OEILLADE, ELIAD, EYELIAD, EYLIAD [n -S]\n",
  "ILLIADS": "ILLIAD, (Shakespeare) an amorous glance, also OEILLADE, ELIAD, EYELIAD, EYLIAD [n]\n",
  "ILLIBERAL": "narrow-minded, intolerant or prejudiced [adj ILLIBERALLY]\n",
  "ILLIBERALISE": "to render illiberal, also ILLIBERALIZE [v ILLIBERALISED, ILLIBERALISING, ILLIBERALISES]\n",
  "ILLIBERALISED": "ILLIBERALISE, to render illiberal, also ILLIBERALIZE [v]\n",
  "ILLIBERALISES": "ILLIBERALISE, to render illiberal, also ILLIBERALIZE [v]\n",
  "ILLIBERALISING": "ILLIBERALISE, to render illiberal, also ILLIBERALIZE [v]\n",
  "ILLIBERALISM": "opposition to or lack of liberalism [n -S]\n",
  "ILLIBERALISMS": "ILLIBERALISM, opposition to or lack of liberalism [n]\n",
  "ILLIBERALITIES": "ILLIBERALITY, the state of being illiberal [n]\n",
  "ILLIBERALITY": "the state of being illiberal [n ILLIBERALITIES]\n",
  "ILLIBERALIZE": "to render illiberal, also ILLIBERALISE [v ILLIBERALIZED, ILLIBERALIZING, ILLIBERALIZES]\n",
  "ILLIBERALIZED": "ILLIBERALIZE, to render illiberal, also ILLIBERALISE [v]\n",
  "ILLIBERALIZES": "ILLIBERALIZE, to render illiberal, also ILLIBERALISE [v]\n",
  "ILLIBERALIZING": "ILLIBERALIZE, to render illiberal, also ILLIBERALISE [v]\n",
  "ILLIBERALLY": "ILLIBERAL, narrow-minded, intolerant or prejudiced [adv]\n",
  "ILLIBERALNESS": "the state of being illiberal [n -ES]\n",
  "ILLIBERALNESSES": "ILLIBERALNESS, the state of being illiberal [n]\n",
  "ILLICIT": "unlawful, forbidden [adj ILLICITLY]\n",
  "ILLICITLY": "ILLICIT, unlawful, forbidden [adv]\n",
  "ILLICITNESS": "the state of being illicit [n -ES]\n",
  "ILLICITNESSES": "ILLICITNESS, the state of being illicit [n]\n",
  "ILLIMITABILITY": "the state of being illimitable [n]\n",
  "ILLIMITABLE": "limitless, infinite [adj ILLIMITABLY]\n",
  "ILLIMITABLENESS": "ILLIMITABLE, limitless, infinite [n]\n",
  "ILLIMITABLY": "ILLIMITABLE, limitless, infinite [adv]\n",
  "ILLIMITATION": "the state of being illimitable [n -S]\n",
  "ILLIMITATIONS": "ILLIMITATION, the state of being illimitable [n]\n",
  "ILLIMITED": "not limited; interminable [adj]\n",
  "ILLINIUM": "a former name for the element promethium [n -S]\n",
  "ILLINIUMS": "ILLINIUM, a former name for the element promethium [n]\n",
  "ILLIPE": "(Tamil) the mahwa tree, also ILLUPI [n -S]\n",
  "ILLIPES": "ILLIPE, (Tamil) the mahwa tree, also ILLUPI [n]\n",
  "ILLIQUATION": "the melting of one thing into another [n -S]\n",
  "ILLIQUATIONS": "ILLIQUATION, the melting of one thing into another [n]\n",
  "ILLIQUID": "of assets etc. not easily converted into cash [adj]\n",
  "ILLIQUIDITIES": "ILLIQUIDITY, the state of being illiquid [n]\n",
  "ILLIQUIDITY": "the state of being illiquid [n ILLIQUIDITIES]\n",
  "ILLISION": "the act of striking against something [n -S]\n",
  "ILLISIONS": "ILLISION, the act of striking against something [n]\n",
  "ILLITE": "a white or pale clay mineral found in shales or sediments [n -S]\n",
  "ILLITERACIES": "ILLITERACY, the state of being illiterate [n]\n",
  "ILLITERACY": "the state of being illiterate [n ILLITERACIES]\n",
  "ILLITERATE": "having little or no education [adj ILLITERATELY] / one with little or no education [n -S]\n",
  "ILLITERATELY": "ILLITERATE, having little or no education [adv]\n",
  "ILLITERATENESS": "ILLITERATE, having little or no education [n]\n",
  "ILLITERATES": "ILLITERATE, one with little or no education [n]\n",
  "ILLITES": "ILLITE, a white or pale clay mineral found in shales or sediments [n]\n",
  "ILLITIC": "of or like illite, a clay mineral [adj]\n",
  "ILLNESS": "sickness [n -ES]\n",
  "ILLNESSES": "ILLNESS, sickness [n]\n",
  "ILLOCUTION": "an act which is performed by a speaker actually speaking the words, as an order or a promise [n -S]\n",
  "ILLOCUTIONARY": "pertaining to illocution, an act which is performed by a speaker actually speaking the words [adj]\n",
  "ILLOCUTIONS": "ILLOCUTION, an act which is performed by a speaker actually speaking the words, as an order or a promise [n]\n",
  "ILLOGIC": "the absence of logic [n -S]\n",
  "ILLOGICAL": "not logical, also UNLOGICAL [adj ILLOGICALLY]\n",
  "ILLOGICALITIES": "ILLOGICALITY, the state of being illogical [n]\n",
  "ILLOGICALITY": "the state of being illogical [n ILLOGICALITIES]\n",
  "ILLOGICALLY": "ILLOGICAL, not logical, also UNLOGICAL [adv]\n",
  "ILLOGICALNESS": "ILLOGICAL, not logical, also UNLOGICAL [n]\n",
  "ILLOGICALNESSES": "ILLOGICALNESS, ILLOGICAL, not logical, also UNLOGICAL [n]\n",
  "ILLOGICS": "ILLOGIC, the absence of logic [n]\n",
  "ILLS": "ILL, harm, misfortune [n]\n",
  "ILLTH": "the contrary of wealth or wellbeing [n -S]\n",
  "ILLTHS": "ILLTH, the contrary of wealth or wellbeing [n]\n",
  "ILLUDE": "to trick [v ILLUDED, ILLUDING, ILLUDES]\n",
  "ILLUDED": "ILLUDE, to trick [v]\n",
  "ILLUDES": "ILLUDE, to trick [v]\n",
  "ILLUDING": "ILLUDE, to trick [v]\n",
  "ILLUME": "to light up [v ILLUMED, ILLUMING, ILLUMES]\n",
  "ILLUMED": "ILLUME, to light up [v]\n",
  "ILLUMES": "ILLUME, to light up [v]\n",
  "ILLUMINABLE": "capable of being illuminated [adj]\n",
  "ILLUMINANCE": "the act of illuminating [n -S]\n",
  "ILLUMINANCES": "ILLUMINANCE, the act of illuminating [n]\n",
  "ILLUMINANT": "that which illuminates or affords light; as, gas and petroleum are illuminants [n -S]\n",
  "ILLUMINANTS": "ILLUMINANT, that which illuminates or affords light; as, gas and petroleum are illuminants [n]\n",
  "ILLUMINATE": "to enlighten spiritually or intellectually [v ILLUMINATED, ILLUMINATING, ILLUMINATES]\n",
  "ILLUMINATED": "ILLUMINATE, to enlighten spiritually or intellectually [v]\n",
  "ILLUMINATES": "ILLUMINATE, to enlighten spiritually or intellectually [v]\n",
  "ILLUMINATI": "ILLUMINATO, a member of any of various sects or societies claiming special enlightenment [n]\n",
  "ILLUMINATING": "ILLUMINATE, to enlighten spiritually or intellectually [v]\n",
  "ILLUMINATINGLY": "ILLUMINATING, ILLUMINATE, to enlighten spiritually or intellectually [adv]\n",
  "ILLUMINATION": "spiritual or intellectual enlightenment [n -S]\n",
  "ILLUMINATIONAL": "providing illumination [adj]\n",
  "ILLUMINATIONS": "ILLUMINATION, spiritual or intellectual enlightenment [n]\n",
  "ILLUMINATIVE": "of, relating to, or producing illumination [adj]\n",
  "ILLUMINATO": "a member of any of various sects or societies claiming special enlightenment [n ILLUMINATI]\n",
  "ILLUMINATOR": "one who illuminates [n -S]\n",
  "ILLUMINATORS": "ILLUMINATOR, one who illuminates [n]\n",
  "ILLUMINE": "to throw light upon, also ENLUMINE [v ILLUMINED, ILLUMINING, ILLUMINES]\n",
  "ILLUMINED": "ILLUMINE, to throw light upon, also ENLUMINE [v]\n",
  "ILLUMINER": "one who illumines [n -S]\n",
  "ILLUMINERS": "ILLUMINER, one who illumines [n]\n",
  "ILLUMINES": "ILLUMINE, to throw light upon, also ENLUMINE [v]\n",
  "ILLUMING": "ILLUME, to light up [v]\n",
  "ILLUMINING": "ILLUMINE, to throw light upon, also ENLUMINE [v]\n",
  "ILLUMINISM": "a belief in an inward spiritual light [n -S]\n",
  "ILLUMINISMS": "ILLUMINISM, a belief in an inward spiritual light [n]\n",
  "ILLUMINIST": "a believer in illuminism, a belief in an inward spiritual light [n -S]\n",
  "ILLUMINISTS": "ILLUMINIST, a believer in illuminism, a belief in an inward spiritual light [n]\n",
  "ILLUPI": "(Tamil) the mahwa tree, also ILLIPE [n -S]\n",
  "ILLUPIS": "ILLUPI, (Tamil) the mahwa tree, also ILLIPE [n]\n",
  "ILLUSION": "a false perception [n -S]\n",
  "ILLUSIONAL": "of or like an illusion [adj]\n",
  "ILLUSIONARY": "having the nature of an illusion [adj]\n",
  "ILLUSIONED": "under an illusion [adj]\n",
  "ILLUSIONISM": "the doctrine that the external world is illusory [n -S]\n",
  "ILLUSIONISMS": "ILLUSIONISM, the doctrine that the external world is illusory [n]\n",
  "ILLUSIONIST": "a person who produces illusory effects [n -S]\n",
  "ILLUSIONISTIC": "relating to illusionism, the doctrine that the external world is illusory [adj]\n",
  "ILLUSIONISTS": "ILLUSIONIST, a person who produces illusory effects [n]\n",
  "ILLUSIONS": "ILLUSION, a false perception [n]\n",
  "ILLUSIVE": "based on illusion, also ILLUSORY [adj ILLUSIVELY]\n",
  "ILLUSIVELY": "ILLUSIVE, based on illusion, also ILLUSORY [adv]\n",
  "ILLUSIVENESS": "the state of being illusive [n -ES]\n",
  "ILLUSIVENESSES": "ILLUSIVENESS, the state of being illusive [n]\n",
  "ILLUSORILY": "ILLUSORY, based on illusion, also ILLUSIVE [adv]\n",
  "ILLUSORINESS": "the state of being illusory [n -ES]\n",
  "ILLUSORINESSES": "ILLUSORINESS, the state of being illusory [n]\n",
  "ILLUSORY": "based on illusion, also ILLUSIVE [adj]\n",
  "ILLUSTRATABLE": "capable of being illustrated [adj]\n",
  "ILLUSTRATE": "to elucidate and amplify by pictures [v ILLUSTRATED, ILLUSTRATING, ILLUSTRATES]\n",
  "ILLUSTRATED": "an illustrated magazine [n -S]\n",
  "ILLUSTRATEDS": "ILLUSTRATED, an illustrated magazine [n]\n",
  "ILLUSTRATES": "ILLUSTRATE, to elucidate and amplify by pictures [v]\n",
  "ILLUSTRATING": "ILLUSTRATE, to elucidate and amplify by pictures [v]\n",
  "ILLUSTRATION": "an example or instance that helps make something clear [n -S]\n",
  "ILLUSTRATIONAL": "relating to illustration [adj]\n",
  "ILLUSTRATIONS": "ILLUSTRATION, an example or instance that helps make something clear [n]\n",
  "ILLUSTRATIVE": "serving to illustrate [adj ILLUSTRATIVELY]\n",
  "ILLUSTRATIVELY": "ILLUSTRATIVE, serving to illustrate [adv]\n",
  "ILLUSTRATOR": "one who illustrates [n -S]\n",
  "ILLUSTRATORS": "ILLUSTRATOR, one who illustrates [n]\n",
  "ILLUSTRATORY": "serving to illustrate [adj]\n",
  "ILLUSTRIOUS": "notably or brilliantly outstanding because of dignity or achievements or actions [adj ILLUSTRIOUSLY]\n",
  "ILLUSTRIOUSLY": "ILLUSTRIOUS, notably or brilliantly outstanding because of dignity or achievements or actions [adv]\n",
  "ILLUSTRIOUSNESS": "the state of being illustrious [n]\n",
  "ILLUSTRISSIMO": "(Italian) most illustrious, esp. as belonging to the Italian aristocracy [adj]\n",
  "ILLUVIA": "ILLUVIUM, material removed from the soil layer by rainwater and deposited in a lower layer [n]\n",
  "ILLUVIAL": "relating to illuvium, material removed from soil layer by rainwater and deposited in lower layer [adj]\n",
  "ILLUVIATE": "to deposit illuvium, material removed from soil layer by rainwater and deposited in lower layer [v ILLUVIATED, ILLUVIATING, ILLUVIATES]\n",
  "ILLUVIATED": "ILLUVIATE, to deposit illuvium, material removed from soil layer by rainwater and deposited in lower layer [v]\n",
  "ILLUVIATES": "ILLUVIATE, to deposit illuvium, material removed from soil layer by rainwater and deposited in lower layer [v]\n",
  "ILLUVIATING": "ILLUVIATE, to deposit illuvium, material removed from soil layer by rainwater and deposited in lower layer [v]\n",
  "ILLUVIATION": "the accumulation of illuvium [n -S]\n",
  "ILLUVIATIONS": "ILLUVIATION, the accumulation of illuvium [n]\n",
  "ILLUVIUM": "material removed from the soil layer by rainwater and deposited in a lower layer [n ILLUVIUMS or ILLUVIA]\n",
  "ILLUVIUMS": "ILLUVIUM, material removed from the soil layer by rainwater and deposited in a lower layer [n]\n",
  "ILLY": "ill [adv]\n",
  "ILMENITE": "a brownish-black titanium ore [n -S]\n",
  "ILMENITES": "ILMENITE, a brownish-black titanium ore [n]\n",
  "IMAGE": "to form a likeness of mentally [v IMAGED, IMAGING, IMAGES]\n",
  "IMAGEABLE": "that may be imaged [adj]\n",
  "IMAGED": "IMAGE, to form a likeness of mentally [v]\n",
  "IMAGELESS": "having no image [adj]\n",
  "IMAGER": "one that images [n -S]\n",
  "IMAGERIES": "IMAGERY, a mental picture [n]\n",
  "IMAGERS": "IMAGER, one that images [n]\n",
  "IMAGERY": "a mental picture [n IMAGERIES]\n",
  "IMAGES": "IMAGE, to form a likeness of mentally [v]\n",
  "IMAGINABLE": "that can be imagined [adj IMAGINABLY]\n",
  "IMAGINABLENESS": "IMAGINABLE, that can be imagined [n]\n",
  "IMAGINABLY": "IMAGINABLE, that can be imagined [adv]\n",
  "IMAGINAL": "characterized by imagination; imaginative [adj]\n",
  "IMAGINARIES": "IMAGINARY, an imaginary quantity or expression [n]\n",
  "IMAGINARILY": "IMAGINARY, imagined [adv]\n",
  "IMAGINARINESS": "the state of being imaginary [n -ES]\n",
  "IMAGINARINESSES": "IMAGINARINESS, the state of being imaginary [n]\n",
  "IMAGINARY": "imagined [adj IMAGINARILY] / an imaginary quantity or expression [n IMAGINARIES]\n",
  "IMAGINATION": "the act of imagining [n -S]\n",
  "IMAGINATIONAL": "relating to the imagination [adj]\n",
  "IMAGINATIONS": "IMAGINATION, the act of imagining [n]\n",
  "IMAGINATIVE": "characterized by imagination [adj IMAGINATIVELY]\n",
  "IMAGINATIVELY": "IMAGINATIVE, characterized by imagination [adv]\n",
  "IMAGINATIVENESS": "IMAGINATIVE, characterized by imagination [n]\n",
  "IMAGINE": "to form a mental picture of [v IMAGINED, IMAGINING, IMAGINES]\n",
  "IMAGINED": "IMAGINE, to form a mental picture of [v]\n",
  "IMAGINEER": "to design and create something new and imaginative [v -ED, -ING, -S]\n",
  "IMAGINEERED": "IMAGINEER, to design and create something new and imaginative [v]\n",
  "IMAGINEERING": "IMAGINEER, to design and create something new and imaginative [v]\n",
  "IMAGINEERS": "IMAGINEER, to design and create something new and imaginative [v]\n",
  "IMAGINER": "one who imagines [n -S]\n",
  "IMAGINERS": "IMAGINER, one who imagines [n]\n",
  "IMAGINES": "IMAGINE, to form a mental picture of [v]\n",
  "IMAGING": "the process of producing an image [n -S]\n",
  "IMAGINGS": "IMAGING, the process of producing an image [n]\n",
  "IMAGINING": "the act of imagining [n -S]\n",
  "IMAGININGS": "IMAGINING, the act of imagining [n]\n",
  "IMAGINIST": "a person with an active imagination [n -S]\n",
  "IMAGINISTS": "IMAGINIST, a person with an active imagination [n]\n",
  "IMAGISM": "a twentieth century school of poetry [n -S]\n",
  "IMAGISMS": "IMAGISM, a twentieth century school of poetry [n]\n",
  "IMAGIST": "a member of a group of early twentieth century poets who, in revolt against romanticism, sought clarity of expression through the use of precise images [n -S]\n",
  "IMAGISTIC": "relating to imagism, the artistic doctrine of the use of precise images with unrestricted subject matter [adj IMAGISTICALLY]\n",
  "IMAGISTICALLY": "IMAGISTIC, relating to imagism, the artistic doctrine of the use of precise images with unrestricted subject matter [adv]\n",
  "IMAGISTS": "IMAGIST, a member of a group of early twentieth century poets who, in revolt against romanticism, sought clarity of expression through the use of precise images [n]\n",
  "IMAGO": "(Latin) an insect in its final, adult, sexually mature, and typically winged state [n IMAGOS, IMAGOES or IMAGINES]\n",
  "IMAGOES": "IMAGO, (Latin) an insect in its final, adult, sexually mature, and typically winged state [n]\n",
  "IMAGOS": "IMAGO, (Latin) an insect in its final, adult, sexually mature, and typically winged state [n]\n",
  "IMAM": "(Arabic) the officer who leads the devotions in a mosque, also IMAUM [n -S]\n",
  "IMAMATE": "(Arabic) the office of an imam [n -S]\n",
  "IMAMATES": "IMAMATE, (Arabic) the office of an imam [n]\n",
  "IMAMS": "IMAM, (Arabic) the officer who leads the devotions in a mosque, also IMAUM [n]\n",
  "IMARET": "(Turkish) a lodging house for Mohammedan pilgrims [n -S]\n",
  "IMARETS": "IMARET, (Turkish) a lodging house for Mohammedan pilgrims [n]\n",
  "IMARI": "(Japanese) a type of porcelain, richly decorated in red green and blue [n -S]\n",
  "IMARIS": "IMARI, (Japanese) a type of porcelain, richly decorated in red green and blue [n]\n",
  "IMAUM": "(Arabic) the officer who leads the devotions in a mosque, also IMAM [n -S]\n",
  "IMAUMS": "IMAUM, (Arabic) the officer who leads the devotions in a mosque, also IMAM [n]\n",
  "IMBALANCE": "lack of balance [n -S]\n",
  "IMBALANCED": "in a state of imbalance [adj]\n",
  "IMBALANCES": "IMBALANCE, lack of balance [n]\n",
  "IMBALM": "to impregnate with balm or perfume e.g. to preserve a dead body, also EMBALM [v -ED, -ING, -S]\n",
  "IMBALMED": "IMBALM, to impregnate with balm or perfume e.g. to preserve a dead body, also EMBALM [v]\n",
  "IMBALMER": "one who imbalms, also EMBALMER [n -S]\n",
  "IMBALMERS": "IMBALMER, one who imbalms, also EMBALMER [n]\n",
  "IMBALMING": "IMBALM, to impregnate with balm or perfume e.g. to preserve a dead body, also EMBALM [v]\n",
  "IMBALMS": "IMBALM, to impregnate with balm or perfume e.g. to preserve a dead body, also EMBALM [v]\n",
  "IMBAR": "(obsolete) to bar in; to secure, also EMBAR [v IMBARRED, IMBARRING, IMBARS]\n",
  "IMBARK": "to enclose in bark [v -ED, -ING, -S]\n",
  "IMBARKED": "IMBARK, to enclose in bark [v]\n",
  "IMBARKING": "IMBARK, to enclose in bark [v]\n",
  "IMBARKS": "IMBARK, to enclose in bark [v]\n",
  "IMBARRED": "IMBAR, (obsolete) to bar in; to secure, also EMBAR [v]\n",
  "IMBARRING": "IMBAR, (obsolete) to bar in; to secure, also EMBAR [v]\n",
  "IMBARS": "IMBAR, (obsolete) to bar in; to secure, also EMBAR [v]\n",
  "IMBASE": "to lower, debase, also EMBASE, EMBACE [v IMBASED, IMBASING, IMBASES]\n",
  "IMBASED": "IMBASE, to lower, debase, also EMBASE, EMBACE [v]\n",
  "IMBASES": "IMBASE, to lower, debase, also EMBASE, EMBACE [v]\n",
  "IMBASING": "IMBASE, to lower, debase, also EMBASE, EMBACE [v]\n",
  "IMBATHE": "(archaic) to bathe, also EMBATHE [v IMBATHED, IMBATHING, IMBATHES]\n",
  "IMBATHED": "IMBATHE, (archaic) to bathe, also EMBATHE [v]\n",
  "IMBATHES": "IMBATHE, (archaic) to bathe, also EMBATHE [v]\n",
  "IMBATHING": "IMBATHE, (archaic) to bathe, also EMBATHE [v]\n",
  "IMBECILE": "feebleminded [adj IMBECILELY] / a mentally deficient person [n -S]\n",
  "IMBECILELY": "IMBECILE, feebleminded [adv]\n",
  "IMBECILES": "IMBECILE, a mentally deficient person [n]\n",
  "IMBECILIC": "like an imbecile [adj IMBECILICALLY]\n",
  "IMBECILICALLY": "IMBECILIC, like an imbecile [adv]\n",
  "IMBECILITIES": "IMBECILITY, the state of being an imbecile [n]\n",
  "IMBECILITY": "the state of being an imbecile [n IMBECILITIES]\n",
  "IMBED": "to plant firmly, also EMBED [v IMBEDDED, IMBEDDING, IMBEDS]\n",
  "IMBEDDED": "IMBED, to plant firmly, also EMBED [v]\n",
  "IMBEDDING": "IMBED, to plant firmly, also EMBED [v]\n",
  "IMBEDS": "IMBED, to plant firmly, also EMBED [v]\n",
  "IMBIBE": "to drink [v IMBIBED, IMBIBING, IMBIBES]\n",
  "IMBIBED": "IMBIBE, to drink [v]\n",
  "IMBIBER": "one that imbibes [n -S]\n",
  "IMBIBERS": "IMBIBER, one that imbibes [n]\n",
  "IMBIBES": "IMBIBE, to drink [v]\n",
  "IMBIBING": "IMBIBE, to drink [v]\n",
  "IMBIBITION": "the absorption of a liquid by a solid or a gel; the uptake of water by germinating seeds [n -S]\n",
  "IMBIBITIONAL": "relating to imbibition, the absorption of a liquid by a solid or a gel; the uptake of water by germinating seeds [adj]\n",
  "IMBIBITIONS": "IMBIBITION, the absorption of a liquid by a solid or a gel; the uptake of water by germinating seeds [n]\n",
  "IMBITTER": "to make bitter, also EMBITTER [v -ED, -ING, -S]\n",
  "IMBITTERED": "IMBITTER, to make bitter, also EMBITTER [v]\n",
  "IMBITTERING": "IMBITTER, to make bitter, also EMBITTER [v]\n",
  "IMBITTERS": "IMBITTER, to make bitter, also EMBITTER [v]\n",
  "IMBIZO": "(Zulu) a gathering of people at the request of a chieftain [n -S]\n",
  "IMBIZOS": "IMBIZO, (Zulu) a gathering of people at the request of a chieftain [n]\n",
  "IMBLAZE": "to adorn with glittering embellishments, also EMBLAZE [v IMBLAZED, IMBLAZING, IMBLAZES]\n",
  "IMBLAZED": "IMBLAZE, to adorn with glittering embellishments, also EMBLAZE [v]\n",
  "IMBLAZES": "IMBLAZE, to adorn with glittering embellishments, also EMBLAZE [v]\n",
  "IMBLAZING": "IMBLAZE, to adorn with glittering embellishments, also EMBLAZE [v]\n",
  "IMBODIED": "IMBODY, to form into a body, also EMBODY [v]\n",
  "IMBODIES": "IMBODY, to form into a body, also EMBODY [v]\n",
  "IMBODY": "to form into a body, also EMBODY [v IMBODIED, IMBODYING, IMBODIES]\n",
  "IMBODYING": "IMBODY, to form into a body, also EMBODY [v]\n",
  "IMBOLDEN": "to instil with courage, also EMBOLDEN [v -ED, -ING, -S]\n",
  "IMBOLDENED": "IMBOLDEN, to instil with courage, also EMBOLDEN [v]\n",
  "IMBOLDENING": "IMBOLDEN, to instil with courage, also EMBOLDEN [v]\n",
  "IMBOLDENS": "IMBOLDEN, to instil with courage, also EMBOLDEN [v]\n",
  "IMBORDER": "to provide with a border, also EMBORDER [v -ED, -ING, -S]\n",
  "IMBORDERED": "IMBORDER, to provide with a border, also EMBORDER [v]\n",
  "IMBORDERING": "IMBORDER, to provide with a border, also EMBORDER [v]\n",
  "IMBORDERS": "IMBORDER, to provide with a border, also EMBORDER [v]\n",
  "IMBOSK": "to go deep into the woods [v -ED, -ING, -S]\n",
  "IMBOSKED": "IMBOSK, to go deep into the woods [v]\n",
  "IMBOSKING": "IMBOSK, to go deep into the woods [v]\n",
  "IMBOSKS": "IMBOSK, to go deep into the woods [v]\n",
  "IMBOSOM": "to embrace, also EMBOSOM [v -ED, -ING, -S]\n",
  "IMBOSOMED": "IMBOSOM, to embrace, also EMBOSOM [v]\n",
  "IMBOSOMING": "IMBOSOM, to embrace, also EMBOSOM [v]\n",
  "IMBOSOMS": "IMBOSOM, to embrace, also EMBOSOM [v]\n",
  "IMBOSS": "to decorate with a raised design, also EMBOSS [v -ED, -ING, -ES]\n",
  "IMBOSSED": "IMBOSS, to decorate with a raised design, also EMBOSS [v]\n",
  "IMBOSSES": "IMBOSS, to decorate with a raised design, also EMBOSS [v]\n",
  "IMBOSSING": "IMBOSS, to decorate with a raised design, also EMBOSS [v]\n",
  "IMBOWER": "to give shelter, also EMBOWER [v -ED, -ING, -S]\n",
  "IMBOWERED": "IMBOWER, to give shelter, also EMBOWER [v]\n",
  "IMBOWERING": "IMBOWER, to give shelter, also EMBOWER [v]\n",
  "IMBOWERS": "IMBOWER, to give shelter, also EMBOWER [v]\n",
  "IMBRANGLE": "(archaic) to confuse or perplex, also EMBRANGLE [v IMBRANGLED, IMBRANGLING, IMBRANGLES]\n",
  "IMBRANGLED": "IMBRANGLE, (archaic) to confuse or perplex, also EMBRANGLE [v]\n",
  "IMBRANGLES": "IMBRANGLE, (archaic) to confuse or perplex, also EMBRANGLE [v]\n",
  "IMBRANGLING": "IMBRANGLE, (archaic) to confuse or perplex, also EMBRANGLE [v]\n",
  "IMBRAST": "(Spenser) embraced [v]\n",
  "IMBREX": "(Latin) in Roman buildings, one of a series of usually curved tiles fitting over flat tiles [n IMBRICES]\n",
  "IMBRICATE": "overlapping [adj IMBRICATELY] / to lay overlapping one another [v IMBRICATED, IMBRICATING, IMBRICATES]\n",
  "IMBRICATED": "IMBRICATE, to lay overlapping one another [v]\n",
  "IMBRICATELY": "IMBRICATE, overlapping [adv]\n",
  "IMBRICATES": "IMBRICATE, to lay overlapping one another [v]\n",
  "IMBRICATING": "IMBRICATE, to lay overlapping one another [v]\n",
  "IMBRICATION": "an overlapping of edges (as of tiles) [n -S]\n",
  "IMBRICATIONS": "IMBRICATION, an overlapping of edges (as of tiles) [n]\n",
  "IMBRICES": "IMBREX, (Latin) in Roman buildings, one of a series of usually curved tiles fitting over flat tiles [n]\n",
  "IMBROCCATA": "(Italian) a downward pass or thrust in fencing [n -S]\n",
  "IMBROCCATAS": "IMBROCCATA, (Italian) a downward pass or thrust in fencing [n]\n",
  "IMBROGLIO": "(Italian) a confusing or disturbing situation, also EMBROGLIO [n -S]\n",
  "IMBROGLIOS": "IMBROGLIO, (Italian) a confusing or disturbing situation, also EMBROGLIO [n]\n",
  "IMBROWN": "to make brown, also EMBROWN [v -ED, -ING, -S]\n",
  "IMBROWNED": "IMBROWN, to make brown, also EMBROWN [v]\n",
  "IMBROWNING": "IMBROWN, to make brown, also EMBROWN [v]\n",
  "IMBROWNS": "IMBROWN, to make brown, also EMBROWN [v]\n",
  "IMBRUE": "to drench, also EMBRUE [v IMBRUED, IMBRUING, IMBRUES]\n",
  "IMBRUED": "IMBRUE, to drench, also EMBRUE [v]\n",
  "IMBRUEMENT": "the act of imbruing or state of being imbrued, also EMBRUEMENT [n -S]\n",
  "IMBRUEMENTS": "IMBRUEMENT, the act of imbruing or state of being imbrued, also EMBRUEMENT [n]\n",
  "IMBRUES": "IMBRUE, to drench, also EMBRUE [v]\n",
  "IMBRUING": "IMBRUE, to drench, also EMBRUE [v]\n",
  "IMBRUTE": "(archaic) to degrade to the state of a brute, also EMBRUTE [v IMBRUTED, IMBRUTING, IMBRUTES]\n",
  "IMBRUTED": "IMBRUTE, (archaic) to degrade to the state of a brute, also EMBRUTE [v]\n",
  "IMBRUTES": "IMBRUTE, (archaic) to degrade to the state of a brute, also EMBRUTE [v]\n",
  "IMBRUTING": "IMBRUTE, (archaic) to degrade to the state of a brute, also EMBRUTE [v]\n",
  "IMBUE": "to inspire with [v IMBUED, IMBUING, IMBUES]\n",
  "IMBUED": "IMBUE, to inspire with [v]\n",
  "IMBUEMENT": "the act of imbuing [n -S]\n",
  "IMBUEMENTS": "IMBUEMENT, the act of imbuing [n]\n",
  "IMBUES": "IMBUE, to inspire with [v]\n",
  "IMBUING": "IMBUE, to inspire with [v]\n",
  "IMBURSE": "to put in a purse [v IMBURSED, IMBURSING, IMBURSES]\n",
  "IMBURSED": "IMBURSE, to put in a purse [v]\n",
  "IMBURSES": "IMBURSE, to put in a purse [v]\n",
  "IMBURSING": "IMBURSE, to put in a purse [v]\n",
  "IMID": "a class of organic compounds formed from ammonia, also IMIDE [n -S]\n",
  "IMIDAZOLE": "a white crystalline compound, also IMINAZOLE [n -S]\n",
  "IMIDAZOLES": "IMIDAZOLE, a white crystalline compound, also IMINAZOLE [n]\n",
  "IMIDE": "a class of organic compounds formed from ammonia, also IMID [n -S]\n",
  "IMIDES": "IMIDE, a class of organic compounds formed from ammonia, also IMID [n]\n",
  "IMIDIC": "of or like an imide, an ammonia compound [adj]\n",
  "IMIDO": "of a compound, containing an imide, a class of organic compounds formed from ammonia [adj]\n",
  "IMIDS": "IMID, a class of organic compounds formed from ammonia, also IMIDE [n]\n",
  "IMINAZOLE": "a white crystalline compound, also IMIDAZOLE [n -S]\n",
  "IMINAZOLES": "IMINAZOLE, a white crystalline compound, also IMIDAZOLE [n]\n",
  "IMINE": "a chemical compound [n -S]\n",
  "IMINES": "IMINE, a chemical compound [n]\n",
  "IMINO": "of a compound, containing an imine [adj]\n",
  "IMINOUREA": "a strongly basic compound used in organic synthesis, aka guanidine [n -S]\n",
  "IMINOUREAS": "IMINOUREA, a strongly basic compound used in organic synthesis, aka guanidine [n]\n",
  "IMIPENEM": "a drug used to kill bacteria [n -S]\n",
  "IMIPENEMS": "IMIPENEM, a drug used to kill bacteria [n]\n",
  "IMIPRAMINE": "an antidepressant drug also used in the treatment of enuresis [n -S]\n",
  "IMIPRAMINES": "IMIPRAMINE, an antidepressant drug also used in the treatment of enuresis [n]\n",
  "IMITABILITIES": "IMITABILITY, the state of being imitable [n]\n",
  "IMITABILITY": "the state of being imitable [n IMITABILITIES]\n",
  "IMITABLE": "capable of being imitated [adj]\n",
  "IMITABLENESS": "the state of being imitable [n -ES]\n",
  "IMITABLENESSES": "IMITABLENESS, the state of being imitable [n]\n",
  "IMITANCIES": "IMITANCY, (Caribbean) the tendency to imitate [n]\n",
  "IMITANCY": "(Caribbean) the tendency to imitate [n IMITANCIES]\n",
  "IMITANT": "an imitation [n -S]\n",
  "IMITANTS": "IMITANT, an imitation [n]\n",
  "IMITATE": "to behave in the same way as [v IMITATED, IMITATING, IMITATES]\n",
  "IMITATED": "IMITATE, to behave in the same way as [v]\n",
  "IMITATES": "IMITATE, to behave in the same way as [v]\n",
  "IMITATING": "IMITATE, to behave in the same way as [v]\n",
  "IMITATION": "the act of imitating, a copy [n -S]\n",
  "IMITATIONAL": "relating to imitation [adj]\n",
  "IMITATIONS": "IMITATION, the act of imitating, a copy [n]\n",
  "IMITATIVE": "inclined to imitate; formed after a model [adj IMITATIVELY]\n",
  "IMITATIVELY": "IMITATIVE, inclined to imitate; formed after a model [adv]\n",
  "IMITATIVENESS": "IMITATIVE, inclined to imitate; formed after a model [n]\n",
  "IMITATIVENESSES": "IMITATIVENESS, IMITATIVE, inclined to imitate; formed after a model [n]\n",
  "IMITATOR": "one that imitates [n -S]\n",
  "IMITATORS": "IMITATOR, one that imitates [n]\n",
  "IMMACULACIES": "IMMACULACY, the state of being immaculate [n]\n",
  "IMMACULACY": "the state of being immaculate [n IMMACULACIES]\n",
  "IMMACULATE": "having no stain or blemish [adj IMMACULATELY]\n",
  "IMMACULATELY": "IMMACULATE, having no stain or blemish [adv]\n",
  "IMMACULATENESS": "IMMACULATE, having no stain or blemish [n]\n",
  "IMMANACLE": "(Milton) to put in manacles [v IMMANACLED, IMMANACLING, IMMANACLES]\n",
  "IMMANACLED": "IMMANACLE, (Milton) to put in manacles [v]\n",
  "IMMANACLES": "IMMANACLE, (Milton) to put in manacles [v]\n",
  "IMMANACLING": "IMMANACLE, (Milton) to put in manacles [v]\n",
  "IMMANATION": "a flowing in [n -S]\n",
  "IMMANATIONS": "IMMANATION, a flowing in [n]\n",
  "IMMANE": "(archaic) huge; monstrous in size or character [adj IMMANELY]\n",
  "IMMANELY": "IMMANE, (archaic) huge; monstrous in size or character [adv]\n",
  "IMMANENCE": "the state of being immanent, also IMMANENCY [n -S]\n",
  "IMMANENCES": "IMMANENCE, the state of being immanent, also IMMANENCY [n]\n",
  "IMMANENCIES": "IMMANENCY, the state of being immanent, also IMMANENCE [n]\n",
  "IMMANENCY": "the state of being immanent, also IMMANENCE [n IMMANENCIES]\n",
  "IMMANENT": "dwelling within [adj]\n",
  "IMMANENTAL": "relating to the immanent [adj]\n",
  "IMMANENTISM": "belief in an immanent or permanent god [n -S]\n",
  "IMMANENTISMS": "IMMANENTISM, belief in an immanent or permanent god [n]\n",
  "IMMANENTIST": "one who believes in an immanent or permanent god [n -S]\n",
  "IMMANENTISTIC": "relating to immanentism [adj]\n",
  "IMMANENTISTS": "IMMANENTIST, one who believes in an immanent or permanent god [n]\n",
  "IMMANENTLY": "IMMANENT, dwelling within [adv]\n",
  "IMMANITIES": "IMMANITY, monstrous cruelty [n]\n",
  "IMMANITY": "monstrous cruelty [n IMMANITIES]\n",
  "IMMANTLE": "to cloak in a mantle [v IMMANTLED, IMMANTLING, IMMANTLES]\n",
  "IMMANTLED": "IMMANTLE, to cloak in a mantle [v]\n",
  "IMMANTLES": "IMMANTLE, to cloak in a mantle [v]\n",
  "IMMANTLING": "IMMANTLE, to cloak in a mantle [v]\n",
  "IMMARCESCIBLE": "unfading; imperishable [adj]\n",
  "IMMARGINATE": "without a distinct margin [adj]\n",
  "IMMASK": "(Shakespeare) to mask or disguise [v -ED, -ING, -S]\n",
  "IMMASKED": "IMMASK, (Shakespeare) to mask or disguise [v]\n",
  "IMMASKING": "IMMASK, (Shakespeare) to mask or disguise [v]\n",
  "IMMASKS": "IMMASK, (Shakespeare) to mask or disguise [v]\n",
  "IMMATERIAL": "not consisting of matter [adj IMMATERIALLY]\n",
  "IMMATERIALISE": "to make immaterial, also IMMATERIALIZE [v IMMATERIALISED, IMMATERIALISING, IMMATERIALISES]\n",
  "IMMATERIALISED": "IMMATERIALISE, to make immaterial, also IMMATERIALIZE [v]\n",
  "IMMATERIALISES": "IMMATERIALISE, to make immaterial, also IMMATERIALIZE [v]\n",
  "IMMATERIALISING": "IMMATERIALISE, to make immaterial, also IMMATERIALIZE [v]\n",
  "IMMATERIALISM": "the doctrine that there is no material substance [n -S]\n",
  "IMMATERIALISMS": "IMMATERIALISM, the doctrine that there is no material substance [n]\n",
  "IMMATERIALIST": "an exponent of immaterialism [n -S]\n",
  "IMMATERIALISTS": "IMMATERIALIST, an exponent of immaterialism [n]\n",
  "IMMATERIALITIES": "IMMATERIALITY, the state of being immaterial [n]\n",
  "IMMATERIALITY": "the state of being immaterial [n IMMATERIALITIES]\n",
  "IMMATERIALIZE": "to make immaterial, also IMMATERIALISE [v IMMATERIALIZED, IMMATERIALIZING, IMMATERIALIZES]\n",
  "IMMATERIALIZED": "IMMATERIALIZE, to make immaterial, also IMMATERIALISE [v]\n",
  "IMMATERIALIZES": "IMMATERIALIZE, to make immaterial, also IMMATERIALISE [v]\n",
  "IMMATERIALIZING": "IMMATERIALIZE, to make immaterial, also IMMATERIALISE [v]\n",
  "IMMATERIALLY": "IMMATERIAL, not consisting of matter [adv]\n",
  "IMMATERIALNESS": "the state of being immaterial [n]\n",
  "IMMATURE": "not mature [adj IMMATURER, IMMATUREST; IMMATURELY] / an immature animal [n -S]\n",
  "IMMATURELY": "IMMATURE, not mature [adv]\n",
  "IMMATURENESS": "the state of being immature [n -ES]\n",
  "IMMATURENESSES": "IMMATURENESS, the state of being immature [n]\n",
  "IMMATURER": "IMMATURE, not mature [adj]\n",
  "IMMATURES": "IMMATURE, an immature animal [n]\n",
  "IMMATUREST": "IMMATURE, not mature [adj]\n",
  "IMMATURITIES": "IMMATURITY, the state of being immature [n]\n",
  "IMMATURITY": "the state of being immature [n IMMATURITIES]\n",
  "IMMEASURABILITY": "the quality of being immeasurable [n]\n",
  "IMMEASURABLE": "incapable of being measured [adj IMMEASURABLY]\n",
  "IMMEASURABLY": "IMMEASURABLE, incapable of being measured [adv]\n",
  "IMMEASURED": "(Spenser) immeasurable [adj]\n",
  "IMMEDIACIES": "IMMEDIACY, the quality of being immediate [n]\n",
  "IMMEDIACY": "the quality of being immediate [n IMMEDIACIES]\n",
  "IMMEDIATE": "done or happening without delay [adj IMMEDIATELY]\n",
  "IMMEDIATELY": "IMMEDIATE, done or happening without delay [adv]\n",
  "IMMEDIATENESS": "the state of being immediate [n -ES]\n",
  "IMMEDIATENESSES": "IMMEDIATENESS, the state of being immediate [n]\n",
  "IMMEDIATISM": "the policy of action at once, esp. in the abolition of slavery in the US [n -S]\n",
  "IMMEDIATISMS": "IMMEDIATISM, the policy of action at once, esp. in the abolition of slavery in the US [n]\n",
  "IMMEDICABLE": "that cannot be medicated [adj IMMEDICABLY]\n",
  "IMMEDICABLENESS": "IMMEDICABLE, that cannot be medicated [n]\n",
  "IMMEDICABLY": "IMMEDICABLE, that cannot be medicated [adv]\n",
  "IMMEMORIAL": "extending or existing since beyond the reach of memory, record, or tradition [adj IMMEMORIALLY]\n",
  "IMMEMORIALLY": "IMMEMORIAL, extending or existing since beyond the reach of memory, record, or tradition [adv]\n",
  "IMMENSE": "huge [adj IMMENSER, IMMENSEST, IMMENSELY]\n",
  "IMMENSELY": "IMMENSE, huge [adv]\n",
  "IMMENSENESS": "the state of being immense [n -ES]\n",
  "IMMENSENESSES": "IMMENSENESS, the state of being immense [n]\n",
  "IMMENSER": "IMMENSE, huge [adj]\n",
  "IMMENSEST": "IMMENSE, huge [adj]\n",
  "IMMENSITIES": "IMMENSITY, the quality of being immense [n]\n",
  "IMMENSITY": "the quality of being immense [n IMMENSITIES]\n",
  "IMMENSURABILITY": "the quality of being immensurable [n]\n",
  "IMMENSURABLE": "immeasurable [adj]\n",
  "IMMERGE": "to plunge into a liquid, also IMMERSE [v IMMERGED, IMMERGING, IMMERGES]\n",
  "IMMERGED": "IMMERGE, to plunge into a liquid, also IMMERSE [v]\n",
  "IMMERGENCE": "immersion [n -S]\n",
  "IMMERGENCES": "IMMERGENCE, immersion [n]\n",
  "IMMERGES": "IMMERGE, to plunge into a liquid, also IMMERSE [v]\n",
  "IMMERGING": "IMMERGE, to plunge into a liquid, also IMMERSE [v]\n",
  "IMMERITOUS": "(archaic) undeserving [adj]\n",
  "IMMERSE": "to plunge into a liquid, also IMMERGE [v IMMERSED, IMMERSING, IMMERSES]\n",
  "IMMERSED": "IMMERSE, to plunge into a liquid, also IMMERGE [v]\n",
  "IMMERSER": "one who immerses [n -S]\n",
  "IMMERSERS": "IMMERSER, one who immerses [n]\n",
  "IMMERSES": "IMMERSE, to plunge into a liquid, also IMMERGE [v]\n",
  "IMMERSIBLE": "capable of being immersed [adj]\n",
  "IMMERSING": "IMMERSE, to plunge into a liquid, also IMMERGE [v]\n",
  "IMMERSION": "the act of immersing [n -S]\n",
  "IMMERSIONISM": "the practise of baptism by immersion [n -S]\n",
  "IMMERSIONISMS": "IMMERSIONISM, the practise of baptism by immersion [n]\n",
  "IMMERSIONIST": "a person who favours or practises baptism by immersion [n -S]\n",
  "IMMERSIONISTS": "IMMERSIONIST, a person who favours or practises baptism by immersion [n]\n",
  "IMMERSIONS": "IMMERSION, the act of immersing [n]\n",
  "IMMERSIVE": "providing stimulation for a number of senses, not just sight and sound [adj]\n",
  "IMMESH": "to entangle, as in, the meshes of a net, also ENMESH, EMMESH, INMESH [v -ED, -ING, -ES]\n",
  "IMMESHED": "IMMESH, to entangle, as in, the meshes of a net, also ENMESH, EMMESH, INMESH [v]\n",
  "IMMESHES": "IMMESH, to entangle, as in, the meshes of a net, also ENMESH, EMMESH, INMESH [v]\n",
  "IMMESHING": "IMMESH, to entangle, as in, the meshes of a net, also ENMESH, EMMESH, INMESH [v]\n",
  "IMMETHODICAL": "not methodical [adj IMMETHODICALLY]\n",
  "IMMETHODICALLY": "IMMETHODICAL, not methodical [adv]\n",
  "IMMEW": "to confine, mew up, as a hawk in mews, also EMMEW, ENMEW [v -ED, -ING, -S]\n",
  "IMMEWED": "IMMEW, to confine, mew up, as a hawk in mews, also EMMEW, ENMEW [v]\n",
  "IMMEWING": "IMMEW, to confine, mew up, as a hawk in mews, also EMMEW, ENMEW [v]\n",
  "IMMEWS": "IMMEW, to confine, mew up, as a hawk in mews, also EMMEW, ENMEW [v]\n",
  "IMMIES": "IMMY, (short for) image orthicon, an early form of television camera [n]\n",
  "IMMIGRANCIES": "IMMIGRANCY, the state or condition of being an immigrant or a person who comes to a country in order to settle there [n]\n",
  "IMMIGRANCY": "the state or condition of being an immigrant or a person who comes to a country in order to settle there [n IMMIGRANCIES]\n",
  "IMMIGRANT": "a person who immigrates, also INMIGRANT [n -S]\n",
  "IMMIGRANTS": "IMMIGRANT, a person who immigrates, also INMIGRANT [n]\n",
  "IMMIGRATE": "to migrate into a country with the intention of settling in it [v IMMIGRATED, IMMIGRATING, IMMIGRATES]\n",
  "IMMIGRATED": "IMMIGRATE, to migrate into a country with the intention of settling in it [v]\n",
  "IMMIGRATES": "IMMIGRATE, to migrate into a country with the intention of settling in it [v]\n",
  "IMMIGRATING": "IMMIGRATE, to migrate into a country with the intention of settling in it [v]\n",
  "IMMIGRATION": "the act or process of immigrating [n -S]\n",
  "IMMIGRATIONAL": "relating to immigration [adj]\n",
  "IMMIGRATIONS": "IMMIGRATION, the act or process of immigrating [n]\n",
  "IMMIGRATOR": "one who immigrates [n -S]\n",
  "IMMIGRATORS": "IMMIGRATOR, one who immigrates [n]\n",
  "IMMIGRATORY": "relating to immigration [adj]\n",
  "IMMINENCE": "the quality of being imminent, also IMMINENCY [n -S]\n",
  "IMMINENCES": "IMMINENCE, the quality of being imminent, also IMMINENCY [n]\n",
  "IMMINENCIES": "IMMINENCY, the quality of being imminent, also IMMINENCE [n]\n",
  "IMMINENCY": "the quality of being imminent, also IMMINENCE [n IMMINENCIES]\n",
  "IMMINENT": "impending [adj IMMINENTLY]\n",
  "IMMINENTLY": "IMMINENT, impending [adv]\n",
  "IMMINENTNESS": "the state of being imminent [n -ES]\n",
  "IMMINENTNESSES": "IMMINENTNESS, the state of being imminent [n]\n",
  "IMMINGLE": "to mix [v IMMINGLED, IMMINGLING, IMMINGLES]\n",
  "IMMINGLED": "IMMINGLE, to mix [v]\n",
  "IMMINGLES": "IMMINGLE, to mix [v]\n",
  "IMMINGLING": "IMMINGLE, to mix [v]\n",
  "IMMINUTE": "(archaic) lessened, decreased [adj]\n",
  "IMMINUTION": "a lessening, a decrease [n -S]\n",
  "IMMINUTIONS": "IMMINUTION, a lessening, a decrease [n]\n",
  "IMMISCIBILITIES": "IMMISCIBILITY, the state of being immiscible [n]\n",
  "IMMISCIBILITY": "the state of being immiscible [n IMMISCIBILITIES]\n",
  "IMMISCIBLE": "not capable of being mixed or mingled [adj IMMISCIBLY]\n",
  "IMMISCIBLY": "IMMISCIBLE, not capable of being mixed or mingled [adv]\n",
  "IMMISERATION": "progressive impoverishment or degradation, also IMMISERISATION, IMMISERIZATION [n -S]\n",
  "IMMISERATIONS": "IMMISERATION, progressive impoverishment or degradation, also IMMISERISATION, IMMISERIZATION [n]\n",
  "IMMISERISATION": "progressive impoverishment or degradation, also IMMISERATION, IMMISERIZATION [n -S]\n",
  "IMMISERISATIONS": "IMMISERISATION, progressive impoverishment or degradation, also IMMISERATION, IMMISERIZATION [n]\n",
  "IMMISERISE": "to subject to immiseration, progressive impoverishment or degradation, also IMMISERIZE [v IMMISERISED, IMMISERISING, IMMISERISES]\n",
  "IMMISERISED": "IMMISERISE, to subject to immiseration, progressive impoverishment or degradation, also IMMISERIZE [v]\n",
  "IMMISERISES": "IMMISERISE, to subject to immiseration, progressive impoverishment or degradation, also IMMISERIZE [v]\n",
  "IMMISERISING": "IMMISERISE, to subject to immiseration, progressive impoverishment or degradation, also IMMISERIZE [v]\n",
  "IMMISERIZATION": "progressive impoverishment or degradation, also IMMISERATION, IMMISERISATION [n -S]\n",
  "IMMISERIZATIONS": "IMMISERIZATION, progressive impoverishment or degradation, also IMMISERATION, IMMISERISATION [n]\n",
  "IMMISERIZE": "to subject to progressive impoverishment or degradation, also IMMISERISE [v IMMISERIZED, IMMISERIZING, IMMISERIZES]\n",
  "IMMISERIZED": "IMMISERIZE, to subject to progressive impoverishment or degradation, also IMMISERISE [v]\n",
  "IMMISERIZES": "IMMISERIZE, to subject to progressive impoverishment or degradation, also IMMISERISE [v]\n",
  "IMMISERIZING": "IMMISERIZE, to subject to progressive impoverishment or degradation, also IMMISERISE [v]\n",
  "IMMISSION": "insertion; infusion [n -S]\n",
  "IMMISSIONS": "IMMISSION, insertion; infusion [n]\n",
  "IMMIT": "(obsolete) to insert, infuse [v IMMITTED, IMMITTING, IMMITS]\n",
  "IMMITIGABILITY": "the quality of being immitigable [n]\n",
  "IMMITIGABLE": "that cannot be mitigated [adj IMMITIGABLY]\n",
  "IMMITIGABLY": "IMMITIGABLE, that cannot be mitigated [adv]\n",
  "IMMITS": "IMMIT, (obsolete) to insert, infuse [v]\n",
  "IMMITTANCE": "the act of immitting, inserting [n -S]\n",
  "IMMITTANCES": "IMMITTANCE, the act of immitting, inserting [n]\n",
  "IMMITTED": "IMMIT, (obsolete) to insert, infuse [v]\n",
  "IMMITTING": "IMMIT, (obsolete) to insert, infuse [v]\n",
  "IMMIX": "(archaic) to mix in, commingle [v IMMIXED, IMMIXING, IMMIXES]\n",
  "IMMIXED": "IMMIX, (archaic) to mix in, commingle [v]\n",
  "IMMIXES": "IMMIX, (archaic) to mix in, commingle [v]\n",
  "IMMIXING": "IMMIX, (archaic) to mix in, commingle [v]\n",
  "IMMIXTURE": "freedom from mixture; purity [n -S]\n",
  "IMMIXTURES": "IMMIXTURE, freedom from mixture; purity [n]\n",
  "IMMOBILE": "stationary [adj]\n",
  "IMMOBILISATION": "the act of immobilising, also IMMOBILIZATION [n -S]\n",
  "IMMOBILISATIONS": "IMMOBILISATION, the act of immobilising, also IMMOBILIZATION [n]\n",
  "IMMOBILISE": "to render immobile, also IMMOBILIZE [v IMMOBILISED, IMMOBILISING, IMMOBILISES]\n",
  "IMMOBILISED": "IMMOBILISE, to render immobile, also IMMOBILIZE [v]\n",
  "IMMOBILISER": "a device for preventing an engine from being started, also IMMOBILIZER [n -S]\n",
  "IMMOBILISERS": "IMMOBILISER, a device for preventing an engine from being started, also IMMOBILIZER [n]\n",
  "IMMOBILISES": "IMMOBILISE, to render immobile, also IMMOBILIZE [v]\n",
  "IMMOBILISING": "IMMOBILISE, to render immobile, also IMMOBILIZE [v]\n",
  "IMMOBILISM": "a political policy characterised by extreme lack of action [n -S]\n",
  "IMMOBILISMS": "IMMOBILISM, a political policy characterised by extreme lack of action [n]\n",
  "IMMOBILITIES": "IMMOBILITY, the state of being immobile [n]\n",
  "IMMOBILITY": "the state of being immobile [n IMMOBILITIES]\n",
  "IMMOBILIZATION": "the act of immobilizing, also IMMOBILISATION [n -S]\n",
  "IMMOBILIZATIONS": "IMMOBILIZATION, the act of immobilizing, also IMMOBILISATION [n]\n",
  "IMMOBILIZE": "to make immovable, also IMMOBILISE [v IMMOBILIZED, IMMOBILIZING, IMMOBILIZES]\n",
  "IMMOBILIZED": "IMMOBILIZE, to make immovable, also IMMOBILISE [v]\n",
  "IMMOBILIZER": "a device for preventing an engine from being started, also IMMOBILISER [n -S]\n",
  "IMMOBILIZERS": "IMMOBILIZER, a device for preventing an engine from being started, also IMMOBILISER [n]\n",
  "IMMOBILIZES": "IMMOBILIZE, to make immovable, also IMMOBILISE [v]\n",
  "IMMOBILIZING": "IMMOBILIZE, to make immovable, also IMMOBILISE [v]\n",
  "IMMODERACIES": "IMMODERACY, lack of moderation [n]\n",
  "IMMODERACY": "lack of moderation [n IMMODERACIES]\n",
  "IMMODERATE": "exceeding just, usual, or suitable bounds [adj IMMODERATELY]\n",
  "IMMODERATELY": "IMMODERATE, exceeding just, usual, or suitable bounds [adv]\n",
  "IMMODERATENESS": "the state of being immoderate [n]\n",
  "IMMODERATION": "the state of being immoderate [n -S]\n",
  "IMMODERATIONS": "IMMODERATION, the state of being immoderate [n]\n",
  "IMMODEST": "not modest [adj IMMODESTER, IMMODESTEST; IMMODESTLY]\n",
  "IMMODESTER": "IMMODEST, not modest [adj]\n",
  "IMMODESTEST": "IMMODEST, not modest [adj]\n",
  "IMMODESTIES": "IMMODESTY, lack of modesty [n]\n",
  "IMMODESTLY": "IMMODEST, not modest [adv]\n",
  "IMMODESTY": "lack of modesty [n IMMODESTIES]\n",
  "IMMOLATE": "to kill as a sacrifice [v IMMOLATED, IMMOLATING, IMMOLATES]\n",
  "IMMOLATED": "IMMOLATE, to kill as a sacrifice [v]\n",
  "IMMOLATES": "IMMOLATE, to kill as a sacrifice [v]\n",
  "IMMOLATING": "IMMOLATE, to kill as a sacrifice [v]\n",
  "IMMOLATION": "the act of immolating, or the state of being immolated, or sacrificed [n -S]\n",
  "IMMOLATIONS": "IMMOLATION, the act of immolating, or the state of being immolated, or sacrificed [n]\n",
  "IMMOLATOR": "one who offers in sacrifice; specifically, one of a sect of Russian fanatics who practice self-mutilation and sacrifice [n -S]\n",
  "IMMOLATORS": "IMMOLATOR, one who offers in sacrifice; specifically, one of a sect of Russian fanatics who practice self-mutilation and sacrifice [n]\n",
  "IMMOMENT": "(Shakespeare) of no value, trifling [adj]\n",
  "IMMOMENTOUS": "of no value, trifling, also IMMOMENT [adj]\n",
  "IMMORAL": "promiscuous or unscrupulous [adj IMMORALLY]\n",
  "IMMORALISM": "rejection of morality [n -S]\n",
  "IMMORALISMS": "IMMORALISM, rejection of morality [n]\n",
  "IMMORALIST": "a person who practises immorality [n -S]\n",
  "IMMORALISTS": "IMMORALIST, a person who practises immorality [n]\n",
  "IMMORALITIES": "IMMORALITY, the state of being immoral [n]\n",
  "IMMORALITY": "the state of being immoral [n IMMORALITIES]\n",
  "IMMORALLY": "IMMORAL, promiscuous or unscrupulous [adv]\n",
  "IMMORTAL": "not subject to death [adj IMMORTALLY] / one who is not subject to death [n -S]\n",
  "IMMORTALISATION": "the process of immortalizing, also IMMORTALIZATION [n]\n",
  "IMMORTALISE": "to render immortal, also IMMORTALIZE [v IMMORTALISED, IMMORTALISING, IMMORTALISES]\n",
  "IMMORTALISED": "IMMORTALISE, to render immortal, also IMMORTALIZE [v]\n",
  "IMMORTALISER": "one who immortalises, also IMMORTALIZER [n -S]\n",
  "IMMORTALISERS": "IMMORTALISER, one who immortalises, also IMMORTALIZER [n]\n",
  "IMMORTALISES": "IMMORTALISE, to render immortal, also IMMORTALIZE [v]\n",
  "IMMORTALISING": "IMMORTALISE, to render immortal, also IMMORTALIZE [v]\n",
  "IMMORTALITIES": "IMMORTALITY, the state of being immortal [n]\n",
  "IMMORTALITY": "the state of being immortal [n IMMORTALITIES]\n",
  "IMMORTALIZATION": "the process of immortalizing, also IMMORTALISATION [n]\n",
  "IMMORTALIZE": "to make immortal, also IMMORTALISE [v IMMORTALIZED, IMMORTALIZING, IMMORTALIZES]\n",
  "IMMORTALIZED": "IMMORTALIZE, to make immortal, also IMMORTALISE [v]\n",
  "IMMORTALIZER": "one who immortalizes, also IMMORTALISER [n -S]\n",
  "IMMORTALIZERS": "IMMORTALIZER, one who immortalizes, also IMMORTALISER [n]\n",
  "IMMORTALIZES": "IMMORTALIZE, to make immortal, also IMMORTALISE [v]\n",
  "IMMORTALIZING": "IMMORTALIZE, to make immortal, also IMMORTALISE [v]\n",
  "IMMORTALLY": "IMMORTAL, not subject to death [adv]\n",
  "IMMORTALS": "IMMORTAL, one who is not subject to death [n]\n",
  "IMMORTELLE": "(French) a plant with flowers that retain their color when dried [n -S]\n",
  "IMMORTELLES": "IMMORTELLE, (French) a plant with flowers that retain their color when dried [n]\n",
  "IMMOTILE": "lacking mobility [adj]\n",
  "IMMOTILITIES": "IMMOTILITY, the quality of being immotile [n]\n",
  "IMMOTILITY": "the quality of being immotile [n IMMOTILITIES]\n",
  "IMMOVABILITIES": "IMMOVABILITY, the state of being immovable, also IMMOVEABILITY [n]\n",
  "IMMOVABILITY": "the state of being immovable, also IMMOVEABILITY [n IMMOVABILITIES]\n",
  "IMMOVABLE": "that cannot be moved, also IMMOVEABLE [adj IMMOVABLY] / something immovable [n -S]\n",
  "IMMOVABLENESS": "the state of being immovable, also IMMOVEABLENESS [n -ES]\n",
  "IMMOVABLENESSES": "IMMOVABLENESS, the state of being immovable, also IMMOVEABLENESS [n]\n",
  "IMMOVABLES": "IMMOVABLE, something immovable [n]\n",
  "IMMOVABLY": "IMMOVABLE, that cannot be moved, also IMMOVEABLE [adv]\n",
  "IMMOVEABILITIES": "IMMOVEABILITY, the quality of being immoveable, also IMMOVABILITY [n]\n",
  "IMMOVEABILITY": "the quality of being immoveable, also IMMOVABILITY [n IMMOVEABILITIES]\n",
  "IMMOVEABLE": "no capable of being moved, also IMMOVABLE [adj IMMOVEABLY] / something that cannot be moved [n -S]\n",
  "IMMOVEABLENESS": "IMMOVEABLE, no capable of being moved, also IMMOVABLE [n]\n",
  "IMMOVEABLES": "IMMOVEABLE, something that cannot be moved [n]\n",
  "IMMOVEABLY": "IMMOVEABLE, no capable of being moved, also IMMOVABLE [adv]\n",
  "IMMUNE": "exempt from; resistant to disease [adj IMMUNER, IMMUNEST] / someone who, or something that, is immune [n -S]\n",
  "IMMUNER": "IMMUNE, exempt from; resistant to disease [adj]\n",
  "IMMUNES": "IMMUNE, someone who, or something that, is immune [n]\n",
  "IMMUNEST": "IMMUNE, exempt from; resistant to disease [adj]\n",
  "IMMUNIFACIENT": "causing immunity [adj]\n",
  "IMMUNISATION": "the act of immunising, also IMMUNIZATION [n -S]\n",
  "IMMUNISATIONS": "IMMUNISATION, the act of immunising, also IMMUNIZATION [n]\n",
  "IMMUNISE": "to render immune from infection, also IMMUNIZE [v IMMUNISED, IMMUNISING, IMMUNISES]\n",
  "IMMUNISED": "IMMUNISE, to render immune from infection, also IMMUNIZE [v]\n",
  "IMMUNISER": "one that renders immune from infection, also IMMUNIZER [n -S]\n",
  "IMMUNISERS": "IMMUNISER, one that renders immune from infection, also IMMUNIZER [n]\n",
  "IMMUNISES": "IMMUNISE, to render immune from infection, also IMMUNIZE [v]\n",
  "IMMUNISING": "IMMUNISE, to render immune from infection, also IMMUNIZE [v]\n",
  "IMMUNITIES": "IMMUNITY, the state of being protected from disease [n]\n",
  "IMMUNITY": "the state of being protected from disease [n IMMUNITIES]\n",
  "IMMUNIZATION": "the act of immunizing, also IMMUNISATION [n -S]\n",
  "IMMUNIZATIONS": "IMMUNIZATION, the act of immunizing, also IMMUNISATION [n]\n",
  "IMMUNIZE": "to render immune from infection, also IMMUNISE [v IMMUNIZED, IMMUNIZING, IMMUNIZES]\n",
  "IMMUNIZED": "IMMUNIZE, to render immune from infection, also IMMUNISE [v]\n",
  "IMMUNIZER": "one that renders immune from infection, also IMMUNISER [n -S]\n",
  "IMMUNIZERS": "IMMUNIZER, one that renders immune from infection, also IMMUNISER [n]\n",
  "IMMUNIZES": "IMMUNIZE, to render immune from infection, also IMMUNISE [v]\n",
  "IMMUNIZING": "IMMUNIZE, to render immune from infection, also IMMUNISE [v]\n",
  "IMMUNOASSAY": "the determination of the presence and quantity of a substance through its action as an antigen [n -S]\n",
  "IMMUNOASSAYABLE": "capable of undergoing immunoassay [adj]\n",
  "IMMUNOASSAYIST": "one who carries out immunoassays [n -S]\n",
  "IMMUNOASSAYISTS": "IMMUNOASSAYIST, one who carries out immunoassays [n]\n",
  "IMMUNOASSAYS": "IMMUNOASSAY, the determination of the presence and quantity of a substance through its action as an antigen [n]\n",
  "IMMUNOBLOT": "a technique used in biology to transfer a pattern of proteins [n -S]\n",
  "IMMUNOBLOTS": "IMMUNOBLOT, a technique used in biology to transfer a pattern of proteins [n]\n",
  "IMMUNOBLOTTING": "the act of making immunoblots [n -S]\n",
  "IMMUNOBLOTTINGS": "IMMUNOBLOTTING, the act of making immunoblots [n]\n",
  "IMMUNOCHEMICAL": "relating to immunochemistry [adj]\n",
  "IMMUNOCHEMIST": "a student of immunochemistry [n -S]\n",
  "IMMUNOCHEMISTRY": "a branch of chemistry that deals with the chemical aspects of immunology [n]\n",
  "IMMUNOCHEMISTS": "IMMUNOCHEMIST, a student of immunochemistry [n]\n",
  "IMMUNOCOMPETENT": "relating to immunocompetence, the capacity of the immune system to distinguish and neutralize antigenic or foreign matter [adj]\n",
  "IMMUNOCOMPLEX": "a complex formed between an antibody and an antigen [n -ES]\n",
  "IMMUNOCOMPLEXES": "IMMUNOCOMPLEX, a complex formed between an antibody and an antigen [n]\n",
  "IMMUNODEFICIENT": "relating to immunodeficiency, deficiency in immune response due to depletion or inactivity of lymphoid cells [adj]\n",
  "IMMUNODIAGNOSES": "IMMUNODIAGNOSIS, a diagnosis relating to immunology [n]\n",
  "IMMUNODIAGNOSIS": "a diagnosis relating to immunology [n IMMUNODIAGNOSES]\n",
  "IMMUNODIFFUSION": "any of various analytical techniques that involve antigen and antibody solutions diffusing toward each other in a gel until antibody binds specifically to antigen to form a precipitate [n]\n",
  "IMMUNOGEN": "an antigen [n -S]\n",
  "IMMUNOGENESES": "IMMUNOGENESIS, the production of an immune response [n]\n",
  "IMMUNOGENESIS": "the production of an immune response [n IMMUNOGENESES]\n",
  "IMMUNOGENETIC": "relating to immunogenetics, the study of the genetic characteristics of immunity, also IMMUNOGENETICAL [adj]\n",
  "IMMUNOGENETICAL": "relating to immunogenetics, the study of the genetic characteristics of immunity, also IMMUNOGENETIC [adj]\n",
  "IMMUNOGENETICS": "the study of the genetic characteristics of immunity [n]\n",
  "IMMUNOGENIC": "producing an immune response [adj IMMUNOGENICALLY]\n",
  "IMMUNOGENICALLY": "IMMUNOGENIC, producing an immune response [adv]\n",
  "IMMUNOGENICITY": "the state of being immunogenic [n]\n",
  "IMMUNOGENS": "IMMUNOGEN, an antigen [n]\n",
  "IMMUNOGLOBULIN": "an immune protein [n -S]\n",
  "IMMUNOGLOBULINS": "IMMUNOGLOBULIN, an immune protein [n]\n",
  "IMMUNOLOGIC": "relating to immunology, also IMMUNOLOGICAL [adj]\n",
  "IMMUNOLOGICAL": "relating to immunology, also IMMUNOLOGIC [adj IMMUNOLOGICALLY]\n",
  "IMMUNOLOGICALLY": "IMMUNOLOGICAL, relating to immunology, also IMMUNOLOGIC [adv]\n",
  "IMMUNOLOGIES": "IMMUNOLOGY, the science of the immune system [n]\n",
  "IMMUNOLOGIST": "a practitioner of immunology [n -S]\n",
  "IMMUNOLOGISTS": "IMMUNOLOGIST, a practitioner of immunology [n]\n",
  "IMMUNOLOGY": "the science of the immune system [n IMMUNOLOGIES]\n",
  "IMMUNOMODULATOR": "a substance that affects the functioning of the immune system [n]\n",
  "IMMUNOPATHOLOGY": "the study of immunity to disease [n]\n",
  "IMMUNOPHORESES": "IMMUNOPHORESIS, a technique for identifying an (unknown) antigen or testing for a specific antibody in serum [n]\n",
  "IMMUNOPHORESIS": "a technique for identifying an (unknown) antigen or testing for a specific antibody in serum [n IMMUNOPHORESES]\n",
  "IMMUNOREACTION": "the reaction between an antigen and its antibody [n -S]\n",
  "IMMUNOREACTIONS": "IMMUNOREACTION, the reaction between an antigen and its antibody [n]\n",
  "IMMUNOREACTIVE": "reacting to particular antigens or haptens [adj]\n",
  "IMMUNOSORBENT": "a substrate consisting of a specific antibody or antigen chemically combined with an insoluble substance, such as cellulose, to selectively remove the corresponding specific antigen or antibody from solution [n -S]\n",
  "IMMUNOSORBENTS": "IMMUNOSORBENT, a substrate consisting of a specific antibody or antigen chemically combined with an insoluble substance, such as cellulose, to selectively remove the corresponding specific antigen or antibody from solution [n]\n",
  "IMMUNOSTIMULANT": "a drug or nutrient which stimulates the body's immune system [n]\n",
  "IMMUNOSUPPRESS": "to inhibit the body's immune response [v]\n",
  "IMMUNOTHERAPIES": "IMMUNOTHERAPY, the treatment or prevention of disease by taking measures to increase immune system functioning [n]\n",
  "IMMUNOTHERAPY": "the treatment or prevention of disease by taking measures to increase immune system functioning [n IMMUNOTHERAPIES]\n",
  "IMMUNOTOXIC": "relating to an immunotoxin [adj]\n",
  "IMMUNOTOXIN": "a toxin with immunosuppressive effects [n -S]\n",
  "IMMUNOTOXINS": "IMMUNOTOXIN, a toxin with immunosuppressive effects [n]\n",
  "IMMURE": "to enclose behind walls, also EMURE [v IMMURED, IMMURING, IMMURES]\n",
  "IMMURED": "IMMURE, to enclose behind walls, also EMURE [v]\n",
  "IMMUREMENT": "the act of immuring, or the state of being immured [n -S]\n",
  "IMMUREMENTS": "IMMUREMENT, the act of immuring, or the state of being immured [n]\n",
  "IMMURES": "IMMURE, to enclose behind walls, also EMURE [v]\n",
  "IMMURING": "IMMURE, to enclose behind walls, also EMURE [v]\n",
  "IMMUTABILITIES": "IMMUTABILITY, the state of being immutable [n]\n",
  "IMMUTABILITY": "the state of being immutable [n IMMUTABILITIES]\n",
  "IMMUTABLE": "that cannot be changed [adj IMMUTABLY]\n",
  "IMMUTABLENESS": "IMMUTABLE, that cannot be changed [n]\n",
  "IMMUTABLENESSES": "IMMUTABLENESS, IMMUTABLE, that cannot be changed [n]\n",
  "IMMUTABLY": "IMMUTABLE, that cannot be changed [adv]\n",
  "IMMY": "(short for) image orthicon, an early form of television camera [n IMMIES]\n",
  "IMP": "to graft feathers onto a bird's wing, also YMPE [v -ED, -ING, -S]\n",
  "IMPACABLE": "not able to be quieted or appeased [adj]\n",
  "IMPACT": "to fix firmly together [v -ED, -ING, -S]\n",
  "IMPACTED": "IMPACT, to fix firmly together [v]\n",
  "IMPACTER": "one that impacts, also IMPACTOR [n -S]\n",
  "IMPACTERS": "IMPACTER, one that impacts, also IMPACTOR [n]\n",
  "IMPACTFUL": "full of impact [adj]\n",
  "IMPACTING": "IMPACT, to fix firmly together [v]\n",
  "IMPACTION": "the driving of one fragment of bone into another so that the fragments are not movable upon each other [n -S]\n",
  "IMPACTIONS": "IMPACTION, the driving of one fragment of bone into another so that the fragments are not movable upon each other [n]\n",
  "IMPACTITE": "a rock, typically glassy, produced where a meteor has collided with the earth [n -S]\n",
  "IMPACTITES": "IMPACTITE, a rock, typically glassy, produced where a meteor has collided with the earth [n]\n",
  "IMPACTIVE": "relating to impact [adj]\n",
  "IMPACTOR": "one that impacts, also IMPACTER [n -S]\n",
  "IMPACTORS": "IMPACTOR, one that impacts, also IMPACTER [n]\n",
  "IMPACTS": "IMPACT, to fix firmly together [v]\n",
  "IMPAINT": "(Shakespeare) to paint or depict [v -ED, -ING, -S]\n",
  "IMPAINTED": "IMPAINT, (Shakespeare) to paint or depict [v]\n",
  "IMPAINTING": "IMPAINT, (Shakespeare) to paint or depict [v]\n",
  "IMPAINTS": "IMPAINT, (Shakespeare) to paint or depict [v]\n",
  "IMPAIR": "to make worse, also EMPAIRE, EMPARE, EMPAYRE [v -ED, -ING, -S]\n",
  "IMPAIRABLE": "that can be impaired [adj]\n",
  "IMPAIRED": "IMPAIR, to make worse, also EMPAIRE, EMPARE, EMPAYRE [v]\n",
  "IMPAIRER": "one who, or that which, impairs [n -S]\n",
  "IMPAIRERS": "IMPAIRER, one who, or that which, impairs [n]\n",
  "IMPAIRING": "the act of making worse [n -S]\n",
  "IMPAIRINGS": "IMPAIRING, the act of making worse [n]\n",
  "IMPAIRMENT": "the state of being impaired [n -S]\n",
  "IMPAIRMENTS": "IMPAIRMENT, the state of being impaired [n]\n",
  "IMPAIRS": "IMPAIR, to make worse, also EMPAIRE, EMPARE, EMPAYRE [v]\n",
  "IMPALA": "(Zulu) an African antelope with horns curved in the shape of a lyre [n -S]\n",
  "IMPALAS": "IMPALA, (Zulu) an African antelope with horns curved in the shape of a lyre [n]\n",
  "IMPALE": "to pierce with a pointed object, also EMPALE [v IMPALED, IMPALING, IMPALES]\n",
  "IMPALED": "IMPALE, to pierce with a pointed object, also EMPALE [v]\n",
  "IMPALEMENT": "the act of impaling [n -S]\n",
  "IMPALEMENTS": "IMPALEMENT, the act of impaling [n]\n",
  "IMPALER": "one that impales, also EMPALER [n -S]\n",
  "IMPALERS": "IMPALER, one that impales, also EMPALER [n]\n",
  "IMPALES": "IMPALE, to pierce with a pointed object, also EMPALE [v]\n",
  "IMPALING": "IMPALE, to pierce with a pointed object, also EMPALE [v]\n",
  "IMPALPABILITIES": "IMPALPABILITY, the state of being impalpable [n]\n",
  "IMPALPABILITY": "the state of being impalpable [n IMPALPABILITIES]\n",
  "IMPALPABLE": "not perceivable by touch [adj IMPALPABLY]\n",
  "IMPALPABLY": "IMPALPABLE, not perceivable by touch [adv]\n",
  "IMPALUDISM": "a disease carried by insects affecting the inhabitants of marshy areas [n -S]\n",
  "IMPALUDISMS": "IMPALUDISM, a disease carried by insects affecting the inhabitants of marshy areas [n]\n",
  "IMPANATE": "in the context of the Eucharist, embodied in bread [adj]\n",
  "IMPANATION": "in Eucharistic doctrine, the presence of the body and blood of Christ in the bread (and wine) after consecration [n -S]\n",
  "IMPANATIONS": "IMPANATION, in Eucharistic doctrine, the presence of the body and blood of Christ in the bread (and wine) after consecration [n]\n",
  "IMPANEL": "to put onto a list for jury duty, also IMPANNEL [v IMPANELED or IMPANELLED, IMPANELING or IMPANELLING, IMPANELS]\n",
  "IMPANELED": "IMPANEL, to put onto a list for jury duty, also IMPANNEL [v]\n",
  "IMPANELING": "IMPANEL, to put onto a list for jury duty, also IMPANNEL [v]\n",
  "IMPANELLED": "IMPANEL, to put onto a list for jury duty, also IMPANNEL [v]\n",
  "IMPANELLING": "IMPANEL, to put onto a list for jury duty, also IMPANNEL [v]\n",
  "IMPANELMENT": "the act of impanelling [n -S]\n",
  "IMPANELMENTS": "IMPANELMENT, the act of impanelling [n]\n",
  "IMPANELS": "IMPANEL, to put onto a list for jury duty, also IMPANNEL [v]\n",
  "IMPANNEL": "to put onto a list for jury duty, also IMPANEL [v IMPANNELLED, IMPANNELLING, IMPANNELS]\n",
  "IMPANNELLED": "IMPANNEL, to put onto a list for jury duty, also IMPANEL [v]\n",
  "IMPANNELLING": "IMPANNEL, to put onto a list for jury duty, also IMPANEL [v]\n",
  "IMPANNELS": "IMPANNEL, to put onto a list for jury duty, also IMPANEL [v]\n",
  "IMPARADISE": "to put in a state like paradise; to make supremely happy [v IMPARADISED, IMPARADISING, IMPARADISES]\n",
  "IMPARADISED": "IMPARADISE, to put in a state like paradise; to make supremely happy [v]\n",
  "IMPARADISES": "IMPARADISE, to put in a state like paradise; to make supremely happy [v]\n",
  "IMPARADISING": "IMPARADISE, to put in a state like paradise; to make supremely happy [v]\n",
  "IMPARIDIGITATE": "having an odd number of fingers on each limb [adj]\n",
  "IMPARIPINNATE": "pinnate with the rachis terminated by a single leaflet or tendril [adj]\n",
  "IMPARISYLLABIC": "having different number of syllables in different cases [adj]\n",
  "IMPARITIES": "IMPARITY, lack of equality [n]\n",
  "IMPARITY": "lack of equality [n IMPARITIES]\n",
  "IMPARK": "to enclose in a park [v -ED, -ING, -S]\n",
  "IMPARKATION": "the act of imparking [n -S]\n",
  "IMPARKATIONS": "IMPARKATION, the act of imparking [n]\n",
  "IMPARKED": "IMPARK, to enclose in a park [v]\n",
  "IMPARKING": "IMPARK, to enclose in a park [v]\n",
  "IMPARKS": "IMPARK, to enclose in a park [v]\n",
  "IMPARL": "to talk over, also EMPARL [v -ED, -ING, -S]\n",
  "IMPARLANCE": "parleying, conference, also EMPARLAUNCE [n -S]\n",
  "IMPARLANCES": "IMPARLANCE, parleying, conference, also EMPARLAUNCE [n]\n",
  "IMPARLED": "IMPARL, to talk over, also EMPARL [v]\n",
  "IMPARLING": "IMPARL, to talk over, also EMPARL [v]\n",
  "IMPARLS": "IMPARL, to talk over, also EMPARL [v]\n",
  "IMPART": "to communicate, also EMPART [v -ED, -ING, -S]\n",
  "IMPARTABLE": "that can be imparted [adj]\n",
  "IMPARTATION": "the act of imparting [n -S]\n",
  "IMPARTATIONS": "IMPARTATION, the act of imparting [n]\n",
  "IMPARTED": "IMPART, to communicate, also EMPART [v]\n",
  "IMPARTER": "one who imparts [n -S]\n",
  "IMPARTERS": "IMPARTER, one who imparts [n]\n",
  "IMPARTIAL": "not partial, not biased [adj IMPARTIALLY]\n",
  "IMPARTIALITIES": "IMPARTIALITY, the state of being impartial [n]\n",
  "IMPARTIALITY": "the state of being impartial [n IMPARTIALITIES]\n",
  "IMPARTIALLY": "IMPARTIAL, not partial, not biased [adv]\n",
  "IMPARTIALNESS": "the state of being impartial [n -ES]\n",
  "IMPARTIALNESSES": "IMPARTIALNESS, the state of being impartial [n]\n",
  "IMPARTIBILITIES": "IMPARTIBILITY, the state of being impartible, of a field, that cannot be divided up [n]\n",
  "IMPARTIBILITY": "the state of being impartible, of a field, that cannot be divided up [n IMPARTIBILITIES]\n",
  "IMPARTIBLE": "of a field, that cannot be divided up [adj IMPARTIBLY]\n",
  "IMPARTIBLY": "IMPARTIBLE, of a field, that cannot be divided up [adv]\n",
  "IMPARTING": "IMPART, to communicate, also EMPART [v]\n",
  "IMPARTMENT": "the act of imparting [n -S]\n",
  "IMPARTMENTS": "IMPARTMENT, the act of imparting [n]\n",
  "IMPARTS": "IMPART, to communicate, also EMPART [v]\n",
  "IMPASSABILITIES": "IMPASSABILITY, the state of being impassable [n]\n",
  "IMPASSABILITY": "the state of being impassable [n IMPASSABILITIES]\n",
  "IMPASSABLE": "that cannot be passed [adj IMPASSABLY]\n",
  "IMPASSABLENESS": "IMPASSABLE, that cannot be passed [n]\n",
  "IMPASSABLY": "IMPASSABLE, that cannot be passed [adv]\n",
  "IMPASSE": "(French) a position from which there is no escape [n -S]\n",
  "IMPASSES": "IMPASSE, (French) a position from which there is no escape [n]\n",
  "IMPASSIBILITIES": "IMPASSIBILITY, the state of being impassible [n]\n",
  "IMPASSIBILITY": "the state of being impassible [n IMPASSIBILITIES]\n",
  "IMPASSIBLE": "not subject to suffering or pain [adj IMPASSIBLY]\n",
  "IMPASSIBLENESS": "the state of being impassible [n]\n",
  "IMPASSIBLY": "IMPASSIBLE, not subject to suffering or pain [adv]\n",
  "IMPASSION": "to arouse the passions of [v -ED, -ING, -S]\n",
  "IMPASSIONATE": "impassioned, also EMPASSIONATE [adj]\n",
  "IMPASSIONED": "IMPASSION, to arouse the passions of [v]\n",
  "IMPASSIONEDLY": "IMPASSIONED, IMPASSION, to arouse the passions of [adv]\n",
  "IMPASSIONEDNESS": "the state of being impassioned [n]\n",
  "IMPASSIONING": "IMPASSION, to arouse the passions of [v]\n",
  "IMPASSIONS": "IMPASSION, to arouse the passions of [v]\n",
  "IMPASSIVE": "not showing feeling or emotion [adj IMPASSIVELY]\n",
  "IMPASSIVELY": "IMPASSIVE, not showing feeling or emotion [adv]\n",
  "IMPASSIVENESS": "IMPASSIVE, not showing feeling or emotion [n]\n",
  "IMPASSIVENESSES": "IMPASSIVENESS, IMPASSIVE, not showing feeling or emotion [n]\n",
  "IMPASSIVITIES": "IMPASSIVITY, the quality of being impassive [n]\n",
  "IMPASSIVITY": "the quality of being impassive [n IMPASSIVITIES]\n",
  "IMPASTATION": "the act of impasting [n -S]\n",
  "IMPASTATIONS": "IMPASTATION, the act of impasting [n]\n",
  "IMPASTE": "to lay colours on thickly [v IMPASTED, IMPASTING, IMPASTES]\n",
  "IMPASTED": "IMPASTE, to lay colours on thickly [v]\n",
  "IMPASTES": "IMPASTE, to lay colours on thickly [v]\n",
  "IMPASTING": "IMPASTE, to lay colours on thickly [v]\n",
  "IMPASTO": "(Italian) the application of pigment thickly, in painting [n -S]\n",
  "IMPASTOED": "with impasto applied [adj]\n",
  "IMPASTOS": "IMPASTO, (Italian) the application of pigment thickly, in painting [n]\n",
  "IMPATIENCE": "the state of being impatient [n -S]\n",
  "IMPATIENCES": "IMPATIENCE, the state of being impatient [n]\n",
  "IMPATIENS": "(Latin) a genus of plants, so called because the elastic capsules burst when touched, and scatter the seeds with considerable force [n]\n",
  "IMPATIENT": "not patient [adj IMPATIENTLY]\n",
  "IMPATIENTLY": "IMPATIENT, not patient [adv]\n",
  "IMPAVE": "to set in a pavement [v IMPAVED, IMPAVING, IMPAVES]\n",
  "IMPAVED": "IMPAVE, to set in a pavement [v]\n",
  "IMPAVES": "IMPAVE, to set in a pavement [v]\n",
  "IMPAVID": "fearless; undaunted [adj IMPAVIDLY]\n",
  "IMPAVIDLY": "IMPAVID, fearless; undaunted [adv]\n",
  "IMPAVING": "IMPAVE, to set in a pavement [v]\n",
  "IMPAWN": "(archaic) to stake, compromise [v -ED, -ING, -S]\n",
  "IMPAWNED": "IMPAWN, (archaic) to stake, compromise [v]\n",
  "IMPAWNING": "IMPAWN, (archaic) to stake, compromise [v]\n",
  "IMPAWNS": "IMPAWN, (archaic) to stake, compromise [v]\n",
  "IMPEACH": "to accuse of impropriety, also EMPEACH [v -ED, -ING, -ES]\n",
  "IMPEACHABILITY": "the quality of being impeachable [n]\n",
  "IMPEACHABLE": "that can be impeached [adj]\n",
  "IMPEACHED": "IMPEACH, to accuse of impropriety, also EMPEACH [v]\n",
  "IMPEACHER": "one who impeaches [n -S]\n",
  "IMPEACHERS": "IMPEACHER, one who impeaches [n]\n",
  "IMPEACHES": "IMPEACH, to accuse of impropriety, also EMPEACH [v]\n",
  "IMPEACHING": "IMPEACH, to accuse of impropriety, also EMPEACH [v]\n",
  "IMPEACHMENT": "the act of impeaching [n -S]\n",
  "IMPEACHMENTS": "IMPEACHMENT, the act of impeaching [n]\n",
  "IMPEARL": "to make pearl-like [v -ED, -ING, -S]\n",
  "IMPEARLED": "IMPEARL, to make pearl-like [v]\n",
  "IMPEARLING": "IMPEARL, to make pearl-like [v]\n",
  "IMPEARLS": "IMPEARL, to make pearl-like [v]\n",
  "IMPECCABILITIES": "IMPECCABILITY, the state of being impeccable [n]\n",
  "IMPECCABILITY": "the state of being impeccable [n IMPECCABILITIES]\n",
  "IMPECCABLE": "faultless, flawless [adj IMPECCABLY]\n",
  "IMPECCABLY": "IMPECCABLE, faultless, flawless [adv]\n",
  "IMPECCANCIES": "IMPECCANCY, sinlessness [n]\n",
  "IMPECCANCY": "sinlessness [n IMPECCANCIES]\n",
  "IMPECCANT": "sinless; impeccable [adj]\n",
  "IMPECUNIOSITIES": "IMPECUNIOSITY, poverty [n]\n",
  "IMPECUNIOSITY": "poverty [n IMPECUNIOSITIES]\n",
  "IMPECUNIOUS": "without money; penniless [adj IMPECUNIOUSLY]\n",
  "IMPECUNIOUSLY": "IMPECUNIOUS, without money; penniless [adv]\n",
  "IMPECUNIOUSNESS": "IMPECUNIOUS, without money; penniless [n]\n",
  "IMPED": "IMP, to graft feathers onto a bird's wing, also YMPE [v]\n",
  "IMPEDANCE": "the measurement, in ohms, of opposition to an alternating current [n -S]\n",
  "IMPEDANCES": "IMPEDANCE, the measurement, in ohms, of opposition to an alternating current [n]\n",
  "IMPEDE": "to retard by obstructing [v IMPEDED, IMPEDING, IMPEDES]\n",
  "IMPEDED": "IMPEDE, to retard by obstructing [v]\n",
  "IMPEDER": "one that impedes [n -S]\n",
  "IMPEDERS": "IMPEDER, one that impedes [n]\n",
  "IMPEDES": "IMPEDE, to retard by obstructing [v]\n",
  "IMPEDIMENT": "something that impedes [n -S]\n",
  "IMPEDIMENTA": "things that impede; baggage [n]\n",
  "IMPEDIMENTAL": "causing hindrance; impeding [adj]\n",
  "IMPEDIMENTARY": "hindering [adj]\n",
  "IMPEDIMENTS": "IMPEDIMENT, something that impedes [n]\n",
  "IMPEDING": "IMPEDE, to retard by obstructing [v]\n",
  "IMPEDINGLY": "IMPEDING, IMPEDE, to retard by obstructing [adv]\n",
  "IMPEDITIVE": "causing hindrance; impeding [adj]\n",
  "IMPEDOR": "an electrical component, such as a capacitor or resistor, that offers impedance [n -S]\n",
  "IMPEDORS": "IMPEDOR, an electrical component, such as a capacitor or resistor, that offers impedance [n]\n",
  "IMPEL": "to drive forward [v IMPELLED, IMPELLING, IMPELS]\n",
  "IMPELLED": "IMPEL, to drive forward [v]\n",
  "IMPELLENT": "something with the quality of impelling [n -S]\n",
  "IMPELLENTS": "IMPELLENT, something with the quality of impelling [n]\n",
  "IMPELLER": "one that impels, also IMPELLOR [n -S]\n",
  "IMPELLERS": "IMPELLER, one that impels, also IMPELLOR [n]\n",
  "IMPELLING": "IMPEL, to drive forward [v]\n",
  "IMPELLOR": "one that impels, also IMPELLER [n -S]\n",
  "IMPELLORS": "IMPELLOR, one that impels, also IMPELLER [n]\n",
  "IMPELS": "IMPEL, to drive forward [v]\n",
  "IMPEND": "to be imminent [v -ED, -ING, -S]\n",
  "IMPENDED": "IMPEND, to be imminent [v]\n",
  "IMPENDENCE": "(obsolete) the state of impending; also, that which impends, also IMPENDENCY [n -S]\n",
  "IMPENDENCES": "IMPENDENCE, (obsolete) the state of impending; also, that which impends, also IMPENDENCY [n]\n",
  "IMPENDENCIES": "IMPENDENCY, (obsolete) the state of impending; also, that which impends, also IMPENDENCE [n]\n",
  "IMPENDENCY": "(obsolete) the state of impending; also, that which impends, also IMPENDENCE [n IMPENDENCIES]\n",
  "IMPENDENT": "impending; threatening [adj]\n",
  "IMPENDING": "IMPEND, to be imminent [v]\n",
  "IMPENDS": "IMPEND, to be imminent [v]\n",
  "IMPENETRABILITY": "the inability of two portions of matter to occupy the same space at the same time [n]\n",
  "IMPENETRABLE": "incapable of being penetrated or pierced [adj IMPENETRABLY]\n",
  "IMPENETRABLY": "IMPENETRABLE, incapable of being penetrated or pierced [adv]\n",
  "IMPENETRATE": "to penetrate thoroughly [v IMPENETRATED, IMPENETRATING, IMPENETRATES]\n",
  "IMPENETRATED": "IMPENETRATE, to penetrate thoroughly [v]\n",
  "IMPENETRATES": "IMPENETRATE, to penetrate thoroughly [v]\n",
  "IMPENETRATING": "IMPENETRATE, to penetrate thoroughly [v]\n",
  "IMPENETRATION": "thorough penetration [n -S]\n",
  "IMPENETRATIONS": "IMPENETRATION, thorough penetration [n]\n",
  "IMPENITENCE": "the state of being impenitent, also IMPENITENCY [n -S]\n",
  "IMPENITENCES": "IMPENITENCE, the state of being impenitent, also IMPENITENCY [n]\n",
  "IMPENITENCIES": "IMPENITENCY, the state of being impenitent, also IMPENITENCE [n]\n",
  "IMPENITENCY": "the state of being impenitent, also IMPENITENCE [n IMPENITENCIES]\n",
  "IMPENITENT": "not impenitent [adj IMPENITENTLY] / one who is not penitent [n -S]\n",
  "IMPENITENTLY": "IMPENITENT, not impenitent [adv]\n",
  "IMPENITENTNESS": "IMPENITENT, not impenitent [n]\n",
  "IMPENITENTS": "IMPENITENT, one who is not penitent [n]\n",
  "IMPENNATE": "featherless; wingless [adj]\n",
  "IMPERATIVAL": "relating to the imperative [adj]\n",
  "IMPERATIVE": "expressive of command, advice or request [adj IMPERATIVELY] / a verb in the imperative mood [n -S]\n",
  "IMPERATIVELY": "IMPERATIVE, expressive of command, advice or request [adv]\n",
  "IMPERATIVENESS": "IMPERATIVE, expressive of command, advice or request [n]\n",
  "IMPERATIVES": "IMPERATIVE, a verb in the imperative mood [n]\n",
  "IMPERATOR": "(Latin) a commander; an emperor [n -S]\n",
  "IMPERATORIAL": "like an imperator [adj IMPERATORIALLY]\n",
  "IMPERATORIALLY": "IMPERATORIAL, like an imperator [adv]\n",
  "IMPERATORS": "IMPERATOR, (Latin) a commander; an emperor [n]\n",
  "IMPERATORSHIP": "the office of imperator [n -S]\n",
  "IMPERATORSHIPS": "IMPERATORSHIP, the office of imperator [n]\n",
  "IMPERCEABLE": "(Spenser) not pierceable [adj]\n",
  "IMPERCEIVABLE": "imperceptible [adj]\n",
  "IMPERCEPTIBLE": "not perceptible [adj IMPERCEPTIBLY]\n",
  "IMPERCEPTIBLY": "IMPERCEPTIBLE, not perceptible [adv]\n",
  "IMPERCEPTION": "lack of perception [n -S]\n",
  "IMPERCEPTIONS": "IMPERCEPTION, lack of perception [n]\n",
  "IMPERCEPTIVE": "not perceptive [adj IMPERCEPTIVELY]\n",
  "IMPERCEPTIVELY": "IMPERCEPTIVE, not perceptive [adv]\n",
  "IMPERCEPTIVITY": "the state of being imperceptive [n]\n",
  "IMPERCIPIENCE": "the state of being imperceptive [n -S]\n",
  "IMPERCIPIENCES": "IMPERCIPIENCE, the state of being imperceptive [n]\n",
  "IMPERCIPIENT": "unperceptive [adj IMPERCIPIENTLY]\n",
  "IMPERCIPIENTLY": "IMPERCIPIENT, unperceptive [adv]\n",
  "IMPERFECT": "not perfect, also UNPERFECT [adj IMPERFECTER, IMPERFECTEST; IMPERFECTLY] / a verb tense expressing ongoing action in the past [n -S]\n",
  "IMPERFECTER": "IMPERFECT, not perfect, also UNPERFECT [adj]\n",
  "IMPERFECTEST": "IMPERFECT, not perfect, also UNPERFECT [adj]\n",
  "IMPERFECTIBLE": "not capable of being perfected [adj]\n",
  "IMPERFECTION": "the state of being imperfect [n -S]\n",
  "IMPERFECTIONS": "IMPERFECTION, the state of being imperfect [n]\n",
  "IMPERFECTIVE": "expressing action as incomplete or without reference to completion or as reiterated [adj IMPERFECTIVELY] / a tense expressing incomplete action [n -S]\n",
  "IMPERFECTIVELY": "IMPERFECTIVE, expressing action as incomplete or without reference to completion or as reiterated [adv]\n",
  "IMPERFECTIVES": "IMPERFECTIVE, a tense expressing incomplete action [n]\n",
  "IMPERFECTLY": "IMPERFECT, not perfect, also UNPERFECT [adv]\n",
  "IMPERFECTNESS": "the state of being imperfect [n -ES]\n",
  "IMPERFECTNESSES": "IMPERFECTNESS, the state of being imperfect [n]\n",
  "IMPERFECTS": "IMPERFECT, a verb tense expressing ongoing action in the past [n]\n",
  "IMPERFORABLE": "not able to be perforated [adj]\n",
  "IMPERFORATE": "not perforated into perforated rows, used of stamps and sheets of stamps, also IMPERFORATED [adj]\n",
  "IMPERFORATED": "not perforated into perforated rows, used of stamps and sheets of stamps, also IMPERFORATE [adj]\n",
  "IMPERFORATION": "the state of being imperforate [n -S]\n",
  "IMPERFORATIONS": "IMPERFORATION, the state of being imperforate [n]\n",
  "IMPERIA": "IMPERIUM, (Latin) empire, absolute power [n]\n",
  "IMPERIAL": "commanding [adj IMPERIALLY] / an emperor or member of an imperial family [n -S]\n",
  "IMPERIALISE": "to make imperial, also IMPERIALIZE [v IMPERIALISED, IMPERIALISING, IMPERIALISES]\n",
  "IMPERIALISED": "IMPERIALISE, to make imperial, also IMPERIALIZE [v]\n",
  "IMPERIALISES": "IMPERIALISE, to make imperial, also IMPERIALIZE [v]\n",
  "IMPERIALISING": "IMPERIALISE, to make imperial, also IMPERIALIZE [v]\n",
  "IMPERIALISM": "the policy, practice or advocacy of extension of a nation's power or influence over other territories [n -S]\n",
  "IMPERIALISMS": "IMPERIALISM, the policy, practice or advocacy of extension of a nation's power or influence over other territories [n]\n",
  "IMPERIALIST": "a supporter of imperialism [n -S]\n",
  "IMPERIALISTIC": "relating to imperialism [adj]\n",
  "IMPERIALISTS": "IMPERIALIST, a supporter of imperialism [n]\n",
  "IMPERIALITIES": "IMPERIALITY, the state of being imperial [n]\n",
  "IMPERIALITY": "the state of being imperial [n IMPERIALITIES]\n",
  "IMPERIALIZE": "to make imperial [v IMPERIALIZED, IMPERIALIZING, IMPERIALIZES]\n",
  "IMPERIALIZED": "IMPERIALIZE, to make imperial [v]\n",
  "IMPERIALIZES": "IMPERIALIZE, to make imperial [v]\n",
  "IMPERIALIZING": "IMPERIALIZE, to make imperial [v]\n",
  "IMPERIALLY": "IMPERIAL, commanding [adv]\n",
  "IMPERIALNESS": "the state of being imperial [n -ES]\n",
  "IMPERIALNESSES": "IMPERIALNESS, the state of being imperial [n]\n",
  "IMPERIALS": "IMPERIAL, an emperor or member of an imperial family [n]\n",
  "IMPERIL": "to put in danger, also PERIL [v IMPERILLED or IMPERILED, IMPERILLING or IMPERILING, IMPERILS]\n",
  "IMPERILED": "IMPERIL, to put in danger, also PERIL [v]\n",
  "IMPERILING": "IMPERIL, to put in danger, also PERIL [v]\n",
  "IMPERILLED": "IMPERIL, to put in danger, also PERIL [v]\n",
  "IMPERILLING": "IMPERIL, to put in danger, also PERIL [v]\n",
  "IMPERILMENT": "the act of imperilling [n -S]\n",
  "IMPERILMENTS": "IMPERILMENT, the act of imperilling [n]\n",
  "IMPERILS": "IMPERIL, to put in danger, also PERIL [v]\n",
  "IMPERIOUS": "assuming command; haughty [adj IMPERIOUSLY]\n",
  "IMPERIOUSLY": "IMPERIOUS, assuming command; haughty [adv]\n",
  "IMPERIOUSNESS": "IMPERIOUS, assuming command; haughty [n]\n",
  "IMPERIOUSNESSES": "IMPERIOUSNESS, IMPERIOUS, assuming command; haughty [n]\n",
  "IMPERISHABILITY": "the state of being imperishable [n]\n",
  "IMPERISHABLE": "not perishable or subject to decay [adj IMPERISHABLY] / something imperishable [n -S]\n",
  "IMPERISHABLES": "IMPERISHABLE, something imperishable [n]\n",
  "IMPERISHABLY": "IMPERISHABLE, not perishable or subject to decay [adv]\n",
  "IMPERIUM": "(Latin) empire, absolute power [n IMPERIUMS or IMPERIA]\n",
  "IMPERIUMS": "IMPERIUM, (Latin) empire, absolute power [n]\n",
  "IMPERMANENCE": "the state of being impermanent, also IMPERMANENCY [n -S]\n",
  "IMPERMANENCES": "IMPERMANENCE, the state of being impermanent, also IMPERMANENCY [n]\n",
  "IMPERMANENCIES": "IMPERMANENCY, the state of being impermanent, also IMPERMANENCE [n]\n",
  "IMPERMANENCY": "the state of being impermanent, also IMPERMANENCE [n IMPERMANENCIES]\n",
  "IMPERMANENT": "not permanent [adj IMPERMANENTLY]\n",
  "IMPERMANENTLY": "IMPERMANENT, not permanent [adv]\n",
  "IMPERMEABILITY": "the state of being impermeable [n]\n",
  "IMPERMEABLE": "that cannot be permeated [adj]\n",
  "IMPERMEABLENESS": "IMPERMEABLE, that cannot be permeated [n]\n",
  "IMPERMEABLY": "IMPERMEABLE, that cannot be permeated [adv]\n",
  "IMPERMISSIBLE": "not permissible [adj IMPERMISSIBLY]\n",
  "IMPERMISSIBLY": "IMPERMISSIBLE, not permissible [adv]\n",
  "IMPERSCRIPTIBLE": "not supported by written authority [adj]\n",
  "IMPERSEVERANT": "lacking the power to perceive [adj]\n",
  "IMPERSISTENT": "not persistent [adj]\n",
  "IMPERSONAL": "denoting the verbal action of an unspecified agent and hence used with no expressed subject (as methinks) or with a merely formal subject (as rained in it rained) [adj IMPERSONALLY]\n",
  "IMPERSONALISE": "to make impersonal, also IMPERSONALIZE [v IMPERSONALISED, IMPERSONALISING, IMPERSONALISES]\n",
  "IMPERSONALISED": "IMPERSONALISE, to make impersonal, also IMPERSONALIZE [v]\n",
  "IMPERSONALISES": "IMPERSONALISE, to make impersonal, also IMPERSONALIZE [v]\n",
  "IMPERSONALISING": "IMPERSONALISE, to make impersonal, also IMPERSONALIZE [v]\n",
  "IMPERSONALITIES": "IMPERSONALITY, the state of being impersonal [n]\n",
  "IMPERSONALITY": "the state of being impersonal [n IMPERSONALITIES]\n",
  "IMPERSONALIZE": "to make impersonal, also IMPERSONALISE [v IMPERSONALIZED, IMPERSONALIZING, IMPERSONALIZES]\n",
  "IMPERSONALIZED": "IMPERSONALIZE, to make impersonal, also IMPERSONALISE [v]\n",
  "IMPERSONALIZES": "IMPERSONALIZE, to make impersonal, also IMPERSONALISE [v]\n",
  "IMPERSONALIZING": "IMPERSONALIZE, to make impersonal, also IMPERSONALISE [v]\n",
  "IMPERSONALLY": "IMPERSONAL, denoting the verbal action of an unspecified agent and hence used with no expressed subject (as methinks) or with a merely formal subject (as rained in it rained) [adv]\n",
  "IMPERSONATE": "to assume or act the character of [v IMPERSONATED, IMPERSONATING, IMPERSONATES]\n",
  "IMPERSONATED": "IMPERSONATE, to assume or act the character of [v]\n",
  "IMPERSONATES": "IMPERSONATE, to assume or act the character of [v]\n",
  "IMPERSONATING": "IMPERSONATE, to assume or act the character of [v]\n",
  "IMPERSONATION": "the act of impersonating [n -S]\n",
  "IMPERSONATIONS": "IMPERSONATION, the act of impersonating [n]\n",
  "IMPERSONATOR": "one who impersonates [n -S]\n",
  "IMPERSONATORS": "IMPERSONATOR, one who impersonates [n]\n",
  "IMPERTINENCE": "impudence; lack of pertinence, also IMPERTINENCY [n -S]\n",
  "IMPERTINENCES": "IMPERTINENCE, impudence; lack of pertinence, also IMPERTINENCY [n]\n",
  "IMPERTINENCIES": "IMPERTINENCY, impudence; lack of pertinence, also IMPERTINENCE [n]\n",
  "IMPERTINENCY": "impudence; lack of pertinence, also IMPERTINENCE [n IMPERTINENCIES]\n",
  "IMPERTINENT": "given to or characterized by insolent rudeness [adj IMPERTINENTLY]\n",
  "IMPERTINENTLY": "IMPERTINENT, given to or characterized by insolent rudeness [adv]\n",
  "IMPERTURBABLE": "marked by extreme calm, impassivity, and steadiness [adj IMPERTURBABLY]\n",
  "IMPERTURBABLY": "IMPERTURBABLE, marked by extreme calm, impassivity, and steadiness [adv]\n",
  "IMPERTURBATION": "the state of being unperturbed [n -S]\n",
  "IMPERTURBATIONS": "IMPERTURBATION, the state of being unperturbed [n]\n",
  "IMPERVIABILITY": "the quality of being imperviable [n]\n",
  "IMPERVIABLE": "not able to be penetrated, also IMPERVIOUS [adj]\n",
  "IMPERVIABLENESS": "IMPERVIABLE, not able to be penetrated, also IMPERVIOUS [n]\n",
  "IMPERVIOUS": "not allowing entrance or passage, also IMPERVIABLE [adj IMPERVIOUSLY]\n",
  "IMPERVIOUSLY": "IMPERVIOUS, not allowing entrance or passage, also IMPERVIABLE [adv]\n",
  "IMPERVIOUSNESS": "IMPERVIOUS, not allowing entrance or passage, also IMPERVIABLE [n]\n",
  "IMPETICOS": "(Shakespeare) a word of doubtful meaning, perhaps to impocket [v IMPETICOSSED, IMPETICOSSING, IMPETICOSSES]\n",
  "IMPETICOSSED": "IMPETICOS, (Shakespeare) a word of doubtful meaning, perhaps to impocket [v]\n",
  "IMPETICOSSES": "IMPETICOS, (Shakespeare) a word of doubtful meaning, perhaps to impocket [v]\n",
  "IMPETICOSSING": "IMPETICOS, (Shakespeare) a word of doubtful meaning, perhaps to impocket [v]\n",
  "IMPETIGINES": "IMPETIGO, (Latin) a skin disease [n]\n",
  "IMPETIGINOUS": "suffering from impetigo [adj]\n",
  "IMPETIGO": "(Latin) a skin disease [n IMPETIGOS or IMPETIGINES]\n",
  "IMPETIGOS": "IMPETIGO, (Latin) a skin disease [n]\n",
  "IMPETRATE": "to obtain by entreaty, request or prayer [v IMPETRATED, IMPETRATING, IMPETRATES]\n",
  "IMPETRATED": "IMPETRATE, to obtain by entreaty, request or prayer [v]\n",
  "IMPETRATES": "IMPETRATE, to obtain by entreaty, request or prayer [v]\n",
  "IMPETRATING": "IMPETRATE, to obtain by entreaty, request or prayer [v]\n",
  "IMPETRATION": "seeking by entreaty [n -S]\n",
  "IMPETRATIONS": "IMPETRATION, seeking by entreaty [n]\n",
  "IMPETRATIVE": "relating to impetration, also IMPETRATORY [adj]\n",
  "IMPETRATOR": "one who impetrates, obtains by entreaty [n -S]\n",
  "IMPETRATORS": "IMPETRATOR, one who impetrates, obtains by entreaty [n]\n",
  "IMPETRATORY": "relating to impetration, also IMPETRATIVE [adj]\n",
  "IMPETUOSITIES": "IMPETUOSITY, the state of being impetuous [n]\n",
  "IMPETUOSITY": "the state of being impetuous [n IMPETUOSITIES]\n",
  "IMPETUOUS": "tending to act in a rash or impulsive manner [adj IMPETUOUSLY]\n",
  "IMPETUOUSLY": "IMPETUOUS, tending to act in a rash or impulsive manner [adv]\n",
  "IMPETUOUSNESS": "IMPETUOUS, tending to act in a rash or impulsive manner [n]\n",
  "IMPETUOUSNESSES": "IMPETUOUSNESS, IMPETUOUS, tending to act in a rash or impulsive manner [n]\n",
  "IMPETUS": "(Latin) the force or energy with which a body moves [n -ES]\n",
  "IMPETUSES": "IMPETUS, (Latin) the force or energy with which a body moves [n]\n",
  "IMPHEE": "(Zulu) any of several southern African varieties of sorghum [n -S]\n",
  "IMPHEES": "IMPHEE, (Zulu) any of several southern African varieties of sorghum [n]\n",
  "IMPI": "(Zulu) a regiment of Zulu warriors [n IMPIS or IMPIES]\n",
  "IMPICTURED": "(Spenser) painted [adj]\n",
  "IMPIERCEABLE": "(obsolete) not pierceable [adj]\n",
  "IMPIES": "IMPI, (Zulu) a regiment of Zulu warriors [n]\n",
  "IMPIETIES": "IMPIETY, lack of piety [n]\n",
  "IMPIETY": "lack of piety [n IMPIETIES]\n",
  "IMPIGNORATE": "to pledge, pawn or mortgage [v IMPIGNORATED, IMPIGNORATING, IMPIGNORATES]\n",
  "IMPIGNORATED": "IMPIGNORATE, to pledge, pawn or mortgage [v]\n",
  "IMPIGNORATES": "IMPIGNORATE, to pledge, pawn or mortgage [v]\n",
  "IMPIGNORATING": "IMPIGNORATE, to pledge, pawn or mortgage [v]\n",
  "IMPIGNORATION": "the state of being mortgaged [n -S]\n",
  "IMPIGNORATIONS": "IMPIGNORATION, the state of being mortgaged [n]\n",
  "IMPING": "the process of engrafting a hawk with new feathers [n -S]\n",
  "IMPINGE": "to collide with [v IMPINGED, IMPINGING, IMPINGES]\n",
  "IMPINGED": "IMPINGE, to collide with [v]\n",
  "IMPINGEMENT": "the act of impinging [n -S]\n",
  "IMPINGEMENTS": "IMPINGEMENT, the act of impinging [n]\n",
  "IMPINGENT": "striking against or upon [adj]\n",
  "IMPINGER": "one that impinges [n -S]\n",
  "IMPINGERS": "IMPINGER, one that impinges [n]\n",
  "IMPINGES": "IMPINGE, to collide with [v]\n",
  "IMPINGING": "IMPINGE, to collide with [v]\n",
  "IMPINGS": "IMPING, the process of engrafting a hawk with new feathers [n]\n",
  "IMPIOUS": "not pious [adj IMPIOUSLY]\n",
  "IMPIOUSLY": "IMPIOUS, not pious [adv]\n",
  "IMPIOUSNESS": "the state of being impious [n -ES]\n",
  "IMPIOUSNESSES": "IMPIOUSNESS, the state of being impious [n]\n",
  "IMPIS": "IMPI, (Zulu) a regiment of Zulu warriors [n]\n",
  "IMPISH": "mischievous [adj IMPISHLY]\n",
  "IMPISHLY": "IMPISH, mischievous [adv]\n",
  "IMPISHNESS": "the quality of being impish [n -ES]\n",
  "IMPISHNESSES": "IMPISHNESS, the quality of being impish [n]\n",
  "IMPLACABILITIES": "IMPLACABILITY, the state of being implacable [n]\n",
  "IMPLACABILITY": "the state of being implacable [n IMPLACABILITIES]\n",
  "IMPLACABLE": "incapable of being placated [adj IMPLACABLY]\n",
  "IMPLACABLENESS": "the state of being implacable [n]\n",
  "IMPLACABLY": "IMPLACABLE, incapable of being placated [adv]\n",
  "IMPLACENTAL": "having no placenta, also APLACENTAL [adj]\n",
  "IMPLANT": "to plant firmly [v -ED, -ING, -S]\n",
  "IMPLANTABLE": "capable of being implanted [adj]\n",
  "IMPLANTATION": "the act of implanting something [n -S]\n",
  "IMPLANTATIONS": "IMPLANTATION, the act of implanting something [n]\n",
  "IMPLANTED": "IMPLANT, to plant firmly [v]\n",
  "IMPLANTER": "one who implants [n -S]\n",
  "IMPLANTERS": "IMPLANTER, one who implants [n]\n",
  "IMPLANTING": "IMPLANT, to plant firmly [v]\n",
  "IMPLANTS": "IMPLANT, to plant firmly [v]\n",
  "IMPLATE": "to put a covering plate over [v IMPLATED, IMPLATING, IMPLATES]\n",
  "IMPLATED": "IMPLATE, to put a covering plate over [v]\n",
  "IMPLATES": "IMPLATE, to put a covering plate over [v]\n",
  "IMPLATING": "IMPLATE, to put a covering plate over [v]\n",
  "IMPLAUSIBILITY": "the state of being implausible [n]\n",
  "IMPLAUSIBLE": "not plausible, also UNPLAUSIBLE [adj IMPLAUSIBLY]\n",
  "IMPLAUSIBLENESS": "IMPLAUSIBLE, not plausible, also UNPLAUSIBLE [n]\n",
  "IMPLAUSIBLY": "IMPLAUSIBLE, not plausible, also UNPLAUSIBLE [adv]\n",
  "IMPLEACH": "to intertwine, also EMPLEACH [v -ED, -ING, -ES]\n",
  "IMPLEACHED": "IMPLEACH, to intertwine, also EMPLEACH [v]\n",
  "IMPLEACHES": "IMPLEACH, to intertwine, also EMPLEACH [v]\n",
  "IMPLEACHING": "IMPLEACH, to intertwine, also EMPLEACH [v]\n",
  "IMPLEAD": "to sue in a court of law [v IMPLED or IMPLEADED, IMPLEADING, IMPLEADS]\n",
  "IMPLEADABLE": "that can be impleaded [adj]\n",
  "IMPLEADED": "IMPLEAD, to sue in a court of law [v]\n",
  "IMPLEADER": "one who prosecutes or sues another [n -S]\n",
  "IMPLEADERS": "IMPLEADER, one who prosecutes or sues another [n]\n",
  "IMPLEADING": "IMPLEAD, to sue in a court of law [v]\n",
  "IMPLEADS": "IMPLEAD, to sue in a court of law [v]\n",
  "IMPLED": "IMPLEAD, to sue in a court of law [v]\n",
  "IMPLEDGE": "to pawn, put in pledge [v IMPLEDGED, IMPLEDGING, IMPLEDGES]\n",
  "IMPLEDGED": "IMPLEDGE, to pawn, put in pledge [v]\n",
  "IMPLEDGES": "IMPLEDGE, to pawn, put in pledge [v]\n",
  "IMPLEDGING": "IMPLEDGE, to pawn, put in pledge [v]\n",
  "IMPLEMENT": "to put into practice [v -ED, -ING, -S]\n",
  "IMPLEMENTAL": "instrumental, effective [adj]\n",
  "IMPLEMENTATION": "the act of implementing [n -S]\n",
  "IMPLEMENTATIONS": "IMPLEMENTATION, the act of implementing [n]\n",
  "IMPLEMENTED": "IMPLEMENT, to put into practice [v]\n",
  "IMPLEMENTER": "one who implements, also IMPLEMENTOR [n -S]\n",
  "IMPLEMENTERS": "IMPLEMENTER, one who implements, also IMPLEMENTOR [n]\n",
  "IMPLEMENTING": "IMPLEMENT, to put into practice [v]\n",
  "IMPLEMENTOR": "one who implements, also IMPLEMENTER [n -S]\n",
  "IMPLEMENTORS": "IMPLEMENTOR, one who implements, also IMPLEMENTER [n]\n",
  "IMPLEMENTS": "IMPLEMENT, to put into practice [v]\n",
  "IMPLETE": "(archaic) to fill [v IMPLETED, IMPLETING, IMPLETES]\n",
  "IMPLETED": "IMPLETE, (archaic) to fill [v]\n",
  "IMPLETES": "IMPLETE, (archaic) to fill [v]\n",
  "IMPLETING": "IMPLETE, (archaic) to fill [v]\n",
  "IMPLETION": "filling, fullness [n -S]\n",
  "IMPLETIONS": "IMPLETION, filling, fullness [n]\n",
  "IMPLEX": "(Latin) a muscle attachment in jointed creatures like centipedes [n -ES]\n",
  "IMPLEXES": "IMPLEX, (Latin) a muscle attachment in jointed creatures like centipedes [n]\n",
  "IMPLEXION": "the act of involving, or state of being involved [n -S]\n",
  "IMPLEXIONS": "IMPLEXION, the act of involving, or state of being involved [n]\n",
  "IMPLEXUOUS": "not simple; involved; complicated [adj]\n",
  "IMPLICATE": "to involve, to entangle [v IMPLICATED, IMPLICATING, IMPLICATES]\n",
  "IMPLICATED": "IMPLICATE, to involve, to entangle [v]\n",
  "IMPLICATES": "IMPLICATE, to involve, to entangle [v]\n",
  "IMPLICATING": "IMPLICATE, to involve, to entangle [v]\n",
  "IMPLICATION": "something implied [n -S]\n",
  "IMPLICATIONAL": "of the nature of implication [adj]\n",
  "IMPLICATIONS": "IMPLICATION, something implied [n]\n",
  "IMPLICATIVE": "tending to implicate [adj IMPLICATIVELY]\n",
  "IMPLICATIVELY": "IMPLICATIVE, tending to implicate [adv]\n",
  "IMPLICATIVENESS": "IMPLICATIVE, tending to implicate [n]\n",
  "IMPLICATURE": "the act of implying a meaning other than the literal meaning of a statement [n -S]\n",
  "IMPLICATURES": "IMPLICATURE, the act of implying a meaning other than the literal meaning of a statement [n]\n",
  "IMPLICIT": "implied but not stated [adj IMPLICITLY]\n",
  "IMPLICITIES": "IMPLICITY, a state of being implicit [n]\n",
  "IMPLICITLY": "IMPLICIT, implied but not stated [adv]\n",
  "IMPLICITNESS": "the state of being implicit [n -ES]\n",
  "IMPLICITNESSES": "IMPLICITNESS, the state of being implicit [n]\n",
  "IMPLICITY": "a state of being implicit [n IMPLICITIES]\n",
  "IMPLIED": "IMPLY, to insinuate [v]\n",
  "IMPLIEDLY": "IMPLIED, IMPLY, to insinuate [adv]\n",
  "IMPLIES": "IMPLY, to insinuate [v]\n",
  "IMPLODE": "to collapse inward [v IMPLODED, IMPLODING, IMPLODES]\n",
  "IMPLODED": "IMPLODE, to collapse inward [v]\n",
  "IMPLODENT": "an implosive sound [n -S]\n",
  "IMPLODENTS": "IMPLODENT, an implosive sound [n]\n",
  "IMPLODES": "IMPLODE, to collapse inward [v]\n",
  "IMPLODING": "IMPLODE, to collapse inward [v]\n",
  "IMPLORATION": "the act of imploring [n -S]\n",
  "IMPLORATIONS": "IMPLORATION, the act of imploring [n]\n",
  "IMPLORATOR": "(Shakespeare) one who implores [n -S]\n",
  "IMPLORATORS": "IMPLORATOR, (Shakespeare) one who implores [n]\n",
  "IMPLORATORY": "having an imploring quality [adj]\n",
  "IMPLORE": "to beg for urgently [v IMPLORED, IMPLORING, IMPLORES]\n",
  "IMPLORED": "IMPLORE, to beg for urgently [v]\n",
  "IMPLORER": "one who implores [n -S]\n",
  "IMPLORERS": "IMPLORER, one who implores [n]\n",
  "IMPLORES": "IMPLORE, to beg for urgently [v]\n",
  "IMPLORING": "IMPLORE, to beg for urgently [v]\n",
  "IMPLORINGLY": "IMPLORING, IMPLORE, to beg for urgently [adv]\n",
  "IMPLOSION": "the act of imploding [n -S]\n",
  "IMPLOSIONS": "IMPLOSION, the act of imploding [n]\n",
  "IMPLOSIVE": "of or relating to implosion [adj IMPLOSIVELY] / an implosive consonant [n -S]\n",
  "IMPLOSIVELY": "IMPLOSIVE, of or relating to implosion [adv]\n",
  "IMPLOSIVES": "IMPLOSIVE, an implosive consonant [n]\n",
  "IMPLUNGE": "to plunge, also EMPLONGE [v IMPLUNGED, IMPLUNGING, IMPLUNGES]\n",
  "IMPLUNGED": "IMPLUNGE, to plunge, also EMPLONGE [v]\n",
  "IMPLUNGES": "IMPLUNGE, to plunge, also EMPLONGE [v]\n",
  "IMPLUNGING": "IMPLUNGE, to plunge, also EMPLONGE [v]\n",
  "IMPLUVIA": "IMPLUVIUM, (Latin) a rain water receptacle in Roman houses [n]\n",
  "IMPLUVIUM": "(Latin) a rain water receptacle in Roman houses [n IMPLUVIA]\n",
  "IMPLY": "to insinuate [v IMPLIED, IMPLYING, IMPLIES]\n",
  "IMPLYING": "IMPLY, to insinuate [v]\n",
  "IMPOCKET": "(archaic) to put in one's pocket [v -ED, -ING, -S]\n",
  "IMPOCKETED": "IMPOCKET, (archaic) to put in one's pocket [v]\n",
  "IMPOCKETING": "IMPOCKET, (archaic) to put in one's pocket [v]\n",
  "IMPOCKETS": "IMPOCKET, (archaic) to put in one's pocket [v]\n",
  "IMPOLDER": "(Dutch) to reclaim low-lying land, also EMPOLDER [v -ED, -ING, -S]\n",
  "IMPOLDERED": "IMPOLDER, (Dutch) to reclaim low-lying land, also EMPOLDER [v]\n",
  "IMPOLDERING": "IMPOLDER, (Dutch) to reclaim low-lying land, also EMPOLDER [v]\n",
  "IMPOLDERS": "IMPOLDER, (Dutch) to reclaim low-lying land, also EMPOLDER [v]\n",
  "IMPOLICIES": "IMPOLICY, an instance of being impolite [n]\n",
  "IMPOLICY": "an instance of being impolite [n IMPOLICIES]\n",
  "IMPOLITE": "having bad manners [adj IMPOLITER, IMPOLITEST, IMPOLITELY]\n",
  "IMPOLITELY": "IMPOLITE, having bad manners [adv]\n",
  "IMPOLITENESS": "the state of being impolite [n -ES]\n",
  "IMPOLITENESSES": "IMPOLITENESS, the state of being impolite [n]\n",
  "IMPOLITER": "IMPOLITE, having bad manners [adj]\n",
  "IMPOLITEST": "IMPOLITE, having bad manners [adj]\n",
  "IMPOLITIC": "not politic, also IMPOLITICAL, UNPOLITIC [adj IMPOLITICLY or IMPOLITICALLY]\n",
  "IMPOLITICAL": "(obsolete) impolitic, also IMPOLITIC, UNPOLITIC [adj IMPOLITICALLY]\n",
  "IMPOLITICALLY": "IMPOLITICAL, (obsolete) impolitic, also IMPOLITIC, UNPOLITIC [adv]\n",
  "IMPOLITICLY": "IMPOLITIC, not politic, also IMPOLITICAL, UNPOLITIC [adv]\n",
  "IMPOLITICNESS": "the state of being impolitic [n -ES]\n",
  "IMPOLITICNESSES": "IMPOLITICNESS, the state of being impolitic [n]\n",
  "IMPONDERABILIA": "factors in a situation whose influence cannot be gauged or evaluated [n]\n",
  "IMPONDERABILITY": "the state of being imponderable [n]\n",
  "IMPONDERABLE": "not ponderable [adj IMPONDERABLY] / something not ponderable [n -S]\n",
  "IMPONDERABLES": "IMPONDERABLE, something not ponderable [n]\n",
  "IMPONDERABLY": "IMPONDERABLE, not ponderable [adv]\n",
  "IMPONDEROUS": "weightless, very light [adj]\n",
  "IMPONE": "to impose; to wager [v IMPONED, IMPONING, IMPONES]\n",
  "IMPONED": "IMPONE, to impose; to wager [v]\n",
  "IMPONENT": "someone who imposes an obligation [n -S]\n",
  "IMPONENTS": "IMPONENT, someone who imposes an obligation [n]\n",
  "IMPONES": "IMPONE, to impose; to wager [v]\n",
  "IMPONING": "IMPONE, to impose; to wager [v]\n",
  "IMPOROUS": "extremely dense [adj]\n",
  "IMPORT": "to bring in from an outside source [v -ED, -ING, -S]\n",
  "IMPORTABILITIES": "IMPORTABILITY, the quality of being importable [n]\n",
  "IMPORTABILITY": "the quality of being importable [n IMPORTABILITIES]\n",
  "IMPORTABLE": "capable of being imported [adj]\n",
  "IMPORTANCE": "the state of being important, also IMPORTANCY [n -S]\n",
  "IMPORTANCES": "IMPORTANCE, the state of being important, also IMPORTANCY [n]\n",
  "IMPORTANCIES": "IMPORTANCY, (obsolete) importance, also IMPORTANCE [n]\n",
  "IMPORTANCY": "(obsolete) importance, also IMPORTANCE [n IMPORTANCIES]\n",
  "IMPORTANT": "of great import or consequence [adj IMPORTANTLY]\n",
  "IMPORTANTLY": "IMPORTANT, of great import or consequence [adv]\n",
  "IMPORTATION": "the act or practice of importing [n -S]\n",
  "IMPORTATIONS": "IMPORTATION, the act or practice of importing [n]\n",
  "IMPORTED": "IMPORT, to bring in from an outside source [v]\n",
  "IMPORTER": "one that imports [n -S]\n",
  "IMPORTERS": "IMPORTER, one that imports [n]\n",
  "IMPORTING": "the act of importing [n -S]\n",
  "IMPORTINGS": "IMPORTING, the act of importing [n]\n",
  "IMPORTS": "IMPORT, to bring in from an outside source [v]\n",
  "IMPORTUNACIES": "IMPORTUNACY, the state of being importunate [n]\n",
  "IMPORTUNACY": "the state of being importunate [n IMPORTUNACIES]\n",
  "IMPORTUNATE": "stubbornly or unreasonably persistent [adj IMPORTUNATELY]\n",
  "IMPORTUNATELY": "IMPORTUNATE, stubbornly or unreasonably persistent [adv]\n",
  "IMPORTUNATENESS": "IMPORTUNATE, stubbornly or unreasonably persistent [n]\n",
  "IMPORTUNE": "importunate [adj IMPORTUNELY] / to press or urge with repeated requests [v IMPORTUNED, IMPORTUNING, IMPORTUNES]\n",
  "IMPORTUNED": "IMPORTUNE, to press or urge with repeated requests [v]\n",
  "IMPORTUNELY": "IMPORTUNE, importunate [adv]\n",
  "IMPORTUNER": "one who importunes [n -S]\n",
  "IMPORTUNERS": "IMPORTUNER, one who importunes [n]\n",
  "IMPORTUNES": "IMPORTUNE, to press or urge with repeated requests [v]\n",
  "IMPORTUNING": "the act of importuning, making urgent requests [n -S]\n",
  "IMPORTUNINGS": "IMPORTUNING, the act of importuning, making urgent requests [n]\n",
  "IMPORTUNITIES": "IMPORTUNITY, the state of being importunate [n]\n",
  "IMPORTUNITY": "the state of being importunate [n IMPORTUNITIES]\n",
  "IMPOSABLE": "capable of being imposed or laid on [adj]\n",
  "IMPOSE": "to set as a burden or task [v IMPOSED, IMPOSING, IMPOSES]\n",
  "IMPOSED": "IMPOSE, to set as a burden or task [v]\n",
  "IMPOSER": "one who imposes [n -S]\n",
  "IMPOSERS": "IMPOSER, one who imposes [n]\n",
  "IMPOSES": "IMPOSE, to set as a burden or task [v]\n",
  "IMPOSEX": "the superimposition of male sexual characteristics onto female gastropods, caused by certain pollutants [n -ES]\n",
  "IMPOSEXES": "IMPOSEX, the superimposition of male sexual characteristics onto female gastropods, caused by certain pollutants [n]\n",
  "IMPOSING": "impressive [adj IMPOSINGLY]\n",
  "IMPOSINGLY": "IMPOSING, impressive [adv]\n",
  "IMPOSINGNESS": "the state of being imposing [n -ES]\n",
  "IMPOSINGNESSES": "IMPOSINGNESS, the state of being imposing [n]\n",
  "IMPOSITION": "the act of imposing [n -S]\n",
  "IMPOSITIONS": "IMPOSITION, the act of imposing [n]\n",
  "IMPOSSIBILISM": "belief in or advocacy of an impracticable policy [n -S]\n",
  "IMPOSSIBILISMS": "IMPOSSIBILISM, belief in or advocacy of an impracticable policy [n]\n",
  "IMPOSSIBILIST": "one who believes in or advocates an impracticable policy [n -S]\n",
  "IMPOSSIBILISTS": "IMPOSSIBILIST, one who believes in or advocates an impracticable policy [n]\n",
  "IMPOSSIBILITIES": "IMPOSSIBILITY, the state of being impossible [n]\n",
  "IMPOSSIBILITY": "the state of being impossible [n IMPOSSIBILITIES]\n",
  "IMPOSSIBLE": "not possible [adj IMPOSSIBLY] / an impossible thing [n -S]\n",
  "IMPOSSIBLENESS": "IMPOSSIBLE, not possible [n]\n",
  "IMPOSSIBLES": "IMPOSSIBLE, an impossible thing [n]\n",
  "IMPOSSIBLY": "IMPOSSIBLE, not possible [adv]\n",
  "IMPOST": "to determine customs duties [v -ED, -ING, -S]\n",
  "IMPOSTED": "IMPOST, to determine customs duties [v]\n",
  "IMPOSTER": "one who poses as another to deceive, also IMPOSTOR [n -S]\n",
  "IMPOSTERS": "IMPOSTER, one who poses as another to deceive, also IMPOSTOR [n]\n",
  "IMPOSTHUMATE": "to form or inflict an abscess, also IMPOSTUMATE [v IMPOSTHUMATED, IMPOSTHUMATING, IMPOSTHUMATES]\n",
  "IMPOSTHUMATED": "IMPOSTHUMATE, to form or inflict an abscess, also IMPOSTUMATE [v]\n",
  "IMPOSTHUMATES": "IMPOSTHUMATE, to form or inflict an abscess, also IMPOSTUMATE [v]\n",
  "IMPOSTHUMATING": "IMPOSTHUMATE, to form or inflict an abscess, also IMPOSTUMATE [v]\n",
  "IMPOSTHUMATION": "the act of forming an imposthume, an abscess, also IMPOSTUMATION [n -S]\n",
  "IMPOSTHUMATIONS": "IMPOSTHUMATION, the act of forming an imposthume, an abscess, also IMPOSTUMATION [n]\n",
  "IMPOSTHUME": "(archaic) an abscess, also IMPOSTUME [n -S]\n",
  "IMPOSTHUMED": "having an imposthume, an abscess, also IMPOSTUMED [adj]\n",
  "IMPOSTHUMES": "IMPOSTHUME, (archaic) an abscess, also IMPOSTUME [n]\n",
  "IMPOSTING": "IMPOST, to determine customs duties [v]\n",
  "IMPOSTOR": "one who poses as another to deceive, also IMPOSTER [n -S]\n",
  "IMPOSTOROUS": "relating to imposture, also IMPOSTUROUS [adj]\n",
  "IMPOSTORS": "IMPOSTOR, one who poses as another to deceive, also IMPOSTER [n]\n",
  "IMPOSTROUS": "doing imposture [adj]\n",
  "IMPOSTS": "IMPOST, to determine customs duties [v]\n",
  "IMPOSTUMATE": "to form or inflict an abscess, also IMPOSTHUMATE [v IMPOSTUMATED, IMPOSTUMATING, IMPOSTUMATES]\n",
  "IMPOSTUMATED": "IMPOSTUMATE, to form or inflict an abscess, also IMPOSTHUMATE [v]\n",
  "IMPOSTUMATES": "IMPOSTUMATE, to form or inflict an abscess, also IMPOSTHUMATE [v]\n",
  "IMPOSTUMATING": "IMPOSTUMATE, to form or inflict an abscess, also IMPOSTHUMATE [v]\n",
  "IMPOSTUMATION": "the formation of an abscess, also IMPOSTHUMATION [n -S]\n",
  "IMPOSTUMATIONS": "IMPOSTUMATION, the formation of an abscess, also IMPOSTHUMATION [n]\n",
  "IMPOSTUME": "(archaic) an abscess, also IMPOSTHUME [n -S]\n",
  "IMPOSTUMED": "having an impostume, an abscess, also IMPOSTHUMED [adj]\n",
  "IMPOSTUMES": "IMPOSTUME, (archaic) an abscess, also IMPOSTHUME [n]\n",
  "IMPOSTURE": "a fraud, the act of an impostor [n -S]\n",
  "IMPOSTURES": "IMPOSTURE, a fraud, the act of an impostor [n]\n",
  "IMPOSTUROUS": "relating to imposture, also IMPOSTOROUS [adj]\n",
  "IMPOT": "(slang) an imposition, a punishment task given to schoolchildren [n -S]\n",
  "IMPOTENCE": "lack of power, also IMPOTENCY [n -S]\n",
  "IMPOTENCES": "IMPOTENCE, lack of power, also IMPOTENCY [n]\n",
  "IMPOTENCIES": "IMPOTENCY, lack of power, also IMPOTENCE [n]\n",
  "IMPOTENCY": "lack of power, also IMPOTENCE [n IMPOTENCIES]\n",
  "IMPOTENT": "powerless [adj IMPOTENTLY] / one who is impotent [n -S]\n",
  "IMPOTENTLY": "IMPOTENT, powerless [adv]\n",
  "IMPOTENTNESS": "the state of being impotent [n -ES]\n",
  "IMPOTENTNESSES": "IMPOTENTNESS, the state of being impotent [n]\n",
  "IMPOTENTS": "IMPOTENT, one who is impotent [n]\n",
  "IMPOTS": "IMPOT, (slang) an imposition, a punishment task given to schoolchildren [n]\n",
  "IMPOUND": "to seize and retain in legal custody [v -ED, -ING, -S]\n",
  "IMPOUNDABLE": "that can be impounded [adj]\n",
  "IMPOUNDAGE": "the act of impounding [n -S]\n",
  "IMPOUNDAGES": "IMPOUNDAGE, the act of impounding [n]\n",
  "IMPOUNDED": "IMPOUND, to seize and retain in legal custody [v]\n",
  "IMPOUNDER": "one who impounds [n -S]\n",
  "IMPOUNDERS": "IMPOUNDER, one who impounds [n]\n",
  "IMPOUNDING": "IMPOUND, to seize and retain in legal custody [v]\n",
  "IMPOUNDMENT": "the act of impounding [n -S]\n",
  "IMPOUNDMENTS": "IMPOUNDMENT, the act of impounding [n]\n",
  "IMPOUNDS": "IMPOUND, to seize and retain in legal custody [v]\n",
  "IMPOVERISH": "to make poor, also EMPOVERISH [v -ED, -ING, -ES]\n",
  "IMPOVERISHED": "IMPOVERISH, to make poor, also EMPOVERISH [v]\n",
  "IMPOVERISHER": "one who impoverishes [n -S]\n",
  "IMPOVERISHERS": "IMPOVERISHER, one who impoverishes [n]\n",
  "IMPOVERISHES": "IMPOVERISH, to make poor, also EMPOVERISH [v]\n",
  "IMPOVERISHING": "IMPOVERISH, to make poor, also EMPOVERISH [v]\n",
  "IMPOVERISHMENT": "the state of being impoverished [n -S]\n",
  "IMPOVERISHMENTS": "IMPOVERISHMENT, the state of being impoverished [n]\n",
  "IMPOWER": "to authorize, also EMPOWER [v -ED, -ING, -S]\n",
  "IMPOWERED": "IMPOWER, to authorize, also EMPOWER [v]\n",
  "IMPOWERING": "IMPOWER, to authorize, also EMPOWER [v]\n",
  "IMPOWERS": "IMPOWER, to authorize, also EMPOWER [v]\n",
  "IMPRACTICABLE": "not practicable [adj IMPRACTICABLY]\n",
  "IMPRACTICABLY": "IMPRACTICABLE, not practicable [adv]\n",
  "IMPRACTICAL": "not practical [adj IMPRACTICALLY]\n",
  "IMPRACTICALITY": "the state of being impractical [n]\n",
  "IMPRACTICALLY": "IMPRACTICAL, not practical [adv]\n",
  "IMPRACTICALNESS": "IMPRACTICAL, not practical [n]\n",
  "IMPRECATE": "to call down by prayer; to curse; to invoke evil on [v IMPRECATED, IMPRECATING, IMPRECATES]\n",
  "IMPRECATED": "IMPRECATE, to call down by prayer; to curse; to invoke evil on [v]\n",
  "IMPRECATES": "IMPRECATE, to call down by prayer; to curse; to invoke evil on [v]\n",
  "IMPRECATING": "IMPRECATE, to call down by prayer; to curse; to invoke evil on [v]\n",
  "IMPRECATION": "the act of cursing [n -S]\n",
  "IMPRECATIONS": "IMPRECATION, the act of cursing [n]\n",
  "IMPRECATORY": "of or like an imprecation [adj]\n",
  "IMPRECISE": "not precise, also UNPRECISE [adj IMPRECISELY]\n",
  "IMPRECISELY": "IMPRECISE, not precise, also UNPRECISE [adv]\n",
  "IMPRECISENESS": "IMPRECISE, not precise, also UNPRECISE [n]\n",
  "IMPRECISENESSES": "IMPRECISENESS, IMPRECISE, not precise, also UNPRECISE [n]\n",
  "IMPRECISION": "lack of precision [n -S]\n",
  "IMPRECISIONS": "IMPRECISION, lack of precision [n]\n",
  "IMPREDICATIVE": "of a definition, given in terms that require quantification over a range that includes that which is to be defined [adj]\n",
  "IMPREGN": "(archaic) to impregnate [v -ED, -ING, -S]\n",
  "IMPREGNABILITY": "the state of being impregnable [n]\n",
  "IMPREGNABLE": "that cannot be taken by attack [adj IMPREGNABLY]\n",
  "IMPREGNABLENESS": "IMPREGNABLE, that cannot be taken by attack [n]\n",
  "IMPREGNABLY": "IMPREGNABLE, that cannot be taken by attack [adv]\n",
  "IMPREGNANT": "that which impregnates [n -S]\n",
  "IMPREGNANTS": "IMPREGNANT, that which impregnates [n]\n",
  "IMPREGNATABLE": "capable of being impregnated [adj]\n",
  "IMPREGNATE": "to fill, imbue; to make pregnant [v IMPREGNATED, IMPREGNATING, IMPREGNATES]\n",
  "IMPREGNATED": "IMPREGNATE, to fill, imbue; to make pregnant [v]\n",
  "IMPREGNATES": "IMPREGNATE, to fill, imbue; to make pregnant [v]\n",
  "IMPREGNATING": "IMPREGNATE, to fill, imbue; to make pregnant [v]\n",
  "IMPREGNATION": "the act of making pregnant [n -S]\n",
  "IMPREGNATIONS": "IMPREGNATION, the act of making pregnant [n]\n",
  "IMPREGNATOR": "one who impregnates [n -S]\n",
  "IMPREGNATORS": "IMPREGNATOR, one who impregnates [n]\n",
  "IMPREGNED": "IMPREGN, (archaic) to impregnate [v]\n",
  "IMPREGNING": "IMPREGN, (archaic) to impregnate [v]\n",
  "IMPREGNS": "IMPREGN, (archaic) to impregnate [v]\n",
  "IMPRESA": "(Italian) an emblem with a motto, also IMPRESE, IMPRESSE [n -S]\n",
  "IMPRESARI": "IMPRESARIO, an organizer, promoter, or manager of public entertainments, such as a ballet, opera, concert, or theater company [n]\n",
  "IMPRESARIO": "an organizer, promoter, or manager of public entertainments, such as a ballet, opera, concert, or theater company [n IMPRESARIOS or IMPRESARI]\n",
  "IMPRESARIOS": "IMPRESARIO, an organizer, promoter, or manager of public entertainments, such as a ballet, opera, concert, or theater company [n]\n",
  "IMPRESAS": "IMPRESA, (Italian) an emblem with a motto, also IMPRESE, IMPRESSE [n]\n",
  "IMPRESCRIPTIBLE": "not liable to be lost by prescription; inalienable [adj IMPRESCRIPTIBLY]\n",
  "IMPRESCRIPTIBLY": "IMPRESCRIPTIBLE, not liable to be lost by prescription; inalienable [adv]\n",
  "IMPRESE": "(Italian) an emblem with a motto, also IMPRESA, IMPRESSE [n -S]\n",
  "IMPRESES": "IMPRESE, (Italian) an emblem with a motto, also IMPRESA, IMPRESSE [n]\n",
  "IMPRESS": "to fix deeply in the mind [v -ED, -ING, -ES]\n",
  "IMPRESSE": "(Italian) an emblem with a motto, also IMPRESA, IMPRESE [n -S]\n",
  "IMPRESSED": "IMPRESS, to fix deeply in the mind [v]\n",
  "IMPRESSER": "one who impresses [n -S]\n",
  "IMPRESSERS": "IMPRESSER, one who impresses [n]\n",
  "IMPRESSES": "IMPRESS, to fix deeply in the mind [v]\n",
  "IMPRESSIBILITY": "the state of being impressible [n]\n",
  "IMPRESSIBLE": "that can be impressed [adj]\n",
  "IMPRESSING": "IMPRESS, to fix deeply in the mind [v]\n",
  "IMPRESSION": "a stamp, form, or figure resulting from physical contact [n -S]\n",
  "IMPRESSIONABLE": "capable of being easily impressed [adj]\n",
  "IMPRESSIONAL": "of or like an impression [adj IMPRESSIONALLY]\n",
  "IMPRESSIONALLY": "IMPRESSIONAL, of or like an impression [adv]\n",
  "IMPRESSIONISM": "a 19th century movement in painting [n -S]\n",
  "IMPRESSIONISMS": "IMPRESSIONISM, a 19th century movement in painting [n]\n",
  "IMPRESSIONIST": "an artist who practices or adheres to the theories of impressionism [n -S]\n",
  "IMPRESSIONISTIC": "relating to impressionism [adj]\n",
  "IMPRESSIONISTS": "IMPRESSIONIST, an artist who practices or adheres to the theories of impressionism [n]\n",
  "IMPRESSIONS": "IMPRESSION, a stamp, form, or figure resulting from physical contact [n]\n",
  "IMPRESSIVE": "making or tending to make a marked impression [adj IMPRESSIVELY]\n",
  "IMPRESSIVELY": "IMPRESSIVE, making or tending to make a marked impression [adv]\n",
  "IMPRESSIVENESS": "IMPRESSIVE, making or tending to make a marked impression [n]\n",
  "IMPRESSMENT": "the act of seizing for public use or of impressing into public service [n -S]\n",
  "IMPRESSMENTS": "IMPRESSMENT, the act of seizing for public use or of impressing into public service [n]\n",
  "IMPRESSURE": "(archaic) an impression [n -S]\n",
  "IMPRESSURES": "IMPRESSURE, (archaic) an impression [n]\n",
  "IMPREST": "an advance of money, esp. one made to carry out some business for a government [n -S]\n",
  "IMPRESTS": "IMPREST, an advance of money, esp. one made to carry out some business for a government [n]\n",
  "IMPRIMATUR": "(Latin) a license to print or publish, esp. one issued by a censor of the Roman Catholic Church [n -S]\n",
  "IMPRIMATURS": "IMPRIMATUR, (Latin) a license to print or publish, esp. one issued by a censor of the Roman Catholic Church [n]\n",
  "IMPRIMIS": "(Latin) in the first place: originally used to introduce the first of a number of articles in a list, such as a will, an inventory, etc. [adv]\n",
  "IMPRINT": "to produce a mark by pressure [v -ED, -ING, -S]\n",
  "IMPRINTED": "IMPRINT, to produce a mark by pressure [v]\n",
  "IMPRINTER": "one who imprints [n -S]\n",
  "IMPRINTERS": "IMPRINTER, one who imprints [n]\n",
  "IMPRINTING": "a learning process in young animals in which their social preferences become restricted to their own species, or a substitute for this [n -S]\n",
  "IMPRINTINGS": "IMPRINTING, a learning process in young animals in which their social preferences become restricted to their own species, or a substitute for this [n]\n",
  "IMPRINTS": "IMPRINT, to produce a mark by pressure [v]\n",
  "IMPRISON": "to confine in a prison [v -ED, -ING, -S]\n",
  "IMPRISONABLE": "capable of being imprisoned [adj]\n",
  "IMPRISONED": "IMPRISON, to confine in a prison [v]\n",
  "IMPRISONER": "one who imprisons [n -S]\n",
  "IMPRISONERS": "IMPRISONER, one who imprisons [n]\n",
  "IMPRISONING": "IMPRISON, to confine in a prison [v]\n",
  "IMPRISONMENT": "the act of imprisoning [n -S]\n",
  "IMPRISONMENTS": "IMPRISONMENT, the act of imprisoning [n]\n",
  "IMPRISONS": "IMPRISON, to confine in a prison [v]\n",
  "IMPRO": "(short for) improvisation, also IMPROV [n -S]\n",
  "IMPROBABILITIES": "IMPROBABILITY, the state of being improbable [n]\n",
  "IMPROBABILITY": "the state of being improbable [n IMPROBABILITIES]\n",
  "IMPROBABLE": "not probable [adj IMPROBABLY]\n",
  "IMPROBABLENESS": "IMPROBABLE, not probable [n]\n",
  "IMPROBABLY": "IMPROBABLE, not probable [adv]\n",
  "IMPROBATION": "in Scots law, an action for the purpose of declaring some instrument false or forged [n -S]\n",
  "IMPROBATIONS": "IMPROBATION, in Scots law, an action for the purpose of declaring some instrument false or forged [n]\n",
  "IMPROBITIES": "IMPROBITY, dishonesty [n]\n",
  "IMPROBITY": "dishonesty [n IMPROBITIES]\n",
  "IMPROMPTU": "(Latin) improvised, spontaneous [adj] / a short piece of impromptu music [n -S]\n",
  "IMPROMPTUS": "IMPROMPTU, a short piece of impromptu music [n]\n",
  "IMPROPER": "not proper [adj IMPROPERER, IMPROPEREST; IMPROPERLY]\n",
  "IMPROPERER": "IMPROPER, not proper [adj]\n",
  "IMPROPEREST": "IMPROPER, not proper [adj]\n",
  "IMPROPERLY": "IMPROPER, not proper [adv]\n",
  "IMPROPERNESS": "the state of being improper [n -ES]\n",
  "IMPROPERNESSES": "IMPROPERNESS, the state of being improper [n]\n",
  "IMPROPRIATE": "to transfer ecclesiastical revenue to a layman [v IMPROPRIATED, IMPROPRIATING, IMPROPRIATES]\n",
  "IMPROPRIATED": "IMPROPRIATE, to transfer ecclesiastical revenue to a layman [v]\n",
  "IMPROPRIATES": "IMPROPRIATE, to transfer ecclesiastical revenue to a layman [v]\n",
  "IMPROPRIATING": "IMPROPRIATE, to transfer ecclesiastical revenue to a layman [v]\n",
  "IMPROPRIATION": "the act of impropriating [n -S]\n",
  "IMPROPRIATIONS": "IMPROPRIATION, the act of impropriating [n]\n",
  "IMPROPRIATOR": "a layman who is in possession of a benefice or its revenues [n -S]\n",
  "IMPROPRIATORS": "IMPROPRIATOR, a layman who is in possession of a benefice or its revenues [n]\n",
  "IMPROPRIETIES": "IMPROPRIETY, an improper or indecorous act or remark [n]\n",
  "IMPROPRIETY": "an improper or indecorous act or remark [n IMPROPRIETIES]\n",
  "IMPROS": "IMPRO, (short for) improvisation, also IMPROV [n]\n",
  "IMPROV": "(colloquial) improvisational comedy, also IMPRO [n -S]\n",
  "IMPROVABILITIES": "IMPROVABILITY, the state of being improvable [n]\n",
  "IMPROVABILITY": "the state of being improvable [n IMPROVABILITIES]\n",
  "IMPROVABLE": "capable of being improved [adj IMPROVABLY]\n",
  "IMPROVABLENESS": "IMPROVABLE, capable of being improved [n]\n",
  "IMPROVABLY": "IMPROVABLE, capable of being improved [adv]\n",
  "IMPROVE": "to make better [v IMPROVED, IMPROVING, IMPROVES]\n",
  "IMPROVED": "IMPROVE, to make better [v]\n",
  "IMPROVEMENT": "the act of improving [n -S]\n",
  "IMPROVEMENTS": "IMPROVEMENT, the act of improving [n]\n",
  "IMPROVER": "one who improves [n -S]\n",
  "IMPROVERS": "IMPROVER, one who improves [n]\n",
  "IMPROVES": "IMPROVE, to make better [v]\n",
  "IMPROVIDENCE": "the state of being improvident [n -S]\n",
  "IMPROVIDENCES": "IMPROVIDENCE, the state of being improvident [n]\n",
  "IMPROVIDENT": "lacking foresight, thoughtless, also UNPROVIDENT [adj IMPROVIDENTLY]\n",
  "IMPROVIDENTLY": "IMPROVIDENT, lacking foresight, thoughtless, also UNPROVIDENT [adv]\n",
  "IMPROVING": "IMPROVE, to make better [v]\n",
  "IMPROVINGLY": "IMPROVING, IMPROVE, to make better [adv]\n",
  "IMPROVISATE": "(obsolete) to improvise [v IMPROVISATED, IMPROVISATING, IMPROVISATES]\n",
  "IMPROVISATED": "IMPROVISATE, (obsolete) to improvise [v]\n",
  "IMPROVISATES": "IMPROVISATE, (obsolete) to improvise [v]\n",
  "IMPROVISATING": "IMPROVISATE, (obsolete) to improvise [v]\n",
  "IMPROVISATION": "the act or art of improvising [n -S]\n",
  "IMPROVISATIONAL": "relating to improvisation [adj]\n",
  "IMPROVISATIONS": "IMPROVISATION, the act or art of improvising [n]\n",
  "IMPROVISATOR": "an improviser, also IMPROVISER, IMPROVISOR [n -S]\n",
  "IMPROVISATORE": "(Italian) an improviser in an Italian manner, also IMPROVVISATORE [n IMPROVISATORI or IMPROVISATORES]\n",
  "IMPROVISATORES": "IMPROVISATORE, (Italian) an improviser in an Italian manner, also IMPROVVISATORE [n]\n",
  "IMPROVISATORI": "IMPROVISATORE, (Italian) an improviser in an Italian manner, also IMPROVVISATORE [n]\n",
  "IMPROVISATORIAL": "of or like an improvisator [adj]\n",
  "IMPROVISATORS": "IMPROVISATOR, an improviser, also IMPROVISER, IMPROVISOR [n]\n",
  "IMPROVISATORY": "of or like an improvisator [adj]\n",
  "IMPROVISATRICE": "(archaic) a female improvisator, also IMPROVISATRIX [n -S]\n",
  "IMPROVISATRICES": "IMPROVISATRIX, (archaic) a female improvisator, also IMPROVISATRICE [n]\n",
  "IMPROVISATRIX": "(archaic) a female improvisator, also IMPROVISATRICE [n IMPROVISATRICES or IMPROVISATRIXES]\n",
  "IMPROVISATRIXES": "IMPROVISATRIX, (archaic) a female improvisator, also IMPROVISATRICE [n]\n",
  "IMPROVISE": "to compose and recite, or perform, without preparation [v IMPROVISED, IMPROVISING, IMPROVISES]\n",
  "IMPROVISED": "IMPROVISE, to compose and recite, or perform, without preparation [v]\n",
  "IMPROVISER": "one who improvises, also IMPROVISATOR, IMPROVISOR [n -S]\n",
  "IMPROVISERS": "IMPROVISER, one who improvises, also IMPROVISATOR, IMPROVISOR [n]\n",
  "IMPROVISES": "IMPROVISE, to compose and recite, or perform, without preparation [v]\n",
  "IMPROVISING": "IMPROVISE, to compose and recite, or perform, without preparation [v]\n",
  "IMPROVISOR": "one who improvises, also IMPROVISATOR, IMPROVISER [n -S]\n",
  "IMPROVISORS": "IMPROVISOR, one who improvises, also IMPROVISATOR, IMPROVISER [n]\n",
  "IMPROVS": "IMPROV, (colloquial) improvisational comedy, also IMPRO [n]\n",
  "IMPROVVISATORE": "(Italian) an improviser in an Italian manner, also IMPROVISATORE [n -S]\n",
  "IMPROVVISATORES": "IMPROVVISATORE, (Italian) an improviser in an Italian manner, also IMPROVISATORE [n]\n",
  "IMPROVVISATRICE": "(archaic) a female improvisator, also IMPROVISATRIX [n]\n",
  "IMPRUDENCE": "the state of being imprudent [n -S]\n",
  "IMPRUDENCES": "IMPRUDENCE, the state of being imprudent [n]\n",
  "IMPRUDENT": "not prudent, rash [adj IMPRUDENTLY]\n",
  "IMPRUDENTLY": "IMPRUDENT, not prudent, rash [adv]\n",
  "IMPS": "IMP, to graft feathers onto a bird's wing, also YMPE [v]\n",
  "IMPSONITE": "an organic compound of the asphaltic group [n -S]\n",
  "IMPSONITES": "IMPSONITE, an organic compound of the asphaltic group [n]\n",
  "IMPUDENCE": "shameless boldness, also IMPUDENCY [n -S]\n",
  "IMPUDENCES": "IMPUDENCE, shameless boldness, also IMPUDENCY [n]\n",
  "IMPUDENCIES": "IMPUDENCY, shameless boldness, also IMPUDENCE [n]\n",
  "IMPUDENCY": "shameless boldness, also IMPUDENCE [n IMPUDENCIES]\n",
  "IMPUDENT": "insolently disrespectful [adj IMPUDENTLY]\n",
  "IMPUDENTLY": "IMPUDENT, insolently disrespectful [adv]\n",
  "IMPUDENTNESS": "the state of being impudent [n -ES]\n",
  "IMPUDENTNESSES": "IMPUDENTNESS, the state of being impudent [n]\n",
  "IMPUDICITIES": "IMPUDICITY, immodesty, shamelessness [n]\n",
  "IMPUDICITY": "immodesty, shamelessness [n IMPUDICITIES]\n",
  "IMPUGN": "to attack by words [v -ED, -ING, -S]\n",
  "IMPUGNABLE": "capable of being impugned [adj]\n",
  "IMPUGNATION": "the act of impugning [n -S]\n",
  "IMPUGNATIONS": "IMPUGNATION, the act of impugning [n]\n",
  "IMPUGNED": "IMPUGN, to attack by words [v]\n",
  "IMPUGNER": "one who impugns, attacks with words [n -S]\n",
  "IMPUGNERS": "IMPUGNER, one who impugns, attacks with words [n]\n",
  "IMPUGNING": "IMPUGN, to attack by words [v]\n",
  "IMPUGNMENT": "the act of impugning, or the state of being impugned [n -S]\n",
  "IMPUGNMENTS": "IMPUGNMENT, the act of impugning, or the state of being impugned [n]\n",
  "IMPUGNS": "IMPUGN, to attack by words [v]\n",
  "IMPUISSANCE": "lack of strength or power [n -S]\n",
  "IMPUISSANCES": "IMPUISSANCE, lack of strength or power [n]\n",
  "IMPUISSANT": "(archaic) powerless [adj]\n",
  "IMPULSE": "to give impetus to [v IMPULSED, IMPULSING, IMPULSES]\n",
  "IMPULSED": "IMPULSE, to give impetus to [v]\n",
  "IMPULSES": "IMPULSE, to give impetus to [v]\n",
  "IMPULSING": "IMPULSE, to give impetus to [v]\n",
  "IMPULSION": "the act of impelling or driving onward [n -S]\n",
  "IMPULSIONS": "IMPULSION, the act of impelling or driving onward [n]\n",
  "IMPULSIVE": "given to acting on impulse [adj IMPULSIVELY]\n",
  "IMPULSIVELY": "IMPULSIVE, given to acting on impulse [adv]\n",
  "IMPULSIVENESS": "the state of being impulsive [n -ES]\n",
  "IMPULSIVENESSES": "IMPULSIVENESS, the state of being impulsive [n]\n",
  "IMPULSIVITIES": "IMPULSIVITY, the state of being impulsive [n]\n",
  "IMPULSIVITY": "the state of being impulsive [n IMPULSIVITIES]\n",
  "IMPUNDULU": "(Bantu) a mythical bird with magical powers, often identified with the secretary bird [n -S]\n",
  "IMPUNDULUS": "IMPUNDULU, (Bantu) a mythical bird with magical powers, often identified with the secretary bird [n]\n",
  "IMPUNITIES": "IMPUNITY, exemption from penalty [n]\n",
  "IMPUNITY": "exemption from penalty [n IMPUNITIES]\n",
  "IMPURE": "tainted, also UNPURE [adj IMPURER, IMPUREST, IMPURELY]\n",
  "IMPURELY": "IMPURE, tainted, also UNPURE [adv]\n",
  "IMPURENESS": "the state of being impure [n -ES]\n",
  "IMPURENESSES": "IMPURENESS, the state of being impure [n]\n",
  "IMPURER": "IMPURE, tainted, also UNPURE [adj]\n",
  "IMPUREST": "IMPURE, tainted, also UNPURE [adj]\n",
  "IMPURITIES": "IMPURITY, something that is impure [n]\n",
  "IMPURITY": "something that is impure [n IMPURITIES]\n",
  "IMPURPLE": "to dye purple, also EMPURPLE [v IMPURPLED, IMPURPLING, IMPURPLES]\n",
  "IMPURPLED": "IMPURPLE, to dye purple, also EMPURPLE [v]\n",
  "IMPURPLES": "IMPURPLE, to dye purple, also EMPURPLE [v]\n",
  "IMPURPLING": "IMPURPLE, to dye purple, also EMPURPLE [v]\n",
  "IMPUTABILITIES": "IMPUTABILITY, the ability to be imputed [n]\n",
  "IMPUTABILITY": "the ability to be imputed [n IMPUTABILITIES]\n",
  "IMPUTABLE": "that can be imputed [adj IMPUTABLY]\n",
  "IMPUTABLENESS": "the state of being imputable [n -ES]\n",
  "IMPUTABLENESSES": "IMPUTABLENESS, the state of being imputable [n]\n",
  "IMPUTABLY": "IMPUTABLE, that can be imputed [adv]\n",
  "IMPUTATION": "the act of imputing [n -S]\n",
  "IMPUTATIONS": "IMPUTATION, the act of imputing [n]\n",
  "IMPUTATIVE": "transferred by imputation; that may be imputed [adj IMPUTATIVELY]\n",
  "IMPUTATIVELY": "IMPUTATIVE, transferred by imputation; that may be imputed [adv]\n",
  "IMPUTE": "to reckon or take into account [v IMPUTED, IMPUTING, IMPUTES]\n",
  "IMPUTED": "IMPUTE, to reckon or take into account [v]\n",
  "IMPUTER": "one who imputes [n -S]\n",
  "IMPUTERS": "IMPUTER, one who imputes [n]\n",
  "IMPUTES": "IMPUTE, to reckon or take into account [v]\n",
  "IMPUTING": "IMPUTE, to reckon or take into account [v]\n",
  "IMSHI": "(Australian) in old military slang, go away, also IMSHY [interj]\n",
  "IMSHY": "(Australian) in old military slang, go away, also IMSHI [interj]\n",
  "IN": "to take in e.g. harvest [v INNED, INNING, INS]\n",
  "INABILITIES": "INABILITY, the absence of an inability [n]\n",
  "INABILITY": "the absence of an inability [n INABILITIES]\n",
  "INABSTINENCE": "lack of abstinence [n -S]\n",
  "INABSTINENCES": "INABSTINENCE, lack of abstinence [n]\n",
  "INACCESSIBILITY": "the state of being inaccessible [n]\n",
  "INACCESSIBLE": "not accessible [adj INACCESSIBLY]\n",
  "INACCESSIBLY": "INACCESSIBLE, not accessible [adv]\n",
  "INACCURACIES": "INACCURACY, the state of being inaccurate [n]\n",
  "INACCURACY": "the state of being inaccurate [n INACCURACIES]\n",
  "INACCURATE": "not accurate [adj INACCURATELY]\n",
  "INACCURATELY": "INACCURATE, not accurate [adv]\n",
  "INACCURATENESS": "INACCURATE, not accurate [n]\n",
  "INACTION": "lack of action [n -S]\n",
  "INACTIONS": "INACTION, lack of action [n]\n",
  "INACTIVATE": "to make inactive [v INACTIVATED, INACTIVATING, INACTIVATES]\n",
  "INACTIVATED": "INACTIVATE, to make inactive [v]\n",
  "INACTIVATES": "INACTIVATE, to make inactive [v]\n",
  "INACTIVATING": "INACTIVATE, to make inactive [v]\n",
  "INACTIVATION": "the act of inactivating [n -S]\n",
  "INACTIVATIONS": "INACTIVATION, the act of inactivating [n]\n",
  "INACTIVE": "not active, also UNACTIVE [adj INACTIVELY]\n",
  "INACTIVELY": "INACTIVE, not active, also UNACTIVE [adv]\n",
  "INACTIVENESS": "the state of being inactive [n -ES]\n",
  "INACTIVENESSES": "INACTIVENESS, the state of being inactive [n]\n",
  "INACTIVITIES": "INACTIVITY, the state of being inactive [n]\n",
  "INACTIVITY": "the state of being inactive [n INACTIVITIES]\n",
  "INADAPTABLE": "that cannot be adapted [adj]\n",
  "INADAPTATION": "lack of adaptation [n -S]\n",
  "INADAPTATIONS": "INADAPTATION, lack of adaptation [n]\n",
  "INADAPTIVE": "not adaptive [adj]\n",
  "INADEQUACIES": "INADEQUACY, the state of being inadequate [n]\n",
  "INADEQUACY": "the state of being inadequate [n INADEQUACIES]\n",
  "INADEQUATE": "not adequate [adj INADEQUATELY] / an incompetent person [n -S]\n",
  "INADEQUATELY": "INADEQUATE, not adequate [adv]\n",
  "INADEQUATENESS": "INADEQUATE, not adequate [n]\n",
  "INADEQUATES": "INADEQUATE, an incompetent person [n]\n",
  "INADMISSIBILITY": "the state of being inadmissible [n]\n",
  "INADMISSIBLE": "not admissible [adj INADMISSIBLY]\n",
  "INADMISSIBLY": "INADMISSIBLE, not admissible [adv]\n",
  "INADVERTENCE": "negligence, oversight, also INADVERTENCY [n -S]\n",
  "INADVERTENCES": "INADVERTENCE, negligence, oversight, also INADVERTENCY [n]\n",
  "INADVERTENCIES": "INADVERTENCY, negligence, oversight, also INADVERTENCE [n]\n",
  "INADVERTENCY": "negligence, oversight, also INADVERTENCE [n INADVERTENCIES]\n",
  "INADVERTENT": "not focusing the mind on a matter [adj INADVERTENTLY]\n",
  "INADVERTENTLY": "INADVERTENT, not focusing the mind on a matter [adv]\n",
  "INADVISABILITY": "the state of being inadvisable [n]\n",
  "INADVISABLE": "not advisable [adj INADVISABLY]\n",
  "INADVISABLENESS": "INADVISABLE, not advisable [n]\n",
  "INADVISABLY": "INADVISABLE, not advisable [adv]\n",
  "INAIDABLE": "(Shakespeare) that cannot be aided, also UNAIDABLE [adj]\n",
  "INALIENABILITY": "the state of being inalienable [n]\n",
  "INALIENABLE": "incapable of being withdrawn, surrendered, or transferred, also UNALIENABLE [adj INALIENABLY]\n",
  "INALIENABLENESS": "the state of being inalienable [n]\n",
  "INALIENABLY": "INALIENABLE, incapable of being withdrawn, surrendered, or transferred, also UNALIENABLE [adv]\n",
  "INALTERABILITY": "the state of being inalterable [n]\n",
  "INALTERABLE": "that cannot be altered [adj INALTERABLY]\n",
  "INALTERABLENESS": "INALTERABLE, that cannot be altered [n]\n",
  "INALTERABLY": "INALTERABLE, that cannot be altered [adv]\n",
  "INAMORATA": "(Italian) a (female) lover; beloved person [n -S]\n",
  "INAMORATAS": "INAMORATA, (Italian) a (female) lover; beloved person [n]\n",
  "INAMORATI": "INAMORATO, (Italian) a (male) lover; beloved person [n]\n",
  "INAMORATO": "(Italian) a (male) lover; beloved person [n INAMORATI or INAMORATOS]\n",
  "INAMORATOS": "INAMORATO, (Italian) a (male) lover; beloved person [n]\n",
  "INANE": "empty, senseless [adj INANER, INANEST, INANELY] / empty space [n -S]\n",
  "INANELY": "INANE, empty, senseless [adv]\n",
  "INANENESS": "the state of being inane [n -ES]\n",
  "INANENESSES": "INANENESS, the state of being inane [n]\n",
  "INANER": "INANE, empty, senseless [adj]\n",
  "INANES": "INANE, empty space [n]\n",
  "INANEST": "INANE, empty, senseless [adj]\n",
  "INANGA": "(Maori) the New Zealand whitebait [n -S]\n",
  "INANGAS": "INANGA, (Maori) the New Zealand whitebait [n]\n",
  "INANIMATE": "not alive [adj INANIMATELY]\n",
  "INANIMATELY": "INANIMATE, not alive [adv]\n",
  "INANIMATENESS": "the state of being inanimate [n -ES]\n",
  "INANIMATENESSES": "INANIMATENESS, the state of being inanimate [n]\n",
  "INANIMATION": "the state of being inanimate [n -S]\n",
  "INANIMATIONS": "INANIMATION, the state of being inanimate [n]\n",
  "INANITIES": "INANITY, something that is inane [n]\n",
  "INANITION": "a condition of exhaustion resulting from lack of nourishment [n -S]\n",
  "INANITIONS": "INANITION, a condition of exhaustion resulting from lack of nourishment [n]\n",
  "INANITY": "something that is inane [n INANITIES]\n",
  "INAPPARENT": "not apparent [adj INAPPARENTLY]\n",
  "INAPPARENTLY": "INAPPARENT, not apparent [adv]\n",
  "INAPPEASABLE": "not capable of being appeased, also UNAPPEASABLE [adj]\n",
  "INAPPELLABLE": "incapable of being appealed against or challenged [adj]\n",
  "INAPPETENCE": "lack of desire or appetite, also INAPPETENCY [n -S]\n",
  "INAPPETENCES": "INAPPETENCE, lack of desire or appetite, also INAPPETENCY [n]\n",
  "INAPPETENCIES": "INAPPETENCY, lack of desire or appetite, also INAPPETENCE [n]\n",
  "INAPPETENCY": "lack of desire or appetite, also INAPPETENCE [n INAPPETENCIES]\n",
  "INAPPETENT": "lacking desire or appetite [adj]\n",
  "INAPPLICABILITY": "the state of being inapplicable [n]\n",
  "INAPPLICABLE": "not applicable [adj INAPPLICABLY]\n",
  "INAPPLICABLY": "INAPPLICABLE, not applicable [adv]\n",
  "INAPPOSITE": "not apposite [adj INAPPOSITELY]\n",
  "INAPPOSITELY": "INAPPOSITE, not apposite [adv]\n",
  "INAPPOSITENESS": "INAPPOSITE, not apposite [n]\n",
  "INAPPRECIABLE": "too small to be perceived [adj INAPPRECIABLY]\n",
  "INAPPRECIABLY": "INAPPRECIABLE, too small to be perceived [adv]\n",
  "INAPPRECIATION": "lack of appreciation [n -S]\n",
  "INAPPRECIATIONS": "INAPPRECIATION, lack of appreciation [n]\n",
  "INAPPRECIATIVE": "not appreciative [adj]\n",
  "INAPPREHENSIBLE": "not capable of being apprehended [adj]\n",
  "INAPPREHENSION": "lack of apprehension [n -S]\n",
  "INAPPREHENSIONS": "INAPPREHENSION, lack of apprehension [n]\n",
  "INAPPREHENSIVE": "not apprehensive [adj]\n",
  "INAPPROACHABLE": "not approachable [adj INAPPROACHABLY]\n",
  "INAPPROACHABLY": "INAPPROACHABLE, not approachable [adv]\n",
  "INAPPROPRIATE": "not appropriate, also UNAPPROPRIATE [adj INAPPROPRIATELY]\n",
  "INAPPROPRIATELY": "INAPPROPRIATE, not appropriate, also UNAPPROPRIATE [adv]\n",
  "INAPT": "unfit or unqualified, also INEPT, UNAPT [adj INAPTER, INAPTEST; INAPTLY]\n",
  "INAPTER": "INAPT, unfit or unqualified, also INEPT, UNAPT [adj]\n",
  "INAPTEST": "INAPT, unfit or unqualified, also INEPT, UNAPT [adj]\n",
  "INAPTITUDE": "want of aptitude [n -S]\n",
  "INAPTITUDES": "INAPTITUDE, want of aptitude [n]\n",
  "INAPTLY": "INAPT, unfit or unqualified, also INEPT, UNAPT [adv]\n",
  "INAPTNESS": "the state of being inapt [n -ES]\n",
  "INAPTNESSES": "INAPTNESS, the state of being inapt [n]\n",
  "INARABLE": "arid or barren [adj]\n",
  "INARCH": "to graft in a certain way [v -ED, -ING, -ES]\n",
  "INARCHED": "INARCH, to graft in a certain way [v]\n",
  "INARCHES": "INARCH, to graft in a certain way [v]\n",
  "INARCHING": "INARCH, to graft in a certain way [v]\n",
  "INARGUABLE": "that cannot be disputed [adj INARGUABLY]\n",
  "INARGUABLY": "INARGUABLE, that cannot be disputed [adv]\n",
  "INARM": "to encircle with the arms [v -ED, -ING, -S]\n",
  "INARMED": "INARM, to encircle with the arms [v]\n",
  "INARMING": "INARM, to encircle with the arms [v]\n",
  "INARMS": "INARM, to encircle with the arms [v]\n",
  "INARTICULACIES": "INARTICULACY, the state of being inarticulate [n]\n",
  "INARTICULACY": "the state of being inarticulate [n INARTICULACIES]\n",
  "INARTICULATE": "not articulate, also UNARTICULATE [adj INARTICULATELY] / any of a class of brachiopods lacking a hinge connecting the two shell valves [n -S]\n",
  "INARTICULATELY": "INARTICULATE, not articulate, also UNARTICULATE [adv]\n",
  "INARTICULATES": "INARTICULATE, any of a class of brachiopods lacking a hinge connecting the two shell valves [n]\n",
  "INARTICULATION": "lack of articulation [n -S]\n",
  "INARTICULATIONS": "INARTICULATION, lack of articulation [n]\n",
  "INARTIFICIAL": "not artificial [adj INARTIFICIALLY]\n",
  "INARTIFICIALLY": "INARTIFICIAL, not artificial [adv]\n",
  "INARTISTIC": "not conforming to the principles of art [adj INARTISTICALLY]\n",
  "INARTISTICALLY": "INARTISTIC, not conforming to the principles of art [adv]\n",
  "INASMUCH": "to such a degree, also INSOMUCH [adv]\n",
  "INATTENTION": "failure to pay attention [n -S]\n",
  "INATTENTIONS": "INATTENTION, failure to pay attention [n]\n",
  "INATTENTIVE": "not attentive [adj INATTENTIVELY]\n",
  "INATTENTIVELY": "INATTENTIVE, not attentive [adv]\n",
  "INATTENTIVENESS": "the state of being inattentive [n]\n",
  "INAUDIBILITIES": "INAUDIBILITY, the state of being inaudible [n]\n",
  "INAUDIBILITY": "the state of being inaudible [n INAUDIBILITIES]\n",
  "INAUDIBLE": "that cannot be heard [adj INAUDIBLY]\n",
  "INAUDIBLENESS": "INAUDIBLE, that cannot be heard [n]\n",
  "INAUDIBLENESSES": "INAUDIBLENESS, INAUDIBLE, that cannot be heard [n]\n",
  "INAUDIBLY": "INAUDIBLE, that cannot be heard [adv]\n",
  "INAUGURAL": "relating to, or done at, an inauguration [adj] / an inaugural address or lecture [n -S]\n",
  "INAUGURALS": "INAUGURAL, an inaugural address or lecture [n]\n",
  "INAUGURATE": "to invest with office [v INAUGURATED, INAUGURATING, INAUGURATES]\n",
  "INAUGURATED": "INAUGURATE, to invest with office [v]\n",
  "INAUGURATES": "INAUGURATE, to invest with office [v]\n",
  "INAUGURATING": "INAUGURATE, to invest with office [v]\n",
  "INAUGURATION": "an act of inaugurating [n -S]\n",
  "INAUGURATIONS": "INAUGURATION, an act of inaugurating [n]\n",
  "INAUGURATOR": "one who inaugurates [n -S]\n",
  "INAUGURATORS": "INAUGURATOR, one who inaugurates [n]\n",
  "INAUGURATORY": "serving to inaugurate [adj]\n",
  "INAURATE": "to cover with gold [v INAURATED, INAURATING, INAURATES]\n",
  "INAURATED": "INAURATE, to cover with gold [v]\n",
  "INAURATES": "INAURATE, to cover with gold [v]\n",
  "INAURATING": "INAURATE, to cover with gold [v]\n",
  "INAUSPICIOUS": "not auspicious [adj INAUSPICIOUSLY]\n",
  "INAUSPICIOUSLY": "INAUSPICIOUS, not auspicious [adv]\n",
  "INAUTHENTIC": "not authentic [adj]\n",
  "INAUTHENTICITY": "the state of being inauthentic [n]\n",
  "INBEING": "inherent existence [n -S]\n",
  "INBEINGS": "INBEING, inherent existence [n]\n",
  "INBENT": "bent inwards [adj]\n",
  "INBOARD": "a type of motor boat [n -S]\n",
  "INBOARDS": "INBOARD, a type of motor boat [n]\n",
  "INBORN": "existing in one from birth [adj]\n",
  "INBOUND": "to return a basketball to play from out of bounds [v -ED, -ING, -S]\n",
  "INBOUNDED": "INBOUND, to return a basketball to play from out of bounds [v]\n",
  "INBOUNDING": "INBOUND, to return a basketball to play from out of bounds [v]\n",
  "INBOUNDS": "INBOUND, to return a basketball to play from out of bounds [v]\n",
  "INBOX": "(on a computer) a folder in a mailbox in which incoming messages are stored and displayed [n -ES]\n",
  "INBOXES": "INBOX, (on a computer) a folder in a mailbox in which incoming messages are stored and displayed [n]\n",
  "INBREAK": "a violent rush in [n -S]\n",
  "INBREAKS": "INBREAK, a violent rush in [n]\n",
  "INBREATHE": "to infuse by breathing; to inspire [v INBREATHED, INBREATHING, INBREATHES]\n",
  "INBREATHED": "INBREATHE, to infuse by breathing; to inspire [v]\n",
  "INBREATHES": "INBREATHE, to infuse by breathing; to inspire [v]\n",
  "INBREATHING": "INBREATHE, to infuse by breathing; to inspire [v]\n",
  "INBRED": "a product of inbreeding [n -S]\n",
  "INBREDS": "INBRED, a product of inbreeding [n]\n",
  "INBREED": "to breed closely related stock [v INBRED, INBREEDING, INBREEDS]\n",
  "INBREEDER": "one who inbreeds [n -S]\n",
  "INBREEDERS": "INBREEDER, one who inbreeds [n]\n",
  "INBREEDING": "the act of inbreeding [n -S]\n",
  "INBREEDINGS": "INBREEDING, the act of inbreeding [n]\n",
  "INBREEDS": "INBREED, to breed closely related stock [v]\n",
  "INBRING": "to bring in [v INBROUGHT, INBRINGING, INBRINGS]\n",
  "INBRINGING": "the act of bringing in [n -S]\n",
  "INBRINGINGS": "INBRINGING, the act of bringing in [n]\n",
  "INBRINGS": "INBRING, to bring in [v]\n",
  "INBROUGHT": "INBRING, to bring in [v]\n",
  "INBUILT": "forming an integral part of a structure [adj]\n",
  "INBURNING": "(Spenser) burning within [adj]\n",
  "INBURST": "to burst into [v INBURST, INBURSTING, INBURSTS]\n",
  "INBURSTING": "INBURST, to burst into [v]\n",
  "INBURSTS": "INBURST, to burst into [v]\n",
  "INBY": "(Scots) towards the interior, by the house, also INBYE [adv]\n",
  "INBYE": "(Scots) towards the interior, by the house, also INBY [adv]\n",
  "INCAGE": "to put in a cage, also ENCAGE [v INCAGED, INCAGING, INCAGES]\n",
  "INCAGED": "INCAGE, to put in a cage, also ENCAGE [v]\n",
  "INCAGES": "INCAGE, to put in a cage, also ENCAGE [v]\n",
  "INCAGING": "INCAGE, to put in a cage, also ENCAGE [v]\n",
  "INCALCULABILITY": "the state of being incalculable [n]\n",
  "INCALCULABLE": "not capable of being calculated [adj INCALCULABLY]\n",
  "INCALCULABLY": "INCALCULABLE, not capable of being calculated [adv]\n",
  "INCALESCENCE": "the process or action of becoming warm or hot [n -S]\n",
  "INCALESCENCES": "INCALESCENCE, the process or action of becoming warm or hot [n]\n",
  "INCALESCENT": "growing warm [adj]\n",
  "INCANDESCE": "to be or become incandescent [v INCANDESCED, INCANDESCING, INCANDESCES]\n",
  "INCANDESCED": "INCANDESCE, to be or become incandescent [v]\n",
  "INCANDESCENCE": "the state of being incandescent, also INCANDESCENCY [n -S]\n",
  "INCANDESCENCES": "INCANDESCENCE, the state of being incandescent, also INCANDESCENCY [n]\n",
  "INCANDESCENCIES": "INCANDESCENCY, the state of being incandescent, also INCANDESCENCE [n]\n",
  "INCANDESCENCY": "the state of being incandescent, also INCANDESCENCE [n INCANDESCENCIES]\n",
  "INCANDESCENT": "white, glowing, or luminous with intense heat [adj INCANDESCENTLY] / a type of lightbulb [n -S]\n",
  "INCANDESCENTLY": "INCANDESCENT, white, glowing, or luminous with intense heat [adv]\n",
  "INCANDESCENTS": "INCANDESCENT, a type of lightbulb [n]\n",
  "INCANDESCES": "INCANDESCE, to be or become incandescent [v]\n",
  "INCANDESCING": "INCANDESCE, to be or become incandescent [v]\n",
  "INCANT": "to utter ritually [v -ED, -ING, -S]\n",
  "INCANTATION": "a use of spells or verbal charms spoken or sung as a part of a ritual of magic [n -S]\n",
  "INCANTATIONAL": "relating to incantation [adj]\n",
  "INCANTATIONS": "INCANTATION, a use of spells or verbal charms spoken or sung as a part of a ritual of magic [n]\n",
  "INCANTATOR": "one who utters incantations [n -S]\n",
  "INCANTATORS": "INCANTATOR, one who utters incantations [n]\n",
  "INCANTATORY": "of or like an incantation [adj]\n",
  "INCANTED": "INCANT, to utter ritually [v]\n",
  "INCANTING": "INCANT, to utter ritually [v]\n",
  "INCANTS": "INCANT, to utter ritually [v]\n",
  "INCAPABILITIES": "INCAPABILITY, the state of being incapable [n]\n",
  "INCAPABILITY": "the state of being incapable [n INCAPABILITIES]\n",
  "INCAPABLE": "not capable [adj INCAPABLY] / one who is in incapable [n -S]\n",
  "INCAPABLENESS": "the state of being incapable [n -ES]\n",
  "INCAPABLENESSES": "INCAPABLENESS, the state of being incapable [n]\n",
  "INCAPABLES": "INCAPABLE, one who is in incapable [n]\n",
  "INCAPABLY": "INCAPABLE, not capable [adv]\n",
  "INCAPACIOUS": "not capacious [adj]\n",
  "INCAPACIOUSNESS": "INCAPACIOUS, not capacious [n]\n",
  "INCAPACITANT": "a substance that can temporarily incapacitate a person, used esp. as a weapon in biological warfare [n -S]\n",
  "INCAPACITANTS": "INCAPACITANT, a substance that can temporarily incapacitate a person, used esp. as a weapon in biological warfare [n]\n",
  "INCAPACITATE": "to make legally incapable or ineligible [v INCAPACITATED, INCAPACITATING, INCAPACITATES]\n",
  "INCAPACITATED": "INCAPACITATE, to make legally incapable or ineligible [v]\n",
  "INCAPACITATES": "INCAPACITATE, to make legally incapable or ineligible [v]\n",
  "INCAPACITATING": "INCAPACITATE, to make legally incapable or ineligible [v]\n",
  "INCAPACITATION": "the act of incapacitating [n -S]\n",
  "INCAPACITATIONS": "INCAPACITATION, the act of incapacitating [n]\n",
  "INCAPACITIES": "INCAPACITY, the state of being incapable [n]\n",
  "INCAPACITY": "the state of being incapable [n INCAPACITIES]\n",
  "INCAPSULATE": "to enclose in or as if in a capsule, also ENCAPSULATE [v INCAPSULATED, INCAPSULATING, INCAPSULATES]\n",
  "INCAPSULATED": "INCAPSULATE, to enclose in or as if in a capsule, also ENCAPSULATE [v]\n",
  "INCAPSULATES": "INCAPSULATE, to enclose in or as if in a capsule, also ENCAPSULATE [v]\n",
  "INCAPSULATING": "INCAPSULATE, to enclose in or as if in a capsule, also ENCAPSULATE [v]\n",
  "INCAPSULATION": "the act of incapsulating [n -S]\n",
  "INCAPSULATIONS": "INCAPSULATION, the act of incapsulating [n]\n",
  "INCARCERATE": "to put in prison [v INCARCERATED, INCARCERATING, INCARCERATES]\n",
  "INCARCERATED": "INCARCERATE, to put in prison [v]\n",
  "INCARCERATES": "INCARCERATE, to put in prison [v]\n",
  "INCARCERATING": "INCARCERATE, to put in prison [v]\n",
  "INCARCERATION": "imprisonment [n -S]\n",
  "INCARCERATIONS": "INCARCERATION, imprisonment [n]\n",
  "INCARCERATOR": "one who incarcerates [n -S]\n",
  "INCARCERATORS": "INCARCERATOR, one who incarcerates [n]\n",
  "INCARDINATE": "to make cardinal; to receive (priest) from another diocese [v INCARDINATED, INCARDINATING, INCARDINATES]\n",
  "INCARDINATED": "INCARDINATE, to make cardinal; to receive (priest) from another diocese [v]\n",
  "INCARDINATES": "INCARDINATE, to make cardinal; to receive (priest) from another diocese [v]\n",
  "INCARDINATING": "INCARDINATE, to make cardinal; to receive (priest) from another diocese [v]\n",
  "INCARDINATION": "acceptance by a diocese of clergyman from another diocese [n -S]\n",
  "INCARDINATIONS": "INCARDINATION, acceptance by a diocese of clergyman from another diocese [n]\n",
  "INCARNADINE": "flesh-colored; red, esp. bloodred [adj] / to make bloodred [v INCARNADINED, INCARNADINING, INCARNADINES]\n",
  "INCARNADINED": "INCARNADINE, to make bloodred [v]\n",
  "INCARNADINES": "INCARNADINE, to make bloodred [v]\n",
  "INCARNADINING": "INCARNADINE, to make bloodred [v]\n",
  "INCARNATE": "to embody in flesh, give human form to [v INCARNATED, INCARNATING, INCARNATES]\n",
  "INCARNATED": "INCARNATE, to embody in flesh, give human form to [v]\n",
  "INCARNATES": "INCARNATE, to embody in flesh, give human form to [v]\n",
  "INCARNATING": "INCARNATE, to embody in flesh, give human form to [v]\n",
  "INCARNATION": "the embodiment of a deity or spirit in some earthly form [n -S]\n",
  "INCARNATIONS": "INCARNATION, the embodiment of a deity or spirit in some earthly form [n]\n",
  "INCARVILLEA": "any plant of the genus Incarvillea, of the family Bignoniaceae typically having trumpet-shaped flowers borne in clusters on erect stems [n -S]\n",
  "INCARVILLEAS": "INCARVILLEA, any plant of the genus Incarvillea, of the family Bignoniaceae typically having trumpet-shaped flowers borne in clusters on erect stems [n]\n",
  "INCASE": "to put in a case, also ENCASE [v INCASED, INCASING, INCASES]\n",
  "INCASED": "INCASE, to put in a case, also ENCASE [v]\n",
  "INCASEMENT": "the act of incasing [n -S]\n",
  "INCASEMENTS": "INCASEMENT, the act of incasing [n]\n",
  "INCASES": "INCASE, to put in a case, also ENCASE [v]\n",
  "INCASING": "INCASE, to put in a case, also ENCASE [v]\n",
  "INCATENATE": "to chain together [v INCATENATED, INCATENATING, INCATENATES]\n",
  "INCATENATED": "INCATENATE, to chain together [v]\n",
  "INCATENATES": "INCATENATE, to chain together [v]\n",
  "INCATENATING": "INCATENATE, to chain together [v]\n",
  "INCATENATION": "harnessing; chaining together [n -S]\n",
  "INCATENATIONS": "INCATENATION, harnessing; chaining together [n]\n",
  "INCAUTION": "want of caution [n -S]\n",
  "INCAUTIONS": "INCAUTION, want of caution [n]\n",
  "INCAUTIOUS": "lacking in caution [adj INCAUTIOUSLY]\n",
  "INCAUTIOUSLY": "INCAUTIOUS, lacking in caution [adv]\n",
  "INCAUTIOUSNESS": "the state of being incautious [n]\n",
  "INCAVE": "(Shakespeare) to secrete, also ENCAVE [v INCAVED, INCAVING, INCAVES]\n",
  "INCAVED": "INCAVE, (Shakespeare) to secrete, also ENCAVE [v]\n",
  "INCAVES": "INCAVE, (Shakespeare) to secrete, also ENCAVE [v]\n",
  "INCAVI": "INCAVO, (Italian) the hollowed portion of an intaglio [n]\n",
  "INCAVING": "INCAVE, (Shakespeare) to secrete, also ENCAVE [v]\n",
  "INCAVO": "(Italian) the hollowed portion of an intaglio [n INCAVI]\n",
  "INCEDE": "to advance majestically [v INCEDED, INCEDING, INCEDES]\n",
  "INCEDED": "INCEDE, to advance majestically [v]\n",
  "INCEDES": "INCEDE, to advance majestically [v]\n",
  "INCEDING": "INCEDE, to advance majestically [v]\n",
  "INCEDINGLY": "INCEDING, INCEDE, to advance majestically [adv]\n",
  "INCEL": "an involuntary celibate: a person, esp a man, who identifies as being frustrated by a lack of opportunities to have sex [n -S]\n",
  "INCELS": "INCEL, an involuntary celibate: a person, esp a man, who identifies as being frustrated by a lack of opportunities to have sex [n]\n",
  "INCENDIARIES": "INCENDIARY, a person who commits arson [n]\n",
  "INCENDIARISM": "the malicious burning of property [n -S]\n",
  "INCENDIARISMS": "INCENDIARISM, the malicious burning of property [n]\n",
  "INCENDIARY": "adapted or used for setting buildings, etc. on fire [adj] / a person who commits arson [n INCENDIARIES]\n",
  "INCENDIVITIES": "INCENDIVITY, the power of causing ignition [n]\n",
  "INCENDIVITY": "the power of causing ignition [n INCENDIVITIES]\n",
  "INCENSATION": "the act of perfuming with incense [n -S]\n",
  "INCENSATIONS": "INCENSATION, the act of perfuming with incense [n]\n",
  "INCENSE": "to make very angry [v INCENSED, INCENSING, INCENSES]\n",
  "INCENSED": "INCENSE, to make very angry [v]\n",
  "INCENSEMENT": "the act of incensing, making angry [n -S]\n",
  "INCENSEMENTS": "INCENSEMENT, the act of incensing, making angry [n]\n",
  "INCENSER": "a burner of incense, also INCENSOR [n -S]\n",
  "INCENSERS": "INCENSER, a burner of incense, also INCENSOR [n]\n",
  "INCENSES": "INCENSE, to make very angry [v]\n",
  "INCENSING": "INCENSE, to make very angry [v]\n",
  "INCENSOR": "a burner of incense, also INCENSER [n -S]\n",
  "INCENSORIES": "INCENSORY, the vessel in which incense is burned and offered, aka censer or thurible [n]\n",
  "INCENSORS": "INCENSOR, a burner of incense, also INCENSER [n]\n",
  "INCENSORY": "the vessel in which incense is burned and offered, aka censer or thurible [n INCENSORIES]\n",
  "INCENT": "to provide with an incentive [v -ED, -ING, -S]\n",
  "INCENTED": "INCENT, to provide with an incentive [v]\n",
  "INCENTER": "the centre of an inscribed circle, also INCENTRE [n -S]\n",
  "INCENTERS": "INCENTER, the centre of an inscribed circle, also INCENTRE [n]\n",
  "INCENTING": "INCENT, to provide with an incentive [v]\n",
  "INCENTIVE": "inciting to action [adj INCENTIVELY] / that which incites to action, a stimulus [n -S]\n",
  "INCENTIVELY": "INCENTIVE, inciting to action [adv]\n",
  "INCENTIVES": "INCENTIVE, that which incites to action, a stimulus [n]\n",
  "INCENTIVISATION": "the process of incentivising, also INCENTIVIZATION [n]\n",
  "INCENTIVISE": "to give an incentive, also INCENTIVIZE [v INCENTIVISED, INCENTIVISING, INCENTIVISES]\n",
  "INCENTIVISED": "INCENTIVISE, to give an incentive, also INCENTIVIZE [v]\n",
  "INCENTIVISES": "INCENTIVISE, to give an incentive, also INCENTIVIZE [v]\n",
  "INCENTIVISING": "INCENTIVISE, to give an incentive, also INCENTIVIZE [v]\n",
  "INCENTIVIZATION": "the action or process of making something (esp. a product, scheme, etc.) attractive by offering an incentive for purchase or participation, also INCENTIVISATION [n]\n",
  "INCENTIVIZE": "to give an incentive, also INCENTIVISE [v INCENTIVIZED, INCENTIVIZING, INCENTIVIZES]\n",
  "INCENTIVIZED": "INCENTIVIZE, to give an incentive, also INCENTIVISE [v]\n",
  "INCENTIVIZES": "INCENTIVIZE, to give an incentive, also INCENTIVISE [v]\n",
  "INCENTIVIZING": "INCENTIVIZE, to give an incentive, also INCENTIVISE [v]\n",
  "INCENTRE": "the centre of an inscribed circle, also INCENTER [n -S]\n",
  "INCENTRES": "INCENTRE, the centre of an inscribed circle, also INCENTER [n]\n",
  "INCENTS": "INCENT, to provide with an incentive [v]\n",
  "INCEPT": "to take into the body [v -ED, -ING, -S]\n",
  "INCEPTED": "INCEPT, to take into the body [v]\n",
  "INCEPTING": "INCEPT, to take into the body [v]\n",
  "INCEPTION": "a beginning [n -S]\n",
  "INCEPTIONS": "INCEPTION, a beginning [n]\n",
  "INCEPTIVE": "marking the beginning or formation [adj INCEPTIVELY] / an inceptive verb [n -S]\n",
  "INCEPTIVELY": "INCEPTIVE, marking the beginning or formation [adv]\n",
  "INCEPTIVES": "INCEPTIVE, an inceptive verb [n]\n",
  "INCEPTOR": "a beginner [n -S]\n",
  "INCEPTORS": "INCEPTOR, a beginner [n]\n",
  "INCEPTS": "INCEPT, to take into the body [v]\n",
  "INCERTAIN": "(obsolete) uncertain; doubtful, also UNCERTAIN [adj]\n",
  "INCERTAINTIES": "INCERTAINTY, (obsolete) uncertainty, also UNCERTAINTY [n]\n",
  "INCERTAINTY": "(obsolete) uncertainty, also UNCERTAINTY [n INCERTAINTIES]\n",
  "INCERTITUDE": "(archaic) uncertainty [n -S]\n",
  "INCERTITUDES": "INCERTITUDE, (archaic) uncertainty [n]\n",
  "INCESSANCIES": "INCESSANCY, the quality of being incessant [n]\n",
  "INCESSANCY": "the quality of being incessant [n INCESSANCIES]\n",
  "INCESSANT": "unceasing, also UNCESSANT [adj INCESSANTLY]\n",
  "INCESSANTLY": "INCESSANT, unceasing, also UNCESSANT [adv]\n",
  "INCESSANTNESS": "INCESSANT, unceasing, also UNCESSANT [n]\n",
  "INCESSANTNESSES": "INCESSANTNESS, INCESSANT, unceasing, also UNCESSANT [n]\n",
  "INCEST": "sexual intercourse between close relatives [n -S]\n",
  "INCESTS": "INCEST, sexual intercourse between close relatives [n]\n",
  "INCESTUOUS": "constituting or involving incest [adj INCESTUOUSLY]\n",
  "INCESTUOUSLY": "INCESTUOUS, constituting or involving incest [adv]\n",
  "INCESTUOUSNESS": "INCESTUOUS, constituting or involving incest [n]\n",
  "INCH": "to move very slowly [v -ED, -ING, -ES]\n",
  "INCHARITABLE": "lacking charity, also UNCHARITABLE [adj]\n",
  "INCHASE": "to place in an ornamental border, also ENCHASE [v INCHASED, INCHASING, INCHASES]\n",
  "INCHASED": "INCHASE, to place in an ornamental border, also ENCHASE [v]\n",
  "INCHASES": "INCHASE, to place in an ornamental border, also ENCHASE [v]\n",
  "INCHASING": "INCHASE, to place in an ornamental border, also ENCHASE [v]\n",
  "INCHED": "INCH, to move very slowly [v]\n",
  "INCHER": "something having a specified number of inches [n -S]\n",
  "INCHERS": "INCHER, something having a specified number of inches [n]\n",
  "INCHES": "INCH, to move very slowly [v]\n",
  "INCHING": "INCH, to move very slowly [v]\n",
  "INCHMEAL": "little by little [adv]\n",
  "INCHOATE": "beginning [adj INCHOATELY] / to make a beginning, commence [v INCHOATED, INCHOATING, INCHOATES]\n",
  "INCHOATED": "INCHOATE, to make a beginning, commence [v]\n",
  "INCHOATELY": "INCHOATE, beginning [adv]\n",
  "INCHOATENESS": "the state of being inchoate [n -ES]\n",
  "INCHOATENESSES": "INCHOATENESS, the state of being inchoate [n]\n",
  "INCHOATES": "INCHOATE, to make a beginning, commence [v]\n",
  "INCHOATING": "INCHOATE, to make a beginning, commence [v]\n",
  "INCHOATION": "the act of beginning [n -S]\n",
  "INCHOATIONS": "INCHOATION, the act of beginning [n]\n",
  "INCHOATIVE": "expressing or pertaining to a beginning [adj INCHOATIVELY] / an inchoative verb [n -S]\n",
  "INCHOATIVELY": "INCHOATIVE, expressing or pertaining to a beginning [adv]\n",
  "INCHOATIVES": "INCHOATIVE, an inchoative verb [n]\n",
  "INCHPIN": "(obsolete) the sweetbread of a deer [n -S]\n",
  "INCHPINS": "INCHPIN, (obsolete) the sweetbread of a deer [n]\n",
  "INCHTAPE": "a measuring tape marked out in inches [n -S]\n",
  "INCHTAPES": "INCHTAPE, a measuring tape marked out in inches [n]\n",
  "INCHWORM": "another name for the looper caterpillar [n -S]\n",
  "INCHWORMS": "INCHWORM, another name for the looper caterpillar [n]\n",
  "INCIDENCE": "the frequency of an event [n -S]\n",
  "INCIDENCES": "INCIDENCE, the frequency of an event [n]\n",
  "INCIDENT": "an event [n -S]\n",
  "INCIDENTAL": "by the way [adj INCIDENTALLY] / a minor item (as of expense) that is not particularized [n -S]\n",
  "INCIDENTALLY": "INCIDENTAL, by the way [adv]\n",
  "INCIDENTALNESS": "INCIDENTAL, by the way [n]\n",
  "INCIDENTALS": "INCIDENTAL, a minor item (as of expense) that is not particularized [n]\n",
  "INCIDENTS": "INCIDENT, an event [n]\n",
  "INCINERATE": "to cause to burn to ashes [v INCINERATED, INCINERATING, INCINERATES]\n",
  "INCINERATED": "INCINERATE, to cause to burn to ashes [v]\n",
  "INCINERATES": "INCINERATE, to cause to burn to ashes [v]\n",
  "INCINERATING": "INCINERATE, to cause to burn to ashes [v]\n",
  "INCINERATION": "the act of incinerating [n -S]\n",
  "INCINERATIONS": "INCINERATION, the act of incinerating [n]\n",
  "INCINERATOR": "one that incinerates [n -S]\n",
  "INCINERATORS": "INCINERATOR, one that incinerates [n]\n",
  "INCIPIENCE": "a beginning; an incipient state, also INCIPIENCY [n -S]\n",
  "INCIPIENCES": "INCIPIENCE, a beginning; an incipient state, also INCIPIENCY [n]\n",
  "INCIPIENCIES": "INCIPIENCY, a beginning; an incipient state, also INCIPIENCE [n]\n",
  "INCIPIENCY": "a beginning; an incipient state, also INCIPIENCE [n INCIPIENCIES]\n",
  "INCIPIENT": "beginning; in an early stage [adj INCIPIENTLY]\n",
  "INCIPIENTLY": "INCIPIENT, beginning; in an early stage [adv]\n",
  "INCIPIT": "(Latin) an inscription meaning 'here begins', serving as the opening words of a text [n -S]\n",
  "INCIPITS": "INCIPIT, (Latin) an inscription meaning 'here begins', serving as the opening words of a text [n]\n",
  "INCISAL": "relating to the cutting edge of a tooth [adj]\n",
  "INCISE": "to cut into [v INCISED, INCISING, INCISES]\n",
  "INCISED": "INCISE, to cut into [v]\n",
  "INCISES": "INCISE, to cut into [v]\n",
  "INCISIFORM": "shaped like an incisor tooth [adj]\n",
  "INCISING": "INCISE, to cut into [v]\n",
  "INCISION": "the act of incising [n -S]\n",
  "INCISIONS": "INCISION, the act of incising [n]\n",
  "INCISIVE": "cutting, trenchant [adj INCISIVELY]\n",
  "INCISIVELY": "INCISIVE, cutting, trenchant [adv]\n",
  "INCISIVENESS": "the state of being incisive [n -ES]\n",
  "INCISIVENESSES": "INCISIVENESS, the state of being incisive [n]\n",
  "INCISOR": "a cutting tooth [n -S]\n",
  "INCISORIAL": "relating to an incision [adj]\n",
  "INCISORS": "INCISOR, a cutting tooth [n]\n",
  "INCISORY": "adapted for cutting [adj]\n",
  "INCISURAL": "relating to an incisure [adj]\n",
  "INCISURE": "a cut or incision [n -S]\n",
  "INCISURES": "INCISURE, a cut or incision [n]\n",
  "INCITABLE": "capable of being incited [adj]\n",
  "INCITANT": "something that incites [n -S]\n",
  "INCITANTS": "INCITANT, something that incites [n]\n",
  "INCITATION": "the act of inciting [n -S]\n",
  "INCITATIONS": "INCITATION, the act of inciting [n]\n",
  "INCITATIVE": "an agent that incites [n -S]\n",
  "INCITATIVES": "INCITATIVE, an agent that incites [n]\n",
  "INCITE": "to arouse to action [v INCITED, INCITING, INCITES]\n",
  "INCITED": "INCITE, to arouse to action [v]\n",
  "INCITEMENT": "the act of inciting [n -S]\n",
  "INCITEMENTS": "INCITEMENT, the act of inciting [n]\n",
  "INCITER": "one who incites [n -S]\n",
  "INCITERS": "INCITER, one who incites [n]\n",
  "INCITES": "INCITE, to arouse to action [v]\n",
  "INCITING": "INCITE, to arouse to action [v]\n",
  "INCITINGLY": "INCITING, INCITE, to arouse to action [adv]\n",
  "INCIVIL": "discourteous [adj]\n",
  "INCIVILITIES": "INCIVILITY, the state of being not civil, also UNCIVILITY [n]\n",
  "INCIVILITY": "the state of being not civil, also UNCIVILITY [n INCIVILITIES]\n",
  "INCIVISM": "neglect of duty as a citizen [n -S]\n",
  "INCIVISMS": "INCIVISM, neglect of duty as a citizen [n]\n",
  "INCLASP": "to embrace, also ENCLASP [v -ED, -ING, -S]\n",
  "INCLASPED": "INCLASP, to embrace, also ENCLASP [v]\n",
  "INCLASPING": "INCLASP, to embrace, also ENCLASP [v]\n",
  "INCLASPS": "INCLASP, to embrace, also ENCLASP [v]\n",
  "INCLE": "a broad linen tape, also INKLE [n -S]\n",
  "INCLEMENCIES": "INCLEMENCY, the quality of being inclement [n]\n",
  "INCLEMENCY": "the quality of being inclement [n INCLEMENCIES]\n",
  "INCLEMENT": "severe, stormy [adj INCLEMENTLY]\n",
  "INCLEMENTLY": "INCLEMENT, severe, stormy [adv]\n",
  "INCLEMENTNESS": "INCLEMENT, severe, stormy [n]\n",
  "INCLEMENTNESSES": "INCLEMENTNESS, INCLEMENT, severe, stormy [n]\n",
  "INCLES": "INCLE, a broad linen tape, also INKLE [n]\n",
  "INCLINABLE": "leaning; tending [adj]\n",
  "INCLINABLENESS": "the state of being inclinable [n]\n",
  "INCLINATION": "the act of inclining [n -S]\n",
  "INCLINATIONAL": "relating to inclination [adj]\n",
  "INCLINATIONS": "INCLINATION, the act of inclining [n]\n",
  "INCLINATORIA": "INCLINATORIUM, the dipping-needle, an instrument for determining magnetic dip [n]\n",
  "INCLINATORIUM": "the dipping-needle, an instrument for determining magnetic dip [n INCLINATORIA]\n",
  "INCLINATORY": "of the nature of inclination [adj]\n",
  "INCLINE": "to slant [v INCLINED, INCLINING, INCLINES]\n",
  "INCLINED": "INCLINE, to slant [v]\n",
  "INCLINER": "something or someone that inclines [n -S]\n",
  "INCLINERS": "INCLINER, something or someone that inclines [n]\n",
  "INCLINES": "INCLINE, to slant [v]\n",
  "INCLINING": "an inclination, a following [n -S]\n",
  "INCLININGS": "INCLINING, an inclination, a following [n]\n",
  "INCLINOMETER": "an instrument for measuring the inclination to the horizontal of an axis [n -S]\n",
  "INCLINOMETERS": "INCLINOMETER, an instrument for measuring the inclination to the horizontal of an axis [n]\n",
  "INCLIP": "(archaic) to clasp; to inclose [v INCLIPPED, INCLIPPING, INCLIPS]\n",
  "INCLIPPED": "INCLIP, (archaic) to clasp; to inclose [v]\n",
  "INCLIPPING": "INCLIP, (archaic) to clasp; to inclose [v]\n",
  "INCLIPS": "INCLIP, (archaic) to clasp; to inclose [v]\n",
  "INCLOSABLE": "capable of being inclosed, also ENCLOSABLE [adj]\n",
  "INCLOSE": "to surround, also ENCLOSE [v INCLOSED, INCLOSING, INCLOSES]\n",
  "INCLOSED": "INCLOSE, to surround, also ENCLOSE [v]\n",
  "INCLOSER": "one who, or that which, incloses [n -S]\n",
  "INCLOSERS": "INCLOSER, one who, or that which, incloses [n]\n",
  "INCLOSES": "INCLOSE, to surround, also ENCLOSE [v]\n",
  "INCLOSING": "INCLOSE, to surround, also ENCLOSE [v]\n",
  "INCLOSURE": "the act of inclosing; the separation of land from common ground by a fence, also ENCLOSURE [n -S]\n",
  "INCLOSURES": "INCLOSURE, the act of inclosing; the separation of land from common ground by a fence, also ENCLOSURE [n]\n",
  "INCLUDABLE": "that can be included, also INCLUDIBLE [adj]\n",
  "INCLUDE": "to take in as part of a whole [v INCLUDED, INCLUDING, INCLUDES]\n",
  "INCLUDED": "INCLUDE, to take in as part of a whole [v]\n",
  "INCLUDEDNESS": "the state of being included [n -ES]\n",
  "INCLUDEDNESSES": "INCLUDEDNESS, the state of being included [n]\n",
  "INCLUDES": "INCLUDE, to take in as part of a whole [v]\n",
  "INCLUDIBLE": "that can be included, also INCLUDABLE [adj]\n",
  "INCLUDING": "INCLUDE, to take in as part of a whole [v]\n",
  "INCLUSION": "a fragment of older rock caught up in an igneous rock [n -S]\n",
  "INCLUSIONS": "INCLUSION, a fragment of older rock caught up in an igneous rock [n]\n",
  "INCLUSIVE": "comprehensive; including everything [adj INCLUSIVELY]\n",
  "INCLUSIVELY": "INCLUSIVE, comprehensive; including everything [adv]\n",
  "INCLUSIVENESS": "INCLUSIVE, comprehensive; including everything [n]\n",
  "INCLUSIVENESSES": "INCLUSIVENESS, INCLUSIVE, comprehensive; including everything [n]\n",
  "INCLUSIVITIES": "INCLUSIVITY, the state of being inclusive [n]\n",
  "INCLUSIVITY": "the state of being inclusive [n INCLUSIVITIES]\n",
  "INCOAGULABLE": "incapable of coagulation [adj]\n",
  "INCOERCIBLE": "that cannot be coerced [adj]\n",
  "INCOG": "(short for) incognito, a person concealing his identity [n -S]\n",
  "INCOGITABILITY": "the quality of being incogitable, unthinkable [n]\n",
  "INCOGITABLE": "unthinkable [adj]\n",
  "INCOGITANCIES": "INCOGITANCY, the state of being incogitant, thoughtless [n]\n",
  "INCOGITANCY": "the state of being incogitant, thoughtless [n INCOGITANCIES]\n",
  "INCOGITANT": "thoughtless; inconsiderate [adj]\n",
  "INCOGITATIVE": "unthinking, thoughtless [adj]\n",
  "INCOGNISABLE": "that cannot be known or distinguished, also INCOGNIZABLE [adj]\n",
  "INCOGNISANCE": "failure to recognise, also INCOGNIZANCE [n -S]\n",
  "INCOGNISANCES": "INCOGNISANCE, failure to recognise, also INCOGNIZANCE [n]\n",
  "INCOGNISANT": "unaware, also INCOGNIZANT [adj]\n",
  "INCOGNITA": "(Italian) a woman who is unknown or in disguise [n -S]\n",
  "INCOGNITAS": "INCOGNITA, (Italian) a woman who is unknown or in disguise [n]\n",
  "INCOGNITO": "(Italian) a man who is unknown or in disguise [n -S]\n",
  "INCOGNITOS": "INCOGNITO, (Italian) a man who is unknown or in disguise [n]\n",
  "INCOGNIZABLE": "that cannot be known or distinguished, also INCOGNISABLE [adj]\n",
  "INCOGNIZANCE": "failure to recognise, also INCOGNISANCE [n -S]\n",
  "INCOGNIZANCES": "INCOGNIZANCE, failure to recognise, also INCOGNISANCE [n]\n",
  "INCOGNIZANT": "lacking awareness or consciousness, also INCOGNISANT [adj]\n",
  "INCOGS": "INCOG, (short for) incognito, a person concealing his identity [n]\n",
  "INCOHERENCE": "the state of being incoherent, also INCOHERENCY [n -S]\n",
  "INCOHERENCES": "INCOHERENCE, the state of being incoherent, also INCOHERENCY [n]\n",
  "INCOHERENCIES": "INCOHERENCY, the state of being incoherent, also INCOHERENCE [n]\n",
  "INCOHERENCY": "the state of being incoherent, also INCOHERENCE [n INCOHERENCIES]\n",
  "INCOHERENT": "lacking coherence [adj INCOHERENTLY]\n",
  "INCOHERENTLY": "INCOHERENT, lacking coherence [adv]\n",
  "INCOHERENTNESS": "the state of being incoherent [n]\n",
  "INCOHESIVE": "lacking in unity; not fitting together smoothly [adj]\n",
  "INCOMBUSTIBLE": "not combustible [adj INCOMBUSTIBLY] / something not combustible [n -S]\n",
  "INCOMBUSTIBLES": "INCOMBUSTIBLE, something not combustible [n]\n",
  "INCOMBUSTIBLY": "INCOMBUSTIBLE, not combustible [adv]\n",
  "INCOME": "money earned regularly [n -S]\n",
  "INCOMER": "one that comes in [n -S]\n",
  "INCOMERS": "INCOMER, one that comes in [n]\n",
  "INCOMES": "INCOME, money earned regularly [n]\n",
  "INCOMING": "an arrival [n -S]\n",
  "INCOMINGS": "INCOMING, an arrival [n]\n",
  "INCOMMENSURABLE": "not commensurable, lacking a basis of comparison in respect to a quality normally subject to comparison [adj INCOMMENSURABLY]\n",
  "INCOMMENSURABLY": "INCOMMENSURABLE, not commensurable, lacking a basis of comparison in respect to a quality normally subject to comparison [adv]\n",
  "INCOMMENSURATE": "not commensurate [adj]\n",
  "INCOMMISCIBLE": "unable to be mixed or intermingled [adj]\n",
  "INCOMMODE": "to put to inconvenience, also DISCOMMODE [v INCOMMODED, INCOMMODING, INCOMMODES]\n",
  "INCOMMODED": "INCOMMODE, to put to inconvenience, also DISCOMMODE [v]\n",
  "INCOMMODES": "INCOMMODE, to put to inconvenience, also DISCOMMODE [v]\n",
  "INCOMMODING": "INCOMMODE, to put to inconvenience, also DISCOMMODE [v]\n",
  "INCOMMODIOUS": "not commodious [adj INCOMMODIOUSLY]\n",
  "INCOMMODIOUSLY": "INCOMMODIOUS, not commodious [adv]\n",
  "INCOMMODITIES": "INCOMMODITY, anything that causes inconvenience [n]\n",
  "INCOMMODITY": "anything that causes inconvenience [n INCOMMODITIES]\n",
  "INCOMMUNICABLE": "not communicable [adj INCOMMUNICABLY]\n",
  "INCOMMUNICABLY": "INCOMMUNICABLE, not communicable [adv]\n",
  "INCOMMUNICADO": "(Spanish) without means of communication, also INCOMUNICADO [adj]\n",
  "INCOMMUNICATIVE": "not communicative, also UNCOMMUNICATIVE [adj]\n",
  "INCOMMUTABILITY": "the quality of being incommutable [n]\n",
  "INCOMMUTABLE": "that cannot be commuted or exchanged [adj INCOMMUTABLY]\n",
  "INCOMMUTABLY": "INCOMMUTABLE, that cannot be commuted or exchanged [adv]\n",
  "INCOMPACT": "not compact [adj]\n",
  "INCOMPARABILITY": "the state of being incomparable [n]\n",
  "INCOMPARABLE": "eminent beyond comparison [adj INCOMPARABLY]\n",
  "INCOMPARABLY": "INCOMPARABLE, eminent beyond comparison [adv]\n",
  "INCOMPARED": "(Spenser) peerless; incomparable [adj]\n",
  "INCOMPATIBILITY": "the state of being incompatible [n]\n",
  "INCOMPATIBLE": "incapable of association or harmonious coexistence [adj INCOMPATIBLY] / one who is incompatible [n -S]\n",
  "INCOMPATIBLES": "INCOMPATIBLE, one who is incompatible [n]\n",
  "INCOMPATIBLY": "INCOMPATIBLE, incapable of association or harmonious coexistence [adv]\n",
  "INCOMPETENCE": "the state or fact of being incompetent, also INCOMPETENCY [n -S]\n",
  "INCOMPETENCES": "INCOMPETENCE, the state or fact of being incompetent, also INCOMPETENCY [n]\n",
  "INCOMPETENCIES": "INCOMPETENCY, the state of being incompetent, also INCOMPETENCE [n]\n",
  "INCOMPETENCY": "the state of being incompetent, also INCOMPETENCE [n INCOMPETENCIES]\n",
  "INCOMPETENT": "not competent [adj] / one who is not legally qualified [n -S]\n",
  "INCOMPETENTLY": "INCOMPETENT, not competent [adv]\n",
  "INCOMPETENTS": "INCOMPETENT, one who is not legally qualified [n]\n",
  "INCOMPLETE": "lacking a part [adj INCOMPLETELY]\n",
  "INCOMPLETELY": "INCOMPLETE, lacking a part [adv]\n",
  "INCOMPLETENESS": "the state of being incomplete [n]\n",
  "INCOMPLETION": "lack of completeness [n -S]\n",
  "INCOMPLETIONS": "INCOMPLETION, lack of completeness [n]\n",
  "INCOMPLIANCE": "lack of compliance, also INCOMPLIANCY [n -S]\n",
  "INCOMPLIANCES": "INCOMPLIANCE, lack of compliance, also INCOMPLIANCY [n]\n",
  "INCOMPLIANCIES": "INCOMPLIANCY, lack of compliance, also INCOMPLIANCE [n]\n",
  "INCOMPLIANCY": "lack of compliance, also INCOMPLIANCE [n INCOMPLIANCIES]\n",
  "INCOMPLIANT": "not compliant [adj INCOMPLIANTLY]\n",
  "INCOMPLIANTLY": "INCOMPLIANT, not compliant [adv]\n",
  "INCOMPOSED": "disordered; disturbed [adj]\n",
  "INCOMPOSITE": "not composite [adj]\n",
  "INCOMPOSSIBLE": "incapable of coexisting [adj]\n",
  "INCOMPREHENSION": "lack of comprehension or understanding [n]\n",
  "INCOMPREHENSIVE": "not comprehensive [adj]\n",
  "INCOMPRESSIBLE": "incapable of or resistant to compression [adj INCOMPRESSIBLY]\n",
  "INCOMPRESSIBLY": "INCOMPRESSIBLE, incapable of or resistant to compression [adv]\n",
  "INCOMPUTABILITY": "the quality of being incomputable [n]\n",
  "INCOMPUTABLE": "not computable [adj INCOMPUTABLY]\n",
  "INCOMPUTABLY": "INCOMPUTABLE, not computable [adv]\n",
  "INCOMUNICADO": "(Spanish) without means of communication, also INCOMMUNICADO [adj]\n",
  "INCONCEIVABLE": "not conceivable, also UNCONCEIVABLE [adj INCONCEIVABLY] / something that cannot be conceived [n -S]\n",
  "INCONCEIVABLES": "INCONCEIVABLE, something that cannot be conceived [n]\n",
  "INCONCEIVABLY": "INCONCEIVABLE, not conceivable, also UNCONCEIVABLE [adv]\n",
  "INCONCINNITIES": "INCONCINNITY, lack of suitability or congruity [n]\n",
  "INCONCINNITY": "lack of suitability or congruity [n INCONCINNITIES]\n",
  "INCONCINNOUS": "showing inconcinnity, lack of congruousness or proportion [adj]\n",
  "INCONCLUSION": "lack of a definite conclusion [n -S]\n",
  "INCONCLUSIONS": "INCONCLUSION, lack of a definite conclusion [n]\n",
  "INCONCLUSIVE": "leading to no conclusion or definite result [adj INCONCLUSIVELY]\n",
  "INCONCLUSIVELY": "INCONCLUSIVE, leading to no conclusion or definite result [adv]\n",
  "INCONDENSABLE": "not able to be condensed, also INCONDENSIBLE [adj]\n",
  "INCONDENSIBLE": "not able to be condensed, also INCONDENSABLE [adj]\n",
  "INCONDITE": "not well put together; poorly constructed [adj INCONDITELY]\n",
  "INCONDITELY": "INCONDITE, not well put together; poorly constructed [adv]\n",
  "INCONFORMITIES": "INCONFORMITY, lack of conformity [n]\n",
  "INCONFORMITY": "lack of conformity [n INCONFORMITIES]\n",
  "INCONGRUENCE": "lack of congruence [n -S]\n",
  "INCONGRUENCES": "INCONGRUENCE, lack of congruence [n]\n",
  "INCONGRUENT": "not congruent [adj INCONGRUENTLY]\n",
  "INCONGRUENTLY": "INCONGRUENT, not congruent [adv]\n",
  "INCONGRUITIES": "INCONGRUITY, the state of being incongruous [n]\n",
  "INCONGRUITY": "the state of being incongruous [n INCONGRUITIES]\n",
  "INCONGRUOUS": "lacking congruity [adj INCONGRUOUSLY]\n",
  "INCONGRUOUSLY": "INCONGRUOUS, lacking congruity [adv]\n",
  "INCONGRUOUSNESS": "INCONGRUOUS, lacking congruity [n]\n",
  "INCONIE": "(Shakespeare) delicate and pretty, also INCONY [adj]\n",
  "INCONNU": "(French) an unknown (male) person; a large food fish of NW Canada [n -S]\n",
  "INCONNUE": "(French) an unknown (female) person [n -S]\n",
  "INCONNUES": "INCONNUE, (French) an unknown (female) person [n]\n",
  "INCONNUS": "INCONNU, (French) an unknown (male) person; a large food fish of NW Canada [n]\n",
  "INCONSCIENT": "unconscious; abstracted [adj INCONSCIENTLY]\n",
  "INCONSCIENTLY": "INCONSCIENT, unconscious; abstracted [adv]\n",
  "INCONSCIONABLE": "disregarding the conscience, also UNCONSCIONABLE [adj]\n",
  "INCONSCIOUS": "not conscious, also UNCONSCIOUS [adj]\n",
  "INCONSECUTIVE": "not consecutive [adj INCONSECUTIVELY]\n",
  "INCONSECUTIVELY": "INCONSECUTIVE, not consecutive [adv]\n",
  "INCONSEQUENCE": "the state of being inconsequent [n -S]\n",
  "INCONSEQUENCES": "INCONSEQUENCE, the state of being inconsequent [n]\n",
  "INCONSEQUENT": "lacking reasonable sequence [adj INCONSEQUENTLY]\n",
  "INCONSEQUENTIAL": "of no consequence [adj]\n",
  "INCONSEQUENTLY": "INCONSEQUENT, lacking reasonable sequence [adv]\n",
  "INCONSIDERABLE": "not considerable [adj INCONSIDERABLY]\n",
  "INCONSIDERABLY": "INCONSIDERABLE, not considerable [adv]\n",
  "INCONSIDERATE": "heedless, thoughtless [adj INCONSIDERATELY]\n",
  "INCONSIDERATELY": "INCONSIDERATE, heedless, thoughtless [adv]\n",
  "INCONSIDERATION": "the state of being inconsiderate [n]\n",
  "INCONSISTENCE": "the state of being inconsistent, also INCONSISTENCY [n -S]\n",
  "INCONSISTENCES": "INCONSISTENCE, the state of being inconsistent, also INCONSISTENCY [n]\n",
  "INCONSISTENCIES": "INCONSISTENCY, the state of being inconsistent, also INCONSISTENCE [n]\n",
  "INCONSISTENCY": "the state of being inconsistent, also INCONSISTENCE [n INCONSISTENCIES]\n",
  "INCONSISTENT": "lacking consistency [adj INCONSISTENTLY]\n",
  "INCONSISTENTLY": "INCONSISTENT, lacking consistency [adv]\n",
  "INCONSOLABILITY": "the quality of being inconsolable [n]\n",
  "INCONSOLABLE": "incapable of being consoled [adj INCONSOLABLY]\n",
  "INCONSOLABLY": "INCONSOLABLE, incapable of being consoled [adv]\n",
  "INCONSONANCE": "lack of consonance or harmony [n -S]\n",
  "INCONSONANCES": "INCONSONANCE, lack of consonance or harmony [n]\n",
  "INCONSONANT": "not consonant [adj INCONSONANTLY]\n",
  "INCONSONANTLY": "INCONSONANT, not consonant [adv]\n",
  "INCONSPICUOUS": "not easily seen [adj INCONSPICUOUSLY]\n",
  "INCONSPICUOUSLY": "INCONSPICUOUS, not easily seen [adv]\n",
  "INCONSTANCIES": "INCONSTANCY, the state of being inconstant [n]\n",
  "INCONSTANCY": "the state of being inconstant [n INCONSTANCIES]\n",
  "INCONSTANT": "not constant, also UNCONSTANT [adj INCONSTANTLY]\n",
  "INCONSTANTLY": "INCONSTANT, not constant, also UNCONSTANT [adv]\n",
  "INCONSTRUABLE": "that cannot be construed [adj]\n",
  "INCONSUMABLE": "not capable of being consumed [adj INCONSUMABLY]\n",
  "INCONSUMABLY": "INCONSUMABLE, not capable of being consumed [adv]\n",
  "INCONTESTABLE": "not contestable [adj INCONTESTABLY]\n",
  "INCONTESTABLY": "INCONTESTABLE, not contestable [adv]\n",
  "INCONTIGUOUS": "not contiguous [adj INCONTIGUOUSLY]\n",
  "INCONTIGUOUSLY": "INCONTIGUOUS, not contiguous [adv]\n",
  "INCONTINENCE": "the state of being incontinent, also INCONTINENCY [n -S]\n",
  "INCONTINENCES": "INCONTINENCE, the state of being incontinent, also INCONTINENCY [n]\n",
  "INCONTINENCIES": "INCONTINENCY, the state of being incontinent, also INCONTINENCE [n]\n",
  "INCONTINENCY": "the state of being incontinent, also INCONTINENCE [n INCONTINENCIES]\n",
  "INCONTINENT": "not continent [adj INCONTINENTLY]\n",
  "INCONTINENTLY": "INCONTINENT, not continent [adv]\n",
  "INCONTROLLABLE": "not controllable, also UNCONTROLLABLE [adj INCONTROLLABLY]\n",
  "INCONTROLLABLY": "INCONTROLLABLE, not controllable, also UNCONTROLLABLE [adv]\n",
  "INCONVENIENCE": "to subject to inconvenience [v INCONVENIENCED, INCONVENIENCING, INCONVENIENCES]\n",
  "INCONVENIENCED": "INCONVENIENCE, to subject to inconvenience [v]\n",
  "INCONVENIENCES": "INCONVENIENCE, to subject to inconvenience [v]\n",
  "INCONVENIENCIES": "INCONVENIENCY, lack of convenience, also INCONVENIENCE [n]\n",
  "INCONVENIENCING": "INCONVENIENCE, to subject to inconvenience [v]\n",
  "INCONVENIENCY": "lack of convenience, also INCONVENIENCE [n INCONVENIENCIES]\n",
  "INCONVENIENT": "not convenient esp. in giving trouble or annoyance [adj INCONVENIENTLY]\n",
  "INCONVENIENTLY": "INCONVENIENT, not convenient esp. in giving trouble or annoyance [adv]\n",
  "INCONVERSABLE": "not capable of being conversed with [adj]\n",
  "INCONVERSANT": "not conversant [adj]\n",
  "INCONVERTIBLE": "not convertible [adj INCONVERTIBLY]\n",
  "INCONVERTIBLY": "INCONVERTIBLE, not convertible [adv]\n",
  "INCONVINCIBLE": "incapable of being convinced [adj INCONVINCIBLY]\n",
  "INCONVINCIBLY": "INCONVINCIBLE, incapable of being convinced [adv]\n",
  "INCONY": "(Shakespeare) fine, delicate, also INCONIE [adj]\n",
  "INCOORDINATE": "not coordinate [adj]\n",
  "INCOORDINATION": "lack of coordination [n -S]\n",
  "INCOORDINATIONS": "INCOORDINATION, lack of coordination [n]\n",
  "INCORONATE": "crowned, also INCORONATED [adj]\n",
  "INCORONATED": "crowned, also INCORONATE [adj]\n",
  "INCORONATION": "the act of crowning [n -S]\n",
  "INCORONATIONS": "INCORONATION, the act of crowning [n]\n",
  "INCORPORABLE": "capable of being incorporated [adj]\n",
  "INCORPORAL": "(archaic) incorporeal, also INCORPORALL [adj]\n",
  "INCORPORALL": "(archaic) incorporeal, also INCORPORAL [adj]\n",
  "INCORPORATE": "to form into a body [v INCORPORATED, INCORPORATING, INCORPORATES]\n",
  "INCORPORATED": "INCORPORATE, to form into a body [v]\n",
  "INCORPORATES": "INCORPORATE, to form into a body [v]\n",
  "INCORPORATING": "INCORPORATE, to form into a body [v]\n",
  "INCORPORATION": "the act of incorporating [n -S]\n",
  "INCORPORATIONS": "INCORPORATION, the act of incorporating [n]\n",
  "INCORPORATIVE": "serving to incorporate [adj]\n",
  "INCORPORATOR": "one who incorporates [n -S]\n",
  "INCORPORATORS": "INCORPORATOR, one who incorporates [n]\n",
  "INCORPOREAL": "not corporeal, having no bodily or material structure [adj INCORPOREALLY]\n",
  "INCORPOREALITY": "the state of being incorporeal [n]\n",
  "INCORPOREALLY": "INCORPOREAL, not corporeal, having no bodily or material structure [adv]\n",
  "INCORPOREITIES": "INCORPOREITY, the state of being incorporeal [n]\n",
  "INCORPOREITY": "the state of being incorporeal [n INCORPOREITIES]\n",
  "INCORPSE": "to incorporate [v INCORPSED, INCORPSING, INCORPSES]\n",
  "INCORPSED": "INCORPSE, to incorporate [v]\n",
  "INCORPSES": "INCORPSE, to incorporate [v]\n",
  "INCORPSING": "INCORPSE, to incorporate [v]\n",
  "INCORRECT": "not correct [adj INCORRECTLY]\n",
  "INCORRECTLY": "INCORRECT, not correct [adv]\n",
  "INCORRECTNESS": "the state of being incorrect [n -ES]\n",
  "INCORRECTNESSES": "INCORRECTNESS, the state of being incorrect [n]\n",
  "INCORRIGIBILITY": "the state of being incorrigible [n]\n",
  "INCORRIGIBLE": "incapable of being corrected or amended [adj INCORRIGIBLY] / one who is incorrigible [n -S]\n",
  "INCORRIGIBLES": "INCORRIGIBLE, one who is incorrigible [n]\n",
  "INCORRIGIBLY": "INCORRIGIBLE, incapable of being corrected or amended [adv]\n",
  "INCORRODIBLE": "not corrodible, also INCORROSIBLE [adj]\n",
  "INCORROSIBLE": "not corrosible, also INCORRODIBLE [adj]\n",
  "INCORRUPT": "not corrupt, also UNCORRUPT [adj INCORRUPTLY]\n",
  "INCORRUPTED": "not corrupted [adj]\n",
  "INCORRUPTIBLE": "incapable of corruption [adj INCORRUPTIBLY] / someone who cannot be corrupted [n -S]\n",
  "INCORRUPTIBLES": "INCORRUPTIBLE, someone who cannot be corrupted [n]\n",
  "INCORRUPTIBLY": "INCORRUPTIBLE, incapable of corruption [adv]\n",
  "INCORRUPTION": "the state of being free from physical decay [n -S]\n",
  "INCORRUPTIONS": "INCORRUPTION, the state of being free from physical decay [n]\n",
  "INCORRUPTIVE": "incapable of being corrupted [adj]\n",
  "INCORRUPTLY": "INCORRUPT, not corrupt, also UNCORRUPT [adv]\n",
  "INCORRUPTNESS": "the state of being incorrupt [n -ES]\n",
  "INCORRUPTNESSES": "INCORRUPTNESS, the state of being incorrupt [n]\n",
  "INCRASSATE": "(obsolete) to thicken [v INCRASSATED, INCRASSATING, INCRASSATES]\n",
  "INCRASSATED": "INCRASSATE, (obsolete) to thicken [v]\n",
  "INCRASSATES": "INCRASSATE, (obsolete) to thicken [v]\n",
  "INCRASSATING": "INCRASSATE, (obsolete) to thicken [v]\n",
  "INCRASSATION": "thickening [n -S]\n",
  "INCRASSATIONS": "INCRASSATION, thickening [n]\n",
  "INCRASSATIVE": "a drug used to incrassate, thicken the humours [n -S]\n",
  "INCRASSATIVES": "INCRASSATIVE, a drug used to incrassate, thicken the humours [n]\n",
  "INCREASABLE": "capable of being increased [adj]\n",
  "INCREASE": "to become larger, also ENCREASE [v INCREASED, INCREASING, INCREASES]\n",
  "INCREASED": "INCREASE, to become larger, also ENCREASE [v]\n",
  "INCREASEDLY": "INCREASED, INCREASE, to become larger, also ENCREASE [adv]\n",
  "INCREASEFUL": "(Shakespeare) fruitful, productive [adj]\n",
  "INCREASER": "one who increases [n -S]\n",
  "INCREASERS": "INCREASER, one who increases [n]\n",
  "INCREASES": "INCREASE, to become larger, also ENCREASE [v]\n",
  "INCREASING": "growing [adj INCREASINGLY] / the act of increasing [n -S]\n",
  "INCREASINGLY": "INCREASING, growing [adv]\n",
  "INCREASINGS": "INCREASING, the act of increasing [n]\n",
  "INCREATE": "(archaic) existing without having been created [adj INCREATELY]\n",
  "INCREATELY": "INCREATE, (archaic) existing without having been created [adv]\n",
  "INCREDIBILITIES": "INCREDIBILITY, the state of being incredible [n]\n",
  "INCREDIBILITY": "the state of being incredible [n INCREDIBILITIES]\n",
  "INCREDIBLE": "unbelievable, also UNCREDIBLE [adj INCREDIBLY]\n",
  "INCREDIBLENESS": "the state of being incredible [n]\n",
  "INCREDIBLY": "INCREDIBLE, unbelievable, also UNCREDIBLE [adv]\n",
  "INCREDULITIES": "INCREDULITY, the state of being incredulous [n]\n",
  "INCREDULITY": "the state of being incredulous [n INCREDULITIES]\n",
  "INCREDULOUS": "unwilling to admit or accept what is offered as true [adj INCREDULOUSLY]\n",
  "INCREDULOUSLY": "INCREDULOUS, unwilling to admit or accept what is offered as true [adv]\n",
  "INCREDULOUSNESS": "the state of being incredulous [n]\n",
  "INCREMATE": "(obsolete) to cremate [v INCREMATED, INCREMATING, INCREMATES]\n",
  "INCREMATED": "INCREMATE, (obsolete) to cremate [v]\n",
  "INCREMATES": "INCREMATE, (obsolete) to cremate [v]\n",
  "INCREMATING": "INCREMATE, (obsolete) to cremate [v]\n",
  "INCREMATION": "the act of incremating [n -S]\n",
  "INCREMATIONS": "INCREMATION, the act of incremating [n]\n",
  "INCREMENT": "to add 1 to the value in a storage location [v -ED, -ING, -S]\n",
  "INCREMENTAL": "of the nature of an increment [adj INCREMENTALLY] / an increment [n -S]\n",
  "INCREMENTALISM": "a policy or advocacy of a policy of political or social change by degrees [n -S]\n",
  "INCREMENTALISMS": "INCREMENTALISM, a policy or advocacy of a policy of political or social change by degrees [n]\n",
  "INCREMENTALIST": "an exponent of incrementalism [n -S]\n",
  "INCREMENTALISTS": "INCREMENTALIST, an exponent of incrementalism [n]\n",
  "INCREMENTALLY": "INCREMENTAL, of the nature of an increment [adv]\n",
  "INCREMENTALS": "INCREMENTAL, an increment [n]\n",
  "INCREMENTED": "INCREMENT, to add 1 to the value in a storage location [v]\n",
  "INCREMENTING": "INCREMENT, to add 1 to the value in a storage location [v]\n",
  "INCREMENTS": "INCREMENT, to add 1 to the value in a storage location [v]\n",
  "INCRESCENT": "of a moon, waxing, with horns towards dexter [adj]\n",
  "INCRETION": "internal secretion [n -S]\n",
  "INCRETIONARY": "relating to incretion, internal secretion [adj]\n",
  "INCRETIONS": "INCRETION, internal secretion [n]\n",
  "INCRETORY": "relating to incretion, internal secretion [adj]\n",
  "INCRIMINATE": "to charge with a crime or fault [v INCRIMINATED, INCRIMINATING, INCRIMINATES]\n",
  "INCRIMINATED": "INCRIMINATE, to charge with a crime or fault [v]\n",
  "INCRIMINATES": "INCRIMINATE, to charge with a crime or fault [v]\n",
  "INCRIMINATING": "INCRIMINATE, to charge with a crime or fault [v]\n",
  "INCRIMINATION": "the act of incriminating [n -S]\n",
  "INCRIMINATIONS": "INCRIMINATION, the act of incriminating [n]\n",
  "INCRIMINATOR": "one who incriminates [n -S]\n",
  "INCRIMINATORS": "INCRIMINATOR, one who incriminates [n]\n",
  "INCRIMINATORY": "tending to incriminate [adj]\n",
  "INCROSS": "to produce by crossing two inbred individuals of different breeds, also INCROSSBREED [v INCROSSED, INCROSSING, INCROSSES]\n",
  "INCROSSBRED": "a plant or animal produced by crossing two inbred individuals of different breeds [n -S]\n",
  "INCROSSBREDS": "INCROSSBRED, a plant or animal produced by crossing two inbred individuals of different breeds [n]\n",
  "INCROSSBREED": "to produce by crossing two inbred individuals of different breeds, also INCROSS [v INCROSSBRED, INCROSSBREEDING, INCROSSBREEDS]\n",
  "INCROSSBREEDING": "INCROSSBREED, to produce by crossing two inbred individuals of different breeds, also INCROSS [v]\n",
  "INCROSSBREEDS": "INCROSSBREED, to produce by crossing two inbred individuals of different breeds, also INCROSS [v]\n",
  "INCROSSED": "INCROSS, to produce by crossing two inbred individuals of different breeds, also INCROSSBREED [v]\n",
  "INCROSSES": "INCROSS, to produce by crossing two inbred individuals of different breeds, also INCROSSBREED [v]\n",
  "INCROSSING": "INCROSS, to produce by crossing two inbred individuals of different breeds, also INCROSSBREED [v]\n",
  "INCRUST": "to cover with a crust, also ENCRUST [v -ED, -ING, -S]\n",
  "INCRUSTANT": "something tending to incrust [n -S]\n",
  "INCRUSTANTS": "INCRUSTANT, something tending to incrust [n]\n",
  "INCRUSTATION": "a crust or hard coating, also ENCRUSTATION [n -S]\n",
  "INCRUSTATIONS": "INCRUSTATION, a crust or hard coating, also ENCRUSTATION [n]\n",
  "INCRUSTED": "INCRUST, to cover with a crust, also ENCRUST [v]\n",
  "INCRUSTING": "INCRUST, to cover with a crust, also ENCRUST [v]\n",
  "INCRUSTMENT": "the state of being incrusted, also ENCRUSTMENT [n -S]\n",
  "INCRUSTMENTS": "INCRUSTMENT, the state of being incrusted, also ENCRUSTMENT [n]\n",
  "INCRUSTS": "INCRUST, to cover with a crust, also ENCRUST [v]\n",
  "INCUBATE": "to warm eggs for hatching [v INCUBATED, INCUBATING, INCUBATES]\n",
  "INCUBATED": "INCUBATE, to warm eggs for hatching [v]\n",
  "INCUBATES": "INCUBATE, to warm eggs for hatching [v]\n",
  "INCUBATING": "INCUBATE, to warm eggs for hatching [v]\n",
  "INCUBATION": "the act of incubating [n -S]\n",
  "INCUBATIONAL": "relating to incubation [adj]\n",
  "INCUBATIONS": "INCUBATION, the act of incubating [n]\n",
  "INCUBATIVE": "of or pertaining to incubation [adj]\n",
  "INCUBATOR": "an apparatus for hatching eggs by artificial heat [n -S]\n",
  "INCUBATORS": "INCUBATOR, an apparatus for hatching eggs by artificial heat [n]\n",
  "INCUBATORY": "serving for incubation [adj]\n",
  "INCUBI": "INCUBUS, (Latin) an evil spirit that lies on women in their sleep [n]\n",
  "INCUBOUS": "having overlapping leaves, as in liverworts [adj]\n",
  "INCUBUS": "(Latin) an evil spirit that lies on women in their sleep [n INCUBI or INCUBUSES]\n",
  "INCUBUSES": "INCUBUS, (Latin) an evil spirit that lies on women in their sleep [n]\n",
  "INCUDAL": "shaped like an incus or anvil, also INCUDATE [adj]\n",
  "INCUDATE": "shaped like an incus or anvil, also INCUDAL [adj]\n",
  "INCUDES": "INCUS, (Latin) an anvil-shaped bone in the middle ear [n]\n",
  "INCULCATE": "to teach and impress by frequent repetitions or admonitions [v INCULCATED, INCULCATING, INCULCATES]\n",
  "INCULCATED": "INCULCATE, to teach and impress by frequent repetitions or admonitions [v]\n",
  "INCULCATES": "INCULCATE, to teach and impress by frequent repetitions or admonitions [v]\n",
  "INCULCATING": "INCULCATE, to teach and impress by frequent repetitions or admonitions [v]\n",
  "INCULCATION": "the act of inculcating [n -S]\n",
  "INCULCATIONS": "INCULCATION, the act of inculcating [n]\n",
  "INCULCATIVE": "serving to inculcate [adj]\n",
  "INCULCATOR": "one who inculcates [n -S]\n",
  "INCULCATORS": "INCULCATOR, one who inculcates [n]\n",
  "INCULCATORY": "serving to inculcate [adj]\n",
  "INCULPABILITIES": "INCULPABILITY, the quality of being inculpable [n]\n",
  "INCULPABILITY": "the quality of being inculpable [n INCULPABILITIES]\n",
  "INCULPABLE": "blameless [adj INCULPABLY]\n",
  "INCULPABLENESS": "the state of being inculpable [n]\n",
  "INCULPABLY": "INCULPABLE, blameless [adv]\n",
  "INCULPATE": "to blame; to incriminate [v INCULPATED, INCULPATING, INCULPATES]\n",
  "INCULPATED": "INCULPATE, to blame; to incriminate [v]\n",
  "INCULPATES": "INCULPATE, to blame; to incriminate [v]\n",
  "INCULPATING": "INCULPATE, to blame; to incriminate [v]\n",
  "INCULPATION": "the act of inculpating [n -S]\n",
  "INCULPATIONS": "INCULPATION, the act of inculpating [n]\n",
  "INCULPATIVE": "serving to inculpate, also INCULPATORY [adj]\n",
  "INCULPATORY": "tending to inculpate, also INCULPATIVE [adj]\n",
  "INCULT": "uncultivated [adj]\n",
  "INCUMBENCIES": "INCUMBENCY, something that is incumbent [n]\n",
  "INCUMBENCY": "something that is incumbent [n INCUMBENCIES]\n",
  "INCUMBENT": "imposed on [adj INCUMBENTLY] / a person who holds an ecclesiastical benefice, or any office [n -S]\n",
  "INCUMBENTLY": "INCUMBENT, imposed on [adv]\n",
  "INCUMBENTS": "INCUMBENT, a person who holds an ecclesiastical benefice, or any office [n]\n",
  "INCUMBER": "to impede the motion of, also ENCUMBER [v -ED, -ING, -S]\n",
  "INCUMBERED": "INCUMBER, to impede the motion of, also ENCUMBER [v]\n",
  "INCUMBERING": "INCUMBER, to impede the motion of, also ENCUMBER [v]\n",
  "INCUMBERINGLY": "INCUMBERING, INCUMBER, to impede the motion of, also ENCUMBER [adv]\n",
  "INCUMBERS": "INCUMBER, to impede the motion of, also ENCUMBER [v]\n",
  "INCUMBRANCE": "something that encumbers, also ENCUMBRANCE [n -S]\n",
  "INCUMBRANCER": "a person who holds an encumbrance on property belonging to another, also ENCUMBRANCER [n -S]\n",
  "INCUMBRANCERS": "INCUMBRANCER, a person who holds an encumbrance on property belonging to another, also ENCUMBRANCER [n]\n",
  "INCUMBRANCES": "INCUMBRANCE, something that encumbers, also ENCUMBRANCE [n]\n",
  "INCUNABLE": "a book printed from movable type before 1501, also INCUNABULUM [n -S]\n",
  "INCUNABLES": "INCUNABLE, a book printed from movable type before 1501, also INCUNABULUM [n]\n",
  "INCUNABULA": "INCUNABULUM, (Latin) a book printed from movable type before 1501, also INCUNABLE [n]\n",
  "INCUNABULAR": "relating to incunabula [adj]\n",
  "INCUNABULIST": "a student of incunabula [n -S]\n",
  "INCUNABULISTS": "INCUNABULIST, a student of incunabula [n]\n",
  "INCUNABULUM": "(Latin) a book printed from movable type before 1501, also INCUNABLE [n INCUNABULA]\n",
  "INCUR": "to bring upon oneself [v INCURRED, INCURRING, INCURS]\n",
  "INCURABILITIES": "INCURABILITY, the state of being incurable [n]\n",
  "INCURABILITY": "the state of being incurable [n INCURABILITIES]\n",
  "INCURABLE": "that cannot be cured, also UNCURABLE [adj INCURABLY] / one who cannot be cured [n -S]\n",
  "INCURABLENESS": "the state of being incurable [n -ES]\n",
  "INCURABLENESSES": "INCURABLENESS, the state of being incurable [n]\n",
  "INCURABLES": "INCURABLE, one who cannot be cured [n]\n",
  "INCURABLY": "INCURABLE, that cannot be cured, also UNCURABLE [adv]\n",
  "INCURIOSITIES": "INCURIOSITY, lack of curiosity [n]\n",
  "INCURIOSITY": "lack of curiosity [n INCURIOSITIES]\n",
  "INCURIOUS": "not curious, also UNCURIOUS [adj INCURIOUSLY]\n",
  "INCURIOUSLY": "INCURIOUS, not curious, also UNCURIOUS [adv]\n",
  "INCURIOUSNESS": "the state of being incurious [n -ES]\n",
  "INCURIOUSNESSES": "INCURIOUSNESS, the state of being incurious [n]\n",
  "INCURRABLE": "that can be incurred [adj]\n",
  "INCURRED": "INCUR, to bring upon oneself [v]\n",
  "INCURRENCE": "the act of incurring [n -S]\n",
  "INCURRENCES": "INCURRENCE, the act of incurring [n]\n",
  "INCURRENT": "carrying an inflowing current [adj]\n",
  "INCURRING": "INCUR, to bring upon oneself [v]\n",
  "INCURS": "INCUR, to bring upon oneself [v]\n",
  "INCURSION": "a hostile inroad; the action of leaking or running in [n -S]\n",
  "INCURSIONS": "INCURSION, a hostile inroad; the action of leaking or running in [n]\n",
  "INCURSIVE": "making an incursion, invasive [adj]\n",
  "INCURVATE": "curved inward [adj] / to curve in, also INCURVE [v INCURVATED, INCURVATING, INCURVATES]\n",
  "INCURVATED": "INCURVATE, to curve in, also INCURVE [v]\n",
  "INCURVATES": "INCURVATE, to curve in, also INCURVE [v]\n",
  "INCURVATING": "INCURVATE, to curve in, also INCURVE [v]\n",
  "INCURVATION": "the state of being incurved [n -S]\n",
  "INCURVATIONS": "INCURVATION, the state of being incurved [n]\n",
  "INCURVATURE": "the state of being incurved [n -S]\n",
  "INCURVATURES": "INCURVATURE, the state of being incurved [n]\n",
  "INCURVE": "to curve inward, also INCURVATE [v INCURVED, INCURVING, INCURVES]\n",
  "INCURVED": "INCURVE, to curve inward, also INCURVATE [v]\n",
  "INCURVES": "INCURVE, to curve inward, also INCURVATE [v]\n",
  "INCURVING": "INCURVE, to curve inward, also INCURVATE [v]\n",
  "INCURVITIES": "INCURVITY, a state of being bent or curved [n]\n",
  "INCURVITY": "a state of being bent or curved [n INCURVITIES]\n",
  "INCUS": "(Latin) an anvil-shaped bone in the middle ear [n INCUDES or INCUSES]\n",
  "INCUSE": "to mark by stamping [v INCUSED, INCUSING, INCUSES]\n",
  "INCUSED": "INCUSE, to mark by stamping [v]\n",
  "INCUSES": "INCUSE, to mark by stamping [v]\n",
  "INCUSING": "INCUSE, to mark by stamping [v]\n",
  "INCUT": "in rock climbing, an indent cut into the face of the rock which can be used as a handhold or foothold [n -S]\n",
  "INCUTS": "INCUT, in rock climbing, an indent cut into the face of the rock which can be used as a handhold or foothold [n]\n",
  "INDABA": "(Zulu) a tribal conference in southern Africa [n -S]\n",
  "INDABAS": "INDABA, (Zulu) a tribal conference in southern Africa [n]\n",
  "INDAGATE": "to investigate [v INDAGATED, INDAGATING, INDAGATES]\n",
  "INDAGATED": "INDAGATE, to investigate [v]\n",
  "INDAGATES": "INDAGATE, to investigate [v]\n",
  "INDAGATING": "INDAGATE, to investigate [v]\n",
  "INDAGATION": "the act of searching out [n -S]\n",
  "INDAGATIONS": "INDAGATION, the act of searching out [n]\n",
  "INDAGATIVE": "investigative, also INDAGATORY [adj]\n",
  "INDAGATOR": "a searcher; an investigator [n -S]\n",
  "INDAGATORS": "INDAGATOR, a searcher; an investigator [n]\n",
  "INDAGATORY": "investigative, also INDAGATIVE [adj]\n",
  "INDAMIN": "any unstable organic base whose salts are blue or green dyes, also INDAMINE [n -S]\n",
  "INDAMINE": "any unstable organic base whose salts are blue or green dyes, also INDAMIN [n -S]\n",
  "INDAMINES": "INDAMINE, any unstable organic base whose salts are blue or green dyes, also INDAMIN [n]\n",
  "INDAMINS": "INDAMIN, any unstable organic base whose salts are blue or green dyes, also INDAMINE [n]\n",
  "INDAPAMIDE": "a synthetic thiazide drug used in the treatment of high blood pressure and oedema [n -S]\n",
  "INDAPAMIDES": "INDAPAMIDE, a synthetic thiazide drug used in the treatment of high blood pressure and oedema [n]\n",
  "INDART": "(Shakespeare) to dart in, also ENDART [v -ED, -ING, -S]\n",
  "INDARTED": "INDART, (Shakespeare) to dart in, also ENDART [v]\n",
  "INDARTING": "INDART, (Shakespeare) to dart in, also ENDART [v]\n",
  "INDARTS": "INDART, (Shakespeare) to dart in, also ENDART [v]\n",
  "INDEBTED": "under an obligation, beholden [adj]\n",
  "INDEBTEDNESS": "the state of being indebted [n -ES]\n",
  "INDEBTEDNESSES": "INDEBTEDNESS, the state of being indebted [n]\n",
  "INDECENCIES": "INDECENCY, the quality of being indecent [n]\n",
  "INDECENCY": "the quality of being indecent [n INDECENCIES]\n",
  "INDECENT": "not decent, also UNDECENT [adj INDECENTER, INDECENTEST, INDECENTLY]\n",
  "INDECENTER": "INDECENT, not decent, also UNDECENT [adj]\n",
  "INDECENTEST": "INDECENT, not decent, also UNDECENT [adj]\n",
  "INDECENTLY": "INDECENT, not decent, also UNDECENT [adv]\n",
  "INDECIDUATE": "not deciduate [adj]\n",
  "INDECIDUOUS": "not deciduous [adj]\n",
  "INDECIPHERABLE": "incapable of being deciphered [adj INDECIPHERABLY]\n",
  "INDECIPHERABLY": "INDECIPHERABLE, incapable of being deciphered [adv]\n",
  "INDECISION": "a wavering between two or more possible courses of action [n -S]\n",
  "INDECISIONS": "INDECISION, a wavering between two or more possible courses of action [n]\n",
  "INDECISIVE": "not decisive [adj INDECISIVELY]\n",
  "INDECISIVELY": "INDECISIVE, not decisive [adv]\n",
  "INDECISIVENESS": "the state of being indecisive [n]\n",
  "INDECLINABLE": "having no grammatical inflections [adj INDECLINABLY]\n",
  "INDECLINABLY": "INDECLINABLE, having no grammatical inflections [adv]\n",
  "INDECOMPOSABLE": "not capable of being separated into component parts or elements [adj]\n",
  "INDECOROUS": "not decorous [adj INDECOROUSLY]\n",
  "INDECOROUSLY": "INDECOROUS, not decorous [adv]\n",
  "INDECOROUSNESS": "the state of being indecorous [n]\n",
  "INDECORUM": "(Latin) a lack of decorum [n -S]\n",
  "INDECORUMS": "INDECORUM, (Latin) a lack of decorum [n]\n",
  "INDEED": "in truth [adv]\n",
  "INDEEDY": "indeed [interj]\n",
  "INDEFATIGABLE": "incapable of being fatigued [adj]\n",
  "INDEFATIGABLY": "INDEFATIGABLE, incapable of being fatigued [adv]\n",
  "INDEFEASIBILITY": "the state of being indefeasible [n]\n",
  "INDEFEASIBLE": "not capable of being annulled e.g. of a right [adj INDEFEASIBLY]\n",
  "INDEFEASIBLY": "INDEFEASIBLE, not capable of being annulled e.g. of a right [adv]\n",
  "INDEFECTIBILITY": "the state of being indefectible [n]\n",
  "INDEFECTIBLE": "not subject to failure or decay [adj INDEFECTIBLY]\n",
  "INDEFECTIBLY": "INDEFECTIBLE, not subject to failure or decay [adv]\n",
  "INDEFENSIBILITY": "the state of being indefensible [n]\n",
  "INDEFENSIBLE": "incapable of being maintained as right or valid [adj INDEFENSIBLY]\n",
  "INDEFENSIBLY": "INDEFENSIBLE, incapable of being maintained as right or valid [adv]\n",
  "INDEFINABILITY": "the state of being indefinable [n]\n",
  "INDEFINABLE": "that cannot be defined, also UNDEFINABLE [adj INDEFINABLY] / something that cannot be defined [n -S]\n",
  "INDEFINABLENESS": "INDEFINABLE, that cannot be defined, also UNDEFINABLE [n]\n",
  "INDEFINABLES": "INDEFINABLE, something that cannot be defined [n]\n",
  "INDEFINABLY": "INDEFINABLE, that cannot be defined, also UNDEFINABLE [adv]\n",
  "INDEFINITE": "of unlimited, or apparently unlimited number of extent [adj INDEFINITELY] / an indefinite thing [n -S]\n",
  "INDEFINITELY": "INDEFINITE, of unlimited, or apparently unlimited number of extent [adv]\n",
  "INDEFINITENESS": "the state of being indefinite [n]\n",
  "INDEFINITES": "INDEFINITE, an indefinite thing [n]\n",
  "INDEHISCENCE": "the state of being indehiscent, not splitting open at maturity [n -S]\n",
  "INDEHISCENCES": "INDEHISCENCE, the state of being indehiscent, not splitting open at maturity [n]\n",
  "INDEHISCENT": "not splitting open at maturity [adj]\n",
  "INDELIBILITIES": "INDELIBILITY, the state of being indelible [n]\n",
  "INDELIBILITY": "the state of being indelible [n INDELIBILITIES]\n",
  "INDELIBLE": "that cannot be erased [adj INDELIBLY]\n",
  "INDELIBLENESS": "INDELIBLE, that cannot be erased [n]\n",
  "INDELIBLENESSES": "INDELIBLENESS, INDELIBLE, that cannot be erased [n]\n",
  "INDELIBLY": "INDELIBLE, that cannot be erased [adv]\n",
  "INDELICACIES": "INDELICACY, the quality of being indelicate [n]\n",
  "INDELICACY": "the quality of being indelicate [n INDELICACIES]\n",
  "INDELICATE": "not delicate [adj INDELICATELY]\n",
  "INDELICATELY": "INDELICATE, not delicate [adv]\n",
  "INDELICATENESS": "INDELICATE, not delicate [n]\n",
  "INDEMNIFICATION": "the action of indemnifying [n]\n",
  "INDEMNIFIED": "INDEMNIFY, to secure, to compensate [v]\n",
  "INDEMNIFIER": "one who indemnifies [n -S]\n",
  "INDEMNIFIERS": "INDEMNIFIER, one who indemnifies [n]\n",
  "INDEMNIFIES": "INDEMNIFY, to secure, to compensate [v]\n",
  "INDEMNIFY": "to secure, to compensate [v INDEMNIFIED, INDEMNIFYING, INDEMNIFIES]\n",
  "INDEMNIFYING": "INDEMNIFY, to secure, to compensate [v]\n",
  "INDEMNITIES": "INDEMNITY, security from damage or loss [n]\n",
  "INDEMNITY": "security from damage or loss [n INDEMNITIES]\n",
  "INDEMONSTRABLE": "incapable of being demonstrated [adj INDEMONSTRABLY]\n",
  "INDEMONSTRABLY": "INDEMONSTRABLE, incapable of being demonstrated [adv]\n",
  "INDENE": "a liquid hydrocarbon obtained from coal tar and used in making resins [n -S]\n",
  "INDENES": "INDENE, a liquid hydrocarbon obtained from coal tar and used in making resins [n]\n",
  "INDENT": "to cut or tear irregularly [v -ED, -ING, -S]\n",
  "INDENTATION": "a blank space left at the beginning of a line, also INDENTION [n -S]\n",
  "INDENTATIONS": "INDENTATION, a blank space left at the beginning of a line, also INDENTION [n]\n",
  "INDENTED": "INDENT, to cut or tear irregularly [v]\n",
  "INDENTER": "one that indents, also INDENTOR [n -S]\n",
  "INDENTERS": "INDENTER, one that indents, also INDENTOR [n]\n",
  "INDENTING": "INDENT, to cut or tear irregularly [v]\n",
  "INDENTION": "a blank space left at the beginning of a line, also INDENTATION [n -S]\n",
  "INDENTIONS": "INDENTION, a blank space left at the beginning of a line, also INDENTATION [n]\n",
  "INDENTOR": "one that indents, also INDENTER [n -S]\n",
  "INDENTORS": "INDENTOR, one that indents, also INDENTER [n]\n",
  "INDENTS": "INDENT, to cut or tear irregularly [v]\n",
  "INDENTURE": "to bind by indentures, esp. as an apprentice [v INDENTURED, INDENTURING, INDENTURES]\n",
  "INDENTURED": "INDENTURE, to bind by indentures, esp. as an apprentice [v]\n",
  "INDENTURES": "INDENTURE, to bind by indentures, esp. as an apprentice [v]\n",
  "INDENTURESHIP": "the state of being indentured [n -S]\n",
  "INDENTURESHIPS": "INDENTURESHIP, the state of being indentured [n]\n",
  "INDENTURING": "INDENTURE, to bind by indentures, esp. as an apprentice [v]\n",
  "INDEPENDENCE": "the state of being independent, also INDEPENDENCY [n -S]\n",
  "INDEPENDENCES": "INDEPENDENCE, the state of being independent, also INDEPENDENCY [n]\n",
  "INDEPENDENCIES": "INDEPENDENCY, the state of being independent, also INDEPENDENCE [n]\n",
  "INDEPENDENCY": "the state of being independent, also INDEPENDENCE [n INDEPENDENCIES]\n",
  "INDEPENDENT": "not committed to any group [adj INDEPENDENTLY] / one not committed to any group [n -S]\n",
  "INDEPENDENTLY": "INDEPENDENT, not committed to any group [adv]\n",
  "INDEPENDENTS": "INDEPENDENT, one not committed to any group [n]\n",
  "INDESCRIBABLE": "that cannot be described [adj INDESCRIBABLY] / something that cannot be described [n -S]\n",
  "INDESCRIBABLES": "INDESCRIBABLE, something that cannot be described [n]\n",
  "INDESCRIBABLY": "INDESCRIBABLE, that cannot be described [adv]\n",
  "INDESIGNATE": "without any indication of quantification [adj]\n",
  "INDESTRUCTIBLE": "incapable of being destroyed [adj INDESTRUCTIBLY]\n",
  "INDESTRUCTIBLY": "INDESTRUCTIBLE, incapable of being destroyed [adv]\n",
  "INDETECTABLE": "that cannot be detected, also INDETECTIBLE [adj]\n",
  "INDETECTIBLE": "that cannot be detected, also INDETECTABLE [adj]\n",
  "INDETERMINABLE": "incapable of being definitely decided or settled [adj INDETERMINABLY]\n",
  "INDETERMINABLY": "INDETERMINABLE, incapable of being definitely decided or settled [adv]\n",
  "INDETERMINACIES": "INDETERMINACY, the state of being indeterminate [n]\n",
  "INDETERMINACY": "the state of being indeterminate [n INDETERMINACIES]\n",
  "INDETERMINATE": "not determined [adj INDETERMINATELY]\n",
  "INDETERMINATELY": "INDETERMINATE, not determined [adv]\n",
  "INDETERMINATION": "the state of being indeterminate [n]\n",
  "INDETERMINED": "not determined [adj]\n",
  "INDETERMINISM": "the theory that denies determinism [n -S]\n",
  "INDETERMINISMS": "INDETERMINISM, the theory that denies determinism [n]\n",
  "INDETERMINIST": "a believer in indeterminism [n -S]\n",
  "INDETERMINISTIC": "relating to indeterminism [adj]\n",
  "INDETERMINISTS": "INDETERMINIST, a believer in indeterminism [n]\n",
  "INDEVOUT": "not devout [adj]\n",
  "INDEW": "(Spenser) to provide with, also ENDUE, INDUE [v -ED, -ING, -S]\n",
  "INDEWED": "INDEW, (Spenser) to provide with, also ENDUE, INDUE [v]\n",
  "INDEWING": "INDEW, (Spenser) to provide with, also ENDUE, INDUE [v]\n",
  "INDEWS": "INDEW, (Spenser) to provide with, also ENDUE, INDUE [v]\n",
  "INDEX": "to provide with an index [v -ED, -ING, -ES] / a type of reference guide in a book [n INDEXES or INDICES]\n",
  "INDEXABLE": "that can be indexed [adj]\n",
  "INDEXAL": "of or like an index [adj]\n",
  "INDEXATION": "a system by which wages, rates of interest etc. are directly linked to changes in the cost of living index [n -S]\n",
  "INDEXATIONS": "INDEXATION, a system by which wages, rates of interest etc. are directly linked to changes in the cost of living index [n]\n",
  "INDEXED": "INDEX, to provide with an index [v]\n",
  "INDEXER": "one who indexes [n -S]\n",
  "INDEXERS": "INDEXER, one who indexes [n]\n",
  "INDEXES": "INDEX, to provide with an index [v]\n",
  "INDEXICAL": "of, pertaining to, or like, an index [adj] / something with the form of an index [n -S]\n",
  "INDEXICALS": "INDEXICAL, something with the form of an index [n]\n",
  "INDEXING": "the linking of wages and cost-of-living levels [n -S]\n",
  "INDEXINGS": "INDEXING, the linking of wages and cost-of-living levels [n]\n",
  "INDEXLESS": "without an index [adj]\n",
  "INDEXTERITIES": "INDEXTERITY, lack of dexterity [n]\n",
  "INDEXTERITY": "lack of dexterity [n INDEXTERITIES]\n",
  "INDEXTROUS": "not possessing dexterity [adj]\n",
  "INDIA": "(in international radio communication) a code word for the letter i [n -S]\n",
  "INDIAS": "INDIA, (in international radio communication) a code word for the letter i [n]\n",
  "INDICAN": "a glucoside that occurs in the indigo plant and is a source of the dye indigo [n -S]\n",
  "INDICANS": "INDICAN, a glucoside that occurs in the indigo plant and is a source of the dye indigo [n]\n",
  "INDICANT": "something that indicates [n -S]\n",
  "INDICANTS": "INDICANT, something that indicates [n]\n",
  "INDICATABLE": "that can be indicated [adj]\n",
  "INDICATE": "to point out [v INDICATED, INDICATING, INDICATES]\n",
  "INDICATED": "INDICATE, to point out [v]\n",
  "INDICATES": "INDICATE, to point out [v]\n",
  "INDICATING": "INDICATE, to point out [v]\n",
  "INDICATION": "something that serves to indicate [n -S]\n",
  "INDICATIONAL": "of the nature of an indication [adj]\n",
  "INDICATIONS": "INDICATION, something that serves to indicate [n]\n",
  "INDICATIVE": "serving to indicate [adj INDICATIVELY] / the indicative mood of a language [n -S]\n",
  "INDICATIVELY": "INDICATIVE, serving to indicate [adv]\n",
  "INDICATIVES": "INDICATIVE, the indicative mood of a language [n]\n",
  "INDICATOR": "someone who or that which indicates [n -S]\n",
  "INDICATORS": "INDICATOR, someone who or that which indicates [n]\n",
  "INDICATORY": "serving to indicate [adj]\n",
  "INDICES": "INDEX, a type of reference guide in a book [n]\n",
  "INDICIA": "a distinctive mark, also INDICIUM [n -S]\n",
  "INDICIAL": "relating to an indicium [adj]\n",
  "INDICIAS": "INDICIA, a distinctive mark, also INDICIUM [n]\n",
  "INDICIUM": "(Latin) a distinctive mark, also INDICIA [n -S]\n",
  "INDICIUMS": "INDICIUM, (Latin) a distinctive mark, also INDICIA [n]\n",
  "INDICOLITE": "a variety of tourmaline of an indigo-blue color, also INDIGOLITE [n -S]\n",
  "INDICOLITES": "INDICOLITE, a variety of tourmaline of an indigo-blue color, also INDIGOLITE [n]\n",
  "INDICT": "to charge with a crime [v -ED, -ING, -S]\n",
  "INDICTABLE": "that can be indicted [adj INDICTABLY]\n",
  "INDICTABLY": "INDICTABLE, that can be indicted [adv]\n",
  "INDICTED": "INDICT, to charge with a crime [v]\n",
  "INDICTEE": "one who is indicted [n -S]\n",
  "INDICTEES": "INDICTEE, one who is indicted [n]\n",
  "INDICTER": "one who indicts, also INDICTOR [n -S]\n",
  "INDICTERS": "INDICTER, one who indicts, also INDICTOR [n]\n",
  "INDICTING": "INDICT, to charge with a crime [v]\n",
  "INDICTION": "a declaration; a proclamation; a public notice or appointment [n -S]\n",
  "INDICTIONAL": "relating to indiction [adj]\n",
  "INDICTIONS": "INDICTION, a declaration; a proclamation; a public notice or appointment [n]\n",
  "INDICTMENT": "the action or the legal process of indicting [n -S]\n",
  "INDICTMENTS": "INDICTMENT, the action or the legal process of indicting [n]\n",
  "INDICTOR": "one who indicts, also INDICTER [n -S]\n",
  "INDICTORS": "INDICTOR, one who indicts, also INDICTER [n]\n",
  "INDICTS": "INDICT, to charge with a crime [v]\n",
  "INDIE": "(colloquial) an independent record company; a type of music produced by such [n -S]\n",
  "INDIES": "INDIE, (colloquial) an independent record company; a type of music produced by such [n]\n",
  "INDIFFERENCE": "the state of being indifferent, also INDIFFERENCY [n -S]\n",
  "INDIFFERENCES": "INDIFFERENCE, the state of being indifferent, also INDIFFERENCY [n]\n",
  "INDIFFERENCIES": "INDIFFERENCY, the state of being indifferent, also INDIFFERENCE [n]\n",
  "INDIFFERENCY": "the state of being indifferent, also INDIFFERENCE [n INDIFFERENCIES]\n",
  "INDIFFERENT": "marked by impartiality [adj INDIFFERENTLY] / a person who is indifferent [n -S]\n",
  "INDIFFERENTISM": "the belief that all religions are equally valid [n -S]\n",
  "INDIFFERENTISMS": "INDIFFERENTISM, the belief that all religions are equally valid [n]\n",
  "INDIFFERENTIST": "an exponent of indifferentism [n -S]\n",
  "INDIFFERENTISTS": "INDIFFERENTIST, an exponent of indifferentism [n]\n",
  "INDIFFERENTLY": "INDIFFERENT, marked by impartiality [adv]\n",
  "INDIFFERENTS": "INDIFFERENT, a person who is indifferent [n]\n",
  "INDIGEN": "one born in a country; an aboriginal animal or plant, also INDIGENE [n -S]\n",
  "INDIGENCE": "poverty; the state of being needy, also INDIGENCY [n -S]\n",
  "INDIGENCES": "INDIGENCE, poverty; the state of being needy, also INDIGENCY [n]\n",
  "INDIGENCIES": "INDIGENCY, poverty; the state of being needy, also INDIGENCE [n]\n",
  "INDIGENCY": "poverty; the state of being needy, also INDIGENCE [n INDIGENCIES]\n",
  "INDIGENE": "one born in a country; an aboriginal animal or plant, also INDIGEN [n -S]\n",
  "INDIGENES": "INDIGENE, one born in a country; an aboriginal animal or plant, also INDIGEN [n]\n",
  "INDIGENISATION": "the act of indigenising, also INDIGENIZATION [n -S]\n",
  "INDIGENISATIONS": "INDIGENISATION, the act of indigenising, also INDIGENIZATION [n]\n",
  "INDIGENISE": "to render indigenous, also INDIGENIZE [v INDIGENISED, INDIGENISING, INDIGENISES]\n",
  "INDIGENISED": "INDIGENISE, to render indigenous, also INDIGENIZE [v]\n",
  "INDIGENISES": "INDIGENISE, to render indigenous, also INDIGENIZE [v]\n",
  "INDIGENISING": "INDIGENISE, to render indigenous, also INDIGENIZE [v]\n",
  "INDIGENITIES": "INDIGENITY, indigenousness [n]\n",
  "INDIGENITY": "indigenousness [n INDIGENITIES]\n",
  "INDIGENIZATION": "the act of indigenizing, also INDIGENISATION [n -S]\n",
  "INDIGENIZATIONS": "INDIGENIZATION, the act of indigenizing, also INDIGENISATION [n]\n",
  "INDIGENIZE": "to render indigenous, also INDIGENISE [v INDIGENIZED, INDIGENIZING, INDIGENIZES]\n",
  "INDIGENIZED": "INDIGENIZE, to render indigenous, also INDIGENISE [v]\n",
  "INDIGENIZES": "INDIGENIZE, to render indigenous, also INDIGENISE [v]\n",
  "INDIGENIZING": "INDIGENIZE, to render indigenous, also INDIGENISE [v]\n",
  "INDIGENOUS": "occurring naturally in a particular region or environment [adj INDIGENOUSLY]\n",
  "INDIGENOUSLY": "INDIGENOUS, occurring naturally in a particular region or environment [adv]\n",
  "INDIGENOUSNESS": "INDIGENOUS, occurring naturally in a particular region or environment [n]\n",
  "INDIGENS": "INDIGEN, one born in a country; an aboriginal animal or plant, also INDIGENE [n]\n",
  "INDIGENT": "needy [adj INDIGENTLY] / an indigent or poor person [n -S]\n",
  "INDIGENTLY": "INDIGENT, needy [adv]\n",
  "INDIGENTS": "INDIGENT, an indigent or poor person [n]\n",
  "INDIGEST": "to suffer indigestion [v -ED, -ING, -S]\n",
  "INDIGESTED": "not digested [adj]\n",
  "INDIGESTIBILITY": "the state of being indigestible [n]\n",
  "INDIGESTIBLE": "not digestible, also UNDIGESTIBLE [adj INDIGESTIBLY] / something not digestible [n -S]\n",
  "INDIGESTIBLES": "INDIGESTIBLE, something not digestible [n]\n",
  "INDIGESTIBLY": "INDIGESTIBLE, not digestible, also UNDIGESTIBLE [adv]\n",
  "INDIGESTING": "INDIGEST, to suffer indigestion [v]\n",
  "INDIGESTION": "inability to digest or difficulty in digesting something [n -S]\n",
  "INDIGESTIONS": "INDIGESTION, inability to digest or difficulty in digesting something [n]\n",
  "INDIGESTIVE": "dyspeptic [adj]\n",
  "INDIGESTS": "INDIGEST, to suffer indigestion [v]\n",
  "INDIGN": "disgraceful, unworthy [adj INDIGNLY]\n",
  "INDIGNANCE": "(archaic) indignation, contempt, also INDIGNATION [n -S]\n",
  "INDIGNANCES": "INDIGNANCE, (archaic) indignation, contempt, also INDIGNATION [n]\n",
  "INDIGNANT": "feeling or showing justifiable anger [adj INDIGNANTLY]\n",
  "INDIGNANTLY": "INDIGNANT, feeling or showing justifiable anger [adv]\n",
  "INDIGNATION": "anger aroused by something unjust, unworthy, or mean, also INDIGNANCE [n -S]\n",
  "INDIGNATIONS": "INDIGNATION, anger aroused by something unjust, unworthy, or mean, also INDIGNANCE [n]\n",
  "INDIGNIFIED": "INDIGNIFY, (archaic) to treat insultingly [v]\n",
  "INDIGNIFIES": "INDIGNIFY, (archaic) to treat insultingly [v]\n",
  "INDIGNIFY": "(archaic) to treat insultingly [v INDIGNIFIED, INDIGNIFYING, INDIGNIFIES]\n",
  "INDIGNIFYING": "INDIGNIFY, (archaic) to treat insultingly [v]\n",
  "INDIGNITIES": "INDIGNITY, disgrace, humiliation [n]\n",
  "INDIGNITY": "disgrace, humiliation [n INDIGNITIES]\n",
  "INDIGNLY": "INDIGN, disgraceful, unworthy [adv]\n",
  "INDIGO": "a blue dye [n -S or -ES]\n",
  "INDIGOES": "INDIGO, a blue dye [n]\n",
  "INDIGOID": "a blue dye [n -S]\n",
  "INDIGOIDS": "INDIGOID, a blue dye [n]\n",
  "INDIGOLITE": "a variety of tourmaline of an indigo-blue color, also INDICOLITE [n -S]\n",
  "INDIGOLITES": "INDIGOLITE, a variety of tourmaline of an indigo-blue color, also INDICOLITE [n]\n",
  "INDIGOS": "INDIGO, a blue dye [n]\n",
  "INDIGOTIC": "relating to indigo [adj]\n",
  "INDIGOTIN": "the blue colouring matter of indigo, obtained by hydrolysis from indican [n -S]\n",
  "INDIGOTINS": "INDIGOTIN, the blue colouring matter of indigo, obtained by hydrolysis from indican [n]\n",
  "INDINAVIR": "a drug used to treat AIDS [n -S]\n",
  "INDINAVIRS": "INDINAVIR, a drug used to treat AIDS [n]\n",
  "INDIRECT": "not straightforward [adj INDIRECTLY]\n",
  "INDIRECTION": "(Shakespeare) dishonest practice [n -S]\n",
  "INDIRECTIONS": "INDIRECTION, (Shakespeare) dishonest practice [n]\n",
  "INDIRECTLY": "INDIRECT, not straightforward [adv]\n",
  "INDIRECTNESS": "the state of being indirect [n -ES]\n",
  "INDIRECTNESSES": "INDIRECTNESS, the state of being indirect [n]\n",
  "INDIRUBIN": "a red crystalline substance resembling indigotin but with oxidized indoxyl rather than indoxyl nuclei [n -S]\n",
  "INDIRUBINS": "INDIRUBIN, a red crystalline substance resembling indigotin but with oxidized indoxyl rather than indoxyl nuclei [n]\n",
  "INDISCERNIBLE": "incapable of being discerned [adj INDISCERNIBLY]\n",
  "INDISCERNIBLY": "INDISCERNIBLE, incapable of being discerned [adv]\n",
  "INDISCERPTIBLE": "not able to be separated [adj]\n",
  "INDISCIPLINABLE": "not subject to or capable of being disciplined [adj]\n",
  "INDISCIPLINE": "lack of discipline, also UNDISCIPLINE [n -S]\n",
  "INDISCIPLINED": "not disciplined [adj]\n",
  "INDISCIPLINES": "INDISCIPLINE, lack of discipline, also UNDISCIPLINE [n]\n",
  "INDISCOVERABLE": "not discoverable [adj]\n",
  "INDISCREET": "not discreet [adj INDISCREETER, INDISCREETEST; INDISCREETLY]\n",
  "INDISCREETER": "INDISCREET, not discreet [adj]\n",
  "INDISCREETEST": "INDISCREET, not discreet [adj]\n",
  "INDISCREETLY": "INDISCREET, not discreet [adv]\n",
  "INDISCREETNESS": "INDISCREET, not discreet [n]\n",
  "INDISCRETE": "not discrete [adj INDISCRETELY]\n",
  "INDISCRETELY": "INDISCRETE, not discrete [adv]\n",
  "INDISCRETENESS": "INDISCRETE, not discrete [n]\n",
  "INDISCRETION": "lack of discretion [n -S]\n",
  "INDISCRETIONARY": "not discretionary [adj]\n",
  "INDISCRETIONS": "INDISCRETION, lack of discretion [n]\n",
  "INDISCRIMINATE": "not marked by careful distinction [adj]\n",
  "INDISPENSABLE": "that cannot be dispensed [adj INDISPENSABLY] / something that cannot be dispensed with [n -S]\n",
  "INDISPENSABLES": "INDISPENSABLE, something that cannot be dispensed with [n]\n",
  "INDISPENSABLY": "INDISPENSABLE, that cannot be dispensed [adv]\n",
  "INDISPOSE": "to render indisposed [v INDISPOSED, INDISPOSING, INDISPOSES]\n",
  "INDISPOSED": "INDISPOSE, to render indisposed [v]\n",
  "INDISPOSEDNESS": "the state of being indisposed [n]\n",
  "INDISPOSES": "INDISPOSE, to render indisposed [v]\n",
  "INDISPOSING": "INDISPOSE, to render indisposed [v]\n",
  "INDISPOSITION": "the condition of being indisposed [n -S]\n",
  "INDISPOSITIONS": "INDISPOSITION, the condition of being indisposed [n]\n",
  "INDISPUTABILITY": "the quality of being indisputable [n]\n",
  "INDISPUTABLE": "not disputable [adj INDISPUTABLY]\n",
  "INDISPUTABLY": "INDISPUTABLE, not disputable [adv]\n",
  "INDISSOCIABLE": "not dissociated [adj INDISSOCIABLY]\n",
  "INDISSOCIABLY": "INDISSOCIABLE, not dissociated [adv]\n",
  "INDISSOLUBILITY": "the state of being indissoluble [n]\n",
  "INDISSOLUBLE": "not dissoluble [adj]\n",
  "INDISSOLUBLY": "INDISSOLUBLE, not dissoluble [adv]\n",
  "INDISSOLVABLE": "(archaic) indissoluble [adj]\n",
  "INDISSUADABLE": "not able to be dissuaded [adj INDISSUADABLY]\n",
  "INDISSUADABLY": "INDISSUADABLE, not able to be dissuaded [adv]\n",
  "INDISTINCT": "not distinct [adj INDISTINCTLY]\n",
  "INDISTINCTION": "lack of distinction [n -S]\n",
  "INDISTINCTIONS": "INDISTINCTION, lack of distinction [n]\n",
  "INDISTINCTIVE": "lacking distinctive qualities [adj INDISTINCTIVELY]\n",
  "INDISTINCTIVELY": "INDISTINCTIVE, lacking distinctive qualities [adv]\n",
  "INDISTINCTLY": "INDISTINCT, not distinct [adv]\n",
  "INDISTINCTNESS": "the state of being indistinct [n]\n",
  "INDISTRIBUTABLE": "not able to be distributed [adj]\n",
  "INDITE": "to write or compose, also DITE, ENDITE [v INDITED, INDITING, INDITES]\n",
  "INDITED": "INDITE, to write or compose, also DITE, ENDITE [v]\n",
  "INDITEMENT": "composition, the act of inditing [n -S]\n",
  "INDITEMENTS": "INDITEMENT, composition, the act of inditing [n]\n",
  "INDITER": "one who indites [n -S]\n",
  "INDITERS": "INDITER, one who indites [n]\n",
  "INDITES": "INDITE, to write or compose, also DITE, ENDITE [v]\n",
  "INDITING": "INDITE, to write or compose, also DITE, ENDITE [v]\n",
  "INDIUM": "a metallic element [n -S]\n",
  "INDIUMS": "INDIUM, a metallic element [n]\n",
  "INDIVERTIBLE": "that cannot be diverted [adj INDIVERTIBLY]\n",
  "INDIVERTIBLY": "INDIVERTIBLE, that cannot be diverted [adv]\n",
  "INDIVIDABLE": "(archaic) indivisible [adj]\n",
  "INDIVIDUA": "INDIVIDUUM, (Latin) an indivisible entity; an individual person [n]\n",
  "INDIVIDUAL": "single [adj INDIVIDUALLY] / a single human being as contrasted with a social group or institution [n -S]\n",
  "INDIVIDUALISE": "to make individual, also INDIVIDUALIZE [v INDIVIDUALISED, INDIVIDUALISING, INDIVIDUALISES]\n",
  "INDIVIDUALISED": "INDIVIDUALISE, to make individual, also INDIVIDUALIZE [v]\n",
  "INDIVIDUALISER": "one who individualises, also INDIVIDUALIZER [n -S]\n",
  "INDIVIDUALISERS": "INDIVIDUALISER, one who individualises, also INDIVIDUALIZER [n]\n",
  "INDIVIDUALISES": "INDIVIDUALISE, to make individual, also INDIVIDUALIZE [v]\n",
  "INDIVIDUALISING": "INDIVIDUALISE, to make individual, also INDIVIDUALIZE [v]\n",
  "INDIVIDUALISM": "belief that individual interests and rights are paramount [n -S]\n",
  "INDIVIDUALISMS": "INDIVIDUALISM, belief that individual interests and rights are paramount [n]\n",
  "INDIVIDUALIST": "one that pursues a markedly independent course in thought or action [n -S]\n",
  "INDIVIDUALISTIC": "of or like an individualist [adj]\n",
  "INDIVIDUALISTS": "INDIVIDUALIST, one that pursues a markedly independent course in thought or action [n]\n",
  "INDIVIDUALITIES": "INDIVIDUALITY, total character peculiar to and distinguishing an individual from others [n]\n",
  "INDIVIDUALITY": "total character peculiar to and distinguishing an individual from others [n INDIVIDUALITIES]\n",
  "INDIVIDUALIZE": "to make individual in character, also INDIVIDUALISE [v INDIVIDUALIZED, INDIVIDUALIZING, INDIVIDUALIZES]\n",
  "INDIVIDUALIZED": "INDIVIDUALIZE, to make individual in character, also INDIVIDUALISE [v]\n",
  "INDIVIDUALIZER": "one who individualises, also INDIVIDUALISER [n -S]\n",
  "INDIVIDUALIZERS": "INDIVIDUALIZER, one who individualises, also INDIVIDUALISER [n]\n",
  "INDIVIDUALIZES": "INDIVIDUALIZE, to make individual in character, also INDIVIDUALISE [v]\n",
  "INDIVIDUALIZING": "INDIVIDUALIZE, to make individual in character, also INDIVIDUALISE [v]\n",
  "INDIVIDUALLY": "INDIVIDUAL, single [adv]\n",
  "INDIVIDUALS": "INDIVIDUAL, a single human being as contrasted with a social group or institution [n]\n",
  "INDIVIDUATE": "to give individuality to [v INDIVIDUATED, INDIVIDUATING, INDIVIDUATES]\n",
  "INDIVIDUATED": "INDIVIDUATE, to give individuality to [v]\n",
  "INDIVIDUATES": "INDIVIDUATE, to give individuality to [v]\n",
  "INDIVIDUATING": "INDIVIDUATE, to give individuality to [v]\n",
  "INDIVIDUATION": "the development of the individual from the universal [n -S]\n",
  "INDIVIDUATIONS": "INDIVIDUATION, the development of the individual from the universal [n]\n",
  "INDIVIDUATOR": "one who individuates [n -S]\n",
  "INDIVIDUATORS": "INDIVIDUATOR, one who individuates [n]\n",
  "INDIVIDUUM": "(Latin) an indivisible entity; an individual person [n INDIVIDUA]\n",
  "INDIVISIBILITY": "the state of being indivisible [n]\n",
  "INDIVISIBLE": "that cannot be divided [adj INDIVISIBLY] / an indefinitely small quantity [n -S]\n",
  "INDIVISIBLENESS": "the state of being indivisible [n]\n",
  "INDIVISIBLES": "INDIVISIBLE, an indefinitely small quantity [n]\n",
  "INDIVISIBLY": "INDIVISIBLE, that cannot be divided [adv]\n",
  "INDOCIBLE": "incapable of being taught, or not easily instructed [adj]\n",
  "INDOCILE": "not docile, also UNDOCILE [adj]\n",
  "INDOCILITIES": "INDOCILITY, the quality of being indocile [n]\n",
  "INDOCILITY": "the quality of being indocile [n INDOCILITIES]\n",
  "INDOCTRINATE": "to instruct esp. in fundamentals or rudiments [v INDOCTRINATED, INDOCTRINATING, INDOCTRINATES]\n",
  "INDOCTRINATED": "INDOCTRINATE, to instruct esp. in fundamentals or rudiments [v]\n",
  "INDOCTRINATES": "INDOCTRINATE, to instruct esp. in fundamentals or rudiments [v]\n",
  "INDOCTRINATING": "INDOCTRINATE, to instruct esp. in fundamentals or rudiments [v]\n",
  "INDOCTRINATION": "the act of indoctrinating [n -S]\n",
  "INDOCTRINATIONS": "INDOCTRINATION, the act of indoctrinating [n]\n",
  "INDOCTRINATOR": "one who indoctrinates [n -S]\n",
  "INDOCTRINATORS": "INDOCTRINATOR, one who indoctrinates [n]\n",
  "INDOL": "a crystalline chemical compound, forming the basis of the indigo molecule, also INDOLE [n -S]\n",
  "INDOLE": "a chemical compound, also INDOL [n -S]\n",
  "INDOLEACETIC": "as in indoleacetic acid, a naturally-occurring plant growth hormone [adj]\n",
  "INDOLEBUTYRIC": "as in indolebutyric acid, a synthetic plant growth regulator [adj]\n",
  "INDOLENCE": "laziness, also INDOLENCY [n -S]\n",
  "INDOLENCES": "INDOLENCE, laziness, also INDOLENCY [n]\n",
  "INDOLENCIES": "INDOLENCY, laziness, also INDOLENCE [n]\n",
  "INDOLENCY": "laziness, also INDOLENCE [n INDOLENCIES]\n",
  "INDOLENT": "lazy, lethargic [adj INDOLENTLY]\n",
  "INDOLENTLY": "INDOLENT, lazy, lethargic [adv]\n",
  "INDOLES": "INDOLE, a chemical compound, also INDOL [n]\n",
  "INDOLS": "INDOL, a crystalline chemical compound, forming the basis of the indigo molecule, also INDOLE [n]\n",
  "INDOMETACIN": "a nonsteroidal drug used esp. to treat painful inflammatory conditions, also INDOMETHACIN [n -S]\n",
  "INDOMETACINS": "INDOMETACIN, a nonsteroidal drug used esp. to treat painful inflammatory conditions, also INDOMETHACIN [n]\n",
  "INDOMETHACIN": "a nonsteroidal drug used esp. to treat painful inflammatory conditions, also INDOMETACIN [n -S]\n",
  "INDOMETHACINS": "INDOMETHACIN, a nonsteroidal drug used esp. to treat painful inflammatory conditions, also INDOMETACIN [n]\n",
  "INDOMITABILITY": "the state of being indomitable [n]\n",
  "INDOMITABLE": "not to be overcome, unconquerable [adj INDOMITABLY]\n",
  "INDOMITABLENESS": "INDOMITABLE, not to be overcome, unconquerable [n]\n",
  "INDOMITABLY": "INDOMITABLE, not to be overcome, unconquerable [adv]\n",
  "INDOOR": "pertaining to the interior of a building [adj]\n",
  "INDOORS": "situated inside [adv]\n",
  "INDOPHENOL": "any one of a series of artificial blue dyestuffs [n -S]\n",
  "INDOPHENOLS": "INDOPHENOL, any one of a series of artificial blue dyestuffs [n]\n",
  "INDORSABLE": "capable of being indorsed [adj]\n",
  "INDORSATION": "approval or support, also ENDORSATION [n -S]\n",
  "INDORSATIONS": "INDORSATION, approval or support, also ENDORSATION [n]\n",
  "INDORSE": "to declare one's approval, also ENDORSE [v INDORSED, INDORSING, INDORSES]\n",
  "INDORSED": "INDORSE, to declare one's approval, also ENDORSE [v]\n",
  "INDORSEE": "a person to whom a bill is assigned, also ENDORSEE [n -S]\n",
  "INDORSEES": "INDORSEE, a person to whom a bill is assigned, also ENDORSEE [n]\n",
  "INDORSEMENT": "the act of indorsing [n -S]\n",
  "INDORSEMENTS": "INDORSEMENT, the act of indorsing [n]\n",
  "INDORSER": "one that endorses, also ENDORSER, ENDORSOR, INDORSOR [n -S]\n",
  "INDORSERS": "INDORSER, one that endorses, also ENDORSER, ENDORSOR, INDORSOR [n]\n",
  "INDORSES": "INDORSE, to declare one's approval, also ENDORSE [v]\n",
  "INDORSING": "INDORSE, to declare one's approval, also ENDORSE [v]\n",
  "INDORSOR": "one that endorses, also ENDORSER, ENDORSOR, INDORSER [n -S]\n",
  "INDORSORS": "INDORSOR, one that endorses, also ENDORSER, ENDORSOR, INDORSER [n]\n",
  "INDOW": "to bequeath, also ENDOW [v -ED, -ING, -S]\n",
  "INDOWED": "INDOW, to bequeath, also ENDOW [v]\n",
  "INDOWING": "INDOW, to bequeath, also ENDOW [v]\n",
  "INDOWS": "INDOW, to bequeath, also ENDOW [v]\n",
  "INDOXYL": "a nitrogenous substance obtained as an oily liquid [n -S]\n",
  "INDOXYLS": "INDOXYL, a nitrogenous substance obtained as an oily liquid [n]\n",
  "INDRAFT": "a drawing in; an inward flow of air, also INDRAUGHT [n -S]\n",
  "INDRAFTS": "INDRAFT, a drawing in; an inward flow of air, also INDRAUGHT [n]\n",
  "INDRAUGHT": "a drawing in; an inward flow of air, also INDRAFT [n -S]\n",
  "INDRAUGHTS": "INDRAUGHT, a drawing in; an inward flow of air, also INDRAFT [n]\n",
  "INDRAWN": "drawn in [adj]\n",
  "INDRENCH": "to submerge in water [v -ED, -ING, -ES]\n",
  "INDRENCHED": "INDRENCH, to submerge in water [v]\n",
  "INDRENCHES": "INDRENCH, to submerge in water [v]\n",
  "INDRENCHING": "INDRENCH, to submerge in water [v]\n",
  "INDRI": "(Malagasy) a short-tailed lemur of Madagascar, also INDRIS [n -S]\n",
  "INDRIS": "(Malagasy) a short-tailed lemur of Madagascar, also INDRI [n -ES]\n",
  "INDRISES": "INDRIS, (Malagasy) a short-tailed lemur of Madagascar, also INDRI [n]\n",
  "INDUBIOUS": "(archaic) not dubious [adj]\n",
  "INDUBITABILITY": "the quality of being beyond question or dispute or doubt [n]\n",
  "INDUBITABLE": "that cannot be doubted [adj INDUBITABLY]\n",
  "INDUBITABLENESS": "the state of being indubitable [n]\n",
  "INDUBITABLY": "INDUBITABLE, that cannot be doubted [adv]\n",
  "INDUCE": "to influence into doing something [v INDUCED, INDUCING, INDUCES]\n",
  "INDUCED": "INDUCE, to influence into doing something [v]\n",
  "INDUCEMENT": "the act of inducing [n -S]\n",
  "INDUCEMENTS": "INDUCEMENT, the act of inducing [n]\n",
  "INDUCER": "one who, or that which, induces [n -S]\n",
  "INDUCERS": "INDUCER, one who, or that which, induces [n]\n",
  "INDUCES": "INDUCE, to influence into doing something [v]\n",
  "INDUCIAE": "a Scottish legal time limit for a defendant [n INDUCIAE]\n",
  "INDUCIBILITIES": "INDUCIBILITY, the state of being inducible [n]\n",
  "INDUCIBILITY": "the state of being inducible [n INDUCIBILITIES]\n",
  "INDUCIBLE": "capable of being induced [adj]\n",
  "INDUCING": "INDUCE, to influence into doing something [v]\n",
  "INDUCT": "to bring into military service [v -ED, -ING, -S]\n",
  "INDUCTANCE": "the property of inducing an electromotive force by variation of current in a circuit [n -S]\n",
  "INDUCTANCES": "INDUCTANCE, the property of inducing an electromotive force by variation of current in a circuit [n]\n",
  "INDUCTED": "INDUCT, to bring into military service [v]\n",
  "INDUCTEE": "one who is inducted [n -S]\n",
  "INDUCTEES": "INDUCTEE, one who is inducted [n]\n",
  "INDUCTILE": "not ductile [adj]\n",
  "INDUCTILITIES": "INDUCTILITY, the state of being inductile [n]\n",
  "INDUCTILITY": "the state of being inductile [n INDUCTILITIES]\n",
  "INDUCTING": "INDUCT, to bring into military service [v]\n",
  "INDUCTION": "the act of inducing [n -S]\n",
  "INDUCTIONAL": "relating to induction [adj]\n",
  "INDUCTIONS": "INDUCTION, the act of inducing [n]\n",
  "INDUCTIVE": "relating to induction [adj INDUCTIVELY]\n",
  "INDUCTIVELY": "INDUCTIVE, relating to induction [adv]\n",
  "INDUCTIVENESS": "INDUCTIVE, relating to induction [n]\n",
  "INDUCTIVENESSES": "INDUCTIVENESS, INDUCTIVE, relating to induction [n]\n",
  "INDUCTIVITIES": "INDUCTIVITY, the state of being inductive [n]\n",
  "INDUCTIVITY": "the state of being inductive [n INDUCTIVITIES]\n",
  "INDUCTOR": "a part of an electrical apparatus which acts inductively on another, esp. to produce an electromotive force or a current [n -S]\n",
  "INDUCTORS": "INDUCTOR, a part of an electrical apparatus which acts inductively on another, esp. to produce an electromotive force or a current [n]\n",
  "INDUCTS": "INDUCT, to bring into military service [v]\n",
  "INDUE": "to provide with, also ENDUE, INDEW [v INDUED, INDUING, INDUES]\n",
  "INDUED": "INDUE, to provide with, also ENDUE, INDEW [v]\n",
  "INDUES": "INDUE, to provide with, also ENDUE, INDEW [v]\n",
  "INDUING": "INDUE, to provide with, also ENDUE, INDEW [v]\n",
  "INDULGE": "to yield to the desire of [v INDULGED, INDULGING, INDULGES]\n",
  "INDULGED": "INDULGE, to yield to the desire of [v]\n",
  "INDULGENCE": "favourable treatment; a former Catholic pardon granted for remission of punishment for sins, also INDULGENCY [n -S] / to grant an indulgence [v INDULGENCED, INDULGENCING, INDULGENCES]\n",
  "INDULGENCED": "INDULGENCE, to grant an indulgence [v]\n",
  "INDULGENCES": "INDULGENCE, to grant an indulgence [v]\n",
  "INDULGENCIES": "INDULGENCY, indulgence, also INDULGENCE [n]\n",
  "INDULGENCING": "INDULGENCE, to grant an indulgence [v]\n",
  "INDULGENCY": "indulgence, also INDULGENCE [n INDULGENCIES]\n",
  "INDULGENT": "tending to indulge [adj]\n",
  "INDULGENTLY": "INDULGENT, tending to indulge [adv]\n",
  "INDULGER": "one who indulges [n -S]\n",
  "INDULGERS": "INDULGER, one who indulges [n]\n",
  "INDULGES": "INDULGE, to yield to the desire of [v]\n",
  "INDULGING": "INDULGE, to yield to the desire of [v]\n",
  "INDULGINGLY": "INDULGING, INDULGE, to yield to the desire of [adv]\n",
  "INDULIN": "a blue dye, also INDULINE [n -S]\n",
  "INDULINE": "a blue dye, also INDULIN [n -S]\n",
  "INDULINES": "INDULINE, a blue dye, also INDULIN [n]\n",
  "INDULINS": "INDULIN, a blue dye, also INDULINE [n]\n",
  "INDULT": "a privilege granted by the pope [n -S]\n",
  "INDULTS": "INDULT, a privilege granted by the pope [n]\n",
  "INDUMENTA": "INDUMENTUM, (Latin) a total body covering of hair, fur or feathers [n]\n",
  "INDUMENTUM": "(Latin) a total body covering of hair, fur or feathers [n INDUMENTA or INDUMENTUMS]\n",
  "INDUMENTUMS": "INDUMENTUM, (Latin) a total body covering of hair, fur or feathers [n]\n",
  "INDUNA": "(Zulu) a South African tribal councillor [n -S]\n",
  "INDUNAS": "INDUNA, (Zulu) a South African tribal councillor [n]\n",
  "INDUPLICATE": "folded inwards, also INDUPLICATED [adj]\n",
  "INDUPLICATED": "folded inwards, also INDUPLICATE [adj]\n",
  "INDUPLICATION": "being folded inwards [n -S]\n",
  "INDUPLICATIONS": "INDUPLICATION, being folded inwards [n]\n",
  "INDURATE": "to make hard, callous or unfeeling [v INDURATED, INDURATING, INDURATES]\n",
  "INDURATED": "INDURATE, to make hard, callous or unfeeling [v]\n",
  "INDURATES": "INDURATE, to make hard, callous or unfeeling [v]\n",
  "INDURATING": "INDURATE, to make hard, callous or unfeeling [v]\n",
  "INDURATION": "the act of hardening, or the process of growing hard [n -S]\n",
  "INDURATIONS": "INDURATION, the act of hardening, or the process of growing hard [n]\n",
  "INDURATIVE": "relating to induration [adj]\n",
  "INDUSIA": "INDUSIUM, an enclosing membrane [n]\n",
  "INDUSIAL": "of or like an indusium, the protective cover of an insect's wing [adj]\n",
  "INDUSIATE": "having an indusium, a protective covering [adj]\n",
  "INDUSIUM": "an enclosing membrane [n INDUSIA]\n",
  "INDUSTRIAL": "related to industry [adj INDUSTRIALLY] / one that is employed in industry [n -S]\n",
  "INDUSTRIALISE": "to make industrial, also INDUSTRIALIZE [v INDUSTRIALISED, INDUSTRIALISING, INDUSTRIALISES]\n",
  "INDUSTRIALISED": "INDUSTRIALISE, to make industrial, also INDUSTRIALIZE [v]\n",
  "INDUSTRIALISES": "INDUSTRIALISE, to make industrial, also INDUSTRIALIZE [v]\n",
  "INDUSTRIALISING": "INDUSTRIALISE, to make industrial, also INDUSTRIALIZE [v]\n",
  "INDUSTRIALISM": "social organization in which industries and especially large-scale industries are dominant [n -S]\n",
  "INDUSTRIALISMS": "INDUSTRIALISM, social organization in which industries and especially large-scale industries are dominant [n]\n",
  "INDUSTRIALIST": "one owning or engaged in the management of an industry [n -S]\n",
  "INDUSTRIALISTS": "INDUSTRIALIST, one owning or engaged in the management of an industry [n]\n",
  "INDUSTRIALIZE": "to make industrial, also INDUSTRIALISE [v INDUSTRIALIZED, INDUSTRIALIZING, INDUSTRIALIZES]\n",
  "INDUSTRIALIZED": "INDUSTRIALIZE, to make industrial, also INDUSTRIALISE [v]\n",
  "INDUSTRIALIZES": "INDUSTRIALIZE, to make industrial, also INDUSTRIALISE [v]\n",
  "INDUSTRIALIZING": "INDUSTRIALIZE, to make industrial, also INDUSTRIALISE [v]\n",
  "INDUSTRIALLY": "INDUSTRIAL, related to industry [adv]\n",
  "INDUSTRIALS": "INDUSTRIAL, one that is employed in industry [n]\n",
  "INDUSTRIES": "INDUSTRY, a group of productive enterprises [n]\n",
  "INDUSTRIOUS": "habitually active or occupied [adj INDUSTRIOUSLY]\n",
  "INDUSTRIOUSLY": "INDUSTRIOUS, habitually active or occupied [adv]\n",
  "INDUSTRIOUSNESS": "INDUSTRIOUS, habitually active or occupied [n]\n",
  "INDUSTRY": "a group of productive enterprises [n INDUSTRIES]\n",
  "INDUSTRYWIDE": "throughout industry [adj]\n",
  "INDUVIAE": "(Latin) persistent withered leaves on some plants [n]\n",
  "INDUVIAL": "pertaining to withered leaves [adj]\n",
  "INDUVIATE": "covered with induviae, as the upper part of the trunk of a palm tree [adj]\n",
  "INDWELL": "to live within [v INDWELT, INDWELLING, INDWELLS]\n",
  "INDWELLER": "an inhabitant [n -S]\n",
  "INDWELLERS": "INDWELLER, an inhabitant [n]\n",
  "INDWELLING": "residence within, or in the heart or soul [n -S]\n",
  "INDWELLINGS": "INDWELLING, residence within, or in the heart or soul [n]\n",
  "INDWELLS": "INDWELL, to live within [v]\n",
  "INDWELT": "INDWELL, to live within [v]\n",
  "INDYREF": "a referendum on the subject of a nation's independence [n -S]\n",
  "INDYREFS": "INDYREF, a referendum on the subject of a nation's independence [n]\n",
  "INEARTH": "(archaic) to inter [v -ED, -ING, -S]\n",
  "INEARTHED": "INEARTH, (archaic) to inter [v]\n",
  "INEARTHING": "INEARTH, (archaic) to inter [v]\n",
  "INEARTHS": "INEARTH, (archaic) to inter [v]\n",
  "INEBRIANT": "something that inebriates [n -S]\n",
  "INEBRIANTS": "INEBRIANT, something that inebriates [n]\n",
  "INEBRIATE": "to make drunk [v INEBRIATED, INEBRIATING, INEBRIATES]\n",
  "INEBRIATED": "INEBRIATE, to make drunk [v]\n",
  "INEBRIATES": "INEBRIATE, to make drunk [v]\n",
  "INEBRIATING": "INEBRIATE, to make drunk [v]\n",
  "INEBRIATION": "drunkenness [n -S]\n",
  "INEBRIATIONS": "INEBRIATION, drunkenness [n]\n",
  "INEBRIETIES": "INEBRIETY, drunkenness [n]\n",
  "INEBRIETY": "drunkenness [n INEBRIETIES]\n",
  "INEBRIOUS": "drunk; causing intoxication [adj]\n",
  "INEDIBILITIES": "INEDIBILITY, the state of being inedible [n]\n",
  "INEDIBILITY": "the state of being inedible [n INEDIBILITIES]\n",
  "INEDIBLE": "not fit to be eaten, also UNEDIBLE [adj INEDIBLY]\n",
  "INEDIBLY": "INEDIBLE, not fit to be eaten, also UNEDIBLE [adv]\n",
  "INEDITA": "(Latin) unpublished literary works [n]\n",
  "INEDITED": "not published [adj]\n",
  "INEDUCABILITIES": "INEDUCABILITY, the state of being ineducable [n]\n",
  "INEDUCABILITY": "the state of being ineducable [n INEDUCABILITIES]\n",
  "INEDUCABLE": "incapable of being educated [adj]\n",
  "INEFFABILITIES": "INEFFABILITY, the state of being ineffable [n]\n",
  "INEFFABILITY": "the state of being ineffable [n INEFFABILITIES]\n",
  "INEFFABLE": "unspeakable, indescribable [adj INEFFABLY]\n",
  "INEFFABLENESS": "the state of being ineffable [n -ES]\n",
  "INEFFABLENESSES": "INEFFABLENESS, the state of being ineffable [n]\n",
  "INEFFABLY": "INEFFABLE, unspeakable, indescribable [adv]\n",
  "INEFFACEABILITY": "the state of being ineffaceable [n]\n",
  "INEFFACEABLE": "not effaceable [adj INEFFACEABLY]\n",
  "INEFFACEABLY": "INEFFACEABLE, not effaceable [adv]\n",
  "INEFFECTIVE": "not producing an intended effect [adj INEFFECTIVELY]\n",
  "INEFFECTIVELY": "INEFFECTIVE, not producing an intended effect [adv]\n",
  "INEFFECTIVENESS": "the state of being ineffective [n]\n",
  "INEFFECTUAL": "not producing the proper or intended effect [adj INEFFECTUALLY]\n",
  "INEFFECTUALITY": "the state of being ineffectual [n]\n",
  "INEFFECTUALLY": "INEFFECTUAL, not producing the proper or intended effect [adv]\n",
  "INEFFECTUALNESS": "the state of being ineffectual [n]\n",
  "INEFFICACIES": "INEFFICACY, lack of power to produce a desired effect, also INEFFICACITY [n]\n",
  "INEFFICACIOUS": "lacking the power to produce a desired effect [adj INEFFICACIOUSLY]\n",
  "INEFFICACIOUSLY": "INEFFICACIOUS, lacking the power to produce a desired effect [adv]\n",
  "INEFFICACITIES": "INEFFICACITY, lack of power to produce a desired effect, also INEFFICACY [n]\n",
  "INEFFICACITY": "lack of power to produce a desired effect, also INEFFICACY [n INEFFICACITIES]\n",
  "INEFFICACY": "lack of power to produce a desired effect, also INEFFICACITY [n INEFFICACIES]\n",
  "INEFFICIENCIES": "INEFFICIENCY, the state of being inefficient [n]\n",
  "INEFFICIENCY": "the state of being inefficient [n INEFFICIENCIES]\n",
  "INEFFICIENT": "not efficient [adj INEFFICIENTLY] / one who is not efficient [n -S]\n",
  "INEFFICIENTLY": "INEFFICIENT, not efficient [adv]\n",
  "INEFFICIENTS": "INEFFICIENT, one who is not efficient [n]\n",
  "INEGALITARIAN": "a person who holds that people are not equal [n -S]\n",
  "INEGALITARIANS": "INEGALITARIAN, a person who holds that people are not equal [n]\n",
  "INELABORATE": "not elaborate [adj INELABORATELY] / to make elaborate [v INELABORATED, INELABORATING, INELABORATES]\n",
  "INELABORATED": "INELABORATE, to make elaborate [v]\n",
  "INELABORATELY": "INELABORATE, not elaborate [adv]\n",
  "INELABORATES": "INELABORATE, to make elaborate [v]\n",
  "INELABORATING": "INELABORATE, to make elaborate [v]\n",
  "INELASTIC": "not elastic [adj INELASTICALLY]\n",
  "INELASTICALLY": "INELASTIC, not elastic [adv]\n",
  "INELASTICITIES": "INELASTICITY, the state of being inelastic [n]\n",
  "INELASTICITY": "the state of being inelastic [n INELASTICITIES]\n",
  "INELEGANCE": "lack of elegance, also INELEGANCY [n -S]\n",
  "INELEGANCES": "INELEGANCE, lack of elegance, also INELEGANCY [n]\n",
  "INELEGANCIES": "INELEGANCY, lack of elegance, also INELEGANCE [n]\n",
  "INELEGANCY": "lack of elegance, also INELEGANCE [n INELEGANCIES]\n",
  "INELEGANT": "not elegant [adj INELEGANTLY]\n",
  "INELEGANTLY": "INELEGANT, not elegant [adv]\n",
  "INELIGIBILITIES": "INELIGIBILITY, the state of being ineligible [n]\n",
  "INELIGIBILITY": "the state of being ineligible [n INELIGIBILITIES]\n",
  "INELIGIBLE": "not eligible [adj INELIGIBLY] / one who is not eligible [n -S]\n",
  "INELIGIBLENESS": "INELIGIBLE, not eligible [n]\n",
  "INELIGIBLES": "INELIGIBLE, one who is not eligible [n]\n",
  "INELIGIBLY": "INELIGIBLE, not eligible [adv]\n",
  "INELOQUENCE": "lack of eloquence [n -S]\n",
  "INELOQUENCES": "INELOQUENCE, lack of eloquence [n]\n",
  "INELOQUENT": "not eloquent [adj INELOQUENTLY]\n",
  "INELOQUENTLY": "INELOQUENT, not eloquent [adv]\n",
  "INELUCTABILITY": "the state of being ineluctable, inevitable; irresistible [n]\n",
  "INELUCTABLE": "inevitable; irresistible [adj INELUCTABLY]\n",
  "INELUCTABLY": "INELUCTABLE, inevitable; irresistible [adv]\n",
  "INELUDIBILITIES": "INELUDIBILITY, the state of being ineludible [n]\n",
  "INELUDIBILITY": "the state of being ineludible [n INELUDIBILITIES]\n",
  "INELUDIBLE": "incapable of being eluded [adj INELUDIBLY]\n",
  "INELUDIBLY": "INELUDIBLE, incapable of being eluded [adv]\n",
  "INENARRABLE": "incapable of being narrated; indescribable [adj]\n",
  "INEPT": "unfit or unqualified, also INAPT, UNAPT [adj INEPTER, INEPTEST, INEPTLY]\n",
  "INEPTER": "INEPT, unfit or unqualified, also INAPT, UNAPT [adj]\n",
  "INEPTEST": "INEPT, unfit or unqualified, also INAPT, UNAPT [adj]\n",
  "INEPTITUDE": "the state of being inept [n -S]\n",
  "INEPTITUDES": "INEPTITUDE, the state of being inept [n]\n",
  "INEPTLY": "INEPT, unfit or unqualified, also INAPT, UNAPT [adv]\n",
  "INEPTNESS": "the state of being inept [n -ES]\n",
  "INEPTNESSES": "INEPTNESS, the state of being inept [n]\n",
  "INEQUABLE": "not equable, also UNEQUABLE [adj]\n",
  "INEQUALITIES": "INEQUALITY, lack of equality [n]\n",
  "INEQUALITY": "lack of equality [n INEQUALITIES]\n",
  "INEQUATION": "an inequality [n -S]\n",
  "INEQUATIONS": "INEQUATION, an inequality [n]\n",
  "INEQUIPOTENT": "having different potentialities for development and differentiation [adj]\n",
  "INEQUITABLE": "not equitable, also UNEQUITABLE [adj INEQUITABLY]\n",
  "INEQUITABLENESS": "INEQUITABLE, not equitable, also UNEQUITABLE [n]\n",
  "INEQUITABLY": "INEQUITABLE, not equitable, also UNEQUITABLE [adv]\n",
  "INEQUITIES": "INEQUITY, unfairness [n]\n",
  "INEQUITY": "unfairness [n INEQUITIES]\n",
  "INEQUIVALVE": "having the valves of the shell of a mollusk unequal in size, also INEQUIVALVED [adj]\n",
  "INEQUIVALVED": "having the valves of the shell of a mollusk unequal in size, also INEQUIVALVE [adj]\n",
  "INERADICABILITY": "the state of being ineradicable [n]\n",
  "INERADICABLE": "incapable of being eradicated [adj INERADICABLY]\n",
  "INERADICABLY": "INERADICABLE, incapable of being eradicated [adv]\n",
  "INERASABLE": "that cannot be erased, also INERASIBLE [adj]\n",
  "INERASABLY": "INERASABLE, that cannot be erased, also INERASIBLE [adv]\n",
  "INERASIBLE": "that cannot be erased, also INERASABLE [adj]\n",
  "INERASIBLY": "INERASIBLE, that cannot be erased, also INERASABLE [adv]\n",
  "INERM": "without thorns, also INERMOUS [adj]\n",
  "INERMOUS": "without thorns, also INERM [adj]\n",
  "INERRABILITIES": "INERRABILITY, the state of being inerrable [n]\n",
  "INERRABILITY": "the state of being inerrable [n INERRABILITIES]\n",
  "INERRABLE": "incapable of erring; infallible [adj INERRABLY]\n",
  "INERRABLENESS": "the state of being inerrable, incapable of erring [n -ES]\n",
  "INERRABLENESSES": "INERRABLENESS, the state of being inerrable, incapable of erring [n]\n",
  "INERRABLY": "INERRABLE, incapable of erring; infallible [adv]\n",
  "INERRANCIES": "INERRANCY, exemption from error, infallibility [n]\n",
  "INERRANCY": "exemption from error, infallibility [n INERRANCIES]\n",
  "INERRANT": "free from error [adj]\n",
  "INERT": "passive [adj INERTER, INERTEST, INERTLY] / something that lacks active properties [n -S]\n",
  "INERTER": "INERT, passive [adj]\n",
  "INERTEST": "INERT, passive [adj]\n",
  "INERTIA": "(Latin) the tendency of a body to resist acceleration [n INERTIAS or INERTIAE]\n",
  "INERTIAE": "INERTIA, (Latin) the tendency of a body to resist acceleration [n]\n",
  "INERTIAL": "of or relating to inertia [adj INERTIALLY]\n",
  "INERTIALLY": "INERTIAL, of or relating to inertia [adv]\n",
  "INERTIAS": "INERTIA, (Latin) the tendency of a body to resist acceleration [n]\n",
  "INERTLY": "INERT, passive [adv]\n",
  "INERTNESS": "the state of being inert [n -ES]\n",
  "INERTNESSES": "INERTNESS, the state of being inert [n]\n",
  "INERTS": "INERT, something that lacks active properties [n]\n",
  "INERUDITE": "not erudite [adj]\n",
  "INESCAPABLE": "that cannot be escaped [adj INESCAPABLY]\n",
  "INESCAPABLY": "INESCAPABLE, that cannot be escaped [adv]\n",
  "INESCULENT": "(archaic) inedible [adj]\n",
  "INESCUTCHEON": "a small shield borne in the centre of another shield [n -S]\n",
  "INESCUTCHEONS": "INESCUTCHEON, a small shield borne in the centre of another shield [n]\n",
  "INESSENTIAL": "not essential [adj] / something not essential [n -S]\n",
  "INESSENTIALITY": "the state of being inessential [n]\n",
  "INESSENTIALS": "INESSENTIAL, something not essential [n]\n",
  "INESSIVE": "a case in Finnish nouns indicating location within [n -S]\n",
  "INESSIVES": "INESSIVE, a case in Finnish nouns indicating location within [n]\n",
  "INESTIMABILITY": "the quality of being inestimable [n]\n",
  "INESTIMABLE": "that cannot be estimated [adj INESTIMABLY]\n",
  "INESTIMABLENESS": "INESTIMABLE, that cannot be estimated [n]\n",
  "INESTIMABLY": "INESTIMABLE, that cannot be estimated [adv]\n",
  "INEVITABILITIES": "INEVITABILITY, the state of being inevitable [n]\n",
  "INEVITABILITY": "the state of being inevitable [n INEVITABILITIES]\n",
  "INEVITABLE": "that cannot be avoided [adj INEVITABLY] / something that cannot be avoided [n -S]\n",
  "INEVITABLENESS": "the state of being inevitable [n]\n",
  "INEVITABLES": "INEVITABLE, something that cannot be avoided [n]\n",
  "INEVITABLY": "INEVITABLE, that cannot be avoided [adv]\n",
  "INEXACT": "not exact or precise [adj INEXACTLY]\n",
  "INEXACTITUDE": "lack of exactitude [n -S]\n",
  "INEXACTITUDES": "INEXACTITUDE, lack of exactitude [n]\n",
  "INEXACTLY": "INEXACT, not exact or precise [adv]\n",
  "INEXACTNESS": "the state of being inexact [n -ES]\n",
  "INEXACTNESSES": "INEXACTNESS, the state of being inexact [n]\n",
  "INEXCITABLE": "not excitable [adj]\n",
  "INEXCUSABILITY": "the quality of being inexcusable [n]\n",
  "INEXCUSABLE": "that cannot be excused [adj INEXCUSABLY]\n",
  "INEXCUSABLENESS": "the state of being inexcusable [n]\n",
  "INEXCUSABLY": "INEXCUSABLE, that cannot be excused [adv]\n",
  "INEXECRABLE": "(Shakespeare) perhaps a misprint for inexorable, though interpreted by some as an intensive form of execrable [adj]\n",
  "INEXECUTABLE": "that cannot be executed [adj]\n",
  "INEXECUTION": "the fact or state of not being executed [n -S]\n",
  "INEXECUTIONS": "INEXECUTION, the fact or state of not being executed [n]\n",
  "INEXHAUSTED": "(archaic) unexhausted, also UNEXHAUSTED [adj]\n",
  "INEXHAUSTIBLE": "not exhaustible [adj INEXHAUSTIBLY]\n",
  "INEXHAUSTIBLY": "INEXHAUSTIBLE, not exhaustible [adv]\n",
  "INEXHAUSTIVE": "not exhaustive [adj]\n",
  "INEXISTANT": "indwelling, inherent, also INEXISTENT [adj]\n",
  "INEXISTENCE": "(archaic) nonexistence, also INEXISTENCY [n -S]\n",
  "INEXISTENCES": "INEXISTENCE, (archaic) nonexistence, also INEXISTENCY [n]\n",
  "INEXISTENCIES": "INEXISTENCY, lack of existence, also INEXISTENCE [n]\n",
  "INEXISTENCY": "lack of existence, also INEXISTENCE [n INEXISTENCIES]\n",
  "INEXISTENT": "not existing, also INEXISTANT [adj]\n",
  "INEXORABILITIES": "INEXORABILITY, the state of being inexorable [n]\n",
  "INEXORABILITY": "the state of being inexorable [n INEXORABILITIES]\n",
  "INEXORABLE": "not to be moved by entreaty or persuasion [adj INEXORABLY]\n",
  "INEXORABLENESS": "the state of being inexorable [n]\n",
  "INEXORABLY": "INEXORABLE, not to be moved by entreaty or persuasion [adv]\n",
  "INEXPANSIBLE": "not expansible [adj]\n",
  "INEXPECTANCIES": "INEXPECTANCY, lack of expectancy [n]\n",
  "INEXPECTANCY": "lack of expectancy [n INEXPECTANCIES]\n",
  "INEXPECTANT": "without expectation [adj]\n",
  "INEXPECTATION": "lack of expectation [n -S]\n",
  "INEXPECTATIONS": "INEXPECTATION, lack of expectation [n]\n",
  "INEXPEDIENCE": "the state of being inexpedient, also INEXPEDIENCY [n -S]\n",
  "INEXPEDIENCES": "INEXPEDIENCE, the state of being inexpedient, also INEXPEDIENCY [n]\n",
  "INEXPEDIENCIES": "INEXPEDIENCY, the state of being inexpedient, also INEXPEDIENCE [n]\n",
  "INEXPEDIENCY": "the state of being inexpedient, also INEXPEDIENCE [n INEXPEDIENCIES]\n",
  "INEXPEDIENT": "not expedient [adj INEXPEDIENTLY]\n",
  "INEXPEDIENTLY": "INEXPEDIENT, not expedient [adv]\n",
  "INEXPENSIVE": "not expensive, also UNEXPENSIVE [adj INEXPENSIVELY]\n",
  "INEXPENSIVELY": "INEXPENSIVE, not expensive, also UNEXPENSIVE [adv]\n",
  "INEXPENSIVENESS": "INEXPENSIVE, not expensive, also UNEXPENSIVE [n]\n",
  "INEXPERIENCE": "lack of practical experience [n -S]\n",
  "INEXPERIENCED": "not experienced, also UNEXPERIENCED [adj]\n",
  "INEXPERIENCES": "INEXPERIENCE, lack of practical experience [n]\n",
  "INEXPERT": "not expert, also UNEXPERT [adj INEXPERTLY] / one who lacks specific skills, also NONEXPERT [n -S]\n",
  "INEXPERTLY": "INEXPERT, one who lacks specific skills, also NONEXPERT [adv]\n",
  "INEXPERTNESS": "a lack of specific skills [n -ES]\n",
  "INEXPERTNESSES": "INEXPERTNESS, a lack of specific skills [n]\n",
  "INEXPERTS": "INEXPERT, one who lacks specific skills, also NONEXPERT [n]\n",
  "INEXPIABLE": "that cannot be expiated or atoned for [adj INEXPIABLY]\n",
  "INEXPIABLENESS": "the state of being inexpiable [n]\n",
  "INEXPIABLY": "INEXPIABLE, that cannot be expiated or atoned for [adv]\n",
  "INEXPLAINABLE": "not able to be explained [adj INEXPLAINABLY]\n",
  "INEXPLAINABLY": "INEXPLAINABLE, not able to be explained [adv]\n",
  "INEXPLICABILITY": "the state of being inexplicable [n]\n",
  "INEXPLICABLE": "incapable of being explained [adj INEXPLICABLY]\n",
  "INEXPLICABLY": "INEXPLICABLE, incapable of being explained [adv]\n",
  "INEXPLICIT": "not explicit [adj INEXPLICITLY]\n",
  "INEXPLICITLY": "INEXPLICIT, not explicit [adv]\n",
  "INEXPLICITNESS": "INEXPLICIT, not explicit [n]\n",
  "INEXPRESSIBLE": "that cannot be expressed [adj INEXPRESSIBLY]\n",
  "INEXPRESSIBLES": "(colloquial) underwear [n]\n",
  "INEXPRESSIBLY": "INEXPRESSIBLE, that cannot be expressed [adv]\n",
  "INEXPRESSIVE": "lacking expression or meaning [adj INEXPRESSIVELY]\n",
  "INEXPRESSIVELY": "INEXPRESSIVE, lacking expression or meaning [adv]\n",
  "INEXPUGNABILITY": "the quality of being inexpugnable [n]\n",
  "INEXPUGNABLE": "not able to be attacked or captured [adj INEXPUGNABLY]\n",
  "INEXPUGNABLY": "INEXPUGNABLE, not able to be attacked or captured [adv]\n",
  "INEXPUNGIBLE": "incapable of being obliterated [adj]\n",
  "INEXTENDED": "not extended [adj]\n",
  "INEXTENSIBILITY": "the state of being inextensible [n]\n",
  "INEXTENSIBLE": "not extensible [adj]\n",
  "INEXTENSION": "lack of extension [n -S]\n",
  "INEXTENSIONS": "INEXTENSION, lack of extension [n]\n",
  "INEXTIRPABLE": "that cannot be extirpated [adj]\n",
  "INEXTRICABILITY": "the state of being inextricable [n]\n",
  "INEXTRICABLE": "forming a maze or tangle from which it is impossible to get free [adj INEXTRICABLY]\n",
  "INEXTRICABLY": "INEXTRICABLE, forming a maze or tangle from which it is impossible to get free [adv]\n",
  "INFALL": "a falling inwards [n -S]\n",
  "INFALLIBILISM": "the doctrine of the Pope's infallibility [n -S]\n",
  "INFALLIBILISMS": "INFALLIBILISM, the doctrine of the Pope's infallibility [n]\n",
  "INFALLIBILIST": "one who believes in the Pope's infallibility [n -S]\n",
  "INFALLIBILISTS": "INFALLIBILIST, one who believes in the Pope's infallibility [n]\n",
  "INFALLIBILITIES": "INFALLIBILITY, the state of being infallible [n]\n",
  "INFALLIBILITY": "the state of being infallible [n INFALLIBILITIES]\n",
  "INFALLIBLE": "not capable of failure, also UNFALLIBLE [adj INFALLIBLY] / one incapable of failure [n -S]\n",
  "INFALLIBLENESS": "the state of being infallible [n]\n",
  "INFALLIBLES": "INFALLIBLE, one incapable of failure [n]\n",
  "INFALLIBLY": "INFALLIBLE, not capable of failure, also UNFALLIBLE [adv]\n",
  "INFALLING": "a falling inwards [adj]\n",
  "INFALLS": "INFALL, a falling inwards [n]\n",
  "INFAME": "(archaic) to defame [v INFAMED, INFAMING, INFAMES]\n",
  "INFAMED": "INFAME, (archaic) to defame [v]\n",
  "INFAMES": "INFAME, (archaic) to defame [v]\n",
  "INFAMIES": "INFAMY, the state of being infamous [n]\n",
  "INFAMING": "INFAME, (archaic) to defame [v]\n",
  "INFAMISE": "to proclaim as infamous, also INFAMIZE [v INFAMISED, INFAMISING, INFAMISES]\n",
  "INFAMISED": "INFAMISE, to proclaim as infamous, also INFAMIZE [v]\n",
  "INFAMISES": "INFAMISE, to proclaim as infamous, also INFAMIZE [v]\n",
  "INFAMISING": "INFAMISE, to proclaim as infamous, also INFAMIZE [v]\n",
  "INFAMIZE": "to proclaim as infamous, also INFAMISE [v INFAMIZED, INFAMIZING, INFAMIZES]\n",
  "INFAMIZED": "INFAMIZE, to proclaim as infamous, also INFAMISE [v]\n",
  "INFAMIZES": "INFAMIZE, to proclaim as infamous, also INFAMISE [v]\n",
  "INFAMIZING": "INFAMIZE, to proclaim as infamous, also INFAMISE [v]\n",
  "INFAMONISE": "to defame, to brand with infamy, also INFAMONIZE [v INFAMONISED, INFAMONISING, INFAMONISES]\n",
  "INFAMONISED": "INFAMONISE, to defame, to brand with infamy, also INFAMONIZE [v]\n",
  "INFAMONISES": "INFAMONISE, to defame, to brand with infamy, also INFAMONIZE [v]\n",
  "INFAMONISING": "INFAMONISE, to defame, to brand with infamy, also INFAMONIZE [v]\n",
  "INFAMONIZE": "to defame, to brand with infamy, also INFAMONISE [v INFAMONIZED, INFAMONIZING, INFAMONIZES]\n",
  "INFAMONIZED": "INFAMONIZE, to defame, to brand with infamy, also INFAMONISE [v]\n",
  "INFAMONIZES": "INFAMONIZE, to defame, to brand with infamy, also INFAMONISE [v]\n",
  "INFAMONIZING": "INFAMONIZE, to defame, to brand with infamy, also INFAMONISE [v]\n",
  "INFAMOUS": "having a vile reputation [adj INFAMOUSLY]\n",
  "INFAMOUSLY": "INFAMOUS, having a vile reputation [adv]\n",
  "INFAMOUSNESS": "the state of being infamous [n -ES]\n",
  "INFAMOUSNESSES": "INFAMOUSNESS, the state of being infamous [n]\n",
  "INFAMY": "the state of being infamous [n INFAMIES]\n",
  "INFANCIES": "INFANCY, the state of being an infant [n]\n",
  "INFANCY": "the state of being an infant [n INFANCIES]\n",
  "INFANGTHIEF": "(Old English) the right of taking and fining a thief within the boundaries of one's own jurisdiction [n -S]\n",
  "INFANGTHIEFS": "INFANGTHIEF, (Old English) the right of taking and fining a thief within the boundaries of one's own jurisdiction [n]\n",
  "INFANT": "a child in the early stages of life [n -S]\n",
  "INFANTA": "(Spanish) a title borne by every one of the daughters of the kings of Spain and Portugal, except the eldest [n -S]\n",
  "INFANTAS": "INFANTA, (Spanish) a title borne by every one of the daughters of the kings of Spain and Portugal, except the eldest [n]\n",
  "INFANTE": "(historical) a title borne by every one of sons of the kings of Spain and Portugal, except the eldest or heir apparent [n -S]\n",
  "INFANTEER": "(Canadian) a Canadian word for an infantryman [n -S]\n",
  "INFANTEERS": "INFANTEER, (Canadian) a Canadian word for an infantryman [n]\n",
  "INFANTES": "INFANTE, (historical) a title borne by every one of sons of the kings of Spain and Portugal, except the eldest or heir apparent [n]\n",
  "INFANTHOOD": "infancy [n -S]\n",
  "INFANTHOODS": "INFANTHOOD, infancy [n]\n",
  "INFANTICIDAL": "relating to infanticide, the killing of a small child [adj]\n",
  "INFANTICIDE": "the killing of a small child [n -S]\n",
  "INFANTICIDES": "INFANTICIDE, the killing of a small child [n]\n",
  "INFANTILE": "like an infant, childish, also INFANTINE [adj]\n",
  "INFANTILISATION": "the act of infantilising, also INFANTILIZATION [n]\n",
  "INFANTILISE": "to render infantile, also INFANTILIZE [v INFANTILISED, INFANTILISING, INFANTILISES]\n",
  "INFANTILISED": "INFANTILISE, to render infantile, also INFANTILIZE [v]\n",
  "INFANTILISES": "INFANTILISE, to render infantile, also INFANTILIZE [v]\n",
  "INFANTILISING": "INFANTILISE, to render infantile, also INFANTILIZE [v]\n",
  "INFANTILISM": "retention of childish physical, mental, or emotional qualities in adult life [n -S]\n",
  "INFANTILISMS": "INFANTILISM, retention of childish physical, mental, or emotional qualities in adult life [n]\n",
  "INFANTILITIES": "INFANTILITY, the state of being infantile [n]\n",
  "INFANTILITY": "the state of being infantile [n INFANTILITIES]\n",
  "INFANTILIZATION": "the act of infantilizing, also INFANTILISATION [n]\n",
  "INFANTILIZE": "to render infantile, also INFANTILISE [v INFANTILIZED, INFANTILIZING, INFANTILIZES]\n",
  "INFANTILIZED": "INFANTILIZE, to render infantile, also INFANTILISE [v]\n",
  "INFANTILIZES": "INFANTILIZE, to render infantile, also INFANTILISE [v]\n",
  "INFANTILIZING": "INFANTILIZE, to render infantile, also INFANTILISE [v]\n",
  "INFANTINE": "like an infant, childish, also INFANTILE [adj]\n",
  "INFANTRIES": "INFANTRY, soldiers marching and fighting on foot [n]\n",
  "INFANTRY": "soldiers marching and fighting on foot [n INFANTRIES]\n",
  "INFANTRYMAN": "an infantry soldier [n INFANTRYMEN]\n",
  "INFANTRYMEN": "INFANTRYMAN, an infantry soldier [n]\n",
  "INFANTS": "INFANT, a child in the early stages of life [n]\n",
  "INFARCT": "a portion of dead and scarred tissue in an organ resulting from congestion or blockage of a blood vessel serving it [n -S]\n",
  "INFARCTED": "affected by infarction, necrosis [adj]\n",
  "INFARCTION": "necrosis, the death of tissues due to the blocking of (esp. the arterial) blood supply [n -S]\n",
  "INFARCTIONS": "INFARCTION, necrosis, the death of tissues due to the blocking of (esp. the arterial) blood supply [n]\n",
  "INFARCTS": "INFARCT, a portion of dead and scarred tissue in an organ resulting from congestion or blockage of a blood vessel serving it [n]\n",
  "INFARE": "a housewarming after a wedding [n -S]\n",
  "INFARES": "INFARE, a housewarming after a wedding [n]\n",
  "INFATUATE": "to inspire with foolish or unreasoning passion [v INFATUATED, INFATUATING, INFATUATES]\n",
  "INFATUATED": "INFATUATE, to inspire with foolish or unreasoning passion [v]\n",
  "INFATUATEDLY": "INFATUATED, INFATUATE, to inspire with foolish or unreasoning passion [adv]\n",
  "INFATUATES": "INFATUATE, to inspire with foolish or unreasoning passion [v]\n",
  "INFATUATING": "INFATUATE, to inspire with foolish or unreasoning passion [v]\n",
  "INFATUATION": "the state of being infatuated [n -S]\n",
  "INFATUATIONS": "INFATUATION, the state of being infatuated [n]\n",
  "INFAUNA": "(Latin) fauna living on a soft sea floor [n INFAUNAS or INFAUNAE]\n",
  "INFAUNAE": "INFAUNA, (Latin) fauna living on a soft sea floor [n]\n",
  "INFAUNAL": "relating to infauna, the class of animals inhabiting ocean and river beds [adj]\n",
  "INFAUNAS": "INFAUNA, (Latin) fauna living on a soft sea floor [n]\n",
  "INFAUST": "(Latin) unlucky; ill-omened [adj]\n",
  "INFEASIBILITIES": "INFEASIBILITY, the state of being infeasible [n]\n",
  "INFEASIBILITY": "the state of being infeasible [n INFEASIBILITIES]\n",
  "INFEASIBLE": "not feasible, also UNFEASIBLE [adj]\n",
  "INFEASIBLENESS": "the state of being infeasible [n]\n",
  "INFECT": "to contaminate with germs [v -ED, -ING, -S]\n",
  "INFECTANT": "a thing that infects or causes infection [n -S]\n",
  "INFECTANTS": "INFECTANT, a thing that infects or causes infection [n]\n",
  "INFECTED": "INFECT, to contaminate with germs [v]\n",
  "INFECTER": "one that infects, also INFECTOR [n -S]\n",
  "INFECTERS": "INFECTER, one that infects, also INFECTOR [n]\n",
  "INFECTING": "INFECT, to contaminate with germs [v]\n",
  "INFECTION": "the act of infecting [n -S]\n",
  "INFECTIONS": "INFECTION, the act of infecting [n]\n",
  "INFECTIOUS": "capable of causing infection [adj INFECTIOUSLY]\n",
  "INFECTIOUSLY": "INFECTIOUS, capable of causing infection [adv]\n",
  "INFECTIOUSNESS": "the state of being infectious [n]\n",
  "INFECTIVE": "infectious [adj INFECTIVELY]\n",
  "INFECTIVELY": "INFECTIVE, infectious [adv]\n",
  "INFECTIVENESS": "INFECTIVE, infectious [n]\n",
  "INFECTIVENESSES": "INFECTIVENESS, INFECTIVE, infectious [n]\n",
  "INFECTIVITIES": "INFECTIVITY, the state of being infective [n]\n",
  "INFECTIVITY": "the state of being infective [n INFECTIVITIES]\n",
  "INFECTOR": "one that infects, also INFECTER [n -S]\n",
  "INFECTORS": "INFECTOR, one that infects, also INFECTER [n]\n",
  "INFECTS": "INFECT, to contaminate with germs [v]\n",
  "INFECUND": "unfruitful; not producing young [adj]\n",
  "INFECUNDITIES": "INFECUNDITY, the state of being infecund [n]\n",
  "INFECUNDITY": "the state of being infecund [n INFECUNDITIES]\n",
  "INFEED": "the action of supplying material to a machine [n -S]\n",
  "INFEEDS": "INFEED, the action of supplying material to a machine [n]\n",
  "INFEFT": "in Scots law, to enfeoff, to invest with heritable property [v -ED, -ING, -S]\n",
  "INFEFTED": "INFEFT, in Scots law, to enfeoff, to invest with heritable property [v]\n",
  "INFEFTING": "INFEFT, in Scots law, to enfeoff, to invest with heritable property [v]\n",
  "INFEFTMENT": "in Scots law, the act of giving legal possession of feudal property [n -S]\n",
  "INFEFTMENTS": "INFEFTMENT, in Scots law, the act of giving legal possession of feudal property [n]\n",
  "INFEFTS": "INFEFT, in Scots law, to enfeoff, to invest with heritable property [v]\n",
  "INFELICITIES": "INFELICITY, the state of being infelicitous [n]\n",
  "INFELICITOUS": "inappropriate in application or expression [adj INFELICITOUSLY]\n",
  "INFELICITOUSLY": "INFELICITOUS, inappropriate in application or expression [adv]\n",
  "INFELICITY": "the state of being infelicitous [n INFELICITIES]\n",
  "INFELT": "heartfelt [adj]\n",
  "INFEOFF": "to invest with a feudal property, also ENFEOFF [v -ED, -ING, -S]\n",
  "INFEOFFED": "INFEOFF, to invest with a feudal property, also ENFEOFF [v]\n",
  "INFEOFFING": "INFEOFF, to invest with a feudal property, also ENFEOFF [v]\n",
  "INFEOFFS": "INFEOFF, to invest with a feudal property, also ENFEOFF [v]\n",
  "INFER": "to reach or derive by reasoning [v INFERRED, INFERRING, INFERS]\n",
  "INFERABLE": "that can be inferred, also INFERIBLE, INFERRABLE, INFERRIBLE [adj INFERABLY]\n",
  "INFERABLY": "INFERABLE, that can be inferred, also INFERIBLE, INFERRABLE, INFERRIBLE [adv]\n",
  "INFERE": "(obsolete) in fere, together [adv]\n",
  "INFERENCE": "the act of inferring [n -S]\n",
  "INFERENCES": "INFERENCE, the act of inferring [n]\n",
  "INFERENCING": "the practice of inferring the meaning of an unfamiliar word or expression from the meaning of familiar words occurring with it in a context together with one's knowledge of or beliefs about the context [n -S]\n",
  "INFERENCINGS": "INFERENCING, the practice of inferring the meaning of an unfamiliar word or expression from the meaning of familiar words occurring with it in a context together with one's knowledge of or beliefs about the context [n]\n",
  "INFERENTIAL": "relating to inference [adj INFERENTIALLY]\n",
  "INFERENTIALLY": "INFERENTIAL, relating to inference [adv]\n",
  "INFERIAE": "(Latin) offerings to the spirits of the dead [n]\n",
  "INFERIBLE": "that can be inferred, also INFERABLE, INFERRABLE, INFERRIBLE [adj]\n",
  "INFERIOR": "lower in any respect, worse [adj INFERIORLY] / one of lesser rank [n -S]\n",
  "INFERIORITIES": "INFERIORITY, the state of being inferior [n]\n",
  "INFERIORITY": "the state of being inferior [n INFERIORITIES]\n",
  "INFERIORLY": "INFERIOR, lower in any respect, worse [adv]\n",
  "INFERIORS": "INFERIOR, one of lesser rank [n]\n",
  "INFERNAL": "pertaining to hell [adj INFERNALLY]\n",
  "INFERNALITIES": "INFERNALITY, the state of being infernal [n]\n",
  "INFERNALITY": "the state of being infernal [n INFERNALITIES]\n",
  "INFERNALLY": "INFERNAL, pertaining to hell [adv]\n",
  "INFERNO": "(Italian) a place of horror and confusion [n -S]\n",
  "INFERNOS": "INFERNO, (Italian) a place of horror and confusion [n]\n",
  "INFERRABLE": "that can be inferred, also INFERABLE, INFERIBLE, INFERRIBLE [adj]\n",
  "INFERRED": "INFER, to reach or derive by reasoning [v]\n",
  "INFERRER": "one who infers [n -S]\n",
  "INFERRERS": "INFERRER, one who infers [n]\n",
  "INFERRIBLE": "that can be inferred, also INFERABLE, INFERIBLE, INFERRABLE [adj]\n",
  "INFERRING": "INFER, to reach or derive by reasoning [v]\n",
  "INFERS": "INFER, to reach or derive by reasoning [v]\n",
  "INFERTILE": "not fertile, also UNFERTILE [adj INFERTILELY]\n",
  "INFERTILELY": "INFERTILE, not fertile, also UNFERTILE [adv]\n",
  "INFERTILITIES": "INFERTILITY, the state of being infertile [n]\n",
  "INFERTILITY": "the state of being infertile [n INFERTILITIES]\n",
  "INFEST": "to invade and swarm over [v -ED, -ING, -S]\n",
  "INFESTANT": "something that infests [n -S]\n",
  "INFESTANTS": "INFESTANT, something that infests [n]\n",
  "INFESTATION": "the state of being infested [n -S]\n",
  "INFESTATIONS": "INFESTATION, the state of being infested [n]\n",
  "INFESTED": "INFEST, to invade and swarm over [v]\n",
  "INFESTER": "one who, or that which, infests [n -S]\n",
  "INFESTERS": "INFESTER, one who, or that which, infests [n]\n",
  "INFESTING": "INFEST, to invade and swarm over [v]\n",
  "INFESTS": "INFEST, to invade and swarm over [v]\n",
  "INFEUDATION": "the granting of feoff; transfer of tithes to layman [n -S]\n",
  "INFEUDATIONS": "INFEUDATION, the granting of feoff; transfer of tithes to layman [n]\n",
  "INFIBULATE": "to fasten with a clasp [v INFIBULATED, INFIBULATING, INFIBULATES]\n",
  "INFIBULATED": "INFIBULATE, to fasten with a clasp [v]\n",
  "INFIBULATES": "INFIBULATE, to fasten with a clasp [v]\n",
  "INFIBULATING": "INFIBULATE, to fasten with a clasp [v]\n",
  "INFIBULATION": "the act of fastening with ring, clasp or stitches to prevent sexual intercourse [n -S]\n",
  "INFIBULATIONS": "INFIBULATION, the act of fastening with ring, clasp or stitches to prevent sexual intercourse [n]\n",
  "INFICETE": "not facetious [adj]\n",
  "INFIDEL": "one who has no religion [n -S]\n",
  "INFIDELIC": "of or like an infidel [adj]\n",
  "INFIDELITIES": "INFIDELITY, lack of fidelity [n]\n",
  "INFIDELITY": "lack of fidelity [n INFIDELITIES]\n",
  "INFIDELS": "INFIDEL, one who has no religion [n]\n",
  "INFIELD": "the area of a baseball field near the pitch [n -S]\n",
  "INFIELDER": "a fielder who stands near the wicket [n -S]\n",
  "INFIELDERS": "INFIELDER, a fielder who stands near the wicket [n]\n",
  "INFIELDS": "INFIELD, the area of a baseball field near the pitch [n]\n",
  "INFIELDSMAN": "one who plays in the infield [n INFIELDSMEN]\n",
  "INFIELDSMEN": "INFIELDSMAN, one who plays in the infield [n]\n",
  "INFIGHT": "to contend with others in the same group [v INFOUGHT, INFIGHTING, INFIGHTS]\n",
  "INFIGHTER": "one who fights at close quarters [n -S]\n",
  "INFIGHTERS": "INFIGHTER, one who fights at close quarters [n]\n",
  "INFIGHTING": "fighting at close quarters [n -S]\n",
  "INFIGHTINGS": "INFIGHTING, fighting at close quarters [n]\n",
  "INFIGHTS": "INFIGHT, to contend with others in the same group [v]\n",
  "INFILL": "to fill in [v -ED, -ING, -S]\n",
  "INFILLED": "INFILL, to fill in [v]\n",
  "INFILLING": "material used to fill up or level [n -S]\n",
  "INFILLINGS": "INFILLING, material used to fill up or level [n]\n",
  "INFILLS": "INFILL, to fill in [v]\n",
  "INFILTRATE": "to cause to filter into [v INFILTRATED, INFILTRATING, INFILTRATES]\n",
  "INFILTRATED": "INFILTRATE, to cause to filter into [v]\n",
  "INFILTRATES": "INFILTRATE, to cause to filter into [v]\n",
  "INFILTRATING": "INFILTRATE, to cause to filter into [v]\n",
  "INFILTRATION": "the act of infiltrating [n -S]\n",
  "INFILTRATIONS": "INFILTRATION, the act of infiltrating [n]\n",
  "INFILTRATIVE": "tending to infiltrate [adj]\n",
  "INFILTRATOR": "one who infiltrates [n -S]\n",
  "INFILTRATORS": "INFILTRATOR, one who infiltrates [n]\n",
  "INFIMA": "INFIMUM, (Latin) a mathematical term for the greatest lower bound [n]\n",
  "INFIMUM": "(Latin) a mathematical term for the greatest lower bound [n INFIMUMS or INFIMA]\n",
  "INFIMUMS": "INFIMUM, (Latin) a mathematical term for the greatest lower bound [n]\n",
  "INFINITANT": "denoting merely negative attribution [adj]\n",
  "INFINITARY": "relating to infinity [adj]\n",
  "INFINITATE": "to make infinite [v INFINITATED, INFINITATING, INFINITATES]\n",
  "INFINITATED": "INFINITATE, to make infinite [v]\n",
  "INFINITATES": "INFINITATE, to make infinite [v]\n",
  "INFINITATING": "INFINITATE, to make infinite [v]\n",
  "INFINITE": "without limit [adj INFINITELY] / something that has no limits [n -S]\n",
  "INFINITELY": "INFINITE, without limit [adv]\n",
  "INFINITENESS": "the state of being infinite [n -ES]\n",
  "INFINITENESSES": "INFINITENESS, the state of being infinite [n]\n",
  "INFINITES": "INFINITE, something that has no limits [n]\n",
  "INFINITESIMAL": "taking on values arbitrarily close to but greater than zero [adj INFINITESIMALLY] / an infinitesimal number [n -S]\n",
  "INFINITESIMALLY": "INFINITESIMAL, taking on values arbitrarily close to but greater than zero [adv]\n",
  "INFINITESIMALS": "INFINITESIMAL, an infinitesimal number [n]\n",
  "INFINITIES": "INFINITY, the state of having no limits [n]\n",
  "INFINITIVAL": "relating to the infinitive mood [adj INFINITIVALLY]\n",
  "INFINITIVALLY": "INFINITIVAL, relating to the infinitive mood [adv]\n",
  "INFINITIVE": "expressing the verbal idea without reference to person, number or time [adj INFINITIVELY] / the infinitive mood; a verb in the infinitive mood [n -S]\n",
  "INFINITIVELY": "INFINITIVE, expressing the verbal idea without reference to person, number or time [adv]\n",
  "INFINITIVES": "INFINITIVE, the infinitive mood; a verb in the infinitive mood [n]\n",
  "INFINITUDE": "the state of being infinite [n -S]\n",
  "INFINITUDES": "INFINITUDE, the state of being infinite [n]\n",
  "INFINITY": "the state of having no limits [n INFINITIES]\n",
  "INFIRM": "to weaken or destroy the validity of [v -ED, -ING, -S] / sickly [adj INFIRMER, INFIRMEST]\n",
  "INFIRMARER": "an officer in a mediaeval monastery who was in charge of the infirmary, also INFIRMARIAN [n -S]\n",
  "INFIRMARERS": "INFIRMARER, an officer in a mediaeval monastery who was in charge of the infirmary, also INFIRMARIAN [n]\n",
  "INFIRMARIAN": "(historical) an officer in a mediaeval monastery who was in charge of the infirmary, also INFIRMARER [n -S]\n",
  "INFIRMARIANS": "INFIRMARIAN, (historical) an officer in a mediaeval monastery who was in charge of the infirmary, also INFIRMARER [n]\n",
  "INFIRMARIES": "INFIRMARY, a hospital or place for the treatment of the sick [n]\n",
  "INFIRMARY": "a hospital or place for the treatment of the sick [n INFIRMARIES]\n",
  "INFIRMED": "INFIRM, to weaken or destroy the validity of [v]\n",
  "INFIRMER": "INFIRM, sickly [adj]\n",
  "INFIRMEST": "INFIRM, sickly [adj]\n",
  "INFIRMING": "INFIRM, to weaken or destroy the validity of [v]\n",
  "INFIRMITIES": "INFIRMITY, weakness, frailty [n]\n",
  "INFIRMITY": "weakness, frailty [n INFIRMITIES]\n",
  "INFIRMLY": "INFIRM, sickly [adv]\n",
  "INFIRMNESS": "the state of being infirm [n -ES]\n",
  "INFIRMNESSES": "INFIRMNESS, the state of being infirm [n]\n",
  "INFIRMS": "INFIRM, to weaken or destroy the validity of [v]\n",
  "INFIX": "to fix in, also ENFIX [v -ED, -ING, -ES]\n",
  "INFIXATION": "the act of infixing [n -S]\n",
  "INFIXATIONS": "INFIXATION, the act of infixing [n]\n",
  "INFIXED": "INFIX, to fix in, also ENFIX [v]\n",
  "INFIXES": "INFIX, to fix in, also ENFIX [v]\n",
  "INFIXING": "INFIX, to fix in, also ENFIX [v]\n",
  "INFIXION": "the act of infixing [n -S]\n",
  "INFIXIONS": "INFIXION, the act of infixing [n]\n",
  "INFLAMABLE": "(obsolete) inflammable [adj]\n",
  "INFLAME": "to set on fire [v INFLAMED, INFLAMING, INFLAMES]\n",
  "INFLAMED": "INFLAME, to set on fire [v]\n",
  "INFLAMER": "one who inflames [n -S]\n",
  "INFLAMERS": "INFLAMER, one who inflames [n]\n",
  "INFLAMES": "INFLAME, to set on fire [v]\n",
  "INFLAMING": "INFLAME, to set on fire [v]\n",
  "INFLAMINGLY": "INFLAMING, INFLAME, to set on fire [adv]\n",
  "INFLAMMABILITY": "the state of being inflammable [n]\n",
  "INFLAMMABLE": "easily able to catch fire, also FLAMMABLE, INFLAMABLE [adj INFLAMMABLY] / something inflammable [n -S]\n",
  "INFLAMMABLENESS": "the state of being inflammable [n]\n",
  "INFLAMMABLES": "INFLAMMABLE, something inflammable [n]\n",
  "INFLAMMABLY": "INFLAMMABLE, easily able to catch fire, also FLAMMABLE, INFLAMABLE [adv]\n",
  "INFLAMMATION": "the state of being inflamed [n -S]\n",
  "INFLAMMATIONS": "INFLAMMATION, the state of being inflamed [n]\n",
  "INFLAMMATORILY": "INFLAMMATORY, tending to inflame [adv]\n",
  "INFLAMMATORY": "tending to inflame [adj INFLAMMATORILY]\n",
  "INFLATABLE": "capable of being inflated [adj] / an inflatable vehicle [n -S]\n",
  "INFLATABLES": "INFLATABLE, an inflatable vehicle [n]\n",
  "INFLATE": "to expand with air or gas [v INFLATED, INFLATING, INFLATES]\n",
  "INFLATED": "INFLATE, to expand with air or gas [v]\n",
  "INFLATEDLY": "INFLATED, INFLATE, to expand with air or gas [adv]\n",
  "INFLATEDNESS": "the state of being inflated [n -ES]\n",
  "INFLATEDNESSES": "INFLATEDNESS, the state of being inflated [n]\n",
  "INFLATER": "one that inflates, also INFLATOR [n -S]\n",
  "INFLATERS": "INFLATER, one that inflates, also INFLATOR [n]\n",
  "INFLATES": "INFLATE, to expand with air or gas [v]\n",
  "INFLATING": "INFLATE, to expand with air or gas [v]\n",
  "INFLATINGLY": "INFLATING, INFLATE, to expand with air or gas [adv]\n",
  "INFLATION": "undue increase in quantity of money in proportion to buying power [n -S]\n",
  "INFLATIONARY": "of, characterized by, or productive of inflation [adj]\n",
  "INFLATIONISM": "the policy of economic inflation [n -S]\n",
  "INFLATIONISMS": "INFLATIONISM, the policy of economic inflation [n]\n",
  "INFLATIONIST": "a supporter of inflationism [n -S]\n",
  "INFLATIONISTS": "INFLATIONIST, a supporter of inflationism [n]\n",
  "INFLATIONS": "INFLATION, undue increase in quantity of money in proportion to buying power [n]\n",
  "INFLATIVE": "causing inflation, tending to inflate [adj]\n",
  "INFLATOR": "one that inflates, also INFLATER [n -S]\n",
  "INFLATORS": "INFLATOR, one that inflates, also INFLATER [n]\n",
  "INFLATUS": "(Latin) a blowing or breathing into; inspiration [n -ES]\n",
  "INFLATUSES": "INFLATUS, (Latin) a blowing or breathing into; inspiration [n]\n",
  "INFLECT": "to bend or curve inwards [v -ED, -ING, -S]\n",
  "INFLECTABLE": "capable of being inflected [adj]\n",
  "INFLECTED": "INFLECT, to bend or curve inwards [v]\n",
  "INFLECTEDNESS": "the state of being inflected [n -ES]\n",
  "INFLECTEDNESSES": "INFLECTEDNESS, the state of being inflected [n]\n",
  "INFLECTING": "INFLECT, to bend or curve inwards [v]\n",
  "INFLECTION": "a change in the form of a word, usually modification or affixation, signalling change in such grammatical functions as tense, voice, mood, person, also INFLEXION [n -S]\n",
  "INFLECTIONAL": "relating to inflection, also INFLEXIONAL [adj INFLECTIONALLY]\n",
  "INFLECTIONALLY": "INFLECTIONAL, relating to inflection, also INFLEXIONAL [adv]\n",
  "INFLECTIONLESS": "without inflection, also INFLEXIONLESS [adj]\n",
  "INFLECTIONS": "INFLECTION, a change in the form of a word, usually modification or affixation, signalling change in such grammatical functions as tense, voice, mood, person, also INFLEXION [n]\n",
  "INFLECTIVE": "capable of, or pertaining to, inflection [adj]\n",
  "INFLECTOR": "one who inflects [n -S]\n",
  "INFLECTORS": "INFLECTOR, one who inflects [n]\n",
  "INFLECTS": "INFLECT, to bend or curve inwards [v]\n",
  "INFLEXED": "bent inward [adj]\n",
  "INFLEXIBILITIES": "INFLEXIBILITY, the state of being inflexible [n]\n",
  "INFLEXIBILITY": "the state of being inflexible [n INFLEXIBILITIES]\n",
  "INFLEXIBLE": "not flexible [adj INFLEXIBLY]\n",
  "INFLEXIBLENESS": "the state of being inflexible [n]\n",
  "INFLEXIBLY": "INFLEXIBLE, not flexible [adv]\n",
  "INFLEXION": "a change in the form of a word, usually modification or affixation, signalling change in such grammatical functions as tense, voice, mood, person, also INFLECTION [n -S]\n",
  "INFLEXIONAL": "relating to inflexion, also INFLECTIONAL [adj INFLEXIONALLY]\n",
  "INFLEXIONALLY": "INFLEXIONAL, relating to inflexion, also INFLECTIONAL [adv]\n",
  "INFLEXIONLESS": "without inflexion, also INFLECTIONLESS [adj]\n",
  "INFLEXIONS": "INFLEXION, a change in the form of a word, usually modification or affixation, signalling change in such grammatical functions as tense, voice, mood, person, also INFLECTION [n]\n",
  "INFLEXURE": "an inflection; a bend or fold [n -S]\n",
  "INFLEXURES": "INFLEXURE, an inflection; a bend or fold [n]\n",
  "INFLICT": "to impose on [v -ED, -ING, -S]\n",
  "INFLICTABLE": "that can be inflicted [adj]\n",
  "INFLICTED": "INFLICT, to impose on [v]\n",
  "INFLICTER": "one who inflicts, also INFLICTOR [n -S]\n",
  "INFLICTERS": "INFLICTER, one who inflicts, also INFLICTOR [n]\n",
  "INFLICTING": "INFLICT, to impose on [v]\n",
  "INFLICTION": "the act of inflicting [n -S]\n",
  "INFLICTIONS": "INFLICTION, the act of inflicting [n]\n",
  "INFLICTIVE": "causing infliction; acting as an infliction [adj]\n",
  "INFLICTOR": "one who inflicts, also INFLICTER [n -S]\n",
  "INFLICTORS": "INFLICTOR, one who inflicts, also INFLICTER [n]\n",
  "INFLICTS": "INFLICT, to impose on [v]\n",
  "INFLIGHT": "done during an air voyage [adj]\n",
  "INFLORESCENCE": "a cluster of flowers [n -S]\n",
  "INFLORESCENCES": "INFLORESCENCE, a cluster of flowers [n]\n",
  "INFLORESCENT": "of or like an inflorescence, a cluster of flowers [adj]\n",
  "INFLOW": "the act of flowing in [n -S]\n",
  "INFLOWING": "the act of flowing inwards [n -S]\n",
  "INFLOWINGS": "INFLOWING, the act of flowing inwards [n]\n",
  "INFLOWS": "INFLOW, the act of flowing in [n]\n",
  "INFLUENCE": "to have or exert an effect on [v INFLUENCED, INFLUENCING, INFLUENCES]\n",
  "INFLUENCEABLE": "capable of being influenced [adj]\n",
  "INFLUENCED": "INFLUENCE, to have or exert an effect on [v]\n",
  "INFLUENCER": "one who influences [n -S]\n",
  "INFLUENCERS": "INFLUENCER, one who influences [n]\n",
  "INFLUENCES": "INFLUENCE, to have or exert an effect on [v]\n",
  "INFLUENCING": "INFLUENCE, to have or exert an effect on [v]\n",
  "INFLUENT": "a tributary stream [n -S]\n",
  "INFLUENTIAL": "having great influence [adj INFLUENTIALLY] / one who has great influence [n -S]\n",
  "INFLUENTIALLY": "INFLUENTIAL, having great influence [adv]\n",
  "INFLUENTIALS": "INFLUENTIAL, one who has great influence [n]\n",
  "INFLUENTS": "INFLUENT, a tributary stream [n]\n",
  "INFLUENZA": "a highly contagious viral infection [n -S]\n",
  "INFLUENZAL": "relating to influenza [adj]\n",
  "INFLUENZAS": "INFLUENZA, a highly contagious viral infection [n]\n",
  "INFLUX": "a flowing in, also INFLUXION [n -ES]\n",
  "INFLUXES": "INFLUX, a flowing in, also INFLUXION [n]\n",
  "INFLUXION": "a flowing in, also INFLUX [n -S]\n",
  "INFLUXIONS": "INFLUXION, a flowing in, also INFLUX [n]\n",
  "INFO": "(short for) information [n -S]\n",
  "INFOBAHN": "an information superhighway such as the Internet [n -S]\n",
  "INFOBAHNS": "INFOBAHN, an information superhighway such as the Internet [n]\n",
  "INFOGRAPHIC": "a graph, diagram, or other visual image designed to present complex information in an easily understandable form [n -S]\n",
  "INFOGRAPHICS": "INFOGRAPHIC, a graph, diagram, or other visual image designed to present complex information in an easily understandable form [n]\n",
  "INFOLD": "to fold inwards [v -ED, -ING, -S]\n",
  "INFOLDED": "INFOLD, to fold inwards [v]\n",
  "INFOLDER": "one that infolds [n -S]\n",
  "INFOLDERS": "INFOLDER, one that infolds [n]\n",
  "INFOLDING": "a folding inwards [n -S]\n",
  "INFOLDINGS": "INFOLDING, a folding inwards [n]\n",
  "INFOLDMENT": "the state of being infolded [n -S]\n",
  "INFOLDMENTS": "INFOLDMENT, the state of being infolded [n]\n",
  "INFOLDS": "INFOLD, to fold inwards [v]\n",
  "INFOMANIA": "an excessive desire for information [n -S]\n",
  "INFOMANIAS": "INFOMANIA, an excessive desire for information [n]\n",
  "INFOMERCIAL": "a television program that is an extended advertisement often including a discussion or demonstration [n -S]\n",
  "INFOMERCIALS": "INFOMERCIAL, a television program that is an extended advertisement often including a discussion or demonstration [n]\n",
  "INFOPRENEURIAL": "of or relating to the industry concerned with the development, manufacture and sale of esp. computerized or electronic equipment for the distribution of information [adj]\n",
  "INFORCE": "to compel, also ENFORCE [v INFORCED, INFORCING, INFORCES]\n",
  "INFORCED": "INFORCE, to compel, also ENFORCE [v]\n",
  "INFORCES": "INFORCE, to compel, also ENFORCE [v]\n",
  "INFORCING": "INFORCE, to compel, also ENFORCE [v]\n",
  "INFORM": "to pass on information, also ENFORM [v -ED, -ING, -S]\n",
  "INFORMABLE": "that can be informed [adj]\n",
  "INFORMAL": "marked by the absence of formality or ceremony, also UNFORMAL [adj INFORMALLY]\n",
  "INFORMALITIES": "INFORMALITY, the state of being informal [n]\n",
  "INFORMALITY": "the state of being informal [n INFORMALITIES]\n",
  "INFORMALLY": "INFORMAL, marked by the absence of formality or ceremony, also UNFORMAL [adv]\n",
  "INFORMANT": "someone who informs [n -S]\n",
  "INFORMANTS": "INFORMANT, someone who informs [n]\n",
  "INFORMATICIAN": "someone engaged in informatics [n -S]\n",
  "INFORMATICIANS": "INFORMATICIAN, someone engaged in informatics [n]\n",
  "INFORMATICS": "information science [n]\n",
  "INFORMATION": "the communication or reception of knowledge or intelligence [n -S]\n",
  "INFORMATIONAL": "relating to information [adj INFORMATIONALLY]\n",
  "INFORMATIONALLY": "INFORMATIONAL, relating to information [adv]\n",
  "INFORMATIONS": "INFORMATION, the communication or reception of knowledge or intelligence [n]\n",
  "INFORMATISATION": "the conversion of (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATIZATION [n]\n",
  "INFORMATISE": "to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATIZE [v INFORMATISED, INFORMATISING, INFORMATISES]\n",
  "INFORMATISED": "INFORMATISE, to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATIZE [v]\n",
  "INFORMATISES": "INFORMATISE, to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATIZE [v]\n",
  "INFORMATISING": "INFORMATISE, to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATIZE [v]\n",
  "INFORMATIVE": "imparting knowledge [adj INFORMATIVELY]\n",
  "INFORMATIVELY": "INFORMATIVE, imparting knowledge [adv]\n",
  "INFORMATIVENESS": "INFORMATIVE, imparting knowledge [n]\n",
  "INFORMATIZATION": "the conversion of (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATISATION [n]\n",
  "INFORMATIZE": "to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATISE [v INFORMATIZED, INFORMATIZING, INFORMATIZES]\n",
  "INFORMATIZED": "INFORMATIZE, to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATISE [v]\n",
  "INFORMATIZES": "INFORMATIZE, to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATISE [v]\n",
  "INFORMATIZING": "INFORMATIZE, to convert (something) into data or information, esp. for analysis, processing, or consumption by computers, also INFORMATISE [v]\n",
  "INFORMATORILY": "INFORMATORY, conveying information [adv]\n",
  "INFORMATORY": "conveying information [adj INFORMATORILY]\n",
  "INFORMED": "INFORM, to pass on information, also ENFORM [v]\n",
  "INFORMEDLY": "INFORMED, INFORM, to pass on information, also ENFORM [adv]\n",
  "INFORMER": "one that informs [n -S]\n",
  "INFORMERS": "INFORMER, one that informs [n]\n",
  "INFORMIDABLE": "not formidable [adj]\n",
  "INFORMING": "INFORM, to pass on information, also ENFORM [v]\n",
  "INFORMINGLY": "INFORMING, INFORM, to pass on information, also ENFORM [adv]\n",
  "INFORMS": "INFORM, to pass on information, also ENFORM [v]\n",
  "INFORTUNE": "misfortune [n -S]\n",
  "INFORTUNES": "INFORTUNE, misfortune [n]\n",
  "INFOS": "INFO, (short for) information [n]\n",
  "INFOSPHERE": "the business of collecting (esp. electronic) information [n -S]\n",
  "INFOSPHERES": "INFOSPHERE, the business of collecting (esp. electronic) information [n]\n",
  "INFOTAINMENT": "television programming that presents information (such as news) in a way that is meant to be entertaining [n -S]\n",
  "INFOTAINMENTS": "INFOTAINMENT, television programming that presents information (such as news) in a way that is meant to be entertaining [n]\n",
  "INFOTECH": "an informal short form of information technology [n -S]\n",
  "INFOTECHS": "INFOTECH, an informal short form of information technology [n]\n",
  "INFOUGHT": "INFIGHT, to contend with others in the same group [v]\n",
  "INFRA": "(Latin) below; later in a text [adv]\n",
  "INFRACOSTAL": "beneath the ribs [adj]\n",
  "INFRACT": "to break a legal rule [v -ED, -ING, -S]\n",
  "INFRACTED": "INFRACT, to break a legal rule [v]\n",
  "INFRACTING": "INFRACT, to break a legal rule [v]\n",
  "INFRACTION": "the act of infringing [n -S]\n",
  "INFRACTIONS": "INFRACTION, the act of infringing [n]\n",
  "INFRACTOR": "one who infracts or infringes [n -S]\n",
  "INFRACTORS": "INFRACTOR, one who infracts or infringes [n]\n",
  "INFRACTS": "INFRACT, to break a legal rule [v]\n",
  "INFRAGRANT": "not fragrant [adj]\n",
  "INFRAHUMAN": "less or lower than human [adj] / a creature e.g. of the primates less than human [n -S]\n",
  "INFRAHUMANS": "INFRAHUMAN, a creature e.g. of the primates less than human [n]\n",
  "INFRALAPSARIAN": "a person who believes that foreknowledge of the Fall preceded God's decree of who was predestined to salvation and who was not [n -S]\n",
  "INFRALAPSARIANS": "INFRALAPSARIAN, a person who believes that foreknowledge of the Fall preceded God's decree of who was predestined to salvation and who was not [n]\n",
  "INFRAMAXILLARY": "situated under the jaw; belonging to the lower jaw [adj]\n",
  "INFRANGIBILITY": "the state of being infrangible [n]\n",
  "INFRANGIBLE": "not able to be broken or violated [adj INFRANGIBLY]\n",
  "INFRANGIBLENESS": "the state of being infrangible [n]\n",
  "INFRANGIBLY": "INFRANGIBLE, not able to be broken or violated [adv]\n",
  "INFRAORBITAL": "situated below the orbit of the eye [adj]\n",
  "INFRAPOSED": "placed below something else [adj]\n",
  "INFRAPOSITION": "the state of being placed below something else [n -S]\n",
  "INFRAPOSITIONS": "INFRAPOSITION, the state of being placed below something else [n]\n",
  "INFRARED": "a part of the visible spectrum, also ULTRARED [n -S]\n",
  "INFRAREDS": "INFRARED, a part of the visible spectrum, also ULTRARED [n]\n",
  "INFRASONIC": "having or relating to a frequency below the audibility range of the human ear [adj]\n",
  "INFRASOUND": "frequencies below the usual audible limit [n -S]\n",
  "INFRASOUNDS": "INFRASOUND, frequencies below the usual audible limit [n]\n",
  "INFRASPECIFIC": "of taxonomic divisions of a lower rank than species [adj]\n",
  "INFRASTRUCTURAL": "of or like an infrastructure [adj]\n",
  "INFRASTRUCTURE": "the underlying foundation or basic framework (as of a system or organization) [n -S]\n",
  "INFRASTRUCTURES": "INFRASTRUCTURE, the underlying foundation or basic framework (as of a system or organization) [n]\n",
  "INFREQUENCE": "rarity of occurrence, also INFREQUENCY [n -S]\n",
  "INFREQUENCES": "INFREQUENCE, rarity of occurrence, also INFREQUENCY [n]\n",
  "INFREQUENCIES": "INFREQUENCY, rarity of occurrence, also INFREQUENCE [n]\n",
  "INFREQUENCY": "rarity of occurrence, also INFREQUENCE [n INFREQUENCIES]\n",
  "INFREQUENT": "not frequent, also UNFREQUENT [adj INFREQUENTLY]\n",
  "INFREQUENTLY": "INFREQUENT, not frequent, also UNFREQUENT [adv]\n",
  "INFRINGE": "to violate an oath or law [v INFRINGED, INFRINGING, INFRINGES]\n",
  "INFRINGED": "INFRINGE, to violate an oath or law [v]\n",
  "INFRINGEMENT": "the act of infringing [n -S]\n",
  "INFRINGEMENTS": "INFRINGEMENT, the act of infringing [n]\n",
  "INFRINGER": "one who infringes [n -S]\n",
  "INFRINGERS": "INFRINGER, one who infringes [n]\n",
  "INFRINGES": "INFRINGE, to violate an oath or law [v]\n",
  "INFRINGING": "INFRINGE, to violate an oath or law [v]\n",
  "INFRUCTUOUS": "not fruitful [adj INFRUCTUOUSLY]\n",
  "INFRUCTUOUSLY": "INFRUCTUOUS, not fruitful [adv]\n",
  "INFRUGAL": "prodigal [adj]\n",
  "INFULA": "(Latin) a headband used during Roman rites [n INFULAE]\n",
  "INFULAE": "INFULA, (Latin) a headband used during Roman rites [n]\n",
  "INFUNDIBULA": "INFUNDIBULUM, a funnel-shaped body part (e.g. the nares) [n]\n",
  "INFUNDIBULAR": "funnel-shaped, also INFUNDIBULATE [adj]\n",
  "INFUNDIBULATE": "funnel-shaped, also INFUNDIBULAR [adj]\n",
  "INFUNDIBULIFORM": "shaped like a funnel [adj]\n",
  "INFUNDIBULUM": "a funnel-shaped body part (e.g. the nares) [n INFUNDIBULA]\n",
  "INFURIATE": "enraged [adj INFURIATELY] / to make furious [v INFURIATED, INFURIATING, INFURIATES]\n",
  "INFURIATED": "INFURIATE, to make furious [v]\n",
  "INFURIATELY": "INFURIATE, enraged [adv]\n",
  "INFURIATES": "INFURIATE, to make furious [v]\n",
  "INFURIATING": "INFURIATE, to make furious [v]\n",
  "INFURIATINGLY": "INFURIATING, INFURIATE, to make furious [adv]\n",
  "INFURIATION": "the act of infuriating [n -S]\n",
  "INFURIATIONS": "INFURIATION, the act of infuriating [n]\n",
  "INFUSCATE": "clouded or tinged with brown, esp. of insects' wings, also INFUSCATED [adj]\n",
  "INFUSCATED": "clouded or tinged with brown, esp. of insects' wings, also INFUSCATE [adj]\n",
  "INFUSE": "to permeate with something [v INFUSED, INFUSING, INFUSES]\n",
  "INFUSED": "INFUSE, to permeate with something [v]\n",
  "INFUSER": "one who infuses [n -S]\n",
  "INFUSERS": "INFUSER, one who infuses [n]\n",
  "INFUSES": "INFUSE, to permeate with something [v]\n",
  "INFUSIBILITIES": "INFUSIBILITY, the state of being infusible [n]\n",
  "INFUSIBILITY": "the state of being infusible [n INFUSIBILITIES]\n",
  "INFUSIBLE": "unable to be fused or melted [adj]\n",
  "INFUSIBLENESS": "the state of being infusible [n -ES]\n",
  "INFUSIBLENESSES": "INFUSIBLENESS, the state of being infusible [n]\n",
  "INFUSING": "INFUSE, to permeate with something [v]\n",
  "INFUSION": "the act of infusing [n -S]\n",
  "INFUSIONISM": "the doctrine that at the birth of each individual a preexisting soul is implanted in his body [n -S]\n",
  "INFUSIONISMS": "INFUSIONISM, the doctrine that at the birth of each individual a preexisting soul is implanted in his body [n]\n",
  "INFUSIONIST": "a believer in infusionism [n -S]\n",
  "INFUSIONISTS": "INFUSIONIST, a believer in infusionism [n]\n",
  "INFUSIONS": "INFUSION, the act of infusing [n]\n",
  "INFUSIVE": "capable of infusing [adj]\n",
  "INFUSORIA": "a class of protozoa found in stagnant water [n]\n",
  "INFUSORIAL": "composed of or containing infusoria, also INFUSORY [adj]\n",
  "INFUSORIAN": "an obsolete term for small aquatic organisms, rotifers, algae etc. [n -S]\n",
  "INFUSORIANS": "INFUSORIAN, an obsolete term for small aquatic organisms, rotifers, algae etc. [n]\n",
  "INFUSORIES": "INFUSORY, an infusorian [n]\n",
  "INFUSORY": "an infusorian [n INFUSORIES]\n",
  "ING": "a meadow, esp. one beside a river [n -S]\n",
  "INGAN": "(Scots) an onion [n -S]\n",
  "INGANS": "INGAN, (Scots) an onion [n]\n",
  "INGATE": "(Scots) a way in, an entrance [n -S]\n",
  "INGATES": "INGATE, (Scots) a way in, an entrance [n]\n",
  "INGATHER": "to gather in, to harvest [v -ED, -ING, -S]\n",
  "INGATHERED": "INGATHER, to gather in, to harvest [v]\n",
  "INGATHERER": "one who ingathers [n -S]\n",
  "INGATHERERS": "INGATHERER, one who ingathers [n]\n",
  "INGATHERING": "the gathering in of crops etc. [n -S]\n",
  "INGATHERINGS": "INGATHERING, the gathering in of crops etc. [n]\n",
  "INGATHERS": "INGATHER, to gather in, to harvest [v]\n",
  "INGEMINATE": "to reiterate; to redouble [v INGEMINATED, INGEMINATING, INGEMINATES]\n",
  "INGEMINATED": "INGEMINATE, to reiterate; to redouble [v]\n",
  "INGEMINATES": "INGEMINATE, to reiterate; to redouble [v]\n",
  "INGEMINATING": "INGEMINATE, to reiterate; to redouble [v]\n",
  "INGEMINATION": "the act of ingeminating [n -S]\n",
  "INGEMINATIONS": "INGEMINATION, the act of ingeminating [n]\n",
  "INGENER": "(Shakespeare) an engineer, also ENGINER [n -S]\n",
  "INGENERATE": "to generate or produce within [v INGENERATED, INGENERATING, INGENERATES]\n",
  "INGENERATED": "INGENERATE, to generate or produce within [v]\n",
  "INGENERATES": "INGENERATE, to generate or produce within [v]\n",
  "INGENERATING": "INGENERATE, to generate or produce within [v]\n",
  "INGENERATION": "the act of ingenerating [n -S]\n",
  "INGENERATIONS": "INGENERATION, the act of ingenerating [n]\n",
  "INGENERS": "INGENER, (Shakespeare) an engineer, also ENGINER [n]\n",
  "INGENIOUS": "cunningly devised [adj INGENIOUSLY]\n",
  "INGENIOUSLY": "INGENIOUS, cunningly devised [adv]\n",
  "INGENIOUSNESS": "the state of being ingenious [n -ES]\n",
  "INGENIOUSNESSES": "INGENIOUSNESS, the state of being ingenious [n]\n",
  "INGENIUM": "(obsolete) mentality; talent, genius [n -S]\n",
  "INGENIUMS": "INGENIUM, (obsolete) mentality; talent, genius [n]\n",
  "INGENU": "(French) an artless, naive young man [n -S]\n",
  "INGENUE": "(French) an artless, naive young woman [n -S]\n",
  "INGENUES": "INGENUE, (French) an artless, naive young woman [n]\n",
  "INGENUITIES": "INGENUITY, the quality of being ingenious [n]\n",
  "INGENUITY": "the quality of being ingenious [n INGENUITIES]\n",
  "INGENUOUS": "showing innocent or childlike simplicity and candidness; lacking craft or subtlety [adj INGENUOUSLY]\n",
  "INGENUOUSLY": "INGENUOUS, showing innocent or childlike simplicity and candidness; lacking craft or subtlety [adv]\n",
  "INGENUOUSNESS": "the state of being ingenuous [n -ES]\n",
  "INGENUOUSNESSES": "INGENUOUSNESS, the state of being ingenuous [n]\n",
  "INGENUS": "INGENU, (French) an artless, naive young man [n]\n",
  "INGEST": "to take into the body [v -ED, -ING, -S]\n",
  "INGESTA": "(Latin) that which is introduced into the body by the stomach or alimentary canal [n]\n",
  "INGESTED": "INGEST, to take into the body [v]\n",
  "INGESTIBLE": "that can be ingested [adj]\n",
  "INGESTING": "INGEST, to take into the body [v]\n",
  "INGESTION": "the act of taking e.g. food into the body [n -S]\n",
  "INGESTIONS": "INGESTION, the act of taking e.g. food into the body [n]\n",
  "INGESTIVE": "relating to ingestion, the act of taking e.g. food into the body [adj]\n",
  "INGESTS": "INGEST, to take into the body [v]\n",
  "INGINE": "(obsolete) ability, genius [n -S]\n",
  "INGINES": "INGINE, (obsolete) ability, genius [n]\n",
  "INGLE": "a fireplace [n -S]\n",
  "INGLENEUK": "an alcove by a large open fire, also INGLENOOK [n -S]\n",
  "INGLENEUKS": "INGLENEUK, an alcove by a large open fire, also INGLENOOK [n]\n",
  "INGLENOOK": "an alcove by a large open fire, also INGLENEUK [n -S]\n",
  "INGLENOOKS": "INGLENOOK, an alcove by a large open fire, also INGLENEUK [n]\n",
  "INGLES": "INGLE, a fireplace [n]\n",
  "INGLOBE": "to form into a globe, also ENGLOBE [v INGLOBED, INGLOBING, INGLOBES]\n",
  "INGLOBED": "INGLOBE, to form into a globe, also ENGLOBE [v]\n",
  "INGLOBES": "INGLOBE, to form into a globe, also ENGLOBE [v]\n",
  "INGLOBING": "INGLOBE, to form into a globe, also ENGLOBE [v]\n",
  "INGLORIOUS": "not glorious [adj INGLORIOUSLY]\n",
  "INGLORIOUSLY": "INGLORIOUS, not glorious [adv]\n",
  "INGLORIOUSNESS": "the state of being inglorious [n]\n",
  "INGLUVIAL": "of or pertaining to the ingluvies or crop of birds [adj]\n",
  "INGLUVIES": "(Latin) the crop or craw of birds [n INGLUVIES]\n",
  "INGO": "(Scots) entry into or taking on a new tenancy [n -ES]\n",
  "INGOES": "INGO, (Scots) entry into or taking on a new tenancy [n]\n",
  "INGOING": "a going in [n -S]\n",
  "INGOINGS": "INGOING, a going in [n]\n",
  "INGOT": "a mass of unwrought metal, esp. gold or silver, cast in a mould [n -S] / to shape (metal) into a convenient form for storage [v -ED, -ING, -S]\n",
  "INGOTED": "INGOT, to shape (metal) into a convenient form for storage [v]\n",
  "INGOTING": "INGOT, to shape (metal) into a convenient form for storage [v]\n",
  "INGOTS": "INGOT, to shape (metal) into a convenient form for storage [v]\n",
  "INGRAFT": "(Shakespeare) to graft for propagation, also ENGRAFT [v -ED, -ING, -S]\n",
  "INGRAFTATION": "the act of ingrafting [n -S]\n",
  "INGRAFTATIONS": "INGRAFTATION, the act of ingrafting [n]\n",
  "INGRAFTED": "INGRAFT, (Shakespeare) to graft for propagation, also ENGRAFT [v]\n",
  "INGRAFTING": "INGRAFT, (Shakespeare) to graft for propagation, also ENGRAFT [v]\n",
  "INGRAFTMENT": "the act of ingrafting [n -S]\n",
  "INGRAFTMENTS": "INGRAFTMENT, the act of ingrafting [n]\n",
  "INGRAFTS": "INGRAFT, (Shakespeare) to graft for propagation, also ENGRAFT [v]\n",
  "INGRAIN": "to impress firmly on the mind, also ENGRAIN [v -ED, -ING, -S]\n",
  "INGRAINED": "INGRAIN, to impress firmly on the mind, also ENGRAIN [v]\n",
  "INGRAINEDLY": "INGRAINED, INGRAIN, to impress firmly on the mind, also ENGRAIN [adv]\n",
  "INGRAINEDNESS": "the state of being ingrained [n -ES]\n",
  "INGRAINEDNESSES": "INGRAINEDNESS, the state of being ingrained [n]\n",
  "INGRAINER": "one who ingrains, also ENGRAINER [n -S]\n",
  "INGRAINERS": "INGRAINER, one who ingrains, also ENGRAINER [n]\n",
  "INGRAINING": "INGRAIN, to impress firmly on the mind, also ENGRAIN [v]\n",
  "INGRAINS": "INGRAIN, to impress firmly on the mind, also ENGRAIN [v]\n",
  "INGRAM": "(obsolete) an ignorant person, also INGRUM [n -S]\n",
  "INGRAMS": "INGRAM, (obsolete) an ignorant person, also INGRUM [n]\n",
  "INGRATE": "(archaic) ungrateful [adj INGRATELY] / an ungrateful person [n -S]\n",
  "INGRATEFUL": "not grateful, also UNGRATEFUL [adj]\n",
  "INGRATELY": "(archaic) ungratefully [adv]\n",
  "INGRATES": "INGRATE, an ungrateful person [n]\n",
  "INGRATIATE": "to commend (usually oneself) persuasively to someone's favour [v INGRATIATED, INGRATIATING, INGRATIATES]\n",
  "INGRATIATED": "INGRATIATE, to commend (usually oneself) persuasively to someone's favour [v]\n",
  "INGRATIATES": "INGRATIATE, to commend (usually oneself) persuasively to someone's favour [v]\n",
  "INGRATIATING": "INGRATIATE, to commend (usually oneself) persuasively to someone's favour [v]\n",
  "INGRATIATINGLY": "INGRATIATING, INGRATIATE, to commend (usually oneself) persuasively to someone's favour [adv]\n",
  "INGRATIATION": "the act of ingratiating [n -S]\n",
  "INGRATIATIONS": "INGRATIATION, the act of ingratiating [n]\n",
  "INGRATIATORY": "serving to ingratiate [adj]\n",
  "INGRATITUDE": "lack of gratitude [n -S]\n",
  "INGRATITUDES": "INGRATITUDE, lack of gratitude [n]\n",
  "INGRAVESCENCE": "the state of being ingravescent, becoming more severe [n -S]\n",
  "INGRAVESCENCES": "INGRAVESCENCE, the state of being ingravescent, becoming more severe [n]\n",
  "INGRAVESCENT": "becoming more severe [adj]\n",
  "INGREDIENT": "something that enters into a mixture or compound [n -S]\n",
  "INGREDIENTS": "INGREDIENT, something that enters into a mixture or compound [n]\n",
  "INGRESS": "a way in, an entrance [n -ES]\n",
  "INGRESSES": "INGRESS, a way in, an entrance [n]\n",
  "INGRESSION": "entrance, ingress [n -S]\n",
  "INGRESSIONS": "INGRESSION, entrance, ingress [n]\n",
  "INGRESSIVE": "pronounced with inhalation rather than exhalation of breath [adj] / a sound pronounced with inhalation [n -S]\n",
  "INGRESSIVENESS": "INGRESSIVE, pronounced with inhalation rather than exhalation of breath [n]\n",
  "INGRESSIVES": "INGRESSIVE, a sound pronounced with inhalation [n]\n",
  "INGROOVE": "to fit into a groove, also ENGROOVE [v INGROOVED, INGROOVING, INGROOVES]\n",
  "INGROOVED": "INGROOVE, to fit into a groove, also ENGROOVE [v]\n",
  "INGROOVES": "INGROOVE, to fit into a groove, also ENGROOVE [v]\n",
  "INGROOVING": "INGROOVE, to fit into a groove, also ENGROOVE [v]\n",
  "INGROSS": "to completely absorb one's attention, also ENGROSS [v -ED, -ING, -ES]\n",
  "INGROSSED": "INGROSS, to completely absorb one's attention, also ENGROSS [v]\n",
  "INGROSSES": "INGROSS, to completely absorb one's attention, also ENGROSS [v]\n",
  "INGROSSING": "INGROSS, to completely absorb one's attention, also ENGROSS [v]\n",
  "INGROUND": "to fix (something) in something as in the ground [v -ED, -ING, -S]\n",
  "INGROUNDED": "INGROUND, to fix (something) in something as in the ground [v]\n",
  "INGROUNDING": "INGROUND, to fix (something) in something as in the ground [v]\n",
  "INGROUNDS": "INGROUND, to fix (something) in something as in the ground [v]\n",
  "INGROUP": "a group united by common interests [n -S]\n",
  "INGROUPS": "INGROUP, a group united by common interests [n]\n",
  "INGROWING": "growing in, as e.g. a toenail [adj]\n",
  "INGROWN": "grown into the flesh [adj]\n",
  "INGROWNNESS": "the state of being ingrown [n -ES]\n",
  "INGROWNNESSES": "INGROWNNESS, the state of being ingrown [n]\n",
  "INGROWTH": "a growth inward [n -S]\n",
  "INGROWTHS": "INGROWTH, a growth inward [n]\n",
  "INGRUM": "(obsolete) an ignorant person, also INGRAM [n -S]\n",
  "INGRUMS": "INGRUM, (obsolete) an ignorant person, also INGRAM [n]\n",
  "INGS": "ING, a meadow, esp. one beside a river [n]\n",
  "INGUINAL": "pertaining to the groin [adj]\n",
  "INGULF": "to swallow up completely, also ENGULF, ENGULPH, INGULPH [v -ED, -ING, -S]\n",
  "INGULFED": "INGULF, to swallow up completely, also ENGULF, ENGULPH, INGULPH [v]\n",
  "INGULFING": "INGULF, to swallow up completely, also ENGULF, ENGULPH, INGULPH [v]\n",
  "INGULFMENT": "the state of being engulfed, also ENGULFMENT [n -S]\n",
  "INGULFMENTS": "INGULFMENT, the state of being engulfed, also ENGULFMENT [n]\n",
  "INGULFS": "INGULF, to swallow up completely, also ENGULF, ENGULPH, INGULPH [v]\n",
  "INGULPH": "to swallow up completely, also ENGULF, ENGULPH, INGULF [v -ED, -ING, -S]\n",
  "INGULPHED": "INGULPH, to swallow up completely, also ENGULF, ENGULPH, INGULF [v]\n",
  "INGULPHING": "INGULPH, to swallow up completely, also ENGULF, ENGULPH, INGULF [v]\n",
  "INGULPHS": "INGULPH, to swallow up completely, also ENGULF, ENGULPH, INGULF [v]\n",
  "INGURGITATE": "to swallow greedily or in large quantities [v INGURGITATED, INGURGITATING, INGURGITATES]\n",
  "INGURGITATED": "INGURGITATE, to swallow greedily or in large quantities [v]\n",
  "INGURGITATES": "INGURGITATE, to swallow greedily or in large quantities [v]\n",
  "INGURGITATING": "INGURGITATE, to swallow greedily or in large quantities [v]\n",
  "INGURGITATION": "the act of ingurgitating [n -S]\n",
  "INGURGITATIONS": "INGURGITATION, the act of ingurgitating [n]\n",
  "INHABIT": "to live in [v -ED, -ING, -S]\n",
  "INHABITABILITY": "the quality of being inhabitable [n]\n",
  "INHABITABLE": "capable of being inhabited [adj]\n",
  "INHABITANCE": "the act of inhabiting, also INHABITANCY [n -S]\n",
  "INHABITANCES": "INHABITANCE, the act of inhabiting, also INHABITANCY [n]\n",
  "INHABITANCIES": "INHABITANCY, the act of inhabiting, also INHABITANCE [n]\n",
  "INHABITANCY": "the act of inhabiting, also INHABITANCE [n INHABITANCIES]\n",
  "INHABITANT": "one that occupies a particular place regularly, routinely, or for a period of time [n -S]\n",
  "INHABITANTS": "INHABITANT, one that occupies a particular place regularly, routinely, or for a period of time [n]\n",
  "INHABITATION": "the act of inhabiting [n -S]\n",
  "INHABITATIONS": "INHABITATION, the act of inhabiting [n]\n",
  "INHABITED": "INHABIT, to live in [v]\n",
  "INHABITER": "one who inhabits, also INHABITOR [n -S]\n",
  "INHABITERS": "INHABITER, one who inhabits, also INHABITOR [n]\n",
  "INHABITING": "INHABIT, to live in [v]\n",
  "INHABITIVENESS": "in phrenology, love of location and home [n]\n",
  "INHABITOR": "one who inhabits, also INHABITER [n -S]\n",
  "INHABITORS": "INHABITOR, one who inhabits, also INHABITER [n]\n",
  "INHABITRESS": "(archaic) a female inhabitant [n -ES]\n",
  "INHABITRESSES": "INHABITRESS, (archaic) a female inhabitant [n]\n",
  "INHABITS": "INHABIT, to live in [v]\n",
  "INHALABLE": "that can be inhaled [adj]\n",
  "INHALANT": "something that is inhaled [n -S]\n",
  "INHALANTS": "INHALANT, something that is inhaled [n]\n",
  "INHALATION": "the act or an instance of inhaling [n -S]\n",
  "INHALATIONAL": "relating to inhalation [adj]\n",
  "INHALATIONS": "INHALATION, the act or an instance of inhaling [n]\n",
  "INHALATOR": "an apparatus for enabling one to inhale a gas, vapour etc. [n -S]\n",
  "INHALATORIUM": "an institution or department for administering inhalations [n -S]\n",
  "INHALATORIUMS": "INHALATORIUM, an institution or department for administering inhalations [n]\n",
  "INHALATORS": "INHALATOR, an apparatus for enabling one to inhale a gas, vapour etc. [n]\n",
  "INHALE": "to take into the lungs [v INHALED, INHALING, INHALES]\n",
  "INHALED": "INHALE, to take into the lungs [v]\n",
  "INHALER": "one that inhales [n -S]\n",
  "INHALERS": "INHALER, one that inhales [n]\n",
  "INHALES": "INHALE, to take into the lungs [v]\n",
  "INHALING": "INHALE, to take into the lungs [v]\n",
  "INHARMONIC": "lacking harmony, inharmonious, also INHARMONICAL [adj]\n",
  "INHARMONICAL": "lacking harmony, inharmonious, also INHARMONIC [adj]\n",
  "INHARMONICITIES": "INHARMONICITY, the state of being inharmonic [n]\n",
  "INHARMONICITY": "the state of being inharmonic [n INHARMONICITIES]\n",
  "INHARMONIES": "INHARMONY, want of harmony [n]\n",
  "INHARMONIOUS": "not harmonious [adj INHARMONIOUSLY]\n",
  "INHARMONIOUSLY": "INHARMONIOUS, not harmonious [adv]\n",
  "INHARMONY": "want of harmony [n INHARMONIES]\n",
  "INHAUL": "a line for bringing in a sail, also INHAULER [n -S]\n",
  "INHAULER": "a line for bringing in a sail, also INHAUL [n -S]\n",
  "INHAULERS": "INHAULER, a line for bringing in a sail, also INHAUL [n]\n",
  "INHAULS": "INHAUL, a line for bringing in a sail, also INHAULER [n]\n",
  "INHAUST": "to drink in [v -ED, -ING, -S]\n",
  "INHAUSTED": "INHAUST, to drink in [v]\n",
  "INHAUSTING": "INHAUST, to drink in [v]\n",
  "INHAUSTS": "INHAUST, to drink in [v]\n",
  "INHEARSE": "(Shakespeare) to enclose in a hearse, also ENHEARSE, INHERCE [v INHEARSED, INHEARSING, INHEARSES]\n",
  "INHEARSED": "INHEARSE, (Shakespeare) to enclose in a hearse, also ENHEARSE, INHERCE [v]\n",
  "INHEARSES": "INHEARSE, (Shakespeare) to enclose in a hearse, also ENHEARSE, INHERCE [v]\n",
  "INHEARSING": "INHEARSE, (Shakespeare) to enclose in a hearse, also ENHEARSE, INHERCE [v]\n",
  "INHERCE": "(Shakespeare) to enclose in a hearse, also INHEARSE, ENHEARSE [v INHERCED, INHERCING, INHERCES]\n",
  "INHERCED": "INHERCE, (Shakespeare) to enclose in a hearse, also INHEARSE, ENHEARSE [v]\n",
  "INHERCES": "INHERCE, (Shakespeare) to enclose in a hearse, also INHEARSE, ENHEARSE [v]\n",
  "INHERCING": "INHERCE, (Shakespeare) to enclose in a hearse, also INHEARSE, ENHEARSE [v]\n",
  "INHERE": "to be an essential characteristic [v INHERED, INHERING, INHERES]\n",
  "INHERED": "INHERE, to be an essential characteristic [v]\n",
  "INHERENCE": "the state of inhering, also INHERENCY, INHESION [n -S]\n",
  "INHERENCES": "INHERENCE, the state of inhering, also INHERENCY, INHESION [n]\n",
  "INHERENCIES": "INHERENCY, the state of inhering, also INHERENCE, INHESION [n]\n",
  "INHERENCY": "the state of inhering, also INHERENCE, INHESION [n INHERENCIES]\n",
  "INHERENT": "innate, natural [adj INHERENTLY]\n",
  "INHERENTLY": "INHERENT, innate, natural [adv]\n",
  "INHERES": "INHERE, to be an essential characteristic [v]\n",
  "INHERING": "INHERE, to be an essential characteristic [v]\n",
  "INHERIT": "to receive by legal succession [v -ED, -ING, -S]\n",
  "INHERITABILITY": "the state of being inheritable [n]\n",
  "INHERITABLE": "capable of being inherited or of passing by inheritance, also HERITABLE [adj INHERITABLY]\n",
  "INHERITABLENESS": "INHERITABLE, capable of being inherited or of passing by inheritance, also HERITABLE [n]\n",
  "INHERITABLY": "INHERITABLE, capable of being inherited or of passing by inheritance, also HERITABLE [adv]\n",
  "INHERITANCE": "the act of inheriting property [n -S]\n",
  "INHERITANCES": "INHERITANCE, the act of inheriting property [n]\n",
  "INHERITED": "INHERIT, to receive by legal succession [v]\n",
  "INHERITING": "INHERIT, to receive by legal succession [v]\n",
  "INHERITOR": "one who inherits [n -S]\n",
  "INHERITORS": "INHERITOR, one who inherits [n]\n",
  "INHERITRESS": "a female inheritor, also INHERITRIX [n -ES]\n",
  "INHERITRESSES": "INHERITRESS, a female inheritor, also INHERITRIX [n]\n",
  "INHERITRICES": "INHERITRIX, a female inheritor, also INHERITRESS [n]\n",
  "INHERITRIX": "a female inheritor, also INHERITRESS [n INHERITRICES or INHERITRIXES]\n",
  "INHERITRIXES": "INHERITRIX, a female inheritor, also INHERITRESS [n]\n",
  "INHERITS": "INHERIT, to receive by legal succession [v]\n",
  "INHESION": "the state of being inherent, also INHERENCE, INHERENCY [n -S]\n",
  "INHESIONS": "INHESION, the state of being inherent, also INHERENCE, INHERENCY [n]\n",
  "INHIBIN": "a human sex hormone [n -S]\n",
  "INHIBINS": "INHIBIN, a human sex hormone [n]\n",
  "INHIBIT": "to restrain or hold back [v -ED, -ING, -S]\n",
  "INHIBITABLE": "that can be inhibited [adj]\n",
  "INHIBITED": "INHIBIT, to restrain or hold back [v]\n",
  "INHIBITEDLY": "in the manner of being restrained or held back [adv]\n",
  "INHIBITER": "something or someone that inhibits, also INHIBITOR [n -S]\n",
  "INHIBITERS": "INHIBITER, something or someone that inhibits, also INHIBITOR [n]\n",
  "INHIBITING": "INHIBIT, to restrain or hold back [v]\n",
  "INHIBITION": "the action of preventing, hindering, or checking [n -S]\n",
  "INHIBITIONS": "INHIBITION, the action of preventing, hindering, or checking [n]\n",
  "INHIBITIVE": "tending to inhibit, also INHIBITORY [adj]\n",
  "INHIBITOR": "something or someone that inhibits, also INHIBITER [n -S]\n",
  "INHIBITORS": "INHIBITOR, something or someone that inhibits, also INHIBITER [n]\n",
  "INHIBITORY": "tending to inhibit, also INHIBITIVE [adj]\n",
  "INHIBITS": "INHIBIT, to restrain or hold back [v]\n",
  "INHOLDER": "a container [n -S]\n",
  "INHOLDERS": "INHOLDER, a container [n]\n",
  "INHOLDING": "privately owned land inside the bounds of a national park [n -S]\n",
  "INHOLDINGS": "INHOLDING, privately owned land inside the bounds of a national park [n]\n",
  "INHOMOGENEITIES": "INHOMOGENEITY, the condition or an instance of not being homogeneous [n]\n",
  "INHOMOGENEITY": "the condition or an instance of not being homogeneous [n INHOMOGENEITIES]\n",
  "INHOMOGENEOUS": "relating to inhomogeneity [adj]\n",
  "INHOOP": "(Shakespeare) to confine in a hoop [v -ED, -ING, -S]\n",
  "INHOOPED": "INHOOP, (Shakespeare) to confine in a hoop [v]\n",
  "INHOOPING": "INHOOP, (Shakespeare) to confine in a hoop [v]\n",
  "INHOOPS": "INHOOP, (Shakespeare) to confine in a hoop [v]\n",
  "INHOSPITABLE": "not showing hospitality, also UNHOSPITABLE [adj INHOSPITABLY]\n",
  "INHOSPITABLY": "INHOSPITABLE, not showing hospitality, also UNHOSPITABLE [adv]\n",
  "INHOSPITALITIES": "INHOSPITALITY, the state of being inhospitable [n]\n",
  "INHOSPITALITY": "the state of being inhospitable [n INHOSPITALITIES]\n",
  "INHUMAN": "lacking desirable human qualities [adj INHUMANLY]\n",
  "INHUMANE": "not humane [adj INHUMANER, INHUMANEST; INHUMANELY]\n",
  "INHUMANELY": "INHUMANE, not humane [adv]\n",
  "INHUMANER": "INHUMANE, not humane [adj]\n",
  "INHUMANEST": "INHUMANE, not humane [adj]\n",
  "INHUMANITIES": "INHUMANITY, the quality of being inhuman [n]\n",
  "INHUMANITY": "the quality of being inhuman [n INHUMANITIES]\n",
  "INHUMANLY": "INHUMAN, lacking desirable human qualities [adv]\n",
  "INHUMANNESS": "the state of being inhuman [n -ES]\n",
  "INHUMANNESSES": "INHUMANNESS, the state of being inhuman [n]\n",
  "INHUMATE": "to bury, also INHUME [v INHUMATED, INHUMATING, INHUMATES]\n",
  "INHUMATED": "INHUMATE, to bury, also INHUME [v]\n",
  "INHUMATES": "INHUMATE, to bury, also INHUME [v]\n",
  "INHUMATING": "INHUMATE, to bury, also INHUME [v]\n",
  "INHUMATION": "burial [n -S]\n",
  "INHUMATIONS": "INHUMATION, burial [n]\n",
  "INHUME": "to bury, also INHUMATE [v INHUMED, INHUMING, INHUMES]\n",
  "INHUMED": "INHUME, to bury, also INHUMATE [v]\n",
  "INHUMER": "one who inhumes [n -S]\n",
  "INHUMERS": "INHUMER, one who inhumes [n]\n",
  "INHUMES": "INHUME, to bury, also INHUMATE [v]\n",
  "INHUMING": "INHUME, to bury, also INHUMATE [v]\n",
  "INIA": "INION, (Greek) a part of the skull [n]\n",
  "INIMICAL": "hostile [adj INIMICALLY]\n",
  "INIMICALITIES": "INIMICALITY, the state of being inimical [n]\n",
  "INIMICALITY": "the state of being inimical [n INIMICALITIES]\n",
  "INIMICALLY": "INIMICAL, hostile [adv]\n",
  "INIMICALNESS": "the state of being inimical [n -ES]\n",
  "INIMICALNESSES": "INIMICALNESS, the state of being inimical [n]\n",
  "INIMICITIOUS": "(Sterne) unfriendly [adj]\n",
  "INIMITABILITIES": "INIMITABILITY, the quality of being inimitable [n]\n",
  "INIMITABILITY": "the quality of being inimitable [n INIMITABILITIES]\n",
  "INIMITABLE": "that cannot be imitated [adj INIMITABLY]\n",
  "INIMITABLENESS": "INIMITABLE, that cannot be imitated [n]\n",
  "INIMITABLY": "INIMITABLE, that cannot be imitated [adv]\n",
  "INION": "(Greek) a part of the skull [n INIONS or INIA]\n",
  "INIONS": "INION, (Greek) a part of the skull [n]\n",
  "INIQUITIES": "INIQUITY, a gross injustice [n]\n",
  "INIQUITOUS": "characterized by gross wickedness [adj INIQUITOUSLY]\n",
  "INIQUITOUSLY": "INIQUITOUS, characterized by gross wickedness [adv]\n",
  "INIQUITOUSNESS": "INIQUITOUS, characterized by gross wickedness [n]\n",
  "INIQUITY": "a gross injustice [n INIQUITIES]\n",
  "INISLE": "to put onto an island, also ENISLE [v INISLED, INISLING, INISLES]\n",
  "INISLED": "INISLE, to put onto an island, also ENISLE [v]\n",
  "INISLES": "INISLE, to put onto an island, also ENISLE [v]\n",
  "INISLING": "INISLE, to put onto an island, also ENISLE [v]\n",
  "INITIAL": "at the beginning [adj INITIALLY] / to mark with the first letters of one's name [v INITIALED or INITIALLED, INITIALING or INITIALLING, INITIALS]\n",
  "INITIALED": "INITIAL, to mark with the first letters of one's name [v]\n",
  "INITIALER": "one who initials, also INITIALLER [n -S]\n",
  "INITIALERS": "INITIALER, one who initials, also INITIALLER [n]\n",
  "INITIALING": "INITIAL, to mark with the first letters of one's name [v]\n",
  "INITIALISATION": "the act of initialising, also INITIALIZATION [n -S]\n",
  "INITIALISATIONS": "INITIALISATION, the act of initialising, also INITIALIZATION [n]\n",
  "INITIALISE": "to set (as a computer program counter) to a starting position, value, or configuration, also INITIALIZE [v INITIALISED, INITIALISING, INITIALISES]\n",
  "INITIALISED": "INITIALISE, to set (as a computer program counter) to a starting position, value, or configuration, also INITIALIZE [v]\n",
  "INITIALISES": "INITIALISE, to set (as a computer program counter) to a starting position, value, or configuration, also INITIALIZE [v]\n",
  "INITIALISING": "INITIALISE, to set (as a computer program counter) to a starting position, value, or configuration, also INITIALIZE [v]\n",
  "INITIALISM": "an acronym formed from initial letters only, as in FBI [n -S]\n",
  "INITIALISMS": "INITIALISM, an acronym formed from initial letters only, as in FBI [n]\n",
  "INITIALIZATION": "the act of initializing, also INITIALISATION [n -S]\n",
  "INITIALIZATIONS": "INITIALIZATION, the act of initializing, also INITIALISATION [n]\n",
  "INITIALIZE": "to set (as a computer program counter) to a starting position, value, or configuration, also INITIALISE [v INITIALIZED, INITIALIZING, INITIALIZES]\n",
  "INITIALIZED": "INITIALIZE, to set (as a computer program counter) to a starting position, value, or configuration, also INITIALISE [v]\n",
  "INITIALIZES": "INITIALIZE, to set (as a computer program counter) to a starting position, value, or configuration, also INITIALISE [v]\n",
  "INITIALIZING": "INITIALIZE, to set (as a computer program counter) to a starting position, value, or configuration, also INITIALISE [v]\n",
  "INITIALLED": "INITIAL, to mark with the first letters of one's name [v]\n",
  "INITIALLER": "one who initials, also INITIALER [n -S]\n",
  "INITIALLERS": "INITIALLER, one who initials, also INITIALER [n]\n",
  "INITIALLING": "INITIAL, to mark with the first letters of one's name [v]\n",
  "INITIALLY": "INITIAL, at the beginning [adv]\n",
  "INITIALNESS": "the state of being initial [n -ES]\n",
  "INITIALNESSES": "INITIALNESS, the state of being initial [n]\n",
  "INITIALS": "INITIAL, to mark with the first letters of one's name [v]\n",
  "INITIATE": "to begin or start [v INITIATED, INITIATING, INITIATES]\n",
  "INITIATED": "INITIATE, to begin or start [v]\n",
  "INITIATES": "INITIATE, to begin or start [v]\n",
  "INITIATING": "INITIATE, to begin or start [v]\n",
  "INITIATION": "the act of initiating [n -S]\n",
  "INITIATIONS": "INITIATION, the act of initiating [n]\n",
  "INITIATIVE": "serving to initiate [adj INITIATIVELY] / an introductory step [n -S]\n",
  "INITIATIVELY": "INITIATIVE, serving to initiate [adv]\n",
  "INITIATIVES": "INITIATIVE, an introductory step [n]\n",
  "INITIATOR": "one who initiates [n -S]\n",
  "INITIATORIES": "INITIATORY, an introductory rite [n]\n",
  "INITIATORS": "INITIATOR, one who initiates [n]\n",
  "INITIATORY": "suitable for an introduction or beginning [adj] / an introductory rite [n INITIATORIES]\n",
  "INITIATRESS": "a female initiator [n -ES]\n",
  "INITIATRESSES": "INITIATRESS, a female initiator [n]\n",
  "INITIATRICES": "INITIATRIX, a female initiator [n]\n",
  "INITIATRIX": "a female initiator [n INITIATRICES or INITIATRIXES]\n",
  "INITIATRIXES": "INITIATRIX, a female initiator [n]\n",
  "INJECT": "to force liquid into [v -ED, -ING, -S]\n",
  "INJECTABLE": "capable of being administered by injection [adj] / an injectable drug [n -S]\n",
  "INJECTABLES": "INJECTABLE, an injectable drug [n]\n",
  "INJECTANT": "a substance that is injected into something [n -S]\n",
  "INJECTANTS": "INJECTANT, a substance that is injected into something [n]\n",
  "INJECTED": "INJECT, to force liquid into [v]\n",
  "INJECTING": "INJECT, to force liquid into [v]\n",
  "INJECTION": "the act of injecting [n -S]\n",
  "INJECTIONS": "INJECTION, the act of injecting [n]\n",
  "INJECTIVE": "being a one to one mathematical function [adj]\n",
  "INJECTOR": "one who injects [n -S]\n",
  "INJECTORS": "INJECTOR, one who injects [n]\n",
  "INJECTS": "INJECT, to force liquid into [v]\n",
  "INJELLIED": "INJELLY, to place as if in jelly [v]\n",
  "INJELLIES": "INJELLY, to place as if in jelly [v]\n",
  "INJELLY": "to place as if in jelly [v INJELLIED, INJELLYING, INJELLIES]\n",
  "INJELLYING": "INJELLY, to place as if in jelly [v]\n",
  "INJERA": "a type of Ethiopian bread made from soured tef flour [n -S]\n",
  "INJERAS": "INJERA, a type of Ethiopian bread made from soured tef flour [n]\n",
  "INJOINT": "(Shakespeare) to join [v -ED, -ING, -S]\n",
  "INJOINTED": "INJOINT, (Shakespeare) to join [v]\n",
  "INJOINTING": "INJOINT, (Shakespeare) to join [v]\n",
  "INJOINTS": "INJOINT, (Shakespeare) to join [v]\n",
  "INJUDICIAL": "not judicial [adj INJUDICIALLY]\n",
  "INJUDICIALLY": "INJUDICIAL, not judicial [adv]\n",
  "INJUDICIOUS": "not judicious [adj INJUDICIOUSLY]\n",
  "INJUDICIOUSLY": "INJUDICIOUS, not judicious [adv]\n",
  "INJUDICIOUSNESS": "the state of being injudicious [n]\n",
  "INJUNCT": "to prohibit; to restrain by means of an injunction [v -ED, -ING, -S]\n",
  "INJUNCTED": "INJUNCT, to prohibit; to restrain by means of an injunction [v]\n",
  "INJUNCTING": "INJUNCT, to prohibit; to restrain by means of an injunction [v]\n",
  "INJUNCTION": "the act or an instance of enjoining [n -S]\n",
  "INJUNCTIONS": "INJUNCTION, the act or an instance of enjoining [n]\n",
  "INJUNCTIVE": "relating to an injunction [adj INJUNCTIVELY]\n",
  "INJUNCTIVELY": "INJUNCTIVE, relating to an injunction [adv]\n",
  "INJUNCTS": "INJUNCT, to prohibit; to restrain by means of an injunction [v]\n",
  "INJURABLE": "that can be injured [adj]\n",
  "INJURE": "to harm or do hurt to [v INJURED, INJURING, INJURES]\n",
  "INJURED": "INJURE, to harm or do hurt to [v]\n",
  "INJURER": "one who injures [n -S]\n",
  "INJURERS": "INJURER, one who injures [n]\n",
  "INJURES": "INJURE, to harm or do hurt to [v]\n",
  "INJURIES": "INJURY, harm inflicted or suffered [n]\n",
  "INJURING": "INJURE, to harm or do hurt to [v]\n",
  "INJURIOUS": "causing injury [adj INJURIOUSLY]\n",
  "INJURIOUSLY": "INJURIOUS, causing injury [adv]\n",
  "INJURIOUSNESS": "the state of being injurious [n -ES]\n",
  "INJURIOUSNESSES": "INJURIOUSNESS, the state of being injurious [n]\n",
  "INJURY": "harm inflicted or suffered [n INJURIES]\n",
  "INJUSTICE": "the fact or act of being unjust [n -S]\n",
  "INJUSTICES": "INJUSTICE, the fact or act of being unjust [n]\n",
  "INK": "a coloured liquid used in writing [n -S] / to colour with ink [v -ED, -ING, -S]\n",
  "INKBERRIES": "INKBERRY, a small shrub [n]\n",
  "INKBERRY": "a small shrub [n INKBERRIES]\n",
  "INKBLOT": "a blotted pattern of spilled ink [n -S]\n",
  "INKBLOTS": "INKBLOT, a blotted pattern of spilled ink [n]\n",
  "INKED": "INK, to colour with ink [v]\n",
  "INKER": "one who inks; a pad for inking [n -S]\n",
  "INKERS": "INKER, one who inks; a pad for inking [n]\n",
  "INKHOLDER": "a container for ink; the reservoir of a fountain-pen [n -S]\n",
  "INKHOLDERS": "INKHOLDER, a container for ink; the reservoir of a fountain-pen [n]\n",
  "INKHORN": "a small container for ink [n -S]\n",
  "INKHORNS": "INKHORN, a small container for ink [n]\n",
  "INKHOSI": "a traditional leader of a Zulu clan, also INKOSI [n AMAKHOSI or INKHOSIS]\n",
  "INKHOSIS": "INKHOSI, a traditional leader of a Zulu clan, also INKOSI [n]\n",
  "INKIER": "INKY, like ink [adj]\n",
  "INKIEST": "INKY, like ink [adj]\n",
  "INKINESS": "the state of being inky [n -ES]\n",
  "INKINESSES": "INKINESS, the state of being inky [n]\n",
  "INKING": "INK, to colour with ink [v]\n",
  "INKJET": "a printer that spurts ink to form letters [n -S]\n",
  "INKJETS": "INKJET, a printer that spurts ink to form letters [n]\n",
  "INKLE": "a broad linen tape, also INCLE [n -S] / to give a hint [v INKLED, INKLING, INKLES]\n",
  "INKLED": "INKLE, to give a hint [v]\n",
  "INKLES": "INKLE, to give a hint [v]\n",
  "INKLESS": "without ink [adj]\n",
  "INKLIKE": "like ink [adj]\n",
  "INKLING": "a slight suggestion [n -S]\n",
  "INKLINGS": "INKLING, a slight suggestion [n]\n",
  "INKOSI": "a traditional leader of a Zulu clan, also INKHOSI [n INKOSIS or AMAKOSI]\n",
  "INKOSIS": "INKOSI, a traditional leader of a Zulu clan, also INKHOSI [n]\n",
  "INKPAD": "a pad of inked cloth used in rubber-stamping, fingerprinting, etc. [n -S]\n",
  "INKPADS": "INKPAD, a pad of inked cloth used in rubber-stamping, fingerprinting, etc. [n]\n",
  "INKPOT": "an inkwell [n -S]\n",
  "INKPOTS": "INKPOT, an inkwell [n]\n",
  "INKS": "INK, to colour with ink [v]\n",
  "INKSPOT": "a small ink stain [n -S]\n",
  "INKSPOTS": "INKSPOT, a small ink stain [n]\n",
  "INKSTAIN": "a stain made by ink [n -S]\n",
  "INKSTAINS": "INKSTAIN, a stain made by ink [n]\n",
  "INKSTAND": "an inkwell [n -S]\n",
  "INKSTANDS": "INKSTAND, an inkwell [n]\n",
  "INKSTONE": "a type of stone used in making ink [n -S]\n",
  "INKSTONES": "INKSTONE, a type of stone used in making ink [n]\n",
  "INKWELL": "a small container for ink [n -S]\n",
  "INKWELLS": "INKWELL, a small container for ink [n]\n",
  "INKWOOD": "an evergreen tree [n -S]\n",
  "INKWOODS": "INKWOOD, an evergreen tree [n]\n",
  "INKY": "like ink [adj INKIER, INKIEST]\n",
  "INLACE": "to entwine or entangle, also ENLACE [v INLACED, INLACING, INLACES]\n",
  "INLACED": "INLACE, to entwine or entangle, also ENLACE [v]\n",
  "INLACES": "INLACE, to entwine or entangle, also ENLACE [v]\n",
  "INLACING": "INLACE, to entwine or entangle, also ENLACE [v]\n",
  "INLAID": "INLAY, to insert or imbed [v]\n",
  "INLAND": "the interior of a country [n -S]\n",
  "INLANDER": "one living inland [n -S]\n",
  "INLANDERS": "INLANDER, one living inland [n]\n",
  "INLANDS": "INLAND, the interior of a country [n]\n",
  "INLAY": "to insert or imbed [v INLAID, INLAYING, INLAYS]\n",
  "INLAYER": "one who inlays [n -S]\n",
  "INLAYERS": "INLAYER, one who inlays [n]\n",
  "INLAYING": "the act of inlaying [n -S]\n",
  "INLAYINGS": "INLAYING, the act of inlaying [n]\n",
  "INLAYS": "INLAY, to insert or imbed [v]\n",
  "INLET": "to insert [v INLET, INLETTING, INLETS]\n",
  "INLETS": "INLET, to insert [v]\n",
  "INLETTING": "INLET, to insert [v]\n",
  "INLIER": "an older rock formation completely surrounded by newer strata [n -S]\n",
  "INLIERS": "INLIER, an older rock formation completely surrounded by newer strata [n]\n",
  "INLOCK": "to lock up, also ENLOCK [v -ED, -ING, -S]\n",
  "INLOCKED": "INLOCK, to lock up, also ENLOCK [v]\n",
  "INLOCKING": "INLOCK, to lock up, also ENLOCK [v]\n",
  "INLOCKS": "INLOCK, to lock up, also ENLOCK [v]\n",
  "INLY": "inwardly; thoroughly [adv]\n",
  "INLYING": "situated inside [adj]\n",
  "INMARRIAGE": "endogamy [n -S]\n",
  "INMARRIAGES": "INMARRIAGE, endogamy [n]\n",
  "INMATE": "one who is confined to an institution [n -S]\n",
  "INMATES": "INMATE, one who is confined to an institution [n]\n",
  "INMESH": "to entangle, also ENMESH, EMMESH, IMMESH [v -ED, -ING, -ES]\n",
  "INMESHED": "INMESH, to entangle, also ENMESH, EMMESH, IMMESH [v]\n",
  "INMESHES": "INMESH, to entangle, also ENMESH, EMMESH, IMMESH [v]\n",
  "INMESHING": "INMESH, to entangle, also ENMESH, EMMESH, IMMESH [v]\n",
  "INMIGRANT": "coming in from another area of the same country [adj] / an inmigrant person or animal, also IMMIGRANT [n -S]\n",
  "INMIGRANTS": "INMIGRANT, an inmigrant person or animal, also IMMIGRANT [n]\n",
  "INMOST": "farthest within [adj]\n",
  "INN": "to stay at a public lodging house [v -ED, -ING, -S]\n",
  "INNAGE": "the quantity of goods remaining in a container after shipment [n -S]\n",
  "INNAGES": "INNAGE, the quantity of goods remaining in a container after shipment [n]\n",
  "INNARDS": "the internal organs [n]\n",
  "INNATE": "inborn [adj INNATELY]\n",
  "INNATELY": "INNATE, inborn [adv]\n",
  "INNATENESS": "the quality of being innate [n -ES]\n",
  "INNATENESSES": "INNATENESS, the quality of being innate [n]\n",
  "INNATIVE": "native [adj]\n",
  "INNAVIGABLE": "that cannot be navigated [adj INNAVIGABLY]\n",
  "INNAVIGABLY": "INNAVIGABLE, that cannot be navigated [adv]\n",
  "INNED": "IN, to take in e.g. harvest [v]\n",
  "INNER": "interior [adj INNERLY] / in archery, a hit next to the bull [n -S]\n",
  "INNERLY": "more inward [adv]\n",
  "INNERMOST": "farthest in [adj] / an innermost thing [n -S]\n",
  "INNERMOSTS": "INNERMOST, an innermost thing [n]\n",
  "INNERNESS": "the state of being inner [n -ES]\n",
  "INNERNESSES": "INNERNESS, the state of being inner [n]\n",
  "INNERS": "INNER, in archery, a hit next to the bull [n]\n",
  "INNERSOLE": "an insole [n -S]\n",
  "INNERSOLES": "INNERSOLE, an insole [n]\n",
  "INNERSPRING": "having coil springs inside a padded casing [adj]\n",
  "INNERVATE": "to supply with nerves or a nervous stimulus, also INNERVE [v INNERVATED, INNERVATING, INNERVATES]\n",
  "INNERVATED": "INNERVATE, to supply with nerves or a nervous stimulus, also INNERVE [v]\n",
  "INNERVATES": "INNERVATE, to supply with nerves or a nervous stimulus, also INNERVE [v]\n",
  "INNERVATING": "INNERVATE, to supply with nerves or a nervous stimulus, also INNERVE [v]\n",
  "INNERVATION": "the state of being innervate [n -S]\n",
  "INNERVATIONS": "INNERVATION, the state of being innervate [n]\n",
  "INNERVE": "to supply with nerves or a nervous stimulus, also INNERVATE [v INNERVED, INNERVING, INNERVES]\n",
  "INNERVED": "INNERVE, to supply with nerves or a nervous stimulus, also INNERVATE [v]\n",
  "INNERVES": "INNERVE, to supply with nerves or a nervous stimulus, also INNERVATE [v]\n",
  "INNERVING": "INNERVE, to supply with nerves or a nervous stimulus, also INNERVATE [v]\n",
  "INNERWEAR": "underwear [n -S]\n",
  "INNERWEARS": "INNERWEAR, underwear [n]\n",
  "INNING": "in baseball, an innings, a turn at batting [n -S]\n",
  "INNINGS": "a team's or individual batsman's turn at batting in cricket, etc. [n -ES]\n",
  "INNINGSES": "INNINGS, a team's or individual batsman's turn at batting in cricket, etc. [n]\n",
  "INNIT": "an informal contraction of isn't it, used as a tag question [interj]\n",
  "INNKEEPER": "a person in charge of an inn [n -S]\n",
  "INNKEEPERS": "INNKEEPER, a person in charge of an inn [n]\n",
  "INNLESS": "without an inn [adj]\n",
  "INNOCENCE": "the quality of being innocent, also INNOCENCY [n -S]\n",
  "INNOCENCES": "INNOCENCE, the quality of being innocent, also INNOCENCY [n]\n",
  "INNOCENCIES": "INNOCENCY, (archaic) innocence, also INNOCENCE [n]\n",
  "INNOCENCY": "(archaic) innocence, also INNOCENCE [n INNOCENCIES]\n",
  "INNOCENT": "a person who is guileless [n -S] / free from moral wrong [adj INNOCENTER, INNOCENTEST, INNOCENTLY]\n",
  "INNOCENTER": "INNOCENT, free from moral wrong [adj]\n",
  "INNOCENTEST": "INNOCENT, free from moral wrong [adj]\n",
  "INNOCENTLY": "INNOCENT, free from moral wrong [adv]\n",
  "INNOCENTS": "INNOCENT, a person who is guileless [n]\n",
  "INNOCUITIES": "INNOCUITY, innocuousness [n]\n",
  "INNOCUITY": "innocuousness [n INNOCUITIES]\n",
  "INNOCUOUS": "harmless [adj INNOCUOUSLY]\n",
  "INNOCUOUSLY": "INNOCUOUS, harmless [adv]\n",
  "INNOCUOUSNESS": "INNOCUOUS, harmless [n]\n",
  "INNOCUOUSNESSES": "INNOCUOUSNESS, INNOCUOUS, harmless [n]\n",
  "INNOMINABLE": "(something) that cannot be named [n -S]\n",
  "INNOMINABLES": "(obsolete) trousers [n]\n",
  "INNOMINATE": "having no name [adj]\n",
  "INNOVATE": "to introduce something new [v INNOVATED, INNOVATING, INNOVATES]\n",
  "INNOVATED": "INNOVATE, to introduce something new [v]\n",
  "INNOVATES": "INNOVATE, to introduce something new [v]\n",
  "INNOVATING": "INNOVATE, to introduce something new [v]\n",
  "INNOVATION": "the introduction of something new [n -S]\n",
  "INNOVATIONAL": "relating to innovation [adj]\n",
  "INNOVATIONIST": "one who innovates [n -S]\n",
  "INNOVATIONISTS": "INNOVATIONIST, one who innovates [n]\n",
  "INNOVATIONS": "INNOVATION, the introduction of something new [n]\n",
  "INNOVATIVE": "characterized by innovation [adj INNOVATIVELY]\n",
  "INNOVATIVELY": "INNOVATIVE, characterized by innovation [adv]\n",
  "INNOVATIVENESS": "INNOVATIVE, characterized by innovation [n]\n",
  "INNOVATOR": "one who innovates [n -S]\n",
  "INNOVATORS": "INNOVATOR, one who innovates [n]\n",
  "INNOVATORY": "relating to innovation [adj]\n",
  "INNOXIOUS": "harmless [adj INNOXIOUSLY]\n",
  "INNOXIOUSLY": "INNOXIOUS, harmless [adv]\n",
  "INNOXIOUSNESS": "INNOXIOUS, harmless [n]\n",
  "INNOXIOUSNESSES": "INNOXIOUSNESS, INNOXIOUS, harmless [n]\n",
  "INNS": "INN, to stay at a public lodging house [v]\n",
  "INNUENDO": "an insinuation [n -ES or -S] / to make an innuendo [v -ED, -ING, -ES]\n",
  "INNUENDOED": "INNUENDO, to make an innuendo [v]\n",
  "INNUENDOES": "INNUENDO, to make an innuendo [v]\n",
  "INNUENDOING": "INNUENDO, to make an innuendo [v]\n",
  "INNUENDOS": "INNUENDO, an insinuation [n]\n",
  "INNUMERABILITY": "the quality of being innumerable [n]\n",
  "INNUMERABLE": "that cannot be counted, also INNUMEROUS [adj INNUMERABLY]\n",
  "INNUMERABLENESS": "INNUMERABLE, that cannot be counted, also INNUMEROUS [n]\n",
  "INNUMERABLY": "INNUMERABLE, that cannot be counted, also INNUMEROUS [adv]\n",
  "INNUMERACIES": "INNUMERACY, the state of being innumerate [n]\n",
  "INNUMERACY": "the state of being innumerate [n INNUMERACIES]\n",
  "INNUMERATE": "marked by an ignorance of mathematics and the scientific approach [adj] / one who is innumerate [n -S]\n",
  "INNUMERATES": "INNUMERATE, one who is innumerate [n]\n",
  "INNUMEROUS": "(archaic) innumerable, also INNUMERABLE [adj]\n",
  "INNUTRIENT": "not nutrient [adj]\n",
  "INNUTRITION": "lack of nutrition; the failure to give proper nourishment [n -S]\n",
  "INNUTRITIONS": "INNUTRITION, lack of nutrition; the failure to give proper nourishment [n]\n",
  "INNUTRITIOUS": "not nutritious [adj]\n",
  "INNYARD": "the courtyard surrounding an inn [n -S]\n",
  "INNYARDS": "INNYARD, the courtyard surrounding an inn [n]\n",
  "INOBEDIENCE": "disobedience [n -S]\n",
  "INOBEDIENCES": "INOBEDIENCE, disobedience [n]\n",
  "INOBEDIENT": "not obedient [adj INOBEDIENTLY]\n",
  "INOBEDIENTLY": "INOBEDIENT, not obedient [adv]\n",
  "INOBSERVABLE": "that cannot be observed [adj]\n",
  "INOBSERVANCE": "lack of attention [n -S]\n",
  "INOBSERVANCES": "INOBSERVANCE, lack of attention [n]\n",
  "INOBSERVANT": "not observant [adj INOBSERVANTLY]\n",
  "INOBSERVANTLY": "INOBSERVANT, not observant [adv]\n",
  "INOBSERVATION": "lack of observation [n -S]\n",
  "INOBSERVATIONS": "INOBSERVATION, lack of observation [n]\n",
  "INOBTRUSIVE": "not obtrusive, also UNOBTRUSIVE [adj INOBTRUSIVELY]\n",
  "INOBTRUSIVELY": "INOBTRUSIVE, not obtrusive, also UNOBTRUSIVE [adv]\n",
  "INOBTRUSIVENESS": "INOBTRUSIVE, not obtrusive, also UNOBTRUSIVE [n]\n",
  "INOCCUPATION": "lack of occupation [n -S]\n",
  "INOCCUPATIONS": "INOCCUPATION, lack of occupation [n]\n",
  "INOCULA": "INOCULUM, (Latin) the material used in an inoculation [n]\n",
  "INOCULABILITIES": "INOCULABILITY, the quality of being inoculable [n]\n",
  "INOCULABILITY": "the quality of being inoculable [n INOCULABILITIES]\n",
  "INOCULABLE": "capable of being inoculated [adj]\n",
  "INOCULANT": "any material used in inoculation, also INOCULUM [n -S]\n",
  "INOCULANTS": "INOCULANT, any material used in inoculation, also INOCULUM [n]\n",
  "INOCULATE": "to introduce (e.g. bacteria, a virus) into an organism [v INOCULATED, INOCULATING, INOCULATES]\n",
  "INOCULATED": "INOCULATE, to introduce (e.g. bacteria, a virus) into an organism [v]\n",
  "INOCULATES": "INOCULATE, to introduce (e.g. bacteria, a virus) into an organism [v]\n",
  "INOCULATING": "INOCULATE, to introduce (e.g. bacteria, a virus) into an organism [v]\n",
  "INOCULATION": "the act of inoculating [n -S]\n",
  "INOCULATIONS": "INOCULATION, the act of inoculating [n]\n",
  "INOCULATIVE": "serving to inoculate [adj]\n",
  "INOCULATOR": "one who inoculates [n -S]\n",
  "INOCULATORS": "INOCULATOR, one who inoculates [n]\n",
  "INOCULATORY": "relating to inoculation [adj]\n",
  "INOCULUM": "(Latin) the material used in an inoculation [n INOCULUMS or INOCULA]\n",
  "INOCULUMS": "INOCULUM, (Latin) the material used in an inoculation [n]\n",
  "INODOROUS": "emitting no odor [adj INODOROUSLY]\n",
  "INODOROUSLY": "INODOROUS, emitting no odor [adv]\n",
  "INODOROUSNESS": "INODOROUS, emitting no odor [n]\n",
  "INODOROUSNESSES": "INODOROUSNESS, INODOROUS, emitting no odor [n]\n",
  "INOFFENSIVE": "causing no harm or injury, also UNOFFENSIVE [adj INOFFENSIVELY]\n",
  "INOFFENSIVELY": "INOFFENSIVE, causing no harm or injury, also UNOFFENSIVE [adv]\n",
  "INOFFENSIVENESS": "INOFFENSIVE, causing no harm or injury, also UNOFFENSIVE [n]\n",
  "INOFFICIOUS": "not officious [adj INOFFICIOUSLY]\n",
  "INOFFICIOUSLY": "INOFFICIOUS, not officious [adv]\n",
  "INOFFICIOUSNESS": "INOFFICIOUS, not officious [n]\n",
  "INOPERABILITIES": "INOPERABILITY, the quality of being inoperable [n]\n",
  "INOPERABILITY": "the quality of being inoperable [n INOPERABILITIES]\n",
  "INOPERABLE": "that cannot be operated upon [adj INOPERABLY]\n",
  "INOPERABLENESS": "INOPERABLE, that cannot be operated upon [n]\n",
  "INOPERABLY": "INOPERABLE, that cannot be operated upon [adv]\n",
  "INOPERATIVE": "not operative [adj]\n",
  "INOPERATIVENESS": "INOPERATIVE, not operative [n]\n",
  "INOPERCULATE": "something without an operculum or lid [n -S]\n",
  "INOPERCULATES": "INOPERCULATE, something without an operculum or lid [n]\n",
  "INOPINATE": "(obsolete) not thought of; unexpected [adj]\n",
  "INOPPORTUNE": "inconvenient, unseasonable [adj INOPPORTUNELY]\n",
  "INOPPORTUNELY": "INOPPORTUNE, inconvenient, unseasonable [adv]\n",
  "INOPPORTUNENESS": "INOPPORTUNE, inconvenient, unseasonable [n]\n",
  "INOPPORTUNITIES": "INOPPORTUNITY, the state of being inopportune [n]\n",
  "INOPPORTUNITY": "the state of being inopportune [n INOPPORTUNITIES]\n",
  "INORB": "to set in an orb, to encircle [v -ED, -ING, -S]\n",
  "INORBED": "INORB, to set in an orb, to encircle [v]\n",
  "INORBING": "INORB, to set in an orb, to encircle [v]\n",
  "INORBS": "INORB, to set in an orb, to encircle [v]\n",
  "INORDINACIES": "INORDINACY, the quality of being inordinate [n]\n",
  "INORDINACY": "the quality of being inordinate [n INORDINACIES]\n",
  "INORDINATE": "exceeding reasonable limits [adj INORDINATELY]\n",
  "INORDINATELY": "INORDINATE, exceeding reasonable limits [adv]\n",
  "INORDINATENESS": "INORDINATE, exceeding reasonable limits [n]\n",
  "INORDINATION": "deviation from rule; irregularity [n -S]\n",
  "INORDINATIONS": "INORDINATION, deviation from rule; irregularity [n]\n",
  "INORGANIC": "not organic [adj INORGANICALLY] / an inorganic substance [n -S]\n",
  "INORGANICALLY": "INORGANIC, not organic [adv]\n",
  "INORGANICS": "INORGANIC, an inorganic substance [n]\n",
  "INORGANISATION": "lack of organisation, also INORGANIZATION [n -S]\n",
  "INORGANISATIONS": "INORGANISATION, lack of organisation, also INORGANIZATION [n]\n",
  "INORGANISED": "not organised, also INORGANIZED [adj]\n",
  "INORGANIZATION": "lack of organisation, also INORGANISATION [n -S]\n",
  "INORGANIZATIONS": "INORGANIZATION, lack of organisation, also INORGANISATION [n]\n",
  "INORGANIZED": "not organized, also INORGANISED [adj]\n",
  "INORNATE": "not ornate, also UNORNATE [adj]\n",
  "INOSCULATE": "to join or unite [v INOSCULATED, INOSCULATING, INOSCULATES]\n",
  "INOSCULATED": "INOSCULATE, to join or unite [v]\n",
  "INOSCULATES": "INOSCULATE, to join or unite [v]\n",
  "INOSCULATING": "INOSCULATE, to join or unite [v]\n",
  "INOSCULATION": "the act of inosculating, joining [n -S]\n",
  "INOSCULATIONS": "INOSCULATION, the act of inosculating, joining [n]\n",
  "INOSILICATE": "a class of polymeric silicates [n -S]\n",
  "INOSILICATES": "INOSILICATE, a class of polymeric silicates [n]\n",
  "INOSINE": "a compound of hypoxanthine and ribose [n -S]\n",
  "INOSINES": "INOSINE, a compound of hypoxanthine and ribose [n]\n",
  "INOSITE": "an alcohol found in plant and animal tissue, also INOSITOL [n -S]\n",
  "INOSITES": "INOSITE, an alcohol found in plant and animal tissue, also INOSITOL [n]\n",
  "INOSITOL": "an alcohol found in plant and animal tissue, also INOSITE [n -S]\n",
  "INOSITOLS": "INOSITOL, an alcohol found in plant and animal tissue, also INOSITE [n]\n",
  "INOTROPE": "a drug for controlling the force of muscular contractions [n -S]\n",
  "INOTROPES": "INOTROPE, a drug for controlling the force of muscular contractions [n]\n",
  "INOTROPIC": "affecting or controlling muscular contraction, esp. of the heart [adj]\n",
  "INPATIENT": "a patient living and being treated in a hospital [n -S]\n",
  "INPATIENTS": "INPATIENT, a patient living and being treated in a hospital [n]\n",
  "INPAYMENT": "the payment of money into a bank account [n -S]\n",
  "INPAYMENTS": "INPAYMENT, the payment of money into a bank account [n]\n",
  "INPHASE": "having matching electrical phases [adj]\n",
  "INPOUR": "to pour in [v -ED, -ING, -S]\n",
  "INPOURED": "INPOUR, to pour in [v]\n",
  "INPOURING": "the act of pouring in [n -S]\n",
  "INPOURINGS": "INPOURING, the act of pouring in [n]\n",
  "INPOURS": "INPOUR, to pour in [v]\n",
  "INPUT": "to enter data into a computer [v INPUTTED, INPUTTING, INPUTS]\n",
  "INPUTS": "INPUT, to enter data into a computer [v]\n",
  "INPUTTED": "INPUT, to enter data into a computer [v]\n",
  "INPUTTER": "someone who feeds in information [n -S]\n",
  "INPUTTERS": "INPUTTER, someone who feeds in information [n]\n",
  "INPUTTING": "INPUT, to enter data into a computer [v]\n",
  "INQILAB": "(Urdu) in India, Pakistan etc., a revolution [n -S]\n",
  "INQILABS": "INQILAB, (Urdu) in India, Pakistan etc., a revolution [n]\n",
  "INQUERE": "(Spenser) to ask about, inquire [v INQUERED, INQUERING, INQUERES]\n",
  "INQUERED": "INQUERE, (Spenser) to ask about, inquire [v]\n",
  "INQUERES": "INQUERE, (Spenser) to ask about, inquire [v]\n",
  "INQUERING": "INQUERE, (Spenser) to ask about, inquire [v]\n",
  "INQUEST": "a legal inquiry [n -S]\n",
  "INQUESTS": "INQUEST, a legal inquiry [n]\n",
  "INQUIET": "not quiet [adj INQUIETLY] / to disturb [v -ED, -ING, -S]\n",
  "INQUIETED": "INQUIET, to disturb [v]\n",
  "INQUIETING": "INQUIET, to disturb [v]\n",
  "INQUIETLY": "INQUIET, not quiet [adv]\n",
  "INQUIETS": "INQUIET, to disturb [v]\n",
  "INQUIETUDE": "a disturbed state [n -S]\n",
  "INQUIETUDES": "INQUIETUDE, a disturbed state [n]\n",
  "INQUILINE": "living with another [adj] / a creature dwelling in another creature's lair, also INQUILINIC [n -S]\n",
  "INQUILINES": "INQUILINE, a creature dwelling in another creature's lair, also INQUILINIC [n]\n",
  "INQUILINIC": "living with another [adj] / a creature dwelling in another creature's lair, also INQUILINE [n -S]\n",
  "INQUILINICS": "INQUILINIC, a creature dwelling in another creature's lair, also INQUILINE [n]\n",
  "INQUILINISM": "living in another's nest [n -S]\n",
  "INQUILINISMS": "INQUILINISM, living in another's nest [n]\n",
  "INQUILINITIES": "INQUILINITY, living in another's nest [n]\n",
  "INQUILINITY": "living in another's nest [n INQUILINITIES]\n",
  "INQUILINOUS": "living in another's nest [adj]\n",
  "INQUINATE": "to corrupt or defile [v INQUINATED, INQUINATING, INQUINATES]\n",
  "INQUINATED": "INQUINATE, to corrupt or defile [v]\n",
  "INQUINATES": "INQUINATE, to corrupt or defile [v]\n",
  "INQUINATING": "INQUINATE, to corrupt or defile [v]\n",
  "INQUINATION": "the act of inquinating [n -S]\n",
  "INQUINATIONS": "INQUINATION, the act of inquinating [n]\n",
  "INQUIRATION": "(Dickens) inquiry, also ENQUIRATION [n -S]\n",
  "INQUIRATIONS": "INQUIRATION, (Dickens) inquiry, also ENQUIRATION [n]\n",
  "INQUIRE": "to ask about, also ENQUIRE [v INQUIRED, INQUIRING, INQUIRES]\n",
  "INQUIRED": "INQUIRE, to ask about, also ENQUIRE [v]\n",
  "INQUIRENDO": "the authority to inquire into something e.g. for the benefit of the Crown [n -S]\n",
  "INQUIRENDOS": "INQUIRENDO, the authority to inquire into something e.g. for the benefit of the Crown [n]\n",
  "INQUIRER": "one who enquires, also ENQUIRER [n -S]\n",
  "INQUIRERS": "INQUIRER, one who enquires, also ENQUIRER [n]\n",
  "INQUIRES": "INQUIRE, to ask about, also ENQUIRE [v]\n",
  "INQUIRIES": "INQUIRY, a question, also ENQUIRY [n]\n",
  "INQUIRING": "INQUIRE, to ask about, also ENQUIRE [v]\n",
  "INQUIRINGLY": "INQUIRING, INQUIRE, to ask about, also ENQUIRE [adv]\n",
  "INQUIRY": "a question, also ENQUIRY [n INQUIRIES]\n",
  "INQUISITION": "the act of inquiring [n -S]\n",
  "INQUISITIONAL": "relating to inquisition [adj]\n",
  "INQUISITIONIST": "one who carries out an inquisition [n -S]\n",
  "INQUISITIONISTS": "INQUISITIONIST, one who carries out an inquisition [n]\n",
  "INQUISITIONS": "INQUISITION, the act of inquiring [n]\n",
  "INQUISITIVE": "given to examination or investigation [adj INQUISITIVELY]\n",
  "INQUISITIVELY": "INQUISITIVE, given to examination or investigation [adv]\n",
  "INQUISITIVENESS": "the state of being inquisitive [n]\n",
  "INQUISITOR": "one who inquires or makes inquisition [n -S]\n",
  "INQUISITORIAL": "of or like an inquisitor [adj INQUISITORIALLY]\n",
  "INQUISITORIALLY": "INQUISITORIAL, of or like an inquisitor [adv]\n",
  "INQUISITORS": "INQUISITOR, one who inquires or makes inquisition [n]\n",
  "INQUISITRESS": "(archaic) a female inquisitor [n -ES]\n",
  "INQUISITRESSES": "INQUISITRESS, (archaic) a female inquisitor [n]\n",
  "INQUISITURIENT": "(Milton) eager to act as an inquisitor [adj]\n",
  "INQUORATE": "of the attendance at a meeting, not making up a quorum [adj]\n",
  "INRO": "(Japanese) an ornamental container for pills and medicines [n INRO]\n",
  "INROAD": "a hostile invasion [n -S]\n",
  "INROADS": "INROAD, a hostile invasion [n]\n",
  "INRUN": "the approach ramp of a ski jump [n -S]\n",
  "INRUNS": "INRUN, the approach ramp of a ski jump [n]\n",
  "INRUSH": "a rushing in [n -ES]\n",
  "INRUSHES": "INRUSH, a rushing in [n]\n",
  "INRUSHING": "the act of rushing in, also INRUSH [n -S]\n",
  "INRUSHINGS": "INRUSHING, the act of rushing in, also INRUSH [n]\n",
  "INS": "IN, to take in e.g. harvest [v]\n",
  "INSALIVATE": "to mix with saliva [v INSALIVATED, INSALIVATING, INSALIVATES]\n",
  "INSALIVATED": "INSALIVATE, to mix with saliva [v]\n",
  "INSALIVATES": "INSALIVATE, to mix with saliva [v]\n",
  "INSALIVATING": "INSALIVATE, to mix with saliva [v]\n",
  "INSALIVATION": "the act of insalivating, mixing with saliva [n -S]\n",
  "INSALIVATIONS": "INSALIVATION, the act of insalivating, mixing with saliva [n]\n",
  "INSALUBRIOUS": "unhealthy, deleterious [adj INSALUBRIOUSLY]\n",
  "INSALUBRIOUSLY": "INSALUBRIOUS, unhealthy, deleterious [adv]\n",
  "INSALUBRITIES": "INSALUBRITY, the state of being insalubrious [n]\n",
  "INSALUBRITY": "the state of being insalubrious [n INSALUBRITIES]\n",
  "INSALUTARY": "not salutary or wholesome; unfavorable to health [adj]\n",
  "INSANE": "mentally unsound [adj INSANER, INSANEST, INSANELY]\n",
  "INSANELY": "INSANE, mentally unsound [adv]\n",
  "INSANENESS": "insanity, madness [n -ES]\n",
  "INSANENESSES": "INSANENESS, insanity, madness [n]\n",
  "INSANER": "INSANE, mentally unsound [adj]\n",
  "INSANEST": "INSANE, mentally unsound [adj]\n",
  "INSANIE": "(Shakespeare) insanity [n -S]\n",
  "INSANIES": "INSANIE, (Shakespeare) insanity [n]\n",
  "INSANITARINESS": "the state of being insanitary [n]\n",
  "INSANITARY": "not sanitary [adj]\n",
  "INSANITATION": "lack of sanitation [n -S]\n",
  "INSANITATIONS": "INSANITATION, lack of sanitation [n]\n",
  "INSANITIES": "INSANITY, the state of being insane [n]\n",
  "INSANITY": "the state of being insane [n INSANITIES]\n",
  "INSATIABILITIES": "INSATIABILITY, the state of being insatiable [n]\n",
  "INSATIABILITY": "the state of being insatiable [n INSATIABILITIES]\n",
  "INSATIABLE": "that cannot be satiated [adj INSATIABLY]\n",
  "INSATIABLENESS": "the state of being insatiable [n]\n",
  "INSATIABLY": "INSATIABLE, that cannot be satiated [adv]\n",
  "INSATIATE": "insatiable; as, insatiate thirst [adj INSATIATELY]\n",
  "INSATIATELY": "INSATIATE, insatiable; as, insatiate thirst [adv]\n",
  "INSATIATENESS": "the state of being insatiate [n -ES]\n",
  "INSATIATENESSES": "INSATIATENESS, the state of being insatiate [n]\n",
  "INSATIETIES": "INSATIETY, insatiableness [n]\n",
  "INSATIETY": "insatiableness [n INSATIETIES]\n",
  "INSCAPE": "the essential inner nature of persons, objects etc. [n -S]\n",
  "INSCAPES": "INSCAPE, the essential inner nature of persons, objects etc. [n]\n",
  "INSCIENCE": "want of knowledge; ignorance [n -S]\n",
  "INSCIENCES": "INSCIENCE, want of knowledge; ignorance [n]\n",
  "INSCIENT": "(archaic) having little or no knowledge [adj]\n",
  "INSCONCE": "(Shakespeare) to settle comfortably, also ENSCONCE [v INSCONCED, INSCONCING, INSCONCES]\n",
  "INSCONCED": "INSCONCE, (Shakespeare) to settle comfortably, also ENSCONCE [v]\n",
  "INSCONCES": "INSCONCE, (Shakespeare) to settle comfortably, also ENSCONCE [v]\n",
  "INSCONCING": "INSCONCE, (Shakespeare) to settle comfortably, also ENSCONCE [v]\n",
  "INSCRIBABLE": "that can be inscribed [adj]\n",
  "INSCRIBABLENESS": "the state of being inscribable [n]\n",
  "INSCRIBE": "to write or engrave as a lasting record [v INSCRIBED, INSCRIBING, INSCRIBES]\n",
  "INSCRIBED": "INSCRIBE, to write or engrave as a lasting record [v]\n",
  "INSCRIBER": "one who inscribes [n -S]\n",
  "INSCRIBERS": "INSCRIBER, one who inscribes [n]\n",
  "INSCRIBES": "INSCRIBE, to write or engrave as a lasting record [v]\n",
  "INSCRIBING": "INSCRIBE, to write or engrave as a lasting record [v]\n",
  "INSCRIPTION": "something that is inscribed [n -S]\n",
  "INSCRIPTIONAL": "relating to inscription [adj]\n",
  "INSCRIPTIONS": "INSCRIPTION, something that is inscribed [n]\n",
  "INSCRIPTIVE": "relating to or constituting an inscription [adj INSCRIPTIVELY]\n",
  "INSCRIPTIVELY": "INSCRIPTIVE, relating to or constituting an inscription [adv]\n",
  "INSCROLL": "(Shakespeare) to write on a scroll, also ENSCROLL [v -ED, -ING, -S]\n",
  "INSCROLLED": "INSCROLL, (Shakespeare) to write on a scroll, also ENSCROLL [v]\n",
  "INSCROLLING": "INSCROLL, (Shakespeare) to write on a scroll, also ENSCROLL [v]\n",
  "INSCROLLS": "INSCROLL, (Shakespeare) to write on a scroll, also ENSCROLL [v]\n",
  "INSCRUTABILITY": "the state of being inscrutable [n]\n",
  "INSCRUTABLE": "that cannot be scrutinized or searched into [adj INSCRUTABLY]\n",
  "INSCRUTABLENESS": "the state of being inscrutable [n]\n",
  "INSCRUTABLY": "INSCRUTABLE, that cannot be scrutinized or searched into [adv]\n",
  "INSCULP": "to engrave, to cut or carve from something [v INSCULPED or (Shakespeare) INSCULPT, INSCULPING, INSCULPS]\n",
  "INSCULPED": "INSCULP, to engrave, to cut or carve from something [v]\n",
  "INSCULPING": "INSCULP, to engrave, to cut or carve from something [v]\n",
  "INSCULPS": "INSCULP, to engrave, to cut or carve from something [v]\n",
  "INSCULPT": "engraved [adj]\n",
  "INSCULPTURE": "(archaic) an inscription; anything engraved [n -S] / to carve on something [v INSCULPTURED, INSCULPTURING, INSCULPTURES]\n",
  "INSCULPTURED": "INSCULPTURE, to carve on something [v]\n",
  "INSCULPTURES": "INSCULPTURE, to carve on something [v]\n",
  "INSCULPTURING": "INSCULPTURE, to carve on something [v]\n",
  "INSEAM": "to cover with grease, also ENSEAM, INSEEM [v -ED, -ING, -S]\n",
  "INSEAMED": "INSEAM, to cover with grease, also ENSEAM, INSEEM [v]\n",
  "INSEAMING": "INSEAM, to cover with grease, also ENSEAM, INSEEM [v]\n",
  "INSEAMS": "INSEAM, to cover with grease, also ENSEAM, INSEEM [v]\n",
  "INSECT": "a word loosely used for a small invertebrate creature, esp. one with a body divided into sections; in zoological terms, a member of the Insecta [n -S]\n",
  "INSECTAN": "pertaining to insects, also INSECTEAN [adj]\n",
  "INSECTARIA": "INSECTARIUM, a place for keeping living insects, also INSECTARY [n]\n",
  "INSECTARIES": "INSECTARY, a place for keeping living insects, also INSECTARIUM [n]\n",
  "INSECTARIUM": "a place for keeping living insects, also INSECTARY [n INSECTARIA or INSECTARIUMS]\n",
  "INSECTARIUMS": "INSECTARIUM, a place for keeping living insects, also INSECTARY [n]\n",
  "INSECTARY": "a place for keeping living insects, also INSECTARIUM [n INSECTARIES]\n",
  "INSECTEAN": "pertaining to insects, also INSECTAN [adj]\n",
  "INSECTICIDAL": "destroying or controlling insects [adj INSECTICIDALLY]\n",
  "INSECTICIDALLY": "INSECTICIDAL, destroying or controlling insects [adv]\n",
  "INSECTICIDE": "an agent that destroys insects [n -S]\n",
  "INSECTICIDES": "INSECTICIDE, an agent that destroys insects [n]\n",
  "INSECTIFORM": "having the form of an insect [adj]\n",
  "INSECTIFUGE": "insect repellent [n -S]\n",
  "INSECTIFUGES": "INSECTIFUGE, insect repellent [n]\n",
  "INSECTILE": "pertaining to, or having the nature of, insects [adj]\n",
  "INSECTION": "a cutting in, an incision [n -S]\n",
  "INSECTIONS": "INSECTION, a cutting in, an incision [n]\n",
  "INSECTIVORE": "an animal that eats insects [n -S]\n",
  "INSECTIVORES": "INSECTIVORE, an animal that eats insects [n]\n",
  "INSECTIVOROUS": "eating insects [adj]\n",
  "INSECTOLOGIES": "INSECTOLOGY, the study of insects [n]\n",
  "INSECTOLOGIST": "a student of insectology [n -S]\n",
  "INSECTOLOGISTS": "INSECTOLOGIST, a student of insectology [n]\n",
  "INSECTOLOGY": "the study of insects [n INSECTOLOGIES]\n",
  "INSECTS": "INSECT, a word loosely used for a small invertebrate creature, esp. one with a body divided into sections; in zoological terms, a member of the Insecta [n]\n",
  "INSECURE": "not safe [adj INSECURER, INSECUREST; INSECURELY]\n",
  "INSECURELY": "INSECURE, not safe [adv]\n",
  "INSECURENESS": "the state of being insecure [n -ES]\n",
  "INSECURENESSES": "INSECURENESS, the state of being insecure [n]\n",
  "INSECURER": "INSECURE, not safe [adj]\n",
  "INSECUREST": "INSECURE, not safe [adj]\n",
  "INSECURITIES": "INSECURITY, the state of being insecure [n]\n",
  "INSECURITY": "the state of being insecure [n INSECURITIES]\n",
  "INSEEM": "(Shakespeare) to grease, defile, also ENSEAM, INSEAM [v -ED, -ING, -S]\n",
  "INSEEMED": "INSEEM, (Shakespeare) to grease, defile, also ENSEAM, INSEAM [v]\n",
  "INSEEMING": "INSEEM, (Shakespeare) to grease, defile, also ENSEAM, INSEAM [v]\n",
  "INSEEMS": "INSEEM, (Shakespeare) to grease, defile, also ENSEAM, INSEAM [v]\n",
  "INSELBERG": "(German) an isolated mountain or hill rising abruptly from its surrounding, aka monadnock [n INSELBERGE or INSELBERGS]\n",
  "INSELBERGE": "INSELBERG, (German) an isolated mountain or hill rising abruptly from its surrounding, aka monadnock [n]\n",
  "INSELBERGS": "INSELBERG, (German) an isolated mountain or hill rising abruptly from its surrounding, aka monadnock [n]\n",
  "INSEMINATE": "to sow; to impregnate [v INSEMINATED, INSEMINATING, INSEMINATES]\n",
  "INSEMINATED": "INSEMINATE, to sow; to impregnate [v]\n",
  "INSEMINATES": "INSEMINATE, to sow; to impregnate [v]\n",
  "INSEMINATING": "INSEMINATE, to sow; to impregnate [v]\n",
  "INSEMINATION": "the act of inseminating [n -S]\n",
  "INSEMINATIONS": "INSEMINATION, the act of inseminating [n]\n",
  "INSEMINATOR": "one that inseminates cattle artificially [n -S]\n",
  "INSEMINATORS": "INSEMINATOR, one that inseminates cattle artificially [n]\n",
  "INSENSATE": "without sensation, inanimate [adj INSENSATELY]\n",
  "INSENSATELY": "INSENSATE, without sensation, inanimate [adv]\n",
  "INSENSATENESS": "INSENSATE, without sensation, inanimate [n]\n",
  "INSENSATENESSES": "INSENSATENESS, INSENSATE, without sensation, inanimate [n]\n",
  "INSENSIBILITIES": "INSENSIBILITY, the state of being insensible [n]\n",
  "INSENSIBILITY": "the state of being insensible [n INSENSIBILITIES]\n",
  "INSENSIBLE": "imperceptible [adj INSENSIBLY]\n",
  "INSENSIBLENESS": "the state of being insensible [n]\n",
  "INSENSIBLY": "INSENSIBLE, imperceptible [adv]\n",
  "INSENSITIVE": "not responsive or susceptible, also UNSENSITIVE [adj INSENSITIVELY]\n",
  "INSENSITIVELY": "INSENSITIVE, not responsive or susceptible, also UNSENSITIVE [adv]\n",
  "INSENSITIVENESS": "INSENSITIVE, not responsive or susceptible, also UNSENSITIVE [n]\n",
  "INSENSITIVITIES": "INSENSITIVITY, the state of being insensitive [n]\n",
  "INSENSITIVITY": "the state of being insensitive [n INSENSITIVITIES]\n",
  "INSENSUOUS": "not sensuous [adj]\n",
  "INSENTIENCE": "the state of being insentient, also INSENTIENCY [n -S]\n",
  "INSENTIENCES": "INSENTIENCE, the state of being insentient, also INSENTIENCY [n]\n",
  "INSENTIENCIES": "INSENTIENCY, the state of being insentient, also INSENTIENCE [n]\n",
  "INSENTIENCY": "the state of being insentient, also INSENTIENCE [n INSENTIENCIES]\n",
  "INSENTIENT": "not sentient [adj]\n",
  "INSEPARABILITY": "the state of being inseparable [n]\n",
  "INSEPARABLE": "that cannot be separated, also UNSEPARABLE [adj INSEPARABLY] / something that cannot be separated [n -S]\n",
  "INSEPARABLENESS": "the state of being inseparable [n]\n",
  "INSEPARABLES": "INSEPARABLE, something that cannot be separated [n]\n",
  "INSEPARABLY": "INSEPARABLE, that cannot be separated, also UNSEPARABLE [adv]\n",
  "INSEPARATE": "(archaic) not separate [adj]\n",
  "INSERT": "to put in [v -ED, -ING, -S]\n",
  "INSERTABLE": "capable of being inserted [adj]\n",
  "INSERTED": "INSERT, to put in [v]\n",
  "INSERTER": "one who inserts [n -S]\n",
  "INSERTERS": "INSERTER, one who inserts [n]\n",
  "INSERTING": "INSERT, to put in [v]\n",
  "INSERTION": "the act of inserting [n -S]\n",
  "INSERTIONAL": "relating to insertion [adj]\n",
  "INSERTIONS": "INSERTION, the act of inserting [n]\n",
  "INSERTS": "INSERT, to put in [v]\n",
  "INSESSORIAL": "adapted for perching [adj]\n",
  "INSET": "to set in, in fix [v INSET or INSETTED, INSETTING, INSETS]\n",
  "INSETS": "INSET, to set in, in fix [v]\n",
  "INSETTED": "INSET, to set in, in fix [v]\n",
  "INSETTER": "a person who or thing which insets pages etc. [n -S]\n",
  "INSETTERS": "INSETTER, a person who or thing which insets pages etc. [n]\n",
  "INSETTING": "INSET, to set in, in fix [v]\n",
  "INSEVERABLE": "that cannot be severed [adj]\n",
  "INSHALLAH": "(Arabic) an interjection among Muslims, if Allah wills [interj]\n",
  "INSHEATH": "to enclose in a sheath, also ENSHEATH [v -ED, -ING, -S]\n",
  "INSHEATHE": "to insert as in a sheath, also ENSHEATH, ENSHEATHE, INSHEATH [v INSHEATHED, INSHEATHING, INSHEATHES]\n",
  "INSHEATHED": "INSHEATH, to enclose in a sheath, also ENSHEATH [v]\n",
  "INSHEATHES": "INSHEATHE, to insert as in a sheath, also ENSHEATH, ENSHEATHE, INSHEATH [v]\n",
  "INSHEATHING": "INSHEATH, to enclose in a sheath, also ENSHEATH [v]\n",
  "INSHEATHS": "INSHEATH, to enclose in a sheath, also ENSHEATH [v]\n",
  "INSHELL": "(Shakespeare) to enclose in a shell, also ENSHELL [v -ED, -ING, -S]\n",
  "INSHELLED": "INSHELL, (Shakespeare) to enclose in a shell, also ENSHELL [v]\n",
  "INSHELLING": "INSHELL, (Shakespeare) to enclose in a shell, also ENSHELL [v]\n",
  "INSHELLS": "INSHELL, (Shakespeare) to enclose in a shell, also ENSHELL [v]\n",
  "INSHELTER": "to place in shelter [v -ED, -ING, -S]\n",
  "INSHELTERED": "INSHELTER, to place in shelter [v]\n",
  "INSHELTERING": "INSHELTER, to place in shelter [v]\n",
  "INSHELTERS": "INSHELTER, to place in shelter [v]\n",
  "INSHIP": "(Shakespeare) to take ship [v INSHIPPED, INSHIPPING, INSHIPS]\n",
  "INSHIPPED": "INSHIP, (Shakespeare) to take ship [v]\n",
  "INSHIPPING": "INSHIP, (Shakespeare) to take ship [v]\n",
  "INSHIPS": "INSHIP, (Shakespeare) to take ship [v]\n",
  "INSHORE": "belonging to the region near the shore [adj]\n",
  "INSHRINE": "to place in a shrine, also ENSHRINE [v INSHRINED, INSHRINING, INSHRINES]\n",
  "INSHRINED": "INSHRINE, to place in a shrine, also ENSHRINE [v]\n",
  "INSHRINEMENT": "the act of inshrining, also ENSHRINEMENT [n -S]\n",
  "INSHRINEMENTS": "INSHRINEMENT, the act of inshrining, also ENSHRINEMENT [n]\n",
  "INSHRINES": "INSHRINE, to place in a shrine, also ENSHRINE [v]\n",
  "INSHRINING": "INSHRINE, to place in a shrine, also ENSHRINE [v]\n",
  "INSIDE": "the part within [n -S]\n",
  "INSIDER": "an accepted member of a group [n -S]\n",
  "INSIDERS": "INSIDER, an accepted member of a group [n]\n",
  "INSIDES": "INSIDE, the part within [n]\n",
  "INSIDIOUS": "developing or advancing gradually and imperceptibly [adj INSIDIOUSLY]\n",
  "INSIDIOUSLY": "INSIDIOUS, developing or advancing gradually and imperceptibly [adv]\n",
  "INSIDIOUSNESS": "INSIDIOUS, developing or advancing gradually and imperceptibly [n]\n",
  "INSIDIOUSNESSES": "INSIDIOUSNESS, INSIDIOUS, developing or advancing gradually and imperceptibly [n]\n",
  "INSIGHT": "a perception of the inner nature of things [n -S]\n",
  "INSIGHTFUL": "exhibiting or characterized by insight [adj INSIGHTFULLY]\n",
  "INSIGHTFULLY": "INSIGHTFUL, exhibiting or characterized by insight [adv]\n",
  "INSIGHTS": "INSIGHT, a perception of the inner nature of things [n]\n",
  "INSIGNE": "(French) a sign of membership or honour [n INSIGNIA]\n",
  "INSIGNIA": "a sign of membership or honour [n INSIGNIAS]\n",
  "INSIGNIAS": "INSIGNIA, a sign of membership or honour [n]\n",
  "INSIGNIFICANCE": "the state of being insignificant, also INSIGNIFICANCY [n -S]\n",
  "INSIGNIFICANCES": "INSIGNIFICANCE, the state of being insignificant, also INSIGNIFICANCY [n]\n",
  "INSIGNIFICANCY": "the state of being insignificant, also INSIGNIFICANCE [n]\n",
  "INSIGNIFICANT": "not significant [adj INSIGNIFICANTLY]\n",
  "INSIGNIFICANTLY": "INSIGNIFICANT, not significant [adv]\n",
  "INSIGNIFICATIVE": "not significative or expressing by external signs [adj]\n",
  "INSINCERE": "not sincere [adj INSINCERER, INSINCEREST; INSINCERELY]\n",
  "INSINCERELY": "INSINCERE, not sincere [adv]\n",
  "INSINCERER": "INSINCERE, not sincere [adj]\n",
  "INSINCEREST": "INSINCERE, not sincere [adj]\n",
  "INSINCERITIES": "INSINCERITY, the state of being insincere [n]\n",
  "INSINCERITY": "the state of being insincere [n INSINCERITIES]\n",
  "INSINEW": "(Shakespeare) to be joined as with sinews [v -ED, -ING, -S]\n",
  "INSINEWED": "INSINEW, (Shakespeare) to be joined as with sinews [v]\n",
  "INSINEWING": "INSINEW, (Shakespeare) to be joined as with sinews [v]\n",
  "INSINEWS": "INSINEW, (Shakespeare) to be joined as with sinews [v]\n",
  "INSINUATE": "to hint or indirectly suggest [v INSINUATED, INSINUATING, INSINUATES]\n",
  "INSINUATED": "INSINUATE, to hint or indirectly suggest [v]\n",
  "INSINUATES": "INSINUATE, to hint or indirectly suggest [v]\n",
  "INSINUATING": "INSINUATE, to hint or indirectly suggest [v]\n",
  "INSINUATINGLY": "INSINUATING, INSINUATE, to hint or indirectly suggest [adv]\n",
  "INSINUATION": "the act of insinuating [n -S]\n",
  "INSINUATIONS": "INSINUATION, the act of insinuating [n]\n",
  "INSINUATIVE": "serving to insinuate [adj]\n",
  "INSINUATOR": "one who, or that which, insinuates [n -S]\n",
  "INSINUATORS": "INSINUATOR, one who, or that which, insinuates [n]\n",
  "INSINUATORY": "tending to insinuate, insinuative [adj]\n",
  "INSIPID": "dull and uninteresting [adj INSIPIDER, INSIPIDEST; INSIPIDLY]\n",
  "INSIPIDER": "INSIPID, dull and uninteresting [adj]\n",
  "INSIPIDEST": "INSIPID, dull and uninteresting [adj]\n",
  "INSIPIDITIES": "INSIPIDITY, the state of being insipid, also INSIPIDNESS [n]\n",
  "INSIPIDITY": "the state of being insipid, also INSIPIDNESS [n INSIPIDITIES]\n",
  "INSIPIDLY": "INSIPID, dull and uninteresting [adv]\n",
  "INSIPIDNESS": "the state of being insipid, also INSIPIDITY [n -ES]\n",
  "INSIPIDNESSES": "INSIPIDNESS, the state of being insipid, also INSIPIDITY [n]\n",
  "INSIPIENCE": "(archaic) a lack of intelligence [n -S]\n",
  "INSIPIENCES": "INSIPIENCE, (archaic) a lack of intelligence [n]\n",
  "INSIPIENT": "wanting wisdom; foolish [adj INSIPIENTLY]\n",
  "INSIPIENTLY": "INSIPIENT, wanting wisdom; foolish [adv]\n",
  "INSIST": "to maintain very firmly [v -ED, -ING, -S]\n",
  "INSISTED": "INSIST, to maintain very firmly [v]\n",
  "INSISTENCE": "the state of being insistent, also INSISTENCY [n -S]\n",
  "INSISTENCES": "INSISTENCE, the state of being insistent, also INSISTENCY [n]\n",
  "INSISTENCIES": "INSISTENCY, the state of being insistent, also INSISTENCE [n]\n",
  "INSISTENCY": "the state of being insistent, also INSISTENCE [n INSISTENCIES]\n",
  "INSISTENT": "given to insisting [adj INSISTENTLY]\n",
  "INSISTENTLY": "INSISTENT, given to insisting [adv]\n",
  "INSISTER": "one who insists [n -S]\n",
  "INSISTERS": "INSISTER, one who insists [n]\n",
  "INSISTING": "INSIST, to maintain very firmly [v]\n",
  "INSISTINGLY": "INSISTING, INSIST, to maintain very firmly [adv]\n",
  "INSISTS": "INSIST, to maintain very firmly [v]\n",
  "INSNARE": "to trap, also ENSNARE [v INSNARED, INSNARING, INSNARES]\n",
  "INSNARED": "INSNARE, to trap, also ENSNARE [v]\n",
  "INSNAREMENT": "the act of insnaring [n -S]\n",
  "INSNAREMENTS": "INSNAREMENT, the act of insnaring [n]\n",
  "INSNARER": "one that ensnares, also ENSNARER [n -S]\n",
  "INSNARERS": "INSNARER, one that ensnares, also ENSNARER [n]\n",
  "INSNARES": "INSNARE, to trap, also ENSNARE [v]\n",
  "INSNARING": "INSNARE, to trap, also ENSNARE [v]\n",
  "INSOBRIETIES": "INSOBRIETY, want of sobriety [n]\n",
  "INSOBRIETY": "want of sobriety [n INSOBRIETIES]\n",
  "INSOCIABILITIES": "INSOCIABILITY, the state of being insociable [n]\n",
  "INSOCIABILITY": "the state of being insociable [n INSOCIABILITIES]\n",
  "INSOCIABLE": "unsociable [adj INSOCIABLY]\n",
  "INSOCIABLY": "INSOCIABLE, unsociable [adv]\n",
  "INSOFAR": "to such an extent [adv]\n",
  "INSOLATE": "to expose to the sun's rays [v INSOLATED, INSOLATING, INSOLATES]\n",
  "INSOLATED": "INSOLATE, to expose to the sun's rays [v]\n",
  "INSOLATES": "INSOLATE, to expose to the sun's rays [v]\n",
  "INSOLATING": "INSOLATE, to expose to the sun's rays [v]\n",
  "INSOLATION": "exposure to sunlight; sunstroke [n -S]\n",
  "INSOLATIONS": "INSOLATION, exposure to sunlight; sunstroke [n]\n",
  "INSOLE": "the inner sole of a shoe or boot [n -S]\n",
  "INSOLENCE": "rudeness, impudence [n -S]\n",
  "INSOLENCES": "INSOLENCE, rudeness, impudence [n]\n",
  "INSOLENT": "impertinent [adj INSOLENTLY] / an insolent person [n -S]\n",
  "INSOLENTLY": "INSOLENT, impertinent [adv]\n",
  "INSOLENTS": "INSOLENT, an insolent person [n]\n",
  "INSOLES": "INSOLE, the inner sole of a shoe or boot [n]\n",
  "INSOLIDITIES": "INSOLIDITY, want of solidity [n]\n",
  "INSOLIDITY": "want of solidity [n INSOLIDITIES]\n",
  "INSOLUBILISE": "to make insoluble, also INSOLUBILIZE [v INSOLUBILISED, INSOLUBILISING, INSOLUBILISES]\n",
  "INSOLUBILISED": "INSOLUBILISE, to make insoluble, also INSOLUBILIZE [v]\n",
  "INSOLUBILISES": "INSOLUBILISE, to make insoluble, also INSOLUBILIZE [v]\n",
  "INSOLUBILISING": "INSOLUBILISE, to make insoluble, also INSOLUBILIZE [v]\n",
  "INSOLUBILITIES": "INSOLUBILITY, the state of being insoluble [n]\n",
  "INSOLUBILITY": "the state of being insoluble [n INSOLUBILITIES]\n",
  "INSOLUBILIZE": "to make insoluble, also INSOLUBILISE [v INSOLUBILIZED, INSOLUBILIZING, INSOLUBILIZES]\n",
  "INSOLUBILIZED": "INSOLUBILIZE, to make insoluble, also INSOLUBILISE [v]\n",
  "INSOLUBILIZES": "INSOLUBILIZE, to make insoluble, also INSOLUBILISE [v]\n",
  "INSOLUBILIZING": "INSOLUBILIZE, to make insoluble, also INSOLUBILISE [v]\n",
  "INSOLUBLE": "that cannot be solved [adj INSOLUBLY] / something insoluble [n -S]\n",
  "INSOLUBLENESS": "the state of being insoluble [n -ES]\n",
  "INSOLUBLENESSES": "INSOLUBLENESS, the state of being insoluble [n]\n",
  "INSOLUBLES": "INSOLUBLE, something insoluble [n]\n",
  "INSOLUBLY": "INSOLUBLE, that cannot be solved [adv]\n",
  "INSOLVABILITIES": "INSOLVABILITY, the quality of being insolvable [n]\n",
  "INSOLVABILITY": "the quality of being insolvable [n INSOLVABILITIES]\n",
  "INSOLVABLE": "not solvable [adj INSOLVABLY]\n",
  "INSOLVABLY": "INSOLVABLE, not solvable [adv]\n",
  "INSOLVENCIES": "INSOLVENCY, the state of being insolvent [n]\n",
  "INSOLVENCY": "the state of being insolvent [n INSOLVENCIES]\n",
  "INSOLVENT": "not able to pay one's debts [adj] / one who is insolvent [n -S]\n",
  "INSOLVENTS": "INSOLVENT, one who is insolvent [n]\n",
  "INSOMNIA": "chronic inability to sleep [n -S]\n",
  "INSOMNIAC": "one who suffers from insomnia [n -S]\n",
  "INSOMNIACS": "INSOMNIAC, one who suffers from insomnia [n]\n",
  "INSOMNIAS": "INSOMNIA, chronic inability to sleep [n]\n",
  "INSOMNIOUS": "restless; sleepless [adj]\n",
  "INSOMNOLENCE": "sleeplessness [n -S]\n",
  "INSOMNOLENCES": "INSOMNOLENCE, sleeplessness [n]\n",
  "INSOMUCH": "to such a degree, also INASMUCH [adv]\n",
  "INSOOTH": "(archaic) in sooth; truly [adj]\n",
  "INSOUCIANCE": "lighthearted unconcern, nonchalance [n -S]\n",
  "INSOUCIANCES": "INSOUCIANCE, lighthearted unconcern, nonchalance [n]\n",
  "INSOUCIANT": "lighthearted and unconcerned [adj INSOUCIANTLY]\n",
  "INSOUCIANTLY": "INSOUCIANT, lighthearted and unconcerned [adv]\n",
  "INSOUL": "to infuse with a soul, also ENSOUL [v -ED, -ING, -S]\n",
  "INSOULED": "INSOUL, to infuse with a soul, also ENSOUL [v]\n",
  "INSOULING": "INSOUL, to infuse with a soul, also ENSOUL [v]\n",
  "INSOULMENT": "the act of animating with a soul, also ENSOULMENT [n -S]\n",
  "INSOULMENTS": "INSOULMENT, the act of animating with a soul, also ENSOULMENT [n]\n",
  "INSOULS": "INSOUL, to infuse with a soul, also ENSOUL [v]\n",
  "INSOURCE": "to subcontract work to another company that is under the same general ownership [v INSOURCED, INSOURCING, INSOURCES]\n",
  "INSOURCED": "INSOURCE, to subcontract work to another company that is under the same general ownership [v]\n",
  "INSOURCES": "INSOURCE, to subcontract work to another company that is under the same general ownership [v]\n",
  "INSOURCING": "the practice of subcontracting work to another company that is under the same general ownership [n -S]\n",
  "INSOURCINGS": "INSOURCING, the practice of subcontracting work to another company that is under the same general ownership [n]\n",
  "INSPAN": "(South African) to harness or yoke animals to a vehicle [v INSPANNED, INSPANNING, INSPANS]\n",
  "INSPANNED": "INSPAN, (South African) to harness or yoke animals to a vehicle [v]\n",
  "INSPANNING": "INSPAN, (South African) to harness or yoke animals to a vehicle [v]\n",
  "INSPANS": "INSPAN, (South African) to harness or yoke animals to a vehicle [v]\n",
  "INSPECT": "to examine closely [v -ED, -ING, -S]\n",
  "INSPECTABLE": "that can be inspected [adj]\n",
  "INSPECTED": "INSPECT, to examine closely [v]\n",
  "INSPECTING": "INSPECT, to examine closely [v]\n",
  "INSPECTINGLY": "INSPECTING, INSPECT, to examine closely [adv]\n",
  "INSPECTION": "the act of inspecting [n -S]\n",
  "INSPECTIONAL": "relating to inspection [adj]\n",
  "INSPECTIONS": "INSPECTION, the act of inspecting [n]\n",
  "INSPECTIVE": "engaged in inspection [adj]\n",
  "INSPECTOR": "one who inspects; a police rank [n -S]\n",
  "INSPECTORAL": "relating to inspection [adj]\n",
  "INSPECTORATE": "the office, position, work, or district of an inspector [n -S]\n",
  "INSPECTORATES": "INSPECTORATE, the office, position, work, or district of an inspector [n]\n",
  "INSPECTORIAL": "of or like an inspector, also INSPECTORAL [adj]\n",
  "INSPECTORS": "INSPECTOR, one who inspects; a police rank [n]\n",
  "INSPECTORSHIP": "the office of inspector [n -S]\n",
  "INSPECTORSHIPS": "INSPECTORSHIP, the office of inspector [n]\n",
  "INSPECTS": "INSPECT, to examine closely [v]\n",
  "INSPHERE": "to enclose in a sphere, also ENSPHERE [v INSPHERED, INSPHERING, INSPHERES]\n",
  "INSPHERED": "INSPHERE, to enclose in a sphere, also ENSPHERE [v]\n",
  "INSPHERES": "INSPHERE, to enclose in a sphere, also ENSPHERE [v]\n",
  "INSPHERING": "INSPHERE, to enclose in a sphere, also ENSPHERE [v]\n",
  "INSPIRABLE": "capable of being inspired or drawn into the lungs [adj]\n",
  "INSPIRATION": "the act of inspiring [n -S]\n",
  "INSPIRATIONAL": "relating to inspiration [adj INSPIRATIONALLY]\n",
  "INSPIRATIONALLY": "INSPIRATIONAL, relating to inspiration [adv]\n",
  "INSPIRATIONISM": "the belief that the writers of the Scriptures were directly and divinely inspired [n -S]\n",
  "INSPIRATIONISMS": "INSPIRATIONISM, the belief that the writers of the Scriptures were directly and divinely inspired [n]\n",
  "INSPIRATIONIST": "a person who maintains that the writers of the Scriptures were directly and divinely inspired [n -S]\n",
  "INSPIRATIONISTS": "INSPIRATIONIST, a person who maintains that the writers of the Scriptures were directly and divinely inspired [n]\n",
  "INSPIRATIONS": "INSPIRATION, the act of inspiring [n]\n",
  "INSPIRATIVE": "giving inspiration [adj]\n",
  "INSPIRATOR": "a kind of injector for forcing water by steam [n -S]\n",
  "INSPIRATORS": "INSPIRATOR, a kind of injector for forcing water by steam [n]\n",
  "INSPIRATORY": "tending to inspire [adj]\n",
  "INSPIRE": "to influence to greater heights [v INSPIRED, INSPIRING, INSPIRES]\n",
  "INSPIRED": "INSPIRE, to influence to greater heights [v]\n",
  "INSPIRER": "one that inspires [n -S]\n",
  "INSPIRERS": "INSPIRER, one that inspires [n]\n",
  "INSPIRES": "INSPIRE, to influence to greater heights [v]\n",
  "INSPIRING": "INSPIRE, to influence to greater heights [v]\n",
  "INSPIRINGLY": "INSPIRING, INSPIRE, to influence to greater heights [adv]\n",
  "INSPIRIT": "to animate or encourage [v -ED, -ING, -S]\n",
  "INSPIRITED": "INSPIRIT, to animate or encourage [v]\n",
  "INSPIRITER": "one who inspirits [n -S]\n",
  "INSPIRITERS": "INSPIRITER, one who inspirits [n]\n",
  "INSPIRITING": "INSPIRIT, to animate or encourage [v]\n",
  "INSPIRITINGLY": "INSPIRITING, INSPIRIT, to animate or encourage [adv]\n",
  "INSPIRITMENT": "the act of inspiriting [n -S]\n",
  "INSPIRITMENTS": "INSPIRITMENT, the act of inspiriting [n]\n",
  "INSPIRITS": "INSPIRIT, to animate or encourage [v]\n",
  "INSPISSATE": "to make thick [v INSPISSATED, INSPISSATING, INSPISSATES]\n",
  "INSPISSATED": "INSPISSATE, to make thick [v]\n",
  "INSPISSATES": "INSPISSATE, to make thick [v]\n",
  "INSPISSATING": "INSPISSATE, to make thick [v]\n",
  "INSPISSATION": "the act of inspissating [n -S]\n",
  "INSPISSATIONS": "INSPISSATION, the act of inspissating [n]\n",
  "INSPISSATOR": "an agent that inspissates [n -S]\n",
  "INSPISSATORS": "INSPISSATOR, an agent that inspissates [n]\n",
  "INSPO": "someone or something that is a source of inspiration [n -S]\n",
  "INSPOS": "INSPO, someone or something that is a source of inspiration [n]\n",
  "INSTABILITIES": "INSTABILITY, the state of being unstable [n]\n",
  "INSTABILITY": "the state of being unstable [n INSTABILITIES]\n",
  "INSTABLE": "not stable, also UNSTABLE [adj]\n",
  "INSTAGRAM": "to share (a photograph) using the Instagram application [v INSTAGRAMMED, INSTAGRAMMING, INSTAGRAMS]\n",
  "INSTAGRAMMED": "INSTAGRAM, to share (a photograph) using the Instagram application [v]\n",
  "INSTAGRAMMING": "INSTAGRAM, to share (a photograph) using the Instagram application [v]\n",
  "INSTAGRAMS": "INSTAGRAM, to share (a photograph) using the Instagram application [v]\n",
  "INSTAL": "to place in position for use, also INSTALL [v INSTALLED, INSTALLING, INSTALS]\n",
  "INSTALL": "to place in position for use, also INSTAL [v -ED, -ING, -S]\n",
  "INSTALLANT": "one who instals another in an office [n -S]\n",
  "INSTALLANTS": "INSTALLANT, one who instals another in an office [n]\n",
  "INSTALLATION": "the act of installing [n -S]\n",
  "INSTALLATIONS": "INSTALLATION, the act of installing [n]\n",
  "INSTALLED": "INSTALL, to place in position for use, also INSTAL [v]\n",
  "INSTALLER": "one who instals [n -S]\n",
  "INSTALLERS": "INSTALLER, one who instals [n]\n",
  "INSTALLING": "INSTALL, to place in position for use, also INSTAL [v]\n",
  "INSTALLMENT": "(US) one of a series of partial payments, also INSTALMENT [n -S]\n",
  "INSTALLMENTS": "INSTALLMENT, (US) one of a series of partial payments, also INSTALMENT [n]\n",
  "INSTALLS": "INSTALL, to place in position for use, also INSTAL [v]\n",
  "INSTALMENT": "one of a series of partial payments, also INSTALLMENT [n -S]\n",
  "INSTALMENTS": "INSTALMENT, one of a series of partial payments, also INSTALLMENT [n]\n",
  "INSTALS": "INSTAL, to place in position for use, also INSTALL [v]\n",
  "INSTANCE": "to cite as an example [v INSTANCED, INSTANCING, INSTANCES]\n",
  "INSTANCED": "INSTANCE, to cite as an example [v]\n",
  "INSTANCES": "INSTANCE, to cite as an example [v]\n",
  "INSTANCIES": "INSTANCY, the quality of being pressing [n]\n",
  "INSTANCING": "INSTANCE, to cite as an example [v]\n",
  "INSTANCY": "the quality of being pressing [n INSTANCIES]\n",
  "INSTANT": "without delay [adj INSTANTER, INSTANTLY] / a very short period of time [n -S]\n",
  "INSTANTANEITIES": "INSTANTANEITY, the state of being instantaneous [n]\n",
  "INSTANTANEITY": "the state of being instantaneous [n INSTANTANEITIES]\n",
  "INSTANTANEOUS": "done, occurring, or acting without any perceptible duration of time [adj INSTANTANEOUSLY]\n",
  "INSTANTANEOUSLY": "INSTANTANEOUS, done, occurring, or acting without any perceptible duration of time [adv]\n",
  "INSTANTER": "without delay [adj]\n",
  "INSTANTIAL": "relating to an instant [adj]\n",
  "INSTANTIATE": "to represent (an abstraction) by a concrete instance [v INSTANTIATED, INSTANTIATING, INSTANTIATES]\n",
  "INSTANTIATED": "INSTANTIATE, to represent (an abstraction) by a concrete instance [v]\n",
  "INSTANTIATES": "INSTANTIATE, to represent (an abstraction) by a concrete instance [v]\n",
  "INSTANTIATING": "INSTANTIATE, to represent (an abstraction) by a concrete instance [v]\n",
  "INSTANTIATION": "the act of instantiating [n -S]\n",
  "INSTANTIATIONS": "INSTANTIATION, the act of instantiating [n]\n",
  "INSTANTLY": "INSTANT, without delay [adv]\n",
  "INSTANTNESS": "the state of being instant [n -ES]\n",
  "INSTANTNESSES": "INSTANTNESS, the state of being instant [n]\n",
  "INSTANTS": "INSTANT, a very short period of time [n]\n",
  "INSTAR": "to adorn with stars [v INSTARRED, INSTARRING, INSTARS]\n",
  "INSTARRED": "INSTAR, to adorn with stars [v]\n",
  "INSTARRING": "INSTAR, to adorn with stars [v]\n",
  "INSTARS": "INSTAR, to adorn with stars [v]\n",
  "INSTATE": "to install in office [v INSTATED, INSTATING, INSTATES]\n",
  "INSTATED": "INSTATE, to install in office [v]\n",
  "INSTATEMENT": "the act of instating [n -S]\n",
  "INSTATEMENTS": "INSTATEMENT, the act of instating [n]\n",
  "INSTATES": "INSTATE, to install in office [v]\n",
  "INSTATING": "INSTATE, to install in office [v]\n",
  "INSTAURATION": "renewal; renovation [n -S]\n",
  "INSTAURATIONS": "INSTAURATION, renewal; renovation [n]\n",
  "INSTAURATOR": "one who restores [n -S]\n",
  "INSTAURATORS": "INSTAURATOR, one who restores [n]\n",
  "INSTEAD": "as a substitute or alternative [adv]\n",
  "INSTEP": "a part of the foot [n -S]\n",
  "INSTEPS": "INSTEP, a part of the foot [n]\n",
  "INSTIGATE": "to initiate, bring about [v INSTIGATED, INSTIGATING, INSTIGATES]\n",
  "INSTIGATED": "INSTIGATE, to initiate, bring about [v]\n",
  "INSTIGATES": "INSTIGATE, to initiate, bring about [v]\n",
  "INSTIGATING": "INSTIGATE, to initiate, bring about [v]\n",
  "INSTIGATINGLY": "INSTIGATING, INSTIGATE, to initiate, bring about [adv]\n",
  "INSTIGATION": "the act of instigating [n -S]\n",
  "INSTIGATIONS": "INSTIGATION, the act of instigating [n]\n",
  "INSTIGATIVE": "serving to instigate [adj]\n",
  "INSTIGATOR": "one who instigates [n -S]\n",
  "INSTIGATORS": "INSTIGATOR, one who instigates [n]\n",
  "INSTIL": "to infuse slowly, also INSTILL [v INSTILLED, INSTILLING, INSTILS]\n",
  "INSTILL": "to infuse slowly, also INSTIL [v -ED, -ING, -S]\n",
  "INSTILLATION": "the act of instilling [n -S]\n",
  "INSTILLATIONS": "INSTILLATION, the act of instilling [n]\n",
  "INSTILLED": "INSTILL, to infuse slowly, also INSTIL [v]\n",
  "INSTILLER": "one who instils [n -S]\n",
  "INSTILLERS": "INSTILLER, one who instils [n]\n",
  "INSTILLING": "INSTILL, to infuse slowly, also INSTIL [v]\n",
  "INSTILLMENT": "the act of instilling [n -S]\n",
  "INSTILLMENTS": "INSTILLMENT, the act of instilling [n]\n",
  "INSTILLS": "INSTILL, to infuse slowly, also INSTIL [v]\n",
  "INSTILMENT": "the act of instilling [n -S]\n",
  "INSTILMENTS": "INSTILMENT, the act of instilling [n]\n",
  "INSTILS": "INSTIL, to infuse slowly, also INSTILL [v]\n",
  "INSTINCT": "an inborn impulse, intuition [n -S]\n",
  "INSTINCTIVE": "relating to instinct [adj INSTINCTIVELY]\n",
  "INSTINCTIVELY": "INSTINCTIVE, relating to instinct [adv]\n",
  "INSTINCTIVITIES": "INSTINCTIVITY, the state of being instinctive [n]\n",
  "INSTINCTIVITY": "the state of being instinctive [n INSTINCTIVITIES]\n",
  "INSTINCTS": "INSTINCT, an inborn impulse, intuition [n]\n",
  "INSTINCTUAL": "relating to instinct [adj INSTINCTUALLY]\n",
  "INSTINCTUALLY": "INSTINCTUAL, relating to instinct [adv]\n",
  "INSTITORIAL": "pertaining to an agent or factor [adj]\n",
  "INSTITUTE": "to set up, establish [v INSTITUTED, INSTITUTING, INSTITUTES]\n",
  "INSTITUTED": "INSTITUTE, to set up, establish [v]\n",
  "INSTITUTER": "one who institutes, also INSTITUTOR [n -S]\n",
  "INSTITUTERS": "INSTITUTER, one who institutes, also INSTITUTOR [n]\n",
  "INSTITUTES": "INSTITUTE, to set up, establish [v]\n",
  "INSTITUTING": "INSTITUTE, to set up, establish [v]\n",
  "INSTITUTION": "an act of instituting [n -S]\n",
  "INSTITUTIONAL": "of or relating to an institution, also INSTITUTIONARY [adj INSTITUTIONALLY]\n",
  "INSTITUTIONALLY": "INSTITUTIONAL, of or relating to an institution, also INSTITUTIONARY [adv]\n",
  "INSTITUTIONARY": "of or relating to an institution, also INSTITUTIONAL [adj]\n",
  "INSTITUTIONS": "INSTITUTION, an act of instituting [n]\n",
  "INSTITUTIST": "a writer of institutes or elementary rules [n -S]\n",
  "INSTITUTISTS": "INSTITUTIST, a writer of institutes or elementary rules [n]\n",
  "INSTITUTIVE": "able or tending to establish [adj INSTITUTIVELY]\n",
  "INSTITUTIVELY": "INSTITUTIVE, able or tending to establish [adv]\n",
  "INSTITUTOR": "one who institutes, also INSTITUTER [n -S]\n",
  "INSTITUTORS": "INSTITUTOR, one who institutes, also INSTITUTER [n]\n",
  "INSTREAMING": "an influx [n -S]\n",
  "INSTREAMINGS": "INSTREAMING, an influx [n]\n",
  "INSTRESS": "to create an inner nature [v -ED, -ING, -ES]\n",
  "INSTRESSED": "INSTRESS, to create an inner nature [v]\n",
  "INSTRESSES": "INSTRESS, to create an inner nature [v]\n",
  "INSTRESSING": "INSTRESS, to create an inner nature [v]\n",
  "INSTROKE": "the upstroke of a piston [n -S]\n",
  "INSTROKES": "INSTROKE, the upstroke of a piston [n]\n",
  "INSTRUCT": "to supply with knowledge [v -ED, -ING, -S]\n",
  "INSTRUCTED": "INSTRUCT, to supply with knowledge [v]\n",
  "INSTRUCTIBLE": "that can be instructed [adj]\n",
  "INSTRUCTING": "INSTRUCT, to supply with knowledge [v]\n",
  "INSTRUCTION": "a precept [n -S]\n",
  "INSTRUCTIONAL": "relating to instruction [adj]\n",
  "INSTRUCTIONS": "INSTRUCTION, a precept [n]\n",
  "INSTRUCTIVE": "indicating means whereby [adj INSTRUCTIVELY]\n",
  "INSTRUCTIVELY": "INSTRUCTIVE, indicating means whereby [adv]\n",
  "INSTRUCTIVENESS": "INSTRUCTIVE, indicating means whereby [n]\n",
  "INSTRUCTOR": "one that instructs [n -S]\n",
  "INSTRUCTORS": "INSTRUCTOR, one that instructs [n]\n",
  "INSTRUCTORSHIP": "the office of instructor [n -S]\n",
  "INSTRUCTORSHIPS": "INSTRUCTORSHIP, the office of instructor [n]\n",
  "INSTRUCTRESS": "a woman who is an instructor [n -ES]\n",
  "INSTRUCTRESSES": "INSTRUCTRESS, a woman who is an instructor [n]\n",
  "INSTRUCTS": "INSTRUCT, to supply with knowledge [v]\n",
  "INSTRUMENT": "to address a legal instrument to [v -ED, -ING, -S]\n",
  "INSTRUMENTAL": "nonvocal [adj INSTRUMENTALLY] / a nonvocal passage of music [n -S]\n",
  "INSTRUMENTALISM": "doctrine that ideas are instruments of action [n]\n",
  "INSTRUMENTALIST": "one who plays a musical instrument, esp. as opposed to a vocalist [n]\n",
  "INSTRUMENTALITY": "the state of being instrumental [n]\n",
  "INSTRUMENTALLY": "INSTRUMENTAL, nonvocal [adv]\n",
  "INSTRUMENTALS": "INSTRUMENTAL, a nonvocal passage of music [n]\n",
  "INSTRUMENTATION": "the arrangement or composition of music for instruments esp. for a band or orchestra [n]\n",
  "INSTRUMENTED": "INSTRUMENT, to address a legal instrument to [v]\n",
  "INSTRUMENTING": "INSTRUMENT, to address a legal instrument to [v]\n",
  "INSTRUMENTS": "INSTRUMENT, to address a legal instrument to [v]\n",
  "INSUBJECTION": "lack of subjection [n -S]\n",
  "INSUBJECTIONS": "INSUBJECTION, lack of subjection [n]\n",
  "INSUBORDINATE": "disobedient to authority [adj INSUBORDINATELY] / someone disobedient to authority [n -S]\n",
  "INSUBORDINATELY": "INSUBORDINATE, disobedient to authority [adv]\n",
  "INSUBORDINATES": "INSUBORDINATE, someone disobedient to authority [n]\n",
  "INSUBORDINATION": "the state of being insubordinate [n]\n",
  "INSUBSTANTIAL": "not substantial [adj INSUBSTANTIALLY]\n",
  "INSUBSTANTIALLY": "INSUBSTANTIAL, not substantial [adv]\n",
  "INSUCKEN": "in Scots law, relating to a sucken, the jurisdiction of a mill, or that extent of ground astricted to it [adj]\n",
  "INSUFFERABLE": "not to be endured, also UNSUFFERABLE [adj INSUFFERABLY]\n",
  "INSUFFERABLY": "INSUFFERABLE, not to be endured, also UNSUFFERABLE [adv]\n",
  "INSUFFICIENCE": "the state of being insufficient, also INSUFFICIENCY [n -S]\n",
  "INSUFFICIENCES": "INSUFFICIENCE, the state of being insufficient, also INSUFFICIENCY [n]\n",
  "INSUFFICIENCIES": "INSUFFICIENCY, the state of being insufficient, also INSUFFICIENCE [n]\n",
  "INSUFFICIENCY": "the state of being insufficient, also INSUFFICIENCE [n INSUFFICIENCIES]\n",
  "INSUFFICIENT": "not sufficient, also UNSUFFICIENT [adj INSUFFICIENTLY]\n",
  "INSUFFICIENTLY": "INSUFFICIENT, not sufficient, also UNSUFFICIENT [adv]\n",
  "INSUFFLATE": "to blow on or into [v INSUFFLATED, INSUFFLATING, INSUFFLATES]\n",
  "INSUFFLATED": "INSUFFLATE, to blow on or into [v]\n",
  "INSUFFLATES": "INSUFFLATE, to blow on or into [v]\n",
  "INSUFFLATING": "INSUFFLATE, to blow on or into [v]\n",
  "INSUFFLATION": "the act of breathing into or upon [n -S]\n",
  "INSUFFLATIONS": "INSUFFLATION, the act of breathing into or upon [n]\n",
  "INSUFFLATOR": "one who insufflates [n -S]\n",
  "INSUFFLATORS": "INSUFFLATOR, one who insufflates [n]\n",
  "INSULA": "(Latin) a Roman block of buildings [n INSULAE]\n",
  "INSULAE": "INSULA, (Latin) a Roman block of buildings [n]\n",
  "INSULANT": "an insulating material [n -S]\n",
  "INSULANTS": "INSULANT, an insulating material [n]\n",
  "INSULAR": "like an island [adj INSULARLY] / a native or inhabitant of an island [n -S]\n",
  "INSULARISM": "the state of being insular, also INSULARITY [n -S]\n",
  "INSULARISMS": "INSULARISM, the state of being insular, also INSULARITY [n]\n",
  "INSULARITIES": "INSULARITY, the state of being insular, also INSULARISM [n]\n",
  "INSULARITY": "the state of being insular, also INSULARISM [n INSULARITIES]\n",
  "INSULARLY": "INSULAR, like an island [adv]\n",
  "INSULARS": "INSULAR, a native or inhabitant of an island [n]\n",
  "INSULATE": "to isolate from connection [v INSULATED, INSULATING, INSULATES]\n",
  "INSULATED": "INSULATE, to isolate from connection [v]\n",
  "INSULATES": "INSULATE, to isolate from connection [v]\n",
  "INSULATING": "INSULATE, to isolate from connection [v]\n",
  "INSULATION": "the action of insulating [n -S]\n",
  "INSULATIONS": "INSULATION, the action of insulating [n]\n",
  "INSULATOR": "a nonconductor of electricity; a device for insulating a conductor [n -S]\n",
  "INSULATORS": "INSULATOR, a nonconductor of electricity; a device for insulating a conductor [n]\n",
  "INSULIN": "a protein hormone produced in the pancreas of animals [n -S]\n",
  "INSULINASE": "an enzyme, present in the liver and kidneys, which breaks down insulin [n -S]\n",
  "INSULINASES": "INSULINASE, an enzyme, present in the liver and kidneys, which breaks down insulin [n]\n",
  "INSULINS": "INSULIN, a protein hormone produced in the pancreas of animals [n]\n",
  "INSULSE": "lacking wit; dull; insipid [adj]\n",
  "INSULSITIES": "INSULSITY, stupidity [n]\n",
  "INSULSITY": "stupidity [n INSULSITIES]\n",
  "INSULT": "to subject to indignity [v -ED, -ING, -S]\n",
  "INSULTABLE": "capable of being insulted or affronted [adj]\n",
  "INSULTANT": "insulting [adj]\n",
  "INSULTED": "INSULT, to subject to indignity [v]\n",
  "INSULTER": "one who insults [n -S]\n",
  "INSULTERS": "INSULTER, one who insults [n]\n",
  "INSULTING": "INSULT, to subject to indignity [v]\n",
  "INSULTINGLY": "INSULTING, INSULT, to subject to indignity [adv]\n",
  "INSULTMENT": "(Shakespeare) insult [n -S]\n",
  "INSULTMENTS": "INSULTMENT, (Shakespeare) insult [n]\n",
  "INSULTS": "INSULT, to subject to indignity [v]\n",
  "INSUPERABILITY": "the state of being insuperable, also INSUPERABLENESS [n]\n",
  "INSUPERABLE": "that cannot be overcome [adj INSUPERABLY]\n",
  "INSUPERABLENESS": "INSUPERABLE, that cannot be overcome [n]\n",
  "INSUPERABLY": "INSUPERABLE, that cannot be overcome [adv]\n",
  "INSUPPORTABLE": "not supportable [adj INSUPPORTABLY]\n",
  "INSUPPORTABLY": "INSUPPORTABLE, not supportable [adv]\n",
  "INSUPPRESSIBLE": "not able to be suppressed [adj INSUPPRESSIBLY]\n",
  "INSUPPRESSIBLY": "INSUPPRESSIBLE, not able to be suppressed [adv]\n",
  "INSURABILITIES": "INSURABILITY, the state of being insurable [n]\n",
  "INSURABILITY": "the state of being insurable [n INSURABILITIES]\n",
  "INSURABLE": "that can be insured [adj]\n",
  "INSURANCE": "the act, practice or business of insuring [n -S]\n",
  "INSURANCER": "(obsolete) one who effects insurance [n -S]\n",
  "INSURANCERS": "INSURANCER, (obsolete) one who effects insurance [n]\n",
  "INSURANCES": "INSURANCE, the act, practice or business of insuring [n]\n",
  "INSURANT": "one who is insured [n -S]\n",
  "INSURANTS": "INSURANT, one who is insured [n]\n",
  "INSURE": "to secure payment in the event of loss or damage [v INSURED, INSURING, INSURES]\n",
  "INSURED": "one who is insured [n -S]\n",
  "INSUREDS": "INSURED, one who is insured [n]\n",
  "INSURER": "one who insures, also ENSURER [n -S]\n",
  "INSURERS": "INSURER, one who insures, also ENSURER [n]\n",
  "INSURES": "INSURE, to secure payment in the event of loss or damage [v]\n",
  "INSURGENCE": "the state of being insurgent, also INSURGENCY [n -S]\n",
  "INSURGENCES": "INSURGENCE, the state of being insurgent, also INSURGENCY [n]\n",
  "INSURGENCIES": "INSURGENCY, the state of being insurgent, also INSURGENCE [n]\n",
  "INSURGENCY": "the state of being insurgent, also INSURGENCE [n INSURGENCIES]\n",
  "INSURGENT": "rising up [adj INSURGENTLY] / a person who rises in opposition to established authority; a rebel [n -S]\n",
  "INSURGENTLY": "INSURGENT, rising up [adv]\n",
  "INSURGENTS": "INSURGENT, a person who rises in opposition to established authority; a rebel [n]\n",
  "INSURING": "INSURE, to secure payment in the event of loss or damage [v]\n",
  "INSURMOUNTABLE": "incapable of being surmounted [adj INSURMOUNTABLY]\n",
  "INSURMOUNTABLY": "INSURMOUNTABLE, incapable of being surmounted [adv]\n",
  "INSURRECTION": "an act or instance of revolting against civil authority or an established government [n -S]\n",
  "INSURRECTIONAL": "relating to insurrection [adj]\n",
  "INSURRECTIONARY": "relating to insurrection [adj]\n",
  "INSURRECTIONISM": "a policy of insurrection [n]\n",
  "INSURRECTIONIST": "one who takes part in an insurrection [n]\n",
  "INSURRECTIONS": "INSURRECTION, an act or instance of revolting against civil authority or an established government [n]\n",
  "INSUSCEPTIBLE": "not susceptible, also INSUSCEPTIVE [adj INSUSCEPTIBLY]\n",
  "INSUSCEPTIBLY": "INSUSCEPTIBLE, not susceptible, also INSUSCEPTIVE [adv]\n",
  "INSUSCEPTIVE": "not susceptible, also INSUSCEPTIBLE [adj INSUSCEPTIVELY]\n",
  "INSUSCEPTIVELY": "INSUSCEPTIVE, not susceptible, also INSUSCEPTIBLE [adv]\n",
  "INSWATHE": "to wrap around, also ENSWATHE [v INSWATHED, INSWATHING, INSWATHES]\n",
  "INSWATHED": "INSWATHE, to wrap around, also ENSWATHE [v]\n",
  "INSWATHES": "INSWATHE, to wrap around, also ENSWATHE [v]\n",
  "INSWATHING": "INSWATHE, to wrap around, also ENSWATHE [v]\n",
  "INSWEPT": "narrowed in front [adj]\n",
  "INSWING": "an inward swing [n -S]\n",
  "INSWINGER": "in cricket, a ball bowled so as to swerve to leg [n -S]\n",
  "INSWINGERS": "INSWINGER, in cricket, a ball bowled so as to swerve to leg [n]\n",
  "INSWINGS": "INSWING, an inward swing [n]\n",
  "INTACT": "entire, undamaged [adj INTACTLY]\n",
  "INTACTLY": "INTACT, entire, undamaged [adv]\n",
  "INTACTNESS": "the state of being intact [n -ES]\n",
  "INTACTNESSES": "INTACTNESS, the state of being intact [n]\n",
  "INTAGLI": "INTAGLIO, (Italian) a figure engraved into a gem or another substance [n]\n",
  "INTAGLIATED": "incised, engraved [adj]\n",
  "INTAGLIO": "(Italian) a figure engraved into a gem or another substance [n INTAGLI or INTAGLIOS] / to carve an intaglio on [v -ED, -ING, -ES]\n",
  "INTAGLIOED": "INTAGLIO, to carve an intaglio on [v]\n",
  "INTAGLIOES": "INTAGLIO, to carve an intaglio on [v]\n",
  "INTAGLIOING": "INTAGLIO, to carve an intaglio on [v]\n",
  "INTAGLIOS": "INTAGLIO, to carve an intaglio on [v]\n",
  "INTAKE": "the act of taking in [n -S]\n",
  "INTAKES": "INTAKE, the act of taking in [n]\n",
  "INTANGIBILITIES": "INTANGIBILITY, the state of being intangible [n]\n",
  "INTANGIBILITY": "the state of being intangible [n INTANGIBILITIES]\n",
  "INTANGIBLE": "that cannot be touched, also UNTANGIBLE [adj INTANGIBLY] / something that cannot be touched [n -S]\n",
  "INTANGIBLENESS": "INTANGIBLE, that cannot be touched, also UNTANGIBLE [n]\n",
  "INTANGIBLES": "INTANGIBLE, something that cannot be touched [n]\n",
  "INTANGIBLY": "INTANGIBLE, that cannot be touched, also UNTANGIBLE [adv]\n",
  "INTARSIA": "(Italian) a form of decorative wood inlay work, also TARSIA [n -S]\n",
  "INTARSIAS": "INTARSIA, (Italian) a form of decorative wood inlay work, also TARSIA [n]\n",
  "INTEGER": "a whole number [n -S]\n",
  "INTEGERS": "INTEGER, a whole number [n]\n",
  "INTEGRABILITIES": "INTEGRABILITY, the state of being integrable [n]\n",
  "INTEGRABILITY": "the state of being integrable [n INTEGRABILITIES]\n",
  "INTEGRABLE": "capable of being integrated [adj]\n",
  "INTEGRAL": "whole [adj INTEGRALLY] / a type of mathematical function [n -S]\n",
  "INTEGRALITIES": "INTEGRALITY, the state of being integral [n]\n",
  "INTEGRALITY": "the state of being integral [n INTEGRALITIES]\n",
  "INTEGRALLY": "INTEGRAL, whole [adv]\n",
  "INTEGRALS": "INTEGRAL, a type of mathematical function [n]\n",
  "INTEGRAND": "a function to be integrated [n -S]\n",
  "INTEGRANDS": "INTEGRAND, a function to be integrated [n]\n",
  "INTEGRANT": "making part of a whole; necessary to constitute an entire thing [adj] / an integrant part or thing [n -S]\n",
  "INTEGRANTS": "INTEGRANT, an integrant part or thing [n]\n",
  "INTEGRATE": "to make entire [v INTEGRATED, INTEGRATING, INTEGRATES]\n",
  "INTEGRATED": "INTEGRATE, to make entire [v]\n",
  "INTEGRATES": "INTEGRATE, to make entire [v]\n",
  "INTEGRATING": "INTEGRATE, to make entire [v]\n",
  "INTEGRATION": "the act or process of integrating [n -S]\n",
  "INTEGRATIONIST": "a person who believes in, advocates, or practices social integration [n -S]\n",
  "INTEGRATIONISTS": "INTEGRATIONIST, a person who believes in, advocates, or practices social integration [n]\n",
  "INTEGRATIONS": "INTEGRATION, the act or process of integrating [n]\n",
  "INTEGRATIVE": "serving to integrate or favoring integration [adj]\n",
  "INTEGRATOR": "one that integrates [n -S]\n",
  "INTEGRATORS": "INTEGRATOR, one that integrates [n]\n",
  "INTEGRIN": "any of a superfamily of cell surface proteins that bind to components of the extracellular matrix, facilitating the cell adhesion and signalling [n -S]\n",
  "INTEGRINS": "INTEGRIN, any of a superfamily of cell surface proteins that bind to components of the extracellular matrix, facilitating the cell adhesion and signalling [n]\n",
  "INTEGRITIES": "INTEGRITY, the state of being whole [n]\n",
  "INTEGRITY": "the state of being whole [n INTEGRITIES]\n",
  "INTEGUMENT": "an external covering or coating [n -S]\n",
  "INTEGUMENTAL": "of or like an integument, also INTEGUMENTARY [adj]\n",
  "INTEGUMENTARY": "of or like an integument, also INTEGUMENTAL [adj]\n",
  "INTEGUMENTS": "INTEGUMENT, an external covering or coating [n]\n",
  "INTEL": "military intelligence [n -S]\n",
  "INTELLECT": "the mind, in reference to its rational powers [n -S]\n",
  "INTELLECTED": "(Cowper) endowed with intellect [adj]\n",
  "INTELLECTION": "an exercise of the intellect [n -S]\n",
  "INTELLECTIONS": "INTELLECTION, an exercise of the intellect [n]\n",
  "INTELLECTIVE": "relating to the intellect [adj INTELLECTIVELY]\n",
  "INTELLECTIVELY": "INTELLECTIVE, relating to the intellect [adv]\n",
  "INTELLECTS": "INTELLECT, the mind, in reference to its rational powers [n]\n",
  "INTELLECTUAL": "relating to the intellect [adj INTELLECTUALLY] / an intellectual person [n -S]\n",
  "INTELLECTUALISE": "to make intellectual, also INTELLECTUALIZE [v]\n",
  "INTELLECTUALISM": "belief that all knowledge is derived from reason [n]\n",
  "INTELLECTUALIST": "relating to intellectualism [n]\n",
  "INTELLECTUALITY": "the state of being intellectual [n]\n",
  "INTELLECTUALIZE": "to give rational form or content to, also INTELLECTUALISE [v]\n",
  "INTELLECTUALLY": "INTELLECTUAL, relating to the intellect [adv]\n",
  "INTELLECTUALS": "INTELLECTUAL, an intellectual person [n]\n",
  "INTELLIGENCE": "the ability to learn or understand or to deal with new or trying situations [n -S]\n",
  "INTELLIGENCER": "(archaic) a secret agent [n -S]\n",
  "INTELLIGENCERS": "INTELLIGENCER, (archaic) a secret agent [n]\n",
  "INTELLIGENCES": "INTELLIGENCE, the ability to learn or understand or to deal with new or trying situations [n]\n",
  "INTELLIGENT": "having a high degree of intelligence [adj INTELLIGENTLY]\n",
  "INTELLIGENTIAL": "concerning the intelligence [adj]\n",
  "INTELLIGENTLY": "INTELLIGENT, having a high degree of intelligence [adv]\n",
  "INTELLIGENTSIA": "(Russian) the intellectual or cultured classes, originally in Russia, also INTELLIGENTZIA [n -S]\n",
  "INTELLIGENTSIAS": "INTELLIGENTSIA, (Russian) the intellectual or cultured classes, originally in Russia, also INTELLIGENTZIA [n]\n",
  "INTELLIGENTZIA": "(Russian) the intellectual or cultured classes, originally in Russia, also INTELLIGENTSIA [n -S]\n",
  "INTELLIGENTZIAS": "INTELLIGENTZIA, (Russian) the intellectual or cultured classes, originally in Russia, also INTELLIGENTSIA [n]\n",
  "INTELLIGIBILITY": "the state of being intelligible [n]\n",
  "INTELLIGIBLE": "apprehensible by the intellect only [adj INTELLIGIBLY]\n",
  "INTELLIGIBLY": "INTELLIGIBLE, apprehensible by the intellect only [adv]\n",
  "INTELS": "INTEL, military intelligence [n]\n",
  "INTEMERATE": "pure, unspoiled [adj INTEMERATELY]\n",
  "INTEMERATELY": "INTEMERATE, pure, unspoiled [adv]\n",
  "INTEMERATENESS": "the state of being intemerate [n]\n",
  "INTEMPERANCE": "lack of moderation [n -S]\n",
  "INTEMPERANCES": "INTEMPERANCE, lack of moderation [n]\n",
  "INTEMPERANT": "a person who is intemperate [n -S]\n",
  "INTEMPERANTS": "INTEMPERANT, a person who is intemperate [n]\n",
  "INTEMPERATE": "not temperate [adj INTEMPERATELY]\n",
  "INTEMPERATELY": "INTEMPERATE, not temperate [adv]\n",
  "INTEMPERATENESS": "the state of being intemperate [n]\n",
  "INTEMPESTIVE": "unseasonable; untimely; inopportune [adj INTEMPESTIVELY]\n",
  "INTEMPESTIVELY": "INTEMPESTIVE, unseasonable; untimely; inopportune [adv]\n",
  "INTEMPESTIVITY": "inopportuneness [n]\n",
  "INTENABLE": "(obsolete) not tenable, also INTENIBLE, UNTENABLE [adj]\n",
  "INTEND": "to have as one's aim or purpose [v -ED, -ING, -S]\n",
  "INTENDANCE": "the office or employment of an intendant, also INTENDANCY [n -S]\n",
  "INTENDANCES": "INTENDANCE, the office or employment of an intendant, also INTENDANCY [n]\n",
  "INTENDANCIES": "INTENDANCY, the office or employment of an intendant, also INTENDANCE [n]\n",
  "INTENDANCY": "the office or employment of an intendant, also INTENDANCE [n INTENDANCIES]\n",
  "INTENDANT": "one who has the charge, direction, or management of some public business [n -S]\n",
  "INTENDANTS": "INTENDANT, one who has the charge, direction, or management of some public business [n]\n",
  "INTENDED": "meant [adj INTENDEDLY] / one whom one intends to marry [n -S]\n",
  "INTENDEDLY": "INTENDED, meant [adv]\n",
  "INTENDEDS": "INTENDED, one whom one intends to marry [n]\n",
  "INTENDER": "(obsolete) to make tender or weaken, also ENTENDER [v -ED, -ING, -S]\n",
  "INTENDERED": "INTENDER, (obsolete) to make tender or weaken, also ENTENDER [v]\n",
  "INTENDERING": "INTENDER, (obsolete) to make tender or weaken, also ENTENDER [v]\n",
  "INTENDERS": "INTENDER, (obsolete) to make tender or weaken, also ENTENDER [v]\n",
  "INTENDING": "INTEND, to have as one's aim or purpose [v]\n",
  "INTENDMENT": "the true meaning or intention of something, esp. a law [n -S]\n",
  "INTENDMENTS": "INTENDMENT, the true meaning or intention of something, esp. a law [n]\n",
  "INTENDS": "INTEND, to have as one's aim or purpose [v]\n",
  "INTENERATE": "to make tender; to soften [v INTENERATED, INTENERATING, INTENERATES]\n",
  "INTENERATED": "INTENERATE, to make tender; to soften [v]\n",
  "INTENERATES": "INTENERATE, to make tender; to soften [v]\n",
  "INTENERATING": "INTENERATE, to make tender; to soften [v]\n",
  "INTENERATION": "softening [n -S]\n",
  "INTENERATIONS": "INTENERATION, softening [n]\n",
  "INTENIBLE": "not capable of holding or retaining, also INTENABLE, UNTENABLE [adj]\n",
  "INTENSATE": "to intensify [v INTENSATED, INTENSATING, INTENSATES]\n",
  "INTENSATED": "INTENSATE, to intensify [v]\n",
  "INTENSATES": "INTENSATE, to intensify [v]\n",
  "INTENSATING": "INTENSATE, to intensify [v]\n",
  "INTENSATIVE": "giving force or emphasis [adj] / a word giving emphasis, also INTENSITIVE [n -S]\n",
  "INTENSATIVES": "INTENSATIVE, a word giving emphasis, also INTENSITIVE [n]\n",
  "INTENSE": "existing in a high degree [adj INTENSER, INTENSEST, INTENSELY]\n",
  "INTENSELY": "INTENSE, existing in a high degree [adv]\n",
  "INTENSENESS": "the state of being intense [n -ES]\n",
  "INTENSENESSES": "INTENSENESS, the state of being intense [n]\n",
  "INTENSER": "INTENSE, existing in a high degree [adj]\n",
  "INTENSEST": "INTENSE, existing in a high degree [adj]\n",
  "INTENSIFICATION": "the act of intensifying [n]\n",
  "INTENSIFIED": "INTENSIFY, to make intense [v]\n",
  "INTENSIFIER": "one that intensifies [n -S]\n",
  "INTENSIFIERS": "INTENSIFIER, one that intensifies [n]\n",
  "INTENSIFIES": "INTENSIFY, to make intense [v]\n",
  "INTENSIFY": "to make intense [v INTENSIFIED, INTENSIFYING, INTENSIFIES]\n",
  "INTENSIFYING": "INTENSIFY, to make intense [v]\n",
  "INTENSION": "the state of being stretched; as, the intension of a musical string [n -S]\n",
  "INTENSIONAL": "relating to intension [adj INTENSIONALLY]\n",
  "INTENSIONALITY": "the state of being intensional [n]\n",
  "INTENSIONALLY": "INTENSIONAL, relating to intension [adv]\n",
  "INTENSIONS": "INTENSION, the state of being stretched; as, the intension of a musical string [n]\n",
  "INTENSITIES": "INTENSITY, the state of being intense [n]\n",
  "INTENSITIVE": "giving force or emphasis [adj] / a word giving emphasis, also INTENSATIVE [n -S]\n",
  "INTENSITIVES": "INTENSITIVE, a word giving emphasis, also INTENSATIVE [n]\n",
  "INTENSITY": "the state of being intense [n INTENSITIES]\n",
  "INTENSIVE": "making intense [adj INTENSIVELY] / an intensifier [n -S]\n",
  "INTENSIVELY": "INTENSIVE, making intense [adv]\n",
  "INTENSIVENESS": "the state of being intensive [n -ES]\n",
  "INTENSIVENESSES": "INTENSIVENESS, the state of being intensive [n]\n",
  "INTENSIVES": "INTENSIVE, an intensifier [n]\n",
  "INTENT": "fixed, concentrating [adj INTENTLY] / a purpose [n -S]\n",
  "INTENTION": "design, purpose [n -S]\n",
  "INTENTIONAL": "done by intention or design [adj INTENTIONALLY]\n",
  "INTENTIONALITY": "the state of being intentional [n]\n",
  "INTENTIONALLY": "INTENTIONAL, done by intention or design [adv]\n",
  "INTENTIONED": "having an intention [adj]\n",
  "INTENTIONS": "INTENTION, design, purpose [n]\n",
  "INTENTIVE": "(archaic) attentive [adj]\n",
  "INTENTLY": "INTENT, fixed, concentrating [adv]\n",
  "INTENTNESS": "the state of being intent [n -ES]\n",
  "INTENTNESSES": "INTENTNESS, the state of being intent [n]\n",
  "INTENTS": "INTENT, a purpose [n]\n",
  "INTER": "to bury [v INTERRED, INTERRING, INTERS]\n",
  "INTERABANG": "a punctuation mark (?!) designed for use esp. at the end of an exclamatory rhetorical question, also INTERROBANG [n -S]\n",
  "INTERABANGS": "INTERABANG, a punctuation mark (?!) designed for use esp. at the end of an exclamatory rhetorical question, also INTERROBANG [n]\n",
  "INTERACT": "to act on one another [v -ED, -ING, -S]\n",
  "INTERACTANT": "one that interacts [n -S]\n",
  "INTERACTANTS": "INTERACTANT, one that interacts [n]\n",
  "INTERACTED": "INTERACT, to act on one another [v]\n",
  "INTERACTING": "INTERACT, to act on one another [v]\n",
  "INTERACTION": "mutual or reciprocal action or influence [n -S]\n",
  "INTERACTIONAL": "relating to interaction [adj]\n",
  "INTERACTIONISM": "the belief that mind and body act on each other [n -S]\n",
  "INTERACTIONISMS": "INTERACTIONISM, the belief that mind and body act on each other [n]\n",
  "INTERACTIONIST": "a believer in interactionism, the belief that mind and body act on each other [n -S]\n",
  "INTERACTIONISTS": "INTERACTIONIST, a believer in interactionism, the belief that mind and body act on each other [n]\n",
  "INTERACTIONS": "INTERACTION, mutual or reciprocal action or influence [n]\n",
  "INTERACTIVE": "mutually or reciprocally active [adj INTERACTIVELY]\n",
  "INTERACTIVELY": "INTERACTIVE, mutually or reciprocally active [adv]\n",
  "INTERACTIVITIES": "INTERACTIVITY, the state of being interactive [n]\n",
  "INTERACTIVITY": "the state of being interactive [n INTERACTIVITIES]\n",
  "INTERACTS": "INTERACT, to act on one another [v]\n",
  "INTERAGE": "including people of various ages [adj]\n",
  "INTERAGENCY": "between agencies [adj]\n",
  "INTERALLELIC": "taking place between alleles [adj]\n",
  "INTERALLIED": "relating to, composed of, or involving allies [adj]\n",
  "INTERAMBULACRA": "INTERAMBULACRUM, in sea urchins, a radial band between ambulacra [n]\n",
  "INTERAMBULACRAL": "of or like an interambulacrum [adj]\n",
  "INTERAMBULACRUM": "in sea urchins, a radial band between ambulacra [n INTERAMBULACRA]\n",
  "INTERANIMATION": "mutual animation [n -S]\n",
  "INTERANIMATIONS": "INTERANIMATION, mutual animation [n]\n",
  "INTERANNUAL": "between years [adj]\n",
  "INTERARCH": "to have intersecting arches [v -ED, -ING, -ES]\n",
  "INTERARCHED": "INTERARCH, to have intersecting arches [v]\n",
  "INTERARCHES": "INTERARCH, to have intersecting arches [v]\n",
  "INTERARCHING": "INTERARCH, to have intersecting arches [v]\n",
  "INTERATOMIC": "between atoms [adj]\n",
  "INTERBANK": "between or among banks [adj]\n",
  "INTERBASIN": "between two (river) basins [adj]\n",
  "INTERBED": "to insert between other layers [v INTERBEDDED, INTERBEDDING, INTERBEDS]\n",
  "INTERBEDDED": "INTERBED, to insert between other layers [v]\n",
  "INTERBEDDING": "the act of inserting between layers [n -S]\n",
  "INTERBEDDINGS": "INTERBEDDING, the act of inserting between layers [n]\n",
  "INTERBEDS": "INTERBED, to insert between other layers [v]\n",
  "INTERBEHAVIOR": "the behaviour of interaction between organisms, also INTERBEHAVIOUR [n -S]\n",
  "INTERBEHAVIORAL": "relating to interbehavior [adj]\n",
  "INTERBEHAVIORS": "INTERBEHAVIOR, the behaviour of interaction between organisms, also INTERBEHAVIOUR [n]\n",
  "INTERBEHAVIOUR": "interaction between multiple individuals, also INTERBEHAVIOR [n -S]\n",
  "INTERBEHAVIOURS": "INTERBEHAVIOUR, interaction between multiple individuals, also INTERBEHAVIOR [n]\n",
  "INTERBLEND": "to blend together [v INTERBLENDED, INTERBLENDING, INTERBLENDS]\n",
  "INTERBLENDED": "INTERBLEND, to blend together [v]\n",
  "INTERBLENDING": "INTERBLEND, to blend together [v]\n",
  "INTERBLENDS": "INTERBLEND, to blend together [v]\n",
  "INTERBOROUGH": "between boroughs [adj]\n",
  "INTERBRAIN": "the diencephalon [n -S]\n",
  "INTERBRAINS": "INTERBRAIN, the diencephalon [n]\n",
  "INTERBRANCH": "between branches [adj]\n",
  "INTERBRED": "INTERBREED, to breed together esp. of different races [v]\n",
  "INTERBREED": "to breed together esp. of different races [v INTERBRED, INTERBREEDING, INTERBREEDS]\n",
  "INTERBREEDING": "the act of breeding together [n -S]\n",
  "INTERBREEDINGS": "INTERBREEDING, the act of breeding together [n]\n",
  "INTERBREEDS": "INTERBREED, to breed together esp. of different races [v]\n",
  "INTERBROKER": "of a transaction, between brokers [adj]\n",
  "INTERCALAR": "(obsolete) inserted in a calendar (for example, a day or a month), also INTERCALARY [adj]\n",
  "INTERCALARILY": "INTERCALARY, inserted in a calendar (for example, a day or a month), also INTERCALAR [adv]\n",
  "INTERCALARY": "inserted in a calendar (for example, a day or a month), also INTERCALAR [adj INTERCALARILY]\n",
  "INTERCALATE": "to insert (as a day) in a calendar [v INTERCALATED, INTERCALATING, INTERCALATES]\n",
  "INTERCALATED": "INTERCALATE, to insert (as a day) in a calendar [v]\n",
  "INTERCALATES": "INTERCALATE, to insert (as a day) in a calendar [v]\n",
  "INTERCALATING": "INTERCALATE, to insert (as a day) in a calendar [v]\n",
  "INTERCALATION": "an insertion or interposing, as of a word between other words in a sentence [n -S]\n",
  "INTERCALATIONS": "INTERCALATION, an insertion or interposing, as of a word between other words in a sentence [n]\n",
  "INTERCALATIVE": "relating to intercalation, an insertion or interposing, as of a word between other words in a sentence [adj]\n",
  "INTERCAMPUS": "between campuses [adj]\n",
  "INTERCASTE": "between castes e.g. an intercaste marriage [adj]\n",
  "INTERCEDE": "to act as peacemaker between two parties, mediate [v INTERCEDED, INTERCEDING, INTERCEDES]\n",
  "INTERCEDED": "INTERCEDE, to act as peacemaker between two parties, mediate [v]\n",
  "INTERCEDENT": "serving to intercede [adj]\n",
  "INTERCEDER": "one who intercedes [n -S]\n",
  "INTERCEDERS": "INTERCEDER, one who intercedes [n]\n",
  "INTERCEDES": "INTERCEDE, to act as peacemaker between two parties, mediate [v]\n",
  "INTERCEDING": "INTERCEDE, to act as peacemaker between two parties, mediate [v]\n",
  "INTERCELL": "between cells [adj]\n",
  "INTERCELLULAR": "between cells [adj]\n",
  "INTERCENSAL": "occurring between censuses [adj]\n",
  "INTERCEPT": "to stop and seize on the way from one place to another [v -ED, -ING, -S]\n",
  "INTERCEPTED": "INTERCEPT, to stop and seize on the way from one place to another [v]\n",
  "INTERCEPTER": "one who intercepts, also INTERCEPTOR [n -S]\n",
  "INTERCEPTERS": "INTERCEPTER, one who intercepts, also INTERCEPTOR [n]\n",
  "INTERCEPTING": "INTERCEPT, to stop and seize on the way from one place to another [v]\n",
  "INTERCEPTION": "the action of intercepting [n -S]\n",
  "INTERCEPTIONS": "INTERCEPTION, the action of intercepting [n]\n",
  "INTERCEPTIVE": "relating to interception [adj]\n",
  "INTERCEPTOR": "one who intercepts, also INTERCEPTER [n -S]\n",
  "INTERCEPTORS": "INTERCEPTOR, one who intercepts, also INTERCEPTER [n]\n",
  "INTERCEPTS": "INTERCEPT, to stop and seize on the way from one place to another [v]\n",
  "INTERCESSION": "the act of interceding [n -S]\n",
  "INTERCESSIONAL": "relating to intercession [adj]\n",
  "INTERCESSIONS": "INTERCESSION, the act of interceding [n]\n",
  "INTERCESSOR": "one who intercedes [n -S]\n",
  "INTERCESSORIAL": "interceding, also INTERCESSORY [adj]\n",
  "INTERCESSORS": "INTERCESSOR, one who intercedes [n]\n",
  "INTERCESSORY": "interceding, also INTERCESSORIAL [adj]\n",
  "INTERCHAIN": "to link together; to unite closely or firmly, as by a chain [v -ED, -ING, -S]\n",
  "INTERCHAINED": "INTERCHAIN, to link together; to unite closely or firmly, as by a chain [v]\n",
  "INTERCHAINING": "INTERCHAIN, to link together; to unite closely or firmly, as by a chain [v]\n",
  "INTERCHAINS": "INTERCHAIN, to link together; to unite closely or firmly, as by a chain [v]\n",
  "INTERCHANGE": "to put each of (two things) in the place of the other, also ENTERCHAUNGE [v INTERCHANGED, INTERCHANGING, INTERCHANGES]\n",
  "INTERCHANGEABLE": "capable of being interchanged [adj INTERCHANGEABLY]\n",
  "INTERCHANGEABLY": "INTERCHANGEABLE, capable of being interchanged [adv]\n",
  "INTERCHANGED": "INTERCHANGE, to put each of (two things) in the place of the other, also ENTERCHAUNGE [v]\n",
  "INTERCHANGEMENT": "(Shakespeare) exchange, mutual transfer [n]\n",
  "INTERCHANGER": "one who interchanges [n -S]\n",
  "INTERCHANGERS": "INTERCHANGER, one who interchanges [n]\n",
  "INTERCHANGES": "INTERCHANGE, to put each of (two things) in the place of the other, also ENTERCHAUNGE [v]\n",
  "INTERCHANGING": "INTERCHANGE, to put each of (two things) in the place of the other, also ENTERCHAUNGE [v]\n",
  "INTERCHANNEL": "between channels [adj]\n",
  "INTERCHAPTER": "an intercalary chapter in a book, not numbered in the general sequence [n -S]\n",
  "INTERCHAPTERS": "INTERCHAPTER, an intercalary chapter in a book, not numbered in the general sequence [n]\n",
  "INTERCHURCH": "between churches [adj]\n",
  "INTERCIPIENT": "(obsolete) intercepting [adj] / an interceptor [n -S]\n",
  "INTERCIPIENTS": "INTERCIPIENT, an interceptor [n]\n",
  "INTERCITY": "between cities [adj]\n",
  "INTERCLAN": "between clans [adj]\n",
  "INTERCLASS": "between classes e.g. an intercaste marriage [adj]\n",
  "INTERCLAVICLE": "a membrane bone between and beneath the clavicles, present in some fossil amphibians, all reptiles except snakes, and monotremes [n -S]\n",
  "INTERCLAVICLES": "INTERCLAVICLE, a membrane bone between and beneath the clavicles, present in some fossil amphibians, all reptiles except snakes, and monotremes [n]\n",
  "INTERCLAVICULAR": "relating to the interclavicle, a bone between and beneath the clavicles [adj]\n",
  "INTERCLUB": "between clubs [adj]\n",
  "INTERCLUDE": "to block; to cut off [v INTERCLUDED, INTERCLUDING, INTERCLUDES]\n",
  "INTERCLUDED": "INTERCLUDE, to block; to cut off [v]\n",
  "INTERCLUDES": "INTERCLUDE, to block; to cut off [v]\n",
  "INTERCLUDING": "INTERCLUDE, to block; to cut off [v]\n",
  "INTERCLUSION": "the act of intercluding, blocking off [n -S]\n",
  "INTERCLUSIONS": "INTERCLUSION, the act of intercluding, blocking off [n]\n",
  "INTERCLUSTER": "between clusters [adj]\n",
  "INTERCOASTAL": "between coasts [adj]\n",
  "INTERCOLLEGIATE": "existing, carried on, or participating in activities between colleges [adj]\n",
  "INTERCOLLINE": "lying between hills [adj]\n",
  "INTERCOLONIAL": "between colonies [adj INTERCOLONIALLY]\n",
  "INTERCOLONIALLY": "INTERCOLONIAL, between colonies [adv]\n",
  "INTERCOLUMNAR": "between columns [adj]\n",
  "INTERCOM": "a type of communication system [n -S]\n",
  "INTERCOMMUNAL": "between communities [adj]\n",
  "INTERCOMMUNE": "to commune mutually or together [v INTERCOMMUNED, INTERCOMMUNING, INTERCOMMUNES]\n",
  "INTERCOMMUNED": "INTERCOMMUNE, to commune mutually or together [v]\n",
  "INTERCOMMUNES": "INTERCOMMUNE, to commune mutually or together [v]\n",
  "INTERCOMMUNING": "INTERCOMMUNE, to commune mutually or together [v]\n",
  "INTERCOMMUNION": "interdenominational participation in communion [n -S]\n",
  "INTERCOMMUNIONS": "INTERCOMMUNION, interdenominational participation in communion [n]\n",
  "INTERCOMMUNITY": "between communities [adj]\n",
  "INTERCOMPANY": "between companies [adj]\n",
  "INTERCOMPARE": "to make a comparison between [v INTERCOMPARED, INTERCOMPARING, INTERCOMPARES]\n",
  "INTERCOMPARED": "INTERCOMPARE, to make a comparison between [v]\n",
  "INTERCOMPARES": "INTERCOMPARE, to make a comparison between [v]\n",
  "INTERCOMPARING": "INTERCOMPARE, to make a comparison between [v]\n",
  "INTERCOMPARISON": "a comparison between two things [n]\n",
  "INTERCOMS": "INTERCOM, a type of communication system [n]\n",
  "INTERCONNECT": "to connect with one another [v -ED, -ING, -S]\n",
  "INTERCONNECTED": "INTERCONNECT, to connect with one another [v]\n",
  "INTERCONNECTING": "INTERCONNECT, to connect with one another [v]\n",
  "INTERCONNECTION": "a connection between things [n]\n",
  "INTERCONNECTOR": "a device or feeder by which electricity generated in an area or country may be exported to another area or country [n -S]\n",
  "INTERCONNECTORS": "INTERCONNECTOR, a device or feeder by which electricity generated in an area or country may be exported to another area or country [n]\n",
  "INTERCONNECTS": "INTERCONNECT, to connect with one another [v]\n",
  "INTERCONNEXION": "a mutual connexion [n -S]\n",
  "INTERCONNEXIONS": "INTERCONNEXION, a mutual connexion [n]\n",
  "INTERCONVERSION": "mutual conversion [n]\n",
  "INTERCONVERT": "to convert (two or more things) into one another [v -ED, -ING, -S]\n",
  "INTERCONVERTED": "INTERCONVERT, to convert (two or more things) into one another [v]\n",
  "INTERCONVERTING": "INTERCONVERT, to convert (two or more things) into one another [v]\n",
  "INTERCONVERTS": "INTERCONVERT, to convert (two or more things) into one another [v]\n",
  "INTERCOOL": "to cool by means of an intercooler, a heat exchanger in a turbocharger [v -ED, -ING, -S]\n",
  "INTERCOOLED": "INTERCOOL, to cool by means of an intercooler, a heat exchanger in a turbocharger [v]\n",
  "INTERCOOLER": "a heat exchanger in a turbocharger [n -S]\n",
  "INTERCOOLERS": "INTERCOOLER, a heat exchanger in a turbocharger [n]\n",
  "INTERCOOLING": "INTERCOOL, to cool by means of an intercooler, a heat exchanger in a turbocharger [v]\n",
  "INTERCOOLS": "INTERCOOL, to cool by means of an intercooler, a heat exchanger in a turbocharger [v]\n",
  "INTERCORPORATE": "between corporations [adj]\n",
  "INTERCORRELATE": "to correlate together [v INTERCORRELATED, INTERCORRELATES]\n",
  "INTERCORRELATED": "INTERCORRELATE, to correlate together [v]\n",
  "INTERCORRELATES": "INTERCORRELATE, to correlate together [v]\n",
  "INTERCORTICAL": "between cortices [adj]\n",
  "INTERCOSTAL": "situated between the ribs [adj INTERCOSTALLY] / an intercostal muscle [n -S]\n",
  "INTERCOSTALLY": "INTERCOSTAL, situated between the ribs [adv]\n",
  "INTERCOSTALS": "INTERCOSTAL, an intercostal muscle [n]\n",
  "INTERCOUNTRY": "between countries [adj]\n",
  "INTERCOUNTY": "between counties [adj]\n",
  "INTERCOUPLE": "between couples [adj]\n",
  "INTERCOURSE": "connection or dealings between persons or groups [n -S]\n",
  "INTERCOURSES": "INTERCOURSE, connection or dealings between persons or groups [n]\n",
  "INTERCRATER": "(of a flat plain on a planet's surface) situated between two large craters [adj]\n",
  "INTERCROP": "to plant a second crop between the rows of the first [v INTERCROPPED, INTERCROPPING, INTERCROPS]\n",
  "INTERCROPPED": "INTERCROP, to plant a second crop between the rows of the first [v]\n",
  "INTERCROPPING": "INTERCROP, to plant a second crop between the rows of the first [v]\n",
  "INTERCROPS": "INTERCROP, to plant a second crop between the rows of the first [v]\n",
  "INTERCROSS": "to cross each other, as lines [v -ED, -ING, -ES]\n",
  "INTERCROSSED": "INTERCROSS, to cross each other, as lines [v]\n",
  "INTERCROSSES": "INTERCROSS, to cross each other, as lines [v]\n",
  "INTERCROSSING": "INTERCROSS, to cross each other, as lines [v]\n",
  "INTERCRURAL": "within or pertaining to the area between the legs [adj]\n",
  "INTERCULTURAL": "between cultures, also INTERCULTURE [adj INTERCULTURALLY]\n",
  "INTERCULTURALLY": "INTERCULTURAL, between cultures, also INTERCULTURE [adv]\n",
  "INTERCULTURE": "interaction between one or more cultures [n -S]\n",
  "INTERCULTURES": "INTERCULTURE, interaction between one or more cultures [n]\n",
  "INTERCURRENCE": "the state of being intercurrent [n -S]\n",
  "INTERCURRENCES": "INTERCURRENCE, the state of being intercurrent [n]\n",
  "INTERCURRENT": "occurring during an existing disease [adj INTERCURRENTLY] / an intervening circumstance or event [n -S]\n",
  "INTERCURRENTLY": "INTERCURRENT, occurring during an existing disease [adv]\n",
  "INTERCURRENTS": "INTERCURRENT, an intervening circumstance or event [n]\n",
  "INTERCUT": "to alternate camera shots in filming [v INTERCUT, INTERCUTTING, INTERCUTS]\n",
  "INTERCUTS": "INTERCUT, to alternate camera shots in filming [v]\n",
  "INTERCUTTING": "INTERCUT, to alternate camera shots in filming [v]\n",
  "INTERDASH": "to dash between or among; to intersperse [v -ED, -ING, -ES]\n",
  "INTERDASHED": "INTERDASH, to dash between or among; to intersperse [v]\n",
  "INTERDASHES": "INTERDASH, to dash between or among; to intersperse [v]\n",
  "INTERDASHING": "INTERDASH, to dash between or among; to intersperse [v]\n",
  "INTERDEAL": "(archaic) to intrigue, also ENTERDEALE [v INTERDEALT, INTERDEALING, INTERDEALS]\n",
  "INTERDEALER": "one who interdeals [n -S]\n",
  "INTERDEALERS": "INTERDEALER, one who interdeals [n]\n",
  "INTERDEALING": "INTERDEAL, (archaic) to intrigue, also ENTERDEALE [v]\n",
  "INTERDEALS": "INTERDEAL, (archaic) to intrigue, also ENTERDEALE [v]\n",
  "INTERDEALT": "INTERDEAL, (archaic) to intrigue, also ENTERDEALE [v]\n",
  "INTERDENTAL": "pronounced with the tip of the tongue between upper and lower teeth [adj INTERDENTALLY]\n",
  "INTERDENTALLY": "INTERDENTAL, pronounced with the tip of the tongue between upper and lower teeth [adv]\n",
  "INTERDEPEND": "to depend on one another [v -ED, -ING, -S]\n",
  "INTERDEPENDED": "INTERDEPEND, to depend on one another [v]\n",
  "INTERDEPENDENCE": "the state of being interdependent, also INTERDEPENDENCY [n]\n",
  "INTERDEPENDENCY": "the state of being interdependent, also INTERDEPENDENCE [n]\n",
  "INTERDEPENDENT": "mutually dependent [adj]\n",
  "INTERDEPENDING": "INTERDEPEND, to depend on one another [v]\n",
  "INTERDEPENDS": "INTERDEPEND, to depend on one another [v]\n",
  "INTERDIALECTAL": "between dialects [adj]\n",
  "INTERDICT": "to forbid, prohibit [v -ED, -ING, -S]\n",
  "INTERDICTED": "INTERDICT, to forbid, prohibit [v]\n",
  "INTERDICTING": "INTERDICT, to forbid, prohibit [v]\n",
  "INTERDICTION": "the act of interdicting [n -S]\n",
  "INTERDICTIONS": "INTERDICTION, the act of interdicting [n]\n",
  "INTERDICTIVE": "serving to interdict [adj INTERDICTIVELY]\n",
  "INTERDICTIVELY": "INTERDICTIVE, serving to interdict [adv]\n",
  "INTERDICTOR": "one who interdicts [n -S]\n",
  "INTERDICTORS": "INTERDICTOR, one who interdicts [n]\n",
  "INTERDICTORY": "serving to interdict [adj]\n",
  "INTERDICTS": "INTERDICT, to forbid, prohibit [v]\n",
  "INTERDIFFUSE": "to diffuse between [v INTERDIFFUSED, INTERDIFFUSING, INTERDIFFUSES]\n",
  "INTERDIFFUSED": "INTERDIFFUSE, to diffuse between [v]\n",
  "INTERDIFFUSES": "INTERDIFFUSE, to diffuse between [v]\n",
  "INTERDIFFUSING": "INTERDIFFUSE, to diffuse between [v]\n",
  "INTERDIFFUSION": "the process of diffusing and mixing freely so as to approach a homogeneous mixture [n -S]\n",
  "INTERDIFFUSIONS": "INTERDIFFUSION, the process of diffusing and mixing freely so as to approach a homogeneous mixture [n]\n",
  "INTERDIGITAL": "between digits [adj]\n",
  "INTERDIGITATE": "to become interlocked like the fingers of folded hands [v INTERDIGITATED, INTERDIGITATING, INTERDIGITATES]\n",
  "INTERDIGITATED": "INTERDIGITATE, to become interlocked like the fingers of folded hands [v]\n",
  "INTERDIGITATES": "INTERDIGITATE, to become interlocked like the fingers of folded hands [v]\n",
  "INTERDIGITATING": "INTERDIGITATE, to become interlocked like the fingers of folded hands [v]\n",
  "INTERDIGITATION": "the act of interdigitating, interlocking the fingers [n]\n",
  "INTERDINE": "to eat together [v INTERDINED, INTERDINING, INTERDINES]\n",
  "INTERDINED": "INTERDINE, to eat together [v]\n",
  "INTERDINES": "INTERDINE, to eat together [v]\n",
  "INTERDINING": "INTERDINE, to eat together [v]\n",
  "INTERDISTRICT": "between districts [adj]\n",
  "INTERDIVISIONAL": "between divisions [adj]\n",
  "INTERDOMINION": "between dominions [adj]\n",
  "INTERELECTRODE": "between electrodes [adj]\n",
  "INTERELECTRON": "operating between electrons [adj]\n",
  "INTERELECTRONIC": "operating between electrons [adj]\n",
  "INTEREPIDEMIC": "between epidemics [adj]\n",
  "INTERESS": "(obsolete) to interest, also INTERESSE [v -ED, -ING, -ES]\n",
  "INTERESSE": "(obsolete) an interest [n -S] / to interest, also INTERESS [v INTERESSED, INTERESSING, INTERESSES]\n",
  "INTERESSED": "INTERESS, (obsolete) to interest, also INTERESSE [v]\n",
  "INTERESSES": "INTERESS, (obsolete) to interest, also INTERESSE [v]\n",
  "INTERESSING": "INTERESS, (obsolete) to interest, also INTERESSE [v]\n",
  "INTEREST": "to engage the attention of [v -ED, -ING, -S]\n",
  "INTERESTED": "INTEREST, to engage the attention of [v]\n",
  "INTERESTEDLY": "INTERESTED, INTEREST, to engage the attention of [adv]\n",
  "INTERESTEDNESS": "the state of being interested [n]\n",
  "INTERESTING": "INTEREST, to engage the attention of [v]\n",
  "INTERESTINGLY": "INTERESTING, INTEREST, to engage the attention of [adv]\n",
  "INTERESTINGNESS": "the state of being interesting [n]\n",
  "INTERESTS": "INTEREST, to engage the attention of [v]\n",
  "INTERETHNIC": "taking place between ethnic groups [adj]\n",
  "INTERFACE": "to interact or operate compatibly (with) [v INTERFACED, INTERFACING, INTERFACES]\n",
  "INTERFACED": "INTERFACE, to interact or operate compatibly (with) [v]\n",
  "INTERFACES": "INTERFACE, to interact or operate compatibly (with) [v]\n",
  "INTERFACIAL": "between plane faces; of an interface [adj INTERFACIALLY]\n",
  "INTERFACIALLY": "INTERFACIAL, between plane faces; of an interface [adv]\n",
  "INTERFACING": "firm material sewn between layers of fabric to shape and stiffen a garment [n -S]\n",
  "INTERFACINGS": "INTERFACING, firm material sewn between layers of fabric to shape and stiffen a garment [n]\n",
  "INTERFACULTY": "between faculties [adj]\n",
  "INTERFAITH": "between faiths [adj]\n",
  "INTERFAMILIAL": "between families [adj]\n",
  "INTERFAMILY": "between family [adj]\n",
  "INTERFASCICULAR": "situated between fascicles [adj]\n",
  "INTERFEMORAL": "situated between the thighs, connecting the hind limbs [adj]\n",
  "INTERFERE": "to intervene, come in the way [v INTERFERED, INTERFERING, INTERFERES]\n",
  "INTERFERED": "INTERFERE, to intervene, come in the way [v]\n",
  "INTERFERENCE": "the act of interfering [n -S]\n",
  "INTERFERENCES": "INTERFERENCE, the act of interfering [n]\n",
  "INTERFERENTIAL": "of the nature of interference [adj]\n",
  "INTERFERER": "one who interferes [n -S]\n",
  "INTERFERERS": "INTERFERER, one who interferes [n]\n",
  "INTERFERES": "INTERFERE, to intervene, come in the way [v]\n",
  "INTERFERING": "INTERFERE, to intervene, come in the way [v]\n",
  "INTERFERINGLY": "INTERFERING, INTERFERE, to intervene, come in the way [adv]\n",
  "INTERFEROGRAM": "a photographic record made by an apparatus for recording optical interference phenomena [n -S]\n",
  "INTERFEROGRAMS": "INTERFEROGRAM, a photographic record made by an apparatus for recording optical interference phenomena [n]\n",
  "INTERFEROMETER": "an instrument for analysing spectra of light [n -S]\n",
  "INTERFEROMETERS": "INTERFEROMETER, an instrument for analysing spectra of light [n]\n",
  "INTERFEROMETRIC": "relating to interferometry, the use of two telescopes separated [adj]\n",
  "INTERFEROMETRY": "the use of two telescopes separated [n]\n",
  "INTERFERON": "any of several proteins produced by cells infected with a virus and having the ability to inhibit viral growth [n -S]\n",
  "INTERFERONS": "INTERFERON, any of several proteins produced by cells infected with a virus and having the ability to inhibit viral growth [n]\n",
  "INTERFERTILE": "capable of interbreeding [adj]\n",
  "INTERFERTILITY": "the state of being interfertile [n]\n",
  "INTERFIBER": "between fibers, also INTERFIBRE [adj]\n",
  "INTERFIBRE": "occurring or situated between two or more fibres, also INTERFIBER [adj]\n",
  "INTERFILE": "to arrange in or add to a file [v INTERFILED, INTERFILING, INTERFILES]\n",
  "INTERFILED": "INTERFILE, to arrange in or add to a file [v]\n",
  "INTERFILES": "INTERFILE, to arrange in or add to a file [v]\n",
  "INTERFILING": "INTERFILE, to arrange in or add to a file [v]\n",
  "INTERFIRM": "between firms [adj]\n",
  "INTERFLOW": "to flow in [v -ED, -ING, -S]\n",
  "INTERFLOWED": "INTERFLOW, to flow in [v]\n",
  "INTERFLOWING": "INTERFLOW, to flow in [v]\n",
  "INTERFLOWS": "INTERFLOW, to flow in [v]\n",
  "INTERFLUENCE": "a flowing between [n -S]\n",
  "INTERFLUENCES": "INTERFLUENCE, a flowing between [n]\n",
  "INTERFLUENT": "flowing between or together, also INTERFLUOUS [adj]\n",
  "INTERFLUOUS": "flowing between or together, also INTERFLUENT [adj]\n",
  "INTERFLUVE": "an area between two rivers that flow in the same direction [n -S]\n",
  "INTERFLUVES": "INTERFLUVE, an area between two rivers that flow in the same direction [n]\n",
  "INTERFLUVIAL": "between two rivers flowing in same direction [adj]\n",
  "INTERFOLD": "to fold together or within each other [v -ED, -ING, -S]\n",
  "INTERFOLDED": "INTERFOLD, to fold together or within each other [v]\n",
  "INTERFOLDING": "INTERFOLD, to fold together or within each other [v]\n",
  "INTERFOLDS": "INTERFOLD, to fold together or within each other [v]\n",
  "INTERFOLIATE": "to interleave [v INTERFOLIATED, INTERFOLIATING, INTERFOLIATES]\n",
  "INTERFOLIATED": "INTERFOLIATE, to interleave [v]\n",
  "INTERFOLIATES": "INTERFOLIATE, to interleave [v]\n",
  "INTERFOLIATING": "INTERFOLIATE, to interleave [v]\n",
  "INTERFRATERNITY": "between fraternities [n]\n",
  "INTERFRETTED": "interlaced [adj]\n",
  "INTERFRONTAL": "between the frontal bones [adj]\n",
  "INTERFUSE": "to pour or spread between or among [v INTERFUSED, INTERFUSING, INTERFUSES]\n",
  "INTERFUSED": "INTERFUSE, to pour or spread between or among [v]\n",
  "INTERFUSES": "INTERFUSE, to pour or spread between or among [v]\n",
  "INTERFUSING": "INTERFUSE, to pour or spread between or among [v]\n",
  "INTERFUSION": "the act of interfusing [n -S]\n",
  "INTERFUSIONS": "INTERFUSION, the act of interfusing [n]\n",
  "INTERGALACTIC": "situated in or relating to the spaces between galaxies [adj]\n",
  "INTERGANG": "between gangs [adj]\n",
  "INTERGENERATION": "between generations [n]\n",
  "INTERGENERIC": "existing, occurring, or arising between genera [adj]\n",
  "INTERGLACIAL": "occurring between two periods of glacial action [adj] / a retreat of ice between glaciations [n -S]\n",
  "INTERGLACIALS": "INTERGLACIAL, a retreat of ice between glaciations [n]\n",
  "INTERGRADATION": "the condition of an individual or population that intergrades [n -S]\n",
  "INTERGRADATIONS": "INTERGRADATION, the condition of an individual or population that intergrades [n]\n",
  "INTERGRADE": "an intermediate grade [n -S] / to merge or shade by means of intermediate steps [v INTERGRADED, INTERGRADING, INTERGRADES]\n",
  "INTERGRADED": "INTERGRADE, to merge or shade by means of intermediate steps [v]\n",
  "INTERGRADES": "INTERGRADE, to merge or shade by means of intermediate steps [v]\n",
  "INTERGRADIENT": "relating to an intergrade [adj]\n",
  "INTERGRADING": "INTERGRADE, to merge or shade by means of intermediate steps [v]\n",
  "INTERGRAFT": "to graft between [v -ED, -ING, -S]\n",
  "INTERGRAFTED": "INTERGRAFT, to graft between [v]\n",
  "INTERGRAFTING": "INTERGRAFT, to graft between [v]\n",
  "INTERGRAFTS": "INTERGRAFT, to graft between [v]\n",
  "INTERGRANULAR": "between granules [adj]\n",
  "INTERGREW": "INTERGROW, to grow into or among each other [v]\n",
  "INTERGROUP": "a group between other groups [n -S]\n",
  "INTERGROUPS": "INTERGROUP, a group between other groups [n]\n",
  "INTERGROW": "to grow into or among each other [v INTERGREW, INTERGROWN, INTERGROWING, INTERGROWS]\n",
  "INTERGROWING": "INTERGROW, to grow into or among each other [v]\n",
  "INTERGROWN": "INTERGROW, to grow into or among each other [v]\n",
  "INTERGROWS": "INTERGROW, to grow into or among each other [v]\n",
  "INTERGROWTH": "a growing between or together [n -S]\n",
  "INTERGROWTHS": "INTERGROWTH, a growing between or together [n]\n",
  "INTERIM": "(Latin) temporary, provisional [adj] / the time between [n -S]\n",
  "INTERIMS": "INTERIM, the time between [n]\n",
  "INTERINDIVIDUAL": "between individuals [adj]\n",
  "INTERINDUSTRY": "between industries [adj]\n",
  "INTERINFLUENCE": "to influence reciprocally [v INTERINFLUENCED, INTERINFLUENCES]\n",
  "INTERINFLUENCED": "INTERINFLUENCE, to influence reciprocally [v]\n",
  "INTERINFLUENCES": "INTERINFLUENCE, to influence reciprocally [v]\n",
  "INTERINVOLVE": "to involve between [v INTERINVOLVED, INTERINVOLVING, INTERINVOLVES]\n",
  "INTERINVOLVED": "INTERINVOLVE, to involve between [v]\n",
  "INTERINVOLVES": "INTERINVOLVE, to involve between [v]\n",
  "INTERINVOLVING": "INTERINVOLVE, to involve between [v]\n",
  "INTERIONIC": "between ions [adj]\n",
  "INTERIOR": "internal [adj INTERIORLY] / the inside [n -S]\n",
  "INTERIORISATION": "the process of interiorising, also INTERIORIZATION [n]\n",
  "INTERIORISE": "to make interior [v INTERIORISED, INTERIORISING, INTERIORISES]\n",
  "INTERIORISED": "INTERIORISE, to make interior [v]\n",
  "INTERIORISES": "INTERIORISE, to make interior [v]\n",
  "INTERIORISING": "INTERIORISE, to make interior [v]\n",
  "INTERIORITIES": "INTERIORITY, interior quality or character [n]\n",
  "INTERIORITY": "interior quality or character [n INTERIORITIES]\n",
  "INTERIORIZATION": "the act of interiorizing, also INTERIORISATION [n]\n",
  "INTERIORIZE": "to make interior, also INTERIORISE [v INTERIORIZED, INTERIORIZING, INTERIORIZES]\n",
  "INTERIORIZED": "INTERIORIZE, to make interior, also INTERIORISE [v]\n",
  "INTERIORIZES": "INTERIORIZE, to make interior, also INTERIORISE [v]\n",
  "INTERIORIZING": "INTERIORIZE, to make interior, also INTERIORISE [v]\n",
  "INTERIORLY": "INTERIOR, internal [adv]\n",
  "INTERIORS": "INTERIOR, the inside [n]\n",
  "INTERISLAND": "between islands [adj]\n",
  "INTERJACENCIES": "INTERJACENCY, the state of being situated between [n]\n",
  "INTERJACENCY": "the state of being situated between [n INTERJACENCIES]\n",
  "INTERJACENT": "intervening; situated between two things [adj]\n",
  "INTERJACULATE": "to ejaculate in interruption [v INTERJACULATED, INTERJACULATING, INTERJACULATES]\n",
  "INTERJACULATED": "INTERJACULATE, to ejaculate in interruption [v]\n",
  "INTERJACULATES": "INTERJACULATE, to ejaculate in interruption [v]\n",
  "INTERJACULATING": "INTERJACULATE, to ejaculate in interruption [v]\n",
  "INTERJACULATORY": "exclamatory [adj]\n",
  "INTERJECT": "to interpose, throw between [v -ED, -ING, -S]\n",
  "INTERJECTED": "INTERJECT, to interpose, throw between [v]\n",
  "INTERJECTING": "INTERJECT, to interpose, throw between [v]\n",
  "INTERJECTION": "a word or phrase used in exclamation [n -S]\n",
  "INTERJECTIONAL": "of, relating to, or constituting an interjection [adj]\n",
  "INTERJECTIONARY": "like an interjection [adj]\n",
  "INTERJECTIONS": "INTERJECTION, a word or phrase used in exclamation [n]\n",
  "INTERJECTOR": "one who interjects [n -S]\n",
  "INTERJECTORS": "INTERJECTOR, one who interjects [n]\n",
  "INTERJECTORY": "relating to interjection [adj]\n",
  "INTERJECTS": "INTERJECT, to interpose, throw between [v]\n",
  "INTERJECTURAL": "like an interjection [adj]\n",
  "INTERJOIN": "(Shakespeare) to join together [v -ED, -ING, -S]\n",
  "INTERJOINED": "INTERJOIN, (Shakespeare) to join together [v]\n",
  "INTERJOINING": "INTERJOIN, (Shakespeare) to join together [v]\n",
  "INTERJOINS": "INTERJOIN, (Shakespeare) to join together [v]\n",
  "INTERKINESES": "INTERKINESIS, the resting stage between two divisions of mitosis [n]\n",
  "INTERKINESIS": "the resting stage between two divisions of mitosis [n INTERKINESES]\n",
  "INTERKNIT": "to knit together [v INTERKNITTED, INTERKNITTING, INTERKNITS]\n",
  "INTERKNITS": "INTERKNIT, to knit together [v]\n",
  "INTERKNITTED": "INTERKNIT, to knit together [v]\n",
  "INTERKNITTING": "INTERKNIT, to knit together [v]\n",
  "INTERKNOT": "to knot together [v INTERKNOTTED, INTERKNOTTING, INTERKNOTS]\n",
  "INTERKNOTS": "INTERKNOT, to knot together [v]\n",
  "INTERKNOTTED": "INTERKNOT, to knot together [v]\n",
  "INTERKNOTTING": "INTERKNOT, to knot together [v]\n",
  "INTERLACE": "to lace, weave together [v INTERLACED, INTERLACING, INTERLACES]\n",
  "INTERLACED": "INTERLACE, to lace, weave together [v]\n",
  "INTERLACEDLY": "INTERLACED, INTERLACE, to lace, weave together [adv]\n",
  "INTERLACEMENT": "the state of being interlaced [n -S]\n",
  "INTERLACEMENTS": "INTERLACEMENT, the state of being interlaced [n]\n",
  "INTERLACES": "INTERLACE, to lace, weave together [v]\n",
  "INTERLACING": "INTERLACE, to lace, weave together [v]\n",
  "INTERLACUSTRINE": "situated between lakes [adj]\n",
  "INTERLAID": "INTERLAY, to place between [v]\n",
  "INTERLAMINAR": "between layers [adj]\n",
  "INTERLAMINATE": "to insert between layers [v INTERLAMINATED, INTERLAMINATING, INTERLAMINATES]\n",
  "INTERLAMINATED": "INTERLAMINATE, to insert between layers [v]\n",
  "INTERLAMINATES": "INTERLAMINATE, to insert between layers [v]\n",
  "INTERLAMINATING": "INTERLAMINATE, to insert between layers [v]\n",
  "INTERLAMINATION": "insertion between layers [n]\n",
  "INTERLAP": "to lap over one another [v INTERLAPPED, INTERLAPPING, INTERLAPS]\n",
  "INTERLAPPED": "INTERLAP, to lap over one another [v]\n",
  "INTERLAPPING": "INTERLAP, to lap over one another [v]\n",
  "INTERLAPS": "INTERLAP, to lap over one another [v]\n",
  "INTERLARD": "to place lard or bacon amongst; to mix, as fat meat with lean [v -ED, -ING, -S]\n",
  "INTERLARDED": "INTERLARD, to place lard or bacon amongst; to mix, as fat meat with lean [v]\n",
  "INTERLARDING": "INTERLARD, to place lard or bacon amongst; to mix, as fat meat with lean [v]\n",
  "INTERLARDS": "INTERLARD, to place lard or bacon amongst; to mix, as fat meat with lean [v]\n",
  "INTERLAY": "to place between [v INTERLAID, INTERLAYING, INTERLAYS]\n",
  "INTERLAYER": "a layer between other layers [n -S] / to create a layer between other layers [v -ED, -ING, -S]\n",
  "INTERLAYERED": "INTERLAYER, to create a layer between other layers [v]\n",
  "INTERLAYERING": "the act of creating a layer between other layers [n -S]\n",
  "INTERLAYERINGS": "INTERLAYERING, the act of creating a layer between other layers [n]\n",
  "INTERLAYERS": "INTERLAYER, to create a layer between other layers [v]\n",
  "INTERLAYING": "INTERLAY, to place between [v]\n",
  "INTERLAYS": "INTERLAY, to place between [v]\n",
  "INTERLEAF": "a leaf inserted between other leaves; a blank leaf inserted, as in a book [n INTERLEAVES]\n",
  "INTERLEAVE": "to arrange in or as if in alternate layers [v INTERLEAVED, INTERLEAVING, INTERLEAVES]\n",
  "INTERLEAVED": "INTERLEAVE, to arrange in or as if in alternate layers [v]\n",
  "INTERLEAVES": "INTERLEAVE, to arrange in or as if in alternate layers [v]\n",
  "INTERLEAVING": "INTERLEAVE, to arrange in or as if in alternate layers [v]\n",
  "INTERLEND": "to lend between [v INTERLENT, INTERLENDING, INTERLENDS]\n",
  "INTERLENDING": "INTERLEND, to lend between [v]\n",
  "INTERLENDS": "INTERLEND, to lend between [v]\n",
  "INTERLENT": "INTERLEND, to lend between [v]\n",
  "INTERLEUKIN": "any of a group of proteins that control the production of blood cells and play an important part in the combating of infection [n -S]\n",
  "INTERLEUKINS": "INTERLEUKIN, any of a group of proteins that control the production of blood cells and play an important part in the combating of infection [n]\n",
  "INTERLIBRARY": "between libraries [adj]\n",
  "INTERLINE": "to write or insert between lines already written or printed, as for correction or addition [v INTERLINED, INTERLINING, INTERLINES]\n",
  "INTERLINEAL": "between the lines [adj INTERLINEALLY]\n",
  "INTERLINEALLY": "INTERLINEAL, between the lines [adv]\n",
  "INTERLINEAR": "between the lines [adj INTERLINEARLY] / a book having interlinear matter [n -S]\n",
  "INTERLINEARLY": "INTERLINEAR, between the lines [adv]\n",
  "INTERLINEARS": "INTERLINEAR, a book having interlinear matter [n]\n",
  "INTERLINEATE": "to write between lines [v INTERLINEATED, INTERLINEATING, INTERLINEATES]\n",
  "INTERLINEATED": "INTERLINEATE, to write between lines [v]\n",
  "INTERLINEATES": "INTERLINEATE, to write between lines [v]\n",
  "INTERLINEATING": "INTERLINEATE, to write between lines [v]\n",
  "INTERLINEATION": "the state of being interlineated [n -S]\n",
  "INTERLINEATIONS": "INTERLINEATION, the state of being interlineated [n]\n",
  "INTERLINED": "INTERLINE, to write or insert between lines already written or printed, as for correction or addition [v]\n",
  "INTERLINER": "the material used to interline parts of garments, now often made of reinforced paper [n -S]\n",
  "INTERLINERS": "INTERLINER, the material used to interline parts of garments, now often made of reinforced paper [n]\n",
  "INTERLINES": "INTERLINE, to write or insert between lines already written or printed, as for correction or addition [v]\n",
  "INTERLINGUA": "any artificially devised international language [n -S]\n",
  "INTERLINGUAL": "relating to an interlingua [adj INTERLINGUALLY]\n",
  "INTERLINGUALLY": "INTERLINGUAL, relating to an interlingua [adv]\n",
  "INTERLINGUAS": "INTERLINGUA, any artificially devised international language [n]\n",
  "INTERLINING": "the act of writing between the lines [n -S]\n",
  "INTERLININGS": "INTERLINING, the act of writing between the lines [n]\n",
  "INTERLINK": "to link together [v -ED, -ING, -S]\n",
  "INTERLINKED": "INTERLINK, to link together [v]\n",
  "INTERLINKING": "INTERLINK, to link together [v]\n",
  "INTERLINKS": "INTERLINK, to link together [v]\n",
  "INTERLOAN": "a loan between one library and another [n -S]\n",
  "INTERLOANS": "INTERLOAN, a loan between one library and another [n]\n",
  "INTERLOBULAR": "between lobes [adj]\n",
  "INTERLOCAL": "between localities [adj]\n",
  "INTERLOCATION": "a placing between [n -S]\n",
  "INTERLOCATIONS": "INTERLOCATION, a placing between [n]\n",
  "INTERLOCK": "to lock or clasp together [v -ED, -ING, -S]\n",
  "INTERLOCKED": "INTERLOCK, to lock or clasp together [v]\n",
  "INTERLOCKER": "something that interlocks [n -S]\n",
  "INTERLOCKERS": "INTERLOCKER, something that interlocks [n]\n",
  "INTERLOCKING": "INTERLOCK, to lock or clasp together [v]\n",
  "INTERLOCKS": "INTERLOCK, to lock or clasp together [v]\n",
  "INTERLOCUTION": "dialogue, conversation; an intermediate decree before a final decision [n -S]\n",
  "INTERLOCUTIONS": "INTERLOCUTION, dialogue, conversation; an intermediate decree before a final decision [n]\n",
  "INTERLOCUTOR": "one who takes part in dialogue or conversation [n -S]\n",
  "INTERLOCUTORILY": "INTERLOCUTORY, made during the progress of a legal action and not final or definitive [adv]\n",
  "INTERLOCUTORS": "INTERLOCUTOR, one who takes part in dialogue or conversation [n]\n",
  "INTERLOCUTORY": "made during the progress of a legal action and not final or definitive [adj INTERLOCUTORILY]\n",
  "INTERLOCUTRESS": "a female interlocutor, also INTERLOCUTRICE, INTERLOCUTRIX [n]\n",
  "INTERLOCUTRICE": "a female interlocutor, also INTERLOCUTRESS, INTERLOCUTRIX [n -S]\n",
  "INTERLOCUTRICES": "INTERLOCUTRICE, a female interlocutor, also INTERLOCUTRESS, INTERLOCUTRIX [n]\n",
  "INTERLOCUTRIX": "a female interlocutor, also INTERLOCUTRESS, INTERLOCUTRICE [n INTERLOCUTRICES or INTERLOCUTRIXES]\n",
  "INTERLOCUTRIXES": "INTERLOCUTRIX, a female interlocutor, also INTERLOCUTRESS, INTERLOCUTRICE [n]\n",
  "INTERLOOP": "to loop together [v -ED, -ING, -S]\n",
  "INTERLOOPED": "INTERLOOP, to loop together [v]\n",
  "INTERLOOPING": "INTERLOOP, to loop together [v]\n",
  "INTERLOOPS": "INTERLOOP, to loop together [v]\n",
  "INTERLOPE": "to intrude; to traffic without a licence [v INTERLOPED, INTERLOPING, INTERLOPES]\n",
  "INTERLOPED": "INTERLOPE, to intrude; to traffic without a licence [v]\n",
  "INTERLOPER": "one that interlopes [n -S]\n",
  "INTERLOPERS": "INTERLOPER, one that interlopes [n]\n",
  "INTERLOPES": "INTERLOPE, to intrude; to traffic without a licence [v]\n",
  "INTERLOPING": "INTERLOPE, to intrude; to traffic without a licence [v]\n",
  "INTERLUDE": "an interval between acts of a play, etc. [n -S] / to write or perform a dramatic interlude [v INTERLUDED, INTERLUDING, INTERLUDES]\n",
  "INTERLUDED": "INTERLUDE, to write or perform a dramatic interlude [v]\n",
  "INTERLUDES": "INTERLUDE, to write or perform a dramatic interlude [v]\n",
  "INTERLUDIAL": "relating to an interlude [adj]\n",
  "INTERLUDING": "INTERLUDE, to write or perform a dramatic interlude [v]\n",
  "INTERLUNAR": "pertaining to the period between the old and new moon, also INTERLUNARY [adj]\n",
  "INTERLUNARY": "pertaining to the period between the old and new moon, also INTERLUNAR [adj]\n",
  "INTERLUNATION": "the dark time between the old moon and the new [n -S]\n",
  "INTERLUNATIONS": "INTERLUNATION, the dark time between the old moon and the new [n]\n",
  "INTERMALE": "between males [adj]\n",
  "INTERMARGINAL": "between margins [adj]\n",
  "INTERMARRIAGE": "marriage within one's own family or group [n -S]\n",
  "INTERMARRIAGES": "INTERMARRIAGE, marriage within one's own family or group [n]\n",
  "INTERMARRIED": "INTERMARRY, to marry each other [v]\n",
  "INTERMARRIES": "INTERMARRY, to marry each other [v]\n",
  "INTERMARRY": "to marry each other [v INTERMARRIED, INTERMARRYING, INTERMARRIES]\n",
  "INTERMARRYING": "INTERMARRY, to marry each other [v]\n",
  "INTERMAT": "to mat fibers together [v INTERMATTED, INTERMATTING, INTERMATS]\n",
  "INTERMATS": "INTERMAT, to mat fibers together [v]\n",
  "INTERMATTED": "INTERMAT, to mat fibers together [v]\n",
  "INTERMATTING": "INTERMAT, to mat fibers together [v]\n",
  "INTERMAXILLA": "the bone between the maxillae [n INTERMAXILLAE]\n",
  "INTERMAXILLAE": "INTERMAXILLA, the bone between the maxillae [n]\n",
  "INTERMAXILLARY": "between the maxillaries [adj]\n",
  "INTERMEDDLE": "to meddle, to interfere [v INTERMEDDLED, INTERMEDDLING, INTERMEDDLES]\n",
  "INTERMEDDLED": "INTERMEDDLE, to meddle, to interfere [v]\n",
  "INTERMEDDLER": "one who interferes [n -S]\n",
  "INTERMEDDLERS": "INTERMEDDLER, one who interferes [n]\n",
  "INTERMEDDLES": "INTERMEDDLE, to meddle, to interfere [v]\n",
  "INTERMEDDLING": "INTERMEDDLE, to meddle, to interfere [v]\n",
  "INTERMEDIA": "INTERMEDIUM, a small bone in the wrist and ankle [n]\n",
  "INTERMEDIACIES": "INTERMEDIACY, the act or action of intermediating [n]\n",
  "INTERMEDIACY": "the act or action of intermediating [n INTERMEDIACIES]\n",
  "INTERMEDIAL": "intermediate [adj]\n",
  "INTERMEDIARIES": "INTERMEDIARY, a mediator, a go-between [n]\n",
  "INTERMEDIARY": "acting as an intermediate [adj] / a mediator, a go-between [n INTERMEDIARIES]\n",
  "INTERMEDIATE": "placed between others [adj INTERMEDIATELY] / to mediate between [v INTERMEDIATED, INTERMEDIATING, INTERMEDIATES]\n",
  "INTERMEDIATED": "INTERMEDIATE, to mediate between [v]\n",
  "INTERMEDIATELY": "INTERMEDIATE, placed between others [adv]\n",
  "INTERMEDIATES": "INTERMEDIATE, to mediate between [v]\n",
  "INTERMEDIATING": "INTERMEDIATE, to mediate between [v]\n",
  "INTERMEDIATION": "the act of coming between [n -S]\n",
  "INTERMEDIATIONS": "INTERMEDIATION, the act of coming between [n]\n",
  "INTERMEDIATOR": "one who intermediates [n -S]\n",
  "INTERMEDIATORS": "INTERMEDIATOR, one who intermediates [n]\n",
  "INTERMEDIATORY": "relating to intermediation [adj]\n",
  "INTERMEDIN": "a messenger hormone [n -S]\n",
  "INTERMEDINS": "INTERMEDIN, a messenger hormone [n]\n",
  "INTERMEDIUM": "a small bone in the wrist and ankle [n INTERMEDIA or INTERMEDIUMS]\n",
  "INTERMEDIUMS": "INTERMEDIUM, a small bone in the wrist and ankle [n]\n",
  "INTERMEMBRANE": "between membranes [adj]\n",
  "INTERMENSTRUAL": "occurring between menstrual periods [adj]\n",
  "INTERMENT": "the act or ceremony of depositing a dead body in the earth [n -S]\n",
  "INTERMENTS": "INTERMENT, the act or ceremony of depositing a dead body in the earth [n]\n",
  "INTERMESH": "to mesh together, to interlock [v -ED, -ING, -ES]\n",
  "INTERMESHED": "INTERMESH, to mesh together, to interlock [v]\n",
  "INTERMESHES": "INTERMESH, to mesh together, to interlock [v]\n",
  "INTERMESHING": "INTERMESH, to mesh together, to interlock [v]\n",
  "INTERMETALLIC": "composed of two or more metals or of a metal and a nonmetal [adj] / an intermetallic material [n -S]\n",
  "INTERMETALLICS": "INTERMETALLIC, an intermetallic material [n]\n",
  "INTERMEZZI": "INTERMEZZO, (Italian) a short connecting instrumental movement in an opera or other musical work [n]\n",
  "INTERMEZZO": "(Italian) a short connecting instrumental movement in an opera or other musical work [n INTERMEZZI or INTERMEZZOS]\n",
  "INTERMEZZOS": "INTERMEZZO, (Italian) a short connecting instrumental movement in an opera or other musical work [n]\n",
  "INTERMIGRATION": "two-way migration between two countries [n -S]\n",
  "INTERMIGRATIONS": "INTERMIGRATION, two-way migration between two countries [n]\n",
  "INTERMINABILITY": "the quality of being interminable [n]\n",
  "INTERMINABLE": "having or seeming to have no end [adj INTERMINABLY]\n",
  "INTERMINABLY": "INTERMINABLE, having or seeming to have no end [adv]\n",
  "INTERMINGLE": "to intermix [v INTERMINGLED, INTERMINGLING, INTERMINGLES]\n",
  "INTERMINGLED": "INTERMINGLE, to intermix [v]\n",
  "INTERMINGLES": "INTERMINGLE, to intermix [v]\n",
  "INTERMINGLING": "INTERMINGLE, to intermix [v]\n",
  "INTERMISSION": "the act of intermitting [n -S]\n",
  "INTERMISSIONS": "INTERMISSION, the act of intermitting [n]\n",
  "INTERMISSIVE": "coming and going; intermittent [adj]\n",
  "INTERMIT": "to stop temporarily [v INTERMITTED, INTERMITTING, INTERMITS]\n",
  "INTERMITOTIC": "occurring or existing between mitoses; capable of dividing again [adj]\n",
  "INTERMITS": "INTERMIT, to stop temporarily [v]\n",
  "INTERMITTED": "INTERMIT, to stop temporarily [v]\n",
  "INTERMITTENCE": "the state of being intermittent, also INTERMITTENCY [n -S]\n",
  "INTERMITTENCES": "INTERMITTENCE, the state of being intermittent, also INTERMITTENCY [n]\n",
  "INTERMITTENCIES": "INTERMITTENCY, the state of being intermittent, also INTERMITTENCE [n]\n",
  "INTERMITTENCY": "the state of being intermittent, also INTERMITTENCE [n INTERMITTENCIES]\n",
  "INTERMITTENT": "coming and going at intervals [adj INTERMITTENTLY]\n",
  "INTERMITTENTLY": "INTERMITTENT, coming and going at intervals [adv]\n",
  "INTERMITTER": "one who intermits [n -S]\n",
  "INTERMITTERS": "INTERMITTER, one who intermits [n]\n",
  "INTERMITTING": "INTERMIT, to stop temporarily [v]\n",
  "INTERMITTINGLY": "INTERMITTING, INTERMIT, to stop temporarily [adv]\n",
  "INTERMITTOR": "one who intermits [n -S]\n",
  "INTERMITTORS": "INTERMITTOR, one who intermits [n]\n",
  "INTERMIX": "to mix together [v -ED, -ING, -ES]\n",
  "INTERMIXED": "INTERMIX, to mix together [v]\n",
  "INTERMIXES": "INTERMIX, to mix together [v]\n",
  "INTERMIXING": "INTERMIX, to mix together [v]\n",
  "INTERMIXTURE": "a mass formed by mixture [n -S]\n",
  "INTERMIXTURES": "INTERMIXTURE, a mass formed by mixture [n]\n",
  "INTERMODAL": "between modes [adj]\n",
  "INTERMODULATION": "the production in an electrical device of currents having frequencies equal to the sums and differences of frequencies supplied to the device or of their harmonics [n]\n",
  "INTERMOLECULAR": "between molecules [adj]\n",
  "INTERMONT": "situated between mountains, also INTERMONTANE, INTERMOUNTAIN [adj]\n",
  "INTERMONTANE": "situated between mountains, also INTERMONT, INTERMOUNTAIN [adj]\n",
  "INTERMOUNTAIN": "situated between mountains, also INTERMONT, INTERMONTANE [adj]\n",
  "INTERMUNDANE": "between worlds [adj]\n",
  "INTERMURE": "(obsolete) to wall in [v INTERMURED, INTERMURING, INTERMURES]\n",
  "INTERMURED": "INTERMURE, (obsolete) to wall in [v]\n",
  "INTERMURES": "INTERMURE, (obsolete) to wall in [v]\n",
  "INTERMURING": "INTERMURE, (obsolete) to wall in [v]\n",
  "INTERMUSCULAR": "situated between muscles [adj]\n",
  "INTERN": "to confine during a war [v -ED, -ING, -S]\n",
  "INTERNAL": "inner [adj INTERNALLY] / an inner attribute [n -S]\n",
  "INTERNALISATION": "the act of internalising, also INTERNALIZATION [n]\n",
  "INTERNALISE": "to make internal, also INTERNALIZE [v INTERNALISED, INTERNALISING, INTERNALISES]\n",
  "INTERNALISED": "INTERNALISE, to make internal, also INTERNALIZE [v]\n",
  "INTERNALISES": "INTERNALISE, to make internal, also INTERNALIZE [v]\n",
  "INTERNALISING": "INTERNALISE, to make internal, also INTERNALIZE [v]\n",
  "INTERNALITIES": "INTERNALITY, the state of being internal [n]\n",
  "INTERNALITY": "the state of being internal [n INTERNALITIES]\n",
  "INTERNALIZATION": "the act of internalising, also INTERNALISATION [n]\n",
  "INTERNALIZE": "to make internal, also INTERNALISE [v INTERNALIZED, INTERNALIZING, INTERNALIZES]\n",
  "INTERNALIZED": "INTERNALIZE, to make internal, also INTERNALISE [v]\n",
  "INTERNALIZES": "INTERNALIZE, to make internal, also INTERNALISE [v]\n",
  "INTERNALIZING": "INTERNALIZE, to make internal, also INTERNALISE [v]\n",
  "INTERNALLY": "INTERNAL, inner [adv]\n",
  "INTERNALNESS": "the state of being internal [n -ES]\n",
  "INTERNALNESSES": "INTERNALNESS, the state of being internal [n]\n",
  "INTERNALS": "INTERNAL, an inner attribute [n]\n",
  "INTERNATIONAL": "between nations [adj INTERNATIONALLY] / one that is international [n -S]\n",
  "INTERNATIONALLY": "INTERNATIONAL, between nations [adv]\n",
  "INTERNATIONALS": "INTERNATIONAL, one that is international [n]\n",
  "INTERNE": "a trainee gaining practical medical experience [n -S]\n",
  "INTERNECINE": "deadly, murderous, also INTERNECIVE [adj]\n",
  "INTERNECIVE": "deadly, murderous, also INTERNECINE [adj]\n",
  "INTERNED": "INTERN, to confine during a war [v]\n",
  "INTERNEE": "one who has been interned [n -S]\n",
  "INTERNEES": "INTERNEE, one who has been interned [n]\n",
  "INTERNES": "INTERNE, a trainee gaining practical medical experience [n]\n",
  "INTERNET": "the worldwide connection of computers [n -S]\n",
  "INTERNETS": "INTERNET, the worldwide connection of computers [n]\n",
  "INTERNEURAL": "situated between the neural spines or spinous processes of successive vertebrae [adj]\n",
  "INTERNEURON": "an internuncial neuron [n -S]\n",
  "INTERNEURONAL": "relating to interneuron [adj]\n",
  "INTERNEURONS": "INTERNEURON, an internuncial neuron [n]\n",
  "INTERNING": "INTERN, to confine during a war [v]\n",
  "INTERNIST": "a specialist in internal medicine [n -S]\n",
  "INTERNISTS": "INTERNIST, a specialist in internal medicine [n]\n",
  "INTERNMENT": "the act of interning [n -S]\n",
  "INTERNMENTS": "INTERNMENT, the act of interning [n]\n",
  "INTERNODAL": "between nodes, also INTERNODIAL [adj]\n",
  "INTERNODE": "the space between two nodes or points of the stem from which the leaves properly arise [n -S]\n",
  "INTERNODES": "INTERNODE, the space between two nodes or points of the stem from which the leaves properly arise [n]\n",
  "INTERNODIAL": "(obsolete) between nodes, also INTERNODAL [adj]\n",
  "INTERNS": "INTERN, to confine during a war [v]\n",
  "INTERNSHIP": "the office of an intern [n -S]\n",
  "INTERNSHIPS": "INTERNSHIP, the office of an intern [n]\n",
  "INTERNUCLEAR": "between nuclei [adj]\n",
  "INTERNUCLEON": "between nucleons [adj]\n",
  "INTERNUCLEONIC": "between nucleons [adj]\n",
  "INTERNUCLEOTIDE": "between nucleotides [adj]\n",
  "INTERNUNCIAL": "linking two neurons in a neuronal pathway [adj]\n",
  "INTERNUNCIO": "(Italian) a messenger between two parties; a low-ranking papal legate [n -S]\n",
  "INTERNUNCIOS": "INTERNUNCIO, (Italian) a messenger between two parties; a low-ranking papal legate [n]\n",
  "INTEROBSERVER": "between observers [adj]\n",
  "INTEROCEAN": "between oceans, also INTEROCEANIC [adj]\n",
  "INTEROCEANIC": "between oceans, also INTEROCEAN [adj]\n",
  "INTEROCEPTION": "sensitivity to stimuli originating inside of the body [n -S]\n",
  "INTEROCEPTIONS": "INTEROCEPTION, sensitivity to stimuli originating inside of the body [n]\n",
  "INTEROCEPTIVE": "responding to stimuli arising within the body [adj]\n",
  "INTEROCEPTOR": "a sensory receptor responding to stimuli arising within the body, esp. the viscera [n -S]\n",
  "INTEROCEPTORS": "INTEROCEPTOR, a sensory receptor responding to stimuli arising within the body, esp. the viscera [n]\n",
  "INTEROCULAR": "between the eyes [adj]\n",
  "INTEROFFICE": "between offices [adj]\n",
  "INTEROPERABLE": "of hardware or software systems, able to exchange and use information from different computer systems [adj]\n",
  "INTEROPERATIVE": "between operatives [adj]\n",
  "INTERORBITAL": "between orbits [adj]\n",
  "INTERORGAN": "between organs [adj]\n",
  "INTEROSCULANT": "possessing attributes common to different groups [adj]\n",
  "INTEROSCULATE": "to connect by osculation [v INTEROSCULATED, INTEROSCULATING, INTEROSCULATES]\n",
  "INTEROSCULATED": "INTEROSCULATE, to connect by osculation [v]\n",
  "INTEROSCULATES": "INTEROSCULATE, to connect by osculation [v]\n",
  "INTEROSCULATING": "INTEROSCULATE, to connect by osculation [v]\n",
  "INTEROSCULATION": "intersection [n]\n",
  "INTEROSSEAL": "situated between bones, also INTEROSSEOUS [adj]\n",
  "INTEROSSEOUS": "situated between bones, also INTEROSSEAL [adj]\n",
  "INTERPAGE": "to print or insert on intermediate pages [v INTERPAGED, INTERPAGING, INTERPAGES]\n",
  "INTERPAGED": "INTERPAGE, to print or insert on intermediate pages [v]\n",
  "INTERPAGES": "INTERPAGE, to print or insert on intermediate pages [v]\n",
  "INTERPAGING": "INTERPAGE, to print or insert on intermediate pages [v]\n",
  "INTERPANDEMIC": "between pandemics [adj]\n",
  "INTERPARIETAL": "situated between two parietal bones of the skull [adj]\n",
  "INTERPARISH": "between parishes [adj]\n",
  "INTERPAROCHIAL": "between parishes [adj]\n",
  "INTERPAROXYSMAL": "between paroxysms [adj]\n",
  "INTERPARTICLE": "between particles [adj]\n",
  "INTERPARTY": "between parties [adj]\n",
  "INTERPELLANT": "interrupting [adj] / a person interpellating [n -S]\n",
  "INTERPELLANTS": "INTERPELLANT, a person interpellating [n]\n",
  "INTERPELLATE": "to question formally concerning an official action or policy or personal conduct [v INTERPELLATED, INTERPELLATING, INTERPELLATES]\n",
  "INTERPELLATED": "INTERPELLATE, to question formally concerning an official action or policy or personal conduct [v]\n",
  "INTERPELLATES": "INTERPELLATE, to question formally concerning an official action or policy or personal conduct [v]\n",
  "INTERPELLATING": "INTERPELLATE, to question formally concerning an official action or policy or personal conduct [v]\n",
  "INTERPELLATION": "a formal questioning or challenging regarding an action or policy [n -S]\n",
  "INTERPELLATIONS": "INTERPELLATION, a formal questioning or challenging regarding an action or policy [n]\n",
  "INTERPELLATOR": "one who interpellates, questions formally concerning an official action or policy or personal conduct [n -S]\n",
  "INTERPELLATORS": "INTERPELLATOR, one who interpellates, questions formally concerning an official action or policy or personal conduct [n]\n",
  "INTERPENETRABLE": "able to be interpenetrated [adj]\n",
  "INTERPENETRANT": "mutually penetrating [adj]\n",
  "INTERPENETRATE": "to penetrate mutually [v INTERPENETRATED, INTERPENETRATES]\n",
  "INTERPENETRATED": "INTERPENETRATE, to penetrate mutually [v]\n",
  "INTERPENETRATES": "INTERPENETRATE, to penetrate mutually [v]\n",
  "INTERPERCEPTUAL": "relating to interaction between modes of perception [adj]\n",
  "INTERPERMEATE": "to permeate between [v INTERPERMEATED, INTERPERMEATING, INTERPERMEATES]\n",
  "INTERPERMEATED": "INTERPERMEATE, to permeate between [v]\n",
  "INTERPERMEATES": "INTERPERMEATE, to permeate between [v]\n",
  "INTERPERMEATING": "INTERPERMEATE, to permeate between [v]\n",
  "INTERPERSONAL": "relating to relations between persons [adj INTERPERSONALLY]\n",
  "INTERPERSONALLY": "INTERPERSONAL, relating to relations between persons [adv]\n",
  "INTERPETIOLAR": "between petioles [adj]\n",
  "INTERPHALANGEAL": "between the phalanges, the bones of a digit [adj]\n",
  "INTERPHASE": "the interval between the end of one meiotic or mitotic division and the start of another [n -S]\n",
  "INTERPHASES": "INTERPHASE, the interval between the end of one meiotic or mitotic division and the start of another [n]\n",
  "INTERPHONE": "an intercom [n -S]\n",
  "INTERPHONES": "INTERPHONE, an intercom [n]\n",
  "INTERPILASTER": "a space between two pilasters [n -S]\n",
  "INTERPILASTERS": "INTERPILASTER, a space between two pilasters [n]\n",
  "INTERPLANETARY": "between planets [adj]\n",
  "INTERPLANT": "to plant a crop between other plants [v -ED, -ING, -S]\n",
  "INTERPLANTED": "INTERPLANT, to plant a crop between other plants [v]\n",
  "INTERPLANTING": "INTERPLANT, to plant a crop between other plants [v]\n",
  "INTERPLANTS": "INTERPLANT, to plant a crop between other plants [v]\n",
  "INTERPLAY": "mutual action [n -S] / to exert mutual influence [v -ED, -ING, -S]\n",
  "INTERPLAYED": "INTERPLAY, to exert mutual influence [v]\n",
  "INTERPLAYING": "INTERPLAY, to exert mutual influence [v]\n",
  "INTERPLAYS": "INTERPLAY, to exert mutual influence [v]\n",
  "INTERPLEAD": "to plead against each other, or go to trial between themselves, as the claimants in an interpleader [v INTERPLEADED or INTERPLED, INTERPLEADING, INTERPLEADS]\n",
  "INTERPLEADED": "INTERPLEAD, to plead against each other, or go to trial between themselves, as the claimants in an interpleader [v]\n",
  "INTERPLEADER": "one who interpleads [n -S]\n",
  "INTERPLEADERS": "INTERPLEADER, one who interpleads [n]\n",
  "INTERPLEADING": "INTERPLEAD, to plead against each other, or go to trial between themselves, as the claimants in an interpleader [v]\n",
  "INTERPLEADS": "INTERPLEAD, to plead against each other, or go to trial between themselves, as the claimants in an interpleader [v]\n",
  "INTERPLED": "INTERPLEAD, to plead against each other, or go to trial between themselves, as the claimants in an interpleader [v]\n",
  "INTERPLEURAL": "situated between the right and left pleural cavities [adj]\n",
  "INTERPLUVIAL": "a period between bouts of rain [n -S]\n",
  "INTERPLUVIALS": "INTERPLUVIAL, a period between bouts of rain [n]\n",
  "INTERPOINT": "the technique of printing Braille on both sides of the paper, spacing the dots in such a way that none counteracts each other [n -S]\n",
  "INTERPOINTS": "INTERPOINT, the technique of printing Braille on both sides of the paper, spacing the dots in such a way that none counteracts each other [n]\n",
  "INTERPOLABLE": "that can be interpolated [adj]\n",
  "INTERPOLAR": "between poles [adj]\n",
  "INTERPOLATE": "to insert a word or passage in a book or manuscript, esp. in order to mislead [v INTERPOLATED, INTERPOLATING, INTERPOLATES]\n",
  "INTERPOLATED": "INTERPOLATE, to insert a word or passage in a book or manuscript, esp. in order to mislead [v]\n",
  "INTERPOLATER": "one who interpolates, also INTERPOLATOR [n -S]\n",
  "INTERPOLATERS": "INTERPOLATER, one who interpolates, also INTERPOLATOR [n]\n",
  "INTERPOLATES": "INTERPOLATE, to insert a word or passage in a book or manuscript, esp. in order to mislead [v]\n",
  "INTERPOLATING": "INTERPOLATE, to insert a word or passage in a book or manuscript, esp. in order to mislead [v]\n",
  "INTERPOLATION": "the act of interpolating [n -S]\n",
  "INTERPOLATIONS": "INTERPOLATION, the act of interpolating [n]\n",
  "INTERPOLATIVE": "relating to interpolation [adj]\n",
  "INTERPOLATOR": "one who interpolates, also INTERPOLATER [n -S]\n",
  "INTERPOLATORS": "INTERPOLATOR, one who interpolates, also INTERPOLATER [n]\n",
  "INTERPONE": "to interpose; to insert or place between [v INTERPONED, INTERPONING, INTERPONES]\n",
  "INTERPONED": "INTERPONE, to interpose; to insert or place between [v]\n",
  "INTERPONES": "INTERPONE, to interpose; to insert or place between [v]\n",
  "INTERPONING": "INTERPONE, to interpose; to insert or place between [v]\n",
  "INTERPOPULATION": "between populations [n]\n",
  "INTERPOSABLE": "that can be interposed [adj]\n",
  "INTERPOSAL": "the act of interposing [n -S]\n",
  "INTERPOSALS": "INTERPOSAL, the act of interposing [n]\n",
  "INTERPOSE": "to place between [v INTERPOSED, INTERPOSING, INTERPOSES]\n",
  "INTERPOSED": "INTERPOSE, to place between [v]\n",
  "INTERPOSER": "one who interposes [n -S]\n",
  "INTERPOSERS": "INTERPOSER, one who interposes [n]\n",
  "INTERPOSES": "INTERPOSE, to place between [v]\n",
  "INTERPOSING": "INTERPOSE, to place between [v]\n",
  "INTERPOSITION": "the act of interposing [n -S]\n",
  "INTERPOSITIONS": "INTERPOSITION, the act of interposing [n]\n",
  "INTERPRET": "to explain the meaning of, to elucidate, also INTERPRETATE [v -ED, -ING, -S]\n",
  "INTERPRETABLE": "able to be interpreted [adj INTERPRETABLY]\n",
  "INTERPRETABLY": "INTERPRETABLE, able to be interpreted [adv]\n",
  "INTERPRETATE": "(archaic) to interpret [v INTERPRETATED, INTERPRETATING, INTERPRETATES]\n",
  "INTERPRETATED": "INTERPRETATE, (archaic) to interpret [v]\n",
  "INTERPRETATES": "INTERPRETATE, (archaic) to interpret [v]\n",
  "INTERPRETATING": "INTERPRETATE, (archaic) to interpret [v]\n",
  "INTERPRETATION": "the act or the result of interpreting [n -S]\n",
  "INTERPRETATIONS": "INTERPRETATION, the act or the result of interpreting [n]\n",
  "INTERPRETATIVE": "relating to interpretation, also INTERPRETIVE [adj]\n",
  "INTERPRETED": "INTERPRET, to explain the meaning of, to elucidate, also INTERPRETATE [v]\n",
  "INTERPRETER": "one who translates orally for parties conversing in different languages [n -S]\n",
  "INTERPRETERS": "INTERPRETER, one who translates orally for parties conversing in different languages [n]\n",
  "INTERPRETERSHIP": "the office of interpreter [n]\n",
  "INTERPRETESS": "(obsolete) a female interpreter, also INTERPRETRESS [n -ES]\n",
  "INTERPRETESSES": "INTERPRETESS, (obsolete) a female interpreter, also INTERPRETRESS [n]\n",
  "INTERPRETING": "INTERPRET, to explain the meaning of, to elucidate, also INTERPRETATE [v]\n",
  "INTERPRETIVE": "relating to interpretation, also INTERPRETATIVE [adj INTERPRETIVELY]\n",
  "INTERPRETIVELY": "INTERPRETIVE, relating to interpretation, also INTERPRETATIVE [adv]\n",
  "INTERPRETRESS": "a female interpreter, also INTERPRETESS [n -ES]\n",
  "INTERPRETRESSES": "INTERPRETRESS, a female interpreter, also INTERPRETESS [n]\n",
  "INTERPRETS": "INTERPRET, to explain the meaning of, to elucidate, also INTERPRETATE [v]\n",
  "INTERPROVINCIAL": "between provinces [adj]\n",
  "INTERPROXIMAL": "situated or used in the areas between adjoining teeth [adj]\n",
  "INTERPSYCHIC": "between psyches [adj]\n",
  "INTERPUNCTION": "the insertion of punctuation marks in writing [n -S]\n",
  "INTERPUNCTIONS": "INTERPUNCTION, the insertion of punctuation marks in writing [n]\n",
  "INTERPUNCTUATE": "to insert punctuation marks between [v INTERPUNCTUATED, INTERPUNCTUATES]\n",
  "INTERPUNCTUATED": "INTERPUNCTUATE, to insert punctuation marks between [v]\n",
  "INTERPUNCTUATES": "INTERPUNCTUATE, to insert punctuation marks between [v]\n",
  "INTERPUPILLARY": "extending between the pupils of the eyes [adj]\n",
  "INTERQUARTILE": "between quartiles [adj]\n",
  "INTERRACE": "between races [adj]\n",
  "INTERRACIAL": "involving members of different races [adj INTERRACIALLY]\n",
  "INTERRACIALLY": "INTERRACIAL, involving members of different races [adv]\n",
  "INTERRADIAL": "between radii or rays [adj INTERRADIALLY]\n",
  "INTERRADIALLY": "INTERRADIAL, between radii or rays [adv]\n",
  "INTERRADII": "INTERRADIUS, a radius midway between primary radii or perradii [n]\n",
  "INTERRADIUS": "a radius midway between primary radii or perradii [n INTERRADII or INTERRADIUSES]\n",
  "INTERRADIUSES": "INTERRADIUS, a radius midway between primary radii or perradii [n]\n",
  "INTERRAIL": "to travel between cities by train [v -ED, -ING, -S]\n",
  "INTERRAILED": "INTERRAIL, to travel between cities by train [v]\n",
  "INTERRAILER": "one who travels by interrail [n -S]\n",
  "INTERRAILERS": "INTERRAILER, one who travels by interrail [n]\n",
  "INTERRAILING": "INTERRAIL, to travel between cities by train [v]\n",
  "INTERRAILS": "INTERRAIL, to travel between cities by train [v]\n",
  "INTERRAMAL": "between rami or branches; esp. between the mandibles, or rami of the lower jaw [adj]\n",
  "INTERRED": "INTER, to bury [v]\n",
  "INTERREGAL": "between kings [adj]\n",
  "INTERREGES": "INTERREX, someone who rules between two reigns [n]\n",
  "INTERREGIONAL": "between regions [adj]\n",
  "INTERREGNA": "INTERREGNUM, (Latin) the time during which a throne is vacant between two reigns [n]\n",
  "INTERREGNAL": "occurring between reigns [adj]\n",
  "INTERREGNUM": "(Latin) the time during which a throne is vacant between two reigns [n INTERREGNA or INTERREGNUMS]\n",
  "INTERREGNUMS": "INTERREGNUM, (Latin) the time during which a throne is vacant between two reigns [n]\n",
  "INTERRELATE": "to bring into mutual relation [v INTERRELATED, INTERRELATING, INTERRELATES]\n",
  "INTERRELATED": "INTERRELATE, to bring into mutual relation [v]\n",
  "INTERRELATEDLY": "INTERRELATED, INTERRELATE, to bring into mutual relation [adv]\n",
  "INTERRELATES": "INTERRELATE, to bring into mutual relation [v]\n",
  "INTERRELATING": "INTERRELATE, to bring into mutual relation [v]\n",
  "INTERRELATION": "the state of being interrelated [n -S]\n",
  "INTERRELATIONS": "INTERRELATION, the state of being interrelated [n]\n",
  "INTERRELIGIOUS": "between religions [adj]\n",
  "INTERRENAL": "between the kidneys; as, the interrenal body, an organ found in many fishes [adj]\n",
  "INTERREX": "someone who rules between two reigns [n INTERREGES]\n",
  "INTERRING": "INTER, to bury [v]\n",
  "INTERROBANG": "a punctuation mark (?!) designed for use esp. at the end of an exclamatory rhetorical question, also INTERABANG [n -S]\n",
  "INTERROBANGS": "INTERROBANG, a punctuation mark (?!) designed for use esp. at the end of an exclamatory rhetorical question, also INTERABANG [n]\n",
  "INTERROGABLE": "that can be interrogated [adj]\n",
  "INTERROGANT": "a questioner [n -S]\n",
  "INTERROGANTS": "INTERROGANT, a questioner [n]\n",
  "INTERROGATE": "to question formally and systematically [v INTERROGATED, INTERROGATING, INTERROGATES]\n",
  "INTERROGATED": "INTERROGATE, to question formally and systematically [v]\n",
  "INTERROGATEE": "one who is interrogated, also INTERROGEE [n -S]\n",
  "INTERROGATEES": "INTERROGATEE, one who is interrogated, also INTERROGEE [n]\n",
  "INTERROGATES": "INTERROGATE, to question formally and systematically [v]\n",
  "INTERROGATING": "INTERROGATE, to question formally and systematically [v]\n",
  "INTERROGATINGLY": "INTERROGATING, INTERROGATE, to question formally and systematically [adv]\n",
  "INTERROGATION": "the act of interrogating [n -S]\n",
  "INTERROGATIONAL": "relating to interrogation [adj]\n",
  "INTERROGATIONS": "INTERROGATION, the act of interrogating [n]\n",
  "INTERROGATIVE": "related to the asking of questions [adj INTERROGATIVELY] / a word (as who, what, which) or a particle (as Latin -ne) used in asking questions [n -S]\n",
  "INTERROGATIVELY": "INTERROGATIVE, related to the asking of questions [adv]\n",
  "INTERROGATIVES": "INTERROGATIVE, a word (as who, what, which) or a particle (as Latin -ne) used in asking questions [n]\n",
  "INTERROGATOR": "one that interrogates [n -S]\n",
  "INTERROGATORIES": "INTERROGATORY, a question or interrogation [n]\n",
  "INTERROGATORILY": "INTERROGATORY, like an interrogation [adv]\n",
  "INTERROGATORS": "INTERROGATOR, one that interrogates [n]\n",
  "INTERROGATORY": "like an interrogation [adj INTERROGATORILY] / a question or interrogation [n INTERROGATORIES]\n",
  "INTERROGEE": "one who is interrogated, also INTERROGATEE [n -S]\n",
  "INTERROGEES": "INTERROGEE, one who is interrogated, also INTERROGATEE [n]\n",
  "INTERROW": "existing between rows [adj]\n",
  "INTERRUPT": "to break in between [v -ED, -ING, -S]\n",
  "INTERRUPTED": "INTERRUPT, to break in between [v]\n",
  "INTERRUPTEDLY": "INTERRUPTED, INTERRUPT, to break in between [adv]\n",
  "INTERRUPTER": "one that interrupts, also INTERRUPTOR [n -S]\n",
  "INTERRUPTERS": "INTERRUPTER, one that interrupts, also INTERRUPTOR [n]\n",
  "INTERRUPTIBLE": "capable of being interrupted [adj]\n",
  "INTERRUPTING": "INTERRUPT, to break in between [v]\n",
  "INTERRUPTION": "the act of interrupting [n -S]\n",
  "INTERRUPTIONS": "INTERRUPTION, the act of interrupting [n]\n",
  "INTERRUPTIVE": "serving to interrupt [adj INTERRUPTIVELY]\n",
  "INTERRUPTIVELY": "INTERRUPTIVE, serving to interrupt [adv]\n",
  "INTERRUPTOR": "one who interrupts, also INTERRUPTER [n -S]\n",
  "INTERRUPTORS": "INTERRUPTOR, one who interrupts, also INTERRUPTER [n]\n",
  "INTERRUPTS": "INTERRUPT, to break in between [v]\n",
  "INTERS": "INTER, to bury [v]\n",
  "INTERSCAPULAR": "between the shoulder-blades [adj]\n",
  "INTERSCHOLASTIC": "existing or carried on between schools [adj]\n",
  "INTERSCHOOL": "between schools [adj]\n",
  "INTERSCRIBE": "(obsolete) to write between [v INTERSCRIBED, INTERSCRIBING, INTERSCRIBES]\n",
  "INTERSCRIBED": "INTERSCRIBE, (obsolete) to write between [v]\n",
  "INTERSCRIBES": "INTERSCRIBE, (obsolete) to write between [v]\n",
  "INTERSCRIBING": "INTERSCRIBE, (obsolete) to write between [v]\n",
  "INTERSECT": "to cut into or between; to cut or cross mutually [v -ED, -ING, -S]\n",
  "INTERSECTED": "INTERSECT, to cut into or between; to cut or cross mutually [v]\n",
  "INTERSECTING": "INTERSECT, to cut into or between; to cut or cross mutually [v]\n",
  "INTERSECTION": "the act of intersecting [n -S]\n",
  "INTERSECTIONAL": "relating to an intersection [adj]\n",
  "INTERSECTIONS": "INTERSECTION, the act of intersecting [n]\n",
  "INTERSECTS": "INTERSECT, to cut into or between; to cut or cross mutually [v]\n",
  "INTERSEGMENT": "the part of the body between two segments, such as in an earthworm [n -S]\n",
  "INTERSEGMENTAL": "between segments [adj]\n",
  "INTERSEGMENTS": "INTERSEGMENT, the part of the body between two segments, such as in an earthworm [n]\n",
  "INTERSENSORY": "relating to interaction between the senses [adj]\n",
  "INTERSEPTAL": "between septa [adj]\n",
  "INTERSERT": "(obsolete) to put in between other things; to insert [v -ED, -ING, -S]\n",
  "INTERSERTAL": "having interstitial crystalline or glassy matter between feldspar laths [adj]\n",
  "INTERSERTED": "INTERSERT, (obsolete) to put in between other things; to insert [v]\n",
  "INTERSERTING": "INTERSERT, (obsolete) to put in between other things; to insert [v]\n",
  "INTERSERTS": "INTERSERT, (obsolete) to put in between other things; to insert [v]\n",
  "INTERSERVICE": "existing between or relating to two or more of the armed services [adj]\n",
  "INTERSESSION": "a period between two academic sessions or terms sometimes utilized for brief concentrated courses [n -S]\n",
  "INTERSESSIONS": "INTERSESSION, a period between two academic sessions or terms sometimes utilized for brief concentrated courses [n]\n",
  "INTERSEX": "people having characteristics of both sexes [n -ES]\n",
  "INTERSEXES": "INTERSEX, people having characteristics of both sexes [n]\n",
  "INTERSEXUAL": "existing between sexes [adj INTERSEXUALLY] / someone existing between sexes [n -S]\n",
  "INTERSEXUALISM": "the state of being intersexual, existing between sexes [n -S]\n",
  "INTERSEXUALISMS": "INTERSEXUALISM, the state of being intersexual, existing between sexes [n]\n",
  "INTERSEXUALITY": "the state of being intersexual [n]\n",
  "INTERSEXUALLY": "INTERSEXUAL, existing between sexes [adv]\n",
  "INTERSEXUALS": "INTERSEXUAL, someone existing between sexes [n]\n",
  "INTERSIDEREAL": "between stars [adj]\n",
  "INTERSOCIETAL": "between societies [adj]\n",
  "INTERSOCIETY": "between societies [adj]\n",
  "INTERSPACE": "an intervening space [n -S] / to put spaces between [v INTERSPACED, INTERSPACING, INTERSPACES]\n",
  "INTERSPACED": "INTERSPACE, to put spaces between [v]\n",
  "INTERSPACES": "INTERSPACE, to put spaces between [v]\n",
  "INTERSPACING": "INTERSPACE, to put spaces between [v]\n",
  "INTERSPATIAL": "of or like an interspace [adj INTERSPATIALLY]\n",
  "INTERSPATIALLY": "INTERSPATIAL, of or like an interspace [adv]\n",
  "INTERSPECIES": "a species between other species [n INTERSPECIES]\n",
  "INTERSPECIFIC": "existing, occurring, or arising between species [adj]\n",
  "INTERSPERSAL": "the act of interspersing [n -S]\n",
  "INTERSPERSALS": "INTERSPERSAL, the act of interspersing [n]\n",
  "INTERSPERSE": "to place something at intervals in or among [v INTERSPERSED, INTERSPERSING, INTERSPERSES]\n",
  "INTERSPERSED": "INTERSPERSE, to place something at intervals in or among [v]\n",
  "INTERSPERSEDLY": "INTERSPERSED, INTERSPERSE, to place something at intervals in or among [adv]\n",
  "INTERSPERSES": "INTERSPERSE, to place something at intervals in or among [v]\n",
  "INTERSPERSING": "INTERSPERSE, to place something at intervals in or among [v]\n",
  "INTERSPERSION": "the act of interspersing [n -S]\n",
  "INTERSPERSIONS": "INTERSPERSION, the act of interspersing [n]\n",
  "INTERSPINAL": "between the vertebrae, also INTERSPINOUS [adj]\n",
  "INTERSPINOUS": "between the vertebrae, also INTERSPINAL [adj]\n",
  "INTERSTADIAL": "a subdivision within a glacial stage marking a temporary retreat of the ice [n -S]\n",
  "INTERSTADIALS": "INTERSTADIAL, a subdivision within a glacial stage marking a temporary retreat of the ice [n]\n",
  "INTERSTAGE": "between stages [adj]\n",
  "INTERSTATE": "any of a system of expressways connecting most major United States cities [n -S]\n",
  "INTERSTATES": "INTERSTATE, any of a system of expressways connecting most major United States cities [n]\n",
  "INTERSTATION": "between stations [adj]\n",
  "INTERSTELLAR": "in the intervals between the stars, also INTERSTELLARY [adj]\n",
  "INTERSTELLARY": "in the intervals between the stars, also INTERSTELLAR [adj]\n",
  "INTERSTERILE": "incapable of producing offspring by interbreeding [adj]\n",
  "INTERSTERILITY": "the state of being intersterile [n]\n",
  "INTERSTICE": "a gap or break in something generally continuous [n -S]\n",
  "INTERSTICES": "INTERSTICE, a gap or break in something generally continuous [n]\n",
  "INTERSTIMULUS": "between stimuli [adj]\n",
  "INTERSTITIAL": "occurring in an interstice [adj INTERSTITIALLY] / an extra atom in a crystal lattice, causing a defect [n -S]\n",
  "INTERSTITIALLY": "INTERSTITIAL, occurring in an interstice [adv]\n",
  "INTERSTITIALS": "INTERSTITIAL, an extra atom in a crystal lattice, causing a defect [n]\n",
  "INTERSTRAIN": "between strains [adj]\n",
  "INTERSTRAND": "between strands [adj]\n",
  "INTERSTRATIFIED": "INTERSTRATIFY, to create strata between [v]\n",
  "INTERSTRATIFIES": "INTERSTRATIFY, to create strata between [v]\n",
  "INTERSTRATIFY": "to create strata between [v INTERSTRATIFIED, INTERSTRATIFIES]\n",
  "INTERSUBJECTIVE": "involving or occurring between separate conscious minds [adj]\n",
  "INTERSYSTEM": "between systems [adj]\n",
  "INTERTANGLE": "to tangle together [v INTERTANGLED, INTERTANGLING, INTERTANGLES]\n",
  "INTERTANGLED": "INTERTANGLE, to tangle together [v]\n",
  "INTERTANGLEMENT": "mutual entanglement [n]\n",
  "INTERTANGLES": "INTERTANGLE, to tangle together [v]\n",
  "INTERTANGLING": "INTERTANGLE, to tangle together [v]\n",
  "INTERTARSAL": "between tarsal bones [adj]\n",
  "INTERTENTACULAR": "between tentacles [adj]\n",
  "INTERTERM": "the period between the end of one academic session and the beginning of the next session [n -S]\n",
  "INTERTERMINAL": "between termini [adj]\n",
  "INTERTERMS": "INTERTERM, the period between the end of one academic session and the beginning of the next session [n]\n",
  "INTERTEXT": "a text between texts [n -S]\n",
  "INTERTEXTS": "INTERTEXT, a text between texts [n]\n",
  "INTERTEXTUAL": "of or like an intertext [adj INTERTEXTUALLY]\n",
  "INTERTEXTUALITY": "the complex interrelationship between a text and other texts taken as basic to the creation or interpretation of the text [n]\n",
  "INTERTEXTUALLY": "INTERTEXTUAL, of or like an intertext [adv]\n",
  "INTERTEXTURE": "an interwoven state [n -S]\n",
  "INTERTEXTURES": "INTERTEXTURE, an interwoven state [n]\n",
  "INTERTIDAL": "referring to the zone between high and low tides [adj INTERTIDALLY]\n",
  "INTERTIDALLY": "INTERTIDAL, referring to the zone between high and low tides [adv]\n",
  "INTERTIE": "a short timber binding together upright posts [n -S]\n",
  "INTERTIES": "INTERTIE, a short timber binding together upright posts [n]\n",
  "INTERTILL": "to cultivate between the rows (of a crop) [v -ED, -ING, -S]\n",
  "INTERTILLAGE": "a tillage between other tillages [n -S]\n",
  "INTERTILLAGES": "INTERTILLAGE, a tillage between other tillages [n]\n",
  "INTERTILLED": "INTERTILL, to cultivate between the rows (of a crop) [v]\n",
  "INTERTILLING": "INTERTILL, to cultivate between the rows (of a crop) [v]\n",
  "INTERTILLS": "INTERTILL, to cultivate between the rows (of a crop) [v]\n",
  "INTERTISSUED": "interwoven, also ENTERTISSUED [adj]\n",
  "INTERTRAFFIC": "(obsolete) traffic between two or more people or places [n -S]\n",
  "INTERTRAFFICS": "INTERTRAFFIC, (obsolete) traffic between two or more people or places [n]\n",
  "INTERTRIAL": "taking place between trials [adj]\n",
  "INTERTRIBAL": "between tribes [adj]\n",
  "INTERTRIGO": "a skin rash due to friction of two moist surfaces [n -S]\n",
  "INTERTRIGOS": "INTERTRIGO, a skin rash due to friction of two moist surfaces [n]\n",
  "INTERTROOP": "taking place between troops [adj]\n",
  "INTERTROPICAL": "situated between or within the tropics [adj]\n",
  "INTERTWINE": "to unite by twining one with another [v INTERTWINED, INTERTWINING, INTERTWINES]\n",
  "INTERTWINED": "INTERTWINE, to unite by twining one with another [v]\n",
  "INTERTWINEMENT": "the state of being intertwined [n -S]\n",
  "INTERTWINEMENTS": "INTERTWINEMENT, the state of being intertwined [n]\n",
  "INTERTWINES": "INTERTWINE, to unite by twining one with another [v]\n",
  "INTERTWINING": "twining together [adj INTERTWININGLY] / the act of intertwining [n -S]\n",
  "INTERTWININGLY": "INTERTWINING [adv]\n",
  "INTERTWININGS": "INTERTWINING, the act of intertwining [n]\n",
  "INTERTWIST": "to twist together one with another [v -ED, -ING, -S]\n",
  "INTERTWISTED": "INTERTWIST, to twist together one with another [v]\n",
  "INTERTWISTING": "INTERTWIST, to twist together one with another [v]\n",
  "INTERTWISTINGLY": "INTERTWISTING, INTERTWIST, to twist together one with another [adv]\n",
  "INTERTWISTS": "INTERTWIST, to twist together one with another [v]\n",
  "INTERUNION": "a blending together [n -S]\n",
  "INTERUNIONS": "INTERUNION, a blending together [n]\n",
  "INTERUNIT": "between units [adj]\n",
  "INTERUNIVERSITY": "between universities [n]\n",
  "INTERURBAN": "between cities [adj]\n",
  "INTERVAL": "a space of time between periods or events [n -S]\n",
  "INTERVALE": "a low level tract of land, esp. along a river [n -S]\n",
  "INTERVALES": "INTERVALE, a low level tract of land, esp. along a river [n]\n",
  "INTERVALLEY": "between valleys [adj]\n",
  "INTERVALLIC": "relating to an interval [adj]\n",
  "INTERVALLUM": "between ramparts [adj] / a gap, an interval [n -S]\n",
  "INTERVALLUMS": "INTERVALLUM, a gap, an interval [n]\n",
  "INTERVALOMETER": "a device that operates a control (as for a camera shutter) at regular intervals [n -S]\n",
  "INTERVALOMETERS": "INTERVALOMETER, a device that operates a control (as for a camera shutter) at regular intervals [n]\n",
  "INTERVALS": "INTERVAL, a space of time between periods or events [n]\n",
  "INTERVARSITY": "of e.g. a sporting event, taking place between Oxford and Cambridge [adj]\n",
  "INTERVEIN": "to intersect (as) with veins [v -ED, -ING, -S]\n",
  "INTERVEINED": "INTERVEIN, to intersect (as) with veins [v]\n",
  "INTERVEINING": "INTERVEIN, to intersect (as) with veins [v]\n",
  "INTERVEINS": "INTERVEIN, to intersect (as) with veins [v]\n",
  "INTERVENE": "to come or be between [v INTERVENED, INTERVENING, INTERVENES]\n",
  "INTERVENED": "INTERVENE, to come or be between [v]\n",
  "INTERVENER": "one who intervenes, also INTERVENOR [n -S]\n",
  "INTERVENERS": "INTERVENER, one who intervenes, also INTERVENOR [n]\n",
  "INTERVENES": "INTERVENE, to come or be between [v]\n",
  "INTERVENIENT": "(archaic) intervening [adj]\n",
  "INTERVENING": "INTERVENE, to come or be between [v]\n",
  "INTERVENOR": "in law, one who intervenes, also INTERVENER [n -S]\n",
  "INTERVENORS": "INTERVENOR, in law, one who intervenes, also INTERVENER [n]\n",
  "INTERVENTION": "the act of intervening [n -S]\n",
  "INTERVENTIONAL": "of the nature of intervention [adj]\n",
  "INTERVENTIONISM": "the theory or practice of intervening [n]\n",
  "INTERVENTIONIST": "relating to interventionism [n]\n",
  "INTERVENTIONS": "INTERVENTION, the act of intervening [n]\n",
  "INTERVENTOR": "a mediator in ecclesiastical controversies [n -S]\n",
  "INTERVENTORS": "INTERVENTOR, a mediator in ecclesiastical controversies [n]\n",
  "INTERVERTEBRAL": "between vertebrae [adj]\n",
  "INTERVIEW": "to conduct a formal meeting with [v INTERVIEWED, INTERVIEWING, INTERVIEWS]\n",
  "INTERVIEWED": "INTERVIEW, to conduct a formal meeting with [v]\n",
  "INTERVIEWEE": "one who is interviewed [n -S]\n",
  "INTERVIEWEES": "INTERVIEWEE, one who is interviewed [n]\n",
  "INTERVIEWER": "one who interviews [n -S]\n",
  "INTERVIEWERS": "INTERVIEWER, one who interviews [n]\n",
  "INTERVIEWING": "INTERVIEW, to conduct a formal meeting with [v]\n",
  "INTERVIEWS": "INTERVIEW, to conduct a formal meeting with [v]\n",
  "INTERVILLAGE": "between villages [adj]\n",
  "INTERVISIBILITY": "the state of being intervisible [n]\n",
  "INTERVISIBLE": "able to be seen between [adj]\n",
  "INTERVISITATION": "between visits [n]\n",
  "INTERVITAL": "between two lives [adj]\n",
  "INTERVOCALIC": "immediately preceded and immediately followed by a vowel [adj]\n",
  "INTERVOLVE": "to roll up or entwine with one another [v INTERVOLVED, INTERVOLVING, INTERVOLVES]\n",
  "INTERVOLVED": "INTERVOLVE, to roll up or entwine with one another [v]\n",
  "INTERVOLVES": "INTERVOLVE, to roll up or entwine with one another [v]\n",
  "INTERVOLVING": "INTERVOLVE, to roll up or entwine with one another [v]\n",
  "INTERWAR": "happening between wars [adj]\n",
  "INTERWEAVE": "to weave together [v INTERWEAVED or INTERWOVE, INTERWOVEN, INTERWEAVING, INTERWEAVES]\n",
  "INTERWEAVED": "INTERWEAVE, to weave together [v]\n",
  "INTERWEAVEMENT": "the act of interweaving [n -S]\n",
  "INTERWEAVEMENTS": "INTERWEAVEMENT, the act of interweaving [n]\n",
  "INTERWEAVER": "one who interweaves [n -S]\n",
  "INTERWEAVERS": "INTERWEAVER, one who interweaves [n]\n",
  "INTERWEAVES": "INTERWEAVE, to weave together [v]\n",
  "INTERWEAVING": "INTERWEAVE, to weave together [v]\n",
  "INTERWEB": "a facetious name for the Internet, used to imply that the speaker has little understanding of or interest in the subject [n -S]\n",
  "INTERWEBS": "INTERWEB, a facetious name for the Internet, used to imply that the speaker has little understanding of or interest in the subject [n]\n",
  "INTERWIND": "to wind in among [v INTERWOUND, INTERWINDING, INTERWINDS]\n",
  "INTERWINDING": "INTERWIND, to wind in among [v]\n",
  "INTERWINDS": "INTERWIND, to wind in among [v]\n",
  "INTERWORD": "between words [adj]\n",
  "INTERWORK": "to work together or in among [v INTERWORKED or INTERWROUGHT, INTERWORKING, INTERWORKS]\n",
  "INTERWORKED": "INTERWORK, to work together or in among [v]\n",
  "INTERWORKING": "the act of working together [n -S]\n",
  "INTERWORKINGS": "INTERWORKING, the act of working together [n]\n",
  "INTERWORKS": "INTERWORK, to work together or in among [v]\n",
  "INTERWOUND": "INTERWIND, to wind in among [v]\n",
  "INTERWOVE": "INTERWEAVE, to weave together [v]\n",
  "INTERWOVEN": "INTERWEAVE, to weave together [v]\n",
  "INTERWREATHE": "to twine in between [v INTERWREATHED, INTERWREATHING, INTERWREATHES]\n",
  "INTERWREATHED": "INTERWREATHE, to twine in between [v]\n",
  "INTERWREATHES": "INTERWREATHE, to twine in between [v]\n",
  "INTERWREATHING": "INTERWREATHE, to twine in between [v]\n",
  "INTERWROUGHT": "INTERWORK, to work together or in among [v]\n",
  "INTERZONAL": "between zones [adj]\n",
  "INTERZONE": "a zone between zones [n -S]\n",
  "INTERZONES": "INTERZONE, a zone between zones [n]\n",
  "INTESTACIES": "INTESTACY, the condition or fact of dying without having made a will [n]\n",
  "INTESTACY": "the condition or fact of dying without having made a will [n INTESTACIES]\n",
  "INTESTATE": "not having made a will [adj] / one who has not made a will [n -S]\n",
  "INTESTATES": "INTESTATE, one who has not made a will [n]\n",
  "INTESTINAL": "affecting, occurring, or living in the intestine [adj INTESTINALLY]\n",
  "INTESTINALLY": "INTESTINAL, affecting, occurring, or living in the intestine [adv]\n",
  "INTESTINE": "a part of the digestive system extending from the stomach to the anus [n -S]\n",
  "INTESTINES": "INTESTINE, a part of the digestive system extending from the stomach to the anus [n]\n",
  "INTHRAL": "to charm, also ENTHRALL, INTHRALL [v INTHRALLED, INTHRALLING, INTHRALS]\n",
  "INTHRALL": "to charm, also ENTHRALL, INTHRAL [v -ED, -ING, -S]\n",
  "INTHRALLED": "INTHRALL, to charm, also ENTHRALL, INTHRAL [v]\n",
  "INTHRALLING": "INTHRALL, to charm, also ENTHRALL, INTHRAL [v]\n",
  "INTHRALLS": "INTHRALL, to charm, also ENTHRALL, INTHRAL [v]\n",
  "INTHRALS": "INTHRAL, to charm, also ENTHRALL, INTHRALL [v]\n",
  "INTHRONE": "to place on a throne, also ENTHRONE [v INTHRONED, INTHRONING, INTHRONES]\n",
  "INTHRONED": "INTHRONE, to place on a throne, also ENTHRONE [v]\n",
  "INTHRONES": "INTHRONE, to place on a throne, also ENTHRONE [v]\n",
  "INTHRONING": "INTHRONE, to place on a throne, also ENTHRONE [v]\n",
  "INTI": "(Quechua) a monetary unit of Peru [n -S]\n",
  "INTIFADA": "(Arabic) the uprising in 1987 and continued resistance by Palestinians to Israeli occupation of the Gaza Strip and the West Bank of Jordan, also INTIFADAH, INTIFADEH [n -S]\n",
  "INTIFADAH": "(Arabic) the uprising in 1987 and continued resistance by Palestinians to Israeli occupation of the Gaza Strip and the West Bank of Jordan, also INTIFADA, INTIFADEH [n -S]\n",
  "INTIFADAHS": "INTIFADAH, (Arabic) the uprising in 1987 and continued resistance by Palestinians to Israeli occupation of the Gaza Strip and the West Bank of Jordan, also INTIFADA, INTIFADEH [n]\n",
  "INTIFADAS": "INTIFADA, (Arabic) the uprising in 1987 and continued resistance by Palestinians to Israeli occupation of the Gaza Strip and the West Bank of Jordan, also INTIFADAH, INTIFADEH [n]\n",
  "INTIFADEH": "(Arabic) the uprising in 1987 and continued resistance by Palestinians to Israeli occupation of the Gaza Strip and the West Bank of Jordan, also INTIFADA, INTIFADAH [n -S]\n",
  "INTIFADEHS": "INTIFADEH, (Arabic) the uprising in 1987 and continued resistance by Palestinians to Israeli occupation of the Gaza Strip and the West Bank of Jordan, also INTIFADA, INTIFADAH [n]\n",
  "INTIL": "(Scots) into, in [prep]\n",
  "INTIMA": "(Latin) the innermost layer of an organ [n INTIMAS or INTIMAE]\n",
  "INTIMACIES": "INTIMACY, a state of close familiarity, also INTIMITY [n]\n",
  "INTIMACY": "a state of close familiarity, also INTIMITY [n INTIMACIES]\n",
  "INTIMAE": "INTIMA, (Latin) the innermost layer of an organ [n]\n",
  "INTIMAL": "relating to an intima, the innermost layer of an organ [adj]\n",
  "INTIMAS": "INTIMA, (Latin) the innermost layer of an organ [n]\n",
  "INTIMATE": "innermost [adj INTIMATELY] / to make known indirectly [v INTIMATED, INTIMATING, INTIMATES]\n",
  "INTIMATED": "INTIMATE, to make known indirectly [v]\n",
  "INTIMATELY": "INTIMATE, innermost [adv]\n",
  "INTIMATENESS": "the state of being intimate [n -ES]\n",
  "INTIMATENESSES": "INTIMATENESS, the state of being intimate [n]\n",
  "INTIMATER": "one who intimates [n -S]\n",
  "INTIMATERS": "INTIMATER, one who intimates [n]\n",
  "INTIMATES": "INTIMATE, to make known indirectly [v]\n",
  "INTIMATING": "INTIMATE, to make known indirectly [v]\n",
  "INTIMATION": "the act of intimating [n -S]\n",
  "INTIMATIONS": "INTIMATION, the act of intimating [n]\n",
  "INTIME": "(French) intimate, cosy [adj]\n",
  "INTIMIDATE": "to make timid or fearful [v INTIMIDATED, INTIMIDATING, INTIMIDATES]\n",
  "INTIMIDATED": "INTIMIDATE, to make timid or fearful [v]\n",
  "INTIMIDATES": "INTIMIDATE, to make timid or fearful [v]\n",
  "INTIMIDATING": "INTIMIDATE, to make timid or fearful [v]\n",
  "INTIMIDATINGLY": "INTIMIDATING, INTIMIDATE, to make timid or fearful [adv]\n",
  "INTIMIDATION": "the act of intimidating [n -S]\n",
  "INTIMIDATIONS": "INTIMIDATION, the act of intimidating [n]\n",
  "INTIMIDATOR": "one who intimidates [n -S]\n",
  "INTIMIDATORS": "INTIMIDATOR, one who intimidates [n]\n",
  "INTIMIDATORY": "tending or intended to intimidate [adj]\n",
  "INTIMISM": "a genre of French impressionist painting of the early 20th century [n -S]\n",
  "INTIMISMS": "INTIMISM, a genre of French impressionist painting of the early 20th century [n]\n",
  "INTIMIST": "a painter whose subject matter is everyday life [n -S]\n",
  "INTIMISTE": "(French) a painter of the school of intimism, a genre of French impressionist painting of the early 20th century, also INTIMIST [n -S]\n",
  "INTIMISTES": "INTIMISTE, (French) a painter of the school of intimism, a genre of French impressionist painting of the early 20th century, also INTIMIST [n]\n",
  "INTIMISTS": "INTIMIST, a painter whose subject matter is everyday life [n]\n",
  "INTIMITIES": "INTIMITY, a state of close familiarity, also INTIMACY [n]\n",
  "INTIMITY": "a state of close familiarity, also INTIMACY [n INTIMITIES]\n",
  "INTINCTION": "a mode of administering communion by dipping bread into wine [n -S]\n",
  "INTINCTIONS": "INTINCTION, a mode of administering communion by dipping bread into wine [n]\n",
  "INTINE": "the inner membrane of a pollen grain or spore [n -S]\n",
  "INTINES": "INTINE, the inner membrane of a pollen grain or spore [n]\n",
  "INTIRE": "(obsolete) entire [adj]\n",
  "INTIS": "INTI, (Quechua) a monetary unit of Peru [n]\n",
  "INTITLE": "to give a right to, also ENTITLE, INTITULE [v INTITLED, INTITLING, INTITLES]\n",
  "INTITLED": "INTITLE, to give a right to, also ENTITLE, INTITULE [v]\n",
  "INTITLES": "INTITLE, to give a right to, also ENTITLE, INTITULE [v]\n",
  "INTITLING": "INTITLE, to give a right to, also ENTITLE, INTITULE [v]\n",
  "INTITULE": "to give a right to, also ENTITLE, INTITLE [v INTITULED, INTITULING, INTITULES]\n",
  "INTITULED": "INTITULE, to give a right to, also ENTITLE, INTITLE [v]\n",
  "INTITULES": "INTITULE, to give a right to, also ENTITLE, INTITLE [v]\n",
  "INTITULING": "INTITULE, to give a right to, also ENTITLE, INTITLE [v]\n",
  "INTO": "to a position within [prep]\n",
  "INTOED": "having the toes pointed inwards [adj]\n",
  "INTOLERABILITY": "the state of being intolerable [n]\n",
  "INTOLERABLE": "that cannot be tolerated [adj INTOLERABLY]\n",
  "INTOLERABLENESS": "INTOLERABLE, that cannot be tolerated [n]\n",
  "INTOLERABLY": "INTOLERABLE, that cannot be tolerated [adv]\n",
  "INTOLERANCE": "the state of being intolerant [n -S]\n",
  "INTOLERANCES": "INTOLERANCE, the state of being intolerant [n]\n",
  "INTOLERANT": "not tolerant [adj INTOLERANTLY] / one who is intolerant [n -S]\n",
  "INTOLERANTLY": "INTOLERANT, not tolerant [adv]\n",
  "INTOLERANTNESS": "INTOLERANT, not tolerant [n]\n",
  "INTOLERANTS": "INTOLERANT, one who is intolerant [n]\n",
  "INTOLERATION": "lack of toleration [n -S]\n",
  "INTOLERATIONS": "INTOLERATION, lack of toleration [n]\n",
  "INTOMB": "to place in a tomb, also ENTOMB [v -ED, -ING, -S]\n",
  "INTOMBED": "INTOMB, to place in a tomb, also ENTOMB [v]\n",
  "INTOMBING": "INTOMB, to place in a tomb, also ENTOMB [v]\n",
  "INTOMBS": "INTOMB, to place in a tomb, also ENTOMB [v]\n",
  "INTONACO": "(Italian) in fresco painting, the finishing coat of lime plaster on which the paint is applied [n -S]\n",
  "INTONACOS": "INTONACO, (Italian) in fresco painting, the finishing coat of lime plaster on which the paint is applied [n]\n",
  "INTONATE": "to modulate the voice [v INTONATED, INTONATING, INTONATES]\n",
  "INTONATED": "INTONATE, to modulate the voice [v]\n",
  "INTONATES": "INTONATE, to modulate the voice [v]\n",
  "INTONATING": "INTONATE, to modulate the voice [v]\n",
  "INTONATION": "something that is intoned [n -S]\n",
  "INTONATIONAL": "relating to intonation [adj]\n",
  "INTONATIONS": "INTONATION, something that is intoned [n]\n",
  "INTONATOR": "one who intonates [n -S]\n",
  "INTONATORS": "INTONATOR, one who intonates [n]\n",
  "INTONE": "to speak in a singing voice [v INTONED, INTONING, INTONES]\n",
  "INTONED": "INTONE, to speak in a singing voice [v]\n",
  "INTONER": "one who intones [n -S]\n",
  "INTONERS": "INTONER, one who intones [n]\n",
  "INTONES": "INTONE, to speak in a singing voice [v]\n",
  "INTONING": "the act of intoning [n -S]\n",
  "INTONINGLY": "INTONING [adv]\n",
  "INTONINGS": "INTONING, the act of intoning [n]\n",
  "INTORSION": "a twist, a twine, also INTORTION [n -S]\n",
  "INTORSIONS": "INTORSION, a twist, a twine, also INTORTION [n]\n",
  "INTORT": "to twist inwards [v -ED, -ING, -S]\n",
  "INTORTED": "INTORT, to twist inwards [v]\n",
  "INTORTING": "INTORT, to twist inwards [v]\n",
  "INTORTION": "a twist, a twine, also INTORSION [n -S]\n",
  "INTORTIONS": "INTORTION, a twist, a twine, also INTORSION [n]\n",
  "INTORTS": "INTORT, to twist inwards [v]\n",
  "INTOWN": "located in the centre of the city [adj]\n",
  "INTOXICABLE": "able to be intoxicated [adj]\n",
  "INTOXICANT": "something that intoxicates [n -S]\n",
  "INTOXICANTS": "INTOXICANT, something that intoxicates [n]\n",
  "INTOXICATE": "to make drunk [v INTOXICATED, INTOXICATING, INTOXICATES]\n",
  "INTOXICATED": "INTOXICATE, to make drunk [v]\n",
  "INTOXICATEDLY": "INTOXICATED, INTOXICATE, to make drunk [adv]\n",
  "INTOXICATES": "INTOXICATE, to make drunk [v]\n",
  "INTOXICATING": "INTOXICATE, to make drunk [v]\n",
  "INTOXICATINGLY": "INTOXICATING, INTOXICATE, to make drunk [adv]\n",
  "INTOXICATION": "an abnormal state that is essentially a poisoning [n -S]\n",
  "INTOXICATIONS": "INTOXICATION, an abnormal state that is essentially a poisoning [n]\n",
  "INTOXICATIVE": "serving to intoxicate [adj]\n",
  "INTOXICATOR": "one who intoxicates [n -S]\n",
  "INTOXICATORS": "INTOXICATOR, one who intoxicates [n]\n",
  "INTOXIMETER": "a device for measuring the amount of alcohol in the blood of a person who breathes into it, and showing this measurement on a printout [n -S]\n",
  "INTOXIMETERS": "INTOXIMETER, a device for measuring the amount of alcohol in the blood of a person who breathes into it, and showing this measurement on a printout [n]\n",
  "INTRA": "(Latin) within [prep]\n",
  "INTRACAPSULAR": "lying within a capsule [adj]\n",
  "INTRACARDIAC": "situated or occurring within or introduced or involving entry into the heart [adj]\n",
  "INTRACARDIAL": "within the heart [adj INTRACARDIALLY]\n",
  "INTRACARDIALLY": "INTRACARDIAL, within the heart [adv]\n",
  "INTRACAVITARY": "applied within or through body cavities, as radium applied in the uterus, or irradiation through natural or artificial body cavities [adj]\n",
  "INTRACELLULAR": "existing, occurring, or functioning within a cell [adj INTRACELLULARLY]\n",
  "INTRACELLULARLY": "INTRACELLULAR, existing, occurring, or functioning within a cell [adv]\n",
  "INTRACEREBRAL": "situated or occurring within or introduced or administered into the cerebrum [adj INTRACEREBRALLY]\n",
  "INTRACEREBRALLY": "INTRACEREBRAL, situated or occurring within or introduced or administered into the cerebrum [adv]\n",
  "INTRACITY": "between cities [adj]\n",
  "INTRACOMPANY": "occurring within or taking place between branches or employees of a company [adj]\n",
  "INTRACRANIAL": "existing or occurring within the cranium [adj INTRACRANIALLY]\n",
  "INTRACRANIALLY": "INTRACRANIAL, existing or occurring within the cranium [adv]\n",
  "INTRACTABILITY": "the state of being intractable [n]\n",
  "INTRACTABLE": "unmanageable, also UNTRACTABLE [adj INTRACTABLY]\n",
  "INTRACTABLENESS": "INTRACTABLE, unmanageable, also UNTRACTABLE [n]\n",
  "INTRACTABLY": "INTRACTABLE, unmanageable, also UNTRACTABLE [adv]\n",
  "INTRACUTANEOUS": "within the skin [adj]\n",
  "INTRADA": "(Italian) a musical prelude [n -S]\n",
  "INTRADAS": "INTRADA, (Italian) a musical prelude [n]\n",
  "INTRADAY": "occurring within a single day [adj]\n",
  "INTRADERMAL": "situated or done within or between the layers of the skin, also INTRADERMIC [adj INTRADERMALLY]\n",
  "INTRADERMALLY": "INTRADERMAL, situated or done within or between the layers of the skin, also INTRADERMIC [adv]\n",
  "INTRADERMIC": "situated or done within or between the layers of the skin, also INTRADERMAL [adj INTRADERMICALLY]\n",
  "INTRADERMICALLY": "INTRADERMIC, situated or done within or between the layers of the skin, also INTRADERMAL [adv]\n",
  "INTRADOS": "(French) the inner curve of an arch [n -ES]\n",
  "INTRADOSES": "INTRADOS, (French) the inner curve of an arch [n]\n",
  "INTRAFALLOPIAN": "within, or introduced into, (either of) the Fallopian tubes [adj]\n",
  "INTRAFASCICULAR": "between fascicles [adj]\n",
  "INTRAGALACTIC": "situated or occurring within the confines of a single galaxy [adj]\n",
  "INTRAGENIC": "being or occurring within a gene [adj]\n",
  "INTRAMEDULLARY": "within the bone marrow [adj]\n",
  "INTRAMERCURIAL": "within Mercury's orbit [adj]\n",
  "INTRAMOLECULAR": "existing or acting within the molecule [adj]\n",
  "INTRAMUNDANE": "within the world [adj]\n",
  "INTRAMURAL": "being within the walls, as of a city [adj INTRAMURALLY]\n",
  "INTRAMURALLY": "INTRAMURAL, being within the walls, as of a city [adv]\n",
  "INTRAMURALS": "sports played by teams or competitors within the same school or university [n]\n",
  "INTRAMUSCULAR": "situated in, occurring in, or administered by entering a muscle [adj INTRAMUSCULARLY]\n",
  "INTRAMUSCULARLY": "INTRAMUSCULAR, situated in, occurring in, or administered by entering a muscle [adv]\n",
  "INTRANASAL": "lying within or administered by way of the nasal structure [adj INTRANASALLY]\n",
  "INTRANASALLY": "INTRANASAL, lying within or administered by way of the nasal structure [adv]\n",
  "INTRANATIONAL": "within a nation [adj]\n",
  "INTRANET": "a restricted network of computers such as within a company [n -S]\n",
  "INTRANETS": "INTRANET, a restricted network of computers such as within a company [n]\n",
  "INTRANSIGEANCE": "the state of being intransigeant, also INTRANSIGENCE, INTRANSIGENCY [n -S]\n",
  "INTRANSIGEANCES": "INTRANSIGEANCE, the state of being intransigeant, also INTRANSIGENCE, INTRANSIGENCY [n]\n",
  "INTRANSIGEANT": "intransigent [adj INTRANSIGEANTLY] / one who is intransigeant [n -S]\n",
  "INTRANSIGEANTLY": "INTRANSIGEANT, intransigent [adv]\n",
  "INTRANSIGEANTS": "INTRANSIGEANT, one who is intransigeant [n]\n",
  "INTRANSIGENCE": "the state of being intransigent, also INTRANSIGEANCE, INTRANSIGENCY [n -S]\n",
  "INTRANSIGENCES": "INTRANSIGENCE, the state of being intransigent, also INTRANSIGEANCE, INTRANSIGENCY [n]\n",
  "INTRANSIGENCIES": "INTRANSIGENCY, the state of being intransigent, also INTRANSIGEANCE, INTRANSIGENCE [n]\n",
  "INTRANSIGENCY": "the state of being intransigent, also INTRANSIGEANCE, INTRANSIGENCE [n INTRANSIGENCIES]\n",
  "INTRANSIGENT": "characterized by refusal to compromise [adj INTRANSIGENTLY] / an intransigent person [n -S]\n",
  "INTRANSIGENTISM": "a policy of being intransigent [n]\n",
  "INTRANSIGENTIST": "a supporter of intransigentism [n]\n",
  "INTRANSIGENTLY": "INTRANSIGENT, characterized by refusal to compromise [adv]\n",
  "INTRANSIGENTS": "INTRANSIGENT, an intransigent person [n]\n",
  "INTRANSITIVE": "not transitive [adj INTRANSITIVELY] / a type of verb [n -S]\n",
  "INTRANSITIVELY": "INTRANSITIVE, not transitive [adv]\n",
  "INTRANSITIVES": "INTRANSITIVE, a type of verb [n]\n",
  "INTRANSITIVITY": "the state of being intransitive [n]\n",
  "INTRANSMISSIBLE": "that cannot be transmitted [adj]\n",
  "INTRANSMUTABLE": "not capable of being transmuted [adj]\n",
  "INTRANT": "a person who enters, esp. on membership, office or possession [n -S]\n",
  "INTRANTS": "INTRANT, a person who enters, esp. on membership, office or possession [n]\n",
  "INTRANUCLEAR": "within the nucleus [adj]\n",
  "INTRAOCULAR": "situated or occurring within the eyeball [adj INTRAOCULARLY]\n",
  "INTRAOCULARLY": "INTRAOCULAR, situated or occurring within the eyeball [adv]\n",
  "INTRAPARIETAL": "within walls, private; situated in the parietal lobe of the brain [adj]\n",
  "INTRAPARTUM": "of or relating to childbirth [adj]\n",
  "INTRAPERITONEAL": "existing within or administered by entry into the peritoneum [adj]\n",
  "INTRAPERSONAL": "occurring within the individual mind or self [adj]\n",
  "INTRAPETIOLAR": "situated between petiole and stem [adj]\n",
  "INTRAPLATE": "relating to or occurring within the interior of a tectonic plate, e.g. an intraplate earthquake [adj]\n",
  "INTRAPOPULATION": "occurring within or taking place between members of a population [adj]\n",
  "INTRAPRENEUR": "a company employee who is not bound by rules or policies and who is free to refine products [n -S]\n",
  "INTRAPRENEURIAL": "of or like an intrapreneur, a company employee who is not bound by rules or policies and who is free to refine products [adj]\n",
  "INTRAPRENEURS": "INTRAPRENEUR, a company employee who is not bound by rules or policies and who is free to refine products [n]\n",
  "INTRAPSYCHIC": "being or occurring within the psyche, mind, or personality [adj]\n",
  "INTRASEXUAL": "within or between members of the same sex [adj]\n",
  "INTRASPECIES": "occurring within a species or involving members of one species, also INTRASPECIFIC [adj]\n",
  "INTRASPECIFIC": "occurring within a species or involving members of one species, also INTRASPECIES [adj]\n",
  "INTRASTATE": "existing or occurring within a state [adj]\n",
  "INTRATELLURIC": "of rocks and their constituents, processes, etc., formed or occurring below the surface of the earth [adj]\n",
  "INTRATHECAL": "introduced into or occurring in the space under the arachnoid membrane of the brain or spinal cord [adj INTRATHECALLY]\n",
  "INTRATHECALLY": "INTRATHECAL, introduced into or occurring in the space under the arachnoid membrane of the brain or spinal cord [adv]\n",
  "INTRATHORACIC": "situated or occurring within the thorax [adj]\n",
  "INTRAUTERINE": "situated, used, or occurring within the uterus [adj]\n",
  "INTRAVASATION": "the entrance of externally formed matter into vessels [n -S]\n",
  "INTRAVASATIONS": "INTRAVASATION, the entrance of externally formed matter into vessels [n]\n",
  "INTRAVASCULAR": "situated in, occurring in, or administered by entry into a blood vessel [adj INTRAVASCULARLY]\n",
  "INTRAVASCULARLY": "INTRAVASCULAR, situated in, occurring in, or administered by entry into a blood vessel [adv]\n",
  "INTRAVENOUS": "situated, performed, or occurring within or entering by way of a vein [adj INTRAVENOUSLY]\n",
  "INTRAVENOUSLY": "INTRAVENOUS, situated, performed, or occurring within or entering by way of a vein [adv]\n",
  "INTRAVERSABLE": "that cannot be traversed [adj]\n",
  "INTRAVITAL": "performed upon or found in a living organism, also INTRAVITAM [adj INTRAVITALLY]\n",
  "INTRAVITALLY": "INTRAVITAL, performed upon or found in a living organism, also INTRAVITAM [adv]\n",
  "INTRAVITAM": "performed upon or found in a living organism, also INTRAVITAL [adj]\n",
  "INTRAZONAL": "within zones [adj]\n",
  "INTREAT": "to ask for earnestly, also ENTREAT [v -ED, -ING, -S]\n",
  "INTREATED": "INTREAT, to ask for earnestly, also ENTREAT [v]\n",
  "INTREATFULL": "(Spenser) full of entreaty [adj]\n",
  "INTREATING": "INTREAT, to ask for earnestly, also ENTREAT [v]\n",
  "INTREATINGLY": "INTREATING, INTREAT, to ask for earnestly, also ENTREAT [adv]\n",
  "INTREATMENT": "the act of intreating [n -S]\n",
  "INTREATMENTS": "INTREATMENT, the act of intreating [n]\n",
  "INTREATS": "INTREAT, to ask for earnestly, also ENTREAT [v]\n",
  "INTRENCH": "to fix firmly, also ENTRENCH [v -ED, -ING, -ES]\n",
  "INTRENCHANT": "(Shakespeare) incapable of being cut [adj]\n",
  "INTRENCHED": "INTRENCH, to fix firmly, also ENTRENCH [v]\n",
  "INTRENCHER": "one who intrenches, also ENTRENCHER [n -S]\n",
  "INTRENCHERS": "INTRENCHER, one who intrenches, also ENTRENCHER [n]\n",
  "INTRENCHES": "INTRENCH, to fix firmly, also ENTRENCH [v]\n",
  "INTRENCHING": "INTRENCH, to fix firmly, also ENTRENCH [v]\n",
  "INTRENCHMENT": "the act of intrenching [n -S]\n",
  "INTRENCHMENTS": "INTRENCHMENT, the act of intrenching [n]\n",
  "INTREPID": "fearless [adj INTREPIDLY]\n",
  "INTREPIDITIES": "INTREPIDITY, the state of being intrepid [n]\n",
  "INTREPIDITY": "the state of being intrepid [n INTREPIDITIES]\n",
  "INTREPIDLY": "INTREPID, fearless [adv]\n",
  "INTREPIDNESS": "the state of being intrepid [n -ES]\n",
  "INTREPIDNESSES": "INTREPIDNESS, the state of being intrepid [n]\n",
  "INTRICACIES": "INTRICACY, the state of being intricate [n]\n",
  "INTRICACY": "the state of being intricate [n INTRICACIES]\n",
  "INTRICATE": "involved, complex, also INTRINCE, INTRINSICATE [adj INTRICATELY]\n",
  "INTRICATELY": "INTRICATE, involved, complex, also INTRINCE, INTRINSICATE [adv]\n",
  "INTRICATENESS": "the state of being intricate [n -ES]\n",
  "INTRICATENESSES": "INTRICATENESS, the state of being intricate [n]\n",
  "INTRIGANT": "(archaic) a (male) intriguer, also INTRIGUANT [n -S]\n",
  "INTRIGANTE": "(French) a female intriguer, also INTRIGUANTE [n -S]\n",
  "INTRIGANTES": "INTRIGANTE, (French) a female intriguer, also INTRIGUANTE [n]\n",
  "INTRIGANTS": "INTRIGANT, (archaic) a (male) intriguer, also INTRIGUANT [n]\n",
  "INTRIGUANT": "(archaic) one that intrigues, also INTRIGANT [n -S]\n",
  "INTRIGUANTE": "(French) a female intriguer, also INTRIGANTE [n -S]\n",
  "INTRIGUANTES": "INTRIGUANTE, (French) a female intriguer, also INTRIGANTE [n]\n",
  "INTRIGUANTS": "INTRIGUANT, (archaic) one that intrigues, also INTRIGANT [n]\n",
  "INTRIGUE": "to arouse the curiosity of [v INTRIGUED, INTRIGUING, INTRIGUES]\n",
  "INTRIGUED": "INTRIGUE, to arouse the curiosity of [v]\n",
  "INTRIGUER": "one who intrigues [n -S]\n",
  "INTRIGUERS": "INTRIGUER, one who intrigues [n]\n",
  "INTRIGUES": "INTRIGUE, to arouse the curiosity of [v]\n",
  "INTRIGUING": "INTRIGUE, to arouse the curiosity of [v]\n",
  "INTRIGUINGLY": "INTRIGUING, INTRIGUE, to arouse the curiosity of [adv]\n",
  "INTRINCE": "(Shakespeare) intricate [adj]\n",
  "INTRINSIC": "inward, internal, also INTRINSICAL [adj INTRINSICALLY]\n",
  "INTRINSICAL": "inward, internal, also INTRINSIC [adj INTRINSICALLY]\n",
  "INTRINSICALITY": "the state of being intrinsic [n]\n",
  "INTRINSICALLY": "INTRINSICAL, inward, internal, also INTRINSIC [adv]\n",
  "INTRINSICALNESS": "the quality of being intrinsic [n]\n",
  "INTRINSICATE": "(Shakespeare) intricate, also INTRICATE, INTRINCE [adj]\n",
  "INTRO": "(short for) an introduction [n -S]\n",
  "INTRODUCE": "to bring in, establish [v INTRODUCED, INTRODUCING, INTRODUCES]\n",
  "INTRODUCED": "INTRODUCE, to bring in, establish [v]\n",
  "INTRODUCER": "one who introduces [n -S]\n",
  "INTRODUCERS": "INTRODUCER, one who introduces [n]\n",
  "INTRODUCES": "INTRODUCE, to bring in, establish [v]\n",
  "INTRODUCIBLE": "that can be introduced [adj]\n",
  "INTRODUCING": "INTRODUCE, to bring in, establish [v]\n",
  "INTRODUCTION": "a part of a book or treatise preliminary to the main portion [n -S]\n",
  "INTRODUCTIONS": "INTRODUCTION, a part of a book or treatise preliminary to the main portion [n]\n",
  "INTRODUCTIVE": "serving to introduce, also INTRODUCTORY [adj]\n",
  "INTRODUCTORILY": "INTRODUCTORY, serving to introduce, also INTRODUCTIVE [adv]\n",
  "INTRODUCTORY": "serving to introduce, also INTRODUCTIVE [adj INTRODUCTORILY]\n",
  "INTROFIED": "INTROFY, to increase the wetting properties of [v]\n",
  "INTROFIES": "INTROFY, to increase the wetting properties of [v]\n",
  "INTROFY": "to increase the wetting properties of [v INTROFIED, INTROFYING, INTROFIES]\n",
  "INTROFYING": "INTROFY, to increase the wetting properties of [v]\n",
  "INTROGRESSANT": "a gene introduced from one species into another [n -S]\n",
  "INTROGRESSANTS": "INTROGRESSANT, a gene introduced from one species into another [n]\n",
  "INTROGRESSION": "the modification of species by the backcrossing of the hybrids with the parent species [n -S]\n",
  "INTROGRESSIONS": "INTROGRESSION, the modification of species by the backcrossing of the hybrids with the parent species [n]\n",
  "INTROGRESSIVE": "relating to introgression [adj]\n",
  "INTROIT": "(Latin) psalm or antiphon sung or said at the start of a service [n -S]\n",
  "INTROITAL": "relating to an introit, the first part of the Roman Catholic Mass [adj]\n",
  "INTROITS": "INTROIT, (Latin) psalm or antiphon sung or said at the start of a service [n]\n",
  "INTROITUS": "(Latin) the entrance to a cavity or hollow organ e.g. the vagina [n -ES]\n",
  "INTROITUSES": "INTROITUS, (Latin) the entrance to a cavity or hollow organ e.g. the vagina [n]\n",
  "INTROJECT": "to incorporate external ideas and attitudes into one's own personality [v -ED, -ING, -S]\n",
  "INTROJECTED": "INTROJECT, to incorporate external ideas and attitudes into one's own personality [v]\n",
  "INTROJECTING": "INTROJECT, to incorporate external ideas and attitudes into one's own personality [v]\n",
  "INTROJECTION": "the incorporation of external ideas and attitudes into one's own personality [n -S]\n",
  "INTROJECTIONS": "INTROJECTION, the incorporation of external ideas and attitudes into one's own personality [n]\n",
  "INTROJECTIVE": "INTROJECT, to incorporate external ideas and attitudes into one's own personality [adj]\n",
  "INTROJECTS": "INTROJECT, to incorporate external ideas and attitudes into one's own personality [v]\n",
  "INTROLD": "(Spenser) a past participle of obscure meaning, possibly enrolled, also ENTROLD [v]\n",
  "INTROMISSIBLE": "that can be intromitted [adj]\n",
  "INTROMISSION": "an introduction, an insertion [n -S]\n",
  "INTROMISSIONS": "INTROMISSION, an introduction, an insertion [n]\n",
  "INTROMISSIVE": "relating to intromission [adj]\n",
  "INTROMIT": "to introduce or admit [v INTROMITTED, INTROMITTING, INTROMITS]\n",
  "INTROMITS": "INTROMIT, to introduce or admit [v]\n",
  "INTROMITTED": "INTROMIT, to introduce or admit [v]\n",
  "INTROMITTENT": "adapted for insertion, esp. zoologically, in copulation [adj]\n",
  "INTROMITTER": "one who intromits [n -S]\n",
  "INTROMITTERS": "INTROMITTER, one who intromits [n]\n",
  "INTROMITTING": "INTROMIT, to introduce or admit [v]\n",
  "INTRON": "any of the segments of a eukaryotic gene that do not carry coded information for the synthesis of proteins [n -S]\n",
  "INTRONIC": "of or like an intron, an intervening sequence in the genetic code [adj]\n",
  "INTRONS": "INTRON, any of the segments of a eukaryotic gene that do not carry coded information for the synthesis of proteins [n]\n",
  "INTRORSE": "turned or facing inward [adj INTRORSELY]\n",
  "INTRORSELY": "INTRORSE, turned or facing inward [adv]\n",
  "INTROS": "INTRO, (short for) an introduction [n]\n",
  "INTROSPECT": "to look inwards [v -ED, -ING, -S]\n",
  "INTROSPECTED": "INTROSPECT, to look inwards [v]\n",
  "INTROSPECTING": "INTROSPECT, to look inwards [v]\n",
  "INTROSPECTION": "a reflective looking inward [n -S]\n",
  "INTROSPECTIONAL": "relating to introspection, also INTROSPECTIVE [adj]\n",
  "INTROSPECTIONS": "INTROSPECTION, a reflective looking inward [n]\n",
  "INTROSPECTIVE": "relating to introspection, also INTROSPECTIONAL [adj INTROSPECTIVELY]\n",
  "INTROSPECTIVELY": "INTROSPECTIVE, relating to introspection, also INTROSPECTIONAL [adv]\n",
  "INTROSPECTS": "INTROSPECT, to look inwards [v]\n",
  "INTROSUSCEPTION": "intussusception [n]\n",
  "INTROVERSIBLE": "capable of being introverted [adj]\n",
  "INTROVERSION": "the act of introverting [n -S]\n",
  "INTROVERSIONS": "INTROVERSION, the act of introverting [n]\n",
  "INTROVERSIVE": "related to introversion [adj INTROVERSIVELY]\n",
  "INTROVERSIVELY": "INTROVERSIVE, related to introversion [adv]\n",
  "INTROVERT": "to turn inwards [v -ED, -ING, -S]\n",
  "INTROVERTED": "INTROVERT, to turn inwards [v]\n",
  "INTROVERTING": "INTROVERT, to turn inwards [v]\n",
  "INTROVERTIVE": "INTROVERT, to turn inwards [adj]\n",
  "INTROVERTS": "INTROVERT, to turn inwards [v]\n",
  "INTRUDE": "to thrust or force oneself in [v INTRUDED, INTRUDING, INTRUDES]\n",
  "INTRUDED": "INTRUDE, to thrust or force oneself in [v]\n",
  "INTRUDER": "one that intrudes [n -S]\n",
  "INTRUDERS": "INTRUDER, one that intrudes [n]\n",
  "INTRUDES": "INTRUDE, to thrust or force oneself in [v]\n",
  "INTRUDING": "INTRUDE, to thrust or force oneself in [v]\n",
  "INTRUDINGLY": "INTRUDING, INTRUDE, to thrust or force oneself in [adv]\n",
  "INTRUSION": "the act of intruding [n -S]\n",
  "INTRUSIONAL": "having the nature of an intrusion [adj]\n",
  "INTRUSIONIST": "a person who intrudes, esp. of those who, before the Scottish Disruption of 1843, refused a parish the right of objecting to the settlement of an obnoxious minister by a patron [n -S]\n",
  "INTRUSIONISTS": "INTRUSIONIST, a person who intrudes, esp. of those who, before the Scottish Disruption of 1843, refused a parish the right of objecting to the settlement of an obnoxious minister by a patron [n]\n",
  "INTRUSIONS": "INTRUSION, the act of intruding [n]\n",
  "INTRUSIVE": "tending to intrude [adj INTRUSIVELY] / an intrusive rock [n -S]\n",
  "INTRUSIVELY": "INTRUSIVE, tending to intrude [adv]\n",
  "INTRUSIVENESS": "INTRUSIVE, tending to intrude [n]\n",
  "INTRUSIVENESSES": "INTRUSIVENESS, INTRUSIVE, tending to intrude [n]\n",
  "INTRUSIVES": "INTRUSIVE, an intrusive rock [n]\n",
  "INTRUST": "to give over for safe keeping, also ENTRUST [v -ED, -ING, -S]\n",
  "INTRUSTED": "INTRUST, to give over for safe keeping, also ENTRUST [v]\n",
  "INTRUSTING": "INTRUST, to give over for safe keeping, also ENTRUST [v]\n",
  "INTRUSTMENT": "the act of intrusting [n -S]\n",
  "INTRUSTMENTS": "INTRUSTMENT, the act of intrusting [n]\n",
  "INTRUSTS": "INTRUST, to give over for safe keeping, also ENTRUST [v]\n",
  "INTUBATE": "to insert a tube into [v INTUBATED, INTUBATING, INTUBATES]\n",
  "INTUBATED": "INTUBATE, to insert a tube into [v]\n",
  "INTUBATES": "INTUBATE, to insert a tube into [v]\n",
  "INTUBATING": "INTUBATE, to insert a tube into [v]\n",
  "INTUBATION": "the introduction of a tube into an organ to keep it open, as into the larynx in croup [n -S]\n",
  "INTUBATIONS": "INTUBATION, the introduction of a tube into an organ to keep it open, as into the larynx in croup [n]\n",
  "INTUIT": "to know without conscious reasoning [v -ED, -ING, -S]\n",
  "INTUITABLE": "that can be intuited [adj]\n",
  "INTUITED": "INTUIT, to know without conscious reasoning [v]\n",
  "INTUITING": "INTUIT, to know without conscious reasoning [v]\n",
  "INTUITION": "the power of the mind by which it immediately perceives the truth of things without reasoning or analysis [n -S]\n",
  "INTUITIONAL": "relating to an intuition [adj INTUITIONALLY]\n",
  "INTUITIONALISM": "the doctrine that the perception of truth is by intuition; a philosophical system which stresses intuition and mysticism as opposed to the idea of a logical universe [n -S]\n",
  "INTUITIONALISMS": "INTUITIONALISM, the doctrine that the perception of truth is by intuition; a philosophical system which stresses intuition and mysticism as opposed to the idea of a logical universe [n]\n",
  "INTUITIONALIST": "a believer in intuitionalism [n -S]\n",
  "INTUITIONALISTS": "INTUITIONALIST, a believer in intuitionalism [n]\n",
  "INTUITIONALLY": "INTUITIONAL, relating to an intuition [adv]\n",
  "INTUITIONISM": "the belief that the perception of truth is by intuition [n -S]\n",
  "INTUITIONISMS": "INTUITIONISM, the belief that the perception of truth is by intuition [n]\n",
  "INTUITIONIST": "a believer in intuitionism [n -S]\n",
  "INTUITIONISTS": "INTUITIONIST, a believer in intuitionism [n]\n",
  "INTUITIONS": "INTUITION, the power of the mind by which it immediately perceives the truth of things without reasoning or analysis [n]\n",
  "INTUITIVE": "possessing intuition [adj INTUITIVELY]\n",
  "INTUITIVELY": "INTUITIVE, possessing intuition [adv]\n",
  "INTUITIVENESS": "INTUITIVE, possessing intuition [n]\n",
  "INTUITIVENESSES": "INTUITIVENESS, INTUITIVE, possessing intuition [n]\n",
  "INTUITIVISM": "being intuitive [n -S]\n",
  "INTUITIVISMS": "INTUITIVISM, being intuitive [n]\n",
  "INTUITS": "INTUIT, to know without conscious reasoning [v]\n",
  "INTUMESCE": "to swell up [v INTUMESCED, INTUMESCING, INTUMESCES]\n",
  "INTUMESCED": "INTUMESCE, to swell up [v]\n",
  "INTUMESCENCE": "a swollen or enlarged part of a plant or animal [n -S]\n",
  "INTUMESCENCES": "INTUMESCENCE, a swollen or enlarged part of a plant or animal [n]\n",
  "INTUMESCENCIES": "INTUMESCENCY, the state of being intumescent [n]\n",
  "INTUMESCENCY": "the state of being intumescent [n INTUMESCENCIES]\n",
  "INTUMESCENT": "swelling and charring when exposed to flame [adj]\n",
  "INTUMESCES": "INTUMESCE, to swell up [v]\n",
  "INTUMESCING": "INTUMESCE, to swell up [v]\n",
  "INTURBIDATE": "to render turbid [v INTURBIDATED, INTURBIDATING, INTURBIDATES]\n",
  "INTURBIDATED": "INTURBIDATE, to render turbid [v]\n",
  "INTURBIDATES": "INTURBIDATE, to render turbid [v]\n",
  "INTURBIDATING": "INTURBIDATE, to render turbid [v]\n",
  "INTURN": "a turning inward [n -S]\n",
  "INTURNED": "having an inturn [adj]\n",
  "INTURNS": "INTURN, a turning inward [n]\n",
  "INTUSE": "(Spenser) a bruise [n -S]\n",
  "INTUSES": "INTUSE, (Spenser) a bruise [n]\n",
  "INTUSSUSCEPT": "to take in by or cause to undergo intussusception [v -ED, -ING, -S]\n",
  "INTUSSUSCEPTED": "INTUSSUSCEPT, to take in by or cause to undergo intussusception [v]\n",
  "INTUSSUSCEPTING": "INTUSSUSCEPT, to take in by or cause to undergo intussusception [v]\n",
  "INTUSSUSCEPTION": "movement of one part of a thing into another [n]\n",
  "INTUSSUSCEPTIVE": "INTUSSUSCEPT, to take in by or cause to undergo intussusception [adj]\n",
  "INTUSSUSCEPTS": "INTUSSUSCEPT, to take in by or cause to undergo intussusception [v]\n",
  "INTWINE": "to weave together, also ENTWINE [v INTWINED, INTWINING, INTWINES]\n",
  "INTWINED": "INTWINE, to weave together, also ENTWINE [v]\n",
  "INTWINEMENT": "the act of intwining [n -S]\n",
  "INTWINEMENTS": "INTWINEMENT, the act of intwining [n]\n",
  "INTWINES": "INTWINE, to weave together, also ENTWINE [v]\n",
  "INTWINING": "INTWINE, to weave together, also ENTWINE [v]\n",
  "INTWIST": "to twist together, also ENTWIST [v -ED, -ING, -S]\n",
  "INTWISTED": "INTWIST, to twist together, also ENTWIST [v]\n",
  "INTWISTING": "INTWIST, to twist together, also ENTWIST [v]\n",
  "INTWISTS": "INTWIST, to twist together, also ENTWIST [v]\n",
  "INUKSHUIT": "INUKSHUK, (Inuit) a stone used by Inuit people to mark a location, also INUKSUK [n]\n",
  "INUKSHUK": "(Inuit) a stone used by Inuit people to mark a location, also INUKSUK [n INUKSHUKS or INUKSHUIT]\n",
  "INUKSHUKS": "INUKSHUK, (Inuit) a stone used by Inuit people to mark a location, also INUKSUK [n]\n",
  "INUKSUIT": "INUKSUK, (Inuit) a stone used by Inuit people to mark a location, also INUKSHUK [n]\n",
  "INUKSUK": "(Inuit) a stone used by Inuit people to mark a location, also INUKSHUK [n INUKSUKS or INUKSUIT]\n",
  "INUKSUKS": "INUKSUK, (Inuit) a stone used by Inuit people to mark a location, also INUKSHUK [n]\n",
  "INULA": "(Latin) a kind of plant, aka elecampane [n -S]\n",
  "INULAS": "INULA, (Latin) a kind of plant, aka elecampane [n]\n",
  "INULASE": "an enzyme that forms fructose from insulin [n -S]\n",
  "INULASES": "INULASE, an enzyme that forms fructose from insulin [n]\n",
  "INULIN": "a carbohydrate got from elecampane roots [n -S]\n",
  "INULINS": "INULIN, a carbohydrate got from elecampane roots [n]\n",
  "INUMBRATE": "to cast a shadow upon [v INUMBRATED, INUMBRATING, INUMBRATES]\n",
  "INUMBRATED": "INUMBRATE, to cast a shadow upon [v]\n",
  "INUMBRATES": "INUMBRATE, to cast a shadow upon [v]\n",
  "INUMBRATING": "INUMBRATE, to cast a shadow upon [v]\n",
  "INUNCTION": "the act of anointing, smearing or rubbing with ointment [n -S]\n",
  "INUNCTIONS": "INUNCTION, the act of anointing, smearing or rubbing with ointment [n]\n",
  "INUNDANT": "overflowing [adj]\n",
  "INUNDATE": "to fill with overflowing abundance [v INUNDATED, INUNDATING, INUNDATES]\n",
  "INUNDATED": "INUNDATE, to fill with overflowing abundance [v]\n",
  "INUNDATES": "INUNDATE, to fill with overflowing abundance [v]\n",
  "INUNDATING": "INUNDATE, to fill with overflowing abundance [v]\n",
  "INUNDATION": "the act of inundating [n -S]\n",
  "INUNDATIONS": "INUNDATION, the act of inundating [n]\n",
  "INUNDATOR": "one who inundates [n -S]\n",
  "INUNDATORS": "INUNDATOR, one who inundates [n]\n",
  "INUNDATORY": "causing inundation, flooding [adj]\n",
  "INURBANE": "not urbane [adj INURBANELY]\n",
  "INURBANELY": "INURBANE, not urbane [adv]\n",
  "INURBANITIES": "INURBANITY, want of urbanity [n]\n",
  "INURBANITY": "want of urbanity [n INURBANITIES]\n",
  "INURE": "to accustom oneself to accept unpleasant things [v INURED, INURING, INURES]\n",
  "INURED": "INURE, to accustom oneself to accept unpleasant things [v]\n",
  "INUREDNESS": "the state of being inured [n -ES]\n",
  "INUREDNESSES": "INUREDNESS, the state of being inured [n]\n",
  "INUREMENT": "use; practice, also ENUREMENT [n -S]\n",
  "INUREMENTS": "INUREMENT, use; practice, also ENUREMENT [n]\n",
  "INURES": "INURE, to accustom oneself to accept unpleasant things [v]\n",
  "INURING": "INURE, to accustom oneself to accept unpleasant things [v]\n",
  "INURN": "to put in an urn [v -ED, -ING, -S]\n",
  "INURNED": "INURN, to put in an urn [v]\n",
  "INURNING": "INURN, to put in an urn [v]\n",
  "INURNMENT": "the act of inurning, putting into an urn [n -S]\n",
  "INURNMENTS": "INURNMENT, the act of inurning, putting into an urn [n]\n",
  "INURNS": "INURN, to put in an urn [v]\n",
  "INUSITATE": "(obsolete) unaccustomed [adj]\n",
  "INUSITATION": "disuse, disrepair [n -S]\n",
  "INUSITATIONS": "INUSITATION, disuse, disrepair [n]\n",
  "INUST": "(obsolete) burnt in [adj]\n",
  "INUSTION": "burning in [n -S]\n",
  "INUSTIONS": "INUSTION, burning in [n]\n",
  "INUTILE": "useless; unprofitable [adj INUTILELY]\n",
  "INUTILELY": "INUTILE, useless; unprofitable [adv]\n",
  "INUTILITIES": "INUTILITY, lack of utility [n]\n",
  "INUTILITY": "lack of utility [n INUTILITIES]\n",
  "INUTTERABLE": "that cannot be uttered, also UNUTTERABLE [adj]\n",
  "INVADABLE": "that can be invaded [adj]\n",
  "INVADE": "to enter by military force [v INVADED, INVADING, INVADES]\n",
  "INVADED": "INVADE, to enter by military force [v]\n",
  "INVADER": "one that invades [n -S]\n",
  "INVADERS": "INVADER, one that invades [n]\n",
  "INVADES": "INVADE, to enter by military force [v]\n",
  "INVADING": "INVADE, to enter by military force [v]\n",
  "INVAGINABLE": "that can be invaginated [adj]\n",
  "INVAGINATE": "to ensheath [v INVAGINATED, INVAGINATING, INVAGINATES]\n",
  "INVAGINATED": "INVAGINATE, to ensheath [v]\n",
  "INVAGINATES": "INVAGINATE, to ensheath [v]\n",
  "INVAGINATING": "INVAGINATE, to ensheath [v]\n",
  "INVAGINATION": "the act of invaginating [n -S]\n",
  "INVAGINATIONS": "INVAGINATION, the act of invaginating [n]\n",
  "INVALID": "not valid [adj INVALIDER, INVALIDEST; INVALIDLY] / to treat as an invalid [v -ED, -ING, -S]\n",
  "INVALIDATE": "to make invalid [v INVALIDATED, INVALIDATING, INVALIDATES]\n",
  "INVALIDATED": "INVALIDATE, to make invalid [v]\n",
  "INVALIDATES": "INVALIDATE, to make invalid [v]\n",
  "INVALIDATING": "INVALIDATE, to make invalid [v]\n",
  "INVALIDATION": "the act of invalidating [n -S]\n",
  "INVALIDATIONS": "INVALIDATION, the act of invalidating [n]\n",
  "INVALIDATOR": "one who invalidates [n -S]\n",
  "INVALIDATORS": "INVALIDATOR, one who invalidates [n]\n",
  "INVALIDED": "INVALID, to treat as an invalid [v]\n",
  "INVALIDER": "INVALID, not valid [adj]\n",
  "INVALIDEST": "INVALID, not valid [adj]\n",
  "INVALIDHOOD": "the state of being an invalid [n -S]\n",
  "INVALIDHOODS": "INVALIDHOOD, the state of being an invalid [n]\n",
  "INVALIDING": "the act of treating as an invalid [n -S]\n",
  "INVALIDINGS": "INVALIDING, the act of treating as an invalid [n]\n",
  "INVALIDISM": "the condition of an invalid [n -S]\n",
  "INVALIDISMS": "INVALIDISM, the condition of an invalid [n]\n",
  "INVALIDITIES": "INVALIDITY, lack of validity or cogency [n]\n",
  "INVALIDITY": "lack of validity or cogency [n INVALIDITIES]\n",
  "INVALIDLY": "INVALID, not valid [adv]\n",
  "INVALIDNESS": "the state of being invalid [n -ES]\n",
  "INVALIDNESSES": "INVALIDNESS, the state of being invalid [n]\n",
  "INVALIDS": "INVALID, to treat as an invalid [v]\n",
  "INVALUABLE": "beyond value [adj INVALUABLY]\n",
  "INVALUABLENESS": "INVALUABLE, beyond value [n]\n",
  "INVALUABLY": "INVALUABLE, beyond value [adv]\n",
  "INVAR": "(tradename) an iron-nickel alloy with very little heat expansion [n -S]\n",
  "INVARIABILITIES": "INVARIABILITY, the state of being invariable [n]\n",
  "INVARIABILITY": "the state of being invariable [n INVARIABILITIES]\n",
  "INVARIABLE": "not varying, also UNVARIABLE [adj INVARIABLY] / something that does not vary [n -S]\n",
  "INVARIABLENESS": "INVARIABLE, not varying, also UNVARIABLE [n]\n",
  "INVARIABLES": "INVARIABLE, something that does not vary [n]\n",
  "INVARIABLY": "INVARIABLE, not varying, also UNVARIABLE [adv]\n",
  "INVARIANCE": "the state of being invariant, also INVARIANCY [n -S]\n",
  "INVARIANCES": "INVARIANCE, the state of being invariant, also INVARIANCY [n]\n",
  "INVARIANCIES": "INVARIANCY, the state of being invariant, also INVARIANCE [n]\n",
  "INVARIANCY": "the state of being invariant, also INVARIANCE [n INVARIANCIES]\n",
  "INVARIANT": "not varying [adj] / an invariant quantity [n -S]\n",
  "INVARIANTS": "INVARIANT, an invariant quantity [n]\n",
  "INVARS": "INVAR, (tradename) an iron-nickel alloy with very little heat expansion [n]\n",
  "INVASION": "the act of invading [n -S]\n",
  "INVASIONS": "INVASION, the act of invading [n]\n",
  "INVASIVE": "intrusive [adj INVASIVELY]\n",
  "INVASIVELY": "INVASIVE, intrusive [adv]\n",
  "INVASIVENESS": "the state of being invasive [n -ES]\n",
  "INVASIVENESSES": "INVASIVENESS, the state of being invasive [n]\n",
  "INVEAGLE": "to cajole, also INVEIGLE, ENVEIGLE [v INVEAGLED, INVEAGLING, INVEAGLES]\n",
  "INVEAGLED": "INVEAGLE, to cajole, also INVEIGLE, ENVEIGLE [v]\n",
  "INVEAGLES": "INVEAGLE, to cajole, also INVEIGLE, ENVEIGLE [v]\n",
  "INVEAGLING": "INVEAGLE, to cajole, also INVEIGLE, ENVEIGLE [v]\n",
  "INVECKED": "in heraldry, having or consisting of a borderline of small convex curves, like reverse engrailed, also INVECTED [adj]\n",
  "INVECTED": "in heraldry, having or consisting of a borderline of small convex curves, like reverse engrailed, also INVECKED [adj]\n",
  "INVECTIVE": "abusive [adj INVECTIVELY] / an attack with words; abusive language [n -S]\n",
  "INVECTIVELY": "INVECTIVE, abusive [adv]\n",
  "INVECTIVENESS": "INVECTIVE, abusive [n]\n",
  "INVECTIVENESSES": "INVECTIVENESS, INVECTIVE, abusive [n]\n",
  "INVECTIVES": "INVECTIVE, an attack with words; abusive language [n]\n",
  "INVEIGH": "to speak violently [v -ED, -ING, -S]\n",
  "INVEIGHED": "INVEIGH, to speak violently [v]\n",
  "INVEIGHER": "one who inveighs [n -S]\n",
  "INVEIGHERS": "INVEIGHER, one who inveighs [n]\n",
  "INVEIGHING": "INVEIGH, to speak violently [v]\n",
  "INVEIGHS": "INVEIGH, to speak violently [v]\n",
  "INVEIGLE": "to cajole, also ENVEIGLE, INVEAGLE [v INVEIGLED, INVEIGLING, INVEIGLES]\n",
  "INVEIGLED": "INVEIGLE, to cajole, also ENVEIGLE, INVEAGLE [v]\n",
  "INVEIGLEMENT": "the act of inveigling [n -S]\n",
  "INVEIGLEMENTS": "INVEIGLEMENT, the act of inveigling [n]\n",
  "INVEIGLER": "one who inveigles [n -S]\n",
  "INVEIGLERS": "INVEIGLER, one who inveigles [n]\n",
  "INVEIGLES": "INVEIGLE, to cajole, also ENVEIGLE, INVEAGLE [v]\n",
  "INVEIGLING": "INVEIGLE, to cajole, also ENVEIGLE, INVEAGLE [v]\n",
  "INVENDIBILITIES": "INVENDIBILITY, the state of being invendible [n]\n",
  "INVENDIBILITY": "the state of being invendible [n INVENDIBILITIES]\n",
  "INVENDIBLE": "not vendible or salable [adj]\n",
  "INVENIT": "(Latin) he or she devised it [v]\n",
  "INVENT": "to devise originally [v -ED, -ING, -S]\n",
  "INVENTABLE": "that can be invented, also INVENTIBLE [adj]\n",
  "INVENTED": "INVENT, to devise originally [v]\n",
  "INVENTER": "one who invents, also INVENTOR [n -S]\n",
  "INVENTERS": "INVENTER, one who invents, also INVENTOR [n]\n",
  "INVENTIBLE": "that can be invented, also INVENTABLE [adj]\n",
  "INVENTING": "INVENT, to devise originally [v]\n",
  "INVENTION": "that which is invented; a contrivance [n -S]\n",
  "INVENTIONAL": "relating to invention [adj]\n",
  "INVENTIONLESS": "without invention [adj]\n",
  "INVENTIONS": "INVENTION, that which is invented; a contrivance [n]\n",
  "INVENTIVE": "given to invention [adj INVENTIVELY]\n",
  "INVENTIVELY": "INVENTIVE, given to invention [adv]\n",
  "INVENTIVENESS": "INVENTIVE, given to invention [n]\n",
  "INVENTIVENESSES": "INVENTIVENESS, INVENTIVE, given to invention [n]\n",
  "INVENTOR": "one who invents, also INVENTER [n -S]\n",
  "INVENTORIABLE": "subject to inventory [adj]\n",
  "INVENTORIAL": "relating to inventory [adj INVENTORIALLY]\n",
  "INVENTORIALLY": "INVENTORIAL, relating to inventory [adv]\n",
  "INVENTORIED": "INVENTORY, to make an inventory, a list of goods [v]\n",
  "INVENTORIES": "INVENTORY, to make an inventory, a list of goods [v]\n",
  "INVENTORS": "INVENTOR, one who invents, also INVENTER [n]\n",
  "INVENTORY": "a list or schedule of articles [n INVENTORIES] / to make an inventory, a list of goods [v INVENTORIED, INVENTORYING, INVENTORIES]\n",
  "INVENTORYING": "INVENTORY, to make an inventory, a list of goods [v]\n",
  "INVENTRESS": "a woman who invents [n -ES]\n",
  "INVENTRESSES": "INVENTRESS, a woman who invents [n]\n",
  "INVENTS": "INVENT, to devise originally [v]\n",
  "INVERACITIES": "INVERACITY, want of veracity [n]\n",
  "INVERACITY": "want of veracity [n INVERACITIES]\n",
  "INVERITIES": "INVERITY, lack of truth [n]\n",
  "INVERITY": "lack of truth [n INVERITIES]\n",
  "INVERNESS": "a loose overcoat with a detachable cape [n -ES]\n",
  "INVERNESSES": "INVERNESS, a loose overcoat with a detachable cape [n]\n",
  "INVERSE": "opposite [adj INVERSELY] / to turn something into the opposite [v INVERSED, INVERSING, INVERSES]\n",
  "INVERSED": "INVERSE, to turn something into the opposite [v]\n",
  "INVERSELY": "INVERSE, opposite [adv]\n",
  "INVERSES": "INVERSE, to turn something into the opposite [v]\n",
  "INVERSING": "INVERSE, to turn something into the opposite [v]\n",
  "INVERSION": "the act of inverting or state of being inverted [n -S]\n",
  "INVERSIONS": "INVERSION, the act of inverting or state of being inverted [n]\n",
  "INVERSIVE": "tending to invert [adj]\n",
  "INVERT": "to turn upside down [v -ED, -ING, -S]\n",
  "INVERTASE": "an enzyme that inverts cane sugar [n -S]\n",
  "INVERTASES": "INVERTASE, an enzyme that inverts cane sugar [n]\n",
  "INVERTEBRAL": "invertebrate [adj]\n",
  "INVERTEBRATE": "an animal lacking a spinal column [n -S]\n",
  "INVERTEBRATES": "INVERTEBRATE, an animal lacking a spinal column [n]\n",
  "INVERTED": "INVERT, to turn upside down [v]\n",
  "INVERTEDLY": "INVERTED, INVERT, to turn upside down [adv]\n",
  "INVERTER": "one who inverts, also INVERTOR [n -S]\n",
  "INVERTERS": "INVERTER, one who inverts, also INVERTOR [n]\n",
  "INVERTIBILITIES": "INVERTIBILITY, the quality of being invertible [n]\n",
  "INVERTIBILITY": "the quality of being invertible [n INVERTIBILITIES]\n",
  "INVERTIBLE": "capable of being inverted [adj]\n",
  "INVERTIN": "an unorganized ferment which causes cane sugar to take up a molecule of water and be converted into invert sugar [n -S]\n",
  "INVERTING": "INVERT, to turn upside down [v]\n",
  "INVERTINS": "INVERTIN, an unorganized ferment which causes cane sugar to take up a molecule of water and be converted into invert sugar [n]\n",
  "INVERTOR": "one who inverts, also INVERTER [n -S]\n",
  "INVERTORS": "INVERTOR, one who inverts, also INVERTER [n]\n",
  "INVERTS": "INVERT, to turn upside down [v]\n",
  "INVEST": "to lay out for profit [v -ED, -ING, -S]\n",
  "INVESTABLE": "capable of being invested, also INVESTIBLE [adj]\n",
  "INVESTED": "INVEST, to lay out for profit [v]\n",
  "INVESTIBLE": "capable of being invested, also INVESTABLE [adj]\n",
  "INVESTIGABLE": "able to be investigated [adj]\n",
  "INVESTIGATE": "to observe or study by close examination and systematic inquiry [v INVESTIGATED, INVESTIGATING, INVESTIGATES]\n",
  "INVESTIGATED": "INVESTIGATE, to observe or study by close examination and systematic inquiry [v]\n",
  "INVESTIGATES": "INVESTIGATE, to observe or study by close examination and systematic inquiry [v]\n",
  "INVESTIGATING": "INVESTIGATE, to observe or study by close examination and systematic inquiry [v]\n",
  "INVESTIGATION": "the act of investigating [n -S]\n",
  "INVESTIGATIONAL": "of or relating to investigation [adj]\n",
  "INVESTIGATIONS": "INVESTIGATION, the act of investigating [n]\n",
  "INVESTIGATIVE": "relating to investigation [adj]\n",
  "INVESTIGATOR": "one who investigates [n -S]\n",
  "INVESTIGATORS": "INVESTIGATOR, one who investigates [n]\n",
  "INVESTIGATORY": "of the nature of investigation [adj]\n",
  "INVESTING": "INVEST, to lay out for profit [v]\n",
  "INVESTITIVE": "serving to invest [adj]\n",
  "INVESTITURE": "the act of establishing in office or ratifying [n -S]\n",
  "INVESTITURES": "INVESTITURE, the act of establishing in office or ratifying [n]\n",
  "INVESTMENT": "the act of investing [n -S]\n",
  "INVESTMENTS": "INVESTMENT, the act of investing [n]\n",
  "INVESTOR": "one that invests [n -S]\n",
  "INVESTORS": "INVESTOR, one that invests [n]\n",
  "INVESTS": "INVEST, to lay out for profit [v]\n",
  "INVETERACIES": "INVETERACY, the quality of being inveterate [n]\n",
  "INVETERACY": "the quality of being inveterate [n INVETERACIES]\n",
  "INVETERATE": "firmly established by long persistence [adj INVETERATELY]\n",
  "INVETERATELY": "INVETERATE, firmly established by long persistence [adv]\n",
  "INVETERATENESS": "the state of being inveterate [n]\n",
  "INVEXED": "(in heraldry) arched [adj]\n",
  "INVIABILITIES": "INVIABILITY, the state of being inviable [n]\n",
  "INVIABILITY": "the state of being inviable [n INVIABILITIES]\n",
  "INVIABLE": "not viable, also UNVIABLE [adj INVIABLY]\n",
  "INVIABLENESS": "the state of being inviable [n -ES]\n",
  "INVIABLENESSES": "INVIABLENESS, the state of being inviable [n]\n",
  "INVIABLY": "INVIABLE, not viable, also UNVIABLE [adv]\n",
  "INVIDIOUS": "tending to cause discontent, animosity, or envy [adj INVIDIOUSLY]\n",
  "INVIDIOUSLY": "INVIDIOUS, tending to cause discontent, animosity, or envy [adv]\n",
  "INVIDIOUSNESS": "INVIDIOUS, tending to cause discontent, animosity, or envy [n]\n",
  "INVIDIOUSNESSES": "INVIDIOUSNESS, INVIDIOUS, tending to cause discontent, animosity, or envy [n]\n",
  "INVIGILATE": "to keep watch; esp. to supervise students at an examination [v INVIGILATED, INVIGILATING, INVIGILATES]\n",
  "INVIGILATED": "INVIGILATE, to keep watch; esp. to supervise students at an examination [v]\n",
  "INVIGILATES": "INVIGILATE, to keep watch; esp. to supervise students at an examination [v]\n",
  "INVIGILATING": "INVIGILATE, to keep watch; esp. to supervise students at an examination [v]\n",
  "INVIGILATION": "the act of invigilating [n -S]\n",
  "INVIGILATIONS": "INVIGILATION, the act of invigilating [n]\n",
  "INVIGILATOR": "one who invigilates [n -S]\n",
  "INVIGILATORS": "INVIGILATOR, one who invigilates [n]\n",
  "INVIGORANT": "an invigorating agent [n -S]\n",
  "INVIGORANTS": "INVIGORANT, an invigorating agent [n]\n",
  "INVIGORATE": "to give life and energy to [v INVIGORATED, INVIGORATING, INVIGORATES]\n",
  "INVIGORATED": "INVIGORATE, to give life and energy to [v]\n",
  "INVIGORATES": "INVIGORATE, to give life and energy to [v]\n",
  "INVIGORATING": "INVIGORATE, to give life and energy to [v]\n",
  "INVIGORATINGLY": "INVIGORATING, INVIGORATE, to give life and energy to [adv]\n",
  "INVIGORATION": "the act of invigorating [n -S]\n",
  "INVIGORATIONS": "INVIGORATION, the act of invigorating [n]\n",
  "INVIGORATIVE": "serving to invigorate [adj INVIGORATIVELY]\n",
  "INVIGORATIVELY": "INVIGORATIVE, serving to invigorate [adv]\n",
  "INVIGORATOR": "one who invigorates [n -S]\n",
  "INVIGORATORS": "INVIGORATOR, one who invigorates [n]\n",
  "INVINCIBILITIES": "INVINCIBILITY, the state of being invincible [n]\n",
  "INVINCIBILITY": "the state of being invincible [n INVINCIBILITIES]\n",
  "INVINCIBLE": "unconquerable [adj INVINCIBLY]\n",
  "INVINCIBLENESS": "INVINCIBLE, unconquerable [n]\n",
  "INVINCIBLY": "INVINCIBLE, unconquerable [adv]\n",
  "INVIOLABILITIES": "INVIOLABILITY, the state of being inviolable [n]\n",
  "INVIOLABILITY": "the state of being inviolable [n INVIOLABILITIES]\n",
  "INVIOLABLE": "secure from violation or profanation [adj INVIOLABLY]\n",
  "INVIOLABLENESS": "the state of being inviolable [n]\n",
  "INVIOLABLY": "INVIOLABLE, secure from violation or profanation [adv]\n",
  "INVIOLACIES": "INVIOLACY, the state of being inviolate [n]\n",
  "INVIOLACY": "the state of being inviolate [n INVIOLACIES]\n",
  "INVIOLATE": "not violated; uninjured, also INVIOLATED [adj INVIOLATELY]\n",
  "INVIOLATED": "not violated; uninjured, also INVIOLATE [adj]\n",
  "INVIOLATELY": "INVIOLATE, not violated; uninjured, also INVIOLATED [adv]\n",
  "INVIOLATENESS": "INVIOLATE, not violated; uninjured, also INVIOLATED [n]\n",
  "INVIOLATENESSES": "INVIOLATENESS, INVIOLATE, not violated; uninjured, also INVIOLATED [n]\n",
  "INVIOUS": "impassable [adj]\n",
  "INVIRILE": "not virile [adj]\n",
  "INVISCID": "not viscid [adj]\n",
  "INVISIBILITIES": "INVISIBILITY, the state of being invisible [n]\n",
  "INVISIBILITY": "the state of being invisible [n INVISIBILITIES]\n",
  "INVISIBLE": "that cannot be seen [adj INVISIBLY] / an invisible export [n -S]\n",
  "INVISIBLENESS": "the state of being invisible [n -ES]\n",
  "INVISIBLENESSES": "INVISIBLENESS, the state of being invisible [n]\n",
  "INVISIBLES": "INVISIBLE, an invisible export [n]\n",
  "INVISIBLY": "INVISIBLE, that cannot be seen [adv]\n",
  "INVITAL": "not vital, also UNVITAL [adj]\n",
  "INVITATION": "the act of inviting [n -S]\n",
  "INVITATIONAL": "by invitation [adj] / an event limited to invited participants [n -S]\n",
  "INVITATIONALS": "INVITATIONAL, an event limited to invited participants [n]\n",
  "INVITATIONS": "INVITATION, the act of inviting [n]\n",
  "INVITATORIES": "INVITATORY, a psalm or anthem sung before prayer during church service [n]\n",
  "INVITATORY": "a psalm or anthem sung before prayer during church service [n INVITATORIES]\n",
  "INVITE": "to request the presence of [v INVITED, INVITING, INVITES]\n",
  "INVITED": "INVITE, to request the presence of [v]\n",
  "INVITEE": "one who is invited [n -S]\n",
  "INVITEES": "INVITEE, one who is invited [n]\n",
  "INVITEMENT": "an invitation [n -S]\n",
  "INVITEMENTS": "INVITEMENT, an invitation [n]\n",
  "INVITER": "one who invites [n -S]\n",
  "INVITERS": "INVITER, one who invites [n]\n",
  "INVITES": "INVITE, to request the presence of [v]\n",
  "INVITING": "attractive [adj INVITINGLY] / the act of inviting [n -S]\n",
  "INVITINGLY": "INVITING, attractive [adv]\n",
  "INVITINGNESS": "the state of being inviting [n -ES]\n",
  "INVITINGNESSES": "INVITINGNESS, the state of being inviting [n]\n",
  "INVITINGS": "INVITING, the act of inviting [n]\n",
  "INVOCABLE": "that can be invoked [adj]\n",
  "INVOCATE": "to appeal to for help, also INVOKE [v INVOCATED, INVOCATING, INVOCATES]\n",
  "INVOCATED": "INVOCATE, to appeal to for help, also INVOKE [v]\n",
  "INVOCATES": "INVOCATE, to appeal to for help, also INVOKE [v]\n",
  "INVOCATING": "INVOCATE, to appeal to for help, also INVOKE [v]\n",
  "INVOCATION": "the act of invoking [n -S]\n",
  "INVOCATIONAL": "relating to invocation [adj]\n",
  "INVOCATIONS": "INVOCATION, the act of invoking [n]\n",
  "INVOCATIVE": "serving to invoke [adj]\n",
  "INVOCATOR": "one who invokes [n -S]\n",
  "INVOCATORS": "INVOCATOR, one who invokes [n]\n",
  "INVOCATORY": "making or containing invocation [adj]\n",
  "INVOICE": "a letter of advice of the despatch of goods, with particulars of their quantity and the amount due for payment [n -S] / to bill [v INVOICED, INVOICING, INVOICES]\n",
  "INVOICED": "INVOICE, to bill [v]\n",
  "INVOICES": "INVOICE, to bill [v]\n",
  "INVOICING": "the act of presenting with an invoice [n -S]\n",
  "INVOICINGS": "INVOICING, the act of presenting with an invoice [n]\n",
  "INVOKE": "to appeal to for help, also INVOCATE [v INVOKED, INVOKING, INVOKES]\n",
  "INVOKED": "INVOKE, to appeal to for help, also INVOCATE [v]\n",
  "INVOKER": "one who invokes [n -S]\n",
  "INVOKERS": "INVOKER, one who invokes [n]\n",
  "INVOKES": "INVOKE, to appeal to for help, also INVOCATE [v]\n",
  "INVOKING": "INVOKE, to appeal to for help, also INVOCATE [v]\n",
  "INVOLUCEL": "a small secondary bract (as on Queen Anne's lace) [n -S]\n",
  "INVOLUCELLA": "INVOLUCELLUM, a whorl or set of bracts around a flower, umbel, or head [n]\n",
  "INVOLUCELLATE": "having an involucel, also INVOLUCELLATED [adj]\n",
  "INVOLUCELLATED": "having an involucel, also INVOLUCELLATE [adj]\n",
  "INVOLUCELLUM": "a whorl or set of bracts around a flower, umbel, or head [n INVOLUCELLA]\n",
  "INVOLUCELS": "INVOLUCEL, a small secondary bract (as on Queen Anne's lace) [n]\n",
  "INVOLUCRA": "INVOLUCRUM, (Latin) a whorl or set of bracts around a flower, umbel, or head, also INVOLUCRE [n]\n",
  "INVOLUCRAL": "pertaining to, possessing, or like, an involucrum [adj]\n",
  "INVOLUCRATE": "having an involucre [adj]\n",
  "INVOLUCRE": "a whorl or set of bracts around a flower, umbel, or head, also INVOLUCRUM [n -S]\n",
  "INVOLUCRES": "INVOLUCRE, a whorl or set of bracts around a flower, umbel, or head, also INVOLUCRUM [n]\n",
  "INVOLUCRUM": "(Latin) a whorl or set of bracts around a flower, umbel, or head, also INVOLUCRE [n INVOLUCRA]\n",
  "INVOLUNTARILY": "INVOLUNTARY, done contrary to or without choice [adv]\n",
  "INVOLUNTARINESS": "the state of being involuntary [n]\n",
  "INVOLUNTARY": "done contrary to or without choice [adj INVOLUNTARILY]\n",
  "INVOLUTE": "infolded [adj INVOLUTELY] / to roll or curl up [v INVOLUTED, INVOLUTING, INVOLUTES]\n",
  "INVOLUTED": "INVOLUTE, to roll or curl up [v]\n",
  "INVOLUTEDLY": "INVOLUTED, INVOLUTE, to roll or curl up [adv]\n",
  "INVOLUTELY": "INVOLUTE, infolded [adv]\n",
  "INVOLUTES": "INVOLUTE, to roll or curl up [v]\n",
  "INVOLUTING": "INVOLUTE, to roll or curl up [v]\n",
  "INVOLUTION": "the act of involving or infolding [n -S]\n",
  "INVOLUTIONAL": "relating to involution [adj]\n",
  "INVOLUTIONS": "INVOLUTION, the act of involving or infolding [n]\n",
  "INVOLVE": "to implicate or entangle [v INVOLVED, INVOLVING, INVOLVES]\n",
  "INVOLVED": "INVOLVE, to implicate or entangle [v]\n",
  "INVOLVEDLY": "INVOLVED, INVOLVE, to implicate or entangle [adv]\n",
  "INVOLVEMENT": "the act of involving [n -S]\n",
  "INVOLVEMENTS": "INVOLVEMENT, the act of involving [n]\n",
  "INVOLVER": "one who involves [n -S]\n",
  "INVOLVERS": "INVOLVER, one who involves [n]\n",
  "INVOLVES": "INVOLVE, to implicate or entangle [v]\n",
  "INVOLVING": "INVOLVE, to implicate or entangle [v]\n",
  "INVULNERABILITY": "the state of being invulnerable [n]\n",
  "INVULNERABLE": "incapable of being wounded, injured, or harmed, also UNVULNERABLE [adj INVULNERABLY]\n",
  "INVULNERABLY": "INVULNERABLE, incapable of being wounded, injured, or harmed, also UNVULNERABLE [adv]\n",
  "INVULTUATION": "the stabbing of a wax image of person to be injured as form of witchcraft [n -S]\n",
  "INVULTUATIONS": "INVULTUATION, the stabbing of a wax image of person to be injured as form of witchcraft [n]\n",
  "INWALL": "to surround with a wall, also ENWALL [v -ED, -ING, -S]\n",
  "INWALLED": "INWALL, to surround with a wall, also ENWALL [v]\n",
  "INWALLING": "INWALL, to surround with a wall, also ENWALL [v]\n",
  "INWALLS": "INWALL, to surround with a wall, also ENWALL [v]\n",
  "INWARD": "placed within, also INWARDS [adj INWARDLY] / moving towards the inside [adv]\n",
  "INWARDLY": "INWARD, placed within, also INWARDS [adv]\n",
  "INWARDNESS": "the state of being inward [n -ES]\n",
  "INWARDNESSES": "INWARDNESS, the state of being inward [n]\n",
  "INWARDS": "towards the inside, also INWARD [adv]\n",
  "INWEAVE": "to weave in [v INWOVE or INWEAVED, INWOVEN, INWEAVING, INWEAVES]\n",
  "INWEAVED": "INWEAVE, to weave in [v]\n",
  "INWEAVES": "INWEAVE, to weave in [v]\n",
  "INWEAVING": "INWEAVE, to weave in [v]\n",
  "INWICK": "(Scots) to perform a certain stroke in the game of curling [v -ED, -ING, -S]\n",
  "INWICKED": "INWICK, (Scots) to perform a certain stroke in the game of curling [v]\n",
  "INWICKING": "INWICK, (Scots) to perform a certain stroke in the game of curling [v]\n",
  "INWICKS": "INWICK, (Scots) to perform a certain stroke in the game of curling [v]\n",
  "INWIND": "to enwrap, also ENWIND [v INWOUND, INWINDING, INWINDS]\n",
  "INWINDING": "INWIND, to enwrap, also ENWIND [v]\n",
  "INWINDS": "INWIND, to enwrap, also ENWIND [v]\n",
  "INWIT": "(archaic) inward sense; mind [n -S]\n",
  "INWITH": "(Scots) within [prep]\n",
  "INWITS": "INWIT, (archaic) inward sense; mind [n]\n",
  "INWORK": "to work in [v -ED, -ING, -S]\n",
  "INWORKED": "INWORK, to work in [v]\n",
  "INWORKING": "the act of working in [n -S]\n",
  "INWORKINGS": "INWORKING, the act of working in [n]\n",
  "INWORKS": "INWORK, to work in [v]\n",
  "INWORN": "worn or worked in; inwrought [adj]\n",
  "INWOUND": "INWIND, to enwrap, also ENWIND [v]\n",
  "INWOVE": "INWEAVE, to weave in [v]\n",
  "INWOVEN": "INWEAVE, to weave in [v]\n",
  "INWRAP": "to cover by wrapping, also ENWRAP [v INWRAPPED or INWRAPT, INWRAPPING, INWRAPS]\n",
  "INWRAPMENT": "the act of inwrapping, also ENWRAPMENT [n -S]\n",
  "INWRAPMENTS": "INWRAPMENT, the act of inwrapping, also ENWRAPMENT [n]\n",
  "INWRAPPED": "INWRAP, to cover by wrapping, also ENWRAP [v]\n",
  "INWRAPPING": "the act of wrapping round [n -S]\n",
  "INWRAPPINGS": "INWRAPPING, the act of wrapping round [n]\n",
  "INWRAPS": "INWRAP, to cover by wrapping, also ENWRAP [v]\n",
  "INWRAPT": "INWRAP, to cover by wrapping, also ENWRAP [v]\n",
  "INWREATHE": "to surround or encompass as with a wreath, also ENWREATH, ENWREATHE [v INWREATHED, INWREATHING, INWREATHES]\n",
  "INWREATHED": "INWREATHE, to surround or encompass as with a wreath, also ENWREATH, ENWREATHE [v]\n",
  "INWREATHES": "INWREATHE, to surround or encompass as with a wreath, also ENWREATH, ENWREATHE [v]\n",
  "INWREATHING": "INWREATHE, to surround or encompass as with a wreath, also ENWREATH, ENWREATHE [v]\n",
  "INWROUGHT": "wrought or worked in or among other things [adj]\n",
  "INYALA": "(Bantu) a kind of South African antelope, also NYALA [n -S]\n",
  "INYALAS": "INYALA, (Bantu) a kind of South African antelope, also NYALA [n]\n",
  "IO": "a cry of joy [n -S]\n",
  "IODATE": "to treat with iodine, also IODINATE, IODIZE [v IODATED, IODATING, IODATES]\n",
  "IODATED": "IODATE, to treat with iodine, also IODINATE, IODIZE [v]\n",
  "IODATES": "IODATE, to treat with iodine, also IODINATE, IODIZE [v]\n",
  "IODATING": "IODATE, to treat with iodine, also IODINATE, IODIZE [v]\n",
  "IODATION": "the act of iodating [n -S]\n",
  "IODATIONS": "IODATION, the act of iodating [n]\n",
  "IODIC": "pertaining to iodine, as applied to an acid [adj]\n",
  "IODID": "a salt of hydriodic acid, also IODIDE [n -S]\n",
  "IODIDE": "a salt of hydriodic acid, also IODID [n -S]\n",
  "IODIDES": "IODIDE, a salt of hydriodic acid, also IODID [n]\n",
  "IODIDS": "IODID, a salt of hydriodic acid, also IODIDE [n]\n",
  "IODIN": "a chemical element, also IODINE [n -S]\n",
  "IODINATE": "to treat with iodine, also IODATE [v IODINATED, IODINATING, IODINATES]\n",
  "IODINATED": "IODINATE, to treat with iodine, also IODATE [v]\n",
  "IODINATES": "IODINATE, to treat with iodine, also IODATE [v]\n",
  "IODINATING": "IODINATE, to treat with iodine, also IODATE [v]\n",
  "IODINATION": "treatment with iodine or a compound of iodine [n -S]\n",
  "IODINATIONS": "IODINATION, treatment with iodine or a compound of iodine [n]\n",
  "IODINE": "a nonmetallic element, also IODIN [n -S]\n",
  "IODINES": "IODINE, a nonmetallic element, also IODIN [n]\n",
  "IODINS": "IODIN, a chemical element, also IODINE [n]\n",
  "IODISATION": "the act of iodising, also IODIZATION [n -S]\n",
  "IODISATIONS": "IODISATION, the act of iodising, also IODIZATION [n]\n",
  "IODISE": "to treat with iodine, also IODIZE [v IODISED, IODISING, IODISES]\n",
  "IODISED": "IODISE, to treat with iodine, also IODIZE [v]\n",
  "IODISER": "one that iodizes, also IODIZER [n -S]\n",
  "IODISERS": "IODISER, one that iodizes, also IODIZER [n]\n",
  "IODISES": "IODISE, to treat with iodine, also IODIZE [v]\n",
  "IODISING": "IODISE, to treat with iodine, also IODIZE [v]\n",
  "IODISM": "a morbid state produced by the use of iodine and its compounds [n -S]\n",
  "IODISMS": "IODISM, a morbid state produced by the use of iodine and its compounds [n]\n",
  "IODIZATION": "the act of iodizing, also IODISATION [n -S]\n",
  "IODIZATIONS": "IODIZATION, the act of iodizing, also IODISATION [n]\n",
  "IODIZE": "to treat with iodine, also IODISE [v IODIZED, IODIZING, IODIZES]\n",
  "IODIZED": "IODIZE, to treat with iodine, also IODISE [v]\n",
  "IODIZER": "one that iodizes, also IODISER [n -S]\n",
  "IODIZERS": "IODIZER, one that iodizes, also IODISER [n]\n",
  "IODIZES": "IODIZE, to treat with iodine, also IODISE [v]\n",
  "IODIZING": "IODIZE, to treat with iodine, also IODISE [v]\n",
  "IODOFORM": "a lemon-yellow crystalline compound of iodine with a saffron-like odour, used as an antiseptic [n -S]\n",
  "IODOFORMS": "IODOFORM, a lemon-yellow crystalline compound of iodine with a saffron-like odour, used as an antiseptic [n]\n",
  "IODOMETRIC": "measured by iodine, also IODOMETRICAL [adj IODOMETRICALLY]\n",
  "IODOMETRICAL": "measured by iodine, also IODOMETRIC [adj IODOMETRICALLY]\n",
  "IODOMETRICALLY": "IODOMETRICAL, measured by iodine, also IODOMETRIC [adv]\n",
  "IODOMETRIES": "IODOMETRY, a procedure for determining the amount of iodine present in a substance [n]\n",
  "IODOMETRY": "a procedure for determining the amount of iodine present in a substance [n IODOMETRIES]\n",
  "IODOPHILE": "esp. of bacteria containing compounds similar to starch, readily stained by iodine [adj]\n",
  "IODOPHOR": "a soluble compound of iodine used in making disinfectants [n -S]\n",
  "IODOPHORS": "IODOPHOR, a soluble compound of iodine used in making disinfectants [n]\n",
  "IODOPSIN": "a light sensitive pigment in retinal cones [n -S]\n",
  "IODOPSINS": "IODOPSIN, a light sensitive pigment in retinal cones [n]\n",
  "IODOUS": "pertaining to, or containing, iodine [adj]\n",
  "IODURET": "(obsolete) an iodide [n -S]\n",
  "IODURETS": "IODURET, (obsolete) an iodide [n]\n",
  "IODYRITE": "native silver iodide, a yellow or greenish mineral crystallizing in the hexagonal system [n -S]\n",
  "IODYRITES": "IODYRITE, native silver iodide, a yellow or greenish mineral crystallizing in the hexagonal system [n]\n",
  "IOLITE": "a transparent gem, varying in colour with the light it transmits [n -S]\n",
  "IOLITES": "IOLITE, a transparent gem, varying in colour with the light it transmits [n]\n",
  "ION": "an electrically-charged particle formed by loss or gain of electrons by an atom [n -S]\n",
  "IONIC": "relating to a kind of chemical bond [adj IONICALLY] / a style of type [n -S]\n",
  "IONICALLY": "IONIC, relating to a kind of chemical bond [adv]\n",
  "IONICITIES": "IONICITY, the state of existing as an ion [n]\n",
  "IONICITY": "the state of existing as an ion [n IONICITIES]\n",
  "IONICS": "IONIC, a style of type [n]\n",
  "IONISABLE": "that can be ionised, also IONIZABLE [adj]\n",
  "IONISATION": "the act of ionising, also IONIZATION [n -S]\n",
  "IONISATIONS": "IONISATION, the act of ionising, also IONIZATION [n]\n",
  "IONISE": "to convert into ions, also IONIZE [v IONISED, IONISING, IONISES]\n",
  "IONISED": "IONISE, to convert into ions, also IONIZE [v]\n",
  "IONISER": "something that ionizes, also IONIZER [n -S]\n",
  "IONISERS": "IONISER, something that ionizes, also IONIZER [n]\n",
  "IONISES": "IONISE, to convert into ions, also IONIZE [v]\n",
  "IONISING": "IONISE, to convert into ions, also IONIZE [v]\n",
  "IONIUM": "a radioactive isotope of thorium [n -S]\n",
  "IONIUMS": "IONIUM, a radioactive isotope of thorium [n]\n",
  "IONIZABLE": "that can be ionized, also IONISABLE [adj]\n",
  "IONIZATION": "the act of ionizing, also IONISATION [n -S]\n",
  "IONIZATIONS": "IONIZATION, the act of ionizing, also IONISATION [n]\n",
  "IONIZE": "to convert into ions, also IONISE [v IONIZED, IONIZING, IONIZES]\n",
  "IONIZED": "IONIZE, to convert into ions, also IONISE [v]\n",
  "IONIZER": "something that ionizes, also IONISER [n -S]\n",
  "IONIZERS": "IONIZER, something that ionizes, also IONISER [n]\n",
  "IONIZES": "IONIZE, to convert into ions, also IONISE [v]\n",
  "IONIZING": "IONIZE, to convert into ions, also IONISE [v]\n",
  "IONOGEN": "a compound capable of forming ions [n -S]\n",
  "IONOGENIC": "forming ions [adj]\n",
  "IONOGENS": "IONOGEN, a compound capable of forming ions [n]\n",
  "IONOMER": "the product of ionic bonding between long chains of molecules [n -S]\n",
  "IONOMERS": "IONOMER, the product of ionic bonding between long chains of molecules [n]\n",
  "IONONE": "a chemical used in perfume-making, smelling of violets [n -S]\n",
  "IONONES": "IONONE, a chemical used in perfume-making, smelling of violets [n]\n",
  "IONOPAUSE": "the region of the earth's atmosphere at the outer limit of the ionosphere [n -S]\n",
  "IONOPAUSES": "IONOPAUSE, the region of the earth's atmosphere at the outer limit of the ionosphere [n]\n",
  "IONOPHORE": "a chemical compound able to combine with an ion and enable it to pass through a cell membrane [n -S]\n",
  "IONOPHORES": "IONOPHORE, a chemical compound able to combine with an ion and enable it to pass through a cell membrane [n]\n",
  "IONOPHORESES": "IONOPHORESIS, the migration of charged particles, e.g. of a drug, into body tissue [n]\n",
  "IONOPHORESIS": "the migration of charged particles, e.g. of a drug, into body tissue [n IONOPHORESES]\n",
  "IONOSONDE": "an instrument for measuring ionization [n -S]\n",
  "IONOSONDES": "IONOSONDE, an instrument for measuring ionization [n]\n",
  "IONOSPHERE": "a region of the upper atmosphere [n -S]\n",
  "IONOSPHERES": "IONOSPHERE, a region of the upper atmosphere [n]\n",
  "IONOSPHERIC": "relating to the ionosphere [adj IONOSPHERICALLY]\n",
  "IONOSPHERICALLY": "IONOSPHERIC, relating to the ionosphere [adv]\n",
  "IONOTROPIC": "pertaining to or exhibiting ionotropy, the reversible interconversion of a pair of organic isomers [adj]\n",
  "IONOTROPIES": "IONOTROPY, the reversible interconversion of a pair of organic isomers [n]\n",
  "IONOTROPY": "the reversible interconversion of a pair of organic isomers [n IONOTROPIES]\n",
  "IONS": "ION, an electrically-charged particle formed by loss or gain of electrons by an atom [n]\n",
  "IONTOPHORESES": "IONTOPHORESIS, the introduction of an ionized substance, such as a drug, through intact skin by the application of a direct electric current [n]\n",
  "IONTOPHORESIS": "the introduction of an ionized substance, such as a drug, through intact skin by the application of a direct electric current [n IONTOPHORESES]\n",
  "IONTOPHORETIC": "relating to iontophoresis [adj]\n",
  "IOPANOIC": "as in iopanoic acid, a compound containing iodine, opaque to X-rays and used in X-ray examination of the gall bladder [adj]\n",
  "IOS": "IO, a cry of joy [n]\n",
  "IOTA": "(Greek) a Greek letter [n -S]\n",
  "IOTACISM": "excessive use of the letter iota [n -S]\n",
  "IOTACISMS": "IOTACISM, excessive use of the letter iota [n]\n",
  "IOTAS": "IOTA, (Greek) a Greek letter [n]\n",
  "IPECAC": "(Portuguese) the dried root of various South American plants, used as a purgative, expectorant and emetic, also IPECACUANHA [n -S]\n",
  "IPECACS": "IPECAC, (Portuguese) the dried root of various South American plants, used as a purgative, expectorant and emetic, also IPECACUANHA [n]\n",
  "IPECACUANHA": "(Portuguese) the dried root of various South American plants, used as a purgative, expectorant and emetic, also IPECAC [n -S]\n",
  "IPECACUANHAS": "IPECACUANHA, (Portuguese) the dried root of various South American plants, used as a purgative, expectorant and emetic, also IPECAC [n]\n",
  "IPOMOEA": "(Greek) a flowering plant [n -S]\n",
  "IPOMOEAS": "IPOMOEA, (Greek) a flowering plant [n]\n",
  "IPPON": "(Japanese) a winning point for a clean throw in judo [n -S]\n",
  "IPPONS": "IPPON, (Japanese) a winning point for a clean throw in judo [n]\n",
  "IPRATROPIUM": "a bronchodilator drug used in the treatment of asthma [n -S]\n",
  "IPRATROPIUMS": "IPRATROPIUM, a bronchodilator drug used in the treatment of asthma [n]\n",
  "IPRINDOLE": "an antidepressant drug [n -S]\n",
  "IPRINDOLES": "IPRINDOLE, an antidepressant drug [n]\n",
  "IPRONIAZID": "a derivative of isoniazid used in the treatment of tuberculosis [n -S]\n",
  "IPRONIAZIDS": "IPRONIAZID, a derivative of isoniazid used in the treatment of tuberculosis [n]\n",
  "IPSELATERAL": "belonging to or affecting the same side of the body, also IPSILATERAL [adj]\n",
  "IPSILATERAL": "belonging to or affecting the same side of the body, also IPSELATERAL [adj IPSILATERALLY]\n",
  "IPSILATERALLY": "IPSILATERAL, belonging to or affecting the same side of the body, also IPSELATERAL [adv]\n",
  "IRACUND": "easily angered [adj]\n",
  "IRACUNDITIES": "IRACUNDITY, the state of being iracund, easily angered [n]\n",
  "IRACUNDITY": "the state of being iracund, easily angered [n IRACUNDITIES]\n",
  "IRACUNDULOUS": "somewhat inclined to become angry [adj]\n",
  "IRADE": "(historical) a written decree of the Sultan of Turkey [n -S]\n",
  "IRADES": "IRADE, (historical) a written decree of the Sultan of Turkey [n]\n",
  "IRASCIBILITIES": "IRASCIBILITY, the state of being irascible [n]\n",
  "IRASCIBILITY": "the state of being irascible [n IRASCIBILITIES]\n",
  "IRASCIBLE": "easily angered, irritable [adj IRASCIBLY]\n",
  "IRASCIBLENESS": "IRASCIBLE, easily angered, irritable [n]\n",
  "IRASCIBLENESSES": "IRASCIBLENESS, IRASCIBLE, easily angered, irritable [n]\n",
  "IRASCIBLY": "IRASCIBLE, easily angered, irritable [adv]\n",
  "IRATE": "angry [adj IRATER, IRATEST, IRATELY]\n",
  "IRATELY": "IRATE, angry [adv]\n",
  "IRATENESS": "the state of being irate [n -ES]\n",
  "IRATENESSES": "IRATENESS, the state of being irate [n]\n",
  "IRATER": "IRATE, angry [adj]\n",
  "IRATEST": "IRATE, angry [adj]\n",
  "IRE": "to anger [v IRED, IRING, IRES]\n",
  "IRED": "IRE, to anger [v]\n",
  "IREFUL": "full of anger [adj IREFULLY]\n",
  "IREFULLY": "IREFUL, full of anger [adv]\n",
  "IREFULNESS": "wrathfulness [n -ES]\n",
  "IREFULNESSES": "IREFULNESS, wrathfulness [n]\n",
  "IRELESS": "without anger [adj]\n",
  "IRENIC": "peaceful in purpose, also EIRENIC, IRENICAL [adj IRENICALLY]\n",
  "IRENICAL": "peaceful in purpose, also IRENIC, EIRENIC, EIRENICAL [adj IRENICALLY]\n",
  "IRENICALLY": "IRENICAL, peaceful in purpose, also IRENIC, EIRENIC, EIRENICAL [adv]\n",
  "IRENICISM": "the process of creating peace [n -S]\n",
  "IRENICISMS": "IRENICISM, the process of creating peace [n]\n",
  "IRENICON": "(Greek) a peacemaking message, a proposition for peace, also EIRENICON [n -S]\n",
  "IRENICONS": "IRENICON, (Greek) a peacemaking message, a proposition for peace, also EIRENICON [n]\n",
  "IRENICS": "the theology of promoting peace between churches, also EIRENICS [n]\n",
  "IRENOLOGIES": "IRENOLOGY, the study of peace [n]\n",
  "IRENOLOGY": "the study of peace [n IRENOLOGIES]\n",
  "IRES": "IRE, to anger [v]\n",
  "IRID": "a plant of the iris family [n -S]\n",
  "IRIDACEOUS": "belonging to the iris family [adj]\n",
  "IRIDAL": "pertaining to the iris of the eye, also IRIDIAL, IRIDIAN [adj]\n",
  "IRIDEAL": "belonging to the iris family [adj]\n",
  "IRIDECTOMIES": "IRIDECTOMY, the act of cutting out a portion of the iris in order to form an artificial pupil [n]\n",
  "IRIDECTOMY": "the act of cutting out a portion of the iris in order to form an artificial pupil [n IRIDECTOMIES]\n",
  "IRIDES": "IRIS, a part of the eye [n]\n",
  "IRIDESCENCE": "exhibition of multicolored reflections such as the 'play of colors' given by films of oil on water [n -S]\n",
  "IRIDESCENCES": "IRIDESCENCE, exhibition of multicolored reflections such as the 'play of colors' given by films of oil on water [n]\n",
  "IRIDESCENT": "having or exhibiting iridescence [adj IRIDESCENTLY]\n",
  "IRIDESCENTLY": "IRIDESCENT, having or exhibiting iridescence [adv]\n",
  "IRIDIAL": "relating to the iris of the eye, also IRIDAL, IRIDIAN, IRIDIC [adj]\n",
  "IRIDIAN": "relating to the iris of the eye, also IRIDAL, IRIDIAL, IRIDIC [adj]\n",
  "IRIDIC": "relating to the iris of the eye, also IRIDAL, IRIDIAL, IRIDIAN [adj]\n",
  "IRIDISATION": "iridescence, also IRIDIZATION [n -S]\n",
  "IRIDISATIONS": "IRIDISATION, iridescence, also IRIDIZATION [n]\n",
  "IRIDISE": "to make iridescent, also IRIDIZE [v IRIDISED, IRIDISING, IRIDISES]\n",
  "IRIDISED": "IRIDISE, to make iridescent, also IRIDIZE [v]\n",
  "IRIDISES": "IRIDISE, to make iridescent, also IRIDIZE [v]\n",
  "IRIDISING": "IRIDISE, to make iridescent, also IRIDIZE [v]\n",
  "IRIDIUM": "a metallic element [n -S]\n",
  "IRIDIUMS": "IRIDIUM, a metallic element [n]\n",
  "IRIDIZATION": "iridescence, also IRIDISATION [n -S]\n",
  "IRIDIZATIONS": "IRIDIZATION, iridescence, also IRIDISATION [n]\n",
  "IRIDIZE": "to make iridescent, also IRIDISE [v IRIDIZED, IRIDIZING, IRIDIZES]\n",
  "IRIDIZED": "IRIDIZE, to make iridescent, also IRIDISE [v]\n",
  "IRIDIZES": "IRIDIZE, to make iridescent, also IRIDISE [v]\n",
  "IRIDIZING": "IRIDIZE, to make iridescent, also IRIDISE [v]\n",
  "IRIDOCYTE": "a cell in the skin of a fish that gives the fish iridescence [n -S]\n",
  "IRIDOCYTES": "IRIDOCYTE, a cell in the skin of a fish that gives the fish iridescence [n]\n",
  "IRIDOLOGIES": "IRIDOLOGY, diagnosis based on examining the iris of the eye [n]\n",
  "IRIDOLOGIST": "one who practises iridology [n -S]\n",
  "IRIDOLOGISTS": "IRIDOLOGIST, one who practises iridology [n]\n",
  "IRIDOLOGY": "diagnosis based on examining the iris of the eye [n IRIDOLOGIES]\n",
  "IRIDOSMINE": "a very hard corrosion-resistant white or grey natural alloy of osmium and iridium used esp. in pen nibs, also IRIDOSMIUM, OSMIRIDIUM [n -S]\n",
  "IRIDOSMINES": "IRIDOSMINE, a very hard corrosion-resistant white or grey natural alloy of osmium and iridium used esp. in pen nibs, also IRIDOSMIUM, OSMIRIDIUM [n]\n",
  "IRIDOSMIUM": "a very hard corrosion-resistant white or grey natural alloy of osmium and iridium used esp. in pen nibs, also IRIDOSMINE, OSMIRIDIUM [n -S]\n",
  "IRIDOSMIUMS": "IRIDOSMIUM, a very hard corrosion-resistant white or grey natural alloy of osmium and iridium used esp. in pen nibs, also IRIDOSMINE, OSMIRIDIUM [n]\n",
  "IRIDOTOMIES": "IRIDOTOMY, surgical removal of the iris [n]\n",
  "IRIDOTOMY": "surgical removal of the iris [n IRIDOTOMIES]\n",
  "IRIDS": "IRID, a plant of the iris family [n]\n",
  "IRING": "IRE, to anger [v]\n",
  "IRIS": "to give the form of a rainbow to [v -ED, -ING, -ES] / a part of the eye [n IRISES or IRIDES]\n",
  "IRISATE": "to make iridescent [v IRISATED, IRISATING, IRISATES]\n",
  "IRISATED": "IRISATE, to make iridescent [v]\n",
  "IRISATES": "IRISATE, to make iridescent [v]\n",
  "IRISATING": "IRISATE, to make iridescent [v]\n",
  "IRISATION": "iridescence [n -S]\n",
  "IRISATIONS": "IRISATION, iridescence [n]\n",
  "IRISCOPE": "an instrument showing colours of a prism [n -S]\n",
  "IRISCOPES": "IRISCOPE, an instrument showing colours of a prism [n]\n",
  "IRISED": "IRIS, to give the form of a rainbow to [v]\n",
  "IRISES": "IRIS, to give the form of a rainbow to [v]\n",
  "IRISING": "IRIS, to give the form of a rainbow to [v]\n",
  "IRITIC": "relating to iritis, an inflammation of the iris of the eye [adj]\n",
  "IRITIS": "inflammation of the iris [n -ES]\n",
  "IRITISES": "IRITIS, inflammation of the iris [n]\n",
  "IRK": "to annoy or weary [v -ED, -ING, -S]\n",
  "IRKED": "IRK, to annoy or weary [v]\n",
  "IRKING": "IRK, to annoy or weary [v]\n",
  "IRKS": "IRK, to annoy or weary [v]\n",
  "IRKSOME": "tending to irk [adj]\n",
  "IRKSOMELY": "IRKSOME, tending to irk [adv]\n",
  "IRKSOMENESS": "the state of being irksome [n -ES]\n",
  "IRKSOMENESSES": "IRKSOMENESS, the state of being irksome [n]\n",
  "IROKO": "(Yoruba) a large African timber tree [n -S]\n",
  "IROKOS": "IROKO, (Yoruba) a large African timber tree [n]\n",
  "IRON": "a metallic element [n -S] / to eliminate wrinkles from clothes by pressing [v -ED, -ING, -S]\n",
  "IRONBARK": "a species of Australian eucalyptus, also IRONWOOD [n -S]\n",
  "IRONBARKS": "IRONBARK, a species of Australian eucalyptus, also IRONWOOD [n]\n",
  "IRONBOUND": "bound as with iron; rugged; as, an ironbound coast [adj]\n",
  "IRONCLAD": "an armored warship [n -S]\n",
  "IRONCLADS": "IRONCLAD, an armored warship [n]\n",
  "IRONE": "an aromatic oil [n -S]\n",
  "IRONED": "IRON, to eliminate wrinkles from clothes by pressing [v]\n",
  "IRONER": "a machine for pressing clothes [n -S]\n",
  "IRONERS": "IRONER, a machine for pressing clothes [n]\n",
  "IRONES": "IRONE, an aromatic oil [n]\n",
  "IRONFISTED": "stingy, miserly [adj]\n",
  "IRONHANDED": "having an iron hand [adj]\n",
  "IRONHEARTED": "cruel, hardhearted [adj]\n",
  "IRONIC": "pertaining to irony, also IRONICAL [adj IRONICALLY]\n",
  "IRONICAL": "pertaining to irony, also IRONIC [adj IRONICALLY]\n",
  "IRONICALLY": "IRONICAL, pertaining to irony, also IRONIC [adv]\n",
  "IRONICALNESS": "the state of being ironical [n -ES]\n",
  "IRONICALNESSES": "IRONICALNESS, the state of being ironical [n]\n",
  "IRONIER": "IRONY, like iron [adj]\n",
  "IRONIES": "IRONY, words used to express the opposite of that stated [n]\n",
  "IRONIEST": "IRONY, like iron [adj]\n",
  "IRONING": "clothes to be pressed [n -S]\n",
  "IRONINGS": "IRONING, clothes to be pressed [n]\n",
  "IRONISE": "to satirize with irony, also IRONIZE [v IRONISED, IRONISING, IRONISES]\n",
  "IRONISED": "IRONISE, to satirize with irony, also IRONIZE [v]\n",
  "IRONISES": "IRONISE, to satirize with irony, also IRONIZE [v]\n",
  "IRONISING": "IRONISE, to satirize with irony, also IRONIZE [v]\n",
  "IRONIST": "one who uses irony [n -S]\n",
  "IRONISTS": "IRONIST, one who uses irony [n]\n",
  "IRONIZE": "to satirize with irony, also IRONISE [v IRONIZED, IRONIZING, IRONIZES]\n",
  "IRONIZED": "IRONIZE, to satirize with irony, also IRONISE [v]\n",
  "IRONIZES": "IRONIZE, to satirize with irony, also IRONISE [v]\n",
  "IRONIZING": "IRONIZE, to satirize with irony, also IRONISE [v]\n",
  "IRONLESS": "not using iron [adj]\n",
  "IRONLIKE": "like iron [adj]\n",
  "IRONMAN": "a man of great strength and stamina [n IRONMEN]\n",
  "IRONMASTER": "a manufacturer of iron [n -S]\n",
  "IRONMASTERS": "IRONMASTER, a manufacturer of iron [n]\n",
  "IRONMEN": "IRONMAN, a man of great strength and stamina [n]\n",
  "IRONMONGER": "a dealer in ironware [n -S]\n",
  "IRONMONGERIES": "IRONMONGERY, something made of metal [n]\n",
  "IRONMONGERS": "IRONMONGER, a dealer in ironware [n]\n",
  "IRONMONGERY": "something made of metal [n IRONMONGERIES]\n",
  "IRONNESS": "the state of being iron [n -ES]\n",
  "IRONNESSES": "IRONNESS, the state of being iron [n]\n",
  "IRONS": "IRON, to eliminate wrinkles from clothes by pressing [v]\n",
  "IRONSIDE": "a man of great strength [n -S]\n",
  "IRONSIDES": "IRONSIDE, a man of great strength [n]\n",
  "IRONSMITH": "a worker in iron [n -S]\n",
  "IRONSMITHS": "IRONSMITH, a worker in iron [n]\n",
  "IRONSTONE": "a hard, earthy ore of iron [n -S]\n",
  "IRONSTONES": "IRONSTONE, a hard, earthy ore of iron [n]\n",
  "IRONWARE": "articles made of iron [n -S]\n",
  "IRONWARES": "IRONWARE, articles made of iron [n]\n",
  "IRONWEED": "a tall weed with purplish flowers [n -S]\n",
  "IRONWEEDS": "IRONWEED, a tall weed with purplish flowers [n]\n",
  "IRONWOMAN": "a woman who takes part in extended triathlons [n IRONWOMEN]\n",
  "IRONWOMEN": "IRONWOMAN, a woman who takes part in extended triathlons [n]\n",
  "IRONWOOD": "a species of Australian eucalyptus, also IRONBARK [n -S]\n",
  "IRONWOODS": "IRONWOOD, a species of Australian eucalyptus, also IRONBARK [n]\n",
  "IRONWORK": "objects made of iron [n -S]\n",
  "IRONWORKER": "one who works in iron [n -S]\n",
  "IRONWORKERS": "IRONWORKER, one who works in iron [n]\n",
  "IRONWORKS": "IRONWORK, objects made of iron [n]\n",
  "IRONY": "words used to express the opposite of that stated [n IRONIES] / like iron [adj IRONIER, IRONIEST]\n",
  "IRRADIANCE": "the act of irradiating, also IRRADIANCY [n -S]\n",
  "IRRADIANCES": "IRRADIANCE, the act of irradiating, also IRRADIANCY [n]\n",
  "IRRADIANCIES": "IRRADIANCY, the act of irradiating, also IRRADIANCE [n]\n",
  "IRRADIANCY": "the act of irradiating, also IRRADIANCE [n IRRADIANCIES]\n",
  "IRRADIANT": "irradiating or illuminating; as, the irradiant moon [adj]\n",
  "IRRADIATE": "to shed light or other rays upon or into [v IRRADIATED, IRRADIATING, IRRADIATES]\n",
  "IRRADIATED": "IRRADIATE, to shed light or other rays upon or into [v]\n",
  "IRRADIATES": "IRRADIATE, to shed light or other rays upon or into [v]\n",
  "IRRADIATING": "IRRADIATE, to shed light or other rays upon or into [v]\n",
  "IRRADIATION": "exposure to radiation (as X rays or alpha particles) [n -S]\n",
  "IRRADIATIONS": "IRRADIATION, exposure to radiation (as X rays or alpha particles) [n]\n",
  "IRRADIATIVE": "performing irradiation [adj]\n",
  "IRRADIATOR": "something or someone that irradiates [n -S]\n",
  "IRRADIATORS": "IRRADIATOR, something or someone that irradiates [n]\n",
  "IRRADICABLE": "that cannot be eradicated [adj IRRADICABLY]\n",
  "IRRADICABLY": "IRRADICABLE, that cannot be eradicated [adv]\n",
  "IRRADICATE": "to fix firmly [v IRRADICATED, IRRADICATING, IRRADICATES]\n",
  "IRRADICATED": "IRRADICATE, to fix firmly [v]\n",
  "IRRADICATES": "IRRADICATE, to fix firmly [v]\n",
  "IRRADICATING": "IRRADICATE, to fix firmly [v]\n",
  "IRRATIONAL": "not rational [adj IRRATIONALLY] / an irrational number [n -S]\n",
  "IRRATIONALISE": "to make irrational, also IRRATIONALIZE [v IRRATIONALISED, IRRATIONALISING, IRRATIONALISES]\n",
  "IRRATIONALISED": "IRRATIONALISE, to make irrational, also IRRATIONALIZE [v]\n",
  "IRRATIONALISES": "IRRATIONALISE, to make irrational, also IRRATIONALIZE [v]\n",
  "IRRATIONALISING": "IRRATIONALISE, to make irrational, also IRRATIONALIZE [v]\n",
  "IRRATIONALISM": "a system emphasizing intuition, instinct, feeling, or faith rather than reason or holding that the universe is governed by irrational forces [n -S]\n",
  "IRRATIONALISMS": "IRRATIONALISM, a system emphasizing intuition, instinct, feeling, or faith rather than reason or holding that the universe is governed by irrational forces [n]\n",
  "IRRATIONALIST": "an upholder of irrationalism [n -S]\n",
  "IRRATIONALISTIC": "relating to irrationalism [adj]\n",
  "IRRATIONALISTS": "IRRATIONALIST, an upholder of irrationalism [n]\n",
  "IRRATIONALITIES": "IRRATIONALITY, the state of being irrational [n]\n",
  "IRRATIONALITY": "the state of being irrational [n IRRATIONALITIES]\n",
  "IRRATIONALIZE": "to make irrational, also IRRATIONALISE [v IRRATIONALIZED, IRRATIONALIZING, IRRATIONALIZES]\n",
  "IRRATIONALIZED": "IRRATIONALIZE, to make irrational, also IRRATIONALISE [v]\n",
  "IRRATIONALIZES": "IRRATIONALIZE, to make irrational, also IRRATIONALISE [v]\n",
  "IRRATIONALIZING": "IRRATIONALIZE, to make irrational, also IRRATIONALISE [v]\n",
  "IRRATIONALLY": "IRRATIONAL, not rational [adv]\n",
  "IRRATIONALNESS": "the state of being irrational [n]\n",
  "IRRATIONALS": "IRRATIONAL, an irrational number [n]\n",
  "IRREAL": "not real [adj]\n",
  "IRREALISABLE": "not capable of being realised, also IRREALIZABLE [adj]\n",
  "IRREALITIES": "IRREALITY, unreality [n]\n",
  "IRREALITY": "unreality [n IRREALITIES]\n",
  "IRREALIZABLE": "not capable of being realized, also IRREALISABLE [adj]\n",
  "IRREBUTTABLE": "not capable of being rebutted [adj]\n",
  "IRRECEPTIVE": "not receptive [adj]\n",
  "IRRECIPROCAL": "not reciprocal [adj]\n",
  "IRRECIPROCITIES": "IRRECIPROCITY, lack of reciprocity [n]\n",
  "IRRECIPROCITY": "lack of reciprocity [n IRRECIPROCITIES]\n",
  "IRRECLAIMABLE": "incapable of being reclaimed [adj IRRECLAIMABLY]\n",
  "IRRECLAIMABLY": "IRRECLAIMABLE, incapable of being reclaimed [adv]\n",
  "IRRECOGNISABLE": "unrecognizable, also IRRECOGNIZABLE [adj]\n",
  "IRRECOGNITION": "lack of recognition [n -S]\n",
  "IRRECOGNITIONS": "IRRECOGNITION, lack of recognition [n]\n",
  "IRRECOGNIZABLE": "unrecognizable, also IRRECOGNISABLE [adj]\n",
  "IRRECONCILABLE": "incapable of being reconciled [adj IRRECONCILABLY] / one that is irreconcilable [n -S]\n",
  "IRRECONCILABLES": "IRRECONCILABLE, one that is irreconcilable [n]\n",
  "IRRECONCILABLY": "IRRECONCILABLE, incapable of being reconciled [adv]\n",
  "IRRECONCILED": "not reconciled [adj]\n",
  "IRRECONCILEMENT": "the state of being irreconciled [n]\n",
  "IRRECOVERABLE": "not capable of being recovered or rectified [adj IRRECOVERABLY]\n",
  "IRRECOVERABLY": "IRRECOVERABLE, not capable of being recovered or rectified [adv]\n",
  "IRRECUSABLE": "that cannot be rejected [adj IRRECUSABLY]\n",
  "IRRECUSABLY": "IRRECUSABLE, that cannot be rejected [adv]\n",
  "IRREDEEMABILITY": "the quality of being irredeemable [n]\n",
  "IRREDEEMABLE": "not redeemable [adj IRREDEEMABLY] / something that cannot be redeemed [n -S]\n",
  "IRREDEEMABLES": "IRREDEEMABLE, something that cannot be redeemed [n]\n",
  "IRREDEEMABLY": "IRREDEEMABLE, not redeemable [adv]\n",
  "IRREDENTA": "(Italian) a region containing people ethnically related to the inhabitants of one State but politically subject to another, also IRRIDENTA [n -S]\n",
  "IRREDENTAS": "IRREDENTA, (Italian) a region containing people ethnically related to the inhabitants of one State but politically subject to another, also IRRIDENTA [n]\n",
  "IRREDENTISM": "advocating return of what is now foreign land to the former occupants [n -S]\n",
  "IRREDENTISMS": "IRREDENTISM, advocating return of what is now foreign land to the former occupants [n]\n",
  "IRREDENTIST": "one who attempts to recover a region to a country that has lost it [n -S]\n",
  "IRREDENTISTS": "IRREDENTIST, one who attempts to recover a region to a country that has lost it [n]\n",
  "IRREDUCIBILITY": "the state of being irreducible [n]\n",
  "IRREDUCIBLE": "that cannot be reduced [adj IRREDUCIBLY]\n",
  "IRREDUCIBLENESS": "IRREDUCIBLE, that cannot be reduced [n]\n",
  "IRREDUCIBLY": "IRREDUCIBLE, that cannot be reduced [adv]\n",
  "IRREDUCTIBILITY": "the state of being irreducible [n]\n",
  "IRREDUCTION": "being irreducible [n -S]\n",
  "IRREDUCTIONS": "IRREDUCTION, being irreducible [n]\n",
  "IRREFLECTION": "the state of not being reflective, also IRREFLEXION [n -S]\n",
  "IRREFLECTIONS": "IRREFLECTION, the state of not being reflective, also IRREFLEXION [n]\n",
  "IRREFLECTIVE": "not reflective [adj]\n",
  "IRREFLEXION": "not being reflective, also IRREFLECTION [n -S]\n",
  "IRREFLEXIONS": "IRREFLEXION, not being reflective, also IRREFLECTION [n]\n",
  "IRREFLEXIVE": "not reflecting [adj]\n",
  "IRREFORMABILITY": "the state of being irreformable [n]\n",
  "IRREFORMABLE": "incapable of being reformed [adj IRREFORMABLY]\n",
  "IRREFORMABLY": "IRREFORMABLE, incapable of being reformed [adv]\n",
  "IRREFRAGABILITY": "the state of being irrefragable [n]\n",
  "IRREFRAGABLE": "impossible to refute or dispute [adj IRREFRAGABLY]\n",
  "IRREFRAGABLY": "IRREFRAGABLE, impossible to refute or dispute [adv]\n",
  "IRREFRANGIBLE": "that cannot or should not be broken [adj IRREFRANGIBLY]\n",
  "IRREFRANGIBLY": "IRREFRANGIBLE, that cannot or should not be broken [adv]\n",
  "IRREFUTABILITY": "the state of being irrefutable [n]\n",
  "IRREFUTABLE": "that cannot be refuted [adj IRREFUTABLY]\n",
  "IRREFUTABLENESS": "IRREFUTABLE, that cannot be refuted [n]\n",
  "IRREFUTABLY": "IRREFUTABLE, that cannot be refuted [adv]\n",
  "IRREGARDLESS": "regardless [adj]\n",
  "IRREGULAR": "not regular [adj IRREGULARLY] / a soldier not formally attached to a military body [n -S]\n",
  "IRREGULARITIES": "IRREGULARITY, something that is irregular, as improper or dishonest conduct [n]\n",
  "IRREGULARITY": "something that is irregular, as improper or dishonest conduct [n IRREGULARITIES]\n",
  "IRREGULARLY": "IRREGULAR, not regular [adv]\n",
  "IRREGULARS": "IRREGULAR, a soldier not formally attached to a military body [n]\n",
  "IRRELATED": "not relative; irrelevant, also IRRELATIVE [adj]\n",
  "IRRELATION": "the state of being irrelative [n -S]\n",
  "IRRELATIONS": "IRRELATION, the state of being irrelative [n]\n",
  "IRRELATIVE": "not relative; irrelevant, also IRRELATED [adj IRRELATIVELY]\n",
  "IRRELATIVELY": "IRRELATIVE, not relative; irrelevant, also IRRELATED [adv]\n",
  "IRRELATIVENESS": "IRRELATIVE, not relative; irrelevant, also IRRELATED [n]\n",
  "IRRELEVANCE": "the state of being irrelevant, also IRRELEVANCY [n -S]\n",
  "IRRELEVANCES": "IRRELEVANCE, the state of being irrelevant, also IRRELEVANCY [n]\n",
  "IRRELEVANCIES": "IRRELEVANCY, the state of being irrelevant, also IRRELEVANCE [n]\n",
  "IRRELEVANCY": "the state of being irrelevant, also IRRELEVANCE [n IRRELEVANCIES]\n",
  "IRRELEVANT": "not relevant [adj IRRELEVANTLY]\n",
  "IRRELEVANTLY": "IRRELEVANT, not relevant [adv]\n",
  "IRRELIEVABLE": "that cannot be relieved [adj]\n",
  "IRRELIGION": "the state of being irreligious [n -S]\n",
  "IRRELIGIONIST": "one who has no religion [n -S]\n",
  "IRRELIGIONISTS": "IRRELIGIONIST, one who has no religion [n]\n",
  "IRRELIGIONS": "IRRELIGION, the state of being irreligious [n]\n",
  "IRRELIGIOUS": "neglectful of religion [adj IRRELIGIOUSLY]\n",
  "IRRELIGIOUSLY": "IRRELIGIOUS, neglectful of religion [adv]\n",
  "IRRELIGIOUSNESS": "the state of being irreligious [n]\n",
  "IRREMEABLE": "which cannot be returned; irrevocable [adj IRREMEABLY]\n",
  "IRREMEABLY": "IRREMEABLE, which cannot be returned; irrevocable [adv]\n",
  "IRREMEDIABLE": "not remediable [adj IRREMEDIABLY]\n",
  "IRREMEDIABLY": "IRREMEDIABLE, not remediable [adv]\n",
  "IRREMISSIBILITY": "the state of being irremissible, unpardonable [n]\n",
  "IRREMISSIBLE": "unpardonable [adj IRREMISSIBLY]\n",
  "IRREMISSIBLY": "IRREMISSIBLE, unpardonable [adv]\n",
  "IRREMISSION": "the state of being irremissible, unpardonable [n -S]\n",
  "IRREMISSIONS": "IRREMISSION, the state of being irremissible, unpardonable [n]\n",
  "IRREMISSIVE": "unremitting [adj]\n",
  "IRREMOVABILITY": "the state of being irremovable [n]\n",
  "IRREMOVABLE": "incapable of being removed or displaced [adj IRREMOVABLY]\n",
  "IRREMOVABLENESS": "IRREMOVABLE, incapable of being removed or displaced [n]\n",
  "IRREMOVABLY": "IRREMOVABLE, incapable of being removed or displaced [adv]\n",
  "IRRENOWNED": "(Spenser) inglorious [adj]\n",
  "IRREPAIRABLE": "(archaic) irreparable, not able to be repaired [adj]\n",
  "IRREPARABILITY": "the quality of being irreparable [n]\n",
  "IRREPARABLE": "that cannot be repaired [adj IRREPARABLY]\n",
  "IRREPARABLENESS": "the state of being irreparable [n]\n",
  "IRREPARABLY": "IRREPARABLE, that cannot be repaired [adv]\n",
  "IRREPEALABILITY": "the state of being irrepealable [n]\n",
  "IRREPEALABLE": "not repealable [adj IRREPEALABLY]\n",
  "IRREPEALABLY": "IRREPEALABLE, not repealable [adv]\n",
  "IRREPLACEABLE": "not replaceable [adj IRREPLACEABLY]\n",
  "IRREPLACEABLY": "IRREPLACEABLE, not replaceable [adv]\n",
  "IRREPLEVIABLE": "unable to be replevied, also IRREPLEVISABLE [adj]\n",
  "IRREPLEVISABLE": "unable to be replevied, also IRREPLEVIABLE [adj]\n",
  "IRREPREHENSIBLE": "beyond blame [adj IRREPREHENSIBLY]\n",
  "IRREPREHENSIBLY": "IRREPREHENSIBLE, beyond blame [adv]\n",
  "IRREPRESSIBLE": "impossible to repress [adj IRREPRESSIBLY]\n",
  "IRREPRESSIBLY": "IRREPRESSIBLE, impossible to repress [adv]\n",
  "IRREPROACHABLE": "not reproachable [adj IRREPROACHABLY]\n",
  "IRREPROACHABLY": "IRREPROACHABLE, not reproachable [adv]\n",
  "IRREPRODUCIBLE": "not reproducible [adj]\n",
  "IRREPROVABLE": "blameless [adj IRREPROVABLY]\n",
  "IRREPROVABLY": "IRREPROVABLE, blameless [adv]\n",
  "IRRESISTANCE": "lack of resistance [n -S]\n",
  "IRRESISTANCES": "IRRESISTANCE, lack of resistance [n]\n",
  "IRRESISTIBILITY": "the state of being irresistible [n]\n",
  "IRRESISTIBLE": "impossible to resist [adj IRRESISTIBLY]\n",
  "IRRESISTIBLY": "IRRESISTIBLE, impossible to resist [adv]\n",
  "IRRESOLUBILITY": "the state of being irresoluble [n]\n",
  "IRRESOLUBLE": "that cannot be resolved into parts [adj IRRESOLUBLY]\n",
  "IRRESOLUBLY": "IRRESOLUBLE, that cannot be resolved into parts [adv]\n",
  "IRRESOLUTE": "uncertain how to act or proceed [adj IRRESOLUTELY]\n",
  "IRRESOLUTELY": "IRRESOLUTE, uncertain how to act or proceed [adv]\n",
  "IRRESOLUTENESS": "IRRESOLUTE, uncertain how to act or proceed [n]\n",
  "IRRESOLUTION": "vacillation [n -S]\n",
  "IRRESOLUTIONS": "IRRESOLUTION, vacillation [n]\n",
  "IRRESOLVABILITY": "the quality of being irresolvable [n]\n",
  "IRRESOLVABLE": "incapable of being resolved [adj IRRESOLVABLY]\n",
  "IRRESOLVABLY": "IRRESOLVABLE, incapable of being resolved [adv]\n",
  "IRRESPECTIVE": "not having regard [adj IRRESPECTIVELY]\n",
  "IRRESPECTIVELY": "IRRESPECTIVE, not having regard [adv]\n",
  "IRRESPIRABLE": "unfit for respiration [adj]\n",
  "IRRESPONSIBLE": "not responsible [adj IRRESPONSIBLY] / a person who is irresponsible [n -S]\n",
  "IRRESPONSIBLES": "IRRESPONSIBLE, a person who is irresponsible [n]\n",
  "IRRESPONSIBLY": "IRRESPONSIBLE, not responsible [adv]\n",
  "IRRESPONSIVE": "not responsive [adj IRRESPONSIVELY]\n",
  "IRRESPONSIVELY": "IRRESPONSIVE, not responsive [adv]\n",
  "IRRESTRAINABLE": "that cannot be restrained [adj]\n",
  "IRRESUSCITABLE": "not capable of being resuscitated [adj IRRESUSCITABLY]\n",
  "IRRESUSCITABLY": "IRRESUSCITABLE, not capable of being resuscitated [adv]\n",
  "IRRETENTION": "absence of retention or power to retain [n -S]\n",
  "IRRETENTIONS": "IRRETENTION, absence of retention or power to retain [n]\n",
  "IRRETENTIVE": "incapable of retention [adj]\n",
  "IRRETENTIVENESS": "IRRETENTIVE, incapable of retention [n]\n",
  "IRRETRIEVABLE": "not retrievable [adj IRRETRIEVABLY]\n",
  "IRRETRIEVABLY": "IRRETRIEVABLE, not retrievable [adv]\n",
  "IRREVERENCE": "lack of reverence [n -S]\n",
  "IRREVERENCES": "IRREVERENCE, lack of reverence [n]\n",
  "IRREVERENT": "lacking reverence [adj IRREVERENTLY]\n",
  "IRREVERENTIAL": "not reverential [adj]\n",
  "IRREVERENTLY": "IRREVERENT, lacking reverence [adv]\n",
  "IRREVERSIBILITY": "the state of being irreversible [n]\n",
  "IRREVERSIBLE": "not reversible [adj IRREVERSIBLY]\n",
  "IRREVERSIBLY": "IRREVERSIBLE, not reversible [adv]\n",
  "IRREVOCABILITY": "the state of being irrevocable [n]\n",
  "IRREVOCABLE": "that cannot be revoked [adj IRREVOCABLY]\n",
  "IRREVOCABLENESS": "IRREVOCABLE, that cannot be revoked [n]\n",
  "IRREVOCABLY": "IRREVOCABLE, that cannot be revoked [adv]\n",
  "IRRIDENTA": "(Italian) a region containing people ethnically related to the inhabitants of one State but politically subject to another, also IRREDENTA [n -S]\n",
  "IRRIDENTAS": "IRRIDENTA, (Italian) a region containing people ethnically related to the inhabitants of one State but politically subject to another, also IRREDENTA [n]\n",
  "IRRIGABLE": "that can be irrigated [adj IRRIGABLY]\n",
  "IRRIGABLY": "IRRIGABLE, that can be irrigated [adv]\n",
  "IRRIGATE": "to water by canals or watercourses [v IRRIGATED, IRRIGATING, IRRIGATES]\n",
  "IRRIGATED": "IRRIGATE, to water by canals or watercourses [v]\n",
  "IRRIGATES": "IRRIGATE, to water by canals or watercourses [v]\n",
  "IRRIGATING": "IRRIGATE, to water by canals or watercourses [v]\n",
  "IRRIGATION": "the therapeutic flushing of a body part with a stream of liquid [n -S]\n",
  "IRRIGATIONAL": "relating to irrigation [adj]\n",
  "IRRIGATIONS": "IRRIGATION, the therapeutic flushing of a body part with a stream of liquid [n]\n",
  "IRRIGATIVE": "relating to irrigation [adj]\n",
  "IRRIGATOR": "one who irrigates [n -S]\n",
  "IRRIGATORS": "IRRIGATOR, one who irrigates [n]\n",
  "IRRIGUOUS": "watered; wet; irrigating [adj]\n",
  "IRRISION": "the act of laughing at another [n -S]\n",
  "IRRISIONS": "IRRISION, the act of laughing at another [n]\n",
  "IRRISORY": "mocking [adj]\n",
  "IRRITABILITIES": "IRRITABILITY, the state of being irritable [n]\n",
  "IRRITABILITY": "the state of being irritable [n IRRITABILITIES]\n",
  "IRRITABLE": "easily provoked [adj IRRITABLY]\n",
  "IRRITABLENESS": "the state of being irritable [n -ES]\n",
  "IRRITABLENESSES": "IRRITABLENESS, the state of being irritable [n]\n",
  "IRRITABLY": "IRRITABLE, easily provoked [adv]\n",
  "IRRITANCIES": "IRRITANCY, the state of being null and void [n]\n",
  "IRRITANCY": "the state of being null and void [n IRRITANCIES]\n",
  "IRRITANT": "something that irritates [n -S]\n",
  "IRRITANTS": "IRRITANT, something that irritates [n]\n",
  "IRRITATE": "to excite to impatience or anger [v IRRITATED, IRRITATING, IRRITATES]\n",
  "IRRITATED": "IRRITATE, to excite to impatience or anger [v]\n",
  "IRRITATEDLY": "in the manner of being provoked [adv]\n",
  "IRRITATES": "IRRITATE, to excite to impatience or anger [v]\n",
  "IRRITATING": "IRRITATE, to excite to impatience or anger [v]\n",
  "IRRITATINGLY": "IRRITATING, IRRITATE, to excite to impatience or anger [adv]\n",
  "IRRITATION": "the act of irritating [n -S]\n",
  "IRRITATIONS": "IRRITATION, the act of irritating [n]\n",
  "IRRITATIVE": "serving to irritate [adj]\n",
  "IRRITATOR": "one who irritates [n -S]\n",
  "IRRITATORS": "IRRITATOR, one who irritates [n]\n",
  "IRROTATIONAL": "not rotating or involving rotation [adj]\n",
  "IRRUPT": "to enter forcibly or violently [v -ED, -ING, -S]\n",
  "IRRUPTED": "IRRUPT, to enter forcibly or violently [v]\n",
  "IRRUPTING": "IRRUPT, to enter forcibly or violently [v]\n",
  "IRRUPTION": "a forcible or violent rush; a breaking in [n -S]\n",
  "IRRUPTIONS": "IRRUPTION, a forcible or violent rush; a breaking in [n]\n",
  "IRRUPTIVE": "rushing in or upon [adj IRRUPTIVELY]\n",
  "IRRUPTIVELY": "IRRUPTIVE, rushing in or upon [adv]\n",
  "IRRUPTS": "IRRUPT, to enter forcibly or violently [v]\n",
  "IRUKANDJI": "a very venomous jellyfish found mainly near Australia [n -S]\n",
  "IRUKANDJIS": "IRUKANDJI, a very venomous jellyfish found mainly near Australia [n]\n",
  "IS": "BE, to exist [v]\n",
  "ISABEL": "a dingy yellowish-grey or drab, also ISABELLA, ISABELLINE [n -S]\n",
  "ISABELLA": "a dingy yellowish-grey or drab colour, also ISABEL, ISABELLINE [n -S]\n",
  "ISABELLAS": "ISABELLA, a dingy yellowish-grey or drab colour, also ISABEL, ISABELLINE [n]\n",
  "ISABELLINE": "a dingy yellowish-grey or drab colour, also ISABEL, ISABELLA [n -S]\n",
  "ISABELLINES": "ISABELLINE, a dingy yellowish-grey or drab colour, also ISABEL, ISABELLA [n]\n",
  "ISABELS": "ISABEL, a dingy yellowish-grey or drab, also ISABELLA, ISABELLINE [n]\n",
  "ISAGOGE": "(Greek) an academic introduction to a subject [n -S]\n",
  "ISAGOGES": "ISAGOGE, (Greek) an academic introduction to a subject [n]\n",
  "ISAGOGIC": "introductory [adj]\n",
  "ISAGOGICS": "that part of theological science directly preliminary to actual exegesis, or interpretation of the Scriptures [n]\n",
  "ISALLOBAR": "the contour line on a weather chart, connecting those places experiencing equal changes in atmospheric pressure over a specified period [n -S]\n",
  "ISALLOBARIC": "of or like an isallobar [adj]\n",
  "ISALLOBARS": "ISALLOBAR, the contour line on a weather chart, connecting those places experiencing equal changes in atmospheric pressure over a specified period [n]\n",
  "ISAPOSTOLIC": "equal to the apostles, as bishops of apostolic creation, the first preachers of Christ in a country, etc. [adj]\n",
  "ISARITHM": "a line on a map passing through places of the same density of population [n -S]\n",
  "ISARITHMS": "ISARITHM, a line on a map passing through places of the same density of population [n]\n",
  "ISATIN": "a substance obtained by oxidising indigo, also ISATINE [n -S]\n",
  "ISATINE": "a substance obtained by oxidising indigo, also ISATIN [n -S]\n",
  "ISATINES": "ISATINE, a substance obtained by oxidising indigo, also ISATIN [n]\n",
  "ISATINIC": "pertaining to, or derived from, isatin, a substance obtained by oxidising indigo [adj]\n",
  "ISATINS": "ISATIN, a substance obtained by oxidising indigo, also ISATINE [n]\n",
  "ISBA": "(Russian) a log hut [n -S]\n",
  "ISBAS": "ISBA, (Russian) a log hut [n]\n",
  "ISCHAEMIA": "an inadequate flow of blood to part of the body, also ISCHEMIA [n -S]\n",
  "ISCHAEMIAS": "ISCHAEMIA, an inadequate flow of blood to part of the body, also ISCHEMIA [n]\n",
  "ISCHAEMIC": "relating to ischaemia, an inadequate supply of blood to part of the body, also ISCHEMIC [adj]\n",
  "ISCHEMIA": "an inadequate flow of blood to part of the body, also ISCHAEMIA [n -S]\n",
  "ISCHEMIAS": "ISCHEMIA, an inadequate flow of blood to part of the body, also ISCHAEMIA [n]\n",
  "ISCHEMIC": "relating to ischemia, an inadequate supply of blood to part of the body, also ISCHAEMIC [adj]\n",
  "ISCHIA": "ISCHIUM, (Latin) the ventral and posterior of the three principal bones composing either half of the pelvis [n]\n",
  "ISCHIADIC": "of or pertaining to the ischium or hip, also ISCHIAL, ISCHIATIC [adj]\n",
  "ISCHIAL": "of or pertaining to the ischium or hip, also ISCHIADIC, ISCHIATIC [adj]\n",
  "ISCHIATIC": "of or pertaining to the ischium or hip, also ISCHIADIC, ISCHIAL [adj]\n",
  "ISCHIUM": "(Latin) the ventral and posterior of the three principal bones composing either half of the pelvis [n ISCHIA]\n",
  "ISCHURETIC": "having the quality of relieving ischuria, retention of urine [adj] / a drug used to relieve ischuria [n -S]\n",
  "ISCHURETICS": "ISCHURETIC, a drug used to relieve ischuria [n]\n",
  "ISCHURIA": "retention of urine [n -S]\n",
  "ISCHURIAS": "ISCHURIA, retention of urine [n]\n",
  "ISEIKONIA": "the seeing of the same image in both eyes [n -S]\n",
  "ISEIKONIAS": "ISEIKONIA, the seeing of the same image in both eyes [n]\n",
  "ISEIKONIC": "relating to iseikonia, the seeing of the same image in both eyes [adj]\n",
  "ISENERGIC": "denoting equal energy [adj]\n",
  "ISENTROPIC": "having equal entropy [adj ISENTROPICALLY]\n",
  "ISENTROPICALLY": "ISENTROPIC, having equal entropy [adv]\n",
  "ISH": "in Scots law, issue or expiry [n -ES]\n",
  "ISHES": "ISH, in Scots law, issue or expiry [n]\n",
  "ISINGLASS": "(Dutch) the dried bladder of certain fish, esp. the sturgeon, used e.g. to clarify wines [n -ES]\n",
  "ISINGLASSES": "ISINGLASS, (Dutch) the dried bladder of certain fish, esp. the sturgeon, used e.g. to clarify wines [n]\n",
  "ISIT": "(South African) is it? an expression used in response to a statement, sometimes to seek confirmation but often merely to show that one is listening [interj]\n",
  "ISLAND": "a mass of land (not a continent) surrounded with water [n -S] / to set or dot with or as with islands [v -ED, -ING, -S]\n",
  "ISLANDED": "ISLAND, to set or dot with or as with islands [v]\n",
  "ISLANDER": "one who lives on an island [n -S]\n",
  "ISLANDERS": "ISLANDER, one who lives on an island [n]\n",
  "ISLANDING": "ISLAND, to set or dot with or as with islands [v]\n",
  "ISLANDS": "ISLAND, to set or dot with or as with islands [v]\n",
  "ISLE": "a small island [n -S] / to place on a small island [v ISLED, ISLING, ISLES]\n",
  "ISLED": "ISLE, to place on a small island [v]\n",
  "ISLELESS": "lacking an isle [adj]\n",
  "ISLEMAN": "an islander, also ISLESMAN [n ISLEMEN]\n",
  "ISLEMEN": "ISLEMAN, an islander, also ISLESMAN [n]\n",
  "ISLES": "ISLE, to place on a small island [v]\n",
  "ISLESMAN": "an islander, also ISLEMAN [n ISLESMEN]\n",
  "ISLESMEN": "ISLESMAN, an islander, also ISLEMAN [n]\n",
  "ISLET": "a small island [n -S]\n",
  "ISLETED": "having islets [adj]\n",
  "ISLETS": "ISLET, a small island [n]\n",
  "ISLING": "ISLE, to place on a small island [v]\n",
  "ISLOMANIA": "an obsessional enthusiasm for islands [n -S]\n",
  "ISLOMANIAS": "ISLOMANIA, an obsessional enthusiasm for islands [n]\n",
  "ISM": "a distinctive theory or doctrine [n -S]\n",
  "ISMATIC": "addicted to isms or faddish theories, also ISMATICAL [adj]\n",
  "ISMATICAL": "addicted to isms or faddish theories, also ISMATIC [adj]\n",
  "ISMATICALNESS": "ISMATICAL, addicted to isms or faddish theories, also ISMATIC [n]\n",
  "ISMATICALNESSES": "ISMATICALNESS, ISMATICAL, addicted to isms or faddish theories, also ISMATIC [n]\n",
  "ISMS": "ISM, a distinctive theory or doctrine [n]\n",
  "ISNA": "(Scots) is not, also ISNAE [v]\n",
  "ISNAE": "(Scots) is not (no inflections), also ISNA [v]\n",
  "ISO": "(short for) an isolated replay, a TV and film facility [n -S]\n",
  "ISOAGGLUTININ": "an antibody that causes the agglutination of red blood corpuscles in animals of the same species from which it was derived [n -S]\n",
  "ISOAGGLUTININS": "ISOAGGLUTININ, an antibody that causes the agglutination of red blood corpuscles in animals of the same species from which it was derived [n]\n",
  "ISOALLOXAZINE": "a yellow solid that is the precursor of various flavins, such as riboflavin [n -S]\n",
  "ISOALLOXAZINES": "ISOALLOXAZINE, a yellow solid that is the precursor of various flavins, such as riboflavin [n]\n",
  "ISOAMINILE": "an antitussive drug [n -S]\n",
  "ISOAMINILES": "ISOAMINILE, an antitussive drug [n]\n",
  "ISOAMYL": "isoamyl acetate, an organic solvent and flavouring [n -S]\n",
  "ISOAMYLS": "ISOAMYL, isoamyl acetate, an organic solvent and flavouring [n]\n",
  "ISOANTIBODIES": "ISOANTIBODY, an antibody that occurs naturally against foreign tissue from an individual of the same species [n]\n",
  "ISOANTIBODY": "an antibody that occurs naturally against foreign tissue from an individual of the same species [n ISOANTIBODIES]\n",
  "ISOANTIGEN": "an antigen that stimulates antibody production in different members of the same species [n -S]\n",
  "ISOANTIGENIC": "relating to an isoantigen [adj]\n",
  "ISOANTIGENS": "ISOANTIGEN, an antigen that stimulates antibody production in different members of the same species [n]\n",
  "ISOBAR": "a type of atom, also ISOBARE [n -S]\n",
  "ISOBARE": "a type of atom, also ISOBAR [n -S]\n",
  "ISOBARES": "ISOBARE, a type of atom, also ISOBAR [n]\n",
  "ISOBARIC": "denoting equal pressure; as, an isobaric line [adj]\n",
  "ISOBARISM": "the use of isobars [n -S]\n",
  "ISOBARISMS": "ISOBARISM, the use of isobars [n]\n",
  "ISOBAROMETRIC": "relating to measurement by isobar [adj]\n",
  "ISOBARS": "ISOBAR, a type of atom, also ISOBARE [n]\n",
  "ISOBASE": "a contour line of equal upheaval of the land [n -S]\n",
  "ISOBASES": "ISOBASE, a contour line of equal upheaval of the land [n]\n",
  "ISOBATH": "a contour line connecting points of equal water depth [n -S]\n",
  "ISOBATHIC": "relating to isobaths, contour lines connecting points of equal underwater depth [adj]\n",
  "ISOBATHS": "ISOBATH, a contour line connecting points of equal water depth [n]\n",
  "ISOBILATERAL": "having the same structure on both sides [adj]\n",
  "ISOBRONT": "a contour line showing the development of thunder [n -S]\n",
  "ISOBRONTS": "ISOBRONT, a contour line showing the development of thunder [n]\n",
  "ISOBUTANE": "a gaseous branched-chain hydrocarbon [n -S]\n",
  "ISOBUTANES": "ISOBUTANE, a gaseous branched-chain hydrocarbon [n]\n",
  "ISOBUTENE": "an isomer of butene [n -S]\n",
  "ISOBUTENES": "ISOBUTENE, an isomer of butene [n]\n",
  "ISOBUTYL": "as in methyl isobutyl ketone, a colourless insoluble liquid ketone used as a solvent for organic compounds [n -S]\n",
  "ISOBUTYLENE": "an isomer of butylene used in the manufacture of synthetic rubber [n -S]\n",
  "ISOBUTYLENES": "ISOBUTYLENE, an isomer of butylene used in the manufacture of synthetic rubber [n]\n",
  "ISOBUTYLS": "ISOBUTYL, as in methyl isobutyl ketone, a colourless insoluble liquid ketone used as a solvent for organic compounds [n]\n",
  "ISOCALORIC": "having similar caloric values [adj]\n",
  "ISOCARBOXAZID": "an antidepressant drug [n -S]\n",
  "ISOCARBOXAZIDS": "ISOCARBOXAZID, an antidepressant drug [n]\n",
  "ISOCHASM": "a line connecting points of equal frequency of aurorae [n -S]\n",
  "ISOCHASMIC": "indicating equal auroral display; as, an isochasmic line [adj]\n",
  "ISOCHASMS": "ISOCHASM, a line connecting points of equal frequency of aurorae [n]\n",
  "ISOCHEIM": "a line connecting points of same average winter temperature, also ISOCHEIMENAL, ISOCHIME [n -S]\n",
  "ISOCHEIMAL": "connecting points of same average winter temperature [adj] / an isocheimal line, also ISOCHIMAL [n -S]\n",
  "ISOCHEIMALS": "ISOCHEIMAL, an isocheimal line, also ISOCHIMAL [n]\n",
  "ISOCHEIMENAL": "a line connecting points of same average winter temperature, also ISOCHEIM, ISOCHIME [n -S]\n",
  "ISOCHEIMENALS": "ISOCHEIMENAL, a line connecting points of same average winter temperature, also ISOCHEIM, ISOCHIME [n]\n",
  "ISOCHEIMIC": "relating to an isocheim, a line connecting points of same average winter temperature [adj]\n",
  "ISOCHEIMS": "ISOCHEIM, a line connecting points of same average winter temperature, also ISOCHEIMENAL, ISOCHIME [n]\n",
  "ISOCHIMAL": "connecting points of same average winter temperature [adj] / an isochimal line, also ISOCHEIMAL [n -S]\n",
  "ISOCHIMALS": "ISOCHIMAL, an isochimal line, also ISOCHEIMAL [n]\n",
  "ISOCHIME": "a line connecting points of same average winter temperature, also ISOCHEIM, ISOCHEIMENAL [n -S]\n",
  "ISOCHIMES": "ISOCHIME, a line connecting points of same average winter temperature, also ISOCHEIM, ISOCHEIMENAL [n]\n",
  "ISOCHOR": "a curve showing pressure and temperature, also ISOCHORE [n -S]\n",
  "ISOCHORE": "a curve showing pressure and temperature, also ISOCHOR [n -S]\n",
  "ISOCHORES": "ISOCHORE, a curve showing pressure and temperature, also ISOCHOR [n]\n",
  "ISOCHORIC": "of or like an isochor, a curve representing variation of some quantity under conditions of constant volume [adj]\n",
  "ISOCHORS": "ISOCHOR, a curve showing pressure and temperature, also ISOCHORE [n]\n",
  "ISOCHROMATIC": "having the same colour [adj]\n",
  "ISOCHROMOSOME": "a chromosome produced by transverse splitting of the centromere so that both arms are from the same side of the centromere, are of equal length, and possess identical genes [n -S]\n",
  "ISOCHROMOSOMES": "ISOCHROMOSOME, a chromosome produced by transverse splitting of the centromere so that both arms are from the same side of the centromere, are of equal length, and possess identical genes [n]\n",
  "ISOCHRON": "a line connecting points of equal time difference, also ISOCHRONE [n -S]\n",
  "ISOCHRONAL": "uniform in time; recurring at regular intervals; e.g. isochronal vibrations or oscillations [adj ISOCHRONALLY]\n",
  "ISOCHRONALLY": "ISOCHRONAL, uniform in time; recurring at regular intervals; e.g. isochronal vibrations or oscillations [adv]\n",
  "ISOCHRONE": "a line connecting points of equal time difference, also ISOCHRON [n -S]\n",
  "ISOCHRONES": "ISOCHRONE, a line connecting points of equal time difference, also ISOCHRON [n]\n",
  "ISOCHRONISE": "to make isochronous, also ISOCHRONIZE [v ISOCHRONISED, ISOCHRONISING, ISOCHRONISES]\n",
  "ISOCHRONISED": "ISOCHRONISE, to make isochronous, also ISOCHRONIZE [v]\n",
  "ISOCHRONISES": "ISOCHRONISE, to make isochronous, also ISOCHRONIZE [v]\n",
  "ISOCHRONISING": "ISOCHRONISE, to make isochronous, also ISOCHRONIZE [v]\n",
  "ISOCHRONISM": "the property of having the same duration; recurring at equal intervals [n -S]\n",
  "ISOCHRONISMS": "ISOCHRONISM, the property of having the same duration; recurring at equal intervals [n]\n",
  "ISOCHRONIZE": "to make isochronous, also ISOCHRONISE [v ISOCHRONIZED, ISOCHRONIZING, ISOCHRONIZES]\n",
  "ISOCHRONIZED": "ISOCHRONIZE, to make isochronous, also ISOCHRONISE [v]\n",
  "ISOCHRONIZES": "ISOCHRONIZE, to make isochronous, also ISOCHRONISE [v]\n",
  "ISOCHRONIZING": "ISOCHRONIZE, to make isochronous, also ISOCHRONISE [v]\n",
  "ISOCHRONOUS": "having the same duration; recurring at equal intervals [adj ISOCHRONOUSLY]\n",
  "ISOCHRONOUSLY": "ISOCHRONOUS, having the same duration; recurring at equal intervals [adv]\n",
  "ISOCHRONS": "ISOCHRON, a line connecting points of equal time difference, also ISOCHRONE [n]\n",
  "ISOCHROOUS": "of uniform colour [adj]\n",
  "ISOCLINAL": "a line connecting points of same magnetic dip, also ISOCLINIC [n -S]\n",
  "ISOCLINALS": "ISOCLINAL, a line connecting points of same magnetic dip, also ISOCLINIC [n]\n",
  "ISOCLINE": "a cline with strata so tightly folded that they have the same dip [n -S]\n",
  "ISOCLINES": "ISOCLINE, a cline with strata so tightly folded that they have the same dip [n]\n",
  "ISOCLINIC": "a line on a map connecting points of same magnetic dip, also ISOCLINAL [n -S]\n",
  "ISOCLINICS": "ISOCLINIC, a line on a map connecting points of same magnetic dip, also ISOCLINAL [n]\n",
  "ISOCRACIES": "ISOCRACY, a form of government [n]\n",
  "ISOCRACY": "a form of government [n ISOCRACIES]\n",
  "ISOCRATIC": "relating to isocracy, equal political power [adj]\n",
  "ISOCRYMAL": "a line connecting points of equal temperature during the coldest time, also ISOCRYME [n -S]\n",
  "ISOCRYMALS": "ISOCRYMAL, a line connecting points of equal temperature during the coldest time, also ISOCRYME [n]\n",
  "ISOCRYME": "a contour line of equal temperature during the cold [n -S]\n",
  "ISOCRYMES": "ISOCRYME, a contour line of equal temperature during the cold [n]\n",
  "ISOCYANATE": "an ester of isomeric cyanic acid used in plastics and adhesives [n -S]\n",
  "ISOCYANATES": "ISOCYANATE, an ester of isomeric cyanic acid used in plastics and adhesives [n]\n",
  "ISOCYANIC": "as in isocyanic acid, a hypothetical acid known only in the form of its compounds [adj]\n",
  "ISOCYANIDE": "a salt or ester of isocyanic acid [n -S]\n",
  "ISOCYANIDES": "ISOCYANIDE, a salt or ester of isocyanic acid [n]\n",
  "ISOCYCLIC": "having or being a ring consisting of only one element [adj]\n",
  "ISODIAMETRIC": "of equal diameters; about as broad as long, also ISODIAMETRICAL [adj]\n",
  "ISODIAMETRICAL": "of equal diameters; about as broad as long, also ISODIAMETRIC [adj]\n",
  "ISODIAPHERE": "one of two or more nuclides with the same difference between the totals of neutrons and protons [n -S]\n",
  "ISODIAPHERES": "ISODIAPHERE, one of two or more nuclides with the same difference between the totals of neutrons and protons [n]\n",
  "ISODICA": "ISODICON, (Greek) in the Greek Church, a short anthem sung while the gospel is being carried through the church [n]\n",
  "ISODICON": "(Greek) in the Greek Church, a short anthem sung while the gospel is being carried through the church [n ISODICA]\n",
  "ISODIMORPHIC": "showing isodimorphism [adj]\n",
  "ISODIMORPHISM": "isomorphism between each of the two forms of a dimorphous substance and the corresponding forms of another dimorphous substance [n -S]\n",
  "ISODIMORPHISMS": "ISODIMORPHISM, isomorphism between each of the two forms of a dimorphous substance and the corresponding forms of another dimorphous substance [n]\n",
  "ISODIMORPHOUS": "showing isodimorphism, isomorphism between each of the two forms of a dimorphous substance [adj]\n",
  "ISODOMA": "ISODOMUM, a type of masonry, also ISODOMON [n]\n",
  "ISODOMON": "a type of masonry, also ISODOMUM [n ISODOMA]\n",
  "ISODOMOUS": "in the form of an isodomon, masonry of uniform blocks in course of equal heights [adj]\n",
  "ISODOMUM": "a type of masonry, also ISODOMON [n ISODOMA]\n",
  "ISODONT": "having all the teeth similar in size and form [adj] / an animal with uniform teeth, also ISODONTAL [n -S]\n",
  "ISODONTAL": "having all the teeth similar in size and form [adj] / an isodontal animal, also ISODONT [n -S]\n",
  "ISODONTALS": "ISODONTAL, an isodontal animal, also ISODONT [n]\n",
  "ISODONTS": "ISODONT, an animal with uniform teeth, also ISODONTAL [n]\n",
  "ISODOSE": "one of several zones with equal radiation [n -S]\n",
  "ISODOSES": "ISODOSE, one of several zones with equal radiation [n]\n",
  "ISODYNAMIC": "a line on a map connecting points of equal magnetic intensity [n -S]\n",
  "ISODYNAMICS": "ISODYNAMIC, a line on a map connecting points of equal magnetic intensity [n]\n",
  "ISOELECTRIC": "having the same potential [adj]\n",
  "ISOELECTRONIC": "having the same number of electrons or valence electrons [adj]\n",
  "ISOENZYMATIC": "of or like an isoenzyme, one of several variants of the same enzyme occurring within a single species, also ISOENZYMIC [adj]\n",
  "ISOENZYME": "one of several variants of the same enzyme occurring within a single species, also ISOZYME [n -S]\n",
  "ISOENZYMES": "ISOENZYME, one of several variants of the same enzyme occurring within a single species, also ISOZYME [n]\n",
  "ISOENZYMIC": "of or like an isoenzyme, one of several variants of the same enzyme occurring within a single species, also ISOENZYMATIC [adj]\n",
  "ISOETES": "(Greek) a plant of the quillwort genus [n ISOETES]\n",
  "ISOFLAVONE": "a plant oestrogen, found esp. in soy beans, having possible nutritional benefits [n -S]\n",
  "ISOFLAVONES": "ISOFLAVONE, a plant oestrogen, found esp. in soy beans, having possible nutritional benefits [n]\n",
  "ISOFORM": "one of two or more proteins having a similar form [n -S]\n",
  "ISOFORMS": "ISOFORM, one of two or more proteins having a similar form [n]\n",
  "ISOGAMETE": "a gamete indistinguishable in form or size or behavior from another gamete, with which it can unite to form a zygote [n -S]\n",
  "ISOGAMETES": "ISOGAMETE, a gamete indistinguishable in form or size or behavior from another gamete, with which it can unite to form a zygote [n]\n",
  "ISOGAMETIC": "relating to isogamy, the conjugation of two gametes of equal size and form, also ISOGAMIC, ISOGAMOUS [adj]\n",
  "ISOGAMIC": "relating to isogamy, the conjugation of two gametes of equal size and form, also ISOGAMETIC, ISOGAMOUS [adj]\n",
  "ISOGAMIES": "ISOGAMY, the fusion of similar gametes [n]\n",
  "ISOGAMOUS": "relating to isogamy, the conjugation of two gametes of equal size and form, also ISOGAMETIC, ISOGAMIC [adj]\n",
  "ISOGAMY": "the fusion of similar gametes [n ISOGAMIES]\n",
  "ISOGENEIC": "genetically similar or identical, e.g. in respect of grafts, also ISOGENIC [adj]\n",
  "ISOGENETIC": "relating to isogeny, sameness or similarity of origin [adj]\n",
  "ISOGENIC": "genetically similar or identical, e.g. in respect of grafts, also ISOGENEIC [adj]\n",
  "ISOGENIES": "ISOGENY, the state of being of similar origin [n]\n",
  "ISOGENOUS": "having the same origin [adj]\n",
  "ISOGENY": "the state of being of similar origin [n ISOGENIES]\n",
  "ISOGEOTHERM": "a line connecting points of equal subterranean temperature, also ISOGEOTHERMAL, ISOGEOTHERMIC [n -S]\n",
  "ISOGEOTHERMAL": "a line connecting points of equal subterranean temperature, also ISOGEOTHERM, ISOGEOTHERMIC [n -S]\n",
  "ISOGEOTHERMALS": "ISOGEOTHERMAL, a line connecting points of equal subterranean temperature, also ISOGEOTHERM, ISOGEOTHERMIC [n]\n",
  "ISOGEOTHERMIC": "a line on a map connecting points of equal subterranean temperature, also ISOGEOTHERM, ISOGEOTHERMAL [n -S]\n",
  "ISOGEOTHERMICS": "ISOGEOTHERMIC, a line on a map connecting points of equal subterranean temperature, also ISOGEOTHERM, ISOGEOTHERMAL [n]\n",
  "ISOGEOTHERMS": "ISOGEOTHERM, a line connecting points of equal subterranean temperature, also ISOGEOTHERMAL, ISOGEOTHERMIC [n]\n",
  "ISOGLOSS": "a line indicating linguistically varied areas [n -ES]\n",
  "ISOGLOSSAL": "relating to an isogloss, a line connecting points of similar regional dialect, also ISOGLOSSIC, ISOGLOTTAL, ISOGLOTTIC [adj]\n",
  "ISOGLOSSES": "ISOGLOSS, a line indicating linguistically varied areas [n]\n",
  "ISOGLOSSIC": "relating to an isogloss, a line connecting points of similar regional dialect, also ISOGLOSSAL, ISOGLOTTAL, ISOGLOTTIC [adj]\n",
  "ISOGLOTTAL": "relating to an isogloss, a line connecting points of similar regional dialect, also ISOGLOSSAL, ISOGLOSSIC, ISOGLOTTIC [adj]\n",
  "ISOGLOTTIC": "relating to an isogloss, a line connecting points of similar regional dialect, also ISOGLOSSAL, ISOGLOSSIC, ISOGLOTTAL [adj]\n",
  "ISOGON": "a polygon having equal angles [n -S]\n",
  "ISOGONAL": "a line indicating the earth's magnetic field, also ISOGONE, ISOGONIC [n -S]\n",
  "ISOGONALS": "ISOGONAL, a line indicating the earth's magnetic field, also ISOGONE, ISOGONIC [n]\n",
  "ISOGONE": "a line indicating the earth's magnetic field, also ISOGONAL, ISOGONIC [n -S]\n",
  "ISOGONES": "ISOGONE, a line indicating the earth's magnetic field, also ISOGONAL, ISOGONIC [n]\n",
  "ISOGONIC": "a line indicating the earth's magnetic field, also ISOGONAL, ISOGONE [n -S]\n",
  "ISOGONICS": "ISOGONIC, a line indicating the earth's magnetic field, also ISOGONAL, ISOGONE [n]\n",
  "ISOGONIES": "ISOGONY, an equivalent relative growth of parts [n]\n",
  "ISOGONS": "ISOGON, a polygon having equal angles [n]\n",
  "ISOGONY": "an equivalent relative growth of parts [n ISOGONIES]\n",
  "ISOGRAFT": "to transplant from one to another of the same species [v -ED, -ING, -S]\n",
  "ISOGRAFTED": "ISOGRAFT, to transplant from one to another of the same species [v]\n",
  "ISOGRAFTING": "ISOGRAFT, to transplant from one to another of the same species [v]\n",
  "ISOGRAFTS": "ISOGRAFT, to transplant from one to another of the same species [v]\n",
  "ISOGRAM": "a map line indicating points of equal value, also ISOLINE [n -S]\n",
  "ISOGRAMS": "ISOGRAM, a map line indicating points of equal value, also ISOLINE [n]\n",
  "ISOGRAPH": "a map line indicating similar linguistical areas [n -S]\n",
  "ISOGRAPHS": "ISOGRAPH, a map line indicating similar linguistical areas [n]\n",
  "ISOGRIV": "a map line indicating equal grid variation [n -S]\n",
  "ISOGRIVS": "ISOGRIV, a map line indicating equal grid variation [n]\n",
  "ISOHEL": "a map line indicating points of equal sunshine [n -S]\n",
  "ISOHELS": "ISOHEL, a map line indicating points of equal sunshine [n]\n",
  "ISOHYDRIC": "having the same acidity or hydrogen-ion concentration [adj]\n",
  "ISOHYET": "a line on a map connecting points that receive equal amounts of rainfall, also ISOHYETAL [n -S]\n",
  "ISOHYETAL": "a line drawn on a map connecting points that receive equal amounts of rainfall, also ISOHYET [n -S]\n",
  "ISOHYETALS": "ISOHYETAL, a line drawn on a map connecting points that receive equal amounts of rainfall, also ISOHYET [n]\n",
  "ISOHYETS": "ISOHYET, a line on a map connecting points that receive equal amounts of rainfall, also ISOHYETAL [n]\n",
  "ISOIMMUNISATION": "the development of antibodies within an individual against antigens from another individual of the same species, also ISOIMMUNIZATION [n]\n",
  "ISOIMMUNIZATION": "the development of antibodies within an individual against antigens from another individual of the same species, also ISOIMMUNISATION [n]\n",
  "ISOKINETIC": "of the withdrawal of a fluid sample, accomplished without alteration of the speed or direction of flow [adj]\n",
  "ISOKONT": "any member of the Isokontae, the green algae, whose zoospores have equal cilia, also ISOKONTAN [n -S]\n",
  "ISOKONTAN": "any member of the Isokontae, the green algae, whose zoospores have equal cilia, also ISOKONT [n -S]\n",
  "ISOKONTANS": "ISOKONTAN, any member of the Isokontae, the green algae, whose zoospores have equal cilia, also ISOKONT [n]\n",
  "ISOKONTS": "ISOKONT, any member of the Isokontae, the green algae, whose zoospores have equal cilia, also ISOKONTAN [n]\n",
  "ISOLABILITIES": "ISOLABILITY, being isolable [n]\n",
  "ISOLABILITY": "being isolable [n ISOLABILITIES]\n",
  "ISOLABLE": "capable of being isolated, or of being obtained in a pure state; as, gold is isolable [adj]\n",
  "ISOLATABLE": "that can be isolated [adj]\n",
  "ISOLATE": "to set apart from others [v ISOLATED, ISOLATING, ISOLATES]\n",
  "ISOLATED": "ISOLATE, to set apart from others [v]\n",
  "ISOLATES": "ISOLATE, to set apart from others [v]\n",
  "ISOLATING": "ISOLATE, to set apart from others [v]\n",
  "ISOLATION": "the state of being apart, isolated [n -S]\n",
  "ISOLATIONISM": "a policy of national isolation by abstention from alliances and other international political and economic relations [n -S]\n",
  "ISOLATIONISMS": "ISOLATIONISM, a policy of national isolation by abstention from alliances and other international political and economic relations [n]\n",
  "ISOLATIONIST": "a believer in isolationism [n -S]\n",
  "ISOLATIONISTS": "ISOLATIONIST, a believer in isolationism [n]\n",
  "ISOLATIONS": "ISOLATION, the state of being apart, isolated [n]\n",
  "ISOLATIVE": "tending towards isolation [adj]\n",
  "ISOLATOR": "one who, or that which, isolates [n -S]\n",
  "ISOLATORS": "ISOLATOR, one who, or that which, isolates [n]\n",
  "ISOLEAD": "a line on a ballistic graph [n -S]\n",
  "ISOLEADS": "ISOLEAD, a line on a ballistic graph [n]\n",
  "ISOLECITHAL": "of the ova of mammals and some other vertebrates, having the yolk distributed evenly through the protoplasm [adj]\n",
  "ISOLEUCINE": "an essential amino acid [n -S]\n",
  "ISOLEUCINES": "ISOLEUCINE, an essential amino acid [n]\n",
  "ISOLEX": "a line delineating a geographical region where a vocabulary item is used [n -ES]\n",
  "ISOLEXES": "ISOLEX, a line delineating a geographical region where a vocabulary item is used [n]\n",
  "ISOLINE": "a map line indicating points of equal value, also ISOGRAM [n -S]\n",
  "ISOLINES": "ISOLINE, a map line indicating points of equal value, also ISOGRAM [n]\n",
  "ISOLOG": "an organic compound with similar molecular structure to another but containing different atoms of the same valency, also ISOLOGUE [n -S]\n",
  "ISOLOGOUS": "of two or more (series of) compounds, having comparable or related molecular structures [adj]\n",
  "ISOLOGS": "ISOLOG, an organic compound with similar molecular structure to another but containing different atoms of the same valency, also ISOLOGUE [n]\n",
  "ISOLOGUE": "an organic compound with similar molecular structure to another but containing different atoms of the same valency, also ISOLOG [n -S]\n",
  "ISOLOGUES": "ISOLOGUE, an organic compound with similar molecular structure to another but containing different atoms of the same valency, also ISOLOG [n]\n",
  "ISOMAGNETIC": "a line on a map connecting points of equal magnetic induction [n -S]\n",
  "ISOMAGNETICS": "ISOMAGNETIC, a line on a map connecting points of equal magnetic induction [n]\n",
  "ISOMER": "a body or compound which is isomeric with another body or compound, also ISOMERE [n -S]\n",
  "ISOMERASE": "an enzyme which speeds up the conversion of one isomeric compound to another isomeric form [n -S]\n",
  "ISOMERASES": "ISOMERASE, an enzyme which speeds up the conversion of one isomeric compound to another isomeric form [n]\n",
  "ISOMERE": "a body or compound which is isomeric with another body or compound, also ISOMER [n -S]\n",
  "ISOMERES": "ISOMERE, a body or compound which is isomeric with another body or compound, also ISOMER [n]\n",
  "ISOMERIC": "of or like an isomer [adj]\n",
  "ISOMERISATION": "the process of isomerising, also ISOMERIZATION [n -S]\n",
  "ISOMERISATIONS": "ISOMERISATION, the process of isomerising, also ISOMERIZATION [n]\n",
  "ISOMERISE": "to change into an isomer, also ISOMERIZE [v ISOMERISED, ISOMERISING, ISOMERISES]\n",
  "ISOMERISED": "ISOMERISE, to change into an isomer, also ISOMERIZE [v]\n",
  "ISOMERISES": "ISOMERISE, to change into an isomer, also ISOMERIZE [v]\n",
  "ISOMERISING": "ISOMERISE, to change into an isomer, also ISOMERIZE [v]\n",
  "ISOMERISM": "the state, quality, or relation, of two or more isomeric substances [n -S]\n",
  "ISOMERISMS": "ISOMERISM, the state, quality, or relation, of two or more isomeric substances [n]\n",
  "ISOMERIZATION": "the process of isomerizing, also ISOMERISATION [n -S]\n",
  "ISOMERIZATIONS": "ISOMERIZATION, the process of isomerizing, also ISOMERISATION [n]\n",
  "ISOMERIZE": "to change into an isomer, also ISOMERISE [v ISOMERIZED, ISOMERIZING, ISOMERIZES]\n",
  "ISOMERIZED": "ISOMERIZE, to change into an isomer, also ISOMERISE [v]\n",
  "ISOMERIZES": "ISOMERIZE, to change into an isomer, also ISOMERISE [v]\n",
  "ISOMERIZING": "ISOMERIZE, to change into an isomer, also ISOMERISE [v]\n",
  "ISOMEROUS": "having the same number of parts (esp. in floral whorls) [adj]\n",
  "ISOMERS": "ISOMER, a body or compound which is isomeric with another body or compound, also ISOMERE [n]\n",
  "ISOMETRIC": "having equality of power [adj ISOMETRICALLY] / a line connecting points of equal variations of pressure [n -S]\n",
  "ISOMETRICAL": "having equality of measure, also ISOMETRIC [adj ISOMETRICALLY]\n",
  "ISOMETRICALLY": "ISOMETRICAL, having equality of measure, also ISOMETRIC [adv]\n",
  "ISOMETRICS": "ISOMETRIC, a line connecting points of equal variations of pressure [n]\n",
  "ISOMETRIES": "ISOMETRY, equality of measure [n]\n",
  "ISOMETROPIA": "equal refraction of the two eyes [n -S]\n",
  "ISOMETROPIAS": "ISOMETROPIA, equal refraction of the two eyes [n]\n",
  "ISOMETRY": "equality of measure [n ISOMETRIES]\n",
  "ISOMORPH": "something similar to something else in form [n -S]\n",
  "ISOMORPHIC": "of the same form or appearance [adj ISOMORPHICALLY]\n",
  "ISOMORPHICALLY": "ISOMORPHIC, of the same form or appearance [adv]\n",
  "ISOMORPHISM": "similarity in shape or structure in unrelated forms [n -S]\n",
  "ISOMORPHISMS": "ISOMORPHISM, similarity in shape or structure in unrelated forms [n]\n",
  "ISOMORPHOUS": "similar in form [adj]\n",
  "ISOMORPHS": "ISOMORPH, something similar to something else in form [n]\n",
  "ISONIAZID": "a pyridine derivative used in the treatment of tuberculosis, also ISONIAZIDE [n -S]\n",
  "ISONIAZIDE": "a pyridine derivative used in the treatment of tuberculosis, also ISONIAZID [n -S]\n",
  "ISONIAZIDES": "ISONIAZIDE, a pyridine derivative used in the treatment of tuberculosis, also ISONIAZID [n]\n",
  "ISONIAZIDS": "ISONIAZID, a pyridine derivative used in the treatment of tuberculosis, also ISONIAZIDE [n]\n",
  "ISONITRILE": "a type of organic compound, aka isocyanide [n -S]\n",
  "ISONITRILES": "ISONITRILE, a type of organic compound, aka isocyanide [n]\n",
  "ISONOME": "a line connecting points where a species is equally abundant [n -S]\n",
  "ISONOMES": "ISONOME, a line connecting points where a species is equally abundant [n]\n",
  "ISONOMIC": "having equal rights or privileges, also ISONOMOUS [adj]\n",
  "ISONOMIES": "ISONOMY, equality of law, rights or privileges [n]\n",
  "ISONOMOUS": "having equal rights or privileges, also ISONOMIC [adj]\n",
  "ISONOMY": "equality of law, rights or privileges [n ISONOMIES]\n",
  "ISOOCTANE": "a fuel of the same octane rating [n -S]\n",
  "ISOOCTANES": "ISOOCTANE, a fuel of the same octane rating [n]\n",
  "ISOPACH": "a line connecting points of equal thickness of geological strata [n -S]\n",
  "ISOPACHS": "ISOPACH, a line connecting points of equal thickness of geological strata [n]\n",
  "ISOPACHYTE": "a line connecting points of equal thickness of geological strata [n -S]\n",
  "ISOPACHYTES": "ISOPACHYTE, a line connecting points of equal thickness of geological strata [n]\n",
  "ISOPERIMETER": "a figure with perimeter equal to another [n -S]\n",
  "ISOPERIMETERS": "ISOPERIMETER, a figure with perimeter equal to another [n]\n",
  "ISOPERIMETRICAL": "having equal perimeters [adj]\n",
  "ISOPERIMETRIES": "ISOPERIMETRY, the state of being isoperimetrical [n]\n",
  "ISOPERIMETRY": "the state of being isoperimetrical [n ISOPERIMETRIES]\n",
  "ISOPHONE": "a line delineating a geographical region where a certain pronunciation is used [n -S]\n",
  "ISOPHONES": "ISOPHONE, a line delineating a geographical region where a certain pronunciation is used [n]\n",
  "ISOPHOTAL": "relating to an isophote, a line connecting points of equal light intensity from a given source [adj]\n",
  "ISOPHOTE": "a line on an image of a galaxy, nebula or other celestial object connecting points of equal light intensity from a given source [n -S]\n",
  "ISOPHOTES": "ISOPHOTE, a line on an image of a galaxy, nebula or other celestial object connecting points of equal light intensity from a given source [n]\n",
  "ISOPIESTIC": "having equal pressure [adj ISOPIESTICALLY]\n",
  "ISOPIESTICALLY": "ISOPIESTIC, having equal pressure [adv]\n",
  "ISOPLETH": "a line connecting points of equal aspect of climate [n -S]\n",
  "ISOPLETHIC": "of or like an isopleth, a line connecting points of equal aspect of climate [adj]\n",
  "ISOPLETHS": "ISOPLETH, a line connecting points of equal aspect of climate [n]\n",
  "ISOPLUVIAL": "a line on a map connecting places registering the same amount of precipitation or rainfall [n -S]\n",
  "ISOPLUVIALS": "ISOPLUVIAL, a line on a map connecting places registering the same amount of precipitation or rainfall [n]\n",
  "ISOPOD": "any crustacean of the order Isopoda, that includes woodlice etc., also ISOPODAN [n -S]\n",
  "ISOPODAN": "a kind of crustacean, also ISOPOD [n -S]\n",
  "ISOPODANS": "ISOPODAN, a kind of crustacean, also ISOPOD [n]\n",
  "ISOPODOUS": "of or like an isopod, a kind of small crustacean [adj]\n",
  "ISOPODS": "ISOPOD, any crustacean of the order Isopoda, that includes woodlice etc., also ISOPODAN [n]\n",
  "ISOPOLITIES": "ISOPOLITY, reciprocity of rights of citizenship in two communities [n]\n",
  "ISOPOLITY": "reciprocity of rights of citizenship in two communities [n ISOPOLITIES]\n",
  "ISOPRENALINE": "a drug used to stimulate the heart and to dilate the air-passages in asthma and bronchial conditions [n -S]\n",
  "ISOPRENALINES": "ISOPRENALINE, a drug used to stimulate the heart and to dilate the air-passages in asthma and bronchial conditions [n]\n",
  "ISOPRENE": "a hydrocarbon of the terpene group [n -S]\n",
  "ISOPRENES": "ISOPRENE, a hydrocarbon of the terpene group [n]\n",
  "ISOPRENOID": "a type of chemical compound, featuring a hydrocarbon of the terpene group [n -S]\n",
  "ISOPRENOIDS": "ISOPRENOID, a type of chemical compound, featuring a hydrocarbon of the terpene group [n]\n",
  "ISOPROPYL": "a radical derived from propane [n -S]\n",
  "ISOPROPYLS": "ISOPROPYL, a radical derived from propane [n]\n",
  "ISOPROTERENOL": "a sympathomimetic agent used in the treatment of asthma [n -S]\n",
  "ISOPROTERENOLS": "ISOPROTERENOL, a sympathomimetic agent used in the treatment of asthma [n]\n",
  "ISOPTERAN": "any member of an order of insects, the termites, having the two pairs of wings (when present) closely alike [n -S]\n",
  "ISOPTERANS": "ISOPTERAN, any member of an order of insects, the termites, having the two pairs of wings (when present) closely alike [n]\n",
  "ISOPTEROUS": "relating to the Isoptera, an order of insects having the two pairs of wings closely alike [adj]\n",
  "ISOPYCNAL": "a line on a map connecting points of equal atmospheric density, also ISOPYCNIC [n -S]\n",
  "ISOPYCNALS": "ISOPYCNAL, a line on a map connecting points of equal atmospheric density, also ISOPYCNIC [n]\n",
  "ISOPYCNIC": "a line on a map connecting points of equal atmospheric density, also ISOPYCNAL [n -S]\n",
  "ISOPYCNICS": "ISOPYCNIC, a line on a map connecting points of equal atmospheric density, also ISOPYCNAL [n]\n",
  "ISORHYTHMIC": "in ancient prosody, equal in the number of time-units for thesis and arsis, as dactyl, spondee, anapaest; (in medieval motets) having a strict scheme of repeated rhythm independent of melodic repetition [adj]\n",
  "ISOS": "ISO, (short for) an isolated replay, a TV and film facility [n]\n",
  "ISOSCELES": "a triangle with two equal sides [n]\n",
  "ISOSEISMAL": "a line connecting points of same earthquake intensity, also ISOSEISMIC [n -S]\n",
  "ISOSEISMALS": "ISOSEISMAL, a line connecting points of same earthquake intensity, also ISOSEISMIC [n]\n",
  "ISOSEISMIC": "a line connecting points of same earthquake intensity, also ISOSEISMAL [n -S]\n",
  "ISOSEISMICS": "ISOSEISMIC, a line connecting points of same earthquake intensity, also ISOSEISMAL [n]\n",
  "ISOSMOTIC": "of, relating to or exhibiting equal osmotic pressure [adj ISOSMOTICALLY]\n",
  "ISOSMOTICALLY": "ISOSMOTIC, of, relating to or exhibiting equal osmotic pressure [adv]\n",
  "ISOSPIN": "a quantum number applied to members of closely related groups of particles [n -S]\n",
  "ISOSPINS": "ISOSPIN, a quantum number applied to members of closely related groups of particles [n]\n",
  "ISOSPONDYLOUS": "of, relating to, or belonging to the Isospondyli, an order of soft-finned teleost fishes that includes the herring, salmon, trout, and pike [adj]\n",
  "ISOSPORIES": "ISOSPORY, the condition of producing sexless spores [n]\n",
  "ISOSPOROUS": "having spores of one kind only, as opposed to heterosporous [adj]\n",
  "ISOSPORY": "the condition of producing sexless spores [n ISOSPORIES]\n",
  "ISOSTACIES": "ISOSTACY, the state of balance in the earth's crust, also ISOSTASY [n]\n",
  "ISOSTACY": "the state of balance in the earth's crust, also ISOSTASY [n ISOSTACIES]\n",
  "ISOSTASIES": "ISOSTASY, the state of balance in the earth's crust, also ISOSTACY [n]\n",
  "ISOSTASY": "the state of balance in the earth's crust, also ISOSTACY [n ISOSTASIES]\n",
  "ISOSTATIC": "in a state of isostasy, hydrostatic equilibrium from equality of pressure [adj ISOSTATICALLY]\n",
  "ISOSTATICALLY": "ISOSTATIC, in a state of isostasy, hydrostatic equilibrium from equality of pressure [adv]\n",
  "ISOSTEMONOUS": "having as many stamens as petals [adj]\n",
  "ISOSTERIC": "of two different molecules, having the same number of atoms, and the same number and valency of electrons [adj]\n",
  "ISOSTHENURIA": "the inability to produce urine [n -S]\n",
  "ISOSTHENURIAS": "ISOSTHENURIA, the inability to produce urine [n]\n",
  "ISOTACH": "a line connecting points of equal wind velocity [n -S]\n",
  "ISOTACHS": "ISOTACH, a line connecting points of equal wind velocity [n]\n",
  "ISOTACTIC": "of a polymer, with its attached groups of atoms in a regular order on one side of the chain [adj]\n",
  "ISOTENISCOPE": "an instrument used to measure vapour pressure [n -S]\n",
  "ISOTENISCOPES": "ISOTENISCOPE, an instrument used to measure vapour pressure [n]\n",
  "ISOTHERAL": "a line connecting points of the same average summer temperature, also ISOTHERE [n -S]\n",
  "ISOTHERALS": "ISOTHERAL, a line connecting points of the same average summer temperature, also ISOTHERE [n]\n",
  "ISOTHERE": "a line connecting points of the same average summer temperature, also ISOTHERAL [n -S]\n",
  "ISOTHERES": "ISOTHERE, a line connecting points of the same average summer temperature, also ISOTHERAL [n]\n",
  "ISOTHERM": "a line on a map connecting points of equal average temperature, also ISOTHERMAL [n -S]\n",
  "ISOTHERMAL": "having an equal average temperature [adj ISOTHERMALLY] / a line on a map connecting points of equal average temperature, also ISOTHERM [n -S]\n",
  "ISOTHERMALLY": "ISOTHERMAL, having an equal average temperature [adv]\n",
  "ISOTHERMALS": "ISOTHERMAL, a line on a map connecting points of equal average temperature, also ISOTHERM [n]\n",
  "ISOTHERMS": "ISOTHERM, a line on a map connecting points of equal average temperature, also ISOTHERMAL [n]\n",
  "ISOTONE": "one of a number of nuclides having the same number of neutrons in the nucleus with differing numbers of protons [n -S]\n",
  "ISOTONES": "ISOTONE, one of a number of nuclides having the same number of neutrons in the nucleus with differing numbers of protons [n]\n",
  "ISOTONIC": "having equal tones, or tension [adj ISOTONICALLY]\n",
  "ISOTONICALLY": "ISOTONIC, having equal tones, or tension [adv]\n",
  "ISOTONICITIES": "ISOTONICITY, the quality of being isotonic [n]\n",
  "ISOTONICITY": "the quality of being isotonic [n ISOTONICITIES]\n",
  "ISOTOPE": "one of two more atoms with the same atomic number that contain different numbers of neutrons [n -S]\n",
  "ISOTOPES": "ISOTOPE, one of two more atoms with the same atomic number that contain different numbers of neutrons [n]\n",
  "ISOTOPIC": "of or like an isotope [adj ISOTOPICALLY]\n",
  "ISOTOPICALLY": "ISOTOPIC, of or like an isotope [adv]\n",
  "ISOTOPIES": "ISOTOPY, the state of being an isotope [n]\n",
  "ISOTOPY": "the state of being an isotope [n ISOTOPIES]\n",
  "ISOTRETINOIN": "a drug derived from Vitamin A, used in the treatment of severe acne [n -S]\n",
  "ISOTRETINOINS": "ISOTRETINOIN, a drug derived from Vitamin A, used in the treatment of severe acne [n]\n",
  "ISOTRON": "a device for separating isotopes [n -S]\n",
  "ISOTRONS": "ISOTRON, a device for separating isotopes [n]\n",
  "ISOTROPIC": "having the same properties in every direction, also ISOTROPOUS [adj ISOTROPICALLY]\n",
  "ISOTROPICALLY": "ISOTROPIC, having the same properties in every direction, also ISOTROPOUS [adv]\n",
  "ISOTROPIES": "ISOTROPY, the state of being identical in all directions [n]\n",
  "ISOTROPISM": "isotropy, also ISOTROPY [n -S]\n",
  "ISOTROPISMS": "ISOTROPISM, isotropy, also ISOTROPY [n]\n",
  "ISOTROPOUS": "having the same properties irrespective of direction, also ISOTROPIC [adj]\n",
  "ISOTROPY": "the state of being identical in all directions [n ISOTROPIES]\n",
  "ISOTYPE": "in taxonomy, a duplicate of the holotype, a specimen made from the same collection as the holotype [n -S]\n",
  "ISOTYPES": "ISOTYPE, in taxonomy, a duplicate of the holotype, a specimen made from the same collection as the holotype [n]\n",
  "ISOTYPIC": "of or like an isotype, a duplicate of the holotype, a specimen made from the same collection as the holotype [adj]\n",
  "ISOXSUPRINE": "a drug which dilates blood vessels, used to inhibit contractions in premature labour and in the treatment of arteriosclerosis [n -S]\n",
  "ISOXSUPRINES": "ISOXSUPRINE, a drug which dilates blood vessels, used to inhibit contractions in premature labour and in the treatment of arteriosclerosis [n]\n",
  "ISOZYME": "one of several variants of the same enzyme occurring within a single species, also ISOENZYME [n -S]\n",
  "ISOZYMES": "ISOZYME, one of several variants of the same enzyme occurring within a single species, also ISOENZYME [n]\n",
  "ISOZYMIC": "of or like an isozyme, one of several variants of the same enzyme occurring within a single species [adj]\n",
  "ISPAGHULA": "a dietary fibre derived from seed husks and used as a thickener or stabilizer in the food industry, aka psyllium [n -S]\n",
  "ISPAGHULAS": "ISPAGHULA, a dietary fibre derived from seed husks and used as a thickener or stabilizer in the food industry, aka psyllium [n]\n",
  "ISSEI": "(Japanese) a Japanese immigrant to the United States [n -S]\n",
  "ISSEIS": "ISSEI, (Japanese) a Japanese immigrant to the United States [n]\n",
  "ISSUABLE": "authorized for issuing [adj ISSUABLY]\n",
  "ISSUABLY": "ISSUABLE, authorized for issuing [adv]\n",
  "ISSUANCE": "the act of giving out, issuing [n -S]\n",
  "ISSUANCES": "ISSUANCE, the act of giving out, issuing [n]\n",
  "ISSUANT": "in heraldry, issuing or coming up from another, as a charge or bearing [adj]\n",
  "ISSUE": "to put into circulation [v ISSUED, ISSUING, ISSUES]\n",
  "ISSUED": "ISSUE, to put into circulation [v]\n",
  "ISSUELESS": "having no issue or progeny; childless [adj]\n",
  "ISSUER": "one who issues [n -S]\n",
  "ISSUERS": "ISSUER, one who issues [n]\n",
  "ISSUES": "ISSUE, to put into circulation [v]\n",
  "ISSUING": "ISSUE, to put into circulation [v]\n",
  "ISTANA": "(Malay) in Malaysia, a royal palace [n -S]\n",
  "ISTANAS": "ISTANA, (Malay) in Malaysia, a royal palace [n]\n",
  "ISTHMI": "ISTHMUS, (Latin) a strip of land connecting two larger land masses [n]\n",
  "ISTHMIAN": "a native of an isthmus [n -S]\n",
  "ISTHMIANS": "ISTHMIAN, a native of an isthmus [n]\n",
  "ISTHMIC": "pertaining to an isthmus, also ISTHMOID [adj]\n",
  "ISTHMOID": "pertaining to an isthmus, also ISTHMIC [adj]\n",
  "ISTHMUS": "(Latin) a strip of land connecting two larger land masses [n ISTHMUSES or ISTHMI]\n",
  "ISTHMUSES": "ISTHMUS, (Latin) a strip of land connecting two larger land masses [n]\n",
  "ISTLE": "(Nahuatl) a strong fibre obtained from agave, also IXTLE [n -S]\n",
  "ISTLES": "ISTLE, (Nahuatl) a strong fibre obtained from agave, also IXTLE [n]\n",
  "IT": "the neuter of he, she, him or her [pron]\n",
  "ITA": "the miriti palm [n -S]\n",
  "ITACISM": "the pronunciation of the Greek letter eta as the modern Greeks pronounce it, that is, like e in the English word be, also ETACISM [n -S]\n",
  "ITACISMS": "ITACISM, the pronunciation of the Greek letter eta as the modern Greeks pronounce it, that is, like e in the English word be, also ETACISM [n]\n",
  "ITACOLUMITE": "a kind of sandstone, flexible when cut into thin slabs [n -S]\n",
  "ITACOLUMITES": "ITACOLUMITE, a kind of sandstone, flexible when cut into thin slabs [n]\n",
  "ITACONIC": "as in itaconic acid, a component of some synthetic resins [adj]\n",
  "ITALIANATE": "to render Italian, or conformable to Italian customs [v ITALIANATED, ITALIANATING, ITALIANATES]\n",
  "ITALIANATED": "ITALIANATE, to render Italian, or conformable to Italian customs [v]\n",
  "ITALIANATES": "ITALIANATE, to render Italian, or conformable to Italian customs [v]\n",
  "ITALIANATING": "ITALIANATE, to render Italian, or conformable to Italian customs [v]\n",
  "ITALIANISE": "to make Italian, also ITALIANIZE [v ITALIANISED, ITALIANISING, ITALIANISES]\n",
  "ITALIANISED": "ITALIANISE, to make Italian, also ITALIANIZE [v]\n",
  "ITALIANISES": "ITALIANISE, to make Italian, also ITALIANIZE [v]\n",
  "ITALIANISING": "ITALIANISE, to make Italian, also ITALIANIZE [v]\n",
  "ITALIANIZE": "to make Italian, also ITALIANISE [v ITALIANIZED, ITALIANIZING, ITALIANIZES]\n",
  "ITALIANIZED": "ITALIANIZE, to make Italian, also ITALIANISE [v]\n",
  "ITALIANIZES": "ITALIANIZE, to make Italian, also ITALIANISE [v]\n",
  "ITALIANIZING": "ITALIANIZE, to make Italian, also ITALIANISE [v]\n",
  "ITALIC": "of a sloping type used esp. for emphasis or other distinctive purpose [adj] / a letter in italic type [n -S]\n",
  "ITALICISATION": "the act of italicising, also ITALICIZATION [n -S]\n",
  "ITALICISATIONS": "ITALICISATION, the act of italicising, also ITALICIZATION [n]\n",
  "ITALICISE": "to print in italic characters, also ITALICIZE [v ITALICISED, ITALICISING, ITALICISES]\n",
  "ITALICISED": "ITALICISE, to print in italic characters, also ITALICIZE [v]\n",
  "ITALICISES": "ITALICISE, to print in italic characters, also ITALICIZE [v]\n",
  "ITALICISING": "ITALICISE, to print in italic characters, also ITALICIZE [v]\n",
  "ITALICIZATION": "the act of italicizing, also ITALICISATION [n -S]\n",
  "ITALICIZATIONS": "ITALICIZATION, the act of italicizing, also ITALICISATION [n]\n",
  "ITALICIZE": "to print in italic characters, also ITALICISE [v ITALICIZED, ITALICIZING, ITALICIZES]\n",
  "ITALICIZED": "ITALICIZE, to print in italic characters, also ITALICISE [v]\n",
  "ITALICIZES": "ITALICIZE, to print in italic characters, also ITALICISE [v]\n",
  "ITALICIZING": "ITALICIZE, to print in italic characters, also ITALICISE [v]\n",
  "ITALICS": "ITALIC, a letter in italic type [n]\n",
  "ITAS": "ITA, the miriti palm [n]\n",
  "ITCH": "to have an irritating sensation in the skin [v -ED, -ING, -ES]\n",
  "ITCHED": "ITCH, to have an irritating sensation in the skin [v]\n",
  "ITCHES": "ITCH, to have an irritating sensation in the skin [v]\n",
  "ITCHIER": "ITCHY, affected with itching [adj]\n",
  "ITCHIEST": "ITCHY, affected with itching [adj]\n",
  "ITCHILY": "ITCHY, affected with itching [adv]\n",
  "ITCHINESS": "the state of being itchy [n -ES]\n",
  "ITCHINESSES": "ITCHINESS, the state of being itchy [n]\n",
  "ITCHING": "a tingling skin sensation [n -S]\n",
  "ITCHINGS": "ITCHING, a tingling skin sensation [n]\n",
  "ITCHWEED": "a flower, Indian pokeweed [n -S]\n",
  "ITCHWEEDS": "ITCHWEED, a flower, Indian pokeweed [n]\n",
  "ITCHY": "affected with itching [adj ITCHIER, ITCHIEST, ITCHILY]\n",
  "ITEM": "to set down the particulars of, also ITEMISE, ITEMIZE [v -ED, -ING, -S]\n",
  "ITEMED": "ITEM, to set down the particulars of, also ITEMISE, ITEMIZE [v]\n",
  "ITEMING": "ITEM, to set down the particulars of, also ITEMISE, ITEMIZE [v]\n",
  "ITEMISATION": "the act of itemizing, also ITEMIZATION [n -S]\n",
  "ITEMISATIONS": "ITEMISATION, the act of itemizing, also ITEMIZATION [n]\n",
  "ITEMISE": "to set down the particulars of, also ITEM, ITEMIZE [v ITEMISED, ITEMISING, ITEMISES]\n",
  "ITEMISED": "ITEMISE, to set down the particulars of, also ITEM, ITEMIZE [v]\n",
  "ITEMISER": "one that itemizes, also ITEMIZER [n -S]\n",
  "ITEMISERS": "ITEMISER, one that itemizes, also ITEMIZER [n]\n",
  "ITEMISES": "ITEMISE, to set down the particulars of, also ITEM, ITEMIZE [v]\n",
  "ITEMISING": "ITEMISE, to set down the particulars of, also ITEM, ITEMIZE [v]\n",
  "ITEMIZATION": "the act of itemizing, also ITEMISATION [n -S]\n",
  "ITEMIZATIONS": "ITEMIZATION, the act of itemizing, also ITEMISATION [n]\n",
  "ITEMIZE": "to set down the particulars of, also ITEM, ITEMISE [v ITEMIZED, ITEMIZING, ITEMIZES]\n",
  "ITEMIZED": "ITEMIZE, to set down the particulars of, also ITEM, ITEMISE [v]\n",
  "ITEMIZER": "one that itemizes, also ITEMISER [n -S]\n",
  "ITEMIZERS": "ITEMIZER, one that itemizes, also ITEMISER [n]\n",
  "ITEMIZES": "ITEMIZE, to set down the particulars of, also ITEM, ITEMISE [v]\n",
  "ITEMIZING": "ITEMIZE, to set down the particulars of, also ITEM, ITEMISE [v]\n",
  "ITEMS": "ITEM, to set down the particulars of, also ITEMISE, ITEMIZE [v]\n",
  "ITERANCE": "repetition [n -S]\n",
  "ITERANCES": "ITERANCE, repetition [n]\n",
  "ITERANT": "repeating [adj]\n",
  "ITERATE": "to repeat, do again [v ITERATED, ITERATING, ITERATES]\n",
  "ITERATED": "ITERATE, to repeat, do again [v]\n",
  "ITERATES": "ITERATE, to repeat, do again [v]\n",
  "ITERATING": "ITERATE, to repeat, do again [v]\n",
  "ITERATION": "repetition, also ITERANCE [n -S]\n",
  "ITERATIONS": "ITERATION, repetition, also ITERANCE [n]\n",
  "ITERATIVE": "repeating, iterating, also ITERANT [adj ITERATIVELY]\n",
  "ITERATIVELY": "ITERATIVE, repeating, iterating, also ITERANT [adv]\n",
  "ITERATIVENESS": "ITERATIVE, repeating, iterating, also ITERANT [n]\n",
  "ITERATIVENESSES": "ITERATIVENESS, ITERATIVE, repeating, iterating, also ITERANT [n]\n",
  "ITEROPARITIES": "ITEROPARITY, the state of being iteroparous [n]\n",
  "ITEROPARITY": "the state of being iteroparous [n ITEROPARITIES]\n",
  "ITEROPAROUS": "reproducing more than once in a lifetime [adj]\n",
  "ITERUM": "(Latin) again, once more [adv]\n",
  "ITHER": "other [adj]\n",
  "ITHYPHALLI": "ITHYPHALLUS, an erect phallus [n]\n",
  "ITHYPHALLIC": "in classical verse, of or relating to the usual metre in hymns to Bacchus [adj] / a poem in this metre [n -S]\n",
  "ITHYPHALLICS": "ITHYPHALLIC, a poem in this metre [n]\n",
  "ITHYPHALLUS": "an erect phallus [n ITHYPHALLI or ITHYPHALLUSES]\n",
  "ITHYPHALLUSES": "ITHYPHALLUS, an erect phallus [n]\n",
  "ITINERACIES": "ITINERACY, making journeys from place to place, also ITINERANCY [n]\n",
  "ITINERACY": "making journeys from place to place, also ITINERANCY [n ITINERACIES]\n",
  "ITINERANCIES": "ITINERANCY, making journeys from place to place, also ITINERACY [n]\n",
  "ITINERANCY": "making journeys from place to place, also ITINERACY [n ITINERANCIES]\n",
  "ITINERANT": "travelling [adj ITINERANTLY] / someone who travels from place to place, esp. a judge [n -S]\n",
  "ITINERANTLY": "ITINERANT, travelling [adv]\n",
  "ITINERANTS": "ITINERANT, someone who travels from place to place, esp. a judge [n]\n",
  "ITINERARIES": "ITINERARY, a plan or record of a journey [n]\n",
  "ITINERARY": "a plan or record of a journey [n ITINERARIES]\n",
  "ITINERATE": "to wander without a settled habitation; to travel from place or on a circuit, particularly for the purpose of preaching, lecturing, etc. [v ITINERATED, ITINERATING, ITINERATES]\n",
  "ITINERATED": "ITINERATE, to wander without a settled habitation; to travel from place or on a circuit, particularly for the purpose of preaching, lecturing, etc. [v]\n",
  "ITINERATES": "ITINERATE, to wander without a settled habitation; to travel from place or on a circuit, particularly for the purpose of preaching, lecturing, etc. [v]\n",
  "ITINERATING": "ITINERATE, to wander without a settled habitation; to travel from place or on a circuit, particularly for the purpose of preaching, lecturing, etc. [v]\n",
  "ITINERATION": "the act of itinerating [n -S]\n",
  "ITINERATIONS": "ITINERATION, the act of itinerating [n]\n",
  "ITS": "possessive form of IT [pron]\n",
  "ITSELF": "a reflexive form of IT [pron]\n",
  "IURE": "(Latin) by right or law, also JURE [adv]\n",
  "IVERMECTIN": "a drug used in veterinary medicine [n -S]\n",
  "IVERMECTINS": "IVERMECTIN, a drug used in veterinary medicine [n]\n",
  "IVIED": "covered with ivy [adj]\n",
  "IVIES": "IVY, a climbing vine [n]\n",
  "IVORIED": "made like ivory [adj]\n",
  "IVORIER": "IVORY, of a white colour [adj]\n",
  "IVORIES": "IVORY, a hard white substance found in elephant tusks [n]\n",
  "IVORIEST": "IVORY, of a white colour [adj]\n",
  "IVORIST": "a worker in ivory [n -S]\n",
  "IVORISTS": "IVORIST, a worker in ivory [n]\n",
  "IVORY": "of a white colour [adj IVORIER, IVORIEST] / a hard white substance found in elephant tusks [n IVORIES]\n",
  "IVORYBILL": "the ivory-billed woodpecker [n -S]\n",
  "IVORYBILLS": "IVORYBILL, the ivory-billed woodpecker [n]\n",
  "IVORYLIKE": "like ivory [adj]\n",
  "IVORYWOOD": "the yellowish-white wood of an Australian tree, used for engraving, inlaying, and turnery; the tree itself [n -S]\n",
  "IVORYWOODS": "IVORYWOOD, the yellowish-white wood of an Australian tree, used for engraving, inlaying, and turnery; the tree itself [n]\n",
  "IVRESSE": "(French) drunkenness [n -S]\n",
  "IVRESSES": "IVRESSE, (French) drunkenness [n]\n",
  "IVY": "a climbing vine [n IVIES]\n",
  "IVYLEAF": "as in ivyleaf geranium, a geranium plant, with trailing leaves and white, pink, red, or violet flowers [adj]\n",
  "IVYLIKE": "like ivy [adj]\n",
  "IWI": "(Maori) a large Maori tribe (sometimes the whole Maori nation) [n -S]\n",
  "IWIS": "certainly, also YWIS [adv]\n",
  "IXIA": "a flowering plant of South Africa [n -S]\n",
  "IXIAS": "IXIA, a flowering plant of South Africa [n]\n",
  "IXNAY": "not! [interj]\n",
  "IXODIASES": "IXODIASIS, a disease caused by or transmitted by ticks [n]\n",
  "IXODIASIS": "a disease caused by or transmitted by ticks [n IXODIASES]\n",
  "IXODID": "(Greek) a tick, a bloodsucking insect [n -S]\n",
  "IXODIDS": "IXODID, (Greek) a tick, a bloodsucking insect [n]\n",
  "IXORA": "a flowering plant, aka St Rita and Maltese Cross [n -S]\n",
  "IXORAS": "IXORA, a flowering plant, aka St Rita and Maltese Cross [n]\n",
  "IXTLE": "(Nahuatl) a strong fibre obtained from the agave, also ISTLE [n -S]\n",
  "IXTLES": "IXTLE, (Nahuatl) a strong fibre obtained from the agave, also ISTLE [n]\n",
  "IZAR": "(Arabic) a long cotton outer garment (usually white) worn by Muslim women [n -S]\n",
  "IZARD": "(French) the Pyrenean ibex [n -S]\n",
  "IZARDS": "IZARD, (French) the Pyrenean ibex [n]\n",
  "IZARS": "IZAR, (Arabic) a long cotton outer garment (usually white) worn by Muslim women [n]\n",
  "IZVESTIA": "(Russian) news, information, also IZVESTIYA [n -S]\n",
  "IZVESTIAS": "IZVESTIA, (Russian) news, information, also IZVESTIYA [n]\n",
  "IZVESTIYA": "(Russian) news, information, also IZVESTIA [n -S]\n",
  "IZVESTIYAS": "IZVESTIYA, (Russian) news, information, also IZVESTIA [n]\n",
  "IZZARD": "the letter Z [n -S]\n",
  "IZZARDS": "IZZARD, the letter Z [n]\n",
  "IZZAT": "(Urdu) honour, reputation, prestige [n -S]\n",
  "IZZATS": "IZZAT, (Urdu) honour, reputation, prestige [n]\n",
  "JA": "(German) yes [interj]\n",
  "JAAP": "(offensive South African) an ignorant fool [n -S]\n",
  "JAAPS": "JAAP, (offensive South African) an ignorant fool [n]\n",
  "JAB": "to poke sharply [v JABBED, JABBING, JABS]\n",
  "JABBED": "JAB, to poke sharply [v]\n",
  "JABBER": "to talk rapidly [v -ED, -ING, -S]\n",
  "JABBERED": "JABBER, to talk rapidly [v]\n",
  "JABBERER": "one who jabbers [n -S]\n",
  "JABBERERS": "JABBERER, one who jabbers [n]\n",
  "JABBERING": "talking rapidly [adj JABBERINGLY] / the act of jabbering [n -S]\n",
  "JABBERINGLY": "JABBERING, talking rapidly [adv]\n",
  "JABBERINGS": "JABBERING, the act of jabbering [n]\n",
  "JABBERS": "JABBER, to talk rapidly [v]\n",
  "JABBERWOCK": "nonsense, gibberish, also JABBERWOCKY [n -S]\n",
  "JABBERWOCKIES": "JABBERWOCKY, nonsense, gibberish, also JABBERWOCK [n]\n",
  "JABBERWOCKS": "JABBERWOCK, nonsense, gibberish, also JABBERWOCKY [n]\n",
  "JABBERWOCKY": "nonsense, gibberish, also JABBERWOCK [n JABBERWOCKIES]\n",
  "JABBING": "JAB, to poke sharply [v]\n",
  "JABBINGLY": "JABBING, JAB, to poke sharply [adv]\n",
  "JABBLE": "(Scots) to splash, ripple [v JABBLED, JABBLING, JABBLES]\n",
  "JABBLED": "JABBLE, (Scots) to splash, ripple [v]\n",
  "JABBLES": "JABBLE, (Scots) to splash, ripple [v]\n",
  "JABBLING": "JABBLE, (Scots) to splash, ripple [v]\n",
  "JABERS": "as in the Irish oath be jabers, by Jesus [n]\n",
  "JABIRU": "(Tupi) one of several large wading birds allied to the storks [n -S]\n",
  "JABIRUS": "JABIRU, (Tupi) one of several large wading birds allied to the storks [n]\n",
  "JABORANDI": "(Tupi) the native name of a South American rutaceous shrub, whose leaves are used in medicine as a diaphoretic and sialogogue [n -S]\n",
  "JABORANDIS": "JABORANDI, (Tupi) the native name of a South American rutaceous shrub, whose leaves are used in medicine as a diaphoretic and sialogogue [n]\n",
  "JABOT": "(French) a lace frill worn on shirt or dress front [n -S]\n",
  "JABOTICABA": "(Tupi) a Brazilian tree of the myrtle family [n -S]\n",
  "JABOTICABAS": "JABOTICABA, (Tupi) a Brazilian tree of the myrtle family [n]\n",
  "JABOTS": "JABOT, (French) a lace frill worn on shirt or dress front [n]\n",
  "JABS": "JAB, to poke sharply [v]\n",
  "JACAL": "(Nahuatl) a hut built of erect stakes filled in with wattle and mud, common in Mexico and the southwestern US [n -ES or -S]\n",
  "JACALES": "JACAL, (Nahuatl) a hut built of erect stakes filled in with wattle and mud, common in Mexico and the southwestern US [n]\n",
  "JACALS": "JACAL, (Nahuatl) a hut built of erect stakes filled in with wattle and mud, common in Mexico and the southwestern US [n]\n",
  "JACAMAR": "(Tupi) any of various small insectivorous birds of tropical South America, with partly iridescent plumage [n -S]\n",
  "JACAMARS": "JACAMAR, (Tupi) any of various small insectivorous birds of tropical South America, with partly iridescent plumage [n]\n",
  "JACANA": "(Portuguese) any of various small tropical wading birds of the family Jacanidae, which have greatly elongated toes and claws, enabling them to walk on floating vegetation [n -S]\n",
  "JACANAS": "JACANA, (Portuguese) any of various small tropical wading birds of the family Jacanidae, which have greatly elongated toes and claws, enabling them to walk on floating vegetation [n]\n",
  "JACARANDA": "(Tupi) a tropical American tree of the Bignoniaceae [n -S]\n",
  "JACARANDAS": "JACARANDA, (Tupi) a tropical American tree of the Bignoniaceae [n]\n",
  "JACARE": "(Tupi) the caiman [n -S]\n",
  "JACARES": "JACARE, (Tupi) the caiman [n]\n",
  "JACCHUS": "a South American marmoset [n -ES]\n",
  "JACCHUSES": "JACCHUS, a South American marmoset [n]\n",
  "JACENT": "(obsolete) lying flat; sluggish [adj]\n",
  "JACINTH": "a variety of zircon [n -S]\n",
  "JACINTHE": "an orange colour [n -S]\n",
  "JACINTHES": "JACINTHE, an orange colour [n]\n",
  "JACINTHS": "JACINTH, a variety of zircon [n]\n",
  "JACK": "a device for raising e.g. a car [n -S] / to raise with jack [v -ED, -ING, -S]\n",
  "JACKAL": "an African carnivorous mammal related to the dog [n -S] / to play the jackal, do someone else's dirty work [v JACKALLED, JACKALLING, JACKALS]\n",
  "JACKALLED": "JACKAL, to play the jackal, do someone else's dirty work [v]\n",
  "JACKALLING": "JACKAL, to play the jackal, do someone else's dirty work [v]\n",
  "JACKALOPE": "a mythical animal that is reported chiefly from the western US and is reputed to be the size of a small deer and to have the body of a jackrabbit and the horns of an antelope [n -S]\n",
  "JACKALOPES": "JACKALOPE, a mythical animal that is reported chiefly from the western US and is reputed to be the size of a small deer and to have the body of a jackrabbit and the horns of an antelope [n]\n",
  "JACKALS": "JACKAL, to play the jackal, do someone else's dirty work [v]\n",
  "JACKANAPES": "an impudent child; a conceited fellow [n -ES]\n",
  "JACKANAPESES": "JACKANAPES, an impudent child; a conceited fellow [n]\n",
  "JACKAROO": "(Australian) a newcomer gaining experience at a sheep-station [n -S] / to work as a newcomer at a sheep farm, also JACKEROO [v -ED, -ING, -S]\n",
  "JACKAROOED": "JACKAROO, to work as a newcomer at a sheep farm, also JACKEROO [v]\n",
  "JACKAROOING": "JACKAROO, to work as a newcomer at a sheep farm, also JACKEROO [v]\n",
  "JACKAROOS": "JACKAROO, (Australian) a newcomer gaining experience at a sheep-station [n]\n",
  "JACKASS": "a male ass or donkey [n -ES]\n",
  "JACKASSERIES": "JACKASSERY, being a jackass [n]\n",
  "JACKASSERY": "being a jackass [n JACKASSERIES]\n",
  "JACKASSES": "JACKASS, a male ass or donkey [n]\n",
  "JACKBOOT": "a kind of high boot [n -S] / to behave in a brutally authoritarian way [v -ED, -ING, -S]\n",
  "JACKBOOTED": "JACKBOOT, to behave in a brutally authoritarian way [v]\n",
  "JACKBOOTING": "JACKBOOT, to behave in a brutally authoritarian way [v]\n",
  "JACKBOOTS": "JACKBOOT, a kind of high boot [n]\n",
  "JACKDAW": "a bird resembling a crow [n -S]\n",
  "JACKDAWS": "JACKDAW, a bird resembling a crow [n]\n",
  "JACKED": "JACK, to raise with jack [v]\n",
  "JACKEEN": "(Irish) a person from Dublin, esp. one with a parochial attitude [n -S]\n",
  "JACKEENS": "JACKEEN, (Irish) a person from Dublin, esp. one with a parochial attitude [n]\n",
  "JACKER": "one who jacks [n -S]\n",
  "JACKEROO": "(Australian) a newcomer gaining experience at a sheep-station [n -S] / to work as a newcomer at a sheep farm, also JACKAROO [v -ED, -ING, -S]\n",
  "JACKEROOED": "JACKEROO, to work as a newcomer at a sheep farm, also JACKAROO [v]\n",
  "JACKEROOING": "JACKEROO, to work as a newcomer at a sheep farm, also JACKAROO [v]\n",
  "JACKEROOS": "JACKEROO, (Australian) a newcomer gaining experience at a sheep-station [n]\n",
  "JACKERS": "JACKER, one who jacks [n]\n",
  "JACKET": "to provide with a short coat [v -ED, -ING, -S]\n",
  "JACKETED": "JACKET, to provide with a short coat [v]\n",
  "JACKETING": "JACKET, to provide with a short coat [v]\n",
  "JACKETLESS": "without a jacket [adj]\n",
  "JACKETS": "JACKET, to provide with a short coat [v]\n",
  "JACKFISH": "a food fish [n -ES]\n",
  "JACKFISHES": "JACKFISH, a food fish [n]\n",
  "JACKFRUIT": "an East Indian tree of the breadfruit family, also JAK, JAKFRUIT [n -S]\n",
  "JACKFRUITS": "JACKFRUIT, an East Indian tree of the breadfruit family, also JAK, JAKFRUIT [n]\n",
  "JACKHAMMER": "a handheld compressed air rock-drill [n -S] / to hammer with a jackhammer [v -ED, -ING, -S]\n",
  "JACKHAMMERED": "JACKHAMMER, to hammer with a jackhammer [v]\n",
  "JACKHAMMERING": "JACKHAMMER, to hammer with a jackhammer [v]\n",
  "JACKHAMMERS": "JACKHAMMER, a handheld compressed air rock-drill [n]\n",
  "JACKIES": "JACKY, a sailor [n]\n",
  "JACKING": "in house dancing, moving the torso forward and backward in a rippling motion [n -S]\n",
  "JACKINGS": "JACKING, in house dancing, moving the torso forward and backward in a rippling motion [n]\n",
  "JACKKNIFE": "a large clasp knife [n JACKKNIVES] / to fold up like a jackknife [v JACKKNIFED, JACKKNIFING, JACKKNIFES]\n",
  "JACKKNIFED": "JACKKNIFE, to fold up like a jackknife [v]\n",
  "JACKKNIFES": "JACKKNIFE, to fold up like a jackknife [v]\n",
  "JACKKNIFING": "JACKKNIFE, to fold up like a jackknife [v]\n",
  "JACKKNIVES": "JACKKNIFE, a large clasp knife [n]\n",
  "JACKLEG": "an amateur; one characterized by unscrupulousness, dishonesty or lack or standards [n -S]\n",
  "JACKLEGS": "JACKLEG, an amateur; one characterized by unscrupulousness, dishonesty or lack or standards [n]\n",
  "JACKLIGHT": "a kind of fishing lure [n -S] / to fish with a jacklight [v -ED, -ING, -S]\n",
  "JACKLIGHTED": "JACKLIGHT, to fish with a jacklight [v]\n",
  "JACKLIGHTING": "JACKLIGHT, to fish with a jacklight [v]\n",
  "JACKLIGHTS": "JACKLIGHT, a kind of fishing lure [n]\n",
  "JACKLING": "the winning of the ball, by the defender's team, after a tackle and before a ruck has formed [n -S]\n",
  "JACKLINGS": "JACKLING, the winning of the ball, by the defender's team, after a tackle and before a ruck has formed [n]\n",
  "JACKMAN": "a soldier wearing leather armour [n JACKMEN]\n",
  "JACKMEN": "JACKMAN, a soldier wearing leather armour [n]\n",
  "JACKPLANE": "a large woodworking plane [n -S]\n",
  "JACKPLANES": "JACKPLANE, a large woodworking plane [n]\n",
  "JACKPOT": "a top prize or reward [n -S] / (Australian) to win a top prize or reward [v JACKPOTTED, JACKPOTTING, JACKPOTS]\n",
  "JACKPOTS": "JACKPOT, a top prize or reward [n]\n",
  "JACKPOTTED": "JACKPOT, (Australian) to win a top prize or reward [v]\n",
  "JACKPOTTING": "JACKPOT, (Australian) to win a top prize or reward [v]\n",
  "JACKRABBIT": "a long-eared American hare [n -S]\n",
  "JACKRABBITS": "JACKRABBIT, a long-eared American hare [n]\n",
  "JACKROLL": "(South African) to roll a drunken or sleeping person [v -ED, -ING, -S]\n",
  "JACKROLLED": "JACKROLL, (South African) to roll a drunken or sleeping person [v]\n",
  "JACKROLLING": "JACKROLL, (South African) to roll a drunken or sleeping person [v]\n",
  "JACKROLLS": "JACKROLL, (South African) to roll a drunken or sleeping person [v]\n",
  "JACKS": "JACK, to raise with jack [v]\n",
  "JACKSCREW": "a jack in which a screw is used for lifting, or exerting pressure [n -S]\n",
  "JACKSCREWS": "JACKSCREW, a jack in which a screw is used for lifting, or exerting pressure [n]\n",
  "JACKSHAFT": "an intermediate shaft e.g. between a motor and the wheels it drives [n -S]\n",
  "JACKSHAFTS": "JACKSHAFT, an intermediate shaft e.g. between a motor and the wheels it drives [n]\n",
  "JACKSIE": "(slang) the posterior, also JAXY, JAXIE, JACKSY [n -S]\n",
  "JACKSIES": "JACKSIE, (slang) the posterior, also JAXY, JAXIE, JACKSY [n]\n",
  "JACKSMELT": "a large fish of the Pacific coast of North America [n -S]\n",
  "JACKSMELTS": "JACKSMELT, a large fish of the Pacific coast of North America [n]\n",
  "JACKSMITH": "a smith who makes jacks [n -S]\n",
  "JACKSMITHS": "JACKSMITH, a smith who makes jacks [n]\n",
  "JACKSNIPE": "a kind of snipe [n -S]\n",
  "JACKSNIPES": "JACKSNIPE, a kind of snipe [n]\n",
  "JACKSTAFF": "a short staff at a ship's bow, on which a jack is hoisted [n JACKSTAFFS or JACKSTAVES]\n",
  "JACKSTAFFS": "JACKSTAFF, a short staff at a ship's bow, on which a jack is hoisted [n]\n",
  "JACKSTAVES": "JACKSTAFF, a short staff at a ship's bow, on which a jack is hoisted [n]\n",
  "JACKSTAY": "an iron or wooden bar running along the yard of a ship to which sails are fastened [n -S]\n",
  "JACKSTAYS": "JACKSTAY, an iron or wooden bar running along the yard of a ship to which sails are fastened [n]\n",
  "JACKSTONE": "a piece used in the game of jacks [n -S]\n",
  "JACKSTONES": "JACKSTONE, a piece used in the game of jacks [n]\n",
  "JACKSTRAW": "an effigy stuffed with straw; a scarecrow; hence, a man without property or influence [n -S]\n",
  "JACKSTRAWS": "JACKSTRAW, an effigy stuffed with straw; a scarecrow; hence, a man without property or influence [n]\n",
  "JACKSY": "the posterior, also JAXY, JAXIE, JACKSIE [n JACKSIES]\n",
  "JACKY": "a sailor [n JACKIES]\n",
  "JACOBIN": "a variety of fancy pigeon with a hood of feathers [n -S]\n",
  "JACOBINS": "JACOBIN, a variety of fancy pigeon with a hood of feathers [n]\n",
  "JACOBUS": "(historical) an English gold coin, struck in the reign of James I [n -ES]\n",
  "JACOBUSES": "JACOBUS, (historical) an English gold coin, struck in the reign of James I [n]\n",
  "JACONET": "(Hindi) a kind of thin cotton fabric, esp. with one side glazed [n -S]\n",
  "JACONETS": "JACONET, (Hindi) a kind of thin cotton fabric, esp. with one side glazed [n]\n",
  "JACQUARD": "(French) an apparatus with perforated cards for controlling the movement of the warp threads in weaving intricate designs; a fabric woven by this method [n -S]\n",
  "JACQUARDS": "JACQUARD, (French) an apparatus with perforated cards for controlling the movement of the warp threads in weaving intricate designs; a fabric woven by this method [n]\n",
  "JACQUERIE": "(French) a peasant's revolt, esp. in 1358, the French peasant uprising against nobility [n -S]\n",
  "JACQUERIES": "JACQUERIE, (French) a peasant's revolt, esp. in 1358, the French peasant uprising against nobility [n]\n",
  "JACTATION": "restless tossing in bed, characteristic of severe fevers and certain mental disorders, also JACTITATION [n -S]\n",
  "JACTATIONS": "JACTATION, restless tossing in bed, characteristic of severe fevers and certain mental disorders, also JACTITATION [n]\n",
  "JACTITATION": "restless tossing in bed, characteristic of severe fevers and certain mental disorders, also JACTATION [n -S]\n",
  "JACTITATIONS": "JACTITATION, restless tossing in bed, characteristic of severe fevers and certain mental disorders, also JACTATION [n]\n",
  "JACULATE": "to throw or cast, as a dart [v JACULATED, JACULATING, JACULATES]\n",
  "JACULATED": "JACULATE, to throw or cast, as a dart [v]\n",
  "JACULATES": "JACULATE, to throw or cast, as a dart [v]\n",
  "JACULATING": "JACULATE, to throw or cast, as a dart [v]\n",
  "JACULATION": "the act of throwing or hurling [n -S]\n",
  "JACULATIONS": "JACULATION, the act of throwing or hurling [n]\n",
  "JACULATOR": "one who throws or casts [n -S]\n",
  "JACULATORS": "JACULATOR, one who throws or casts [n]\n",
  "JACULATORY": "throwing out suddenly [adj]\n",
  "JACUZZI": "a kind of large bath which uses underwater jets of warm water to massage the body [n -S]\n",
  "JACUZZIS": "JACUZZI, a kind of large bath which uses underwater jets of warm water to massage the body [n]\n",
  "JADE": "to tire [v JADED, JADING, JADES]\n",
  "JADED": "JADE, to tire [v]\n",
  "JADEDLY": "JADED, JADE, to tire [adv]\n",
  "JADEDNESS": "the state of being jaded [n -ES]\n",
  "JADEDNESSES": "JADEDNESS, the state of being jaded [n]\n",
  "JADEITE": "a mineral, a silicate of sodium, aluminium, and ferric iron [n -S]\n",
  "JADEITES": "JADEITE, a mineral, a silicate of sodium, aluminium, and ferric iron [n]\n",
  "JADELIKE": "like jade [adj]\n",
  "JADERIES": "JADERY, the tricks of a perverse woman [n]\n",
  "JADERY": "the tricks of a perverse woman [n JADERIES]\n",
  "JADES": "JADE, to tire [v]\n",
  "JADING": "JADE, to tire [v]\n",
  "JADISH": "like a jade, vicious [adj JADISHLY]\n",
  "JADISHLY": "JADISH, like a jade, vicious [adv]\n",
  "JADISHNESS": "the state of being jaded [n -ES]\n",
  "JADISHNESSES": "JADISHNESS, the state of being jaded [n]\n",
  "JADITIC": "of or like jadeite, a mineral [adj]\n",
  "JAEGER": "(German) a German army marksman, also JAGER, YAGER [n -S]\n",
  "JAEGERS": "JAEGER, (German) a German army marksman, also JAGER, YAGER [n]\n",
  "JAFA": "(offensive New Zealand slang) a person from Auckland [n -S]\n",
  "JAFAS": "JAFA, (offensive New Zealand slang) a person from Auckland [n]\n",
  "JAFFA": "in cricket, a well-bowled ball that is likely to take a wicket [n -S]\n",
  "JAFFAS": "JAFFA, in cricket, a well-bowled ball that is likely to take a wicket [n]\n",
  "JAG": "to cut unevenly, also JAGG [v JAGGED, JAGGING, JAGS]\n",
  "JAGA": "(Malay) in Indonesia, to guard [v -ED, -ING, -S]\n",
  "JAGAED": "JAGA, (Malay) in Indonesia, to guard [v]\n",
  "JAGAING": "JAGA, (Malay) in Indonesia, to guard [v]\n",
  "JAGAS": "JAGA, (Malay) in Indonesia, to guard [v]\n",
  "JAGDWURST": "(German) a cured sausage with chunks of ham in a pbti base, often with whole mustard seeds, pistachios, and pimentos [n -S]\n",
  "JAGDWURSTS": "JAGDWURST, (German) a cured sausage with chunks of ham in a pbti base, often with whole mustard seeds, pistachios, and pimentos [n]\n",
  "JAGER": "(German) a German army marksman, also JAEGER, YAGER [n -S]\n",
  "JAGERS": "JAGER, (German) a German army marksman, also JAEGER, YAGER [n]\n",
  "JAGG": "to cut unevenly, also JAG [v -ED, -ING, -S]\n",
  "JAGGARIES": "JAGGARY, (Hindi) a coarse, dark sugar, also JAGGERY, JAGGHERY, JAGRA [n]\n",
  "JAGGARY": "(Hindi) a coarse, dark sugar, also JAGGERY, JAGGHERY, JAGRA [n JAGGARIES]\n",
  "JAGGED": "rough-edged [adj JAGGEDER, JAGGEDEST, JAGGEDLY]\n",
  "JAGGEDER": "JAGGED, rough-edged [adj]\n",
  "JAGGEDEST": "JAGGED, rough-edged [adj]\n",
  "JAGGEDLY": "JAGGED, rough-edged [adv]\n",
  "JAGGEDNESS": "the state of being jagged [n -ES]\n",
  "JAGGEDNESSES": "JAGGEDNESS, the state of being jagged [n]\n",
  "JAGGER": "a hawker, a pedlar, also YAGGER [n -S]\n",
  "JAGGERIES": "JAGGERY, (Hindi) a coarse, dark sugar, also JAGGARY, JAGGHERY, JAGRA [n]\n",
  "JAGGERS": "JAGGER, a hawker, a pedlar, also YAGGER [n]\n",
  "JAGGERY": "(Hindi) a coarse, dark sugar, also JAGGARY, JAGGHERY, JAGRA [n JAGGERIES]\n",
  "JAGGHERIES": "JAGGHERY, (Hindi) a coarse, dark sugar, also JAGGARY, JAGGERY, JAGRA [n]\n",
  "JAGGHERY": "(Hindi) a coarse, dark sugar, also JAGGARY, JAGGERY, JAGRA [n JAGGHERIES]\n",
  "JAGGIER": "JAGGY, jagged, rough-edged [adj]\n",
  "JAGGIES": "JAGGY, a jagged computer image [n]\n",
  "JAGGIEST": "JAGGY, jagged, rough-edged [adj]\n",
  "JAGGING": "JAGG, to cut unevenly, also JAG [v]\n",
  "JAGGS": "JAGG, to cut unevenly, also JAG [v]\n",
  "JAGGY": "jagged, rough-edged [adj JAGGIER, JAGGIEST] / a jagged computer image [n JAGGIES]\n",
  "JAGHIR": "(Hindi) the government revenues of a tract of land assigned with power to administer, also JAGHIRE, JAGIR [n -S]\n",
  "JAGHIRDAR": "(Hindi) the holder of a jaghir, in Pakistan, a village or district the government and revenues of which are assigned to some person [n -S]\n",
  "JAGHIRDARS": "JAGHIRDAR, (Hindi) the holder of a jaghir, in Pakistan, a village or district the government and revenues of which are assigned to some person [n]\n",
  "JAGHIRE": "(Hindi) the government revenues of a tract of land assigned with power to administer, also JAGHIR, JAGIR [n -S]\n",
  "JAGHIRES": "JAGHIRE, (Hindi) the government revenues of a tract of land assigned with power to administer, also JAGHIR, JAGIR [n]\n",
  "JAGHIRS": "JAGHIR, (Hindi) the government revenues of a tract of land assigned with power to administer, also JAGHIRE, JAGIR [n]\n",
  "JAGIR": "(Hindi) the government revenues of a tract of land assigned with power to administer, also JAGHIR, JAGHIRE [n -S]\n",
  "JAGIRS": "JAGIR, (Hindi) the government revenues of a tract of land assigned with power to administer, also JAGHIR, JAGHIRE [n]\n",
  "JAGLESS": "(slang) not producing intoxication [adj]\n",
  "JAGRA": "(Hindi) a coarse, dark sugar, also JAGGARY, JAGGERY, JAGGHERY [n -S]\n",
  "JAGRAS": "JAGRA, (Hindi) a coarse, dark sugar, also JAGGARY, JAGGERY, JAGGHERY [n]\n",
  "JAGS": "JAG, to cut unevenly, also JAGG [v]\n",
  "JAGUAR": "a powerful feline beast of prey [n -S]\n",
  "JAGUARONDI": "(Tupi) a South American wild cat, aka eyra, also JAGUARUNDI [n -S]\n",
  "JAGUARONDIS": "JAGUARONDI, (Tupi) a South American wild cat, aka eyra, also JAGUARUNDI [n]\n",
  "JAGUARS": "JAGUAR, a powerful feline beast of prey [n]\n",
  "JAGUARUNDI": "(Tupi) a South American wild cat, aka eyra, also JAGUARONDI [n -S]\n",
  "JAGUARUNDIS": "JAGUARUNDI, (Tupi) a South American wild cat, aka eyra, also JAGUARONDI [n]\n",
  "JAI": "(Hindi) onward to victory [interj]\n",
  "JAIL": "to imprison, also GAOL [v -ED, -ING, -S]\n",
  "JAILABLE": "able to be jailed [adj]\n",
  "JAILBAIT": "(offensive) a sexually attractive person who is below the age of legal consent [n -S]\n",
  "JAILBAITS": "JAILBAIT, (offensive) a sexually attractive person who is below the age of legal consent [n]\n",
  "JAILBIRD": "an inveterate convict, also GAOLBIRD [n -S]\n",
  "JAILBIRDS": "JAILBIRD, an inveterate convict, also GAOLBIRD [n]\n",
  "JAILBREAK": "to free from jail, also GAOLBREAK [v JAILBROKE, JAILBROKEN, JAILBREAKING, JAILBREAKS]\n",
  "JAILBREAKER": "one who escapes from jail [n -S]\n",
  "JAILBREAKERS": "JAILBREAKER, one who escapes from jail [n]\n",
  "JAILBREAKING": "JAILBREAK, to free from jail, also GAOLBREAK [v]\n",
  "JAILBREAKS": "JAILBREAK, to free from jail, also GAOLBREAK [v]\n",
  "JAILBROKE": "JAILBREAK, to free from jail, also GAOLBREAK [v]\n",
  "JAILBROKEN": "JAILBREAK, to free from jail, also GAOLBREAK [v]\n",
  "JAILED": "JAIL, to imprison, also GAOL [v]\n",
  "JAILER": "a keeper of a jail, also GAOLER, JAILOR [n -S]\n",
  "JAILERESS": "a female jailer, also GAOLERESS, JAILORESS [n -ES]\n",
  "JAILERESSES": "JAILERESS, a female jailer, also GAOLERESS, JAILORESS [n]\n",
  "JAILERS": "JAILER, a keeper of a jail, also GAOLER, JAILOR [n]\n",
  "JAILHOUSE": "a prison [n -S]\n",
  "JAILHOUSES": "JAILHOUSE, a prison [n]\n",
  "JAILING": "JAIL, to imprison, also GAOL [v]\n",
  "JAILLESS": "having no gaol, also GAOLLESS [adj]\n",
  "JAILOR": "a keeper of a jail, also GAOLER, JAILER [n -S]\n",
  "JAILORESS": "a female jailor, also GAOLERESS, JAILERESS [n -ES]\n",
  "JAILORESSES": "JAILORESS, a female jailor, also GAOLERESS, JAILERESS [n]\n",
  "JAILORS": "JAILOR, a keeper of a jail, also GAOLER, JAILER [n]\n",
  "JAILS": "JAIL, to imprison, also GAOL [v]\n",
  "JAK": "an East Indian tree of the breadfruit family, also JACKFRUIT, JAKFRUIT [n -S]\n",
  "JAKE": "(Australian slang) honest, fine [adj JAKER, JAKEST] / (US) a country lout, a yokel [n -S]\n",
  "JAKER": "JAKE, (Australian slang) honest, fine [adj]\n",
  "JAKES": "(Shakespeare) a privy [n -ES]\n",
  "JAKESES": "JAKES, (Shakespeare) a privy [n]\n",
  "JAKEST": "JAKE, (Australian slang) honest, fine [adj]\n",
  "JAKEY": "(offensive Scots) a homeless alcoholic [n -S]\n",
  "JAKEYS": "JAKEY, (offensive Scots) a homeless alcoholic [n]\n",
  "JAKFRUIT": "an East Indian tree of the breadfruit family, also JACKFRUIT, JAK [n -S]\n",
  "JAKFRUITS": "JAKFRUIT, an East Indian tree of the breadfruit family, also JACKFRUIT, JAK [n]\n",
  "JAKS": "JAK, an East Indian tree of the breadfruit family, also JACKFRUIT, JAKFRUIT [n]\n",
  "JALABIB": "JILBAB, (Arabic) a long robe worn by Muslim women [n]\n",
  "JALAP": "a Mexican plant, also JALOP [n -S]\n",
  "JALAPENO": "(Spanish) an especially hot type of Capsicum pepper [n -S]\n",
  "JALAPENOS": "JALAPENO, (Spanish) an especially hot type of Capsicum pepper [n]\n",
  "JALAPIC": "pertaining to jalap, the purgative root of a Mexican plant [adj]\n",
  "JALAPIN": "a glucoside resin, one of the purgative principles of jalap [n -S]\n",
  "JALAPINS": "JALAPIN, a glucoside resin, one of the purgative principles of jalap [n]\n",
  "JALAPS": "JALAP, a Mexican plant, also JALOP [n]\n",
  "JALEBI": "(Hindi) an Asian snack of deep-fried dough covered with syrup, also JALLEBI [n -S]\n",
  "JALEBIS": "JALEBI, (Hindi) an Asian snack of deep-fried dough covered with syrup, also JALLEBI [n]\n",
  "JALFREZI": "a hot-flavoured Indian dish of meat or vegetables stir-fried with green chillis and spices [n -S]\n",
  "JALFREZIS": "JALFREZI, a hot-flavoured Indian dish of meat or vegetables stir-fried with green chillis and spices [n]\n",
  "JALLEBI": "(Sanskrit) an Asian snack of deep-fried dough covered with syrup, also JALEBI [n -S]\n",
  "JALLEBIS": "JALLEBI, (Sanskrit) an Asian snack of deep-fried dough covered with syrup, also JALEBI [n]\n",
  "JALOALLOFANE": "a crystalline mineral which contains potassium and belongs to the feldspar group, aka hyalophane [n -S]\n",
  "JALOALLOFANES": "JALOALLOFANE, a crystalline mineral which contains potassium and belongs to the feldspar group, aka hyalophane [n]\n",
  "JALOP": "the purgative root of a Mexican plant, also JALAP [n -S]\n",
  "JALOPIES": "JALOPY, a decrepit car, also JALOPPY [n]\n",
  "JALOPPIES": "JALOPPY, a decrepit car, also JALOPY [n]\n",
  "JALOPPY": "a decrepit car, also JALOPY [n JALOPPIES]\n",
  "JALOPS": "JALOP, the purgative root of a Mexican plant, also JALAP [n]\n",
  "JALOPY": "a decrepit car, also JALOPPY [n JALOPIES]\n",
  "JALOUSE": "(Scots) to suspect, also JEALOUSE [v JALOUSED, JALOUSING, JALOUSES]\n",
  "JALOUSED": "JALOUSE, (Scots) to suspect, also JEALOUSE [v]\n",
  "JALOUSES": "JALOUSE, (Scots) to suspect, also JEALOUSE [v]\n",
  "JALOUSIE": "(French) an outside shutter with slats [n -S]\n",
  "JALOUSIED": "fitted with jalousies, outside shutters with slats [adj]\n",
  "JALOUSIES": "JALOUSIE, (French) an outside shutter with slats [n]\n",
  "JALOUSING": "JALOUSE, (Scots) to suspect, also JEALOUSE [v]\n",
  "JAM": "to force together tightly [v JAMMED, JAMMING, JAMS]\n",
  "JAMAAT": "(Arabic) an Islamic council or assembly [n -S]\n",
  "JAMAATS": "JAMAAT, (Arabic) an Islamic council or assembly [n]\n",
  "JAMADAR": "(Urdu) in the native army of India, an officer of a rank corresponding to that of lieutenant in the English army, also JEMADAR, JEMIDAR [n -S]\n",
  "JAMADARS": "JAMADAR, (Urdu) in the native army of India, an officer of a rank corresponding to that of lieutenant in the English army, also JEMADAR, JEMIDAR [n]\n",
  "JAMAHIRIYA": "(Arabic) in Arab socialist states, the people or proletariat state, also JUMHOURIYA [n -S]\n",
  "JAMAHIRIYAS": "JAMAHIRIYA, (Arabic) in Arab socialist states, the people or proletariat state, also JUMHOURIYA [n]\n",
  "JAMB": "a piece of leg armour, a greave, also JAMBART, JAMBE, JAMBEAU, JAMBER, JAMBIER [n -S] / to jam [v -ED, -ING, -S]\n",
  "JAMBALAYA": "(Provencal) a Creole dish of rice, meat, shellfish etc. [n -S]\n",
  "JAMBALAYAS": "JAMBALAYA, (Provencal) a Creole dish of rice, meat, shellfish etc. [n]\n",
  "JAMBART": "a greave, armour covering the lower leg, also JAMB, JAMBE, JAMBEAU, JAMBER, JAMBIER [n -S]\n",
  "JAMBARTS": "JAMBART, a greave, armour covering the lower leg, also JAMB, JAMBE, JAMBEAU, JAMBER, JAMBIER [n]\n",
  "JAMBE": "a piece of leg-armour, a greave, also JAMB, JAMBART, JAMBEAU, JAMBER, JAMBIER [n -S]\n",
  "JAMBEAU": "(obsolete) armour for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBER, JAMBIER [n JAMBEAUS or JAMBEAUX]\n",
  "JAMBEAUS": "JAMBEAU, (obsolete) armour for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBER, JAMBIER [n]\n",
  "JAMBEAUX": "JAMBEAU, (obsolete) armour for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBER, JAMBIER [n]\n",
  "JAMBED": "JAMB, to jam [v]\n",
  "JAMBEE": "a light cane, fashionable in the 18th century [n -S]\n",
  "JAMBEES": "JAMBEE, a light cane, fashionable in the 18th century [n]\n",
  "JAMBER": "(obsolete) armor for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBEAU, JAMBIER [n -S]\n",
  "JAMBERS": "JAMBER, (obsolete) armor for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBEAU, JAMBIER [n]\n",
  "JAMBES": "JAMBE, a piece of leg-armour, a greave, also JAMB, JAMBART, JAMBEAU, JAMBER, JAMBIER [n]\n",
  "JAMBEUX": "armour for the legs below the knees, a greave [n]\n",
  "JAMBIER": "(obsolete) armor for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBEAU, JAMBER [n -S]\n",
  "JAMBIERS": "JAMBIER, (obsolete) armor for the legs below the knees, a greave, also JAMB, JAMBART, JAMBE, JAMBEAU, JAMBER [n]\n",
  "JAMBING": "JAMB, to jam [v]\n",
  "JAMBIYA": "(Arabic) a Middle Eastern curved dagger, also JAMBIYAH [n -S]\n",
  "JAMBIYAH": "(Arabic) a Middle Eastern curved dagger, also JAMBIYA [n -S]\n",
  "JAMBIYAHS": "JAMBIYAH, (Arabic) a Middle Eastern curved dagger, also JAMBIYA [n]\n",
  "JAMBIYAS": "JAMBIYA, (Arabic) a Middle Eastern curved dagger, also JAMBIYAH [n]\n",
  "JAMBO": "(Swahili) an East African salutation [interj]\n",
  "JAMBOK": "(South African) to beat with a rhinoceros-hide whip, also SJAMBOK [v JAMBOKKED, JAMBOKKING, JAMBOKS]\n",
  "JAMBOKKED": "JAMBOK, (South African) to beat with a rhinoceros-hide whip, also SJAMBOK [v]\n",
  "JAMBOKKING": "JAMBOK, (South African) to beat with a rhinoceros-hide whip, also SJAMBOK [v]\n",
  "JAMBOKS": "JAMBOK, (South African) to beat with a rhinoceros-hide whip, also SJAMBOK [v]\n",
  "JAMBOLAN": "(Sanskrit) the rose-apple tree of Malaysia, also JAMBOLANA, JAMBOOL, JAMBU, JAMBUL [n -S]\n",
  "JAMBOLANA": "(Sanskrit) the rose-apple tree of Malaysia, also JAMBOLAN, JAMBOOL, JAMBU, JAMBUL [n -S]\n",
  "JAMBOLANAS": "JAMBOLANA, (Sanskrit) the rose-apple tree of Malaysia, also JAMBOLAN, JAMBOOL, JAMBU, JAMBUL [n]\n",
  "JAMBOLANS": "JAMBOLAN, (Sanskrit) the rose-apple tree of Malaysia, also JAMBOLANA, JAMBOOL, JAMBU, JAMBUL [n]\n",
  "JAMBONE": "a lone hand in Euchre [n -S]\n",
  "JAMBONES": "JAMBONE, a lone hand in Euchre [n]\n",
  "JAMBOOL": "(Sanskrit) the rose-apple tree, also JAMBU, JAMBOLAN, JAMBUL [n -S]\n",
  "JAMBOOLS": "JAMBOOL, (Sanskrit) the rose-apple tree, also JAMBU, JAMBOLAN, JAMBUL [n]\n",
  "JAMBOREE": "a noisy celebration [n -S]\n",
  "JAMBOREES": "JAMBOREE, a noisy celebration [n]\n",
  "JAMBS": "JAMB, to jam [v]\n",
  "JAMBU": "(Sanskrit) the rose-apple tree of Malaysia, also JAMBOLAN, JAMBOLANA, JAMBOOL, JAMBUL [n -S]\n",
  "JAMBUL": "(Sanskrit) the rose-apple tree of Malaysia, also JAMBOLAN, JAMBOLANA, JAMBOOL, JAMBU [n -S]\n",
  "JAMBULS": "JAMBUL, (Sanskrit) the rose-apple tree of Malaysia, also JAMBOLAN, JAMBOLANA, JAMBOOL, JAMBU [n]\n",
  "JAMBUS": "JAMBU, (Sanskrit) the rose-apple tree of Malaysia, also JAMBOLAN, JAMBOLANA, JAMBOOL, JAMBUL [n]\n",
  "JAMBUSTER": "(Canadian) a jelly-filled doughnut [n -S]\n",
  "JAMBUSTERS": "JAMBUSTER, (Canadian) a jelly-filled doughnut [n]\n",
  "JAMDANI": "(Urdu) a kind of Dacca muslin [n -S]\n",
  "JAMDANIS": "JAMDANI, (Urdu) a kind of Dacca muslin [n]\n",
  "JAMES": "a short crowbar [n -ES]\n",
  "JAMESES": "JAMES, a short crowbar [n]\n",
  "JAMJAR": "a jar for jam, also JAMPOT [n -S]\n",
  "JAMJARS": "JAMJAR, a jar for jam, also JAMPOT [n]\n",
  "JAMLIKE": "like jam [adj]\n",
  "JAMMABLE": "able to be jammed [adj]\n",
  "JAMMED": "JAM, to force together tightly [v]\n",
  "JAMMER": "a person or thing that jams something [n -S]\n",
  "JAMMERS": "JAMMER, a person or thing that jams something [n]\n",
  "JAMMIER": "JAMMY, very lucky [adj]\n",
  "JAMMIES": "(colloquial) pajamas [n]\n",
  "JAMMIEST": "JAMMY, very lucky [adj]\n",
  "JAMMING": "a rock-climbing technique in which holds are got by wedging the hands and feet in suitable cracks [n -S]\n",
  "JAMMINGS": "JAMMING, a rock-climbing technique in which holds are got by wedging the hands and feet in suitable cracks [n]\n",
  "JAMMY": "very lucky [adj JAMMIER, JAMMIEST]\n",
  "JAMON": "(Spanish) designating a variety of Spanish ham [adj]\n",
  "JAMPACKED": "packed to the full [adj]\n",
  "JAMPAN": "(Bengali) an Indian sedan chair [n -S]\n",
  "JAMPANEE": "(Bengali) an Indian sedan chair bearer, also JAMPANI [n -S]\n",
  "JAMPANEES": "JAMPANEE, (Bengali) an Indian sedan chair bearer, also JAMPANI [n]\n",
  "JAMPANI": "(Bengali) an Indian sedan chair bearer, also JAMPANEE [n -S]\n",
  "JAMPANIS": "JAMPANI, (Bengali) an Indian sedan chair bearer, also JAMPANEE [n]\n",
  "JAMPANS": "JAMPAN, (Bengali) an Indian sedan chair [n]\n",
  "JAMPOT": "a jar for jam, also JAMJAR [n -S]\n",
  "JAMPOTS": "JAMPOT, a jar for jam, also JAMJAR [n]\n",
  "JAMS": "JAM, to force together tightly [v]\n",
  "JANE": "a small silver Genoese coin [n -S]\n",
  "JANES": "JANE, a small silver Genoese coin [n]\n",
  "JANGLE": "to make a harsh metallic sound [v JANGLED, JANGLING, JANGLES]\n",
  "JANGLED": "JANGLE, to make a harsh metallic sound [v]\n",
  "JANGLER": "a storyteller, a jester [n -S]\n",
  "JANGLERS": "JANGLER, a storyteller, a jester [n]\n",
  "JANGLES": "JANGLE, to make a harsh metallic sound [v]\n",
  "JANGLIER": "JANGLY, making a jangling sound [adj]\n",
  "JANGLIEST": "JANGLY, making a jangling sound [adj]\n",
  "JANGLING": "a jangling noise [n -S]\n",
  "JANGLINGS": "JANGLING, a jangling noise [n]\n",
  "JANGLY": "making a jangling sound [adj JANGLIER, JANGLIEST]\n",
  "JANIFORM": "like the Roman god Janus; two-faced, hypocritical [adj]\n",
  "JANISARIES": "JANISARY, (Turkish) a soldier of the old Turkish footguards, also JANISSARY, JANIZAR, JANIZARY [n]\n",
  "JANISARY": "(Turkish) a soldier of the old Turkish footguards, also JANISSARY, JANIZAR, JANIZARY [n JANISARIES]\n",
  "JANISSARIES": "JANISSARY, (Turkish) a soldier of the old Turkish footguards, also JANISARY, JANIZAR, JANIZARY [n]\n",
  "JANISSARY": "(Turkish) a soldier of the old Turkish footguards, also JANISARY, JANIZAR, JANIZARY [n JANISSARIES]\n",
  "JANITOR": "(Latin) a doorkeeper; an attendant or caretaker [n -S]\n",
  "JANITORIAL": "relating to a janitor [adj]\n",
  "JANITORS": "JANITOR, (Latin) a doorkeeper; an attendant or caretaker [n]\n",
  "JANITORSHIP": "the office of janitor [n -S]\n",
  "JANITORSHIPS": "JANITORSHIP, the office of janitor [n]\n",
  "JANITRESS": "a female janitor, also JANITRIX [n -ES]\n",
  "JANITRESSES": "JANITRESS, a female janitor, also JANITRIX [n]\n",
  "JANITRIX": "(Latin) a female doorkeeper [n -ES]\n",
  "JANITRIXES": "JANITRIX, (Latin) a female doorkeeper [n]\n",
  "JANIZAR": "(Turkish) a soldier of the old Turkish footguards, also JANISARY, JANISSARY, JANIZARY [n -S]\n",
  "JANIZARIAN": "of or pertaining to the janizaries, or their government [adj]\n",
  "JANIZARIES": "JANIZARY, (Turkish) a soldier of the old Turkish footguards, also JANISARY, JANISSARY, JANIZAR [n]\n",
  "JANIZARS": "JANIZAR, (Turkish) a soldier of the old Turkish footguards, also JANISARY, JANISSARY, JANIZARY [n]\n",
  "JANIZARY": "(Turkish) a soldier of the old Turkish footguards, also JANISARY, JANISSARY, JANIZAR [n JANIZARIES]\n",
  "JANKER": "a long pole on wheels for transporting logs [n -S]\n",
  "JANKERS": "JANKER, a long pole on wheels for transporting logs [n]\n",
  "JANN": "(Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JIN, JINN, JINNEE, JINNI [n -S]\n",
  "JANNEY": "to act as a disguised merrymaker at Christmas, also JANNY [v -ED, -ING, -S]\n",
  "JANNEYED": "JANNEY, to act as a disguised merrymaker at Christmas, also JANNY [v]\n",
  "JANNEYING": "acting as a disguised merrymaker at Christmas [n -S]\n",
  "JANNEYINGS": "JANNEYING, acting as a disguised merrymaker at Christmas [n]\n",
  "JANNEYS": "JANNEY, to act as a disguised merrymaker at Christmas, also JANNY [v]\n",
  "JANNIED": "JANNY, to act as a disguised merrymaker at Christmas, also JANNEY [v]\n",
  "JANNIES": "JANNY, to act as a disguised merrymaker at Christmas, also JANNEY [v]\n",
  "JANNOCK": "straightforward, honest, also JONNOCK [adj] / oaten bread [n -S]\n",
  "JANNOCKS": "JANNOCK, oaten bread [n]\n",
  "JANNS": "JANN, (Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JIN, JINN, JINNEE, JINNI [n]\n",
  "JANNY": "to act as a disguised merrymaker at Christmas, also JANNEY [v JANNIED, JANNYING, JANNIES]\n",
  "JANNYING": "acting as a disguised merrymaker at Christmas [n -S]\n",
  "JANNYINGS": "JANNYING, acting as a disguised merrymaker at Christmas [n]\n",
  "JANSKY": "the unit of strength of radio wave emission [n JANSKYS]\n",
  "JANSKYS": "JANSKY, the unit of strength of radio wave emission [n]\n",
  "JANTEE": "(obsolete) jaunty, sprightly, also JANTY, JAUNTEE, JAUNTIE, JAUNTY, JONTY [adj]\n",
  "JANTIER": "JANTY, briskly self-assured, also JAUNTY, JANTEE, JAUNTEE [adj]\n",
  "JANTIES": "JANTY, a naval master-at-arms, also JONTY [n]\n",
  "JANTIEST": "JANTY, briskly self-assured, also JAUNTY, JANTEE, JAUNTEE [adj]\n",
  "JANTY": "briskly self-assured, also JAUNTY, JANTEE, JAUNTEE [adj JANTIER, JANTIEST] / a naval master-at-arms, also JONTY [n JANTIES]\n",
  "JAP": "to splash or spatter, also JAUP [v JAPPED, JAPPING, JAPS]\n",
  "JAPAN": "to coat with a glossy black lacquer [v JAPANNED, JAPANNING, JAPANS]\n",
  "JAPANISE": "to make Japanese, also JAPANIZE [v JAPANISED, JAPANISING, JAPANISES]\n",
  "JAPANISED": "JAPANISE, to make Japanese, also JAPANIZE [v]\n",
  "JAPANISES": "JAPANISE, to make Japanese, also JAPANIZE [v]\n",
  "JAPANISING": "JAPANISE, to make Japanese, also JAPANIZE [v]\n",
  "JAPANIZE": "to make Japanese, also JAPANISE [v JAPANIZED, JAPANIZING, JAPANIZES]\n",
  "JAPANIZED": "JAPANIZE, to make Japanese, also JAPANISE [v]\n",
  "JAPANIZES": "JAPANIZE, to make Japanese, also JAPANISE [v]\n",
  "JAPANIZING": "JAPANIZE, to make Japanese, also JAPANISE [v]\n",
  "JAPANNED": "JAPAN, to coat with a glossy black lacquer [v]\n",
  "JAPANNER": "one who varnishes in the manner of the Japanese, or one skilled in the art [n -S]\n",
  "JAPANNERS": "JAPANNER, one who varnishes in the manner of the Japanese, or one skilled in the art [n]\n",
  "JAPANNING": "JAPAN, to coat with a glossy black lacquer [v]\n",
  "JAPANS": "JAPAN, to coat with a glossy black lacquer [v]\n",
  "JAPE": "to play a joke [v JAPED, JAPING, JAPES]\n",
  "JAPED": "JAPE, to play a joke [v]\n",
  "JAPER": "one who japes [n -S]\n",
  "JAPERIES": "JAPERY, jesting, buffoonery [n]\n",
  "JAPERS": "JAPER, one who japes [n]\n",
  "JAPERY": "jesting, buffoonery [n JAPERIES]\n",
  "JAPES": "JAPE, to play a joke [v]\n",
  "JAPING": "joking [adj JAPINGLY] / the act of japing [n -S]\n",
  "JAPINGLY": "JAPING, joking [adv]\n",
  "JAPINGS": "JAPING, the act of japing [n]\n",
  "JAPONAISERIE": "(French) art or craft in the Japanese style [n -S]\n",
  "JAPONAISERIES": "JAPONAISERIE, (French) art or craft in the Japanese style [n]\n",
  "JAPONICA": "any of several plants native to Japan, esp. the Japanese quince [n -S]\n",
  "JAPONICAS": "JAPONICA, any of several plants native to Japan, esp. the Japanese quince [n]\n",
  "JAPPED": "JAP, to splash or spatter, also JAUP [v]\n",
  "JAPPING": "JAP, to splash or spatter, also JAUP [v]\n",
  "JAPS": "JAP, to splash or spatter, also JAUP [v]\n",
  "JAR": "to vibrate from an impact [v JARRED, JARRING, JARS]\n",
  "JARARACA": "(Tupi) a South American venomous snake, also JARARAKA [n -S]\n",
  "JARARACAS": "JARARACA, (Tupi) a South American venomous snake, also JARARAKA [n]\n",
  "JARARAKA": "(Tupi) a South American venomous snake, also JARARACA [n -S]\n",
  "JARARAKAS": "JARARAKA, (Tupi) a South American venomous snake, also JARARACA [n]\n",
  "JARDINIERE": "(French) an ornamental stand or receptacle for plants, flowers, etc., used as a piece of decorative furniture in room; a garnish for meat of cooked vegetables [n -S]\n",
  "JARDINIERES": "JARDINIERE, (French) an ornamental stand or receptacle for plants, flowers, etc., used as a piece of decorative furniture in room; a garnish for meat of cooked vegetables [n]\n",
  "JARFUL": "as much as a container can hold [n JARFULS or JARSFUL]\n",
  "JARFULS": "JARFUL, as much as a container can hold [n]\n",
  "JARGON": "to use words specific to a trade or group [v -ED, -ING, -S]\n",
  "JARGONED": "JARGON, to use words specific to a trade or group [v]\n",
  "JARGONEER": "a person who uses jargon, also JARGONIST [n -S]\n",
  "JARGONEERS": "JARGONEER, a person who uses jargon, also JARGONIST [n]\n",
  "JARGONEL": "(French) an early variety of pear, also JARGONELLE [n -S]\n",
  "JARGONELLE": "(French) an early variety of pear, also JARGONEL [n -S]\n",
  "JARGONELLES": "JARGONELLE, (French) an early variety of pear, also JARGONEL [n]\n",
  "JARGONELS": "JARGONEL, (French) an early variety of pear, also JARGONELLE [n]\n",
  "JARGONIER": "JARGONY, like jargon [adj]\n",
  "JARGONIEST": "JARGONY, like jargon [adj]\n",
  "JARGONING": "JARGON, to use words specific to a trade or group [v]\n",
  "JARGONISATION": "the process of jargonising, also JARGONIZATION [n -S]\n",
  "JARGONISATIONS": "JARGONISATION, the process of jargonising, also JARGONIZATION [n]\n",
  "JARGONISE": "to express in jargon, also JARGONIZE [v JARGONISED, JARGONISING, JARGONISES]\n",
  "JARGONISED": "JARGONISE, to express in jargon, also JARGONIZE [v]\n",
  "JARGONISES": "JARGONISE, to express in jargon, also JARGONIZE [v]\n",
  "JARGONISH": "of or like jargon [adj]\n",
  "JARGONISING": "JARGONISE, to express in jargon, also JARGONIZE [v]\n",
  "JARGONIST": "a person who uses jargon, also JARGONEER [n -S]\n",
  "JARGONISTIC": "of or like jargon [adj]\n",
  "JARGONISTS": "JARGONIST, a person who uses jargon, also JARGONEER [n]\n",
  "JARGONIZATION": "the process of jargonizing, also JARGONISATION [n -S]\n",
  "JARGONIZATIONS": "JARGONIZATION, the process of jargonizing, also JARGONISATION [n]\n",
  "JARGONIZE": "to express in jargon, also JARGONISE [v JARGONIZED, JARGONIZING, JARGONIZES]\n",
  "JARGONIZED": "JARGONIZE, to express in jargon, also JARGONISE [v]\n",
  "JARGONIZES": "JARGONIZE, to express in jargon, also JARGONISE [v]\n",
  "JARGONIZING": "JARGONIZE, to express in jargon, also JARGONISE [v]\n",
  "JARGONS": "JARGON, to use words specific to a trade or group [v]\n",
  "JARGONY": "like jargon [adj JARGONIER, JARGONIEST]\n",
  "JARGOON": "(French) a brilliant pale or colourless zircon [n -S]\n",
  "JARGOONS": "JARGOON, (French) a brilliant pale or colourless zircon [n]\n",
  "JARHEAD": "an American marine soldier [n -S]\n",
  "JARHEADS": "JARHEAD, an American marine soldier [n]\n",
  "JARINA": "the hard seed of a palm tree [n -S]\n",
  "JARINAS": "JARINA, the hard seed of a palm tree [n]\n",
  "JARK": "a seal on a document; a safe-conduct [n -S]\n",
  "JARKMAN": "(archaic) a vagabond who fabricates counterfeit passes, licenses and certificates for others [n JARKMEN]\n",
  "JARKMEN": "JARKMAN, (archaic) a vagabond who fabricates counterfeit passes, licenses and certificates for others [n]\n",
  "JARKS": "JARK, a seal on a document; a safe-conduct [n]\n",
  "JARL": "(Old Norse) a Scandinavian nobleman [n -S]\n",
  "JARLDOM": "the domain of a jarl [n -S]\n",
  "JARLDOMS": "JARLDOM, the domain of a jarl [n]\n",
  "JARLS": "JARL, (Old Norse) a Scandinavian nobleman [n]\n",
  "JARLSBERG": "(tradename) a Norwegian cheese [n -S]\n",
  "JARLSBERGS": "JARLSBERG, (tradename) a Norwegian cheese [n]\n",
  "JAROOL": "(Bengali) a deciduous tree of the purple loosestrife family, also JARUL [n -S]\n",
  "JAROOLS": "JAROOL, (Bengali) a deciduous tree of the purple loosestrife family, also JARUL [n]\n",
  "JAROSITE": "a sulphate of potassium and iron occurring as yellow or brown crusts on ferruginous ores [n -S]\n",
  "JAROSITES": "JAROSITE, a sulphate of potassium and iron occurring as yellow or brown crusts on ferruginous ores [n]\n",
  "JAROVISE": "to hasten the flowering of a plant, also JAROVIZE [v JAROVISED, JAROVISING, JAROVISES]\n",
  "JAROVISED": "JAROVISE, to hasten the flowering of a plant, also JAROVIZE [v]\n",
  "JAROVISES": "JAROVISE, to hasten the flowering of a plant, also JAROVIZE [v]\n",
  "JAROVISING": "JAROVISE, to hasten the flowering of a plant, also JAROVIZE [v]\n",
  "JAROVIZE": "to hasten the flowering of a plant, also JAROVISE [v JAROVIZED, JAROVIZING, JAROVIZES]\n",
  "JAROVIZED": "JAROVIZE, to hasten the flowering of a plant, also JAROVISE [v]\n",
  "JAROVIZES": "JAROVIZE, to hasten the flowering of a plant, also JAROVISE [v]\n",
  "JAROVIZING": "JAROVIZE, to hasten the flowering of a plant, also JAROVISE [v]\n",
  "JARP": "(dialect) to tap an egg against another until one breaks, an Easter competition [v -ED, -ING, -S]\n",
  "JARPED": "JARP, (dialect) to tap an egg against another until one breaks, an Easter competition [v]\n",
  "JARPING": "JARP, (dialect) to tap an egg against another until one breaks, an Easter competition [v]\n",
  "JARPS": "JARP, (dialect) to tap an egg against another until one breaks, an Easter competition [v]\n",
  "JARRAH": "(Native Australian) the mahogany-like wood of an Australian eucalyptus [n -S]\n",
  "JARRAHS": "JARRAH, (Native Australian) the mahogany-like wood of an Australian eucalyptus [n]\n",
  "JARRED": "JAR, to vibrate from an impact [v]\n",
  "JARRING": "harshly discordant [adj JARRINGLY] / the act of jarring [n -S]\n",
  "JARRINGLY": "JARRING, harshly discordant [adv]\n",
  "JARRINGS": "JARRING, the act of jarring [n]\n",
  "JARS": "JAR, to vibrate from an impact [v]\n",
  "JARSFUL": "JARFUL, as much as a container can hold [n]\n",
  "JARTA": "(Old Norse) heart, used as term of endearment in the Shetlands, also YARTA, YARTO [n -S]\n",
  "JARTAS": "JARTA, (Old Norse) heart, used as term of endearment in the Shetlands, also YARTA, YARTO [n]\n",
  "JARUL": "(Bengali) a deciduous tree of the purple loosestrife family, also JAROOL [n -S]\n",
  "JARULS": "JARUL, (Bengali) a deciduous tree of the purple loosestrife family, also JAROOL [n]\n",
  "JARVEY": "a driver of a horse-drawn taxi, also JARVIE [n -S]\n",
  "JARVEYS": "JARVEY, a driver of a horse-drawn taxi, also JARVIE [n]\n",
  "JARVIE": "a driver of a horse-drawn taxi, also JARVEY [n -S]\n",
  "JARVIES": "JARVIE, a driver of a horse-drawn taxi, also JARVEY [n]\n",
  "JASEY": "a wig of worsted, also JASY, JAZY [n -S]\n",
  "JASEYS": "JASEY, a wig of worsted, also JASY, JAZY [n]\n",
  "JASIES": "JASY, a wig of worsted, also JASEY, JAZY [n]\n",
  "JASMIN": "a genus of oleaceous climbing shrubs, also GESSAMINE, JASMINE, JESSAMINE, JESSAMY [n -S]\n",
  "JASMINE": "a genus of oleaceous climbing shrubs, also GESSAMINE, JASMIN, JESSAMINE, JESSAMY [n -S]\n",
  "JASMINES": "JASMINE, a genus of oleaceous climbing shrubs, also GESSAMINE, JASMIN, JESSAMINE, JESSAMY [n]\n",
  "JASMINS": "JASMIN, a genus of oleaceous climbing shrubs, also GESSAMINE, JASMINE, JESSAMINE, JESSAMY [n]\n",
  "JASMONATE": "any of several organic compounds that occur in plants and are thought to control processes such as growth and fruit ripening and to aid the plant's defences against disease and insect attack [n -S]\n",
  "JASMONATES": "JASMONATE, any of several organic compounds that occur in plants and are thought to control processes such as growth and fruit ripening and to aid the plant's defences against disease and insect attack [n]\n",
  "JASP": "(Spenser) a precious stone, jasper, also JASPIS [n -S]\n",
  "JASPE": "(French) a cotton cloth with a shaded effect [n -S]\n",
  "JASPER": "a red variety of chert, its color coming from minute particles of included hematite, also JASP, JASPIS [n -S]\n",
  "JASPERIER": "JASPERY, of or like jasper, also JASPEROUS, JASPIDEAN, JASPIDEOUS [adj]\n",
  "JASPERIEST": "JASPERY, of or like jasper, also JASPEROUS, JASPIDEAN, JASPIDEOUS [adj]\n",
  "JASPERISE": "to turn into, or cause to resemble, jasper, also JASPERIZE [v JASPERISED, JASPERISING, JASPERISES]\n",
  "JASPERISED": "JASPERISE, to turn into, or cause to resemble, jasper, also JASPERIZE [v]\n",
  "JASPERISES": "JASPERISE, to turn into, or cause to resemble, jasper, also JASPERIZE [v]\n",
  "JASPERISING": "JASPERISE, to turn into, or cause to resemble, jasper, also JASPERIZE [v]\n",
  "JASPERIZE": "to turn into, or cause to resemble, jasper, also JASPERISE [v JASPERIZED, JASPERIZING, JASPERIZES]\n",
  "JASPERIZED": "JASPERIZE, to turn into, or cause to resemble, jasper, also JASPERISE [v]\n",
  "JASPERIZES": "JASPERIZE, to turn into, or cause to resemble, jasper, also JASPERISE [v]\n",
  "JASPERIZING": "JASPERIZE, to turn into, or cause to resemble, jasper, also JASPERISE [v]\n",
  "JASPEROUS": "of or like jasper, also JASPIDEOUS [adj]\n",
  "JASPERS": "JASPER, a red variety of chert, its color coming from minute particles of included hematite, also JASP, JASPIS [n]\n",
  "JASPERWARE": "goods made of jasper [n -S]\n",
  "JASPERWARES": "JASPERWARE, goods made of jasper [n]\n",
  "JASPERY": "of or like jasper, also JASPEROUS, JASPIDEAN, JASPIDEOUS [adj JASPERIER, JASPERIEST]\n",
  "JASPES": "JASPE, (French) a cotton cloth with a shaded effect [n]\n",
  "JASPIDEAN": "consisting of jasper, or containing jasper, also JASPERY, JASPIDEOUS [adj]\n",
  "JASPIDEOUS": "consisting of jasper or containing jasper, also JASPERY, JASPIDEAN [adj]\n",
  "JASPILITE": "a rock like jasper [n -S]\n",
  "JASPILITES": "JASPILITE, a rock like jasper [n]\n",
  "JASPIS": "jasper, also JASP [n -ES]\n",
  "JASPISES": "JASPIS, jasper, also JASP [n]\n",
  "JASPS": "JASP, (Spenser) a precious stone, jasper, also JASPIS [n]\n",
  "JASS": "(obsolete) jazz [n -ES]\n",
  "JASSES": "JASS, (obsolete) jazz [n]\n",
  "JASSID": "an insect of the leafhopper family [n -S]\n",
  "JASSIDS": "JASSID, an insect of the leafhopper family [n]\n",
  "JASY": "a wig of worsted, also JASEY, JAZY [n JASIES]\n",
  "JATAKA": "(Pali) the birth-story of Buddha [n -S]\n",
  "JATAKAS": "JATAKA, (Pali) the birth-story of Buddha [n]\n",
  "JATO": "a jet-assisted take off [n -S]\n",
  "JATOS": "JATO, a jet-assisted take off [n]\n",
  "JATROPHA": "any plant of the genus Jatropha, esp. Jatropha curcas, whose seeds yield an oil that can be used as a biofuel [n -S]\n",
  "JATROPHAS": "JATROPHA, any plant of the genus Jatropha, esp. Jatropha curcas, whose seeds yield an oil that can be used as a biofuel [n]\n",
  "JAUK": "to dawdle [v -ED, -ING, -S]\n",
  "JAUKED": "JAUK, to dawdle [v]\n",
  "JAUKING": "JAUK, to dawdle [v]\n",
  "JAUKS": "JAUK, to dawdle [v]\n",
  "JAUNCE": "to prance, also JAUNSE [v JAUNCED, JAUNCING, JAUNCES]\n",
  "JAUNCED": "JAUNCE, to prance, also JAUNSE [v]\n",
  "JAUNCES": "JAUNCE, to prance, also JAUNSE [v]\n",
  "JAUNCING": "JAUNCE, to prance, also JAUNSE [v]\n",
  "JAUNDICE": "to prejudice unfavourably [v JAUNDICED, JAUNDICING, JAUNDICES]\n",
  "JAUNDICED": "JAUNDICE, to prejudice unfavourably [v]\n",
  "JAUNDICES": "JAUNDICE, to prejudice unfavourably [v]\n",
  "JAUNDICING": "JAUNDICE, to prejudice unfavourably [v]\n",
  "JAUNSE": "to prance, also JAUNCE [v JAUNSED, JAUNSING, JAUNSES]\n",
  "JAUNSED": "JAUNSE, to prance, also JAUNCE [v]\n",
  "JAUNSES": "JAUNSE, to prance, also JAUNCE [v]\n",
  "JAUNSING": "JAUNSE, to prance, also JAUNCE [v]\n",
  "JAUNT": "to go on a pleasure trip [v -ED, -ING, -S]\n",
  "JAUNTED": "JAUNT, to go on a pleasure trip [v]\n",
  "JAUNTEE": "(obsolete) jaunty, sprightly, also JANTEE, JANTY, JAUNTIE, JAUNTY [adj]\n",
  "JAUNTIE": "a naval master-at-arms, also JONTY [n -S]\n",
  "JAUNTIER": "JAUNTY, briskly self-assured, also JANTY, JANTEE, JAUNTEE, JAUNTIE [adj]\n",
  "JAUNTIES": "JAUNTIE, a naval master-at-arms, also JONTY [n]\n",
  "JAUNTIEST": "JAUNTY, briskly self-assured, also JANTY, JANTEE, JAUNTEE, JAUNTIE [adj]\n",
  "JAUNTILY": "JAUNTY, briskly self-assured, also JANTY, JANTEE, JAUNTEE, JAUNTIE [adv]\n",
  "JAUNTINESS": "the state of being jaunty [n -ES]\n",
  "JAUNTINESSES": "JAUNTINESS, the state of being jaunty [n]\n",
  "JAUNTING": "JAUNT, to go on a pleasure trip [v]\n",
  "JAUNTINGLY": "JAUNTING, JAUNT, to go on a pleasure trip [adv]\n",
  "JAUNTS": "JAUNT, to go on a pleasure trip [v]\n",
  "JAUNTY": "briskly self-assured, also JANTY, JANTEE, JAUNTEE, JAUNTIE [adj JAUNTIER, JAUNTIEST, JAUNTILY]\n",
  "JAUP": "(Scots) to splash or spatter, also JAP [v -ED, -ING, -S]\n",
  "JAUPED": "JAUP, (Scots) to splash or spatter, also JAP [v]\n",
  "JAUPING": "JAUP, (Scots) to splash or spatter, also JAP [v]\n",
  "JAUPS": "JAUP, (Scots) to splash or spatter, also JAP [v]\n",
  "JAVA": "a type of coffee [n -S]\n",
  "JAVAS": "JAVA, a type of coffee [n]\n",
  "JAVEL": "(Spenser) a worthless fellow [n -S]\n",
  "JAVELIN": "to pierce with a light spear [v -ED, -ING, -S]\n",
  "JAVELINA": "(Spanish) a wild boar, aka peccary [n -S]\n",
  "JAVELINAS": "JAVELINA, (Spanish) a wild boar, aka peccary [n]\n",
  "JAVELINED": "JAVELIN, to pierce with a light spear [v]\n",
  "JAVELINING": "JAVELIN, to pierce with a light spear [v]\n",
  "JAVELINS": "JAVELIN, to pierce with a light spear [v]\n",
  "JAVELLE": "as in javelle water, an aqueous solution containing sodium hypochlorite and some sodium chloride, used as a bleach and disinfectant [adj]\n",
  "JAVELS": "JAVEL, (Spenser) a worthless fellow [n]\n",
  "JAW": "to chatter at length [v -ED, -ING, -S]\n",
  "JAWAN": "(Urdu) an Indian common soldier [n -S]\n",
  "JAWANS": "JAWAN, (Urdu) an Indian common soldier [n]\n",
  "JAWARI": "(Hindi) Indian millet, aka durra, also JOWAR, JOWARI [n -S]\n",
  "JAWARIS": "JAWARI, (Hindi) Indian millet, aka durra, also JOWAR, JOWARI [n]\n",
  "JAWBATION": "a long, tedious rebuke or harangue, also JOBATION [n -S]\n",
  "JAWBATIONS": "JAWBATION, a long, tedious rebuke or harangue, also JOBATION [n]\n",
  "JAWBONE": "to lecture or scold [v JAWBONED, JAWBONING, JAWBONES]\n",
  "JAWBONED": "JAWBONE, to lecture or scold [v]\n",
  "JAWBONER": "one who engages in jawboning, i.e. governmental urging of industry to accept wage restraints etc. [n -S]\n",
  "JAWBONERS": "JAWBONER, one who engages in jawboning, i.e. governmental urging of industry to accept wage restraints etc. [n]\n",
  "JAWBONES": "JAWBONE, to lecture or scold [v]\n",
  "JAWBONING": "governmental urging of industry to accept wage restraints etc. [n -S]\n",
  "JAWBONINGS": "JAWBONING, governmental urging of industry to accept wage restraints etc. [n]\n",
  "JAWBOX": "(Scots) a sink [n -ES]\n",
  "JAWBOXES": "JAWBOX, (Scots) a sink [n]\n",
  "JAWBREAKER": "a word hard to pronounce [n -S]\n",
  "JAWBREAKERS": "JAWBREAKER, a word hard to pronounce [n]\n",
  "JAWBREAKING": "difficult to pronounce [adj JAWBREAKINGLY]\n",
  "JAWBREAKINGLY": "JAWBREAKING, difficult to pronounce [adv]\n",
  "JAWCRUSHER": "a heavy-duty rock-breaking machine with hinged jaws [n -S]\n",
  "JAWCRUSHERS": "JAWCRUSHER, a heavy-duty rock-breaking machine with hinged jaws [n]\n",
  "JAWED": "JAW, to chatter at length [v]\n",
  "JAWFALL": "a falling of the jaw; a depression of the spirits [n -S]\n",
  "JAWFALLS": "JAWFALL, a falling of the jaw; a depression of the spirits [n]\n",
  "JAWHOLE": "(Scots) a cesspool; a sewer entrance [n -S]\n",
  "JAWHOLES": "JAWHOLE, (Scots) a cesspool; a sewer entrance [n]\n",
  "JAWING": "chattering at length [n -S]\n",
  "JAWINGS": "JAWING, chattering at length [n]\n",
  "JAWLESS": "without a jaw [adj]\n",
  "JAWLIKE": "resembling the framework of the mouth [adj]\n",
  "JAWLINE": "the outline of the lower jaw [n -S]\n",
  "JAWLINES": "JAWLINE, the outline of the lower jaw [n]\n",
  "JAWS": "JAW, to chatter at length [v]\n",
  "JAXIE": "(slang) the posterior, also JAXY, JACKSIE, JACKSY [n -S]\n",
  "JAXIES": "JAXIE, (slang) the posterior, also JAXY, JACKSIE, JACKSY [n]\n",
  "JAXY": "(slang) the posterior, also JAXIE, JACKSIE, JACKSY [n JAXIES]\n",
  "JAY": "a corvine bird, also JAYBIRD [n -S]\n",
  "JAYBIRD": "a corvine bird, also JAY [n -S]\n",
  "JAYBIRDS": "JAYBIRD, a corvine bird, also JAY [n]\n",
  "JAYCEE": "a member of a Junior Chamber of Commerce, an organization that promotes business skills for young people [n -S]\n",
  "JAYCEES": "JAYCEE, a member of a Junior Chamber of Commerce, an organization that promotes business skills for young people [n]\n",
  "JAYGEE": "a military officer [n -S]\n",
  "JAYGEES": "JAYGEE, a military officer [n]\n",
  "JAYHAWKER": "a name given to a freebooting, un-enlisted, armed man or guerrilla in the American Civil War [n -S]\n",
  "JAYHAWKERS": "JAYHAWKER, a name given to a freebooting, un-enlisted, armed man or guerrilla in the American Civil War [n]\n",
  "JAYS": "JAY, a corvine bird, also JAYBIRD [n]\n",
  "JAYVEE": "a junior varsity player [n -S]\n",
  "JAYVEES": "JAYVEE, a junior varsity player [n]\n",
  "JAYWALK": "to cross a street carelessly [v -ED, -ING, -S]\n",
  "JAYWALKED": "JAYWALK, to cross a street carelessly [v]\n",
  "JAYWALKER": "one who walks in the road rather than on the pavement [n -S]\n",
  "JAYWALKERS": "JAYWALKER, one who walks in the road rather than on the pavement [n]\n",
  "JAYWALKING": "walking in the road rather than on the pavement [n -S]\n",
  "JAYWALKINGS": "JAYWALKING, walking in the road rather than on the pavement [n]\n",
  "JAYWALKS": "JAYWALK, to cross a street carelessly [v]\n",
  "JAZERANT": "(historical) a coat of mail made of small plates of metal sewed upon linen or the like, also JESSERANT [n -S]\n",
  "JAZERANTS": "JAZERANT, (historical) a coat of mail made of small plates of metal sewed upon linen or the like, also JESSERANT [n]\n",
  "JAZIES": "JAZY, a wig, also JASEY, JASY [n]\n",
  "JAZY": "a wig, also JASEY, JASY [n JAZIES]\n",
  "JAZZ": "to liven up the beat of [v -ED, -ING, -ES]\n",
  "JAZZBO": "a devotee of jazz (a style of lively syncopated music) [n -S]\n",
  "JAZZBOS": "JAZZBO, a devotee of jazz (a style of lively syncopated music) [n]\n",
  "JAZZED": "JAZZ, to liven up the beat of [v]\n",
  "JAZZER": "a jazz musician [n -S]\n",
  "JAZZERS": "JAZZER, a jazz musician [n]\n",
  "JAZZES": "JAZZ, to liven up the beat of [v]\n",
  "JAZZIER": "JAZZY, of or like jazz, noisy, garish [adj]\n",
  "JAZZIEST": "JAZZY, of or like jazz, noisy, garish [adj]\n",
  "JAZZILY": "JAZZY, of or like jazz, noisy, garish [adv]\n",
  "JAZZINESS": "the state of being jazzy [n -ES]\n",
  "JAZZINESSES": "JAZZINESS, the state of being jazzy [n]\n",
  "JAZZING": "JAZZ, to liven up the beat of [v]\n",
  "JAZZLIKE": "resembling a type of music [adj]\n",
  "JAZZMAN": "a musician who plays jazz [n JAZZMEN]\n",
  "JAZZMEN": "JAZZMAN, a musician who plays jazz [n]\n",
  "JAZZY": "of or like jazz, noisy, garish [adj JAZZIER, JAZZIEST, JAZZILY]\n",
  "JEALOUS": "resentful of another's advantages, also GEALOUS [adj JEALOUSER, JEALOUSEST; JEALOUSLY]\n",
  "JEALOUSE": "(Scots) to suspect, also JALOUSE [v JEALOUSED, JEALOUSING, JEALOUSES]\n",
  "JEALOUSED": "JEALOUSE, (Scots) to suspect, also JALOUSE [v]\n",
  "JEALOUSER": "JEALOUS, resentful of another's advantages, also GEALOUS [adj]\n",
  "JEALOUSES": "JEALOUSE, (Scots) to suspect, also JALOUSE [v]\n",
  "JEALOUSEST": "JEALOUS, resentful of another's advantages, also GEALOUS [adj]\n",
  "JEALOUSHOOD": "(Shakespeare) jealousy [n -S]\n",
  "JEALOUSHOODS": "JEALOUSHOOD, (Shakespeare) jealousy [n]\n",
  "JEALOUSIES": "JEALOUSY, a jealous feeling, also GEALOUSY, GELOSY [n]\n",
  "JEALOUSING": "JEALOUSE, (Scots) to suspect, also JALOUSE [v]\n",
  "JEALOUSLY": "JEALOUS, resentful of another's advantages, also GEALOUS [adv]\n",
  "JEALOUSNESS": "the state of being jealous [n -ES]\n",
  "JEALOUSNESSES": "JEALOUSNESS, the state of being jealous [n]\n",
  "JEALOUSY": "a jealous feeling, also GEALOUSY, GELOSY [n JEALOUSIES]\n",
  "JEAN": "a durable cotton fabric [n -S]\n",
  "JEANED": "wearing jeans [adj]\n",
  "JEANETTE": "a light or coarse jean, a twilled cotton cloth [n -S]\n",
  "JEANETTES": "JEANETTE, a light or coarse jean, a twilled cotton cloth [n]\n",
  "JEANS": "JEAN, a durable cotton fabric [n]\n",
  "JEANSWEAR": "clothing made from denim [n -S]\n",
  "JEANSWEARS": "JEANSWEAR, clothing made from denim [n]\n",
  "JEAT": "(obsolete) jet, the mineral [n -S]\n",
  "JEATS": "JEAT, (obsolete) jet, the mineral [n]\n",
  "JEBEL": "(Arabic) a hill, a range of mountains, also DJEBEL [n -S]\n",
  "JEBELS": "JEBEL, (Arabic) a hill, a range of mountains, also DJEBEL [n]\n",
  "JEDI": "(tradename) a person who claims to live according to a philosophy based on that of the fictional Jedi in 'Star Wars' [n -S]\n",
  "JEDIS": "JEDI, (tradename) a person who claims to live according to a philosophy based on that of the fictional Jedi in 'Star Wars' [n]\n",
  "JEE": "of horses, to urge on, also GEE [v JEED, JEEING, JEES]\n",
  "JEED": "JEE, of horses, to urge on, also GEE [v]\n",
  "JEEING": "JEE, of horses, to urge on, also GEE [v]\n",
  "JEEL": "(Scots) extreme cold; jelly [n -S] / to set, jell, also JEELIE, JEELY [v -ED, -ING, -S]\n",
  "JEELED": "JEEL, to set, jell, also JEELIE, JEELY [v]\n",
  "JEELIE": "(Scots) to make into a jelly, also JELLY, JEELY [v JEELIED, JEELIEING, JEELIES]\n",
  "JEELIED": "JEELIE, (Scots) to make into a jelly, also JELLY, JEELY [v]\n",
  "JEELIEING": "JEELIE, (Scots) to make into a jelly, also JELLY, JEELY [v]\n",
  "JEELIES": "JEELIE, (Scots) to make into a jelly, also JELLY, JEELY [v]\n",
  "JEELING": "JEEL, to set, jell, also JEELIE, JEELY [v]\n",
  "JEELS": "JEEL, to set, jell, also JEELIE, JEELY [v]\n",
  "JEELY": "(Scots) to make into a jelly, also JELLY, JEELIE [v JEELIED, JEELYING, JEELIES]\n",
  "JEELYING": "JEELY, (Scots) to make into a jelly, also JELLY, JEELIE [v]\n",
  "JEEP": "to travel by a four wheeled drive vehicle [v -ED, -ING, -S]\n",
  "JEEPED": "JEEP, to travel by a four wheeled drive vehicle [v]\n",
  "JEEPERS": "used as a mild oath [interj]\n",
  "JEEPING": "JEEP, to travel by a four wheeled drive vehicle [v]\n",
  "JEEPNEY": "in the Philippines, a small vehicle constructed from a jeep [n -S]\n",
  "JEEPNEYS": "JEEPNEY, in the Philippines, a small vehicle constructed from a jeep [n]\n",
  "JEEPS": "JEEP, to travel by a four wheeled drive vehicle [v]\n",
  "JEER": "to mock, also GEARE [v -ED, -ING, -S]\n",
  "JEERED": "JEER, to mock, also GEARE [v]\n",
  "JEERER": "one who jeers [n -S]\n",
  "JEERERS": "JEERER, one who jeers [n]\n",
  "JEERING": "mocking [adj JEERINGLY] / the act of jeering [n -S]\n",
  "JEERINGLY": "JEERING, mocking [adv]\n",
  "JEERINGS": "JEERING, the act of jeering [n]\n",
  "JEERS": "JEER, to mock, also GEARE [v]\n",
  "JEES": "JEE, of horses, to urge on, also GEE [v]\n",
  "JEESLY": "used as an intensifier, also JEEZELY, JEEZLY [adj]\n",
  "JEEZ": "an interjection expressing consternation, also GEEZ, JEEZE [interj]\n",
  "JEEZE": "an interjection expressing consternation, also GEEZ, JEEZ [interj]\n",
  "JEEZELY": "used as an intensifier, also JEESLY, JEEZLY [adj]\n",
  "JEEZLY": "used as an intensifier, also JEESLY, JEEZELY [adj]\n",
  "JEFE": "(Spanish) a chief [n -S]\n",
  "JEFES": "JEFE, (Spanish) a chief [n]\n",
  "JEFF": "(Australian slang) to spoil or destroy ruthlessly [v JEFFED, JEFFING, JEFFS]\n",
  "JEFFED": "JEFF, (Australian slang) to spoil or destroy ruthlessly [v]\n",
  "JEFFING": "JEFF, (Australian slang) to spoil or destroy ruthlessly [v]\n",
  "JEFFS": "JEFF, (Australian slang) to spoil or destroy ruthlessly [v]\n",
  "JEGGINGS": "tight-fitting trousers in a lightweight fabric with the colour and appearance of denim [n]\n",
  "JEHAD": "(Arabic) in Islam, a holy war, also JIHAD [n -S]\n",
  "JEHADEEN": "Islamic freedom fighters, also JIHADEEN [n]\n",
  "JEHADI": "(Arabic) one who takes part in a jehad, also JIHADI, JEHADIST, JIHADIST [n -S]\n",
  "JEHADIS": "JEHADI, (Arabic) one who takes part in a jehad, also JIHADI, JEHADIST, JIHADIST [n]\n",
  "JEHADISM": "promotion of jehad, also JIHADISM [n -S]\n",
  "JEHADISMS": "JEHADISM, promotion of jehad, also JIHADISM [n]\n",
  "JEHADIST": "one who takes part in a jehad, also JEHADI, JIHADI, JIHADIST [n -S]\n",
  "JEHADISTS": "JEHADIST, one who takes part in a jehad, also JEHADI, JIHADI, JIHADIST [n]\n",
  "JEHADS": "JEHAD, (Arabic) in Islam, a holy war, also JIHAD [n]\n",
  "JEHU": "a coachman, esp. one who drives at a rattling pace [n -S]\n",
  "JEHUS": "JEHU, a coachman, esp. one who drives at a rattling pace [n]\n",
  "JEISTIECOR": "(Scots) a close-fitting garment [n -S]\n",
  "JEISTIECORS": "JEISTIECOR, (Scots) a close-fitting garment [n]\n",
  "JEJUNA": "JEJUNUM, (Latin) the middle division of the small intestine, between the duodenum and ileum [n]\n",
  "JEJUNAL": "pertaining to the jejunum [adj]\n",
  "JEJUNE": "lacking interest or significance; dull or insipid [adj JEJUNELY]\n",
  "JEJUNELY": "JEJUNE, lacking interest or significance; dull or insipid [adv]\n",
  "JEJUNENESS": "the quality of being jejune [n -ES]\n",
  "JEJUNENESSES": "JEJUNENESS, the quality of being jejune [n]\n",
  "JEJUNITIES": "JEJUNITY, something that is naive [n]\n",
  "JEJUNITY": "something that is naive [n JEJUNITIES]\n",
  "JEJUNOSTOMIES": "JEJUNOSTOMY, surgical excision of the jejunum [n]\n",
  "JEJUNOSTOMY": "surgical excision of the jejunum [n JEJUNOSTOMIES]\n",
  "JEJUNUM": "(Latin) the middle division of the small intestine, between the duodenum and ileum [n JEJUNA or JEJUNUMS]\n",
  "JEJUNUMS": "JEJUNUM, (Latin) the middle division of the small intestine, between the duodenum and ileum [n]\n",
  "JELAB": "(Arabic) a Middle Eastern hooded cloak, also DJELLABA, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABIA, JELLABA, JELLABAH [n -S]\n",
  "JELABS": "JELAB, (Arabic) a Middle Eastern hooded cloak, also DJELLABA, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABIA, JELLABA, JELLABAH [n]\n",
  "JELL": "to set like jelly [v -ED, -ING, -S]\n",
  "JELLABA": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABAH [n -S]\n",
  "JELLABAH": "an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA [n -S]\n",
  "JELLABAHS": "JELLABAH, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABA [n]\n",
  "JELLABAS": "JELLABA, an Arab cloak with a hood and wide sleeves, also DJELLABA, DJELLABAH, GALABEA, GALABEAH, GALABIA, GALABIAH, GALABIEH, GALABIYA, GALABIYAH, GALLABEA, GALLABEAH, GALLABIA, GALLABIAH, GALLABIEH, GALLABIYA, GALLABIYAH, GALLABIYEH, JELAB, JELLABAH [n]\n",
  "JELLED": "JELL, to set like jelly [v]\n",
  "JELLIED": "JELLY, to make into a jelly, also JEELIE, JEELY [v]\n",
  "JELLIES": "JELLY, to make into a jelly, also JEELIE, JEELY [v]\n",
  "JELLIFICATION": "the act of jellifying [n -S]\n",
  "JELLIFICATIONS": "JELLIFICATION, the act of jellifying [n]\n",
  "JELLIFIED": "JELLIFY, to turn to jelly [v]\n",
  "JELLIFIES": "JELLIFY, to turn to jelly [v]\n",
  "JELLIFY": "to turn to jelly [v JELLIFIED, JELLIFYING, JELLIFIES]\n",
  "JELLIFYING": "JELLIFY, to turn to jelly [v]\n",
  "JELLING": "JELL, to set like jelly [v]\n",
  "JELLO": "(tradename) a dessert made from flavoured gelatine [n -S]\n",
  "JELLOS": "JELLO, (tradename) a dessert made from flavoured gelatine [n]\n",
  "JELLS": "JELL, to set like jelly [v]\n",
  "JELLY": "to make into a jelly, also JEELIE, JEELY [v JELLIED, JELLYING, JELLIES]\n",
  "JELLYBEAN": "a bean-shaped sweet with a brightly coloured coating around a gelatinous filling [n -S]\n",
  "JELLYBEANS": "JELLYBEAN, a bean-shaped sweet with a brightly coloured coating around a gelatinous filling [n]\n",
  "JELLYFISH": "a marine coelenterate with jellylike body [n -ES]\n",
  "JELLYFISHES": "JELLYFISH, a marine coelenterate with jellylike body [n]\n",
  "JELLYGRAPH": "to copy by jellygraph, an old device for copying that used a plate of jelly [v -ED, -ING, -S]\n",
  "JELLYGRAPHED": "JELLYGRAPH, to copy by jellygraph, an old device for copying that used a plate of jelly [v]\n",
  "JELLYGRAPHING": "JELLYGRAPH, to copy by jellygraph, an old device for copying that used a plate of jelly [v]\n",
  "JELLYGRAPHS": "JELLYGRAPH, to copy by jellygraph, an old device for copying that used a plate of jelly [v]\n",
  "JELLYING": "JELLY, to make into a jelly, also JEELIE, JEELY [v]\n",
  "JELLYLIKE": "like a jelly [adj]\n",
  "JELLYROLL": "a type of cake [n -S]\n",
  "JELLYROLLS": "JELLYROLL, a type of cake [n]\n",
  "JELUTONG": "(Malay) a naturally occurring rubberlike substance, aka pontianak [n -S]\n",
  "JELUTONGS": "JELUTONG, (Malay) a naturally occurring rubberlike substance, aka pontianak [n]\n",
  "JEMADAR": "(Urdu) in the native army of India, an officer of a rank corresponding to that of lieutenant in the English army, also JAMADAR, JEMIDAR [n -S]\n",
  "JEMADARS": "JEMADAR, (Urdu) in the native army of India, an officer of a rank corresponding to that of lieutenant in the English army, also JAMADAR, JEMIDAR [n]\n",
  "JEMBE": "(Swahili) a hoe [n -S]\n",
  "JEMBES": "JEMBE, (Swahili) a hoe [n]\n",
  "JEMIDAR": "(Urdu) in the native army of India, an officer of a rank corresponding to that of lieutenant in the English army, also JAMADAR, JEMADAR [n -S]\n",
  "JEMIDARS": "JEMIDAR, (Urdu) in the native army of India, an officer of a rank corresponding to that of lieutenant in the English army, also JAMADAR, JEMADAR [n]\n",
  "JEMIMA": "an elastic-sided boot [n -S]\n",
  "JEMIMAS": "JEMIMA, an elastic-sided boot [n]\n",
  "JEMMIED": "JEMMY, to force open with a short crowbar, also JIMMIE, JIMMY [v]\n",
  "JEMMIER": "JEMMY, neat, smart [adj]\n",
  "JEMMIES": "JEMMY, to force open with a short crowbar, also JIMMIE, JIMMY [v]\n",
  "JEMMIEST": "JEMMY, neat, smart [adj]\n",
  "JEMMINESS": "spruceness [n -ES]\n",
  "JEMMINESSES": "JEMMINESS, spruceness [n]\n",
  "JEMMY": "neat, smart [adj JEMMIER, JEMMIEST] / to force open with a short crowbar, also JIMMIE, JIMMY [v JEMMIED, JEMMYING, JEMMIES]\n",
  "JEMMYING": "JEMMY, to force open with a short crowbar, also JIMMIE, JIMMY [v]\n",
  "JENNET": "a small Spanish horse, a jenny donkey, also GENET, GENETTE, GENNET [n -S]\n",
  "JENNETING": "an early type of apple, also JUNEATING [n -S]\n",
  "JENNETINGS": "JENNETING, an early type of apple, also JUNEATING [n]\n",
  "JENNETS": "JENNET, a small Spanish horse, a jenny donkey, also GENET, GENETTE, GENNET [n]\n",
  "JENNIES": "JENNY, a female donkey [n]\n",
  "JENNY": "a female donkey [n JENNIES]\n",
  "JEOFAIL": "(obsolete) an omission or oversight in a law proceeding [n -S]\n",
  "JEOFAILS": "JEOFAIL, (obsolete) an omission or oversight in a law proceeding [n]\n",
  "JEON": "(Korean) a monetary unit of South Korea, also CHON [n -S]\n",
  "JEONS": "JEON, (Korean) a monetary unit of South Korea, also CHON [n]\n",
  "JEOPARD": "to put in jeopardy; to imperil [v -ED, -ING, -S]\n",
  "JEOPARDED": "JEOPARD, to put in jeopardy; to imperil [v]\n",
  "JEOPARDER": "one who puts in jeopardy [n -S]\n",
  "JEOPARDERS": "JEOPARDER, one who puts in jeopardy [n]\n",
  "JEOPARDIED": "JEOPARDY, to put into jeopardy [v]\n",
  "JEOPARDIES": "JEOPARDY, to put into jeopardy [v]\n",
  "JEOPARDING": "JEOPARD, to put in jeopardy; to imperil [v]\n",
  "JEOPARDISE": "to expose to loss or injury, also JEOPARDIZE [v JEOPARDISED, JEOPARDISING, JEOPARDISES]\n",
  "JEOPARDISED": "JEOPARDISE, to expose to loss or injury, also JEOPARDIZE [v]\n",
  "JEOPARDISES": "JEOPARDISE, to expose to loss or injury, also JEOPARDIZE [v]\n",
  "JEOPARDISING": "JEOPARDISE, to expose to loss or injury, also JEOPARDIZE [v]\n",
  "JEOPARDIZE": "to expose to loss or injury, also JEOPARDISE [v JEOPARDIZED, JEOPARDIZING, JEOPARDIZES]\n",
  "JEOPARDIZED": "JEOPARDIZE, to expose to loss or injury, also JEOPARDISE [v]\n",
  "JEOPARDIZES": "JEOPARDIZE, to expose to loss or injury, also JEOPARDISE [v]\n",
  "JEOPARDIZING": "JEOPARDIZE, to expose to loss or injury, also JEOPARDISE [v]\n",
  "JEOPARDOUS": "(obsolete) perilous; hazardous [adj JEOPARDOUSLY]\n",
  "JEOPARDOUSLY": "JEOPARDOUS, (obsolete) perilous; hazardous [adv]\n",
  "JEOPARDS": "JEOPARD, to put in jeopardy; to imperil [v]\n",
  "JEOPARDY": "a hazard or danger [n JEOPARDIES] / to put into jeopardy [v JEOPARDIED, JEOPARDYING, JEOPARDIES]\n",
  "JEOPARDYING": "JEOPARDY, to put into jeopardy [v]\n",
  "JEQUERITIES": "JEQUERITY, the tropical shrub Indian liquorice, also JEQUIRITY [n]\n",
  "JEQUERITY": "the tropical shrub Indian liquorice, also JEQUIRITY [n JEQUERITIES]\n",
  "JEQUIRITIES": "JEQUIRITY, the tropical shrub Indian liquorice, also JEQUERITY [n]\n",
  "JEQUIRITY": "the tropical shrub Indian liquorice, also JEQUERITY [n JEQUIRITIES]\n",
  "JERBIL": "(French) a desert rodent, also GERBIL, GERBILLE [n -S]\n",
  "JERBILS": "JERBIL, (French) a desert rodent, also GERBIL, GERBILLE [n]\n",
  "JERBOA": "(Arabic) a desert rodent that jumps on long legs like a kangaroo [n -S]\n",
  "JERBOAS": "JERBOA, (Arabic) a desert rodent that jumps on long legs like a kangaroo [n]\n",
  "JEREED": "(Arabic) a wooden Oriental javelin, also JERID, JERREED, JERRID [n -S]\n",
  "JEREEDS": "JEREED, (Arabic) a wooden Oriental javelin, also JERID, JERREED, JERRID [n]\n",
  "JEREMIAD": "a literary work or speech expressing a bitter lament or a righteous prophecy of doom [n -S]\n",
  "JEREMIADS": "JEREMIAD, a literary work or speech expressing a bitter lament or a righteous prophecy of doom [n]\n",
  "JEREPIGO": "(Portuguese) a sweet fortified wine similar to port, also GEROPIGA [n -S]\n",
  "JEREPIGOS": "JEREPIGO, (Portuguese) a sweet fortified wine similar to port, also GEROPIGA [n]\n",
  "JERFALCON": "a heavy, powerful falcon of cold northerly regions, also GERFALCON, GYRFALCON [n -S]\n",
  "JERFALCONS": "JERFALCON, a heavy, powerful falcon of cold northerly regions, also GERFALCON, GYRFALCON [n]\n",
  "JERID": "(Arabic) a wooden Oriental javelin, also JEREED, JERREED, JERRID [n -S]\n",
  "JERIDS": "JERID, (Arabic) a wooden Oriental javelin, also JEREED, JERREED, JERRID [n]\n",
  "JERK": "to move spasmodically [v -ED, -ING, -S]\n",
  "JERKED": "JERK, to move spasmodically [v]\n",
  "JERKER": "(US) a kind of fish, aka hornyhead [n -S]\n",
  "JERKERS": "JERKER, (US) a kind of fish, aka hornyhead [n]\n",
  "JERKIER": "JERKY, spasmodic [adj]\n",
  "JERKIES": "JERKY, dried meat [n]\n",
  "JERKIEST": "JERKY, spasmodic [adj]\n",
  "JERKILY": "JERKY, spasmodic [adv]\n",
  "JERKIN": "a kind of jacket [n -S]\n",
  "JERKINESS": "the state of being jerky [n -ES]\n",
  "JERKINESSES": "JERKINESS, the state of being jerky [n]\n",
  "JERKING": "jerky [adj JERKINGLY] / the act of jerking [n -S]\n",
  "JERKINGLY": "JERKING, jerky [adv]\n",
  "JERKINGS": "JERKING, the act of jerking [n]\n",
  "JERKINHEAD": "a truncated gable with a lipped roof [n -S]\n",
  "JERKINHEADS": "JERKINHEAD, a truncated gable with a lipped roof [n]\n",
  "JERKINS": "JERKIN, a kind of jacket [n]\n",
  "JERKS": "JERK, to move spasmodically [v]\n",
  "JERKWATER": "not on a branch line, hick, insignificant [adj] / a train on a branch line [n -S]\n",
  "JERKWATERS": "JERKWATER, a train on a branch line [n]\n",
  "JERKY": "dried meat [n JERKIES] / spasmodic [adj JERKIER, JERKIEST, JERKILY]\n",
  "JEROBOAM": "an oversize wine bottle holding about four 26-ounce quarts [n -S]\n",
  "JEROBOAMS": "JEROBOAM, an oversize wine bottle holding about four 26-ounce quarts [n]\n",
  "JERQUE": "to search a vessel for contraband [v JERQUED, JERQUING, JERQUES]\n",
  "JERQUED": "JERQUE, to search a vessel for contraband [v]\n",
  "JERQUER": "one who searches for contraband, also JERKER [n -S]\n",
  "JERQUERS": "JERQUER, one who searches for contraband, also JERKER [n]\n",
  "JERQUES": "JERQUE, to search a vessel for contraband [v]\n",
  "JERQUING": "a search for contraband, also JERKING [n -S]\n",
  "JERQUINGS": "JERQUING, a search for contraband, also JERKING [n]\n",
  "JERREED": "(Arabic) a wooden Oriental javelin, also JEREED, JERID, JERRID [n -S]\n",
  "JERREEDS": "JERREED, (Arabic) a wooden Oriental javelin, also JEREED, JERID, JERRID [n]\n",
  "JERRICAN": "a fuel container, also JERRYCAN [n -S]\n",
  "JERRICANS": "JERRICAN, a fuel container, also JERRYCAN [n]\n",
  "JERRID": "(Arabic) a wooden Oriental javelin, also JEREED, JERID, JERREED [n -S]\n",
  "JERRIDS": "JERRID, (Arabic) a wooden Oriental javelin, also JEREED, JERID, JERREED [n]\n",
  "JERRIES": "JERRY, (colloquial) a chamberpot [n]\n",
  "JERRY": "(colloquial) a chamberpot [n JERRIES]\n",
  "JERRYCAN": "a fuel container, also JERRICAN [n -S]\n",
  "JERRYCANS": "JERRYCAN, a fuel container, also JERRICAN [n]\n",
  "JERRYMANDER": "to rearrange (voting districts) in the interests of a particular party or candidate, also GERRYMANDER [v -ED, -ING, -S]\n",
  "JERRYMANDERED": "JERRYMANDER, to rearrange (voting districts) in the interests of a particular party or candidate, also GERRYMANDER [v]\n",
  "JERRYMANDERING": "JERRYMANDER, to rearrange (voting districts) in the interests of a particular party or candidate, also GERRYMANDER [v]\n",
  "JERRYMANDERS": "JERRYMANDER, to rearrange (voting districts) in the interests of a particular party or candidate, also GERRYMANDER [v]\n",
  "JERSEY": "a knitted shirt [n -S]\n",
  "JERSEYED": "wearing a jersey [adj]\n",
  "JERSEYS": "JERSEY, a knitted shirt [n]\n",
  "JESS": "to fasten straps to a hawk's legs, also JESSE [v -ED, -ING, -ES]\n",
  "JESSAMIES": "JESSAMY, (obsolete) jasmine, also GESSAMINE, JASMIN, JASMINE, JESSAMINE [n]\n",
  "JESSAMINE": "a genus of oleaceous shrubs, also GESSAMINE, JASMIN, JASMINE, JESSAMY [n -S]\n",
  "JESSAMINES": "JESSAMINE, a genus of oleaceous shrubs, also GESSAMINE, JASMIN, JASMINE, JESSAMY [n]\n",
  "JESSAMY": "(obsolete) jasmine, also GESSAMINE, JASMIN, JASMINE, JESSAMINE [n JESSAMIES]\n",
  "JESSANT": "in heraldry, shooting from the earth [adj]\n",
  "JESSE": "to fasten straps to a hawk's legs, also JESS [v JESSED, JESSING, JESSES]\n",
  "JESSED": "JESSE, to fasten straps to a hawk's legs, also JESS [v]\n",
  "JESSERANT": "(historical) a coat of mail made of small plates of metal sewed upon linen or the like, also JAZERANT [n -S]\n",
  "JESSERANTS": "JESSERANT, (historical) a coat of mail made of small plates of metal sewed upon linen or the like, also JAZERANT [n]\n",
  "JESSES": "JESSE, to fasten straps to a hawk's legs, also JESS [v]\n",
  "JESSIE": "(Scots) an effeminate man [n -S]\n",
  "JESSIES": "JESSIE, (Scots) an effeminate man [n]\n",
  "JESSING": "JESSE, to fasten straps to a hawk's legs, also JESS [v]\n",
  "JEST": "to joke [v -ED, -ING, -S]\n",
  "JESTBOOK": "a collection of funny stories [n -S]\n",
  "JESTBOOKS": "JESTBOOK, a collection of funny stories [n]\n",
  "JESTED": "JEST, to joke [v]\n",
  "JESTEE": "the object of a jest [n -S]\n",
  "JESTEES": "JESTEE, the object of a jest [n]\n",
  "JESTER": "one that jests [n -S]\n",
  "JESTERS": "JESTER, one that jests [n]\n",
  "JESTFUL": "given to jesting [adj]\n",
  "JESTING": "the act of one who jests [n -S]\n",
  "JESTINGLY": "JESTING [adv]\n",
  "JESTINGS": "JESTING, the act of one who jests [n]\n",
  "JESTS": "JEST, to joke [v]\n",
  "JESUIT": "an intriguer, a prevaricator [n -S]\n",
  "JESUITIC": "cunning; quibbling, also JESUITICAL [adj JESUITICALLY]\n",
  "JESUITICAL": "cunning; quibbling, also JESUITIC [adj JESUITICALLY]\n",
  "JESUITICALLY": "JESUITICAL, cunning; quibbling, also JESUITIC [adv]\n",
  "JESUITISM": "subtle argument, also JESUITRY [n -S]\n",
  "JESUITISMS": "JESUITISM, subtle argument, also JESUITRY [n]\n",
  "JESUITRIES": "JESUITRY, an unethical practice [n]\n",
  "JESUITRY": "an unethical practice [n JESUITRIES]\n",
  "JESUITS": "JESUIT, an intriguer, a prevaricator [n]\n",
  "JESUS": "a size of paper in France [n JESUS]\n",
  "JET": "to spurt forth in a stream [v JETTED, JETTING, JETS]\n",
  "JETBEAD": "an ornamental shrub [n -S]\n",
  "JETBEADS": "JETBEAD, an ornamental shrub [n]\n",
  "JETE": "a ballet leap [n -S]\n",
  "JETES": "JETE, a ballet leap [n]\n",
  "JETFOIL": "a hydrofoil powered by a jet of water [n -S]\n",
  "JETFOILS": "JETFOIL, a hydrofoil powered by a jet of water [n]\n",
  "JETLAG": "the disruption of body rhythms after a flight through several time zones [n -S]\n",
  "JETLAGS": "JETLAG, the disruption of body rhythms after a flight through several time zones [n]\n",
  "JETLIKE": "resembling a jet aeroplane [adj]\n",
  "JETLINER": "a plane powered by jet engines [n -S]\n",
  "JETLINERS": "JETLINER, a plane powered by jet engines [n]\n",
  "JETON": "(French) a piece of metal used as a counter, also JETTON [n -S]\n",
  "JETONS": "JETON, (French) a piece of metal used as a counter, also JETTON [n]\n",
  "JETPACK": "a backpack with jets used for transport [n -S]\n",
  "JETPACKS": "JETPACK, a backpack with jets used for transport [n]\n",
  "JETPORT": "an airport for jets [n -S]\n",
  "JETPORTS": "JETPORT, an airport for jets [n]\n",
  "JETS": "JET, to spurt forth in a stream [v]\n",
  "JETSAM": "stuff thrown overboard to lighten the load in time of distress which sinks or is washed ashore, also JETSOM, JETSON [n -S]\n",
  "JETSAMS": "JETSAM, stuff thrown overboard to lighten the load in time of distress which sinks or is washed ashore, also JETSOM, JETSON [n]\n",
  "JETSOM": "(archaic) jetsam, also JETSON [n -S]\n",
  "JETSOMS": "JETSOM, (archaic) jetsam, also JETSON [n]\n",
  "JETSON": "(archaic) jetsam, also JETSOM [n -S]\n",
  "JETSONS": "JETSON, (archaic) jetsam, also JETSOM [n]\n",
  "JETSTREAM": "a narrow belt of high-altitude winds moving east at high speeds and having an important effect on frontogenesis [n -S]\n",
  "JETSTREAMS": "JETSTREAM, a narrow belt of high-altitude winds moving east at high speeds and having an important effect on frontogenesis [n]\n",
  "JETTATURA": "(Italian) the evil eye [n -S]\n",
  "JETTATURAS": "JETTATURA, (Italian) the evil eye [n]\n",
  "JETTED": "JET, to spurt forth in a stream [v]\n",
  "JETTIED": "JETTY, to jut out, also JUTTY [v]\n",
  "JETTIER": "JETTY, jet black in colour [adj]\n",
  "JETTIES": "JETTY, to jut out, also JUTTY [v]\n",
  "JETTIEST": "JETTY, jet black in colour [adj]\n",
  "JETTINESS": "the state of being jetty; blackness [n -ES]\n",
  "JETTINESSES": "JETTINESS, the state of being jetty; blackness [n]\n",
  "JETTING": "JET, to spurt forth in a stream [v]\n",
  "JETTISON": "to throw overboard [v -ED, -ING, -S]\n",
  "JETTISONABLE": "capable of being jettisoned [adj]\n",
  "JETTISONED": "JETTISON, to throw overboard [v]\n",
  "JETTISONING": "JETTISON, to throw overboard [v]\n",
  "JETTISONS": "JETTISON, to throw overboard [v]\n",
  "JETTON": "(French) a piece of metal used as a counter, also JETON [n -S]\n",
  "JETTONS": "JETTON, (French) a piece of metal used as a counter, also JETON [n]\n",
  "JETTY": "to jut out, also JUTTY [v JETTIED, JETTYING, JETTIES] / jet black in colour [adj JETTIER, JETTIEST]\n",
  "JETTYING": "JETTY, to jut out, also JUTTY [v]\n",
  "JETWAY": "a telescoping corridor that extends from an airport terminal to an aircraft [n -S]\n",
  "JETWAYS": "JETWAY, a telescoping corridor that extends from an airport terminal to an aircraft [n]\n",
  "JEU": "(French) a game [n JEUX]\n",
  "JEUNE": "(French) young [adj]\n",
  "JEUX": "JEU, (French) a game [n]\n",
  "JEW": "(offensive) to barter successfully [v -ED, -ING, -S]\n",
  "JEWED": "JEW, (offensive) to barter successfully [v]\n",
  "JEWEL": "to adorn with precious stones [v JEWELED or JEWELLED, JEWELING or JEWELLING, JEWELS]\n",
  "JEWELED": "JEWEL, to adorn with precious stones [v]\n",
  "JEWELER": "a trader or maker of jewelry, also JEWELLER [n -S]\n",
  "JEWELERS": "JEWELER, a trader or maker of jewelry, also JEWELLER [n]\n",
  "JEWELFISH": "a brightly-coloured African cichlid [n -ES]\n",
  "JEWELFISHES": "JEWELFISH, a brightly-coloured African cichlid [n]\n",
  "JEWELING": "JEWEL, to adorn with precious stones [v]\n",
  "JEWELLED": "JEWEL, to adorn with precious stones [v]\n",
  "JEWELLER": "a trader or maker of jewelry, also JEWELER [n -S]\n",
  "JEWELLERIES": "JEWELLERY, jewels in general, also JEWELRY [n]\n",
  "JEWELLERS": "JEWELLER, a trader or maker of jewelry, also JEWELER [n]\n",
  "JEWELLERY": "jewels in general, also JEWELRY [n JEWELLERIES]\n",
  "JEWELLIKE": "like a jewel [adj]\n",
  "JEWELLING": "JEWEL, to adorn with precious stones [v]\n",
  "JEWELRIES": "JEWELRY, jewels in general [n]\n",
  "JEWELRY": "jewels in general [n JEWELRIES]\n",
  "JEWELS": "JEWEL, to adorn with precious stones [v]\n",
  "JEWELWEED": "a plant of the touch-me-not genus with crimson-spotted yellow flowers [n -S]\n",
  "JEWELWEEDS": "JEWELWEED, a plant of the touch-me-not genus with crimson-spotted yellow flowers [n]\n",
  "JEWFISH": "a large marine fish of Florida and the Gulf of Mexico [n -ES]\n",
  "JEWFISHES": "JEWFISH, a large marine fish of Florida and the Gulf of Mexico [n]\n",
  "JEWIE": "(Australian slang) the jewfish [n -S]\n",
  "JEWIES": "JEWIE, (Australian slang) the jewfish [n]\n",
  "JEWING": "JEW, (offensive) to barter successfully [v]\n",
  "JEWS": "JEW, (offensive) to barter successfully [v]\n",
  "JEZAIL": "a heavy Afghan musket [n -S]\n",
  "JEZAILS": "JEZAIL, a heavy Afghan musket [n]\n",
  "JEZEBEL": "a scheming, wicked woman [n -S]\n",
  "JEZEBELS": "JEZEBEL, a scheming, wicked woman [n]\n",
  "JHALA": "(Sanskrit) in Hindu music, part of the second movement of a raga [n -S]\n",
  "JHALAS": "JHALA, (Sanskrit) in Hindu music, part of the second movement of a raga [n]\n",
  "JHATKA": "(Punjabi) the slaughter of animals for food in accordance with Sikh law [n -S]\n",
  "JHATKAS": "JHATKA, (Punjabi) the slaughter of animals for food in accordance with Sikh law [n]\n",
  "JIAO": "(Chinese) a Chinese monetary unit, one tenth of a yuan, also CHIAO [n -S]\n",
  "JIAOS": "JIAO, (Chinese) a Chinese monetary unit, one tenth of a yuan, also CHIAO [n]\n",
  "JIB": "to draw back, to renegue [v -ED, -ING, -S]\n",
  "JIBB": "to shift from side to side while sailing [v -ED, -ING, -S]\n",
  "JIBBA": "a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JIBBAH, JUBBAH, JUBHAH [n -S]\n",
  "JIBBAH": "(Arabic) a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JUBBAH, JUBHAH [n -S]\n",
  "JIBBAHS": "JIBBAH, (Arabic) a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JUBBAH, JUBHAH [n]\n",
  "JIBBAS": "JIBBA, a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JIBBAH, JUBBAH, JUBHAH [n]\n",
  "JIBBED": "JIBB, to shift from side to side while sailing [v]\n",
  "JIBBER": "to utter senseless sounds [v -ED, -ING, -S]\n",
  "JIBBERED": "JIBBER, to utter senseless sounds [v]\n",
  "JIBBERING": "JIBBER, to utter senseless sounds [v]\n",
  "JIBBERS": "JIBBER, to utter senseless sounds [v]\n",
  "JIBBING": "JIB, to draw back, to renegue [v]\n",
  "JIBBINGS": "(Scots) the last milk drawn from a cow [n]\n",
  "JIBBONS": "spring onions [n]\n",
  "JIBBOOM": "a ship's spar [n -S]\n",
  "JIBBOOMS": "JIBBOOM, a ship's spar [n]\n",
  "JIBBS": "JIBB, to shift from side to side while sailing [v]\n",
  "JIBE": "to jeer, also GIBE [v JIBED, JIBING, JIBES]\n",
  "JIBED": "JIBE, to jeer, also GIBE [v]\n",
  "JIBER": "one who jibes, also GIBER [n -S]\n",
  "JIBERS": "JIBER, one who jibes, also GIBER [n]\n",
  "JIBES": "JIBE, to jeer, also GIBE [v]\n",
  "JIBING": "JIBE, to jeer, also GIBE [v]\n",
  "JIBINGLY": "JIBING, JIBE, to jeer, also GIBE [adv]\n",
  "JIBS": "JIB, to draw back, to renegue [v]\n",
  "JICAMA": "(Nahuatl) an edible starchy tuberous root of a leguminous tropical American vine [n -S]\n",
  "JICAMAS": "JICAMA, (Nahuatl) an edible starchy tuberous root of a leguminous tropical American vine [n]\n",
  "JICKAJOG": "to copulate, also JIGAJIG, JIGAJOG, JIGJIG [v JICKAJOGGED, JICKAJOGGING, JICKAJOGS]\n",
  "JICKAJOGGED": "JICKAJOG, to copulate, also JIGAJIG, JIGAJOG, JIGJIG [v]\n",
  "JICKAJOGGING": "the act of moving with a rolling motion [n -S]\n",
  "JICKAJOGGINGS": "JICKAJOGGING, the act of moving with a rolling motion [n]\n",
  "JICKAJOGS": "JICKAJOG, to copulate, also JIGAJIG, JIGAJOG, JIGJIG [v]\n",
  "JIFF": "a short time, also JIFFY [n -S]\n",
  "JIFFIES": "JIFFY, (colloquial) a short time, also JIFF [n]\n",
  "JIFFS": "JIFF, a short time, also JIFFY [n]\n",
  "JIFFY": "(colloquial) a short time, also JIFF [n JIFFIES]\n",
  "JIG": "to dance a jig; to jump up and down [v JIGGED, JIGGING, JIGS]\n",
  "JIGABOO": "(offensive US slang) a black person [n -S]\n",
  "JIGABOOS": "JIGABOO, (offensive US slang) a black person [n]\n",
  "JIGAJIG": "to copulate, also JICKAJOG, JIGAJOG, JIGJIG [v JIGAJIGGED, JIGAJIGGING, JIGAJIGS]\n",
  "JIGAJIGGED": "JIGAJIG, to copulate, also JICKAJOG, JIGAJOG, JIGJIG [v]\n",
  "JIGAJIGGING": "JIGAJIG, to copulate, also JICKAJOG, JIGAJOG, JIGJIG [v]\n",
  "JIGAJIGS": "JIGAJIG, to copulate, also JICKAJOG, JIGAJOG, JIGJIG [v]\n",
  "JIGAJOG": "to copulate, also JICKAJOG, JIGAJIG, JIGJIG [v JIGAJOGGED, JIGAJOGGING, JIGAJOGS]\n",
  "JIGAJOGGED": "JIGAJOG, to copulate, also JICKAJOG, JIGAJIG, JIGJIG [v]\n",
  "JIGAJOGGING": "JIGAJOG, to copulate, also JICKAJOG, JIGAJIG, JIGJIG [v]\n",
  "JIGAJOGS": "JIGAJOG, to copulate, also JICKAJOG, JIGAJIG, JIGJIG [v]\n",
  "JIGAMAREE": "a whatsit [n -S]\n",
  "JIGAMAREES": "JIGAMAREE, a whatsit [n]\n",
  "JIGGED": "JIG, to dance a jig; to jump up and down [v]\n",
  "JIGGER": "to jerk up and down [v -ED, -ING, -S]\n",
  "JIGGERED": "JIGGER, to jerk up and down [v]\n",
  "JIGGERING": "JIGGER, to jerk up and down [v]\n",
  "JIGGERMAST": "a small mast on a sailing vessel [n -S]\n",
  "JIGGERMASTS": "JIGGERMAST, a small mast on a sailing vessel [n]\n",
  "JIGGERS": "JIGGER, to jerk up and down [v]\n",
  "JIGGIER": "JIGGY, with the rhythm of a jig (dance) [adj]\n",
  "JIGGIEST": "JIGGY, with the rhythm of a jig (dance) [adj]\n",
  "JIGGING": "the act of jigging [n -S]\n",
  "JIGGINGS": "JIGGING, the act of jigging [n]\n",
  "JIGGISH": "jerky [adj]\n",
  "JIGGLE": "to shake from side to side [v JIGGLED, JIGGLING, JIGGLES]\n",
  "JIGGLED": "JIGGLE, to shake from side to side [v]\n",
  "JIGGLES": "JIGGLE, to shake from side to side [v]\n",
  "JIGGLIER": "JIGGLY, given to jiggling [adj]\n",
  "JIGGLIEST": "JIGGLY, given to jiggling [adj]\n",
  "JIGGLING": "JIGGLE, to shake from side to side [v]\n",
  "JIGGLY": "given to jiggling [adj JIGGLIER, JIGGLIEST]\n",
  "JIGGUMBOB": "a thingamabob; a gewgaw [n -S]\n",
  "JIGGUMBOBS": "JIGGUMBOB, a thingamabob; a gewgaw [n]\n",
  "JIGGY": "with the rhythm of a jig (dance) [adj JIGGIER, JIGGIEST]\n",
  "JIGJIG": "a jolting motion; a jog, also JICKAJOG, JIGAJIG, JIGAJOG [n -S]\n",
  "JIGJIGS": "JIGJIG [v]\n",
  "JIGLIKE": "like a jig [adj]\n",
  "JIGOT": "(French) a leg of lamb, also GIGOT [n -S]\n",
  "JIGOTS": "JIGOT, (French) a leg of lamb, also GIGOT [n]\n",
  "JIGS": "JIG, to dance a jig; to jump up and down [v]\n",
  "JIGSAW": "to cut with a narrow saw [v JIGSAWED, JIGSAWN, JIGSAWING, JIGSAWS]\n",
  "JIGSAWED": "JIGSAW, to cut with a narrow saw [v]\n",
  "JIGSAWING": "JIGSAW, to cut with a narrow saw [v]\n",
  "JIGSAWN": "JIGSAW, to cut with a narrow saw [v]\n",
  "JIGSAWS": "JIGSAW, to cut with a narrow saw [v]\n",
  "JIHAD": "(Arabic) in Islam, a holy war, also JEHAD [n -S]\n",
  "JIHADEEN": "Islamic freedom fighters, also JEHADEEN [n]\n",
  "JIHADI": "(Arabic) one who takes part in a jehad, also JEHADI, JEHADIST, JIHADIST [n -S]\n",
  "JIHADIS": "JIHADI, (Arabic) one who takes part in a jehad, also JEHADI, JEHADIST, JIHADIST [n]\n",
  "JIHADISM": "an Islamic fundamentalist movement that favours the pursuit of jihads in defence of the Islamic faith, also JEHADISM [n -S]\n",
  "JIHADISMS": "JIHADISM, an Islamic fundamentalist movement that favours the pursuit of jihads in defence of the Islamic faith, also JEHADISM [n]\n",
  "JIHADIST": "one who takes part in a jehad, also JEHADI, JIHADI, JEHADIST [n -S]\n",
  "JIHADISTS": "JIHADIST, one who takes part in a jehad, also JEHADI, JIHADI, JEHADIST [n]\n",
  "JIHADS": "JIHAD, (Arabic) in Islam, a holy war, also JEHAD [n]\n",
  "JILBAB": "(Arabic) a long robe worn by Muslim women [n JILBABS or JALABIB]\n",
  "JILBABS": "JILBAB, (Arabic) a long robe worn by Muslim women [n]\n",
  "JILGIE": "(Native Australian) a yabby, a small freshwater crayfish, also GILGIE [n -S]\n",
  "JILGIES": "JILGIE, (Native Australian) a yabby, a small freshwater crayfish, also GILGIE [n]\n",
  "JILL": "a female hare [n -S]\n",
  "JILLAROO": "(Australian) a female jackaroo (apprentice at a cattle station) [n -S]\n",
  "JILLAROOS": "JILLAROO, (Australian) a female jackaroo (apprentice at a cattle station) [n]\n",
  "JILLET": "(Scots) a skittish, flighty girl, also GIGLET, GIGLOT, GILLET [n -S]\n",
  "JILLETS": "JILLET, (Scots) a skittish, flighty girl, also GIGLET, GIGLOT, GILLET [n]\n",
  "JILLFLIRT": "(archaic) a wanton girl, also GILLFLIRT [n -S]\n",
  "JILLFLIRTS": "JILLFLIRT, (archaic) a wanton girl, also GILLFLIRT [n]\n",
  "JILLION": "an indefinite but extremely large number [n -S]\n",
  "JILLIONS": "JILLION, an indefinite but extremely large number [n]\n",
  "JILLIONTH": "the ordinal of jillion [adj]\n",
  "JILLS": "JILL, a female hare [n]\n",
  "JILT": "to discard a lover [v -ED, -ING, -S]\n",
  "JILTED": "JILT, to discard a lover [v]\n",
  "JILTER": "one who jilts [n -S]\n",
  "JILTERS": "JILTER, one who jilts [n]\n",
  "JILTING": "JILT, to discard a lover [v]\n",
  "JILTS": "JILT, to discard a lover [v]\n",
  "JIMCRACK": "cheap and showy [adj] / something cheap and showy, of little use, also GIMCRACK [n -S]\n",
  "JIMCRACKS": "JIMCRACK, something cheap and showy, of little use, also GIMCRACK [n]\n",
  "JIMINY": "an interjection expressing surprise, also GEMINI, GEMONY, JIMMINY [interj]\n",
  "JIMJAM": "a knickknack [n -S]\n",
  "JIMJAMS": "JIMJAM, a knickknack [n]\n",
  "JIMMIE": "a short crowbar used by burglars [n -S] / to pry open with a jimmie, also JEMMY, JIMMY [v JIMMIED, JIMMYING, JIMMIES]\n",
  "JIMMIED": "JIMMIE, to pry open with a jimmie, also JEMMY, JIMMY [v]\n",
  "JIMMIES": "JIMMIE, to pry open with a jimmie, also JEMMY, JIMMY [v]\n",
  "JIMMINY": "an interjection expressing surprise, also GEMINI, GEMONY, JIMINY [interj]\n",
  "JIMMY": "a short crowbar used by burglars [n JIMMIES] / to pry open with a jimmy, also JEMMY, JIMMIE [v JIMMIED, JIMMYING, JIMMIES]\n",
  "JIMMYING": "JIMMY, to pry open with a jimmy, also JEMMY, JIMMIE [v]\n",
  "JIMP": "(Scots) slender [adj JIMPER, JIMPEST, JIMPLY]\n",
  "JIMPER": "JIMP, (Scots) slender [adj]\n",
  "JIMPEST": "JIMP, (Scots) slender [adj]\n",
  "JIMPIER": "JIMPY, (Scots) neat [adj]\n",
  "JIMPIEST": "JIMPY, (Scots) neat [adj]\n",
  "JIMPLY": "JIMP, (Scots) slender [adv]\n",
  "JIMPNESS": "(Scots) slenderness [n -ES]\n",
  "JIMPNESSES": "JIMPNESS, (Scots) slenderness [n]\n",
  "JIMPSON": "as in jimpson weed, the thorn apple, also JIMSON [adj]\n",
  "JIMPY": "(Scots) neat [adj JIMPIER, JIMPIEST]\n",
  "JIMSON": "a type of poisonous plant with white flowers and shiny fruits, also JIMPSON [n -S]\n",
  "JIMSONS": "JIMSON, a type of poisonous plant with white flowers and shiny fruits, also JIMPSON [n]\n",
  "JIMSONWEED": "the thorn-apple [n -S]\n",
  "JIMSONWEEDS": "JIMSONWEED, the thorn-apple [n]\n",
  "JIN": "(Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JANN, JINN, JINNEE, JINNI [n -S]\n",
  "JINGAL": "(Hindi) a large Chinese or Indian swivel-musket, also GINGAL, GINGALL, JINGALL [n -S]\n",
  "JINGALL": "(Hindi) a large Chinese or Indian swivel-musket, also GINGAL, GINGALL, JINGAL [n -S]\n",
  "JINGALLS": "JINGALL, (Hindi) a large Chinese or Indian swivel-musket, also GINGAL, GINGALL, JINGAL [n]\n",
  "JINGALS": "JINGAL, (Hindi) a large Chinese or Indian swivel-musket, also GINGAL, GINGALL, JINGALL [n]\n",
  "JINGBANG": "(colloquial) company, collection [n -S]\n",
  "JINGBANGS": "JINGBANG, (colloquial) company, collection [n]\n",
  "JINGKO": "(Japanese) a kind of tree, also GINGKO, GINKGO [n -ES]\n",
  "JINGKOES": "JINGKO, (Japanese) a kind of tree, also GINGKO, GINKGO [n]\n",
  "JINGLE": "to make a tinkling sound [v JINGLED, JINGLING, JINGLES]\n",
  "JINGLED": "JINGLE, to make a tinkling sound [v]\n",
  "JINGLER": "one who, or that which, jingles [n -S]\n",
  "JINGLERS": "JINGLER, one who, or that which, jingles [n]\n",
  "JINGLES": "JINGLE, to make a tinkling sound [v]\n",
  "JINGLET": "a clapper on a sleigh-bell [n -S]\n",
  "JINGLETS": "JINGLET, a clapper on a sleigh-bell [n]\n",
  "JINGLIER": "JINGLY, jingling [adj]\n",
  "JINGLIEST": "JINGLY, jingling [adj]\n",
  "JINGLING": "JINGLE, to make a tinkling sound [v]\n",
  "JINGLY": "jingling [adj JINGLIER, JINGLIEST]\n",
  "JINGO": "a zealous patriot, also JINGOIST [n JINGOES]\n",
  "JINGOES": "JINGO, a zealous patriot, also JINGOIST [n]\n",
  "JINGOISH": "chauvinist, sabre-rattling, also JINGOISTIC [adj]\n",
  "JINGOISM": "the policy of jingoes [n -S]\n",
  "JINGOISMS": "JINGOISM, the policy of jingoes [n]\n",
  "JINGOIST": "a zealous patriot, also JINGO [n -S]\n",
  "JINGOISTIC": "chauvinist, sabre-rattling, also JINGOISH [adj JINGOISTICALLY]\n",
  "JINGOISTICALLY": "JINGOISTIC, chauvinist, sabre-rattling, also JINGOISH [adv]\n",
  "JINGOISTS": "JINGOIST, a zealous patriot, also JINGO [n]\n",
  "JINJILI": "(Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILI, GINGILLI [n -S]\n",
  "JINJILIS": "JINJILI, (Hindi) the sesame seed or its oil, also GINGELEY, GINGELI, GINGELLI, GINGELLY, GINGELY, GINGILI, GINGILLI [n]\n",
  "JINK": "to dodge nimbly [v -ED, -ING, -S]\n",
  "JINKED": "JINK, to dodge nimbly [v]\n",
  "JINKER": "(Australian slang) a light horse-drawn passenger carriage [n -S] / to transport in a jinker [v -ED, -ING, -S]\n",
  "JINKERED": "JINKER, to transport in a jinker [v]\n",
  "JINKERING": "JINKER, to transport in a jinker [v]\n",
  "JINKERS": "JINKER, to transport in a jinker [v]\n",
  "JINKING": "JINK, to dodge nimbly [v]\n",
  "JINKS": "JINK, to dodge nimbly [v]\n",
  "JINN": "a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JANN, JIN, JINNEE, JINNI [n -S]\n",
  "JINNE": "(South African) an exclamation expressive of surprise, admiration, shock, etc., also JIRRE [interj]\n",
  "JINNEE": "(Arabic) one of a class of spirits in Muslim theology, also DJIN, DJINNI, DJINNY, GENIE, JIN, JINNI [n JINN]\n",
  "JINNI": "(Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JANN, JIN, JINN, JINNEE [n -S]\n",
  "JINNIS": "JINNI, (Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JANN, JIN, JINN, JINNEE [n]\n",
  "JINNS": "JINN, a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JANN, JIN, JINNEE, JINNI [n]\n",
  "JINRICKSHA": "(Japanese) a small, two-wheeled, hooded vehicle drawn by one more men, also JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n -S]\n",
  "JINRICKSHAS": "JINRICKSHA, (Japanese) a small, two-wheeled, hooded vehicle drawn by one more men, also JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n]\n",
  "JINRICKSHAW": "(Japanese) a small, two-wheeled, hooded vehicle drawn by one more men, also JINRICKSHA, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n -S]\n",
  "JINRICKSHAWS": "JINRICKSHAW, (Japanese) a small, two-wheeled, hooded vehicle drawn by one more men, also JINRICKSHA, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n]\n",
  "JINRIKISHA": "(Japanese) a small, two-wheeled, hooded vehicle drawn by one more men, also JINRICKSHA, JINRICKSHAW, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n -S]\n",
  "JINRIKISHAS": "JINRIKISHA, (Japanese) a small, two-wheeled, hooded vehicle drawn by one more men, also JINRICKSHA, JINRICKSHAW, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n]\n",
  "JINRIKSHA": "(Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n -S]\n",
  "JINRIKSHAS": "JINRIKSHA, (Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, RICKSHA, RICKSHAW, RIKISHA, RIKSHAW [n]\n",
  "JINS": "JIN, (Arabic) a supernatural being in Muslim mythology, also DJIN, DJINN, DJINNI, DJINNY, GENIE, JANN, JINN, JINNEE, JINNI [n]\n",
  "JINX": "to bring bad luck to [v -ED, -ING, -ES]\n",
  "JINXED": "JINX, to bring bad luck to [v]\n",
  "JINXES": "JINX, to bring bad luck to [v]\n",
  "JINXING": "JINX, to bring bad luck to [v]\n",
  "JIPIJAPA": "(Spanish) a palmlike tree of tropical America, also JIPYAPA [n -S]\n",
  "JIPIJAPAS": "JIPIJAPA, (Spanish) a palmlike tree of tropical America, also JIPYAPA [n]\n",
  "JIPYAPA": "(Spanish) a palmlike tree of tropical America, also JIPIJAPA [n -S]\n",
  "JIPYAPAS": "JIPYAPA, (Spanish) a palmlike tree of tropical America, also JIPIJAPA [n]\n",
  "JIRBLE": "(Scots) to pour unsteadily [v JIRBLED, JIRBLING, JIRBLES]\n",
  "JIRBLED": "JIRBLE, (Scots) to pour unsteadily [v]\n",
  "JIRBLES": "JIRBLE, (Scots) to pour unsteadily [v]\n",
  "JIRBLING": "JIRBLE, (Scots) to pour unsteadily [v]\n",
  "JIRD": "an African gerbil [n -S]\n",
  "JIRDS": "JIRD, an African gerbil [n]\n",
  "JIRGA": "a council of tribal headmen in Afghanistan [n -S]\n",
  "JIRGAS": "JIRGA, a council of tribal headmen in Afghanistan [n]\n",
  "JIRKINET": "(Scots) a woman's jacket or bodice [n -S]\n",
  "JIRKINETS": "JIRKINET, (Scots) a woman's jacket or bodice [n]\n",
  "JIRRE": "(South African) an exclamation expressive of surprise, admiration, shock, etc., also JINNE [interj]\n",
  "JISM": "(colloquial) energy, force; semen, also GISM, JISSOM [n -S]\n",
  "JISMS": "JISM, (colloquial) energy, force; semen, also GISM, JISSOM [n]\n",
  "JISSOM": "(colloquial) energy, force; semen, also GISM, JISM [n -S]\n",
  "JISSOMS": "JISSOM, (colloquial) energy, force; semen, also GISM, JISM [n]\n",
  "JITNEY": "a small bus [n -S]\n",
  "JITNEYS": "JITNEY, a small bus [n]\n",
  "JITTER": "to fidget [v -ED, -ING, -S]\n",
  "JITTERBUG": "to dance a jazz dance featuring vigorous acrobatic feats [v JITTERBUGGED, JITTERBUGGING, JITTERBUGS]\n",
  "JITTERBUGGED": "JITTERBUG, to dance a jazz dance featuring vigorous acrobatic feats [v]\n",
  "JITTERBUGGING": "JITTERBUG, to dance a jazz dance featuring vigorous acrobatic feats [v]\n",
  "JITTERBUGS": "JITTERBUG, to dance a jazz dance featuring vigorous acrobatic feats [v]\n",
  "JITTERED": "JITTER, to fidget [v]\n",
  "JITTERIER": "JITTERY, extremely nervous [adj]\n",
  "JITTERIEST": "JITTERY, extremely nervous [adj]\n",
  "JITTERINESS": "the state of being jittery [n -ES]\n",
  "JITTERINESSES": "JITTERINESS, the state of being jittery [n]\n",
  "JITTERING": "JITTER, to fidget [v]\n",
  "JITTERS": "JITTER, to fidget [v]\n",
  "JITTERY": "extremely nervous [adj JITTERIER, JITTERIEST]\n",
  "JIUJITSU": "(Japanese) a Japanese art of self defence, also JIUJUTSU, JUJITSU, JUJUTSU [n -S]\n",
  "JIUJITSUS": "JIUJITSU, (Japanese) a Japanese art of self defence, also JIUJUTSU, JUJITSU, JUJUTSU [n]\n",
  "JIUJUTSU": "(Japanese) a Japanese art of self defence, also JIUJITSU, JUJITSU, JUJUTSU [n -S]\n",
  "JIUJUTSUS": "JIUJUTSU, (Japanese) a Japanese art of self defence, also JIUJITSU, JUJITSU, JUJUTSU [n]\n",
  "JIVE": "deceitful [adj JIVER, JIVEST] / to dance to jazz or swing music [v JIVED, JIVING, JIVES]\n",
  "JIVEASS": "(colloquial) a person who loves fun and excitement [n -ES]\n",
  "JIVEASSES": "JIVEASS, (colloquial) a person who loves fun and excitement [n]\n",
  "JIVED": "JIVE, to dance to jazz or swing music [v]\n",
  "JIVER": "one who jives [n -S]\n",
  "JIVERS": "JIVER, one who jives [n]\n",
  "JIVES": "JIVE, to dance to jazz or swing music [v]\n",
  "JIVEST": "JIVE, deceitful [adj]\n",
  "JIVEY": "jazzy, lively, also JIVY [adj JIVIER, JIVIEST]\n",
  "JIVIER": "JIVY, jazzy, lively, also JIVEY [adj]\n",
  "JIVIEST": "JIVY, jazzy, lively, also JIVEY [adj]\n",
  "JIVING": "JIVE, to dance to jazz or swing music [v]\n",
  "JIVY": "jazzy, lively, also JIVEY [adj JIVIER, JIVIEST]\n",
  "JIZ": "a wig, also GIZZ [n JIZZES]\n",
  "JIZZ": "the characteristic movement of a bird [n -ES]\n",
  "JIZZES": "JIZZ, the characteristic movement of a bird [n]\n",
  "JNANA": "(Sanskrit) knowledge acquired through meditation [n -S]\n",
  "JNANAS": "JNANA, (Sanskrit) knowledge acquired through meditation [n]\n",
  "JO": "(Scots) a Scottish sweetheart, also JOE [n -ES]\n",
  "JOANNA": "(colloquial) a piano [n -S]\n",
  "JOANNAS": "JOANNA, (colloquial) a piano [n]\n",
  "JOANNES": "a Portuguese gold coin, also JOHANNES [n -ES]\n",
  "JOANNESES": "JOANNES, a Portuguese gold coin, also JOHANNES [n]\n",
  "JOB": "to do piece work [v JOBBED, JOBBING, JOBS]\n",
  "JOBATION": "a long, tedious rebuke or harangue, also JAWBATION [n -S]\n",
  "JOBATIONS": "JOBATION, a long, tedious rebuke or harangue, also JAWBATION [n]\n",
  "JOBBED": "JOB, to do piece work [v]\n",
  "JOBBER": "a pieceworker [n -S]\n",
  "JOBBERIES": "JOBBERY, the conduct of public business for private gain [n]\n",
  "JOBBERS": "JOBBER, a pieceworker [n]\n",
  "JOBBERY": "the conduct of public business for private gain [n JOBBERIES]\n",
  "JOBBIE": "(Scots) a lump of excrement [n -S]\n",
  "JOBBIES": "JOBBIE, (Scots) a lump of excrement [n]\n",
  "JOBBING": "the doing of jobs [n -S]\n",
  "JOBBINGS": "JOBBING, the doing of jobs [n]\n",
  "JOBCENTRE": "a centre for employment [n -S]\n",
  "JOBCENTRES": "JOBCENTRE, a centre for employment [n]\n",
  "JOBE": "to reprimand tediously [v JOBED, JOBING, JOBES]\n",
  "JOBED": "JOBE, to reprimand tediously [v]\n",
  "JOBERNOWL": "a stupid person [n -S]\n",
  "JOBERNOWLS": "JOBERNOWL, a stupid person [n]\n",
  "JOBES": "JOBE, to reprimand tediously [v]\n",
  "JOBHOLDER": "one who has a job [n -S]\n",
  "JOBHOLDERS": "JOBHOLDER, one who has a job [n]\n",
  "JOBING": "JOBE, to reprimand tediously [v]\n",
  "JOBLESS": "without a job [adj]\n",
  "JOBLESSNESS": "the state of being jobless [n -ES]\n",
  "JOBLESSNESSES": "JOBLESSNESS, the state of being jobless [n]\n",
  "JOBNAME": "a computer code for a job instruction [n -S]\n",
  "JOBNAMES": "JOBNAME, a computer code for a job instruction [n]\n",
  "JOBS": "JOB, to do piece work [v]\n",
  "JOBSEEKER": "one engaged in seeking employment [n -S]\n",
  "JOBSEEKERS": "JOBSEEKER, one engaged in seeking employment [n]\n",
  "JOBSHARE": "the practice of dividing one job between two [n -S]\n",
  "JOBSHARES": "JOBSHARE, the practice of dividing one job between two [n]\n",
  "JOBSWORTH": "a minor official, esp. one who adheres rigidly to petty rules [n -S]\n",
  "JOBSWORTHS": "JOBSWORTH, a minor official, esp. one who adheres rigidly to petty rules [n]\n",
  "JOCK": "(US slang) a keen sportsman [n -S]\n",
  "JOCKDOM": "the world of athletes [n -S]\n",
  "JOCKDOMS": "JOCKDOM, the world of athletes [n]\n",
  "JOCKETTE": "(facetious) a female jockey [n -S]\n",
  "JOCKETTES": "JOCKETTE, (facetious) a female jockey [n]\n",
  "JOCKEY": "to maneuver for position [v -ED, -ING, -S]\n",
  "JOCKEYED": "JOCKEY, to maneuver for position [v]\n",
  "JOCKEYING": "JOCKEY, to maneuver for position [v]\n",
  "JOCKEYISH": "like a jockey [adj]\n",
  "JOCKEYISM": "the practice of jockeys [n -S]\n",
  "JOCKEYISMS": "JOCKEYISM, the practice of jockeys [n]\n",
  "JOCKEYS": "JOCKEY, to maneuver for position [v]\n",
  "JOCKEYSHIP": "the art or practice of a jockey [n -S]\n",
  "JOCKEYSHIPS": "JOCKEYSHIP, the art or practice of a jockey [n]\n",
  "JOCKIER": "JOCKY, resembling an athlete [adj]\n",
  "JOCKIEST": "JOCKY, resembling an athlete [adj]\n",
  "JOCKISH": "like a jock, macho [adj]\n",
  "JOCKNEY": "the Scots dialect influenced by cockney speech patterns [n -S]\n",
  "JOCKNEYS": "JOCKNEY, the Scots dialect influenced by cockney speech patterns [n]\n",
  "JOCKO": "(Bantu) a chimpanzee [n -S]\n",
  "JOCKOS": "JOCKO, (Bantu) a chimpanzee [n]\n",
  "JOCKS": "JOCK, (US slang) a keen sportsman [n]\n",
  "JOCKSTRAP": "a genital support worn esp. by men participating in athletics [n -S]\n",
  "JOCKSTRAPS": "JOCKSTRAP, a genital support worn esp. by men participating in athletics [n]\n",
  "JOCKTELEG": "(Scots) a large clasp knife [n -S]\n",
  "JOCKTELEGS": "JOCKTELEG, (Scots) a large clasp knife [n]\n",
  "JOCKY": "resembling an athlete [adj JOCKIER, JOCKIEST]\n",
  "JOCO": "(Scots) a joke [n -S]\n",
  "JOCOS": "JOCO, (Scots) a joke [n]\n",
  "JOCOSE": "merry; characterized by joking [adj JOCOSER, JOCOSEST; JOCOSELY]\n",
  "JOCOSELY": "JOCOSE, merry; characterized by joking [adv]\n",
  "JOCOSENESS": "the quality of being jocose [n -ES]\n",
  "JOCOSENESSES": "JOCOSENESS, the quality of being jocose [n]\n",
  "JOCOSER": "JOCOSE, merry; characterized by joking [adj]\n",
  "JOCOSERIOUS": "combining serious and humorous matters [adj]\n",
  "JOCOSEST": "JOCOSE, merry; characterized by joking [adj]\n",
  "JOCOSITIES": "JOCOSITY, cheerfulness [n]\n",
  "JOCOSITY": "cheerfulness [n JOCOSITIES]\n",
  "JOCULAR": "given to joking [adj JOCULARLY]\n",
  "JOCULARITIES": "JOCULARITY, jesting, merriment [n]\n",
  "JOCULARITY": "jesting, merriment [n JOCULARITIES]\n",
  "JOCULARLY": "JOCULAR, given to joking [adv]\n",
  "JOCULATOR": "a professional jester or minstrel [n -S]\n",
  "JOCULATORS": "JOCULATOR, a professional jester or minstrel [n]\n",
  "JOCUND": "marked by or suggestive of high spirits and lively mirthfulness [adj JOCUNDER, JOCUNDEST; JOCUNDLY]\n",
  "JOCUNDER": "JOCUND, marked by or suggestive of high spirits and lively mirthfulness [adj]\n",
  "JOCUNDEST": "JOCUND, marked by or suggestive of high spirits and lively mirthfulness [adj]\n",
  "JOCUNDITIES": "JOCUNDITY, joyfulness [n]\n",
  "JOCUNDITY": "joyfulness [n JOCUNDITIES]\n",
  "JOCUNDLY": "JOCUND, marked by or suggestive of high spirits and lively mirthfulness [adv]\n",
  "JOCUNDNESS": "the state of being jocund [n -ES]\n",
  "JOCUNDNESSES": "JOCUNDNESS, the state of being jocund [n]\n",
  "JODEL": "(German) to sing with rapidly fluctuating pitch, also YODEL, YODLE [v JODELLED, JODELLING, JODELS]\n",
  "JODELLED": "JODEL, (German) to sing with rapidly fluctuating pitch, also YODEL, YODLE [v]\n",
  "JODELLING": "JODEL, (German) to sing with rapidly fluctuating pitch, also YODEL, YODLE [v]\n",
  "JODELS": "JODEL, (German) to sing with rapidly fluctuating pitch, also YODEL, YODLE [v]\n",
  "JODHPUR": "(Hindi) usually in plural, long riding-breeches, wide around the hips but close-fitting from knee to ankle [n -S]\n",
  "JODHPURS": "JODHPUR, (Hindi) usually in plural, long riding-breeches, wide around the hips but close-fitting from knee to ankle [n]\n",
  "JOE": "(Scots) a loved one, also JO [n -S]\n",
  "JOES": "JOE, (Scots) a loved one, also JO [n]\n",
  "JOEY": "a young kangaroo [n -S]\n",
  "JOEYS": "JOEY, a young kangaroo [n]\n",
  "JOG": "to run at a slow, steady pace [v JOGGED, JOGGING, JOGS]\n",
  "JOGGED": "JOG, to run at a slow, steady pace [v]\n",
  "JOGGER": "one that jogs [n -S]\n",
  "JOGGERS": "JOGGER, one that jogs [n]\n",
  "JOGGING": "running at a slow, steady pace [n -S]\n",
  "JOGGINGS": "JOGGING, running at a slow, steady pace [n]\n",
  "JOGGLE": "to shake slightly [v JOGGLED, JOGGLING, JOGGLES]\n",
  "JOGGLED": "JOGGLE, to shake slightly [v]\n",
  "JOGGLER": "one who joggles [n -S]\n",
  "JOGGLERS": "JOGGLER, one who joggles [n]\n",
  "JOGGLES": "JOGGLE, to shake slightly [v]\n",
  "JOGGLING": "JOGGLE, to shake slightly [v]\n",
  "JOGPANTS": "loose fitting trousers for jogging [n]\n",
  "JOGS": "JOG, to run at a slow, steady pace [v]\n",
  "JOGTROT": "to move at a slow trot [v JOGTROTTED, JOGTROTTING, JOGTROTS]\n",
  "JOGTROTS": "JOGTROT, to move at a slow trot [v]\n",
  "JOGTROTTED": "JOGTROT, to move at a slow trot [v]\n",
  "JOGTROTTING": "JOGTROT, to move at a slow trot [v]\n",
  "JOHANNES": "an obsolete Portuguese gold coin, named from the figure of King John which it bears, also JOANNES [n -ES]\n",
  "JOHANNESES": "JOHANNES, an obsolete Portuguese gold coin, named from the figure of King John which it bears, also JOANNES [n]\n",
  "JOHN": "a toilet [n -S]\n",
  "JOHNBOAT": "a narrow square-ended boat [n -S]\n",
  "JOHNBOATS": "JOHNBOAT, a narrow square-ended boat [n]\n",
  "JOHNNIE": "(slang) a condom, also JOHNNY [n -S]\n",
  "JOHNNIES": "JOHNNY, a condom, also JOHNNIE [n]\n",
  "JOHNNY": "a condom, also JOHNNIE [n JOHNNIES]\n",
  "JOHNNYCAKE": "a kind of bread made of the meal of maize (Indian corn), mixed with water or milk, etc. and baked, also JONNYCAKE [n -S]\n",
  "JOHNNYCAKES": "JOHNNYCAKE, a kind of bread made of the meal of maize (Indian corn), mixed with water or milk, etc. and baked, also JONNYCAKE [n]\n",
  "JOHNS": "JOHN, a toilet [n]\n",
  "JOHNSON": "(vulgar slang) a penis [n -S]\n",
  "JOHNSONGRASS": "a tall perennial sorghum widely used as forage [n -ES]\n",
  "JOHNSONGRASSES": "JOHNSONGRASS, a tall perennial sorghum widely used as forage [n]\n",
  "JOHNSONS": "JOHNSON, (vulgar slang) a penis [n]\n",
  "JOIN": "to unite [v -ED, -ING, -S]\n",
  "JOINABLE": "able to be joined [adj]\n",
  "JOINDER": "a joining of parties in a law suit [n -S]\n",
  "JOINDERS": "JOINDER, a joining of parties in a law suit [n]\n",
  "JOINED": "JOIN, to unite [v]\n",
  "JOINER": "a carpenter [n -S]\n",
  "JOINERIES": "JOINERY, the trade of a joiner [n]\n",
  "JOINERS": "JOINER, a carpenter [n]\n",
  "JOINERY": "the trade of a joiner [n JOINERIES]\n",
  "JOINING": "a juncture [n -S]\n",
  "JOININGS": "JOINING, a juncture [n]\n",
  "JOINS": "JOIN, to unite [v]\n",
  "JOINT": "combined [adj JOINTLY] / to fit together by means of a junction [v -ED, -ING, -S]\n",
  "JOINTED": "JOINT, to fit together by means of a junction [v]\n",
  "JOINTEDLY": "JOINTED, JOINT, to fit together by means of a junction [adv]\n",
  "JOINTEDNESS": "the state of being jointed [n -ES]\n",
  "JOINTEDNESSES": "JOINTEDNESS, the state of being jointed [n]\n",
  "JOINTER": "a bricklayer's tool for putting joints in mortar [n -S]\n",
  "JOINTERS": "JOINTER, a bricklayer's tool for putting joints in mortar [n]\n",
  "JOINTING": "the act of fitting together [n -S]\n",
  "JOINTINGS": "JOINTING, the act of fitting together [n]\n",
  "JOINTLESS": "without joints [adj]\n",
  "JOINTLY": "JOINT, combined [adv]\n",
  "JOINTNESS": "the state of being joint [n -ES]\n",
  "JOINTNESSES": "JOINTNESS, the state of being joint [n]\n",
  "JOINTRESS": "a woman who has a jointure, also JOINTURESS [n -ES]\n",
  "JOINTRESSES": "JOINTRESS, a woman who has a jointure, also JOINTURESS [n]\n",
  "JOINTS": "JOINT, to fit together by means of a junction [v]\n",
  "JOINTURE": "the settlement of a husband's estate on his wife to become effective on his death [n -S] / to settle a jointure on [v JOINTURED, JOINTURING, JOINTURES]\n",
  "JOINTURED": "JOINTURE, to settle a jointure on [v]\n",
  "JOINTURES": "JOINTURE, to settle a jointure on [v]\n",
  "JOINTURESS": "a woman who has a jointure, also JOINTRESS [n -ES]\n",
  "JOINTURESSES": "JOINTURESS, a woman who has a jointure, also JOINTRESS [n]\n",
  "JOINTURING": "JOINTURE, to settle a jointure on [v]\n",
  "JOINTWEED": "an American wild plant [n -S]\n",
  "JOINTWEEDS": "JOINTWEED, an American wild plant [n]\n",
  "JOINTWORM": "the larva of a small, hymenopterous fly, which is found in gall-like swellings on the stalks of wheat [n -S]\n",
  "JOINTWORMS": "JOINTWORM, the larva of a small, hymenopterous fly, which is found in gall-like swellings on the stalks of wheat [n]\n",
  "JOIST": "a beam supporting boards of a floor or laths of a ceiling [n -S] / to fit with joists [v -ED, -ING, -S]\n",
  "JOISTED": "JOIST, to fit with joists [v]\n",
  "JOISTING": "JOIST, to fit with joists [v]\n",
  "JOISTS": "JOIST, to fit with joists [v]\n",
  "JOJOBA": "(Spanish) a small tree [n -S]\n",
  "JOJOBAS": "JOJOBA, (Spanish) a small tree [n]\n",
  "JOKE": "to say something amusing [v JOKED, JOKING, JOKES]\n",
  "JOKED": "JOKE, to say something amusing [v]\n",
  "JOKER": "one that jokes [n -S]\n",
  "JOKERS": "JOKER, one that jokes [n]\n",
  "JOKES": "JOKE, to say something amusing [v]\n",
  "JOKESMITH": "(archaic) a composer of jokes [n -S]\n",
  "JOKESMITHS": "JOKESMITH, (archaic) a composer of jokes [n]\n",
  "JOKESOME": "amusing [adj]\n",
  "JOKESTER": "a practical joker [n -S]\n",
  "JOKESTERS": "JOKESTER, a practical joker [n]\n",
  "JOKEY": "full of jokes, also JOKY [adj JOKIER, JOKIEST, JOKILY]\n",
  "JOKIER": "JOKY, amusing, also JOKEY [adj]\n",
  "JOKIEST": "JOKY, amusing, also JOKEY [adj]\n",
  "JOKILY": "amusing [adv]\n",
  "JOKINESS": "the state of being amusing [n -ES]\n",
  "JOKINESSES": "JOKINESS, the state of being amusing [n]\n",
  "JOKING": "the act of making a joke [n -S]\n",
  "JOKINGLY": "JOKING [adv]\n",
  "JOKINGS": "JOKING, the act of making a joke [n]\n",
  "JOKOL": "(Shetlands) yes (literally yes carl i.e. yes, fellow), also YOKUL [interj]\n",
  "JOKY": "amusing, also JOKEY [adj JOKIER, JOKIEST, JOKILY]\n",
  "JOL": "(South African slang) to have a good time [v JOLLED, JOLLING, JOLS]\n",
  "JOLE": "(dialect) to bump, knock, also JOLL, JOULE, JOWL [v JOLED, JOLING, JOLES]\n",
  "JOLED": "JOLE, (dialect) to bump, knock, also JOLL, JOULE, JOWL [v]\n",
  "JOLES": "JOLE, (dialect) to bump, knock, also JOLL, JOULE, JOWL [v]\n",
  "JOLING": "JOLE, (dialect) to bump, knock, also JOLL, JOULE, JOWL [v]\n",
  "JOLIOTIUM": "a former name for the element dubnium [n -S]\n",
  "JOLIOTIUMS": "JOLIOTIUM, a former name for the element dubnium [n]\n",
  "JOLL": "(dialect) to bump, knock, also JOLE, JOULE, JOWL [v -ED, -ING, -S]\n",
  "JOLLED": "JOLL, (dialect) to bump, knock, also JOLE, JOULE, JOWL [v]\n",
  "JOLLER": "one who jols, has a good time [n -S]\n",
  "JOLLERS": "JOLLER, one who jols, has a good time [n]\n",
  "JOLLEY": "a guide for fixing a pottery mould for plates [n -S]\n",
  "JOLLEYER": "one who uses a jolley, a guide for fixing a pottery mould for plates, also JOLLYER [n -S]\n",
  "JOLLEYERS": "JOLLEYER, one who uses a jolley, a guide for fixing a pottery mould for plates, also JOLLYER [n]\n",
  "JOLLEYING": "using a jolley, a guide for fixing a pottery mould for plates [n -S]\n",
  "JOLLEYINGS": "JOLLEYING, using a jolley, a guide for fixing a pottery mould for plates [n]\n",
  "JOLLEYS": "JOLLEY, a guide for fixing a pottery mould for plates [n]\n",
  "JOLLIED": "JOLLY, to put or keep in a good humour [v]\n",
  "JOLLIER": "one who puts others in a good humor [n -S]\n",
  "JOLLIERS": "JOLLIER, one who puts others in a good humor [n]\n",
  "JOLLIES": "JOLLY, to put or keep in a good humour [v]\n",
  "JOLLIEST": "JOLLY, mirthful [adj]\n",
  "JOLLIFICATION": "festivity, merrymaking [n -S]\n",
  "JOLLIFICATIONS": "JOLLIFICATION, festivity, merrymaking [n]\n",
  "JOLLIFIED": "JOLLIFY, to make jolly [v]\n",
  "JOLLIFIES": "JOLLIFY, to make jolly [v]\n",
  "JOLLIFY": "to make jolly [v JOLLIFIED, JOLLIFYING, JOLLIFIES]\n",
  "JOLLIFYING": "JOLLIFY, to make jolly [v]\n",
  "JOLLILY": "JOLLY, mirthful [adv]\n",
  "JOLLIMENT": "(Spenser) jollity [n -S]\n",
  "JOLLIMENTS": "JOLLIMENT, (Spenser) jollity [n]\n",
  "JOLLINESS": "the state of being jolly [n -ES]\n",
  "JOLLINESSES": "JOLLINESS, the state of being jolly [n]\n",
  "JOLLING": "JOLL, (dialect) to bump, knock, also JOLE, JOULE, JOWL [v]\n",
  "JOLLITIES": "JOLLITY, mirth [n]\n",
  "JOLLITY": "mirth [n JOLLITIES]\n",
  "JOLLOF": "as in jollof rice, a West African dish made from rice and meat or fish [adj]\n",
  "JOLLOP": "a cream [n -S]\n",
  "JOLLOPS": "JOLLOP, a cream [n]\n",
  "JOLLS": "JOLL, (dialect) to bump, knock, also JOLE, JOULE, JOWL [v]\n",
  "JOLLY": "mirthful [adj JOLLIER, JOLLIEST, JOLLILY] / to put or keep in a good humour [v JOLLIED, JOLLYING, JOLLIES]\n",
  "JOLLYBOAT": "a small boat kept hoisted at a ship's stern [n -S]\n",
  "JOLLYBOATS": "JOLLYBOAT, a small boat kept hoisted at a ship's stern [n]\n",
  "JOLLYER": "one who uses a jolley, a guide for fixing a pottery mould for plates, also JOLLEYER [n -S]\n",
  "JOLLYERS": "JOLLYER, one who uses a jolley, a guide for fixing a pottery mould for plates, also JOLLEYER [n]\n",
  "JOLLYHEAD": "(Spenser) jollity [n -S]\n",
  "JOLLYHEADS": "JOLLYHEAD, (Spenser) jollity [n]\n",
  "JOLLYING": "the act of making plates on a special potter's wheel [n -S]\n",
  "JOLLYINGS": "JOLLYING, the act of making plates on a special potter's wheel [n]\n",
  "JOLS": "JOL, (South African slang) to have a good time [v]\n",
  "JOLT": "to jar or shake roughly [v -ED, -ING, -S]\n",
  "JOLTED": "JOLT, to jar or shake roughly [v]\n",
  "JOLTER": "one who, or that which, jolts [n -S]\n",
  "JOLTERHEAD": "(archaic) a clumsy oaf, a blockhead, also JOLTHEAD [n -S]\n",
  "JOLTERHEADS": "JOLTERHEAD, (archaic) a clumsy oaf, a blockhead, also JOLTHEAD [n]\n",
  "JOLTERS": "JOLTER, one who, or that which, jolts [n]\n",
  "JOLTHEAD": "(archaic) a clumsy oaf, a blockhead, also JOLTERHEAD [n -S]\n",
  "JOLTHEADS": "JOLTHEAD, (archaic) a clumsy oaf, a blockhead, also JOLTERHEAD [n]\n",
  "JOLTIER": "JOLTY, in a jolting manner [adj]\n",
  "JOLTIEST": "JOLTY, in a jolting manner [adj]\n",
  "JOLTILY": "JOLTY, in a jolting manner [adv]\n",
  "JOLTING": "the act of making a jolt [n -S]\n",
  "JOLTINGLY": "JOLTING [adv]\n",
  "JOLTINGS": "JOLTING, the act of making a jolt [n]\n",
  "JOLTS": "JOLT, to jar or shake roughly [v]\n",
  "JOLTY": "in a jolting manner [adj JOLTIER, JOLTIEST, JOLTILY]\n",
  "JOMO": "a cross between a yak and a cow, also ZHO, DSO, DZHO, DZO [n -S]\n",
  "JOMON": "(Japanese) a particular era in Japanese history [n -S]\n",
  "JOMONS": "JOMON, (Japanese) a particular era in Japanese history [n]\n",
  "JOMOS": "JOMO, a cross between a yak and a cow, also ZHO, DSO, DZHO, DZO [n]\n",
  "JONCANOE": "a boisterous West Indian dance, also JUNKANOO [n -S]\n",
  "JONCANOES": "JONCANOE, a boisterous West Indian dance, also JUNKANOO [n]\n",
  "JONES": "a drug addiction [n -ES] / to have a strong desire [v -ED, -ING, -ES]\n",
  "JONESED": "JONES, to have a strong desire [v]\n",
  "JONESES": "JONES, to have a strong desire [v]\n",
  "JONESING": "JONES, to have a strong desire [v]\n",
  "JONG": "(South African) friend [n -S]\n",
  "JONGLEUR": "(French) a medieval wandering minstrel [n -S]\n",
  "JONGLEURS": "JONGLEUR, (French) a medieval wandering minstrel [n]\n",
  "JONGS": "JONG, (South African) friend [n]\n",
  "JONNOCK": "straightforward, honest, also JANNOCK [adj]\n",
  "JONNYCAKE": "a kind of bread made of the meal of maize (Indian corn), mixed with water or milk, etc., and baked, also JOHNNYCAKE [n -S]\n",
  "JONNYCAKES": "JONNYCAKE, a kind of bread made of the meal of maize (Indian corn), mixed with water or milk, etc., and baked, also JOHNNYCAKE [n]\n",
  "JONQUIL": "a species of narcissus [n -S]\n",
  "JONQUILS": "JONQUIL, a species of narcissus [n]\n",
  "JONTIES": "JONTY, a naval master-at-arms, also JANTY [n]\n",
  "JONTY": "a naval master-at-arms, also JANTY [n JONTIES]\n",
  "JOOK": "(Scots) to duck or dodge, also JOUK [v -ED, -ING, -S]\n",
  "JOOKED": "JOOK, (Scots) to duck or dodge, also JOUK [v]\n",
  "JOOKERIES": "JOOKERY, (Scots) trickery, roguery, also JOUKERY [n]\n",
  "JOOKERY": "(Scots) trickery, roguery, also JOUKERY [n JOOKERIES]\n",
  "JOOKING": "JOOK, (Scots) to duck or dodge, also JOUK [v]\n",
  "JOOKS": "JOOK, (Scots) to duck or dodge, also JOUK [v]\n",
  "JOR": "in Indian music, the second movement of a raga [n -S]\n",
  "JORAM": "a large drinking bowl, also JORUM [n -S]\n",
  "JORAMS": "JORAM, a large drinking bowl, also JORUM [n]\n",
  "JORDAN": "a chamberpot [n -S]\n",
  "JORDANS": "JORDAN, a chamberpot [n]\n",
  "JORDELOO": "(Scots) a warning cry when slops are thrown from a window, also GARDYLOO [n -S]\n",
  "JORDELOOS": "JORDELOO, (Scots) a warning cry when slops are thrown from a window, also GARDYLOO [n]\n",
  "JORS": "JOR, in Indian music, the second movement of a raga [n]\n",
  "JORUM": "a large drinking bowl, also JORAM [n -S]\n",
  "JORUMS": "JORUM, a large drinking bowl, also JORAM [n]\n",
  "JOSEPH": "a caped overcoat worn by women in the 18th century for riding [n -S]\n",
  "JOSEPHINITE": "a mineral found only at Jospehine Creek in Oregon [n -S]\n",
  "JOSEPHINITES": "JOSEPHINITE, a mineral found only at Jospehine Creek in Oregon [n]\n",
  "JOSEPHS": "JOSEPH, a caped overcoat worn by women in the 18th century for riding [n]\n",
  "JOSH": "to tease [v JOSHED, JOSHING, JOSHES]\n",
  "JOSHED": "JOSH, to tease [v]\n",
  "JOSHER": "one who joshes [n -S]\n",
  "JOSHERS": "JOSHER, one who joshes [n]\n",
  "JOSHES": "JOSH, to tease [v]\n",
  "JOSHING": "the act of teasing [n -S]\n",
  "JOSHINGLY": "JOSHING [adv]\n",
  "JOSHINGS": "JOSHING, the act of teasing [n]\n",
  "JOSKIN": "(slang) a clown, yokel [n -S]\n",
  "JOSKINS": "JOSKIN, (slang) a clown, yokel [n]\n",
  "JOSS": "(Portuguese) a Chinese figure of a god, an idol [n -ES]\n",
  "JOSSER": "(slang) a clergyman [n -S]\n",
  "JOSSERS": "JOSSER, (slang) a clergyman [n]\n",
  "JOSSES": "JOSS, (Portuguese) a Chinese figure of a god, an idol [n]\n",
  "JOSTLE": "to run or strike against, also JUSTLE [v JOSTLED, JOSTLING, JOSTLES]\n",
  "JOSTLED": "JOSTLE, to run or strike against, also JUSTLE [v]\n",
  "JOSTLEMENT": "crowding; hustling [n -S]\n",
  "JOSTLEMENTS": "JOSTLEMENT, crowding; hustling [n]\n",
  "JOSTLER": "one who jostles [n -S]\n",
  "JOSTLERS": "JOSTLER, one who jostles [n]\n",
  "JOSTLES": "JOSTLE, to run or strike against, also JUSTLE [v]\n",
  "JOSTLING": "the act of jostling [n -S]\n",
  "JOSTLINGS": "JOSTLING, the act of jostling [n]\n",
  "JOT": "to note quickly [v JOTTED, JOTTING, JOTS]\n",
  "JOTA": "(Spanish) a Spanish dance [n -S]\n",
  "JOTAS": "JOTA, (Spanish) a Spanish dance [n]\n",
  "JOTS": "JOT, to note quickly [v]\n",
  "JOTTED": "JOT, to note quickly [v]\n",
  "JOTTER": "one that jots; a pad for jotting [n -S]\n",
  "JOTTERS": "JOTTER, one that jots; a pad for jotting [n]\n",
  "JOTTIER": "JOTTY, written down quickly [adj]\n",
  "JOTTIEST": "JOTTY, written down quickly [adj]\n",
  "JOTTING": "a brief note [n -S]\n",
  "JOTTINGS": "JOTTING, a brief note [n]\n",
  "JOTTY": "written down quickly [adj JOTTIER, JOTTIEST]\n",
  "JOTUN": "(Old Norse) in Norse myth, a giant, also JOTUNN [n -S]\n",
  "JOTUNN": "(Old Norse) in Norse myth, a giant, also JOTUN [n -S]\n",
  "JOTUNNS": "JOTUNN, (Old Norse) in Norse myth, a giant, also JOTUN [n]\n",
  "JOTUNS": "JOTUN, (Old Norse) in Norse myth, a giant, also JOTUNN [n]\n",
  "JOUAL": "(Canadian) a nonstandard, chiefly urban variety of French Canadian [n -S]\n",
  "JOUALS": "JOUAL, (Canadian) a nonstandard, chiefly urban variety of French Canadian [n]\n",
  "JOUGS": "(Scots) an old instrument of punishment consisting of a hinged iron collar locked round an offender's neck and attached by a chain to a wall or post [n]\n",
  "JOUISANCE": "(Spenser) joyousness, also JOUYSAUNCE, JOVYSAUNCE [n -S]\n",
  "JOUISANCES": "JOUISANCE, (Spenser) joyousness, also JOUYSAUNCE, JOVYSAUNCE [n]\n",
  "JOUK": "(Scots) to duck or dodge, also JOOK [v -ED, -ING, -S]\n",
  "JOUKED": "JOUK, (Scots) to duck or dodge, also JOOK [v]\n",
  "JOUKERIES": "JOUKERY, (Scots) trickery, also JOOKERY [n]\n",
  "JOUKERY": "(Scots) trickery, also JOOKERY [n JOUKERIES]\n",
  "JOUKING": "JOUK, (Scots) to duck or dodge, also JOOK [v]\n",
  "JOUKS": "JOUK, (Scots) to duck or dodge, also JOOK [v]\n",
  "JOULE": "to bump, also JOLE, JOLL, JOWL [v JOULED, JOULING, JOULES]\n",
  "JOULED": "JOULE, to bump, also JOLE, JOLL, JOWL [v]\n",
  "JOULES": "JOULE, to bump, also JOLE, JOLL, JOWL [v]\n",
  "JOULING": "JOULE, to bump, also JOLE, JOLL, JOWL [v]\n",
  "JOUNCE": "to jolt, shake [v JOUNCED, JOUNCING, JOUNCES]\n",
  "JOUNCED": "JOUNCE, to jolt, shake [v]\n",
  "JOUNCES": "JOUNCE, to jolt, shake [v]\n",
  "JOUNCIER": "JOUNCY, jolting [adj]\n",
  "JOUNCIEST": "JOUNCY, jolting [adj]\n",
  "JOUNCING": "JOUNCE, to jolt, shake [v]\n",
  "JOUNCY": "jolting [adj JOUNCIER, JOUNCIEST]\n",
  "JOUR": "(French) a day, as in 'jour de feste' [n -S]\n",
  "JOURNAL": "a record of daily events [n -S] / to record in a journal [v JOURNALED or JOURNALLED, JOURNALING or JOURNALLING, JOURNALS]\n",
  "JOURNALED": "JOURNAL, to record in a journal [v]\n",
  "JOURNALESE": "the jargon of bad journalism [n -S]\n",
  "JOURNALESES": "JOURNALESE, the jargon of bad journalism [n]\n",
  "JOURNALING": "the act of recording in a journal, also JOURNALLING [n -S]\n",
  "JOURNALINGS": "JOURNALING, the act of recording in a journal, also JOURNALLING [n]\n",
  "JOURNALISATION": "the process of journalising, also JOURNALIZATION [n -S]\n",
  "JOURNALISATIONS": "JOURNALISATION, the process of journalising, also JOURNALIZATION [n]\n",
  "JOURNALISE": "to write for or in a journal, also JOURNALIZE [v JOURNALISED, JOURNALISING, JOURNALISES]\n",
  "JOURNALISED": "JOURNALISE, to write for or in a journal, also JOURNALIZE [v]\n",
  "JOURNALISER": "one who journalises, also JOURNALIZER [n -S]\n",
  "JOURNALISERS": "JOURNALISER, one who journalises, also JOURNALIZER [n]\n",
  "JOURNALISES": "JOURNALISE, to write for or in a journal, also JOURNALIZE [v]\n",
  "JOURNALISING": "JOURNALISE, to write for or in a journal, also JOURNALIZE [v]\n",
  "JOURNALISM": "the collection and editing of news for presentation through the media [n -S]\n",
  "JOURNALISMS": "JOURNALISM, the collection and editing of news for presentation through the media [n]\n",
  "JOURNALIST": "a person engaged in journalism [n -S]\n",
  "JOURNALISTIC": "of, relating to, or characteristic of journalism or journalists [adj]\n",
  "JOURNALISTS": "JOURNALIST, a person engaged in journalism [n]\n",
  "JOURNALIZATION": "the process of journalizing, also JOURNALISATION [n -S]\n",
  "JOURNALIZATIONS": "JOURNALIZATION, the process of journalizing, also JOURNALISATION [n]\n",
  "JOURNALIZE": "to enter or record in a journal or diary, also JOURNALISE [v JOURNALIZED, JOURNALIZING, JOURNALIZES]\n",
  "JOURNALIZED": "JOURNALIZE, to enter or record in a journal or diary, also JOURNALISE [v]\n",
  "JOURNALIZER": "one who journalizes, also JOURNALISER [n -S]\n",
  "JOURNALIZERS": "JOURNALIZER, one who journalizes, also JOURNALISER [n]\n",
  "JOURNALIZES": "JOURNALIZE, to enter or record in a journal or diary, also JOURNALISE [v]\n",
  "JOURNALIZING": "JOURNALIZE, to enter or record in a journal or diary, also JOURNALISE [v]\n",
  "JOURNALLED": "JOURNAL, to record in a journal [v]\n",
  "JOURNALLING": "the act of recording in a journal, also JOURNALING [n -S]\n",
  "JOURNALLINGS": "JOURNALLING, the act of recording in a journal, also JOURNALING [n]\n",
  "JOURNALS": "JOURNAL, to record in a journal [v]\n",
  "JOURNEY": "to travel [v -ED, -ING, -S]\n",
  "JOURNEYED": "JOURNEY, to travel [v]\n",
  "JOURNEYER": "one who journeys [n -S]\n",
  "JOURNEYERS": "JOURNEYER, one who journeys [n]\n",
  "JOURNEYING": "JOURNEY, to travel [v]\n",
  "JOURNEYMAN": "an experienced reliable worker or performer esp. as distinguished from one who is brilliant or colourful [n JOURNEYMEN]\n",
  "JOURNEYMEN": "JOURNEYMAN, an experienced reliable worker or performer esp. as distinguished from one who is brilliant or colourful [n]\n",
  "JOURNEYS": "JOURNEY, to travel [v]\n",
  "JOURNEYWORK": "work done by a journeyman [n -S]\n",
  "JOURNEYWORKS": "JOURNEYWORK, work done by a journeyman [n]\n",
  "JOURNO": "(slang) a journalist [n -S]\n",
  "JOURNOS": "JOURNO, (slang) a journalist [n]\n",
  "JOURS": "JOUR, (French) a day, as in 'jour de feste' [n]\n",
  "JOUST": "to engage in personal combat, also JUST [v -ED, -ING, -S]\n",
  "JOUSTED": "JOUST, to engage in personal combat, also JUST [v]\n",
  "JOUSTER": "one who jousts, also JUSTER [n -S]\n",
  "JOUSTERS": "JOUSTER, one who jousts, also JUSTER [n]\n",
  "JOUSTING": "the act of fighting in a joust [n -S]\n",
  "JOUSTINGS": "JOUSTING, the act of fighting in a joust [n]\n",
  "JOUSTS": "JOUST, to engage in personal combat, also JUST [v]\n",
  "JOUYSAUNCE": "(Spenser) joyousness, also JOUISANCE, JOVYSAUNCE [n -S]\n",
  "JOUYSAUNCES": "JOUYSAUNCE, (Spenser) joyousness, also JOUISANCE, JOVYSAUNCE [n]\n",
  "JOVIAL": "good-humoured [adj JOVIALLY]\n",
  "JOVIALITIES": "JOVIALITY, the state of being jovial, also JOVIALTY [n]\n",
  "JOVIALITY": "the state of being jovial, also JOVIALTY [n JOVIALITIES]\n",
  "JOVIALLY": "JOVIAL, good-humoured [adv]\n",
  "JOVIALNESS": "noisy mirth, joviality [n -ES]\n",
  "JOVIALNESSES": "JOVIALNESS, noisy mirth, joviality [n]\n",
  "JOVIALTIES": "JOVIALTY, the state of being jovial [n]\n",
  "JOVIALTY": "the state of being jovial [n JOVIALTIES]\n",
  "JOVYSAUNCE": "(Spenser) joyousness, also JOUISANCE, JOUYSAUNCE [n -S]\n",
  "JOVYSAUNCES": "JOVYSAUNCE, (Spenser) joyousness, also JOUISANCE, JOUYSAUNCE [n]\n",
  "JOW": "to ring, toll a bell [v -ED, -ING, -S]\n",
  "JOWAR": "(Hindi) Indian millet, aka durra, also JAWARI, JOWARI [n -S]\n",
  "JOWARI": "(Hindi) Indian millet, aka durra, also JOWAR, JAWARI [n -S]\n",
  "JOWARIS": "JOWARI, (Hindi) Indian millet, aka durra, also JOWAR, JAWARI [n]\n",
  "JOWARS": "JOWAR, (Hindi) Indian millet, aka durra, also JAWARI, JOWARI [n]\n",
  "JOWED": "JOW, to ring, toll a bell [v]\n",
  "JOWING": "JOW, to ring, toll a bell [v]\n",
  "JOWL": "to bump, also JOLE, JOLL, JOULE [v -ED, -ING, -S]\n",
  "JOWLED": "JOWL, to bump, also JOLE, JOLL, JOULE [v]\n",
  "JOWLER": "a heavy-jawed hound [n -S]\n",
  "JOWLERS": "JOWLER, a heavy-jawed hound [n]\n",
  "JOWLIER": "JOWLY, having prominent jowls [adj]\n",
  "JOWLIEST": "JOWLY, having prominent jowls [adj]\n",
  "JOWLINESS": "the state of being jowly [n -ES]\n",
  "JOWLINESSES": "JOWLINESS, the state of being jowly [n]\n",
  "JOWLING": "JOWL, to bump, also JOLE, JOLL, JOULE [v]\n",
  "JOWLS": "JOWL, to bump, also JOLE, JOLL, JOULE [v]\n",
  "JOWLY": "having prominent jowls [adj JOWLIER, JOWLIEST]\n",
  "JOWS": "JOW, to ring, toll a bell [v]\n",
  "JOY": "to rejoice [v -ED, -ING, -S]\n",
  "JOYANCE": "delight [n -S]\n",
  "JOYANCES": "JOYANCE, delight [n]\n",
  "JOYED": "JOY, to rejoice [v]\n",
  "JOYFUL": "full of joy [adj JOYFULLER, JOYFULLEST, JOYFULLY]\n",
  "JOYFULLER": "JOYFUL, full of joy [adj]\n",
  "JOYFULLEST": "JOYFUL, full of joy [adj]\n",
  "JOYFULLY": "JOYFUL, full of joy [adv]\n",
  "JOYFULNESS": "the state of being joyful [n -ES]\n",
  "JOYFULNESSES": "JOYFULNESS, the state of being joyful [n]\n",
  "JOYING": "JOY, to rejoice [v]\n",
  "JOYLESS": "without joy [adj JOYLESSLY]\n",
  "JOYLESSLY": "JOYLESS, without joy [adv]\n",
  "JOYLESSNESS": "the state of being joyless [n -ES]\n",
  "JOYLESSNESSES": "JOYLESSNESS, the state of being joyless [n]\n",
  "JOYOUS": "joyful [adj JOYOUSLY]\n",
  "JOYOUSLY": "JOYOUS, joyful [adv]\n",
  "JOYOUSNESS": "the state of being joyous [n -ES]\n",
  "JOYOUSNESSES": "JOYOUSNESS, the state of being joyous [n]\n",
  "JOYPAD": "a device consisting of a pad with buttons on it, used for controlling the motion of objects in a computer game [n -S]\n",
  "JOYPADS": "JOYPAD, a device consisting of a pad with buttons on it, used for controlling the motion of objects in a computer game [n]\n",
  "JOYPOP": "to use habit-forming drugs occasionally [v JOYPOPPED, JOYPOPPING, JOYPOPS]\n",
  "JOYPOPPED": "JOYPOP, to use habit-forming drugs occasionally [v]\n",
  "JOYPOPPER": "one who joypops, uses habit-forming drugs occasionally [n -S]\n",
  "JOYPOPPERS": "JOYPOPPER, one who joypops, uses habit-forming drugs occasionally [n]\n",
  "JOYPOPPING": "JOYPOP, to use habit-forming drugs occasionally [v]\n",
  "JOYPOPS": "JOYPOP, to use habit-forming drugs occasionally [v]\n",
  "JOYRIDDEN": "JOYRIDE, to take a ride for pleasure [v]\n",
  "JOYRIDE": "to take a ride for pleasure [v JOYRODE, JOYRIDDEN, JOYRIDING, JOYRIDES]\n",
  "JOYRIDER": "one who joyrides [n -S]\n",
  "JOYRIDERS": "JOYRIDER, one who joyrides [n]\n",
  "JOYRIDES": "JOYRIDE, to take a ride for pleasure [v]\n",
  "JOYRIDING": "the act of taking a car without the owner's permission [n -S]\n",
  "JOYRIDINGS": "JOYRIDING, the act of taking a car without the owner's permission [n]\n",
  "JOYRODE": "JOYRIDE, to take a ride for pleasure [v]\n",
  "JOYS": "JOY, to rejoice [v]\n",
  "JOYSTICK": "the control stick in an airplane [n -S]\n",
  "JOYSTICKS": "JOYSTICK, the control stick in an airplane [n]\n",
  "JUBA": "a Negro rustic dance [n -S]\n",
  "JUBAS": "JUBA, a Negro rustic dance [n]\n",
  "JUBATE": "having or possessing a mane [adj]\n",
  "JUBBAH": "(Arabic) a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JIBBA, JIBBAH, JUBHAH [n -S]\n",
  "JUBBAHS": "JUBBAH, (Arabic) a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JIBBA, JIBBAH, JUBHAH [n]\n",
  "JUBE": "(Latin) a rood-loft, or screen and gallery, in a church [n -S]\n",
  "JUBES": "JUBE, (Latin) a rood-loft, or screen and gallery, in a church [n]\n",
  "JUBHAH": "(Arabic) a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JIBBA, JIBBAH, JUBBAH [n -S]\n",
  "JUBHAHS": "JUBHAH, (Arabic) a long loose outer garment worn by Muslims, also DJIBBA, DJIBBAH, JIBBA, JIBBAH, JUBBAH [n]\n",
  "JUBILANCE": "jubilation, also JUBILANCY [n -S]\n",
  "JUBILANCES": "JUBILANCE, jubilation, also JUBILANCY [n]\n",
  "JUBILANCIES": "JUBILANCY, jubilation, also JUBILANCE [n]\n",
  "JUBILANCY": "jubilation, also JUBILANCE [n JUBILANCIES]\n",
  "JUBILANT": "exultant [adj JUBILANTLY]\n",
  "JUBILANTLY": "JUBILANT, exultant [adv]\n",
  "JUBILARIAN": "one celebrating a jubilee [n -S]\n",
  "JUBILARIANS": "JUBILARIAN, one celebrating a jubilee [n]\n",
  "JUBILATE": "to rejoice [v JUBILATED, JUBILATING, JUBILATES]\n",
  "JUBILATED": "JUBILATE, to rejoice [v]\n",
  "JUBILATES": "JUBILATE, to rejoice [v]\n",
  "JUBILATING": "JUBILATE, to rejoice [v]\n",
  "JUBILATION": "an act of rejoicing [n -S]\n",
  "JUBILATIONS": "JUBILATION, an act of rejoicing [n]\n",
  "JUBILE": "(Latin) a celebration, also JUBILEE [n -S]\n",
  "JUBILEE": "a celebration, also JUBILE [n -S]\n",
  "JUBILEES": "JUBILEE, a celebration, also JUBILE [n]\n",
  "JUBILES": "JUBILE, (Latin) a celebration, also JUBILEE [n]\n",
  "JUCO": "(US) junior college; an athlete at a junior college [n -S]\n",
  "JUCOS": "JUCO, (US) junior college; an athlete at a junior college [n]\n",
  "JUD": "a mass of coal ready for removal [n -S]\n",
  "JUDAS": "a peephole in a door [n -ES]\n",
  "JUDASES": "JUDAS, a peephole in a door [n]\n",
  "JUDDER": "to vibrate, shudder esp. of a machine [v -ED, -ING, -S]\n",
  "JUDDERED": "JUDDER, to vibrate, shudder esp. of a machine [v]\n",
  "JUDDERIER": "JUDDERY, given to juddering [adj]\n",
  "JUDDERIEST": "JUDDERY, given to juddering [adj]\n",
  "JUDDERING": "JUDDER, to vibrate, shudder esp. of a machine [v]\n",
  "JUDDERS": "JUDDER, to vibrate, shudder esp. of a machine [v]\n",
  "JUDDERY": "given to juddering [adj JUDDERIER, JUDDERIEST]\n",
  "JUDGE": "to decide on critically [v JUDGED, JUDGING, JUDGES]\n",
  "JUDGEABLE": "able to be judged [adj]\n",
  "JUDGED": "JUDGE, to decide on critically [v]\n",
  "JUDGELESS": "without a judge [adj]\n",
  "JUDGELIKE": "like a judge [adj]\n",
  "JUDGEMENT": "an act of judging, also JUDGMENT [n -S]\n",
  "JUDGEMENTAL": "giving to making judgements, also JUDGMENTAL [adj JUDGEMENTALLY]\n",
  "JUDGEMENTALLY": "JUDGEMENTAL, giving to making judgements, also JUDGMENTAL [adv]\n",
  "JUDGEMENTS": "JUDGEMENT, an act of judging, also JUDGMENT [n]\n",
  "JUDGER": "one who judges [n -S]\n",
  "JUDGERS": "JUDGER, one who judges [n]\n",
  "JUDGES": "JUDGE, to decide on critically [v]\n",
  "JUDGESHIP": "the office of a judge [n -S]\n",
  "JUDGESHIPS": "JUDGESHIP, the office of a judge [n]\n",
  "JUDGEY": "tending to judge others, also JUDGY [adj JUDGIER, JUDGIEST]\n",
  "JUDGIER": "JUDGY, tending to judge others, also JUDGEY [adj]\n",
  "JUDGIEST": "JUDGY, tending to judge others, also JUDGEY [adj]\n",
  "JUDGING": "the act of making a judgment [n -S]\n",
  "JUDGINGLY": "JUDGING [adv]\n",
  "JUDGINGS": "JUDGING, the act of making a judgment [n]\n",
  "JUDGMATIC": "given to judgment, also JUDGMATICAL [adj JUDGMATICALLY]\n",
  "JUDGMATICAL": "given to judgment, also JUDGMATIC [adj JUDGMATICALLY]\n",
  "JUDGMATICALLY": "JUDGMATICAL, given to judgment, also JUDGMATIC [adv]\n",
  "JUDGMENT": "an opinion formed [n -S]\n",
  "JUDGMENTAL": "given to making judgements, also JUDGEMENTAL [adj JUDGMENTALLY]\n",
  "JUDGMENTALLY": "JUDGMENTAL, given to making judgements, also JUDGEMENTAL [adv]\n",
  "JUDGMENTS": "JUDGMENT, an opinion formed [n]\n",
  "JUDGY": "tending to judge others, also JUDGEY [adj JUDGIER, JUDGIEST]\n",
  "JUDICABLE": "capable of being judged or tried [adj]\n",
  "JUDICARE": "government-paid legal services [n -S]\n",
  "JUDICARES": "JUDICARE, government-paid legal services [n]\n",
  "JUDICATION": "judgment [n -S]\n",
  "JUDICATIONS": "JUDICATION, judgment [n]\n",
  "JUDICATIVE": "having power to judge; as, the judicative faculty [adj]\n",
  "JUDICATOR": "a person who judges [n -S]\n",
  "JUDICATORIAL": "relating to the judicatory [adj]\n",
  "JUDICATORIES": "JUDICATORY, the judicature, a court [n]\n",
  "JUDICATORS": "JUDICATOR, a person who judges [n]\n",
  "JUDICATORY": "the judicature, a court [n JUDICATORIES]\n",
  "JUDICATURE": "the power of dispensing justice by trial [n -S]\n",
  "JUDICATURES": "JUDICATURE, the power of dispensing justice by trial [n]\n",
  "JUDICIAL": "pertaining to courts of law [adj JUDICIALLY]\n",
  "JUDICIALLY": "JUDICIAL, pertaining to courts of law [adv]\n",
  "JUDICIARIES": "JUDICIARY, the judicial authorities of a country; judges collectively [n]\n",
  "JUDICIARILY": "JUDICIARY, having judicial power [adv]\n",
  "JUDICIARY": "the judicial authorities of a country; judges collectively [n JUDICIARIES] / having judicial power [adj JUDICIARILY]\n",
  "JUDICIOUS": "showing judgment [adj JUDICIOUSLY]\n",
  "JUDICIOUSLY": "JUDICIOUS, showing judgment [adv]\n",
  "JUDICIOUSNESS": "the state of being judicious [n -ES]\n",
  "JUDICIOUSNESSES": "JUDICIOUSNESS, the state of being judicious [n]\n",
  "JUDIES": "JUDY, (slang) a girl, a girlfriend [n]\n",
  "JUDO": "(Japanese) a Japanese form of unarmed combat [n -S]\n",
  "JUDOGI": "(Japanese) a judo costume [n -S]\n",
  "JUDOGIS": "JUDOGI, (Japanese) a judo costume [n]\n",
  "JUDOIST": "one skilled in judo, also JUDOKA [n -S]\n",
  "JUDOISTS": "JUDOIST, one skilled in judo, also JUDOKA [n]\n",
  "JUDOKA": "(Japanese) one skilled in judo, also JUDOIST [n -S]\n",
  "JUDOKAS": "JUDOKA, (Japanese) one skilled in judo, also JUDOIST [n]\n",
  "JUDOS": "JUDO, (Japanese) a Japanese form of unarmed combat [n]\n",
  "JUDS": "JUD, a mass of coal ready for removal [n]\n",
  "JUDY": "(slang) a girl, a girlfriend [n JUDIES]\n",
  "JUG": "to stew in a closed container [v JUGGED, JUGGING, JUGS]\n",
  "JUGA": "JUGUM, (Latin) a pair of opposite leaves [n]\n",
  "JUGAAD": "(Hindi) a resourceful approach to problem-solving [n -S]\n",
  "JUGAADS": "JUGAAD, (Hindi) a resourceful approach to problem-solving [n]\n",
  "JUGAL": "the cheek bone [n -S]\n",
  "JUGALS": "JUGAL, the cheek bone [n]\n",
  "JUGATE": "having leaflets arranged in pairs [adj]\n",
  "JUGFUL": "as much as a jug will hold [n JUGFULS or JUGSFUL]\n",
  "JUGFULS": "JUGFUL, as much as a jug will hold [n]\n",
  "JUGGED": "JUG, to stew in a closed container [v]\n",
  "JUGGERNAUT": "(Sanskrit) a massive relentless force, person, institution, etc. that crushes everything in its path [n -S]\n",
  "JUGGERNAUTS": "JUGGERNAUT, (Sanskrit) a massive relentless force, person, institution, etc. that crushes everything in its path [n]\n",
  "JUGGING": "the act of jugging [n -S]\n",
  "JUGGINGS": "JUGGING, the act of jugging [n]\n",
  "JUGGINS": "a simpleton [n -ES]\n",
  "JUGGINSES": "JUGGINS, a simpleton [n]\n",
  "JUGGLE": "to manipulate objects with dexterity [v JUGGLED, JUGGLING, JUGGLES]\n",
  "JUGGLED": "JUGGLE, to manipulate objects with dexterity [v]\n",
  "JUGGLER": "one who juggles [n -S]\n",
  "JUGGLERIES": "JUGGLERY, the art of juggler [n]\n",
  "JUGGLERS": "JUGGLER, one who juggles [n]\n",
  "JUGGLERY": "the art of juggler [n JUGGLERIES]\n",
  "JUGGLES": "JUGGLE, to manipulate objects with dexterity [v]\n",
  "JUGGLING": "the act of juggling [n -S]\n",
  "JUGGLINGLY": "JUGGLING [adv]\n",
  "JUGGLINGS": "JUGGLING, the act of juggling [n]\n",
  "JUGHEAD": "an idiot, a fool [n -S]\n",
  "JUGHEADS": "JUGHEAD, an idiot, a fool [n]\n",
  "JUGLANDACEOUS": "belonging to the walnut family [adj]\n",
  "JUGLET": "a small jug [n -S]\n",
  "JUGLETS": "JUGLET, a small jug [n]\n",
  "JUGS": "JUG, to stew in a closed container [v]\n",
  "JUGSFUL": "JUGFUL, as much as a jug will hold [n]\n",
  "JUGULA": "JUGULUM, (Latin) the front part of the neck [n]\n",
  "JUGULAR": "pertaining to neck or throat [adj] / a vein in the neck [n -S]\n",
  "JUGULARS": "JUGULAR, a vein in the neck [n]\n",
  "JUGULATE": "to cut the throat of [v JUGULATED, JUGULATING, JUGULATES]\n",
  "JUGULATED": "JUGULATE, to cut the throat of [v]\n",
  "JUGULATES": "JUGULATE, to cut the throat of [v]\n",
  "JUGULATING": "JUGULATE, to cut the throat of [v]\n",
  "JUGULATION": "the act of jugulating [n -S]\n",
  "JUGULATIONS": "JUGULATION, the act of jugulating [n]\n",
  "JUGULUM": "(Latin) the front part of the neck [n JUGULA]\n",
  "JUGUM": "(Latin) a pair of opposite leaves [n JUGUMS or JUGA]\n",
  "JUGUMS": "JUGUM, (Latin) a pair of opposite leaves [n]\n",
  "JUICE": "to extract liquid from fruit or vegetables [v JUICED, JUICING, JUICES]\n",
  "JUICED": "JUICE, to extract liquid from fruit or vegetables [v]\n",
  "JUICEHEAD": "(slang) an alcoholic [n -S]\n",
  "JUICEHEADS": "JUICEHEAD, (slang) an alcoholic [n]\n",
  "JUICELESS": "without juice [adj]\n",
  "JUICER": "a juice extractor [n -S]\n",
  "JUICERS": "JUICER, a juice extractor [n]\n",
  "JUICES": "JUICE, to extract liquid from fruit or vegetables [v]\n",
  "JUICIER": "JUICY, full of juice [adj]\n",
  "JUICIEST": "JUICY, full of juice [adj]\n",
  "JUICILY": "JUICY, full of juice [adv]\n",
  "JUICINESS": "the state of being juicy [n -ES]\n",
  "JUICINESSES": "JUICINESS, the state of being juicy [n]\n",
  "JUICING": "JUICE, to extract liquid from fruit or vegetables [v]\n",
  "JUICY": "full of juice [adj JUICIER, JUICIEST, JUICILY]\n",
  "JUJITSU": "(Japanese) a Japanese art of self defence, also JIUJITSU, JIUJUTSU, JUJUTSU [n -S]\n",
  "JUJITSUS": "JUJITSU, (Japanese) a Japanese art of self defence, also JIUJITSU, JIUJUTSU, JUJUTSU [n]\n",
  "JUJU": "a fetish or charm [n -S]\n",
  "JUJUBE": "a fruit-flavored candy [n -S]\n",
  "JUJUBES": "JUJUBE, a fruit-flavored candy [n]\n",
  "JUJUISM": "a belief in jujus [n -S]\n",
  "JUJUISMS": "JUJUISM, a belief in jujus [n]\n",
  "JUJUIST": "a follower of jujuism [n -S]\n",
  "JUJUISTS": "JUJUIST, a follower of jujuism [n]\n",
  "JUJUS": "JUJU, a fetish or charm [n]\n",
  "JUJUTSU": "(Japanese) a Japanese art of self defence, also JIUJITSU, JIUJUTSU, JUJITSU [n -S]\n",
  "JUJUTSUS": "JUJUTSU, (Japanese) a Japanese art of self defence, also JIUJITSU, JIUJUTSU, JUJITSU [n]\n",
  "JUKE": "to dance [v JUKED, JUKING, JUKES]\n",
  "JUKEBOX": "a coin-operated gramophone machine [n -ES]\n",
  "JUKEBOXES": "JUKEBOX, a coin-operated gramophone machine [n]\n",
  "JUKED": "JUKE, to dance [v]\n",
  "JUKES": "JUKE, to dance [v]\n",
  "JUKING": "JUKE, to dance [v]\n",
  "JUKSKEI": "(South African) an outdoor game similar to quoits [n -S]\n",
  "JUKSKEIS": "JUKSKEI, (South African) an outdoor game similar to quoits [n]\n",
  "JUKU": "(Japanese) a school that prepares students for entrance exams e.g. to university [n -S]\n",
  "JUKUS": "JUKU, (Japanese) a school that prepares students for entrance exams e.g. to university [n]\n",
  "JULEP": "(Persian) a cocktail of bourbon, sugar, and mint [n -S]\n",
  "JULEPS": "JULEP, (Persian) a cocktail of bourbon, sugar, and mint [n]\n",
  "JULIENNE": "(French) a kind of soup containing thin slices or shreds of carrots, onions, etc. [n -S] / to shred or cut into thin strips [v JULIENNED, JULIENNING, JULIENNES]\n",
  "JULIENNED": "JULIENNE, to shred or cut into thin strips [v]\n",
  "JULIENNES": "JULIENNE, to shred or cut into thin strips [v]\n",
  "JULIENNING": "JULIENNE, to shred or cut into thin strips [v]\n",
  "JULIET": "(in international radio communication) a code word for the letter j [n -S]\n",
  "JULIETS": "JULIET, (in international radio communication) a code word for the letter j [n]\n",
  "JUMAR": "to climb using ropes and clips [v JUMARRED or JUMARED, JUMARRING or JUMARING, JUMARS]\n",
  "JUMARED": "JUMAR, to climb using ropes and clips [v]\n",
  "JUMARING": "JUMAR, to climb using ropes and clips [v]\n",
  "JUMARRED": "JUMAR, to climb using ropes and clips [v]\n",
  "JUMARRING": "JUMAR, to climb using ropes and clips [v]\n",
  "JUMARS": "JUMAR, to climb using ropes and clips [v]\n",
  "JUMART": "the supposed offspring of a bull and a mare [n -S]\n",
  "JUMARTS": "JUMART, the supposed offspring of a bull and a mare [n]\n",
  "JUMBAL": "a thin crisp sweet cake [n -S]\n",
  "JUMBALS": "JUMBAL, a thin crisp sweet cake [n]\n",
  "JUMBIE": "(West Indian) a ghost or evil spirit, also JUMBY [n -S]\n",
  "JUMBIES": "JUMBY, (West Indian) a ghost or evil spirit, also JUMBIE [n]\n",
  "JUMBLE": "to mix in a disordered manner [v JUMBLED, JUMBLING, JUMBLES]\n",
  "JUMBLED": "JUMBLE, to mix in a disordered manner [v]\n",
  "JUMBLER": "one that jumbles [n -S]\n",
  "JUMBLERS": "JUMBLER, one that jumbles [n]\n",
  "JUMBLES": "JUMBLE, to mix in a disordered manner [v]\n",
  "JUMBLIER": "JUMBLY, in a jumble [adj]\n",
  "JUMBLIEST": "JUMBLY, in a jumble [adj]\n",
  "JUMBLING": "JUMBLE, to mix in a disordered manner [v]\n",
  "JUMBLINGLY": "JUMBLING, JUMBLE, to mix in a disordered manner [adv]\n",
  "JUMBLY": "in a jumble [adj JUMBLIER, JUMBLIEST]\n",
  "JUMBO": "(colloquial) an elephant [n -S]\n",
  "JUMBOISE": "to enlarge a ship using prefabricated sections, also JUMBOIZE [v JUMBOISED, JUMBOISING, JUMBOISES]\n",
  "JUMBOISED": "JUMBOISE, to enlarge a ship using prefabricated sections, also JUMBOIZE [v]\n",
  "JUMBOISES": "JUMBOISE, to enlarge a ship using prefabricated sections, also JUMBOIZE [v]\n",
  "JUMBOISING": "JUMBOISE, to enlarge a ship using prefabricated sections, also JUMBOIZE [v]\n",
  "JUMBOIZE": "to enlarge a ship using prefabricated sections, also JUMBOISE [v JUMBOIZED, JUMBOIZING, JUMBOIZES]\n",
  "JUMBOIZED": "JUMBOIZE, to enlarge a ship using prefabricated sections, also JUMBOISE [v]\n",
  "JUMBOIZES": "JUMBOIZE, to enlarge a ship using prefabricated sections, also JUMBOISE [v]\n",
  "JUMBOIZING": "JUMBOIZE, to enlarge a ship using prefabricated sections, also JUMBOISE [v]\n",
  "JUMBOS": "JUMBO, (colloquial) an elephant [n]\n",
  "JUMBUCK": "(Australian slang) a sheep [n -S]\n",
  "JUMBUCKS": "JUMBUCK, (Australian slang) a sheep [n]\n",
  "JUMBY": "(West Indian) a ghost or evil spirit, also JUMBIE [n JUMBIES]\n",
  "JUMELLE": "(French) a paired or twinned article; opera-glasses [n -S]\n",
  "JUMELLES": "JUMELLE, (French) a paired or twinned article; opera-glasses [n]\n",
  "JUMHOURIYA": "(Arabic) in Arab socialist states, the people or proletariat state, also JAMAHIRIYA [n -S]\n",
  "JUMHOURIYAS": "JUMHOURIYA, (Arabic) in Arab socialist states, the people or proletariat state, also JAMAHIRIYA [n]\n",
  "JUMP": "to leap into the air [v -ED, -ING, -S]\n",
  "JUMPABLE": "able to be jumped [adj]\n",
  "JUMPED": "JUMP, to leap into the air [v]\n",
  "JUMPER": "a type of overall, slipped over the head [n -S]\n",
  "JUMPERS": "JUMPER, a type of overall, slipped over the head [n]\n",
  "JUMPIER": "JUMPY, nervy [adj]\n",
  "JUMPIEST": "JUMPY, nervy [adj]\n",
  "JUMPILY": "JUMPY, nervy [adv]\n",
  "JUMPINESS": "the state of being jumpy [n -ES]\n",
  "JUMPINESSES": "JUMPINESS, the state of being jumpy [n]\n",
  "JUMPING": "the act of jumping [n -S]\n",
  "JUMPINGLY": "JUMPING [adv]\n",
  "JUMPINGS": "JUMPING, the act of jumping [n]\n",
  "JUMPOFF": "a starting point [n -S]\n",
  "JUMPOFFS": "JUMPOFF, a starting point [n]\n",
  "JUMPROPE": "a rope used in children's games for jumping [n -S]\n",
  "JUMPROPES": "JUMPROPE, a rope used in children's games for jumping [n]\n",
  "JUMPS": "JUMP, to leap into the air [v]\n",
  "JUMPSHOT": "a type of shot in basketball [n -S]\n",
  "JUMPSHOTS": "JUMPSHOT, a type of shot in basketball [n]\n",
  "JUMPSIES": "a game involving jumping over a taut rope [n]\n",
  "JUMPSUIT": "a one-piece garment for either sex, combining trousers and jacket or blouse [n -S]\n",
  "JUMPSUITS": "JUMPSUIT, a one-piece garment for either sex, combining trousers and jacket or blouse [n]\n",
  "JUMPY": "nervy [adj JUMPIER, JUMPIEST, JUMPILY]\n",
  "JUN": "a North Korean coin [n JUN]\n",
  "JUNCACEOUS": "of or pertaining to rushes [adj]\n",
  "JUNCATE": "(Spenser) a junket, a dessert made from curds, also JUNKET [n -S]\n",
  "JUNCATES": "JUNCATE, (Spenser) a junket, a dessert made from curds, also JUNKET [n]\n",
  "JUNCO": "(Spanish) a North American bird [n JUNCOS or JUNCOES]\n",
  "JUNCOES": "JUNCO, (Spanish) a North American bird [n]\n",
  "JUNCOS": "JUNCO, (Spanish) a North American bird [n]\n",
  "JUNCTION": "an intersection [n -S]\n",
  "JUNCTIONAL": "relating to junctions [adj]\n",
  "JUNCTIONS": "JUNCTION, an intersection [n]\n",
  "JUNCTURAL": "relating to junctures [adj]\n",
  "JUNCTURE": "the act of joining [n -S]\n",
  "JUNCTURES": "JUNCTURE, the act of joining [n]\n",
  "JUNCUS": "(Latin) any plant of the genus Juncus, rushes [n -ES]\n",
  "JUNCUSES": "JUNCUS, (Latin) any plant of the genus Juncus, rushes [n]\n",
  "JUNEATING": "an erroneous form of jenneting, an early type of apple, also JENNETING [n -S]\n",
  "JUNEATINGS": "JUNEATING, an erroneous form of jenneting, an early type of apple, also JENNETING [n]\n",
  "JUNGLE": "land covered with dense tropical vegetation [n -S]\n",
  "JUNGLED": "abounding in jungle [adj]\n",
  "JUNGLEGYM": "(tradename) a climbing frame for children [n -S]\n",
  "JUNGLEGYMS": "JUNGLEGYM, (tradename) a climbing frame for children [n]\n",
  "JUNGLELIKE": "like a jungle [adj]\n",
  "JUNGLES": "JUNGLE, land covered with dense tropical vegetation [n]\n",
  "JUNGLI": "an uneducated peasant [n -S]\n",
  "JUNGLIER": "JUNGLY, of or relating to jungles [adj]\n",
  "JUNGLIEST": "JUNGLY, of or relating to jungles [adj]\n",
  "JUNGLIS": "JUNGLI, an uneducated peasant [n]\n",
  "JUNGLIST": "an adherent of jungle, a style of rock music [n -S]\n",
  "JUNGLISTS": "JUNGLIST, an adherent of jungle, a style of rock music [n]\n",
  "JUNGLY": "of or relating to jungles [adj JUNGLIER, JUNGLIEST]\n",
  "JUNIOR": "(of a lawyer) to assist the lead lawyer on a case [v -ED, -ING, -S]\n",
  "JUNIORATE": "a course of high school or college study for candidates for the priesthood [n -S]\n",
  "JUNIORATES": "JUNIORATE, a course of high school or college study for candidates for the priesthood [n]\n",
  "JUNIORED": "JUNIOR, (of a lawyer) to assist the lead lawyer on a case [v]\n",
  "JUNIORING": "JUNIOR, (of a lawyer) to assist the lead lawyer on a case [v]\n",
  "JUNIORITIES": "JUNIORITY, the state of being junior [n]\n",
  "JUNIORITY": "the state of being junior [n JUNIORITIES]\n",
  "JUNIORS": "JUNIOR, (of a lawyer) to assist the lead lawyer on a case [v]\n",
  "JUNIPER": "an evergreen coniferous shrub whose berries are used in making gin [n -S]\n",
  "JUNIPERS": "JUNIPER, an evergreen coniferous shrub whose berries are used in making gin [n]\n",
  "JUNK": "to discard as trash [v -ED, -ING, -S]\n",
  "JUNKANOO": "a boisterous West Indian dance, also JONCANOE [n -S]\n",
  "JUNKANOOS": "JUNKANOO, a boisterous West Indian dance, also JONCANOE [n]\n",
  "JUNKED": "JUNK, to discard as trash [v]\n",
  "JUNKER": "(German) a young German noble or squire; esp. a member of the aristocratic party in Prussia [n -S]\n",
  "JUNKERDOM": "the office of junker [n -S]\n",
  "JUNKERDOMS": "JUNKERDOM, the office of junker [n]\n",
  "JUNKERS": "JUNKER, (German) a young German noble or squire; esp. a member of the aristocratic party in Prussia [n]\n",
  "JUNKET": "a pleasure trip, particularly one made by government officials [n -S] / to go on such a pleasure trip [v JUNKETTED or JUNKETED, JUNKETTING or JUNKETING, JUNKETS]\n",
  "JUNKETED": "JUNKET, to go on such a pleasure trip [v]\n",
  "JUNKETEER": "one who junkets, feasts, also JUNKETER, JUNKETTER [n -S] / to engage in junketeering [v -ED, -ING, -S]\n",
  "JUNKETEERED": "JUNKETEER, to engage in junketeering [v]\n",
  "JUNKETEERING": "JUNKETEER, to engage in junketeering [v]\n",
  "JUNKETEERS": "JUNKETEER, one who junkets, feasts, also JUNKETER, JUNKETTER [n]\n",
  "JUNKETER": "one that junkets, also JUNKETTER [n -S]\n",
  "JUNKETERS": "JUNKETER, one that junkets, also JUNKETTER [n]\n",
  "JUNKETING": "going on a pleasure trip [n -S]\n",
  "JUNKETINGS": "JUNKETING, going on a pleasure trip [n]\n",
  "JUNKETS": "JUNKET, to go on such a pleasure trip [v]\n",
  "JUNKETTED": "JUNKET, to go on such a pleasure trip [v]\n",
  "JUNKETTER": "one who junkets, feasts, also JUNKETEER, JUNKETER [n -S]\n",
  "JUNKETTERS": "JUNKETTER, one who junkets, feasts, also JUNKETEER, JUNKETER [n]\n",
  "JUNKETTING": "JUNKET, to go on such a pleasure trip [v]\n",
  "JUNKIE": "a narcotics addict, also JUNKY [n -S]\n",
  "JUNKIER": "JUNKY, rubbishy, worthless [adj]\n",
  "JUNKIES": "JUNKIE, a narcotics addict, also JUNKY [n]\n",
  "JUNKIEST": "JUNKY, rubbishy, worthless [adj]\n",
  "JUNKINESS": "the quality of being junk [n -ES]\n",
  "JUNKINESSES": "JUNKINESS, the quality of being junk [n]\n",
  "JUNKING": "JUNK, to discard as trash [v]\n",
  "JUNKMAN": "a man who buys and sells junk [n JUNKMEN]\n",
  "JUNKMEN": "JUNKMAN, a man who buys and sells junk [n]\n",
  "JUNKS": "JUNK, to discard as trash [v]\n",
  "JUNKY": "rubbishy, worthless [adj JUNKIER, JUNKIEST] / a narcotics addict, also JUNKIE [n JUNKIES]\n",
  "JUNKYARD": "a yard where junk is stored [n -S]\n",
  "JUNKYARDS": "JUNKYARD, a yard where junk is stored [n]\n",
  "JUNTA": "(Spanish) a government council [n -S]\n",
  "JUNTAS": "JUNTA, (Spanish) a government council [n]\n",
  "JUNTO": "(Spanish) a group, esp. one made of military officers, ruling a country after a coup, also JUNTA [n -S]\n",
  "JUNTOS": "JUNTO, (Spanish) a group, esp. one made of military officers, ruling a country after a coup, also JUNTA [n]\n",
  "JUPATI": "(Tupi) a large Brazilian palm tree [n -S]\n",
  "JUPATIS": "JUPATI, (Tupi) a large Brazilian palm tree [n]\n",
  "JUPE": "a woman's jacket [n -S]\n",
  "JUPES": "JUPE, a woman's jacket [n]\n",
  "JUPON": "a sleeveless jacket worn beneath a hauberk, also GIPON [n -S]\n",
  "JUPONS": "JUPON, a sleeveless jacket worn beneath a hauberk, also GIPON [n]\n",
  "JURA": "JUS, (Latin) a law or legal right [n]\n",
  "JURAL": "pertaining to law [adj JURALLY]\n",
  "JURALLY": "JURAL, pertaining to law [adv]\n",
  "JURANT": "one who takes an oath [n -S]\n",
  "JURANTS": "JURANT, one who takes an oath [n]\n",
  "JURASSIC": "relating to the second period of the Mesozoic era [adj]\n",
  "JURAT": "(Latin) a memorandum at the end of an affidavit showing to whom it was sworn [n -S]\n",
  "JURATORY": "pertaining to an oath [adj]\n",
  "JURATS": "JURAT, (Latin) a memorandum at the end of an affidavit showing to whom it was sworn [n]\n",
  "JURE": "(Latin) by right or law, also IURE [adv] / jurisprudence [n -S]\n",
  "JUREL": "(Spanish) a kind of food fish [n -S]\n",
  "JURELS": "JUREL, (Spanish) a kind of food fish [n]\n",
  "JURES": "JURE, jurisprudence [n]\n",
  "JURIDIC": "relating to the administration of justice; pertaining to a judge, also JURIDICAL [adj JURIDICALLY]\n",
  "JURIDICAL": "relating to the administration of justice; pertaining to a judge, also JURIDIC [adj JURIDICALLY]\n",
  "JURIDICALLY": "JURIDICAL, relating to the administration of justice; pertaining to a judge, also JURIDIC [adv]\n",
  "JURIED": "JURY, to select material for exhibition [v]\n",
  "JURIES": "JURY, to select material for exhibition [v]\n",
  "JURISCONSULT": "someone who is consulted on the law; a lawyer who gives opinions on cases put to him or her [n -S]\n",
  "JURISCONSULTS": "JURISCONSULT, someone who is consulted on the law; a lawyer who gives opinions on cases put to him or her [n]\n",
  "JURISDICTION": "the power, right, or authority to interpret and apply the law [n -S]\n",
  "JURISDICTIONAL": "relating to jurisdiction, also JURISDICTIVE [adj]\n",
  "JURISDICTIONS": "JURISDICTION, the power, right, or authority to interpret and apply the law [n]\n",
  "JURISDICTIVE": "relating to jurisdiction, also JURISDICTIONAL [adj]\n",
  "JURISPRUDENCE": "the science or philosophy of law [n -S]\n",
  "JURISPRUDENCES": "JURISPRUDENCE, the science or philosophy of law [n]\n",
  "JURISPRUDENT": "a person who is knowledgeable in jurisprudence [n -S]\n",
  "JURISPRUDENTIAL": "relating to jurisprudence [adj]\n",
  "JURISPRUDENTS": "JURISPRUDENT, a person who is knowledgeable in jurisprudence [n]\n",
  "JURIST": "one versed in the law [n -S]\n",
  "JURISTIC": "of or pertaining to a jurist, to the legal profession, or to jurisprudence, also JURISTICAL [adj JURISTICALLY]\n",
  "JURISTICAL": "of or pertaining to a jurist, to the legal profession, or to jurisprudence, also JURISTIC [adj JURISTICALLY]\n",
  "JURISTICALLY": "JURISTICAL, of or pertaining to a jurist, to the legal profession, or to jurisprudence, also JURISTIC [adv]\n",
  "JURISTS": "JURIST, one versed in the law [n]\n",
  "JUROR": "a member of a jury, also JURYMAN [n -S]\n",
  "JURORS": "JUROR, a member of a jury, also JURYMAN [n]\n",
  "JURY": "a committee of adjudicators or examiners [n JURIES] / to select material for exhibition [v JURIED, JURYING, JURIES]\n",
  "JURYING": "JURY, to select material for exhibition [v]\n",
  "JURYLESS": "with no jury [adj]\n",
  "JURYMAN": "a member of a jury, also JUROR [n JURYMEN]\n",
  "JURYMAST": "a temporary mast [n -S]\n",
  "JURYMASTS": "JURYMAST, a temporary mast [n]\n",
  "JURYMEN": "JURYMAN, a member of a jury, also JUROR [n]\n",
  "JURYWOMAN": "a woman who serves on a jury [n JURYWOMEN]\n",
  "JURYWOMEN": "JURYWOMAN, a woman who serves on a jury [n]\n",
  "JUS": "(Latin) a law or legal right [n JURA]\n",
  "JUSSIVE": "a word used to express command [n -S]\n",
  "JUSSIVES": "JUSSIVE, a word used to express command [n]\n",
  "JUST": "fair, impartial [adj JUSTER, JUSTEST, JUSTLY] / to tilt with lances, also GIUST, JOUST [v -ED, -ING, -S]\n",
  "JUSTED": "JUST, to tilt with lances, also GIUST, JOUST [v]\n",
  "JUSTER": "one who tilts with lances, also JOUSTER [n -S]\n",
  "JUSTERS": "JUSTER, one who tilts with lances, also JOUSTER [n]\n",
  "JUSTEST": "JUST, fair, impartial [adj]\n",
  "JUSTICE": "a judge [n -S]\n",
  "JUSTICER": "(obsolete) a judge, magistrate, also JUSTICIAR, JUSTICIARY [n -S]\n",
  "JUSTICERS": "JUSTICER, (obsolete) a judge, magistrate, also JUSTICIAR, JUSTICIARY [n]\n",
  "JUSTICES": "JUSTICE, a judge [n]\n",
  "JUSTICESHIP": "the office or dignity of a justice [n -S]\n",
  "JUSTICESHIPS": "JUSTICESHIP, the office or dignity of a justice [n]\n",
  "JUSTICIABILITY": "the state of being justiciable [n]\n",
  "JUSTICIABLE": "liable to trial [adj]\n",
  "JUSTICIALISM": "the political ideology of Juan Domingo Peron, President of Argentina, which combined Fascism and Socialism [n -S]\n",
  "JUSTICIALISMS": "JUSTICIALISM, the political ideology of Juan Domingo Peron, President of Argentina, which combined Fascism and Socialism [n]\n",
  "JUSTICIAR": "(historical) an administrator of justice; a supreme judge, also JUSTICER, JUSTICIARY [n -S]\n",
  "JUSTICIARIES": "JUSTICIARY, an old name for the judges of the higher English courts, also JUSTICER, JUSTICIAR [n]\n",
  "JUSTICIARS": "JUSTICIAR, (historical) an administrator of justice; a supreme judge, also JUSTICER, JUSTICIARY [n]\n",
  "JUSTICIARSHIP": "the office of justiciar [n -S]\n",
  "JUSTICIARSHIPS": "JUSTICIARSHIP, the office of justiciar [n]\n",
  "JUSTICIARY": "an old name for the judges of the higher English courts, also JUSTICER, JUSTICIAR [n JUSTICIARIES]\n",
  "JUSTIFIABILITY": "the state of being justifiable [n]\n",
  "JUSTIFIABLE": "that can be justified [adj JUSTIFIABLY]\n",
  "JUSTIFIABLENESS": "JUSTIFIABLE, that can be justified [n]\n",
  "JUSTIFIABLY": "JUSTIFIABLE, that can be justified [adv]\n",
  "JUSTIFICATION": "the act, process, or state of being justified by God [n -S]\n",
  "JUSTIFICATIONS": "JUSTIFICATION, the act, process, or state of being justified by God [n]\n",
  "JUSTIFICATIVE": "serving to justify, also JUSTIFICATORY [adj]\n",
  "JUSTIFICATOR": "a person who defends or vindicates; a person who pardons and absolves from guilt and punishment [n -S]\n",
  "JUSTIFICATORS": "JUSTIFICATOR, a person who defends or vindicates; a person who pardons and absolves from guilt and punishment [n]\n",
  "JUSTIFICATORY": "serving to justify, also JUSTIFICATIVE [adj]\n",
  "JUSTIFIED": "JUSTIFY, to vindicate [v]\n",
  "JUSTIFIER": "one who justifies [n -S]\n",
  "JUSTIFIERS": "JUSTIFIER, one who justifies [n]\n",
  "JUSTIFIES": "JUSTIFY, to vindicate [v]\n",
  "JUSTIFY": "to vindicate [v JUSTIFIED, JUSTIFYING, JUSTIFIES]\n",
  "JUSTIFYING": "JUSTIFY, to vindicate [v]\n",
  "JUSTING": "JUST, to tilt with lances, also GIUST, JOUST [v]\n",
  "JUSTLE": "to run or strike against, also JOSTLE [v JUSTLED, JUSTLING, JUSTLES]\n",
  "JUSTLED": "JUSTLE, to run or strike against, also JOSTLE [v]\n",
  "JUSTLES": "JUSTLE, to run or strike against, also JOSTLE [v]\n",
  "JUSTLING": "JUSTLE, to run or strike against, also JOSTLE [v]\n",
  "JUSTLY": "JUST, fair, impartial [adv]\n",
  "JUSTNESS": "the quality of being just [n -ES]\n",
  "JUSTNESSES": "JUSTNESS, the quality of being just [n]\n",
  "JUSTS": "JUST, to tilt with lances, also GIUST, JOUST [v]\n",
  "JUT": "to project, stick out [v JUTTED, JUTTING, JUTS]\n",
  "JUTE": "a fibre obtained from the phloem of two plants of the linden family, used for making ropes [n -S]\n",
  "JUTELIKE": "like jute [adj]\n",
  "JUTES": "JUTE, a fibre obtained from the phloem of two plants of the linden family, used for making ropes [n]\n",
  "JUTS": "JUT, to project, stick out [v]\n",
  "JUTTED": "JUT, to project, stick out [v]\n",
  "JUTTIED": "JUTTY, to stick out [v]\n",
  "JUTTIER": "JUTTY, jutting out [adj]\n",
  "JUTTIES": "JUTTY, to stick out [v]\n",
  "JUTTIEST": "JUTTY, jutting out [adj]\n",
  "JUTTING": "JUT, to project, stick out [v]\n",
  "JUTTINGLY": "JUTTING, JUT, to project, stick out [adv]\n",
  "JUTTY": "jutting out [adj JUTTIER, JUTTIEST] / to stick out [v JUTTIED, JUTTYING, JUTTIES]\n",
  "JUTTYING": "JUTTY, to stick out [v]\n",
  "JUVE": "(short for) a juvenile lead in the theatre [n -S]\n",
  "JUVENAL": "a young bird [n -S]\n",
  "JUVENALS": "JUVENAL, a young bird [n]\n",
  "JUVENESCENCE": "the state of growing young [n -S]\n",
  "JUVENESCENCES": "JUVENESCENCE, the state of growing young [n]\n",
  "JUVENESCENT": "becoming youthful [adj]\n",
  "JUVENILE": "young, not adult [adj JUVENILELY] / a young person [n -S]\n",
  "JUVENILELY": "JUVENILE, young, not adult [adv]\n",
  "JUVENILENESS": "the state of being juvenile [n -ES]\n",
  "JUVENILENESSES": "JUVENILENESS, the state of being juvenile [n]\n",
  "JUVENILES": "JUVENILE, a young person [n]\n",
  "JUVENILIA": "(Latin) works of one's youth; early works of an artist or author [n]\n",
  "JUVENILITIES": "JUVENILITY, youthfulness; adolescence [n]\n",
  "JUVENILITY": "youthfulness; adolescence [n JUVENILITIES]\n",
  "JUVES": "JUVE, (short for) a juvenile lead in the theatre [n]\n",
  "JUVIE": "(slang) a juvenile detention centre [n -S]\n",
  "JUVIES": "JUVIE, (slang) a juvenile detention centre [n]\n",
  "JUXTAPOSE": "to place side by side [v JUXTAPOSED, JUXTAPOSING, JUXTAPOSES]\n",
  "JUXTAPOSED": "JUXTAPOSE, to place side by side [v]\n",
  "JUXTAPOSES": "JUXTAPOSE, to place side by side [v]\n",
  "JUXTAPOSING": "JUXTAPOSE, to place side by side [v]\n",
  "JUXTAPOSITION": "the act or an instance of placing two or more things side by side [n -S]\n",
  "JUXTAPOSITIONAL": "in a state of juxtaposition [adj]\n",
  "JUXTAPOSITIONS": "JUXTAPOSITION, the act or an instance of placing two or more things side by side [n]\n",
  "JYMOLD": "(Shakespeare) jointed, hinged, also GIMMALLED [adj]\n",
  "JYNX": "the wryneck, a bird related to the woodpecker [n -ES]\n",
  "JYNXES": "JYNX, the wryneck, a bird related to the woodpecker [n]\n",
  "KA": "to serve, also KAE [v -ED, -ING, -S]\n",
  "KAAL": "(South African) naked [adj]\n",
  "KAAMA": "a large South African antelope, aka hartebeest [n -S]\n",
  "KAAMAS": "KAAMA, a large South African antelope, aka hartebeest [n]\n",
  "KAAS": "a large cupboard [n KAAS]\n",
  "KAB": "an ancient Hebrew unit of measure [n -S]\n",
  "KABAB": "(Arabic) cubes of meat cooked on a skewer [n -S] / to cook on a skewer, also CABOB, KABOB, KEBAB, KEBOB [v KABABBED, KABABBING, KABABS]\n",
  "KABABBED": "KABAB, to cook on a skewer, also CABOB, KABOB, KEBAB, KEBOB [v]\n",
  "KABABBING": "KABAB, to cook on a skewer, also CABOB, KABOB, KEBAB, KEBOB [v]\n",
  "KABABS": "KABAB, (Arabic) cubes of meat cooked on a skewer [n]\n",
  "KABADDI": "(Tamil) an Asian version of tag played between two teams of nine boys or young men [n -S]\n",
  "KABADDIS": "KABADDI, (Tamil) an Asian version of tag played between two teams of nine boys or young men [n]\n",
  "KABAKA": "(Ugandan) a Ugandan emperor [n -S]\n",
  "KABAKAS": "KABAKA, (Ugandan) a Ugandan emperor [n]\n",
  "KABALA": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABBALA, KABBALAH, QABALA, QABALAH [n -S]\n",
  "KABALAS": "KABALA, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABBALA, KABBALAH, QABALA, QABALAH [n]\n",
  "KABALISM": "a sect based on kabala, also KABBALISM, CABALISM, QABALISM, CABBALISM [n -S]\n",
  "KABALISMS": "KABALISM, a sect based on kabala, also KABBALISM, CABALISM, QABALISM, CABBALISM [n]\n",
  "KABALIST": "someone who finds hidden meanings in sacred texts, also CABALIST, CABBALIST, KABBALIST, QABALIST [n -S]\n",
  "KABALISTIC": "relating to the kabala, also CABALISTIC, CABBALISTIC, CABBALISTICAL [adj]\n",
  "KABALISTS": "KABALIST, someone who finds hidden meanings in sacred texts, also CABALIST, CABBALIST, KABBALIST, QABALIST [n]\n",
  "KABAR": "(Scots) a heavy wooden heaving pole, also CABER, KEBAR [n -S]\n",
  "KABARAGOYA": "(Tagalog) a very large monitor lizard of SE Asia [n -S]\n",
  "KABARAGOYAS": "KABARAGOYA, (Tagalog) a very large monitor lizard of SE Asia [n]\n",
  "KABARS": "KABAR, (Scots) a heavy wooden heaving pole, also CABER, KEBAR [n]\n",
  "KABAYA": "(Malay) a cotton jacket [n -S]\n",
  "KABAYAS": "KABAYA, (Malay) a cotton jacket [n]\n",
  "KABBALA": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALAH, QABALA, QABALAH [n -S]\n",
  "KABBALAH": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALA, QABALA, QABALAH [n -S]\n",
  "KABBALAHS": "KABBALAH, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALA, QABALA, QABALAH [n]\n",
  "KABBALAS": "KABBALA, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALAH, QABALA, QABALAH [n]\n",
  "KABBALISM": "the secret science of the cabalists, also CABALISM, CABBALISM, KABALISM, QABALISM [n -S]\n",
  "KABBALISMS": "KABBALISM, the secret science of the cabalists, also CABALISM, CABBALISM, KABALISM, QABALISM [n]\n",
  "KABBALIST": "one who practises kabbalism, also CABALIST, CABBALIST, KABALIST, QABALIST [n -S]\n",
  "KABBALISTIC": "relating to the kabbala [adj]\n",
  "KABBALISTS": "KABBALIST, one who practises kabbalism, also CABALIST, CABBALIST, KABALIST, QABALIST [n]\n",
  "KABELE": "(Amharic) a self-governing association found in towns in Ethiopia, also KEBELE [n -S]\n",
  "KABELES": "KABELE, (Amharic) a self-governing association found in towns in Ethiopia, also KEBELE [n]\n",
  "KABELJOU": "(South African) a large South African fish, also KABELJOUW [n -S]\n",
  "KABELJOUS": "KABELJOU, (South African) a large South African fish, also KABELJOUW [n]\n",
  "KABELJOUW": "(South African) a large South African fish, also KABELJOU [n -S]\n",
  "KABELJOUWS": "KABELJOUW, (South African) a large South African fish, also KABELJOU [n]\n",
  "KABIKI": "a fruit tree native to India, the fruit of which is edible and often used in preserves, and the fragrant flowers of which are used in cosmetics [n -S]\n",
  "KABIKIS": "KABIKI, a fruit tree native to India, the fruit of which is edible and often used in preserves, and the fragrant flowers of which are used in cosmetics [n]\n",
  "KABLOOEY": "an interjection expressing an abrupt happening, also KABLOOIE [interj]\n",
  "KABLOOIE": "an interjection expressing an abrupt happening, also KABLOOEY [interj]\n",
  "KABLOONA": "(Inuit) a person who is not Inuit [n KABLOONAS or KABLOONAT]\n",
  "KABLOONAS": "KABLOONA, (Inuit) a person who is not Inuit [n]\n",
  "KABLOONAT": "KABLOONA, (Inuit) a person who is not Inuit [n]\n",
  "KABOB": "(Arabic) cubes of meat cooked on a skewer [n -S] / to cook on a skewer, also CABOB, KABAB, KEBAB, KEBOB [v KABOBBED, KABOBBING, KABOBS]\n",
  "KABOBBED": "KABOB, to cook on a skewer, also CABOB, KABAB, KEBAB, KEBOB [v]\n",
  "KABOBBING": "KABOB, to cook on a skewer, also CABOB, KABAB, KEBAB, KEBOB [v]\n",
  "KABOBS": "KABOB, to cook on a skewer, also CABOB, KABAB, KEBAB, KEBOB [v]\n",
  "KABOCHA": "(Japanese) a Japanese pumpkin or squash [n -S]\n",
  "KABOCHAS": "KABOCHA, (Japanese) a Japanese pumpkin or squash [n]\n",
  "KABOODLE": "a crowd or collection, also CABOODLE [n -S]\n",
  "KABOODLES": "KABOODLE, a crowd or collection, also CABOODLE [n]\n",
  "KABOOM": "the sound of a large explosion [n -S]\n",
  "KABOOMS": "KABOOM, the sound of a large explosion [n]\n",
  "KABS": "KAB, an ancient Hebrew unit of measure [n]\n",
  "KABUKI": "(Japanese) a formal, stylized form of Japanese drama [n -S]\n",
  "KABUKIS": "KABUKI, (Japanese) a formal, stylized form of Japanese drama [n]\n",
  "KACCHA": "(Punjabi) short trousers worn by Sikhs, also KUCCHA [n -S]\n",
  "KACCHAS": "KACCHA, (Punjabi) short trousers worn by Sikhs, also KUCCHA [n]\n",
  "KACHA": "(Hindi) made of dried mud, makeshift, also CUTCHA, KACHCHA, KUCHCHA, KUTCHA [adj]\n",
  "KACHAHRI": "(Hindi) an Indian magistrate's office or courthouse, also CUTCHERRY, CUTCHERY, KACHERI [n -S]\n",
  "KACHAHRIS": "KACHAHRI, (Hindi) an Indian magistrate's office or courthouse, also CUTCHERRY, CUTCHERY, KACHERI [n]\n",
  "KACHCHA": "(Hindi) made of dried mud, makeshift, also CUTCHA, KACHA, KUCHCHA, KUTCHA [adj]\n",
  "KACHERI": "(Hindi) an Indian magistrate's office or courthouse, also CUTCHERRY, CUTCHERY, KACHAHRI [n -S]\n",
  "KACHERIS": "KACHERI, (Hindi) an Indian magistrate's office or courthouse, also CUTCHERRY, CUTCHERY, KACHAHRI [n]\n",
  "KACHINA": "(Native American) a doll representing rain-bringing Hopi ancestors, also KATCHINA, KATCINA, KATSINA [n -S]\n",
  "KACHINAS": "KACHINA, (Native American) a doll representing rain-bringing Hopi ancestors, also KATCHINA, KATCINA, KATSINA [n]\n",
  "KACHORI": "(Hindi) an Indian snack of pastry with a spicy filling [n -S]\n",
  "KACHORIS": "KACHORI, (Hindi) an Indian snack of pastry with a spicy filling [n]\n",
  "KACHUMBER": "(Hindi) a salad of chopped onion, tomato, cucumber, and (sometimes) other vegetables [n -S]\n",
  "KACHUMBERS": "KACHUMBER, (Hindi) a salad of chopped onion, tomato, cucumber, and (sometimes) other vegetables [n]\n",
  "KACK": "(vulgar) faeces, rubbish, also CACA, CACK, KAK [n -S]\n",
  "KACKS": "KACK, (vulgar) faeces, rubbish, also CACA, CACK, KAK [n]\n",
  "KADAI": "(Hindi) a wok-like copper utensil used in Asian cookery; a dish prepared in this, also KARAHI [n -S]\n",
  "KADAIS": "KADAI, (Hindi) a wok-like copper utensil used in Asian cookery; a dish prepared in this, also KARAHI [n]\n",
  "KADAITCHA": "(Native Australian) in certain Central Australian aboriginal tribes, a man with the mission of avenging the death of a tribesman, also KURDAITCHA [n -S]\n",
  "KADAITCHAS": "KADAITCHA, (Native Australian) in certain Central Australian aboriginal tribes, a man with the mission of avenging the death of a tribesman, also KURDAITCHA [n]\n",
  "KADDISH": "(Hebrew) a Jewish prayer [n KADDISHES or KADDISHIM]\n",
  "KADDISHES": "KADDISH, (Hebrew) a Jewish prayer [n]\n",
  "KADDISHIM": "KADDISH, (Hebrew) a Jewish prayer [n]\n",
  "KADE": "a wingless fly that infests sheep, also KED [n -S]\n",
  "KADES": "KADE, a wingless fly that infests sheep, also KED [n]\n",
  "KADI": "(Arabic) a civil judge in a Muslim country, also CADI, CAID, KAID, QADI, QAID [n -S]\n",
  "KADIS": "KADI, (Arabic) a civil judge in a Muslim country, also CADI, CAID, KAID, QADI, QAID [n]\n",
  "KAE": "(Scots) to serve, also KA [v KAED, KAING or KAEING, KAES]\n",
  "KAED": "KAE, (Scots) to serve, also KA [v]\n",
  "KAEING": "KAE, (Scots) to serve, also KA [v]\n",
  "KAES": "KAE, (Scots) to serve, also KA [v]\n",
  "KAF": "(Hebrew) the eleventh letter of the Hebrew alphabet, also CAPH, KAPH, KHAF, KHAPH [n -S]\n",
  "KAFFEEKLATSCH": "(German) an informal social gathering for coffee and talk, also KLATCH, KLATSCH [n -ES]\n",
  "KAFFEEKLATSCHES": "KAFFEEKLATSCH, (German) an informal social gathering for coffee and talk, also KLATCH, KLATSCH [n]\n",
  "KAFFIR": "a kind of cereal grass, aka sorghum, also KAFIR [n -S]\n",
  "KAFFIRBOOM": "a deciduous flowering tree having large clusters of brilliant orange or scarlet flowers [n -S]\n",
  "KAFFIRBOOMS": "KAFFIRBOOM, a deciduous flowering tree having large clusters of brilliant orange or scarlet flowers [n]\n",
  "KAFFIRS": "KAFFIR, a kind of cereal grass, aka sorghum, also KAFIR [n]\n",
  "KAFFIYAH": "(Arabic) an Arab headdress, also KAFFIYEH, KEFFIYAH, KEFFIYEH, KUFIYAH [n -S]\n",
  "KAFFIYAHS": "KAFFIYAH, (Arabic) an Arab headdress, also KAFFIYEH, KEFFIYAH, KEFFIYEH, KUFIYAH [n]\n",
  "KAFFIYEH": "(Arabic) an Arab headdress, also KAFFIYAH, KEFFIYAH, KEFFIYEH, KUFIYAH [n -S]\n",
  "KAFFIYEHS": "KAFFIYEH, (Arabic) an Arab headdress, also KAFFIYAH, KEFFIYAH, KEFFIYEH, KUFIYAH [n]\n",
  "KAFILA": "(Arabic) a caravan, also CAFILA, CAFFILA [n -S]\n",
  "KAFILAS": "KAFILA, (Arabic) a caravan, also CAFILA, CAFFILA [n]\n",
  "KAFIR": "a kind of cereal grass, sorghum, also KAFFIR [n -S]\n",
  "KAFIRS": "KAFIR, a kind of cereal grass, sorghum, also KAFFIR [n]\n",
  "KAFS": "KAF, (Hebrew) the eleventh letter of the Hebrew alphabet, also CAPH, KAPH, KHAF, KHAPH [n]\n",
  "KAFTAN": "(Turkish) a kind of tunic, also CAFTAN [n -S]\n",
  "KAFTANS": "KAFTAN, (Turkish) a kind of tunic, also CAFTAN [n]\n",
  "KAFUFFLE": "a commotion, also CUFFUFFLE [n -S]\n",
  "KAFUFFLES": "KAFUFFLE, a commotion, also CUFFUFFLE [n]\n",
  "KAGO": "(Japanese) a basketwork passenger litter [n -S]\n",
  "KAGOOL": "(French) a light anorak, also CAGOUL, CAGOULE, KAGOUL, KAGOULE [n -S]\n",
  "KAGOOLS": "KAGOOL, (French) a light anorak, also CAGOUL, CAGOULE, KAGOUL, KAGOULE [n]\n",
  "KAGOS": "KAGO, (Japanese) a basketwork passenger litter [n]\n",
  "KAGOUL": "(French) a light anorak, also CAGOUL, CAGOULE, KAGOOL, KAGOULE [n -S]\n",
  "KAGOULE": "(French) a light anorak, also CAGOUL, CAGOULE, KAGOOL, KAGOUL [n -S]\n",
  "KAGOULES": "KAGOULE, (French) a light anorak, also CAGOUL, CAGOULE, KAGOOL, KAGOUL [n]\n",
  "KAGOULS": "KAGOUL, (French) a light anorak, also CAGOUL, CAGOULE, KAGOOL, KAGOULE [n]\n",
  "KAGU": "a flightless bird [n -S]\n",
  "KAGUS": "KAGU, a flightless bird [n]\n",
  "KAHAL": "(Hebrew) the governing body of a Jewish community [n -S]\n",
  "KAHALS": "KAHAL, (Hebrew) the governing body of a Jewish community [n]\n",
  "KAHAWAI": "(Maori) a large marine fish of the perch family [n -S]\n",
  "KAHAWAIS": "KAHAWAI, (Maori) a large marine fish of the perch family [n]\n",
  "KAHIKATEA": "(Maori) a tall New Zealand coniferous tree [n -S]\n",
  "KAHIKATEAS": "KAHIKATEA, (Maori) a tall New Zealand coniferous tree [n]\n",
  "KAHIKATOA": "(Maori) a New Zealand myrtaceous tree, with strong elastic wood and aromatic leaves [n -S]\n",
  "KAHIKATOAS": "KAHIKATOA, (Maori) a New Zealand myrtaceous tree, with strong elastic wood and aromatic leaves [n]\n",
  "KAHUNA": "(Hawaiian) a priest or medicine-man; an expert in any field [n -S]\n",
  "KAHUNAS": "KAHUNA, (Hawaiian) a priest or medicine-man; an expert in any field [n]\n",
  "KAI": "(Maori) in New Zealand, a meal, also KAIKAI [n -S]\n",
  "KAIAK": "(Inuit) a type of canoe, also KAYAK, KYAK, QAJAQ [n -S] / to travel by kaiak, also KAYAK [v -ED, -ING, -S]\n",
  "KAIAKED": "KAIAK, to travel by kaiak, also KAYAK [v]\n",
  "KAIAKING": "KAIAK, to travel by kaiak, also KAYAK [v]\n",
  "KAIAKS": "KAIAK, to travel by kaiak, also KAYAK [v]\n",
  "KAID": "(Arabic) a North African chief, also CADI, CAID, KADI, QADI, QAID [n -S]\n",
  "KAIDS": "KAID, (Arabic) a North African chief, also CADI, CAID, KADI, QADI, QAID [n]\n",
  "KAIE": "(obsolete) a key [n -S]\n",
  "KAIES": "KAIE, (obsolete) a key [n]\n",
  "KAIF": "(Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KEEF, KEF, KIEF, KIF [n -S]\n",
  "KAIFS": "KAIF, (Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KEEF, KEF, KIEF, KIF [n]\n",
  "KAIK": "(Maori) the South Island dialect word for KAINGA, a Maori village, also KAIKA [n -S]\n",
  "KAIKA": "(Maori) the South Island dialect word for KAINGA, a Maori village, also KAIK [n -S]\n",
  "KAIKAI": "(Maori) food, a feast, also KAI [n -S]\n",
  "KAIKAIS": "KAIKAI, (Maori) food, a feast, also KAI [n]\n",
  "KAIKAS": "KAIKA, (Maori) the South Island dialect word for KAINGA, a Maori village, also KAIK [n]\n",
  "KAIKAWAKA": "(Maori) a small pyramid-shaped New Zealand conifer, aka pahautea [n -S]\n",
  "KAIKAWAKAS": "KAIKAWAKA, (Maori) a small pyramid-shaped New Zealand conifer, aka pahautea [n]\n",
  "KAIKOMAKO": "(Maori) a small New Zealand tree with white flowers and black fruit [n -S]\n",
  "KAIKOMAKOS": "KAIKOMAKO, (Maori) a small New Zealand tree with white flowers and black fruit [n]\n",
  "KAIKS": "KAIK, (Maori) the South Island dialect word for KAINGA, a Maori village, also KAIKA [n]\n",
  "KAIL": "a ninepin, also KAYLE [n -S]\n",
  "KAILS": "KAIL, a ninepin, also KAYLE [n]\n",
  "KAILYAIRD": "a cabbage patch, a kitchen garden, also KAILYARD, KALEYARD [n -S]\n",
  "KAILYAIRDS": "KAILYAIRD, a cabbage patch, a kitchen garden, also KAILYARD, KALEYARD [n]\n",
  "KAILYARD": "a kitchen garden, also KALEYARD [n -S]\n",
  "KAILYARDS": "KAILYARD, a kitchen garden, also KALEYARD [n]\n",
  "KAIM": "(Scots) a comb; a ridge of gravel or sand left by a glacier, also KAME [n -S]\n",
  "KAIMAKAM": "(Turkish) a Turkish governor, also CAIMAC, CAIMACAM, QAIMAQAM [n -S]\n",
  "KAIMAKAMS": "KAIMAKAM, (Turkish) a Turkish governor, also CAIMAC, CAIMACAM, QAIMAQAM [n]\n",
  "KAIMS": "KAIM, (Scots) a comb; a ridge of gravel or sand left by a glacier, also KAME [n]\n",
  "KAIN": "(Gaelic) a tenanted farm rent paid in kind, also CAIN, KANE [n -S]\n",
  "KAING": "KA, to serve, also KAE [v]\n",
  "KAINGA": "(Maori) a Maori village [n -S]\n",
  "KAINGAS": "KAINGA, (Maori) a Maori village [n]\n",
  "KAINIT": "(German) hydrous magnesium sulphate with potassium chloride, found in salt deposits, used as a fertilizer, also KAINITE [n -S]\n",
  "KAINITE": "hydrous magnesium sulphate with potassium chloride, found in salt deposits, used as a fertilizer, also KAINIT [n -S]\n",
  "KAINITES": "KAINITE, hydrous magnesium sulphate with potassium chloride, found in salt deposits, used as a fertilizer, also KAINIT [n]\n",
  "KAINITS": "KAINIT, (German) hydrous magnesium sulphate with potassium chloride, found in salt deposits, used as a fertilizer, also KAINITE [n]\n",
  "KAINOGENESES": "KAINOGENESIS, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CAENOGENESIS, CENOGENESIS, KENOGENESIS [n]\n",
  "KAINOGENESIS": "the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CAENOGENESIS, CENOGENESIS, KENOGENESIS [n KAINOGENESES]\n",
  "KAINOGENETIC": "relating to kainogenesis, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage [adj]\n",
  "KAINS": "KAIN, (Gaelic) a tenanted farm rent paid in kind, also CAIN, KANE [n]\n",
  "KAIROMONE": "a semiochemical, emitted by an organism, which mediates interspecific interactions in a way that benefits an individual of another species which receives it, without benefiting the emitter [n -S]\n",
  "KAIROMONES": "KAIROMONE, a semiochemical, emitted by an organism, which mediates interspecific interactions in a way that benefits an individual of another species which receives it, without benefiting the emitter [n]\n",
  "KAIS": "KAI, (Maori) in New Zealand, a meal, also KAIKAI [n]\n",
  "KAISER": "(German) an emperor, also KEASAR, KESAR [n -S]\n",
  "KAISERDOM": "the office of kaiser [n -S]\n",
  "KAISERDOMS": "KAISERDOM, the office of kaiser [n]\n",
  "KAISERIN": "(German) a kaiser's wife [n -S]\n",
  "KAISERINS": "KAISERIN, (German) a kaiser's wife [n]\n",
  "KAISERISM": "the system of having a kaiser [n -S]\n",
  "KAISERISMS": "KAISERISM, the system of having a kaiser [n]\n",
  "KAISERS": "KAISER, (German) an emperor, also KEASAR, KESAR [n]\n",
  "KAISERSHIP": "the office of kaiser [n -S]\n",
  "KAISERSHIPS": "KAISERSHIP, the office of kaiser [n]\n",
  "KAIZEN": "(Japanese) the principle of continuously improving work practice [n -S]\n",
  "KAIZENS": "KAIZEN, (Japanese) the principle of continuously improving work practice [n]\n",
  "KAJAWAH": "(Urdu) a camel saddle [n -S]\n",
  "KAJAWAHS": "KAJAWAH, (Urdu) a camel saddle [n]\n",
  "KAJEPUT": "(Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJAPUT, CAJEPUT, CAJUPUT [n -S]\n",
  "KAJEPUTS": "KAJEPUT, (Malay) a volatile oil, distilled from the leaves of an East Indian tree, also CAJAPUT, CAJEPUT, CAJUPUT [n]\n",
  "KAK": "(vulgar South African) faeces, rubbish, also CACA, CACK, KACK [n -S]\n",
  "KAKA": "(Maori) a brownish-green New Zealand parrot [n -S]\n",
  "KAKAPO": "(Maori) a ground-dwelling New Zealand parrot [n -S]\n",
  "KAKAPOS": "KAKAPO, (Maori) a ground-dwelling New Zealand parrot [n]\n",
  "KAKARIKI": "(Maori) a green-feathered New Zealand parrot [n -S]\n",
  "KAKARIKIS": "KAKARIKI, (Maori) a green-feathered New Zealand parrot [n]\n",
  "KAKAS": "KAKA, (Maori) a brownish-green New Zealand parrot [n]\n",
  "KAKEMONO": "(Japanese) a vertical wall-picture or inscription mounted on a roller [n -S]\n",
  "KAKEMONOS": "KAKEMONO, (Japanese) a vertical wall-picture or inscription mounted on a roller [n]\n",
  "KAKI": "(Japanese) a fruit like a persimmon [n -S]\n",
  "KAKIEMON": "(Japanese) a type of Japanese porcelain [n -S]\n",
  "KAKIEMONS": "KAKIEMON, (Japanese) a type of Japanese porcelain [n]\n",
  "KAKIS": "KAKI, (Japanese) a fruit like a persimmon [n]\n",
  "KAKISTOCRACIES": "KAKISTOCRACY, government by the worst men of the state [n]\n",
  "KAKISTOCRACY": "government by the worst men of the state [n KAKISTOCRACIES]\n",
  "KAKIVAK": "(Inuit) a fish spear used by the Inuits [n -S]\n",
  "KAKIVAKS": "KAKIVAK, (Inuit) a fish spear used by the Inuits [n]\n",
  "KAKODYL": "a colourless, poisonous, foul-smelling liquid, composed of arsenic, carbon and hydrogen, also CACODYL [n -S]\n",
  "KAKODYLS": "KAKODYL, a colourless, poisonous, foul-smelling liquid, composed of arsenic, carbon and hydrogen, also CACODYL [n]\n",
  "KAKS": "KAK, (vulgar South African) faeces, rubbish, also CACA, CACK, KACK [n]\n",
  "KAKURO": "a kind of logic puzzle, resembling a mathematical crossword [n -S]\n",
  "KAKUROS": "KAKURO, a kind of logic puzzle, resembling a mathematical crossword [n]\n",
  "KALAM": "(Persian) a type of Muslim theology [n -S]\n",
  "KALAMANSI": "a citrus hybrid predominantly cultivated in the Philippines, aka calamondin, also CALAMANSI [n KALAMANSI]\n",
  "KALAMATA": "(Modern Greek) a black olive grown in Greece, also CALAMATA [n -S]\n",
  "KALAMATAS": "KALAMATA, (Modern Greek) a black olive grown in Greece, also CALAMATA [n]\n",
  "KALAMDAN": "(Persian) a Persian writing-case, also QALAMDAN [n -S]\n",
  "KALAMDANS": "KALAMDAN, (Persian) a Persian writing-case, also QALAMDAN [n]\n",
  "KALAMKARI": "(Persian) a method of colouring and decorating by several dyeings or printings; a chintz fabric treated in this way [n -S]\n",
  "KALAMKARIS": "KALAMKARI, (Persian) a method of colouring and decorating by several dyeings or printings; a chintz fabric treated in this way [n]\n",
  "KALAMS": "KALAM, (Persian) a type of Muslim theology [n]\n",
  "KALANCHOE": "a succulent plant which bears red, yellow or pink clusters on long stems [n -S]\n",
  "KALANCHOES": "KALANCHOE, a succulent plant which bears red, yellow or pink clusters on long stems [n]\n",
  "KALASHNIKOV": "(Russian) a kind of sub-machinegun made in the former USSR [n -S]\n",
  "KALASHNIKOVS": "KALASHNIKOV, (Russian) a kind of sub-machinegun made in the former USSR [n]\n",
  "KALE": "a hardy cabbage-like vegetable [n -S]\n",
  "KALEIDOPHONE": "an instrument for demonstrating sound waves by lines of light [n -S]\n",
  "KALEIDOPHONES": "KALEIDOPHONE, an instrument for demonstrating sound waves by lines of light [n]\n",
  "KALEIDOSCOPE": "a variegated changing pattern or scene [n -S]\n",
  "KALEIDOSCOPES": "KALEIDOSCOPE, a variegated changing pattern or scene [n]\n",
  "KALEIDOSCOPIC": "like a kaleidoscope [adj]\n",
  "KALENDAR": "to schedule, also CALENDAR [v -ED, -ING, -S]\n",
  "KALENDARED": "KALENDAR, to schedule, also CALENDAR [v]\n",
  "KALENDARING": "KALENDAR, to schedule, also CALENDAR [v]\n",
  "KALENDARS": "KALENDAR, to schedule, also CALENDAR [v]\n",
  "KALENDS": "(Latin) the first day of the ancient Roman month from which days were counted backwards to the Ides, also CALENDS [n]\n",
  "KALES": "KALE, a hardy cabbage-like vegetable [n]\n",
  "KALEWIFE": "a female vegetable vendor [n KALEWIVES]\n",
  "KALEWIVES": "KALEWIFE, a female vegetable vendor [n]\n",
  "KALEYARD": "a cabbage patch, a kitchen garden, also KAILYAIRD, KAILYARD [n -S]\n",
  "KALEYARDS": "KALEYARD, a cabbage patch, a kitchen garden, also KAILYAIRD, KAILYARD [n]\n",
  "KALI": "(Arabic) the prickly saltwort or glasswort [n -S]\n",
  "KALIAN": "(Persian) a Persian hookah or water-pipe [n -S]\n",
  "KALIANS": "KALIAN, (Persian) a Persian hookah or water-pipe [n]\n",
  "KALIF": "(Arabic) an Eastern ruler, also CALIF, CALIPH, KALIPH, KHALIF [n -S]\n",
  "KALIFATE": "the domain of a Muslim leader [n -S]\n",
  "KALIFATES": "KALIFATE, the domain of a Muslim leader [n]\n",
  "KALIFS": "KALIF, (Arabic) an Eastern ruler, also CALIF, CALIPH, KALIPH, KHALIF [n]\n",
  "KALIMBA": "(Bantu) a musical instrument played with the thumbs, consisting of metal strips along a small hollow piece of wood [n -S]\n",
  "KALIMBAS": "KALIMBA, (Bantu) a musical instrument played with the thumbs, consisting of metal strips along a small hollow piece of wood [n]\n",
  "KALINITE": "native potash alum [n -S]\n",
  "KALINITES": "KALINITE, native potash alum [n]\n",
  "KALIPH": "(Arabic) an Eastern ruler, also CALIF, CALIPH, KALIF, KHALIF [n -S]\n",
  "KALIPHATE": "the office of a kaliph, an Eastern ruler, also CALIFATE, CALIPHATE, KHALIFAT, KHALIFATE, KHILAFAT [n -S]\n",
  "KALIPHATES": "KALIPHATE, the office of a kaliph, an Eastern ruler, also CALIFATE, CALIPHATE, KHALIFAT, KHALIFATE, KHILAFAT [n]\n",
  "KALIPHS": "KALIPH, (Arabic) an Eastern ruler, also CALIF, CALIPH, KALIF, KHALIF [n]\n",
  "KALIS": "KALI, (Arabic) the prickly saltwort or glasswort [n]\n",
  "KALIUM": "an old name for potassium [n -S]\n",
  "KALIUMS": "KALIUM, an old name for potassium [n]\n",
  "KALLIDIN": "a naturally occurring peptide, which causes contraction of smooth muscle and vasodilation [n -S]\n",
  "KALLIDINS": "KALLIDIN, a naturally occurring peptide, which causes contraction of smooth muscle and vasodilation [n]\n",
  "KALLIKREIN": "a hypotensive protein that liberates kinins from blood plasma proteins [n -S]\n",
  "KALLIKREINS": "KALLIKREIN, a hypotensive protein that liberates kinins from blood plasma proteins [n]\n",
  "KALLITYPE": "a former photographic process in which ferric salts are reduced to ferrous salts [n -S]\n",
  "KALLITYPES": "KALLITYPE, a former photographic process in which ferric salts are reduced to ferrous salts [n]\n",
  "KALMIA": "(Swedish) a genus of North American shrubs with poisonous evergreen foliage and corymbs of showy flowers [n -S]\n",
  "KALMIAS": "KALMIA, (Swedish) a genus of North American shrubs with poisonous evergreen foliage and corymbs of showy flowers [n]\n",
  "KALONG": "(Malay) a fruit-eating bat [n -S]\n",
  "KALONGS": "KALONG, (Malay) a fruit-eating bat [n]\n",
  "KALOOKI": "a card game similar to rummy, using two packs of cards and two jokers, also KALOOKIE, KALUKI [n -S]\n",
  "KALOOKIE": "a card game similar to rummy, using two packs of cards and two jokers, also KALOOKI, KALUKI [n -S]\n",
  "KALOOKIES": "KALOOKIE, a card game similar to rummy, using two packs of cards and two jokers, also KALOOKI, KALUKI [n]\n",
  "KALOOKIS": "KALOOKI, a card game similar to rummy, using two packs of cards and two jokers, also KALOOKIE, KALUKI [n]\n",
  "KALOTYPE": "(tradename) an early type of photography, also CALOTYPE [n -S]\n",
  "KALOTYPES": "KALOTYPE, (tradename) an early type of photography, also CALOTYPE [n]\n",
  "KALPA": "(Sanskrit) one of the Brahmanic eons, a period of 4,320,000,000 years, also CALPA [n -S]\n",
  "KALPAC": "(Turkish) a triangular Turkish or Tatar felt cap, also CALPAC, CALPACK, KALPAK [n -S]\n",
  "KALPACS": "KALPAC, (Turkish) a triangular Turkish or Tatar felt cap, also CALPAC, CALPACK, KALPAK [n]\n",
  "KALPAK": "(Turkish) a triangular Turkish or Tatar felt cap, also CALPAC, CALPACK, KALPAC [n -S]\n",
  "KALPAKS": "KALPAK, (Turkish) a triangular Turkish or Tatar felt cap, also CALPAC, CALPACK, KALPAC [n]\n",
  "KALPAS": "KALPA, (Sanskrit) one of the Brahmanic eons, a period of 4,320,000,000 years, also CALPA [n]\n",
  "KALPIS": "(Greek) a Greek water-jar [n -ES]\n",
  "KALPISES": "KALPIS, (Greek) a Greek water-jar [n]\n",
  "KALSOMINE": "(tradename) a kind of whitewash or colour wash for walls [n -S] / to whitewash with this, also CALCIMINE [v KALSOMINED, KALSOMINING, KALSOMINES]\n",
  "KALSOMINED": "KALSOMINE, to whitewash with this, also CALCIMINE [v]\n",
  "KALSOMINES": "KALSOMINE, to whitewash with this, also CALCIMINE [v]\n",
  "KALSOMINING": "KALSOMINE, to whitewash with this, also CALCIMINE [v]\n",
  "KALUKI": "a card game similar to rummy, using two packs of cards and two jokers, also KALOOKI, KALOOKIE [n -S]\n",
  "KALUKIS": "KALUKI, a card game similar to rummy, using two packs of cards and two jokers, also KALOOKI, KALOOKIE [n]\n",
  "KALUMPIT": "(Tagalog) a Philippine tree of the myrobalan genus; its edible fruit [n -S]\n",
  "KALUMPITS": "KALUMPIT, (Tagalog) a Philippine tree of the myrobalan genus; its edible fruit [n]\n",
  "KALYPTRA": "(Greek) a veil worn by Greek women [n -S]\n",
  "KALYPTRAS": "KALYPTRA, (Greek) a veil worn by Greek women [n]\n",
  "KAM": "(Shakespeare) crooked, awry, also KAMME [adj]\n",
  "KAMA": "(Sanskrit) in Indian philosophy, earthly desire [n -S]\n",
  "KAMAAINA": "(Hawaiian) a longtime resident of Hawaii [n -S]\n",
  "KAMAAINAS": "KAMAAINA, (Hawaiian) a longtime resident of Hawaii [n]\n",
  "KAMACITE": "a variety of nickeliferous iron, found in meteorites [n -S]\n",
  "KAMACITES": "KAMACITE, a variety of nickeliferous iron, found in meteorites [n]\n",
  "KAMAHI": "(Maori) a tall New Zealand hardwood tree with pinkish flowers [n -S]\n",
  "KAMAHIS": "KAMAHI, (Maori) a tall New Zealand hardwood tree with pinkish flowers [n]\n",
  "KAMALA": "(Hindi) the red dusty hairs of the capsules of an East Indian tree used for dyeing silk, also KAMELA, KAMILA [n -S]\n",
  "KAMALAS": "KAMALA, (Hindi) the red dusty hairs of the capsules of an East Indian tree used for dyeing silk, also KAMELA, KAMILA [n]\n",
  "KAMAS": "KAMA, (Sanskrit) in Indian philosophy, earthly desire [n]\n",
  "KAME": "(Scots) a comb; a ridge or mound of sand and gravel deposited on or near a glacier, also KAIM [n -S]\n",
  "KAMEES": "(Urdu) in South Asia, a loose tunic, worn by women, also KAMEEZ [n -ES]\n",
  "KAMEESES": "KAMEES, (Urdu) in South Asia, a loose tunic, worn by women, also KAMEEZ [n]\n",
  "KAMEEZ": "(Urdu) in South Asia, a loose tunic, worn by women, also KAMEES [n -ES]\n",
  "KAMEEZES": "KAMEEZ, (Urdu) in South Asia, a loose tunic, worn by women, also KAMEES [n]\n",
  "KAMELA": "(Hindi) the red dusty hairs of the capsules of an East Indian tree used for dyeing silk, also KAMALA, KAMILA [n -S]\n",
  "KAMELAS": "KAMELA, (Hindi) the red dusty hairs of the capsules of an East Indian tree used for dyeing silk, also KAMALA, KAMILA [n]\n",
  "KAMELAUKION": "(Modern Greek) a tall cylindrical hat worn by Orthodox priests [n -S]\n",
  "KAMELAUKIONS": "KAMELAUKION, (Modern Greek) a tall cylindrical hat worn by Orthodox priests [n]\n",
  "KAMERAD": "(German) to surrender [v -ED, -ING, -S]\n",
  "KAMERADED": "KAMERAD, (German) to surrender [v]\n",
  "KAMERADING": "KAMERAD, (German) to surrender [v]\n",
  "KAMERADS": "KAMERAD, (German) to surrender [v]\n",
  "KAMES": "KAME, (Scots) a comb; a ridge or mound of sand and gravel deposited on or near a glacier, also KAIM [n]\n",
  "KAMI": "(Japanese) a Japanese divine being [n -S]\n",
  "KAMICHI": "(Caribbean) a South American bird, aka the horned screamer [n -S]\n",
  "KAMICHIS": "KAMICHI, (Caribbean) a South American bird, aka the horned screamer [n]\n",
  "KAMIK": "(Inuit) a knee-length sealskin boot [n -S]\n",
  "KAMIKAZE": "(Japanese) a suicide attack by a Japanese airman [n -S]\n",
  "KAMIKAZES": "KAMIKAZE, (Japanese) a suicide attack by a Japanese airman [n]\n",
  "KAMIKS": "KAMIK, (Inuit) a knee-length sealskin boot [n]\n",
  "KAMILA": "(Hindi) the red dusty hairs of the capsules of an East Indian tree used for dyeing silk, also KAMALA, KAMELA [n -S]\n",
  "KAMILAS": "KAMILA, (Hindi) the red dusty hairs of the capsules of an East Indian tree used for dyeing silk, also KAMALA, KAMELA [n]\n",
  "KAMIS": "(Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISA, CAMISE, CAMISIA [n -ES]\n",
  "KAMISES": "KAMIS, (Arabic) a loose shirt or tunic, as worn by Arabs, also CAMESE, CAMISA, CAMISE, CAMISIA [n]\n",
  "KAMME": "(Shakespeare) crooked, awry, also KAM [adj]\n",
  "KAMOKAMO": "(Maori) a kind of marrow found in New Zealand, also KUMIKUMI [n -S]\n",
  "KAMOKAMOS": "KAMOKAMO, (Maori) a kind of marrow found in New Zealand, also KUMIKUMI [n]\n",
  "KAMOTIK": "(Inuit) a sled with wooden runners, also COMATIK, KAMOTIQ, KOMATIK, QAMUTIK [n -S]\n",
  "KAMOTIKS": "KAMOTIK, (Inuit) a sled with wooden runners, also COMATIK, KAMOTIQ, KOMATIK, QAMUTIK [n]\n",
  "KAMOTIQ": "(Inuit) a sled with wooden runners, also COMATIK, KAMOTIK, KOMATIK, QAMUTIK [n -S]\n",
  "KAMOTIQS": "KAMOTIQ, (Inuit) a sled with wooden runners, also COMATIK, KAMOTIK, KOMATIK, QAMUTIK [n]\n",
  "KAMPONG": "(Malay) a Malay village, also CAMPONG [n -S]\n",
  "KAMPONGS": "KAMPONG, (Malay) a Malay village, also CAMPONG [n]\n",
  "KAMSEEN": "(Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSIN, KHAMSEEN, KHAMSIN [n -S]\n",
  "KAMSEENS": "KAMSEEN, (Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSIN, KHAMSEEN, KHAMSIN [n]\n",
  "KAMSIN": "(Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSEEN, KHAMSEEN, KHAMSIN [n -S]\n",
  "KAMSINS": "KAMSIN, (Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSEEN, KHAMSEEN, KHAMSIN [n]\n",
  "KANA": "(Japanese) the Japanese syllabic script [n -S]\n",
  "KANAE": "(Maori) the grey mullet [n -S]\n",
  "KANAES": "KANAE, (Maori) the grey mullet [n]\n",
  "KANAKA": "(Hawaiian) a native of the Sandwich Islands [n -S]\n",
  "KANAKAS": "KANAKA, (Hawaiian) a native of the Sandwich Islands [n]\n",
  "KANAMYCIN": "a broad-spectrum antibiotic derived from a Japanese soil streptomyces [n -S]\n",
  "KANAMYCINS": "KANAMYCIN, a broad-spectrum antibiotic derived from a Japanese soil streptomyces [n]\n",
  "KANAS": "KANA, (Japanese) the Japanese syllabic script [n]\n",
  "KANBAN": "(Japanese) an industrial system based on the use of cards to regulate the stages of a manufacturing process and control costs [n -S]\n",
  "KANBANS": "KANBAN, (Japanese) an industrial system based on the use of cards to regulate the stages of a manufacturing process and control costs [n]\n",
  "KANDIES": "KANDY, (Tamil) a South Indian weight, approximately 500 lb Imperial, also CANDIE, CANDY [n]\n",
  "KANDY": "(Tamil) a South Indian weight, approximately 500 lb Imperial, also CANDIE, CANDY [n KANDIES]\n",
  "KANE": "(Gaelic) a tenanted farm rent paid in kind, also CAIN, KAIN [n -S]\n",
  "KANEH": "(Hebrew) a Hebrew measure of 6 cubits, also CANEH [n -S]\n",
  "KANEHS": "KANEH, (Hebrew) a Hebrew measure of 6 cubits, also CANEH [n]\n",
  "KANES": "KANE, (Gaelic) a tenanted farm rent paid in kind, also CAIN, KAIN [n]\n",
  "KANG": "(Chinese) a Chinese sleeping-platform [n -S]\n",
  "KANGA": "(Swahili) a coloured cotton cloth worn as a dress, also KANGHA, KHANGA [n -S]\n",
  "KANGAROO": "(Native Australian) a large marsupial [n -S] / to bound like a kangaroo [v -ED, -ING, -S]\n",
  "KANGAROOED": "KANGAROO, to bound like a kangaroo [v]\n",
  "KANGAROOING": "KANGAROO, to bound like a kangaroo [v]\n",
  "KANGAROOS": "KANGAROO, to bound like a kangaroo [v]\n",
  "KANGAS": "KANGA, (Swahili) a coloured cotton cloth worn as a dress, also KANGHA, KHANGA [n]\n",
  "KANGHA": "(Punjabi) a coloured cotton cloth worn as a dress, also KANGA, KHANGA [n -S]\n",
  "KANGHAS": "KANGHA, (Punjabi) a coloured cotton cloth worn as a dress, also KANGA, KHANGA [n]\n",
  "KANGS": "KANG, (Chinese) a Chinese sleeping-platform [n]\n",
  "KANJI": "(Japanese) the characters in Japanese orthography which originate from written Chinese [n -S]\n",
  "KANJIS": "KANJI, (Japanese) the characters in Japanese orthography which originate from written Chinese [n]\n",
  "KANS": "(Hindi) a type of Indian grass [n -ES]\n",
  "KANSES": "KANS, (Hindi) a type of Indian grass [n]\n",
  "KANT": "to tilt, slope, also CANT [v -ED, -ING, -S]\n",
  "KANTAR": "(Arabic) an Arab unit of weight, also CANTAR [n -S]\n",
  "KANTARS": "KANTAR, (Arabic) an Arab unit of weight, also CANTAR [n]\n",
  "KANTED": "KANT, to tilt, slope, also CANT [v]\n",
  "KANTELA": "(Finnish) a kind of zither, also KANTELE [n -S]\n",
  "KANTELAS": "KANTELA, (Finnish) a kind of zither, also KANTELE [n]\n",
  "KANTELE": "(Finnish) a kind of zither, also KANTELA [n -S]\n",
  "KANTELES": "KANTELE, (Finnish) a kind of zither, also KANTELA [n]\n",
  "KANTEN": "(Japanese) agar-agar jelly [n -S]\n",
  "KANTENS": "KANTEN, (Japanese) agar-agar jelly [n]\n",
  "KANTHA": "(Bengali) an embroidered cloth quilt [n -S]\n",
  "KANTHAS": "KANTHA, (Bengali) an embroidered cloth quilt [n]\n",
  "KANTIKOY": "(Native American) to dance as an act of worship, also CANTICO, CANTICOY [v -ED, -ING, -S]\n",
  "KANTIKOYED": "KANTIKOY, (Native American) to dance as an act of worship, also CANTICO, CANTICOY [v]\n",
  "KANTIKOYING": "KANTIKOY, (Native American) to dance as an act of worship, also CANTICO, CANTICOY [v]\n",
  "KANTIKOYS": "KANTIKOY, (Native American) to dance as an act of worship, also CANTICO, CANTICOY [v]\n",
  "KANTING": "KANT, to tilt, slope, also CANT [v]\n",
  "KANTS": "KANT, to tilt, slope, also CANT [v]\n",
  "KANUKA": "(Maori) a New Zealand myrtaceous tree [n -S]\n",
  "KANUKAS": "KANUKA, (Maori) a New Zealand myrtaceous tree [n]\n",
  "KANZU": "(Swahili) a long white garment worn in parts of Africa [n -S]\n",
  "KANZUS": "KANZU, (Swahili) a long white garment worn in parts of Africa [n]\n",
  "KAOLIANG": "(Chinese) sorghum grain of several varieties; an alcoholic drink made from it [n -S]\n",
  "KAOLIANGS": "KAOLIANG, (Chinese) sorghum grain of several varieties; an alcoholic drink made from it [n]\n",
  "KAOLIN": "(Chinese) a very pure white clay used to form the paste of porcelain; aka China clay, also KAOLINE [n -S]\n",
  "KAOLINE": "(Chinese) a very pure white clay used to form the paste of porcelain, aka China clay, also KAOLIN [n -S]\n",
  "KAOLINES": "KAOLINE, (Chinese) a very pure white clay used to form the paste of porcelain, aka China clay, also KAOLIN [n]\n",
  "KAOLINIC": "relating to kaolin, a very pure white clay [adj]\n",
  "KAOLINISE": "to turn into kaolin, a very pure white clay, also KAOLINIZE [v KAOLINISED, KAOLINISING, KAOLINISES]\n",
  "KAOLINISED": "KAOLINISE, to turn into kaolin, a very pure white clay, also KAOLINIZE [v]\n",
  "KAOLINISES": "KAOLINISE, to turn into kaolin, a very pure white clay, also KAOLINIZE [v]\n",
  "KAOLINISING": "KAOLINISE, to turn into kaolin, a very pure white clay, also KAOLINIZE [v]\n",
  "KAOLINITE": "a hydrated aluminum silicate [n -S]\n",
  "KAOLINITES": "KAOLINITE, a hydrated aluminum silicate [n]\n",
  "KAOLINITIC": "relating to kaolinite [adj]\n",
  "KAOLINIZE": "to turn into kaolin, a very pure white clay, also KAOLINISE [v KAOLINIZED, KAOLINIZING, KAOLINIZES]\n",
  "KAOLINIZED": "KAOLINIZE, to turn into kaolin, a very pure white clay, also KAOLINISE [v]\n",
  "KAOLINIZES": "KAOLINIZE, to turn into kaolin, a very pure white clay, also KAOLINISE [v]\n",
  "KAOLINIZING": "KAOLINIZE, to turn into kaolin, a very pure white clay, also KAOLINISE [v]\n",
  "KAOLINOSES": "KAOLINOSIS, a disease caused by inhaling kaolin dust [n]\n",
  "KAOLINOSIS": "a disease caused by inhaling kaolin dust [n KAOLINOSES]\n",
  "KAOLINS": "KAOLIN, (Chinese) a very pure white clay used to form the paste of porcelain; aka China clay, also KAOLINE [n]\n",
  "KAON": "an elementary particle of the meson family [n -S]\n",
  "KAONIC": "of or like a kaon, an elementary particle [adj]\n",
  "KAONS": "KAON, an elementary particle of the meson family [n]\n",
  "KAPA": "a kind of cloth prepared by the Polynesians from the inner bark of the paper mulberry, also TAPA, TAPPA [n -S]\n",
  "KAPAS": "KAPA, a kind of cloth prepared by the Polynesians from the inner bark of the paper mulberry, also TAPA, TAPPA [n]\n",
  "KAPEEK": "KAPEYKA, a monetary unit of Belarus [n]\n",
  "KAPELLMEISTER": "(German) the director of a choir or orchestra, also CAPELLMEISTER [n -S]\n",
  "KAPELLMEISTERS": "KAPELLMEISTER, (German) the director of a choir or orchestra, also CAPELLMEISTER [n]\n",
  "KAPEYKA": "a monetary unit of Belarus [n KAPEEK]\n",
  "KAPH": "(Hebrew) a Hebrew letter, also KAF, KHAF, KHAPH [n -S]\n",
  "KAPHS": "KAPH, (Hebrew) a Hebrew letter, also KAF, KHAF, KHAPH [n]\n",
  "KAPOK": "(Malay) a very light, waterproof, oily fibre covering the seeds of a species of silk-cotton tree, used for stuffing pillows etc. [n -S]\n",
  "KAPOKS": "KAPOK, (Malay) a very light, waterproof, oily fibre covering the seeds of a species of silk-cotton tree, used for stuffing pillows etc. [n]\n",
  "KAPOW": "a sudden sharp sound [n -S]\n",
  "KAPOWS": "KAPOW, a sudden sharp sound [n]\n",
  "KAPPA": "(Greek) the tenth letter of the Greek alphabet [n -S]\n",
  "KAPPAS": "KAPPA, (Greek) the tenth letter of the Greek alphabet [n]\n",
  "KAPU": "(Hawaiian) a Hawaiian set of rules for daily life [n -S]\n",
  "KAPUKA": "(Maori) a large evergreen tree, aka broadleaf or papauma, also PUKA [n -S]\n",
  "KAPUKAS": "KAPUKA, (Maori) a large evergreen tree, aka broadleaf or papauma, also PUKA [n]\n",
  "KAPUS": "KAPU, (Hawaiian) a Hawaiian set of rules for daily life [n]\n",
  "KAPUT": "(German) finished, done for, also KAPUTT [adj]\n",
  "KAPUTT": "(German) finished, done for, also KAPUT [adj]\n",
  "KARA": "(Punjabi) a steel bangle, worn by Sikhs [n -S]\n",
  "KARABINER": "(German) a steel link with clip on side used in mountaineering, also CARABINER [n -S]\n",
  "KARABINERS": "KARABINER, (German) a steel link with clip on side used in mountaineering, also CARABINER [n]\n",
  "KARAHI": "(Hindi) a wok-like copper utensil used in Asian cookery; a dish prepared in this, also KADAI [n -S]\n",
  "KARAHIS": "KARAHI, (Hindi) a wok-like copper utensil used in Asian cookery; a dish prepared in this, also KADAI [n]\n",
  "KARAISM": "a Jewish doctrine of literalism [n -S]\n",
  "KARAISMS": "KARAISM, a Jewish doctrine of literalism [n]\n",
  "KARAIT": "(Hindi) a venomous snake of India, also KRAIT [n -S]\n",
  "KARAITS": "KARAIT, (Hindi) a venomous snake of India, also KRAIT [n]\n",
  "KARAKA": "(Maori) a New Zealand tree with edible orange fruit whose seeds are poisonous until treated [n -S]\n",
  "KARAKAS": "KARAKA, (Maori) a New Zealand tree with edible orange fruit whose seeds are poisonous until treated [n]\n",
  "KARAKIA": "(Maori) a prayer [n -S]\n",
  "KARAKIAS": "KARAKIA, (Maori) a prayer [n]\n",
  "KARAKUL": "(Russian) a sheep of Central Asia; the curled black fleece of its lambs, also CARACUL [n -S]\n",
  "KARAKULS": "KARAKUL, (Russian) a sheep of Central Asia; the curled black fleece of its lambs, also CARACUL [n]\n",
  "KARAMU": "(Maori) a small New Zealand tree with glossy leaves and orange fruit [n -S]\n",
  "KARAMUS": "KARAMU, (Maori) a small New Zealand tree with glossy leaves and orange fruit [n]\n",
  "KARANGA": "(Maori) a Maori chant of welcome by an elder female [n -S] / to perform such a welcome [v -ED, -ING, -S]\n",
  "KARANGAED": "KARANGA, to perform such a welcome [v]\n",
  "KARANGAING": "KARANGA, to perform such a welcome [v]\n",
  "KARANGAS": "KARANGA, to perform such a welcome [v]\n",
  "KARAOKE": "(Japanese) a type of musical singalong entertainment [n -S]\n",
  "KARAOKES": "KARAOKE, (Japanese) a type of musical singalong entertainment [n]\n",
  "KARAS": "KARA, (Punjabi) a steel bangle, worn by Sikhs [n]\n",
  "KARAT": "(US) a unit of quality for gold, also CARAT, CARRAT [n -S]\n",
  "KARATE": "(Japanese) a Japanese art of self-defense [n -S]\n",
  "KARATEIST": "an exponent of karate [n -S]\n",
  "KARATEISTS": "KARATEIST, an exponent of karate [n]\n",
  "KARATEKA": "(Japanese) an expert in karate [n -S]\n",
  "KARATEKAS": "KARATEKA, (Japanese) an expert in karate [n]\n",
  "KARATES": "KARATE, (Japanese) a Japanese art of self-defense [n]\n",
  "KARATS": "KARAT, (US) a unit of quality for gold, also CARAT, CARRAT [n]\n",
  "KAREAREA": "(Maori) a New Zealand falcon [n -S]\n",
  "KAREAREAS": "KAREAREA, (Maori) a New Zealand falcon [n]\n",
  "KARENGO": "(Maori) an edible type of Pacific seaweed [n -S]\n",
  "KARENGOS": "KARENGO, (Maori) an edible type of Pacific seaweed [n]\n",
  "KARITE": "an African tree, aka the shea-tree [n -S]\n",
  "KARITES": "KARITE, an African tree, aka the shea-tree [n]\n",
  "KARK": "(Australian slang) to break down, die [v -ED, -ING, -S]\n",
  "KARKED": "KARK, (Australian slang) to break down, die [v]\n",
  "KARKING": "KARK, (Australian slang) to break down, die [v]\n",
  "KARKS": "KARK, (Australian slang) to break down, die [v]\n",
  "KARMA": "(Sanskrit) the moral quality of actions regarded as determining the nature of a future existence [n -S]\n",
  "KARMAS": "KARMA, (Sanskrit) the moral quality of actions regarded as determining the nature of a future existence [n]\n",
  "KARMIC": "(Sanskrit) relating to karma, the moral quality of actions regarded as determining the nature of a future existence [adj KARMICALLY]\n",
  "KARMICALLY": "KARMIC, (Sanskrit) relating to karma, the moral quality of actions regarded as determining the nature of a future existence [adv]\n",
  "KARN": "a mound of stone set up as a memorial, also CAIRN, CARN [n -S]\n",
  "KARNS": "KARN, a mound of stone set up as a memorial, also CAIRN, CARN [n]\n",
  "KARO": "(Maori) a small New Zealand tree [n -S]\n",
  "KAROO": "(Hottentot) in South Africa, a high inland pastoral tableland, also KARROO [n -S]\n",
  "KAROOS": "KAROO, (Hottentot) in South Africa, a high inland pastoral tableland, also KARROO [n]\n",
  "KARORO": "(Maori) a large seagull with black feathers on its back [n -S]\n",
  "KAROROS": "KARORO, (Maori) a large seagull with black feathers on its back [n]\n",
  "KAROS": "KARO, (Maori) a small New Zealand tree [n]\n",
  "KAROSHI": "(Japanese) death caused by overwork [n -S]\n",
  "KAROSHIS": "KAROSHI, (Japanese) death caused by overwork [n]\n",
  "KAROSS": "(South African) a South African garment of animal skins [n -ES]\n",
  "KAROSSES": "KAROSS, (South African) a South African garment of animal skins [n]\n",
  "KARRI": "(Native Australian) a type of Australian gum tree [n -S]\n",
  "KARRIS": "KARRI, (Native Australian) a type of Australian gum tree [n]\n",
  "KARROO": "(Hottentot) in South Africa, a high inland pastoral tableland, also KAROO [n -S]\n",
  "KARROOS": "KARROO, (Hottentot) in South Africa, a high inland pastoral tableland, also KAROO [n]\n",
  "KARSEY": "(slang) a lavatory, also KHAZI, KAZI, CARSEY, KARZY, KARSY [n -S]\n",
  "KARSEYS": "KARSEY, (slang) a lavatory, also KHAZI, KAZI, CARSEY, KARZY, KARSY [n]\n",
  "KARSIES": "KARSY, (slang) a lavatory, also KHAZI, KAZI, CARSEY, KARZY, KARSEY [n]\n",
  "KARST": "(German) a landscape composed of limestone features including sinkholes, caves, and underground streams [n -S]\n",
  "KARSTIC": "of or like karst, a landscape composed of limestone features including sinkholes, caves, and underground streams [adj]\n",
  "KARSTIFICATION": "the process of becoming karstified [n -S]\n",
  "KARSTIFICATIONS": "KARSTIFICATION, the process of becoming karstified [n]\n",
  "KARSTIFIED": "KARSTIFY, to develop underground drainage [v]\n",
  "KARSTIFIES": "KARSTIFY, to develop underground drainage [v]\n",
  "KARSTIFY": "to develop underground drainage [v KARSTIFIED, KARSTIFYING, KARSTIFIES]\n",
  "KARSTIFYING": "KARSTIFY, to develop underground drainage [v]\n",
  "KARSTS": "KARST, (German) a landscape composed of limestone features including sinkholes, caves, and underground streams [n]\n",
  "KARSY": "(slang) a lavatory, also KHAZI, KAZI, CARSEY, KARZY, KARSEY [n KARSIES]\n",
  "KART": "a small motor vehicle [n -S]\n",
  "KARTER": "one who drives go-carts [n -S]\n",
  "KARTERS": "KARTER, one who drives go-carts [n]\n",
  "KARTING": "the sport of racing go-karts [n -S]\n",
  "KARTINGS": "KARTING, the sport of racing go-karts [n]\n",
  "KARTS": "KART, a small motor vehicle [n]\n",
  "KARUHIRUHI": "(Maori) the pied shag, found in New Zealand [n -S]\n",
  "KARUHIRUHIS": "KARUHIRUHI, (Maori) the pied shag, found in New Zealand [n]\n",
  "KARYOGAMIC": "relating to karyogamy [adj]\n",
  "KARYOGAMIES": "KARYOGAMY, a process of fusion of the nuclei of two cells; the second step in syngamy [n]\n",
  "KARYOGAMY": "a process of fusion of the nuclei of two cells; the second step in syngamy [n KARYOGAMIES]\n",
  "KARYOGRAM": "a chromosome diagram or karyotype [n -S]\n",
  "KARYOGRAMS": "KARYOGRAM, a chromosome diagram or karyotype [n]\n",
  "KARYOKINESES": "KARYOKINESIS, division of the cell nucleus [n]\n",
  "KARYOKINESIS": "division of the cell nucleus [n KARYOKINESES]\n",
  "KARYOKINETIC": "relating to karyokinesis, division of the cell nucleus [adj]\n",
  "KARYOLOGIC": "relating to karyology, the study of cell nuclei, also KARYOLOGICAL [adj]\n",
  "KARYOLOGICAL": "relating to karyology, the study of cell nuclei, also KARYOLOGIC [adj]\n",
  "KARYOLOGIES": "KARYOLOGY, the study of cell nuclei [n]\n",
  "KARYOLOGIST": "a practitioner of karyology, the study of cell nuclei [n -S]\n",
  "KARYOLOGISTS": "KARYOLOGIST, a practitioner of karyology, the study of cell nuclei [n]\n",
  "KARYOLOGY": "the study of cell nuclei [n KARYOLOGIES]\n",
  "KARYOLYMPH": "the liquid portion of nuclear protoplasm [n -S]\n",
  "KARYOLYMPHS": "KARYOLYMPH, the liquid portion of nuclear protoplasm [n]\n",
  "KARYOLYSES": "KARYOLYSIS, the dissolution of the nucleus by disintegration of the chromatin [n]\n",
  "KARYOLYSIS": "the dissolution of the nucleus by disintegration of the chromatin [n KARYOLYSES]\n",
  "KARYOLYTIC": "relating to karyolysis [adj]\n",
  "KARYOMAPPING": "a technique for determining whether an embryo has inherited a genetic defect by analysing DNA taken from it and its close relatives [n -S]\n",
  "KARYOMAPPINGS": "KARYOMAPPING, a technique for determining whether an embryo has inherited a genetic defect by analysing DNA taken from it and its close relatives [n]\n",
  "KARYON": "the cell nucleus [n -S]\n",
  "KARYONS": "KARYON, the cell nucleus [n]\n",
  "KARYOPLASM": "nucleoplasm [n -S]\n",
  "KARYOPLASMIC": "of or like karyoplasm, nucleoplasm [adj]\n",
  "KARYOPLASMS": "KARYOPLASM, nucleoplasm [n]\n",
  "KARYOSOME": "a spherical aggregation of chromatin in a resting nucleus during mitosis [n -S]\n",
  "KARYOSOMES": "KARYOSOME, a spherical aggregation of chromatin in a resting nucleus during mitosis [n]\n",
  "KARYOTIN": "a readily stained substance in the nucleus of a cell made up of DNA, RNA and proteins, aka chromatin, also CARYOTIN [n -S]\n",
  "KARYOTINS": "KARYOTIN, a readily stained substance in the nucleus of a cell made up of DNA, RNA and proteins, aka chromatin, also CARYOTIN [n]\n",
  "KARYOTYPE": "the appearance, number and arrangements of chromosomes [n -S] / to determine the karyotype of [v KARYOTYPED, KARYOTYPING, KARYOTYPES]\n",
  "KARYOTYPED": "KARYOTYPE, to determine the karyotype of [v]\n",
  "KARYOTYPES": "KARYOTYPE, to determine the karyotype of [v]\n",
  "KARYOTYPIC": "of or like a karyotype, the appearance, number and arrangements of chromosomes, also KARYOTYPICAL [adj]\n",
  "KARYOTYPICAL": "of or like a karyotype, the appearance, number and arrangements of chromosomes, also KARYOTYPIC [adj]\n",
  "KARYOTYPICALLY": "KARYOTYPICAL, of or like a karyotype, the appearance, number and arrangements of chromosomes, also KARYOTYPIC [adv]\n",
  "KARYOTYPING": "KARYOTYPE, to determine the karyotype of [v]\n",
  "KARZIES": "KARZY, (slang) a lavatory, also KHAZI, KAZI, CARSEY, KARSY, KARSEY [n]\n",
  "KARZY": "(slang) a lavatory, also KHAZI, KAZI, CARSEY, KARSY, KARSEY [n KARZIES]\n",
  "KAS": "KA, to serve, also KAE [v]\n",
  "KASBAH": "(Arabic) the old section of a North African city, also CASBAH [n -S]\n",
  "KASBAHS": "KASBAH, (Arabic) the old section of a North African city, also CASBAH [n]\n",
  "KASHA": "(Russian) a porridge or gruel-like dish made from crushed buckwheat [n -S]\n",
  "KASHAS": "KASHA, (Russian) a porridge or gruel-like dish made from crushed buckwheat [n]\n",
  "KASHER": "(Hebrew) permissible to eat under Jewish law / to make kasher, also KOSHER [v -ED, -ING, -S]\n",
  "KASHERED": "KASHER, to make kasher, also KOSHER [v]\n",
  "KASHERING": "KASHER, to make kasher, also KOSHER [v]\n",
  "KASHERS": "KASHER, to make kasher, also KOSHER [v]\n",
  "KASHMIR": "a soft twilled fabric made of fine goat's wool, also CASHMERE, CASIMERE, CASIMIRE, CASSIMERE, KERSEYMERE [n -S]\n",
  "KASHMIRS": "KASHMIR, a soft twilled fabric made of fine goat's wool, also CASHMERE, CASIMERE, CASIMIRE, CASSIMERE, KERSEYMERE [n]\n",
  "KASHRUS": "(Hebrew) the Jewish laws of diet and food preparation, also KASHRUTH, KASHRUT [n -ES]\n",
  "KASHRUSES": "KASHRUS, (Hebrew) the Jewish laws of diet and food preparation, also KASHRUTH, KASHRUT [n]\n",
  "KASHRUT": "(Hebrew) the Jewish laws of diet and food preparation, also KASHRUTH, KASHRUS [n -S]\n",
  "KASHRUTH": "(Hebrew) the Jewish laws of diet and food preparation, also KASHRUS, KASHRUT [n -S]\n",
  "KASHRUTHS": "KASHRUTH, (Hebrew) the Jewish laws of diet and food preparation, also KASHRUS, KASHRUT [n]\n",
  "KASHRUTS": "KASHRUT, (Hebrew) the Jewish laws of diet and food preparation, also KASHRUTH, KASHRUS [n]\n",
  "KASME": "(Hinglish) I swear [interj]\n",
  "KAT": "(Arabic) a shrub of East Africa, Arabia, etc., or its leaves, chewed or taken as tea for their stimulant effect, also KHAT, QAT [n -S]\n",
  "KATA": "(Japanese) a sequence of movements in the martial arts [n -S]\n",
  "KATABASES": "KATABASIS, a going down; a military retreat, also CATABASIS [n]\n",
  "KATABASIS": "a going down; a military retreat, also CATABASIS [n KATABASES]\n",
  "KATABATIC": "moving downhill, sinking (of winds), also CATABATIC [adj]\n",
  "KATABOLIC": "relating to catabolism, destructive chemical processes in living creatures, also CATABOLIC [adj KATABOLICALLY]\n",
  "KATABOLICALLY": "KATABOLIC, relating to catabolism, destructive chemical processes in living creatures, also CATABOLIC [adv]\n",
  "KATABOLISM": "destructive metabolism, the disruptive processes of chemical change in organisms, also CATABOLISM [n -S]\n",
  "KATABOLISMS": "KATABOLISM, destructive metabolism, the disruptive processes of chemical change in organisms, also CATABOLISM [n]\n",
  "KATABOTHRON": "(Modern Greek) an underground water channel, also KATAVOTHRON [n -S]\n",
  "KATABOTHRONS": "KATABOTHRON, (Modern Greek) an underground water channel, also KATAVOTHRON [n]\n",
  "KATADROMOUS": "of fishes, descending periodically for spawning to the lower parts of a river or to the sea, as opposed to anadromous, also CATADROMOUS [adj]\n",
  "KATAKANA": "(Japanese) a Japanese writing system [n -S]\n",
  "KATAKANAS": "KATAKANA, (Japanese) a Japanese writing system [n]\n",
  "KATAL": "a derived SI unit, the unit of catalytic activity, equal to one mole per second [n -S]\n",
  "KATALS": "KATAL, a derived SI unit, the unit of catalytic activity, equal to one mole per second [n]\n",
  "KATANA": "(Japanese) a long single-edged samurai sword [n -S]\n",
  "KATANAS": "KATANA, (Japanese) a long single-edged samurai sword [n]\n",
  "KATAS": "KATA, (Japanese) a sequence of movements in the martial arts [n]\n",
  "KATATHERMOMETER": "an instrument for measuring the cooling power of air [n]\n",
  "KATAVOTHRON": "(Modern Greek) an underground water channel, also KATABOTHRON [n -S]\n",
  "KATAVOTHRONS": "KATAVOTHRON, (Modern Greek) an underground water channel, also KATABOTHRON [n]\n",
  "KATCHINA": "(Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCINA, KATSINA [n -S]\n",
  "KATCHINAS": "KATCHINA, (Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCINA, KATSINA [n]\n",
  "KATCINA": "(Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCHINA, KATSINA [n -S]\n",
  "KATCINAS": "KATCINA, (Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCHINA, KATSINA [n]\n",
  "KATHAK": "(Sanskrit) a classical dance of India in which brief passages of mime alternate with rapid, rhythmic dance [n -S]\n",
  "KATHAKALI": "(Malayalam) a highly stylized form of South Indian drama, using dance and mime [n -S]\n",
  "KATHAKALIS": "KATHAKALI, (Malayalam) a highly stylized form of South Indian drama, using dance and mime [n]\n",
  "KATHAKS": "KATHAK, (Sanskrit) a classical dance of India in which brief passages of mime alternate with rapid, rhythmic dance [n]\n",
  "KATHAREVOUSA": "a formal archaizing written form of Modern Greek, based on Ancient Greek [n -S]\n",
  "KATHAREVOUSAS": "KATHAREVOUSA, a formal archaizing written form of Modern Greek, based on Ancient Greek [n]\n",
  "KATHAROMETER": "an instrument measuring changes in composition of gases [n -S]\n",
  "KATHAROMETERS": "KATHAROMETER, an instrument measuring changes in composition of gases [n]\n",
  "KATHARSES": "KATHARSIS, (Greek) a natural or artificial purgation of any passage, as of the mouth, bowels, etc., also CATHARSIS [n]\n",
  "KATHARSIS": "(Greek) a natural or artificial purgation of any passage, as of the mouth, bowels, etc., also CATHARSIS [n KATHARSES]\n",
  "KATHODAL": "relating to a kathode, the positive terminal of a battery, also CATHODAL, CATHODIC, CATHODICAL, KATHODIC [adj]\n",
  "KATHODE": "a negatively charged electrode, also CATHODE [n -S]\n",
  "KATHODES": "KATHODE, a negatively charged electrode, also CATHODE [n]\n",
  "KATHODIC": "relating to a kathode, the positive terminal of a battery, also CATHODAL, CATHODIC, CATHODICAL, KATHODAL [adj]\n",
  "KATHUMP": "a loud thudding sound [n -S]\n",
  "KATHUMPS": "KATHUMP, a loud thudding sound [n]\n",
  "KATI": "(Malay) an Asian unit of weight, also CATTIE, KATTI [n -S]\n",
  "KATION": "a positively charged ion, also CATION [n -S]\n",
  "KATIONS": "KATION, a positively charged ion, also CATION [n]\n",
  "KATIPO": "(Maori) a venomous black New Zealand spider with a red spot on its back [n -S]\n",
  "KATIPOS": "KATIPO, (Maori) a venomous black New Zealand spider with a red spot on its back [n]\n",
  "KATIS": "KATI, (Malay) an Asian unit of weight, also CATTIE, KATTI [n]\n",
  "KATORGA": "(Russian) a Russian form of penal servitude [n -S]\n",
  "KATORGAS": "KATORGA, (Russian) a Russian form of penal servitude [n]\n",
  "KATS": "KAT, (Arabic) a shrub of East Africa, Arabia, etc., or its leaves, chewed or taken as tea for their stimulant effect, also KHAT, QAT [n]\n",
  "KATSINA": "(Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCHINA, KATCINA [n KATSINAM or KATSINAS]\n",
  "KATSINAM": "KATSINA, (Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCHINA, KATCINA [n]\n",
  "KATSINAS": "KATSINA, (Native American) a doll representing rain-bringing Hopi ancestors, also KACHINA, KATCHINA, KATCINA [n]\n",
  "KATSURA": "(Japanese) a deciduous tree of Japan and China [n -S]\n",
  "KATSURAS": "KATSURA, (Japanese) a deciduous tree of Japan and China [n]\n",
  "KATTI": "(Malay) an Asian unit of weight, also CATTIE, KATI [n -S]\n",
  "KATTIS": "KATTI, (Malay) an Asian unit of weight, also CATTIE, KATI [n]\n",
  "KATYDID": "a kind of grasshopper [n -S]\n",
  "KATYDIDS": "KATYDID, a kind of grasshopper [n]\n",
  "KATZENJAMMER": "(German) a hangover [n -S]\n",
  "KATZENJAMMERS": "KATZENJAMMER, (German) a hangover [n]\n",
  "KAUGH": "(Scots) care, trouble, also KIAUGH [n -S]\n",
  "KAUGHS": "KAUGH, (Scots) care, trouble, also KIAUGH [n]\n",
  "KAUMATUA": "(Maori) a tribal elder [n -S]\n",
  "KAUMATUAS": "KAUMATUA, (Maori) a tribal elder [n]\n",
  "KAUPAPA": "(Maori) a strategy or cause [n -S]\n",
  "KAUPAPAS": "KAUPAPA, (Maori) a strategy or cause [n]\n",
  "KAURI": "(Maori) a gum- and timber-yielding tree of New Zealand, also KAURY [n -S]\n",
  "KAURIES": "KAURY, (Maori) a gum- and timber-yielding tree of New Zealand, also KAURI [n]\n",
  "KAURIS": "KAURI, (Maori) a gum- and timber-yielding tree of New Zealand, also KAURY [n]\n",
  "KAURU": "(Maori) the edible stem of the New Zealand cabbage tree [n -S]\n",
  "KAURUS": "KAURU, (Maori) the edible stem of the New Zealand cabbage tree [n]\n",
  "KAURY": "(Maori) a gum- and timber-yielding tree of New Zealand, also KAURI [n KAURIES]\n",
  "KAVA": "(Tongan) a tropical shrub, also AVA, KAVAKAVA [n -S]\n",
  "KAVAKAVA": "(Tongan) an aromatic plant of the pepper family; a narcotic drink prepared from its root and stem, also AVA, KAVA [n -S]\n",
  "KAVAKAVAS": "KAVAKAVA, (Tongan) an aromatic plant of the pepper family; a narcotic drink prepared from its root and stem, also AVA, KAVA [n]\n",
  "KAVAL": "a kind of flute, played esp. in the Balkans [n -S]\n",
  "KAVALS": "KAVAL, a kind of flute, played esp. in the Balkans [n]\n",
  "KAVAS": "KAVA, (Tongan) a tropical shrub, also AVA, KAVAKAVA [n]\n",
  "KAVASS": "(Turkish) an armed attendant in Turkey, also CAVASS [n -ES]\n",
  "KAVASSES": "KAVASS, (Turkish) an armed attendant in Turkey, also CAVASS [n]\n",
  "KAW": "to cry like a crow, also CAW [v -ED, -ING, -S]\n",
  "KAWA": "(Maori) protocol or etiquette (in a Maori tribal meeting place) [n -S]\n",
  "KAWAII": "(Japanese) in Japanese culture, the quality of being cute [n -S]\n",
  "KAWAIIS": "KAWAII, (Japanese) in Japanese culture, the quality of being cute [n]\n",
  "KAWAKAWA": "(Maori) a New Zealand tree, aka peppertree [n -S]\n",
  "KAWAKAWAS": "KAWAKAWA, (Maori) a New Zealand tree, aka peppertree [n]\n",
  "KAWANATANGA": "(Maori) sovereignty [n -S]\n",
  "KAWANATANGAS": "KAWANATANGA, (Maori) sovereignty [n]\n",
  "KAWAS": "KAWA, (Maori) protocol or etiquette (in a Maori tribal meeting place) [n]\n",
  "KAWAU": "(Maori) the black shag [n -S]\n",
  "KAWAUS": "KAWAU, (Maori) the black shag [n]\n",
  "KAWED": "KAW, to cry like a crow, also CAW [v]\n",
  "KAWING": "KAW, to cry like a crow, also CAW [v]\n",
  "KAWS": "KAW, to cry like a crow, also CAW [v]\n",
  "KAY": "the letter K [n -S]\n",
  "KAYAK": "(Inuit) a type of canoe, also KAIAK, KYAK, QAJAQ [n -S] / to travel by kayak, also KAIAK [v -ED, -ING, -S]\n",
  "KAYAKED": "KAYAK, to travel by kayak, also KAIAK [v]\n",
  "KAYAKER": "one that rides in a kayak [n -S]\n",
  "KAYAKERS": "KAYAKER, one that rides in a kayak [n]\n",
  "KAYAKING": "the act of paddling a kayak [n -S]\n",
  "KAYAKINGS": "KAYAKING, the act of paddling a kayak [n]\n",
  "KAYAKS": "KAYAK, to travel by kayak, also KAIAK [v]\n",
  "KAYLE": "a ninepin, also KAIL [n -S]\n",
  "KAYLES": "KAYLE, a ninepin, also KAIL [n]\n",
  "KAYLIED": "(slang) intoxicated [adj]\n",
  "KAYO": "to knock out [v KAYOED, KAYOING, KAYOS or KAYOES]\n",
  "KAYOED": "KAYO, to knock out [v]\n",
  "KAYOES": "KAYO, to knock out [v]\n",
  "KAYOING": "the act of a knockout [n -S]\n",
  "KAYOINGS": "KAYOING, the act of a knockout [n]\n",
  "KAYOS": "KAYO, to knock out [v]\n",
  "KAYS": "KAY, the letter K [n]\n",
  "KAZACHKI": "KAZACHOK, (Russian) a Russian folk dance, also KAZACHOC, KAZATSKI, KAZATSKY, KAZATZKA [n]\n",
  "KAZACHOC": "(Russian) a Russian folk dance in which high kicks are performed from a squatting position, also KAZACHOK, KAZATSKI, KAZATSKY, KAZATZKA [n -S]\n",
  "KAZACHOCS": "KAZACHOC, (Russian) a Russian folk dance in which high kicks are performed from a squatting position, also KAZACHOK, KAZATSKI, KAZATSKY, KAZATZKA [n]\n",
  "KAZACHOK": "(Russian) a Russian folk dance, also KAZACHOC, KAZATSKI, KAZATSKY, KAZATZKA [n KAZACHKI or KAZACHOKS]\n",
  "KAZACHOKS": "KAZACHOK, (Russian) a Russian folk dance, also KAZACHOC, KAZATSKI, KAZATSKY, KAZATZKA [n]\n",
  "KAZATSKI": "(Russian) a Russian folk dance, also KAZACHOC, KAZACHOK, KAZATSKY, KAZATZKA [n -ES]\n",
  "KAZATSKIES": "KAZATSKI, (Russian) a Russian folk dance, also KAZACHOC, KAZACHOK, KAZATSKY, KAZATZKA [n]\n",
  "KAZATSKY": "(Russian) a Russian folk dance, also KAZACHOC, KAZACHOK, KAZATSKI, KAZATZKA [n KAZATSKIES]\n",
  "KAZATZKA": "(Russian) a Russian folk dance, also KAZACHOC, KAZACHOK, KAZATSKI, KAZATSKY [n -S]\n",
  "KAZATZKAS": "KAZATZKA, (Russian) a Russian folk dance, also KAZACHOC, KAZACHOK, KAZATSKI, KAZATSKY [n]\n",
  "KAZI": "a lavatory, also KHAZI, CARSEY, KARZY, KARSY, KARSEY [n -S]\n",
  "KAZILLION": "an indefinitely large number, also GAZILLION [n -S]\n",
  "KAZILLIONS": "KAZILLION, an indefinitely large number, also GAZILLION [n]\n",
  "KAZIS": "KAZI, a lavatory, also KHAZI, CARSEY, KARZY, KARSY, KARSEY [n]\n",
  "KAZOO": "a toy musical instrument, also GAZOO, GAZOOKA [n -S]\n",
  "KAZOOS": "KAZOO, a toy musical instrument, also GAZOO, GAZOOKA [n]\n",
  "KBAR": "a unit of atmospheric pressure [n -S]\n",
  "KBARS": "KBAR, a unit of atmospheric pressure [n]\n",
  "KEA": "a large New Zealand parrot [n -S]\n",
  "KEAS": "KEA, a large New Zealand parrot [n]\n",
  "KEASAR": "(obsolete) an emperor, also KAISER, KESAR [n -S]\n",
  "KEASARS": "KEASAR, (obsolete) an emperor, also KAISER, KESAR [n]\n",
  "KEAVIE": "(Scots) a hencoop or cage, also CAVIE [n -S]\n",
  "KEAVIES": "KEAVIE, (Scots) a hencoop or cage, also CAVIE [n]\n",
  "KEB": "to give birth to a premature lamb [v KEBBED, KEBBING, KEBS]\n",
  "KEBAB": "(Arabic) cubes of meat cooked on a skewer [n -S] / to skewer, also CABOB, KABAB, KABOB, KEBOB [v KEBABBED, KEBABBING, KEBABS]\n",
  "KEBABBED": "KEBAB, to skewer, also CABOB, KABAB, KABOB, KEBOB [v]\n",
  "KEBABBING": "KEBAB, to skewer, also CABOB, KABAB, KABOB, KEBOB [v]\n",
  "KEBABS": "KEBAB, to skewer, also CABOB, KABAB, KABOB, KEBOB [v]\n",
  "KEBAR": "(Scots) a heavy wooden heaving pole, also CABER, KABAR [n -S]\n",
  "KEBARS": "KEBAR, (Scots) a heavy wooden heaving pole, also CABER, KABAR [n]\n",
  "KEBBED": "KEB, to give birth to a premature lamb [v]\n",
  "KEBBIE": "(Scots) a shepherd's crook [n -S]\n",
  "KEBBIES": "KEBBIE, (Scots) a shepherd's crook [n]\n",
  "KEBBING": "KEB, to give birth to a premature lamb [v]\n",
  "KEBBOCK": "(Scots) a double cream cheese rolled in oatmeal, also CABOC, KEBBUCK [n -S]\n",
  "KEBBOCKS": "KEBBOCK, (Scots) a double cream cheese rolled in oatmeal, also CABOC, KEBBUCK [n]\n",
  "KEBBUCK": "(Scots) a double cream cheese rolled in oatmeal, also CABOC, KEBBOCK [n -S]\n",
  "KEBBUCKS": "KEBBUCK, (Scots) a double cream cheese rolled in oatmeal, also CABOC, KEBBOCK [n]\n",
  "KEBELE": "(Amharic) a self-governing association found in towns in Ethiopia, also KABELE [n -S]\n",
  "KEBELES": "KEBELE, (Amharic) a self-governing association found in towns in Ethiopia, also KABELE [n]\n",
  "KEBLAH": "(Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KIBLA, KIBLAH, QIBLA [n -S]\n",
  "KEBLAHS": "KEBLAH, (Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KIBLA, KIBLAH, QIBLA [n]\n",
  "KEBOB": "(Arabic) cubes of meat cooked on a skewer [n -S] / to skewer, also CABOB, KEBAB, KABAB, KABOB [v KEBOBBED, KEBOBBING, KEBOBS]\n",
  "KEBOBBED": "KEBOB, to skewer, also CABOB, KEBAB, KABAB, KABOB [v]\n",
  "KEBOBBING": "KEBOB, to skewer, also CABOB, KEBAB, KABAB, KABOB [v]\n",
  "KEBOBS": "KEBOB, to skewer, also CABOB, KEBAB, KABAB, KABOB [v]\n",
  "KEBS": "KEB, to give birth to a premature lamb [v]\n",
  "KECK": "to heave or retch, as in an effort to vomit [v -ED, -ING, -S]\n",
  "KECKED": "KECK, to heave or retch, as in an effort to vomit [v]\n",
  "KECKING": "KECK, to heave or retch, as in an effort to vomit [v]\n",
  "KECKLE": "to protect by binding with rope [v KECKLED, KECKLING, KECKLES]\n",
  "KECKLED": "KECKLE, to protect by binding with rope [v]\n",
  "KECKLES": "KECKLE, to protect by binding with rope [v]\n",
  "KECKLING": "a protective layer of rope [n -S]\n",
  "KECKLINGS": "KECKLING, a protective layer of rope [n]\n",
  "KECKS": "the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKSY, KEKSYE, KEX [n -ES]\n",
  "KECKSES": "KECKS, the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKSY, KEKSYE, KEX [n]\n",
  "KECKSIES": "KECKSY, the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKS, KEKSYE, KEX [n]\n",
  "KECKSY": "the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKS, KEKSYE, KEX [n KECKSIES]\n",
  "KED": "a wingless fly that infests sheep, also KADE [n -S]\n",
  "KEDDAH": "(Hindi) an enclosure used for the capture of wild elephants, also KHEDA, KHEDAH [n -S]\n",
  "KEDDAHS": "KEDDAH, (Hindi) an enclosure used for the capture of wild elephants, also KHEDA, KHEDAH [n]\n",
  "KEDGE": "to move (a ship) by hauling on an anchor dropped ahead from a boat [v KEDGED, KEDGING, KEDGES]\n",
  "KEDGED": "KEDGE, to move (a ship) by hauling on an anchor dropped ahead from a boat [v]\n",
  "KEDGER": "a small steadying anchor [n -S]\n",
  "KEDGEREE": "(Hindi) a food in India [n -S]\n",
  "KEDGEREES": "KEDGEREE, (Hindi) a food in India [n]\n",
  "KEDGERS": "KEDGER, a small steadying anchor [n]\n",
  "KEDGES": "KEDGE, to move (a ship) by hauling on an anchor dropped ahead from a boat [v]\n",
  "KEDGIER": "KEDGY, (Scots) brisk, cheerful, also CADGY, KEDGE, KIDGE, KIDGIE [adj]\n",
  "KEDGIEST": "KEDGY, (Scots) brisk, cheerful, also CADGY, KEDGE, KIDGE, KIDGIE [adj]\n",
  "KEDGING": "KEDGE, to move (a ship) by hauling on an anchor dropped ahead from a boat [v]\n",
  "KEDGY": "(Scots) brisk, cheerful, also CADGY, KEDGE, KIDGE, KIDGIE [adj KEDGIER, KEDGIEST]\n",
  "KEDS": "KED, a wingless fly that infests sheep, also KADE [n]\n",
  "KEECH": "(Shakespeare) a lump of tallow [n -ES]\n",
  "KEECHES": "KEECH, (Shakespeare) a lump of tallow [n]\n",
  "KEEF": "(Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEF, KIEF, KIF [n -S]\n",
  "KEEFS": "KEEF, (Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEF, KIEF, KIF [n]\n",
  "KEEK": "to glance; to peep [v -ED, -ING, -S]\n",
  "KEEKED": "KEEK, to glance; to peep [v]\n",
  "KEEKER": "someone who looks, specifically an inspector of coal [n -S]\n",
  "KEEKERS": "KEEKER, someone who looks, specifically an inspector of coal [n]\n",
  "KEEKING": "KEEK, to glance; to peep [v]\n",
  "KEEKS": "KEEK, to glance; to peep [v]\n",
  "KEEL": "the part of a ship along the bottom from stem to stern [n -S] / to turn keel upward [v -ED, -ING, -S]\n",
  "KEELAGE": "the amount paid to keep a boat in harbour [n -S]\n",
  "KEELAGES": "KEELAGE, the amount paid to keep a boat in harbour [n]\n",
  "KEELBOAT": "a type of yacht with a heavy external keel to offset the weight of the sails [n -S]\n",
  "KEELBOATS": "KEELBOAT, a type of yacht with a heavy external keel to offset the weight of the sails [n]\n",
  "KEELED": "KEEL, to turn keel upward [v]\n",
  "KEELER": "one employed in managing a Newcastle keel, also KEELMAN [n -S]\n",
  "KEELERS": "KEELER, one employed in managing a Newcastle keel, also KEELMAN [n]\n",
  "KEELHALE": "to punish by dragging under the keel of a ship, also KEELHAUL [v KEELHALED, KEELHALING, KEELHALES]\n",
  "KEELHALED": "KEELHALE, to punish by dragging under the keel of a ship, also KEELHAUL [v]\n",
  "KEELHALES": "KEELHALE, to punish by dragging under the keel of a ship, also KEELHAUL [v]\n",
  "KEELHALING": "KEELHALE, to punish by dragging under the keel of a ship, also KEELHAUL [v]\n",
  "KEELHAUL": "to punish by dragging under the keel of a ship, also KEELHALE [v -ED, -ING, -S]\n",
  "KEELHAULED": "KEELHAUL, to punish by dragging under the keel of a ship, also KEELHALE [v]\n",
  "KEELHAULING": "punishment by dragging under keel of ship [n -S]\n",
  "KEELHAULINGS": "KEELHAULING, punishment by dragging under keel of ship [n]\n",
  "KEELHAULS": "KEELHAUL, to punish by dragging under the keel of a ship, also KEELHALE [v]\n",
  "KEELIE": "(Scots) the kestrel or other hawk; an urban tough, esp. from Glasgow [n -S]\n",
  "KEELIES": "KEELIE, (Scots) the kestrel or other hawk; an urban tough, esp. from Glasgow [n]\n",
  "KEELING": "(Scots) a codfish [n -S]\n",
  "KEELINGS": "KEELING, (Scots) a codfish [n]\n",
  "KEELIVINE": "(Scots) a lead pencil, also KEELYVINE [n -S]\n",
  "KEELIVINES": "KEELIVINE, (Scots) a lead pencil, also KEELYVINE [n]\n",
  "KEELLESS": "having no keel [adj]\n",
  "KEELMAN": "one employed in managing a Newcastle keel, also KEELER [n KEELMEN]\n",
  "KEELMEN": "KEELMAN, one employed in managing a Newcastle keel, also KEELER [n]\n",
  "KEELS": "KEEL, to turn keel upward [v]\n",
  "KEELSON": "a wooden or steel structure lengthwise within a ship's frame to bear and distribute stress, also KELSON [n -S]\n",
  "KEELSONS": "KEELSON, a wooden or steel structure lengthwise within a ship's frame to bear and distribute stress, also KELSON [n]\n",
  "KEELYVINE": "(Scots) a lead pencil, also KEELIVINE [n -S]\n",
  "KEELYVINES": "KEELYVINE, (Scots) a lead pencil, also KEELIVINE [n]\n",
  "KEEMA": "(Hindi) in Indian cookery, minced beef [n -S]\n",
  "KEEMAS": "KEEMA, (Hindi) in Indian cookery, minced beef [n]\n",
  "KEEN": "to wail loudly over the dead [v -ED, -ING, -S] / enthusiastic [adj KEENER, KEENEST, KEENLY]\n",
  "KEENED": "KEEN, to wail loudly over the dead [v]\n",
  "KEENER": "(Canadian) a student is keen [n -S]\n",
  "KEENERS": "KEENER, (Canadian) a student is keen [n]\n",
  "KEENEST": "KEEN, enthusiastic [adj]\n",
  "KEENING": "a wailing, a lament [n -S]\n",
  "KEENINGS": "KEENING, a wailing, a lament [n]\n",
  "KEENLY": "KEEN, enthusiastic [adv]\n",
  "KEENNESS": "sharpness [n -ES]\n",
  "KEENNESSES": "KEENNESS, sharpness [n]\n",
  "KEENO": "a gambling game, a variety of the game of lotto, played with numbered balls or knobs, also KENO, KINO, QUINO [n -S]\n",
  "KEENOS": "KEENO, a gambling game, a variety of the game of lotto, played with numbered balls or knobs, also KENO, KINO, QUINO [n]\n",
  "KEENS": "KEEN, to wail loudly over the dead [v]\n",
  "KEEP": "to retain in one's possession [v KEPT, KEEPING, KEEPS]\n",
  "KEEPABLE": "able to be kept [adj]\n",
  "KEEPER": "one who keeps [n -S]\n",
  "KEEPERLESS": "without a keeper [adj]\n",
  "KEEPERS": "KEEPER, one who keeps [n]\n",
  "KEEPERSHIP": "the office or position of a keeper [n -S]\n",
  "KEEPERSHIPS": "KEEPERSHIP, the office or position of a keeper [n]\n",
  "KEEPING": "custody, ownership [n -S]\n",
  "KEEPINGS": "KEEPING, custody, ownership [n]\n",
  "KEEPNET": "a net for holding fish alive in a river [n -S]\n",
  "KEEPNETS": "KEEPNET, a net for holding fish alive in a river [n]\n",
  "KEEPS": "KEEP, to retain in one's possession [v]\n",
  "KEEPSAKE": "a memento [n -S]\n",
  "KEEPSAKES": "KEEPSAKE, a memento [n]\n",
  "KEEPSAKIER": "KEEPSAKY, vapidly pretty [adj]\n",
  "KEEPSAKIEST": "KEEPSAKY, vapidly pretty [adj]\n",
  "KEEPSAKY": "vapidly pretty [adj KEEPSAKIER, KEEPSAKIEST]\n",
  "KEESHOND": "(Dutch) a small, heavy-coated dog [n KEESHONDS or KEESHONDEN]\n",
  "KEESHONDEN": "KEESHOND, (Dutch) a small, heavy-coated dog [n]\n",
  "KEESHONDS": "KEESHOND, (Dutch) a small, heavy-coated dog [n]\n",
  "KEESTER": "(slang) the buttocks, also KEISTER, KEYSTER, KIESTER [n -S]\n",
  "KEESTERS": "KEESTER, (slang) the buttocks, also KEISTER, KEYSTER, KIESTER [n]\n",
  "KEET": "a young guinea fowl [n -S]\n",
  "KEETS": "KEET, a young guinea fowl [n]\n",
  "KEEVE": "a large tub, also KIEVE [n -S]\n",
  "KEEVES": "KEEVE, a large tub, also KIEVE [n]\n",
  "KEF": "(Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEEF, KIEF, KIF [n -S]\n",
  "KEFFEL": "(Welsh) a horse, a nag [n -S]\n",
  "KEFFELS": "KEFFEL, (Welsh) a horse, a nag [n]\n",
  "KEFFIYAH": "(Arabic) the cloth headgear worn by many Palestinians, also KAFFIYAH, KAFFIYEH, KEFFIYEH, KUFIYAH [n -S]\n",
  "KEFFIYAHS": "KEFFIYAH, (Arabic) the cloth headgear worn by many Palestinians, also KAFFIYAH, KAFFIYEH, KEFFIYEH, KUFIYAH [n]\n",
  "KEFFIYEH": "(Arabic) the cloth headgear worn by many Palestinians, also KAFFIYAH, KAFFIYEH, KEFFIYAH, KUFIYAH [n -S]\n",
  "KEFFIYEHS": "KEFFIYEH, (Arabic) the cloth headgear worn by many Palestinians, also KAFFIYAH, KAFFIYEH, KEFFIYAH, KUFIYAH [n]\n",
  "KEFIR": "a drink made from fermented cow's milk, also KEPHIR [n -S]\n",
  "KEFIRS": "KEFIR, a drink made from fermented cow's milk, also KEPHIR [n]\n",
  "KEFS": "KEF, (Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEEF, KIEF, KIF [n]\n",
  "KEFTEDES": "(Modern Greek) a Greek dish of meatballs cooked with herbs and onions [n]\n",
  "KEFUFFLE": "(Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KERFUFFLE, KURFUFFLE [v KEFUFFLED, KEFUFFLING, KEFUFFLES]\n",
  "KEFUFFLED": "KEFUFFLE, (Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "KEFUFFLES": "KEFUFFLE, (Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "KEFUFFLING": "KEFUFFLE, (Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KERFUFFLE, KURFUFFLE [v]\n",
  "KEG": "a small barrel [n -S] / to store in a keg [v KEGGED, KEGGING, KEGS]\n",
  "KEGELER": "(German) a bowler, also KEGLER [n -S]\n",
  "KEGELERS": "KEGELER, (German) a bowler, also KEGLER [n]\n",
  "KEGGED": "KEG, to store in a keg [v]\n",
  "KEGGER": "a drinking party at which a keg of beer is consumed [n -S]\n",
  "KEGGERS": "KEGGER, a drinking party at which a keg of beer is consumed [n]\n",
  "KEGGING": "KEG, to store in a keg [v]\n",
  "KEGLER": "(German) a bowler, also KEGELER [n -S]\n",
  "KEGLERS": "KEGLER, (German) a bowler, also KEGELER [n]\n",
  "KEGLING": "bowling [n -S]\n",
  "KEGLINGS": "KEGLING, bowling [n]\n",
  "KEGS": "KEG, to store in a keg [v]\n",
  "KEHUA": "(Maori) a ghost or spirit [n -S]\n",
  "KEHUAS": "KEHUA, (Maori) a ghost or spirit [n]\n",
  "KEIGHT": "KETCH, (obsolete) to catch [v]\n",
  "KEIR": "a bleaching-vat, also KIER [n -S]\n",
  "KEIREN": "an 8-lap track cycling event in which the riders follow a motorcycle pacer, also KEIRIN [n -S]\n",
  "KEIRENS": "KEIREN, an 8-lap track cycling event in which the riders follow a motorcycle pacer, also KEIRIN [n]\n",
  "KEIRETSU": "(Japanese) a coalition of business groups in Japan [n -S]\n",
  "KEIRETSUS": "KEIRETSU, (Japanese) a coalition of business groups in Japan [n]\n",
  "KEIRIN": "an 8-lap track cycling event in which the riders follow a motorcycle pacer, also KEIREN [n -S]\n",
  "KEIRINS": "KEIRIN, an 8-lap track cycling event in which the riders follow a motorcycle pacer, also KEIREN [n]\n",
  "KEIRS": "KEIR, a bleaching-vat, also KIER [n]\n",
  "KEISTER": "(slang) the buttocks, also KEESTER, KEYSTER, KIESTER [n -S]\n",
  "KEISTERS": "KEISTER, (slang) the buttocks, also KEESTER, KEYSTER, KIESTER [n]\n",
  "KEITLOA": "(Setswana) a two-horned rhinoceros [n -S]\n",
  "KEITLOAS": "KEITLOA, (Setswana) a two-horned rhinoceros [n]\n",
  "KEKENO": "(Maori) a New Zealand fur seal [n -S]\n",
  "KEKENOS": "KEKENO, (Maori) a New Zealand fur seal [n]\n",
  "KEKERENGU": "(Maori) a New Zealand bug [n -S]\n",
  "KEKERENGUS": "KEKERENGU, (Maori) a New Zealand bug [n]\n",
  "KEKS": "trousers [n]\n",
  "KEKSYE": "the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKS, KECKSY, KEX [n -S]\n",
  "KEKSYES": "KEKSYE, the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKS, KECKSY, KEX [n]\n",
  "KELEP": "a stinging ant, introduced into the Unitd States from Guatemala, that preys on the boll weevil [n -S]\n",
  "KELEPS": "KELEP, a stinging ant, introduced into the Unitd States from Guatemala, that preys on the boll weevil [n]\n",
  "KELIM": "(Turkish) a pileless woven rug traditionally made in the Middle East, also KHILIM, KILIM [n -S]\n",
  "KELIMS": "KELIM, (Turkish) a pileless woven rug traditionally made in the Middle East, also KHILIM, KILIM [n]\n",
  "KELL": "(Scots) a woman's headdress, a veil [n -S]\n",
  "KELLAUT": "(Hindi) an Indian robe of honour, also KILLUT, KHALAT, KHILAT [n -S]\n",
  "KELLAUTS": "KELLAUT, (Hindi) an Indian robe of honour, also KILLUT, KHALAT, KHILAT [n]\n",
  "KELLIES": "KELLY, the top pipe of a rotary string of drill pipes [n]\n",
  "KELLS": "KELL, (Scots) a woman's headdress, a veil [n]\n",
  "KELLY": "the top pipe of a rotary string of drill pipes [n KELLIES]\n",
  "KELOID": "a hard growth of scar tissue, also CHELOID [n -S]\n",
  "KELOIDAL": "relating to a keloid, a hard growth of scar tissue [adj]\n",
  "KELOIDS": "KELOID, a hard growth of scar tissue, also CHELOID [n]\n",
  "KELP": "a type of seaweed, also KILP [n -S] / to burn kelp seaweed [v -ED, -ING, -S]\n",
  "KELPED": "KELP, to burn kelp seaweed [v]\n",
  "KELPER": "an inhabitant of the Falkland Isles [n -S]\n",
  "KELPERS": "KELPER, an inhabitant of the Falkland Isles [n]\n",
  "KELPFISH": "a fish that lives in the kelp [n -ES]\n",
  "KELPFISHES": "KELPFISH, a fish that lives in the kelp [n]\n",
  "KELPIE": "(Scots) a water-horse, a fabulous beast, also KELPY [n -S]\n",
  "KELPIES": "KELPY, (Scots) a water-horse, a fabulous beast, also KELPIE [n]\n",
  "KELPING": "KELP, to burn kelp seaweed [v]\n",
  "KELPS": "KELP, to burn kelp seaweed [v]\n",
  "KELPY": "(Scots) a water-horse, a fabulous beast, also KELPIE [n KELPIES]\n",
  "KELSON": "a wooden or steel structure lengthwise within ship's frame to bear and distribute stress, also KEELSON [n -S]\n",
  "KELSONS": "KELSON, a wooden or steel structure lengthwise within ship's frame to bear and distribute stress, also KEELSON [n]\n",
  "KELT": "(Scots) a salmon that has just spawned [n -S]\n",
  "KELTER": "a coarse cloth made of black and white wool mixed and not dyed [n -S]\n",
  "KELTERS": "KELTER, a coarse cloth made of black and white wool mixed and not dyed [n]\n",
  "KELTIE": "(Scots) a bumper or glass filled to the brim, esp. one imposed as a forfeit, also KELTY [n -S]\n",
  "KELTIES": "KELTY, (Scots) a bumper or glass filled to the brim, esp. one imposed as a forfeit, also KELTIE [n]\n",
  "KELTS": "KELT, (Scots) a salmon that has just spawned [n]\n",
  "KELTY": "(Scots) a bumper or glass filled to the brim, esp. one imposed as a forfeit, also KELTIE [n KELTIES]\n",
  "KELVIN": "the SI unit of temperature [n -S]\n",
  "KELVINS": "KELVIN, the SI unit of temperature [n]\n",
  "KELYPHITIC": "as in kelyphitic rim, a mineral shell enclosing another mineral in an igneous rock [adj]\n",
  "KEMB": "(dialect) to comb [v KEMBED, KEMPT, KEMBING, KEMBS]\n",
  "KEMBED": "KEMB, (dialect) to comb [v]\n",
  "KEMBING": "KEMB, (dialect) to comb [v]\n",
  "KEMBLA": "(Australian slang) small change [n -S]\n",
  "KEMBLAS": "KEMBLA, (Australian slang) small change [n]\n",
  "KEMBO": "to set akimbo, also KIMBO [v -ED, -ING, -S]\n",
  "KEMBOED": "KEMBO, to set akimbo, also KIMBO [v]\n",
  "KEMBOING": "KEMBO, to set akimbo, also KIMBO [v]\n",
  "KEMBOS": "KEMBO, to set akimbo, also KIMBO [v]\n",
  "KEMBS": "KEMB, (dialect) to comb [v]\n",
  "KEMP": "to strive to win [v -ED, -ING, -S]\n",
  "KEMPED": "KEMP, to strive to win [v]\n",
  "KEMPER": "a champion [n -S]\n",
  "KEMPERS": "KEMPER, a champion [n]\n",
  "KEMPIER": "KEMPY, of hair, coarse, like kemp [adj]\n",
  "KEMPIEST": "KEMPY, of hair, coarse, like kemp [adj]\n",
  "KEMPING": "a striving for mastery [n -S]\n",
  "KEMPINGS": "KEMPING, a striving for mastery [n]\n",
  "KEMPLE": "(Scots) forty bundles of hay [n -S]\n",
  "KEMPLES": "KEMPLE, (Scots) forty bundles of hay [n]\n",
  "KEMPS": "KEMP, to strive to win [v]\n",
  "KEMPT": "combed, tidy [adj]\n",
  "KEMPY": "of hair, coarse, like kemp [adj KEMPIER, KEMPIEST]\n",
  "KEN": "to know [v KENNED, KENNING, KENS]\n",
  "KENAF": "(Persian) a fibre-yielding plant of East Indies, aka ambary or ambari [n -S]\n",
  "KENAFS": "KENAF, (Persian) a fibre-yielding plant of East Indies, aka ambary or ambari [n]\n",
  "KENCH": "a bin for salting fish [n -ES]\n",
  "KENCHES": "KENCH, a bin for salting fish [n]\n",
  "KENDO": "(Japanese) a martial art, stick fighting [n -S]\n",
  "KENDOIST": "one who practises kendo [n -S]\n",
  "KENDOISTS": "KENDOIST, one who practises kendo [n]\n",
  "KENDOS": "KENDO, (Japanese) a martial art, stick fighting [n]\n",
  "KENNED": "KEN, to know [v]\n",
  "KENNEL": "to put in a dog house [v KENNELLED or KENNELED, KENNELLING or KENNELING, KENNELS]\n",
  "KENNELED": "KENNEL, to put in a dog house [v]\n",
  "KENNELING": "KENNEL, to put in a dog house [v]\n",
  "KENNELLED": "KENNEL, to put in a dog house [v]\n",
  "KENNELLING": "KENNEL, to put in a dog house [v]\n",
  "KENNELMAN": "a male attendant who looks after dogs [n KENNELMEN]\n",
  "KENNELMEN": "KENNELMAN, a male attendant who looks after dogs [n]\n",
  "KENNELS": "KENNEL, to put in a dog house [v]\n",
  "KENNER": "one who kens, knows [n -S]\n",
  "KENNERS": "KENNER, one who kens, knows [n]\n",
  "KENNET": "a small hunting dog [n -S]\n",
  "KENNETS": "KENNET, a small hunting dog [n]\n",
  "KENNETT": "(Australian slang) to ruthlessly downsize an organisation, (after Jeff Kennett, premier of Victoria) [v -ED, -ING, -S]\n",
  "KENNETTED": "KENNETT, (Australian slang) to ruthlessly downsize an organisation, (after Jeff Kennett, premier of Victoria) [v]\n",
  "KENNETTING": "KENNETT, (Australian slang) to ruthlessly downsize an organisation, (after Jeff Kennett, premier of Victoria) [v]\n",
  "KENNETTS": "KENNETT, (Australian slang) to ruthlessly downsize an organisation, (after Jeff Kennett, premier of Victoria) [v]\n",
  "KENNING": "a metaphorical compound word or phrase [n -S]\n",
  "KENNINGS": "KENNING, a metaphorical compound word or phrase [n]\n",
  "KENO": "a gambling game, a variety of the game of lotto, played with numbered balls or knobs, also KEENO, KINO, QUINO [n -S]\n",
  "KENOGENESES": "KENOGENESIS, the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CAENOGENESIS, CENOGENESIS, KAINOGENESIS [n]\n",
  "KENOGENESIS": "the state where adaptations to the needs of the young stages develop early, and disappear in the adult stage, also CAENOGENESIS, CENOGENESIS, KAINOGENESIS [n KENOGENESES]\n",
  "KENOGENETIC": "related to kenogenesis [adj KENOGENETICALLY]\n",
  "KENOGENETICALLY": "KENOGENETIC, related to kenogenesis [adv]\n",
  "KENOPHOBIA": "fear of empty spaces [n -S]\n",
  "KENOPHOBIAS": "KENOPHOBIA, fear of empty spaces [n]\n",
  "KENOS": "KENO, a gambling game, a variety of the game of lotto, played with numbered balls or knobs, also KEENO, KINO, QUINO [n]\n",
  "KENOSES": "KENOSIS, (Greek) Christ's acceptance of his human nature [n]\n",
  "KENOSIS": "(Greek) Christ's acceptance of his human nature [n KENOSISES or KENOSES]\n",
  "KENOSISES": "KENOSIS, (Greek) Christ's acceptance of his human nature [n]\n",
  "KENOTIC": "relating to kenosis, the relinquishment of the form of God by Jesus in becoming man [adj]\n",
  "KENOTICIST": "a believer in kenosis, the relinquishment of the form of God by Jesus in becoming man [n -S]\n",
  "KENOTICISTS": "KENOTICIST, a believer in kenosis, the relinquishment of the form of God by Jesus in becoming man [n]\n",
  "KENOTICS": "the study of the doctrine of kenosis, the relinquishment of the form of God by Jesus in becoming man [n]\n",
  "KENOTRON": "a type of diode (valve) [n -S]\n",
  "KENOTRONS": "KENOTRON, a type of diode (valve) [n]\n",
  "KENS": "KEN, to know [v]\n",
  "KENSPECK": "(Scots) obvious, conspicuous, also KENSPECKLE [adj]\n",
  "KENSPECKLE": "(Scots) obvious, conspicuous, also KENSPECK [adj]\n",
  "KENT": "(Scots) to steer by a punting pole [v -ED, -ING, -S]\n",
  "KENTE": "brightly coloured woven cloth of Ghana, usually with some gold thread [n -S]\n",
  "KENTED": "KENT, (Scots) to steer by a punting pole [v]\n",
  "KENTES": "KENTE, brightly coloured woven cloth of Ghana, usually with some gold thread [n]\n",
  "KENTIA": "the Howea feather palm [n -S]\n",
  "KENTIAS": "KENTIA, the Howea feather palm [n]\n",
  "KENTING": "KENT, (Scots) to steer by a punting pole [v]\n",
  "KENTLEDGE": "pig-iron used as ballast in a ship's hold, also KINTLEDGE [n -S]\n",
  "KENTLEDGES": "KENTLEDGE, pig-iron used as ballast in a ship's hold, also KINTLEDGE [n]\n",
  "KENTS": "KENT, (Scots) to steer by a punting pole [v]\n",
  "KEP": "(Scots) to catch [v KEPPIT or KEPPED, KEPPEN or KIPPEN, KEPPING, KEPS]\n",
  "KEPHALIC": "a headache remedy, also CEPHALIC [n -S]\n",
  "KEPHALICS": "KEPHALIC, a headache remedy, also CEPHALIC [n]\n",
  "KEPHALIN": "a compound of phosphorus found in the brain and nervous tissue, also CEPHALIN [n -S]\n",
  "KEPHALINS": "KEPHALIN, a compound of phosphorus found in the brain and nervous tissue, also CEPHALIN [n]\n",
  "KEPHIR": "a drink made from fermented cow's milk, also KEFIR [n -S]\n",
  "KEPHIRS": "KEPHIR, a drink made from fermented cow's milk, also KEFIR [n]\n",
  "KEPI": "(French) a legionnaire's cap [n -S]\n",
  "KEPIS": "KEPI, (French) a legionnaire's cap [n]\n",
  "KEPPED": "KEP, (Scots) to catch [v]\n",
  "KEPPEN": "KEP, (Scots) to catch [v]\n",
  "KEPPING": "KEP, (Scots) to catch [v]\n",
  "KEPPIT": "KEP, (Scots) to catch [v]\n",
  "KEPS": "KEP, (Scots) to catch [v]\n",
  "KEPT": "KEEP, to retain in one's possession [v]\n",
  "KERAMIC": "an item made of baked clay, also CERAMIC [n -S]\n",
  "KERAMICS": "KERAMIC, an item made of baked clay, also CERAMIC [n]\n",
  "KERATECTOMIES": "KERATECTOMY, surgical incision of the cornea [n]\n",
  "KERATECTOMY": "surgical incision of the cornea [n KERATECTOMIES]\n",
  "KERATIN": "a fibrous protein [n -S]\n",
  "KERATINISATION": "the process of making keratinous, also KERATINIZATION [n -S]\n",
  "KERATINISATIONS": "KERATINISATION, the process of making keratinous, also KERATINIZATION [n]\n",
  "KERATINISE": "to make keratinous, also KERATINIZE [v KERATINISED, KERATINISING, KERATINISES]\n",
  "KERATINISED": "KERATINISE, to make keratinous, also KERATINIZE [v]\n",
  "KERATINISES": "KERATINISE, to make keratinous, also KERATINIZE [v]\n",
  "KERATINISING": "KERATINISE, to make keratinous, also KERATINIZE [v]\n",
  "KERATINIZATION": "the process of making keratinous, also KERATINISATION [n -S]\n",
  "KERATINIZATIONS": "KERATINIZATION, the process of making keratinous, also KERATINISATION [n]\n",
  "KERATINIZE": "to make keratinous, also KERATINISE [v KERATINIZED, KERATINIZING, KERATINIZES]\n",
  "KERATINIZED": "KERATINIZE, to make keratinous, also KERATINISE [v]\n",
  "KERATINIZES": "KERATINIZE, to make keratinous, also KERATINISE [v]\n",
  "KERATINIZING": "KERATINIZE, to make keratinous, also KERATINISE [v]\n",
  "KERATINOPHILIC": "of fungi, exhibiting affinity for keratin (as in hair, skin, feathers, or horns) [adj]\n",
  "KERATINOUS": "like keratin, horny [adj]\n",
  "KERATINS": "KERATIN, a fibrous protein [n]\n",
  "KERATITIDES": "KERATITIS, inflammation of the cornea, also CERATITIS [n]\n",
  "KERATITIS": "inflammation of the cornea, also CERATITIS [n KERATITISES or KERATITIDES]\n",
  "KERATITISES": "KERATITIS, inflammation of the cornea, also CERATITIS [n]\n",
  "KERATOGENOUS": "producing horn or keratin [adj]\n",
  "KERATOID": "resembling horn or keratin, also CERATOID [adj]\n",
  "KERATOMA": "a skin disease [n KERATOMAS or KERATOMATA]\n",
  "KERATOMAS": "KERATOMA, a skin disease [n]\n",
  "KERATOMATA": "KERATOMA, a skin disease [n]\n",
  "KERATOMETER": "an instrument for measuring curvature of the cornea [n -S]\n",
  "KERATOMETERS": "KERATOMETER, an instrument for measuring curvature of the cornea [n]\n",
  "KERATOPHYRE": "a fine-grained soda trachyte [n -S]\n",
  "KERATOPHYRES": "KERATOPHYRE, a fine-grained soda trachyte [n]\n",
  "KERATOPLASTIC": "relating to keratoplasty, plastic surgery on the cornea [adj]\n",
  "KERATOPLASTIES": "KERATOPLASTY, plastic surgery on the cornea [n]\n",
  "KERATOPLASTY": "plastic surgery on the cornea [n KERATOPLASTIES]\n",
  "KERATOSE": "of certain sponges, having a horny skeleton [adj]\n",
  "KERATOSES": "KERATOSIS, excessive growth of horny tissue of skin [n]\n",
  "KERATOSIC": "relating to keratosis , excessive growth of horny tissue of skin, also KERATOTIC [adj]\n",
  "KERATOSIS": "excessive growth of horny tissue of skin [n KERATOSES]\n",
  "KERATOTIC": "relating to keratosis, excessive growth of horny tissue of skin, also KERATOSIC [adj]\n",
  "KERATOTOMIES": "KERATOTOMY, surgery of the cornea [n]\n",
  "KERATOTOMY": "surgery of the cornea [n KERATOTOMIES]\n",
  "KERAUNOGRAPH": "an instrument for detecting distant thunderstorms, also CERAUNOGRAPH [n -S]\n",
  "KERAUNOGRAPHS": "KERAUNOGRAPH, an instrument for detecting distant thunderstorms, also CERAUNOGRAPH [n]\n",
  "KERB": "to provide with a pavement edge [v -ED, -ING, -S]\n",
  "KERBAYA": "(Malay) a blouse worn by Malay women [n -S]\n",
  "KERBAYAS": "KERBAYA, (Malay) a blouse worn by Malay women [n]\n",
  "KERBED": "KERB, to provide with a pavement edge [v]\n",
  "KERBING": "a concrete border along the street, also CURBING [n -S]\n",
  "KERBINGS": "KERBING, a concrete border along the street, also CURBING [n]\n",
  "KERBLOOEY": "the sound of an explosion [n -S]\n",
  "KERBLOOEYS": "KERBLOOEY, the sound of an explosion [n]\n",
  "KERBS": "KERB, to provide with a pavement edge [v]\n",
  "KERBSIDE": "the side of a pavement bordered by a kerb, also CURBSIDE [n -S]\n",
  "KERBSIDES": "KERBSIDE, the side of a pavement bordered by a kerb, also CURBSIDE [n]\n",
  "KERBSTONE": "a stone placed edgeways as an edging to a path or pavement, also CURBSTONE [n -S]\n",
  "KERBSTONES": "KERBSTONE, a stone placed edgeways as an edging to a path or pavement, also CURBSTONE [n]\n",
  "KERCHIEF": "a cloth or scarf used to cover the head, esp. by a woman [n KERCHIEFS or KERCHIEVES] / to wear a kerchief [v -ED, -ING, -S]\n",
  "KERCHIEFED": "KERCHIEF, to wear a kerchief [v]\n",
  "KERCHIEFING": "KERCHIEF, to wear a kerchief [v]\n",
  "KERCHIEFS": "KERCHIEF, a cloth or scarf used to cover the head, esp. by a woman [n]\n",
  "KERCHIEVES": "KERCHIEF, a cloth or scarf used to cover the head, esp. by a woman [n]\n",
  "KERCHOO": "an interjection expressing a sneeze [interj]\n",
  "KEREL": "(South African) a chap or fellow [n -S]\n",
  "KERELS": "KEREL, (South African) a chap or fellow [n]\n",
  "KERERU": "(Maori) a kind of New Zealand pigeon [n -S]\n",
  "KERERUS": "KERERU, (Maori) a kind of New Zealand pigeon [n]\n",
  "KERF": "an incision made by a cutting tool, also CURF [n -S] / to make an incision with a cutting tool [v -ED, -ING, -S]\n",
  "KERFED": "KERF, to make an incision with a cutting tool [v]\n",
  "KERFING": "KERF, to make an incision with a cutting tool [v]\n",
  "KERFLOOEY": "into a state of destruction or malfunction [adj]\n",
  "KERFS": "KERF, to make an incision with a cutting tool [v]\n",
  "KERFUFFLE": "(Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KURFUFFLE [v KERFUFFLED, KERFUFFLING, KERFUFFLES]\n",
  "KERFUFFLED": "KERFUFFLE, (Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KURFUFFLE [v]\n",
  "KERFUFFLES": "KERFUFFLE [n]\n",
  "KERFUFFLING": "KERFUFFLE, (Scots) to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KURFUFFLE [v]\n",
  "KERKIER": "KERKY, stupid [adj]\n",
  "KERKIEST": "KERKY, stupid [adj]\n",
  "KERKY": "stupid [adj KERKIER, KERKIEST]\n",
  "KERMA": "a term in physics relating to kinetic energy [n -S]\n",
  "KERMAS": "KERMA, a term in physics relating to kinetic energy [n]\n",
  "KERMES": "a red cochineal-like dye made from dried bodies of certain female insects of Mediterranean; the evergreen oak on which these insects feed [n KERMESES]\n",
  "KERMESES": "KERMES, a red cochineal-like dye made from dried bodies of certain female insects of Mediterranean; the evergreen oak on which these insects feed [n]\n",
  "KERMESITE": "a cherry-red mineral, antimony oxysulphide [n -S]\n",
  "KERMESITES": "KERMESITE, a cherry-red mineral, antimony oxysulphide [n]\n",
  "KERMESS": "(Dutch) in Europe, particularly in Belgium and Holland, an outdoor festival and fair; in the United States, generally an indoor entertainment and fair combined, also KERMIS, KIRMESS [n -ES]\n",
  "KERMESSE": "(Dutch) a cycle race held in an urban area [n -S]\n",
  "KERMESSES": "KERMESSE, (Dutch) a cycle race held in an urban area [n]\n",
  "KERMIS": "(Dutch) in Europe, particularly in Belgium and Holland, an outdoor festival and fair; in the United States, generally an indoor entertainment and fair combined, also KERMESS, KIRMESS [n -ES]\n",
  "KERMISES": "KERMIS, (Dutch) in Europe, particularly in Belgium and Holland, an outdoor festival and fair; in the United States, generally an indoor entertainment and fair combined, also KERMESS, KIRMESS [n]\n",
  "KERMODE": "a type of black bear [n -S]\n",
  "KERMODES": "KERMODE, a type of black bear [n]\n",
  "KERN": "to be formed with a projecting typeface [v -ED, -ING, -S]\n",
  "KERNE": "a medieval foot soldier [n -S]\n",
  "KERNED": "KERN, to be formed with a projecting typeface [v]\n",
  "KERNEL": "to envelop like the inner part of a nut [v KERNELLED or KERNELED, KERNELLING or KERNELING, KERNELS]\n",
  "KERNELED": "KERNEL, to envelop like the inner part of a nut [v]\n",
  "KERNELING": "KERNEL, to envelop like the inner part of a nut [v]\n",
  "KERNELLED": "KERNEL, to envelop like the inner part of a nut [v]\n",
  "KERNELLIER": "KERNELLY, full of kernels; resembling a kernel [adj]\n",
  "KERNELLIEST": "KERNELLY, full of kernels; resembling a kernel [adj]\n",
  "KERNELLING": "KERNEL, to envelop like the inner part of a nut [v]\n",
  "KERNELLY": "full of kernels; resembling a kernel [adj KERNELLIER, KERNELLIEST]\n",
  "KERNELS": "KERNEL, to envelop like the inner part of a nut [v]\n",
  "KERNES": "KERNE, a medieval foot soldier [n]\n",
  "KERNICTERUS": "a condition of acute neural dysfunction linked with high levels of bilirubin in the blood [n -ES]\n",
  "KERNICTERUSES": "KERNICTERUS, a condition of acute neural dysfunction linked with high levels of bilirubin in the blood [n]\n",
  "KERNING": "adjustment of adjoining typeset letters [n -S]\n",
  "KERNINGS": "KERNING, adjustment of adjoining typeset letters [n]\n",
  "KERNISH": "relating to a kern, an Irish foot-soldier [adj]\n",
  "KERNITE": "a hydrated oxide of sodium and boron [n -S]\n",
  "KERNITES": "KERNITE, a hydrated oxide of sodium and boron [n]\n",
  "KERNMANTEL": "denoting a type of mountaineering rope [adj]\n",
  "KERNS": "KERN, to be formed with a projecting typeface [v]\n",
  "KERO": "(Australian slang) kerosene [n -S]\n",
  "KEROGEN": "a kind of bitumen found in oil shale [n -S]\n",
  "KEROGENS": "KEROGEN, a kind of bitumen found in oil shale [n]\n",
  "KEROS": "KERO, (Australian slang) kerosene [n]\n",
  "KEROSENE": "a fuel oil, also KERO, KEROSINE [n -S]\n",
  "KEROSENES": "KEROSENE, a fuel oil, also KERO, KEROSINE [n]\n",
  "KEROSINE": "a fuel oil, also KEROSENE, KERO [n -S]\n",
  "KEROSINES": "KEROSINE, a fuel oil, also KEROSENE, KERO [n]\n",
  "KERPLUNK": "to drop with a heavy sound [v -ED, -ING, -S]\n",
  "KERPLUNKED": "KERPLUNK, to drop with a heavy sound [v]\n",
  "KERPLUNKING": "KERPLUNK, to drop with a heavy sound [v]\n",
  "KERPLUNKS": "KERPLUNK, to drop with a heavy sound [v]\n",
  "KERRIA": "a flowering shrub [n -S]\n",
  "KERRIAS": "KERRIA, a flowering shrub [n]\n",
  "KERRIES": "KERRY, one of an Irish breed of cattle [n]\n",
  "KERRY": "one of an Irish breed of cattle [n KERRIES]\n",
  "KERSANTITE": "a dyke-rock of black mica and plagioclase [n -S]\n",
  "KERSANTITES": "KERSANTITE, a dyke-rock of black mica and plagioclase [n]\n",
  "KERSEY": "a kind of coarse woollen cloth [n -S]\n",
  "KERSEYMERE": "a twilled cloth of the finest wool, also CASHMERE, CASIMERE, CASIMIRE, CASSIMERE, KASHMIR [n -S]\n",
  "KERSEYMERES": "KERSEYMERE, a twilled cloth of the finest wool, also CASHMERE, CASIMERE, CASIMIRE, CASSIMERE, KASHMIR [n]\n",
  "KERSEYS": "KERSEY, a kind of coarse woollen cloth [n]\n",
  "KERVE": "(Spenser) to carve [v KERVED, KERVING, KERVES]\n",
  "KERVED": "KERVE, (Spenser) to carve [v]\n",
  "KERVES": "KERVE, (Spenser) to carve [v]\n",
  "KERVING": "KERVE, (Spenser) to carve [v]\n",
  "KERYGMA": "(Greek) the apostolic proclamation of salvation through Jesus Christ [n KERYGMAS or KERYGMATA]\n",
  "KERYGMAS": "KERYGMA, (Greek) the apostolic proclamation of salvation through Jesus Christ [n]\n",
  "KERYGMATA": "KERYGMA, (Greek) the apostolic proclamation of salvation through Jesus Christ [n]\n",
  "KERYGMATIC": "of or relating to preaching the Gospel [adj]\n",
  "KESAR": "(obsolete) an emperor, also KAISER, KEASAR [n -S]\n",
  "KESARS": "KESAR, (obsolete) an emperor, also KAISER, KEASAR [n]\n",
  "KESH": "(Punjabi) the uncut hair and beard of a male Sikh [n -ES]\n",
  "KESHES": "KESH, (Punjabi) the uncut hair and beard of a male Sikh [n]\n",
  "KEST": "(obsolete) to cast [v KEST, KESTING, KESTS]\n",
  "KESTING": "KEST, (obsolete) to cast [v]\n",
  "KESTREL": "a kind of small falcon [n -S]\n",
  "KESTRELS": "KESTREL, a kind of small falcon [n]\n",
  "KESTS": "KEST, (obsolete) to cast [v]\n",
  "KET": "(Scots) carrion, rotting flesh [n -S]\n",
  "KETA": "(Russian) a Pacific salmon [n -S]\n",
  "KETAINE": "(Canadian) in poor taste, unfashionable [adj]\n",
  "KETAMINE": "an anaesthetic drug [n -S]\n",
  "KETAMINES": "KETAMINE, an anaesthetic drug [n]\n",
  "KETAS": "KETA, (Russian) a Pacific salmon [n]\n",
  "KETCH": "a small two-masted sailing vessel [n -ES] / (obsolete) to catch [v CAUGHT, KETCHING, KETCHES]\n",
  "KETCHES": "KETCH, (obsolete) to catch [v]\n",
  "KETCHING": "KETCH, (obsolete) to catch [v]\n",
  "KETCHUP": "(Malay) a spicy tomato sauce, also CATCHUP, CATSUP [n -S]\n",
  "KETCHUPIER": "KETCHUPY, of or like ketchup [adj]\n",
  "KETCHUPIEST": "KETCHUPY, of or like ketchup [adj]\n",
  "KETCHUPS": "KETCHUP, (Malay) a spicy tomato sauce, also CATCHUP, CATSUP [n]\n",
  "KETCHUPY": "of or like ketchup [adj KETCHUPIER, KETCHUPIEST]\n",
  "KETE": "(Maori) a basket woven from flax [n -S]\n",
  "KETENE": "a toxic gas, also ETHONONE [n -S]\n",
  "KETENES": "KETENE, a toxic gas, also ETHONONE [n]\n",
  "KETES": "KETE, (Maori) a basket woven from flax [n]\n",
  "KETMIA": "as in bladder ketmia, a plant with yellow flowers and a bladderlike calyx [n -S]\n",
  "KETMIAS": "KETMIA, as in bladder ketmia, a plant with yellow flowers and a bladderlike calyx [n]\n",
  "KETO": "pertaining to ketone, a chemical compound of carbon, obtained by distilling salts of organic acids [adj]\n",
  "KETOACIDOSES": "KETOACIDOSIS, a condition in which excessive levels of ketone bodies and glucose cause the blood to become acidic [n]\n",
  "KETOACIDOSIS": "a condition in which excessive levels of ketone bodies and glucose cause the blood to become acidic [n KETOACIDOSES]\n",
  "KETOGENESES": "KETOGENESIS, the production of ketone, esp. in diabetes [n]\n",
  "KETOGENESIS": "the production of ketone, esp. in diabetes [n KETOGENESES]\n",
  "KETOGENIC": "relating to ketogenesis, the production of ketones in diabetes [adj]\n",
  "KETOL": "one of a series of complex nitrogenous substances, represented by methyl ketol and related to indol [n -S]\n",
  "KETOLS": "KETOL, one of a series of complex nitrogenous substances, represented by methyl ketol and related to indol [n]\n",
  "KETONAEMIA": "an excess of ketone bodies in the blood, also KETONEMIA [n -S]\n",
  "KETONAEMIAS": "KETONAEMIA, an excess of ketone bodies in the blood, also KETONEMIA [n]\n",
  "KETONE": "a chemical compound of carbon, obtained by distilling salts of organic acids [n -S]\n",
  "KETONEMIA": "an excess of ketone bodies in the blood, also KETONAEMIA [n -S]\n",
  "KETONEMIAS": "KETONEMIA, an excess of ketone bodies in the blood, also KETONAEMIA [n]\n",
  "KETONES": "KETONE, a chemical compound of carbon, obtained by distilling salts of organic acids [n]\n",
  "KETONIC": "pertaining to, or derived from, a ketone; as, a ketonic acid [adj]\n",
  "KETONURIA": "an excess of ketones in the urine [n -S]\n",
  "KETONURIAS": "KETONURIA, an excess of ketones in the urine [n]\n",
  "KETOSE": "any of a class of monosaccharide sugars which contain a ketone group [n -S]\n",
  "KETOSES": "KETOSE, any of a class of monosaccharide sugars which contain a ketone group [n]\n",
  "KETOSIS": "the presence of excess of ketone in body [n KETOSES]\n",
  "KETOSTEROID": "a steroid, such as cortisone or estrone, containing a ketone group [n -S]\n",
  "KETOSTEROIDS": "KETOSTEROID, a steroid, such as cortisone or estrone, containing a ketone group [n]\n",
  "KETOTIC": "relating to ketosis, the presence of excess of ketone in the body [adj]\n",
  "KETOXIME": "an oxime product of a ketone reacting with hydroxylamine [n -S]\n",
  "KETOXIMES": "KETOXIME, an oxime product of a ketone reacting with hydroxylamine [n]\n",
  "KETS": "KET, (Scots) carrion, rotting flesh [n]\n",
  "KETTLE": "a device for boiling water [n -S] / to confine in an enclosed space [v KETTLED, KETTLING, KETTLES]\n",
  "KETTLEBELL": "an exercising weight consisting of a heavy ball with a handle [n -S]\n",
  "KETTLEBELLS": "KETTLEBELL, an exercising weight consisting of a heavy ball with a handle [n]\n",
  "KETTLED": "KETTLE, to confine in an enclosed space [v]\n",
  "KETTLEDRUM": "a drum made of thin copper in the form of a hemispherical kettle, with parchment stretched over the mouth of it [n -S]\n",
  "KETTLEDRUMMER": "one who plays the kettledrums [n -S]\n",
  "KETTLEDRUMMERS": "KETTLEDRUMMER, one who plays the kettledrums [n]\n",
  "KETTLEDRUMS": "KETTLEDRUM, a drum made of thin copper in the form of a hemispherical kettle, with parchment stretched over the mouth of it [n]\n",
  "KETTLEFUL": "the contents of a kettle [n -S]\n",
  "KETTLEFULS": "KETTLEFUL, the contents of a kettle [n]\n",
  "KETTLES": "KETTLE, to confine in an enclosed space [v]\n",
  "KETTLESTITCH": "a stitch made at head and tail of section of book to connect sections [n -ES]\n",
  "KETTLESTITCHES": "KETTLESTITCH, a stitch made at head and tail of section of book to connect sections [n]\n",
  "KETTLING": "KETTLE, to confine in an enclosed space [v]\n",
  "KETUBAH": "(Hebrew) a contract that states the obligations in Jewish marriages [n KETUBAHS or KETUBOT or KETUBOTH]\n",
  "KETUBAHS": "KETUBAH, (Hebrew) a contract that states the obligations in Jewish marriages [n]\n",
  "KETUBOT": "KETUBAH, (Hebrew) a contract that states the obligations in Jewish marriages [n]\n",
  "KETUBOTH": "KETUBAH, (Hebrew) a contract that states the obligations in Jewish marriages [n]\n",
  "KEVEL": "(Scots) a piece of wood used in casting lots, also CAVEL, KEVIL [n -S]\n",
  "KEVELS": "KEVEL, (Scots) a piece of wood used in casting lots, also CAVEL, KEVIL [n]\n",
  "KEVIL": "(Scots) a piece of wood used in casting lots, also CAVEL, KEVEL [n -S]\n",
  "KEVILS": "KEVIL, (Scots) a piece of wood used in casting lots, also CAVEL, KEVEL [n]\n",
  "KEWL": "(colloquial) cool [adj KEWLER, KEWLEST]\n",
  "KEWLER": "KEWL, (colloquial) cool [adj]\n",
  "KEWLEST": "KEWL, (colloquial) cool [adj]\n",
  "KEWPIE": "(tradename) as in kewpie (doll), a brightly coloured doll [n -S]\n",
  "KEWPIES": "KEWPIE, (tradename) as in kewpie (doll), a brightly coloured doll [n]\n",
  "KEX": "the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKS, KECKSY, KEKSYE [n -ES]\n",
  "KEXES": "KEX, the hollow stalk of an umbelliferous plant, such as the cow parsnip or the hemlock, also KECKS, KECKSY, KEKSYE [n]\n",
  "KEY": "crucial [adj KEYER, KEYEST] / to enter (data) into a computer [v -ED, -ING, -S]\n",
  "KEYBOARD": "the manually operated range of keys or levers in a musical instrument, computer, etc. [n -S] / to enter data on a keyboard [v -ED, -ING, -S]\n",
  "KEYBOARDED": "KEYBOARD, to enter data on a keyboard [v]\n",
  "KEYBOARDER": "one who plays the keyboard [n -S]\n",
  "KEYBOARDERS": "KEYBOARDER, one who plays the keyboard [n]\n",
  "KEYBOARDING": "the process of entering data on a keyboard [n -S]\n",
  "KEYBOARDINGS": "KEYBOARDING, the process of entering data on a keyboard [n]\n",
  "KEYBOARDIST": "one who plays the keyboard [n -S]\n",
  "KEYBOARDISTS": "KEYBOARDIST, one who plays the keyboard [n]\n",
  "KEYBOARDS": "KEYBOARD, to enter data on a keyboard [v]\n",
  "KEYBUGLE": "a bugle with keys [n -S]\n",
  "KEYBUGLES": "KEYBUGLE, a bugle with keys [n]\n",
  "KEYBUTTON": "a key on a typewriter [n -S]\n",
  "KEYBUTTONS": "KEYBUTTON, a key on a typewriter [n]\n",
  "KEYCARD": "a coded card for operating a device [n -S]\n",
  "KEYCARDS": "KEYCARD, a coded card for operating a device [n]\n",
  "KEYED": "KEY, to enter (data) into a computer [v]\n",
  "KEYER": "a device that turns a circuit on and off [n -S]\n",
  "KEYERS": "KEYER, a device that turns a circuit on and off [n]\n",
  "KEYEST": "KEY, crucial [adj]\n",
  "KEYFRAME": "the frozen image in an animation sequence [n -S]\n",
  "KEYFRAMES": "KEYFRAME, the frozen image in an animation sequence [n]\n",
  "KEYHOLE": "a hole for a key [n -S]\n",
  "KEYHOLES": "KEYHOLE, a hole for a key [n]\n",
  "KEYING": "providing a key for (cryptography) [n -S]\n",
  "KEYINGS": "KEYING, providing a key for (cryptography) [n]\n",
  "KEYLESS": "without a key [adj]\n",
  "KEYLINE": "a diagram representing how an illustration will appear [n -S]\n",
  "KEYLINES": "KEYLINE, a diagram representing how an illustration will appear [n]\n",
  "KEYLOGGER": "a device or software application for covertly recording keystrokes on a remote computer [n -S]\n",
  "KEYLOGGERS": "KEYLOGGER, a device or software application for covertly recording keystrokes on a remote computer [n]\n",
  "KEYLOGGING": "the logging of keystrokes on a computer [n -S]\n",
  "KEYLOGGINGS": "KEYLOGGING, the logging of keystrokes on a computer [n]\n",
  "KEYNOTE": "to deliver the main speech at a function [v KEYNOTED, KEYNOTING, KEYNOTES]\n",
  "KEYNOTED": "KEYNOTE, to deliver the main speech at a function [v]\n",
  "KEYNOTER": "one who delivers a keynote speech [n -S]\n",
  "KEYNOTERS": "KEYNOTER, one who delivers a keynote speech [n]\n",
  "KEYNOTES": "KEYNOTE, to deliver the main speech at a function [v]\n",
  "KEYNOTING": "KEYNOTE, to deliver the main speech at a function [v]\n",
  "KEYPAD": "a small device with push-button controls, e.g. a TV remote control unit [n -S]\n",
  "KEYPADS": "KEYPAD, a small device with push-button controls, e.g. a TV remote control unit [n]\n",
  "KEYPAL": "a person with whom one corresponds by email [n -S]\n",
  "KEYPALS": "KEYPAL, a person with whom one corresponds by email [n]\n",
  "KEYPRESS": "a single depression of a key on a keyboard [n -ES]\n",
  "KEYPRESSES": "KEYPRESS, a single depression of a key on a keyboard [n]\n",
  "KEYPUNCH": "to transfer data on to punched cards [v -ED, -ING, -ES]\n",
  "KEYPUNCHED": "KEYPUNCH, to transfer data on to punched cards [v]\n",
  "KEYPUNCHER": "one who keypunches [n -S]\n",
  "KEYPUNCHERS": "KEYPUNCHER, one who keypunches [n]\n",
  "KEYPUNCHES": "KEYPUNCH, to transfer data on to punched cards [v]\n",
  "KEYPUNCHING": "KEYPUNCH, to transfer data on to punched cards [v]\n",
  "KEYRING": "a type of computer drive [n -S]\n",
  "KEYRINGS": "KEYRING, a type of computer drive [n]\n",
  "KEYS": "KEY, to enter (data) into a computer [v]\n",
  "KEYSET": "a system of finger levers [n -S]\n",
  "KEYSETS": "KEYSET, a system of finger levers [n]\n",
  "KEYSTER": "(slang) backside, bottom, also KEESTER, KEISTER, KIESTER [n -S]\n",
  "KEYSTERS": "KEYSTER, (slang) backside, bottom, also KEESTER, KEISTER, KIESTER [n]\n",
  "KEYSTONE": "to produce a distortion of a television picture in which a rectangular pattern is transformed into a trapezoidal pattern [v KEYSTONED, KEYSTONING, KEYSTONES]\n",
  "KEYSTONED": "KEYSTONE, to produce a distortion of a television picture in which a rectangular pattern is transformed into a trapezoidal pattern [v]\n",
  "KEYSTONES": "KEYSTONE, to produce a distortion of a television picture in which a rectangular pattern is transformed into a trapezoidal pattern [v]\n",
  "KEYSTONING": "KEYSTONE, to produce a distortion of a television picture in which a rectangular pattern is transformed into a trapezoidal pattern [v]\n",
  "KEYSTROKE": "a single operation of a key on a typewriter or other machine using keys [n -S] / to type on a keyboard [v KEYSTROKED, KEYSTROKING, KEYSTROKES]\n",
  "KEYSTROKED": "KEYSTROKE, to type on a keyboard [v]\n",
  "KEYSTROKES": "KEYSTROKE, to type on a keyboard [v]\n",
  "KEYSTROKING": "typing on a keyboard [n -S]\n",
  "KEYSTROKINGS": "KEYSTROKING, typing on a keyboard [n]\n",
  "KEYWAY": "a groove cut in a shaft or key to accommodate which interlocks with another component [n -S]\n",
  "KEYWAYS": "KEYWAY, a groove cut in a shaft or key to accommodate which interlocks with another component [n]\n",
  "KEYWORD": "a significant word in a text [n -S]\n",
  "KEYWORDS": "KEYWORD, a significant word in a text [n]\n",
  "KEYWORKER": "a worker such as a teacher or health worker [n -S]\n",
  "KEYWORKERS": "KEYWORKER, a worker such as a teacher or health worker [n]\n",
  "KGOTLA": "(Bantu) an assembly of tribal elders in Botswana, also LEKGOTLA [n -S]\n",
  "KGOTLAS": "KGOTLA, (Bantu) an assembly of tribal elders in Botswana, also LEKGOTLA [n]\n",
  "KHADDAR": "(Hindi) a homespun cotton cloth, also KHADI [n -S]\n",
  "KHADDARS": "KHADDAR, (Hindi) a homespun cotton cloth, also KHADI [n]\n",
  "KHADI": "(Hindi) a homespun cotton cloth, also KHADDAR [n -S]\n",
  "KHADIS": "KHADI, (Hindi) a homespun cotton cloth, also KHADDAR [n]\n",
  "KHAF": "(Hebrew) the eleventh letter of the Hebrew alphabet, also CAPH, KAF, KAPH, KHAPH [n -S]\n",
  "KHAFS": "KHAF, (Hebrew) the eleventh letter of the Hebrew alphabet, also CAPH, KAF, KAPH, KHAPH [n]\n",
  "KHAKI": "(Urdu) a dull brownish colour [n -S]\n",
  "KHAKILIKE": "like khaki [adj]\n",
  "KHAKIS": "KHAKI, (Urdu) a dull brownish colour [n]\n",
  "KHALAT": "(Hindi) an Indian robe of honour, also KILLUT, KELLAUT, KHILAT [n -S]\n",
  "KHALATS": "KHALAT, (Hindi) an Indian robe of honour, also KILLUT, KELLAUT, KHILAT [n]\n",
  "KHALIF": "(Arabic) an Eastern ruler, also CALIF, CALIPH, KALIF, KALIPH [n -S]\n",
  "KHALIFA": "(Arabic) a caliph; a Senussi leader; the Mahdi's successor, also KHALIFAH [n -S]\n",
  "KHALIFAH": "(Arabic) a caliph; a Senussi leader; the Mahdi's successor, also KHALIFA [n -S]\n",
  "KHALIFAHS": "KHALIFAH, (Arabic) a caliph; a Senussi leader; the Mahdi's successor, also KHALIFA [n]\n",
  "KHALIFAS": "KHALIFA, (Arabic) a caliph; a Senussi leader; the Mahdi's successor, also KHALIFAH [n]\n",
  "KHALIFAT": "(Arabic) the office of khalif, also CALIFATE, CALIPHATE, KALIPHATE, KHALIFATE, KHILAFAT [n -S]\n",
  "KHALIFATE": "(Arabic) the office of khalif, also CALIFATE, CALIPHATE, KALIPHATE, KHALIFAT, KHILAFAT [n -S]\n",
  "KHALIFATES": "KHALIFATE, (Arabic) the office of khalif, also CALIFATE, CALIPHATE, KALIPHATE, KHALIFAT, KHILAFAT [n]\n",
  "KHALIFATS": "KHALIFAT, (Arabic) the office of khalif, also CALIFATE, CALIPHATE, KALIPHATE, KHALIFATE, KHILAFAT [n]\n",
  "KHALIFS": "KHALIF, (Arabic) an Eastern ruler, also CALIF, CALIPH, KALIF, KALIPH [n]\n",
  "KHAMSEEN": "(Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSEEN, KAMSIN, KHAMSIN [n -S]\n",
  "KHAMSEENS": "KHAMSEEN, (Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSEEN, KAMSIN, KHAMSIN [n]\n",
  "KHAMSIN": "(Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSEEN, KAMSIN, KHAMSEEN [n -S]\n",
  "KHAMSINS": "KHAMSIN, (Arabic) the sirocco in Egypt, a hot southerly wind that usually blows from about March to May, also KAMSEEN, KAMSIN, KHAMSEEN [n]\n",
  "KHAN": "(Turkish) an Asian prince or chief; a governor, also CHAGAN, CHAM [n -S]\n",
  "KHANATE": "the domain of a khan [n -S]\n",
  "KHANATES": "KHANATE, the domain of a khan [n]\n",
  "KHANDA": "(Punjabi) a double-edged Sikh sword [n -S]\n",
  "KHANDAS": "KHANDA, (Punjabi) a double-edged Sikh sword [n]\n",
  "KHANGA": "(Swahili) a piece of cotton cloth wound round the body as a dress, also KANGA [n -S]\n",
  "KHANGAS": "KHANGA, (Swahili) a piece of cotton cloth wound round the body as a dress, also KANGA [n]\n",
  "KHANJAR": "(Persian) a Persian dagger, also HANDJAR, HANJAR [n -S]\n",
  "KHANJARS": "KHANJAR, (Persian) a Persian dagger, also HANDJAR, HANJAR [n]\n",
  "KHANS": "KHAN, (Turkish) an Asian prince or chief; a governor, also CHAGAN, CHAM [n]\n",
  "KHANSAMA": "(Hindi) a house-steward or butler in India, also KHANSAMAH [n -S]\n",
  "KHANSAMAH": "(Hindi) a house-steward or butler in India, also KHANSAMA [n -S]\n",
  "KHANSAMAHS": "KHANSAMAH, (Hindi) a house-steward or butler in India, also KHANSAMA [n]\n",
  "KHANSAMAS": "KHANSAMA, (Hindi) a house-steward or butler in India, also KHANSAMAH [n]\n",
  "KHANUM": "(Turkish) a lady's title of rank in the Middle East [n -S]\n",
  "KHANUMS": "KHANUM, (Turkish) a lady's title of rank in the Middle East [n]\n",
  "KHAPH": "(Hebrew) the eleventh letter of the Hebrew alphabet, also CAPH, KAF, KAPH, KHAF [n -S]\n",
  "KHAPHS": "KHAPH, (Hebrew) the eleventh letter of the Hebrew alphabet, also CAPH, KAF, KAPH, KHAF [n]\n",
  "KHARIF": "(Urdu) in India, a crop sown before the monsoon to ripen in autumn [n -S]\n",
  "KHARIFS": "KHARIF, (Urdu) in India, a crop sown before the monsoon to ripen in autumn [n]\n",
  "KHAT": "(Arabic) a shrub of East Africa, Arabia, etc., or its leaves, chewed or taken as tea for their stimulant effect, also KAT, QAT [n -S]\n",
  "KHATS": "KHAT, (Arabic) a shrub of East Africa, Arabia, etc., or its leaves, chewed or taken as tea for their stimulant effect, also KAT, QAT [n]\n",
  "KHAYA": "(Wolof) a lofty West African tree related to the mahogany [n -S]\n",
  "KHAYAL": "(Urdu) a kind of classical Indian vocal music [n -S]\n",
  "KHAYALS": "KHAYAL, (Urdu) a kind of classical Indian vocal music [n]\n",
  "KHAYAS": "KHAYA, (Wolof) a lofty West African tree related to the mahogany [n]\n",
  "KHAZEN": "(Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZAN, HAZZAN [n KHAZENIM or KHAZENS]\n",
  "KHAZENIM": "KHAZEN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZAN, HAZZAN [n]\n",
  "KHAZENS": "KHAZEN, (Hebrew) a cantor in a synagogue, also CHAZAN, CHAZZAN, CHAZZEN, HAZAN, HAZZAN [n]\n",
  "KHAZI": "(slang) a lavatory, also KAZI, CARSEY, KARZY, KARSY, KARSEY [n -S]\n",
  "KHAZIS": "KHAZI, (slang) a lavatory, also KAZI, CARSEY, KARZY, KARSY, KARSEY [n]\n",
  "KHEDA": "(Hindi) an enclosure for elephants, also KEDDAH, KHEDAH [n -S]\n",
  "KHEDAH": "(Hindi) an enclosure for elephants, also KEDDAH, KHEDA [n -S]\n",
  "KHEDAHS": "KHEDAH, (Hindi) an enclosure for elephants, also KEDDAH, KHEDA [n]\n",
  "KHEDAS": "KHEDA, (Hindi) an enclosure for elephants, also KEDDAH, KHEDAH [n]\n",
  "KHEDIVA": "the wife of a khedive [n -S]\n",
  "KHEDIVAL": "relating to a khedive, the title of the Viceroy of Egypt, also KHEDIVIAL [adj]\n",
  "KHEDIVAS": "KHEDIVA, the wife of a khedive [n]\n",
  "KHEDIVATE": "the office of khedive, the Viceroy of Egypt, also KHEDIVIATE [n -S]\n",
  "KHEDIVATES": "KHEDIVATE, the office of khedive, the Viceroy of Egypt, also KHEDIVIATE [n]\n",
  "KHEDIVE": "a Turkish viceroy [n -S]\n",
  "KHEDIVES": "KHEDIVE, a Turkish viceroy [n]\n",
  "KHEDIVIAL": "relating to a khedive, the Viceroy of Egypt, also KHEDIVAL [adj]\n",
  "KHEDIVIATE": "the office of khedive, the Viceroy of Egypt, also KHEDIVATE [n -S]\n",
  "KHEDIVIATES": "KHEDIVIATE, the office of khedive, the Viceroy of Egypt, also KHEDIVATE [n]\n",
  "KHET": "(Hebrew) the eighth letter of the Hebrew alphabet, also CHETH, HETH, KHETH [n -S]\n",
  "KHETH": "(Hebrew) the eighth letter of the Hebrew alphabet, also CHETH, HETH, KHET [n -S]\n",
  "KHETHS": "KHETH, (Hebrew) the eighth letter of the Hebrew alphabet, also CHETH, HETH, KHET [n]\n",
  "KHETS": "KHET, (Hebrew) the eighth letter of the Hebrew alphabet, also CHETH, HETH, KHETH [n]\n",
  "KHI": "the twenty-second letter of the Greek alphabet, also CHI [n -S]\n",
  "KHIDMUTGAR": "(Urdu) a table-servant, also KHITMUTGAR [n -S]\n",
  "KHIDMUTGARS": "KHIDMUTGAR, (Urdu) a table-servant, also KHITMUTGAR [n]\n",
  "KHILAFAT": "(Arabic) the office of khalif, also CALIFATE, CALIPHATE, KALIPHATE, KHALIFAT, KHALIFATE [n -S]\n",
  "KHILAFATS": "KHILAFAT, (Arabic) the office of khalif, also CALIFATE, CALIPHATE, KALIPHATE, KHALIFAT, KHALIFATE [n]\n",
  "KHILAT": "(Hindi) a robe of honour, also KELLAUT, KHALAT, KILLUT [n -S]\n",
  "KHILATS": "KHILAT, (Hindi) a robe of honour, also KELLAUT, KHALAT, KILLUT [n]\n",
  "KHILIM": "(Turkish) an Eastern woven rug, also KILIM, KELIM [n -S]\n",
  "KHILIMS": "KHILIM, (Turkish) an Eastern woven rug, also KILIM, KELIM [n]\n",
  "KHIMAR": "a type of head covering worn by Arab women [n -S]\n",
  "KHIMARS": "KHIMAR, a type of head covering worn by Arab women [n]\n",
  "KHIRKAH": "a patchwork garment [n -S]\n",
  "KHIRKAHS": "KHIRKAH, a patchwork garment [n]\n",
  "KHIS": "KHI, the twenty-second letter of the Greek alphabet, also CHI [n]\n",
  "KHITMUTGAR": "(Urdu) a table-servant, also KHIDMUTGAR [n -S]\n",
  "KHITMUTGARS": "KHITMUTGAR, (Urdu) a table-servant, also KHIDMUTGAR [n]\n",
  "KHODJA": "(Turkish) an Eastern term of respect, a Muslim teacher or professor, also HODJA, KHOJA [n -S]\n",
  "KHODJAS": "KHODJA, (Turkish) an Eastern term of respect, a Muslim teacher or professor, also HODJA, KHOJA [n]\n",
  "KHOJA": "(Turkish) a Middle Eastern title of respect, also KHODJA [n -S]\n",
  "KHOJAS": "KHOJA, (Turkish) a Middle Eastern title of respect, also KHODJA [n]\n",
  "KHOR": "(Arabic) a dry watercourse; a ravine [n -S]\n",
  "KHORS": "KHOR, (Arabic) a dry watercourse; a ravine [n]\n",
  "KHOTBAH": "(Arabic) an address or public prayer read from the steps of the pulpit in Mohammedan mosques, also KHOTBEH, KHUTBAH [n -S]\n",
  "KHOTBAHS": "KHOTBAH, (Arabic) an address or public prayer read from the steps of the pulpit in Mohammedan mosques, also KHOTBEH, KHUTBAH [n]\n",
  "KHOTBEH": "(Arabic) an address or public prayer read from the steps of the pulpit in Mohammedan mosques, also KHOTBAH, KHUTBAH [n -S]\n",
  "KHOTBEHS": "KHOTBEH, (Arabic) an address or public prayer read from the steps of the pulpit in Mohammedan mosques, also KHOTBAH, KHUTBAH [n]\n",
  "KHOUM": "(Arabic) a monetary unit of Mauretania, 1/5th of an ouguiya [n -S]\n",
  "KHOUMS": "KHOUM, (Arabic) a monetary unit of Mauretania, 1/5th of an ouguiya [n]\n",
  "KHUD": "(Hindi) in India, a pit, hollow, ravine [n -S]\n",
  "KHUDS": "KHUD, (Hindi) in India, a pit, hollow, ravine [n]\n",
  "KHURTA": "(Hindi) a loose-fitting tunic of India, also KURTA [n -S]\n",
  "KHURTAS": "KHURTA, (Hindi) a loose-fitting tunic of India, also KURTA [n]\n",
  "KHUSKHUS": "the grain of the African millet, also COUSCOUS, COUSCOUSOU, KOUSKOUS [n -ES]\n",
  "KHUSKHUSES": "KHUSKHUS, the grain of the African millet, also COUSCOUS, COUSCOUSOU, KOUSKOUS [n]\n",
  "KHUTBAH": "(Arabic) an address or public prayer read from the steps of the pulpit in Mohammedan mosques, also KHOTBAH, KHOTBEH [n -S]\n",
  "KHUTBAHS": "KHUTBAH, (Arabic) an address or public prayer read from the steps of the pulpit in Mohammedan mosques, also KHOTBAH, KHOTBEH [n]\n",
  "KI": "(Japanese) the spirit of martial art [n -S]\n",
  "KIAAT": "(South African) a tropical African leguminous tree [n -S]\n",
  "KIAATS": "KIAAT, (South African) a tropical African leguminous tree [n]\n",
  "KIACK": "a fish of the herring family [n -S]\n",
  "KIACKS": "KIACK, a fish of the herring family [n]\n",
  "KIANG": "a kind of Tibetan wild ass, also KYANG [n -S]\n",
  "KIANGS": "KIANG, a kind of Tibetan wild ass, also KYANG [n]\n",
  "KIAUGH": "(Scots) care, trouble, also KAUGH [n -S]\n",
  "KIAUGHS": "KIAUGH, (Scots) care, trouble, also KAUGH [n]\n",
  "KIBBE": "(Arabic) an Eastern dish of ground lamb and crushed wheat, also KIBBEH, KIBBI [n -S]\n",
  "KIBBEH": "(Arabic) an Eastern dish of ground lamb and crushed wheat, also KIBBE, KIBBI [n -S]\n",
  "KIBBEHS": "KIBBEH, (Arabic) an Eastern dish of ground lamb and crushed wheat, also KIBBE, KIBBI [n]\n",
  "KIBBES": "KIBBE, (Arabic) an Eastern dish of ground lamb and crushed wheat, also KIBBEH, KIBBI [n]\n",
  "KIBBI": "(Arabic) an Eastern dish of ground lamb and crushed wheat, also KIBBE, KIBBEH [n -S]\n",
  "KIBBIS": "KIBBI, (Arabic) an Eastern dish of ground lamb and crushed wheat, also KIBBE, KIBBEH [n]\n",
  "KIBBITZ": "(Yiddish) to give unwelcome advice, also KIBITZ [v -ED, -ING, -ES]\n",
  "KIBBITZED": "KIBBITZ, (Yiddish) to give unwelcome advice, also KIBITZ [v]\n",
  "KIBBITZER": "(Yiddish) one who offers unwanted advice, also KIBITZER [n -S]\n",
  "KIBBITZERS": "KIBBITZER, (Yiddish) one who offers unwanted advice, also KIBITZER [n]\n",
  "KIBBITZES": "KIBBITZ, (Yiddish) to give unwelcome advice, also KIBITZ [v]\n",
  "KIBBITZING": "KIBBITZ, (Yiddish) to give unwelcome advice, also KIBITZ [v]\n",
  "KIBBLE": "to grind coarsely [v KIBBLED, KIBBLING, KIBBLES]\n",
  "KIBBLED": "KIBBLE, to grind coarsely [v]\n",
  "KIBBLES": "KIBBLE, to grind coarsely [v]\n",
  "KIBBLING": "KIBBLE, to grind coarsely [v]\n",
  "KIBBUTZ": "(Hebrew) a collective farm in Israel [n KIBBUTZIM]\n",
  "KIBBUTZIM": "KIBBUTZ, (Hebrew) a collective farm in Israel [n]\n",
  "KIBBUTZNIK": "(Hebrew) a person who lives or works on a kibbutz [n -S]\n",
  "KIBBUTZNIKS": "KIBBUTZNIK, (Hebrew) a person who lives or works on a kibbutz [n]\n",
  "KIBE": "a chapped place on the skin; an ulcerated chilblain [n -S]\n",
  "KIBEI": "(Japanese) an American Japanese educated in Japan [n -S]\n",
  "KIBEIS": "KIBEI, (Japanese) an American Japanese educated in Japan [n]\n",
  "KIBES": "KIBE, a chapped place on the skin; an ulcerated chilblain [n]\n",
  "KIBIBYTE": "two to the power of ten bytes [n -S]\n",
  "KIBIBYTES": "KIBIBYTE, two to the power of ten bytes [n]\n",
  "KIBITKA": "(Russian) a tent used by the Kirghiz Tartars [n -S]\n",
  "KIBITKAS": "KIBITKA, (Russian) a tent used by the Kirghiz Tartars [n]\n",
  "KIBITZ": "(Yiddish) to give unwelcome advice, also KIBBITZ [v -ED, -ING, -ES]\n",
  "KIBITZED": "KIBITZ, (Yiddish) to give unwelcome advice, also KIBBITZ [v]\n",
  "KIBITZER": "(Yiddish) one who offers unwanted advice, also KIBBITZER [n -S]\n",
  "KIBITZERS": "KIBITZER, (Yiddish) one who offers unwanted advice, also KIBBITZER [n]\n",
  "KIBITZES": "KIBITZ, (Yiddish) to give unwelcome advice, also KIBBITZ [v]\n",
  "KIBITZING": "KIBITZ, (Yiddish) to give unwelcome advice, also KIBBITZ [v]\n",
  "KIBLA": "(Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KEBLAH, KIBLAH, QIBLA [n -S]\n",
  "KIBLAH": "(Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KEBLAH, KIBLA, QIBLA [n -S]\n",
  "KIBLAHS": "KIBLAH, (Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KEBLAH, KIBLA, QIBLA [n]\n",
  "KIBLAS": "KIBLA, (Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KEBLAH, KIBLAH, QIBLA [n]\n",
  "KIBOSH": "to put a stop to, ruin the chances of, also KYBOSH [v -ED, -ING, -ES]\n",
  "KIBOSHED": "KIBOSH, to put a stop to, ruin the chances of, also KYBOSH [v]\n",
  "KIBOSHES": "KIBOSH, to put a stop to, ruin the chances of, also KYBOSH [v]\n",
  "KIBOSHING": "KIBOSH, to put a stop to, ruin the chances of, also KYBOSH [v]\n",
  "KICK": "to strike with the foot [v -ED, -ING, -S]\n",
  "KICKABLE": "able to be kicked [adj]\n",
  "KICKABOUT": "an informal game of football, also KICKAROUND [n -S]\n",
  "KICKABOUTS": "KICKABOUT, an informal game of football, also KICKAROUND [n]\n",
  "KICKAROUND": "an informal game of football, also KICKABOUT [n -S]\n",
  "KICKAROUNDS": "KICKAROUND, an informal game of football, also KICKABOUT [n]\n",
  "KICKBACK": "a payment (usually illegal) made to a person who has facilitated a transaction, appointment, etc. [n -S]\n",
  "KICKBACKS": "KICKBACK, a payment (usually illegal) made to a person who has facilitated a transaction, appointment, etc. [n]\n",
  "KICKBALL": "a child's game, similar to baseball [n -S]\n",
  "KICKBALLS": "KICKBALL, a child's game, similar to baseball [n]\n",
  "KICKBOARD": "a buoyant rectangular board held by swimmers to practise kicking technique [n -S]\n",
  "KICKBOARDS": "KICKBOARD, a buoyant rectangular board held by swimmers to practise kicking technique [n]\n",
  "KICKBOX": "to box in a style that allows kicking [v -ED, -ING, -ES]\n",
  "KICKBOXED": "KICKBOX, to box in a style that allows kicking [v]\n",
  "KICKBOXER": "one who practises kickboxing [n -S]\n",
  "KICKBOXERS": "KICKBOXER, one who practises kickboxing [n]\n",
  "KICKBOXES": "KICKBOX, to box in a style that allows kicking [v]\n",
  "KICKBOXING": "boxing with hands and feet [n -S]\n",
  "KICKBOXINGS": "KICKBOXING, boxing with hands and feet [n]\n",
  "KICKDOWN": "a method of changing gear in a car with automatic transmission, by pressing the accelerator pedal right down [n -S]\n",
  "KICKDOWNS": "KICKDOWN, a method of changing gear in a car with automatic transmission, by pressing the accelerator pedal right down [n]\n",
  "KICKED": "KICK, to strike with the foot [v]\n",
  "KICKER": "one that kicks [n -S]\n",
  "KICKERS": "KICKER, one that kicks [n]\n",
  "KICKFLIP": "a skateboard manoeuvre [n -S] / to perform a kickflip [v KICKFLIPPED, KICKFLIPPING, KICKFLIPS]\n",
  "KICKFLIPPED": "KICKFLIP, to perform a kickflip [v]\n",
  "KICKFLIPPING": "KICKFLIP, to perform a kickflip [v]\n",
  "KICKFLIPS": "KICKFLIP, to perform a kickflip [v]\n",
  "KICKIER": "KICKY, exciting [adj]\n",
  "KICKIEST": "KICKY, exciting [adj]\n",
  "KICKING": "the act of striking with the foot [n -S]\n",
  "KICKINGS": "KICKING, the act of striking with the foot [n]\n",
  "KICKOFF": "a kick that begins play in football [n -S]\n",
  "KICKOFFS": "KICKOFF, a kick that begins play in football [n]\n",
  "KICKOUT": "in Gaelic football, a free kick to restart play after a goal or after the ball has gone out of play [n -S]\n",
  "KICKOUTS": "KICKOUT, in Gaelic football, a free kick to restart play after a goal or after the ball has gone out of play [n]\n",
  "KICKPLATE": "a metal plate at the base of a door or panel to protect it from damage or wear [n -S]\n",
  "KICKPLATES": "KICKPLATE, a metal plate at the base of a door or panel to protect it from damage or wear [n]\n",
  "KICKS": "KICK, to strike with the foot [v]\n",
  "KICKSHAW": "a fancy dish, a delicacy; a trinket, also KICKSHAWS [n -S]\n",
  "KICKSHAWS": "KICKSHAW, a fancy dish, a delicacy; a trinket, also KICKSHAWS [n]\n",
  "KICKSHAWSES": "KICKSHAWS, KICKSHAW, a fancy dish, a delicacy; a trinket, also KICKSHAWS [n]\n",
  "KICKSORTER": "a device which selects and counts electrical pulses of a specified amplitude [n -S]\n",
  "KICKSORTERS": "KICKSORTER, a device which selects and counts electrical pulses of a specified amplitude [n]\n",
  "KICKSTAND": "a support for a motorbike [n -S]\n",
  "KICKSTANDS": "KICKSTAND, a support for a motorbike [n]\n",
  "KICKSTART": "to start by kicking a pedal [v -ED, -ING, -S]\n",
  "KICKSTARTED": "KICKSTART, to start by kicking a pedal [v]\n",
  "KICKSTARTING": "KICKSTART, to start by kicking a pedal [v]\n",
  "KICKSTARTS": "KICKSTART, to start by kicking a pedal [v]\n",
  "KICKUP": "a noisy argument [n -S]\n",
  "KICKUPS": "KICKUP, a noisy argument [n]\n",
  "KICKY": "exciting [adj KICKIER, KICKIEST]\n",
  "KID": "to tease, deceive [v KIDDED, KIDDING, KIDS]\n",
  "KIDDED": "KID, to tease, deceive [v]\n",
  "KIDDER": "a person who kids another, a teaser [n -S]\n",
  "KIDDERS": "KIDDER, a person who kids another, a teaser [n]\n",
  "KIDDIE": "(colloquial) a child [n -S]\n",
  "KIDDIED": "KIDDY, to hoax; to kid [v]\n",
  "KIDDIER": "a huckster; a cadger [n -S]\n",
  "KIDDIERS": "KIDDIER, a huckster; a cadger [n]\n",
  "KIDDIES": "KIDDY, to hoax; to kid [v]\n",
  "KIDDIEWINK": "(facetious) a child, also KIDDIEWINKIE, KIDDYWINK [n -S]\n",
  "KIDDIEWINKIE": "(facetious) a child, also KIDDIEWINK, KIDDYWINK [n -S]\n",
  "KIDDIEWINKIES": "KIDDIEWINKIE, (facetious) a child, also KIDDIEWINK, KIDDYWINK [n]\n",
  "KIDDIEWINKS": "KIDDIEWINK, (facetious) a child, also KIDDIEWINKIE, KIDDYWINK [n]\n",
  "KIDDING": "the act of teasing by deception [n -S]\n",
  "KIDDINGLY": "KIDDING [adv]\n",
  "KIDDINGS": "KIDDING, the act of teasing by deception [n]\n",
  "KIDDISH": "childish [adj]\n",
  "KIDDISHNESS": "the state of being kiddish [n -ES]\n",
  "KIDDISHNESSES": "KIDDISHNESS, the state of being kiddish [n]\n",
  "KIDDLE": "a stake fence set in a stream for catching fish, also KIDEL [n -S]\n",
  "KIDDLES": "KIDDLE, a stake fence set in a stream for catching fish, also KIDEL [n]\n",
  "KIDDO": "(slang) a kid, child [n -ES or -S]\n",
  "KIDDOES": "KIDDO, (slang) a kid, child [n]\n",
  "KIDDOS": "KIDDO, (slang) a kid, child [n]\n",
  "KIDDUSH": "(Hebrew) a ceremony of prayer and blessing over wine, performed by the head of a Jewish household at the meal ushering in the Sabbath [n -ES]\n",
  "KIDDUSHES": "KIDDUSH, (Hebrew) a ceremony of prayer and blessing over wine, performed by the head of a Jewish household at the meal ushering in the Sabbath [n]\n",
  "KIDDY": "to hoax; to kid [v KIDDIED, KIDDYING, KIDDIES]\n",
  "KIDDYING": "KIDDY, to hoax; to kid [v]\n",
  "KIDDYWINK": "(facetious) a child, also KIDDIEWINK, KIDDIEWINKIE [n -S]\n",
  "KIDDYWINKS": "KIDDYWINK, (facetious) a child, also KIDDIEWINK, KIDDIEWINKIE [n]\n",
  "KIDEL": "(historical) a stake-fence set in a stream for catching fish, also KIDDLE [n -S]\n",
  "KIDELS": "KIDEL, (historical) a stake-fence set in a stream for catching fish, also KIDDLE [n]\n",
  "KIDGE": "(Scots) brisk, cheerful, also CADGY, KEDGE, KEDGY, KIDGIE [adj]\n",
  "KIDGIE": "(Scots) brisk, cheerful, also CADGY, KEDGE, KEDGY, KIDGE [adj KIDGIER, KIDGIEST]\n",
  "KIDGIER": "KIDGIE, (Scots) brisk, cheerful, also CADGY, KEDGE, KEDGY, KIDGE [adj]\n",
  "KIDGIEST": "KIDGIE, (Scots) brisk, cheerful, also CADGY, KEDGE, KEDGY, KIDGE [adj]\n",
  "KIDGLOVE": "careful and diplomatic [adj]\n",
  "KIDLET": "a little child [n -S]\n",
  "KIDLETS": "KIDLET, a little child [n]\n",
  "KIDLIKE": "like a child [adj]\n",
  "KIDLING": "a young kid [n -S]\n",
  "KIDLINGS": "KIDLING, a young kid [n]\n",
  "KIDLIT": "literature for children [n -S]\n",
  "KIDLITS": "KIDLIT, literature for children [n]\n",
  "KIDNAP": "to take by force and offer for ransom [v KIDNAPPED or KIDNAPED, KIDNAPPING or KIDNAPING, KIDNAPS]\n",
  "KIDNAPED": "KIDNAP, to take by force and offer for ransom [v]\n",
  "KIDNAPEE": "one who is kidnapped, also KIDNAPPEE [n -S]\n",
  "KIDNAPEES": "KIDNAPEE, one who is kidnapped, also KIDNAPPEE [n]\n",
  "KIDNAPER": "one who kidnaps, also KIDNAPPER [n -S]\n",
  "KIDNAPERS": "KIDNAPER, one who kidnaps, also KIDNAPPER [n]\n",
  "KIDNAPING": "an act of kidnaping [n -S]\n",
  "KIDNAPINGS": "KIDNAPING, an act of kidnaping [n]\n",
  "KIDNAPPED": "KIDNAP, to take by force and offer for ransom [v]\n",
  "KIDNAPPEE": "one who is kidnapped, also KIDNAPEE [n -S]\n",
  "KIDNAPPEES": "KIDNAPPEE, one who is kidnapped, also KIDNAPEE [n]\n",
  "KIDNAPPER": "one who kidnaps, also KIDNAPER [n -S]\n",
  "KIDNAPPERS": "KIDNAPPER, one who kidnaps, also KIDNAPER [n]\n",
  "KIDNAPPING": "the act of kidnapping [n -S]\n",
  "KIDNAPPINGS": "KIDNAPPING, the act of kidnapping [n]\n",
  "KIDNAPS": "KIDNAP, to take by force and offer for ransom [v]\n",
  "KIDNEY": "a bodily organ [n -S]\n",
  "KIDNEYLIKE": "shaped like a kidney [adj]\n",
  "KIDNEYS": "KIDNEY, a bodily organ [n]\n",
  "KIDOLOGIES": "KIDOLOGY, the art of kidding [n]\n",
  "KIDOLOGIST": "a student of kidology [n -S]\n",
  "KIDOLOGISTS": "KIDOLOGIST, a student of kidology [n]\n",
  "KIDOLOGY": "the art of kidding [n KIDOLOGIES]\n",
  "KIDS": "KID, to tease, deceive [v]\n",
  "KIDSKIN": "a type of leather [n -S]\n",
  "KIDSKINS": "KIDSKIN, a type of leather [n]\n",
  "KIDSTAKES": "(Australian colloquial) nonsense, humbug [n]\n",
  "KIDULT": "(slang) a film or video for an adult or child audience [n -S]\n",
  "KIDULTS": "KIDULT, (slang) a film or video for an adult or child audience [n]\n",
  "KIDVID": "a television or video entertainment for children [n -S]\n",
  "KIDVIDS": "KIDVID, a television or video entertainment for children [n]\n",
  "KIEF": "(Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEEF, KEF, KIF [n -S]\n",
  "KIEFS": "KIEF, (Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEEF, KEF, KIF [n]\n",
  "KIEKIE": "(Maori) a climbing bush plant of New Zealand [n -S]\n",
  "KIEKIES": "KIEKIE, (Maori) a climbing bush plant of New Zealand [n]\n",
  "KIELBASA": "(Polish) a smoked sausage, also KOLBASI, KOLBASSA, KOLBASSI, KUBASA, KULBASA [n KIELBASY, KIELBASAS, KIELBASI]\n",
  "KIELBASAS": "KIELBASA, (Polish) a smoked sausage, also KOLBASI, KOLBASSA, KOLBASSI, KUBASA, KULBASA [n]\n",
  "KIELBASI": "KIELBASA, (Polish) a smoked sausage, also KOLBASI, KOLBASSA, KOLBASSI, KUBASA, KULBASA [n]\n",
  "KIELBASY": "KIELBASA, (Polish) a smoked sausage, also KOLBASI, KOLBASSA, KOLBASSI, KUBASA, KULBASA [n]\n",
  "KIER": "a vat for boiling and dyeing fabrics, also KEIR [n -S]\n",
  "KIERIE": "(Hottentot) a stick, club, also KIRRI [n -S]\n",
  "KIERIES": "KIERIE, (Hottentot) a stick, club, also KIRRI [n]\n",
  "KIERS": "KIER, a vat for boiling and dyeing fabrics, also KEIR [n]\n",
  "KIESELGUHR": "(German) a soft diatomaceous earth used as an absorbent in explosives, a filtering medium, etc., also KIESELGUR [n -S]\n",
  "KIESELGUHRS": "KIESELGUHR, (German) a soft diatomaceous earth used as an absorbent in explosives, a filtering medium, etc., also KIESELGUR [n]\n",
  "KIESELGUR": "(German) a soft diatomaceous earth used as an absorbent in explosives, a filtering medium, etc., also KIESELGUHR [n -S]\n",
  "KIESELGURS": "KIESELGUR, (German) a soft diatomaceous earth used as an absorbent in explosives, a filtering medium, etc., also KIESELGUHR [n]\n",
  "KIESERITE": "a hydrous sulphate of magnesia found at the salt mines of Stassfurt, Prussian Saxony [n -S]\n",
  "KIESERITES": "KIESERITE, a hydrous sulphate of magnesia found at the salt mines of Stassfurt, Prussian Saxony [n]\n",
  "KIESTER": "(slang) backside, bottom, also KEESTER, KEISTER, KEYSTER [n -S]\n",
  "KIESTERS": "KIESTER, (slang) backside, bottom, also KEESTER, KEISTER, KEYSTER [n]\n",
  "KIEV": "a dish made of thin fillets of meat, esp. chicken (chicken kiev), filled with butter, etc., coated with breadcrumbs, and fried [n -S]\n",
  "KIEVE": "a large tub, also KEEVE [n -S]\n",
  "KIEVES": "KIEVE, a large tub, also KEEVE [n]\n",
  "KIEVS": "KIEV, a dish made of thin fillets of meat, esp. chicken (chicken kiev), filled with butter, etc., coated with breadcrumbs, and fried [n]\n",
  "KIF": "(Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEEF, KEF, KIEF [n -S]\n",
  "KIFF": "(South African) excellent [adj]\n",
  "KIFS": "KIF, (Arabic) a state of dreamy intoxication induced by e.g. cannabis, also KAIF, KEEF, KEF, KIEF [n]\n",
  "KIGHT": "(Spenser) a bird of prey, a kite [n -S]\n",
  "KIGHTS": "KIGHT, (Spenser) a bird of prey, a kite [n]\n",
  "KIKE": "(offensive) a Jew [n -S]\n",
  "KIKES": "KIKE, (offensive) a Jew [n]\n",
  "KIKOI": "(Swahili) in East Africa, a striped cloth worn around the waist [n -S]\n",
  "KIKOIS": "KIKOI, (Swahili) in East Africa, a striped cloth worn around the waist [n]\n",
  "KIKUMON": "(Japanese) the chrysanthemum badge of the Japanese emperor [n -S]\n",
  "KIKUMONS": "KIKUMON, (Japanese) the chrysanthemum badge of the Japanese emperor [n]\n",
  "KIKUYU": "(Bantu) a type of African grass [n -S]\n",
  "KIKUYUS": "KIKUYU, (Bantu) a type of African grass [n]\n",
  "KILD": "KILL, to put to death [v]\n",
  "KILDERKIN": "(obsolete) a cask measuring 18 gallons (1/2 barrel) [n -S]\n",
  "KILDERKINS": "KILDERKIN, (obsolete) a cask measuring 18 gallons (1/2 barrel) [n]\n",
  "KILERG": "a thousand ergs [n -S]\n",
  "KILERGS": "KILERG, a thousand ergs [n]\n",
  "KILEY": "(Native Australian) a boomerang, also KYLIE [n -S]\n",
  "KILEYS": "KILEY, (Native Australian) a boomerang, also KYLIE [n]\n",
  "KILIKITI": "a Polynesian version of cricket played by teams of 15-20 players [n -S]\n",
  "KILIKITIS": "KILIKITI, a Polynesian version of cricket played by teams of 15-20 players [n]\n",
  "KILIM": "(Turkish) a pileless woven rug traditionally made in the Middle East, also KELIM, KHILIM [n -S]\n",
  "KILIMS": "KILIM, (Turkish) a pileless woven rug traditionally made in the Middle East, also KELIM, KHILIM [n]\n",
  "KILL": "to put to death [v KILLED or (Spenser) KILD, KILLING, KILLS]\n",
  "KILLABLE": "able to be killed [adj]\n",
  "KILLADAR": "(Hindi) in India, the commandant of a fort or garrison [n -S]\n",
  "KILLADARS": "KILLADAR, (Hindi) in India, the commandant of a fort or garrison [n]\n",
  "KILLAS": "a Cornish word for clay slate [n -ES]\n",
  "KILLASES": "KILLAS, a Cornish word for clay slate [n]\n",
  "KILLCOW": "(obsolete) a bully, a swaggerer [n -S]\n",
  "KILLCOWS": "KILLCOW, (obsolete) a bully, a swaggerer [n]\n",
  "KILLCROP": "a greedy insatiable baby; a changeling [n -S]\n",
  "KILLCROPS": "KILLCROP, a greedy insatiable baby; a changeling [n]\n",
  "KILLDEE": "a wading bird, also KILLDEER [n -S]\n",
  "KILLDEER": "a wading bird, also KILLDEE [n -S]\n",
  "KILLDEERS": "KILLDEER, a wading bird, also KILLDEE [n]\n",
  "KILLDEES": "KILLDEE, a wading bird, also KILLDEER [n]\n",
  "KILLED": "KILL, to put to death [v]\n",
  "KILLER": "one that kills [n -S]\n",
  "KILLERS": "KILLER, one that kills [n]\n",
  "KILLICK": "a small stone anchor in a wooden frame, also KILLOCK [n -S]\n",
  "KILLICKS": "KILLICK, a small stone anchor in a wooden frame, also KILLOCK [n]\n",
  "KILLIE": "a small freshwater fish, used as bait, also KILLIFISH [n -S]\n",
  "KILLIES": "KILLIE, a small freshwater fish, used as bait, also KILLIFISH [n]\n",
  "KILLIFISH": "a small freshwater fish, used as bait, also KILLIE [n -ES]\n",
  "KILLIFISHES": "KILLIFISH, a small freshwater fish, used as bait, also KILLIE [n]\n",
  "KILLIKINICK": "(Native American) a mixture used by Native Americans as a substitute for tobacco, also KINNIKINIC, KINNIKINICK, KINNIKINNICK [n -S]\n",
  "KILLIKINICKS": "KILLIKINICK, (Native American) a mixture used by Native Americans as a substitute for tobacco, also KINNIKINIC, KINNIKINICK, KINNIKINNICK [n]\n",
  "KILLING": "causing death [adj KILLINGLY] / an act of killing; an outstanding success [n -S]\n",
  "KILLINGLY": "KILLING, causing death [adv]\n",
  "KILLINGS": "KILLING, an act of killing; an outstanding success [n]\n",
  "KILLJOY": "one who spoils the fun of others [n -S]\n",
  "KILLJOYS": "KILLJOY, one who spoils the fun of others [n]\n",
  "KILLOCK": "a small stone anchor in a wooden frame, also KILLICK [n -S]\n",
  "KILLOCKS": "KILLOCK, a small stone anchor in a wooden frame, also KILLICK [n]\n",
  "KILLOGIE": "(Scots) the space in front of the fireplace of a kiln [n -S]\n",
  "KILLOGIES": "KILLOGIE, (Scots) the space in front of the fireplace of a kiln [n]\n",
  "KILLS": "KILL, to put to death [v]\n",
  "KILLUT": "(Hindi) an Indian robe of honour, also KELLAUT, KHALAT, KHILAT [n -S]\n",
  "KILLUTS": "KILLUT, (Hindi) an Indian robe of honour, also KELLAUT, KHALAT, KHILAT [n]\n",
  "KILN": "to bake in a type of oven [v -ED, -ING, -S]\n",
  "KILNED": "KILN, to bake in a type of oven [v]\n",
  "KILNING": "KILN, to bake in a type of oven [v]\n",
  "KILNS": "KILN, to bake in a type of oven [v]\n",
  "KILO": "a short form of kilogram [n -S]\n",
  "KILOBAR": "a unit of atmospheric pressure [n -S]\n",
  "KILOBARS": "KILOBAR, a unit of atmospheric pressure [n]\n",
  "KILOBASE": "a length of a thousand base pairs in a DNA chain [n -S]\n",
  "KILOBASES": "KILOBASE, a length of a thousand base pairs in a DNA chain [n]\n",
  "KILOBAUD": "a unit of data transmission speed [n -S]\n",
  "KILOBAUDS": "KILOBAUD, a unit of data transmission speed [n]\n",
  "KILOBIT": "a unit of computer information, one thousand bits [n -S]\n",
  "KILOBITS": "KILOBIT, a unit of computer information, one thousand bits [n]\n",
  "KILOBYTE": "one thousand bytes [n -S]\n",
  "KILOBYTES": "KILOBYTE, one thousand bytes [n]\n",
  "KILOCALORIE": "one thousand calories [n -S]\n",
  "KILOCALORIES": "KILOCALORIE, one thousand calories [n]\n",
  "KILOCURIE": "one thousand curies [n -S]\n",
  "KILOCURIES": "KILOCURIE, one thousand curies [n]\n",
  "KILOCYCLE": "a unit of frequency: 1 kilocycle per second equals 1 kilohertz [n -S]\n",
  "KILOCYCLES": "KILOCYCLE, a unit of frequency: 1 kilocycle per second equals 1 kilohertz [n]\n",
  "KILOGAUSS": "a unit of magnetism, 1000 gauss [n -ES]\n",
  "KILOGAUSSES": "KILOGAUSS, a unit of magnetism, 1000 gauss [n]\n",
  "KILOGRAM": "a unit of mass and weight, one thousand grams, also KILOGRAMME [n -S]\n",
  "KILOGRAMME": "a unit of mass and weight, one thousand grams, also KILOGRAM [n -S]\n",
  "KILOGRAMMES": "KILOGRAMME, a unit of mass and weight, one thousand grams, also KILOGRAM [n]\n",
  "KILOGRAMS": "KILOGRAM, a unit of mass and weight, one thousand grams, also KILOGRAMME [n]\n",
  "KILOGRAY": "a unit of absorbed radiation, one thousand grays [n -S]\n",
  "KILOGRAYS": "KILOGRAY, a unit of absorbed radiation, one thousand grays [n]\n",
  "KILOHERTZ": "a unit of frequency, 1000 hertz [n -ES]\n",
  "KILOHERTZES": "KILOHERTZ, a unit of frequency, 1000 hertz [n]\n",
  "KILOJOULE": "a unit of energy, 1000 joules [n -S]\n",
  "KILOJOULES": "KILOJOULE, a unit of energy, 1000 joules [n]\n",
  "KILOLITER": "a unit of capacity, 1000 litres, also KILOLITRE [n -S]\n",
  "KILOLITERS": "KILOLITER, a unit of capacity, 1000 litres, also KILOLITRE [n]\n",
  "KILOLITRE": "one thousand litres, also KILOLITER [n -S]\n",
  "KILOLITRES": "KILOLITRE, one thousand litres, also KILOLITER [n]\n",
  "KILOMETER": "a thousand metres, also KILOMETRE [n -S]\n",
  "KILOMETERS": "KILOMETER, a thousand metres, also KILOMETRE [n]\n",
  "KILOMETRE": "a thousand metres, also KILOMETER [n -S]\n",
  "KILOMETRES": "KILOMETRE, a thousand metres, also KILOMETER [n]\n",
  "KILOMETRIC": "relating to measurement by kilometre, also KILOMETRICAL [adj]\n",
  "KILOMETRICAL": "relating to measurement by kilometer, also KILOMETRIC [adj]\n",
  "KILOMOLE": "one thousand moles [n -S]\n",
  "KILOMOLES": "KILOMOLE, one thousand moles [n]\n",
  "KILOPARSEC": "a unit of astronomical distance, 1000 parsecs [n -S]\n",
  "KILOPARSECS": "KILOPARSEC, a unit of astronomical distance, 1000 parsecs [n]\n",
  "KILOPASCAL": "a unit of pressure, 1000 pascals [n -S]\n",
  "KILOPASCALS": "KILOPASCAL, a unit of pressure, 1000 pascals [n]\n",
  "KILOPOND": "a unit of measurement equal to the gravitational force on a mass of one kilogram [n -S]\n",
  "KILOPONDS": "KILOPOND, a unit of measurement equal to the gravitational force on a mass of one kilogram [n]\n",
  "KILORAD": "a unit of nuclear radiation [n -S]\n",
  "KILORADS": "KILORAD, a unit of nuclear radiation [n]\n",
  "KILOS": "KILO, a short form of kilogram [n]\n",
  "KILOTON": "a measure of explosive force equivalent to that of 1000 tons of TNT, also KILOTONNE [n -S]\n",
  "KILOTONNE": "a measure of explosive force equivalent to that of 1000 tons of TNT, also KILOTON [n -S]\n",
  "KILOTONNES": "KILOTONNE, a measure of explosive force equivalent to that of 1000 tons of TNT, also KILOTON [n]\n",
  "KILOTONS": "KILOTON, a measure of explosive force equivalent to that of 1000 tons of TNT, also KILOTONNE [n]\n",
  "KILOVOLT": "a unit of electromotive force [n -S]\n",
  "KILOVOLTS": "KILOVOLT, a unit of electromotive force [n]\n",
  "KILOWATT": "a unit of power [n -S]\n",
  "KILOWATTS": "KILOWATT, a unit of power [n]\n",
  "KILP": "a type of large brown seaweed, also KELP [n -S]\n",
  "KILPS": "KILP, a type of large brown seaweed, also KELP [n]\n",
  "KILT": "a skirtlike garment [n -S] / to tuck up like a kilt [v -ED, -ING, -S]\n",
  "KILTED": "KILT, to tuck up like a kilt [v]\n",
  "KILTER": "good condition, also KELTER [n -S]\n",
  "KILTERS": "KILTER, good condition, also KELTER [n]\n",
  "KILTIE": "one who wears a kilt (a type of skirt), also KILTY [n -S]\n",
  "KILTIES": "KILTY, one who wears a kilt (a type of skirt), also KILTIE [n]\n",
  "KILTING": "an arrangement of kilt pleats [n -S]\n",
  "KILTINGS": "KILTING, an arrangement of kilt pleats [n]\n",
  "KILTLIKE": "like a kilt [adj]\n",
  "KILTS": "KILT, to tuck up like a kilt [v]\n",
  "KILTY": "one who wears a kilt (a type of skirt), also KILTIE [n KILTIES]\n",
  "KIMBERLITE": "a mica-peridotite, an intrusive igneous rock, in which the Kimberley diamonds were found [n -S]\n",
  "KIMBERLITES": "KIMBERLITE, a mica-peridotite, an intrusive igneous rock, in which the Kimberley diamonds were found [n]\n",
  "KIMBO": "to set akimbo, also KEMBO [v -ED, -ING, -S]\n",
  "KIMBOED": "KIMBO, to set akimbo, also KEMBO [v]\n",
  "KIMBOING": "KIMBO, to set akimbo, also KEMBO [v]\n",
  "KIMBOS": "KIMBO, to set akimbo, also KEMBO [v]\n",
  "KIMCHEE": "(Korean) a spicy Korean dish of pickled cabbage, also KIMCHI [n -S]\n",
  "KIMCHEES": "KIMCHEE, (Korean) a spicy Korean dish of pickled cabbage, also KIMCHI [n]\n",
  "KIMCHI": "(Korean) a spicy Korean dish of pickled cabbage, also KIMCHEE [n -S]\n",
  "KIMCHIS": "KIMCHI, (Korean) a spicy Korean dish of pickled cabbage, also KIMCHEE [n]\n",
  "KIMMER": "(Scots) a godmother, also CUMMER [n -S]\n",
  "KIMMERS": "KIMMER, (Scots) a godmother, also CUMMER [n]\n",
  "KIMONO": "(Japanese) a traditional Japanese costume [n -S]\n",
  "KIMONOED": "wearing a kimono [adj]\n",
  "KIMONOS": "KIMONO, (Japanese) a traditional Japanese costume [n]\n",
  "KIN": "a group of persons of common ancestry [n -S]\n",
  "KINA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINAKINA, QUINA, QUINAQUINA, QUINQUINA [n -S]\n",
  "KINAESTHESES": "KINAESTHESIS, a sense of the body's movement or of muscular effort, also KINAESTHESIA, KINESTHESIA, KINESTHESIS [n]\n",
  "KINAESTHESIA": "a sense of the body's movement or of muscular effort, also KINAESTHESIS, KINESTHESIA, KINESTHESIS [n -S]\n",
  "KINAESTHESIAS": "KINAESTHESIA, a sense of the body's movement or of muscular effort, also KINAESTHESIS, KINESTHESIA, KINESTHESIS [n]\n",
  "KINAESTHESIS": "a sense of the body's movement or of muscular effort, also KINAESTHESIA, KINESTHESIA, KINESTHESIS [n KINAESTHESES]\n",
  "KINAESTHETIC": "relating to kinaesthesia, also KINESTHETIC [adj]\n",
  "KINAKINA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, QUINA, QUINAQUINA, QUINQUINA [n -S]\n",
  "KINAKINAS": "KINAKINA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, QUINA, QUINAQUINA, QUINQUINA [n]\n",
  "KINARA": "an African candle holder [n -S]\n",
  "KINARAS": "KINARA, an African candle holder [n]\n",
  "KINAS": "KINA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINAKINA, QUINA, QUINAQUINA, QUINQUINA [n]\n",
  "KINASE": "a kind of enzyme [n -S]\n",
  "KINASES": "KINASE, a kind of enzyme [n]\n",
  "KINCHIN": "in thieves's slang, a child [n -S]\n",
  "KINCHINS": "KINCHIN, in thieves's slang, a child [n]\n",
  "KINCOB": "(Urdu) a rich silk fabric made in India [n -S]\n",
  "KINCOBS": "KINCOB, (Urdu) a rich silk fabric made in India [n]\n",
  "KIND": "good to others [adj KINDER, KINDEST, KINDLY] / (obsolete) to beget, also KYND, KYNDE [v -ED, -ING, -S]\n",
  "KINDA": "(colloquial) kind of [adv]\n",
  "KINDED": "KIND, (obsolete) to beget, also KYND, KYNDE [v]\n",
  "KINDER": "(short for) a kindergarten, a nursery school, also KINDIE, KINDY [n -S]\n",
  "KINDERGARTEN": "(German) a nursery school [n -S]\n",
  "KINDERGARTENER": "a teacher at a kindergarten, also KINDERGARTNER [n -S]\n",
  "KINDERGARTENERS": "KINDERGARTENER, a teacher at a kindergarten, also KINDERGARTNER [n]\n",
  "KINDERGARTENS": "KINDERGARTEN, (German) a nursery school [n]\n",
  "KINDERGARTNER": "a teacher at a kindergarten, also KINDERGARTENER [n -S]\n",
  "KINDERGARTNERS": "KINDERGARTNER, a teacher at a kindergarten, also KINDERGARTENER [n]\n",
  "KINDERS": "KINDER, (short for) a kindergarten, a nursery school, also KINDIE, KINDY [n]\n",
  "KINDERSPIEL": "(German) a children's cantata or play [n -S]\n",
  "KINDERSPIELS": "KINDERSPIEL, (German) a children's cantata or play [n]\n",
  "KINDEST": "KIND, good to others [adj]\n",
  "KINDHEARTED": "having or showing a sympathetic nature [adj KINDHEARTEDLY]\n",
  "KINDHEARTEDLY": "KINDHEARTED, having or showing a sympathetic nature [adv]\n",
  "KINDHEARTEDNESS": "the state of being kindhearted [n]\n",
  "KINDIE": "(Australian slang) a kindergarten, a nursery school, also KINDER, KINDY [n -S]\n",
  "KINDIES": "KINDY, (Australian slang) a kindergarten, a nursery school, also KINDER, KINDIE [n]\n",
  "KINDING": "KIND, (obsolete) to beget, also KYND, KYNDE [v]\n",
  "KINDLE": "to cause to burn [v KINDLED, KINDLING, KINDLES]\n",
  "KINDLED": "KINDLE, to cause to burn [v]\n",
  "KINDLER": "one who kindles [n -S]\n",
  "KINDLERS": "KINDLER, one who kindles [n]\n",
  "KINDLES": "KINDLE, to cause to burn [v]\n",
  "KINDLESS": "(Shakespeare) unnatural [adj KINDLESSLY]\n",
  "KINDLESSLY": "KINDLESS, (Shakespeare) unnatural [adv]\n",
  "KINDLIER": "KINDLY, kind [adj]\n",
  "KINDLIEST": "KINDLY, kind [adj]\n",
  "KINDLILY": "KINDLY, kind [adv]\n",
  "KINDLINESS": "the state of being kindly [n -ES]\n",
  "KINDLINESSES": "KINDLINESS, the state of being kindly [n]\n",
  "KINDLING": "twigs etc. used to start a fire [n -S]\n",
  "KINDLINGS": "KINDLING, twigs etc. used to start a fire [n]\n",
  "KINDLY": "kind [adj KINDLIER, KINDLIEST, KINDLILY]\n",
  "KINDNESS": "the quality of being kind [n -ES]\n",
  "KINDNESSES": "KINDNESS, the quality of being kind [n]\n",
  "KINDRED": "blood relationship, also KINRED [n -S]\n",
  "KINDREDNESS": "relatedness [n -ES]\n",
  "KINDREDNESSES": "KINDREDNESS, relatedness [n]\n",
  "KINDREDS": "KINDRED, blood relationship, also KINRED [n]\n",
  "KINDREDSHIP": "relatedness [n -S]\n",
  "KINDREDSHIPS": "KINDREDSHIP, relatedness [n]\n",
  "KINDS": "KIND, (obsolete) to beget, also KYND, KYNDE [v]\n",
  "KINDY": "(Australian slang) a kindergarten, a nursery school, also KINDER, KINDIE [n KINDIES]\n",
  "KINE": "cattle, also KYNE [n] / a type of television tube [n -S]\n",
  "KINEMA": "a motion-picture theatre, also CINEMA [n -S]\n",
  "KINEMAS": "KINEMA, a motion-picture theatre, also CINEMA [n]\n",
  "KINEMATIC": "relating to the kinema [adj KINEMATICALLY]\n",
  "KINEMATICAL": "relating to the kinema [adj KINEMATICALLY]\n",
  "KINEMATICALLY": "KINEMATICAL, relating to the kinema [adv]\n",
  "KINEMATICS": "the study of motion [n]\n",
  "KINEMATOGRAPH": "an apparatus for filming, printing and projecting a series of instantaneous photographs so as to give a moving representation of a scene, also CINEMATOGRAPH [n -S]\n",
  "KINEMATOGRAPHER": "one who operates a kinematograph [n]\n",
  "KINEMATOGRAPHIC": "relating to kinematography [adj]\n",
  "KINEMATOGRAPHS": "KINEMATOGRAPH, an apparatus for filming, printing and projecting a series of instantaneous photographs so as to give a moving representation of a scene, also CINEMATOGRAPH [n]\n",
  "KINEMATOGRAPHY": "the art of the kinematograph [n]\n",
  "KINES": "KINE, cattle, also KYNE [n]\n",
  "KINESCOPE": "(tradename) a cathode ray tube for a television; a motion picture made from an image on this [n -S] / to make a kinescope [v KINESCOPED, KINESCOPING, KINESCOPES]\n",
  "KINESCOPED": "KINESCOPE, to make a kinescope [v]\n",
  "KINESCOPES": "KINESCOPE, to make a kinescope [v]\n",
  "KINESCOPING": "KINESCOPE, to make a kinescope [v]\n",
  "KINESES": "KINESIS, (Greek) movement, change of position, esp. under stimulus [n]\n",
  "KINESIATRIC": "relating to kinesiatrics, healing by kinesiology [adj]\n",
  "KINESIATRICS": "a method of treating disease by means of exercises or gymnastic movements [n]\n",
  "KINESIC": "relating to kinesis, movement, change of position, esp. under stimulus [adj]\n",
  "KINESICS": "the study of body motion in relation to communication [n]\n",
  "KINESIOLOGIES": "KINESIOLOGY, the study of human movement and posture, including aspects of anatomy [n]\n",
  "KINESIOLOGIST": "a specialist in kinesiology [n -S]\n",
  "KINESIOLOGISTS": "KINESIOLOGIST, a specialist in kinesiology [n]\n",
  "KINESIOLOGY": "the study of human movement and posture, including aspects of anatomy [n KINESIOLOGIES]\n",
  "KINESIPATH": "one who heals by kinesiology [n -S]\n",
  "KINESIPATHIC": "relating to kinesiatrics, a method of treating disease by means of exercises or gymnastic movements [adj]\n",
  "KINESIPATHIES": "KINESIPATHY, the practice of treating illness with exercise [n]\n",
  "KINESIPATHIST": "one who practises kinesiatrics, a method of treating disease by means of exercises or gymnastic movements [n -S]\n",
  "KINESIPATHISTS": "KINESIPATHIST, one who practises kinesiatrics, a method of treating disease by means of exercises or gymnastic movements [n]\n",
  "KINESIPATHS": "KINESIPATH, one who heals by kinesiology [n]\n",
  "KINESIPATHY": "the practice of treating illness with exercise [n KINESIPATHIES]\n",
  "KINESIS": "(Greek) movement, change of position, esp. under stimulus [n KINESES or KINESISES]\n",
  "KINESISES": "KINESIS, (Greek) movement, change of position, esp. under stimulus [n]\n",
  "KINESITHERAPIES": "KINESITHERAPY, a method of treating disease by means of exercises or gymnastic movements, aka kinesiatrics [n]\n",
  "KINESITHERAPY": "a method of treating disease by means of exercises or gymnastic movements, aka kinesiatrics [n KINESITHERAPIES]\n",
  "KINESTHESES": "KINESTHESIS, a sense of the body's movement or of muscular effort, also KINAESTHESIA, KINAESTHESIS, KINESTHESIA [n]\n",
  "KINESTHESIA": "a sense of the body's movement or of muscular effort, also KINAESTHESIA, KINAESTHESIS, KINESTHESIS [n -S]\n",
  "KINESTHESIAS": "KINESTHESIA, a sense of the body's movement or of muscular effort, also KINAESTHESIA, KINAESTHESIS, KINESTHESIS [n]\n",
  "KINESTHESIS": "a sense of the body's movement or of muscular effort, also KINAESTHESIA, KINAESTHESIS, KINESTHESIA [n KINESTHESES]\n",
  "KINESTHETIC": "relating to kinesthesia, also KINAESTHETIC [adj KINESTHETICALLY]\n",
  "KINESTHETICALLY": "KINESTHETIC, relating to kinesthesia, also KINAESTHETIC [adv]\n",
  "KINETHEODOLITE": "a theodolite used in tracking missiles and satellites [n -S]\n",
  "KINETHEODOLITES": "KINETHEODOLITE, a theodolite used in tracking missiles and satellites [n]\n",
  "KINETIC": "relating to movement, also KINETICAL [adj KINETICALLY]\n",
  "KINETICAL": "relating to movement, also KINETIC [adj KINETICALLY]\n",
  "KINETICALLY": "KINETICAL, relating to movement, also KINETIC [adv]\n",
  "KINETICIST": "one who studies kinetics [n -S]\n",
  "KINETICISTS": "KINETICIST, one who studies kinetics [n]\n",
  "KINETICS": "the study of forces producing or changing motion [n]\n",
  "KINETIN": "a substance that increases plant growth [n -S]\n",
  "KINETINS": "KINETIN, a substance that increases plant growth [n]\n",
  "KINETOCHORE": "a structure forming at the centromere during mitosis for binding microtubules [n -S]\n",
  "KINETOCHORES": "KINETOCHORE, a structure forming at the centromere during mitosis for binding microtubules [n]\n",
  "KINETOGRAPH": "an early form of cinematograph camera [n -S]\n",
  "KINETOGRAPHS": "KINETOGRAPH, an early form of cinematograph camera [n]\n",
  "KINETONUCLEI": "KINETONUCLEUS, a DNA body located near the base of the flagellum in flagellate protozoa, also KINETOPLAST [n]\n",
  "KINETONUCLEUS": "a DNA body located near the base of the flagellum in flagellate protozoa, also KINETOPLAST [n KINETONUCLEI or KINETONUCLEUSES]\n",
  "KINETONUCLEUSES": "KINETONUCLEUS, a DNA body located near the base of the flagellum in flagellate protozoa, also KINETOPLAST [n]\n",
  "KINETOPLAST": "a DNA body located near the base of the flagellum in flagellate protozoa, also KINETONUCLEUS [n -S]\n",
  "KINETOPLASTS": "KINETOPLAST, a DNA body located near the base of the flagellum in flagellate protozoa, also KINETONUCLEUS [n]\n",
  "KINETOSCOPE": "an instrument for producing curves by the combination of circular movements [n -S]\n",
  "KINETOSCOPES": "KINETOSCOPE, an instrument for producing curves by the combination of circular movements [n]\n",
  "KINETOSOME": "a basal body [n -S]\n",
  "KINETOSOMES": "KINETOSOME, a basal body [n]\n",
  "KINFOLK": "people related to one, also KINSFOLK [n -S]\n",
  "KINFOLKS": "KINFOLK, people related to one, also KINSFOLK [n]\n",
  "KING": "a male hereditary chief ruler or titular head of a nation [n -S] / to make king; to provide with a king [v -ED, -ING, -S]\n",
  "KINGBIRD": "a small American bird, noted for its courage in attacking larger birds, even hawks and eagles, esp. when they approach its nest in the breeding season [n -S]\n",
  "KINGBIRDS": "KINGBIRD, a small American bird, noted for its courage in attacking larger birds, even hawks and eagles, esp. when they approach its nest in the breeding season [n]\n",
  "KINGBOLT": "a central bolt connecting an axle to a vehicle, also KINGPIN [n -S]\n",
  "KINGBOLTS": "KINGBOLT, a central bolt connecting an axle to a vehicle, also KINGPIN [n]\n",
  "KINGCRAFT": "(obsolete) the craft of kings; the art of governing as a sovereign [n -S]\n",
  "KINGCRAFTS": "KINGCRAFT, (obsolete) the craft of kings; the art of governing as a sovereign [n]\n",
  "KINGCUP": "a marsh flower [n -S]\n",
  "KINGCUPS": "KINGCUP, a marsh flower [n]\n",
  "KINGDOM": "an area ruled by a king [n -S]\n",
  "KINGDOMED": "(Shakespeare) having a kingdom or the dignity of a king [adj]\n",
  "KINGDOMLESS": "without a kingdom [adj]\n",
  "KINGDOMS": "KINGDOM, an area ruled by a king [n]\n",
  "KINGED": "KING, to make king; to provide with a king [v]\n",
  "KINGFISH": "an American marine food fish of the Atlantic coast; aka gemfish [n -ES]\n",
  "KINGFISHER": "a European fish-eating bird with very brilliant blue-green and chestnut plumage, formerly known as the halcyon [n -S]\n",
  "KINGFISHERS": "KINGFISHER, a European fish-eating bird with very brilliant blue-green and chestnut plumage, formerly known as the halcyon [n]\n",
  "KINGFISHES": "KINGFISH, an American marine food fish of the Atlantic coast; aka gemfish [n]\n",
  "KINGHOOD": "the office of a king [n -S]\n",
  "KINGHOODS": "KINGHOOD, the office of a king [n]\n",
  "KINGING": "KING, to make king; to provide with a king [v]\n",
  "KINGKLIP": "(South African) any of several marine food fishes [n -S]\n",
  "KINGKLIPS": "KINGKLIP, (South African) any of several marine food fishes [n]\n",
  "KINGLE": "(Scots) a very hard rock esp. sandstone [n -S]\n",
  "KINGLES": "KINGLE, (Scots) a very hard rock esp. sandstone [n]\n",
  "KINGLESS": "without a king [adj]\n",
  "KINGLET": "any of several tiny birds of the wren genus [n -S]\n",
  "KINGLETS": "KINGLET, any of several tiny birds of the wren genus [n]\n",
  "KINGLIER": "KINGLY, befitting a king [adj]\n",
  "KINGLIEST": "KINGLY, befitting a king [adj]\n",
  "KINGLIHOOD": "kingliness [n -S]\n",
  "KINGLIHOODS": "KINGLIHOOD, kingliness [n]\n",
  "KINGLIKE": "like a king [adj]\n",
  "KINGLINESS": "the quality of being kingly [n -ES]\n",
  "KINGLINESSES": "KINGLINESS, the quality of being kingly [n]\n",
  "KINGLING": "a petty king [n -S]\n",
  "KINGLINGS": "KINGLING, a petty king [n]\n",
  "KINGLY": "befitting a king [adj KINGLIER, KINGLIEST]\n",
  "KINGMAKER": "one who decides who shall be king [n -S]\n",
  "KINGMAKERS": "KINGMAKER, one who decides who shall be king [n]\n",
  "KINGPIN": "a central bolt connecting an axle to a vehicle, also KINGBOLT [n -S]\n",
  "KINGPINS": "KINGPIN, a central bolt connecting an axle to a vehicle, also KINGBOLT [n]\n",
  "KINGPOST": "a perpendicular beam in the frame of a roof [n -S]\n",
  "KINGPOSTS": "KINGPOST, a perpendicular beam in the frame of a roof [n]\n",
  "KINGS": "KING, to make king; to provide with a king [v]\n",
  "KINGSHIP": "the position of a king [n -S]\n",
  "KINGSHIPS": "KINGSHIP, the position of a king [n]\n",
  "KINGSIDE": "a part of a chessboard [n -S]\n",
  "KINGSIDES": "KINGSIDE, a part of a chessboard [n]\n",
  "KINGSNAKE": "a North American snake [n -S]\n",
  "KINGSNAKES": "KINGSNAKE, a North American snake [n]\n",
  "KINGWOOD": "a hardwood tree [n -S]\n",
  "KINGWOODS": "KINGWOOD, a hardwood tree [n]\n",
  "KININ": "a plant hormone which promotes cell division and is used commercially as a preservative for cut flowers [n -S]\n",
  "KININS": "KININ, a plant hormone which promotes cell division and is used commercially as a preservative for cut flowers [n]\n",
  "KINK": "to form a loop or bend in [v -ED, -ING, -S]\n",
  "KINKAJOU": "a nocturnal carnivorous mammal of South America, allied to the raccoons [n -S]\n",
  "KINKAJOUS": "KINKAJOU, a nocturnal carnivorous mammal of South America, allied to the raccoons [n]\n",
  "KINKED": "KINK, to form a loop or bend in [v]\n",
  "KINKIER": "KINKY, twisted [adj]\n",
  "KINKIEST": "KINKY, twisted [adj]\n",
  "KINKILY": "KINKY, twisted [adv]\n",
  "KINKINESS": "the state of being kinky [n -ES]\n",
  "KINKINESSES": "KINKINESS, the state of being kinky [n]\n",
  "KINKING": "KINK, to form a loop or bend in [v]\n",
  "KINKLE": "a slight kink [n -S]\n",
  "KINKLES": "KINKLE, a slight kink [n]\n",
  "KINKS": "KINK, to form a loop or bend in [v]\n",
  "KINKY": "twisted [adj KINKIER, KINKIEST, KINKILY]\n",
  "KINLESS": "without relatives [adj]\n",
  "KINNIKINIC": "(Native American) a mixture used by Native Americans as a substitute for tobacco, also KILLIKINICK, KINNIKINICK, KINNIKINNICK [n -S]\n",
  "KINNIKINICK": "(Native American) a mixture used by Native Americans as a substitute for tobacco, also KILLIKINICK, KINNIKINIC, KINNIKINNICK [n -S]\n",
  "KINNIKINICKS": "KINNIKINICK, (Native American) a mixture used by Native Americans as a substitute for tobacco, also KILLIKINICK, KINNIKINIC, KINNIKINNICK [n]\n",
  "KINNIKINICS": "KINNIKINIC, (Native American) a mixture used by Native Americans as a substitute for tobacco, also KILLIKINICK, KINNIKINICK, KINNIKINNICK [n]\n",
  "KINNIKINNICK": "(Native American) a mixture used by Native Americans as a substitute for tobacco, also KILLIKINICK, KINNIKINIC, KINNIKINICK [n -S]\n",
  "KINNIKINNICKS": "KINNIKINNICK, (Native American) a mixture used by Native Americans as a substitute for tobacco, also KILLIKINICK, KINNIKINIC, KINNIKINICK [n]\n",
  "KINO": "a red gum containing tannin, obtained from several tropical trees [n -S]\n",
  "KINONE": "a golden-yellow crystalline compound usually prepared by oxidizing aniline, also CHINONE, QUINONE [n -S]\n",
  "KINONES": "KINONE, a golden-yellow crystalline compound usually prepared by oxidizing aniline, also CHINONE, QUINONE [n]\n",
  "KINOS": "KINO, a red gum containing tannin, obtained from several tropical trees [n]\n",
  "KINRED": "(Spenser) kindred [n -S]\n",
  "KINREDS": "KINRED, (Spenser) kindred [n]\n",
  "KINS": "KIN, a group of persons of common ancestry [n]\n",
  "KINSFOLK": "people related to one, also KINFOLK [n -S]\n",
  "KINSFOLKS": "KINSFOLK, people related to one, also KINFOLK [n]\n",
  "KINSHIP": "relationship [n -S]\n",
  "KINSHIPS": "KINSHIP, relationship [n]\n",
  "KINSMAN": "a male relative [n KINSMEN]\n",
  "KINSMEN": "KINSMAN, a male relative [n]\n",
  "KINSWOMAN": "a female relative [n KINSWOMEN]\n",
  "KINSWOMEN": "KINSWOMAN, a female relative [n]\n",
  "KINTLEDGE": "pig-iron used as ballast in a ship's hold, also KENTLEDGE [n -S]\n",
  "KINTLEDGES": "KINTLEDGE, pig-iron used as ballast in a ship's hold, also KENTLEDGE [n]\n",
  "KIORE": "(Maori) a small brown rat native to New Zealand [n -S]\n",
  "KIORES": "KIORE, (Maori) a small brown rat native to New Zealand [n]\n",
  "KIOSK": "an open booth [n -S]\n",
  "KIOSKS": "KIOSK, an open booth [n]\n",
  "KIP": "to sleep [v KIPPED, KIPPING, KIPS]\n",
  "KIPE": "an osier basket for catching pike [n -S]\n",
  "KIPES": "KIPE, an osier basket for catching pike [n]\n",
  "KIPP": "(Scots) anything beaked; a pointed hill [n -S]\n",
  "KIPPA": "(Hebrew) a religious skullcap, aka yarmulka, also KIPPAH [n -S]\n",
  "KIPPAGE": "(Scots) a state of displeasure or anger [n -S]\n",
  "KIPPAGES": "KIPPAGE, (Scots) a state of displeasure or anger [n]\n",
  "KIPPAH": "(Hebrew) a religious skullcap, aka yarmulka, also KIPPA [n -S]\n",
  "KIPPAHS": "KIPPAH, (Hebrew) a religious skullcap, aka yarmulka, also KIPPA [n]\n",
  "KIPPAS": "KIPPA, (Hebrew) a religious skullcap, aka yarmulka, also KIPPAH [n]\n",
  "KIPPED": "KIP, to sleep [v]\n",
  "KIPPEN": "KEP, (Scots) to catch [v]\n",
  "KIPPER": "to cure fish by salting and smoking [v -ED, -ING, -S]\n",
  "KIPPERED": "KIPPER, to cure fish by salting and smoking [v]\n",
  "KIPPERER": "one who cures kippers [n -S]\n",
  "KIPPERERS": "KIPPERER, one who cures kippers [n]\n",
  "KIPPERING": "KIPPER, to cure fish by salting and smoking [v]\n",
  "KIPPERS": "KIPPER, to cure fish by salting and smoking [v]\n",
  "KIPPING": "KIP, to sleep [v]\n",
  "KIPPS": "KIPP, (Scots) anything beaked; a pointed hill [n]\n",
  "KIPS": "KIP, to sleep [v]\n",
  "KIPSKIN": "leather prepared from the skin of young or small cattle, intermediate in grade between calfskin and cowhide [n -S]\n",
  "KIPSKINS": "KIPSKIN, leather prepared from the skin of young or small cattle, intermediate in grade between calfskin and cowhide [n]\n",
  "KIPUNJI": "a long-tailed Tanzanian monkey with a crest of erect hair [n -S]\n",
  "KIPUNJIS": "KIPUNJI, a long-tailed Tanzanian monkey with a crest of erect hair [n]\n",
  "KIR": "a wine and blackcurrant drink [n -S]\n",
  "KIRANA": "(in India) a small, usually family-owned shop selling groceries and other sundries [n -S]\n",
  "KIRANAS": "KIRANA, (in India) a small, usually family-owned shop selling groceries and other sundries [n]\n",
  "KIRBEH": "(Arabic) an Eastern water container made from hide [n -S]\n",
  "KIRBEHS": "KIRBEH, (Arabic) an Eastern water container made from hide [n]\n",
  "KIRBIGRIP": "(tradename) a kind of hairgrip [n -S]\n",
  "KIRBIGRIPS": "KIRBIGRIP, (tradename) a kind of hairgrip [n]\n",
  "KIRBY": "as in kirby grip, a kind of hair grip [adj]\n",
  "KIRIGAMI": "(Japanese) the art of folding and cutting paper [n -S]\n",
  "KIRIGAMIS": "KIRIGAMI, (Japanese) the art of folding and cutting paper [n]\n",
  "KIRIMON": "(Japanese) a Japanese imperial crest with leaves and flowers [n -S]\n",
  "KIRIMONS": "KIRIMON, (Japanese) a Japanese imperial crest with leaves and flowers [n]\n",
  "KIRK": "(Scots) to perform a church service with [v -ED, -ING, -S]\n",
  "KIRKED": "KIRK, (Scots) to perform a church service with [v]\n",
  "KIRKING": "the first attendance at church after marriage [n -S]\n",
  "KIRKINGS": "KIRKING, the first attendance at church after marriage [n]\n",
  "KIRKMAN": "a clergyman or officer in a kirk [n KIRKMEN]\n",
  "KIRKMEN": "KIRKMAN, a clergyman or officer in a kirk [n]\n",
  "KIRKS": "KIRK, (Scots) to perform a church service with [v]\n",
  "KIRKTON": "(Scots) a village with a parish church [n -S]\n",
  "KIRKTONS": "KIRKTON, (Scots) a village with a parish church [n]\n",
  "KIRKWARD": "(Scots) in the direction of the church [adv]\n",
  "KIRKYAIRD": "(Scots) a churchyard, also KIRKYARD [n -S]\n",
  "KIRKYAIRDS": "KIRKYAIRD, (Scots) a churchyard, also KIRKYARD [n]\n",
  "KIRKYARD": "(Scots) a churchyard, also KIRKYAIRD [n -S]\n",
  "KIRKYARDS": "KIRKYARD, (Scots) a churchyard, also KIRKYAIRD [n]\n",
  "KIRMESS": "(Dutch) in Europe, particularly in Belgium and Holland, an outdoor festival and fair; in the United States, generally an indoor entertainment and fair combined, also KERMESS, KERMIS [n -ES]\n",
  "KIRMESSES": "KIRMESS, (Dutch) in Europe, particularly in Belgium and Holland, an outdoor festival and fair; in the United States, generally an indoor entertainment and fair combined, also KERMESS, KERMIS [n]\n",
  "KIRN": "to churn [v -ED, -ING, -S]\n",
  "KIRNED": "KIRN, to churn [v]\n",
  "KIRNING": "KIRN, to churn [v]\n",
  "KIRNS": "KIRN, to churn [v]\n",
  "KIRPAN": "(Punjabi) a small sword of religious significance to Sikhs [n -S]\n",
  "KIRPANS": "KIRPAN, (Punjabi) a small sword of religious significance to Sikhs [n]\n",
  "KIRRI": "(Hottentot) a stick, club, also KIERIE [n -S]\n",
  "KIRRIS": "KIRRI, (Hottentot) a stick, club, also KIERIE [n]\n",
  "KIRS": "KIR, a wine and blackcurrant drink [n]\n",
  "KIRSCH": "(German) an alcoholic spirit distilled, chiefly in Germany and Switzerland, from the fermented juice of cherries, also KIRSCHWASSER [n -ES]\n",
  "KIRSCHES": "KIRSCH, (German) an alcoholic spirit distilled, chiefly in Germany and Switzerland, from the fermented juice of cherries, also KIRSCHWASSER [n]\n",
  "KIRSCHWASSER": "(German) an alcoholic spirit distilled, chiefly in Germany and Switzerland, from the fermented juice of cherries, also KIRSCH [n -S]\n",
  "KIRSCHWASSERS": "KIRSCHWASSER, (German) an alcoholic spirit distilled, chiefly in Germany and Switzerland, from the fermented juice of cherries, also KIRSCH [n]\n",
  "KIRTAN": "(Sanskrit) devotional singing, usually accompanied by musical instruments [n -S]\n",
  "KIRTANS": "KIRTAN, (Sanskrit) devotional singing, usually accompanied by musical instruments [n]\n",
  "KIRTLE": "(historical) a man's or woman's tunic or coat [n -S]\n",
  "KIRTLED": "wearing a kirtle [adj]\n",
  "KIRTLES": "KIRTLE, (historical) a man's or woman's tunic or coat [n]\n",
  "KIS": "KI, (Japanese) the spirit of martial art [n]\n",
  "KISAN": "(Hindi) an Indian peasant or farm worker [n -S]\n",
  "KISANS": "KISAN, (Hindi) an Indian peasant or farm worker [n]\n",
  "KISH": "solid graphite which separates from hot cast-iron [n -ES]\n",
  "KISHES": "KISH, solid graphite which separates from hot cast-iron [n]\n",
  "KISHKA": "(Yiddish) seasoned mashed potatoes in a casing, also KISHKE [n -S]\n",
  "KISHKAS": "KISHKA, (Yiddish) seasoned mashed potatoes in a casing, also KISHKE [n]\n",
  "KISHKE": "(Yiddish) seasoned mashed potatoes in a casing, also KISHKA [n -S]\n",
  "KISHKES": "KISHKE, (Yiddish) seasoned mashed potatoes in a casing, also KISHKA [n]\n",
  "KISKADEE": "a kind of large flycatcher [n -S]\n",
  "KISKADEES": "KISKADEE, a kind of large flycatcher [n]\n",
  "KISMAT": "(Turkish) destiny, also KISMET [n -S]\n",
  "KISMATS": "KISMAT, (Turkish) destiny, also KISMET [n]\n",
  "KISMET": "(Turkish) destiny, also KISMAT [n -S]\n",
  "KISMETIC": "relating to kismet, fate, destiny [adj]\n",
  "KISMETS": "KISMET, (Turkish) destiny, also KISMAT [n]\n",
  "KISS": "to caress by touching with the lips [v -ED, -ING, -ES]\n",
  "KISSABLE": "able to be kissed [adj KISSABLY]\n",
  "KISSABLY": "KISSABLE, able to be kissed [adv]\n",
  "KISSAGRAM": "a service whereby a kiss is delivered e.g. on someone's birthday by a kissagram girl, also KISSOGRAM [n -S]\n",
  "KISSAGRAMS": "KISSAGRAM, a service whereby a kiss is delivered e.g. on someone's birthday by a kissagram girl, also KISSOGRAM [n]\n",
  "KISSED": "KISS, to caress by touching with the lips [v]\n",
  "KISSEL": "(Russian) thickened fruit puree dessert [n -S]\n",
  "KISSELS": "KISSEL, (Russian) thickened fruit puree dessert [n]\n",
  "KISSER": "(colloquial) the mouth, the face [n -S]\n",
  "KISSERS": "KISSER, (colloquial) the mouth, the face [n]\n",
  "KISSES": "KISS, to caress by touching with the lips [v]\n",
  "KISSIER": "KISSY, inclined to kiss [adj]\n",
  "KISSIEST": "KISSY, inclined to kiss [adj]\n",
  "KISSING": "the act of caressing by touching with the lips [n -S]\n",
  "KISSINGS": "KISSING, the act of caressing by touching with the lips [n]\n",
  "KISSOGRAM": "a service whereby a kiss is delivered e.g. on someone's birthday by a kissogram girl, also KISSAGRAM [n -S]\n",
  "KISSOGRAMS": "KISSOGRAM, a service whereby a kiss is delivered e.g. on someone's birthday by a kissogram girl, also KISSAGRAM [n]\n",
  "KISSPEPTIN": "a protein molecule that is responsible for triggering the onset of puberty in humans [n -S]\n",
  "KISSPEPTINS": "KISSPEPTIN, a protein molecule that is responsible for triggering the onset of puberty in humans [n]\n",
  "KISSY": "inclined to kiss [adj KISSIER, KISSIEST]\n",
  "KIST": "(Scots) to place into a coffin [v -ED, -ING, -S]\n",
  "KISTED": "KIST, (Scots) to place into a coffin [v]\n",
  "KISTFUL": "as much as a chest can hold, also CHESTFUL [n -S]\n",
  "KISTFULS": "KISTFUL, as much as a chest can hold, also CHESTFUL [n]\n",
  "KISTING": "KIST, (Scots) to place into a coffin [v]\n",
  "KISTS": "KIST, (Scots) to place into a coffin [v]\n",
  "KISTVAEN": "(Welsh) a tomb covered with stone slabs, also CISTVAEN [n -S]\n",
  "KISTVAENS": "KISTVAEN, (Welsh) a tomb covered with stone slabs, also CISTVAEN [n]\n",
  "KIT": "to equip, fit out [v KITTED, KITTING, KITS]\n",
  "KITBAG": "a bag for holding kit [n -S]\n",
  "KITBAGS": "KITBAG, a bag for holding kit [n]\n",
  "KITCHEN": "a room equipped for preparing food [n -S] / to entertain in a kitchen, provide with food [v -ED, -ING, -S]\n",
  "KITCHENALIA": "apparatus for the kitchen [n -S]\n",
  "KITCHENALIAS": "KITCHENALIA, apparatus for the kitchen [n]\n",
  "KITCHENDOM": "the domain of the kitchen [n -S]\n",
  "KITCHENDOMS": "KITCHENDOM, the domain of the kitchen [n]\n",
  "KITCHENED": "KITCHEN, to entertain in a kitchen, provide with food [v]\n",
  "KITCHENER": "a kitchen servant; a cook [n -S]\n",
  "KITCHENERS": "KITCHENER, a kitchen servant; a cook [n]\n",
  "KITCHENET": "a small kitchen or part of another room equipped for use as a kitchen, also KITCHENETTE [n -S]\n",
  "KITCHENETS": "KITCHENET, a small kitchen or part of another room equipped for use as a kitchen, also KITCHENETTE [n]\n",
  "KITCHENETTE": "a small kitchen or an alcove containing cooking facilities, also KITCHENET [n -S]\n",
  "KITCHENETTES": "KITCHENETTE, a small kitchen or an alcove containing cooking facilities, also KITCHENET [n]\n",
  "KITCHENING": "KITCHEN, to entertain in a kitchen, provide with food [v]\n",
  "KITCHENMAID": "a maid who works in the kitchen [n -S]\n",
  "KITCHENMAIDS": "KITCHENMAID, a maid who works in the kitchen [n]\n",
  "KITCHENS": "KITCHEN, to entertain in a kitchen, provide with food [v]\n",
  "KITCHENWARE": "utensils and appliances for use in a kitchen [n -S]\n",
  "KITCHENWARES": "KITCHENWARE, utensils and appliances for use in a kitchen [n]\n",
  "KITE": "to obtain money fraudulently [v KITED, KITING, KITES]\n",
  "KITEBOARD": "a board similar to a windsurfing board, towed by a kite [n -S]\n",
  "KITEBOARDS": "KITEBOARD, a board similar to a windsurfing board, towed by a kite [n]\n",
  "KITED": "KITE, to obtain money fraudulently [v]\n",
  "KITELIKE": "like a light covered frame flown in the wind [adj]\n",
  "KITENGE": "(Swahili) a cotton cloth worn as a dress in East Africa [n -S]\n",
  "KITENGES": "KITENGE, (Swahili) a cotton cloth worn as a dress in East Africa [n]\n",
  "KITER": "one that kites, obtains money fraudulently [n -S]\n",
  "KITERS": "KITER, one that kites, obtains money fraudulently [n]\n",
  "KITES": "KITE, to obtain money fraudulently [v]\n",
  "KITESURFER": "one who engages in kitesurfing [n -S]\n",
  "KITESURFERS": "KITESURFER, one who engages in kitesurfing [n]\n",
  "KITESURFING": "the sport of surfing while towed by a kite [n -S]\n",
  "KITESURFINGS": "KITESURFING, the sport of surfing while towed by a kite [n]\n",
  "KITH": "one's friends and neighbours [n -S]\n",
  "KITHARA": "(Greek) an ancient Greek musical instrument like a lyre, also CITHARA [n -S]\n",
  "KITHARAS": "KITHARA, (Greek) an ancient Greek musical instrument like a lyre, also CITHARA [n]\n",
  "KITHE": "to make known, also KYTHE [v KITHED, KITHING, KITHES]\n",
  "KITHED": "KITHE, to make known, also KYTHE [v]\n",
  "KITHES": "KITHE, to make known, also KYTHE [v]\n",
  "KITHING": "KITHE, to make known, also KYTHE [v]\n",
  "KITHS": "KITH, one's friends and neighbours [n]\n",
  "KITING": "kite-flying [n -S]\n",
  "KITINGS": "KITING, kite-flying [n]\n",
  "KITLING": "a young animal [n -S]\n",
  "KITLINGS": "KITLING, a young animal [n]\n",
  "KITS": "KIT, to equip, fit out [v]\n",
  "KITSCH": "(German) faddish art or literature [n -ES]\n",
  "KITSCHES": "KITSCH, (German) faddish art or literature [n]\n",
  "KITSCHIER": "KITSCHY, having the quality of kitsch, trashy [adj]\n",
  "KITSCHIEST": "KITSCHY, having the quality of kitsch, trashy [adj]\n",
  "KITSCHIFIED": "KITSCHIFY, to make kitsch [v]\n",
  "KITSCHIFIES": "KITSCHIFY, to make kitsch [v]\n",
  "KITSCHIFY": "to make kitsch [v KITSCHIFIED, KITSCHIFYING, KITSCHIFIES]\n",
  "KITSCHIFYING": "KITSCHIFY, to make kitsch [v]\n",
  "KITSCHILY": "KITSCHY, having the quality of kitsch, trashy [adv]\n",
  "KITSCHNESS": "the state of being kitsch [n -ES]\n",
  "KITSCHNESSES": "KITSCHNESS, the state of being kitsch [n]\n",
  "KITSCHY": "having the quality of kitsch, trashy [adj KITSCHIER, KITSCHIEST, KITSCHILY]\n",
  "KITSET": "in New Zealand, a self-assembly furniture kit [n -S]\n",
  "KITSETS": "KITSET, in New Zealand, a self-assembly furniture kit [n]\n",
  "KITTED": "KIT, to equip, fit out [v]\n",
  "KITTEL": "(Yiddish) a white robe used in Jewish ceremonies [n -S]\n",
  "KITTELS": "KITTEL, (Yiddish) a white robe used in Jewish ceremonies [n]\n",
  "KITTEN": "to bear young cats [v -ED, -ING, -S]\n",
  "KITTENED": "KITTEN, to bear young cats [v]\n",
  "KITTENIER": "KITTENY, like a kitten [adj]\n",
  "KITTENIEST": "KITTENY, like a kitten [adj]\n",
  "KITTENING": "KITTEN, to bear young cats [v]\n",
  "KITTENISH": "of or like a kitten [adj KITTENISHLY]\n",
  "KITTENISHLY": "KITTENISH, of or like a kitten [adv]\n",
  "KITTENISHNESS": "KITTENISH, of or like a kitten [n]\n",
  "KITTENISHNESSES": "KITTENISHNESS, KITTENISH, of or like a kitten [n]\n",
  "KITTENS": "KITTEN, to bear young cats [v]\n",
  "KITTENY": "like a kitten [adj KITTENIER, KITTENIEST]\n",
  "KITTIES": "KITTY, a kitten [n]\n",
  "KITTING": "KIT, to equip, fit out [v]\n",
  "KITTIWAKE": "a kind of gull, white, with black tips to the wings, and has but three toes [n -S]\n",
  "KITTIWAKES": "KITTIWAKE, a kind of gull, white, with black tips to the wings, and has but three toes [n]\n",
  "KITTLE": "(Scots) ticklish, delicate [adj KITTLER, KITTLEST] / to offend [v KITTLED, KITTLING, KITTLES]\n",
  "KITTLED": "KITTLE, to offend [v]\n",
  "KITTLER": "KITTLE, (Scots) ticklish, delicate [adj]\n",
  "KITTLES": "KITTLE, to offend [v]\n",
  "KITTLEST": "KITTLE, (Scots) ticklish, delicate [adj]\n",
  "KITTLIER": "KITTLY, (Scots) ticklish, delicate [adj]\n",
  "KITTLIEST": "KITTLY, (Scots) ticklish, delicate [adj]\n",
  "KITTLING": "KITTLE, to offend [v]\n",
  "KITTLY": "(Scots) ticklish, delicate [adj KITTLIER, KITTLIEST]\n",
  "KITTUL": "(Sinhalese) the jaggery palm; a fibre obtained from the leafstalks of this, used for making ropes, brushes, etc., also KITUL [n -S]\n",
  "KITTULS": "KITTUL, (Sinhalese) the jaggery palm; a fibre obtained from the leafstalks of this, used for making ropes, brushes, etc., also KITUL [n]\n",
  "KITTY": "a kitten [n KITTIES]\n",
  "KITUL": "(Sinhalese) the jaggery palm; a fibre obtained from the leafstalks of this, used for making ropes, brushes, etc., also KITTUL [n -S]\n",
  "KITULS": "KITUL, (Sinhalese) the jaggery palm; a fibre obtained from the leafstalks of this, used for making ropes, brushes, etc., also KITTUL [n]\n",
  "KIVA": "(Native American) an underground chamber used in religious rites by Pueblo Indians [n -S]\n",
  "KIVAS": "KIVA, (Native American) an underground chamber used in religious rites by Pueblo Indians [n]\n",
  "KIWI": "(Maori) a flightless New Zealand bird, aka apteryx [n -S]\n",
  "KIWIFRUIT": "the edible green fruit of the Chinese gooseberry [n -S]\n",
  "KIWIFRUITS": "KIWIFRUIT, the edible green fruit of the Chinese gooseberry [n]\n",
  "KIWIS": "KIWI, (Maori) a flightless New Zealand bird, aka apteryx [n]\n",
  "KIWISPORTS": "outdoor sports associated with New Zealand [n]\n",
  "KLANG": "(German) a complex tone, composed of fundamental and harmonics [n -S]\n",
  "KLANGFARBE": "(German) tone-colour; timbre [n -S]\n",
  "KLANGFARBES": "KLANGFARBE, (German) tone-colour; timbre [n]\n",
  "KLANGS": "KLANG, (German) a complex tone, composed of fundamental and harmonics [n]\n",
  "KLAP": "(South African) to slap [v KLAPPED, KLAPPING, KLAPS]\n",
  "KLAPPED": "KLAP, (South African) to slap [v]\n",
  "KLAPPING": "KLAP, (South African) to slap [v]\n",
  "KLAPS": "KLAP, (South African) to slap [v]\n",
  "KLATCH": "(German) in North America, a coffee party or other social function, also KLATSCH, KAFFEEKLATSCH [n -ES]\n",
  "KLATCHES": "KLATCH, (German) in North America, a coffee party or other social function, also KLATSCH, KAFFEEKLATSCH [n]\n",
  "KLATSCH": "(German) in North America, a coffee party or other social function, also KLATCH, KAFFEEKLATSCH [n -ES]\n",
  "KLATSCHES": "KLATSCH, (German) in North America, a coffee party or other social function, also KLATCH, KAFFEEKLATSCH [n]\n",
  "KLAVERN": "a local branch of the Ku Klux Klan [n -S]\n",
  "KLAVERNS": "KLAVERN, a local branch of the Ku Klux Klan [n]\n",
  "KLAVIER": "(German) an early keyboard instrument, also CLAVIER [n -S]\n",
  "KLAVIERS": "KLAVIER, (German) an early keyboard instrument, also CLAVIER [n]\n",
  "KLAXON": "a loud mechanical horn, also CLAXON [n -S] / to sound a klaxon [v -ED, -ING, -S]\n",
  "KLAXONED": "KLAXON, to sound a klaxon [v]\n",
  "KLAXONING": "KLAXON, to sound a klaxon [v]\n",
  "KLAXONS": "KLAXON, to sound a klaxon [v]\n",
  "KLEAGLE": "an official in the Ku Klux Klan [n -S]\n",
  "KLEAGLES": "KLEAGLE, an official in the Ku Klux Klan [n]\n",
  "KLEBSIELLA": "a genus of gram-negative rodlike bacteria [n -S]\n",
  "KLEBSIELLAS": "KLEBSIELLA, a genus of gram-negative rodlike bacteria [n]\n",
  "KLEENEX": "(tradename) a kind of soft paper tissue, used esp. as a handkerchief [n -ES]\n",
  "KLEENEXES": "KLEENEX, (tradename) a kind of soft paper tissue, used esp. as a handkerchief [n]\n",
  "KLEFTIKO": "(Modern Greek) a Greek dish of slowly cooked lamb [n -S]\n",
  "KLEFTIKOS": "KLEFTIKO, (Modern Greek) a Greek dish of slowly cooked lamb [n]\n",
  "KLEINHUISIE": "(South African) an outside lavatory [n -S]\n",
  "KLEINHUISIES": "KLEINHUISIE, (South African) an outside lavatory [n]\n",
  "KLENDUSIC": "of a plant, able to withstand disease due to some protective mechanism [adj]\n",
  "KLENDUSITIES": "KLENDUSITY, of a plant, the ability to withstand disease due to some protective mechanism [n]\n",
  "KLENDUSITY": "of a plant, the ability to withstand disease due to some protective mechanism [n KLENDUSITIES]\n",
  "KLEPHT": "(Modern Greek) a Greek brigand or guerrilla [n -S]\n",
  "KLEPHTIC": "(Modern Greek) of or like a klepht, a Greek brigand [adj]\n",
  "KLEPHTISM": "being a klepht, a Greek brigand [n -S]\n",
  "KLEPHTISMS": "KLEPHTISM, being a klepht, a Greek brigand [n]\n",
  "KLEPHTS": "KLEPHT, (Modern Greek) a Greek brigand or guerrilla [n]\n",
  "KLEPTO": "(short for) kleptomaniac, one that steals impulsively [n -S]\n",
  "KLEPTOCRACIES": "KLEPTOCRACY, a government by the corrupt in which rulers use their official positions for personal gain [n]\n",
  "KLEPTOCRACY": "a government by the corrupt in which rulers use their official positions for personal gain [n KLEPTOCRACIES]\n",
  "KLEPTOCRATIC": "of or like a kleptocracy, a government characterized by rampant greed and corruption [adj]\n",
  "KLEPTOMANIA": "an obsessive urge to steal, driven by emotional disturbance rather than material need, also CLEPTOMANIA [n -S]\n",
  "KLEPTOMANIAC": "a person having an obsessive urge to steal, also CLEPTOMANIAC, KLEPTO [n -S]\n",
  "KLEPTOMANIACS": "KLEPTOMANIAC, a person having an obsessive urge to steal, also CLEPTOMANIAC, KLEPTO [n]\n",
  "KLEPTOMANIAS": "KLEPTOMANIA, an obsessive urge to steal, driven by emotional disturbance rather than material need, also CLEPTOMANIA [n]\n",
  "KLEPTOS": "KLEPTO, (short for) kleptomaniac, one that steals impulsively [n]\n",
  "KLETT": "a lightweight climbing boot, also KLETTERSCHUH [n -S]\n",
  "KLETTERSCHUH": "a lightweight climbing boot with a canvas or suede upper and Vibram, also KLETT [n KLETTERSCHUHE]\n",
  "KLETTERSCHUHE": "KLETTERSCHUH, a lightweight climbing boot with a canvas or suede upper and Vibram, also KLETT [n]\n",
  "KLETTS": "KLETT, a lightweight climbing boot, also KLETTERSCHUH [n]\n",
  "KLEZMER": "(Yiddish) a style of music, part Jewish, part big-band [n KLEZMORIM or KLEZMERS]\n",
  "KLEZMERS": "KLEZMER, (Yiddish) a style of music, part Jewish, part big-band [n]\n",
  "KLEZMORIM": "KLEZMER, (Yiddish) a style of music, part Jewish, part big-band [n]\n",
  "KLICK": "(colloquial) a kilometre, also KLIK [n -S]\n",
  "KLICKS": "KLICK, (colloquial) a kilometre, also KLIK [n]\n",
  "KLIEG": "a kind of electric lamp used in filming [n -S]\n",
  "KLIEGS": "KLIEG, a kind of electric lamp used in filming [n]\n",
  "KLIK": "(colloquial) a kilometer, also KLICK [n -S]\n",
  "KLIKS": "KLIK, (colloquial) a kilometer, also KLICK [n]\n",
  "KLINKER": "(Dutch) a very hard paving brick, also CLINKER [n -S]\n",
  "KLINKERS": "KLINKER, (Dutch) a very hard paving brick, also CLINKER [n]\n",
  "KLINOSTAT": "a revolving stand for experimenting with growing plants [n -S]\n",
  "KLINOSTATS": "KLINOSTAT, a revolving stand for experimenting with growing plants [n]\n",
  "KLIPDAS": "(South African) the Cape hyrax, an African mammal, like a woodchuck but more closely related to ungulates [n -ES]\n",
  "KLIPDASES": "KLIPDAS, (South African) the Cape hyrax, an African mammal, like a woodchuck but more closely related to ungulates [n]\n",
  "KLIPSPRINGER": "(South African) a small, hoofed African antelope [n -S]\n",
  "KLIPSPRINGERS": "KLIPSPRINGER, (South African) a small, hoofed African antelope [n]\n",
  "KLISTER": "(Norwegian) a kind of wax for skis [n -S]\n",
  "KLISTERS": "KLISTER, (Norwegian) a kind of wax for skis [n]\n",
  "KLONDIKE": "to export (fish, esp. mackerel or herring) while fresh, frequently to a foreign factory ship, also KLONDYKE [v KLONDIKED, KLONDIKING, KLONDIKES]\n",
  "KLONDIKED": "KLONDIKE, to export (fish, esp. mackerel or herring) while fresh, frequently to a foreign factory ship, also KLONDYKE [v]\n",
  "KLONDIKER": "a factory-ship, also KLONDYKER [n -S]\n",
  "KLONDIKERS": "KLONDIKER, a factory-ship, also KLONDYKER [n]\n",
  "KLONDIKES": "KLONDIKE, to export (fish, esp. mackerel or herring) while fresh, frequently to a foreign factory ship, also KLONDYKE [v]\n",
  "KLONDIKING": "KLONDIKE, to export (fish, esp. mackerel or herring) while fresh, frequently to a foreign factory ship, also KLONDYKE [v]\n",
  "KLONDYKE": "to export herrings, also KLONDIKE [v KLONDYKED, KLONDYKING, KLONDYKES]\n",
  "KLONDYKED": "KLONDYKE, to export herrings, also KLONDIKE [v]\n",
  "KLONDYKER": "a factory-ship, also KLONDIKER [n -S]\n",
  "KLONDYKERS": "KLONDYKER, a factory-ship, also KLONDIKER [n]\n",
  "KLONDYKES": "KLONDYKE, to export herrings, also KLONDIKE [v]\n",
  "KLONDYKING": "KLONDYKE, to export herrings, also KLONDIKE [v]\n",
  "KLONG": "(Thai) in Thailand, a canal [n -S]\n",
  "KLONGS": "KLONG, (Thai) in Thailand, a canal [n]\n",
  "KLOOCH": "(Native American) a Native American woman, wife or squaw, also KLOOCHMAN, KLOOTCH, KLOOTCHMAN [n -ES]\n",
  "KLOOCHES": "KLOOCH, (Native American) a Native American woman, wife or squaw, also KLOOCHMAN, KLOOTCH, KLOOTCHMAN [n]\n",
  "KLOOCHMAN": "(Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOTCH, KLOOTCHMAN [n KLOOCHMANS or KLOOCHMEN]\n",
  "KLOOCHMANS": "KLOOCHMAN, (Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOTCH, KLOOTCHMAN [n]\n",
  "KLOOCHMEN": "KLOOCHMAN, (Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOTCH, KLOOTCHMAN [n]\n",
  "KLOOF": "(South African) a deep ravine in South Africa [n -S]\n",
  "KLOOFS": "KLOOF, (South African) a deep ravine in South Africa [n]\n",
  "KLOOTCH": "(Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOCHMAN, KLOOTCHMAN [n -ES]\n",
  "KLOOTCHES": "KLOOTCH, (Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOCHMAN, KLOOTCHMAN [n]\n",
  "KLOOTCHMAN": "(Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOCHMAN, KLOOTCH [n KLOOTCHMANS or KLOOTCHMEN]\n",
  "KLOOTCHMANS": "KLOOTCHMAN, (Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOCHMAN, KLOOTCH [n]\n",
  "KLOOTCHMEN": "KLOOTCHMAN, (Native American) a Native American woman, wife or squaw, also KLOOCH, KLOOCHMAN, KLOOTCH [n]\n",
  "KLUDGE": "to contrive a clumsy makeshift mechanism, also KLUGE [v KLUDGED, KLUDGING, KLUDGES]\n",
  "KLUDGED": "KLUDGE, to contrive a clumsy makeshift mechanism, also KLUGE [v]\n",
  "KLUDGES": "KLUDGE, to contrive a clumsy makeshift mechanism, also KLUGE [v]\n",
  "KLUDGEY": "involving or put together with ill-fitting components, also KLUDGY [adj]\n",
  "KLUDGIER": "KLUDGY, involving or put together with ill-fitting components, also KLUDGEY [adj]\n",
  "KLUDGIEST": "KLUDGY, involving or put together with ill-fitting components, also KLUDGEY [adj]\n",
  "KLUDGING": "KLUDGE, to contrive a clumsy makeshift mechanism, also KLUGE [v]\n",
  "KLUDGY": "involving or put together with ill-fitting components, also KLUDGEY [adj KLUDGIER, KLUDGIEST]\n",
  "KLUGE": "to fix by clumsy makeshift methods, also KLUDGE [v KLUGED, KLUGING, KLUGES]\n",
  "KLUGED": "KLUGE, to fix by clumsy makeshift methods, also KLUDGE [v]\n",
  "KLUGES": "KLUGE, to fix by clumsy makeshift methods, also KLUDGE [v]\n",
  "KLUGING": "KLUGE, to fix by clumsy makeshift methods, also KLUDGE [v]\n",
  "KLUTZ": "(Yiddish) a clumsy person [n -ES]\n",
  "KLUTZES": "KLUTZ, (Yiddish) a clumsy person [n]\n",
  "KLUTZIER": "KLUTZY, clumsy [adj]\n",
  "KLUTZIEST": "KLUTZY, clumsy [adj]\n",
  "KLUTZINESS": "being like a klutz, clumsiness [n -ES]\n",
  "KLUTZINESSES": "KLUTZINESS, being like a klutz, clumsiness [n]\n",
  "KLUTZY": "clumsy [adj KLUTZIER, KLUTZIEST]\n",
  "KLYSTRON": "a type of electron tube [n -S]\n",
  "KLYSTRONS": "KLYSTRON, a type of electron tube [n]\n",
  "KNACK": "to strike sharply [v -ED, -ING, -S]\n",
  "KNACKED": "KNACK, to strike sharply [v]\n",
  "KNACKER": "to exhaust [v -ED, -ING, -S]\n",
  "KNACKERED": "KNACKER, to exhaust [v]\n",
  "KNACKERIES": "KNACKERY, a knacker's yard [n]\n",
  "KNACKERING": "KNACKER, to exhaust [v]\n",
  "KNACKERS": "KNACKER, to exhaust [v]\n",
  "KNACKERY": "a knacker's yard [n KNACKERIES]\n",
  "KNACKIER": "KNACKY, cunning, also KNACKISH [adj]\n",
  "KNACKIEST": "KNACKY, cunning, also KNACKISH [adj]\n",
  "KNACKINESS": "craftiness, cunning [n -ES]\n",
  "KNACKINESSES": "KNACKINESS, craftiness, cunning [n]\n",
  "KNACKING": "KNACK, to strike sharply [v]\n",
  "KNACKISH": "having a knack; cunning, also KNACKY [adj]\n",
  "KNACKS": "KNACK, to strike sharply [v]\n",
  "KNACKWURST": "(German) a kind of highly seasoned sausage, also KNOCKWURST [n -S]\n",
  "KNACKWURSTS": "KNACKWURST, (German) a kind of highly seasoned sausage, also KNOCKWURST [n]\n",
  "KNACKY": "cunning, also KNACKISH [adj KNACKIER, KNACKIEST]\n",
  "KNAG": "a short projection from the trunk or branch of a tree [n -S]\n",
  "KNAGGIER": "KNAGGY, of wood, knotty [adj]\n",
  "KNAGGIEST": "KNAGGY, of wood, knotty [adj]\n",
  "KNAGGINESS": "being knaggy [n -ES]\n",
  "KNAGGINESSES": "KNAGGINESS, being knaggy [n]\n",
  "KNAGGY": "of wood, knotty [adj KNAGGIER, KNAGGIEST]\n",
  "KNAGS": "KNAG, a short projection from the trunk or branch of a tree [n]\n",
  "KNAIDEL": "(Yiddish) in Jewish cooking, a dumpling, also KNEIDEL [n KNAIDLACH or KNAIDELS]\n",
  "KNAIDELS": "KNAIDEL, (Yiddish) in Jewish cooking, a dumpling, also KNEIDEL [n]\n",
  "KNAIDLACH": "KNAIDEL, (Yiddish) in Jewish cooking, a dumpling, also KNEIDEL [n]\n",
  "KNAP": "to strike sharply [v KNAPPED, KNAPPING, KNAPS]\n",
  "KNAPPED": "KNAP, to strike sharply [v]\n",
  "KNAPPER": "someone who breaks stones, esp. flint-flakes for gunflints [n -S]\n",
  "KNAPPERS": "KNAPPER, someone who breaks stones, esp. flint-flakes for gunflints [n]\n",
  "KNAPPING": "KNAP, to strike sharply [v]\n",
  "KNAPPLE": "to break off with an abrupt, sharp noise [v KNAPPLED, KNAPPLING, KNAPPLES]\n",
  "KNAPPLED": "KNAPPLE, to break off with an abrupt, sharp noise [v]\n",
  "KNAPPLES": "KNAPPLE, to break off with an abrupt, sharp noise [v]\n",
  "KNAPPLING": "KNAPPLE, to break off with an abrupt, sharp noise [v]\n",
  "KNAPS": "KNAP, to strike sharply [v]\n",
  "KNAPSACK": "a bag of canvas or other weatherproof material with shoulder-straps, carried on the back [n -S]\n",
  "KNAPSACKED": "equipped with a knapsack, a bag of canvas or other weatherproof material with shoulder-straps, carried on the back [adj]\n",
  "KNAPSACKS": "KNAPSACK, a bag of canvas or other weatherproof material with shoulder-straps, carried on the back [n]\n",
  "KNAPWEED": "any of several plants of the genus Centaurea, related to the thistles [n -S]\n",
  "KNAPWEEDS": "KNAPWEED, any of several plants of the genus Centaurea, related to the thistles [n]\n",
  "KNAR": "to snarl, also GNAR, GNARR [v KNARRED, KNARRING, KNARS]\n",
  "KNARL": "a knot in a tree, also GNARL [n -S]\n",
  "KNARLIER": "KNARLY, like a knarl, also GNARLY [adj]\n",
  "KNARLIEST": "KNARLY, like a knarl, also GNARLY [adj]\n",
  "KNARLS": "KNARL, a knot in a tree, also GNARL [n]\n",
  "KNARLY": "like a knarl, also GNARLY [adj KNARLIER, KNARLIEST]\n",
  "KNARRED": "KNAR, to snarl, also GNAR, GNARR [v]\n",
  "KNARRIER": "KNARRY, of a tree, having knots [adj]\n",
  "KNARRIEST": "KNARRY, of a tree, having knots [adj]\n",
  "KNARRING": "KNAR, to snarl, also GNAR, GNARR [v]\n",
  "KNARRY": "of a tree, having knots [adj KNARRIER, KNARRIEST]\n",
  "KNARS": "KNAR, to snarl, also GNAR, GNARR [v]\n",
  "KNAUR": "a knot in a tree, also GNARL, KNARL [n -S]\n",
  "KNAURS": "KNAUR, a knot in a tree, also GNARL, KNARL [n]\n",
  "KNAVE": "a dishonest man [n -S]\n",
  "KNAVERIES": "KNAVERY, trickery [n]\n",
  "KNAVERY": "trickery [n KNAVERIES]\n",
  "KNAVES": "KNAVE, a dishonest man [n]\n",
  "KNAVESHIP": "a small due, in meal, established by usage, which is paid to the under miller [n -S]\n",
  "KNAVESHIPS": "KNAVESHIP, a small due, in meal, established by usage, which is paid to the under miller [n]\n",
  "KNAVISH": "like a knave [adj KNAVISHLY]\n",
  "KNAVISHLY": "KNAVISH, like a knave [adv]\n",
  "KNAVISHNESS": "the quality of being knavish [n -ES]\n",
  "KNAVISHNESSES": "KNAVISHNESS, the quality of being knavish [n]\n",
  "KNAWE": "a cornfield weed of the chickweed family, also KNAWEL [n -S]\n",
  "KNAWEL": "(German) a cornfield weed of the chickweed family, also KNAWE [n -S]\n",
  "KNAWELS": "KNAWEL, (German) a cornfield weed of the chickweed family, also KNAWE [n]\n",
  "KNAWES": "KNAWE, a cornfield weed of the chickweed family, also KNAWEL [n]\n",
  "KNEAD": "to massage with the hands [v -ED, -ING, -S]\n",
  "KNEADABLE": "that may be kneaded [adj]\n",
  "KNEADED": "KNEAD, to massage with the hands [v]\n",
  "KNEADER": "one who kneads [n -S]\n",
  "KNEADERS": "KNEADER, one who kneads [n]\n",
  "KNEADING": "KNEAD, to massage with the hands [v]\n",
  "KNEADS": "KNEAD, to massage with the hands [v]\n",
  "KNEE": "to strike with a joint of the leg [v KNEED, KNEEING, KNEES]\n",
  "KNEEBOARD": "to ride a kind of short surfboard ridden in a kneeling position [v -ED, -ING, -S]\n",
  "KNEEBOARDED": "KNEEBOARD, to ride a kind of short surfboard ridden in a kneeling position [v]\n",
  "KNEEBOARDING": "KNEEBOARD, to ride a kind of short surfboard ridden in a kneeling position [v]\n",
  "KNEEBOARDS": "KNEEBOARD, to ride a kind of short surfboard ridden in a kneeling position [v]\n",
  "KNEECAP": "the kneecap [n -S] / to maim by shooting in the patella [v KNEECAPPED, KNEECAPPING, KNEECAPS]\n",
  "KNEECAPPED": "KNEECAP, to maim by shooting in the patella [v]\n",
  "KNEECAPPING": "punishment by shooting through the kneecap [n -S]\n",
  "KNEECAPPINGS": "KNEECAPPING, punishment by shooting through the kneecap [n]\n",
  "KNEECAPS": "KNEECAP, to maim by shooting in the patella [v]\n",
  "KNEED": "KNEE, to strike with a joint of the leg [v]\n",
  "KNEEHOLE": "the space beneath a desk or bureau for the knees [n -S]\n",
  "KNEEHOLES": "KNEEHOLE, the space beneath a desk or bureau for the knees [n]\n",
  "KNEEING": "KNEE, to strike with a joint of the leg [v]\n",
  "KNEEJERK": "responding in a predictable manner [adj]\n",
  "KNEEL": "to rest on the knees [v KNELT or KNEELED, KNEELING, KNEELS]\n",
  "KNEELED": "KNEEL, to rest on the knees [v]\n",
  "KNEELER": "a cushion, hassock, or low bench used for kneeling on, esp. in prayer [n -S]\n",
  "KNEELERS": "KNEELER, a cushion, hassock, or low bench used for kneeling on, esp. in prayer [n]\n",
  "KNEELIKE": "like a knee [adj]\n",
  "KNEELING": "KNEEL, to rest on the knees [v]\n",
  "KNEELS": "KNEEL, to rest on the knees [v]\n",
  "KNEEPAD": "a protective covering for the knees [n -S]\n",
  "KNEEPADS": "KNEEPAD, a protective covering for the knees [n]\n",
  "KNEEPAN": "the kneecap [n -S]\n",
  "KNEEPANS": "KNEEPAN, the kneecap [n]\n",
  "KNEEPIECE": "a knee-shaped piece of timber in a ship [n -S]\n",
  "KNEEPIECES": "KNEEPIECE, a knee-shaped piece of timber in a ship [n]\n",
  "KNEEROOM": "space to put one's knees [n -S]\n",
  "KNEEROOMS": "KNEEROOM, space to put one's knees [n]\n",
  "KNEES": "KNEE, to strike with a joint of the leg [v]\n",
  "KNEESIES": "flirtatious touching of knees under the table [n]\n",
  "KNEESOCK": "a knee-high sock [n -S]\n",
  "KNEESOCKS": "KNEESOCK, a knee-high sock [n]\n",
  "KNEIDEL": "(Yiddish) in Jewish cooking, a dumpling, also KNAIDEL [n KNEIDELS or KNEIDLACH]\n",
  "KNEIDELS": "KNEIDEL, (Yiddish) in Jewish cooking, a dumpling, also KNAIDEL [n]\n",
  "KNEIDLACH": "KNEIDEL, (Yiddish) in Jewish cooking, a dumpling, also KNAIDEL [n]\n",
  "KNELL": "to sound a bell [v -ED, -ING, -S]\n",
  "KNELLED": "KNELL, to sound a bell [v]\n",
  "KNELLING": "KNELL, to sound a bell [v]\n",
  "KNELLS": "KNELL, to sound a bell [v]\n",
  "KNELT": "KNEEL, to rest on the knees [v]\n",
  "KNESSET": "(Hebrew) the Israeli parliament [n -S]\n",
  "KNESSETS": "KNESSET, (Hebrew) the Israeli parliament [n]\n",
  "KNEVELL": "(Scots) to pound with the fists, also NEVEL [v -ED, -ING, -S]\n",
  "KNEVELLED": "KNEVELL, (Scots) to pound with the fists, also NEVEL [v]\n",
  "KNEVELLING": "KNEVELL, (Scots) to pound with the fists, also NEVEL [v]\n",
  "KNEVELLS": "KNEVELL, (Scots) to pound with the fists, also NEVEL [v]\n",
  "KNEW": "KNOW, to have a true understanding of [v]\n",
  "KNICKER": "the round seed of a tree, used for playing marbles, also NICKAR, NICKERNUT [n -S]\n",
  "KNICKERBOCKER": "a descendant of the early Dutch settlers of New York [n -S]\n",
  "KNICKERBOCKERS": "loose breeches gathered in at the knee [n]\n",
  "KNICKERED": "wearing knickers [adj]\n",
  "KNICKERS": "women's or girls' underpants; a woman's undergarment covering (and sometimes gathered in at) the thigh, also KNICKS [n]\n",
  "KNICKKNACK": "a small ornament, a gewgaw, also NICKNACK [n -S]\n",
  "KNICKKNACKS": "KNICKKNACK, a small ornament, a gewgaw, also NICKNACK [n]\n",
  "KNICKPOINT": "a break of slope in a river profile, esp. where a new curve of erosion arising from rejuvenation intersects an earlier curve, also NICKPOINT [n -S]\n",
  "KNICKPOINTS": "KNICKPOINT, a break of slope in a river profile, esp. where a new curve of erosion arising from rejuvenation intersects an earlier curve, also NICKPOINT [n]\n",
  "KNICKS": "(colloquial) knickers [n]\n",
  "KNIFE": "to stab with a knife [v KNIFED, KNIFING, KNIFES]\n",
  "KNIFED": "KNIFE, to stab with a knife [v]\n",
  "KNIFELESS": "without a knife [adj]\n",
  "KNIFELIKE": "like a knife [adj]\n",
  "KNIFEMAN": "a man armed with a knife [n KNIFEMEN]\n",
  "KNIFEMEN": "KNIFEMAN, a man armed with a knife [n]\n",
  "KNIFEPOINT": "the point of a knife [n -S]\n",
  "KNIFEPOINTS": "KNIFEPOINT, the point of a knife [n]\n",
  "KNIFER": "someone who knifes [n -S]\n",
  "KNIFEREST": "a support on which a carving knife or carving fork is placed at the table [n -S]\n",
  "KNIFERESTS": "KNIFEREST, a support on which a carving knife or carving fork is placed at the table [n]\n",
  "KNIFERS": "KNIFER, someone who knifes [n]\n",
  "KNIFES": "KNIFE, to stab with a knife [v]\n",
  "KNIFING": "the act of stabbing with a knife [n -S]\n",
  "KNIFINGS": "KNIFING, the act of stabbing with a knife [n]\n",
  "KNIGHT": "a man who has been awarded the rank immediately below baronet, with the title 'Sir' [n -S] / to confer the title of knight upon [v -ED, -ING, -S]\n",
  "KNIGHTAGE": "the body of knights, taken collectively [n -S]\n",
  "KNIGHTAGES": "KNIGHTAGE, the body of knights, taken collectively [n]\n",
  "KNIGHTED": "KNIGHT, to confer the title of knight upon [v]\n",
  "KNIGHTHEAD": "either of a pair of vertical supports for the bowsprit [n -S]\n",
  "KNIGHTHEADS": "KNIGHTHEAD, either of a pair of vertical supports for the bowsprit [n]\n",
  "KNIGHTHOOD": "the rank of a knight [n -S]\n",
  "KNIGHTHOODS": "KNIGHTHOOD, the rank of a knight [n]\n",
  "KNIGHTING": "KNIGHT, to confer the title of knight upon [v]\n",
  "KNIGHTLESS": "(Spenser) unbecoming a knight [adj]\n",
  "KNIGHTLIER": "KNIGHTLY, befitting a knight [adj]\n",
  "KNIGHTLIEST": "KNIGHTLY, befitting a knight [adj]\n",
  "KNIGHTLINESS": "the state of being knightly [n -ES]\n",
  "KNIGHTLINESSES": "KNIGHTLINESS, the state of being knightly [n]\n",
  "KNIGHTLY": "befitting a knight [adj KNIGHTLIER, KNIGHTLIEST]\n",
  "KNIGHTS": "KNIGHT, to confer the title of knight upon [v]\n",
  "KNIPHOFIA": "any plant of the Kniphofia genus, the red-hot poker [n -S]\n",
  "KNIPHOFIAS": "KNIPHOFIA, any plant of the Kniphofia genus, the red-hot poker [n]\n",
  "KNISH": "(Yiddish) in Jewish cooking, dough with potato, meat etc. baked or fried [n -ES]\n",
  "KNISHES": "KNISH, (Yiddish) in Jewish cooking, dough with potato, meat etc. baked or fried [n]\n",
  "KNIT": "to make a garment by joining loops of yarn [v KNITTED, KNITTING, KNITS]\n",
  "KNITBONE": "the plant comfrey [n -S]\n",
  "KNITBONES": "KNITBONE, the plant comfrey [n]\n",
  "KNITCH": "a bundle of wood [n -ES]\n",
  "KNITCHES": "KNITCH, a bundle of wood [n]\n",
  "KNITS": "KNIT, to make a garment by joining loops of yarn [v]\n",
  "KNITTABLE": "that can be knitted [adj]\n",
  "KNITTED": "KNIT, to make a garment by joining loops of yarn [v]\n",
  "KNITTER": "one that knits [n -S]\n",
  "KNITTERS": "KNITTER, one that knits [n]\n",
  "KNITTING": "knitted work [n -S]\n",
  "KNITTINGS": "KNITTING, knitted work [n]\n",
  "KNITTLE": "a string that draws together a purse or bag [n -S]\n",
  "KNITTLES": "KNITTLE, a string that draws together a purse or bag [n]\n",
  "KNITWEAR": "knitted clothing [n -S]\n",
  "KNITWEARS": "KNITWEAR, knitted clothing [n]\n",
  "KNIVE": "to knife [v KNIVED, KNIVING, KNIVES]\n",
  "KNIVED": "KNIVE, to knife [v]\n",
  "KNIVES": "KNIVE, to knife [v]\n",
  "KNIVING": "KNIVE, to knife [v]\n",
  "KNOB": "a rounded protuberance [n -S] / to knock off protuberances [v KNOBBED, KNOBBING, KNOBS]\n",
  "KNOBBED": "KNOB, to knock off protuberances [v]\n",
  "KNOBBER": "a stag in its second year [n -S]\n",
  "KNOBBERS": "KNOBBER, a stag in its second year [n]\n",
  "KNOBBIER": "KNOBBY, full of knobs [adj]\n",
  "KNOBBIEST": "KNOBBY, full of knobs [adj]\n",
  "KNOBBINESS": "the state of being knobby [n -ES]\n",
  "KNOBBINESSES": "KNOBBINESS, the state of being knobby [n]\n",
  "KNOBBING": "KNOB, to knock off protuberances [v]\n",
  "KNOBBLE": "to beat with the fists, also KNUBBLE, NUBBLE [v KNOBBLED, KNOBBLING, KNOBBLES]\n",
  "KNOBBLED": "KNOBBLE, to beat with the fists, also KNUBBLE, NUBBLE [v]\n",
  "KNOBBLES": "KNOBBLE, to beat with the fists, also KNUBBLE, NUBBLE [v]\n",
  "KNOBBLIER": "KNOBBLY, having very small knobs [adj]\n",
  "KNOBBLIEST": "KNOBBLY, having very small knobs [adj]\n",
  "KNOBBLING": "KNOBBLE, to beat with the fists, also KNUBBLE, NUBBLE [v]\n",
  "KNOBBLY": "having very small knobs [adj KNOBBLIER, KNOBBLIEST]\n",
  "KNOBBY": "full of knobs [adj KNOBBIER, KNOBBIEST]\n",
  "KNOBHEAD": "(vulgar slang) a stupid person [n -S]\n",
  "KNOBHEADS": "KNOBHEAD, (vulgar slang) a stupid person [n]\n",
  "KNOBKERRIE": "a short South African knobbed-head club [n -S]\n",
  "KNOBKERRIES": "KNOBKERRIE, a short South African knobbed-head club [n]\n",
  "KNOBLIKE": "like a knob [adj]\n",
  "KNOBS": "KNOB, to knock off protuberances [v]\n",
  "KNOBSTICK": "a stick with a round knob at the end, used as a club or missile by South African tribesmen [n -S]\n",
  "KNOBSTICKS": "KNOBSTICK, a stick with a round knob at the end, used as a club or missile by South African tribesmen [n]\n",
  "KNOCK": "to strike sharply [v -ED, -ING, -S]\n",
  "KNOCKABOUT": "a boisterous performance with horseplay [n -S]\n",
  "KNOCKABOUTS": "KNOCKABOUT, a boisterous performance with horseplay [n]\n",
  "KNOCKBACK": "a refusal, a setback [n -S]\n",
  "KNOCKBACKS": "KNOCKBACK, a refusal, a setback [n]\n",
  "KNOCKDOWN": "the act of knocking down, as in boxing [n -S]\n",
  "KNOCKDOWNS": "KNOCKDOWN, the act of knocking down, as in boxing [n]\n",
  "KNOCKED": "KNOCK, to strike sharply [v]\n",
  "KNOCKER": "one that knocks [n -S]\n",
  "KNOCKERS": "KNOCKER, one that knocks [n]\n",
  "KNOCKING": "the noise of something knocking [n -S]\n",
  "KNOCKINGS": "KNOCKING, the noise of something knocking [n]\n",
  "KNOCKLESS": "of an engine, bearing or fuel, producing no knocking sound [adj]\n",
  "KNOCKOFF": "a copy that sells for less than the original [n -S]\n",
  "KNOCKOFFS": "KNOCKOFF, a copy that sells for less than the original [n]\n",
  "KNOCKOUT": "a blow that induces unconsciousness [n -S]\n",
  "KNOCKOUTS": "KNOCKOUT, a blow that induces unconsciousness [n]\n",
  "KNOCKS": "KNOCK, to strike sharply [v]\n",
  "KNOCKWURST": "(German) a kind of highly seasoned sausage, also KNACKWURST [n -S]\n",
  "KNOCKWURSTS": "KNOCKWURST, (German) a kind of highly seasoned sausage, also KNACKWURST [n]\n",
  "KNOLL": "a small hill [n -S] / an obsolete form of knell, to ring a bell [v -ED, -ING, -S]\n",
  "KNOLLED": "KNOLL, an obsolete form of knell, to ring a bell [v]\n",
  "KNOLLER": "one that knolls, tolls a bell [n -S]\n",
  "KNOLLERS": "KNOLLER, one that knolls, tolls a bell [n]\n",
  "KNOLLIER": "KNOLLY, like a knoll [adj]\n",
  "KNOLLIEST": "KNOLLY, like a knoll [adj]\n",
  "KNOLLING": "KNOLL, an obsolete form of knell, to ring a bell [v]\n",
  "KNOLLS": "KNOLL, an obsolete form of knell, to ring a bell [v]\n",
  "KNOLLY": "like a knoll [adj KNOLLIER, KNOLLIEST]\n",
  "KNOP": "a loop or tuft in yarn [n -S]\n",
  "KNOPPED": "having a knop [adj]\n",
  "KNOPS": "KNOP, a loop or tuft in yarn [n]\n",
  "KNOSP": "(German) an architectural ornament in the form of a bud [n -S]\n",
  "KNOSPS": "KNOSP, (German) an architectural ornament in the form of a bud [n]\n",
  "KNOT": "to tie with a closed loop [v KNOTTED, KNOTTING, KNOTS]\n",
  "KNOTGRASS": "any of several weeds of the genus Polygonum, with wiry jointed creeping stems and small pinkish or whitish flowers in the axils of the leaves [n -ES]\n",
  "KNOTGRASSES": "KNOTGRASS, any of several weeds of the genus Polygonum, with wiry jointed creeping stems and small pinkish or whitish flowers in the axils of the leaves [n]\n",
  "KNOTHEAD": "a stupid person [n -S]\n",
  "KNOTHEADS": "KNOTHEAD, a stupid person [n]\n",
  "KNOTHOLE": "a hole in a plank [n -S]\n",
  "KNOTHOLES": "KNOTHOLE, a hole in a plank [n]\n",
  "KNOTLESS": "without a knot [adj]\n",
  "KNOTLIKE": "like a knot [adj]\n",
  "KNOTS": "KNOT, to tie with a closed loop [v]\n",
  "KNOTTED": "KNOT, to tie with a closed loop [v]\n",
  "KNOTTER": "one who knots [n -S]\n",
  "KNOTTERS": "KNOTTER, one who knots [n]\n",
  "KNOTTIER": "KNOTTY, full of knots [adj]\n",
  "KNOTTIEST": "KNOTTY, full of knots [adj]\n",
  "KNOTTILY": "KNOTTY, full of knots [adv]\n",
  "KNOTTINESS": "the state of being knotty [n -ES]\n",
  "KNOTTINESSES": "KNOTTINESS, the state of being knotty [n]\n",
  "KNOTTING": "fancywork made by knotting [n -S]\n",
  "KNOTTINGS": "KNOTTING, fancywork made by knotting [n]\n",
  "KNOTTY": "full of knots [adj KNOTTIER, KNOTTIEST, KNOTTILY]\n",
  "KNOTWEED": "a pernicious weed of waterways [n -S]\n",
  "KNOTWEEDS": "KNOTWEED, a pernicious weed of waterways [n]\n",
  "KNOTWORK": "ornamental work done with knots; carving or decoration in interlaced forms [n -S]\n",
  "KNOTWORKS": "KNOTWORK, ornamental work done with knots; carving or decoration in interlaced forms [n]\n",
  "KNOUT": "(Russian) to flog with a leather whip [v -ED, -ING, -S]\n",
  "KNOUTED": "KNOUT, (Russian) to flog with a leather whip [v]\n",
  "KNOUTING": "KNOUT, (Russian) to flog with a leather whip [v]\n",
  "KNOUTS": "KNOUT, (Russian) to flog with a leather whip [v]\n",
  "KNOW": "to have a true understanding of [v KNEW, KNOWN, KNOWING, KNOWS]\n",
  "KNOWABLE": "able to be known [adj]\n",
  "KNOWABLENESS": "the state of being knowable [n -ES]\n",
  "KNOWABLENESSES": "KNOWABLENESS, the state of being knowable [n]\n",
  "KNOWE": "a rounded hillock, also KNOLL [n -S]\n",
  "KNOWER": "one who knows [n -S]\n",
  "KNOWERS": "KNOWER, one who knows [n]\n",
  "KNOWES": "KNOWE, a rounded hillock, also KNOLL [n]\n",
  "KNOWHOW": "the faculty of knowing what to do [n -S]\n",
  "KNOWHOWS": "KNOWHOW, the faculty of knowing what to do [n]\n",
  "KNOWING": "knowledge [n -S] / astute, crafty [adj KNOWINGER, KNOWINGEST, KNOWINGLY]\n",
  "KNOWINGER": "KNOWING, astute, crafty [adj]\n",
  "KNOWINGEST": "KNOWING, astute, crafty [adj]\n",
  "KNOWINGLY": "KNOWING, astute, crafty [adv]\n",
  "KNOWINGNESS": "the state of being knowing [n -ES]\n",
  "KNOWINGNESSES": "KNOWINGNESS, the state of being knowing [n]\n",
  "KNOWINGS": "KNOWING, knowledge [n]\n",
  "KNOWLEDGABILITY": "the quality of being knowledgable [n]\n",
  "KNOWLEDGABLE": "possessing knowledge, also KNOWLEDGEABLE [adj KNOWLEDGABLY]\n",
  "KNOWLEDGABLY": "KNOWLEDGABLE, possessing knowledge, also KNOWLEDGEABLE [adv]\n",
  "KNOWLEDGE": "what is known [n -S] / (obsolete) to acknowledge [v KNOWLEDGED, KNOWLEDGING, KNOWLEDGES]\n",
  "KNOWLEDGEABLE": "possessing knowledge, also KNOWLEDGABLE [adj]\n",
  "KNOWLEDGEABLY": "KNOWLEDGEABLE, possessing knowledge, also KNOWLEDGABLE [adv]\n",
  "KNOWLEDGED": "KNOWLEDGE, (obsolete) to acknowledge [v]\n",
  "KNOWLEDGES": "KNOWLEDGE, (obsolete) to acknowledge [v]\n",
  "KNOWLEDGING": "KNOWLEDGE, (obsolete) to acknowledge [v]\n",
  "KNOWN": "a mathematical quantity whose value is given [n -S]\n",
  "KNOWNS": "KNOWN, a mathematical quantity whose value is given [n]\n",
  "KNOWS": "KNOW, to have a true understanding of [v]\n",
  "KNUB": "a small lump [n -S]\n",
  "KNUBBIER": "KNUBBY, having little lumps, also NUBBY, KNUBBLY [adj]\n",
  "KNUBBIEST": "KNUBBY, having little lumps, also NUBBY, KNUBBLY [adj]\n",
  "KNUBBLE": "to beat with the fists, also KNOBBLE, NUBBLE [v KNUBBLED, KNUBBLING, KNUBBLES]\n",
  "KNUBBLED": "KNUBBLE, to beat with the fists, also KNOBBLE, NUBBLE [v]\n",
  "KNUBBLES": "KNUBBLE, to beat with the fists, also KNOBBLE, NUBBLE [v]\n",
  "KNUBBLIER": "KNUBBLY, having little lumps, also NUBBY, KNUBBY [adj]\n",
  "KNUBBLIEST": "KNUBBLY, having little lumps, also NUBBY, KNUBBY [adj]\n",
  "KNUBBLING": "KNUBBLE, to beat with the fists, also KNOBBLE, NUBBLE [v]\n",
  "KNUBBLY": "having little lumps, also NUBBY, KNUBBY [adj KNUBBLIER, KNUBBLIEST]\n",
  "KNUBBY": "having little lumps, also NUBBY, KNUBBLY [adj KNUBBIER, KNUBBIEST]\n",
  "KNUBS": "KNUB, a small lump [n]\n",
  "KNUCKLE": "to hit with the joints of the fist [v KNUCKLED, KNUCKLING, KNUCKLES]\n",
  "KNUCKLEBALL": "a baseball pitch in which the ball is gripped with the knuckles [n -S]\n",
  "KNUCKLEBALLER": "a player who delivers knuckleballs [n -S]\n",
  "KNUCKLEBALLERS": "KNUCKLEBALLER, a player who delivers knuckleballs [n]\n",
  "KNUCKLEBALLS": "KNUCKLEBALL, a baseball pitch in which the ball is gripped with the knuckles [n]\n",
  "KNUCKLEBONE": "the bone of the knuckle [n -S]\n",
  "KNUCKLEBONES": "KNUCKLEBONE, the bone of the knuckle [n]\n",
  "KNUCKLED": "KNUCKLE, to hit with the joints of the fist [v]\n",
  "KNUCKLEDUSTER": "a metal covering for the knuckles, worn on the hand as a weapon in fist-fighting [n -S]\n",
  "KNUCKLEDUSTERS": "KNUCKLEDUSTER, a metal covering for the knuckles, worn on the hand as a weapon in fist-fighting [n]\n",
  "KNUCKLEHEAD": "a chump [n -S]\n",
  "KNUCKLEHEADED": "of or like a knucklehead, a chump [adj]\n",
  "KNUCKLEHEADS": "KNUCKLEHEAD, a chump [n]\n",
  "KNUCKLER": "a baseball pitch in which the ball is gripped with the knuckles, also KNUCKLEBALL [n -S]\n",
  "KNUCKLERS": "KNUCKLER, a baseball pitch in which the ball is gripped with the knuckles, also KNUCKLEBALL [n]\n",
  "KNUCKLES": "KNUCKLE, to hit with the joints of the fist [v]\n",
  "KNUCKLIER": "KNUCKLY, having prominent knuckles [adj]\n",
  "KNUCKLIEST": "KNUCKLY, having prominent knuckles [adj]\n",
  "KNUCKLING": "KNUCKLE, to hit with the joints of the fist [v]\n",
  "KNUCKLY": "having prominent knuckles [adj KNUCKLIER, KNUCKLIEST]\n",
  "KNUR": "a knot of wood, also KNURR, NUR, NURR [n -S]\n",
  "KNURL": "to make grooves or ridges in [v -ED, -ING, -S]\n",
  "KNURLED": "KNURL, to make grooves or ridges in [v]\n",
  "KNURLIER": "KNURLY, full of knots, gnarled [adj]\n",
  "KNURLIEST": "KNURLY, full of knots, gnarled [adj]\n",
  "KNURLING": "a moulding of ornamental knobs [n -S]\n",
  "KNURLINGS": "KNURLING, a moulding of ornamental knobs [n]\n",
  "KNURLS": "KNURL, to make grooves or ridges in [v]\n",
  "KNURLY": "full of knots, gnarled [adj KNURLIER, KNURLIEST]\n",
  "KNURR": "a knot of wood, also KNUR, NUR, NURR [n -S]\n",
  "KNURRS": "KNURR, a knot of wood, also KNUR, NUR, NURR [n]\n",
  "KNURS": "KNUR, a knot of wood, also KNURR, NUR, NURR [n]\n",
  "KNUT": "a swell, a dandy [n -S]\n",
  "KNUTS": "KNUT, a swell, a dandy [n]\n",
  "KO": "(Maori) a Maori digging-stick [n -S]\n",
  "KOA": "a Hawaiian acacia tree [n -S]\n",
  "KOALA": "(Native Australian) a small furry Australian marsupial, also KOOLAH, COALA [n -S]\n",
  "KOALAS": "KOALA, (Native Australian) a small furry Australian marsupial, also KOOLAH, COALA [n]\n",
  "KOAN": "(Japanese) a paradox meditated on by Buddhist monks [n -S]\n",
  "KOANS": "KOAN, (Japanese) a paradox meditated on by Buddhist monks [n]\n",
  "KOAP": "in Papua New Guinea, a slang word for sexual intercourse [n -S]\n",
  "KOAPS": "KOAP, in Papua New Guinea, a slang word for sexual intercourse [n]\n",
  "KOAS": "KOA, a Hawaiian acacia tree [n]\n",
  "KOB": "a reddish brown antelope [n -S]\n",
  "KOBAN": "(Japanese) an obsolete Japanese gold coin, also KOBANG, OBANG [n -S]\n",
  "KOBANG": "(Japanese) an obsolete Japanese gold coin, also KOBAN, OBANG [n -S]\n",
  "KOBANGS": "KOBANG, (Japanese) an obsolete Japanese gold coin, also KOBAN, OBANG [n]\n",
  "KOBANS": "KOBAN, (Japanese) an obsolete Japanese gold coin, also KOBANG, OBANG [n]\n",
  "KOBO": "a monetary unit of Nigeria [n -S]\n",
  "KOBOLD": "(German) a mischievous elf in German folklore, found esp. in mines [n -S]\n",
  "KOBOLDS": "KOBOLD, (German) a mischievous elf in German folklore, found esp. in mines [n]\n",
  "KOBOS": "KOBO, a monetary unit of Nigeria [n]\n",
  "KOBS": "KOB, a reddish brown antelope [n]\n",
  "KOCHIA": "any of several plants whose foliage turns dark red in summer [n -S]\n",
  "KOCHIAS": "KOCHIA, any of several plants whose foliage turns dark red in summer [n]\n",
  "KOEKOEA": "(Maori) the long-tailed cuckoo of New Zealand [n -S]\n",
  "KOEKOEAS": "KOEKOEA, (Maori) the long-tailed cuckoo of New Zealand [n]\n",
  "KOEKSISTER": "a South African doughnut [n -S]\n",
  "KOEKSISTERS": "KOEKSISTER, a South African doughnut [n]\n",
  "KOEL": "(Hindi) an Asian or Australian bird of the cuckoo family [n -S]\n",
  "KOELS": "KOEL, (Hindi) an Asian or Australian bird of the cuckoo family [n]\n",
  "KOFF": "(Dutch) a small Dutch sailing vessel [n -S]\n",
  "KOFFS": "KOFF, (Dutch) a small Dutch sailing vessel [n]\n",
  "KOFTA": "(Hindi) in India, fried balls of meat or vegetables [n -S]\n",
  "KOFTAS": "KOFTA, (Hindi) in India, fried balls of meat or vegetables [n]\n",
  "KOFTGAR": "(Urdu) a craftsman in koftgari, who inlays steel with gold [n -S]\n",
  "KOFTGARI": "(Urdu) the craft of inlaying steel with gold [n -S]\n",
  "KOFTGARIS": "KOFTGARI, (Urdu) the craft of inlaying steel with gold [n]\n",
  "KOFTGARS": "KOFTGAR, (Urdu) a craftsman in koftgari, who inlays steel with gold [n]\n",
  "KOFTWORK": "steel inlaid with gold, also KOFTGARI [n -S]\n",
  "KOFTWORKS": "KOFTWORK, steel inlaid with gold, also KOFTGARI [n]\n",
  "KOGAL": "(Japanese) a teenage girl or young woman noted for her busy social life and her purchase of expensive designer clothes and accessories and the latest electronic gadgets [n -S]\n",
  "KOGALS": "KOGAL, (Japanese) a teenage girl or young woman noted for her busy social life and her purchase of expensive designer clothes and accessories and the latest electronic gadgets [n]\n",
  "KOHA": "(Maori) a gift or donation when visiting a marae [n -S]\n",
  "KOHANIM": "KOHEN, a member of the Jewish priestly class, descended from Aaron, having certain privileges and obligations in the synagogue, also COHEN [n]\n",
  "KOHAS": "KOHA, (Maori) a gift or donation when visiting a marae [n]\n",
  "KOHEKOHE": "(Maori) a New Zealand tree with large glossy leaves and reddish flowers [n -S]\n",
  "KOHEKOHES": "KOHEKOHE, (Maori) a New Zealand tree with large glossy leaves and reddish flowers [n]\n",
  "KOHEN": "a member of the Jewish priestly class, descended from Aaron, having certain privileges and obligations in the synagogue, also COHEN [n KOHANIM]\n",
  "KOHL": "(Arabic) a black powder used as eye makeup [n -S]\n",
  "KOHLRABI": "(German) a variety of cabbage [n KOHLRABIES or KOHLRABIS]\n",
  "KOHLRABIES": "KOHLRABI, (German) a variety of cabbage [n]\n",
  "KOHLRABIS": "KOHLRABI, (German) a variety of cabbage [n]\n",
  "KOHLS": "KOHL, (Arabic) a black powder used as eye makeup [n]\n",
  "KOHUTUHUTU": "(Maori) a New Zealand shrub with tasty purple berries [n -S]\n",
  "KOHUTUHUTUS": "KOHUTUHUTU, (Maori) a New Zealand shrub with tasty purple berries [n]\n",
  "KOI": "(Japanese) a large Japanese carp [n -S]\n",
  "KOINE": "(Greek) a dialect that spreads to become common language of a region [n -S]\n",
  "KOINES": "KOINE, (Greek) a dialect that spreads to become common language of a region [n]\n",
  "KOIS": "KOI, (Japanese) a large Japanese carp [n]\n",
  "KOJI": "(Japanese) a kind of fungus which breaks down soy beans into soy sauce [n -S]\n",
  "KOJIS": "KOJI, (Japanese) a kind of fungus which breaks down soy beans into soy sauce [n]\n",
  "KOKA": "the lowest score awarded for a throw or hold in judo, worth three points [n -S]\n",
  "KOKAKO": "(Maori) a large dark grey wattled crow of New Zealand [n -S]\n",
  "KOKAKOS": "KOKAKO, (Maori) a large dark grey wattled crow of New Zealand [n]\n",
  "KOKAM": "(Marathi) an East Indian tree, also KOKUM, KOOKUM [n -S]\n",
  "KOKAMS": "KOKAM, (Marathi) an East Indian tree, also KOKUM, KOOKUM [n]\n",
  "KOKANEE": "(Native American) a small landlocked species of sockeye salmon [n -S]\n",
  "KOKANEES": "KOKANEE, (Native American) a small landlocked species of sockeye salmon [n]\n",
  "KOKAS": "KOKA, the lowest score awarded for a throw or hold in judo, worth three points [n]\n",
  "KOKER": "(Dutch) in Guyana, a sluicegate [n -S]\n",
  "KOKERS": "KOKER, (Dutch) in Guyana, a sluicegate [n]\n",
  "KOKIRI": "(Maori) the rough-skinned New Zealand triggerfish [n -S]\n",
  "KOKIRIS": "KOKIRI, (Maori) the rough-skinned New Zealand triggerfish [n]\n",
  "KOKOBEH": "of fruit, having a rough skin (literally leprosy) [adj]\n",
  "KOKOPU": "(Maori) any of several small freshwater fish of New Zealand [n -S]\n",
  "KOKOPUS": "KOKOPU, (Maori) any of several small freshwater fish of New Zealand [n]\n",
  "KOKOWAI": "(Maori) a type of clay used in decoration because of its reddish colour [n -S]\n",
  "KOKOWAIS": "KOKOWAI, (Maori) a type of clay used in decoration because of its reddish colour [n]\n",
  "KOKRA": "the wood of a tree used for making flutes [n -S]\n",
  "KOKRAS": "KOKRA, the wood of a tree used for making flutes [n]\n",
  "KOKUM": "(Marathi) an East Indian tree, also KOKAM, KOOKUM [n -S]\n",
  "KOKUMS": "KOKUM, (Marathi) an East Indian tree, also KOKAM, KOOKUM [n]\n",
  "KOLA": "a genus of West African trees producing nuts used in drugs and for flavouring soft drinks, also COLA [n -S]\n",
  "KOLACKIES": "KOLACKY, a kind of pastry, a rich, sweet bun with fruit or poppy-seed filling [n]\n",
  "KOLACKY": "a kind of pastry, a rich, sweet bun with fruit or poppy-seed filling [n KOLACKIES]\n",
  "KOLAS": "KOLA, a genus of West African trees producing nuts used in drugs and for flavouring soft drinks, also COLA [n]\n",
  "KOLBASI": "(Polish) a smoked sausage, also KIELBASA, KOLBASSI [n -S]\n",
  "KOLBASIS": "KOLBASI, (Polish) a smoked sausage, also KIELBASA, KOLBASSI [n]\n",
  "KOLBASSA": "(Polish) a smoked sausage, also KIELBASA, KOLBASI, KOLBASSI, KUBASA, KULBASA [n -S]\n",
  "KOLBASSAS": "KOLBASSA, (Polish) a smoked sausage, also KIELBASA, KOLBASI, KOLBASSI, KUBASA, KULBASA [n]\n",
  "KOLBASSI": "(Polish) a smoked sausage, also KIELBASA, KOLBASI [n -S]\n",
  "KOLBASSIS": "KOLBASSI, (Polish) a smoked sausage, also KIELBASA, KOLBASI [n]\n",
  "KOLHOZ": "(Russian) a collective farm in Russia, also KOLKHOS, KOLKHOZ, KOLKOZ [n KOLHOZES or KOLHOZY]\n",
  "KOLHOZES": "KOLHOZ, (Russian) a collective farm in Russia, also KOLKHOS, KOLKHOZ, KOLKOZ [n]\n",
  "KOLHOZY": "KOLHOZ, (Russian) a collective farm in Russia, also KOLKHOS, KOLKHOZ, KOLKOZ [n]\n",
  "KOLINSKI": "(Russian) a kind of Asian mink, also KOLINSKY [n -ES]\n",
  "KOLINSKIES": "KOLINSKY, (Russian) an Asian mink, also KOLINSKI [n]\n",
  "KOLINSKY": "(Russian) an Asian mink, also KOLINSKI [n KOLINSKIES]\n",
  "KOLKHOS": "(Russian) a collective farm in Russia, also KOLHOZ, KOLKHOZ, KOLKOZ [n KOLKHOSES or KOLKHOSY]\n",
  "KOLKHOSES": "KOLKHOS, (Russian) a collective farm in Russia, also KOLHOZ, KOLKHOZ, KOLKOZ [n]\n",
  "KOLKHOSY": "KOLKHOS, (Russian) a collective farm in Russia, also KOLHOZ, KOLKHOZ, KOLKOZ [n]\n",
  "KOLKHOZ": "(Russian) a collective farm in Russia, also KOLHOZ, KOLKHOS, KOLKOZ [n KOLKHOZES or KOLKHOZY]\n",
  "KOLKHOZES": "KOLKHOZ, (Russian) a collective farm in Russia, also KOLHOZ, KOLKHOS, KOLKOZ [n]\n",
  "KOLKHOZNIK": "one who works on a kolkhoz [n -S]\n",
  "KOLKHOZNIKI": "KOLKHOZNIK, one who works on a kolkhoz [n]\n",
  "KOLKHOZNIKS": "KOLKHOZNIK, one who works on a kolkhoz [n]\n",
  "KOLKHOZY": "KOLKHOZ, (Russian) a collective farm in Russia, also KOLHOZ, KOLKHOS, KOLKOZ [n]\n",
  "KOLKOZ": "(Russian) a collective farm in Russia, also KOLHOZ, KOLKHOS, KOLKHOZ [n KOLKOZES or KOLKOZY]\n",
  "KOLKOZES": "KOLKOZ, (Russian) a collective farm in Russia, also KOLHOZ, KOLKHOS, KOLKHOZ [n]\n",
  "KOLKOZY": "KOLKOZ, (Russian) a collective farm in Russia, also KOLHOZ, KOLKHOS, KOLKHOZ [n]\n",
  "KOLO": "(Serbo-Croat) a Serbian folk dance [n -S]\n",
  "KOLOS": "KOLO, (Serbo-Croat) a Serbian folk dance [n]\n",
  "KOMATIK": "(Inuit) a sled with wooden runners, also COMATIK, KAMOTIK, KAMOTIQ, QAMUTIK [n -S]\n",
  "KOMATIKS": "KOMATIK, (Inuit) a sled with wooden runners, also COMATIK, KAMOTIK, KAMOTIQ, QAMUTIK [n]\n",
  "KOMBU": "(Japanese) a type of Japanese seaweed used to flavour stock, also KONBU [n -S]\n",
  "KOMBUS": "KOMBU, (Japanese) a type of Japanese seaweed used to flavour stock, also KONBU [n]\n",
  "KOMISSAR": "a Communist party official who enjoined loyalty [n -S]\n",
  "KOMISSARS": "KOMISSAR, a Communist party official who enjoined loyalty [n]\n",
  "KOMITAJI": "(Turkish) a member of the Bulgarian Revolutionary Committee in Macedonia; any Balkan guerilla, also COMITADJI [n -S]\n",
  "KOMITAJIS": "KOMITAJI, (Turkish) a member of the Bulgarian Revolutionary Committee in Macedonia; any Balkan guerilla, also COMITADJI [n]\n",
  "KOMONDOR": "(Hungarian) a large, shaggy-coated dog [n KOMONDORS or KOMONDOROCK or KOMONDOROK]\n",
  "KOMONDOROCK": "KOMONDOR, (Hungarian) a large, shaggy-coated dog [n]\n",
  "KOMONDOROK": "KOMONDOR, (Hungarian) a large, shaggy-coated dog [n]\n",
  "KOMONDORS": "KOMONDOR, (Hungarian) a large, shaggy-coated dog [n]\n",
  "KOMPROMAT": "documents, photographs, etc that may be damaging to a person's reputation, kept as a potential tool for blackmail [n -S]\n",
  "KOMPROMATS": "KOMPROMAT, documents, photographs, etc that may be damaging to a person's reputation, kept as a potential tool for blackmail [n]\n",
  "KON": "(Spenser) to know, also CON, CONNE [v KOND, KONNING, KONS]\n",
  "KONAKI": "(Maori) in New Zealand, a farm vehicle with runners at the front and wheels at the rear, also KONEKE [n -S]\n",
  "KONAKIS": "KONAKI, (Maori) in New Zealand, a farm vehicle with runners at the front and wheels at the rear, also KONEKE [n]\n",
  "KONBU": "(Japanese) a type of Japanese seaweed used to flavour stock, also KOMBU [n -S]\n",
  "KONBUS": "KONBU, (Japanese) a type of Japanese seaweed used to flavour stock, also KOMBU [n]\n",
  "KOND": "KON, (Spenser) to know, also CON, CONNE [v]\n",
  "KONDO": "in Uganda, a thief or armed robber [n -S]\n",
  "KONDOS": "KONDO, in Uganda, a thief or armed robber [n]\n",
  "KONEKE": "(Maori) in New Zealand, a farm vehicle with runners at the front and wheels at the rear, also KONAKI [n -S]\n",
  "KONEKES": "KONEKE, (Maori) in New Zealand, a farm vehicle with runners at the front and wheels at the rear, also KONAKI [n]\n",
  "KONFYT": "(South African) a preserve of fruit, in syrup or candied [n -S]\n",
  "KONFYTS": "KONFYT, (South African) a preserve of fruit, in syrup or candied [n]\n",
  "KONGONI": "(Swahili) an East African hartebeest [n KONGONI]\n",
  "KONIMETER": "an instrument for measuring the amount of dust in the air, also KONISCOPE [n -S]\n",
  "KONIMETERS": "KONIMETER, an instrument for measuring the amount of dust in the air, also KONISCOPE [n]\n",
  "KONINI": "(Maori) the edible dark purple berry of the kotukutuku or tree fuchsia [n -S]\n",
  "KONINIS": "KONINI, (Maori) the edible dark purple berry of the kotukutuku or tree fuchsia [n]\n",
  "KONIOLOGIES": "KONIOLOGY, the study of atmospheric pollutants and dust, also CONIOLOGY [n]\n",
  "KONIOLOGY": "the study of atmospheric pollutants and dust, also CONIOLOGY [n KONIOLOGIES]\n",
  "KONISCOPE": "an instrument for measuring the amount of dust in the air, also KONIMETER [n -S]\n",
  "KONISCOPES": "KONISCOPE, an instrument for measuring the amount of dust in the air, also KONIMETER [n]\n",
  "KONK": "to hit on the head, also CONK [v -ED, -ING, -S]\n",
  "KONKED": "KONK, to hit on the head, also CONK [v]\n",
  "KONKING": "KONK, to hit on the head, also CONK [v]\n",
  "KONKS": "KONK, to hit on the head, also CONK [v]\n",
  "KONNING": "KON, (Spenser) to know, also CON, CONNE [v]\n",
  "KONS": "KON, (Spenser) to know, also CON, CONNE [v]\n",
  "KOODOO": "(Hottentot) a kind of antelope with long spiral horns, also KUDU [n -S]\n",
  "KOODOOS": "KOODOO, (Hottentot) a kind of antelope with long spiral horns, also KUDU [n]\n",
  "KOOK": "to dart in and out of sight [v -ED, -ING, -S]\n",
  "KOOKABURRA": "(Native Australian) a large Australian kingfisher, with a call sounds like a raucous laugh, also GOBURRA [n -S]\n",
  "KOOKABURRAS": "KOOKABURRA, (Native Australian) a large Australian kingfisher, with a call sounds like a raucous laugh, also GOBURRA [n]\n",
  "KOOKED": "KOOK, to dart in and out of sight [v]\n",
  "KOOKIE": "with the qualities of a kook, also KOOKY [adj KOOKIER, KOOKIEST]\n",
  "KOOKIER": "KOOKY, eccentric [adj]\n",
  "KOOKIEST": "KOOKY, eccentric [adj]\n",
  "KOOKILY": "KOOKY, eccentric [adv]\n",
  "KOOKINESS": "the state of being kooky [n -ES]\n",
  "KOOKINESSES": "KOOKINESS, the state of being kooky [n]\n",
  "KOOKING": "KOOK, to dart in and out of sight [v]\n",
  "KOOKS": "KOOK, to dart in and out of sight [v]\n",
  "KOOKUM": "(Marathi) an East Indian tree, also KOKAM, KOKUM [n -S]\n",
  "KOOKUMS": "KOOKUM, (Marathi) an East Indian tree, also KOKAM, KOKUM [n]\n",
  "KOOKY": "eccentric [adj KOOKIER, KOOKIEST, KOOKILY]\n",
  "KOOLAH": "(Native Australian) a small furry Australian marsupial, also KOALA, COALA [n -S]\n",
  "KOOLAHS": "KOOLAH, (Native Australian) a small furry Australian marsupial, also KOALA, COALA [n]\n",
  "KOORI": "(Native Australian) a young Aborigine girl [n KOORIS or KOORIES]\n",
  "KOORIES": "KOORI, (Native Australian) a young Aborigine girl [n]\n",
  "KOORIS": "KOORI, (Native Australian) a young Aborigine girl [n]\n",
  "KOP": "(South African) a hill [n -S]\n",
  "KOPASETIC": "(US colloquial) sound, adequate, excellent, also COPACETIC, COPASETIC, COPESETIC, COPESETTIC [adj]\n",
  "KOPECK": "(Russian) a Russian monetary unit, the hundredth part of a rouble, also COPECK, KOPEK [n -S]\n",
  "KOPECKS": "KOPECK, (Russian) a Russian monetary unit, the hundredth part of a rouble, also COPECK, KOPEK [n]\n",
  "KOPEK": "(Russian) a Russian monetary unit, the hundredth part of a rouble, also COPECK, KOPECK [n -S]\n",
  "KOPEKS": "KOPEK, (Russian) a Russian monetary unit, the hundredth part of a rouble, also COPECK, KOPECK [n]\n",
  "KOPH": "(Hebrew) the nineteenth letter of the Hebrew alphabet, also QOPH [n -S]\n",
  "KOPHS": "KOPH, (Hebrew) the nineteenth letter of the Hebrew alphabet, also QOPH [n]\n",
  "KOPIYKA": "a monetary unit of Ukraine, worth a hundredth part of a hryvna [n KOPIYKAS, KOPIYOK, KOPIYKY]\n",
  "KOPIYKAS": "KOPIYKA, a monetary unit of Ukraine, worth a hundredth part of a hryvna [n]\n",
  "KOPIYKY": "KOPIYKA, a monetary unit of Ukraine, worth a hundredth part of a hryvna [n]\n",
  "KOPIYOK": "KOPIYKA, a monetary unit of Ukraine, worth a hundredth part of a hryvna [n]\n",
  "KOPJE": "(South African) a low hill, also KOPPIE [n -S]\n",
  "KOPJES": "KOPJE, (South African) a low hill, also KOPPIE [n]\n",
  "KOPPA": "(Greek) a Greek letter [n -S]\n",
  "KOPPAS": "KOPPA, (Greek) a Greek letter [n]\n",
  "KOPPIE": "(South African) a low hill, also KOPJE [n -S]\n",
  "KOPPIES": "KOPPIE, (South African) a low hill, also KOPJE [n]\n",
  "KOPS": "KOP, (South African) a hill [n]\n",
  "KOR": "a Hebrew unit of measure [n -S]\n",
  "KORA": "an African musical instrument like the harp [n -S]\n",
  "KORAI": "KORE, (Greek) an ancient Greek statue of a young woman [n]\n",
  "KORARI": "(Maori) a native New Zealand flax plant, aka claddie [n -S]\n",
  "KORARIS": "KORARI, (Maori) a native New Zealand flax plant, aka claddie [n]\n",
  "KORAS": "KORA, an African musical instrument like the harp [n]\n",
  "KORAT": "(Thai) a cat with a silver-blue coat [n -S]\n",
  "KORATS": "KORAT, (Thai) a cat with a silver-blue coat [n]\n",
  "KORE": "(Greek) an ancient Greek statue of a young woman [n KORES or KORAI]\n",
  "KORERO": "(Maori) to talk, converse [v -ED, -ING, -S]\n",
  "KOREROED": "KORERO, (Maori) to talk, converse [v]\n",
  "KOREROING": "KORERO, (Maori) to talk, converse [v]\n",
  "KOREROS": "KORERO, (Maori) to talk, converse [v]\n",
  "KORES": "KORE, (Greek) an ancient Greek statue of a young woman [n]\n",
  "KORFBALL": "(Dutch) a basketball-like game played between two teams of six men and six women each [n -S]\n",
  "KORFBALLS": "KORFBALL, (Dutch) a basketball-like game played between two teams of six men and six women each [n]\n",
  "KORIMAKO": "(Maori) the bellbird of New Zealand [n -S]\n",
  "KORIMAKOS": "KORIMAKO, (Maori) the bellbird of New Zealand [n]\n",
  "KORKIR": "(Gaelic) a lichen used for dyeing red or purple, also CORKIR [n -S]\n",
  "KORKIRS": "KORKIR, (Gaelic) a lichen used for dyeing red or purple, also CORKIR [n]\n",
  "KORMA": "(Hindi) a mild curry, also QORMA [n -S]\n",
  "KORMAS": "KORMA, (Hindi) a mild curry, also QORMA [n]\n",
  "KORO": "(Maori) an elderly Maori man [n -S]\n",
  "KOROMIKO": "(Maori) a flowering New Zealand shrub [n -S]\n",
  "KOROMIKOS": "KOROMIKO, (Maori) a flowering New Zealand shrub [n]\n",
  "KORORA": "(Maori) the fairy penguin or little blue penguin [n -S]\n",
  "KORORAS": "KORORA, (Maori) the fairy penguin or little blue penguin [n]\n",
  "KOROS": "KORO, (Maori) an elderly Maori man [n]\n",
  "KOROWAI": "(Maori) a decorative woven cloak worn by a Maori chief [n -S]\n",
  "KOROWAIS": "KOROWAI, (Maori) a decorative woven cloak worn by a Maori chief [n]\n",
  "KORS": "KOR, a Hebrew unit of measure [n]\n",
  "KORU": "(Maori) a stylized curved pattern used esp. in carving [n -S]\n",
  "KORUN": "KORUNA, (Czech) a Czech monetary unit [n]\n",
  "KORUNA": "(Czech) a Czech monetary unit [n KORUN, KORUNAS or KORUNY]\n",
  "KORUNAS": "KORUNA, (Czech) a Czech monetary unit [n]\n",
  "KORUNY": "KORUNA, (Czech) a Czech monetary unit [n]\n",
  "KORUS": "KORU, (Maori) a stylized curved pattern used esp. in carving [n]\n",
  "KOS": "a measure of distance in India, also COSS, KOSS [n KOSES or KOSSES]\n",
  "KOSES": "KOS, a measure of distance in India, also COSS, KOSS [n]\n",
  "KOSHER": "(Hebrew) to prepare food according to Jewish dietary law, also KASHER [v -ED, -ING, -S]\n",
  "KOSHERED": "KOSHER, (Hebrew) to prepare food according to Jewish dietary law, also KASHER [v]\n",
  "KOSHERING": "KOSHER, (Hebrew) to prepare food according to Jewish dietary law, also KASHER [v]\n",
  "KOSHERS": "KOSHER, (Hebrew) to prepare food according to Jewish dietary law, also KASHER [v]\n",
  "KOSMOS": "(Greek) the universe as an orderly system, also COSMOS [n -ES]\n",
  "KOSMOSES": "KOSMOS, (Greek) the universe as an orderly system, also COSMOS [n]\n",
  "KOSS": "(Hindi) a measure of distance in India, also COSS, KOS [n -ES]\n",
  "KOSSES": "KOS, a measure of distance in India, also COSS, KOSS [n]\n",
  "KOTAHITANGA": "(Maori) unity or solidarity [n -S]\n",
  "KOTAHITANGAS": "KOTAHITANGA, (Maori) unity or solidarity [n]\n",
  "KOTARE": "(Maori) a small greenish-blue kingfisher found in New Zealand [n -S]\n",
  "KOTARES": "KOTARE, (Maori) a small greenish-blue kingfisher found in New Zealand [n]\n",
  "KOTCH": "(South African) to vomit [v -ED, -ING, -ES]\n",
  "KOTCHED": "KOTCH, (South African) to vomit [v]\n",
  "KOTCHES": "KOTCH, (South African) to vomit [v]\n",
  "KOTCHING": "KOTCH, (South African) to vomit [v]\n",
  "KOTO": "(Japanese) a Japanese musical instrument [n -S]\n",
  "KOTOS": "KOTO, (Japanese) a Japanese musical instrument [n]\n",
  "KOTOW": "(Chinese) to grovel, also KOWTOW [v -ED, -ING, -S]\n",
  "KOTOWED": "KOTOW, (Chinese) to grovel, also KOWTOW [v]\n",
  "KOTOWER": "one who kotows, also KOWTOWER [n -S]\n",
  "KOTOWERS": "KOTOWER, one who kotows, also KOWTOWER [n]\n",
  "KOTOWING": "KOTOW, (Chinese) to grovel, also KOWTOW [v]\n",
  "KOTOWS": "KOTOW, (Chinese) to grovel, also KOWTOW [v]\n",
  "KOTTABOS": "(Greek) an ancient Greek game of throwing wine into a vessel, also COTTABUS [n -ES]\n",
  "KOTTABOSES": "KOTTABOS, (Greek) an ancient Greek game of throwing wine into a vessel, also COTTABUS [n]\n",
  "KOTUKU": "(Maori) a kind of heron with brilliant white plumage, black legs, yellow eyes and bill [n -S]\n",
  "KOTUKUS": "KOTUKU, (Maori) a kind of heron with brilliant white plumage, black legs, yellow eyes and bill [n]\n",
  "KOTUKUTUKU": "(Maori) a New Zealand shrub with tasty purple berries, aka tree fuchsia [n -S]\n",
  "KOTUKUTUKUS": "KOTUKUTUKU, (Maori) a New Zealand shrub with tasty purple berries, aka tree fuchsia [n]\n",
  "KOTWAL": "(Hindi) the chief constable of an Indian town, also COTWAL [n -S]\n",
  "KOTWALS": "KOTWAL, (Hindi) the chief constable of an Indian town, also COTWAL [n]\n",
  "KOULAN": "a wild ass inhabiting the plains of Central Asia, aka onager, also KULAN [n -S]\n",
  "KOULANS": "KOULAN, a wild ass inhabiting the plains of Central Asia, aka onager, also KULAN [n]\n",
  "KOULIBIACA": "(Russian) a Russian fish pie, also COULIBIAC, COULIBIACA [n -S]\n",
  "KOULIBIACAS": "KOULIBIACA, (Russian) a Russian fish pie, also COULIBIAC, COULIBIACA [n]\n",
  "KOUMIS": "(Russian) a beverage made from camel's milk, also KOUMISS, KOUMYS, KOUMYSS, KUMIS, KUMISS, KUMYS [n -ES]\n",
  "KOUMISES": "KOUMIS, (Russian) a beverage made from camel's milk, also KOUMISS, KOUMYS, KOUMYSS, KUMIS, KUMISS, KUMYS [n]\n",
  "KOUMISS": "(Russian) a beverage made from camel's milk, also KOUMIS, KOUMYS, KOUMYSS, KUMIS, KUMISS, KUMYS [n -ES]\n",
  "KOUMISSES": "KOUMISS, (Russian) a beverage made from camel's milk, also KOUMIS, KOUMYS, KOUMYSS, KUMIS, KUMISS, KUMYS [n]\n",
  "KOUMYS": "(Russian) a beverage made from camel's milk, also KOUMIS, KOUMISS, KOUMYSS, KUMIS, KUMISS, KUMYS [n -ES]\n",
  "KOUMYSES": "KOUMYS, (Russian) a beverage made from camel's milk, also KOUMIS, KOUMISS, KOUMYSS, KUMIS, KUMISS, KUMYS [n]\n",
  "KOUMYSS": "(Russian) a beverage made from camel's milk, also KOUMIS, KOUMISS, KOUMYS, KUMIS, KUMISS, KUMYS [n -ES]\n",
  "KOUMYSSES": "KOUMYSS, (Russian) a beverage made from camel's milk, also KOUMIS, KOUMISS, KOUMYS, KUMIS, KUMISS, KUMYS [n]\n",
  "KOUPREY": "(Khmer) an Indo-Chinese wild cow [n -S]\n",
  "KOUPREYS": "KOUPREY, (Khmer) an Indo-Chinese wild cow [n]\n",
  "KOURA": "(Maori) a New Zealand freshwater crayfish [n -S]\n",
  "KOURAS": "KOURA, (Maori) a New Zealand freshwater crayfish [n]\n",
  "KOURBASH": "(Arabic) to whip with a hide whip, also KURBASH [v -ED, -ING, -ES]\n",
  "KOURBASHED": "KOURBASH, (Arabic) to whip with a hide whip, also KURBASH [v]\n",
  "KOURBASHES": "KOURBASH, (Arabic) to whip with a hide whip, also KURBASH [v]\n",
  "KOURBASHING": "KOURBASH, (Arabic) to whip with a hide whip, also KURBASH [v]\n",
  "KOUROI": "KOUROS, (Greek) an ancient Greek statue of a nude boy [n]\n",
  "KOUROS": "(Greek) an ancient Greek statue of a nude boy [n KOUROI]\n",
  "KOUSKOUS": "the grain of the African millet, also COUSCOUS, COUSCOUSOU, KHUSKHUS [n -ES]\n",
  "KOUSKOUSES": "KOUSKOUS, the grain of the African millet, also COUSCOUS, COUSCOUSOU, KHUSKHUS [n]\n",
  "KOUSSO": "(Amharic) an Ethiopian tree, also CUSSO, KUSSO [n -S]\n",
  "KOUSSOS": "KOUSSO, (Amharic) an Ethiopian tree, also CUSSO, KUSSO [n]\n",
  "KOW": "a branch of twigs [n -S]\n",
  "KOWHAI": "(Maori) a New Zealand tree with golden flowers [n -S]\n",
  "KOWHAIS": "KOWHAI, (Maori) a New Zealand tree with golden flowers [n]\n",
  "KOWHAIWHAI": "(Maori) a type of pattern in Maori decorative art [n -S]\n",
  "KOWHAIWHAIS": "KOWHAIWHAI, (Maori) a type of pattern in Maori decorative art [n]\n",
  "KOWS": "KOW, a branch of twigs [n]\n",
  "KOWTOW": "(Chinese) the prostration made by mandarins and others to their superiors, either as homage or worship, by knocking the forehead on the ground [n -S] / to perform a kowtow, also KOTOW [v -ED, -ING, -S]\n",
  "KOWTOWED": "KOWTOW, to perform a kowtow, also KOTOW [v]\n",
  "KOWTOWER": "one who kowtows, also KOTOWER [n -S]\n",
  "KOWTOWERS": "KOWTOWER, one who kowtows, also KOTOWER [n]\n",
  "KOWTOWING": "KOWTOW, to perform a kowtow, also KOTOW [v]\n",
  "KOWTOWS": "KOWTOW, to perform a kowtow, also KOTOW [v]\n",
  "KRAAL": "(South African) a village of huts surrounded by a fence [n -S] / to pen, also CRAAL [v -ED, -ING, -S]\n",
  "KRAALED": "KRAAL, to pen, also CRAAL [v]\n",
  "KRAALING": "KRAAL, to pen, also CRAAL [v]\n",
  "KRAALS": "KRAAL, to pen, also CRAAL [v]\n",
  "KRAB": "(short for) a karabiner, a steel link used in mountaineering [n -S]\n",
  "KRABS": "KRAB, (short for) a karabiner, a steel link used in mountaineering [n]\n",
  "KRAFT": "(German) a type of strong brown wrapping paper [n -S]\n",
  "KRAFTS": "KRAFT, (German) a type of strong brown wrapping paper [n]\n",
  "KRAI": "(Russian) an administrative district in Russia [n -S]\n",
  "KRAIS": "KRAI, (Russian) an administrative district in Russia [n]\n",
  "KRAIT": "(Hindi) a venomous snake of India, also KARAIT [n -S]\n",
  "KRAITS": "KRAIT, (Hindi) a venomous snake of India, also KARAIT [n]\n",
  "KRAKEN": "(Norwegian) a legendary sea monster [n -S]\n",
  "KRAKENS": "KRAKEN, (Norwegian) a legendary sea monster [n]\n",
  "KRAKOWIAK": "(Polish) a lively Polish dance, also CRACOVIENNE [n -S]\n",
  "KRAKOWIAKS": "KRAKOWIAK, (Polish) a lively Polish dance, also CRACOVIENNE [n]\n",
  "KRAMERIA": "a genus of spreading shrubs with many stems [n -S]\n",
  "KRAMERIAS": "KRAMERIA, a genus of spreading shrubs with many stems [n]\n",
  "KRANG": "(Dutch) the carcass of a whale after the blubber has been removed, also KRENG [n -S]\n",
  "KRANGS": "KRANG, (Dutch) the carcass of a whale after the blubber has been removed, also KRENG [n]\n",
  "KRANS": "(South African) a crown of rock on a mountaintop, also KRANTZ, KRANZ [n -ES]\n",
  "KRANSES": "KRANS, (South African) a crown of rock on a mountaintop, also KRANTZ, KRANZ [n]\n",
  "KRANTZ": "(South African) a crown of rock on a mountaintop, also KRANS, KRANZ [n -ES]\n",
  "KRANTZES": "KRANTZ, (South African) a crown of rock on a mountaintop, also KRANS, KRANZ [n]\n",
  "KRANZ": "(South African) a crown of rock on a mountaintop, also KRANS, KRANTZ [n -ES]\n",
  "KRANZES": "KRANZ, (South African) a crown of rock on a mountaintop, also KRANS, KRANTZ [n]\n",
  "KRATER": "(Greek) a large two-handled bowl for mixing wine [n -S]\n",
  "KRATERS": "KRATER, (Greek) a large two-handled bowl for mixing wine [n]\n",
  "KRAUT": "(short for) sauerkraut, a dish of cabbage [n -S]\n",
  "KRAUTROCK": "a name applied to experimental German rock music of the late 1960s and 1970s, characterized by repetitive rhythms and the use of electronic instruments [n -S]\n",
  "KRAUTROCKS": "KRAUTROCK, a name applied to experimental German rock music of the late 1960s and 1970s, characterized by repetitive rhythms and the use of electronic instruments [n]\n",
  "KRAUTS": "KRAUT, (short for) sauerkraut, a dish of cabbage [n]\n",
  "KRAY": "(Russian) an administrative district in Russia, also KRAI [n -S]\n",
  "KRAYS": "KRAY, (Russian) an administrative district in Russia, also KRAI [n]\n",
  "KREASOTE": "to treat with a wood preservative, also CREOSOTE, KREOSOTE [v KREASOTED, KREASOTING, KREASOTES]\n",
  "KREASOTED": "KREASOTE, to treat with a wood preservative, also CREOSOTE, KREOSOTE [v]\n",
  "KREASOTES": "KREASOTE, to treat with a wood preservative, also CREOSOTE, KREOSOTE [v]\n",
  "KREASOTING": "KREASOTE, to treat with a wood preservative, also CREOSOTE, KREOSOTE [v]\n",
  "KREATINE": "a chemical found within vertebrate muscle, also CREATIN, CREATINE [n -S]\n",
  "KREATINES": "KREATINE, a chemical found within vertebrate muscle, also CREATIN, CREATINE [n]\n",
  "KREEP": "a basaltic lunar rock [n -S]\n",
  "KREEPS": "KREEP, a basaltic lunar rock [n]\n",
  "KREESE": "(Malay) a dagger or short sword used by the Malays, commonly having a serpentine blade [n -S] / to stab with a kreese, also CREESE, CRIS, KRIS [v KREESED, KREESING, KREESES]\n",
  "KREESED": "KREESE, to stab with a kreese, also CREESE, CRIS, KRIS [v]\n",
  "KREESES": "KREESE, to stab with a kreese, also CREESE, CRIS, KRIS [v]\n",
  "KREESING": "KREESE, to stab with a kreese, also CREESE, CRIS, KRIS [v]\n",
  "KREMLIN": "(Russian) a Russian citadel [n -S]\n",
  "KREMLINOLOGIES": "KREMLINOLOGY, the study of the policies and practices of the former Soviet government [n]\n",
  "KREMLINOLOGIST": "one who studies kremlinology [n -S]\n",
  "KREMLINOLOGISTS": "KREMLINOLOGIST, one who studies kremlinology [n]\n",
  "KREMLINOLOGY": "the study of the policies and practices of the former Soviet government [n KREMLINOLOGIES]\n",
  "KREMLINS": "KREMLIN, (Russian) a Russian citadel [n]\n",
  "KRENG": "(Dutch) the carcass of a whale after the blubber has been removed, also KRANG [n -S]\n",
  "KRENGS": "KRENG, (Dutch) the carcass of a whale after the blubber has been removed, also KRANG [n]\n",
  "KREOSOTE": "a pitch-like substance used to coat fences etc. [n -S] / to coat with kreosote, also CREASOTE, CREOSOTE, KREASOTE [v KREOSOTED, KREOSOTING, KREOSOTES]\n",
  "KREOSOTED": "KREOSOTE, to coat with kreosote, also CREASOTE, CREOSOTE, KREASOTE [v]\n",
  "KREOSOTES": "KREOSOTE, to coat with kreosote, also CREASOTE, CREOSOTE, KREASOTE [v]\n",
  "KREOSOTING": "KREOSOTE, to coat with kreosote, also CREASOTE, CREOSOTE, KREASOTE [v]\n",
  "KREPLACH": "(Yiddish) small dough dumplings usually served in soup, also KREPLECH [n]\n",
  "KREPLECH": "(Yiddish) small dough dumplings usually served in soup, also KREPLACH [n]\n",
  "KREUTZER": "(German) a small copper coin formerly used in South Germany, also CREUTZER, KREUZER [n -S]\n",
  "KREUTZERS": "KREUTZER, (German) a small copper coin formerly used in South Germany, also CREUTZER, KREUZER [n]\n",
  "KREUZER": "(German) a small copper coin formerly used in South Germany, also CREUTZER, KREUTZER [n -S]\n",
  "KREUZERS": "KREUZER, (German) a small copper coin formerly used in South Germany, also CREUTZER, KREUTZER [n]\n",
  "KREWE": "a private group participating in the New Orleans Mardi Gras [n -S]\n",
  "KREWES": "KREWE, a private group participating in the New Orleans Mardi Gras [n]\n",
  "KRIEGSPIEL": "(German) a game in which miniature characters and blocks represent armies, ships, etc. as they move around on a drawing of a battlefield, used to simulate war, also KRIEGSSPIEL [n -S]\n",
  "KRIEGSPIELS": "KRIEGSPIEL, (German) a game in which miniature characters and blocks represent armies, ships, etc. as they move around on a drawing of a battlefield, used to simulate war, also KRIEGSSPIEL [n]\n",
  "KRIEGSSPIEL": "(German) a war game played on a map to train officers; a form of chess in which the players use separate boards and are allowed only limited communication through an umpire, also KRIEGSPIEL [n -S]\n",
  "KRIEGSSPIELS": "KRIEGSSPIEL, (German) a war game played on a map to train officers; a form of chess in which the players use separate boards and are allowed only limited communication through an umpire, also KRIEGSPIEL [n]\n",
  "KRILL": "a species of shrimplike creatures [n -S]\n",
  "KRILLS": "KRILL, a species of shrimplike creatures [n]\n",
  "KRIMMER": "(German) tightly curled grey or black lamb's wool, also CRIMMER [n -S]\n",
  "KRIMMERS": "KRIMMER, (German) tightly curled grey or black lamb's wool, also CRIMMER [n]\n",
  "KRIS": "(Malay) to stab with a Malay dagger, also CRIS, CREESE, KREESE [v -ED, -ING, -ES]\n",
  "KRISED": "KRIS, (Malay) to stab with a Malay dagger, also CRIS, CREESE, KREESE [v]\n",
  "KRISES": "KRIS, (Malay) to stab with a Malay dagger, also CRIS, CREESE, KREESE [v]\n",
  "KRISING": "KRIS, (Malay) to stab with a Malay dagger, also CRIS, CREESE, KREESE [v]\n",
  "KROMESKIES": "KROMESKY, (Polish) a Polish fried croquette wrapped in bacon [n]\n",
  "KROMESKY": "(Polish) a Polish fried croquette wrapped in bacon [n KROMESKIES]\n",
  "KRONA": "(Swedish) a monetary unit of Sweden [n KRONOR or KRONUR] / a monetary unit of Iceland [n KRONOR or KRONUR]\n",
  "KRONE": "(Norwegian) a former monetary unit of Austria [n KRONEN or KRONER] / a monetary unit of Denmark [n KRONEN or KRONER]\n",
  "KRONEN": "KRONE, (Norwegian) a former monetary unit of Austria [n]\n",
  "KRONER": "KRONE, (Norwegian) a former monetary unit of Austria [n]\n",
  "KRONOR": "KRONA, (Swedish) a monetary unit of Sweden [n]\n",
  "KRONUR": "KRONA, (Swedish) a monetary unit of Sweden [n]\n",
  "KROON": "a former monetary unit of Estonia [n KROONS or KROONI]\n",
  "KROONI": "KROON, a former monetary unit of Estonia [n]\n",
  "KROONS": "KROON, a former monetary unit of Estonia [n]\n",
  "KRUBI": "a malodorous tropical plant, also KRUBUT [n -S]\n",
  "KRUBIS": "KRUBI, a malodorous tropical plant, also KRUBUT [n]\n",
  "KRUBUT": "a malodorous tropical plant, also KRUBI [n -S]\n",
  "KRUBUTS": "KRUBUT, a malodorous tropical plant, also KRUBI [n]\n",
  "KRUGERRAND": "a South African coin, used for investment, containing one troy ounce of fine gold [n -S]\n",
  "KRUGERRANDS": "KRUGERRAND, a South African coin, used for investment, containing one troy ounce of fine gold [n]\n",
  "KRULLER": "(Dutch) in North America, a type of sweet cake fried in fat, also CRULLER [n -S]\n",
  "KRULLERS": "KRULLER, (Dutch) in North America, a type of sweet cake fried in fat, also CRULLER [n]\n",
  "KRUMHORN": "(German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CROMORNE, CRUMHORN, KRUMMHORN [n -S]\n",
  "KRUMHORNS": "KRUMHORN, (German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CROMORNE, CRUMHORN, KRUMMHORN [n]\n",
  "KRUMKAKE": "(Swedish) a kind of Scandinavian biscuit [n -S]\n",
  "KRUMKAKES": "KRUMKAKE, (Swedish) a kind of Scandinavian biscuit [n]\n",
  "KRUMMHOLZ": "(German) stunted forest typical of the timberline [n KRUMMHOLZ]\n",
  "KRUMMHORN": "(German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CROMORNE, CRUMHORN, KRUMHORN [n -S]\n",
  "KRUMMHORNS": "KRUMMHORN, (German) an ancient double-reed wind instrument, also CREMONA, CREMORNE, CROMORNA, CROMORNE, CRUMHORN, KRUMHORN [n]\n",
  "KRUMPER": "one who does krumping, a kind of dance [n -S]\n",
  "KRUMPERS": "KRUMPER, one who does krumping, a kind of dance [n]\n",
  "KRUMPING": "a type of dancing in which participants, often wearing face paint, dance with one another in a fast and aggressive style mimicking a fight but without any physical contact [n -S]\n",
  "KRUMPINGS": "KRUMPING, a type of dancing in which participants, often wearing face paint, dance with one another in a fast and aggressive style mimicking a fight but without any physical contact [n]\n",
  "KRUNK": "a form of hip-hop music originating in the southern states of the US, also CRUNK [n -S]\n",
  "KRUNKED": "in a state of excitement or exhilaration, also CRUNKED [adj]\n",
  "KRUNKS": "KRUNK, a form of hip-hop music originating in the southern states of the US, also CRUNK [n]\n",
  "KRYOLITE": "a mineral, also CRYOLITE, KRYOLITH [n -S]\n",
  "KRYOLITES": "KRYOLITE, a mineral, also CRYOLITE, KRYOLITH [n]\n",
  "KRYOLITH": "an aluminum ore, also CRYOLITE, KRYOLITE [n -S]\n",
  "KRYOLITHS": "KRYOLITH, an aluminum ore, also CRYOLITE, KRYOLITE [n]\n",
  "KRYOMETER": "an instrument for measuring low temperatures, also CRYOMETER [n -S]\n",
  "KRYOMETERS": "KRYOMETER, an instrument for measuring low temperatures, also CRYOMETER [n]\n",
  "KRYPSES": "KRYPSIS, (Greek) a doctrine that Christ concealed his divine powers [n]\n",
  "KRYPSIS": "(Greek) a doctrine that Christ concealed his divine powers [n KRYPSES]\n",
  "KRYPTON": "(Greek) an element, an inert gas, also CRYPTON [n -S]\n",
  "KRYPTONITE": "something that renders a person or thing helpless [n -S]\n",
  "KRYPTONITES": "KRYPTONITE, something that renders a person or thing helpless [n]\n",
  "KRYPTONS": "KRYPTON, (Greek) an element, an inert gas, also CRYPTON [n]\n",
  "KRYTRON": "an electronic timing device used for detonating nuclear and other explosive charges [n -S]\n",
  "KRYTRONS": "KRYTRON, an electronic timing device used for detonating nuclear and other explosive charges [n]\n",
  "KSAR": "(Milton) a tsar [n -S]\n",
  "KSARS": "KSAR, (Milton) a tsar [n]\n",
  "KUBASA": "(Russian) a Ukrainian sausage, also KIELBASA, KOLBASI, KOLBASSA, KOLBASSI, KULBASA [n -S]\n",
  "KUBASAS": "KUBASA, (Russian) a Ukrainian sausage, also KIELBASA, KOLBASI, KOLBASSA, KOLBASSI, KULBASA [n]\n",
  "KUBIE": "a kubasa on a bun [n -S]\n",
  "KUBIES": "KUBIE, a kubasa on a bun [n]\n",
  "KUCCHA": "the short trousers traditionally worn by Sikhs, also KACCHA [n -S]\n",
  "KUCCHAS": "KUCCHA, the short trousers traditionally worn by Sikhs, also KACCHA [n]\n",
  "KUCHCHA": "(Hindi) made of dried mud, makeshift, also CUTCHA, KACHA, KACHCHA, KUTCHA [adj]\n",
  "KUCHEN": "(German) a yeast-raised coffee cake [n -S]\n",
  "KUCHENS": "KUCHEN, (German) a yeast-raised coffee cake [n]\n",
  "KUDLIK": "(Inuit) a soapstone seal-oil lamp, also QULLIQ [n -S]\n",
  "KUDLIKS": "KUDLIK, (Inuit) a soapstone seal-oil lamp, also QULLIQ [n]\n",
  "KUDO": "honour, also KUDOS [n -S]\n",
  "KUDOS": "(Greek) honour, also KUDO [n -ES]\n",
  "KUDOSES": "KUDOS, (Greek) honour, also KUDO [n]\n",
  "KUDU": "(Hottentot) a kind of antelope with long spiral horns, also KOODOO [n -S]\n",
  "KUDUS": "KUDU, (Hottentot) a kind of antelope with long spiral horns, also KOODOO [n]\n",
  "KUDZU": "(Japanese) an ornamental papilionaceous plant of China and Japan [n -S]\n",
  "KUDZUS": "KUDZU, (Japanese) an ornamental papilionaceous plant of China and Japan [n]\n",
  "KUE": "the letter Q [n -S]\n",
  "KUEH": "(Malay) a Malaysian, Indian or Chinese cake [n KUEH]\n",
  "KUES": "KUE, the letter Q [n]\n",
  "KUFI": "a close-fitting brimless cylindrical or round hat worn by Muslim men [n -S]\n",
  "KUFIS": "KUFI, a close-fitting brimless cylindrical or round hat worn by Muslim men [n]\n",
  "KUFIYAH": "(Arabic) an Arab headdress, also KAFFIYAH, KAFFIYEH, KEFFIYAH, KEFFIYEH [n -S]\n",
  "KUFIYAHS": "KUFIYAH, (Arabic) an Arab headdress, also KAFFIYAH, KAFFIYEH, KEFFIYAH, KEFFIYEH [n]\n",
  "KUGEL": "(Yiddish) a casserole, usually of potatoes or noodles [n -S]\n",
  "KUGELS": "KUGEL, (Yiddish) a casserole, usually of potatoes or noodles [n]\n",
  "KUIA": "(Maori) an elderly Maori woman [n -S]\n",
  "KUIAS": "KUIA, (Maori) an elderly Maori woman [n]\n",
  "KUKRI": "(Hindi) a sharp, curved Gurkha knife [n -S]\n",
  "KUKRIS": "KUKRI, (Hindi) a sharp, curved Gurkha knife [n]\n",
  "KUKU": "(Maori) a large fruit-eating pigeon of New Zealand, aka kereru [n -S]\n",
  "KUKUS": "KUKU, (Maori) a large fruit-eating pigeon of New Zealand, aka kereru [n]\n",
  "KULA": "ceremonial gift exchange between W Pacific islands [n -S]\n",
  "KULAK": "(Russian) a rich peasant [n KULAKS or KULAKI]\n",
  "KULAKI": "KULAK, (Russian) a rich peasant [n]\n",
  "KULAKS": "KULAK, (Russian) a rich peasant [n]\n",
  "KULAN": "a wild ass inhabiting the plains of Central Asia, aka onager, also KOULAN [n -S]\n",
  "KULANS": "KULAN, a wild ass inhabiting the plains of Central Asia, aka onager, also KOULAN [n]\n",
  "KULAS": "KULA, ceremonial gift exchange between W Pacific islands [n]\n",
  "KULBASA": "a traditional garlic sausage of Eastern European origin, also KIELBASA, KOLBASI, KOLBASSA, KOLBASSI, KUBASA [n -S]\n",
  "KULBASAS": "KULBASA, a traditional garlic sausage of Eastern European origin, also KIELBASA, KOLBASI, KOLBASSA, KOLBASSI, KUBASA [n]\n",
  "KULFI": "(Hindi) an Indian dessert made by freezing milk which has been concentrated by boiling away some of the water in it, and flavoured with nuts and cardamom seeds [n -S]\n",
  "KULFIS": "KULFI, (Hindi) an Indian dessert made by freezing milk which has been concentrated by boiling away some of the water in it, and flavoured with nuts and cardamom seeds [n]\n",
  "KULTUR": "(German) culture, civilisation [n -S]\n",
  "KULTURS": "KULTUR, (German) culture, civilisation [n]\n",
  "KUMARA": "(Maori) the sweet potato, also KUMERA [n -S]\n",
  "KUMARAHOU": "(Maori) a New Zealand shrub [n -S]\n",
  "KUMARAHOUS": "KUMARAHOU, (Maori) a New Zealand shrub [n]\n",
  "KUMARAS": "KUMARA, (Maori) the sweet potato, also KUMERA [n]\n",
  "KUMARI": "(Hindi) in India, the title of Miss [n -S]\n",
  "KUMARIS": "KUMARI, (Hindi) in India, the title of Miss [n]\n",
  "KUMBALOI": "(Modern Greek) worry beads [n]\n",
  "KUMERA": "(Maori) the sweet potato, also KUMARA [n -S]\n",
  "KUMERAS": "KUMERA, (Maori) the sweet potato, also KUMARA [n]\n",
  "KUMIKUMI": "(Maori) a kind of marrow found in New Zealand, also KAMOKAMO [n -S]\n",
  "KUMIKUMIS": "KUMIKUMI, (Maori) a kind of marrow found in New Zealand, also KAMOKAMO [n]\n",
  "KUMIS": "(Russian) an intoxicating fermented or distilled liquor originally made by the Tartars from mare's or camel's milk, also KOUMIS, KOUMISS, KOUMYS, KOUMYSS, KUMISS, KUMYS [n -ES]\n",
  "KUMISES": "KUMIS, (Russian) an intoxicating fermented or distilled liquor originally made by the Tartars from mare's or camel's milk, also KOUMIS, KOUMISS, KOUMYS, KOUMYSS, KUMISS, KUMYS [n]\n",
  "KUMISS": "(Russian) a beverage made from camel's milk, also KOUMIS, KOUMISS, KOUMYS, KOUMYSS, KUMYS [n -ES]\n",
  "KUMISSES": "KUMISS, (Russian) a beverage made from camel's milk, also KOUMIS, KOUMISS, KOUMYS, KOUMYSS, KUMYS [n]\n",
  "KUMITE": "(Japanese) freestyle martial arts fighting or sparring [n -S]\n",
  "KUMITES": "KUMITE, (Japanese) freestyle martial arts fighting or sparring [n]\n",
  "KUMKUM": "(Hindi) a red powder used by Hindu women as a cosmetic [n -S]\n",
  "KUMKUMS": "KUMKUM, (Hindi) a red powder used by Hindu women as a cosmetic [n]\n",
  "KUMMEL": "(German) a cumin-flavoured liqueur [n -S]\n",
  "KUMMELS": "KUMMEL, (German) a cumin-flavoured liqueur [n]\n",
  "KUMMERBUND": "(Hindi) a waistband, a sash, also CUMBERBUND, CUMMERBUND [n -S]\n",
  "KUMMERBUNDS": "KUMMERBUND, (Hindi) a waistband, a sash, also CUMBERBUND, CUMMERBUND [n]\n",
  "KUMQUAT": "(Chinese) any of several small yellow to orange citrus fruits with sweet spongy rind and somewhat acid pulp that are used chiefly for preserves, also CUMQUAT [n -S]\n",
  "KUMQUATS": "KUMQUAT, (Chinese) any of several small yellow to orange citrus fruits with sweet spongy rind and somewhat acid pulp that are used chiefly for preserves, also CUMQUAT [n]\n",
  "KUMYS": "(Russian) an intoxicating fermented or distilled liquor originally made by the Tartars from mare's or camel's milk, also KOUMIS, KOUMISS, KOUMYS, KOUMYSS, KUMIS, KUMISS [n -ES]\n",
  "KUMYSES": "KUMYS, (Russian) an intoxicating fermented or distilled liquor originally made by the Tartars from mare's or camel's milk, also KOUMIS, KOUMISS, KOUMYS, KOUMYSS, KUMIS, KUMISS [n]\n",
  "KUNA": "the standard monetary unit of Croatia, divided into 100 lipa [n KUNE]\n",
  "KUNDALINI": "(Sanskrit) in yoga, spiritual energy that lies dormant at base of spine until the brain is enlightened [n -S]\n",
  "KUNDALINIS": "KUNDALINI, (Sanskrit) in yoga, spiritual energy that lies dormant at base of spine until the brain is enlightened [n]\n",
  "KUNE": "KUNA, the standard monetary unit of Croatia, divided into 100 lipa [n]\n",
  "KUNEKUNE": "(Maori) a feral pig native to New Zealand [n -S]\n",
  "KUNEKUNES": "KUNEKUNE, (Maori) a feral pig native to New Zealand [n]\n",
  "KUNJOOS": "(Hinglish) mean or stingy [adj]\n",
  "KUNKAR": "(Hindi) a limestone found in India, also KUNKUR [n -S]\n",
  "KUNKARS": "KUNKAR, (Hindi) a limestone found in India, also KUNKUR [n]\n",
  "KUNKUR": "(Hindi) a limestone found in India, also KUNKAR [n -S]\n",
  "KUNKURS": "KUNKUR, (Hindi) a limestone found in India, also KUNKAR [n]\n",
  "KUNZITE": "a lilac variety of spodumene, used as a gemstone [n -S]\n",
  "KUNZITES": "KUNZITE, a lilac variety of spodumene, used as a gemstone [n]\n",
  "KURBASH": "(Arabic) to flog with a leather whip, also KOURBASH [v -ED, -ING, -ES]\n",
  "KURBASHED": "KURBASH, (Arabic) to flog with a leather whip, also KOURBASH [v]\n",
  "KURBASHES": "KURBASH, (Arabic) to flog with a leather whip, also KOURBASH [v]\n",
  "KURBASHING": "KURBASH, (Arabic) to flog with a leather whip, also KOURBASH [v]\n",
  "KURCHATOVIUM": "a former name for rutherfordium, an artificially produced radioactive transuranic element [n -S]\n",
  "KURCHATOVIUMS": "KURCHATOVIUM, a former name for rutherfordium, an artificially produced radioactive transuranic element [n]\n",
  "KURDAITCHA": "(Native Australian) in certain Central Australian aboriginal tribes, a man with the mission of avenging the death of a tribesman, also KADAITCHA [n -S]\n",
  "KURDAITCHAS": "KURDAITCHA, (Native Australian) in certain Central Australian aboriginal tribes, a man with the mission of avenging the death of a tribesman, also KADAITCHA [n]\n",
  "KURFUFFLE": "to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE [v KURFUFFLED, KURFUFFLING, KURFUFFLES]\n",
  "KURFUFFLED": "KURFUFFLE, to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE [v]\n",
  "KURFUFFLES": "KURFUFFLE, to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE [v]\n",
  "KURFUFFLING": "KURFUFFLE, to make a commotion, also CARFUFFLE, CURFUFFLE, GEFUFFLE, KEFUFFLE, KERFUFFLE [v]\n",
  "KURGAN": "(Russian) a prehistoric burial mound [n -S]\n",
  "KURGANS": "KURGAN, (Russian) a prehistoric burial mound [n]\n",
  "KURI": "(Maori) a mongrel, an extinct native dog, also GOORY, GOORIE [n -S]\n",
  "KURIS": "KURI, (Maori) a mongrel, an extinct native dog, also GOORY, GOORIE [n]\n",
  "KURRAJONG": "(Native Australian) an Australian evergreen, also CURRAJONG, CURREJONG, CURRIJONG [n -S]\n",
  "KURRAJONGS": "KURRAJONG, (Native Australian) an Australian evergreen, also CURRAJONG, CURREJONG, CURRIJONG [n]\n",
  "KURRE": "(Spenser) a cur [n -S]\n",
  "KURRES": "KURRE, (Spenser) a cur [n]\n",
  "KURSAAL": "(German) a public hall or room, for the use of visitors at watering places and health resorts in Germany [n -S]\n",
  "KURSAALS": "KURSAAL, (German) a public hall or room, for the use of visitors at watering places and health resorts in Germany [n]\n",
  "KURTA": "(Hindi) a loose-fitting tunic of India, also KHURTA [n -S]\n",
  "KURTAS": "KURTA, (Hindi) a loose-fitting tunic of India, also KHURTA [n]\n",
  "KURTOSES": "KURTOSIS, the sharpness of the peak of a statistical curve [n]\n",
  "KURTOSIS": "the sharpness of the peak of a statistical curve [n KURTOSISES or KURTOSES]\n",
  "KURTOSISES": "KURTOSIS, the sharpness of the peak of a statistical curve [n]\n",
  "KURU": "a disease of the nervous system, occurring in New Guinea [n -S]\n",
  "KURUS": "KURU, a disease of the nervous system, occurring in New Guinea [n]\n",
  "KURUSH": "a monetary unit of Turkey, also GIRSH, GURSH, QURSH, QURUSH [n -ES]\n",
  "KURUSHES": "KURUSH, a monetary unit of Turkey, also GIRSH, GURSH, QURSH, QURUSH [n]\n",
  "KURVEY": "(South African) to move goods by ox wagon [v -ED, -ING, -S]\n",
  "KURVEYED": "KURVEY, (South African) to move goods by ox wagon [v]\n",
  "KURVEYING": "KURVEY, (South African) to move goods by ox wagon [v]\n",
  "KURVEYOR": "(South African) a carrier [n -S]\n",
  "KURVEYORS": "KURVEYOR, (South African) a carrier [n]\n",
  "KURVEYS": "KURVEY, (South African) to move goods by ox wagon [v]\n",
  "KUSSO": "(Amharic) an Ethiopian tree, also CUSSO, KOUSSO [n -S]\n",
  "KUSSOS": "KUSSO, (Amharic) an Ethiopian tree, also CUSSO, KOUSSO [n]\n",
  "KUTA": "(Hinglish) a male dog; a man or a boy regarded as unpleasant or contemptible [n -S]\n",
  "KUTAS": "KUTA, (Hinglish) a male dog; a man or a boy regarded as unpleasant or contemptible [n]\n",
  "KUTCH": "(Malay) a resin used in tanning, also CATECHU, CACHOU, CASHOO, CUTCH [n -ES]\n",
  "KUTCHA": "(Hindi) made of dried mud, makeshift, also KACHA, KACHCHA, KUCHCHA [adj]\n",
  "KUTCHES": "KUTCH, (Malay) a resin used in tanning, also CATECHU, CACHOU, CASHOO, CUTCH [n]\n",
  "KUTI": "(Hinglish) a female dog; a woman or girl regarded as unpleasant or contemptible [n -S]\n",
  "KUTIS": "KUTI, (Hinglish) a female dog; a woman or girl regarded as unpleasant or contemptible [n]\n",
  "KUTU": "(Maori) a body louse, a cootie [n -S]\n",
  "KUTUS": "KUTU, (Maori) a body louse, a cootie [n]\n",
  "KUVASZ": "(Hungarian) an ancient breed of sheepdog with a white coat [n KUVASZOK]\n",
  "KUVASZOK": "KUVASZ, (Hungarian) an ancient breed of sheepdog with a white coat [n]\n",
  "KUZU": "(Japanese) a thickening agent used in a macrobiotic diet [n -S]\n",
  "KUZUS": "KUZU, (Japanese) a thickening agent used in a macrobiotic diet [n]\n",
  "KVAS": "(Russian) an alcoholic drink of low strength made in Russia and East Europe from cereals and stale bread, also KVASS, QUASS [n -ES]\n",
  "KVASES": "KVAS, (Russian) an alcoholic drink of low strength made in Russia and East Europe from cereals and stale bread, also KVASS, QUASS [n]\n",
  "KVASS": "(Russian) an alcoholic drink of low strength made in Russia and East Europe from cereals and stale bread, also KVAS, QUASS [n -ES]\n",
  "KVASSES": "KVASS, (Russian) an alcoholic drink of low strength made in Russia and East Europe from cereals and stale bread, also KVAS, QUASS [n]\n",
  "KVELL": "(Yiddish) to be happy [v -ED, -ING, -S]\n",
  "KVELLED": "KVELL, (Yiddish) to be happy [v]\n",
  "KVELLING": "KVELL, (Yiddish) to be happy [v]\n",
  "KVELLS": "KVELL, (Yiddish) to be happy [v]\n",
  "KVETCH": "(Yiddish) to complain habitually, to gripe [v -ED, -ING, -ES]\n",
  "KVETCHED": "KVETCH, (Yiddish) to complain habitually, to gripe [v]\n",
  "KVETCHER": "(Yiddish) a whiner, complainer [n -S]\n",
  "KVETCHERS": "KVETCHER, (Yiddish) a whiner, complainer [n]\n",
  "KVETCHES": "KVETCH, (Yiddish) to complain habitually, to gripe [v]\n",
  "KVETCHIER": "KVETCHY, (Yiddish) habitually complaining [adj]\n",
  "KVETCHIEST": "KVETCHY, (Yiddish) habitually complaining [adj]\n",
  "KVETCHILY": "KVETCHY, (Yiddish) habitually complaining [adv]\n",
  "KVETCHINESS": "the state of being kvetchy [n -ES]\n",
  "KVETCHINESSES": "KVETCHINESS, the state of being kvetchy [n]\n",
  "KVETCHING": "the act of griping, complaining [n -S]\n",
  "KVETCHINGS": "KVETCHING, the act of griping, complaining [n]\n",
  "KVETCHY": "(Yiddish) habitually complaining [adj KVETCHIER, KVETCHIEST, KVETCHILY]\n",
  "KWACHA": "(Bantu) a monetary unit of Zambia [n -S]\n",
  "KWACHAS": "KWACHA, (Bantu) a monetary unit of Zambia [n]\n",
  "KWAITO": "(South African) a type of South African pop music [n -S]\n",
  "KWAITOS": "KWAITO, (South African) a type of South African pop music [n]\n",
  "KWANZA": "(Swahili) a monetary unit of Angola [n -S]\n",
  "KWANZAS": "KWANZA, (Swahili) a monetary unit of Angola [n]\n",
  "KWASHIORKOR": "a tropical disease of infants caused by protein deficiency [n -S]\n",
  "KWASHIORKORS": "KWASHIORKOR, a tropical disease of infants caused by protein deficiency [n]\n",
  "KWELA": "(Zulu) a form of Zulu folk music [n -S]\n",
  "KWELAS": "KWELA, (Zulu) a form of Zulu folk music [n]\n",
  "KY": "cattle, also KYE [n]\n",
  "KYACK": "a packsack [n -S]\n",
  "KYACKS": "KYACK, a packsack [n]\n",
  "KYAK": "(Inuit) a type of canoe, also KAIAK, KAYAK, QAJAQ [n -S]\n",
  "KYAKS": "KYAK, (Inuit) a type of canoe, also KAIAK, KAYAK, QAJAQ [n]\n",
  "KYANG": "a Tibetan wild ass, also KIANG [n -S]\n",
  "KYANGS": "KYANG, a Tibetan wild ass, also KIANG [n]\n",
  "KYANISATION": "the process of kyanising, proofing against decay by saturating with a solution of corrosive sublimate, also KYANIZATION [n -S]\n",
  "KYANISATIONS": "KYANISATION, the process of kyanising, proofing against decay by saturating with a solution of corrosive sublimate, also KYANIZATION [n]\n",
  "KYANISE": "to treat wood with a preservative, also KYANIZE [v KYANISED, KYANISING, KYANISES]\n",
  "KYANISED": "KYANISE, to treat wood with a preservative, also KYANIZE [v]\n",
  "KYANISES": "KYANISE, to treat wood with a preservative, also KYANIZE [v]\n",
  "KYANISING": "KYANISE, to treat wood with a preservative, also KYANIZE [v]\n",
  "KYANITE": "a mineral, an aluminium silicate, generally sky-blue, also CYANITE [n -S]\n",
  "KYANITES": "KYANITE, a mineral, an aluminium silicate, generally sky-blue, also CYANITE [n]\n",
  "KYANITIC": "of or like kyanite, an aluminium silicate [adj]\n",
  "KYANIZATION": "the process of kyanizing, proofing against decay by saturating with a solution of corrosive sublimate, also KYANISATION [n -S]\n",
  "KYANIZATIONS": "KYANIZATION, the process of kyanizing, proofing against decay by saturating with a solution of corrosive sublimate, also KYANISATION [n]\n",
  "KYANIZE": "to treat wood with a preservative, also KYANISE [v KYANIZED, KYANIZING, KYANIZES]\n",
  "KYANIZED": "KYANIZE, to treat wood with a preservative, also KYANISE [v]\n",
  "KYANIZES": "KYANIZE, to treat wood with a preservative, also KYANISE [v]\n",
  "KYANIZING": "KYANIZE, to treat wood with a preservative, also KYANISE [v]\n",
  "KYAR": "a fibre obtained from coconut husks, also COIR [n -S]\n",
  "KYARS": "KYAR, a fibre obtained from coconut husks, also COIR [n]\n",
  "KYAT": "(Burmese) the standard Burmese monetary unit, equal to 100 pyas [n -S]\n",
  "KYATS": "KYAT, (Burmese) the standard Burmese monetary unit, equal to 100 pyas [n]\n",
  "KYBO": "(Australian slang) a temporary lavatory constructed for use when camping [n -S]\n",
  "KYBOS": "KYBO, (Australian slang) a temporary lavatory constructed for use when camping [n]\n",
  "KYBOSH": "to put a stop to, also KIBOSH [v -ED, -ING, -ES]\n",
  "KYBOSHED": "KYBOSH, to put a stop to, also KIBOSH [v]\n",
  "KYBOSHES": "KYBOSH, to put a stop to, also KIBOSH [v]\n",
  "KYBOSHING": "KYBOSH, to put a stop to, also KIBOSH [v]\n",
  "KYDST": "KYTHE, to make known, also KITHE [v]\n",
  "KYE": "a Korean village fund which lends for weddings, funerals etc. [n -S]\n",
  "KYES": "KYE, a Korean village fund which lends for weddings, funerals etc. [n]\n",
  "KYLE": "(Gaelic) a narrow strait [n -S]\n",
  "KYLES": "KYLE, (Gaelic) a narrow strait [n]\n",
  "KYLICES": "KYLIX, (Greek) a shallow two-handled Greek drinking cup, also CYLIX [n]\n",
  "KYLIE": "(Native Australian) (Native Australian) (Native Australian) (Native Australian) a boomerang, also KILEY [n -S]\n",
  "KYLIES": "KYLIE, (Native Australian) (Native Australian) (Native Australian) (Native Australian) a boomerang, also KILEY [n]\n",
  "KYLIKES": "KYLIX, (Greek) a shallow two-handled Greek drinking cup, also CYLIX [n]\n",
  "KYLIN": "(Chinese) a fabulous animal figured in the decoration of Chinese pottery [n -S]\n",
  "KYLINS": "KYLIN, (Chinese) a fabulous animal figured in the decoration of Chinese pottery [n]\n",
  "KYLIX": "(Greek) a shallow two-handled Greek drinking cup, also CYLIX [n KYLICES, KYLIKES or KYLIXES]\n",
  "KYLIXES": "KYLIX, (Greek) a shallow two-handled Greek drinking cup, also CYLIX [n]\n",
  "KYLLOSES": "KYLLOSIS, clubfoot [n]\n",
  "KYLLOSIS": "clubfoot [n KYLLOSES]\n",
  "KYLOE": "(Gaelic) a small longhaired breed of Hebridean cattle [n -S]\n",
  "KYLOES": "KYLOE, (Gaelic) a small longhaired breed of Hebridean cattle [n]\n",
  "KYMOGRAM": "a record made by a kymograph, an instrument for recording fluid pressure [n -S]\n",
  "KYMOGRAMS": "KYMOGRAM, a record made by a kymograph, an instrument for recording fluid pressure [n]\n",
  "KYMOGRAPH": "an instrument for recording fluid pressure [n -S]\n",
  "KYMOGRAPHIC": "relating to a kymograph [adj]\n",
  "KYMOGRAPHIES": "KYMOGRAPHY, using a kymograph, an instrument for recording fluid pressure [n]\n",
  "KYMOGRAPHS": "KYMOGRAPH, an instrument for recording fluid pressure [n]\n",
  "KYMOGRAPHY": "using a kymograph, an instrument for recording fluid pressure [n KYMOGRAPHIES]\n",
  "KYND": "(Spenser) to kind, beget, also KYNDE [v -ED, -ING, -S]\n",
  "KYNDE": "(Spenser) to beget, also KYND [v KYNDED, KYNDING, KYNDES]\n",
  "KYNDED": "KYNDE, (Spenser) to beget, also KYND [v]\n",
  "KYNDES": "KYNDE, (Spenser) to beget, also KYND [v]\n",
  "KYNDING": "KYNDE, (Spenser) to beget, also KYND [v]\n",
  "KYNDS": "KYND, (Spenser) to kind, beget, also KYNDE [v]\n",
  "KYNE": "(Spenser) kine, cattle, KINE [n]\n",
  "KYOGEN": "(Japanese) a comic interlude between Japanese plays [n -S]\n",
  "KYOGENS": "KYOGEN, (Japanese) a comic interlude between Japanese plays [n]\n",
  "KYPE": "a hook on the lower jaw of a male salmon [n -S]\n",
  "KYPES": "KYPE, a hook on the lower jaw of a male salmon [n]\n",
  "KYPHOSES": "KYPHOSIS, inward curvature of the spine [n]\n",
  "KYPHOSIS": "inward curvature of the spine [n KYPHOSES]\n",
  "KYPHOTIC": "suffering from kyphosis, humpbacked [adj]\n",
  "KYRIE": "(Greek) a religious petition for mercy [n -S]\n",
  "KYRIELLE": "(French) a string of short lines in stanzas all ending with the same word [n -S]\n",
  "KYRIELLES": "KYRIELLE, (French) a string of short lines in stanzas all ending with the same word [n]\n",
  "KYRIES": "KYRIE, (Greek) a religious petition for mercy [n]\n",
  "KYTE": "(Scots) the belly [n -S]\n",
  "KYTES": "KYTE, (Scots) the belly [n]\n",
  "KYTHE": "to make known, also KITHE [v KYTHED, KYTHING, KYDST or KYTHES]\n",
  "KYTHED": "KYTHE, to make known, also KITHE [v]\n",
  "KYTHES": "KYTHE, to make known, also KITHE [v]\n",
  "KYTHING": "KYTHE, to make known, also KITHE [v]\n",
  "KYU": "a novice grade in judo [n -S]\n",
  "KYUS": "KYU, a novice grade in judo [n]\n",
  "LA": "the sixth tone of the diatonic scale, also LAH [n -S]\n",
  "LAAGER": "(South African) to form a defensive encampment, also LAER, LAGER [v -ED, -ING, -S]\n",
  "LAAGERED": "LAAGER, (South African) to form a defensive encampment, also LAER, LAGER [v]\n",
  "LAAGERING": "LAAGER, (South African) to form a defensive encampment, also LAER, LAGER [v]\n",
  "LAAGERS": "LAAGER, (South African) to form a defensive encampment, also LAER, LAGER [v]\n",
  "LAARI": "a monetary unit of the Maldives, 1/100th of a rufiyaa, also LAREE, LARI [n -S]\n",
  "LAARIS": "LAARI, a monetary unit of the Maldives, 1/100th of a rufiyaa, also LAREE, LARI [n]\n",
  "LAB": "(short for) a laboratory [n -S]\n",
  "LABANOTATION": "a method of writing down the movements, etc., of ballet diagrammatically [n -S]\n",
  "LABANOTATIONS": "LABANOTATION, a method of writing down the movements, etc., of ballet diagrammatically [n]\n",
  "LABARA": "LABARUM, (Latin) a moral standard; an ecclesiastical banner bearing Christ's monogram [n]\n",
  "LABARUM": "(Latin) a moral standard; an ecclesiastical banner bearing Christ's monogram [n LABARA or LABARUMS]\n",
  "LABARUMS": "LABARUM, (Latin) a moral standard; an ecclesiastical banner bearing Christ's monogram [n]\n",
  "LABDA": "(Greek) the Greek letter L, also LAMBDA [n -S]\n",
  "LABDACISM": "a fault in speaking or in composition, which consists in too frequent use of the letter l, or in doubling it erroneously, also LAMBDACISM [n -S]\n",
  "LABDACISMS": "LABDACISM, a fault in speaking or in composition, which consists in too frequent use of the letter l, or in doubling it erroneously, also LAMBDACISM [n]\n",
  "LABDANUM": "(Latin) a gum resin gathered from certain Oriental species of Cistus, also LADANUM [n -S]\n",
  "LABDANUMS": "LABDANUM, (Latin) a gum resin gathered from certain Oriental species of Cistus, also LADANUM [n]\n",
  "LABDAS": "LABDA, (Greek) the Greek letter L, also LAMBDA [n]\n",
  "LABEFACTATION": "a weakening, a decay, also LABEFACTION [n -S]\n",
  "LABEFACTATIONS": "LABEFACTATION, a weakening, a decay, also LABEFACTION [n]\n",
  "LABEFACTION": "a weakening, a decay, also LABEFACTATION [n -S]\n",
  "LABEFACTIONS": "LABEFACTION, a weakening, a decay, also LABEFACTATION [n]\n",
  "LABEL": "to attach a tag to [v LABELLED or LABELED, LABELLING or LABELING, LABELS]\n",
  "LABELABLE": "that can be labeled, also LABELLABLE [adj]\n",
  "LABELED": "LABEL, to attach a tag to [v]\n",
  "LABELER": "one that labels, also LABELLER [n -S]\n",
  "LABELERS": "LABELER, one that labels, also LABELLER [n]\n",
  "LABELING": "LABEL, to attach a tag to [v]\n",
  "LABELLA": "LABELLUM, (Latin) the lower petal of an orchid [n]\n",
  "LABELLABLE": "that can be labelled, also LABELABLE [adj]\n",
  "LABELLATE": "of or like a labellum, the lower or apparently anterior petal of an orchidaceous flower [adj]\n",
  "LABELLED": "LABEL, to attach a tag to [v]\n",
  "LABELLER": "one that labels, also LABELER [n -S]\n",
  "LABELLERS": "LABELLER, one that labels, also LABELER [n]\n",
  "LABELLING": "the act of attaching a tag to [n -S]\n",
  "LABELLINGS": "LABELLING, the act of attaching a tag to [n]\n",
  "LABELLIST": "(New Zealand) one who wears only clothes with fashionable labels [n -S]\n",
  "LABELLISTS": "LABELLIST, (New Zealand) one who wears only clothes with fashionable labels [n]\n",
  "LABELLOID": "liplike [adj]\n",
  "LABELLUM": "(Latin) the lower petal of an orchid [n LABELLA]\n",
  "LABELMATE": "a singer or musician who records for the same company as another [n -S]\n",
  "LABELMATES": "LABELMATE, a singer or musician who records for the same company as another [n]\n",
  "LABELS": "LABEL, to attach a tag to [v]\n",
  "LABIA": "LABIUM, (Latin) a fold of the vulva [n]\n",
  "LABIAL": "pronounced with the lips [adj LABIALLY] / a sound pronounced with the lips [n -S]\n",
  "LABIALISATION": "the process of labialising, also LABIALIZATION [n -S]\n",
  "LABIALISATIONS": "LABIALISATION, the process of labialising, also LABIALIZATION [n]\n",
  "LABIALISE": "to pronounce with rounded lips, also LABIALIZE [v LABIALISED, LABIALISING, LABIALISES]\n",
  "LABIALISED": "LABIALISE, to pronounce with rounded lips, also LABIALIZE [v]\n",
  "LABIALISES": "LABIALISE, to pronounce with rounded lips, also LABIALIZE [v]\n",
  "LABIALISING": "LABIALISE, to pronounce with rounded lips, also LABIALIZE [v]\n",
  "LABIALISM": "the quality of being labial, also LABIALITY [n -S]\n",
  "LABIALISMS": "LABIALISM, the quality of being labial, also LABIALITY [n]\n",
  "LABIALITIES": "LABIALITY, the quality of being labial, also LABIALISM [n]\n",
  "LABIALITY": "the quality of being labial, also LABIALISM [n LABIALITIES]\n",
  "LABIALIZATION": "the process of labializing, also LABIALISATION [n -S]\n",
  "LABIALIZATIONS": "LABIALIZATION, the process of labializing, also LABIALISATION [n]\n",
  "LABIALIZE": "to pronounce with rounded lips, also LABIALISE [v LABIALIZED, LABIALIZING, LABIALIZES]\n",
  "LABIALIZED": "LABIALIZE, to pronounce with rounded lips, also LABIALISE [v]\n",
  "LABIALIZES": "LABIALIZE, to pronounce with rounded lips, also LABIALISE [v]\n",
  "LABIALIZING": "LABIALIZE, to pronounce with rounded lips, also LABIALISE [v]\n",
  "LABIALLY": "LABIAL, pronounced with the lips [adv]\n",
  "LABIALS": "LABIAL, a sound pronounced with the lips [n]\n",
  "LABIATE": "a plant with liplike parts [n -S]\n",
  "LABIATED": "having corollas that are divided into two liplike parts [adj]\n",
  "LABIATES": "LABIATE, a plant with liplike parts [n]\n",
  "LABILE": "likely to change [adj]\n",
  "LABILITIES": "LABILITY, the state of being labile, susceptible to change [n]\n",
  "LABILITY": "the state of being labile, susceptible to change [n LABILITIES]\n",
  "LABIODENTAL": "pertaining to or pronounced with lips and teeth [adj] / such a sound, as f [n -S]\n",
  "LABIODENTALS": "LABIODENTAL, such a sound, as f [n]\n",
  "LABIONASAL": "a sound produced with nose and closed lips [n -S]\n",
  "LABIONASALS": "LABIONASAL, a sound produced with nose and closed lips [n]\n",
  "LABIOVELAR": "produced by the lips and soft palate together, such as w [adj] / a labiovelar sound [n -S]\n",
  "LABIOVELARS": "LABIOVELAR, a labiovelar sound [n]\n",
  "LABIS": "(Greek) a spoon used to give the Eucharist to communicants [n -ES]\n",
  "LABISES": "LABIS, (Greek) a spoon used to give the Eucharist to communicants [n]\n",
  "LABIUM": "(Latin) a fold of the vulva [n LABIA]\n",
  "LABLAB": "(Arabic) a tropical bean with edible pods [n -S]\n",
  "LABLABS": "LABLAB, (Arabic) a tropical bean with edible pods [n]\n",
  "LABNEH": "(Arabic) a kind of soft cheese produced by straining yogurt [n -S]\n",
  "LABNEHS": "LABNEH, (Arabic) a kind of soft cheese produced by straining yogurt [n]\n",
  "LABOR": "to work, also LABOUR [v -ED, -ING, -S]\n",
  "LABORATORIES": "LABORATORY, a place equipped for experimental study in a science or for testing and analysis, also ELABORATORY [n]\n",
  "LABORATORY": "a place equipped for experimental study in a science or for testing and analysis, also ELABORATORY [n LABORATORIES]\n",
  "LABORED": "LABOR, to work, also LABOUR [v]\n",
  "LABOREDLY": "LABORED, LABOR, to work, also LABOUR [adv]\n",
  "LABOREDNESS": "the state of being labored [n -ES]\n",
  "LABOREDNESSES": "LABOREDNESS, the state of being labored [n]\n",
  "LABORER": "one who labors, also LABOURER [n -S]\n",
  "LABORERS": "LABORER, one who labors, also LABOURER [n]\n",
  "LABORING": "LABOR, to work, also LABOUR [v]\n",
  "LABORINGLY": "LABORING, LABOR, to work, also LABOUR [adv]\n",
  "LABORIOUS": "full of labour [adj LABORIOUSLY]\n",
  "LABORIOUSLY": "LABORIOUS, full of labour [adv]\n",
  "LABORIOUSNESS": "LABORIOUS, full of labour [n]\n",
  "LABORIOUSNESSES": "LABORIOUSNESS, LABORIOUS, full of labour [n]\n",
  "LABORISM": "a support for workers' rights, also LABOURISM [n -S]\n",
  "LABORISMS": "LABORISM, a support for workers' rights, also LABOURISM [n]\n",
  "LABORIST": "a supporter of workers' rights, also LABOURIST, LABORITE [n -S]\n",
  "LABORISTS": "LABORIST, a supporter of workers' rights, also LABOURIST, LABORITE [n]\n",
  "LABORITE": "one who supports workers' rights, also LABOURIST, LABOURITE [n -S]\n",
  "LABORITES": "LABORITE, one who supports workers' rights, also LABOURIST, LABOURITE [n]\n",
  "LABORS": "LABOR, to work, also LABOUR [v]\n",
  "LABORSAVING": "of a household device, saving work, also LABOURSAVING [adj]\n",
  "LABORSOME": "requiring hard work, also LABOURSOME [adj]\n",
  "LABOUR": "to work, also LABOR [v -ED, -ING, -S]\n",
  "LABOURED": "LABOUR, to work, also LABOR [v]\n",
  "LABOUREDLY": "LABOURED, LABOUR, to work, also LABOR [adv]\n",
  "LABOUREDNESS": "the state of being laboured [n -ES]\n",
  "LABOUREDNESSES": "LABOUREDNESS, the state of being laboured [n]\n",
  "LABOURER": "one who labours, also LABORER [n -S]\n",
  "LABOURERS": "LABOURER, one who labours, also LABORER [n]\n",
  "LABOURING": "LABOUR, to work, also LABOR [v]\n",
  "LABOURINGLY": "LABOURING, LABOUR, to work, also LABOR [adv]\n",
  "LABOURISM": "a support for workers' rights, also LABORISM [n -S]\n",
  "LABOURISMS": "LABOURISM, a support for workers' rights, also LABORISM [n]\n",
  "LABOURIST": "a supporter of workers' rights, also LABORITE, LABORIST [n -S]\n",
  "LABOURISTS": "LABOURIST, a supporter of workers' rights, also LABORITE, LABORIST [n]\n",
  "LABOURITE": "a member or supporter of the Labour party, also LABORITE, LABOURIST [n -S]\n",
  "LABOURITES": "LABOURITE, a member or supporter of the Labour party, also LABORITE, LABOURIST [n]\n",
  "LABOURS": "LABOUR, to work, also LABOR [v]\n",
  "LABOURSAVING": "reducing (human) effort, hard work, or labour, also LABORSAVING [adj]\n",
  "LABOURSOME": "(Shakespeare) laborious, also LABORSOME [adj]\n",
  "LABRA": "LABRUM, (Latin) a liplike structure [n]\n",
  "LABRADOODLE": "a breed of dog [n -S]\n",
  "LABRADOODLES": "LABRADOODLE, a breed of dog [n]\n",
  "LABRADOR": "a hunting dog [n -S]\n",
  "LABRADORESCENT": "of minerals, displaying a brilliant play of colours, as that shown by some forms of labradorite [adj]\n",
  "LABRADORITE": "a triclinic silicate of the plagioclase feldspar series which may show a bluish or multicoloured iridescence [n -S]\n",
  "LABRADORITES": "LABRADORITE, a triclinic silicate of the plagioclase feldspar series which may show a bluish or multicoloured iridescence [n]\n",
  "LABRADORS": "LABRADOR, a hunting dog [n]\n",
  "LABRAL": "relating to the labrum, liplike [adj]\n",
  "LABRET": "an ornament worn in the lip [n -S]\n",
  "LABRETS": "LABRET, an ornament worn in the lip [n]\n",
  "LABRID": "a member of the wrasse genus of fishes, also LABROID [n -S]\n",
  "LABRIDS": "LABRID, a member of the wrasse genus of fishes, also LABROID [n]\n",
  "LABROID": "a member of the wrasse family of fishes, also LABRID [n -S]\n",
  "LABROIDS": "LABROID, a member of the wrasse family of fishes, also LABRID [n]\n",
  "LABROSE": "having thick or large lips [adj]\n",
  "LABRUM": "(Latin) a liplike structure [n LABRUMS or LABRA]\n",
  "LABRUMS": "LABRUM, (Latin) a liplike structure [n]\n",
  "LABRUSCA": "a kind of fox grape [n -S]\n",
  "LABRUSCAS": "LABRUSCA, a kind of fox grape [n]\n",
  "LABRYS": "(Greek) the double-headed axe, a religious symbol of ancient Crete [n -ES]\n",
  "LABRYSES": "LABRYS, (Greek) the double-headed axe, a religious symbol of ancient Crete [n]\n",
  "LABS": "LAB, (short for) a laboratory [n]\n",
  "LABURNUM": "a genus of ornamental shrubs [n -S]\n",
  "LABURNUMS": "LABURNUM, a genus of ornamental shrubs [n]\n",
  "LABYRINTH": "a building with intricate passages; a maze [n -S]\n",
  "LABYRINTHAL": "of or like a labyrinth, also LABYRINTHIAN, LABYRINTHIC, LABYRINTHINE [adj]\n",
  "LABYRINTHIAN": "of or like a labyrinth, also LABYRINTHAL, LABYRINTHIC, LABYRINTHINE [adj]\n",
  "LABYRINTHIC": "of or like a labyrinth, also LABYRINTHAL, LABYRINTHIAN, LABYRINTHINE [adj]\n",
  "LABYRINTHICAL": "like a labyrinth [adj LABYRINTHICALLY]\n",
  "LABYRINTHICALLY": "LABYRINTHICAL, like a labyrinth [adv]\n",
  "LABYRINTHINE": "like a labyrinth, also LABYRINTHAL, LABYRINTHIAN, LABYRINTHIC [adj]\n",
  "LABYRINTHITIS": "inflammation of the inner ear [n -ES]\n",
  "LABYRINTHITISES": "LABYRINTHITIS, inflammation of the inner ear [n]\n",
  "LABYRINTHODONT": "an extinct amphibian, so called from a mazy pattern on a section of its teeth [n -S]\n",
  "LABYRINTHODONTS": "LABYRINTHODONT, an extinct amphibian, so called from a mazy pattern on a section of its teeth [n]\n",
  "LABYRINTHS": "LABYRINTH, a building with intricate passages; a maze [n]\n",
  "LAC": "a dark red resinous substance secreted by some insects [n -S]\n",
  "LACCOLITE": "a mass of igneous rock intruded between two sedimentary beds, also LACCOLITH [n -S]\n",
  "LACCOLITES": "LACCOLITE, a mass of igneous rock intruded between two sedimentary beds, also LACCOLITH [n]\n",
  "LACCOLITH": "a mass of igneous rock intruded between two sedimentary beds, also LACCOLITE [n -S]\n",
  "LACCOLITHIC": "of or like a laccolith, a mass of igneous rock intruded between two sedimentary beds [adj]\n",
  "LACCOLITHS": "LACCOLITH, a mass of igneous rock intruded between two sedimentary beds, also LACCOLITE [n]\n",
  "LACCOLITIC": "of or like a laccolite, a mass of igneous rock intruded between two sedimentary beds [adj]\n",
  "LACE": "to draw together two edges with a cord [v LACED, LACING, LACES]\n",
  "LACEBARK": "a West Indian tree [n -S]\n",
  "LACEBARKS": "LACEBARK, a West Indian tree [n]\n",
  "LACED": "LACE, to draw together two edges with a cord [v]\n",
  "LACELESS": "without a lace [adj]\n",
  "LACELIKE": "like a lace [adj]\n",
  "LACEMAKER": "one who makes lace [n -S]\n",
  "LACEMAKERS": "LACEMAKER, one who makes lace [n]\n",
  "LACEMAKING": "the craft of making lace [n -S]\n",
  "LACEMAKINGS": "LACEMAKING, the craft of making lace [n]\n",
  "LACER": "one that laces [n -S]\n",
  "LACERABILITIES": "LACERABILITY, the quality of being lacerable [n]\n",
  "LACERABILITY": "the quality of being lacerable [n LACERABILITIES]\n",
  "LACERABLE": "that can be lacerated or torn [adj]\n",
  "LACERANT": "harrowing [adj]\n",
  "LACERATE": "to tear roughly [v LACERATED, LACERATING, LACERATES]\n",
  "LACERATED": "LACERATE, to tear roughly [v]\n",
  "LACERATES": "LACERATE, to tear roughly [v]\n",
  "LACERATING": "LACERATE, to tear roughly [v]\n",
  "LACERATION": "the act of lacerating [n -S]\n",
  "LACERATIONS": "LACERATION, the act of lacerating [n]\n",
  "LACERATIVE": "having the power to lacerate [adj]\n",
  "LACERS": "LACER, one that laces [n]\n",
  "LACERTIAN": "a member of the lizard family, also LACERTINE [n -S]\n",
  "LACERTIANS": "LACERTIAN, a member of the lizard family, also LACERTINE [n]\n",
  "LACERTID": "a kind of lizard [n -S]\n",
  "LACERTIDS": "LACERTID, a kind of lizard [n]\n",
  "LACERTILIAN": "of or pertaining to lizards [adj] / a member of the lizard family [n -S]\n",
  "LACERTILIANS": "LACERTILIAN, a member of the lizard family [n]\n",
  "LACERTINE": "a member of the lizard family, also LACERTIAN [n -S]\n",
  "LACERTINES": "LACERTINE, a member of the lizard family, also LACERTIAN [n]\n",
  "LACES": "LACE, to draw together two edges with a cord [v]\n",
  "LACET": "a kind of lacework [n -S]\n",
  "LACETS": "LACET, a kind of lacework [n]\n",
  "LACEWING": "any one of several species of neuropterous insects of the genus Chrysopa and allied genera [n -S]\n",
  "LACEWINGS": "LACEWING, any one of several species of neuropterous insects of the genus Chrysopa and allied genera [n]\n",
  "LACEWOOD": "the wood of the American plane or a similar wood, suitable for ornamental use [n -S]\n",
  "LACEWOODS": "LACEWOOD, the wood of the American plane or a similar wood, suitable for ornamental use [n]\n",
  "LACEWORK": "a delicate openwork fabric [n -S]\n",
  "LACEWORKS": "LACEWORK, a delicate openwork fabric [n]\n",
  "LACEY": "resembling lacework, also LACY [adj LACIER, LACIEST, LACILY]\n",
  "LACHES": "undue delay in carrying out a legal right [n LACHESES]\n",
  "LACHESES": "LACHES, undue delay in carrying out a legal right [n]\n",
  "LACHRYMAL": "relating to tears [adj] / a gland that produces tears, also LACRIMAL, LACRYMAL [n -S]\n",
  "LACHRYMALS": "LACHRYMAL, a gland that produces tears, also LACRIMAL, LACRYMAL [n]\n",
  "LACHRYMARIES": "LACHRYMARY, a vessel containing, or intended to contain, tears, also LACRIMARY [n]\n",
  "LACHRYMARY": "a vessel containing, or intended to contain, tears, also LACRIMARY [n LACHRYMARIES]\n",
  "LACHRYMATION": "the secretion of tears, also LACRIMATION [n -S]\n",
  "LACHRYMATIONS": "LACHRYMATION, the secretion of tears, also LACRIMATION [n]\n",
  "LACHRYMATOR": "a substance or gas causing tears, also LACRIMATOR, LACRYMATOR [n -S]\n",
  "LACHRYMATORIES": "LACHRYMATORY, a narrow-necked vase; a tear-bottle [n]\n",
  "LACHRYMATORS": "LACHRYMATOR, a substance or gas causing tears, also LACRIMATOR, LACRYMATOR [n]\n",
  "LACHRYMATORY": "a narrow-necked vase; a tear-bottle [n LACHRYMATORIES]\n",
  "LACHRYMOSE": "shedding tears [adj LACHRYMOSELY]\n",
  "LACHRYMOSELY": "LACHRYMOSE, shedding tears [adv]\n",
  "LACHRYMOSITIES": "LACHRYMOSITY, the state of being lachrymose, tearful [n]\n",
  "LACHRYMOSITY": "the state of being lachrymose, tearful [n LACHRYMOSITIES]\n",
  "LACIER": "LACEY, resembling lacework, also LACY [adj]\n",
  "LACIEST": "LACEY, resembling lacework, also LACY [adj]\n",
  "LACILY": "LACY, resembling lacework, also LACEY [adv]\n",
  "LACINESS": "the quality of being lacy [n -ES]\n",
  "LACINESSES": "LACINESS, the quality of being lacy [n]\n",
  "LACING": "a contrasting marginal band of colour [n -S]\n",
  "LACINGS": "LACING, a contrasting marginal band of colour [n]\n",
  "LACINIA": "(Latin) a long narrow lobe in a leaf [n LACINIAE]\n",
  "LACINIAE": "LACINIA, (Latin) a long narrow lobe in a leaf [n]\n",
  "LACINIATE": "cut into narrow lobes; finely fringed, also LACINIATED [adj]\n",
  "LACINIATED": "cut into narrow lobes; finely fringed, also LACINIATE [adj]\n",
  "LACINIATION": "the state of being laciniate, finely fringed [n -S]\n",
  "LACINIATIONS": "LACINIATION, the state of being laciniate, finely fringed [n]\n",
  "LACK": "to be without [v -ED, -ING, -S]\n",
  "LACKADAISICAL": "lacking life, spirit, or zest; languid [adj LACKADAISICALLY]\n",
  "LACKADAISICALLY": "LACKADAISICAL, lacking life, spirit, or zest; languid [adv]\n",
  "LACKADAISY": "(archaic) an expression of languor [interj]\n",
  "LACKADAY": "(archaic) an expression of regret or deprecation, also ALACKADAY [interj]\n",
  "LACKED": "LACK, to be without [v]\n",
  "LACKER": "to coat with a glossy substance, also LACQUER [v -ED, -ING, -S]\n",
  "LACKERED": "LACKER, to coat with a glossy substance, also LACQUER [v]\n",
  "LACKERING": "LACKER, to coat with a glossy substance, also LACQUER [v]\n",
  "LACKERS": "LACKER, to coat with a glossy substance, also LACQUER [v]\n",
  "LACKEY": "to serve in a servile manner, also LACQUEY [v -ED, -ING, -S]\n",
  "LACKEYED": "LACKEY, to serve in a servile manner, also LACQUEY [v]\n",
  "LACKEYING": "LACKEY, to serve in a servile manner, also LACQUEY [v]\n",
  "LACKEYS": "LACKEY, to serve in a servile manner, also LACQUEY [v]\n",
  "LACKING": "LACK, to be without [v]\n",
  "LACKLAND": "one who is wanting in land [n -S]\n",
  "LACKLANDS": "LACKLAND, one who is wanting in land [n]\n",
  "LACKLUSTER": "lacking lustre, uninspiring [adj] / something lacking lustre, also LACKLUSTRE [n -S]\n",
  "LACKLUSTERS": "LACKLUSTER, something lacking lustre, also LACKLUSTRE [n]\n",
  "LACKLUSTRE": "lacking lustre, uninspiring [adj] / something lacking lustre, also LACKLUSTER [n -S]\n",
  "LACKLUSTRES": "LACKLUSTRE, something lacking lustre, also LACKLUSTER [n]\n",
  "LACKS": "LACK, to be without [v]\n",
  "LACMUS": "a substance that changes colour with acidity, also LITMUS [n -ES]\n",
  "LACMUSES": "LACMUS, a substance that changes colour with acidity, also LITMUS [n]\n",
  "LACONIC": "brief with words, also LACONICAL [adj LACONICALLY]\n",
  "LACONICAL": "of a person's speech, using few words, terse, also LACONIC [adj LACONICALLY]\n",
  "LACONICALLY": "LACONICAL, of a person's speech, using few words, terse, also LACONIC [adv]\n",
  "LACONICISM": "a vigorous, brief manner of expression, also LACONISM [n -S]\n",
  "LACONICISMS": "LACONICISM, a vigorous, brief manner of expression, also LACONISM [n]\n",
  "LACONISM": "brevity of expression [n -S]\n",
  "LACONISMS": "LACONISM, brevity of expression [n]\n",
  "LACQUER": "to coat with a glossy substance, also LACKER [v -ED, -ING, -S]\n",
  "LACQUERED": "LACQUER, to coat with a glossy substance, also LACKER [v]\n",
  "LACQUERER": "one who lacquers [n -S]\n",
  "LACQUERERS": "LACQUERER, one who lacquers [n]\n",
  "LACQUERING": "a coating of lacquer [n -S]\n",
  "LACQUERINGS": "LACQUERING, a coating of lacquer [n]\n",
  "LACQUERS": "LACQUER, to coat with a glossy substance, also LACKER [v]\n",
  "LACQUERWARE": "craft goods made from lacquer [n -S]\n",
  "LACQUERWARES": "LACQUERWARE, craft goods made from lacquer [n]\n",
  "LACQUERWORK": "craftwork in lacquer [n -S]\n",
  "LACQUERWORKS": "LACQUERWORK, craftwork in lacquer [n]\n",
  "LACQUEY": "to serve in a servile manner, also LACKEY [v -ED, -ING, -S]\n",
  "LACQUEYED": "LACQUEY, to serve in a servile manner, also LACKEY [v]\n",
  "LACQUEYING": "LACQUEY, to serve in a servile manner, also LACKEY [v]\n",
  "LACQUEYS": "LACQUEY, to serve in a servile manner, also LACKEY [v]\n",
  "LACRIMAL": "a gland that produces tears, also LACHRYMAL, LACRYMAL [n -S]\n",
  "LACRIMALS": "LACRIMAL, a gland that produces tears, also LACHRYMAL, LACRYMAL [n]\n",
  "LACRIMARIES": "LACRIMARY, a tear bottle, also LACHRYMARY [n]\n",
  "LACRIMARY": "a tear bottle, also LACHRYMARY [n LACRIMARIES]\n",
  "LACRIMATION": "the secretion of tears, also LACHRYMATION [n -S]\n",
  "LACRIMATIONS": "LACRIMATION, the secretion of tears, also LACHRYMATION [n]\n",
  "LACRIMATOR": "a substance or gas causing tears, also LACHRYMATOR, LACRYMATOR [n -S]\n",
  "LACRIMATORS": "LACRIMATOR, a substance or gas causing tears, also LACHRYMATOR, LACRYMATOR [n]\n",
  "LACRIMATORY": "of, causing or producing tears, also LACRYMATORY [adj]\n",
  "LACRIMOSO": "(Italian) plaintive, also LAGRIMOSO [adj]\n",
  "LACROSSE": "a type of ball game [n -S]\n",
  "LACROSSES": "LACROSSE, a type of ball game [n]\n",
  "LACRYMAL": "a gland that produces tears, also LACHRYMAL, LACRIMAL [n -S]\n",
  "LACRYMALS": "LACRYMAL, a gland that produces tears, also LACHRYMAL, LACRIMAL [n]\n",
  "LACRYMATOR": "a substance or gas causing tears, also LACHRYMATOR, LACRIMATOR [n -S]\n",
  "LACRYMATORS": "LACRYMATOR, a substance or gas causing tears, also LACHRYMATOR, LACRIMATOR [n]\n",
  "LACRYMATORY": "of, causing or producing tears, also LACRIMATORY [adj]\n",
  "LACS": "LAC, a dark red resinous substance secreted by some insects [n]\n",
  "LACTALBUMIN": "a protein, present in milk, which contains all of the essential amino acids [n -S]\n",
  "LACTALBUMINS": "LACTALBUMIN, a protein, present in milk, which contains all of the essential amino acids [n]\n",
  "LACTAM": "one of a series of anhydrides of an amido type, analogous to the lactones [n -S]\n",
  "LACTAMS": "LACTAM, one of a series of anhydrides of an amido type, analogous to the lactones [n]\n",
  "LACTARIAN": "a vegetarian whose diet includes dairy products [n -S]\n",
  "LACTARIANS": "LACTARIAN, a vegetarian whose diet includes dairy products [n]\n",
  "LACTARY": "milky; full of white juice like milk [adj]\n",
  "LACTASE": "an enzyme that acts on lactose [n -S]\n",
  "LACTASES": "LACTASE, an enzyme that acts on lactose [n]\n",
  "LACTATE": "to secrete milk [v LACTATED, LACTATING, LACTATES]\n",
  "LACTATED": "LACTATE, to secrete milk [v]\n",
  "LACTATES": "LACTATE, to secrete milk [v]\n",
  "LACTATING": "LACTATE, to secrete milk [v]\n",
  "LACTATION": "the act of suckling young; the period of milk secretion normally following childbirth [n -S]\n",
  "LACTATIONAL": "relating to lactation [adj LACTATIONALLY]\n",
  "LACTATIONALLY": "LACTATIONAL, relating to lactation [adv]\n",
  "LACTATIONS": "LACTATION, the act of suckling young; the period of milk secretion normally following childbirth [n]\n",
  "LACTEAL": "pertaining to milk, also LACTEAN, LACTEOUS [adj LACTEALLY] / a vessel conveying chyle from the intestines to the thoracic ducts [n -S]\n",
  "LACTEALLY": "LACTEAL, pertaining to milk, also LACTEAN, LACTEOUS [adv]\n",
  "LACTEALS": "LACTEAL, a vessel conveying chyle from the intestines to the thoracic ducts [n]\n",
  "LACTEAN": "milky; consisting of, or resembling, milk, also LACTEAL, LACTEOUS [adj]\n",
  "LACTEOUS": "milky, also LACTEAL, LACTEAN [adj]\n",
  "LACTESCENCE": "milkiness [n -S]\n",
  "LACTESCENCES": "LACTESCENCE, milkiness [n]\n",
  "LACTESCENT": "producing milky juice [adj]\n",
  "LACTIC": "derived from milk [adj]\n",
  "LACTIFEROUS": "milk-bearing [adj]\n",
  "LACTIFEROUSNESS": "the state of being lactiferous [n]\n",
  "LACTIFIC": "producing milk [adj]\n",
  "LACTIFLUOUS": "flowing with milk [adj]\n",
  "LACTITOL": "an artificial sweetener [n -S]\n",
  "LACTITOLS": "LACTITOL, an artificial sweetener [n]\n",
  "LACTIVISM": "strong advocacy of breastfeeding as opposed to bottle-feeding [n -S]\n",
  "LACTIVISMS": "LACTIVISM, strong advocacy of breastfeeding as opposed to bottle-feeding [n]\n",
  "LACTIVIST": "a person, esp. a woman, who advocates strongly the breastfeeding of children and is opposed to bottle-feeding [n -S]\n",
  "LACTIVISTS": "LACTIVIST, a person, esp. a woman, who advocates strongly the breastfeeding of children and is opposed to bottle-feeding [n]\n",
  "LACTOBACILLI": "LACTOBACILLUS, any of a genus of bacteria that produce lactic acid [n]\n",
  "LACTOBACILLUS": "any of a genus of bacteria that produce lactic acid [n LACTOBACILLI]\n",
  "LACTOFLAVIN": "an earlier name for riboflavin [n -S]\n",
  "LACTOFLAVINS": "LACTOFLAVIN, an earlier name for riboflavin [n]\n",
  "LACTOGENIC": "producing milk [adj]\n",
  "LACTOGLOBULIN": "a crystalline protein fraction that is obtained from the whey of milk [n -S]\n",
  "LACTOGLOBULINS": "LACTOGLOBULIN, a crystalline protein fraction that is obtained from the whey of milk [n]\n",
  "LACTOMETER": "an instrument for testing the relative density of milk [n -S]\n",
  "LACTOMETERS": "LACTOMETER, an instrument for testing the relative density of milk [n]\n",
  "LACTONE": "a cyclic ester [n -S]\n",
  "LACTONES": "LACTONE, a cyclic ester [n]\n",
  "LACTONIC": "of, pertaining to, or derived from, lactone, one of a series of organic compounds, regarded as anhydrides of certain hydroxy acids [adj]\n",
  "LACTOPROTEIN": "any protein present in milk [n -S]\n",
  "LACTOPROTEINS": "LACTOPROTEIN, any protein present in milk [n]\n",
  "LACTOSCOPE": "an instrument for measuring the purity or richness of milk [n -S]\n",
  "LACTOSCOPES": "LACTOSCOPE, an instrument for measuring the purity or richness of milk [n]\n",
  "LACTOSE": "a lactic sugar [n -S]\n",
  "LACTOSES": "LACTOSE, a lactic sugar [n]\n",
  "LACTOSURIA": "the presence of lactose in the urine [n -S]\n",
  "LACTOSURIAS": "LACTOSURIA, the presence of lactose in the urine [n]\n",
  "LACTOVEGETARIAN": "a vegetarian whose diet includes milk and other dairy products [n]\n",
  "LACTULOSE": "a synthetic sugar with laxative properties [n -S]\n",
  "LACTULOSES": "LACTULOSE, a synthetic sugar with laxative properties [n]\n",
  "LACUNA": "(Latin) an empty space or missing part, also LACUNE [n LACUNAS or LACUNAE]\n",
  "LACUNAE": "LACUNA, (Latin) an empty space or missing part, also LACUNE [n]\n",
  "LACUNAL": "relating to a lacuna, a gap, also LACUNARY, LACUNATE [adj]\n",
  "LACUNAR": "(Latin) a sunken panel or coffer in a ceiling, also LAQUEARIA, LEQUEAR [n LACUNARS or LACUNARIA]\n",
  "LACUNARIA": "LACUNAR, (Latin) a sunken panel or coffer in a ceiling, also LAQUEARIA, LEQUEAR [n]\n",
  "LACUNARS": "LACUNAR, (Latin) a sunken panel or coffer in a ceiling, also LAQUEARIA, LEQUEAR [n]\n",
  "LACUNARY": "relating to a lacuna, a gap, also LACUNAL, LACUNATE [adj]\n",
  "LACUNAS": "LACUNA, (Latin) an empty space or missing part, also LACUNE [n]\n",
  "LACUNATE": "relating to a lacuna, a gap, also LACUNAL, LACUNARY [adj]\n",
  "LACUNE": "an empty space or missing part, also LACUNA [n -S]\n",
  "LACUNES": "LACUNE, an empty space or missing part, also LACUNA [n]\n",
  "LACUNOSE": "marked by shallow depressions [adj]\n",
  "LACUNOSITIES": "LACUNOSITY, the state of being lacunose [n]\n",
  "LACUNOSITY": "the state of being lacunose [n LACUNOSITIES]\n",
  "LACUSTRINE": "relating to lakes [adj]\n",
  "LACY": "resembling lacework, also LACEY [adj LACIER, LACIEST, LACILY]\n",
  "LAD": "a boy or youth [n -S]\n",
  "LADANUM": "(Latin) a gum resin gathered from certain Oriental species of Cistus, also LABDANUM [n -S]\n",
  "LADANUMS": "LADANUM, (Latin) a gum resin gathered from certain Oriental species of Cistus, also LABDANUM [n]\n",
  "LADDER": "to cause a run in a stocking [v -ED, -ING, -S]\n",
  "LADDERED": "LADDER, to cause a run in a stocking [v]\n",
  "LADDERIER": "LADDERY, of stockings, laddered [adj]\n",
  "LADDERIEST": "LADDERY, of stockings, laddered [adj]\n",
  "LADDERING": "LADDER, to cause a run in a stocking [v]\n",
  "LADDERLIKE": "like a ladder [adj]\n",
  "LADDERPROOF": "of tights etc., not susceptible to laddering [adj]\n",
  "LADDERS": "LADDER, to cause a run in a stocking [v]\n",
  "LADDERY": "of stockings, laddered [adj LADDERIER, LADDERIEST]\n",
  "LADDIE": "a lad [n -S]\n",
  "LADDIER": "LADDY, laddish in behaviour [adj]\n",
  "LADDIES": "LADDIE, a lad [n]\n",
  "LADDIEST": "LADDY, laddish in behaviour [adj]\n",
  "LADDISH": "of young men, boisterous or aggressive [adj LADDISHLY]\n",
  "LADDISHLY": "LADDISH, of young men, boisterous or aggressive [adv]\n",
  "LADDISHNESS": "the state of being laddish [n -ES]\n",
  "LADDISHNESSES": "LADDISHNESS, the state of being laddish [n]\n",
  "LADDISM": "a culture of laddishness [n -S]\n",
  "LADDISMS": "LADDISM, a culture of laddishness [n]\n",
  "LADDY": "laddish in behaviour [adj LADDIER, LADDIEST]\n",
  "LADE": "to load with cargo, also LADEN, LAID, LOAD, LOADEN [v LADED, LADING, LADES]\n",
  "LADED": "LADE, to load with cargo, also LADEN, LAID, LOAD, LOADEN [v]\n",
  "LADEN": "to load with cargo, also LADE, LAID, LOAD, LOADEN [v -ED, -ING, -S]\n",
  "LADENED": "LADEN, to load with cargo, also LADE, LAID, LOAD, LOADEN [v]\n",
  "LADENING": "LADEN, to load with cargo, also LADE, LAID, LOAD, LOADEN [v]\n",
  "LADENS": "LADEN, to load with cargo, also LADE, LAID, LOAD, LOADEN [v]\n",
  "LADER": "one who lades [n -S]\n",
  "LADERS": "LADER, one who lades [n]\n",
  "LADES": "LADE, to load with cargo, also LADEN, LAID, LOAD, LOADEN [v]\n",
  "LADETTE": "a lively woman who behaves like one of the lads [n -S]\n",
  "LADETTES": "LADETTE, a lively woman who behaves like one of the lads [n]\n",
  "LADHOOD": "the state of being a lad [n -S]\n",
  "LADHOODS": "LADHOOD, the state of being a lad [n]\n",
  "LADIES": "LADY, a woman of refinement and gentle manners [n]\n",
  "LADIESWEAR": "clothes for women [n -S]\n",
  "LADIESWEARS": "LADIESWEAR, clothes for women [n]\n",
  "LADIFIED": "LADIFY, to make a lady of, also LADYFY [v]\n",
  "LADIFIES": "LADIFY, to make a lady of, also LADYFY [v]\n",
  "LADIFY": "to make a lady of, also LADYFY [v LADIFIED, LADIFYING, LADIFIES]\n",
  "LADIFYING": "LADIFY, to make a lady of, also LADYFY [v]\n",
  "LADING": "cargo or freight [n -S]\n",
  "LADINGS": "LADING, cargo or freight [n]\n",
  "LADINO": "(Spanish) a fast-growing clover [n -S]\n",
  "LADINOS": "LADINO, (Spanish) a fast-growing clover [n]\n",
  "LADLE": "to serve with a large type of spoon [v LADLED, LADLING, LADLES]\n",
  "LADLED": "LADLE, to serve with a large type of spoon [v]\n",
  "LADLEFUL": "as much as a ladle can hold [n -S]\n",
  "LADLEFULS": "LADLEFUL, as much as a ladle can hold [n]\n",
  "LADLER": "one who ladles; (historical) a collector of ladle dues [n -S]\n",
  "LADLERS": "LADLER, one who ladles; (historical) a collector of ladle dues [n]\n",
  "LADLES": "LADLE, to serve with a large type of spoon [v]\n",
  "LADLING": "LADLE, to serve with a large type of spoon [v]\n",
  "LADRON": "(Spanish) a robber; a pirate; hence, loosely, a rogue or rascal, also LADRONE, LATRON [n -S]\n",
  "LADRONE": "(archaic) a robber; a pirate; hence, loosely, a rogue or rascal, also LADRON, LATRON [n -S]\n",
  "LADRONES": "LADRONE, (archaic) a robber; a pirate; hence, loosely, a rogue or rascal, also LADRON, LATRON [n]\n",
  "LADRONS": "LADRON, (Spanish) a robber; a pirate; hence, loosely, a rogue or rascal, also LADRONE, LATRON [n]\n",
  "LADS": "LAD, a boy or youth [n]\n",
  "LADY": "a woman of refinement and gentle manners [n LADIES]\n",
  "LADYBIRD": "a small brightly coloured beetle, also LADYBUG, LADYCOW, LADYFLY [n -S]\n",
  "LADYBIRDS": "LADYBIRD, a small brightly coloured beetle, also LADYBUG, LADYCOW, LADYFLY [n]\n",
  "LADYBOY": "a transvestite [n -S]\n",
  "LADYBOYS": "LADYBOY, a transvestite [n]\n",
  "LADYBUG": "a small beetle, also LADYBIRD, LADYCOW, LADYFLY [n -S]\n",
  "LADYBUGS": "LADYBUG, a small beetle, also LADYBIRD, LADYCOW, LADYFLY [n]\n",
  "LADYCOW": "a small beetle, also LADYBUG, LADYBIRD, LADYFLY [n -S]\n",
  "LADYCOWS": "LADYCOW, a small beetle, also LADYBUG, LADYBIRD, LADYFLY [n]\n",
  "LADYFIED": "LADYFY, to make a lady of, also LADIFY [v]\n",
  "LADYFIES": "LADYFY, to make a lady of, also LADIFY [v]\n",
  "LADYFINGER": "a small finger-shaped sponge cake [n -S]\n",
  "LADYFINGERS": "LADYFINGER, a small finger-shaped sponge cake [n]\n",
  "LADYFISH": "a large, handsome fish, found both in the Atlantic and Pacific oceans [n -ES]\n",
  "LADYFISHES": "LADYFISH, a large, handsome fish, found both in the Atlantic and Pacific oceans [n]\n",
  "LADYFLIES": "LADYFLY, a small beetle, also LADYBUG, LADYBIRD, LADYCOW [n]\n",
  "LADYFLY": "a small beetle, also LADYBUG, LADYBIRD, LADYCOW [n LADYFLIES]\n",
  "LADYFY": "to make a lady of, also LADIFY [v LADYFIED, LADYFYING, LADYFIES]\n",
  "LADYFYING": "LADYFY, to make a lady of, also LADIFY [v]\n",
  "LADYHOOD": "the state of being a lady [n -S]\n",
  "LADYHOODS": "LADYHOOD, the state of being a lady [n]\n",
  "LADYISH": "somewhat like a lady [adj]\n",
  "LADYISM": "the affectation of the airs of a lady [n -S]\n",
  "LADYISMS": "LADYISM, the affectation of the airs of a lady [n]\n",
  "LADYKIN": "(archaic) a little lady, also LAKIN [n -S]\n",
  "LADYKINS": "LADYKIN, (archaic) a little lady, also LAKIN [n]\n",
  "LADYLIKE": "like a lady [adj]\n",
  "LADYLIKENESS": "the state of being ladylike [n -ES]\n",
  "LADYLIKENESSES": "LADYLIKENESS, the state of being ladylike [n]\n",
  "LADYLOVE": "a sweetheart [n -S]\n",
  "LADYLOVES": "LADYLOVE, a sweetheart [n]\n",
  "LADYNESS": "the quality or state of being a lady [n -ES]\n",
  "LADYNESSES": "LADYNESS, the quality or state of being a lady [n]\n",
  "LADYPALM": "a kind of palm tree, native to China and Taiwan [n -S]\n",
  "LADYPALMS": "LADYPALM, a kind of palm tree, native to China and Taiwan [n]\n",
  "LADYSHIP": "the condition of being a lady [n -S]\n",
  "LADYSHIPS": "LADYSHIP, the condition of being a lady [n]\n",
  "LAEOTROPIC": "coiled in a leftward direction, as of a left-spiralling snail shell [adj]\n",
  "LAER": "(South African) in South Africa, a defensive ring of ox-wagons [n -S] / to make a defensive ring of ox-wagons, also LAAGER [v -ED, -ING, -S]\n",
  "LAERED": "LAER, to make a defensive ring of ox-wagons, also LAAGER [v]\n",
  "LAERING": "LAER, to make a defensive ring of ox-wagons, also LAAGER [v]\n",
  "LAERS": "LAER, to make a defensive ring of ox-wagons, also LAAGER [v]\n",
  "LAESIE": "(Spenser) lazy [adj]\n",
  "LAETARE": "(Latin) the fourth Sunday in Lent [n -S]\n",
  "LAETARES": "LAETARE, (Latin) the fourth Sunday in Lent [n]\n",
  "LAETRILE": "(tradename) a drug derived from apricot pits, used in the treatment of cancer [n -S]\n",
  "LAETRILES": "LAETRILE, (tradename) a drug derived from apricot pits, used in the treatment of cancer [n]\n",
  "LAEVIGATE": "to smooth, polish, also LEVIGATE [v LAEVIGATED, LAEVIGATING, LAEVIGATES]\n",
  "LAEVIGATED": "LAEVIGATE, to smooth, polish, also LEVIGATE [v]\n",
  "LAEVIGATES": "LAEVIGATE, to smooth, polish, also LEVIGATE [v]\n",
  "LAEVIGATING": "LAEVIGATE, to smooth, polish, also LEVIGATE [v]\n",
  "LAEVO": "turning towards the left, also LEVO [adj]\n",
  "LAEVOGYRATE": "of, having or causing laevorotation [adj]\n",
  "LAEVOROTARY": "of, having or causing laevorotation [adj]\n",
  "LAEVOROTATION": "counterclockwise rotation [n -S]\n",
  "LAEVOROTATIONS": "LAEVOROTATION, counterclockwise rotation [n]\n",
  "LAEVOROTATORY": "counterclockwise; rotating the plane of polarization of light to the left, also LEVOROTARY, LEVOROTATORY [adj]\n",
  "LAEVULIN": "a sugar occurring in certain plants, also LEVULIN [n -S]\n",
  "LAEVULINS": "LAEVULIN, a sugar occurring in certain plants, also LEVULIN [n]\n",
  "LAEVULOSE": "the laevorotatory (and predominant naturally occurring) form of fructose, also LEVULOSE [n -S]\n",
  "LAEVULOSES": "LAEVULOSE, the laevorotatory (and predominant naturally occurring) form of fructose, also LEVULOSE [n]\n",
  "LAG": "to fall behind [v LAGGED, LAGGING, LAGS]\n",
  "LAGAN": "goods thrown into the sea for future recovery, also LAGEND, LIGAN [n -S]\n",
  "LAGANS": "LAGAN, goods thrown into the sea for future recovery, also LAGEND, LIGAN [n]\n",
  "LAGENA": "(Latin) a narrow-necked bottle [n -S]\n",
  "LAGENAS": "LAGENA, (Latin) a narrow-necked bottle [n]\n",
  "LAGEND": "goods thrown into the sea for future recovery, also LAGAN, LIGAN [n -S]\n",
  "LAGENDS": "LAGEND, goods thrown into the sea for future recovery, also LAGAN, LIGAN [n]\n",
  "LAGENIFORM": "shaped like a flask [adj]\n",
  "LAGER": "to form a defensive encampment, also LAER, LAAGER [v -ED, -ING, -S]\n",
  "LAGERED": "LAGER, to form a defensive encampment, also LAER, LAAGER [v]\n",
  "LAGERING": "LAGER, to form a defensive encampment, also LAER, LAAGER [v]\n",
  "LAGERPHONE": "(Australian) a percussion instrument using the tops of beer bottles to make a jingling noise when struck or shaken [n -S]\n",
  "LAGERPHONES": "LAGERPHONE, (Australian) a percussion instrument using the tops of beer bottles to make a jingling noise when struck or shaken [n]\n",
  "LAGERS": "LAGER, to form a defensive encampment, also LAER, LAAGER [v]\n",
  "LAGGARD": "lagging behind [adj LAGGARDLY] / one who lags behind [n -S]\n",
  "LAGGARDLIER": "LAGGARDLY, like a laggard [adj]\n",
  "LAGGARDLIEST": "LAGGARDLY, like a laggard [adj]\n",
  "LAGGARDLY": "like a laggard [adj LAGGARDLIER, LAGGARDLIEST]\n",
  "LAGGARDNESS": "the state of being a laggard, one who lags behind [n -ES]\n",
  "LAGGARDNESSES": "LAGGARDNESS, the state of being a laggard, one who lags behind [n]\n",
  "LAGGARDS": "LAGGARD, one who lags behind [n]\n",
  "LAGGED": "LAG, to fall behind [v]\n",
  "LAGGEN": "(Scots) the angle between the side and bottom of a wooden dish, also LAGGIN [n -S]\n",
  "LAGGENS": "LAGGEN, (Scots) the angle between the side and bottom of a wooden dish, also LAGGIN [n]\n",
  "LAGGER": "one who lags, also LAGGARD [n -S]\n",
  "LAGGERS": "LAGGER, one who lags, also LAGGARD [n]\n",
  "LAGGIN": "(Scots) the angle between the side and bottom of a wooden dish, also LAGGEN [n -S]\n",
  "LAGGING": "an insulating material [n -S]\n",
  "LAGGINGLY": "LAGGING [adv]\n",
  "LAGGINGS": "LAGGING, an insulating material [n]\n",
  "LAGGINS": "LAGGIN, (Scots) the angle between the side and bottom of a wooden dish, also LAGGEN [n]\n",
  "LAGNAPPE": "(Spanish) a small gift given a customer by a merchant at the time of purchase, also LAGNIAPPE [n -S]\n",
  "LAGNAPPES": "LAGNAPPE, (Spanish) a small gift given a customer by a merchant at the time of purchase, also LAGNIAPPE [n]\n",
  "LAGNIAPPE": "(Spanish) a small gift given a customer by a merchant at the time of purchase, also LAGNAPPE [n -S]\n",
  "LAGNIAPPES": "LAGNIAPPE, (Spanish) a small gift given a customer by a merchant at the time of purchase, also LAGNAPPE [n]\n",
  "LAGOMORPH": "a gnawing mammal (rabbits, hares, pikas) [n -S]\n",
  "LAGOMORPHIC": "of or like a lagomorph, a gnawing mammal, also LAGOMORPHOUS [adj]\n",
  "LAGOMORPHOUS": "of or like a lagomorph, a gnawing mammal, also LAGOMORPHIC [adj]\n",
  "LAGOMORPHS": "LAGOMORPH, a gnawing mammal (rabbits, hares, pikas) [n]\n",
  "LAGOON": "a shallow body of water, also LAGUNA, LAGUNE [n -S]\n",
  "LAGOONAL": "of or like a lagoon [adj]\n",
  "LAGOONS": "LAGOON, a shallow body of water, also LAGUNA, LAGUNE [n]\n",
  "LAGRIMOSO": "(Italian) plaintive, also LACRIMOSO [adj]\n",
  "LAGS": "LAG, to fall behind [v]\n",
  "LAGUNA": "(Italian) a shallow body of water, also LAGOON, LAGUNE [n -S]\n",
  "LAGUNAS": "LAGUNA, (Italian) a shallow body of water, also LAGOON, LAGUNE [n]\n",
  "LAGUNE": "(French) a shallow body of water, also LAGOON, LAGUNA [n -S]\n",
  "LAGUNES": "LAGUNE, (French) a shallow body of water, also LAGOON, LAGUNA [n]\n",
  "LAH": "a musical note, also LA [n -S]\n",
  "LAHAL": "a team game played by the indigenous peoples of the Pacific Northwest, also SLAHAL [n -S]\n",
  "LAHALS": "LAHAL, a team game played by the indigenous peoples of the Pacific Northwest, also SLAHAL [n]\n",
  "LAHAR": "(Javanese) a flowing mass of volcanic debris [n -S]\n",
  "LAHARS": "LAHAR, (Javanese) a flowing mass of volcanic debris [n]\n",
  "LAHS": "LAH, a musical note, also LA [n]\n",
  "LAIC": "pertaining to lay people rather than clergy [adj LAICALLY] / a lay person [n -S]\n",
  "LAICAL": "of or pertaining to a layman or the laity [adj LAICALLY]\n",
  "LAICALLY": "LAICAL, of or pertaining to a layman or the laity [adv]\n",
  "LAICH": "(Scots) a piece of low-lying ground; a hollow, also LAIGH [n -S]\n",
  "LAICHS": "LAICH, (Scots) a piece of low-lying ground; a hollow, also LAIGH [n]\n",
  "LAICISATION": "the process of returning a clergyman to lay status, also LAICIZATION [n -S]\n",
  "LAICISATIONS": "LAICISATION, the process of returning a clergyman to lay status, also LAICIZATION [n]\n",
  "LAICISE": "to free from clerical control, also LAICIZE [v LAICISED, LAICISING, LAICISES]\n",
  "LAICISED": "LAICISE, to free from clerical control, also LAICIZE [v]\n",
  "LAICISES": "LAICISE, to free from clerical control, also LAICIZE [v]\n",
  "LAICISING": "LAICISE, to free from clerical control, also LAICIZE [v]\n",
  "LAICISM": "a political system free from clerical control [n -S]\n",
  "LAICISMS": "LAICISM, a political system free from clerical control [n]\n",
  "LAICITIES": "LAICITY, the state of being lay [n]\n",
  "LAICITY": "the state of being lay [n LAICITIES]\n",
  "LAICIZATION": "the process of returning a clergyman to lay status, also LAICISATION [n -S]\n",
  "LAICIZATIONS": "LAICIZATION, the process of returning a clergyman to lay status, also LAICISATION [n]\n",
  "LAICIZE": "to free from clerical control, also LAICISE [v LAICIZED, LAICIZING, LAICIZES]\n",
  "LAICIZED": "LAICIZE, to free from clerical control, also LAICISE [v]\n",
  "LAICIZES": "LAICIZE, to free from clerical control, also LAICISE [v]\n",
  "LAICIZING": "LAICIZE, to free from clerical control, also LAICISE [v]\n",
  "LAICS": "LAIC, a lay person [n]\n",
  "LAID": "(Scots) to load, also LADE, LADEN, LOAD, LOADEN [v -ED, -ING, -S]\n",
  "LAIDED": "LAID, (Scots) to load, also LADE, LADEN, LOAD, LOADEN [v]\n",
  "LAIDING": "LAID, (Scots) to load, also LADE, LADEN, LOAD, LOADEN [v]\n",
  "LAIDLIER": "LAIDLY, (Scots) loathly, also LAITHLY, LOATHLY [adj]\n",
  "LAIDLIEST": "LAIDLY, (Scots) loathly, also LAITHLY, LOATHLY [adj]\n",
  "LAIDLY": "(Scots) loathly, also LAITHLY, LOATHLY [adj LAIDLIER, LAIDLIEST]\n",
  "LAIDS": "LAID, (Scots) to load, also LADE, LADEN, LOAD, LOADEN [v]\n",
  "LAIGH": "(Scots) low, also LAICH [adj LAIGHER, LAIGHEST] / a piece of low-lying ground; a hollow [n -S]\n",
  "LAIGHER": "LAIGH, (Scots) low, also LAICH [adj]\n",
  "LAIGHEST": "LAIGH, (Scots) low, also LAICH [adj]\n",
  "LAIGHS": "LAIGH, a piece of low-lying ground; a hollow [n]\n",
  "LAIK": "(Scots) to sport or play, also LAKE [v -ED, -ING, -S]\n",
  "LAIKA": "(Russian) a breed of small reddish-brown working dog [n -S]\n",
  "LAIKAS": "LAIKA, (Russian) a breed of small reddish-brown working dog [n]\n",
  "LAIKED": "LAIK, (Scots) to sport or play, also LAKE [v]\n",
  "LAIKER": "one who sports or plays [n -S]\n",
  "LAIKERS": "LAIKER, one who sports or plays [n]\n",
  "LAIKING": "LAIK, (Scots) to sport or play, also LAKE [v]\n",
  "LAIKS": "LAIK, (Scots) to sport or play, also LAKE [v]\n",
  "LAIN": "LIE, to make an intentional false statement [v]\n",
  "LAIPSE": "(dialect) to defeat thoroughly [v LAIPSED, LAIPSING, LAIPSES]\n",
  "LAIPSED": "LAIPSE, (dialect) to defeat thoroughly [v]\n",
  "LAIPSES": "LAIPSE, (dialect) to defeat thoroughly [v]\n",
  "LAIPSING": "LAIPSE, (dialect) to defeat thoroughly [v]\n",
  "LAIR": "the den or retreat of a wild animal [n -S] / to go to a lair [v -ED, -ING, -S]\n",
  "LAIRAGE": "cattle housing [n -S]\n",
  "LAIRAGES": "LAIRAGE, cattle housing [n]\n",
  "LAIRD": "(Scots) the owner of a landed estate [n -S]\n",
  "LAIRDLIER": "LAIRDLY, like a laird [adj]\n",
  "LAIRDLIEST": "LAIRDLY, like a laird [adj]\n",
  "LAIRDLY": "like a laird [adj LAIRDLIER, LAIRDLIEST]\n",
  "LAIRDS": "LAIRD, (Scots) the owner of a landed estate [n]\n",
  "LAIRDSHIP": "the office of a laird [n -S]\n",
  "LAIRDSHIPS": "LAIRDSHIP, the office of a laird [n]\n",
  "LAIRED": "LAIR, to go to a lair [v]\n",
  "LAIRIER": "LAIRY, flashily dressed [adj]\n",
  "LAIRIEST": "LAIRY, flashily dressed [adj]\n",
  "LAIRING": "LAIR, to go to a lair [v]\n",
  "LAIRISE": "(Australian) to act like a flashy man, also LAIRIZE [v LAIRISED, LAIRISING, LAIRISES]\n",
  "LAIRISED": "LAIRISE, (Australian) to act like a flashy man, also LAIRIZE [v]\n",
  "LAIRISES": "LAIRISE, (Australian) to act like a flashy man, also LAIRIZE [v]\n",
  "LAIRISING": "LAIRISE, (Australian) to act like a flashy man, also LAIRIZE [v]\n",
  "LAIRIZE": "(Australian) tto act like a flashy man, also LAIRISE [v LAIRIZED, LAIRIZING, LAIRIZES]\n",
  "LAIRIZED": "LAIRIZE, (Australian) tto act like a flashy man, also LAIRISE [v]\n",
  "LAIRIZES": "LAIRIZE, (Australian) tto act like a flashy man, also LAIRISE [v]\n",
  "LAIRIZING": "LAIRIZE, (Australian) tto act like a flashy man, also LAIRISE [v]\n",
  "LAIRS": "LAIR, to go to a lair [v]\n",
  "LAIRY": "flashily dressed [adj LAIRIER, LAIRIEST]\n",
  "LAISSE": "(French) a tirade or string of verses on one rhyme [n -S]\n",
  "LAISSES": "LAISSE, (French) a tirade or string of verses on one rhyme [n]\n",
  "LAITANCE": "(French) a milky deposit on the surface of fresh concrete [n -S]\n",
  "LAITANCES": "LAITANCE, (French) a milky deposit on the surface of fresh concrete [n]\n",
  "LAITH": "(Scots) loth, also LOATH, LOTH [adj LAITHLY]\n",
  "LAITHLY": "(Scots) loathly, also LAIDLY, LOATHLY [adj]\n",
  "LAITIES": "LAITY, the people as distinguished from some particular profession, usually clerical [n]\n",
  "LAITY": "the people as distinguished from some particular profession, usually clerical [n LAITIES]\n",
  "LAKE": "to sport or play also LAIK [v LAKED, LAKING, LAKES]\n",
  "LAKEBED": "the floor of a lake [n -S]\n",
  "LAKEBEDS": "LAKEBED, the floor of a lake [n]\n",
  "LAKED": "LAKE, to sport or play also LAIK [v]\n",
  "LAKEFILL": "an area of land built by filling a lake [n -S]\n",
  "LAKEFILLS": "LAKEFILL, an area of land built by filling a lake [n]\n",
  "LAKEFRONT": "the front of a lake [n -S]\n",
  "LAKEFRONTS": "LAKEFRONT, the front of a lake [n]\n",
  "LAKEHEAD": "the shore of a lake furthest from the outlet [n -S]\n",
  "LAKEHEADS": "LAKEHEAD, the shore of a lake furthest from the outlet [n]\n",
  "LAKELAND": "scenery with lakes [n -S]\n",
  "LAKELANDS": "LAKELAND, scenery with lakes [n]\n",
  "LAKELET": "a little lake [n -S]\n",
  "LAKELETS": "LAKELET, a little lake [n]\n",
  "LAKELIKE": "like a lake [adj]\n",
  "LAKEPORT": "a city located on the shore of a lake [n -S]\n",
  "LAKEPORTS": "LAKEPORT, a city located on the shore of a lake [n]\n",
  "LAKER": "a fish found in lakes; a type of ship which trades only in the Great Lakes of North America [n -S]\n",
  "LAKERS": "LAKER, a fish found in lakes; a type of ship which trades only in the Great Lakes of North America [n]\n",
  "LAKES": "LAKE, to sport or play also LAIK [v]\n",
  "LAKESHORE": "the shore of a lake [n -S]\n",
  "LAKESHORES": "LAKESHORE, the shore of a lake [n]\n",
  "LAKESIDE": "the land on the edge of a lake [n -S]\n",
  "LAKESIDES": "LAKESIDE, the land on the edge of a lake [n]\n",
  "LAKEVIEW": "overlooking a lake [adj]\n",
  "LAKEWARD": "facing a lake, also LAKEWARDS [adj]\n",
  "LAKEWARDS": "facing a lake, also LAKEWARD [adj]\n",
  "LAKH": "(Hindi) a unit of counting, one hundred thousand [n -S]\n",
  "LAKHS": "LAKH, (Hindi) a unit of counting, one hundred thousand [n]\n",
  "LAKIER": "LAKY, full of lakes [adj]\n",
  "LAKIEST": "LAKY, full of lakes [adj]\n",
  "LAKIN": "(Shakespeare) a little lady, also LADYKIN [n -S]\n",
  "LAKING": "the reddening of blood plasma by the release of haemoglobin from the red blood corpuscles [n -S]\n",
  "LAKINGS": "LAKING, the reddening of blood plasma by the release of haemoglobin from the red blood corpuscles [n]\n",
  "LAKINS": "LAKIN, (Shakespeare) a little lady, also LADYKIN [n]\n",
  "LAKISH": "like a lake [adj]\n",
  "LAKSA": "(Malay) rice noodles served in curry or hot soup [n -S]\n",
  "LAKSAS": "LAKSA, (Malay) rice noodles served in curry or hot soup [n]\n",
  "LAKY": "full of lakes [adj LAKIER, LAKIEST]\n",
  "LALANG": "(Malay) a coarse grass of the Malay archipelago, also ALANG [n -S]\n",
  "LALANGS": "LALANG, (Malay) a coarse grass of the Malay archipelago, also ALANG [n]\n",
  "LALAPALOOZA": "something excellent, also LALLAPALOOZA, LOLLAPALOOSA, LOLLAPALOOZA [n -S]\n",
  "LALAPALOOZAS": "LALAPALOOZA, something excellent, also LALLAPALOOZA, LOLLAPALOOSA, LOLLAPALOOZA [n]\n",
  "LALDIE": "(Scots) a beating or thrashing, also LALDY [n -S]\n",
  "LALDIES": "LALDIE, (Scots) a beating or thrashing, also LALDY [n]\n",
  "LALDY": "(Scots) a beating or thrashing, also LALDIE [n LALDIES]\n",
  "LALIQUE": "a style of cut glass or crystal [n -S]\n",
  "LALIQUES": "LALIQUE, a style of cut glass or crystal [n]\n",
  "LALL": "to articulate the letter R as L [v -ED, -ING, -S]\n",
  "LALLAN": "(Scots) lowland, also LALLAND, LAWLAND, LOWLAND [n -S]\n",
  "LALLAND": "(Scots) lowland, also LALLAN, LAWLAND, LOWLAND [n -S]\n",
  "LALLANDS": "LALLAND, (Scots) lowland, also LALLAN, LAWLAND, LOWLAND [n]\n",
  "LALLANS": "LALLAN, (Scots) lowland, also LALLAND, LAWLAND, LOWLAND [n]\n",
  "LALLAPALOOZA": "something excellent, also LALAPALOOZA, LOLLAPALOOSA, LOLLAPALOOZA [n -S]\n",
  "LALLAPALOOZAS": "LALLAPALOOZA, something excellent, also LALAPALOOZA, LOLLAPALOOSA, LOLLAPALOOZA [n]\n",
  "LALLATION": "infant's talk, or speech similar to it; the pronunciation of r as l [n -S]\n",
  "LALLATIONS": "LALLATION, infant's talk, or speech similar to it; the pronunciation of r as l [n]\n",
  "LALLED": "LALL, to articulate the letter R as L [v]\n",
  "LALLING": "babbling [n -S]\n",
  "LALLINGS": "LALLING, babbling [n]\n",
  "LALLS": "LALL, to articulate the letter R as L [v]\n",
  "LALLYGAG": "to dawdle, idle, also LOLLYGAG [v LALLYGAGGED, LALLYGAGGING, LALLYGAGS]\n",
  "LALLYGAGGED": "LALLYGAG, to dawdle, idle, also LOLLYGAG [v]\n",
  "LALLYGAGGING": "LALLYGAG, to dawdle, idle, also LOLLYGAG [v]\n",
  "LALLYGAGS": "LALLYGAG, to dawdle, idle, also LOLLYGAG [v]\n",
  "LAM": "to beat [v LAMMED, LAMMING, LAMS]\n",
  "LAMA": "a Buddhist monk [n -S]\n",
  "LAMAISTIC": "of or pertaining to Lamaism [adj]\n",
  "LAMANTIN": "(French) a large aquatic mammal, aka manatee [n -S]\n",
  "LAMANTINS": "LAMANTIN, (French) a large aquatic mammal, aka manatee [n]\n",
  "LAMAS": "LAMA, a Buddhist monk [n]\n",
  "LAMASERAI": "(Tibetan) a monastery or convent of lamas, in Tibet, Mongolia, etc., also LAMASERY [n -S]\n",
  "LAMASERAIS": "LAMASERAI, (Tibetan) a monastery or convent of lamas, in Tibet, Mongolia, etc., also LAMASERY [n]\n",
  "LAMASERIES": "LAMASERY, a monastery of lamas [n]\n",
  "LAMASERY": "a monastery of lamas [n LAMASERIES]\n",
  "LAMB": "a young sheep [n -S] / to give birth to baby sheep [v -ED, -ING, -S]\n",
  "LAMBADA": "a rhythmic energetic Latin-American dance [n -S]\n",
  "LAMBADAS": "LAMBADA, a rhythmic energetic Latin-American dance [n]\n",
  "LAMBAST": "to beat severely, also LAMBASTE [v -ED, -ING, -S]\n",
  "LAMBASTE": "to beat severely, also LAMBAST [v LAMBASTED, LAMBASTING, LAMBASTES]\n",
  "LAMBASTED": "LAMBAST, to beat severely, also LAMBASTE [v]\n",
  "LAMBASTES": "LAMBASTE, to beat severely, also LAMBAST [v]\n",
  "LAMBASTING": "LAMBAST, to beat severely, also LAMBASTE [v]\n",
  "LAMBASTS": "LAMBAST, to beat severely, also LAMBASTE [v]\n",
  "LAMBDA": "(Greek) the Greek letter L, also LABDA [n -S]\n",
  "LAMBDACISM": "a fault in speaking or in composition, which consists in too frequent use of the letter l, or in doubling it erroneously, also LABDACISM [n -S]\n",
  "LAMBDACISMS": "LAMBDACISM, a fault in speaking or in composition, which consists in too frequent use of the letter l, or in doubling it erroneously, also LABDACISM [n]\n",
  "LAMBDAS": "LAMBDA, (Greek) the Greek letter L, also LABDA [n]\n",
  "LAMBDOID": "shaped like the letter Greek lambda, also LAMBDOIDAL [adj]\n",
  "LAMBDOIDAL": "shaped like the Greek letter lambda, also LAMBDOID [adj]\n",
  "LAMBED": "LAMB, to give birth to baby sheep [v]\n",
  "LAMBENCIES": "LAMBENCY, the quality of being lambent [n]\n",
  "LAMBENCY": "the quality of being lambent [n LAMBENCIES]\n",
  "LAMBENT": "flickering like a flame [adj LAMBENTLY]\n",
  "LAMBENTLY": "LAMBENT, flickering like a flame [adv]\n",
  "LAMBER": "a ewe that is lambing [n -S]\n",
  "LAMBERS": "LAMBER, a ewe that is lambing [n]\n",
  "LAMBERT": "a unit of brightness [n -S]\n",
  "LAMBERTS": "LAMBERT, a unit of brightness [n]\n",
  "LAMBIE": "a small lamb, also LAMBKIN [n -S]\n",
  "LAMBIER": "LAMBY, resembling a lamb [adj]\n",
  "LAMBIES": "LAMBIE, a small lamb, also LAMBKIN [n]\n",
  "LAMBIEST": "LAMBY, resembling a lamb [adj]\n",
  "LAMBING": "giving birth to a lamb [n -S]\n",
  "LAMBINGS": "LAMBING, giving birth to a lamb [n]\n",
  "LAMBITIVE": "(obsolete) a medicine taken by licking [n -S]\n",
  "LAMBITIVES": "LAMBITIVE, (obsolete) a medicine taken by licking [n]\n",
  "LAMBKILL": "an evergreen shrub [n -S]\n",
  "LAMBKILLS": "LAMBKILL, an evergreen shrub [n]\n",
  "LAMBKIN": "a small lamb, also LAMBIE [n -S]\n",
  "LAMBKINS": "LAMBKIN, a small lamb, also LAMBIE [n]\n",
  "LAMBLIKE": "like a lamb [adj]\n",
  "LAMBLING": "a little lamb [n -S]\n",
  "LAMBLINGS": "LAMBLING, a little lamb [n]\n",
  "LAMBOYS": "(archaic) kilted flexible steel plates worn skirtlike from the waist [n]\n",
  "LAMBREQUIN": "(French) a veil over a helmet; a strip of drapery over a window or doorway [n -S]\n",
  "LAMBREQUINS": "LAMBREQUIN, (French) a veil over a helmet; a strip of drapery over a window or doorway [n]\n",
  "LAMBRUSCO": "(Italian) an Italian sparkling wine [n -S]\n",
  "LAMBRUSCOS": "LAMBRUSCO, (Italian) an Italian sparkling wine [n]\n",
  "LAMBS": "LAMB, to give birth to baby sheep [v]\n",
  "LAMBSKIN": "the skin of a lamb [n -S]\n",
  "LAMBSKINS": "LAMBSKIN, the skin of a lamb [n]\n",
  "LAMBSWOOL": "the wool of a lamb [n -S]\n",
  "LAMBSWOOLS": "LAMBSWOOL, the wool of a lamb [n]\n",
  "LAMBY": "resembling a lamb [adj LAMBIER, LAMBIEST]\n",
  "LAME": "disabled in the legs [adj LAMER, LAMEST, LAMELY] / to make lame [v LAMED, LAMING, LAMES]\n",
  "LAMEBRAIN": "an unintelligent person [n -S]\n",
  "LAMEBRAINED": "unintelligent [adj]\n",
  "LAMEBRAINS": "LAMEBRAIN, an unintelligent person [n]\n",
  "LAMED": "(Hebrew) a Hebrew letter, also LAMEDH [n -S]\n",
  "LAMEDH": "(Hebrew) a Hebrew letter, also LAMED [n -S]\n",
  "LAMEDHS": "LAMEDH, (Hebrew) a Hebrew letter, also LAMED [n]\n",
  "LAMEDS": "LAMED, (Hebrew) a Hebrew letter, also LAMEDH [n]\n",
  "LAMELLA": "(Latin) a thin plate or layer, also LAMINA [n LAMELLAS or LAMELLAE]\n",
  "LAMELLAE": "LAMELLA, (Latin) a thin plate or layer, also LAMINA [n]\n",
  "LAMELLAR": "flat and thin; composed of lamellae [adj]\n",
  "LAMELLARLY": "LAMELLAR, flat and thin; composed of lamellae [adv]\n",
  "LAMELLAS": "LAMELLA, (Latin) a thin plate or layer, also LAMINA [n]\n",
  "LAMELLATE": "composed of, or furnished with, thin plates or scales, also LAMELLATED [adj LAMELLATELY]\n",
  "LAMELLATED": "composed of, or furnished with, thin plates or scales, also LAMELLATE [adj]\n",
  "LAMELLATELY": "LAMELLATE, composed of, or furnished with, thin plates or scales, also LAMELLATED [adv]\n",
  "LAMELLATION": "the state of being lamellate [n -S]\n",
  "LAMELLATIONS": "LAMELLATION, the state of being lamellate [n]\n",
  "LAMELLIBRANCH": "any member of the Lamellibranchiata, bivalve molluscs including clams, mussels and oysters [n -S]\n",
  "LAMELLIBRANCHS": "LAMELLIBRANCH, any member of the Lamellibranchiata, bivalve molluscs including clams, mussels and oysters [n]\n",
  "LAMELLICORN": "a scarab or other beetle with leaf-tipped antennae [n -S]\n",
  "LAMELLICORNS": "LAMELLICORN, a scarab or other beetle with leaf-tipped antennae [n]\n",
  "LAMELLIFORM": "shaped like a plate or layer [adj]\n",
  "LAMELLIROSTRAL": "having transverse lamellae within the edge of the bill, also LAMELLIROSTRATE [adj]\n",
  "LAMELLIROSTRATE": "having transverse lamellae within the edge of the bill, also LAMELLIROSTRAL [adj]\n",
  "LAMELLOID": "like lamellae, in thin plates [adj]\n",
  "LAMELLOSE": "composed of, or having, lamellae [adj]\n",
  "LAMELLOSITIES": "LAMELLOSITY, the state of being lamellose [n]\n",
  "LAMELLOSITY": "the state of being lamellose [n LAMELLOSITIES]\n",
  "LAMELY": "LAME, disabled in the legs [adv]\n",
  "LAMENESS": "the state of being lame [n -ES]\n",
  "LAMENESSES": "LAMENESS, the state of being lame [n]\n",
  "LAMENT": "to cry out in grief [v -ED, -ING, -S]\n",
  "LAMENTABLE": "deserving or expressing sorrow [adj LAMENTABLY]\n",
  "LAMENTABLENESS": "LAMENTABLE, deserving or expressing sorrow [n]\n",
  "LAMENTABLY": "LAMENTABLE, deserving or expressing sorrow [adv]\n",
  "LAMENTATION": "an act or instance of lamenting [n -S]\n",
  "LAMENTATIONS": "LAMENTATION, an act or instance of lamenting [n]\n",
  "LAMENTED": "LAMENT, to cry out in grief [v]\n",
  "LAMENTEDLY": "LAMENTED, LAMENT, to cry out in grief [adv]\n",
  "LAMENTER": "one who laments [n -S]\n",
  "LAMENTERS": "LAMENTER, one who laments [n]\n",
  "LAMENTING": "expressing sorrow or regret [adj LAMENTINGLY] / the act of lamenting [n -S]\n",
  "LAMENTINGLY": "LAMENTING, expressing sorrow or regret [adv]\n",
  "LAMENTINGS": "LAMENTING, the act of lamenting [n]\n",
  "LAMENTS": "LAMENT, to cry out in grief [v]\n",
  "LAMER": "LAME, disabled in the legs [adj]\n",
  "LAMES": "LAME, to make lame [v]\n",
  "LAMEST": "LAME, disabled in the legs [adj]\n",
  "LAMESTREAM": "the traditional media such as newspapers, television and radio, considered by some people as old-fashioned and gullible when compared to online news sources such as blogs [n -S]\n",
  "LAMESTREAMS": "LAMESTREAM, the traditional media such as newspapers, television and radio, considered by some people as old-fashioned and gullible when compared to online news sources such as blogs [n]\n",
  "LAMETER": "(dialect) a cripple, also LAMIGER, LAMITER, LAMMIGER [n -S]\n",
  "LAMETERS": "LAMETER, (dialect) a cripple, also LAMIGER, LAMITER, LAMMIGER [n]\n",
  "LAMIA": "(Greek) a mythical monster with snake's body and woman's head and breasts [n LAMIAE or LAMIAS]\n",
  "LAMIAE": "LAMIA, (Greek) a mythical monster with snake's body and woman's head and breasts [n]\n",
  "LAMIAS": "LAMIA, (Greek) a mythical monster with snake's body and woman's head and breasts [n]\n",
  "LAMIGER": "(dialect) a cripple, also LAMETER, LAMITER, LAMMIGER [n -S]\n",
  "LAMIGERS": "LAMIGER, (dialect) a cripple, also LAMETER, LAMITER, LAMMIGER [n]\n",
  "LAMINA": "(Latin) a thin plate or layer, also LAMELLA [n LAMINAS or LAMINAE]\n",
  "LAMINABLE": "capable of being split into laminae or thin plates, as mica [adj]\n",
  "LAMINAE": "LAMINA, (Latin) a thin plate or layer, also LAMELLA [n]\n",
  "LAMINAL": "relating to a lamina [adj] / a consonant like l or n made with the blade of the tongue [n -S]\n",
  "LAMINALS": "LAMINAL, a consonant like l or n made with the blade of the tongue [n]\n",
  "LAMINAR": "pertaining to a lamina, also LAMINARY [adj]\n",
  "LAMINARIA": "a genus of large seaweeds with long and broad fronds, aka tangle [n -S]\n",
  "LAMINARIAN": "a brown seaweed [n -S]\n",
  "LAMINARIANS": "LAMINARIAN, a brown seaweed [n]\n",
  "LAMINARIAS": "LAMINARIA, a genus of large seaweeds with long and broad fronds, aka tangle [n]\n",
  "LAMINARIN": "a polysaccharide found in various brown algae [n -S]\n",
  "LAMINARINS": "LAMINARIN, a polysaccharide found in various brown algae [n]\n",
  "LAMINARISE": "to make laminar, also LAMINARIZE [v LAMINARISED, LAMINARISING, LAMINARISES]\n",
  "LAMINARISED": "LAMINARISE, to make laminar, also LAMINARIZE [v]\n",
  "LAMINARISES": "LAMINARISE, to make laminar, also LAMINARIZE [v]\n",
  "LAMINARISING": "LAMINARISE, to make laminar, also LAMINARIZE [v]\n",
  "LAMINARIZE": "to make laminar, also LAMINARISE [v LAMINARIZED, LAMINARIZING, LAMINARIZES]\n",
  "LAMINARIZED": "LAMINARIZE, to make laminar, also LAMINARISE [v]\n",
  "LAMINARIZES": "LAMINARIZE, to make laminar, also LAMINARISE [v]\n",
  "LAMINARIZING": "LAMINARIZE, to make laminar, also LAMINARISE [v]\n",
  "LAMINARY": "pertaining to a lamina, also LAMINAR [adj]\n",
  "LAMINAS": "LAMINA, (Latin) a thin plate or layer, also LAMELLA [n]\n",
  "LAMINATE": "to compress into a thin plate [v LAMINATED, LAMINATING, LAMINATES]\n",
  "LAMINATED": "LAMINATE, to compress into a thin plate [v]\n",
  "LAMINATES": "LAMINATE, to compress into a thin plate [v]\n",
  "LAMINATING": "LAMINATE, to compress into a thin plate [v]\n",
  "LAMINATION": "the act of laminating [n -S]\n",
  "LAMINATIONS": "LAMINATION, the act of laminating [n]\n",
  "LAMINATOR": "a device for laminating [n -S]\n",
  "LAMINATORS": "LAMINATOR, a device for laminating [n]\n",
  "LAMINECTOMIES": "LAMINECTOMY, a kind of operation on the spine [n]\n",
  "LAMINECTOMY": "a kind of operation on the spine [n LAMINECTOMIES]\n",
  "LAMING": "LAME, to make lame [v]\n",
  "LAMINGTON": "(Australian) a piece of sponge cake, coated in chocolate and coconut [n -S]\n",
  "LAMINGTONS": "LAMINGTON, (Australian) a piece of sponge cake, coated in chocolate and coconut [n]\n",
  "LAMININ": "a glycoprotein [n -S]\n",
  "LAMININS": "LAMININ, a glycoprotein [n]\n",
  "LAMINITIS": "inflammation of a horse's lamina [n -ES]\n",
  "LAMINITISES": "LAMINITIS, inflammation of a horse's lamina [n]\n",
  "LAMINOSE": "composed of laminae, also LAMINOUS [adj]\n",
  "LAMINOUS": "composed of laminae, also LAMINOSE [adj]\n",
  "LAMISH": "somewhat lame [adj]\n",
  "LAMISTER": "(US) a fugitive, also LAMSTER [n -S]\n",
  "LAMISTERS": "LAMISTER, (US) a fugitive, also LAMSTER [n]\n",
  "LAMITER": "(dialect) a cripple, also LAMETER, LAMIGER, LAMMIGER [n -S]\n",
  "LAMITERS": "LAMITER, (dialect) a cripple, also LAMETER, LAMIGER, LAMMIGER [n]\n",
  "LAMMED": "LAM, to beat [v]\n",
  "LAMMER": "(Scots) amber [n -S]\n",
  "LAMMERGEIER": "(German) a large European bird of prey, aka bearded vulture, also LAMMERGEYER [n -S]\n",
  "LAMMERGEIERS": "LAMMERGEIER, (German) a large European bird of prey, aka bearded vulture, also LAMMERGEYER [n]\n",
  "LAMMERGEYER": "(German) a large European bird of prey, aka bearded vulture, also LAMMERGEIER [n -S]\n",
  "LAMMERGEYERS": "LAMMERGEYER, (German) a large European bird of prey, aka bearded vulture, also LAMMERGEIER [n]\n",
  "LAMMERS": "LAMMER, (Scots) amber [n]\n",
  "LAMMIE": "a thick quilted jumper worn by sailors, also LAMMY [n -S]\n",
  "LAMMIES": "LAMMIE, a thick quilted jumper worn by sailors, also LAMMY [n]\n",
  "LAMMIGER": "(dialect) a cripple, also LAMETER, LAMIGER, LAMITER [n -S]\n",
  "LAMMIGERS": "LAMMIGER, (dialect) a cripple, also LAMETER, LAMIGER, LAMITER [n]\n",
  "LAMMING": "a thrashing [n -S]\n",
  "LAMMINGS": "LAMMING, a thrashing [n]\n",
  "LAMMY": "a thick quilted jumper worn by sailors, also LAMMIE [n LAMMIES]\n",
  "LAMP": "to supply with a light [v -ED, -ING, -S]\n",
  "LAMPAD": "a candlestick [n -S]\n",
  "LAMPADARIES": "LAMPADARY, in the Greek Church, someone who looks after the lamps and carries a lighted taper before the patriarch [n]\n",
  "LAMPADARY": "in the Greek Church, someone who looks after the lamps and carries a lighted taper before the patriarch [n LAMPADARIES]\n",
  "LAMPADEDROMIES": "LAMPADEDROMY, a foot race with lighted torches, esp. a relay race in which the torch is passed on, also LAMPADEPHORIA [n]\n",
  "LAMPADEDROMY": "a foot race with lighted torches, esp. a relay race in which the torch is passed on, also LAMPADEPHORIA [n LAMPADEDROMIES]\n",
  "LAMPADEPHORIA": "a foot race with lighted torches, esp. a relay race in which torch is passed on, also LAMPADEDROMY [n -S]\n",
  "LAMPADEPHORIAS": "LAMPADEPHORIA, a foot race with lighted torches, esp. a relay race in which torch is passed on, also LAMPADEDROMY [n]\n",
  "LAMPADIST": "one who gained the prize in a lampadedromy, a foot race with lighted torches [n -S]\n",
  "LAMPADISTS": "LAMPADIST, one who gained the prize in a lampadedromy, a foot race with lighted torches [n]\n",
  "LAMPADOMANCIES": "LAMPADOMANCY, divination using the flame of a torch [n]\n",
  "LAMPADOMANCY": "divination using the flame of a torch [n LAMPADOMANCIES]\n",
  "LAMPADS": "LAMPAD, a candlestick [n]\n",
  "LAMPAS": "inflammation of the roof of a horse's mouth, also LAMPASSE, LAMPERS [n LAMPASES or LAMPASSES]\n",
  "LAMPASES": "LAMPAS, inflammation of the roof of a horse's mouth, also LAMPASSE, LAMPERS [n]\n",
  "LAMPASSE": "(Shakespeare) inflammation of the roof of a horse's mouth, also LAMPAS, LAMPERS [n -S]\n",
  "LAMPASSES": "LAMPAS, inflammation of the roof of a horse's mouth, also LAMPASSE, LAMPERS [n]\n",
  "LAMPBLACK": "a finely divided form of almost pure carbon produced by the incomplete combustion of organic compounds [n -S] / to blacken with lampblack [v -ED, -ING, -S]\n",
  "LAMPBLACKED": "LAMPBLACK, to blacken with lampblack [v]\n",
  "LAMPBLACKING": "LAMPBLACK, to blacken with lampblack [v]\n",
  "LAMPBLACKS": "LAMPBLACK, a finely divided form of almost pure carbon produced by the incomplete combustion of organic compounds [n]\n",
  "LAMPBRUSH": "as in lampbrush chromosome, a chromosome observed during the early stages of meiosis in many eukaryotes [adj]\n",
  "LAMPED": "LAMP, to supply with a light [v]\n",
  "LAMPER": "a primitive fishlike vertebrate, also LAMPERN, LAMPREY [n -S]\n",
  "LAMPERN": "a primitive fishlike vertebrate, also LAMPER, LAMPREY [n -S]\n",
  "LAMPERNS": "LAMPERN, a primitive fishlike vertebrate, also LAMPER, LAMPREY [n]\n",
  "LAMPERS": "inflammation of the roof of a horse's mouth, also LAMPAS, LAMPASSE [n -ES]\n",
  "LAMPERSES": "LAMPERS, inflammation of the roof of a horse's mouth, also LAMPAS, LAMPASSE [n]\n",
  "LAMPHOLDER": "a socket for an electric bulb [n -S]\n",
  "LAMPHOLDERS": "LAMPHOLDER, a socket for an electric bulb [n]\n",
  "LAMPHOLE": "a shaft for lowering a lamp into a sewer [n -S]\n",
  "LAMPHOLES": "LAMPHOLE, a shaft for lowering a lamp into a sewer [n]\n",
  "LAMPING": "the hunting of rabbits etc. by using bright lights to lure them out of their holes [n -S]\n",
  "LAMPINGS": "LAMPING, the hunting of rabbits etc. by using bright lights to lure them out of their holes [n]\n",
  "LAMPION": "an oil lamp, often in a decorative coloured-glass pot [n -S]\n",
  "LAMPIONS": "LAMPION, an oil lamp, often in a decorative coloured-glass pot [n]\n",
  "LAMPLESS": "lacking a lamp [adj]\n",
  "LAMPLIGHT": "the light cast by a lamp [n -S]\n",
  "LAMPLIGHTER": "one whose job it is to light lamps [n -S]\n",
  "LAMPLIGHTERS": "LAMPLIGHTER, one whose job it is to light lamps [n]\n",
  "LAMPLIGHTS": "LAMPLIGHT, the light cast by a lamp [n]\n",
  "LAMPLIT": "lit by lamps [adj]\n",
  "LAMPOON": "to ridicule by personal satire [v -ED, -ING, -S]\n",
  "LAMPOONED": "LAMPOON, to ridicule by personal satire [v]\n",
  "LAMPOONER": "one who writes lampoons [n -S]\n",
  "LAMPOONERIES": "LAMPOONERY, the practice of lampooning [n]\n",
  "LAMPOONERS": "LAMPOONER, one who writes lampoons [n]\n",
  "LAMPOONERY": "the practice of lampooning [n LAMPOONERIES]\n",
  "LAMPOONING": "LAMPOON, to ridicule by personal satire [v]\n",
  "LAMPOONIST": "one who composes lampoons [n -S]\n",
  "LAMPOONISTS": "LAMPOONIST, one who composes lampoons [n]\n",
  "LAMPOONS": "LAMPOON, to ridicule by personal satire [v]\n",
  "LAMPPOST": "a post holding a streetlight [n -S]\n",
  "LAMPPOSTS": "LAMPPOST, a post holding a streetlight [n]\n",
  "LAMPREY": "a primitive fishlike vertebrate, also LAMPER, LAMPERN [n -S]\n",
  "LAMPREYS": "LAMPREY, a primitive fishlike vertebrate, also LAMPER, LAMPERN [n]\n",
  "LAMPROPHYRE": "a compact intrusive rock with phenocrysts of black mica, hornblende, etc. [n -S]\n",
  "LAMPROPHYRES": "LAMPROPHYRE, a compact intrusive rock with phenocrysts of black mica, hornblende, etc. [n]\n",
  "LAMPROPHYRIC": "of or like lamprophyre, a kind of basic igneous rock [adj]\n",
  "LAMPS": "LAMP, to supply with a light [v]\n",
  "LAMPSHADE": "a decorative or protective cover designed to moderate or direct the light of a lamp or light bulb [n -S]\n",
  "LAMPSHADES": "LAMPSHADE, a decorative or protective cover designed to moderate or direct the light of a lamp or light bulb [n]\n",
  "LAMPSHELL": "a kind of brachiopod with a shell shaped like an antique lamp [n -S]\n",
  "LAMPSHELLS": "LAMPSHELL, a kind of brachiopod with a shell shaped like an antique lamp [n]\n",
  "LAMPSTAND": "a stand for a lamp [n -S]\n",
  "LAMPSTANDS": "LAMPSTAND, a stand for a lamp [n]\n",
  "LAMPUKA": "(Maltese) an edible Mediterranean fish, also LAMPUKI [n -S]\n",
  "LAMPUKAS": "LAMPUKA, (Maltese) an edible Mediterranean fish, also LAMPUKI [n]\n",
  "LAMPUKI": "(Maltese) an edible Mediterranean fish, also LAMPUKA [n -S]\n",
  "LAMPUKIS": "LAMPUKI, (Maltese) an edible Mediterranean fish, also LAMPUKA [n]\n",
  "LAMPYRID": "a glowworm or firefly [n -S]\n",
  "LAMPYRIDS": "LAMPYRID, a glowworm or firefly [n]\n",
  "LAMS": "LAM, to beat [v]\n",
  "LAMSTER": "a fugitive, also LAMISTER [n -S]\n",
  "LAMSTERS": "LAMSTER, a fugitive, also LAMISTER [n]\n",
  "LANA": "the wood of the genipap, a large West Indian tree [n -S]\n",
  "LANAI": "(Hawaiian) a verandah or roofed patio [n -S]\n",
  "LANAIS": "LANAI, (Hawaiian) a verandah or roofed patio [n]\n",
  "LANAS": "LANA, the wood of the genipap, a large West Indian tree [n]\n",
  "LANATE": "having or consisting of a woolly covering of hairs, also LANATED, LANOSE [adj]\n",
  "LANATED": "having or consisting of a woolly covering of hairs, also LANATE, LANOSE [adj]\n",
  "LANCE": "to pierce with a spearlike weapon [v LANCED, LANCING, LANCES]\n",
  "LANCED": "LANCE, to pierce with a spearlike weapon [v]\n",
  "LANCEGAY": "(obsolete) a kind of spear, also LAUNCEGAYE [n -S]\n",
  "LANCEGAYS": "LANCEGAY, (obsolete) a kind of spear, also LAUNCEGAYE [n]\n",
  "LANCEJACK": "a lance corporal [n -S]\n",
  "LANCEJACKS": "LANCEJACK, a lance corporal [n]\n",
  "LANCELET": "any of a number of small elongated fishlike chordates that burrow in underwater sand [n -S]\n",
  "LANCELETS": "LANCELET, any of a number of small elongated fishlike chordates that burrow in underwater sand [n]\n",
  "LANCELIKE": "like a lance [adj]\n",
  "LANCEOLAR": "lanceolate [adj]\n",
  "LANCEOLATE": "shaped like a lance-head, also LANCEOLATED [adj LANCEOLATELY]\n",
  "LANCEOLATED": "shaped like a lance-head, also LANCEOLATE [adj]\n",
  "LANCEOLATELY": "LANCEOLATE, shaped like a lance-head, also LANCEOLATED [adv]\n",
  "LANCER": "a cavalryman armed with a spear [n -S]\n",
  "LANCERS": "LANCER, a cavalryman armed with a spear [n]\n",
  "LANCES": "LANCE, to pierce with a spearlike weapon [v]\n",
  "LANCET": "a narrow, pointed arch [n -S]\n",
  "LANCETED": "having a lancet [adj]\n",
  "LANCETS": "LANCET, a narrow, pointed arch [n]\n",
  "LANCEWOOD": "a tough, elastic wood, often used for the shafts of gigs, archery bows, fishing rods, and the like [n -S]\n",
  "LANCEWOODS": "LANCEWOOD, a tough, elastic wood, often used for the shafts of gigs, archery bows, fishing rods, and the like [n]\n",
  "LANCH": "to throw, as a lance; to let fly [v -ED, -ING, -ES]\n",
  "LANCHED": "LANCH, to throw, as a lance; to let fly [v]\n",
  "LANCHES": "LANCH, to throw, as a lance; to let fly [v]\n",
  "LANCHING": "LANCH, to throw, as a lance; to let fly [v]\n",
  "LANCIERS": "(French) a French dance [n]\n",
  "LANCIFORM": "shaped like a lance [adj]\n",
  "LANCINATE": "to pierce or tear [v LANCINATED, LANCINATING, LANCINATES]\n",
  "LANCINATED": "LANCINATE, to pierce or tear [v]\n",
  "LANCINATES": "LANCINATE, to pierce or tear [v]\n",
  "LANCINATING": "LANCINATE, to pierce or tear [v]\n",
  "LANCINATION": "a sharp, shooting pain [n -S]\n",
  "LANCINATIONS": "LANCINATION, a sharp, shooting pain [n]\n",
  "LANCING": "LANCE, to pierce with a spearlike weapon [v]\n",
  "LAND": "to set down on solid ground [v -ED, -ING, -S]\n",
  "LANDAMMAN": "(German) a chief magistrate in some of the Swiss cantons, also LANDAMMANN [n -S]\n",
  "LANDAMMANN": "(German) a chief magistrate in some of the Swiss cantons, also LANDAMMAN [n -S]\n",
  "LANDAMMANNS": "LANDAMMANN, (German) a chief magistrate in some of the Swiss cantons, also LANDAMMAN [n]\n",
  "LANDAMMANS": "LANDAMMAN, (German) a chief magistrate in some of the Swiss cantons, also LANDAMMANN [n]\n",
  "LANDAU": "(German) a horse-drawn carriage with folding top [n -S]\n",
  "LANDAULET": "a small landau, a horse-drawn carriage with folding top, also LANDAULETTE [n -S]\n",
  "LANDAULETS": "LANDAULET, a small landau, a horse-drawn carriage with folding top, also LANDAULETTE [n]\n",
  "LANDAULETTE": "a small landau, a horse-drawn carriage with folding top, also LANDAULET [n -S]\n",
  "LANDAULETTES": "LANDAULETTE, a small landau, a horse-drawn carriage with folding top, also LANDAULET [n]\n",
  "LANDAUS": "LANDAU, (German) a horse-drawn carriage with folding top [n]\n",
  "LANDBOARD": "a kind of large skateboard [n -S]\n",
  "LANDBOARDING": "the sport of being pulled along by a kite on a board [n -S]\n",
  "LANDBOARDINGS": "LANDBOARDING, the sport of being pulled along by a kite on a board [n]\n",
  "LANDBOARDS": "LANDBOARD, a kind of large skateboard [n]\n",
  "LANDDAMNE": "(Shakespeare) to abuse with violence [v LANDDAMNED, LANDDAMNING, LANDDAMNES]\n",
  "LANDDAMNED": "LANDDAMNE, (Shakespeare) to abuse with violence [v]\n",
  "LANDDAMNES": "LANDDAMNE, (Shakespeare) to abuse with violence [v]\n",
  "LANDDAMNING": "LANDDAMNE, (Shakespeare) to abuse with violence [v]\n",
  "LANDDROS": "(South African) in South Africa, a district magistrate or sheriff, also LANDDROST [n -ES]\n",
  "LANDDROSES": "LANDDROS, (South African) in South Africa, a district magistrate or sheriff, also LANDDROST [n]\n",
  "LANDDROST": "(South African) in South Africa, a district magistrate or sheriff, also LANDDROS [n -S]\n",
  "LANDDROSTS": "LANDDROST, (South African) in South Africa, a district magistrate or sheriff, also LANDDROS [n]\n",
  "LANDE": "(French) a heathy plain or sandy tract, esp. in SW France [n -S]\n",
  "LANDED": "LAND, to set down on solid ground [v]\n",
  "LANDER": "one who lands [n -S]\n",
  "LANDERS": "LANDER, one who lands [n]\n",
  "LANDES": "LANDE, (French) a heathy plain or sandy tract, esp. in SW France [n]\n",
  "LANDFALL": "an approach to land [n -S]\n",
  "LANDFALLS": "LANDFALL, an approach to land [n]\n",
  "LANDFAST": "of ice, attached to the shore [adj]\n",
  "LANDFILL": "a system of waste disposal [n -S] / to dispose waste into landfill [v -ED, -ING, -S]\n",
  "LANDFILLED": "LANDFILL, to dispose waste into landfill [v]\n",
  "LANDFILLING": "the process of filling in land by the disposal of rubbish [n -S]\n",
  "LANDFILLINGS": "LANDFILLING, the process of filling in land by the disposal of rubbish [n]\n",
  "LANDFILLS": "LANDFILL, to dispose waste into landfill [v]\n",
  "LANDFORCE": "a military force serving on land [n -S]\n",
  "LANDFORCES": "LANDFORCE, a military force serving on land [n]\n",
  "LANDFORM": "a natural feature of the earth's surface [n -S]\n",
  "LANDFORMS": "LANDFORM, a natural feature of the earth's surface [n]\n",
  "LANDGRAB": "a swift and often fraudulent seizure of land [n -S]\n",
  "LANDGRABS": "LANDGRAB, a swift and often fraudulent seizure of land [n]\n",
  "LANDGRAVATE": "the jurisdiction or position of a landgrave, also LANDGRAVIATE [n -S]\n",
  "LANDGRAVATES": "LANDGRAVATE, the jurisdiction or position of a landgrave, also LANDGRAVIATE [n]\n",
  "LANDGRAVE": "(historical) a German nobleman of a rank corresponding to that of an earl in England and of a count in France [n -S]\n",
  "LANDGRAVES": "LANDGRAVE, (historical) a German nobleman of a rank corresponding to that of an earl in England and of a count in France [n]\n",
  "LANDGRAVIATE": "the jurisdiction or position of a landgrave, also LANDGRAVATE [n -S]\n",
  "LANDGRAVIATES": "LANDGRAVIATE, the jurisdiction or position of a landgrave, also LANDGRAVATE [n]\n",
  "LANDGRAVINE": "a member of the German aristocracy [n -S]\n",
  "LANDGRAVINES": "LANDGRAVINE, a member of the German aristocracy [n]\n",
  "LANDHOLDER": "a holder, owner, or proprietor of land [n -S]\n",
  "LANDHOLDERS": "LANDHOLDER, a holder, owner, or proprietor of land [n]\n",
  "LANDHOLDING": "the state or fact of holding or owning land [n -S]\n",
  "LANDHOLDINGS": "LANDHOLDING, the state or fact of holding or owning land [n]\n",
  "LANDING": "a place to disembark or board [n -S]\n",
  "LANDINGS": "LANDING, a place to disembark or board [n]\n",
  "LANDLADIES": "LANDLADY, a female landlord [n]\n",
  "LANDLADY": "a female landlord [n LANDLADIES]\n",
  "LANDLER": "(German) a slow Austrian dance [n -S]\n",
  "LANDLERS": "LANDLER, (German) a slow Austrian dance [n]\n",
  "LANDLESS": "having no land [adj]\n",
  "LANDLESSNESS": "the state of being without lands [n -ES]\n",
  "LANDLESSNESSES": "LANDLESSNESS, the state of being without lands [n]\n",
  "LANDLINE": "a line of communication on land [n -S]\n",
  "LANDLINES": "LANDLINE, a line of communication on land [n]\n",
  "LANDLOCKED": "of a stretch of water, enclosed or nearly enclosed by land [adj]\n",
  "LANDLOPER": "(Dutch) a wanderer, a vagabond [n -S]\n",
  "LANDLOPERS": "LANDLOPER, (Dutch) a wanderer, a vagabond [n]\n",
  "LANDLORD": "one who owns and rents out real estate [n -S]\n",
  "LANDLORDISM": "an economic system or practice by which ownership of land is vested in one who leases it to cultivators [n -S]\n",
  "LANDLORDISMS": "LANDLORDISM, an economic system or practice by which ownership of land is vested in one who leases it to cultivators [n]\n",
  "LANDLORDS": "LANDLORD, one who owns and rents out real estate [n]\n",
  "LANDLUBBER": "a seaman's derogatory name for a landsman [n -S]\n",
  "LANDLUBBERLY": "like a landlubber, a seaman's derogatory name for a landsman [adj]\n",
  "LANDLUBBERS": "LANDLUBBER, a seaman's derogatory name for a landsman [n]\n",
  "LANDLUBBING": "having the characteristics of a landlubber [adj]\n",
  "LANDMAN": "a man who lives and works on land, also LANDSMAN [n LANDMEN]\n",
  "LANDMARK": "a conspicuous object on land marking a locality [n -S] / to mark land with a boundary line [v -ED, -ING, -S]\n",
  "LANDMARKED": "LANDMARK, to mark land with a boundary line [v]\n",
  "LANDMARKING": "LANDMARK, to mark land with a boundary line [v]\n",
  "LANDMARKS": "LANDMARK, to mark land with a boundary line [v]\n",
  "LANDMASS": "a large area of land [n -ES]\n",
  "LANDMASSES": "LANDMASS, a large area of land [n]\n",
  "LANDMEN": "LANDMAN, a man who lives and works on land, also LANDSMAN [n]\n",
  "LANDMINE": "to lay landmines [v LANDMINED, LANDMINING, LANDMINES]\n",
  "LANDMINED": "LANDMINE, to lay landmines [v]\n",
  "LANDMINES": "LANDMINE, to lay landmines [v]\n",
  "LANDMINING": "the act of laying landmines [n -S]\n",
  "LANDMININGS": "LANDMINING, the act of laying landmines [n]\n",
  "LANDOWNER": "one who owns land [n -S]\n",
  "LANDOWNERS": "LANDOWNER, one who owns land [n]\n",
  "LANDOWNERSHIP": "the office of landowner [n -S]\n",
  "LANDOWNERSHIPS": "LANDOWNERSHIP, the office of landowner [n]\n",
  "LANDOWNING": "the owning of land [n -S]\n",
  "LANDOWNINGS": "LANDOWNING, the owning of land [n]\n",
  "LANDRACE": "a large white Danish breed of pig [n -S]\n",
  "LANDRACES": "LANDRACE, a large white Danish breed of pig [n]\n",
  "LANDRAIL": "a bird with a rasping cry, aka corncrake [n -S]\n",
  "LANDRAILS": "LANDRAIL, a bird with a rasping cry, aka corncrake [n]\n",
  "LANDS": "LAND, to set down on solid ground [v]\n",
  "LANDSCAPE": "the appearance of the area of land which the eye can view at once [n -S] / to create a landscape [v LANDSCAPED, LANDSCAPING, LANDSCAPES]\n",
  "LANDSCAPED": "LANDSCAPE, to create a landscape [v]\n",
  "LANDSCAPER": "a landscape gardener [n -S]\n",
  "LANDSCAPERS": "LANDSCAPER, a landscape gardener [n]\n",
  "LANDSCAPES": "LANDSCAPE, to create a landscape [v]\n",
  "LANDSCAPING": "the act of doing various grounds maintenance [n -S]\n",
  "LANDSCAPINGS": "LANDSCAPING, the act of doing various grounds maintenance [n]\n",
  "LANDSCAPIST": "an artist who does landscapes [n -S]\n",
  "LANDSCAPISTS": "LANDSCAPIST, an artist who does landscapes [n]\n",
  "LANDSHARK": "a person who makes inordinate profits by buying and selling land [n -S]\n",
  "LANDSHARKS": "LANDSHARK, a person who makes inordinate profits by buying and selling land [n]\n",
  "LANDSIDE": "the flat side of a plough opposite the furrow [n -S]\n",
  "LANDSIDES": "LANDSIDE, the flat side of a plough opposite the furrow [n]\n",
  "LANDSKIP": "(archaic) a landscape, also LANTSKIP [n -S] / to landscape [v LANDSKIPPED, LANDSKIPPING, LANDSKIPS]\n",
  "LANDSKIPPED": "LANDSKIP, to landscape [v]\n",
  "LANDSKIPPING": "LANDSKIP, to landscape [v]\n",
  "LANDSKIPS": "LANDSKIP, to landscape [v]\n",
  "LANDSKNECHT": "(historical) a mercenary foot-soldier of the 16th century, also LANSQUENET, LANZKNECHT [n -S]\n",
  "LANDSKNECHTS": "LANDSKNECHT, (historical) a mercenary foot-soldier of the 16th century, also LANSQUENET, LANZKNECHT [n]\n",
  "LANDSLEIT": "LANDSMAN, (Yiddish) a fellow Jew from the same town in Eastern Europe [n]\n",
  "LANDSLID": "LANDSLIDE, to win an election by a huge majority [v]\n",
  "LANDSLIDDEN": "LANDSLIDE, to win an election by a huge majority [v]\n",
  "LANDSLIDE": "to win an election by a huge majority [v LANDSLID, LANDSLIDDEN, LANDSLIDING, LANDSLIDES]\n",
  "LANDSLIDES": "LANDSLIDE, to win an election by a huge majority [v]\n",
  "LANDSLIDING": "LANDSLIDE, to win an election by a huge majority [v]\n",
  "LANDSLIP": "the fall of a mass of earth [n -S]\n",
  "LANDSLIPS": "LANDSLIP, the fall of a mass of earth [n]\n",
  "LANDSMAN": "(Yiddish) a fellow Jew from the same town in Eastern Europe [n LANDSMEN or LANDSLEIT]\n",
  "LANDSMEN": "LANDSMAN, (Yiddish) a fellow Jew from the same town in Eastern Europe [n]\n",
  "LANDWAITER": "an officer of the custom house [n -S]\n",
  "LANDWAITERS": "LANDWAITER, an officer of the custom house [n]\n",
  "LANDWARD": "towards the land [adv]\n",
  "LANDWARDS": "in the direction of land, also LANDWARD [adv]\n",
  "LANDWASH": "the shore area between the high-water mark and the sea [n -ES]\n",
  "LANDWASHES": "LANDWASH, the shore area between the high-water mark and the sea [n]\n",
  "LANDWIND": "a wind blowing off the land [n -S]\n",
  "LANDWINDS": "LANDWIND, a wind blowing off the land [n]\n",
  "LANE": "a narrow passageway, also LANEWAY [n -S]\n",
  "LANELY": "(Scots) lonely [adj]\n",
  "LANES": "LANE, a narrow passageway, also LANEWAY [n]\n",
  "LANEWAY": "a narrow passageway, also LANE [n -S]\n",
  "LANEWAYS": "LANEWAY, a narrow passageway, also LANE [n]\n",
  "LANG": "(Scots) long [adj LANGER, LANGEST]\n",
  "LANGAHA": "(Malagasy) a colubriform snake of Madagascar, with a nose prolonged in the form of a sharp blade [n -S]\n",
  "LANGAHAS": "LANGAHA, (Malagasy) a colubriform snake of Madagascar, with a nose prolonged in the form of a sharp blade [n]\n",
  "LANGAR": "(Punjabi) a dining hall in a Sikh place of worship [n -S]\n",
  "LANGARS": "LANGAR, (Punjabi) a dining hall in a Sikh place of worship [n]\n",
  "LANGBEINITE": "a double sulfate of potassium and magnesium, used in the fertiliser industry [n -S]\n",
  "LANGBEINITES": "LANGBEINITE, a double sulfate of potassium and magnesium, used in the fertiliser industry [n]\n",
  "LANGER": "(vulgar Irish slang) a penis, a foolish person [n -S]\n",
  "LANGERED": "(colloquial) extremely drunk [adj]\n",
  "LANGERS": "LANGER, (vulgar Irish slang) a penis, a foolish person [n]\n",
  "LANGEST": "LANG, (Scots) long [adj]\n",
  "LANGLAUF": "(German) a cross-country ski run [n -S]\n",
  "LANGLAUFER": "a cross-country skier [n -S]\n",
  "LANGLAUFERS": "LANGLAUFER, a cross-country skier [n]\n",
  "LANGLAUFS": "LANGLAUF, (German) a cross-country ski run [n]\n",
  "LANGLEY": "a unit of illumination used to measure the temperature of a star [n -S]\n",
  "LANGLEYS": "LANGLEY, a unit of illumination used to measure the temperature of a star [n]\n",
  "LANGOSTINO": "the spiny lobster, also LANGOUSTE, LANGOUSTINE [n -S]\n",
  "LANGOSTINOS": "LANGOSTINO, the spiny lobster, also LANGOUSTE, LANGOUSTINE [n]\n",
  "LANGOUSTE": "(French) the spiny lobster, also LANGOSTINO, LANGOUSTINE [n -S]\n",
  "LANGOUSTES": "LANGOUSTE, (French) the spiny lobster, also LANGOSTINO, LANGOUSTINE [n]\n",
  "LANGOUSTINE": "the spiny lobster, also LANGOSTINO, LANGOUSTE [n -S]\n",
  "LANGOUSTINES": "LANGOUSTINE, the spiny lobster, also LANGOSTINO, LANGOUSTE [n]\n",
  "LANGRAGE": "a shot consisting of canister containing irregular pieces of iron, formerly used to damage sails and rigging, also LANGREL, LANGRIDGE [n -S]\n",
  "LANGRAGES": "LANGRAGE, a shot consisting of canister containing irregular pieces of iron, formerly used to damage sails and rigging, also LANGREL, LANGRIDGE [n]\n",
  "LANGREL": "a shot consisting of canister containing irregular pieces of iron, formerly used to damage sails and rigging, also LANGRAGE, LANGRIDGE [n -S]\n",
  "LANGRELS": "LANGREL, a shot consisting of canister containing irregular pieces of iron, formerly used to damage sails and rigging, also LANGRAGE, LANGRIDGE [n]\n",
  "LANGRIDGE": "a shot consisting of canister containing irregular pieces of iron, formerly used to damage sails and rigging, also LANGRAGE, LANGREL [n -S]\n",
  "LANGRIDGES": "LANGRIDGE, a shot consisting of canister containing irregular pieces of iron, formerly used to damage sails and rigging, also LANGRAGE, LANGREL [n]\n",
  "LANGSHAN": "(Chinese) a small black Chinese hen [n -S]\n",
  "LANGSHANS": "LANGSHAN, (Chinese) a small black Chinese hen [n]\n",
  "LANGSPEL": "(Norwegian) an old Shetland cithern, also LANGSPIEL, LANGSPIL [n -S]\n",
  "LANGSPELS": "LANGSPEL, (Norwegian) an old Shetland cithern, also LANGSPIEL, LANGSPIL [n]\n",
  "LANGSPIEL": "(Norwegian) an old Shetland cithern, also LANGSPEL, LANGSPIL [n -S]\n",
  "LANGSPIELS": "LANGSPIEL, (Norwegian) an old Shetland cithern, also LANGSPEL, LANGSPIL [n]\n",
  "LANGSPIL": "(Norwegian) an old Shetland cithern, also LANGSPEL, LANGSPIEL [n -S]\n",
  "LANGSPILS": "LANGSPIL, (Norwegian) an old Shetland cithern, also LANGSPEL, LANGSPIEL [n]\n",
  "LANGSYNE": "(Scots) long since; long ago, also LANGSYNES [adv]\n",
  "LANGSYNES": "(Scots) long since, long ago, also LANGSYNE [adv]\n",
  "LANGUAGE": "to express in a body of words serving as communication [v LANGUAGED, LANGUAGING, LANGUAGES]\n",
  "LANGUAGED": "LANGUAGE, to express in a body of words serving as communication [v]\n",
  "LANGUAGELESS": "(Shakespeare) without speech [adj]\n",
  "LANGUAGES": "LANGUAGE, to express in a body of words serving as communication [v]\n",
  "LANGUAGING": "LANGUAGE, to express in a body of words serving as communication [v]\n",
  "LANGUE": "(French) a language viewed as an abstract system used by a speech-community, in contrast to the actual linguistic behaviour (parole) of individuals [n -S]\n",
  "LANGUED": "of a heraldic beast, with tongue in a different colour [adj]\n",
  "LANGUES": "LANGUE, (French) a language viewed as an abstract system used by a speech-community, in contrast to the actual linguistic behaviour (parole) of individuals [n]\n",
  "LANGUESCENT": "growing languid [adj]\n",
  "LANGUET": "(French) a tonguelike appendage or outgrowth, also LANGUETTE [n -S]\n",
  "LANGUETS": "LANGUET, (French) a tonguelike appendage or outgrowth, also LANGUETTE [n]\n",
  "LANGUETTE": "(French) a tonguelike appendage or outgrowth, also LANGUET [n -S]\n",
  "LANGUETTES": "LANGUETTE, (French) a tonguelike appendage or outgrowth, also LANGUET [n]\n",
  "LANGUID": "lacking vitality [adj LANGUIDLY]\n",
  "LANGUIDLY": "LANGUID, lacking vitality [adv]\n",
  "LANGUIDNESS": "the state of being languid [n -ES]\n",
  "LANGUIDNESSES": "LANGUIDNESS, the state of being languid [n]\n",
  "LANGUISH": "to lose vitality [v -ED, -ING, -ES]\n",
  "LANGUISHED": "LANGUISH, to lose vitality [v]\n",
  "LANGUISHER": "one who languishes [n -S]\n",
  "LANGUISHERS": "LANGUISHER, one who languishes [n]\n",
  "LANGUISHES": "LANGUISH, to lose vitality [v]\n",
  "LANGUISHING": "losing vigor or vitality [adj LANGUISHINGLY] / the act of languishing [n -S]\n",
  "LANGUISHINGLY": "LANGUISHING, losing vigor or vitality [adv]\n",
  "LANGUISHINGS": "LANGUISHING, the act of languishing [n]\n",
  "LANGUISHMENT": "the act of languishing [n -S]\n",
  "LANGUISHMENTS": "LANGUISHMENT, the act of languishing [n]\n",
  "LANGUOR": "listlessness, weariness [n -S]\n",
  "LANGUOROUS": "producing or tending to produce languor [adj LANGUOROUSLY]\n",
  "LANGUOROUSLY": "LANGUOROUS, producing or tending to produce languor [adv]\n",
  "LANGUOROUSNESS": "LANGUOROUS, producing or tending to produce languor [n]\n",
  "LANGUORS": "LANGUOR, listlessness, weariness [n]\n",
  "LANGUR": "(Hindi) a long-tailed Asian monkey [n -S]\n",
  "LANGURS": "LANGUR, (Hindi) a long-tailed Asian monkey [n]\n",
  "LANIARD": "a fastening rope on a ship, also LANYARD [n -S]\n",
  "LANIARDS": "LANIARD, a fastening rope on a ship, also LANYARD [n]\n",
  "LANIARIES": "LANIARY, a pointed conical tooth [n]\n",
  "LANIARY": "a pointed conical tooth [n LANIARIES]\n",
  "LANIFEROUS": "wool-bearing, also LANIGEROUS [adj]\n",
  "LANIGEROUS": "wool-bearing, also LANIFEROUS [adj]\n",
  "LANITAL": "a woollike fibre [n -S]\n",
  "LANITALS": "LANITAL, a woollike fibre [n]\n",
  "LANK": "long and thin [adj LANKER, LANKEST, LANKLY] / to become limp [v -ED, -ING, -S]\n",
  "LANKED": "LANK, to become limp [v]\n",
  "LANKER": "LANK, long and thin [adj]\n",
  "LANKEST": "LANK, long and thin [adj]\n",
  "LANKIER": "LANKY, tall and thin [adj]\n",
  "LANKIEST": "LANKY, tall and thin [adj]\n",
  "LANKILY": "LANKY, tall and thin [adv]\n",
  "LANKINESS": "the state of being lanky [n -ES]\n",
  "LANKINESSES": "LANKINESS, the state of being lanky [n]\n",
  "LANKING": "LANK, to become limp [v]\n",
  "LANKLY": "LANK, long and thin [adv]\n",
  "LANKNESS": "the state of being lank [n -ES]\n",
  "LANKNESSES": "LANKNESS, the state of being lank [n]\n",
  "LANKS": "LANK, to become limp [v]\n",
  "LANKY": "tall and thin [adj LANKIER, LANKIEST, LANKILY]\n",
  "LANNER": "a kind of falcon [n -S]\n",
  "LANNERET": "the male lanner, a kind of falcon [n -S]\n",
  "LANNERETS": "LANNERET, the male lanner, a kind of falcon [n]\n",
  "LANNERS": "LANNER, a kind of falcon [n]\n",
  "LANOLATED": "covered with lanolin [adj]\n",
  "LANOLIN": "a fatty substance obtained from wool, also LANOLINE [n -S]\n",
  "LANOLINE": "a fatty substance obtained from wool, also LANOLIN [n -S]\n",
  "LANOLINES": "LANOLINE, a fatty substance obtained from wool, also LANOLIN [n]\n",
  "LANOLINS": "LANOLIN, a fatty substance obtained from wool, also LANOLINE [n]\n",
  "LANOSE": "covered with wool, also LANATE, LANATED [adj]\n",
  "LANOSITIES": "LANOSITY, woolliness [n]\n",
  "LANOSITY": "woolliness [n LANOSITIES]\n",
  "LANSQUENET": "(French) a mercenary foot soldier of the 16th century, also LANDSKNECHT, LANZKNECHT [n -S]\n",
  "LANSQUENETS": "LANSQUENET, (French) a mercenary foot soldier of the 16th century, also LANDSKNECHT, LANZKNECHT [n]\n",
  "LANT": "stale urine, used in wool-scouring [n -S]\n",
  "LANTANA": "a tropical shrub of the vervain family [n -S]\n",
  "LANTANAS": "LANTANA, a tropical shrub of the vervain family [n]\n",
  "LANTERLOO": "(obsolete) a card game, an ancestral form of loo [n -S]\n",
  "LANTERLOOS": "LANTERLOO, (obsolete) a card game, an ancestral form of loo [n]\n",
  "LANTERN": "a lamp or light in a case, also LANTHORN [n -S] / to provide with a case for carrying a light [v -ED, -ING, -S]\n",
  "LANTERNED": "LANTERN, to provide with a case for carrying a light [v]\n",
  "LANTERNING": "LANTERN, to provide with a case for carrying a light [v]\n",
  "LANTERNIST": "a person who works a magic lantern [n -S]\n",
  "LANTERNISTS": "LANTERNIST, a person who works a magic lantern [n]\n",
  "LANTERNS": "LANTERN, to provide with a case for carrying a light [v]\n",
  "LANTHANIDE": "a rare-earth element [n -S]\n",
  "LANTHANIDES": "LANTHANIDE, a rare-earth element [n]\n",
  "LANTHANON": "any element of the lanthanide series [n -S]\n",
  "LANTHANONS": "LANTHANON, any element of the lanthanide series [n]\n",
  "LANTHANUM": "a rare element of the group of the earth metals, allied to aluminium [n -S]\n",
  "LANTHANUMS": "LANTHANUM, a rare element of the group of the earth metals, allied to aluminium [n]\n",
  "LANTHORN": "(obsolete) a lantern, from folk etymology deriving from use of horn in lanterns [n -S]\n",
  "LANTHORNS": "LANTHORN, (obsolete) a lantern, from folk etymology deriving from use of horn in lanterns [n]\n",
  "LANTS": "LANT, stale urine, used in wool-scouring [n]\n",
  "LANTSKIP": "(Milton) landscape, also LANDSKIP [n -S]\n",
  "LANTSKIPS": "LANTSKIP, (Milton) landscape, also LANDSKIP [n]\n",
  "LANUGINOSE": "downy; covered with fine soft hair, also LANUGINOUS [adj]\n",
  "LANUGINOUS": "downy; covered with fine soft hair, also LANUGINOSE [adj]\n",
  "LANUGINOUSNESS": "LANUGINOUS, downy; covered with fine soft hair, also LANUGINOSE [n]\n",
  "LANUGO": "(Latin) a woolly down, esp. covering the human fetus [n -S]\n",
  "LANUGOS": "LANUGO, (Latin) a woolly down, esp. covering the human fetus [n]\n",
  "LANX": "(archaic) a platter [n LANCES]\n",
  "LANYARD": "a fastening rope on a ship, also LANIARD [n -S]\n",
  "LANYARDS": "LANYARD, a fastening rope on a ship, also LANIARD [n]\n",
  "LANZKNECHT": "(German) a mercenary foot-soldier of the 16th century, also LANDSKNECHT, LANSQUENET [n -S]\n",
  "LANZKNECHTS": "LANZKNECHT, (German) a mercenary foot-soldier of the 16th century, also LANDSKNECHT, LANSQUENET [n]\n",
  "LAODICEAN": "a person having a lukewarm attitude in religious matters [n -S]\n",
  "LAODICEANS": "LAODICEAN, a person having a lukewarm attitude in religious matters [n]\n",
  "LAOGAI": "(Chinese) the system of forced labor camps in China [n -S]\n",
  "LAOGAIS": "LAOGAI, (Chinese) the system of forced labor camps in China [n]\n",
  "LAP": "to extend beyond some limit [v LAPPED, LAPPING, LAPS]\n",
  "LAPAROSCOPE": "an instrument for viewing the interior of the peritoneal cavity [n -S]\n",
  "LAPAROSCOPES": "LAPAROSCOPE, an instrument for viewing the interior of the peritoneal cavity [n]\n",
  "LAPAROSCOPIC": "relating to laparoscopy [adj]\n",
  "LAPAROSCOPIES": "LAPAROSCOPY, an examination done via a laparoscope [n]\n",
  "LAPAROSCOPIST": "one who performs a laparoscopy [n -S]\n",
  "LAPAROSCOPISTS": "LAPAROSCOPIST, one who performs a laparoscopy [n]\n",
  "LAPAROSCOPY": "an examination done via a laparoscope [n LAPAROSCOPIES]\n",
  "LAPAROTOMIES": "LAPAROTOMY, a cutting through the walls of the abdomen, as in the Caesarean section [n]\n",
  "LAPAROTOMY": "a cutting through the walls of the abdomen, as in the Caesarean section [n LAPAROTOMIES]\n",
  "LAPBOARD": "a board used on the lap as a substitute for a table, as by tailors [n -S]\n",
  "LAPBOARDS": "LAPBOARD, a board used on the lap as a substitute for a table, as by tailors [n]\n",
  "LAPDOG": "a small dog fondled in the lap [n -S]\n",
  "LAPDOGS": "LAPDOG, a small dog fondled in the lap [n]\n",
  "LAPEL": "an extension of the collar of a garment, also LAPPEL [n -S]\n",
  "LAPELED": "having lapels, also LAPELLED [adj]\n",
  "LAPELLED": "having a lapel [adj]\n",
  "LAPELS": "LAPEL, an extension of the collar of a garment, also LAPPEL [n]\n",
  "LAPFUL": "as much as a lap can hold [n -S]\n",
  "LAPFULS": "LAPFUL, as much as a lap can hold [n]\n",
  "LAPHELD": "pertaining to a small computer [adj]\n",
  "LAPIDARIAN": "of or relating to stones; inscribed on stones [adj]\n",
  "LAPIDARIES": "LAPIDARY, an expert in gems, also LAPIDIST [n]\n",
  "LAPIDARIST": "one who polishes stones [n -S]\n",
  "LAPIDARISTS": "LAPIDARIST, one who polishes stones [n]\n",
  "LAPIDARY": "an expert in gems, also LAPIDIST [n LAPIDARIES]\n",
  "LAPIDATE": "to hurl stones at [v LAPIDATED, LAPIDATING, LAPIDATES]\n",
  "LAPIDATED": "LAPIDATE, to hurl stones at [v]\n",
  "LAPIDATES": "LAPIDATE, to hurl stones at [v]\n",
  "LAPIDATING": "LAPIDATE, to hurl stones at [v]\n",
  "LAPIDATION": "(archaic) the act of stoning [n -S]\n",
  "LAPIDATIONS": "LAPIDATION, (archaic) the act of stoning [n]\n",
  "LAPIDEOUS": "of or cut in stone [adj]\n",
  "LAPIDES": "LAPIS, (Latin) a stone, as in set phrases such as 'lapis philosophicus', philosopher's stone [n]\n",
  "LAPIDESCENCE": "(archaic) becoming like a stone [n -S]\n",
  "LAPIDESCENCES": "LAPIDESCENCE, (archaic) becoming like a stone [n]\n",
  "LAPIDESCENT": "(archaic) becoming stone; petrifying [adj]\n",
  "LAPIDICOLOUS": "living under stones [adj]\n",
  "LAPIDIFIC": "(archaic) forming stone [adj]\n",
  "LAPIDIFICATION": "(archaic) the formation of stone [n -S]\n",
  "LAPIDIFICATIONS": "LAPIDIFICATION, (archaic) the formation of stone [n]\n",
  "LAPIDIFIED": "LAPIDIFY, to turn to stone [v]\n",
  "LAPIDIFIES": "LAPIDIFY, to turn to stone [v]\n",
  "LAPIDIFY": "to turn to stone [v LAPIDIFIED, LAPIDIFYING, LAPIDIFIES]\n",
  "LAPIDIFYING": "LAPIDIFY, to turn to stone [v]\n",
  "LAPIDIST": "an expert in gems, also LAPIDARY [n -S]\n",
  "LAPIDISTS": "LAPIDIST, an expert in gems, also LAPIDARY [n]\n",
  "LAPILLI": "LAPILLUS, (Latin) a small stone ejected by volcanic eruption [n]\n",
  "LAPILLIFORM": "shaped like a small stone [adj]\n",
  "LAPILLUS": "(Latin) a small stone ejected by volcanic eruption [n LAPILLI]\n",
  "LAPIN": "(French) rabbit, rabbit fur [n -S]\n",
  "LAPINS": "LAPIN, (French) rabbit, rabbit fur [n]\n",
  "LAPIS": "(Latin) a stone, as in set phrases such as 'lapis philosophicus', philosopher's stone [n LAPISES or LAPIDES]\n",
  "LAPISES": "LAPIS, (Latin) a stone, as in set phrases such as 'lapis philosophicus', philosopher's stone [n]\n",
  "LAPJE": "(South African) a rag or piece of cloth, also LAPPIE [n -S]\n",
  "LAPJES": "LAPJE, (South African) a rag or piece of cloth, also LAPPIE [n]\n",
  "LAPPED": "LAP, to extend beyond some limit [v]\n",
  "LAPPEL": "an extension of the collar of a garment, also LAPEL [n -S]\n",
  "LAPPELS": "LAPPEL, an extension of the collar of a garment, also LAPEL [n]\n",
  "LAPPER": "(Scots) to curdle, also LOPPER [v -ED, -ING, -S]\n",
  "LAPPERED": "LAPPER, (Scots) to curdle, also LOPPER [v]\n",
  "LAPPERING": "LAPPER, (Scots) to curdle, also LOPPER [v]\n",
  "LAPPERS": "LAPPER, (Scots) to curdle, also LOPPER [v]\n",
  "LAPPET": "a fold or flap on a garment or headdress worn by priest [n -S]\n",
  "LAPPETED": "having a lappet [adj]\n",
  "LAPPETS": "LAPPET, a fold or flap on a garment or headdress worn by priest [n]\n",
  "LAPPIE": "(South African) a rag or piece of cloth, also LAPJE [n -S]\n",
  "LAPPIES": "LAPPIE, (South African) a rag or piece of cloth, also LAPJE [n]\n",
  "LAPPING": "the act of lapping [n -S]\n",
  "LAPPINGS": "LAPPING, the act of lapping [n]\n",
  "LAPS": "LAP, to extend beyond some limit [v]\n",
  "LAPSABLE": "liable to lapse, also LAPSIBLE [adj]\n",
  "LAPSANG": "(Chinese) a variety of souchong tea with a smoky flavour [n -S]\n",
  "LAPSANGS": "LAPSANG, (Chinese) a variety of souchong tea with a smoky flavour [n]\n",
  "LAPSE": "to pass into disuse [v LAPSED, LAPSING, LAPSES]\n",
  "LAPSED": "LAPSE, to pass into disuse [v]\n",
  "LAPSER": "one who lapses [n -S]\n",
  "LAPSERS": "LAPSER, one who lapses [n]\n",
  "LAPSES": "LAPSE, to pass into disuse [v]\n",
  "LAPSIBLE": "liable to lapse, also LAPSABLE [adj]\n",
  "LAPSING": "LAPSE, to pass into disuse [v]\n",
  "LAPSTONE": "a stone for the lap, on which shoemakers beat leather [n -S]\n",
  "LAPSTONES": "LAPSTONE, a stone for the lap, on which shoemakers beat leather [n]\n",
  "LAPSTRAKE": "a clinker-built boat, also LAPSTREAK [n -S]\n",
  "LAPSTRAKES": "LAPSTRAKE, a clinker-built boat, also LAPSTREAK [n]\n",
  "LAPSTREAK": "a clinker-built boat, also LAPSTRAKE [n -S]\n",
  "LAPSTREAKS": "LAPSTREAK, a clinker-built boat, also LAPSTRAKE [n]\n",
  "LAPSUS": "(Latin) a slip e.g. of the tongue [n LAPSUS]\n",
  "LAPTOP": "a small computer used in the lap [n -S]\n",
  "LAPTOPS": "LAPTOP, a small computer used in the lap [n]\n",
  "LAPTRAY": "a tray with a cushion, made to sit on one's lap and hold a book, meal etc. [n -S]\n",
  "LAPTRAYS": "LAPTRAY, a tray with a cushion, made to sit on one's lap and hold a book, meal etc. [n]\n",
  "LAPWING": "a bird of the plover family with crested head [n -S]\n",
  "LAPWINGS": "LAPWING, a bird of the plover family with crested head [n]\n",
  "LAPWORK": "work in which one part laps over another [n -S]\n",
  "LAPWORKS": "LAPWORK, work in which one part laps over another [n]\n",
  "LAQUEARIA": "(Latin) a ceiling consisting of panelled recessed compartments, with bands between the panels, also LACUNAR, LEQUEAR [n]\n",
  "LAR": "the god of a house [n LARS or LARES]\n",
  "LARBOARD": "the left-hand side of a ship [n -S]\n",
  "LARBOARDS": "LARBOARD, the left-hand side of a ship [n]\n",
  "LARCENER": "one who commits larceny, also LARCENIST [n -S]\n",
  "LARCENERS": "LARCENER, one who commits larceny, also LARCENIST [n]\n",
  "LARCENIES": "LARCENY, theft of personal property (replaced as a statutory crime in English law by theft) [n]\n",
  "LARCENIST": "one who commits larceny, also LARCENER [n -S]\n",
  "LARCENISTS": "LARCENIST, one who commits larceny, also LARCENER [n]\n",
  "LARCENOUS": "relating to larceny, theft of personal property [adj LARCENOUSLY]\n",
  "LARCENOUSLY": "LARCENOUS, relating to larceny, theft of personal property [adv]\n",
  "LARCENY": "theft of personal property (replaced as a statutory crime in English law by theft) [n LARCENIES]\n",
  "LARCH": "any tree of the coniferous genus Larix, distinguished from cedar by the deciduous leaves [n -ES]\n",
  "LARCHEN": "of or pertaining to the larch [adj]\n",
  "LARCHES": "LARCH, any tree of the coniferous genus Larix, distinguished from cedar by the deciduous leaves [n]\n",
  "LARCHWOOD": "the wood of the larch [n -S]\n",
  "LARCHWOODS": "LARCHWOOD, the wood of the larch [n]\n",
  "LARD": "to smear with the melted fat of pigs [v -ED, -ING, -S]\n",
  "LARDACEOUS": "of or like lard [adj]\n",
  "LARDALITE": "a coarse nepheline syenite, also LAURDALITE [n -S]\n",
  "LARDALITES": "LARDALITE, a coarse nepheline syenite, also LAURDALITE [n]\n",
  "LARDED": "LARD, to smear with the melted fat of pigs [v]\n",
  "LARDER": "a place where food is stored [n -S]\n",
  "LARDERER": "a person in charge of a larder [n -S]\n",
  "LARDERERS": "LARDERER, a person in charge of a larder [n]\n",
  "LARDERS": "LARDER, a place where food is stored [n]\n",
  "LARDIER": "LARDY, like lard [adj]\n",
  "LARDIEST": "LARDY, like lard [adj]\n",
  "LARDING": "LARD, to smear with the melted fat of pigs [v]\n",
  "LARDLIKE": "like lard [adj]\n",
  "LARDON": "a strip of bacon, also LARDOON [n -S]\n",
  "LARDONS": "LARDON, a strip of bacon, also LARDOON [n]\n",
  "LARDOON": "a strip of bacon, also LARDON [n -S]\n",
  "LARDOONS": "LARDOON, a strip of bacon, also LARDON [n]\n",
  "LARDS": "LARD, to smear with the melted fat of pigs [v]\n",
  "LARDY": "like lard [adj LARDIER, LARDIEST]\n",
  "LARE": "lore; learning [n -S]\n",
  "LAREE": "a monetary unit of Maldives, also LARI [n -S]\n",
  "LAREES": "LAREE, a monetary unit of Maldives, also LARI [n]\n",
  "LARES": "LARE, lore; learning [n]\n",
  "LARGANDO": "(Italian) becoming gradually slower (music) [adj]\n",
  "LARGE": "generosity [n -S] / great in size [adj LARGER, LARGEST, LARGELY]\n",
  "LARGEHEARTED": "having a generous disposition [adj]\n",
  "LARGELY": "LARGE, great in size [adv]\n",
  "LARGEMOUTH": "a kind of fish, a large black bass [n -S]\n",
  "LARGEMOUTHS": "LARGEMOUTH, a kind of fish, a large black bass [n]\n",
  "LARGEN": "to enlarge, also ENLARGEN [v -ED, -ING, -S]\n",
  "LARGENED": "LARGEN, to enlarge, also ENLARGEN [v]\n",
  "LARGENESS": "the state of being large [n -ES]\n",
  "LARGENESSES": "LARGENESS, the state of being large [n]\n",
  "LARGENING": "LARGEN, to enlarge, also ENLARGEN [v]\n",
  "LARGENS": "LARGEN, to enlarge, also ENLARGEN [v]\n",
  "LARGER": "LARGE, great in size [adj]\n",
  "LARGES": "LARGE, generosity [n]\n",
  "LARGESS": "(French) generosity, also LARGESSE [n -ES]\n",
  "LARGESSE": "(French) generosity, also LARGESS [n -S]\n",
  "LARGESSES": "LARGESSE, (French) generosity, also LARGESS [n]\n",
  "LARGEST": "LARGE, great in size [adj]\n",
  "LARGHETTO": "(Italian) rather slowly [adj] / a rather slow movement [n -S]\n",
  "LARGHETTOS": "LARGHETTO, a rather slow movement [n]\n",
  "LARGISH": "somewhat large [adj]\n",
  "LARGITION": "(archaic) the giving of largesse [n -S]\n",
  "LARGITIONS": "LARGITION, (archaic) the giving of largesse [n]\n",
  "LARGO": "(Italian) a slow musical movement [n -S]\n",
  "LARGOS": "LARGO, (Italian) a slow musical movement [n]\n",
  "LARI": "a monetary unit of Maldives, also LAREE [n -S]\n",
  "LARIAT": "(Spanish) to catch with a long rope with a running noose, also LASSO, LAZO [v -ED, -ING, -S]\n",
  "LARIATED": "LARIAT, (Spanish) to catch with a long rope with a running noose, also LASSO, LAZO [v]\n",
  "LARIATING": "LARIAT, (Spanish) to catch with a long rope with a running noose, also LASSO, LAZO [v]\n",
  "LARIATS": "LARIAT, (Spanish) to catch with a long rope with a running noose, also LASSO, LAZO [v]\n",
  "LARIGAN": "a type of leather boot, also LARRIGAN [n -S]\n",
  "LARIGANS": "LARIGAN, a type of leather boot, also LARRIGAN [n]\n",
  "LARINE": "of or pertaining to the gull family, also LAROID [adj]\n",
  "LARIS": "LARI, a monetary unit of Maldives, also LAREE [n]\n",
  "LARK": "to behave playfully [v -ED, -ING, -S]\n",
  "LARKED": "LARK, to behave playfully [v]\n",
  "LARKER": "a catcher of larks [n -S]\n",
  "LARKERS": "LARKER, a catcher of larks [n]\n",
  "LARKIER": "LARKY, given to larking, also LARKISH, LARKSOME [adj]\n",
  "LARKIEST": "LARKY, given to larking, also LARKISH, LARKSOME [adj]\n",
  "LARKINESS": "playfulness [n -ES]\n",
  "LARKINESSES": "LARKINESS, playfulness [n]\n",
  "LARKING": "LARK, to behave playfully [v]\n",
  "LARKISH": "given to larking, also LARKSOME, LARKY [adj]\n",
  "LARKISHNESS": "the state of being larkish [n -ES]\n",
  "LARKISHNESSES": "LARKISHNESS, the state of being larkish [n]\n",
  "LARKS": "LARK, to behave playfully [v]\n",
  "LARKSOME": "given to larking, also LARKISH, LARKY [adj]\n",
  "LARKSPUR": "any of various ranunculaceous plants of the genus Delphinium [n -S]\n",
  "LARKSPURS": "LARKSPUR, any of various ranunculaceous plants of the genus Delphinium [n]\n",
  "LARKY": "given to larking, also LARKISH, LARKSOME [adj LARKIER, LARKIEST]\n",
  "LARMIER": "(French) a corona or other course serving as a dripstone [n -S]\n",
  "LARMIERS": "LARMIER, (French) a corona or other course serving as a dripstone [n]\n",
  "LARN": "(dialect) to learn [v LARNED, LARNT, LARNING, LARNS]\n",
  "LARNAKES": "LARNAX, (Greek) a terracotta chest of ancient Greece [n]\n",
  "LARNAX": "(Greek) a terracotta chest of ancient Greece [n LARNAKES]\n",
  "LARNED": "LARN, (dialect) to learn [v]\n",
  "LARNEY": "(South African) a white person, a rich person [n -S] / of clothes, smart [adj LARNIER, LARNIEST]\n",
  "LARNEYS": "LARNEY, (South African) a white person, a rich person [n]\n",
  "LARNIER": "LARNEY, of clothes, smart [adj]\n",
  "LARNIEST": "LARNEY, of clothes, smart [adj]\n",
  "LARNING": "LARN, (dialect) to learn [v]\n",
  "LARNS": "LARN, (dialect) to learn [v]\n",
  "LARNT": "LARN, (dialect) to learn [v]\n",
  "LAROID": "of or pertaining to the gull family, also LARINE [adj]\n",
  "LARRIGAN": "a long boot made of oiled leather, worn by lumbermen etc., also LARIGAN [n -S]\n",
  "LARRIGANS": "LARRIGAN, a long boot made of oiled leather, worn by lumbermen etc., also LARIGAN [n]\n",
  "LARRIKIN": "(Australian slang) a hoodlum, a rowdy [n -S]\n",
  "LARRIKINISM": "(Australian slang) the activities of a larrikin, a hoodlum [n -S]\n",
  "LARRIKINISMS": "LARRIKINISM, (Australian slang) the activities of a larrikin, a hoodlum [n]\n",
  "LARRIKINS": "LARRIKIN, (Australian slang) a hoodlum, a rowdy [n]\n",
  "LARRUP": "to flog or thrash [v -ED, -ING, -S]\n",
  "LARRUPED": "LARRUP, to flog or thrash [v]\n",
  "LARRUPER": "one who larrups [n -S]\n",
  "LARRUPERS": "LARRUPER, one who larrups [n]\n",
  "LARRUPING": "LARRUP, to flog or thrash [v]\n",
  "LARRUPS": "LARRUP, to flog or thrash [v]\n",
  "LARS": "LAR, the god of a house [n]\n",
  "LARUM": "(archaic) alarm, also ALARM, ALARUM [n -S]\n",
  "LARUMS": "LARUM, (archaic) alarm, also ALARM, ALARUM [n]\n",
  "LARVA": "(Latin) an animal in an immature but active state [n LARVAS or LARVAE]\n",
  "LARVACEOUS": "relating to the Larvaceae, tunicates [adj]\n",
  "LARVAE": "LARVA, (Latin) an animal in an immature but active state [n]\n",
  "LARVAL": "of or like a larva [adj]\n",
  "LARVAS": "LARVA, (Latin) an animal in an immature but active state [n]\n",
  "LARVATE": "masked, also LARVATED [adj]\n",
  "LARVATED": "masked, also LARVATE [adj]\n",
  "LARVICIDAL": "killing larvae [adj]\n",
  "LARVICIDE": "to kill larvae [v LARVICIDED, LARVICIDING, LARVICIDES]\n",
  "LARVICIDED": "LARVICIDE, to kill larvae [v]\n",
  "LARVICIDES": "LARVICIDE, to kill larvae [v]\n",
  "LARVICIDING": "LARVICIDE, to kill larvae [v]\n",
  "LARVIFORM": "having the form or structure of a larva [adj]\n",
  "LARVIKITE": "a mineral, a soda syenite, also LAURVIKITE [n -S]\n",
  "LARVIKITES": "LARVIKITE, a mineral, a soda syenite, also LAURVIKITE [n]\n",
  "LARVIPAROUS": "giving birth to larvae [adj]\n",
  "LARYNGAL": "relating to the larynx [adj] / (phonics) a sound articulated at the larynx, also LARYNGEAL [n -S]\n",
  "LARYNGALS": "LARYNGAL, (phonics) a sound articulated at the larynx, also LARYNGEAL [n]\n",
  "LARYNGEAL": "relating to the larynx [adj] / (phonics) a sound articulated at the larynx, also LARYNGAL [n -S]\n",
  "LARYNGEALLY": "LARYNGEAL, relating to the larynx [adv]\n",
  "LARYNGEALS": "LARYNGEAL, (phonics) a sound articulated at the larynx, also LARYNGAL [n]\n",
  "LARYNGECTOMEE": "a person who has undergone a laryngectomy [n -S]\n",
  "LARYNGECTOMEES": "LARYNGECTOMEE, a person who has undergone a laryngectomy [n]\n",
  "LARYNGECTOMIES": "LARYNGECTOMY, the surgical removal of the larynx [n]\n",
  "LARYNGECTOMISED": "having undergone a laryngectomy, also LARYNGECTOMIZED [adj]\n",
  "LARYNGECTOMIZED": "having undergone a laryngectomy, also LARYNGECTOMISED [adj]\n",
  "LARYNGECTOMY": "the surgical removal of the larynx [n LARYNGECTOMIES]\n",
  "LARYNGES": "LARYNX, (Greek) an organ of the respiratory tract [n]\n",
  "LARYNGISMUS": "spasm of the larynx [n -ES]\n",
  "LARYNGISMUSES": "LARYNGISMUS, spasm of the larynx [n]\n",
  "LARYNGITIC": "of or like laryngitis [adj]\n",
  "LARYNGITIDES": "LARYNGITIS, inflammation of the larynx [n]\n",
  "LARYNGITIS": "inflammation of the larynx [n LARYNGITIDES or LARYNGITISES]\n",
  "LARYNGITISES": "LARYNGITIS, inflammation of the larynx [n]\n",
  "LARYNGOLOGIC": "relating to laryngology [adj]\n",
  "LARYNGOLOGICAL": "related to laryngology [adj]\n",
  "LARYNGOLOGIES": "LARYNGOLOGY, the study of the larynx [n]\n",
  "LARYNGOLOGIST": "a specialist in laryngology [n -S]\n",
  "LARYNGOLOGISTS": "LARYNGOLOGIST, a specialist in laryngology [n]\n",
  "LARYNGOLOGY": "the study of the larynx [n LARYNGOLOGIES]\n",
  "LARYNGOPHONIES": "LARYNGOPHONY, the sound of the voice as heard through the stethoscope applied over the larynx [n]\n",
  "LARYNGOPHONY": "the sound of the voice as heard through the stethoscope applied over the larynx [n LARYNGOPHONIES]\n",
  "LARYNGOSCOPE": "an instrument for examining the interior of the larynx [n -S]\n",
  "LARYNGOSCOPES": "LARYNGOSCOPE, an instrument for examining the interior of the larynx [n]\n",
  "LARYNGOSCOPIC": "of or like a laryngoscope, an instrument for examining the interior of the larynx [adj]\n",
  "LARYNGOSCOPIES": "LARYNGOSCOPY, examination by use of a laryngoscope [n]\n",
  "LARYNGOSCOPIST": "one who uses a laryngoscope, an instrument for examining the interior of the larynx [n -S]\n",
  "LARYNGOSCOPISTS": "LARYNGOSCOPIST, one who uses a laryngoscope, an instrument for examining the interior of the larynx [n]\n",
  "LARYNGOSCOPY": "examination by use of a laryngoscope [n LARYNGOSCOPIES]\n",
  "LARYNGOSPASM": "spasmodic closure of the larynx [n -S]\n",
  "LARYNGOSPASMS": "LARYNGOSPASM, spasmodic closure of the larynx [n]\n",
  "LARYNGOTOMIES": "LARYNGOTOMY, surgical removal of the larynx [n]\n",
  "LARYNGOTOMY": "surgical removal of the larynx [n LARYNGOTOMIES]\n",
  "LARYNX": "(Greek) an organ of the respiratory tract [n LARYNXES or LARYNGES]\n",
  "LARYNXES": "LARYNX, (Greek) an organ of the respiratory tract [n]\n",
  "LAS": "LA, the sixth tone of the diatonic scale, also LAH [n]\n",
  "LASAGNA": "(Italian) an Italian baked pasta dish, also LASAGNE [n -S]\n",
  "LASAGNAS": "LASAGNA, (Italian) an Italian baked pasta dish, also LASAGNE [n]\n",
  "LASAGNE": "(Italian) an Italian baked pasta dish, also LASAGNA [n -S]\n",
  "LASAGNES": "LASAGNE, (Italian) an Italian baked pasta dish, also LASAGNA [n]\n",
  "LASCAR": "(Hindi) an East Indian sailor, also LASHKAR [n -S]\n",
  "LASCARS": "LASCAR, (Hindi) an East Indian sailor, also LASHKAR [n]\n",
  "LASCIVIOUS": "lustful; inclining or tending to lechery [adj LASCIVIOUSLY]\n",
  "LASCIVIOUSLY": "LASCIVIOUS, lustful; inclining or tending to lechery [adv]\n",
  "LASCIVIOUSNESS": "LASCIVIOUS, lustful; inclining or tending to lechery [n]\n",
  "LASE": "to use a laser [v LASED, LASING, LASES]\n",
  "LASED": "LASE, to use a laser [v]\n",
  "LASER": "a source of high-intensity optical, infrared, or ultraviolet radiation produced as a result of stimulated emission maintained within a solid, liquid, or gaseous medium [n -S] / to treat with a laser [v -ED, -ING, -S]\n",
  "LASERDISC": "a disc similar to a long-playing record on which data is stored by the use of a laser, also LASERDISK [n -S]\n",
  "LASERDISCS": "LASERDISC, a disc similar to a long-playing record on which data is stored by the use of a laser, also LASERDISK [n]\n",
  "LASERDISK": "a disc similar to a long-playing record on which data is stored by the use of a laser, also LASERDISC [n -S]\n",
  "LASERDISKS": "LASERDISK, a disc similar to a long-playing record on which data is stored by the use of a laser, also LASERDISC [n]\n",
  "LASERED": "LASER, to treat with a laser [v]\n",
  "LASERING": "LASER, to treat with a laser [v]\n",
  "LASERS": "LASER, a source of high-intensity optical, infrared, or ultraviolet radiation produced as a result of stimulated emission maintained within a solid, liquid, or gaseous medium [n]\n",
  "LASERWORT": "any plant of the umbelliferous genus Laserpitium, the root of which yields a resinous substance of a bitter taste [n -S]\n",
  "LASERWORTS": "LASERWORT, any plant of the umbelliferous genus Laserpitium, the root of which yields a resinous substance of a bitter taste [n]\n",
  "LASES": "LASE, to use a laser [v]\n",
  "LASH": "to strike with a whip [v -ED, -ING, -ES]\n",
  "LASHED": "LASH, to strike with a whip [v]\n",
  "LASHER": "a rope for binding one thing to another [n -S]\n",
  "LASHERS": "LASHER, a rope for binding one thing to another [n]\n",
  "LASHES": "LASH, to strike with a whip [v]\n",
  "LASHING": "the act of lashing [n -S]\n",
  "LASHINGLY": "LASHING [adv]\n",
  "LASHINGS": "LASHING, the act of lashing [n]\n",
  "LASHINS": "(colloquial) an abundance, also LASHINGS [n]\n",
  "LASHKAR": "(Hindi) an East Indian sailor, also LASCAR [n -S]\n",
  "LASHKARS": "LASHKAR, (Hindi) an East Indian sailor, also LASCAR [n]\n",
  "LASHLESS": "of a whip, lacking a lash [adj]\n",
  "LASING": "the act of using a laser [n -S]\n",
  "LASINGS": "LASING, the act of using a laser [n]\n",
  "LASKET": "a loop at the foot of a sail, to fasten as an extra sail [n -S]\n",
  "LASKETS": "LASKET, a loop at the foot of a sail, to fasten as an extra sail [n]\n",
  "LASQUE": "(Persian) a thin, flat diamond [n -S]\n",
  "LASQUES": "LASQUE, (Persian) a thin, flat diamond [n]\n",
  "LASS": "(Scots) a girl, also LASSIE, LASSOCK [n -ES]\n",
  "LASSES": "LASS, (Scots) a girl, also LASSIE, LASSOCK [n]\n",
  "LASSI": "(Hindi) a drink based on sour milk, popular in the East [n -S]\n",
  "LASSIE": "(Scots) a girl, also LASS, LASSOCK [n -S]\n",
  "LASSIES": "LASSIE, (Scots) a girl, also LASS, LASSOCK [n]\n",
  "LASSIS": "LASSI, (Hindi) a drink based on sour milk, popular in the East [n]\n",
  "LASSITUDE": "the state of being tired or weary [n -S]\n",
  "LASSITUDES": "LASSITUDE, the state of being tired or weary [n]\n",
  "LASSLORN": "(Shakespeare) forsaken by one's mistress [adj]\n",
  "LASSO": "to catch with a long rope with a running noose, also LARIAT, LAZO [v -ED, -ING, -S or -ES]\n",
  "LASSOCK": "(Scots) a little lass, also LASS, LASSIE [n -S]\n",
  "LASSOCKS": "LASSOCK, (Scots) a little lass, also LASS, LASSIE [n]\n",
  "LASSOED": "LASSO, to catch with a long rope with a running noose, also LARIAT, LAZO [v]\n",
  "LASSOER": "one who uses a lasso [n -S]\n",
  "LASSOERS": "LASSOER, one who uses a lasso [n]\n",
  "LASSOES": "LASSO, to catch with a long rope with a running noose, also LARIAT, LAZO [v]\n",
  "LASSOING": "the act of catching with a lasso [n -S]\n",
  "LASSOINGS": "LASSOING, the act of catching with a lasso [n]\n",
  "LASSOS": "LASSO, to catch with a long rope with a running noose, also LARIAT, LAZO [v]\n",
  "LASSU": "(Hungarian) the slow movement of a Hungarian dance [n -S]\n",
  "LASSUS": "LASSU, (Hungarian) the slow movement of a Hungarian dance [n]\n",
  "LASSY": "molasses [n LASSIES]\n",
  "LAST": "coming after all others in sequence [adj LASTLY] / to continue in existence [v -ED, -ING, -S]\n",
  "LASTAGE": "a duty formerly paid for the right of carrying goods, etc. [n -S]\n",
  "LASTAGES": "LASTAGE, a duty formerly paid for the right of carrying goods, etc. [n]\n",
  "LASTBORN": "a child born last in a family [n -S]\n",
  "LASTBORNS": "LASTBORN, a child born last in a family [n]\n",
  "LASTED": "LAST, to continue in existence [v]\n",
  "LASTER": "a worker who shapes a boot or shoe by fixing the parts smoothly on a last [n -S]\n",
  "LASTERS": "LASTER, a worker who shapes a boot or shoe by fixing the parts smoothly on a last [n]\n",
  "LASTING": "remaining effective for a long period of time [adj LASTINGLY] / a sturdy cotton or worsted cloth [n -S]\n",
  "LASTINGLY": "LASTING, remaining effective for a long period of time [adv]\n",
  "LASTINGNESS": "the state of being lasting [n -ES]\n",
  "LASTINGNESSES": "LASTINGNESS, the state of being lasting [n]\n",
  "LASTINGS": "LASTING, a sturdy cotton or worsted cloth [n]\n",
  "LASTLY": "LAST, coming after all others in sequence [adv]\n",
  "LASTS": "LAST, to continue in existence [v]\n",
  "LAT": "(short for) latrine [n -S] / a Latvian unit of currency [n LATI or LATU]\n",
  "LATAH": "a psychological condition, observed esp. in Malaysian cultures, in which an individual, after experiencing a shock, becomes anxious and suggestible, often imitating the actions of another person [n -S]\n",
  "LATAHS": "LATAH, a psychological condition, observed esp. in Malaysian cultures, in which an individual, after experiencing a shock, becomes anxious and suggestible, often imitating the actions of another person [n]\n",
  "LATAKIA": "a superior quality of Turkish smoking tobacco [n -S]\n",
  "LATAKIAS": "LATAKIA, a superior quality of Turkish smoking tobacco [n]\n",
  "LATCH": "to close a gate with a catch [v -ED, -ING, -ES]\n",
  "LATCHED": "LATCH, to close a gate with a catch [v]\n",
  "LATCHES": "LATCH, to close a gate with a catch [v]\n",
  "LATCHET": "a thong used to fasten a shoe [n -S]\n",
  "LATCHETS": "LATCHET, a thong used to fasten a shoe [n]\n",
  "LATCHING": "LATCH, to close a gate with a catch [v]\n",
  "LATCHKEY": "a key for opening a latched door [n -S]\n",
  "LATCHKEYS": "LATCHKEY, a key for opening a latched door [n]\n",
  "LATCHSTRING": "a key or string for opening a latched door [n -S]\n",
  "LATCHSTRINGS": "LATCHSTRING, a key or string for opening a latched door [n]\n",
  "LATE": "coming after the expected time [adj LATER, LATEST, LATELY]\n",
  "LATECOMER": "one who arrives late [n -S]\n",
  "LATECOMERS": "LATECOMER, one who arrives late [n]\n",
  "LATED": "(Shakespeare) belated [adj]\n",
  "LATEEN": "a triangular sail rigged on a spar forming an angle of 45 degrees with the mast [n -S]\n",
  "LATEENER": "a lateenrigged vessel [n -S]\n",
  "LATEENERS": "LATEENER, a lateenrigged vessel [n]\n",
  "LATEENRIGGED": "rigged with lateen sails [adj]\n",
  "LATEENS": "LATEEN, a triangular sail rigged on a spar forming an angle of 45 degrees with the mast [n]\n",
  "LATELY": "not long ago [adv]\n",
  "LATEN": "to make or grow late [v -ED, -ING, -S]\n",
  "LATENCE": "the state of being latent, also LATENCY [n -S]\n",
  "LATENCES": "LATENCE, the state of being latent, also LATENCY [n]\n",
  "LATENCIES": "LATENCY, the state of being present but not obvious [n]\n",
  "LATENCY": "the state of being present but not obvious [n LATENCIES]\n",
  "LATENED": "LATEN, to make or grow late [v]\n",
  "LATENESS": "the quality of being late [n -ES]\n",
  "LATENESSES": "LATENESS, the quality of being late [n]\n",
  "LATENING": "LATEN, to make or grow late [v]\n",
  "LATENS": "LATEN, to make or grow late [v]\n",
  "LATENSIFICATION": "the intensification of a latent photographic image by chemical treatment or exposure to light of low intensity [n]\n",
  "LATENT": "hidden [adj LATENTLY] / a barely visible fingerprint that can be developed for study [n -S]\n",
  "LATENTLY": "LATENT, hidden [adv]\n",
  "LATENTS": "LATENT, a barely visible fingerprint that can be developed for study [n]\n",
  "LATER": "LATE, coming after the expected time [adj]\n",
  "LATERAD": "toward the side [adv]\n",
  "LATERAL": "sideways [adj LATERALLY] / to throw a sideways pass in football [v LATERALED or LATERALLED, LATERALING or LATERALLING, LATERALS]\n",
  "LATERALED": "LATERAL, to throw a sideways pass in football [v]\n",
  "LATERALING": "LATERAL, to throw a sideways pass in football [v]\n",
  "LATERALISATION": "the process of lateralising, also LATERALIZATION [n -S]\n",
  "LATERALISATIONS": "LATERALISATION, the process of lateralising, also LATERALIZATION [n]\n",
  "LATERALISE": "to make lateral, also LATERALIZE [v LATERALISED, LATERALISING, LATERALISES]\n",
  "LATERALISED": "LATERALISE, to make lateral, also LATERALIZE [v]\n",
  "LATERALISES": "LATERALISE, to make lateral, also LATERALIZE [v]\n",
  "LATERALISING": "LATERALISE, to make lateral, also LATERALIZE [v]\n",
  "LATERALITIES": "LATERALITY, the state or condition of being lateral [n]\n",
  "LATERALITY": "the state or condition of being lateral [n LATERALITIES]\n",
  "LATERALIZATION": "the process of lateralising, also LATERALISATION [n -S]\n",
  "LATERALIZATIONS": "LATERALIZATION, the process of lateralising, also LATERALISATION [n]\n",
  "LATERALIZE": "to make lateral, also LATERALISE [v LATERALIZED, LATERALIZING, LATERALIZES]\n",
  "LATERALIZED": "LATERALIZE, to make lateral, also LATERALISE [v]\n",
  "LATERALIZES": "LATERALIZE, to make lateral, also LATERALISE [v]\n",
  "LATERALIZING": "LATERALIZE, to make lateral, also LATERALISE [v]\n",
  "LATERALLED": "LATERAL, to throw a sideways pass in football [v]\n",
  "LATERALLING": "LATERAL, to throw a sideways pass in football [v]\n",
  "LATERALLY": "LATERAL, sideways [adv]\n",
  "LATERALS": "LATERAL, to throw a sideways pass in football [v]\n",
  "LATERBORN": "someone born later [n -S]\n",
  "LATERBORNS": "LATERBORN, someone born later [n]\n",
  "LATERIGRADE": "having a sideways manner of moving, as a crab [adj]\n",
  "LATERISATION": "conversion into laterite, also LATERIZATION [n -S]\n",
  "LATERISATIONS": "LATERISATION, conversion into laterite, also LATERIZATION [n]\n",
  "LATERISE": "to convert to laterite, also LATERIZE [v LATERISED, LATERISING, LATERISES]\n",
  "LATERISED": "LATERISE, to convert to laterite, also LATERIZE [v]\n",
  "LATERISES": "LATERISE, to convert to laterite, also LATERIZE [v]\n",
  "LATERISING": "LATERISE, to convert to laterite, also LATERIZE [v]\n",
  "LATERITE": "a highly weathered red soil rich in iron and aluminum oxides [n -S]\n",
  "LATERITES": "LATERITE, a highly weathered red soil rich in iron and aluminum oxides [n]\n",
  "LATERITIC": "of laterite; similar to laterite in composition [adj]\n",
  "LATERITIOUS": "brick-red in color [adj]\n",
  "LATERIZATION": "conversion into laterite, also LATERISATION [n -S]\n",
  "LATERIZATIONS": "LATERIZATION, conversion into laterite, also LATERISATION [n]\n",
  "LATERIZE": "to convert to laterite, also LATERISE [v LATERIZED, LATERIZING, LATERIZES]\n",
  "LATERIZED": "LATERIZE, to convert to laterite, also LATERISE [v]\n",
  "LATERIZES": "LATERIZE, to convert to laterite, also LATERISE [v]\n",
  "LATERIZING": "LATERIZE, to convert to laterite, also LATERISE [v]\n",
  "LATEROVERSION": "abnormal lateral displacement of a bodily organ or part, esp. of the uterus [n -S]\n",
  "LATEROVERSIONS": "LATEROVERSION, abnormal lateral displacement of a bodily organ or part, esp. of the uterus [n]\n",
  "LATESCENCE": "a slight withdrawal from view or knowledge [n -S]\n",
  "LATESCENCES": "LATESCENCE, a slight withdrawal from view or knowledge [n]\n",
  "LATESCENT": "becoming latent or hidden [adj]\n",
  "LATEST": "the most recent development [n -S]\n",
  "LATESTS": "LATEST, the most recent development [n]\n",
  "LATEWAKE": "an erroneous form of lykewake, a watch over a corpse, also LICHWAKE, LIKEWAKE, LIKEWALK, LYKEWAKE, LYKEWALK [n -S]\n",
  "LATEWAKES": "LATEWAKE, an erroneous form of lykewake, a watch over a corpse, also LICHWAKE, LIKEWAKE, LIKEWALK, LYKEWAKE, LYKEWALK [n]\n",
  "LATEWOOD": "the wood formed in the later part of a growth ring [n -S]\n",
  "LATEWOODS": "LATEWOOD, the wood formed in the later part of a growth ring [n]\n",
  "LATEX": "(Latin) the milky juice of rubber trees [n LATEXES or LATICES]\n",
  "LATEXES": "LATEX, (Latin) the milky juice of rubber trees [n]\n",
  "LATH": "to cover with thin strips of wood [v -ED, -ING, -S]\n",
  "LATHE": "a machine for turning wood, metal etc. [n -S] / to shape or cut on a type of machine [v LATHED, LATHING, LATHES]\n",
  "LATHED": "LATH, to cover with thin strips of wood [v]\n",
  "LATHEE": "(Hindi) in India, a heavy stick used as a weapon, also LATHI [n -S]\n",
  "LATHEES": "LATHEE, (Hindi) in India, a heavy stick used as a weapon, also LATHI [n]\n",
  "LATHEN": "made of lath, thin strips of wood [adj]\n",
  "LATHER": "to cover with a light foam [v -ED, -ING, -S]\n",
  "LATHERED": "LATHER, to cover with a light foam [v]\n",
  "LATHERER": "one who lathers [n -S]\n",
  "LATHERERS": "LATHERER, one who lathers [n]\n",
  "LATHERIER": "LATHERY, covered with lather [adj]\n",
  "LATHERIEST": "LATHERY, covered with lather [adj]\n",
  "LATHERING": "LATHER, to cover with a light foam [v]\n",
  "LATHERS": "LATHER, to cover with a light foam [v]\n",
  "LATHERY": "covered with lather [adj LATHERIER, LATHERIEST]\n",
  "LATHES": "LATHE, to shape or cut on a type of machine [v]\n",
  "LATHI": "(Hindi) in India, a heavy stick used as a weapon, also LATHEE [n -S]\n",
  "LATHIER": "LATHY, like a lath; long and slender [adj]\n",
  "LATHIEST": "LATHY, like a lath; long and slender [adj]\n",
  "LATHING": "work made by using laths, also LATHWORK [n -S]\n",
  "LATHINGS": "LATHING, work made by using laths, also LATHWORK [n]\n",
  "LATHIS": "LATHI, (Hindi) in India, a heavy stick used as a weapon, also LATHEE [n]\n",
  "LATHLIKE": "like a lath, long and slender [adj]\n",
  "LATHS": "LATH, to cover with thin strips of wood [v]\n",
  "LATHWORK": "work made by using laths, also LATHING [n -S]\n",
  "LATHWORKS": "LATHWORK, work made by using laths, also LATHING [n]\n",
  "LATHY": "like a lath; long and slender [adj LATHIER, LATHIEST]\n",
  "LATHYRISM": "a neurological disease producing paralysis of the legs, apparently caused by eating cultivated vetch [n -S]\n",
  "LATHYRISMS": "LATHYRISM, a neurological disease producing paralysis of the legs, apparently caused by eating cultivated vetch [n]\n",
  "LATHYRITIC": "of or like lathyrism [adj]\n",
  "LATHYRUS": "(Greek) any plant of the Lathyrus genus, that includes sweet peas [n -ES]\n",
  "LATHYRUSES": "LATHYRUS, (Greek) any plant of the Lathyrus genus, that includes sweet peas [n]\n",
  "LATI": "LAT, (short for) latrine [n]\n",
  "LATICES": "LATEX, (Latin) the milky juice of rubber trees [n]\n",
  "LATICIFER": "a cell or group of cells containing latex [n -S]\n",
  "LATICIFEROUS": "containing or conveying latex [adj]\n",
  "LATICIFERS": "LATICIFER, a cell or group of cells containing latex [n]\n",
  "LATICLAVE": "(historical) a broad stripe of purple on the fore part of the tunic, worn by senators in ancient Rome as an emblem of office [n -S]\n",
  "LATICLAVES": "LATICLAVE, (historical) a broad stripe of purple on the fore part of the tunic, worn by senators in ancient Rome as an emblem of office [n]\n",
  "LATIFONDI": "LATIFONDO, a great landed estate, also LATIFUNDIO, LATIFUNDIUM [n]\n",
  "LATIFONDO": "a great landed estate, also LATIFUNDIO, LATIFUNDIUM [n LATIFONDI]\n",
  "LATIFUNDIA": "LATIFUNDIUM, (Latin) a great landed estate, also LATIFONDO, LATIFUNDIO [n]\n",
  "LATIFUNDIO": "(Latin) a great landed estate, also LATIFONDO, LATIFUNDIUM [n -S]\n",
  "LATIFUNDIOS": "LATIFUNDIO, (Latin) a great landed estate, also LATIFONDO, LATIFUNDIUM [n]\n",
  "LATIFUNDIUM": "(Latin) a great landed estate, also LATIFONDO, LATIFUNDIO [n LATIFUNDIA]\n",
  "LATIGO": "(Spanish) a strap used to fasten a saddle [n -ES or -S]\n",
  "LATIGOES": "LATIGO, (Spanish) a strap used to fasten a saddle [n]\n",
  "LATIGOS": "LATIGO, (Spanish) a strap used to fasten a saddle [n]\n",
  "LATILLA": "a peeled limb used in ceilings [n -S]\n",
  "LATILLAS": "LATILLA, a peeled limb used in ceilings [n]\n",
  "LATIMERIA": "any fish of the coelacanth family [n -S]\n",
  "LATIMERIAS": "LATIMERIA, any fish of the coelacanth family [n]\n",
  "LATINA": "a female Latin American [n -S]\n",
  "LATINAS": "LATINA, a female Latin American [n]\n",
  "LATINISATION": "conversion into Latin, also LATINIZATION [n -S]\n",
  "LATINISATIONS": "LATINISATION, conversion into Latin, also LATINIZATION [n]\n",
  "LATINISE": "to translate into Latin, also LATINIZE [v LATINISED, LATINISING, LATINISES]\n",
  "LATINISED": "LATINISE, to translate into Latin, also LATINIZE [v]\n",
  "LATINISES": "LATINISE, to translate into Latin, also LATINIZE [v]\n",
  "LATINISING": "LATINISE, to translate into Latin, also LATINIZE [v]\n",
  "LATINITIES": "LATINITY, a manner of writing or speaking Latin [n]\n",
  "LATINITY": "a manner of writing or speaking Latin [n LATINITIES]\n",
  "LATINIZATION": "conversion into Latin, also LATINISATION [n -S]\n",
  "LATINIZATIONS": "LATINIZATION, conversion into Latin, also LATINISATION [n]\n",
  "LATINIZE": "to translate into Latin, also LATINISE [v LATINIZED, LATINIZING, LATINIZES]\n",
  "LATINIZED": "LATINIZE, to translate into Latin, also LATINISE [v]\n",
  "LATINIZES": "LATINIZE, to translate into Latin, also LATINISE [v]\n",
  "LATINIZING": "LATINIZE, to translate into Latin, also LATINISE [v]\n",
  "LATINO": "(Spanish) a (male) Latin American [n -S]\n",
  "LATINOS": "LATINO, (Spanish) a (male) Latin American [n]\n",
  "LATIROSTRAL": "having a broad beak, also LATIROSTRATE [adj]\n",
  "LATIROSTRATE": "having a broad beak, also LATIROSTRAL [adj]\n",
  "LATISEPTATE": "having a broad partition [adj]\n",
  "LATISH": "somewhat late [adj]\n",
  "LATITANCIES": "LATITANCY, the act or state of lying hid, or lurking [n]\n",
  "LATITANCY": "the act or state of lying hid, or lurking [n LATITANCIES]\n",
  "LATITANT": "lurking; lying in wait [adj]\n",
  "LATITAT": "(Latin) a writ based on the supposition that a person is in hiding [n -S]\n",
  "LATITATION": "a lying in concealment [n -S]\n",
  "LATITATIONS": "LATITATION, a lying in concealment [n]\n",
  "LATITATS": "LATITAT, (Latin) a writ based on the supposition that a person is in hiding [n]\n",
  "LATITUDE": "freedom from narrow restrictions [n -S]\n",
  "LATITUDES": "LATITUDE, freedom from narrow restrictions [n]\n",
  "LATITUDINAL": "relating to latitude [adj LATITUDINALLY]\n",
  "LATITUDINALLY": "LATITUDINAL, relating to latitude [adv]\n",
  "LATITUDINARIAN": "having broad and free views, esp. religious [adj] / a person of broad views [n -S]\n",
  "LATITUDINARIANS": "LATITUDINARIAN, a person of broad views [n]\n",
  "LATITUDINOUS": "broad or wide interpretation [adj]\n",
  "LATKE": "(Yiddish) a traditional Jewish pancake [n -S]\n",
  "LATKES": "LATKE, (Yiddish) a traditional Jewish pancake [n]\n",
  "LATOSOL": "a tropical soil [n -S]\n",
  "LATOSOLIC": "of or like latosol, a tropical soil [adj]\n",
  "LATOSOLS": "LATOSOL, a tropical soil [n]\n",
  "LATRANT": "barking, snarling [adj]\n",
  "LATRATION": "the act of yelping or barking [n -S]\n",
  "LATRATIONS": "LATRATION, the act of yelping or barking [n]\n",
  "LATRIA": "(Greek) in Roman Catholicism, the veneration accorded to God alone [n -S]\n",
  "LATRIAS": "LATRIA, (Greek) in Roman Catholicism, the veneration accorded to God alone [n]\n",
  "LATRINE": "a type of toilet [n -S]\n",
  "LATRINES": "LATRINE, a type of toilet [n]\n",
  "LATROCINIA": "LATROCINIUM, (obsolete) highway robbery, also LATROCINY [n]\n",
  "LATROCINIES": "LATROCINY, (obsolete) highway robbery, also LATROCINIUM [n]\n",
  "LATROCINIUM": "(obsolete) highway robbery, also LATROCINY [n LATROCINIA]\n",
  "LATROCINY": "(obsolete) highway robbery, also LATROCINIUM [n LATROCINIES]\n",
  "LATRON": "(obsolete) a robber, also LADRON, LADRONE [n -S]\n",
  "LATRONS": "LATRON, (obsolete) a robber, also LADRON, LADRONE [n]\n",
  "LATS": "LAT, (short for) latrine [n]\n",
  "LATTE": "(Italian) a white coffee [n -S]\n",
  "LATTEN": "metal in thin plates, also LATTIN [n -S]\n",
  "LATTENS": "LATTEN, metal in thin plates, also LATTIN [n]\n",
  "LATTER": "the second mentioned of two [n -S]\n",
  "LATTERLY": "lately [adv]\n",
  "LATTERMATH": "the latter, or second, mowing [n -S]\n",
  "LATTERMATHS": "LATTERMATH, the latter, or second, mowing [n]\n",
  "LATTERMOST": "last [adj]\n",
  "LATTERS": "LATTER, the second mentioned of two [n]\n",
  "LATTES": "LATTE, (Italian) a white coffee [n]\n",
  "LATTICE": "to form a network of crossed laths or bars [v LATTICED, LATTICING, LATTICES]\n",
  "LATTICED": "LATTICE, to form a network of crossed laths or bars [v]\n",
  "LATTICES": "LATTICE, to form a network of crossed laths or bars [v]\n",
  "LATTICEWORK": "a network of crossed laths or bars [n -S]\n",
  "LATTICEWORKS": "LATTICEWORK, a network of crossed laths or bars [n]\n",
  "LATTICING": "latticework [n -S]\n",
  "LATTICINGS": "LATTICING, latticework [n]\n",
  "LATTICINI": "LATTICINO, (Italian) a type of Venetian glassware containing decorative threads of milk-white glass, also LATTICINIO [n]\n",
  "LATTICINIO": "(Italian) a type of Venetian glassware containing decorative threads of milk-white glass, also LATTICINO [n LATTICINI]\n",
  "LATTICINO": "(Italian) a type of Venetian glassware containing decorative threads of milk-white glass, also LATTICINIO [n LATTICINI]\n",
  "LATTIN": "metal in thin plates, also LATTEN [n -S]\n",
  "LATTINS": "LATTIN, metal in thin plates, also LATTEN [n]\n",
  "LATU": "an edible Asian seaweed, having small green berrylike capsules [n -S]\n",
  "LATUS": "LATU, an edible Asian seaweed, having small green berrylike capsules [n]\n",
  "LAUAN": "(Tagalog) a lightweight hardwood timber produced by various Philippine trees [n -S]\n",
  "LAUANS": "LAUAN, (Tagalog) a lightweight hardwood timber produced by various Philippine trees [n]\n",
  "LAUCH": "(Scots) to laugh [v LEUCH or LEUGH, LEUCHEN or LEUGHEN, LAUCHING, LAUCHS]\n",
  "LAUCHING": "LAUCH, (Scots) to laugh [v]\n",
  "LAUCHS": "LAUCH, (Scots) to laugh [v]\n",
  "LAUD": "to praise [v -ED, -ING, -S]\n",
  "LAUDABILITIES": "LAUDABILITY, the state of being laudable [n]\n",
  "LAUDABILITY": "the state of being laudable [n LAUDABILITIES]\n",
  "LAUDABLE": "worthy of praise [adj]\n",
  "LAUDABLENESS": "the state of being laudable [n -ES]\n",
  "LAUDABLENESSES": "LAUDABLENESS, the state of being laudable [n]\n",
  "LAUDABLY": "LAUDABLE, worthy of praise [adv]\n",
  "LAUDANUM": "a type of opium preparation [n -S]\n",
  "LAUDANUMS": "LAUDANUM, a type of opium preparation [n]\n",
  "LAUDATION": "the act of lauding; praise [n -S]\n",
  "LAUDATIONS": "LAUDATION, the act of lauding; praise [n]\n",
  "LAUDATIVE": "expressing praise [adj] / a eulogy [n -S]\n",
  "LAUDATIVES": "LAUDATIVE, a eulogy [n]\n",
  "LAUDATOR": "one who lauds, also LAUDER [n -S]\n",
  "LAUDATORIES": "LAUDATORY, a eulogy [n]\n",
  "LAUDATORS": "LAUDATOR, one who lauds, also LAUDER [n]\n",
  "LAUDATORY": "expressing praise [adj] / a eulogy [n LAUDATORIES]\n",
  "LAUDED": "LAUD, to praise [v]\n",
  "LAUDER": "one who lauds, also LAUDATOR [n -S]\n",
  "LAUDERS": "LAUDER, one who lauds, also LAUDATOR [n]\n",
  "LAUDING": "LAUD, to praise [v]\n",
  "LAUDS": "LAUD, to praise [v]\n",
  "LAUF": "(German) a run in a bobsleigh contest [n -S]\n",
  "LAUFS": "LAUF, (German) a run in a bobsleigh contest [n]\n",
  "LAUGH": "to express mirth by explosive inarticulate sounds [v -ED, -ING, -S]\n",
  "LAUGHABLE": "ridiculous [adj LAUGHABLY]\n",
  "LAUGHABLENESS": "LAUGHABLE, ridiculous [n]\n",
  "LAUGHABLENESSES": "LAUGHABLENESS, LAUGHABLE, ridiculous [n]\n",
  "LAUGHABLY": "LAUGHABLE, ridiculous [adv]\n",
  "LAUGHED": "LAUGH, to express mirth by explosive inarticulate sounds [v]\n",
  "LAUGHER": "one who laughs [n -S]\n",
  "LAUGHERS": "LAUGHER, one who laughs [n]\n",
  "LAUGHFUL": "full of laughter [adj]\n",
  "LAUGHIER": "LAUGHY, inclined to laugh [adj]\n",
  "LAUGHIEST": "LAUGHY, inclined to laugh [adj]\n",
  "LAUGHING": "mirthful [adj LAUGHINGLY] / the act of laughing [n -S]\n",
  "LAUGHINGLY": "LAUGHING, mirthful [adv]\n",
  "LAUGHINGS": "LAUGHING, the act of laughing [n]\n",
  "LAUGHINGSTOCK": "an object of ridicule [n -S]\n",
  "LAUGHINGSTOCKS": "LAUGHINGSTOCK, an object of ridicule [n]\n",
  "LAUGHLINE": "a funny line in a dialogue [n -S]\n",
  "LAUGHLINES": "LAUGHLINE, a funny line in a dialogue [n]\n",
  "LAUGHS": "LAUGH, to express mirth by explosive inarticulate sounds [v]\n",
  "LAUGHSOME": "(archaic) exciting laughter; inclined to laugh [adj]\n",
  "LAUGHTER": "the act or sound of one who laughs [n -S]\n",
  "LAUGHTERS": "LAUGHTER, the act or sound of one who laughs [n]\n",
  "LAUGHWORTHIER": "LAUGHWORTHY, worthy of being laughed at [adj]\n",
  "LAUGHWORTHIEST": "LAUGHWORTHY, worthy of being laughed at [adj]\n",
  "LAUGHWORTHY": "worthy of being laughed at [adj LAUGHWORTHIER, LAUGHWORTHIEST]\n",
  "LAUGHY": "inclined to laugh [adj LAUGHIER, LAUGHIEST]\n",
  "LAUNCE": "(Spenser) to pierce [v LAUNCED, LAUNCING, LAUNCES]\n",
  "LAUNCED": "LAUNCE, (Spenser) to pierce [v]\n",
  "LAUNCEGAYE": "(obsolete) a kind of spear, also LANCEGAY [n -S]\n",
  "LAUNCEGAYES": "LAUNCEGAYE, (obsolete) a kind of spear, also LANCEGAY [n]\n",
  "LAUNCES": "LAUNCE, (Spenser) to pierce [v]\n",
  "LAUNCH": "to set in motion [v -ED, -ING, -ES]\n",
  "LAUNCHED": "LAUNCH, to set in motion [v]\n",
  "LAUNCHER": "a launching device [n -S]\n",
  "LAUNCHERS": "LAUNCHER, a launching device [n]\n",
  "LAUNCHES": "LAUNCH, to set in motion [v]\n",
  "LAUNCHING": "the act of making a launch [n -S]\n",
  "LAUNCHINGS": "LAUNCHING, the act of making a launch [n]\n",
  "LAUNCHPAD": "a platform from which a rocket can be launched [n -S]\n",
  "LAUNCHPADS": "LAUNCHPAD, a platform from which a rocket can be launched [n]\n",
  "LAUNCING": "LAUNCE, (Spenser) to pierce [v]\n",
  "LAUND": "(Shakespeare) a glade, a grassy place [n -S]\n",
  "LAUNDER": "to wash clothes [v -ED, -ING, -S]\n",
  "LAUNDERED": "LAUNDER, to wash clothes [v]\n",
  "LAUNDERER": "one who launders [n -S]\n",
  "LAUNDERERS": "LAUNDERER, one who launders [n]\n",
  "LAUNDERETTE": "a self-service laundry, also LAUNDRETTE [n -S]\n",
  "LAUNDERETTES": "LAUNDERETTE, a self-service laundry, also LAUNDRETTE [n]\n",
  "LAUNDERING": "the act of cleansing e.g. clothes, money [n -S]\n",
  "LAUNDERINGS": "LAUNDERING, the act of cleansing e.g. clothes, money [n]\n",
  "LAUNDERS": "LAUNDER, to wash clothes [v]\n",
  "LAUNDRESS": "a woman who does laundry [n -ES]\n",
  "LAUNDRESSES": "LAUNDRESS, a woman who does laundry [n]\n",
  "LAUNDRETTE": "a self-service laundry, also LAUNDERETTE [n -S]\n",
  "LAUNDRETTES": "LAUNDRETTE, a self-service laundry, also LAUNDERETTE [n]\n",
  "LAUNDRIES": "LAUNDRY, a place where clothes are washed and ironed [n]\n",
  "LAUNDRY": "a place where clothes are washed and ironed [n LAUNDRIES]\n",
  "LAUNDRYMAN": "a man who is a laundry worker [n LAUNDRYMEN]\n",
  "LAUNDRYMEN": "LAUNDRYMAN, a man who is a laundry worker [n]\n",
  "LAUNDRYWOMAN": "a woman who washes clothes for a living [n LAUNDRYWOMEN]\n",
  "LAUNDRYWOMEN": "LAUNDRYWOMAN, a woman who washes clothes for a living [n]\n",
  "LAUNDS": "LAUND, (Shakespeare) a glade, a grassy place [n]\n",
  "LAURA": "(Latin) a group of huts or cells inhabited by reclusive monks in Egypt and the Middle East, also LAVRA [n LAURAE or LAURAS]\n",
  "LAURACEOUS": "belonging to the laurel genus [adj]\n",
  "LAURAE": "LAURA, (Latin) a group of huts or cells inhabited by reclusive monks in Egypt and the Middle East, also LAVRA [n]\n",
  "LAURAS": "LAURA, (Latin) a group of huts or cells inhabited by reclusive monks in Egypt and the Middle East, also LAVRA [n]\n",
  "LAURDALITE": "a coarse nepheline syenite, also LARDALITE [n -S]\n",
  "LAURDALITES": "LAURDALITE, a coarse nepheline syenite, also LARDALITE [n]\n",
  "LAUREATE": "to crown with a wreath of evergreen leaves, also LAUREL [v LAUREATED, LAUREATING, LAUREATES]\n",
  "LAUREATED": "LAUREATE, to crown with a wreath of evergreen leaves, also LAUREL [v]\n",
  "LAUREATES": "LAUREATE, to crown with a wreath of evergreen leaves, also LAUREL [v]\n",
  "LAUREATESHIP": "the office of laureate [n -S]\n",
  "LAUREATESHIPS": "LAUREATESHIP, the office of laureate [n]\n",
  "LAUREATING": "LAUREATE, to crown with a wreath of evergreen leaves, also LAUREL [v]\n",
  "LAUREATION": "the act of crowning with laurel; graduation [n -S]\n",
  "LAUREATIONS": "LAUREATION, the act of crowning with laurel; graduation [n]\n",
  "LAUREL": "to crown with a wreath of evergreen leaves, also LAUREATE [v LAURELLED or LAURELED, LAURELLING or LAURELING, LAURELS]\n",
  "LAURELED": "LAUREL, to crown with a wreath of evergreen leaves, also LAUREATE [v]\n",
  "LAURELING": "LAUREL, to crown with a wreath of evergreen leaves, also LAUREATE [v]\n",
  "LAURELLED": "LAUREL, to crown with a wreath of evergreen leaves, also LAUREATE [v]\n",
  "LAURELLING": "LAUREL, to crown with a wreath of evergreen leaves, also LAUREATE [v]\n",
  "LAURELS": "LAUREL, to crown with a wreath of evergreen leaves, also LAUREATE [v]\n",
  "LAURIC": "as in lauric acid, an acid derived from laurel berries [adj]\n",
  "LAURUSTINE": "a winter-flowering shrub, also LAURUSTINUS [n -S]\n",
  "LAURUSTINES": "LAURUSTINE, a winter-flowering shrub, also LAURUSTINUS [n]\n",
  "LAURUSTINUS": "a winter-flowering shrub, also LAURUSTINE [n -ES]\n",
  "LAURUSTINUSES": "LAURUSTINUS, a winter-flowering shrub, also LAURUSTINE [n]\n",
  "LAURVIKITE": "a mineral, a soda syenite, also LARVIKITE [n -S]\n",
  "LAURVIKITES": "LAURVIKITE, a mineral, a soda syenite, also LARVIKITE [n]\n",
  "LAURYL": "a radical in lauryl alcohol, an ingredient in some detergents [n -S]\n",
  "LAURYLS": "LAURYL, a radical in lauryl alcohol, an ingredient in some detergents [n]\n",
  "LAUWINE": "(German) an avalanche, also LAWINE [n -S]\n",
  "LAUWINES": "LAUWINE, (German) an avalanche, also LAWINE [n]\n",
  "LAV": "(short for) lavatory [n -S]\n",
  "LAVA": "molten rock that issues from a volcano [n -S]\n",
  "LAVABO": "(Latin) a fixed basin or washstand [n -ES or -S]\n",
  "LAVABOES": "LAVABO, (Latin) a fixed basin or washstand [n]\n",
  "LAVABOS": "LAVABO, (Latin) a fixed basin or washstand [n]\n",
  "LAVAFORM": "in the form of lava [adj]\n",
  "LAVAGE": "the irrigation or washing out of of an organ [n -S]\n",
  "LAVAGES": "LAVAGE, the irrigation or washing out of of an organ [n]\n",
  "LAVAL": "of or pertaining to lava [adj]\n",
  "LAVALAVA": "(Samoan) a Polynesian kilt or skirt [n -S]\n",
  "LAVALAVAS": "LAVALAVA, (Samoan) a Polynesian kilt or skirt [n]\n",
  "LAVALIER": "(French) a loosely-tied bow; a jewelled pendant, also LAVALIERE, LAVALLIERE [n -S]\n",
  "LAVALIERE": "(French) a loosely-tied bow; a jewelled pendant, also LAVALIER, LAVALLIERE [n -S]\n",
  "LAVALIERES": "LAVALIERE, (French) a loosely-tied bow; a jewelled pendant, also LAVALIER, LAVALLIERE [n]\n",
  "LAVALIERS": "LAVALIER, (French) a loosely-tied bow; a jewelled pendant, also LAVALIERE, LAVALLIERE [n]\n",
  "LAVALIKE": "like lava [adj]\n",
  "LAVALLIERE": "(French) a loosely-tied bow; a jewelled pendant, also LAVALIER, LAVALIERE [n -S]\n",
  "LAVALLIERES": "LAVALLIERE, (French) a loosely-tied bow; a jewelled pendant, also LAVALIER, LAVALIERE [n]\n",
  "LAVANDIN": "a hybrid plant with blue or grey flowers, developed by crossing true lavender with spike lavender [n -S]\n",
  "LAVANDINS": "LAVANDIN, a hybrid plant with blue or grey flowers, developed by crossing true lavender with spike lavender [n]\n",
  "LAVAS": "LAVA, molten rock that issues from a volcano [n]\n",
  "LAVASH": "a thin flat bread of Armenian origin [n -ES]\n",
  "LAVASHES": "LAVASH, a thin flat bread of Armenian origin [n]\n",
  "LAVATERA": "any plant of the lavatera genus [n -S]\n",
  "LAVATERAS": "LAVATERA, any plant of the lavatera genus [n]\n",
  "LAVATION": "the act of washing or cleansing [n -S]\n",
  "LAVATIONAL": "relating to lavation [adj]\n",
  "LAVATIONS": "LAVATION, the act of washing or cleansing [n]\n",
  "LAVATORIAL": "relating to a lavatory [adj]\n",
  "LAVATORIES": "LAVATORY, a room equipped with toilet facilities [n]\n",
  "LAVATORY": "a room equipped with toilet facilities [n LAVATORIES]\n",
  "LAVE": "(archaic) to wash, bathe [v LAVED, LAVING, LAVES]\n",
  "LAVED": "LAVE, (archaic) to wash, bathe [v]\n",
  "LAVEER": "(archaic) to sail against the wind [v -ED, -ING, -S]\n",
  "LAVEERED": "LAVEER, (archaic) to sail against the wind [v]\n",
  "LAVEERING": "LAVEER, (archaic) to sail against the wind [v]\n",
  "LAVEERS": "LAVEER, (archaic) to sail against the wind [v]\n",
  "LAVEMENT": "a washing or bathing; a clyster [n -S]\n",
  "LAVEMENTS": "LAVEMENT, a washing or bathing; a clyster [n]\n",
  "LAVENDER": "a labiate plant with fragrant pale-lilac flowers [n -S] / to perfume with lavender [v -ED, -ING, -S]\n",
  "LAVENDERED": "LAVENDER, to perfume with lavender [v]\n",
  "LAVENDERING": "LAVENDER, to perfume with lavender [v]\n",
  "LAVENDERS": "LAVENDER, to perfume with lavender [v]\n",
  "LAVER": "an edible seaweed of various kinds, including ulva [n -S]\n",
  "LAVERBREAD": "a kind of bread made from seaweed [n -S]\n",
  "LAVERBREADS": "LAVERBREAD, a kind of bread made from seaweed [n]\n",
  "LAVEROCK": "(Scots) a songbird, the lark, also LAVROCK [n -S] / to catch larks [v -ED, -ING, -S]\n",
  "LAVEROCKED": "LAVEROCK, to catch larks [v]\n",
  "LAVEROCKING": "LAVEROCK, to catch larks [v]\n",
  "LAVEROCKS": "LAVEROCK, to catch larks [v]\n",
  "LAVERS": "LAVER, an edible seaweed of various kinds, including ulva [n]\n",
  "LAVES": "LAVE, (archaic) to wash, bathe [v]\n",
  "LAVING": "LAVE, (archaic) to wash, bathe [v]\n",
  "LAVISH": "to give generously [v -ED, -ING, -ES] / generous or profuse in giving [adj LAVISHER, LAVISHEST, LAVISHLY]\n",
  "LAVISHED": "LAVISH, to give generously [v]\n",
  "LAVISHER": "one who lavishes [n -S]\n",
  "LAVISHERS": "LAVISHER, one who lavishes [n]\n",
  "LAVISHES": "LAVISH, to give generously [v]\n",
  "LAVISHEST": "LAVISH, generous or profuse in giving [adj]\n",
  "LAVISHING": "LAVISH, to give generously [v]\n",
  "LAVISHLY": "LAVISH, generous or profuse in giving [adv]\n",
  "LAVISHMENT": "the act of lavishing [n -S]\n",
  "LAVISHMENTS": "LAVISHMENT, the act of lavishing [n]\n",
  "LAVISHNESS": "the state of being lavish [n -ES]\n",
  "LAVISHNESSES": "LAVISHNESS, the state of being lavish [n]\n",
  "LAVOLT": "(Shakespeare) a lively dance for couples in 3/4 time, also LAVOLTA, VOLTA [n -S] / to dance with much leaping and turning, also LAVOLTA [v -ED, -ING, -S]\n",
  "LAVOLTA": "(Shakespeare) a lively dance for couples in 3/4 time, also LAVOLT, VOLTA [n -S] / to dance with much leaping and turning, also LAVOLT [v -ED, -ING, -S]\n",
  "LAVOLTAED": "LAVOLTA, to dance with much leaping and turning, also LAVOLT [v]\n",
  "LAVOLTAING": "LAVOLTA, to dance with much leaping and turning, also LAVOLT [v]\n",
  "LAVOLTAS": "LAVOLTA, to dance with much leaping and turning, also LAVOLT [v]\n",
  "LAVOLTED": "LAVOLT, to dance with much leaping and turning, also LAVOLTA [v]\n",
  "LAVOLTING": "LAVOLT, to dance with much leaping and turning, also LAVOLTA [v]\n",
  "LAVOLTS": "LAVOLT, to dance with much leaping and turning, also LAVOLTA [v]\n",
  "LAVRA": "(Greek) a group of huts or cells inhabited by reclusive monks in Egypt and the Middle East, also LAURA [n -S]\n",
  "LAVRAS": "LAVRA, (Greek) a group of huts or cells inhabited by reclusive monks in Egypt and the Middle East, also LAURA [n]\n",
  "LAVROCK": "(Scots) a skylark, also LAVEROCK [n -S]\n",
  "LAVROCKS": "LAVROCK, (Scots) a skylark, also LAVEROCK [n]\n",
  "LAVS": "LAV, (short for) lavatory [n]\n",
  "LAVVIES": "LAVVY, (colloquial) lavatory [n]\n",
  "LAVVY": "(colloquial) lavatory [n LAVVIES]\n",
  "LAW": "(Scots) low [adj LAWER, LAWEST] / (obsolete) to take to court [v -ED, -ING, -S]\n",
  "LAWBOOK": "a book containing laws and the practise of it [n -S]\n",
  "LAWBOOKS": "LAWBOOK, a book containing laws and the practise of it [n]\n",
  "LAWBREAKER": "a person who violates the law [n -S]\n",
  "LAWBREAKERS": "LAWBREAKER, a person who violates the law [n]\n",
  "LAWBREAKING": "the act of breaking the law [n -S]\n",
  "LAWBREAKINGS": "LAWBREAKING, the act of breaking the law [n]\n",
  "LAWCOURT": "a court of justice [n -S]\n",
  "LAWCOURTS": "LAWCOURT, a court of justice [n]\n",
  "LAWED": "LAW, (obsolete) to take to court [v]\n",
  "LAWER": "LAW, (Scots) low [adj]\n",
  "LAWEST": "LAW, (Scots) low [adj]\n",
  "LAWFARE": "the practice of using the law against enemies, esp. by challenging the legality of military or foreign policy [n -S]\n",
  "LAWFARES": "LAWFARE, the practice of using the law against enemies, esp. by challenging the legality of military or foreign policy [n]\n",
  "LAWFUL": "allowed by law (the body of rules governing the affairs of a community) [adj LAWFULLY]\n",
  "LAWFULLY": "LAWFUL, allowed by law (the body of rules governing the affairs of a community) [adv]\n",
  "LAWFULNESS": "the state of being lawful [n -ES]\n",
  "LAWFULNESSES": "LAWFULNESS, the state of being lawful [n]\n",
  "LAWGIVER": "one who institutes a legal system [n -S]\n",
  "LAWGIVERS": "LAWGIVER, one who institutes a legal system [n]\n",
  "LAWGIVING": "the giving of law [n -S]\n",
  "LAWGIVINGS": "LAWGIVING, the giving of law [n]\n",
  "LAWIN": "(Scots) a bill or reckoning [n -S]\n",
  "LAWINE": "(German) an avalanche, also LAUWINE [n -S]\n",
  "LAWINES": "LAWINE, (German) an avalanche, also LAUWINE [n]\n",
  "LAWING": "a bill for food or drink in a tavern [n -S]\n",
  "LAWINGS": "LAWING, a bill for food or drink in a tavern [n]\n",
  "LAWINS": "LAWIN, (Scots) a bill or reckoning [n]\n",
  "LAWK": "(dialect) an interjection expressing surprise, also LAWKS [interj]\n",
  "LAWKS": "(dialect) an interjection expressing surprise, also LAWK [interj]\n",
  "LAWLAND": "(Scots) lowland, also LALLAN, LALLAND, LOWLAND [n -S]\n",
  "LAWLANDS": "LAWLAND, (Scots) lowland, also LALLAN, LALLAND, LOWLAND [n]\n",
  "LAWLESS": "having no laws [adj LAWLESSLY]\n",
  "LAWLESSLY": "LAWLESS, having no laws [adv]\n",
  "LAWLESSNESS": "the state of being lawless [n -ES]\n",
  "LAWLESSNESSES": "LAWLESSNESS, the state of being lawless [n]\n",
  "LAWLIKE": "being like the law [adj]\n",
  "LAWMAKER": "one who makes the laws [n -S]\n",
  "LAWMAKERS": "LAWMAKER, one who makes the laws [n]\n",
  "LAWMAKING": "the process of making law [n -S]\n",
  "LAWMAKINGS": "LAWMAKING, the process of making law [n]\n",
  "LAWMAN": "a law-enforcement officer [n LAWMEN]\n",
  "LAWMEN": "LAWMAN, a law-enforcement officer [n]\n",
  "LAWMONGER": "a trivially contentious lawyer [n -S]\n",
  "LAWMONGERS": "LAWMONGER, a trivially contentious lawyer [n]\n",
  "LAWN": "a smooth space of ground covered with grass [n -S] / to turn into lawn [v -ED, -ING, -S]\n",
  "LAWNED": "having a lawn [adj]\n",
  "LAWNIER": "LAWNY, covered with lawn [adj]\n",
  "LAWNIEST": "LAWNY, covered with lawn [adj]\n",
  "LAWNING": "LAWN, to turn into lawn [v]\n",
  "LAWNMOWER": "a machine for cutting grass [n -S]\n",
  "LAWNMOWERS": "LAWNMOWER, a machine for cutting grass [n]\n",
  "LAWNS": "LAWN, a smooth space of ground covered with grass [n]\n",
  "LAWNY": "covered with lawn [adj LAWNIER, LAWNIEST]\n",
  "LAWRENCIUM": "a transuranic element, atomic number 103, discovered in 1961 [n -S]\n",
  "LAWRENCIUMS": "LAWRENCIUM, a transuranic element, atomic number 103, discovered in 1961 [n]\n",
  "LAWS": "LAW, (obsolete) to take to court [v]\n",
  "LAWSUIT": "a legal action [n -S]\n",
  "LAWSUITS": "LAWSUIT, a legal action [n]\n",
  "LAWYER": "a member of the legal profession [n -S] / to work as a member of the legal profession [v -ED, -ING, -S]\n",
  "LAWYERED": "LAWYER, to work as a member of the legal profession [v]\n",
  "LAWYERING": "working as a member of the legal profession [n -S]\n",
  "LAWYERINGS": "LAWYERING, working as a member of the legal profession [n]\n",
  "LAWYERLIER": "LAWYERLY, like, or becoming, a lawyer [adj]\n",
  "LAWYERLIEST": "LAWYERLY, like, or becoming, a lawyer [adj]\n",
  "LAWYERLIKE": "like a lawyer [adj]\n",
  "LAWYERLY": "like, or becoming, a lawyer [adj LAWYERLIER, LAWYERLIEST]\n",
  "LAWYERS": "LAWYER, to work as a member of the legal profession [v]\n",
  "LAX": "slack, careless [adj LAXER, LAXEST, LAXLY] / to relax [v -ED, -ING, -ES]\n",
  "LAXATION": "the act of loosening or slackening [n -S]\n",
  "LAXATIONS": "LAXATION, the act of loosening or slackening [n]\n",
  "LAXATIVE": "a drug that stimulates evacuation of the bowels [n -S]\n",
  "LAXATIVENESS": "the state of being laxative [n -ES]\n",
  "LAXATIVENESSES": "LAXATIVENESS, the state of being laxative [n]\n",
  "LAXATIVES": "LAXATIVE, a drug that stimulates evacuation of the bowels [n]\n",
  "LAXATOR": "a muscle that relaxes an organ [n -S]\n",
  "LAXATORS": "LAXATOR, a muscle that relaxes an organ [n]\n",
  "LAXED": "LAX, to relax [v]\n",
  "LAXER": "LAX, slack, careless [adj]\n",
  "LAXES": "LAX, to relax [v]\n",
  "LAXEST": "LAX, slack, careless [adj]\n",
  "LAXING": "LAX, to relax [v]\n",
  "LAXISM": "the belief that an unlikely opinion may be safely followed [n -S]\n",
  "LAXISMS": "LAXISM, the belief that an unlikely opinion may be safely followed [n]\n",
  "LAXIST": "a person with low moral views [n -S]\n",
  "LAXISTS": "LAXIST, a person with low moral views [n]\n",
  "LAXITIES": "LAXITY, the state of being lax, also LAXNESS [n]\n",
  "LAXITY": "the state of being lax, also LAXNESS [n LAXITIES]\n",
  "LAXLY": "LAX, slack, careless [adv]\n",
  "LAXNESS": "the state of being lax, also LAXITY [n -ES]\n",
  "LAXNESSES": "LAXNESS, the state of being lax, also LAXITY [n]\n",
  "LAY": "to deposit as a wager [v LAID or LAYED, LAYING, LAYS]\n",
  "LAYABOUT": "a lazy person [n -S]\n",
  "LAYABOUTS": "LAYABOUT, a lazy person [n]\n",
  "LAYAWAY": "an item that has been reserved with a down payment [n -S]\n",
  "LAYAWAYS": "LAYAWAY, an item that has been reserved with a down payment [n]\n",
  "LAYBACK": "in climbing, a method of climbing a sharp-edged crack in a horizontal position [n -S] / to climb using the layback technique [v -ED, -ING, -S]\n",
  "LAYBACKED": "LAYBACK, to climb using the layback technique [v]\n",
  "LAYBACKING": "LAYBACK, to climb using the layback technique [v]\n",
  "LAYBACKS": "LAYBACK, to climb using the layback technique [v]\n",
  "LAYDEEZ": "a jocular word for ladies [n]\n",
  "LAYED": "LAY, to deposit as a wager [v]\n",
  "LAYER": "a single thickness, coating, or covering [n -S] / to form a layer [v -ED, -ING, -S]\n",
  "LAYERAGE": "a method of plant propagation, also LAYERING [n -S]\n",
  "LAYERAGES": "LAYERAGE, a method of plant propagation, also LAYERING [n]\n",
  "LAYERED": "LAYER, to form a layer [v]\n",
  "LAYERING": "a method of plant propagation, also LAYERAGE [n -S]\n",
  "LAYERINGS": "LAYERING, a method of plant propagation, also LAYERAGE [n]\n",
  "LAYERS": "LAYER, to form a layer [v]\n",
  "LAYETTE": "(French) clothing or equipment for a newborn child [n -S]\n",
  "LAYETTES": "LAYETTE, (French) clothing or equipment for a newborn child [n]\n",
  "LAYIN": "a basketball score made by dropping the ball into the basket [n -S]\n",
  "LAYING": "the first coat of plaster [n -S]\n",
  "LAYINGS": "LAYING, the first coat of plaster [n]\n",
  "LAYINS": "LAYIN, a basketball score made by dropping the ball into the basket [n]\n",
  "LAYLOCK": "(obsolete) lilac [n -S]\n",
  "LAYLOCKS": "LAYLOCK, (obsolete) lilac [n]\n",
  "LAYMAN": "a member of the laity [n LAYMEN]\n",
  "LAYMANISE": "to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANIZE [v LAYMANISED, LAYMANISING, LAYMANISES]\n",
  "LAYMANISED": "LAYMANISE, to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANIZE [v]\n",
  "LAYMANISES": "LAYMANISE, to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANIZE [v]\n",
  "LAYMANISING": "LAYMANISE, to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANIZE [v]\n",
  "LAYMANIZE": "to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANISE [v LAYMANIZED, LAYMANIZING, LAYMANIZES]\n",
  "LAYMANIZED": "LAYMANIZE, to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANISE [v]\n",
  "LAYMANIZES": "LAYMANIZE, to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANISE [v]\n",
  "LAYMANIZING": "LAYMANIZE, to simplify (technical information) into a form that can be understood by ordinary people, also LAYMANISE [v]\n",
  "LAYMEN": "LAYMAN, a member of the laity [n]\n",
  "LAYOFF": "the suspension or dismissal of employees [n -S]\n",
  "LAYOFFS": "LAYOFF, the suspension or dismissal of employees [n]\n",
  "LAYOUT": "an arrangement or plan [n -S]\n",
  "LAYOUTS": "LAYOUT, an arrangement or plan [n]\n",
  "LAYOVER": "a stopover [n -S]\n",
  "LAYOVERS": "LAYOVER, a stopover [n]\n",
  "LAYPEOPLE": "LAYPERSON, a member of the laity, the people as distinguished from some particular profession, usually the church [n]\n",
  "LAYPERSON": "a member of the laity, the people as distinguished from some particular profession, usually the church [n LAYPERSONS or LAYPEOPLE]\n",
  "LAYPERSONS": "LAYPERSON, a member of the laity, the people as distinguished from some particular profession, usually the church [n]\n",
  "LAYS": "LAY, to deposit as a wager [v]\n",
  "LAYSHAFT": "a shaft in a gearbox, allowing choice of gear ratios [n -S]\n",
  "LAYSHAFTS": "LAYSHAFT, a shaft in a gearbox, allowing choice of gear ratios [n]\n",
  "LAYSTALL": "a place for depositing dung [n -S]\n",
  "LAYSTALLS": "LAYSTALL, a place for depositing dung [n]\n",
  "LAYTIME": "the total time allowed for the loading and unloading of cargo [n -S]\n",
  "LAYTIMES": "LAYTIME, the total time allowed for the loading and unloading of cargo [n]\n",
  "LAYUP": "a shot in basketball [n -S]\n",
  "LAYUPS": "LAYUP, a shot in basketball [n]\n",
  "LAYWOMAN": "a female member of the laity [n LAYWOMEN]\n",
  "LAYWOMEN": "LAYWOMAN, a female member of the laity [n]\n",
  "LAZAR": "a leper or person with similar pestilential disease [n -S]\n",
  "LAZARET": "(Italian) a hospital treating infectious diseases, also LAZARETTE, LAZARETTO [n -S]\n",
  "LAZARETS": "LAZARET, (Italian) a hospital treating infectious diseases, also LAZARETTE, LAZARETTO [n]\n",
  "LAZARETTE": "(Italian) a hospital treating infectious diseases, also LAZARET, LAZARETTO [n -S]\n",
  "LAZARETTES": "LAZARETTE, (Italian) a hospital treating infectious diseases, also LAZARET, LAZARETTO [n]\n",
  "LAZARETTO": "(Italian) a hospital treating infectious diseases, also LAZARET, LAZARETTE [n -S]\n",
  "LAZARETTOS": "LAZARETTO, (Italian) a hospital treating infectious diseases, also LAZARET, LAZARETTE [n]\n",
  "LAZARS": "LAZAR, a leper or person with similar pestilential disease [n]\n",
  "LAZE": "to pass time idly [v LAZED, LAZING, LAZES]\n",
  "LAZED": "LAZE, to pass time idly [v]\n",
  "LAZES": "LAZE, to pass time idly [v]\n",
  "LAZIED": "LAZY, to move or lie sluggishly [v]\n",
  "LAZIER": "LAZY, disinclined toward work or exertion [adj]\n",
  "LAZIES": "LAZY, to move or lie sluggishly [v]\n",
  "LAZIEST": "LAZY, disinclined toward work or exertion [adj]\n",
  "LAZILY": "LAZY, disinclined toward work or exertion [adv]\n",
  "LAZINESS": "the state of being lazy [n -ES]\n",
  "LAZINESSES": "LAZINESS, the state of being lazy [n]\n",
  "LAZING": "LAZE, to pass time idly [v]\n",
  "LAZO": "to catch with a long rope with a running noose, also LASSO, LARIAT [v LAZOED, LAZOING, LAZOES or LAZOS]\n",
  "LAZOED": "LAZO, to catch with a long rope with a running noose, also LASSO, LARIAT [v]\n",
  "LAZOES": "LAZO, to catch with a long rope with a running noose, also LASSO, LARIAT [v]\n",
  "LAZOING": "LAZO, to catch with a long rope with a running noose, also LASSO, LARIAT [v]\n",
  "LAZOS": "LAZO, to catch with a long rope with a running noose, also LASSO, LARIAT [v]\n",
  "LAZULI": "a beautiful blue stone usually called lapis lazuli [n -S]\n",
  "LAZULIS": "LAZULI, a beautiful blue stone usually called lapis lazuli [n]\n",
  "LAZULITE": "a mineral of a light indigo-blue color, a hydrous phosphate of alumina and magnesia [n -S]\n",
  "LAZULITES": "LAZULITE, a mineral of a light indigo-blue color, a hydrous phosphate of alumina and magnesia [n]\n",
  "LAZURITE": "a blue cubic mineral, sodium aluminum silicate [n -S]\n",
  "LAZURITES": "LAZURITE, a blue cubic mineral, sodium aluminum silicate [n]\n",
  "LAZY": "to move or lie sluggishly [v LAZIED, LAZYING, LAZIES] / disinclined toward work or exertion [adj LAZIER, LAZIEST, LAZILY]\n",
  "LAZYBONES": "a lazy person [n LAZYBONES]\n",
  "LAZYING": "LAZY, to move or lie sluggishly [v]\n",
  "LAZYISH": "somewhat lazy [adj]\n",
  "LAZZARONE": "(Italian) a homeless idler of Naples who lives by chance work or begging [n LAZZARONI]\n",
  "LAZZARONI": "LAZZARONE, (Italian) a homeless idler of Naples who lives by chance work or begging [n]\n",
  "LAZZI": "LAZZO, (Italian) a comic dialogue [n]\n",
  "LAZZO": "(Italian) a comic dialogue [n LAZZI]\n",
  "LEA": "a meadow or pasture, also LEY [n -S]\n",
  "LEACH": "to allow a liquid to percolate [v -ED, -ING, -ES]\n",
  "LEACHABILITIES": "LEACHABILITY, the state of being leachable [n]\n",
  "LEACHABILITY": "the state of being leachable [n LEACHABILITIES]\n",
  "LEACHABLE": "that can be leached [adj]\n",
  "LEACHATE": "a liquid that has percolated through or out of some substance [n -S]\n",
  "LEACHATES": "LEACHATE, a liquid that has percolated through or out of some substance [n]\n",
  "LEACHED": "LEACH, to allow a liquid to percolate [v]\n",
  "LEACHER": "one who leaches [n -S]\n",
  "LEACHERS": "LEACHER, one who leaches [n]\n",
  "LEACHES": "LEACH, to allow a liquid to percolate [v]\n",
  "LEACHIER": "LEACHY, permitting liquids to pass by percolation; porous [adj]\n",
  "LEACHIEST": "LEACHY, permitting liquids to pass by percolation; porous [adj]\n",
  "LEACHING": "the act of leaching [n -S]\n",
  "LEACHINGS": "LEACHING, the act of leaching [n]\n",
  "LEACHOUR": "(Spenser) a lecher [n -S]\n",
  "LEACHOURS": "LEACHOUR, (Spenser) a lecher [n]\n",
  "LEACHY": "permitting liquids to pass by percolation; porous [adj LEACHIER, LEACHIEST]\n",
  "LEAD": "to go in advance [v LED, LEADING, LEADS] / to cover with a heavy metallic element [v LEADED, LEADING, LEADS]\n",
  "LEADABLE": "able to be led [adj]\n",
  "LEADED": "LEAD, to go in advance [v]\n",
  "LEADEN": "made of or resembling lead [adj LEADENLY] / to make leaden [v -ED, -ING, -S]\n",
  "LEADENED": "LEADEN, to make leaden [v]\n",
  "LEADENING": "LEADEN, to make leaden [v]\n",
  "LEADENLY": "LEADEN, made of or resembling lead [adv]\n",
  "LEADENNESS": "the state of being leaden [n -ES]\n",
  "LEADENNESSES": "LEADENNESS, the state of being leaden [n]\n",
  "LEADENS": "LEADEN, to make leaden [v]\n",
  "LEADER": "one that leads or guides [n -S]\n",
  "LEADERBOARD": "a scoreboard that lists the names and scores of the current leaders in a sporting competition [n -S]\n",
  "LEADERBOARDS": "LEADERBOARD, a scoreboard that lists the names and scores of the current leaders in a sporting competition [n]\n",
  "LEADERENE": "a female leader, esp. a dominant one [n -S]\n",
  "LEADERENES": "LEADERENE, a female leader, esp. a dominant one [n]\n",
  "LEADERETTE": "a brief newspaper leader [n -S]\n",
  "LEADERETTES": "LEADERETTE, a brief newspaper leader [n]\n",
  "LEADERLESS": "without a leader [adj]\n",
  "LEADERS": "LEADER, one that leads or guides [n]\n",
  "LEADERSHIP": "the office or position of a leader [n -S]\n",
  "LEADERSHIPS": "LEADERSHIP, the office or position of a leader [n]\n",
  "LEADIER": "LEADY, resembling lead [adj]\n",
  "LEADIEST": "LEADY, resembling lead [adj]\n",
  "LEADING": "in first position [adj LEADINGLY] / the act of leading [n -S]\n",
  "LEADINGLY": "LEADING, in first position [adv]\n",
  "LEADINGS": "LEADING, the act of leading [n]\n",
  "LEADLESS": "without lead [adj]\n",
  "LEADMAN": "a worker in charge of other workers [n LEADMEN]\n",
  "LEADMEN": "LEADMAN, a worker in charge of other workers [n]\n",
  "LEADOFF": "an opening play or move [n -S]\n",
  "LEADOFFS": "LEADOFF, an opening play or move [n]\n",
  "LEADPLANT": "a shrub of sandy woodlands and stream-banks of the Western US, thought to indicate the presence of lead [n -S]\n",
  "LEADPLANTS": "LEADPLANT, a shrub of sandy woodlands and stream-banks of the Western US, thought to indicate the presence of lead [n]\n",
  "LEADS": "LEAD, to go in advance [v]\n",
  "LEADSCREW": "a threaded rod on which a mechanism travels, and which can be adjusted [n -S]\n",
  "LEADSCREWS": "LEADSCREW, a threaded rod on which a mechanism travels, and which can be adjusted [n]\n",
  "LEADSMAN": "the man who heaves the lead to take depth soundings [n LEADSMEN]\n",
  "LEADSMEN": "LEADSMAN, the man who heaves the lead to take depth soundings [n]\n",
  "LEADWORK": "something made of lead [n -S]\n",
  "LEADWORKS": "LEADWORK, something made of lead [n]\n",
  "LEADWORT": "a genus of maritime herbs with lead-colored spots on the leaves, and nearly lead-colored flowers [n -S]\n",
  "LEADWORTS": "LEADWORT, a genus of maritime herbs with lead-colored spots on the leaves, and nearly lead-colored flowers [n]\n",
  "LEADY": "resembling lead [adj LEADIER, LEADIEST]\n",
  "LEAF": "to turn pages rapidly [v -ED, -ING, -S] / a flat green structure attached to a plant [n LEAVES]\n",
  "LEAFAGE": "foliage, also LEAFERY [n -S]\n",
  "LEAFAGES": "LEAFAGE, foliage, also LEAFERY [n]\n",
  "LEAFBUD": "a bud from which a leaf unfolds [n -S]\n",
  "LEAFBUDS": "LEAFBUD, a bud from which a leaf unfolds [n]\n",
  "LEAFCUTTER": "a kind of ant [n -S]\n",
  "LEAFCUTTERS": "LEAFCUTTER, a kind of ant [n]\n",
  "LEAFED": "LEAF, to turn pages rapidly [v]\n",
  "LEAFERIES": "LEAFERY, foliage, also LEAFAGE [n]\n",
  "LEAFERY": "foliage, also LEAFAGE [n LEAFERIES]\n",
  "LEAFHOPPER": "a name for various hopping orthopterous insects that suck plant juices [n -S]\n",
  "LEAFHOPPERS": "LEAFHOPPER, a name for various hopping orthopterous insects that suck plant juices [n]\n",
  "LEAFIER": "LEAFY, abounding in leaves, also LEAVY [adj]\n",
  "LEAFIEST": "LEAFY, abounding in leaves, also LEAVY [adj]\n",
  "LEAFINESS": "the state of being leafy [n -ES]\n",
  "LEAFINESSES": "LEAFINESS, the state of being leafy [n]\n",
  "LEAFING": "LEAF, to turn pages rapidly [v]\n",
  "LEAFLESS": "without leaves [adj]\n",
  "LEAFLESSNESS": "the state of being leafless [n -ES]\n",
  "LEAFLESSNESSES": "LEAFLESSNESS, the state of being leafless [n]\n",
  "LEAFLET": "to distribute printed sheets of paper [v LEAFLETED or LEAFLETTED, LEAFLETING or LEAFLETTING, LEAFLETS]\n",
  "LEAFLETED": "LEAFLET, to distribute printed sheets of paper [v]\n",
  "LEAFLETEER": "one who distributes leaflets, also LEAFLETER [n -S]\n",
  "LEAFLETEERS": "LEAFLETEER, one who distributes leaflets, also LEAFLETER [n]\n",
  "LEAFLETER": "one who distributes leaflets, also LEAFLETEER [n -S]\n",
  "LEAFLETERS": "LEAFLETER, one who distributes leaflets, also LEAFLETEER [n]\n",
  "LEAFLETING": "LEAFLET, to distribute printed sheets of paper [v]\n",
  "LEAFLETS": "LEAFLET, to distribute printed sheets of paper [v]\n",
  "LEAFLETTED": "LEAFLET, to distribute printed sheets of paper [v]\n",
  "LEAFLETTING": "LEAFLET, to distribute printed sheets of paper [v]\n",
  "LEAFLIKE": "resembling a leaf [adj]\n",
  "LEAFMOLD": "mould from decayed leaves [n -S]\n",
  "LEAFMOLDS": "LEAFMOLD, mould from decayed leaves [n]\n",
  "LEAFROLL": "a virus disease of potatoes [n -S]\n",
  "LEAFROLLS": "LEAFROLL, a virus disease of potatoes [n]\n",
  "LEAFS": "LEAF, to turn pages rapidly [v]\n",
  "LEAFSTALK": "the stalk or petiole which supports a leaf [n -S]\n",
  "LEAFSTALKS": "LEAFSTALK, the stalk or petiole which supports a leaf [n]\n",
  "LEAFWORM": "a moth larva that feeds on leaves [n -S]\n",
  "LEAFWORMS": "LEAFWORM, a moth larva that feeds on leaves [n]\n",
  "LEAFY": "abounding in leaves, also LEAVY [adj LEAFIER, LEAFIEST]\n",
  "LEAGUE": "to come together for a common purpose [v LEAGUED, LEAGUING, LEAGUES]\n",
  "LEAGUED": "LEAGUE, to come together for a common purpose [v]\n",
  "LEAGUER": "to besiege [v -ED, -ING, -S]\n",
  "LEAGUERED": "LEAGUER, to besiege [v]\n",
  "LEAGUERING": "LEAGUER, to besiege [v]\n",
  "LEAGUERS": "LEAGUER, to besiege [v]\n",
  "LEAGUES": "LEAGUE, to come together for a common purpose [v]\n",
  "LEAGUING": "LEAGUE, to come together for a common purpose [v]\n",
  "LEAK": "to seep through [v -ED, -ING, -S]\n",
  "LEAKAGE": "the act or an instance of leaking [n -S]\n",
  "LEAKAGES": "LEAKAGE, the act or an instance of leaking [n]\n",
  "LEAKED": "LEAK, to seep through [v]\n",
  "LEAKER": "something that leaks [n -S]\n",
  "LEAKERS": "LEAKER, something that leaks [n]\n",
  "LEAKIER": "LEAKY, inclined to leak [adj]\n",
  "LEAKIEST": "LEAKY, inclined to leak [adj]\n",
  "LEAKILY": "LEAKY, inclined to leak [adv]\n",
  "LEAKINESS": "the state of being leaky [n -ES]\n",
  "LEAKINESSES": "LEAKINESS, the state of being leaky [n]\n",
  "LEAKING": "LEAK, to seep through [v]\n",
  "LEAKLESS": "sound and not inclined to leak [adj]\n",
  "LEAKPROOF": "proof against leakage [adj]\n",
  "LEAKS": "LEAK, to seep through [v]\n",
  "LEAKY": "inclined to leak [adj LEAKIER, LEAKIEST, LEAKILY]\n",
  "LEAL": "(Scots) loyal [adj LEALER, LEALEST, LEALLY]\n",
  "LEALER": "LEAL, (Scots) loyal [adj]\n",
  "LEALEST": "LEAL, (Scots) loyal [adj]\n",
  "LEALLY": "LEAL, (Scots) loyal [adv]\n",
  "LEALTIES": "LEALTY, (Scots) loyalty [n]\n",
  "LEALTY": "(Scots) loyalty [n LEALTIES]\n",
  "LEAM": "(archaic) to gleam, glow, also LEME [v -ED, -ING, -S]\n",
  "LEAMED": "LEAM, (archaic) to gleam, glow, also LEME [v]\n",
  "LEAMING": "LEAM, (archaic) to gleam, glow, also LEME [v]\n",
  "LEAMS": "LEAM, (archaic) to gleam, glow, also LEME [v]\n",
  "LEAN": "to incline or tilt [v LEANT or LEANED, LEANING, LEANS] / having little fat [adj LEANER, LEANEST, LEANLY]\n",
  "LEANED": "LEAN, to incline or tilt [v]\n",
  "LEANER": "one that leans [n -S]\n",
  "LEANERS": "LEANER, one that leans [n]\n",
  "LEANEST": "LEAN, having little fat [adj]\n",
  "LEANING": "a tendency [n -S]\n",
  "LEANINGS": "LEANING, a tendency [n]\n",
  "LEANLY": "LEAN, having little fat [adv]\n",
  "LEANNESS": "the state of being lean [n -ES]\n",
  "LEANNESSES": "LEANNESS, the state of being lean [n]\n",
  "LEANS": "LEAN, to incline or tilt [v]\n",
  "LEANT": "LEAN, to incline or tilt [v]\n",
  "LEANY": "(Spenser) lean [adj]\n",
  "LEAP": "(Scots) to spring off the ground [v LEPT or LEAPED or LEAPT or (Scots) LUPPEN, LEAPING, LEAPS]\n",
  "LEAPED": "LEAP, (Scots) to spring off the ground [v]\n",
  "LEAPER": "one who leaps [n -S]\n",
  "LEAPEROUS": "(obsolete) leprous, also LEAPOROUS, LEAPROUS, LEPROUS [adj]\n",
  "LEAPERS": "LEAPER, one who leaps [n]\n",
  "LEAPFROG": "to jump over with the legs apart [v LEAPFROGGED, LEAPFROGGING, LEAPFROGS]\n",
  "LEAPFROGGED": "LEAPFROG, to jump over with the legs apart [v]\n",
  "LEAPFROGGING": "LEAPFROG, to jump over with the legs apart [v]\n",
  "LEAPFROGS": "LEAPFROG, to jump over with the legs apart [v]\n",
  "LEAPING": "LEAP, (Scots) to spring off the ground [v]\n",
  "LEAPOROUS": "(obsolete) leprous, also LEAPEROUS, LEAPROUS, LEPROUS [adj]\n",
  "LEAPROUS": "infected with leprosy [adj]\n",
  "LEAPS": "LEAP, (Scots) to spring off the ground [v]\n",
  "LEAPT": "LEAP, (Scots) to spring off the ground [v]\n",
  "LEAR": "(Scots) to teach, also LEARE, LEIR, LERE [v -ED, -ING, -S]\n",
  "LEARE": "(Scots) to teach, also LEAR, LEIR, LERE [v LEARED, LEARING, LEARES]\n",
  "LEARED": "LEARE, (Scots) to teach, also LEAR, LEIR, LERE [v]\n",
  "LEARES": "LEARE, (Scots) to teach, also LEAR, LEIR, LERE [v]\n",
  "LEARIER": "LEARY, cunning, wary, also LEERY [adj]\n",
  "LEARIEST": "LEARY, cunning, wary, also LEERY [adj]\n",
  "LEARINESS": "the state of being leary [n -ES]\n",
  "LEARINESSES": "LEARINESS, the state of being leary [n]\n",
  "LEARING": "LEARE, (Scots) to teach, also LEAR, LEIR, LERE [v]\n",
  "LEARN": "to be informed [v LEARNED or LEARNT, LEARNING, LEARNS]\n",
  "LEARNABILITIES": "LEARNABILITY, the quality of being learnable [n]\n",
  "LEARNABILITY": "the quality of being learnable [n LEARNABILITIES]\n",
  "LEARNABLE": "such as can be learned [adj]\n",
  "LEARNED": "LEARN, to be informed [v]\n",
  "LEARNEDLY": "LEARNED, LEARN, to be informed [adv]\n",
  "LEARNEDNESS": "the state of being learned [n -ES]\n",
  "LEARNEDNESSES": "LEARNEDNESS, the state of being learned [n]\n",
  "LEARNER": "one that learns [n -S]\n",
  "LEARNERS": "LEARNER, one that learns [n]\n",
  "LEARNING": "acquired knowledge [n -S]\n",
  "LEARNINGS": "LEARNING, acquired knowledge [n]\n",
  "LEARNS": "LEARN, to be informed [v]\n",
  "LEARNT": "LEARN, to be informed [v]\n",
  "LEARS": "LEAR, (Scots) to teach, also LEARE, LEIR, LERE [v]\n",
  "LEARY": "cunning, wary, also LEERY [adj LEARIER, LEARIEST]\n",
  "LEAS": "LEA, a meadow or pasture, also LEY [n]\n",
  "LEASABLE": "able to be leased [adj]\n",
  "LEASE": "to contract the loan of premises for rent [v LEASED, LEASING, LEASES]\n",
  "LEASEBACK": "an arrangement whereby the buyer of a property leases it back to the seller [n -S]\n",
  "LEASEBACKS": "LEASEBACK, an arrangement whereby the buyer of a property leases it back to the seller [n]\n",
  "LEASED": "LEASE, to contract the loan of premises for rent [v]\n",
  "LEASEHOLD": "land or property held under a lease [n -S]\n",
  "LEASEHOLDER": "one who holds a lease [n -S]\n",
  "LEASEHOLDERS": "LEASEHOLDER, one who holds a lease [n]\n",
  "LEASEHOLDS": "LEASEHOLD, land or property held under a lease [n]\n",
  "LEASER": "one who leases [n -S]\n",
  "LEASERS": "LEASER, one who leases [n]\n",
  "LEASES": "LEASE, to contract the loan of premises for rent [v]\n",
  "LEASH": "to hold by a lead or thong [v -ED, -ING, -ES]\n",
  "LEASHED": "LEASH, to hold by a lead or thong [v]\n",
  "LEASHES": "LEASH, to hold by a lead or thong [v]\n",
  "LEASHING": "LEASH, to hold by a lead or thong [v]\n",
  "LEASING": "a falsehood [n -S]\n",
  "LEASINGS": "LEASING, a falsehood [n]\n",
  "LEASOW": "(Old English) to pasture, also LEASOWE [v -ED, -ING, -S]\n",
  "LEASOWE": "(Old English) to pasture, also LEASOW [v LEASOWED, LEASOWING, LEASOWES]\n",
  "LEASOWED": "LEASOW, (Old English) to pasture, also LEASOWE [v]\n",
  "LEASOWES": "LEASOWE, (Old English) to pasture, also LEASOW [v]\n",
  "LEASOWING": "LEASOW, (Old English) to pasture, also LEASOWE [v]\n",
  "LEASOWS": "LEASOW, (Old English) to pasture, also LEASOWE [v]\n",
  "LEAST": "the smallest in size of degree [n -S]\n",
  "LEASTAWAYS": "at least; at all events, also LEASTWAYS, LEASTWISE [adv]\n",
  "LEASTS": "LEAST, the smallest in size of degree [n]\n",
  "LEASTWAYS": "at least; at all events, also LEASTAWAYS, LEASTWISE [adv]\n",
  "LEASTWISE": "at least; at all events, also LEASTAWAYS, LEASTWAYS [adv]\n",
  "LEASURE": "(Spenser) leisure [n -S]\n",
  "LEASURES": "LEASURE, (Spenser) leisure [n]\n",
  "LEAT": "a millstream [n -S]\n",
  "LEATHER": "to cover with the tanned hide of an animal [v -ED, -ING, -S]\n",
  "LEATHERBACK": "a kind of large sea turtle [n -S]\n",
  "LEATHERBACKS": "LEATHERBACK, a kind of large sea turtle [n]\n",
  "LEATHERBOUND": "of a book, bound in leather [adj]\n",
  "LEATHERED": "LEATHER, to cover with the tanned hide of an animal [v]\n",
  "LEATHERETTE": "(tradename) imitation leather [n -S]\n",
  "LEATHERETTES": "LEATHERETTE, (tradename) imitation leather [n]\n",
  "LEATHERGOODS": "goods made of leather [n]\n",
  "LEATHERHEAD": "an Australian honeyeater, aka friarbird [n -S]\n",
  "LEATHERHEADS": "LEATHERHEAD, an Australian honeyeater, aka friarbird [n]\n",
  "LEATHERIER": "LEATHERY, resembling leather [adj]\n",
  "LEATHERIEST": "LEATHERY, resembling leather [adj]\n",
  "LEATHERINESS": "the state of being leathery [n -ES]\n",
  "LEATHERINESSES": "LEATHERINESS, the state of being leathery [n]\n",
  "LEATHERING": "a thrashing [n -S]\n",
  "LEATHERINGS": "LEATHERING, a thrashing [n]\n",
  "LEATHERJACKET": "any of various tropical carangid fishes having a leathery skin [n -S]\n",
  "LEATHERJACKETS": "LEATHERJACKET, any of various tropical carangid fishes having a leathery skin [n]\n",
  "LEATHERLEAF": "an ericaceous bog shrub with coriaceous leaves [n LEATHERLEAFS or LEATHERLEAVES]\n",
  "LEATHERLEAFS": "LEATHERLEAF, an ericaceous bog shrub with coriaceous leaves [n]\n",
  "LEATHERLEAVES": "LEATHERLEAF, an ericaceous bog shrub with coriaceous leaves [n]\n",
  "LEATHERLIKE": "like leather [adj]\n",
  "LEATHERN": "made of leather [adj]\n",
  "LEATHERNECK": "a member of the United States Marine Corps [n -S]\n",
  "LEATHERNECKS": "LEATHERNECK, a member of the United States Marine Corps [n]\n",
  "LEATHERS": "LEATHER, to cover with the tanned hide of an animal [v]\n",
  "LEATHERWOOD": "a small shrub with white, soft wood, and a tough, leathery bark, common in damp woods in the Northern United States, aka wicopy [n -S]\n",
  "LEATHERWOODS": "LEATHERWOOD, a small shrub with white, soft wood, and a tough, leathery bark, common in damp woods in the Northern United States, aka wicopy [n]\n",
  "LEATHERWORK": "work in leather [n -S]\n",
  "LEATHERWORKS": "LEATHERWORK, work in leather [n]\n",
  "LEATHERY": "resembling leather [adj LEATHERIER, LEATHERIEST]\n",
  "LEATS": "LEAT, a millstream [n]\n",
  "LEAVE": "to go away from [v LEFT, LEAVING, LEAVES]\n",
  "LEAVED": "having leaves [adj]\n",
  "LEAVEN": "to produce fermentation in [v -ED, -ING, -S]\n",
  "LEAVENED": "LEAVEN, to produce fermentation in [v]\n",
  "LEAVENER": "one who leavens, has a tempering influence [n -S]\n",
  "LEAVENERS": "LEAVENER, one who leavens, has a tempering influence [n]\n",
  "LEAVENING": "the production of fermentation in [n -S]\n",
  "LEAVENINGS": "LEAVENING, the production of fermentation in [n]\n",
  "LEAVENOUS": "containing leaven [adj]\n",
  "LEAVENS": "LEAVEN, to produce fermentation in [v]\n",
  "LEAVER": "one that leaves [n -S]\n",
  "LEAVERS": "LEAVER, one that leaves [n]\n",
  "LEAVES": "LEAVE, to go away from [v]\n",
  "LEAVIER": "LEAVY, full of leaves, also LEAFY [adj]\n",
  "LEAVIEST": "LEAVY, full of leaves, also LEAFY [adj]\n",
  "LEAVING": "something left over [n -S]\n",
  "LEAVINGS": "LEAVING, something left over [n]\n",
  "LEAVY": "full of leaves, also LEAFY [adj LEAVIER, LEAVIEST]\n",
  "LEAZE": "a pasture [n -S]\n",
  "LEAZES": "LEAZE, a pasture [n]\n",
  "LEBBEK": "(Arabic) an Old World tropical mimosaceous tree [n -S]\n",
  "LEBBEKS": "LEBBEK, (Arabic) an Old World tropical mimosaceous tree [n]\n",
  "LEBEN": "(Arabic) a kind of Eastern yogurt [n -S]\n",
  "LEBENS": "LEBEN, (Arabic) a kind of Eastern yogurt [n]\n",
  "LEBENSRAUM": "(German) room to live (and, if necessary, expand); specifically, territory claimed as necessary for economic growth (as by the Nazis) [n -S]\n",
  "LEBENSRAUMS": "LEBENSRAUM, (German) room to live (and, if necessary, expand); specifically, territory claimed as necessary for economic growth (as by the Nazis) [n]\n",
  "LEBKUCHEN": "(German) a biscuit containing honey and spices [n LEBKUCHEN]\n",
  "LECANORA": "(Greek) a kind of lichen [n -S]\n",
  "LECANORAS": "LECANORA, (Greek) a kind of lichen [n]\n",
  "LECCIES": "LECCY, (colloquial) electricity [n]\n",
  "LECCY": "(colloquial) electricity [n LECCIES]\n",
  "LECH": "to engage in lechery, also LETCH [v -ED, -ING, -ES]\n",
  "LECHAIM": "(Hebrew) a traditional Jewish toast, also LECHAYIM, LEHAYIM, LEHAIM [n -S]\n",
  "LECHAIMS": "LECHAIM, (Hebrew) a traditional Jewish toast, also LECHAYIM, LEHAYIM, LEHAIM [n]\n",
  "LECHAYIM": "(Hebrew) a traditional Jewish toast, also LEHAYIM, LECHAIM, LEHAIM [n -S]\n",
  "LECHAYIMS": "LECHAYIM, (Hebrew) a traditional Jewish toast, also LEHAYIM, LECHAIM, LEHAIM [n]\n",
  "LECHED": "LECH, to engage in lechery, also LETCH [v]\n",
  "LECHER": "an excessively lewd man, also LEACHOUR [n -S] / to lust [v -ED, -ING, -S]\n",
  "LECHERED": "LECHER, to lust [v]\n",
  "LECHERIES": "LECHERY, excessive sexual indulgence [n]\n",
  "LECHERING": "LECHER, to lust [v]\n",
  "LECHEROUS": "lustful [adj LECHEROUSLY]\n",
  "LECHEROUSLY": "LECHEROUS, lustful [adv]\n",
  "LECHEROUSNESS": "LECHEROUS, lustful [n]\n",
  "LECHEROUSNESSES": "LECHEROUSNESS, LECHEROUS, lustful [n]\n",
  "LECHERS": "LECHER, to lust [v]\n",
  "LECHERY": "excessive sexual indulgence [n LECHERIES]\n",
  "LECHES": "LECH, to engage in lechery, also LETCH [v]\n",
  "LECHING": "LECH, to engage in lechery, also LETCH [v]\n",
  "LECHWE": "(Bantu) a kind of African antelope, aka marsh antelope [n -S]\n",
  "LECHWES": "LECHWE, (Bantu) a kind of African antelope, aka marsh antelope [n]\n",
  "LECITHIN": "a complex substance containing phosphorus [n -S]\n",
  "LECITHINASE": "an enzyme which catalyses the hydrolysis of lecithin [n -S]\n",
  "LECITHINASES": "LECITHINASE, an enzyme which catalyses the hydrolysis of lecithin [n]\n",
  "LECITHINS": "LECITHIN, a complex substance containing phosphorus [n]\n",
  "LECTERN": "a reading desk or support in a church, also LECTURN, LETTERN [n -S]\n",
  "LECTERNS": "LECTERN, a reading desk or support in a church, also LECTURN, LETTERN [n]\n",
  "LECTIN": "a protein that binds to a sugar molecule [n -S]\n",
  "LECTINS": "LECTIN, a protein that binds to a sugar molecule [n]\n",
  "LECTION": "a portion of sacred writing read in a church service [n -S]\n",
  "LECTIONARIES": "LECTIONARY, a book, or a list, of lections, for reading in divine service [n]\n",
  "LECTIONARY": "a book, or a list, of lections, for reading in divine service [n LECTIONARIES]\n",
  "LECTIONS": "LECTION, a portion of sacred writing read in a church service [n]\n",
  "LECTISTERNIA": "LECTISTERNIUM, (Latin) an ancient Greek/Roman religious rite in which the images of gods were placed on couches and food spread before them [n]\n",
  "LECTISTERNIUM": "(Latin) an ancient Greek/Roman religious rite in which the images of gods were placed on couches and food spread before them [n LECTISTERNIA or LECTISTERNIUMS]\n",
  "LECTISTERNIUMS": "LECTISTERNIUM, (Latin) an ancient Greek/Roman religious rite in which the images of gods were placed on couches and food spread before them [n]\n",
  "LECTOR": "(Latin) a reader of the lessons in a church service [n -S]\n",
  "LECTORATE": "the office of lector, a reader, esp. in a college or church service [n -S]\n",
  "LECTORATES": "LECTORATE, the office of lector, a reader, esp. in a college or church service [n]\n",
  "LECTORS": "LECTOR, (Latin) a reader of the lessons in a church service [n]\n",
  "LECTORSHIP": "the office of lector [n -S]\n",
  "LECTORSHIPS": "LECTORSHIP, the office of lector [n]\n",
  "LECTOTYPE": "a specimen or similar element selected from the original material to serve as the nomenclatural type when a holotype was not originally designated, or is missing [n -S]\n",
  "LECTOTYPES": "LECTOTYPE, a specimen or similar element selected from the original material to serve as the nomenclatural type when a holotype was not originally designated, or is missing [n]\n",
  "LECTRESS": "a female lector [n -ES]\n",
  "LECTRESSES": "LECTRESS, a female lector [n]\n",
  "LECTURE": "to expound on a specific subject [v LECTURED, LECTURING, LECTURES]\n",
  "LECTURED": "LECTURE, to expound on a specific subject [v]\n",
  "LECTURER": "one who lectures [n -S]\n",
  "LECTURERS": "LECTURER, one who lectures [n]\n",
  "LECTURES": "LECTURE, to expound on a specific subject [v]\n",
  "LECTURESHIP": "the office of lecturer [n -S]\n",
  "LECTURESHIPS": "LECTURESHIP, the office of lecturer [n]\n",
  "LECTURING": "LECTURE, to expound on a specific subject [v]\n",
  "LECTURN": "(obsolete) a reading desk or support in a church, also LECTERN, LETTERN [n -S]\n",
  "LECTURNS": "LECTURN, (obsolete) a reading desk or support in a church, also LECTERN, LETTERN [n]\n",
  "LECYTHI": "LECYTHUS, (Latin) an oil jar used in ancient Greece, also LEKYTHOS, LEKYTHUS [n]\n",
  "LECYTHIDACEOUS": "belonging to the Lecythidaceae, a family of tropical trees including the Brazil nut [adj]\n",
  "LECYTHIS": "any of a genus of gigantic trees, chiefly Brazilian [n -ES]\n",
  "LECYTHISES": "LECYTHIS, any of a genus of gigantic trees, chiefly Brazilian [n]\n",
  "LECYTHUS": "(Latin) an oil jar used in ancient Greece, also LEKYTHOS, LEKYTHUS [n LECYTHI]\n",
  "LED": "LEAD, to go in advance [v]\n",
  "LEDDEN": "(Spenser) language, dialect, speech [n -S]\n",
  "LEDDENS": "LEDDEN, (Spenser) language, dialect, speech [n]\n",
  "LEDE": "the introductory section of a news story [n -S]\n",
  "LEDERHOSEN": "(German) short leather trousers with braces [n]\n",
  "LEDES": "LEDE, the introductory section of a news story [n]\n",
  "LEDGE": "a narrow, shelflike projection [n -S]\n",
  "LEDGED": "having a ledge [adj]\n",
  "LEDGER": "(obsolete) an ambassador, LEIDGER, LEIGER, LIDGER, LIEGER [n -S] / to fish with a ledger-line [v -ED, -ING, -S]\n",
  "LEDGERED": "LEDGER, to fish with a ledger-line [v]\n",
  "LEDGERING": "LEDGER, to fish with a ledger-line [v]\n",
  "LEDGERS": "LEDGER, to fish with a ledger-line [v]\n",
  "LEDGES": "LEDGE, a narrow, shelflike projection [n]\n",
  "LEDGIER": "LEDGY, abounding in ledges; as, a ledgy island [adj]\n",
  "LEDGIEST": "LEDGY, abounding in ledges; as, a ledgy island [adj]\n",
  "LEDGY": "abounding in ledges; as, a ledgy island [adj LEDGIER, LEDGIEST]\n",
  "LEDUM": "(Greek) a plant of the Labrador tea genus [n -S]\n",
  "LEDUMS": "LEDUM, (Greek) a plant of the Labrador tea genus [n]\n",
  "LEE": "(Scots) to lie, make a false statement [v LEED, LEEING, LEES]\n",
  "LEEAR": "(Scots) a liar [n -S]\n",
  "LEEARS": "LEEAR, (Scots) a liar [n]\n",
  "LEEBOARD": "a board attached to a sailing vessel to prevent leeway [n -S]\n",
  "LEEBOARDS": "LEEBOARD, a board attached to a sailing vessel to prevent leeway [n]\n",
  "LEECH": "a bloodsucking annelid worm [n -ES] / to cling to and drain [v -ED, -ING, -ES]\n",
  "LEECHCRAFT": "(archaic) the art of healing [n -S]\n",
  "LEECHCRAFTS": "LEECHCRAFT, (archaic) the art of healing [n]\n",
  "LEECHDOM": "a remedy [n -S]\n",
  "LEECHDOMS": "LEECHDOM, a remedy [n]\n",
  "LEECHED": "LEECH, to cling to and drain [v]\n",
  "LEECHEE": "(Chinese) a tropical fruit, also LICHEE, LICHI, LITCHI, LYCHEE [n -S]\n",
  "LEECHEES": "LEECHEE, (Chinese) a tropical fruit, also LICHEE, LICHI, LITCHI, LYCHEE [n]\n",
  "LEECHES": "LEECH, to cling to and drain [v]\n",
  "LEECHING": "LEECH, to cling to and drain [v]\n",
  "LEECHLIKE": "like a leech [adj]\n",
  "LEED": "LEE, (Scots) to lie, make a false statement [v]\n",
  "LEEING": "LEE, (Scots) to lie, make a false statement [v]\n",
  "LEEK": "a vegetable of the onion genus [n -S]\n",
  "LEEKS": "LEEK, a vegetable of the onion genus [n]\n",
  "LEEP": "(Hindi) to plaster with cow-dung; to boil or scald [v -ED, -ING, -S]\n",
  "LEEPED": "LEEP, (Hindi) to plaster with cow-dung; to boil or scald [v]\n",
  "LEEPING": "LEEP, (Hindi) to plaster with cow-dung; to boil or scald [v]\n",
  "LEEPS": "LEEP, (Hindi) to plaster with cow-dung; to boil or scald [v]\n",
  "LEER": "to look with a sideways glance [v -ED, -ING, -S]\n",
  "LEERED": "LEER, to look with a sideways glance [v]\n",
  "LEERIER": "LEERY, cunning, wary, also LEARY [adj]\n",
  "LEERIEST": "LEERY, cunning, wary, also LEARY [adj]\n",
  "LEERILY": "LEERY, cunning, wary, also LEARY [adv]\n",
  "LEERINESS": "the state of being leery [n -ES]\n",
  "LEERINESSES": "LEERINESS, the state of being leery [n]\n",
  "LEERING": "the act of leering [n -S]\n",
  "LEERINGLY": "LEERING [adv]\n",
  "LEERINGS": "LEERING, the act of leering [n]\n",
  "LEERS": "LEER, to look with a sideways glance [v]\n",
  "LEERY": "cunning, wary, also LEARY [adj LEERIER, LEERIEST, LEERILY]\n",
  "LEES": "LEE, (Scots) to lie, make a false statement [v]\n",
  "LEESE": "(Shakespeare) to lose [v LORE, LORN, LEESING, LEESES]\n",
  "LEESES": "LEESE, (Shakespeare) to lose [v]\n",
  "LEESING": "LEESE, (Shakespeare) to lose [v]\n",
  "LEET": "a former English court for petty offenses [n -S]\n",
  "LEETLE": "an old-fashioned affectation for little [adj]\n",
  "LEETS": "LEET, a former English court for petty offenses [n]\n",
  "LEETSPEAK": "a jargon used by some internet groups, in which standard English is translated into a mixture of letters, numerals, and symbols found on a computer keyboard [n -S]\n",
  "LEETSPEAKS": "LEETSPEAK, a jargon used by some internet groups, in which standard English is translated into a mixture of letters, numerals, and symbols found on a computer keyboard [n]\n",
  "LEEWARD": "towards the lee side [adj LEEWARDLY] / the direction toward which the wind is blowing [n -S]\n",
  "LEEWARDLY": "LEEWARD, towards the lee side [adv]\n",
  "LEEWARDS": "LEEWARD, the direction toward which the wind is blowing [n]\n",
  "LEEWAY": "the lateral drift of a ship [n -S]\n",
  "LEEWAYS": "LEEWAY, the lateral drift of a ship [n]\n",
  "LEEZE": "as in leeze me, Scots for lief is me, an expression of affection [adj]\n",
  "LEFT": "the left side or hand [n -S] / pertaining to the side to the north when one faces east [adj LEFTER, LEFTEST]\n",
  "LEFTE": "(Spenser) lifted [v]\n",
  "LEFTER": "LEFT, pertaining to the side to the north when one faces east [adj]\n",
  "LEFTEST": "LEFT, pertaining to the side to the north when one faces east [adj]\n",
  "LEFTIE": "someone who is politically leftwing, also LEFTY [n -S]\n",
  "LEFTIES": "LEFTY, someone who is politically leftwing, also LEFTIE [n]\n",
  "LEFTISH": "inclined to the left [adj]\n",
  "LEFTISM": "a liberal political philosophy [n -S]\n",
  "LEFTISMS": "LEFTISM, a liberal political philosophy [n]\n",
  "LEFTIST": "one tending to the left in politics [n -S]\n",
  "LEFTISTS": "LEFTIST, one tending to the left in politics [n]\n",
  "LEFTMOST": "the location or direction of the left side [n -S]\n",
  "LEFTMOSTS": "LEFTMOST, the location or direction of the left side [n]\n",
  "LEFTOVER": "an unused portion [n -S]\n",
  "LEFTOVERS": "LEFTOVER, an unused portion [n]\n",
  "LEFTS": "LEFT, the left side or hand [n]\n",
  "LEFTWARD": "on the left, also LEFTWARDS [adj LEFTWARDLY] / the left side [n -S]\n",
  "LEFTWARDLY": "towards the left [adv]\n",
  "LEFTWARDS": "towards the left, also LEFTWARD [adv]\n",
  "LEFTWING": "favouring leftism [adj]\n",
  "LEFTY": "someone who is politically leftwing, also LEFTIE [n LEFTIES]\n",
  "LEG": "to walk briskly [v LEGGED, LEGGING, LEGS]\n",
  "LEGACIES": "LEGACY, something bequeathed [n]\n",
  "LEGACY": "something bequeathed [n LEGACIES]\n",
  "LEGAL": "according to law [adj LEGALLY] / an authorised investment that may be made on behalf of savers e.g. by a bank [n -S]\n",
  "LEGALESE": "the specialized language of lawyers [n -S]\n",
  "LEGALESES": "LEGALESE, the specialized language of lawyers [n]\n",
  "LEGALISATION": "the act of making legal, also LEGALIZATION [n -S]\n",
  "LEGALISATIONS": "LEGALISATION, the act of making legal, also LEGALIZATION [n]\n",
  "LEGALISE": "to make lawful, also LEGALIZE [v LEGALISED, LEGALISING, LEGALISES]\n",
  "LEGALISED": "LEGALISE, to make lawful, also LEGALIZE [v]\n",
  "LEGALISER": "one who legalises, also LEGALIZER [n -S]\n",
  "LEGALISERS": "LEGALISER, one who legalises, also LEGALIZER [n]\n",
  "LEGALISES": "LEGALISE, to make lawful, also LEGALIZE [v]\n",
  "LEGALISING": "LEGALISE, to make lawful, also LEGALIZE [v]\n",
  "LEGALISM": "belief that salvation depends on strict adherence to the law [n -S]\n",
  "LEGALISMS": "LEGALISM, belief that salvation depends on strict adherence to the law [n]\n",
  "LEGALIST": "someone inclined to legalism [n -S]\n",
  "LEGALISTIC": "inclined to legalism [adj LEGALISTICALLY]\n",
  "LEGALISTICALLY": "LEGALISTIC, inclined to legalism [adv]\n",
  "LEGALISTS": "LEGALIST, someone inclined to legalism [n]\n",
  "LEGALITIES": "LEGALITY, the condition of being lawful [n]\n",
  "LEGALITY": "the condition of being lawful [n LEGALITIES]\n",
  "LEGALIZATION": "the act of making legal, also LEGALISATION [n -S]\n",
  "LEGALIZATIONS": "LEGALIZATION, the act of making legal, also LEGALISATION [n]\n",
  "LEGALIZE": "to make lawful, also LEGALISE [v LEGALIZED, LEGALIZING, LEGALIZES]\n",
  "LEGALIZED": "LEGALIZE, to make lawful, also LEGALISE [v]\n",
  "LEGALIZER": "one who legalizes, also LEGALISER [n -S]\n",
  "LEGALIZERS": "LEGALIZER, one who legalizes, also LEGALISER [n]\n",
  "LEGALIZES": "LEGALIZE, to make lawful, also LEGALISE [v]\n",
  "LEGALIZING": "LEGALIZE, to make lawful, also LEGALISE [v]\n",
  "LEGALLY": "LEGAL, according to law [adv]\n",
  "LEGALS": "LEGAL, an authorised investment that may be made on behalf of savers e.g. by a bank [n]\n",
  "LEGATARIES": "LEGATARY, the inheritor of a legacy, also LEGATEE [n]\n",
  "LEGATARY": "the inheritor of a legacy, also LEGATEE [n LEGATARIES]\n",
  "LEGATE": "an emissary of the pope [n -S] / to bequeath [v LEGATED, LEGATING, LEGATES]\n",
  "LEGATED": "LEGATE, to bequeath [v]\n",
  "LEGATEE": "the inheritor of a legacy, also LEGATARY [n -S]\n",
  "LEGATEES": "LEGATEE, the inheritor of a legacy, also LEGATARY [n]\n",
  "LEGATES": "LEGATE, to bequeath [v]\n",
  "LEGATESHIP": "the office of a legate [n -S]\n",
  "LEGATESHIPS": "LEGATESHIP, the office of a legate [n]\n",
  "LEGATINE": "pertaining to an official envoy [adj]\n",
  "LEGATING": "LEGATE, to bequeath [v]\n",
  "LEGATION": "the sending of an official envoy [n -S]\n",
  "LEGATIONARY": "relating to a legation [adj]\n",
  "LEGATIONS": "LEGATION, the sending of an official envoy [n]\n",
  "LEGATISSIMO": "(Italian) as smoothly as possible [adv]\n",
  "LEGATO": "(Italian) in a smooth, even style [adv] / a legato passage [n -S]\n",
  "LEGATOR": "a testator; one who bequeaths a legacy [n -S]\n",
  "LEGATORIAL": "like a legator [adj]\n",
  "LEGATORS": "LEGATOR, a testator; one who bequeaths a legacy [n]\n",
  "LEGATOS": "LEGATO, a legato passage [n]\n",
  "LEGEND": "an unverified story from earlier times [n -S]\n",
  "LEGENDARIES": "LEGENDARY, a book or writer of legends [n]\n",
  "LEGENDARILY": "LEGENDARY, having the nature of legend [adv]\n",
  "LEGENDARY": "having the nature of legend [adj LEGENDARILY] / a book or writer of legends [n LEGENDARIES]\n",
  "LEGENDISE": "to make into a legend, also LEGENDIZE [v LEGENDISED, LEGENDISING, LEGENDISES]\n",
  "LEGENDISED": "LEGENDISE, to make into a legend, also LEGENDIZE [v]\n",
  "LEGENDISES": "LEGENDISE, to make into a legend, also LEGENDIZE [v]\n",
  "LEGENDISING": "LEGENDISE, to make into a legend, also LEGENDIZE [v]\n",
  "LEGENDIST": "a writer of legend [n -S]\n",
  "LEGENDISTS": "LEGENDIST, a writer of legend [n]\n",
  "LEGENDIZE": "to make into a legend, also LEGENDISE [v LEGENDIZED, LEGENDIZING, LEGENDIZES]\n",
  "LEGENDIZED": "LEGENDIZE, to make into a legend, also LEGENDISE [v]\n",
  "LEGENDIZES": "LEGENDIZE, to make into a legend, also LEGENDISE [v]\n",
  "LEGENDIZING": "LEGENDIZE, to make into a legend, also LEGENDISE [v]\n",
  "LEGENDRIES": "LEGENDRY, a collection of legends [n]\n",
  "LEGENDRY": "a collection of legends [n LEGENDRIES]\n",
  "LEGENDS": "LEGEND, an unverified story from earlier times [n]\n",
  "LEGER": "one who sells short weight in charcoal [n -S]\n",
  "LEGERDEMAIN": "slight of hand; magic tricks [n -S]\n",
  "LEGERDEMAINIST": "one who practises legerdemain [n -S]\n",
  "LEGERDEMAINISTS": "LEGERDEMAINIST, one who practises legerdemain [n]\n",
  "LEGERDEMAINS": "LEGERDEMAIN, slight of hand; magic tricks [n]\n",
  "LEGERING": "the act of selling short weight in charcoal [n -S]\n",
  "LEGERINGS": "LEGERING, the act of selling short weight in charcoal [n]\n",
  "LEGERITIES": "LEGERITY, quickness of the mind or body [n]\n",
  "LEGERITY": "quickness of the mind or body [n LEGERITIES]\n",
  "LEGERS": "LEGER, one who sells short weight in charcoal [n]\n",
  "LEGES": "LEX, (Latin) law [n]\n",
  "LEGGE": "(Shakespeare) the dregs of the people [n -S]\n",
  "LEGGED": "LEG, to walk briskly [v]\n",
  "LEGGER": "a bargeman who legs [n -S]\n",
  "LEGGERS": "LEGGER, a bargeman who legs [n]\n",
  "LEGGES": "LEGGE, (Shakespeare) the dregs of the people [n]\n",
  "LEGGIE": "in cricket, a leg-break or a bowler of leg-breaks [n -S]\n",
  "LEGGIER": "LEGGY, having long legs [adj]\n",
  "LEGGIERO": "(Italian) light or graceful [adj]\n",
  "LEGGIES": "LEGGIE, in cricket, a leg-break or a bowler of leg-breaks [n]\n",
  "LEGGIEST": "LEGGY, having long legs [adj]\n",
  "LEGGIN": "a cover for the leg, like a long gaiter [n -S]\n",
  "LEGGINESS": "the quality of being (disproportionately) long-legged [n -ES]\n",
  "LEGGINESSES": "LEGGINESS, the quality of being (disproportionately) long-legged [n]\n",
  "LEGGING": "a covering for the leg, also LEGGIN [n -S]\n",
  "LEGGINGED": "wearing leggings [adj]\n",
  "LEGGINGS": "LEGGING, a covering for the leg, also LEGGIN [n]\n",
  "LEGGINS": "LEGGIN, a cover for the leg, like a long gaiter [n]\n",
  "LEGGISM": "(archaic) the character of a blackleg [n -S]\n",
  "LEGGISMS": "LEGGISM, (archaic) the character of a blackleg [n]\n",
  "LEGGO": "(short for) let go [interj]\n",
  "LEGGY": "having long legs [adj LEGGIER, LEGGIEST]\n",
  "LEGHOLD": "a trap that catches an animal by its leg [n -S]\n",
  "LEGHOLDS": "LEGHOLD, a trap that catches an animal by its leg [n]\n",
  "LEGHORN": "a kind of smooth, plaited straw [n -S]\n",
  "LEGHORNS": "LEGHORN, a kind of smooth, plaited straw [n]\n",
  "LEGIBILITIES": "LEGIBILITY, the quality of being legible, also LEGIBLENESS [n]\n",
  "LEGIBILITY": "the quality of being legible, also LEGIBLENESS [n LEGIBILITIES]\n",
  "LEGIBLE": "capable of being read [adj LEGIBLY]\n",
  "LEGIBLENESS": "the quality of being legible, also LEGIBILITY [n -ES]\n",
  "LEGIBLENESSES": "LEGIBLENESS, the quality of being legible, also LEGIBILITY [n]\n",
  "LEGIBLY": "LEGIBLE, capable of being read [adv]\n",
  "LEGION": "a large military force [n -S]\n",
  "LEGIONARIES": "LEGIONARY, a member of a legion [n]\n",
  "LEGIONARY": "a member of a legion [n LEGIONARIES]\n",
  "LEGIONED": "set out in legions [adj]\n",
  "LEGIONELLA": "a bacterium of the genus Legionella, esp. one that causes legionnaires' disease [n LEGIONELLAE or LEGIONELLAS]\n",
  "LEGIONELLAE": "LEGIONELLA, a bacterium of the genus Legionella, esp. one that causes legionnaires' disease [n]\n",
  "LEGIONELLAS": "LEGIONELLA, a bacterium of the genus Legionella, esp. one that causes legionnaires' disease [n]\n",
  "LEGIONNAIRE": "(French) a member of the French Foreign Legion [n -S]\n",
  "LEGIONNAIRES": "LEGIONNAIRE, (French) a member of the French Foreign Legion [n]\n",
  "LEGIONS": "LEGION, a large military force [n]\n",
  "LEGISLATE": "to make laws; to pass law in the form of an Act of Parliament or by delegated legislation [v LEGISLATED, LEGISLATING, LEGISLATES]\n",
  "LEGISLATED": "LEGISLATE, to make laws; to pass law in the form of an Act of Parliament or by delegated legislation [v]\n",
  "LEGISLATES": "LEGISLATE, to make laws; to pass law in the form of an Act of Parliament or by delegated legislation [v]\n",
  "LEGISLATING": "LEGISLATE, to make laws; to pass law in the form of an Act of Parliament or by delegated legislation [v]\n",
  "LEGISLATION": "the action of legislating [n -S]\n",
  "LEGISLATIONS": "LEGISLATION, the action of legislating [n]\n",
  "LEGISLATIVE": "relating to legislation [adj LEGISLATIVELY] / the body or department exercising the power and function of legislating [n -S]\n",
  "LEGISLATIVELY": "LEGISLATIVE, relating to legislation [adv]\n",
  "LEGISLATIVES": "LEGISLATIVE, the body or department exercising the power and function of legislating [n]\n",
  "LEGISLATOR": "one that makes laws esp. for a political unit [n -S]\n",
  "LEGISLATORIAL": "of or like a legislator [adj]\n",
  "LEGISLATORS": "LEGISLATOR, one that makes laws esp. for a political unit [n]\n",
  "LEGISLATORSHIP": "the office of legislator [n -S]\n",
  "LEGISLATORSHIPS": "LEGISLATORSHIP, the office of legislator [n]\n",
  "LEGISLATRESS": "a female legislator [n -ES]\n",
  "LEGISLATRESSES": "LEGISLATRESS, a female legislator [n]\n",
  "LEGISLATURE": "a body of persons having the power to legislate [n -S]\n",
  "LEGISLATURES": "LEGISLATURE, a body of persons having the power to legislate [n]\n",
  "LEGIST": "one skilled in the law [n -S]\n",
  "LEGISTS": "LEGIST, one skilled in the law [n]\n",
  "LEGIT": "a legitimate drama [n -S]\n",
  "LEGITIM": "(Latin) the portion of movable estate to which the children are entitled upon the death of the father [n -S]\n",
  "LEGITIMACIES": "LEGITIMACY, the quality of being legitimate [n]\n",
  "LEGITIMACY": "the quality of being legitimate [n LEGITIMACIES]\n",
  "LEGITIMATE": "lawful, born in wedlock [adj LEGITIMATELY] / to make legitimate [v LEGITIMATED, LEGITIMATING, LEGITIMATES]\n",
  "LEGITIMATED": "LEGITIMATE, to make legitimate [v]\n",
  "LEGITIMATELY": "LEGITIMATE, lawful, born in wedlock [adv]\n",
  "LEGITIMATENESS": "the state of being legitimate [n]\n",
  "LEGITIMATES": "LEGITIMATE, to make legitimate [v]\n",
  "LEGITIMATING": "LEGITIMATE, to make legitimate [v]\n",
  "LEGITIMATION": "the act of making legitimate [n -S]\n",
  "LEGITIMATIONS": "LEGITIMATION, the act of making legitimate [n]\n",
  "LEGITIMATISE": "to make legitimate, also LEGITIMATIZE, LEGITIMISE, LEGITIMIZE [v LEGITIMATISED, LEGITIMATISING, LEGITIMATISES]\n",
  "LEGITIMATISED": "LEGITIMATISE, to make legitimate, also LEGITIMATIZE, LEGITIMISE, LEGITIMIZE [v]\n",
  "LEGITIMATISES": "LEGITIMATISE, to make legitimate, also LEGITIMATIZE, LEGITIMISE, LEGITIMIZE [v]\n",
  "LEGITIMATISING": "LEGITIMATISE, to make legitimate, also LEGITIMATIZE, LEGITIMISE, LEGITIMIZE [v]\n",
  "LEGITIMATIZE": "to make legitimate, also LEGITIMATISE, LEGITIMISE, LEGITIMIZE [v LEGITIMATIZED, LEGITIMATIZING, LEGITIMATIZES]\n",
  "LEGITIMATIZED": "LEGITIMATIZE, to make legitimate, also LEGITIMATISE, LEGITIMISE, LEGITIMIZE [v]\n",
  "LEGITIMATIZES": "LEGITIMATIZE, to make legitimate, also LEGITIMATISE, LEGITIMISE, LEGITIMIZE [v]\n",
  "LEGITIMATIZING": "LEGITIMATIZE, to make legitimate, also LEGITIMATISE, LEGITIMISE, LEGITIMIZE [v]\n",
  "LEGITIMATOR": "one who makes legitimate [n -S]\n",
  "LEGITIMATORS": "LEGITIMATOR, one who makes legitimate [n]\n",
  "LEGITIMISATION": "the act of legitimising, also LEGITIMIZATION [n -S]\n",
  "LEGITIMISATIONS": "LEGITIMISATION, the act of legitimising, also LEGITIMIZATION [n]\n",
  "LEGITIMISE": "to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMIZE [v LEGITIMISED, LEGITIMISING, LEGITIMISES]\n",
  "LEGITIMISED": "LEGITIMISE, to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMIZE [v]\n",
  "LEGITIMISER": "one who legitimises, also LEGITIMIZER [n -S]\n",
  "LEGITIMISERS": "LEGITIMISER, one who legitimises, also LEGITIMIZER [n]\n",
  "LEGITIMISES": "LEGITIMISE, to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMIZE [v]\n",
  "LEGITIMISING": "LEGITIMISE, to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMIZE [v]\n",
  "LEGITIMISM": "adherence to the principles of political legitimacy or to a person claiming legitimacy [n -S]\n",
  "LEGITIMISMS": "LEGITIMISM, adherence to the principles of political legitimacy or to a person claiming legitimacy [n]\n",
  "LEGITIMIST": "a person who believes in the right of royal succession according to the principle of heredity and primogeniture [n -S]\n",
  "LEGITIMISTIC": "relating to legitimism, adherence to the principles of political legitimacy or to a person claiming legitimacy [adj]\n",
  "LEGITIMISTS": "LEGITIMIST, a person who believes in the right of royal succession according to the principle of heredity and primogeniture [n]\n",
  "LEGITIMIZATION": "the act of legitimizing, also LEGITIMISATION [n -S]\n",
  "LEGITIMIZATIONS": "LEGITIMIZATION, the act of legitimizing, also LEGITIMISATION [n]\n",
  "LEGITIMIZE": "to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMISE [v LEGITIMIZED, LEGITIMIZING, LEGITIMIZES]\n",
  "LEGITIMIZED": "LEGITIMIZE, to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMISE [v]\n",
  "LEGITIMIZER": "one who legitimizes, also LEGITIMISER [n -S]\n",
  "LEGITIMIZERS": "LEGITIMIZER, one who legitimizes, also LEGITIMISER [n]\n",
  "LEGITIMIZES": "LEGITIMIZE, to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMISE [v]\n",
  "LEGITIMIZING": "LEGITIMIZE, to make legitimate, also LEGITIMATISE, LEGITIMATIZE, LEGITIMISE [v]\n",
  "LEGITIMS": "LEGITIM, (Latin) the portion of movable estate to which the children are entitled upon the death of the father [n]\n",
  "LEGITS": "LEGIT, a legitimate drama [n]\n",
  "LEGLAN": "(Scots) a milking pail, also LEGLEN, LEGLIN [n -S]\n",
  "LEGLANS": "LEGLAN, (Scots) a milking pail, also LEGLEN, LEGLIN [n]\n",
  "LEGLEN": "(Scots) a milking pail, also LEGLAN, LEGLIN [n -S]\n",
  "LEGLENS": "LEGLEN, (Scots) a milking pail, also LEGLAN, LEGLIN [n]\n",
  "LEGLESS": "without legs [adj]\n",
  "LEGLESSNESS": "the quality of being legless [n -ES]\n",
  "LEGLESSNESSES": "LEGLESSNESS, the quality of being legless [n]\n",
  "LEGLET": "a leg decoration [n -S]\n",
  "LEGLETS": "LEGLET, a leg decoration [n]\n",
  "LEGLIKE": "like a leg [adj]\n",
  "LEGLIN": "(Scots) a milking pail, also LEGLAN, LEGLEN [n -S]\n",
  "LEGLINS": "LEGLIN, (Scots) a milking pail, also LEGLAN, LEGLEN [n]\n",
  "LEGMAN": "a newspaperman assigned to gather information [n LEGMEN]\n",
  "LEGMEN": "LEGMAN, a newspaperman assigned to gather information [n]\n",
  "LEGONG": "a Balinese dance [n -S]\n",
  "LEGONGS": "LEGONG, a Balinese dance [n]\n",
  "LEGROOM": "space in which to stretch the legs [n -S]\n",
  "LEGROOMS": "LEGROOM, space in which to stretch the legs [n]\n",
  "LEGS": "LEG, to walk briskly [v]\n",
  "LEGSIDE": "that half of a cricket field on the side on which the batsman stands when waiting to receive the ball [n -S]\n",
  "LEGSIDES": "LEGSIDE, that half of a cricket field on the side on which the batsman stands when waiting to receive the ball [n]\n",
  "LEGUAAN": "(Dutch) a large monitor lizard of the genus Varanus, also LEGUAN [n -S]\n",
  "LEGUAANS": "LEGUAAN, (Dutch) a large monitor lizard of the genus Varanus, also LEGUAN [n]\n",
  "LEGUAN": "(Dutch) a large monitor lizard of the genus Varanus, also LEGUAAN [n -S]\n",
  "LEGUANS": "LEGUAN, (Dutch) a large monitor lizard of the genus Varanus, also LEGUAAN [n]\n",
  "LEGUME": "(French) the fruit or edible portion of any leguminous plant (bean, pea, etc.) grown for food [n -S]\n",
  "LEGUMES": "LEGUME, (French) the fruit or edible portion of any leguminous plant (bean, pea, etc.) grown for food [n]\n",
  "LEGUMIN": "a plant protein obtained from peas, beans, lentils, etc. [n -S]\n",
  "LEGUMINOUS": "relating to pulse vegetables [adj]\n",
  "LEGUMINS": "LEGUMIN, a plant protein obtained from peas, beans, lentils, etc. [n]\n",
  "LEGWARMER": "one of a pair of garments resembling stockings without feet [n -S]\n",
  "LEGWARMERS": "LEGWARMER, one of a pair of garments resembling stockings without feet [n]\n",
  "LEGWEAR": "anything worn on the legs [n -S]\n",
  "LEGWEARS": "LEGWEAR, anything worn on the legs [n]\n",
  "LEGWORK": "work that involves lots of walking [n -S]\n",
  "LEGWORKS": "LEGWORK, work that involves lots of walking [n]\n",
  "LEHAIM": "(Hebrew) a traditional Jewish toast, also LECHAYIM, LEHAYIM, LECHAIM [n -S]\n",
  "LEHAIMS": "LEHAIM, (Hebrew) a traditional Jewish toast, also LECHAYIM, LEHAYIM, LECHAIM [n]\n",
  "LEHAYIM": "(Hebrew) a traditional Jewish toast, also LECHAYIM, LECHAIM, LEHAIM [n -S]\n",
  "LEHAYIMS": "LEHAYIM, (Hebrew) a traditional Jewish toast, also LECHAYIM, LECHAIM, LEHAIM [n]\n",
  "LEHR": "a glass-annealing oven [n -S]\n",
  "LEHRJAHRE": "(German) an apprenticeship [n]\n",
  "LEHRS": "LEHR, a glass-annealing oven [n]\n",
  "LEHUA": "(Hawaiian) a Polynesian tree of the myrtle family with bright red flowers, aka ohia [n -S]\n",
  "LEHUAS": "LEHUA, (Hawaiian) a Polynesian tree of the myrtle family with bright red flowers, aka ohia [n]\n",
  "LEI": "a garland of flowers [n -S]\n",
  "LEIDGER": "(obsolete) an ambassador, also LEDGER, LEIGER, LIDGER, LIEGER [n -S]\n",
  "LEIDGERS": "LEIDGER, (obsolete) an ambassador, also LEDGER, LEIGER, LIDGER, LIEGER [n]\n",
  "LEIGER": "(obsolete) an ambassador, also LEDGER, LEIDGER, LIDGER, LIEGER [n -S]\n",
  "LEIGERS": "LEIGER, (obsolete) an ambassador, also LEDGER, LEIDGER, LIDGER, LIEGER [n]\n",
  "LEIOMYOMA": "a fibrous tumour, a fibroid [n LEIOMYOMAS or LEIOMYOMATA]\n",
  "LEIOMYOMAS": "LEIOMYOMA, a fibrous tumour, a fibroid [n]\n",
  "LEIOMYOMATA": "LEIOMYOMA, a fibrous tumour, a fibroid [n]\n",
  "LEIOTRICHIES": "LEIOTRICHY, the state of being straight-haired [n]\n",
  "LEIOTRICHOUS": "straight-haired [adj]\n",
  "LEIOTRICHY": "the state of being straight-haired [n LEIOTRICHIES]\n",
  "LEIPOA": "(Greek) any bird of the genus Leipoa of Australian moundbirds [n -S]\n",
  "LEIPOAS": "LEIPOA, (Greek) any bird of the genus Leipoa of Australian moundbirds [n]\n",
  "LEIR": "(Scots) to teach, also LEAR, LEARE, LERE [v -ED, -ING, -S]\n",
  "LEIRED": "LEIR, (Scots) to teach, also LEAR, LEARE, LERE [v]\n",
  "LEIRING": "LEIR, (Scots) to teach, also LEAR, LEARE, LERE [v]\n",
  "LEIRS": "LEIR, (Scots) to teach, also LEAR, LEARE, LERE [v]\n",
  "LEIS": "LEI, a garland of flowers [n]\n",
  "LEISH": "(Scots) active, supple [adj LEISHER, LEISHEST]\n",
  "LEISHER": "LEISH, (Scots) active, supple [adj]\n",
  "LEISHEST": "LEISH, (Scots) active, supple [adj]\n",
  "LEISHMANIA": "any protozoon of the genus Leishmania [n LEISHMANIAE or LEISHMANIAS]\n",
  "LEISHMANIAE": "LEISHMANIA, any protozoon of the genus Leishmania [n]\n",
  "LEISHMANIAL": "of or like leishmania, any protozoon of the genus Leishmania [adj]\n",
  "LEISHMANIAS": "LEISHMANIA, any protozoon of the genus Leishmania [n]\n",
  "LEISHMANIASES": "LEISHMANIASIS, infection with or a disease caused by species of Leishmania, principally kala-azar and oriental sore, also LEISHMANIOSIS [n]\n",
  "LEISHMANIASIS": "infection with or a disease caused by species of Leishmania, principally kala-azar and oriental sore, also LEISHMANIOSIS [n LEISHMANIASES]\n",
  "LEISHMANIOSES": "LEISHMANIOSIS, infection with or a disease caused by species of Leishmania, principally kala-azar and oriental sore, also LEISHMANIASIS [n]\n",
  "LEISHMANIOSIS": "infection with or a disease caused by species of Leishmania, principally kala-azar and oriental sore, also LEISHMANIASIS [n LEISHMANIOSES]\n",
  "LEISLER": "a small black bat [n -S]\n",
  "LEISLERS": "LEISLER, a small black bat [n]\n",
  "LEISTER": "(Old Norse) to spear with a three-pronged fishing implement [v -ED, -ING, -S]\n",
  "LEISTERED": "LEISTER, (Old Norse) to spear with a three-pronged fishing implement [v]\n",
  "LEISTERING": "LEISTER, (Old Norse) to spear with a three-pronged fishing implement [v]\n",
  "LEISTERS": "LEISTER, (Old Norse) to spear with a three-pronged fishing implement [v]\n",
  "LEISURABLE": "leisurely [adj LEISURABLY]\n",
  "LEISURABLY": "LEISURABLE, leisurely [adv]\n",
  "LEISURE": "free time, also LEASURE [n -S] / to have recreational time [v LEISURED, LEISURING, LEISURES]\n",
  "LEISURED": "LEISURE, to have recreational time [v]\n",
  "LEISURELIER": "LEISURELY, relaxed [adj]\n",
  "LEISURELIEST": "LEISURELY, relaxed [adj]\n",
  "LEISURELINESS": "the state of being leisurely [n -ES]\n",
  "LEISURELINESSES": "LEISURELINESS, the state of being leisurely [n]\n",
  "LEISURELY": "relaxed [adj LEISURELIER, LEISURELIEST]\n",
  "LEISURES": "LEISURE, to have recreational time [v]\n",
  "LEISUREWEAR": "clothes suitable for leisure activities [n -S]\n",
  "LEISUREWEARS": "LEISUREWEAR, clothes suitable for leisure activities [n]\n",
  "LEISURING": "LEISURE, to have recreational time [v]\n",
  "LEITMOTIF": "(German) a leading motif, a recurring theme in a novel, musical signature for something, also LEITMOTIV [n -S]\n",
  "LEITMOTIFS": "LEITMOTIF, (German) a leading motif, a recurring theme in a novel, musical signature for something, also LEITMOTIV [n]\n",
  "LEITMOTIV": "(German) a leading motif, a recurring theme in a novel, musical signature for something, also LEITMOTIF [n -S]\n",
  "LEITMOTIVS": "LEITMOTIV, (German) a leading motif, a recurring theme in a novel, musical signature for something, also LEITMOTIF [n]\n",
  "LEK": "to gather at a piece of ground for display purposes [v LEKKED, LEKKING, LEKS] / a monetary unit of Albania [n LEKS or LEKE or LEKU]\n",
  "LEKE": "(Spenser) leaky [adj]\n",
  "LEKGOTLA": "(Bantu) an assembly of tribal elders in Botswana, also KGOTLA [n -S]\n",
  "LEKGOTLAS": "LEKGOTLA, (Bantu) an assembly of tribal elders in Botswana, also KGOTLA [n]\n",
  "LEKKED": "LEK, to gather at a piece of ground for display purposes [v]\n",
  "LEKKER": "(South African slang) pleasing, tasty [adj]\n",
  "LEKKING": "the act of lekking [n -S]\n",
  "LEKKINGS": "LEKKING, the act of lekking [n]\n",
  "LEKS": "LEK, to gather at a piece of ground for display purposes [v]\n",
  "LEKU": "LEK, a monetary unit of Albania [n]\n",
  "LEKVAR": "(Hungarian) a prune butter [n -S]\n",
  "LEKVARS": "LEKVAR, (Hungarian) a prune butter [n]\n",
  "LEKYTHI": "LEKYTHUS, (Latin) an oil jar used in ancient Greece, also LEKYTHOS, LECYTHUS [n]\n",
  "LEKYTHOI": "LEKYTHOS, an oil jar used in ancient Greece, also LECYTHUS, LEKYTHUS [n]\n",
  "LEKYTHOS": "an oil jar used in ancient Greece, also LECYTHUS, LEKYTHUS [n LEKYTHOI]\n",
  "LEKYTHUS": "(Latin) an oil jar used in ancient Greece, also LEKYTHOS, LECYTHUS [n LEKYTHI]\n",
  "LEMAN": "(archaic) a lover, sweetheart or paramour [n -S]\n",
  "LEMANS": "LEMAN, (archaic) a lover, sweetheart or paramour [n]\n",
  "LEME": "(archaic) a gleam of light, a glow [n -S] / to gleam, glow, also LEAM [v LEMED, LEMING, LEMES]\n",
  "LEMED": "LEME, to gleam, glow, also LEAM [v]\n",
  "LEMEL": "the dust and filings of metal, also LIMAIL [n -S]\n",
  "LEMELS": "LEMEL, the dust and filings of metal, also LIMAIL [n]\n",
  "LEMES": "LEME, to gleam, glow, also LEAM [v]\n",
  "LEMING": "LEME, to gleam, glow, also LEAM [v]\n",
  "LEMMA": "(Latin) a type of proposition in logic [n LEMMAS or LEMMATA]\n",
  "LEMMAS": "LEMMA, (Latin) a type of proposition in logic [n]\n",
  "LEMMATA": "LEMMA, (Latin) a type of proposition in logic [n]\n",
  "LEMMATISATION": "the process of lemmatising, also LEMMATIZATION [n -S]\n",
  "LEMMATISATIONS": "LEMMATISATION, the process of lemmatising, also LEMMATIZATION [n]\n",
  "LEMMATISE": "to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATIZE [v LEMMATISED, LEMMATISING, LEMMATISES]\n",
  "LEMMATISED": "LEMMATISE, to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATIZE [v]\n",
  "LEMMATISES": "LEMMATISE, to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATIZE [v]\n",
  "LEMMATISING": "LEMMATISE, to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATIZE [v]\n",
  "LEMMATIZATION": "the process of lemmatizing, also LEMMATISATION [n -S]\n",
  "LEMMATIZATIONS": "LEMMATIZATION, the process of lemmatizing, also LEMMATISATION [n]\n",
  "LEMMATIZE": "to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATISE [v LEMMATIZED, LEMMATIZING, LEMMATIZES]\n",
  "LEMMATIZED": "LEMMATIZE, to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATISE [v]\n",
  "LEMMATIZES": "LEMMATIZE, to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATISE [v]\n",
  "LEMMATIZING": "LEMMATIZE, to organise (words in a text) so that inflected and variant forms are grouped under the appropriate lemma, also LEMMATISE [v]\n",
  "LEMME": "(short for) let me [interj]\n",
  "LEMMING": "(Norwegian) a small short-tailed Arctic rodent [n -S]\n",
  "LEMMINGLIKE": "like a lemming [adj]\n",
  "LEMMINGS": "LEMMING, (Norwegian) a small short-tailed Arctic rodent [n]\n",
  "LEMNISCAL": "relating to a lemniscus, a band of fibres [adj]\n",
  "LEMNISCATE": "an oval shape with two symmetrical loops across a central node (as the figure 8), used as the symbol for infinity [n -S]\n",
  "LEMNISCATES": "LEMNISCATE, an oval shape with two symmetrical loops across a central node (as the figure 8), used as the symbol for infinity [n]\n",
  "LEMNISCI": "LEMNISCUS, (Latin) a band of nerve fibres [n]\n",
  "LEMNISCUS": "(Latin) a band of nerve fibres [n LEMNISCI]\n",
  "LEMON": "a pale yellow oval citrus fruit with sour-tasting flesh [n -S] / to flavour with the juice of a citrus fruit [v -ED, -ING, -S]\n",
  "LEMONADE": "a soft drink made from lemons [n -S]\n",
  "LEMONADES": "LEMONADE, a soft drink made from lemons [n]\n",
  "LEMONED": "LEMON, to flavour with the juice of a citrus fruit [v]\n",
  "LEMONFISH": "(New Zealand) shark meat sold as food [n -ES]\n",
  "LEMONFISHES": "LEMONFISH, (New Zealand) shark meat sold as food [n]\n",
  "LEMONGRASS": "a fragrant perennial grass [n -ES]\n",
  "LEMONGRASSES": "LEMONGRASS, a fragrant perennial grass [n]\n",
  "LEMONIER": "LEMONY, tasting of lemon [adj]\n",
  "LEMONIEST": "LEMONY, tasting of lemon [adj]\n",
  "LEMONING": "LEMON, to flavour with the juice of a citrus fruit [v]\n",
  "LEMONISH": "somewhat lemon [adj]\n",
  "LEMONLIKE": "like a lemon [adj]\n",
  "LEMONS": "LEMON, to flavour with the juice of a citrus fruit [v]\n",
  "LEMONWOOD": "a small tree of New Zealand [n -S]\n",
  "LEMONWOODS": "LEMONWOOD, a small tree of New Zealand [n]\n",
  "LEMONY": "tasting of lemon [adj LEMONIER, LEMONIEST]\n",
  "LEMPIRA": "a monetary unit of Honduras [n -S]\n",
  "LEMPIRAS": "LEMPIRA, a monetary unit of Honduras [n]\n",
  "LEMUR": "(Latin) one of a group of long-tailed mammals allied to the monkeys, living in Madagascar [n -S] / an ancient Roman ghost of the dead [n -ES]\n",
  "LEMURES": "the ghosts of the dead in ancient Roman religion [n]\n",
  "LEMURIAN": "like a lemur [adj] / a member of the lemur family, also LEMURINE, LEMUROID [n -S]\n",
  "LEMURIANS": "LEMURIAN, a member of the lemur family, also LEMURINE, LEMUROID [n]\n",
  "LEMURINE": "like a lemur [adj] / a member of the lemur family, also LEMURIAN, LEMUROID [n -S]\n",
  "LEMURINES": "LEMURINE, a member of the lemur family, also LEMURIAN, LEMUROID [n]\n",
  "LEMURLIKE": "like a lemur [adj]\n",
  "LEMUROID": "like a lemur [adj] / a member of the lemur family, also LEMURIAN, LEMURINE [n -S]\n",
  "LEMUROIDS": "LEMUROID, a member of the lemur family, also LEMURIAN, LEMURINE [n]\n",
  "LEMURS": "LEMUR, (Latin) one of a group of long-tailed mammals allied to the monkeys, living in Madagascar [n]\n",
  "LEND": "to give for a time only [v LENT, LENDING, LENDS]\n",
  "LENDABLE": "able to be lent [adj]\n",
  "LENDER": "one that lends [n -S]\n",
  "LENDERS": "LENDER, one that lends [n]\n",
  "LENDING": "the act of giving in loan [n -S]\n",
  "LENDINGS": "LENDING, the act of giving in loan [n]\n",
  "LENDS": "LEND, to give for a time only [v]\n",
  "LENES": "LENIS, (Latin) a speech sound requiring little effort or breath [n]\n",
  "LENG": "(obsolete) long [adj LENGER, LENGEST] / to tarry [v -ED, -ING, -S]\n",
  "LENGED": "LENG, to tarry [v]\n",
  "LENGER": "LENG, (obsolete) long [adj]\n",
  "LENGEST": "LENG, (obsolete) long [adj]\n",
  "LENGING": "LENG, to tarry [v]\n",
  "LENGS": "LENG, to tarry [v]\n",
  "LENGTH": "the extent from end to end [n -S]\n",
  "LENGTHEN": "to make longer [v -ED, -ING, -S]\n",
  "LENGTHENED": "LENGTHEN, to make longer [v]\n",
  "LENGTHENER": "something that lengthens [n -S]\n",
  "LENGTHENERS": "LENGTHENER, something that lengthens [n]\n",
  "LENGTHENING": "LENGTHEN, to make longer [v]\n",
  "LENGTHENS": "LENGTHEN, to make longer [v]\n",
  "LENGTHFUL": "long [adj]\n",
  "LENGTHIER": "LENGTHY, very long [adj]\n",
  "LENGTHIEST": "LENGTHY, very long [adj]\n",
  "LENGTHILY": "LENGTHY, very long [adv]\n",
  "LENGTHINESS": "the state of being lengthy [n -ES]\n",
  "LENGTHINESSES": "LENGTHINESS, the state of being lengthy [n]\n",
  "LENGTHMAN": "a person whose job it is to maintain a particular length of railway line [n LENGTHMEN]\n",
  "LENGTHMEN": "LENGTHMAN, a person whose job it is to maintain a particular length of railway line [n]\n",
  "LENGTHS": "LENGTH, the extent from end to end [n]\n",
  "LENGTHSMAN": "someone responsible for the upkeep of a particular length of railway [n LENGTHSMEN]\n",
  "LENGTHSMEN": "LENGTHSMAN, someone responsible for the upkeep of a particular length of railway [n]\n",
  "LENGTHWAYS": "in the direction of the length, also LENGTHWISE [adv]\n",
  "LENGTHWISE": "in the direction of the length, also LENGTHWAYS [adv]\n",
  "LENGTHY": "very long [adj LENGTHIER, LENGTHIEST, LENGTHILY]\n",
  "LENIENCE": "the quality of being lenient, also LENIENCY [n -S]\n",
  "LENIENCES": "LENIENCE, the quality of being lenient, also LENIENCY [n]\n",
  "LENIENCIES": "LENIENCY, the quality of being lenient, also LENIENCE [n]\n",
  "LENIENCY": "the quality of being lenient, also LENIENCE [n LENIENCIES]\n",
  "LENIENT": "not severe, tolerant [adj LENIENTLY] / (archaic) something which softens, an emollient [n -S]\n",
  "LENIENTLY": "LENIENT, not severe, tolerant [adv]\n",
  "LENIENTS": "LENIENT, (archaic) something which softens, an emollient [n]\n",
  "LENIFIED": "LENIFY, (archaic) to mitigate or assuage [v]\n",
  "LENIFIES": "LENIFY, (archaic) to mitigate or assuage [v]\n",
  "LENIFY": "(archaic) to mitigate or assuage [v LENIFIED, LENIFYING, LENIFIES]\n",
  "LENIFYING": "LENIFY, (archaic) to mitigate or assuage [v]\n",
  "LENIS": "(Latin) a speech sound requiring little effort or breath [n LENES]\n",
  "LENITE": "to articulate a lenis [v LENITED, LENITING, LENITES]\n",
  "LENITED": "LENITE, to articulate a lenis [v]\n",
  "LENITES": "LENITE, to articulate a lenis [v]\n",
  "LENITIES": "LENITY, the quality of being lenient, also LENIENCY, LENIENCE [n]\n",
  "LENITING": "LENITE, to articulate a lenis [v]\n",
  "LENITION": "a change in articulation [n -S]\n",
  "LENITIONS": "LENITION, a change in articulation [n]\n",
  "LENITIVE": "soothing [adj LENITIVELY] / a soothing medicine [n -S]\n",
  "LENITIVELY": "LENITIVE, soothing [adv]\n",
  "LENITIVES": "LENITIVE, a soothing medicine [n]\n",
  "LENITY": "the quality of being lenient, also LENIENCY, LENIENCE [n LENITIES]\n",
  "LENO": "a thin, muslin-like fabric [n -S]\n",
  "LENOCINIUM": "in Scots law, connivance at one's wife's adultery [n -S]\n",
  "LENOCINIUMS": "LENOCINIUM, in Scots law, connivance at one's wife's adultery [n]\n",
  "LENOS": "LENO, a thin, muslin-like fabric [n]\n",
  "LENS": "a piece of transparent matter with one or both surfaces curved to cause regular convergence or divergence of rays passing through it [n -ES] / to make a film of [v -ED, -ING, -ES]\n",
  "LENSE": "a lens, transparent material used to change convergence of light ray [n -S]\n",
  "LENSED": "LENS, to make a film of [v]\n",
  "LENSES": "LENS, to make a film of [v]\n",
  "LENSING": "the act of making a film [n -S]\n",
  "LENSINGS": "LENSING, the act of making a film [n]\n",
  "LENSLESS": "without a lens [adj]\n",
  "LENSLIKE": "like a lens [adj]\n",
  "LENSMAN": "(colloquial) a cameraman [n LENSMEN]\n",
  "LENSMEN": "LENSMAN, (colloquial) a cameraman [n]\n",
  "LENT": "LEND, to give for a time only [v]\n",
  "LENTAMENTE": "(Italian) slowly; in slow time [adv]\n",
  "LENTANDO": "(Italian) of music, becoming slower [adv]\n",
  "LENTEN": "meagre, i.e. that which may be eaten in Lent [adj]\n",
  "LENTI": "LENTO, (Italian) a slow musical movement [n]\n",
  "LENTIC": "pertaining to still water [adj]\n",
  "LENTICEL": "a breathing pore in bark [n -S]\n",
  "LENTICELLATE": "of or like a lenticel, a breathing pore in bark [adj]\n",
  "LENTICELS": "LENTICEL, a breathing pore in bark [n]\n",
  "LENTICLE": "a double convex mass [n -S]\n",
  "LENTICLES": "LENTICLE, a double convex mass [n]\n",
  "LENTICULAR": "lens-shaped [adj LENTICULARLY] / a three-dimensional picture made up of photographs of a scene which have been taken from several angles, split into strips, juxtaposed, and laminated with corrugated plastic [n -S]\n",
  "LENTICULARLY": "LENTICULAR, lens-shaped [adv]\n",
  "LENTICULARS": "LENTICULAR, a three-dimensional picture made up of photographs of a scene which have been taken from several angles, split into strips, juxtaposed, and laminated with corrugated plastic [n]\n",
  "LENTICULE": "any of the small corrugations on the base side of a film used in colour processing [n -S]\n",
  "LENTICULES": "LENTICULE, any of the small corrugations on the base side of a film used in colour processing [n]\n",
  "LENTIFORM": "shaped like a lens [adj]\n",
  "LENTIGINES": "LENTIGO, (Latin) a freckle [n]\n",
  "LENTIGINOSE": "freckled, minutely dotted, also LENTIGINOUS [adj]\n",
  "LENTIGINOUS": "freckled, minutely dotted, also LENTIGINOSE [adj]\n",
  "LENTIGO": "(Latin) a freckle [n LENTIGINES]\n",
  "LENTIL": "a leguminous annual plant common near the Mediterranean; its small, flattish, round seed, orange or brown, used for food [n -S]\n",
  "LENTILS": "LENTIL, a leguminous annual plant common near the Mediterranean; its small, flattish, round seed, orange or brown, used for food [n]\n",
  "LENTISC": "the mastic tree, also LENTISK [n -S]\n",
  "LENTISCS": "LENTISC, the mastic tree, also LENTISK [n]\n",
  "LENTISK": "(Latin) an evergreen tree, aka mastic tree [n -S]\n",
  "LENTISKS": "LENTISK, (Latin) an evergreen tree, aka mastic tree [n]\n",
  "LENTISSIMO": "(Italian) very slow [adv]\n",
  "LENTIVIRUS": "any of a group of retroviruses producing illnesses characterized by a delay in the onset of symptoms after infection [n -ES]\n",
  "LENTIVIRUSES": "LENTIVIRUS, any of a group of retroviruses producing illnesses characterized by a delay in the onset of symptoms after infection [n]\n",
  "LENTO": "(Italian) a slow musical movement [n LENTOS or LENTI]\n",
  "LENTOID": "lens-shaped [adj] / something in the shape of a lens [n -S]\n",
  "LENTOIDS": "LENTOID, something in the shape of a lens [n]\n",
  "LENTOR": "(archaic) sluggishness, viscidity [n -S]\n",
  "LENTORS": "LENTOR, (archaic) sluggishness, viscidity [n]\n",
  "LENTOS": "LENTO, (Italian) a slow musical movement [n]\n",
  "LENTOUS": "viscid [adj]\n",
  "LENVOY": "an envoy [n -S]\n",
  "LENVOYS": "LENVOY, an envoy [n]\n",
  "LEONE": "the standard monetary unit of Sierra Leone [n -S]\n",
  "LEONES": "LEONE, the standard monetary unit of Sierra Leone [n]\n",
  "LEONINE": "of or like a lion [adj]\n",
  "LEONTIASES": "LEONTIASIS, a kind of leprosy giving a leonine appearance to face [n]\n",
  "LEONTIASIS": "a kind of leprosy giving a leonine appearance to face [n LEONTIASES]\n",
  "LEONTOPODIUM": "any plant of the Eurasian alpine genus Leontopodium, that includes edelweiss [n -S]\n",
  "LEONTOPODIUMS": "LEONTOPODIUM, any plant of the Eurasian alpine genus Leontopodium, that includes edelweiss [n]\n",
  "LEOPARD": "a large, carnivorous, feline mammal [n -S]\n",
  "LEOPARDESS": "a female leopard [n -ES]\n",
  "LEOPARDESSES": "LEOPARDESS, a female leopard [n]\n",
  "LEOPARDS": "LEOPARD, a large, carnivorous, feline mammal [n]\n",
  "LEOPARDSKIN": "the skin of a leopard [n -S]\n",
  "LEOPARDSKINS": "LEOPARDSKIN, the skin of a leopard [n]\n",
  "LEOTARD": "a skintight garment worn by dancers, acrobats, etc. [n -S]\n",
  "LEOTARDED": "wearing a leotard [adj]\n",
  "LEOTARDS": "LEOTARD, a skintight garment worn by dancers, acrobats, etc. [n]\n",
  "LEP": "(dialect) to leap [v LEPPED, LEPT, LEPPING, LEPS]\n",
  "LEPER": "one affected with leprosy [n -S]\n",
  "LEPERS": "LEPER, one affected with leprosy [n]\n",
  "LEPID": "pleasant, jocose [adj]\n",
  "LEPIDODENDROID": "any of a genus of fossil trees [n -S]\n",
  "LEPIDODENDROIDS": "LEPIDODENDROID, any of a genus of fossil trees [n]\n",
  "LEPIDOLITE": "a species of mica, of a lilac or rose-violet color, usually occurring in masses consisting of small scales [n -S]\n",
  "LEPIDOLITES": "LEPIDOLITE, a species of mica, of a lilac or rose-violet color, usually occurring in masses consisting of small scales [n]\n",
  "LEPIDOMELANE": "a black mica rich in iron, occurring in scales [n -S]\n",
  "LEPIDOMELANES": "LEPIDOMELANE, a black mica rich in iron, occurring in scales [n]\n",
  "LEPIDOPTERA": "LEPIDOPTERON, any of numerous insects of the order Lepidoptera, typically having two pairs of wings covered with fragile scales, also LEPIDOPTERAN [n]\n",
  "LEPIDOPTERAN": "an insect such as moth or butterfly, also LEPIDOPTERON [n -S]\n",
  "LEPIDOPTERANS": "LEPIDOPTERAN, an insect such as moth or butterfly, also LEPIDOPTERON [n]\n",
  "LEPIDOPTERIST": "a specialist in lepidopterology [n -S]\n",
  "LEPIDOPTERISTS": "LEPIDOPTERIST, a specialist in lepidopterology [n]\n",
  "LEPIDOPTEROLOGY": "the study of butterflies and moths [n]\n",
  "LEPIDOPTERON": "any of numerous insects of the order Lepidoptera, typically having two pairs of wings covered with fragile scales, also LEPIDOPTERAN [n -S]\n",
  "LEPIDOPTERONS": "LEPIDOPTERON, any of numerous insects of the order Lepidoptera, typically having two pairs of wings covered with fragile scales, also LEPIDOPTERAN [n]\n",
  "LEPIDOPTEROUS": "having four wings, such as a moth or butterfly [adj]\n",
  "LEPIDOSIREN": "a South American lungfish having an eel-shaped body and whiplike paired fins [n -S]\n",
  "LEPIDOSIRENS": "LEPIDOSIREN, a South American lungfish having an eel-shaped body and whiplike paired fins [n]\n",
  "LEPIDOTE": "a flowering shrub [n -S]\n",
  "LEPIDOTES": "LEPIDOTE, a flowering shrub [n]\n",
  "LEPORID": "pertaining or belonging to the family comprising rabbits and hares [adj] / an animal of this family [n -S]\n",
  "LEPORIDAE": "animals of the rabbit or hare family [n]\n",
  "LEPORIDS": "LEPORID, an animal of this family [n]\n",
  "LEPORINE": "resembling a rabbit or hare [adj]\n",
  "LEPPED": "LEP, (dialect) to leap [v]\n",
  "LEPPING": "LEP, (dialect) to leap [v]\n",
  "LEPRA": "(Latin) leprosy; a mealy substance on some plants [n -S]\n",
  "LEPRAS": "LEPRA, (Latin) leprosy; a mealy substance on some plants [n]\n",
  "LEPRECHAUN": "(Irish) a small supernatural creature in Irish folklore, also LEPRECHAWN [n -S]\n",
  "LEPRECHAUNISH": "like a leprechaun, a small supernatural creature in Irish folklore [adj]\n",
  "LEPRECHAUNS": "LEPRECHAUN, (Irish) a small supernatural creature in Irish folklore, also LEPRECHAWN [n]\n",
  "LEPRECHAWN": "(Irish) a small supernatural creature in Irish folklore, also LEPRECHAUN [n -S]\n",
  "LEPRECHAWNS": "LEPRECHAWN, (Irish) a small supernatural creature in Irish folklore, also LEPRECHAUN [n]\n",
  "LEPROMATOUS": "characterized by, exhibiting, or being leprosy with infective superficial granulomatous nodules [adj]\n",
  "LEPROSARIA": "LEPROSARIUM, a hospital for lepers [n]\n",
  "LEPROSARIUM": "a hospital for lepers [n LEPROSARIUMS or LEPROSARIA]\n",
  "LEPROSARIUMS": "LEPROSARIUM, a hospital for lepers [n]\n",
  "LEPROSE": "affected with leprosy, also LEPROUS, LEPROTIC [adj]\n",
  "LEPROSERIE": "(French) a hospital for lepers, also LEPROSERY [n -S]\n",
  "LEPROSERIES": "LEPROSERIE, (French) a hospital for lepers, also LEPROSERY [n]\n",
  "LEPROSERY": "a hospital for lepers, also LEPROSERIE [n LEPROSERIES]\n",
  "LEPROSIES": "LEPROSY, a chronic disease with skin lesions and deformities, also LEPRA [n]\n",
  "LEPROSITIES": "LEPROSITY, the state of being leprous [n]\n",
  "LEPROSITY": "the state of being leprous [n LEPROSITIES]\n",
  "LEPROSY": "a chronic disease with skin lesions and deformities, also LEPRA [n LEPROSIES]\n",
  "LEPROTIC": "affected with leprosy, also LEPROUS, LEPROSE [adj]\n",
  "LEPROUS": "affected with leprosy, also LEPROSE, LEPROTIC [adj LEPROUSLY]\n",
  "LEPROUSLY": "LEPROUS, affected with leprosy, also LEPROSE, LEPROTIC [adv]\n",
  "LEPROUSNESS": "the state of being leprous [n -ES]\n",
  "LEPROUSNESSES": "LEPROUSNESS, the state of being leprous [n]\n",
  "LEPS": "LEP, (dialect) to leap [v]\n",
  "LEPT": "LEP, (dialect) to leap [v]\n",
  "LEPTA": "LEPTON, a monetary unit of Greece [n]\n",
  "LEPTIN": "a hormone released by fat cells [n -S]\n",
  "LEPTINS": "LEPTIN, a hormone released by fat cells [n]\n",
  "LEPTOCEPHALI": "LEPTOCEPHALUS, the larva of the conger eel [n]\n",
  "LEPTOCEPHALIC": "having a narrow skull, also LEPTOCEPHALOUS [adj]\n",
  "LEPTOCEPHALOUS": "having a narrow skull, also LEPTOCEPHALIC [adj]\n",
  "LEPTOCEPHALUS": "the larva of the conger eel [n LEPTOCEPHALI]\n",
  "LEPTOCERCAL": "slender-tailed [adj]\n",
  "LEPTODACTYL": "a bird or other animal with long slender toes [n -S]\n",
  "LEPTODACTYLOUS": "having fine, slender digits [adj]\n",
  "LEPTODACTYLS": "LEPTODACTYL, a bird or other animal with long slender toes [n]\n",
  "LEPTOKURTIC": "in statistics, referring to a distribution showing a particular type of kurtosis [adj]\n",
  "LEPTOME": "phloem or bast [n -S]\n",
  "LEPTOMES": "LEPTOME, phloem or bast [n]\n",
  "LEPTON": "a monetary unit of Greece [n LEPTONS or LEPTA]\n",
  "LEPTONIC": "relating to a lepton, a subatomic particle [adj]\n",
  "LEPTONS": "LEPTON, a monetary unit of Greece [n]\n",
  "LEPTOPHOS": "a type of pesticide [n LEPTOPHOSES]\n",
  "LEPTOPHOSES": "LEPTOPHOS, a type of pesticide [n]\n",
  "LEPTOPHYLLOUS": "having long thin leaves [adj]\n",
  "LEPTORRHINE": "having a long narrow nose [adj]\n",
  "LEPTOSOMATIC": "like a leptosome, of slender build, also LEPTOSOMIC [adj]\n",
  "LEPTOSOME": "a person with a slight or slender build [n -S]\n",
  "LEPTOSOMES": "LEPTOSOME, a person with a slight or slender build [n]\n",
  "LEPTOSOMIC": "like a leptosome, of slender build, also LEPTOSOMATIC [adj]\n",
  "LEPTOSPIRAL": "of or like a leptospire [adj]\n",
  "LEPTOSPIRE": "any of a genus of slender aerobic spirochetes [n -S]\n",
  "LEPTOSPIRES": "LEPTOSPIRE, any of a genus of slender aerobic spirochetes [n]\n",
  "LEPTOSPIROSES": "LEPTOSPIROSIS, a disease of animals or man caused by bacteria of the genus Leptospira, aka Weil's disease [n]\n",
  "LEPTOSPIROSIS": "a disease of animals or man caused by bacteria of the genus Leptospira, aka Weil's disease [n LEPTOSPIROSES]\n",
  "LEPTOTENE": "the first stage of meiotic prophase in which long, slender, single-stranded chromosomes develop [n -S]\n",
  "LEPTOTENES": "LEPTOTENE, the first stage of meiotic prophase in which long, slender, single-stranded chromosomes develop [n]\n",
  "LEQUEAR": "a sunken panel or coffer in a ceiling, also LACUNAR, LAQUEARIA [n -S]\n",
  "LEQUEARS": "LEQUEAR, a sunken panel or coffer in a ceiling, also LACUNAR, LAQUEARIA [n]\n",
  "LERE": "(Scots) to teach, also LEAR, LEARE, LEIR [v LERED, LERING, LERES]\n",
  "LERED": "LERE, (Scots) to teach, also LEAR, LEARE, LEIR [v]\n",
  "LERES": "LERE, (Scots) to teach, also LEAR, LEARE, LEIR [v]\n",
  "LERING": "LERE, (Scots) to teach, also LEAR, LEARE, LEIR [v]\n",
  "LERNAEAN": "in Greek myth relating to Lerna, the swamp or lake near Argos in which dwelt the Hydra which Hercules slew [adj]\n",
  "LERP": "(Native Australian) in Australia, a scalelike, waxy, protective, edible secretion produced on the leaves of certain plant louse larvae [n -S]\n",
  "LERPS": "LERP, (Native Australian) in Australia, a scalelike, waxy, protective, edible secretion produced on the leaves of certain plant louse larvae [n]\n",
  "LES": "(short for) a lesbian, also LEZ, LEZZ, LEZZA, LEZZIE, LEZZY [n -ES]\n",
  "LESBIAN": "a female homosexual [n -S]\n",
  "LESBIANISM": "female homosexuality [n -S]\n",
  "LESBIANISMS": "LESBIANISM, female homosexuality [n]\n",
  "LESBIANS": "LESBIAN, a female homosexual [n]\n",
  "LESBIC": "lesbian [adj]\n",
  "LESBIGAY": "a lesbian, bisexual, or male homosexual [n -S]\n",
  "LESBIGAYS": "LESBIGAY, a lesbian, bisexual, or male homosexual [n]\n",
  "LESBO": "(colloquial) a lesbian [n -S]\n",
  "LESBOS": "LESBO, (colloquial) a lesbian [n]\n",
  "LESES": "LES, (short for) a lesbian, also LEZ, LEZZ, LEZZA, LEZZIE, LEZZY [n]\n",
  "LESION": "an abnormal change in the structure of a bodily part [n -S] / to cause lesions [v -ED, -ING, -S]\n",
  "LESIONED": "LESION, to cause lesions [v]\n",
  "LESIONING": "LESION, to cause lesions [v]\n",
  "LESIONS": "LESION, to cause lesions [v]\n",
  "LESPEDEZA": "bush clover [n -S]\n",
  "LESPEDEZAS": "LESPEDEZA, bush clover [n]\n",
  "LESS": "a smaller portion [n -ES] / smaller [adj LESSER, LEAST]\n",
  "LESSEE": "one to whom a lease is granted [n -S]\n",
  "LESSEES": "LESSEE, one to whom a lease is granted [n]\n",
  "LESSEESHIP": "being a lessee [n -S]\n",
  "LESSEESHIPS": "LESSEESHIP, being a lessee [n]\n",
  "LESSEN": "to make or become less [v -ED, -ING, -S]\n",
  "LESSENED": "LESSEN, to make or become less [v]\n",
  "LESSENING": "the act of making less [n -S]\n",
  "LESSENINGS": "LESSENING, the act of making less [n]\n",
  "LESSENS": "LESSEN, to make or become less [v]\n",
  "LESSER": "LESS, smaller [adj]\n",
  "LESSES": "LESS, a smaller portion [n]\n",
  "LESSON": "a teaching [n -S] / to teach a lesson to [v -ED, -ING, -S]\n",
  "LESSONED": "LESSON, to teach a lesson to [v]\n",
  "LESSONING": "the act of teaching a lesson to [n -S]\n",
  "LESSONINGS": "LESSONING, the act of teaching a lesson to [n]\n",
  "LESSONS": "LESSON, to teach a lesson to [v]\n",
  "LESSOR": "one who grants a lease [n -S]\n",
  "LESSORS": "LESSOR, one who grants a lease [n]\n",
  "LEST": "(Spenser) to listen [v -ED, -ING, -S]\n",
  "LESTED": "LEST, (Spenser) to listen [v]\n",
  "LESTING": "LEST, (Spenser) to listen [v]\n",
  "LESTS": "LEST, (Spenser) to listen [v]\n",
  "LESULA": "a genus of Congolese monkey [n -S]\n",
  "LESULAS": "LESULA, a genus of Congolese monkey [n]\n",
  "LET": "to allow [v LET or (Scots) LOOT, (Scots) LUIT, (Scots) LITTEN, LOOTEN, LUTTEN, LETTING, LETS] / to hinder [v LETTED, LETTING, LETS]\n",
  "LETCH": "to engage in lechery, also LECH [v -ED, -ING, -ES]\n",
  "LETCHED": "LETCH, to engage in lechery, also LECH [v]\n",
  "LETCHES": "LETCH, to engage in lechery, also LECH [v]\n",
  "LETCHING": "the act of being a lecher [n -S]\n",
  "LETCHINGS": "LETCHING, the act of being a lecher [n]\n",
  "LETDOWN": "an anticlimax [n -S]\n",
  "LETDOWNS": "LETDOWN, an anticlimax [n]\n",
  "LETHAL": "causing death [adj LETHALLY] / a death-dealing genetic defect [n -S]\n",
  "LETHALITIES": "LETHALITY, the quality of being lethal [n]\n",
  "LETHALITY": "the quality of being lethal [n LETHALITIES]\n",
  "LETHALLY": "LETHAL, causing death [adv]\n",
  "LETHALS": "LETHAL, a death-dealing genetic defect [n]\n",
  "LETHARGIC": "showing lethargy, also LETHARGICAL [adj LETHARGICALLY]\n",
  "LETHARGICAL": "showing lethargy, also LETHARGIC [adj LETHARGICALLY]\n",
  "LETHARGICALLY": "LETHARGICAL, showing lethargy, also LETHARGIC [adv]\n",
  "LETHARGIED": "suffering from lethargy [adj]\n",
  "LETHARGIES": "LETHARGY, morbid drowsiness [n]\n",
  "LETHARGISE": "to make lethargic, also LETHARGIZE [v LETHARGISED, LETHARGISING, LETHARGISES]\n",
  "LETHARGISED": "LETHARGISE, to make lethargic, also LETHARGIZE [v]\n",
  "LETHARGISES": "LETHARGISE, to make lethargic, also LETHARGIZE [v]\n",
  "LETHARGISING": "LETHARGISE, to make lethargic, also LETHARGIZE [v]\n",
  "LETHARGIZE": "to make lethargic, also LETHARGISE [v LETHARGIZED, LETHARGIZING, LETHARGIZES]\n",
  "LETHARGIZED": "LETHARGIZE, to make lethargic, also LETHARGISE [v]\n",
  "LETHARGIZES": "LETHARGIZE, to make lethargic, also LETHARGISE [v]\n",
  "LETHARGIZING": "LETHARGIZE, to make lethargic, also LETHARGISE [v]\n",
  "LETHARGY": "morbid drowsiness [n LETHARGIES]\n",
  "LETHE": "forgetfulness [n -S]\n",
  "LETHEAN": "resembling in effect the water of Lethe, causing oblivion [adj]\n",
  "LETHEE": "(Shakespeare) lifeblood, or death [n -S]\n",
  "LETHEES": "LETHEE, (Shakespeare) lifeblood, or death [n]\n",
  "LETHES": "LETHE, forgetfulness [n]\n",
  "LETHIED": "(Shakespeare) suffering from forgetfulness, as having drunk the waters of Lethe [adj]\n",
  "LETHIFEROUS": "causing death; carrying or bearing death [adj]\n",
  "LETOUT": "something that makes it possible to avoid doing something [n -S]\n",
  "LETOUTS": "LETOUT, something that makes it possible to avoid doing something [n]\n",
  "LETROZOLE": "an antioestrogen drug used in the treatment of breast cancer in postmenopausal women [n -S]\n",
  "LETROZOLES": "LETROZOLE, an antioestrogen drug used in the treatment of breast cancer in postmenopausal women [n]\n",
  "LETS": "LET, to allow [v]\n",
  "LETTABLE": "able to be hired [adj]\n",
  "LETTED": "LET, to allow [v]\n",
  "LETTER": "to inscribe with symbols of speech sounds [v -ED, -ING, -S]\n",
  "LETTERBOX": "a box for holding letters [n -ES]\n",
  "LETTERBOXED": "having a letterbox [adj]\n",
  "LETTERBOXES": "LETTERBOX, a box for holding letters [n]\n",
  "LETTERBOXING": "showing a film on television in its original wide screen format [n -S]\n",
  "LETTERBOXINGS": "LETTERBOXING, showing a film on television in its original wide screen format [n]\n",
  "LETTERED": "LETTER, to inscribe with symbols of speech sounds [v]\n",
  "LETTERER": "one who letters [n -S]\n",
  "LETTERERS": "LETTERER, one who letters [n]\n",
  "LETTERFORM": "the shape of a letter of the alphabet from the point of view of design [n -S]\n",
  "LETTERFORMS": "LETTERFORM, the shape of a letter of the alphabet from the point of view of design [n]\n",
  "LETTERHEAD": "stationery printed or engraved usually with the name and address of an organization [n -S]\n",
  "LETTERHEADS": "LETTERHEAD, stationery printed or engraved usually with the name and address of an organization [n]\n",
  "LETTERING": "the act of impressing or marking with letters [n -S]\n",
  "LETTERINGS": "LETTERING, the act of impressing or marking with letters [n]\n",
  "LETTERLESS": "not having a letter [adj]\n",
  "LETTERMAN": "an athlete who has earned a letter in a school sport [n LETTERMEN]\n",
  "LETTERMEN": "LETTERMAN, an athlete who has earned a letter in a school sport [n]\n",
  "LETTERN": "(obsolete) a reading desk or support in a church, also LECTERN, LECTURN [n -S]\n",
  "LETTERNS": "LETTERN, (obsolete) a reading desk or support in a church, also LECTERN, LECTURN [n]\n",
  "LETTERPRESS": "the process of printing from an inked raised surface esp. when the paper is impressed directly upon the surface [n -ES]\n",
  "LETTERPRESSES": "LETTERPRESS, the process of printing from an inked raised surface esp. when the paper is impressed directly upon the surface [n]\n",
  "LETTERS": "LETTER, to inscribe with symbols of speech sounds [v]\n",
  "LETTERSET": "a method of rotary printing [n -S]\n",
  "LETTERSETS": "LETTERSET, a method of rotary printing [n]\n",
  "LETTERSPACING": "insertion of space between the letters of a word [n -S]\n",
  "LETTERSPACINGS": "LETTERSPACING, insertion of space between the letters of a word [n]\n",
  "LETTING": "the act of letting [n -S]\n",
  "LETTINGS": "LETTING, the act of letting [n]\n",
  "LETTRE": "(French) letter, as in e.g. lettre de cachet, a royal warrant [n -S]\n",
  "LETTRES": "LETTRE, (French) letter, as in e.g. lettre de cachet, a royal warrant [n]\n",
  "LETTUCE": "a herb used in salads [n -S]\n",
  "LETTUCES": "LETTUCE, a herb used in salads [n]\n",
  "LETUP": "an easing off [n -S]\n",
  "LETUPS": "LETUP, an easing off [n]\n",
  "LEU": "a monetary unit of Romania [n LEI]\n",
  "LEUCAEMIA": "a type of cancer, also LEUCEMIA, LEUCHAEMIA, LEUKAEMIA, LEUKEMIA [n -S]\n",
  "LEUCAEMIAS": "LEUCAEMIA, a type of cancer, also LEUCEMIA, LEUCHAEMIA, LEUKAEMIA, LEUKEMIA [n]\n",
  "LEUCAEMIC": "of or like leucemia, a type of cancer, also LEUKAEMIC [adj]\n",
  "LEUCAEMOGEN": "a substance that encourages the development of leukaemia, also LEUKAEMOGEN, LEUKEMOGEN [n -S]\n",
  "LEUCAEMOGENESES": "LEUCAEMOGENESIS, the development of leukaemia [n]\n",
  "LEUCAEMOGENESIS": "the development of leukaemia [n LEUCAEMOGENESES]\n",
  "LEUCAEMOGENIC": "of or like a leucaemogen, a substance that encourages the development of leukaemia, also LEUKAEMOGENIC [adj]\n",
  "LEUCAEMOGENS": "LEUCAEMOGEN, a substance that encourages the development of leukaemia, also LEUKAEMOGEN, LEUKEMOGEN [n]\n",
  "LEUCEMIA": "a disease of the blood-forming organs, also LEUKEMIA, LEUKOSIS [n -S]\n",
  "LEUCEMIAS": "LEUCEMIA, a disease of the blood-forming organs, also LEUKEMIA, LEUKOSIS [n]\n",
  "LEUCEMIC": "of or like leucemia, a type of cancer, also LEUKEMIC [adj]\n",
  "LEUCH": "LAUCH, (Scots) to laugh [v]\n",
  "LEUCHAEMIA": "a type of cancer, also LEUCAEMIA, LEUCEMIA, LEUKAEMIA, LEUKEMIA [n -S]\n",
  "LEUCHAEMIAS": "LEUCHAEMIA, a type of cancer, also LEUCAEMIA, LEUCEMIA, LEUKAEMIA, LEUKEMIA [n]\n",
  "LEUCHEN": "LAUCH, (Scots) to laugh [v]\n",
  "LEUCIN": "an amino acid, also LEUCINE [n -S]\n",
  "LEUCINE": "an amino acid, also LEUCIN [n -S]\n",
  "LEUCINES": "LEUCINE, an amino acid, also LEUCIN [n]\n",
  "LEUCINS": "LEUCIN, an amino acid, also LEUCINE [n]\n",
  "LEUCISM": "abnormally pale coloring of skin or hair [n -S]\n",
  "LEUCISMS": "LEUCISM, abnormally pale coloring of skin or hair [n]\n",
  "LEUCISTIC": "lacking pigmentation in the skin but differing from an albino in having blue eyes [adj]\n",
  "LEUCITE": "a silicate of aluminium and potassium, named for its whitish colour [n -S]\n",
  "LEUCITES": "LEUCITE, a silicate of aluminium and potassium, named for its whitish colour [n]\n",
  "LEUCITIC": "containing leucite, as, leucitic rocks [adj]\n",
  "LEUCITOHEDRA": "LEUCITOHEDRON, the cubic icositetrahedron, simulated by typical leucite crystals [n]\n",
  "LEUCITOHEDRON": "the cubic icositetrahedron, simulated by typical leucite crystals [n LEUCITOHEDRA or LEUCITOHEDRONS]\n",
  "LEUCITOHEDRONS": "LEUCITOHEDRON, the cubic icositetrahedron, simulated by typical leucite crystals [n]\n",
  "LEUCO": "as in leuco base, a colourless compound formed by reducing a dye [adj]\n",
  "LEUCOBLAST": "an immature cell which will develop into a leucocyte, also LEUKOBLAST [n -S]\n",
  "LEUCOBLASTS": "LEUCOBLAST, an immature cell which will develop into a leucocyte, also LEUKOBLAST [n]\n",
  "LEUCOCIDIN": "a bacterial substance that destroys white blood cells, also LEUKOCIDIN [n -S]\n",
  "LEUCOCIDINS": "LEUCOCIDIN, a bacterial substance that destroys white blood cells, also LEUKOCIDIN [n]\n",
  "LEUCOCRATIC": "of igneous rocks, light in colour, due to a low content of iron and magnesium [adj]\n",
  "LEUCOCYTE": "a colourless corpuscle, as one of the white blood corpuscles, also LEUKOCYTE [n -S]\n",
  "LEUCOCYTES": "LEUCOCYTE, a colourless corpuscle, as one of the white blood corpuscles, also LEUKOCYTE [n]\n",
  "LEUCOCYTHAEMIA": "leukaemia [n -S]\n",
  "LEUCOCYTHAEMIAS": "LEUCOCYTHAEMIA, leukaemia [n]\n",
  "LEUCOCYTIC": "relating to white corpuscles [adj]\n",
  "LEUCOCYTOLYSES": "LEUCOCYTOLYSIS, breaking down of the leucocytes, also LEUKOCYTOLYSIS [n]\n",
  "LEUCOCYTOLYSIS": "breaking down of the leucocytes, also LEUKOCYTOLYSIS [n LEUCOCYTOLYSES]\n",
  "LEUCOCYTOPENIA": "leucocyte deficiency [n -S]\n",
  "LEUCOCYTOPENIAS": "LEUCOCYTOPENIA, leucocyte deficiency [n]\n",
  "LEUCOCYTOSES": "LEUCOCYTOSIS, an increase in the number of leucocytes in blood [n]\n",
  "LEUCOCYTOSIS": "an increase in the number of leucocytes in blood [n LEUCOCYTOSES]\n",
  "LEUCOCYTOTIC": "related to leucocytosis [adj]\n",
  "LEUCODEPLETED": "of blood, deficient in leucocytes, white blood corpuscles, also LEUKODEPLETED [adj]\n",
  "LEUCODERMA": "a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMIA, LEUKODERMA [n -S]\n",
  "LEUCODERMAL": "relating to leucoderma, a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMIC, LEUKODERMAL [adj]\n",
  "LEUCODERMAS": "LEUCODERMA, a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMIA, LEUKODERMA [n]\n",
  "LEUCODERMIA": "a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMA, LEUKODERMA [n -S]\n",
  "LEUCODERMIAS": "LEUCODERMIA, a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMA, LEUKODERMA [n]\n",
  "LEUCODERMIC": "relating to leucoderma, a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMAL, LEUKODERMAL [adj]\n",
  "LEUCOMA": "(Greek) a white opacity in the cornea of the eye, aka albugo, also LEUKOMA [n -S]\n",
  "LEUCOMAINE": "any of a group of toxic amines produced during animal metabolism [n -S]\n",
  "LEUCOMAINES": "LEUCOMAINE, any of a group of toxic amines produced during animal metabolism [n]\n",
  "LEUCOMAS": "LEUCOMA, (Greek) a white opacity in the cornea of the eye, aka albugo, also LEUKOMA [n]\n",
  "LEUCON": "a sponge of complex structure [n -S]\n",
  "LEUCONS": "LEUCON, a sponge of complex structure [n]\n",
  "LEUCOPENIA": "a decrease in the number of leucocytes in blood, also LEUKOPENIA [n -S]\n",
  "LEUCOPENIAS": "LEUCOPENIA, a decrease in the number of leucocytes in blood, also LEUKOPENIA [n]\n",
  "LEUCOPENIC": "having leucopenia, a decrease in number of leucocytes in blood [adj]\n",
  "LEUCOPLAKIA": "the stage of a chronically inflamed area at which the surface becomes hard, white and smooth, also LEUKOPLAKIA [n -S]\n",
  "LEUCOPLAKIAS": "LEUCOPLAKIA, the stage of a chronically inflamed area at which the surface becomes hard, white and smooth, also LEUKOPLAKIA [n]\n",
  "LEUCOPLAKIC": "relating to leukoplakia, also LEUKOPLAKIC [adj]\n",
  "LEUCOPLAST": "a colorless plastid in the cytoplasm of plant cells around which starch collects [n -S]\n",
  "LEUCOPLASTID": "a starch-forming body in protoplasm [n -S]\n",
  "LEUCOPLASTIDS": "LEUCOPLASTID, a starch-forming body in protoplasm [n]\n",
  "LEUCOPLASTS": "LEUCOPLAST, a colorless plastid in the cytoplasm of plant cells around which starch collects [n]\n",
  "LEUCOPOIESES": "LEUCOPOIESIS, the formation of leucocytes, also LEUKOPOIESIS [n]\n",
  "LEUCOPOIESIS": "the formation of leucocytes, also LEUKOPOIESIS [n LEUCOPOIESES]\n",
  "LEUCOPOIETIC": "relating to leucopoiesis, the formation of leucocytes, also LEUKOPOIETIC [adj]\n",
  "LEUCORRHOEA": "an abnormal mucous or mucopurulent discharge from the vagina, also LEUKORRHEA [n -S]\n",
  "LEUCORRHOEAL": "relating to leucorrhoea, also LEUKORRHEAL [adj]\n",
  "LEUCORRHOEAS": "LEUCORRHOEA, an abnormal mucous or mucopurulent discharge from the vagina, also LEUKORRHEA [n]\n",
  "LEUCOSES": "LEUCOSIS, leukaemia, also LEUKOSIS [n]\n",
  "LEUCOSIN": "a cereal albumen [n -S]\n",
  "LEUCOSINS": "LEUCOSIN, a cereal albumen [n]\n",
  "LEUCOSIS": "leukaemia, also LEUKOSIS [n LEUCOSES]\n",
  "LEUCOTIC": "relating to leucosis, leukaemia, also LEUKOTIC [adj]\n",
  "LEUCOTOME": "a needle used to carry out a leucotomy, also LEUKOTOME [n -S]\n",
  "LEUCOTOMES": "LEUCOTOME, a needle used to carry out a leucotomy, also LEUKOTOME [n]\n",
  "LEUCOTOMIES": "LEUCOTOMY, a surgical scission of the fibres between the frontal lobes of the brain and the thalamus to relieve cases of severe schizophrenia, also LEUKOTOMY [n]\n",
  "LEUCOTOMY": "a surgical scission of the fibres between the frontal lobes of the brain and the thalamus to relieve cases of severe schizophrenia, also LEUKOTOMY [n LEUCOTOMIES]\n",
  "LEUD": "a feudal vassal [n LEUDS or LEUDES]\n",
  "LEUDES": "LEUD, a feudal vassal [n]\n",
  "LEUDS": "LEUD, a feudal vassal [n]\n",
  "LEUGH": "LAUCH, (Scots) to laugh [v]\n",
  "LEUGHEN": "LAUCH, (Scots) to laugh [v]\n",
  "LEUKAEMIA": "a type of cancer, also LEUCAEMIA, LEUCEMIA, LEUCHAEMIA, LEUKEMIA [n -S]\n",
  "LEUKAEMIAS": "LEUKAEMIA, a type of cancer, also LEUCAEMIA, LEUCEMIA, LEUCHAEMIA, LEUKEMIA [n]\n",
  "LEUKAEMIC": "relating to leukaemia, also LEUCAEMIC [adj]\n",
  "LEUKAEMOGEN": "a substance or agent which promotes the development of leukaemia, also LEUCAEMOGEN, LEUKEMOGEN [n -S]\n",
  "LEUKAEMOGENESES": "LEUKAEMOGENESIS, the development of leukaemia, also LEUKEMOGENESIS [n]\n",
  "LEUKAEMOGENESIS": "the development of leukaemia, also LEUKEMOGENESIS [n LEUKAEMOGENESES]\n",
  "LEUKAEMOGENIC": "causing leukaemia, also LEUCAEMOGENIC [adj]\n",
  "LEUKAEMOGENS": "LEUKAEMOGEN, a substance or agent which promotes the development of leukaemia, also LEUCAEMOGEN, LEUKEMOGEN [n]\n",
  "LEUKEMIA": "a disease of the blood-forming organs, also LEUCEMIA, LEUKOSIS [n -S]\n",
  "LEUKEMIAS": "LEUKEMIA, a disease of the blood-forming organs, also LEUCEMIA, LEUKOSIS [n]\n",
  "LEUKEMIC": "relating to leukemia, also LEUCEMIC [n -S] / one suffering from leukemia [n -S]\n",
  "LEUKEMICS": "LEUKEMIC, relating to leukemia, also LEUCEMIC [n]\n",
  "LEUKEMOGEN": "a substance or agent which promotes the development of leukaemia, also LEUCAEMOGEN, LEUKAEMOGEN [n -S]\n",
  "LEUKEMOGENESES": "LEUKEMOGENESIS, the development of leukaemia, also LEUKAEMOGENESIS [n]\n",
  "LEUKEMOGENESIS": "the development of leukaemia, also LEUKAEMOGENESIS [n LEUKEMOGENESES]\n",
  "LEUKEMOGENIC": "relating to leukemogenesis [adj]\n",
  "LEUKEMOGENS": "LEUKEMOGEN, a substance or agent which promotes the development of leukaemia, also LEUCAEMOGEN, LEUKAEMOGEN [n]\n",
  "LEUKEMOID": "resembling leukemia but not causing the same changes in blood-forming organs [adj]\n",
  "LEUKOBLAST": "an immature leukocyte, also LEUCOBLAST [n -S]\n",
  "LEUKOBLASTS": "LEUKOBLAST, an immature leukocyte, also LEUCOBLAST [n]\n",
  "LEUKOCIDIN": "an exotoxin, produced by bacteria, that destroys leucocytes, also LEUCOCIDIN [n -S]\n",
  "LEUKOCIDINS": "LEUKOCIDIN, an exotoxin, produced by bacteria, that destroys leucocytes, also LEUCOCIDIN [n]\n",
  "LEUKOCYTE": "a colorless corpuscle, as one of the white blood corpuscles, also LEUCOCYTE [n -S]\n",
  "LEUKOCYTES": "LEUKOCYTE, a colorless corpuscle, as one of the white blood corpuscles, also LEUCOCYTE [n]\n",
  "LEUKOCYTIC": "of or like leukocytes [adj]\n",
  "LEUKOCYTOLYSES": "LEUKOCYTOLYSIS, the destruction of leucocytes, also LEUCOCYTOLYSIS [n]\n",
  "LEUKOCYTOLYSIS": "the destruction of leucocytes, also LEUCOCYTOLYSIS [n LEUKOCYTOLYSES]\n",
  "LEUKOCYTOPENIA": "a decrease in the number of leucocytes in blood [n -S]\n",
  "LEUKOCYTOPENIAS": "LEUKOCYTOPENIA, a decrease in the number of leucocytes in blood [n]\n",
  "LEUKOCYTOSES": "LEUKOCYTOSIS, an increase in the number of white blood cells in the circulating blood [n]\n",
  "LEUKOCYTOSIS": "an increase in the number of white blood cells in the circulating blood [n LEUKOCYTOSES]\n",
  "LEUKOCYTOTIC": "relating to leukocytosis, an increase in the number of white blood cells in the circulating blood [adj]\n",
  "LEUKODEPLETED": "of or denoting blood from which the white cells have been removed, also LEUCODEPLETED [adj]\n",
  "LEUKODERMA": "any area of skin that is white from albinism, also LEUCODERMA [n -S]\n",
  "LEUKODERMAL": "relating to leucoderma, a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMAL, LEUCODERMIC [adj]\n",
  "LEUKODERMAS": "LEUKODERMA, any area of skin that is white from albinism, also LEUCODERMA [n]\n",
  "LEUKODERMIC": "relating to leukoderma, a condition in which white patches, surrounded by a pigmented area, appear on the skin, also LEUCODERMIC [adj]\n",
  "LEUKODYSTROPHY": "any of several genetically determined diseases characterized by progressive degeneration of myelin in the brain, spinal cord, and peripheral nerves [n]\n",
  "LEUKOMA": "(Greek) a white opacity in the cornea of the eye, aka albugo, also LEUCOMA [n -S]\n",
  "LEUKOMAS": "LEUKOMA, (Greek) a white opacity in the cornea of the eye, aka albugo, also LEUCOMA [n]\n",
  "LEUKON": "(Greek) a bodily organ consisting of the white blood cells [n -S]\n",
  "LEUKONS": "LEUKON, (Greek) a bodily organ consisting of the white blood cells [n]\n",
  "LEUKOPENIA": "an abnormally low white blood count, also LEUCOPENIA [n -S]\n",
  "LEUKOPENIAS": "LEUKOPENIA, an abnormally low white blood count, also LEUCOPENIA [n]\n",
  "LEUKOPENIC": "relating to leukopenia, an abnormally low white blood count, also LEUCOPENIC [adj]\n",
  "LEUKOPLAKIA": "the stage of a chronically inflamed area at which the surface becomes hard, white and smooth, also LEUCOPLAKIA [n -S]\n",
  "LEUKOPLAKIAS": "LEUKOPLAKIA, the stage of a chronically inflamed area at which the surface becomes hard, white and smooth, also LEUCOPLAKIA [n]\n",
  "LEUKOPLAKIC": "relating to leukoplakia, the stage of a chronically inflamed area at which the surface becomes hard, white and smooth, also LEUCOPLAKIC [adj]\n",
  "LEUKOPOIESES": "LEUKOPOIESIS, the formation of white blood cells, also LEUCOPOIESIS [n]\n",
  "LEUKOPOIESIS": "the formation of white blood cells, also LEUCOPOIESIS [n LEUKOPOIESES]\n",
  "LEUKOPOIETIC": "relating to leukopoiesis, also LEUCOPOIETIC [adj]\n",
  "LEUKORRHEA": "a vaginal discharge, also LEUCORRHOEA [n -S]\n",
  "LEUKORRHEAL": "relating to leukorrhea, a vaginal discharge, also LEUCORRHOEAL [adj]\n",
  "LEUKORRHEAS": "LEUKORRHEA, a vaginal discharge, also LEUCORRHOEA [n]\n",
  "LEUKOSES": "LEUKOSIS, leukaemia, also LEUCOSIS [n]\n",
  "LEUKOSIS": "leukaemia, also LEUCOSIS [n LEUKOSES]\n",
  "LEUKOTIC": "relating to leukosis, leukaemia, also LEUCOTIC [adj]\n",
  "LEUKOTOME": "a needle used in leukotomy, also LEUCOTOME [n -S]\n",
  "LEUKOTOMES": "LEUKOTOME, a needle used in leukotomy, also LEUCOTOME [n]\n",
  "LEUKOTOMIES": "LEUKOTOMY, a surgical scission of the fibres between the frontal lobes of the brain and the thalamus to relieve cases of severe schizophrenia, also LEUCOTOMY [n]\n",
  "LEUKOTOMY": "a surgical scission of the fibres between the frontal lobes of the brain and the thalamus to relieve cases of severe schizophrenia, also LEUCOTOMY [n LEUKOTOMIES]\n",
  "LEUKOTRIENE": "any of a group of eicosanoids that participate in allergic responses, such as bronchial constriction [n -S]\n",
  "LEUKOTRIENES": "LEUKOTRIENE, any of a group of eicosanoids that participate in allergic responses, such as bronchial constriction [n]\n",
  "LEV": "a unit of Bulgarian currency, also LEW [n LEVA, LEVAS or LEVS]\n",
  "LEVA": "LEV, a unit of Bulgarian currency, also LEW [n]\n",
  "LEVANT": "to run away from a debt [v -ED, -ING, -S]\n",
  "LEVANTED": "LEVANT, to run away from a debt [v]\n",
  "LEVANTER": "a boisterous Mediterranean easterly wind [n -S]\n",
  "LEVANTERS": "LEVANTER, a boisterous Mediterranean easterly wind [n]\n",
  "LEVANTINE": "a closely-woven twilled silk cloth [n -S]\n",
  "LEVANTINES": "LEVANTINE, a closely-woven twilled silk cloth [n]\n",
  "LEVANTING": "LEVANT, to run away from a debt [v]\n",
  "LEVANTS": "LEVANT, to run away from a debt [v]\n",
  "LEVAS": "LEV, a unit of Bulgarian currency, also LEW [n]\n",
  "LEVATOR": "(Latin) a muscle that raises [n LEVATORS or LEVATORES]\n",
  "LEVATORES": "LEVATOR, (Latin) a muscle that raises [n]\n",
  "LEVATORS": "LEVATOR, (Latin) a muscle that raises [n]\n",
  "LEVE": "(archaic) gladly, also LIEF [adj] / a beloved, also LIEVE [n -S]\n",
  "LEVEE": "(historical) an early reception of visitors [n -S] / to attend such a reception [v LEVEED, LEVEEING, LEVEES]\n",
  "LEVEED": "LEVEE, to attend such a reception [v]\n",
  "LEVEEING": "LEVEE, to attend such a reception [v]\n",
  "LEVEES": "LEVEE, to attend such a reception [v]\n",
  "LEVEL": "even [adj LEVELLER, LEVELLEST, LEVELLY] / to make even [v LEVELED or LEVELLED, LEVELING or LEVELLING, LEVELS]\n",
  "LEVELED": "LEVEL, to make even [v]\n",
  "LEVELER": "one that levels, also LEVELLER [n -S]\n",
  "LEVELERS": "LEVELER, one that levels, also LEVELLER [n]\n",
  "LEVELHEADED": "having or showing sound judgment [adj]\n",
  "LEVELHEADEDNESS": "LEVELHEADED, having or showing sound judgment [n]\n",
  "LEVELING": "LEVEL, to make even [v]\n",
  "LEVELLED": "LEVEL, to make even [v]\n",
  "LEVELLER": "one that levels, also LEVELER [n -S]\n",
  "LEVELLERS": "LEVELLER, one that levels, also LEVELER [n]\n",
  "LEVELLEST": "LEVEL, even [adj]\n",
  "LEVELLING": "the act of making level [n -S]\n",
  "LEVELLINGS": "LEVELLING, the act of making level [n]\n",
  "LEVELLY": "LEVEL, even [adv]\n",
  "LEVELNESS": "the state of being level [n -ES]\n",
  "LEVELNESSES": "LEVELNESS, the state of being level [n]\n",
  "LEVELS": "LEVEL, to make even [v]\n",
  "LEVER": "to prise open [v -ED, -ING, -S]\n",
  "LEVERAGE": "the mechanical power gained by the use of a lever [n -S] / to provide with a type of economic advantage [v LEVERAGED, LEVERAGING, LEVERAGES]\n",
  "LEVERAGED": "LEVERAGE, to provide with a type of economic advantage [v]\n",
  "LEVERAGES": "LEVERAGE, to provide with a type of economic advantage [v]\n",
  "LEVERAGING": "LEVERAGE, to provide with a type of economic advantage [v]\n",
  "LEVERED": "LEVER, to prise open [v]\n",
  "LEVERET": "a young hare [n -S]\n",
  "LEVERETS": "LEVERET, a young hare [n]\n",
  "LEVERING": "LEVER, to prise open [v]\n",
  "LEVERS": "LEVER, to prise open [v]\n",
  "LEVES": "LEVE, a beloved, also LIEVE [n]\n",
  "LEVIABLE": "able to be levied [adj]\n",
  "LEVIATHAN": "an (imaginary or real) aquatic animal of enormous size; anything of giant size [n -S]\n",
  "LEVIATHANS": "LEVIATHAN, an (imaginary or real) aquatic animal of enormous size; anything of giant size [n]\n",
  "LEVIED": "LEVY, to impose or collect by legal authority [v]\n",
  "LEVIER": "one who levies [n -S]\n",
  "LEVIERS": "LEVIER, one who levies [n]\n",
  "LEVIES": "LEVY, to impose or collect by legal authority [v]\n",
  "LEVIGABLE": "capable of being levigated [adj]\n",
  "LEVIGATE": "to reduce to a fine powder [v LEVIGATED, LEVIGATING, LEVIGATES]\n",
  "LEVIGATED": "LEVIGATE, to reduce to a fine powder [v]\n",
  "LEVIGATES": "LEVIGATE, to reduce to a fine powder [v]\n",
  "LEVIGATING": "LEVIGATE, to reduce to a fine powder [v]\n",
  "LEVIGATION": "the act or operation of levigating [n -S]\n",
  "LEVIGATIONS": "LEVIGATION, the act or operation of levigating [n]\n",
  "LEVIGATOR": "one who levigates [n -S]\n",
  "LEVIGATORS": "LEVIGATOR, one who levigates [n]\n",
  "LEVIN": "(archaic) lightning [n -S]\n",
  "LEVINS": "LEVIN, (archaic) lightning [n]\n",
  "LEVIRATE": "the ancient Hebrew custom of compulsory marriage with a childless brother's widow [n -S]\n",
  "LEVIRATES": "LEVIRATE, the ancient Hebrew custom of compulsory marriage with a childless brother's widow [n]\n",
  "LEVIRATIC": "of or like a levirate, the ancient Hebrew custom of compulsory marriage with a childless brother's widow, also LEVIRATICAL [adj]\n",
  "LEVIRATICAL": "of or like a levirate, the ancient Hebrew custom of compulsory marriage with a childless brother's widow, also LEVIRATIC [adj]\n",
  "LEVIRATION": "levirate marriage or marriages [n -S]\n",
  "LEVIRATIONS": "LEVIRATION, levirate marriage or marriages [n]\n",
  "LEVIS": "(tradename) heavy close-fitting denim trousers [n]\n",
  "LEVITATE": "to rise and float in the air [v LEVITATED, LEVITATING, LEVITATES]\n",
  "LEVITATED": "LEVITATE, to rise and float in the air [v]\n",
  "LEVITATES": "LEVITATE, to rise and float in the air [v]\n",
  "LEVITATING": "LEVITATE, to rise and float in the air [v]\n",
  "LEVITATION": "the act of levitating [n -S]\n",
  "LEVITATIONAL": "relating to levitation [adj]\n",
  "LEVITATIONS": "LEVITATION, the act of levitating [n]\n",
  "LEVITATOR": "one who levitates [n -S]\n",
  "LEVITATORS": "LEVITATOR, one who levitates [n]\n",
  "LEVITE": "(slang) a clergyman [n -S]\n",
  "LEVITES": "LEVITE, (slang) a clergyman [n]\n",
  "LEVITIC": "of or like a levite or clergyman, also LEVITICAL [adj LEVITICALLY]\n",
  "LEVITICAL": "of or like a levite or clergyman, also LEVITIC [adj LEVITICALLY]\n",
  "LEVITICALLY": "LEVITICAL, of or like a levite or clergyman, also LEVITIC [adv]\n",
  "LEVITIES": "LEVITY, frivolity [n]\n",
  "LEVITY": "frivolity [n LEVITIES]\n",
  "LEVO": "turning towards the left, also LAEVO [adj]\n",
  "LEVODOPA": "a type of drug to treat Parkinson's disease [n -S]\n",
  "LEVODOPAS": "LEVODOPA, a type of drug to treat Parkinson's disease [n]\n",
  "LEVOGYRE": "an anticlockwise spiral [n -S]\n",
  "LEVOGYRES": "LEVOGYRE, an anticlockwise spiral [n]\n",
  "LEVOROTARY": "counterclockwise; rotating the plane of polarization of light to the left, also LAEVOROTATORY, LEVOROTATORY [adj]\n",
  "LEVOROTATORY": "counterclockwise; rotating the plane of polarization of light to the left, also LAEVOROTATORY, LEVOROTARY [adj]\n",
  "LEVS": "LEV, a unit of Bulgarian currency, also LEW [n]\n",
  "LEVULIN": "a sugar in certain plants, also LAEVULIN [n -S]\n",
  "LEVULINS": "LEVULIN, a sugar in certain plants, also LAEVULIN [n]\n",
  "LEVULOSE": "a form of fructose, also LAEVULOSE [n -S]\n",
  "LEVULOSES": "LEVULOSE, a form of fructose, also LAEVULOSE [n]\n",
  "LEVY": "to impose or collect by legal authority [v LEVIED, LEVYING, LEVIES]\n",
  "LEVYING": "LEVY, to impose or collect by legal authority [v]\n",
  "LEW": "a unit of Bulgarian currency, also LEV [n LEVA]\n",
  "LEWD": "sexually suggestive [adj LEWDER, LEWDEST, LEWDLY]\n",
  "LEWDER": "LEWD, sexually suggestive [adj]\n",
  "LEWDEST": "LEWD, sexually suggestive [adj]\n",
  "LEWDLY": "LEWD, sexually suggestive [adv]\n",
  "LEWDNESS": "the state of being lewd [n -ES]\n",
  "LEWDNESSES": "LEWDNESS, the state of being lewd [n]\n",
  "LEWDSBIES": "LEWDSBY, someone addicted to lewdness, also LEWDSTER [n]\n",
  "LEWDSBY": "someone addicted to lewdness, also LEWDSTER [n LEWDSBIES]\n",
  "LEWDSTER": "someone addicted to lewdness, also LEWDSBY [n -S]\n",
  "LEWDSTERS": "LEWDSTER, someone addicted to lewdness, also LEWDSBY [n]\n",
  "LEWIS": "a dovetailed iron tenon made to fit into a stone so that it can be hoisted, also LEWISSON [n -ES]\n",
  "LEWISES": "LEWIS, a dovetailed iron tenon made to fit into a stone so that it can be hoisted, also LEWISSON [n]\n",
  "LEWISIA": "a perennial herb with pink and white flowers [n -S]\n",
  "LEWISIAS": "LEWISIA, a perennial herb with pink and white flowers [n]\n",
  "LEWISITE": "an irritant and poison gas used for chemical warfare [n -S]\n",
  "LEWISITES": "LEWISITE, an irritant and poison gas used for chemical warfare [n]\n",
  "LEWISSON": "a dovetailed iron tenon made to fit into a stone so that it can be hoisted, also LEWIS [n -S]\n",
  "LEWISSONS": "LEWISSON, a dovetailed iron tenon made to fit into a stone so that it can be hoisted, also LEWIS [n]\n",
  "LEX": "(Latin) law [n LEXES or LEGES]\n",
  "LEXEME": "the fundamental unit of the lexicon of a language e.g. find, found, and finding are members of the English lexeme find [n -S]\n",
  "LEXEMES": "LEXEME, the fundamental unit of the lexicon of a language e.g. find, found, and finding are members of the English lexeme find [n]\n",
  "LEXEMIC": "of or like a lexeme, one of the vocabulary items of a language [adj]\n",
  "LEXES": "LEX, (Latin) law [n]\n",
  "LEXICA": "LEXICON, (Greek) a dictionary [n]\n",
  "LEXICAL": "of or relating to words or the vocabulary of a language as distinguished from its grammar and construction [adj LEXICALLY]\n",
  "LEXICALISATION": "the realization of a meaning in a single word or morpheme rather than in a grammatical construction, also LEXICALIZATION [n -S]\n",
  "LEXICALISATIONS": "LEXICALISATION, the realization of a meaning in a single word or morpheme rather than in a grammatical construction, also LEXICALIZATION [n]\n",
  "LEXICALISE": "to put into a lexicon, also LEXICALIZE [v LEXICALISED, LEXICALISING, LEXICALISES]\n",
  "LEXICALISED": "LEXICALISE, to put into a lexicon, also LEXICALIZE [v]\n",
  "LEXICALISES": "LEXICALISE, to put into a lexicon, also LEXICALIZE [v]\n",
  "LEXICALISING": "LEXICALISE, to put into a lexicon, also LEXICALIZE [v]\n",
  "LEXICALITIES": "LEXICALITY, the quality of belonging to a lexicon [n]\n",
  "LEXICALITY": "the quality of belonging to a lexicon [n LEXICALITIES]\n",
  "LEXICALIZATION": "the realization of a meaning in a single word or morpheme rather than in a grammatical construction, also LEXICALISATION [n -S]\n",
  "LEXICALIZATIONS": "LEXICALIZATION, the realization of a meaning in a single word or morpheme rather than in a grammatical construction, also LEXICALISATION [n]\n",
  "LEXICALIZE": "to put into a lexicon, also LEXICALISE [v LEXICALIZED, LEXICALIZING, LEXICALIZES]\n",
  "LEXICALIZED": "LEXICALIZE, to put into a lexicon, also LEXICALISE [v]\n",
  "LEXICALIZES": "LEXICALIZE, to put into a lexicon, also LEXICALISE [v]\n",
  "LEXICALIZING": "LEXICALIZE, to put into a lexicon, also LEXICALISE [v]\n",
  "LEXICALLY": "LEXICAL, of or relating to words or the vocabulary of a language as distinguished from its grammar and construction [adv]\n",
  "LEXICOGRAPHER": "an author or editor of a dictionary [n -S]\n",
  "LEXICOGRAPHERS": "LEXICOGRAPHER, an author or editor of a dictionary [n]\n",
  "LEXICOGRAPHIC": "relating to lexicography, also LEXICOGRAPHICAL [adj]\n",
  "LEXICOGRAPHICAL": "relating to lexicography, also LEXICOGRAPHIC [adj]\n",
  "LEXICOGRAPHIES": "LEXICOGRAPHY, the editing or making of a dictionary [n]\n",
  "LEXICOGRAPHIST": "one who makes dictionaries [n -S]\n",
  "LEXICOGRAPHISTS": "LEXICOGRAPHIST, one who makes dictionaries [n]\n",
  "LEXICOGRAPHY": "the editing or making of a dictionary [n LEXICOGRAPHIES]\n",
  "LEXICOLOGICAL": "relating to lexicology [adj LEXICOLOGICALLY]\n",
  "LEXICOLOGICALLY": "LEXICOLOGICAL, relating to lexicology [adv]\n",
  "LEXICOLOGIES": "LEXICOLOGY, the study of words and their meanings [n]\n",
  "LEXICOLOGIST": "a practitioner of lexicology [n -S]\n",
  "LEXICOLOGISTS": "LEXICOLOGIST, a practitioner of lexicology [n]\n",
  "LEXICOLOGY": "the study of words and their meanings [n LEXICOLOGIES]\n",
  "LEXICON": "(Greek) a dictionary [n LEXICONS or LEXICA]\n",
  "LEXICONS": "LEXICON, (Greek) a dictionary [n]\n",
  "LEXIGRAM": "a sign which represents a word [n -S]\n",
  "LEXIGRAMS": "LEXIGRAM, a sign which represents a word [n]\n",
  "LEXIGRAPHIC": "relating to lexigraphy, the art of the definition of words, also LEXIGRAPHICAL [adj]\n",
  "LEXIGRAPHICAL": "relating to lexigraphy, the art of the definition of words, also LEXIGRAPHIC [adj]\n",
  "LEXIGRAPHIES": "LEXIGRAPHY, the art of the definition of words [n]\n",
  "LEXIGRAPHY": "the art of the definition of words [n LEXIGRAPHIES]\n",
  "LEXIS": "(Latin) the total stock of words in a language [n -ES]\n",
  "LEXISES": "LEXIS, (Latin) the total stock of words in a language [n]\n",
  "LEY": "a meadow, also LEA [n -S]\n",
  "LEYLANDI": "the Leyland cypress [n -S]\n",
  "LEYLANDII": "the Leyland cypress, also LEYLANDI [n -S]\n",
  "LEYLANDIIS": "LEYLANDII, the Leyland cypress, also LEYLANDI [n]\n",
  "LEYLANDIS": "LEYLANDI, the Leyland cypress [n]\n",
  "LEYS": "LEY, a meadow, also LEA [n]\n",
  "LEZ": "(short for) a lesbian, also LES, LEZZ, LEZZA, LEZZIE, LEZZY [n -ES]\n",
  "LEZES": "LEZ, (short for) a lesbian, also LES, LEZZ, LEZZA, LEZZIE, LEZZY [n]\n",
  "LEZZ": "(short for) a lesbian, also LES, LEZ, LEZZA, LEZZIE, LEZZY [n -ES]\n",
  "LEZZA": "(short for) a lesbian, also LES, LEZ, LEZZ, LEZZIE, LEZZY [n -S]\n",
  "LEZZAS": "LEZZA, (short for) a lesbian, also LES, LEZ, LEZZ, LEZZIE, LEZZY [n]\n",
  "LEZZES": "LEZZ, (short for) a lesbian, also LES, LEZ, LEZZA, LEZZIE, LEZZY [n]\n",
  "LEZZIE": "(short for) a lesbian, also LES, LEZ, LEZZ, LEZZA, LEZZY [n -S]\n",
  "LEZZIES": "LEZZIE, (short for) a lesbian, also LES, LEZ, LEZZ, LEZZA, LEZZY [n]\n",
  "LEZZY": "(short for) a lesbian, also LES, LEZ, LEZZ, LEZZA, LEZZIE [n LEZZIES]\n",
  "LHERZOLITE": "an igneous rock consisting largely of chrysolite, with pyroxene and picotite [n -S]\n",
  "LHERZOLITES": "LHERZOLITE, an igneous rock consisting largely of chrysolite, with pyroxene and picotite [n]\n",
  "LI": "(Chinese) a Chinese unit of distance [n -S]\n",
  "LIABILITIES": "LIABILITY, the state of being liable [n]\n",
  "LIABILITY": "the state of being liable [n LIABILITIES]\n",
  "LIABLE": "subject to an obligation [adj]\n",
  "LIABLENESS": "the state of being liable [n -ES]\n",
  "LIABLENESSES": "LIABLENESS, the state of being liable [n]\n",
  "LIAISE": "to form a link with [v LIAISED, LIAISING, LIAISES]\n",
  "LIAISED": "LIAISE, to form a link with [v]\n",
  "LIAISES": "LIAISE, to form a link with [v]\n",
  "LIAISING": "LIAISE, to form a link with [v]\n",
  "LIAISON": "(French) a means of maintaining communication [n -S]\n",
  "LIAISONS": "LIAISON, (French) a means of maintaining communication [n]\n",
  "LIANA": "any climbing plant, esp. a twisted woody kind festooning tropical forests, also LIANE [n -S]\n",
  "LIANAS": "LIANA, any climbing plant, esp. a twisted woody kind festooning tropical forests, also LIANE [n]\n",
  "LIANE": "any climbing plant, esp. a twisted woody kind festooning tropical forests, also LIANA [n -S]\n",
  "LIANES": "LIANE, any climbing plant, esp. a twisted woody kind festooning tropical forests, also LIANA [n]\n",
  "LIANG": "(Chinese) a Chinese unit of weight [n -S]\n",
  "LIANGS": "LIANG, (Chinese) a Chinese unit of weight [n]\n",
  "LIANOID": "like a liana [adj]\n",
  "LIAR": "one that speaks falsely, also LEEAR [n -S]\n",
  "LIARD": "grey; dapple-grey, also LIART, LYARD, LYART [adj] / an old French coin of low value [n -S]\n",
  "LIARDS": "LIARD, an old French coin of low value [n]\n",
  "LIARS": "LIAR, one that speaks falsely, also LEEAR [n]\n",
  "LIART": "grey; dapple-grey, also LIARD, LYARD, LYART [adj]\n",
  "LIAS": "the lowest series of rocks of the Jurassic system [n -ES]\n",
  "LIASES": "LIAS, the lowest series of rocks of the Jurassic system [n]\n",
  "LIASSIC": "of, relating to, or being a subdivision of the European Jurassic [adj]\n",
  "LIATRIS": "a North American plant with small white flowers [n -ES]\n",
  "LIATRISES": "LIATRIS, a North American plant with small white flowers [n]\n",
  "LIB": "to geld [v LIBBED, LIBBING, LIBS]\n",
  "LIBANT": "(archaic) sipping; touching lightly [adj]\n",
  "LIBATE": "to pour in honour to [v LIBATED, LIBATING, LIBATES]\n",
  "LIBATED": "LIBATE, to pour in honour to [v]\n",
  "LIBATES": "LIBATE, to pour in honour to [v]\n",
  "LIBATING": "LIBATE, to pour in honour to [v]\n",
  "LIBATION": "a ceremonial pouring of a liquid [n -S]\n",
  "LIBATIONAL": "relating to or having libation [adj]\n",
  "LIBATIONARY": "of or like a libation [adj]\n",
  "LIBATIONS": "LIBATION, a ceremonial pouring of a liquid [n]\n",
  "LIBATORY": "relating to libation [adj]\n",
  "LIBBARD": "(archaic) a leopard [n -S]\n",
  "LIBBARDS": "LIBBARD, (archaic) a leopard [n]\n",
  "LIBBED": "LIB, to geld [v]\n",
  "LIBBER": "(short for) a liberationist [n -S]\n",
  "LIBBERS": "LIBBER, (short for) a liberationist [n]\n",
  "LIBBING": "LIB, to geld [v]\n",
  "LIBECCHIO": "(Milton) a strong westerly (or southwesterly) wind that blows on to Corsica's western coast, also LIBECCIO [n -S]\n",
  "LIBECCHIOS": "LIBECCHIO, (Milton) a strong westerly (or southwesterly) wind that blows on to Corsica's western coast, also LIBECCIO [n]\n",
  "LIBECCIO": "(Italian) a strong westerly (or southwesterly) wind that blows on to Corsica's western coast, also LIBECCHIO [n -S]\n",
  "LIBECCIOS": "LIBECCIO, (Italian) a strong westerly (or southwesterly) wind that blows on to Corsica's western coast, also LIBECCHIO [n]\n",
  "LIBEL": "to make a defamatory statement about [v LIBELED or LIBELLED, LIBELING or LIBELLING, LIBELS]\n",
  "LIBELANT": "one who brings a charge of libel, also LIBELLANT [n -S]\n",
  "LIBELANTS": "LIBELANT, one who brings a charge of libel, also LIBELLANT [n]\n",
  "LIBELED": "LIBEL, to make a defamatory statement about [v]\n",
  "LIBELEE": "one who is libeled, also LIBELLEE [n -S]\n",
  "LIBELEES": "LIBELEE, one who is libeled, also LIBELLEE [n]\n",
  "LIBELER": "one that libels, also LIBELIST, LIBELLER [n -S]\n",
  "LIBELERS": "LIBELER, one that libels, also LIBELIST, LIBELLER [n]\n",
  "LIBELING": "the act of libeling [n -S]\n",
  "LIBELINGS": "LIBELING, the act of libeling [n]\n",
  "LIBELIST": "one that libels, also LIBELER, LIBELLER [n -S]\n",
  "LIBELISTS": "LIBELIST, one that libels, also LIBELER, LIBELLER [n]\n",
  "LIBELLANT": "one who brings a charge of libel, also LIBELANT [n -S]\n",
  "LIBELLANTS": "LIBELLANT, one who brings a charge of libel, also LIBELANT [n]\n",
  "LIBELLED": "LIBEL, to make a defamatory statement about [v]\n",
  "LIBELLEE": "a defendant in a type of lawsuit, also LIBELEE [n -S]\n",
  "LIBELLEES": "LIBELLEE, a defendant in a type of lawsuit, also LIBELEE [n]\n",
  "LIBELLER": "one that libels, also LIBELER, LIBELIST [n -S]\n",
  "LIBELLERS": "LIBELLER, one that libels, also LIBELER, LIBELIST [n]\n",
  "LIBELLING": "the act of making a libel [n -S]\n",
  "LIBELLINGS": "LIBELLING, the act of making a libel [n]\n",
  "LIBELLOUS": "relating to libel, also LIBELOUS [adj LIBELLOUSLY]\n",
  "LIBELLOUSLY": "LIBELLOUS, relating to libel, also LIBELOUS [adv]\n",
  "LIBELOUS": "relating to libel, also LIBELLOUS [adj]\n",
  "LIBELOUSLY": "LIBELOUS, relating to libel, also LIBELLOUS [adv]\n",
  "LIBELS": "LIBEL, to make a defamatory statement about [v]\n",
  "LIBER": "(Latin) a book of public records [n LIBERS or LIBRI]\n",
  "LIBERAL": "generous, freehanded [adj LIBERALLY] / a person favorable to progress or reform [n -S]\n",
  "LIBERALISATION": "the process of liberalising, also LIBERALIZATION [n -S]\n",
  "LIBERALISATIONS": "LIBERALISATION, the process of liberalising, also LIBERALIZATION [n]\n",
  "LIBERALISE": "to make liberal or more liberal, also LIBERALIZE [v LIBERALISED, LIBERALISING, LIBERALISES]\n",
  "LIBERALISED": "LIBERALISE, to make liberal or more liberal, also LIBERALIZE [v]\n",
  "LIBERALISER": "one who liberalises, also LIBERALIZER [n -S]\n",
  "LIBERALISERS": "LIBERALISER, one who liberalises, also LIBERALIZER [n]\n",
  "LIBERALISES": "LIBERALISE, to make liberal or more liberal, also LIBERALIZE [v]\n",
  "LIBERALISING": "LIBERALISE, to make liberal or more liberal, also LIBERALIZE [v]\n",
  "LIBERALISM": "the state of being liberal [n -S]\n",
  "LIBERALISMS": "LIBERALISM, the state of being liberal [n]\n",
  "LIBERALIST": "an adherent of liberalism [n -S]\n",
  "LIBERALISTIC": "relating to liberalism [adj]\n",
  "LIBERALISTS": "LIBERALIST, an adherent of liberalism [n]\n",
  "LIBERALITIES": "LIBERALITY, the state of being liberal [n]\n",
  "LIBERALITY": "the state of being liberal [n LIBERALITIES]\n",
  "LIBERALIZATION": "the act of liberalizing, also LIBERALISATION [n -S]\n",
  "LIBERALIZATIONS": "LIBERALIZATION, the act of liberalizing, also LIBERALISATION [n]\n",
  "LIBERALIZE": "to make liberal or more liberal, also LIBERALISE [v LIBERALIZED, LIBERALIZING, LIBERALIZES]\n",
  "LIBERALIZED": "LIBERALIZE, to make liberal or more liberal, also LIBERALISE [v]\n",
  "LIBERALIZER": "one who liberalizes, also LIBERALISER [n -S]\n",
  "LIBERALIZERS": "LIBERALIZER, one who liberalizes, also LIBERALISER [n]\n",
  "LIBERALIZES": "LIBERALIZE, to make liberal or more liberal, also LIBERALISE [v]\n",
  "LIBERALIZING": "LIBERALIZE, to make liberal or more liberal, also LIBERALISE [v]\n",
  "LIBERALLY": "LIBERAL, generous, freehanded [adv]\n",
  "LIBERALNESS": "the state of being liberal [n -ES]\n",
  "LIBERALNESSES": "LIBERALNESS, the state of being liberal [n]\n",
  "LIBERALS": "LIBERAL, a person favorable to progress or reform [n]\n",
  "LIBERATE": "to set free [v LIBERATED, LIBERATING, LIBERATES]\n",
  "LIBERATED": "LIBERATE, to set free [v]\n",
  "LIBERATES": "LIBERATE, to set free [v]\n",
  "LIBERATING": "LIBERATE, to set free [v]\n",
  "LIBERATION": "the act of liberating [n -S]\n",
  "LIBERATIONISM": "the cause of social freedom and equality for sections of society believed to be underprivileged or discriminated against [n -S]\n",
  "LIBERATIONISMS": "LIBERATIONISM, the cause of social freedom and equality for sections of society believed to be underprivileged or discriminated against [n]\n",
  "LIBERATIONIST": "a believer in liberation [n -S]\n",
  "LIBERATIONISTS": "LIBERATIONIST, a believer in liberation [n]\n",
  "LIBERATIONS": "LIBERATION, the act of liberating [n]\n",
  "LIBERATOR": "one who liberates [n -S]\n",
  "LIBERATORS": "LIBERATOR, one who liberates [n]\n",
  "LIBERATORY": "tending, or serving, to liberate [adj]\n",
  "LIBERO": "(Italian) a footballer who plays behind the backs, a sweeper [n -S]\n",
  "LIBEROS": "LIBERO, (Italian) a footballer who plays behind the backs, a sweeper [n]\n",
  "LIBERS": "LIBER, (Latin) a book of public records [n]\n",
  "LIBERTARIAN": "one who believes in the maximum amount of freedom [n -S]\n",
  "LIBERTARIANISM": "belief in the maximum amount of freedom [n -S]\n",
  "LIBERTARIANISMS": "LIBERTARIANISM, belief in the maximum amount of freedom [n]\n",
  "LIBERTARIANS": "LIBERTARIAN, one who believes in the maximum amount of freedom [n]\n",
  "LIBERTICIDAL": "destructive of liberty [adj]\n",
  "LIBERTICIDE": "destruction of liberty [n -S]\n",
  "LIBERTICIDES": "LIBERTICIDE, destruction of liberty [n]\n",
  "LIBERTIES": "LIBERTY, the state of being free [n]\n",
  "LIBERTINAGE": "debauchery [n -S]\n",
  "LIBERTINAGES": "LIBERTINAGE, debauchery [n]\n",
  "LIBERTINE": "a person who leads a licentious life, a rake [n -S]\n",
  "LIBERTINES": "LIBERTINE, a person who leads a licentious life, a rake [n]\n",
  "LIBERTINISM": "the state of being libertine [n -S]\n",
  "LIBERTINISMS": "LIBERTINISM, the state of being libertine [n]\n",
  "LIBERTY": "the state of being free [n LIBERTIES]\n",
  "LIBIDINAL": "relating to the libido [adj LIBIDINALLY]\n",
  "LIBIDINALLY": "LIBIDINAL, relating to the libido [adv]\n",
  "LIBIDINIST": "a lewd person [n -S]\n",
  "LIBIDINISTS": "LIBIDINIST, a lewd person [n]\n",
  "LIBIDINOSITIES": "LIBIDINOSITY, the state of being libidinous [n]\n",
  "LIBIDINOSITY": "the state of being libidinous [n LIBIDINOSITIES]\n",
  "LIBIDINOUS": "having lustful desires; characterized by lewdness [adj LIBIDINOUSLY]\n",
  "LIBIDINOUSLY": "LIBIDINOUS, having lustful desires; characterized by lewdness [adv]\n",
  "LIBIDINOUSNESS": "LIBIDINOUS, having lustful desires; characterized by lewdness [n]\n",
  "LIBIDO": "(Latin) psychic drive or energy, esp. that associated with the sexual instinct [n -S]\n",
  "LIBIDOS": "LIBIDO, (Latin) psychic drive or energy, esp. that associated with the sexual instinct [n]\n",
  "LIBKEN": "in thieves' slang, a place to sleep [n -S]\n",
  "LIBKENS": "LIBKEN, in thieves' slang, a place to sleep [n]\n",
  "LIBLAB": "a person supporting a coalition of liberal and labour groups [n -S]\n",
  "LIBLABS": "LIBLAB, a person supporting a coalition of liberal and labour groups [n]\n",
  "LIBRA": "(Latin) an ancient Roman unit of weight [n LIBRAS or LIBRAE]\n",
  "LIBRAE": "LIBRA, (Latin) an ancient Roman unit of weight [n]\n",
  "LIBRAIRE": "(French) a bookseller [n -S]\n",
  "LIBRAIRES": "LIBRAIRE, (French) a bookseller [n]\n",
  "LIBRAIRIE": "(French) a bookshop [n -S]\n",
  "LIBRAIRIES": "LIBRAIRIE, (French) a bookshop [n]\n",
  "LIBRARIAN": "one who works in a library [n -S]\n",
  "LIBRARIANS": "LIBRARIAN, one who works in a library [n]\n",
  "LIBRARIANSHIP": "the office of librarian [n -S]\n",
  "LIBRARIANSHIPS": "LIBRARIANSHIP, the office of librarian [n]\n",
  "LIBRARIES": "LIBRARY, a room containing books for reading or reference [n]\n",
  "LIBRARY": "a room containing books for reading or reference [n LIBRARIES]\n",
  "LIBRAS": "LIBRA, (Latin) an ancient Roman unit of weight [n]\n",
  "LIBRATE": "to oscillate before settling into equilibrium [v LIBRATED, LIBRATING, LIBRATES]\n",
  "LIBRATED": "LIBRATE, to oscillate before settling into equilibrium [v]\n",
  "LIBRATES": "LIBRATE, to oscillate before settling into equilibrium [v]\n",
  "LIBRATING": "LIBRATE, to oscillate before settling into equilibrium [v]\n",
  "LIBRATION": "a slight swinging motion [n -S]\n",
  "LIBRATIONAL": "relating to libration, a slight swinging motion [adj]\n",
  "LIBRATIONS": "LIBRATION, a slight swinging motion [n]\n",
  "LIBRATORY": "balancing; moving like a balance, as it tends to an equipoise or level [adj]\n",
  "LIBRETTI": "LIBRETTO, (Italian) the text of an opera [n]\n",
  "LIBRETTIST": "one who makes a libretto [n -S]\n",
  "LIBRETTISTS": "LIBRETTIST, one who makes a libretto [n]\n",
  "LIBRETTO": "(Italian) the text of an opera [n LIBRETTOS or LIBRETTI]\n",
  "LIBRETTOS": "LIBRETTO, (Italian) the text of an opera [n]\n",
  "LIBRI": "LIBER, (Latin) a book of public records [n]\n",
  "LIBRIFORM": "shaped like a book [adj]\n",
  "LIBS": "LIB, to geld [v]\n",
  "LICE": "LOUSE, a parasitic insect [n]\n",
  "LICENCE": "to issue or grant authoritative permission to, also LICENSE [v LICENCED, LICENCING, LICENCES]\n",
  "LICENCED": "LICENCE, to issue or grant authoritative permission to, also LICENSE [v]\n",
  "LICENCEE": "one who is licensed, e.g. to run a pub, also LICENSEE [n -S]\n",
  "LICENCEES": "LICENCEE, one who is licensed, e.g. to run a pub, also LICENSEE [n]\n",
  "LICENCER": "one who licenses, also LICENSER, LICENSOR [n -S]\n",
  "LICENCERS": "LICENCER, one who licenses, also LICENSER, LICENSOR [n]\n",
  "LICENCES": "LICENCE, to issue or grant authoritative permission to, also LICENSE [v]\n",
  "LICENCING": "LICENCE, to issue or grant authoritative permission to, also LICENSE [v]\n",
  "LICENSABLE": "that can be licensed [adj]\n",
  "LICENSE": "to issue or grant authoritative permission to, also LICENCE [v LICENSED, LICENSING, LICENSES]\n",
  "LICENSED": "LICENSE, to issue or grant authoritative permission to, also LICENCE [v]\n",
  "LICENSEE": "one who is licensed, e.g. to run a pub, also LICENCEE [n -S]\n",
  "LICENSEES": "LICENSEE, one who is licensed, e.g. to run a pub, also LICENCEE [n]\n",
  "LICENSER": "one who licenses, also LICENSOR [n -S]\n",
  "LICENSERS": "LICENSER, one who licenses, also LICENSOR [n]\n",
  "LICENSES": "LICENSE, to issue or grant authoritative permission to, also LICENCE [v]\n",
  "LICENSING": "LICENSE, to issue or grant authoritative permission to, also LICENCE [v]\n",
  "LICENSOR": "one who licenses, also LICENSER [n -S]\n",
  "LICENSORS": "LICENSOR, one who licenses, also LICENSER [n]\n",
  "LICENSURE": "the act of licensing or granting of a licence, esp. for professional practice [n -S]\n",
  "LICENSURES": "LICENSURE, the act of licensing or granting of a licence, esp. for professional practice [n]\n",
  "LICENTE": "SENTE, a monetary unit of Lesotho [n]\n",
  "LICENTIATE": "one who has a license to exercise a profession; as, a licentiate in medicine or theology [n -S]\n",
  "LICENTIATES": "LICENTIATE, one who has a license to exercise a profession; as, a licentiate in medicine or theology [n]\n",
  "LICENTIATESHIP": "the office of licentiate [n -S]\n",
  "LICENTIATESHIPS": "LICENTIATESHIP, the office of licentiate [n]\n",
  "LICENTIATION": "the state of being a licentiate [n -S]\n",
  "LICENTIATIONS": "LICENTIATION, the state of being a licentiate [n]\n",
  "LICENTIOUS": "characterized by license; abusive of freedom [adj LICENTIOUSLY]\n",
  "LICENTIOUSLY": "LICENTIOUS, characterized by license; abusive of freedom [adv]\n",
  "LICENTIOUSNESS": "LICENTIOUS, characterized by license; abusive of freedom [n]\n",
  "LICH": "(obsolete) a corpse, also LYCH [n -ES]\n",
  "LICHANOS": "(Greek) in ancient Greek music, the string or the note struck by the forefinger [n -ES]\n",
  "LICHANOSES": "LICHANOS, (Greek) in ancient Greek music, the string or the note struck by the forefinger [n]\n",
  "LICHEE": "(Chinese) a tropical fruit, also LEECHEE, LICHI, LITCHI, LYCHEE [n -S]\n",
  "LICHEES": "LICHEE, (Chinese) a tropical fruit, also LEECHEE, LICHI, LITCHI, LYCHEE [n]\n",
  "LICHEN": "a compound plant consisting of a fungus and an alga living symbiotically [n -S] / to cover with lichen [v -ED, -ING, -S]\n",
  "LICHENED": "LICHEN, to cover with lichen [v]\n",
  "LICHENIN": "a substance isomeric with starch, extracted from several species of moss and lichen [n -S]\n",
  "LICHENING": "LICHEN, to cover with lichen [v]\n",
  "LICHENINS": "LICHENIN, a substance isomeric with starch, extracted from several species of moss and lichen [n]\n",
  "LICHENISM": "the association of fungus and alga as a lichen [n -S]\n",
  "LICHENISMS": "LICHENISM, the association of fungus and alga as a lichen [n]\n",
  "LICHENIST": "one who studies lichen [n -S]\n",
  "LICHENISTS": "LICHENIST, one who studies lichen [n]\n",
  "LICHENOID": "of or like lichen [adj]\n",
  "LICHENOLOGICAL": "relating to lichenology [adj]\n",
  "LICHENOLOGIES": "LICHENOLOGY, the study of lichens [n]\n",
  "LICHENOLOGIST": "a student of lichens [n -S]\n",
  "LICHENOLOGISTS": "LICHENOLOGIST, a student of lichens [n]\n",
  "LICHENOLOGY": "the study of lichens [n LICHENOLOGIES]\n",
  "LICHENOSE": "of, pertaining to, or resembling, lichens; abounding in lichens, also LICHENOUS [adj]\n",
  "LICHENOUS": "of, pertaining to, or resembling, lichens; abounding in lichens, also LICHENOSE [adj]\n",
  "LICHENS": "LICHEN, to cover with lichen [v]\n",
  "LICHES": "LICH, (obsolete) a corpse, also LYCH [n]\n",
  "LICHGATE": "a roofed churchyard gate, also LYCHGATE [n -S]\n",
  "LICHGATES": "LICHGATE, a roofed churchyard gate, also LYCHGATE [n]\n",
  "LICHI": "(Chinese) a tropical fruit, also LEECHEE, LICHEE, LITCHI, LYCHEE [n -S]\n",
  "LICHIS": "LICHI, (Chinese) a tropical fruit, also LEECHEE, LICHEE, LITCHI, LYCHEE [n]\n",
  "LICHT": "(Scots) light [adj LICHTER, LICHTEST, LICHTLY] / to light [v -ED, -ING, -S]\n",
  "LICHTED": "LICHT, to light [v]\n",
  "LICHTER": "LICHT, (Scots) light [adj]\n",
  "LICHTEST": "LICHT, (Scots) light [adj]\n",
  "LICHTING": "LICHT, to light [v]\n",
  "LICHTLIED": "LICHTLY, (Scots) to slight or make light of, also LIGHTLY [v]\n",
  "LICHTLIES": "LICHTLY, (Scots) to slight or make light of, also LIGHTLY [v]\n",
  "LICHTLY": "(Scots) to slight or make light of, also LIGHTLY [v LICHTLIED, LICHTLYING, LICHTLIES]\n",
  "LICHTLYING": "LICHTLY, (Scots) to slight or make light of, also LIGHTLY [v]\n",
  "LICHTS": "LICHT, to light [v]\n",
  "LICHWAKE": "a watch over a corpse, also LATEWAKE, LIKEWAKE, LIKEWALK, LYKEWAKE, LYKEWALK [n -S]\n",
  "LICHWAKES": "LICHWAKE, a watch over a corpse, also LATEWAKE, LIKEWAKE, LIKEWALK, LYKEWAKE, LYKEWALK [n]\n",
  "LICHWAY": "a path by which the dead are carried to burial [n -S]\n",
  "LICHWAYS": "LICHWAY, a path by which the dead are carried to burial [n]\n",
  "LICIT": "not forbidden by law, permissible [adj LICITLY]\n",
  "LICITLY": "LICIT, not forbidden by law, permissible [adv]\n",
  "LICITNESS": "the state of being licit [n -ES]\n",
  "LICITNESSES": "LICITNESS, the state of being licit [n]\n",
  "LICK": "to lap, taste or moisten with the tongue [v -ED, -ING, -S]\n",
  "LICKED": "LICK, to lap, taste or moisten with the tongue [v]\n",
  "LICKER": "one who licks [n -S]\n",
  "LICKERISH": "(obsolete) dainty, tempting to the taste; lecherous, also LIQUORISH [adj LICKERISHLY]\n",
  "LICKERISHLY": "LICKERISH, (obsolete) dainty, tempting to the taste; lecherous, also LIQUORISH [adv]\n",
  "LICKERISHNESS": "LICKERISH, (obsolete) dainty, tempting to the taste; lecherous, also LIQUORISH [n]\n",
  "LICKERISHNESSES": "LICKERISHNESS, LICKERISH, (obsolete) dainty, tempting to the taste; lecherous, also LIQUORISH [n]\n",
  "LICKERS": "LICKER, one who licks [n]\n",
  "LICKING": "a thrashing or beating [n -S]\n",
  "LICKINGS": "LICKING, a thrashing or beating [n]\n",
  "LICKPENNIES": "LICKPENNY, an absorber or devourer of money [n]\n",
  "LICKPENNY": "an absorber or devourer of money [n LICKPENNIES]\n",
  "LICKS": "LICK, to lap, taste or moisten with the tongue [v]\n",
  "LICKSPIT": "a fawning subordinate, a toady, also LICKSPITTLE [n -S]\n",
  "LICKSPITS": "LICKSPIT, a fawning subordinate, a toady, also LICKSPITTLE [n]\n",
  "LICKSPITTLE": "a fawning subordinate, a toady, also LICKSPIT [n -S]\n",
  "LICKSPITTLES": "LICKSPITTLE, a fawning subordinate, a toady, also LICKSPIT [n]\n",
  "LICORICE": "a confectionery made with an extract from the root of the liquorice plant, also LIQUORICE [n -S]\n",
  "LICORICES": "LICORICE, a confectionery made with an extract from the root of the liquorice plant, also LIQUORICE [n]\n",
  "LICTOR": "(historical) an ancient Roman magistrate's attendant [n -S]\n",
  "LICTORIAN": "relating to a lictor [adj]\n",
  "LICTORS": "LICTOR, (historical) an ancient Roman magistrate's attendant [n]\n",
  "LID": "a cover, hinged or separate, for the opening and closing of a receptacle [n -S] / to provide with a lid [v LIDDED, LIDDING, LIDS]\n",
  "LIDAR": "a system of using lasers in the same way as radar [n -S]\n",
  "LIDARS": "LIDAR, a system of using lasers in the same way as radar [n]\n",
  "LIDDED": "LID, to provide with a lid [v]\n",
  "LIDDING": "the act of covering with a lid [n -S]\n",
  "LIDDINGS": "LIDDING, the act of covering with a lid [n]\n",
  "LIDGER": "(obsolete) an ambassador, also LEDGER, LEIDGER, LEIGER, LIEGER [n -S]\n",
  "LIDGERS": "LIDGER, (obsolete) an ambassador, also LEDGER, LEIDGER, LEIGER, LIEGER [n]\n",
  "LIDLESS": "without a lid [adj]\n",
  "LIDO": "a bathing beach; an open-air swimming pool [n -S]\n",
  "LIDOCAINE": "the US name for lignocaine, a local anaesthetic used in dentistry [n -S]\n",
  "LIDOCAINES": "LIDOCAINE, the US name for lignocaine, a local anaesthetic used in dentistry [n]\n",
  "LIDOS": "LIDO, a bathing beach; an open-air swimming pool [n]\n",
  "LIDS": "LID, to provide with a lid [v]\n",
  "LIE": "to make an intentional false statement [v LIED, LYING, LIES] / to be in a horizontal position [v LAY, LAIN, LYING, LIES]\n",
  "LIEBFRAUMILCH": "a fruity white Rhine wine [n -S]\n",
  "LIEBFRAUMILCHS": "LIEBFRAUMILCH, a fruity white Rhine wine [n]\n",
  "LIED": "(German) a German song [n LIEDER]\n",
  "LIEDER": "LIED, (German) a German song [n]\n",
  "LIEF": "(archaic) soon, gladly, also LEVE, LIEVE [adj LIEFER, LIEVER or LOOR, LIEFEST or LIEVEST, LIEFLY] / a beloved [n -S]\n",
  "LIEFER": "LIEF, (archaic) soon, gladly, also LEVE, LIEVE [adj]\n",
  "LIEFEST": "LIEF, (archaic) soon, gladly, also LEVE, LIEVE [adj]\n",
  "LIEFLY": "LIEF, (archaic) soon, gladly, also LEVE, LIEVE [adv]\n",
  "LIEFS": "LIEF, a beloved [n]\n",
  "LIEGE": "(historical) a person under a feudal tenure; a vassal or feudal lord [n -S]\n",
  "LIEGEDOM": "the condition of being a liege [n -S]\n",
  "LIEGEDOMS": "LIEGEDOM, the condition of being a liege [n]\n",
  "LIEGELESS": "without a liege [adj]\n",
  "LIEGEMAN": "a feudal vassal [n LIEGEMEN]\n",
  "LIEGEMEN": "LIEGEMAN, a feudal vassal [n]\n",
  "LIEGER": "(obsolete) an ambassador, also LEDGER, LEIDGER, LEIGER, LIDGER [n -S]\n",
  "LIEGERS": "LIEGER, (obsolete) an ambassador, also LEDGER, LEIDGER, LEIGER, LIDGER [n]\n",
  "LIEGES": "LIEGE, (historical) a person under a feudal tenure; a vassal or feudal lord [n]\n",
  "LIEN": "a right to keep possession of property belonging to another person until a debt due by that person is discharged [n -S]\n",
  "LIENABLE": "capable of being subjected to a lien [adj]\n",
  "LIENAL": "pertaining to the spleen [adj]\n",
  "LIENEE": "in law, a party against whom a lien has been placed [n -S]\n",
  "LIENEES": "LIENEE, in law, a party against whom a lien has been placed [n]\n",
  "LIENHOLDER": "a party who holds a lien on a property [n -S]\n",
  "LIENHOLDERS": "LIENHOLDER, a party who holds a lien on a property [n]\n",
  "LIENOR": "a party who holds a lien on a property [n -S]\n",
  "LIENORS": "LIENOR, a party who holds a lien on a property [n]\n",
  "LIENS": "LIEN, a right to keep possession of property belonging to another person until a debt due by that person is discharged [n]\n",
  "LIENTERIC": "of or pertaining to a lientery, the discharge of partially digested food [adj]\n",
  "LIENTERIES": "LIENTERY, the discharge of partially digested food [n]\n",
  "LIENTERY": "the discharge of partially digested food [n LIENTERIES]\n",
  "LIER": "one who lies [n -S]\n",
  "LIERNE": "(French) a cross-rib or branch-rib in vaulting [n -S]\n",
  "LIERNES": "LIERNE, (French) a cross-rib or branch-rib in vaulting [n]\n",
  "LIERS": "LIER, one who lies [n]\n",
  "LIES": "LIE, to make an intentional false statement [v]\n",
  "LIEU": "(French) a place or stead, esp. in the phrase in lieu of [n -S]\n",
  "LIEUS": "LIEU, (French) a place or stead, esp. in the phrase in lieu of [n]\n",
  "LIEUTENANCIES": "LIEUTENANCY, the office, rank, or commission of a lieutenant [n]\n",
  "LIEUTENANCY": "the office, rank, or commission of a lieutenant [n LIEUTENANCIES]\n",
  "LIEUTENANT": "an official empowered to act for a higher official [n -S]\n",
  "LIEUTENANTRIES": "LIEUTENANTRY, (Shakespeare) the office of lieutenant [n]\n",
  "LIEUTENANTRY": "(Shakespeare) the office of lieutenant [n LIEUTENANTRIES]\n",
  "LIEUTENANTS": "LIEUTENANT, an official empowered to act for a higher official [n]\n",
  "LIEUTENANTSHIP": "the office of lieutenant [n -S]\n",
  "LIEUTENANTSHIPS": "LIEUTENANTSHIP, the office of lieutenant [n]\n",
  "LIEVE": "(archaic) beloved, dear, also LEVE, LIEF [adj LIEVER, LIEVEST] / a beloved [n -S]\n",
  "LIEVER": "LIEVE, (archaic) beloved, dear, also LEVE, LIEF [adv]\n",
  "LIEVES": "LIEVE, a beloved [n]\n",
  "LIEVEST": "LIEF, (archaic) soon, gladly, also LEVE, LIEVE [adv]\n",
  "LIFE": "the state of functional activity [n LIVES] / in painting, a still life [n LIFES]\n",
  "LIFEBELT": "a buoyant belt for use in water [n -S]\n",
  "LIFEBELTS": "LIFEBELT, a buoyant belt for use in water [n]\n",
  "LIFEBLOOD": "the blood necessary to life [n -S]\n",
  "LIFEBLOODS": "LIFEBLOOD, the blood necessary to life [n]\n",
  "LIFEBOAT": "a small rescue boat [n -S]\n",
  "LIFEBOATMAN": "one who forms part of the crew of a lifeboat [n LIFEBOATMEN]\n",
  "LIFEBOATMEN": "LIFEBOATMAN, one who forms part of the crew of a lifeboat [n]\n",
  "LIFEBOATS": "LIFEBOAT, a small rescue boat [n]\n",
  "LIFEBUOY": "any of various kinds of buoyant device for keeping people afloat in an emergency [n -S]\n",
  "LIFEBUOYS": "LIFEBUOY, any of various kinds of buoyant device for keeping people afloat in an emergency [n]\n",
  "LIFECARE": "housing and health services for the elderly [n -S]\n",
  "LIFECARES": "LIFECARE, housing and health services for the elderly [n]\n",
  "LIFEFUL": "full of vitality, also LIFULL, LYFULL [adj]\n",
  "LIFEGUARD": "one employed to assist swimmers in difficulties [n -S] / to serve as a lifeguard [v -ED, -ING, -S]\n",
  "LIFEGUARDED": "LIFEGUARD, to serve as a lifeguard [v]\n",
  "LIFEGUARDING": "LIFEGUARD, to serve as a lifeguard [v]\n",
  "LIFEGUARDS": "LIFEGUARD, to serve as a lifeguard [v]\n",
  "LIFEHACK": "to live one's life in a way such as to simplify tasks and minimize effort [v -ED, -ING, -S]\n",
  "LIFEHACKED": "LIFEHACK, to live one's life in a way such as to simplify tasks and minimize effort [v]\n",
  "LIFEHACKER": "one who lives in a way such as to simplify tasks and minimize effort [n -S]\n",
  "LIFEHACKERS": "LIFEHACKER, one who lives in a way such as to simplify tasks and minimize effort [n]\n",
  "LIFEHACKING": "LIFEHACK, to live one's life in a way such as to simplify tasks and minimize effort [v]\n",
  "LIFEHACKS": "LIFEHACK, to live one's life in a way such as to simplify tasks and minimize effort [v]\n",
  "LIFEHOLD": "of land, held by a life estate [adj]\n",
  "LIFELESS": "having no life [adj LIFELESSLY]\n",
  "LIFELESSLY": "LIFELESS, having no life [adv]\n",
  "LIFELESSNESS": "the state of being lifeless [n -ES]\n",
  "LIFELESSNESSES": "LIFELESSNESS, the state of being lifeless [n]\n",
  "LIFELIKE": "resembling a living thing [adj]\n",
  "LIFELIKENESS": "the state of being lifelike [n -ES]\n",
  "LIFELIKENESSES": "LIFELIKENESS, the state of being lifelike [n]\n",
  "LIFELINE": "a vital access or communication [n -S]\n",
  "LIFELINES": "LIFELINE, a vital access or communication [n]\n",
  "LIFELONG": "lasting a lifetime [adj]\n",
  "LIFEMANSHIP": "the skill or practice of achieving superiority or an appearance of superiority over others by perplexing and demoralizing them [n -S]\n",
  "LIFEMANSHIPS": "LIFEMANSHIP, the skill or practice of achieving superiority or an appearance of superiority over others by perplexing and demoralizing them [n]\n",
  "LIFER": "a prisoner serving a life sentence [n -S]\n",
  "LIFERS": "LIFER, a prisoner serving a life sentence [n]\n",
  "LIFES": "LIFE, the state of functional activity [n]\n",
  "LIFESAVER": "the saver of a person's life [n -S]\n",
  "LIFESAVERS": "LIFESAVER, the saver of a person's life [n]\n",
  "LIFESAVING": "the skill or practice of saving or protecting the lives esp. of drowning persons [n -S]\n",
  "LIFESAVINGS": "LIFESAVING, the skill or practice of saving or protecting the lives esp. of drowning persons [n]\n",
  "LIFESOME": "full of life [adj]\n",
  "LIFESPAN": "the time from birth to death [n -S]\n",
  "LIFESPANS": "LIFESPAN, the time from birth to death [n]\n",
  "LIFESTYLE": "a way in which one lives [n -S]\n",
  "LIFESTYLER": "a kind of exercise apparatus [n -S]\n",
  "LIFESTYLERS": "LIFESTYLER, a kind of exercise apparatus [n]\n",
  "LIFESTYLES": "LIFESTYLE, a way in which one lives [n]\n",
  "LIFETIME": "the period of living existence [n -S]\n",
  "LIFETIMES": "LIFETIME, the period of living existence [n]\n",
  "LIFEWAY": "a way of living [n -S]\n",
  "LIFEWAYS": "LIFEWAY, a way of living [n]\n",
  "LIFEWORK": "the major work of one's lifetime [n -S]\n",
  "LIFEWORKS": "LIFEWORK, the major work of one's lifetime [n]\n",
  "LIFEWORLD": "the way an individual experiences the world [n -S]\n",
  "LIFEWORLDS": "LIFEWORLD, the way an individual experiences the world [n]\n",
  "LIFT": "to raise higher [v LIFTED, LIFTING, LIFTS]\n",
  "LIFTABLE": "able to be lifted [adj]\n",
  "LIFTBACK": "a motorcar with a sloping rear door; a hatchback [n -S]\n",
  "LIFTBACKS": "LIFTBACK, a motorcar with a sloping rear door; a hatchback [n]\n",
  "LIFTBOY": "someone employed to operate a lift [n -S]\n",
  "LIFTBOYS": "LIFTBOY, someone employed to operate a lift [n]\n",
  "LIFTED": "LIFT, to raise higher [v]\n",
  "LIFTER": "one who lifts [n -S]\n",
  "LIFTERS": "LIFTER, one who lifts [n]\n",
  "LIFTGATE": "a rear panel on a station wagon that opens upward [n -S]\n",
  "LIFTGATES": "LIFTGATE, a rear panel on a station wagon that opens upward [n]\n",
  "LIFTING": "LIFT, to raise higher [v]\n",
  "LIFTMAN": "a person who operates a lift, also LIFTBOY [n LIFTMEN]\n",
  "LIFTMEN": "LIFTMAN, a person who operates a lift, also LIFTBOY [n]\n",
  "LIFTOFF": "the initial movement of ascent of a rocket from its launch pad [n -S]\n",
  "LIFTOFFS": "LIFTOFF, the initial movement of ascent of a rocket from its launch pad [n]\n",
  "LIFTS": "LIFT, to raise higher [v]\n",
  "LIFULL": "(Spenser) full of vital energy, also LIFEFUL, LYFULL [adj]\n",
  "LIG": "to lie, also LIGGE [v LIGGED, LIGGING, LIGS]\n",
  "LIGAMENT": "a band of firm, fibrous tissue [n -S]\n",
  "LIGAMENTAL": "of or like a ligament, also LIGAMENTARY, LIGAMENTOUS [adj]\n",
  "LIGAMENTARY": "of or like a ligament, also LIGAMENTAL, LIGAMENTOUS [adj]\n",
  "LIGAMENTOUS": "of or like a ligament, also LIGAMENTAL, LIGAMENTARY [adj]\n",
  "LIGAMENTS": "LIGAMENT, a band of firm, fibrous tissue [n]\n",
  "LIGAN": "goods thrown into the sea for future recovery, also LAGAN, LAGEND [n -S]\n",
  "LIGAND": "an atom, molecule, radical or ion which forms a complex with a central atom [n -S]\n",
  "LIGANDS": "LIGAND, an atom, molecule, radical or ion which forms a complex with a central atom [n]\n",
  "LIGANS": "LIGAN, goods thrown into the sea for future recovery, also LAGAN, LAGEND [n]\n",
  "LIGASE": "an enzyme which seals nicks in one strand of a duplex DNA [n -S]\n",
  "LIGASES": "LIGASE, an enzyme which seals nicks in one strand of a duplex DNA [n]\n",
  "LIGATE": "to tie with a ligature [v LIGATED, LIGATING, LIGATES]\n",
  "LIGATED": "LIGATE, to tie with a ligature [v]\n",
  "LIGATES": "LIGATE, to tie with a ligature [v]\n",
  "LIGATING": "LIGATE, to tie with a ligature [v]\n",
  "LIGATION": "the act of binding [n -S]\n",
  "LIGATIONS": "LIGATION, the act of binding [n]\n",
  "LIGATIVE": "acting as a ligature [adj]\n",
  "LIGATURE": "anything that binds; a bandage [n -S] / to tie with a ligature [v LIGATURED, LIGATURING, LIGATURES]\n",
  "LIGATURED": "LIGATURE, to tie with a ligature [v]\n",
  "LIGATURES": "LIGATURE, to tie with a ligature [v]\n",
  "LIGATURING": "LIGATURE, to tie with a ligature [v]\n",
  "LIGER": "the offspring of a male lion and a female tiger [n -S]\n",
  "LIGERS": "LIGER, the offspring of a male lion and a female tiger [n]\n",
  "LIGGE": "(dialect) to lie, also LIG [v LIGGED, LIGGING, LIGGES]\n",
  "LIGGED": "LIGGE, (dialect) to lie, also LIG [v]\n",
  "LIGGER": "a horizontal timber in scaffolding [n -S]\n",
  "LIGGERS": "LIGGER, a horizontal timber in scaffolding [n]\n",
  "LIGGES": "LIGGE, (dialect) to lie, also LIG [v]\n",
  "LIGGING": "the act of ligging [n -S]\n",
  "LIGGINGS": "LIGGING, the act of ligging [n]\n",
  "LIGHT": "having little weight [adj LIGHTER, LIGHTEST, LIGHTLY] / to illuminate [v LIGHTED or LIT, LIGHTING, LIGHTS]\n",
  "LIGHTBULB": "a glass bulb containing a low-pressure gas and a metal filament which glows when an electric current is passed through it [n -S]\n",
  "LIGHTBULBS": "LIGHTBULB, a glass bulb containing a low-pressure gas and a metal filament which glows when an electric current is passed through it [n]\n",
  "LIGHTED": "LIGHT, to illuminate [v]\n",
  "LIGHTEN": "to reduce the weight of [v -ED, -ING, -S]\n",
  "LIGHTENED": "LIGHTEN, to reduce the weight of [v]\n",
  "LIGHTENER": "something that lightens [n -S]\n",
  "LIGHTENERS": "LIGHTENER, something that lightens [n]\n",
  "LIGHTENING": "lightning [n -S]\n",
  "LIGHTENINGS": "LIGHTENING, lightning [n]\n",
  "LIGHTENS": "LIGHTEN, to reduce the weight of [v]\n",
  "LIGHTER": "a large open boat used in loading and unloading ships [n -S] / to convey by lighter [v -ED, -ING, -S]\n",
  "LIGHTERAGE": "a fee for carrying cargo by lighter [n -S]\n",
  "LIGHTERAGES": "LIGHTERAGE, a fee for carrying cargo by lighter [n]\n",
  "LIGHTERED": "LIGHTER, to convey by lighter [v]\n",
  "LIGHTERING": "LIGHTER, to convey by lighter [v]\n",
  "LIGHTERMAN": "a person employed on, or who manages, a lighter [n LIGHTERMEN]\n",
  "LIGHTERMEN": "LIGHTERMAN, a person employed on, or who manages, a lighter [n]\n",
  "LIGHTERS": "LIGHTER, to convey by lighter [v]\n",
  "LIGHTEST": "LIGHT, having little weight [adj]\n",
  "LIGHTFACE": "a typeface having comparatively light thin lines [n -S]\n",
  "LIGHTFACED": "in a typeface having comparatively light thin lines [adj]\n",
  "LIGHTFACES": "LIGHTFACE, a typeface having comparatively light thin lines [n]\n",
  "LIGHTFAST": "of a fabric, that doesn't fade on exposure to light [adj]\n",
  "LIGHTFASTNESS": "LIGHTFAST, of a fabric, that doesn't fade on exposure to light [n]\n",
  "LIGHTFASTNESSES": "LIGHTFASTNESS, LIGHTFAST, of a fabric, that doesn't fade on exposure to light [n]\n",
  "LIGHTFUL": "brightly illuminated [adj]\n",
  "LIGHTHEARTED": "free from care [adj LIGHTHEARTEDLY]\n",
  "LIGHTHEARTEDLY": "LIGHTHEARTED, free from care [adv]\n",
  "LIGHTHOUSE": "a structure (as a tower) with a powerful light that gives a continuous or intermittent signal to navigators [n -S]\n",
  "LIGHTHOUSEMAN": "one who keeps a lighthouse [n LIGHTHOUSEMEN]\n",
  "LIGHTHOUSEMEN": "LIGHTHOUSEMAN, one who keeps a lighthouse [n]\n",
  "LIGHTHOUSES": "LIGHTHOUSE, a structure (as a tower) with a powerful light that gives a continuous or intermittent signal to navigators [n]\n",
  "LIGHTING": "illumination [n -S]\n",
  "LIGHTINGS": "LIGHTING, illumination [n]\n",
  "LIGHTISH": "somewhat light [adj]\n",
  "LIGHTLESS": "without lights [adj]\n",
  "LIGHTLIED": "LIGHTLY, to slight or make light of, also LICHTLY [v]\n",
  "LIGHTLIES": "LIGHTLY, to slight or make light of, also LICHTLY [v]\n",
  "LIGHTLY": "to slight or make light of, also LICHTLY [v LIGHTLIED, LIGHTLYING, LIGHTLIES]\n",
  "LIGHTLYING": "LIGHTLY, to slight or make light of, also LICHTLY [v]\n",
  "LIGHTNESS": "the state of being light [n -ES]\n",
  "LIGHTNESSES": "LIGHTNESS, the state of being light [n]\n",
  "LIGHTNING": "to flash with lightning, a flash of light in the sky, caused by electricity being discharged from thunderclouds [v LIGHTNINGED, LIGHTNING, LIGHTNINGS]\n",
  "LIGHTNINGED": "LIGHTNING, to flash with lightning, a flash of light in the sky, caused by electricity being discharged from thunderclouds [v]\n",
  "LIGHTNINGS": "LIGHTNING, to flash with lightning, a flash of light in the sky, caused by electricity being discharged from thunderclouds [v]\n",
  "LIGHTPLANE": "a small and comparatively lightweight airplane [n -S]\n",
  "LIGHTPLANES": "LIGHTPLANE, a small and comparatively lightweight airplane [n]\n",
  "LIGHTPROOF": "impervious to light, also LIGHTTIGHT [adj]\n",
  "LIGHTS": "LIGHT, to illuminate [v]\n",
  "LIGHTSHIP": "a ship intended to function as a lighthouse [n -S]\n",
  "LIGHTSHIPS": "LIGHTSHIP, a ship intended to function as a lighthouse [n]\n",
  "LIGHTSOME": "having light; not dark or gloomy [adj LIGHTSOMELY]\n",
  "LIGHTSOMELY": "LIGHTSOME, having light; not dark or gloomy [adv]\n",
  "LIGHTSOMENESS": "LIGHTSOME, having light; not dark or gloomy [n]\n",
  "LIGHTSOMENESSES": "LIGHTSOMENESS, LIGHTSOME, having light; not dark or gloomy [n]\n",
  "LIGHTTIGHT": "impervious to light, also LIGHTPROOF [adj]\n",
  "LIGHTWAVE": "relating to a wave of light [adj]\n",
  "LIGHTWEIGHT": "of less than average weight [adj] / a person of little account [n -S]\n",
  "LIGHTWEIGHTS": "LIGHTWEIGHT, a person of little account [n]\n",
  "LIGHTWOOD": "pine wood abounding in pitch, used for torches in the Southern United States [n -S]\n",
  "LIGHTWOODS": "LIGHTWOOD, pine wood abounding in pitch, used for torches in the Southern United States [n]\n",
  "LIGNAGE": "(obsolete) lineage, also LYNAGE [n -S]\n",
  "LIGNAGES": "LIGNAGE, (obsolete) lineage, also LYNAGE [n]\n",
  "LIGNALOES": "(biblical) aloeswood [n]\n",
  "LIGNAN": "a beneficial substance found in plants [n -S]\n",
  "LIGNANS": "LIGNAN, a beneficial substance found in plants [n]\n",
  "LIGNE": "(French) a measure of watch movements [n -S]\n",
  "LIGNEOUS": "resembling wood [adj]\n",
  "LIGNES": "LIGNE, (French) a measure of watch movements [n]\n",
  "LIGNICOLE": "growing or living in wood, also LIGNICOLOUS [adj]\n",
  "LIGNICOLOUS": "growing or living in wood, also LIGNICOLE [adj]\n",
  "LIGNIFICATION": "the act of lignifying, turning to wood [n -S]\n",
  "LIGNIFICATIONS": "LIGNIFICATION, the act of lignifying, turning to wood [n]\n",
  "LIGNIFIED": "LIGNIFY, to convert into wood [v]\n",
  "LIGNIFIES": "LIGNIFY, to convert into wood [v]\n",
  "LIGNIFORM": "of the form or shape of wood [adj]\n",
  "LIGNIFY": "to convert into wood [v LIGNIFIED, LIGNIFYING, LIGNIFIES]\n",
  "LIGNIFYING": "LIGNIFY, to convert into wood [v]\n",
  "LIGNIN": "an essential part of woody tissue [n -S]\n",
  "LIGNINS": "LIGNIN, an essential part of woody tissue [n]\n",
  "LIGNIPERDOUS": "destroying wood [adj]\n",
  "LIGNITE": "brown coal, a stage in the conversion of vegetable matter into coal [n -S]\n",
  "LIGNITES": "LIGNITE, brown coal, a stage in the conversion of vegetable matter into coal [n]\n",
  "LIGNITIC": "of or containing lignite [adj]\n",
  "LIGNIVOROUS": "feeding on wood [adj]\n",
  "LIGNOCAINE": "a local anaesthetic used in dentistry [n -S]\n",
  "LIGNOCAINES": "LIGNOCAINE, a local anaesthetic used in dentistry [n]\n",
  "LIGNOCELLULOSE": "any of several compounds of lignin and cellulose occurring in woody tissue [n -S]\n",
  "LIGNOCELLULOSES": "LIGNOCELLULOSE, any of several compounds of lignin and cellulose occurring in woody tissue [n]\n",
  "LIGNOCELLULOSIC": "of or like lignocellulose [adj]\n",
  "LIGNOSE": "a constituent of lignin [n -S]\n",
  "LIGNOSES": "LIGNOSE, a constituent of lignin [n]\n",
  "LIGNOSULFONATE": "any of various compounds produced from the spent sulfite liquor in the pulping of softwood in papermaking and used esp. for binders and dispersing agents [n -S]\n",
  "LIGNOSULFONATES": "LIGNOSULFONATE, any of various compounds produced from the spent sulfite liquor in the pulping of softwood in papermaking and used esp. for binders and dispersing agents [n]\n",
  "LIGNUM": "(Latin) the fragrant wood of several shrubs and trees [n -S]\n",
  "LIGNUMS": "LIGNUM, (Latin) the fragrant wood of several shrubs and trees [n]\n",
  "LIGROIN": "(tradename) a name applied to some of the volatile products obtained in refining crude petroleum, also LIGROINE [n -S]\n",
  "LIGROINE": "(tradename) a name applied to some of the volatile products obtained in refining crude petroleum, also LIGROIN [n -S]\n",
  "LIGROINES": "LIGROINE, (tradename) a name applied to some of the volatile products obtained in refining crude petroleum, also LIGROIN [n]\n",
  "LIGROINS": "LIGROIN, (tradename) a name applied to some of the volatile products obtained in refining crude petroleum, also LIGROINE [n]\n",
  "LIGS": "LIG, to lie, also LIGGE [v]\n",
  "LIGULA": "(Latin) a tonguelike part or organ [n LIGULAS or LIGULAE]\n",
  "LIGULAE": "LIGULA, (Latin) a tonguelike part or organ [n]\n",
  "LIGULAR": "pertaining to a ligule, a thin outgrowth at the junction of a leaf and leafstalk [adj]\n",
  "LIGULAS": "LIGULA, (Latin) a tonguelike part or organ [n]\n",
  "LIGULATE": "like a ligula [adj]\n",
  "LIGULATED": "resembling or shaped like a strap, also LIGULATE [adj]\n",
  "LIGULE": "a strap-shaped corolla in composite plants [n -S]\n",
  "LIGULES": "LIGULE, a strap-shaped corolla in composite plants [n]\n",
  "LIGULIFLORAL": "having strap-shaped flowers [adj]\n",
  "LIGULOID": "like a ligule, a thin outgrowth at the junction of a leaf and leafstalk [adj]\n",
  "LIGURE": "a precious stone [n -S]\n",
  "LIGURES": "LIGURE, a precious stone [n]\n",
  "LIGUSTRUM": "a plant of a genus that comprises the privets [n -S]\n",
  "LIGUSTRUMS": "LIGUSTRUM, a plant of a genus that comprises the privets [n]\n",
  "LIKABILITIES": "LIKABILITY, the quality of being likable, also LIKEABILITY [n]\n",
  "LIKABILITY": "the quality of being likable, also LIKEABILITY [n LIKABILITIES]\n",
  "LIKABLE": "able to be liked, also LIKEABLE [adj LIKABLY]\n",
  "LIKABLENESS": "the state of being likable [n -ES]\n",
  "LIKABLENESSES": "LIKABLENESS, the state of being likable [n]\n",
  "LIKABLY": "LIKABLE, able to be liked, also LIKEABLE [adv]\n",
  "LIKE": "to be fond of [v LIKED, LIKING, LIKES] / identical or similar [adj LIKER, LIKEST]\n",
  "LIKEABILITIES": "LIKEABILITY, the quality of being likeable [n]\n",
  "LIKEABILITY": "the quality of being likeable [n LIKEABILITIES]\n",
  "LIKEABLE": "able to be liked, also LIKABLE [adj LIKEABLY]\n",
  "LIKEABLENESS": "the state of being likeable [n -ES]\n",
  "LIKEABLENESSES": "LIKEABLENESS, the state of being likeable [n]\n",
  "LIKEABLY": "LIKEABLE, able to be liked, also LIKABLE [adv]\n",
  "LIKED": "LIKE, to be fond of [v]\n",
  "LIKELIER": "LIKELY, probable [adj]\n",
  "LIKELIEST": "LIKELY, probable [adj]\n",
  "LIKELIHOOD": "probability [n -S]\n",
  "LIKELIHOODS": "LIKELIHOOD, probability [n]\n",
  "LIKELINESS": "likelihood, probability [n -ES]\n",
  "LIKELINESSES": "LIKELINESS, likelihood, probability [n]\n",
  "LIKELY": "probable [adj LIKELIER, LIKELIEST]\n",
  "LIKEN": "to represent as similar [v -ED, -ING, -S]\n",
  "LIKENED": "LIKEN, to represent as similar [v]\n",
  "LIKENESS": "a pictorial representation [n -ES]\n",
  "LIKENESSES": "LIKENESS, a pictorial representation [n]\n",
  "LIKENING": "LIKEN, to represent as similar [v]\n",
  "LIKENS": "LIKEN, to represent as similar [v]\n",
  "LIKER": "one who likes [n -S]\n",
  "LIKERS": "LIKER, one who likes [n]\n",
  "LIKES": "LIKE, to be fond of [v]\n",
  "LIKEST": "LIKE, identical or similar [adj]\n",
  "LIKEWAKE": "a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWALK, LYKEWAKE, LYKEWALK [n -S]\n",
  "LIKEWAKES": "LIKEWAKE, a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWALK, LYKEWAKE, LYKEWALK [n]\n",
  "LIKEWALK": "a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWAKE, LYKEWAKE, LYKEWALK [n -S]\n",
  "LIKEWALKS": "LIKEWALK, a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWAKE, LYKEWAKE, LYKEWALK [n]\n",
  "LIKEWISE": "in a similar manner [adv]\n",
  "LIKIN": "(Chinese) an old Chinese transit duty [n -S]\n",
  "LIKING": "a feeling of affection [n -S]\n",
  "LIKINGS": "LIKING, a feeling of affection [n]\n",
  "LIKINS": "LIKIN, (Chinese) an old Chinese transit duty [n]\n",
  "LIKUTA": "(Bantu) a monetary unit of Zaire [n MAKUTA]\n",
  "LILAC": "a flowering shrub, also LAYLOCK [n -S]\n",
  "LILACS": "LILAC, a flowering shrub, also LAYLOCK [n]\n",
  "LILANGENI": "(Bantu) the standard monetary unit of Swaziland [n EMALANGENI or LILANGENIS]\n",
  "LILANGENIS": "LILANGENI, (Bantu) the standard monetary unit of Swaziland [n]\n",
  "LILIACEOUS": "of or pertaining to a natural order of which the lily, tulip, and hyacinth are well-known examples [adj]\n",
  "LILIED": "covered with lilies [adj]\n",
  "LILIES": "LILY, any plant or flower of the genus Lilium [n]\n",
  "LILL": "(Spenser) to loll the tongue [v -ED, -ING, -S]\n",
  "LILLED": "LILL, (Spenser) to loll the tongue [v]\n",
  "LILLING": "LILL, (Spenser) to loll the tongue [v]\n",
  "LILLIPUT": "a very small person [n -S]\n",
  "LILLIPUTIAN": "very small [adj] / a very small person [n -S]\n",
  "LILLIPUTIANS": "LILLIPUTIAN, a very small person [n]\n",
  "LILLIPUTS": "LILLIPUT, a very small person [n]\n",
  "LILLS": "LILL, (Spenser) to loll the tongue [v]\n",
  "LILO": "(tradename) an inflatable mattress [n -S]\n",
  "LILOS": "LILO, (tradename) an inflatable mattress [n]\n",
  "LILT": "to sing or speak rhythmically [v -ED, -ING, -S]\n",
  "LILTED": "LILT, to sing or speak rhythmically [v]\n",
  "LILTING": "LILT, to sing or speak rhythmically [v]\n",
  "LILTINGLY": "LILTING, LILT, to sing or speak rhythmically [adv]\n",
  "LILTINGNESS": "having a lilting quality [n -ES]\n",
  "LILTINGNESSES": "LILTINGNESS, having a lilting quality [n]\n",
  "LILTS": "LILT, to sing or speak rhythmically [v]\n",
  "LILY": "any plant or flower of the genus Lilium [n LILIES]\n",
  "LILYLIKE": "like a lily [adj]\n",
  "LIMA": "an edible seed of a tropical American plant [n -S]\n",
  "LIMACEL": "(Latin) a slug's reduced shell [n -S]\n",
  "LIMACELS": "LIMACEL, (Latin) a slug's reduced shell [n]\n",
  "LIMACEOUS": "pertaining to, or like, Limax, or the slugs [adj]\n",
  "LIMACES": "LIMAX, (Latin) a slug [n]\n",
  "LIMACIFORM": "slug-like [adj]\n",
  "LIMACINE": "resembling a slug [adj]\n",
  "LIMACOLOGIES": "LIMACOLOGY, the study of slugs [n]\n",
  "LIMACOLOGIST": "a specialist in limacology [n -S]\n",
  "LIMACOLOGISTS": "LIMACOLOGIST, a specialist in limacology [n]\n",
  "LIMACOLOGY": "the study of slugs [n LIMACOLOGIES]\n",
  "LIMACON": "(French) a type of mathematical curve [n -S]\n",
  "LIMACONS": "LIMACON, (French) a type of mathematical curve [n]\n",
  "LIMAIL": "the dust and filings of metal, also LEMEL [n -S]\n",
  "LIMAILS": "LIMAIL, the dust and filings of metal, also LEMEL [n]\n",
  "LIMAN": "(Russian) a lagoon at the mouth of an estuary where slime is deposited [n -S]\n",
  "LIMANS": "LIMAN, (Russian) a lagoon at the mouth of an estuary where slime is deposited [n]\n",
  "LIMAS": "LIMA, an edible seed of a tropical American plant [n]\n",
  "LIMATION": "filing; (figurative) the process of refining or improving the appearance of something [n -S]\n",
  "LIMATIONS": "LIMATION, filing; (figurative) the process of refining or improving the appearance of something [n]\n",
  "LIMAX": "(Latin) a slug [n LIMACES]\n",
  "LIMB": "to cut off the arms or legs [v -ED, -ING, -S]\n",
  "LIMBA": "a West African hardwood tree or its timber [n -S]\n",
  "LIMBAS": "LIMBA, a West African hardwood tree or its timber [n]\n",
  "LIMBATE": "having an edge of a different colour [adj]\n",
  "LIMBEC": "(Spenser) an old distilling apparatus, also LIMBECK [n -S]\n",
  "LIMBECK": "(Spenser) an old distilling apparatus, also LIMBEC [n -S]\n",
  "LIMBECKS": "LIMBECK, (Spenser) an old distilling apparatus, also LIMBEC [n]\n",
  "LIMBECS": "LIMBEC, (Spenser) an old distilling apparatus, also LIMBECK [n]\n",
  "LIMBED": "LIMB, to cut off the arms or legs [v]\n",
  "LIMBER": "supple [adj LIMBERER, LIMBEREST, LIMBERLY] / to make supple [v -ED, -ING, -S]\n",
  "LIMBERED": "LIMBER, to make supple [v]\n",
  "LIMBERER": "LIMBER, supple [adj]\n",
  "LIMBEREST": "LIMBER, supple [adj]\n",
  "LIMBERING": "LIMBER, to make supple [v]\n",
  "LIMBERLY": "LIMBER, supple [adv]\n",
  "LIMBERNESS": "the state of being limber [n -ES]\n",
  "LIMBERNESSES": "LIMBERNESS, the state of being limber [n]\n",
  "LIMBERS": "LIMBER, to make supple [v]\n",
  "LIMBI": "LIMBUS, (Latin) a distinctive border [n]\n",
  "LIMBIC": "pertaining to a system of the brain [adj]\n",
  "LIMBIER": "LIMBY, having many large branches [adj]\n",
  "LIMBIEST": "LIMBY, having many large branches [adj]\n",
  "LIMBING": "LIMB, to cut off the arms or legs [v]\n",
  "LIMBLESS": "without limbs [adj]\n",
  "LIMBMEAL": "(Shakespeare) piecemeal, limb by limb [adv]\n",
  "LIMBO": "a place of oblivion or uncertain status [n LIMBOS] / to perform a kind of West Indian dance [v -ED, -ING, -ES]\n",
  "LIMBOED": "LIMBO, to perform a kind of West Indian dance [v]\n",
  "LIMBOES": "LIMBO, to perform a kind of West Indian dance [v]\n",
  "LIMBOING": "LIMBO, to perform a kind of West Indian dance [v]\n",
  "LIMBOS": "LIMBO, a place of oblivion or uncertain status [n]\n",
  "LIMBOUS": "overlapping [adj]\n",
  "LIMBS": "LIMB, to cut off the arms or legs [v]\n",
  "LIMBURGITE": "a volcanic rock composed of olivine and augite in a fine-grained or glassy groundmass [n -S]\n",
  "LIMBURGITES": "LIMBURGITE, a volcanic rock composed of olivine and augite in a fine-grained or glassy groundmass [n]\n",
  "LIMBUS": "(Latin) a distinctive border [n LIMBUSES or LIMBI]\n",
  "LIMBUSES": "LIMBUS, (Latin) a distinctive border [n]\n",
  "LIMBY": "having many large branches [adj LIMBIER, LIMBIEST]\n",
  "LIME": "calcium oxide [n -S] / to treat with lime [v LIMED, LIMING, LIMES]\n",
  "LIMEADE": "a nonalcoholic drink made from the juice of limes [n -S]\n",
  "LIMEADES": "LIMEADE, a nonalcoholic drink made from the juice of limes [n]\n",
  "LIMED": "LIME, to treat with lime [v]\n",
  "LIMEKILN": "a furnace in which shells are burned to produce lime [n -S]\n",
  "LIMEKILNS": "LIMEKILN, a furnace in which shells are burned to produce lime [n]\n",
  "LIMELESS": "without lime [adj]\n",
  "LIMELIGHT": "a bright theatre light [n -S] / to light with limelight [v LIMELIT or LIMELIGHTED, LIMELIGHTING, LIMELIGHTS]\n",
  "LIMELIGHTED": "LIMELIGHT, to light with limelight [v]\n",
  "LIMELIGHTER": "something that produces limelight [n -S]\n",
  "LIMELIGHTERS": "LIMELIGHTER, something that produces limelight [n]\n",
  "LIMELIGHTING": "LIMELIGHT, to light with limelight [v]\n",
  "LIMELIGHTS": "LIMELIGHT, to light with limelight [v]\n",
  "LIMELIT": "LIMELIGHT, to light with limelight [v]\n",
  "LIMEN": "(Latin) a threshold, a limit below which a stimulus becomes imperceptible [n LIMENS or LIMINA]\n",
  "LIMENS": "LIMEN, (Latin) a threshold, a limit below which a stimulus becomes imperceptible [n]\n",
  "LIMEPIT": "a pit from which lime is dug [n -S]\n",
  "LIMEPITS": "LIMEPIT, a pit from which lime is dug [n]\n",
  "LIMERENCE": "a state of mind resulting from romantic attraction, characterized by feelings of euphoria, the desire to have one's feelings reciprocated, etc. [n -S]\n",
  "LIMERENCES": "LIMERENCE, a state of mind resulting from romantic attraction, characterized by feelings of euphoria, the desire to have one's feelings reciprocated, etc. [n]\n",
  "LIMERICK": "(Irish) a form of humorous verse in a five-line jingle [n -S]\n",
  "LIMERICKS": "LIMERICK, (Irish) a form of humorous verse in a five-line jingle [n]\n",
  "LIMES": "(Latin) an ancient Roman fortified boundary [n LIMITES]\n",
  "LIMESCALE": "a flaky deposit left in containers such as kettles [n -S]\n",
  "LIMESCALES": "LIMESCALE, a flaky deposit left in containers such as kettles [n]\n",
  "LIMESTONE": "a sedimentary rock composed mostly of the mineral calcite [n -S]\n",
  "LIMESTONES": "LIMESTONE, a sedimentary rock composed mostly of the mineral calcite [n]\n",
  "LIMEWASH": "a mixture of lime and water [n -ES]\n",
  "LIMEWASHES": "LIMEWASH, a mixture of lime and water [n]\n",
  "LIMEWATER": "water impregnated with lime; esp. an artificial solution of lime for medicinal purposes [n -S]\n",
  "LIMEWATERS": "LIMEWATER, water impregnated with lime; esp. an artificial solution of lime for medicinal purposes [n]\n",
  "LIMEY": "a British sailor [n -S]\n",
  "LIMEYS": "LIMEY, a British sailor [n]\n",
  "LIMICOLINE": "belonging to the Charadrii suborder of birds [adj]\n",
  "LIMICOLOUS": "living in mud, usually applied to birds or worms [adj]\n",
  "LIMIER": "LIMY, containing lime [adj]\n",
  "LIMIEST": "LIMY, containing lime [adj]\n",
  "LIMINA": "LIMEN, (Latin) a threshold, a limit below which a stimulus becomes imperceptible [n]\n",
  "LIMINAL": "of or relating to a sensory threshold; barely perceptible [adj]\n",
  "LIMINESS": "the state of being limy [n -ES]\n",
  "LIMINESSES": "LIMINESS, the state of being limy [n]\n",
  "LIMING": "in the preparation of leather etc. the soaking of skins in limewater to remove hair [n -S]\n",
  "LIMINGS": "LIMING, in the preparation of leather etc. the soaking of skins in limewater to remove hair [n]\n",
  "LIMIT": "to restrict [v -ED, -ING, -S]\n",
  "LIMITABLE": "that can be limited [adj]\n",
  "LIMITABLENESS": "LIMITABLE, that can be limited [n]\n",
  "LIMITABLENESSES": "LIMITABLENESS, LIMITABLE, that can be limited [n]\n",
  "LIMITARIAN": "someone who limits salvation to part of mankind [n -S]\n",
  "LIMITARIANS": "LIMITARIAN, someone who limits salvation to part of mankind [n]\n",
  "LIMITARY": "placed at the limit, as a guard [adj]\n",
  "LIMITATION": "an act or instance of limiting [n -S]\n",
  "LIMITATIONAL": "relating to limitation [adj]\n",
  "LIMITATIONS": "LIMITATION, an act or instance of limiting [n]\n",
  "LIMITATIVE": "tending to limit [adj]\n",
  "LIMITED": "restricted [adj LIMITEDLY] / a limited company [n -S]\n",
  "LIMITEDLY": "LIMITED, restricted [adv]\n",
  "LIMITEDNESS": "the state of being limited [n -ES]\n",
  "LIMITEDNESSES": "LIMITEDNESS, the state of being limited [n]\n",
  "LIMITEDS": "LIMITED, a limited company [n]\n",
  "LIMITER": "a friar who had a license to beg within certain areas, also LYMITER [n -S]\n",
  "LIMITERS": "LIMITER, a friar who had a license to beg within certain areas, also LYMITER [n]\n",
  "LIMITES": "LIMES, (Latin) an ancient Roman fortified boundary [n]\n",
  "LIMITING": "setting a limit [adj LIMITINGLY] / the act of limiting [n -S]\n",
  "LIMITINGLY": "LIMITING, setting a limit [adv]\n",
  "LIMITINGS": "LIMITING, the act of limiting [n]\n",
  "LIMITLESS": "without limit [adj LIMITLESSLY]\n",
  "LIMITLESSLY": "LIMITLESS, without limit [adv]\n",
  "LIMITLESSNESS": "LIMITLESS, without limit [n]\n",
  "LIMITLESSNESSES": "LIMITLESSNESS, LIMITLESS, without limit [n]\n",
  "LIMITROPHE": "near the frontier or border [adj]\n",
  "LIMITS": "LIMIT, to restrict [v]\n",
  "LIMIVOROUS": "feeding on mud [adj]\n",
  "LIMMA": "(Latin) in prosody, a pause of one mora [n -S]\n",
  "LIMMAS": "LIMMA, (Latin) in prosody, a pause of one mora [n]\n",
  "LIMMER": "(Scots) a rogue or thief; a hussy [n -S]\n",
  "LIMMERS": "LIMMER, (Scots) a rogue or thief; a hussy [n]\n",
  "LIMN": "(archaic) to portray, paint or delineate [v -ED, -ING, -S]\n",
  "LIMNAEID": "a member of the family of pond-snails [n -S]\n",
  "LIMNAEIDS": "LIMNAEID, a member of the family of pond-snails [n]\n",
  "LIMNED": "LIMN, (archaic) to portray, paint or delineate [v]\n",
  "LIMNER": "a painter of portraits [n -S]\n",
  "LIMNERS": "LIMNER, a painter of portraits [n]\n",
  "LIMNETIC": "living in fresh water, also LIMNIC [adj]\n",
  "LIMNIC": "living in fresh water, also LIMNETIC [adj]\n",
  "LIMNING": "LIMN, (archaic) to portray, paint or delineate [v]\n",
  "LIMNOLOGIC": "relating to limnology, the study of bodies of fresh water, also LIMNOLOGICAL [adj LIMNOLOGICALLY]\n",
  "LIMNOLOGICAL": "relating to limnology, the study of bodies of fresh water, also LIMNOLOGIC [adj LIMNOLOGICALLY]\n",
  "LIMNOLOGICALLY": "LIMNOLOGICAL, relating to limnology, the study of bodies of fresh water, also LIMNOLOGIC [adv]\n",
  "LIMNOLOGIES": "LIMNOLOGY, the study of bodies of fresh water [n]\n",
  "LIMNOLOGIST": "one who studies limnology, the study of bodies of fresh water [n -S]\n",
  "LIMNOLOGISTS": "LIMNOLOGIST, one who studies limnology, the study of bodies of fresh water [n]\n",
  "LIMNOLOGY": "the study of bodies of fresh water [n LIMNOLOGIES]\n",
  "LIMNOPHILOUS": "living in ponds or marshes [adj]\n",
  "LIMNS": "LIMN, (archaic) to portray, paint or delineate [v]\n",
  "LIMO": "(short for) a limousine [n -S]\n",
  "LIMONENE": "a liquid terpene found in lemon, orange, and other essential oils [n -S]\n",
  "LIMONENES": "LIMONENE, a liquid terpene found in lemon, orange, and other essential oils [n]\n",
  "LIMONITE": "a major ore of iron [n -S]\n",
  "LIMONITES": "LIMONITE, a major ore of iron [n]\n",
  "LIMONITIC": "of or like limonite, hydrous sesquioxide of iron [adj]\n",
  "LIMONIUM": "a sea plant with brightly coloured funnel-shaped flowers [n -S]\n",
  "LIMONIUMS": "LIMONIUM, a sea plant with brightly coloured funnel-shaped flowers [n]\n",
  "LIMOS": "LIMO, (short for) a limousine [n]\n",
  "LIMOSES": "LIMOSIS, (Greek) an abnormally ravenous appetite [n]\n",
  "LIMOSIS": "(Greek) an abnormally ravenous appetite [n LIMOSES]\n",
  "LIMOUS": "(archaic) muddy, slimy [adj]\n",
  "LIMOUSINE": "any large and luxurious car, esp. one that has a glass division between the driver and passengers [n -S]\n",
  "LIMOUSINES": "LIMOUSINE, any large and luxurious car, esp. one that has a glass division between the driver and passengers [n]\n",
  "LIMP": "lacking rigidity [adj LIMPER, LIMPEST, LIMPLY] / to walk lamely [v -ED, -ING, -S]\n",
  "LIMPA": "(Swedish) rye bread made with molasses [n -S]\n",
  "LIMPAS": "LIMPA, (Swedish) rye bread made with molasses [n]\n",
  "LIMPED": "LIMP, to walk lamely [v]\n",
  "LIMPER": "one who limps [n -S]\n",
  "LIMPERS": "LIMPER, one who limps [n]\n",
  "LIMPEST": "LIMP, lacking rigidity [adj]\n",
  "LIMPET": "a gastropod with a conical shell, that clings to rocks [n -S]\n",
  "LIMPETS": "LIMPET, a gastropod with a conical shell, that clings to rocks [n]\n",
  "LIMPID": "transparent [adj LIMPIDLY]\n",
  "LIMPIDITIES": "LIMPIDITY, the quality of being limpid [n]\n",
  "LIMPIDITY": "the quality of being limpid [n LIMPIDITIES]\n",
  "LIMPIDLY": "LIMPID, transparent [adv]\n",
  "LIMPIDNESS": "the quality of being limpid [n -ES]\n",
  "LIMPIDNESSES": "LIMPIDNESS, the quality of being limpid [n]\n",
  "LIMPING": "the act of limping [n -S]\n",
  "LIMPINGLY": "LIMPING [adv]\n",
  "LIMPINGS": "LIMPING, the act of limping [n]\n",
  "LIMPKIN": "an American wading bird, like a rail [n -S]\n",
  "LIMPKINS": "LIMPKIN, an American wading bird, like a rail [n]\n",
  "LIMPLY": "LIMP, lacking rigidity [adv]\n",
  "LIMPNESS": "the state of being limp [n -ES]\n",
  "LIMPNESSES": "LIMPNESS, the state of being limp [n]\n",
  "LIMPS": "LIMP, to walk lamely [v]\n",
  "LIMPSEY": "lacking strength or vigour, also LIMPSY [adj LIMPSIER, LIMPSIEST]\n",
  "LIMPSIER": "LIMPSEY, lacking strength or vigour, also LIMPSY [adj]\n",
  "LIMPSIEST": "LIMPSEY, lacking strength or vigour, also LIMPSY [adj]\n",
  "LIMPSY": "lacking strength or vigour, also LIMPSEY [adj LIMPSIER, LIMPSIEST]\n",
  "LIMULI": "LIMULUS, (Latin) a horseshoe crab, also LIMULOID [n]\n",
  "LIMULOID": "a member of the king crab family, also LIMULUS [n -S]\n",
  "LIMULOIDS": "LIMULOID, a member of the king crab family, also LIMULUS [n]\n",
  "LIMULUS": "(Latin) a horseshoe crab, also LIMULOID [n LIMULUSES or LIMULI]\n",
  "LIMULUSES": "LIMULUS, (Latin) a horseshoe crab, also LIMULOID [n]\n",
  "LIMY": "containing lime [adj LIMIER, LIMIEST]\n",
  "LIN": "to cease [v LINNED, LINNING, LINS]\n",
  "LINABLE": "lying in a straight line [adj]\n",
  "LINAC": "a linear particle accelerator [n -S]\n",
  "LINACS": "LINAC, a linear particle accelerator [n]\n",
  "LINAGE": "payment for written work by the line [n -S]\n",
  "LINAGES": "LINAGE, payment for written work by the line [n]\n",
  "LINALOL": "(Spanish) a fragrant liquid alcohol, used to make perfume, obtained from oil of rosewood, also LINALOOL [n -S]\n",
  "LINALOLS": "LINALOL, (Spanish) a fragrant liquid alcohol, used to make perfume, obtained from oil of rosewood, also LINALOOL [n]\n",
  "LINALOOL": "(Spanish) a fragrant liquid alcohol, used to make perfume, obtained from oil of rosewood, also LINALOL [n -S]\n",
  "LINALOOLS": "LINALOOL, (Spanish) a fragrant liquid alcohol, used to make perfume, obtained from oil of rosewood, also LINALOL [n]\n",
  "LINCH": "a terrace or ridge formed in prehistoric or medieval times by ploughing a hillside, also LINCHET, LYNCHET [n -ES]\n",
  "LINCHES": "LINCH, a terrace or ridge formed in prehistoric or medieval times by ploughing a hillside, also LINCHET, LYNCHET [n]\n",
  "LINCHET": "a terrace or ridge formed in prehistoric or medieval times by ploughing a hillside, also LINCH, LYNCHET [n -S]\n",
  "LINCHETS": "LINCHET, a terrace or ridge formed in prehistoric or medieval times by ploughing a hillside, also LINCH, LYNCHET [n]\n",
  "LINCHPIN": "a locking pin inserted in the end of a shaft, also LYNCHPIN [n -S]\n",
  "LINCHPINS": "LINCHPIN, a locking pin inserted in the end of a shaft, also LYNCHPIN [n]\n",
  "LINCOMYCIN": "an antibiotic used for streptococcal infections [n -S]\n",
  "LINCOMYCINS": "LINCOMYCIN, an antibiotic used for streptococcal infections [n]\n",
  "LINCRUSTA": "thick embossed wallpaper [n -S]\n",
  "LINCRUSTAS": "LINCRUSTA, thick embossed wallpaper [n]\n",
  "LINCTURE": "a medicated syrup for the throat, also LINCTUS [n -S]\n",
  "LINCTURES": "LINCTURE, a medicated syrup for the throat, also LINCTUS [n]\n",
  "LINCTUS": "(Latin) a medicated syrup for the throat, also LINCTURE [n -ES]\n",
  "LINCTUSES": "LINCTUS, (Latin) a medicated syrup for the throat, also LINCTURE [n]\n",
  "LIND": "a lime-tree, also LINDEN [n -S]\n",
  "LINDANE": "an insecticide [n -S]\n",
  "LINDANES": "LINDANE, an insecticide [n]\n",
  "LINDEN": "a lime-tree, also LIND [n -S]\n",
  "LINDENS": "LINDEN, a lime-tree, also LIND [n]\n",
  "LINDIED": "LINDY, to perform the lindy, a dance closely resembling the jitterbug [v]\n",
  "LINDIES": "LINDY, to perform the lindy, a dance closely resembling the jitterbug [v]\n",
  "LINDS": "LIND, a lime-tree, also LINDEN [n]\n",
  "LINDWORM": "a wingless dragon [n -S]\n",
  "LINDWORMS": "LINDWORM, a wingless dragon [n]\n",
  "LINDY": "to perform the lindy, a dance closely resembling the jitterbug [v LINDIED, LINDYING, LINDIES]\n",
  "LINDYING": "LINDY, to perform the lindy, a dance closely resembling the jitterbug [v]\n",
  "LINE": "to mark out with slender, continuous marks [v LINED, LINING, LINES]\n",
  "LINEABLE": "that can be lined, also LINABLE [adj]\n",
  "LINEAGE": "direct descent from an ancestor, also LIGNAGE, LYNAGE [n -S]\n",
  "LINEAGES": "LINEAGE, direct descent from an ancestor, also LIGNAGE, LYNAGE [n]\n",
  "LINEAL": "being directly descended from ancestor [adj LINEALLY]\n",
  "LINEALITIES": "LINEALITY, the quality of being lineal [n]\n",
  "LINEALITY": "the quality of being lineal [n LINEALITIES]\n",
  "LINEALLY": "LINEAL, being directly descended from ancestor [adv]\n",
  "LINEAMENT": "a distinctive feature or characteristic [n -S]\n",
  "LINEAMENTAL": "relating to lineaments [adj]\n",
  "LINEAMENTS": "LINEAMENT, a distinctive feature or characteristic [n]\n",
  "LINEAR": "of or belonging to a line [adj LINEARLY]\n",
  "LINEARISATION": "the act of making linear, also LINEARIZATION [n -S]\n",
  "LINEARISATIONS": "LINEARISATION, the act of making linear, also LINEARIZATION [n]\n",
  "LINEARISE": "to make linear, also LINEARIZE [v LINEARISED, LINEARISING, LINEARISES]\n",
  "LINEARISED": "LINEARISE, to make linear, also LINEARIZE [v]\n",
  "LINEARISES": "LINEARISE, to make linear, also LINEARIZE [v]\n",
  "LINEARISING": "LINEARISE, to make linear, also LINEARIZE [v]\n",
  "LINEARITIES": "LINEARITY, the quality of being linear [n]\n",
  "LINEARITY": "the quality of being linear [n LINEARITIES]\n",
  "LINEARIZATION": "the act of making linear, also LINEARISATION [n -S]\n",
  "LINEARIZATIONS": "LINEARIZATION, the act of making linear, also LINEARISATION [n]\n",
  "LINEARIZE": "to make linear, also LINEARISE [v LINEARIZED, LINEARIZING, LINEARIZES]\n",
  "LINEARIZED": "LINEARIZE, to make linear, also LINEARISE [v]\n",
  "LINEARIZES": "LINEARIZE, to make linear, also LINEARISE [v]\n",
  "LINEARIZING": "LINEARIZE, to make linear, also LINEARISE [v]\n",
  "LINEARLY": "LINEAR, of or belonging to a line [adv]\n",
  "LINEATE": "marked with lines, also LINEATED [adj]\n",
  "LINEATED": "marked with lines, also LINEATE [adj]\n",
  "LINEATION": "the act of marking with lines [n -S]\n",
  "LINEATIONS": "LINEATION, the act of marking with lines [n]\n",
  "LINEBACKER": "in American football, a defensive player [n -S]\n",
  "LINEBACKERS": "LINEBACKER, in American football, a defensive player [n]\n",
  "LINEBACKING": "playing as a linebacker [n -S]\n",
  "LINEBACKINGS": "LINEBACKING, playing as a linebacker [n]\n",
  "LINEBRED": "produced by breeding within a particular line of descent [adj]\n",
  "LINEBREEDING": "the interbreeding of individuals within a particular line of descent usually to perpetuate desirable characters [n -S]\n",
  "LINEBREEDINGS": "LINEBREEDING, the interbreeding of individuals within a particular line of descent usually to perpetuate desirable characters [n]\n",
  "LINECASTER": "a machine that casts metal type in lines [n -S]\n",
  "LINECASTERS": "LINECASTER, a machine that casts metal type in lines [n]\n",
  "LINECASTING": "the casting of metal type in lines [n -S]\n",
  "LINECASTINGS": "LINECASTING, the casting of metal type in lines [n]\n",
  "LINECUT": "a type of printing plate [n -S]\n",
  "LINECUTS": "LINECUT, a type of printing plate [n]\n",
  "LINED": "LINE, to mark out with slender, continuous marks [v]\n",
  "LINELESS": "without lines [adj]\n",
  "LINELIKE": "like a line [adj]\n",
  "LINEMAN": "one who installs or repairs telephone wires [n LINEMEN]\n",
  "LINEMATE": "a hockey player on the same line as another [n -S]\n",
  "LINEMATES": "LINEMATE, a hockey player on the same line as another [n]\n",
  "LINEMEN": "LINEMAN, one who installs or repairs telephone wires [n]\n",
  "LINEN": "a fabric woven from the fibres of flax [n -S]\n",
  "LINENFOLD": "a representation of linen laid in vertical folds, of Flemish origin in the 15th century and used by Tudor woodcarvers, mainly for decorating panelling, doors, and chests [n -S]\n",
  "LINENFOLDS": "LINENFOLD, a representation of linen laid in vertical folds, of Flemish origin in the 15th century and used by Tudor woodcarvers, mainly for decorating panelling, doors, and chests [n]\n",
  "LINENIER": "LINENY, like linen [adj]\n",
  "LINENIEST": "LINENY, like linen [adj]\n",
  "LINENS": "LINEN, a fabric woven from the fibres of flax [n]\n",
  "LINENY": "like linen [adj LINENIER, LINENIEST]\n",
  "LINEOLATE": "marked with fine lines, also LINEOLATED [adj]\n",
  "LINEOLATED": "marked with fine lines, also LINEOLATE [adj]\n",
  "LINER": "a passenger ship, esp. one that is part of a commercial fleet [n -S]\n",
  "LINERBOARD": "a thin paperboard used for the flat facings of corrugated containerboard [n -S]\n",
  "LINERBOARDS": "LINERBOARD, a thin paperboard used for the flat facings of corrugated containerboard [n]\n",
  "LINERLESS": "of clothing, without a liner [adj]\n",
  "LINERS": "LINER, a passenger ship, esp. one that is part of a commercial fleet [n]\n",
  "LINES": "LINE, to mark out with slender, continuous marks [v]\n",
  "LINESCORE": "a summary of the scoring in a game displayed in a horizontal table [n -S]\n",
  "LINESCORES": "LINESCORE, a summary of the scoring in a game displayed in a horizontal table [n]\n",
  "LINESMAN": "an official who helps the referee or umpire in various sports, esp. by indicating when the ball has gone out of play [n LINESMEN]\n",
  "LINESMEN": "LINESMAN, an official who helps the referee or umpire in various sports, esp. by indicating when the ball has gone out of play [n]\n",
  "LINEUP": "a list of team members [n -S]\n",
  "LINEUPS": "LINEUP, a list of team members [n]\n",
  "LINEY": "resembling a line, also LINY [adj LINIER, LINIEST]\n",
  "LING": "any of various plants of the heath family, esp. heather [n -S]\n",
  "LINGA": "(Sanskrit) the phallic symbol under which Siva is principally worshipped in his character of the creative and reproductive power, also LINGAM [n -S]\n",
  "LINGAM": "(Sanskrit) the phallic symbol under which Siva is principally worshipped in his character of the creative and reproductive power, also LINGA [n -S]\n",
  "LINGAMS": "LINGAM, (Sanskrit) the phallic symbol under which Siva is principally worshipped in his character of the creative and reproductive power, also LINGA [n]\n",
  "LINGAS": "LINGA, (Sanskrit) the phallic symbol under which Siva is principally worshipped in his character of the creative and reproductive power, also LINGAM [n]\n",
  "LINGBERRIES": "LINGBERRY, the cowberry or red whortleberry, esp. as used in Scandinavian cookery, also LINGONBERRY [n]\n",
  "LINGBERRY": "the cowberry or red whortleberry, esp. as used in Scandinavian cookery, also LINGONBERRY [n LINGBERRIES]\n",
  "LINGCOD": "a marine food fish [n -S]\n",
  "LINGCODS": "LINGCOD, a marine food fish [n]\n",
  "LINGEL": "a shoemaker's waxed thread, also LINGLE [n -S]\n",
  "LINGELS": "LINGEL, a shoemaker's waxed thread, also LINGLE [n]\n",
  "LINGER": "to delay departure [v -ED, -ING, -S]\n",
  "LINGERED": "LINGER, to delay departure [v]\n",
  "LINGERER": "one who lingers [n -S]\n",
  "LINGERERS": "LINGERER, one who lingers [n]\n",
  "LINGERIE": "(French) women's underwear [n -S]\n",
  "LINGERIES": "LINGERIE, (French) women's underwear [n]\n",
  "LINGERING": "remaining [adj LINGERINGLY] / the act of lingering [n -S]\n",
  "LINGERINGLY": "LINGERING, remaining [adv]\n",
  "LINGERINGS": "LINGERING, the act of lingering [n]\n",
  "LINGERS": "LINGER, to delay departure [v]\n",
  "LINGIER": "LINGY, covered with heaths [adj]\n",
  "LINGIEST": "LINGY, covered with heaths [adj]\n",
  "LINGLE": "a shoemaker's waxed thread, also LINGEL [n -S]\n",
  "LINGLES": "LINGLE, a shoemaker's waxed thread, also LINGEL [n]\n",
  "LINGO": "(colloquial) language [n -ES or -S]\n",
  "LINGOES": "LINGO, (colloquial) language [n]\n",
  "LINGONBERRIES": "LINGONBERRY, the cowberry or red whortleberry, esp. as used in Scandinavian cookery, also LINGBERRY [n]\n",
  "LINGONBERRY": "the cowberry or red whortleberry, esp. as used in Scandinavian cookery, also LINGBERRY [n LINGONBERRIES]\n",
  "LINGOS": "LINGO, (colloquial) language [n]\n",
  "LINGOT": "(obsolete) an ingot [n -S]\n",
  "LINGOTS": "LINGOT, (obsolete) an ingot [n]\n",
  "LINGS": "LING, any of various plants of the heath family, esp. heather [n]\n",
  "LINGSTER": "an interpreter, also LINKSTER [n -S]\n",
  "LINGSTERS": "LINGSTER, an interpreter, also LINKSTER [n]\n",
  "LINGUA": "(Latin) the tongue [n LINGUAS or LINGUAE]\n",
  "LINGUAE": "LINGUA, (Latin) the tongue [n]\n",
  "LINGUAL": "pronounced with the tongue [adj LINGUALLY] / a sound pronounced using the tongue [n -S]\n",
  "LINGUALLY": "LINGUAL, pronounced with the tongue [adv]\n",
  "LINGUALS": "LINGUAL, a sound pronounced using the tongue [n]\n",
  "LINGUAS": "LINGUA, (Latin) the tongue [n]\n",
  "LINGUICA": "a spicy Portuguese sausage, also LINGUISA [n -S]\n",
  "LINGUICAS": "LINGUICA, a spicy Portuguese sausage, also LINGUISA [n]\n",
  "LINGUIFORM": "shaped like a tongue [adj]\n",
  "LINGUINE": "(Italian) a kind of pasta made in narrow strips, also LINGUINI [n -S]\n",
  "LINGUINES": "LINGUINE, (Italian) a kind of pasta made in narrow strips, also LINGUINI [n]\n",
  "LINGUINI": "(Italian) a kind of pasta made in narrow strips, also LINGUINE [n -S]\n",
  "LINGUINIS": "LINGUINI, (Italian) a kind of pasta made in narrow strips, also LINGUINE [n]\n",
  "LINGUISA": "a spicy Portuguese sausage, also LINGUICA [n -S]\n",
  "LINGUISAS": "LINGUISA, a spicy Portuguese sausage, also LINGUICA [n]\n",
  "LINGUIST": "a person skilled in several languages [n -S]\n",
  "LINGUISTER": "an interpreter, also LINGSTER, LINKSTER [n -S]\n",
  "LINGUISTERS": "LINGUISTER, an interpreter, also LINGSTER, LINKSTER [n]\n",
  "LINGUISTIC": "of or relating to language or linguistics, also LINGUISTICAL [adj LINGUISTICALLY]\n",
  "LINGUISTICAL": "relating to language, also LINGUISTIC [adj LINGUISTICALLY]\n",
  "LINGUISTICALLY": "LINGUISTICAL, relating to language, also LINGUISTIC [adv]\n",
  "LINGUISTICIAN": "a linguist [n -S]\n",
  "LINGUISTICIANS": "LINGUISTICIAN, a linguist [n]\n",
  "LINGUISTICS": "the study of human speech including the units, nature, structure, and modification of language [n]\n",
  "LINGUISTRIES": "LINGUISTRY, the study of languages [n]\n",
  "LINGUISTRY": "the study of languages [n LINGUISTRIES]\n",
  "LINGUISTS": "LINGUIST, a person skilled in several languages [n]\n",
  "LINGULA": "(Latin) a tonguelike process or part [n LINGULAE or LINGULAS]\n",
  "LINGULAE": "LINGULA, (Latin) a tonguelike process or part [n]\n",
  "LINGULAR": "of or like a lingula, a tonguelike process or part [adj]\n",
  "LINGULAS": "LINGULA, (Latin) a tonguelike process or part [n]\n",
  "LINGULATE": "shaped like the tongue or a strap, also LINGULATED [adj]\n",
  "LINGULATED": "shaped like the tongue or a strap, also LINGULATE [adj]\n",
  "LINGY": "covered with heaths [adj LINGIER, LINGIEST]\n",
  "LINHAY": "a shed, also LINNEY, LINNY [n -S]\n",
  "LINHAYS": "LINHAY, a shed, also LINNEY, LINNY [n]\n",
  "LINIER": "LINEY, resembling a line, also LINY [adj]\n",
  "LINIEST": "LINEY, resembling a line, also LINY [adj]\n",
  "LINIMENT": "a liquid preparation for rubbing into the skin to relieve pain or stiffness of a joint [n -S]\n",
  "LINIMENTS": "LINIMENT, a liquid preparation for rubbing into the skin to relieve pain or stiffness of a joint [n]\n",
  "LININ": "(Greek) a substance which forms the network of a cell nucleus [n -S]\n",
  "LINING": "an inner layer [n -S]\n",
  "LININGS": "LINING, an inner layer [n]\n",
  "LININS": "LININ, (Greek) a substance which forms the network of a cell nucleus [n]\n",
  "LINISH": "to give a smooth linen-like finish to metal [v -ED, -ING, -ES]\n",
  "LINISHED": "LINISH, to give a smooth linen-like finish to metal [v]\n",
  "LINISHER": "someone or something which linishes, gives a smooth surface to metal [n -S]\n",
  "LINISHERS": "LINISHER, someone or something which linishes, gives a smooth surface to metal [n]\n",
  "LINISHES": "LINISH, to give a smooth linen-like finish to metal [v]\n",
  "LINISHING": "the act of giving a smooth surface to metal [n -S]\n",
  "LINISHINGS": "LINISHING, the act of giving a smooth surface to metal [n]\n",
  "LINK": "to connect [v -ED, -ING, -S]\n",
  "LINKABLE": "able to be linked [adj]\n",
  "LINKAGE": "the act of linking [n -S]\n",
  "LINKAGES": "LINKAGE, the act of linking [n]\n",
  "LINKBOY": "a male hired to light the way along dark streets, also LINKMAN [n -S]\n",
  "LINKBOYS": "LINKBOY, a male hired to light the way along dark streets, also LINKMAN [n]\n",
  "LINKED": "LINK, to connect [v]\n",
  "LINKER": "one who links [n -S]\n",
  "LINKERS": "LINKER, one who links [n]\n",
  "LINKIER": "LINKY, (of countryside) consisting of or having the appearance of links [adj]\n",
  "LINKIEST": "LINKY, (of countryside) consisting of or having the appearance of links [adj]\n",
  "LINKING": "LINK, to connect [v]\n",
  "LINKMAN": "a male hired to light the way along dark streets, also LINKBOY [n LINKMEN]\n",
  "LINKMEN": "LINKMAN, a male hired to light the way along dark streets, also LINKBOY [n]\n",
  "LINKROT": "the condition of a website link not being updated, with the result that the host website is no longer hyperlinked to the desired website [n -S]\n",
  "LINKROTS": "LINKROT, the condition of a website link not being updated, with the result that the host website is no longer hyperlinked to the desired website [n]\n",
  "LINKS": "LINK, to connect [v]\n",
  "LINKSLAND": "land near the sea used for golf [n -S]\n",
  "LINKSLANDS": "LINKSLAND, land near the sea used for golf [n]\n",
  "LINKSMAN": "a golfer [n LINKSMEN]\n",
  "LINKSMEN": "LINKSMAN, a golfer [n]\n",
  "LINKSPAN": "a ramp attached to a pier to assist the loading of vehicles on to ferries [n -S]\n",
  "LINKSPANS": "LINKSPAN, a ramp attached to a pier to assist the loading of vehicles on to ferries [n]\n",
  "LINKSTER": "(US) an interpreter, also LINGSTER, LINGUISTER [n -S]\n",
  "LINKSTERS": "LINKSTER, (US) an interpreter, also LINGSTER, LINGUISTER [n]\n",
  "LINKUP": "something that serves as a linking device [n -S]\n",
  "LINKUPS": "LINKUP, something that serves as a linking device [n]\n",
  "LINKWORK": "a fabric consisting of links made of metal or other material fastened together [n -S]\n",
  "LINKWORKS": "LINKWORK, a fabric consisting of links made of metal or other material fastened together [n]\n",
  "LINKY": "(of countryside) consisting of or having the appearance of links [adj LINKIER, LINKIEST]\n",
  "LINN": "(Scots) a waterfall, also LIN [n -S]\n",
  "LINNED": "LIN, to cease [v]\n",
  "LINNET": "a common finch, feeding on flaxseed, also LINTIE, LINTWHITE [n -S]\n",
  "LINNETS": "LINNET, a common finch, feeding on flaxseed, also LINTIE, LINTWHITE [n]\n",
  "LINNEY": "a shed with an open front, also LINHAY, LINNY [n -S]\n",
  "LINNEYS": "LINNEY, a shed with an open front, also LINHAY, LINNY [n]\n",
  "LINNIES": "LINNY, a shed, also LINHAY, LINNEY [n]\n",
  "LINNING": "LIN, to cease [v]\n",
  "LINNS": "LINN, (Scots) a waterfall, also LIN [n]\n",
  "LINNY": "a shed, also LINHAY, LINNEY [n LINNIES]\n",
  "LINO": "(short for) linoleum [n -S]\n",
  "LINOCUT": "a print made from a design cut into linoleum [n -S]\n",
  "LINOCUTS": "LINOCUT, a print made from a design cut into linoleum [n]\n",
  "LINOLEATE": "a salt of linoleic acid [n -S]\n",
  "LINOLEATES": "LINOLEATE, a salt of linoleic acid [n]\n",
  "LINOLEIC": "as in linoleic acid [adj]\n",
  "LINOLENIC": "as in linolenic acid, an essential fatty acid derived from linoleic acid [adj]\n",
  "LINOLEUM": "a durable material used as floor covering [n -S]\n",
  "LINOLEUMS": "LINOLEUM, a durable material used as floor covering [n]\n",
  "LINOS": "LINO, (short for) linoleum [n]\n",
  "LINOTYPE": "(tradename) a brand of typesetting machine [n -S] / to set a line of type using a linotype machine [v LINOTYPED, LINOTYPING, LINOTYPES]\n",
  "LINOTYPED": "LINOTYPE, to set a line of type using a linotype machine [v]\n",
  "LINOTYPER": "one who sets type using linotype [n -S]\n",
  "LINOTYPERS": "LINOTYPER, one who sets type using linotype [n]\n",
  "LINOTYPES": "LINOTYPE, to set a line of type using a linotype machine [v]\n",
  "LINOTYPING": "LINOTYPE, to set a line of type using a linotype machine [v]\n",
  "LINS": "LIN, to cease [v]\n",
  "LINSANG": "(Javanese) a civetlike animal of Borneo [n -S]\n",
  "LINSANGS": "LINSANG, (Javanese) a civetlike animal of Borneo [n]\n",
  "LINSEED": "lint or flax seed, also LINTSEED [n -S]\n",
  "LINSEEDS": "LINSEED, lint or flax seed, also LINTSEED [n]\n",
  "LINSEY": "a coarse linen and wool blend [n -S]\n",
  "LINSEYS": "LINSEY, a coarse linen and wool blend [n]\n",
  "LINSTOCK": "(historical) a pointed forked staff, shod with iron at the foot, to hold a lighted match for firing cannon, also LINTSTOCK [n -S]\n",
  "LINSTOCKS": "LINSTOCK, (historical) a pointed forked staff, shod with iron at the foot, to hold a lighted match for firing cannon, also LINTSTOCK [n]\n",
  "LINT": "an absorbent cotton or linen fabric with the nap raised on one side, used to dress wounds, etc. [n -S] / to put lint on [v -ED, -ING, -S]\n",
  "LINTED": "LINT, to put lint on [v]\n",
  "LINTEL": "a horizontal supporting beam, also LINTOL [n -S]\n",
  "LINTELED": "having a lintel, also LINTELLED [adj]\n",
  "LINTELLED": "having a lintel, also LINTELED [adj]\n",
  "LINTELS": "LINTEL, a horizontal supporting beam, also LINTOL [n]\n",
  "LINTER": "a machine for removing fibres from cotton seeds [n -S]\n",
  "LINTERS": "LINTER, a machine for removing fibres from cotton seeds [n]\n",
  "LINTIE": "(Scots) a linnet, also LINTWHITE [n -S]\n",
  "LINTIER": "LINTY, covered with lint [adj]\n",
  "LINTIES": "LINTIE, (Scots) a linnet, also LINTWHITE [n]\n",
  "LINTIEST": "LINTY, covered with lint [adj]\n",
  "LINTING": "the act of putting lint on [n -S]\n",
  "LINTINGS": "LINTING, the act of putting lint on [n]\n",
  "LINTLESS": "free from lint [adj]\n",
  "LINTOL": "a horizontal supporting beam, also LINTEL [n -S]\n",
  "LINTOLS": "LINTOL, a horizontal supporting beam, also LINTEL [n]\n",
  "LINTS": "LINT, an absorbent cotton or linen fabric with the nap raised on one side, used to dress wounds, etc. [n]\n",
  "LINTSEED": "a lint or flax seed [n -S]\n",
  "LINTSEEDS": "LINTSEED, a lint or flax seed [n]\n",
  "LINTSTOCK": "(historical) a pointed forked staff, shod with iron at the foot, to hold a lighted match for firing cannon, also LINSTOCK [n -S]\n",
  "LINTSTOCKS": "LINTSTOCK, (historical) a pointed forked staff, shod with iron at the foot, to hold a lighted match for firing cannon, also LINSTOCK [n]\n",
  "LINTWHITE": "(Scots) a linnet, also LINTIE [n -S]\n",
  "LINTWHITES": "LINTWHITE, (Scots) a linnet, also LINTIE [n]\n",
  "LINTY": "covered with lint [adj LINTIER, LINTIEST]\n",
  "LINUM": "(Latin) a plant of the flax family [n -S]\n",
  "LINUMS": "LINUM, (Latin) a plant of the flax family [n]\n",
  "LINURON": "a herbicide [n -S]\n",
  "LINURONS": "LINURON, a herbicide [n]\n",
  "LINUX": "(tradename) a nonproprietary computer operating system for personal computers [n -ES]\n",
  "LINUXES": "LINUX, (tradename) a nonproprietary computer operating system for personal computers [n]\n",
  "LINY": "resembling a line, also LINEY [adj LINIER, LINIEST]\n",
  "LION": "a large, carnivorous, feline animal [n -S]\n",
  "LIONCEL": "a small lion used as a bearing in heraldry, also LIONEL, LIONCELLE [n -S]\n",
  "LIONCELLE": "a small lion used as a bearing in heraldry, also LIONCEL, LIONEL [n -S]\n",
  "LIONCELLES": "LIONCELLE, a small lion used as a bearing in heraldry, also LIONCEL, LIONEL [n]\n",
  "LIONCELS": "LIONCEL, a small lion used as a bearing in heraldry, also LIONEL, LIONCELLE [n]\n",
  "LIONEL": "a small lion used as a bearing in heraldry, also LIONCEL, LIONCELLE [n -S]\n",
  "LIONELS": "LIONEL, a small lion used as a bearing in heraldry, also LIONCEL, LIONCELLE [n]\n",
  "LIONESS": "a female lion [n -ES]\n",
  "LIONESSES": "LIONESS, a female lion [n]\n",
  "LIONET": "a young lion [n -S]\n",
  "LIONETS": "LIONET, a young lion [n]\n",
  "LIONFISH": "a tropical fish [n -ES]\n",
  "LIONFISHES": "LIONFISH, a tropical fish [n]\n",
  "LIONHEAD": "a small long-tailed breed of rabbit [n -S]\n",
  "LIONHEADS": "LIONHEAD, a small long-tailed breed of rabbit [n]\n",
  "LIONHEARTED": "brave as a lion [adj]\n",
  "LIONHEARTEDNESS": "LIONHEARTED, brave as a lion [n]\n",
  "LIONISATION": "the act of lionising, also LIONIZATION [n -S]\n",
  "LIONISATIONS": "LIONISATION, the act of lionising, also LIONIZATION [n]\n",
  "LIONISE": "to treat as a celebrity, also LIONIZE [v LIONISED, LIONISING, LIONISES]\n",
  "LIONISED": "LIONISE, to treat as a celebrity, also LIONIZE [v]\n",
  "LIONISER": "one who lionises, also LIONIZER [n -S]\n",
  "LIONISERS": "LIONISER, one who lionises, also LIONIZER [n]\n",
  "LIONISES": "LIONISE, to treat as a celebrity, also LIONIZE [v]\n",
  "LIONISING": "LIONISE, to treat as a celebrity, also LIONIZE [v]\n",
  "LIONISM": "a lionlike appearance symptomatic of leprosy [n -S]\n",
  "LIONISMS": "LIONISM, a lionlike appearance symptomatic of leprosy [n]\n",
  "LIONIZATION": "the act of lionizing, also LIONISATION [n -S]\n",
  "LIONIZATIONS": "LIONIZATION, the act of lionizing, also LIONISATION [n]\n",
  "LIONIZE": "to treat as a celebrity, also LIONISE [v LIONIZED, LIONIZING, LIONIZES]\n",
  "LIONIZED": "LIONIZE, to treat as a celebrity, also LIONISE [v]\n",
  "LIONIZER": "one who lionizes, also LIONISER [n -S]\n",
  "LIONIZERS": "LIONIZER, one who lionizes, also LIONISER [n]\n",
  "LIONIZES": "LIONIZE, to treat as a celebrity, also LIONISE [v]\n",
  "LIONIZING": "LIONIZE, to treat as a celebrity, also LIONISE [v]\n",
  "LIONLIER": "LIONLY, like a lion; fierce [adj]\n",
  "LIONLIEST": "LIONLY, like a lion; fierce [adj]\n",
  "LIONLIKE": "like a lion [adj]\n",
  "LIONLY": "like a lion; fierce [adj LIONLIER, LIONLIEST]\n",
  "LIONS": "LION, a large, carnivorous, feline animal [n]\n",
  "LIP": "to touch with the flesh around the mouth [v LIPPED, LIPPING, LIPS]\n",
  "LIPA": "a Croatian monetary unit, 1/100 of a kuna [n LIPAS or LIPE]\n",
  "LIPAEMIA": "an abnormal level of fat in the blood, also LIPEMIA [n -S]\n",
  "LIPAEMIAS": "LIPAEMIA, an abnormal level of fat in the blood, also LIPEMIA [n]\n",
  "LIPARITE": "an acid igneous rock, aka rhyolite [n -S]\n",
  "LIPARITES": "LIPARITE, an acid igneous rock, aka rhyolite [n]\n",
  "LIPAS": "LIPA, a Croatian monetary unit, 1/100 of a kuna [n]\n",
  "LIPASE": "an enzyme that breaks up fats [n -S]\n",
  "LIPASES": "LIPASE, an enzyme that breaks up fats [n]\n",
  "LIPE": "a lurching or jerking movement [n -S]\n",
  "LIPECTOMIES": "LIPECTOMY, the surgical removal of fatty tissue [n]\n",
  "LIPECTOMY": "the surgical removal of fatty tissue [n LIPECTOMIES]\n",
  "LIPEMIA": "an abnormal level of fat in the blood, also LIPAEMIA [n -S]\n",
  "LIPEMIAS": "LIPEMIA, an abnormal level of fat in the blood, also LIPAEMIA [n]\n",
  "LIPES": "LIPE, a lurching or jerking movement [n]\n",
  "LIPGLOSS": "a cosmetic for making lips glossy [n -ES]\n",
  "LIPGLOSSES": "LIPGLOSS, a cosmetic for making lips glossy [n]\n",
  "LIPID": "any of a class of fatty substances, also LIPIDE, LIPIN, LIPOID [n -S]\n",
  "LIPIDE": "any of a class of fatty substances, also LIPID, LIPIN, LIPOID [n -S]\n",
  "LIPIDES": "LIPIDE, any of a class of fatty substances, also LIPID, LIPIN, LIPOID [n]\n",
  "LIPIDIC": "of or like a lipid, a group of chemicals found in tissues, a constituent of fat [adj]\n",
  "LIPIDOPLAST": "a small particle in plant cytoplasm, esp. that of seeds, in which fat is stored [n -S]\n",
  "LIPIDOPLASTS": "LIPIDOPLAST, a small particle in plant cytoplasm, esp. that of seeds, in which fat is stored [n]\n",
  "LIPIDOSES": "LIPIDOSIS, a disorder of lipid metabolism in the body tissues [n]\n",
  "LIPIDOSIS": "a disorder of lipid metabolism in the body tissues [n LIPIDOSES]\n",
  "LIPIDS": "LIPID, any of a class of fatty substances, also LIPIDE, LIPIN, LIPOID [n]\n",
  "LIPIN": "any of a class of fatty substances, also LIPID, LIPIDE, LIPOID [n -S]\n",
  "LIPINS": "LIPIN, any of a class of fatty substances, also LIPID, LIPIDE, LIPOID [n]\n",
  "LIPLESS": "without lips [adj]\n",
  "LIPLIKE": "like a lip [adj]\n",
  "LIPLINER": "a cosmetic used to outline the lips [n -S]\n",
  "LIPLINERS": "LIPLINER, a cosmetic used to outline the lips [n]\n",
  "LIPO": "(colloquial) a liposuction [n -S]\n",
  "LIPOCHROME": "a pigment of butter fat etc. [n -S]\n",
  "LIPOCHROMES": "LIPOCHROME, a pigment of butter fat etc. [n]\n",
  "LIPOCYTE": "a fat-producing cell [n -S]\n",
  "LIPOCYTES": "LIPOCYTE, a fat-producing cell [n]\n",
  "LIPODYSTROPHIES": "LIPODYSTROPHY, a medical condition characterized by abnormal or degenerative conditions of the body's adipose tissue [n]\n",
  "LIPODYSTROPHY": "a medical condition characterized by abnormal or degenerative conditions of the body's adipose tissue [n LIPODYSTROPHIES]\n",
  "LIPOGENESES": "LIPOGENESIS, the formation of fat in the body [n]\n",
  "LIPOGENESIS": "the formation of fat in the body [n LIPOGENESES]\n",
  "LIPOGRAM": "a piece of writing that avoids one or more letters of the alphabet [n -S]\n",
  "LIPOGRAMMATIC": "of or like a lipogram, a piece of writing that avoids one or more letters of the alphabet [adj]\n",
  "LIPOGRAMMATISM": "the practice of writing lipograms [n -S]\n",
  "LIPOGRAMMATISMS": "LIPOGRAMMATISM, the practice of writing lipograms [n]\n",
  "LIPOGRAMMATIST": "one who writes lipograms [n -S]\n",
  "LIPOGRAMMATISTS": "LIPOGRAMMATIST, one who writes lipograms [n]\n",
  "LIPOGRAMS": "LIPOGRAM, a piece of writing that avoids one or more letters of the alphabet [n]\n",
  "LIPOGRAPHIES": "LIPOGRAPHY, the accidental omission of a letter or syllable [n]\n",
  "LIPOGRAPHY": "the accidental omission of a letter or syllable [n LIPOGRAPHIES]\n",
  "LIPOIC": "as in lipoic acid, a sulphur-containing fatty acid [adj]\n",
  "LIPOID": "any of a class of fatty substances, also LIPID, LIPIDE, LIPIN [n -S]\n",
  "LIPOIDAL": "like fat [adj]\n",
  "LIPOIDS": "LIPOID, any of a class of fatty substances, also LIPID, LIPIDE, LIPIN [n]\n",
  "LIPOLITIC": "of or like lipolysis, the disintegration of fat, also LIPOLYTIC [adj]\n",
  "LIPOLYSES": "LIPOLYSIS, the disintegration of fat [n]\n",
  "LIPOLYSIS": "the disintegration of fat [n LIPOLYSES]\n",
  "LIPOLYTIC": "of or like lipolysis, the disintegration of fat, also LIPOLITIC [adj]\n",
  "LIPOMA": "(Greek) a tumor of fatty tissue [n LIPOMAS or LIPOMATA]\n",
  "LIPOMAS": "LIPOMA, (Greek) a tumor of fatty tissue [n]\n",
  "LIPOMATA": "LIPOMA, (Greek) a tumor of fatty tissue [n]\n",
  "LIPOMATOSES": "LIPOMATOSIS, the presence of many lipomata; obesity [n]\n",
  "LIPOMATOSIS": "the presence of many lipomata; obesity [n LIPOMATOSES]\n",
  "LIPOMATOUS": "of or like a lipoma [adj]\n",
  "LIPOPHILIC": "having an affinity for lipids [adj]\n",
  "LIPOPLAST": "a small particle in plant cytoplasm esp. that of seeds in which fat is stored [n -S]\n",
  "LIPOPLASTS": "LIPOPLAST, a small particle in plant cytoplasm esp. that of seeds in which fat is stored [n]\n",
  "LIPOPROTEIN": "a water-soluble protein found in the blood, which carries cholesterol [n -S]\n",
  "LIPOPROTEINS": "LIPOPROTEIN, a water-soluble protein found in the blood, which carries cholesterol [n]\n",
  "LIPOS": "LIPO, (colloquial) a liposuction [n]\n",
  "LIPOSCULPTURE": "cosmetic surgery on the lips [n -S]\n",
  "LIPOSCULPTURES": "LIPOSCULPTURE, cosmetic surgery on the lips [n]\n",
  "LIPOSOMAL": "relating to a liposome, a naturally occurring liquid globule in the cytoplasm of a cell [adj]\n",
  "LIPOSOME": "a microscopic globule composed of lipids [n -S]\n",
  "LIPOSOMES": "LIPOSOME, a microscopic globule composed of lipids [n]\n",
  "LIPOSUCK": "to subject to liposuction [v -ED, -ING, -S]\n",
  "LIPOSUCKED": "LIPOSUCK, to subject to liposuction [v]\n",
  "LIPOSUCKING": "LIPOSUCK, to subject to liposuction [v]\n",
  "LIPOSUCKS": "LIPOSUCK, to subject to liposuction [v]\n",
  "LIPOSUCTION": "a surgical procedure for the removal of excess, unwanted fat from the body [n -S]\n",
  "LIPOSUCTIONS": "LIPOSUCTION, a surgical procedure for the removal of excess, unwanted fat from the body [n]\n",
  "LIPOTROPIC": "serving to prevent excessive accumulation of fat in the liver [adj]\n",
  "LIPOTROPIES": "LIPOTROPY, the breaking down of fat in the body [n]\n",
  "LIPOTROPIN": "a protein hormone of the pituitary gland [n -S]\n",
  "LIPOTROPINS": "LIPOTROPIN, a protein hormone of the pituitary gland [n]\n",
  "LIPOTROPY": "the breaking down of fat in the body [n LIPOTROPIES]\n",
  "LIPPED": "LIP, to touch with the flesh around the mouth [v]\n",
  "LIPPEN": "(Scots) to trust, depend on [v -ED, -ING, -S]\n",
  "LIPPENED": "LIPPEN, (Scots) to trust, depend on [v]\n",
  "LIPPENING": "LIPPEN, (Scots) to trust, depend on [v]\n",
  "LIPPENS": "LIPPEN, (Scots) to trust, depend on [v]\n",
  "LIPPER": "to ripple [v -ED, -ING, -S]\n",
  "LIPPERED": "LIPPER, to ripple [v]\n",
  "LIPPERING": "LIPPER, to ripple [v]\n",
  "LIPPERS": "LIPPER, to ripple [v]\n",
  "LIPPIE": "(Scots) an old Scottish dry measure, the fourth part of a peck, also LIPPY [n -S]\n",
  "LIPPIER": "LIPPY, impertinent [adj]\n",
  "LIPPIES": "LIPPIE, (Scots) an old Scottish dry measure, the fourth part of a peck, also LIPPY [n]\n",
  "LIPPIEST": "LIPPY, impertinent [adj]\n",
  "LIPPINESS": "the state of being lippy [n -ES]\n",
  "LIPPINESSES": "LIPPINESS, the state of being lippy [n]\n",
  "LIPPING": "a liplike outgrowth of bone [n -S]\n",
  "LIPPINGS": "LIPPING, a liplike outgrowth of bone [n]\n",
  "LIPPITUDE": "(archaic) soreness of the eyes [n -S]\n",
  "LIPPITUDES": "LIPPITUDE, (archaic) soreness of the eyes [n]\n",
  "LIPPY": "impertinent [adj LIPPIER, LIPPIEST] / an old Scottish dry measure, the fourth part of a peck, also LIPPIE [n LIPPIES]\n",
  "LIPREAD": "to understand spoken words by interpreting the lip movements of a speaker [v LIPREAD, LIPREADING, LIPREADS]\n",
  "LIPREADER": "one who lipreads [n -S]\n",
  "LIPREADERS": "LIPREADER, one who lipreads [n]\n",
  "LIPREADING": "the interpreting of speech by watching the speaker's lip and facial movements without hearing the voice [n -S]\n",
  "LIPREADINGS": "LIPREADING, the interpreting of speech by watching the speaker's lip and facial movements without hearing the voice [n]\n",
  "LIPREADS": "LIPREAD, to understand spoken words by interpreting the lip movements of a speaker [v]\n",
  "LIPS": "LIP, to touch with the flesh around the mouth [v]\n",
  "LIPSALVE": "ointment for the lips, esp. to prevent chapping; blandishment [n -S]\n",
  "LIPSALVES": "LIPSALVE, ointment for the lips, esp. to prevent chapping; blandishment [n]\n",
  "LIPSTICK": "a short stick of colouring for the lips [n -S] / to apply lipstick to [v -ED, -ING, -S]\n",
  "LIPSTICKED": "LIPSTICK, to apply lipstick to [v]\n",
  "LIPSTICKING": "LIPSTICK, to apply lipstick to [v]\n",
  "LIPSTICKS": "LIPSTICK, to apply lipstick to [v]\n",
  "LIPURIA": "the presence of fat in the urine [n -S]\n",
  "LIPURIAS": "LIPURIA, the presence of fat in the urine [n]\n",
  "LIQUABLE": "able to be liquefied [adj]\n",
  "LIQUATE": "to separate or purify (metals) by heating to liquify certain components [v LIQUATED, LIQUATING, LIQUATES]\n",
  "LIQUATED": "LIQUATE, to separate or purify (metals) by heating to liquify certain components [v]\n",
  "LIQUATES": "LIQUATE, to separate or purify (metals) by heating to liquify certain components [v]\n",
  "LIQUATING": "LIQUATE, to separate or purify (metals) by heating to liquify certain components [v]\n",
  "LIQUATION": "the act or operation of making or becoming liquid [n -S]\n",
  "LIQUATIONS": "LIQUATION, the act or operation of making or becoming liquid [n]\n",
  "LIQUEFACIENT": "an agent that causes liquefaction [n -S]\n",
  "LIQUEFACIENTS": "LIQUEFACIENT, an agent that causes liquefaction [n]\n",
  "LIQUEFACTION": "the process of making or becoming liquid, also LIQUIFACTION [n -S]\n",
  "LIQUEFACTIONS": "LIQUEFACTION, the process of making or becoming liquid, also LIQUIFACTION [n]\n",
  "LIQUEFACTIVE": "serving to liquefy, also LIQUIFACTIVE [adj]\n",
  "LIQUEFIABLE": "that can be liquefied, also LIQUIFIABLE [adj]\n",
  "LIQUEFIED": "LIQUEFY, to make or become liquid, also LIQUIFY [v]\n",
  "LIQUEFIER": "that which liquefies, also LIQUIFIER [n -S]\n",
  "LIQUEFIERS": "LIQUEFIER, that which liquefies, also LIQUIFIER [n]\n",
  "LIQUEFIES": "LIQUEFY, to make or become liquid, also LIQUIFY [v]\n",
  "LIQUEFY": "to make or become liquid, also LIQUIFY [v LIQUEFIED, LIQUEFYING, LIQUEFIES]\n",
  "LIQUEFYING": "LIQUEFY, to make or become liquid, also LIQUIFY [v]\n",
  "LIQUESCE": "to become liquid [v LIQUESCED, LIQUESCING, LIQUESCES]\n",
  "LIQUESCED": "LIQUESCE, to become liquid [v]\n",
  "LIQUESCENCE": "melting, also LIQUESCENCY [n -S]\n",
  "LIQUESCENCES": "LIQUESCENCE, melting, also LIQUESCENCY [n]\n",
  "LIQUESCENCIES": "LIQUESCENCY, melting, also LIQUESCENCE [n]\n",
  "LIQUESCENCY": "melting, also LIQUESCENCE [n LIQUESCENCIES]\n",
  "LIQUESCENT": "becoming liquid [adj]\n",
  "LIQUESCES": "LIQUESCE, to become liquid [v]\n",
  "LIQUESCING": "LIQUESCE, to become liquid [v]\n",
  "LIQUEUR": "a potent alcoholic preparation flavoured or perfumed and sweetened [n -S] / to flavour with a liqueur [v -ED, -ING, -S]\n",
  "LIQUEURED": "LIQUEUR, to flavour with a liqueur [v]\n",
  "LIQUEURING": "LIQUEUR, to flavour with a liqueur [v]\n",
  "LIQUEURS": "LIQUEUR, to flavour with a liqueur [v]\n",
  "LIQUID": "free-flowing [adj LIQUIDLY] / a substance that flows freely [n -S]\n",
  "LIQUIDAMBAR": "a genus of balsamiferous trees of the family Hamamelidaceae [n -S]\n",
  "LIQUIDAMBARS": "LIQUIDAMBAR, a genus of balsamiferous trees of the family Hamamelidaceae [n]\n",
  "LIQUIDATE": "to clear up or off (esp. a debt) [v LIQUIDATED, LIQUIDATING, LIQUIDATES]\n",
  "LIQUIDATED": "LIQUIDATE, to clear up or off (esp. a debt) [v]\n",
  "LIQUIDATES": "LIQUIDATE, to clear up or off (esp. a debt) [v]\n",
  "LIQUIDATING": "LIQUIDATE, to clear up or off (esp. a debt) [v]\n",
  "LIQUIDATION": "the act of liquidating [n -S]\n",
  "LIQUIDATIONISM": "a theory of economics which holds that governments should not interfere in a recession [n -S]\n",
  "LIQUIDATIONISMS": "LIQUIDATIONISM, a theory of economics which holds that governments should not interfere in a recession [n]\n",
  "LIQUIDATIONIST": "a proponent of the theory of economics which holds that governments should not interfere in a recession [n -S]\n",
  "LIQUIDATIONISTS": "LIQUIDATIONIST, a proponent of the theory of economics which holds that governments should not interfere in a recession [n]\n",
  "LIQUIDATIONS": "LIQUIDATION, the act of liquidating [n]\n",
  "LIQUIDATOR": "one that liquidates [n -S]\n",
  "LIQUIDATORS": "LIQUIDATOR, one that liquidates [n]\n",
  "LIQUIDIER": "LIQUIDY, having the nature of a liquid, flowing freely [adj]\n",
  "LIQUIDIEST": "LIQUIDY, having the nature of a liquid, flowing freely [adj]\n",
  "LIQUIDISE": "to make esp. food liquid, also LIQUIDIZE [v LIQUIDISED, LIQUIDISING, LIQUIDISES]\n",
  "LIQUIDISED": "LIQUIDISE, to make esp. food liquid, also LIQUIDIZE [v]\n",
  "LIQUIDISER": "a device for liquidising, also LIQUIDIZER [n -S]\n",
  "LIQUIDISERS": "LIQUIDISER, a device for liquidising, also LIQUIDIZER [n]\n",
  "LIQUIDISES": "LIQUIDISE, to make esp. food liquid, also LIQUIDIZE [v]\n",
  "LIQUIDISING": "LIQUIDISE, to make esp. food liquid, also LIQUIDIZE [v]\n",
  "LIQUIDITIES": "LIQUIDITY, the state of being liquid [n]\n",
  "LIQUIDITY": "the state of being liquid [n LIQUIDITIES]\n",
  "LIQUIDIZE": "to make esp. food liquid, also LIQUIDISE [v LIQUIDIZED, LIQUIDIZING, LIQUIDIZES]\n",
  "LIQUIDIZED": "LIQUIDIZE, to make esp. food liquid, also LIQUIDISE [v]\n",
  "LIQUIDIZER": "a device for liquidising, also LIQUIDISER [n -S]\n",
  "LIQUIDIZERS": "LIQUIDIZER, a device for liquidising, also LIQUIDISER [n]\n",
  "LIQUIDIZES": "LIQUIDIZE, to make esp. food liquid, also LIQUIDISE [v]\n",
  "LIQUIDIZING": "LIQUIDIZE, to make esp. food liquid, also LIQUIDISE [v]\n",
  "LIQUIDLY": "LIQUID, free-flowing [adv]\n",
  "LIQUIDNESS": "the state of being liquid [n -ES]\n",
  "LIQUIDNESSES": "LIQUIDNESS, the state of being liquid [n]\n",
  "LIQUIDS": "LIQUID, a substance that flows freely [n]\n",
  "LIQUIDUS": "(Latin) a curve plotted on a graph showing how temperature affects the composition of a melting or solidifying mixture [n -ES]\n",
  "LIQUIDUSES": "LIQUIDUS, (Latin) a curve plotted on a graph showing how temperature affects the composition of a melting or solidifying mixture [n]\n",
  "LIQUIDY": "having the nature of a liquid, flowing freely [adj LIQUIDIER, LIQUIDIEST]\n",
  "LIQUIFACTION": "the act of making liquid, also LIQUEFACTION [n -S]\n",
  "LIQUIFACTIONS": "LIQUIFACTION, the act of making liquid, also LIQUEFACTION [n]\n",
  "LIQUIFACTIVE": "serving to make liquid, also LIQUEFACTIVE [adj]\n",
  "LIQUIFIABLE": "capable of being liquefied, also LIQUEFIABLE [adj]\n",
  "LIQUIFIED": "LIQUIFY, to make or become liquid, also LIQUEFY [v]\n",
  "LIQUIFIER": "something that liquifies, also LIQUEFIER [n -S]\n",
  "LIQUIFIERS": "LIQUIFIER, something that liquifies, also LIQUEFIER [n]\n",
  "LIQUIFIES": "LIQUIFY, to make or become liquid, also LIQUEFY [v]\n",
  "LIQUIFY": "to make or become liquid, also LIQUEFY [v LIQUIFIED, LIQUIFYING, LIQUIFIES]\n",
  "LIQUIFYING": "LIQUIFY, to make or become liquid, also LIQUEFY [v]\n",
  "LIQUITAB": "a plastic packet containing a portion of detergent for use in a washing machine or dishwasher [n -S]\n",
  "LIQUITABS": "LIQUITAB, a plastic packet containing a portion of detergent for use in a washing machine or dishwasher [n]\n",
  "LIQUOR": "a strong alcoholic drink [n -S] / to intoxicate with an alcoholic beverage [v -ED, -ING, -S]\n",
  "LIQUORED": "LIQUOR, to intoxicate with an alcoholic beverage [v]\n",
  "LIQUORICE": "a confectionery made with an extract from the root of the liquorice plant, also LICORICE [n -S]\n",
  "LIQUORICES": "LIQUORICE, a confectionery made with an extract from the root of the liquorice plant, also LICORICE [n]\n",
  "LIQUORING": "LIQUOR, to intoxicate with an alcoholic beverage [v]\n",
  "LIQUORISH": "(obsolete) dainty, tempting to the taste; lecherous, also LICKERISH [adj LIQUORISHLY]\n",
  "LIQUORISHLY": "LIQUORISH, (obsolete) dainty, tempting to the taste; lecherous, also LICKERISH [adv]\n",
  "LIQUORISHNESS": "LIQUORISH, (obsolete) dainty, tempting to the taste; lecherous, also LICKERISH [n]\n",
  "LIQUORISHNESSES": "LIQUORISHNESS, LIQUORISH, (obsolete) dainty, tempting to the taste; lecherous, also LICKERISH [n]\n",
  "LIQUORS": "LIQUOR, to intoxicate with an alcoholic beverage [v]\n",
  "LIRA": "(Italian) an Italian unit of currency [n LIRE or LIRAS] / a Maltese unit of currency [n LIRI] / an Israeli unit of currency [n LIROT or LIROTH]\n",
  "LIRAS": "LIRA, (Italian) an Italian unit of currency [n]\n",
  "LIRE": "LIRA, (Italian) an Italian unit of currency [n]\n",
  "LIRI": "LIRA, (Italian) an Italian unit of currency [n]\n",
  "LIRIODENDRA": "LIRIODENDRON, the tulip tree [n]\n",
  "LIRIODENDRON": "the tulip tree [n LIRIODENDRONS or LIRIODENDRA]\n",
  "LIRIODENDRONS": "LIRIODENDRON, the tulip tree [n]\n",
  "LIRIOPE": "a stemless Asian herb [n -S]\n",
  "LIRIOPES": "LIRIOPE, a stemless Asian herb [n]\n",
  "LIRIPIPE": "(obsolete) a long tail of a hood, esp. in old academic or clerical dress, also LIRIPOOP [n -S]\n",
  "LIRIPIPES": "LIRIPIPE, (obsolete) a long tail of a hood, esp. in old academic or clerical dress, also LIRIPOOP [n]\n",
  "LIRIPOOP": "(obsolete) a long tail of a hood, esp. in old academic or clerical dress, also LIRIPIPE [n -S]\n",
  "LIRIPOOPS": "LIRIPOOP, (obsolete) a long tail of a hood, esp. in old academic or clerical dress, also LIRIPIPE [n]\n",
  "LIRK": "(Scots) to wrinkle [v -ED, -ING, -S]\n",
  "LIRKED": "LIRK, (Scots) to wrinkle [v]\n",
  "LIRKING": "LIRK, (Scots) to wrinkle [v]\n",
  "LIRKS": "LIRK, (Scots) to wrinkle [v]\n",
  "LIROT": "LIRA, (Italian) an Italian unit of currency [n]\n",
  "LIROTH": "LIRA, (Italian) an Italian unit of currency [n]\n",
  "LIS": "a heraldic fleur-de-lis [n LISSES]\n",
  "LISENTE": "SENTE, a monetary unit of Lesotho [n]\n",
  "LISK": "the groin [n -S]\n",
  "LISKS": "LISK, the groin [n]\n",
  "LISLE": "a fine, tightly twisted cotton thread [n -S]\n",
  "LISLES": "LISLE, a fine, tightly twisted cotton thread [n]\n",
  "LISP": "to pronounce the letters S and Z imperfectly [v -ED, -ING, -S]\n",
  "LISPED": "LISP, to pronounce the letters S and Z imperfectly [v]\n",
  "LISPER": "one who lisps [n -S]\n",
  "LISPERS": "LISPER, one who lisps [n]\n",
  "LISPING": "making a lisping sound [adj LISPINGLY] / the act of lisping [n -S]\n",
  "LISPINGLY": "LISPING, making a lisping sound [adv]\n",
  "LISPINGS": "LISPING, the act of lisping [n]\n",
  "LISPOUND": "(Dutch) a varying weight, 12 to 34 pounds, used in Orkney and Shetland, also LISPUND [n -S]\n",
  "LISPOUNDS": "LISPOUND, (Dutch) a varying weight, 12 to 34 pounds, used in Orkney and Shetland, also LISPUND [n]\n",
  "LISPS": "LISP, to pronounce the letters S and Z imperfectly [v]\n",
  "LISPUND": "(Dutch) a varying weight, 12 to 34 pounds, used in Orkney and Shetland, also LISPOUND [n -S]\n",
  "LISPUNDS": "LISPUND, (Dutch) a varying weight, 12 to 34 pounds, used in Orkney and Shetland, also LISPOUND [n]\n",
  "LISSENCEPHALOUS": "with smooth cerebral hemispheres [adj]\n",
  "LISSES": "LIS, a heraldic fleur-de-lis [n]\n",
  "LISSOM": "easily flexed, lithe, also LISSOME, LITHESOME [adj LISSOMLY]\n",
  "LISSOME": "easily flexed, lithe, also LISSOM, LITHESOME [adj LISSOMELY]\n",
  "LISSOMELY": "LISSOME, easily flexed, lithe, also LISSOM, LITHESOME [adv]\n",
  "LISSOMENESS": "the state of being lissome, also LISSOMNESS [n -ES]\n",
  "LISSOMENESSES": "LISSOMENESS, the state of being lissome, also LISSOMNESS [n]\n",
  "LISSOMLY": "LISSOM, easily flexed, lithe, also LISSOME, LITHESOME [adv]\n",
  "LISSOMNESS": "the state of being lissom, also LISSOMENESS [n -ES]\n",
  "LISSOMNESSES": "LISSOMNESS, the state of being lissom, also LISSOMENESS [n]\n",
  "LISSOTRICHOUS": "having straight or smooth hair [adj]\n",
  "LIST": "to write down in a particular order [v LISTED, LISTING, LISTS] / (archaic) to take pleasure in [v LISTED, LISTING, LISTETH]\n",
  "LISTABLE": "able to be listed [adj]\n",
  "LISTBOX": "a box on a computer screen that contains a list of options [n -ES]\n",
  "LISTBOXES": "LISTBOX, a box on a computer screen that contains a list of options [n]\n",
  "LISTED": "LIST, to write down in a particular order [v]\n",
  "LISTEE": "one who is on the list [n -S]\n",
  "LISTEES": "LISTEE, one who is on the list [n]\n",
  "LISTEL": "(archaic) a narrow border or moulding [n -S]\n",
  "LISTELS": "LISTEL, (archaic) a narrow border or moulding [n]\n",
  "LISTEN": "to try to hear [v -ED, -ING, -S]\n",
  "LISTENABILITIES": "LISTENABILITY, the quality of being listenable [n]\n",
  "LISTENABILITY": "the quality of being listenable [n LISTENABILITIES]\n",
  "LISTENABLE": "pleasant to listen to [adj]\n",
  "LISTENED": "LISTEN, to try to hear [v]\n",
  "LISTENER": "one who listens [n -S]\n",
  "LISTENERS": "LISTENER, one who listens [n]\n",
  "LISTENERSHIP": "the audience for a radio program or recording [n -S]\n",
  "LISTENERSHIPS": "LISTENERSHIP, the audience for a radio program or recording [n]\n",
  "LISTENING": "the act of trying to hear [n -S]\n",
  "LISTENINGS": "LISTENING, the act of trying to hear [n]\n",
  "LISTENS": "LISTEN, to try to hear [v]\n",
  "LISTER": "a three-pronged spear or trident used for fishing, also LEISTER [n -S]\n",
  "LISTERIA": "any bacterium of the genus Listeria, a widespread pathogen of people and animals [n -S]\n",
  "LISTERIAL": "relating to listeria [adj]\n",
  "LISTERIAS": "LISTERIA, any bacterium of the genus Listeria, a widespread pathogen of people and animals [n]\n",
  "LISTERIOSES": "LISTERIOSIS, the disease caused by listeria [n]\n",
  "LISTERIOSIS": "the disease caused by listeria [n LISTERIOSES]\n",
  "LISTERS": "LISTER, a three-pronged spear or trident used for fishing, also LEISTER [n]\n",
  "LISTETH": "LIST, to write down in a particular order [v]\n",
  "LISTFUL": "attentive [adj]\n",
  "LISTICLE": "a piece of writing based around or consisting of a list [n -S]\n",
  "LISTICLES": "LISTICLE, a piece of writing based around or consisting of a list [n]\n",
  "LISTING": "something that is listed [n -S]\n",
  "LISTINGS": "LISTING, something that is listed [n]\n",
  "LISTLESS": "languid [adj LISTLESSLY]\n",
  "LISTLESSLY": "LISTLESS, languid [adv]\n",
  "LISTLESSNESS": "the state of being listless [n -ES]\n",
  "LISTLESSNESSES": "LISTLESSNESS, the state of being listless [n]\n",
  "LISTS": "LIST, to write down in a particular order [v]\n",
  "LISTSERV": "(tradename) an Internet mailing service [n -S]\n",
  "LISTSERVS": "LISTSERV, (tradename) an Internet mailing service [n]\n",
  "LIT": "a former monetary unit of Lithuania, also LITAS [n -S]\n",
  "LITAI": "LITAS, a former monetary unit of Lithuania, also LIT [n]\n",
  "LITANIES": "LITANY, a ceremonial form of prayer [n]\n",
  "LITANY": "a ceremonial form of prayer [n LITANIES]\n",
  "LITAS": "a former monetary unit of Lithuania, also LIT [n LITAI or LITU]\n",
  "LITCHI": "(Chinese) the edible fruit of a Chinese tree, also LEECHEE, LICHEE, LICHI, LYCHEE [n -S]\n",
  "LITCHIS": "LITCHI, (Chinese) the edible fruit of a Chinese tree, also LEECHEE, LICHEE, LICHI, LYCHEE [n]\n",
  "LITE": "of food and drink, low in calories, alcoholic content, etc. [adj LITER, LITEST] / (Spenser) to alight, dismount, also LYTE [v LITED, LITING, LITES]\n",
  "LITED": "LITE, (Spenser) to alight, dismount, also LYTE [v]\n",
  "LITENESS": "the state of being lite [n -ES]\n",
  "LITENESSES": "LITENESS, the state of being lite [n]\n",
  "LITER": "(US) a measure of capacity in the metric system, a cubic decimeter, also LITRE [n -S]\n",
  "LITERACIES": "LITERACY, the ability to read and write [n]\n",
  "LITERACY": "the ability to read and write [n LITERACIES]\n",
  "LITERAL": "to be taken as read [adj LITERALLY] / a misprint, a typographical error [n -S]\n",
  "LITERALISATION": "the process of literalising, also LITERALIZATION [n -S]\n",
  "LITERALISATIONS": "LITERALISATION, the process of literalising, also LITERALIZATION [n]\n",
  "LITERALISE": "to make literal, also LITERALIZE [v LITERALISED, LITERALISING, LITERALISES]\n",
  "LITERALISED": "LITERALISE, to make literal, also LITERALIZE [v]\n",
  "LITERALISER": "one who literalises, also LITERALIZER [n -S]\n",
  "LITERALISERS": "LITERALISER, one who literalises, also LITERALIZER [n]\n",
  "LITERALISES": "LITERALISE, to make literal, also LITERALIZE [v]\n",
  "LITERALISING": "LITERALISE, to make literal, also LITERALIZE [v]\n",
  "LITERALISM": "adherence to the explicit substance of an idea or expression [n -S]\n",
  "LITERALISMS": "LITERALISM, adherence to the explicit substance of an idea or expression [n]\n",
  "LITERALIST": "an adherent of literalism [n -S]\n",
  "LITERALISTIC": "relating to literalism [adj]\n",
  "LITERALISTS": "LITERALIST, an adherent of literalism [n]\n",
  "LITERALITIES": "LITERALITY, the quality of being literal [n]\n",
  "LITERALITY": "the quality of being literal [n LITERALITIES]\n",
  "LITERALIZATION": "the act of literalizing, also LITERALISATION [n -S]\n",
  "LITERALIZATIONS": "LITERALIZATION, the act of literalizing, also LITERALISATION [n]\n",
  "LITERALIZE": "to make literal, also LITERALISE [v LITERALIZED, LITERALIZING, LITERALIZES]\n",
  "LITERALIZED": "LITERALIZE, to make literal, also LITERALISE [v]\n",
  "LITERALIZER": "one who literalizes, also LITERALISER [n -S]\n",
  "LITERALIZERS": "LITERALIZER, one who literalizes, also LITERALISER [n]\n",
  "LITERALIZES": "LITERALIZE, to make literal, also LITERALISE [v]\n",
  "LITERALIZING": "LITERALIZE, to make literal, also LITERALISE [v]\n",
  "LITERALLY": "LITERAL, to be taken as read [adv]\n",
  "LITERALNESS": "the state of being literal [n -ES]\n",
  "LITERALNESSES": "LITERALNESS, the state of being literal [n]\n",
  "LITERALS": "LITERAL, a misprint, a typographical error [n]\n",
  "LITERARILY": "LITERARY, pertaining to books and writings [adv]\n",
  "LITERARINESS": "the state of being literary [n -ES]\n",
  "LITERARINESSES": "LITERARINESS, the state of being literary [n]\n",
  "LITERARY": "pertaining to books and writings [adj LITERARILY]\n",
  "LITERARYISM": "a bookish expression [n -S]\n",
  "LITERARYISMS": "LITERARYISM, a bookish expression [n]\n",
  "LITERATE": "able to read and write [adj LITERATELY] / one who can read and write [n -S]\n",
  "LITERATELY": "LITERATE, able to read and write [adv]\n",
  "LITERATENESS": "the state of being literate [n -ES]\n",
  "LITERATENESSES": "LITERATENESS, the state of being literate [n]\n",
  "LITERATES": "LITERATE, one who can read and write [n]\n",
  "LITERATI": "LITERATO, (Italian) a learned man, one acquainted with letters [n]\n",
  "LITERATIM": "(Latin) letter for letter [adv]\n",
  "LITERATION": "representation of sounds by letters [n -S]\n",
  "LITERATIONS": "LITERATION, representation of sounds by letters [n]\n",
  "LITERATO": "(Italian) a learned man, one acquainted with letters [n LITERATI]\n",
  "LITERATOR": "a dabbler in learning [n -S]\n",
  "LITERATORS": "LITERATOR, a dabbler in learning [n]\n",
  "LITERATURE": "the production of literary work esp. as an occupation [n -S]\n",
  "LITERATURED": "(Shakespeare) having literary knowledge [adj]\n",
  "LITERATURES": "LITERATURE, the production of literary work esp. as an occupation [n]\n",
  "LITERATUS": "(Latin) a learned man; a man acquainted with literature [n LITERATI]\n",
  "LITEROSE": "affectedly literary [adj]\n",
  "LITEROSITIES": "LITEROSITY, the quality of being literose [n]\n",
  "LITEROSITY": "the quality of being literose [n LITEROSITIES]\n",
  "LITERS": "LITER, (US) a measure of capacity in the metric system, a cubic decimeter, also LITRE [n]\n",
  "LITES": "LITE, (Spenser) to alight, dismount, also LYTE [v]\n",
  "LITEST": "LITE, of food and drink, low in calories, alcoholic content, etc. [adj]\n",
  "LITH": "(Scots) a joint; specifically the last joint of the finger [n -S]\n",
  "LITHARGE": "a monoxide of lead [n -S]\n",
  "LITHARGES": "LITHARGE, a monoxide of lead [n]\n",
  "LITHATE": "(obsolete) a urate, a salt of uric acid [n -S]\n",
  "LITHATES": "LITHATE, (obsolete) a urate, a salt of uric acid [n]\n",
  "LITHE": "supple [adj LITHER, LITHEST, LITHELY] / to listen [v LITHED, LITHING, LITHES]\n",
  "LITHED": "LITHE, to listen [v]\n",
  "LITHELY": "LITHE, supple [adv]\n",
  "LITHEMIA": "an excess of uric acid in the blood [n -S]\n",
  "LITHEMIAS": "LITHEMIA, an excess of uric acid in the blood [n]\n",
  "LITHEMIC": "relating to lithemia, an excess of uric acid in the blood [adj]\n",
  "LITHENESS": "the state of being lithe [n -ES]\n",
  "LITHENESSES": "LITHENESS, the state of being lithe [n]\n",
  "LITHER": "LITHE, supple [adj]\n",
  "LITHERLY": "(obsolete) mischievous [adj]\n",
  "LITHES": "LITHE, to listen [v]\n",
  "LITHESOME": "easily flexed, lithe, also LISSOM, LISSOME [adj]\n",
  "LITHESOMENESS": "LITHESOME, easily flexed, lithe, also LISSOM, LISSOME [n]\n",
  "LITHESOMENESSES": "LITHESOMENESS, LITHESOME, easily flexed, lithe, also LISSOM, LISSOME [n]\n",
  "LITHEST": "LITHE, supple [adj]\n",
  "LITHIA": "lithium oxide, a strong alkaline caustic [n -S]\n",
  "LITHIAS": "LITHIA, lithium oxide, a strong alkaline caustic [n]\n",
  "LITHIASES": "LITHIASIS, the formation of stony concretions or calculi in any part of the body, esp. in the bladder and urinary passages [n]\n",
  "LITHIASIS": "the formation of stony concretions or calculi in any part of the body, esp. in the bladder and urinary passages [n LITHIASES]\n",
  "LITHIC": "of or pertaining to stone; as, lithic architecture [adj]\n",
  "LITHIFICATION": "the process by which an unconsolidated deposit of sediments is converted in to solid rock [n -S]\n",
  "LITHIFICATIONS": "LITHIFICATION, the process by which an unconsolidated deposit of sediments is converted in to solid rock [n]\n",
  "LITHIFIED": "LITHIFY, to petrify, convert to rock [v]\n",
  "LITHIFIES": "LITHIFY, to petrify, convert to rock [v]\n",
  "LITHIFY": "to petrify, convert to rock [v LITHIFIED, LITHIFYING, LITHIFIES]\n",
  "LITHIFYING": "LITHIFY, to petrify, convert to rock [v]\n",
  "LITHING": "LITHE, to listen [v]\n",
  "LITHISTID": "any of the Lithistida, hard stony sponges [n -S]\n",
  "LITHISTIDS": "LITHISTID, any of the Lithistida, hard stony sponges [n]\n",
  "LITHITE": "a calcareous body secreted by an animal cell [n -S]\n",
  "LITHITES": "LITHITE, a calcareous body secreted by an animal cell [n]\n",
  "LITHIUM": "a metallic element [n -S]\n",
  "LITHIUMS": "LITHIUM, a metallic element [n]\n",
  "LITHO": "(short for) lithograph [n LITHOS] / to make a lithograph [v -ED, -ING, -ES]\n",
  "LITHOCHROMATIC": "relating to lithochromatics [adj]\n",
  "LITHOCHROMATICS": "the art or process of painting in oil on stone and taking impressions from the result [n]\n",
  "LITHOCHROMIES": "LITHOCHROMY, painting upon stone [n]\n",
  "LITHOCHROMY": "painting upon stone [n LITHOCHROMIES]\n",
  "LITHOCLAST": "a stone breaker; a tool for breaking rocks [n -S]\n",
  "LITHOCLASTS": "LITHOCLAST, a stone breaker; a tool for breaking rocks [n]\n",
  "LITHOCYST": "a cell containing a cystolith, a hard mineralized ingrowth of the wall of cells in the epidermis of certain plants [n -S]\n",
  "LITHOCYSTS": "LITHOCYST, a cell containing a cystolith, a hard mineralized ingrowth of the wall of cells in the epidermis of certain plants [n]\n",
  "LITHODOMOUS": "living in burrows in rocks [adj]\n",
  "LITHOED": "LITHO, to make a lithograph [v]\n",
  "LITHOES": "LITHO, to make a lithograph [v]\n",
  "LITHOGENOUS": "rock-building [adj]\n",
  "LITHOGLYPH": "an engraving on stone [n -S]\n",
  "LITHOGLYPHS": "LITHOGLYPH, an engraving on stone [n]\n",
  "LITHOGRAPH": "to produce by lithography [v -ED, -ING, -S]\n",
  "LITHOGRAPHED": "LITHOGRAPH, to produce by lithography [v]\n",
  "LITHOGRAPHER": "one who produces lithographs [n -S]\n",
  "LITHOGRAPHERS": "LITHOGRAPHER, one who produces lithographs [n]\n",
  "LITHOGRAPHIC": "relating to lithography, also LITHOGRAPHICAL [adj]\n",
  "LITHOGRAPHICAL": "relating to lithography, also LITHOGRAPHIC [adj]\n",
  "LITHOGRAPHIES": "LITHOGRAPHY, the process of printing from a plane surface, as a smooth stone or metal plate, on which the image to be printed is ink-receptive and the blank area ink-repellent [n]\n",
  "LITHOGRAPHING": "LITHOGRAPH, to produce by lithography [v]\n",
  "LITHOGRAPHS": "LITHOGRAPH, to produce by lithography [v]\n",
  "LITHOGRAPHY": "the process of printing from a plane surface, as a smooth stone or metal plate, on which the image to be printed is ink-receptive and the blank area ink-repellent [n LITHOGRAPHIES]\n",
  "LITHOID": "like stone, also LITHOIDAL [adj]\n",
  "LITHOIDAL": "like stone, also LITHOID [adj]\n",
  "LITHOING": "LITHO, to make a lithograph [v]\n",
  "LITHOLAPAXIES": "LITHOLAPAXY, the operation of crushing stone in the bladder and working it out [n]\n",
  "LITHOLAPAXY": "the operation of crushing stone in the bladder and working it out [n LITHOLAPAXIES]\n",
  "LITHOLATRIES": "LITHOLATRY, stone-worship [n]\n",
  "LITHOLATROUS": "engaging in litholatry, the worship of stones [adj]\n",
  "LITHOLATRY": "stone-worship [n LITHOLATRIES]\n",
  "LITHOLOGIC": "relating to lithology, the study of rocks, also LITHOLOGICAL [adj LITHOLOGICALLY]\n",
  "LITHOLOGICAL": "relating to lithology, the study of rocks, also LITHOLOGIC [adj LITHOLOGICALLY]\n",
  "LITHOLOGICALLY": "LITHOLOGICAL, relating to lithology, the study of rocks, also LITHOLOGIC [adv]\n",
  "LITHOLOGIES": "LITHOLOGY, the study of rocks [n]\n",
  "LITHOLOGIST": "a student of lithology [n -S]\n",
  "LITHOLOGISTS": "LITHOLOGIST, a student of lithology [n]\n",
  "LITHOLOGY": "the study of rocks [n LITHOLOGIES]\n",
  "LITHOMANCIES": "LITHOMANCY, divination by stones or meteorites [n]\n",
  "LITHOMANCY": "divination by stones or meteorites [n LITHOMANCIES]\n",
  "LITHOMARGE": "a clay of a fine smooth texture, and very sectile [n -S]\n",
  "LITHOMARGES": "LITHOMARGE, a clay of a fine smooth texture, and very sectile [n]\n",
  "LITHOMETEOR": "a mass of solid particles, such as dust, sand, etc., suspended in the atmosphere [n -S]\n",
  "LITHOMETEORS": "LITHOMETEOR, a mass of solid particles, such as dust, sand, etc., suspended in the atmosphere [n]\n",
  "LITHONTHRYPTIC": "a medicine for dissolving kidney stones, also LITHONTRIPTIC, LITHOTRIPTIC [n -S]\n",
  "LITHONTHRYPTICS": "LITHONTHRYPTIC, a medicine for dissolving kidney stones, also LITHONTRIPTIC, LITHOTRIPTIC [n]\n",
  "LITHONTRIPTIC": "a medicine for dissolving kidney stones, also LITHONTHRYPTIC, LITHOTRIPTIC [n -S]\n",
  "LITHONTRIPTICS": "LITHONTRIPTIC, a medicine for dissolving kidney stones, also LITHONTHRYPTIC, LITHOTRIPTIC [n]\n",
  "LITHONTRIPTIST": "a surgeon who performs a lithotripsy [n -S]\n",
  "LITHONTRIPTISTS": "LITHONTRIPTIST, a surgeon who performs a lithotripsy [n]\n",
  "LITHONTRIPTOR": "a device that crushes stones in the bladder by ultrasound, also LITHOTRIPTER, LITHOTRIPTOR, LITHOTRITE, LITHOTRITOR [n -S]\n",
  "LITHONTRIPTORS": "LITHONTRIPTOR, a device that crushes stones in the bladder by ultrasound, also LITHOTRIPTER, LITHOTRIPTOR, LITHOTRITE, LITHOTRITOR [n]\n",
  "LITHOPHAGOUS": "stone-swallowing; rock-boring; eating rock [adj]\n",
  "LITHOPHANE": "porcelain with pictures showing through transparency [n -S]\n",
  "LITHOPHANES": "LITHOPHANE, porcelain with pictures showing through transparency [n]\n",
  "LITHOPHILOUS": "living among stones [adj]\n",
  "LITHOPHYSA": "a bladderlike spherulite, also LITHOPHYSE [n LITHOPHYSAE]\n",
  "LITHOPHYSAE": "LITHOPHYSA, a bladderlike spherulite, also LITHOPHYSE [n]\n",
  "LITHOPHYSE": "a bladderlike spherulite, also LITHOPHYSA [n -S]\n",
  "LITHOPHYSES": "LITHOPHYSE, a bladderlike spherulite, also LITHOPHYSA [n]\n",
  "LITHOPHYTE": "a plant that grows on rock [n -S]\n",
  "LITHOPHYTES": "LITHOPHYTE, a plant that grows on rock [n]\n",
  "LITHOPHYTIC": "of or like a lithophyte, a plant that grows on rock [adj]\n",
  "LITHOPONE": "a white pigment used in paints, consisting of a mixture of zinc sulphide and barium sulphate [n -S]\n",
  "LITHOPONES": "LITHOPONE, a white pigment used in paints, consisting of a mixture of zinc sulphide and barium sulphate [n]\n",
  "LITHOPRINT": "a print made by lithography [n -S]\n",
  "LITHOPRINTS": "LITHOPRINT, a print made by lithography [n]\n",
  "LITHOPS": "a fleshy-leaved plant [n LITHOPS]\n",
  "LITHOS": "LITHO, to make a lithograph [v]\n",
  "LITHOSOL": "a type of soil [n -S]\n",
  "LITHOSOLS": "LITHOSOL, a type of soil [n]\n",
  "LITHOSPERMUM": "a kind of flower [n -S]\n",
  "LITHOSPERMUMS": "LITHOSPERMUM, a kind of flower [n]\n",
  "LITHOSPHERE": "the solid outer portion of the Earth consisting of the crust and upper mantle, approximately 100 km (62 miles) thick [n -S]\n",
  "LITHOSPHERES": "LITHOSPHERE, the solid outer portion of the Earth consisting of the crust and upper mantle, approximately 100 km (62 miles) thick [n]\n",
  "LITHOSPHERIC": "relating to the lithosphere [adj]\n",
  "LITHOSTATIC": "relating to the pressure or stress imposed on a layer of soil or rock by the weight of overlying material [adj]\n",
  "LITHOTOME": "a stone so formed by nature as to appear as if cut by art [n -S]\n",
  "LITHOTOMES": "LITHOTOME, a stone so formed by nature as to appear as if cut by art [n]\n",
  "LITHOTOMIC": "relating to lithotomy, the surgical removal of stones from bodily organs, also LITHOTOMICAL [adj]\n",
  "LITHOTOMICAL": "relating to lithotomy, the surgical removal of stones from bodily organs, also LITHOTOMIC [adj]\n",
  "LITHOTOMIES": "LITHOTOMY, the operation, art, or practice of cutting for stone in the bladder [n]\n",
  "LITHOTOMIST": "a surgeon who practises lithotomy [n -S]\n",
  "LITHOTOMISTS": "LITHOTOMIST, a surgeon who practises lithotomy [n]\n",
  "LITHOTOMOUS": "boring in rocks, as some molluscs [adj]\n",
  "LITHOTOMY": "the operation, art, or practice of cutting for stone in the bladder [n LITHOTOMIES]\n",
  "LITHOTRIPSIES": "LITHOTRIPSY, the surgical operation of crushing a stone in the bladder, kidney or gall bladder, so that its fragments may be passed naturally from the body [n]\n",
  "LITHOTRIPSY": "the surgical operation of crushing a stone in the bladder, kidney or gall bladder, so that its fragments may be passed naturally from the body [n LITHOTRIPSIES]\n",
  "LITHOTRIPTER": "a device that crushes stones in the bladder by ultrasound, also LITHONTRIPTOR, LITHOTRIPTOR, LITHOTRITE, LITHOTRITOR [n -S]\n",
  "LITHOTRIPTERS": "LITHOTRIPTER, a device that crushes stones in the bladder by ultrasound, also LITHONTRIPTOR, LITHOTRIPTOR, LITHOTRITE, LITHOTRITOR [n]\n",
  "LITHOTRIPTIC": "a medicine for dissolving kidney stones, also LITHONTHRYPTIC, LITHONTRIPTIC [n -S]\n",
  "LITHOTRIPTICS": "LITHOTRIPTIC, a medicine for dissolving kidney stones, also LITHONTHRYPTIC, LITHONTRIPTIC [n]\n",
  "LITHOTRIPTIST": "a surgeon who performs a lithotripsy [n -S]\n",
  "LITHOTRIPTISTS": "LITHOTRIPTIST, a surgeon who performs a lithotripsy [n]\n",
  "LITHOTRIPTOR": "a device that crushes stones in the bladder by ultrasound, also LITHONTRIPTOR, LITHOTRIPTER, LITHOTRITE, LITHOTRITOR [n -S]\n",
  "LITHOTRIPTORS": "LITHOTRIPTOR, a device that crushes stones in the bladder by ultrasound, also LITHONTRIPTOR, LITHOTRIPTER, LITHOTRITE, LITHOTRITOR [n]\n",
  "LITHOTRITE": "a device that crushes stones in the bladder by ultrasound, also LITHONTRIPTOR, LITHOTRIPTER, LITHOTRIPTOR, LITHOTRITOR [n -S]\n",
  "LITHOTRITES": "LITHOTRITE, a device that crushes stones in the bladder by ultrasound, also LITHONTRIPTOR, LITHOTRIPTER, LITHOTRIPTOR, LITHOTRITOR [n]\n",
  "LITHOTRITIC": "a medicine for dissolving stones in the bladder [n -S]\n",
  "LITHOTRITICS": "LITHOTRITIC, a medicine for dissolving stones in the bladder [n]\n",
  "LITHOTRITIES": "LITHOTRITY, the operation of breaking a stone in the bladder into small pieces capable of being voided [n]\n",
  "LITHOTRITISE": "to perform a lithotrity, also LITHOTRITIZE [v LITHOTRITISED, LITHOTRITISING, LITHOTRITISES]\n",
  "LITHOTRITISED": "LITHOTRITISE, to perform a lithotrity, also LITHOTRITIZE [v]\n",
  "LITHOTRITISES": "LITHOTRITISE, to perform a lithotrity, also LITHOTRITIZE [v]\n",
  "LITHOTRITISING": "LITHOTRITISE, to perform a lithotrity, also LITHOTRITIZE [v]\n",
  "LITHOTRITIST": "one who performs a lithotrity [n -S]\n",
  "LITHOTRITISTS": "LITHOTRITIST, one who performs a lithotrity [n]\n",
  "LITHOTRITIZE": "to perform a lithotrity, also LITHOTRITISE [v LITHOTRITIZED, LITHOTRITIZING, LITHOTRITIZES]\n",
  "LITHOTRITIZED": "LITHOTRITIZE, to perform a lithotrity, also LITHOTRITISE [v]\n",
  "LITHOTRITIZES": "LITHOTRITIZE, to perform a lithotrity, also LITHOTRITISE [v]\n",
  "LITHOTRITIZING": "LITHOTRITIZE, to perform a lithotrity, also LITHOTRITISE [v]\n",
  "LITHOTRITOR": "a device that crushes stones in the bladder, also LITHONTRIPTOR, LITHOTRIPTER, LITHOTRIPTOR, LITHOTRITE [n -S]\n",
  "LITHOTRITORS": "LITHOTRITOR, a device that crushes stones in the bladder, also LITHONTRIPTOR, LITHOTRIPTER, LITHOTRIPTOR, LITHOTRITE [n]\n",
  "LITHOTRITY": "the operation of breaking a stone in the bladder into small pieces capable of being voided [n LITHOTRITIES]\n",
  "LITHOTYPE": "an etched stone surface for printing a design in relief; an imprint made from it [n -S]\n",
  "LITHOTYPES": "LITHOTYPE, an etched stone surface for printing a design in relief; an imprint made from it [n]\n",
  "LITHS": "LITH, (Scots) a joint; specifically the last joint of the finger [n]\n",
  "LITIGABLE": "such as can be litigated [adj]\n",
  "LITIGANT": "one who is engaged in a lawsuit [n -S]\n",
  "LITIGANTS": "LITIGANT, one who is engaged in a lawsuit [n]\n",
  "LITIGATE": "to subject to legal proceedings [v LITIGATED, LITIGATING, LITIGATES]\n",
  "LITIGATED": "LITIGATE, to subject to legal proceedings [v]\n",
  "LITIGATES": "LITIGATE, to subject to legal proceedings [v]\n",
  "LITIGATING": "LITIGATE, to subject to legal proceedings [v]\n",
  "LITIGATION": "the act of litigating [n -S]\n",
  "LITIGATIONS": "LITIGATION, the act of litigating [n]\n",
  "LITIGATOR": "one who litigates [n -S]\n",
  "LITIGATORS": "LITIGATOR, one who litigates [n]\n",
  "LITIGIOUS": "having ready recourse to litigation [adj LITIGIOUSLY]\n",
  "LITIGIOUSLY": "LITIGIOUS, having ready recourse to litigation [adv]\n",
  "LITIGIOUSNESS": "the state of being litigious [n -ES]\n",
  "LITIGIOUSNESSES": "LITIGIOUSNESS, the state of being litigious [n]\n",
  "LITING": "LITE, (Spenser) to alight, dismount, also LYTE [v]\n",
  "LITMUS": "(Old Norse) a substance that changes colour with acidity, also LACMUS [n -ES]\n",
  "LITMUSES": "LITMUS, (Old Norse) a substance that changes colour with acidity, also LACMUS [n]\n",
  "LITORAL": "pertaining to or on the seashore, also LITTORAL [adj]\n",
  "LITOTES": "(Latin) the expression of an affirmative by the negative of the contrary, e.g. not a little angry [n LITOTES]\n",
  "LITOTIC": "of or like litotes, expressing an affirmative by the negative of the contrary [adj]\n",
  "LITRE": "a unit of capacity, also LITER [n -S]\n",
  "LITREAGE": "volume in litres [n -S]\n",
  "LITREAGES": "LITREAGE, volume in litres [n]\n",
  "LITRES": "LITRE, a unit of capacity, also LITER [n]\n",
  "LITS": "LIT, a former monetary unit of Lithuania, also LITAS [n]\n",
  "LITTEN": "LET, to allow [v]\n",
  "LITTER": "to scatter rubbish about [v -ED, -ING, -S]\n",
  "LITTERATEUR": "(French) one who is devoted to the study or writing of literature [n -S]\n",
  "LITTERATEURS": "LITTERATEUR, (French) one who is devoted to the study or writing of literature [n]\n",
  "LITTERBAG": "a bag for litter [n -S]\n",
  "LITTERBAGS": "LITTERBAG, a bag for litter [n]\n",
  "LITTERBUG": "someone who creates litter [n -S]\n",
  "LITTERBUGS": "LITTERBUG, someone who creates litter [n]\n",
  "LITTERED": "LITTER, to scatter rubbish about [v]\n",
  "LITTERER": "one who litters [n -S]\n",
  "LITTERERS": "LITTERER, one who litters [n]\n",
  "LITTERIER": "LITTERY, covered or encumbered with litter [adj]\n",
  "LITTERIEST": "LITTERY, covered or encumbered with litter [adj]\n",
  "LITTERING": "LITTER, to scatter rubbish about [v]\n",
  "LITTERMATE": "one who shares the same litter [n -S]\n",
  "LITTERMATES": "LITTERMATE, one who shares the same litter [n]\n",
  "LITTERS": "LITTER, to scatter rubbish about [v]\n",
  "LITTERY": "covered or encumbered with litter [adj LITTERIER, LITTERIEST]\n",
  "LITTLE": "small [adj LITTLER, LITTLEST] / a small amount [n -S]\n",
  "LITTLENECK": "a young quahog suitable to be eaten raw [n -S]\n",
  "LITTLENECKS": "LITTLENECK, a young quahog suitable to be eaten raw [n]\n",
  "LITTLENESS": "the quality of being little [n -ES]\n",
  "LITTLENESSES": "LITTLENESS, the quality of being little [n]\n",
  "LITTLER": "LITTLE, small [adj]\n",
  "LITTLES": "LITTLE, a small amount [n]\n",
  "LITTLEST": "LITTLE, small [adj]\n",
  "LITTLEWORTH": "(archaic) worthless [adj]\n",
  "LITTLIE": "(Australian slang) a young child, also LITTLIN, LITTLING [n -S]\n",
  "LITTLIES": "LITTLIE, (Australian slang) a young child, also LITTLIN, LITTLING [n]\n",
  "LITTLIN": "(Scots) a child, also LITTLIE, LITTLING [n -S]\n",
  "LITTLING": "(Scots) a child, also LITTLIE, LITTLIN [n -S]\n",
  "LITTLINGS": "LITTLING, (Scots) a child, also LITTLIE, LITTLIN [n]\n",
  "LITTLINS": "LITTLIN, (Scots) a child, also LITTLIE, LITTLING [n]\n",
  "LITTLISH": "somewhat little [adj]\n",
  "LITTORAL": "pertaining to or on the seashore, also LITORAL [adj] / a shore region [n -S]\n",
  "LITTORALS": "LITTORAL, a shore region [n]\n",
  "LITU": "LITAS, a former monetary unit of Lithuania, also LIT [n]\n",
  "LITURGIC": "pertaining to, of or the nature of, a liturgy, also LITURGICAL [adj LITURGICALLY]\n",
  "LITURGICAL": "pertaining to, of or the nature of, a liturgy, also LITURGIC [adj LITURGICALLY]\n",
  "LITURGICALLY": "LITURGICAL, pertaining to, of or the nature of, a liturgy, also LITURGIC [adv]\n",
  "LITURGICS": "the branch of knowledge that deals with liturgies, their form, origin, etc. [n]\n",
  "LITURGIES": "LITURGY, (Greek) a prescribed system of public worship [n]\n",
  "LITURGIOLOGIES": "LITURGIOLOGY, the study of liturgical forms and church rituals [n]\n",
  "LITURGIOLOGIST": "one who studies liturgiology [n -S]\n",
  "LITURGIOLOGISTS": "LITURGIOLOGIST, one who studies liturgiology [n]\n",
  "LITURGIOLOGY": "the study of liturgical forms and church rituals [n LITURGIOLOGIES]\n",
  "LITURGISM": "the study of liturgical forms [n -S]\n",
  "LITURGISMS": "LITURGISM, the study of liturgical forms [n]\n",
  "LITURGIST": "a leader in public worship [n -S]\n",
  "LITURGISTIC": "relating to a liturgist [adj]\n",
  "LITURGISTS": "LITURGIST, a leader in public worship [n]\n",
  "LITURGY": "(Greek) a prescribed system of public worship [n LITURGIES]\n",
  "LITUUS": "(Latin) a J-shaped Roman trumpet [n -ES]\n",
  "LITUUSES": "LITUUS, (Latin) a J-shaped Roman trumpet [n]\n",
  "LIVABILITIES": "LIVABILITY, the quality of being livable, also LIVEABILITY [n]\n",
  "LIVABILITY": "the quality of being livable, also LIVEABILITY [n LIVABILITIES]\n",
  "LIVABLE": "suitable for living in, also LIVEABLE [adj]\n",
  "LIVABLENESS": "the state of being livable, also LIVEABLENESS [n -ES]\n",
  "LIVABLENESSES": "LIVABLENESS, the state of being livable, also LIVEABLENESS [n]\n",
  "LIVE": "to function as a living thing [v LIVED, LIVING, LIVES] / having life [adj LIVER, LIVEST, LIVELY]\n",
  "LIVEABILITIES": "LIVEABILITY, the quality of being liveable, also LIVABILITY [n]\n",
  "LIVEABILITY": "the quality of being liveable, also LIVABILITY [n LIVEABILITIES]\n",
  "LIVEABLE": "suitable for living in, also LIVABLE [adj]\n",
  "LIVEABLENESS": "the state of being liveable, also LIVABLENESS [n -ES]\n",
  "LIVEABLENESSES": "LIVEABLENESS, the state of being liveable, also LIVABLENESS [n]\n",
  "LIVEBLOG": "to keep a blog in which an event is described as it is taking place [v LIVEBLOGGED, LIVEBLOGGING, LIVEBLOGS]\n",
  "LIVEBLOGGED": "LIVEBLOG, to keep a blog in which an event is described as it is taking place [v]\n",
  "LIVEBLOGGER": "one who keeps a liveblog [n -S]\n",
  "LIVEBLOGGERS": "LIVEBLOGGER, one who keeps a liveblog [n]\n",
  "LIVEBLOGGING": "the act of keeping a liveblog [n -S]\n",
  "LIVEBLOGGINGS": "LIVEBLOGGING, the act of keeping a liveblog [n]\n",
  "LIVEBLOGS": "LIVEBLOG, to keep a blog in which an event is described as it is taking place [v]\n",
  "LIVED": "LIVE, to function as a living thing [v]\n",
  "LIVEDO": "(Latin) a discoloured patch on the skin [n -S]\n",
  "LIVEDOS": "LIVEDO, (Latin) a discoloured patch on the skin [n]\n",
  "LIVELIER": "LIVELY, full of energy [adj]\n",
  "LIVELIEST": "LIVELY, full of energy [adj]\n",
  "LIVELIHEAD": "(obsolete) liveliness [n -S]\n",
  "LIVELIHEADS": "LIVELIHEAD, (obsolete) liveliness [n]\n",
  "LIVELIHOOD": "means of support or subsistence [n -S]\n",
  "LIVELIHOODS": "LIVELIHOOD, means of support or subsistence [n]\n",
  "LIVELILY": "LIVELY, full of energy [adv]\n",
  "LIVELINESS": "the state of being lively [n -ES]\n",
  "LIVELINESSES": "LIVELINESS, the state of being lively [n]\n",
  "LIVELOD": "(Spenser) livelihood, also LIVELOOD [n -S]\n",
  "LIVELODS": "LIVELOD, (Spenser) livelihood, also LIVELOOD [n]\n",
  "LIVELONG": "whole or entire (referring to time) [adj] / a kind of stonecrop, aka orpine [n -S]\n",
  "LIVELONGS": "LIVELONG, a kind of stonecrop, aka orpine [n]\n",
  "LIVELOOD": "(Spenser) livelihood, also LIVELOD [n -S]\n",
  "LIVELOODS": "LIVELOOD, (Spenser) livelihood, also LIVELOD [n]\n",
  "LIVELY": "full of energy [adj LIVELIER, LIVELIEST, LIVELILY]\n",
  "LIVEN": "to make lively [v -ED, -ING, -S]\n",
  "LIVENED": "LIVEN, to make lively [v]\n",
  "LIVENER": "one who livens [n -S]\n",
  "LIVENERS": "LIVENER, one who livens [n]\n",
  "LIVENESS": "the quality of being live [n -ES]\n",
  "LIVENESSES": "LIVENESS, the quality of being live [n]\n",
  "LIVENING": "LIVEN, to make lively [v]\n",
  "LIVENS": "LIVEN, to make lively [v]\n",
  "LIVER": "a secreting organ [n -S] / to thicken or gel [v -ED, -ING, -S]\n",
  "LIVERED": "LIVER, to thicken or gel [v]\n",
  "LIVERIED": "attired in livery [adj]\n",
  "LIVERIES": "LIVERY, the identifying uniform, badge, etc. of a member of a guild or one of the servants of a feudal lord [n]\n",
  "LIVERING": "the act of thickening or gelling [n -S]\n",
  "LIVERINGS": "LIVERING, the act of thickening or gelling [n]\n",
  "LIVERISH": "having a liver disorder [adj LIVERISHLY]\n",
  "LIVERISHLY": "LIVERISH, having a liver disorder [adv]\n",
  "LIVERISHNESS": "the state of being liverish [n -ES]\n",
  "LIVERISHNESSES": "LIVERISHNESS, the state of being liverish [n]\n",
  "LIVERLEAF": "a woodland plant [n LIVERLEAVES]\n",
  "LIVERLEAVES": "LIVERLEAF, a woodland plant [n]\n",
  "LIVERLESS": "without a liver [adj]\n",
  "LIVERMORIUM": "a transuranic element produced by bombarding curium with calcium-20 ions [n -S]\n",
  "LIVERMORIUMS": "LIVERMORIUM, a transuranic element produced by bombarding curium with calcium-20 ions [n]\n",
  "LIVERS": "LIVER, to thicken or gel [v]\n",
  "LIVERWORT": "any bryophyte of the class Hepaticae, with a capsule splitting open into four valves [n -S]\n",
  "LIVERWORTS": "LIVERWORT, any bryophyte of the class Hepaticae, with a capsule splitting open into four valves [n]\n",
  "LIVERWURST": "liver sausage [n -S]\n",
  "LIVERWURSTS": "LIVERWURST, liver sausage [n]\n",
  "LIVERY": "the identifying uniform, badge, etc. of a member of a guild or one of the servants of a feudal lord [n LIVERIES]\n",
  "LIVERYMAN": "one who wears a livery, as a servant [n LIVERYMEN]\n",
  "LIVERYMEN": "LIVERYMAN, one who wears a livery, as a servant [n]\n",
  "LIVES": "LIVE, to function as a living thing [v]\n",
  "LIVEST": "LIVE, having life [adj]\n",
  "LIVESTOCK": "domestic animals, esp. horses, cattle, sheep and pigs [n -S]\n",
  "LIVESTOCKS": "LIVESTOCK, domestic animals, esp. horses, cattle, sheep and pigs [n]\n",
  "LIVESTREAM": "to broadcast (an event) on the internet as it happens [v -ED, -ING, -S]\n",
  "LIVESTREAMED": "LIVESTREAM, to broadcast (an event) on the internet as it happens [v]\n",
  "LIVESTREAMING": "LIVESTREAM, to broadcast (an event) on the internet as it happens [v]\n",
  "LIVESTREAMS": "LIVESTREAM, to broadcast (an event) on the internet as it happens [v]\n",
  "LIVETRAP": "to capture in a type of animal trap [v LIVETRAPPED, LIVETRAPPING, LIVETRAPS]\n",
  "LIVETRAPPED": "LIVETRAP, to capture in a type of animal trap [v]\n",
  "LIVETRAPPING": "LIVETRAP, to capture in a type of animal trap [v]\n",
  "LIVETRAPS": "LIVETRAP, to capture in a type of animal trap [v]\n",
  "LIVEWARE": "(colloquial) all the people working on a computer system [n -S]\n",
  "LIVEWARES": "LIVEWARE, (colloquial) all the people working on a computer system [n]\n",
  "LIVEWELL": "a container of water in a boat for keeping fish alive [n -S]\n",
  "LIVEWELLS": "LIVEWELL, a container of water in a boat for keeping fish alive [n]\n",
  "LIVEYER": "a permanent resident of Newfoundland, also LIVYER, LIVEYERE, LIVIER [n -S]\n",
  "LIVEYERE": "a permanent resident of Newfoundland, also LIVYER, LIVEYER, LIVIER [n -S]\n",
  "LIVEYERES": "LIVEYERE, a permanent resident of Newfoundland, also LIVYER, LIVEYER, LIVIER [n]\n",
  "LIVEYERS": "LIVEYER, a permanent resident of Newfoundland, also LIVYER, LIVEYERE, LIVIER [n]\n",
  "LIVID": "of bluish leaden colour; very angry [adj LIVIDER, LIVIDEST, LIVIDLY]\n",
  "LIVIDER": "LIVID, of bluish leaden colour; very angry [adj]\n",
  "LIVIDEST": "LIVID, of bluish leaden colour; very angry [adj]\n",
  "LIVIDITIES": "LIVIDITY, the state of being livid [n]\n",
  "LIVIDITY": "the state of being livid [n LIVIDITIES]\n",
  "LIVIDLY": "LIVID, of bluish leaden colour; very angry [adv]\n",
  "LIVIDNESS": "the state of being livid [n -ES]\n",
  "LIVIDNESSES": "LIVIDNESS, the state of being livid [n]\n",
  "LIVIER": "a permanent resident of Newfoundland, also LIVYER, LIVEYERE, LIVEYER [n -S]\n",
  "LIVIERS": "LIVIER, a permanent resident of Newfoundland, also LIVYER, LIVEYERE, LIVEYER [n]\n",
  "LIVING": "a means of subsistence [n -S]\n",
  "LIVINGLY": "LIVING [adv]\n",
  "LIVINGNESS": "the state of being alive [n -ES]\n",
  "LIVINGNESSES": "LIVINGNESS, the state of being alive [n]\n",
  "LIVINGS": "LIVING, a means of subsistence [n]\n",
  "LIVOR": "lividness of colour [n -S]\n",
  "LIVORS": "LIVOR, lividness of colour [n]\n",
  "LIVRAISON": "(French) a part of a book or literary composition printed and delivered by itself [n -S]\n",
  "LIVRAISONS": "LIVRAISON, (French) a part of a book or literary composition printed and delivered by itself [n]\n",
  "LIVRE": "(French) a former monetary unit of France [n -S]\n",
  "LIVRES": "LIVRE, (French) a former monetary unit of France [n]\n",
  "LIVYER": "a permanent resident of Newfoundland, also LIVEYER, LIVEYERE, LIVIER [n -S]\n",
  "LIVYERS": "LIVYER, a permanent resident of Newfoundland, also LIVEYER, LIVEYERE, LIVIER [n]\n",
  "LIXIVIA": "LIXIVIUM, (Latin) a solution of alkaline salts extracted from wood ashes; hence, any solution obtained by lixiviation [n]\n",
  "LIXIVIAL": "impregnated with a salt or salts like a lixivium [adj]\n",
  "LIXIVIATE": "to separate by washing with solvent; to treat with lye, etc. [v LIXIVIATED, LIXIVIATING, LIXIVIATES]\n",
  "LIXIVIATED": "LIXIVIATE, to separate by washing with solvent; to treat with lye, etc. [v]\n",
  "LIXIVIATES": "LIXIVIATE, to separate by washing with solvent; to treat with lye, etc. [v]\n",
  "LIXIVIATING": "LIXIVIATE, to separate by washing with solvent; to treat with lye, etc. [v]\n",
  "LIXIVIATION": "the separation of a substance into soluble and insoluble constituents by percolation of liquid, usually water [n -S]\n",
  "LIXIVIATIONS": "LIXIVIATION, the separation of a substance into soluble and insoluble constituents by percolation of liquid, usually water [n]\n",
  "LIXIVIOUS": "impregnated with a salt or salts like a lixivium [adj]\n",
  "LIXIVIUM": "(Latin) a solution of alkaline salts extracted from wood ashes; hence, any solution obtained by lixiviation [n LIXIVIA or LIXIVIUMS]\n",
  "LIXIVIUMS": "LIXIVIUM, (Latin) a solution of alkaline salts extracted from wood ashes; hence, any solution obtained by lixiviation [n]\n",
  "LIZARD": "any of a suborder of scaly reptiles [n -S]\n",
  "LIZARDS": "LIZARD, any of a suborder of scaly reptiles [n]\n",
  "LIZZIE": "as in tin lizzie, an old car [n -S]\n",
  "LIZZIES": "LIZZIE, as in tin lizzie, an old car [n]\n",
  "LLAMA": "(Quechua) a South American cud-chewing mammal which belongs to the same family as camels but is smaller and humpless [n -S]\n",
  "LLAMAS": "LLAMA, (Quechua) a South American cud-chewing mammal which belongs to the same family as camels but is smaller and humpless [n]\n",
  "LLANERO": "(Spanish) an inhabitant of the llanos of South America [n -S]\n",
  "LLANEROS": "LLANERO, (Spanish) an inhabitant of the llanos of South America [n]\n",
  "LLANO": "(Spanish) an open, grassy plain [n -S]\n",
  "LLANOS": "LLANO, (Spanish) an open, grassy plain [n]\n",
  "LO": "(archaic) an interjection meaning see, look [interj]\n",
  "LOACH": "a freshwater fish [n -ES]\n",
  "LOACHES": "LOACH, a freshwater fish [n]\n",
  "LOAD": "to place goods or cargo on transportation, also LADE, LADEN, LAID, LOADEN [v -ED, -ING, -S]\n",
  "LOADABLE": "that can be loaded [adj]\n",
  "LOADED": "LOAD, to place goods or cargo on transportation, also LADE, LADEN, LAID, LOADEN [v]\n",
  "LOADEN": "(archaic) to load, also LADE, LADEN, LAID [v -ED, -ING, -S]\n",
  "LOADENED": "LOADEN, (archaic) to load, also LADE, LADEN, LAID [v]\n",
  "LOADENING": "LOADEN, (archaic) to load, also LADE, LADEN, LAID [v]\n",
  "LOADENS": "LOADEN, (archaic) to load, also LADE, LADEN, LAID [v]\n",
  "LOADER": "one that loads [n -S]\n",
  "LOADERS": "LOADER, one that loads [n]\n",
  "LOADING": "a burden [n -S]\n",
  "LOADINGS": "LOADING, a burden [n]\n",
  "LOADMASTER": "a member of an aircrew who is in charge of the cargo [n -S]\n",
  "LOADMASTERS": "LOADMASTER, a member of an aircrew who is in charge of the cargo [n]\n",
  "LOADS": "LOAD, to place goods or cargo on transportation, also LADE, LADEN, LAID, LOADEN [v]\n",
  "LOADSAMONEY": "wealth accumulated as a result of the economic boom of the 1980s [n LOADSAMONEYS or LOADSAMONIES]\n",
  "LOADSAMONEYS": "LOADSAMONEY, wealth accumulated as a result of the economic boom of the 1980s [n]\n",
  "LOADSAMONIES": "LOADSAMONEY, wealth accumulated as a result of the economic boom of the 1980s [n]\n",
  "LOADSPACE": "the space available in a vehicle for loading [n -S]\n",
  "LOADSPACES": "LOADSPACE, the space available in a vehicle for loading [n]\n",
  "LOADSTAR": "a star used as a point of reference, also LODESTAR [n -S]\n",
  "LOADSTARS": "LOADSTAR, a star used as a point of reference, also LODESTAR [n]\n",
  "LOADSTONE": "magnetite that is naturally magnetized; a piece of this used as a magnet, also LODESTONE [n -S]\n",
  "LOADSTONES": "LOADSTONE, magnetite that is naturally magnetized; a piece of this used as a magnet, also LODESTONE [n]\n",
  "LOAF": "to pass time idly [v -ED, -ING, -S] / a portion of baked bread [n LOAVES]\n",
  "LOAFED": "LOAF, to pass time idly [v]\n",
  "LOAFER": "a lazy person; a shoe like a moccasin for casual wear [n -S]\n",
  "LOAFERISH": "like a loafer, an idle person [adj]\n",
  "LOAFERS": "LOAFER, a lazy person; a shoe like a moccasin for casual wear [n]\n",
  "LOAFING": "the act of idling [n -S]\n",
  "LOAFINGS": "LOAFING, the act of idling [n]\n",
  "LOAFS": "LOAF, to pass time idly [v]\n",
  "LOAM": "a soil consisting of a natural mixture of clay and sand, with animal and vegetable matter [n -S] / to cover with loam [v -ED, -ING, -S]\n",
  "LOAMED": "LOAM, to cover with loam [v]\n",
  "LOAMIER": "LOAMY, resembling loam [adj]\n",
  "LOAMIEST": "LOAMY, resembling loam [adj]\n",
  "LOAMINESS": "the state of being loamy [n -ES]\n",
  "LOAMINESSES": "LOAMINESS, the state of being loamy [n]\n",
  "LOAMING": "LOAM, to cover with loam [v]\n",
  "LOAMLESS": "having no loam [adj]\n",
  "LOAMS": "LOAM, to cover with loam [v]\n",
  "LOAMY": "resembling loam [adj LOAMIER, LOAMIEST]\n",
  "LOAN": "to lend [v -ED, -ING, -S]\n",
  "LOANABLE": "able to be loaned [adj]\n",
  "LOANBACK": "a system operated by some life assurance companies whereby the assured may borrow back some of the money he has invested [n -S]\n",
  "LOANBACKS": "LOANBACK, a system operated by some life assurance companies whereby the assured may borrow back some of the money he has invested [n]\n",
  "LOANED": "LOAN, to lend [v]\n",
  "LOANEE": "a person who receives a loan; a sportsperson who is loaned from one organization to another [n -S]\n",
  "LOANEES": "LOANEE, a person who receives a loan; a sportsperson who is loaned from one organization to another [n]\n",
  "LOANER": "one who loans [n -S]\n",
  "LOANERS": "LOANER, one who loans [n]\n",
  "LOANING": "(Scots) a lane, an open space for passage between fields of corn; a place for milking cows [n -S]\n",
  "LOANINGS": "LOANING, (Scots) a lane, an open space for passage between fields of corn; a place for milking cows [n]\n",
  "LOANS": "LOAN, to lend [v]\n",
  "LOANSHIFT": "the adaptation of a word from one language to another [n -S]\n",
  "LOANSHIFTS": "LOANSHIFT, the adaptation of a word from one language to another [n]\n",
  "LOANWORD": "a word taken from another language [n -S]\n",
  "LOANWORDS": "LOANWORD, a word taken from another language [n]\n",
  "LOAST": "LOOSE, to set free, also LOWSE [v]\n",
  "LOATH": "unwilling, also LAITH, LOTH [adj LOATHER, LOATHEST]\n",
  "LOATHE": "to detest greatly [v LOATHED, LOATHING, LOATHES]\n",
  "LOATHED": "LOATHE, to detest greatly [v]\n",
  "LOATHEDNESS": "the state of being loathed [n -ES]\n",
  "LOATHEDNESSES": "LOATHEDNESS, the state of being loathed [n]\n",
  "LOATHER": "one who loathes [n -S]\n",
  "LOATHERS": "LOATHER, one who loathes [n]\n",
  "LOATHES": "LOATHE, to detest greatly [v]\n",
  "LOATHEST": "LOATH, unwilling, also LAITH, LOTH [adj]\n",
  "LOATHFUL": "full of loathing, also LOTHEFULL, LOTHFULL [adj]\n",
  "LOATHFULNESS": "the state of being loathful [n -ES]\n",
  "LOATHFULNESSES": "LOATHFULNESS, the state of being loathful [n]\n",
  "LOATHING": "hating [adj LOATHINGLY] / extreme dislike [n -S]\n",
  "LOATHINGLY": "LOATHING, hating [adv]\n",
  "LOATHINGS": "LOATHING, extreme dislike [n]\n",
  "LOATHLIER": "LOATHLY, (archaic) hideous, loathsome, also LAIDLY, LAITHLY [adj]\n",
  "LOATHLIEST": "LOATHLY, (archaic) hideous, loathsome, also LAIDLY, LAITHLY [adj]\n",
  "LOATHLINESS": "the state of being loathly [n -ES]\n",
  "LOATHLINESSES": "LOATHLINESS, the state of being loathly [n]\n",
  "LOATHLY": "(archaic) hideous, loathsome, also LAIDLY, LAITHLY [adj LOATHLIER, LOATHLIEST]\n",
  "LOATHNESS": "unwillingness, reluctance [n -ES]\n",
  "LOATHNESSES": "LOATHNESS, unwillingness, reluctance [n]\n",
  "LOATHSOME": "abhorrent, also LOTHSOME [adj LOATHSOMELY]\n",
  "LOATHSOMELY": "LOATHSOME, abhorrent, also LOTHSOME [adv]\n",
  "LOATHSOMENESS": "LOATHSOME, abhorrent, also LOTHSOME [n]\n",
  "LOATHSOMENESSES": "LOATHSOMENESS, LOATHSOME, abhorrent, also LOTHSOME [n]\n",
  "LOATHY": "(archaic) loathsome [adj]\n",
  "LOAVE": "to form a head as in a cabbage [v LOAVED, LOAVING, LOAVES]\n",
  "LOAVED": "LOAVE, to form a head as in a cabbage [v]\n",
  "LOAVES": "LOAVE, to form a head as in a cabbage [v]\n",
  "LOAVING": "LOAVE, to form a head as in a cabbage [v]\n",
  "LOB": "to hit a ball in a high arc [v LOBBED, LOBBING, LOBS]\n",
  "LOBAR": "of or relating to a lobe [adj]\n",
  "LOBATE": "having lobes, also LOBATED [adj LOBATELY]\n",
  "LOBATED": "having lobes, also LOBATE [adj]\n",
  "LOBATELY": "LOBATE, having lobes, also LOBATED [adv]\n",
  "LOBATION": "the formation of lobes [n -S]\n",
  "LOBATIONS": "LOBATION, the formation of lobes [n]\n",
  "LOBBED": "LOB, to hit a ball in a high arc [v]\n",
  "LOBBER": "one who lobs [n -S]\n",
  "LOBBERS": "LOBBER, one who lobs [n]\n",
  "LOBBIED": "LOBBY, to seek to influence (members of a house of legislature) in the exercise of legislative functions [v]\n",
  "LOBBIES": "LOBBY, to seek to influence (members of a house of legislature) in the exercise of legislative functions [v]\n",
  "LOBBING": "LOB, to hit a ball in a high arc [v]\n",
  "LOBBY": "to seek to influence (members of a house of legislature) in the exercise of legislative functions [v LOBBIED, LOBBYING, LOBBIES]\n",
  "LOBBYER": "one who lobbies, also LOBBYIST [n -S]\n",
  "LOBBYERS": "LOBBYER, one who lobbies, also LOBBYIST [n]\n",
  "LOBBYGOW": "an errand boy [n -S]\n",
  "LOBBYGOWS": "LOBBYGOW, an errand boy [n]\n",
  "LOBBYING": "the act of lobbying [n -S]\n",
  "LOBBYINGS": "LOBBYING, the act of lobbying [n]\n",
  "LOBBYISM": "the practice of lobbying [n -S]\n",
  "LOBBYISMS": "LOBBYISM, the practice of lobbying [n]\n",
  "LOBBYIST": "one who lobbies, also LOBBYER [n -S]\n",
  "LOBBYISTS": "LOBBYIST, one who lobbies, also LOBBYER [n]\n",
  "LOBE": "a rounded, projecting anatomical part [n -S] / to divide into lobes [v LOBED, LOBING, LOBES]\n",
  "LOBECTOMIES": "LOBECTOMY, the surgical excision of a lobe [n]\n",
  "LOBECTOMY": "the surgical excision of a lobe [n LOBECTOMIES]\n",
  "LOBED": "LOBE, to divide into lobes [v]\n",
  "LOBEFIN": "a type of fish to which the coelacanth belongs [n -S]\n",
  "LOBEFINS": "LOBEFIN, a type of fish to which the coelacanth belongs [n]\n",
  "LOBELESS": "without lobes [adj]\n",
  "LOBELET": "a small lobe [n -S]\n",
  "LOBELETS": "LOBELET, a small lobe [n]\n",
  "LOBELIA": "a flowering plant [n -S]\n",
  "LOBELIAS": "LOBELIA, a flowering plant [n]\n",
  "LOBELIKE": "like a lobe [adj]\n",
  "LOBELINE": "a poisonous alkaloid obtained from Lobelia inflata, used as a respiratory stimulant and to discourage tobacco-smoking [n -S]\n",
  "LOBELINES": "LOBELINE, a poisonous alkaloid obtained from Lobelia inflata, used as a respiratory stimulant and to discourage tobacco-smoking [n]\n",
  "LOBES": "LOBE, to divide into lobes [v]\n",
  "LOBI": "LOBUS, (Latin) a lobe [n]\n",
  "LOBING": "a division into lobes [n -S]\n",
  "LOBINGS": "LOBING, a division into lobes [n]\n",
  "LOBIPED": "having lobate feet [adj]\n",
  "LOBLOLLIES": "LOBLOLLY, a pine tree [n]\n",
  "LOBLOLLY": "a pine tree [n LOBLOLLIES]\n",
  "LOBO": "the timber wolf [n -S]\n",
  "LOBOLA": "an African custom whereby the bridegroom's family makes a payment in cattle or cash to the bride's family before marriage, also LOBOLO [n -S]\n",
  "LOBOLAS": "LOBOLA, an African custom whereby the bridegroom's family makes a payment in cattle or cash to the bride's family before marriage, also LOBOLO [n]\n",
  "LOBOLO": "an African custom whereby the bridegroom's family makes a payment in cattle or cash to the bride's family before marriage, also LOBOLA [n -S]\n",
  "LOBOLOS": "LOBOLO, an African custom whereby the bridegroom's family makes a payment in cattle or cash to the bride's family before marriage, also LOBOLA [n]\n",
  "LOBOS": "LOBO, the timber wolf [n]\n",
  "LOBOSE": "having a lobe [adj]\n",
  "LOBOTOMIES": "LOBOTOMY, a type of surgical operation [n]\n",
  "LOBOTOMISE": "to carry out a lobotomy, also LOBOTOMIZE [v LOBOTOMISED, LOBOTOMISING, LOBOTOMISES]\n",
  "LOBOTOMISED": "LOBOTOMISE, to carry out a lobotomy, also LOBOTOMIZE [v]\n",
  "LOBOTOMISES": "LOBOTOMISE, to carry out a lobotomy, also LOBOTOMIZE [v]\n",
  "LOBOTOMISING": "LOBOTOMISE, to carry out a lobotomy, also LOBOTOMIZE [v]\n",
  "LOBOTOMIZE": "to carry out a lobotomy, also LOBOTOMISE [v LOBOTOMIZED, LOBOTOMIZING, LOBOTOMIZES]\n",
  "LOBOTOMIZED": "LOBOTOMIZE, to carry out a lobotomy, also LOBOTOMISE [v]\n",
  "LOBOTOMIZES": "LOBOTOMIZE, to carry out a lobotomy, also LOBOTOMISE [v]\n",
  "LOBOTOMIZING": "LOBOTOMIZE, to carry out a lobotomy, also LOBOTOMISE [v]\n",
  "LOBOTOMY": "a type of surgical operation [n LOBOTOMIES]\n",
  "LOBS": "LOB, to hit a ball in a high arc [v]\n",
  "LOBSCOUSE": "a sailor's dish prepared by stewing or baking bits of meat with vegetables [n -S]\n",
  "LOBSCOUSES": "LOBSCOUSE, a sailor's dish prepared by stewing or baking bits of meat with vegetables [n]\n",
  "LOBSTER": "a large strong-clawed edible crustacean [n -S] / to fish for lobsters [v -ED, -ING, -S]\n",
  "LOBSTERED": "LOBSTER, to fish for lobsters [v]\n",
  "LOBSTERER": "a person who catches lobsters [n -S]\n",
  "LOBSTERERS": "LOBSTERER, a person who catches lobsters [n]\n",
  "LOBSTERING": "fishing for lobsters [n -S]\n",
  "LOBSTERINGS": "LOBSTERING, fishing for lobsters [n]\n",
  "LOBSTERLIKE": "like a lobster [adj]\n",
  "LOBSTERMAN": "a fisherman who catches lobsters [n LOBSTERMEN]\n",
  "LOBSTERMEN": "LOBSTERMAN, a fisherman who catches lobsters [n]\n",
  "LOBSTERS": "LOBSTER, to fish for lobsters [v]\n",
  "LOBSTICK": "(Canadian) a tree with its lower branches trimmed, also LOPSTICK [n -S]\n",
  "LOBSTICKS": "LOBSTICK, (Canadian) a tree with its lower branches trimmed, also LOPSTICK [n]\n",
  "LOBTAIL": "of a whale, to slap its tail against the surface of the water [v -ED, -ING, -S]\n",
  "LOBTAILED": "LOBTAIL, of a whale, to slap its tail against the surface of the water [v]\n",
  "LOBTAILING": "the slapping of a whale's tail against the surface of the water [n -S]\n",
  "LOBTAILINGS": "LOBTAILING, the slapping of a whale's tail against the surface of the water [n]\n",
  "LOBTAILS": "LOBTAIL, of a whale, to slap its tail against the surface of the water [v]\n",
  "LOBULAR": "shaped like a lobe [adj LOBULARLY]\n",
  "LOBULARLY": "LOBULAR, shaped like a lobe [adv]\n",
  "LOBULATE": "having lobules, also LOBULATED, LOBULOSE [adj]\n",
  "LOBULATED": "having lobules, also LOBULATE, LOBULOSE [adj]\n",
  "LOBULATION": "the state of being lobulate [n -S]\n",
  "LOBULATIONS": "LOBULATION, the state of being lobulate [n]\n",
  "LOBULE": "a small lobe, also LOBULUS [n -S]\n",
  "LOBULES": "LOBULE, a small lobe, also LOBULUS [n]\n",
  "LOBULI": "LOBULUS, (Latin) a small lobe or lobe-like structure, also LOBULE [n]\n",
  "LOBULOSE": "having lobules, also LOBULATE, LOBULATED [adj]\n",
  "LOBULUS": "(Latin) a small lobe or lobe-like structure, also LOBULE [n LOBULI]\n",
  "LOBUS": "(Latin) a lobe [n LOBI]\n",
  "LOBWORM": "a burrowing marine worm, also LUGWORM [n -S]\n",
  "LOBWORMS": "LOBWORM, a burrowing marine worm, also LUGWORM [n]\n",
  "LOCA": "LOCUS, (Latin) a place, a locality [n]\n",
  "LOCAL": "from the immediate area [adj LOCALLY] / a person belonging to a particular place [n -S]\n",
  "LOCALE": "(French) a place, position or district, also LOCALITY [n -S]\n",
  "LOCALES": "LOCALE, (French) a place, position or district, also LOCALITY [n]\n",
  "LOCALISABILITY": "the state of being localisable, also LOCALIZABILITY [n]\n",
  "LOCALISABLE": "able to be localised, also LOCALIZABLE [adj]\n",
  "LOCALISATION": "the act of localising, also LOCALIZATION [n -S]\n",
  "LOCALISATIONS": "LOCALISATION, the act of localising, also LOCALIZATION [n]\n",
  "LOCALISE": "to confine or limit to a certain place, also LOCALIZE [v LOCALISED, LOCALISING, LOCALISES]\n",
  "LOCALISED": "LOCALISE, to confine or limit to a certain place, also LOCALIZE [v]\n",
  "LOCALISER": "one who localises, also LOCALIZER [n -S]\n",
  "LOCALISERS": "LOCALISER, one who localises, also LOCALIZER [n]\n",
  "LOCALISES": "LOCALISE, to confine or limit to a certain place, also LOCALIZE [v]\n",
  "LOCALISING": "LOCALISE, to confine or limit to a certain place, also LOCALIZE [v]\n",
  "LOCALISM": "a custom peculiar to a locality [n -S]\n",
  "LOCALISMS": "LOCALISM, a custom peculiar to a locality [n]\n",
  "LOCALIST": "one preoccupied with local concerns [n -S]\n",
  "LOCALISTIC": "having localism [adj]\n",
  "LOCALISTS": "LOCALIST, one preoccupied with local concerns [n]\n",
  "LOCALITE": "a resident of a locality [n -S]\n",
  "LOCALITES": "LOCALITE, a resident of a locality [n]\n",
  "LOCALITIES": "LOCALITY, a place, position or district, also LOCALE [n]\n",
  "LOCALITY": "a place, position or district, also LOCALE [n LOCALITIES]\n",
  "LOCALIZABILITY": "the state of being localizable, also LOCALISABILITY [n]\n",
  "LOCALIZABLE": "able to be localized, also LOCALISABLE [adj]\n",
  "LOCALIZATION": "the act of localizing, also LOCALISATION [n -S]\n",
  "LOCALIZATIONS": "LOCALIZATION, the act of localizing, also LOCALISATION [n]\n",
  "LOCALIZE": "to confine or limit to a certain place, also LOCALISE [v LOCALIZED, LOCALIZING, LOCALIZES]\n",
  "LOCALIZED": "LOCALIZE, to confine or limit to a certain place, also LOCALISE [v]\n",
  "LOCALIZER": "one who localises, also LOCALISER [n -S]\n",
  "LOCALIZERS": "LOCALIZER, one who localises, also LOCALISER [n]\n",
  "LOCALIZES": "LOCALIZE, to confine or limit to a certain place, also LOCALISE [v]\n",
  "LOCALIZING": "LOCALIZE, to confine or limit to a certain place, also LOCALISE [v]\n",
  "LOCALLY": "LOCAL, from the immediate area [adv]\n",
  "LOCALNESS": "the state of being local [n -ES]\n",
  "LOCALNESSES": "LOCALNESS, the state of being local [n]\n",
  "LOCALS": "LOCAL, a person belonging to a particular place [n]\n",
  "LOCATABLE": "that can be located, also LOCATEABLE [adj]\n",
  "LOCATE": "to find or pinpoint [v LOCATED, LOCATING, LOCATES]\n",
  "LOCATEABLE": "that can be located, also LOCATABLE [adj]\n",
  "LOCATED": "LOCATE, to find or pinpoint [v]\n",
  "LOCATER": "one who locates, or is entitled to locate, land or a mining claim, also LOCATOR [n -S]\n",
  "LOCATERS": "LOCATER, one who locates, or is entitled to locate, land or a mining claim, also LOCATOR [n]\n",
  "LOCATES": "LOCATE, to find or pinpoint [v]\n",
  "LOCATING": "LOCATE, to find or pinpoint [v]\n",
  "LOCATION": "the position in a particular place [n -S]\n",
  "LOCATIONAL": "relating to location [adj LOCATIONALLY]\n",
  "LOCATIONALLY": "LOCATIONAL, relating to location [adv]\n",
  "LOCATIONS": "LOCATION, the position in a particular place [n]\n",
  "LOCATIVE": "a grammatical case signifying place where [n -S]\n",
  "LOCATIVES": "LOCATIVE, a grammatical case signifying place where [n]\n",
  "LOCATOR": "one who locates, or is entitled to locate, land or a mining claim, also LOCATER [n -S]\n",
  "LOCATORS": "LOCATOR, one who locates, or is entitled to locate, land or a mining claim, also LOCATER [n]\n",
  "LOCAVORE": "a person who will eat only food produced locally [n -S]\n",
  "LOCAVORES": "LOCAVORE, a person who will eat only food produced locally [n]\n",
  "LOCELLATE": "divided into small compartments [adj]\n",
  "LOCH": "(Scots) a lake [n -S]\n",
  "LOCHAN": "(Gaelic) a small lake [n -S]\n",
  "LOCHANS": "LOCHAN, (Gaelic) a small lake [n]\n",
  "LOCHE": "a fish of the cod family [n -S]\n",
  "LOCHES": "LOCHE, a fish of the cod family [n]\n",
  "LOCHIA": "(Greek) the discharge from the womb and vagina which follows childbirth [n -S]\n",
  "LOCHIAL": "of or pertaining to the lochia, the discharge from the womb and vagina which follows childbirth [adj]\n",
  "LOCHIAS": "LOCHIA, (Greek) the discharge from the womb and vagina which follows childbirth [n]\n",
  "LOCHS": "LOCH, (Scots) a lake [n]\n",
  "LOCI": "an engine used in logging, also LOCIE [n -S]\n",
  "LOCIE": "an engine used in logging, also LOCI [n -S]\n",
  "LOCIES": "LOCIE, an engine used in logging, also LOCI [n]\n",
  "LOCIS": "LOCI, an engine used in logging, also LOCIE [n]\n",
  "LOCK": "to secure with a fastening device [v -ED, -ING, -S]\n",
  "LOCKABLE": "able to be locked [adj]\n",
  "LOCKAGE": "the toll on a ship passing through a lock [n -S]\n",
  "LOCKAGES": "LOCKAGE, the toll on a ship passing through a lock [n]\n",
  "LOCKAWAY": "in finance, a long-term security [n -S]\n",
  "LOCKAWAYS": "LOCKAWAY, in finance, a long-term security [n]\n",
  "LOCKBOX": "a box that locks [n -ES]\n",
  "LOCKBOXES": "LOCKBOX, a box that locks [n]\n",
  "LOCKDOWN": "the confinement of prisoners to their cells [n -S]\n",
  "LOCKDOWNS": "LOCKDOWN, the confinement of prisoners to their cells [n]\n",
  "LOCKED": "LOCK, to secure with a fastening device [v]\n",
  "LOCKER": "a small cupboard for securing valuables [n -S]\n",
  "LOCKERS": "LOCKER, a small cupboard for securing valuables [n]\n",
  "LOCKET": "a small ornamental case, usually on a necklace or chain, that holds a picture, keepsake, etc. [n -S]\n",
  "LOCKETS": "LOCKET, a small ornamental case, usually on a necklace or chain, that holds a picture, keepsake, etc. [n]\n",
  "LOCKFAST": "secured by locks [adj]\n",
  "LOCKFUL": "enough to fill a canal lock [n -S]\n",
  "LOCKFULS": "LOCKFUL, enough to fill a canal lock [n]\n",
  "LOCKHOUSE": "a lockkeeper's house [n -S]\n",
  "LOCKHOUSES": "LOCKHOUSE, a lockkeeper's house [n]\n",
  "LOCKING": "the act of locking [n -S]\n",
  "LOCKINGS": "LOCKING, the act of locking [n]\n",
  "LOCKJAW": "a form of tetanus [n -S]\n",
  "LOCKJAWS": "LOCKJAW, a form of tetanus [n]\n",
  "LOCKKEEPER": "a person in charge of a lock (as on a canal) [n -S]\n",
  "LOCKKEEPERS": "LOCKKEEPER, a person in charge of a lock (as on a canal) [n]\n",
  "LOCKLESS": "without a lock [adj]\n",
  "LOCKMAKER": "one who makes locks [n -S]\n",
  "LOCKMAKERS": "LOCKMAKER, one who makes locks [n]\n",
  "LOCKMAN": "a lockkeeper; a public executioner [n LOCKMEN]\n",
  "LOCKMEN": "LOCKMAN, a lockkeeper; a public executioner [n]\n",
  "LOCKNUT": "a nut which prevents another from loosening [n -S]\n",
  "LOCKNUTS": "LOCKNUT, a nut which prevents another from loosening [n]\n",
  "LOCKOUT": "the locking out of employees in an industrial dispute [n -S]\n",
  "LOCKOUTS": "LOCKOUT, the locking out of employees in an industrial dispute [n]\n",
  "LOCKPICK": "an instrument for picking locks, also PICKLOCK [n -S]\n",
  "LOCKPICKS": "LOCKPICK, an instrument for picking locks, also PICKLOCK [n]\n",
  "LOCKRAM": "a coarse linen fabric [n -S]\n",
  "LOCKRAMS": "LOCKRAM, a coarse linen fabric [n]\n",
  "LOCKS": "LOCK, to secure with a fastening device [v]\n",
  "LOCKSET": "a set of hardware for locking a door [n -S]\n",
  "LOCKSETS": "LOCKSET, a set of hardware for locking a door [n]\n",
  "LOCKSMAN": "a turnkey; a lockkeeper [n LOCKSMEN]\n",
  "LOCKSMEN": "LOCKSMAN, a turnkey; a lockkeeper [n]\n",
  "LOCKSMITH": "one who makes locks and keys [n -S]\n",
  "LOCKSMITHERIES": "LOCKSMITHERY, the craft of the locksmith [n]\n",
  "LOCKSMITHERY": "the craft of the locksmith [n LOCKSMITHERIES]\n",
  "LOCKSMITHING": "the work or business of a locksmith [n -S]\n",
  "LOCKSMITHINGS": "LOCKSMITHING, the work or business of a locksmith [n]\n",
  "LOCKSMITHS": "LOCKSMITH, one who makes locks and keys [n]\n",
  "LOCKSTEP": "a method of marching in tight formation [n -S]\n",
  "LOCKSTEPS": "LOCKSTEP, a method of marching in tight formation [n]\n",
  "LOCKSTITCH": "a sewing-machine stitch formed by the locking of two threads together [n -ES] / to sew by lockstitch [v -ED, -ING, -ES]\n",
  "LOCKSTITCHED": "LOCKSTITCH, to sew by lockstitch [v]\n",
  "LOCKSTITCHES": "LOCKSTITCH, a sewing-machine stitch formed by the locking of two threads together [n]\n",
  "LOCKSTITCHING": "LOCKSTITCH, to sew by lockstitch [v]\n",
  "LOCKUP": "a jail [n -S]\n",
  "LOCKUPS": "LOCKUP, a jail [n]\n",
  "LOCO": "a locomotive [n -S] / to poison with locoweed [v -ED, -ING, -S]\n",
  "LOCOED": "LOCO, to poison with locoweed [v]\n",
  "LOCOES": "LOCO, to poison with locoweed [v]\n",
  "LOCOFOCO": "(Spanish) a match or cigar which can be lit by friction on any rough surface [n -S]\n",
  "LOCOFOCOS": "LOCOFOCO, (Spanish) a match or cigar which can be lit by friction on any rough surface [n]\n",
  "LOCOING": "LOCO, to poison with locoweed [v]\n",
  "LOCOISM": "a disease of livestock, caused by ingestion of locoweed [n -S]\n",
  "LOCOISMS": "LOCOISM, a disease of livestock, caused by ingestion of locoweed [n]\n",
  "LOCOMAN": "a railway engine driver [n LOCOMEN]\n",
  "LOCOMEN": "LOCOMAN, a railway engine driver [n]\n",
  "LOCOMOBILE": "an early automobile [n -S]\n",
  "LOCOMOBILES": "LOCOMOBILE, an early automobile [n]\n",
  "LOCOMOBILITIES": "LOCOMOBILITY, having the power of changing places [n]\n",
  "LOCOMOBILITY": "having the power of changing places [n LOCOMOBILITIES]\n",
  "LOCOMOTE": "to move about [v LOCOMOTED, LOCOMOTING, LOCOMOTES]\n",
  "LOCOMOTED": "LOCOMOTE, to move about [v]\n",
  "LOCOMOTES": "LOCOMOTE, to move about [v]\n",
  "LOCOMOTING": "LOCOMOTE, to move about [v]\n",
  "LOCOMOTION": "an act or the power of moving from place to place [n -S]\n",
  "LOCOMOTIONS": "LOCOMOTION, an act or the power of moving from place to place [n]\n",
  "LOCOMOTIVE": "moving from place to place [adj LOCOMOTIVELY] / a self-propelled vehicle that runs on rails and is used for moving railroad cars [n -S]\n",
  "LOCOMOTIVELY": "LOCOMOTIVE, moving from place to place [adv]\n",
  "LOCOMOTIVENESS": "LOCOMOTIVE, moving from place to place [n]\n",
  "LOCOMOTIVES": "LOCOMOTIVE, a self-propelled vehicle that runs on rails and is used for moving railroad cars [n]\n",
  "LOCOMOTIVITIES": "LOCOMOTIVITY, the state of being locomotive [n]\n",
  "LOCOMOTIVITY": "the state of being locomotive [n LOCOMOTIVITIES]\n",
  "LOCOMOTOR": "a muscle involved in movement or locomotion [n -S]\n",
  "LOCOMOTORS": "LOCOMOTOR, a muscle involved in movement or locomotion [n]\n",
  "LOCOMOTORY": "relating to locomotion [adj]\n",
  "LOCOPLANT": "astragalus or other related plant, that drives cattle mad, also LOCOWEED [n -S]\n",
  "LOCOPLANTS": "LOCOPLANT, astragalus or other related plant, that drives cattle mad, also LOCOWEED [n]\n",
  "LOCORESTIVE": "(Lamb) staying in one place [adj]\n",
  "LOCOS": "LOCO, to poison with locoweed [v]\n",
  "LOCOWEED": "astragalus or other related plant, that drives cattle mad, also LOCOPLANT [n -S]\n",
  "LOCOWEEDS": "LOCOWEED, astragalus or other related plant, that drives cattle mad, also LOCOPLANT [n]\n",
  "LOCULAMENT": "the cell of a pericarp in which the seed is lodged [n -S]\n",
  "LOCULAMENTS": "LOCULAMENT, the cell of a pericarp in which the seed is lodged [n]\n",
  "LOCULAR": "of e.g. an ovary, divided into compartments by septa, also LOCULATE, LOCULATED [adj]\n",
  "LOCULATE": "of e.g. an ovary, divided into compartments by septa, also LOCULAR, LOCULATED [adj]\n",
  "LOCULATED": "of e.g. an ovary, divided into compartments by septa, also LOCULAR, LOCULATE [adj]\n",
  "LOCULATION": "the state of being locular [n -S]\n",
  "LOCULATIONS": "LOCULATION, the state of being locular [n]\n",
  "LOCULE": "a small, cell-like chamber, also LOCULUS [n -S]\n",
  "LOCULED": "having loculi, small hollows [adj]\n",
  "LOCULES": "LOCULE, a small, cell-like chamber, also LOCULUS [n]\n",
  "LOCULI": "LOCULUS, (Latin) a small, cell-like chamber, also LOCULE [n]\n",
  "LOCULICIDAL": "dehiscing along the back of the carpel [adj]\n",
  "LOCULUS": "(Latin) a small, cell-like chamber, also LOCULE [n LOCULI]\n",
  "LOCUM": "(Latin) a temporary substitute [n -S]\n",
  "LOCUMS": "LOCUM, (Latin) a temporary substitute [n]\n",
  "LOCUPLETE": "well-stored, rich [adj]\n",
  "LOCUS": "(Latin) a place, a locality [n LOCI or LOCA]\n",
  "LOCUST": "any of numerous orthopterous insects of the genus Locusta [n -S] / to lay waste like a locust [v -ED, -ING, -S]\n",
  "LOCUSTA": "(Latin) the spikelet or flower cluster of grasses [n LOCUSTAE]\n",
  "LOCUSTAE": "LOCUSTA, (Latin) the spikelet or flower cluster of grasses [n]\n",
  "LOCUSTAL": "of or like a locusta, the spikelet or flower cluster of grasses [adj]\n",
  "LOCUSTED": "LOCUST, to lay waste like a locust [v]\n",
  "LOCUSTING": "LOCUST, to lay waste like a locust [v]\n",
  "LOCUSTS": "LOCUST, to lay waste like a locust [v]\n",
  "LOCUTION": "a style of speech, idiom [n -S]\n",
  "LOCUTIONARY": "of or relating to an utterance [adj]\n",
  "LOCUTIONS": "LOCUTION, a style of speech, idiom [n]\n",
  "LOCUTORIES": "LOCUTORY, a room in a monastery [n]\n",
  "LOCUTORY": "a room in a monastery [n LOCUTORIES]\n",
  "LOD": "the logarithm of the odds, used in statistics [n -S]\n",
  "LODE": "a deposit of valuable ore occurring between definite limits in the surrounding rock [n -S]\n",
  "LODEN": "(German) a thick waterproof woollen cloth [n -S]\n",
  "LODENS": "LODEN, (German) a thick waterproof woollen cloth [n]\n",
  "LODES": "LODE, a deposit of valuable ore occurring between definite limits in the surrounding rock [n]\n",
  "LODESMAN": "a pilot [n LODESMEN]\n",
  "LODESMEN": "LODESMAN, a pilot [n]\n",
  "LODESTAR": "a star used as a point of reference, also LOADSTAR [n -S]\n",
  "LODESTARS": "LODESTAR, a star used as a point of reference, also LOADSTAR [n]\n",
  "LODESTONE": "magnetite that is naturally magnetized; a piece of this used as a magnet, also LOADSTONE [n -S]\n",
  "LODESTONES": "LODESTONE, magnetite that is naturally magnetized; a piece of this used as a magnet, also LOADSTONE [n]\n",
  "LODGE": "to provide temporary accommodation [v LODGED, LODGING, LODGES]\n",
  "LODGEABLE": "that can be lodged [adj]\n",
  "LODGED": "LODGE, to provide temporary accommodation [v]\n",
  "LODGEMENT": "the act of lodging, or the state of being lodged, also LODGMENT [n -S]\n",
  "LODGEMENTS": "LODGEMENT, the act of lodging, or the state of being lodged, also LODGMENT [n]\n",
  "LODGEPOLE": "a pole used in the construction of a Native American lodge [n -S]\n",
  "LODGEPOLES": "LODGEPOLE, a pole used in the construction of a Native American lodge [n]\n",
  "LODGER": "one who stays in rented accommodation [n -S]\n",
  "LODGERS": "LODGER, one who stays in rented accommodation [n]\n",
  "LODGES": "LODGE, to provide temporary accommodation [v]\n",
  "LODGING": "a temporary place to live, also LODGMENT [n -S]\n",
  "LODGINGS": "LODGING, a temporary place to live, also LODGMENT [n]\n",
  "LODGMENT": "a temporary place to live, also LODGING [n -S]\n",
  "LODGMENTS": "LODGMENT, a temporary place to live, also LODGING [n]\n",
  "LODICULA": "(Latin) a small scale in a grass flower, also LODICULE [n LODICULAE]\n",
  "LODICULAE": "LODICULA, (Latin) a small scale in a grass flower, also LODICULE [n]\n",
  "LODICULE": "a small scale in a grass flower, also LODICULA [n -S]\n",
  "LODICULES": "LODICULE, a small scale in a grass flower, also LODICULA [n]\n",
  "LODS": "LOD, the logarithm of the odds, used in statistics [n]\n",
  "LOERIE": "a type of African bird with crimson or grey plumage, also LORY, LOURIE, LOWRIE, LOWRY [n -S]\n",
  "LOERIES": "LOERIE, a type of African bird with crimson or grey plumage, also LORY, LOURIE, LOWRIE, LOWRY [n]\n",
  "LOESS": "(German) a fine-grained wind deposit of clay, sand, and silt [n -ES]\n",
  "LOESSAL": "relating to loess, a fine-grained wind deposit of clay, sand, and silt, also LOESSIAL, LOESSIC [adj]\n",
  "LOESSES": "LOESS, (German) a fine-grained wind deposit of clay, sand, and silt [n]\n",
  "LOESSIAL": "relating to loess, a fine-grained wind deposit of clay, sand, and silt, also LOESSAL, LOESSIC [adj]\n",
  "LOESSIC": "of or relating to loess, also LOESSAL, LOESSIAL [adj]\n",
  "LOFT": "to propel high into the air [v -ED, -ING, -S]\n",
  "LOFTED": "LOFT, to propel high into the air [v]\n",
  "LOFTER": "a type of golf club [n -S]\n",
  "LOFTERS": "LOFTER, a type of golf club [n]\n",
  "LOFTIER": "LOFTY, very high [adj]\n",
  "LOFTIEST": "LOFTY, very high [adj]\n",
  "LOFTILY": "LOFTY, very high [adv]\n",
  "LOFTINESS": "the state of being lofty [n -ES]\n",
  "LOFTINESSES": "LOFTINESS, the state of being lofty [n]\n",
  "LOFTING": "LOFT, to propel high into the air [v]\n",
  "LOFTLESS": "without a high room [adj]\n",
  "LOFTLIKE": "like a loft [adj]\n",
  "LOFTS": "LOFT, to propel high into the air [v]\n",
  "LOFTSMAN": "someone who makes a 1:1 model from draughtsman's plans [n LOFTSMEN]\n",
  "LOFTSMEN": "LOFTSMAN, someone who makes a 1:1 model from draughtsman's plans [n]\n",
  "LOFTY": "very high [adj LOFTIER, LOFTIEST, LOFTILY]\n",
  "LOG": "to fell timber [v LOGGED, LOGGING, LOGS]\n",
  "LOGAGRAPHIA": "the inability to express ideas in writing [n -S]\n",
  "LOGAGRAPHIAS": "LOGAGRAPHIA, the inability to express ideas in writing [n]\n",
  "LOGAN": "a rocking-stone [n -S]\n",
  "LOGANBERRIES": "LOGANBERRY, a hybrid between a raspberry and a Pacific coast blackberry [n]\n",
  "LOGANBERRY": "a hybrid between a raspberry and a Pacific coast blackberry [n LOGANBERRIES]\n",
  "LOGANIA": "any of a family of Australian plants related to the gentians [n -S]\n",
  "LOGANIACEOUS": "belonging to the Loganiaceae, a tropical and subtropical family of plants that includes nux vomica, pinkroot, and gelsemium [adj]\n",
  "LOGANIAS": "LOGANIA, any of a family of Australian plants related to the gentians [n]\n",
  "LOGANS": "LOGAN, a rocking-stone [n]\n",
  "LOGAOEDIC": "combining dactyls with trochees [adj] / a verse in this form [n -S]\n",
  "LOGAOEDICS": "LOGAOEDIC, a verse in this form [n]\n",
  "LOGARITHM": "a mathematical operation used esp. before electronic computing, to simplify multiplication and division [n -S]\n",
  "LOGARITHMIC": "of or like a logarithm, also LOGARITHMICAL [adj LOGARITHMICALLY]\n",
  "LOGARITHMICAL": "of or like a logarithm, also LOGARITHMIC [adj LOGARITHMICALLY]\n",
  "LOGARITHMICALLY": "LOGARITHMICAL, of or like a logarithm, also LOGARITHMIC [adv]\n",
  "LOGARITHMS": "LOGARITHM, a mathematical operation used esp. before electronic computing, to simplify multiplication and division [n]\n",
  "LOGBOARD": "a hinged board containing notes for a logbook [n -S]\n",
  "LOGBOARDS": "LOGBOARD, a hinged board containing notes for a logbook [n]\n",
  "LOGBOOK": "an official record book of a ship's progress [n -S]\n",
  "LOGBOOKS": "LOGBOOK, an official record book of a ship's progress [n]\n",
  "LOGE": "(French) a small enclosure or box in a theatre or opera house [n -S]\n",
  "LOGES": "LOGE, (French) a small enclosure or box in a theatre or opera house [n]\n",
  "LOGGAT": "a small log or piece of wood [n -S]\n",
  "LOGGATS": "LOGGAT, a small log or piece of wood [n]\n",
  "LOGGED": "LOG, to fell timber [v]\n",
  "LOGGER": "one who fells timber for a living [n -S]\n",
  "LOGGERHEAD": "a large-headed sea turtle [n -S]\n",
  "LOGGERHEADED": "like a loggerhead or dunce [adj]\n",
  "LOGGERHEADS": "LOGGERHEAD, a large-headed sea turtle [n]\n",
  "LOGGERS": "LOGGER, one who fells timber for a living [n]\n",
  "LOGGETS": "an old English throwing game, aka ninepins [n]\n",
  "LOGGIA": "(Italian) an open-sided gallery or arcade [n LOGGIAS or LOGGIE]\n",
  "LOGGIAS": "LOGGIA, (Italian) an open-sided gallery or arcade [n]\n",
  "LOGGIE": "LOGGIA, (Italian) an open-sided gallery or arcade [n]\n",
  "LOGGIER": "LOGGY, sluggish, also LOGY [adj]\n",
  "LOGGIEST": "LOGGY, sluggish, also LOGY [adj]\n",
  "LOGGING": "the business of cutting down trees for timber [n -S]\n",
  "LOGGINGS": "LOGGING, the business of cutting down trees for timber [n]\n",
  "LOGGISH": "like a log [adj]\n",
  "LOGGY": "sluggish, also LOGY [adj LOGGIER, LOGGIEST]\n",
  "LOGIA": "LOGION, (Greek) a saying attributed to Jesus [n]\n",
  "LOGIC": "the science of reasoning correctly [n -S]\n",
  "LOGICAL": "pertaining to logic [adj LOGICALLY]\n",
  "LOGICALITIES": "LOGICALITY, logicalness [n]\n",
  "LOGICALITY": "logicalness [n LOGICALITIES]\n",
  "LOGICALLY": "LOGICAL, pertaining to logic [adv]\n",
  "LOGICALNESS": "the state of being logical [n -ES]\n",
  "LOGICALNESSES": "LOGICALNESS, the state of being logical [n]\n",
  "LOGICIAN": "one who is skilled in logic [n -S]\n",
  "LOGICIANS": "LOGICIAN, one who is skilled in logic [n]\n",
  "LOGICISE": "to reason, also LOGICIZE [v LOGICISED, LOGICISING, LOGICISES]\n",
  "LOGICISED": "LOGICISE, to reason, also LOGICIZE [v]\n",
  "LOGICISES": "LOGICISE, to reason, also LOGICIZE [v]\n",
  "LOGICISING": "LOGICISE, to reason, also LOGICIZE [v]\n",
  "LOGICISM": "Frege's theory that underlying mathematics is a purely logical set of axioms [n -S]\n",
  "LOGICISMS": "LOGICISM, Frege's theory that underlying mathematics is a purely logical set of axioms [n]\n",
  "LOGICIST": "a believer in logicism, Frege's theory that underlying mathematics is a purely logical set of axioms [n -S]\n",
  "LOGICISTS": "LOGICIST, a believer in logicism, Frege's theory that underlying mathematics is a purely logical set of axioms [n]\n",
  "LOGICIZE": "to reason, also LOGICISE [v LOGICIZED, LOGICIZING, LOGICIZES]\n",
  "LOGICIZED": "LOGICIZE, to reason, also LOGICISE [v]\n",
  "LOGICIZES": "LOGICIZE, to reason, also LOGICISE [v]\n",
  "LOGICIZING": "LOGICIZE, to reason, also LOGICISE [v]\n",
  "LOGICLESS": "without logic [adj]\n",
  "LOGICS": "LOGIC, the science of reasoning correctly [n]\n",
  "LOGIE": "the space in front of a kiln fire [n -S]\n",
  "LOGIER": "LOGY, sluggish, also LOGGY [adj]\n",
  "LOGIES": "LOGIE, the space in front of a kiln fire [n]\n",
  "LOGIEST": "LOGY, sluggish, also LOGGY [adj]\n",
  "LOGILY": "LOGY, sluggish, also LOGGY [adv]\n",
  "LOGIN": "access to a mainframe or server system, also LOGON [n -S]\n",
  "LOGINESS": "the state of being logy, heavy or dull in respect to motion or thought [n -ES]\n",
  "LOGINESSES": "LOGINESS, the state of being logy, heavy or dull in respect to motion or thought [n]\n",
  "LOGINS": "LOGIN, access to a mainframe or server system, also LOGON [n]\n",
  "LOGION": "(Greek) a saying attributed to Jesus [n LOGIONS or LOGIA]\n",
  "LOGIONS": "LOGION, (Greek) a saying attributed to Jesus [n]\n",
  "LOGISTIC": "relating to reasoning or calculation [adj]\n",
  "LOGISTICAL": "logical [adj LOGISTICALLY]\n",
  "LOGISTICALLY": "LOGISTICAL, logical [adv]\n",
  "LOGISTICIAN": "a person skilled in logistics [n -S]\n",
  "LOGISTICIANS": "LOGISTICIAN, a person skilled in logistics [n]\n",
  "LOGISTICS": "the science of the movement, supplying, and maintenance of military forces in the field [n]\n",
  "LOGJAM": "a tangled mass of logs, any blockage [n -S] / to cause a logjam [v LOGJAMMED, LOGJAMMING, LOGJAMS]\n",
  "LOGJAMMED": "LOGJAM, to cause a logjam [v]\n",
  "LOGJAMMING": "the act of creating a logjam [n -S]\n",
  "LOGJAMMINGS": "LOGJAMMING, the act of creating a logjam [n]\n",
  "LOGJAMS": "LOGJAM, to cause a logjam [v]\n",
  "LOGJUICE": "(slang) bad port wine, as if coloured with logwood [n -S]\n",
  "LOGJUICES": "LOGJUICE, (slang) bad port wine, as if coloured with logwood [n]\n",
  "LOGLINE": "a line for finding the speed of a vessel [n -S]\n",
  "LOGLINES": "LOGLINE, a line for finding the speed of a vessel [n]\n",
  "LOGLOG": "the logarithm of a logarithm, also LOLOG [n -S]\n",
  "LOGLOGS": "LOGLOG, the logarithm of a logarithm, also LOLOG [n]\n",
  "LOGNORMAL": "relating to or being a normal distribution that is the distribution of the logarithm of a random variable [adj LOGNORMALLY]\n",
  "LOGNORMALITIES": "LOGNORMALITY, being lognormal [n]\n",
  "LOGNORMALITY": "being lognormal [n LOGNORMALITIES]\n",
  "LOGNORMALLY": "LOGNORMAL, relating to or being a normal distribution that is the distribution of the logarithm of a random variable [adv]\n",
  "LOGO": "a small design used as the symbol of an organisation etc. [n -S]\n",
  "LOGOCENTRISM": "a philosophy holding that all forms of thought are based on an external point of reference which is held to exist and given a certain degree of authority [n -S]\n",
  "LOGOCENTRISMS": "LOGOCENTRISM, a philosophy holding that all forms of thought are based on an external point of reference which is held to exist and given a certain degree of authority [n]\n",
  "LOGODAEDALIC": "skilled in the manipulative use of words [adj]\n",
  "LOGODAEDALIES": "LOGODAEDALY, verbal legerdemain, esp. in the imaginative or capricious coining of new words [n]\n",
  "LOGODAEDALUS": "one skilled in the manipulative use of words [n -ES]\n",
  "LOGODAEDALUSES": "LOGODAEDALUS, one skilled in the manipulative use of words [n]\n",
  "LOGODAEDALY": "verbal legerdemain, esp. in the imaginative or capricious coining of new words [n LOGODAEDALIES]\n",
  "LOGOED": "having a logo [adj]\n",
  "LOGOFF": "exit from a mainframe or server system, also LOGOUT [n -S]\n",
  "LOGOFFS": "LOGOFF, exit from a mainframe or server system, also LOGOUT [n]\n",
  "LOGOGRAM": "a written symbol representing an entire spoken word without expressing its pronunciation, also LOGOGRAPH [n -S]\n",
  "LOGOGRAMMATIC": "relating to a logogram [adj]\n",
  "LOGOGRAMS": "LOGOGRAM, a written symbol representing an entire spoken word without expressing its pronunciation, also LOGOGRAPH [n]\n",
  "LOGOGRAPH": "a written symbol representing an entire spoken word without expressing its pronunciation, also LOGOGRAM [n -S]\n",
  "LOGOGRAPHER": "a person who writes speeches or chronicles historical events [n -S]\n",
  "LOGOGRAPHERS": "LOGOGRAPHER, a person who writes speeches or chronicles historical events [n]\n",
  "LOGOGRAPHIC": "relating to logography, a method of printing in which whole words or syllables, cast as single types, are used, also LOGOGRAPHICAL [adj LOGOGRAPHICALLY]\n",
  "LOGOGRAPHICAL": "relating to logography, a method of printing in which whole words or syllables, cast as single types, are used, also LOGOGRAPHIC [adj LOGOGRAPHICALLY]\n",
  "LOGOGRAPHICALLY": "LOGOGRAPHICAL, relating to logography, a method of printing in which whole words or syllables, cast as single types, are used, also LOGOGRAPHIC [adv]\n",
  "LOGOGRAPHIES": "LOGOGRAPHY, a method of printing in which whole words or syllables, cast as single types, are used [n]\n",
  "LOGOGRAPHS": "LOGOGRAPH, a written symbol representing an entire spoken word without expressing its pronunciation, also LOGOGRAM [n]\n",
  "LOGOGRAPHY": "a method of printing in which whole words or syllables, cast as single types, are used [n LOGOGRAPHIES]\n",
  "LOGOGRIPH": "a riddle in which a word is found from other words' letters [n -S]\n",
  "LOGOGRIPHIC": "like a logogriph, a riddle in which a word is found from other words' letters [adj]\n",
  "LOGOGRIPHS": "LOGOGRIPH, a riddle in which a word is found from other words' letters [n]\n",
  "LOGOI": "LOGOS, (Greek) the rational principle that governs the universe in Greek philosophy [n]\n",
  "LOGOMACH": "one given to arguing about words [n -S]\n",
  "LOGOMACHIES": "LOGOMACHY, a dispute about words; controversy marked by verbiage [n]\n",
  "LOGOMACHIST": "a person who engages in a war of words [n -S]\n",
  "LOGOMACHISTS": "LOGOMACHIST, a person who engages in a war of words [n]\n",
  "LOGOMACHS": "LOGOMACH, one given to arguing about words [n]\n",
  "LOGOMACHY": "a dispute about words; controversy marked by verbiage [n LOGOMACHIES]\n",
  "LOGON": "access to a mainframe or server system, also LOGIN [n -S]\n",
  "LOGONS": "LOGON, access to a mainframe or server system, also LOGIN [n]\n",
  "LOGOPAEDIC": "relating to speech therapy, also LOGOPEDIC [adj]\n",
  "LOGOPAEDICS": "speech therapy, also LOGOPEDICS [n]\n",
  "LOGOPEDIC": "relating to speech therapy, also LOGOPAEDIC [adj]\n",
  "LOGOPEDICS": "speech therapy, also LOGOPAEDICS [n]\n",
  "LOGOPHILE": "a person who loves words [n -S]\n",
  "LOGOPHILES": "LOGOPHILE, a person who loves words [n]\n",
  "LOGORRHEA": "excessive and often incoherent talkativeness or wordiness [n -S]\n",
  "LOGORRHEAS": "LOGORRHEA, excessive and often incoherent talkativeness or wordiness [n]\n",
  "LOGORRHEIC": "relating to logorrhoea [adj]\n",
  "LOGORRHOEA": "uncontrollable garrulity [n -S]\n",
  "LOGORRHOEAS": "LOGORRHOEA, uncontrollable garrulity [n]\n",
  "LOGOS": "(Greek) the rational principle that governs the universe in Greek philosophy [n LOGOI]\n",
  "LOGOTHETE": "(historical) a chancellor, esp. in the Byzantine emperor [n -S]\n",
  "LOGOTHETES": "LOGOTHETE, (historical) a chancellor, esp. in the Byzantine emperor [n]\n",
  "LOGOTYPE": "a piece of type representing a word or several letters cast in one piece [n -S]\n",
  "LOGOTYPES": "LOGOTYPE, a piece of type representing a word or several letters cast in one piece [n]\n",
  "LOGOTYPIES": "LOGOTYPY, the use of logotypes [n]\n",
  "LOGOTYPY": "the use of logotypes [n LOGOTYPIES]\n",
  "LOGOUT": "exit from a mainframe or server system, also LOGOFF [n -S]\n",
  "LOGOUTS": "LOGOUT, exit from a mainframe or server system, also LOGOFF [n]\n",
  "LOGROLL": "to obtain passage of by exchanging political favours [v -ED, -ING, -S]\n",
  "LOGROLLED": "LOGROLL, to obtain passage of by exchanging political favours [v]\n",
  "LOGROLLER": "one who engages in logrolling [n -S]\n",
  "LOGROLLERS": "LOGROLLER, one who engages in logrolling [n]\n",
  "LOGROLLING": "the exchanging of political favors [n -S]\n",
  "LOGROLLINGS": "LOGROLLING, the exchanging of political favors [n]\n",
  "LOGROLLS": "LOGROLL, to obtain passage of by exchanging political favours [v]\n",
  "LOGS": "LOG, to fell timber [v]\n",
  "LOGWAY": "a ramp used in logging [n -S]\n",
  "LOGWAYS": "LOGWAY, a ramp used in logging [n]\n",
  "LOGWOOD": "the heavy, red heartwood of a tree native to South America, used in dyeing [n -S]\n",
  "LOGWOODS": "LOGWOOD, the heavy, red heartwood of a tree native to South America, used in dyeing [n]\n",
  "LOGY": "sluggish, also LOGGY [adj LOGIER, LOGIEST, LOGILY]\n",
  "LOHAN": "(Sanskrit) a Buddhist who has attained nirvana, aka arhat [n -S]\n",
  "LOHANS": "LOHAN, (Sanskrit) a Buddhist who has attained nirvana, aka arhat [n]\n",
  "LOIASES": "LOIASIS, a tropical African disease [n]\n",
  "LOIASIS": "a tropical African disease [n LOIASES or LOIASISES]\n",
  "LOIASISES": "LOIASIS, a tropical African disease [n]\n",
  "LOID": "to open a lock with a strip of celluloid [v -ED, -ING, -S]\n",
  "LOIDED": "LOID, to open a lock with a strip of celluloid [v]\n",
  "LOIDING": "LOID, to open a lock with a strip of celluloid [v]\n",
  "LOIDS": "LOID, to open a lock with a strip of celluloid [v]\n",
  "LOIN": "meat from the lower part of an animal's back [n -S]\n",
  "LOINCLOTH": "a cloth worn round the loins [n -S]\n",
  "LOINCLOTHS": "LOINCLOTH, a cloth worn round the loins [n]\n",
  "LOINS": "LOIN, meat from the lower part of an animal's back [n]\n",
  "LOIPE": "(Danish) a track for cross-country skiing [n LOIPEN]\n",
  "LOIPEN": "LOIPE, (Danish) a track for cross-country skiing [n]\n",
  "LOIR": "(French) a European dormouse [n -S]\n",
  "LOIRS": "LOIR, (French) a European dormouse [n]\n",
  "LOITER": "to stand idly about [v -ED, -ING, -S]\n",
  "LOITERED": "LOITER, to stand idly about [v]\n",
  "LOITERER": "one that loiters [n -S]\n",
  "LOITERERS": "LOITERER, one that loiters [n]\n",
  "LOITERING": "standing idly [adj LOITERINGLY] / the act of loitering [n -S]\n",
  "LOITERINGLY": "LOITERING, standing idly [adv]\n",
  "LOITERINGS": "LOITERING, the act of loitering [n]\n",
  "LOITERS": "LOITER, to stand idly about [v]\n",
  "LOKE": "(dialect) a short narrow lane; a grass-covered track [n -S]\n",
  "LOKES": "LOKE, (dialect) a short narrow lane; a grass-covered track [n]\n",
  "LOKSHEN": "(Yiddish) noodles [n]\n",
  "LOLIGO": "(Latin) a genus of cephalopods, including numerous species of squids [n -S]\n",
  "LOLIGOS": "LOLIGO, (Latin) a genus of cephalopods, including numerous species of squids [n]\n",
  "LOLIUM": "(Latin) any plant of the Lolium genus of grasses [n -S]\n",
  "LOLIUMS": "LOLIUM, (Latin) any plant of the Lolium genus of grasses [n]\n",
  "LOLL": "to lounge, also LOLLOP [v -ED, -ING, -S]\n",
  "LOLLAPALOOSA": "something excellent, also LALAPALOOZA, LALLAPALOOZA, LOLLAPALOOZA [n -S]\n",
  "LOLLAPALOOSAS": "LOLLAPALOOSA, something excellent, also LALAPALOOZA, LALLAPALOOZA, LOLLAPALOOZA [n]\n",
  "LOLLAPALOOZA": "something excellent, also LALAPALOOZA, LALLAPALOOZA, LOLLAPALOOSA [n -S]\n",
  "LOLLAPALOOZAS": "LOLLAPALOOZA, something excellent, also LALAPALOOZA, LALLAPALOOZA, LOLLAPALOOSA [n]\n",
  "LOLLED": "LOLL, to lounge, also LOLLOP [v]\n",
  "LOLLER": "one who lolls [n -S]\n",
  "LOLLERS": "LOLLER, one who lolls [n]\n",
  "LOLLIES": "LOLLY, (short for) a lollipop [n]\n",
  "LOLLING": "LOLL, to lounge, also LOLLOP [v]\n",
  "LOLLINGLY": "LOLLING, LOLL, to lounge, also LOLLOP [adv]\n",
  "LOLLIPOP": "a piece of candy on the end of a stick, also LOLLYPOP, LULIBUB [n -S]\n",
  "LOLLIPOPS": "LOLLIPOP, a piece of candy on the end of a stick, also LOLLYPOP, LULIBUB [n]\n",
  "LOLLOP": "to lounge, also LOLL [v -ED, -ING, -S]\n",
  "LOLLOPED": "LOLLOP, to lounge, also LOLL [v]\n",
  "LOLLOPIER": "LOLLOPY, given to lolloping [adj]\n",
  "LOLLOPIEST": "LOLLOPY, given to lolloping [adj]\n",
  "LOLLOPING": "LOLLOP, to lounge, also LOLL [v]\n",
  "LOLLOPS": "LOLLOP, to lounge, also LOLL [v]\n",
  "LOLLOPY": "given to lolloping [adj LOLLOPIER, LOLLOPIEST]\n",
  "LOLLS": "LOLL, to lounge, also LOLLOP [v]\n",
  "LOLLY": "(short for) a lollipop [n LOLLIES]\n",
  "LOLLYGAG": "to dawdle, also LALLYGAG [v LOLLYGAGGED, LOLLYGAGGING, LOLLYGAGS]\n",
  "LOLLYGAGGED": "LOLLYGAG, to dawdle, also LALLYGAG [v]\n",
  "LOLLYGAGGING": "LOLLYGAG, to dawdle, also LALLYGAG [v]\n",
  "LOLLYGAGS": "LOLLYGAG, to dawdle, also LALLYGAG [v]\n",
  "LOLLYPOP": "a piece of candy on the end of a stick, also LOLLIPOP, LULIBUB [n -S]\n",
  "LOLLYPOPS": "LOLLYPOP, a piece of candy on the end of a stick, also LOLLIPOP, LULIBUB [n]\n",
  "LOLOG": "the logarithm of a logarithm, also LOGLOG [n -S]\n",
  "LOLOGS": "LOLOG, the logarithm of a logarithm, also LOGLOG [n]\n",
  "LOLZ": "(slang) amusement derived from mischievous or provocative behaviour on the Internet, also LULZ [n]\n",
  "LOMA": "(Greek) a membranous fringe or flap [n LOMATA] / in the southwestern US, a hill with a broad flat top [n -S]\n",
  "LOMAS": "LOMA, (Greek) a membranous fringe or flap [n]\n",
  "LOMATA": "LOMA, (Greek) a membranous fringe or flap [n]\n",
  "LOME": "to cover with loam [v LOMED, LOMING, LOMES]\n",
  "LOMED": "LOME, to cover with loam [v]\n",
  "LOMEIN": "(Chinese) a Chinese dish of noodles, meat and vegetables [n -S]\n",
  "LOMEINS": "LOMEIN, (Chinese) a Chinese dish of noodles, meat and vegetables [n]\n",
  "LOMENT": "a pod that breaks in pieces at constrictions between the seeds, also LOMENTUM [n -S]\n",
  "LOMENTA": "LOMENTUM, (Latin) a type of plant pod, also LOMENT [n]\n",
  "LOMENTACEOUS": "bearing lomenta [adj]\n",
  "LOMENTS": "LOMENT, a pod that breaks in pieces at constrictions between the seeds, also LOMENTUM [n]\n",
  "LOMENTUM": "(Latin) a type of plant pod, also LOMENT [n LOMENTUMS or LOMENTA]\n",
  "LOMENTUMS": "LOMENTUM, (Latin) a type of plant pod, also LOMENT [n]\n",
  "LOMES": "LOME, to cover with loam [v]\n",
  "LOMING": "LOME, to cover with loam [v]\n",
  "LOMPISH": "(Spenser) lumpish [adj]\n",
  "LONE": "solitary [adj]\n",
  "LONELIER": "LONELY, sad from lack of companionship [adj]\n",
  "LONELIEST": "LONELY, sad from lack of companionship [adj]\n",
  "LONELILY": "LONELY, sad from lack of companionship [adv]\n",
  "LONELINESS": "the state of being lonely [n -ES]\n",
  "LONELINESSES": "LONELINESS, the state of being lonely [n]\n",
  "LONELY": "sad from lack of companionship [adj LONELIER, LONELIEST, LONELILY]\n",
  "LONENESS": "the state of being lone [n -ES]\n",
  "LONENESSES": "LONENESS, the state of being lone [n]\n",
  "LONER": "one who avoids others [n -S]\n",
  "LONERS": "LONER, one who avoids others [n]\n",
  "LONESOME": "lonely [adj LONESOMELY] / on one's own [n -S]\n",
  "LONESOMELY": "LONESOME, lonely [adv]\n",
  "LONESOMENESS": "the state of being lonesome [n -ES]\n",
  "LONESOMENESSES": "LONESOMENESS, the state of being lonesome [n]\n",
  "LONESOMES": "LONESOME, on one's own [n]\n",
  "LONG": "extending for a considerable distance, also LANG, LENG [adj LONGER, LONGEST, LONGLY] / to desire strongly [v -ED, -ING, -S]\n",
  "LONGA": "(Latin) a long note [n -S]\n",
  "LONGAEVAL": "long-lived, also LONGEVAL [adj]\n",
  "LONGAEVOUS": "long-lived, also LONGEVOUS [adj]\n",
  "LONGAN": "(Chinese) the edible fruit of a Chinese tree, also LUNGAN [n -S]\n",
  "LONGANIMITIES": "LONGANIMITY, a disposition to bear injuries patiently [n]\n",
  "LONGANIMITY": "a disposition to bear injuries patiently [n LONGANIMITIES]\n",
  "LONGANIMOUS": "disposed to bear injuries patiently [adj]\n",
  "LONGANS": "LONGAN, (Chinese) the edible fruit of a Chinese tree, also LUNGAN [n]\n",
  "LONGAS": "LONGA, (Latin) a long note [n]\n",
  "LONGBOARD": "a type of surfboard [n -S]\n",
  "LONGBOARDS": "LONGBOARD, a type of surfboard [n]\n",
  "LONGBOAT": "a Viking ship, also LONGSHIP [n -S]\n",
  "LONGBOATS": "LONGBOAT, a Viking ship, also LONGSHIP [n]\n",
  "LONGBOW": "a bow drawn by hand as distinct from the crossbow [n -S]\n",
  "LONGBOWMAN": "an archer who uses a longbow [n LONGBOWMEN]\n",
  "LONGBOWMEN": "LONGBOWMAN, an archer who uses a longbow [n]\n",
  "LONGBOWS": "LONGBOW, a bow drawn by hand as distinct from the crossbow [n]\n",
  "LONGCASE": "as in longcase clock, a grandfather clock [adj]\n",
  "LONGCLOTH": "a cotton made in long pieces [n -S]\n",
  "LONGCLOTHS": "LONGCLOTH, a cotton made in long pieces [n]\n",
  "LONGE": "to guide a horse by means of a long rope [v LONGED, LONGEING, LONGES]\n",
  "LONGED": "LONG, to desire strongly [v]\n",
  "LONGEING": "LONGE, to guide a horse by means of a long rope [v]\n",
  "LONGER": "one that longs [n -S]\n",
  "LONGERON": "(French) a longitudinal member of an aeroplane's fuselage [n -S]\n",
  "LONGERONS": "LONGERON, (French) a longitudinal member of an aeroplane's fuselage [n]\n",
  "LONGERS": "LONGER, one that longs [n]\n",
  "LONGES": "LONGE, to guide a horse by means of a long rope [v]\n",
  "LONGEST": "LONG, extending for a considerable distance, also LANG, LENG [adj]\n",
  "LONGEVAL": "long-lived, also LONGAEVAL [adj]\n",
  "LONGEVITIES": "LONGEVITY, long life [n]\n",
  "LONGEVITY": "long life [n LONGEVITIES]\n",
  "LONGEVOUS": "long-lived, also LONGAEVOUS [adj]\n",
  "LONGFORM": "unusually long in form [adj]\n",
  "LONGHAIR": "an intellectual; one having a deep interest in the arts, especially in classical music [n -S]\n",
  "LONGHAIRED": "highbrow [adj]\n",
  "LONGHAIRS": "LONGHAIR, an intellectual; one having a deep interest in the arts, especially in classical music [n]\n",
  "LONGHAND": "ordinary handwriting, as distinguished from shorthand or typing or printing [n -S]\n",
  "LONGHANDS": "LONGHAND, ordinary handwriting, as distinguished from shorthand or typing or printing [n]\n",
  "LONGHEAD": "a person having a long skull [n -S]\n",
  "LONGHEADED": "having unusual foresight or sagacity [adj]\n",
  "LONGHEADEDNESS": "LONGHEADED, having unusual foresight or sagacity [n]\n",
  "LONGHEADS": "LONGHEAD, a person having a long skull [n]\n",
  "LONGHORN": "one of a breed of long-horned cattle [n -S]\n",
  "LONGHORNS": "LONGHORN, one of a breed of long-horned cattle [n]\n",
  "LONGHOUSE": "a long communal house e.g. in SE Asia [n -S]\n",
  "LONGHOUSES": "LONGHOUSE, a long communal house e.g. in SE Asia [n]\n",
  "LONGICAUDATE": "long-tailed [adj]\n",
  "LONGICORN": "a kind of beetle with very long antennae [n -S]\n",
  "LONGICORNS": "LONGICORN, a kind of beetle with very long antennae [n]\n",
  "LONGIES": "long underwear [n]\n",
  "LONGING": "a strong desire [n -S]\n",
  "LONGINGLY": "LONGING [adv]\n",
  "LONGINGS": "LONGING, a strong desire [n]\n",
  "LONGINQUITIES": "LONGINQUITY, remoteness [n]\n",
  "LONGINQUITY": "remoteness [n LONGINQUITIES]\n",
  "LONGIPENNATE": "having elongated wings or feathers [adj]\n",
  "LONGIROSTRAL": "having an elongated beak [adj]\n",
  "LONGISH": "somewhat long [adj]\n",
  "LONGITUDE": "the angular distance of any place on the earth's surface, east or west of a standard meridian (e.g. that of Greenwich) [n -S]\n",
  "LONGITUDES": "LONGITUDE, the angular distance of any place on the earth's surface, east or west of a standard meridian (e.g. that of Greenwich) [n]\n",
  "LONGITUDINAL": "placed or running lengthwise [adj LONGITUDINALLY]\n",
  "LONGITUDINALLY": "LONGITUDINAL, placed or running lengthwise [adv]\n",
  "LONGJUMP": "to jump for distance from a running start [v -ED, -ING, -S]\n",
  "LONGJUMPED": "LONGJUMP, to jump for distance from a running start [v]\n",
  "LONGJUMPING": "LONGJUMP, to jump for distance from a running start [v]\n",
  "LONGJUMPS": "LONGJUMP, to jump for distance from a running start [v]\n",
  "LONGLEAF": "an evergreen tree [n LONGLEAVES]\n",
  "LONGLEAVES": "LONGLEAF, an evergreen tree [n]\n",
  "LONGLINE": "a type of fishing line [n -S]\n",
  "LONGLINER": "one that fishes with a longline [n -S]\n",
  "LONGLINERS": "LONGLINER, one that fishes with a longline [n]\n",
  "LONGLINES": "LONGLINE, a type of fishing line [n]\n",
  "LONGLIST": "to include on a long list [v -ED, -ING, -S]\n",
  "LONGLISTED": "LONGLIST, to include on a long list [v]\n",
  "LONGLISTING": "LONGLIST, to include on a long list [v]\n",
  "LONGLISTS": "LONGLIST, to include on a long list [v]\n",
  "LONGLY": "(Shakespeare) long [adv]\n",
  "LONGNECK": "a beer bottle with a long neck [n -S]\n",
  "LONGNECKS": "LONGNECK, a beer bottle with a long neck [n]\n",
  "LONGNESS": "length [n -ES]\n",
  "LONGNESSES": "LONGNESS, length [n]\n",
  "LONGPRIMER": "in printing, a size of type intermediate between small pica and bourgeois [n -S]\n",
  "LONGPRIMERS": "LONGPRIMER, in printing, a size of type intermediate between small pica and bourgeois [n]\n",
  "LONGS": "LONG, to desire strongly [v]\n",
  "LONGSHIP": "a Viking ship, also LONGBOAT [n -S]\n",
  "LONGSHIPS": "LONGSHIP, a Viking ship, also LONGBOAT [n]\n",
  "LONGSHORE": "found or employed along a shore [adj]\n",
  "LONGSHOREMAN": "a stevedore; a person who makes a living along the shore by fishing, etc., also ALONGSHOREMAN [n LONGSHOREMEN]\n",
  "LONGSHOREMEN": "LONGSHOREMAN, a stevedore; a person who makes a living along the shore by fishing, etc., also ALONGSHOREMAN [n]\n",
  "LONGSHORING": "working longshore [n -S]\n",
  "LONGSHORINGS": "LONGSHORING, working longshore [n]\n",
  "LONGSIGHTED": "having long sight [adj]\n",
  "LONGSIGHTEDNESS": "the state of being longsighted [n]\n",
  "LONGSOME": "tediously long [adj LONGSOMELY]\n",
  "LONGSOMELY": "LONGSOME, tediously long [adv]\n",
  "LONGSOMENESS": "the state of being longsome, extended in length, tiresome [n -ES]\n",
  "LONGSOMENESSES": "LONGSOMENESS, the state of being longsome, extended in length, tiresome [n]\n",
  "LONGSPUR": "any of several North American buntings of the genus Calcarius [n -S]\n",
  "LONGSPURS": "LONGSPUR, any of several North American buntings of the genus Calcarius [n]\n",
  "LONGTIME": "enduring for a long time, e.g. my longtime friend [adj]\n",
  "LONGUEUR": "(French) a long and tedious section of a book, play, etc. [n -S]\n",
  "LONGUEURS": "LONGUEUR, (French) a long and tedious section of a book, play, etc. [n]\n",
  "LONGWALL": "a long working face in a coalmine [n -S]\n",
  "LONGWALLS": "LONGWALL, a long working face in a coalmine [n]\n",
  "LONGWAYS": "along the length, also LONGWISE [adv]\n",
  "LONGWEARING": "lasting a long time e.g. of clothes [adj]\n",
  "LONGWISE": "along the length, also LONGWAYS [adv]\n",
  "LONGWORM": "as in sea longworm, a kind of marine worm [n -S]\n",
  "LONGWORMS": "LONGWORM, as in sea longworm, a kind of marine worm [n]\n",
  "LONICERA": "the honeysuckle [n -S]\n",
  "LONICERAS": "LONICERA, the honeysuckle [n]\n",
  "LOO": "to love, also LOU [v -ED, -ING, -S]\n",
  "LOOBIER": "LOOBY, clumsy or stupid [adj]\n",
  "LOOBIES": "LOOBY, a large, awkward person [n]\n",
  "LOOBIEST": "LOOBY, clumsy or stupid [adj]\n",
  "LOOBILY": "LOOBY, clumsy or stupid [adv]\n",
  "LOOBY": "a large, awkward person [n LOOBIES] / clumsy or stupid [adj LOOBIER, LOOBIEST, LOOBILY]\n",
  "LOOED": "LOO, to love, also LOU [v]\n",
  "LOOEY": "a lieutenant of the armed forces, also LOOIE, LOUIE [n -S]\n",
  "LOOEYS": "LOOEY, a lieutenant of the armed forces, also LOOIE, LOUIE [n]\n",
  "LOOF": "(Scots) the palm of the hand [n LOOFS or LOOVES]\n",
  "LOOFA": "(Arabic) a kind of vine, whose fibrous gourdlike fruit is used as sponge, also LOOFAH, LUFFA [n -S]\n",
  "LOOFAH": "(Arabic) a kind of vine, whose fibrous gourdlike fruit is used as sponge, also LOOFA, LUFFA [n -S]\n",
  "LOOFAHS": "LOOFAH, (Arabic) a kind of vine, whose fibrous gourdlike fruit is used as sponge, also LOOFA, LUFFA [n]\n",
  "LOOFAS": "LOOFA, (Arabic) a kind of vine, whose fibrous gourdlike fruit is used as sponge, also LOOFAH, LUFFA [n]\n",
  "LOOFFUL": "(Scots) an open handful [n -S]\n",
  "LOOFFULS": "LOOFFUL, (Scots) an open handful [n]\n",
  "LOOFS": "LOOF, (Scots) the palm of the hand [n]\n",
  "LOOGIE": "a mass of saliva and phlegm [n -S]\n",
  "LOOGIES": "LOOGIE, a mass of saliva and phlegm [n]\n",
  "LOOIE": "(colloquial) a lieutenant, also LOOEY, LOUIE [n -S]\n",
  "LOOIES": "LOOIE, (colloquial) a lieutenant, also LOOEY, LOUIE [n]\n",
  "LOOING": "LOO, to love, also LOU [v]\n",
  "LOOK": "to use one's sight [v -ED, -ING, -S]\n",
  "LOOKALIKE": "a person who is the double of another [n -S]\n",
  "LOOKALIKES": "LOOKALIKE, a person who is the double of another [n]\n",
  "LOOKDOWN": "a marine fish [n -S]\n",
  "LOOKDOWNS": "LOOKDOWN, a marine fish [n]\n",
  "LOOKED": "LOOK, to use one's sight [v]\n",
  "LOOKER": "one that looks [n -S]\n",
  "LOOKERS": "LOOKER, one that looks [n]\n",
  "LOOKIE": "an interjection: look at this [interj]\n",
  "LOOKING": "LOOK, to use one's sight [v]\n",
  "LOOKISM": "a prejudice against physical disability, also LOOKSISM [n -S]\n",
  "LOOKISMS": "LOOKISM, a prejudice against physical disability, also LOOKSISM [n]\n",
  "LOOKIST": "one given to lookism, prejudice on grounds of appearance [n -S]\n",
  "LOOKISTS": "LOOKIST, one given to lookism, prejudice on grounds of appearance [n]\n",
  "LOOKIT": "an interjection: look at this [interj]\n",
  "LOOKOUT": "one engaged in keeping watch [n -S]\n",
  "LOOKOUTS": "LOOKOUT, one engaged in keeping watch [n]\n",
  "LOOKOVER": "a looking over [n -S]\n",
  "LOOKOVERS": "LOOKOVER, a looking over [n]\n",
  "LOOKS": "LOOK, to use one's sight [v]\n",
  "LOOKSISM": "a prejudice against physical disability, also LOOKISM [n -S]\n",
  "LOOKSISMS": "LOOKSISM, a prejudice against physical disability, also LOOKISM [n]\n",
  "LOOKUP": "the process of looking something up [n -S]\n",
  "LOOKUPS": "LOOKUP, the process of looking something up [n]\n",
  "LOOKY": "an interjection: look at this [interj]\n",
  "LOOM": "to appear indistinctly as in a mirage [v -ED, -ING, -S]\n",
  "LOOMED": "LOOM, to appear indistinctly as in a mirage [v]\n",
  "LOOMING": "LOOM, to appear indistinctly as in a mirage [v]\n",
  "LOOMS": "LOOM, to appear indistinctly as in a mirage [v]\n",
  "LOON": "a diving waterfowl [n -S]\n",
  "LOONEY": "crazy [adj LOONIER, LOONIEST] / a crazy person, also LOONIE, LOONY, LUNY [n -S]\n",
  "LOONEYS": "LOONEY, a crazy person, also LOONIE, LOONY, LUNY [n]\n",
  "LOONIE": "(Canadian) a Canadian dollar coin with a loon bird on one of its faces [n -S]\n",
  "LOONIER": "LOONIE [adj]\n",
  "LOONIES": "LOONIE, (Canadian) a Canadian dollar coin with a loon bird on one of its faces [n]\n",
  "LOONIEST": "LOONIE [adj]\n",
  "LOONILY": "LOONY, crazy [adv]\n",
  "LOONINESS": "the state of being loony [n -ES]\n",
  "LOONINESSES": "LOONINESS, the state of being loony [n]\n",
  "LOONING": "the cry of the loon, a northern diving bird [n -S]\n",
  "LOONINGS": "LOONING, the cry of the loon, a northern diving bird [n]\n",
  "LOONS": "LOON, a diving waterfowl [n]\n",
  "LOONY": "crazy [adj LOONIER, LOONIEST, LOONILY] / a crazy person, also LOONEY, LOONIE, LUNY [n LOONIES]\n",
  "LOOP": "to form oval openings [v -ED, -ING, -S]\n",
  "LOOPED": "LOOP, to form oval openings [v]\n",
  "LOOPER": "a caterpillar of the Geometridae, so called from its mode of walking [n -S]\n",
  "LOOPERS": "LOOPER, a caterpillar of the Geometridae, so called from its mode of walking [n]\n",
  "LOOPHOLE": "to make small openings in [v LOOPHOLED, LOOPHOLING, LOOPHOLES]\n",
  "LOOPHOLED": "LOOPHOLE, to make small openings in [v]\n",
  "LOOPHOLES": "LOOPHOLE, to make small openings in [v]\n",
  "LOOPHOLING": "LOOPHOLE, to make small openings in [v]\n",
  "LOOPIER": "LOOPY, full of loops [adj]\n",
  "LOOPIEST": "LOOPY, full of loops [adj]\n",
  "LOOPILY": "LOOPY, full of loops [adv]\n",
  "LOOPINESS": "the state of being loopy [n -ES]\n",
  "LOOPINESSES": "LOOPINESS, the state of being loopy [n]\n",
  "LOOPING": "the act of looping [n -S]\n",
  "LOOPINGS": "LOOPING, the act of looping [n]\n",
  "LOOPLIKE": "like a loop [adj]\n",
  "LOOPS": "LOOP, to form oval openings [v]\n",
  "LOOPY": "full of loops [adj LOOPIER, LOOPIEST, LOOPILY]\n",
  "LOOR": "LIEF, (archaic) soon, gladly, also LEVE, LIEVE [adj]\n",
  "LOORD": "(Spenser) a lout [n -S]\n",
  "LOORDS": "LOORD, (Spenser) a lout [n]\n",
  "LOOS": "LOO, to love, also LOU [v]\n",
  "LOOSE": "slack [adj LOOSER, LOOSEST, LOOSELY] / to set free, also LOWSE [v LOOSED or (Spenser) LOAST, LOSEN or LOOSED, LOOSING, LOOSES]\n",
  "LOOSEBOX": "a type of stall for an animal [n -ES]\n",
  "LOOSEBOXES": "LOOSEBOX, a type of stall for an animal [n]\n",
  "LOOSED": "LOOSE, to set free, also LOWSE [v]\n",
  "LOOSELY": "LOOSE, slack [adv]\n",
  "LOOSEN": "to make less tight [v -ED, -ING, -S]\n",
  "LOOSENED": "LOOSEN, to make less tight [v]\n",
  "LOOSENER": "a laxative [n -S]\n",
  "LOOSENERS": "LOOSENER, a laxative [n]\n",
  "LOOSENESS": "the state of being loose [n -ES]\n",
  "LOOSENESSES": "LOOSENESS, the state of being loose [n]\n",
  "LOOSENING": "the act of making looser [n -S]\n",
  "LOOSENINGS": "LOOSENING, the act of making looser [n]\n",
  "LOOSENS": "LOOSEN, to make less tight [v]\n",
  "LOOSER": "LOOSE, slack [adj]\n",
  "LOOSES": "LOOSE, to set free, also LOWSE [v]\n",
  "LOOSEST": "LOOSE, slack [adj]\n",
  "LOOSESTRIFE": "a wild flower of the primrose family [n -S]\n",
  "LOOSESTRIFES": "LOOSESTRIFE, a wild flower of the primrose family [n]\n",
  "LOOSIE": "(slang) a loose forward in rugby [n -S]\n",
  "LOOSIES": "LOOSIE, (slang) a loose forward in rugby [n]\n",
  "LOOSING": "the celebration of a twenty-first birthday, also LOWSENING [n -S]\n",
  "LOOSINGS": "LOOSING, the celebration of a twenty-first birthday, also LOWSENING [n]\n",
  "LOOT": "to plunder [v -ED, -ING, -S]\n",
  "LOOTED": "LOOT, to plunder [v]\n",
  "LOOTEN": "LET, to allow [v]\n",
  "LOOTER": "one that loots [n -S]\n",
  "LOOTERS": "LOOTER, one that loots [n]\n",
  "LOOTING": "the act of looting [n -S]\n",
  "LOOTINGS": "LOOTING, the act of looting [n]\n",
  "LOOTS": "LOOT, to plunder [v]\n",
  "LOOVES": "LOOF, (Scots) the palm of the hand [n]\n",
  "LOOYENWORK": "therapy of the body tissues aimed at releasing muscle fibre adhesions and easing physical and emotional tensions [n -S]\n",
  "LOOYENWORKS": "LOOYENWORK, therapy of the body tissues aimed at releasing muscle fibre adhesions and easing physical and emotional tensions [n]\n",
  "LOP": "to cut the tops off branches [v LOPPED, LOPPING, LOPS]\n",
  "LOPE": "to run with a long stride [v LOPED, LOPING, LOPES]\n",
  "LOPED": "LOPE, to run with a long stride [v]\n",
  "LOPER": "one of a pair of sliding hinged pieces of metal acting as supports for e.g. a desktop [n -S]\n",
  "LOPERS": "LOPER, one of a pair of sliding hinged pieces of metal acting as supports for e.g. a desktop [n]\n",
  "LOPES": "LOPE, to run with a long stride [v]\n",
  "LOPGRASS": "soft bromegrass [n -ES]\n",
  "LOPGRASSES": "LOPGRASS, soft bromegrass [n]\n",
  "LOPHOBRANCH": "any fish of the pipefish and seahorse genus [n -S]\n",
  "LOPHOBRANCHIATE": "any fish of the seahorse and pipefish genus [n]\n",
  "LOPHOBRANCHS": "LOPHOBRANCH, any fish of the pipefish and seahorse genus [n]\n",
  "LOPHODONT": "of a molar tooth, having (esp. transverse) ridges between the cusps; (of a dentition) characterized by such molar teeth [adj]\n",
  "LOPHOPHORATE": "of or like a lophophore, a ring of ciliated tentacles round the mouth of some sedentary marine animals [adj]\n",
  "LOPHOPHORE": "a ring of ciliated tentacles round the mouth of some sedentary marine animals [n -S]\n",
  "LOPHOPHORES": "LOPHOPHORE, a ring of ciliated tentacles round the mouth of some sedentary marine animals [n]\n",
  "LOPING": "LOPE, to run with a long stride [v]\n",
  "LOPINGLY": "in the manner of one that lopes [adv]\n",
  "LOPOLITH": "a lens-shaped body of igneous rock [n -S]\n",
  "LOPOLITHS": "LOPOLITH, a lens-shaped body of igneous rock [n]\n",
  "LOPPED": "LOP, to cut the tops off branches [v]\n",
  "LOPPER": "(Scots) to curdle, also LAPPER [v -ED, -ING, -S]\n",
  "LOPPERED": "LOPPER, (Scots) to curdle, also LAPPER [v]\n",
  "LOPPERING": "LOPPER, (Scots) to curdle, also LAPPER [v]\n",
  "LOPPERS": "LOPPER, (Scots) to curdle, also LAPPER [v]\n",
  "LOPPET": "a long-distance cross-country ski race [n -S]\n",
  "LOPPETS": "LOPPET, a long-distance cross-country ski race [n]\n",
  "LOPPIER": "LOPPY, hanging limply [adj]\n",
  "LOPPIES": "LOPPY, a ranch handyman [n]\n",
  "LOPPIEST": "LOPPY, hanging limply [adj]\n",
  "LOPPING": "the act of cutting off [n -S]\n",
  "LOPPINGS": "LOPPING, the act of cutting off [n]\n",
  "LOPPY": "hanging limply [adj LOPPIER, LOPPIEST] / a ranch handyman [n LOPPIES]\n",
  "LOPS": "LOP, to cut the tops off branches [v]\n",
  "LOPSIDED": "leaning to one side [adj LOPSIDEDLY]\n",
  "LOPSIDEDLY": "LOPSIDED, leaning to one side [adv]\n",
  "LOPSIDEDNESS": "the state of being lopsided [n -ES]\n",
  "LOPSIDEDNESSES": "LOPSIDEDNESS, the state of being lopsided [n]\n",
  "LOPSTICK": "(Canadian) a tree with its lower branches trimmed, also LOBSTICK [n -S]\n",
  "LOPSTICKS": "LOPSTICK, (Canadian) a tree with its lower branches trimmed, also LOBSTICK [n]\n",
  "LOQUACIOUS": "talkative, garrulous [adj LOQUACIOUSLY]\n",
  "LOQUACIOUSLY": "LOQUACIOUS, talkative, garrulous [adv]\n",
  "LOQUACIOUSNESS": "talkativeness [n]\n",
  "LOQUACITIES": "LOQUACITY, talkativeness [n]\n",
  "LOQUACITY": "talkativeness [n LOQUACITIES]\n",
  "LOQUAT": "(Chinese) a Chinese and Japanese tree or its small, yellow, edible fruit [n -S]\n",
  "LOQUATS": "LOQUAT, (Chinese) a Chinese and Japanese tree or its small, yellow, edible fruit [n]\n",
  "LOQUITUR": "(Latin) 'he/she speaks' -- used as a stage direction [v]\n",
  "LOR": "(colloquial) for lord, an interjection expressing surprise [interj]\n",
  "LORAL": "pertaining to the lore, the side of a bird's head, also LOREAL [adj]\n",
  "LORAN": "an acronym for long-range radio navigation system [n -S]\n",
  "LORANS": "LORAN, an acronym for long-range radio navigation system [n]\n",
  "LORATE": "having the form of a thong or strap [adj]\n",
  "LORAZEPAM": "a drug used in the treatment of anxiety [n -S]\n",
  "LORAZEPAMS": "LORAZEPAM, a drug used in the treatment of anxiety [n]\n",
  "LORCHA": "(Portuguese) a light vessel of European build, like a Chinese junk [n -S]\n",
  "LORCHAS": "LORCHA, (Portuguese) a light vessel of European build, like a Chinese junk [n]\n",
  "LORD": "to rule over others [v -ED, -ING, -S]\n",
  "LORDED": "LORD, to rule over others [v]\n",
  "LORDING": "a young or unimportant lord, also LORDLING [n -S]\n",
  "LORDINGS": "LORDING, a young or unimportant lord, also LORDLING [n]\n",
  "LORDKIN": "a little lord, also LORDING, LORDLING [n -S]\n",
  "LORDKINS": "LORDKIN, a little lord, also LORDING, LORDLING [n]\n",
  "LORDLESS": "without a lord [adj]\n",
  "LORDLIER": "LORDLY, in the manner of a lord [adj]\n",
  "LORDLIEST": "LORDLY, in the manner of a lord [adj]\n",
  "LORDLIKE": "like a lord [adj]\n",
  "LORDLINESS": "the state of being lordly [n -ES]\n",
  "LORDLINESSES": "LORDLINESS, the state of being lordly [n]\n",
  "LORDLING": "a young or unimportant lord, also LORDING [n -S]\n",
  "LORDLINGS": "LORDLING, a young or unimportant lord, also LORDING [n]\n",
  "LORDLY": "in the manner of a lord [adj LORDLIER, LORDLIEST]\n",
  "LORDOLATRIES": "LORDOLATRY, worship of nobility [n]\n",
  "LORDOLATRY": "worship of nobility [n LORDOLATRIES]\n",
  "LORDOMA": "a curvature of the spinal column, also LORDOSIS [n -S]\n",
  "LORDOMAS": "LORDOMA, a curvature of the spinal column, also LORDOSIS [n]\n",
  "LORDOSES": "LORDOSIS, a curvature of the spinal column, also LORDOMA [n]\n",
  "LORDOSIS": "a curvature of the spinal column, also LORDOMA [n LORDOSES]\n",
  "LORDOTIC": "having a convex curvature of the spine [adj]\n",
  "LORDS": "LORD, to rule over others [v]\n",
  "LORDSHIP": "the power of a lord [n -S]\n",
  "LORDSHIPS": "LORDSHIP, the power of a lord [n]\n",
  "LORDY": "a mild interjection expressing surprise [interj]\n",
  "LORE": "a traditional knowledge or belief [n -S]\n",
  "LOREAL": "pertaining to the lore, the side of a bird's head, also LORAL [adj]\n",
  "LOREL": "a good for nothing fellow; a vagabond, also LORRELL, LOSEL, LOZELL [n -S]\n",
  "LORELS": "LOREL, a good for nothing fellow; a vagabond, also LORRELL, LOSEL, LOZELL [n]\n",
  "LORES": "LORE, a traditional knowledge or belief [n]\n",
  "LORETTE": "(French) a courtesan [n -S]\n",
  "LORETTES": "LORETTE, (French) a courtesan [n]\n",
  "LORGNETTE": "(French) a pair of spectacles or opera glasses on a handle [n -S]\n",
  "LORGNETTES": "LORGNETTE, (French) a pair of spectacles or opera glasses on a handle [n]\n",
  "LORGNON": "(French) a pair of eyeglasses with a handle [n -S]\n",
  "LORGNONS": "LORGNON, (French) a pair of eyeglasses with a handle [n]\n",
  "LORIC": "a leather corslet; the case of a rotifer etc., also LORICA [n -S]\n",
  "LORICA": "(Latin) a leather corslet, also LORIC [n LORICAE or LORICAS]\n",
  "LORICAE": "LORICA, (Latin) a leather corslet, also LORIC [n]\n",
  "LORICAS": "LORICA, (Latin) a leather corslet, also LORIC [n]\n",
  "LORICATE": "to coat protectively, to armour [v LORICATED, LORICATING, LORICATES]\n",
  "LORICATED": "LORICATE, to coat protectively, to armour [v]\n",
  "LORICATES": "LORICATE, to coat protectively, to armour [v]\n",
  "LORICATING": "LORICATE, to coat protectively, to armour [v]\n",
  "LORICATION": "a covering of scales or plates [n -S]\n",
  "LORICATIONS": "LORICATION, a covering of scales or plates [n]\n",
  "LORICS": "LORIC, a leather corslet; the case of a rotifer etc., also LORICA [n]\n",
  "LORIES": "LORY, (Malay) a kind of small parrot, also LOERIE, LOURIE, LOWRIE, LOWRY [n]\n",
  "LORIKEET": "a kind of Australian parrot [n -S]\n",
  "LORIKEETS": "LORIKEET, a kind of Australian parrot [n]\n",
  "LORIMER": "a maker of implements for harnesses and saddles, also LORINER [n -S]\n",
  "LORIMERS": "LORIMER, a maker of implements for harnesses and saddles, also LORINER [n]\n",
  "LORINER": "a maker of implements for harnesses and saddles, also LORIMER [n -S]\n",
  "LORINERS": "LORINER, a maker of implements for harnesses and saddles, also LORIMER [n]\n",
  "LORING": "(Spenser) learning [n -S]\n",
  "LORINGS": "LORING, (Spenser) learning [n]\n",
  "LORIOT": "(French) the golden oriole [n -S]\n",
  "LORIOTS": "LORIOT, (French) the golden oriole [n]\n",
  "LORIS": "the slender lemur of Sri Lanka [n -ES]\n",
  "LORISES": "LORIS, the slender lemur of Sri Lanka [n]\n",
  "LORN": "(archaic) lost, abandoned [adj LORNER, LORNEST]\n",
  "LORNER": "LORN, (archaic) lost, abandoned [adj]\n",
  "LORNEST": "LORN, (archaic) lost, abandoned [adj]\n",
  "LORNNESS": "the state of being lorn [n -ES]\n",
  "LORNNESSES": "LORNNESS, the state of being lorn [n]\n",
  "LORRELL": "(Spenser) a good for nothing fellow, also LOREL, LOSEL, LOZELL [n -S]\n",
  "LORRELLS": "LORRELL, (Spenser) a good for nothing fellow, also LOREL, LOSEL, LOZELL [n]\n",
  "LORRIES": "LORRY, a vehicle used for transportation [n]\n",
  "LORRY": "a vehicle used for transportation [n LORRIES]\n",
  "LORY": "(Malay) a kind of small parrot, also LOERIE, LOURIE, LOWRIE, LOWRY [n LORIES]\n",
  "LOS": "(obsolete) praise [n -ES]\n",
  "LOSABLE": "able to be lost [adj]\n",
  "LOSABLENESS": "the state of being losable [n -ES]\n",
  "LOSABLENESSES": "LOSABLENESS, the state of being losable [n]\n",
  "LOSE": "to misplace or be deprived of [v LOST, LOSING, LOSES] / (obsolete) to loose [v LOSED, LOAST, LOSING, LOSES]\n",
  "LOSED": "(Spenser) loosed [v]\n",
  "LOSEL": "a good for nothing fellow; a vagabond, also LOREL, LORRELL, LOZELL [n -S]\n",
  "LOSELS": "LOSEL, a good for nothing fellow; a vagabond, also LOREL, LORRELL, LOZELL [n]\n",
  "LOSEN": "(Spenser) to loosen [v]\n",
  "LOSER": "one who loses [n -S]\n",
  "LOSERS": "LOSER, one who loses [n]\n",
  "LOSES": "LOSE, to misplace or be deprived of [v]\n",
  "LOSH": "(Scots) an interjection, Lord [interj]\n",
  "LOSING": "tending to suffer loss [adj LOSINGEST, LOSINGLY] / the act of losing [n -S]\n",
  "LOSINGEST": "losing more often than others of its kind; least successful [adj]\n",
  "LOSINGLY": "LOSING, tending to suffer loss [adv]\n",
  "LOSINGS": "LOSING, the act of losing [n]\n",
  "LOSLYF": "(offensive South African) a promiscuous female [n -S]\n",
  "LOSLYFS": "LOSLYF, (offensive South African) a promiscuous female [n]\n",
  "LOSS": "the act of one that loses [n -ES]\n",
  "LOSSES": "LOSS, the act of one that loses [n]\n",
  "LOSSIER": "LOSSY, of a compression format, losing data [adj]\n",
  "LOSSIEST": "LOSSY, of a compression format, losing data [adj]\n",
  "LOSSLESS": "without loss, as in lossless compression of data [adj]\n",
  "LOSSMAKER": "a business that makes a continual loss [n -S]\n",
  "LOSSMAKERS": "LOSSMAKER, a business that makes a continual loss [n]\n",
  "LOSSMAKING": "making a loss, as in a lossmaking enterprise [adj]\n",
  "LOSSY": "of a compression format, losing data [adj LOSSIER, LOSSIEST]\n",
  "LOST": "LOSE, to misplace or be deprived of [v]\n",
  "LOSTNESS": "the state of being lost [n -ES]\n",
  "LOSTNESSES": "LOSTNESS, the state of being lost [n]\n",
  "LOT": "to separate into batches [v LOTTED, LOTTING, LOTS]\n",
  "LOTA": "(Hindi) a small brass water vessel used in India, also LOTAH [n -S]\n",
  "LOTAH": "(Hindi) a small brass water vessel used in India, also LOTA [n -S]\n",
  "LOTAHS": "LOTAH, (Hindi) a small brass water vessel used in India, also LOTA [n]\n",
  "LOTAS": "LOTA, (Hindi) a small brass water vessel used in India, also LOTAH [n]\n",
  "LOTE": "(archaic) a lotus, also LOTOS [n -S]\n",
  "LOTES": "LOTE, (archaic) a lotus, also LOTOS [n]\n",
  "LOTH": "unwilling, also LAITH, LOATH [adj LOTHER, LOTHEST]\n",
  "LOTHARIO": "a seducer of women [n -S]\n",
  "LOTHARIOS": "LOTHARIO, a seducer of women [n]\n",
  "LOTHEFULL": "(Spenser) reluctant, also LOATHFUL, LOTHFULL [adj]\n",
  "LOTHER": "LOTH, unwilling, also LAITH, LOATH [adj]\n",
  "LOTHEST": "LOTH, unwilling, also LAITH, LOATH [adj]\n",
  "LOTHFULL": "(Spenser) reluctant, also LOATHFUL, LOTHEFULL [adj]\n",
  "LOTHNESS": "the state of being loth [n -ES]\n",
  "LOTHNESSES": "LOTHNESS, the state of being loth [n]\n",
  "LOTHSOME": "abhorrent, also LOATHSOME [adj]\n",
  "LOTI": "a monetary unit of Lesotho [n MALOTI]\n",
  "LOTIC": "pertaining to moving water [adj]\n",
  "LOTION": "a liquid preparation for external application [n -S]\n",
  "LOTIONS": "LOTION, a liquid preparation for external application [n]\n",
  "LOTO": "a game played by covering on a card each number drawn till a line of numbers is completed, also LOTTO [n -S]\n",
  "LOTOS": "an aquatic plant, also LOTE, LOTUS [n -ES]\n",
  "LOTOSES": "LOTOS, an aquatic plant, also LOTE, LOTUS [n]\n",
  "LOTS": "LOT, to separate into batches [v]\n",
  "LOTSA": "(colloquial) a lot of, also LOTTA [adj]\n",
  "LOTTA": "(colloquial) a lot of, also LOTSA [adj]\n",
  "LOTTE": "(French) a food fish, aka monkfish [n -S]\n",
  "LOTTED": "LOT, to separate into batches [v]\n",
  "LOTTER": "someone who rents or works an allotment [n -S]\n",
  "LOTTERIES": "LOTTERY, a game of chance [n]\n",
  "LOTTERS": "LOTTER, someone who rents or works an allotment [n]\n",
  "LOTTERY": "a game of chance [n LOTTERIES]\n",
  "LOTTES": "LOTTE, (French) a food fish, aka monkfish [n]\n",
  "LOTTING": "LOT, to separate into batches [v]\n",
  "LOTTO": "a game played by covering on a card each number drawn till a line of numbers is completed, also LOTO [n -S]\n",
  "LOTTOS": "LOTTO, a game played by covering on a card each number drawn till a line of numbers is completed, also LOTO [n]\n",
  "LOTUS": "any of various plants, including certain waterlilies, also LOTE, LOTOS [n -ES]\n",
  "LOTUSES": "LOTUS, any of various plants, including certain waterlilies, also LOTE, LOTOS [n]\n",
  "LOTUSLAND": "a place of dreamy contentment and self-indulgence [n -S]\n",
  "LOTUSLANDS": "LOTUSLAND, a place of dreamy contentment and self-indulgence [n]\n",
  "LOU": "(Scots) to love, also LOO [v -ED, -ING, -S]\n",
  "LOUCHE": "(French) not reputable [adj LOUCHER, LOUCHEST, LOUCHELY]\n",
  "LOUCHELY": "LOUCHE, (French) not reputable [adv]\n",
  "LOUCHER": "LOUCHE, (French) not reputable [adj]\n",
  "LOUCHEST": "LOUCHE, (French) not reputable [adj]\n",
  "LOUD": "strongly audible [adj LOUDER, LOUDEST, LOUDLY]\n",
  "LOUDEN": "to increase in volume [v -ED, -ING, -S]\n",
  "LOUDENED": "LOUDEN, to increase in volume [v]\n",
  "LOUDENING": "LOUDEN, to increase in volume [v]\n",
  "LOUDENS": "LOUDEN, to increase in volume [v]\n",
  "LOUDER": "LOUD, strongly audible [adj]\n",
  "LOUDEST": "LOUD, strongly audible [adj]\n",
  "LOUDHAILER": "a megaphone [n -S]\n",
  "LOUDHAILERS": "LOUDHAILER, a megaphone [n]\n",
  "LOUDISH": "somewhat loud [adj]\n",
  "LOUDLIER": "LOUDLY, in a loud fashion [adv]\n",
  "LOUDLIEST": "LOUDLY, in a loud fashion [adv]\n",
  "LOUDLY": "in a loud fashion [adv LOUDLIER, LOUDLIEST]\n",
  "LOUDMOUTH": "a person who speaks loudly and is opinionated [n -S]\n",
  "LOUDMOUTHED": "given to loud offensive talk [adj]\n",
  "LOUDMOUTHS": "LOUDMOUTH, a person who speaks loudly and is opinionated [n]\n",
  "LOUDNESS": "the quality of being loud [n -ES]\n",
  "LOUDNESSES": "LOUDNESS, the quality of being loud [n]\n",
  "LOUDSPEAKER": "a device that changes electrical signals into sounds loud enough to be heard at a distance [n -S]\n",
  "LOUDSPEAKERS": "LOUDSPEAKER, a device that changes electrical signals into sounds loud enough to be heard at a distance [n]\n",
  "LOUED": "LOU, (Scots) to love, also LOO [v]\n",
  "LOUGH": "(Irish) a lake [n -S]\n",
  "LOUGHS": "LOUGH, (Irish) a lake [n]\n",
  "LOUIE": "(colloquial) a lieutenant, also LOOEY, LOOIE [n -S]\n",
  "LOUIES": "LOUIE, (colloquial) a lieutenant, also LOOEY, LOOIE [n]\n",
  "LOUING": "LOU, (Scots) to love, also LOO [v]\n",
  "LOUIS": "(French) a former gold coin of France [n LOUIS]\n",
  "LOUMA": "a weekly market in rural areas of developing countries [n -S]\n",
  "LOUMAS": "LOUMA, a weekly market in rural areas of developing countries [n]\n",
  "LOUN": "(Scots) to calm, also LOUND, LOWN, LOWND, LOWNE [v -ED, -ING, -S]\n",
  "LOUND": "(Scots) to calm, also LOUN [v -ED, -ING, -S]\n",
  "LOUNDED": "LOUND, (Scots) to calm, also LOUN [v]\n",
  "LOUNDER": "(Scots) to beat, thump [v -ED, -ING, -S]\n",
  "LOUNDERED": "LOUNDER, (Scots) to beat, thump [v]\n",
  "LOUNDERING": "a beating, thumping [n -S]\n",
  "LOUNDERINGS": "LOUNDERING, a beating, thumping [n]\n",
  "LOUNDERS": "LOUNDER, (Scots) to beat, thump [v]\n",
  "LOUNDING": "LOUND, (Scots) to calm, also LOUN [v]\n",
  "LOUNDS": "LOUND, (Scots) to calm, also LOUN [v]\n",
  "LOUNED": "LOUN, (Scots) to calm, also LOUND, LOWN, LOWND, LOWNE [v]\n",
  "LOUNGE": "to recline in a relaxed manner [v LOUNGED, LOUNGING, LOUNGES]\n",
  "LOUNGED": "LOUNGE, to recline in a relaxed manner [v]\n",
  "LOUNGER": "a comfortable sometimes adjustable couch or extending chair designed for someone to relax on [n -S]\n",
  "LOUNGERS": "LOUNGER, a comfortable sometimes adjustable couch or extending chair designed for someone to relax on [n]\n",
  "LOUNGES": "LOUNGE, to recline in a relaxed manner [v]\n",
  "LOUNGEWEAR": "informal clothing designed to be worn at home [n -S]\n",
  "LOUNGEWEARS": "LOUNGEWEAR, informal clothing designed to be worn at home [n]\n",
  "LOUNGEY": "relating to or reminiscent of a cocktail lounge or lounge music, also LOUNGY [adj LOUNGIER, LOUNGIEST]\n",
  "LOUNGIER": "LOUNGY, suitable for lounging, also LOUNGEY [adj]\n",
  "LOUNGIEST": "LOUNGY, suitable for lounging, also LOUNGEY [adj]\n",
  "LOUNGING": "reclining [adj LOUNGINGLY] / the act of lounging [n -S]\n",
  "LOUNGINGLY": "LOUNGING, reclining [adv]\n",
  "LOUNGINGS": "LOUNGING, the act of lounging [n]\n",
  "LOUNGY": "suitable for lounging, also LOUNGEY [adj LOUNGIER, LOUNGIEST]\n",
  "LOUNING": "LOUN, (Scots) to calm, also LOUND, LOWN, LOWND, LOWNE [v]\n",
  "LOUNS": "LOUN, (Scots) to calm, also LOUND, LOWN, LOWND, LOWNE [v]\n",
  "LOUP": "(Scots) to leap, also LOWP [v LOUPIT or LOUPED, LOUPEN, LOUPING, LOUPS]\n",
  "LOUPE": "(French) a jeweller's magnifying glass worn on the eye-socket [n -S]\n",
  "LOUPED": "LOUP, (Scots) to leap, also LOWP [v]\n",
  "LOUPEN": "LOUP, (Scots) to leap, also LOWP [v]\n",
  "LOUPES": "LOUPE, (French) a jeweller's magnifying glass worn on the eye-socket [n]\n",
  "LOUPING": "LOUP, (Scots) to leap, also LOWP [v]\n",
  "LOUPIT": "LOUP, (Scots) to leap, also LOWP [v]\n",
  "LOUPS": "LOUP, (Scots) to leap, also LOWP [v]\n",
  "LOUR": "to look sullen or threatening, also LOWER [v -ED, -ING, -S]\n",
  "LOURE": "(French) an old slow dance in 6-4 time [n -S]\n",
  "LOURED": "LOUR, to look sullen or threatening, also LOWER [v]\n",
  "LOURES": "LOURE, (French) an old slow dance in 6-4 time [n]\n",
  "LOURIE": "a type of African bird with crimson or grey plumage, aka turaco, also LOERIE, LORY, LOWRIE, LOWRY [n -S]\n",
  "LOURIER": "LOURY, gloomy, louring, also LOWERY [adj]\n",
  "LOURIES": "LOURIE, a type of African bird with crimson or grey plumage, aka turaco, also LOERIE, LORY, LOWRIE, LOWRY [n]\n",
  "LOURIEST": "LOURY, gloomy, louring, also LOWERY [adj]\n",
  "LOURING": "sullen, threatening [adj LOURINGLY] / the act of louring [n -S]\n",
  "LOURINGLY": "LOURING, sullen, threatening [adv]\n",
  "LOURINGS": "LOURING, the act of louring [n]\n",
  "LOURS": "LOUR, to look sullen or threatening, also LOWER [v]\n",
  "LOURY": "gloomy, louring, also LOWERY [adj LOURIER, LOURIEST]\n",
  "LOUS": "LOU, (Scots) to love, also LOO [v]\n",
  "LOUSE": "to spoil or bungle [v LOUSED, LOUSING, LOUSES] / a parasitic insect [n LICE]\n",
  "LOUSED": "LOUSE, to spoil or bungle [v]\n",
  "LOUSER": "(Irish) a mean, nasty person [n -S]\n",
  "LOUSERS": "LOUSER, (Irish) a mean, nasty person [n]\n",
  "LOUSES": "LOUSE, to spoil or bungle [v]\n",
  "LOUSEWORT": "any plant of the genus Pedicularis, of the figwort family [n -S]\n",
  "LOUSEWORTS": "LOUSEWORT, any plant of the genus Pedicularis, of the figwort family [n]\n",
  "LOUSIER": "LOUSY, infested with lice [adj]\n",
  "LOUSIEST": "LOUSY, infested with lice [adj]\n",
  "LOUSILY": "LOUSY, infested with lice [adv]\n",
  "LOUSINESS": "the state of being lousy [n -ES]\n",
  "LOUSINESSES": "LOUSINESS, the state of being lousy [n]\n",
  "LOUSING": "the act of messing up, spoiling [n -S]\n",
  "LOUSINGS": "LOUSING, the act of messing up, spoiling [n]\n",
  "LOUSY": "infested with lice [adj LOUSIER, LOUSIEST, LOUSILY]\n",
  "LOUT": "(obsolete) to bow, stoop, also LOWT [v -ED, -ING, -S]\n",
  "LOUTED": "LOUT, (obsolete) to bow, stoop, also LOWT [v]\n",
  "LOUTERIES": "LOUTERY, loutish behaviour [n]\n",
  "LOUTERY": "loutish behaviour [n LOUTERIES]\n",
  "LOUTING": "LOUT, (obsolete) to bow, stoop, also LOWT [v]\n",
  "LOUTISH": "ill-mannered and coarse [adj LOUTISHLY]\n",
  "LOUTISHLY": "LOUTISH, ill-mannered and coarse [adv]\n",
  "LOUTISHNESS": "the state of being loutish [n -ES]\n",
  "LOUTISHNESSES": "LOUTISHNESS, the state of being loutish [n]\n",
  "LOUTS": "LOUT, (obsolete) to bow, stoop, also LOWT [v]\n",
  "LOUVAR": "(Italian) a large silvery whalelike scombroid fish [n -S]\n",
  "LOUVARS": "LOUVAR, (Italian) a large silvery whalelike scombroid fish [n]\n",
  "LOUVER": "a sloping slat placed across an opening, also LOUVRE [n -S]\n",
  "LOUVERED": "having louvers, sloping slats placed across an opening, also LOUVRED [adj]\n",
  "LOUVERS": "LOUVER, a sloping slat placed across an opening, also LOUVRE [n]\n",
  "LOUVRE": "a sloping slat placed across an opening, also LOUVER [n -S]\n",
  "LOUVRED": "having a louvre [adj]\n",
  "LOUVRES": "LOUVRE, a sloping slat placed across an opening, also LOUVER [n]\n",
  "LOVABILITIES": "LOVABILITY, the state of being lovable, also LOVEABILITY [n]\n",
  "LOVABILITY": "the state of being lovable, also LOVEABILITY [n LOVABILITIES]\n",
  "LOVABLE": "worthy of love, also LOVEABLE [adj]\n",
  "LOVABLENESS": "the state of being lovable, also LOVEABLENESS [n -ES]\n",
  "LOVABLENESSES": "LOVABLENESS, the state of being lovable, also LOVEABLENESS [n]\n",
  "LOVABLY": "LOVABLE, worthy of love, also LOVEABLE [adv]\n",
  "LOVAGE": "a perennial herb [n -S]\n",
  "LOVAGES": "LOVAGE, a perennial herb [n]\n",
  "LOVASTATIN": "a drug used to lower cholesterol levels in the blood [n -S]\n",
  "LOVASTATINS": "LOVASTATIN, a drug used to lower cholesterol levels in the blood [n]\n",
  "LOVAT": "a greyish or bluish-green colour in tweed [n -S]\n",
  "LOVATS": "LOVAT, a greyish or bluish-green colour in tweed [n]\n",
  "LOVE": "to feel great affection for [v LOVED, LOVING, LOVES]\n",
  "LOVEABILITIES": "LOVEABILITY, the state of being loveable, also LOVABILITY [n]\n",
  "LOVEABILITY": "the state of being loveable, also LOVABILITY [n LOVEABILITIES]\n",
  "LOVEABLE": "worthy of love, also LOVABLE [adj]\n",
  "LOVEABLENESS": "the state of being loveable, also LOVABLENESS [n -ES]\n",
  "LOVEABLENESSES": "LOVEABLENESS, the state of being loveable, also LOVABLENESS [n]\n",
  "LOVEABLY": "LOVEABLE, worthy of love, also LOVABLE [adv]\n",
  "LOVEBIRD": "a small bird popular in aviaries [n -S]\n",
  "LOVEBIRDS": "LOVEBIRD, a small bird popular in aviaries [n]\n",
  "LOVEBITE": "a mark made by a bite given in amorous play [n -S]\n",
  "LOVEBITES": "LOVEBITE, a mark made by a bite given in amorous play [n]\n",
  "LOVEBUG": "a small black fly that swarms along highways [n -S]\n",
  "LOVEBUGS": "LOVEBUG, a small black fly that swarms along highways [n]\n",
  "LOVED": "LOVE, to feel great affection for [v]\n",
  "LOVEFEST": "an event where people talk about loving one another [n -S]\n",
  "LOVEFESTS": "LOVEFEST, an event where people talk about loving one another [n]\n",
  "LOVELESS": "without love [adj LOVELESSLY]\n",
  "LOVELESSLY": "LOVELESS, without love [adv]\n",
  "LOVELESSNESS": "the state of being loveless [n -ES]\n",
  "LOVELESSNESSES": "LOVELESSNESS, the state of being loveless [n]\n",
  "LOVELIER": "LOVELY, extremely beautiful [adj]\n",
  "LOVELIES": "LOVELY, a beautiful woman [n]\n",
  "LOVELIEST": "LOVELY, extremely beautiful [adj]\n",
  "LOVELIGHT": "an amorous look in the eyes [n -S]\n",
  "LOVELIGHTS": "LOVELIGHT, an amorous look in the eyes [n]\n",
  "LOVELIHEAD": "loveliness [n -S]\n",
  "LOVELIHEADS": "LOVELIHEAD, loveliness [n]\n",
  "LOVELILY": "LOVELY, extremely beautiful [adv]\n",
  "LOVELINESS": "the state of being lovely [n -ES]\n",
  "LOVELINESSES": "LOVELINESS, the state of being lovely [n]\n",
  "LOVELOCK": "a long lock of hair hanging prominently by itself, worn by men of fashion in the reigns of Elizabeth and James I [n -S]\n",
  "LOVELOCKS": "LOVELOCK, a long lock of hair hanging prominently by itself, worn by men of fashion in the reigns of Elizabeth and James I [n]\n",
  "LOVELORN": "not loved [adj]\n",
  "LOVELORNNESS": "the state of being lovelorn [n -ES]\n",
  "LOVELORNNESSES": "LOVELORNNESS, the state of being lovelorn [n]\n",
  "LOVELY": "a beautiful woman [n LOVELIES] / extremely beautiful [adj LOVELIER, LOVELIEST, LOVELILY]\n",
  "LOVEMAKER": "one who makes love [n -S]\n",
  "LOVEMAKERS": "LOVEMAKER, one who makes love [n]\n",
  "LOVEMAKING": "sexual play and usually intercourse [n -S]\n",
  "LOVEMAKINGS": "LOVEMAKING, sexual play and usually intercourse [n]\n",
  "LOVER": "someone who loves [n -S]\n",
  "LOVERED": "(Shakespeare) having a love [adj]\n",
  "LOVERLESS": "without a lover [adj]\n",
  "LOVERLY": "(archaic) like a lover [adj]\n",
  "LOVERS": "LOVER, someone who loves [n]\n",
  "LOVES": "LOVE, to feel great affection for [v]\n",
  "LOVESEAT": "a small sofa for two persons [n -S]\n",
  "LOVESEATS": "LOVESEAT, a small sofa for two persons [n]\n",
  "LOVESICK": "languishing with love [adj]\n",
  "LOVESICKNESS": "the state of being lovesick [n -ES]\n",
  "LOVESICKNESSES": "LOVESICKNESS, the state of being lovesick [n]\n",
  "LOVESOME": "(archaic) lovely, loving [adj]\n",
  "LOVESTRUCK": "affected by love for someone [adj]\n",
  "LOVEVINE": "a twining herb, aka dodder [n -S]\n",
  "LOVEVINES": "LOVEVINE, a twining herb, aka dodder [n]\n",
  "LOVEWORTHIER": "LOVEWORTHY, lovable [adj]\n",
  "LOVEWORTHIES": "LOVEWORTHY, a person worthy of being loved [n]\n",
  "LOVEWORTHIEST": "LOVEWORTHY, lovable [adj]\n",
  "LOVEWORTHY": "lovable [adj LOVEWORTHIER, LOVEWORTHIEST] / a person worthy of being loved [n LOVEWORTHIES]\n",
  "LOVEY": "fondly affectionate [adj LOVIER, LOVIEST] / a term of endearment, also LOVIE [n -S]\n",
  "LOVEYS": "LOVEY, a term of endearment, also LOVIE [n]\n",
  "LOVIE": "an endearment, love, also LOVEY [n -S]\n",
  "LOVIER": "LOVEY, fondly affectionate [adj]\n",
  "LOVIES": "LOVIE, an endearment, love, also LOVEY [n]\n",
  "LOVIEST": "LOVEY, fondly affectionate [adj]\n",
  "LOVING": "affectionate [adj LOVINGLY] / the act of loving [n -S]\n",
  "LOVINGLY": "LOVING, affectionate [adv]\n",
  "LOVINGNESS": "affection; kind regard [n -ES]\n",
  "LOVINGNESSES": "LOVINGNESS, affection; kind regard [n]\n",
  "LOVINGS": "LOVING, the act of loving [n]\n",
  "LOW": "to utter the sound of cattle [v -ED, -ING, -S] / not high [adj LOWER, LOWEST, LOWLY]\n",
  "LOWAN": "(Native Australian) an Australian bird, aka mallee-bird [n -S]\n",
  "LOWANS": "LOWAN, (Native Australian) an Australian bird, aka mallee-bird [n]\n",
  "LOWBALL": "to give a customer a deceptively low price [v -ED, -ING, -S]\n",
  "LOWBALLED": "LOWBALL, to give a customer a deceptively low price [v]\n",
  "LOWBALLING": "the practice of giving a customer a deceptively low price [n -S]\n",
  "LOWBALLINGS": "LOWBALLING, the practice of giving a customer a deceptively low price [n]\n",
  "LOWBALLS": "LOWBALL, to give a customer a deceptively low price [v]\n",
  "LOWBORN": "of humble birth [adj]\n",
  "LOWBOY": "a low chest of drawers [n -S]\n",
  "LOWBOYS": "LOWBOY, a low chest of drawers [n]\n",
  "LOWBRED": "of a low station in life [adj]\n",
  "LOWBROW": "a person who is not intellectual [n -S]\n",
  "LOWBROWED": "not intellectual [adj]\n",
  "LOWBROWISM": "the state of being a lowbrow [n -S]\n",
  "LOWBROWISMS": "LOWBROWISM, the state of being a lowbrow [n]\n",
  "LOWBROWS": "LOWBROW, a person who is not intellectual [n]\n",
  "LOWBUSH": "a bush with sweet blueberries [n -ES]\n",
  "LOWBUSHES": "LOWBUSH, a bush with sweet blueberries [n]\n",
  "LOWDOWN": "the real information about something [n -S]\n",
  "LOWDOWNS": "LOWDOWN, the real information about something [n]\n",
  "LOWE": "(Scots) to blaze [v LOWED, LOWING, LOWES]\n",
  "LOWED": "LOW, to utter the sound of cattle [v]\n",
  "LOWER": "to appear dark and threatening, also LOUR [v -ED, -ING, -S]\n",
  "LOWERABLE": "that can be lowered [adj]\n",
  "LOWERCASE": "in printing, small as distinguished from capital [n -S] / to make lower case [v LOWERCASED, LOWERCASING, LOWERCASES]\n",
  "LOWERCASED": "LOWERCASE, to make lower case [v]\n",
  "LOWERCASES": "LOWERCASE, to make lower case [v]\n",
  "LOWERCASING": "LOWERCASE, to make lower case [v]\n",
  "LOWERCLASSMAN": "a freshman or sophomore [n LOWERCLASSMEN]\n",
  "LOWERCLASSMEN": "LOWERCLASSMAN, a freshman or sophomore [n]\n",
  "LOWERED": "LOWER, to appear dark and threatening, also LOUR [v]\n",
  "LOWERIER": "LOWERY, cloudy, gloomy, lowering, also LOURY [adj]\n",
  "LOWERIEST": "LOWERY, cloudy, gloomy, lowering, also LOURY [adj]\n",
  "LOWERING": "overcast, threatening [adj LOWERINGLY] / the act of lowering [n -S]\n",
  "LOWERINGLY": "LOWERING, overcast, threatening [adv]\n",
  "LOWERINGS": "LOWERING, the act of lowering [n]\n",
  "LOWERMOST": "lowest [adj]\n",
  "LOWERS": "LOWER, to appear dark and threatening, also LOUR [v]\n",
  "LOWERY": "cloudy, gloomy, lowering, also LOURY [adj LOWERIER, LOWERIEST]\n",
  "LOWES": "LOWE, (Scots) to blaze [v]\n",
  "LOWEST": "LOW, not high [adj]\n",
  "LOWING": "the sound of cattle [n -S]\n",
  "LOWINGS": "LOWING, the sound of cattle [n]\n",
  "LOWISH": "somewhat low [adj]\n",
  "LOWLAND": "an area of land lying lower than the adjacent country, also LALLAN, LALLAND, LAWLAND [n -S]\n",
  "LOWLANDER": "one who lives in the lowlands [n -S]\n",
  "LOWLANDERS": "LOWLANDER, one who lives in the lowlands [n]\n",
  "LOWLANDS": "LOWLAND, an area of land lying lower than the adjacent country, also LALLAN, LALLAND, LAWLAND [n]\n",
  "LOWLIER": "LOWLY, in a low position or rank [adj]\n",
  "LOWLIEST": "LOWLY, in a low position or rank [adj]\n",
  "LOWLIFE": "a despicable person, also LOWLIFER [n LOWLIFES or LOWLIVES]\n",
  "LOWLIFER": "a despicable person, also LOWLIFE [n -S]\n",
  "LOWLIFERS": "LOWLIFER, a despicable person, also LOWLIFE [n]\n",
  "LOWLIFES": "LOWLIFE, a despicable person, also LOWLIFER [n]\n",
  "LOWLIGHT": "to enhance the natural colour of the hair [v -ED, -ING, -S]\n",
  "LOWLIGHTED": "LOWLIGHT, to enhance the natural colour of the hair [v]\n",
  "LOWLIGHTING": "LOWLIGHT, to enhance the natural colour of the hair [v]\n",
  "LOWLIGHTS": "LOWLIGHT, to enhance the natural colour of the hair [v]\n",
  "LOWLIHEAD": "(archaic) humility [n -S]\n",
  "LOWLIHEADS": "LOWLIHEAD, (archaic) humility [n]\n",
  "LOWLILY": "LOWLY, in a low position or rank [adv]\n",
  "LOWLINESS": "the state of being lowly [n -ES]\n",
  "LOWLINESSES": "LOWLINESS, the state of being lowly [n]\n",
  "LOWLIVES": "LOWLIFE, a despicable person, also LOWLIFER [n]\n",
  "LOWLY": "in a low position or rank [adj LOWLIER, LOWLIEST, LOWLILY]\n",
  "LOWN": "(Scots) sheltered, calm, quiet [adj] / to calm, also LOUN, LOUND, LOWND, LOWNE [v -ED, -ING, -S]\n",
  "LOWND": "(Scots) sheltered, calm, quiet [adj] / to calm, also LOUN, LOUND, LOWN, LOWNE [v -ED, -ING, -S]\n",
  "LOWNDED": "LOWND, to calm, also LOUN, LOUND, LOWN, LOWNE [v]\n",
  "LOWNDING": "LOWND, to calm, also LOUN, LOUND, LOWN, LOWNE [v]\n",
  "LOWNDS": "LOWND, to calm, also LOUN, LOUND, LOWN, LOWNE [v]\n",
  "LOWNE": "(Scots) sheltered, calm, quiet [adj] / to calm, also LOUN, LOUND, LOWN, LOWND [v LOWNED, LOWNING, LOWNES]\n",
  "LOWNED": "LOWN, to calm, also LOUN, LOUND, LOWND, LOWNE [v]\n",
  "LOWNES": "LOWNE, to calm, also LOUN, LOUND, LOWN, LOWND [v]\n",
  "LOWNESS": "the state of being low [n -ES]\n",
  "LOWNESSES": "LOWNESS, the state of being low [n]\n",
  "LOWNING": "LOWN, to calm, also LOUN, LOUND, LOWND, LOWNE [v]\n",
  "LOWNS": "LOWN, to calm, also LOUN, LOUND, LOWND, LOWNE [v]\n",
  "LOWP": "(Scots) to leap, also LOUP [v -ED, -ING, -S]\n",
  "LOWPASS": "designating a type of filter [adj]\n",
  "LOWPED": "LOWP, (Scots) to leap, also LOUP [v]\n",
  "LOWPING": "LOWP, (Scots) to leap, also LOUP [v]\n",
  "LOWPS": "LOWP, (Scots) to leap, also LOUP [v]\n",
  "LOWRIDER": "a car having a lowered suspension [n -S]\n",
  "LOWRIDERS": "LOWRIDER, a car having a lowered suspension [n]\n",
  "LOWRIE": "a kind of small parrot, also LOERIE, LORY, LOURIE, LOWRY [n -S]\n",
  "LOWRIES": "LOWRY, a kind of small parrot, also LOERIE, LORY, LOURIE, LOWRIE [n]\n",
  "LOWRY": "a kind of small parrot, also LOERIE, LORY, LOURIE, LOWRIE [n LOWRIES]\n",
  "LOWS": "LOW, to utter the sound of cattle [v]\n",
  "LOWSE": "(Scots) loose [adj LOWSER, LOWSEST] / to loosen [v LOWSIT or LOWSED, LOWSING, LOWSES]\n",
  "LOWSED": "LOWSE, to loosen [v]\n",
  "LOWSENING": "the celebration of a twenty-first birthday, also LOOSING [n -S]\n",
  "LOWSENINGS": "LOWSENING, the celebration of a twenty-first birthday, also LOOSING [n]\n",
  "LOWSER": "LOWSE, (Scots) loose [adj]\n",
  "LOWSES": "LOWSE, to loosen [v]\n",
  "LOWSEST": "LOWSE, (Scots) loose [adj]\n",
  "LOWSING": "LOWSE, to loosen [v]\n",
  "LOWSIT": "LOWSE, to loosen [v]\n",
  "LOWT": "(obsolete) to bow, stoop, also LOUT [v -ED, -ING, -S]\n",
  "LOWTED": "LOWT, (obsolete) to bow, stoop, also LOUT [v]\n",
  "LOWTING": "LOWT, (obsolete) to bow, stoop, also LOUT [v]\n",
  "LOWTS": "LOWT, (obsolete) to bow, stoop, also LOUT [v]\n",
  "LOWVELD": "(South African) the lower altitude areas of the eastern Transvaal [n -S]\n",
  "LOWVELDS": "LOWVELD, (South African) the lower altitude areas of the eastern Transvaal [n]\n",
  "LOX": "to supply with loxygen (liquid oxygen) [v -ED, -ING, -ES]\n",
  "LOXED": "LOX, to supply with loxygen (liquid oxygen) [v]\n",
  "LOXES": "LOX, to supply with loxygen (liquid oxygen) [v]\n",
  "LOXING": "LOX, to supply with loxygen (liquid oxygen) [v]\n",
  "LOXODROME": "a line on the globe equally oblique to all meridians [n -S]\n",
  "LOXODROMES": "LOXODROME, a line on the globe equally oblique to all meridians [n]\n",
  "LOXODROMIC": "pertaining to sailing on rhumb lines; as, loxodromic tables, also LOXODROMICAL [adj LOXODROMICALLY]\n",
  "LOXODROMICAL": "pertaining to sailing on rhumb lines, also LOXODROMIC [adj LOXODROMICALLY]\n",
  "LOXODROMICALLY": "LOXODROMICAL, pertaining to sailing on rhumb lines, also LOXODROMIC [adv]\n",
  "LOXODROMICS": "the art of sailing along rhumb-lines [n]\n",
  "LOXODROMIES": "LOXODROMY, the art of sailing along rhumb-lines [n]\n",
  "LOXODROMY": "the art of sailing along rhumb-lines [n LOXODROMIES]\n",
  "LOXYGEN": "liquid oxygen, also LOX [n -S]\n",
  "LOXYGENS": "LOXYGEN, liquid oxygen, also LOX [n]\n",
  "LOY": "a long, narrow spade with a footrest on one side of the handle [n -S]\n",
  "LOYAL": "faithful [adj LOYALLER or LOYALER, LOYALLEST or LOYALEST]\n",
  "LOYALER": "LOYAL, faithful [adj]\n",
  "LOYALEST": "LOYAL, faithful [adj]\n",
  "LOYALISM": "the state of being loyal, also LOYALTY [n -S]\n",
  "LOYALISMS": "LOYALISM, the state of being loyal, also LOYALTY [n]\n",
  "LOYALIST": "one who is loyal [n -S]\n",
  "LOYALISTS": "LOYALIST, one who is loyal [n]\n",
  "LOYALLER": "LOYAL, faithful [adj]\n",
  "LOYALLEST": "LOYAL, faithful [adj]\n",
  "LOYALLY": "LOYAL, faithful [adv]\n",
  "LOYALNESS": "the state of being loyal [n -ES]\n",
  "LOYALNESSES": "LOYALNESS, the state of being loyal [n]\n",
  "LOYALTIES": "LOYALTY, the state of being loyal, also LOYALISM [n]\n",
  "LOYALTY": "the state of being loyal, also LOYALISM [n LOYALTIES]\n",
  "LOYS": "LOY, a long, narrow spade with a footrest on one side of the handle [n]\n",
  "LOZELL": "(Spenser) a good for nothing fellow, also LOREL, LORRELL, LOSEL [n -S]\n",
  "LOZELLS": "LOZELL, (Spenser) a good for nothing fellow, also LOREL, LORRELL, LOSEL [n]\n",
  "LOZEN": "(Scots) a windowpane [n -S]\n",
  "LOZENGE": "a rhombus or diamond-shaped figure [n -S]\n",
  "LOZENGED": "divided into lozenges [adj]\n",
  "LOZENGES": "LOZENGE, a rhombus or diamond-shaped figure [n]\n",
  "LOZENGIER": "LOZENGY, with lozenges [adj]\n",
  "LOZENGIEST": "LOZENGY, with lozenges [adj]\n",
  "LOZENGY": "with lozenges [adj LOZENGIER, LOZENGIEST]\n",
  "LOZENS": "LOZEN, (Scots) a windowpane [n]\n",
  "LUACH": "(Hebrew) an inscribed tablet of Commandments [n LUCHOT or LUCHOTH]\n",
  "LUAU": "(Hawaiian) a dish made of coconut, octopus etc. [n -S]\n",
  "LUAUS": "LUAU, (Hawaiian) a dish made of coconut, octopus etc. [n]\n",
  "LUBBARD": "a clumsy fellow, also LUBBER [n -S]\n",
  "LUBBARDS": "LUBBARD, a clumsy fellow, also LUBBER [n]\n",
  "LUBBER": "a clumsy fellow, also LUBBARD [n -S]\n",
  "LUBBERLIER": "LUBBERLY, like a lubber, clumsy [adj]\n",
  "LUBBERLIEST": "LUBBERLY, like a lubber, clumsy [adj]\n",
  "LUBBERLINESS": "the state of being lubberly [n -ES]\n",
  "LUBBERLINESSES": "LUBBERLINESS, the state of being lubberly [n]\n",
  "LUBBERLY": "like a lubber, clumsy [adj LUBBERLIER, LUBBERLIEST]\n",
  "LUBBERS": "LUBBER, a clumsy fellow, also LUBBARD [n]\n",
  "LUBE": "to lubricate [v LUBED, LUBING, LUBES]\n",
  "LUBED": "LUBE, to lubricate [v]\n",
  "LUBES": "LUBE, to lubricate [v]\n",
  "LUBFISH": "a kind of stockfish [n -ES]\n",
  "LUBFISHES": "LUBFISH, a kind of stockfish [n]\n",
  "LUBING": "LUBE, to lubricate [v]\n",
  "LUBRA": "(Native Australian) an aboriginal woman [n -S]\n",
  "LUBRAS": "LUBRA, (Native Australian) an aboriginal woman [n]\n",
  "LUBRIC": "(archaic) lubricious, also LUBRICAL, LUBRICOUS [adj]\n",
  "LUBRICAL": "(archaic) lubricious, also LUBRIC, LUBRICOUS [adj]\n",
  "LUBRICANT": "a substance used to reduce friction [n -S]\n",
  "LUBRICANTS": "LUBRICANT, a substance used to reduce friction [n]\n",
  "LUBRICATE": "to make smooth or slippery [v LUBRICATED, LUBRICATING, LUBRICATES]\n",
  "LUBRICATED": "LUBRICATE, to make smooth or slippery [v]\n",
  "LUBRICATES": "LUBRICATE, to make smooth or slippery [v]\n",
  "LUBRICATING": "LUBRICATE, to make smooth or slippery [v]\n",
  "LUBRICATION": "the act of lubricating [n -S]\n",
  "LUBRICATIONAL": "relating to lubrication [adj]\n",
  "LUBRICATIONS": "LUBRICATION, the act of lubricating [n]\n",
  "LUBRICATIVE": "serving to lubricate [adj]\n",
  "LUBRICATOR": "one who, or that which, lubricates [n -S]\n",
  "LUBRICATORS": "LUBRICATOR, one who, or that which, lubricates [n]\n",
  "LUBRICIOUS": "slippery; lewd, also LUBRIC, LUBRICAL, LUBRICOUS [adj LUBRICIOUSLY]\n",
  "LUBRICIOUSLY": "LUBRICIOUS, slippery; lewd, also LUBRIC, LUBRICAL, LUBRICOUS [adv]\n",
  "LUBRICITIES": "LUBRICITY, slipperiness; lewdness [n]\n",
  "LUBRICITY": "slipperiness; lewdness [n LUBRICITIES]\n",
  "LUBRICOUS": "slippery; lewd, also LUBRIC, LUBRICAL, LUBRICIOUS [adj LUBRICOUSLY]\n",
  "LUBRICOUSLY": "LUBRICOUS, slippery; lewd, also LUBRIC, LUBRICAL, LUBRICIOUS [adv]\n",
  "LUBRITORIA": "LUBRITORIUM, a place in a garage or service station where motor vehicles are lubricated [n]\n",
  "LUBRITORIUM": "a place in a garage or service station where motor vehicles are lubricated [n LUBRITORIUMS or LUBRITORIA]\n",
  "LUBRITORIUMS": "LUBRITORIUM, a place in a garage or service station where motor vehicles are lubricated [n]\n",
  "LUCARNE": "(French) a dormer window [n -S]\n",
  "LUCARNES": "LUCARNE, (French) a dormer window [n]\n",
  "LUCE": "the pike or jack, a freshwater fish [n -S]\n",
  "LUCENCE": "the quality of being lucent, also LUCENCY [n -S]\n",
  "LUCENCES": "LUCENCE, the quality of being lucent, also LUCENCY [n]\n",
  "LUCENCIES": "LUCENCY, the quality of being lucent, also LUCENCE [n]\n",
  "LUCENCY": "the quality of being lucent, also LUCENCE [n LUCENCIES]\n",
  "LUCENT": "shining, bright [adj LUCENTLY]\n",
  "LUCENTLY": "LUCENT, shining, bright [adv]\n",
  "LUCERN": "a fodder plant, aka alfalfa, also LUCERNE, LUZERN [n -S]\n",
  "LUCERNE": "a fodder plant, aka alfalfa, also LUCERN, LUZERN [n -S]\n",
  "LUCERNES": "LUCERNE, a fodder plant, aka alfalfa, also LUCERN, LUZERN [n]\n",
  "LUCERNS": "LUCERN, a fodder plant, aka alfalfa, also LUCERNE, LUZERN [n]\n",
  "LUCES": "LUCE, the pike or jack, a freshwater fish [n]\n",
  "LUCHOT": "LUACH, (Hebrew) an inscribed tablet of Commandments [n]\n",
  "LUCHOTH": "LUACH, (Hebrew) an inscribed tablet of Commandments [n]\n",
  "LUCID": "easily understood [adj LUCIDER, LUCIDEST, LUCIDLY]\n",
  "LUCIDER": "LUCID, easily understood [adj]\n",
  "LUCIDEST": "LUCID, easily understood [adj]\n",
  "LUCIDITIES": "LUCIDITY, the quality of being lucid [n]\n",
  "LUCIDITY": "the quality of being lucid [n LUCIDITIES]\n",
  "LUCIDLY": "LUCID, easily understood [adv]\n",
  "LUCIDNESS": "the quality of being lucid, also LUCIDITY [n -ES]\n",
  "LUCIDNESSES": "LUCIDNESS, the quality of being lucid, also LUCIDITY [n]\n",
  "LUCIFER": "a friction match [n -S]\n",
  "LUCIFERASE": "an oxidising enzyme in the luminous organs of certain animals that acts on luciferin to produce bioluminescence [n -S]\n",
  "LUCIFERASES": "LUCIFERASE, an oxidising enzyme in the luminous organs of certain animals that acts on luciferin to produce bioluminescence [n]\n",
  "LUCIFERIN": "a protein-like substance in the luminous organs of certain animals, which is acted on by the enzyme luciferase to produce bioluminescence [n -S]\n",
  "LUCIFERINS": "LUCIFERIN, a protein-like substance in the luminous organs of certain animals, which is acted on by the enzyme luciferase to produce bioluminescence [n]\n",
  "LUCIFEROUS": "light-bringing; light-giving [adj]\n",
  "LUCIFERS": "LUCIFER, a friction match [n]\n",
  "LUCIFUGOUS": "shunning or avoiding light [adj]\n",
  "LUCIGEN": "a lamp burning oil mixed with air in a spray [n -S]\n",
  "LUCIGENS": "LUCIGEN, a lamp burning oil mixed with air in a spray [n]\n",
  "LUCITE": "a type of transparent acrylic-based plastic [n -S]\n",
  "LUCITES": "LUCITE, a type of transparent acrylic-based plastic [n]\n",
  "LUCK": "to succeed by chance or good fortune [v -ED, -ING, -S]\n",
  "LUCKED": "LUCK, to succeed by chance or good fortune [v]\n",
  "LUCKEN": "(Scots) closed [adj]\n",
  "LUCKENBOOTH": "(Scots) a shop or booth esp. in 18th century Edinburgh [n -S]\n",
  "LUCKENBOOTHS": "LUCKENBOOTH, (Scots) a shop or booth esp. in 18th century Edinburgh [n]\n",
  "LUCKENGOWAN": "(Scots) the globeflower [n -S]\n",
  "LUCKENGOWANS": "LUCKENGOWAN, (Scots) the globeflower [n]\n",
  "LUCKIE": "an elderly woman who keeps an alehouse, also LUCKY [n -S]\n",
  "LUCKIER": "LUCKY, fortunate [adj]\n",
  "LUCKIES": "LUCKIE, an elderly woman who keeps an alehouse, also LUCKY [n]\n",
  "LUCKIEST": "LUCKY, fortunate [adj]\n",
  "LUCKILY": "LUCKY, fortunate [adv]\n",
  "LUCKINESS": "the state of being lucky [n -ES]\n",
  "LUCKINESSES": "LUCKINESS, the state of being lucky [n]\n",
  "LUCKING": "LUCK, to succeed by chance or good fortune [v]\n",
  "LUCKLESS": "unlucky [adj LUCKLESSLY]\n",
  "LUCKLESSLY": "LUCKLESS, unlucky [adv]\n",
  "LUCKLESSNESS": "the state of being luckless [n -ES]\n",
  "LUCKLESSNESSES": "LUCKLESSNESS, the state of being luckless [n]\n",
  "LUCKPENNIES": "LUCKPENNY, a coin kept for luck [n]\n",
  "LUCKPENNY": "a coin kept for luck [n LUCKPENNIES]\n",
  "LUCKS": "LUCK, to succeed by chance or good fortune [v]\n",
  "LUCKY": "fortunate [adj LUCKIER, LUCKIEST, LUCKILY] / an elderly woman who keeps an alehouse, also LUCKIE [n LUCKIES]\n",
  "LUCRATIVE": "yielding lucre; profitable [adj LUCRATIVELY]\n",
  "LUCRATIVELY": "LUCRATIVE, yielding lucre; profitable [adv]\n",
  "LUCRATIVENESS": "LUCRATIVE, yielding lucre; profitable [n]\n",
  "LUCRATIVENESSES": "LUCRATIVENESS, LUCRATIVE, yielding lucre; profitable [n]\n",
  "LUCRE": "sordid gain; riches [n -S]\n",
  "LUCRES": "LUCRE, sordid gain; riches [n]\n",
  "LUCTATION": "(obsolete) a struggle [n -S]\n",
  "LUCTATIONS": "LUCTATION, (obsolete) a struggle [n]\n",
  "LUCUBRATE": "to study by lamplight; to discourse learnedly or pedantically [v LUCUBRATED, LUCUBRATING, LUCUBRATES]\n",
  "LUCUBRATED": "LUCUBRATE, to study by lamplight; to discourse learnedly or pedantically [v]\n",
  "LUCUBRATES": "LUCUBRATE, to study by lamplight; to discourse learnedly or pedantically [v]\n",
  "LUCUBRATING": "LUCUBRATE, to study by lamplight; to discourse learnedly or pedantically [v]\n",
  "LUCUBRATION": "laborious or intensive study [n -S]\n",
  "LUCUBRATIONS": "LUCUBRATION, laborious or intensive study [n]\n",
  "LUCUBRATOR": "a person who studies during the night [n -S]\n",
  "LUCUBRATORS": "LUCUBRATOR, a person who studies during the night [n]\n",
  "LUCULENT": "readily understood; lucid [adj LUCULENTLY]\n",
  "LUCULENTLY": "LUCULENT, readily understood; lucid [adv]\n",
  "LUCUMA": "(Quechua) a tree of the Lucuma genus of sapotaceous trees with edible fruit, mostly found in South America [n -S]\n",
  "LUCUMAS": "LUCUMA, (Quechua) a tree of the Lucuma genus of sapotaceous trees with edible fruit, mostly found in South America [n]\n",
  "LUCUMO": "(Latin) an Etruscan prince [n LUCUMOS or LUCUMONES]\n",
  "LUCUMONES": "LUCUMO, (Latin) an Etruscan prince [n]\n",
  "LUCUMOS": "LUCUMO, (Latin) an Etruscan prince [n]\n",
  "LUD": "lord, used when addressing a judge, also LUDSHIP [n -S]\n",
  "LUDE": "a type of sedative pill [n -S]\n",
  "LUDERICK": "(Native Australian) an estuarine and rock fish of Australia [n -S]\n",
  "LUDERICKS": "LUDERICK, (Native Australian) an estuarine and rock fish of Australia [n]\n",
  "LUDES": "LUDE, a type of sedative pill [n]\n",
  "LUDIC": "aimlessly playful [adj LUDICALLY]\n",
  "LUDICALLY": "LUDIC, aimlessly playful [adv]\n",
  "LUDICROUS": "ridiculous [adj LUDICROUSLY]\n",
  "LUDICROUSLY": "LUDICROUS, ridiculous [adv]\n",
  "LUDICROUSNESS": "LUDICROUS, ridiculous [n]\n",
  "LUDICROUSNESSES": "LUDICROUSNESS, LUDICROUS, ridiculous [n]\n",
  "LUDO": "a simple board game played with dice and counters in which the aim is to be the first to reach a destination [n -S]\n",
  "LUDOS": "LUDO, a simple board game played with dice and counters in which the aim is to be the first to reach a destination [n]\n",
  "LUDS": "LUD, lord, used when addressing a judge, also LUDSHIP [n]\n",
  "LUDSHIP": "lordship, used when addressing a judge, also LUD [n -S]\n",
  "LUDSHIPS": "LUDSHIP, lordship, used when addressing a judge, also LUD [n]\n",
  "LUES": "(Latin) disease, esp. of a contagious kind [n LUES]\n",
  "LUETIC": "infected with syphilis [adj LUETICALLY] / someone infected with syphilis [n -S]\n",
  "LUETICALLY": "LUETIC, infected with syphilis [adv]\n",
  "LUETICS": "LUETIC, someone infected with syphilis [n]\n",
  "LUFF": "to steer a sailing vessel nearer into the wind [v -ED, -ING, -S]\n",
  "LUFFA": "(Arabic) a kind of vine, whose fibrous gourdlike fruit is used as sponge, also LOOFA, LOOFAH [n -S]\n",
  "LUFFAS": "LUFFA, (Arabic) a kind of vine, whose fibrous gourdlike fruit is used as sponge, also LOOFA, LOOFAH [n]\n",
  "LUFFED": "LUFF, to steer a sailing vessel nearer into the wind [v]\n",
  "LUFFING": "LUFF, to steer a sailing vessel nearer into the wind [v]\n",
  "LUFFS": "LUFF, to steer a sailing vessel nearer into the wind [v]\n",
  "LUFTMENSCH": "(Yiddish) an impractical dreamer having no definite business or income [n LUFTMENSCHEN]\n",
  "LUFTMENSCHEN": "LUFTMENSCH, (Yiddish) an impractical dreamer having no definite business or income [n]\n",
  "LUG": "to drag heavily [v LUGGED, LUGGING, LUGS]\n",
  "LUGE": "to race on a small sled [v LUGED, LUGEING or LUGING, LUGES]\n",
  "LUGED": "LUGE, to race on a small sled [v]\n",
  "LUGEING": "the act of tobogganing on a luge [n -S]\n",
  "LUGEINGS": "LUGEING, the act of tobogganing on a luge [n]\n",
  "LUGER": "one who rides a luge [n -S]\n",
  "LUGERS": "LUGER, one who rides a luge [n]\n",
  "LUGES": "LUGE, to race on a small sled [v]\n",
  "LUGGABLE": "a computer that is portable with difficulty [n -S]\n",
  "LUGGABLES": "LUGGABLE, a computer that is portable with difficulty [n]\n",
  "LUGGAGE": "baggage of a traveller [n -S]\n",
  "LUGGAGES": "LUGGAGE, baggage of a traveller [n]\n",
  "LUGGED": "LUG, to drag heavily [v]\n",
  "LUGGER": "a small 2- or 3-masted fishing boat with lugsails and jibs on bowsprit [n -S]\n",
  "LUGGERS": "LUGGER, a small 2- or 3-masted fishing boat with lugsails and jibs on bowsprit [n]\n",
  "LUGGIE": "(Scots) a hooped dish with one long stave [n -S]\n",
  "LUGGIES": "LUGGIE, (Scots) a hooped dish with one long stave [n]\n",
  "LUGGING": "LUG, to drag heavily [v]\n",
  "LUGHOLE": "(colloquial) the ear [n -S]\n",
  "LUGHOLES": "LUGHOLE, (colloquial) the ear [n]\n",
  "LUGING": "the act of tobogganing on a luge, also LUGEING [n -S]\n",
  "LUGINGS": "LUGING, the act of tobogganing on a luge, also LUGEING [n]\n",
  "LUGS": "LUG, to drag heavily [v]\n",
  "LUGSAIL": "a four-sided sail bent to an obliquely hanging yard [n -S]\n",
  "LUGSAILS": "LUGSAIL, a four-sided sail bent to an obliquely hanging yard [n]\n",
  "LUGUBRIOUS": "mournful, dismal, esp. in an exaggerated or affected manner [adj LUGUBRIOUSLY]\n",
  "LUGUBRIOUSLY": "LUGUBRIOUS, mournful, dismal, esp. in an exaggerated or affected manner [adv]\n",
  "LUGUBRIOUSNESS": "LUGUBRIOUS, mournful, dismal, esp. in an exaggerated or affected manner [n]\n",
  "LUGWORM": "a burrowing marine worm, much used as fishing bait, also LOBWORM [n -S]\n",
  "LUGWORMS": "LUGWORM, a burrowing marine worm, much used as fishing bait, also LOBWORM [n]\n",
  "LUIT": "LET, to allow [v]\n",
  "LUITEN": "LET, to allow [v]\n",
  "LUKE": "moderately warm; tepid, also LUKEWARM [adj]\n",
  "LUKEWARM": "moderately warm [adj LUKEWARMLY]\n",
  "LUKEWARMISH": "somewhat lukewarm [adj]\n",
  "LUKEWARMLY": "LUKEWARM, moderately warm [adv]\n",
  "LUKEWARMNESS": "the state of being lukewarm [n -ES]\n",
  "LUKEWARMNESSES": "LUKEWARMNESS, the state of being lukewarm [n]\n",
  "LUKEWARMTH": "the state of being lukewarm [n -S]\n",
  "LUKEWARMTHS": "LUKEWARMTH, the state of being lukewarm [n]\n",
  "LULIBUB": "(archaic) a piece of candy on the end of a stick, also LOLLIPOP, LOLLYPOP [n -S]\n",
  "LULIBUBS": "LULIBUB, (archaic) a piece of candy on the end of a stick, also LOLLIPOP, LOLLYPOP [n]\n",
  "LULL": "to cause to sleep or rest [v -ED, -ING, -S]\n",
  "LULLABIED": "LULLABY, to lull to sleep with a soothing song [v]\n",
  "LULLABIES": "LULLABY, to lull to sleep with a soothing song [v]\n",
  "LULLABY": "to lull to sleep with a soothing song [v LULLABIED, LULLABYING, LULLABIES]\n",
  "LULLABYING": "LULLABY, to lull to sleep with a soothing song [v]\n",
  "LULLED": "LULL, to cause to sleep or rest [v]\n",
  "LULLER": "one who lulls [n -S]\n",
  "LULLERS": "LULLER, one who lulls [n]\n",
  "LULLING": "LULL, to cause to sleep or rest [v]\n",
  "LULLINGLY": "in a lulling manner [adv]\n",
  "LULLS": "LULL, to cause to sleep or rest [v]\n",
  "LULU": "an outstandingly bad or impressive person or thing [n -S]\n",
  "LULUS": "LULU, an outstandingly bad or impressive person or thing [n]\n",
  "LULZ": "(slang) amusement derived from mischievous or provocative behaviour on the Internet, also LOLZ [n]\n",
  "LUM": "(Scots) a chimney [n -S]\n",
  "LUMA": "a unit of currency of Armenia, also LOUMA [n -S]\n",
  "LUMAS": "LUMA, a unit of currency of Armenia, also LOUMA [n]\n",
  "LUMBAGINOUS": "relating to lumbago [adj]\n",
  "LUMBAGO": "(Latin) inflammation of the lumbar muscles and tendons [n -S]\n",
  "LUMBAGOS": "LUMBAGO, (Latin) inflammation of the lumbar muscles and tendons [n]\n",
  "LUMBANG": "(Tagalog) the candlenut tree [n -S]\n",
  "LUMBANGS": "LUMBANG, (Tagalog) the candlenut tree [n]\n",
  "LUMBAR": "an anatomical part situated near the loins [n -S]\n",
  "LUMBARS": "LUMBAR, an anatomical part situated near the loins [n]\n",
  "LUMBER": "to move heavily and clumsily [v -ED, -ING, -S]\n",
  "LUMBERED": "LUMBER, to move heavily and clumsily [v]\n",
  "LUMBERER": "someone employed in the felling, sawing etc. of timber, also LUMBERJACK, LUMBERMAN [n -S]\n",
  "LUMBERERS": "LUMBERER, someone employed in the felling, sawing etc. of timber, also LUMBERJACK, LUMBERMAN [n]\n",
  "LUMBERING": "walking heavily [adj LUMBERINGLY] / the act of lumbering [n -S]\n",
  "LUMBERINGLY": "LUMBERING, walking heavily [adv]\n",
  "LUMBERINGNESS": "LUMBERING, walking heavily [n]\n",
  "LUMBERINGNESSES": "LUMBERINGNESS, LUMBERING, walking heavily [n]\n",
  "LUMBERINGS": "LUMBERING, the act of lumbering [n]\n",
  "LUMBERJACK": "someone employed in the felling, sawing etc. of timber, also LUMBERER, LUMBERMAN [n -S]\n",
  "LUMBERJACKET": "a man's jacket, usually in bold-patterned heavy material [n -S]\n",
  "LUMBERJACKETS": "LUMBERJACKET, a man's jacket, usually in bold-patterned heavy material [n]\n",
  "LUMBERJACKS": "LUMBERJACK, someone employed in the felling, sawing etc. of timber, also LUMBERER, LUMBERMAN [n]\n",
  "LUMBERLY": "lumbering [adj]\n",
  "LUMBERMAN": "someone employed in the felling, sawing etc. of timber, also LUMBERER, LUMBERJACK [n LUMBERMEN]\n",
  "LUMBERMEN": "LUMBERMAN, someone employed in the felling, sawing etc. of timber, also LUMBERER, LUMBERJACK [n]\n",
  "LUMBERS": "LUMBER, to move heavily and clumsily [v]\n",
  "LUMBERSOME": "lumbering [adj]\n",
  "LUMBERSOMENESS": "LUMBERSOME, lumbering [n]\n",
  "LUMBERYARD": "a yard where a stock of lumber is kept for sale [n -S]\n",
  "LUMBERYARDS": "LUMBERYARD, a yard where a stock of lumber is kept for sale [n]\n",
  "LUMBI": "LUMBUS, (Latin) the part of the lower back and sides between the pelvis and the ribs [n]\n",
  "LUMBOSACRAL": "relating to the lumbar sacral region [adj]\n",
  "LUMBRICAL": "one of certain muscles of the hand and foot used in flexing the digits, also LUMBRICALIS [n LUMBRICALS or LUMBRICALES]\n",
  "LUMBRICALES": "LUMBRICAL, one of certain muscles of the hand and foot used in flexing the digits, also LUMBRICALIS [n]\n",
  "LUMBRICALIS": "one of certain muscles of the hand and foot used in flexing the digits, also LUMBRICAL [n LUMBRICALISES]\n",
  "LUMBRICALISES": "LUMBRICALIS, one of certain muscles of the hand and foot used in flexing the digits, also LUMBRICAL [n]\n",
  "LUMBRICALS": "LUMBRICAL, one of certain muscles of the hand and foot used in flexing the digits, also LUMBRICALIS [n]\n",
  "LUMBRICI": "LUMBRICUS, (Latin) a genus of annelids including the common earthworm [n]\n",
  "LUMBRICIFORM": "shaped like a worm [adj]\n",
  "LUMBRICOID": "wormlike [adj]\n",
  "LUMBRICUS": "(Latin) a genus of annelids including the common earthworm [n LUMBRICUSES or LUMBRICI]\n",
  "LUMBRICUSES": "LUMBRICUS, (Latin) a genus of annelids including the common earthworm [n]\n",
  "LUMBUS": "(Latin) the part of the lower back and sides between the pelvis and the ribs [n LUMBI]\n",
  "LUMEN": "(Latin) a unit of luminous flux [n LUMENS or LUMINA]\n",
  "LUMENAL": "of a lumen, a unit of luminous flux, also LUMINAL [adj]\n",
  "LUMENS": "LUMEN, (Latin) a unit of luminous flux [n]\n",
  "LUMINA": "LUMEN, (Latin) a unit of luminous flux [n]\n",
  "LUMINAIRE": "(French) the British Standards Institute term for a light fitting [n -S]\n",
  "LUMINAIRES": "LUMINAIRE, (French) the British Standards Institute term for a light fitting [n]\n",
  "LUMINAL": "pertaining to a lumen, a unit of luminous flux, also LUMENAL [adj]\n",
  "LUMINANCE": "the measure of the brightness of a surface [n -S]\n",
  "LUMINANCES": "LUMINANCE, the measure of the brightness of a surface [n]\n",
  "LUMINANT": "a means of lighting [n -S]\n",
  "LUMINANTS": "LUMINANT, a means of lighting [n]\n",
  "LUMINARIA": "a traditional Mexican Christmas lantern originally consisting of a candle set in sand inside a paper bag [n -S]\n",
  "LUMINARIAS": "LUMINARIA, a traditional Mexican Christmas lantern originally consisting of a candle set in sand inside a paper bag [n]\n",
  "LUMINARIES": "LUMINARY, a body that gives light [n]\n",
  "LUMINARISM": "painting that shows great mastery of light and shade [n -S]\n",
  "LUMINARISMS": "LUMINARISM, painting that shows great mastery of light and shade [n]\n",
  "LUMINARIST": "a painter who shows great mastery of light and shade [n -S]\n",
  "LUMINARISTS": "LUMINARIST, a painter who shows great mastery of light and shade [n]\n",
  "LUMINARY": "a body that gives light [n LUMINARIES]\n",
  "LUMINATION": "illumination [n -S]\n",
  "LUMINATIONS": "LUMINATION, illumination [n]\n",
  "LUMINE": "(obsolete) to illumine [v LUMINED, LUMINING, LUMINES]\n",
  "LUMINED": "LUMINE, (obsolete) to illumine [v]\n",
  "LUMINES": "LUMINE, (obsolete) to illumine [v]\n",
  "LUMINESCE": "to show luminescence [v LUMINESCED, LUMINESCING, LUMINESCES]\n",
  "LUMINESCED": "LUMINESCE, to show luminescence [v]\n",
  "LUMINESCENCE": "the emission of light by a substance as the result of some external stimulus [n -S]\n",
  "LUMINESCENCES": "LUMINESCENCE, the emission of light by a substance as the result of some external stimulus [n]\n",
  "LUMINESCENT": "showing luminescence [adj]\n",
  "LUMINESCES": "LUMINESCE, to show luminescence [v]\n",
  "LUMINESCING": "LUMINESCE, to show luminescence [v]\n",
  "LUMINIFEROUS": "bearing or bringing light [adj]\n",
  "LUMINING": "LUMINE, (obsolete) to illumine [v]\n",
  "LUMINISM": "a style of realist landscape painting [n -S]\n",
  "LUMINISMS": "LUMINISM, a style of realist landscape painting [n]\n",
  "LUMINIST": "a painter who uses the effects of light [n -S]\n",
  "LUMINISTS": "LUMINIST, a painter who uses the effects of light [n]\n",
  "LUMINOSITIES": "LUMINOSITY, the state of being luminous [n]\n",
  "LUMINOSITY": "the state of being luminous [n LUMINOSITIES]\n",
  "LUMINOUS": "giving off light [adj LUMINOUSLY]\n",
  "LUMINOUSLY": "LUMINOUS, giving off light [adv]\n",
  "LUMINOUSNESS": "the state of being luminous [n -ES]\n",
  "LUMINOUSNESSES": "LUMINOUSNESS, the state of being luminous [n]\n",
  "LUMISTEROL": "a steroid compound [n -S]\n",
  "LUMISTEROLS": "LUMISTEROL, a steroid compound [n]\n",
  "LUMME": "(colloquial) an interjection expressing surprise [interj]\n",
  "LUMMIER": "LUMMY, (slang) excellent [adj]\n",
  "LUMMIEST": "LUMMY, (slang) excellent [adj]\n",
  "LUMMOX": "a clumsy person [n -ES]\n",
  "LUMMOXES": "LUMMOX, a clumsy person [n]\n",
  "LUMMY": "(slang) excellent [adj LUMMIER, LUMMIEST]\n",
  "LUMP": "to make into a shapeless mass [v -ED, -ING, -S]\n",
  "LUMPECTOMIES": "LUMPECTOMY, the surgical removal of a lump, esp. in the breast, aka tylectomy [n]\n",
  "LUMPECTOMY": "the surgical removal of a lump, esp. in the breast, aka tylectomy [n LUMPECTOMIES]\n",
  "LUMPED": "LUMP, to make into a shapeless mass [v]\n",
  "LUMPEN": "(German) relating to people cut off from the social and economic class to which they would normally belong [adj LUMPENLY] / someone belonging to the underclass [n -S]\n",
  "LUMPENLY": "LUMPEN, (German) relating to people cut off from the social and economic class to which they would normally belong [adv]\n",
  "LUMPENS": "LUMPEN, someone belonging to the underclass [n]\n",
  "LUMPER": "a labourer employed to load and unload ships [n -S]\n",
  "LUMPERS": "LUMPER, a labourer employed to load and unload ships [n]\n",
  "LUMPFISH": "a kind of marine fish, covered with lumps, also LUMPSUCKER [n -ES]\n",
  "LUMPFISHES": "LUMPFISH, a kind of marine fish, covered with lumps, also LUMPSUCKER [n]\n",
  "LUMPIA": "(Chinese) an Indonesian spring roll [n -S]\n",
  "LUMPIAS": "LUMPIA, (Chinese) an Indonesian spring roll [n]\n",
  "LUMPIER": "LUMPY, full of lumps [adj]\n",
  "LUMPIEST": "LUMPY, full of lumps [adj]\n",
  "LUMPILY": "LUMPY, full of lumps [adv]\n",
  "LUMPINESS": "the state of being lumpy [n -ES]\n",
  "LUMPINESSES": "LUMPINESS, the state of being lumpy [n]\n",
  "LUMPING": "LUMP, to make into a shapeless mass [v]\n",
  "LUMPINGLY": "LUMPING, LUMP, to make into a shapeless mass [adv]\n",
  "LUMPISH": "like a lump; sullen, also LOMPISH [adj LUMPISHLY]\n",
  "LUMPISHLY": "LUMPISH, like a lump; sullen, also LOMPISH [adv]\n",
  "LUMPISHNESS": "the state of being lumpish, sullen [n -ES]\n",
  "LUMPISHNESSES": "LUMPISHNESS, the state of being lumpish, sullen [n]\n",
  "LUMPKIN": "a lout [n -S]\n",
  "LUMPKINS": "LUMPKIN, a lout [n]\n",
  "LUMPS": "LUMP, to make into a shapeless mass [v]\n",
  "LUMPSUCKER": "a kind of fish, covered with lumps, also LUMPFISH [n -S]\n",
  "LUMPSUCKERS": "LUMPSUCKER, a kind of fish, covered with lumps, also LUMPFISH [n]\n",
  "LUMPY": "full of lumps [adj LUMPIER, LUMPIEST, LUMPILY]\n",
  "LUMS": "LUM, (Scots) a chimney [n]\n",
  "LUN": "a lee, a sheltered place [n -S]\n",
  "LUNA": "(Latin) a North American moth with crescent-shaped markings [n -S]\n",
  "LUNACIES": "LUNACY, insanity [n]\n",
  "LUNACY": "insanity [n LUNACIES]\n",
  "LUNANAUT": "an astronaut who has travelled to the moon, also LUNARNAUT [n -S]\n",
  "LUNANAUTS": "LUNANAUT, an astronaut who has travelled to the moon, also LUNARNAUT [n]\n",
  "LUNAR": "the distance of the moon as used for navigation [n -S]\n",
  "LUNARIAN": "(archaic) an inhabitant of the moon; a student of the moon [n -S]\n",
  "LUNARIANS": "LUNARIAN, (archaic) an inhabitant of the moon; a student of the moon [n]\n",
  "LUNARIES": "LUNARY, the moonwort fern [n]\n",
  "LUNARIST": "one who thinks the moon affects the weather [n -S]\n",
  "LUNARISTS": "LUNARIST, one who thinks the moon affects the weather [n]\n",
  "LUNARNAUT": "one who travels to the moon, also LUNANAUT [n -S]\n",
  "LUNARNAUTS": "LUNARNAUT, one who travels to the moon, also LUNANAUT [n]\n",
  "LUNARS": "LUNAR, the distance of the moon as used for navigation [n]\n",
  "LUNARY": "the moonwort fern [n LUNARIES]\n",
  "LUNAS": "LUNA, (Latin) a North American moth with crescent-shaped markings [n]\n",
  "LUNATE": "crescent-shaped, also LUNATED [adj LUNATELY] / a crescent-shaped bone in the wrist [n -S]\n",
  "LUNATED": "crescent-shaped, also LUNATE [adj]\n",
  "LUNATELY": "LUNATE, crescent-shaped, also LUNATED [adv]\n",
  "LUNATES": "LUNATE, a crescent-shaped bone in the wrist [n]\n",
  "LUNATIC": "affected with lunacy, also LUNATICAL [adj LUNATICALLY] / an insane person [n -S]\n",
  "LUNATICAL": "crazy, also LUNATIC [adj LUNATICALLY]\n",
  "LUNATICALLY": "LUNATICAL, crazy, also LUNATIC [adv]\n",
  "LUNATICS": "LUNATIC, an insane person [n]\n",
  "LUNATION": "a lunar month; the interval between successive new moons [n -S]\n",
  "LUNATIONS": "LUNATION, a lunar month; the interval between successive new moons [n]\n",
  "LUNCH": "to eat a midday meal [v -ED, -ING, -ES]\n",
  "LUNCHBOX": "a container for carrying meals to school or work [n -ES]\n",
  "LUNCHBOXES": "LUNCHBOX, a container for carrying meals to school or work [n]\n",
  "LUNCHBREAK": "a break for lunch [n -S]\n",
  "LUNCHBREAKS": "LUNCHBREAK, a break for lunch [n]\n",
  "LUNCHED": "LUNCH, to eat a midday meal [v]\n",
  "LUNCHEON": "a midday meal [n -S] / (archaic) to take lunch [v -ED, -ING, -S]\n",
  "LUNCHEONED": "LUNCHEON, (archaic) to take lunch [v]\n",
  "LUNCHEONETTE": "a small restaurant serving light lunches [n -S]\n",
  "LUNCHEONETTES": "LUNCHEONETTE, a small restaurant serving light lunches [n]\n",
  "LUNCHEONING": "LUNCHEON, (archaic) to take lunch [v]\n",
  "LUNCHEONS": "LUNCHEON, (archaic) to take lunch [v]\n",
  "LUNCHER": "one who takes lunch [n -S]\n",
  "LUNCHERS": "LUNCHER, one who takes lunch [n]\n",
  "LUNCHES": "LUNCH, to eat a midday meal [v]\n",
  "LUNCHING": "LUNCH, to eat a midday meal [v]\n",
  "LUNCHMEAT": "a mixture of meat and cereal [n -S]\n",
  "LUNCHMEATS": "LUNCHMEAT, a mixture of meat and cereal [n]\n",
  "LUNCHPAIL": "a container for lunch [n -S]\n",
  "LUNCHPAILS": "LUNCHPAIL, a container for lunch [n]\n",
  "LUNCHROOM": "a room where lunch is served [n -S]\n",
  "LUNCHROOMS": "LUNCHROOM, a room where lunch is served [n]\n",
  "LUNCHTIME": "the time at which lunch is eaten [n -S]\n",
  "LUNCHTIMES": "LUNCHTIME, the time at which lunch is eaten [n]\n",
  "LUNE": "a crescent-shaped figure [n -S]\n",
  "LUNES": "LUNE, a crescent-shaped figure [n]\n",
  "LUNET": "a little moon or satellite [n -S]\n",
  "LUNETS": "LUNET, a little moon or satellite [n]\n",
  "LUNETTE": "(French) a crescent-shaped space where a vault meets a wall [n -S]\n",
  "LUNETTES": "LUNETTE, (French) a crescent-shaped space where a vault meets a wall [n]\n",
  "LUNG": "a respiratory organ [n -S]\n",
  "LUNGAN": "(Chinese) a pulpy fruit related to the litchi, and produced by an evergreen East Indian tree, also LONGAN [n -S]\n",
  "LUNGANS": "LUNGAN, (Chinese) a pulpy fruit related to the litchi, and produced by an evergreen East Indian tree, also LONGAN [n]\n",
  "LUNGE": "to make a sudden plunge forward [v LUNGED, LUNGEING or LUNGING, LUNGES]\n",
  "LUNGED": "LUNGE, to make a sudden plunge forward [v]\n",
  "LUNGEE": "(Hindi) a loincloth worn by men in India, also LUNGI, LUNGYI [n -S]\n",
  "LUNGEES": "LUNGEE, (Hindi) a loincloth worn by men in India, also LUNGI, LUNGYI [n]\n",
  "LUNGEING": "LUNGE, to make a sudden plunge forward [v]\n",
  "LUNGER": "one who lunges [n -S]\n",
  "LUNGERS": "LUNGER, one who lunges [n]\n",
  "LUNGES": "LUNGE, to make a sudden plunge forward [v]\n",
  "LUNGFISH": "a fish able to breathe air using primitive lungs, a dipnoan [n -ES]\n",
  "LUNGFISHES": "LUNGFISH, a fish able to breathe air using primitive lungs, a dipnoan [n]\n",
  "LUNGFUL": "as much as the lungs can hold [n -S]\n",
  "LUNGFULS": "LUNGFUL, as much as the lungs can hold [n]\n",
  "LUNGI": "(Hindi) in India, a long cloth used as a loin cloth, turban etc., also LUNGEE, LUNGYI [n -S]\n",
  "LUNGIE": "(Scots) the guillemot, also LUNYIE [n -S]\n",
  "LUNGIES": "LUNGIE, (Scots) the guillemot, also LUNYIE [n]\n",
  "LUNGING": "LUNGE, to make a sudden plunge forward [v]\n",
  "LUNGIS": "LUNGI, (Hindi) in India, a long cloth used as a loin cloth, turban etc., also LUNGEE, LUNGYI [n]\n",
  "LUNGLESS": "without lungs [adj]\n",
  "LUNGLIKE": "like a lung [adj]\n",
  "LUNGS": "LUNG, a respiratory organ [n]\n",
  "LUNGWORM": "a kind of parasitic worm [n -S]\n",
  "LUNGWORMS": "LUNGWORM, a kind of parasitic worm [n]\n",
  "LUNGWORT": "a wild flower with spotted leaves [n -S]\n",
  "LUNGWORTS": "LUNGWORT, a wild flower with spotted leaves [n]\n",
  "LUNGYI": "(Hindi) in India, a long cloth used as a loin cloth, turban etc., also LUNGEE, LUNGI [n -S]\n",
  "LUNGYIS": "LUNGYI, (Hindi) in India, a long cloth used as a loin cloth, turban etc., also LUNGEE, LUNGI [n]\n",
  "LUNIER": "LUNY, crazy [adj]\n",
  "LUNIES": "LUNY, a crazy person, also LOONY, LOONEY, LOONIE [n]\n",
  "LUNIEST": "LUNY, crazy [adj]\n",
  "LUNINESS": "the state of being luny [n -ES]\n",
  "LUNINESSES": "LUNINESS, the state of being luny [n]\n",
  "LUNISOLAR": "relating jointly to the moon and sun [adj]\n",
  "LUNITIDAL": "pertaining to tidal movements dependent on the moon [adj]\n",
  "LUNK": "a stupid person, also LUNKHEAD [n -S]\n",
  "LUNKER": "a large game fish [n -S]\n",
  "LUNKERS": "LUNKER, a large game fish [n]\n",
  "LUNKHEAD": "a stupid person, also LUNK [n -S]\n",
  "LUNKHEADED": "stupid, like a lunkhead [adj]\n",
  "LUNKHEADS": "LUNKHEAD, a stupid person, also LUNK [n]\n",
  "LUNKS": "LUNK, a stupid person, also LUNKHEAD [n]\n",
  "LUNS": "LUN, a lee, a sheltered place [n]\n",
  "LUNT": "(Scots) a slow match; a sudden flame [n -S] / to kindle [v -ED, -ING, -S]\n",
  "LUNTED": "LUNT, to kindle [v]\n",
  "LUNTING": "LUNT, to kindle [v]\n",
  "LUNTS": "LUNT, to kindle [v]\n",
  "LUNULA": "(Latin) a Bronze Age crescent necklace [n LUNULAE]\n",
  "LUNULAE": "LUNULA, (Latin) a Bronze Age crescent necklace [n]\n",
  "LUNULAR": "crescent-shaped [adj]\n",
  "LUNULATE": "crescent-shaped; having crescent-shaped markings, also LUNULATED [adj]\n",
  "LUNULATED": "crescent-shaped; having crescent-shaped markings, also LUNULATE [adj]\n",
  "LUNULE": "a crescent-shaped mark or organ [n -S]\n",
  "LUNULES": "LUNULE, a crescent-shaped mark or organ [n]\n",
  "LUNY": "crazy [adj LUNIER, LUNIEST] / a crazy person, also LOONY, LOONEY, LOONIE [n LUNIES]\n",
  "LUNYIE": "(Scots) the guillemot, also LUNGIE [n -S]\n",
  "LUNYIES": "LUNYIE, (Scots) the guillemot, also LUNGIE [n]\n",
  "LUPANAR": "(Latin) a brothel [n -S]\n",
  "LUPANARS": "LUPANAR, (Latin) a brothel [n]\n",
  "LUPIN": "any papilionaceous plant of the genus Lupinus, also LUPINE [n -S]\n",
  "LUPINE": "any papilionaceous plant of the genus Lupinus, also LUPIN [n -S]\n",
  "LUPINES": "LUPINE, any papilionaceous plant of the genus Lupinus, also LUPIN [n]\n",
  "LUPINS": "LUPIN, any papilionaceous plant of the genus Lupinus, also LUPINE [n]\n",
  "LUPOID": "suffering from lupus [adj]\n",
  "LUPOUS": "pertaining to lupus, a skin disease [adj]\n",
  "LUPPEN": "LEAP, (Scots) to spring off the ground [v]\n",
  "LUPULIN": "a medicinal powder obtained from the hop plant [n -S]\n",
  "LUPULINE": "of or like lupulin, a yellow powder on hop cones, used as sedative, also LUPULINIC [adj]\n",
  "LUPULINIC": "of or like lupulin, a yellow powder on hop cones, used as sedative, also LUPULINE [adj]\n",
  "LUPULINS": "LUPULIN, a medicinal powder obtained from the hop plant [n]\n",
  "LUPUS": "(Latin) a skin disease [n -ES]\n",
  "LUPUSES": "LUPUS, (Latin) a skin disease [n]\n",
  "LUR": "a Bronze Age trumpet [n -S]\n",
  "LURCH": "to roll or pitch suddenly [v -ED, -ING, -ES]\n",
  "LURCHED": "LURCH, to roll or pitch suddenly [v]\n",
  "LURCHER": "a crossbred dog, esp. the offspring of a greyhound and a collie or retriever, used esp. by poachers for pursuing hares and rabbits [n -S]\n",
  "LURCHERS": "LURCHER, a crossbred dog, esp. the offspring of a greyhound and a collie or retriever, used esp. by poachers for pursuing hares and rabbits [n]\n",
  "LURCHES": "LURCH, to roll or pitch suddenly [v]\n",
  "LURCHING": "LURCH, to roll or pitch suddenly [v]\n",
  "LURDAN": "(archaic) a dull or sluggish person, also LURDANE, LURDEN [n -S]\n",
  "LURDANE": "(archaic) a dull or sluggish person, also LURDAN, LURDEN [n -S]\n",
  "LURDANES": "LURDANE, (archaic) a dull or sluggish person, also LURDAN, LURDEN [n]\n",
  "LURDANS": "LURDAN, (archaic) a dull or sluggish person, also LURDANE, LURDEN [n]\n",
  "LURDEN": "(archaic) a dull or sluggish person, also LURDAN, LURDANE [n -S]\n",
  "LURDENS": "LURDEN, (archaic) a dull or sluggish person, also LURDAN, LURDANE [n]\n",
  "LURE": "to attract with something desirable [v LURED, LURING, LURES]\n",
  "LURED": "LURE, to attract with something desirable [v]\n",
  "LURER": "one who lures [n -S]\n",
  "LURERS": "LURER, one who lures [n]\n",
  "LURES": "LURE, to attract with something desirable [v]\n",
  "LUREX": "(tradename) a thin glittery thread [n -ES]\n",
  "LUREXES": "LUREX, (tradename) a thin glittery thread [n]\n",
  "LURGI": "(facetious) a fictitious disease, also LURGY [n -S]\n",
  "LURGIES": "LURGY, (facetious) a fictitious disease, also LURGI [n]\n",
  "LURGIS": "LURGI, (facetious) a fictitious disease, also LURGY [n]\n",
  "LURGY": "(facetious) a fictitious disease, also LURGI [n LURGIES]\n",
  "LURID": "shining with a red glow or glare amid darkness [adj LURIDER, LURIDEST, LURIDLY]\n",
  "LURIDER": "LURID, shining with a red glow or glare amid darkness [adj]\n",
  "LURIDEST": "LURID, shining with a red glow or glare amid darkness [adj]\n",
  "LURIDLY": "LURID, shining with a red glow or glare amid darkness [adv]\n",
  "LURIDNESS": "the state of being lurid, shining with a red glow [n -ES]\n",
  "LURIDNESSES": "LURIDNESS, the state of being lurid, shining with a red glow [n]\n",
  "LURING": "as in tape luring, the enticement and subsequent capture of a seabird by playing tape recordings of its call from beaches and cliffs [n -S]\n",
  "LURINGLY": "LURING [adv]\n",
  "LURINGS": "LURING, as in tape luring, the enticement and subsequent capture of a seabird by playing tape recordings of its call from beaches and cliffs [n]\n",
  "LURK": "to lie in wait [v -ED, -ING, -S]\n",
  "LURKED": "LURK, to lie in wait [v]\n",
  "LURKER": "one that lurks [n -S]\n",
  "LURKERS": "LURKER, one that lurks [n]\n",
  "LURKING": "lying in wait [adj LURKINGLY] / the act of lurking [n -S]\n",
  "LURKINGLY": "LURKING, lying in wait [adv]\n",
  "LURKINGS": "LURKING, the act of lurking [n]\n",
  "LURKS": "LURK, to lie in wait [v]\n",
  "LURRIES": "LURRY, (Milton) a confused heap, a throng [n]\n",
  "LURRY": "(Milton) a confused heap, a throng [n LURRIES]\n",
  "LURS": "LUR, a Bronze Age trumpet [n]\n",
  "LURVE": "(slang) romantic love [n -S]\n",
  "LURVES": "LURVE, (slang) romantic love [n]\n",
  "LUSCIOUS": "having a delicious taste [adj LUSCIOUSLY]\n",
  "LUSCIOUSLY": "LUSCIOUS, having a delicious taste [adv]\n",
  "LUSCIOUSNESS": "the state of being luscious [n -ES]\n",
  "LUSCIOUSNESSES": "LUSCIOUSNESS, the state of being luscious [n]\n",
  "LUSER": "a user of a computer system as perceived by a technical support group [n -S]\n",
  "LUSERS": "LUSER, a user of a computer system as perceived by a technical support group [n]\n",
  "LUSH": "abounding in vegetation [adj LUSHER, LUSHEST, LUSHLY] / to ply with alcohol [v -ED, -ING, -ES]\n",
  "LUSHED": "LUSH, to ply with alcohol [v]\n",
  "LUSHER": "a heavy drinker [n -S]\n",
  "LUSHERS": "LUSHER, a heavy drinker [n]\n",
  "LUSHES": "LUSH, to ply with alcohol [v]\n",
  "LUSHEST": "LUSH, abounding in vegetation [adj]\n",
  "LUSHIER": "LUSHY, tipsy [adj]\n",
  "LUSHIES": "LUSHY, a drunkard [n]\n",
  "LUSHIEST": "LUSHY, tipsy [adj]\n",
  "LUSHING": "LUSH, to ply with alcohol [v]\n",
  "LUSHLY": "LUSH, abounding in vegetation [adv]\n",
  "LUSHNESS": "the state of being lush [n -ES]\n",
  "LUSHNESSES": "LUSHNESS, the state of being lush [n]\n",
  "LUSHY": "tipsy [adj LUSHIER, LUSHIEST] / a drunkard [n LUSHIES]\n",
  "LUSK": "to lie about lazily [v -ED, -ING, -S]\n",
  "LUSKED": "LUSK, to lie about lazily [v]\n",
  "LUSKING": "LUSK, to lie about lazily [v]\n",
  "LUSKISH": "(obsolete) inclined to be lazy [adj]\n",
  "LUSKISHNESS": "(obsolete) the state of being luskish, inclined to be lazy [n -ES]\n",
  "LUSKISHNESSES": "LUSKISHNESS, (obsolete) the state of being luskish, inclined to be lazy [n]\n",
  "LUSKS": "LUSK, to lie about lazily [v]\n",
  "LUST": "to have a strong sexual desire for [v -ED, -ING, -S]\n",
  "LUSTED": "LUST, to have a strong sexual desire for [v]\n",
  "LUSTER": "to make lustrous, also LUSTRE [v -ED, -ING, -S]\n",
  "LUSTERED": "LUSTER, to make lustrous, also LUSTRE [v]\n",
  "LUSTERING": "LUSTER, to make lustrous, also LUSTRE [v]\n",
  "LUSTERLESS": "without luster, also LUSTRELESS [adj]\n",
  "LUSTERS": "LUSTER, to make lustrous, also LUSTRE [v]\n",
  "LUSTERWARE": "pottery with a metallic glaze, also LUSTREWARE [n -S]\n",
  "LUSTERWARES": "LUSTERWARE, pottery with a metallic glaze, also LUSTREWARE [n]\n",
  "LUSTFUL": "marked by excessive sexual desire [adj LUSTFULLY]\n",
  "LUSTFULLY": "LUSTFUL, marked by excessive sexual desire [adv]\n",
  "LUSTFULNESS": "the state of being lustful [n -ES]\n",
  "LUSTFULNESSES": "LUSTFULNESS, the state of being lustful [n]\n",
  "LUSTICK": "(obsolete) lusty, healthy, also LUSTIQUE [adj]\n",
  "LUSTIER": "LUSTY, full of vigour [adj]\n",
  "LUSTIEST": "LUSTY, full of vigour [adj]\n",
  "LUSTIHEAD": "(archaic) lustiness, also LUSTIHOOD [n -S]\n",
  "LUSTIHEADS": "LUSTIHEAD, (archaic) lustiness, also LUSTIHOOD [n]\n",
  "LUSTIHOOD": "(archaic) lustiness, also LUSTIHEAD [n -S]\n",
  "LUSTIHOODS": "LUSTIHOOD, (archaic) lustiness, also LUSTIHEAD [n]\n",
  "LUSTILY": "LUSTY, full of vigour [adv]\n",
  "LUSTINESS": "the state of being lusty [n -ES]\n",
  "LUSTINESSES": "LUSTINESS, the state of being lusty [n]\n",
  "LUSTING": "LUST, to have a strong sexual desire for [v]\n",
  "LUSTIQUE": "(obsolete) lusty, healthy, also LUSTICK [adj]\n",
  "LUSTLESS": "(Spenser) listless, feeble [adj]\n",
  "LUSTRA": "LUSTRUM, (Latin) a period of five years [n]\n",
  "LUSTRAL": "of or pertaining to, or used for, purification; as, lustral days; lustral water [adj]\n",
  "LUSTRATE": "to purify ceremonially [v LUSTRATED, LUSTRATING, LUSTRATES]\n",
  "LUSTRATED": "LUSTRATE, to purify ceremonially [v]\n",
  "LUSTRATES": "LUSTRATE, to purify ceremonially [v]\n",
  "LUSTRATING": "LUSTRATE, to purify ceremonially [v]\n",
  "LUSTRATION": "ritual washing; ablution [n -S]\n",
  "LUSTRATIONS": "LUSTRATION, ritual washing; ablution [n]\n",
  "LUSTRATIVE": "tending to lustrate [adj]\n",
  "LUSTRE": "to make lustrous, also LUSTER [v LUSTRED, LUSTRING, LUSTRES]\n",
  "LUSTRED": "LUSTRE, to make lustrous, also LUSTER [v]\n",
  "LUSTRELESS": "without lustre, also LUSTERLESS [adj]\n",
  "LUSTRES": "LUSTRE, to make lustrous, also LUSTER [v]\n",
  "LUSTREWARE": "pottery with a metallic glaze, also LUSTERWARE [n -S]\n",
  "LUSTREWARES": "LUSTREWARE, pottery with a metallic glaze, also LUSTERWARE [n]\n",
  "LUSTRINE": "a glossy silk cloth, also LUSTRING, LUTESTRING [n -S]\n",
  "LUSTRINES": "LUSTRINE, a glossy silk cloth, also LUSTRING, LUTESTRING [n]\n",
  "LUSTRING": "a glossy silk cloth, also LUSTRINE, LUTESTRING [n -S]\n",
  "LUSTRINGS": "LUSTRING, a glossy silk cloth, also LUSTRINE, LUTESTRING [n]\n",
  "LUSTROUS": "reflecting light evenly and efficiently [adj LUSTROUSLY]\n",
  "LUSTROUSLY": "LUSTROUS, reflecting light evenly and efficiently [adv]\n",
  "LUSTROUSNESS": "the state of being lustrous [n -ES]\n",
  "LUSTROUSNESSES": "LUSTROUSNESS, the state of being lustrous [n]\n",
  "LUSTRUM": "(Latin) a period of five years [n LUSTRA or LUSTRUMS]\n",
  "LUSTRUMS": "LUSTRUM, (Latin) a period of five years [n]\n",
  "LUSTS": "LUST, to have a strong sexual desire for [v]\n",
  "LUSTY": "full of vigour [adj LUSTIER, LUSTIEST, LUSTILY]\n",
  "LUSUS": "(Latin) a sport or freak of nature [n -ES]\n",
  "LUSUSES": "LUSUS, (Latin) a sport or freak of nature [n]\n",
  "LUTANIST": "a lute-player, also LUTENIST, LUTER, LUTIST [n -S]\n",
  "LUTANISTS": "LUTANIST, a lute-player, also LUTENIST, LUTER, LUTIST [n]\n",
  "LUTE": "an old stringed instrument shaped like half a pear [n -S] / to play on the lute [v LUTED, LUTING, LUTES]\n",
  "LUTEA": "LUTEUM, (Latin) a hormone-secreting body [n]\n",
  "LUTEAL": "pertaining to the corpus luteum [adj]\n",
  "LUTECIUM": "a rare earth element, also LUTETIUM [n -S]\n",
  "LUTECIUMS": "LUTECIUM, a rare earth element, also LUTETIUM [n]\n",
  "LUTED": "LUTE, to play on the lute [v]\n",
  "LUTEFISK": "(Norwegian) dried codfish, also LUTFISK [n -S]\n",
  "LUTEFISKS": "LUTEFISK, (Norwegian) dried codfish, also LUTFISK [n]\n",
  "LUTEIN": "a yellow pigment found in egg yolk [n -S]\n",
  "LUTEINISATION": "the process of stimulation to the ovary, whereby ovulation occurs and a corpus luteum is formed, also LUTEINIZATION [n -S]\n",
  "LUTEINISATIONS": "LUTEINISATION, the process of stimulation to the ovary, whereby ovulation occurs and a corpus luteum is formed, also LUTEINIZATION [n]\n",
  "LUTEINISE": "to convert into lutein, also LUTEINIZE [v LUTEINISED, LUTEINISING, LUTEINISES]\n",
  "LUTEINISED": "LUTEINISE, to convert into lutein, also LUTEINIZE [v]\n",
  "LUTEINISES": "LUTEINISE, to convert into lutein, also LUTEINIZE [v]\n",
  "LUTEINISING": "LUTEINISE, to convert into lutein, also LUTEINIZE [v]\n",
  "LUTEINIZATION": "the process of stimulation to the ovary, whereby ovulation occurs and a corpus luteum is formed, also LUTEINISATION [n -S]\n",
  "LUTEINIZATIONS": "LUTEINIZATION, the process of stimulation to the ovary, whereby ovulation occurs and a corpus luteum is formed, also LUTEINISATION [n]\n",
  "LUTEINIZE": "to convert into lutein, also LUTEINISE [v LUTEINIZED, LUTEINIZING, LUTEINIZES]\n",
  "LUTEINIZED": "LUTEINIZE, to convert into lutein, also LUTEINISE [v]\n",
  "LUTEINIZES": "LUTEINIZE, to convert into lutein, also LUTEINISE [v]\n",
  "LUTEINIZING": "LUTEINIZE, to convert into lutein, also LUTEINISE [v]\n",
  "LUTEINS": "LUTEIN, a yellow pigment found in egg yolk [n]\n",
  "LUTELIKE": "like a lute [adj]\n",
  "LUTENIST": "a lute-player, also LUTANIST, LUTER, LUTIST [n -S]\n",
  "LUTENISTS": "LUTENIST, a lute-player, also LUTANIST, LUTER, LUTIST [n]\n",
  "LUTEOLIN": "a yellow dyestuff obtained from the foliage of the dyer's broom [n -S]\n",
  "LUTEOLINS": "LUTEOLIN, a yellow dyestuff obtained from the foliage of the dyer's broom [n]\n",
  "LUTEOLOUS": "yellowish [adj]\n",
  "LUTEOTROPHIC": "acting on the corpora lutea, also LUTEOTROPIC [adj]\n",
  "LUTEOTROPHIN": "another name for the hormone prolactin, also LUTEOTROPIN [n -S]\n",
  "LUTEOTROPHINS": "LUTEOTROPHIN, another name for the hormone prolactin, also LUTEOTROPIN [n]\n",
  "LUTEOTROPIC": "acting on the corpora lutea, also LUTEOTROPHIC [adj]\n",
  "LUTEOTROPIN": "another name for the hormone prolactin, also LUTEOTROPHIN [n -S]\n",
  "LUTEOTROPINS": "LUTEOTROPIN, another name for the hormone prolactin, also LUTEOTROPHIN [n]\n",
  "LUTEOUS": "golden-yellow [adj]\n",
  "LUTER": "a lute-player, also LUTANIST, LUTENIST, LUTIST [n -S]\n",
  "LUTERS": "LUTER, a lute-player, also LUTANIST, LUTENIST, LUTIST [n]\n",
  "LUTES": "LUTE, to play on the lute [v]\n",
  "LUTESCENT": "yellowish [adj]\n",
  "LUTESTRING": "a glossy silk cloth, also LUSTRINE, LUSTRING [n -S]\n",
  "LUTESTRINGS": "LUTESTRING, a glossy silk cloth, also LUSTRINE, LUSTRING [n]\n",
  "LUTETIUM": "a rare earth element, also LUTECIUM [n -S]\n",
  "LUTETIUMS": "LUTETIUM, a rare earth element, also LUTECIUM [n]\n",
  "LUTEUM": "(Latin) a hormone-secreting body [n LUTEA]\n",
  "LUTFISK": "dried codfish, also LUTEFISK [n -S]\n",
  "LUTFISKS": "LUTFISK, dried codfish, also LUTEFISK [n]\n",
  "LUTHERN": "a dormer window [n -S]\n",
  "LUTHERNS": "LUTHERN, a dormer window [n]\n",
  "LUTHIER": "one who makes stringed instruments [n -S]\n",
  "LUTHIERS": "LUTHIER, one who makes stringed instruments [n]\n",
  "LUTING": "a rubber seal; a paste used for fastening lids on pie dishes [n -S]\n",
  "LUTINGS": "LUTING, a rubber seal; a paste used for fastening lids on pie dishes [n]\n",
  "LUTIST": "a lute-player, also LUTANIST, LUTENIST, LUTER [n -S]\n",
  "LUTISTS": "LUTIST, a lute-player, also LUTANIST, LUTENIST, LUTER [n]\n",
  "LUTITE": "any rock derived from clay or mud, aka pelite [n -S]\n",
  "LUTITES": "LUTITE, any rock derived from clay or mud, aka pelite [n]\n",
  "LUTTEN": "LET, to allow [v]\n",
  "LUTZ": "a jump in figure skating [n -ES]\n",
  "LUTZES": "LUTZ, a jump in figure skating [n]\n",
  "LUV": "(colloquial) to love [v LUVVED, LUVVING, LUVS]\n",
  "LUVS": "LUV, (colloquial) to love [v]\n",
  "LUVVED": "LUV, (colloquial) to love [v]\n",
  "LUVVIE": "(colloquial) a member of the entertainment industry, also LUVVY [n -S]\n",
  "LUVVIEDOM": "the world of luvvies [n -S]\n",
  "LUVVIEDOMS": "LUVVIEDOM, the world of luvvies [n]\n",
  "LUVVIES": "LUVVY, (colloquial) a member of the entertainment industry, also LUVVIE [n]\n",
  "LUVVING": "LUV, (colloquial) to love [v]\n",
  "LUVVY": "(colloquial) a member of the entertainment industry, also LUVVIE [n LUVVIES]\n",
  "LUX": "a unit of illumination [n LUXES or LUCES] / to clean with a vacuum cleaner [v -ED, -ING, -ES]\n",
  "LUXATE": "to put out of joint [v LUXATED, LUXATING, LUXATES]\n",
  "LUXATED": "LUXATE, to put out of joint [v]\n",
  "LUXATES": "LUXATE, to put out of joint [v]\n",
  "LUXATING": "LUXATE, to put out of joint [v]\n",
  "LUXATION": "the dislocation of an anatomical part [n -S]\n",
  "LUXATIONS": "LUXATION, the dislocation of an anatomical part [n]\n",
  "LUXE": "(French) luxurious, as in de luxe [adj LUXER, LUXEST]\n",
  "LUXED": "LUX, to clean with a vacuum cleaner [v]\n",
  "LUXER": "LUXE, (French) luxurious, as in de luxe [adj]\n",
  "LUXES": "LUX, to clean with a vacuum cleaner [v]\n",
  "LUXEST": "LUXE, (French) luxurious, as in de luxe [adj]\n",
  "LUXING": "LUX, to clean with a vacuum cleaner [v]\n",
  "LUXMETER": "an instrument for measuring illumination [n -S]\n",
  "LUXMETERS": "LUXMETER, an instrument for measuring illumination [n]\n",
  "LUXULIANITE": "a tourmaline granite found at Luxulyan in Cornwall, also LUXULLIANITE, LUXULYANITE [n -S]\n",
  "LUXULIANITES": "LUXULIANITE, a tourmaline granite found at Luxulyan in Cornwall, also LUXULLIANITE, LUXULYANITE [n]\n",
  "LUXULLIANITE": "a tourmaline granite found at Luxulyan in Cornwall, also LUXULIANITE, LUXULYANITE [n -S]\n",
  "LUXULLIANITES": "LUXULLIANITE, a tourmaline granite found at Luxulyan in Cornwall, also LUXULIANITE, LUXULYANITE [n]\n",
  "LUXULYANITE": "a tourmaline granite found at Luxulyan in Cornwall, also LUXULIANITE, LUXULLIANITE [n -S]\n",
  "LUXULYANITES": "LUXULYANITE, a tourmaline granite found at Luxulyan in Cornwall, also LUXULIANITE, LUXULLIANITE [n]\n",
  "LUXURIANCE": "the state of being luxuriant, also LUXURIANCY [n -S]\n",
  "LUXURIANCES": "LUXURIANCE, the state of being luxuriant, also LUXURIANCY [n]\n",
  "LUXURIANCIES": "LUXURIANCY, the state of being luxuriant, also LUXURIANCE [n]\n",
  "LUXURIANCY": "the state of being luxuriant, also LUXURIANCE [n LUXURIANCIES]\n",
  "LUXURIANT": "overabundant in growth [adj LUXURIANTLY]\n",
  "LUXURIANTLY": "LUXURIANT, overabundant in growth [adv]\n",
  "LUXURIATE": "to be luxuriant, grow profusely [v LUXURIATED, LUXURIATING, LUXURIATES]\n",
  "LUXURIATED": "LUXURIATE, to be luxuriant, grow profusely [v]\n",
  "LUXURIATES": "LUXURIATE, to be luxuriant, grow profusely [v]\n",
  "LUXURIATING": "LUXURIATE, to be luxuriant, grow profusely [v]\n",
  "LUXURIATION": "the act of luxuriating [n -S]\n",
  "LUXURIATIONS": "LUXURIATION, the act of luxuriating [n]\n",
  "LUXURIES": "LUXURY, ease, pleasure and indulgence [n]\n",
  "LUXURIOUS": "enjoying or indulging in luxury [adj LUXURIOUSLY]\n",
  "LUXURIOUSLY": "LUXURIOUS, enjoying or indulging in luxury [adv]\n",
  "LUXURIOUSNESS": "LUXURIOUS, enjoying or indulging in luxury [n]\n",
  "LUXURIOUSNESSES": "LUXURIOUSNESS, LUXURIOUS, enjoying or indulging in luxury [n]\n",
  "LUXURIST": "someone given to luxury [n -S]\n",
  "LUXURISTS": "LUXURIST, someone given to luxury [n]\n",
  "LUXURY": "ease, pleasure and indulgence [n LUXURIES]\n",
  "LUZ": "a supposedly indestructible bone in the sacrum [n LUZZES]\n",
  "LUZERN": "a fodder plant, aka alfalfa, also LUCERN, LUCERNE [n -S]\n",
  "LUZERNS": "LUZERN, a fodder plant, aka alfalfa, also LUCERN, LUCERNE [n]\n",
  "LUZZES": "LUZ, a supposedly indestructible bone in the sacrum [n]\n",
  "LWEI": "a monetary unit of Angola [n -S]\n",
  "LWEIS": "LWEI, a monetary unit of Angola [n]\n",
  "LYAM": "a kind of bloodhound, also LYM, LYME [n -S]\n",
  "LYAMS": "LYAM, a kind of bloodhound, also LYM, LYME [n]\n",
  "LYARD": "grey, dapple-grey, also LIARD, LIART, LYART [adj]\n",
  "LYART": "grey, dapple-grey, also LIARD, LIART, LYARD [adj]\n",
  "LYASE": "an enzyme [n -S]\n",
  "LYASES": "LYASE, an enzyme [n]\n",
  "LYCAENID": "any member of the Lycaenidae, a family of butterflies [n -S]\n",
  "LYCAENIDS": "LYCAENID, any member of the Lycaenidae, a family of butterflies [n]\n",
  "LYCANTHROPE": "a werewolf; a person suffering from lycanthropy, also LYCANTHROPIST [n -S]\n",
  "LYCANTHROPES": "LYCANTHROPE, a werewolf; a person suffering from lycanthropy, also LYCANTHROPIST [n]\n",
  "LYCANTHROPIC": "related to lycanthropy [adj]\n",
  "LYCANTHROPIES": "LYCANTHROPY, a delusion that one has become a wolf [n]\n",
  "LYCANTHROPIST": "a werewolf; a person suffering from lycanthropy, also LYCANTHROPE [n -S]\n",
  "LYCANTHROPISTS": "LYCANTHROPIST, a werewolf; a person suffering from lycanthropy, also LYCANTHROPE [n]\n",
  "LYCANTHROPY": "a delusion that one has become a wolf [n LYCANTHROPIES]\n",
  "LYCEA": "LYCEUM, (Latin) a hall for public lectures or discussions [n]\n",
  "LYCEE": "(French) a French secondary school [n -S]\n",
  "LYCEES": "LYCEE, (French) a French secondary school [n]\n",
  "LYCEUM": "(Latin) a hall for public lectures or discussions [n LYCEUMS or LYCEA]\n",
  "LYCEUMS": "LYCEUM, (Latin) a hall for public lectures or discussions [n]\n",
  "LYCH": "a corpse, also LICH [n -ES]\n",
  "LYCHEE": "(Chinese) a tropical fruit, also LEECHEE, LICHEE, LICHI, LITCHI [n -S]\n",
  "LYCHEES": "LYCHEE, (Chinese) a tropical fruit, also LEECHEE, LICHEE, LICHI, LITCHI [n]\n",
  "LYCHES": "LYCH, a corpse, also LICH [n]\n",
  "LYCHGATE": "the roofed gate of a churchyard, also LICHGATE [n -S]\n",
  "LYCHGATES": "LYCHGATE, the roofed gate of a churchyard, also LICHGATE [n]\n",
  "LYCHNIS": "(Greek) a plant of the campion genus Lychnis of the pink family [n -ES]\n",
  "LYCHNISES": "LYCHNIS, (Greek) a plant of the campion genus Lychnis of the pink family [n]\n",
  "LYCHNOSCOPE": "a low side window [n -S]\n",
  "LYCHNOSCOPES": "LYCHNOSCOPE, a low side window [n]\n",
  "LYCOPENE": "a red pigment [n -S]\n",
  "LYCOPENES": "LYCOPENE, a red pigment [n]\n",
  "LYCOPOD": "a plant of the genus Lycopodium, a clubmoss [n -S]\n",
  "LYCOPODIUM": "a genus of mosslike plants, aka clubmoss [n -S]\n",
  "LYCOPODIUMS": "LYCOPODIUM, a genus of mosslike plants, aka clubmoss [n]\n",
  "LYCOPODS": "LYCOPOD, a plant of the genus Lycopodium, a clubmoss [n]\n",
  "LYCOPSID": "a type of clubmoss [n -S]\n",
  "LYCOPSIDS": "LYCOPSID, a type of clubmoss [n]\n",
  "LYCRA": "(tradename) a type of synthetic elastic fabric [n -S]\n",
  "LYCRAS": "LYCRA, (tradename) a type of synthetic elastic fabric [n]\n",
  "LYDDITE": "a high explosive for shells, largely picric acid [n -S]\n",
  "LYDDITES": "LYDDITE, a high explosive for shells, largely picric acid [n]\n",
  "LYE": "a strongly alkaline solution obtained by leaching [n -S]\n",
  "LYES": "LYE, a strongly alkaline solution obtained by leaching [n]\n",
  "LYFULL": "(Spenser) full of vital energy, also LIFEFUL, LIFULL [adj]\n",
  "LYING": "untruthful [adj LYINGLY] / the act of lying [n -S]\n",
  "LYINGLY": "in an untruthful manner [adv]\n",
  "LYINGS": "LYING, the act of lying [n]\n",
  "LYKEWAKE": "a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWAKE, LIKEWALK, LYKEWALK [n -S]\n",
  "LYKEWAKES": "LYKEWAKE, a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWAKE, LIKEWALK, LYKEWALK [n]\n",
  "LYKEWALK": "a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWAKE, LIKEWALK, LYKEWAKE [n -S]\n",
  "LYKEWALKS": "LYKEWALK, a watch over a corpse, also LATEWAKE, LICHWAKE, LIKEWAKE, LIKEWALK, LYKEWAKE [n]\n",
  "LYM": "(Shakespeare) a kind of bloodhound, also LYAM, LYME [n -S]\n",
  "LYME": "a kind of bloodhound, also LYAM, LYM [n -S]\n",
  "LYMES": "LYME, a kind of bloodhound, also LYAM, LYM [n]\n",
  "LYMITER": "(Spenser) a friar who had a license to beg within certain areas, also LIMITER [n -S]\n",
  "LYMITERS": "LYMITER, (Spenser) a friar who had a license to beg within certain areas, also LIMITER [n]\n",
  "LYMPH": "a body fluid containing white blood cells [n -S]\n",
  "LYMPHAD": "(Gaelic) a Highland galley [n -S]\n",
  "LYMPHADENITIS": "inflammation of the lymph nodes [n -ES]\n",
  "LYMPHADENITISES": "LYMPHADENITIS, inflammation of the lymph nodes [n]\n",
  "LYMPHADENOPATHY": "abnormal enlargement of the lymph nodes [n]\n",
  "LYMPHADS": "LYMPHAD, (Gaelic) a Highland galley [n]\n",
  "LYMPHANGIAL": "relating to the lymphatic vessels [adj]\n",
  "LYMPHANGIOGRAM": "a radiogram of the lymph glands [n -S]\n",
  "LYMPHANGIOGRAMS": "LYMPHANGIOGRAM, a radiogram of the lymph glands [n]\n",
  "LYMPHANGIOMA": "an angioma of the lymph nodes [n LYMPHANGIOMAS, LYMPHANGIOMATA]\n",
  "LYMPHANGIOMAS": "LYMPHANGIOMA, an angioma of the lymph nodes [n]\n",
  "LYMPHANGIOMATA": "LYMPHANGIOMA, an angioma of the lymph nodes [n]\n",
  "LYMPHANGITIC": "relating to lymphangitis, inflammation of a lymphatic vessel [adj]\n",
  "LYMPHANGITIDES": "LYMPHANGITIS, inflammation of a lymphatic vessel [n]\n",
  "LYMPHANGITIS": "inflammation of a lymphatic vessel [n LYMPHANGITIDES or LYMPHANGITISES]\n",
  "LYMPHANGITISES": "LYMPHANGITIS, inflammation of a lymphatic vessel [n]\n",
  "LYMPHATIC": "relating to lymph [adj LYMPHATICALLY] / a gland pertaining to, containing, or conveying lymph [n -S]\n",
  "LYMPHATICALLY": "LYMPHATIC, relating to lymph [adv]\n",
  "LYMPHATICS": "LYMPHATIC, a gland pertaining to, containing, or conveying lymph [n]\n",
  "LYMPHOADENOMA": "a tumour of the lymph glands, aka Hodgkin's disease [n LYMPHOADENOMAS or LYMPHOADENOMATA]\n",
  "LYMPHOADENOMAS": "LYMPHOADENOMA, a tumour of the lymph glands, aka Hodgkin's disease [n]\n",
  "LYMPHOADENOMATA": "LYMPHOADENOMA, a tumour of the lymph glands, aka Hodgkin's disease [n]\n",
  "LYMPHOBLAST": "an abnormal cell, the production of which is linked to lymphoblastic leukaemia [n -S]\n",
  "LYMPHOBLASTIC": "of or like a lymphoblast [adj]\n",
  "LYMPHOBLASTS": "LYMPHOBLAST, an abnormal cell, the production of which is linked to lymphoblastic leukaemia [n]\n",
  "LYMPHOCYTE": "a small white blood cell [n -S]\n",
  "LYMPHOCYTES": "LYMPHOCYTE, a small white blood cell [n]\n",
  "LYMPHOCYTIC": "of or like a lymphocyte [adj]\n",
  "LYMPHOCYTOPENIA": "an abnormally low level of lymphocytes in the blood [n]\n",
  "LYMPHOCYTOSES": "LYMPHOCYTOSIS, a great increase in leukocytes [n]\n",
  "LYMPHOCYTOSIS": "a great increase in leukocytes [n LYMPHOCYTOSES]\n",
  "LYMPHOCYTOTIC": "relating to lymphocytosis, a great increase in leukocytes [adj]\n",
  "LYMPHOGRAM": "a record made by lymphography, radiography of the lymph glands [n -S]\n",
  "LYMPHOGRAMS": "LYMPHOGRAM, a record made by lymphography, radiography of the lymph glands [n]\n",
  "LYMPHOGRANULOMA": "a tumour of the lymph glands [n]\n",
  "LYMPHOGRAPHIC": "relating to lymphography [adj]\n",
  "LYMPHOGRAPHIES": "LYMPHOGRAPHY, radiography of the lymph glands [n]\n",
  "LYMPHOGRAPHY": "radiography of the lymph glands [n LYMPHOGRAPHIES]\n",
  "LYMPHOID": "of or resembling lymph, or relating to the lymphatic system [adj]\n",
  "LYMPHOKINE": "any of various substances secreted by T cells [n -S]\n",
  "LYMPHOKINES": "LYMPHOKINE, any of various substances secreted by T cells [n]\n",
  "LYMPHOMA": "a tumor having a structure resembling that of a lymphatic gland [n LYMPHOMAS or LYMPHOMATA]\n",
  "LYMPHOMAS": "LYMPHOMA, a tumor having a structure resembling that of a lymphatic gland [n]\n",
  "LYMPHOMATA": "LYMPHOMA, a tumor having a structure resembling that of a lymphatic gland [n]\n",
  "LYMPHOMATOID": "like a lymphoma [adj]\n",
  "LYMPHOMATOSES": "LYMPHOMATOSIS, the presence of multiple lymphomas in the body [n]\n",
  "LYMPHOMATOSIS": "the presence of multiple lymphomas in the body [n LYMPHOMATOSES]\n",
  "LYMPHOMATOUS": "of or like a lymphoma [adj]\n",
  "LYMPHOPENIA": "an abnormally low level of lymphocytes in the blood [n -S]\n",
  "LYMPHOPENIAS": "LYMPHOPENIA, an abnormally low level of lymphocytes in the blood [n]\n",
  "LYMPHOPOIESES": "LYMPHOPOIESIS, the formation of lymphatic tissue or lymphocytes [n]\n",
  "LYMPHOPOIESIS": "the formation of lymphatic tissue or lymphocytes [n LYMPHOPOIESES]\n",
  "LYMPHOPOIETIC": "relating to lymphopoiesis, the formation of lymphatic tissue or lymphocytes [adj]\n",
  "LYMPHOSARCOMA": "a tumour of the lymph glands [n LYMPHOSARCOMAS or LYMPHOSARCOMATA]\n",
  "LYMPHOSARCOMAS": "LYMPHOSARCOMA, a tumour of the lymph glands [n]\n",
  "LYMPHOSARCOMATA": "LYMPHOSARCOMA, a tumour of the lymph glands [n]\n",
  "LYMPHOTROPHIC": "of a virus, preferentially infecting lymphocytes [adj]\n",
  "LYMPHOUS": "having the nature of lymph [adj]\n",
  "LYMPHS": "LYMPH, a body fluid containing white blood cells [n]\n",
  "LYMS": "LYM, (Shakespeare) a kind of bloodhound, also LYAM, LYME [n]\n",
  "LYNAGE": "(obsolete) lineage, also LIGNAGE [n -S]\n",
  "LYNAGES": "LYNAGE, (obsolete) lineage, also LIGNAGE [n]\n",
  "LYNCEAN": "lynxlike; sharp-sighted [adj]\n",
  "LYNCH": "to judge and put to death without legal sanction [v -ED, -ING, -ES]\n",
  "LYNCHED": "LYNCH, to judge and put to death without legal sanction [v]\n",
  "LYNCHER": "one who takes part in a lynching [n -S]\n",
  "LYNCHERS": "LYNCHER, one who takes part in a lynching [n]\n",
  "LYNCHES": "LYNCH, to judge and put to death without legal sanction [v]\n",
  "LYNCHET": "a terrace or ridge formed in prehistoric or medieval times by ploughing a hillside, also LINCH, LINCHET [n -S]\n",
  "LYNCHETS": "LYNCHET, a terrace or ridge formed in prehistoric or medieval times by ploughing a hillside, also LINCH, LINCHET [n]\n",
  "LYNCHING": "the act of lynching [n -S]\n",
  "LYNCHINGS": "LYNCHING, the act of lynching [n]\n",
  "LYNCHPIN": "a locking pin inserted in the end of a shaft, also LINCHPIN [n -S]\n",
  "LYNCHPINS": "LYNCHPIN, a locking pin inserted in the end of a shaft, also LINCHPIN [n]\n",
  "LYNE": "(Spenser) linen [n -S]\n",
  "LYNES": "LYNE, (Spenser) linen [n]\n",
  "LYNX": "an animal of the Lynx genus of wild cats [n -ES]\n",
  "LYNXES": "LYNX, an animal of the Lynx genus of wild cats [n]\n",
  "LYNXLIKE": "like a lynx [adj]\n",
  "LYOLYSES": "LYOLYSIS, the formation of an acid and a base from the interaction of a salt with a solvent [n]\n",
  "LYOLYSIS": "the formation of an acid and a base from the interaction of a salt with a solvent [n LYOLYSES]\n",
  "LYOMEROUS": "relating to the Lyomeri, soft-bodied fishes [adj]\n",
  "LYONNAISE": "(French) applied to boiled potatoes cut into small pieces, heated in oil or butter and flavored with onion and parsley [adj]\n",
  "LYOPHIL": "of a colloid, readily dispersed in a suitable medium, also LYOPHILE, LYOPHILIC [adj]\n",
  "LYOPHILE": "of a colloid, readily dispersed in a suitable medium, also LYOPHIL, LYOPHILIC [adj]\n",
  "LYOPHILED": "obtained by freeze-drying [adj]\n",
  "LYOPHILIC": "of a colloid, readily dispersed in a suitable medium, also LYOPHIL, LYOPHILE [adj]\n",
  "LYOPHILISATION": "freeze-drying, also LYOPHILIZATION [n -S]\n",
  "LYOPHILISATIONS": "LYOPHILISATION, freeze-drying, also LYOPHILIZATION [n]\n",
  "LYOPHILISE": "to dry by freezing, also LYOPHILIZE [v LYOPHILISED, LYOPHILISING, LYOPHILISES]\n",
  "LYOPHILISED": "LYOPHILISE, to dry by freezing, also LYOPHILIZE [v]\n",
  "LYOPHILISER": "an agent that lyophilises, also LYOPHILIZER [n -S]\n",
  "LYOPHILISERS": "LYOPHILISER, an agent that lyophilises, also LYOPHILIZER [n]\n",
  "LYOPHILISES": "LYOPHILISE, to dry by freezing, also LYOPHILIZE [v]\n",
  "LYOPHILISING": "LYOPHILISE, to dry by freezing, also LYOPHILIZE [v]\n",
  "LYOPHILIZATION": "freeze-drying, also LYOPHILISATION [n -S]\n",
  "LYOPHILIZATIONS": "LYOPHILIZATION, freeze-drying, also LYOPHILISATION [n]\n",
  "LYOPHILIZE": "to dry by freezing, also LYOPHILISE [v LYOPHILIZED, LYOPHILIZING, LYOPHILIZES]\n",
  "LYOPHILIZED": "LYOPHILIZE, to dry by freezing, also LYOPHILISE [v]\n",
  "LYOPHILIZER": "a freeze dryer, also LYOPHILISER [n -S]\n",
  "LYOPHILIZERS": "LYOPHILIZER, a freeze dryer, also LYOPHILISER [n]\n",
  "LYOPHILIZES": "LYOPHILIZE, to dry by freezing, also LYOPHILISE [v]\n",
  "LYOPHILIZING": "LYOPHILIZE, to dry by freezing, also LYOPHILISE [v]\n",
  "LYOPHOBE": "of a colloid, not readily dispersed, also LYOPHOBIC [adj]\n",
  "LYOPHOBIC": "of a colloid, not readily dispersed, also LYOPHOBE [adj]\n",
  "LYOSORPTION": "the adsorption of a liquid on a solid surface, esp. of a solvent on suspended particles [n -S]\n",
  "LYOSORPTIONS": "LYOSORPTION, the adsorption of a liquid on a solid surface, esp. of a solvent on suspended particles [n]\n",
  "LYRA": "as in lyra viol, a lute-like instrument forerunner of the mandolin [adj]\n",
  "LYRATE": "having the shape of a lyre, also LYRATED, LYRIFORM [adj LYRATELY]\n",
  "LYRATED": "having the shape of a lyre, also LYRATE, LYRIFORM [adj]\n",
  "LYRATELY": "LYRATE, having the shape of a lyre, also LYRATED, LYRIFORM [adv]\n",
  "LYRE": "an ancient harp-like instrument [n -S]\n",
  "LYREBIRD": "an Australian bird, that spreads its tail like a lyre during courtship [n -S]\n",
  "LYREBIRDS": "LYREBIRD, an Australian bird, that spreads its tail like a lyre during courtship [n]\n",
  "LYRES": "LYRE, an ancient harp-like instrument [n]\n",
  "LYRIC": "of poems or their authors, expressing individual or private emotions [adj] / a lyrical poem [n -S]\n",
  "LYRICAL": "having the form of a song [adj LYRICALLY]\n",
  "LYRICALLY": "LYRICAL, having the form of a song [adv]\n",
  "LYRICALNESS": "the quality of being lyrical [n -ES]\n",
  "LYRICALNESSES": "LYRICALNESS, the quality of being lyrical [n]\n",
  "LYRICISE": "to write lyrics, also LYRICIZE [v LYRICISED, LYRICISING, LYRICISES]\n",
  "LYRICISED": "LYRICISE, to write lyrics, also LYRICIZE [v]\n",
  "LYRICISES": "LYRICISE, to write lyrics, also LYRICIZE [v]\n",
  "LYRICISING": "LYRICISE, to write lyrics, also LYRICIZE [v]\n",
  "LYRICISM": "the quality of being lyrics, also LYRISM [n -S]\n",
  "LYRICISMS": "LYRICISM, the quality of being lyrics, also LYRISM [n]\n",
  "LYRICIST": "one who writes words for songs [n -S]\n",
  "LYRICISTS": "LYRICIST, one who writes words for songs [n]\n",
  "LYRICIZE": "to write lyrics, also LYRICISE [v LYRICIZED, LYRICIZING, LYRICIZES]\n",
  "LYRICIZED": "LYRICIZE, to write lyrics, also LYRICISE [v]\n",
  "LYRICIZES": "LYRICIZE, to write lyrics, also LYRICISE [v]\n",
  "LYRICIZING": "LYRICIZE, to write lyrics, also LYRICISE [v]\n",
  "LYRICON": "an electronic wind instrument like a large obverse flute [n -S]\n",
  "LYRICONS": "LYRICON, an electronic wind instrument like a large obverse flute [n]\n",
  "LYRICS": "LYRIC, a lyrical poem [n]\n",
  "LYRIFORM": "having the shape of a lyre, also LYRATE, LYRATED [adj]\n",
  "LYRISM": "the quality of being lyrics, also LYRICISM [n -S]\n",
  "LYRISMS": "LYRISM, the quality of being lyrics, also LYRICISM [n]\n",
  "LYRIST": "one who plays the lyre [n -S]\n",
  "LYRISTS": "LYRIST, one who plays the lyre [n]\n",
  "LYSATE": "a product of lysis, the disintegration or destruction of cells [n -S]\n",
  "LYSATES": "LYSATE, a product of lysis, the disintegration or destruction of cells [n]\n",
  "LYSE": "to cause to undergo lysis [v LYSED, LYSING, LYSES]\n",
  "LYSED": "LYSE, to cause to undergo lysis [v]\n",
  "LYSERGIC": "as in lysergic acid diethylamide, the hallucinogen [adj]\n",
  "LYSERGIDE": "the drug LSD [n -S]\n",
  "LYSERGIDES": "LYSERGIDE, the drug LSD [n]\n",
  "LYSES": "LYSE, to cause to undergo lysis [v]\n",
  "LYSIGENETIC": "caused by the breaking down of cells, also LYSIGENIC, LYSIGENOUS [adj]\n",
  "LYSIGENIC": "caused by the breaking down of cells, also LYSIGENETIC, LYSIGENOUS [adj]\n",
  "LYSIGENOUS": "caused by the breaking down of cells, also LYSIGENETIC, LYSIGENIC [adj]\n",
  "LYSIMETER": "an instrument for measuring percolation of water through soil [n -S]\n",
  "LYSIMETERS": "LYSIMETER, an instrument for measuring percolation of water through soil [n]\n",
  "LYSIMETRIC": "relating to measurement by a lysimeter [adj]\n",
  "LYSIN": "a substance capable of disintegrating bacteria [n -S]\n",
  "LYSINE": "an essential amino acid [n -S]\n",
  "LYSINES": "LYSINE, an essential amino acid [n]\n",
  "LYSING": "LYSE, to cause to undergo lysis [v]\n",
  "LYSINS": "LYSIN, a substance capable of disintegrating bacteria [n]\n",
  "LYSIS": "the disintegration of cells by lysins [n LYSES]\n",
  "LYSOGEN": "an antigen increasing lysin production [n -S]\n",
  "LYSOGENIC": "relating to the action of lysogens, an antigen increasing lysin production [adj]\n",
  "LYSOGENICITIES": "LYSOGENICITY, the state of being lysogenic [n]\n",
  "LYSOGENICITY": "the state of being lysogenic [n LYSOGENICITIES]\n",
  "LYSOGENIES": "LYSOGENY, the state of being like a lysogen [n]\n",
  "LYSOGENISATION": "the process of lysogenising, also LYSOGENIZATION [n -S]\n",
  "LYSOGENISATIONS": "LYSOGENISATION, the process of lysogenising, also LYSOGENIZATION [n]\n",
  "LYSOGENISE": "to subject to the action of a lysogen, also LYSOGENIZE [v LYSOGENISED, LYSOGENISING, LYSOGENISES]\n",
  "LYSOGENISED": "LYSOGENISE, to subject to the action of a lysogen, also LYSOGENIZE [v]\n",
  "LYSOGENISES": "LYSOGENISE, to subject to the action of a lysogen, also LYSOGENIZE [v]\n",
  "LYSOGENISING": "LYSOGENISE, to subject to the action of a lysogen, also LYSOGENIZE [v]\n",
  "LYSOGENIZATION": "the process of lysogenizing, also LYSOGENISATION [n -S]\n",
  "LYSOGENIZATIONS": "LYSOGENIZATION, the process of lysogenizing, also LYSOGENISATION [n]\n",
  "LYSOGENIZE": "to subject to the action of a lysogen, also LYSOGENISE [v LYSOGENIZED, LYSOGENIZING, LYSOGENIZES]\n",
  "LYSOGENIZED": "LYSOGENIZE, to subject to the action of a lysogen, also LYSOGENISE [v]\n",
  "LYSOGENIZES": "LYSOGENIZE, to subject to the action of a lysogen, also LYSOGENISE [v]\n",
  "LYSOGENIZING": "LYSOGENIZE, to subject to the action of a lysogen, also LYSOGENISE [v]\n",
  "LYSOGENS": "LYSOGEN, an antigen increasing lysin production [n]\n",
  "LYSOGENY": "the state of being like a lysogen [n LYSOGENIES]\n",
  "LYSOL": "(tradename) a kind of disinfectant [n -S]\n",
  "LYSOLECITHIN": "a hydrolytic substance formed by the enzymatic hydrolysis (as by some snake venoms) of a lecithin [n -S]\n",
  "LYSOLECITHINS": "LYSOLECITHIN, a hydrolytic substance formed by the enzymatic hydrolysis (as by some snake venoms) of a lecithin [n]\n",
  "LYSOLS": "LYSOL, (tradename) a kind of disinfectant [n]\n",
  "LYSOSOMAL": "of or like a lysosome, a saclike part of a cell [adj]\n",
  "LYSOSOME": "a saclike part of a cell [n -S]\n",
  "LYSOSOMES": "LYSOSOME, a saclike part of a cell [n]\n",
  "LYSOZYME": "an antibacterial enzyme present in some plants, and in saliva [n -S]\n",
  "LYSOZYMES": "LYSOZYME, an antibacterial enzyme present in some plants, and in saliva [n]\n",
  "LYSSA": "rabies or hydrophobia [n -S]\n",
  "LYSSAS": "LYSSA, rabies or hydrophobia [n]\n",
  "LYTE": "to alight, also LITE [v LYTED, LYTING, LYTES]\n",
  "LYTED": "LYTE, to alight, also LITE [v]\n",
  "LYTES": "LYTE, to alight, also LITE [v]\n",
  "LYTHE": "(Scots) a fish of the cod family, aka pollack [n -S]\n",
  "LYTHES": "LYTHE, (Scots) a fish of the cod family, aka pollack [n]\n",
  "LYTHRACEOUS": "relating to the purple loosestrife genus [adj]\n",
  "LYTHRUM": "any of a genus of plants including loosestrife [n -S]\n",
  "LYTHRUMS": "LYTHRUM, any of a genus of plants including loosestrife [n]\n",
  "LYTIC": "relating to lysis, the disintegration or destruction of cells [adj LYTICALLY]\n",
  "LYTICALLY": "LYTIC, relating to lysis, the disintegration or destruction of cells [adv]\n",
  "LYTING": "LYTE, to alight, also LITE [v]\n",
  "LYTTA": "(Greek) a fibrous band in the tongue of certain carnivorous mammals [n LYTTAS or LYTTAE]\n",
  "LYTTAE": "LYTTA, (Greek) a fibrous band in the tongue of certain carnivorous mammals [n]\n",
  "LYTTAS": "LYTTA, (Greek) a fibrous band in the tongue of certain carnivorous mammals [n]\n",
  "MA": "(colloquial) mother [n -S]\n",
  "MAA": "to bleat like a goat [v -ED, -ING, -S]\n",
  "MAAED": "MAA, to bleat like a goat [v]\n",
  "MAAING": "MAA, to bleat like a goat [v]\n",
  "MAAR": "(German) a volcanic crater without a cone, usually filled by a lake [n MAARS or MAARE]\n",
  "MAARE": "MAAR, (German) a volcanic crater without a cone, usually filled by a lake [n]\n",
  "MAARS": "MAAR, (German) a volcanic crater without a cone, usually filled by a lake [n]\n",
  "MAAS": "(South African) thick soured milk [n -ES]\n",
  "MAASES": "MAAS, (South African) thick soured milk [n]\n",
  "MAATJES": "(Danish) a young herring, treated, and served as an hors d'oeuvre, also MATJES [n MAATJES]\n",
  "MABE": "a cultured pearl [n -S]\n",
  "MABELA": "(Zulu) ground kaffir corn used for making porridge [n -S]\n",
  "MABELAS": "MABELA, (Zulu) ground kaffir corn used for making porridge [n]\n",
  "MABES": "MABE, a cultured pearl [n]\n",
  "MAC": "(short for) mackintosh, also MACK [n -S]\n",
  "MACA": "a cruciferous biennial plant, native to the Peruvian Andes; the powdered root of this plant, used as a stimulant and health supplement [n -S]\n",
  "MACABER": "gruesome, also MACABRE [adj]\n",
  "MACABERESQUE": "somewhat macaber [adj]\n",
  "MACABRE": "grim, gruesome, also MACABER [adj MACABRER, MACABREST; MACABRELY]\n",
  "MACABRELY": "MACABRE, grim, gruesome, also MACABER [adv]\n",
  "MACABRER": "MACABRE, grim, gruesome, also MACABER [adj]\n",
  "MACABREST": "MACABRE, grim, gruesome, also MACABER [adj]\n",
  "MACACO": "(French) any one of several species of lemurs [n -S]\n",
  "MACACOS": "MACACO, (French) any one of several species of lemurs [n]\n",
  "MACADAM": "pavement made of layers of compacted broken stone, now usually bound with tar or asphalt [n -S]\n",
  "MACADAMED": "paved with macadam [adj]\n",
  "MACADAMIA": "a kind of nut grown in Australia [n -S]\n",
  "MACADAMIAS": "MACADAMIA, a kind of nut grown in Australia [n]\n",
  "MACADAMISATION": "the process of macadamising, also MACADAMIZATION [n -S]\n",
  "MACADAMISATIONS": "MACADAMISATION, the process of macadamising, also MACADAMIZATION [n]\n",
  "MACADAMISE": "to cover a road with small broken stones, also MACADAMIZE [v MACADAMISED, MACADAMISING, MACADAMISES]\n",
  "MACADAMISED": "MACADAMISE, to cover a road with small broken stones, also MACADAMIZE [v]\n",
  "MACADAMISER": "one who macadamises, also MACADAMIZER [n -S]\n",
  "MACADAMISERS": "MACADAMISER, one who macadamises, also MACADAMIZER [n]\n",
  "MACADAMISES": "MACADAMISE, to cover a road with small broken stones, also MACADAMIZE [v]\n",
  "MACADAMISING": "MACADAMISE, to cover a road with small broken stones, also MACADAMIZE [v]\n",
  "MACADAMIZATION": "the process of macadamizing, also MACADAMISATION [n -S]\n",
  "MACADAMIZATIONS": "MACADAMIZATION, the process of macadamizing, also MACADAMISATION [n]\n",
  "MACADAMIZE": "to cover a road with small broken stones, also MACADAMISE [v MACADAMIZED, MACADAMIZING, MACADAMIZES]\n",
  "MACADAMIZED": "MACADAMIZE, to cover a road with small broken stones, also MACADAMISE [v]\n",
  "MACADAMIZER": "one who macadamises, also MACADAMISER [n -S]\n",
  "MACADAMIZERS": "MACADAMIZER, one who macadamises, also MACADAMISER [n]\n",
  "MACADAMIZES": "MACADAMIZE, to cover a road with small broken stones, also MACADAMISE [v]\n",
  "MACADAMIZING": "MACADAMIZE, to cover a road with small broken stones, also MACADAMISE [v]\n",
  "MACADAMS": "MACADAM, pavement made of layers of compacted broken stone, now usually bound with tar or asphalt [n]\n",
  "MACAHUBA": "(Spanish) an American palm, whose nuts yield a violet-scented oil, also MACOYA [n -S]\n",
  "MACAHUBAS": "MACAHUBA, (Spanish) an American palm, whose nuts yield a violet-scented oil, also MACOYA [n]\n",
  "MACALLUM": "(Scots) a dish of vanilla ice-cream topped with raspberry sauce [n -S]\n",
  "MACALLUMS": "MACALLUM, (Scots) a dish of vanilla ice-cream topped with raspberry sauce [n]\n",
  "MACAQUE": "(Bantu) a kind of short-tailed monkey [n -S]\n",
  "MACAQUES": "MACAQUE, (Bantu) a kind of short-tailed monkey [n]\n",
  "MACARISE": "to declare to be blessed, also MACARIZE [v MACARISED, MACARISING, MACARISES]\n",
  "MACARISED": "MACARISE, to declare to be blessed, also MACARIZE [v]\n",
  "MACARISES": "MACARISE, to declare to be blessed, also MACARIZE [v]\n",
  "MACARISING": "MACARISE, to declare to be blessed, also MACARIZE [v]\n",
  "MACARISM": "a beatitude [n -S]\n",
  "MACARISMS": "MACARISM, a beatitude [n]\n",
  "MACARIZE": "to declare to be blessed, also MACARISE [v MACARIZED, MACARIZING, MACARIZES]\n",
  "MACARIZED": "MACARIZE, to declare to be blessed, also MACARISE [v]\n",
  "MACARIZES": "MACARIZE, to declare to be blessed, also MACARISE [v]\n",
  "MACARIZING": "MACARIZE, to declare to be blessed, also MACARISE [v]\n",
  "MACARON": "a cookie with filling in the middle [n -S]\n",
  "MACARONI": "(Italian) a tubular pasta, also MACCARONI [n MACARONIS or MACARONIES]\n",
  "MACARONIC": "mixing words from different languages, esp. Latin with vernacular or Latinized vernacular words [adj MACARONICALLY] / a verse of this type [n -S]\n",
  "MACARONICALLY": "MACARONIC, mixing words from different languages, esp. Latin with vernacular or Latinized vernacular words [adv]\n",
  "MACARONICS": "MACARONIC, a verse of this type [n]\n",
  "MACARONIES": "MACARONI, (Italian) a tubular pasta, also MACCARONI [n]\n",
  "MACARONIS": "MACARONI, (Italian) a tubular pasta, also MACCARONI [n]\n",
  "MACARONS": "MACARON, a cookie with filling in the middle [n]\n",
  "MACAROON": "a sweet biscuit made with egg white and ground almonds or coconut [n -S]\n",
  "MACAROONS": "MACAROON, a sweet biscuit made with egg white and ground almonds or coconut [n]\n",
  "MACAS": "MACA, a cruciferous biennial plant, native to the Peruvian Andes; the powdered root of this plant, used as a stimulant and health supplement [n]\n",
  "MACASSAR": "a kind of hair-oil [n -S]\n",
  "MACASSARS": "MACASSAR, a kind of hair-oil [n]\n",
  "MACAW": "a large tropical American parrot, having a long tail and brilliant plumage [n -S]\n",
  "MACAWS": "MACAW, a large tropical American parrot, having a long tail and brilliant plumage [n]\n",
  "MACCABAW": "a type of snuff, also MACCABOY, MACCOBOY [n -S]\n",
  "MACCABAWS": "MACCABAW, a type of snuff, also MACCABOY, MACCOBOY [n]\n",
  "MACCABOY": "a type of snuff, also MACCABAW, MACCOBOY [n -S]\n",
  "MACCABOYS": "MACCABOY, a type of snuff, also MACCABAW, MACCOBOY [n]\n",
  "MACCARONI": "(Italian) a form of pasta, also MACARONI [n MACCARONIS or MACCARONIES]\n",
  "MACCARONIES": "MACCARONI, (Italian) a form of pasta, also MACARONI [n]\n",
  "MACCARONIS": "MACCARONI, (Italian) a form of pasta, also MACARONI [n]\n",
  "MACCHERONCINI": "a type of macaroni [n -S]\n",
  "MACCHERONCINIS": "MACCHERONCINI, a type of macaroni [n]\n",
  "MACCHIA": "(Italian) a dense growth of small trees and shrubs [n MACCHIE]\n",
  "MACCHIATO": "(Italian) espresso coffee served with a dash of hot or cold milk [n -S]\n",
  "MACCHIATOS": "MACCHIATO, (Italian) espresso coffee served with a dash of hot or cold milk [n]\n",
  "MACCHIE": "MACCHIA, (Italian) a dense growth of small trees and shrubs [n]\n",
  "MACCOBOY": "a type of snuff, also MACCABOY, MACCABAW [n -S]\n",
  "MACCOBOYS": "MACCOBOY, a type of snuff, also MACCABOY, MACCABAW [n]\n",
  "MACE": "to attack with a club-like weapon [v MACED, MACING, MACES]\n",
  "MACEBEARER": "one who carries a mace [n -S]\n",
  "MACEBEARERS": "MACEBEARER, one who carries a mace [n]\n",
  "MACED": "MACE, to attack with a club-like weapon [v]\n",
  "MACEDOINE": "(French) mixed diced vegetables; mixed fruit in syrup of jelly [n -S]\n",
  "MACEDOINES": "MACEDOINE, (French) mixed diced vegetables; mixed fruit in syrup of jelly [n]\n",
  "MACER": "an official who carries a ceremonial staff [n -S]\n",
  "MACERAL": "any of the organic elements that constitute coal [n -S]\n",
  "MACERALS": "MACERAL, any of the organic elements that constitute coal [n]\n",
  "MACERANDUBA": "(Tupi) the Brazilian milk-tree, also MASSARANDUBA, MASSERANDUBA [n -S]\n",
  "MACERANDUBAS": "MACERANDUBA, (Tupi) the Brazilian milk-tree, also MASSARANDUBA, MASSERANDUBA [n]\n",
  "MACERATE": "to soften by soaking [v MACERATED, MACERATING, MACERATES]\n",
  "MACERATED": "MACERATE, to soften by soaking [v]\n",
  "MACERATER": "one who macerates [n -S]\n",
  "MACERATERS": "MACERATER, one who macerates [n]\n",
  "MACERATES": "MACERATE, to soften by soaking [v]\n",
  "MACERATING": "MACERATE, to soften by soaking [v]\n",
  "MACERATION": "the act of macerating [n -S]\n",
  "MACERATIONS": "MACERATION, the act of macerating [n]\n",
  "MACERATIVE": "tending to macerate [adj]\n",
  "MACERATOR": "a person who fasts and becomes emaciated [n -S]\n",
  "MACERATORS": "MACERATOR, a person who fasts and becomes emaciated [n]\n",
  "MACERS": "MACER, an official who carries a ceremonial staff [n]\n",
  "MACES": "MACE, to attack with a club-like weapon [v]\n",
  "MACH": "a number relating the speed of a body to the speed of sound [n -S]\n",
  "MACHACA": "(Spanish) a Mexican dish of shredded meat fried with vegetables [n -S]\n",
  "MACHACAS": "MACHACA, (Spanish) a Mexican dish of shredded meat fried with vegetables [n]\n",
  "MACHAIR": "(Gaelic) a low-lying sandy beach, esp. in the Hebrides [n -S]\n",
  "MACHAIRODONT": "a sabre-toothed animal [n -S]\n",
  "MACHAIRODONTS": "MACHAIRODONT, a sabre-toothed animal [n]\n",
  "MACHAIRS": "MACHAIR, (Gaelic) a low-lying sandy beach, esp. in the Hebrides [n]\n",
  "MACHAN": "(Hindi) a raised platform, esp. in a tree, to watch for game [n -S]\n",
  "MACHANS": "MACHAN, (Hindi) a raised platform, esp. in a tree, to watch for game [n]\n",
  "MACHE": "a herb, lamb's lettuce, corn-salad [n -S]\n",
  "MACHER": "(Yiddish) an important person [n -S]\n",
  "MACHERS": "MACHER, (Yiddish) an important person [n]\n",
  "MACHES": "MACHE, a herb, lamb's lettuce, corn-salad [n]\n",
  "MACHETE": "(Spanish) a large heavy knife, also MATCHET [n -S]\n",
  "MACHETES": "MACHETE, (Spanish) a large heavy knife, also MATCHET [n]\n",
  "MACHI": "(Hinglish) as in machi chips, fish and chips [adj]\n",
  "MACHIAVELIAN": "characterised by ruthless political cunning [adj] / a politically cunning person, also MACHIAVELLIAN [n -S]\n",
  "MACHIAVELIANS": "MACHIAVELIAN, a politically cunning person, also MACHIAVELLIAN [n]\n",
  "MACHIAVELLIAN": "characterised by ruthless political cunning [adj] / a politically cunning person, also MACHIAVELIAN [n -S]\n",
  "MACHIAVELLIANS": "MACHIAVELLIAN, a politically cunning person, also MACHIAVELIAN [n]\n",
  "MACHICOLATE": "to furnish with machicolations [v MACHICOLATED, MACHICOLATING, MACHICOLATES]\n",
  "MACHICOLATED": "MACHICOLATE, to furnish with machicolations [v]\n",
  "MACHICOLATES": "MACHICOLATE, to furnish with machicolations [v]\n",
  "MACHICOLATING": "MACHICOLATE, to furnish with machicolations [v]\n",
  "MACHICOLATION": "an opening between the corbels which support a projecting parapet, or in the floor of a gallery or the roof of a portal for shooting or dropping missiles upon assailants attacking the base of the walls [n -S]\n",
  "MACHICOLATIONS": "MACHICOLATION, an opening between the corbels which support a projecting parapet, or in the floor of a gallery or the roof of a portal for shooting or dropping missiles upon assailants attacking the base of the walls [n]\n",
  "MACHINABILITIES": "MACHINABILITY, the state of being machinable, also MACHINEABILITY [n]\n",
  "MACHINABILITY": "the state of being machinable, also MACHINEABILITY [n MACHINABILITIES]\n",
  "MACHINABLE": "that can be machined, also MACHINEABLE [adj]\n",
  "MACHINATE": "to plan; to contrive; esp. to form a scheme with the purpose of doing harm [v MACHINATED, MACHINATING, MACHINATES]\n",
  "MACHINATED": "MACHINATE, to plan; to contrive; esp. to form a scheme with the purpose of doing harm [v]\n",
  "MACHINATES": "MACHINATE, to plan; to contrive; esp. to form a scheme with the purpose of doing harm [v]\n",
  "MACHINATING": "MACHINATE, to plan; to contrive; esp. to form a scheme with the purpose of doing harm [v]\n",
  "MACHINATION": "an act of machinating [n -S]\n",
  "MACHINATIONS": "MACHINATION, an act of machinating [n]\n",
  "MACHINATOR": "one who machinates; a plotter [n -S]\n",
  "MACHINATORS": "MACHINATOR, one who machinates; a plotter [n]\n",
  "MACHINE": "to process by a mechanical device [v MACHINED, MACHINING, MACHINES]\n",
  "MACHINEABILITY": "the state of being machineable, also MACHINABILITY [n]\n",
  "MACHINEABLE": "that can be machined, also MACHINABLE [adj]\n",
  "MACHINED": "MACHINE, to process by a mechanical device [v]\n",
  "MACHINEGUN": "an automatic rapid-firing gun on a stable but portable mounting [n -S] / to shoot with a machinegun [v MACHINEGUNNED, MACHINEGUNNING, MACHINEGUNS]\n",
  "MACHINEGUNNED": "MACHINEGUN, to shoot with a machinegun [v]\n",
  "MACHINEGUNNING": "MACHINEGUN, to shoot with a machinegun [v]\n",
  "MACHINEGUNS": "MACHINEGUN, to shoot with a machinegun [v]\n",
  "MACHINELESS": "without a machine [adj]\n",
  "MACHINELIKE": "resembling or suggesting a machine esp. in regularity of action or stereotyped uniformity of product [adj]\n",
  "MACHINEMAN": "a person who oversees the working of a machine [n MACHINEMEN]\n",
  "MACHINEMEN": "MACHINEMAN, a person who oversees the working of a machine [n]\n",
  "MACHINERIES": "MACHINERY, machines in general [n]\n",
  "MACHINERY": "machines in general [n MACHINERIES]\n",
  "MACHINES": "MACHINE, to process by a mechanical device [v]\n",
  "MACHINIMA": "the use of realtime three-dimensional graphics rendering engines to generate computer animation [n -S]\n",
  "MACHINIMAS": "MACHINIMA, the use of realtime three-dimensional graphics rendering engines to generate computer animation [n]\n",
  "MACHINING": "process by machine [n -S]\n",
  "MACHININGS": "MACHINING, process by machine [n]\n",
  "MACHINIST": "a person who operates machines to cut or process materials [n -S]\n",
  "MACHINISTS": "MACHINIST, a person who operates machines to cut or process materials [n]\n",
  "MACHISMO": "(Spanish) the quality of being macho, also MACHOISM [n -S]\n",
  "MACHISMOS": "MACHISMO, (Spanish) the quality of being macho, also MACHOISM [n]\n",
  "MACHMETER": "an instrument for measuring Mach number [n -S]\n",
  "MACHMETERS": "MACHMETER, an instrument for measuring Mach number [n]\n",
  "MACHO": "(Spanish) an aggressively virile man, one who exhibits machismo [n -S]\n",
  "MACHOISM": "the quality of being macho, also MACHISMO [n -S]\n",
  "MACHOISMS": "MACHOISM, the quality of being macho, also MACHISMO [n]\n",
  "MACHOS": "MACHO, (Spanish) an aggressively virile man, one who exhibits machismo [n]\n",
  "MACHREE": "(Anglo-Irish) an affectionate form of address, my dear [n -S]\n",
  "MACHREES": "MACHREE, (Anglo-Irish) an affectionate form of address, my dear [n]\n",
  "MACHS": "MACH, a number relating the speed of a body to the speed of sound [n]\n",
  "MACHTPOLITIK": "(German) power politics [n -S]\n",
  "MACHTPOLITIKS": "MACHTPOLITIK, (German) power politics [n]\n",
  "MACHZOR": "(Hebrew) a Jewish prayer book, also MAHZOR [n MACHZORS or MACHZORIM]\n",
  "MACHZORIM": "MACHZOR, (Hebrew) a Jewish prayer book, also MAHZOR [n]\n",
  "MACHZORS": "MACHZOR, (Hebrew) a Jewish prayer book, also MAHZOR [n]\n",
  "MACING": "MACE, to attack with a club-like weapon [v]\n",
  "MACINTOSH": "a waterproof raincoat made of rubberized cloth, also MACKINTOSH [n -ES]\n",
  "MACINTOSHES": "MACINTOSH, a waterproof raincoat made of rubberized cloth, also MACKINTOSH [n]\n",
  "MACK": "a raincoat, also MAC [n -S]\n",
  "MACKEREL": "a marine food fish [n -S]\n",
  "MACKERELS": "MACKEREL, a marine food fish [n]\n",
  "MACKINAW": "(Native American) a heavy napped and felted wool cloth [n -S]\n",
  "MACKINAWS": "MACKINAW, (Native American) a heavy napped and felted wool cloth [n]\n",
  "MACKINTOSH": "a waterproof raincoat made of rubberized cloth, also MACINTOSH [n -ES]\n",
  "MACKINTOSHES": "MACKINTOSH, a waterproof raincoat made of rubberized cloth, also MACINTOSH [n]\n",
  "MACKLE": "to blur in printing, also MACULE [v MACKLED, MACKLING, MACKLES]\n",
  "MACKLED": "MACKLE, to blur in printing, also MACULE [v]\n",
  "MACKLES": "MACKLE, to blur in printing, also MACULE [v]\n",
  "MACKLING": "MACKLE, to blur in printing, also MACULE [v]\n",
  "MACKS": "MACK, a raincoat, also MAC [n]\n",
  "MACLE": "a mineral, aka chiastolite or andalusite, so called from the tessellated appearance of a cross section [n -S]\n",
  "MACLED": "having a dark spot [adj]\n",
  "MACLES": "MACLE, a mineral, aka chiastolite or andalusite, so called from the tessellated appearance of a cross section [n]\n",
  "MACON": "(French) smoked salted mutton [n -S]\n",
  "MACONOCHIE": "army tinned stew [n -S]\n",
  "MACONOCHIES": "MACONOCHIE, army tinned stew [n]\n",
  "MACONS": "MACON, (French) smoked salted mutton [n]\n",
  "MACOYA": "(Spanish) an American palm, whose nuts yield a violet-scented oil, also MACAHUBA [n -S]\n",
  "MACOYAS": "MACOYA, (Spanish) an American palm, whose nuts yield a violet-scented oil, also MACAHUBA [n]\n",
  "MACRAME": "(Turkish) a fringe or trimming of knotted thread, also MACRAMI [n -S]\n",
  "MACRAMES": "MACRAME, (Turkish) a fringe or trimming of knotted thread, also MACRAMI [n]\n",
  "MACRAMI": "(Turkish) a fringe or trimming of knotted thread, also MACRAME [n -S]\n",
  "MACRAMIS": "MACRAMI, (Turkish) a fringe or trimming of knotted thread, also MACRAME [n]\n",
  "MACRENCEPHALIA": "the condition of having an abnormally large brain, also MACRENCEPHALY, MACROCEPHALIA [n -S]\n",
  "MACRENCEPHALIAS": "MACRENCEPHALIA, the condition of having an abnormally large brain, also MACRENCEPHALY, MACROCEPHALIA [n]\n",
  "MACRENCEPHALIES": "MACRENCEPHALY, the condition of having an abnormally large brain, also MACRENCEPHALIA, MACROCEPHALIA [n]\n",
  "MACRENCEPHALY": "the condition of having an abnormally large brain, also MACRENCEPHALIA, MACROCEPHALIA [n MACRENCEPHALIES]\n",
  "MACRO": "in computing, a single instruction that brings a set of instructions into operation [n -S]\n",
  "MACROAGGREGATE": "a relatively large particle (as of soil) [n -S]\n",
  "MACROAGGREGATED": "in the form of a macroaggregate [adj]\n",
  "MACROAGGREGATES": "MACROAGGREGATE, a relatively large particle (as of soil) [n]\n",
  "MACROBIAN": "long-lived [adj]\n",
  "MACROBIOTA": "the larger organisms in the soil collectively [n -S]\n",
  "MACROBIOTAS": "MACROBIOTA, the larger organisms in the soil collectively [n]\n",
  "MACROBIOTE": "a long-lived organism [n -S]\n",
  "MACROBIOTES": "MACROBIOTE, a long-lived organism [n]\n",
  "MACROBIOTIC": "promoting longevity [adj]\n",
  "MACROBIOTICS": "the art or science of prolonging life; a cult partly concerned with diet, foods regarded as pure being vegetable substances grown and prepared without chemicals or processing [n]\n",
  "MACROCARPA": "an evergreen conifer of New Zealand [n -S]\n",
  "MACROCARPAS": "MACROCARPA, an evergreen conifer of New Zealand [n]\n",
  "MACROCEPHALIA": "the condition of having an abnormally large brain, also MACRENCEPHALIA, MACRENCEPHALY [n -S]\n",
  "MACROCEPHALIAS": "MACROCEPHALIA, the condition of having an abnormally large brain, also MACRENCEPHALIA, MACRENCEPHALY [n]\n",
  "MACROCEPHALIC": "having an abnormally large head or skull [adj]\n",
  "MACROCEPHALIES": "MACROCEPHALY, largeness, or abnormal largeness, of the head [n]\n",
  "MACROCEPHALOUS": "having a large head [adj]\n",
  "MACROCEPHALY": "largeness, or abnormal largeness, of the head [n MACROCEPHALIES]\n",
  "MACROCLIMATE": "large-scale climate [n -S]\n",
  "MACROCLIMATES": "MACROCLIMATE, large-scale climate [n]\n",
  "MACROCLIMATIC": "relating to climate on a large scale [adj]\n",
  "MACROCODE": "a macro instruction [n -S]\n",
  "MACROCODES": "MACROCODE, a macro instruction [n]\n",
  "MACROCOPIES": "MACROCOPY, an enlarged copy of printed material for people with weak sight [n]\n",
  "MACROCOPY": "an enlarged copy of printed material for people with weak sight [n MACROCOPIES]\n",
  "MACROCOSM": "a large and complex structure considered as a whole [n -S]\n",
  "MACROCOSMIC": "relating to a macrocosm [adj MACROCOSMICALLY]\n",
  "MACROCOSMICALLY": "MACROCOSMIC, relating to a macrocosm [adv]\n",
  "MACROCOSMS": "MACROCOSM, a large and complex structure considered as a whole [n]\n",
  "MACROCYCLE": "a macrocyclic organic molecule or compound [n -S]\n",
  "MACROCYCLES": "MACROCYCLE, a macrocyclic organic molecule or compound [n]\n",
  "MACROCYCLIC": "containing or being a chemical ring that consists usually of 15 or more atoms [adj]\n",
  "MACROCYST": "an unusually large cyst [n -S]\n",
  "MACROCYSTS": "MACROCYST, an unusually large cyst [n]\n",
  "MACROCYTE": "an abnormally large red blood corpuscle [n -S]\n",
  "MACROCYTES": "MACROCYTE, an abnormally large red blood corpuscle [n]\n",
  "MACROCYTIC": "relating to a macrocyte [adj]\n",
  "MACROCYTOSES": "MACROCYTOSIS, the occurrence of macrocytes in the blood [n]\n",
  "MACROCYTOSIS": "the occurrence of macrocytes in the blood [n MACROCYTOSES]\n",
  "MACRODACTYL": "one of a group of wading birds [n -S]\n",
  "MACRODACTYLIC": "having large fingers, also MACRODACTYLOUS [adj]\n",
  "MACRODACTYLIES": "MACRODACTYLY, the condition of being macrodactylous, having large fingers [n]\n",
  "MACRODACTYLOUS": "having large fingers, also MACRODACTYLIC [adj]\n",
  "MACRODACTYLS": "MACRODACTYL, one of a group of wading birds [n]\n",
  "MACRODACTYLY": "the condition of being macrodactylous, having large fingers [n MACRODACTYLIES]\n",
  "MACRODIAGONAL": "in crystallography, the longer lateral axis [n -S]\n",
  "MACRODIAGONALS": "MACRODIAGONAL, in crystallography, the longer lateral axis [n]\n",
  "MACRODOME": "a dome parallel to the longer lateral axis of an orthorhombic crystal [n -S]\n",
  "MACRODOMES": "MACRODOME, a dome parallel to the longer lateral axis of an orthorhombic crystal [n]\n",
  "MACRODONT": "having large teeth [adj]\n",
  "MACROECONOMIC": "relating to macroeconomics [adj]\n",
  "MACROECONOMICS": "a study of economics in terms of whole systems esp. with reference to general levels of output and income and to the interrelations among sectors of the economy [n]\n",
  "MACROEVOLUTION": "evolution that results in relatively large and complex changes, as in species formation [n -S]\n",
  "MACROEVOLUTIONS": "MACROEVOLUTION, evolution that results in relatively large and complex changes, as in species formation [n]\n",
  "MACROFAUNA": "animals visible to the naked eye [n MACROFAUNAS or MACROFAUNAE]\n",
  "MACROFAUNAE": "MACROFAUNA, animals visible to the naked eye [n]\n",
  "MACROFAUNAS": "MACROFAUNA, animals visible to the naked eye [n]\n",
  "MACROFLORA": "(Greek) plants visible to the naked eye [n MACROFLORAS or MACROFLORAE]\n",
  "MACROFLORAE": "MACROFLORA, (Greek) plants visible to the naked eye [n]\n",
  "MACROFLORAS": "MACROFLORA, (Greek) plants visible to the naked eye [n]\n",
  "MACROFOSSIL": "a fossil large enough to be seen with the naked eye [n -S]\n",
  "MACROFOSSILS": "MACROFOSSIL, a fossil large enough to be seen with the naked eye [n]\n",
  "MACROGAMETE": "the larger and usually female gamete of a heterogamous organism, also MEGAGAMETE [n -S]\n",
  "MACROGAMETES": "MACROGAMETE, the larger and usually female gamete of a heterogamous organism, also MEGAGAMETE [n]\n",
  "MACROGLIA": "one of the two types of non-nervous tissue found in the central nervous system [n -S]\n",
  "MACROGLIAS": "MACROGLIA, one of the two types of non-nervous tissue found in the central nervous system [n]\n",
  "MACROGLOBULIN": "a highly polymerized globulin of high molecular weight [n -S]\n",
  "MACROGLOBULINS": "MACROGLOBULIN, a highly polymerized globulin of high molecular weight [n]\n",
  "MACROGRAPH": "a photograph, drawing, etc. in which an object appears as large as or several times larger than the original [n -S]\n",
  "MACROGRAPHIC": "of or like a macrograph, a photograph, drawing, etc. in which an object appears as large as or several times larger than the original [adj]\n",
  "MACROGRAPHS": "MACROGRAPH, a photograph, drawing, etc. in which an object appears as large as or several times larger than the original [n]\n",
  "MACROLIDE": "any of a class of antibiotics used to treat fungal infections [n -S]\n",
  "MACROLIDES": "MACROLIDE, any of a class of antibiotics used to treat fungal infections [n]\n",
  "MACROLOGIES": "MACROLOGY, much talk with little to say [n]\n",
  "MACROLOGY": "much talk with little to say [n MACROLOGIES]\n",
  "MACROMARKETING": "marketing concerning all marketing as a whole, marketing systems, and the mutual effect that society and marketing systems have on each other [n -S]\n",
  "MACROMARKETINGS": "MACROMARKETING, marketing concerning all marketing as a whole, marketing systems, and the mutual effect that society and marketing systems have on each other [n]\n",
  "MACROMERE": "a large blastomere, one of the segments first formed by the division of the ovum [n -S]\n",
  "MACROMERES": "MACROMERE, a large blastomere, one of the segments first formed by the division of the ovum [n]\n",
  "MACROMOLE": "in chemistry, a large mole [n -S]\n",
  "MACROMOLECULAR": "of or like a macromolecule [adj]\n",
  "MACROMOLECULE": "a very large molecule, as of a protein or rubber [n -S]\n",
  "MACROMOLECULES": "MACROMOLECULE, a very large molecule, as of a protein or rubber [n]\n",
  "MACROMOLES": "MACROMOLE, in chemistry, a large mole [n]\n",
  "MACROMUTATION": "an abnormally great change in the characteristics of a population of animals or plants over relatively few successive generations [n -S]\n",
  "MACROMUTATIONS": "MACROMUTATION, an abnormally great change in the characteristics of a population of animals or plants over relatively few successive generations [n]\n",
  "MACRON": "(Greek) a symbol placed over a vowel to indicate a long sound [n -S]\n",
  "MACRONS": "MACRON, (Greek) a symbol placed over a vowel to indicate a long sound [n]\n",
  "MACRONUCLEAR": "of or like a macronucleus [adj]\n",
  "MACRONUCLEI": "MACRONUCLEUS, a relatively large densely staining nucleus of most ciliate protozoans that is derived from micronuclei and controls various nonreproductive functions [n]\n",
  "MACRONUCLEUS": "a relatively large densely staining nucleus of most ciliate protozoans that is derived from micronuclei and controls various nonreproductive functions [n MACRONUCLEI or MACRONUCLEUSES]\n",
  "MACRONUCLEUSES": "MACRONUCLEUS, a relatively large densely staining nucleus of most ciliate protozoans that is derived from micronuclei and controls various nonreproductive functions [n]\n",
  "MACRONUTRIENT": "a chemical element (as nitrogen, phosphorus, or potassium) of which relatively large quantities are essential to the growth and health of a plant [n -S]\n",
  "MACRONUTRIENTS": "MACRONUTRIENT, a chemical element (as nitrogen, phosphorus, or potassium) of which relatively large quantities are essential to the growth and health of a plant [n]\n",
  "MACROPHAGE": "any of the large phagocytic cells situated in the walls of blood vessels [n -S]\n",
  "MACROPHAGES": "MACROPHAGE, any of the large phagocytic cells situated in the walls of blood vessels [n]\n",
  "MACROPHAGIC": "of or like a macrophage [adj]\n",
  "MACROPHAGOUS": "of an animal, feeding on relatively large particles of food [adj]\n",
  "MACROPHOTOGRAPH": "a larger than life-size closeup photograph [n]\n",
  "MACROPHYLA": "MACROPHYLUM, a large phylum, as in New Guinea macrophylum [n]\n",
  "MACROPHYLUM": "a large phylum, as in New Guinea macrophylum [n MACROPHYLA]\n",
  "MACROPHYSICS": "the branch of physics concerned with macroscopic systems and objects [n]\n",
  "MACROPHYTE": "a macroscopic plant in an aquatic environment [n -S]\n",
  "MACROPHYTES": "MACROPHYTE, a macroscopic plant in an aquatic environment [n]\n",
  "MACROPHYTIC": "relating to a macrophyte [adj]\n",
  "MACROPINACOID": "a crystalline pinacoid which runs parallel to the longer horizontal axis, also MACROPINAKOID [n -S]\n",
  "MACROPINACOIDS": "MACROPINACOID, a crystalline pinacoid which runs parallel to the longer horizontal axis, also MACROPINAKOID [n]\n",
  "MACROPINAKOID": "a crystalline pinacoid which runs parallel to the longer horizontal axis, also MACROPINACOID [n -S]\n",
  "MACROPINAKOIDS": "MACROPINAKOID, a crystalline pinacoid which runs parallel to the longer horizontal axis, also MACROPINACOID [n]\n",
  "MACROPOD": "an animal of the marsupial family that includes kangaroos [n -S]\n",
  "MACROPODS": "MACROPOD, an animal of the marsupial family that includes kangaroos [n]\n",
  "MACROPRISM": "in crystallography, a prism parallel to the macrodiagonal [n -S]\n",
  "MACROPRISMS": "MACROPRISM, in crystallography, a prism parallel to the macrodiagonal [n]\n",
  "MACROPRUDENTIAL": "of or relating to regulations designed to prevent financial institutions from taking risks that could endanger the financial system as a whole [adj]\n",
  "MACROPSIA": "a condition of the eyes in which objects appear larger than normal [n -S]\n",
  "MACROPSIAS": "MACROPSIA, a condition of the eyes in which objects appear larger than normal [n]\n",
  "MACROPTEROUS": "having large wings or fins [adj]\n",
  "MACROS": "MACRO, in computing, a single instruction that brings a set of instructions into operation [n]\n",
  "MACROSCALE": "a large often macroscopic scale [n -S]\n",
  "MACROSCALES": "MACROSCALE, a large often macroscopic scale [n]\n",
  "MACROSCOPIC": "large enough to be visible to the unaided eye [adj MACROSCOPICALLY]\n",
  "MACROSCOPICALLY": "MACROSCOPIC, large enough to be visible to the unaided eye [adv]\n",
  "MACROSOCIOLOGY": "the branch of sociology concerned with the study of human societies on a wide scale [n]\n",
  "MACROSPORANGIA": "MACROSPORANGIUM, a sporangium producing only megaspores [n]\n",
  "MACROSPORANGIUM": "a sporangium producing only megaspores [n MACROSPORANGIA]\n",
  "MACROSPORE": "a spore giving rise to a female gametophyte [n -S]\n",
  "MACROSPORES": "MACROSPORE, a spore giving rise to a female gametophyte [n]\n",
  "MACROSTRUCTURAL": "of or like a macrostructure [adj]\n",
  "MACROSTRUCTURE": "the structure (as of metal, a body part, or the soil) revealed by visual examination with little or no magnification [n -S]\n",
  "MACROSTRUCTURES": "MACROSTRUCTURE, the structure (as of metal, a body part, or the soil) revealed by visual examination with little or no magnification [n]\n",
  "MACROTOUS": "having large ears [adj]\n",
  "MACROZAMIA": "a plant of genus Macrozamia, Australian cycads [n -S]\n",
  "MACROZAMIAS": "MACROZAMIA, a plant of genus Macrozamia, Australian cycads [n]\n",
  "MACRURAL": "long-tailed, also MACRUROUS [adj]\n",
  "MACRURAN": "any of a suborder of crustaceans [n -S]\n",
  "MACRURANS": "MACRURAN, any of a suborder of crustaceans [n]\n",
  "MACRUROID": "belonging to the crustacean division including lobsters, prawns [adj]\n",
  "MACRUROUS": "long-tailed, also MACRURAL [adj]\n",
  "MACS": "MAC, (short for) mackintosh, also MACK [n]\n",
  "MACTATION": "the killing or slaughter esp. of a sacrificial victim [n -S]\n",
  "MACTATIONS": "MACTATION, the killing or slaughter esp. of a sacrificial victim [n]\n",
  "MACULA": "(Latin) a spot, as on the skin, or on the surface of the sun [n MACULAE or MACULAS]\n",
  "MACULAE": "MACULA, (Latin) a spot, as on the skin, or on the surface of the sun [n]\n",
  "MACULAR": "spotted; patchy [adj]\n",
  "MACULAS": "MACULA, (Latin) a spot, as on the skin, or on the surface of the sun [n]\n",
  "MACULATE": "to spot or stain [v MACULATED, MACULATING, MACULATES]\n",
  "MACULATED": "MACULATE, to spot or stain [v]\n",
  "MACULATES": "MACULATE, to spot or stain [v]\n",
  "MACULATING": "MACULATE, to spot or stain [v]\n",
  "MACULATION": "being covered in spots [n -S]\n",
  "MACULATIONS": "MACULATION, being covered in spots [n]\n",
  "MACULATURE": "blotting paper [n -S]\n",
  "MACULATURES": "MACULATURE, blotting paper [n]\n",
  "MACULE": "to blur in printing, also MACKLE [v MACULED, MACULING, MACULES]\n",
  "MACULED": "MACULE, to blur in printing, also MACKLE [v]\n",
  "MACULES": "MACULE, to blur in printing, also MACKLE [v]\n",
  "MACULING": "MACULE, to blur in printing, also MACKLE [v]\n",
  "MACULOSE": "spotted [adj]\n",
  "MACUMBA": "(Portuguese) a Black religious cult practised in Brazil, characterized by sorcery, ritual dancing, and the use of fetishes [n -S]\n",
  "MACUMBAS": "MACUMBA, (Portuguese) a Black religious cult practised in Brazil, characterized by sorcery, ritual dancing, and the use of fetishes [n]\n",
  "MAD": "insane [adj MADDER, MADDEST, MADLY] / to become or make angry or mad [v MADDED, MADDING, MADS]\n",
  "MADAFU": "(Swahili) coconut milk [n -S]\n",
  "MADAFUS": "MADAFU, (Swahili) coconut milk [n]\n",
  "MADAM": "a courteous form of address for a woman [n -S] / to address as madam [v -ED, -ING, -S]\n",
  "MADAME": "(French) the French title of respect for a married woman [n MADAMES or MESDAMES] / to address as madame [v MADAMED, MADAMING, MADAMES]\n",
  "MADAMED": "MADAM, to address as madam [v]\n",
  "MADAMES": "MADAME, to address as madame [v]\n",
  "MADAMING": "MADAM, to address as madam [v]\n",
  "MADAMS": "MADAM, to address as madam [v]\n",
  "MADAROSES": "MADAROSIS, loss of eyelashes or eyebrows [n]\n",
  "MADAROSIS": "loss of eyelashes or eyebrows [n MADAROSES]\n",
  "MADBRAIN": "(Shakespeare) a rash or insane person [n -S]\n",
  "MADBRAINED": "(Shakespeare) hotheaded, rash [adj]\n",
  "MADBRAINS": "MADBRAIN, (Shakespeare) a rash or insane person [n]\n",
  "MADCAP": "an impulsive person [n -S]\n",
  "MADCAPS": "MADCAP, an impulsive person [n]\n",
  "MADDED": "MAD, to become or make angry or mad [v]\n",
  "MADDEN": "to make or become mad [v -ED, -ING, -S]\n",
  "MADDENED": "MADDEN, to make or become mad [v]\n",
  "MADDENING": "MADDEN, to make or become mad [v]\n",
  "MADDENINGLY": "MADDENING, MADDEN, to make or become mad [adv]\n",
  "MADDENINGNESS": "the state of being maddening [n -ES]\n",
  "MADDENINGNESSES": "MADDENINGNESS, the state of being maddening [n]\n",
  "MADDENS": "MADDEN, to make or become mad [v]\n",
  "MADDER": "a herbaceous plant whose root produces a red dye [n -S]\n",
  "MADDERS": "MADDER, a herbaceous plant whose root produces a red dye [n]\n",
  "MADDEST": "MAD, insane [adj]\n",
  "MADDING": "MAD, to become or make angry or mad [v]\n",
  "MADDINGLY": "MADDING, MAD, to become or make angry or mad [adv]\n",
  "MADDISH": "somewhat mad [adj]\n",
  "MADDOCK": "(dialect) a kind of pickaxe for loosening soil, also MATTOCK [n -S]\n",
  "MADDOCKS": "MADDOCK, (dialect) a kind of pickaxe for loosening soil, also MATTOCK [n]\n",
  "MADE": "MAKE, to cause to exist [v]\n",
  "MADEFACTION": "moistening [n -S]\n",
  "MADEFACTIONS": "MADEFACTION, moistening [n]\n",
  "MADEFIED": "MADEFY, (archaic) to moisten [v]\n",
  "MADEFIES": "MADEFY, (archaic) to moisten [v]\n",
  "MADEFY": "(archaic) to moisten [v MADEFIED, MADEFYING, MADEFIES]\n",
  "MADEFYING": "MADEFY, (archaic) to moisten [v]\n",
  "MADEIRA": "a white wine [n -S]\n",
  "MADEIRAS": "MADEIRA, a white wine [n]\n",
  "MADELEINE": "(French) a small, rich cake baked in a fluted, shell-shaped pan [n -S]\n",
  "MADELEINES": "MADELEINE, (French) a small, rich cake baked in a fluted, shell-shaped pan [n]\n",
  "MADEMOISELLE": "(French) a French title of respect for an unmarried woman [n -S]\n",
  "MADEMOISELLES": "MADEMOISELLE, (French) a French title of respect for an unmarried woman [n]\n",
  "MADERISATION": "the act of maderising, also MADERIZATION [n -S]\n",
  "MADERISATIONS": "MADERISATION, the act of maderising, also MADERIZATION [n]\n",
  "MADERISE": "(French) to become flat and rusty (wine), also MADERIZE [v MADERISED, MADERISING, MADERISES]\n",
  "MADERISED": "MADERISE, (French) to become flat and rusty (wine), also MADERIZE [v]\n",
  "MADERISES": "MADERISE, (French) to become flat and rusty (wine), also MADERIZE [v]\n",
  "MADERISING": "MADERISE, (French) to become flat and rusty (wine), also MADERIZE [v]\n",
  "MADERIZATION": "the act of maderizing, also MADERISATION [n -S]\n",
  "MADERIZATIONS": "MADERIZATION, the act of maderizing, also MADERISATION [n]\n",
  "MADERIZE": "(French) to become flat and rusty (wine), also MADERISE [v MADERIZED, MADERIZING, MADERIZES]\n",
  "MADERIZED": "MADERIZE, (French) to become flat and rusty (wine), also MADERISE [v]\n",
  "MADERIZES": "MADERIZE, (French) to become flat and rusty (wine), also MADERISE [v]\n",
  "MADERIZING": "MADERIZE, (French) to become flat and rusty (wine), also MADERISE [v]\n",
  "MADEUPPY": "(colloquial) artificially invented [adj]\n",
  "MADGE": "a type of hammer used in silver plating [n -S]\n",
  "MADGES": "MADGE, a type of hammer used in silver plating [n]\n",
  "MADHOUSE": "an insane asylum [n -S]\n",
  "MADHOUSES": "MADHOUSE, an insane asylum [n]\n",
  "MADID": "wet; dank [adj]\n",
  "MADISON": "a type of cycle relay race [n -S]\n",
  "MADISONS": "MADISON, a type of cycle relay race [n]\n",
  "MADLING": "a mad person [n -S]\n",
  "MADLINGS": "MADLING, a mad person [n]\n",
  "MADLY": "MAD, insane [adv]\n",
  "MADMAN": "a man who is insane [n MADMEN]\n",
  "MADMEN": "MADMAN, a man who is insane [n]\n",
  "MADNESS": "the state of being mad [n -ES]\n",
  "MADNESSES": "MADNESS, the state of being mad [n]\n",
  "MADONNA": "(Italian) a former Italian title of respect for a woman [n -S]\n",
  "MADONNAISH": "like a madonna [adj]\n",
  "MADONNAS": "MADONNA, (Italian) a former Italian title of respect for a woman [n]\n",
  "MADONNAWISE": "in the manner of a madonna [adv]\n",
  "MADOQUA": "(Amharic) a small Abyssinian antelope [n -S]\n",
  "MADOQUAS": "MADOQUA, (Amharic) a small Abyssinian antelope [n]\n",
  "MADRAS": "(Tamil) a fine plain-woven cotton or silk [n -ES]\n",
  "MADRASA": "(Arabic) an Islamic college, or school attached to mosque, also MADRASAH, MADRASSA, MADRASSAH, MEDRESA, MEDRESE, MEDRESSEH [n -S]\n",
  "MADRASAH": "(Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASSA, MADRASSAH, MEDRESA, MEDRESE, MEDRESSEH [n -S]\n",
  "MADRASAHS": "MADRASAH, (Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASSA, MADRASSAH, MEDRESA, MEDRESE, MEDRESSEH [n]\n",
  "MADRASAS": "MADRASA, (Arabic) an Islamic college, or school attached to mosque, also MADRASAH, MADRASSA, MADRASSAH, MEDRESA, MEDRESE, MEDRESSEH [n]\n",
  "MADRASES": "MADRAS, (Tamil) a fine plain-woven cotton or silk [n]\n",
  "MADRASSA": "(Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSAH, MEDRESA, MEDRESE, MEDRESSEH [n -S]\n",
  "MADRASSAH": "(Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSA, MEDRESA, MEDRESE, MEDRESSEH [n -S]\n",
  "MADRASSAHS": "MADRASSAH, (Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSA, MEDRESA, MEDRESE, MEDRESSEH [n]\n",
  "MADRASSAS": "MADRASSA, (Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSAH, MEDRESA, MEDRESE, MEDRESSEH [n]\n",
  "MADRE": "(Spanish) mother [n -S]\n",
  "MADREPORAL": "relating to madrepore, a kind of coral, also MADREPORIC [adj]\n",
  "MADREPORE": "a coral of the common reef-building type, occurring esp. in tropical seas [n -S]\n",
  "MADREPORES": "MADREPORE, a coral of the common reef-building type, occurring esp. in tropical seas [n]\n",
  "MADREPORIAN": "a coral, a madrepore [n -S]\n",
  "MADREPORIANS": "MADREPORIAN, a coral, a madrepore [n]\n",
  "MADREPORIC": "relating to madrepore, a kind of coral, also MADREPORAL [adj]\n",
  "MADREPORITE": "in echinoderms, a perforated plate serving as opening to the stone canal [n -S]\n",
  "MADREPORITES": "MADREPORITE, in echinoderms, a perforated plate serving as opening to the stone canal [n]\n",
  "MADREPORITIC": "of or like madreporite, in echinoderms, a perforated plate serving as opening to the stone canal [adj]\n",
  "MADRES": "MADRE, (Spanish) mother [n]\n",
  "MADRIGAL": "an unaccompanied song in several parts in counterpoint [n -S]\n",
  "MADRIGALESQUE": "somewhat in the style of a madrigal [adj]\n",
  "MADRIGALIAN": "of or like a madrigal [adj]\n",
  "MADRIGALIST": "one who sings madrigals [n -S]\n",
  "MADRIGALISTS": "MADRIGALIST, one who sings madrigals [n]\n",
  "MADRIGALS": "MADRIGAL, an unaccompanied song in several parts in counterpoint [n]\n",
  "MADRILENE": "(French) a tomato-flavored consomme [n -S]\n",
  "MADRILENES": "MADRILENE, (French) a tomato-flavored consomme [n]\n",
  "MADRONA": "(Spanish) a Californian tree of the Arbutus genus, also MADRONE, MADRONO [n -S]\n",
  "MADRONAS": "MADRONA, (Spanish) a Californian tree of the Arbutus genus, also MADRONE, MADRONO [n]\n",
  "MADRONE": "(Spanish) a Californian tree of the Arbutus genus, also MADRONA, MADRONO [n -S]\n",
  "MADRONES": "MADRONE, (Spanish) a Californian tree of the Arbutus genus, also MADRONA, MADRONO [n]\n",
  "MADRONO": "(Spanish) a Californian tree of the Arbutus genus, also MADRONA, MADRONE [n -S]\n",
  "MADRONOS": "MADRONO, (Spanish) a Californian tree of the Arbutus genus, also MADRONA, MADRONE [n]\n",
  "MADS": "MAD, to become or make angry or mad [v]\n",
  "MADTOM": "a North American catfish [n -S]\n",
  "MADTOMS": "MADTOM, a North American catfish [n]\n",
  "MADURO": "(Spanish) a dark-coloured strong cigar [n -S]\n",
  "MADUROS": "MADURO, (Spanish) a dark-coloured strong cigar [n]\n",
  "MADWOMAN": "a woman who is insane [n MADWOMEN]\n",
  "MADWOMEN": "MADWOMAN, a woman who is insane [n]\n",
  "MADWORT": "any of various plants believed to cure canine madness [n -S]\n",
  "MADWORTS": "MADWORT, any of various plants believed to cure canine madness [n]\n",
  "MADZOON": "a food similar to yoghurt made from fermented milk, also MATZOON [n -S]\n",
  "MADZOONS": "MADZOON, a food similar to yoghurt made from fermented milk, also MATZOON [n]\n",
  "MAE": "(Scots) more [n -S]\n",
  "MAELID": "(Greek) an apple nymph [n -S]\n",
  "MAELIDS": "MAELID, (Greek) an apple nymph [n]\n",
  "MAELSTROM": "(Dutch) a powerful whirlpool [n -S]\n",
  "MAELSTROMS": "MAELSTROM, (Dutch) a powerful whirlpool [n]\n",
  "MAENAD": "(Greek) a female follower of Bacchus, also MENAD [n MAENADS or MAENADES]\n",
  "MAENADES": "MAENAD, (Greek) a female follower of Bacchus, also MENAD [n]\n",
  "MAENADIC": "like a maenad, furious, bacchanalian [adj MAENADICALLY]\n",
  "MAENADICALLY": "MAENADIC, like a maenad, furious, bacchanalian [adv]\n",
  "MAENADISM": "the state of being a maenad [n -S]\n",
  "MAENADISMS": "MAENADISM, the state of being a maenad [n]\n",
  "MAENADS": "MAENAD, (Greek) a female follower of Bacchus, also MENAD [n]\n",
  "MAERL": "calcified red seaweed; a mass of this [n -S]\n",
  "MAERLS": "MAERL, calcified red seaweed; a mass of this [n]\n",
  "MAES": "MAE, (Scots) more [n]\n",
  "MAESTOSO": "(Italian) a stately musical passage [n -S]\n",
  "MAESTOSOS": "MAESTOSO, (Italian) a stately musical passage [n]\n",
  "MAESTRI": "MAESTRO, (Italian) a master of an art [n]\n",
  "MAESTRO": "(Italian) a master of an art [n MAESTROS or MAESTRI]\n",
  "MAESTROS": "MAESTRO, (Italian) a master of an art [n]\n",
  "MAFFIA": "(Italian) a secret criminal organization, also MAFIA [n -S]\n",
  "MAFFIAS": "MAFFIA, (Italian) a secret criminal organization, also MAFIA [n]\n",
  "MAFFICK": "to celebrate exuberantly [v -ED, -ING, -S]\n",
  "MAFFICKED": "MAFFICK, to celebrate exuberantly [v]\n",
  "MAFFICKER": "one who mafficks, celebrates with boisterous rejoicing [n -S]\n",
  "MAFFICKERS": "MAFFICKER, one who mafficks, celebrates with boisterous rejoicing [n]\n",
  "MAFFICKING": "boisterous rejoicing [n -S]\n",
  "MAFFICKINGS": "MAFFICKING, boisterous rejoicing [n]\n",
  "MAFFICKS": "MAFFICK, to celebrate exuberantly [v]\n",
  "MAFFLED": "(colloquial) mentally confused [adj]\n",
  "MAFFLIN": "a simpleton, also MAFFLING [n -S]\n",
  "MAFFLING": "a simpleton, also MAFFLIN [n -S]\n",
  "MAFFLINGS": "MAFFLING, a simpleton, also MAFFLIN [n]\n",
  "MAFFLINS": "MAFFLIN, a simpleton, also MAFFLING [n]\n",
  "MAFIA": "(Italian) a secret criminal organization, also MAFFIA [n -S]\n",
  "MAFIAS": "MAFIA, (Italian) a secret criminal organization, also MAFFIA [n]\n",
  "MAFIC": "a generally dark-colored igneous rock with significant amounts of one or more ferromagnesian minerals [n -S]\n",
  "MAFICS": "MAFIC, a generally dark-colored igneous rock with significant amounts of one or more ferromagnesian minerals [n]\n",
  "MAFIOSI": "MAFIOSO, (Italian) a member of the mafia [n]\n",
  "MAFIOSO": "(Italian) a member of the mafia [n MAFIOSOS or MAFIOSI]\n",
  "MAFIOSOS": "MAFIOSO, (Italian) a member of the mafia [n]\n",
  "MAFTED": "(dialect) suffering under intense heat [adj]\n",
  "MAFTIR": "(Hebrew) the concluding section of a parashah, a passage in Jewish literature [n -S]\n",
  "MAFTIRS": "MAFTIR, (Hebrew) the concluding section of a parashah, a passage in Jewish literature [n]\n",
  "MAG": "to tease; to steal, also MAGG [v MAGGED, MAGGING, MAGS]\n",
  "MAGAININ": "one of several chemicals derived from frog skin [n -S]\n",
  "MAGAININS": "MAGAININ, one of several chemicals derived from frog skin [n]\n",
  "MAGALOG": "(colloquial) a large mail-order catalog in the form of a magazine, also MAGALOGUE [n -S]\n",
  "MAGALOGS": "MAGALOG, (colloquial) a large mail-order catalog in the form of a magazine, also MAGALOGUE [n]\n",
  "MAGALOGUE": "a large mail-order catalog in the form of a magazine, also MAGALOG [n -S]\n",
  "MAGALOGUES": "MAGALOGUE, a large mail-order catalog in the form of a magazine, also MAGALOG [n]\n",
  "MAGAZINE": "a type of periodical publication [n -S]\n",
  "MAGAZINES": "MAGAZINE, a type of periodical publication [n]\n",
  "MAGAZINIST": "one who edits or writes for a magazine [n -S]\n",
  "MAGAZINISTS": "MAGAZINIST, one who edits or writes for a magazine [n]\n",
  "MAGDALEN": "a reformed prostitute, also MAGDALENE [n -S]\n",
  "MAGDALENE": "a reformed prostitute, also MAGDALEN [n -S]\n",
  "MAGDALENES": "MAGDALENE, a reformed prostitute, also MAGDALEN [n]\n",
  "MAGDALENS": "MAGDALEN, a reformed prostitute, also MAGDALENE [n]\n",
  "MAGE": "a magician; a person of exceptional wisdom and learning, also MAGUS [n -S]\n",
  "MAGENTA": "a purplish red dye [n -S]\n",
  "MAGENTAS": "MAGENTA, a purplish red dye [n]\n",
  "MAGES": "MAGE, a magician; a person of exceptional wisdom and learning, also MAGUS [n]\n",
  "MAGESHIP": "the office of a sorcerer [n -S]\n",
  "MAGESHIPS": "MAGESHIP, the office of a sorcerer [n]\n",
  "MAGG": "(Scott) to steal, also MAG [v -ED, -ING, -S]\n",
  "MAGGED": "MAGG, (Scott) to steal, also MAG [v]\n",
  "MAGGIE": "(dialect) a magpie [n -S]\n",
  "MAGGIES": "MAGGIE, (dialect) a magpie [n]\n",
  "MAGGING": "MAGG, (Scott) to steal, also MAG [v]\n",
  "MAGGOT": "any soft-bodied limbless larva, esp. of a housefly, blowfly, or other dipteran fly, typically found in decaying organic matter [n -S]\n",
  "MAGGOTIER": "MAGGOTY, full of maggots [adj]\n",
  "MAGGOTIEST": "MAGGOTY, full of maggots [adj]\n",
  "MAGGOTORIA": "MAGGOTORIUM, a place where maggots are bred for sale to fishers [n]\n",
  "MAGGOTORIUM": "a place where maggots are bred for sale to fishers [n MAGGOTORIA]\n",
  "MAGGOTS": "MAGGOT, any soft-bodied limbless larva, esp. of a housefly, blowfly, or other dipteran fly, typically found in decaying organic matter [n]\n",
  "MAGGOTY": "full of maggots [adj MAGGOTIER, MAGGOTIEST]\n",
  "MAGGS": "MAGG, (Scott) to steal, also MAG [v]\n",
  "MAGI": "MAGUS, (Latin) a magician, also MAGE, MAGIAN [n]\n",
  "MAGIAN": "a magician, also MAGUS [n -S]\n",
  "MAGIANISM": "the teachings or philosophy of the magi [n -S]\n",
  "MAGIANISMS": "MAGIANISM, the teachings or philosophy of the magi [n]\n",
  "MAGIANS": "MAGIAN, a magician, also MAGUS [n]\n",
  "MAGIC": "to work spells [v MAGICKED, MAGICKING, MAGICS]\n",
  "MAGICAL": "resembling magic [adj MAGICALLY]\n",
  "MAGICALLY": "MAGICAL, resembling magic [adv]\n",
  "MAGICIAN": "one who is skilled in magic [n -S]\n",
  "MAGICIANS": "MAGICIAN, one who is skilled in magic [n]\n",
  "MAGICKED": "MAGIC, to work spells [v]\n",
  "MAGICKING": "MAGIC, to work spells [v]\n",
  "MAGICS": "MAGIC, to work spells [v]\n",
  "MAGILP": "a substance with which pigments are mixed in painting, also MEGILP, MEGILPH [n -S]\n",
  "MAGILPS": "MAGILP, a substance with which pigments are mixed in painting, also MEGILP, MEGILPH [n]\n",
  "MAGISM": "the teaching of the magi [n -S]\n",
  "MAGISMS": "MAGISM, the teaching of the magi [n]\n",
  "MAGISTER": "(Latin) a person licensed to teach in a medieval university [n -S]\n",
  "MAGISTERIAL": "in the manner of a teacher or magistrate [adj MAGISTERIALLY]\n",
  "MAGISTERIALLY": "MAGISTERIAL, in the manner of a teacher or magistrate [adv]\n",
  "MAGISTERIALNESS": "the state of being magisterial [n]\n",
  "MAGISTERIES": "MAGISTERY, the quality, position, or function of a master [n]\n",
  "MAGISTERIUM": "(Latin) the teaching function of the Catholic church [n -S]\n",
  "MAGISTERIUMS": "MAGISTERIUM, (Latin) the teaching function of the Catholic church [n]\n",
  "MAGISTERS": "MAGISTER, (Latin) a person licensed to teach in a medieval university [n]\n",
  "MAGISTERY": "the quality, position, or function of a master [n MAGISTERIES]\n",
  "MAGISTRACIES": "MAGISTRACY, the office or dignity of a magistrate [n]\n",
  "MAGISTRACY": "the office or dignity of a magistrate [n MAGISTRACIES]\n",
  "MAGISTRAL": "masterly [adj MAGISTRALLY] / (obsolete) a preparation devised by a physician for a particular case; not included in the standard pharmacopoeia [n -S]\n",
  "MAGISTRALITIES": "MAGISTRALITY, the state of being magistral [n]\n",
  "MAGISTRALITY": "the state of being magistral [n MAGISTRALITIES]\n",
  "MAGISTRALLY": "MAGISTRAL, masterly [adv]\n",
  "MAGISTRALS": "MAGISTRAL, (obsolete) a preparation devised by a physician for a particular case; not included in the standard pharmacopoeia [n]\n",
  "MAGISTRAND": "a university student in fourth year [n -S]\n",
  "MAGISTRANDS": "MAGISTRAND, a university student in fourth year [n]\n",
  "MAGISTRATE": "an official entrusted with administration of the laws [n -S]\n",
  "MAGISTRATES": "MAGISTRATE, an official entrusted with administration of the laws [n]\n",
  "MAGISTRATESHIP": "the office of magistrate [n -S]\n",
  "MAGISTRATESHIPS": "MAGISTRATESHIP, the office of magistrate [n]\n",
  "MAGISTRATIC": "relating to a magistrate, also MAGISTRATICAL [adj MAGISTRATICALLY]\n",
  "MAGISTRATICAL": "relating to a magistrate, also MAGISTRATIC [adj MAGISTRATICALLY]\n",
  "MAGISTRATICALLY": "MAGISTRATICAL, relating to a magistrate, also MAGISTRATIC [adv]\n",
  "MAGISTRATURE": "the office or rank of a magistrate [n -S]\n",
  "MAGISTRATURES": "MAGISTRATURE, the office or rank of a magistrate [n]\n",
  "MAGLEV": "(short for) a magnetically levitating train [n -S]\n",
  "MAGLEVS": "MAGLEV, (short for) a magnetically levitating train [n]\n",
  "MAGMA": "the molten matter from which igneous rock is formed [n MAGMAS or MAGMATA]\n",
  "MAGMAS": "MAGMA, the molten matter from which igneous rock is formed [n]\n",
  "MAGMATA": "MAGMA, the molten matter from which igneous rock is formed [n]\n",
  "MAGMATIC": "of or like magma, molten or partially molten rock material [adj]\n",
  "MAGMATISM": "the production of magma [n -S]\n",
  "MAGMATISMS": "MAGMATISM, the production of magma [n]\n",
  "MAGNALIUM": "an alloy of magnesium and aluminum [n -S]\n",
  "MAGNALIUMS": "MAGNALIUM, an alloy of magnesium and aluminum [n]\n",
  "MAGNANIMITIES": "MAGNANIMITY, the quality of being magnanimous [n]\n",
  "MAGNANIMITY": "the quality of being magnanimous [n MAGNANIMITIES]\n",
  "MAGNANIMOUS": "showing or suggesting a lofty and courageous spirit [adj MAGNANIMOUSLY]\n",
  "MAGNANIMOUSLY": "MAGNANIMOUS, showing or suggesting a lofty and courageous spirit [adv]\n",
  "MAGNANIMOUSNESS": "MAGNANIMOUS, showing or suggesting a lofty and courageous spirit [n]\n",
  "MAGNATE": "a great or noble person; now esp. a wealthy and influential person, esp. in business [n -S]\n",
  "MAGNATES": "MAGNATE, a great or noble person; now esp. a wealthy and influential person, esp. in business [n]\n",
  "MAGNATESHIP": "the office of magnate [n -S]\n",
  "MAGNATESHIPS": "MAGNATESHIP, the office of magnate [n]\n",
  "MAGNES": "(archaic) a lodestone, also MAGNESSTONE [n -ES]\n",
  "MAGNESES": "MAGNES, (archaic) a lodestone, also MAGNESSTONE [n]\n",
  "MAGNESIA": "an ore of magnesium [n -S]\n",
  "MAGNESIAL": "relating to magnesia or magnesium, also MAGNESIAN, MAGNESIC [adj]\n",
  "MAGNESIAN": "relating to magnesia or magnesium, also MAGNESIAL, MAGNESIC [adj]\n",
  "MAGNESIAS": "MAGNESIA, an ore of magnesium [n]\n",
  "MAGNESIC": "relating to magnesia or magnesium, also MAGNESIAL, MAGNESIAN [adj]\n",
  "MAGNESITE": "native magnesium carbonate, occurring in white compact or granular masses [n -S]\n",
  "MAGNESITES": "MAGNESITE, native magnesium carbonate, occurring in white compact or granular masses [n]\n",
  "MAGNESIUM": "a bright silver-white metallic element [n -S]\n",
  "MAGNESIUMS": "MAGNESIUM, a bright silver-white metallic element [n]\n",
  "MAGNESSTONE": "(Spenser) a lodestone, also MAGNES [n -S]\n",
  "MAGNESSTONES": "MAGNESSTONE, (Spenser) a lodestone, also MAGNES [n]\n",
  "MAGNET": "a body that possesses the property of attracting iron [n -S]\n",
  "MAGNETAR": "a type of neutron star that has a very intense magnetic field [n -S]\n",
  "MAGNETARS": "MAGNETAR, a type of neutron star that has a very intense magnetic field [n]\n",
  "MAGNETIC": "relating to magnets, also MAGNETICAL [adj MAGNETICALLY]\n",
  "MAGNETICAL": "pertaining to the magnet, also MAGNETIC [adj MAGNETICALLY]\n",
  "MAGNETICALLY": "MAGNETICAL, pertaining to the magnet, also MAGNETIC [adv]\n",
  "MAGNETICIAN": "a scientist specialising in magnetism [n -S]\n",
  "MAGNETICIANS": "MAGNETICIAN, a scientist specialising in magnetism [n]\n",
  "MAGNETICS": "the study of magnetism [n]\n",
  "MAGNETISABLE": "able to be magnetised, also MAGNETIZABLE [adj]\n",
  "MAGNETISATION": "the process of magnetising, also MAGNETIZATION [n -S]\n",
  "MAGNETISATIONS": "MAGNETISATION, the process of magnetising, also MAGNETIZATION [n]\n",
  "MAGNETISE": "to make magnetic, also MAGNETIZE [v MAGNETISED, MAGNETISING, MAGNETISES]\n",
  "MAGNETISED": "MAGNETISE, to make magnetic, also MAGNETIZE [v]\n",
  "MAGNETISER": "something that magnetises, also MAGNETIZER [n -S]\n",
  "MAGNETISERS": "MAGNETISER, something that magnetises, also MAGNETIZER [n]\n",
  "MAGNETISES": "MAGNETISE, to make magnetic, also MAGNETIZE [v]\n",
  "MAGNETISING": "MAGNETISE, to make magnetic, also MAGNETIZE [v]\n",
  "MAGNETISM": "the state of being magnetic [n -S]\n",
  "MAGNETISMS": "MAGNETISM, the state of being magnetic [n]\n",
  "MAGNETIST": "an expert in magnetism [n -S]\n",
  "MAGNETISTS": "MAGNETIST, an expert in magnetism [n]\n",
  "MAGNETITE": "magnetic iron ore, called lodestone when polar [n -S]\n",
  "MAGNETITES": "MAGNETITE, magnetic iron ore, called lodestone when polar [n]\n",
  "MAGNETITIC": "of or like magnetite [adj]\n",
  "MAGNETIZABLE": "capable of being magnetized, also MAGNETISABLE [adj]\n",
  "MAGNETIZATION": "the process of magnetizing, also MAGNETISATION [n -S]\n",
  "MAGNETIZATIONS": "MAGNETIZATION, the process of magnetizing, also MAGNETISATION [n]\n",
  "MAGNETIZE": "to make magnetic, also MAGNETISE [v MAGNETIZED, MAGNETIZING, MAGNETIZES]\n",
  "MAGNETIZED": "MAGNETIZE, to make magnetic, also MAGNETISE [v]\n",
  "MAGNETIZER": "something that magnetizes, also MAGNETISER [n -S]\n",
  "MAGNETIZERS": "MAGNETIZER, something that magnetizes, also MAGNETISER [n]\n",
  "MAGNETIZES": "MAGNETIZE, to make magnetic, also MAGNETISE [v]\n",
  "MAGNETIZING": "MAGNETIZE, to make magnetic, also MAGNETISE [v]\n",
  "MAGNETO": "a small electric generator which uses permanent magnets; specifically one used for ignition in an internal-combustion engine [n -S]\n",
  "MAGNETOCHEMICAL": "relating to the branch of chemistry concerned with the relationship between magnetic and chemical properties [adj]\n",
  "MAGNETOELECTRIC": "relating to or characterized by electromotive forces developed by magnetic means [adj]\n",
  "MAGNETOGRAPH": "an instrument for recording measurements of magnetic fields [n -S]\n",
  "MAGNETOGRAPHS": "MAGNETOGRAPH, an instrument for recording measurements of magnetic fields [n]\n",
  "MAGNETOMETER": "an instrument for measuring the intensity of magnetic fields [n -S]\n",
  "MAGNETOMETERS": "MAGNETOMETER, an instrument for measuring the intensity of magnetic fields [n]\n",
  "MAGNETOMETRIC": "relating to magnetometry [adj]\n",
  "MAGNETOMETRIES": "MAGNETOMETRY, measurement by magnetometer [n]\n",
  "MAGNETOMETRY": "measurement by magnetometer [n MAGNETOMETRIES]\n",
  "MAGNETOMOTIVE": "producing a magnetic flux [adj]\n",
  "MAGNETON": "a unit of magnetic moment [n -S]\n",
  "MAGNETONS": "MAGNETON, a unit of magnetic moment [n]\n",
  "MAGNETOPAUSE": "the outer boundary of a magnetosphere [n -S]\n",
  "MAGNETOPAUSES": "MAGNETOPAUSE, the outer boundary of a magnetosphere [n]\n",
  "MAGNETOS": "MAGNETO, a small electric generator which uses permanent magnets; specifically one used for ignition in an internal-combustion engine [n]\n",
  "MAGNETOSPHERE": "a region of space surrounding a celestial object that is dominated by the object's magnetic field such that charged particles are trapped in it [n -S]\n",
  "MAGNETOSPHERES": "MAGNETOSPHERE, a region of space surrounding a celestial object that is dominated by the object's magnetic field such that charged particles are trapped in it [n]\n",
  "MAGNETOSPHERIC": "relating to the magnetosphere [adj]\n",
  "MAGNETOSTATIC": "of, relating to, or being a stationary magnetic field [adj]\n",
  "MAGNETOSTATICS": "the study of steady-state magnetic fields [n]\n",
  "MAGNETRON": "a vacuum tube combined with a magnetic field to deflect electrons [n -S]\n",
  "MAGNETRONS": "MAGNETRON, a vacuum tube combined with a magnetic field to deflect electrons [n]\n",
  "MAGNETS": "MAGNET, a body that possesses the property of attracting iron [n]\n",
  "MAGNIFIABLE": "that can be magnified [adj]\n",
  "MAGNIFIC": "(archaic) magnificent, also MAGNIFICAL [adj MAGNIFICALLY]\n",
  "MAGNIFICAL": "(archaic) magnificent, also MAGNIFIC [adj MAGNIFICALLY]\n",
  "MAGNIFICALLY": "MAGNIFICAL, (archaic) magnificent, also MAGNIFIC [adv]\n",
  "MAGNIFICAT": "a canticle in praise of the Virgin Mary [n -S]\n",
  "MAGNIFICATION": "the act of magnifying [n -S]\n",
  "MAGNIFICATIONS": "MAGNIFICATION, the act of magnifying [n]\n",
  "MAGNIFICATS": "MAGNIFICAT, a canticle in praise of the Virgin Mary [n]\n",
  "MAGNIFICENCE": "the state of being magnificent [n -S]\n",
  "MAGNIFICENCES": "MAGNIFICENCE, the state of being magnificent [n]\n",
  "MAGNIFICENT": "splendid [adj MAGNIFICENTLY]\n",
  "MAGNIFICENTLY": "MAGNIFICENT, splendid [adv]\n",
  "MAGNIFICENTNESS": "MAGNIFICENT, splendid [n]\n",
  "MAGNIFICO": "(Italian) a person of high rank or position, originally the chief magistrate at Venice [n -ES or -S]\n",
  "MAGNIFICOES": "MAGNIFICO, (Italian) a person of high rank or position, originally the chief magistrate at Venice [n]\n",
  "MAGNIFICOS": "MAGNIFICO, (Italian) a person of high rank or position, originally the chief magistrate at Venice [n]\n",
  "MAGNIFIED": "MAGNIFY, to increase the perceived size of [v]\n",
  "MAGNIFIER": "something that magnifies [n -S]\n",
  "MAGNIFIERS": "MAGNIFIER, something that magnifies [n]\n",
  "MAGNIFIES": "MAGNIFY, to increase the perceived size of [v]\n",
  "MAGNIFY": "to increase the perceived size of [v MAGNIFIED, MAGNIFYING, MAGNIFIES]\n",
  "MAGNIFYING": "MAGNIFY, to increase the perceived size of [v]\n",
  "MAGNILOQUENCE": "grandly high-flown, lofty speech [n -S]\n",
  "MAGNILOQUENCES": "MAGNILOQUENCE, grandly high-flown, lofty speech [n]\n",
  "MAGNILOQUENT": "speaking in a grand or pompous style [adj MAGNILOQUENTLY]\n",
  "MAGNILOQUENTLY": "MAGNILOQUENT, speaking in a grand or pompous style [adv]\n",
  "MAGNITUDE": "size, extent [n -S]\n",
  "MAGNITUDES": "MAGNITUDE, size, extent [n]\n",
  "MAGNITUDINOUS": "having magnitude [adj]\n",
  "MAGNOLIA": "any tree or shrub of the magnoliaceous genus Magnolia of Asia and North America [n -S]\n",
  "MAGNOLIACEOUS": "belonging to the magnolia family [adj]\n",
  "MAGNOLIAS": "MAGNOLIA, any tree or shrub of the magnoliaceous genus Magnolia of Asia and North America [n]\n",
  "MAGNON": "a quantum of spin wave energy [n -S]\n",
  "MAGNONS": "MAGNON, a quantum of spin wave energy [n]\n",
  "MAGNOX": "(tradename) an alloy of magnesium and aluminum used to make containers for fuel for nuclear reactors [n -ES]\n",
  "MAGNOXES": "MAGNOX, (tradename) an alloy of magnesium and aluminum used to make containers for fuel for nuclear reactors [n]\n",
  "MAGNUM": "(Latin) a bottle for wine, spirits etc., twice the standard size, now usually containing one and a half litres [n -S]\n",
  "MAGNUMS": "MAGNUM, (Latin) a bottle for wine, spirits etc., twice the standard size, now usually containing one and a half litres [n]\n",
  "MAGNUS": "as in magnus hitch, a knot similar to a clove hitch [adj]\n",
  "MAGOT": "(French) the Barbary ape; a small grotesque figure in Chinese art [n -S]\n",
  "MAGOTS": "MAGOT, (French) the Barbary ape; a small grotesque figure in Chinese art [n]\n",
  "MAGPIE": "a black and white corvine bird [n -S]\n",
  "MAGPIES": "MAGPIE, a black and white corvine bird [n]\n",
  "MAGS": "MAG, to tease; to steal, also MAGG [v]\n",
  "MAGSMAN": "(Australian slang) a street swindler [n MAGSMEN]\n",
  "MAGSMEN": "MAGSMAN, (Australian slang) a street swindler [n]\n",
  "MAGUEY": "(Spanish) the century plant, a species of agave [n -S]\n",
  "MAGUEYS": "MAGUEY, (Spanish) the century plant, a species of agave [n]\n",
  "MAGUS": "(Latin) a magician, also MAGE, MAGIAN [n MAGI]\n",
  "MAGYAR": "(Hungarian) pertaining to a garment without individual sleeves [adj]\n",
  "MAHA": "as in maha yoga, a form of yoga practised with a master that incorporates all eight classical yogas [adj]\n",
  "MAHANT": "(Hindi) a chief Hindu priest [n -S]\n",
  "MAHANTS": "MAHANT, (Hindi) a chief Hindu priest [n]\n",
  "MAHARAJA": "(Sanskrit) a king or prince in India ranking above a rajah, esp. the sovereign of one of the former native states, also MAHARAJAH [n -S]\n",
  "MAHARAJAH": "(Sanskrit) a king or prince in India ranking above a rajah, esp. the sovereign of one of the former native states, also MAHARAJA [n -S]\n",
  "MAHARAJAHS": "MAHARAJAH, (Sanskrit) a king or prince in India ranking above a rajah, esp. the sovereign of one of the former native states, also MAHARAJA [n]\n",
  "MAHARAJAS": "MAHARAJA, (Sanskrit) a king or prince in India ranking above a rajah, esp. the sovereign of one of the former native states, also MAHARAJAH [n]\n",
  "MAHARANEE": "(Sanskrit) the wife of a maharajah, also MAHARANI [n -S]\n",
  "MAHARANEES": "MAHARANEE, (Sanskrit) the wife of a maharajah, also MAHARANI [n]\n",
  "MAHARANI": "(Sanskrit) the wife of a maharajah, also MAHARANEE [n -S]\n",
  "MAHARANIS": "MAHARANI, (Sanskrit) the wife of a maharajah, also MAHARANEE [n]\n",
  "MAHARISHI": "(Sanskrit) a Hindu teacher of mysticism and spiritual knowledge [n -S]\n",
  "MAHARISHIS": "MAHARISHI, (Sanskrit) a Hindu teacher of mysticism and spiritual knowledge [n]\n",
  "MAHATMA": "(Sanskrit) a religious adept, a sage [n -S]\n",
  "MAHATMAISM": "the state of being a mahatma [n -S]\n",
  "MAHATMAISMS": "MAHATMAISM, the state of being a mahatma [n]\n",
  "MAHATMAS": "MAHATMA, (Sanskrit) a religious adept, a sage [n]\n",
  "MAHEWU": "in South Africa, fermented liquid mealie-meal porridge, used as a stimulant [n -S]\n",
  "MAHEWUS": "MAHEWU, in South Africa, fermented liquid mealie-meal porridge, used as a stimulant [n]\n",
  "MAHIMAHI": "(Hawaiian) the dolphinfish, especially its flesh prepared as food [n -S]\n",
  "MAHIMAHIS": "MAHIMAHI, (Hawaiian) the dolphinfish, especially its flesh prepared as food [n]\n",
  "MAHJONG": "(Chinese) a game of Chinese origin, also MAHJONGG [n -S]\n",
  "MAHJONGG": "(Chinese) a game of Chinese origin, also MAHJONG [n -S]\n",
  "MAHJONGGS": "MAHJONGG, (Chinese) a game of Chinese origin, also MAHJONG [n]\n",
  "MAHJONGS": "MAHJONG, (Chinese) a game of Chinese origin, also MAHJONGG [n]\n",
  "MAHLSTICK": "(Dutch) a stick used by painters to steady the hand, also MALSTICK, MAULSTICK [n -S]\n",
  "MAHLSTICKS": "MAHLSTICK, (Dutch) a stick used by painters to steady the hand, also MALSTICK, MAULSTICK [n]\n",
  "MAHMAL": "(Arabic) the empty litter sent to Mecca in the hadj [n -S]\n",
  "MAHMALS": "MAHMAL, (Arabic) the empty litter sent to Mecca in the hadj [n]\n",
  "MAHOE": "(Maori) a small, bushy white-barked tree of New Zealand [n -S]\n",
  "MAHOES": "MAHOE, (Maori) a small, bushy white-barked tree of New Zealand [n]\n",
  "MAHOGANIES": "MAHOGANY, any of various tropical American trees, valued for their hard reddish-brown wood [n]\n",
  "MAHOGANY": "any of various tropical American trees, valued for their hard reddish-brown wood [n MAHOGANIES]\n",
  "MAHONIA": "a shrub of the barberry family, with yellow flowers and prickly pinnate leaves [n -S]\n",
  "MAHONIAS": "MAHONIA, a shrub of the barberry family, with yellow flowers and prickly pinnate leaves [n]\n",
  "MAHOUT": "(Hindi) the keeper and driver of an elephant [n -S]\n",
  "MAHOUTS": "MAHOUT, (Hindi) the keeper and driver of an elephant [n]\n",
  "MAHSEER": "(Hindi) a large freshwater fish, also MAHSIR [n -S]\n",
  "MAHSEERS": "MAHSEER, (Hindi) a large freshwater fish, also MAHSIR [n]\n",
  "MAHSIR": "(Hindi) a large freshwater fish, also MAHSEER [n -S]\n",
  "MAHSIRS": "MAHSIR, (Hindi) a large freshwater fish, also MAHSEER [n]\n",
  "MAHUA": "(Hindi) a kind of butter-tree with edible flowers, also MAHWA, MOWA, MOWRA [n -S]\n",
  "MAHUANG": "(Chinese) an Asian plant of the Ephedra genus [n -S]\n",
  "MAHUANGS": "MAHUANG, (Chinese) an Asian plant of the Ephedra genus [n]\n",
  "MAHUAS": "MAHUA, (Hindi) a kind of butter-tree with edible flowers, also MAHWA, MOWA, MOWRA [n]\n",
  "MAHWA": "(Hindi) a kind of butter-tree with edible flowers, also MAHUA, MOWA, MOWRA [n -S]\n",
  "MAHWAS": "MAHWA, (Hindi) a kind of butter-tree with edible flowers, also MAHUA, MOWA, MOWRA [n]\n",
  "MAHZOR": "(Hebrew) a Jewish prayer book, also MACHZOR [n MAHZORS or MAHZORIM]\n",
  "MAHZORIM": "MAHZOR, (Hebrew) a Jewish prayer book, also MACHZOR [n]\n",
  "MAHZORS": "MAHZOR, (Hebrew) a Jewish prayer book, also MACHZOR [n]\n",
  "MAIASAUR": "a species of herbivorous dinosaur, also MAIASAURA [n -S]\n",
  "MAIASAURA": "a species of dinosaur, also MAIASAUR [n -S]\n",
  "MAIASAURAS": "MAIASAURA, a species of dinosaur, also MAIASAUR [n]\n",
  "MAIASAURS": "MAIASAUR, a species of herbivorous dinosaur, also MAIASAURA [n]\n",
  "MAID": "to work as a maidservant [v -ED, -ING, -S]\n",
  "MAIDAN": "(Urdu) in India, an open plain; an open space near a town [n -S]\n",
  "MAIDANS": "MAIDAN, (Urdu) in India, an open plain; an open space near a town [n]\n",
  "MAIDED": "MAID, to work as a maidservant [v]\n",
  "MAIDEN": "unmarried, virgin [adj MAIDENLY] / a young unmarried girl, esp. when still a virgin [n -S]\n",
  "MAIDENHAIR": "a fern of the genus Adiantum, having very slender graceful stalks [n -S]\n",
  "MAIDENHAIRS": "MAIDENHAIR, a fern of the genus Adiantum, having very slender graceful stalks [n]\n",
  "MAIDENHEAD": "virginity; hymen [n -S]\n",
  "MAIDENHEADS": "MAIDENHEAD, virginity; hymen [n]\n",
  "MAIDENHOOD": "the state of being a maiden, also MAIDHOOD [n -S]\n",
  "MAIDENHOODS": "MAIDENHOOD, the state of being a maiden, also MAIDHOOD [n]\n",
  "MAIDENISH": "like a maiden [adj]\n",
  "MAIDENLIER": "MAIDENLY, like a maiden [adj]\n",
  "MAIDENLIEST": "MAIDENLY, like a maiden [adj]\n",
  "MAIDENLIKE": "like a maiden; modest; coy [adj]\n",
  "MAIDENLINESS": "the state of being maidenly [n -ES]\n",
  "MAIDENLINESSES": "MAIDENLINESS, the state of being maidenly [n]\n",
  "MAIDENLY": "like a maiden [adj MAIDENLIER, MAIDENLIEST]\n",
  "MAIDENS": "MAIDEN, a young unmarried girl, esp. when still a virgin [n]\n",
  "MAIDENWEED": "another name for mayweed [n -S]\n",
  "MAIDENWEEDS": "MAIDENWEED, another name for mayweed [n]\n",
  "MAIDHOOD": "the state of being a maid, also MAIDENHOOD [n -S]\n",
  "MAIDHOODS": "MAIDHOOD, the state of being a maid, also MAIDENHOOD [n]\n",
  "MAIDING": "MAID, to work as a maidservant [v]\n",
  "MAIDISH": "like a maiden [adj]\n",
  "MAIDISHNESS": "the state of being maidish [n -ES]\n",
  "MAIDISHNESSES": "MAIDISHNESS, the state of being maidish [n]\n",
  "MAIDISM": "a chronic disease due to a vitamin deficiency [n -S]\n",
  "MAIDISMS": "MAIDISM, a chronic disease due to a vitamin deficiency [n]\n",
  "MAIDLESS": "without a maid [adj]\n",
  "MAIDS": "MAID, to work as a maidservant [v]\n",
  "MAIDSERVANT": "a female servant [n -S]\n",
  "MAIDSERVANTS": "MAIDSERVANT, a female servant [n]\n",
  "MAIEUTIC": "(Greek) of or relating to the Socratic method of eliciting knowledge by a series of questions and answers, also MAIEUTICAL [adj]\n",
  "MAIEUTICAL": "of or relating to the Socratic method of eliciting knowledge by a series of questions and answers, also MAIEUTIC [adj]\n",
  "MAIEUTICS": "the Socratic mode of enquiry, serving to bring out a person's latent ideas into clear consciousness [n]\n",
  "MAIGRE": "(French) a large Mediterranean food fish [n -S]\n",
  "MAIGRES": "MAIGRE, (French) a large Mediterranean food fish [n]\n",
  "MAIHEM": "maiming, malicious damage, also MAYHEM [n -S]\n",
  "MAIHEMS": "MAIHEM, maiming, malicious damage, also MAYHEM [n]\n",
  "MAIK": "(Scots) a mate or consort; a halfpenny, also MECK, MEG [n -S]\n",
  "MAIKO": "(Japanese) an apprentice geisha [n -S]\n",
  "MAIKOS": "MAIKO, (Japanese) an apprentice geisha [n]\n",
  "MAIKS": "MAIK, (Scots) a mate or consort; a halfpenny, also MECK, MEG [n]\n",
  "MAIL": "to send by the government postal system [v -ED, -ING, -S]\n",
  "MAILABILITIES": "MAILABILITY, the ability to be sent by mail [n]\n",
  "MAILABILITY": "the ability to be sent by mail [n MAILABILITIES]\n",
  "MAILABLE": "able to be mailed [adj]\n",
  "MAILBAG": "a bag containing posted articles [n -S]\n",
  "MAILBAGS": "MAILBAG, a bag containing posted articles [n]\n",
  "MAILBOAT": "a boat that carries mail [n -S]\n",
  "MAILBOATS": "MAILBOAT, a boat that carries mail [n]\n",
  "MAILBOX": "a box for posting mail [n -ES]\n",
  "MAILBOXES": "MAILBOX, a box for posting mail [n]\n",
  "MAILCAR": "a railway coach specially constructed for the transport of mail, also MAILCOACH [n -S]\n",
  "MAILCARS": "MAILCAR, a railway coach specially constructed for the transport of mail, also MAILCOACH [n]\n",
  "MAILCOACH": "a railway coach specially constructed for the transport of mail, also MAILCAR [n -ES]\n",
  "MAILCOACHES": "MAILCOACH, a railway coach specially constructed for the transport of mail, also MAILCAR [n]\n",
  "MAILE": "(Hawaiian) a kind of flowering vine [n -S]\n",
  "MAILED": "MAIL, to send by the government postal system [v]\n",
  "MAILER": "one who sends mail [n -S]\n",
  "MAILERS": "MAILER, one who sends mail [n]\n",
  "MAILES": "MAILE, (Hawaiian) a kind of flowering vine [n]\n",
  "MAILGRAM": "(tradename) to send a letter electronically [v MAILGRAMMED, MAILGRAMMING, MAILGRAMS]\n",
  "MAILGRAMMED": "MAILGRAM, (tradename) to send a letter electronically [v]\n",
  "MAILGRAMMING": "MAILGRAM, (tradename) to send a letter electronically [v]\n",
  "MAILGRAMS": "MAILGRAM, (tradename) to send a letter electronically [v]\n",
  "MAILING": "a batch of items sent by post [n -S]\n",
  "MAILINGS": "MAILING, a batch of items sent by post [n]\n",
  "MAILL": "a payment [n -S]\n",
  "MAILLESS": "without armour [adj]\n",
  "MAILLOT": "(French) tights worn by a ballet dancer [n -S]\n",
  "MAILLOTS": "MAILLOT, (French) tights worn by a ballet dancer [n]\n",
  "MAILLS": "MAILL, a payment [n]\n",
  "MAILMAN": "a man who carries and delivers mail [n MAILMEN]\n",
  "MAILMEN": "MAILMAN, a man who carries and delivers mail [n]\n",
  "MAILMERGE": "a merge of a file of names and addresses with the text of a letter, or a computer program that carries this out [n -S] / to carry out a mailmerge [v MAILMERGED, MAILMERGING, MAILMERGES]\n",
  "MAILMERGED": "MAILMERGE, to carry out a mailmerge [v]\n",
  "MAILMERGES": "MAILMERGE, a merge of a file of names and addresses with the text of a letter, or a computer program that carries this out [n]\n",
  "MAILMERGING": "MAILMERGE, to carry out a mailmerge [v]\n",
  "MAILPOUCH": "a mailbag [n -ES]\n",
  "MAILPOUCHES": "MAILPOUCH, a mailbag [n]\n",
  "MAILROOM": "a room in an office that deals with mail [n -S]\n",
  "MAILROOMS": "MAILROOM, a room in an office that deals with mail [n]\n",
  "MAILS": "MAIL, to send by the government postal system [v]\n",
  "MAILSACK": "a sack in which mail is carried [n -S]\n",
  "MAILSACKS": "MAILSACK, a sack in which mail is carried [n]\n",
  "MAILSHOT": "to send unsolicited items by post [v MAILSHOTTED, MAILSHOTTING, MAILSHOTS]\n",
  "MAILSHOTS": "MAILSHOT [n]\n",
  "MAILSHOTTED": "MAILSHOT, to send unsolicited items by post [v]\n",
  "MAILSHOTTING": "MAILSHOT, to send unsolicited items by post [v]\n",
  "MAILVAN": "any vehicle which carries public mail [n -S]\n",
  "MAILVANS": "MAILVAN, any vehicle which carries public mail [n]\n",
  "MAIM": "to injure or mutilate [v -ED, -ING, -S]\n",
  "MAIMED": "MAIM, to injure or mutilate [v]\n",
  "MAIMEDNESS": "the state of being maimed [n -ES]\n",
  "MAIMEDNESSES": "MAIMEDNESS, the state of being maimed [n]\n",
  "MAIMER": "one who maims [n -S]\n",
  "MAIMERS": "MAIMER, one who maims [n]\n",
  "MAIMING": "the act of disabling [n -S]\n",
  "MAIMINGS": "MAIMING, the act of disabling [n]\n",
  "MAIMS": "MAIM, to injure or mutilate [v]\n",
  "MAIN": "chief, principal [adj MAINER, MAINEST, MAINLY] / to maim or cripple [v -ED, -ING, -S]\n",
  "MAINBOOM": "the spar that extends the foot of a fore-and-aft mainsail [n -S]\n",
  "MAINBOOMS": "MAINBOOM, the spar that extends the foot of a fore-and-aft mainsail [n]\n",
  "MAINBRACE": "the brace attached to the mainyard [n -S]\n",
  "MAINBRACES": "MAINBRACE, the brace attached to the mainyard [n]\n",
  "MAINDOOR": "the principal door of an establishment [n -S]\n",
  "MAINDOORS": "MAINDOOR, the principal door of an establishment [n]\n",
  "MAINED": "MAIN, to maim or cripple [v]\n",
  "MAINER": "MAIN, chief, principal [adj]\n",
  "MAINEST": "MAIN, chief, principal [adj]\n",
  "MAINFRAME": "a large computer serving others [n -S]\n",
  "MAINFRAMES": "MAINFRAME, a large computer serving others [n]\n",
  "MAINING": "MAIN, to maim or cripple [v]\n",
  "MAINLAND": "a principal land mass [n -S]\n",
  "MAINLANDER": "one who lives on the mainland [n -S]\n",
  "MAINLANDERS": "MAINLANDER, one who lives on the mainland [n]\n",
  "MAINLANDS": "MAINLAND, a principal land mass [n]\n",
  "MAINLINE": "to inject a narcotic into a major vein [v MAINLINED, MAINLINING, MAINLINES]\n",
  "MAINLINED": "MAINLINE, to inject a narcotic into a major vein [v]\n",
  "MAINLINER": "one who takes a narcotic intravenously [n -S]\n",
  "MAINLINERS": "MAINLINER, one who takes a narcotic intravenously [n]\n",
  "MAINLINES": "MAINLINE, to inject a narcotic into a major vein [v]\n",
  "MAINLINING": "the act of injecting drugs intravenously [n -S]\n",
  "MAINLININGS": "MAINLINING, the act of injecting drugs intravenously [n]\n",
  "MAINLY": "MAIN, chief, principal [adv]\n",
  "MAINMAST": "the principal mast of a vessel [n -S]\n",
  "MAINMASTS": "MAINMAST, the principal mast of a vessel [n]\n",
  "MAINOR": "act or fact of theft, also MAINOUR [n -S]\n",
  "MAINORS": "MAINOR, act or fact of theft, also MAINOUR [n]\n",
  "MAINOUR": "(archaic) an act or fact of theft; that which is stolen, also MAINOR [n -S]\n",
  "MAINOURS": "MAINOUR, (archaic) an act or fact of theft; that which is stolen, also MAINOR [n]\n",
  "MAINPERNOR": "one who gives mainprise, surety for the appearance of a prisoner at trial [n -S]\n",
  "MAINPERNORS": "MAINPERNOR, one who gives mainprise, surety for the appearance of a prisoner at trial [n]\n",
  "MAINPRISE": "(historical) to allow a prisoner to go free based on a guarantee that he or she will appear in court on the designated day [v MAINPRISED, MAINPRISING, MAINPRISES]\n",
  "MAINPRISED": "MAINPRISE, (historical) to allow a prisoner to go free based on a guarantee that he or she will appear in court on the designated day [v]\n",
  "MAINPRISES": "MAINPRISE, (historical) to allow a prisoner to go free based on a guarantee that he or she will appear in court on the designated day [v]\n",
  "MAINPRISING": "MAINPRISE, (historical) to allow a prisoner to go free based on a guarantee that he or she will appear in court on the designated day [v]\n",
  "MAINS": "MAIN, to maim or cripple [v]\n",
  "MAINSAIL": "the principal sail of a vessel [n -S]\n",
  "MAINSAILS": "MAINSAIL, the principal sail of a vessel [n]\n",
  "MAINSHEET": "a rope by which a mainsail is trimmed and secured [n -S]\n",
  "MAINSHEETS": "MAINSHEET, a rope by which a mainsail is trimmed and secured [n]\n",
  "MAINSPRING": "the chief spring in a mechanism esp. of a watch or clock [n -S]\n",
  "MAINSPRINGS": "MAINSPRING, the chief spring in a mechanism esp. of a watch or clock [n]\n",
  "MAINSTAGE": "the stage of the principal theatre operated by a theatrical company, usually the one on which major works are performed [n -S]\n",
  "MAINSTAGES": "MAINSTAGE, the stage of the principal theatre operated by a theatrical company, usually the one on which major works are performed [n]\n",
  "MAINSTAY": "the principal support [n -S]\n",
  "MAINSTAYS": "MAINSTAY, the principal support [n]\n",
  "MAINSTREAM": "to place (as a disabled child) in regular school classes [v -ED, -ING, -S]\n",
  "MAINSTREAMED": "MAINSTREAM, to place (as a disabled child) in regular school classes [v]\n",
  "MAINSTREAMING": "the integration of children with disabilities into classes of able-bodied children [n -S]\n",
  "MAINSTREAMINGS": "MAINSTREAMING, the integration of children with disabilities into classes of able-bodied children [n]\n",
  "MAINSTREAMS": "MAINSTREAM, to place (as a disabled child) in regular school classes [v]\n",
  "MAINSTREETING": "electioneering in the main streets of a town [n -S]\n",
  "MAINSTREETINGS": "MAINSTREETING, electioneering in the main streets of a town [n]\n",
  "MAINTAIN": "to keep in proper condition [v -ED, -ING, -S]\n",
  "MAINTAINABILITY": "the state of being maintainable [n]\n",
  "MAINTAINABLE": "capable of being maintained [adj]\n",
  "MAINTAINED": "MAINTAIN, to keep in proper condition [v]\n",
  "MAINTAINER": "one who maintains [n -S]\n",
  "MAINTAINERS": "MAINTAINER, one who maintains [n]\n",
  "MAINTAINING": "MAINTAIN, to keep in proper condition [v]\n",
  "MAINTAINS": "MAINTAIN, to keep in proper condition [v]\n",
  "MAINTENANCE": "the act of maintaining [n -S] / to keep in working order [v MAINTENANCED, MAINTENANCING, MAINTENANCES]\n",
  "MAINTENANCED": "MAINTENANCE, to keep in working order [v]\n",
  "MAINTENANCES": "MAINTENANCE, the act of maintaining [n]\n",
  "MAINTENANCING": "MAINTENANCE, to keep in working order [v]\n",
  "MAINTOP": "a platform at the head of a mainmast [n -S]\n",
  "MAINTOPMAST": "the mast next above the lower mainmast [n -S]\n",
  "MAINTOPMASTS": "MAINTOPMAST, the mast next above the lower mainmast [n]\n",
  "MAINTOPS": "MAINTOP, a platform at the head of a mainmast [n]\n",
  "MAINTOPSAIL": "the sail above the mainsail [n -S]\n",
  "MAINTOPSAILS": "MAINTOPSAIL, the sail above the mainsail [n]\n",
  "MAINYARD": "the lower yard on the mainmast [n -S]\n",
  "MAINYARDS": "MAINYARD, the lower yard on the mainmast [n]\n",
  "MAIOLICA": "(Italian) an elaborate, highly-colored, glazed Italian pottery, also MAJOLICA [n -S]\n",
  "MAIOLICAS": "MAIOLICA, (Italian) an elaborate, highly-colored, glazed Italian pottery, also MAJOLICA [n]\n",
  "MAIR": "(Scots) more [n -S]\n",
  "MAIRE": "(French) a mayor [n -S]\n",
  "MAIREHAU": "(Maori) a small aromatic shrub of New Zealand [n -S]\n",
  "MAIREHAUS": "MAIREHAU, (Maori) a small aromatic shrub of New Zealand [n]\n",
  "MAIRES": "MAIRE, (French) a mayor [n]\n",
  "MAIRS": "MAIR, (Scots) more [n]\n",
  "MAISE": "a measure of five hundreds of herring, also MEASE [n -S]\n",
  "MAISES": "MAISE, a measure of five hundreds of herring, also MEASE [n]\n",
  "MAISONETTE": "(French) a part of a residential building which is occupied separately, usually on more than one floor, also MAISONNETTE [n -S]\n",
  "MAISONETTES": "MAISONETTE, (French) a part of a residential building which is occupied separately, usually on more than one floor, also MAISONNETTE [n]\n",
  "MAISONNETTE": "(French) a part of a residential building which is occupied separately, usually on more than one floor, also MAISONETTE [n -S]\n",
  "MAISONNETTES": "MAISONNETTE, (French) a part of a residential building which is occupied separately, usually on more than one floor, also MAISONETTE [n]\n",
  "MAIST": "(Scots) the most part [n -S]\n",
  "MAISTER": "(Scots) to master, to gain control over [v -ED, -ING, -S]\n",
  "MAISTERDOME": "(obsolete) mastery [n -S]\n",
  "MAISTERDOMES": "MAISTERDOME, (obsolete) mastery [n]\n",
  "MAISTERED": "MAISTER, (Scots) to master, to gain control over [v]\n",
  "MAISTERING": "MAISTER, (Scots) to master, to gain control over [v]\n",
  "MAISTERS": "MAISTER, (Scots) to master, to gain control over [v]\n",
  "MAISTRIES": "MAISTRY, (obsolete) mastery, the power of a maister [n]\n",
  "MAISTRING": "(obsolete) mastering, also MASTERING [n -S]\n",
  "MAISTRINGS": "MAISTRING, (obsolete) mastering, also MASTERING [n]\n",
  "MAISTRY": "(obsolete) mastery, the power of a maister [n MAISTRIES]\n",
  "MAISTS": "MAIST, (Scots) the most part [n]\n",
  "MAIZE": "an American cereal grass [n -S]\n",
  "MAIZES": "MAIZE, an American cereal grass [n]\n",
  "MAJAGUA": "a forest tree of Cuba and Jamaica having variably hairy leaves and orange-yellow or orange-red flower [n -S]\n",
  "MAJAGUAS": "MAJAGUA, a forest tree of Cuba and Jamaica having variably hairy leaves and orange-yellow or orange-red flower [n]\n",
  "MAJESTIC": "having majesty, also MAJESTICAL [adj MAJESTICALLY]\n",
  "MAJESTICAL": "having majesty, also MAJESTIC [adj MAJESTICALLY]\n",
  "MAJESTICALLY": "MAJESTICAL, having majesty, also MAJESTIC [adv]\n",
  "MAJESTICALNESS": "MAJESTICAL, having majesty, also MAJESTIC [n]\n",
  "MAJESTICNESS": "(obsolete) the state of being majestic [n -ES]\n",
  "MAJESTICNESSES": "MAJESTICNESS, (obsolete) the state of being majestic [n]\n",
  "MAJESTIES": "MAJESTY, regal dignity [n]\n",
  "MAJESTY": "regal dignity [n MAJESTIES]\n",
  "MAJLIS": "(Arabic) an assembly or council in various North African and Middle Eastern countries, also MEJLIS [n -ES]\n",
  "MAJLISES": "MAJLIS, (Arabic) an assembly or council in various North African and Middle Eastern countries, also MEJLIS [n]\n",
  "MAJOLICA": "(Italian) an elaborate, highly-colored, glazed Italian pottery, also MAIOLICA [n -S]\n",
  "MAJOLICAS": "MAJOLICA, (Italian) an elaborate, highly-colored, glazed Italian pottery, also MAIOLICA [n]\n",
  "MAJOLICAWARE": "goods made from majolica [n -S]\n",
  "MAJOLICAWARES": "MAJOLICAWARE, goods made from majolica [n]\n",
  "MAJOR": "greater [adj MAJORLY] / to pursue a specific principal course of study [v -ED, -ING, -S]\n",
  "MAJORAT": "(French) primogeniture, the circumstance of being firstborn [n -S]\n",
  "MAJORATS": "MAJORAT, (French) primogeniture, the circumstance of being firstborn [n]\n",
  "MAJORDOMO": "an official who has the general management in a large household [n -S]\n",
  "MAJORDOMOS": "MAJORDOMO, an official who has the general management in a large household [n]\n",
  "MAJORED": "MAJOR, to pursue a specific principal course of study [v]\n",
  "MAJORETTE": "a member of a group of girls who march in parades etc. [n -S]\n",
  "MAJORETTES": "MAJORETTE, a member of a group of girls who march in parades etc. [n]\n",
  "MAJORETTING": "the practice of performing as majorettes [n -S]\n",
  "MAJORETTINGS": "MAJORETTING, the practice of performing as majorettes [n]\n",
  "MAJORING": "MAJOR, to pursue a specific principal course of study [v]\n",
  "MAJORITAIRE": "(French) a member of a majority section of a political party, esp. a socialist one [n -S]\n",
  "MAJORITAIRES": "MAJORITAIRE, (French) a member of a majority section of a political party, esp. a socialist one [n]\n",
  "MAJORITARIAN": "a person who believes in or advocates majoritarianism [n -S]\n",
  "MAJORITARIANISM": "majority rule [n]\n",
  "MAJORITARIANS": "MAJORITARIAN, a person who believes in or advocates majoritarianism [n]\n",
  "MAJORITIES": "MAJORITY, the greater number [n]\n",
  "MAJORITY": "the greater number [n MAJORITIES]\n",
  "MAJORLY": "MAJOR, greater [adv]\n",
  "MAJORS": "MAJOR, to pursue a specific principal course of study [v]\n",
  "MAJORSHIP": "the rank or office of a major [n -S]\n",
  "MAJORSHIPS": "MAJORSHIP, the rank or office of a major [n]\n",
  "MAJUSCULAR": "of letters, capital [adj]\n",
  "MAJUSCULE": "a capital or other large letter, esp. one used in ancient manuscripts [n -S]\n",
  "MAJUSCULES": "MAJUSCULE, a capital or other large letter, esp. one used in ancient manuscripts [n]\n",
  "MAK": "(Scots) to make [v MADE, MAKING, MAKS]\n",
  "MAKABLE": "capable of being made, also MAKEABLE [adj]\n",
  "MAKAR": "(Scots) a maker, a poet [n -S]\n",
  "MAKARS": "MAKAR, (Scots) a maker, a poet [n]\n",
  "MAKE": "to cause to exist [v MADE, MAKING, MAKES]\n",
  "MAKEABLE": "something that can be made, also MAKABLE [n -S]\n",
  "MAKEABLES": "MAKEABLE, something that can be made, also MAKABLE [n]\n",
  "MAKEBATE": "(archaic) a mischief-maker [n -S]\n",
  "MAKEBATES": "MAKEBATE, (archaic) a mischief-maker [n]\n",
  "MAKEFAST": "an object to which a boat is tied [n -S]\n",
  "MAKEFASTS": "MAKEFAST, an object to which a boat is tied [n]\n",
  "MAKELESS": "matchless [adj]\n",
  "MAKEOVER": "a complete change of appearance [n -S]\n",
  "MAKEOVERS": "MAKEOVER, a complete change of appearance [n]\n",
  "MAKER": "one that makes, also MAKAR [n -S]\n",
  "MAKEREADIES": "MAKEREADY, the preparation of a letterpress sheet for printing, so as to obtain evenness of impression [n]\n",
  "MAKEREADY": "the preparation of a letterpress sheet for printing, so as to obtain evenness of impression [n MAKEREADIES]\n",
  "MAKERS": "MAKER, one that makes, also MAKAR [n]\n",
  "MAKES": "MAKE, to cause to exist [v]\n",
  "MAKESHIFT": "something that serves as a temporary means [n -S]\n",
  "MAKESHIFTS": "MAKESHIFT, something that serves as a temporary means [n]\n",
  "MAKEUP": "the way in which things are put together [n -S]\n",
  "MAKEUPS": "MAKEUP, the way in which things are put together [n]\n",
  "MAKEWEIGHT": "a small quantity added to make up a certain weight e.g. an extra slice of bread; hence, an insignificant person or thing [n -S]\n",
  "MAKEWEIGHTS": "MAKEWEIGHT, a small quantity added to make up a certain weight e.g. an extra slice of bread; hence, an insignificant person or thing [n]\n",
  "MAKHANI": "(Hindi) in Indian cookery, a dish cooked in butter or cream [n -S]\n",
  "MAKHANIS": "MAKHANI, (Hindi) in Indian cookery, a dish cooked in butter or cream [n]\n",
  "MAKI": "(Japanese) a small segment cut from a long roll of cold rice and various other ingredients wrapped in a sheet of seaweed, in Japanese cuisine [n -S]\n",
  "MAKIMONO": "(Japanese) a Japanese ornamental scroll [n -S]\n",
  "MAKIMONOS": "MAKIMONO, (Japanese) a Japanese ornamental scroll [n]\n",
  "MAKING": "material from which something can be developed [n -S]\n",
  "MAKINGS": "MAKING, material from which something can be developed [n]\n",
  "MAKIS": "MAKI, (Japanese) a small segment cut from a long roll of cold rice and various other ingredients wrapped in a sheet of seaweed, in Japanese cuisine [n]\n",
  "MAKO": "(Maori) a kind of large shark [n -S]\n",
  "MAKOS": "MAKO, (Maori) a kind of large shark [n]\n",
  "MAKS": "MAK, (Scots) to make [v]\n",
  "MAKUNOUCHI": "(Japanese) the highest division in sumo wrestling [n -S]\n",
  "MAKUNOUCHIS": "MAKUNOUCHI, (Japanese) the highest division in sumo wrestling [n]\n",
  "MAKUTA": "LIKUTA, (Bantu) a monetary unit of Zaire [n]\n",
  "MAKUTU": "(Maori) Polynesian witchcraft [n -S] / to cast a spell upon [v -ED, -ING, -S]\n",
  "MAKUTUED": "MAKUTU, to cast a spell upon [v]\n",
  "MAKUTUING": "MAKUTU, to cast a spell upon [v]\n",
  "MAKUTUS": "MAKUTU, to cast a spell upon [v]\n",
  "MAL": "(French) pain, sickness [n -S]\n",
  "MALA": "(Hindi) a string of beads or knots used in prayer [n -S]\n",
  "MALABSORPTION": "faulty absorption esp. of nutrient materials from the gastrointestinal tract [n -S]\n",
  "MALABSORPTIONS": "MALABSORPTION, faulty absorption esp. of nutrient materials from the gastrointestinal tract [n]\n",
  "MALACCA": "(Malay) the cane of an Asian rattan palm [n -S]\n",
  "MALACCAS": "MALACCA, (Malay) the cane of an Asian rattan palm [n]\n",
  "MALACHITE": "native hydrous carbonate of copper, usually occurring in green mammillary masses with concentric fibrous structure [n -S]\n",
  "MALACHITES": "MALACHITE, native hydrous carbonate of copper, usually occurring in green mammillary masses with concentric fibrous structure [n]\n",
  "MALACIA": "(Greek) a pathological softening of tissue [n -S]\n",
  "MALACIAS": "MALACIA, (Greek) a pathological softening of tissue [n]\n",
  "MALACOLOGICAL": "relating to malacology, the study of molluscs [adj]\n",
  "MALACOLOGIES": "MALACOLOGY, the study of molluscs [n]\n",
  "MALACOLOGIST": "a student of molluscs [n -S]\n",
  "MALACOLOGISTS": "MALACOLOGIST, a student of molluscs [n]\n",
  "MALACOLOGY": "the study of molluscs [n MALACOLOGIES]\n",
  "MALACOPHILIES": "MALACOPHILY, pollination by snails [n]\n",
  "MALACOPHILOUS": "of plants, pollinated by snails [adj]\n",
  "MALACOPHILY": "pollination by snails [n MALACOPHILIES]\n",
  "MALACOPHYLLOUS": "of plants living in dry regions, having fleshy leaves in which water is stored [adj]\n",
  "MALACOPTERYGIAN": "belonging to the Malacopterygii, a soft-finned suborder of bony fishes, including herrings and salmon [adj]\n",
  "MALACOSTRACAN": "any of a large subclass of crustaceans having a thorax consisting of eight segments usually covered by a carapace and including the decapods and isopods [n -S]\n",
  "MALACOSTRACANS": "MALACOSTRACAN, any of a large subclass of crustaceans having a thorax consisting of eight segments usually covered by a carapace and including the decapods and isopods [n]\n",
  "MALACOSTRACOUS": "relating to the Malacostra, the best-known class of crustaceans, including crabs, lobsters, shrimps, prawns, etc. [adj]\n",
  "MALADAPTATION": "poor or inadequate adaptation [n -S]\n",
  "MALADAPTATIONS": "MALADAPTATION, poor or inadequate adaptation [n]\n",
  "MALADAPTED": "not well adapted [adj]\n",
  "MALADAPTIVE": "marked by poor or inadequate adaptation [adj MALADAPTIVELY]\n",
  "MALADAPTIVELY": "MALADAPTIVE, marked by poor or inadequate adaptation [adv]\n",
  "MALADDRESS": "awkwardness, social clumsiness [n -ES]\n",
  "MALADDRESSES": "MALADDRESS, awkwardness, social clumsiness [n]\n",
  "MALADIES": "MALADY, an illness [n]\n",
  "MALADJUSTED": "poorly or inadequately adjusted [adj]\n",
  "MALADJUSTIVE": "not conducive to adjustment [adj]\n",
  "MALADJUSTMENT": "poor, faulty, or inadequate adjustment [n -S]\n",
  "MALADJUSTMENTS": "MALADJUSTMENT, poor, faulty, or inadequate adjustment [n]\n",
  "MALADMINISTER": "to administer wrongly [v -ED, -S]\n",
  "MALADMINISTERED": "MALADMINISTER, to administer wrongly [v]\n",
  "MALADMINISTERS": "MALADMINISTER, to administer wrongly [v]\n",
  "MALADROIT": "(French) clumsy, unskilful [adj MALADROITLY] / one who is clumsy [n -S]\n",
  "MALADROITLY": "MALADROIT, (French) clumsy, unskilful [adv]\n",
  "MALADROITNESS": "MALADROIT, (French) clumsy, unskilful [n]\n",
  "MALADROITNESSES": "MALADROITNESS, MALADROIT, (French) clumsy, unskilful [n]\n",
  "MALADROITS": "MALADROIT, one who is clumsy [n]\n",
  "MALADY": "an illness [n MALADIES]\n",
  "MALAGUENA": "(Spanish) a Spanish dance performed by a couple, similar to the fandango [n -S]\n",
  "MALAGUENAS": "MALAGUENA, (Spanish) a Spanish dance performed by a couple, similar to the fandango [n]\n",
  "MALAGUETTA": "grains of Paradise, aka malaguetta pepper [n -S]\n",
  "MALAGUETTAS": "MALAGUETTA, grains of Paradise, aka malaguetta pepper [n]\n",
  "MALAISE": "(French) a feeling of debility [n -S]\n",
  "MALAISES": "MALAISE, (French) a feeling of debility [n]\n",
  "MALAKATOONE": "(obsolete) a kind of large peach, also MELICOTTON, MELOCOTON, MELOCOTOON [n -S]\n",
  "MALAKATOONES": "MALAKATOONE, (obsolete) a kind of large peach, also MELICOTTON, MELOCOTON, MELOCOTOON [n]\n",
  "MALAM": "a Muslim scholar, used as title, also MALLAM [n -S]\n",
  "MALAMS": "MALAM, a Muslim scholar, used as title, also MALLAM [n]\n",
  "MALAMUTE": "(Inuit) an Alaskan sled dog, also MALEMIUT, MALEMUTE [n -S]\n",
  "MALAMUTES": "MALAMUTE, (Inuit) an Alaskan sled dog, also MALEMIUT, MALEMUTE [n]\n",
  "MALANDER": "an eruption of the skin behind a horse's knee, also MALLANDER, MALLENDER [n -S]\n",
  "MALANDERS": "MALANDER, an eruption of the skin behind a horse's knee, also MALLANDER, MALLENDER [n]\n",
  "MALANGA": "a tropical plant, aka Mantle of the Queen [n -S]\n",
  "MALANGAS": "MALANGA, a tropical plant, aka Mantle of the Queen [n]\n",
  "MALAPERT": "(archaic) impudently bold [adj MALAPERTLY] / a saucy person [n -S]\n",
  "MALAPERTLY": "MALAPERT, (archaic) impudently bold [adv]\n",
  "MALAPERTNESS": "the state of being malapert [n -ES]\n",
  "MALAPERTNESSES": "MALAPERTNESS, the state of being malapert [n]\n",
  "MALAPERTS": "MALAPERT, a saucy person [n]\n",
  "MALAPPORTIONED": "characterized by an inequitable or unsuitable apportioning of representatives to a legislative body [adj]\n",
  "MALAPPROPRIATE": "to misuse or misappropriate [v MALAPPROPRIATED, MALAPPROPRIATES]\n",
  "MALAPPROPRIATED": "MALAPPROPRIATE, to misuse or misappropriate [v]\n",
  "MALAPPROPRIATES": "MALAPPROPRIATE, to misuse or misappropriate [v]\n",
  "MALAPROP": "a humorous misuse of a word, also MALAPROPISM [n -S]\n",
  "MALAPROPIAN": "relating to malapropism [adj]\n",
  "MALAPROPISM": "a humorous misuse of a word, also MALAPROP [n -S]\n",
  "MALAPROPISMS": "MALAPROPISM, a humorous misuse of a word, also MALAPROP [n]\n",
  "MALAPROPIST": "one who commits malapropisms [n -S]\n",
  "MALAPROPISTS": "MALAPROPIST, one who commits malapropisms [n]\n",
  "MALAPROPOS": "inappropriate or inopportune [adj] / something untimely or inappropriate [n]\n",
  "MALAPROPS": "MALAPROP, a humorous misuse of a word, also MALAPROPISM [n]\n",
  "MALAR": "the cheekbone [n -S]\n",
  "MALARIA": "an infectious tropical disease [n -S]\n",
  "MALARIAL": "relating to malaria, also MALARIAN, MALARIOUS [adj]\n",
  "MALARIAN": "relating to malaria, also MALARIAL, MALARIOUS [adj]\n",
  "MALARIAS": "MALARIA, an infectious tropical disease [n]\n",
  "MALARIOLOGIES": "MALARIOLOGY, the study of malaria [n]\n",
  "MALARIOLOGIST": "a specialist in malaria [n -S]\n",
  "MALARIOLOGISTS": "MALARIOLOGIST, a specialist in malaria [n]\n",
  "MALARIOLOGY": "the study of malaria [n MALARIOLOGIES]\n",
  "MALARIOUS": "relating to malaria, also MALARIAL, MALARIAN [adj]\n",
  "MALARKEY": "(US colloquial) absurd talk, nonsense, also MALARKY, MULLARKY [n -S]\n",
  "MALARKEYS": "MALARKEY, (US colloquial) absurd talk, nonsense, also MALARKY, MULLARKY [n]\n",
  "MALARKIES": "MALARKY, (US colloquial) absurd talk, nonsense, also MALARKEY, MULLARKY [n]\n",
  "MALARKY": "(US colloquial) absurd talk, nonsense, also MALARKEY, MULLARKY [n MALARKIES]\n",
  "MALAROMA": "an offensive odor, also MALODOR, MALODOUR [n -S]\n",
  "MALAROMAS": "MALAROMA, an offensive odor, also MALODOR, MALODOUR [n]\n",
  "MALARS": "MALAR, the cheekbone [n]\n",
  "MALAS": "MALA, (Hindi) a string of beads or knots used in prayer [n]\n",
  "MALASSIMILATION": "imperfect assimilation or nutrition [n]\n",
  "MALATE": "a salt of malic acid, also MALEATE [n -S]\n",
  "MALATES": "MALATE, a salt of malic acid, also MALEATE [n]\n",
  "MALATHION": "(tradename) an insecticide [n -S]\n",
  "MALATHIONS": "MALATHION, (tradename) an insecticide [n]\n",
  "MALAX": "to soften by kneading, also MALAXATE [v -ED, -ING, -ES]\n",
  "MALAXAGE": "the softening of clay by kneading it [n -S]\n",
  "MALAXAGES": "MALAXAGE, the softening of clay by kneading it [n]\n",
  "MALAXATE": "to soften by kneading, also MALAX [v MALAXATED, MALAXATING, MALAXATES]\n",
  "MALAXATED": "MALAXATE, to soften by kneading, also MALAX [v]\n",
  "MALAXATES": "MALAXATE, to soften by kneading, also MALAX [v]\n",
  "MALAXATING": "MALAXATE, to soften by kneading, also MALAX [v]\n",
  "MALAXATION": "a kneading movement in massage [n -S]\n",
  "MALAXATIONS": "MALAXATION, a kneading movement in massage [n]\n",
  "MALAXATOR": "one who, or that which, malaxates; esp. a machine for grinding, kneading, or stirring into a pasty or doughy mass [n -S]\n",
  "MALAXATORS": "MALAXATOR, one who, or that which, malaxates; esp. a machine for grinding, kneading, or stirring into a pasty or doughy mass [n]\n",
  "MALAXED": "MALAX, to soften by kneading, also MALAXATE [v]\n",
  "MALAXES": "MALAX, to soften by kneading, also MALAXATE [v]\n",
  "MALAXING": "MALAX, to soften by kneading, also MALAXATE [v]\n",
  "MALCONFORMATION": "disproportionate or imperfect formation [n]\n",
  "MALCONTENT": "a discontented person [n -S]\n",
  "MALCONTENTED": "discontented [adj MALCONTENTEDLY]\n",
  "MALCONTENTEDLY": "MALCONTENTED, discontented [adv]\n",
  "MALCONTENTS": "MALCONTENT, a discontented person [n]\n",
  "MALDEPLOYMENT": "a wrong deployment [n -S]\n",
  "MALDEPLOYMENTS": "MALDEPLOYMENT, a wrong deployment [n]\n",
  "MALDISTRIBUTION": "unfair distribution [n]\n",
  "MALE": "an individual that begets young by fertilizing the female [n -S]\n",
  "MALEATE": "a salt of malic acid, also MALATE [n -S]\n",
  "MALEATES": "MALEATE, a salt of malic acid, also MALATE [n]\n",
  "MALEDICENT": "cursing [adj]\n",
  "MALEDICT": "(archaic) to curse [v -ED, -ING, -S]\n",
  "MALEDICTED": "MALEDICT, (archaic) to curse [v]\n",
  "MALEDICTING": "MALEDICT, (archaic) to curse [v]\n",
  "MALEDICTION": "a curse [n -S]\n",
  "MALEDICTIONS": "MALEDICTION, a curse [n]\n",
  "MALEDICTIVE": "of the nature of a malediction [adj]\n",
  "MALEDICTORY": "of or like a malediction [adj]\n",
  "MALEDICTS": "MALEDICT, (archaic) to curse [v]\n",
  "MALEFACTION": "evildoing [n -S]\n",
  "MALEFACTIONS": "MALEFACTION, evildoing [n]\n",
  "MALEFACTOR": "an evildoer, a criminal [n -S]\n",
  "MALEFACTORS": "MALEFACTOR, an evildoer, a criminal [n]\n",
  "MALEFACTORY": "having the nature of a malefactor [adj]\n",
  "MALEFACTRESS": "a female malefactor [n -ES]\n",
  "MALEFACTRESSES": "MALEFACTRESS, a female malefactor [n]\n",
  "MALEFFECT": "an adverse effect [n -S]\n",
  "MALEFFECTS": "MALEFFECT, an adverse effect [n]\n",
  "MALEFIC": "having a malignant influence, baleful [adj MALEFICALLY]\n",
  "MALEFICALLY": "MALEFIC, having a malignant influence, baleful [adv]\n",
  "MALEFICE": "(archaic) an evil deed; an enchantment [n -S]\n",
  "MALEFICENCE": "the act of committing harm or evil [n -S]\n",
  "MALEFICENCES": "MALEFICENCE, the act of committing harm or evil [n]\n",
  "MALEFICENT": "(archaic) hurtful, also MALEFICIAL [adj]\n",
  "MALEFICES": "MALEFICE, (archaic) an evil deed; an enchantment [n]\n",
  "MALEFICIAL": "(archaic) injurious, also MALEFICENT [adj]\n",
  "MALEIC": "as in maleic acid, an acid of the ethylene series [adj]\n",
  "MALEMIUT": "(Inuit) an Alaskan sled dog, also MALAMUTE, MALEMUTE [n -S]\n",
  "MALEMIUTS": "MALEMIUT, (Inuit) an Alaskan sled dog, also MALAMUTE, MALEMUTE [n]\n",
  "MALEMUTE": "(Inuit) an Alaskan sled dog, also MALAMUTE, MALEMIUT [n -S]\n",
  "MALEMUTES": "MALEMUTE, (Inuit) an Alaskan sled dog, also MALAMUTE, MALEMIUT [n]\n",
  "MALENESS": "the quality of being a male [n -ES]\n",
  "MALENESSES": "MALENESS, the quality of being a male [n]\n",
  "MALENGINE": "(Spenser) evil machination, deceit [n -S]\n",
  "MALENGINES": "MALENGINE, (Spenser) evil machination, deceit [n]\n",
  "MALENTENDU": "(French) a misunderstanding [n -S]\n",
  "MALENTENDUS": "MALENTENDU, (French) a misunderstanding [n]\n",
  "MALES": "MALE, an individual that begets young by fertilizing the female [n]\n",
  "MALEVOLENCE": "the state of being malevolent [n -S]\n",
  "MALEVOLENCES": "MALEVOLENCE, the state of being malevolent [n]\n",
  "MALEVOLENT": "wishing evil [adj MALEVOLENTLY]\n",
  "MALEVOLENTLY": "MALEVOLENT, wishing evil [adv]\n",
  "MALFEASANCE": "the performance by a public official of an act that is legally unjustified, harmful, or contrary to law; wrongdoing (used especially of an act in violation of a public trust), also MISFEASANCE [n -S]\n",
  "MALFEASANCES": "MALFEASANCE, the performance by a public official of an act that is legally unjustified, harmful, or contrary to law; wrongdoing (used especially of an act in violation of a public trust), also MISFEASANCE [n]\n",
  "MALFEASANT": "(French) one who does wrong [n -S]\n",
  "MALFEASANTS": "MALFEASANT, (French) one who does wrong [n]\n",
  "MALFED": "badly fed [adj]\n",
  "MALFORMATION": "faulty structure, deformity [n -S]\n",
  "MALFORMATIONS": "MALFORMATION, faulty structure, deformity [n]\n",
  "MALFORMED": "badly formed [adj]\n",
  "MALFUNCTION": "to function imperfectly or badly [v -ED, -ING, -S]\n",
  "MALFUNCTIONED": "MALFUNCTION, to function imperfectly or badly [v]\n",
  "MALFUNCTIONING": "an instance of functioning imperfectly or badly [n -S]\n",
  "MALFUNCTIONINGS": "MALFUNCTIONING, an instance of functioning imperfectly or badly [n]\n",
  "MALFUNCTIONS": "MALFUNCTION, to function imperfectly or badly [v]\n",
  "MALGRADO": "(obsolete) in spite of, also MALGRE, MAUGER, MAUGRE, MAULGRE [prep]\n",
  "MALGRE": "(archaic) to show spite towards, also MALGRADO, MAUGER, MAUGRE, MAULGRE [v MALGRED, MALGRING, MALGRES]\n",
  "MALGRED": "MALGRE, (archaic) to show spite towards, also MALGRADO, MAUGER, MAUGRE, MAULGRE [v]\n",
  "MALGRES": "MALGRE, (archaic) to show spite towards, also MALGRADO, MAUGER, MAUGRE, MAULGRE [v]\n",
  "MALGRING": "MALGRE, (archaic) to show spite towards, also MALGRADO, MAUGER, MAUGRE, MAULGRE [v]\n",
  "MALI": "(Hindi) a member of the gardener caste in India [n -S]\n",
  "MALIBU": "as in malibu board, a light surfboard [adj]\n",
  "MALIC": "as in malic acid, an acid obtained from apple juice [adj]\n",
  "MALICE": "to have ill-will towards another [v MALICED or (Spenser) MALIST, MALICING, MALICES]\n",
  "MALICED": "MALICE, to have ill-will towards another [v]\n",
  "MALICES": "MALICE, to have ill-will towards another [v]\n",
  "MALICHO": "(Shakespeare) mischief, also MALLECHO [n -S]\n",
  "MALICHOS": "MALICHO, (Shakespeare) mischief, also MALLECHO [n]\n",
  "MALICING": "MALICE, to have ill-will towards another [v]\n",
  "MALICIOUS": "bearing ill-will or spite [adj MALICIOUSLY]\n",
  "MALICIOUSLY": "MALICIOUS, bearing ill-will or spite [adv]\n",
  "MALICIOUSNESS": "MALICIOUS, bearing ill-will or spite [n]\n",
  "MALICIOUSNESSES": "MALICIOUSNESS, MALICIOUS, bearing ill-will or spite [n]\n",
  "MALIGN": "evil [adj MALIGNLY] / to speak evil of [v -ED, -ING, -S]\n",
  "MALIGNANCE": "the state of being malignant, also MALIGNANCY [n -S]\n",
  "MALIGNANCES": "MALIGNANCE, the state of being malignant, also MALIGNANCY [n]\n",
  "MALIGNANCIES": "MALIGNANCY, the state of being malignant, also MALIGNANCE [n]\n",
  "MALIGNANCY": "the state of being malignant, also MALIGNANCE [n MALIGNANCIES]\n",
  "MALIGNANT": "evil, malign [adj MALIGNANTLY] / a supporter of the royalist cause during the English civil war [n -S]\n",
  "MALIGNANTLY": "MALIGNANT, evil, malign [adv]\n",
  "MALIGNANTS": "MALIGNANT, a supporter of the royalist cause during the English civil war [n]\n",
  "MALIGNED": "MALIGN, to speak evil of [v]\n",
  "MALIGNER": "one who maligns [n -S]\n",
  "MALIGNERS": "MALIGNER, one who maligns [n]\n",
  "MALIGNING": "MALIGN, to speak evil of [v]\n",
  "MALIGNITIES": "MALIGNITY, the quality of being malign [n]\n",
  "MALIGNITY": "the quality of being malign [n MALIGNITIES]\n",
  "MALIGNLY": "MALIGN, evil [adv]\n",
  "MALIGNMENT": "a malign act [n -S]\n",
  "MALIGNMENTS": "MALIGNMENT, a malign act [n]\n",
  "MALIGNS": "MALIGN, to speak evil of [v]\n",
  "MALIHINI": "(Hawaiian) a newcomer to Hawaii [n -S]\n",
  "MALIHINIS": "MALIHINI, (Hawaiian) a newcomer to Hawaii [n]\n",
  "MALIK": "(Arabic) in India, the head of a village, an employer, also MELIK [n -S]\n",
  "MALIKS": "MALIK, (Arabic) in India, the head of a village, an employer, also MELIK [n]\n",
  "MALIMPRINTED": "of an animal or person, suffering from a defect in the behavioural process of imprinting, resulting in attraction to members of other species, fetishism, etc. [adj]\n",
  "MALIMPRINTING": "the process of becoming malimprinted [n -S]\n",
  "MALIMPRINTINGS": "MALIMPRINTING, the process of becoming malimprinted [n]\n",
  "MALINE": "(French) a delicate net used for veils [n -S]\n",
  "MALINES": "MALINE, (French) a delicate net used for veils [n]\n",
  "MALINGER": "to feign illness in order to avoid duty or work [v -ED, -ING, -S]\n",
  "MALINGERED": "MALINGER, to feign illness in order to avoid duty or work [v]\n",
  "MALINGERER": "one who malingers [n -S]\n",
  "MALINGERERS": "MALINGERER, one who malingers [n]\n",
  "MALINGERIES": "MALINGERY, the spirit or practices of a malingerer [n]\n",
  "MALINGERING": "MALINGER, to feign illness in order to avoid duty or work [v]\n",
  "MALINGERS": "MALINGER, to feign illness in order to avoid duty or work [v]\n",
  "MALINGERY": "the spirit or practices of a malingerer [n MALINGERIES]\n",
  "MALIS": "MALI, (Hindi) a member of the gardener caste in India [n]\n",
  "MALISM": "belief in the predominance of evil [n -S]\n",
  "MALISMS": "MALISM, belief in the predominance of evil [n]\n",
  "MALISON": "a curse, a malediction [n -S]\n",
  "MALISONS": "MALISON, a curse, a malediction [n]\n",
  "MALIST": "MALICE, to have ill-will towards another [v]\n",
  "MALKIN": "(dialect) a cat, also GRIMALKIN, MAWKIN [n -S]\n",
  "MALKINS": "MALKIN, (dialect) a cat, also GRIMALKIN, MAWKIN [n]\n",
  "MALL": "to beat, batter, also MAUL [v -ED, -ING, -S]\n",
  "MALLAM": "a Muslim scholar, used as title, also MALAM [n -S]\n",
  "MALLAMS": "MALLAM, a Muslim scholar, used as title, also MALAM [n]\n",
  "MALLANDER": "an eruption of the skin behind a horse's knee, also MALANDER, MALLENDER [n -S]\n",
  "MALLANDERS": "MALLANDER, an eruption of the skin behind a horse's knee, also MALANDER, MALLENDER [n]\n",
  "MALLARD": "a wild duck [n -S]\n",
  "MALLARDS": "MALLARD, a wild duck [n]\n",
  "MALLCORE": "a form of music that incorporates rap and funk [n -S]\n",
  "MALLCORES": "MALLCORE, a form of music that incorporates rap and funk [n]\n",
  "MALLEABILITIES": "MALLEABILITY, the state of being malleable [n]\n",
  "MALLEABILITY": "the state of being malleable [n MALLEABILITIES]\n",
  "MALLEABLE": "able to be beaten, rolled, etc. into a new shape [adj MALLEABLY]\n",
  "MALLEABLENESS": "the state of being malleable [n -ES]\n",
  "MALLEABLENESSES": "MALLEABLENESS, the state of being malleable [n]\n",
  "MALLEABLY": "MALLEABLE, able to be beaten, rolled, etc. into a new shape [adv]\n",
  "MALLEATE": "to hammer; to beat into a plate or leaf [v MALLEATED, MALLEATING, MALLEATES]\n",
  "MALLEATED": "MALLEATE, to hammer; to beat into a plate or leaf [v]\n",
  "MALLEATES": "MALLEATE, to hammer; to beat into a plate or leaf [v]\n",
  "MALLEATING": "MALLEATE, to hammer; to beat into a plate or leaf [v]\n",
  "MALLEATION": "hammering; a hammer-mark or dent [n -S]\n",
  "MALLEATIONS": "MALLEATION, hammering; a hammer-mark or dent [n]\n",
  "MALLECHO": "(Shakespeare) mischief, also MALICHO [n -S]\n",
  "MALLECHOS": "MALLECHO, (Shakespeare) mischief, also MALICHO [n]\n",
  "MALLED": "MALL, to beat, batter, also MAUL [v]\n",
  "MALLEE": "(Native Australian) a scrubby Australian evergreen tree [n -S]\n",
  "MALLEES": "MALLEE, (Native Australian) a scrubby Australian evergreen tree [n]\n",
  "MALLEI": "MALLEUS, (Latin) a bone of the middle ear [n]\n",
  "MALLEIFORM": "shaped like a hammer [adj]\n",
  "MALLEMAROKING": "the carousing of seamen in icebound ships, also MOLLIE [n -S]\n",
  "MALLEMAROKINGS": "MALLEMAROKING, the carousing of seamen in icebound ships, also MOLLIE [n]\n",
  "MALLEMUCK": "(Dutch) the albatross, also MOLLYMAWK [n -S]\n",
  "MALLEMUCKS": "MALLEMUCK, (Dutch) the albatross, also MOLLYMAWK [n]\n",
  "MALLENDER": "an eruption of the skin behind a horse's knee, also MALANDER, MALLANDER [n -S]\n",
  "MALLENDERS": "MALLENDER, an eruption of the skin behind a horse's knee, also MALANDER, MALLANDER [n]\n",
  "MALLEOLAR": "of or pertaining to the malleolus, a rounded bony projection on either side of the ankle [adj]\n",
  "MALLEOLI": "MALLEOLUS, (Latin) a rounded bony projection on either side of the ankle [n]\n",
  "MALLEOLUS": "(Latin) a rounded bony projection on either side of the ankle [n MALLEOLUSES or MALLEOLI]\n",
  "MALLEOLUSES": "MALLEOLUS, (Latin) a rounded bony projection on either side of the ankle [n]\n",
  "MALLET": "a type of hammer [n -S]\n",
  "MALLETS": "MALLET, a type of hammer [n]\n",
  "MALLEUS": "(Latin) a bone of the middle ear [n MALLEUSES or MALLEI]\n",
  "MALLEUSES": "MALLEUS, (Latin) a bone of the middle ear [n]\n",
  "MALLING": "a mauling [n -S]\n",
  "MALLINGS": "MALLING, a mauling [n]\n",
  "MALLOPHAGOUS": "relating to the Mallophaga, an order of wingless parasitic insects, bird-lice or biting-lice [adj]\n",
  "MALLOW": "any of various plants of the family Malvaceae and esp. of the genus Malva, typically with deeply-cleft purple flowers [n -S]\n",
  "MALLOWPUFF": "(New Zealand) a white marshmallow on a biscuit base covered in chocolate [n -S]\n",
  "MALLOWPUFFS": "MALLOWPUFF, (New Zealand) a white marshmallow on a biscuit base covered in chocolate [n]\n",
  "MALLOWS": "MALLOW, any of various plants of the family Malvaceae and esp. of the genus Malva, typically with deeply-cleft purple flowers [n]\n",
  "MALLS": "MALL, to beat, batter, also MAUL [v]\n",
  "MALM": "a soft, friable limestone [n -S]\n",
  "MALMAG": "a nocturnal lemuroid monkey of the East Indies, aka tarsier [n -S]\n",
  "MALMAGS": "MALMAG, a nocturnal lemuroid monkey of the East Indies, aka tarsier [n]\n",
  "MALMIER": "MALMY, resembling malm, a calcareous loam used in making brick [adj]\n",
  "MALMIEST": "MALMY, resembling malm, a calcareous loam used in making brick [adj]\n",
  "MALMS": "MALM, a soft, friable limestone [n]\n",
  "MALMSEY": "a strong sweet wine, also MALVESIE, MALVOISIE [n -S]\n",
  "MALMSEYS": "MALMSEY, a strong sweet wine, also MALVESIE, MALVOISIE [n]\n",
  "MALMSTONE": "calcareous loam; earth of this kind, formerly used for making brick [n -S]\n",
  "MALMSTONES": "MALMSTONE, calcareous loam; earth of this kind, formerly used for making brick [n]\n",
  "MALMY": "resembling malm, a calcareous loam used in making brick [adj MALMIER, MALMIEST]\n",
  "MALNOURISHED": "undernourished [adj]\n",
  "MALNUTRITION": "inadequate or faulty nutrition [n -S]\n",
  "MALNUTRITIONS": "MALNUTRITION, inadequate or faulty nutrition [n]\n",
  "MALOCCLUDED": "exhibiting malocclusion [adj]\n",
  "MALOCCLUSION": "faulty contact between the upper and lower teeth when the jaw is closed [n -S]\n",
  "MALOCCLUSIONS": "MALOCCLUSION, faulty contact between the upper and lower teeth when the jaw is closed [n]\n",
  "MALODOR": "an offensive odor, also MALAROMA, MALODOUR [n -S]\n",
  "MALODOROUS": "having a bad odor [adj MALODOROUSLY]\n",
  "MALODOROUSLY": "MALODOROUS, having a bad odor [adv]\n",
  "MALODOROUSNESS": "MALODOROUS, having a bad odor [n]\n",
  "MALODORS": "MALODOR, an offensive odor, also MALAROMA, MALODOUR [n]\n",
  "MALODOUR": "an offensive odor, also MALODOR, MALAROMA [n -S]\n",
  "MALODOURS": "MALODOUR, an offensive odor, also MALODOR, MALAROMA [n]\n",
  "MALOLACTIC": "relating to the conversion of malic acid to lactic acid in the production of wine [adj]\n",
  "MALONATE": "a salt of malonic acid [n -S]\n",
  "MALONATES": "MALONATE, a salt of malonic acid [n]\n",
  "MALONIC": "as in malonic acid, a white crystalline acid, aka propanedioic acid [adj]\n",
  "MALONYLUREA": "another name for barbituric acid [n -S]\n",
  "MALONYLUREAS": "MALONYLUREA, another name for barbituric acid [n]\n",
  "MALOTI": "LOTI, a monetary unit of Lesotho [n]\n",
  "MALPIGHIA": "the Barbados cherry genus of tropical American trees, shrubs, and lianes [n -S]\n",
  "MALPIGHIACEOUS": "belonging to the malpighia family [adj]\n",
  "MALPIGHIAS": "MALPIGHIA, the Barbados cherry genus of tropical American trees, shrubs, and lianes [n]\n",
  "MALPOSED": "being in the wrong position [adj]\n",
  "MALPOSITION": "a wrong or faulty position [n -S]\n",
  "MALPOSITIONS": "MALPOSITION, a wrong or faulty position [n]\n",
  "MALPRACTICE": "an evil or improper practice; professional misconduct [n -S]\n",
  "MALPRACTICES": "MALPRACTICE, an evil or improper practice; professional misconduct [n]\n",
  "MALPRACTITIONER": "one who engages in or commits malpractice [n]\n",
  "MALPRESENTATION": "abnormal positioning of a fetus in childbirth [n]\n",
  "MALS": "MAL, (French) pain, sickness [n]\n",
  "MALSTICK": "(Dutch) a stick used by painters to steady the hand, also MAHLSTICK, MAULSTICK [n -S]\n",
  "MALSTICKS": "MALSTICK, (Dutch) a stick used by painters to steady the hand, also MAHLSTICK, MAULSTICK [n]\n",
  "MALT": "barley or other grain prepared for brewing or distilling, also MAUT [n -S] / to treat or combine with malt [v -ED, -ING, -S]\n",
  "MALTALENT": "(Spenser) ill-will [n -S]\n",
  "MALTALENTS": "MALTALENT, (Spenser) ill-will [n]\n",
  "MALTASE": "an enzyme that produces grape-sugar from maltose [n -S]\n",
  "MALTASES": "MALTASE, an enzyme that produces grape-sugar from maltose [n]\n",
  "MALTED": "a whisky flavoured with malt [n -S]\n",
  "MALTEDS": "MALTED, a whisky flavoured with malt [n]\n",
  "MALTESE": "as in maltese cross, a mechanism providing intermittent frame-by-frame movement in a motion picture film projector [adj]\n",
  "MALTHA": "(Latin) a thick mineral pitch [n -S]\n",
  "MALTHAS": "MALTHA, (Latin) a thick mineral pitch [n]\n",
  "MALTIER": "MALTY, resembling malt [adj]\n",
  "MALTIEST": "MALTY, resembling malt [adj]\n",
  "MALTINESS": "the state of being malty [n -ES]\n",
  "MALTINESSES": "MALTINESS, the state of being malty [n]\n",
  "MALTING": "a building where malt is made [n -S]\n",
  "MALTINGS": "MALTING, a building where malt is made [n]\n",
  "MALTIPOO": "a dog that is a cross between a Maltese and a poodle [n -S]\n",
  "MALTIPOOS": "MALTIPOO, a dog that is a cross between a Maltese and a poodle [n]\n",
  "MALTMAN": "one who makes malt, also MALTSTER [n MALTMEN]\n",
  "MALTMEN": "MALTMAN, one who makes malt, also MALTSTER [n]\n",
  "MALTODEXTRIN": "any of various carbohydrates derived from the partial hydrolysis of starch (as of corn or potatoes) [n -S]\n",
  "MALTODEXTRINS": "MALTODEXTRIN, any of various carbohydrates derived from the partial hydrolysis of starch (as of corn or potatoes) [n]\n",
  "MALTOL": "a natural food additive used in bread and cakes [n -S]\n",
  "MALTOLS": "MALTOL, a natural food additive used in bread and cakes [n]\n",
  "MALTOSE": "a hard, white crystalline sugar, formed by the action of malt or diastase on starch [n -S]\n",
  "MALTOSES": "MALTOSE, a hard, white crystalline sugar, formed by the action of malt or diastase on starch [n]\n",
  "MALTREAT": "to treat badly [v -ED, -ING, -S]\n",
  "MALTREATED": "MALTREAT, to treat badly [v]\n",
  "MALTREATER": "one who maltreats [n -S]\n",
  "MALTREATERS": "MALTREATER, one who maltreats [n]\n",
  "MALTREATING": "MALTREAT, to treat badly [v]\n",
  "MALTREATMENT": "ill treatment [n -S]\n",
  "MALTREATMENTS": "MALTREATMENT, ill treatment [n]\n",
  "MALTREATS": "MALTREAT, to treat badly [v]\n",
  "MALTS": "MALT, to treat or combine with malt [v]\n",
  "MALTSTER": "one who makes malt, also MALTMAN [n -S]\n",
  "MALTSTERS": "MALTSTER, one who makes malt, also MALTMAN [n]\n",
  "MALTWORM": "(Shakespeare) a lover of malted liquids, a tippler [n -S]\n",
  "MALTWORMS": "MALTWORM, (Shakespeare) a lover of malted liquids, a tippler [n]\n",
  "MALTY": "resembling malt [adj MALTIER, MALTIEST]\n",
  "MALUS": "a financial penalty incurred by a trader, investor, or banker when an investment or deal results in a loss [n -ES]\n",
  "MALUSES": "MALUS, a financial penalty incurred by a trader, investor, or banker when an investment or deal results in a loss [n]\n",
  "MALVA": "(Latin) any plant of the mallow family [n -S]\n",
  "MALVACEOUS": "pertaining to the mallow family of plants [adj]\n",
  "MALVAS": "MALVA, (Latin) any plant of the mallow family [n]\n",
  "MALVASIA": "a type of grape from which malmsey is made [n -S]\n",
  "MALVASIAN": "relating to malvasia, a type of grape used to make malmsey [adj]\n",
  "MALVASIAS": "MALVASIA, a type of grape from which malmsey is made [n]\n",
  "MALVERSATION": "dishonest or unethical conduct in office, such as bribery, extortion or embezzlement [n -S]\n",
  "MALVERSATIONS": "MALVERSATION, dishonest or unethical conduct in office, such as bribery, extortion or embezzlement [n]\n",
  "MALVESIE": "a strong sweet wine, also MALMSEY, MALVOISIE [n -S]\n",
  "MALVESIES": "MALVESIE, a strong sweet wine, also MALMSEY, MALVOISIE [n]\n",
  "MALVOISIE": "(French) a strong sweet wine, also MALMSEY, MALVESIE [n -S]\n",
  "MALVOISIES": "MALVOISIE, (French) a strong sweet wine, also MALMSEY, MALVESIE [n]\n",
  "MALWA": "a Ugandan drink brewed from millet [n -S]\n",
  "MALWARE": "a computer program designed to cause damage or disruption to a system [n -S]\n",
  "MALWARES": "MALWARE, a computer program designed to cause damage or disruption to a system [n]\n",
  "MALWAS": "MALWA, a Ugandan drink brewed from millet [n]\n",
  "MAM": "(dialect) mother [n -S]\n",
  "MAMA": "a child's name for mother, also MAMMA, MAMMIE, MAMMY [n -S]\n",
  "MAMAGUY": "(Caribbean) to deceive or tease esp. by flattery [v -ED, -ING, -S]\n",
  "MAMAGUYED": "MAMAGUY, (Caribbean) to deceive or tease esp. by flattery [v]\n",
  "MAMAGUYING": "MAMAGUY, (Caribbean) to deceive or tease esp. by flattery [v]\n",
  "MAMAGUYS": "MAMAGUY, (Caribbean) to deceive or tease esp. by flattery [v]\n",
  "MAMAKAU": "(Maori) a tall edible New Zealand tree fern, also MAMAKO, MAMAKU [n -S]\n",
  "MAMAKAUS": "MAMAKAU, (Maori) a tall edible New Zealand tree fern, also MAMAKO, MAMAKU [n]\n",
  "MAMAKO": "(Maori) a tall edible New Zealand tree fern, also MAMAKAU, MAMAKU [n -S]\n",
  "MAMAKOS": "MAMAKO, (Maori) a tall edible New Zealand tree fern, also MAMAKAU, MAMAKU [n]\n",
  "MAMAKU": "(Maori) a tall edible New Zealand tree fern, also MAMAKAU, MAMAKO [n -S]\n",
  "MAMAKUS": "MAMAKU, (Maori) a tall edible New Zealand tree fern, also MAMAKAU, MAMAKO [n]\n",
  "MAMALIGA": "(Romanian) a type of corn meal mush eaten by Rumanians [n -S]\n",
  "MAMALIGAS": "MAMALIGA, (Romanian) a type of corn meal mush eaten by Rumanians [n]\n",
  "MAMAS": "MAMA, a child's name for mother, also MAMMA, MAMMIE, MAMMY [n]\n",
  "MAMASAN": "(Japanese) a Japanese woman in a position of authority [n -S]\n",
  "MAMASANS": "MAMASAN, (Japanese) a Japanese woman in a position of authority [n]\n",
  "MAMATEEK": "(Native American) a type of wigwam [n -S]\n",
  "MAMATEEKS": "MAMATEEK, (Native American) a type of wigwam [n]\n",
  "MAMBA": "(Zulu) a venomous African snake [n -S]\n",
  "MAMBAS": "MAMBA, (Zulu) a venomous African snake [n]\n",
  "MAMBO": "a Cuban ballroom dance resembling the rumba or cha-cha [n -S] / to dance the mambo [v -ED, -ING, -ES]\n",
  "MAMBOED": "MAMBO, to dance the mambo [v]\n",
  "MAMBOES": "MAMBO, to dance the mambo [v]\n",
  "MAMBOING": "MAMBO, to dance the mambo [v]\n",
  "MAMBOS": "MAMBO, to dance the mambo [v]\n",
  "MAMEE": "a tropical plant having an edible fruit with bright yellow pulp, also MAMEY, MAMIE, MAMMEE, MAMMEY [n -S]\n",
  "MAMEES": "MAMEE, a tropical plant having an edible fruit with bright yellow pulp, also MAMEY, MAMIE, MAMMEE, MAMMEY [n]\n",
  "MAMELON": "(French) a rounded hill or protuberance [n -S]\n",
  "MAMELONS": "MAMELON, (French) a rounded hill or protuberance [n]\n",
  "MAMELUCO": "(Portuguese) a child born of a white father and Indian mother, also MAMELUKE, MAMLUK [n -S]\n",
  "MAMELUCOS": "MAMELUCO, (Portuguese) a child born of a white father and Indian mother, also MAMELUKE, MAMLUK [n]\n",
  "MAMELUKE": "(historical) one of former Turkish slaves that held the Egyptian throne from 1250 to 1517, also MAMELUCO, MAMLUK [n -S]\n",
  "MAMELUKES": "MAMELUKE, (historical) one of former Turkish slaves that held the Egyptian throne from 1250 to 1517, also MAMELUCO, MAMLUK [n]\n",
  "MAMEY": "a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMIE, MAMMEE, MAMMEY [n MAMEYS or MAMEYES]\n",
  "MAMEYES": "MAMEY, a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMIE, MAMMEE, MAMMEY [n]\n",
  "MAMEYS": "MAMEY, a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMIE, MAMMEE, MAMMEY [n]\n",
  "MAMIE": "a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMEY, MAMMEE, MAMMEY [n -S]\n",
  "MAMIES": "MAMIE, a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMEY, MAMMEE, MAMMEY [n]\n",
  "MAMILLA": "(Latin) the nipple of the mammary gland, also MAMMILLA [n MAMILLAE]\n",
  "MAMILLAE": "MAMILLA, (Latin) the nipple of the mammary gland, also MAMMILLA [n]\n",
  "MAMILLAR": "relating to the nipple, also MAMILLARY [adj]\n",
  "MAMILLARY": "relating to the nipple, also MAMILLAR [adj]\n",
  "MAMILLATE": "with nipple-like projections, also MAMMILLATE, MAMMILLATED [adj]\n",
  "MAMILLATED": "with nipple-like projections [adj]\n",
  "MAMILLATION": "the state of being mamillate, with nipple-like projections, also MAMMILLATION [n -S]\n",
  "MAMILLATIONS": "MAMILLATION, the state of being mamillate, with nipple-like projections, also MAMMILLATION [n]\n",
  "MAMILLIFORM": "nipple-shaped, also MAMMILLIFORM [adj]\n",
  "MAMLUK": "(Arabic) one of former Turkish slaves that held the Egyptian throne from 1250 to 1517, also MAMELUCO, MAMELUKE [n -S]\n",
  "MAMLUKS": "MAMLUK, (Arabic) one of former Turkish slaves that held the Egyptian throne from 1250 to 1517, also MAMELUCO, MAMELUKE [n]\n",
  "MAMMA": "(Latin) the milk gland, the breast [n MAMMAE] / a child's name for mother, also MAMA, MAMMIE, MAMMY [n -S]\n",
  "MAMMAE": "MAMMA, (Latin) the milk gland, the breast [n]\n",
  "MAMMAL": "any of a class of warm-blooded vertebrates [n -S]\n",
  "MAMMALIAN": "a mammal [n -S]\n",
  "MAMMALIANS": "MAMMALIAN, a mammal [n]\n",
  "MAMMALIFEROUS": "bearing remains of mammals [adj]\n",
  "MAMMALITIES": "MAMMALITY, the state of being a mammal [n]\n",
  "MAMMALITY": "the state of being a mammal [n MAMMALITIES]\n",
  "MAMMALOGICAL": "related to mammalogy [adj]\n",
  "MAMMALOGIES": "MAMMALOGY, the study of mammals [n]\n",
  "MAMMALOGIST": "a student of mammals [n -S]\n",
  "MAMMALOGISTS": "MAMMALOGIST, a student of mammals [n]\n",
  "MAMMALOGY": "the study of mammals [n MAMMALOGIES]\n",
  "MAMMALS": "MAMMAL, any of a class of warm-blooded vertebrates [n]\n",
  "MAMMAPLASTIES": "MAMMAPLASTY, the surgical reconstruction of the breast [n]\n",
  "MAMMAPLASTY": "the surgical reconstruction of the breast [n MAMMAPLASTIES]\n",
  "MAMMARIES": "MAMMARY, a breast [n]\n",
  "MAMMARY": "a breast [n MAMMARIES]\n",
  "MAMMAS": "MAMMA, (Latin) the milk gland, the breast [n]\n",
  "MAMMATE": "having mammae, breasts [adj]\n",
  "MAMMATI": "MAMMATUS, (Latin) a type of cloud [n]\n",
  "MAMMATUS": "(Latin) a type of cloud [n MAMMATI]\n",
  "MAMMECTOMIES": "MAMMECTOMY, the surgical removal of a nipple [n]\n",
  "MAMMECTOMY": "the surgical removal of a nipple [n MAMMECTOMIES]\n",
  "MAMMEE": "a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMEY, MAMIE, MAMMEY [n -S]\n",
  "MAMMEES": "MAMMEE, a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMEY, MAMIE, MAMMEY [n]\n",
  "MAMMER": "(Shakespeare) to hesitate, stand muttering [v -ED, -ING, -S]\n",
  "MAMMERED": "MAMMER, (Shakespeare) to hesitate, stand muttering [v]\n",
  "MAMMERING": "MAMMER, (Shakespeare) to hesitate, stand muttering [v]\n",
  "MAMMERS": "MAMMER, (Shakespeare) to hesitate, stand muttering [v]\n",
  "MAMMET": "a puppet; a doll, also MAUMET, MAWMET, MOMMET [n -S]\n",
  "MAMMETRIES": "MAMMETRY, idolatry, also MAWMETRY [n]\n",
  "MAMMETRY": "idolatry, also MAWMETRY [n MAMMETRIES]\n",
  "MAMMETS": "MAMMET, a puppet; a doll, also MAUMET, MAWMET, MOMMET [n]\n",
  "MAMMEY": "a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMEY, MAMIE, MAMMEE [n -S]\n",
  "MAMMEYS": "MAMMEY, a tropical plant having an edible fruit with bright yellow pulp, also MAMEE, MAMEY, MAMIE, MAMMEE [n]\n",
  "MAMMIE": "a child's name for mother, also MAMA, MAMMA, MAMMY [n -S]\n",
  "MAMMIES": "MAMMY, a child's name for mother, also MAMA, MAMMA, MAMMIE [n]\n",
  "MAMMIFER": "a mammal [n -S]\n",
  "MAMMIFEROUS": "having breasts [adj]\n",
  "MAMMIFERS": "MAMMIFER, a mammal [n]\n",
  "MAMMIFORM": "shaped like a breast [adj]\n",
  "MAMMILLA": "(Latin) the nipple of the mammary gland, also MAMILLA [n MAMMILLAE]\n",
  "MAMMILLAE": "MAMMILLA, (Latin) the nipple of the mammary gland, also MAMILLA [n]\n",
  "MAMMILLAR": "resembling a breast or nipple [adj]\n",
  "MAMMILLARIA": "a plant belonging to the Mammillaria genus of flowering cactus, with nipple-shaped tubercles in rows [n -S]\n",
  "MAMMILLARIAS": "MAMMILLARIA, a plant belonging to the Mammillaria genus of flowering cactus, with nipple-shaped tubercles in rows [n]\n",
  "MAMMILLARY": "of or pertaining to the mammilla, or nipple [adj]\n",
  "MAMMILLATE": "with nipple-like projections, also MAMILLATE, MAMMILLATED [adj]\n",
  "MAMMILLATED": "with nipple-like projections, also MAMILLATE, MAMMILLATE [adj]\n",
  "MAMMILLATION": "a nipple-like protrusion, also MAMILLATION [n -S]\n",
  "MAMMILLATIONS": "MAMMILLATION, a nipple-like protrusion, also MAMILLATION [n]\n",
  "MAMMILLIFORM": "in the form of a nipple, also MAMILLIFORM [adj]\n",
  "MAMMITIDES": "MAMMITIS, inflammation of the breast [n]\n",
  "MAMMITIS": "inflammation of the breast [n MAMMITIDES]\n",
  "MAMMOCK": "(Shakespeare) to tear something to shreds, also MUMMOCK [v -ED, -ING, -S]\n",
  "MAMMOCKED": "MAMMOCK, (Shakespeare) to tear something to shreds, also MUMMOCK [v]\n",
  "MAMMOCKING": "MAMMOCK, (Shakespeare) to tear something to shreds, also MUMMOCK [v]\n",
  "MAMMOCKS": "MAMMOCK, (Shakespeare) to tear something to shreds, also MUMMOCK [v]\n",
  "MAMMOGENIC": "promoting the growth of the milk glands [adj]\n",
  "MAMMOGRAM": "an X-ray of the breast [n -S]\n",
  "MAMMOGRAMS": "MAMMOGRAM, an X-ray of the breast [n]\n",
  "MAMMOGRAPH": "an X-ray of the breast [n -S]\n",
  "MAMMOGRAPHIC": "relating to mammography [adj]\n",
  "MAMMOGRAPHIES": "MAMMOGRAPHY, an X-ray of the breast [n]\n",
  "MAMMOGRAPHS": "MAMMOGRAPH, an X-ray of the breast [n]\n",
  "MAMMOGRAPHY": "an X-ray of the breast [n MAMMOGRAPHIES]\n",
  "MAMMON": "riches regarded as the root of evil [n -S]\n",
  "MAMMONISH": "actuated or prompted by a devotion to money getting or the service of Mammon [adj]\n",
  "MAMMONISM": "the greedy pursuit of riches [n -S]\n",
  "MAMMONISMS": "MAMMONISM, the greedy pursuit of riches [n]\n",
  "MAMMONIST": "one devoted to the acquisition of wealth or the service of Mammon, also MAMMONITE [n -S]\n",
  "MAMMONISTIC": "devoted to riches [adj]\n",
  "MAMMONISTS": "MAMMONIST, one devoted to the acquisition of wealth or the service of Mammon, also MAMMONITE [n]\n",
  "MAMMONITE": "one devoted to the acquisition of wealth or the service of Mammon, also MAMMONIST [n -S]\n",
  "MAMMONITES": "MAMMONITE, one devoted to the acquisition of wealth or the service of Mammon, also MAMMONIST [n]\n",
  "MAMMONS": "MAMMON, riches regarded as the root of evil [n]\n",
  "MAMMOPLASTIES": "MAMMOPLASTY, plastic surgery to change the shape of the breasts, as by the use of silicone implants, etc., also MAMMAPLASTY [n]\n",
  "MAMMOPLASTY": "plastic surgery to change the shape of the breasts, as by the use of silicone implants, etc., also MAMMAPLASTY [n MAMMOPLASTIES]\n",
  "MAMMOTH": "(Russian) an extinct elephant [n -S]\n",
  "MAMMOTHS": "MAMMOTH, (Russian) an extinct elephant [n]\n",
  "MAMMY": "a child's name for mother, also MAMA, MAMMA, MAMMIE [n MAMMIES]\n",
  "MAMPARA": "(South African) a fool, idiot [n -S]\n",
  "MAMPARAS": "MAMPARA, (South African) a fool, idiot [n]\n",
  "MAMPOER": "(South African) homemade distilled brandy made from peaches, prickly pear etc. [n -S]\n",
  "MAMPOERS": "MAMPOER, (South African) homemade distilled brandy made from peaches, prickly pear etc. [n]\n",
  "MAMS": "MAM, (dialect) mother [n]\n",
  "MAMSELLE": "(French) a form of address for a woman teacher [n -S]\n",
  "MAMSELLES": "MAMSELLE, (French) a form of address for a woman teacher [n]\n",
  "MAMZER": "(Yiddish) an illegitimate child; a despicable person, also MOMSER, MOMZER [n MAMZERIM or MAMZERS]\n",
  "MAMZERIM": "MAMZER, (Yiddish) an illegitimate child; a despicable person, also MOMSER, MOMZER [n]\n",
  "MAMZERS": "MAMZER, (Yiddish) an illegitimate child; a despicable person, also MOMSER, MOMZER [n]\n",
  "MAN": "an adult human male [n MEN] / to provide with workers [v MANNED or (Spenser) MAND, MANNING, MANS]\n",
  "MANA": "(Maori) a supernatural force in certain Pacific island religions [n -S]\n",
  "MANACLE": "to handcuff [v MANACLED, MANACLING, MANACLES]\n",
  "MANACLED": "MANACLE, to handcuff [v]\n",
  "MANACLES": "MANACLE, to handcuff [v]\n",
  "MANACLING": "MANACLE, to handcuff [v]\n",
  "MANAGE": "to control or direct [v MANAGED, MANAGING, MANAGES]\n",
  "MANAGEABILITIES": "MANAGEABILITY, the state of being manageable [n]\n",
  "MANAGEABILITY": "the state of being manageable [n MANAGEABILITIES]\n",
  "MANAGEABLE": "that can be managed [adj MANAGEABLY]\n",
  "MANAGEABLENESS": "MANAGEABLE, that can be managed [n]\n",
  "MANAGEABLY": "MANAGEABLE, that can be managed [adv]\n",
  "MANAGED": "MANAGE, to control or direct [v]\n",
  "MANAGEMENT": "the act of managing [n -S]\n",
  "MANAGEMENTAL": "relating to management [adj]\n",
  "MANAGEMENTS": "MANAGEMENT, the act of managing [n]\n",
  "MANAGER": "one that manages [n -S]\n",
  "MANAGERESS": "a female manager [n -ES]\n",
  "MANAGERESSES": "MANAGERESS, a female manager [n]\n",
  "MANAGERIAL": "relating to a manager [adj MANAGERIALLY]\n",
  "MANAGERIALISM": "the adoption of business methods and management structures in the running of public services, etc. [n -S]\n",
  "MANAGERIALISMS": "MANAGERIALISM, the adoption of business methods and management structures in the running of public services, etc. [n]\n",
  "MANAGERIALIST": "a proponent of managerialism [n -S]\n",
  "MANAGERIALISTS": "MANAGERIALIST, a proponent of managerialism [n]\n",
  "MANAGERIALLY": "MANAGERIAL, relating to a manager [adv]\n",
  "MANAGERS": "MANAGER, one that manages [n]\n",
  "MANAGERSHIP": "the state of being a manager [n -S]\n",
  "MANAGERSHIPS": "MANAGERSHIP, the state of being a manager [n]\n",
  "MANAGES": "MANAGE, to control or direct [v]\n",
  "MANAGING": "MANAGE, to control or direct [v]\n",
  "MANAIA": "(Maori) a figure in Maori carving consisting of a human body and birdlike head [n -S]\n",
  "MANAIAS": "MANAIA, (Maori) a figure in Maori carving consisting of a human body and birdlike head [n]\n",
  "MANAKIN": "any of various small fruit-eating passerine birds of the tropical American family Pipridae [n -S]\n",
  "MANAKINS": "MANAKIN, any of various small fruit-eating passerine birds of the tropical American family Pipridae [n]\n",
  "MANANA": "(Spanish) tomorrow, at an unspecified time in the future [n -S]\n",
  "MANANAS": "MANANA, (Spanish) tomorrow, at an unspecified time in the future [n]\n",
  "MANAS": "MANA, (Maori) a supernatural force in certain Pacific island religions [n]\n",
  "MANAT": "a standard monetary unit of Azerbaijan, containing 100 GOPIK [n -S]\n",
  "MANATEE": "(Caribbean) a large aquatic mammal, also MANATI [n -S]\n",
  "MANATEES": "MANATEE, (Caribbean) a large aquatic mammal, also MANATI [n]\n",
  "MANATI": "(Caribbean) a large aquatic mammal, also MANATEE [n -S]\n",
  "MANATIS": "MANATI, (Caribbean) a large aquatic mammal, also MANATEE [n]\n",
  "MANATOID": "relating to a manatee [adj]\n",
  "MANATS": "MANAT, a standard monetary unit of Azerbaijan, containing 100 GOPIK [n]\n",
  "MANATU": "(Maori) a large flowering New Zealand deciduous shrub [n -S]\n",
  "MANATUS": "MANATU, (Maori) a large flowering New Zealand deciduous shrub [n]\n",
  "MANAWA": "(Maori) a mangrove [n -S]\n",
  "MANAWAS": "MANAWA, (Maori) a mangrove [n]\n",
  "MANBAG": "a bag for small articles carried by men [n -S]\n",
  "MANBAGS": "MANBAG, a bag for small articles carried by men [n]\n",
  "MANBAND": "an all-male vocal pop group which was formed as a boy band, but whose members have reached maturity [n -S]\n",
  "MANBANDS": "MANBAND, an all-male vocal pop group which was formed as a boy band, but whose members have reached maturity [n]\n",
  "MANCALA": "(Arabic) a variety of board games [n -S]\n",
  "MANCALAS": "MANCALA, (Arabic) a variety of board games [n]\n",
  "MANCANDO": "(Italian) fading away [adj]\n",
  "MANCHE": "(French) a sleeve [n -S]\n",
  "MANCHEGO": "(Spanish) a cheese made from ewes' milk [n -S]\n",
  "MANCHEGOS": "MANCHEGO, (Spanish) a cheese made from ewes' milk [n]\n",
  "MANCHES": "MANCHE, (French) a sleeve [n]\n",
  "MANCHESTER": "household linen or cotton goods, such as sheets and towels [n -S]\n",
  "MANCHESTERS": "MANCHESTER, household linen or cotton goods, such as sheets and towels [n]\n",
  "MANCHET": "in heraldry, a charge representing a loaf of manchet bread [n -S]\n",
  "MANCHETS": "MANCHET, in heraldry, a charge representing a loaf of manchet bread [n]\n",
  "MANCHINEEL": "(Spanish) a tropical tree with poisonous latex [n -S]\n",
  "MANCHINEELS": "MANCHINEEL, (Spanish) a tropical tree with poisonous latex [n]\n",
  "MANCIPATE": "to enslave [v MANCIPATED, MANCIPATING, MANCIPATES]\n",
  "MANCIPATED": "MANCIPATE, to enslave [v]\n",
  "MANCIPATES": "MANCIPATE, to enslave [v]\n",
  "MANCIPATING": "MANCIPATE, to enslave [v]\n",
  "MANCIPATION": "(historical) legal transfer by actual or symbolic sale [n -S]\n",
  "MANCIPATIONS": "MANCIPATION, (historical) legal transfer by actual or symbolic sale [n]\n",
  "MANCIPATORY": "relating to mancipation [adj]\n",
  "MANCIPLE": "the steward of a college or monastery; a purveyor [n -S]\n",
  "MANCIPLES": "MANCIPLE, the steward of a college or monastery; a purveyor [n]\n",
  "MANCUS": "(historical) an Anglo-Saxon monetary unit of the value of thirty pence [n -ES]\n",
  "MANCUSES": "MANCUS, (historical) an Anglo-Saxon monetary unit of the value of thirty pence [n]\n",
  "MAND": "(Spenser) manned [adj]\n",
  "MANDALA": "(Sanskrit) a pictorial symbol of the universe in Hindu or Buddhism [n -S]\n",
  "MANDALAS": "MANDALA, (Sanskrit) a pictorial symbol of the universe in Hindu or Buddhism [n]\n",
  "MANDALIC": "of or like a mandala, an Oriental design symbolic of the universe [adj]\n",
  "MANDAMUS": "(Latin) to command by writ from a higher court to a lower [v -ED, -ING, -ES]\n",
  "MANDAMUSED": "MANDAMUS, (Latin) to command by writ from a higher court to a lower [v]\n",
  "MANDAMUSES": "MANDAMUS, (Latin) to command by writ from a higher court to a lower [v]\n",
  "MANDAMUSING": "MANDAMUS, (Latin) to command by writ from a higher court to a lower [v]\n",
  "MANDARIN": "a member of one of nine ranks of public officials in the Chinese Empire [n -S]\n",
  "MANDARINATE": "the rank or office of a mandarin [n -S]\n",
  "MANDARINATES": "MANDARINATE, the rank or office of a mandarin [n]\n",
  "MANDARINE": "a small orange of Chinese origin [n -S]\n",
  "MANDARINES": "MANDARINE, a small orange of Chinese origin [n]\n",
  "MANDARINIC": "appropriate or peculiar to a mandarin [adj]\n",
  "MANDARINISM": "the state of being a mandarin [n -S]\n",
  "MANDARINISMS": "MANDARINISM, the state of being a mandarin [n]\n",
  "MANDARINS": "MANDARIN, a member of one of nine ranks of public officials in the Chinese Empire [n]\n",
  "MANDATARIES": "MANDATARY, the holder of a mandate, also MANDATORY [n]\n",
  "MANDATARY": "the holder of a mandate, also MANDATORY [n MANDATARIES]\n",
  "MANDATE": "an official instruction [n -S] / to issue with a mandate [v MANDATED, MANDATING, MANDATES]\n",
  "MANDATED": "MANDATE, to issue with a mandate [v]\n",
  "MANDATES": "MANDATE, to issue with a mandate [v]\n",
  "MANDATING": "MANDATE, to issue with a mandate [v]\n",
  "MANDATOR": "one who gives a mandate [n -S]\n",
  "MANDATORIES": "MANDATORY, the holder of a mandate [n]\n",
  "MANDATORILY": "MANDATORY, by mandate, also MANDATARY [adv]\n",
  "MANDATORS": "MANDATOR, one who gives a mandate [n]\n",
  "MANDATORY": "by mandate, also MANDATARY [adj MANDATORILY] / the holder of a mandate [n MANDATORIES]\n",
  "MANDI": "(Hindi) a big market [n -S]\n",
  "MANDIBLE": "the bone of the lower jaw [n -S]\n",
  "MANDIBLES": "MANDIBLE, the bone of the lower jaw [n]\n",
  "MANDIBULAR": "of or pertaining to a mandible [adj]\n",
  "MANDIBULATE": "shaped like a mandible [adj] / something shaped like a mandible, also MANDIBULATED [n -S]\n",
  "MANDIBULATED": "shaped like a mandible, also MANDIBULATE [adj]\n",
  "MANDIBULATES": "MANDIBULATE, something shaped like a mandible, also MANDIBULATED [n]\n",
  "MANDILION": "a loose outer garment worn over armour, also MANDYLION [n -S]\n",
  "MANDILIONS": "MANDILION, a loose outer garment worn over armour, also MANDYLION [n]\n",
  "MANDIOC": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOCA, MANDIOCCA, MANIHOC, MANIHOT, MANIOC, MANIOCA [n -S]\n",
  "MANDIOCA": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCCA, MANIHOC, MANIHOT, MANIOC, MANIOCA [n -S]\n",
  "MANDIOCAS": "MANDIOCA, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCCA, MANIHOC, MANIHOT, MANIOC, MANIOCA [n]\n",
  "MANDIOCCA": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANIHOC, MANIHOT, MANIOC, MANIOCA [n -S]\n",
  "MANDIOCCAS": "MANDIOCCA, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANIHOC, MANIHOT, MANIOC, MANIOCA [n]\n",
  "MANDIOCS": "MANDIOC, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOCA, MANDIOCCA, MANIHOC, MANIHOT, MANIOC, MANIOCA [n]\n",
  "MANDIR": "(Hindi) a Hindu temple, also MANDIRA [n -S]\n",
  "MANDIRA": "(Hindi) a Hindu temple, also MANDIR [n -S]\n",
  "MANDIRAS": "MANDIRA, (Hindi) a Hindu temple, also MANDIR [n]\n",
  "MANDIRS": "MANDIR, (Hindi) a Hindu temple, also MANDIRA [n]\n",
  "MANDIS": "MANDI, (Hindi) a big market [n]\n",
  "MANDOLA": "(Italian) an early type of mandolin, also MANDORA [n -S]\n",
  "MANDOLAS": "MANDOLA, (Italian) an early type of mandolin, also MANDORA [n]\n",
  "MANDOLIN": "a musical instrument of the lute kind, also MANDOLINE [n -S]\n",
  "MANDOLINE": "a musical instrument of the lute kind, also MANDOLIN [n -S]\n",
  "MANDOLINES": "MANDOLINE, a musical instrument of the lute kind, also MANDOLIN [n]\n",
  "MANDOLINIST": "one who plays the mandolin [n -S]\n",
  "MANDOLINISTS": "MANDOLINIST, one who plays the mandolin [n]\n",
  "MANDOLINS": "MANDOLIN, a musical instrument of the lute kind, also MANDOLINE [n]\n",
  "MANDOM": "man collectively [n -S]\n",
  "MANDOMS": "MANDOM, man collectively [n]\n",
  "MANDORA": "(Italian) an early type of mandolin, also MANDOLA [n -S]\n",
  "MANDORAS": "MANDORA, (Italian) an early type of mandolin, also MANDOLA [n]\n",
  "MANDORLA": "(Italian) any almond-shaped object or ornament, esp. (in painting, sculpture) area of light surrounding the risen Christ [n -S]\n",
  "MANDORLAS": "MANDORLA, (Italian) any almond-shaped object or ornament, esp. (in painting, sculpture) area of light surrounding the risen Christ [n]\n",
  "MANDRAGORA": "(Shakespeare) any of the various plants of the genus Mandragora, aka mandrake [n -S]\n",
  "MANDRAGORAS": "MANDRAGORA, (Shakespeare) any of the various plants of the genus Mandragora, aka mandrake [n]\n",
  "MANDRAKE": "a poisonous and narcotic Mediterranean plant of the nightshade family [n -S]\n",
  "MANDRAKES": "MANDRAKE, a poisonous and narcotic Mediterranean plant of the nightshade family [n]\n",
  "MANDREL": "a bar of iron fitted to a turning-lathe on which articles to be turned are fixed, also MANDRIL [n -S]\n",
  "MANDRELS": "MANDREL, a bar of iron fitted to a turning-lathe on which articles to be turned are fixed, also MANDRIL [n]\n",
  "MANDRIL": "a bar of iron fitted to a turning-lathe on which articles to be turned are fixed, also MANDREL [n -S]\n",
  "MANDRILL": "a large West African forest baboon, the adult of which has a bright red and blue face and blue buttocks [n -S]\n",
  "MANDRILLS": "MANDRILL, a large West African forest baboon, the adult of which has a bright red and blue face and blue buttocks [n]\n",
  "MANDRILS": "MANDRIL, a bar of iron fitted to a turning-lathe on which articles to be turned are fixed, also MANDREL [n]\n",
  "MANDUCABLE": "edible or soft enough to chew [adj]\n",
  "MANDUCATE": "to chew or eat [v MANDUCATED, MANDUCATING, MANDUCATES]\n",
  "MANDUCATED": "MANDUCATE, to chew or eat [v]\n",
  "MANDUCATES": "MANDUCATE, to chew or eat [v]\n",
  "MANDUCATING": "MANDUCATE, to chew or eat [v]\n",
  "MANDUCATION": "chewing [n -S]\n",
  "MANDUCATIONS": "MANDUCATION, chewing [n]\n",
  "MANDUCATORY": "relating to manducation [adj]\n",
  "MANDYLION": "a loose outer garment worn over armour, also MANDILION [n -S]\n",
  "MANDYLIONS": "MANDYLION, a loose outer garment worn over armour, also MANDILION [n]\n",
  "MANE": "the long hair that grows on the neck of some animals [n -S]\n",
  "MANEB": "a powder for killing fungi [n -S]\n",
  "MANEBS": "MANEB, a powder for killing fungi [n]\n",
  "MANED": "having a mane [adj]\n",
  "MANEGE": "(French) to train horses [v MANEGED, MANEGING, MANEGES]\n",
  "MANEGED": "MANEGE, (French) to train horses [v]\n",
  "MANEGES": "MANEGE, (French) to train horses [v]\n",
  "MANEGING": "MANEGE, (French) to train horses [v]\n",
  "MANEH": "(Hebrew) a unit of weight or money, equivalent to 100 drachmas [n -S]\n",
  "MANEHS": "MANEH, (Hebrew) a unit of weight or money, equivalent to 100 drachmas [n]\n",
  "MANELESS": "without a mane [adj]\n",
  "MANENT": "(Latin) a stage direction, they remain on stage [v]\n",
  "MANES": "MANE, the long hair that grows on the neck of some animals [n]\n",
  "MANET": "(Latin) a stage direction, he or she remains on stage [v]\n",
  "MANEUVER": "to conduct manoeuvres, also MANOEUVER, MANOEUVRE [v -ED, -ING, -S]\n",
  "MANEUVERABILITY": "the state of being maneuverable, also MANOEUVRABILITY [n]\n",
  "MANEUVERABLE": "capable of being maneuvered [adj]\n",
  "MANEUVERED": "MANEUVER, to conduct manoeuvres, also MANOEUVER, MANOEUVRE [v]\n",
  "MANEUVERER": "one who maneuvers, also MANOEUVRER [n -S]\n",
  "MANEUVERERS": "MANEUVERER, one who maneuvers, also MANOEUVRER [n]\n",
  "MANEUVERING": "the act of performing a maneuver [n -S]\n",
  "MANEUVERINGS": "MANEUVERING, the act of performing a maneuver [n]\n",
  "MANEUVERS": "MANEUVER, to conduct manoeuvres, also MANOEUVER, MANOEUVRE [v]\n",
  "MANFUL": "courageous [adj MANFULLER, MANFULLEST; MANFULLY]\n",
  "MANFULLER": "MANFUL, courageous [adj]\n",
  "MANFULLEST": "MANFUL, courageous [adj]\n",
  "MANFULLY": "MANFUL, courageous [adv]\n",
  "MANFULNESS": "the state of being manful [n -ES]\n",
  "MANFULNESSES": "MANFULNESS, the state of being manful [n]\n",
  "MANG": "(archaic) to speak or talk [v -ED, -ING, -S]\n",
  "MANGA": "(Japanese) an adult comic book [n -S]\n",
  "MANGABEIRA": "(Portuguese) a Brazilian apocynaceous rubber tree [n -S]\n",
  "MANGABEIRAS": "MANGABEIRA, (Portuguese) a Brazilian apocynaceous rubber tree [n]\n",
  "MANGABEY": "(Malagasy) a long-tailed African monkey, also MANGABY [n -S]\n",
  "MANGABEYS": "MANGABEY, (Malagasy) a long-tailed African monkey, also MANGABY [n]\n",
  "MANGABIES": "MANGABY, (Malagasy) a long-tailed African monkey, also MANGABEY [n]\n",
  "MANGABY": "(Malagasy) a long-tailed African monkey, also MANGABEY [n MANGABIES]\n",
  "MANGAL": "(Turkish) a brazier [n -S]\n",
  "MANGALS": "MANGAL, (Turkish) a brazier [n]\n",
  "MANGALSUTRA": "a bead necklace worn by a married Hindu woman whose husband is living [n -S]\n",
  "MANGALSUTRAS": "MANGALSUTRA, a bead necklace worn by a married Hindu woman whose husband is living [n]\n",
  "MANGANATE": "a salt of manganic acid [n -S]\n",
  "MANGANATES": "MANGANATE, a salt of manganic acid [n]\n",
  "MANGANESE": "a hard grey brittle chemical element, used in steels and magnetic alloys [n -S]\n",
  "MANGANESES": "MANGANESE, a hard grey brittle chemical element, used in steels and magnetic alloys [n]\n",
  "MANGANESIAN": "like manganese [adj]\n",
  "MANGANIC": "of manganese of higher valency, as in manganic acid [adj]\n",
  "MANGANIFEROUS": "bearing manganese [adj]\n",
  "MANGANIN": "an alloy of copper, manganese, and nickel [n -S]\n",
  "MANGANINS": "MANGANIN, an alloy of copper, manganese, and nickel [n]\n",
  "MANGANITE": "an oxide of manganese, occurring in brilliant steel-gray or iron-black crystals [n -S]\n",
  "MANGANITES": "MANGANITE, an oxide of manganese, occurring in brilliant steel-gray or iron-black crystals [n]\n",
  "MANGANOUS": "of manganese of lower valency [adj]\n",
  "MANGAS": "MANGA, (Japanese) an adult comic book [n]\n",
  "MANGE": "a skin disease of domestic animals [n -S]\n",
  "MANGEAO": "(Maori) a small New Zealand tree with glossy leaves [n -S]\n",
  "MANGEAOS": "MANGEAO, (Maori) a small New Zealand tree with glossy leaves [n]\n",
  "MANGED": "MANG, (archaic) to speak or talk [v]\n",
  "MANGEL": "a variety of beet, also MANGOLD [n -S]\n",
  "MANGELS": "MANGEL, a variety of beet, also MANGOLD [n]\n",
  "MANGELWURZEL": "a kind of root vegetable, also MANGOLDWURZEL [n -S]\n",
  "MANGELWURZELS": "MANGELWURZEL, a kind of root vegetable, also MANGOLDWURZEL [n]\n",
  "MANGEMANGE": "(Maori) a climbing fern of the North Island of New Zealand [n -S]\n",
  "MANGEMANGES": "MANGEMANGE, (Maori) a climbing fern of the North Island of New Zealand [n]\n",
  "MANGER": "a feeding trough for cattle [n -S]\n",
  "MANGERS": "MANGER, a feeding trough for cattle [n]\n",
  "MANGES": "MANGE, a skin disease of domestic animals [n]\n",
  "MANGETOUT": "(French) a type of pea cooked and eaten together with its pod [n -S]\n",
  "MANGETOUTS": "MANGETOUT, (French) a type of pea cooked and eaten together with its pod [n]\n",
  "MANGEY": "affected with mange, also MANGY [adj MANGIER, MANGIEST]\n",
  "MANGIER": "MANGEY, affected with mange, also MANGY [adj]\n",
  "MANGIEST": "MANGEY, affected with mange, also MANGY [adj]\n",
  "MANGILY": "MANGY, affected with mange, also MANGEY [adv]\n",
  "MANGINESS": "the state of being mangy [n -ES]\n",
  "MANGINESSES": "MANGINESS, the state of being mangy [n]\n",
  "MANGING": "MANG, (archaic) to speak or talk [v]\n",
  "MANGLE": "to hack, tear or crush [v MANGLED, MANGLING, MANGLES]\n",
  "MANGLED": "MANGLE, to hack, tear or crush [v]\n",
  "MANGLER": "one who mangles [n -S]\n",
  "MANGLERS": "MANGLER, one who mangles [n]\n",
  "MANGLES": "MANGLE, to hack, tear or crush [v]\n",
  "MANGLING": "MANGLE, to hack, tear or crush [v]\n",
  "MANGO": "a tropical tree of the cashew-nut family; its yellowish-red fleshy fruit [n -ES or -S]\n",
  "MANGOES": "MANGO, a tropical tree of the cashew-nut family; its yellowish-red fleshy fruit [n]\n",
  "MANGOLD": "a variety of beet, also MANGEL [n -S]\n",
  "MANGOLDS": "MANGOLD, a variety of beet, also MANGEL [n]\n",
  "MANGOLDWURZEL": "a mangelwurzel, also MANGELWURZEL [n -S]\n",
  "MANGOLDWURZELS": "MANGOLDWURZEL, a mangelwurzel, also MANGELWURZEL [n]\n",
  "MANGONEL": "(historical) a medieval war engine for throwing stones [n -S]\n",
  "MANGONELS": "MANGONEL, (historical) a medieval war engine for throwing stones [n]\n",
  "MANGOS": "MANGO, a tropical tree of the cashew-nut family; its yellowish-red fleshy fruit [n]\n",
  "MANGOSTAN": "(Malay) a tree of the East Indies, or its orange-shaped fruit, also MANGOSTEEN [n -S]\n",
  "MANGOSTANS": "MANGOSTAN, (Malay) a tree of the East Indies, or its orange-shaped fruit, also MANGOSTEEN [n]\n",
  "MANGOSTEEN": "(Malay) a tree of the East Indies, or its orange-shaped fruit, also MANGOSTAN [n -S]\n",
  "MANGOSTEENS": "MANGOSTEEN, (Malay) a tree of the East Indies, or its orange-shaped fruit, also MANGOSTAN [n]\n",
  "MANGOUSTE": "(French) a mongoose [n -S]\n",
  "MANGOUSTES": "MANGOUSTE, (French) a mongoose [n]\n",
  "MANGROVE": "any of various tropical trees or shrubs with interlacing aerial roots [n -S]\n",
  "MANGROVES": "MANGROVE, any of various tropical trees or shrubs with interlacing aerial roots [n]\n",
  "MANGS": "MANG, (archaic) to speak or talk [v]\n",
  "MANGULATE": "(Australian slang) to bend out of shape, mangle [v MANGULATED, MANGULATING, MANGULATES]\n",
  "MANGULATED": "MANGULATE, (Australian slang) to bend out of shape, mangle [v]\n",
  "MANGULATES": "MANGULATE, (Australian slang) to bend out of shape, mangle [v]\n",
  "MANGULATING": "MANGULATE, (Australian slang) to bend out of shape, mangle [v]\n",
  "MANGY": "affected with mange, also MANGEY [adj MANGIER, MANGIEST, MANGILY]\n",
  "MANHANDLE": "to move by manpower; to handle or treat roughly [v MANHANDLED, MANHANDLING, MANHANDLES]\n",
  "MANHANDLED": "MANHANDLE, to move by manpower; to handle or treat roughly [v]\n",
  "MANHANDLES": "MANHANDLE, to move by manpower; to handle or treat roughly [v]\n",
  "MANHANDLING": "MANHANDLE, to move by manpower; to handle or treat roughly [v]\n",
  "MANHATTAN": "a kind of cocktail [n -S]\n",
  "MANHATTANS": "MANHATTAN, a kind of cocktail [n]\n",
  "MANHOLE": "an opening large enough to admit a man for service [n -S]\n",
  "MANHOLES": "MANHOLE, an opening large enough to admit a man for service [n]\n",
  "MANHOOD": "the state of being a man [n -S]\n",
  "MANHOODS": "MANHOOD, the state of being a man [n]\n",
  "MANHUNT": "an intensive search for a person [n -S]\n",
  "MANHUNTER": "one who takes part in a manhunt [n -S]\n",
  "MANHUNTERS": "MANHUNTER, one who takes part in a manhunt [n]\n",
  "MANHUNTS": "MANHUNT, an intensive search for a person [n]\n",
  "MANI": "a stone prayer wall in a Tibetan Buddhist temple, usually carved with sacred images or texts [n -S]\n",
  "MANIA": "an excessive interest or enthusiasm [n -S]\n",
  "MANIAC": "an insane person [n -S]\n",
  "MANIACAL": "relating to a maniac [adj MANIACALLY]\n",
  "MANIACALLY": "MANIACAL, relating to a maniac [adv]\n",
  "MANIACS": "MANIAC, an insane person [n]\n",
  "MANIAS": "MANIA, an excessive interest or enthusiasm [n]\n",
  "MANIC": "affected by mania [adj MANICALLY] / someone affected by mania [n -S]\n",
  "MANICALLY": "MANIC, affected by mania [adv]\n",
  "MANICOTTI": "(Italian) tubular pasta shells stuffed with ricotta or a meat mixture [n -S]\n",
  "MANICOTTIS": "MANICOTTI, (Italian) tubular pasta shells stuffed with ricotta or a meat mixture [n]\n",
  "MANICS": "MANIC, someone affected by mania [n]\n",
  "MANICURE": "to have the hands and nails treated professionally [v MANICURED, MANICURING, MANICURES]\n",
  "MANICURED": "MANICURE, to have the hands and nails treated professionally [v]\n",
  "MANICURES": "MANICURE, to have the hands and nails treated professionally [v]\n",
  "MANICURING": "MANICURE, to have the hands and nails treated professionally [v]\n",
  "MANICURIST": "a person who gives manicures [n -S]\n",
  "MANICURISTS": "MANICURIST, a person who gives manicures [n]\n",
  "MANIES": "MANY, a great number [n]\n",
  "MANIFEST": "clear, obvious [adj MANIFESTLY] / to show clearly [v -ED, -ING, -S]\n",
  "MANIFESTABLE": "that can be manifested, also MANIFESTIBLE [adj]\n",
  "MANIFESTANT": "a person who makes or participates in a manifestation [n -S]\n",
  "MANIFESTANTS": "MANIFESTANT, a person who makes or participates in a manifestation [n]\n",
  "MANIFESTATION": "the act, process, or an instance of manifesting [n -S]\n",
  "MANIFESTATIONAL": "of or like a manifestation [adj]\n",
  "MANIFESTATIONS": "MANIFESTATION, the act, process, or an instance of manifesting [n]\n",
  "MANIFESTATIVE": "serving to manifest [adj]\n",
  "MANIFESTED": "MANIFEST, to show clearly [v]\n",
  "MANIFESTER": "one who makes manifest [n -S]\n",
  "MANIFESTERS": "MANIFESTER, one who makes manifest [n]\n",
  "MANIFESTIBLE": "that can be manifested, also MANIFESTABLE [adj]\n",
  "MANIFESTING": "MANIFEST, to show clearly [v]\n",
  "MANIFESTLY": "MANIFEST, clear, obvious [adv]\n",
  "MANIFESTNESS": "the state of being manifest [n -ES]\n",
  "MANIFESTNESSES": "MANIFESTNESS, the state of being manifest [n]\n",
  "MANIFESTO": "a written statement declaring publicly the intentions, motives, or views of its issuer [n -ES or -S] / to issue a manifesto [v -ED, -ING, -ES]\n",
  "MANIFESTOED": "MANIFESTO, to issue a manifesto [v]\n",
  "MANIFESTOES": "MANIFESTO, to issue a manifesto [v]\n",
  "MANIFESTOING": "MANIFESTO, to issue a manifesto [v]\n",
  "MANIFESTOS": "MANIFESTO, a written statement declaring publicly the intentions, motives, or views of its issuer [n]\n",
  "MANIFESTS": "MANIFEST, to show clearly [v]\n",
  "MANIFOLD": "many in number, also MANYFOLD [adj MANIFOLDLY] / to make many copies of [v -ED, -ING, -S]\n",
  "MANIFOLDED": "MANIFOLD, to make many copies of [v]\n",
  "MANIFOLDER": "one who makes manifolds [n -S]\n",
  "MANIFOLDERS": "MANIFOLDER, one who makes manifolds [n]\n",
  "MANIFOLDING": "MANIFOLD, to make many copies of [v]\n",
  "MANIFOLDLY": "MANIFOLD, many in number, also MANYFOLD [adv]\n",
  "MANIFOLDNESS": "the state of being manifold [n -ES]\n",
  "MANIFOLDNESSES": "MANIFOLDNESS, the state of being manifold [n]\n",
  "MANIFOLDS": "MANIFOLD, to make many copies of [v]\n",
  "MANIFORM": "having the form of a hand [adj]\n",
  "MANIHOC": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOT, MANIOC, MANIOCA [n -S]\n",
  "MANIHOCS": "MANIHOC, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOT, MANIOC, MANIOCA [n]\n",
  "MANIHOT": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOC, MANIOC, MANIOCA [n -S]\n",
  "MANIHOTS": "MANIHOT, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOC, MANIOC, MANIOCA [n]\n",
  "MANIKIN": "an anatomical model of the human body used for teaching purposes, also MANNEQUIN, MANNIKIN [n -S]\n",
  "MANIKINS": "MANIKIN, an anatomical model of the human body used for teaching purposes, also MANNEQUIN, MANNIKIN [n]\n",
  "MANILA": "a strong paper, also MANILLA [n -S]\n",
  "MANILAS": "MANILA, a strong paper, also MANILLA [n]\n",
  "MANILLA": "(Spanish) a horseshoe-shaped ring used esp. for ceremonial exchanges in parts of West Africa [n -S]\n",
  "MANILLAS": "MANILLA, (Spanish) a horseshoe-shaped ring used esp. for ceremonial exchanges in parts of West Africa [n]\n",
  "MANILLE": "(French) in the card games ombre and quadrille, the highest card but one [n -S]\n",
  "MANILLES": "MANILLE, (French) in the card games ombre and quadrille, the highest card but one [n]\n",
  "MANIOC": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOC, MANIHOT, MANIOCA [n -S]\n",
  "MANIOCA": "(Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOC, MANIHOT, MANIOC [n -S]\n",
  "MANIOCAS": "MANIOCA, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOC, MANIHOT, MANIOC [n]\n",
  "MANIOCS": "MANIOC, (Tupi) a plant of the manioc genus, aka cassava, also MANDIOC, MANDIOCA, MANDIOCCA, MANIHOC, MANIHOT, MANIOCA [n]\n",
  "MANIPLE": "(Latin) a subdivision of Roman legion consisting of two centuries of 60 to 120 men each [n -S]\n",
  "MANIPLES": "MANIPLE, (Latin) a subdivision of Roman legion consisting of two centuries of 60 to 120 men each [n]\n",
  "MANIPLIES": "the third stomach of a ruminant, aka omasum or psalterium, also MANYPLIES, MONIPLIES, MONYPLIES [n]\n",
  "MANIPULABILITY": "the state of being manipulable [n]\n",
  "MANIPULABLE": "that can be manipulated [adj]\n",
  "MANIPULAR": "a soldier of a maniple [n -S]\n",
  "MANIPULARS": "MANIPULAR, a soldier of a maniple [n]\n",
  "MANIPULATABLE": "capable of being manipulated [adj]\n",
  "MANIPULATE": "to work with the hands [v MANIPULATED, MANIPULATING, MANIPULATES]\n",
  "MANIPULATED": "MANIPULATE, to work with the hands [v]\n",
  "MANIPULATES": "MANIPULATE, to work with the hands [v]\n",
  "MANIPULATING": "MANIPULATE, to work with the hands [v]\n",
  "MANIPULATION": "the act of manipulating [n -S]\n",
  "MANIPULATIONS": "MANIPULATION, the act of manipulating [n]\n",
  "MANIPULATIVE": "relating to manipulation [adj MANIPULATIVELY] / one who engages in manipulation [n -S]\n",
  "MANIPULATIVELY": "MANIPULATIVE, relating to manipulation [adv]\n",
  "MANIPULATIVES": "MANIPULATIVE, one who engages in manipulation [n]\n",
  "MANIPULATOR": "one who manipulates [n -S]\n",
  "MANIPULATORS": "MANIPULATOR, one who manipulates [n]\n",
  "MANIPULATORY": "tending to manipulate [adj]\n",
  "MANIS": "another name for the pangolin [n -ES]\n",
  "MANISES": "MANIS, another name for the pangolin [n]\n",
  "MANITO": "(Native American) a name given by tribes of American Indians to a great spirit, whether good or evil, or to any object of worship, also MANITOU, MANITU [n -S]\n",
  "MANITOS": "MANITO, (Native American) a name given by tribes of American Indians to a great spirit, whether good or evil, or to any object of worship, also MANITOU, MANITU [n]\n",
  "MANITOU": "(Native American) a name given by tribes of American Indians to a great spirit, whether good or evil, or to any object of worship, also MANITO, MANITU [n -S]\n",
  "MANITOUS": "MANITOU, (Native American) a name given by tribes of American Indians to a great spirit, whether good or evil, or to any object of worship, also MANITO, MANITU [n]\n",
  "MANITU": "(Native American) a name given by tribes of American Indians to a great spirit, whether good or evil, or to any object of worship, also MANITO, MANITOU [n -S]\n",
  "MANITUS": "MANITU, (Native American) a name given by tribes of American Indians to a great spirit, whether good or evil, or to any object of worship, also MANITO, MANITOU [n]\n",
  "MANJACK": "a West Indian tree [n -S]\n",
  "MANJACKS": "MANJACK, a West Indian tree [n]\n",
  "MANKIER": "MANKY, (Scots) filthy, dirty, rotten [adj]\n",
  "MANKIEST": "MANKY, (Scots) filthy, dirty, rotten [adj]\n",
  "MANKIND": "the human race [n -S]\n",
  "MANKINDS": "MANKIND, the human race [n]\n",
  "MANKINI": "a man's swimming costume consisting of a narrow V-shaped piece of material extending from the crotch to the shoulders [n -S]\n",
  "MANKINIS": "MANKINI, a man's swimming costume consisting of a narrow V-shaped piece of material extending from the crotch to the shoulders [n]\n",
  "MANKY": "(Scots) filthy, dirty, rotten [adj MANKIER, MANKIEST]\n",
  "MANLESS": "without men [adj]\n",
  "MANLIER": "MANLY, having the qualities of a man [adj]\n",
  "MANLIEST": "MANLY, having the qualities of a man [adj]\n",
  "MANLIKE": "like a man [adj MANLIKELY]\n",
  "MANLIKELY": "MANLIKE, like a man [adv]\n",
  "MANLILY": "MANLY, having the qualities of a man [adv]\n",
  "MANLINESS": "the state of being manly [n -ES]\n",
  "MANLINESSES": "MANLINESS, the state of being manly [n]\n",
  "MANLY": "having the qualities of a man [adj MANLIER, MANLIEST, MANLILY]\n",
  "MANMADE": "made by man [adj]\n",
  "MANNA": "the food miraculously provided for the Israelites in the wilderness [n -S]\n",
  "MANNAN": "a type of sugar [n -S]\n",
  "MANNANS": "MANNAN, a type of sugar [n]\n",
  "MANNAS": "MANNA, the food miraculously provided for the Israelites in the wilderness [n]\n",
  "MANNED": "MAN, to provide with workers [v]\n",
  "MANNEQUIN": "a dummy for the display of clothes etc., also MANIKIN, MANNIKIN [n -S]\n",
  "MANNEQUINS": "MANNEQUIN, a dummy for the display of clothes etc., also MANIKIN, MANNIKIN [n]\n",
  "MANNER": "method, fashion or style [n -S]\n",
  "MANNERED": "having a certain manner [adj]\n",
  "MANNERISM": "a marked peculiarity or trick of style or manner [n -S]\n",
  "MANNERISMS": "MANNERISM, a marked peculiarity or trick of style or manner [n]\n",
  "MANNERIST": "one addicted to mannerism [n -S]\n",
  "MANNERISTIC": "relating to mannerism, also MANNERISTICAL [adj MANNERISTICALLY]\n",
  "MANNERISTICAL": "relating to mannerism, also MANNERISTIC [adj MANNERISTICALLY]\n",
  "MANNERISTICALLY": "MANNERISTICAL, relating to mannerism, also MANNERISTIC [adv]\n",
  "MANNERISTS": "MANNERIST, one addicted to mannerism [n]\n",
  "MANNERLESS": "without manners [adj]\n",
  "MANNERLESSNESS": "MANNERLESS, without manners [n]\n",
  "MANNERLIER": "MANNERLY, polite [adj]\n",
  "MANNERLIEST": "MANNERLY, polite [adj]\n",
  "MANNERLINESS": "the state of being mannerly [n -ES]\n",
  "MANNERLINESSES": "MANNERLINESS, the state of being mannerly [n]\n",
  "MANNERLY": "polite [adj MANNERLIER, MANNERLIEST]\n",
  "MANNERS": "MANNER, method, fashion or style [n]\n",
  "MANNIFEROUS": "bearing manna [adj]\n",
  "MANNIKIN": "an anatomical model of the human body used for teaching purposes, also MANIKIN, MANNEQUIN [n -S]\n",
  "MANNIKINS": "MANNIKIN, an anatomical model of the human body used for teaching purposes, also MANIKIN, MANNEQUIN [n]\n",
  "MANNING": "MAN, to provide with workers [v]\n",
  "MANNISH": "resembling or characteristic of a man [adj MANNISHLY]\n",
  "MANNISHLY": "MANNISH, resembling or characteristic of a man [adv]\n",
  "MANNISHNESS": "the state of being mannish [n -ES]\n",
  "MANNISHNESSES": "MANNISHNESS, the state of being mannish [n]\n",
  "MANNITE": "a sweet alcohol obtained from manna, also MANNITOL [n -S]\n",
  "MANNITES": "MANNITE, a sweet alcohol obtained from manna, also MANNITOL [n]\n",
  "MANNITIC": "pertaining to or derived from mannite, a sweet alcohol obtained from manna [adj]\n",
  "MANNITOL": "a sweet alcohol obtained from manna, also MANNITE [n -S]\n",
  "MANNITOLS": "MANNITOL, a sweet alcohol obtained from manna, also MANNITE [n]\n",
  "MANNOSE": "a sugar obtained by oxidising mannitol [n -S]\n",
  "MANNOSES": "MANNOSE, a sugar obtained by oxidising mannitol [n]\n",
  "MANO": "a stone roller used in Mexico etc. for grinding maize [n -S] / a kind of clam with a soft shell [n -ES]\n",
  "MANOAO": "(Maori) a shrub of the heath group, also MONOAO [n -S]\n",
  "MANOAOS": "MANOAO, (Maori) a shrub of the heath group, also MONOAO [n]\n",
  "MANOES": "MANO, a stone roller used in Mexico etc. for grinding maize [n]\n",
  "MANOEUVER": "to execute a contrived, complicated, and possibly deceptive plan or action, also MANEUVER, MANOEUVRE [v -ED, -ING, -S]\n",
  "MANOEUVERED": "MANOEUVER, to execute a contrived, complicated, and possibly deceptive plan or action, also MANEUVER, MANOEUVRE [v]\n",
  "MANOEUVERING": "MANOEUVER, to execute a contrived, complicated, and possibly deceptive plan or action, also MANEUVER, MANOEUVRE [v]\n",
  "MANOEUVERS": "MANOEUVER, to execute a contrived, complicated, and possibly deceptive plan or action, also MANEUVER, MANOEUVRE [v]\n",
  "MANOEUVRABILITY": "the quality of being manoeuvrable, also MANEUVERABILITY [n]\n",
  "MANOEUVRABLE": "able to be manoeuvred [adj]\n",
  "MANOEUVRE": "to conduct manoeuvres, also MANEUVER, MANOEUVER [v MANOEUVRED, MANOEUVRING, MANOEUVRES]\n",
  "MANOEUVRED": "MANOEUVRE, to conduct manoeuvres, also MANEUVER, MANOEUVER [v]\n",
  "MANOEUVRER": "one who manoeuvres, also MANEUVERER [n -S]\n",
  "MANOEUVRERS": "MANOEUVRER, one who manoeuvres, also MANEUVERER [n]\n",
  "MANOEUVRES": "MANOEUVRE, to conduct manoeuvres, also MANEUVER, MANOEUVER [v]\n",
  "MANOEUVRING": "the act of making a manoeuvre [n -S]\n",
  "MANOEUVRINGS": "MANOEUVRING, the act of making a manoeuvre [n]\n",
  "MANOMETER": "an instrument for measuring the pressure of a liquid or gas [n -S]\n",
  "MANOMETERS": "MANOMETER, an instrument for measuring the pressure of a liquid or gas [n]\n",
  "MANOMETRIC": "relating to manometry, the measurement of the pressure of fluids, also MANOMETRICAL [adj MANOMETRICALLY]\n",
  "MANOMETRICAL": "relating to manometry, the measurement of the pressure of fluids, also MANOMETRIC [adj MANOMETRICALLY]\n",
  "MANOMETRICALLY": "MANOMETRICAL, relating to manometry, the measurement of the pressure of fluids, also MANOMETRIC [adv]\n",
  "MANOMETRIES": "MANOMETRY, the measurement of the pressure of fluids [n]\n",
  "MANOMETRY": "the measurement of the pressure of fluids [n MANOMETRIES]\n",
  "MANOR": "the manor house of a lord and the lands attached to it [n -S]\n",
  "MANORIAL": "relating to a manor [adj]\n",
  "MANORIALISM": "the system of having manors [n -S]\n",
  "MANORIALISMS": "MANORIALISM, the system of having manors [n]\n",
  "MANORS": "MANOR, the manor house of a lord and the lands attached to it [n]\n",
  "MANOS": "MANO, a stone roller used in Mexico etc. for grinding maize [n]\n",
  "MANOSCOPIES": "MANOSCOPY, the measurement of the density of gases [n]\n",
  "MANOSCOPY": "the measurement of the density of gases [n MANOSCOPIES]\n",
  "MANPACK": "a pack designed to be carrier by one person [n -S]\n",
  "MANPACKS": "MANPACK, a pack designed to be carrier by one person [n]\n",
  "MANPOWER": "available resources of able-bodied people [n -S]\n",
  "MANPOWERS": "MANPOWER, available resources of able-bodied people [n]\n",
  "MANQUE": "(French) the section on a roulette table which includes the numbers 1 to 18 or a bet placed in this area [n -S]\n",
  "MANQUES": "MANQUE, (French) the section on a roulette table which includes the numbers 1 to 18 or a bet placed in this area [n]\n",
  "MANRED": "(obsolete) homage or service rendered to a superior, as to a lord, also MANRENT [n -S]\n",
  "MANREDS": "MANRED, (obsolete) homage or service rendered to a superior, as to a lord, also MANRENT [n]\n",
  "MANRENT": "(Scots) homage or service rendered to a superior, as to a lord, also MANRED [n -S]\n",
  "MANRENTS": "MANRENT, (Scots) homage or service rendered to a superior, as to a lord, also MANRED [n]\n",
  "MANRIDER": "a paddy train [n -S]\n",
  "MANRIDERS": "MANRIDER, a paddy train [n]\n",
  "MANRIDING": "used of equipment on oil rigs that is for use of personnel rather than for carrying material [adj]\n",
  "MANRIKIGUSARI": "(Japanese) a Japanese chain weapon with weighted ends [n -S]\n",
  "MANRIKIGUSARIS": "MANRIKIGUSARI, (Japanese) a Japanese chain weapon with weighted ends [n]\n",
  "MANROPE": "a rope used as a handrail on a ship [n -S]\n",
  "MANROPES": "MANROPE, a rope used as a handrail on a ship [n]\n",
  "MANS": "MAN, to provide with workers [v]\n",
  "MANSARD": "(French) a type of roof [n -S]\n",
  "MANSARDED": "having a mansard, a hipped curb roof [adj]\n",
  "MANSARDS": "MANSARD, (French) a type of roof [n]\n",
  "MANSCAPE": "to trim or remove a man's body hair to enhance appearance [v MANSCAPED, MANSCAPING, MANSCAPES]\n",
  "MANSCAPED": "MANSCAPE, to trim or remove a man's body hair to enhance appearance [v]\n",
  "MANSCAPES": "MANSCAPE, to trim or remove a man's body hair to enhance appearance [v]\n",
  "MANSCAPING": "the act of trimming or removing a man's body hair to enhance appearance [n -S]\n",
  "MANSCAPINGS": "MANSCAPING, the act of trimming or removing a man's body hair to enhance appearance [n]\n",
  "MANSE": "a house allocated to or occupied by a minister, esp. in the Church of Scotland [n -S]\n",
  "MANSERVANT": "a male servant [n MENSERVANTS]\n",
  "MANSES": "MANSE, a house allocated to or occupied by a minister, esp. in the Church of Scotland [n]\n",
  "MANSHIFT": "the work done by one person in one shift [n -S]\n",
  "MANSHIFTS": "MANSHIFT, the work done by one person in one shift [n]\n",
  "MANSION": "a large impressive house [n -S]\n",
  "MANSIONARIES": "MANSIONARY, residence, buildings, also MANSONRY [n]\n",
  "MANSIONARY": "residence, buildings, also MANSONRY [n MANSIONARIES]\n",
  "MANSIONS": "MANSION, a large impressive house [n]\n",
  "MANSLAUGHTER": "the unlawful killing of a human being without express or implied malice [n -S]\n",
  "MANSLAUGHTERS": "MANSLAUGHTER, the unlawful killing of a human being without express or implied malice [n]\n",
  "MANSLAYER": "a person who kills a man [n -S]\n",
  "MANSLAYERS": "MANSLAYER, a person who kills a man [n]\n",
  "MANSONRIES": "MANSONRY, (Shakespeare) residence, buildings, also MANSIONARY [n]\n",
  "MANSONRY": "(Shakespeare) residence, buildings, also MANSIONARY [n MANSONRIES]\n",
  "MANSPLAIN": "(of a man) to explain (something) to a woman in a patronizing or condescending way [v -ED, -ING, -S]\n",
  "MANSPLAINED": "MANSPLAIN, (of a man) to explain (something) to a woman in a patronizing or condescending way [v]\n",
  "MANSPLAINING": "the act of explaining (something) to a woman in a patronizing or condescending way [n -S]\n",
  "MANSPLAININGS": "MANSPLAINING, the act of explaining (something) to a woman in a patronizing or condescending way [n]\n",
  "MANSPLAINS": "MANSPLAIN, (of a man) to explain (something) to a woman in a patronizing or condescending way [v]\n",
  "MANSPREAD": "of a man, to sit with the legs spread wide apart (as in a public seating area) in a way that intrudes on the space of others [v MANSPREAD, MANSPREADING, MANSPREADS]\n",
  "MANSPREADING": "the practice by a male passenger on public transport of sitting with his legs wide apart, so denying space to passengers beside him [n -S]\n",
  "MANSPREADINGS": "MANSPREADING, the practice by a male passenger on public transport of sitting with his legs wide apart, so denying space to passengers beside him [n]\n",
  "MANSPREADS": "MANSPREAD, of a man, to sit with the legs spread wide apart (as in a public seating area) in a way that intrudes on the space of others [v]\n",
  "MANSUETE": "(archaic) tame, gentle [adj]\n",
  "MANSUETUDE": "the state of being gentle, meekness, tameness [n -S]\n",
  "MANSUETUDES": "MANSUETUDE, the state of being gentle, meekness, tameness [n]\n",
  "MANSWORN": "(archaic) a perjurer [n -S]\n",
  "MANSWORNS": "MANSWORN, (archaic) a perjurer [n]\n",
  "MANTA": "(Spanish) a rough-textured cotton fabric [n -S]\n",
  "MANTAS": "MANTA, (Spanish) a rough-textured cotton fabric [n]\n",
  "MANTEAU": "(French) a woman's loose gown, also MANTO, MANTUA, MANTY [n MANTEAUS or MANTEAUX]\n",
  "MANTEAUS": "MANTEAU, (French) a woman's loose gown, also MANTO, MANTUA, MANTY [n]\n",
  "MANTEAUX": "MANTEAU, (French) a woman's loose gown, also MANTO, MANTUA, MANTY [n]\n",
  "MANTEEL": "(obsolete) a soldier's cloak; a lady's cape [n -S]\n",
  "MANTEELS": "MANTEEL, (obsolete) a soldier's cloak; a lady's cape [n]\n",
  "MANTEL": "the ornamental structure over and in front of a fireplace [n -S]\n",
  "MANTELET": "a mobile screen used to protect soldiers, also MANTLET [n -S]\n",
  "MANTELETS": "MANTELET, a mobile screen used to protect soldiers, also MANTLET [n]\n",
  "MANTELLETTA": "a sleeveless knee-length vestment, worn by cardinals, bishops, etc. [n -S]\n",
  "MANTELLETTAS": "MANTELLETTA, a sleeveless knee-length vestment, worn by cardinals, bishops, etc. [n]\n",
  "MANTELPIECE": "a mantel with its side elements [n -S]\n",
  "MANTELPIECES": "MANTELPIECE, a mantel with its side elements [n]\n",
  "MANTELS": "MANTEL, the ornamental structure over and in front of a fireplace [n]\n",
  "MANTELSHELF": "the ornamental shelf over a fireplace [n MANTELSHELVES]\n",
  "MANTELSHELVES": "MANTELSHELF, the ornamental shelf over a fireplace [n]\n",
  "MANTELTREE": "the lintel of a fireplace when of wood, as frequently in early houses, also MANTLETREE [n -S]\n",
  "MANTELTREES": "MANTELTREE, the lintel of a fireplace when of wood, as frequently in early houses, also MANTLETREE [n]\n",
  "MANTES": "MANTIS, a predatory insect, also MANTID [n]\n",
  "MANTIC": "(Greek) having powers of prophecy [adj MANTICALLY]\n",
  "MANTICALLY": "MANTIC, (Greek) having powers of prophecy [adv]\n",
  "MANTICORA": "a mythical monster with head of man, body of lion, tail of dragon or scorpion, also MANTICORE [n -S]\n",
  "MANTICORAS": "MANTICORA, a mythical monster with head of man, body of lion, tail of dragon or scorpion, also MANTICORE [n]\n",
  "MANTICORE": "a mythical monster with head of man, body of lion, tail of dragon or scorpion, also MANTICORA [n -S]\n",
  "MANTICORES": "MANTICORE, a mythical monster with head of man, body of lion, tail of dragon or scorpion, also MANTICORA [n]\n",
  "MANTID": "a predatory insect, also MANTIS [n -S]\n",
  "MANTIDS": "MANTID, a predatory insect, also MANTIS [n]\n",
  "MANTIES": "MANTY, (Scots) a woman's loose outer gown, also MANTEAU, MANTO, MANTUA [n]\n",
  "MANTILLA": "(Spanish) a veil covering the head and shoulders [n -S]\n",
  "MANTILLAS": "MANTILLA, (Spanish) a veil covering the head and shoulders [n]\n",
  "MANTIS": "a predatory insect, also MANTID [n MANTISES or MANTES]\n",
  "MANTISES": "MANTIS, a predatory insect, also MANTID [n]\n",
  "MANTISSA": "(Latin) the decimal part of a logarithm [n -S]\n",
  "MANTISSAS": "MANTISSA, (Latin) the decimal part of a logarithm [n]\n",
  "MANTLE": "to cover as with a cloak [v MANTLED, MANTLING, MANTLES]\n",
  "MANTLED": "MANTLE, to cover as with a cloak [v]\n",
  "MANTLES": "MANTLE, to cover as with a cloak [v]\n",
  "MANTLET": "a mobile screen used to protect soldiers, also MANTELET [n -S]\n",
  "MANTLETREE": "a beam made of stone or wood that forms the lintel over a fireplace, also MANTELTREE [n -S]\n",
  "MANTLETREES": "MANTLETREE, a beam made of stone or wood that forms the lintel over a fireplace, also MANTELTREE [n]\n",
  "MANTLETS": "MANTLET, a mobile screen used to protect soldiers, also MANTELET [n]\n",
  "MANTLING": "the drapery of a coat-of-arms [n -S]\n",
  "MANTLINGS": "MANTLING, the drapery of a coat-of-arms [n]\n",
  "MANTO": "(historical) a woman's loose gown, also MANTEAU, MANTUA, MANTY [n MANTOES or MANTOS]\n",
  "MANTOES": "MANTO, (historical) a woman's loose gown, also MANTEAU, MANTUA, MANTY [n]\n",
  "MANTOS": "MANTO, (historical) a woman's loose gown, also MANTEAU, MANTUA, MANTY [n]\n",
  "MANTRA": "(Sanskrit) a sacred word or syllable, also MANTRAM [n -S]\n",
  "MANTRAM": "(Sanskrit) a sacred word or syllable, also MANTRA [n -S]\n",
  "MANTRAMS": "MANTRAM, (Sanskrit) a sacred word or syllable, also MANTRA [n]\n",
  "MANTRAP": "a trap for catching men [n -S]\n",
  "MANTRAPS": "MANTRAP, a trap for catching men [n]\n",
  "MANTRAS": "MANTRA, (Sanskrit) a sacred word or syllable, also MANTRAM [n]\n",
  "MANTRIC": "relating to a mantra [adj]\n",
  "MANTUA": "(Italian) a woman's loose outer gown, also MANTEAU, MANTO, MANTY [n -S]\n",
  "MANTUAS": "MANTUA, (Italian) a woman's loose outer gown, also MANTEAU, MANTO, MANTY [n]\n",
  "MANTY": "(Scots) a woman's loose outer gown, also MANTEAU, MANTO, MANTUA [n MANTIES]\n",
  "MANTYHOSE": "a one-piece clinging garment covering the body from the waist to the feet, worn by men [n -S]\n",
  "MANTYHOSES": "MANTYHOSE, a one-piece clinging garment covering the body from the waist to the feet, worn by men [n]\n",
  "MANUAL": "by use of the hands [adj MANUALLY] / a small reference book [n -S]\n",
  "MANUALLY": "MANUAL, by use of the hands [adv]\n",
  "MANUALS": "MANUAL, a small reference book [n]\n",
  "MANUARY": "involving the hands [adj]\n",
  "MANUBRIA": "MANUBRIUM, (Latin) any handle-like structure [n]\n",
  "MANUBRIAL": "shaped like a handle [adj]\n",
  "MANUBRIUM": "(Latin) any handle-like structure [n MANUBRIUMS or MANUBRIA]\n",
  "MANUBRIUMS": "MANUBRIUM, (Latin) any handle-like structure [n]\n",
  "MANUCODE": "(Javanese) a bird of Paradise [n -S]\n",
  "MANUCODES": "MANUCODE, (Javanese) a bird of Paradise [n]\n",
  "MANUFACTORIES": "MANUFACTORY, a place where something is made [n]\n",
  "MANUFACTORY": "a place where something is made [n MANUFACTORIES]\n",
  "MANUFACTURABLE": "that can be manufactured [adj]\n",
  "MANUFACTURAL": "relating to manufacture [adj]\n",
  "MANUFACTURE": "to make into a product suitable for use [v MANUFACTURED, MANUFACTURING, MANUFACTURES]\n",
  "MANUFACTURED": "MANUFACTURE, to make into a product suitable for use [v]\n",
  "MANUFACTURER": "one that manufactures [n -S]\n",
  "MANUFACTURERS": "MANUFACTURER, one that manufactures [n]\n",
  "MANUFACTURES": "MANUFACTURE, to make into a product suitable for use [v]\n",
  "MANUFACTURING": "the manufacturing section of industry [n -S]\n",
  "MANUFACTURINGS": "MANUFACTURING, the manufacturing section of industry [n]\n",
  "MANUHIRI": "(Maori) a non-Maori seen as a guest to a marae [n -S]\n",
  "MANUHIRIS": "MANUHIRI, (Maori) a non-Maori seen as a guest to a marae [n]\n",
  "MANUKA": "(Maori) an Australian and New Zealand tree of the myrtle family, with aromatic leaves used as a substitute for tea [n -S]\n",
  "MANUKAS": "MANUKA, (Maori) an Australian and New Zealand tree of the myrtle family, with aromatic leaves used as a substitute for tea [n]\n",
  "MANUL": "(Mongolian) a kind of Central Asian wild cat [n -S]\n",
  "MANULS": "MANUL, (Mongolian) a kind of Central Asian wild cat [n]\n",
  "MANUMATIC": "relating to an automatic car transmission that enables the driver to shift through the gears [adj]\n",
  "MANUMEA": "(Samoan) a pigeon with a notched lower mandible [n -S]\n",
  "MANUMEAS": "MANUMEA, (Samoan) a pigeon with a notched lower mandible [n]\n",
  "MANUMISSION": "the act of manumitting; freeing from slavery [n -S]\n",
  "MANUMISSIONS": "MANUMISSION, the act of manumitting; freeing from slavery [n]\n",
  "MANUMIT": "to free from slavery [v MANUMITTED, MANUMITTING, MANUMITS]\n",
  "MANUMITS": "MANUMIT, to free from slavery [v]\n",
  "MANUMITTED": "MANUMIT, to free from slavery [v]\n",
  "MANUMITTER": "one who manumits, releases from slavery [n -S]\n",
  "MANUMITTERS": "MANUMITTER, one who manumits, releases from slavery [n]\n",
  "MANUMITTING": "MANUMIT, to free from slavery [v]\n",
  "MANURANCE": "(archaic) cultivation [n -S]\n",
  "MANURANCES": "MANURANCE, (archaic) cultivation [n]\n",
  "MANURE": "animal excrement [n -S] / to fertilize with manure [v MANURED, MANURING, MANURES]\n",
  "MANURED": "MANURE, to fertilize with manure [v]\n",
  "MANURER": "one who manures [n -S]\n",
  "MANURERS": "MANURER, one who manures [n]\n",
  "MANURES": "MANURE, to fertilize with manure [v]\n",
  "MANURIAL": "pertaining to manure [adj]\n",
  "MANURING": "the act of fertilizing [n -S]\n",
  "MANURINGS": "MANURING, the act of fertilizing [n]\n",
  "MANUS": "(Latin) the end of the forelimb in vertebrates [n MANUS]\n",
  "MANUSCRIPT": "a written or typewritten composition or document as distinguished from a printed copy [n -S]\n",
  "MANUSCRIPTS": "MANUSCRIPT, a written or typewritten composition or document as distinguished from a printed copy [n]\n",
  "MANWARD": "towards man, also MANWARDS [adv]\n",
  "MANWARDS": "towards man, also MANWARD [adv]\n",
  "MANWISE": "in a manner characteristic of man [adv]\n",
  "MANY": "a great number [n MANIES] / consisting of a great number [adj MORE, MOST]\n",
  "MANYATA": "a small Masai settlement, also MANYATTA [n -S]\n",
  "MANYATAS": "MANYATA, a small Masai settlement, also MANYATTA [n]\n",
  "MANYATTA": "a small Masai settlement, also MANYATA [n -S]\n",
  "MANYATTAS": "MANYATTA, a small Masai settlement, also MANYATA [n]\n",
  "MANYFOLD": "many in number, also MANIFOLD [adj]\n",
  "MANYPLIES": "the third stomach of a ruminant, aka omasum or psalterium, also MANIPLIES, MONIPLIES, MONYPLIES [n]\n",
  "MANZANILLA": "(Spanish) a very dry, light sherry [n -S]\n",
  "MANZANILLAS": "MANZANILLA, (Spanish) a very dry, light sherry [n]\n",
  "MANZANITA": "(Spanish) a Californian shrub with reddish smooth bark and bearing clusters of red berries [n -S]\n",
  "MANZANITAS": "MANZANITA, (Spanish) a Californian shrub with reddish smooth bark and bearing clusters of red berries [n]\n",
  "MANZELLO": "a musical instrument like the soprano saxophone [n -S]\n",
  "MANZELLOS": "MANZELLO, a musical instrument like the soprano saxophone [n]\n",
  "MAOMAO": "(Maori) a New Zealand fish [n -S]\n",
  "MAOMAOS": "MAOMAO, (Maori) a New Zealand fish [n]\n",
  "MAORMOR": "(Irish) a high-ranking or chief steward, also MORMAOR [n -S]\n",
  "MAORMORS": "MAORMOR, (Irish) a high-ranking or chief steward, also MORMAOR [n]\n",
  "MAP": "to plan a layout of [v MAPPED, MAPPING, MAPS]\n",
  "MAPAU": "(Maori) a small New Zealand tree with reddish bark [n -S]\n",
  "MAPAUS": "MAPAU, (Maori) a small New Zealand tree with reddish bark [n]\n",
  "MAPLE": "a hardwood tree [n -S]\n",
  "MAPLELIKE": "like a maple [adj]\n",
  "MAPLES": "MAPLE, a hardwood tree [n]\n",
  "MAPLESS": "having no map [adj]\n",
  "MAPLIKE": "resembling a map [adj]\n",
  "MAPMAKER": "one who makes maps [n -S]\n",
  "MAPMAKERS": "MAPMAKER, one who makes maps [n]\n",
  "MAPMAKING": "the process of making maps [n -S]\n",
  "MAPMAKINGS": "MAPMAKING, the process of making maps [n]\n",
  "MAPPABLE": "able to be mapped [adj]\n",
  "MAPPED": "MAP, to plan a layout of [v]\n",
  "MAPPEMOND": "a map of the world [n -S]\n",
  "MAPPEMONDS": "MAPPEMOND, a map of the world [n]\n",
  "MAPPER": "one who maps, a mapmaker [n -S]\n",
  "MAPPERIES": "MAPPERY, (Shakespeare) the making, or study, of maps [n]\n",
  "MAPPERS": "MAPPER, one who maps, a mapmaker [n]\n",
  "MAPPERY": "(Shakespeare) the making, or study, of maps [n MAPPERIES]\n",
  "MAPPING": "a mathematical correspondence [n -S]\n",
  "MAPPINGS": "MAPPING, a mathematical correspondence [n]\n",
  "MAPPIST": "one who works with maps [n -S]\n",
  "MAPPISTS": "MAPPIST, one who works with maps [n]\n",
  "MAPS": "MAP, to plan a layout of [v]\n",
  "MAPSTICK": "the long handle of a mop, also MOPSTICK [n -S]\n",
  "MAPSTICKS": "MAPSTICK, the long handle of a mop, also MOPSTICK [n]\n",
  "MAPWISE": "in the manner of a map [adv]\n",
  "MAQUETTE": "(French) a small model of something to be made on a larger scale [n -S]\n",
  "MAQUETTES": "MAQUETTE, (French) a small model of something to be made on a larger scale [n]\n",
  "MAQUI": "(Spanish) a thick underbrush, also MAQUIS [n -S]\n",
  "MAQUILA": "(Spanish) a manufacturing plant in Mexico that produce parts for assembly in the United States, also MAQUILADORA [n -S]\n",
  "MAQUILADORA": "(Spanish) a manufacturing plant in Mexico that produce parts for assembly in the United States, also MAQUILA [n -S]\n",
  "MAQUILADORAS": "MAQUILADORA, (Spanish) a manufacturing plant in Mexico that produce parts for assembly in the United States, also MAQUILA [n]\n",
  "MAQUILAS": "MAQUILA, (Spanish) a manufacturing plant in Mexico that produce parts for assembly in the United States, also MAQUILADORA [n]\n",
  "MAQUILLAGE": "(French) makeup [n -S]\n",
  "MAQUILLAGES": "MAQUILLAGE, (French) makeup [n]\n",
  "MAQUIS": "(French) a thick underbrush, also MAQUI [n MAQUIS]\n",
  "MAQUISARD": "a member of the maquis, a guerrilla resistance force [n -S]\n",
  "MAQUISARDS": "MAQUISARD, a member of the maquis, a guerrilla resistance force [n]\n",
  "MAR": "to spoil or damage [v MARRED or (Spenser) MARD, MARRING, MARS]\n",
  "MARA": "a large rodent, like a cavy, found in Patagonia [n -S]\n",
  "MARABI": "(South African) a kind of music popular in townships in the 1930s [n -S]\n",
  "MARABIS": "MARABI, (South African) a kind of music popular in townships in the 1930s [n]\n",
  "MARABOU": "(French) an African stork, also MARABOUT [n -S]\n",
  "MARABOUS": "MARABOU, (French) an African stork, also MARABOUT [n]\n",
  "MARABOUT": "(French) an African stork, also MARABOU [n -S]\n",
  "MARABOUTS": "MARABOUT, (French) an African stork, also MARABOU [n]\n",
  "MARABUNTA": "(Caribbean) in the Caribbean, a social wasp; an ill-tempered woman [n -S]\n",
  "MARABUNTAS": "MARABUNTA, (Caribbean) in the Caribbean, a social wasp; an ill-tempered woman [n]\n",
  "MARACA": "(Portuguese) a kind of gourd, used as a musical instrument [n -S]\n",
  "MARACAS": "MARACA, (Portuguese) a kind of gourd, used as a musical instrument [n]\n",
  "MARAE": "(Maori) a meeting-place [n -S]\n",
  "MARAES": "MARAE, (Maori) a meeting-place [n]\n",
  "MARAGING": "a process by which an alloy is slowly cooled in the air [n -S]\n",
  "MARAGINGS": "MARAGING, a process by which an alloy is slowly cooled in the air [n]\n",
  "MARAH": "(Hebrew) in Biblical allusions, bitterness; something bitter [n -S]\n",
  "MARAHS": "MARAH, (Hebrew) in Biblical allusions, bitterness; something bitter [n]\n",
  "MARAKA": "MARKA, the standard unit of currency in Bosnia-Herzegovina, also MARKKA [n]\n",
  "MARANATHA": "a curse or excommunication [n -S]\n",
  "MARANATHAS": "MARANATHA, a curse or excommunication [n]\n",
  "MARANTA": "a genus of tropical plants that includes arrowroot [n -S]\n",
  "MARANTAS": "MARANTA, a genus of tropical plants that includes arrowroot [n]\n",
  "MARARI": "(Maori) the butterfish [n -S]\n",
  "MARARIS": "MARARI, (Maori) the butterfish [n]\n",
  "MARAS": "MARA, a large rodent, like a cavy, found in Patagonia [n]\n",
  "MARASCA": "(Italian) a bitter wild cherry [n -S]\n",
  "MARASCAS": "MARASCA, (Italian) a bitter wild cherry [n]\n",
  "MARASCHINO": "a sweet liqueur distilled from maraschino cherries [n -S]\n",
  "MARASCHINOS": "MARASCHINO, a sweet liqueur distilled from maraschino cherries [n]\n",
  "MARASMIC": "wasting away [adj]\n",
  "MARASMOID": "suffering from marasmus [adj]\n",
  "MARASMUS": "a wasting away of the body [n -ES]\n",
  "MARASMUSES": "MARASMUS, a wasting away of the body [n]\n",
  "MARATHON": "a long-distance race [n -S]\n",
  "MARATHONER": "one who takes part in a marathon [n -S]\n",
  "MARATHONERS": "MARATHONER, one who takes part in a marathon [n]\n",
  "MARATHONING": "the act of running marathons [n -S]\n",
  "MARATHONINGS": "MARATHONING, the act of running marathons [n]\n",
  "MARATHONS": "MARATHON, a long-distance race [n]\n",
  "MARAUD": "to wander in search of plunder [v -ED, -ING, -S]\n",
  "MARAUDED": "MARAUD, to wander in search of plunder [v]\n",
  "MARAUDER": "one who marauds [n -S]\n",
  "MARAUDERS": "MARAUDER, one who marauds [n]\n",
  "MARAUDING": "the act of wandering in search of plunder [n -S]\n",
  "MARAUDINGS": "MARAUDING, the act of wandering in search of plunder [n]\n",
  "MARAUDS": "MARAUD, to wander in search of plunder [v]\n",
  "MARAVEDI": "(Spanish) a former coin of Spain [n -S]\n",
  "MARAVEDIS": "MARAVEDI, (Spanish) a former coin of Spain [n]\n",
  "MARBELISE": "to stain or grain in imitation of marble, also MARBELIZE, MARBLEISE, MARBLEIZE [v MARBELISED, MARBELISING, MARBELISES]\n",
  "MARBELISED": "MARBELISE, to stain or grain in imitation of marble, also MARBELIZE, MARBLEISE, MARBLEIZE [v]\n",
  "MARBELISES": "MARBELISE, to stain or grain in imitation of marble, also MARBELIZE, MARBLEISE, MARBLEIZE [v]\n",
  "MARBELISING": "MARBELISE, to stain or grain in imitation of marble, also MARBELIZE, MARBLEISE, MARBLEIZE [v]\n",
  "MARBELIZE": "to stain or grain in imitation of marble, also MARBELISE, MARBLEISE, MARBLEIZE [v MARBELIZED, MARBELIZING, MARBELIZES]\n",
  "MARBELIZED": "MARBELIZE, to stain or grain in imitation of marble, also MARBELISE, MARBLEISE, MARBLEIZE [v]\n",
  "MARBELIZES": "MARBELIZE, to stain or grain in imitation of marble, also MARBELISE, MARBLEISE, MARBLEIZE [v]\n",
  "MARBELIZING": "MARBELIZE, to stain or grain in imitation of marble, also MARBELISE, MARBLEISE, MARBLEIZE [v]\n",
  "MARBLE": "to vein or print in a mottled manner [v MARBLED, MARBLING, MARBLES]\n",
  "MARBLED": "MARBLE, to vein or print in a mottled manner [v]\n",
  "MARBLEISE": "to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEIZE [v MARBLEISED, MARBLEISING, MARBLEISES]\n",
  "MARBLEISED": "MARBLEISE, to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEIZE [v]\n",
  "MARBLEISES": "MARBLEISE, to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEIZE [v]\n",
  "MARBLEISING": "MARBLEISE, to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEIZE [v]\n",
  "MARBLEIZE": "to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEISE [v MARBLEIZED, MARBLEIZING, MARBLEIZES]\n",
  "MARBLEIZED": "MARBLEIZE, to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEISE [v]\n",
  "MARBLEIZES": "MARBLEIZE, to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEISE [v]\n",
  "MARBLEIZING": "MARBLEIZE, to stain or grain in imitation of marble, also MARBELISE, MARBELIZE, MARBLEISE [v]\n",
  "MARBLER": "one who works upon marble or other stone [n -S]\n",
  "MARBLERS": "MARBLER, one who works upon marble or other stone [n]\n",
  "MARBLES": "MARBLE, to vein or print in a mottled manner [v]\n",
  "MARBLEWOOD": "a Malaysian tree; the distinctively marked wood of this tree, having black bands on a lighter background [n -S]\n",
  "MARBLEWOODS": "MARBLEWOOD, a Malaysian tree; the distinctively marked wood of this tree, having black bands on a lighter background [n]\n",
  "MARBLIER": "MARBLY, mottled [adj]\n",
  "MARBLIEST": "MARBLY, mottled [adj]\n",
  "MARBLING": "the intermixture of fat and lean in meat [n -S]\n",
  "MARBLINGS": "MARBLING, the intermixture of fat and lean in meat [n]\n",
  "MARBLY": "mottled [adj MARBLIER, MARBLIEST]\n",
  "MARC": "(French) the residue remaining after a fruit has been pressed [n -S]\n",
  "MARCANTANT": "(Shakespeare) a merchant [n -S]\n",
  "MARCANTANTS": "MARCANTANT, (Shakespeare) a merchant [n]\n",
  "MARCASITE": "sulphide of iron in orthorhombic crystals [n -S]\n",
  "MARCASITES": "MARCASITE, sulphide of iron in orthorhombic crystals [n]\n",
  "MARCASITICAL": "of or like marcasite [adj]\n",
  "MARCATISSIMO": "in a very marcato manner [adv]\n",
  "MARCATO": "(Italian) in a marked emphatic manner [adj] / a musical passage with strong accentuation [n -S]\n",
  "MARCATOS": "MARCATO, a musical passage with strong accentuation [n]\n",
  "MARCEL": "(French) to make a deep, soft wave in the hair [v MARCELLED, MARCELLING, MARCELS]\n",
  "MARCELLA": "a cotton, linen, twill weave [n -S]\n",
  "MARCELLAS": "MARCELLA, a cotton, linen, twill weave [n]\n",
  "MARCELLED": "MARCEL, (French) to make a deep, soft wave in the hair [v]\n",
  "MARCELLER": "one who marcels [n -S]\n",
  "MARCELLERS": "MARCELLER, one who marcels [n]\n",
  "MARCELLING": "MARCEL, (French) to make a deep, soft wave in the hair [v]\n",
  "MARCELS": "MARCEL, (French) to make a deep, soft wave in the hair [v]\n",
  "MARCESCENCE": "the state of being marcescent [n -S]\n",
  "MARCESCENCES": "MARCESCENCE, the state of being marcescent [n]\n",
  "MARCESCENT": "withering without falling off [adj]\n",
  "MARCESCIBLE": "tending to wither or fade [adj]\n",
  "MARCH": "to walk in a military manner [v -ED, -ING, -ES]\n",
  "MARCHANTIA": "a liverwort of the Marchantia genus [n -S]\n",
  "MARCHANTIAS": "MARCHANTIA, a liverwort of the Marchantia genus [n]\n",
  "MARCHED": "MARCH, to walk in a military manner [v]\n",
  "MARCHEN": "(German) a story or fable, a folktale [n MARCHEN]\n",
  "MARCHER": "one that marches [n -S]\n",
  "MARCHERS": "MARCHER, one that marches [n]\n",
  "MARCHES": "MARCH, to walk in a military manner [v]\n",
  "MARCHESA": "(Italian) the wife or widow of a marchese [n -S]\n",
  "MARCHESAS": "MARCHESA, (Italian) the wife or widow of a marchese [n]\n",
  "MARCHESE": "(Italian) an Italian nobleman [n MARCHESI]\n",
  "MARCHESI": "MARCHESE, (Italian) an Italian nobleman [n]\n",
  "MARCHING": "MARCH, to walk in a military manner [v]\n",
  "MARCHIONESS": "the wife or widow of a marquess [n -ES]\n",
  "MARCHIONESSES": "MARCHIONESS, the wife or widow of a marquess [n]\n",
  "MARCHLAND": "a borderland [n -S]\n",
  "MARCHLANDS": "MARCHLAND, a borderland [n]\n",
  "MARCHLIKE": "like a (musical) march [adj]\n",
  "MARCHMAN": "a person living near a border [n MARCHMEN]\n",
  "MARCHMEN": "MARCHMAN, a person living near a border [n]\n",
  "MARCHPANE": "(Italian) an old name for marzipan, a confection of ground almonds, egg whites, and sugar [n -S]\n",
  "MARCHPANES": "MARCHPANE, (Italian) an old name for marzipan, a confection of ground almonds, egg whites, and sugar [n]\n",
  "MARCONI": "to communicate by wireless telegraphy [v -ED, -ING, -S]\n",
  "MARCONIED": "MARCONI, to communicate by wireless telegraphy [v]\n",
  "MARCONIGRAM": "a message sent by wireless telegraphy [n -S]\n",
  "MARCONIGRAMS": "MARCONIGRAM, a message sent by wireless telegraphy [n]\n",
  "MARCONIGRAPH": "a message sent by wireless telegraphy [n -S] / to send a message by wireless telegraphy [v -ED, -ING, -S]\n",
  "MARCONIGRAPHED": "MARCONIGRAPH, to send a message by wireless telegraphy [v]\n",
  "MARCONIGRAPHING": "MARCONIGRAPH, to send a message by wireless telegraphy [v]\n",
  "MARCONIGRAPHS": "MARCONIGRAPH, to send a message by wireless telegraphy [v]\n",
  "MARCONIING": "MARCONI, to communicate by wireless telegraphy [v]\n",
  "MARCONIS": "MARCONI, to communicate by wireless telegraphy [v]\n",
  "MARCS": "MARC, (French) the residue remaining after a fruit has been pressed [n]\n",
  "MARD": "(Spenser) marred [adj]\n",
  "MARDIED": "MARDY, to behave like a spoilt child [v]\n",
  "MARDIER": "MARDY, petulant [adj]\n",
  "MARDIES": "MARDY, to behave like a spoilt child [v]\n",
  "MARDIEST": "MARDY, petulant [adj]\n",
  "MARDY": "petulant [adj MARDIER, MARDIEST] / to behave like a spoilt child [v MARDIED, MARDYING, MARDIES]\n",
  "MARDYING": "MARDY, to behave like a spoilt child [v]\n",
  "MARE": "a female horse [n -S] / a dark area on the Moon or Mars [n MARIA]\n",
  "MAREMMA": "(Italian) a marshy coastal region [n MAREMMAS or MAREMME]\n",
  "MAREMMAS": "MAREMMA, (Italian) a marshy coastal region [n]\n",
  "MAREMME": "MAREMMA, (Italian) a marshy coastal region [n]\n",
  "MARENGO": "(Italian) served with a sauce of mushrooms, tomatoes, oil and wine [adj]\n",
  "MARERO": "a member of a mara in the US or Central America [n -S]\n",
  "MAREROS": "MARERO, a member of a mara in the US or Central America [n]\n",
  "MARES": "MARE, a female horse [n]\n",
  "MARESCHAL": "(archaic) a marshal, also MARISCHAL [n -S]\n",
  "MARESCHALS": "MARESCHAL, (archaic) a marshal, also MARISCHAL [n]\n",
  "MARG": "(short for) margarine, also MARGE [n -S]\n",
  "MARGARIC": "pearl-like, also MARGARITIC [adj]\n",
  "MARGARIN": "a butter substitute [n -S]\n",
  "MARGARINE": "a butter-like substance made from vegetable oils and fats [n -S]\n",
  "MARGARINES": "MARGARINE, a butter-like substance made from vegetable oils and fats [n]\n",
  "MARGARINS": "MARGARIN, a butter substitute [n]\n",
  "MARGARITA": "(Spanish) a cocktail of tequila, lime and lemon-juice, also MARGUERITA [n -S]\n",
  "MARGARITAS": "MARGARITA, (Spanish) a cocktail of tequila, lime and lemon-juice, also MARGUERITA [n]\n",
  "MARGARITE": "a pearl [n -S]\n",
  "MARGARITES": "MARGARITE, a pearl [n]\n",
  "MARGARITIC": "pearl-like, also MARGARIC [adj]\n",
  "MARGARITIFEROUS": "pearl-bearing [adj]\n",
  "MARGATE": "a tropical fish [n -S]\n",
  "MARGATES": "MARGATE, a tropical fish [n]\n",
  "MARGAY": "(Tupi) a small American wildcat [n -S]\n",
  "MARGAYS": "MARGAY, (Tupi) a small American wildcat [n]\n",
  "MARGE": "(short for) margarine, also MARG [n -S]\n",
  "MARGENT": "to provide with a border, also MARGIN [v -ED, -ING, -S]\n",
  "MARGENTED": "MARGENT, to provide with a border, also MARGIN [v]\n",
  "MARGENTING": "MARGENT, to provide with a border, also MARGIN [v]\n",
  "MARGENTS": "MARGENT, to provide with a border, also MARGIN [v]\n",
  "MARGES": "MARGE, (short for) margarine, also MARG [n]\n",
  "MARGHERITA": "a variety of pizza topped with tomato, basil, and mozzarella cheese [n -S]\n",
  "MARGHERITAS": "MARGHERITA, a variety of pizza topped with tomato, basil, and mozzarella cheese [n]\n",
  "MARGIN": "to provide with a border, also MARGENT [v -ED, -ING, -S]\n",
  "MARGINAL": "on the margin [adj MARGINALLY] / anything in or on a margin [n -S]\n",
  "MARGINALIA": "marginal notes [n]\n",
  "MARGINALISATION": "the act of marginalising, also MARGINALIZATION [n]\n",
  "MARGINALISE": "to make marginal, also MARGINALIZE [v MARGINALISED, MARGINALISING, MARGINALISES]\n",
  "MARGINALISED": "MARGINALISE, to make marginal, also MARGINALIZE [v]\n",
  "MARGINALISES": "MARGINALISE, to make marginal, also MARGINALIZE [v]\n",
  "MARGINALISING": "MARGINALISE, to make marginal, also MARGINALIZE [v]\n",
  "MARGINALISM": "an economic theory that the value of a product depends on its value to the final consumer [n -S]\n",
  "MARGINALISMS": "MARGINALISM, an economic theory that the value of a product depends on its value to the final consumer [n]\n",
  "MARGINALIST": "a believer in marginalism [n -S]\n",
  "MARGINALISTS": "MARGINALIST, a believer in marginalism [n]\n",
  "MARGINALITIES": "MARGINALITY, the state of being marginal [n]\n",
  "MARGINALITY": "the state of being marginal [n MARGINALITIES]\n",
  "MARGINALIZATION": "the act of marginalizing, also MARGINALISATION [n]\n",
  "MARGINALIZE": "to make marginal, also MARGINALISE [v MARGINALIZED, MARGINALIZING, MARGINALIZES]\n",
  "MARGINALIZED": "MARGINALIZE, to make marginal, also MARGINALISE [v]\n",
  "MARGINALIZES": "MARGINALIZE, to make marginal, also MARGINALISE [v]\n",
  "MARGINALIZING": "MARGINALIZE, to make marginal, also MARGINALISE [v]\n",
  "MARGINALLY": "MARGINAL, on the margin [adv]\n",
  "MARGINALS": "MARGINAL, anything in or on a margin [n]\n",
  "MARGINATE": "to provide with a margin or border [v MARGINATED, MARGINATING, MARGINATES]\n",
  "MARGINATED": "MARGINATE, to provide with a margin or border [v]\n",
  "MARGINATES": "MARGINATE, to provide with a margin or border [v]\n",
  "MARGINATING": "MARGINATE, to provide with a margin or border [v]\n",
  "MARGINATION": "the act of marginating [n -S]\n",
  "MARGINATIONS": "MARGINATION, the act of marginating [n]\n",
  "MARGINED": "MARGIN, to provide with a border, also MARGENT [v]\n",
  "MARGINING": "MARGIN, to provide with a border, also MARGENT [v]\n",
  "MARGINS": "MARGIN, to provide with a border, also MARGENT [v]\n",
  "MARGOSA": "(Portuguese) a large tree of genus Melia found in India, valued for medicinal purposes, aka neem [n -S]\n",
  "MARGOSAS": "MARGOSA, (Portuguese) a large tree of genus Melia found in India, valued for medicinal purposes, aka neem [n]\n",
  "MARGRAVATE": "the jurisdiction or position of a margrave, also MARGRAVIATE [n -S]\n",
  "MARGRAVATES": "MARGRAVATE, the jurisdiction or position of a margrave, also MARGRAVIATE [n]\n",
  "MARGRAVE": "(German) a German nobleman of rank equivalent to an English marquess [n -S]\n",
  "MARGRAVES": "MARGRAVE, (German) a German nobleman of rank equivalent to an English marquess [n]\n",
  "MARGRAVIAL": "relating to a margrave [adj]\n",
  "MARGRAVIATE": "the jurisdiction or position of a margrave, also MARGRAVATE [n -S]\n",
  "MARGRAVIATES": "MARGRAVIATE, the jurisdiction or position of a margrave, also MARGRAVATE [n]\n",
  "MARGRAVINE": "a margrave's wife or woman having power of margrave [n -S]\n",
  "MARGRAVINES": "MARGRAVINE, a margrave's wife or woman having power of margrave [n]\n",
  "MARGS": "MARG, (short for) margarine, also MARGE [n]\n",
  "MARGUERITA": "a mixed drink consisting of tequila and lemon juice, also MARGARITA [n -S]\n",
  "MARGUERITAS": "MARGUERITA, a mixed drink consisting of tequila and lemon juice, also MARGARITA [n]\n",
  "MARGUERITE": "the oxeye daisy or other single chrysanthemum [n -S]\n",
  "MARGUERITES": "MARGUERITE, the oxeye daisy or other single chrysanthemum [n]\n",
  "MARIA": "MARE, a female horse [n]\n",
  "MARIACHI": "(Spanish) a Mexican musical band [n -S]\n",
  "MARIACHIS": "MARIACHI, (Spanish) a Mexican musical band [n]\n",
  "MARIALITE": "a mineral, a variety of scapolite [n -S]\n",
  "MARIALITES": "MARIALITE, a mineral, a variety of scapolite [n]\n",
  "MARICULTURE": "the cultivation of aquatic flora and fauna [n -S]\n",
  "MARICULTURES": "MARICULTURE, the cultivation of aquatic flora and fauna [n]\n",
  "MARICULTURIST": "one who engages in mariculture, the cultivation of plants and animals of the sea in their own environment [n -S]\n",
  "MARICULTURISTS": "MARICULTURIST, one who engages in mariculture, the cultivation of plants and animals of the sea in their own environment [n]\n",
  "MARID": "(Arabic) a jinn of the most powerful class [n -S]\n",
  "MARIDS": "MARID, (Arabic) a jinn of the most powerful class [n]\n",
  "MARIES": "MARY, (Australian slang) a woman, esp. an aboriginal woman [n]\n",
  "MARIGOLD": "a composite plant of genus Calendula, with orange-yellow flowers [n -S]\n",
  "MARIGOLDS": "MARIGOLD, a composite plant of genus Calendula, with orange-yellow flowers [n]\n",
  "MARIGRAM": "a record of tide levels [n -S]\n",
  "MARIGRAMS": "MARIGRAM, a record of tide levels [n]\n",
  "MARIGRAPH": "an instrument for recording tide levels [n -S]\n",
  "MARIGRAPHS": "MARIGRAPH, an instrument for recording tide levels [n]\n",
  "MARIHUANA": "(Spanish) Indian hemp; its dried flowers or leaves smoked as an intoxicant, also MARIJUANA [n -S]\n",
  "MARIHUANAS": "MARIHUANA, (Spanish) Indian hemp; its dried flowers or leaves smoked as an intoxicant, also MARIJUANA [n]\n",
  "MARIJUANA": "(Spanish) Indian hemp; its dried flowers or leaves smoked as an intoxicant, also MARIHUANA [n -S]\n",
  "MARIJUANAS": "MARIJUANA, (Spanish) Indian hemp; its dried flowers or leaves smoked as an intoxicant, also MARIHUANA [n]\n",
  "MARIMBA": "a percussion instrument resembling a xylophone [n -S]\n",
  "MARIMBAPHONE": "a marimba [n -S]\n",
  "MARIMBAPHONES": "MARIMBAPHONE, a marimba [n]\n",
  "MARIMBAS": "MARIMBA, a percussion instrument resembling a xylophone [n]\n",
  "MARIMBIST": "one who plays the marimba [n -S]\n",
  "MARIMBISTS": "MARIMBIST, one who plays the marimba [n]\n",
  "MARINA": "(Italian) a berthing area for boats [n -S]\n",
  "MARINADE": "to soak in seasoned liquid before cooking, also MARINATE [v MARINADED, MARINADING, MARINADES]\n",
  "MARINADED": "MARINADE, to soak in seasoned liquid before cooking, also MARINATE [v]\n",
  "MARINADES": "MARINADE, to soak in seasoned liquid before cooking, also MARINATE [v]\n",
  "MARINADING": "MARINADE, to soak in seasoned liquid before cooking, also MARINATE [v]\n",
  "MARINARA": "(Italian) a seasoned tomato sauce [n -S]\n",
  "MARINARAS": "MARINARA, (Italian) a seasoned tomato sauce [n]\n",
  "MARINAS": "MARINA, (Italian) a berthing area for boats [n]\n",
  "MARINATE": "to soak in seasoned liquid before cooking, also MARINADE [v MARINATED, MARINATING, MARINATES]\n",
  "MARINATED": "MARINATE, to soak in seasoned liquid before cooking, also MARINADE [v]\n",
  "MARINATES": "MARINATE, to soak in seasoned liquid before cooking, also MARINADE [v]\n",
  "MARINATING": "MARINATE, to soak in seasoned liquid before cooking, also MARINADE [v]\n",
  "MARINATION": "the act of marinating [n -S]\n",
  "MARINATIONS": "MARINATION, the act of marinating [n]\n",
  "MARINE": "a soldier trained for service on land and sea [n -S]\n",
  "MARINER": "a sailor [n -S]\n",
  "MARINERA": "(Spanish) a Peruvian folk-dance [n -S]\n",
  "MARINERAS": "MARINERA, (Spanish) a Peruvian folk-dance [n]\n",
  "MARINERS": "MARINER, a sailor [n]\n",
  "MARINES": "MARINE, a soldier trained for service on land and sea [n]\n",
  "MARINIERE": "(French) esp. of mussels, cooked in white wine with onions and herbs [adj]\n",
  "MARIONBERRIES": "MARIONBERRY, a hybrid fruit, a cross between a loganberry and a wild blackberry [n]\n",
  "MARIONBERRY": "a hybrid fruit, a cross between a loganberry and a wild blackberry [n MARIONBERRIES]\n",
  "MARIONETTE": "(French) a puppet moved by strings, as in a puppet show [n -S]\n",
  "MARIONETTES": "MARIONETTE, (French) a puppet moved by strings, as in a puppet show [n]\n",
  "MARIPOSA": "(Spanish) any of several liliaceous plants of the southwestern United States and Mexico, having brightly coloured tuliplike flowers [n -S]\n",
  "MARIPOSAS": "MARIPOSA, (Spanish) any of several liliaceous plants of the southwestern United States and Mexico, having brightly coloured tuliplike flowers [n]\n",
  "MARISCHAL": "(Scots) a marshal, also MARESCHAL [n -S] / to marshal [v MARISCHALLED, MARISCHALLING, MARISCHALS]\n",
  "MARISCHALLED": "MARISCHAL, to marshal [v]\n",
  "MARISCHALLING": "MARISCHAL, to marshal [v]\n",
  "MARISCHALS": "MARISCHAL, to marshal [v]\n",
  "MARISH": "a tract of low, wet land, also MARSH [n -ES]\n",
  "MARISHES": "MARISH, a tract of low, wet land, also MARSH [n]\n",
  "MARITAGE": "the right of a feudal superior to arrange the marriage of a vassal's heir [n -S]\n",
  "MARITAGES": "MARITAGE, the right of a feudal superior to arrange the marriage of a vassal's heir [n]\n",
  "MARITAL": "relating to marriage [adj MARITALLY]\n",
  "MARITALLY": "MARITAL, relating to marriage [adv]\n",
  "MARITIME": "relating to the sea [adj]\n",
  "MARIVAUDAGE": "preciosity in literary style or expression [n -S]\n",
  "MARIVAUDAGES": "MARIVAUDAGE, preciosity in literary style or expression [n]\n",
  "MARJORAM": "any of various labiate plants of the genus Origanum, aromatic herbs much used in cooking [n -S]\n",
  "MARJORAMS": "MARJORAM, any of various labiate plants of the genus Origanum, aromatic herbs much used in cooking [n]\n",
  "MARK": "to impress or stamp with a sign [v -ED, -ING, -S]\n",
  "MARKA": "the standard unit of currency in Bosnia-Herzegovina, also MARKKA [n MARKAS or MARAKA]\n",
  "MARKAS": "MARKA, the standard unit of currency in Bosnia-Herzegovina, also MARKKA [n]\n",
  "MARKDOWN": "the act of labelling an article with a lower price than before [n -S]\n",
  "MARKDOWNS": "MARKDOWN, the act of labelling an article with a lower price than before [n]\n",
  "MARKED": "MARK, to impress or stamp with a sign [v]\n",
  "MARKEDLY": "MARKED, MARK, to impress or stamp with a sign [adv]\n",
  "MARKEDNESS": "the state of being marked [n -ES]\n",
  "MARKEDNESSES": "MARKEDNESS, the state of being marked [n]\n",
  "MARKER": "one that marks [n -S]\n",
  "MARKERS": "MARKER, one that marks [n]\n",
  "MARKET": "to offer for sale [v -ED, -ING, -S]\n",
  "MARKETABILITIES": "MARKETABILITY, the state of being marketable [n]\n",
  "MARKETABILITY": "the state of being marketable [n MARKETABILITIES]\n",
  "MARKETABLE": "that can be marketed [adj MARKETABLY]\n",
  "MARKETABLENESS": "the state of being marketable [n]\n",
  "MARKETABLY": "MARKETABLE, that can be marketed [adv]\n",
  "MARKETED": "MARKET, to offer for sale [v]\n",
  "MARKETEER": "one who markets, also MARKETER [n -S]\n",
  "MARKETEERS": "MARKETEER, one who markets, also MARKETER [n]\n",
  "MARKETER": "one that markets, also MARKETEER [n -S]\n",
  "MARKETERS": "MARKETER, one that markets, also MARKETEER [n]\n",
  "MARKETING": "the business process of managing the flow of goods, services or processes from the producer to the user [n -S]\n",
  "MARKETINGS": "MARKETING, the business process of managing the flow of goods, services or processes from the producer to the user [n]\n",
  "MARKETISATION": "the process of bringing to market, also MARKETIZATION [n -S]\n",
  "MARKETISATIONS": "MARKETISATION, the process of bringing to market, also MARKETIZATION [n]\n",
  "MARKETISE": "to adopt a market economy, also MARKETIZE [v MARKETISED, MARKETISING, MARKETISES]\n",
  "MARKETISED": "MARKETISE, to adopt a market economy, also MARKETIZE [v]\n",
  "MARKETISES": "MARKETISE, to adopt a market economy, also MARKETIZE [v]\n",
  "MARKETISING": "MARKETISE, to adopt a market economy, also MARKETIZE [v]\n",
  "MARKETIZATION": "the process of bringing to market, also MARKETISATION [n -S]\n",
  "MARKETIZATIONS": "MARKETIZATION, the process of bringing to market, also MARKETISATION [n]\n",
  "MARKETIZE": "to adopt a market economy, also MARKETISE [v MARKETIZED, MARKETIZING, MARKETIZES]\n",
  "MARKETIZED": "MARKETIZE, to adopt a market economy, also MARKETISE [v]\n",
  "MARKETIZES": "MARKETIZE, to adopt a market economy, also MARKETISE [v]\n",
  "MARKETIZING": "MARKETIZE, to adopt a market economy, also MARKETISE [v]\n",
  "MARKETPLACE": "an open square or place in a town where markets or public sales are held [n -S]\n",
  "MARKETPLACES": "MARKETPLACE, an open square or place in a town where markets or public sales are held [n]\n",
  "MARKETS": "MARKET, to offer for sale [v]\n",
  "MARKHOOR": "(Persian) a wild goat of the mountains of Asia, also MARKHOR [n -S]\n",
  "MARKHOORS": "MARKHOOR, (Persian) a wild goat of the mountains of Asia, also MARKHOR [n]\n",
  "MARKHOR": "(Persian) a wild goat of the mountains of Asia, also MARKHOOR [n -S]\n",
  "MARKHORS": "MARKHOR, (Persian) a wild goat of the mountains of Asia, also MARKHOOR [n]\n",
  "MARKING": "a pattern of marks [n -S]\n",
  "MARKINGS": "MARKING, a pattern of marks [n]\n",
  "MARKKA": "(Finnish) the standard monetary unit of Finland, also MARKA [n MARKKAS or MARKKAA]\n",
  "MARKKAA": "MARKKA, (Finnish) the standard monetary unit of Finland, also MARKA [n]\n",
  "MARKKAS": "MARKKA, (Finnish) the standard monetary unit of Finland, also MARKA [n]\n",
  "MARKMAN": "a person skillful at hitting a target, also MARKSMAN [n MARKMEN]\n",
  "MARKMEN": "MARKMAN, a person skillful at hitting a target, also MARKSMAN [n]\n",
  "MARKS": "MARK, to impress or stamp with a sign [v]\n",
  "MARKSMAN": "a person skillful at hitting a target, also MARKMAN [n MARKSMEN]\n",
  "MARKSMANSHIP": "the skill of a marksman [n -S]\n",
  "MARKSMANSHIPS": "MARKSMANSHIP, the skill of a marksman [n]\n",
  "MARKSMEN": "MARKSMAN, a person skillful at hitting a target, also MARKMAN [n]\n",
  "MARKSWOMAN": "a woman skilled in shooting at a mark or target [n MARKSWOMEN]\n",
  "MARKSWOMEN": "MARKSWOMAN, a woman skilled in shooting at a mark or target [n]\n",
  "MARKUP": "the difference between a wholesale and retail price [n -S]\n",
  "MARKUPS": "MARKUP, the difference between a wholesale and retail price [n]\n",
  "MARL": "to fertilize with a calcareous clay [v -ED, -ING, -S]\n",
  "MARLACIOUS": "containing marl [adj]\n",
  "MARLE": "(obsolete) a marvel [n -S]\n",
  "MARLED": "MARL, to fertilize with a calcareous clay [v]\n",
  "MARLES": "MARLE, (obsolete) a marvel [n]\n",
  "MARLIER": "MARLY, abounding with marl [adj]\n",
  "MARLIEST": "MARLY, abounding with marl [adj]\n",
  "MARLIN": "a marine game fish [n -S]\n",
  "MARLINE": "a line of two loosely twisted strands used on a ship [n -S]\n",
  "MARLINES": "MARLINE, a line of two loosely twisted strands used on a ship [n]\n",
  "MARLINESPIKE": "a tool used to separate rope strands while splicing, also MARLINGSPIKE, MARLINSPIKE [n -S]\n",
  "MARLINESPIKES": "MARLINESPIKE, a tool used to separate rope strands while splicing, also MARLINGSPIKE, MARLINSPIKE [n]\n",
  "MARLING": "the act of fertilising with marl [n -S]\n",
  "MARLINGS": "MARLING, the act of fertilising with marl [n]\n",
  "MARLINGSPIKE": "a tool used to separate rope strands while splicing, also MARLINESPIKE, MARLINSPIKE [n -S]\n",
  "MARLINGSPIKES": "MARLINGSPIKE, a tool used to separate rope strands while splicing, also MARLINESPIKE, MARLINSPIKE [n]\n",
  "MARLINS": "MARLIN, a marine game fish [n]\n",
  "MARLINSPIKE": "a tool used to separate rope strands while splicing, also MARLINESPIKE, MARLINGSPIKE [n -S]\n",
  "MARLINSPIKES": "MARLINSPIKE, a tool used to separate rope strands while splicing, also MARLINESPIKE, MARLINGSPIKE [n]\n",
  "MARLITE": "marl with 25% to 75% clay, plus chalk [n -S]\n",
  "MARLITES": "MARLITE, marl with 25% to 75% clay, plus chalk [n]\n",
  "MARLITIC": "partaking of the qualities of marlite, marl with 25% to 75% clay, plus chalk [adj]\n",
  "MARLS": "MARL, to fertilize with a calcareous clay [v]\n",
  "MARLSTONE": "a sandy calcareous stratum, containing, or impregnated with, iron, and lying between the upper and lower Lias of England [n -S]\n",
  "MARLSTONES": "MARLSTONE, a sandy calcareous stratum, containing, or impregnated with, iron, and lying between the upper and lower Lias of England [n]\n",
  "MARLY": "abounding with marl [adj MARLIER, MARLIEST]\n",
  "MARM": "a form of address to a woman, ma'am [n -S]\n",
  "MARMALADE": "a jam or preserve made from the pulp and sometimes rind of citrus fruit [n -S]\n",
  "MARMALADES": "MARMALADE, a jam or preserve made from the pulp and sometimes rind of citrus fruit [n]\n",
  "MARMALISE": "(slang) to beat soundly, also MARMALIZE, MARMELISE, MARMELIZE [v MARMALISED, MARMALISING, MARMALISES]\n",
  "MARMALISED": "MARMALISE, (slang) to beat soundly, also MARMALIZE, MARMELISE, MARMELIZE [v]\n",
  "MARMALISES": "MARMALISE, (slang) to beat soundly, also MARMALIZE, MARMELISE, MARMELIZE [v]\n",
  "MARMALISING": "MARMALISE, (slang) to beat soundly, also MARMALIZE, MARMELISE, MARMELIZE [v]\n",
  "MARMALIZE": "(slang) to beat soundly, also MARMALISE, MARMELISE, MARMELIZE [v MARMALIZED, MARMALIZING, MARMALIZES]\n",
  "MARMALIZED": "MARMALIZE, (slang) to beat soundly, also MARMALISE, MARMELISE, MARMELIZE [v]\n",
  "MARMALIZES": "MARMALIZE, (slang) to beat soundly, also MARMALISE, MARMELISE, MARMELIZE [v]\n",
  "MARMALIZING": "MARMALIZE, (slang) to beat soundly, also MARMALISE, MARMELISE, MARMELIZE [v]\n",
  "MARMARISE": "to convert limestone into marble, also MARMARIZE [v MARMARISED, MARMARISING, MARMARISES]\n",
  "MARMARISED": "MARMARISE, to convert limestone into marble, also MARMARIZE [v]\n",
  "MARMARISES": "MARMARISE, to convert limestone into marble, also MARMARIZE [v]\n",
  "MARMARISING": "MARMARISE, to convert limestone into marble, also MARMARIZE [v]\n",
  "MARMARIZE": "to convert limestone into marble, also MARMARISE [v MARMARIZED, MARMARIZING, MARMARIZES]\n",
  "MARMARIZED": "MARMARIZE, to convert limestone into marble, also MARMARISE [v]\n",
  "MARMARIZES": "MARMARIZE, to convert limestone into marble, also MARMARISE [v]\n",
  "MARMARIZING": "MARMARIZE, to convert limestone into marble, also MARMARISE [v]\n",
  "MARMAROSES": "MARMAROSIS, the conversion of limestone into marble [n]\n",
  "MARMAROSIS": "the conversion of limestone into marble [n MARMAROSES]\n",
  "MARMELISE": "(slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELIZE [v MARMELISED, MARMELISING, MARMELISES]\n",
  "MARMELISED": "MARMELISE, (slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELIZE [v]\n",
  "MARMELISES": "MARMELISE, (slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELIZE [v]\n",
  "MARMELISING": "MARMELISE, (slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELIZE [v]\n",
  "MARMELIZE": "(slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELISE [v MARMELIZED, MARMELIZING, MARMELIZES]\n",
  "MARMELIZED": "MARMELIZE, (slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELISE [v]\n",
  "MARMELIZES": "MARMELIZE, (slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELISE [v]\n",
  "MARMELIZING": "MARMELIZE, (slang) to thrash, defeat heavily, also MARMALISE, MARMALIZE, MARMELISE [v]\n",
  "MARMEM": "as in marmem alloy, an alloy which, under the influence of temperature changes, can be changed from one condition to another and back again [adj]\n",
  "MARMITE": "(French) a metal or earthenware pot without feet [n -S]\n",
  "MARMITES": "MARMITE, (French) a metal or earthenware pot without feet [n]\n",
  "MARMOREAL": "of or like marble, also MARMOREAN [adj MARMOREALLY]\n",
  "MARMOREALLY": "MARMOREAL, of or like marble, also MARMOREAN [adv]\n",
  "MARMOREAN": "of or like marble, also MARMOREAL [adj]\n",
  "MARMOSE": "(French) a small South American opossum [n -S]\n",
  "MARMOSES": "MARMOSE, (French) a small South American opossum [n]\n",
  "MARMOSET": "a kind of small monkey [n -S]\n",
  "MARMOSETS": "MARMOSET, a kind of small monkey [n]\n",
  "MARMOT": "a kind of burrowing rodent [n -S]\n",
  "MARMOTS": "MARMOT, a kind of burrowing rodent [n]\n",
  "MARMS": "MARM, a form of address to a woman, ma'am [n]\n",
  "MAROCAIN": "(French) a dress material finished with a grain surface like morocco leather, also MAROQUIN [n -S]\n",
  "MAROCAINS": "MAROCAIN, (French) a dress material finished with a grain surface like morocco leather, also MAROQUIN [n]\n",
  "MARON": "(Spanish) a kind of freshwater crustacean similar to a crayfish, also CAMARON, MARRON [n -S]\n",
  "MARONS": "MARON, (Spanish) a kind of freshwater crustacean similar to a crayfish, also CAMARON, MARRON [n]\n",
  "MAROON": "to abandon in an isolated place [v -ED, -ING, -S]\n",
  "MAROONED": "MAROON, to abandon in an isolated place [v]\n",
  "MAROONER": "one who maroons [n -S]\n",
  "MAROONERS": "MAROONER, one who maroons [n]\n",
  "MAROONING": "the act of abandoning in an isolated place [n -S]\n",
  "MAROONINGS": "MAROONING, the act of abandoning in an isolated place [n]\n",
  "MAROONS": "MAROON, to abandon in an isolated place [v]\n",
  "MAROQUIN": "(Spanish) goat leather, morocco leather, also MAROCAIN [n -S]\n",
  "MAROQUINS": "MAROQUIN, (Spanish) goat leather, morocco leather, also MAROCAIN [n]\n",
  "MAROR": "(Hebrew) a dish of bitter herbs, esp. horseradish, eaten at the Jewish Passover [n -S]\n",
  "MARORS": "MAROR, (Hebrew) a dish of bitter herbs, esp. horseradish, eaten at the Jewish Passover [n]\n",
  "MARPLOT": "(archaic) a stupid and officious meddler whose interference compromises the success of an undertaking [n -S]\n",
  "MARPLOTS": "MARPLOT, (archaic) a stupid and officious meddler whose interference compromises the success of an undertaking [n]\n",
  "MARPRELATE": "to inveigh after the manner of Martin Marprelate, the name assumed by the author of certain anti-episcopal tracts, 1588-9 [v MARPRELATED, MARPRELATING, MARPRELATES]\n",
  "MARPRELATED": "MARPRELATE, to inveigh after the manner of Martin Marprelate, the name assumed by the author of certain anti-episcopal tracts, 1588-9 [v]\n",
  "MARPRELATES": "MARPRELATE, to inveigh after the manner of Martin Marprelate, the name assumed by the author of certain anti-episcopal tracts, 1588-9 [v]\n",
  "MARPRELATING": "MARPRELATE, to inveigh after the manner of Martin Marprelate, the name assumed by the author of certain anti-episcopal tracts, 1588-9 [v]\n",
  "MARQUE": "(French) a make or brand of something, esp. a motor vehicle [n -S]\n",
  "MARQUEE": "a large tent with open sides for outdoor entertainment [n -S]\n",
  "MARQUEES": "MARQUEE, a large tent with open sides for outdoor entertainment [n]\n",
  "MARQUES": "MARQUE, (French) a make or brand of something, esp. a motor vehicle [n]\n",
  "MARQUESS": "a British or Irish hereditary nobleman of the second rank of the peerage, below a duke and above an earl, also MARQUIS [n -ES]\n",
  "MARQUESSATE": "the rank of marquess [n -S]\n",
  "MARQUESSATES": "MARQUESSATE, the rank of marquess [n]\n",
  "MARQUESSES": "MARQUESS, a British or Irish hereditary nobleman of the second rank of the peerage, below a duke and above an earl, also MARQUIS [n]\n",
  "MARQUETERIE": "(French) furniture inlaid with multicoloured wood, ivory, or metal, also MARQUETRY [n -S]\n",
  "MARQUETERIES": "MARQUETERIE, (French) furniture inlaid with multicoloured wood, ivory, or metal, also MARQUETRY [n]\n",
  "MARQUETRIES": "MARQUETRY, furniture inlaid with multicoloured wood, ivory, or metal, also MARQUETERIE [n]\n",
  "MARQUETRY": "furniture inlaid with multicoloured wood, ivory, or metal, also MARQUETERIE [n MARQUETRIES]\n",
  "MARQUIS": "a British or Irish hereditary nobleman of the second rank of the peerage, below a duke and above an earl, also MARQUESS [n -ES]\n",
  "MARQUISATE": "the rank of a marquis [n -S]\n",
  "MARQUISATES": "MARQUISATE, the rank of a marquis [n]\n",
  "MARQUISE": "(French) the wife or widow of a marquis [n -S]\n",
  "MARQUISES": "MARQUIS, a British or Irish hereditary nobleman of the second rank of the peerage, below a duke and above an earl, also MARQUESS [n]\n",
  "MARQUISETTE": "a sheer fabric of cotton, rayon, silk, or nylon [n -S]\n",
  "MARQUISETTES": "MARQUISETTE, a sheer fabric of cotton, rayon, silk, or nylon [n]\n",
  "MARRA": "a Northern English dialect form of mate [n -S]\n",
  "MARRAM": "(Old Norse) a seaside grass, also MARRUM [n -S]\n",
  "MARRAMS": "MARRAM, (Old Norse) a seaside grass, also MARRUM [n]\n",
  "MARRANO": "(Spanish) a Jew who has converted to Christianity to avoid persecution [n -S]\n",
  "MARRANOS": "MARRANO, (Spanish) a Jew who has converted to Christianity to avoid persecution [n]\n",
  "MARRAS": "MARRA, a Northern English dialect form of mate [n]\n",
  "MARRED": "MAR, to spoil or damage [v]\n",
  "MARRELS": "a rustic game, aka fivepenny morris, also MERELLS, MERELS, MERILS [n]\n",
  "MARRER": "one who mars or injures [n -S]\n",
  "MARRERS": "MARRER, one who mars or injures [n]\n",
  "MARRI": "(Native Australian) a eucalyptus of West Australia, with coloured flowers [n -S]\n",
  "MARRIAGE": "the legal union of a man and woman [n -S]\n",
  "MARRIAGEABILITY": "the state of being marriageable [n]\n",
  "MARRIAGEABLE": "fit for or capable of marriage [adj]\n",
  "MARRIAGES": "MARRIAGE, the legal union of a man and woman [n]\n",
  "MARRIED": "one who has entered into marriage [n -S]\n",
  "MARRIEDS": "MARRIED, one who has entered into marriage [n]\n",
  "MARRIER": "one who marries [n -S]\n",
  "MARRIERS": "MARRIER, one who marries [n]\n",
  "MARRIES": "MARRY, to enter into marriage [v]\n",
  "MARRING": "MAR, to spoil or damage [v]\n",
  "MARRIS": "MARRI, (Native Australian) a eucalyptus of West Australia, with coloured flowers [n]\n",
  "MARRON": "(Native Australian) a freshwater crayfish of West Australia, also CAMARON, MARON [n -S]\n",
  "MARRONS": "MARRON, (Native Australian) a freshwater crayfish of West Australia, also CAMARON, MARON [n]\n",
  "MARROW": "to be a mate or companion [v -ED, -ING, -S]\n",
  "MARROWBONE": "a bone containing marrow; in plural, the knees [n -S]\n",
  "MARROWBONES": "MARROWBONE, a bone containing marrow; in plural, the knees [n]\n",
  "MARROWED": "MARROW, to be a mate or companion [v]\n",
  "MARROWFAT": "a rich but late variety of pea [n -S]\n",
  "MARROWFATS": "MARROWFAT, a rich but late variety of pea [n]\n",
  "MARROWIER": "MARROWY, full of marrow; pithy [adj]\n",
  "MARROWIEST": "MARROWY, full of marrow; pithy [adj]\n",
  "MARROWING": "MARROW, to be a mate or companion [v]\n",
  "MARROWISH": "of the nature of, or like, marrow [adj]\n",
  "MARROWLESS": "destitute of marrow [adj]\n",
  "MARROWS": "MARROW, to be a mate or companion [v]\n",
  "MARROWSKIED": "MARROWSKY, to utter a spoonerism [v]\n",
  "MARROWSKIES": "MARROWSKY, to utter a spoonerism [v]\n",
  "MARROWSKY": "a spoonerism [n MARROWSKIES] / to utter a spoonerism [v MARROWSKIED, MARROWSKYING, MARROWSKIES]\n",
  "MARROWSKYING": "MARROWSKY, to utter a spoonerism [v]\n",
  "MARROWY": "full of marrow; pithy [adj MARROWIER, MARROWIEST]\n",
  "MARRUM": "(Old Norse) a seaside grass, also MARRAM [n -S]\n",
  "MARRUMS": "MARRUM, (Old Norse) a seaside grass, also MARRAM [n]\n",
  "MARRY": "to enter into marriage [v MARRIED, MARRYING, MARRIES]\n",
  "MARRYING": "the act of marrying [n -S]\n",
  "MARRYINGS": "MARRYING, the act of marrying [n]\n",
  "MARS": "MAR, to spoil or damage [v]\n",
  "MARSALA": "(Italian) a kind of wine exported from Marsala in Sicily [n -S]\n",
  "MARSALAS": "MARSALA, (Italian) a kind of wine exported from Marsala in Sicily [n]\n",
  "MARSE": "(US) master [n -S]\n",
  "MARSEILLE": "(French) a strong cotton fabric with a raised pattern, used for bedspreads etc. [n -S]\n",
  "MARSEILLES": "MARSEILLE, (French) a strong cotton fabric with a raised pattern, used for bedspreads etc. [n]\n",
  "MARSES": "MARSE, (US) master [n]\n",
  "MARSH": "a tract of low, wet land, also MARISH [n -ES]\n",
  "MARSHAL": "to put in proper order, also MARSHALL [v MARSHALED or MARSHALLED, MARSHALING or MARSHALLING, MARSHALS]\n",
  "MARSHALCIES": "MARSHALCY, the rank, office or department of a marshal [n]\n",
  "MARSHALCY": "the rank, office or department of a marshal [n MARSHALCIES]\n",
  "MARSHALED": "MARSHAL, to put in proper order, also MARSHALL [v]\n",
  "MARSHALER": "one who marshals, also MARSHALLER [n -S]\n",
  "MARSHALERS": "MARSHALER, one who marshals, also MARSHALLER [n]\n",
  "MARSHALING": "MARSHAL, to put in proper order, also MARSHALL [v]\n",
  "MARSHALL": "to put in proper order, also MARSHAL [v -ED, -ING, -S]\n",
  "MARSHALLED": "MARSHALL, to put in proper order, also MARSHAL [v]\n",
  "MARSHALLER": "one who marshals, also MARSHALER [n -S]\n",
  "MARSHALLERS": "MARSHALLER, one who marshals, also MARSHALER [n]\n",
  "MARSHALLING": "the act of putting into proper order [n -S]\n",
  "MARSHALLINGS": "MARSHALLING, the act of putting into proper order [n]\n",
  "MARSHALLS": "MARSHALL, to put in proper order, also MARSHAL [v]\n",
  "MARSHALS": "MARSHAL, to put in proper order, also MARSHALL [v]\n",
  "MARSHALSHIP": "the office of marshal [n -S]\n",
  "MARSHALSHIPS": "MARSHALSHIP, the office of marshal [n]\n",
  "MARSHBUCK": "an antelope of Central Africa [n -S]\n",
  "MARSHBUCKS": "MARSHBUCK, an antelope of Central Africa [n]\n",
  "MARSHED": "having a marsh [adj]\n",
  "MARSHELDER": "a herbaceous, oily, annual plant native to North America and once cultivated for its edible seeds, aka sumpweed [n -S]\n",
  "MARSHELDERS": "MARSHELDER, a herbaceous, oily, annual plant native to North America and once cultivated for its edible seeds, aka sumpweed [n]\n",
  "MARSHES": "MARSH, a tract of low, wet land, also MARISH [n]\n",
  "MARSHIER": "MARSHY, resembling a marsh [adj]\n",
  "MARSHIEST": "MARSHY, resembling a marsh [adj]\n",
  "MARSHINESS": "the state of being marshy [n -ES]\n",
  "MARSHINESSES": "MARSHINESS, the state of being marshy [n]\n",
  "MARSHLAND": "low poorly drained land that is sometimes flooded and often lies at the edge of lakes, streams, etc. [n -S]\n",
  "MARSHLANDER": "one who lives in marshland [n -S]\n",
  "MARSHLANDERS": "MARSHLANDER, one who lives in marshland [n]\n",
  "MARSHLANDS": "MARSHLAND, low poorly drained land that is sometimes flooded and often lies at the edge of lakes, streams, etc. [n]\n",
  "MARSHLIKE": "like a marsh [adj]\n",
  "MARSHLOCKS": "a marsh-growing species of cinquefoil [n -ES]\n",
  "MARSHLOCKSES": "MARSHLOCKS, a marsh-growing species of cinquefoil [n]\n",
  "MARSHMALLOW": "a spongy, jellylike sweet [n -S]\n",
  "MARSHMALLOWIER": "MARSHMALLOWY, of or like marshmallow [adj]\n",
  "MARSHMALLOWIEST": "MARSHMALLOWY, of or like marshmallow [adj]\n",
  "MARSHMALLOWS": "MARSHMALLOW, a spongy, jellylike sweet [n]\n",
  "MARSHMALLOWY": "of or like marshmallow [adj MARSHMALLOWIER, MARSHMALLOWIEST]\n",
  "MARSHWORT": "a small umbelliferous marsh plant related to celery [n -S]\n",
  "MARSHWORTS": "MARSHWORT, a small umbelliferous marsh plant related to celery [n]\n",
  "MARSHY": "resembling a marsh [adj MARSHIER, MARSHIEST]\n",
  "MARSIPOBRANCH": "a member of the Marsipobranchi, the Cyclostomata [n -S]\n",
  "MARSIPOBRANCHS": "MARSIPOBRANCH, a member of the Marsipobranchi, the Cyclostomata [n]\n",
  "MARSPORT": "(archaic) a spoilsport [n -S]\n",
  "MARSPORTS": "MARSPORT, (archaic) a spoilsport [n]\n",
  "MARSQUAKE": "a violent tremor on Mars [n -S]\n",
  "MARSQUAKES": "MARSQUAKE, a violent tremor on Mars [n]\n",
  "MARSUPIA": "MARSUPIUM, (Latin) the pouch, formed by a fold of the skin of the abdomen, in which marsupials carry their young [n]\n",
  "MARSUPIAL": "relating to a pouch or to the Marsupialia [adj] / a pouched mammal, also MARSUPIAN [n -S]\n",
  "MARSUPIALIAN": "a marsupial mammal [n -S]\n",
  "MARSUPIALIANS": "MARSUPIALIAN, a marsupial mammal [n]\n",
  "MARSUPIALS": "MARSUPIAL, a pouched mammal, also MARSUPIAN [n]\n",
  "MARSUPIAN": "a pouched mammal, also MARSUPIAL [n -S]\n",
  "MARSUPIANS": "MARSUPIAN, a pouched mammal, also MARSUPIAL [n]\n",
  "MARSUPIUM": "(Latin) the pouch, formed by a fold of the skin of the abdomen, in which marsupials carry their young [n MARSUPIA]\n",
  "MART": "to sell, trade [v -ED, -ING, -S]\n",
  "MARTAGON": "a kind of lily [n -S]\n",
  "MARTAGONS": "MARTAGON, a kind of lily [n]\n",
  "MARTED": "MART, to sell, trade [v]\n",
  "MARTEL": "(historical) a mediaeval hammer-like weapon with a pointed head [n -S] / (Spenser) to make a blow with this [v MARTELLED, MARTELLING, MARTELS]\n",
  "MARTELLANDO": "(Italian) the act of playing the violin with a hammering touch, or with short quick detached movements of the bow [n -S]\n",
  "MARTELLANDOS": "MARTELLANDO, (Italian) the act of playing the violin with a hammering touch, or with short quick detached movements of the bow [n]\n",
  "MARTELLATO": "(Italian) (in string playing) the practice of bowing the string with a succession of short sharp blows [n -S]\n",
  "MARTELLATOS": "MARTELLATO, (Italian) (in string playing) the practice of bowing the string with a succession of short sharp blows [n]\n",
  "MARTELLED": "MARTEL, (Spenser) to make a blow with this [v]\n",
  "MARTELLING": "MARTEL, (Spenser) to make a blow with this [v]\n",
  "MARTELLO": "(Italian) a circular fort for coastal defence [n -S]\n",
  "MARTELLOS": "MARTELLO, (Italian) a circular fort for coastal defence [n]\n",
  "MARTELS": "MARTEL, (Spenser) to make a blow with this [v]\n",
  "MARTEN": "a carnivore of the mustelid family [n -S]\n",
  "MARTENS": "MARTEN, a carnivore of the mustelid family [n]\n",
  "MARTENSITE": "the chief constituent of hardened carbon tool steels [n -S]\n",
  "MARTENSITES": "MARTENSITE, the chief constituent of hardened carbon tool steels [n]\n",
  "MARTENSITIC": "relating to martensite [adj MARTENSITICALLY]\n",
  "MARTENSITICALLY": "MARTENSITIC, relating to martensite [adv]\n",
  "MARTEXT": "an ignorant preacher [n -S]\n",
  "MARTEXTS": "MARTEXT, an ignorant preacher [n]\n",
  "MARTIAL": "pertaining to war [adj MARTIALLY] / a court martial [n -S]\n",
  "MARTIALISM": "the quality of being warlike; exercises suitable for war [n -S]\n",
  "MARTIALISMS": "MARTIALISM, the quality of being warlike; exercises suitable for war [n]\n",
  "MARTIALIST": "a warrior [n -S]\n",
  "MARTIALISTS": "MARTIALIST, a warrior [n]\n",
  "MARTIALLY": "MARTIAL, pertaining to war [adv]\n",
  "MARTIALNESS": "the state of being martial [n -ES]\n",
  "MARTIALNESSES": "MARTIALNESS, the state of being martial [n]\n",
  "MARTIALS": "MARTIAL, a court martial [n]\n",
  "MARTIAN": "a supposed inhabitant of the planet Mars [n -S]\n",
  "MARTIANS": "MARTIAN, a supposed inhabitant of the planet Mars [n]\n",
  "MARTIN": "a bird of the swallow family [n -S]\n",
  "MARTINET": "(French) a strict disciplinarian [n -S]\n",
  "MARTINETISH": "like a martinet [adj]\n",
  "MARTINETISM": "the state of being a martinet [n -S]\n",
  "MARTINETISMS": "MARTINETISM, the state of being a martinet [n]\n",
  "MARTINETS": "MARTINET, (French) a strict disciplinarian [n]\n",
  "MARTING": "MART, to sell, trade [v]\n",
  "MARTINGAL": "a strap from the reins to the girth of a horse preventing it from carrying its head too high, also MARTINGALE [n -S]\n",
  "MARTINGALE": "a strap from the reins to the girth of a horse preventing it from carrying its head too high, also MARTINGAL [n -S]\n",
  "MARTINGALES": "MARTINGALE, a strap from the reins to the girth of a horse preventing it from carrying its head too high, also MARTINGAL [n]\n",
  "MARTINGALS": "MARTINGAL, a strap from the reins to the girth of a horse preventing it from carrying its head too high, also MARTINGALE [n]\n",
  "MARTINI": "an alcoholic cocktail a type of vermouth [n -S]\n",
  "MARTINIS": "MARTINI, an alcoholic cocktail a type of vermouth [n]\n",
  "MARTINS": "MARTIN, a bird of the swallow family [n]\n",
  "MARTLET": "a small bird, also MARTIN [n -S]\n",
  "MARTLETS": "MARTLET, a small bird, also MARTIN [n]\n",
  "MARTS": "MART, to sell, trade [v]\n",
  "MARTYR": "to put someone to death for adhering to a belief [v -ED, -ING, -S]\n",
  "MARTYRDOM": "the state of being a martyr [n -S]\n",
  "MARTYRDOMS": "MARTYRDOM, the state of being a martyr [n]\n",
  "MARTYRED": "MARTYR, to put someone to death for adhering to a belief [v]\n",
  "MARTYRIA": "MARTYRIUM, (Latin) a shrine erected in honour of a martyred person, also MARTYRY [n]\n",
  "MARTYRIES": "MARTYRY, a shrine erected in honour of a martyred person, also MARTYRIUM [n]\n",
  "MARTYRING": "MARTYR, to put someone to death for adhering to a belief [v]\n",
  "MARTYRISATION": "the act of martyrising, also MARTYRIZATION [n -S]\n",
  "MARTYRISATIONS": "MARTYRISATION, the act of martyrising, also MARTYRIZATION [n]\n",
  "MARTYRISE": "to cause to suffer martyrdom, also MARTYRIZE [v MARTYRISED, MARTYRISING, MARTYRISES]\n",
  "MARTYRISED": "MARTYRISE, to cause to suffer martyrdom, also MARTYRIZE [v]\n",
  "MARTYRISES": "MARTYRISE, to cause to suffer martyrdom, also MARTYRIZE [v]\n",
  "MARTYRISH": "somewhat like a martyr [adj]\n",
  "MARTYRISING": "MARTYRISE, to cause to suffer martyrdom, also MARTYRIZE [v]\n",
  "MARTYRIUM": "(Latin) a shrine erected in honour of a martyred person, also MARTYRY [n MARTYRIA]\n",
  "MARTYRIZATION": "the act of martyrizing, also MARTYRISATION [n -S]\n",
  "MARTYRIZATIONS": "MARTYRIZATION, the act of martyrizing, also MARTYRISATION [n]\n",
  "MARTYRIZE": "to offer as a sacrifice; to cause to suffer martyrdom, also MARTYRISE [v MARTYRIZED, MARTYRIZING, MARTYRIZES]\n",
  "MARTYRIZED": "MARTYRIZE, to offer as a sacrifice; to cause to suffer martyrdom, also MARTYRISE [v]\n",
  "MARTYRIZES": "MARTYRIZE, to offer as a sacrifice; to cause to suffer martyrdom, also MARTYRISE [v]\n",
  "MARTYRIZING": "MARTYRIZE, to offer as a sacrifice; to cause to suffer martyrdom, also MARTYRISE [v]\n",
  "MARTYRLY": "resembling martyr [adj]\n",
  "MARTYROLOGIC": "relating to martyrology, also MARTYROLOGICAL [adj]\n",
  "MARTYROLOGICAL": "related to martyrology, also MARTYROLOGIC [adj]\n",
  "MARTYROLOGIES": "MARTYROLOGY, the study of martyrs [n]\n",
  "MARTYROLOGIST": "a writer of or a specialist in martyrology [n -S]\n",
  "MARTYROLOGISTS": "MARTYROLOGIST, a writer of or a specialist in martyrology [n]\n",
  "MARTYROLOGY": "the study of martyrs [n MARTYROLOGIES]\n",
  "MARTYRS": "MARTYR, to put someone to death for adhering to a belief [v]\n",
  "MARTYRY": "a shrine erected in honour of a martyred person, also MARTYRIUM [n MARTYRIES]\n",
  "MARVEL": "to be filled with wonder [v MARVELED or MARVELLED, MARVELING or MARVELLING, MARVELS]\n",
  "MARVELED": "MARVEL, to be filled with wonder [v]\n",
  "MARVELER": "one who marvels, also MARVELLER [n -S]\n",
  "MARVELERS": "MARVELER, one who marvels, also MARVELLER [n]\n",
  "MARVELING": "MARVEL, to be filled with wonder [v]\n",
  "MARVELLED": "MARVEL, to be filled with wonder [v]\n",
  "MARVELLER": "one who marvels, also MARVELER [n -S]\n",
  "MARVELLERS": "MARVELLER, one who marvels, also MARVELER [n]\n",
  "MARVELLING": "MARVEL, to be filled with wonder [v]\n",
  "MARVELLOUS": "astonishing, very pleasing, also MARVELOUS [adj MARVELLOUSLY]\n",
  "MARVELLOUSLY": "MARVELLOUS, astonishing, very pleasing, also MARVELOUS [adv]\n",
  "MARVELLOUSNESS": "MARVELLOUS, astonishing, very pleasing, also MARVELOUS [n]\n",
  "MARVELOUS": "(US) astonishing, very pleasing, also MARVELLOUS [adj MARVELOUSLY]\n",
  "MARVELOUSLY": "MARVELOUS, (US) astonishing, very pleasing, also MARVELLOUS [adv]\n",
  "MARVELOUSNESS": "the state of being marvelous, also MARVELLOUSNESS [n -ES]\n",
  "MARVELOUSNESSES": "MARVELOUSNESS, the state of being marvelous, also MARVELLOUSNESS [n]\n",
  "MARVELS": "MARVEL, to be filled with wonder [v]\n",
  "MARVER": "a marble or iron slab on which molten glass is rolled [n -S] / to roll glass on a marver [v -ED, -ING, -S]\n",
  "MARVERED": "MARVER, to roll glass on a marver [v]\n",
  "MARVERING": "MARVER, to roll glass on a marver [v]\n",
  "MARVERS": "MARVER, to roll glass on a marver [v]\n",
  "MARVIER": "MARVY, marvellous [adj]\n",
  "MARVIEST": "MARVY, marvellous [adj]\n",
  "MARVY": "marvellous [adj MARVIER, MARVIEST]\n",
  "MARXISANT": "(French) of Marxist sympathies [adj]\n",
  "MARY": "(Australian slang) a woman, esp. an aboriginal woman [n MARIES]\n",
  "MARYBUD": "a marigold bud [n -S]\n",
  "MARYBUDS": "MARYBUD, a marigold bud [n]\n",
  "MARYJANE": "(slang) marijuana [n -S]\n",
  "MARYJANES": "MARYJANE, (slang) marijuana [n]\n",
  "MARZIPAN": "a confection of ground almonds, egg whites, and sugar [n -S] / to cover with marzipan [v MARZIPANNED, MARZIPANNING, MARZIPANS]\n",
  "MARZIPANNED": "MARZIPAN, to cover with marzipan [v]\n",
  "MARZIPANNING": "MARZIPAN, to cover with marzipan [v]\n",
  "MARZIPANS": "MARZIPAN, a confection of ground almonds, egg whites, and sugar [n]\n",
  "MAS": "a house or home in the south of France [n MAS]\n",
  "MASA": "(Spanish) in Mexican cooking, a dough made from masa harina, ground, dried maize and used to make tamales etc. [n -S]\n",
  "MASALA": "(Urdu) a mixture of ground spices used in Indian cookery [n -S]\n",
  "MASALAS": "MASALA, (Urdu) a mixture of ground spices used in Indian cookery [n]\n",
  "MASAS": "MASA, (Spanish) in Mexican cooking, a dough made from masa harina, ground, dried maize and used to make tamales etc. [n]\n",
  "MASCARA": "(Italian) a colouring for the eyelashes, a cosmetic [n -S] / to apply mascara [v -ED, -ING, -S]\n",
  "MASCARAED": "MASCARA, to apply mascara [v]\n",
  "MASCARAING": "MASCARA, to apply mascara [v]\n",
  "MASCARAS": "MASCARA, to apply mascara [v]\n",
  "MASCARON": "a grotesque face on a doorknocker [n -S]\n",
  "MASCARONS": "MASCARON, a grotesque face on a doorknocker [n]\n",
  "MASCARPONE": "(Italian) an Italian soft cheese, like ricotta [n -S]\n",
  "MASCARPONES": "MASCARPONE, (Italian) an Italian soft cheese, like ricotta [n]\n",
  "MASCLE": "a diamond-shaped plate or scale [n -S]\n",
  "MASCLED": "covered with mascles, a diamond-shaped plate or scale [adj]\n",
  "MASCLES": "MASCLE, a diamond-shaped plate or scale [n]\n",
  "MASCON": "a concentration of dense mass beneath the moon's surface [n -S]\n",
  "MASCONS": "MASCON, a concentration of dense mass beneath the moon's surface [n]\n",
  "MASCOT": "a talisman, or anything supposed to bring good luck [n -S]\n",
  "MASCOTS": "MASCOT, a talisman, or anything supposed to bring good luck [n]\n",
  "MASCULINE": "male [adj MASCULINELY] / the male sex or nature [n -S]\n",
  "MASCULINELY": "MASCULINE, male [adv]\n",
  "MASCULINENESS": "MASCULINE, male [n]\n",
  "MASCULINENESSES": "MASCULINENESS, MASCULINE, male [n]\n",
  "MASCULINES": "MASCULINE, the male sex or nature [n]\n",
  "MASCULINISATION": "the process of masculinising, also MASCULINIZATION [n]\n",
  "MASCULINISE": "to make masculine, also MASCULINIZE [v MASCULINISED, MASCULINISING, MASCULINISES]\n",
  "MASCULINISED": "MASCULINISE, to make masculine, also MASCULINIZE [v]\n",
  "MASCULINISES": "MASCULINISE, to make masculine, also MASCULINIZE [v]\n",
  "MASCULINISING": "MASCULINISE, to make masculine, also MASCULINIZE [v]\n",
  "MASCULINIST": "an advocate of men's rights [n -S]\n",
  "MASCULINISTS": "MASCULINIST, an advocate of men's rights [n]\n",
  "MASCULINITIES": "MASCULINITY, the state of being masculine [n]\n",
  "MASCULINITY": "the state of being masculine [n MASCULINITIES]\n",
  "MASCULINIZATION": "the act of masculinizing, also MASCULINISATION [n]\n",
  "MASCULINIZE": "to make masculine, also MASCULINISE [v MASCULINIZED, MASCULINIZING, MASCULINIZES]\n",
  "MASCULINIZED": "MASCULINIZE, to make masculine, also MASCULINISE [v]\n",
  "MASCULINIZES": "MASCULINIZE, to make masculine, also MASCULINISE [v]\n",
  "MASCULINIZING": "MASCULINIZE, to make masculine, also MASCULINISE [v]\n",
  "MASCULIST": "an advocate of the rights of men [n -S]\n",
  "MASCULISTS": "MASCULIST, an advocate of the rights of men [n]\n",
  "MASCULY": "covered with mascles, diamond-shaped plates or scales [adj]\n",
  "MASE": "to act as a maser, a device used to amplify long-range radar and radio astronomy signals [v MASED, MASING, MASES]\n",
  "MASED": "MASE, to act as a maser, a device used to amplify long-range radar and radio astronomy signals [v]\n",
  "MASER": "a device used to amplify long-range radar and radio astronomy signals [n -S]\n",
  "MASERS": "MASER, a device used to amplify long-range radar and radio astronomy signals [n]\n",
  "MASES": "MASE, to act as a maser, a device used to amplify long-range radar and radio astronomy signals [v]\n",
  "MASH": "to pound down and crush together [v -ED, -ING, -ES]\n",
  "MASHALLAH": "(Arabic) what God will [interj]\n",
  "MASHED": "MASH, to pound down and crush together [v]\n",
  "MASHER": "a dandy frequenting music halls etc.; a beau, a lady-killer [n -S]\n",
  "MASHERS": "MASHER, a dandy frequenting music halls etc.; a beau, a lady-killer [n]\n",
  "MASHES": "MASH, to pound down and crush together [v]\n",
  "MASHGIACH": "(Hebrew) a person who ensures adherence to kosher rules, also MASHGIAH [n MASHGICHIM]\n",
  "MASHGIAH": "(Hebrew) a person who ensures adherence to kosher rules, also MASHGIACH [n MASHGIHIM]\n",
  "MASHGICHIM": "MASHGIACH, (Hebrew) a person who ensures adherence to kosher rules, also MASHGIAH [n]\n",
  "MASHGIHIM": "MASHGIAH, (Hebrew) a person who ensures adherence to kosher rules, also MASHGIACH [n]\n",
  "MASHIACH": "(Hebrew) in Judaism, the Messiah [n -S]\n",
  "MASHIACHS": "MASHIACH, (Hebrew) in Judaism, the Messiah [n]\n",
  "MASHIE": "a kind of golf club [n -S]\n",
  "MASHIER": "MASHY, of the nature of a mash [adj]\n",
  "MASHIES": "MASHIE, a kind of golf club [n]\n",
  "MASHIEST": "MASHY, of the nature of a mash [adj]\n",
  "MASHING": "the act of mashing [n -S]\n",
  "MASHINGS": "MASHING, the act of mashing [n]\n",
  "MASHLAM": "a mixed grain, also MASHLIM, MASHLIN, MASHLOCH, MASHLUM, MASLIN, MONGCORN [n -S]\n",
  "MASHLAMS": "MASHLAM, a mixed grain, also MASHLIM, MASHLIN, MASHLOCH, MASHLUM, MASLIN, MONGCORN [n]\n",
  "MASHLIM": "a mixed grain, also MASHLAM, MASHLIN, MASHLOCH, MASHLUM, MASLIN, MONGCORN [n -S]\n",
  "MASHLIMS": "MASHLIM, a mixed grain, also MASHLAM, MASHLIN, MASHLOCH, MASHLUM, MASLIN, MONGCORN [n]\n",
  "MASHLIN": "a mixed grain, also MASHLAM, MASHLIM, MASHLOCH, MASHLUM, MASLIN, MONGCORN [n -S]\n",
  "MASHLINS": "MASHLIN, a mixed grain, also MASHLAM, MASHLIM, MASHLOCH, MASHLUM, MASLIN, MONGCORN [n]\n",
  "MASHLOCH": "a mixed grain, also MASHLAM, MASHLIM, MASHLIN, MASHLUM, MASLIN, MONGCORN [n -S]\n",
  "MASHLOCHS": "MASHLOCH, a mixed grain, also MASHLAM, MASHLIM, MASHLIN, MASHLUM, MASLIN, MONGCORN [n]\n",
  "MASHLUM": "(Scots) a mixed grain, also MASHLAM, MASHLIM, MASHLIN, MASHLOCH, MASLIN, MONGCORN [n -S]\n",
  "MASHLUMS": "MASHLUM, (Scots) a mixed grain, also MASHLAM, MASHLIM, MASHLIN, MASHLOCH, MASLIN, MONGCORN [n]\n",
  "MASHMAN": "a worker in a brewery who helps to make the mash [n MASHMEN]\n",
  "MASHMEN": "MASHMAN, a worker in a brewery who helps to make the mash [n]\n",
  "MASHUA": "a tuber plant grown in the Andes [n -S]\n",
  "MASHUAS": "MASHUA, a tuber plant grown in the Andes [n]\n",
  "MASHUP": "a piece of live or recorded music in which a producer blends together two or more tracks, often from contrasting genres [n -S]\n",
  "MASHUPS": "MASHUP, a piece of live or recorded music in which a producer blends together two or more tracks, often from contrasting genres [n]\n",
  "MASHY": "of the nature of a mash [adj MASHIER, MASHIEST]\n",
  "MASING": "MASE, to act as a maser, a device used to amplify long-range radar and radio astronomy signals [v]\n",
  "MASJID": "(Arabic) a mosque, also MUSJID [n -S]\n",
  "MASJIDS": "MASJID, (Arabic) a mosque, also MUSJID [n]\n",
  "MASK": "to cover, cloak or disguise [v -ED, -ING, -S]\n",
  "MASKABLE": "able to be masked [adj]\n",
  "MASKALLONGE": "a North American freshwater fish of the pike family, also MASKALONGE, MASKANONGE, MASKINONGE, MUSKELLUNGE, MUSKIE [n -S]\n",
  "MASKALLONGES": "MASKALLONGE, a North American freshwater fish of the pike family, also MASKALONGE, MASKANONGE, MASKINONGE, MUSKELLUNGE, MUSKIE [n]\n",
  "MASKALONGE": "a North American freshwater fish of the pike family, also MASKALLONGE, MASKANONGE, MASKINONGE, MUSKELLUNGE, MUSKIE [n -S]\n",
  "MASKALONGES": "MASKALONGE, a North American freshwater fish of the pike family, also MASKALLONGE, MASKANONGE, MASKINONGE, MUSKELLUNGE, MUSKIE [n]\n",
  "MASKANONGE": "a North American freshwater fish of the pike family, also MASKALLONGE, MASKALONGE, MASKINONGE, MUSKELLUNGE, MUSKIE [n -S]\n",
  "MASKANONGES": "MASKANONGE, a North American freshwater fish of the pike family, also MASKALLONGE, MASKALONGE, MASKINONGE, MUSKELLUNGE, MUSKIE [n]\n",
  "MASKED": "MASK, to cover, cloak or disguise [v]\n",
  "MASKEG": "(Native American) a swamp, bog or marsh, also MUSKEG [n -S]\n",
  "MASKEGS": "MASKEG, (Native American) a swamp, bog or marsh, also MUSKEG [n]\n",
  "MASKER": "one who wears a mask, also MASQUER [n -S]\n",
  "MASKERS": "MASKER, one who wears a mask, also MASQUER [n]\n",
  "MASKING": "a piece of scenery used to conceal parts of the stage [n -S]\n",
  "MASKINGS": "MASKING, a piece of scenery used to conceal parts of the stage [n]\n",
  "MASKINONGE": "a North American freshwater fish of the pike family, also MASKALLONGE, MASKALONGE, MASKANONGE, MUSKELLUNGE, MUSKIE [n -S]\n",
  "MASKINONGES": "MASKINONGE, a North American freshwater fish of the pike family, also MASKALLONGE, MASKALONGE, MASKANONGE, MUSKELLUNGE, MUSKIE [n]\n",
  "MASKIROVKA": "(Russian) use of deception or camouflage as military stratagem [n -S]\n",
  "MASKIROVKAS": "MASKIROVKA, (Russian) use of deception or camouflage as military stratagem [n]\n",
  "MASKLIKE": "like a mask [adj]\n",
  "MASKS": "MASK, to cover, cloak or disguise [v]\n",
  "MASLIN": "a mixed grain, also MASHLAM, MASHLIM, MASHLIN, MASHLOCH, MASHLUM, MONGCORN [n -S]\n",
  "MASLINS": "MASLIN, a mixed grain, also MASHLAM, MASHLIM, MASHLIN, MASHLOCH, MASHLUM, MONGCORN [n]\n",
  "MASOCHISM": "the derivation of sexual gratification from the suffering of pain [n -S]\n",
  "MASOCHISMS": "MASOCHISM, the derivation of sexual gratification from the suffering of pain [n]\n",
  "MASOCHIST": "one who derives sexual gratification from the suffering of pain [n -S]\n",
  "MASOCHISTIC": "relating to masochism [adj MASOCHISTICALLY]\n",
  "MASOCHISTICALLY": "MASOCHISTIC, relating to masochism [adv]\n",
  "MASOCHISTS": "MASOCHIST, one who derives sexual gratification from the suffering of pain [n]\n",
  "MASON": "a person who cuts, prepares and lays stones [n -S] / to build or repair in stone [v -ED, -ING, -S]\n",
  "MASONED": "MASON, to build or repair in stone [v]\n",
  "MASONIC": "relating to freemasonry [adj MASONICALLY]\n",
  "MASONICALLY": "MASONIC, relating to freemasonry [adv]\n",
  "MASONING": "MASON, to build or repair in stone [v]\n",
  "MASONITE": "(tradename) a kind of dark brown hardboard [n -S]\n",
  "MASONITES": "MASONITE, (tradename) a kind of dark brown hardboard [n]\n",
  "MASONRIED": "constructed of masonry [adj]\n",
  "MASONRIES": "MASONRY, the craft of a mason; stonework or brickwork [n]\n",
  "MASONRY": "the craft of a mason; stonework or brickwork [n MASONRIES]\n",
  "MASONS": "MASON, to build or repair in stone [v]\n",
  "MASOOLAH": "an Indian surfboat, also MASSOOLA, MASULA [n -S]\n",
  "MASOOLAHS": "MASOOLAH, an Indian surfboat, also MASSOOLA, MASULA [n]\n",
  "MASQUE": "a dramatic entertainment formerly popular in England [n -S]\n",
  "MASQUER": "one who wears a mask, also MASKER [n -S]\n",
  "MASQUERADE": "an assembly of people wearing masks, costumes, esp. at a ball [n -S] / to disguise oneself [v MASQUERADED, MASQUERADING, MASQUERADES]\n",
  "MASQUERADED": "MASQUERADE, to disguise oneself [v]\n",
  "MASQUERADER": "one who masquerades [n -S]\n",
  "MASQUERADERS": "MASQUERADER, one who masquerades [n]\n",
  "MASQUERADES": "MASQUERADE, to disguise oneself [v]\n",
  "MASQUERADING": "MASQUERADE, to disguise oneself [v]\n",
  "MASQUERS": "MASQUER, one who wears a mask, also MASKER [n]\n",
  "MASQUES": "MASQUE, a dramatic entertainment formerly popular in England [n]\n",
  "MASS": "to assemble as a body [v -ED, -ING, -ES]\n",
  "MASSA": "(US) master [n -S]\n",
  "MASSACRE": "to slaughter [v MASSACRED, MASSACRING, MASSACRES]\n",
  "MASSACRED": "MASSACRE, to slaughter [v]\n",
  "MASSACRER": "one who massacres [n -S]\n",
  "MASSACRERS": "MASSACRER, one who massacres [n]\n",
  "MASSACRES": "MASSACRE, to slaughter [v]\n",
  "MASSACRING": "MASSACRE, to slaughter [v]\n",
  "MASSAGE": "to knead or manipulate body parts [v MASSAGED, MASSAGING, MASSAGES]\n",
  "MASSAGED": "MASSAGE, to knead or manipulate body parts [v]\n",
  "MASSAGER": "one who massages [n -S]\n",
  "MASSAGERS": "MASSAGER, one who massages [n]\n",
  "MASSAGES": "MASSAGE, to knead or manipulate body parts [v]\n",
  "MASSAGING": "MASSAGE, to knead or manipulate body parts [v]\n",
  "MASSAGIST": "a masseur [n -S]\n",
  "MASSAGISTS": "MASSAGIST, a masseur [n]\n",
  "MASSARANDUBA": "(Tupi) the Brazilian milk-tree, also MACERANDUBA, MASSERANDUBA [n -S]\n",
  "MASSARANDUBAS": "MASSARANDUBA, (Tupi) the Brazilian milk-tree, also MACERANDUBA, MASSERANDUBA [n]\n",
  "MASSAS": "MASSA, (US) master [n]\n",
  "MASSASAUGA": "a kind of rattlesnake [n -S]\n",
  "MASSASAUGAS": "MASSASAUGA, a kind of rattlesnake [n]\n",
  "MASSCULT": "culture as promoted by the mass media [n -S]\n",
  "MASSCULTS": "MASSCULT, culture as promoted by the mass media [n]\n",
  "MASSE": "(French) a vertical shot in billiards [n -S]\n",
  "MASSED": "MASS, to assemble as a body [v]\n",
  "MASSEDLY": "MASSED, MASS, to assemble as a body [adv]\n",
  "MASSERANDUBA": "(Tupi) the Brazilian milk-tree, also MACERANDUBA, MASSARANDUBA [n -S]\n",
  "MASSERANDUBAS": "MASSERANDUBA, (Tupi) the Brazilian milk-tree, also MACERANDUBA, MASSARANDUBA [n]\n",
  "MASSES": "MASS, to assemble as a body [v]\n",
  "MASSETER": "a muscle that raises the lower jaw [n -S]\n",
  "MASSETERIC": "of or pertaining to the masseter, a muscle used to move the lower jaw [adj]\n",
  "MASSETERS": "MASSETER, a muscle that raises the lower jaw [n]\n",
  "MASSEUR": "(French) a male who makes a living by giving massage [n -S]\n",
  "MASSEURS": "MASSEUR, (French) a male who makes a living by giving massage [n]\n",
  "MASSEUSE": "(French) a female who makes a living by giving massage [n -S]\n",
  "MASSEUSES": "MASSEUSE, (French) a female who makes a living by giving massage [n]\n",
  "MASSICOT": "(French) yellow lead monoxide, also MASTICOT [n -S]\n",
  "MASSICOTS": "MASSICOT, (French) yellow lead monoxide, also MASTICOT [n]\n",
  "MASSIER": "MASSY, solid, full of mass [adj]\n",
  "MASSIEST": "MASSY, solid, full of mass [adj]\n",
  "MASSIF": "(French) a principal mountain mass [n -S]\n",
  "MASSIFICATION": "the practice of making luxury products available to the mass market [n -S]\n",
  "MASSIFICATIONS": "MASSIFICATION, the practice of making luxury products available to the mass market [n]\n",
  "MASSIFS": "MASSIF, (French) a principal mountain mass [n]\n",
  "MASSINESS": "the state of being massy [n -ES]\n",
  "MASSINESSES": "MASSINESS, the state of being massy [n]\n",
  "MASSING": "MASS, to assemble as a body [v]\n",
  "MASSIVE": "of great size [adj MASSIVELY] / a group of youths from a particular area [n -S]\n",
  "MASSIVELY": "MASSIVE, of great size [adv]\n",
  "MASSIVENESS": "the state of being massive [n -ES]\n",
  "MASSIVENESSES": "MASSIVENESS, the state of being massive [n]\n",
  "MASSIVES": "MASSIVE, a group of youths from a particular area [n]\n",
  "MASSLESS": "without mass e.g. of a particle [adj]\n",
  "MASSOOLA": "an Indian surfboat, also MASOOLAH, MASULA [n -S]\n",
  "MASSOOLAS": "MASSOOLA, an Indian surfboat, also MASOOLAH, MASULA [n]\n",
  "MASSOTHERAPIES": "MASSOTHERAPY, therapy using massage [n]\n",
  "MASSOTHERAPIST": "one who practises massotherapy, therapy using massage [n -S]\n",
  "MASSOTHERAPISTS": "MASSOTHERAPIST, one who practises massotherapy, therapy using massage [n]\n",
  "MASSOTHERAPY": "therapy using massage [n MASSOTHERAPIES]\n",
  "MASSPRIEST": "a priest retained in chantries to say masses for the dead [n -S]\n",
  "MASSPRIESTS": "MASSPRIEST, a priest retained in chantries to say masses for the dead [n]\n",
  "MASSTIGE": "the impression of exclusivity in goods that are affordable for many people [n -S]\n",
  "MASSTIGES": "MASSTIGE, the impression of exclusivity in goods that are affordable for many people [n]\n",
  "MASSY": "solid, full of mass [adj MASSIER, MASSIEST]\n",
  "MASSYMORE": "(Scott) a subterranean prison, also MATTAMORE [n -S]\n",
  "MASSYMORES": "MASSYMORE, (Scott) a subterranean prison, also MATTAMORE [n]\n",
  "MAST": "to provide with a long pole that supports a ship's sails [v -ED, -ING, -S]\n",
  "MASTABA": "(Arabic) an ancient Egyptian tomb, also MASTABAH [n -S]\n",
  "MASTABAH": "(Arabic) an ancient Egyptian tomb, also MASTABA [n -S]\n",
  "MASTABAHS": "MASTABAH, (Arabic) an ancient Egyptian tomb, also MASTABA [n]\n",
  "MASTABAS": "MASTABA, (Arabic) an ancient Egyptian tomb, also MASTABAH [n]\n",
  "MASTECTOMIES": "MASTECTOMY, the surgical excision of a breast [n]\n",
  "MASTECTOMY": "the surgical excision of a breast [n MASTECTOMIES]\n",
  "MASTED": "MAST, to provide with a long pole that supports a ship's sails [v]\n",
  "MASTER": "a person, esp. male, who commands and controls, also MAISTER, MAYSTER [n -S] / to become skilled in [v -ED, -ING, -S]\n",
  "MASTERATE": "(New Zealand) the status or dignity of a person holding a master's degree [n -S]\n",
  "MASTERATES": "MASTERATE, (New Zealand) the status or dignity of a person holding a master's degree [n]\n",
  "MASTERCLASS": "a session of tuition by an expert, esp. a musician, for exceptional students, usually given in public or on television [n -ES]\n",
  "MASTERCLASSES": "MASTERCLASS, a session of tuition by an expert, esp. a musician, for exceptional students, usually given in public or on television [n]\n",
  "MASTERDOM": "dominion; rule; command [n -S]\n",
  "MASTERDOMS": "MASTERDOM, dominion; rule; command [n]\n",
  "MASTERED": "MASTER, to become skilled in [v]\n",
  "MASTERFUL": "exercising the authority, skill or power of a master [adj MASTERFULLY]\n",
  "MASTERFULLY": "MASTERFUL, exercising the authority, skill or power of a master [adv]\n",
  "MASTERFULNESS": "MASTERFUL, exercising the authority, skill or power of a master [n]\n",
  "MASTERFULNESSES": "MASTERFULNESS, MASTERFUL, exercising the authority, skill or power of a master [n]\n",
  "MASTERHOOD": "the state of being a master [n -S]\n",
  "MASTERHOODS": "MASTERHOOD, the state of being a master [n]\n",
  "MASTERIES": "MASTERY, superior knowledge or skill, also MAISTRY [n]\n",
  "MASTERING": "the act of becoming skilled in [n -S]\n",
  "MASTERINGS": "MASTERING, the act of becoming skilled in [n]\n",
  "MASTERLESS": "destitute of a master or owner; ungoverned or ungovernable [adj]\n",
  "MASTERLIER": "MASTERLY, very skillful [adj]\n",
  "MASTERLIEST": "MASTERLY, very skillful [adj]\n",
  "MASTERLINESS": "the state of being masterly [n -ES]\n",
  "MASTERLINESSES": "MASTERLINESS, the state of being masterly [n]\n",
  "MASTERLY": "very skillful [adj MASTERLIER, MASTERLIEST]\n",
  "MASTERMIND": "a mind, or a person having a mind, of very great ability [n -S] / to originate, think out, and direct [v -ED, -ING, -S]\n",
  "MASTERMINDED": "MASTERMIND, to originate, think out, and direct [v]\n",
  "MASTERMINDING": "MASTERMIND, to originate, think out, and direct [v]\n",
  "MASTERMINDS": "MASTERMIND, to originate, think out, and direct [v]\n",
  "MASTERPIECE": "a work done with extraordinary skill [n -S]\n",
  "MASTERPIECES": "MASTERPIECE, a work done with extraordinary skill [n]\n",
  "MASTERS": "MASTER, to become skilled in [v]\n",
  "MASTERSHIP": "the state or office of a master [n -S]\n",
  "MASTERSHIPS": "MASTERSHIP, the state or office of a master [n]\n",
  "MASTERSINGER": "a Meistersinger [n -S]\n",
  "MASTERSINGERS": "MASTERSINGER, a Meistersinger [n]\n",
  "MASTERSTROKE": "a masterly performance or move [n -S]\n",
  "MASTERSTROKES": "MASTERSTROKE, a masterly performance or move [n]\n",
  "MASTERWORK": "a masterpiece [n -S]\n",
  "MASTERWORKS": "MASTERWORK, a masterpiece [n]\n",
  "MASTERWORT": "a plant related to the parsnip, once used as a potherb and in medicine [n -S]\n",
  "MASTERWORTS": "MASTERWORT, a plant related to the parsnip, once used as a potherb and in medicine [n]\n",
  "MASTERY": "superior knowledge or skill, also MAISTRY [n MASTERIES]\n",
  "MASTFUL": "abounding in mast; producing mast in abundance [adj]\n",
  "MASTHEAD": "the head of a mast [n -S] / to raise to the masthead; to punish by sending to the masthead [v -ED, -ING, -S]\n",
  "MASTHEADED": "MASTHEAD, to raise to the masthead; to punish by sending to the masthead [v]\n",
  "MASTHEADING": "MASTHEAD, to raise to the masthead; to punish by sending to the masthead [v]\n",
  "MASTHEADS": "MASTHEAD, to raise to the masthead; to punish by sending to the masthead [v]\n",
  "MASTHOUSE": "a building in which vessels' masts are shaped, fitted, etc. [n -S]\n",
  "MASTHOUSES": "MASTHOUSE, a building in which vessels' masts are shaped, fitted, etc. [n]\n",
  "MASTIC": "(French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTICH, MASTICHE, MASTIX [n -S]\n",
  "MASTICABLE": "capable of being masticated [adj]\n",
  "MASTICATE": "to chew; to knead mechanically [v MASTICATED, MASTICATING, MASTICATES]\n",
  "MASTICATED": "MASTICATE, to chew; to knead mechanically [v]\n",
  "MASTICATES": "MASTICATE, to chew; to knead mechanically [v]\n",
  "MASTICATING": "MASTICATE, to chew; to knead mechanically [v]\n",
  "MASTICATION": "the act of masticating [n -S]\n",
  "MASTICATIONS": "MASTICATION, the act of masticating [n]\n",
  "MASTICATOR": "one who masticates [n -S]\n",
  "MASTICATORIES": "MASTICATORY, a substance chewed to increase saliva [n]\n",
  "MASTICATORS": "MASTICATOR, one who masticates [n]\n",
  "MASTICATORY": "a substance chewed to increase saliva [n MASTICATORIES]\n",
  "MASTICH": "(French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTIC, MASTICHE, MASTIX [n -S]\n",
  "MASTICHE": "(French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTIC, MASTICH, MASTIX [n -S]\n",
  "MASTICHES": "MASTICHE, (French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTIC, MASTICH, MASTIX [n]\n",
  "MASTICHS": "MASTICH, (French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTIC, MASTICHE, MASTIX [n]\n",
  "MASTICOT": "(French) yellow lead monoxide, also MASSICOT [n -S]\n",
  "MASTICOTS": "MASTICOT, (French) yellow lead monoxide, also MASSICOT [n]\n",
  "MASTICS": "MASTIC, (French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTICH, MASTICHE, MASTIX [n]\n",
  "MASTIER": "MASTY, as if well fed on mast [adj]\n",
  "MASTIEST": "MASTY, as if well fed on mast [adj]\n",
  "MASTIFF": "a large shorthaired breed of dog [n -S]\n",
  "MASTIFFS": "MASTIFF, a large shorthaired breed of dog [n]\n",
  "MASTIGOPHORAN": "any protozoan having one or more flagella, also MASTIGOPHORE [n -S]\n",
  "MASTIGOPHORANS": "MASTIGOPHORAN, any protozoan having one or more flagella, also MASTIGOPHORE [n]\n",
  "MASTIGOPHORE": "any protozoan having one or more flagella, also MASTIGOPHORAN [n -S]\n",
  "MASTIGOPHORES": "MASTIGOPHORE, any protozoan having one or more flagella, also MASTIGOPHORAN [n]\n",
  "MASTIGOPHORIC": "like a mastigophoran; whip-bearing, also MASTIGOPHOROUS [adj]\n",
  "MASTIGOPHOROUS": "like a mastigophoran; whip-bearing, also MASTIGOPHORIC [adj]\n",
  "MASTING": "MAST, to provide with a long pole that supports a ship's sails [v]\n",
  "MASTITIC": "relating to mastitis, inflammation of breast or milk gland [adj]\n",
  "MASTITIDES": "MASTITIS, inflammation of the breast [n]\n",
  "MASTITIS": "inflammation of the breast [n MASTITISES or MASTITIDES]\n",
  "MASTITISES": "MASTITIS, inflammation of the breast [n]\n",
  "MASTIX": "(French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTIC, MASTICH, MASTICHE [n -ES]\n",
  "MASTIXES": "MASTIX, (French) a pale yellow gum resin from certain Mediterranean trees, used for varnish, also MASTIC, MASTICH, MASTICHE [n]\n",
  "MASTLESS": "bearing no mast; as, a mastless oak or beech [adj]\n",
  "MASTLIKE": "like a mast [adj]\n",
  "MASTODON": "a large extinct mammal resembling the elephant, also MASTODONT [n -S]\n",
  "MASTODONIC": "of or like a mastodon, also MASTODONTIC [adj]\n",
  "MASTODONS": "MASTODON, a large extinct mammal resembling the elephant, also MASTODONT [n]\n",
  "MASTODONT": "a large extinct mammal resembling the elephant, also MASTODON [n -S]\n",
  "MASTODONTIC": "of or like a mastodon, also MASTODONIC [adj]\n",
  "MASTODONTS": "MASTODONT, a large extinct mammal resembling the elephant, also MASTODON [n]\n",
  "MASTODYNIA": "pain in the breasts [n -S]\n",
  "MASTODYNIAS": "MASTODYNIA, pain in the breasts [n]\n",
  "MASTOID": "like a nipple or teat, also MASTOIDAL [adj] / a prominence on the temporal bone behind the ear [n -S]\n",
  "MASTOIDAL": "relating to the mastoid bone, also MASTOID [adj]\n",
  "MASTOIDECTOMIES": "MASTOIDECTOMY, an operation to remove mastoid bone [n]\n",
  "MASTOIDECTOMY": "an operation to remove mastoid bone [n MASTOIDECTOMIES]\n",
  "MASTOIDITIDES": "MASTOIDITIS, inflammation of mastoid cells [n]\n",
  "MASTOIDITIS": "inflammation of mastoid cells [n MASTOIDITIDES or MASTOIDITISES]\n",
  "MASTOIDITISES": "MASTOIDITIS, inflammation of mastoid cells [n]\n",
  "MASTOIDS": "MASTOID, a prominence on the temporal bone behind the ear [n]\n",
  "MASTOPEXIES": "MASTOPEXY, cosmetic surgery of breasts [n]\n",
  "MASTOPEXY": "cosmetic surgery of breasts [n MASTOPEXIES]\n",
  "MASTS": "MAST, to provide with a long pole that supports a ship's sails [v]\n",
  "MASTURBATE": "to practice masturbation [v MASTURBATED, MASTURBATING, MASTURBATES]\n",
  "MASTURBATED": "MASTURBATE, to practice masturbation [v]\n",
  "MASTURBATES": "MASTURBATE, to practice masturbation [v]\n",
  "MASTURBATING": "MASTURBATE, to practice masturbation [v]\n",
  "MASTURBATION": "the act of masturbating [n -S]\n",
  "MASTURBATIONS": "MASTURBATION, the act of masturbating [n]\n",
  "MASTURBATOR": "one who masturbates [n -S]\n",
  "MASTURBATORS": "MASTURBATOR, one who masturbates [n]\n",
  "MASTURBATORY": "of, relating to, or involving masturbation [adj]\n",
  "MASTY": "as if well fed on mast [adj MASTIER, MASTIEST]\n",
  "MASU": "(Japanese) a Japanese salmon [n -S]\n",
  "MASULA": "an Indian surfboat, also MASOOLAH, MASSOOLA [n -S]\n",
  "MASULAS": "MASULA, an Indian surfboat, also MASOOLAH, MASSOOLA [n]\n",
  "MASURIUM": "a name proposed for element number 43, now called technetium [n -S]\n",
  "MASURIUMS": "MASURIUM, a name proposed for element number 43, now called technetium [n]\n",
  "MASUS": "MASU, (Japanese) a Japanese salmon [n]\n",
  "MAT": "to tangle closely [v MATTED, MATTING, MATS]\n",
  "MATACHIN": "(Spanish) a masked sword-dancer; the sword-dance itself [n MATACHINI or MATACHINS]\n",
  "MATACHINA": "a female matachin, sword-dancer [n -S]\n",
  "MATACHINAS": "MATACHINA, a female matachin, sword-dancer [n]\n",
  "MATACHINI": "MATACHIN, (Spanish) a masked sword-dancer; the sword-dance itself [n]\n",
  "MATACHINS": "MATACHIN, (Spanish) a masked sword-dancer; the sword-dance itself [n]\n",
  "MATADOR": "the bullfighter who kills the bull in a bullfight, also MATADORE [n -S]\n",
  "MATADORA": "a female matador [n -S]\n",
  "MATADORAS": "MATADORA, a female matador [n]\n",
  "MATADORE": "(Spanish) the man who kills the bull in bullfights, also MATADOR [n -S]\n",
  "MATADORES": "MATADORE, (Spanish) the man who kills the bull in bullfights, also MATADOR [n]\n",
  "MATADORS": "MATADOR, the bullfighter who kills the bull in a bullfight, also MATADORE [n]\n",
  "MATAGOURI": "(Maori) a thorny bush of New Zealand, forming thickets in open country [n -S]\n",
  "MATAGOURIS": "MATAGOURI, (Maori) a thorny bush of New Zealand, forming thickets in open country [n]\n",
  "MATAI": "(Maori) a coniferous evergreen tree of New Zealand, aka black pine [n -S]\n",
  "MATAIS": "MATAI, (Maori) a coniferous evergreen tree of New Zealand, aka black pine [n]\n",
  "MATAMATA": "(Tupi) a South American river-turtle [n -S]\n",
  "MATAMATAS": "MATAMATA, (Tupi) a South American river-turtle [n]\n",
  "MATAMBALA": "TAMBALA, (Nyanja) a monetary unit of Malawi [n]\n",
  "MATATA": "(Maori) a New Zealand bird, aka fernbird [n -S]\n",
  "MATATAS": "MATATA, (Maori) a New Zealand bird, aka fernbird [n]\n",
  "MATATU": "a type of taxi used in Kenya [n -S]\n",
  "MATATUS": "MATATU, a type of taxi used in Kenya [n]\n",
  "MATCH": "to be equal to [v -ED, -ING, -ES]\n",
  "MATCHA": "(Japanese) a tea made from finely ground green tea leaves [n -S]\n",
  "MATCHABLE": "capable of being matched [adj]\n",
  "MATCHAS": "MATCHA, (Japanese) a tea made from finely ground green tea leaves [n]\n",
  "MATCHBOARD": "one of a number of boards with a tongue cut along one edge and a groove in the opposite edge, fitted one into the next to make a wall-facing, etc. [n -S]\n",
  "MATCHBOARDING": "matchboards collectively [n -S]\n",
  "MATCHBOARDINGS": "MATCHBOARDING, matchboards collectively [n]\n",
  "MATCHBOARDS": "MATCHBOARD, one of a number of boards with a tongue cut along one edge and a groove in the opposite edge, fitted one into the next to make a wall-facing, etc. [n]\n",
  "MATCHBOOK": "a book of matches [n -S]\n",
  "MATCHBOOKS": "MATCHBOOK, a book of matches [n]\n",
  "MATCHBOX": "a small box [n -ES]\n",
  "MATCHBOXES": "MATCHBOX, a small box [n]\n",
  "MATCHED": "MATCH, to be equal to [v]\n",
  "MATCHER": "one who matches [n -S]\n",
  "MATCHERS": "MATCHER, one who matches [n]\n",
  "MATCHES": "MATCH, to be equal to [v]\n",
  "MATCHET": "a large heavy knife, also MACHETE [n -S]\n",
  "MATCHETS": "MATCHET, a large heavy knife, also MACHETE [n]\n",
  "MATCHING": "MATCH, to be equal to [v]\n",
  "MATCHLESS": "without compare [adj MATCHLESSLY]\n",
  "MATCHLESSLY": "MATCHLESS, without compare [adv]\n",
  "MATCHLESSNESS": "MATCHLESS, without compare [n]\n",
  "MATCHLESSNESSES": "MATCHLESSNESS, MATCHLESS, without compare [n]\n",
  "MATCHLOCK": "an early form of gun [n -S]\n",
  "MATCHLOCKS": "MATCHLOCK, an early form of gun [n]\n",
  "MATCHMADE": "MATCHMAKE, to bring suitable people together for marriage [v]\n",
  "MATCHMAKE": "to bring suitable people together for marriage [v MATCHMADE, MATCHMAKING, MATCHMAKES]\n",
  "MATCHMAKER": "one that arranges a match [n -S]\n",
  "MATCHMAKERS": "MATCHMAKER, one that arranges a match [n]\n",
  "MATCHMAKES": "MATCHMAKE, to bring suitable people together for marriage [v]\n",
  "MATCHMAKING": "the business of bringing suitable people together for marriage [n -S]\n",
  "MATCHMAKINGS": "MATCHMAKING, the business of bringing suitable people together for marriage [n]\n",
  "MATCHMARK": "to mark mating components of an engine etc. [v -ED, -ING, -S]\n",
  "MATCHMARKED": "MATCHMARK, to mark mating components of an engine etc. [v]\n",
  "MATCHMARKING": "MATCHMARK, to mark mating components of an engine etc. [v]\n",
  "MATCHMARKS": "MATCHMARK, to mark mating components of an engine etc. [v]\n",
  "MATCHPLAY": "scoring in golf according to holes won and lost [n -S]\n",
  "MATCHPLAYS": "MATCHPLAY, scoring in golf according to holes won and lost [n]\n",
  "MATCHSTICK": "a slender piece esp. of wood from which a match is made [n -S]\n",
  "MATCHSTICKS": "MATCHSTICK, a slender piece esp. of wood from which a match is made [n]\n",
  "MATCHUP": "a setting of two players against each other [n -S]\n",
  "MATCHUPS": "MATCHUP, a setting of two players against each other [n]\n",
  "MATCHWOOD": "wood suitable for making matches; splinters or fragments [n -S]\n",
  "MATCHWOODS": "MATCHWOOD, wood suitable for making matches; splinters or fragments [n]\n",
  "MATE": "to couple with [v MATED, MATING, MATES]\n",
  "MATED": "MATE, to couple with [v]\n",
  "MATELASSE": "(French) having a raised pattern as if quilted [adj] / a jacquard fabric having a raised pattern, also MATELLASSE [n -S]\n",
  "MATELASSES": "MATELASSE, a jacquard fabric having a raised pattern, also MATELLASSE [n]\n",
  "MATELESS": "without a mate [adj]\n",
  "MATELLASSE": "(French) having a raised pattern as if quilted [n -S] / a jacquard fabric having a raised pattern, also MATELASSE [n -S]\n",
  "MATELLASSES": "MATELLASSE, (French) having a raised pattern as if quilted [n]\n",
  "MATELOT": "(French) a seaman, also MATLO, MATLOW [n -S]\n",
  "MATELOTE": "(French) a kind of rich fish stew, also MATELOTTE [n -S]\n",
  "MATELOTES": "MATELOTE, (French) a kind of rich fish stew, also MATELOTTE [n]\n",
  "MATELOTS": "MATELOT, (French) a seaman, also MATLO, MATLOW [n]\n",
  "MATELOTTE": "(French) a kind of rich fish stew, also MATELOTE [n -S]\n",
  "MATELOTTES": "MATELOTTE, (French) a kind of rich fish stew, also MATELOTE [n]\n",
  "MATER": "(Latin) mother [n MATERS or MATRES]\n",
  "MATERFAMILIAS": "(Latin) the mother or female head of the family [n MATRESFAMILIAS or MATERFAMILIASES]\n",
  "MATERFAMILIASES": "MATERFAMILIAS, (Latin) the mother or female head of the family [n]\n",
  "MATERIAL": "relevant [adj MATERIALLY] / the substance of which anything is or may be composed [n -S]\n",
  "MATERIALISATION": "the act of materialising, also MATERIALIZATION [n]\n",
  "MATERIALISE": "to appear, become material, also MATERIALIZE [v MATERIALISED, MATERIALISING, MATERIALISES]\n",
  "MATERIALISED": "MATERIALISE, to appear, become material, also MATERIALIZE [v]\n",
  "MATERIALISER": "one who materializes, also MATERIALIZER [n -S]\n",
  "MATERIALISERS": "MATERIALISER, one who materializes, also MATERIALIZER [n]\n",
  "MATERIALISES": "MATERIALISE, to appear, become material, also MATERIALIZE [v]\n",
  "MATERIALISING": "MATERIALISE, to appear, become material, also MATERIALIZE [v]\n",
  "MATERIALISM": "the belief that matter is the only extant substance [n -S]\n",
  "MATERIALISMS": "MATERIALISM, the belief that matter is the only extant substance [n]\n",
  "MATERIALIST": "one who espouses materialism [n -S]\n",
  "MATERIALISTIC": "related to materialism, also MATERIALISTICAL [adj]\n",
  "MATERIALISTICAL": "related to materialism, also MATERIALISTIC [adj]\n",
  "MATERIALISTS": "MATERIALIST, one who espouses materialism [n]\n",
  "MATERIALITIES": "MATERIALITY, the state of being material [n]\n",
  "MATERIALITY": "the state of being material [n MATERIALITIES]\n",
  "MATERIALIZATION": "the act of materializing, also MATERIALISATION [n]\n",
  "MATERIALIZE": "to make material, also MATERIALISE [v MATERIALIZED, MATERIALIZING, MATERIALIZES]\n",
  "MATERIALIZED": "MATERIALIZE, to make material, also MATERIALISE [v]\n",
  "MATERIALIZER": "one who materializes, also MATERIALISER [n -S]\n",
  "MATERIALIZERS": "MATERIALIZER, one who materializes, also MATERIALISER [n]\n",
  "MATERIALIZES": "MATERIALIZE, to make material, also MATERIALISE [v]\n",
  "MATERIALIZING": "MATERIALIZE, to make material, also MATERIALISE [v]\n",
  "MATERIALLY": "MATERIAL, relevant [adv]\n",
  "MATERIALNESS": "the state of being material [n -ES]\n",
  "MATERIALNESSES": "MATERIALNESS, the state of being material [n]\n",
  "MATERIALS": "MATERIAL, the substance of which anything is or may be composed [n]\n",
  "MATERIEL": "(French) material; equipment; the baggage and munitions of an army [n -S]\n",
  "MATERIELS": "MATERIEL, (French) material; equipment; the baggage and munitions of an army [n]\n",
  "MATERNAL": "pertaining to a mother [adj MATERNALLY]\n",
  "MATERNALISM": "the state of being maternal [n -S]\n",
  "MATERNALISMS": "MATERNALISM, the state of being maternal [n]\n",
  "MATERNALISTIC": "motherly [adj]\n",
  "MATERNALLY": "MATERNAL, pertaining to a mother [adv]\n",
  "MATERNITIES": "MATERNITY, motherhood [n]\n",
  "MATERNITY": "motherhood [n MATERNITIES]\n",
  "MATERS": "MATER, (Latin) mother [n]\n",
  "MATES": "MATE, to couple with [v]\n",
  "MATESHIP": "the state of being a mate [n -S]\n",
  "MATESHIPS": "MATESHIP, the state of being a mate [n]\n",
  "MATEY": "a friend [n -S]\n",
  "MATEYNESS": "the state of being matey, also MATINESS [n -ES]\n",
  "MATEYNESSES": "MATEYNESS, the state of being matey, also MATINESS [n]\n",
  "MATEYS": "MATEY, a friend [n]\n",
  "MATFELLON": "the greater knapweed, also MATFELON [n -S]\n",
  "MATFELLONS": "MATFELLON, the greater knapweed, also MATFELON [n]\n",
  "MATFELON": "the greater knapweed, also MATFELLON [n -S]\n",
  "MATFELONS": "MATFELON, the greater knapweed, also MATFELLON [n]\n",
  "MATGRASS": "a rushlike moorland grass [n -ES]\n",
  "MATGRASSES": "MATGRASS, a rushlike moorland grass [n]\n",
  "MATH": "(short for) mathematics [n -S]\n",
  "MATHEMATIC": "related to mathematics, also MATHEMATICAL [adj MATHEMATICALLY]\n",
  "MATHEMATICAL": "related to mathematics, also MATHEMATIC [adj MATHEMATICALLY]\n",
  "MATHEMATICALLY": "MATHEMATICAL, related to mathematics, also MATHEMATIC [adv]\n",
  "MATHEMATICIAN": "a specialist or expert in mathematics [n -S]\n",
  "MATHEMATICIANS": "MATHEMATICIAN, a specialist or expert in mathematics [n]\n",
  "MATHEMATICISE": "to make mathematical, also MATHEMATICIZE, MATHEMATISE, MATHEMATIZE [v MATHEMATICISED, MATHEMATICISING, MATHEMATICISES]\n",
  "MATHEMATICISED": "MATHEMATICISE, to make mathematical, also MATHEMATICIZE, MATHEMATISE, MATHEMATIZE [v]\n",
  "MATHEMATICISES": "MATHEMATICISE, to make mathematical, also MATHEMATICIZE, MATHEMATISE, MATHEMATIZE [v]\n",
  "MATHEMATICISING": "MATHEMATICISE, to make mathematical, also MATHEMATICIZE, MATHEMATISE, MATHEMATIZE [v]\n",
  "MATHEMATICISM": "the belief that everything can be described or explained ultimately in mathematical terms [n -S]\n",
  "MATHEMATICISMS": "MATHEMATICISM, the belief that everything can be described or explained ultimately in mathematical terms [n]\n",
  "MATHEMATICIZE": "to make mathematical, also MATHEMATICISE, MATHEMATISE, MATHEMATIZE [v MATHEMATICIZED, MATHEMATICIZING, MATHEMATICIZES]\n",
  "MATHEMATICIZED": "MATHEMATICIZE, to make mathematical, also MATHEMATICISE, MATHEMATISE, MATHEMATIZE [v]\n",
  "MATHEMATICIZES": "MATHEMATICIZE, to make mathematical, also MATHEMATICISE, MATHEMATISE, MATHEMATIZE [v]\n",
  "MATHEMATICIZING": "MATHEMATICIZE, to make mathematical, also MATHEMATICISE, MATHEMATISE, MATHEMATIZE [v]\n",
  "MATHEMATICS": "the science of numbers and their operations [n]\n",
  "MATHEMATISATION": "reduction to mathematical form, also MATHEMATIZATION [n]\n",
  "MATHEMATISE": "to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATIZE [v MATHEMATISED, MATHEMATISING, MATHEMATISES]\n",
  "MATHEMATISED": "MATHEMATISE, to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATIZE [v]\n",
  "MATHEMATISES": "MATHEMATISE, to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATIZE [v]\n",
  "MATHEMATISING": "MATHEMATISE, to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATIZE [v]\n",
  "MATHEMATIZATION": "reduction to mathematical form, also MATHEMATISATION [n]\n",
  "MATHEMATIZE": "to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATISE [v MATHEMATIZED, MATHEMATIZING, MATHEMATIZES]\n",
  "MATHEMATIZED": "MATHEMATIZE, to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATISE [v]\n",
  "MATHEMATIZES": "MATHEMATIZE, to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATISE [v]\n",
  "MATHEMATIZING": "MATHEMATIZE, to make mathematical, also MATHEMATICISE, MATHEMATICIZE, MATHEMATISE [v]\n",
  "MATHESES": "MATHESIS, mental discipline [n]\n",
  "MATHESIS": "mental discipline [n MATHESES]\n",
  "MATHS": "MATH, (short for) mathematics [n]\n",
  "MATICO": "(Spanish) a Peruvian plant, allied to the pepper, the leaves of which are used as a styptic and astringent [n -S]\n",
  "MATICOS": "MATICO, (Spanish) a Peruvian plant, allied to the pepper, the leaves of which are used as a styptic and astringent [n]\n",
  "MATIER": "MATY, friendly [adj]\n",
  "MATIES": "MATY, a friend, also MATEY [n]\n",
  "MATIEST": "MATY, friendly [adj]\n",
  "MATILDA": "(Australian) a hobo's bundle [n -S]\n",
  "MATILDAS": "MATILDA, (Australian) a hobo's bundle [n]\n",
  "MATILY": "MATY, friendly [adv]\n",
  "MATIN": "(French) a morning prayer service, also MATTIN [n -S]\n",
  "MATINAL": "pertaining to the morning [adj]\n",
  "MATINEE": "(French) an afternoon performance at a theatre, cinema, or concert hall [n -S]\n",
  "MATINEES": "MATINEE, (French) an afternoon performance at a theatre, cinema, or concert hall [n]\n",
  "MATINESS": "friendliness [n -ES]\n",
  "MATINESSES": "MATINESS, friendliness [n]\n",
  "MATING": "the period during which a seasonal-breeding animal can mate [n -S]\n",
  "MATINGS": "MATING, the period during which a seasonal-breeding animal can mate [n]\n",
  "MATINS": "MATIN, (French) a morning prayer service, also MATTIN [n]\n",
  "MATIPO": "(Maori) a New Zealand shrub [n -S]\n",
  "MATIPOS": "MATIPO, (Maori) a New Zealand shrub [n]\n",
  "MATJES": "(Danish) a young herring, treated, and served as an hors d'oeuvre, also MAATJES [n MATJES]\n",
  "MATLESS": "without a mat [adj]\n",
  "MATLO": "a seaman, also MATELOT, MATLOW [n -S]\n",
  "MATLOS": "MATLO, a seaman, also MATELOT, MATLOW [n]\n",
  "MATLOW": "a seaman, also MATELOT, MATLO [n -S]\n",
  "MATLOWS": "MATLOW, a seaman, also MATELOT, MATLO [n]\n",
  "MATOKE": "(Bantu) in Uganda, plantain used as a staple food, also MATOOKE [n -S]\n",
  "MATOKES": "MATOKE, (Bantu) in Uganda, plantain used as a staple food, also MATOOKE [n]\n",
  "MATOOKE": "(Bantu) in Uganda, plantain used as a staple food, also MATOKE [n -S]\n",
  "MATOOKES": "MATOOKE, (Bantu) in Uganda, plantain used as a staple food, also MATOKE [n]\n",
  "MATRASS": "a long-necked round-bodied chemical flask, used for distilling, also MATTRASS [n -ES]\n",
  "MATRASSES": "MATRASS, a long-necked round-bodied chemical flask, used for distilling, also MATTRASS [n]\n",
  "MATRES": "MATER, (Latin) mother [n]\n",
  "MATRESFAMILIAS": "MATERFAMILIAS, (Latin) the mother or female head of the family [n]\n",
  "MATRIARCH": "a woman who is the head of a family [n -S]\n",
  "MATRIARCHAL": "of or like a matriarch [adj]\n",
  "MATRIARCHALISM": "the state of being matriarchal [n -S]\n",
  "MATRIARCHALISMS": "MATRIARCHALISM, the state of being matriarchal [n]\n",
  "MATRIARCHATE": "a matriarchy [n -S]\n",
  "MATRIARCHATES": "MATRIARCHATE, a matriarchy [n]\n",
  "MATRIARCHIC": "like a matriarch [adj]\n",
  "MATRIARCHIES": "MATRIARCHY, government by women [n]\n",
  "MATRIARCHS": "MATRIARCH, a woman who is the head of a family [n]\n",
  "MATRIARCHY": "government by women [n MATRIARCHIES]\n",
  "MATRIC": "(short for) matriculation [n -S]\n",
  "MATRICE": "the womb; that in which anything is embedded, also MATRIX [n -S]\n",
  "MATRICES": "MATRICE, the womb; that in which anything is embedded, also MATRIX [n]\n",
  "MATRICIDAL": "relating to matricide [adj]\n",
  "MATRICIDE": "the killing of a mother [n -S]\n",
  "MATRICIDES": "MATRICIDE, the killing of a mother [n]\n",
  "MATRICLINIC": "inherited from the mother; more like the mother than the father, also MATRICLINOUS, MATROCLINAL, MATROCLINIC, MATROCLINOUS [adj]\n",
  "MATRICLINOUS": "inherited from the mother; more like the mother than the father, also MATRICLINIC, MATROCLINAL, MATROCLINIC, MATROCLINOUS [adj]\n",
  "MATRICS": "MATRIC, (short for) matriculation [n]\n",
  "MATRICULA": "(Latin) a register of members, students etc. [n -S]\n",
  "MATRICULANT": "one who is matriculating [n -S]\n",
  "MATRICULANTS": "MATRICULANT, one who is matriculating [n]\n",
  "MATRICULAR": "relating to a register [adj]\n",
  "MATRICULAS": "MATRICULA, (Latin) a register of members, students etc. [n]\n",
  "MATRICULATE": "to enroll [v MATRICULATED, MATRICULATING, MATRICULATES]\n",
  "MATRICULATED": "MATRICULATE, to enroll [v]\n",
  "MATRICULATES": "MATRICULATE, to enroll [v]\n",
  "MATRICULATING": "MATRICULATE, to enroll [v]\n",
  "MATRICULATION": "the act of matriculation [n -S]\n",
  "MATRICULATIONS": "MATRICULATION, the act of matriculation [n]\n",
  "MATRICULATOR": "one who matriculates [n -S]\n",
  "MATRICULATORS": "MATRICULATOR, one who matriculates [n]\n",
  "MATRICULATORY": "relating to matriculation [adj]\n",
  "MATRIFOCAL": "in anthropology, focused on the mother [adj]\n",
  "MATRIFOCALITIES": "MATRIFOCALITY, the state of being matrifocal [n]\n",
  "MATRIFOCALITY": "the state of being matrifocal [n MATRIFOCALITIES]\n",
  "MATRILINEAL": "of descent or kinship, reckoned through the mother or through females alone, also MATRILINEAR [adj MATRILINEALLY]\n",
  "MATRILINEALLY": "MATRILINEAL, of descent or kinship, reckoned through the mother or through females alone, also MATRILINEAR [adv]\n",
  "MATRILINEAR": "of descent or kinship, reckoned through the mother or through females alone, also MATRILINEAL [adj]\n",
  "MATRILINIES": "MATRILINY, descent reckoned through the mother [n]\n",
  "MATRILINY": "descent reckoned through the mother [n MATRILINIES]\n",
  "MATRILOCAL": "of a form of marriage, in which the husband goes to live with the wife's group [adj MATRILOCALLY]\n",
  "MATRILOCALITIES": "MATRILOCALITY, the state of being matrilocal, living in or near the wife's home or community after marriage [n]\n",
  "MATRILOCALITY": "the state of being matrilocal, living in or near the wife's home or community after marriage [n MATRILOCALITIES]\n",
  "MATRILOCALLY": "MATRILOCAL, of a form of marriage, in which the husband goes to live with the wife's group [adv]\n",
  "MATRIMONIAL": "of or relating to marriage [adj MATRIMONIALLY]\n",
  "MATRIMONIALLY": "MATRIMONIAL, of or relating to marriage [adv]\n",
  "MATRIMONIES": "MATRIMONY, the rite or institution of marriage [n]\n",
  "MATRIMONY": "the rite or institution of marriage [n MATRIMONIES]\n",
  "MATRIOSHKA": "(Russian) a Russian doll, also MATROYSHKA, MATRYOSHKA [n MATRIOSHKI or MATRIOSHKAS]\n",
  "MATRIOSHKAS": "MATRIOSHKA, (Russian) a Russian doll, also MATROYSHKA, MATRYOSHKA [n]\n",
  "MATRIOSHKI": "MATRIOSHKA, (Russian) a Russian doll, also MATROYSHKA, MATRYOSHKA [n]\n",
  "MATRIX": "(Latin) the womb; that in which anything is embedded, also MATRICE [n MATRICES or MATRIXES]\n",
  "MATRIXES": "MATRIX, (Latin) the womb; that in which anything is embedded, also MATRICE [n]\n",
  "MATROCLINAL": "inherited from the mother; more like the mother than the father, also MATRICLINIC, MATRICLINOUS, MATROCLINIC, MATROCLINOUS [adj]\n",
  "MATROCLINIC": "inherited from the mother; more like the mother than the father, also MATRICLINIC, MATRICLINOUS, MATROCLINAL, MATROCLINOUS [adj]\n",
  "MATROCLINIES": "MATROCLINY, the inheritance of traits primarily from the mother [n]\n",
  "MATROCLINOUS": "inherited from the mother; more like the mother than the father, also MATRICLINIC, MATRICLINOUS, MATROCLINAL, MATROCLINIC [adj]\n",
  "MATROCLINY": "the inheritance of traits primarily from the mother [n MATROCLINIES]\n",
  "MATRON": "a married woman of established social position [n -S]\n",
  "MATRONAGE": "the state of a matron [n -S]\n",
  "MATRONAGES": "MATRONAGE, the state of a matron [n]\n",
  "MATRONAL": "like a matron [adj]\n",
  "MATRONHOOD": "the state of being a matron [n -S]\n",
  "MATRONHOODS": "MATRONHOOD, the state of being a matron [n]\n",
  "MATRONISE": "to make a matron of; to make like a matron, also MATRONIZE [v MATRONISED, MATRONISING, MATRONISES]\n",
  "MATRONISED": "MATRONISE, to make a matron of; to make like a matron, also MATRONIZE [v]\n",
  "MATRONISES": "MATRONISE, to make a matron of; to make like a matron, also MATRONIZE [v]\n",
  "MATRONISING": "MATRONISE, to make a matron of; to make like a matron, also MATRONIZE [v]\n",
  "MATRONIZE": "to make a matron of; to make like a matron, also MATRONISE [v MATRONIZED, MATRONIZING, MATRONIZES]\n",
  "MATRONIZED": "MATRONIZE, to make a matron of; to make like a matron, also MATRONISE [v]\n",
  "MATRONIZES": "MATRONIZE, to make a matron of; to make like a matron, also MATRONISE [v]\n",
  "MATRONIZING": "MATRONIZE, to make a matron of; to make like a matron, also MATRONISE [v]\n",
  "MATRONLIER": "MATRONLY, like a matron [adj]\n",
  "MATRONLIEST": "MATRONLY, like a matron [adj]\n",
  "MATRONLINESS": "the state of being matronly [n -ES]\n",
  "MATRONLINESSES": "MATRONLINESS, the state of being matronly [n]\n",
  "MATRONLY": "like a matron [adj MATRONLIER, MATRONLIEST]\n",
  "MATRONS": "MATRON, a married woman of established social position [n]\n",
  "MATRONSHIP": "the state of being a matron [n -S]\n",
  "MATRONSHIPS": "MATRONSHIP, the state of being a matron [n]\n",
  "MATRONYMIC": "derived from the name of one's mother, or other female ancestor [adj] / a name so derived, also METRONYMIC [n -S]\n",
  "MATRONYMICS": "MATRONYMIC, a name so derived, also METRONYMIC [n]\n",
  "MATROSS": "(obsolete) an artillery soldier next in rank below a gunner [n -ES]\n",
  "MATROSSES": "MATROSS, (obsolete) an artillery soldier next in rank below a gunner [n]\n",
  "MATROYSHKA": "(Russian) a hollow wooden doll, also MATRIOSHKA, MATRYOSHKA [n -S]\n",
  "MATROYSHKAS": "MATROYSHKA, (Russian) a hollow wooden doll, also MATRIOSHKA, MATRYOSHKA [n]\n",
  "MATRYOSHKA": "(Russian) a hollow wooden doll, also MATRIOSHKA, MATROYSHKA [n MATRYOSHKI or MATRYOSHKAS]\n",
  "MATRYOSHKAS": "MATRYOSHKA, (Russian) a hollow wooden doll, also MATRIOSHKA, MATROYSHKA [n]\n",
  "MATRYOSHKI": "MATRYOSHKA, (Russian) a hollow wooden doll, also MATRIOSHKA, MATROYSHKA [n]\n",
  "MATS": "MAT, to tangle closely [v]\n",
  "MATSAH": "(Yiddish) an unleavened bread, also MATZO, MATZA, MATZAH, MATZOH [n -S]\n",
  "MATSAHS": "MATSAH, (Yiddish) an unleavened bread, also MATZO, MATZA, MATZAH, MATZOH [n]\n",
  "MATSURI": "(Japanese) a Shinto festival or public ceremony held at a shrine [n -S]\n",
  "MATSURIS": "MATSURI, (Japanese) a Shinto festival or public ceremony held at a shrine [n]\n",
  "MATSUTAKE": "(Japanese) a Japanese mushroom [n -S]\n",
  "MATSUTAKES": "MATSUTAKE, (Japanese) a Japanese mushroom [n]\n",
  "MATT": "a nonglossy surface, as on paint [n -S]\n",
  "MATTAMORE": "a subterranean chamber, also MASSYMORE [n -S]\n",
  "MATTAMORES": "MATTAMORE, a subterranean chamber, also MASSYMORE [n]\n",
  "MATTE": "a molten mixture of impure metal sulphides produced during the smelting of sulphide ores of copper, nickel, etc. [n -S]\n",
  "MATTED": "MAT, to tangle closely [v]\n",
  "MATTEDLY": "MATTED [adv]\n",
  "MATTER": "to be of importance [v -ED, -ING, -S]\n",
  "MATTERED": "MATTER, to be of importance [v]\n",
  "MATTERFUL": "(archaic) full of matter, pithy [adj]\n",
  "MATTERIER": "MATTERY, purulent [adj]\n",
  "MATTERIEST": "MATTERY, purulent [adj]\n",
  "MATTERING": "MATTER, to be of importance [v]\n",
  "MATTERLESS": "not being, or having, matter [adj]\n",
  "MATTERS": "MATTER, to be of importance [v]\n",
  "MATTERY": "purulent [adj MATTERIER, MATTERIEST]\n",
  "MATTES": "MATTE, a molten mixture of impure metal sulphides produced during the smelting of sulphide ores of copper, nickel, etc. [n]\n",
  "MATTIE": "(Scots) a young herring with undeveloped roe [n -S]\n",
  "MATTIES": "MATTIE, (Scots) a young herring with undeveloped roe [n]\n",
  "MATTIFIED": "MATTIFY, to use cosmetics to reduce the shine of skin [v]\n",
  "MATTIFIES": "MATTIFY, to use cosmetics to reduce the shine of skin [v]\n",
  "MATTIFY": "to use cosmetics to reduce the shine of skin [v MATTIFIED, MATTIFYING, MATTIFIES]\n",
  "MATTIFYING": "MATTIFY, to use cosmetics to reduce the shine of skin [v]\n",
  "MATTIN": "(French) a morning prayer service, also MATIN [n -S]\n",
  "MATTING": "a woven fabric used as a floor covering [n -S]\n",
  "MATTINGS": "MATTING, a woven fabric used as a floor covering [n]\n",
  "MATTINS": "MATTIN, (French) a morning prayer service, also MATIN [n]\n",
  "MATTOCK": "a kind of pickaxe for loosening soil, also MADDOCK [n -S]\n",
  "MATTOCKS": "MATTOCK, a kind of pickaxe for loosening soil, also MADDOCK [n]\n",
  "MATTOID": "a person on the borderline between sanity and insanity [n -S]\n",
  "MATTOIDS": "MATTOID, a person on the borderline between sanity and insanity [n]\n",
  "MATTRASS": "a long-necked round-bodied chemical flask, used for distilling, also MATRASS [n -ES]\n",
  "MATTRASSES": "MATTRASS, a long-necked round-bodied chemical flask, used for distilling, also MATRASS [n]\n",
  "MATTRESS": "a large pad filled with resilient material used on or as a bed [n -ES]\n",
  "MATTRESSES": "MATTRESS, a large pad filled with resilient material used on or as a bed [n]\n",
  "MATTS": "MATT, a nonglossy surface, as on paint [n]\n",
  "MATURABLE": "that can be matured [adj]\n",
  "MATURATE": "to develop fully, also MATURE [v MATURATED, MATURATING, MATURATES]\n",
  "MATURATED": "MATURATE, to develop fully, also MATURE [v]\n",
  "MATURATES": "MATURATE, to develop fully, also MATURE [v]\n",
  "MATURATING": "MATURATE, to develop fully, also MATURE [v]\n",
  "MATURATION": "the process of bringing or coming to maturity [n -S]\n",
  "MATURATIONAL": "relating to maturation [adj]\n",
  "MATURATIONS": "MATURATION, the process of bringing or coming to maturity [n]\n",
  "MATURATIVE": "conducing to ripeness or maturity [adj]\n",
  "MATURE": "to develop fully, also MATURATE [v MATURED, MATURING, MATURES] / fully developed, also MATURATE [adj MATURER, MATUREST, MATURELY]\n",
  "MATURED": "MATURE, to develop fully, also MATURATE [v]\n",
  "MATURELY": "MATURE, fully developed, also MATURATE [adv]\n",
  "MATURENESS": "the state of being mature [n -ES]\n",
  "MATURENESSES": "MATURENESS, the state of being mature [n]\n",
  "MATURER": "one that brings something to maturity [n -S]\n",
  "MATURERS": "MATURER, one that brings something to maturity [n]\n",
  "MATURES": "MATURE, to develop fully, also MATURATE [v]\n",
  "MATUREST": "MATURE, fully developed, also MATURATE [adj]\n",
  "MATURING": "MATURE, to develop fully, also MATURATE [v]\n",
  "MATURITIES": "MATURITY, the state of being mature [n]\n",
  "MATURITY": "the state of being mature [n MATURITIES]\n",
  "MATUTINAL": "relating to or occurring in the morning, also MATUTINE [adj MATUTINALLY]\n",
  "MATUTINALLY": "MATUTINAL, relating to or occurring in the morning, also MATUTINE [adv]\n",
  "MATUTINE": "relating to or occurring in the morning, also MATUTINAL [adj]\n",
  "MATWEED": "a name of several maritime grasses [n -S]\n",
  "MATWEEDS": "MATWEED, a name of several maritime grasses [n]\n",
  "MATY": "friendly [adj MATIER, MATIEST, MATILY] / a friend, also MATEY [n MATIES]\n",
  "MATZA": "(Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZAH, MATZO, MATZOH [n -S]\n",
  "MATZAH": "(Yiddish) an unleavened bread, also MATZO, MATSAH, MATZA, MATZOH [n -S]\n",
  "MATZAHS": "MATZAH, (Yiddish) an unleavened bread, also MATZO, MATSAH, MATZA, MATZOH [n]\n",
  "MATZAS": "MATZA, (Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZAH, MATZO, MATZOH [n]\n",
  "MATZO": "(Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZA, MATZAH, MATZOH [n MATZOS, MATZOT, MATZOTH]\n",
  "MATZOH": "(Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZA, MATZAH, MATZO [n -S]\n",
  "MATZOHS": "MATZOH, (Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZA, MATZAH, MATZO [n]\n",
  "MATZOON": "a food similar to yoghurt made from fermented milk, also MADZOON [n -S]\n",
  "MATZOONS": "MATZOON, a food similar to yoghurt made from fermented milk, also MADZOON [n]\n",
  "MATZOS": "MATZO, (Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZA, MATZAH, MATZOH [n]\n",
  "MATZOT": "MATZO, (Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZA, MATZAH, MATZOH [n]\n",
  "MATZOTH": "MATZO, (Yiddish) unleavened bread, esp. as eaten on Pesach, also MATSAH, MATZA, MATZAH, MATZOH [n]\n",
  "MAUBIES": "MAUBY, (Caribbean) a frothy beverage made from boiled tree-bark, also MOBBIE, MOBBY [n]\n",
  "MAUBY": "(Caribbean) a frothy beverage made from boiled tree-bark, also MOBBIE, MOBBY [n MAUBIES]\n",
  "MAUD": "a Scottish gray and black plaid [n -S]\n",
  "MAUDLIN": "weakly sentimental [adj MAUDLINLY]\n",
  "MAUDLINISM": "tearful sentimentality, also MAUDLINNESS [n -S]\n",
  "MAUDLINISMS": "MAUDLINISM, tearful sentimentality, also MAUDLINNESS [n]\n",
  "MAUDLINLY": "MAUDLIN, weakly sentimental [adv]\n",
  "MAUDLINNESS": "maudlin sentimentality, also MAUDLINISM [n -ES]\n",
  "MAUDLINNESSES": "MAUDLINNESS, maudlin sentimentality, also MAUDLINISM [n]\n",
  "MAUDS": "MAUD, a Scottish gray and black plaid [n]\n",
  "MAUGER": "(archaic) in spite of, also MALGRADO, MALGRE, MAUGRE, MAULGRE [prep]\n",
  "MAUGRE": "to show spite towards, also MALGRE, MAULGRE [v MAUGRED, MAUGRING, MAUGRES]\n",
  "MAUGRED": "MAUGRE, to show spite towards, also MALGRE, MAULGRE [v]\n",
  "MAUGRES": "MAUGRE, to show spite towards, also MALGRE, MAULGRE [v]\n",
  "MAUGRING": "MAUGRE, to show spite towards, also MALGRE, MAULGRE [v]\n",
  "MAUL": "to batter or maltreat [v -ED, -ING, -S]\n",
  "MAULED": "MAUL, to batter or maltreat [v]\n",
  "MAULER": "one that mauls [n -S]\n",
  "MAULERS": "MAULER, one that mauls [n]\n",
  "MAULGRE": "to show spite towards, also MALGRE, MAUGRE [v MAULGRED, MAULGRING, MAULGRES]\n",
  "MAULGRED": "MAULGRE, to show spite towards, also MALGRE, MAUGRE [v]\n",
  "MAULGRES": "MAULGRE, to show spite towards, also MALGRE, MAUGRE [v]\n",
  "MAULGRING": "MAULGRE, to show spite towards, also MALGRE, MAUGRE [v]\n",
  "MAULING": "the act of handling roughly [n -S]\n",
  "MAULINGS": "MAULING, the act of handling roughly [n]\n",
  "MAULS": "MAUL, to batter or maltreat [v]\n",
  "MAULSTICK": "(Dutch) a stick used by painters to steady the hand, also MAHLSTICK, MALSTICK [n -S]\n",
  "MAULSTICKS": "MAULSTICK, (Dutch) a stick used by painters to steady the hand, also MAHLSTICK, MALSTICK [n]\n",
  "MAULVI": "(Urdu) a teacher of Islamic law, also MOOLVI, MOOLVIE [n -S]\n",
  "MAULVIS": "MAULVI, (Urdu) a teacher of Islamic law, also MOOLVI, MOOLVIE [n]\n",
  "MAUMET": "a puppet; a doll, also MAMMET, MAWMET, MOMMET [n -S]\n",
  "MAUMETRIES": "MAUMETRY, the religion of Mohammed; idolatry, also MAMMETRY, MAWMETRY [n]\n",
  "MAUMETRY": "the religion of Mohammed; idolatry, also MAMMETRY, MAWMETRY [n MAUMETRIES]\n",
  "MAUMETS": "MAUMET, a puppet; a doll, also MAMMET, MAWMET, MOMMET [n]\n",
  "MAUN": "(dialect) must [v]\n",
  "MAUND": "(obsolete) to beg [v -ED, -ING, -S]\n",
  "MAUNDED": "MAUND, (obsolete) to beg [v]\n",
  "MAUNDER": "to talk incoherently [v -ED, -ING, -S]\n",
  "MAUNDERED": "MAUNDER, to talk incoherently [v]\n",
  "MAUNDERER": "one who maunders [n -S]\n",
  "MAUNDERERS": "MAUNDERER, one who maunders [n]\n",
  "MAUNDERING": "grumbling, rambling talk [n -S]\n",
  "MAUNDERINGS": "MAUNDERING, grumbling, rambling talk [n]\n",
  "MAUNDERS": "MAUNDER, to talk incoherently [v]\n",
  "MAUNDIES": "MAUNDY, a religious ceremony of washing of the feet [n]\n",
  "MAUNDING": "MAUND, (obsolete) to beg [v]\n",
  "MAUNDS": "MAUND, (obsolete) to beg [v]\n",
  "MAUNDY": "a religious ceremony of washing of the feet [n MAUNDIES]\n",
  "MAUNGIER": "MAUNGY, scabby, also MANGEY, MANGY [adj]\n",
  "MAUNGIEST": "MAUNGY, scabby, also MANGEY, MANGY [adj]\n",
  "MAUNGY": "scabby, also MANGEY, MANGY [adj MAUNGIER, MAUNGIEST]\n",
  "MAUNNA": "(dialect) must not [v]\n",
  "MAURI": "(Maori) the soul [n -S]\n",
  "MAURIS": "MAURI, (Maori) the soul [n]\n",
  "MAUSIER": "MAUSY, foggy, misty, also MAUZY [adj]\n",
  "MAUSIEST": "MAUSY, foggy, misty, also MAUZY [adj]\n",
  "MAUSOLEA": "MAUSOLEUM, (Latin) a large, stately tomb [n]\n",
  "MAUSOLEAN": "pertaining to a mausoleum; monumental [adj]\n",
  "MAUSOLEUM": "(Latin) a large, stately tomb [n MAUSOLEUMS or MAUSOLEA]\n",
  "MAUSOLEUMS": "MAUSOLEUM, (Latin) a large, stately tomb [n]\n",
  "MAUSY": "foggy, misty, also MAUZY [adj MAUSIER, MAUSIEST]\n",
  "MAUT": "(Scots) malt [n -S]\n",
  "MAUTHER": "an awkward girl, also MAWR, MAWTHER [n -S]\n",
  "MAUTHERS": "MAUTHER, an awkward girl, also MAWR, MAWTHER [n]\n",
  "MAUTS": "MAUT, (Scots) malt [n]\n",
  "MAUVAIS": "(French) bad, wicked, also MAUVAISE [adj]\n",
  "MAUVAISE": "(French) bad, wicked, also MAUVAIS [adj]\n",
  "MAUVE": "a purple colour [n -S] / coloured mauve [adj MAUVER, MAUVEST]\n",
  "MAUVEIN": "a mauve dye, also MAUVEINE, MAUVIN, MAUVINE [n -S]\n",
  "MAUVEINE": "a mauve dye, also MAUVEIN, MAUVIN, MAUVINE [n -S]\n",
  "MAUVEINES": "MAUVEINE, a mauve dye, also MAUVEIN, MAUVIN, MAUVINE [n]\n",
  "MAUVEINS": "MAUVEIN, a mauve dye, also MAUVEINE, MAUVIN, MAUVINE [n]\n",
  "MAUVER": "MAUVE, coloured mauve [adj]\n",
  "MAUVES": "MAUVE, a purple colour [n]\n",
  "MAUVEST": "MAUVE, coloured mauve [adj]\n",
  "MAUVIN": "a mauve dye, also MAUVEIN, MAUVEINE, MAUVINE [n -S]\n",
  "MAUVINE": "a mauve dye, also MAUVEIN, MAUVEINE, MAUVIN [n -S]\n",
  "MAUVINES": "MAUVINE, a mauve dye, also MAUVEIN, MAUVEINE, MAUVIN [n]\n",
  "MAUVINS": "MAUVIN, a mauve dye, also MAUVEIN, MAUVEINE, MAUVINE [n]\n",
  "MAUZIER": "MAUZY, foggy, misty, also MAUSY [adj]\n",
  "MAUZIEST": "MAUZY, foggy, misty, also MAUSY [adj]\n",
  "MAUZY": "foggy, misty, also MAUSY [adj MAUZIER, MAUZIEST]\n",
  "MAVEN": "(US slang) an expert, a pundit, also MAVIN, MAYVIN [n -S]\n",
  "MAVENS": "MAVEN, (US slang) an expert, a pundit, also MAVIN, MAYVIN [n]\n",
  "MAVERICK": "an unbranded animal; a person independent in thought and action [n -S] / to seize without legal claim [v -ED, -ING, -S]\n",
  "MAVERICKED": "MAVERICK, to seize without legal claim [v]\n",
  "MAVERICKING": "MAVERICK, to seize without legal claim [v]\n",
  "MAVERICKS": "MAVERICK, an unbranded animal; a person independent in thought and action [n]\n",
  "MAVIE": "the throstle or song thrush, also MAVIS [n -S]\n",
  "MAVIES": "MAVIE, the throstle or song thrush, also MAVIS [n]\n",
  "MAVIN": "(US slang) an expert, a pundit, also MAVEN, MAYVIN [n -S]\n",
  "MAVINS": "MAVIN, (US slang) an expert, a pundit, also MAVEN, MAYVIN [n]\n",
  "MAVIS": "the European throstle or song thrush, also MAVIE [n -ES]\n",
  "MAVISES": "MAVIS, the European throstle or song thrush, also MAVIE [n]\n",
  "MAVOURNEEN": "(Irish) my dear one, also MAVOURNIN [n -S]\n",
  "MAVOURNEENS": "MAVOURNEEN, (Irish) my dear one, also MAVOURNIN [n]\n",
  "MAVOURNIN": "(Irish) my dear one, also MAVOURNEEN [n -S]\n",
  "MAVOURNINS": "MAVOURNIN, (Irish) my dear one, also MAVOURNEEN [n]\n",
  "MAW": "(US) to mow [v -ED, -ING, -S]\n",
  "MAWBOUND": "constipated by impaction of the rumen [adj]\n",
  "MAWED": "MAW, (US) to mow [v]\n",
  "MAWGER": "(Caribbean) lean, thin [adj]\n",
  "MAWING": "MAW, (US) to mow [v]\n",
  "MAWK": "(Old Norse) a maggot [n -S]\n",
  "MAWKIER": "MAWKY, maggoty [adj]\n",
  "MAWKIEST": "MAWKY, maggoty [adj]\n",
  "MAWKIN": "(dialect) a cat, also GRIMALKIN, MALKIN [n -S]\n",
  "MAWKINS": "MAWKIN, (dialect) a cat, also GRIMALKIN, MALKIN [n]\n",
  "MAWKISH": "offensively sentimental [adj MAWKISHLY]\n",
  "MAWKISHLY": "MAWKISH, offensively sentimental [adv]\n",
  "MAWKISHNESS": "the state of being mawkish [n -ES]\n",
  "MAWKISHNESSES": "MAWKISHNESS, the state of being mawkish [n]\n",
  "MAWKS": "MAWK, (Old Norse) a maggot [n]\n",
  "MAWKY": "maggoty [adj MAWKIER, MAWKIEST]\n",
  "MAWMET": "a puppet; a doll, also MAMMET, MAUMET, MOMMET [n -S]\n",
  "MAWMETRIES": "MAWMETRY, the religion of Mohammed; idolatry, also MAMMETRY, MAUMETRY [n]\n",
  "MAWMETRY": "the religion of Mohammed; idolatry, also MAMMETRY, MAUMETRY [n MAWMETRIES]\n",
  "MAWMETS": "MAWMET, a puppet; a doll, also MAMMET, MAUMET, MOMMET [n]\n",
  "MAWN": "a regional measure of capacity [n -S]\n",
  "MAWNS": "MAWN, a regional measure of capacity [n]\n",
  "MAWPUS": "(slang) a small coin, also MOPUS [n -ES]\n",
  "MAWPUSES": "MAWPUS, (slang) a small coin, also MOPUS [n]\n",
  "MAWR": "(dialect) a girl, esp. a great awkward girl, also MAUTHER, MAWTHER [n -S]\n",
  "MAWRS": "MAWR, (dialect) a girl, esp. a great awkward girl, also MAUTHER, MAWTHER [n]\n",
  "MAWS": "MAW, (US) to mow [v]\n",
  "MAWSEED": "the seed of the opium poppy [n -S]\n",
  "MAWSEEDS": "MAWSEED, the seed of the opium poppy [n]\n",
  "MAWTHER": "(dialect) a big awkward girl, also MAUTHER, MAWR [n -S]\n",
  "MAWTHERS": "MAWTHER, (dialect) a big awkward girl, also MAUTHER, MAWR [n]\n",
  "MAX": "to reach an upper limit [v -ED, -ING, -ES]\n",
  "MAXED": "MAX, to reach an upper limit [v]\n",
  "MAXES": "MAX, to reach an upper limit [v]\n",
  "MAXI": "a long skirt or coat [n -S]\n",
  "MAXIBOAT": "a large racing yacht [n -S]\n",
  "MAXIBOATS": "MAXIBOAT, a large racing yacht [n]\n",
  "MAXICOAT": "a long coat [n -S]\n",
  "MAXICOATS": "MAXICOAT, a long coat [n]\n",
  "MAXIDRESS": "a dress that reaches the ankle [n -ES]\n",
  "MAXIDRESSES": "MAXIDRESS, a dress that reaches the ankle [n]\n",
  "MAXILLA": "(Latin) the bone of either the upper or the under jaw [n MAXILLAE or MAXILLAS]\n",
  "MAXILLAE": "MAXILLA, (Latin) the bone of either the upper or the under jaw [n]\n",
  "MAXILLAR": "relating to the maxilla, the bone of either the upper or the under jaw [adj]\n",
  "MAXILLARIES": "MAXILLARY, a bone of the jaw [n]\n",
  "MAXILLARY": "of or relating to the jaw [adj] / a bone of the jaw [n MAXILLARIES]\n",
  "MAXILLAS": "MAXILLA, (Latin) the bone of either the upper or the under jaw [n]\n",
  "MAXILLIPED": "one of the mouth appendages of Crustacea, situated next behind the maxillae, also MAXILLIPEDE [n -S]\n",
  "MAXILLIPEDARY": "like a maxilliped, one of the mouth appendages of Crustacea [adj]\n",
  "MAXILLIPEDE": "one of the mouth appendages of Crustacea, situated next behind the maxillae, also MAXILLIPED [n -S]\n",
  "MAXILLIPEDES": "MAXILLIPEDE, one of the mouth appendages of Crustacea, situated next behind the maxillae, also MAXILLIPED [n]\n",
  "MAXILLIPEDS": "MAXILLIPED, one of the mouth appendages of Crustacea, situated next behind the maxillae, also MAXILLIPEDE [n]\n",
  "MAXILLOFACIAL": "of, relating to, or treating the maxilla and the face [adj]\n",
  "MAXILLULA": "in crustaceans, a maxilla of the first pair [n MAXILLULAE]\n",
  "MAXILLULAE": "MAXILLULA, in crustaceans, a maxilla of the first pair [n]\n",
  "MAXIM": "a brief expression of a general truth, principle, or rule of conduct [n -S]\n",
  "MAXIMA": "MAXIMUM, the largest possible amount [n]\n",
  "MAXIMAL": "pertaining to the maximum [adj MAXIMALLY] / an element of a mathematical set that is followed by no other [n -S]\n",
  "MAXIMALIST": "a revolutionary, a Bolshevik [n -S]\n",
  "MAXIMALISTS": "MAXIMALIST, a revolutionary, a Bolshevik [n]\n",
  "MAXIMALLY": "MAXIMAL, pertaining to the maximum [adv]\n",
  "MAXIMALS": "MAXIMAL, an element of a mathematical set that is followed by no other [n]\n",
  "MAXIMAND": "something that is to be maximized [n -S]\n",
  "MAXIMANDS": "MAXIMAND, something that is to be maximized [n]\n",
  "MAXIMAPHILIES": "MAXIMAPHILY, the study and collection of maximum cards [n]\n",
  "MAXIMAPHILY": "the study and collection of maximum cards [n MAXIMAPHILIES]\n",
  "MAXIMATION": "the act of maximising, also MAXIMISATION, MAXIMIZATION [n -S]\n",
  "MAXIMATIONS": "MAXIMATION, the act of maximising, also MAXIMISATION, MAXIMIZATION [n]\n",
  "MAXIMIN": "the highest value in a set of minimum values [n -S]\n",
  "MAXIMINS": "MAXIMIN, the highest value in a set of minimum values [n]\n",
  "MAXIMISATION": "the act of maximising, also MAXIMATION, MAXIMIZATION [n -S]\n",
  "MAXIMISATIONS": "MAXIMISATION, the act of maximising, also MAXIMATION, MAXIMIZATION [n]\n",
  "MAXIMISE": "to make as great as possible, also MAXIMIZE [v MAXIMISED, MAXIMISING, MAXIMISES]\n",
  "MAXIMISED": "MAXIMISE, to make as great as possible, also MAXIMIZE [v]\n",
  "MAXIMISER": "one who maximises, also MAXIMIZER [n -S]\n",
  "MAXIMISERS": "MAXIMISER, one who maximises, also MAXIMIZER [n]\n",
  "MAXIMISES": "MAXIMISE, to make as great as possible, also MAXIMIZE [v]\n",
  "MAXIMISING": "MAXIMISE, to make as great as possible, also MAXIMIZE [v]\n",
  "MAXIMIST": "a habitual maker of maxims [n -S]\n",
  "MAXIMISTS": "MAXIMIST, a habitual maker of maxims [n]\n",
  "MAXIMITE": "a powerful explosive [n -S]\n",
  "MAXIMITES": "MAXIMITE, a powerful explosive [n]\n",
  "MAXIMIZATION": "the act of maximizing, also MAXIMATION, MAXIMISATION [n -S]\n",
  "MAXIMIZATIONS": "MAXIMIZATION, the act of maximizing, also MAXIMATION, MAXIMISATION [n]\n",
  "MAXIMIZE": "to make as great as possible, also MAXIMISE [v MAXIMIZED, MAXIMIZING, MAXIMIZES]\n",
  "MAXIMIZED": "MAXIMIZE, to make as great as possible, also MAXIMISE [v]\n",
  "MAXIMIZER": "one who maximizes, also MAXIMISER [n -S]\n",
  "MAXIMIZERS": "MAXIMIZER, one who maximizes, also MAXIMISER [n]\n",
  "MAXIMIZES": "MAXIMIZE, to make as great as possible, also MAXIMISE [v]\n",
  "MAXIMIZING": "MAXIMIZE, to make as great as possible, also MAXIMISE [v]\n",
  "MAXIMS": "MAXIM, a brief expression of a general truth, principle, or rule of conduct [n]\n",
  "MAXIMUM": "(Latin) greatest [adj MAXIMUMLY] / the largest possible amount [n MAXIMA or MAXIMUMS]\n",
  "MAXIMUMLY": "MAXIMUM, (Latin) greatest [adv]\n",
  "MAXIMUMS": "MAXIMUM, the largest possible amount [n]\n",
  "MAXIMUS": "a very long bell ringing sequence on twelve bells [n -ES]\n",
  "MAXIMUSES": "MAXIMUS, a very long bell ringing sequence on twelve bells [n]\n",
  "MAXING": "MAX, to reach an upper limit [v]\n",
  "MAXIS": "MAXI, a long skirt or coat [n]\n",
  "MAXIXE": "(Portuguese) a Brazilian ballroom dance resembling the two-step [n -S]\n",
  "MAXIXES": "MAXIXE, (Portuguese) a Brazilian ballroom dance resembling the two-step [n]\n",
  "MAXWELL": "a unit of magnetic flux [n -S]\n",
  "MAXWELLS": "MAXWELL, a unit of magnetic flux [n]\n",
  "MAY": "to gather flowers in the spring [v -ED, -ING, -S] / to express permission [v present 2d person sing MAY, MAYEST, or MAYST, past tense MIGHT or MOUGHT, past 2d person sing MIGHTST or MIGHTEST]\n",
  "MAYA": "(Sanskrit) in Buddhist philosophy, the power to produce illusions [n -S]\n",
  "MAYAN": "relating to maya, in Buddhist philosophy, the power to produce illusions [adj]\n",
  "MAYAPPLE": "an American plant, the egg-shaped fruit of this [n -S]\n",
  "MAYAPPLES": "MAYAPPLE, an American plant, the egg-shaped fruit of this [n]\n",
  "MAYAS": "MAYA, (Sanskrit) in Buddhist philosophy, the power to produce illusions [n]\n",
  "MAYBE": "an uncertainty [n -S]\n",
  "MAYBES": "MAYBE, an uncertainty [n]\n",
  "MAYBIRD": "an American songbird [n -S]\n",
  "MAYBIRDS": "MAYBIRD, an American songbird [n]\n",
  "MAYBUSH": "the hawthorn [n -ES]\n",
  "MAYBUSHES": "MAYBUSH, the hawthorn [n]\n",
  "MAYDAY": "the international radiotelephonic distress signal [n -S]\n",
  "MAYDAYS": "MAYDAY, the international radiotelephonic distress signal [n]\n",
  "MAYED": "MAY, to gather flowers in the spring [v]\n",
  "MAYEST": "MAY, to gather flowers in the spring [v]\n",
  "MAYFISH": "a common killifish of North America [n -ES]\n",
  "MAYFISHES": "MAYFISH, a common killifish of North America [n]\n",
  "MAYFLIES": "MAYFLY, a short-lived insect that appears in May [n]\n",
  "MAYFLOWER": "in England, the hawthorn; in New England, the trailing arbutus; also, the blossom of these plants [n -S]\n",
  "MAYFLOWERS": "MAYFLOWER, in England, the hawthorn; in New England, the trailing arbutus; also, the blossom of these plants [n]\n",
  "MAYFLY": "a short-lived insect that appears in May [n MAYFLIES]\n",
  "MAYHAP": "(archaic) perhaps, also MAYHAPPEN [adv]\n",
  "MAYHAPPEN": "perhaps, also MAYHAP [adv]\n",
  "MAYHEM": "maiming, malicious damage, also MAIHEM [n -S]\n",
  "MAYHEMS": "MAYHEM, maiming, malicious damage, also MAIHEM [n]\n",
  "MAYING": "the gathering of spring flowers [n -S]\n",
  "MAYINGS": "MAYING, the gathering of spring flowers [n]\n",
  "MAYO": "(short for) mayonnaise [n -S]\n",
  "MAYONNAISE": "(French) a thick sauce consisting of yolk of egg beaten up with oil and vinegar and seasoned with salt etc. [n -S]\n",
  "MAYONNAISES": "MAYONNAISE, (French) a thick sauce consisting of yolk of egg beaten up with oil and vinegar and seasoned with salt etc. [n]\n",
  "MAYOR": "the chief executive official of a city or borough [n -S]\n",
  "MAYORAL": "pertaining to the mayor [adj]\n",
  "MAYORALTIES": "MAYORALTY, the office, or the term of office, of a mayor [n]\n",
  "MAYORALTY": "the office, or the term of office, of a mayor [n MAYORALTIES]\n",
  "MAYORESS": "a female mayor [n -ES]\n",
  "MAYORESSES": "MAYORESS, a female mayor [n]\n",
  "MAYORS": "MAYOR, the chief executive official of a city or borough [n]\n",
  "MAYORSHIP": "the office of a mayor [n -S]\n",
  "MAYORSHIPS": "MAYORSHIP, the office of a mayor [n]\n",
  "MAYOS": "MAYO, (short for) mayonnaise [n]\n",
  "MAYPOLE": "a decorated pole used in a spring celebration [n -S]\n",
  "MAYPOLES": "MAYPOLE, a decorated pole used in a spring celebration [n]\n",
  "MAYPOP": "the edible fruit of a passion flower, an oval yellowish berry as large as a small apple [n -S]\n",
  "MAYPOPS": "MAYPOP, the edible fruit of a passion flower, an oval yellowish berry as large as a small apple [n]\n",
  "MAYS": "MAY, to gather flowers in the spring [v]\n",
  "MAYST": "MAY, to gather flowers in the spring [v]\n",
  "MAYSTER": "(Spenser) master, also MAISTER [n -S]\n",
  "MAYSTERDOME": "(Spenser) mastery [n -S]\n",
  "MAYSTERDOMES": "MAYSTERDOME, (Spenser) mastery [n]\n",
  "MAYSTERS": "MAYSTER, (Spenser) master, also MAISTER [n]\n",
  "MAYVIN": "(US slang) an expert, a pundit, also MAVEN, MAVIN [n -S]\n",
  "MAYVINS": "MAYVIN, (US slang) an expert, a pundit, also MAVEN, MAVIN [n]\n",
  "MAYWEED": "a name for various plants including stinking camomile [n -S]\n",
  "MAYWEEDS": "MAYWEED, a name for various plants including stinking camomile [n]\n",
  "MAZAEDIA": "MAZAEDIUM, a spore-producing organ of certain lichens [n]\n",
  "MAZAEDIUM": "a spore-producing organ of certain lichens [n MAZAEDIA]\n",
  "MAZARD": "a kind of small black cherry, also MAZZARD [n -S]\n",
  "MAZARDS": "MAZARD, a kind of small black cherry, also MAZZARD [n]\n",
  "MAZARINADE": "(historical) a satire or pamphlet against Cardinal Mazarin [n -S]\n",
  "MAZARINADES": "MAZARINADE, (historical) a satire or pamphlet against Cardinal Mazarin [n]\n",
  "MAZARINE": "a rich blue or reddish-blue colour [n -S]\n",
  "MAZARINES": "MAZARINE, a rich blue or reddish-blue colour [n]\n",
  "MAZE": "to bewilder [v MAZED, MAZING, MAZES]\n",
  "MAZED": "MAZE, to bewilder [v]\n",
  "MAZEDLY": "MAZED, MAZE, to bewilder [adv]\n",
  "MAZEDNESS": "the state of being mazed [n -ES]\n",
  "MAZEDNESSES": "MAZEDNESS, the state of being mazed [n]\n",
  "MAZEFUL": "(Spenser) bewildered [adj]\n",
  "MAZELIKE": "like a maze [adj]\n",
  "MAZELTOV": "(Yiddish) congratulations [interj]\n",
  "MAZEMENT": "bewilderment, also AMAZEMENT [n -S]\n",
  "MAZEMENTS": "MAZEMENT, bewilderment, also AMAZEMENT [n]\n",
  "MAZER": "a large drinking vessel of hardwood or metal [n -S]\n",
  "MAZERS": "MAZER, a large drinking vessel of hardwood or metal [n]\n",
  "MAZES": "MAZE, to bewilder [v]\n",
  "MAZEY": "winding or convoluted as a maze; confused, dizzy, also MAZY [adj MAZIER, MAZIEST, MAZILY]\n",
  "MAZHBI": "(Hindi) a Sikh of low caste [n -S]\n",
  "MAZHBIS": "MAZHBI, (Hindi) a Sikh of low caste [n]\n",
  "MAZIER": "MAZY, full of confusing turns and passages [adj]\n",
  "MAZIEST": "MAZY, full of confusing turns and passages [adj]\n",
  "MAZILY": "MAZY, full of confusing turns and passages [adv]\n",
  "MAZINESS": "the quality of being mazy [n -ES]\n",
  "MAZINESSES": "MAZINESS, the quality of being mazy [n]\n",
  "MAZING": "MAZE, to bewilder [v]\n",
  "MAZOURKA": "(Polish) a Polish dance, also MAZURKA [n -S]\n",
  "MAZOURKAS": "MAZOURKA, (Polish) a Polish dance, also MAZURKA [n]\n",
  "MAZOUT": "(Russian) a petroleum residue, also MAZUT [n -S]\n",
  "MAZOUTS": "MAZOUT, (Russian) a petroleum residue, also MAZUT [n]\n",
  "MAZUMA": "(Yiddish) money, cash [n -S]\n",
  "MAZUMAS": "MAZUMA, (Yiddish) money, cash [n]\n",
  "MAZURKA": "(Polish) a Polish folk dance, also MAZOURKA [n -S]\n",
  "MAZURKAS": "MAZURKA, (Polish) a Polish folk dance, also MAZOURKA [n]\n",
  "MAZUT": "(Russian) petroleum residue after distillation, also MAZOUT [n -S]\n",
  "MAZUTS": "MAZUT, (Russian) petroleum residue after distillation, also MAZOUT [n]\n",
  "MAZY": "full of confusing turns and passages [adj MAZIER, MAZIEST, MAZILY]\n",
  "MAZZARD": "a kind of small black cherry, also MAZARD [n -S]\n",
  "MAZZARDS": "MAZZARD, a kind of small black cherry, also MAZARD [n]\n",
  "MBAQANGA": "(Zulu) a type of Black African urban music [n -S]\n",
  "MBAQANGAS": "MBAQANGA, (Zulu) a type of Black African urban music [n]\n",
  "MBIRA": "(Bantu) an African musical instrument played with the thumbs, aka kalimba [n -S]\n",
  "MBIRAS": "MBIRA, (Bantu) an African musical instrument played with the thumbs, aka kalimba [n]\n",
  "ME": "the third note of the musical scale, also MI [n -S]\n",
  "MEACOCK": "(Shakespeare) a meek man who dotes on his wife, or is henpecked [n -S]\n",
  "MEACOCKS": "MEACOCK, (Shakespeare) a meek man who dotes on his wife, or is henpecked [n]\n",
  "MEAD": "an alcoholic liquor produced by fermenting a mixture of honey and water, also MEATH, MEATHE [n -S]\n",
  "MEADOW": "a tract of grassland [n -S]\n",
  "MEADOWIER": "MEADOWY, of or pertaining to meadows [adj]\n",
  "MEADOWIEST": "MEADOWY, of or pertaining to meadows [adj]\n",
  "MEADOWLAND": "land that is or is used for meadow [n -S]\n",
  "MEADOWLANDS": "MEADOWLAND, land that is or is used for meadow [n]\n",
  "MEADOWLARK": "any of several American songbirds of the genus Sturnella [n -S]\n",
  "MEADOWLARKS": "MEADOWLARK, any of several American songbirds of the genus Sturnella [n]\n",
  "MEADOWS": "MEADOW, a tract of grassland [n]\n",
  "MEADOWSWEET": "a tall fragrant plant growing esp. in watery meadows [n -S]\n",
  "MEADOWSWEETS": "MEADOWSWEET, a tall fragrant plant growing esp. in watery meadows [n]\n",
  "MEADOWY": "of or pertaining to meadows [adj MEADOWIER, MEADOWIEST]\n",
  "MEADS": "MEAD, an alcoholic liquor produced by fermenting a mixture of honey and water, also MEATH, MEATHE [n]\n",
  "MEAGER": "(US) scanty, also MAIGRE, MEAGRE [adj MEAGERER, MEAGEREST, MEAGERLY]\n",
  "MEAGERER": "MEAGER, (US) scanty, also MAIGRE, MEAGRE [adj]\n",
  "MEAGEREST": "MEAGER, (US) scanty, also MAIGRE, MEAGRE [adj]\n",
  "MEAGERLY": "MEAGER, (US) scanty, also MAIGRE, MEAGRE [adv]\n",
  "MEAGERNESS": "the state of being meager, also MEAGRENESS [n -ES]\n",
  "MEAGERNESSES": "MEAGERNESS, the state of being meager, also MEAGRENESS [n]\n",
  "MEAGRE": "a large Mediterranean food fish [n -S] / inadequate, also MEAGER [adj MEAGRER, MEAGREST, MEAGRELY]\n",
  "MEAGRELY": "MEAGRE, inadequate, also MEAGER [adv]\n",
  "MEAGRENESS": "the state of being meagre, also MEAGERNESS [n -ES]\n",
  "MEAGRENESSES": "MEAGRENESS, the state of being meagre, also MEAGERNESS [n]\n",
  "MEAGRER": "MEAGRE, inadequate, also MEAGER [adj]\n",
  "MEAGRES": "MEAGRE, a large Mediterranean food fish [n]\n",
  "MEAGREST": "MEAGRE, inadequate, also MEAGER [adj]\n",
  "MEAL": "grain ground to powder [n -S] / to cover with meal [v -ED, -ING, -S]\n",
  "MEALED": "MEAL, to cover with meal [v]\n",
  "MEALER": "a device for converting grain into meal [n -S]\n",
  "MEALERS": "MEALER, a device for converting grain into meal [n]\n",
  "MEALIE": "(South African) an ear of maize, also MIELIE [n -S]\n",
  "MEALIER": "MEALY, covered with meal [adj]\n",
  "MEALIES": "MEALIE, (South African) an ear of maize, also MIELIE [n]\n",
  "MEALIEST": "MEALY, covered with meal [adj]\n",
  "MEALINESS": "the state of being mealy [n -ES]\n",
  "MEALINESSES": "MEALINESS, the state of being mealy [n]\n",
  "MEALING": "MEAL, to cover with meal [v]\n",
  "MEALLESS": "without a meal [adj]\n",
  "MEALS": "MEAL, to cover with meal [v]\n",
  "MEALTIME": "the usual time for a meal [n -S]\n",
  "MEALTIMES": "MEALTIME, the usual time for a meal [n]\n",
  "MEALWORM": "the destructive larva of certain beetles [n -S]\n",
  "MEALWORMS": "MEALWORM, the destructive larva of certain beetles [n]\n",
  "MEALY": "covered with meal [adj MEALIER, MEALIEST]\n",
  "MEALYBUG": "a destructive insect [n -S]\n",
  "MEALYBUGS": "MEALYBUG, a destructive insect [n]\n",
  "MEALYMOUTHED": "not plain and straightforward [adj]\n",
  "MEAN": "stingy; low [adj MEANER, MEANEST, MEANLY] / to tend, signify [v MEANT, MEANING, MEANS] / to moan [v MEANED, MEANING, MEANS]\n",
  "MEANDER": "to wander [v -ED, -ING, -S]\n",
  "MEANDERED": "MEANDER, to wander [v]\n",
  "MEANDERER": "one who meanders [n -S]\n",
  "MEANDERERS": "MEANDERER, one who meanders [n]\n",
  "MEANDERING": "winding about in a circuitous course [adj MEANDERINGLY] / circuitous winding [n -S]\n",
  "MEANDERINGLY": "MEANDERING [adv]\n",
  "MEANDERINGS": "MEANDERING, circuitous winding [n]\n",
  "MEANDERS": "MEANDER, to wander [v]\n",
  "MEANDRIAN": "(obsolete) meandering, also MEANDROUS [adj]\n",
  "MEANDROUS": "meandering, also MEANDRIAN [adj]\n",
  "MEANE": "(Scots) to lament, moan, also MEIN, MENE [v MEANED, MEANING, MEANES]\n",
  "MEANED": "MEAN, to tend, signify [v]\n",
  "MEANER": "a person who means, intends, or purposes [n -S]\n",
  "MEANERS": "MEANER, a person who means, intends, or purposes [n]\n",
  "MEANES": "MEANE, (Scots) to lament, moan, also MEIN, MENE [v]\n",
  "MEANEST": "MEAN, stingy; low [adj]\n",
  "MEANIE": "a nasty person, also MEANY [n -S]\n",
  "MEANIES": "MEANY, a nasty person, also MEANIE [n]\n",
  "MEANING": "meaningful [adj MEANINGLY] / the sense intended [n -S]\n",
  "MEANINGFUL": "having a meaning or purpose [adj MEANINGFULLY]\n",
  "MEANINGFULLY": "MEANINGFUL, having a meaning or purpose [adv]\n",
  "MEANINGFULNESS": "MEANINGFUL, having a meaning or purpose [n]\n",
  "MEANINGLESS": "having no meaning [adj MEANINGLESSLY]\n",
  "MEANINGLESSLY": "MEANINGLESS, having no meaning [adv]\n",
  "MEANINGLESSNESS": "MEANINGLESS, having no meaning [n]\n",
  "MEANINGLY": "MEANING, meaningful [adv]\n",
  "MEANINGS": "MEANING, the sense intended [n]\n",
  "MEANLY": "MEAN, stingy; low [adv]\n",
  "MEANNESS": "the state of being mean [n -ES]\n",
  "MEANNESSES": "MEANNESS, the state of being mean [n]\n",
  "MEANS": "MEAN, to tend, signify [v]\n",
  "MEANT": "MEAN, to tend, signify [v]\n",
  "MEANTIME": "the intervening time [n -S]\n",
  "MEANTIMES": "MEANTIME, the intervening time [n]\n",
  "MEANWHILE": "a period of time while something else is going on [n -S]\n",
  "MEANWHILES": "MEANWHILE, a period of time while something else is going on [n]\n",
  "MEANY": "a nasty person, also MEANIE [n MEANIES]\n",
  "MEARE": "(Spenser) to divide, mark off, also MEER, MERE [v MEARING, MEARES; note that the past tense is given as MEARE'D]\n",
  "MEARES": "MEARE, (Spenser) to divide, mark off, also MEER, MERE [v]\n",
  "MEARING": "MEARE, (Spenser) to divide, mark off, also MEER, MERE [v]\n",
  "MEASE": "(Scots) to make less severe, mitigate [v MEASED, MEASING, MEASES]\n",
  "MEASED": "MEASE, (Scots) to make less severe, mitigate [v]\n",
  "MEASES": "MEASE, (Scots) to make less severe, mitigate [v]\n",
  "MEASING": "MEASE, (Scots) to make less severe, mitigate [v]\n",
  "MEASLE": "(archaic) to catch or infect with measles [v MEASLED, MEASLING, MEASLES]\n",
  "MEASLED": "MEASLE, (archaic) to catch or infect with measles [v]\n",
  "MEASLES": "MEASLE, (archaic) to catch or infect with measles [v]\n",
  "MEASLIER": "MEASLY, spotty, paltry [adj]\n",
  "MEASLIEST": "MEASLY, spotty, paltry [adj]\n",
  "MEASLINESS": "the state of being measly [n -ES]\n",
  "MEASLINESSES": "MEASLINESS, the state of being measly [n]\n",
  "MEASLING": "MEASLE, (archaic) to catch or infect with measles [v]\n",
  "MEASLY": "spotty, paltry [adj MEASLIER, MEASLIEST]\n",
  "MEASURABILITIES": "MEASURABILITY, the state of being measurable [n]\n",
  "MEASURABILITY": "the state of being measurable [n MEASURABILITIES]\n",
  "MEASURABLE": "that can be measured [adj MEASURABLY]\n",
  "MEASURABLENESS": "MEASURABLE, that can be measured [n]\n",
  "MEASURABLY": "MEASURABLE, that can be measured [adv]\n",
  "MEASURE": "to compare with a standard [v MEASURED, MEASURING, MEASURES]\n",
  "MEASURED": "MEASURE, to compare with a standard [v]\n",
  "MEASUREDLY": "MEASURED, MEASURE, to compare with a standard [adv]\n",
  "MEASUREDNESS": "the state of being measured [n -ES]\n",
  "MEASUREDNESSES": "MEASUREDNESS, the state of being measured [n]\n",
  "MEASURELESS": "having no observable limit [adj MEASURELESSLY]\n",
  "MEASURELESSLY": "MEASURELESS, having no observable limit [adv]\n",
  "MEASURELESSNESS": "MEASURELESS, having no observable limit [n]\n",
  "MEASUREMENT": "the act of measuring [n -S]\n",
  "MEASUREMENTS": "MEASUREMENT, the act of measuring [n]\n",
  "MEASURER": "one who measures [n -S]\n",
  "MEASURERS": "MEASURER, one who measures [n]\n",
  "MEASURES": "MEASURE, to compare with a standard [v]\n",
  "MEASURING": "the act of taking a measurement [n -S]\n",
  "MEASURINGS": "MEASURING, the act of taking a measurement [n]\n",
  "MEAT": "animal flesh used as food [n -S]\n",
  "MEATAL": "relating to a meatus, the opening of a passage or canal [adj]\n",
  "MEATAXE": "a meat cleaver [n -S]\n",
  "MEATAXES": "MEATAXE, a meat cleaver [n]\n",
  "MEATBALL": "a small ball of minced meat [n -S]\n",
  "MEATBALLS": "MEATBALL, a small ball of minced meat [n]\n",
  "MEATED": "to become meat [adj]\n",
  "MEATH": "(obsolete) an alcoholic drink made by fermenting honey and water, also MEAD, MEATHE [n -S]\n",
  "MEATHE": "(obsolete) an alcoholic drink made by fermenting honey and water, also MEAD, MEATH [n -S]\n",
  "MEATHEAD": "(US slang) a stupid person [n -S]\n",
  "MEATHEADS": "MEATHEAD, (US slang) a stupid person [n]\n",
  "MEATHES": "MEATHE, (obsolete) an alcoholic drink made by fermenting honey and water, also MEAD, MEATH [n]\n",
  "MEATHOOK": "a hook on which to hang meat [n -S]\n",
  "MEATHOOKS": "MEATHOOK, a hook on which to hang meat [n]\n",
  "MEATHS": "MEATH, (obsolete) an alcoholic drink made by fermenting honey and water, also MEAD, MEATHE [n]\n",
  "MEATIER": "MEATY, full of meat [adj]\n",
  "MEATIEST": "MEATY, full of meat [adj]\n",
  "MEATILY": "MEATY, full of meat [adv]\n",
  "MEATINESS": "the state of being meaty [n -ES]\n",
  "MEATINESSES": "MEATINESS, the state of being meaty [n]\n",
  "MEATLESS": "without meat [adj]\n",
  "MEATLOAF": "a baked loaf of ground meat [n MEATLOAVES]\n",
  "MEATLOAVES": "MEATLOAF, a baked loaf of ground meat [n]\n",
  "MEATMAN": "a vendor of meat [n MEATMEN]\n",
  "MEATMEN": "MEATMAN, a vendor of meat [n]\n",
  "MEATPACKER": "(US) a person or company involved in the wholesale meat trade [n -S]\n",
  "MEATPACKERS": "MEATPACKER, (US) a person or company involved in the wholesale meat trade [n]\n",
  "MEATPACKING": "the wholesale meat industry [n -S]\n",
  "MEATPACKINGS": "MEATPACKING, the wholesale meat industry [n]\n",
  "MEATS": "MEAT, animal flesh used as food [n]\n",
  "MEATSCREEN": "a metal screen behind roasting meat, to throw back the fire's heat on it [n -S]\n",
  "MEATSCREENS": "MEATSCREEN, a metal screen behind roasting meat, to throw back the fire's heat on it [n]\n",
  "MEATSPACE": "real physical space, as contrasted with the world of cyberspace [n -S]\n",
  "MEATSPACES": "MEATSPACE, real physical space, as contrasted with the world of cyberspace [n]\n",
  "MEATUS": "(Latin) a natural body passage [n -ES]\n",
  "MEATUSES": "MEATUS, (Latin) a natural body passage [n]\n",
  "MEATY": "full of meat [adj MEATIER, MEATIEST, MEATILY]\n",
  "MEAWES": "(Spenser) mews, gulls [n]\n",
  "MEAZEL": "(Shakespeare) a leper, spoken in contempt of a mean person, also MESEL [n -S]\n",
  "MEAZELS": "MEAZEL, (Shakespeare) a leper, spoken in contempt of a mean person, also MESEL [n]\n",
  "MEBIBYTE": "2 to the power of 20 bytes [n -S]\n",
  "MEBIBYTES": "MEBIBYTE, 2 to the power of 20 bytes [n]\n",
  "MEBOS": "(South African) salted or sugared dried apricots [n -ES]\n",
  "MEBOSES": "MEBOS, (South African) salted or sugared dried apricots [n]\n",
  "MECAMYLAMINE": "a drug used orally as a ganglionic blocking agent to effect a rapid lowering of severely elevated blood pressure [n -S]\n",
  "MECAMYLAMINES": "MECAMYLAMINE, a drug used orally as a ganglionic blocking agent to effect a rapid lowering of severely elevated blood pressure [n]\n",
  "MECCA": "(Arabic) a place visited by many people, also MEKKA [n -S]\n",
  "MECCAS": "MECCA, (Arabic) a place visited by many people, also MEKKA [n]\n",
  "MECH": "(short for) mechanic [n -S]\n",
  "MECHANIC": "a person who works with machines [n -S]\n",
  "MECHANICAL": "relating to machines [adj MECHANICALLY] / a manual worker [n -S]\n",
  "MECHANICALISM": "the belief that phenomena are determined by physical forces [n -S]\n",
  "MECHANICALISMS": "MECHANICALISM, the belief that phenomena are determined by physical forces [n]\n",
  "MECHANICALLY": "MECHANICAL, relating to machines [adv]\n",
  "MECHANICALNESS": "the state of being mechanical [n]\n",
  "MECHANICALS": "MECHANICAL, a manual worker [n]\n",
  "MECHANICIAN": "a mechanic [n -S]\n",
  "MECHANICIANS": "MECHANICIAN, a mechanic [n]\n",
  "MECHANICS": "MECHANIC, a person who works with machines [n]\n",
  "MECHANISABLE": "that can be mechanised, also MECHANIZABLE [adj]\n",
  "MECHANISATION": "the act of mechanising, also MECHANIZATION [n -S]\n",
  "MECHANISATIONS": "MECHANISATION, the act of mechanising, also MECHANIZATION [n]\n",
  "MECHANISE": "to make mechanical, also MECHANIZE [v MECHANISED, MECHANISING, MECHANISES]\n",
  "MECHANISED": "MECHANISE, to make mechanical, also MECHANIZE [v]\n",
  "MECHANISER": "one who mechanises, also MECHANIZER [n -S]\n",
  "MECHANISERS": "MECHANISER, one who mechanises, also MECHANIZER [n]\n",
  "MECHANISES": "MECHANISE, to make mechanical, also MECHANIZE [v]\n",
  "MECHANISING": "MECHANISE, to make mechanical, also MECHANIZE [v]\n",
  "MECHANISM": "the belief that life is explainable by mechanical forces [n -S]\n",
  "MECHANISMS": "MECHANISM, the belief that life is explainable by mechanical forces [n]\n",
  "MECHANIST": "an adherent of mechanism, the belief that life is explainable by mechanical forces [n -S]\n",
  "MECHANISTIC": "relating to mechanism [adj MECHANISTICALLY]\n",
  "MECHANISTICALLY": "MECHANISTIC, relating to mechanism [adv]\n",
  "MECHANISTS": "MECHANIST, an adherent of mechanism, the belief that life is explainable by mechanical forces [n]\n",
  "MECHANIZABLE": "capable of being mechanized, also MECHANISABLE [adj]\n",
  "MECHANIZATION": "the act of mechanizing, also MECHANISATION [n -S]\n",
  "MECHANIZATIONS": "MECHANIZATION, the act of mechanizing, also MECHANISATION [n]\n",
  "MECHANIZE": "to make mechanical, also MECHANISE [v MECHANIZED, MECHANIZING, MECHANIZES]\n",
  "MECHANIZED": "MECHANIZE, to make mechanical, also MECHANISE [v]\n",
  "MECHANIZER": "one who mechanizes, also MECHANISER [n -S]\n",
  "MECHANIZERS": "MECHANIZER, one who mechanizes, also MECHANISER [n]\n",
  "MECHANIZES": "MECHANIZE, to make mechanical, also MECHANISE [v]\n",
  "MECHANIZING": "MECHANIZE, to make mechanical, also MECHANISE [v]\n",
  "MECHANOCHEMICAL": "of or relating to mechanochemistry, the branch of science that deals with the relation between mechanical and chemical phenomena and the interconversion of these forms of energy [adj]\n",
  "MECHANOMORPHISM": "the doctrine that the universe is fully explicable in mechanistic terms [n]\n",
  "MECHANORECEPTOR": "a neural end organ (as a tactile receptor) that responds to a mechanical stimulus (as a change in pressure) [n]\n",
  "MECHANOTHERAPY": "the treatment of disorders or injuries by means of mechanical devices, esp. devices that provide exercise for bodily parts [n]\n",
  "MECHATRONIC": "relating to mechatronics [adj]\n",
  "MECHATRONICS": "a cross-disciplinary combination of mechanics, electronics, electrical engineering and computing [n]\n",
  "MECHITZA": "(Hebrew) a screen in a synagogue separating men and women [n MECHITZAS or MECHITZOT]\n",
  "MECHITZAS": "MECHITZA, (Hebrew) a screen in a synagogue separating men and women [n]\n",
  "MECHITZOT": "MECHITZA, (Hebrew) a screen in a synagogue separating men and women [n]\n",
  "MECHOUI": "(Canadian) a meal of meat roasted on a spit [n -S]\n",
  "MECHOUIS": "MECHOUI, (Canadian) a meal of meat roasted on a spit [n]\n",
  "MECHS": "MECH, (short for) mechanic [n]\n",
  "MECK": "(Scots) an old halfpenny, also MAIK, MEG [n -S]\n",
  "MECKS": "MECK, (Scots) an old halfpenny, also MAIK, MEG [n]\n",
  "MECLIZINE": "a drug used to treat nausea and vertigo [n -S]\n",
  "MECLIZINES": "MECLIZINE, a drug used to treat nausea and vertigo [n]\n",
  "MECONATE": "a salt of meconic acid [n -S]\n",
  "MECONATES": "MECONATE, a salt of meconic acid [n]\n",
  "MECONIC": "denoting an acid from poppies [adj]\n",
  "MECONIN": "a white, fusible, neutral substance existing in opium [n -S]\n",
  "MECONINS": "MECONIN, a white, fusible, neutral substance existing in opium [n]\n",
  "MECONIUM": "the first fecal excretion of a newborn child [n -S]\n",
  "MECONIUMS": "MECONIUM, the first fecal excretion of a newborn child [n]\n",
  "MECONOPSES": "MECONOPSIS, a plant of the Meconopsis genus of largely Asiatic poppies [n]\n",
  "MECONOPSIS": "a plant of the Meconopsis genus of largely Asiatic poppies [n MECONOPSES]\n",
  "MED": "(short for) medical, medicine [n -S]\n",
  "MEDACCA": "(Japanese) a small Japanese fish, also MEDAKA [n -S]\n",
  "MEDACCAS": "MEDACCA, (Japanese) a small Japanese fish, also MEDAKA [n]\n",
  "MEDAILLON": "(French) a small round or oval serving, as of meat [n -S]\n",
  "MEDAILLONS": "MEDAILLON, (French) a small round or oval serving, as of meat [n]\n",
  "MEDAKA": "(Japanese) a small Japanese fish, also MEDACCA [n -S]\n",
  "MEDAKAS": "MEDAKA, (Japanese) a small Japanese fish, also MEDACCA [n]\n",
  "MEDAL": "to honour with a commemorative piece of metal [v MEDALED or MEDALLED, MEDALING or MEDALLING, MEDALS]\n",
  "MEDALED": "MEDAL, to honour with a commemorative piece of metal [v]\n",
  "MEDALET": "a small medal [n -S]\n",
  "MEDALETS": "MEDALET, a small medal [n]\n",
  "MEDALING": "MEDAL, to honour with a commemorative piece of metal [v]\n",
  "MEDALIST": "one who wins a medal, also MEDALLIST [n -S]\n",
  "MEDALISTS": "MEDALIST, one who wins a medal, also MEDALLIST [n]\n",
  "MEDALLED": "MEDAL, to honour with a commemorative piece of metal [v]\n",
  "MEDALLIC": "pertaining to a medal [adj]\n",
  "MEDALLING": "MEDAL, to honour with a commemorative piece of metal [v]\n",
  "MEDALLION": "a large medal, esp. worn as jewellery on a chain [n -S] / to ornament with a medallion or medallions [v -ED, -ING, -S]\n",
  "MEDALLIONED": "MEDALLION, to ornament with a medallion or medallions [v]\n",
  "MEDALLIONING": "MEDALLION, to ornament with a medallion or medallions [v]\n",
  "MEDALLIONS": "MEDALLION, to ornament with a medallion or medallions [v]\n",
  "MEDALLIST": "one who wins a medal, also MEDALIST [n -S]\n",
  "MEDALLISTS": "MEDALLIST, one who wins a medal, also MEDALIST [n]\n",
  "MEDALPLAY": "a scoring system used in golf, aka stroke play [n -S]\n",
  "MEDALPLAYS": "MEDALPLAY, a scoring system used in golf, aka stroke play [n]\n",
  "MEDALS": "MEDAL, to honour with a commemorative piece of metal [v]\n",
  "MEDCINAL": "(Milton) medicinal, curative [adj]\n",
  "MEDDLE": "to interfere, also MEDLE [v MEDDLED, MEDDLING, MEDDLES]\n",
  "MEDDLED": "MEDDLE, to interfere, also MEDLE [v]\n",
  "MEDDLER": "one who meddles [n -S]\n",
  "MEDDLERS": "MEDDLER, one who meddles [n]\n",
  "MEDDLES": "MEDDLE, to interfere, also MEDLE [v]\n",
  "MEDDLESOME": "given to meddling [adj MEDDLESOMELY]\n",
  "MEDDLESOMELY": "MEDDLESOME, given to meddling [adv]\n",
  "MEDDLESOMENESS": "the state of being meddlesome [n]\n",
  "MEDDLING": "interfering [adj MEDDLINGLY] / the act of meddling [n -S]\n",
  "MEDDLINGLY": "MEDDLING, interfering [adv]\n",
  "MEDDLINGS": "MEDDLING, the act of meddling [n]\n",
  "MEDEVAC": "to evacuate the wounded from a battlefield by helicopter, also MEDIVAC [v MEDEVACED or MEDEVACKED, MEDEVACING or MEDEVACKING, MEDEVACS]\n",
  "MEDEVACED": "MEDEVAC, to evacuate the wounded from a battlefield by helicopter, also MEDIVAC [v]\n",
  "MEDEVACING": "MEDEVAC, to evacuate the wounded from a battlefield by helicopter, also MEDIVAC [v]\n",
  "MEDEVACKED": "MEDEVAC, to evacuate the wounded from a battlefield by helicopter, also MEDIVAC [v]\n",
  "MEDEVACKING": "MEDEVAC, to evacuate the wounded from a battlefield by helicopter, also MEDIVAC [v]\n",
  "MEDEVACS": "MEDEVAC, to evacuate the wounded from a battlefield by helicopter, also MEDIVAC [v]\n",
  "MEDFLIES": "MEDFLY, a Mediterranean fruit fly [n]\n",
  "MEDFLY": "a Mediterranean fruit fly [n MEDFLIES]\n",
  "MEDIA": "(Latin) the middle layer of a blood vessel [n MEDIAS or MEDIAE]\n",
  "MEDIACIES": "MEDIACY, the act of mediating [n]\n",
  "MEDIACY": "the act of mediating [n MEDIACIES]\n",
  "MEDIAD": "toward the middle of a body [adv]\n",
  "MEDIAE": "MEDIA, (Latin) the middle layer of a blood vessel [n]\n",
  "MEDIAEVAL": "belonging to the Middle Ages, also MEDIEVAL [adj MEDIAEVALLY] / a person who lived in the Middle Ages [n -S]\n",
  "MEDIAEVALISM": "the spirit of the Middle Ages; devotion to medieval ideals, also MEDIEVALISM [n -S]\n",
  "MEDIAEVALISMS": "MEDIAEVALISM, the spirit of the Middle Ages; devotion to medieval ideals, also MEDIEVALISM [n]\n",
  "MEDIAEVALIST": "a supporter of mediaevalism, also MEDIEVALIST [n -S]\n",
  "MEDIAEVALISTIC": "related to mediaevalism, also MEDIEVALISTIC [adj]\n",
  "MEDIAEVALISTS": "MEDIAEVALIST, a supporter of mediaevalism, also MEDIEVALIST [n]\n",
  "MEDIAEVALLY": "MEDIAEVAL, belonging to the Middle Ages, also MEDIEVAL [adv]\n",
  "MEDIAEVALS": "MEDIAEVAL, a person who lived in the Middle Ages [n]\n",
  "MEDIAGENIC": "able to present a good image in the media [adj]\n",
  "MEDIAL": "in the middle [adj MEDIALLY] / a medial letter; a form of a letter used in the middle of a word [n -S]\n",
  "MEDIALLY": "MEDIAL, in the middle [adv]\n",
  "MEDIALS": "MEDIAL, a medial letter; a form of a letter used in the middle of a word [n]\n",
  "MEDIAN": "middle [adj MEDIANLY] / in statistics, the value middle in position [n -S]\n",
  "MEDIANLY": "MEDIAN, middle [adv]\n",
  "MEDIANS": "MEDIAN, in statistics, the value middle in position [n]\n",
  "MEDIANT": "the third tone of a scale, about midway between tonic and dominant [n -S]\n",
  "MEDIANTS": "MEDIANT, the third tone of a scale, about midway between tonic and dominant [n]\n",
  "MEDIAS": "MEDIA, (Latin) the middle layer of a blood vessel [n]\n",
  "MEDIASTINA": "MEDIASTINUM, the chest cavity containing the heart [n]\n",
  "MEDIASTINAL": "relating to the mediastinum, the chest cavity containing the heart [adj]\n",
  "MEDIASTINUM": "the chest cavity containing the heart [n MEDIASTINA]\n",
  "MEDIATE": "middle, intervening [adj MEDIATELY] / to act as an intermediary [v MEDIATED, MEDIATING, MEDIATES]\n",
  "MEDIATED": "MEDIATE, to act as an intermediary [v]\n",
  "MEDIATELY": "MEDIATE, middle, intervening [adv]\n",
  "MEDIATENESS": "the state of being mediate [n -ES]\n",
  "MEDIATENESSES": "MEDIATENESS, the state of being mediate [n]\n",
  "MEDIATES": "MEDIATE, to act as an intermediary [v]\n",
  "MEDIATING": "MEDIATE, to act as an intermediary [v]\n",
  "MEDIATION": "the act of mediating or coming between [n -S]\n",
  "MEDIATIONAL": "relating to mediation [adj]\n",
  "MEDIATIONS": "MEDIATION, the act of mediating or coming between [n]\n",
  "MEDIATISATION": "the act of mediatising, also MEDIATIZATION [n -S]\n",
  "MEDIATISATIONS": "MEDIATISATION, the act of mediatising, also MEDIATIZATION [n]\n",
  "MEDIATISE": "to cause to act through an agent or to hold a subordinate position, also MEDIATIZE [v MEDIATISED, MEDIATISING, MEDIATISES]\n",
  "MEDIATISED": "MEDIATISE, to cause to act through an agent or to hold a subordinate position, also MEDIATIZE [v]\n",
  "MEDIATISES": "MEDIATISE, to cause to act through an agent or to hold a subordinate position, also MEDIATIZE [v]\n",
  "MEDIATISING": "MEDIATISE, to cause to act through an agent or to hold a subordinate position, also MEDIATIZE [v]\n",
  "MEDIATIVE": "pertaining to mediation [adj]\n",
  "MEDIATIZATION": "the act of mediatising, also MEDIATISATION [n -S]\n",
  "MEDIATIZATIONS": "MEDIATIZATION, the act of mediatising, also MEDIATISATION [n]\n",
  "MEDIATIZE": "to cause to act through an agent or to hold a subordinate position, also MEDIATISE [v MEDIATIZED, MEDIATIZING, MEDIATIZES]\n",
  "MEDIATIZED": "MEDIATIZE, to cause to act through an agent or to hold a subordinate position, also MEDIATISE [v]\n",
  "MEDIATIZES": "MEDIATIZE, to cause to act through an agent or to hold a subordinate position, also MEDIATISE [v]\n",
  "MEDIATIZING": "MEDIATIZE, to cause to act through an agent or to hold a subordinate position, also MEDIATISE [v]\n",
  "MEDIATOR": "one who mediates [n -S]\n",
  "MEDIATORIAL": "of or like a mediator [adj MEDIATORIALLY]\n",
  "MEDIATORIALLY": "MEDIATORIAL, of or like a mediator [adv]\n",
  "MEDIATORS": "MEDIATOR, one who mediates [n]\n",
  "MEDIATORSHIP": "the office of mediator [n -S]\n",
  "MEDIATORSHIPS": "MEDIATORSHIP, the office of mediator [n]\n",
  "MEDIATORY": "acting to mediate [adj]\n",
  "MEDIATRESS": "(archaic) a female mediator, also MEDIATRIX [n -ES]\n",
  "MEDIATRESSES": "MEDIATRESS, (archaic) a female mediator, also MEDIATRIX [n]\n",
  "MEDIATRICES": "MEDIATRIX, (archaic) a female mediator, also MEDIATRESS [n]\n",
  "MEDIATRIX": "(archaic) a female mediator, also MEDIATRESS [n MEDIATRICES or MEDIATRIXES]\n",
  "MEDIATRIXES": "MEDIATRIX, (archaic) a female mediator, also MEDIATRESS [n]\n",
  "MEDIC": "one engaged in medical work, also MEDICO [n -S]\n",
  "MEDICABLE": "capable of being medicated [adj MEDICABLY]\n",
  "MEDICABLY": "MEDICABLE, capable of being medicated [adv]\n",
  "MEDICAID": "a type of governmental health program, also MEDICARE [n -S]\n",
  "MEDICAIDS": "MEDICAID, a type of governmental health program, also MEDICARE [n]\n",
  "MEDICAL": "related to medicine [adj MEDICALLY] / a medical examination [n -S]\n",
  "MEDICALISATION": "the process of medicalising, also MEDICALIZATION [n -S]\n",
  "MEDICALISATIONS": "MEDICALISATION, the process of medicalising, also MEDICALIZATION [n]\n",
  "MEDICALISE": "to consider or treat in medical terms, also MEDICALIZE [v MEDICALISED, MEDICALISING, MEDICALISES]\n",
  "MEDICALISED": "MEDICALISE, to consider or treat in medical terms, also MEDICALIZE [v]\n",
  "MEDICALISES": "MEDICALISE, to consider or treat in medical terms, also MEDICALIZE [v]\n",
  "MEDICALISING": "MEDICALISE, to consider or treat in medical terms, also MEDICALIZE [v]\n",
  "MEDICALIZATION": "the process of medicalizing, also MEDICALISATION [n -S]\n",
  "MEDICALIZATIONS": "MEDICALIZATION, the process of medicalizing, also MEDICALISATION [n]\n",
  "MEDICALIZE": "to consider or treat in medical terms, also MEDICALISE [v MEDICALIZED, MEDICALIZING, MEDICALIZES]\n",
  "MEDICALIZED": "MEDICALIZE, to consider or treat in medical terms, also MEDICALISE [v]\n",
  "MEDICALIZES": "MEDICALIZE, to consider or treat in medical terms, also MEDICALISE [v]\n",
  "MEDICALIZING": "MEDICALIZE, to consider or treat in medical terms, also MEDICALISE [v]\n",
  "MEDICALLY": "MEDICAL, related to medicine [adv]\n",
  "MEDICALS": "MEDICAL, a medical examination [n]\n",
  "MEDICAMENT": "an externally applied curative treatment [n -S] / to treat with a medicament [v -ED, -ING, -S]\n",
  "MEDICAMENTAL": "relating to medicaments, also MEDICAMENTARY [adj MEDICAMENTALLY]\n",
  "MEDICAMENTALLY": "MEDICAMENTAL, relating to medicaments, also MEDICAMENTARY [adv]\n",
  "MEDICAMENTARY": "relating to medicaments, also MEDICAMENTAL [adj]\n",
  "MEDICAMENTED": "MEDICAMENT, to treat with a medicament [v]\n",
  "MEDICAMENTING": "MEDICAMENT, to treat with a medicament [v]\n",
  "MEDICAMENTOUS": "having the nature of a medicament [adj]\n",
  "MEDICAMENTS": "MEDICAMENT, an externally applied curative treatment [n]\n",
  "MEDICANT": "a healing substance [n -S]\n",
  "MEDICANTS": "MEDICANT, a healing substance [n]\n",
  "MEDICARE": "a type of governmental health program, also MEDICAID [n -S]\n",
  "MEDICARES": "MEDICARE, a type of governmental health program, also MEDICAID [n]\n",
  "MEDICASTER": "(archaic) a medical quack [n -S]\n",
  "MEDICASTERS": "MEDICASTER, (archaic) a medical quack [n]\n",
  "MEDICATE": "to treat with medicine [v MEDICATED, MEDICATING, MEDICATES]\n",
  "MEDICATED": "MEDICATE, to treat with medicine [v]\n",
  "MEDICATES": "MEDICATE, to treat with medicine [v]\n",
  "MEDICATING": "MEDICATE, to treat with medicine [v]\n",
  "MEDICATION": "the act of medicating [n -S]\n",
  "MEDICATIONS": "MEDICATION, the act of medicating [n]\n",
  "MEDICATIVE": "medicinal; acting like a medicine [adj]\n",
  "MEDICIDE": "a medically assisted suicide [n -S]\n",
  "MEDICIDES": "MEDICIDE, a medically assisted suicide [n]\n",
  "MEDICINABLE": "that can be treated with medicine [adj]\n",
  "MEDICINAL": "relating to medicine, also MEDCINAL [adj MEDICINALLY] / a medicinal substance [n -S]\n",
  "MEDICINALLY": "MEDICINAL, relating to medicine, also MEDCINAL [adv]\n",
  "MEDICINALS": "MEDICINAL, a medicinal substance [n]\n",
  "MEDICINE": "to treat with a substance to heal, prevent or cure [v MEDICINED, MEDICINING, MEDICINES]\n",
  "MEDICINED": "MEDICINE, to treat with a substance to heal, prevent or cure [v]\n",
  "MEDICINER": "(archaic) a physician [n -S]\n",
  "MEDICINERS": "MEDICINER, (archaic) a physician [n]\n",
  "MEDICINES": "MEDICINE, to treat with a substance to heal, prevent or cure [v]\n",
  "MEDICINING": "MEDICINE, to treat with a substance to heal, prevent or cure [v]\n",
  "MEDICK": "a clover-like plant [n -S]\n",
  "MEDICKS": "MEDICK, a clover-like plant [n]\n",
  "MEDICO": "(colloquial) a doctor, a medical student, also MEDIC [n -S]\n",
  "MEDICOLEGAL": "of or relating to both medicine and law [adj]\n",
  "MEDICOS": "MEDICO, (colloquial) a doctor, a medical student, also MEDIC [n]\n",
  "MEDICS": "MEDIC, one engaged in medical work, also MEDICO [n]\n",
  "MEDIEVAL": "belonging to the Middle Ages, also MEDIAEVAL [adj MEDIEVALLY] / a person who lived in the Middle Ages [n -S]\n",
  "MEDIEVALISM": "the spirit of the Middle Ages; devotion to medieval ideal, also MEDIAEVALISM [n -S]\n",
  "MEDIEVALISMS": "MEDIEVALISM, the spirit of the Middle Ages; devotion to medieval ideal, also MEDIAEVALISM [n]\n",
  "MEDIEVALIST": "a specialist in medieval history and culture, also MEDIAEVALIST [n -S]\n",
  "MEDIEVALISTIC": "related to mediaevalism, also MEDIAEVALISTIC [adj]\n",
  "MEDIEVALISTS": "MEDIEVALIST, a specialist in medieval history and culture, also MEDIAEVALIST [n]\n",
  "MEDIEVALLY": "MEDIEVAL, belonging to the Middle Ages, also MEDIAEVAL [adv]\n",
  "MEDIEVALS": "MEDIEVAL, a person who lived in the Middle Ages [n]\n",
  "MEDIGAP": "a supplemental health insurance [n -S]\n",
  "MEDIGAPS": "MEDIGAP, a supplemental health insurance [n]\n",
  "MEDII": "MEDIUS, (Latin) the middle finger [n]\n",
  "MEDINA": "(Arabic) the native quarter of a North African city [n -S]\n",
  "MEDINAS": "MEDINA, (Arabic) the native quarter of a North African city [n]\n",
  "MEDIOCRACIES": "MEDIOCRACY, government by the mediocre; a system within which mediocrity is rewarded [n]\n",
  "MEDIOCRACY": "government by the mediocre; a system within which mediocrity is rewarded [n MEDIOCRACIES]\n",
  "MEDIOCRE": "neither good nor bad [adj]\n",
  "MEDIOCRITIES": "MEDIOCRITY, the state of being mediocre [n]\n",
  "MEDIOCRITY": "the state of being mediocre [n MEDIOCRITIES]\n",
  "MEDITATE": "to consider thoughtfully [v MEDITATED, MEDITATING, MEDITATES]\n",
  "MEDITATED": "MEDITATE, to consider thoughtfully [v]\n",
  "MEDITATES": "MEDITATE, to consider thoughtfully [v]\n",
  "MEDITATING": "MEDITATE, to consider thoughtfully [v]\n",
  "MEDITATION": "a discourse intended to express its author's reflections or to guide others in contemplation [n -S]\n",
  "MEDITATIONS": "MEDITATION, a discourse intended to express its author's reflections or to guide others in contemplation [n]\n",
  "MEDITATIVE": "marked by or conducive to meditation [adj MEDITATIVELY]\n",
  "MEDITATIVELY": "MEDITATIVE, marked by or conducive to meditation [adv]\n",
  "MEDITATIVENESS": "MEDITATIVE, marked by or conducive to meditation [n]\n",
  "MEDITATOR": "one who meditates [n -S]\n",
  "MEDITATORS": "MEDITATOR, one who meditates [n]\n",
  "MEDITERRANEAN": "of, relating to, or characteristic of the Mediterranean Sea [adj]\n",
  "MEDIUM": "a spiritualist [n -S] / a middle course [n MEDIA]\n",
  "MEDIUMISTIC": "of, relating to, or having the qualities of a spiritualistic medium [adj]\n",
  "MEDIUMS": "MEDIUM, a spiritualist [n]\n",
  "MEDIUMSHIP": "being a medium [n -S]\n",
  "MEDIUMSHIPS": "MEDIUMSHIP, being a medium [n]\n",
  "MEDIUS": "(Latin) the middle finger [n MEDIUSES or MEDII]\n",
  "MEDIUSES": "MEDIUS, (Latin) the middle finger [n]\n",
  "MEDIVAC": "to evacuate the wounded from a battlefield by helicopter, also MEDEVAC [v MEDIVACED or MEDIVACKED, MEDIVACING or MEDIVACKING, MEDIVACS]\n",
  "MEDIVACED": "MEDIVAC, to evacuate the wounded from a battlefield by helicopter, also MEDEVAC [v]\n",
  "MEDIVACING": "MEDIVAC, to evacuate the wounded from a battlefield by helicopter, also MEDEVAC [v]\n",
  "MEDIVACKED": "MEDIVAC, to evacuate the wounded from a battlefield by helicopter, also MEDEVAC [v]\n",
  "MEDIVACKING": "MEDIVAC, to evacuate the wounded from a battlefield by helicopter, also MEDEVAC [v]\n",
  "MEDIVACS": "MEDIVAC, to evacuate the wounded from a battlefield by helicopter, also MEDEVAC [v]\n",
  "MEDLAR": "a small tree related to the apple; its fruit [n -S]\n",
  "MEDLARS": "MEDLAR, a small tree related to the apple; its fruit [n]\n",
  "MEDLE": "(Shakespeare) to meddle [v MEDLED, MEDLING, MEDLES]\n",
  "MEDLED": "MEDLE, (Shakespeare) to meddle [v]\n",
  "MEDLES": "MEDLE, (Shakespeare) to meddle [v]\n",
  "MEDLEY": "a mixture [n -S]\n",
  "MEDLEYS": "MEDLEY, a mixture [n]\n",
  "MEDLING": "MEDLE, (Shakespeare) to meddle [v]\n",
  "MEDRESA": "(Arabic) an Islamic college, or school attached to a mosque, also MADRASA, MADRASAH, MADRASSA, MADRASSAH, MEDRESE, MEDRESSEH [n -S]\n",
  "MEDRESAS": "MEDRESA, (Arabic) an Islamic college, or school attached to a mosque, also MADRASA, MADRASAH, MADRASSA, MADRASSAH, MEDRESE, MEDRESSEH [n]\n",
  "MEDRESE": "(Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSA, MADRASSAH, MEDRESA, MEDRESSEH [n -S]\n",
  "MEDRESES": "MEDRESE, (Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSA, MADRASSAH, MEDRESA, MEDRESSEH [n]\n",
  "MEDRESSEH": "(Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSA, MADRASSAH, MEDRESA, MEDRESE [n -S]\n",
  "MEDRESSEHS": "MEDRESSEH, (Arabic) an Islamic college, or school attached to mosque, also MADRASA, MADRASAH, MADRASSA, MADRASSAH, MEDRESA, MEDRESE [n]\n",
  "MEDS": "MED, (short for) medical, medicine [n]\n",
  "MEDULLA": "(Latin) the central tissue in the stems of certain plants [n MEDULLAS or MEDULLAE]\n",
  "MEDULLAE": "MEDULLA, (Latin) the central tissue in the stems of certain plants [n]\n",
  "MEDULLAR": "consisting of or resembling marrow or pith, also MEDULLARY [adj]\n",
  "MEDULLARY": "consisting of or resembling marrow or pith, also MEDULLAR [adj]\n",
  "MEDULLAS": "MEDULLA, (Latin) the central tissue in the stems of certain plants [n]\n",
  "MEDULLATE": "having medulla, also MEDULLATED [adj]\n",
  "MEDULLATED": "having medulla, also MEDULLATE [adj]\n",
  "MEDULLOBLASTOMA": "a malignant tumor of the central nervous system arising in the cerebellum esp. in children [n]\n",
  "MEDUSA": "(Latin) a jellyfish, also MEDUSAN, MEDUSOID [n MEDUSAS or MEDUSAE]\n",
  "MEDUSAE": "MEDUSA, (Latin) a jellyfish, also MEDUSAN, MEDUSOID [n]\n",
  "MEDUSAL": "relating to a medusa, a kind of jellyfish [adj]\n",
  "MEDUSAN": "a jellyfish, also MEDUSA, MEDUSOID [n -S]\n",
  "MEDUSANS": "MEDUSAN, a jellyfish, also MEDUSA, MEDUSOID [n]\n",
  "MEDUSAS": "MEDUSA, (Latin) a jellyfish, also MEDUSAN, MEDUSOID [n]\n",
  "MEDUSIFORM": "resembling a jellyfish [adj]\n",
  "MEDUSOID": "a jellyfish, also MEDUSA, MEDUSAN [n -S]\n",
  "MEDUSOIDS": "MEDUSOID, a jellyfish, also MEDUSA, MEDUSAN [n]\n",
  "MEE": "(Chinese) a Malaysian noodle food [n -S]\n",
  "MEED": "a deserved reward [n -S]\n",
  "MEEDS": "MEED, a deserved reward [n]\n",
  "MEEK": "having a mild and gentle temper [adj MEEKER, MEEKEST, MEEKLY]\n",
  "MEEKEN": "to make meek [v -ED, -ING, -S]\n",
  "MEEKENED": "MEEKEN, to make meek [v]\n",
  "MEEKENING": "MEEKEN, to make meek [v]\n",
  "MEEKENS": "MEEKEN, to make meek [v]\n",
  "MEEKER": "MEEK, having a mild and gentle temper [adj]\n",
  "MEEKEST": "MEEK, having a mild and gentle temper [adj]\n",
  "MEEKLY": "MEEK, having a mild and gentle temper [adv]\n",
  "MEEKNESS": "the quality of being meek [n -ES]\n",
  "MEEKNESSES": "MEEKNESS, the quality of being meek [n]\n",
  "MEEMIE": "a hysterical person [n -S]\n",
  "MEEMIES": "MEEMIE, a hysterical person [n]\n",
  "MEER": "to mark off, also MEARE, MERE [v -ED, -ING, -S]\n",
  "MEERCAT": "(Dutch) a South African carnivore related to the ichneumon, aka suricate, also MEERKAT [n -S]\n",
  "MEERCATS": "MEERCAT, (Dutch) a South African carnivore related to the ichneumon, aka suricate, also MEERKAT [n]\n",
  "MEERED": "MEER, to mark off, also MEARE, MERE [v]\n",
  "MEERING": "MEER, to mark off, also MEARE, MERE [v]\n",
  "MEERKAT": "(Dutch) a South African carnivore, aka suricate, related to the ichneumon, also MEERCAT [n -S]\n",
  "MEERKATS": "MEERKAT, (Dutch) a South African carnivore, aka suricate, related to the ichneumon, also MEERCAT [n]\n",
  "MEERS": "MEER, to mark off, also MEARE, MERE [v]\n",
  "MEERSCHAUM": "(German) hydrated magnesium silicate occurring as a soft white or yellowish claylike mineral, aka sepiolite [n -S]\n",
  "MEERSCHAUMS": "MEERSCHAUM, (German) hydrated magnesium silicate occurring as a soft white or yellowish claylike mineral, aka sepiolite [n]\n",
  "MEES": "MEE, (Chinese) a Malaysian noodle food [n]\n",
  "MEET": "suitable [adj MEETER, MEETEST, MEETLY] / to encounter [v MET, MEETING, MEETS]\n",
  "MEETER": "one that meets [n -S]\n",
  "MEETERS": "MEETER, one that meets [n]\n",
  "MEETEST": "MEET, suitable [adj]\n",
  "MEETING": "an assembly for a common purpose [n -S]\n",
  "MEETINGHOUSE": "the place in which certain religious groups, esp. Quakers, hold their meetings for worship [n -S]\n",
  "MEETINGHOUSES": "MEETINGHOUSE, the place in which certain religious groups, esp. Quakers, hold their meetings for worship [n]\n",
  "MEETINGS": "MEETING, an assembly for a common purpose [n]\n",
  "MEETLY": "MEET, suitable [adv]\n",
  "MEETNESS": "suitability [n -ES]\n",
  "MEETNESSES": "MEETNESS, suitability [n]\n",
  "MEETS": "MEET, to encounter [v]\n",
  "MEFF": "(slang) a scruffy tramp, a metho drinker [n -S]\n",
  "MEFFS": "MEFF, (slang) a scruffy tramp, a metho drinker [n]\n",
  "MEFLOQUINE": "an antimalarial drug [n -S]\n",
  "MEFLOQUINES": "MEFLOQUINE, an antimalarial drug [n]\n",
  "MEG": "(archaic) a halfpenny, also MAIK, MECK [n -S]\n",
  "MEGA": "very big [adj]\n",
  "MEGABAR": "a unit of pressure [n -S]\n",
  "MEGABARS": "MEGABAR, a unit of pressure [n]\n",
  "MEGABIT": "a unit of computer information [n -S]\n",
  "MEGABITS": "MEGABIT, a unit of computer information [n]\n",
  "MEGABUCK": "one million dollars [n -S]\n",
  "MEGABUCKS": "MEGABUCK, one million dollars [n]\n",
  "MEGABYTE": "1,048,576 bytes [n -S]\n",
  "MEGABYTES": "MEGABYTE, 1,048,576 bytes [n]\n",
  "MEGACEPHALIC": "having an unusually large skull, also MEGALOCEPHALIC, MEGALOCEPHALOUS [adj]\n",
  "MEGACEPHALIES": "MEGACEPHALY, the condition of having an unusually large head or cranial capacity, also MEGALOCEPHALY [n]\n",
  "MEGACEPHALOUS": "having a large head [adj]\n",
  "MEGACEPHALY": "the condition of having an unusually large head or cranial capacity, also MEGALOCEPHALY [n MEGACEPHALIES]\n",
  "MEGACHURCH": "a church, usually Protestant, with a very large congregation, typically housed in a complex offering sophisticated multimedia presentations and a range of secular facilities and services [n -ES]\n",
  "MEGACHURCHES": "MEGACHURCH, a church, usually Protestant, with a very large congregation, typically housed in a complex offering sophisticated multimedia presentations and a range of secular facilities and services [n]\n",
  "MEGACITIES": "MEGACITY, a very large city [n]\n",
  "MEGACITY": "a very large city [n MEGACITIES]\n",
  "MEGACORPORATION": "a huge and powerful corporation [n]\n",
  "MEGACURIE": "a unit of radiation, a million curies [n -S]\n",
  "MEGACURIES": "MEGACURIE, a unit of radiation, a million curies [n]\n",
  "MEGACYCLE": "a million cycles; a million cycles per second [n -S]\n",
  "MEGACYCLES": "MEGACYCLE, a million cycles; a million cycles per second [n]\n",
  "MEGADEAL": "a business deal involving a lot of money [n -S]\n",
  "MEGADEALS": "MEGADEAL, a business deal involving a lot of money [n]\n",
  "MEGADEATH": "a million deaths [n -S]\n",
  "MEGADEATHS": "MEGADEATH, a million deaths [n]\n",
  "MEGADOSE": "an abnormally large dose [n -S]\n",
  "MEGADOSES": "MEGADOSE, an abnormally large dose [n]\n",
  "MEGADYNE": "a unit of force [n -S]\n",
  "MEGADYNES": "MEGADYNE, a unit of force [n]\n",
  "MEGAFARAD": "a measure of electrical capacity, one million farads [n -S]\n",
  "MEGAFARADS": "MEGAFARAD, a measure of electrical capacity, one million farads [n]\n",
  "MEGAFAUNA": "the large or macroscopic animals, esp. the large vertebrates, of a given area, habitat, or epoch [n MEGAFAUNAE or MEGAFAUNAS]\n",
  "MEGAFAUNAE": "MEGAFAUNA, the large or macroscopic animals, esp. the large vertebrates, of a given area, habitat, or epoch [n]\n",
  "MEGAFAUNAL": "relating to megafauna, large animals [adj]\n",
  "MEGAFAUNAS": "MEGAFAUNA, the large or macroscopic animals, esp. the large vertebrates, of a given area, habitat, or epoch [n]\n",
  "MEGAFLOP": "a measure of computing speed in terms of number of floating point operations per second [n -S]\n",
  "MEGAFLOPS": "MEGAFLOP, a measure of computing speed in terms of number of floating point operations per second [n]\n",
  "MEGAFLORA": "large plants [n MEGAFLORAE or MEGAFLORAS]\n",
  "MEGAFLORAE": "MEGAFLORA, large plants [n]\n",
  "MEGAFLORAS": "MEGAFLORA, large plants [n]\n",
  "MEGAFOG": "a fog signal with megaphones pointing in several directions [n -S]\n",
  "MEGAFOGS": "MEGAFOG, a fog signal with megaphones pointing in several directions [n]\n",
  "MEGAGAMETE": "the larger and usually female gamete of a heterogamous organism, also MACROGAMETE [n -S]\n",
  "MEGAGAMETES": "MEGAGAMETE, the larger and usually female gamete of a heterogamous organism, also MACROGAMETE [n]\n",
  "MEGAGAMETOPHYTE": "the gametophyte developing vegetatively from the megaspore of a heterosporous plant [n]\n",
  "MEGAGAUSS": "a unit of magnetic force, a million gauss [n -ES]\n",
  "MEGAGAUSSES": "MEGAGAUSS, a unit of magnetic force, a million gauss [n]\n",
  "MEGAHERBIVORE": "a large plant-eater [n -S]\n",
  "MEGAHERBIVORES": "MEGAHERBIVORE, a large plant-eater [n]\n",
  "MEGAHERTZ": "a measure of frequency, a million hertz [n -ES]\n",
  "MEGAHERTZES": "MEGAHERTZ, a measure of frequency, a million hertz [n]\n",
  "MEGAHIT": "something extremely successful [n -S]\n",
  "MEGAHITS": "MEGAHIT, something extremely successful [n]\n",
  "MEGAJOULE": "a million joules [n -S]\n",
  "MEGAJOULES": "MEGAJOULE, a million joules [n]\n",
  "MEGAKARYOCYTE": "a large cell with a lobulated nucleus, found esp. in the bone marrow, the source of blood platelets [n -S]\n",
  "MEGAKARYOCYTES": "MEGAKARYOCYTE, a large cell with a lobulated nucleus, found esp. in the bone marrow, the source of blood platelets [n]\n",
  "MEGAKARYOCYTIC": "of or like a megakaryocyte [adj]\n",
  "MEGALITH": "a huge stone used in prehistoric monuments [n -S]\n",
  "MEGALITHIC": "relating to a megalith [adj]\n",
  "MEGALITHS": "MEGALITH, a huge stone used in prehistoric monuments [n]\n",
  "MEGALITRE": "one million litres [n -S]\n",
  "MEGALITRES": "MEGALITRE, one million litres [n]\n",
  "MEGALOBLAST": "a large erythroblast that appears in the blood esp. in pernicious anemia [n -S]\n",
  "MEGALOBLASTIC": "relating to megaloblast [adj]\n",
  "MEGALOBLASTS": "MEGALOBLAST, a large erythroblast that appears in the blood esp. in pernicious anemia [n]\n",
  "MEGALOCARDIA": "the condition of having an enlarged heart [n -S]\n",
  "MEGALOCARDIAS": "MEGALOCARDIA, the condition of having an enlarged heart [n]\n",
  "MEGALOCEPHALIC": "having an unusually large skull, also MEGACEPHALIC, MEGALOCEPHALOUS [adj]\n",
  "MEGALOCEPHALIES": "MEGALOCEPHALY, the condition of having an unusually large head or cranial capacity, also MEGACEPHALY [n]\n",
  "MEGALOCEPHALOUS": "having an unusually large skull, also MEGACEPHALIC, MEGALOCEPHALIC [adj]\n",
  "MEGALOCEPHALY": "the condition of having an unusually large head or cranial capacity, also MEGACEPHALY [n MEGALOCEPHALIES]\n",
  "MEGALODON": "an extinct giant shark of the Cenozoic era [n -S]\n",
  "MEGALODONS": "MEGALODON, an extinct giant shark of the Cenozoic era [n]\n",
  "MEGALOMANIA": "a mania for great or grandiose performance [n -S]\n",
  "MEGALOMANIAC": "one suffering from megalomania [n -S]\n",
  "MEGALOMANIACAL": "relating to megalomania, also MEGALOMANIC [adj]\n",
  "MEGALOMANIACS": "MEGALOMANIAC, one suffering from megalomania [n]\n",
  "MEGALOMANIAS": "MEGALOMANIA, a mania for great or grandiose performance [n]\n",
  "MEGALOMANIC": "relating to megalomania, also MEGALOMANIACAL [adj]\n",
  "MEGALOPIC": "having large eyes [adj]\n",
  "MEGALOPOLIS": "a wide-spreading, thickly-populated urban area [n -ES]\n",
  "MEGALOPOLISES": "MEGALOPOLIS, a wide-spreading, thickly-populated urban area [n]\n",
  "MEGALOPOLITAN": "an inhabitant of a megalopolis [n -S]\n",
  "MEGALOPOLITANS": "MEGALOPOLITAN, an inhabitant of a megalopolis [n]\n",
  "MEGALOPS": "a larval stage of most crabs [n -ES]\n",
  "MEGALOPSES": "MEGALOPS, a larval stage of most crabs [n]\n",
  "MEGALOSAUR": "a large dinosaur, also MEGALOSAURIAN, MEGALOSAURUS [n -S]\n",
  "MEGALOSAURI": "MEGALOSAURUS, a large dinosaur, also MEGALOSAUR, MEGALOSAURIAN [n]\n",
  "MEGALOSAURIAN": "a large dinosaur, also MEGALOSAUR, MEGALOSAURUS [n -S]\n",
  "MEGALOSAURIANS": "MEGALOSAURIAN, a large dinosaur, also MEGALOSAUR, MEGALOSAURUS [n]\n",
  "MEGALOSAURS": "MEGALOSAUR, a large dinosaur, also MEGALOSAURIAN, MEGALOSAURUS [n]\n",
  "MEGALOSAURUS": "a large dinosaur, also MEGALOSAUR, MEGALOSAURIAN [n MEGALOSAURI]\n",
  "MEGAMALL": "a very large shopping mall [n -S]\n",
  "MEGAMALLS": "MEGAMALL, a very large shopping mall [n]\n",
  "MEGANEWTON": "a measure of gravity, a million newtons [n -S]\n",
  "MEGANEWTONS": "MEGANEWTON, a measure of gravity, a million newtons [n]\n",
  "MEGAPARSEC": "a measure of astronomical distance, a million parsecs [n -S]\n",
  "MEGAPARSECS": "MEGAPARSEC, a measure of astronomical distance, a million parsecs [n]\n",
  "MEGAPHONE": "a device to magnify sound, or direct it in a given direction in a greater volume [n -S] / to magnify sound [v MEGAPHONED, MEGAPHONING, MEGAPHONES]\n",
  "MEGAPHONED": "MEGAPHONE, to magnify sound [v]\n",
  "MEGAPHONES": "MEGAPHONE, to magnify sound [v]\n",
  "MEGAPHONIC": "relating to a megaphone [adj MEGAPHONICALLY]\n",
  "MEGAPHONICALLY": "MEGAPHONIC, relating to a megaphone [adv]\n",
  "MEGAPHONING": "MEGAPHONE, to magnify sound [v]\n",
  "MEGAPHYLL": "a relatively large type of leaf produced by e.g. ferns [n -S]\n",
  "MEGAPHYLLS": "MEGAPHYLL, a relatively large type of leaf produced by e.g. ferns [n]\n",
  "MEGAPIXEL": "one million pixels [n -S]\n",
  "MEGAPIXELS": "MEGAPIXEL, one million pixels [n]\n",
  "MEGAPLEX": "a large building having many movie theaters [n -ES]\n",
  "MEGAPLEXES": "MEGAPLEX, a large building having many movie theaters [n]\n",
  "MEGAPOD": "one of a family of birds of Australasia, including jungle fowl, brush turkey, etc., also MEGAPODE [n -S]\n",
  "MEGAPODE": "one of a family of birds of Australasia, including jungle fowl, brush turkey, etc., also MEGAPOD [n -S]\n",
  "MEGAPODES": "MEGAPODE, one of a family of birds of Australasia, including jungle fowl, brush turkey, etc., also MEGAPOD [n]\n",
  "MEGAPODS": "MEGAPOD, one of a family of birds of Australasia, including jungle fowl, brush turkey, etc., also MEGAPODE [n]\n",
  "MEGAPROJECT": "a major project or undertaking [n -S]\n",
  "MEGAPROJECTS": "MEGAPROJECT, a major project or undertaking [n]\n",
  "MEGAQUAKE": "a very large earthquake [n -S]\n",
  "MEGAQUAKES": "MEGAQUAKE, a very large earthquake [n]\n",
  "MEGARA": "MEGARON, (Greek) the principal hall in an ancient Greek house [n]\n",
  "MEGARAD": "a measure of radiation, a million rads [n -S]\n",
  "MEGARADS": "MEGARAD, a measure of radiation, a million rads [n]\n",
  "MEGARON": "(Greek) the principal hall in an ancient Greek house [n MEGARONS or MEGARA]\n",
  "MEGARONS": "MEGARON, (Greek) the principal hall in an ancient Greek house [n]\n",
  "MEGASCOPE": "an instrument for projecting an enlarged image [n -S]\n",
  "MEGASCOPES": "MEGASCOPE, an instrument for projecting an enlarged image [n]\n",
  "MEGASCOPIC": "visible to the naked eye [adj MEGASCOPICALLY]\n",
  "MEGASCOPICALLY": "MEGASCOPIC, visible to the naked eye [adv]\n",
  "MEGASPORANGIA": "MEGASPORANGIUM, the sporangium in heterosporous plants where the megaspores develop [n]\n",
  "MEGASPORANGIUM": "the sporangium in heterosporous plants where the megaspores develop [n MEGASPORANGIA]\n",
  "MEGASPORE": "the larger of the two types of spore produced by some ferns, which develops into the female gametophyte [n -S]\n",
  "MEGASPORES": "MEGASPORE, the larger of the two types of spore produced by some ferns, which develops into the female gametophyte [n]\n",
  "MEGASPORIC": "of or like a megaspore [adj]\n",
  "MEGASPOROPHYLL": "a specialised leaf bearing or subtending one or more megasporangia [n -S]\n",
  "MEGASPOROPHYLLS": "MEGASPOROPHYLL, a specialised leaf bearing or subtending one or more megasporangia [n]\n",
  "MEGASS": "crushed sugarcane, also MEGASSE [n -ES]\n",
  "MEGASSE": "(French) crushed sugarcane, also MEGASS [n -S]\n",
  "MEGASSES": "MEGASS, crushed sugarcane, also MEGASSE [n]\n",
  "MEGASTAR": "an extremely successful performer [n -S]\n",
  "MEGASTARS": "MEGASTAR, an extremely successful performer [n]\n",
  "MEGASTORE": "a large supermarket [n -S]\n",
  "MEGASTORES": "MEGASTORE, a large supermarket [n]\n",
  "MEGASTORM": "a very large storm [n -S]\n",
  "MEGASTORMS": "MEGASTORM, a very large storm [n]\n",
  "MEGASTRUCTURE": "a very large structure [n -S]\n",
  "MEGASTRUCTURES": "MEGASTRUCTURE, a very large structure [n]\n",
  "MEGATECHNOLOGY": "large-scale technology [n]\n",
  "MEGATHERE": "any of various gigantic extinct American sloths [n -S]\n",
  "MEGATHERES": "MEGATHERE, any of various gigantic extinct American sloths [n]\n",
  "MEGATHERIAN": "like a megathere, any of various gigantic extinct American sloths [adj]\n",
  "MEGATHRUST": "as in megathrust earthquake, an earthquake of exceptional destructive power [adj]\n",
  "MEGATON": "a unit of explosive force [n -S]\n",
  "MEGATONIC": "relating to a megaton, a million tons [adj]\n",
  "MEGATONNAGE": "the total explosive capacity in megatons [n -S]\n",
  "MEGATONNAGES": "MEGATONNAGE, the total explosive capacity in megatons [n]\n",
  "MEGATONS": "MEGATON, a unit of explosive force [n]\n",
  "MEGAVERTEBRATE": "a very large vertebrate [n -S]\n",
  "MEGAVERTEBRATES": "MEGAVERTEBRATE, a very large vertebrate [n]\n",
  "MEGAVITAMIN": "relating to or consisting of very large doses of vitamins [n -S]\n",
  "MEGAVITAMINS": "MEGAVITAMIN, relating to or consisting of very large doses of vitamins [n]\n",
  "MEGAVOLT": "a unit of electromotive force [n -S]\n",
  "MEGAVOLTS": "MEGAVOLT, a unit of electromotive force [n]\n",
  "MEGAWATT": "a unit of power, a million watts [n -S]\n",
  "MEGAWATTS": "MEGAWATT, a unit of power, a million watts [n]\n",
  "MEGILLA": "(Hebrew) a scroll containing a book of the Old Testament, also MEGILLAH [n -S]\n",
  "MEGILLAH": "(Hebrew) a scroll containing a book of the Old Testament; (figurative) a long tedious account, also MEGILLA [n MEGILLAHS or MEGILLOTH]\n",
  "MEGILLAHS": "MEGILLAH, (Hebrew) a scroll containing a book of the Old Testament; (figurative) a long tedious account, also MEGILLA [n]\n",
  "MEGILLAS": "MEGILLA, (Hebrew) a scroll containing a book of the Old Testament, also MEGILLAH [n]\n",
  "MEGILLOTH": "MEGILLAH, (Hebrew) a scroll containing a book of the Old Testament; (figurative) a long tedious account, also MEGILLA [n]\n",
  "MEGILP": "a substance with which pigments are mixed in painting, also MAGILP, MEGILPH [n -S]\n",
  "MEGILPH": "a substance with which pigments are mixed in painting, also MEGILP, MAGILP [n -S]\n",
  "MEGILPHS": "MEGILPH, a substance with which pigments are mixed in painting, also MEGILP, MAGILP [n]\n",
  "MEGILPS": "MEGILP, a substance with which pigments are mixed in painting, also MAGILP, MEGILPH [n]\n",
  "MEGOHM": "a measure of electrical resistance, one million ohms [n -S]\n",
  "MEGOHMS": "MEGOHM, a measure of electrical resistance, one million ohms [n]\n",
  "MEGRIM": "a severe headache, also MIGRAINE [n -S]\n",
  "MEGRIMS": "MEGRIM, a severe headache, also MIGRAINE [n]\n",
  "MEGS": "MEG, (archaic) a halfpenny, also MAIK, MECK [n]\n",
  "MEH": "mediocre or boring; an expression of indifference or boredom [interj]\n",
  "MEHNDI": "(Hindi) in India, the practice of painting designs on the hands, feet etc. using henna [n -S]\n",
  "MEHNDIS": "MEHNDI, (Hindi) in India, the practice of painting designs on the hands, feet etc. using henna [n]\n",
  "MEIBOMIAN": "as in meibomian gland, any of the small sebaceous glands in the eyelid [adj]\n",
  "MEIKLE": "(Scots) great, much, also MICKLE, MOCHELL, MUCHEL, MUCHELL [adj]\n",
  "MEIN": "(Scots) to lament, moan, also MEANE, MENE [v -ED, -ING, -S]\n",
  "MEINED": "MEIN, (Scots) to lament, moan, also MEANE, MENE [v]\n",
  "MEINEY": "a family, including servants, etc., a retinue, also MEINIE, MEINY, MENYIE [n -S]\n",
  "MEINEYS": "MEINEY, a family, including servants, etc., a retinue, also MEINIE, MEINY, MENYIE [n]\n",
  "MEINIE": "a family, including servants, etc., a retinue, also MEINEY, MEINY, MENYIE [n -S]\n",
  "MEINIES": "MEINIE, a family, including servants, etc., a retinue, also MEINEY, MEINY, MENYIE [n]\n",
  "MEINING": "MEIN, (Scots) to lament, moan, also MEANE, MENE [v]\n",
  "MEINS": "MEIN, (Scots) to lament, moan, also MEANE, MENE [v]\n",
  "MEINT": "MENG, (archaic) to mix; to unite, couple, also MENGE, MING [v]\n",
  "MEINY": "a family, including servants, etc., a retinue, also MEINEY, MEINIE, MENYIE [n MEINIES]\n",
  "MEIOCYTE": "a cell which divides by meiosis [n -S]\n",
  "MEIOCYTES": "MEIOCYTE, a cell which divides by meiosis [n]\n",
  "MEIOFAUNA": "animals less than 1 mm and larger than 0.1 mm across [n MEIOFAUNAS or MEIOFAUNAE]\n",
  "MEIOFAUNAE": "MEIOFAUNA, animals less than 1 mm and larger than 0.1 mm across [n]\n",
  "MEIOFAUNAL": "relating to the meiofauna [adj]\n",
  "MEIOFAUNAS": "MEIOFAUNA, animals less than 1 mm and larger than 0.1 mm across [n]\n",
  "MEIONITE": "one of a group of rare minerals, a scapolite with less sodium and silica than marialite [n -S]\n",
  "MEIONITES": "MEIONITE, one of a group of rare minerals, a scapolite with less sodium and silica than marialite [n]\n",
  "MEIOSES": "MEIOSIS, (Greek) understatement for rhetorical effect [n]\n",
  "MEIOSIS": "(Greek) understatement for rhetorical effect [n MEIOSES]\n",
  "MEIOSPORE": "a haploid spore [n -S]\n",
  "MEIOSPORES": "MEIOSPORE, a haploid spore [n]\n",
  "MEIOTIC": "exhibiting meiosis, deliberate understatement [adj MEIOTICALLY]\n",
  "MEIOTICALLY": "MEIOTIC, exhibiting meiosis, deliberate understatement [adv]\n",
  "MEISHI": "(Japanese) a Japanese business card [n -S]\n",
  "MEISHIS": "MEISHI, (Japanese) a Japanese business card [n]\n",
  "MEISTER": "(German) an expert in a particular activity [n -S]\n",
  "MEISTERS": "MEISTER, (German) an expert in a particular activity [n]\n",
  "MEITH": "(Scots) a landmark, a boundary [n -S]\n",
  "MEITHS": "MEITH, (Scots) a landmark, a boundary [n]\n",
  "MEITNERIUM": "an artificially produced radioactive transuranic element [n -S]\n",
  "MEITNERIUMS": "MEITNERIUM, an artificially produced radioactive transuranic element [n]\n",
  "MEJLIS": "(Arabic) an assembly or council in various North African and Middle Eastern countries, also MAJLIS [n -ES]\n",
  "MEJLISES": "MEJLIS, (Arabic) an assembly or council in various North African and Middle Eastern countries, also MAJLIS [n]\n",
  "MEKKA": "(Arabic) a place visited by many people, also MECCA [n -S]\n",
  "MEKKAS": "MEKKA, (Arabic) a place visited by many people, also MECCA [n]\n",
  "MEKOMETER": "a kind of rangefinder [n -S]\n",
  "MEKOMETERS": "MEKOMETER, a kind of rangefinder [n]\n",
  "MEL": "honey [n -S]\n",
  "MELA": "(Hindi) in the Indian subcontinent, a Hindu festival or fair [n -S]\n",
  "MELACONITE": "an earthy black oxide of copper, arising from the decomposition of other ores [n -S]\n",
  "MELACONITES": "MELACONITE, an earthy black oxide of copper, arising from the decomposition of other ores [n]\n",
  "MELAENA": "a condition marked by black tarry stool, also MELENA [n -S]\n",
  "MELAENAS": "MELAENA, a condition marked by black tarry stool, also MELENA [n]\n",
  "MELALEUCA": "an Australian tree with a white trunk and black branches [n -S]\n",
  "MELALEUCAS": "MELALEUCA, an Australian tree with a white trunk and black branches [n]\n",
  "MELAMDIM": "MELAMED, (Hebrew) a teacher in a Jewish school [n]\n",
  "MELAMED": "(Hebrew) a teacher in a Jewish school [n MELAMDIM]\n",
  "MELAMINE": "a colourless crystalline compound used in making synthetic resins [n -S]\n",
  "MELAMINES": "MELAMINE, a colourless crystalline compound used in making synthetic resins [n]\n",
  "MELAMPODE": "(Spenser) the black hellebore [n -S]\n",
  "MELAMPODES": "MELAMPODE, (Spenser) the black hellebore [n]\n",
  "MELANAEMIA": "the presence of melanin in the blood [n -S]\n",
  "MELANAEMIAS": "MELANAEMIA, the presence of melanin in the blood [n]\n",
  "MELANCHOLIA": "a state of melancholy [n MELANCHOLIAS or MELANCHOLIAE]\n",
  "MELANCHOLIAC": "one suffering from melancholia [n -S]\n",
  "MELANCHOLIACS": "MELANCHOLIAC, one suffering from melancholia [n]\n",
  "MELANCHOLIAE": "MELANCHOLIA, a state of melancholy [n]\n",
  "MELANCHOLIAS": "MELANCHOLIA, a state of melancholy [n]\n",
  "MELANCHOLIC": "subject to melancholy [adj MELANCHOLICALLY] / one given to melancholy [n -S]\n",
  "MELANCHOLICALLY": "MELANCHOLIC, subject to melancholy [adv]\n",
  "MELANCHOLICS": "MELANCHOLIC, one given to melancholy [n]\n",
  "MELANCHOLIES": "MELANCHOLY, prolonged depression of spirits [n]\n",
  "MELANCHOLILY": "MELANCHOLY, sad, gloomy [adv]\n",
  "MELANCHOLINESS": "the state of being melancholy [n]\n",
  "MELANCHOLIOUS": "melancholic [adj]\n",
  "MELANCHOLY": "sad, gloomy [adj MELANCHOLILY] / prolonged depression of spirits [n MELANCHOLIES]\n",
  "MELANGE": "(French) a mixture often of incongruous elements [n -S]\n",
  "MELANGES": "MELANGE, (French) a mixture often of incongruous elements [n]\n",
  "MELANIAN": "one of a family of freshwater mollusks, having a turret-shaped shell [n -S]\n",
  "MELANIANS": "MELANIAN, one of a family of freshwater mollusks, having a turret-shaped shell [n]\n",
  "MELANIC": "one who is affected with melanism, also MELANIST [n -S]\n",
  "MELANICS": "MELANIC, one who is affected with melanism, also MELANIST [n]\n",
  "MELANIN": "any of various dark brown or black pigments present in the hair, skin, eyes, etc. [n -S]\n",
  "MELANINS": "MELANIN, any of various dark brown or black pigments present in the hair, skin, eyes, etc. [n]\n",
  "MELANISATION": "darkening of the skin pigment, also MELANIZATION [n -S]\n",
  "MELANISATIONS": "MELANISATION, darkening of the skin pigment, also MELANIZATION [n]\n",
  "MELANISE": "to make dark, also MELANIZE [v MELANISED, MELANISING, MELANISES]\n",
  "MELANISED": "MELANISE, to make dark, also MELANIZE [v]\n",
  "MELANISES": "MELANISE, to make dark, also MELANIZE [v]\n",
  "MELANISING": "MELANISE, to make dark, also MELANIZE [v]\n",
  "MELANISM": "abnormally dark pigmentation of the skin [n -S]\n",
  "MELANISMS": "MELANISM, abnormally dark pigmentation of the skin [n]\n",
  "MELANIST": "one who is affected with melanism, also MELANIC [n -S]\n",
  "MELANISTIC": "affected with melanism [adj]\n",
  "MELANISTS": "MELANIST, one who is affected with melanism, also MELANIC [n]\n",
  "MELANITE": "a black variety of garnet [n -S]\n",
  "MELANITES": "MELANITE, a black variety of garnet [n]\n",
  "MELANITIC": "of or like melanite, a black variety of garnet [adj]\n",
  "MELANIZATION": "darkening of the skin pigment, also MELANISATION [n -S]\n",
  "MELANIZATIONS": "MELANIZATION, darkening of the skin pigment, also MELANISATION [n]\n",
  "MELANIZE": "to make dark, also MELANISE [v MELANIZED, MELANIZING, MELANIZES]\n",
  "MELANIZED": "MELANIZE, to make dark, also MELANISE [v]\n",
  "MELANIZES": "MELANIZE, to make dark, also MELANISE [v]\n",
  "MELANIZING": "MELANIZE, to make dark, also MELANISE [v]\n",
  "MELANO": "an abnormally dark person or animal [n -S]\n",
  "MELANOBLAST": "a cell that is a precursor of a melanocyte or melanophore [n -S]\n",
  "MELANOBLASTS": "MELANOBLAST, a cell that is a precursor of a melanocyte or melanophore [n]\n",
  "MELANOCHROI": "people, like Caucasians, with dark hair and light skin [n]\n",
  "MELANOCHROIC": "belonging to the melanochroi, having dark hair and white skin, also MELANOCHROOUS [adj]\n",
  "MELANOCHROOUS": "belonging to the melanochroi, having dark hair and white skin, also MELANOCHROIC [adj]\n",
  "MELANOCYTE": "an epidermal cell that can produce melanism [n -S]\n",
  "MELANOCYTES": "MELANOCYTE, an epidermal cell that can produce melanism [n]\n",
  "MELANOGENESES": "MELANOGENESIS, the formation of melanin [n]\n",
  "MELANOGENESIS": "the formation of melanin [n MELANOGENESES]\n",
  "MELANOID": "suffering from melanosis [adj] / someone suffering from melanosis [n -S]\n",
  "MELANOIDS": "MELANOID, someone suffering from melanosis [n]\n",
  "MELANOMA": "a darkly pigmented tumor [n MELANOMAS or MELANOMATA]\n",
  "MELANOMAS": "MELANOMA, a darkly pigmented tumor [n]\n",
  "MELANOMATA": "MELANOMA, a darkly pigmented tumor [n]\n",
  "MELANOPHORE": "a chromatophore containing melanin [n -S]\n",
  "MELANOPHORES": "MELANOPHORE, a chromatophore containing melanin [n]\n",
  "MELANOS": "MELANO, an abnormally dark person or animal [n]\n",
  "MELANOSES": "MELANOSIS, the morbid deposition of black matter, often of a malignant character, causing pigmented tumors [n]\n",
  "MELANOSIS": "the morbid deposition of black matter, often of a malignant character, causing pigmented tumors [n MELANOSES]\n",
  "MELANOSITIES": "MELANOSITY, the state of being melanous, swarthy [n]\n",
  "MELANOSITY": "the state of being melanous, swarthy [n MELANOSITIES]\n",
  "MELANOSOME": "a melanin-producing granule in a melanocyte [n -S]\n",
  "MELANOSOMES": "MELANOSOME, a melanin-producing granule in a melanocyte [n]\n",
  "MELANOTIC": "dark-complexioned, also MELANOUS [adj]\n",
  "MELANOTROPIN": "a hormone secreted by the pituitary gland which stimulates the production of melanin by melanocytes [n -S]\n",
  "MELANOTROPINS": "MELANOTROPIN, a hormone secreted by the pituitary gland which stimulates the production of melanin by melanocytes [n]\n",
  "MELANOUS": "dark-complexioned, also MELANOTIC [adj]\n",
  "MELANTERITE": "native copperas [n -S]\n",
  "MELANTERITES": "MELANTERITE, native copperas [n]\n",
  "MELANURIA": "the presence of a dark pigment in the urine [n -S]\n",
  "MELANURIAS": "MELANURIA, the presence of a dark pigment in the urine [n]\n",
  "MELANURIC": "relating to melanuria, the presence of a dark pigment in the urine [adj]\n",
  "MELAPHYRE": "any one of several dark-colored augitic, eruptive rocks allied to basalt [n -S]\n",
  "MELAPHYRES": "MELAPHYRE, any one of several dark-colored augitic, eruptive rocks allied to basalt [n]\n",
  "MELAS": "MELA, (Hindi) in the Indian subcontinent, a Hindu festival or fair [n]\n",
  "MELASTOMACEOUS": "belonging to a tropical family of plants related to the myrtles [adj]\n",
  "MELASTOME": "a tropical flowering plant of the myrtle family [n -S]\n",
  "MELASTOMES": "MELASTOME, a tropical flowering plant of the myrtle family [n]\n",
  "MELATONIN": "a hormone secreted by the pineal gland during the hours of darkness [n -S]\n",
  "MELATONINS": "MELATONIN, a hormone secreted by the pineal gland during the hours of darkness [n]\n",
  "MELBA": "applied to several foods named after Dame Nellie Melba (1861-1931), Australian opera singer, such as melba toast, very thin crisp toast, and melba sauce a sauce for puddings, made from raspberries [adj]\n",
  "MELD": "to merge, blend [v -ED, -ING, -S]\n",
  "MELDED": "MELD, to merge, blend [v]\n",
  "MELDER": "(Scots) the quantity of meal ground at one time [n -S]\n",
  "MELDERS": "MELDER, (Scots) the quantity of meal ground at one time [n]\n",
  "MELDING": "MELD, to merge, blend [v]\n",
  "MELDS": "MELD, to merge, blend [v]\n",
  "MELEE": "(French) a confused struggle, also MELLAY [n -S]\n",
  "MELEES": "MELEE, (French) a confused struggle, also MELLAY [n]\n",
  "MELENA": "excrement or vomit stained by blood, also MELAENA [n -S]\n",
  "MELENAS": "MELENA, excrement or vomit stained by blood, also MELAENA [n]\n",
  "MELIACEOUS": "relating to the Melia genus of plants which includes the neem and margosa trees [adj]\n",
  "MELIC": "a type of perennial grass, also MELICK [n -S]\n",
  "MELICK": "a type of perennial grass, also MELIC [n -S]\n",
  "MELICKS": "MELICK, a type of perennial grass, also MELIC [n]\n",
  "MELICOTTON": "(obsolete) a kind of large peach, also MALAKATOONE, MELOCOTON, MELOCOTOON [n -S]\n",
  "MELICOTTONS": "MELICOTTON, (obsolete) a kind of large peach, also MALAKATOONE, MELOCOTON, MELOCOTOON [n]\n",
  "MELICS": "MELIC, a type of perennial grass, also MELICK [n]\n",
  "MELIK": "(Arabic) in India, the head of a village, an employer, also MALIK [n -S]\n",
  "MELIKS": "MELIK, (Arabic) in India, the head of a village, an employer, also MALIK [n]\n",
  "MELILITE": "a tetragonal mineral, calcium aluminium magnesium silicate, often honey-yellow [n -S]\n",
  "MELILITES": "MELILITE, a tetragonal mineral, calcium aluminium magnesium silicate, often honey-yellow [n]\n",
  "MELILOT": "a wild flower [n -S]\n",
  "MELILOTS": "MELILOT, a wild flower [n]\n",
  "MELINITE": "a powerful explosive [n -S]\n",
  "MELINITES": "MELINITE, a powerful explosive [n]\n",
  "MELIORABLE": "capable of improvement [adj]\n",
  "MELIORATE": "to make better, also AMELIORATE [v MELIORATED, MELIORATING, MELIORATES]\n",
  "MELIORATED": "MELIORATE, to make better, also AMELIORATE [v]\n",
  "MELIORATES": "MELIORATE, to make better, also AMELIORATE [v]\n",
  "MELIORATING": "MELIORATE, to make better, also AMELIORATE [v]\n",
  "MELIORATION": "improvement, betterment [n -S]\n",
  "MELIORATIONS": "MELIORATION, improvement, betterment [n]\n",
  "MELIORATIVE": "tending to effect improvement [adj] / something tending to effect improvement [n -S]\n",
  "MELIORATIVES": "MELIORATIVE, something tending to effect improvement [n]\n",
  "MELIORATOR": "one who meliorates [n -S]\n",
  "MELIORATORS": "MELIORATOR, one who meliorates [n]\n",
  "MELIORISM": "the belief that the world tends to become better and that humans can aid its betterment [n -S]\n",
  "MELIORISMS": "MELIORISM, the belief that the world tends to become better and that humans can aid its betterment [n]\n",
  "MELIORIST": "a proponent of meliorism [n -S]\n",
  "MELIORISTIC": "of or like meliorism [adj]\n",
  "MELIORISTS": "MELIORIST, a proponent of meliorism [n]\n",
  "MELIORITIES": "MELIORITY, the state of being better [n]\n",
  "MELIORITY": "the state of being better [n MELIORITIES]\n",
  "MELIPHAGOUS": "feeding upon honey, also MELLIPHAGOUS [adj]\n",
  "MELISMA": "(Greek) melodic embellishment [n MELISMAS or MELISMATA]\n",
  "MELISMAS": "MELISMA, (Greek) melodic embellishment [n]\n",
  "MELISMATA": "MELISMA, (Greek) melodic embellishment [n]\n",
  "MELISMATIC": "in florid style, esp. of singing one syllable on a number of notes [adj]\n",
  "MELITTIN": "a toxic polypeptide found in bee venom, responsible for the pain of the sting [n -S]\n",
  "MELITTINS": "MELITTIN, a toxic polypeptide found in bee venom, responsible for the pain of the sting [n]\n",
  "MELL": "(Scots) to mix, to meddle [v -ED, -ING, -S]\n",
  "MELLAY": "a confused fight, also MELEE [n -S]\n",
  "MELLAYS": "MELLAY, a confused fight, also MELEE [n]\n",
  "MELLED": "MELL, (Scots) to mix, to meddle [v]\n",
  "MELLIFEROUS": "producing or forming honey [adj]\n",
  "MELLIFIC": "producing honey [adj]\n",
  "MELLIFICATION": "honey-making [n -S]\n",
  "MELLIFICATIONS": "MELLIFICATION, honey-making [n]\n",
  "MELLIFLUENCE": "a smooth sweet flow [n -S]\n",
  "MELLIFLUENCES": "MELLIFLUENCE, a smooth sweet flow [n]\n",
  "MELLIFLUENT": "sweet-sounding; flowing with honey, also MELLIFLUOUS [adj MELLIFLUENTLY]\n",
  "MELLIFLUENTLY": "MELLIFLUENT, sweet-sounding; flowing with honey, also MELLIFLUOUS [adv]\n",
  "MELLIFLUOUS": "sweet-sounding; flowing with honey, also MELLIFLUENT [adj MELLIFLUOUSLY]\n",
  "MELLIFLUOUSLY": "MELLIFLUOUS, sweet-sounding; flowing with honey, also MELLIFLUENT [adv]\n",
  "MELLIFLUOUSNESS": "MELLIFLUOUS, sweet-sounding; flowing with honey, also MELLIFLUENT [n]\n",
  "MELLING": "MELL, (Scots) to mix, to meddle [v]\n",
  "MELLIPHAGOUS": "feeding upon honey, also MELIPHAGOUS [adj]\n",
  "MELLITE": "a mineral of a honey color, found in brown coal, and partly the result of vegetable decomposition [n -S]\n",
  "MELLITES": "MELLITE, a mineral of a honey color, found in brown coal, and partly the result of vegetable decomposition [n]\n",
  "MELLITIC": "containing saccharine matter; as, mellitic diabetes [adj]\n",
  "MELLIVOROUS": "honey-eating [adj]\n",
  "MELLOPHONE": "a brass wind instrument resembling the French horn [n -S]\n",
  "MELLOPHONES": "MELLOPHONE, a brass wind instrument resembling the French horn [n]\n",
  "MELLOTRON": "(tradename) an electronic keyboard instrument programmed to produce the tape-recorder sounds of orchestral instruments [n -S]\n",
  "MELLOTRONS": "MELLOTRON, (tradename) an electronic keyboard instrument programmed to produce the tape-recorder sounds of orchestral instruments [n]\n",
  "MELLOW": "to make mature [v -ED, -ING, -S] / well matured [adj MELLOWER, MELLOWEST, MELLOWLY]\n",
  "MELLOWED": "MELLOW, to make mature [v]\n",
  "MELLOWER": "MELLOW, well matured [adj]\n",
  "MELLOWEST": "MELLOW, well matured [adj]\n",
  "MELLOWIER": "MELLOWY, soft; unctuous [adj]\n",
  "MELLOWIEST": "MELLOWY, soft; unctuous [adj]\n",
  "MELLOWING": "MELLOW, to make mature [v]\n",
  "MELLOWLY": "MELLOW, well matured [adv]\n",
  "MELLOWNESS": "the state of being mellow [n -ES]\n",
  "MELLOWNESSES": "MELLOWNESS, the state of being mellow [n]\n",
  "MELLOWS": "MELLOW, to make mature [v]\n",
  "MELLOWSPEAK": "a bland nonassertive form of language associated with New Age philosophy [n -S]\n",
  "MELLOWSPEAKS": "MELLOWSPEAK, a bland nonassertive form of language associated with New Age philosophy [n]\n",
  "MELLOWY": "soft; unctuous [adj MELLOWIER, MELLOWIEST]\n",
  "MELLS": "MELL, (Scots) to mix, to meddle [v]\n",
  "MELOCOTON": "(obsolete) a kind of large peach, also MALAKATOONE, MELICOTTON, MELOCOTOON [n -S]\n",
  "MELOCOTONS": "MELOCOTON, (obsolete) a kind of large peach, also MALAKATOONE, MELICOTTON, MELOCOTOON [n]\n",
  "MELOCOTOON": "(obsolete) a kind of large peach, also MALAKATOONE, MELICOTTON, MELOCOTON [n -S]\n",
  "MELOCOTOONS": "MELOCOTOON, (obsolete) a kind of large peach, also MALAKATOONE, MELICOTTON, MELOCOTON [n]\n",
  "MELODEON": "a small reed organ, also MELODION [n -S]\n",
  "MELODEONS": "MELODEON, a small reed organ, also MELODION [n]\n",
  "MELODIA": "(Latin) a type of organ stop [n -S]\n",
  "MELODIAS": "MELODIA, (Latin) a type of organ stop [n]\n",
  "MELODIC": "pertaining to melody [adj MELODICALLY]\n",
  "MELODICA": "a harmonica with a small keyboard at one end [n -S]\n",
  "MELODICALLY": "MELODIC, pertaining to melody [adv]\n",
  "MELODICAS": "MELODICA, a harmonica with a small keyboard at one end [n]\n",
  "MELODICS": "a branch of music concerned with melody [n]\n",
  "MELODIES": "MELODY, an agreeable succession of single musical sounds [n]\n",
  "MELODION": "a small reed organ, also MELODEON [n -S]\n",
  "MELODIONS": "MELODION, a small reed organ, also MELODEON [n]\n",
  "MELODIOUS": "having melody [adj MELODIOUSLY]\n",
  "MELODIOUSLY": "MELODIOUS, having melody [adv]\n",
  "MELODIOUSNESS": "MELODIOUS, having melody [n]\n",
  "MELODIOUSNESSES": "MELODIOUSNESS, MELODIOUS, having melody [n]\n",
  "MELODISE": "to compose a melody, also MELODIZE [v MELODISED, MELODISING, MELODISES]\n",
  "MELODISED": "MELODISE, to compose a melody, also MELODIZE [v]\n",
  "MELODISER": "one who melodises, also MELODIZER [n -S]\n",
  "MELODISERS": "MELODISER, one who melodises, also MELODIZER [n]\n",
  "MELODISES": "MELODISE, to compose a melody, also MELODIZE [v]\n",
  "MELODISING": "MELODISE, to compose a melody, also MELODIZE [v]\n",
  "MELODIST": "a composer of melodies [n -S]\n",
  "MELODISTS": "MELODIST, a composer of melodies [n]\n",
  "MELODIZE": "to compose a melody, also MELODISE [v MELODIZED, MELODIZING, MELODIZES]\n",
  "MELODIZED": "MELODIZE, to compose a melody, also MELODISE [v]\n",
  "MELODIZER": "one who melodizes, also MELODISER [n -S]\n",
  "MELODIZERS": "MELODIZER, one who melodizes, also MELODISER [n]\n",
  "MELODIZES": "MELODIZE, to compose a melody, also MELODISE [v]\n",
  "MELODIZING": "MELODIZE, to compose a melody, also MELODISE [v]\n",
  "MELODRAMA": "a kind of romantic and sensational drama, also MELODRAME [n -S]\n",
  "MELODRAMAS": "MELODRAMA, a kind of romantic and sensational drama, also MELODRAME [n]\n",
  "MELODRAMATIC": "of, relating to, or characteristic of melodrama [adj]\n",
  "MELODRAMATICS": "melodramatic conduct or writing [n]\n",
  "MELODRAMATISE": "to make melodramatic, also MELODRAMATIZE [v MELODRAMATISED, MELODRAMATISING, MELODRAMATISES]\n",
  "MELODRAMATISED": "MELODRAMATISE, to make melodramatic, also MELODRAMATIZE [v]\n",
  "MELODRAMATISES": "MELODRAMATISE, to make melodramatic, also MELODRAMATIZE [v]\n",
  "MELODRAMATISING": "MELODRAMATISE, to make melodramatic, also MELODRAMATIZE [v]\n",
  "MELODRAMATIST": "one who writes melodramas [n -S]\n",
  "MELODRAMATISTS": "MELODRAMATIST, one who writes melodramas [n]\n",
  "MELODRAMATIZE": "to make melodramatic, also MELODRAMATISE [v MELODRAMATIZED, MELODRAMATIZING, MELODRAMATIZES]\n",
  "MELODRAMATIZED": "MELODRAMATIZE, to make melodramatic, also MELODRAMATISE [v]\n",
  "MELODRAMATIZES": "MELODRAMATIZE, to make melodramatic, also MELODRAMATISE [v]\n",
  "MELODRAMATIZING": "MELODRAMATIZE, to make melodramatic, also MELODRAMATISE [v]\n",
  "MELODRAME": "a kind of romantic and sensational drama, also MELODRAMA [n -S]\n",
  "MELODRAMES": "MELODRAME, a kind of romantic and sensational drama, also MELODRAMA [n]\n",
  "MELODY": "an agreeable succession of single musical sounds [n MELODIES]\n",
  "MELOID": "a blister beetle [n -S]\n",
  "MELOIDS": "MELOID, a blister beetle [n]\n",
  "MELOMANIA": "a mania for music [n -S]\n",
  "MELOMANIAC": "an abnormally dedicated musical fan [n -S]\n",
  "MELOMANIACS": "MELOMANIAC, an abnormally dedicated musical fan [n]\n",
  "MELOMANIAS": "MELOMANIA, a mania for music [n]\n",
  "MELOMANIC": "suffering from melomania, a craze for music [adj]\n",
  "MELON": "any of several juicy, edible gourds [n -S]\n",
  "MELONGENE": "(Caribbean) an aubergine [n -S]\n",
  "MELONGENES": "MELONGENE, (Caribbean) an aubergine [n]\n",
  "MELONIER": "MELONY, like a melon [adj]\n",
  "MELONIEST": "MELONY, like a melon [adj]\n",
  "MELONS": "MELON, any of several juicy, edible gourds [n]\n",
  "MELONY": "like a melon [adj MELONIER, MELONIEST]\n",
  "MELOXICAM": "a drug used to treat osteoarthritis and rheumatoid arthritis [n -S]\n",
  "MELOXICAMS": "MELOXICAM, a drug used to treat osteoarthritis and rheumatoid arthritis [n]\n",
  "MELPHALAN": "an antineoplastic drug [n -S]\n",
  "MELPHALANS": "MELPHALAN, an antineoplastic drug [n]\n",
  "MELS": "MEL, honey [n]\n",
  "MELT": "to change from a solid to a liquid state by heat [v MELTED, YMOLT or YMOLTEN or MELTED, MELTING, MELTS]\n",
  "MELTABILITIES": "MELTABILITY, the quality of being meltable [n]\n",
  "MELTABILITY": "the quality of being meltable [n MELTABILITIES]\n",
  "MELTABLE": "able to be melted [adj]\n",
  "MELTAGE": "the process of melting [n -S]\n",
  "MELTAGES": "MELTAGE, the process of melting [n]\n",
  "MELTDOWN": "the melting of the core of a nuclear reactor [n -S]\n",
  "MELTDOWNS": "MELTDOWN, the melting of the core of a nuclear reactor [n]\n",
  "MELTED": "MELT, to change from a solid to a liquid state by heat [v]\n",
  "MELTEMI": "(Modern Greek) a northerly wind in the NE Mediterranean [n -S]\n",
  "MELTEMIS": "MELTEMI, (Modern Greek) a northerly wind in the NE Mediterranean [n]\n",
  "MELTER": "one who, or that which, melts [n -S]\n",
  "MELTERS": "MELTER, one who, or that which, melts [n]\n",
  "MELTIER": "MELTY, liable to melt [adj]\n",
  "MELTIEST": "MELTY, liable to melt [adj]\n",
  "MELTING": "in a melting state [adj MELTINGLY] / the act of melting [n -S]\n",
  "MELTINGLY": "MELTING, in a melting state [adv]\n",
  "MELTINGNESS": "the state of being melting [n -ES]\n",
  "MELTINGNESSES": "MELTINGNESS, the state of being melting [n]\n",
  "MELTINGS": "MELTING, the act of melting [n]\n",
  "MELTITH": "(Scots) a meal; a cow's yield at one milking [n -S]\n",
  "MELTITHS": "MELTITH, (Scots) a meal; a cow's yield at one milking [n]\n",
  "MELTON": "a strong and smooth heavy woollen cloth [n -S]\n",
  "MELTONS": "MELTON, a strong and smooth heavy woollen cloth [n]\n",
  "MELTS": "MELT, to change from a solid to a liquid state by heat [v]\n",
  "MELTWATER": "the water that runs off from snowfields or glaciers [n -S]\n",
  "MELTWATERS": "MELTWATER, the water that runs off from snowfields or glaciers [n]\n",
  "MELTY": "liable to melt [adj MELTIER, MELTIEST]\n",
  "MELUNGEON": "any of a dark-skinned group of people living in the Appalachians, of mixed White, Indian and Black origin [n -S]\n",
  "MELUNGEONS": "MELUNGEON, any of a dark-skinned group of people living in the Appalachians, of mixed White, Indian and Black origin [n]\n",
  "MEM": "the thirteenth letter of the Hebrew alphabet [n -S]\n",
  "MEMBER": "a distinct part of a whole [n -S]\n",
  "MEMBERED": "having limbs [adj]\n",
  "MEMBERLESS": "without members [adj]\n",
  "MEMBERS": "MEMBER, a distinct part of a whole [n]\n",
  "MEMBERSHIP": "the state or status of being a member [n -S]\n",
  "MEMBERSHIPS": "MEMBERSHIP, the state or status of being a member [n]\n",
  "MEMBRAL": "relating to the limbs [adj]\n",
  "MEMBRANACEOUS": "like a membrane, also MEMBRANEOUS, MEMBRANOUS [adj]\n",
  "MEMBRANAL": "of or like a membrane [adj]\n",
  "MEMBRANE": "a thin, pliable layer of tissue [n -S]\n",
  "MEMBRANED": "having a membrane [adj]\n",
  "MEMBRANEOUS": "like a membrane, also MEMBRANACEOUS, MEMBRANOUS [adj]\n",
  "MEMBRANES": "MEMBRANE, a thin, pliable layer of tissue [n]\n",
  "MEMBRANOUS": "like a membrane, also MEMBRANACEOUS, MEMBRANEOUS [adj MEMBRANOUSLY]\n",
  "MEMBRANOUSLY": "MEMBRANOUS, like a membrane, also MEMBRANACEOUS, MEMBRANEOUS [adv]\n",
  "MEME": "a practice or belief passed on other than by genes [n -S]\n",
  "MEMENTO": "(Latin) something kept or given as a reminder, also MOMENTO [n -ES or -S]\n",
  "MEMENTOES": "MEMENTO, (Latin) something kept or given as a reminder, also MOMENTO [n]\n",
  "MEMENTOS": "MEMENTO, (Latin) something kept or given as a reminder, also MOMENTO [n]\n",
  "MEMES": "MEME, a practice or belief passed on other than by genes [n]\n",
  "MEMETIC": "of or like a meme [adj]\n",
  "MEMETICS": "the study of genetic transmission of culture [n]\n",
  "MEMO": "a brief note used as a reminder [n -S]\n",
  "MEMOIR": "a biography [n -S]\n",
  "MEMOIRISM": "the act or art of writing memoirs [n -S]\n",
  "MEMOIRISMS": "MEMOIRISM, the act or art of writing memoirs [n]\n",
  "MEMOIRIST": "one who writes memoirs [n -S]\n",
  "MEMOIRISTS": "MEMOIRIST, one who writes memoirs [n]\n",
  "MEMOIRS": "MEMOIR, a biography [n]\n",
  "MEMORABILE": "something memorable [n MEMORABILIA]\n",
  "MEMORABILIA": "MEMORABILE, something memorable [n]\n",
  "MEMORABILITIES": "MEMORABILITY, the state of being memorable [n]\n",
  "MEMORABILITY": "the state of being memorable [n MEMORABILITIES]\n",
  "MEMORABLE": "worth remembering [adj MEMORABLY]\n",
  "MEMORABLENESS": "MEMORABLE, worth remembering [n]\n",
  "MEMORABLENESSES": "MEMORABLENESS, MEMORABLE, worth remembering [n]\n",
  "MEMORABLY": "MEMORABLE, worth remembering [adv]\n",
  "MEMORANDA": "MEMORANDUM, (Latin) a note to help the memory [n]\n",
  "MEMORANDUM": "(Latin) a note to help the memory [n MEMORANDUMS or MEMORANDA]\n",
  "MEMORANDUMS": "MEMORANDUM, (Latin) a note to help the memory [n]\n",
  "MEMORATIVE": "(obsolete) commemorative [adj]\n",
  "MEMORIAL": "serving to remember [adj MEMORIALLY] / something that serves as a remembrance of a person or event [n -S]\n",
  "MEMORIALISATION": "the process of memorialising, also MEMORIALIZATION [n]\n",
  "MEMORIALISE": "to celebrate with a memorial, also MEMORIALIZE [v MEMORIALISED, MEMORIALISING, MEMORIALISES]\n",
  "MEMORIALISED": "MEMORIALISE, to celebrate with a memorial, also MEMORIALIZE [v]\n",
  "MEMORIALISER": "one who memorialises, also MEMORIALIZER [n -S]\n",
  "MEMORIALISERS": "MEMORIALISER, one who memorialises, also MEMORIALIZER [n]\n",
  "MEMORIALISES": "MEMORIALISE, to celebrate with a memorial, also MEMORIALIZE [v]\n",
  "MEMORIALISING": "MEMORIALISE, to celebrate with a memorial, also MEMORIALIZE [v]\n",
  "MEMORIALIST": "a person who writes or signs a memorial [n -S]\n",
  "MEMORIALISTS": "MEMORIALIST, a person who writes or signs a memorial [n]\n",
  "MEMORIALIZATION": "the process of memorializing, also MEMORIALISATION [n]\n",
  "MEMORIALIZE": "to address or petition by a memorial, also MEMORIALISE [v MEMORIALIZED, MEMORIALIZING, MEMORIALIZES]\n",
  "MEMORIALIZED": "MEMORIALIZE, to address or petition by a memorial, also MEMORIALISE [v]\n",
  "MEMORIALIZER": "one who memorializes, also MEMORIALISER [n -S]\n",
  "MEMORIALIZERS": "MEMORIALIZER, one who memorializes, also MEMORIALISER [n]\n",
  "MEMORIALIZES": "MEMORIALIZE, to address or petition by a memorial, also MEMORIALISE [v]\n",
  "MEMORIALIZING": "MEMORIALIZE, to address or petition by a memorial, also MEMORIALISE [v]\n",
  "MEMORIALLY": "MEMORIAL, serving to remember [adv]\n",
  "MEMORIALS": "MEMORIAL, something that serves as a remembrance of a person or event [n]\n",
  "MEMORIES": "MEMORY, the gift of being able to retain and recall events [n]\n",
  "MEMORISABLE": "able to be memorised, also MEMORIZABLE [adj]\n",
  "MEMORISATION": "the act of memorising, also MEMORIZATION [n -S]\n",
  "MEMORISATIONS": "MEMORISATION, the act of memorising, also MEMORIZATION [n]\n",
  "MEMORISE": "to commit to memory, also MEMORIZE [v MEMORISED, MEMORISING, MEMORISES]\n",
  "MEMORISED": "MEMORISE, to commit to memory, also MEMORIZE [v]\n",
  "MEMORISER": "one who memorises, also MEMORIZER [n -S]\n",
  "MEMORISERS": "MEMORISER, one who memorises, also MEMORIZER [n]\n",
  "MEMORISES": "MEMORISE, to commit to memory, also MEMORIZE [v]\n",
  "MEMORISING": "MEMORISE, to commit to memory, also MEMORIZE [v]\n",
  "MEMORITER": "(Latin) from memory; by heart [adv]\n",
  "MEMORIZABLE": "able to be memorised, also MEMORISABLE [adj]\n",
  "MEMORIZATION": "the act of memorizing, also MEMORISATION [n -S]\n",
  "MEMORIZATIONS": "MEMORIZATION, the act of memorizing, also MEMORISATION [n]\n",
  "MEMORIZE": "to commit to memory, also MEMORISE [v MEMORIZED, MEMORIZING, MEMORIZES]\n",
  "MEMORIZED": "MEMORIZE, to commit to memory, also MEMORISE [v]\n",
  "MEMORIZER": "one who memorizes, also MEMORISER [n -S]\n",
  "MEMORIZERS": "MEMORIZER, one who memorizes, also MEMORISER [n]\n",
  "MEMORIZES": "MEMORIZE, to commit to memory, also MEMORISE [v]\n",
  "MEMORIZING": "the act of commiting to memory [n -S]\n",
  "MEMORIZINGS": "MEMORIZING, the act of commiting to memory [n]\n",
  "MEMORY": "the gift of being able to retain and recall events [n MEMORIES]\n",
  "MEMOS": "MEMO, a brief note used as a reminder [n]\n",
  "MEMS": "MEM, the thirteenth letter of the Hebrew alphabet [n]\n",
  "MEMSAHIB": "(Hindi) a European woman living in colonial India [n -S]\n",
  "MEMSAHIBS": "MEMSAHIB, (Hindi) a European woman living in colonial India [n]\n",
  "MEN": "MAN, an adult human male [n]\n",
  "MENACE": "to threaten [v MENACED, MENACING, MENACES]\n",
  "MENACED": "MENACE, to threaten [v]\n",
  "MENACER": "one who menaces [n -S]\n",
  "MENACERS": "MENACER, one who menaces [n]\n",
  "MENACES": "MENACE, to threaten [v]\n",
  "MENACING": "MENACE, to threaten [v]\n",
  "MENACINGLY": "MENACING, MENACE, to threaten [adv]\n",
  "MENAD": "(Greek) a female follower of Bacchus, also MAENAD [n -S]\n",
  "MENADIONE": "vitamin K3 [n -S]\n",
  "MENADIONES": "MENADIONE, vitamin K3 [n]\n",
  "MENADS": "MENAD, (Greek) a female follower of Bacchus, also MAENAD [n]\n",
  "MENAGE": "(French) to manage [v MENAGED, MENAGING, MENAGES]\n",
  "MENAGED": "MENAGE, (French) to manage [v]\n",
  "MENAGERIE": "(French) a collection of wild animals [n -S]\n",
  "MENAGERIES": "MENAGERIE, (French) a collection of wild animals [n]\n",
  "MENAGES": "MENAGE, (French) to manage [v]\n",
  "MENAGING": "MENAGE, (French) to manage [v]\n",
  "MENAQUINONE": "a form of vitamin K synthesized by bacteria in the intestine or in putrefying organic matter [n -S]\n",
  "MENAQUINONES": "MENAQUINONE, a form of vitamin K synthesized by bacteria in the intestine or in putrefying organic matter [n]\n",
  "MENARCHE": "(Greek) the first occurrence of menstruation [n -S]\n",
  "MENARCHEAL": "relating to the menarche, also MENARCHIAL [adj]\n",
  "MENARCHES": "MENARCHE, (Greek) the first occurrence of menstruation [n]\n",
  "MENARCHIAL": "relating to the menarche, also MENARCHEAL [adj]\n",
  "MENAZON": "an insecticide [n -S]\n",
  "MENAZONS": "MENAZON, an insecticide [n]\n",
  "MEND": "to repair [v -ED, -ING, -S]\n",
  "MENDABLE": "able to be mended [adj]\n",
  "MENDACIOUS": "telling lies, esp. habitually [adj MENDACIOUSLY]\n",
  "MENDACIOUSLY": "MENDACIOUS, telling lies, esp. habitually [adv]\n",
  "MENDACIOUSNESS": "MENDACIOUS, telling lies, esp. habitually [n]\n",
  "MENDACITIES": "MENDACITY, given to lying, esp. habitually [n]\n",
  "MENDACITY": "given to lying, esp. habitually [n MENDACITIES]\n",
  "MENDED": "MEND, to repair [v]\n",
  "MENDELEVIUM": "an unstable radioactive element discovered in 1955 [n -S]\n",
  "MENDELEVIUMS": "MENDELEVIUM, an unstable radioactive element discovered in 1955 [n]\n",
  "MENDER": "one that mends [n -S]\n",
  "MENDERS": "MENDER, one that mends [n]\n",
  "MENDICANCIES": "MENDICANCY, the practice of begging, also MENDICITY [n]\n",
  "MENDICANCY": "the practice of begging, also MENDICITY [n MENDICANCIES]\n",
  "MENDICANT": "a beggar; a friar who depends on alms [n -S]\n",
  "MENDICANTS": "MENDICANT, a beggar; a friar who depends on alms [n]\n",
  "MENDICITIES": "MENDICITY, the practice of begging, also MENDICANCY [n]\n",
  "MENDICITY": "the practice of begging, also MENDICANCY [n MENDICITIES]\n",
  "MENDIGO": "a freshwater fish [n -S]\n",
  "MENDIGOS": "MENDIGO, a freshwater fish [n]\n",
  "MENDING": "an accumulation of articles to be mended [n -S]\n",
  "MENDINGS": "MENDING, an accumulation of articles to be mended [n]\n",
  "MENDS": "MEND, to repair [v]\n",
  "MENE": "(Scots) to lament, moan, also MEANE, MEIN [v MENED, MENING, MENES]\n",
  "MENED": "MENE, (Scots) to lament, moan, also MEANE, MEIN [v]\n",
  "MENEER": "(Dutch) the Dutch equivalent of Mr. or Sir; hence, a Dutchman, also MIJNHEER, MYNHEER [n -S]\n",
  "MENEERS": "MENEER, (Dutch) the Dutch equivalent of Mr. or Sir; hence, a Dutchman, also MIJNHEER, MYNHEER [n]\n",
  "MENES": "MENE, (Scots) to lament, moan, also MEANE, MEIN [v]\n",
  "MENFOLK": "the men of a family or community, also MENFOLKS [n]\n",
  "MENFOLKS": "the men of a family or community, also MENFOLK [n]\n",
  "MENG": "(archaic) to mix; to unite, couple, also MENGE, MING [v MENT or MEINT or MEYNT, MENGING, MENGS]\n",
  "MENGE": "(archaic) to mix; to unite, couple, also MENG, MING [v MENGED, MENGING, MENGES]\n",
  "MENGED": "MENG, (archaic) to mix; to unite, couple, also MENGE, MING [v]\n",
  "MENGES": "MENGE, (archaic) to mix; to unite, couple, also MENG, MING [v]\n",
  "MENGING": "MENG, (archaic) to mix; to unite, couple, also MENGE, MING [v]\n",
  "MENGS": "MENG, (archaic) to mix; to unite, couple, also MENGE, MING [v]\n",
  "MENHADEN": "(Native American) an oily fish of the herring family, found off the east coast of the United States [n -S]\n",
  "MENHADENS": "MENHADEN, (Native American) an oily fish of the herring family, found off the east coast of the United States [n]\n",
  "MENHIR": "(Welsh) a single upright rude monolith of usually prehistoric origin [n -S]\n",
  "MENHIRS": "MENHIR, (Welsh) a single upright rude monolith of usually prehistoric origin [n]\n",
  "MENIAL": "lowly [adj MENIALLY] / a domestic servant [n -S]\n",
  "MENIALLY": "MENIAL, lowly [adv]\n",
  "MENIALS": "MENIAL, a domestic servant [n]\n",
  "MENILITE": "a kind of opal, liver opal [n -S]\n",
  "MENILITES": "MENILITE, a kind of opal, liver opal [n]\n",
  "MENING": "MENE, (Scots) to lament, moan, also MEANE, MEIN [v]\n",
  "MENINGEAL": "of or pertaining to the meninx, the membrane enclosing the brain and spinal cord [adj]\n",
  "MENINGES": "MENINX, (Greek) any of the membranes enclosing the brain and spinal cord [n]\n",
  "MENINGIOMA": "a tumour of the meninges of the brain [n MENINGIOMAS or MENINGIOMATA]\n",
  "MENINGIOMAS": "MENINGIOMA, a tumour of the meninges of the brain [n]\n",
  "MENINGIOMATA": "MENINGIOMA, a tumour of the meninges of the brain [n]\n",
  "MENINGITIC": "relating to meningitis, inflammation of the meninx [adj]\n",
  "MENINGITIDES": "MENINGITIS, inflammation of the meninx [n]\n",
  "MENINGITIS": "inflammation of the meninx [n MENINGITIDES or MENINGITISES]\n",
  "MENINGITISES": "MENINGITIS, inflammation of the meninx [n]\n",
  "MENINGOCELE": "protrusion of the meninges through the skull [n -S]\n",
  "MENINGOCELES": "MENINGOCELE, protrusion of the meninges through the skull [n]\n",
  "MENINGOCOCCAL": "of or relating to the bacterium meningococcus, also MENINGOCOCCIC [adj]\n",
  "MENINGOCOCCI": "MENINGOCOCCUS, a bacterium involved in cerebrospinal fever and meningitis [n]\n",
  "MENINGOCOCCIC": "of or relating to the bacterium meningococcus, also MENINGOCOCCAL [adj]\n",
  "MENINGOCOCCUS": "a bacterium involved in cerebrospinal fever and meningitis [n MENINGOCOCCI]\n",
  "MENINX": "(Greek) any of the membranes enclosing the brain and spinal cord [n MENINGES]\n",
  "MENISCAL": "in the shape of a meniscus [adj]\n",
  "MENISCATE": "like a meniscus [adj]\n",
  "MENISCECTOMIES": "MENISCECTOMY, surgical removal of the meniscus [n]\n",
  "MENISCECTOMY": "surgical removal of the meniscus [n MENISCECTOMIES]\n",
  "MENISCI": "MENISCUS, (Greek) a crescent-shaped body [n]\n",
  "MENISCOID": "concave/convex, like a meniscus [adj]\n",
  "MENISCUS": "(Greek) a crescent-shaped body [n MENISCUSES or MENISCI]\n",
  "MENISCUSES": "MENISCUS, (Greek) a crescent-shaped body [n]\n",
  "MENISPERMACEOUS": "belonging to the family Menispermaceae, moonseeds [adj]\n",
  "MENISPERMUM": "any plant of the moonseed genus Menispermum [n -S]\n",
  "MENISPERMUMS": "MENISPERMUM, any plant of the moonseed genus Menispermum [n]\n",
  "MENO": "(Italian) in music, less [adv]\n",
  "MENOLOGIES": "MENOLOGY, an ecclesiastical calendar [n]\n",
  "MENOLOGY": "an ecclesiastical calendar [n MENOLOGIES]\n",
  "MENOMINEE": "a small whitefish found in the northern US and Canada, also MENOMINI [n -S]\n",
  "MENOMINEES": "MENOMINEE, a small whitefish found in the northern US and Canada, also MENOMINI [n]\n",
  "MENOMINI": "a small whitefish found in the northern US and Canada, also MENOMINEE [n -S]\n",
  "MENOMINIS": "MENOMINI, a small whitefish found in the northern US and Canada, also MENOMINEE [n]\n",
  "MENOPAUSAL": "relating to the menopause, also MENOPAUSIC [adj]\n",
  "MENOPAUSE": "the period during which a woman's menstrual cycle ceases [n -S]\n",
  "MENOPAUSES": "MENOPAUSE, the period during which a woman's menstrual cycle ceases [n]\n",
  "MENOPAUSIC": "relating to the menopause, also MENOPAUSAL [adj]\n",
  "MENOPOLIS": "(colloquial) an area with a high proportion of single men [n -ES]\n",
  "MENOPOLISES": "MENOPOLIS, (colloquial) an area with a high proportion of single men [n]\n",
  "MENOPOME": "a large American salamander, aka hellbender [n -S]\n",
  "MENOPOMES": "MENOPOME, a large American salamander, aka hellbender [n]\n",
  "MENORAH": "(Hebrew) a candleholder used in Jewish worship [n -S]\n",
  "MENORAHS": "MENORAH, (Hebrew) a candleholder used in Jewish worship [n]\n",
  "MENORRHAGIA": "excessive bleeding during menstruation [n -S]\n",
  "MENORRHAGIAS": "MENORRHAGIA, excessive bleeding during menstruation [n]\n",
  "MENORRHAGIC": "suffering from menorrhagia, excessive bleeding during menstruation [adj]\n",
  "MENORRHEA": "normal menstrual bleeding, also MENORRHOEA [n -S]\n",
  "MENORRHEAS": "MENORRHEA, normal menstrual bleeding, also MENORRHOEA [n]\n",
  "MENORRHOEA": "normal menstrual bleeding, also MENORRHEA [n -S]\n",
  "MENORRHOEAS": "MENORRHOEA, normal menstrual bleeding, also MENORRHEA [n]\n",
  "MENSA": "(Latin) the grinding surface of a tooth [n MENSAS or MENSAE]\n",
  "MENSAE": "MENSA, (Latin) the grinding surface of a tooth [n]\n",
  "MENSAL": "belonging to the table [adj]\n",
  "MENSAS": "MENSA, (Latin) the grinding surface of a tooth [n]\n",
  "MENSCH": "(Yiddish) an admirable person [n MENSCHES or MENSCHEN]\n",
  "MENSCHEN": "MENSCH, (Yiddish) an admirable person [n]\n",
  "MENSCHES": "MENSCH, (Yiddish) an admirable person [n]\n",
  "MENSCHIER": "MENSCHY, like a mensch, a person of integrity and honor [adj]\n",
  "MENSCHIEST": "MENSCHY, like a mensch, a person of integrity and honor [adj]\n",
  "MENSCHY": "like a mensch, a person of integrity and honor [adj MENSCHIER, MENSCHIEST]\n",
  "MENSE": "to do honour to, to grace [v MENSED, MENSING, MENSES]\n",
  "MENSED": "MENSE, to do honour to, to grace [v]\n",
  "MENSEFUL": "(Scots) decorous, graceful [adj]\n",
  "MENSELESS": "(Scots) graceless, uncivil [adj]\n",
  "MENSERVANTS": "MANSERVANT, a male servant [n]\n",
  "MENSES": "MENSE, to do honour to, to grace [v]\n",
  "MENSH": "(colloquial) to mention [v MENSHED, MENSHING, MENSHES]\n",
  "MENSHED": "MENSH, (colloquial) to mention [v]\n",
  "MENSHEN": "(Chinese) a Chinese door god [n]\n",
  "MENSHES": "MENSH, (colloquial) to mention [v]\n",
  "MENSHING": "MENSH, (colloquial) to mention [v]\n",
  "MENSING": "MENSE, to do honour to, to grace [v]\n",
  "MENSTRUA": "MENSTRUUM, (Latin) a solvent, esp. one used in the preparation of drugs [n]\n",
  "MENSTRUAL": "relating to menstruation [adj MENSTRUALLY]\n",
  "MENSTRUALLY": "MENSTRUAL, relating to menstruation [adv]\n",
  "MENSTRUATE": "to undergo menstruation [v MENSTRUATED, MENSTRUATING, MENSTRUATES]\n",
  "MENSTRUATED": "MENSTRUATE, to undergo menstruation [v]\n",
  "MENSTRUATES": "MENSTRUATE, to undergo menstruation [v]\n",
  "MENSTRUATING": "MENSTRUATE, to undergo menstruation [v]\n",
  "MENSTRUATION": "the monthly discharge through the vagina of blood and other substances from the uterus in nonpregnant adult females [n -S]\n",
  "MENSTRUATIONS": "MENSTRUATION, the monthly discharge through the vagina of blood and other substances from the uterus in nonpregnant adult females [n]\n",
  "MENSTRUOUS": "having the monthly flow or discharge; menstruating [adj]\n",
  "MENSTRUUM": "(Latin) a solvent, esp. one used in the preparation of drugs [n MENSTRUA or MENSTRUUMS]\n",
  "MENSTRUUMS": "MENSTRUUM, (Latin) a solvent, esp. one used in the preparation of drugs [n]\n",
  "MENSUAL": "monthly [adj]\n",
  "MENSURABILITIES": "MENSURABILITY, the state of being mensurable [n]\n",
  "MENSURABILITY": "the state of being mensurable [n MENSURABILITIES]\n",
  "MENSURABLE": "capable of being measured [adj]\n",
  "MENSURAL": "pertaining to measure [adj]\n",
  "MENSURATION": "measuring to find the dimensions of things [n -S]\n",
  "MENSURATIONAL": "relating to mensuration, also MENSURATIVE [adj]\n",
  "MENSURATIONS": "MENSURATION, measuring to find the dimensions of things [n]\n",
  "MENSURATIVE": "relating to mensuration, also MENSURATIONAL [adj]\n",
  "MENSWEAR": "clothing for men [n -S]\n",
  "MENSWEARS": "MENSWEAR, clothing for men [n]\n",
  "MENT": "MENG, (archaic) to mix; to unite, couple, also MENGE, MING [v]\n",
  "MENTA": "MENTUM, (Latin) the chin [n]\n",
  "MENTAL": "pertaining to the mind [adj MENTALLY]\n",
  "MENTALESE": "the picturing of concepts in the mind without words [n -S]\n",
  "MENTALESES": "MENTALESE, the picturing of concepts in the mind without words [n]\n",
  "MENTALISM": "the belief that the world can be explained as an aspect of the mind [n -S]\n",
  "MENTALISMS": "MENTALISM, the belief that the world can be explained as an aspect of the mind [n]\n",
  "MENTALIST": "a proponent of mentalism, the belief that the world can be explained as aspect of the mind [n -S]\n",
  "MENTALISTIC": "relating to mental action [adj MENTALISTICALLY]\n",
  "MENTALISTICALLY": "MENTALISTIC, relating to mental action [adv]\n",
  "MENTALISTS": "MENTALIST, a proponent of mentalism, the belief that the world can be explained as aspect of the mind [n]\n",
  "MENTALITIES": "MENTALITY, mind, a way of thinking [n]\n",
  "MENTALITY": "mind, a way of thinking [n MENTALITIES]\n",
  "MENTALLY": "MENTAL, pertaining to the mind [adv]\n",
  "MENTATION": "thought, cogitation [n -S]\n",
  "MENTATIONS": "MENTATION, thought, cogitation [n]\n",
  "MENTEE": "a person under the direction of a mentor, esp. in business [n -S]\n",
  "MENTEES": "MENTEE, a person under the direction of a mentor, esp. in business [n]\n",
  "MENTHACEOUS": "belonging to the mint family [adj]\n",
  "MENTHENE": "a colorless liquid hydrocarbon resembling oil of turpentine, obtained by dehydrating menthol [n -S]\n",
  "MENTHENES": "MENTHENE, a colorless liquid hydrocarbon resembling oil of turpentine, obtained by dehydrating menthol [n]\n",
  "MENTHOL": "a camphor obtained from oil of peppermint [n -S]\n",
  "MENTHOLATED": "containing menthol [adj]\n",
  "MENTHOLS": "MENTHOL, a camphor obtained from oil of peppermint [n]\n",
  "MENTICIDE": "the systematic undermining of a person's beliefs, attitudes, and values [n -S]\n",
  "MENTICIDES": "MENTICIDE, the systematic undermining of a person's beliefs, attitudes, and values [n]\n",
  "MENTION": "to remark briefly [v -ED, -ING, -S]\n",
  "MENTIONABLE": "that can be mentioned [adj]\n",
  "MENTIONED": "MENTION, to remark briefly [v]\n",
  "MENTIONER": "one who mentions [n -S]\n",
  "MENTIONERS": "MENTIONER, one who mentions [n]\n",
  "MENTIONING": "MENTION, to remark briefly [v]\n",
  "MENTIONS": "MENTION, to remark briefly [v]\n",
  "MENTO": "a traditional Jamaican form of song or ballad [n -S]\n",
  "MENTONNIERE": "(French) a piece of armour for the chin and throat [n -S]\n",
  "MENTONNIERES": "MENTONNIERE, (French) a piece of armour for the chin and throat [n]\n",
  "MENTOR": "to serve as a friend and teacher to [v -ED, -ING, -S]\n",
  "MENTORED": "MENTOR, to serve as a friend and teacher to [v]\n",
  "MENTORIAL": "containing advice or admonition [adj]\n",
  "MENTORING": "the act of serving as friend and tutor to [n -S]\n",
  "MENTORINGS": "MENTORING, the act of serving as friend and tutor to [n]\n",
  "MENTORS": "MENTOR, to serve as a friend and teacher to [v]\n",
  "MENTORSHIP": "the office of mentor [n -S]\n",
  "MENTORSHIPS": "MENTORSHIP, the office of mentor [n]\n",
  "MENTOS": "MENTO, a traditional Jamaican form of song or ballad [n]\n",
  "MENTUM": "(Latin) the chin [n MENTA]\n",
  "MENU": "(French) a list of dishes that may be ordered in a restaurant [n -S]\n",
  "MENUDO": "(Spanish) a spicy Mexican dish made with tripe [n -S]\n",
  "MENUDOS": "MENUDO, (Spanish) a spicy Mexican dish made with tripe [n]\n",
  "MENUISIER": "(French) a joiner [n -S]\n",
  "MENUISIERS": "MENUISIER, (French) a joiner [n]\n",
  "MENUS": "MENU, (French) a list of dishes that may be ordered in a restaurant [n]\n",
  "MENYIE": "a family, including servants, etc., a retinue, also MEINEY, MEINIE, MEINY [n -S]\n",
  "MENYIES": "MENYIE, a family, including servants, etc., a retinue, also MEINEY, MEINIE, MEINY [n]\n",
  "MEOU": "to make the sound of a crying cat, also MEOW, MIAOU, MIAOW, MIAUL [v -ED, -ING, -S]\n",
  "MEOUED": "MEOU, to make the sound of a crying cat, also MEOW, MIAOU, MIAOW, MIAUL [v]\n",
  "MEOUING": "MEOU, to make the sound of a crying cat, also MEOW, MIAOU, MIAOW, MIAUL [v]\n",
  "MEOUS": "MEOU, to make the sound of a crying cat, also MEOW, MIAOU, MIAOW, MIAUL [v]\n",
  "MEOW": "to make the sound of a crying cat, also MEOU, MIAOU, MIAOW, MIAUL [v -ED, -ING, -S]\n",
  "MEOWED": "MEOW, to make the sound of a crying cat, also MEOU, MIAOU, MIAOW, MIAUL [v]\n",
  "MEOWING": "MEOW, to make the sound of a crying cat, also MEOU, MIAOU, MIAOW, MIAUL [v]\n",
  "MEOWS": "MEOW, to make the sound of a crying cat, also MEOU, MIAOU, MIAOW, MIAUL [v]\n",
  "MEPACRINE": "a bitter yellow powder, aka atebrin, formerly used against malaria [n -S]\n",
  "MEPACRINES": "MEPACRINE, a bitter yellow powder, aka atebrin, formerly used against malaria [n]\n",
  "MEPERIDINE": "a pain-relieving drug used in childbirth, etc., aka pethidine [n -S]\n",
  "MEPERIDINES": "MEPERIDINE, a pain-relieving drug used in childbirth, etc., aka pethidine [n]\n",
  "MEPHITIC": "poisonous or foul-smelling, also MEPHITICAL [adj MEPHITICALLY]\n",
  "MEPHITICAL": "poisonous or foul-smelling, also MEPHITIC [adj MEPHITICALLY]\n",
  "MEPHITICALLY": "MEPHITICAL, poisonous or foul-smelling, also MEPHITIC [adv]\n",
  "MEPHITIS": "a poisonous exhalation; a foul stink [n -ES]\n",
  "MEPHITISES": "MEPHITIS, a poisonous exhalation; a foul stink [n]\n",
  "MEPHITISM": "poisoning by mephitis [n -S]\n",
  "MEPHITISMS": "MEPHITISM, poisoning by mephitis [n]\n",
  "MEPROBAMATE": "a drug used, esp. formerly, as a muscle relaxant and as a sedative [n -S]\n",
  "MEPROBAMATES": "MEPROBAMATE, a drug used, esp. formerly, as a muscle relaxant and as a sedative [n]\n",
  "MERANTI": "(Malay) the wood of various Malaysian trees [n -S]\n",
  "MERANTIS": "MERANTI, (Malay) the wood of various Malaysian trees [n]\n",
  "MERBROMIN": "a green crystalline mercurial compound used as an antiseptic and germicide [n -S]\n",
  "MERBROMINS": "MERBROMIN, a green crystalline mercurial compound used as an antiseptic and germicide [n]\n",
  "MERC": "(short for) a mercenary [n MERCS or MERCES]\n",
  "MERCADO": "(Spanish) a market [n -S]\n",
  "MERCADOS": "MERCADO, (Spanish) a market [n]\n",
  "MERCANTILE": "of or relating to merchants or trading [adj]\n",
  "MERCANTILISM": "the theory or practice of mercantile pursuits [n -S]\n",
  "MERCANTILISMS": "MERCANTILISM, the theory or practice of mercantile pursuits [n]\n",
  "MERCANTILIST": "a supporter of mercantilism [n -S]\n",
  "MERCANTILISTIC": "relating to mercantilism [adj]\n",
  "MERCANTILISTS": "MERCANTILIST, a supporter of mercantilism [n]\n",
  "MERCAPTAN": "a substance analogous to an alcohol, with sulphur instead of oxygen [n -S]\n",
  "MERCAPTANS": "MERCAPTAN, a substance analogous to an alcohol, with sulphur instead of oxygen [n]\n",
  "MERCAPTIDE": "a compound of mercaptan formed by replacing its sulphur hydrogen by a metal [n -S]\n",
  "MERCAPTIDES": "MERCAPTIDE, a compound of mercaptan formed by replacing its sulphur hydrogen by a metal [n]\n",
  "MERCAPTO": "containing a particular chemical group [adj]\n",
  "MERCAPTOPURINE": "an antimetabolite sometimes used in the treatment of acute leukemia [n -S]\n",
  "MERCAPTOPURINES": "MERCAPTOPURINE, an antimetabolite sometimes used in the treatment of acute leukemia [n]\n",
  "MERCAT": "(Scots) market; trade [n -S]\n",
  "MERCATS": "MERCAT, (Scots) market; trade [n]\n",
  "MERCENARIES": "MERCENARY, one who works for reward only [n]\n",
  "MERCENARILY": "MERCENARY, hired for money; motivated by the hope of reward [adv]\n",
  "MERCENARINESS": "the state of being mercenary [n -ES]\n",
  "MERCENARINESSES": "MERCENARINESS, the state of being mercenary [n]\n",
  "MERCENARISM": "the state of being a mercenary [n -S]\n",
  "MERCENARISMS": "MERCENARISM, the state of being a mercenary [n]\n",
  "MERCENARY": "hired for money; motivated by the hope of reward [adj MERCENARILY] / one who works for reward only [n MERCENARIES]\n",
  "MERCER": "a dealer in textiles, esp. silk and other fine materials [n -S]\n",
  "MERCERIES": "MERCERY, a mercer's shop [n]\n",
  "MERCERISATION": "the process of mercerising, also MERCERIZATION [n -S]\n",
  "MERCERISATIONS": "MERCERISATION, the process of mercerising, also MERCERIZATION [n]\n",
  "MERCERISE": "to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERIZE [v MERCERISED, MERCERISING, MERCERISES]\n",
  "MERCERISED": "MERCERISE, to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERIZE [v]\n",
  "MERCERISER": "one who mercerises, also MERCERIZER [n -S]\n",
  "MERCERISERS": "MERCERISER, one who mercerises, also MERCERIZER [n]\n",
  "MERCERISES": "MERCERISE, to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERIZE [v]\n",
  "MERCERISING": "MERCERISE, to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERIZE [v]\n",
  "MERCERIZATION": "the process of mercerizing, also MERCERISATION [n -S]\n",
  "MERCERIZATIONS": "MERCERIZATION, the process of mercerizing, also MERCERISATION [n]\n",
  "MERCERIZE": "to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERISE [v MERCERIZED, MERCERIZING, MERCERIZES]\n",
  "MERCERIZED": "MERCERIZE, to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERISE [v]\n",
  "MERCERIZER": "one who mercerizes, also MERCERISER [n -S]\n",
  "MERCERIZERS": "MERCERIZER, one who mercerizes, also MERCERISER [n]\n",
  "MERCERIZES": "MERCERIZE, to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERISE [v]\n",
  "MERCERIZING": "MERCERIZE, to treat cotton fabric under tension with caustic soda, so as to increase the strength and dye absorption, also MERCERISE [v]\n",
  "MERCERS": "MERCER, a dealer in textiles, esp. silk and other fine materials [n]\n",
  "MERCERY": "a mercer's shop [n MERCERIES]\n",
  "MERCES": "MERC, (short for) a mercenary [n]\n",
  "MERCH": "(colloquial) merchandise [n -ES]\n",
  "MERCHANDISE": "goods for sale [n -S] / to buy and sell in business, also MERCHANDIZE [v MERCHANDISED, MERCHANDISING, MERCHANDISES]\n",
  "MERCHANDISED": "MERCHANDISE, to buy and sell in business, also MERCHANDIZE [v]\n",
  "MERCHANDISER": "one who sells merchandise, also MERCHANDIZER [n -S]\n",
  "MERCHANDISERS": "MERCHANDISER, one who sells merchandise, also MERCHANDIZER [n]\n",
  "MERCHANDISES": "MERCHANDISE, to buy and sell in business, also MERCHANDIZE [v]\n",
  "MERCHANDISING": "buying and selling in business [n -S]\n",
  "MERCHANDISINGS": "MERCHANDISING, buying and selling in business [n]\n",
  "MERCHANDIZE": "goods for sale [n -S] / to buy and sell in business, also MERCHANDISE [v MERCHANDIZED, MERCHANDIZING, MERCHANDIZES]\n",
  "MERCHANDIZED": "MERCHANDIZE, to buy and sell in business, also MERCHANDISE [v]\n",
  "MERCHANDIZER": "one who sells merchandise, also MERCHANDISER [n -S]\n",
  "MERCHANDIZERS": "MERCHANDIZER, one who sells merchandise, also MERCHANDISER [n]\n",
  "MERCHANDIZES": "MERCHANDIZE, to buy and sell in business, also MERCHANDISE [v]\n",
  "MERCHANDIZING": "buying and selling in business [n -S]\n",
  "MERCHANDIZINGS": "MERCHANDIZING, buying and selling in business [n]\n",
  "MERCHANT": "a trader, esp. wholesale [n -S] / to buy and sell goods for profit [v -ED, -ING, -S]\n",
  "MERCHANTABILITY": "the state of being merchantable [n]\n",
  "MERCHANTABLE": "of commercially acceptable quality [adj]\n",
  "MERCHANTED": "MERCHANT, to buy and sell goods for profit [v]\n",
  "MERCHANTING": "the act of trading as a merchant [n -S]\n",
  "MERCHANTINGS": "MERCHANTING, the act of trading as a merchant [n]\n",
  "MERCHANTLIKE": "(Shakespeare) like a merchant [adj]\n",
  "MERCHANTMAN": "a trading ship [n MERCHANTMEN]\n",
  "MERCHANTMEN": "MERCHANTMAN, a trading ship [n]\n",
  "MERCHANTRIES": "MERCHANTRY, the body of merchants taken collectively [n]\n",
  "MERCHANTRY": "the body of merchants taken collectively [n MERCHANTRIES]\n",
  "MERCHANTS": "MERCHANT, to buy and sell goods for profit [v]\n",
  "MERCHES": "MERCH, (colloquial) merchandise [n]\n",
  "MERCHET": "a fine paid to a lord for the marriage of a daughter [n -S]\n",
  "MERCHETS": "MERCHET, a fine paid to a lord for the marriage of a daughter [n]\n",
  "MERCHILD": "a fish with the body of a child [n MERCHILDREN]\n",
  "MERCHILDREN": "MERCHILD, a fish with the body of a child [n]\n",
  "MERCIABLE": "(Spenser) merciful, also MERCIFUL [adj]\n",
  "MERCIES": "MERCY, compassion and clemency [n]\n",
  "MERCIFIDE": "MERCIFY, (Spenser) to show pity [v]\n",
  "MERCIFIED": "MERCIFY, (Spenser) to show pity [v]\n",
  "MERCIFIES": "MERCIFY, (Spenser) to show pity [v]\n",
  "MERCIFUL": "full of mercy [adj MERCIFULLY]\n",
  "MERCIFULLY": "MERCIFUL, full of mercy [adv]\n",
  "MERCIFULNESS": "the state of being merciful [n -ES]\n",
  "MERCIFULNESSES": "MERCIFULNESS, the state of being merciful [n]\n",
  "MERCIFY": "(Spenser) to show pity [v MERCIFIED or MERCIFIDE, MERCIFYING, MERCIFIES]\n",
  "MERCIFYING": "MERCIFY, (Spenser) to show pity [v]\n",
  "MERCILESS": "without mercy [adj MERCILESSLY]\n",
  "MERCILESSLY": "MERCILESS, without mercy [adv]\n",
  "MERCILESSNESS": "MERCILESS, without mercy [n]\n",
  "MERCILESSNESSES": "MERCILESSNESS, MERCILESS, without mercy [n]\n",
  "MERCS": "MERC, (short for) a mercenary [n]\n",
  "MERCURATE": "to mercurialize or treat with mercury [v MERCURATED, MERCURATING, MERCURATES]\n",
  "MERCURATED": "MERCURATE, to mercurialize or treat with mercury [v]\n",
  "MERCURATES": "MERCURATE, to mercurialize or treat with mercury [v]\n",
  "MERCURATING": "MERCURATE, to mercurialize or treat with mercury [v]\n",
  "MERCURATION": "conversion into a mercury compound [n -S]\n",
  "MERCURATIONS": "MERCURATION, conversion into a mercury compound [n]\n",
  "MERCURIAL": "of a volatile temperament [adj MERCURIALLY] / any compound, esp. a drug or medicine, that contains mercury [n -S]\n",
  "MERCURIALISE": "to treat with mercury or a drug containing mercury, also MERCURIALIZE [v MERCURIALISED, MERCURIALISING, MERCURIALISES]\n",
  "MERCURIALISED": "MERCURIALISE, to treat with mercury or a drug containing mercury, also MERCURIALIZE [v]\n",
  "MERCURIALISES": "MERCURIALISE, to treat with mercury or a drug containing mercury, also MERCURIALIZE [v]\n",
  "MERCURIALISING": "MERCURIALISE, to treat with mercury or a drug containing mercury, also MERCURIALIZE [v]\n",
  "MERCURIALISM": "a morbid condition due to mercury [n -S]\n",
  "MERCURIALISMS": "MERCURIALISM, a morbid condition due to mercury [n]\n",
  "MERCURIALIST": "a believer in the medical use of mercury [n -S]\n",
  "MERCURIALISTS": "MERCURIALIST, a believer in the medical use of mercury [n]\n",
  "MERCURIALITIES": "MERCURIALITY, the state of being mercurial [n]\n",
  "MERCURIALITY": "the state of being mercurial [n MERCURIALITIES]\n",
  "MERCURIALIZE": "to treat with mercury or a drug containing mercury, also MERCURIALISE [v MERCURIALIZED, MERCURIALIZING, MERCURIALIZES]\n",
  "MERCURIALIZED": "MERCURIALIZE, to treat with mercury or a drug containing mercury, also MERCURIALISE [v]\n",
  "MERCURIALIZES": "MERCURIALIZE, to treat with mercury or a drug containing mercury, also MERCURIALISE [v]\n",
  "MERCURIALIZING": "MERCURIALIZE, to treat with mercury or a drug containing mercury, also MERCURIALISE [v]\n",
  "MERCURIALLY": "MERCURIAL, of a volatile temperament [adv]\n",
  "MERCURIALNESS": "the state of being mercurial [n -ES]\n",
  "MERCURIALNESSES": "MERCURIALNESS, the state of being mercurial [n]\n",
  "MERCURIALS": "MERCURIAL, any compound, esp. a drug or medicine, that contains mercury [n]\n",
  "MERCURIC": "containing bivalent mercury [adj]\n",
  "MERCURIES": "MERCURY, a metallic element [n]\n",
  "MERCURISE": "to treat with mercury, also MERCURIZE [v MERCURISED, MERCURISING, MERCURISES]\n",
  "MERCURISED": "MERCURISE, to treat with mercury, also MERCURIZE [v]\n",
  "MERCURISES": "MERCURISE, to treat with mercury, also MERCURIZE [v]\n",
  "MERCURISING": "MERCURISE, to treat with mercury, also MERCURIZE [v]\n",
  "MERCURIZE": "to treat with mercury, also MERCURISE [v MERCURIZED, MERCURIZING, MERCURIZES]\n",
  "MERCURIZED": "MERCURIZE, to treat with mercury, also MERCURISE [v]\n",
  "MERCURIZES": "MERCURIZE, to treat with mercury, also MERCURISE [v]\n",
  "MERCURIZING": "MERCURIZE, to treat with mercury, also MERCURISE [v]\n",
  "MERCUROUS": "containing univalent mercury [adj]\n",
  "MERCURY": "a metallic element [n MERCURIES]\n",
  "MERCY": "compassion and clemency [n MERCIES]\n",
  "MERDE": "(vulgar French) excrement, used as an interjection [n -S]\n",
  "MERDES": "MERDE, (vulgar French) excrement, used as an interjection [n]\n",
  "MERDIVOROUS": "dung-eating [adj]\n",
  "MERE": "nothing more, nothing better [adj MERER, MEREST, MERELY] / to mark off, divide, also MEARE, MEER [v MERED, MERING, MERES]\n",
  "MERED": "MERE, to mark off, divide, also MEARE, MEER [v]\n",
  "MEREL": "a counter used in a game of merils, also MERELL, MERIL [n -S]\n",
  "MERELL": "a counter used in a game of merils, also MEREL, MERIL [n -S]\n",
  "MERELLS": "MERELL, a counter used in a game of merils, also MEREL, MERIL [n]\n",
  "MERELS": "MEREL, a counter used in a game of merils, also MERELL, MERIL [n]\n",
  "MERELY": "MERE, nothing more, nothing better [adv]\n",
  "MERENGUE": "(Spanish) a Caribbean ballroom dance in which feet are frequently dragged [n -S]\n",
  "MERENGUES": "MERENGUE, (Spanish) a Caribbean ballroom dance in which feet are frequently dragged [n]\n",
  "MEREOLOGICAL": "related to mereology, the formal study of the logical properties of the relation between part and whole [adj]\n",
  "MEREOLOGIES": "MEREOLOGY, the formal study of the logical properties of the relation between part and whole [n]\n",
  "MEREOLOGY": "the formal study of the logical properties of the relation between part and whole [n MEREOLOGIES]\n",
  "MERER": "MERE, nothing more, nothing better [adj]\n",
  "MERES": "MERE, to mark off, divide, also MEARE, MEER [v]\n",
  "MERESMAN": "a man appointed to ascertain boundaries [n MERESMEN]\n",
  "MERESMEN": "MERESMAN, a man appointed to ascertain boundaries [n]\n",
  "MEREST": "MERE, nothing more, nothing better [adj]\n",
  "MERESTONE": "a stone designating a limit or boundary; a landmark [n -S]\n",
  "MERESTONES": "MERESTONE, a stone designating a limit or boundary; a landmark [n]\n",
  "MERETRICIOUS": "superficially attractive but of no real merit [adj MERETRICIOUSLY]\n",
  "MERETRICIOUSLY": "MERETRICIOUS, superficially attractive but of no real merit [adv]\n",
  "MERFOLK": "mermen and mermaids [n -S]\n",
  "MERFOLKS": "MERFOLK, mermen and mermaids [n]\n",
  "MERGANSER": "an aquatic bird of a genus allied to the ducks [n -S]\n",
  "MERGANSERS": "MERGANSER, an aquatic bird of a genus allied to the ducks [n]\n",
  "MERGE": "to combine [v MERGED, MERGING, MERGES]\n",
  "MERGED": "MERGE, to combine [v]\n",
  "MERGEE": "a company acquired by a merger [n -S]\n",
  "MERGEES": "MERGEE, a company acquired by a merger [n]\n",
  "MERGENCE": "the act of merging [n -S]\n",
  "MERGENCES": "MERGENCE, the act of merging [n]\n",
  "MERGER": "the combining of two or more businesses into one [n -S]\n",
  "MERGERS": "MERGER, the combining of two or more businesses into one [n]\n",
  "MERGES": "MERGE, to combine [v]\n",
  "MERGING": "an act of merging [n -S]\n",
  "MERGINGS": "MERGING, an act of merging [n]\n",
  "MERGUEZ": "(Arabic) a spicy North African sausage [n MERGUEZ]\n",
  "MERI": "(Maori) a war-club [n -S]\n",
  "MERICARP": "one carpel of an umbelliferous fruit [n -S]\n",
  "MERICARPS": "MERICARP, one carpel of an umbelliferous fruit [n]\n",
  "MERIDIAN": "a line of longitude [n -S]\n",
  "MERIDIANS": "MERIDIAN, a line of longitude [n]\n",
  "MERIDIONAL": "of or pertaining to the meridian, a line of longitude [adj MERIDIONALLY] / a southerner [n -S]\n",
  "MERIDIONALITIES": "MERIDIONALITY, the state of being meridional, a southerner [n]\n",
  "MERIDIONALITY": "the state of being meridional, a southerner [n MERIDIONALITIES]\n",
  "MERIDIONALLY": "MERIDIONAL, of or pertaining to the meridian, a line of longitude [adv]\n",
  "MERIDIONALS": "MERIDIONAL, a southerner [n]\n",
  "MERIL": "a counter used in a game of merils, also MEREL, MERELL [n -S]\n",
  "MERILS": "MERIL, a counter used in a game of merils, also MEREL, MERELL [n]\n",
  "MERIMAKE": "(Spenser) merrymaking [n -S]\n",
  "MERIMAKES": "MERIMAKE, (Spenser) merrymaking [n]\n",
  "MERING": "a marking off [n -S]\n",
  "MERINGS": "MERING, a marking off [n]\n",
  "MERINGUE": "a topping for pies made of egg whites and sugar [n -S]\n",
  "MERINGUES": "MERINGUE, a topping for pies made of egg whites and sugar [n]\n",
  "MERINO": "(Spanish) a soft woollen or wool and cotton cloth [n -S]\n",
  "MERINOS": "MERINO, (Spanish) a soft woollen or wool and cotton cloth [n]\n",
  "MERIS": "MERI, (Maori) a war-club [n]\n",
  "MERISES": "MERISIS, (Greek) growth by cell division [n]\n",
  "MERISIS": "(Greek) growth by cell division [n MERISES]\n",
  "MERISM": "repetition of parts [n -S]\n",
  "MERISMS": "MERISM, repetition of parts [n]\n",
  "MERISTEM": "embryonic plant tissue capable of growth by division [n -S]\n",
  "MERISTEMATIC": "of or like a meristem [adj]\n",
  "MERISTEMS": "MERISTEM, embryonic plant tissue capable of growth by division [n]\n",
  "MERISTIC": "pertaining to the number or variation of body parts [adj MERISTICALLY]\n",
  "MERISTICALLY": "MERISTIC, pertaining to the number or variation of body parts [adv]\n",
  "MERIT": "to deserve [v -ED, -ING, -S]\n",
  "MERITED": "MERIT, to deserve [v]\n",
  "MERITING": "MERIT, to deserve [v]\n",
  "MERITLESS": "without merit [adj]\n",
  "MERITOCRACIES": "MERITOCRACY, government by the meritorious [n]\n",
  "MERITOCRACY": "government by the meritorious [n MERITOCRACIES]\n",
  "MERITOCRAT": "one who earns his position through merit [n -S]\n",
  "MERITOCRATIC": "relating to meritocracy [adj]\n",
  "MERITOCRATS": "MERITOCRAT, one who earns his position through merit [n]\n",
  "MERITORIOUS": "deserving of honor or esteem [adj MERITORIOUSLY]\n",
  "MERITORIOUSLY": "MERITORIOUS, deserving of honor or esteem [adv]\n",
  "MERITORIOUSNESS": "MERITORIOUS, deserving of honor or esteem [n]\n",
  "MERITS": "MERIT, to deserve [v]\n",
  "MERK": "an old Scotch silver coin [n -S]\n",
  "MERKIN": "a hairpiece for the pubic area [n -S]\n",
  "MERKINS": "MERKIN, a hairpiece for the pubic area [n]\n",
  "MERKS": "MERK, an old Scotch silver coin [n]\n",
  "MERL": "a blackbird, also MERLE [n -S]\n",
  "MERLE": "a blackbird, also MERL [n -S]\n",
  "MERLES": "MERLE, a blackbird, also MERL [n]\n",
  "MERLIN": "a species of small falcon [n -S]\n",
  "MERLING": "(obsolete) a fish, the whiting [n -S]\n",
  "MERLINGS": "MERLING, (obsolete) a fish, the whiting [n]\n",
  "MERLINS": "MERLIN, a species of small falcon [n]\n",
  "MERLON": "(French) the part of a parapet between embrasures [n -S]\n",
  "MERLONS": "MERLON, (French) the part of a parapet between embrasures [n]\n",
  "MERLOT": "(French) a red dry wine [n -S]\n",
  "MERLOTS": "MERLOT, (French) a red dry wine [n]\n",
  "MERLS": "MERL, a blackbird, also MERLE [n]\n",
  "MERMAID": "a mythical creature with a woman's upper body and a fish's tail, also MERMAIDEN [n -S]\n",
  "MERMAIDEN": "a mythical creature with a woman's upper body and a fish's tail, also MERMAID [n -S]\n",
  "MERMAIDENS": "MERMAIDEN, a mythical creature with a woman's upper body and a fish's tail, also MERMAID [n]\n",
  "MERMAIDS": "MERMAID, a mythical creature with a woman's upper body and a fish's tail, also MERMAIDEN [n]\n",
  "MERMAN": "a fabulous creature with a man's body and a fish's tail [n MERMEN]\n",
  "MERMEN": "MERMAN, a fabulous creature with a man's body and a fish's tail [n]\n",
  "MEROBLASTIC": "undergoing or involving cleavage in part of the egg surface only, due to a large amount of yolk elsewhere [adj MEROBLASTICALLY]\n",
  "MEROBLASTICALLY": "MEROBLASTIC, undergoing or involving cleavage in part of the egg surface only, due to a large amount of yolk elsewhere [adv]\n",
  "MEROCRINE": "designating a gland in which cytoplasm is not lost during secretion [adj]\n",
  "MEROGENESES": "MEROGENESIS, segmentation [n]\n",
  "MEROGENESIS": "segmentation [n MEROGENESES]\n",
  "MEROGENETIC": "relating to merogenesis [adj]\n",
  "MEROGONIES": "MEROGONY, the artificial production of an embryo [n]\n",
  "MEROGONY": "the artificial production of an embryo [n MEROGONIES]\n",
  "MEROISTIC": "applied to the ovaries of insects when they secrete vitelligenous cells, as well as ova [adj]\n",
  "MEROME": "one of the serial segments of which a body is composed, also MEROSOME [n -S]\n",
  "MEROMES": "MEROME, one of the serial segments of which a body is composed, also MEROSOME [n]\n",
  "MEROMORPHIC": "fractional [adj]\n",
  "MEROMYOSIN": "protein subunits of myosin molecule [n -S]\n",
  "MEROMYOSINS": "MEROMYOSIN, protein subunits of myosin molecule [n]\n",
  "MERONYM": "a word whose relation to another is that of a part to the whole, e.g. whisker to cat, sleeve to coat [n -S]\n",
  "MERONYMIES": "MERONYMY, the state of being a meronym, a word whose relation to another is that of a part to the whole [n]\n",
  "MERONYMS": "MERONYM, a word whose relation to another is that of a part to the whole, e.g. whisker to cat, sleeve to coat [n]\n",
  "MERONYMY": "the state of being a meronym, a word whose relation to another is that of a part to the whole [n MERONYMIES]\n",
  "MEROPIA": "partial blindness [n -S]\n",
  "MEROPIAS": "MEROPIA, partial blindness [n]\n",
  "MEROPIC": "relating to meropia, partial blindness [adj]\n",
  "MEROPIDAN": "one of a family of birds that includes bee-eaters [n -S]\n",
  "MEROPIDANS": "MEROPIDAN, one of a family of birds that includes bee-eaters [n]\n",
  "MEROPLANKTON": "plankton consisting of certain larvae that do not spend all their life as plankton [n -S]\n",
  "MEROPLANKTONS": "MEROPLANKTON, plankton consisting of certain larvae that do not spend all their life as plankton [n]\n",
  "MEROSOME": "one of the serial segments of which a body is composed, also MEROME [n -S]\n",
  "MEROSOMES": "MEROSOME, one of the serial segments of which a body is composed, also MEROME [n]\n",
  "MEROZOITE": "a young trophozoite resulting from the division of a schizont [n -S]\n",
  "MEROZOITES": "MEROZOITE, a young trophozoite resulting from the division of a schizont [n]\n",
  "MERPEOPLE": "mermaids and mermen [n -S]\n",
  "MERPEOPLES": "MERPEOPLE, mermaids and mermen [n]\n",
  "MERRIE": "(archaic) merry [adj]\n",
  "MERRIER": "MERRY, mirthful, also MERRIE [adj]\n",
  "MERRIES": "MERRY, a gean, a wild cherry [n]\n",
  "MERRIEST": "MERRY, mirthful, also MERRIE [adj]\n",
  "MERRILY": "MERRY, mirthful, also MERRIE [adv]\n",
  "MERRIMENT": "gaiety with laughter and noise [n -S]\n",
  "MERRIMENTS": "MERRIMENT, gaiety with laughter and noise [n]\n",
  "MERRINESS": "the state of being merry [n -ES]\n",
  "MERRINESSES": "MERRINESS, the state of being merry [n]\n",
  "MERRY": "mirthful, also MERRIE [adj MERRIER, MERRIEST, MERRILY] / a gean, a wild cherry [n MERRIES]\n",
  "MERRYMAKER": "a reveller [n -S]\n",
  "MERRYMAKERS": "MERRYMAKER, a reveller [n]\n",
  "MERRYMAKING": "gay or festive activity [n -S]\n",
  "MERRYMAKINGS": "MERRYMAKING, gay or festive activity [n]\n",
  "MERRYMAN": "a zany, a jester [n MERRYMEN]\n",
  "MERRYMEN": "MERRYMAN, a zany, a jester [n]\n",
  "MERRYTHOUGHT": "the furcula between the neck and breastbone of poultry, aka wishbone [n -S]\n",
  "MERRYTHOUGHTS": "MERRYTHOUGHT, the furcula between the neck and breastbone of poultry, aka wishbone [n]\n",
  "MERSALYL": "a sodium salt used as a diuretic [n -S]\n",
  "MERSALYLS": "MERSALYL, a sodium salt used as a diuretic [n]\n",
  "MERSE": "(Scots) a low flat marshland [n -S]\n",
  "MERSES": "MERSE, (Scots) a low flat marshland [n]\n",
  "MERSION": "(obsolete) dipping, as in baptism [n -S]\n",
  "MERSIONS": "MERSION, (obsolete) dipping, as in baptism [n]\n",
  "MERVEILLEUSE": "(French) a female merveilleux, a fashion extremist [n -S]\n",
  "MERVEILLEUSES": "MERVEILLEUSE, (French) a female merveilleux, a fashion extremist [n]\n",
  "MERVEILLEUX": "(French) a fashion extremist [n MERVEILLEUXES]\n",
  "MERVEILLEUXES": "MERVEILLEUX, (French) a fashion extremist [n]\n",
  "MERYCISM": "a rare condition in which food is returned to the mouth after a short period in the stomach [n -S]\n",
  "MERYCISMS": "MERYCISM, a rare condition in which food is returned to the mouth after a short period in the stomach [n]\n",
  "MES": "ME, the third note of the musical scale, also MI [n]\n",
  "MESA": "(Spanish) a flat-topped hill with steep sides [n -S]\n",
  "MESAIL": "a visor, esp. one made in two parts, also MEZAIL [n -S]\n",
  "MESAILS": "MESAIL, a visor, esp. one made in two parts, also MEZAIL [n]\n",
  "MESAL": "in or towards the median plane, also MESIAL, MESIAN [adj MESALLY]\n",
  "MESALLIANCE": "(French) a marriage with a person thought to be of inferior social position; an unsuitable union [n -S]\n",
  "MESALLIANCES": "MESALLIANCE, (French) a marriage with a person thought to be of inferior social position; an unsuitable union [n]\n",
  "MESALLY": "MESAL, in or towards the median plane, also MESIAL, MESIAN [adv]\n",
  "MESARAIC": "relating to the mesentery, also MESENTERIAL, MESENTERIC [adj]\n",
  "MESARCH": "originating in a mesic habitat [adj]\n",
  "MESAS": "MESA, (Spanish) a flat-topped hill with steep sides [n]\n",
  "MESATICEPHALIC": "intermediate between dolichocephalic and brachycephalic, also MESATICEPHALOUS [adj]\n",
  "MESATICEPHALIES": "MESATICEPHALY, the state of being mesaticephalic [n]\n",
  "MESATICEPHALOUS": "intermediate between dolichocephalic and brachycephalic, also MESATICEPHALIC [adj]\n",
  "MESATICEPHALY": "the state of being mesaticephalic [n MESATICEPHALIES]\n",
  "MESCAL": "(Nahuatl) a distilled liquor prepared in Mexico from a species of agave, also MEZCAL [n -S]\n",
  "MESCALIN": "the principal alkaloid in mescal, used as a hallucinogen, also MESCALINE, MEZCALINE [n -S]\n",
  "MESCALINE": "the principal alkaloid in mescal, used as a hallucinogen, also MESCALIN, MEZCALINE [n -S]\n",
  "MESCALINES": "MESCALINE, the principal alkaloid in mescal, used as a hallucinogen, also MESCALIN, MEZCALINE [n]\n",
  "MESCALINS": "MESCALIN, the principal alkaloid in mescal, used as a hallucinogen, also MESCALINE, MEZCALINE [n]\n",
  "MESCALISM": "the habitual use of mescalin as an intoxicant [n -S]\n",
  "MESCALISMS": "MESCALISM, the habitual use of mescalin as an intoxicant [n]\n",
  "MESCALS": "MESCAL, (Nahuatl) a distilled liquor prepared in Mexico from a species of agave, also MEZCAL [n]\n",
  "MESCLUM": "(French) a mixed salad of young leaves and shoots, e.g. of rocket, chicory, fennel etc., also MESCLUN [n -S]\n",
  "MESCLUMS": "MESCLUM, (French) a mixed salad of young leaves and shoots, e.g. of rocket, chicory, fennel etc., also MESCLUN [n]\n",
  "MESCLUN": "(French) a mixed salad of young leaves and shoots, e.g. of rocket, chicory, fennel etc., also MESCLUM [n -S]\n",
  "MESCLUNS": "MESCLUN, (French) a mixed salad of young leaves and shoots, e.g. of rocket, chicory, fennel etc., also MESCLUM [n]\n",
  "MESDAMES": "MADAME, (French) the French title of respect for a married woman [n]\n",
  "MESDEMOISELLES": "MADEMOISELLE, (French) a French title of respect for an unmarried woman [n]\n",
  "MESE": "(Greek) in Greek music, the middle string of the lyre; its note [n -S]\n",
  "MESEEMED": "MESEEMS, it seems to me [v]\n",
  "MESEEMETH": "MESEEMS, it seems to me [v]\n",
  "MESEEMS": "it seems to me [v MESEEMED, MESEEMETH]\n",
  "MESEL": "(obsolete) a leper, also MEAZEL [n -S]\n",
  "MESELED": "infected with leprosy [adj]\n",
  "MESELS": "MESEL, (obsolete) a leper, also MEAZEL [n]\n",
  "MESENCEPHALA": "MESENCEPHALON, the middle section of the embryonic brain [n]\n",
  "MESENCEPHALIC": "relating to the midbrain [adj]\n",
  "MESENCEPHALON": "the middle section of the embryonic brain [n MESENCEPHALA or MESENCEPHALONS]\n",
  "MESENCEPHALONS": "MESENCEPHALON, the middle section of the embryonic brain [n]\n",
  "MESENCHYMAL": "relating to mesenchyme, the embryonic tissue from which circulatory, lymphatic, skeletal, and connective tissue develop, also MESENCHYMATOUS [adj]\n",
  "MESENCHYMATOUS": "relating to mesenchyme, the embryonic tissue from which circulatory, lymphatic, skeletal, and connective tissue develop, also MESENCHYMAL [adj]\n",
  "MESENCHYME": "the embryonic tissue from which circulatory, lymphatic, skeletal, and connective tissue develop [n -S]\n",
  "MESENCHYMES": "MESENCHYME, the embryonic tissue from which circulatory, lymphatic, skeletal, and connective tissue develop [n]\n",
  "MESENTERA": "MESENTERON, the midgut [n]\n",
  "MESENTERIAL": "relating to the mesentery, also MESARAIC, MESENTERIC [adj]\n",
  "MESENTERIC": "relating to the mesentery, also MESARAIC, MESENTERIAL [adj]\n",
  "MESENTERIES": "MESENTERY, a membrane enclosing the intestines [n]\n",
  "MESENTERITIS": "inflammation of the mesenteron [n -ES]\n",
  "MESENTERITISES": "MESENTERITIS, inflammation of the mesenteron [n]\n",
  "MESENTERON": "the midgut [n MESENTERA]\n",
  "MESENTERONIC": "relating to the mesenteron, the midgut [adj]\n",
  "MESENTERY": "a membrane enclosing the intestines [n MESENTERIES]\n",
  "MESES": "MESE, (Greek) in Greek music, the middle string of the lyre; its note [n]\n",
  "MESETA": "(Spanish) a plateau, esp. that of central Spain [n -S]\n",
  "MESETAS": "MESETA, (Spanish) a plateau, esp. that of central Spain [n]\n",
  "MESH": "the opening between the threads of a net [n -ES] / to entangle [v -ED, -ING, -ES]\n",
  "MESHED": "MESH, to entangle [v]\n",
  "MESHES": "MESH, to entangle [v]\n",
  "MESHIER": "MESHY, formed like network [adj]\n",
  "MESHIEST": "MESHY, formed like network [adj]\n",
  "MESHING": "the act of meshing [n -S]\n",
  "MESHINGS": "MESHING, the act of meshing [n]\n",
  "MESHUGA": "(Yiddish) mad, crazy [adj] / a crazy person, also MESHUGAH, MESHUGGA, MESHUGGAH, MESHUGGE [n -S]\n",
  "MESHUGAAS": "(Yiddish) madness, foolishness, also MISHEGAAS, MISHEGOSS, MISHUGAS [n MESHUGAASEN or MESHUGASEN]\n",
  "MESHUGAASEN": "MESHUGAAS, (Yiddish) madness, foolishness, also MISHEGAAS, MISHEGOSS, MISHUGAS [n]\n",
  "MESHUGAH": "(Yiddish) crazy, also MESHUGA, MESHUGGA, MESHUGGAH, MESHUGGE [adj]\n",
  "MESHUGAS": "MESHUGA, a crazy person, also MESHUGAH, MESHUGGA, MESHUGGAH, MESHUGGE [n]\n",
  "MESHUGASEN": "MESHUGAAS, (Yiddish) madness, foolishness, also MISHEGAAS, MISHEGOSS, MISHUGAS [n]\n",
  "MESHUGGA": "(Yiddish) crazy, also MESHUGA, MESHUGAH, MESHUGGAH, MESHUGGE [adj]\n",
  "MESHUGGAH": "(Yiddish) mad, crazy, also MESHUGA, MESHUGAH, MESHUGGA, MESHUGGE [adj]\n",
  "MESHUGGE": "(Yiddish) crazy, also MESHUGA, MESHUGAH, MESHUGGAH, MESHUGGA [adj]\n",
  "MESHUGGENAH": "(Yiddish) a fool, a crazy person, also MESHUGGENEH, MESHUGGENER [n -S]\n",
  "MESHUGGENAHS": "MESHUGGENAH, (Yiddish) a fool, a crazy person, also MESHUGGENEH, MESHUGGENER [n]\n",
  "MESHUGGENEH": "(Yiddish) a fool, a crazy person, also MESHUGGENAH, MESHUGGENER [n -S]\n",
  "MESHUGGENEHS": "MESHUGGENEH, (Yiddish) a fool, a crazy person, also MESHUGGENAH, MESHUGGENER [n]\n",
  "MESHUGGENER": "(Yiddish) a fool, a crazy person, also MESHUGGENAH, MESHUGGENEH [n -S]\n",
  "MESHUGGENERS": "MESHUGGENER, (Yiddish) a fool, a crazy person, also MESHUGGENAH, MESHUGGENEH [n]\n",
  "MESHWORK": "a network [n -S]\n",
  "MESHWORKS": "MESHWORK, a network [n]\n",
  "MESHY": "formed like network [adj MESHIER, MESHIEST]\n",
  "MESIAD": "in biology, pertaining to the middle [adj]\n",
  "MESIAL": "situated in the middle, also MESAL, MESIAN [adj MESIALLY]\n",
  "MESIALLY": "MESIAL, situated in the middle, also MESAL, MESIAN [adv]\n",
  "MESIAN": "situated in the middle, also MESAL, MESIAL [adj]\n",
  "MESIC": "relating to a moderate supply of moisture [adj MESICALLY]\n",
  "MESICALLY": "MESIC, relating to a moderate supply of moisture [adv]\n",
  "MESITYLENE": "a colourless liquid that occurs in crude petroleum; 1,3,5-trimethylbenzene [n -S]\n",
  "MESITYLENES": "MESITYLENE, a colourless liquid that occurs in crude petroleum; 1,3,5-trimethylbenzene [n]\n",
  "MESMERIC": "pertaining to hypnotism [adj MESMERICALLY]\n",
  "MESMERICAL": "of, pertaining to, or induced by, mesmerism [adj]\n",
  "MESMERICALLY": "MESMERICAL, of, pertaining to, or induced by, mesmerism [adv]\n",
  "MESMERISATION": "the process of mesmerising, also MESMERIZATION [n -S]\n",
  "MESMERISATIONS": "MESMERISATION, the process of mesmerising, also MESMERIZATION [n]\n",
  "MESMERISE": "to hypnotize, spellbind, also MESMERIZE [v MESMERISED, MESMERISING, MESMERISES]\n",
  "MESMERISED": "MESMERISE, to hypnotize, spellbind, also MESMERIZE [v]\n",
  "MESMERISER": "one who mesmerises, also MESMERIZER [n -S]\n",
  "MESMERISERS": "MESMERISER, one who mesmerises, also MESMERIZER [n]\n",
  "MESMERISES": "MESMERISE, to hypnotize, spellbind, also MESMERIZE [v]\n",
  "MESMERISING": "MESMERISE, to hypnotize, spellbind, also MESMERIZE [v]\n",
  "MESMERISM": "a hypnotic state induced by the operator's imposition of his will on that of the patient [n -S]\n",
  "MESMERISMS": "MESMERISM, a hypnotic state induced by the operator's imposition of his will on that of the patient [n]\n",
  "MESMERIST": "one that practises mesmerism [n -S]\n",
  "MESMERISTS": "MESMERIST, one that practises mesmerism [n]\n",
  "MESMERIZATION": "the process of mesmerizing, also MESMERISATION [n -S]\n",
  "MESMERIZATIONS": "MESMERIZATION, the process of mesmerizing, also MESMERISATION [n]\n",
  "MESMERIZE": "to hypnotize, spellbind, also MESMERISE [v MESMERIZED, MESMERIZING, MESMERIZES]\n",
  "MESMERIZED": "MESMERIZE, to hypnotize, spellbind, also MESMERISE [v]\n",
  "MESMERIZER": "one who mesmerizes, also MESMERISER [n -S]\n",
  "MESMERIZERS": "MESMERIZER, one who mesmerizes, also MESMERISER [n]\n",
  "MESMERIZES": "MESMERIZE, to hypnotize, spellbind, also MESMERISE [v]\n",
  "MESMERIZING": "MESMERIZE, to hypnotize, spellbind, also MESMERISE [v]\n",
  "MESNALTIES": "MESNALTY, a type of feudal estate [n]\n",
  "MESNALTY": "a type of feudal estate [n MESNALTIES]\n",
  "MESNE": "middle; intervening; as, in mesne lord, a lord holding an estate from a superior feudal lord [adj] / a legal intermediate [n -S]\n",
  "MESNES": "MESNE, a legal intermediate [n]\n",
  "MESOAMERICAN": "relating to Central America [adj]\n",
  "MESOBENTHOS": "flora and fauna living at the bottom of seas 182 to 914 metres deep [n -ES]\n",
  "MESOBENTHOSES": "MESOBENTHOS, flora and fauna living at the bottom of seas 182 to 914 metres deep [n]\n",
  "MESOBLAST": "another name for the mesoderm, the middle germ layer of the embryo in early development [n -S]\n",
  "MESOBLASTIC": "like a mesoblast [adj]\n",
  "MESOBLASTS": "MESOBLAST, another name for the mesoderm, the middle germ layer of the embryo in early development [n]\n",
  "MESOCARP": "the middle layer of a pericarp [n -S]\n",
  "MESOCARPS": "MESOCARP, the middle layer of a pericarp [n]\n",
  "MESOCEPHALIC": "having a medium-sized skull [adj] / someone having a medium-sized skull [n -S]\n",
  "MESOCEPHALICS": "MESOCEPHALIC, someone having a medium-sized skull [n]\n",
  "MESOCEPHALIES": "MESOCEPHALY, having a medium skull, also MESOCEPHALISM [n]\n",
  "MESOCEPHALISM": "having a medium skull, also MESOCEPHALY [n -S]\n",
  "MESOCEPHALISMS": "MESOCEPHALISM, having a medium skull, also MESOCEPHALY [n]\n",
  "MESOCEPHALOUS": "having a medium skull [adj]\n",
  "MESOCEPHALY": "having a medium skull, also MESOCEPHALISM [n MESOCEPHALIES]\n",
  "MESOCRANIES": "MESOCRANY, medium skull breadth [n]\n",
  "MESOCRANY": "medium skull breadth [n MESOCRANIES]\n",
  "MESOCRATIC": "of igneous rocks, containing 30-60 per cent of ferromagnesian minerals [adj]\n",
  "MESOCYCLONE": "a rapidly rotating air mass within a thunderstorm that often gives rise to a tornado [n -S]\n",
  "MESOCYCLONES": "MESOCYCLONE, a rapidly rotating air mass within a thunderstorm that often gives rise to a tornado [n]\n",
  "MESODERM": "the middle germ layer of an embryo [n -S]\n",
  "MESODERMAL": "pertaining to, or derived from, the mesoderm, also MESODERMIC [adj]\n",
  "MESODERMIC": "pertaining to, or derived from, the mesoderm, also MESODERMAL [adj]\n",
  "MESODERMS": "MESODERM, the middle germ layer of an embryo [n]\n",
  "MESOGASTRIA": "MESOGASTRIUM, the mesentery supporting the embryonic stomach [n]\n",
  "MESOGASTRIC": "related to the mesogastrium [adj]\n",
  "MESOGASTRIUM": "the mesentery supporting the embryonic stomach [n MESOGASTRIA]\n",
  "MESOGLEA": "a gelatinous layer between the endoderm and ectoderm of a coelenterate, also MESOGLOEA [n -S]\n",
  "MESOGLEAL": "relating to the mesoglea [adj]\n",
  "MESOGLEAS": "MESOGLEA, a gelatinous layer between the endoderm and ectoderm of a coelenterate, also MESOGLOEA [n]\n",
  "MESOGLOEA": "a gelatinous layer between the endoderm and ectoderm of a coelenterate, also MESOGLEA [n -S]\n",
  "MESOGLOEAS": "MESOGLOEA, a gelatinous layer between the endoderm and ectoderm of a coelenterate, also MESOGLEA [n]\n",
  "MESOGNATHIES": "MESOGNATHY, the state of having slightly projecting jaws, also MESOGNATHISM [n]\n",
  "MESOGNATHISM": "the state of having slightly projecting jaws, also MESOGNATHY [n -S]\n",
  "MESOGNATHISMS": "MESOGNATHISM, the state of having slightly projecting jaws, also MESOGNATHY [n]\n",
  "MESOGNATHOUS": "having slightly projecting jaws [adj]\n",
  "MESOGNATHY": "the state of having slightly projecting jaws, also MESOGNATHISM [n MESOGNATHIES]\n",
  "MESOHIPPUS": "an extinct mammal of the Horse family [n -ES]\n",
  "MESOHIPPUSES": "MESOHIPPUS, an extinct mammal of the Horse family [n]\n",
  "MESOKURTIC": "in statistics, referring to a distribution showing a particular type of kurtosis [adj]\n",
  "MESOLITE": "a zeolitic mineral, a hydrous silicate of alumina, lime, and soda [n -S]\n",
  "MESOLITES": "MESOLITE, a zeolitic mineral, a hydrous silicate of alumina, lime, and soda [n]\n",
  "MESOMERE": "an embryonic segment [n -S]\n",
  "MESOMERES": "MESOMERE, an embryonic segment [n]\n",
  "MESOMERISM": "in chemistry, resonance, a type of tautomerism [n -S]\n",
  "MESOMERISMS": "MESOMERISM, in chemistry, resonance, a type of tautomerism [n]\n",
  "MESOMORPH": "a person of muscular body type [n -S]\n",
  "MESOMORPHIC": "being big-boned and muscular [adj]\n",
  "MESOMORPHIES": "MESOMORPHY, the state of being a mesomorph [n]\n",
  "MESOMORPHISM": "the state of being mesomorphic [n -S]\n",
  "MESOMORPHISMS": "MESOMORPHISM, the state of being mesomorphic [n]\n",
  "MESOMORPHOUS": "relating to a mesomorph [adj]\n",
  "MESOMORPHS": "MESOMORPH, a person of muscular body type [n]\n",
  "MESOMORPHY": "the state of being a mesomorph [n MESOMORPHIES]\n",
  "MESON": "a short-lived subatomic particle of smaller mass than a proton [n -S]\n",
  "MESONEPHRIC": "relating to the mesonephros [adj]\n",
  "MESONEPHROI": "MESONEPHROS, the second of the three segments of the embryonic kidney in vertebrates [n]\n",
  "MESONEPHROS": "the second of the three segments of the embryonic kidney in vertebrates [n MESONEPHROI or MESONEPHROSES]\n",
  "MESONEPHROSES": "MESONEPHROS, the second of the three segments of the embryonic kidney in vertebrates [n]\n",
  "MESONIC": "relating to the meson, a short-lived subatomic particle of smaller mass than a proton [adj]\n",
  "MESONS": "MESON, a short-lived subatomic particle of smaller mass than a proton [n]\n",
  "MESOPAUSE": "the upper limit of the atmosphere [n -S]\n",
  "MESOPAUSES": "MESOPAUSE, the upper limit of the atmosphere [n]\n",
  "MESOPELAGIC": "of or relating to oceanic depths from about 600 feet to 3000 feet [adj]\n",
  "MESOPHILE": "the ideal growth temperature of 20 to 45 degrees [n -S]\n",
  "MESOPHILES": "MESOPHILE, the ideal growth temperature of 20 to 45 degrees [n]\n",
  "MESOPHILIC": "esp. of bacteria, having an ideal growth temperature of 20-45 degrees [adj]\n",
  "MESOPHYL": "the soft tissue of a leaf [n -S]\n",
  "MESOPHYLL": "the photosynthetic tissue of a green plant borne beneath the epidermis, also MESOPHYL [n -S]\n",
  "MESOPHYLLIC": "of or like a mesophyll, also MESOPHYLLOUS [adj]\n",
  "MESOPHYLLOUS": "of or like a mesophyll, also MESOPHYLLIC [adj]\n",
  "MESOPHYLLS": "MESOPHYLL, the photosynthetic tissue of a green plant borne beneath the epidermis, also MESOPHYL [n]\n",
  "MESOPHYLS": "MESOPHYL, the soft tissue of a leaf [n]\n",
  "MESOPHYTE": "a land plant growing in an environment with moderate moisture [n -S]\n",
  "MESOPHYTES": "MESOPHYTE, a land plant growing in an environment with moderate moisture [n]\n",
  "MESOPHYTIC": "of a land plant, growing in an environment with moderate moisture [adj]\n",
  "MESOSAUR": "an extinct aquatic reptile [n -S]\n",
  "MESOSAURS": "MESOSAUR, an extinct aquatic reptile [n]\n",
  "MESOSCALE": "looking at or investigating a feature locally, such as within a town or a city block [adj]\n",
  "MESOSCAPHE": "a submersible bathing chamber for use at depths less than a bathyscaphe [n -S]\n",
  "MESOSCAPHES": "MESOSCAPHE, a submersible bathing chamber for use at depths less than a bathyscaphe [n]\n",
  "MESOSOME": "a convoluted invagination of the cell wall in some bacteria [n -S]\n",
  "MESOSOMES": "MESOSOME, a convoluted invagination of the cell wall in some bacteria [n]\n",
  "MESOSPHERE": "a zone in the Earth between 400 and 670 km below the surface separating the upper mantle from the lower mantle [n -S]\n",
  "MESOSPHERES": "MESOSPHERE, a zone in the Earth between 400 and 670 km below the surface separating the upper mantle from the lower mantle [n]\n",
  "MESOSPHERIC": "relating to the mesosphere [adj]\n",
  "MESOTHELIA": "MESOTHELIUM, squamous cells lining peritoneum, pericardium, and pleura [n]\n",
  "MESOTHELIAL": "of or like the mesothelium, squamous cells lining peritoneum, pericardium, and pleura [adj]\n",
  "MESOTHELIOMA": "a tumour of the mesothelia [n MESOTHELIOMAS or MESOTHELIOMATA]\n",
  "MESOTHELIOMAS": "MESOTHELIOMA, a tumour of the mesothelia [n]\n",
  "MESOTHELIOMATA": "MESOTHELIOMA, a tumour of the mesothelia [n]\n",
  "MESOTHELIUM": "squamous cells lining peritoneum, pericardium, and pleura [n MESOTHELIUMS or MESOTHELIA]\n",
  "MESOTHELIUMS": "MESOTHELIUM, squamous cells lining peritoneum, pericardium, and pleura [n]\n",
  "MESOTHERAPIES": "MESOTHERAPY, a type of cosmetic procedure involving the injection of minute doses of vitamins etc. under the skin [n]\n",
  "MESOTHERAPY": "a type of cosmetic procedure involving the injection of minute doses of vitamins etc. under the skin [n MESOTHERAPIES]\n",
  "MESOTHORACES": "MESOTHORAX, the middle segment of the thorax in insects [n]\n",
  "MESOTHORACIC": "of or relating to the mesothorax [adj]\n",
  "MESOTHORAX": "the middle segment of the thorax in insects [n MESOTHORACES or MESOTHORAXES]\n",
  "MESOTHORAXES": "MESOTHORAX, the middle segment of the thorax in insects [n]\n",
  "MESOTHORIUM": "an old name for either of two radioactive elements [n -S]\n",
  "MESOTHORIUMS": "MESOTHORIUM, an old name for either of two radioactive elements [n]\n",
  "MESOTRON": "a former name for the meson, a subatomic particle [n -S]\n",
  "MESOTRONS": "MESOTRON, a former name for the meson, a subatomic particle [n]\n",
  "MESOTROPHIC": "having a moderate amount of dissolved nutrients [adj]\n",
  "MESOZOAN": "any of a phylum of wormlike organisms [n -S]\n",
  "MESOZOANS": "MESOZOAN, any of a phylum of wormlike organisms [n]\n",
  "MESOZOIC": "of the Secondary geological period, including the Triassic, Jurassic, and Cretaceous systems [adj]\n",
  "MESPIL": "a North American tree that produces small white flowers in spring [n -S]\n",
  "MESPILS": "MESPIL, a North American tree that produces small white flowers in spring [n]\n",
  "MESPRISE": "(Spenser) scorn, slighting, also MESPRIZE [n -S]\n",
  "MESPRISES": "MESPRISE, (Spenser) scorn, slighting, also MESPRIZE [n]\n",
  "MESPRIZE": "(Spenser) scorn, slighting, also MESPRISE [n -S]\n",
  "MESPRIZES": "MESPRIZE, (Spenser) scorn, slighting, also MESPRISE [n]\n",
  "MESQUIN": "(French) mean, sordid, shabby, also MESQUINE [adj]\n",
  "MESQUINE": "(French) mean, sordid, shabby, also MESQUIN [adj]\n",
  "MESQUINERIE": "(French) the quality of being mesquin, mean [n -S]\n",
  "MESQUINERIES": "MESQUINERIE, (French) the quality of being mesquin, mean [n]\n",
  "MESQUIT": "(Nahuatl) a spiny tree or shrub of the southwestern part of North America, also MESQUITE, MEZQUIT, MEZQUITE, MUSKIT [n -S]\n",
  "MESQUITE": "(Nahuatl) a spiny tree or shrub of the southwestern part of North America, also MESQUIT, MEZQUIT, MEZQUITE, MUSKIT [n -S]\n",
  "MESQUITES": "MESQUITE, (Nahuatl) a spiny tree or shrub of the southwestern part of North America, also MESQUIT, MEZQUIT, MEZQUITE, MUSKIT [n]\n",
  "MESQUITS": "MESQUIT, (Nahuatl) a spiny tree or shrub of the southwestern part of North America, also MESQUITE, MEZQUIT, MEZQUITE, MUSKIT [n]\n",
  "MESS": "to make dirty or untidy [v -ED, -ING, -ES]\n",
  "MESSAGE": "to send a communication [v MESSAGED, MESSAGING, MESSAGES]\n",
  "MESSAGED": "MESSAGE, to send a communication [v]\n",
  "MESSAGES": "MESSAGE, to send a communication [v]\n",
  "MESSAGING": "the act of sending a message [n -S]\n",
  "MESSAGINGS": "MESSAGING, the act of sending a message [n]\n",
  "MESSALINE": "a soft lightweight silk with a satin weave [n -S]\n",
  "MESSALINES": "MESSALINE, a soft lightweight silk with a satin weave [n]\n",
  "MESSAN": "(Scots) a lapdog, a cur [n -S]\n",
  "MESSANS": "MESSAN, (Scots) a lapdog, a cur [n]\n",
  "MESSED": "MESS, to make dirty or untidy [v]\n",
  "MESSEIGNEURS": "MONSEIGNEUR, (French) a French title of respect given to princes and prelates [n]\n",
  "MESSENGER": "one who bears a message [n -S] / to send by messenger [v -ED, -ING, -S]\n",
  "MESSENGERED": "MESSENGER, to send by messenger [v]\n",
  "MESSENGERING": "MESSENGER, to send by messenger [v]\n",
  "MESSENGERS": "MESSENGER, to send by messenger [v]\n",
  "MESSES": "MESS, to make dirty or untidy [v]\n",
  "MESSIAH": "an expected liberator, also MESSIAS [n -S]\n",
  "MESSIAHS": "MESSIAH, an expected liberator, also MESSIAS [n]\n",
  "MESSIAHSHIP": "the state of being a messiah [n -S]\n",
  "MESSIAHSHIPS": "MESSIAHSHIP, the state of being a messiah [n]\n",
  "MESSIANIC": "inspired, or as though inspired, by a Messiah [adj MESSIANICALLY]\n",
  "MESSIANICALLY": "MESSIANIC, inspired, or as though inspired, by a Messiah [adv]\n",
  "MESSIANISM": "belief in a single messiah or saviour [n -S]\n",
  "MESSIANISMS": "MESSIANISM, belief in a single messiah or saviour [n]\n",
  "MESSIAS": "(Greek) an expected liberator, also MESSIAH [n -ES]\n",
  "MESSIASES": "MESSIAS, (Greek) an expected liberator, also MESSIAH [n]\n",
  "MESSIER": "MESSY, dirty or untidy [adj]\n",
  "MESSIEST": "MESSY, dirty or untidy [adj]\n",
  "MESSIEURS": "MONSIEUR, (French) a French title of courtesy for a man [n]\n",
  "MESSILY": "MESSY, dirty or untidy [adv]\n",
  "MESSINESS": "the state of being messy [n -ES]\n",
  "MESSINESSES": "MESSINESS, the state of being messy [n]\n",
  "MESSING": "MESS, to make dirty or untidy [v]\n",
  "MESSMAN": "a serviceman who works in a dining facility [n MESSMEN]\n",
  "MESSMATE": "a person with whom one eats regularly [n -S]\n",
  "MESSMATES": "MESSMATE, a person with whom one eats regularly [n]\n",
  "MESSMEN": "MESSMAN, a serviceman who works in a dining facility [n]\n",
  "MESSUAGE": "a dwelling house with its adjacent buildings and land [n -S]\n",
  "MESSUAGES": "MESSUAGE, a dwelling house with its adjacent buildings and land [n]\n",
  "MESSY": "dirty or untidy [adj MESSIER, MESSIEST, MESSILY]\n",
  "MESTEE": "in the West Indies, the offspring of a white person and a quadroon, aka octoroon, also MUSTEE [n -S]\n",
  "MESTEES": "MESTEE, in the West Indies, the offspring of a white person and a quadroon, aka octoroon, also MUSTEE [n]\n",
  "MESTER": "(dialect) master, head of the house [n -S]\n",
  "MESTERS": "MESTER, (dialect) master, head of the house [n]\n",
  "MESTESO": "(Spanish) a person of mixed ancestry, also MESTIZO, MESTINO [n -ES or -S]\n",
  "MESTESOES": "MESTESO, (Spanish) a person of mixed ancestry, also MESTIZO, MESTINO [n]\n",
  "MESTESOS": "MESTESO, (Spanish) a person of mixed ancestry, also MESTIZO, MESTINO [n]\n",
  "MESTINO": "(Spanish) a person of mixed ancestry, also MESTIZO, MESTESO [n -ES or -S]\n",
  "MESTINOES": "MESTINO, (Spanish) a person of mixed ancestry, also MESTIZO, MESTESO [n]\n",
  "MESTINOS": "MESTINO, (Spanish) a person of mixed ancestry, also MESTIZO, MESTESO [n]\n",
  "MESTIZA": "(Spanish) a (female) person of mixed, esp. Spanish and American-Indian parentage [n -S]\n",
  "MESTIZAS": "MESTIZA, (Spanish) a (female) person of mixed, esp. Spanish and American-Indian parentage [n]\n",
  "MESTIZO": "(Spanish) a (male) person of mixed, esp. Spanish and American-Indian parentage, also MESTESO, MESTINO [n -ES or -S]\n",
  "MESTIZOES": "MESTIZO, (Spanish) a (male) person of mixed, esp. Spanish and American-Indian parentage, also MESTESO, MESTINO [n]\n",
  "MESTIZOS": "MESTIZO, (Spanish) a (male) person of mixed, esp. Spanish and American-Indian parentage, also MESTESO, MESTINO [n]\n",
  "MESTO": "(Italian) in music, sad [adj]\n",
  "MESTOM": "biological conducting tissue, also MESTOME [n -S]\n",
  "MESTOME": "biological conducting tissue, also MESTOM [n -S]\n",
  "MESTOMES": "MESTOME, biological conducting tissue, also MESTOM [n]\n",
  "MESTOMS": "MESTOM, biological conducting tissue, also MESTOME [n]\n",
  "MESTRANOL": "a synthetic oestrogen used in oral contraceptives [n -S]\n",
  "MESTRANOLS": "MESTRANOL, a synthetic oestrogen used in oral contraceptives [n]\n",
  "MET": "(short for) meteorology [n -S]\n",
  "META": "(US) concerned with cultural conventions; (of an artistic work) self-referential [adj]\n",
  "METABASES": "METABASIS, a transition, e.g. from one subject or point to another [n]\n",
  "METABASIS": "a transition, e.g. from one subject or point to another [n METABASES]\n",
  "METABATIC": "transitional [adj]\n",
  "METABISULPHITE": "as in sodium metabisulphite, an inorganic compound [n -S]\n",
  "METABISULPHITES": "METABISULPHITE, as in sodium metabisulphite, an inorganic compound [n]\n",
  "METABOLIC": "relating to an organism's metabolism [adj METABOLICALLY]\n",
  "METABOLICALLY": "METABOLIC, relating to an organism's metabolism [adv]\n",
  "METABOLIES": "METABOLY, in biology, the capability of an organism to change shape [n]\n",
  "METABOLISABLE": "that can be metabolised, also METABOLIZABLE [adj]\n",
  "METABOLISE": "to change by a metabolic process, also METABOLIZE [v METABOLISED, METABOLISING, METABOLISES]\n",
  "METABOLISED": "METABOLISE, to change by a metabolic process, also METABOLIZE [v]\n",
  "METABOLISES": "METABOLISE, to change by a metabolic process, also METABOLIZE [v]\n",
  "METABOLISING": "METABOLISE, to change by a metabolic process, also METABOLIZE [v]\n",
  "METABOLISM": "the sum of the processes in the buildup and destruction of protoplasm [n -S]\n",
  "METABOLISMS": "METABOLISM, the sum of the processes in the buildup and destruction of protoplasm [n]\n",
  "METABOLITE": "a product of metabolism; a substance produced by metabolic action, as urea [n -S]\n",
  "METABOLITES": "METABOLITE, a product of metabolism; a substance produced by metabolic action, as urea [n]\n",
  "METABOLIZABLE": "capable of being metabolized, also METABOLISABLE [adj]\n",
  "METABOLIZE": "to change by a metabolic process, also METABOLISE [v METABOLIZED, METABOLIZING, METABOLIZES]\n",
  "METABOLIZED": "METABOLIZE, to change by a metabolic process, also METABOLISE [v]\n",
  "METABOLIZES": "METABOLIZE, to change by a metabolic process, also METABOLISE [v]\n",
  "METABOLIZING": "METABOLIZE, to change by a metabolic process, also METABOLISE [v]\n",
  "METABOLOME": "the quantitative complement of all the low molecular weight metabolites present in a particular physiological or developmental state [n -S]\n",
  "METABOLOMES": "METABOLOME, the quantitative complement of all the low molecular weight metabolites present in a particular physiological or developmental state [n]\n",
  "METABOLOMICS": "the study of the range of metabolites present in a person's body at normal times, and when suffering from specific diseases [n]\n",
  "METABOLY": "in biology, the capability of an organism to change shape [n METABOLIES]\n",
  "METABOTROPIC": "describing a neurotransmitter or cell receptor whose action is mediated by metabolic functions (e.g. enzyme activation) [adj]\n",
  "METACARPAL": "a bone of the metacarpus [n -S]\n",
  "METACARPALS": "METACARPAL, a bone of the metacarpus [n]\n",
  "METACARPI": "METACARPUS, that part of the skeleton of the hand or forefoot between the carpus and phalanges [n]\n",
  "METACARPUS": "that part of the skeleton of the hand or forefoot between the carpus and phalanges [n METACARPI]\n",
  "METACENTER": "a term in physics relating to centres of gravity of a body floating in liquid, also METACENTRE [n -S]\n",
  "METACENTERS": "METACENTER, a term in physics relating to centres of gravity of a body floating in liquid, also METACENTRE [n]\n",
  "METACENTRE": "a term in physics relating to centres of gravity of a body floating in liquid, also METACENTER [n -S]\n",
  "METACENTRES": "METACENTRE, a term in physics relating to centres of gravity of a body floating in liquid, also METACENTER [n]\n",
  "METACENTRIC": "a chromosome having the centromere approximately in the middle, such that the two arms are of similar length [n -S]\n",
  "METACENTRICS": "METACENTRIC, a chromosome having the centromere approximately in the middle, such that the two arms are of similar length [n]\n",
  "METACERCARIA": "a parasitic trematode in encysted form [n METACERCARIAE or METACERCARIAS]\n",
  "METACERCARIAE": "METACERCARIA, a parasitic trematode in encysted form [n]\n",
  "METACERCARIAL": "of or like a metacercaria [adj]\n",
  "METACERCARIAS": "METACERCARIA, a parasitic trematode in encysted form [n]\n",
  "METACHROMATIC": "of dyes, capable of staining cells so that they turn a different colour to that of the dye [adj]\n",
  "METACHROMATISM": "a change in colour, esp. when caused by a change in temperature [n -S]\n",
  "METACHROMATISMS": "METACHROMATISM, a change in colour, esp. when caused by a change in temperature [n]\n",
  "METACHRONISM": "an error of dating an event too late [n -S]\n",
  "METACHRONISMS": "METACHRONISM, an error of dating an event too late [n]\n",
  "METACHROSES": "METACHROSIS, the ability of animals to change colour [n]\n",
  "METACHROSIS": "the ability of animals to change colour [n METACHROSES]\n",
  "METACINNABARITE": "the black solid form of mercuric sulphide [n]\n",
  "METACOGNITION": "thinking about one's own mental processes [n -S]\n",
  "METACOGNITIONS": "METACOGNITION, thinking about one's own mental processes [n]\n",
  "METACOMPUTER": "a collection of computers that looks and functions like a single computer [n -S]\n",
  "METACOMPUTERS": "METACOMPUTER, a collection of computers that looks and functions like a single computer [n]\n",
  "METACOMPUTING": "computing that uses metacomputers [n -S]\n",
  "METACOMPUTINGS": "METACOMPUTING, computing that uses metacomputers [n]\n",
  "METADATA": "information about information already supplied, e.g. details about a site on the Internet [n -S]\n",
  "METADATAS": "METADATA, information about information already supplied, e.g. details about a site on the Internet [n]\n",
  "METAETHICAL": "relating to metaethics, the study of matters beyond ethics [adj]\n",
  "METAETHICS": "the study of matters beyond ethics [n]\n",
  "METAFEMALE": "a sterile female organism [n -S]\n",
  "METAFEMALES": "METAFEMALE, a sterile female organism [n]\n",
  "METAFICTION": "fiction which refers to or takes as its subject fictional writing and its conventions [n -S]\n",
  "METAFICTIONAL": "relating to metafiction [adj]\n",
  "METAFICTIONIST": "a writer of metafiction [n -S]\n",
  "METAFICTIONISTS": "METAFICTIONIST, a writer of metafiction [n]\n",
  "METAFICTIONS": "METAFICTION, fiction which refers to or takes as its subject fictional writing and its conventions [n]\n",
  "METAFILE": "graphical information capable of being transferred between systems or software [n -S]\n",
  "METAFILES": "METAFILE, graphical information capable of being transferred between systems or software [n]\n",
  "METAGALACTIC": "relating to a metagalaxy [adj]\n",
  "METAGALAXIES": "METAGALAXY, the whole universe considered as a system of galaxies; any system of galaxies [n]\n",
  "METAGALAXY": "the whole universe considered as a system of galaxies; any system of galaxies [n METAGALAXIES]\n",
  "METAGE": "an official weighing of coal, grain etc. [n -S]\n",
  "METAGENESES": "METAGENESIS, alternating gametophyte (sexual) and sporophyte (asexual) reproductive cycles [n]\n",
  "METAGENESIS": "alternating gametophyte (sexual) and sporophyte (asexual) reproductive cycles [n METAGENESES]\n",
  "METAGENETIC": "relating to metagenesis [adj METAGENETICALLY]\n",
  "METAGENETICALLY": "METAGENETIC, relating to metagenesis [adv]\n",
  "METAGENIC": "relating to metagenesis, the production within the life cycle of an organism of alternating asexual and sexual reproductive forms [adj]\n",
  "METAGES": "METAGE, an official weighing of coal, grain etc. [n]\n",
  "METAGNATHISM": "the state of being metagnathous, having a beak in which the tips of the mandibles cross [n -S]\n",
  "METAGNATHISMS": "METAGNATHISM, the state of being metagnathous, having a beak in which the tips of the mandibles cross [n]\n",
  "METAGNATHOUS": "having a beak in which the tips of the mandibles cross [adj]\n",
  "METAGRABOLISE": "to mystify, to puzzle out, also METAGRABOLIZE, METAGROBOLISE, METAGROBOLIZE [v METAGRABOLISED, METAGRABOLISING, METAGRABOLISES]\n",
  "METAGRABOLISED": "METAGRABOLISE, to mystify, to puzzle out, also METAGRABOLIZE, METAGROBOLISE, METAGROBOLIZE [v]\n",
  "METAGRABOLISES": "METAGRABOLISE, to mystify, to puzzle out, also METAGRABOLIZE, METAGROBOLISE, METAGROBOLIZE [v]\n",
  "METAGRABOLISING": "METAGRABOLISE, to mystify, to puzzle out, also METAGRABOLIZE, METAGROBOLISE, METAGROBOLIZE [v]\n",
  "METAGRABOLIZE": "to mystify, to puzzle out, also METAGRABOLISE, METAGROBOLISE, METAGROBOLIZE [v METAGRABOLIZED, METAGRABOLIZING, METAGRABOLIZES]\n",
  "METAGRABOLIZED": "METAGRABOLIZE, to mystify, to puzzle out, also METAGRABOLISE, METAGROBOLISE, METAGROBOLIZE [v]\n",
  "METAGRABOLIZES": "METAGRABOLIZE, to mystify, to puzzle out, also METAGRABOLISE, METAGROBOLISE, METAGROBOLIZE [v]\n",
  "METAGRABOLIZING": "METAGRABOLIZE, to mystify, to puzzle out, also METAGRABOLISE, METAGROBOLISE, METAGROBOLIZE [v]\n",
  "METAGROBOLISE": "to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLIZE [v METAGROBOLISED, METAGROBOLISING, METAGROBOLISES]\n",
  "METAGROBOLISED": "METAGROBOLISE, to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLIZE [v]\n",
  "METAGROBOLISES": "METAGROBOLISE, to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLIZE [v]\n",
  "METAGROBOLISING": "METAGROBOLISE, to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLIZE [v]\n",
  "METAGROBOLIZE": "to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLISE [v METAGROBOLIZED, METAGROBOLIZING, METAGROBOLIZES]\n",
  "METAGROBOLIZED": "METAGROBOLIZE, to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLISE [v]\n",
  "METAGROBOLIZES": "METAGROBOLIZE, to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLISE [v]\n",
  "METAGROBOLIZING": "METAGROBOLIZE, to mystify, to puzzle out, also METAGRABOLISE, METAGRABOLIZE, METAGROBOLISE [v]\n",
  "METAIRIE": "(French) a piece of land cultivated under the system of metayage [n -S]\n",
  "METAIRIES": "METAIRIE, (French) a piece of land cultivated under the system of metayage [n]\n",
  "METAL": "any of various elementary substances with particular properties made of metal [n -S] / made of metal [adj METALLY] / to cover with metal [v METALED or METALLED, METALING or METALLING, METALS]\n",
  "METALANGUAGE": "a language used to talk about language [n -S]\n",
  "METALANGUAGES": "METALANGUAGE, a language used to talk about language [n]\n",
  "METALDEHYDE": "a polymer of acetaldehyde [n -S]\n",
  "METALDEHYDES": "METALDEHYDE, a polymer of acetaldehyde [n]\n",
  "METALED": "METAL, to cover with metal [v]\n",
  "METALEPSES": "METALEPSIS, metonymy, esp. of a double, complicated, or indirect kind [n]\n",
  "METALEPSIS": "metonymy, esp. of a double, complicated, or indirect kind [n METALEPSES]\n",
  "METALEPTIC": "of or pertaining to a metalepsis, also METALEPTICAL [adj]\n",
  "METALEPTICAL": "of or pertaining to a metalepsis, also METALEPTIC [adj]\n",
  "METALHEAD": "a fan of heavy metal music [n -S]\n",
  "METALHEADS": "METALHEAD, a fan of heavy metal music [n]\n",
  "METALING": "METAL, to cover with metal [v]\n",
  "METALINGUISTIC": "of or relating to a metalanguage or to metalinguistics [adj]\n",
  "METALINGUISTICS": "the study of the relation between a language and other features of behaviour in a particular culture [n]\n",
  "METALISATION": "the act of metalising, also METALIZATION, METALLISATION, METALLIZATION [n -S]\n",
  "METALISATIONS": "METALISATION, the act of metalising, also METALIZATION, METALLISATION, METALLIZATION [n]\n",
  "METALISE": "to make or treat with metal, also METALIZE, METALLISE, METALLIZE [v METALISED, METALISING, METALISES]\n",
  "METALISED": "METALISE, to make or treat with metal, also METALIZE, METALLISE, METALLIZE [v]\n",
  "METALISES": "METALISE, to make or treat with metal, also METALIZE, METALLISE, METALLIZE [v]\n",
  "METALISING": "METALISE, to make or treat with metal, also METALIZE, METALLISE, METALLIZE [v]\n",
  "METALIST": "(US) a worker in metals, or one skilled in metals, also METALLIST [n -S]\n",
  "METALISTS": "METALIST, (US) a worker in metals, or one skilled in metals, also METALLIST [n]\n",
  "METALIZATION": "the act of metalizing, also METALISATION, METALLISATION, METALLIZATION [n -S]\n",
  "METALIZATIONS": "METALIZATION, the act of metalizing, also METALISATION, METALLISATION, METALLIZATION [n]\n",
  "METALIZE": "to make or treat with metal, also METALISE, METALLISE, METALLIZE [v METALIZED, METALIZING, METALIZES]\n",
  "METALIZED": "METALIZE, to make or treat with metal, also METALISE, METALLISE, METALLIZE [v]\n",
  "METALIZES": "METALIZE, to make or treat with metal, also METALISE, METALLISE, METALLIZE [v]\n",
  "METALIZING": "METALIZE, to make or treat with metal, also METALISE, METALLISE, METALLIZE [v]\n",
  "METALLED": "METAL, to cover with metal [v]\n",
  "METALLIC": "of or like metal [adj METALLICALLY] / a fabric made or coated with metal [n -S]\n",
  "METALLICALLY": "METALLIC, of or like metal [adv]\n",
  "METALLICS": "METALLIC, a fabric made or coated with metal [n]\n",
  "METALLIDING": "a high-temperature electrolytic technique for creating metal alloys on the surface of metals [n -S]\n",
  "METALLIDINGS": "METALLIDING, a high-temperature electrolytic technique for creating metal alloys on the surface of metals [n]\n",
  "METALLIFEROUS": "bearing metal [adj]\n",
  "METALLIKE": "like metal [adj]\n",
  "METALLINE": "of, like, consisting of, or mixed with, metal [adj]\n",
  "METALLING": "road metal, broken stones [n -S]\n",
  "METALLINGS": "METALLING, road metal, broken stones [n]\n",
  "METALLISATION": "the act of making metallic, also METALISATION, METALIZATION, METALLIZATION [n -S]\n",
  "METALLISATIONS": "METALLISATION, the act of making metallic, also METALISATION, METALIZATION, METALLIZATION [n]\n",
  "METALLISE": "to make or treat with metal, also METALISE, METALIZE, METALLIZE [v METALLISED, METALLISING, METALLISES]\n",
  "METALLISED": "METALLISE, to make or treat with metal, also METALISE, METALIZE, METALLIZE [v]\n",
  "METALLISES": "METALLISE, to make or treat with metal, also METALISE, METALIZE, METALLIZE [v]\n",
  "METALLISING": "METALLISE, to make or treat with metal, also METALISE, METALIZE, METALLIZE [v]\n",
  "METALLIST": "a worker in metals, or one skilled in metals, also METALIST [n -S]\n",
  "METALLISTS": "METALLIST, a worker in metals, or one skilled in metals, also METALIST [n]\n",
  "METALLIZATION": "the act of making metallic, also METALISATION, METALIZATION, METALLISATION [n -S]\n",
  "METALLIZATIONS": "METALLIZATION, the act of making metallic, also METALISATION, METALIZATION, METALLISATION [n]\n",
  "METALLIZE": "to make or treat with metal, also METALISE, METALIZE, METALLISE [v METALLIZED, METALLIZING, METALLIZES]\n",
  "METALLIZED": "METALLIZE, to make or treat with metal, also METALISE, METALIZE, METALLISE [v]\n",
  "METALLIZES": "METALLIZE, to make or treat with metal, also METALISE, METALIZE, METALLISE [v]\n",
  "METALLIZING": "METALLIZE, to make or treat with metal, also METALISE, METALIZE, METALLISE [v]\n",
  "METALLOCENE": "any one of a class of organometallic sandwich compounds [n -S]\n",
  "METALLOCENES": "METALLOCENE, any one of a class of organometallic sandwich compounds [n]\n",
  "METALLOGENETIC": "relating to metallogeny, the study of the origin and distribution of metal deposits [adj]\n",
  "METALLOGENIC": "of an element, occurring as an ore or a naturally occurring metal, as opposed to in rocks [adj]\n",
  "METALLOGENIES": "METALLOGENY, the study of the origin and distribution of metal deposits [n]\n",
  "METALLOGENY": "the study of the origin and distribution of metal deposits [n METALLOGENIES]\n",
  "METALLOGRAPHER": "one who practises metallography [n -S]\n",
  "METALLOGRAPHERS": "METALLOGRAPHER, one who practises metallography [n]\n",
  "METALLOGRAPHIC": "relating to metallography [adj]\n",
  "METALLOGRAPHIES": "METALLOGRAPHY, the study of the structure and constitution of metals [n]\n",
  "METALLOGRAPHIST": "one who practises metallography [n]\n",
  "METALLOGRAPHY": "the study of the structure and constitution of metals [n METALLOGRAPHIES]\n",
  "METALLOID": "an element intermediate in its properties between a typical metal and a typical nonmetal (e.g. boron, silicon, germanium) [n -S]\n",
  "METALLOIDAL": "intermediate in its properties between a typical metal and a typical nonmetal [adj]\n",
  "METALLOIDS": "METALLOID, an element intermediate in its properties between a typical metal and a typical nonmetal (e.g. boron, silicon, germanium) [n]\n",
  "METALLOPHONE": "an instrument like a xylophone with metal bars, the hammers being operated by hand or by means of a keyboard [n -S]\n",
  "METALLOPHONES": "METALLOPHONE, an instrument like a xylophone with metal bars, the hammers being operated by hand or by means of a keyboard [n]\n",
  "METALLURGIC": "relating to metallurgy, also METALLURGICAL [adj METALLURGICALLY]\n",
  "METALLURGICAL": "relating to metallurgy, also METALLURGIC [adj METALLURGICALLY]\n",
  "METALLURGICALLY": "METALLURGICAL, relating to metallurgy, also METALLURGIC [adv]\n",
  "METALLURGIES": "METALLURGY, the study of alloying and treating metals [n]\n",
  "METALLURGIST": "a practitioner of metallurgy [n -S]\n",
  "METALLURGISTS": "METALLURGIST, a practitioner of metallurgy [n]\n",
  "METALLURGY": "the study of alloying and treating metals [n METALLURGIES]\n",
  "METALLY": "METAL, made of metal [adj]\n",
  "METALMARK": "one of a family of tropical butterflies [n -S]\n",
  "METALMARKS": "METALMARK, one of a family of tropical butterflies [n]\n",
  "METALS": "METAL, to cover with metal [v]\n",
  "METALSMITH": "a smith working in metal [n -S]\n",
  "METALSMITHS": "METALSMITH, a smith working in metal [n]\n",
  "METALWARE": "goods made of metal [n -S]\n",
  "METALWARES": "METALWARE, goods made of metal [n]\n",
  "METALWORK": "work in metal [n -S]\n",
  "METALWORKER": "one who works in metal [n -S]\n",
  "METALWORKERS": "METALWORKER, one who works in metal [n]\n",
  "METALWORKING": "the process of working in metal [n -S]\n",
  "METALWORKINGS": "METALWORKING, the process of working in metal [n]\n",
  "METALWORKS": "METALWORK, work in metal [n]\n",
  "METAMALE": "a sterile male organism [n -S]\n",
  "METAMALES": "METAMALE, a sterile male organism [n]\n",
  "METAMATERIAL": "any artificial material created from microscopic arrangements of existing elements in a structure which gives the material unconventional properties, esp. when used for cloaking light or sound waves [n -S]\n",
  "METAMATERIALS": "METAMATERIAL, any artificial material created from microscopic arrangements of existing elements in a structure which gives the material unconventional properties, esp. when used for cloaking light or sound waves [n]\n",
  "METAMATHEMATICS": "a field of study concerned with the formal structure and properties (as the consistency and completeness of axioms) of mathematical systems [n]\n",
  "METAMER": "a compound metameric with another [n -S]\n",
  "METAMERAL": "relating to a metamere, a serial division or segmentation of a body, also METAMERIC [adj]\n",
  "METAMERE": "one of the similar body segments into which earthworms, crayfish, and similar animals are divided longitudinally [n -S]\n",
  "METAMERES": "METAMERE, one of the similar body segments into which earthworms, crayfish, and similar animals are divided longitudinally [n]\n",
  "METAMERIC": "relating to a metamere, a serial division or segmentation of a body, also METAMERAL [adj METAMERICALLY]\n",
  "METAMERICALLY": "METAMERIC, relating to a metamere, a serial division or segmentation of a body, also METAMERAL [adv]\n",
  "METAMERISM": "a particular form of isomerism in which different groups are attached to the same central atom [n -S]\n",
  "METAMERISMS": "METAMERISM, a particular form of isomerism in which different groups are attached to the same central atom [n]\n",
  "METAMERS": "METAMER, a compound metameric with another [n]\n",
  "METAMICT": "of or denoting the amorphous state of a substance that has lost its crystalline structure as a result of the radioactivity of uranium or thorium within it [adj]\n",
  "METAMICTISATION": "the process of becoming metamict, also METAMICTIZATION [n]\n",
  "METAMICTIZATION": "the process of becoming metamict, also METAMICTISATION [n]\n",
  "METAMORPHIC": "showing or relating to change of form [adj METAMORPHICALLY]\n",
  "METAMORPHICALLY": "METAMORPHIC, showing or relating to change of form [adv]\n",
  "METAMORPHISM": "the processes of recrystallization, textural and mineralogical change that take place in the solid state under conditions beyond those normally encountered during diagenesis [n -S]\n",
  "METAMORPHISMS": "METAMORPHISM, the processes of recrystallization, textural and mineralogical change that take place in the solid state under conditions beyond those normally encountered during diagenesis [n]\n",
  "METAMORPHIST": "a person who believes that Christ's body merged into the Deity at the Ascension [n -S]\n",
  "METAMORPHISTS": "METAMORPHIST, a person who believes that Christ's body merged into the Deity at the Ascension [n]\n",
  "METAMORPHOSE": "to change into a different physical form esp. by supernatural means [v METAMORPHOSED, METAMORPHOSING, METAMORPHOSES]\n",
  "METAMORPHOSED": "METAMORPHOSE, to change into a different physical form esp. by supernatural means [v]\n",
  "METAMORPHOSES": "METAMORPHOSE, to change into a different physical form esp. by supernatural means [v]\n",
  "METAMORPHOSING": "METAMORPHOSE, to change into a different physical form esp. by supernatural means [v]\n",
  "METAMORPHOSIS": "a process of developmental change in insects whereby a larva reaches adulthood only after a radical change in morphology, often involving a pupa stage [n]\n",
  "METAMORPHOUS": "of or relating to metamorphosis (especially of rocks) [adj]\n",
  "METANALYSES": "METANALYSIS, incorrect placement of 'n' at the start of a word following an indefinite article [n]\n",
  "METANALYSIS": "incorrect placement of 'n' at the start of a word following an indefinite article [n METANALYSES]\n",
  "METANARRATIVE": "(in postmodernist literary theory) a narrative about a narrative or narratives [n -S]\n",
  "METANARRATIVES": "METANARRATIVE, (in postmodernist literary theory) a narrative about a narrative or narratives [n]\n",
  "METANEPHRIC": "relating to the metanephros, the third of the three segments of the embryonic kidney in vertebrates [adj]\n",
  "METANEPHROI": "METANEPHROS, the third of the three segments of the embryonic kidney in vertebrates [n]\n",
  "METANEPHROS": "the third of the three segments of the embryonic kidney in vertebrates [n METANEPHROI]\n",
  "METANOIA": "penitence; spiritual conversion [n -S]\n",
  "METANOIAS": "METANOIA, penitence; spiritual conversion [n]\n",
  "METAPELET": "(Hebrew) a woman acting as foster mother in a kibbutz [n METAPLOT]\n",
  "METAPERIODIC": "as in metaperiodic acid [adj]\n",
  "METAPHASE": "the stage of mitotic or meiotic nuclear division when the chromosomes become attached to the spindle fibres [n -S]\n",
  "METAPHASES": "METAPHASE, the stage of mitotic or meiotic nuclear division when the chromosomes become attached to the spindle fibres [n]\n",
  "METAPHOR": "implied comparison achieved through a figurative use of words [n -S]\n",
  "METAPHORIC": "related to metaphor, also METAPHORICAL [adj METAPHORICALLY]\n",
  "METAPHORICAL": "related to metaphor, also METAPHORIC [adj METAPHORICALLY]\n",
  "METAPHORICALLY": "METAPHORICAL, related to metaphor, also METAPHORIC [adv]\n",
  "METAPHORIST": "one who uses metaphors [n -S]\n",
  "METAPHORISTS": "METAPHORIST, one who uses metaphors [n]\n",
  "METAPHORS": "METAPHOR, implied comparison achieved through a figurative use of words [n]\n",
  "METAPHOSPHATE": "a salt or ester of a metaphosphoric acid [n -S]\n",
  "METAPHOSPHATES": "METAPHOSPHATE, a salt or ester of a metaphosphoric acid [n]\n",
  "METAPHOSPHORIC": "applied to an acid (HPO3) containing a molecule less of water than orthophosphoric acid [adj]\n",
  "METAPHRASE": "the turning of prose into verse or vice versa [n -S] / to turn prose into verse or vice versa [v METAPHRASED, METAPHRASING, METAPHRASES]\n",
  "METAPHRASED": "METAPHRASE, to turn prose into verse or vice versa [v]\n",
  "METAPHRASES": "METAPHRASE, the turning of prose into verse or vice versa [n]\n",
  "METAPHRASING": "METAPHRASE, to turn prose into verse or vice versa [v]\n",
  "METAPHRASIS": "a turning of prose into verse, or verse into prose [n METAPHRASES]\n",
  "METAPHRAST": "one who produces a metaphrase [n -S]\n",
  "METAPHRASTIC": "related to metaphrasis, also METAPHRASTICAL [adj]\n",
  "METAPHRASTICAL": "related to metaphrasis, also METAPHRASTIC [adj]\n",
  "METAPHRASTS": "METAPHRAST, one who produces a metaphrase [n]\n",
  "METAPHYSIC": "(relating to) the branch of philosophy which investigates the first principles of nature and thought [n -S]\n",
  "METAPHYSICAL": "of or relating to metaphysicist, also METAPHYSIC [adj METAPHYSICALLY]\n",
  "METAPHYSICALLY": "METAPHYSICAL, of or relating to metaphysicist, also METAPHYSIC [adv]\n",
  "METAPHYSICIAN": "a student of or specialist in metaphysics [n -S]\n",
  "METAPHYSICIANS": "METAPHYSICIAN, a student of or specialist in metaphysics [n]\n",
  "METAPHYSICISE": "to make metaphysical, also METAPHYSICIZE [v METAPHYSICISED, METAPHYSICISING, METAPHYSICISES]\n",
  "METAPHYSICISED": "METAPHYSICISE, to make metaphysical, also METAPHYSICIZE [v]\n",
  "METAPHYSICISES": "METAPHYSICISE, to make metaphysical, also METAPHYSICIZE [v]\n",
  "METAPHYSICISING": "METAPHYSICISE, to make metaphysical, also METAPHYSICIZE [v]\n",
  "METAPHYSICIST": "one who practises metaphysics [n -S]\n",
  "METAPHYSICISTS": "METAPHYSICIST, one who practises metaphysics [n]\n",
  "METAPHYSICIZE": "to make metaphysical, also METAPHYSICISE [v METAPHYSICIZED, METAPHYSICIZING, METAPHYSICIZES]\n",
  "METAPHYSICIZED": "METAPHYSICIZE, to make metaphysical, also METAPHYSICISE [v]\n",
  "METAPHYSICIZES": "METAPHYSICIZE, to make metaphysical, also METAPHYSICISE [v]\n",
  "METAPHYSICIZING": "METAPHYSICIZE, to make metaphysical, also METAPHYSICISE [v]\n",
  "METAPHYSICS": "the study of the principles of nature and thought [n]\n",
  "METAPLASES": "METAPLASIS, the change of one kind of tissue into another, also METAPLASIA [n]\n",
  "METAPLASIA": "the change of one kind of tissue into another, also METAPLASIS [n -S]\n",
  "METAPLASIAS": "METAPLASIA, the change of one kind of tissue into another, also METAPLASIS [n]\n",
  "METAPLASIS": "the change of one kind of tissue into another, also METAPLASIA [n METAPLASES]\n",
  "METAPLASM": "the alteration of a word by adding, subtracting, or transposing letters or syllables e.g. saying 'relator' for 'realtor' [n -S]\n",
  "METAPLASMIC": "relating to metaplasm, also METAPLASTIC [adj]\n",
  "METAPLASMS": "METAPLASM, the alteration of a word by adding, subtracting, or transposing letters or syllables e.g. saying 'relator' for 'realtor' [n]\n",
  "METAPLASTIC": "relating to metaplasm, also METAPLASMIC [adj]\n",
  "METAPLOT": "METAPELET, (Hebrew) a woman acting as foster mother in a kibbutz [n]\n",
  "METAPOLITICAL": "relating to metapolitics [adj]\n",
  "METAPOLITICS": "the politics of politics, a method of analysing political ideologies from the viewpoint of other political ideologies [n]\n",
  "METAPROTEIN": "a protein denatured by acid or alkaline hydrolysis that is soluble in acids or alkalis but insoluble in water [n -S]\n",
  "METAPROTEINS": "METAPROTEIN, a protein denatured by acid or alkaline hydrolysis that is soluble in acids or alkalis but insoluble in water [n]\n",
  "METAPSYCHIC": "relating to metapsychics, the study of psychic phenomena beyond the limits of ordinary or orthodox psychology, also METAPSYCHICAL [adj]\n",
  "METAPSYCHICAL": "relating to metapsychics, the study of psychic phenomena beyond the limits of ordinary or orthodox psychology, also METAPSYCHIC [adj]\n",
  "METAPSYCHICS": "the study of psychic phenomena beyond the limits of ordinary or orthodox psychology [n]\n",
  "METAPSYCHOLOGY": "speculation on the origin, structure and function of the mind [n]\n",
  "METARCHON": "a nontoxic substance, such as a chemical to mask pheromones, that reduces the persistence of a pest [n -S]\n",
  "METARCHONS": "METARCHON, a nontoxic substance, such as a chemical to mask pheromones, that reduces the persistence of a pest [n]\n",
  "METASEQUOIA": "a tree, the dawn redwood [n -S]\n",
  "METASEQUOIAS": "METASEQUOIA, a tree, the dawn redwood [n]\n",
  "METASILICATE": "a salt of metasilicic acid [n -S]\n",
  "METASILICATES": "METASILICATE, a salt of metasilicic acid [n]\n",
  "METASILICIC": "applied to an acid (H2SiO3) [adj]\n",
  "METASOMA": "the posterior part of an arachnid's abdomen [n METASOMATA or METASOMAS]\n",
  "METASOMAS": "METASOMA, the posterior part of an arachnid's abdomen [n]\n",
  "METASOMATA": "METASOMA, the posterior part of an arachnid's abdomen [n]\n",
  "METASOMATIC": "relating to metasomatism [adj]\n",
  "METASOMATISM": "metamorphism caused chiefly by introduction of fluids and/or ions [n -S]\n",
  "METASOMATISMS": "METASOMATISM, metamorphism caused chiefly by introduction of fluids and/or ions [n]\n",
  "METASOMATOSES": "METASOMATOSIS, change in the composition of a rock or mineral by the addition or replacement of chemicals [n]\n",
  "METASOMATOSIS": "change in the composition of a rock or mineral by the addition or replacement of chemicals [n METASOMATOSES]\n",
  "METASTABILITIES": "METASTABILITY, the state of being metastable [n]\n",
  "METASTABILITY": "the state of being metastable [n METASTABILITIES]\n",
  "METASTABLE": "chemically stable [adj METASTABLY] / a metastable compound [n -S]\n",
  "METASTABLES": "METASTABLE, a metastable compound [n]\n",
  "METASTABLY": "METASTABLE, chemically stable [adv]\n",
  "METASTASES": "METASTASIS, the transfer of disease from its original site to another part of the body [n]\n",
  "METASTASIS": "the transfer of disease from its original site to another part of the body [n METASTASES]\n",
  "METASTASISE": "to spread or grow by or as if by metastasis, also METASTASIZE [v METASTASISED, METASTASISING, METASTASISES]\n",
  "METASTASISED": "METASTASISE, to spread or grow by or as if by metastasis, also METASTASIZE [v]\n",
  "METASTASISES": "METASTASISE, to spread or grow by or as if by metastasis, also METASTASIZE [v]\n",
  "METASTASISING": "METASTASISE, to spread or grow by or as if by metastasis, also METASTASIZE [v]\n",
  "METASTASIZE": "to spread or grow by or as if by metastasis, also METASTASISE [v METASTASIZED, METASTASIZING, METASTASIZES]\n",
  "METASTASIZED": "METASTASIZE, to spread or grow by or as if by metastasis, also METASTASISE [v]\n",
  "METASTASIZES": "METASTASIZE, to spread or grow by or as if by metastasis, also METASTASISE [v]\n",
  "METASTASIZING": "METASTASIZE, to spread or grow by or as if by metastasis, also METASTASISE [v]\n",
  "METASTATIC": "of, pertaining to, or caused by, metastasis [adj METASTATICALLY]\n",
  "METASTATICALLY": "METASTATIC, of, pertaining to, or caused by, metastasis [adv]\n",
  "METATAG": "a tag having information about a webpage [n -S]\n",
  "METATAGS": "METATAG, a tag having information about a webpage [n]\n",
  "METATARSAL": "a bone of the metatarsus [n -S]\n",
  "METATARSALS": "METATARSAL, a bone of the metatarsus [n]\n",
  "METATARSI": "METATARSUS, that part of the skeleton of the hind or lower limb between the tarsus and the phalanges [n]\n",
  "METATARSUS": "that part of the skeleton of the hind or lower limb between the tarsus and the phalanges [n METATARSI]\n",
  "METATE": "(Nahuatl) in Mexico etc., a stone with a concave surface used in conjunction with a mano for grinding maize [n -S]\n",
  "METATES": "METATE, (Nahuatl) in Mexico etc., a stone with a concave surface used in conjunction with a mano for grinding maize [n]\n",
  "METATHEORETICAL": "relating to metatheory [adj]\n",
  "METATHEORIES": "METATHEORY, philosophical discussion of the foundations, structure, or results of some theory, such as metamathematics [n]\n",
  "METATHEORY": "philosophical discussion of the foundations, structure, or results of some theory, such as metamathematics [n METATHEORIES]\n",
  "METATHERIAN": "of, relating to, or belonging to the Metatheria, a subclass of mammals comprising the marsupials [adj] / any metatherian mammal; a marsupial [n -S]\n",
  "METATHERIANS": "METATHERIAN, any metatherian mammal; a marsupial [n]\n",
  "METATHESES": "METATHESIS, the transposition within a word of letters, sounds, or syllables, as in the change from Old English brid to modern English bird or in the confusion of modren for modern [n]\n",
  "METATHESIS": "the transposition within a word of letters, sounds, or syllables, as in the change from Old English brid to modern English bird or in the confusion of modren for modern [n METATHESES]\n",
  "METATHESISE": "to transpose by metathesis, metathesize [v METATHESISED, METATHESISING, METATHESISES]\n",
  "METATHESISED": "METATHESISE, to transpose by metathesis, metathesize [v]\n",
  "METATHESISES": "METATHESISE, to transpose by metathesis, metathesize [v]\n",
  "METATHESISING": "METATHESISE, to transpose by metathesis, metathesize [v]\n",
  "METATHESIZE": "to transpose by metathesis, also METATHESISE [v METATHESIZED, METATHESIZING, METATHESIZES]\n",
  "METATHESIZED": "METATHESIZE, to transpose by metathesis, also METATHESISE [v]\n",
  "METATHESIZES": "METATHESIZE, to transpose by metathesis, also METATHESISE [v]\n",
  "METATHESIZING": "METATHESIZE, to transpose by metathesis, also METATHESISE [v]\n",
  "METATHETIC": "relating to metathesis, also METATHETICAL [adj METATHETICALLY]\n",
  "METATHETICAL": "relating to metathesis, also METATHETIC [adj METATHETICALLY]\n",
  "METATHETICALLY": "METATHETICAL, relating to metathesis, also METATHETIC [adv]\n",
  "METATHORACES": "METATHORAX, the last or posterior segment of the thorax in insects [n]\n",
  "METATHORACIC": "relating to the metathorax [adj]\n",
  "METATHORAX": "the last or posterior segment of the thorax in insects [n METATHORACES or METATHORAXES]\n",
  "METATHORAXES": "METATHORAX, the last or posterior segment of the thorax in insects [n]\n",
  "METATUNGSTIC": "as in metatungstic acid, an acid of tungsten [adj]\n",
  "METAVANADIC": "as in metavanadic acid, an acid of vanadium [adj]\n",
  "METAVERSE": "a 3-D virtual world, esp. in an online role-playing game; the universe as portrayed in a given work of fiction [n -S]\n",
  "METAVERSES": "METAVERSE, a 3-D virtual world, esp. in an online role-playing game; the universe as portrayed in a given work of fiction [n]\n",
  "METAXYLEM": "a part of the primary xylem [n -S]\n",
  "METAXYLEMS": "METAXYLEM, a part of the primary xylem [n]\n",
  "METAYAGE": "(French) a system of trading crops for rent [n -S]\n",
  "METAYAGES": "METAYAGE, (French) a system of trading crops for rent [n]\n",
  "METAYER": "(French) one who cultivates land for a share (usually one half) of its yield, receiving stock, tools, and seed from the landlord [n -S]\n",
  "METAYERS": "METAYER, (French) one who cultivates land for a share (usually one half) of its yield, receiving stock, tools, and seed from the landlord [n]\n",
  "METAZOA": "METAZOON, any of a major division of multicellular animals, also METAZOAN [n]\n",
  "METAZOAL": "relating to the metazoa, animals more complex than a unicellular protozoan [adj]\n",
  "METAZOAN": "any of a major division of multicellular animals, also METAZOON [n -S]\n",
  "METAZOANS": "METAZOAN, any of a major division of multicellular animals, also METAZOON [n]\n",
  "METAZOIC": "relating to a metazoan [adj]\n",
  "METAZOON": "any of a major division of multicellular animals, also METAZOAN [n METAZOA]\n",
  "METCAST": "a weather forecast [n -S]\n",
  "METCASTS": "METCAST, a weather forecast [n]\n",
  "METE": "to distribute by measure [v METED, METING, METES]\n",
  "METECDYSES": "METECDYSIS, the period following the moult (ecdysis) of an arthropod, when the new cuticle is forming [n]\n",
  "METECDYSIS": "the period following the moult (ecdysis) of an arthropod, when the new cuticle is forming [n METECDYSES]\n",
  "METED": "METE, to distribute by measure [v]\n",
  "METEMPIRIC": "transcending but associated with empirical knowledge, also METEMPIRICAL [adj METEMPIRICALLY]\n",
  "METEMPIRICAL": "transcending but associated with empirical knowledge, also METEMPIRIC [adj METEMPIRICALLY]\n",
  "METEMPIRICALLY": "METEMPIRICAL, transcending but associated with empirical knowledge, also METEMPIRIC [adv]\n",
  "METEMPIRICISM": "the study of metempiric ideas [n -S]\n",
  "METEMPIRICISMS": "METEMPIRICISM, the study of metempiric ideas [n]\n",
  "METEMPIRICIST": "one who studies metempirics [n -S]\n",
  "METEMPIRICISTS": "METEMPIRICIST, one who studies metempirics [n]\n",
  "METEMPIRICS": "the study of the existence of things beyond the scope of experience [n]\n",
  "METEMPSYCHOSES": "METEMPSYCHOSIS, the passing of the soul at death into another body either human or animal [n]\n",
  "METEMPSYCHOSIS": "the passing of the soul at death into another body either human or animal [n METEMPSYCHOSES]\n",
  "METEMPSYCHOSIST": "a believer in metempsychosis, the passing of the soul at death into another body either human or animal [n]\n",
  "METENCEPHALA": "METENCEPHALON, the anterior segment of the developing vertebrate hindbrain [n]\n",
  "METENCEPHALIC": "relating to the metencephalon, the anterior segment of the developing vertebrate hindbrain [adj]\n",
  "METENCEPHALON": "the anterior segment of the developing vertebrate hindbrain [n METENCEPHALA or METENCEPHALONS]\n",
  "METENCEPHALONS": "METENCEPHALON, the anterior segment of the developing vertebrate hindbrain [n]\n",
  "METEOR": "a small celestial body that enters the earth's atmosphere [n -S]\n",
  "METEORIC": "like a meteor [adj METEORICALLY]\n",
  "METEORICALLY": "METEORIC, like a meteor [adv]\n",
  "METEORISM": "abdominal cramps and swelling due to flatulence [n -S]\n",
  "METEORISMS": "METEORISM, abdominal cramps and swelling due to flatulence [n]\n",
  "METEORIST": "one suffering from meteorism, abdominal cramps and swelling due to flatulence [n -S]\n",
  "METEORISTS": "METEORIST, one suffering from meteorism, abdominal cramps and swelling due to flatulence [n]\n",
  "METEORITAL": "of or like a meteorite, also METEORITIC, METEORITICAL [adj]\n",
  "METEORITE": "a meteor that has fallen to earth as a lump of stone or metal [n -S]\n",
  "METEORITES": "METEORITE, a meteor that has fallen to earth as a lump of stone or metal [n]\n",
  "METEORITIC": "of or like a meteorite, also METEORITAL, METEORITICAL [adj]\n",
  "METEORITICAL": "of or like a meteorite, also METEORITAL, METEORITIC [adj]\n",
  "METEORITICIST": "a student of meteoritics [n -S]\n",
  "METEORITICISTS": "METEORITICIST, a student of meteoritics [n]\n",
  "METEORITICS": "the study of meteors [n]\n",
  "METEOROGRAM": "a meteorograph record [n -S]\n",
  "METEOROGRAMS": "METEOROGRAM, a meteorograph record [n]\n",
  "METEOROGRAPH": "an instrument used to record a variety of meteorological observations [n -S]\n",
  "METEOROGRAPHIC": "relating to a meteorograph, an instrument used to record a variety of meteorological observations [adj]\n",
  "METEOROGRAPHS": "METEOROGRAPH, an instrument used to record a variety of meteorological observations [n]\n",
  "METEOROID": "a meteor that has not reached the earth's atmosphere [n -S]\n",
  "METEOROIDAL": "like a meteor [adj]\n",
  "METEOROIDS": "METEOROID, a meteor that has not reached the earth's atmosphere [n]\n",
  "METEOROLITE": "a meteoric stone [n -S]\n",
  "METEOROLITES": "METEOROLITE, a meteoric stone [n]\n",
  "METEOROLOGIC": "relating to meteorology, also METEOROLOGICAL [adj]\n",
  "METEOROLOGICAL": "relating to meteorology, also METEOROLOGIC [adj]\n",
  "METEOROLOGIES": "METEOROLOGY, the scientific study of the atmosphere [n]\n",
  "METEOROLOGIST": "one who studies the weather [n -S]\n",
  "METEOROLOGISTS": "METEOROLOGIST, one who studies the weather [n]\n",
  "METEOROLOGY": "the scientific study of the atmosphere [n METEOROLOGIES]\n",
  "METEOROUS": "of the nature or appearance of a meteor [adj]\n",
  "METEORS": "METEOR, a small celestial body that enters the earth's atmosphere [n]\n",
  "METEPA": "a chemical compound [n -S]\n",
  "METEPAS": "METEPA, a chemical compound [n]\n",
  "METER": "to measure by mechanical means, also METRE [v -ED, -ING, -S]\n",
  "METERAGE": "measurement by meter [n -S]\n",
  "METERAGES": "METERAGE, measurement by meter [n]\n",
  "METERED": "METER, to measure by mechanical means, also METRE [v]\n",
  "METERING": "METER, to measure by mechanical means, also METRE [v]\n",
  "METERS": "METER, to measure by mechanical means, also METRE [v]\n",
  "METERSTICK": "a measuring stick a metre in length, also METRESTICK [n -S]\n",
  "METERSTICKS": "METERSTICK, a measuring stick a metre in length, also METRESTICK [n]\n",
  "METES": "METE, to distribute by measure [v]\n",
  "METESTICK": "a measuring rod, also METEWAND, METEYARD [n -S]\n",
  "METESTICKS": "METESTICK, a measuring rod, also METEWAND, METEYARD [n]\n",
  "METESTROUS": "relating to the metestrus, the period in the oestrous cycle following oestrus, characterized by lack of sexual activity, also METOESTROUS [adj]\n",
  "METESTRUS": "the short period following oestrus in many mammals during which sexual activity subsides, also METOESTRUS [n -ES]\n",
  "METESTRUSES": "METESTRUS, the short period following oestrus in many mammals during which sexual activity subsides, also METOESTRUS [n]\n",
  "METEWAND": "a measuring rod, also METESTICK, METEYARD [n -S]\n",
  "METEWANDS": "METEWAND, a measuring rod, also METESTICK, METEYARD [n]\n",
  "METEYARD": "a measuring rod, also METESTICK, METEWAND [n -S]\n",
  "METEYARDS": "METEYARD, a measuring rod, also METESTICK, METEWAND [n]\n",
  "METFORMIN": "a drug used to treat diabetes [n -S]\n",
  "METFORMINS": "METFORMIN, a drug used to treat diabetes [n]\n",
  "METH": "a stimulant drug [n -S]\n",
  "METHACRYLATE": "a salt or ester of methacrylic acid [n -S]\n",
  "METHACRYLATES": "METHACRYLATE, a salt or ester of methacrylic acid [n]\n",
  "METHACRYLIC": "denoting a type of acid [adj]\n",
  "METHADON": "a synthetic drug similar to morphine, also METHADONE [n -S]\n",
  "METHADONE": "a synthetic drug similar to morphine, also METHADON [n -S]\n",
  "METHADONES": "METHADONE, a synthetic drug similar to morphine, also METHADON [n]\n",
  "METHADONS": "METHADON, a synthetic drug similar to morphine, also METHADONE [n]\n",
  "METHAEMOGLOBIN": "a brown compound of oxygen and haemoglobin formed in the blood by the action of certain drugs [n -S]\n",
  "METHAEMOGLOBINS": "METHAEMOGLOBIN, a brown compound of oxygen and haemoglobin formed in the blood by the action of certain drugs [n]\n",
  "METHAMPHETAMINE": "a methyl derivative of amphetamine with similar but longer lasting effects, now seldom used in medicine but widespread as a drug of abuse [n]\n",
  "METHANAL": "formaldehyde [n -S]\n",
  "METHANALS": "METHANAL, formaldehyde [n]\n",
  "METHANAMIDE": "an amide derived from formic acid, aka formamide [n -S]\n",
  "METHANAMIDES": "METHANAMIDE, an amide derived from formic acid, aka formamide [n]\n",
  "METHANATION": "the production of methane esp. from carbon monoxide and hydrogen [n -S]\n",
  "METHANATIONS": "METHANATION, the production of methane esp. from carbon monoxide and hydrogen [n]\n",
  "METHANE": "a colourless odourless flammable gas, CH4, the simplest of the alkanes [n -S]\n",
  "METHANES": "METHANE, a colourless odourless flammable gas, CH4, the simplest of the alkanes [n]\n",
  "METHANOIC": "as in methanoic acid, formic acid [adj]\n",
  "METHANOL": "methyl alcohol, wood spirit [n -S]\n",
  "METHANOLS": "METHANOL, methyl alcohol, wood spirit [n]\n",
  "METHANOMETER": "instrument for detecting presence of methane [n -S]\n",
  "METHANOMETERS": "METHANOMETER, instrument for detecting presence of methane [n]\n",
  "METHANOYL": "any of a class of highly reactive organic chemical compounds [n -S]\n",
  "METHANOYLS": "METHANOYL, any of a class of highly reactive organic chemical compounds [n]\n",
  "METHAQUALONE": "a type of sedative, aka quaalude [n -S]\n",
  "METHAQUALONES": "METHAQUALONE, a type of sedative, aka quaalude [n]\n",
  "METHEDRINE": "(tradename) a former proprietary name for an amphetamine, methylamphetamine hydrochloride [n -S]\n",
  "METHEDRINES": "METHEDRINE, (tradename) a former proprietary name for an amphetamine, methylamphetamine hydrochloride [n]\n",
  "METHEGLIN": "(Welsh) a spiced or medicated variety of mead, originally peculiar to Wales [n -S]\n",
  "METHEGLINS": "METHEGLIN, (Welsh) a spiced or medicated variety of mead, originally peculiar to Wales [n]\n",
  "METHEMOGLOBIN": "a soluble brown crystalline basic blood pigment that differs from hemoglobin in containing ferric iron and in being unable to combine reversibly with molecular oxygen [n -S]\n",
  "METHEMOGLOBINS": "METHEMOGLOBIN, a soluble brown crystalline basic blood pigment that differs from hemoglobin in containing ferric iron and in being unable to combine reversibly with molecular oxygen [n]\n",
  "METHENAMINE": "hexamethylenetetramine esp. when used in the form of an organic salt to treat urinary tract infections [n -S]\n",
  "METHENAMINES": "METHENAMINE, hexamethylenetetramine esp. when used in the form of an organic salt to treat urinary tract infections [n]\n",
  "METHICILLIN": "a semisynthetic penicillin used esp. in the form of its sodium salt [n -S]\n",
  "METHICILLINS": "METHICILLIN, a semisynthetic penicillin used esp. in the form of its sodium salt [n]\n",
  "METHINK": "it seems to me, also METHINKETH, METHINKS [v METHOUGHT, METHINKS]\n",
  "METHINKETH": "(obsolete) I think, also METHINK, METHINKS [v]\n",
  "METHINKS": "(archaic) I think, also METHINK, METHINKETH [v]\n",
  "METHIONINE": "an essential sulphur-bearing amino acid [n -S]\n",
  "METHIONINES": "METHIONINE, an essential sulphur-bearing amino acid [n]\n",
  "METHO": "(Australian slang) methylated spirits [n -S]\n",
  "METHOD": "orderly procedure [n -S]\n",
  "METHODIC": "arranged, characterized by, or performed with method or order, also METHODICAL [adj METHODICALLY]\n",
  "METHODICAL": "arranged, characterized by, or performed with method or order, also METHODIC [adj METHODICALLY]\n",
  "METHODICALLY": "METHODICAL, arranged, characterized by, or performed with method or order, also METHODIC [adv]\n",
  "METHODICALNESS": "METHODICAL, arranged, characterized by, or performed with method or order, also METHODIC [n]\n",
  "METHODISATION": "the process of methodising, also METHODIZATION [n -S]\n",
  "METHODISATIONS": "METHODISATION, the process of methodising, also METHODIZATION [n]\n",
  "METHODISE": "to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODIZE [v METHODISED, METHODISING, METHODISES]\n",
  "METHODISED": "METHODISE, to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODIZE [v]\n",
  "METHODISER": "one who methodises, also METHODIZER [n -S]\n",
  "METHODISERS": "METHODISER, one who methodises, also METHODIZER [n]\n",
  "METHODISES": "METHODISE, to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODIZE [v]\n",
  "METHODISING": "METHODISE, to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODIZE [v]\n",
  "METHODISM": "methodical procedure [n -S]\n",
  "METHODISMS": "METHODISM, methodical procedure [n]\n",
  "METHODIST": "a follower of Methodism [n -S]\n",
  "METHODISTIC": "of or like Methodism [adj]\n",
  "METHODISTS": "METHODIST, a follower of Methodism [n]\n",
  "METHODIZATION": "the process of methodizing, also METHODISATION [n -S]\n",
  "METHODIZATIONS": "METHODIZATION, the process of methodizing, also METHODISATION [n]\n",
  "METHODIZE": "to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODISE [v METHODIZED, METHODIZING, METHODIZES]\n",
  "METHODIZED": "METHODIZE, to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODISE [v]\n",
  "METHODIZER": "one who methodizes, also METHODISER [n -S]\n",
  "METHODIZERS": "METHODIZER, one who methodizes, also METHODISER [n]\n",
  "METHODIZES": "METHODIZE, to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODISE [v]\n",
  "METHODIZING": "METHODIZE, to reduce to method; to arrange in an orderly way; as, to methodize one's work or thoughts, also METHODISE [v]\n",
  "METHODOLOGICAL": "of or relating to method or methodology [adj]\n",
  "METHODOLOGIES": "METHODOLOGY, a body of methods employed by a discipline [n]\n",
  "METHODOLOGIST": "a student of methodology [n -S]\n",
  "METHODOLOGISTS": "METHODOLOGIST, a student of methodology [n]\n",
  "METHODOLOGY": "a body of methods employed by a discipline [n METHODOLOGIES]\n",
  "METHODS": "METHOD, orderly procedure [n]\n",
  "METHOMANIA": "a morbid craving for alcohol [n -S]\n",
  "METHOMANIAS": "METHOMANIA, a morbid craving for alcohol [n]\n",
  "METHOS": "METHO, (Australian slang) methylated spirits [n]\n",
  "METHOTREXATE": "a drug used in the treatment of cancer [n -S]\n",
  "METHOTREXATES": "METHOTREXATE, a drug used in the treatment of cancer [n]\n",
  "METHOUGHT": "METHINK, it seems to me, also METHINKETH, METHINKS [v]\n",
  "METHOXIDE": "a saltlike compound of methanol [n -S]\n",
  "METHOXIDES": "METHOXIDE, a saltlike compound of methanol [n]\n",
  "METHOXIES": "METHOXY, a drug that is claimed to increase muscle size and is taken as a supplement by some athletes [n]\n",
  "METHOXY": "a drug that is claimed to increase muscle size and is taken as a supplement by some athletes [n METHOXIES]\n",
  "METHOXYBENZENE": "another name for anisole, a colourless liquid ether [n -S]\n",
  "METHOXYBENZENES": "METHOXYBENZENE, another name for anisole, a colourless liquid ether [n]\n",
  "METHOXYCHLOR": "a relatively nontoxic organochlorine insecticide [n -S]\n",
  "METHOXYCHLORS": "METHOXYCHLOR, a relatively nontoxic organochlorine insecticide [n]\n",
  "METHOXYFLURANE": "a potent general anaesthetic administered as a vapor [n -S]\n",
  "METHOXYFLURANES": "METHOXYFLURANE, a potent general anaesthetic administered as a vapor [n]\n",
  "METHOXYL": "a compound containing a certain chemical group, also METHOXY [n -S]\n",
  "METHOXYLS": "METHOXYL, a compound containing a certain chemical group, also METHOXY [n]\n",
  "METHS": "METH, a stimulant drug [n]\n",
  "METHYL": "the radical (CH3) of wood (or methyl) alcohol [n -S]\n",
  "METHYLAL": "a colourless volatile fragrant liquid, used as a solvent and formerly as an anaesthetic [n -S]\n",
  "METHYLALS": "METHYLAL, a colourless volatile fragrant liquid, used as a solvent and formerly as an anaesthetic [n]\n",
  "METHYLAMINE": "an inflammable gas, obtainable from herring brine [n -S]\n",
  "METHYLAMINES": "METHYLAMINE, an inflammable gas, obtainable from herring brine [n]\n",
  "METHYLASE": "an enzyme that catalyzes methylation [n -S]\n",
  "METHYLASES": "METHYLASE, an enzyme that catalyzes methylation [n]\n",
  "METHYLATE": "to introduce one or more methyl groups into (a compound or group) [v METHYLATED, METHYLATING, METHYLATES]\n",
  "METHYLATED": "METHYLATE, to introduce one or more methyl groups into (a compound or group) [v]\n",
  "METHYLATES": "METHYLATE, to introduce one or more methyl groups into (a compound or group) [v]\n",
  "METHYLATING": "METHYLATE, to introduce one or more methyl groups into (a compound or group) [v]\n",
  "METHYLATION": "the process of methylating [n -S]\n",
  "METHYLATIONS": "METHYLATION, the process of methylating [n]\n",
  "METHYLATOR": "an agent that methylates [n -S]\n",
  "METHYLATORS": "METHYLATOR, an agent that methylates [n]\n",
  "METHYLCELLULOSE": "any of various gummy products of cellulose methylation that swell in water and are used esp. as emulsifiers, adhesives, thickeners, and bulk laxatives [n]\n",
  "METHYLDOPA": "an antihypertensive drug [n -S]\n",
  "METHYLDOPAS": "METHYLDOPA, an antihypertensive drug [n]\n",
  "METHYLENE": "the radical CH2, which is the basic unit of hydrocarbon chains [n -S]\n",
  "METHYLENES": "METHYLENE, the radical CH2, which is the basic unit of hydrocarbon chains [n]\n",
  "METHYLIC": "pertaining to, derived from, or containing, methyl; specifically, designating methyl alcohol [adj]\n",
  "METHYLMERCURIES": "METHYLMERCURY, any of several extremely toxic organometallic compounds formed from metallic mercury by the action of microorganisms [n]\n",
  "METHYLMERCURY": "any of several extremely toxic organometallic compounds formed from metallic mercury by the action of microorganisms [n METHYLMERCURIES]\n",
  "METHYLPHENIDATE": "a stimulant used in treating attention deficit disorder [n]\n",
  "METHYLPHENOL": "a type of aromatic organic compound, aka cresol [n -S]\n",
  "METHYLPHENOLS": "METHYLPHENOL, a type of aromatic organic compound, aka cresol [n]\n",
  "METHYLS": "METHYL, the radical (CH3) of wood (or methyl) alcohol [n]\n",
  "METHYLTHIONINE": "as in methylthionine chloride, a dark green dye used as a stain, antiseptic etc. [n -S]\n",
  "METHYLTHIONINES": "METHYLTHIONINE, as in methylthionine chloride, a dark green dye used as a stain, antiseptic etc. [n]\n",
  "METHYLXANTHINE": "a methylated xanthine derivative, such as caffeine, theobromine, or theophylline [n -S]\n",
  "METHYLXANTHINES": "METHYLXANTHINE, a methylated xanthine derivative, such as caffeine, theobromine, or theophylline [n]\n",
  "METHYSERGIDE": "a serotonin used in the treatment and prevention of migraine headaches [n -S]\n",
  "METHYSERGIDES": "METHYSERGIDE, a serotonin used in the treatment and prevention of migraine headaches [n]\n",
  "METHYSES": "METHYSIS, drunkenness [n]\n",
  "METHYSIS": "drunkenness [n METHYSES]\n",
  "METHYSTIC": "intoxicating [adj]\n",
  "METIC": "(historical) in ancient Greece, a resident alien in a city, subject to a special tax [n -S]\n",
  "METICA": "a monetary unit of Mozambique, also METICAL [n -S]\n",
  "METICAIS": "METICAL, (Portuguese) a monetary unit of Mozambique, also METICA [n]\n",
  "METICAL": "(Portuguese) a monetary unit of Mozambique, also METICA [n METICALS or METICAIS]\n",
  "METICALS": "METICAL, (Portuguese) a monetary unit of Mozambique, also METICA [n]\n",
  "METICAS": "METICA, a monetary unit of Mozambique, also METICAL [n]\n",
  "METICS": "METIC, (historical) in ancient Greece, a resident alien in a city, subject to a special tax [n]\n",
  "METICULOSITIES": "METICULOSITY, the state of being meticulous [n]\n",
  "METICULOSITY": "the state of being meticulous [n METICULOSITIES]\n",
  "METICULOUS": "marked by extreme or excessive care in the consideration or treatment of details [adj METICULOUSLY]\n",
  "METICULOUSLY": "METICULOUS, marked by extreme or excessive care in the consideration or treatment of details [adv]\n",
  "METICULOUSNESS": "METICULOUS, marked by extreme or excessive care in the consideration or treatment of details [n]\n",
  "METIER": "(French) one's occupation or department of activity; a field in which one has special skill or ability [n -S]\n",
  "METIERS": "METIER, (French) one's occupation or department of activity; a field in which one has special skill or ability [n]\n",
  "METIF": "(French) the offspring of a white and a quadroon [n -S]\n",
  "METIFS": "METIF, (French) the offspring of a white and a quadroon [n]\n",
  "METING": "METE, to distribute by measure [v]\n",
  "METIS": "(French) the (male) offspring of a white person and an American Indian [n METIS]\n",
  "METISSE": "(French) the (female) offspring of a white person and an American Indian [n -S]\n",
  "METISSES": "METISSE, (French) the (female) offspring of a white person and an American Indian [n]\n",
  "METOCLOPRAMIDE": "a drug used as an anti-emetic [n -S]\n",
  "METOCLOPRAMIDES": "METOCLOPRAMIDE, a drug used as an anti-emetic [n]\n",
  "METOESTROUS": "relating to the metoestrus, the period in the oestrous cycle following oestrus, characterized by lack of sexual activity, also METESTROUS [adj]\n",
  "METOESTRUS": "the period in the oestrous cycle following oestrus, characterized by lack of sexual activity, also METESTRUS [n -ES]\n",
  "METOESTRUSES": "METOESTRUS, the period in the oestrous cycle following oestrus, characterized by lack of sexual activity, also METESTRUS [n]\n",
  "METOL": "a coal tar derivative used in developing pictures [n -S]\n",
  "METOLS": "METOL, a coal tar derivative used in developing pictures [n]\n",
  "METONYM": "a word used in metonymy [n -S]\n",
  "METONYMIC": "relating to a metonym, a word used in metonymy, also METONYMICAL [adj METONYMICALLY]\n",
  "METONYMICAL": "relating to a metonym, a word used in metonymy, also METONYMIC [adj METONYMICALLY]\n",
  "METONYMICALLY": "METONYMICAL, relating to a metonym, a word used in metonymy, also METONYMIC [adv]\n",
  "METONYMIES": "METONYMY, a type of figure of speech [n]\n",
  "METONYMS": "METONYM, a word used in metonymy [n]\n",
  "METONYMY": "a type of figure of speech [n METONYMIES]\n",
  "METOPAE": "METOPE, (Greek) a space between two triglyphs [n]\n",
  "METOPE": "(Greek) a space between two triglyphs [n METOPES or METOPAE]\n",
  "METOPES": "METOPE, (Greek) a space between two triglyphs [n]\n",
  "METOPIC": "pertaining to the forehead [adj]\n",
  "METOPISM": "the condition of having a frontal suture [n -S]\n",
  "METOPISMS": "METOPISM, the condition of having a frontal suture [n]\n",
  "METOPON": "a pain-relieving drug derived from opium [n -S]\n",
  "METOPONS": "METOPON, a pain-relieving drug derived from opium [n]\n",
  "METOPOSCOPIC": "relating to metoposcopy, the art of judging a person's character and fortune from his face, also METOPOSCOPICAL [adj]\n",
  "METOPOSCOPICAL": "relating to metoposcopy, the art of judging a person's character and fortune from his face, also METOPOSCOPIC [adj]\n",
  "METOPOSCOPIES": "METOPOSCOPY, the art of judging a person's character and fortune from his face, principally his forehead [n]\n",
  "METOPOSCOPIST": "one who practises metoposcopy, the art of judging a person's character and fortune from his face, principally his forehead [n -S]\n",
  "METOPOSCOPISTS": "METOPOSCOPIST, one who practises metoposcopy, the art of judging a person's character and fortune from his face, principally his forehead [n]\n",
  "METOPOSCOPY": "the art of judging a person's character and fortune from his face, principally his forehead [n METOPOSCOPIES]\n",
  "METOPRYL": "an anaesthetic related to ether [n -S]\n",
  "METOPRYLS": "METOPRYL, an anaesthetic related to ether [n]\n",
  "METRALGIA": "pain in the uterus [n -S]\n",
  "METRALGIAS": "METRALGIA, pain in the uterus [n]\n",
  "METRAZOL": "a drug used to improve blood circulation [n -S]\n",
  "METRAZOLS": "METRAZOL, a drug used to improve blood circulation [n]\n",
  "METRE": "to measure by mechanical means, also METER [v METRED, METRING, METRES]\n",
  "METRED": "METRE, to measure by mechanical means, also METER [v]\n",
  "METRES": "METRE, to measure by mechanical means, also METER [v]\n",
  "METRESTICK": "a measuring stick one metre long, also METERSTICK [n -S]\n",
  "METRESTICKS": "METRESTICK, a measuring stick one metre long, also METERSTICK [n]\n",
  "METRIC": "relating to metre [adj METRICALLY] / a standard of measurement [n -S]\n",
  "METRICAL": "pertaining to or composed in a system of arranged and measured rhythm [adj]\n",
  "METRICALLY": "METRICAL, pertaining to or composed in a system of arranged and measured rhythm [adv]\n",
  "METRICATE": "to measure [v METRICATED, METRICATING, METRICATES]\n",
  "METRICATED": "METRICATE, to measure [v]\n",
  "METRICATES": "METRICATE, to measure [v]\n",
  "METRICATING": "METRICATE, to measure [v]\n",
  "METRICATION": "the act of making metric [n -S]\n",
  "METRICATIONS": "METRICATION, the act of making metric [n]\n",
  "METRICIAN": "a composer of verses [n -S]\n",
  "METRICIANS": "METRICIAN, a composer of verses [n]\n",
  "METRICISE": "to convert to metrical form, also METRICIZE [v METRICISED, METRICISING, METRICISES]\n",
  "METRICISED": "METRICISE, to convert to metrical form, also METRICIZE [v]\n",
  "METRICISES": "METRICISE, to convert to metrical form, also METRICIZE [v]\n",
  "METRICISING": "METRICISE, to convert to metrical form, also METRICIZE [v]\n",
  "METRICISM": "the study of metre [n -S]\n",
  "METRICISMS": "METRICISM, the study of metre [n]\n",
  "METRICIST": "a person skilled in metres; one who writes in metres, also METRIST [n -S]\n",
  "METRICISTS": "METRICIST, a person skilled in metres; one who writes in metres, also METRIST [n]\n",
  "METRICIZE": "to convert to metrical form, also METRICISE [v METRICIZED, METRICIZING, METRICIZES]\n",
  "METRICIZED": "METRICIZE, to convert to metrical form, also METRICISE [v]\n",
  "METRICIZES": "METRICIZE, to convert to metrical form, also METRICISE [v]\n",
  "METRICIZING": "METRICIZE, to convert to metrical form, also METRICISE [v]\n",
  "METRICS": "METRIC, a standard of measurement [n]\n",
  "METRIFICATION": "the act of making metric [n -S]\n",
  "METRIFICATIONS": "METRIFICATION, the act of making metric [n]\n",
  "METRIFIED": "METRIFY, to compose in metrical form [v]\n",
  "METRIFIER": "one who metrifies [n -S]\n",
  "METRIFIERS": "METRIFIER, one who metrifies [n]\n",
  "METRIFIES": "METRIFY, to compose in metrical form [v]\n",
  "METRIFONATE": "an organophosphorus insecticide, aka trichlorfon [n -S]\n",
  "METRIFONATES": "METRIFONATE, an organophosphorus insecticide, aka trichlorfon [n]\n",
  "METRIFY": "to compose in metrical form [v METRIFIED, METRIFYING, METRIFIES]\n",
  "METRIFYING": "METRIFY, to compose in metrical form [v]\n",
  "METRING": "METRE, to measure by mechanical means, also METER [v]\n",
  "METRIST": "a person skilled in metres; one who writes in metres, also METRICIST [n -S]\n",
  "METRISTS": "METRIST, a person skilled in metres; one who writes in metres, also METRICIST [n]\n",
  "METRITIS": "inflammation of the uterus [n -ES]\n",
  "METRITISES": "METRITIS, inflammation of the uterus [n]\n",
  "METRO": "an urban railway system running wholly or partly underground [n -S]\n",
  "METROLOGIC": "relating to metrology, also METROLOGICAL [adj METROLOGICALLY]\n",
  "METROLOGICAL": "relating to metrology, also METROLOGIC [adj METROLOGICALLY]\n",
  "METROLOGICALLY": "METROLOGICAL, relating to metrology, also METROLOGIC [adv]\n",
  "METROLOGIES": "METROLOGY, the science of weights and measures [n]\n",
  "METROLOGIST": "a student of metrology [n -S]\n",
  "METROLOGISTS": "METROLOGIST, a student of metrology [n]\n",
  "METROLOGY": "the science of weights and measures [n METROLOGIES]\n",
  "METROMANIA": "an insatiable desire for writing verse [n -S]\n",
  "METROMANIAS": "METROMANIA, an insatiable desire for writing verse [n]\n",
  "METRONIDAZOLE": "a drug used esp. to treat vaginal trichomoniasis, amebiasis, and infections by anaerobic bacteria [n -S]\n",
  "METRONIDAZOLES": "METRONIDAZOLE, a drug used esp. to treat vaginal trichomoniasis, amebiasis, and infections by anaerobic bacteria [n]\n",
  "METRONOME": "a mechanical device which indicates the exact tempo of a piece of music by producing a clicking sound from a pendulum with an adjustable period of swing [n -S]\n",
  "METRONOMES": "METRONOME, a mechanical device which indicates the exact tempo of a piece of music by producing a clicking sound from a pendulum with an adjustable period of swing [n]\n",
  "METRONOMIC": "of or like a metronome, also METRONOMICAL [adj METRONOMICALLY]\n",
  "METRONOMICAL": "of or like a metronome, also METRONOMIC [adj METRONOMICALLY]\n",
  "METRONOMICALLY": "METRONOMICAL, of or like a metronome, also METRONOMIC [adv]\n",
  "METRONYMIC": "derived from the name of one's mother, or other female ancestor [adj] / a name so derived, also MATRONYMIC [n -S]\n",
  "METRONYMICS": "METRONYMIC, a name so derived, also MATRONYMIC [n]\n",
  "METROPLEX": "a large urban or metropolitan area [n -ES]\n",
  "METROPLEXES": "METROPLEX, a large urban or metropolitan area [n]\n",
  "METROPOLIS": "the chief or capital city of a country, state, or region [n -ES]\n",
  "METROPOLISES": "METROPOLIS, the chief or capital city of a country, state, or region [n]\n",
  "METROPOLITAN": "an archbishop holding authority over other bishops [n -S]\n",
  "METROPOLITANATE": "a metropolitan area [n]\n",
  "METROPOLITANISE": "to make metropolitan, also METROPOLITANIZE [v]\n",
  "METROPOLITANISM": "the state of being metropolitan [n]\n",
  "METROPOLITANIZE": "to make metropolitan, also METROPOLITANISE [v]\n",
  "METROPOLITANS": "METROPOLITAN, an archbishop holding authority over other bishops [n]\n",
  "METROPOLITICAL": "of or like a metropolis [adj]\n",
  "METRORRHAGIA": "irregular uterine bleeding esp. between menstrual periods [n -S]\n",
  "METRORRHAGIAS": "METRORRHAGIA, irregular uterine bleeding esp. between menstrual periods [n]\n",
  "METROS": "METRO, an urban railway system running wholly or partly underground [n]\n",
  "METROSEXUAL": "a heterosexual man who spends a lot of time and money on his appearance and likes to shop [n -S]\n",
  "METROSEXUALS": "METROSEXUAL, a heterosexual man who spends a lot of time and money on his appearance and likes to shop [n]\n",
  "METROSTYLE": "a device for regulating speed in a player-piano [n -S]\n",
  "METROSTYLES": "METROSTYLE, a device for regulating speed in a player-piano [n]\n",
  "METS": "MET, (short for) meteorology [n]\n",
  "METTLE": "spirit or courage [n -S]\n",
  "METTLED": "having spirit [adj]\n",
  "METTLES": "METTLE, spirit or courage [n]\n",
  "METTLESOME": "full of mettle [adj]\n",
  "METTLESOMENESS": "METTLESOME, full of mettle [n]\n",
  "METUMP": "a tumpline, a strap placed across a man's forehead to assist him in carrying a pack on his back [n -S]\n",
  "METUMPS": "METUMP, a tumpline, a strap placed across a man's forehead to assist him in carrying a pack on his back [n]\n",
  "MEU": "the plant baldmoney [n -S]\n",
  "MEUNIERE": "(French) of food, esp. fish, lightly coated in flour and fried in butter [adj]\n",
  "MEUS": "MEU, the plant baldmoney [n]\n",
  "MEUSE": "a small hole or gap through which a wild animal passes, also MEWS, MUSET, MUSIT, SMEUSE [n -S] / to pass through a meuse [v MEUSED, MEUSING, MEUSES]\n",
  "MEUSED": "MEUSE, to pass through a meuse [v]\n",
  "MEUSES": "MEUSE, to pass through a meuse [v]\n",
  "MEUSING": "MEUSE, to pass through a meuse [v]\n",
  "MEVE": "(obsolete) to move, also AMOOVE, AMOVE, MIEVE, MOOVE [v MEVED, MEVING, MEVES]\n",
  "MEVED": "MEVE, (obsolete) to move, also AMOOVE, AMOVE, MIEVE, MOOVE [v]\n",
  "MEVES": "MEVE, (obsolete) to move, also AMOOVE, AMOVE, MIEVE, MOOVE [v]\n",
  "MEVING": "MEVE, (obsolete) to move, also AMOOVE, AMOVE, MIEVE, MOOVE [v]\n",
  "MEVROU": "(South African) a title of respect for a woman [n -S]\n",
  "MEVROUS": "MEVROU, (South African) a title of respect for a woman [n]\n",
  "MEW": "of a cat, to make a high pitched cry [v -ED, -ING, -S]\n",
  "MEWED": "MEW, of a cat, to make a high pitched cry [v]\n",
  "MEWING": "MEW, of a cat, to make a high pitched cry [v]\n",
  "MEWL": "to cry feebly, as a kitten [v -ED, -ING, -S]\n",
  "MEWLED": "MEWL, to cry feebly, as a kitten [v]\n",
  "MEWLER": "one that mewls [n -S]\n",
  "MEWLERS": "MEWLER, one that mewls [n]\n",
  "MEWLING": "MEWL, to cry feebly, as a kitten [v]\n",
  "MEWLS": "MEWL, to cry feebly, as a kitten [v]\n",
  "MEWS": "to pass through a meuse [v -ED, -ING, -ES]\n",
  "MEWSED": "MEWS, to pass through a meuse [v]\n",
  "MEWSES": "MEWS, to pass through a meuse [v]\n",
  "MEWSING": "MEWS, to pass through a meuse [v]\n",
  "MEYNT": "MENG, (archaic) to mix; to unite, couple, also MENGE, MING [v]\n",
  "MEZAIL": "a visor, esp. one made in two parts, also MESAIL [n -S]\n",
  "MEZAILS": "MEZAIL, a visor, esp. one made in two parts, also MESAIL [n]\n",
  "MEZCAL": "(Nahuatl) a distilled liquor prepared in Mexico from a species of agave, also MESCAL [n -S]\n",
  "MEZCALINE": "the principal alkaloid in mescal, used as a hallucinogen, also MESCALIN, MESCALINE [n -S]\n",
  "MEZCALINES": "MEZCALINE, the principal alkaloid in mescal, used as a hallucinogen, also MESCALIN, MESCALINE [n]\n",
  "MEZCALS": "MEZCAL, (Nahuatl) a distilled liquor prepared in Mexico from a species of agave, also MESCAL [n]\n",
  "MEZE": "(Turkish) a Greek or Middle Eastern appetizer, also MEZZE [n -S]\n",
  "MEZEREON": "(Arabic) an early-flowering woodland shrub with fragrant purplish or rose-coloured flowers, also MEZEREUM [n -S]\n",
  "MEZEREONS": "MEZEREON, (Arabic) an early-flowering woodland shrub with fragrant purplish or rose-coloured flowers, also MEZEREUM [n]\n",
  "MEZEREUM": "(Arabic) an early-flowering woodland shrub with fragrant purplish or rose-coloured flowers, also MEZEREON [n -S]\n",
  "MEZEREUMS": "MEZEREUM, (Arabic) an early-flowering woodland shrub with fragrant purplish or rose-coloured flowers, also MEZEREON [n]\n",
  "MEZES": "MEZE, (Turkish) a Greek or Middle Eastern appetizer, also MEZZE [n]\n",
  "MEZQUIT": "(Nahuatl) a name for two trees of the southwestern part of North America, the honey mesquite, and screw-pod mesquite, also MESQUIT, MESQUITE, MEZQUITE, MUSKIT [n -S]\n",
  "MEZQUITE": "(Nahuatl) a name for two trees of the southwestern part of North America, the honey mesquite, and screw-pod mesquite, also MESQUIT, MESQUITE, MEZQUIT, MUSKIT [n -S]\n",
  "MEZQUITES": "MEZQUITE, (Nahuatl) a name for two trees of the southwestern part of North America, the honey mesquite, and screw-pod mesquite, also MESQUIT, MESQUITE, MEZQUIT, MUSKIT [n]\n",
  "MEZQUITS": "MEZQUIT, (Nahuatl) a name for two trees of the southwestern part of North America, the honey mesquite, and screw-pod mesquite, also MESQUIT, MESQUITE, MEZQUITE, MUSKIT [n]\n",
  "MEZUZA": "(Hebrew) a small rolled parchment affixed to the doorposts in Jewish houses in fulfilment of the Torah's command to inscribe God's words upon the doorposts of one's house, also MEZUZAH [n -S]\n",
  "MEZUZAH": "(Hebrew) a small rolled parchment affixed to the doorposts in Jewish houses, in fulfilment of the Torah's command to inscribe God's words upon the doorposts of one's house, also MEZUZA [n MEZUZAHS, MEZUZOT or MEZUZOTH]\n",
  "MEZUZAHS": "MEZUZAH, (Hebrew) a small rolled parchment affixed to the doorposts in Jewish houses, in fulfilment of the Torah's command to inscribe God's words upon the doorposts of one's house, also MEZUZA [n]\n",
  "MEZUZAS": "MEZUZA, (Hebrew) a small rolled parchment affixed to the doorposts in Jewish houses in fulfilment of the Torah's command to inscribe God's words upon the doorposts of one's house, also MEZUZAH [n]\n",
  "MEZUZOT": "MEZUZAH, (Hebrew) a small rolled parchment affixed to the doorposts in Jewish houses, in fulfilment of the Torah's command to inscribe God's words upon the doorposts of one's house, also MEZUZA [n]\n",
  "MEZUZOTH": "MEZUZAH, (Hebrew) a small rolled parchment affixed to the doorposts in Jewish houses, in fulfilment of the Torah's command to inscribe God's words upon the doorposts of one's house, also MEZUZA [n]\n",
  "MEZZ": "(short for) mezzanine, relating to an intermediate stage in a financial process [adj]\n",
  "MEZZALUNA": "a half-moon shaped kitchen chopper [n -S]\n",
  "MEZZALUNAS": "MEZZALUNA, a half-moon shaped kitchen chopper [n]\n",
  "MEZZANINE": "a low storey between two main storeys of a building, generally between the ground floor and the first floor [n -S]\n",
  "MEZZANINES": "MEZZANINE, a low storey between two main storeys of a building, generally between the ground floor and the first floor [n]\n",
  "MEZZE": "(Turkish) a Greek or Middle Eastern appetizer, also MEZE [n -S]\n",
  "MEZZES": "MEZZE, (Turkish) a Greek or Middle Eastern appetizer, also MEZE [n]\n",
  "MEZZO": "(Italian) (short for) mezzo-soprano, a female voice of a full, deep quality [n -S]\n",
  "MEZZOS": "MEZZO, (Italian) (short for) mezzo-soprano, a female voice of a full, deep quality [n]\n",
  "MEZZOTINT": "to engrave using a method of copper engraving with even gradation of tones [v MEZZOTINTED, MEZZOTINTING, MEZZOTINTS]\n",
  "MEZZOTINTED": "MEZZOTINT, to engrave using a method of copper engraving with even gradation of tones [v]\n",
  "MEZZOTINTER": "one who works in mezzotint [n -S]\n",
  "MEZZOTINTERS": "MEZZOTINTER, one who works in mezzotint [n]\n",
  "MEZZOTINTING": "MEZZOTINT, to engrave using a method of copper engraving with even gradation of tones [v]\n",
  "MEZZOTINTO": "(Italian) a mezzotint [n -S]\n",
  "MEZZOTINTOS": "MEZZOTINTO, (Italian) a mezzotint [n]\n",
  "MEZZOTINTS": "MEZZOTINT, to engrave using a method of copper engraving with even gradation of tones [v]\n",
  "MGANGA": "(Bantu) in Tanzania and other parts of East Africa, an indigenous African doctor, a witch-doctor [n -S]\n",
  "MGANGAS": "MGANGA, (Bantu) in Tanzania and other parts of East Africa, an indigenous African doctor, a witch-doctor [n]\n",
  "MHO": "a unit of electrical conductance [n -S]\n",
  "MHORR": "(Arabic) a West African gazelle, also MOHR [n -S]\n",
  "MHORRS": "MHORR, (Arabic) a West African gazelle, also MOHR [n]\n",
  "MHOS": "MHO, a unit of electrical conductance [n]\n",
  "MI": "the third note of the musical scale, also ME [n -S]\n",
  "MIAOU": "to make the sound of a crying cat, also MEOW, MEOU, MIAOW, MIAUL [v -ED, -ING, -S]\n",
  "MIAOUED": "MIAOU, to make the sound of a crying cat, also MEOW, MEOU, MIAOW, MIAUL [v]\n",
  "MIAOUING": "MIAOU, to make the sound of a crying cat, also MEOW, MEOU, MIAOW, MIAUL [v]\n",
  "MIAOUS": "MIAOU, to make the sound of a crying cat, also MEOW, MEOU, MIAOW, MIAUL [v]\n",
  "MIAOW": "to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAUL [v -ED, -ING, -S]\n",
  "MIAOWED": "MIAOW, to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAUL [v]\n",
  "MIAOWING": "MIAOW, to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAUL [v]\n",
  "MIAOWS": "MIAOW, to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAUL [v]\n",
  "MIAROLITIC": "having irregular cavities into which the constituent minerals of the rock project with perfectly terminated crystals [adj]\n",
  "MIASM": "a noxious vapor, also MIASMA [n -S]\n",
  "MIASMA": "(Greek) a noxious vapor, also MIASM [n MIASMAS or MIASMATA]\n",
  "MIASMAL": "of or like a miasma, also MIASMATIC, MIASMIC, MIASMOUS [adj]\n",
  "MIASMAS": "MIASMA, (Greek) a noxious vapor, also MIASM [n]\n",
  "MIASMATA": "MIASMA, (Greek) a noxious vapor, also MIASM [n]\n",
  "MIASMATIC": "of or like a miasma, also MIASMAL, MIASMIC, MIASMOUS [adj]\n",
  "MIASMATICAL": "of or like a miasma, also MIASMATOUS [adj]\n",
  "MIASMATOUS": "of or like a miasma, also MIASMATICAL [adj]\n",
  "MIASMIC": "of or like a miasma, also MIASMAL, MIASMATIC, MIASMOUS [adj MIASMICALLY]\n",
  "MIASMICALLY": "MIASMIC, of or like a miasma, also MIASMAL, MIASMATIC, MIASMOUS [adv]\n",
  "MIASMOUS": "of or like a miasma, also MIASMAL, MIASMATIC, MIASMIC [adj]\n",
  "MIASMS": "MIASM, a noxious vapor, also MIASMA [n]\n",
  "MIAUL": "to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAOW [v -ED, -ING, -S]\n",
  "MIAULED": "MIAUL, to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAOW [v]\n",
  "MIAULING": "MIAUL, to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAOW [v]\n",
  "MIAULS": "MIAUL, to make the sound of a crying cat, also MEOW, MEOU, MIAOU, MIAOW [v]\n",
  "MIB": "a type of playing marble, also MIG, MIGG, MIGGLE [n -S]\n",
  "MIBS": "MIB, a type of playing marble, also MIG, MIGG, MIGGLE [n]\n",
  "MIBUNA": "(Japanese) a vegetable of the cabbage family, closely related to mizuna [n -S]\n",
  "MIBUNAS": "MIBUNA, (Japanese) a vegetable of the cabbage family, closely related to mizuna [n]\n",
  "MIC": "(short for) a microphone [n -S]\n",
  "MICA": "a rock-forming mineral (muscovite, biotite, lepidolite, etc.) with perfect basal cleavage [n -S]\n",
  "MICACEOUS": "consisting of or made of mica [adj]\n",
  "MICAS": "MICA, a rock-forming mineral (muscovite, biotite, lepidolite, etc.) with perfect basal cleavage [n]\n",
  "MICATE": "to furnish with mica [v MICATED, MICATING, MICATES]\n",
  "MICATED": "MICATE, to furnish with mica [v]\n",
  "MICATES": "MICATE, to furnish with mica [v]\n",
  "MICATING": "MICATE, to furnish with mica [v]\n",
  "MICAWBER": "a person who remains hopeful despite adversity [n -S]\n",
  "MICAWBERS": "MICAWBER, a person who remains hopeful despite adversity [n]\n",
  "MICE": "MOUSE, a small rodent [n]\n",
  "MICELL": "a group of molecular chains, a structural unit of colloids, also MICELLA, MICELLE [n -S]\n",
  "MICELLA": "(Latin) a group of molecular chains, a structural unit of colloids, also MICELL, MICELLE [n MICELLAE or MICELLAS]\n",
  "MICELLAE": "MICELLA, (Latin) a group of molecular chains, a structural unit of colloids, also MICELL, MICELLE [n]\n",
  "MICELLAR": "of or like a micella, a group of molecular chains, a structural unit of colloids [adj]\n",
  "MICELLAS": "MICELLA, (Latin) a group of molecular chains, a structural unit of colloids, also MICELL, MICELLE [n]\n",
  "MICELLE": "a group of molecular chains, a structural unit of colloids, also MICELL, MICELLA [n -S]\n",
  "MICELLES": "MICELLE, a group of molecular chains, a structural unit of colloids, also MICELL, MICELLA [n]\n",
  "MICELLS": "MICELL, a group of molecular chains, a structural unit of colloids, also MICELLA, MICELLE [n]\n",
  "MICH": "to play truant, also MICHE, MITCH, MOOCH, MOUCH [v -ED, -ING, -ES]\n",
  "MICHAEL": "as in take the michael, to make fun of [n -S]\n",
  "MICHAELS": "MICHAEL, as in take the michael, to make fun of [n]\n",
  "MICHE": "to play truant, also MICH, MITCH, MOOCH, MOUCH [v MICHED, MICHING, MICHES]\n",
  "MICHED": "MICHE, to play truant, also MICH, MITCH, MOOCH, MOUCH [v]\n",
  "MICHER": "a truant, also MOOCHER, MOUCHER [n -S]\n",
  "MICHERS": "MICHER, a truant, also MOOCHER, MOUCHER [n]\n",
  "MICHES": "MICHE, to play truant, also MICH, MITCH, MOOCH, MOUCH [v]\n",
  "MICHIGAN": "(US) a card game, equivalent to newmarket [n -S]\n",
  "MICHIGANS": "MICHIGAN, (US) a card game, equivalent to newmarket [n]\n",
  "MICHING": "the act of playing truant [n -S]\n",
  "MICHINGS": "MICHING, the act of playing truant [n]\n",
  "MICHT": "(Scots) might, power [n -S]\n",
  "MICHTS": "MICHT, (Scots) might, power [n]\n",
  "MICK": "an Irishman, also MICKY [n -S]\n",
  "MICKERIES": "MICKERY, (Native Australian) a well or waterhole, esp. in a dry riverbed [n]\n",
  "MICKERY": "(Native Australian) a well or waterhole, esp. in a dry riverbed [n MICKERIES]\n",
  "MICKEY": "to drug a drink [v -ED, -ING, -S]\n",
  "MICKEYED": "MICKEY, to drug a drink [v]\n",
  "MICKEYING": "MICKEY, to drug a drink [v]\n",
  "MICKEYS": "MICKEY, to drug a drink [v]\n",
  "MICKIES": "MICKY, an Irishman, also MICK [n]\n",
  "MICKLE": "a large amount [n -S] / much or great, also MEIKLE, MOCHELL, MUCHEL, MUCHELL [adj MICKLER, MICKLEST]\n",
  "MICKLER": "MICKLE, much or great, also MEIKLE, MOCHELL, MUCHEL, MUCHELL [adj]\n",
  "MICKLES": "MICKLE, a large amount [n]\n",
  "MICKLEST": "MICKLE, much or great, also MEIKLE, MOCHELL, MUCHEL, MUCHELL [adj]\n",
  "MICKS": "MICK, an Irishman, also MICKY [n]\n",
  "MICKY": "an Irishman, also MICK [n MICKIES]\n",
  "MICO": "(Tupi) the black-tailed marmoset [n -S]\n",
  "MICOS": "MICO, (Tupi) the black-tailed marmoset [n]\n",
  "MICRA": "MICRON, (Greek) a unit of length, also MIKRON [n]\n",
  "MICRIFIED": "MICRIFY, to make small [v]\n",
  "MICRIFIES": "MICRIFY, to make small [v]\n",
  "MICRIFY": "to make small [v MICRIFIED, MICRIFYING, MICRIFIES]\n",
  "MICRIFYING": "MICRIFY, to make small [v]\n",
  "MICRO": "(short for) a microprocessor [n -S]\n",
  "MICROAEROPHILE": "an organism, esp. a bacterium, that thrives in an environment low in oxygen [n -S]\n",
  "MICROAEROPHILES": "MICROAEROPHILE, an organism, esp. a bacterium, that thrives in an environment low in oxygen [n]\n",
  "MICROAEROPHILIC": "of or like a microaerophile, an organism, esp. a bacterium, that thrives in an environment low in oxygen [adj]\n",
  "MICROAGGRESSION": "indirect or subtle actions or statements regarded as denigrating a minority group [n]\n",
  "MICROAMPERE": "a millionth of an ampere [n -S]\n",
  "MICROAMPERES": "MICROAMPERE, a millionth of an ampere [n]\n",
  "MICROANALYSES": "MICROANALYSIS, chemical analysis on a small or minute scale [n]\n",
  "MICROANALYSIS": "chemical analysis on a small or minute scale [n MICROANALYSES]\n",
  "MICROANALYST": "one who undertakes microanalysis [n -S]\n",
  "MICROANALYSTS": "MICROANALYST, one who undertakes microanalysis [n]\n",
  "MICROANALYTIC": "relating to microanalysis, also MICROANALYTICAL [adj]\n",
  "MICROANALYTICAL": "relating to microanalysis, also MICROANALYTIC [adj]\n",
  "MICROANATOMICAL": "relating to microanatomy [adj]\n",
  "MICROANATOMIES": "MICROANATOMY, the study of microscopic tissues [n]\n",
  "MICROANATOMY": "the study of microscopic tissues [n MICROANATOMIES]\n",
  "MICROARRAY": "a collection of microscopic DNA spots, aka gene chip [n -S]\n",
  "MICROARRAYS": "MICROARRAY, a collection of microscopic DNA spots, aka gene chip [n]\n",
  "MICROBALANCE": "a balance designed to measure very small weights [n -S]\n",
  "MICROBALANCES": "MICROBALANCE, a balance designed to measure very small weights [n]\n",
  "MICROBAR": "a unit of atmospheric pressure [n -S]\n",
  "MICROBAROGRAPH": "an instrument for recording minute changes in atmospheric pressure [n -S]\n",
  "MICROBAROGRAPHS": "MICROBAROGRAPH, an instrument for recording minute changes in atmospheric pressure [n]\n",
  "MICROBARS": "MICROBAR, a unit of atmospheric pressure [n]\n",
  "MICROBE": "a microscopic organism [n -S]\n",
  "MICROBEAD": "a very small plastic particle, numbers of which are used as exfoliating agents in cosmetics [n -S]\n",
  "MICROBEADS": "MICROBEAD, a very small plastic particle, numbers of which are used as exfoliating agents in cosmetics [n]\n",
  "MICROBEAM": "a beam of radiation of small cross-section [n -S]\n",
  "MICROBEAMS": "MICROBEAM, a beam of radiation of small cross-section [n]\n",
  "MICROBES": "MICROBE, a microscopic organism [n]\n",
  "MICROBIAL": "of or like a microbe, also MICROBIAN, MICROBIC [adj]\n",
  "MICROBIAN": "of or like a microbe, also MICROBIAL, MICROBIC [adj]\n",
  "MICROBIC": "of or like a microbe, also MICROBIAL, MICROBIAN [adj]\n",
  "MICROBIOLOGIC": "relating to microbiology, also MICROBIOLOGICAL [adj]\n",
  "MICROBIOLOGICAL": "relating to microbiology, also MICROBIOLOGIC [adj]\n",
  "MICROBIOLOGIES": "MICROBIOLOGY, the study of microscopic organisms [n]\n",
  "MICROBIOLOGIST": "one who studies microbiology [n -S]\n",
  "MICROBIOLOGISTS": "MICROBIOLOGIST, one who studies microbiology [n]\n",
  "MICROBIOLOGY": "the study of microscopic organisms [n MICROBIOLOGIES]\n",
  "MICROBIOME": "the microscopic organisms, such as bacteria, which inhabit the human body in a symbiotic relationship [n -S]\n",
  "MICROBIOMES": "MICROBIOME, the microscopic organisms, such as bacteria, which inhabit the human body in a symbiotic relationship [n]\n",
  "MICROBIOTA": "the smallest soil organisms collectively [n -S]\n",
  "MICROBIOTAS": "MICROBIOTA, the smallest soil organisms collectively [n]\n",
  "MICROBLOG": "a blog in which there is a limitation on the length of individual postings [n -S]\n",
  "MICROBLOGGER": "one who keeps a microblog [n -S]\n",
  "MICROBLOGGERS": "MICROBLOGGER, one who keeps a microblog [n]\n",
  "MICROBLOGGING": "the practice of keeping a microblog [n -S]\n",
  "MICROBLOGGINGS": "MICROBLOGGING, the practice of keeping a microblog [n]\n",
  "MICROBLOGS": "MICROBLOG, a blog in which there is a limitation on the length of individual postings [n]\n",
  "MICROBREW": "a beer produced by a microbrewery [n -S]\n",
  "MICROBREWER": "a brewer who works in a microbrewery [n -S]\n",
  "MICROBREWERIES": "MICROBREWERY, a small brewery making specialty beer in limited quantities [n]\n",
  "MICROBREWERS": "MICROBREWER, a brewer who works in a microbrewery [n]\n",
  "MICROBREWERY": "a small brewery making specialty beer in limited quantities [n MICROBREWERIES]\n",
  "MICROBREWING": "production by a microbrew [n -S]\n",
  "MICROBREWINGS": "MICROBREWING, production by a microbrew [n]\n",
  "MICROBREWS": "MICROBREW, a beer produced by a microbrewery [n]\n",
  "MICROBUBBLES": "a contrast medium used with ultrasound, consisting of tiny bubbles of gas introduced into the vascular system [n]\n",
  "MICROBURST": "a sudden violent downward rush of air usually associated with thunderstorms, also DOWNBURST [n -S]\n",
  "MICROBURSTS": "MICROBURST, a sudden violent downward rush of air usually associated with thunderstorms, also DOWNBURST [n]\n",
  "MICROBUS": "a small bus [n MICROBUSES or MICROBUSSES]\n",
  "MICROBUSES": "MICROBUS, a small bus [n]\n",
  "MICROBUSSES": "MICROBUS, a small bus [n]\n",
  "MICROCAP": "of a company, having very small capitalisation [adj]\n",
  "MICROCAPSULE": "a tiny capsule containing material (as an adhesive or a medicine) that is released when the capsule is broken [n -S]\n",
  "MICROCAPSULES": "MICROCAPSULE, a tiny capsule containing material (as an adhesive or a medicine) that is released when the capsule is broken [n]\n",
  "MICROCAR": "a compact small-engined car [n -S]\n",
  "MICROCARD": "a card representing some 200 or more pages of a book in microscopic print [n -S]\n",
  "MICROCARDS": "MICROCARD, a card representing some 200 or more pages of a book in microscopic print [n]\n",
  "MICROCARS": "MICROCAR, a compact small-engined car [n]\n",
  "MICROCASSETTE": "a small cassette of magnetic tape [n -S]\n",
  "MICROCASSETTES": "MICROCASSETTE, a small cassette of magnetic tape [n]\n",
  "MICROCELEBRITY": "a very low-ranking celebrity [n]\n",
  "MICROCEPHAL": "someone having a very small head [n -S]\n",
  "MICROCEPHALIC": "having a very small head, also MICROCEPHALOUS [adj] / someone with a very small head [n -S]\n",
  "MICROCEPHALICS": "MICROCEPHALIC, someone with a very small head [n]\n",
  "MICROCEPHALIES": "MICROCEPHALY, the state of having a small head [n]\n",
  "MICROCEPHALOUS": "small-headed, also MICROCEPHALIC [adj]\n",
  "MICROCEPHALS": "MICROCEPHAL, someone having a very small head [n]\n",
  "MICROCEPHALY": "the state of having a small head [n MICROCEPHALIES]\n",
  "MICROCHEMICAL": "relating to microchemistry [adj]\n",
  "MICROCHEMISTRY": "small-scale chemistry [adj]\n",
  "MICROCHIP": "a chip of silicon [n -S] / to fit with a microchip [v MICROCHIPPED, MICROCHIPPING, MICROCHIPS]\n",
  "MICROCHIPPED": "MICROCHIP, to fit with a microchip [v]\n",
  "MICROCHIPPING": "MICROCHIP, to fit with a microchip [v]\n",
  "MICROCHIPS": "MICROCHIP, a chip of silicon [n]\n",
  "MICROCIRCUIT": "a compact electronic circuit [n -S]\n",
  "MICROCIRCUITRY": "circuitry composed of microcircuits [n]\n",
  "MICROCIRCUITS": "MICROCIRCUIT, a compact electronic circuit [n]\n",
  "MICROCLIMATE": "the climate of a very small area [n -S]\n",
  "MICROCLIMATES": "MICROCLIMATE, the climate of a very small area [n]\n",
  "MICROCLIMATIC": "relating to microclimate, the climate of a very small area [adj]\n",
  "MICROCLINE": "a mineral of the feldspar group [n -S]\n",
  "MICROCLINES": "MICROCLINE, a mineral of the feldspar group [n]\n",
  "MICROCOCCAL": "of or like a micrococcus [adj]\n",
  "MICROCOCCI": "MICROCOCCUS, a small spherical bacterium [n]\n",
  "MICROCOCCUS": "a small spherical bacterium [n MICROCOCCI]\n",
  "MICROCODE": "a micro-instruction [n -S]\n",
  "MICROCODES": "MICROCODE, a micro-instruction [n]\n",
  "MICROCOMPONENT": "a very small component [n -S]\n",
  "MICROCOMPONENTS": "MICROCOMPONENT, a very small component [n]\n",
  "MICROCOMPUTER": "a small computer usually equipped with a microprocessor [n -S]\n",
  "MICROCOMPUTERS": "MICROCOMPUTER, a small computer usually equipped with a microprocessor [n]\n",
  "MICROCOMPUTING": "computing with a microcomputer [n -S]\n",
  "MICROCOMPUTINGS": "MICROCOMPUTING, computing with a microcomputer [n]\n",
  "MICROCOPIED": "MICROCOPY, to copy on microfilm [v]\n",
  "MICROCOPIES": "MICROCOPY, to copy on microfilm [v]\n",
  "MICROCOPY": "a copy on microfilm [n MICROCOPIES] / to copy on microfilm [v MICROCOPIED, MICROCOPYING, MICROCOPIES]\n",
  "MICROCOPYING": "the act of copying on microfilm [n -S]\n",
  "MICROCOPYINGS": "MICROCOPYING, the act of copying on microfilm [n]\n",
  "MICROCOSM": "the world of human nature (as opposed to all nature); humanity viewed as an epitome of the universe [n -S]\n",
  "MICROCOSMIC": "of or like a microcosm, also MICROCOSMICAL [adj MICROCOSMICALLY]\n",
  "MICROCOSMICAL": "of or like a microcosm, also MICROCOSMIC [adj MICROCOSMICALLY]\n",
  "MICROCOSMICALLY": "MICROCOSMICAL, of or like a microcosm, also MICROCOSMIC [adv]\n",
  "MICROCOSMOS": "a little universe or world [n -ES]\n",
  "MICROCOSMOSES": "MICROCOSMOS, a little universe or world [n]\n",
  "MICROCOSMS": "MICROCOSM, the world of human nature (as opposed to all nature); humanity viewed as an epitome of the universe [n]\n",
  "MICROCRACK": "to crack microscopically [v MICROCRACKED, MICROCRACKING, MICROCRACKS]\n",
  "MICROCRACKED": "MICROCRACK, to crack microscopically [v]\n",
  "MICROCRACKING": "microscopic cracking [n -S]\n",
  "MICROCRACKINGS": "MICROCRACKING, microscopic cracking [n]\n",
  "MICROCRACKS": "MICROCRACK, to crack microscopically [v]\n",
  "MICROCRYSTAL": "a microscopic crystal [n -S]\n",
  "MICROCRYSTALS": "MICROCRYSTAL, a microscopic crystal [n]\n",
  "MICROCULTURAL": "relating to microculture [adj]\n",
  "MICROCULTURE": "a microscopic culture of cells or organisms [n -S]\n",
  "MICROCULTURES": "MICROCULTURE, a microscopic culture of cells or organisms [n]\n",
  "MICROCURIE": "a unit of radiation, a millionth of a curie [n -S]\n",
  "MICROCURIES": "MICROCURIE, a unit of radiation, a millionth of a curie [n]\n",
  "MICROCYTE": "an unusually small red blood cell [n -S]\n",
  "MICROCYTES": "MICROCYTE, an unusually small red blood cell [n]\n",
  "MICROCYTIC": "of or like a microcyte [adj]\n",
  "MICRODETECTION": "the detection of minute amounts of change [n -S]\n",
  "MICRODETECTIONS": "MICRODETECTION, the detection of minute amounts of change [n]\n",
  "MICRODETECTOR": "an instrument for detecting minute amounts of changes [n -S]\n",
  "MICRODETECTORS": "MICRODETECTOR, an instrument for detecting minute amounts of changes [n]\n",
  "MICRODISSECTION": "dissection under the microscope [n]\n",
  "MICRODONT": "having unusually small teeth, also MICRODONTOUS [adj]\n",
  "MICRODONTOUS": "having very small teeth, also MICRODONT [adj]\n",
  "MICRODOT": "a copy of printed matter reduced to the size of a dot [n -S]\n",
  "MICRODOTS": "MICRODOT, a copy of printed matter reduced to the size of a dot [n]\n",
  "MICRODRIVE": "a very small hard disk drive [n -S]\n",
  "MICRODRIVES": "MICRODRIVE, a very small hard disk drive [n]\n",
  "MICRODRONE": "a small remote-controlled unmanned flying object [n -S]\n",
  "MICRODRONES": "MICRODRONE, a small remote-controlled unmanned flying object [n]\n",
  "MICROEARTHQUAKE": "an earthquake of low intensity [n]\n",
  "MICROECONOMIC": "relating to microeconomics [adj]\n",
  "MICROECONOMICS": "a study of economics in terms of individual areas of activity (as a firm, household, or prices) [n]\n",
  "MICROELECTRODE": "a minute electrode [n -S]\n",
  "MICROELECTRODES": "MICROELECTRODE, a minute electrode [n]\n",
  "MICROELECTRONIC": "relating to microelectronics [adj]\n",
  "MICROELEMENT": "a trace element [n -S]\n",
  "MICROELEMENTS": "MICROELEMENT, a trace element [n]\n",
  "MICROEVOLUTION": "comparatively minor evolutionary change involving the accumulation of variations in populations usually below the species level [n -S]\n",
  "MICROEVOLUTIONS": "MICROEVOLUTION, comparatively minor evolutionary change involving the accumulation of variations in populations usually below the species level [n]\n",
  "MICROFARAD": "the millionth part of a farad [n -S]\n",
  "MICROFARADS": "MICROFARAD, the millionth part of a farad [n]\n",
  "MICROFAUNA": "very small animals [n MICROFAUNAE or MICROFAUNAS]\n",
  "MICROFAUNAE": "MICROFAUNA, very small animals [n]\n",
  "MICROFAUNAL": "relating to microfauna, very small animals [adj]\n",
  "MICROFAUNAS": "MICROFAUNA, very small animals [n]\n",
  "MICROFELSITIC": "of the cryptocrystalline texture of a quartz-felsite groundmass [adj]\n",
  "MICROFIBER": "a cloth of tightly woven synthetic fibre, also MICROFIBRE [n -S]\n",
  "MICROFIBERS": "MICROFIBER, a cloth of tightly woven synthetic fibre, also MICROFIBRE [n]\n",
  "MICROFIBRE": "a cloth of tightly woven synthetic fibre, also MICROFIBER [n -S]\n",
  "MICROFIBRES": "MICROFIBRE, a cloth of tightly woven synthetic fibre, also MICROFIBER [n]\n",
  "MICROFIBRIL": "a fine fibril [n -S]\n",
  "MICROFIBRILLAR": "of or like a microfibril, a fine fibril [adj]\n",
  "MICROFIBRILS": "MICROFIBRIL, a fine fibril [n]\n",
  "MICROFICHE": "a sheet of microfilm containing rows of images of pages of printed matter [n -S]\n",
  "MICROFICHES": "MICROFICHE, a sheet of microfilm containing rows of images of pages of printed matter [n]\n",
  "MICROFILAMENT": "a very thin filament present in large numbers in muscle and the cytoplasm of other cells [n -S]\n",
  "MICROFILAMENTS": "MICROFILAMENT, a very thin filament present in large numbers in muscle and the cytoplasm of other cells [n]\n",
  "MICROFILARIA": "the minute larval form of a filarial worm [n MICROFILARIAE]\n",
  "MICROFILARIAE": "MICROFILARIA, the minute larval form of a filarial worm [n]\n",
  "MICROFILARIAL": "MICROFILARIA, the minute larval form of a filarial worm [adj]\n",
  "MICROFILING": "the process of microfilming the contents of a file [n -S]\n",
  "MICROFILINGS": "MICROFILING, the process of microfilming the contents of a file [n]\n",
  "MICROFILM": "to make a microfilm copy of, a photographic film with one or more very small images of printed or other graphic matter [v -ED, -ING, -S]\n",
  "MICROFILMABLE": "capable of being transferred to microfilm [adj]\n",
  "MICROFILMED": "MICROFILM, to make a microfilm copy of, a photographic film with one or more very small images of printed or other graphic matter [v]\n",
  "MICROFILMER": "one who works with microfilm [n -S]\n",
  "MICROFILMERS": "MICROFILMER, one who works with microfilm [n]\n",
  "MICROFILMING": "MICROFILM, to make a microfilm copy of, a photographic film with one or more very small images of printed or other graphic matter [v]\n",
  "MICROFILMS": "MICROFILM, to make a microfilm copy of, a photographic film with one or more very small images of printed or other graphic matter [v]\n",
  "MICROFILTER": "a very small filter [n -S]\n",
  "MICROFILTERS": "MICROFILTER, a very small filter [n]\n",
  "MICROFINE": "consisting of or being particles of minute size [adj]\n",
  "MICROFLOPPIES": "MICROFLOPPY, a small floppy disk [n]\n",
  "MICROFLOPPY": "a small floppy disk [n MICROFLOPPIES]\n",
  "MICROFLORA": "very small plants, not visible to the naked eye [n MICROFLORAE or MICROFLORAS]\n",
  "MICROFLORAE": "MICROFLORA, very small plants, not visible to the naked eye [n]\n",
  "MICROFLORAL": "relating to microflora, very small plants [adj]\n",
  "MICROFLORAS": "MICROFLORA, very small plants, not visible to the naked eye [n]\n",
  "MICROFORM": "a process for reproducing printed matter in much reduced size [n -S]\n",
  "MICROFORMS": "MICROFORM, a process for reproducing printed matter in much reduced size [n]\n",
  "MICROFOSSIL": "a very small fossil [n -S]\n",
  "MICROFOSSILS": "MICROFOSSIL, a very small fossil [n]\n",
  "MICROFUNGI": "MICROFUNGUS, a very small fungus [n]\n",
  "MICROFUNGUS": "a very small fungus [n MICROFUNGI or MICROFUNGUSES]\n",
  "MICROFUNGUSES": "MICROFUNGUS, a very small fungus [n]\n",
  "MICROGAMETE": "the smaller, generally the male, gamete [n -S]\n",
  "MICROGAMETES": "MICROGAMETE, the smaller, generally the male, gamete [n]\n",
  "MICROGAMETOCYTE": "a gametocyte producing microgametes [n]\n",
  "MICROGENERATION": "the small-scale generation of electrical power, through means such as solar or wind power [n]\n",
  "MICROGLIA": "a type of non-nervous tissue found in the central nervous system [n -S]\n",
  "MICROGLIAS": "MICROGLIA, a type of non-nervous tissue found in the central nervous system [n]\n",
  "MICROGRAM": "a millionth of a gram [n -S]\n",
  "MICROGRAMS": "MICROGRAM, a millionth of a gram [n]\n",
  "MICROGRANITE": "a minutely crystalline variety of granite [n -S]\n",
  "MICROGRANITES": "MICROGRANITE, a minutely crystalline variety of granite [n]\n",
  "MICROGRANITIC": "of or like microgranite, a minutely crystalline variety of granite [adj]\n",
  "MICROGRAPH": "an instrument used to write on a very small scale [n -S] / to write with a micrograph [v -ED, -ING, -S]\n",
  "MICROGRAPHED": "MICROGRAPH, to write with a micrograph [v]\n",
  "MICROGRAPHER": "a person who draws or describes microscopic objects [n -S]\n",
  "MICROGRAPHERS": "MICROGRAPHER, a person who draws or describes microscopic objects [n]\n",
  "MICROGRAPHIC": "relating to micrographics, the production of photographically reduced texts [adj]\n",
  "MICROGRAPHICS": "the industry concerned with the manufacture and sale of graphic material in microform [n]\n",
  "MICROGRAPHIES": "MICROGRAPHY, the art of writing on a very small scale [n]\n",
  "MICROGRAPHING": "MICROGRAPH, to write with a micrograph [v]\n",
  "MICROGRAPHS": "MICROGRAPH, an instrument used to write on a very small scale [n]\n",
  "MICROGRAPHY": "the art of writing on a very small scale [n MICROGRAPHIES]\n",
  "MICROGRAVITIES": "MICROGRAVITY, a condition in space in which only minuscule forces are experienced [n]\n",
  "MICROGRAVITY": "a condition in space in which only minuscule forces are experienced [n MICROGRAVITIES]\n",
  "MICROGREENS": "the shoots of young salad plants, served as a vegetable dish [n]\n",
  "MICROGROOVE": "the fine groove of long-playing gramophone records [n -S]\n",
  "MICROGROOVES": "MICROGROOVE, the fine groove of long-playing gramophone records [n]\n",
  "MICROHABITAT": "the microenvironment in which an organism lives [n -S]\n",
  "MICROHABITATS": "MICROHABITAT, the microenvironment in which an organism lives [n]\n",
  "MICROHM": "a unit of electrical resistance, the millionth part of an ohm [n -S]\n",
  "MICROHMS": "MICROHM, a unit of electrical resistance, the millionth part of an ohm [n]\n",
  "MICROIMAGE": "a very small image [n -S]\n",
  "MICROIMAGES": "MICROIMAGE, a very small image [n]\n",
  "MICROINCH": "one millionth of an inch [n -ES]\n",
  "MICROINCHES": "MICROINCH, one millionth of an inch [n]\n",
  "MICROINJECT": "to inject (a substance) into a microscopic object, esp. a single cell [v -ED, -ING, -S]\n",
  "MICROINJECTED": "MICROINJECT, to inject (a substance) into a microscopic object, esp. a single cell [v]\n",
  "MICROINJECTING": "MICROINJECT, to inject (a substance) into a microscopic object, esp. a single cell [v]\n",
  "MICROINJECTION": "an injection, e.g. into a single cell, performed under a microscope [n -S]\n",
  "MICROINJECTIONS": "MICROINJECTION, an injection, e.g. into a single cell, performed under a microscope [n]\n",
  "MICROINJECTS": "MICROINJECT, to inject (a substance) into a microscopic object, esp. a single cell [v]\n",
  "MICROJET": "a light jet aircraft [n -S]\n",
  "MICROJETS": "MICROJET, a light jet aircraft [n]\n",
  "MICROLIGHT": "a very light aircraft [n -S]\n",
  "MICROLIGHTING": "the activity or sport of flying microlight aircraft [n -S]\n",
  "MICROLIGHTINGS": "MICROLIGHTING, the activity or sport of flying microlight aircraft [n]\n",
  "MICROLIGHTS": "MICROLIGHT, a very light aircraft [n]\n",
  "MICROLITE": "a rare mineral of resinous luster and high specific gravity, a tantalate of calcium [n -S]\n",
  "MICROLITER": "a millionth of a liter, also MICROLITRE [n -S]\n",
  "MICROLITERS": "MICROLITER, a millionth of a liter, also MICROLITRE [n]\n",
  "MICROLITES": "MICROLITE, a rare mineral of resinous luster and high specific gravity, a tantalate of calcium [n]\n",
  "MICROLITH": "a very small stone tool [n -S]\n",
  "MICROLITHIC": "of or like a microlith [adj]\n",
  "MICROLITHS": "MICROLITH, a very small stone tool [n]\n",
  "MICROLITIC": "of or like microlite, a rare mineral of resinous luster and high specific gravity [adj]\n",
  "MICROLITRE": "a millionth of a litre, also MICROLITER [n -S]\n",
  "MICROLITRES": "MICROLITRE, a millionth of a litre, also MICROLITER [n]\n",
  "MICROLOAN": "a very small loan [n -S]\n",
  "MICROLOANS": "MICROLOAN, a very small loan [n]\n",
  "MICROLOGIC": "relating to micrology, also MICROLOGICAL [adj MICROLOGICALLY]\n",
  "MICROLOGICAL": "relating to micrology, also MICROLOGIC [adj MICROLOGICALLY]\n",
  "MICROLOGICALLY": "MICROLOGICAL, relating to micrology, also MICROLOGIC [adv]\n",
  "MICROLOGIES": "MICROLOGY, the branch of science which depends on the use of a microscope [n]\n",
  "MICROLOGIST": "a practitioner of micrology, the branch of science which depends on the use of a microscope [n -S]\n",
  "MICROLOGISTS": "MICROLOGIST, a practitioner of micrology, the branch of science which depends on the use of a microscope [n]\n",
  "MICROLOGY": "the branch of science which depends on the use of a microscope [n MICROLOGIES]\n",
  "MICROLUCES": "MICROLUX, a unit of illumination [n]\n",
  "MICROLUX": "a unit of illumination [n MICROLUXES or MICROLUCES]\n",
  "MICROLUXES": "MICROLUX, a unit of illumination [n]\n",
  "MICROMANAGE": "to manage at a detailed level [v MICROMANAGED, MICROMANAGING, MICROMANAGES]\n",
  "MICROMANAGED": "MICROMANAGE, to manage at a detailed level [v]\n",
  "MICROMANAGEMENT": "management at a very detailed level [n]\n",
  "MICROMANAGER": "one who micromanages [n -S]\n",
  "MICROMANAGERS": "MICROMANAGER, one who micromanages [n]\n",
  "MICROMANAGES": "MICROMANAGE, to manage at a detailed level [v]\n",
  "MICROMANAGING": "MICROMANAGE, to manage at a detailed level [v]\n",
  "MICROMARKETING": "very small-scale marketing [n -S]\n",
  "MICROMARKETINGS": "MICROMARKETING, very small-scale marketing [n]\n",
  "MICROMERE": "a small cell formed by unequal division of an ovum or embryo, e.g. in sea urchins [n -S]\n",
  "MICROMERES": "MICROMERE, a small cell formed by unequal division of an ovum or embryo, e.g. in sea urchins [n]\n",
  "MICROMESH": "a very fine mesh [n -ES]\n",
  "MICROMESHES": "MICROMESH, a very fine mesh [n]\n",
  "MICROMETEORITE": "a very small meteorite [n -S]\n",
  "MICROMETEORITES": "MICROMETEORITE, a very small meteorite [n]\n",
  "MICROMETEORITIC": "of or like a micrometeorite [adj]\n",
  "MICROMETEOROID": "a small meteoroid [n -S]\n",
  "MICROMETEOROIDS": "MICROMETEOROID, a small meteoroid [n]\n",
  "MICROMETER": "an instrument for measuring very small distances [n -S]\n",
  "MICROMETERS": "MICROMETER, an instrument for measuring very small distances [n]\n",
  "MICROMETHOD": "a method (as of microanalysis) that requires only very small quantities of material or that involves the use of the microscope [n -S]\n",
  "MICROMETHODS": "MICROMETHOD, a method (as of microanalysis) that requires only very small quantities of material or that involves the use of the microscope [n]\n",
  "MICROMETRE": "a millionth of a metre [n -S]\n",
  "MICROMETRES": "MICROMETRE, a millionth of a metre [n]\n",
  "MICROMETRIC": "relating to micrometry, also MICROMETRICAL [adj]\n",
  "MICROMETRICAL": "relating to micrometry, also MICROMETRIC [adj]\n",
  "MICROMETRIES": "MICROMETRY, the art of measuring with a micrometer [n]\n",
  "MICROMETRY": "the art of measuring with a micrometer [n MICROMETRIES]\n",
  "MICROMHO": "a unit of electrical conductance [n -S]\n",
  "MICROMHOS": "MICROMHO, a unit of electrical conductance [n]\n",
  "MICROMICROCURIE": "the trillionth part of a curie [n]\n",
  "MICROMICROFARAD": "the trillionth part of a farad [n]\n",
  "MICROMILLIMETRE": "a millionth part of a millimetre (now called a nanometre) [n]\n",
  "MICROMINI": "something extremely small [n -S]\n",
  "MICROMINIATURE": "made on a very small scale [adj]\n",
  "MICROMINIS": "MICROMINI, something extremely small [n]\n",
  "MICROMOLAR": "relating to a micromole, a millionth of a mole [adj]\n",
  "MICROMOLE": "a millionth of a mole [n -S]\n",
  "MICROMOLES": "MICROMOLE, a millionth of a mole [n]\n",
  "MICROMORPHOLOGY": "the microscopic structure of a material, as a mineral or a biological cell, aka microstructure [n]\n",
  "MICROMORT": "a unit of risk equal to a one in a million chance of dying [n -S]\n",
  "MICROMORTS": "MICROMORT, a unit of risk equal to a one in a million chance of dying [n]\n",
  "MICRON": "(Greek) a unit of length, also MIKRON [n MICRONS or MICRA]\n",
  "MICRONATION": "an entity that resembles an independent nation or state but which is unrecognized by world governments or major international organisations [n -S]\n",
  "MICRONATIONS": "MICRONATION, an entity that resembles an independent nation or state but which is unrecognized by world governments or major international organisations [n]\n",
  "MICRONEEDLE": "a very fine needle used in micromanipulation [n -S]\n",
  "MICRONEEDLES": "MICRONEEDLE, a very fine needle used in micromanipulation [n]\n",
  "MICRONISATION": "the process of micronising, also MICRONIZATION [n -S]\n",
  "MICRONISATIONS": "MICRONISATION, the process of micronising, also MICRONIZATION [n]\n",
  "MICRONISE": "to reduce to a few microns in diameter, also MICRONIZE [v MICRONISED, MICRONISING, MICRONISES]\n",
  "MICRONISED": "MICRONISE, to reduce to a few microns in diameter, also MICRONIZE [v]\n",
  "MICRONISES": "MICRONISE, to reduce to a few microns in diameter, also MICRONIZE [v]\n",
  "MICRONISING": "MICRONISE, to reduce to a few microns in diameter, also MICRONIZE [v]\n",
  "MICRONIZATION": "the process of micronizing, also MICRONISATION [n -S]\n",
  "MICRONIZATIONS": "MICRONIZATION, the process of micronizing, also MICRONISATION [n]\n",
  "MICRONIZE": "to reduce to a few microns in diameter, also MICRONISE [v MICRONIZED, MICRONIZING, MICRONIZES]\n",
  "MICRONIZED": "MICRONIZE, to reduce to a few microns in diameter, also MICRONISE [v]\n",
  "MICRONIZES": "MICRONIZE, to reduce to a few microns in diameter, also MICRONISE [v]\n",
  "MICRONIZING": "MICRONIZE, to reduce to a few microns in diameter, also MICRONISE [v]\n",
  "MICRONS": "MICRON, (Greek) a unit of length, also MIKRON [n]\n",
  "MICRONUCLEI": "MICRONUCLEUS, a minute nucleus [n]\n",
  "MICRONUCLEUS": "a minute nucleus [n MICRONUCLEI or MICRONUCLEUSES]\n",
  "MICRONUCLEUSES": "MICRONUCLEUS, a minute nucleus [n]\n",
  "MICRONUTRIENT": "a nutritive substance required in minute quantities by a living organism [n -S]\n",
  "MICRONUTRIENTS": "MICRONUTRIENT, a nutritive substance required in minute quantities by a living organism [n]\n",
  "MICROORGANISM": "an organism (as a bacterium or protozoan) of microscopic or ultramicroscopic size [n -S]\n",
  "MICROORGANISMS": "MICROORGANISM, an organism (as a bacterium or protozoan) of microscopic or ultramicroscopic size [n]\n",
  "MICROPARASITE": "a very small parasite [n -S]\n",
  "MICROPARASITES": "MICROPARASITE, a very small parasite [n]\n",
  "MICROPARASITIC": "relating to a microparasite [adj]\n",
  "MICROPARTICLE": "a very small particle [n -S]\n",
  "MICROPARTICLES": "MICROPARTICLE, a very small particle [n]\n",
  "MICROPARTIES": "MICROPARTY, a small political party, especially one focussing on a single issue [n]\n",
  "MICROPARTY": "a small political party, especially one focussing on a single issue [n MICROPARTIES]\n",
  "MICROPAYMENT": "payment of a small or prorated sum for each access to a service, esp. on the Internet (as opposed to payment by subscription, etc.) [n -S]\n",
  "MICROPAYMENTS": "MICROPAYMENT, payment of a small or prorated sum for each access to a service, esp. on the Internet (as opposed to payment by subscription, etc.) [n]\n",
  "MICROPEGMATITE": "a microscopic intergrowth of quartz and feldspar [n -S]\n",
  "MICROPEGMATITES": "MICROPEGMATITE, a microscopic intergrowth of quartz and feldspar [n]\n",
  "MICROPEGMATITIC": "relating to micropegmatite, a microscopic intergrowth of quartz and feldspar [adj]\n",
  "MICROPHAGE": "a small phagocyte [n -S]\n",
  "MICROPHAGES": "MICROPHAGE, a small phagocyte [n]\n",
  "MICROPHAGOUS": "of an animal, feeding on small particles of food [adj]\n",
  "MICROPHONE": "an instrument whereby sound waves are caused to generate or modulate an electric current usually for the purpose of transmitting or recording sound (as speech or music) [n -S]\n",
  "MICROPHONES": "MICROPHONE, an instrument whereby sound waves are caused to generate or modulate an electric current usually for the purpose of transmitting or recording sound (as speech or music) [n]\n",
  "MICROPHONIC": "relating to a microphone [adj]\n",
  "MICROPHONICS": "noises in a loudspeaker caused by mechanical shock or vibration of the electronic components [n]\n",
  "MICROPHOTOGRAPH": "a small photograph that is normally magnified for viewing [n]\n",
  "MICROPHOTOMETER": "an instrument for measuring the amount of light transmitted or reflected by small areas or for measuring the relative densities of spectral lines on a photographic film or plate [n]\n",
  "MICROPHOTOMETRY": "measurement by microphotometer, an instrument for measuring the amount of light transmitted or reflected by small areas or for measuring the relative densities of spectral lines on a photographic film or plate [n]\n",
  "MICROPHYLL": "a type of (usually small) leaf having a single medial vein, characteristic of the glycophytes (clubmosses, spike mosses, and quillworts) [n -S]\n",
  "MICROPHYLLOUS": "having minute leaves [adj]\n",
  "MICROPHYLLS": "MICROPHYLL, a type of (usually small) leaf having a single medial vein, characteristic of the glycophytes (clubmosses, spike mosses, and quillworts) [n]\n",
  "MICROPHYSICAL": "relating to microphysics [adj MICROPHYSICALLY]\n",
  "MICROPHYSICALLY": "MICROPHYSICAL, relating to microphysics [adv]\n",
  "MICROPHYSICIST": "a physicist who specializes in microphysics [n -S]\n",
  "MICROPHYSICISTS": "MICROPHYSICIST, a physicist who specializes in microphysics [n]\n",
  "MICROPHYSICS": "the physics of molecules, atoms, and elementary particles [n]\n",
  "MICROPHYTE": "a very minute plant, one of certain unicellular algae, such as the germs of various infectious diseases are believed to be [n -S]\n",
  "MICROPHYTES": "MICROPHYTE, a very minute plant, one of certain unicellular algae, such as the germs of various infectious diseases are believed to be [n]\n",
  "MICROPHYTIC": "of or like a microphyte [adj]\n",
  "MICROPIPET": "a very fine pipet, also MICROPIPETTE [n -S]\n",
  "MICROPIPETS": "MICROPIPET, a very fine pipet, also MICROPIPETTE [n]\n",
  "MICROPIPETTE": "a very fine pipette, also MICROPIPET [n -S]\n",
  "MICROPIPETTES": "MICROPIPETTE, a very fine pipette, also MICROPIPET [n]\n",
  "MICROPLANKTON": "very small plankton [n -S]\n",
  "MICROPLANKTONS": "MICROPLANKTON, very small plankton [n]\n",
  "MICROPLASTIC": "very small particles of plastic debris persisting as waste material in the environment following the breakdown of rubbish [n -S]\n",
  "MICROPLASTICS": "MICROPLASTIC, very small particles of plastic debris persisting as waste material in the environment following the breakdown of rubbish [n]\n",
  "MICROPOLIS": "a small city [n -ES]\n",
  "MICROPOLISES": "MICROPOLIS, a small city [n]\n",
  "MICROPORE": "a very small pore [n -S]\n",
  "MICROPORES": "MICROPORE, a very small pore [n]\n",
  "MICROPOROSITIES": "MICROPOROSITY, the property of micropores, very small pores [n]\n",
  "MICROPOROSITY": "the property of micropores, very small pores [n MICROPOROSITIES]\n",
  "MICROPOROUS": "of or like a micropore [adj]\n",
  "MICROPOWER": "generating, using, or relating to small amounts of power [n -S]\n",
  "MICROPOWERS": "MICROPOWER, generating, using, or relating to small amounts of power [n]\n",
  "MICROPRINT": "a microphotograph of e.g. printed text [n -S] / to make a microprint of [v -ED, -ING, -S]\n",
  "MICROPRINTED": "MICROPRINT, to make a microprint of [v]\n",
  "MICROPRINTING": "the act of making a microprint of [n -S]\n",
  "MICROPRINTINGS": "MICROPRINTING, the act of making a microprint of [n]\n",
  "MICROPRINTS": "MICROPRINT, a microphotograph of e.g. printed text [n]\n",
  "MICROPRISM": "a tiny prism used as a focusing aid on a single-lens reflex camera [n -S]\n",
  "MICROPRISMS": "MICROPRISM, a tiny prism used as a focusing aid on a single-lens reflex camera [n]\n",
  "MICROPROBE": "a device that produces a very thin electron beam by which the chemical makeup of various compounds may be examined [n -S]\n",
  "MICROPROBES": "MICROPROBE, a device that produces a very thin electron beam by which the chemical makeup of various compounds may be examined [n]\n",
  "MICROPROCESSING": "the processing of data by a microprocessor [n]\n",
  "MICROPROCESSOR": "a computer processor contained on an integrated-circuit chip [n -S]\n",
  "MICROPROCESSORS": "MICROPROCESSOR, a computer processor contained on an integrated-circuit chip [n]\n",
  "MICROPROGRAM": "a routine composed of microinstructions used in microprogramming [n -S]\n",
  "MICROPROGRAMS": "MICROPROGRAM, a routine composed of microinstructions used in microprogramming [n]\n",
  "MICROPROJECTION": "the use of a microprojector, a projector utilizing a compound microscope for projecting on a screen a greatly enlarged image of a microscopic object [n]\n",
  "MICROPROJECTOR": "a projector utilizing a compound microscope for projecting on a screen a greatly enlarged image of a microscopic object [n -S]\n",
  "MICROPROJECTORS": "MICROPROJECTOR, a projector utilizing a compound microscope for projecting on a screen a greatly enlarged image of a microscopic object [n]\n",
  "MICROPSIA": "a condition of the eyes in which objects appear smaller than normal [n -S]\n",
  "MICROPSIAS": "MICROPSIA, a condition of the eyes in which objects appear smaller than normal [n]\n",
  "MICROPTEROUS": "having small wings or fins [adj]\n",
  "MICROPUBLISHER": "one who publishes in microform, a process for reproducing printed matter in much reduced size [n -S]\n",
  "MICROPUBLISHERS": "MICROPUBLISHER, one who publishes in microform, a process for reproducing printed matter in much reduced size [n]\n",
  "MICROPUBLISHING": "publishing in microform [n]\n",
  "MICROPULSATION": "a pulsation having a short period [n -S]\n",
  "MICROPULSATIONS": "MICROPULSATION, a pulsation having a short period [n]\n",
  "MICROPUMP": "a miniature pump inserted under the skin to administer a drug [n -S]\n",
  "MICROPUMPS": "MICROPUMP, a miniature pump inserted under the skin to administer a drug [n]\n",
  "MICROPUNCTURE": "an extremely small puncture (as of a nephron) [n -S]\n",
  "MICROPUNCTURES": "MICROPUNCTURE, an extremely small puncture (as of a nephron) [n]\n",
  "MICROPYLAR": "of or like a micropyle, a micropore in ovum for spermatozoon [adj]\n",
  "MICROPYLE": "a micropore in ovum for spermatozoon; a minute pollen opening in a plant ovule [n -S]\n",
  "MICROPYLES": "MICROPYLE, a micropore in ovum for spermatozoon; a minute pollen opening in a plant ovule [n]\n",
  "MICROPYROMETER": "a pyrometer for measuring the temperature of very small objects [n -S]\n",
  "MICROPYROMETERS": "MICROPYROMETER, a pyrometer for measuring the temperature of very small objects [n]\n",
  "MICROQUAKE": "a very small earthquake [n -S]\n",
  "MICROQUAKES": "MICROQUAKE, a very small earthquake [n]\n",
  "MICRORADIOGRAPH": "an X-ray produced by microradiography [n]\n",
  "MICROREADER": "a device that produces an enlarged image of a microphotograph or microfilm [n -S]\n",
  "MICROREADERS": "MICROREADER, a device that produces an enlarged image of a microphotograph or microfilm [n]\n",
  "MICROS": "MICRO, (short for) a microprocessor [n]\n",
  "MICROSATELLITE": "a very small satellite [n -S]\n",
  "MICROSATELLITES": "MICROSATELLITE, a very small satellite [n]\n",
  "MICROSCALE": "an extremely small scale [n -S]\n",
  "MICROSCALES": "MICROSCALE, an extremely small scale [n]\n",
  "MICROSCOPE": "an optical instrument consisting of a lens or combination of lenses for making enlarged images of minute objects [n -S]\n",
  "MICROSCOPES": "MICROSCOPE, an optical instrument consisting of a lens or combination of lenses for making enlarged images of minute objects [n]\n",
  "MICROSCOPIC": "able to be seen only though a microscope, also MICROSCOPICAL [adj MICROSCOPICALLY]\n",
  "MICROSCOPICAL": "able to be seen only though a microscope, also MICROSCOPIC [adj MICROSCOPICALLY]\n",
  "MICROSCOPICALLY": "MICROSCOPICAL, able to be seen only though a microscope, also MICROSCOPIC [adv]\n",
  "MICROSCOPIES": "MICROSCOPY, the use of the microscope [n]\n",
  "MICROSCOPIST": "one who uses a microscope [n -S]\n",
  "MICROSCOPISTS": "MICROSCOPIST, one who uses a microscope [n]\n",
  "MICROSCOPY": "the use of the microscope [n MICROSCOPIES]\n",
  "MICROSECOND": "one millionth of a second [n -S]\n",
  "MICROSECONDS": "MICROSECOND, one millionth of a second [n]\n",
  "MICROSEISM": "a small earth tremor [n -S]\n",
  "MICROSEISMIC": "relating to a microseism, a small earth tremor, also MICROSEISMICAL [adj]\n",
  "MICROSEISMICAL": "relating to a microseism, a small earth tremor, also MICROSEISMIC [adj]\n",
  "MICROSEISMICITY": "the state of being microseismic [n]\n",
  "MICROSEISMS": "MICROSEISM, a small earth tremor [n]\n",
  "MICROSITE": "a website that is intended for a specific limited purpose [n -S]\n",
  "MICROSITES": "MICROSITE, a website that is intended for a specific limited purpose [n]\n",
  "MICROSKIRT": "a very short skirt [n -S]\n",
  "MICROSKIRTS": "MICROSKIRT, a very short skirt [n]\n",
  "MICROSLEEP": "a very short sleep [n -S]\n",
  "MICROSLEEPS": "MICROSLEEP, a very short sleep [n]\n",
  "MICROSMATIC": "of humans and certain animals, having a poor sense of smell [adj]\n",
  "MICROSOMAL": "of or like a microsome [adj]\n",
  "MICROSOME": "a minute granule or drop in cytoplasm [n -S]\n",
  "MICROSOMES": "MICROSOME, a minute granule or drop in cytoplasm [n]\n",
  "MICROSPECIES": "a genetically distinct group of organisms within a species [n]\n",
  "MICROSPHERE": "a small sphere [n -S]\n",
  "MICROSPHERES": "MICROSPHERE, a small sphere [n]\n",
  "MICROSPHERICAL": "of or like a microsphere [adj]\n",
  "MICROSPORANGIA": "MICROSPORANGIUM, the sporangium in heterosporous plants where the microspores develop [n]\n",
  "MICROSPORANGIUM": "the sporangium in heterosporous plants where the microspores develop [n MICROSPORANGIA]\n",
  "MICROSPORE": "a spore giving rise to a male gametophyte [n -S]\n",
  "MICROSPORES": "MICROSPORE, a spore giving rise to a male gametophyte [n]\n",
  "MICROSPORIC": "like a microspore, also MICROSPOROUS [adj]\n",
  "MICROSPORIDIAN": "relating to a class of small parasites [adj]\n",
  "MICROSPOROCYTE": "a microspore mother cell [n -S]\n",
  "MICROSPOROCYTES": "MICROSPOROCYTE, a microspore mother cell [n]\n",
  "MICROSPOROPHYLL": "a specialised leaf bearing or subtending one or more microsporangia [n]\n",
  "MICROSPOROUS": "of or like a microspore, also MICROSPORIC [adj]\n",
  "MICROSTATE": "a tiny country [n -S]\n",
  "MICROSTATES": "MICROSTATE, a tiny country [n]\n",
  "MICROSTOMATOUS": "having an unusually small mouth, also MICROSTOMOUS [adj]\n",
  "MICROSTOMOUS": "having an unusually small mouth, also MICROSTOMATOUS [adj]\n",
  "MICROSTRUCTURAL": "relating to microstructure [adj]\n",
  "MICROSTRUCTURE": "the microscopic structure of a material, as a mineral or a biological cell [n -S]\n",
  "MICROSTRUCTURES": "MICROSTRUCTURE, the microscopic structure of a material, as a mineral or a biological cell [n]\n",
  "MICROSURGEON": "a surgeon who specialises in microsurgery [n -S]\n",
  "MICROSURGEONS": "MICROSURGEON, a surgeon who specialises in microsurgery [n]\n",
  "MICROSURGERIES": "MICROSURGERY, minute dissection or manipulation (as by a micromanipulator or laser beam) of living structures or tissue [n]\n",
  "MICROSURGERY": "minute dissection or manipulation (as by a micromanipulator or laser beam) of living structures or tissue [n MICROSURGERIES]\n",
  "MICROSURGICAL": "relating to microsurgery [adj]\n",
  "MICROSWITCH": "a very small switch that is sensitive to minute motions and is used esp. in automatic devices [n -ES]\n",
  "MICROSWITCHES": "MICROSWITCH, a very small switch that is sensitive to minute motions and is used esp. in automatic devices [n]\n",
  "MICROTECHNIC": "any of various methods of handling and preparing material for microscopic observation and study, also MICROTECHNIQUE [n -S]\n",
  "MICROTECHNICS": "MICROTECHNIC, any of various methods of handling and preparing material for microscopic observation and study, also MICROTECHNIQUE [n]\n",
  "MICROTECHNIQUE": "any of various methods of handling and preparing material for microscopic observation and study, also MICROTECHNIC [n -S]\n",
  "MICROTECHNIQUES": "MICROTECHNIQUE, any of various methods of handling and preparing material for microscopic observation and study, also MICROTECHNIC [n]\n",
  "MICROTECHNOLOGY": "technology that makes use of microelectronics [n]\n",
  "MICROTOME": "an instrument used to cut very small sections of something [n -S]\n",
  "MICROTOMES": "MICROTOME, an instrument used to cut very small sections of something [n]\n",
  "MICROTOMIC": "of or like a microtome, also MICROTOMICAL [adj]\n",
  "MICROTOMICAL": "of or like a microtome, also MICROTOMIC [adj]\n",
  "MICROTOMIES": "MICROTOMY, the art of using the microtome [n]\n",
  "MICROTOMIST": "one who uses a microtome [n -S]\n",
  "MICROTOMISTS": "MICROTOMIST, one who uses a microtome [n]\n",
  "MICROTOMY": "the art of using the microtome [n MICROTOMIES]\n",
  "MICROTONAL": "of or like a microtone [adj MICROTONALLY]\n",
  "MICROTONALITIES": "MICROTONALITY, the state of being microtonal [n]\n",
  "MICROTONALITY": "the state of being microtonal [n MICROTONALITIES]\n",
  "MICROTONALLY": "MICROTONAL, of or like a microtone [adv]\n",
  "MICROTONE": "an interval less than a semitone [n -S]\n",
  "MICROTONES": "MICROTONE, an interval less than a semitone [n]\n",
  "MICROTUBE": "a minute tube [n -S]\n",
  "MICROTUBES": "MICROTUBE, a minute tube [n]\n",
  "MICROTUBULAR": "of or like a microtubule [adj]\n",
  "MICROTUBULE": "any of the relatively rigid structures in the cytoplasm of many plant and animal cells [n -S]\n",
  "MICROTUBULES": "MICROTUBULE, any of the relatively rigid structures in the cytoplasm of many plant and animal cells [n]\n",
  "MICROTUNNELLING": "a technique used in laying underground pipes, etc., in which miniature boring machines excavate the required channel without breaking or damaging the road surface [n]\n",
  "MICROVASCULAR": "of, relating to, or constituting the part of the circulatory system made up of minute vessels (as venules or capillaries) that average less than 0.3 millimeters in diameter [adj]\n",
  "MICROVILLAR": "of or like a microvillus, a microscopic projection from the surface of a cell wall, also MICROVILLOUS [adj]\n",
  "MICROVILLI": "MICROVILLUS, a microscopic projection from the surface of a cell wall [n]\n",
  "MICROVILLOUS": "of or like a microvillus, a microscopic projection from the surface of a cell wall, also MICROVILLAR [adj]\n",
  "MICROVILLUS": "a microscopic projection from the surface of a cell wall [n MICROVILLI]\n",
  "MICROVOLT": "the millionth part of one volt [n -S]\n",
  "MICROVOLTS": "MICROVOLT, the millionth part of one volt [n]\n",
  "MICROWATT": "a millionth of a watt [n -S]\n",
  "MICROWATTS": "MICROWATT, a millionth of a watt [n]\n",
  "MICROWAVABLE": "capable of being microwaved, also MICROWAVEABLE [adj]\n",
  "MICROWAVE": "in radio communication, a wave having a very short wavelength [n -S] / to cook by microwave [v MICROWAVED, MICROWAVING, MICROWAVES]\n",
  "MICROWAVEABLE": "capable of being microwaved, also MICROWAVABLE [adj]\n",
  "MICROWAVED": "MICROWAVE, to cook by microwave [v]\n",
  "MICROWAVES": "MICROWAVE, to cook by microwave [v]\n",
  "MICROWAVING": "MICROWAVE, to cook by microwave [v]\n",
  "MICROWIRE": "a very strong, very fine filament of metal or other material [n -S]\n",
  "MICROWIRES": "MICROWIRE, a very strong, very fine filament of metal or other material [n]\n",
  "MICROWORLD": "a discrete area within a computer database [n -S]\n",
  "MICROWORLDS": "MICROWORLD, a discrete area within a computer database [n]\n",
  "MICROWRITER": "a handheld five- or six-key device by means of which text can be generated on a printer or VDU [n -S]\n",
  "MICROWRITERS": "MICROWRITER, a handheld five- or six-key device by means of which text can be generated on a printer or VDU [n]\n",
  "MICRURGIES": "MICRURGY, the use of minute tools under high magnification [n]\n",
  "MICRURGY": "the use of minute tools under high magnification [n MICRURGIES]\n",
  "MICS": "MIC, (short for) a microphone [n]\n",
  "MICTION": "(obsolete) the voiding of urine [n -S]\n",
  "MICTIONS": "MICTION, (obsolete) the voiding of urine [n]\n",
  "MICTURATE": "to urinate [v MICTURATED, MICTURATING, MICTURATES]\n",
  "MICTURATED": "MICTURATE, to urinate [v]\n",
  "MICTURATES": "MICTURATE, to urinate [v]\n",
  "MICTURATING": "MICTURATE, to urinate [v]\n",
  "MICTURITION": "abnormally frequent urination [n -S]\n",
  "MICTURITIONS": "MICTURITION, abnormally frequent urination [n]\n",
  "MID": "the middle [n -S]\n",
  "MIDAIR": "the midst of a course through the air [n -S]\n",
  "MIDAIRS": "MIDAIR, the midst of a course through the air [n]\n",
  "MIDBAND": "operating across a range of frequencies between broadband and narrowband [adj]\n",
  "MIDBRAIN": "the middle region of the brain [n -S]\n",
  "MIDBRAINS": "MIDBRAIN, the middle region of the brain [n]\n",
  "MIDCALF": "a garment reaching to middle of the calf [n MIDCALVES]\n",
  "MIDCALVES": "MIDCALF, a garment reaching to middle of the calf [n]\n",
  "MIDCAP": "of a company having medium capitalisation [adj]\n",
  "MIDCOURSE": "in mid course [adj]\n",
  "MIDCULT": "middle-class culture [n -S]\n",
  "MIDCULTS": "MIDCULT, middle-class culture [n]\n",
  "MIDDAY": "the middle of the day [n -S]\n",
  "MIDDAYS": "MIDDAY, the middle of the day [n]\n",
  "MIDDELMANNETJIE": "(South African) a ridge between the ruts made by wheels in a dirt road [n]\n",
  "MIDDELSKOT": "(South African) an intermediate payment to a farmer for a crop or wool-clip [n -S]\n",
  "MIDDELSKOTS": "MIDDELSKOT, (South African) an intermediate payment to a farmer for a crop or wool-clip [n]\n",
  "MIDDEN": "a dungheap [n -S]\n",
  "MIDDENS": "MIDDEN, a dungheap [n]\n",
  "MIDDENSTEAD": "the site of a midden [n -S]\n",
  "MIDDENSTEADS": "MIDDENSTEAD, the site of a midden [n]\n",
  "MIDDEST": "(Spenser) situated most nearly in the middle [adj]\n",
  "MIDDIE": "a medium sized beer glass, larger than a pony, smaller than a schooner, also MIDDY [n -S]\n",
  "MIDDIES": "MIDDY, a medium sized beer glass, larger than a pony, smaller than a schooner, also MIDDIE [n]\n",
  "MIDDLE": "equally distant from the extremes [adj] / to place in the middle [v MIDDLED, MIDDLING, MIDDLES]\n",
  "MIDDLEBREAKER": "a double-mould-board plough, aka lister [n -S]\n",
  "MIDDLEBREAKERS": "MIDDLEBREAKER, a double-mould-board plough, aka lister [n]\n",
  "MIDDLEBROW": "a person who is moderately but not highly cultivated [n -S]\n",
  "MIDDLEBROWED": "midway between highbrow and lowbrow [adj]\n",
  "MIDDLEBROWISM": "the state of being middlebrow [n -S]\n",
  "MIDDLEBROWISMS": "MIDDLEBROWISM, the state of being middlebrow [n]\n",
  "MIDDLEBROWS": "MIDDLEBROW, a person who is moderately but not highly cultivated [n]\n",
  "MIDDLEBUSTER": "a plow with a double moldboard, used to prepare the ground for planting by producing furrows and ridges [n -S]\n",
  "MIDDLEBUSTERS": "MIDDLEBUSTER, a plow with a double moldboard, used to prepare the ground for planting by producing furrows and ridges [n]\n",
  "MIDDLED": "MIDDLE, to place in the middle [v]\n",
  "MIDDLEMAN": "an intermediary, esp. between producer and consumer [n MIDDLEMEN]\n",
  "MIDDLEMEN": "MIDDLEMAN, an intermediary, esp. between producer and consumer [n]\n",
  "MIDDLEMOST": "being in the middle, or nearest the middle, also MIDMOST [adj]\n",
  "MIDDLER": "a student in an intermediate grade [n -S]\n",
  "MIDDLERS": "MIDDLER, a student in an intermediate grade [n]\n",
  "MIDDLES": "MIDDLE, to place in the middle [v]\n",
  "MIDDLEWARE": "computer software that has an intermediary function between the various applications of a computer and its operating system [n -S]\n",
  "MIDDLEWARES": "MIDDLEWARE, computer software that has an intermediary function between the various applications of a computer and its operating system [n]\n",
  "MIDDLEWEIGHT": "a weight division in boxing [n -S]\n",
  "MIDDLEWEIGHTS": "MIDDLEWEIGHT, a weight division in boxing [n]\n",
  "MIDDLING": "average, so-so [adj MIDDLINGLY]\n",
  "MIDDLINGLY": "MIDDLING, average, so-so [adv]\n",
  "MIDDLINGS": "goods, esp. flour, cotton, or minerals, which have been sorted according to quality into the second of three grades [n]\n",
  "MIDDORSAL": "in the middle of the dorsal region [adj]\n",
  "MIDDY": "a medium sized beer glass, larger than a pony, smaller than a schooner, also MIDDIE [n MIDDIES]\n",
  "MIDFIELD": "the middle of a playing field [n -S]\n",
  "MIDFIELDER": "a player who plays in the midfield [n -S]\n",
  "MIDFIELDERS": "MIDFIELDER, a player who plays in the midfield [n]\n",
  "MIDFIELDS": "MIDFIELD, the middle of a playing field [n]\n",
  "MIDGE": "a small gnatlike fly, esp. of the family Chironomidae [n -S]\n",
  "MIDGES": "MIDGE, a small gnatlike fly, esp. of the family Chironomidae [n]\n",
  "MIDGET": "a very small person [n -S]\n",
  "MIDGETS": "MIDGET, a very small person [n]\n",
  "MIDGIE": "(colloquial) a small biting insect such as a midge or sandfly [n -S]\n",
  "MIDGIER": "MIDGY, full of midges [adj]\n",
  "MIDGIES": "MIDGIE, (colloquial) a small biting insect such as a midge or sandfly [n]\n",
  "MIDGIEST": "MIDGY, full of midges [adj]\n",
  "MIDGUT": "the middle part of the embryonic digestive tract [n -S]\n",
  "MIDGUTS": "MIDGUT, the middle part of the embryonic digestive tract [n]\n",
  "MIDGY": "full of midges [adj MIDGIER, MIDGIEST]\n",
  "MIDI": "a skirt or coat that extends to the middle of the calf [n -S]\n",
  "MIDIBUS": "a single-decker bus of medium size, typically with seats for between 20 and 30 passengers [n MIDIBUSES or MIDIBUSSES]\n",
  "MIDIBUSES": "MIDIBUS, a single-decker bus of medium size, typically with seats for between 20 and 30 passengers [n]\n",
  "MIDIBUSSES": "MIDIBUS, a single-decker bus of medium size, typically with seats for between 20 and 30 passengers [n]\n",
  "MIDINETTE": "(French) a French, esp. a Parisian, shopgirl; esp. a milliner's assistant [n -S]\n",
  "MIDINETTES": "MIDINETTE, (French) a French, esp. a Parisian, shopgirl; esp. a milliner's assistant [n]\n",
  "MIDIRON": "a golf club [n -S]\n",
  "MIDIRONS": "MIDIRON, a golf club [n]\n",
  "MIDIS": "MIDI, a skirt or coat that extends to the middle of the calf [n]\n",
  "MIDISKIRT": "a skirt of medium length [n -S]\n",
  "MIDISKIRTS": "MIDISKIRT, a skirt of medium length [n]\n",
  "MIDLAND": "the middle part of the country [n -S]\n",
  "MIDLANDER": "one who lives in the midlands [n -S]\n",
  "MIDLANDERS": "MIDLANDER, one who lives in the midlands [n]\n",
  "MIDLANDS": "MIDLAND, the middle part of the country [n]\n",
  "MIDLATITUDE": "a latitude in the temperate regions [n -S]\n",
  "MIDLATITUDES": "MIDLATITUDE, a latitude in the temperate regions [n]\n",
  "MIDLEG": "the middle of the leg [n -S]\n",
  "MIDLEGS": "MIDLEG, the middle of the leg [n]\n",
  "MIDLIFE": "middle age [n MIDLIVES]\n",
  "MIDLIFER": "a middle-aged person [n -S]\n",
  "MIDLIFERS": "MIDLIFER, a middle-aged person [n]\n",
  "MIDLINE": "a median line [n -S]\n",
  "MIDLINES": "MIDLINE, a median line [n]\n",
  "MIDLIST": "a section of a publisher's list of current titles [n -S]\n",
  "MIDLISTS": "MIDLIST, a section of a publisher's list of current titles [n]\n",
  "MIDLITTORAL": "that part of the seashore that lies between high and low neap tidemarks [n -S]\n",
  "MIDLITTORALS": "MIDLITTORAL, that part of the seashore that lies between high and low neap tidemarks [n]\n",
  "MIDLIVES": "MIDLIFE, middle age [n]\n",
  "MIDMONTH": "halfway through the month [n -S]\n",
  "MIDMONTHS": "MIDMONTH, halfway through the month [n]\n",
  "MIDMOST": "a part exactly in the middle, also MIDDLEMOST [n -S]\n",
  "MIDMOSTS": "MIDMOST, a part exactly in the middle, also MIDDLEMOST [n]\n",
  "MIDNIGHT": "the middle of the night [n -S]\n",
  "MIDNIGHTLY": "taking place in the middle of the night [adj]\n",
  "MIDNIGHTS": "MIDNIGHT, the middle of the night [n]\n",
  "MIDNOON": "midday [n -S]\n",
  "MIDNOONS": "MIDNOON, midday [n]\n",
  "MIDPAY": "(of an occupation, industry, etc.) paying or tending to pay more than an unskilled job but less than a high-income one [adj]\n",
  "MIDPOINT": "the point in the middle [n -S]\n",
  "MIDPOINTS": "MIDPOINT, the point in the middle [n]\n",
  "MIDRANGE": "the middle of the range [n -S]\n",
  "MIDRANGES": "MIDRANGE, the middle of the range [n]\n",
  "MIDRASH": "(Hebrew) an early Jewish interpretation of a biblical text [n MIDRASHIM or MIDRASHOT or MIDRASHOTH]\n",
  "MIDRASHIC": "relating to the midrash, the segment of the rabbinic oral tradition that interprets or expounds the Bible [adj]\n",
  "MIDRASHIM": "MIDRASH, (Hebrew) an early Jewish interpretation of a biblical text [n]\n",
  "MIDRASHOT": "MIDRASH, (Hebrew) an early Jewish interpretation of a biblical text [n]\n",
  "MIDRASHOTH": "MIDRASH, (Hebrew) an early Jewish interpretation of a biblical text [n]\n",
  "MIDRIB": "the central vein of a leaf [n -S]\n",
  "MIDRIBS": "MIDRIB, the central vein of a leaf [n]\n",
  "MIDRIFF": "the area of the front of the body between the chest and the waist [n -S]\n",
  "MIDRIFFS": "MIDRIFF, the area of the front of the body between the chest and the waist [n]\n",
  "MIDS": "MID, the middle [n]\n",
  "MIDSAGITTAL": "median and sagittal [adj]\n",
  "MIDSEASON": "taking place in the middle of the season [adj]\n",
  "MIDSECTION": "the middle section of something [n -S]\n",
  "MIDSECTIONS": "MIDSECTION, the middle section of something [n]\n",
  "MIDSHIP": "pertaining to the middle of the ship [adj]\n",
  "MIDSHIPMAN": "formerly, the title of a young officer (originally quartered amidships) entering the navy [n MIDSHIPMEN]\n",
  "MIDSHIPMATE": "a midshipman [n -S]\n",
  "MIDSHIPMATES": "MIDSHIPMATE, a midshipman [n]\n",
  "MIDSHIPMEN": "MIDSHIPMAN, formerly, the title of a young officer (originally quartered amidships) entering the navy [n]\n",
  "MIDSHIPS": "towards the middle of the ship [adv]\n",
  "MIDSHORE": "designating a fishery that is between the inshore and offshore fisheries [adj]\n",
  "MIDSIZE": "medium [adj]\n",
  "MIDSIZED": "medium [adj]\n",
  "MIDSOLE": "the middle layer of the sole of a shoe [n -S]\n",
  "MIDSOLES": "MIDSOLE, the middle layer of the sole of a shoe [n]\n",
  "MIDSPACE": "the middle of space [n -S]\n",
  "MIDSPACES": "MIDSPACE, the middle of space [n]\n",
  "MIDST": "the middle [n -S]\n",
  "MIDSTORIES": "MIDSTORY, the middle of a story [n]\n",
  "MIDSTORY": "the middle of a story [n MIDSTORIES]\n",
  "MIDSTREAM": "the middle part of a stream [n -S]\n",
  "MIDSTREAMS": "MIDSTREAM, the middle part of a stream [n]\n",
  "MIDSTS": "MIDST, the middle [n]\n",
  "MIDSUMMER": "the middle of summer [n -S]\n",
  "MIDSUMMERS": "MIDSUMMER, the middle of summer [n]\n",
  "MIDTERM": "the middle of an academic term [n -S]\n",
  "MIDTERMS": "MIDTERM, the middle of an academic term [n]\n",
  "MIDTHIGH": "a garment reaching to the middle of the thigh [n -S]\n",
  "MIDTHIGHS": "MIDTHIGH, a garment reaching to the middle of the thigh [n]\n",
  "MIDTOWN": "the centre of town [n -S]\n",
  "MIDTOWNS": "MIDTOWN, the centre of town [n]\n",
  "MIDWATCH": "a watch on a ship between midnight and four a.m. [n -ES]\n",
  "MIDWATCHES": "MIDWATCH, a watch on a ship between midnight and four a.m. [n]\n",
  "MIDWATER": "the middle portion vertically of a body of water [n -S]\n",
  "MIDWATERS": "MIDWATER, the middle portion vertically of a body of water [n]\n",
  "MIDWAY": "a central avenue in a fair for sideshows [n -S]\n",
  "MIDWAYS": "MIDWAY, a central avenue in a fair for sideshows [n]\n",
  "MIDWEEK": "the middle of the week [n -S]\n",
  "MIDWEEKLY": "taking place in the middle of the week [adj]\n",
  "MIDWEEKS": "MIDWEEK, the middle of the week [n]\n",
  "MIDWESTERN": "belonging to the Midwest [adj]\n",
  "MIDWIFE": "to assist a woman in childbirth, also MIDWIVE [v MIDWIFED, MIDWIFING, MIDWIFES]\n",
  "MIDWIFED": "MIDWIFE, to assist a woman in childbirth, also MIDWIVE [v]\n",
  "MIDWIFERIES": "MIDWIFERY, the occupation of a midwife [n]\n",
  "MIDWIFERY": "the occupation of a midwife [n MIDWIFERIES]\n",
  "MIDWIFES": "MIDWIFE, to assist a woman in childbirth, also MIDWIVE [v]\n",
  "MIDWIFING": "MIDWIFE, to assist a woman in childbirth, also MIDWIVE [v]\n",
  "MIDWINTER": "the middle of winter [n -S]\n",
  "MIDWINTERS": "MIDWINTER, the middle of winter [n]\n",
  "MIDWIVE": "to assist a woman in childbirth, also MIDWIFE [v MIDWIVED, MIDWIVING, MIDWIVES]\n",
  "MIDWIVED": "MIDWIVE, to assist a woman in childbirth, also MIDWIFE [v]\n",
  "MIDWIVES": "MIDWIVE, to assist a woman in childbirth, also MIDWIFE [v]\n",
  "MIDWIVING": "MIDWIVE, to assist a woman in childbirth, also MIDWIFE [v]\n",
  "MIDYEAR": "the middle part of the year [n -S]\n",
  "MIDYEARS": "MIDYEAR, the middle part of the year [n]\n",
  "MIELIE": "(South African) an ear of corn, also MEALIE [n -S]\n",
  "MIELIES": "MIELIE, (South African) an ear of corn, also MEALIE [n]\n",
  "MIEN": "(French) an air or look [n -S]\n",
  "MIENS": "MIEN, (French) an air or look [n]\n",
  "MIEVE": "(Spenser) to move [v MIEVED, MIEVING, MIEVES]\n",
  "MIEVED": "MIEVE, (Spenser) to move [v]\n",
  "MIEVES": "MIEVE, (Spenser) to move [v]\n",
  "MIEVING": "MIEVE, (Spenser) to move [v]\n",
  "MIFEPRISTONE": "a synthetic compound that inhibits the action of progesterone, used in pill form to induce abortion in early pregnancy [n -S]\n",
  "MIFEPRISTONES": "MIFEPRISTONE, a synthetic compound that inhibits the action of progesterone, used in pill form to induce abortion in early pregnancy [n]\n",
  "MIFF": "to annoy [v -ED, -ING, -S]\n",
  "MIFFED": "MIFF, to annoy [v]\n",
  "MIFFIER": "MIFFY, easily annoyed [adj]\n",
  "MIFFIEST": "MIFFY, easily annoyed [adj]\n",
  "MIFFILY": "MIFFY, easily annoyed [adv]\n",
  "MIFFINESS": "the state of being miffy, quick to take offence [n -ES]\n",
  "MIFFINESSES": "MIFFINESS, the state of being miffy, quick to take offence [n]\n",
  "MIFFING": "MIFF, to annoy [v]\n",
  "MIFFS": "MIFF, to annoy [v]\n",
  "MIFFY": "easily annoyed [adj MIFFIER, MIFFIEST, MIFFILY]\n",
  "MIFTY": "(obsolete) quick to take offence, also MIFFY [adj]\n",
  "MIG": "a type of playing marble, also MIB, MIGG, MIGGLE [n -S]\n",
  "MIGAWD": "an interjection used to express surprise, also OMIGOD [interj]\n",
  "MIGG": "a type of playing marble, also MIB, MIG, MIGGLE [n -S]\n",
  "MIGGLE": "a type of playing marble, also MIB, MIG, MIGG [n -S]\n",
  "MIGGLES": "MIGGLE, a type of playing marble, also MIB, MIG, MIGG [n]\n",
  "MIGGS": "MIGG, a type of playing marble, also MIB, MIG, MIGGLE [n]\n",
  "MIGHT": "strength, also MICHT [n -S]\n",
  "MIGHTEST": "(archaic) 2nd person singular of might, also MIGHTST [v]\n",
  "MIGHTFUL": "(Shakespeare) mighty [adj]\n",
  "MIGHTIER": "MIGHTY, full of might [adj]\n",
  "MIGHTIEST": "MIGHTY, full of might [adj]\n",
  "MIGHTILY": "MIGHTY, full of might [adv]\n",
  "MIGHTINESS": "the state of being mighty [n -ES]\n",
  "MIGHTINESSES": "MIGHTINESS, the state of being mighty [n]\n",
  "MIGHTS": "MIGHT, strength, also MICHT [n]\n",
  "MIGHTST": "(archaic) 2nd person singular of might, also MIGHTEST [v]\n",
  "MIGHTY": "full of might [adj MIGHTIER, MIGHTIEST, MIGHTILY]\n",
  "MIGMATITE": "a type of rock containing igneous and metamorphic elements [n -S]\n",
  "MIGMATITES": "MIGMATITE, a type of rock containing igneous and metamorphic elements [n]\n",
  "MIGNON": "(French) a filet mignon, a small boneless cut of beef from the underside of a sirloin [n -S]\n",
  "MIGNONETTE": "(French) a plant having greenish flowers with orange-colored stamens, and exhaling a delicious fragrance [n -S]\n",
  "MIGNONETTES": "MIGNONETTE, (French) a plant having greenish flowers with orange-colored stamens, and exhaling a delicious fragrance [n]\n",
  "MIGNONNE": "small and dainty [adj] / a darling [n -S]\n",
  "MIGNONNES": "MIGNONNE, a darling [n]\n",
  "MIGNONS": "MIGNON, (French) a filet mignon, a small boneless cut of beef from the underside of a sirloin [n]\n",
  "MIGRAINE": "(French) a severe headache, also MEGRIM [n -S]\n",
  "MIGRAINES": "MIGRAINE, (French) a severe headache, also MEGRIM [n]\n",
  "MIGRAINEUR": "one who suffers from migraines [n -S]\n",
  "MIGRAINEURS": "MIGRAINEUR, one who suffers from migraines [n]\n",
  "MIGRAINOUS": "of or like a migraine [adj]\n",
  "MIGRANT": "one who migrates, also MIGRATOR [n -S]\n",
  "MIGRANTS": "MIGRANT, one who migrates, also MIGRATOR [n]\n",
  "MIGRATE": "to move from one region to another [v MIGRATED, MIGRATING, MIGRATES]\n",
  "MIGRATED": "MIGRATE, to move from one region to another [v]\n",
  "MIGRATES": "MIGRATE, to move from one region to another [v]\n",
  "MIGRATING": "MIGRATE, to move from one region to another [v]\n",
  "MIGRATION": "a removal from one country or climate to another, esp. in a large number [n -S]\n",
  "MIGRATIONAL": "relating to migration [adj]\n",
  "MIGRATIONIST": "a person who explains facts by a theory of migration [n -S]\n",
  "MIGRATIONISTS": "MIGRATIONIST, a person who explains facts by a theory of migration [n]\n",
  "MIGRATIONS": "MIGRATION, a removal from one country or climate to another, esp. in a large number [n]\n",
  "MIGRATOR": "one who migrates, also MIGRANT [n -S]\n",
  "MIGRATORS": "MIGRATOR, one who migrates, also MIGRANT [n]\n",
  "MIGRATORY": "migrating, wandering [adj]\n",
  "MIGS": "MIG, a type of playing marble, also MIB, MIGG, MIGGLE [n]\n",
  "MIHA": "(Maori) a young fern frond that has not opened [n -S]\n",
  "MIHAS": "MIHA, (Maori) a young fern frond that has not opened [n]\n",
  "MIHI": "(Maori) a ceremonial greeting [n -S] / to greet ceremonially [v -ED, -ING, -S]\n",
  "MIHIED": "MIHI, to greet ceremonially [v]\n",
  "MIHIING": "MIHI, to greet ceremonially [v]\n",
  "MIHIS": "MIHI, to greet ceremonially [v]\n",
  "MIHRAB": "(Arabic) a niche or slab in a mosque marking the direction of Mecca [n -S]\n",
  "MIHRABS": "MIHRAB, (Arabic) a niche or slab in a mosque marking the direction of Mecca [n]\n",
  "MIJNHEER": "(Dutch) the Dutch equivalent of Mr. or Sir; hence, a Dutchman, also MENEER, MYNHEER [n -S]\n",
  "MIJNHEERS": "MIJNHEER, (Dutch) the Dutch equivalent of Mr. or Sir; hence, a Dutchman, also MENEER, MYNHEER [n]\n",
  "MIKADO": "(Japanese) the popular designation of the hereditary sovereign of Japan [n -S]\n",
  "MIKADOS": "MIKADO, (Japanese) the popular designation of the hereditary sovereign of Japan [n]\n",
  "MIKE": "(short for) microphone [n -S] / to record by use of a microphone [v MIKED, MIKING, MIKES]\n",
  "MIKED": "MIKE, to record by use of a microphone [v]\n",
  "MIKES": "MIKE, to record by use of a microphone [v]\n",
  "MIKING": "MIKE, to record by use of a microphone [v]\n",
  "MIKRA": "MIKRON, (Greek) a unit of length, also MICRON [n]\n",
  "MIKRON": "(Greek) a unit of length, also MICRON [n MIKRONS or MIKRA]\n",
  "MIKRONS": "MIKRON, (Greek) a unit of length, also MICRON [n]\n",
  "MIKVA": "(Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVAH, MIKVEH [n -S]\n",
  "MIKVAH": "(Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVA, MIKVEH [n MIKVAHS or MIKVOTH]\n",
  "MIKVAHS": "MIKVAH, (Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVA, MIKVEH [n]\n",
  "MIKVAS": "MIKVA, (Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVAH, MIKVEH [n]\n",
  "MIKVEH": "(Hebrew) a place for ritual bathing by orthodox Jews, also MIKVAH [n MIKVEHS or MIKVOS or MIKVOT or MIKVOTH]\n",
  "MIKVEHS": "MIKVEH, (Hebrew) a place for ritual bathing by orthodox Jews, also MIKVAH [n]\n",
  "MIKVOS": "MIKVAH, (Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVA, MIKVEH [n]\n",
  "MIKVOT": "MIKVAH, (Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVA, MIKVEH [n]\n",
  "MIKVOTH": "MIKVAH, (Hebrew) a place for ritual bathing by Orthodox Jews, also MIKVA, MIKVEH [n]\n",
  "MIL": "a unit of wire measurement [n -S]\n",
  "MILADI": "a term of address for a rich or aristocratic English lady, also MILADY [n -S]\n",
  "MILADIES": "MILADY, an English gentlewoman, also MILADI [n]\n",
  "MILADIS": "MILADI, a term of address for a rich or aristocratic English lady, also MILADY [n]\n",
  "MILADY": "an English gentlewoman, also MILADI [n MILADIES]\n",
  "MILAGE": "the total distance expressed in miles, also MILEAGE [n -S]\n",
  "MILAGES": "MILAGE, the total distance expressed in miles, also MILEAGE [n]\n",
  "MILCH": "of cattle, yielding milk [adj]\n",
  "MILCHIG": "(Yiddish) made of or derived from milk or dairy products, also MILCHIK [adj]\n",
  "MILCHIK": "(Yiddish) made of or derived from milk or dairy products, also MILCHIG [adj]\n",
  "MILD": "gentle in temper and disposition [adj MILDER, MILDEST, MILDLY] / to become gentle [v -ED, -ING, -S]\n",
  "MILDED": "MILD, to become gentle [v]\n",
  "MILDEN": "to make mild, or milder [v -ED, -ING, -S]\n",
  "MILDENED": "MILDEN, to make mild, or milder [v]\n",
  "MILDENING": "MILDEN, to make mild, or milder [v]\n",
  "MILDENS": "MILDEN, to make mild, or milder [v]\n",
  "MILDER": "MILD, gentle in temper and disposition [adj]\n",
  "MILDEST": "MILD, gentle in temper and disposition [adj]\n",
  "MILDEW": "to grow a whitish fungi [v -ED, -ING, -S]\n",
  "MILDEWED": "MILDEW, to grow a whitish fungi [v]\n",
  "MILDEWIER": "MILDEWY, covered with mildew [adj]\n",
  "MILDEWIEST": "MILDEWY, covered with mildew [adj]\n",
  "MILDEWING": "MILDEW, to grow a whitish fungi [v]\n",
  "MILDEWS": "MILDEW, to grow a whitish fungi [v]\n",
  "MILDEWY": "covered with mildew [adj MILDEWIER, MILDEWIEST]\n",
  "MILDING": "MILD, to become gentle [v]\n",
  "MILDISH": "somewhat mild [adj]\n",
  "MILDLY": "MILD, gentle in temper and disposition [adv]\n",
  "MILDNESS": "the quality of being mild [n -ES]\n",
  "MILDNESSES": "MILDNESS, the quality of being mild [n]\n",
  "MILDS": "MILD, to become gentle [v]\n",
  "MILE": "a unit of distance [n -S]\n",
  "MILEAGE": "the total distance expressed in miles, also MILAGE [n -S]\n",
  "MILEAGES": "MILEAGE, the total distance expressed in miles, also MILAGE [n]\n",
  "MILEOMETER": "an instrument that records the number of miles that a vehicle, etc. has travelled, also MILOMETER [n -S]\n",
  "MILEOMETERS": "MILEOMETER, an instrument that records the number of miles that a vehicle, etc. has travelled, also MILOMETER [n]\n",
  "MILEPOST": "a post with each progressive mile marked on it [n -S]\n",
  "MILEPOSTS": "MILEPOST, a post with each progressive mile marked on it [n]\n",
  "MILER": "one who runs in mile races [n -S]\n",
  "MILERS": "MILER, one who runs in mile races [n]\n",
  "MILES": "MILE, a unit of distance [n]\n",
  "MILESIAN": "of Irish origin [adj]\n",
  "MILESIMO": "a former monetary unit of Chile [n -S]\n",
  "MILESIMOS": "MILESIMO, a former monetary unit of Chile [n]\n",
  "MILESTONE": "a post or stone marker showing distance in miles [n -S]\n",
  "MILESTONES": "MILESTONE, a post or stone marker showing distance in miles [n]\n",
  "MILF": "(offensive) a sexually attractive middle-aged woman [n -S]\n",
  "MILFOIL": "a yarrow, or other species of Achillea, with finely divided leaves [n -S]\n",
  "MILFOILS": "MILFOIL, a yarrow, or other species of Achillea, with finely divided leaves [n]\n",
  "MILFS": "MILF, (offensive) a sexually attractive middle-aged woman [n]\n",
  "MILIA": "MILIUM, (Latin) a small, whitish lump in the skin caused by the blockage of a sebaceous gland [n]\n",
  "MILIARIA": "a skin disease [n -S]\n",
  "MILIARIAL": "of or like miliaria, a fever accompanied by an eruption of small, isolated, red pimples [adj]\n",
  "MILIARIAS": "MILIARIA, a skin disease [n]\n",
  "MILIARY": "characterized by small skin eruptions like millet-seed [adj]\n",
  "MILIEU": "(French) a social environment [n MILIEUS or MILIEUX]\n",
  "MILIEUS": "MILIEU, (French) a social environment [n]\n",
  "MILIEUX": "MILIEU, (French) a social environment [n]\n",
  "MILING": "the activity of running in a one-mile race [n -S]\n",
  "MILINGS": "MILING, the activity of running in a one-mile race [n]\n",
  "MILITANCE": "the condition or fact of being militant, esp. in pursuing a political or social end, also MILITANCY [n -S]\n",
  "MILITANCES": "MILITANCE, the condition or fact of being militant, esp. in pursuing a political or social end, also MILITANCY [n]\n",
  "MILITANCIES": "MILITANCY, the condition or fact of being militant, esp. in pursuing a political or social end, also MILITANCE [n]\n",
  "MILITANCY": "the condition or fact of being militant, esp. in pursuing a political or social end, also MILITANCE [n MILITANCIES]\n",
  "MILITANT": "aggressive [adj MILITANTLY] / one who is militant [n -S]\n",
  "MILITANTLY": "MILITANT, aggressive [adv]\n",
  "MILITANTNESS": "the state of being militant [n -ES]\n",
  "MILITANTNESSES": "MILITANTNESS, the state of being militant [n]\n",
  "MILITANTS": "MILITANT, one who is militant [n]\n",
  "MILITAR": "(obsolete) military [adj]\n",
  "MILITARIA": "weapons, uniforms and other things associated with wars past and present [n]\n",
  "MILITARIES": "MILITARY, armed forces [n]\n",
  "MILITARILY": "MILITARY, relating to armed forces [adv]\n",
  "MILITARISATION": "the act of militarising, also MILITARIZATION [n -S]\n",
  "MILITARISATIONS": "MILITARISATION, the act of militarising, also MILITARIZATION [n]\n",
  "MILITARISE": "to make military, also MILITARIZE [v MILITARISED, MILITARISING, MILITARISES]\n",
  "MILITARISED": "MILITARISE, to make military, also MILITARIZE [v]\n",
  "MILITARISES": "MILITARISE, to make military, also MILITARIZE [v]\n",
  "MILITARISING": "MILITARISE, to make military, also MILITARIZE [v]\n",
  "MILITARISM": "reliance on military force in administering government [n -S]\n",
  "MILITARISMS": "MILITARISM, reliance on military force in administering government [n]\n",
  "MILITARIST": "a military man [n -S]\n",
  "MILITARISTIC": "relating to militarism [adj]\n",
  "MILITARISTS": "MILITARIST, a military man [n]\n",
  "MILITARIZATION": "the act of militarizing, also MILITARISATION [n -S]\n",
  "MILITARIZATIONS": "MILITARIZATION, the act of militarizing, also MILITARISATION [n]\n",
  "MILITARIZE": "to make military, also MILITARISE [v MILITARIZED, MILITARIZING, MILITARIZES]\n",
  "MILITARIZED": "MILITARIZE, to make military, also MILITARISE [v]\n",
  "MILITARIZES": "MILITARIZE, to make military, also MILITARISE [v]\n",
  "MILITARIZING": "MILITARIZE, to make military, also MILITARISE [v]\n",
  "MILITARY": "relating to armed forces [adj MILITARILY] / armed forces [n MILITARIES]\n",
  "MILITATE": "to have influence [v MILITATED, MILITATING, MILITATES]\n",
  "MILITATED": "MILITATE, to have influence [v]\n",
  "MILITATES": "MILITATE, to have influence [v]\n",
  "MILITATING": "MILITATE, to have influence [v]\n",
  "MILITATION": "the act of militating [n -S]\n",
  "MILITATIONS": "MILITATION, the act of militating [n]\n",
  "MILITIA": "(Latin) a military force raised from the civilian population, as distinguished from mercenaries or professional soldiers [n -S]\n",
  "MILITIAMAN": "a member of a militia [n MILITIAMEN]\n",
  "MILITIAMEN": "MILITIAMAN, a member of a militia [n]\n",
  "MILITIAS": "MILITIA, (Latin) a military force raised from the civilian population, as distinguished from mercenaries or professional soldiers [n]\n",
  "MILIUM": "(Latin) a small, whitish lump in the skin caused by the blockage of a sebaceous gland [n MILIA]\n",
  "MILK": "a white liquid secreted by female mammals for the nourishment of their young [n -S] / to draw milk from the udder of [v -ED, -ING, -S]\n",
  "MILKED": "MILK, to draw milk from the udder of [v]\n",
  "MILKEN": "like milk [adj]\n",
  "MILKER": "one who milks (cows) [n -S]\n",
  "MILKERS": "MILKER, one who milks (cows) [n]\n",
  "MILKFISH": "a marine food fish [n -ES]\n",
  "MILKFISHES": "MILKFISH, a marine food fish [n]\n",
  "MILKIER": "MILKY, like milk [adj]\n",
  "MILKIEST": "MILKY, like milk [adj]\n",
  "MILKILY": "MILKY, like milk [adv]\n",
  "MILKINESS": "the state of being milky [n -ES]\n",
  "MILKINESSES": "MILKINESS, the state of being milky [n]\n",
  "MILKING": "the act of milking [n -S]\n",
  "MILKINGS": "MILKING, the act of milking [n]\n",
  "MILKLESS": "without milk [adj]\n",
  "MILKLIKE": "like milk [adj]\n",
  "MILKMAID": "a woman who milks cows [n -S]\n",
  "MILKMAIDS": "MILKMAID, a woman who milks cows [n]\n",
  "MILKMAN": "a man who sells or delivers milk, also MILKO [n MILKMEN]\n",
  "MILKMEN": "MILKMAN, a man who sells or delivers milk, also MILKO [n]\n",
  "MILKO": "(Australian slang) a milkman [n -S]\n",
  "MILKOS": "MILKO, (Australian slang) a milkman [n]\n",
  "MILKS": "MILK, to draw milk from the udder of [v]\n",
  "MILKSHAKE": "a drink of frothy milk mixed with fruit syrup [n -S]\n",
  "MILKSHAKES": "MILKSHAKE, a drink of frothy milk mixed with fruit syrup [n]\n",
  "MILKSHED": "a region supplying milk to a particular community [n -S]\n",
  "MILKSHEDS": "MILKSHED, a region supplying milk to a particular community [n]\n",
  "MILKSOP": "an effeminate man [n -S]\n",
  "MILKSOPISM": "the state of being a milksop [n -S]\n",
  "MILKSOPISMS": "MILKSOPISM, the state of being a milksop [n]\n",
  "MILKSOPPIER": "MILKSOPPY, like a milksop, a spiritless man or youth, also MILKSOPPING [adj]\n",
  "MILKSOPPIEST": "MILKSOPPY, like a milksop, a spiritless man or youth, also MILKSOPPING [adj]\n",
  "MILKSOPPING": "like a milksop, also MILKSOPPY [adj]\n",
  "MILKSOPPY": "like a milksop, a spiritless man or youth, also MILKSOPPING [adj MILKSOPPIER, MILKSOPPIEST]\n",
  "MILKSOPS": "MILKSOP, an effeminate man [n]\n",
  "MILKTOAST": "a very timid, unassertive person, also MILQUETOAST [n -S]\n",
  "MILKTOASTS": "MILKTOAST, a very timid, unassertive person, also MILQUETOAST [n]\n",
  "MILKWEED": "a plant that secretes a milky fluid [n -S]\n",
  "MILKWEEDS": "MILKWEED, a plant that secretes a milky fluid [n]\n",
  "MILKWOOD": "any of various trees associated with latex [n -S]\n",
  "MILKWOODS": "MILKWOOD, any of various trees associated with latex [n]\n",
  "MILKWORT": "a plant of genus Polygala, supposed by some to promote the production of milk in women [n -S]\n",
  "MILKWORTS": "MILKWORT, a plant of genus Polygala, supposed by some to promote the production of milk in women [n]\n",
  "MILKY": "like milk [adj MILKIER, MILKIEST, MILKILY]\n",
  "MILL": "to grind corn, wheat etc. [v -ED, -ING, -S]\n",
  "MILLABLE": "able to be milled [adj]\n",
  "MILLAGE": "a type of monetary rate [n -S]\n",
  "MILLAGES": "MILLAGE, a type of monetary rate [n]\n",
  "MILLBOARD": "a kind of stout pasteboard [n -S]\n",
  "MILLBOARDS": "MILLBOARD, a kind of stout pasteboard [n]\n",
  "MILLCAKE": "a residue from pressed linseed [n -S]\n",
  "MILLCAKES": "MILLCAKE, a residue from pressed linseed [n]\n",
  "MILLDAM": "a dam built to form a millpond [n -S]\n",
  "MILLDAMS": "MILLDAM, a dam built to form a millpond [n]\n",
  "MILLE": "(French) a thousand [n -S]\n",
  "MILLED": "MILL, to grind corn, wheat etc. [v]\n",
  "MILLEFEUILLE": "(French) a rich confection of thin layers of puff pastry and a filling of jam, cream, etc. [n -S]\n",
  "MILLEFEUILLES": "MILLEFEUILLE, (French) a rich confection of thin layers of puff pastry and a filling of jam, cream, etc. [n]\n",
  "MILLEFIORI": "(Italian) an ornamental glassmaking technique [n -S]\n",
  "MILLEFIORIS": "MILLEFIORI, (Italian) an ornamental glassmaking technique [n]\n",
  "MILLEFLEUR": "(French) having an all over pattern of small flowers and animals, also MILLEFLEURS [n -S]\n",
  "MILLEFLEURS": "(French) having an all over pattern of small flowers and animals, also MILLEFLEUR [n MILLEFLEURS]\n",
  "MILLENARIAN": "one who believes in the second coming of Christ to reign on earth a thousand years [n -S]\n",
  "MILLENARIANISM": "the belief that an ideal society will be produced in the near future, also MILLENARISM, MILLENNIALISM, MILLENNIANISM, MILLENNIARISM [n -S]\n",
  "MILLENARIANISMS": "MILLENARIANISM, the belief that an ideal society will be produced in the near future, also MILLENARISM, MILLENNIALISM, MILLENNIANISM, MILLENNIARISM [n]\n",
  "MILLENARIANS": "MILLENARIAN, one who believes in the second coming of Christ to reign on earth a thousand years [n]\n",
  "MILLENARIES": "MILLENARY, a group of a thousand [n]\n",
  "MILLENARISM": "the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENNIALISM, MILLENNIANISM, MILLENNIARISM [n -S]\n",
  "MILLENARISMS": "MILLENARISM, the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENNIALISM, MILLENNIANISM, MILLENNIARISM [n]\n",
  "MILLENARY": "a group of a thousand [n MILLENARIES]\n",
  "MILLENNIA": "MILLENNIUM, (Latin) a period of one thousand years [n]\n",
  "MILLENNIAL": "of or relating to a millennium [adj MILLENNIALLY] / one born around the year 2000 [n -S]\n",
  "MILLENNIALISM": "the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENARISM, MILLENNIANISM, MILLENNIARISM [n -S]\n",
  "MILLENNIALISMS": "MILLENNIALISM, the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENARISM, MILLENNIANISM, MILLENNIARISM [n]\n",
  "MILLENNIALIST": "one who believes that an ideal society will be produced in the near future [n -S]\n",
  "MILLENNIALISTS": "MILLENNIALIST, one who believes that an ideal society will be produced in the near future [n]\n",
  "MILLENNIALLY": "MILLENNIAL, of or relating to a millennium [adv]\n",
  "MILLENNIALS": "MILLENNIAL, one born around the year 2000 [n]\n",
  "MILLENNIANISM": "the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENARISM, MILLENNIALISM, MILLENNIARISM [n -S]\n",
  "MILLENNIANISMS": "MILLENNIANISM, the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENARISM, MILLENNIALISM, MILLENNIARISM [n]\n",
  "MILLENNIARISM": "the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENARISM, MILLENNIALISM, MILLENNIANISM [n -S]\n",
  "MILLENNIARISMS": "MILLENNIARISM, the belief that an ideal society will be produced in the near future, also MILLENARIANISM, MILLENARISM, MILLENNIALISM, MILLENNIANISM [n]\n",
  "MILLENNIUM": "(Latin) a period of one thousand years [n MILLENNIA or MILLENNIUMS]\n",
  "MILLENNIUMS": "MILLENNIUM, (Latin) a period of one thousand years [n]\n",
  "MILLEPED": "a myriapod with many legs, also MILLEPEDE, MILLIPED, MILLIPEDE [n -S]\n",
  "MILLEPEDE": "a myriapod with many legs, also MILLEPED, MILLIPED, MILLIPEDE [n -S]\n",
  "MILLEPEDES": "MILLEPEDE, a myriapod with many legs, also MILLEPED, MILLIPED, MILLIPEDE [n]\n",
  "MILLEPEDS": "MILLEPED, a myriapod with many legs, also MILLEPEDE, MILLIPED, MILLIPEDE [n]\n",
  "MILLEPORE": "any of a group or order of colonial hydrozoans [n -S]\n",
  "MILLEPORES": "MILLEPORE, any of a group or order of colonial hydrozoans [n]\n",
  "MILLER": "a person who owns or works a mill [n -S]\n",
  "MILLERITE": "nickel sulfide [n -S]\n",
  "MILLERITES": "MILLERITE, nickel sulfide [n]\n",
  "MILLERS": "MILLER, a person who owns or works a mill [n]\n",
  "MILLES": "MILLE, (French) a thousand [n]\n",
  "MILLESIMAL": "thousandth; consisting of thousandth parts [adj MILLESIMALLY] / a thousandth part [n -S]\n",
  "MILLESIMALLY": "MILLESIMAL, thousandth; consisting of thousandth parts [adv]\n",
  "MILLESIMALS": "MILLESIMAL, a thousandth part [n]\n",
  "MILLET": "a cereal grass [n -S]\n",
  "MILLETS": "MILLET, a cereal grass [n]\n",
  "MILLHAND": "a worker in a mill [n -S]\n",
  "MILLHANDS": "MILLHAND, a worker in a mill [n]\n",
  "MILLHOUSE": "a house attached to a mill [n -S]\n",
  "MILLHOUSES": "MILLHOUSE, a house attached to a mill [n]\n",
  "MILLIAMP": "one thousandth of an ampere [n -S]\n",
  "MILLIAMPERE": "a thousandth of an ampere [n -S]\n",
  "MILLIAMPERES": "MILLIAMPERE, a thousandth of an ampere [n]\n",
  "MILLIAMPS": "MILLIAMP, one thousandth of an ampere [n]\n",
  "MILLIARD": "(French) a thousand million [n -S]\n",
  "MILLIARDS": "MILLIARD, (French) a thousand million [n]\n",
  "MILLIARE": "a unit of area [n -S]\n",
  "MILLIARES": "MILLIARE, a unit of area [n]\n",
  "MILLIARIES": "MILLIARY, an ancient Roman milestone [n]\n",
  "MILLIARY": "an ancient Roman milestone [n MILLIARIES]\n",
  "MILLIBAR": "a unit of barometric pressure, equal to a thousandth of a bar [n -S]\n",
  "MILLIBARS": "MILLIBAR, a unit of barometric pressure, equal to a thousandth of a bar [n]\n",
  "MILLICURIE": "a thousandth of a curie [n -S]\n",
  "MILLICURIES": "MILLICURIE, a thousandth of a curie [n]\n",
  "MILLIDEGREE": "a thousandth of a degree [n -S]\n",
  "MILLIDEGREES": "MILLIDEGREE, a thousandth of a degree [n]\n",
  "MILLIE": "(Irish) a young working-class woman [n -S]\n",
  "MILLIEME": "(French) a coin representing one thousandth of the basic unit of currency, as in Egypt [n -S]\n",
  "MILLIEMES": "MILLIEME, (French) a coin representing one thousandth of the basic unit of currency, as in Egypt [n]\n",
  "MILLIER": "a unit of weight [n -S]\n",
  "MILLIERS": "MILLIER, a unit of weight [n]\n",
  "MILLIES": "MILLIE, (Irish) a young working-class woman [n]\n",
  "MILLIGAL": "a thousandth of a gallon [n -S]\n",
  "MILLIGALS": "MILLIGAL, a thousandth of a gallon [n]\n",
  "MILLIGRAM": "a thousandth of a gram, also MILLIGRAMME [n -S]\n",
  "MILLIGRAMME": "a thousandth of a gram, also MILLIGRAM [n -S]\n",
  "MILLIGRAMMES": "MILLIGRAMME, a thousandth of a gram, also MILLIGRAM [n]\n",
  "MILLIGRAMS": "MILLIGRAM, a thousandth of a gram, also MILLIGRAMME [n]\n",
  "MILLIHENRIES": "MILLIHENRY, a thousandth of a henry [n]\n",
  "MILLIHENRY": "a thousandth of a henry [n MILLIHENRIES or MILLIHENRYS]\n",
  "MILLIHENRYS": "MILLIHENRY, a thousandth of a henry [n]\n",
  "MILLILAMBERT": "a thousandth of a lambert [n -S]\n",
  "MILLILAMBERTS": "MILLILAMBERT, a thousandth of a lambert [n]\n",
  "MILLILITER": "a thousandth of a litre, also MILLILITRE [n -S]\n",
  "MILLILITERS": "MILLILITER, a thousandth of a litre, also MILLILITRE [n]\n",
  "MILLILITRE": "a thousandth part of a litre, also MILLILITER [n -S]\n",
  "MILLILITRES": "MILLILITRE, a thousandth part of a litre, also MILLILITER [n]\n",
  "MILLILUCES": "MILLILUX, a unit of illumination, one thousandth of a lux [n]\n",
  "MILLILUX": "a unit of illumination, one thousandth of a lux [n MILLILUXES or MILLILUCES]\n",
  "MILLILUXES": "MILLILUX, a unit of illumination, one thousandth of a lux [n]\n",
  "MILLIME": "a monetary unit of Tunisia [n -S]\n",
  "MILLIMES": "MILLIME, a monetary unit of Tunisia [n]\n",
  "MILLIMETER": "a thousandth of a meter, also MILLIMETRE [n -S]\n",
  "MILLIMETERS": "MILLIMETER, a thousandth of a meter, also MILLIMETRE [n]\n",
  "MILLIMETRE": "a thousandth part of a metre, also MILLIMETER [n -S]\n",
  "MILLIMETRES": "MILLIMETRE, a thousandth part of a metre, also MILLIMETER [n]\n",
  "MILLIMHO": "a unit of electrical conductance, one thousandth of a mho [n -S]\n",
  "MILLIMHOS": "MILLIMHO, a unit of electrical conductance, one thousandth of a mho [n]\n",
  "MILLIMICRON": "a thousandth of a micron [n -S]\n",
  "MILLIMICRONS": "MILLIMICRON, a thousandth of a micron [n]\n",
  "MILLIMOLAR": "relating to a millimole, a thousandth of a mole [adj]\n",
  "MILLIMOLE": "a thousandth of a mole [n -S]\n",
  "MILLIMOLES": "MILLIMOLE, a thousandth of a mole [n]\n",
  "MILLINE": "a unit of advertising space [n -S]\n",
  "MILLINER": "one who makes or sells women's hats [n -S]\n",
  "MILLINERIES": "MILLINERY, hat-making [n]\n",
  "MILLINERS": "MILLINER, one who makes or sells women's hats [n]\n",
  "MILLINERY": "hat-making [n MILLINERIES]\n",
  "MILLINES": "MILLINE, a unit of advertising space [n]\n",
  "MILLING": "a corrugated edge on a coin [n -S]\n",
  "MILLINGS": "MILLING, a corrugated edge on a coin [n]\n",
  "MILLIOHM": "a unit of electrical resistance [n -S]\n",
  "MILLIOHMS": "MILLIOHM, a unit of electrical resistance [n]\n",
  "MILLION": "a thousand thousand [n -S]\n",
  "MILLIONAIRE": "a person whose wealth is estimated at a million or more (as of dollars or pounds), also MILLIONNAIRE [n -S]\n",
  "MILLIONAIRES": "MILLIONAIRE, a person whose wealth is estimated at a million or more (as of dollars or pounds), also MILLIONNAIRE [n]\n",
  "MILLIONAIRESS": "a female millionaire [n -ES]\n",
  "MILLIONAIRESSES": "MILLIONAIRESS, a female millionaire [n]\n",
  "MILLIONARY": "relating to or consisting of millions [adj]\n",
  "MILLIONFOLD": "multiplied by a million [adv] / a million times over [adj]\n",
  "MILLIONNAIRE": "one who possesses a million pounds, also MILLIONAIRE [n -S]\n",
  "MILLIONNAIRES": "MILLIONNAIRE, one who possesses a million pounds, also MILLIONAIRE [n]\n",
  "MILLIONNAIRESS": "a female who possesses a million pounds [n]\n",
  "MILLIONS": "MILLION, a thousand thousand [n]\n",
  "MILLIONTH": "the ordinal of million [adj] / a millionth part of [n -S]\n",
  "MILLIONTHS": "MILLIONTH, a millionth part of [n]\n",
  "MILLIOSMOL": "one thousandth of an osmol, a unit of osmotic pressure [n -S]\n",
  "MILLIOSMOLS": "MILLIOSMOL, one thousandth of an osmol, a unit of osmotic pressure [n]\n",
  "MILLIPED": "a myriapod with many legs, also MILLEPED, MILLEPEDE, MILLIPEDE [n -S]\n",
  "MILLIPEDE": "a myriapod with many legs, also MILLEPED, MILLEPEDE, MILLIPED [n -S]\n",
  "MILLIPEDES": "MILLIPEDE, a myriapod with many legs, also MILLEPED, MILLEPEDE, MILLIPED [n]\n",
  "MILLIPEDS": "MILLIPED, a myriapod with many legs, also MILLEPED, MILLEPEDE, MILLIPEDE [n]\n",
  "MILLIPROBE": "an instrument for analysing small quantities, esp. a spectrometer [n -S]\n",
  "MILLIPROBES": "MILLIPROBE, an instrument for analysing small quantities, esp. a spectrometer [n]\n",
  "MILLIRADIAN": "a thousandth of a radian [n -S]\n",
  "MILLIRADIANS": "MILLIRADIAN, a thousandth of a radian [n]\n",
  "MILLIREM": "a quantity of ionizing radiation, one thousandth of a rem [n -S]\n",
  "MILLIREMS": "MILLIREM, a quantity of ionizing radiation, one thousandth of a rem [n]\n",
  "MILLIROENTGEN": "one thousandth of a roentgen [n -S]\n",
  "MILLIROENTGENS": "MILLIROENTGEN, one thousandth of a roentgen [n]\n",
  "MILLISECOND": "a thousandth part of a second [n -S]\n",
  "MILLISECONDS": "MILLISECOND, a thousandth part of a second [n]\n",
  "MILLISIEVERT": "one thousandth of a sievert [n -S]\n",
  "MILLISIEVERTS": "MILLISIEVERT, one thousandth of a sievert [n]\n",
  "MILLIVOLT": "one thousandth of a volt [n -S]\n",
  "MILLIVOLTS": "MILLIVOLT, one thousandth of a volt [n]\n",
  "MILLIWATT": "one thousandth of a watt [n -S]\n",
  "MILLIWATTS": "MILLIWATT, one thousandth of a watt [n]\n",
  "MILLOCRACIES": "MILLOCRACY, the body of mill-owners regarded as a dominant or ruling class [n]\n",
  "MILLOCRACY": "the body of mill-owners regarded as a dominant or ruling class [n MILLOCRACIES]\n",
  "MILLOCRAT": "a member of the millocracy, the body of mill-owners regarded as a dominant or ruling class [n -S]\n",
  "MILLOCRATS": "MILLOCRAT, a member of the millocracy, the body of mill-owners regarded as a dominant or ruling class [n]\n",
  "MILLPOND": "a pool formed by damming a stream to provide water to turn a millwheel [n -S]\n",
  "MILLPONDS": "MILLPOND, a pool formed by damming a stream to provide water to turn a millwheel [n]\n",
  "MILLRACE": "the current of water that drives a mill wheel, also MILLRUN [n -S]\n",
  "MILLRACES": "MILLRACE, the current of water that drives a mill wheel, also MILLRUN [n]\n",
  "MILLRIND": "an iron support fitted across the hole in an upper millstone [n -S]\n",
  "MILLRINDS": "MILLRIND, an iron support fitted across the hole in an upper millstone [n]\n",
  "MILLRUN": "the current of water that drives a mill wheel, also MILLRACE [n -S]\n",
  "MILLRUNS": "MILLRUN, the current of water that drives a mill wheel, also MILLRACE [n]\n",
  "MILLS": "MILL, to grind corn, wheat etc. [v]\n",
  "MILLSCALE": "scale formed on iron or steel from heating for forging [n -S]\n",
  "MILLSCALES": "MILLSCALE, scale formed on iron or steel from heating for forging [n]\n",
  "MILLSTONE": "one of a pair of heavy flat disc-shaped stones that are rotated one against the other to grind grain [n -S]\n",
  "MILLSTONES": "MILLSTONE, one of a pair of heavy flat disc-shaped stones that are rotated one against the other to grind grain [n]\n",
  "MILLSTREAM": "a stream whose flow is utilized to run a mill [n -S]\n",
  "MILLSTREAMS": "MILLSTREAM, a stream whose flow is utilized to run a mill [n]\n",
  "MILLTAIL": "the channel in which water runs away below a millstream, aka tailrace [n -S]\n",
  "MILLTAILS": "MILLTAIL, the channel in which water runs away below a millstream, aka tailrace [n]\n",
  "MILLWHEEL": "a waterwheel that drives a mill [n -S]\n",
  "MILLWHEELS": "MILLWHEEL, a waterwheel that drives a mill [n]\n",
  "MILLWORK": "the shafting, gearing, and other driving machinery of mills [n -S]\n",
  "MILLWORKS": "MILLWORK, the shafting, gearing, and other driving machinery of mills [n]\n",
  "MILLWRIGHT": "a person whose occupation is planning and building mills or setting up their machinery [n -S]\n",
  "MILLWRIGHTS": "MILLWRIGHT, a person whose occupation is planning and building mills or setting up their machinery [n]\n",
  "MILNEB": "a fungicide [n -S]\n",
  "MILNEBS": "MILNEB, a fungicide [n]\n",
  "MILO": "a drought-resistant variety of sorghum [n -S]\n",
  "MILOMETER": "an instrument that records the number of miles that a vehicle, etc. has travelled, also MILEOMETER [n -S]\n",
  "MILOMETERS": "MILOMETER, an instrument that records the number of miles that a vehicle, etc. has travelled, also MILEOMETER [n]\n",
  "MILOR": "(French) a term of address for a rich or aristocratic Englishman, also MILORD [n -S]\n",
  "MILORD": "(French) a term of address for a rich or aristocratic Englishman, also MILOR [n -S]\n",
  "MILORDS": "MILORD, (French) a term of address for a rich or aristocratic Englishman, also MILOR [n]\n",
  "MILORS": "MILOR, (French) a term of address for a rich or aristocratic Englishman, also MILORD [n]\n",
  "MILOS": "MILO, a drought-resistant variety of sorghum [n]\n",
  "MILPA": "(Spanish) in Central America and Mexico, a small cultivated field, usually of corn or maize [n -S]\n",
  "MILPAS": "MILPA, (Spanish) in Central America and Mexico, a small cultivated field, usually of corn or maize [n]\n",
  "MILQUETOAST": "a very timid, unassertive person, also MILKTOAST [n -S]\n",
  "MILQUETOASTS": "MILQUETOAST, a very timid, unassertive person, also MILKTOAST [n]\n",
  "MILREIS": "(Portuguese) a former Portuguese coin superseded by the escudo [n MILREIS]\n",
  "MILS": "MIL, a unit of wire measurement [n]\n",
  "MILSEY": "(Scots) a milk strainer [n -S]\n",
  "MILSEYS": "MILSEY, (Scots) a milk strainer [n]\n",
  "MILT": "to impregnate with fish sperm [v -ED, -ING, -S]\n",
  "MILTED": "MILT, to impregnate with fish sperm [v]\n",
  "MILTER": "a male fish at breeding time [n -S]\n",
  "MILTERS": "MILTER, a male fish at breeding time [n]\n",
  "MILTIER": "MILTY, full of milt [adj]\n",
  "MILTIEST": "MILTY, full of milt [adj]\n",
  "MILTING": "MILT, to impregnate with fish sperm [v]\n",
  "MILTONIA": "a plant of the Miltonia genus of tropical American orchids with brightly-coloured flowers [n -S]\n",
  "MILTONIAS": "MILTONIA, a plant of the Miltonia genus of tropical American orchids with brightly-coloured flowers [n]\n",
  "MILTS": "MILT, to impregnate with fish sperm [v]\n",
  "MILTY": "full of milt [adj MILTIER, MILTIEST]\n",
  "MILTZ": "in Jewish cookery, the spleen [n -ES]\n",
  "MILTZES": "MILTZ, in Jewish cookery, the spleen [n]\n",
  "MILVINE": "of or resembling birds of the kite kind [adj]\n",
  "MIM": "prim, demure, prudish, also MIMSEY, MIMSY [adj MIMMER, MIMMEST]\n",
  "MIMBAR": "(Arabic) a mosque pulpit, also MINBAR [n -S]\n",
  "MIMBARS": "MIMBAR, (Arabic) a mosque pulpit, also MINBAR [n]\n",
  "MIME": "to mimic [v MIMED, MIMING, MIMES]\n",
  "MIMED": "MIME, to mimic [v]\n",
  "MIMEO": "to copy by mimeograph [v -ED, -ING, -S]\n",
  "MIMEOED": "MIMEO, to copy by mimeograph [v]\n",
  "MIMEOGRAPH": "(tradename) an autographic stencil copying device invented by Edison [n -S] / to copy by mimeograph [v -ED, -ING, -S]\n",
  "MIMEOGRAPHED": "MIMEOGRAPH, to copy by mimeograph [v]\n",
  "MIMEOGRAPHING": "MIMEOGRAPH, to copy by mimeograph [v]\n",
  "MIMEOGRAPHS": "MIMEOGRAPH, (tradename) an autographic stencil copying device invented by Edison [n]\n",
  "MIMEOING": "MIMEO, to copy by mimeograph [v]\n",
  "MIMEOS": "MIMEO, to copy by mimeograph [v]\n",
  "MIMER": "one that mimes [n -S]\n",
  "MIMERS": "MIMER, one that mimes [n]\n",
  "MIMES": "MIME, to mimic [v]\n",
  "MIMESES": "MIMESIS, (Greek) imitation, esp. in literature and art or by an animal of its surroundings, etc. [n]\n",
  "MIMESIS": "(Greek) imitation, esp. in literature and art or by an animal of its surroundings, etc. [n MIMESES or MIMESISES]\n",
  "MIMESISES": "MIMESIS, (Greek) imitation, esp. in literature and art or by an animal of its surroundings, etc. [n]\n",
  "MIMESTER": "one who mimes [n -S]\n",
  "MIMESTERS": "MIMESTER, one who mimes [n]\n",
  "MIMETIC": "imitative; of or relating to mimicry, also MIMETICAL [adj MIMETICALLY]\n",
  "MIMETICAL": "imitative; of or relating to mimicry, also MIMETIC [adj MIMETICALLY]\n",
  "MIMETICALLY": "MIMETICAL, imitative; of or relating to mimicry, also MIMETIC [adv]\n",
  "MIMETITE": "an arseniate of lead, occurring in pale yellow or brownish hexagonal crystals [n -S]\n",
  "MIMETITES": "MIMETITE, an arseniate of lead, occurring in pale yellow or brownish hexagonal crystals [n]\n",
  "MIMIC": "to imitate [v MIMICKED, MIMICKING, MIMICS]\n",
  "MIMICAL": "of the nature of mimicry [adj]\n",
  "MIMICKED": "MIMIC, to imitate [v]\n",
  "MIMICKER": "one who mimics [n -S]\n",
  "MIMICKERS": "MIMICKER, one who mimics [n]\n",
  "MIMICKING": "MIMIC, to imitate [v]\n",
  "MIMICRIES": "MIMICRY, an act of mimicking [n]\n",
  "MIMICRY": "an act of mimicking [n MIMICRIES]\n",
  "MIMICS": "MIMIC, to imitate [v]\n",
  "MIMING": "MIME, to mimic [v]\n",
  "MIMIVIRUS": "a genus of virus, one of the largest and most complex known [n -ES]\n",
  "MIMIVIRUSES": "MIMIVIRUS, a genus of virus, one of the largest and most complex known [n]\n",
  "MIMMER": "MIM, prim, demure, prudish, also MIMSEY, MIMSY [adj]\n",
  "MIMMEST": "MIM, prim, demure, prudish, also MIMSEY, MIMSY [adj]\n",
  "MIMMICK": "an affected person [n -S] / to be over-dainty, also MINNICK, MINNOCK [v -ED, -ING, -S]\n",
  "MIMMICKED": "MIMMICK, to be over-dainty, also MINNICK, MINNOCK [v]\n",
  "MIMMICKING": "MIMMICK, to be over-dainty, also MINNICK, MINNOCK [v]\n",
  "MIMMICKS": "MIMMICK, to be over-dainty, also MINNICK, MINNOCK [v]\n",
  "MIMOGRAPHER": "a writer of mimes [n -S]\n",
  "MIMOGRAPHERS": "MIMOGRAPHER, a writer of mimes [n]\n",
  "MIMOGRAPHIES": "MIMOGRAPHY, the writing of mimes [n]\n",
  "MIMOGRAPHY": "the writing of mimes [n MIMOGRAPHIES]\n",
  "MIMOSA": "any tropical shrubs or trees of the Mimosaceous genus Mimosa, having ball-like clusters of typically yellow flowers [n MIMOSAE or MIMOSAS]\n",
  "MIMOSACEOUS": "belonging to the mimosa family [adj]\n",
  "MIMOSAE": "MIMOSA, any tropical shrubs or trees of the Mimosaceous genus Mimosa, having ball-like clusters of typically yellow flowers [n]\n",
  "MIMOSAS": "MIMOSA, any tropical shrubs or trees of the Mimosaceous genus Mimosa, having ball-like clusters of typically yellow flowers [n]\n",
  "MIMSEY": "prim, demure, prudish, also MIM, MIMSY [adj MIMSIER, MIMSIEST]\n",
  "MIMSIER": "MIMSY, prim, demure, prudish, also MIM, MIMSEY [adj]\n",
  "MIMSIEST": "MIMSY, prim, demure, prudish, also MIM, MIMSEY [adj]\n",
  "MIMSY": "prim, demure, prudish, also MIM, MIMSEY [adj MIMSIER, MIMSIEST]\n",
  "MIMULUS": "any of various plants of the genus Mimulus, cultivated for their yellow or red flowers [n -ES]\n",
  "MIMULUSES": "MIMULUS, any of various plants of the genus Mimulus, cultivated for their yellow or red flowers [n]\n",
  "MINA": "an ancient unit of weight and value [n MINAS or MINAE]\n",
  "MINABLE": "able to be mined, also MINEABLE [adj]\n",
  "MINACIOUS": "threatening [adj MINACIOUSLY]\n",
  "MINACIOUSLY": "MINACIOUS, threatening [adv]\n",
  "MINACITIES": "MINACITY, the state of being threatening [n]\n",
  "MINACITY": "the state of being threatening [n MINACITIES]\n",
  "MINAE": "MINA, an ancient unit of weight and value [n]\n",
  "MINAR": "(Arabic) a tower [n -S]\n",
  "MINARET": "(Arabic) a slender tower attached to a mosque [n -S]\n",
  "MINARETED": "having a minaret [adj]\n",
  "MINARETS": "MINARET, (Arabic) a slender tower attached to a mosque [n]\n",
  "MINARS": "MINAR, (Arabic) a tower [n]\n",
  "MINAS": "MINA, an ancient unit of weight and value [n]\n",
  "MINATORIAL": "menacing, also MINATORY [adj MINATORIALLY]\n",
  "MINATORIALLY": "MINATORIAL, menacing, also MINATORY [adv]\n",
  "MINATORILY": "MINATORY, menacing, also MINATORIAL [adv]\n",
  "MINATORY": "menacing, also MINATORIAL [adj MINATORILY]\n",
  "MINAUDERIE": "(French) coquetry [n -S]\n",
  "MINAUDERIES": "MINAUDERIE, (French) coquetry [n]\n",
  "MINAUDIERE": "(French) an affected, coquettish female [n -S]\n",
  "MINAUDIERES": "MINAUDIERE, (French) an affected, coquettish female [n]\n",
  "MINBAR": "(Arabic) a mosque pulpit, also MIMBAR [n -S]\n",
  "MINBARS": "MINBAR, (Arabic) a mosque pulpit, also MIMBAR [n]\n",
  "MINCE": "to cut into very small pieces [v MINCED, MINCING, MINCES]\n",
  "MINCED": "MINCE, to cut into very small pieces [v]\n",
  "MINCEMEAT": "a mixture of dried fruit, spices, etc., used esp. for filling pies; minced meat [n -S]\n",
  "MINCEMEATS": "MINCEMEAT, a mixture of dried fruit, spices, etc., used esp. for filling pies; minced meat [n]\n",
  "MINCER": "one who minces [n -S]\n",
  "MINCERS": "MINCER, one who minces [n]\n",
  "MINCES": "MINCE, to cut into very small pieces [v]\n",
  "MINCEUR": "(French) of food, lean, low-fat [adj]\n",
  "MINCIER": "MINCY, affectedly dainty [adj]\n",
  "MINCIEST": "MINCY, affectedly dainty [adj]\n",
  "MINCING": "MINCE, to cut into very small pieces [v]\n",
  "MINCINGLY": "MINCING, MINCE, to cut into very small pieces [adv]\n",
  "MINCY": "affectedly dainty [adj MINCIER, MINCIEST]\n",
  "MIND": "to heed, to look after [v -ED, -ING, -S]\n",
  "MINDBLOWER": "something that blows the mind [n -S]\n",
  "MINDBLOWERS": "MINDBLOWER, something that blows the mind [n]\n",
  "MINDED": "MIND, to heed, to look after [v]\n",
  "MINDEDLY": "in the manner of one with a specified kind of mind [adv]\n",
  "MINDEDNESS": "an inclination to do something [n -ES]\n",
  "MINDEDNESSES": "MINDEDNESS, an inclination to do something [n]\n",
  "MINDER": "one that minds [n -S]\n",
  "MINDERS": "MINDER, one that minds [n]\n",
  "MINDFUCK": "(vulgar) an exhilarating experience [n -S]\n",
  "MINDFUCKS": "MINDFUCK, (vulgar) an exhilarating experience [n]\n",
  "MINDFUL": "heedful [adj MINDFULLY]\n",
  "MINDFULLY": "MINDFUL, heedful [adv]\n",
  "MINDFULNESS": "the state of being mindful [n -ES]\n",
  "MINDFULNESSES": "MINDFULNESS, the state of being mindful [n]\n",
  "MINDING": "the act of minding [n -S]\n",
  "MINDINGS": "MINDING, the act of minding [n]\n",
  "MINDLESS": "lacking intelligence [adj MINDLESSLY]\n",
  "MINDLESSLY": "MINDLESS, lacking intelligence [adv]\n",
  "MINDLESSNESS": "the state of being mindless [n -ES]\n",
  "MINDLESSNESSES": "MINDLESSNESS, the state of being mindless [n]\n",
  "MINDS": "MIND, to heed, to look after [v]\n",
  "MINDSCAPE": "the range of a person's thoughts and imagination, regarded as a panorama [n -S]\n",
  "MINDSCAPES": "MINDSCAPE, the range of a person's thoughts and imagination, regarded as a panorama [n]\n",
  "MINDSET": "a fixed mental attitude [n -S]\n",
  "MINDSETS": "MINDSET, a fixed mental attitude [n]\n",
  "MINDSHARE": "the level of awareness in consumers' minds of a particular product [n -S]\n",
  "MINDSHARES": "MINDSHARE, the level of awareness in consumers' minds of a particular product [n]\n",
  "MINE": "to dig for valuable materials [v MINED, MINING, MINES]\n",
  "MINEABLE": "able to be mined, also MINABLE [adj]\n",
  "MINED": "MINE, to dig for valuable materials [v]\n",
  "MINEFIELD": "an area laid with explosive mines [n -S]\n",
  "MINEFIELDS": "MINEFIELD, an area laid with explosive mines [n]\n",
  "MINEHUNTER": "a naval vessel that searches for mines by electronic means [n -S]\n",
  "MINEHUNTERS": "MINEHUNTER, a naval vessel that searches for mines by electronic means [n]\n",
  "MINELAYER": "a ship used to lay mines [n -S]\n",
  "MINELAYERS": "MINELAYER, a ship used to lay mines [n]\n",
  "MINELAYING": "the act of laying mines [n -S]\n",
  "MINELAYINGS": "MINELAYING, the act of laying mines [n]\n",
  "MINEOLA": "a variety of citrus fruit developed from a tangerine and a grapefruit, also MINNEOLA [n -S]\n",
  "MINEOLAS": "MINEOLA, a variety of citrus fruit developed from a tangerine and a grapefruit, also MINNEOLA [n]\n",
  "MINER": "one that mines [n -S]\n",
  "MINERAL": "any of various classes of inorganic substances [n -S]\n",
  "MINERALISABLE": "that can be mineralised, also MINERALIZABLE [adj]\n",
  "MINERALISATION": "the act of mineralising, also MINERALIZATION [n -S]\n",
  "MINERALISATIONS": "MINERALISATION, the act of mineralising, also MINERALIZATION [n]\n",
  "MINERALISE": "to transform into a mineral, also MINERALIZE [v MINERALISED, MINERALISING, MINERALISES]\n",
  "MINERALISED": "MINERALISE, to transform into a mineral, also MINERALIZE [v]\n",
  "MINERALISER": "a person who, or that which, mineralises, also MINERALIZER [n -S]\n",
  "MINERALISERS": "MINERALISER, a person who, or that which, mineralises, also MINERALIZER [n]\n",
  "MINERALISES": "MINERALISE, to transform into a mineral, also MINERALIZE [v]\n",
  "MINERALISING": "MINERALISE, to transform into a mineral, also MINERALIZE [v]\n",
  "MINERALIST": "one versed in minerals; a mineralogist [n -S]\n",
  "MINERALISTS": "MINERALIST, one versed in minerals; a mineralogist [n]\n",
  "MINERALIZABLE": "that can be mineralised, also MINERALISABLE [adj]\n",
  "MINERALIZATION": "the act of mineralizing, also MINERALISATION [n -S]\n",
  "MINERALIZATIONS": "MINERALIZATION, the act of mineralizing, also MINERALISATION [n]\n",
  "MINERALIZE": "to transform into a mineral, also MINERALISE [v MINERALIZED, MINERALIZING, MINERALIZES]\n",
  "MINERALIZED": "MINERALIZE, to transform into a mineral, also MINERALISE [v]\n",
  "MINERALIZER": "a person who, or that which, mineralises, also MINERALISER [n -S]\n",
  "MINERALIZERS": "MINERALIZER, a person who, or that which, mineralises, also MINERALISER [n]\n",
  "MINERALIZES": "MINERALIZE, to transform into a mineral, also MINERALISE [v]\n",
  "MINERALIZING": "MINERALIZE, to transform into a mineral, also MINERALISE [v]\n",
  "MINERALOGIC": "relating to mineralogy [adj MINERALOGICALLY]\n",
  "MINERALOGICAL": "relating to mineralogy [adj MINERALOGICALLY]\n",
  "MINERALOGICALLY": "MINERALOGICAL, relating to mineralogy [adv]\n",
  "MINERALOGIES": "MINERALOGY, the study of minerals [n]\n",
  "MINERALOGISE": "to collect or study minerals, also MINERALOGIZE [v MINERALOGISED, MINERALOGISING, MINERALOGISES]\n",
  "MINERALOGISED": "MINERALOGISE, to collect or study minerals, also MINERALOGIZE [v]\n",
  "MINERALOGISES": "MINERALOGISE, to collect or study minerals, also MINERALOGIZE [v]\n",
  "MINERALOGISING": "MINERALOGISE, to collect or study minerals, also MINERALOGIZE [v]\n",
  "MINERALOGIST": "a student of mineralogy [n -S]\n",
  "MINERALOGISTS": "MINERALOGIST, a student of mineralogy [n]\n",
  "MINERALOGIZE": "to collect or study minerals, also MINERALOGISE [v MINERALOGIZED, MINERALOGIZING, MINERALOGIZES]\n",
  "MINERALOGIZED": "MINERALOGIZE, to collect or study minerals, also MINERALOGISE [v]\n",
  "MINERALOGIZES": "MINERALOGIZE, to collect or study minerals, also MINERALOGISE [v]\n",
  "MINERALOGIZING": "MINERALOGIZE, to collect or study minerals, also MINERALOGISE [v]\n",
  "MINERALOGY": "the study of minerals [n MINERALOGIES]\n",
  "MINERALS": "MINERAL, any of various classes of inorganic substances [n]\n",
  "MINERS": "MINER, one that mines [n]\n",
  "MINES": "MINE, to dig for valuable materials [v]\n",
  "MINESHAFT": "a vertical entrance into a mine [n -S]\n",
  "MINESHAFTS": "MINESHAFT, a vertical entrance into a mine [n]\n",
  "MINESTONE": "ore, esp. ironstone [n -S]\n",
  "MINESTONES": "MINESTONE, ore, esp. ironstone [n]\n",
  "MINESTRONE": "(Italian) a thick vegetable soup containing pasta or rice [n -S]\n",
  "MINESTRONES": "MINESTRONE, (Italian) a thick vegetable soup containing pasta or rice [n]\n",
  "MINESWEEPER": "a ship used to clear mines [n -S]\n",
  "MINESWEEPERS": "MINESWEEPER, a ship used to clear mines [n]\n",
  "MINESWEEPING": "searching for mines [n -S]\n",
  "MINESWEEPINGS": "MINESWEEPING, searching for mines [n]\n",
  "MINETTE": "(French) the smallest of regular sizes of portrait photographs [n -S]\n",
  "MINETTES": "MINETTE, (French) the smallest of regular sizes of portrait photographs [n]\n",
  "MINEVER": "the ermine in winter coat, also MINIVER [n -S]\n",
  "MINEVERS": "MINEVER, the ermine in winter coat, also MINIVER [n]\n",
  "MINEWORKER": "one who works in a mine [n -S]\n",
  "MINEWORKERS": "MINEWORKER, one who works in a mine [n]\n",
  "MING": "to mix [v MINGED, MINGING, MINGS]\n",
  "MINGE": "(vulgar) the female genitalia [n -S]\n",
  "MINGED": "MING, to mix [v]\n",
  "MINGER": "(offensive) an unpleasant person [n -S]\n",
  "MINGERS": "MINGER, (offensive) an unpleasant person [n]\n",
  "MINGES": "MINGE, (vulgar) the female genitalia [n]\n",
  "MINGIER": "MINGY, mean and stingy [adj]\n",
  "MINGIEST": "MINGY, mean and stingy [adj]\n",
  "MINGILY": "MINGY, mean and stingy [adv]\n",
  "MINGIMINGI": "(Maori) a type of New Zealand tree with white berries [n -S]\n",
  "MINGIMINGIS": "MINGIMINGI, (Maori) a type of New Zealand tree with white berries [n]\n",
  "MINGINESS": "meanness, stinginess [n -ES]\n",
  "MINGINESSES": "MINGINESS, meanness, stinginess [n]\n",
  "MINGING": "MING, to mix [v]\n",
  "MINGLE": "to mix together [v MINGLED, MINGLING, MINGLES]\n",
  "MINGLED": "MINGLE, to mix together [v]\n",
  "MINGLEMENT": "the act of mingling, or the state of being mixed [n -S]\n",
  "MINGLEMENTS": "MINGLEMENT, the act of mingling, or the state of being mixed [n]\n",
  "MINGLER": "one who mingles [n -S]\n",
  "MINGLERS": "MINGLER, one who mingles [n]\n",
  "MINGLES": "MINGLE, to mix together [v]\n",
  "MINGLING": "the act of mixing [n -S]\n",
  "MINGLINGLY": "MINGLING [adv]\n",
  "MINGLINGS": "MINGLING, the act of mixing [n]\n",
  "MINGS": "MING, to mix [v]\n",
  "MINGY": "mean and stingy [adj MINGIER, MINGIEST, MINGILY]\n",
  "MINI": "something small of its type [n -S]\n",
  "MINIATE": "to decorate with rubrics; to illuminate a manuscript [v MINIATED, MINIATING, MINIATES]\n",
  "MINIATED": "MINIATE, to decorate with rubrics; to illuminate a manuscript [v]\n",
  "MINIATES": "MINIATE, to decorate with rubrics; to illuminate a manuscript [v]\n",
  "MINIATING": "MINIATE, to decorate with rubrics; to illuminate a manuscript [v]\n",
  "MINIATION": "the act of painting with minium [n -S]\n",
  "MINIATIONS": "MINIATION, the act of painting with minium [n]\n",
  "MINIATURE": "a small or reduced copy, type or breed of anything [n -S] / to miniaturize [v MINIATURED, MINIATURING, MINIATURES]\n",
  "MINIATURED": "MINIATURE, to miniaturize [v]\n",
  "MINIATURES": "MINIATURE, to miniaturize [v]\n",
  "MINIATURING": "MINIATURE, to miniaturize [v]\n",
  "MINIATURISATION": "the act of miniaturising, also MINIATURIZATION [n]\n",
  "MINIATURISE": "to design or construct in small size, also MINIATURIZE [v MINIATURISED, MINIATURISING, MINIATURISES]\n",
  "MINIATURISED": "MINIATURISE, to design or construct in small size, also MINIATURIZE [v]\n",
  "MINIATURISES": "MINIATURISE, to design or construct in small size, also MINIATURIZE [v]\n",
  "MINIATURISING": "MINIATURISE, to design or construct in small size, also MINIATURIZE [v]\n",
  "MINIATURIST": "one who paints miniatures [n -S]\n",
  "MINIATURISTIC": "in the style of a miniaturist [adj]\n",
  "MINIATURISTS": "MINIATURIST, one who paints miniatures [n]\n",
  "MINIATURIZATION": "the act of miniaturizing, also MINIATURISATION [n]\n",
  "MINIATURIZE": "to design or construct in small size, also MINIATURISE [v MINIATURIZED, MINIATURIZING, MINIATURIZES]\n",
  "MINIATURIZED": "MINIATURIZE, to design or construct in small size, also MINIATURISE [v]\n",
  "MINIATURIZES": "MINIATURIZE, to design or construct in small size, also MINIATURISE [v]\n",
  "MINIATURIZING": "MINIATURIZE, to design or construct in small size, also MINIATURISE [v]\n",
  "MINIBAR": "a small fridge as in a hotel room [n -S]\n",
  "MINIBARS": "MINIBAR, a small fridge as in a hotel room [n]\n",
  "MINIBIKE": "a small motorcycle [n -S]\n",
  "MINIBIKER": "one who rides a minibike [n -S]\n",
  "MINIBIKERS": "MINIBIKER, one who rides a minibike [n]\n",
  "MINIBIKES": "MINIBIKE, a small motorcycle [n]\n",
  "MINIBREAK": "a short break [n -S]\n",
  "MINIBREAKS": "MINIBREAK, a short break [n]\n",
  "MINIBUDGET": "a small budget [n -S]\n",
  "MINIBUDGETS": "MINIBUDGET, a small budget [n]\n",
  "MINIBUS": "a small bus [n MINIBUSES or MINIBUSSES]\n",
  "MINIBUSES": "MINIBUS, a small bus [n]\n",
  "MINIBUSSES": "MINIBUS, a small bus [n]\n",
  "MINICAB": "a small taxicab [n -S]\n",
  "MINICABBING": "travelling by minicab [n -S]\n",
  "MINICABBINGS": "MINICABBING, travelling by minicab [n]\n",
  "MINICABS": "MINICAB, a small taxicab [n]\n",
  "MINICALCULATOR": "a very small handheld calculator [n -S]\n",
  "MINICALCULATORS": "MINICALCULATOR, a very small handheld calculator [n]\n",
  "MINICAM": "a portable TV camera [n -S]\n",
  "MINICAMP": "a brief training camp for football players [n -S]\n",
  "MINICAMPS": "MINICAMP, a brief training camp for football players [n]\n",
  "MINICAMS": "MINICAM, a portable TV camera [n]\n",
  "MINICAR": "a small automobile [n -S]\n",
  "MINICARS": "MINICAR, a small automobile [n]\n",
  "MINICASSETTE": "a small tape cassette for use in a handheld tape recorder [n -S]\n",
  "MINICASSETTES": "MINICASSETTE, a small tape cassette for use in a handheld tape recorder [n]\n",
  "MINICOM": "a communication device which allows deaf people to receive telephone messages [n -S]\n",
  "MINICOMPUTER": "a small computer that is intermediate between a microcomputer and a mainframe [n -S]\n",
  "MINICOMPUTERS": "MINICOMPUTER, a small computer that is intermediate between a microcomputer and a mainframe [n]\n",
  "MINICOMS": "MINICOM, a communication device which allows deaf people to receive telephone messages [n]\n",
  "MINICOURSE": "a short course [n -S]\n",
  "MINICOURSES": "MINICOURSE, a short course [n]\n",
  "MINIDISC": "a miniature compact disc, also MINIDISK [n -S]\n",
  "MINIDISCS": "MINIDISC, a miniature compact disc, also MINIDISK [n]\n",
  "MINIDISH": "a small receiving dish for receiving satellite transmissions [n -ES]\n",
  "MINIDISHES": "MINIDISH, a small receiving dish for receiving satellite transmissions [n]\n",
  "MINIDISK": "a miniature compact disc, also MINIDISC [n -S]\n",
  "MINIDISKS": "MINIDISK, a miniature compact disc, also MINIDISC [n]\n",
  "MINIDRESS": "a short dress [n -ES]\n",
  "MINIDRESSES": "MINIDRESS, a short dress [n]\n",
  "MINIER": "MINY, abounding with mines; like a mine [adj]\n",
  "MINIEST": "MINY, abounding with mines; like a mine [adj]\n",
  "MINIFICATION": "diminishment [n -S]\n",
  "MINIFICATIONS": "MINIFICATION, diminishment [n]\n",
  "MINIFIED": "MINIFY, to diminish, in appearance or reality [v]\n",
  "MINIFIES": "MINIFY, to diminish, in appearance or reality [v]\n",
  "MINIFLOPPIES": "MINIFLOPPY, a small floppy disk [n]\n",
  "MINIFLOPPY": "a small floppy disk [n MINIFLOPPIES]\n",
  "MINIFY": "to diminish, in appearance or reality [v MINIFIED, MINIFYING, MINIFIES]\n",
  "MINIFYING": "MINIFY, to diminish, in appearance or reality [v]\n",
  "MINIGOLF": "a game similar to golf played on a small obstacle course [n -S]\n",
  "MINIGOLFS": "MINIGOLF, a game similar to golf played on a small obstacle course [n]\n",
  "MINIKIN": "(Dutch) a small dainty creature [n -S]\n",
  "MINIKINS": "MINIKIN, (Dutch) a small dainty creature [n]\n",
  "MINILAB": "a retail outlet offering rapid on-site film development [n -S]\n",
  "MINILABS": "MINILAB, a retail outlet offering rapid on-site film development [n]\n",
  "MINIM": "a note with the time value of half a semibreve or two crotchets [n -S]\n",
  "MINIMA": "MINIMUM, (Latin) the least possible amount [n]\n",
  "MINIMAL": "relating to the minimum [adj MINIMALLY] / a term in a mathematical set preceding all others [n -S]\n",
  "MINIMALISM": "making do with as little as possible [n -S]\n",
  "MINIMALISMS": "MINIMALISM, making do with as little as possible [n]\n",
  "MINIMALIST": "one who makes do with as little as possible [n -S]\n",
  "MINIMALISTIC": "(of an artistic style) using simple elements with little embellishment [adj]\n",
  "MINIMALISTS": "MINIMALIST, one who makes do with as little as possible [n]\n",
  "MINIMALLY": "MINIMAL, relating to the minimum [adv]\n",
  "MINIMALS": "MINIMAL, a term in a mathematical set preceding all others [n]\n",
  "MINIMARKET": "a small supermarket, also MINIMART [n -S]\n",
  "MINIMARKETS": "MINIMARKET, a small supermarket, also MINIMART [n]\n",
  "MINIMART": "a small supermarket, convenience store, also MINIMARKET [n -S]\n",
  "MINIMARTS": "MINIMART, a small supermarket, convenience store, also MINIMARKET [n]\n",
  "MINIMAX": "to minimize the maximum possible extent of one's loss [v -ED, -ING, -ES]\n",
  "MINIMAXED": "MINIMAX, to minimize the maximum possible extent of one's loss [v]\n",
  "MINIMAXES": "MINIMAX, to minimize the maximum possible extent of one's loss [v]\n",
  "MINIMAXING": "MINIMAX, to minimize the maximum possible extent of one's loss [v]\n",
  "MINIMENT": "a means of defence, also MUNIMENT [n -S]\n",
  "MINIMENTS": "MINIMENT, a means of defence, also MUNIMENT [n]\n",
  "MINIMILL": "a small-scale steel mill [n -S]\n",
  "MINIMILLS": "MINIMILL, a small-scale steel mill [n]\n",
  "MINIMISATION": "the act of minimising, also MINIMIZATION [n -S]\n",
  "MINIMISATIONS": "MINIMISATION, the act of minimising, also MINIMIZATION [n]\n",
  "MINIMISE": "to make as small as possible, also MINIMIZE [v MINIMISED, MINIMISING, MINIMISES]\n",
  "MINIMISED": "MINIMISE, to make as small as possible, also MINIMIZE [v]\n",
  "MINIMISER": "one who minimises, also MINIMIZER [n -S]\n",
  "MINIMISERS": "MINIMISER, one who minimises, also MINIMIZER [n]\n",
  "MINIMISES": "MINIMISE, to make as small as possible, also MINIMIZE [v]\n",
  "MINIMISING": "MINIMISE, to make as small as possible, also MINIMIZE [v]\n",
  "MINIMISM": "the inclination to reduce a dogma to the least possible [n -S]\n",
  "MINIMISMS": "MINIMISM, the inclination to reduce a dogma to the least possible [n]\n",
  "MINIMIST": "one inclined to reduce a dogma to the least possible [n -S]\n",
  "MINIMISTS": "MINIMIST, one inclined to reduce a dogma to the least possible [n]\n",
  "MINIMIZATION": "the act of minimizing, also MINIMISATION [n -S]\n",
  "MINIMIZATIONS": "MINIMIZATION, the act of minimizing, also MINIMISATION [n]\n",
  "MINIMIZE": "to make as small as possible, also MINIMISE [v MINIMIZED, MINIMIZING, MINIMIZES]\n",
  "MINIMIZED": "MINIMIZE, to make as small as possible, also MINIMISE [v]\n",
  "MINIMIZER": "one who minimizes, also MINIMISER [n -S]\n",
  "MINIMIZERS": "MINIMIZER, one who minimizes, also MINIMISER [n]\n",
  "MINIMIZES": "MINIMIZE, to make as small as possible, also MINIMISE [v]\n",
  "MINIMIZING": "MINIMIZE, to make as small as possible, also MINIMISE [v]\n",
  "MINIMOTO": "a reduced size replica motorcycle used for racing [n -S]\n",
  "MINIMOTOS": "MINIMOTO, a reduced size replica motorcycle used for racing [n]\n",
  "MINIMS": "MINIM, a note with the time value of half a semibreve or two crotchets [n]\n",
  "MINIMUM": "(Latin) the least possible amount [n MINIMUMS or MINIMA]\n",
  "MINIMUMS": "MINIMUM, (Latin) the least possible amount [n]\n",
  "MINIMUS": "(Latin) a being of the smallest size [n -ES]\n",
  "MINIMUSES": "MINIMUS, (Latin) a being of the smallest size [n]\n",
  "MINING": "the business of working mines [n -S]\n",
  "MININGS": "MINING, the business of working mines [n]\n",
  "MINION": "a darling, a favourite [n -S]\n",
  "MINIONS": "MINION, a darling, a favourite [n]\n",
  "MINIPARK": "a small city park [n -S]\n",
  "MINIPARKS": "MINIPARK, a small city park [n]\n",
  "MINIPILL": "a low dose oral contraceptive [n -S]\n",
  "MINIPILLS": "MINIPILL, a low dose oral contraceptive [n]\n",
  "MINIRUGBIES": "MINIRUGBY, a scaled down version of rugby [n]\n",
  "MINIRUGBY": "a scaled down version of rugby [n MINIRUGBIES]\n",
  "MINIS": "MINI, something small of its type [n]\n",
  "MINISCHOOL": "a small school [n -S]\n",
  "MINISCHOOLS": "MINISCHOOL, a small school [n]\n",
  "MINISCULE": "small, insignificant [adj] / a small cursive script, also MINUSCULE [n -S]\n",
  "MINISCULES": "MINISCULE, a small cursive script, also MINUSCULE [n]\n",
  "MINISERIES": "a short series e.g. on TV [n MINISERIES]\n",
  "MINISH": "(archaic) to diminish [v -ED, -ING, -ES]\n",
  "MINISHED": "MINISH, (archaic) to diminish [v]\n",
  "MINISHES": "MINISH, (archaic) to diminish [v]\n",
  "MINISHING": "MINISH, (archaic) to diminish [v]\n",
  "MINISKI": "a short ski [n -S]\n",
  "MINISKIRT": "a skirt whose hemline is well above the knees [n -S]\n",
  "MINISKIRTED": "wearing a miniskirt, a skirt whose hemline is well above the knees [adj]\n",
  "MINISKIRTS": "MINISKIRT, a skirt whose hemline is well above the knees [n]\n",
  "MINISKIS": "MINISKI, a short ski [n]\n",
  "MINISODE": "a heavily abridged version of a television episode, esp. as broadcast on the Internet [n -S]\n",
  "MINISODES": "MINISODE, a heavily abridged version of a television episode, esp. as broadcast on the Internet [n]\n",
  "MINISTATE": "a small state [n -S]\n",
  "MINISTATES": "MINISTATE, a small state [n]\n",
  "MINISTER": "to give aid or service [v -ED, -ING, -S]\n",
  "MINISTERED": "MINISTER, to give aid or service [v]\n",
  "MINISTERIA": "MINISTERIUM, (Latin) a ministry [n]\n",
  "MINISTERIAL": "of, relating to, or characteristic of a minister or the ministry [adj MINISTERIALLY]\n",
  "MINISTERIALIST": "a supporter of the government in office [n -S]\n",
  "MINISTERIALISTS": "MINISTERIALIST, a supporter of the government in office [n]\n",
  "MINISTERIALLY": "MINISTERIAL, of, relating to, or characteristic of a minister or the ministry [adv]\n",
  "MINISTERING": "MINISTER, to give aid or service [v]\n",
  "MINISTERIUM": "(Latin) a ministry [n MINISTERIA]\n",
  "MINISTERS": "MINISTER, to give aid or service [v]\n",
  "MINISTERSHIP": "the office of minister [n -S]\n",
  "MINISTERSHIPS": "MINISTERSHIP, the office of minister [n]\n",
  "MINISTRANT": "an attendant [n -S]\n",
  "MINISTRANTS": "MINISTRANT, an attendant [n]\n",
  "MINISTRATION": "the act of ministering [n -S]\n",
  "MINISTRATIONS": "MINISTRATION, the act of ministering [n]\n",
  "MINISTRATIVE": "serving to aid or assist [adj]\n",
  "MINISTRESS": "a woman who ministers [n -ES]\n",
  "MINISTRESSES": "MINISTRESS, a woman who ministers [n]\n",
  "MINISTRIES": "MINISTRY, the act of ministering [n]\n",
  "MINISTROKE": "a small stroke [n -S]\n",
  "MINISTROKES": "MINISTROKE, a small stroke [n]\n",
  "MINISTRY": "the act of ministering [n MINISTRIES]\n",
  "MINISYSTEM": "a set of hi-fidelity equipment in which the components are smaller than standard size [n -S]\n",
  "MINISYSTEMS": "MINISYSTEM, a set of hi-fidelity equipment in which the components are smaller than standard size [n]\n",
  "MINITOWER": "a computer in a small vertical cabinet [n -S]\n",
  "MINITOWERS": "MINITOWER, a computer in a small vertical cabinet [n]\n",
  "MINITRACK": "(tradename) a satellite tracking system [n -S]\n",
  "MINITRACKS": "MINITRACK, (tradename) a satellite tracking system [n]\n",
  "MINIUM": "(Latin) a red pigment [n -S]\n",
  "MINIUMS": "MINIUM, (Latin) a red pigment [n]\n",
  "MINIVAN": "a small van [n -S]\n",
  "MINIVANS": "MINIVAN, a small van [n]\n",
  "MINIVER": "the ermine in winter coat, also MINEVER [n -S]\n",
  "MINIVERS": "MINIVER, the ermine in winter coat, also MINEVER [n]\n",
  "MINIVET": "a brightly coloured shrike-like bird [n -S]\n",
  "MINIVETS": "MINIVET, a brightly coloured shrike-like bird [n]\n",
  "MINIVOLLEY": "a scaled down version of volleyball [n -S]\n",
  "MINIVOLLEYS": "MINIVOLLEY, a scaled down version of volleyball [n]\n",
  "MINK": "a carnivorous mammal of the weasel family [n -S]\n",
  "MINKE": "(Norwegian) a kind of small whale [n -S]\n",
  "MINKES": "MINKE, (Norwegian) a kind of small whale [n]\n",
  "MINKS": "MINK, a carnivorous mammal of the weasel family [n]\n",
  "MINNEOLA": "a variety of citrus fruit developed from a tangerine and a grapefruit, also MINEOLA [n -S]\n",
  "MINNEOLAS": "MINNEOLA, a variety of citrus fruit developed from a tangerine and a grapefruit, also MINEOLA [n]\n",
  "MINNESINGER": "(German) a troubadour-like poet of medieval Germany [n -S]\n",
  "MINNESINGERS": "MINNESINGER, (German) a troubadour-like poet of medieval Germany [n]\n",
  "MINNICK": "to be over dainty in eating, also MINNOCK [v -ED, -ING, -S]\n",
  "MINNICKED": "MINNICK, to be over dainty in eating, also MINNOCK [v]\n",
  "MINNICKING": "MINNICK, to be over dainty in eating, also MINNOCK [v]\n",
  "MINNICKS": "MINNICK, to be over dainty in eating, also MINNOCK [v]\n",
  "MINNIE": "(Scots) mother [n -S]\n",
  "MINNIES": "MINNIE, (Scots) mother [n]\n",
  "MINNOCK": "to be over dainty in eating, also MINNICK [v -ED, -ING, -S]\n",
  "MINNOCKED": "MINNOCK, to be over dainty in eating, also MINNICK [v]\n",
  "MINNOCKING": "MINNOCK, to be over dainty in eating, also MINNICK [v]\n",
  "MINNOCKS": "MINNOCK, to be over dainty in eating, also MINNICK [v]\n",
  "MINNOW": "any of the small freshwater fish of the Cyprinidae family [n -S]\n",
  "MINNOWS": "MINNOW, any of the small freshwater fish of the Cyprinidae family [n]\n",
  "MINNY": "a small fish, a minnow [n MINNIES]\n",
  "MINO": "(Japanese) a raincoat of hemp [n -S]\n",
  "MINOR": "to study a subsidiary subject at college [v -ED, -ING, -S]\n",
  "MINORCA": "any of a breed of large domestic fowls [n -S]\n",
  "MINORCAS": "MINORCA, any of a breed of large domestic fowls [n]\n",
  "MINORED": "MINOR, to study a subsidiary subject at college [v]\n",
  "MINORING": "MINOR, to study a subsidiary subject at college [v]\n",
  "MINORITAIRE": "(French) a member of a minority section of a political party, esp. a socialist one [n -S]\n",
  "MINORITAIRES": "MINORITAIRE, (French) a member of a minority section of a political party, esp. a socialist one [n]\n",
  "MINORITIES": "MINORITY, the fact of being little or less [n]\n",
  "MINORITY": "the fact of being little or less [n MINORITIES]\n",
  "MINORS": "MINOR, to study a subsidiary subject at college [v]\n",
  "MINORSHIP": "the state of being a minor [n -S]\n",
  "MINORSHIPS": "MINORSHIP, the state of being a minor [n]\n",
  "MINOS": "MINO, (Japanese) a raincoat of hemp [n]\n",
  "MINOTAUR": "as in minotaur beetle, a kind of dung-beetle [adj]\n",
  "MINOXIDIL": "a peripheral vasodilator used to treat hypertension [n -S]\n",
  "MINOXIDILS": "MINOXIDIL, a peripheral vasodilator used to treat hypertension [n]\n",
  "MINSHUKU": "(Japanese) a Japanese guest house [n -S]\n",
  "MINSHUKUS": "MINSHUKU, (Japanese) a Japanese guest house [n]\n",
  "MINSTER": "a large church or cathedral [n -S]\n",
  "MINSTERS": "MINSTER, a large church or cathedral [n]\n",
  "MINSTREL": "a medieval musician, itinerant or attached to a noble household [n -S]\n",
  "MINSTRELS": "MINSTREL, a medieval musician, itinerant or attached to a noble household [n]\n",
  "MINSTRELSIES": "MINSTRELSY, the singing and playing of a minstrel [n]\n",
  "MINSTRELSY": "the singing and playing of a minstrel [n MINSTRELSIES]\n",
  "MINT": "to process or stamp coins [v -ED, -ING, -S]\n",
  "MINTAGE": "the coin, or other production, made in a mint [n -S]\n",
  "MINTAGES": "MINTAGE, the coin, or other production, made in a mint [n]\n",
  "MINTED": "MINT, to process or stamp coins [v]\n",
  "MINTER": "a person who coins or stamps money [n -S]\n",
  "MINTERS": "MINTER, a person who coins or stamps money [n]\n",
  "MINTIER": "MINTY, having the flavour of the aromatic herb mint [adj]\n",
  "MINTIEST": "MINTY, having the flavour of the aromatic herb mint [adj]\n",
  "MINTING": "MINT, to process or stamp coins [v]\n",
  "MINTLIKE": "like mint [adj]\n",
  "MINTS": "MINT, to process or stamp coins [v]\n",
  "MINTY": "having the flavour of the aromatic herb mint [adj MINTIER, MINTIEST]\n",
  "MINUEND": "a number from which another is to be subtracted [n -S]\n",
  "MINUENDS": "MINUEND, a number from which another is to be subtracted [n]\n",
  "MINUET": "a slow and stately Baroque dance in 3/4 time [n -S] / to dance a minuet [v -ED, -ING, -S]\n",
  "MINUETED": "MINUET, to dance a minuet [v]\n",
  "MINUETING": "MINUET, to dance a minuet [v]\n",
  "MINUETS": "MINUET, a slow and stately Baroque dance in 3/4 time [n]\n",
  "MINUS": "a negative quantity [n -ES]\n",
  "MINUSCULAR": "of or like minuscule (script) [adj]\n",
  "MINUSCULE": "small, insignificant [adj] / a small cursive script, also MINISCULE [n -S]\n",
  "MINUSCULES": "MINUSCULE, a small cursive script, also MINISCULE [n]\n",
  "MINUSES": "MINUS, a negative quantity [n]\n",
  "MINUTE": "to take brief notes [v MINUTED, MINUTING, MINUTES] / very small [adj MINUTER, MINUTEST, MINUTELY]\n",
  "MINUTED": "MINUTE, to take brief notes [v]\n",
  "MINUTELY": "MINUTE, very small [adv]\n",
  "MINUTEMAN": "in the American Revolution, a militiaman who was to be ready to march at a moment's notice [n MINUTEMEN]\n",
  "MINUTEMEN": "MINUTEMAN, in the American Revolution, a militiaman who was to be ready to march at a moment's notice [n]\n",
  "MINUTENESS": "the quality of being minute [n -ES]\n",
  "MINUTENESSES": "MINUTENESS, the quality of being minute [n]\n",
  "MINUTER": "MINUTE, very small [adj]\n",
  "MINUTES": "MINUTE, to take brief notes [v]\n",
  "MINUTEST": "MINUTE, very small [adj]\n",
  "MINUTIA": "(Latin) a small detail [n MINUTIAE]\n",
  "MINUTIAE": "MINUTIA, (Latin) a small detail [n]\n",
  "MINUTIAL": "of or like a minutia, a minute particular or detail, also MINUTIOSE [adj]\n",
  "MINUTING": "MINUTE, to take brief notes [v]\n",
  "MINUTIOSE": "of or like a minutia, a minute particular or detail, also MINUTIAL [adj]\n",
  "MINX": "a pert girl [n -ES]\n",
  "MINXES": "MINX, a pert girl [n]\n",
  "MINXISH": "like a minx, pert [adj]\n",
  "MINY": "abounding with mines; like a mine [adj MINIER, MINIEST]\n",
  "MINYAN": "(Hebrew) the minimum number required by Jewish law for a religious service [n MINYANS or MINYANIM]\n",
  "MINYANIM": "MINYAN, (Hebrew) the minimum number required by Jewish law for a religious service [n]\n",
  "MINYANS": "MINYAN, (Hebrew) the minimum number required by Jewish law for a religious service [n]\n",
  "MIOCENE": "denoting the fourth epoch of the Tertiary period [adj]\n",
  "MIOMBO": "(Bantu) in East Africa, an area of deciduous woodland [n -S]\n",
  "MIOMBOS": "MIOMBO, (Bantu) in East Africa, an area of deciduous woodland [n]\n",
  "MIOSES": "MIOSIS, (Greek) excessive contraction of the pupil of the eye, also MYOSIS [n]\n",
  "MIOSIS": "(Greek) excessive contraction of the pupil of the eye, also MYOSIS [n MIOSES or MIOSISES]\n",
  "MIOSISES": "MIOSIS, (Greek) excessive contraction of the pupil of the eye, also MYOSIS [n]\n",
  "MIOTIC": "relating to miosis, excessive contraction of the pupil of the eye, also MYOTIC [adj] / a substance producing miosis [n -S]\n",
  "MIOTICS": "MIOTIC, a substance producing miosis [n]\n",
  "MIPS": "a million instruction per second [n]\n",
  "MIQUELET": "(French) an irregular or partisan soldier; a bandit [n -S]\n",
  "MIQUELETS": "MIQUELET, (French) an irregular or partisan soldier; a bandit [n]\n",
  "MIR": "a Russian peasant commune [n MIRS or MIRI]\n",
  "MIRABELLE": "(French) a European species of plum-tree; the small, yellow, firm-fleshed fruit of this [n -S]\n",
  "MIRABELLES": "MIRABELLE, (French) a European species of plum-tree; the small, yellow, firm-fleshed fruit of this [n]\n",
  "MIRABILIA": "(Latin) wonders [n]\n",
  "MIRABILIS": "(short for) aqua mirabilis, a hydrated form of sodium sulphate [n -ES]\n",
  "MIRABILISES": "MIRABILIS, (short for) aqua mirabilis, a hydrated form of sodium sulphate [n]\n",
  "MIRABLE": "(Shakespeare) wonderful; admirable [adj]\n",
  "MIRACIDIA": "MIRACIDIUM, the ciliated first-stage larva of a trematode [n]\n",
  "MIRACIDIAL": "relating to a miracidium, the ciliated first-stage larva of a trematode [adj]\n",
  "MIRACIDIUM": "the ciliated first-stage larva of a trematode [n MIRACIDIA]\n",
  "MIRACLE": "an event ascribed to supernatural or divine origin [n -S]\n",
  "MIRACLES": "MIRACLE, an event ascribed to supernatural or divine origin [n]\n",
  "MIRACULOUS": "of the nature of a miracle [adj MIRACULOUSLY]\n",
  "MIRACULOUSLY": "MIRACULOUS, of the nature of a miracle [adv]\n",
  "MIRACULOUSNESS": "MIRACULOUS, of the nature of a miracle [n]\n",
  "MIRADOR": "(Spanish) a belvedere or watchtower [n -S]\n",
  "MIRADORS": "MIRADOR, (Spanish) a belvedere or watchtower [n]\n",
  "MIRAGE": "a type of optical illusion [n -S]\n",
  "MIRAGES": "MIRAGE, a type of optical illusion [n]\n",
  "MIRANDISE": "in USA, to inform an accused person of their rights, also MIRANDIZE [v MIRANDISED, MIRANDISING, MIRANDISES]\n",
  "MIRANDISED": "MIRANDISE, in USA, to inform an accused person of their rights, also MIRANDIZE [v]\n",
  "MIRANDISES": "MIRANDISE, in USA, to inform an accused person of their rights, also MIRANDIZE [v]\n",
  "MIRANDISING": "MIRANDISE, in USA, to inform an accused person of their rights, also MIRANDIZE [v]\n",
  "MIRANDIZE": "in USA, to inform an accused person of their rights, also MIRANDISE [v MIRANDIZED, MIRANDIZING, MIRANDIZES]\n",
  "MIRANDIZED": "MIRANDIZE, in USA, to inform an accused person of their rights, also MIRANDISE [v]\n",
  "MIRANDIZES": "MIRANDIZE, in USA, to inform an accused person of their rights, also MIRANDISE [v]\n",
  "MIRANDIZING": "MIRANDIZE, in USA, to inform an accused person of their rights, also MIRANDISE [v]\n",
  "MIRBANE": "an apparently meaningless word used in perfumery, as in oil of mirbane, a name for nitrobenzene, also MYRBANE [n -S]\n",
  "MIRBANES": "MIRBANE, an apparently meaningless word used in perfumery, as in oil of mirbane, a name for nitrobenzene, also MYRBANE [n]\n",
  "MIRCHI": "(Hinglish) hot [adj]\n",
  "MIRE": "to sink in mud [v MIRED, MIRING, MIRES]\n",
  "MIRED": "MIRE, to sink in mud [v]\n",
  "MIREPOIX": "(French) sauteed diced vegetables [n MIREPOIX]\n",
  "MIRES": "MIRE, to sink in mud [v]\n",
  "MIREX": "an insecticide [n -ES]\n",
  "MIREXES": "MIREX, an insecticide [n]\n",
  "MIRI": "MIR, a Russian peasant commune [n]\n",
  "MIRID": "a variety of leaf bug [n -S]\n",
  "MIRIDS": "MIRID, a variety of leaf bug [n]\n",
  "MIRIER": "MIRY, full of mire [adj]\n",
  "MIRIEST": "MIRY, full of mire [adj]\n",
  "MIRIFIC": "working wonders; marvellous, also MIRIFICAL [adj MIRIFICALLY]\n",
  "MIRIFICAL": "working wonders; marvellous, also MIRIFIC [adj MIRIFICALLY]\n",
  "MIRIFICALLY": "MIRIFICAL, working wonders; marvellous, also MIRIFIC [adv]\n",
  "MIRIN": "(Japanese) a sweet rice wine used in Japanese cooking [n -S]\n",
  "MIRINESS": "the state of being miry [n -ES]\n",
  "MIRINESSES": "MIRINESS, the state of being miry [n]\n",
  "MIRING": "MIRE, to sink in mud [v]\n",
  "MIRINS": "MIRIN, (Japanese) a sweet rice wine used in Japanese cooking [n]\n",
  "MIRITI": "(Tupi) any palm of the genus Mauritia [n -S]\n",
  "MIRITIS": "MIRITI, (Tupi) any palm of the genus Mauritia [n]\n",
  "MIRK": "darkness, also MURK [n -S] / dark, also MURK [adj MIRKER, MIRKEST]\n",
  "MIRKER": "MIRK, dark, also MURK [adj]\n",
  "MIRKEST": "MIRK, dark, also MURK [adj]\n",
  "MIRKIER": "MIRKY, dark, also MURKY [adj]\n",
  "MIRKIEST": "MIRKY, dark, also MURKY [adj]\n",
  "MIRKILY": "MIRKY, dark, also MURKY [adv]\n",
  "MIRKINESS": "the state of being mirky, dark, gloomy, also MURKINESS [n -ES]\n",
  "MIRKINESSES": "MIRKINESS, the state of being mirky, dark, gloomy, also MURKINESS [n]\n",
  "MIRKS": "MIRK, darkness, also MURK [n]\n",
  "MIRKY": "dark, also MURKY [adj MIRKIER, MIRKIEST, MIRKILY]\n",
  "MIRLIER": "MIRLY, marbled [adj]\n",
  "MIRLIEST": "MIRLY, marbled [adj]\n",
  "MIRLIGOES": "(Scots) dizziness [n]\n",
  "MIRLITON": "(French) a musical instrument resembling a kazoo [n -S]\n",
  "MIRLITONS": "MIRLITON, (French) a musical instrument resembling a kazoo [n]\n",
  "MIRLY": "marbled [adj MIRLIER, MIRLIEST]\n",
  "MIRO": "(Maori) a tall coniferous tree of New Zealand [n -S]\n",
  "MIROMIRO": "(Maori) a small New Zealand bird [n -S]\n",
  "MIROMIROS": "MIROMIRO, (Maori) a small New Zealand bird [n]\n",
  "MIROS": "MIRO, (Maori) a tall coniferous tree of New Zealand [n]\n",
  "MIRROR": "a surface which reflects an image in front of it [n -S] / to reflect an image of [v -ED, -ING, -S]\n",
  "MIRRORED": "MIRROR, to reflect an image of [v]\n",
  "MIRRORING": "the act of reflecting with a mirror [n -S]\n",
  "MIRRORINGS": "MIRRORING, the act of reflecting with a mirror [n]\n",
  "MIRRORLIKE": "like a mirror [adj]\n",
  "MIRRORS": "MIRROR, to reflect an image of [v]\n",
  "MIRRORWISE": "in the fashion of a mirror [adv]\n",
  "MIRS": "MIR, a Russian peasant commune [n]\n",
  "MIRTH": "merriness [n -S]\n",
  "MIRTHFUL": "full of mirth [adj MIRTHFULLY]\n",
  "MIRTHFULLY": "MIRTHFUL, full of mirth [adv]\n",
  "MIRTHFULNESS": "the state of being mirthful [n -ES]\n",
  "MIRTHFULNESSES": "MIRTHFULNESS, the state of being mirthful [n]\n",
  "MIRTHLESS": "without mirth [adj MIRTHLESSLY]\n",
  "MIRTHLESSLY": "MIRTHLESS, without mirth [adv]\n",
  "MIRTHLESSNESS": "the state of being mirthless [n -ES]\n",
  "MIRTHLESSNESSES": "MIRTHLESSNESS, the state of being mirthless [n]\n",
  "MIRTHS": "MIRTH, merriness [n]\n",
  "MIRV": "(slang) to provide with mirv capabilities, i.e. missiles containing many thermonuclear warheads [v -ED, -ING, -S]\n",
  "MIRVED": "MIRV, (slang) to provide with mirv capabilities, i.e. missiles containing many thermonuclear warheads [v]\n",
  "MIRVING": "MIRV, (slang) to provide with mirv capabilities, i.e. missiles containing many thermonuclear warheads [v]\n",
  "MIRVS": "MIRV, (slang) to provide with mirv capabilities, i.e. missiles containing many thermonuclear warheads [v]\n",
  "MIRY": "full of mire [adj MIRIER, MIRIEST]\n",
  "MIRZA": "(Persian) a Persian title of honour [n -S]\n",
  "MIRZAS": "MIRZA, (Persian) a Persian title of honour [n]\n",
  "MIS": "MI, the third note of the musical scale, also ME [n]\n",
  "MISACCEPTATION": "(obsolete) misinterpretation [n -S]\n",
  "MISACCEPTATIONS": "MISACCEPTATION, (obsolete) misinterpretation [n]\n",
  "MISACT": "to act badly [v -ED, -ING, -S]\n",
  "MISACTED": "MISACT, to act badly [v]\n",
  "MISACTING": "MISACT, to act badly [v]\n",
  "MISACTS": "MISACT, to act badly [v]\n",
  "MISADAPT": "to adapt wrongly [v -ED, -ING, -S]\n",
  "MISADAPTED": "MISADAPT, to adapt wrongly [v]\n",
  "MISADAPTING": "MISADAPT, to adapt wrongly [v]\n",
  "MISADAPTS": "MISADAPT, to adapt wrongly [v]\n",
  "MISADD": "to add incorrectly [v -ED, -ING, -S]\n",
  "MISADDED": "MISADD, to add incorrectly [v]\n",
  "MISADDING": "MISADD, to add incorrectly [v]\n",
  "MISADDRESS": "to address wrongly [v -ED, -ING, -ES]\n",
  "MISADDRESSED": "MISADDRESS, to address wrongly [v]\n",
  "MISADDRESSES": "MISADDRESS, to address wrongly [v]\n",
  "MISADDRESSING": "MISADDRESS, to address wrongly [v]\n",
  "MISADDS": "MISADD, to add incorrectly [v]\n",
  "MISADJUST": "to adjust wrongly; to throw out of adjustment [v -ED, -ING, -S]\n",
  "MISADJUSTED": "MISADJUST, to adjust wrongly; to throw out of adjustment [v]\n",
  "MISADJUSTING": "MISADJUST, to adjust wrongly; to throw out of adjustment [v]\n",
  "MISADJUSTS": "MISADJUST, to adjust wrongly; to throw out of adjustment [v]\n",
  "MISADVENTURE": "a misfortune, also MISVENTURE [n -S]\n",
  "MISADVENTURED": "(Shakespeare) unfortunate [adj]\n",
  "MISADVENTURER": "one who misadventures [n -S]\n",
  "MISADVENTURERS": "MISADVENTURER, one who misadventures [n]\n",
  "MISADVENTURES": "MISADVENTURE, a misfortune, also MISVENTURE [n]\n",
  "MISADVENTUROUS": "having the nature of a misadventure [adj]\n",
  "MISADVERTENCE": "inadvertence [n -S]\n",
  "MISADVERTENCES": "MISADVERTENCE, inadvertence [n]\n",
  "MISADVICE": "wrong advice [n -S]\n",
  "MISADVICES": "MISADVICE, wrong advice [n]\n",
  "MISADVISE": "to advise wrongly [v MISADVISED, MISADVISING, MISADVISES]\n",
  "MISADVISED": "MISADVISE, to advise wrongly [v]\n",
  "MISADVISEDLY": "MISADVISED, MISADVISE, to advise wrongly [adv]\n",
  "MISADVISEDNESS": "the state of being misadvised [n]\n",
  "MISADVISES": "MISADVISE, to advise wrongly [v]\n",
  "MISADVISING": "MISADVISE, to advise wrongly [v]\n",
  "MISAGENT": "a bad agent [n -S]\n",
  "MISAGENTS": "MISAGENT, a bad agent [n]\n",
  "MISAIM": "to aim badly [v -ED, -ING, -S]\n",
  "MISAIMED": "MISAIM, to aim badly [v]\n",
  "MISAIMING": "MISAIM, to aim badly [v]\n",
  "MISAIMS": "MISAIM, to aim badly [v]\n",
  "MISALIGN": "to align improperly [v -ED, -ING, -S]\n",
  "MISALIGNED": "MISALIGN, to align improperly [v]\n",
  "MISALIGNING": "MISALIGN, to align improperly [v]\n",
  "MISALIGNMENT": "a wrong alignment [n -S]\n",
  "MISALIGNMENTS": "MISALIGNMENT, a wrong alignment [n]\n",
  "MISALIGNS": "MISALIGN, to align improperly [v]\n",
  "MISALLEGE": "(obsolete) to state erroneously [v MISALLEGED, MISALLEGING, MISALLEGES]\n",
  "MISALLEGED": "MISALLEGE, (obsolete) to state erroneously [v]\n",
  "MISALLEGES": "MISALLEGE, (obsolete) to state erroneously [v]\n",
  "MISALLEGING": "MISALLEGE, (obsolete) to state erroneously [v]\n",
  "MISALLIANCE": "an improper alliance [n -S]\n",
  "MISALLIANCES": "MISALLIANCE, an improper alliance [n]\n",
  "MISALLIED": "MISALLY, to ally badly [v]\n",
  "MISALLIES": "MISALLY, to ally badly [v]\n",
  "MISALLOCATE": "to allocate wrongly [v MISALLOCATED, MISALLOCATING, MISALLOCATES]\n",
  "MISALLOCATED": "MISALLOCATE, to allocate wrongly [v]\n",
  "MISALLOCATES": "MISALLOCATE, to allocate wrongly [v]\n",
  "MISALLOCATING": "MISALLOCATE, to allocate wrongly [v]\n",
  "MISALLOCATION": "a wrong allocation [n -S]\n",
  "MISALLOCATIONS": "MISALLOCATION, a wrong allocation [n]\n",
  "MISALLOT": "to allot wrongly [v MISALLOTTED, MISALLOTTING, MISALLOTS]\n",
  "MISALLOTMENT": "an instance of misallotting [n -S]\n",
  "MISALLOTMENTS": "MISALLOTMENT, an instance of misallotting [n]\n",
  "MISALLOTS": "MISALLOT, to allot wrongly [v]\n",
  "MISALLOTTED": "MISALLOT, to allot wrongly [v]\n",
  "MISALLOTTING": "MISALLOT, to allot wrongly [v]\n",
  "MISALLY": "to ally badly [v MISALLIED, MISALLYING, MISALLIES]\n",
  "MISALLYING": "MISALLY, to ally badly [v]\n",
  "MISALTER": "to alter wrongly [v -ED, -ING, -S]\n",
  "MISALTERED": "MISALTER, to alter wrongly [v]\n",
  "MISALTERING": "MISALTER, to alter wrongly [v]\n",
  "MISALTERS": "MISALTER, to alter wrongly [v]\n",
  "MISANALYSES": "MISANALYSIS, a wrong analysis [n]\n",
  "MISANALYSIS": "a wrong analysis [n MISANALYSES]\n",
  "MISANDRIES": "MISANDRY, hatred of men [n]\n",
  "MISANDRIST": "a hater of men [n -S]\n",
  "MISANDRISTS": "MISANDRIST, a hater of men [n]\n",
  "MISANDROUS": "hating men [adj]\n",
  "MISANDRY": "hatred of men [n MISANDRIES]\n",
  "MISANTHROPE": "one who hates or distrusts mankind, also MISANTHROPOS [n -S]\n",
  "MISANTHROPES": "MISANTHROPE, one who hates or distrusts mankind, also MISANTHROPOS [n]\n",
  "MISANTHROPIC": "of, relating to, or characteristic of a misanthrope, also MISANTHROPICAL [adj]\n",
  "MISANTHROPICAL": "of, relating to, or characteristic of a misanthrope, also MISANTHROPIC [adj]\n",
  "MISANTHROPIES": "MISANTHROPY, a hatred or distrust of humankind [n]\n",
  "MISANTHROPIST": "one who dislikes human beings [n -S]\n",
  "MISANTHROPISTS": "MISANTHROPIST, one who dislikes human beings [n]\n",
  "MISANTHROPOS": "(Shakespeare) a misanthrope, also MISANTHROPE [n -ES]\n",
  "MISANTHROPOSES": "MISANTHROPOS, (Shakespeare) a misanthrope, also MISANTHROPE [n]\n",
  "MISANTHROPY": "a hatred or distrust of humankind [n MISANTHROPIES]\n",
  "MISAPPLICATION": "the act of misapplying [n -S]\n",
  "MISAPPLICATIONS": "MISAPPLICATION, the act of misapplying [n]\n",
  "MISAPPLIED": "MISAPPLY, to apply wrongly [v]\n",
  "MISAPPLIES": "MISAPPLY, to apply wrongly [v]\n",
  "MISAPPLY": "to apply wrongly [v MISAPPLIED, MISAPPLYING, MISAPPLIES]\n",
  "MISAPPLYING": "MISAPPLY, to apply wrongly [v]\n",
  "MISAPPRAISAL": "a wrong appraisal [n -S]\n",
  "MISAPPRAISALS": "MISAPPRAISAL, a wrong appraisal [n]\n",
  "MISAPPRECIATE": "to fail to appreciate [v MISAPPRECIATED, MISAPPRECIATING, MISAPPRECIATES]\n",
  "MISAPPRECIATED": "MISAPPRECIATE, to fail to appreciate [v]\n",
  "MISAPPRECIATES": "MISAPPRECIATE, to fail to appreciate [v]\n",
  "MISAPPRECIATING": "MISAPPRECIATE, to fail to appreciate [v]\n",
  "MISAPPRECIATION": "a wrong appreciation [n]\n",
  "MISAPPRECIATIVE": "failing to appreciate [adj]\n",
  "MISAPPREHEND": "to apprehend wrongly [v -ED, -ING, -S]\n",
  "MISAPPREHENDED": "MISAPPREHEND, to apprehend wrongly [v]\n",
  "MISAPPREHENDING": "MISAPPREHEND, to apprehend wrongly [v]\n",
  "MISAPPREHENDS": "MISAPPREHEND, to apprehend wrongly [v]\n",
  "MISAPPREHENSION": "the act of misapprehending [n]\n",
  "MISAPPREHENSIVE": "having the nature of a misapprehension [adj]\n",
  "MISAPPROPRIATE": "to appropriate wrongly (as by theft or embezzlement) [v MISAPPROPRIATED, MISAPPROPRIATES]\n",
  "MISAPPROPRIATED": "MISAPPROPRIATE, to appropriate wrongly (as by theft or embezzlement) [v]\n",
  "MISAPPROPRIATES": "MISAPPROPRIATE, to appropriate wrongly (as by theft or embezzlement) [v]\n",
  "MISARRANGE": "to arrange wrongly [v MISARRANGED, MISARRANGING, MISARRANGES]\n",
  "MISARRANGED": "MISARRANGE, to arrange wrongly [v]\n",
  "MISARRANGEMENT": "a wrong arrangement [n -S]\n",
  "MISARRANGEMENTS": "MISARRANGEMENT, a wrong arrangement [n]\n",
  "MISARRANGES": "MISARRANGE, to arrange wrongly [v]\n",
  "MISARRANGING": "MISARRANGE, to arrange wrongly [v]\n",
  "MISARRAY": "(Scott) disarray [n -S]\n",
  "MISARRAYS": "MISARRAY, (Scott) disarray [n]\n",
  "MISARTICULATE": "to articulate wrongly [v MISARTICULATED, MISARTICULATING, MISARTICULATES]\n",
  "MISARTICULATED": "MISARTICULATE, to articulate wrongly [v]\n",
  "MISARTICULATES": "MISARTICULATE, to articulate wrongly [v]\n",
  "MISARTICULATING": "MISARTICULATE, to articulate wrongly [v]\n",
  "MISASSAY": "to attempt unsuccessfully [v -ED, -ING, -S]\n",
  "MISASSAYED": "MISASSAY, to attempt unsuccessfully [v]\n",
  "MISASSAYING": "MISASSAY, to attempt unsuccessfully [v]\n",
  "MISASSAYS": "MISASSAY, to attempt unsuccessfully [v]\n",
  "MISASSEMBLE": "to assemble wrongly [v MISASSEMBLED, MISASSEMBLING, MISASSEMBLES]\n",
  "MISASSEMBLED": "MISASSEMBLE, to assemble wrongly [v]\n",
  "MISASSEMBLES": "MISASSEMBLE, to assemble wrongly [v]\n",
  "MISASSEMBLING": "MISASSEMBLE, to assemble wrongly [v]\n",
  "MISASSIGN": "to assign wrongly [v -ED, -ING, -S]\n",
  "MISASSIGNED": "MISASSIGN, to assign wrongly [v]\n",
  "MISASSIGNING": "MISASSIGN, to assign wrongly [v]\n",
  "MISASSIGNS": "MISASSIGN, to assign wrongly [v]\n",
  "MISASSUME": "to assume wrongly [v MISASSUMED, MISASSUMING, MISASSUMES]\n",
  "MISASSUMED": "MISASSUME, to assume wrongly [v]\n",
  "MISASSUMES": "MISASSUME, to assume wrongly [v]\n",
  "MISASSUMING": "MISASSUME, to assume wrongly [v]\n",
  "MISASSUMPTION": "a wrong assumption [n -S]\n",
  "MISASSUMPTIONS": "MISASSUMPTION, a wrong assumption [n]\n",
  "MISATE": "MISEAT, to eat improperly [v]\n",
  "MISATONE": "to atone wrongly [v MISATONED, MISATONING, MISATONES]\n",
  "MISATONED": "MISATONE, to atone wrongly [v]\n",
  "MISATONES": "MISATONE, to atone wrongly [v]\n",
  "MISATONING": "MISATONE, to atone wrongly [v]\n",
  "MISATTRIBUTE": "to attribute wrongly [v MISATTRIBUTED, MISATTRIBUTING, MISATTRIBUTES]\n",
  "MISATTRIBUTED": "MISATTRIBUTE, to attribute wrongly [v]\n",
  "MISATTRIBUTES": "MISATTRIBUTE, to attribute wrongly [v]\n",
  "MISATTRIBUTING": "MISATTRIBUTE, to attribute wrongly [v]\n",
  "MISATTRIBUTION": "the act of misattributing [n -S]\n",
  "MISATTRIBUTIONS": "MISATTRIBUTION, the act of misattributing [n]\n",
  "MISAUNTER": "(Scots) an unlucky chance, a misfortune, also MISCHANTER, MISHANTER [n -S]\n",
  "MISAUNTERS": "MISAUNTER, (Scots) an unlucky chance, a misfortune, also MISCHANTER, MISHANTER [n]\n",
  "MISAVER": "to speak erroneously [v MISAVERRED, MISAVERRING, MISAVERS]\n",
  "MISAVERRED": "MISAVER, to speak erroneously [v]\n",
  "MISAVERRING": "MISAVER, to speak erroneously [v]\n",
  "MISAVERS": "MISAVER, to speak erroneously [v]\n",
  "MISAVISED": "(Spenser) ill-advised [adj]\n",
  "MISAWARD": "to award wrongly [v -ED, -ING, -S]\n",
  "MISAWARDED": "MISAWARD, to award wrongly [v]\n",
  "MISAWARDING": "MISAWARD, to award wrongly [v]\n",
  "MISAWARDS": "MISAWARD, to award wrongly [v]\n",
  "MISBALANCE": "to balance mistakenly [v MISBALANCED, MISBALANCING, MISBALANCES]\n",
  "MISBALANCED": "MISBALANCE, to balance mistakenly [v]\n",
  "MISBALANCES": "MISBALANCE, to balance mistakenly [v]\n",
  "MISBALANCING": "MISBALANCE, to balance mistakenly [v]\n",
  "MISBECAME": "MISBECOME, (archaic) to be unbecoming to [v]\n",
  "MISBECOME": "(archaic) to be unbecoming to [v MISBECAME, MISBECOMING, MISBECOMES]\n",
  "MISBECOMES": "MISBECOME, (archaic) to be unbecoming to [v]\n",
  "MISBECOMING": "MISBECOME, (archaic) to be unbecoming to [v]\n",
  "MISBECOMINGNESS": "the state of being misbecoming [n]\n",
  "MISBEGAN": "MISBEGIN, to begin wrongly [v]\n",
  "MISBEGIN": "to begin wrongly [v MISBEGAN, MISBEGUN, MISBEGINNING, MISBEGINS]\n",
  "MISBEGINNING": "MISBEGIN, to begin wrongly [v]\n",
  "MISBEGINS": "MISBEGIN, to begin wrongly [v]\n",
  "MISBEGOT": "born out of wedlock [adj]\n",
  "MISBEGOTTEN": "begotten by mistake, also MISBEGOT [adj]\n",
  "MISBEGUN": "MISBEGIN, to begin wrongly [v]\n",
  "MISBEHAVE": "to behave wrongly [v MISBEHAVED, MISBEHAVING, MISBEHAVES]\n",
  "MISBEHAVED": "MISBEHAVE, to behave wrongly [v]\n",
  "MISBEHAVER": "one who misbehaves [n -S]\n",
  "MISBEHAVERS": "MISBEHAVER, one who misbehaves [n]\n",
  "MISBEHAVES": "MISBEHAVE, to behave wrongly [v]\n",
  "MISBEHAVING": "MISBEHAVE, to behave wrongly [v]\n",
  "MISBEHAVIOR": "bad behaviour, also MISBEHAVIOUR [n -S]\n",
  "MISBEHAVIORS": "MISBEHAVIOR, bad behaviour, also MISBEHAVIOUR [n]\n",
  "MISBEHAVIOUR": "bad behaviour, also MISBEHAVIOR [n -S]\n",
  "MISBEHAVIOURS": "MISBEHAVIOUR, bad behaviour, also MISBEHAVIOR [n]\n",
  "MISBELIEF": "erroneous or false belief [n -S]\n",
  "MISBELIEFS": "MISBELIEF, erroneous or false belief [n]\n",
  "MISBELIEVE": "to hold a false or unorthodox belief [v MISBELIEVED, MISBELIEVING, MISBELIEVES]\n",
  "MISBELIEVED": "MISBELIEVE, to hold a false or unorthodox belief [v]\n",
  "MISBELIEVER": "one who misbelieves [n -S]\n",
  "MISBELIEVERS": "MISBELIEVER, one who misbelieves [n]\n",
  "MISBELIEVES": "MISBELIEVE, to hold a false or unorthodox belief [v]\n",
  "MISBELIEVING": "MISBELIEVE, to hold a false or unorthodox belief [v]\n",
  "MISBESEEM": "(archaic) to be unsuited to [v -ED, -ING, -S]\n",
  "MISBESEEMED": "MISBESEEM, (archaic) to be unsuited to [v]\n",
  "MISBESEEMING": "MISBESEEM, (archaic) to be unsuited to [v]\n",
  "MISBESEEMS": "MISBESEEM, (archaic) to be unsuited to [v]\n",
  "MISBESTOW": "to bestow improperly [v -ED, -ING, -S]\n",
  "MISBESTOWAL": "the act of misbestowing [n -S]\n",
  "MISBESTOWALS": "MISBESTOWAL, the act of misbestowing [n]\n",
  "MISBESTOWED": "MISBESTOW, to bestow improperly [v]\n",
  "MISBESTOWING": "MISBESTOW, to bestow improperly [v]\n",
  "MISBESTOWS": "MISBESTOW, to bestow improperly [v]\n",
  "MISBIAS": "to bias wrongly [v MISBIASSED or MISBIASED, MISBIASSING or MISBIASING, MISBIASSES or MISBIASES]\n",
  "MISBIASED": "MISBIAS, to bias wrongly [v]\n",
  "MISBIASES": "MISBIAS, to bias wrongly [v]\n",
  "MISBIASING": "MISBIAS, to bias wrongly [v]\n",
  "MISBIASSED": "MISBIAS, to bias wrongly [v]\n",
  "MISBIASSES": "MISBIAS, to bias wrongly [v]\n",
  "MISBIASSING": "MISBIAS, to bias wrongly [v]\n",
  "MISBILL": "to bill wrongly [v -ED, -ING, -S]\n",
  "MISBILLED": "MISBILL, to bill wrongly [v]\n",
  "MISBILLING": "MISBILL, to bill wrongly [v]\n",
  "MISBILLS": "MISBILL, to bill wrongly [v]\n",
  "MISBIND": "to bind imperfectly [v MISBOUND, MISBINDING, MISBINDS]\n",
  "MISBINDING": "MISBIND, to bind imperfectly [v]\n",
  "MISBINDS": "MISBIND, to bind imperfectly [v]\n",
  "MISBIRTH": "(archaic) an abortion [n -S]\n",
  "MISBIRTHS": "MISBIRTH, (archaic) an abortion [n]\n",
  "MISBORN": "born to misfortune [adj]\n",
  "MISBOUND": "MISBIND, to bind imperfectly [v]\n",
  "MISBRAND": "to brand incorrectly [v -ED, -ING, -S]\n",
  "MISBRANDED": "MISBRAND, to brand incorrectly [v]\n",
  "MISBRANDING": "MISBRAND, to brand incorrectly [v]\n",
  "MISBRANDS": "MISBRAND, to brand incorrectly [v]\n",
  "MISBUILD": "to build imperfectly [v MISBUILT, MISBUILDING, MISBUILDS]\n",
  "MISBUILDING": "MISBUILD, to build imperfectly [v]\n",
  "MISBUILDS": "MISBUILD, to build imperfectly [v]\n",
  "MISBUILT": "MISBUILD, to build imperfectly [v]\n",
  "MISBUTTON": "to button wrongly [v -ED, -ING, -S]\n",
  "MISBUTTONED": "MISBUTTON, to button wrongly [v]\n",
  "MISBUTTONING": "MISBUTTON, to button wrongly [v]\n",
  "MISBUTTONS": "MISBUTTON, to button wrongly [v]\n",
  "MISCALCULATE": "to calculate wrongly [v MISCALCULATED, MISCALCULATING, MISCALCULATES]\n",
  "MISCALCULATED": "MISCALCULATE, to calculate wrongly [v]\n",
  "MISCALCULATES": "MISCALCULATE, to calculate wrongly [v]\n",
  "MISCALCULATING": "MISCALCULATE, to calculate wrongly [v]\n",
  "MISCALCULATION": "the act of miscalculating [n -S]\n",
  "MISCALCULATIONS": "MISCALCULATION, the act of miscalculating [n]\n",
  "MISCALCULATOR": "one who miscalculates [n -S]\n",
  "MISCALCULATORS": "MISCALCULATOR, one who miscalculates [n]\n",
  "MISCALL": "to call by a wrong name [v -ED, -ING, -S]\n",
  "MISCALLED": "MISCALL, to call by a wrong name [v]\n",
  "MISCALLER": "one who miscalls [n -S]\n",
  "MISCALLERS": "MISCALLER, one who miscalls [n]\n",
  "MISCALLING": "MISCALL, to call by a wrong name [v]\n",
  "MISCALLS": "MISCALL, to call by a wrong name [v]\n",
  "MISCANTHUS": "any of several hardy, ornamental, perennial grasses [n -ES]\n",
  "MISCANTHUSES": "MISCANTHUS, any of several hardy, ornamental, perennial grasses [n]\n",
  "MISCAPTION": "to caption wrongly [v -ED, -ING, -S]\n",
  "MISCAPTIONED": "MISCAPTION, to caption wrongly [v]\n",
  "MISCAPTIONING": "MISCAPTION, to caption wrongly [v]\n",
  "MISCAPTIONS": "MISCAPTION, to caption wrongly [v]\n",
  "MISCARRIAGE": "the act of giving birth spontaneously to a fetus too premature to survive [n -S]\n",
  "MISCARRIAGES": "MISCARRIAGE, the act of giving birth spontaneously to a fetus too premature to survive [n]\n",
  "MISCARRIED": "MISCARRY, to be unsuccessful [v]\n",
  "MISCARRIES": "MISCARRY, to be unsuccessful [v]\n",
  "MISCARRY": "to be unsuccessful [v MISCARRIED, MISCARRYING, MISCARRIES]\n",
  "MISCARRYING": "MISCARRY, to be unsuccessful [v]\n",
  "MISCAST": "to cast in an unsuitable role [v MISCAST, MISCASTING, MISCASTS]\n",
  "MISCASTING": "MISCAST, to cast in an unsuitable role [v]\n",
  "MISCASTS": "MISCAST, to cast in an unsuitable role [v]\n",
  "MISCATALOG": "to catalog wrongly [v -ED, -ING, -S]\n",
  "MISCATALOGED": "MISCATALOG, to catalog wrongly [v]\n",
  "MISCATALOGING": "MISCATALOG, to catalog wrongly [v]\n",
  "MISCATALOGS": "MISCATALOG, to catalog wrongly [v]\n",
  "MISCEGEN": "a person of mixed racial heritage, also MISCEGENE, MISCEGINE [n -S]\n",
  "MISCEGENATE": "to practise miscegenation [v MISCEGENATED, MISCEGENATING, MISCEGENATES]\n",
  "MISCEGENATED": "MISCEGENATE, to practise miscegenation [v]\n",
  "MISCEGENATES": "MISCEGENATE, to practise miscegenation [v]\n",
  "MISCEGENATING": "MISCEGENATE, to practise miscegenation [v]\n",
  "MISCEGENATION": "the interbreeding of races, esp. where differences of pigmentation are involved [n -S]\n",
  "MISCEGENATIONAL": "relating to miscegenation [adj]\n",
  "MISCEGENATIONS": "MISCEGENATION, the interbreeding of races, esp. where differences of pigmentation are involved [n]\n",
  "MISCEGENATOR": "a person who favours or practises miscegenation, also MISCEGENIST [n -S]\n",
  "MISCEGENATORS": "MISCEGENATOR, a person who favours or practises miscegenation, also MISCEGENIST [n]\n",
  "MISCEGENE": "a person of mixed racial heritage, also MISCEGEN, MISCEGINE [n -S]\n",
  "MISCEGENES": "MISCEGENE, a person of mixed racial heritage, also MISCEGEN, MISCEGINE [n]\n",
  "MISCEGENETIC": "relating to miscegenation [adj]\n",
  "MISCEGENIST": "a person who favours or practises miscegenation, also MISCEGENATOR [n -S]\n",
  "MISCEGENISTS": "MISCEGENIST, a person who favours or practises miscegenation, also MISCEGENATOR [n]\n",
  "MISCEGENS": "MISCEGEN, a person of mixed racial heritage, also MISCEGENE, MISCEGINE [n]\n",
  "MISCEGINE": "a person of mixed racial heritage, also MISCEGEN, MISCEGENE [n -S]\n",
  "MISCEGINES": "MISCEGINE, a person of mixed racial heritage, also MISCEGEN, MISCEGENE [n]\n",
  "MISCELLANARIAN": "(obsolete) a writer of miscellanies [n -S]\n",
  "MISCELLANARIANS": "MISCELLANARIAN, (obsolete) a writer of miscellanies [n]\n",
  "MISCELLANEA": "a collection of miscellaneous objects or writings [n]\n",
  "MISCELLANEOUS": "consisting of diverse things or members [adj MISCELLANEOUSLY]\n",
  "MISCELLANEOUSLY": "MISCELLANEOUS, consisting of diverse things or members [adv]\n",
  "MISCELLANIES": "MISCELLANY, a mixture of various kinds [n]\n",
  "MISCELLANIST": "a writer of miscellanies [n -S]\n",
  "MISCELLANISTS": "MISCELLANIST, a writer of miscellanies [n]\n",
  "MISCELLANY": "a mixture of various kinds [n MISCELLANIES]\n",
  "MISCH": "as in misch metal, an alloy of cerium and other rare earth metals, used esp. as a flint in cigarette lighters [adj]\n",
  "MISCHALLENGE": "(Spenser) an unjust challenge [n -S]\n",
  "MISCHALLENGES": "MISCHALLENGE, (Spenser) an unjust challenge [n]\n",
  "MISCHANCE": "bad luck [n -S] / to happen amiss [v MISCHANCED, MISCHANCING, MISCHANCES]\n",
  "MISCHANCED": "MISCHANCE, to happen amiss [v]\n",
  "MISCHANCEFUL": "(archaic) full of mischance, unlucky [adj]\n",
  "MISCHANCES": "MISCHANCE, to happen amiss [v]\n",
  "MISCHANCIER": "MISCHANCY, unlucky, happening amiss [adj]\n",
  "MISCHANCIEST": "MISCHANCY, unlucky, happening amiss [adj]\n",
  "MISCHANCING": "MISCHANCE, to happen amiss [v]\n",
  "MISCHANCY": "unlucky, happening amiss [adj MISCHANCIER, MISCHANCIEST]\n",
  "MISCHANNEL": "to channel wrongly [v MISCHANNELED or MISCHANNELLED, MISCHANNELING or MISCHANNELLING, MISCHANNELS]\n",
  "MISCHANNELED": "MISCHANNEL, to channel wrongly [v]\n",
  "MISCHANNELING": "MISCHANNEL, to channel wrongly [v]\n",
  "MISCHANNELLED": "MISCHANNEL, to channel wrongly [v]\n",
  "MISCHANNELLING": "MISCHANNEL, to channel wrongly [v]\n",
  "MISCHANNELS": "MISCHANNEL, to channel wrongly [v]\n",
  "MISCHANTER": "(Scots) an unlucky chance, a misfortune, also MISAUNTER, MISHANTER [n -S]\n",
  "MISCHANTERS": "MISCHANTER, (Scots) an unlucky chance, a misfortune, also MISAUNTER, MISHANTER [n]\n",
  "MISCHARACTERISE": "to characterise wrongly, also MISCHARACTERIZE [v]\n",
  "MISCHARACTERIZE": "to characterize wrongly, also MISCHARACTERISE [v]\n",
  "MISCHARGE": "to charge erroneously, as to an account [v MISCHARGED, MISCHARGING, MISCHARGES]\n",
  "MISCHARGED": "MISCHARGE, to charge erroneously, as to an account [v]\n",
  "MISCHARGES": "MISCHARGE, to charge erroneously, as to an account [v]\n",
  "MISCHARGING": "MISCHARGE, to charge erroneously, as to an account [v]\n",
  "MISCHIEF": "petty misdeeds [n -S] / to make mischief [v -ED, -ING, -S]\n",
  "MISCHIEFED": "MISCHIEF, to make mischief [v]\n",
  "MISCHIEFING": "MISCHIEF, to make mischief [v]\n",
  "MISCHIEFS": "MISCHIEF, to make mischief [v]\n",
  "MISCHIEVOUS": "given to mischief [adj MISCHIEVOUSLY]\n",
  "MISCHIEVOUSLY": "MISCHIEVOUS, given to mischief [adv]\n",
  "MISCHIEVOUSNESS": "MISCHIEVOUS, given to mischief [n]\n",
  "MISCHMETAL": "an alloy of cerium with certain rare earth metals and iron, used to produce the spark in lighters [n -S]\n",
  "MISCHMETALS": "MISCHMETAL, an alloy of cerium with certain rare earth metals and iron, used to produce the spark in lighters [n]\n",
  "MISCHOICE": "a wrong choice [n -S]\n",
  "MISCHOICES": "MISCHOICE, a wrong choice [n]\n",
  "MISCHOOSE": "to choose badly [v MISCHOSE, MISCHOSEN, MISCHOOSING, MISCHOOSES]\n",
  "MISCHOOSES": "MISCHOOSE, to choose badly [v]\n",
  "MISCHOOSING": "MISCHOOSE, to choose badly [v]\n",
  "MISCHOSE": "MISCHOOSE, to choose badly [v]\n",
  "MISCHOSEN": "MISCHOOSE, to choose badly [v]\n",
  "MISCIBILITIES": "MISCIBILITY, the quality of being miscible [n]\n",
  "MISCIBILITY": "the quality of being miscible [n MISCIBILITIES]\n",
  "MISCIBLE": "capable of being mixed, also MIXABLE, MIXIBLE [adj]\n",
  "MISCITATION": "the act of misciting [n -S]\n",
  "MISCITATIONS": "MISCITATION, the act of misciting [n]\n",
  "MISCITE": "to cite wrongly [v MISCITED, MISCITING, MISCITES]\n",
  "MISCITED": "MISCITE, to cite wrongly [v]\n",
  "MISCITES": "MISCITE, to cite wrongly [v]\n",
  "MISCITING": "MISCITE, to cite wrongly [v]\n",
  "MISCLAIM": "to claim wrongfully [v -ED, -ING, -S]\n",
  "MISCLAIMED": "MISCLAIM, to claim wrongfully [v]\n",
  "MISCLAIMING": "MISCLAIM, to claim wrongfully [v]\n",
  "MISCLAIMS": "MISCLAIM, to claim wrongfully [v]\n",
  "MISCLASS": "to put in the wrong class [v -ED, -ING, -ES]\n",
  "MISCLASSED": "MISCLASS, to put in the wrong class [v]\n",
  "MISCLASSES": "MISCLASS, to put in the wrong class [v]\n",
  "MISCLASSIFIED": "MISCLASSIFY, to classify wrongly [v]\n",
  "MISCLASSIFIES": "MISCLASSIFY, to classify wrongly [v]\n",
  "MISCLASSIFY": "to classify wrongly [v MISCLASSIFIED, MISCLASSIFYING, MISCLASSIFIES]\n",
  "MISCLASSIFYING": "MISCLASSIFY, to classify wrongly [v]\n",
  "MISCLASSING": "MISCLASS, to put in the wrong class [v]\n",
  "MISCODE": "to code wrongly [v MISCODED, MISCODING, MISCODES]\n",
  "MISCODED": "MISCODE, to code wrongly [v]\n",
  "MISCODES": "MISCODE, to code wrongly [v]\n",
  "MISCODING": "MISCODE, to code wrongly [v]\n",
  "MISCOIN": "to coin improperly [v -ED, -ING, -S]\n",
  "MISCOINED": "MISCOIN, to coin improperly [v]\n",
  "MISCOINING": "MISCOIN, to coin improperly [v]\n",
  "MISCOINS": "MISCOIN, to coin improperly [v]\n",
  "MISCOLOR": "to color incorrectly, also MISCOLOUR [v -ED, -ING, -S]\n",
  "MISCOLORED": "MISCOLOR, to color incorrectly, also MISCOLOUR [v]\n",
  "MISCOLORING": "MISCOLOR, to color incorrectly, also MISCOLOUR [v]\n",
  "MISCOLORS": "MISCOLOR, to color incorrectly, also MISCOLOUR [v]\n",
  "MISCOLOUR": "to give a wrong color to; (figurative) to set forth erroneously or unfairly; as, to miscolour facts, also MISCOLOR [v -ED, -ING, -S]\n",
  "MISCOLOURED": "MISCOLOUR, to give a wrong color to; (figurative) to set forth erroneously or unfairly; as, to miscolour facts, also MISCOLOR [v]\n",
  "MISCOLOURING": "MISCOLOUR, to give a wrong color to; (figurative) to set forth erroneously or unfairly; as, to miscolour facts, also MISCOLOR [v]\n",
  "MISCOLOURS": "MISCOLOUR, to give a wrong color to; (figurative) to set forth erroneously or unfairly; as, to miscolour facts, also MISCOLOR [v]\n",
  "MISCOMPREHEND": "to comprehend wrongly [v -ED, -S]\n",
  "MISCOMPREHENDED": "MISCOMPREHEND, to comprehend wrongly [v]\n",
  "MISCOMPREHENDS": "MISCOMPREHEND, to comprehend wrongly [v]\n",
  "MISCOMPUTATION": "the act of miscomputing [n -S]\n",
  "MISCOMPUTATIONS": "MISCOMPUTATION, the act of miscomputing [n]\n",
  "MISCOMPUTE": "to compute erroneously [v MISCOMPUTED, MISCOMPUTING, MISCOMPUTES]\n",
  "MISCOMPUTED": "MISCOMPUTE, to compute erroneously [v]\n",
  "MISCOMPUTES": "MISCOMPUTE, to compute erroneously [v]\n",
  "MISCOMPUTING": "MISCOMPUTE, to compute erroneously [v]\n",
  "MISCONCEIT": "(Spenser) a misconception [n -S] / to have a wrong conception of [v -ED, -ING, -S]\n",
  "MISCONCEITED": "MISCONCEIT, to have a wrong conception of [v]\n",
  "MISCONCEITING": "MISCONCEIT, to have a wrong conception of [v]\n",
  "MISCONCEITS": "MISCONCEIT, to have a wrong conception of [v]\n",
  "MISCONCEIVE": "to conceive wrongly [v MISCONCEIVED, MISCONCEIVING, MISCONCEIVES]\n",
  "MISCONCEIVED": "MISCONCEIVE, to conceive wrongly [v]\n",
  "MISCONCEIVER": "one who misconceives [n -S]\n",
  "MISCONCEIVERS": "MISCONCEIVER, one who misconceives [n]\n",
  "MISCONCEIVES": "MISCONCEIVE, to conceive wrongly [v]\n",
  "MISCONCEIVING": "MISCONCEIVE, to conceive wrongly [v]\n",
  "MISCONCEPTION": "a false conception [n -S]\n",
  "MISCONCEPTIONS": "MISCONCEPTION, a false conception [n]\n",
  "MISCONDUCT": "to conduct wrongly [v -ED, -ING, -S]\n",
  "MISCONDUCTED": "MISCONDUCT, to conduct wrongly [v]\n",
  "MISCONDUCTING": "MISCONDUCT, to conduct wrongly [v]\n",
  "MISCONDUCTS": "MISCONDUCT, to conduct wrongly [v]\n",
  "MISCONJECTURE": "to make a wrong conjecture [v MISCONJECTURED, MISCONJECTURING, MISCONJECTURES]\n",
  "MISCONJECTURED": "MISCONJECTURE, to make a wrong conjecture [v]\n",
  "MISCONJECTURES": "MISCONJECTURE, to make a wrong conjecture [v]\n",
  "MISCONJECTURING": "MISCONJECTURE, to make a wrong conjecture [v]\n",
  "MISCONNECT": "to connect wrongly [v -ED, -ING, -S]\n",
  "MISCONNECTED": "MISCONNECT, to connect wrongly [v]\n",
  "MISCONNECTING": "MISCONNECT, to connect wrongly [v]\n",
  "MISCONNECTION": "the act of misconnecting [n -S]\n",
  "MISCONNECTIONS": "MISCONNECTION, the act of misconnecting [n]\n",
  "MISCONNECTS": "MISCONNECT, to connect wrongly [v]\n",
  "MISCONSTER": "(obsolete) to misconstrue [v -ED, -ING, -S]\n",
  "MISCONSTERED": "MISCONSTER, (obsolete) to misconstrue [v]\n",
  "MISCONSTERING": "MISCONSTER, (obsolete) to misconstrue [v]\n",
  "MISCONSTERS": "MISCONSTER, (obsolete) to misconstrue [v]\n",
  "MISCONSTRUCT": "to construct wrongly [v -ED, -ING, -S]\n",
  "MISCONSTRUCTED": "MISCONSTRUCT, to construct wrongly [v]\n",
  "MISCONSTRUCTING": "MISCONSTRUCT, to construct wrongly [v]\n",
  "MISCONSTRUCTION": "the act of misconstructing [n]\n",
  "MISCONSTRUCTS": "MISCONSTRUCT, to construct wrongly [v]\n",
  "MISCONSTRUE": "to construe wrongly, also MISCONSTER [v MISCONSTRUED, MISCONSTRUING, MISCONSTRUES]\n",
  "MISCONSTRUED": "MISCONSTRUE, to construe wrongly, also MISCONSTER [v]\n",
  "MISCONSTRUES": "MISCONSTRUE, to construe wrongly, also MISCONSTER [v]\n",
  "MISCONSTRUING": "MISCONSTRUE, to construe wrongly, also MISCONSTER [v]\n",
  "MISCONTENT": "(archaic) to discontent [v -ED, -ING, -S]\n",
  "MISCONTENTED": "MISCONTENT, (archaic) to discontent [v]\n",
  "MISCONTENTING": "MISCONTENT, (archaic) to discontent [v]\n",
  "MISCONTENTMENT": "lack of contentment [n -S]\n",
  "MISCONTENTMENTS": "MISCONTENTMENT, lack of contentment [n]\n",
  "MISCONTENTS": "MISCONTENT, (archaic) to discontent [v]\n",
  "MISCOOK": "to cook badly [v -ED, -ING, -S]\n",
  "MISCOOKED": "MISCOOK, to cook badly [v]\n",
  "MISCOOKING": "MISCOOK, to cook badly [v]\n",
  "MISCOOKS": "MISCOOK, to cook badly [v]\n",
  "MISCOPIED": "MISCOPY, to copy incorrectly [v]\n",
  "MISCOPIES": "MISCOPY, to copy incorrectly [v]\n",
  "MISCOPY": "to copy incorrectly [v MISCOPIED, MISCOPYING, MISCOPIES]\n",
  "MISCOPYING": "MISCOPY, to copy incorrectly [v]\n",
  "MISCORRECT": "to fail or err in attempting to correct [v -ED, -ING, -S]\n",
  "MISCORRECTED": "MISCORRECT, to fail or err in attempting to correct [v]\n",
  "MISCORRECTING": "MISCORRECT, to fail or err in attempting to correct [v]\n",
  "MISCORRECTION": "a wrong correction [n -S]\n",
  "MISCORRECTIONS": "MISCORRECTION, a wrong correction [n]\n",
  "MISCORRECTS": "MISCORRECT, to fail or err in attempting to correct [v]\n",
  "MISCORRELATION": "a wrong correlation [n -S]\n",
  "MISCORRELATIONS": "MISCORRELATION, a wrong correlation [n]\n",
  "MISCOUNSEL": "to counsel or advise wrongly [v MISCOUNSELLED, MISCOUNSELLING, MISCOUNSELS]\n",
  "MISCOUNSELLED": "MISCOUNSEL, to counsel or advise wrongly [v]\n",
  "MISCOUNSELLING": "the act of giving bad advice [n -S]\n",
  "MISCOUNSELLINGS": "MISCOUNSELLING, the act of giving bad advice [n]\n",
  "MISCOUNSELS": "MISCOUNSEL, to counsel or advise wrongly [v]\n",
  "MISCOUNT": "to count incorrectly [v -ED, -ING, -S]\n",
  "MISCOUNTED": "MISCOUNT, to count incorrectly [v]\n",
  "MISCOUNTING": "MISCOUNT, to count incorrectly [v]\n",
  "MISCOUNTS": "MISCOUNT, to count incorrectly [v]\n",
  "MISCREANCE": "(Spenser) false religious belief, also MISCREANCY, MISCREAUNCE [n -S]\n",
  "MISCREANCES": "MISCREANCE, (Spenser) false religious belief, also MISCREANCY, MISCREAUNCE [n]\n",
  "MISCREANCIES": "MISCREANCY, (Spenser) false religious belief, also MISCREANCE, MISCREAUNCE [n]\n",
  "MISCREANCY": "(Spenser) false religious belief, also MISCREANCE, MISCREAUNCE [n MISCREANCIES]\n",
  "MISCREANT": "originally, a misbeliever, a heretic; hence, a despicable person [n -S]\n",
  "MISCREANTS": "MISCREANT, originally, a misbeliever, a heretic; hence, a despicable person [n]\n",
  "MISCREATE": "to create wrongly [v MISCREATED, MISCREATING, MISCREATES]\n",
  "MISCREATED": "MISCREATE, to create wrongly [v]\n",
  "MISCREATES": "MISCREATE, to create wrongly [v]\n",
  "MISCREATING": "MISCREATE, to create wrongly [v]\n",
  "MISCREATION": "wrong creation [n -S]\n",
  "MISCREATIONS": "MISCREATION, wrong creation [n]\n",
  "MISCREATIVE": "that creates imperfectly or improperly [adj]\n",
  "MISCREATOR": "one who creates imperfectly [n -S]\n",
  "MISCREATORS": "MISCREATOR, one who creates imperfectly [n]\n",
  "MISCREAUNCE": "(Spenser) false religious belief, also MISCREANCE, MISCREANCY [n -S]\n",
  "MISCREAUNCES": "MISCREAUNCE, (Spenser) false religious belief, also MISCREANCE, MISCREANCY [n]\n",
  "MISCREDIT": "(archaic) to disbelieve [v -ED, -ING, -S]\n",
  "MISCREDITED": "MISCREDIT, (archaic) to disbelieve [v]\n",
  "MISCREDITING": "MISCREDIT, (archaic) to disbelieve [v]\n",
  "MISCREDITS": "MISCREDIT, (archaic) to disbelieve [v]\n",
  "MISCREED": "a false creed [n -S]\n",
  "MISCREEDS": "MISCREED, a false creed [n]\n",
  "MISCUE": "to make a faulty stroke in billiards [v MISCUED, MISCUEING or MISCUING, MISCUES]\n",
  "MISCUED": "MISCUE, to make a faulty stroke in billiards [v]\n",
  "MISCUEING": "MISCUE, to make a faulty stroke in billiards [v]\n",
  "MISCUES": "MISCUE, to make a faulty stroke in billiards [v]\n",
  "MISCUING": "MISCUE, to make a faulty stroke in billiards [v]\n",
  "MISCUT": "to cut incorrectly [v MISCUT, MISCUTTING, MISCUTS]\n",
  "MISCUTS": "MISCUT, to cut incorrectly [v]\n",
  "MISCUTTING": "MISCUT, to cut incorrectly [v]\n",
  "MISDATE": "to date incorrectly [v MISDATED, MISDATING, MISDATES]\n",
  "MISDATED": "MISDATE, to date incorrectly [v]\n",
  "MISDATES": "MISDATE, to date incorrectly [v]\n",
  "MISDATING": "MISDATE, to date incorrectly [v]\n",
  "MISDEAL": "to deal cards incorrectly [v MISDEALT, MISDEALING, MISDEALS]\n",
  "MISDEALER": "one who misdeals [n -S]\n",
  "MISDEALERS": "MISDEALER, one who misdeals [n]\n",
  "MISDEALING": "MISDEAL, to deal cards incorrectly [v]\n",
  "MISDEALS": "MISDEAL, to deal cards incorrectly [v]\n",
  "MISDEALT": "MISDEAL, to deal cards incorrectly [v]\n",
  "MISDEED": "an evil act [n -S]\n",
  "MISDEEDS": "MISDEED, an evil act [n]\n",
  "MISDEEM": "to judge unfavourably [v MISDEEMED, MISDEMPT, MISDEEMING, MISDEEMS]\n",
  "MISDEEMED": "MISDEEM, to judge unfavourably [v]\n",
  "MISDEEMFUL": "having a mistaken judgment of [adj]\n",
  "MISDEEMING": "the act of misdeeming [n -S]\n",
  "MISDEEMINGS": "MISDEEMING, the act of misdeeming [n]\n",
  "MISDEEMS": "MISDEEM, to judge unfavourably [v]\n",
  "MISDEFINE": "to define wrongly [v MISDEFINED, MISDEFINING, MISDEFINES]\n",
  "MISDEFINED": "MISDEFINE, to define wrongly [v]\n",
  "MISDEFINES": "MISDEFINE, to define wrongly [v]\n",
  "MISDEFINING": "MISDEFINE, to define wrongly [v]\n",
  "MISDEMEAN": "to behave ill, with a reflexive pronoun; as, to misdemean one's self [v -ED, -ING, -S]\n",
  "MISDEMEANANT": "a person guilty of misdemeanour [n -S]\n",
  "MISDEMEANANTS": "MISDEMEANANT, a person guilty of misdemeanour [n]\n",
  "MISDEMEANED": "MISDEMEAN, to behave ill, with a reflexive pronoun; as, to misdemean one's self [v]\n",
  "MISDEMEANING": "MISDEMEAN, to behave ill, with a reflexive pronoun; as, to misdemean one's self [v]\n",
  "MISDEMEANOR": "(US) a crime less serious than a felony, also MISDEMEANOUR [n -S]\n",
  "MISDEMEANORS": "MISDEMEANOR, (US) a crime less serious than a felony, also MISDEMEANOUR [n]\n",
  "MISDEMEANOUR": "in UK formerly, a crime less serious than a felony, also MISDEMEANOR [n -S]\n",
  "MISDEMEANOURS": "MISDEMEANOUR, in UK formerly, a crime less serious than a felony, also MISDEMEANOR [n]\n",
  "MISDEMEANS": "MISDEMEAN, to behave ill, with a reflexive pronoun; as, to misdemean one's self [v]\n",
  "MISDEMPT": "MISDEEM, to judge unfavourably [v]\n",
  "MISDESCRIBE": "to describe wrongly [v MISDESCRIBED, MISDESCRIBING, MISDESCRIBES]\n",
  "MISDESCRIBED": "MISDESCRIBE, to describe wrongly [v]\n",
  "MISDESCRIBES": "MISDESCRIBE, to describe wrongly [v]\n",
  "MISDESCRIBING": "MISDESCRIBE, to describe wrongly [v]\n",
  "MISDESCRIPTION": "the act of misdescribing [n -S]\n",
  "MISDESCRIPTIONS": "MISDESCRIPTION, the act of misdescribing [n]\n",
  "MISDESERT": "(Spenser) lack of deservingness [n -S]\n",
  "MISDESERTS": "MISDESERT, (Spenser) lack of deservingness [n]\n",
  "MISDEVELOP": "to develop wrongly [v -ED, -ING, -S]\n",
  "MISDEVELOPED": "MISDEVELOP, to develop wrongly [v]\n",
  "MISDEVELOPING": "MISDEVELOP, to develop wrongly [v]\n",
  "MISDEVELOPS": "MISDEVELOP, to develop wrongly [v]\n",
  "MISDEVOTION": "a wrong devotion [n -S]\n",
  "MISDEVOTIONS": "MISDEVOTION, a wrong devotion [n]\n",
  "MISDIAGNOSE": "to diagnose wrongly [v MISDIAGNOSED, MISDIAGNOSING, MISDIAGNOSES]\n",
  "MISDIAGNOSED": "MISDIAGNOSE, to diagnose wrongly [v]\n",
  "MISDIAGNOSES": "MISDIAGNOSE, to diagnose wrongly [v]\n",
  "MISDIAGNOSING": "MISDIAGNOSE, to diagnose wrongly [v]\n",
  "MISDIAGNOSIS": "a wrong diagnosis [n MISDIAGNOSES]\n",
  "MISDIAL": "to dial incorrectly [v MISDIALED or MISDIALLED, MISDIALING or MISDIALLING, MISDIALS]\n",
  "MISDIALED": "MISDIAL, to dial incorrectly [v]\n",
  "MISDIALING": "MISDIAL, to dial incorrectly [v]\n",
  "MISDIALLED": "MISDIAL, to dial incorrectly [v]\n",
  "MISDIALLING": "MISDIAL, to dial incorrectly [v]\n",
  "MISDIALS": "MISDIAL, to dial incorrectly [v]\n",
  "MISDID": "MISDO, to do wrongly [v]\n",
  "MISDIET": "(Spenser) to diet or eat improperly [v -ED, -ING, -S]\n",
  "MISDIETED": "MISDIET, (Spenser) to diet or eat improperly [v]\n",
  "MISDIETING": "MISDIET, (Spenser) to diet or eat improperly [v]\n",
  "MISDIETS": "MISDIET, (Spenser) to diet or eat improperly [v]\n",
  "MISDIGHT": "(Spenser) to mismanage or treat badly [v -ED, -ING, -S]\n",
  "MISDIGHTED": "MISDIGHT, (Spenser) to mismanage or treat badly [v]\n",
  "MISDIGHTING": "MISDIGHT, (Spenser) to mismanage or treat badly [v]\n",
  "MISDIGHTS": "MISDIGHT, (Spenser) to mismanage or treat badly [v]\n",
  "MISDIRECT": "to point in the wrong direction [v -ED, -ING, -S]\n",
  "MISDIRECTED": "MISDIRECT, to point in the wrong direction [v]\n",
  "MISDIRECTING": "MISDIRECT, to point in the wrong direction [v]\n",
  "MISDIRECTION": "a wrong direction [n -S]\n",
  "MISDIRECTIONS": "MISDIRECTION, a wrong direction [n]\n",
  "MISDIRECTS": "MISDIRECT, to point in the wrong direction [v]\n",
  "MISDISTRIBUTION": "a wrong distribution [n]\n",
  "MISDIVIDE": "to divide wrongly [v MISDIVIDED, MISDIVIDING, MISDIVIDES]\n",
  "MISDIVIDED": "MISDIVIDE, to divide wrongly [v]\n",
  "MISDIVIDES": "MISDIVIDE, to divide wrongly [v]\n",
  "MISDIVIDING": "MISDIVIDE, to divide wrongly [v]\n",
  "MISDIVISION": "a wrong division [n -S]\n",
  "MISDIVISIONS": "MISDIVISION, a wrong division [n]\n",
  "MISDO": "to do wrongly [v MISDID, MISDONE or MISDONNE, MISDOING, MISDOES]\n",
  "MISDOER": "a wrongdoer [n -S]\n",
  "MISDOERS": "MISDOER, a wrongdoer [n]\n",
  "MISDOES": "MISDO, to do wrongly [v]\n",
  "MISDOING": "the act of doing wrong [n -S]\n",
  "MISDOINGS": "MISDOING, the act of doing wrong [n]\n",
  "MISDONE": "MISDO, to do wrongly [v]\n",
  "MISDONNE": "(Spenser) to misdo [v]\n",
  "MISDOUBT": "to be suspicious of [v -ED, -ING, -S]\n",
  "MISDOUBTED": "MISDOUBT, to be suspicious of [v]\n",
  "MISDOUBTFUL": "(Spenser) suspicious [adj]\n",
  "MISDOUBTING": "MISDOUBT, to be suspicious of [v]\n",
  "MISDOUBTS": "MISDOUBT, to be suspicious of [v]\n",
  "MISDRAW": "to draw incorrectly [v MISDREW, MISDRAWN, MISDRAWING, MISDRAWS]\n",
  "MISDRAWING": "the act of misdrawing [n -S]\n",
  "MISDRAWINGS": "MISDRAWING, the act of misdrawing [n]\n",
  "MISDRAWN": "MISDRAW, to draw incorrectly [v]\n",
  "MISDRAWS": "MISDRAW, to draw incorrectly [v]\n",
  "MISDREAD": "(Shakespeare) to fear [v -ED, -ING, -S]\n",
  "MISDREADED": "MISDREAD, (Shakespeare) to fear [v]\n",
  "MISDREADING": "MISDREAD, (Shakespeare) to fear [v]\n",
  "MISDREADS": "MISDREAD, (Shakespeare) to fear [v]\n",
  "MISDREW": "MISDRAW, to draw incorrectly [v]\n",
  "MISDRIVE": "to drive improperly [v MISDROVE, MISDRIVEN, MISDRIVING, MISDRIVES]\n",
  "MISDRIVEN": "MISDRIVE, to drive improperly [v]\n",
  "MISDRIVES": "MISDRIVE, to drive improperly [v]\n",
  "MISDRIVING": "MISDRIVE, to drive improperly [v]\n",
  "MISDROVE": "MISDRIVE, to drive improperly [v]\n",
  "MISE": "the issue in a writ of right [n -S]\n",
  "MISEASE": "(archaic) uneasiness [n -S]\n",
  "MISEASES": "MISEASE, (archaic) uneasiness [n]\n",
  "MISEAT": "to eat improperly [v MISATE, MISEATEN, MISEATING, MISEATS]\n",
  "MISEATEN": "MISEAT, to eat improperly [v]\n",
  "MISEATING": "MISEAT, to eat improperly [v]\n",
  "MISEATS": "MISEAT, to eat improperly [v]\n",
  "MISEDIT": "to edit incorrectly [v -ED, -ING, -S]\n",
  "MISEDITED": "MISEDIT, to edit incorrectly [v]\n",
  "MISEDITING": "MISEDIT, to edit incorrectly [v]\n",
  "MISEDITS": "MISEDIT, to edit incorrectly [v]\n",
  "MISEDUCATE": "to educate in a wrong manner [v MISEDUCATED, MISEDUCATING, MISEDUCATES]\n",
  "MISEDUCATED": "MISEDUCATE, to educate in a wrong manner [v]\n",
  "MISEDUCATES": "MISEDUCATE, to educate in a wrong manner [v]\n",
  "MISEDUCATING": "MISEDUCATE, to educate in a wrong manner [v]\n",
  "MISEDUCATION": "wrong or faulty education [n -S]\n",
  "MISEDUCATIONS": "MISEDUCATION, wrong or faulty education [n]\n",
  "MISEMPHASES": "MISEMPHASIS, a wrong emphasis [n]\n",
  "MISEMPHASIS": "a wrong emphasis [n MISEMPHASES]\n",
  "MISEMPHASISE": "to emphasise wrongly, also MISEMPHASIZE [v MISEMPHASISED, MISEMPHASISING, MISEMPHASISES]\n",
  "MISEMPHASISED": "MISEMPHASISE, to emphasise wrongly, also MISEMPHASIZE [v]\n",
  "MISEMPHASISES": "MISEMPHASISE, to emphasise wrongly, also MISEMPHASIZE [v]\n",
  "MISEMPHASISING": "MISEMPHASISE, to emphasise wrongly, also MISEMPHASIZE [v]\n",
  "MISEMPHASIZE": "to emphasize wrongly, also MISEMPHASISE [v MISEMPHASIZED, MISEMPHASIZING, MISEMPHASIZES]\n",
  "MISEMPHASIZED": "MISEMPHASIZE, to emphasize wrongly, also MISEMPHASISE [v]\n",
  "MISEMPHASIZES": "MISEMPHASIZE, to emphasize wrongly, also MISEMPHASISE [v]\n",
  "MISEMPHASIZING": "MISEMPHASIZE, to emphasize wrongly, also MISEMPHASISE [v]\n",
  "MISEMPLOY": "to employ wrongly or badly [v -ED, -ING, -S]\n",
  "MISEMPLOYED": "MISEMPLOY, to employ wrongly or badly [v]\n",
  "MISEMPLOYING": "MISEMPLOY, to employ wrongly or badly [v]\n",
  "MISEMPLOYMENT": "a wrong employment [n -S]\n",
  "MISEMPLOYMENTS": "MISEMPLOYMENT, a wrong employment [n]\n",
  "MISEMPLOYS": "MISEMPLOY, to employ wrongly or badly [v]\n",
  "MISENROL": "to enrol incorrectly [v MISENROLLED, MISENROLLING, MISENROLS]\n",
  "MISENROLL": "to enrol wrongly, also MISENROL [v -ED, -ING, -S]\n",
  "MISENROLLED": "MISENROL, to enrol incorrectly [v]\n",
  "MISENROLLING": "MISENROL, to enrol incorrectly [v]\n",
  "MISENROLLS": "MISENROLL, to enrol wrongly, also MISENROL [v]\n",
  "MISENROLS": "MISENROL, to enrol incorrectly [v]\n",
  "MISENTER": "to enter erroneously [v -ED, -ING, -S]\n",
  "MISENTERED": "MISENTER, to enter erroneously [v]\n",
  "MISENTERING": "MISENTER, to enter erroneously [v]\n",
  "MISENTERS": "MISENTER, to enter erroneously [v]\n",
  "MISENTREAT": "(obsolete) to treat wrongfully [v -ED, -ING, -S]\n",
  "MISENTREATED": "MISENTREAT, (obsolete) to treat wrongfully [v]\n",
  "MISENTREATING": "MISENTREAT, (obsolete) to treat wrongfully [v]\n",
  "MISENTREATS": "MISENTREAT, (obsolete) to treat wrongfully [v]\n",
  "MISENTRIES": "MISENTRY, an erroneous entry or charge, as of an account [n]\n",
  "MISENTRY": "an erroneous entry or charge, as of an account [n MISENTRIES]\n",
  "MISER": "one who hoards money greedily [n -S]\n",
  "MISERABILISM": "the quality of seeming to enjoy being depressed by gloomy art or music, also MISERABLISM [n -S]\n",
  "MISERABILISMS": "MISERABILISM, the quality of seeming to enjoy being depressed by gloomy art or music, also MISERABLISM [n]\n",
  "MISERABILIST": "a person who appears to enjoy being depressed, esp. a performer of or listener to gloomy music [n -S]\n",
  "MISERABILISTS": "MISERABILIST, a person who appears to enjoy being depressed, esp. a performer of or listener to gloomy music [n]\n",
  "MISERABLE": "wretched [adj MISERABLY] / a miserable person, a wretch [n -S]\n",
  "MISERABLENESS": "the state of being miserable [n -ES]\n",
  "MISERABLENESSES": "MISERABLENESS, the state of being miserable [n]\n",
  "MISERABLES": "MISERABLE, a miserable person, a wretch [n]\n",
  "MISERABLISM": "the quality of seeming to enjoy being depressed by gloomy art or music, also MISERABILISM [n -S]\n",
  "MISERABLISMS": "MISERABLISM, the quality of seeming to enjoy being depressed by gloomy art or music, also MISERABILISM [n]\n",
  "MISERABLIST": "a person who appears to enjoy being depressed, esp. a performer of or listener to gloomy music [n -S]\n",
  "MISERABLISTS": "MISERABLIST, a person who appears to enjoy being depressed, esp. a performer of or listener to gloomy music [n]\n",
  "MISERABLY": "MISERABLE, wretched [adv]\n",
  "MISERE": "(French) an undertaking in cards to take no tricks [n -S]\n",
  "MISERERE": "(Latin) the psalm usually appointed for penitential acts, being the 50th psalm in the Latin version [n -S]\n",
  "MISERERES": "MISERERE, (Latin) the psalm usually appointed for penitential acts, being the 50th psalm in the Latin version [n]\n",
  "MISERES": "MISERE, (French) an undertaking in cards to take no tricks [n]\n",
  "MISERICORD": "a bracket on a seat in a choirstall, allowing the user some support when standing, also MISERICORDE [n -S]\n",
  "MISERICORDE": "a bracket on a turn-up seat in a choirstall, allowing the user some support when standing, also MISERICORD [n -S]\n",
  "MISERICORDES": "MISERICORDE, a bracket on a turn-up seat in a choirstall, allowing the user some support when standing, also MISERICORD [n]\n",
  "MISERICORDS": "MISERICORD, a bracket on a seat in a choirstall, allowing the user some support when standing, also MISERICORDE [n]\n",
  "MISERIES": "MISERY, a state of great suffering [n]\n",
  "MISERLIER": "MISERLY, characteristic of a miser [adj]\n",
  "MISERLIEST": "MISERLY, characteristic of a miser [adj]\n",
  "MISERLINESS": "the state of being miserly [n -ES]\n",
  "MISERLINESSES": "MISERLINESS, the state of being miserly [n]\n",
  "MISERLY": "characteristic of a miser [adj MISERLIER, MISERLIEST]\n",
  "MISERS": "MISER, one who hoards money greedily [n]\n",
  "MISERY": "a state of great suffering [n MISERIES]\n",
  "MISES": "MISE, the issue in a writ of right [n]\n",
  "MISESTEEM": "to lack esteem for; to disrespect [v -ED, -ING, -S]\n",
  "MISESTEEMED": "MISESTEEM, to lack esteem for; to disrespect [v]\n",
  "MISESTEEMING": "MISESTEEM, to lack esteem for; to disrespect [v]\n",
  "MISESTEEMS": "MISESTEEM, to lack esteem for; to disrespect [v]\n",
  "MISESTIMATE": "to estimate wrongly [v MISESTIMATED, MISESTIMATING, MISESTIMATES]\n",
  "MISESTIMATED": "MISESTIMATE, to estimate wrongly [v]\n",
  "MISESTIMATES": "MISESTIMATE, to estimate wrongly [v]\n",
  "MISESTIMATING": "MISESTIMATE, to estimate wrongly [v]\n",
  "MISESTIMATION": "a wrong estimation [n -S]\n",
  "MISESTIMATIONS": "MISESTIMATION, a wrong estimation [n]\n",
  "MISEVALUATE": "to evaluate wrongly [v MISEVALUATED, MISEVALUATING, MISEVALUATES]\n",
  "MISEVALUATED": "MISEVALUATE, to evaluate wrongly [v]\n",
  "MISEVALUATES": "MISEVALUATE, to evaluate wrongly [v]\n",
  "MISEVALUATING": "MISEVALUATE, to evaluate wrongly [v]\n",
  "MISEVALUATION": "a wrong evaluation [n -S]\n",
  "MISEVALUATIONS": "MISEVALUATION, a wrong evaluation [n]\n",
  "MISEVENT": "a mishap [n -S]\n",
  "MISEVENTS": "MISEVENT, a mishap [n]\n",
  "MISFAITH": "(archaic) distrust [n -S]\n",
  "MISFAITHS": "MISFAITH, (archaic) distrust [n]\n",
  "MISFALL": "unluckily to befall [v MISFELL, MISFALLEN or (Spenser) MISFALNE, MISFALLING, MISFALLS]\n",
  "MISFALLEN": "MISFALL, unluckily to befall [v]\n",
  "MISFALLING": "MISFALL, unluckily to befall [v]\n",
  "MISFALLS": "MISFALL, unluckily to befall [v]\n",
  "MISFALNE": "MISFALL, unluckily to befall [v]\n",
  "MISFARE": "(Spenser) to fare badly [v MISFARED, MISFARING, MISFARES]\n",
  "MISFARED": "MISFARE, (Spenser) to fare badly [v]\n",
  "MISFARES": "MISFARE, (Spenser) to fare badly [v]\n",
  "MISFARING": "(Spenser) wrongdoing [n -S]\n",
  "MISFARINGS": "MISFARING, (Spenser) wrongdoing [n]\n",
  "MISFEASANCE": "the performance by a public official of an act that is legally unjustified, harmful, or contrary to law; wrongdoing (used especially of an act in violation of a public trust), also MALFEASANCE [n -S]\n",
  "MISFEASANCES": "MISFEASANCE, the performance by a public official of an act that is legally unjustified, harmful, or contrary to law; wrongdoing (used especially of an act in violation of a public trust), also MALFEASANCE [n]\n",
  "MISFEASOR": "one who commits a misfeasance [n -S]\n",
  "MISFEASORS": "MISFEASOR, one who commits a misfeasance [n]\n",
  "MISFEATURE": "a bad or distorted feature or trait [v MISFEATURED, MISFEATURING, MISFEATURES]\n",
  "MISFEATURED": "ugly, ill-favoured [adj]\n",
  "MISFEATURES": "MISFEATURE [n]\n",
  "MISFEATURING": "distorting the features [adj]\n",
  "MISFED": "MISFEED, to feed incorrectly [v]\n",
  "MISFEED": "to feed incorrectly [v MISFED, MISFEEDING, MISFEEDS]\n",
  "MISFEEDING": "MISFEED, to feed incorrectly [v]\n",
  "MISFEEDS": "MISFEED, to feed incorrectly [v]\n",
  "MISFEIGN": "(Spenser) to feign with evil intent [v -ED, -ING, -S]\n",
  "MISFEIGNED": "MISFEIGN, (Spenser) to feign with evil intent [v]\n",
  "MISFEIGNING": "MISFEIGN, (Spenser) to feign with evil intent [v]\n",
  "MISFEIGNS": "MISFEIGN, (Spenser) to feign with evil intent [v]\n",
  "MISFELL": "MISFALL, unluckily to befall [v]\n",
  "MISFIELD": "to field badly [v -ED, -ING, -S]\n",
  "MISFIELDED": "MISFIELD, to field badly [v]\n",
  "MISFIELDING": "MISFIELD, to field badly [v]\n",
  "MISFIELDS": "MISFIELD, to field badly [v]\n",
  "MISFILE": "to file in the wrong place [v MISFILED, MISFILING, MISFILES]\n",
  "MISFILED": "MISFILE, to file in the wrong place [v]\n",
  "MISFILES": "MISFILE, to file in the wrong place [v]\n",
  "MISFILING": "MISFILE, to file in the wrong place [v]\n",
  "MISFIRE": "to fail to fire [v MISFIRED, MISFIRING, MISFIRES]\n",
  "MISFIRED": "MISFIRE, to fail to fire [v]\n",
  "MISFIRES": "MISFIRE, to fail to fire [v]\n",
  "MISFIRING": "MISFIRE, to fail to fire [v]\n",
  "MISFIT": "to fit badly [v MISFITTED, MISFITTING, MISFITS]\n",
  "MISFITS": "MISFIT, to fit badly [v]\n",
  "MISFITTED": "MISFIT, to fit badly [v]\n",
  "MISFITTING": "MISFIT, to fit badly [v]\n",
  "MISFOCUS": "to focus badly [v MISFOCUSSED or MISFOCUSED, MISFOCUSSING or MISFOCUSING, MISFOCUSSES or MISFOCUSES]\n",
  "MISFOCUSED": "MISFOCUS, to focus badly [v]\n",
  "MISFOCUSES": "MISFOCUS, to focus badly [v]\n",
  "MISFOCUSING": "MISFOCUS, to focus badly [v]\n",
  "MISFOCUSSED": "MISFOCUS, to focus badly [v]\n",
  "MISFOCUSSES": "MISFOCUS, to focus badly [v]\n",
  "MISFOCUSSING": "MISFOCUS, to focus badly [v]\n",
  "MISFOLD": "to fold wrongly [v -ED, -ING, -S]\n",
  "MISFOLDED": "MISFOLD, to fold wrongly [v]\n",
  "MISFOLDING": "MISFOLD, to fold wrongly [v]\n",
  "MISFOLDS": "MISFOLD, to fold wrongly [v]\n",
  "MISFORM": "to make in an ill form [v -ED, -ING, -S]\n",
  "MISFORMATION": "a wrong formation [n -S]\n",
  "MISFORMATIONS": "MISFORMATION, a wrong formation [n]\n",
  "MISFORMED": "MISFORM, to make in an ill form [v]\n",
  "MISFORMING": "MISFORM, to make in an ill form [v]\n",
  "MISFORMS": "MISFORM, to make in an ill form [v]\n",
  "MISFORTUNE": "an event or conjunction of events that causes an unfortunate or distressing result [n -S]\n",
  "MISFORTUNED": "(archaic) unfortunate [adj]\n",
  "MISFORTUNES": "MISFORTUNE, an event or conjunction of events that causes an unfortunate or distressing result [n]\n",
  "MISFRAME": "to frame badly [v MISFRAMED, MISFRAMING, MISFRAMES]\n",
  "MISFRAMED": "MISFRAME, to frame badly [v]\n",
  "MISFRAMES": "MISFRAME, to frame badly [v]\n",
  "MISFRAMING": "MISFRAME, to frame badly [v]\n",
  "MISFUNCTION": "to function wrongly [v -ED, -ING, -S]\n",
  "MISFUNCTIONED": "MISFUNCTION, to function wrongly [v]\n",
  "MISFUNCTIONING": "MISFUNCTION, to function wrongly [v]\n",
  "MISFUNCTIONS": "MISFUNCTION, to function wrongly [v]\n",
  "MISGAGE": "to gage wrongly, also MISGAUGE [v MISGAGED, MISGAGING, MISGAGES]\n",
  "MISGAGED": "MISGAGE, to gage wrongly, also MISGAUGE [v]\n",
  "MISGAGES": "MISGAGE, to gage wrongly, also MISGAUGE [v]\n",
  "MISGAGING": "MISGAGE, to gage wrongly, also MISGAUGE [v]\n",
  "MISGAUGE": "to gauge incorrectly, also MISGAGE [v MISGAUGED, MISGAUGING, MISGAUGES]\n",
  "MISGAUGED": "MISGAUGE, to gauge incorrectly, also MISGAGE [v]\n",
  "MISGAUGES": "MISGAUGE, to gauge incorrectly, also MISGAGE [v]\n",
  "MISGAUGING": "MISGAUGE, to gauge incorrectly, also MISGAGE [v]\n",
  "MISGAVE": "MISGIVE, to make doubtful or fearful [v]\n",
  "MISGENDER": "to refer to (a person) using a pronoun or title that does not correspond with that person's gender identity [v -ED, -ING, -S]\n",
  "MISGENDERED": "MISGENDER, to refer to (a person) using a pronoun or title that does not correspond with that person's gender identity [v]\n",
  "MISGENDERING": "MISGENDER, to refer to (a person) using a pronoun or title that does not correspond with that person's gender identity [v]\n",
  "MISGENDERS": "MISGENDER, to refer to (a person) using a pronoun or title that does not correspond with that person's gender identity [v]\n",
  "MISGIVE": "to make doubtful or fearful [v MISGAVE, MISGIVEN, MISGIVING, MISGIVES]\n",
  "MISGIVEN": "MISGIVE, to make doubtful or fearful [v]\n",
  "MISGIVES": "MISGIVE, to make doubtful or fearful [v]\n",
  "MISGIVING": "an apprehension [n -S]\n",
  "MISGIVINGS": "MISGIVING, an apprehension [n]\n",
  "MISGO": "(dialect) to go astray [v MISWENT, MISGONE, MISGOING, MISGOES]\n",
  "MISGOES": "MISGO, (dialect) to go astray [v]\n",
  "MISGOING": "MISGO, (dialect) to go astray [v]\n",
  "MISGONE": "MISGO, (dialect) to go astray [v]\n",
  "MISGOTTEN": "(Spenser) unjustly gotten [adj]\n",
  "MISGOVERN": "to govern wrongly [v -ED, -ING, -S]\n",
  "MISGOVERNANCE": "misgovernment, also MISGOVERNAUNCE [n -S]\n",
  "MISGOVERNANCES": "MISGOVERNANCE, misgovernment, also MISGOVERNAUNCE [n]\n",
  "MISGOVERNAUNCE": "(Spenser) misgovernment, also MISGOVERNANCE [n -S]\n",
  "MISGOVERNAUNCES": "MISGOVERNAUNCE, (Spenser) misgovernment, also MISGOVERNANCE [n]\n",
  "MISGOVERNED": "MISGOVERN, to govern wrongly [v]\n",
  "MISGOVERNING": "MISGOVERN, to govern wrongly [v]\n",
  "MISGOVERNMENT": "wrong government [n -S]\n",
  "MISGOVERNMENTS": "MISGOVERNMENT, wrong government [n]\n",
  "MISGOVERNOR": "one who misgoverns [n -S]\n",
  "MISGOVERNORS": "MISGOVERNOR, one who misgoverns [n]\n",
  "MISGOVERNS": "MISGOVERN, to govern wrongly [v]\n",
  "MISGRADE": "to grade incorrectly [v MISGRADED, MISGRADING, MISGRADES]\n",
  "MISGRADED": "MISGRADE, to grade incorrectly [v]\n",
  "MISGRADES": "MISGRADE, to grade incorrectly [v]\n",
  "MISGRADING": "MISGRADE, to grade incorrectly [v]\n",
  "MISGRAFF": "(Shakespeare) badly grafted or matched [adj]\n",
  "MISGRAFT": "to graft wrongly [v -ED, -ING, -S]\n",
  "MISGRAFTED": "MISGRAFT, to graft wrongly [v]\n",
  "MISGRAFTING": "MISGRAFT, to graft wrongly [v]\n",
  "MISGRAFTS": "MISGRAFT, to graft wrongly [v]\n",
  "MISGREW": "MISGROW, to grow abnormally [v]\n",
  "MISGROW": "to grow abnormally [v MISGREW, MISGROWN, MISGROWING, MISGROWS]\n",
  "MISGROWING": "MISGROW, to grow abnormally [v]\n",
  "MISGROWN": "MISGROW, to grow abnormally [v]\n",
  "MISGROWS": "MISGROW, to grow abnormally [v]\n",
  "MISGROWTH": "an unnatural or abnormal growth [n -S]\n",
  "MISGROWTHS": "MISGROWTH, an unnatural or abnormal growth [n]\n",
  "MISGUESS": "to guess wrongly [v -ED, -ING, -ES]\n",
  "MISGUESSED": "MISGUESS, to guess wrongly [v]\n",
  "MISGUESSES": "MISGUESS, to guess wrongly [v]\n",
  "MISGUESSING": "MISGUESS, to guess wrongly [v]\n",
  "MISGUGGLE": "(Scots) to bungle, mar, also MISHGUGGLE [v MISGUGGLED, MISGUGGLING, MISGUGGLES]\n",
  "MISGUGGLED": "MISGUGGLE, (Scots) to bungle, mar, also MISHGUGGLE [v]\n",
  "MISGUGGLES": "MISGUGGLE, (Scots) to bungle, mar, also MISHGUGGLE [v]\n",
  "MISGUGGLING": "MISGUGGLE, (Scots) to bungle, mar, also MISHGUGGLE [v]\n",
  "MISGUIDANCE": "wrong guidance [n -S]\n",
  "MISGUIDANCES": "MISGUIDANCE, wrong guidance [n]\n",
  "MISGUIDE": "to guide wrongly [v MISGUIDED, MISGUIDING, MISGUIDES]\n",
  "MISGUIDED": "MISGUIDE, to guide wrongly [v]\n",
  "MISGUIDEDLY": "MISGUIDED, MISGUIDE, to guide wrongly [adv]\n",
  "MISGUIDEDNESS": "the state of being misguided [n -ES]\n",
  "MISGUIDEDNESSES": "MISGUIDEDNESS, the state of being misguided [n]\n",
  "MISGUIDER": "one who guides wrongly [n -S]\n",
  "MISGUIDERS": "MISGUIDER, one who guides wrongly [n]\n",
  "MISGUIDES": "MISGUIDE, to guide wrongly [v]\n",
  "MISGUIDING": "MISGUIDE, to guide wrongly [v]\n",
  "MISHALLOWED": "(archaic) consecrated to evil [adj]\n",
  "MISHANDLE": "to handle wrongly [v MISHANDLED, MISHANDLING, MISHANDLES]\n",
  "MISHANDLED": "MISHANDLE, to handle wrongly [v]\n",
  "MISHANDLES": "MISHANDLE, to handle wrongly [v]\n",
  "MISHANDLING": "e act of handling wrongly [n -S]\n",
  "MISHANDLINGS": "MISHANDLING, e act of handling wrongly [n]\n",
  "MISHANTER": "(Scots) an unlucky chance, a misfortune, also MISAUNTER, MISCHANTER [n -S]\n",
  "MISHANTERS": "MISHANTER, (Scots) an unlucky chance, a misfortune, also MISAUNTER, MISCHANTER [n]\n",
  "MISHAP": "to have an unfortunate accident [v MISHAPPED, MISHAPPING, MISHAPS]\n",
  "MISHAPPED": "MISHAP, to have an unfortunate accident [v]\n",
  "MISHAPPEN": "(Spenser) to happen ill or unluckily [v -ED, -ING, -S]\n",
  "MISHAPPENED": "MISHAPPEN, (Spenser) to happen ill or unluckily [v]\n",
  "MISHAPPENING": "MISHAPPEN, (Spenser) to happen ill or unluckily [v]\n",
  "MISHAPPENS": "MISHAPPEN, (Spenser) to happen ill or unluckily [v]\n",
  "MISHAPPING": "MISHAP, to have an unfortunate accident [v]\n",
  "MISHAPS": "MISHAP, to have an unfortunate accident [v]\n",
  "MISHAPT": "(Spenser) misshaped [adj]\n",
  "MISHEAR": "to hear incorrectly [v MISHEARD, MISHEARING, MISHEARS]\n",
  "MISHEARD": "MISHEAR, to hear incorrectly [v]\n",
  "MISHEARING": "MISHEAR, to hear incorrectly [v]\n",
  "MISHEARS": "MISHEAR, to hear incorrectly [v]\n",
  "MISHEGAAS": "(Yiddish) madness, foolishness, also MESHUGAAS, MISHEGOSS, MISHUGAS [n MISHEGAASEN]\n",
  "MISHEGAASEN": "MISHEGAAS, (Yiddish) madness, foolishness, also MESHUGAAS, MISHEGOSS, MISHUGAS [n]\n",
  "MISHEGOSS": "(Yiddish) madness, foolishness, also MESHUGAAS, MISHEGAAS, MISHUGAS [n MISHEGOSS]\n",
  "MISHGUGGLE": "(Scots) to bungle, mar, also MISGUGGLE [v MISHGUGGLED, MISHGUGGLING, MISHGUGGLES]\n",
  "MISHGUGGLED": "MISHGUGGLE, (Scots) to bungle, mar, also MISGUGGLE [v]\n",
  "MISHGUGGLES": "MISHGUGGLE, (Scots) to bungle, mar, also MISGUGGLE [v]\n",
  "MISHGUGGLING": "MISHGUGGLE, (Scots) to bungle, mar, also MISGUGGLE [v]\n",
  "MISHIT": "to hit poorly [v MISHIT, MISHITTING, MISHITS]\n",
  "MISHITS": "MISHIT, to hit poorly [v]\n",
  "MISHITTING": "MISHIT, to hit poorly [v]\n",
  "MISHMASH": "a confused mixture, also MISHMOSH [n -ES]\n",
  "MISHMASHES": "MISHMASH, a confused mixture, also MISHMOSH [n]\n",
  "MISHMEE": "the bitter root stock of a plant, also MISHMI [n -S]\n",
  "MISHMEES": "MISHMEE, the bitter root stock of a plant, also MISHMI [n]\n",
  "MISHMI": "the bitter root stock of a plant, also MISHMEE [n -S]\n",
  "MISHMIS": "MISHMI, the bitter root stock of a plant, also MISHMEE [n]\n",
  "MISHMOSH": "a confused mixture, also MISHMASH [n -ES]\n",
  "MISHMOSHES": "MISHMOSH, a confused mixture, also MISHMASH [n]\n",
  "MISHUGAS": "(Yiddish) crazy or foolish behaviour, also MESHUGAAS, MISHEGAAS, MISHEGOSS [n MISHUGASES]\n",
  "MISHUGASES": "MISHUGAS, (Yiddish) crazy or foolish behaviour, also MESHUGAAS, MISHEGAAS, MISHEGOSS [n]\n",
  "MISIDENTIFIED": "MISIDENTIFY, to identify wrongly [v]\n",
  "MISIDENTIFIES": "MISIDENTIFY, to identify wrongly [v]\n",
  "MISIDENTIFY": "to identify wrongly [v MISIDENTIFIED, MISIDENTIFYING, MISIDENTIFIES]\n",
  "MISIDENTIFYING": "MISIDENTIFY, to identify wrongly [v]\n",
  "MISIMPRESSION": "a mistaken impression [n -S]\n",
  "MISIMPRESSIONS": "MISIMPRESSION, a mistaken impression [n]\n",
  "MISIMPROVE": "to make worse by would-be improvement [v MISIMPROVED, MISIMPROVING, MISIMPROVES]\n",
  "MISIMPROVED": "MISIMPROVE, to make worse by would-be improvement [v]\n",
  "MISIMPROVEMENT": "a false improvement [n -S]\n",
  "MISIMPROVEMENTS": "MISIMPROVEMENT, a false improvement [n]\n",
  "MISIMPROVES": "MISIMPROVE, to make worse by would-be improvement [v]\n",
  "MISIMPROVING": "MISIMPROVE, to make worse by would-be improvement [v]\n",
  "MISINFER": "to infer wrongly [v MISINFERRED, MISINFERRING, MISINFERS]\n",
  "MISINFERRED": "MISINFER, to infer wrongly [v]\n",
  "MISINFERRING": "MISINFER, to infer wrongly [v]\n",
  "MISINFERS": "MISINFER, to infer wrongly [v]\n",
  "MISINFORM": "to inform incorrectly, also DISINFORM [v -ED, -ING, -S]\n",
  "MISINFORMANT": "one who misinforms, also MISINFORMER [n -S]\n",
  "MISINFORMANTS": "MISINFORMANT, one who misinforms, also MISINFORMER [n]\n",
  "MISINFORMATION": "wrong information [n -S]\n",
  "MISINFORMATIONS": "MISINFORMATION, wrong information [n]\n",
  "MISINFORMED": "MISINFORM, to inform incorrectly, also DISINFORM [v]\n",
  "MISINFORMER": "one who misinforms, also MISINFORMANT [n -S]\n",
  "MISINFORMERS": "MISINFORMER, one who misinforms, also MISINFORMANT [n]\n",
  "MISINFORMING": "MISINFORM, to inform incorrectly, also DISINFORM [v]\n",
  "MISINFORMS": "MISINFORM, to inform incorrectly, also DISINFORM [v]\n",
  "MISINSTRUCT": "to instruct wrongly [v -ED, -ING, -S]\n",
  "MISINSTRUCTED": "MISINSTRUCT, to instruct wrongly [v]\n",
  "MISINSTRUCTING": "MISINSTRUCT, to instruct wrongly [v]\n",
  "MISINSTRUCTION": "a wrong instruction [n -S]\n",
  "MISINSTRUCTIONS": "MISINSTRUCTION, a wrong instruction [n]\n",
  "MISINSTRUCTS": "MISINSTRUCT, to instruct wrongly [v]\n",
  "MISINTELLIGENCE": "wrong or false information [n]\n",
  "MISINTEND": "(obsolete) to aim amiss [v -ED, -ING, -S]\n",
  "MISINTENDED": "MISINTEND, (obsolete) to aim amiss [v]\n",
  "MISINTENDING": "MISINTEND, (obsolete) to aim amiss [v]\n",
  "MISINTENDS": "MISINTEND, (obsolete) to aim amiss [v]\n",
  "MISINTER": "to inter improperly [v MISINTERRED, MISINTERRING, MISINTERS]\n",
  "MISINTERPRET": "to explain wrongly [v -ED, -ING, -S]\n",
  "MISINTERPRETED": "MISINTERPRET, to explain wrongly [v]\n",
  "MISINTERPRETER": "one who misinterprets [n -S]\n",
  "MISINTERPRETERS": "MISINTERPRETER, one who misinterprets [n]\n",
  "MISINTERPRETING": "MISINTERPRET, to explain wrongly [v]\n",
  "MISINTERPRETS": "MISINTERPRET, to explain wrongly [v]\n",
  "MISINTERRED": "MISINTER, to inter improperly [v]\n",
  "MISINTERRING": "MISINTER, to inter improperly [v]\n",
  "MISINTERS": "MISINTER, to inter improperly [v]\n",
  "MISJOIN": "to join incorrectly [v -ED, -ING, -S]\n",
  "MISJOINDER": "an incorrect union of parties or of causes of action in a procedure, criminal or civil [n -S]\n",
  "MISJOINDERS": "MISJOINDER, an incorrect union of parties or of causes of action in a procedure, criminal or civil [n]\n",
  "MISJOINED": "MISJOIN, to join incorrectly [v]\n",
  "MISJOINING": "MISJOIN, to join incorrectly [v]\n",
  "MISJOINS": "MISJOIN, to join incorrectly [v]\n",
  "MISJUDGE": "to judge wrongly [v MISJUDGED, MISJUDGING, MISJUDGES]\n",
  "MISJUDGED": "MISJUDGE, to judge wrongly [v]\n",
  "MISJUDGEMENT": "an erroneous judgment, also MISJUDGMENT [n -S]\n",
  "MISJUDGEMENTS": "MISJUDGEMENT, an erroneous judgment, also MISJUDGMENT [n]\n",
  "MISJUDGER": "one who misjudges [n -S]\n",
  "MISJUDGERS": "MISJUDGER, one who misjudges [n]\n",
  "MISJUDGES": "MISJUDGE, to judge wrongly [v]\n",
  "MISJUDGING": "MISJUDGE, to judge wrongly [v]\n",
  "MISJUDGMENT": "an erroneous judgment, also MISJUDGEMENT [n -S]\n",
  "MISJUDGMENTS": "MISJUDGMENT, an erroneous judgment, also MISJUDGEMENT [n]\n",
  "MISKAL": "(Arabic) an Oriental unit of weight [n -S]\n",
  "MISKALS": "MISKAL, (Arabic) an Oriental unit of weight [n]\n",
  "MISKEEP": "to keep wrongly [v MISKEPT, MISKEEPING, MISKEEPS]\n",
  "MISKEEPING": "MISKEEP, to keep wrongly [v]\n",
  "MISKEEPS": "MISKEEP, to keep wrongly [v]\n",
  "MISKEN": "to fail to recognize [v MISKENNED, MISKENT, MISKENNING, MISKENS]\n",
  "MISKENNED": "MISKEN, to fail to recognize [v]\n",
  "MISKENNING": "MISKEN, to fail to recognize [v]\n",
  "MISKENS": "MISKEN, to fail to recognize [v]\n",
  "MISKENT": "MISKEN, to fail to recognize [v]\n",
  "MISKEPT": "MISKEEP, to keep wrongly [v]\n",
  "MISKEY": "to key in date incorrectly [v -ED, -ING, -S]\n",
  "MISKEYED": "MISKEY, to key in date incorrectly [v]\n",
  "MISKEYING": "MISKEY, to key in date incorrectly [v]\n",
  "MISKEYS": "MISKEY, to key in date incorrectly [v]\n",
  "MISKICK": "to kick badly [v -ED, -ING, -S]\n",
  "MISKICKED": "MISKICK, to kick badly [v]\n",
  "MISKICKING": "MISKICK, to kick badly [v]\n",
  "MISKICKS": "MISKICK, to kick badly [v]\n",
  "MISKNEW": "MISKNOW, to fail to understand or recognize [v]\n",
  "MISKNOW": "to fail to understand or recognize [v MISKNEW, MISKNOWN, MISKNOWING, MISKNOWS]\n",
  "MISKNOWING": "MISKNOW, to fail to understand or recognize [v]\n",
  "MISKNOWLEDGE": "erroneous knowledge [n -S]\n",
  "MISKNOWLEDGES": "MISKNOWLEDGE, erroneous knowledge [n]\n",
  "MISKNOWN": "MISKNOW, to fail to understand or recognize [v]\n",
  "MISKNOWS": "MISKNOW, to fail to understand or recognize [v]\n",
  "MISLABEL": "to label incorrectly or falsely [v MISLABELED or MISLABELLED, MISLABELING or MISLABELLING, MISLABELS]\n",
  "MISLABELED": "MISLABEL, to label incorrectly or falsely [v]\n",
  "MISLABELING": "MISLABEL, to label incorrectly or falsely [v]\n",
  "MISLABELLED": "MISLABEL, to label incorrectly or falsely [v]\n",
  "MISLABELLING": "MISLABEL, to label incorrectly or falsely [v]\n",
  "MISLABELS": "MISLABEL, to label incorrectly or falsely [v]\n",
  "MISLABOR": "to labor badly, also MISLABOUR [v -ED, -ING, -S]\n",
  "MISLABORED": "MISLABOR, to labor badly, also MISLABOUR [v]\n",
  "MISLABORING": "MISLABOR, to labor badly, also MISLABOUR [v]\n",
  "MISLABORS": "MISLABOR, to labor badly, also MISLABOUR [v]\n",
  "MISLABOUR": "to labour wrongly, also MISLABOR [v -ED, -ING, -S]\n",
  "MISLABOURED": "MISLABOUR, to labour wrongly, also MISLABOR [v]\n",
  "MISLABOURING": "MISLABOUR, to labour wrongly, also MISLABOR [v]\n",
  "MISLABOURS": "MISLABOUR, to labour wrongly, also MISLABOR [v]\n",
  "MISLAID": "MISLAY, to put in a forgotten place [v]\n",
  "MISLAIN": "MISLIE, to lie in the wrong position [v]\n",
  "MISLAY": "to put in a forgotten place [v MISLAID, MISLAYING, MISLAYS]\n",
  "MISLAYER": "one who mislays [n -S]\n",
  "MISLAYERS": "MISLAYER, one who mislays [n]\n",
  "MISLAYING": "MISLAY, to put in a forgotten place [v]\n",
  "MISLAYS": "MISLAY, to put in a forgotten place [v]\n",
  "MISLEAD": "to lead astray [v MISLED, MISLEADING, MISLEADS]\n",
  "MISLEADER": "one who leads into error [n -S]\n",
  "MISLEADERS": "MISLEADER, one who leads into error [n]\n",
  "MISLEADING": "MISLEAD, to lead astray [v]\n",
  "MISLEADINGLY": "MISLEADING, MISLEAD, to lead astray [adv]\n",
  "MISLEADS": "MISLEAD, to lead astray [v]\n",
  "MISLEARED": "(Scots) mistaught, unmannerly [adj]\n",
  "MISLEARN": "to learn wrongly [v MISLEARNED, MISLEARNT, MISLEARNING, MISLEARNS]\n",
  "MISLEARNED": "MISLEARN, to learn wrongly [v]\n",
  "MISLEARNING": "MISLEARN, to learn wrongly [v]\n",
  "MISLEARNS": "MISLEARN, to learn wrongly [v]\n",
  "MISLEARNT": "MISLEARN, to learn wrongly [v]\n",
  "MISLED": "MISLEAD, to lead astray [v]\n",
  "MISLEEKE": "(Spenser) to dislike, also MISLIKE [v MISLEEKED, MISLEEKING, MISLEEKES]\n",
  "MISLEEKED": "MISLEEKE, (Spenser) to dislike, also MISLIKE [v]\n",
  "MISLEEKES": "MISLEEKE, (Spenser) to dislike, also MISLIKE [v]\n",
  "MISLEEKING": "MISLEEKE, (Spenser) to dislike, also MISLIKE [v]\n",
  "MISLETOE": "(obsolete) mistletoe [n -S]\n",
  "MISLETOES": "MISLETOE, (obsolete) mistletoe [n]\n",
  "MISLIE": "to lie in the wrong position [v MISLAY, MISLAIN, MISLYING, MISLIES]\n",
  "MISLIES": "MISLIE, to lie in the wrong position [v]\n",
  "MISLIGHT": "to lead astray by its light [v MISLIGHTED, MISLIT, MISLIGHTING, MISLIGHTS]\n",
  "MISLIGHTED": "MISLIGHT, to lead astray by its light [v]\n",
  "MISLIGHTING": "MISLIGHT, to lead astray by its light [v]\n",
  "MISLIGHTS": "MISLIGHT, to lead astray by its light [v]\n",
  "MISLIKE": "(archaic) to dislike, also MISLEEKE [v MISLIKED, MISLIKING, MISLIKES]\n",
  "MISLIKED": "MISLIKE, (archaic) to dislike, also MISLEEKE [v]\n",
  "MISLIKER": "one who mislikes [n -S]\n",
  "MISLIKERS": "MISLIKER, one who mislikes [n]\n",
  "MISLIKES": "MISLIKE, (archaic) to dislike, also MISLEEKE [v]\n",
  "MISLIKING": "the act of misliking [n -S]\n",
  "MISLIKINGS": "MISLIKING, the act of misliking [n]\n",
  "MISLIPPEN": "(Scots) to mistrust [v -ED, -ING, -S]\n",
  "MISLIPPENED": "MISLIPPEN, (Scots) to mistrust [v]\n",
  "MISLIPPENING": "MISLIPPEN, (Scots) to mistrust [v]\n",
  "MISLIPPENS": "MISLIPPEN, (Scots) to mistrust [v]\n",
  "MISLIT": "MISLIGHT, to lead astray by its light [v]\n",
  "MISLIVE": "to live a bad life [v MISLIVED, MISLIVING, MISLIVES]\n",
  "MISLIVED": "MISLIVE, to live a bad life [v]\n",
  "MISLIVES": "MISLIVE, to live a bad life [v]\n",
  "MISLIVING": "MISLIVE, to live a bad life [v]\n",
  "MISLOCATE": "to locate in the wrong place [v MISLOCATED, MISLOCATING, MISLOCATES]\n",
  "MISLOCATED": "MISLOCATE, to locate in the wrong place [v]\n",
  "MISLOCATES": "MISLOCATE, to locate in the wrong place [v]\n",
  "MISLOCATING": "MISLOCATE, to locate in the wrong place [v]\n",
  "MISLOCATION": "the act of mislocating [n -S]\n",
  "MISLOCATIONS": "MISLOCATION, the act of mislocating [n]\n",
  "MISLODGE": "to lodge in a wrong place [v MISLODGED, MISLODGING, MISLODGES]\n",
  "MISLODGED": "MISLODGE, to lodge in a wrong place [v]\n",
  "MISLODGES": "MISLODGE, to lodge in a wrong place [v]\n",
  "MISLODGING": "MISLODGE, to lodge in a wrong place [v]\n",
  "MISLUCK": "to meet with bad luck [v -ED, -ING, -S]\n",
  "MISLUCKED": "MISLUCK, to meet with bad luck [v]\n",
  "MISLUCKING": "MISLUCK, to meet with bad luck [v]\n",
  "MISLUCKS": "MISLUCK, to meet with bad luck [v]\n",
  "MISLYING": "MISLIE, to lie in the wrong position [v]\n",
  "MISMADE": "MISMAKE, to make incorrectly [v]\n",
  "MISMAKE": "to make incorrectly [v MISMADE, MISMAKING, MISMAKES]\n",
  "MISMAKES": "MISMAKE, to make incorrectly [v]\n",
  "MISMAKING": "MISMAKE, to make incorrectly [v]\n",
  "MISMANAGE": "to manage wrongly [v MISMANAGED, MISMANAGING, MISMANAGES]\n",
  "MISMANAGED": "MISMANAGE, to manage wrongly [v]\n",
  "MISMANAGEMENT": "wrong management [n -S]\n",
  "MISMANAGEMENTS": "MISMANAGEMENT, wrong management [n]\n",
  "MISMANAGER": "one who mismanages [n -S]\n",
  "MISMANAGERS": "MISMANAGER, one who mismanages [n]\n",
  "MISMANAGES": "MISMANAGE, to manage wrongly [v]\n",
  "MISMANAGING": "MISMANAGE, to manage wrongly [v]\n",
  "MISMANNERS": "(obsolete) bad manners [n]\n",
  "MISMARK": "to mark wrongly [v -ED, -ING, -S]\n",
  "MISMARKED": "MISMARK, to mark wrongly [v]\n",
  "MISMARKING": "MISMARK, to mark wrongly [v]\n",
  "MISMARKS": "MISMARK, to mark wrongly [v]\n",
  "MISMARRIAGE": "an unsuitable marriage [n -S]\n",
  "MISMARRIAGES": "MISMARRIAGE, an unsuitable marriage [n]\n",
  "MISMARRIED": "MISMARRY, to marry unsuitably [v]\n",
  "MISMARRIES": "MISMARRY, to marry unsuitably [v]\n",
  "MISMARRY": "to marry unsuitably [v MISMARRIED, MISMARRYING, MISMARRIES]\n",
  "MISMARRYING": "MISMARRY, to marry unsuitably [v]\n",
  "MISMATCH": "to match badly [v -ED, -ING, -ES]\n",
  "MISMATCHED": "MISMATCH, to match badly [v]\n",
  "MISMATCHES": "MISMATCH, to match badly [v]\n",
  "MISMATCHING": "MISMATCH, to match badly [v]\n",
  "MISMATCHMENT": "the act of mismatching [n -S]\n",
  "MISMATCHMENTS": "MISMATCHMENT, the act of mismatching [n]\n",
  "MISMATE": "to mate unsuitably [v MISMATED, MISMATING, MISMATES]\n",
  "MISMATED": "MISMATE, to mate unsuitably [v]\n",
  "MISMATES": "MISMATE, to mate unsuitably [v]\n",
  "MISMATING": "the act of mating wrongly or unsuitably [n -S]\n",
  "MISMATINGS": "MISMATING, the act of mating wrongly or unsuitably [n]\n",
  "MISMEASURE": "to measure or estimate incorrectly [v MISMEASURED, MISMEASURING, MISMEASURES]\n",
  "MISMEASURED": "MISMEASURE, to measure or estimate incorrectly [v]\n",
  "MISMEASUREMENT": "wrong measurement [n -S]\n",
  "MISMEASUREMENTS": "MISMEASUREMENT, wrong measurement [n]\n",
  "MISMEASURES": "MISMEASURE, to measure or estimate incorrectly [v]\n",
  "MISMEASURING": "MISMEASURE, to measure or estimate incorrectly [v]\n",
  "MISMEET": "to meet under unfortunate circumstances [v MISMET, MISMEETING, MISMEETS]\n",
  "MISMEETING": "MISMEET, to meet under unfortunate circumstances [v]\n",
  "MISMEETS": "MISMEET, to meet under unfortunate circumstances [v]\n",
  "MISMET": "MISMEET, to meet under unfortunate circumstances [v]\n",
  "MISMETRE": "to spoil the metre (of a poem) [v MISMETRED, MISMETRING, MISMETRES]\n",
  "MISMETRED": "MISMETRE, to spoil the metre (of a poem) [v]\n",
  "MISMETRES": "MISMETRE, to spoil the metre (of a poem) [v]\n",
  "MISMETRING": "MISMETRE, to spoil the metre (of a poem) [v]\n",
  "MISMOVE": "to move wrongly [v MISMOVED, MISMOVING, MISMOVES]\n",
  "MISMOVED": "MISMOVE, to move wrongly [v]\n",
  "MISMOVES": "MISMOVE, to move wrongly [v]\n",
  "MISMOVING": "MISMOVE, to move wrongly [v]\n",
  "MISNAME": "to call by the wrong name [v MISNAMED, MISNAMING, MISNAMES]\n",
  "MISNAMED": "MISNAME, to call by the wrong name [v]\n",
  "MISNAMES": "MISNAME, to call by the wrong name [v]\n",
  "MISNAMING": "MISNAME, to call by the wrong name [v]\n",
  "MISNOMER": "the use of a wrong name or designation esp. the misnaming of a person in a legal instrument [n -S] / to use a misnomer [v -ED, -ING, -S]\n",
  "MISNOMERED": "MISNOMER, to use a misnomer [v]\n",
  "MISNOMERING": "MISNOMER, to use a misnomer [v]\n",
  "MISNOMERS": "MISNOMER, to use a misnomer [v]\n",
  "MISNUMBER": "to number wrongly [v -ED, -ING, -S]\n",
  "MISNUMBERED": "MISNUMBER, to number wrongly [v]\n",
  "MISNUMBERING": "MISNUMBER, to number wrongly [v]\n",
  "MISNUMBERS": "MISNUMBER, to number wrongly [v]\n",
  "MISO": "(Japanese) a paste, used in flavouring, prepared from soya beans and fermented in brine [n -S]\n",
  "MISOBSERVANCE": "an incorrect observance [n -S]\n",
  "MISOBSERVANCES": "MISOBSERVANCE, an incorrect observance [n]\n",
  "MISOBSERVE": "to observe inaccurately [v MISOBSERVED, MISOBSERVING, MISOBSERVES]\n",
  "MISOBSERVED": "MISOBSERVE, to observe inaccurately [v]\n",
  "MISOBSERVES": "MISOBSERVE, to observe inaccurately [v]\n",
  "MISOBSERVING": "MISOBSERVE, to observe inaccurately [v]\n",
  "MISOCAPNIC": "hating tobacco smoke [adj]\n",
  "MISOCLERE": "hating the clergy [adj]\n",
  "MISOGAMIC": "relating to misogamy, hatred of marriage [adj]\n",
  "MISOGAMIES": "MISOGAMY, a hatred of marriage [n]\n",
  "MISOGAMIST": "one who hates marriage [n -S]\n",
  "MISOGAMISTS": "MISOGAMIST, one who hates marriage [n]\n",
  "MISOGAMY": "a hatred of marriage [n MISOGAMIES]\n",
  "MISOGYNIC": "hating women [adj]\n",
  "MISOGYNIES": "MISOGYNY, a hatred of women [n]\n",
  "MISOGYNIST": "one who hates women [n -S]\n",
  "MISOGYNISTIC": "hating women, also MISOGYNISTICAL, MISOGYNOUS [adj]\n",
  "MISOGYNISTICAL": "hating women, also MISOGYNISTIC, MISOGYNOUS [adj]\n",
  "MISOGYNISTS": "MISOGYNIST, one who hates women [n]\n",
  "MISOGYNOUS": "hating women, also MISOGYNISTIC, MISOGYNISTICAL [adj]\n",
  "MISOGYNY": "a hatred of women [n MISOGYNIES]\n",
  "MISOLOGIES": "MISOLOGY, a hatred of debate or reasoning [n]\n",
  "MISOLOGIST": "a hater of knowledge and enlightenment [n -S]\n",
  "MISOLOGISTS": "MISOLOGIST, a hater of knowledge and enlightenment [n]\n",
  "MISOLOGY": "a hatred of debate or reasoning [n MISOLOGIES]\n",
  "MISONEISM": "a hatred or fear of change or innovation [n -S]\n",
  "MISONEISMS": "MISONEISM, a hatred or fear of change or innovation [n]\n",
  "MISONEIST": "a hater of things which are new [n -S]\n",
  "MISONEISTIC": "relating to misoneism, a hatred of novelty [adj]\n",
  "MISONEISTS": "MISONEIST, a hater of things which are new [n]\n",
  "MISORDER": "to order incorrectly [v -ED, -ING, -S]\n",
  "MISORDERED": "MISORDER, to order incorrectly [v]\n",
  "MISORDERING": "MISORDER, to order incorrectly [v]\n",
  "MISORDERS": "MISORDER, to order incorrectly [v]\n",
  "MISORIENT": "to orient in a wrong direction [v -ED, -ING, -S]\n",
  "MISORIENTATION": "a wrong orientation [n -S]\n",
  "MISORIENTATIONS": "MISORIENTATION, a wrong orientation [n]\n",
  "MISORIENTED": "MISORIENT, to orient in a wrong direction [v]\n",
  "MISORIENTING": "MISORIENT, to orient in a wrong direction [v]\n",
  "MISORIENTS": "MISORIENT, to orient in a wrong direction [v]\n",
  "MISOS": "MISO, (Japanese) a paste, used in flavouring, prepared from soya beans and fermented in brine [n]\n",
  "MISPACKAGE": "to package incorrectly [v MISPACKAGED, MISPACKAGING, MISPACKAGES]\n",
  "MISPACKAGED": "MISPACKAGE, to package incorrectly [v]\n",
  "MISPACKAGES": "MISPACKAGE, to package incorrectly [v]\n",
  "MISPACKAGING": "MISPACKAGE, to package incorrectly [v]\n",
  "MISPAGE": "to page incorrectly [v MISPAGED, MISPAGING, MISPAGES]\n",
  "MISPAGED": "MISPAGE, to page incorrectly [v]\n",
  "MISPAGES": "MISPAGE, to page incorrectly [v]\n",
  "MISPAGING": "MISPAGE, to page incorrectly [v]\n",
  "MISPAINT": "to paint wrongly [v -ED, -ING, -S]\n",
  "MISPAINTED": "MISPAINT, to paint wrongly [v]\n",
  "MISPAINTING": "MISPAINT, to paint wrongly [v]\n",
  "MISPAINTS": "MISPAINT, to paint wrongly [v]\n",
  "MISPARSE": "to parse incorrectly [v MISPARSED, MISPARSING, MISPARSES]\n",
  "MISPARSED": "MISPARSE, to parse incorrectly [v]\n",
  "MISPARSES": "MISPARSE, to parse incorrectly [v]\n",
  "MISPARSING": "MISPARSE, to parse incorrectly [v]\n",
  "MISPART": "to part badly [v -ED, -ING, -S]\n",
  "MISPARTED": "MISPART, to part badly [v]\n",
  "MISPARTING": "MISPART, to part badly [v]\n",
  "MISPARTS": "MISPART, to part badly [v]\n",
  "MISPATCH": "to patch badly [v -ED, -ING, -ES]\n",
  "MISPATCHED": "MISPATCH, to patch badly [v]\n",
  "MISPATCHES": "MISPATCH, to patch badly [v]\n",
  "MISPATCHING": "MISPATCH, to patch badly [v]\n",
  "MISPEN": "to write incorrectly [v MISPENNED, MISPENNING, MISPENS]\n",
  "MISPENNED": "MISPEN, to write incorrectly [v]\n",
  "MISPENNING": "MISPEN, to write incorrectly [v]\n",
  "MISPENS": "MISPEN, to write incorrectly [v]\n",
  "MISPERCEIVE": "to perceive wrongly [v MISPERCEIVED, MISPERCEIVING, MISPERCEIVES]\n",
  "MISPERCEIVED": "MISPERCEIVE, to perceive wrongly [v]\n",
  "MISPERCEIVES": "MISPERCEIVE, to perceive wrongly [v]\n",
  "MISPERCEIVING": "MISPERCEIVE, to perceive wrongly [v]\n",
  "MISPERCEPTION": "a false perception [n -S]\n",
  "MISPERCEPTIONS": "MISPERCEPTION, a false perception [n]\n",
  "MISPERSUADE": "to persuade wrongly [v MISPERSUADED, MISPERSUADING, MISPERSUADES]\n",
  "MISPERSUADED": "MISPERSUADE, to persuade wrongly [v]\n",
  "MISPERSUADES": "MISPERSUADE, to persuade wrongly [v]\n",
  "MISPERSUADING": "MISPERSUADE, to persuade wrongly [v]\n",
  "MISPERSUASION": "a wrong persuasion [n -S]\n",
  "MISPERSUASIONS": "MISPERSUASION, a wrong persuasion [n]\n",
  "MISPHRASE": "to phrase wrongly [v MISPHRASED, MISPHRASING, MISPHRASES]\n",
  "MISPHRASED": "MISPHRASE, to phrase wrongly [v]\n",
  "MISPHRASES": "MISPHRASE, to phrase wrongly [v]\n",
  "MISPHRASING": "MISPHRASE, to phrase wrongly [v]\n",
  "MISPICKEL": "(German) arsenical iron pyrites, aka arsenopyrite [n -S]\n",
  "MISPICKELS": "MISPICKEL, (German) arsenical iron pyrites, aka arsenopyrite [n]\n",
  "MISPLACE": "to put in a wrong place [v MISPLACED, MISPLACING, MISPLACES]\n",
  "MISPLACED": "MISPLACE, to put in a wrong place [v]\n",
  "MISPLACEMENT": "the act of misplacing [n -S]\n",
  "MISPLACEMENTS": "MISPLACEMENT, the act of misplacing [n]\n",
  "MISPLACES": "MISPLACE, to put in a wrong place [v]\n",
  "MISPLACING": "MISPLACE, to put in a wrong place [v]\n",
  "MISPLAN": "to plan badly [v MISPLANNED, MISPLANNING, MISPLANS]\n",
  "MISPLANNED": "MISPLAN, to plan badly [v]\n",
  "MISPLANNING": "MISPLAN, to plan badly [v]\n",
  "MISPLANS": "MISPLAN, to plan badly [v]\n",
  "MISPLANT": "to plant wrongly [v -ED, -ING, -S]\n",
  "MISPLANTED": "MISPLANT, to plant wrongly [v]\n",
  "MISPLANTING": "MISPLANT, to plant wrongly [v]\n",
  "MISPLANTS": "MISPLANT, to plant wrongly [v]\n",
  "MISPLAY": "to make a bad play in a game [v -ED, -ING, -S]\n",
  "MISPLAYED": "MISPLAY, to make a bad play in a game [v]\n",
  "MISPLAYING": "MISPLAY, to make a bad play in a game [v]\n",
  "MISPLAYS": "MISPLAY, to make a bad play in a game [v]\n",
  "MISPLEAD": "to plead wrongly or falsely [v MISPLEADED or MISPLED, MISPLED, MISPLEADING, MISPLEADS]\n",
  "MISPLEADED": "MISPLEAD, to plead wrongly or falsely [v]\n",
  "MISPLEADING": "an error in pleading [n -S]\n",
  "MISPLEADINGS": "MISPLEADING, an error in pleading [n]\n",
  "MISPLEADS": "MISPLEAD, to plead wrongly or falsely [v]\n",
  "MISPLEASE": "(obsolete) to displease [v MISPLEASED, MISPLEASING, MISPLEASES]\n",
  "MISPLEASED": "MISPLEASE, (obsolete) to displease [v]\n",
  "MISPLEASES": "MISPLEASE, (obsolete) to displease [v]\n",
  "MISPLEASING": "MISPLEASE, (obsolete) to displease [v]\n",
  "MISPLED": "MISPLEAD, to plead wrongly or falsely [v]\n",
  "MISPOINT": "to point improperly [v -ED, -ING, -S]\n",
  "MISPOINTED": "MISPOINT, to point improperly [v]\n",
  "MISPOINTING": "MISPOINT, to point improperly [v]\n",
  "MISPOINTS": "MISPOINT, to point improperly [v]\n",
  "MISPOISE": "to poise incorrectly [v MISPOISED, MISPOISING, MISPOISES]\n",
  "MISPOISED": "MISPOISE, to poise incorrectly [v]\n",
  "MISPOISES": "MISPOISE, to poise incorrectly [v]\n",
  "MISPOISING": "MISPOISE, to poise incorrectly [v]\n",
  "MISPOSITION": "to position wrongly [v -ED, -ING, -S]\n",
  "MISPOSITIONED": "MISPOSITION, to position wrongly [v]\n",
  "MISPOSITIONING": "MISPOSITION, to position wrongly [v]\n",
  "MISPOSITIONS": "MISPOSITION, to position wrongly [v]\n",
  "MISPRAISE": "to praise amiss [v MISPRAISED, MISPRAISING, MISPRAISES]\n",
  "MISPRAISED": "MISPRAISE, to praise amiss [v]\n",
  "MISPRAISES": "MISPRAISE, to praise amiss [v]\n",
  "MISPRAISING": "MISPRAISE, to praise amiss [v]\n",
  "MISPRICE": "to price incorrectly [v MISPRICED, MISPRICING, MISPRICES]\n",
  "MISPRICED": "MISPRICE, to price incorrectly [v]\n",
  "MISPRICES": "MISPRICE, to price incorrectly [v]\n",
  "MISPRICING": "MISPRICE, to price incorrectly [v]\n",
  "MISPRINT": "to print incorrectly [v -ED, -ING, -S]\n",
  "MISPRINTED": "MISPRINT, to print incorrectly [v]\n",
  "MISPRINTING": "MISPRINT, to print incorrectly [v]\n",
  "MISPRINTS": "MISPRINT, to print incorrectly [v]\n",
  "MISPRISE": "to undervalue, also MISPRIZE [v MISPRISED, MISPRISING, MISPRISES]\n",
  "MISPRISED": "MISPRISE, to undervalue, also MISPRIZE [v]\n",
  "MISPRISES": "MISPRISE, to undervalue, also MISPRIZE [v]\n",
  "MISPRISING": "MISPRISE, to undervalue, also MISPRIZE [v]\n",
  "MISPRISION": "a wrongful act or omission; specifically a misdemeanour or failure of duty by a public official [n -S]\n",
  "MISPRISIONS": "MISPRISION, a wrongful act or omission; specifically a misdemeanour or failure of duty by a public official [n]\n",
  "MISPRIZE": "to undervalue, also MISPRISE [v MISPRIZED, MISPRIZING, MISPRIZES]\n",
  "MISPRIZED": "MISPRIZE, to undervalue, also MISPRISE [v]\n",
  "MISPRIZER": "one who misprizes [n -S]\n",
  "MISPRIZERS": "MISPRIZER, one who misprizes [n]\n",
  "MISPRIZES": "MISPRIZE, to undervalue, also MISPRISE [v]\n",
  "MISPRIZING": "MISPRIZE, to undervalue, also MISPRISE [v]\n",
  "MISPROGRAM": "to program incorrectly [v MISPROGRAMED or MISPROGRAMMED, MISPROGRAMING or MISPROGRAMMING, MISPROGRAMS]\n",
  "MISPROGRAMED": "MISPROGRAM, to program incorrectly [v]\n",
  "MISPROGRAMING": "MISPROGRAM, to program incorrectly [v]\n",
  "MISPROGRAMMED": "MISPROGRAM, to program incorrectly [v]\n",
  "MISPROGRAMMING": "MISPROGRAM, to program incorrectly [v]\n",
  "MISPROGRAMS": "MISPROGRAM, to program incorrectly [v]\n",
  "MISPRONOUNCE": "to pronounce incorrectly [v MISPRONOUNCED, MISPRONOUNCING, MISPRONOUNCES]\n",
  "MISPRONOUNCED": "MISPRONOUNCE, to pronounce incorrectly [v]\n",
  "MISPRONOUNCES": "MISPRONOUNCE, to pronounce incorrectly [v]\n",
  "MISPRONOUNCING": "MISPRONOUNCE, to pronounce incorrectly [v]\n",
  "MISPROPORTION": "to proportion wrongly [v -ED, -S]\n",
  "MISPROPORTIONED": "MISPROPORTION, to proportion wrongly [v]\n",
  "MISPROPORTIONS": "MISPROPORTION, to proportion wrongly [v]\n",
  "MISPROUD": "(archaic) unduly proud [adj]\n",
  "MISPUNCTUATE": "to punctuate wrongly [v MISPUNCTUATED, MISPUNCTUATING, MISPUNCTUATES]\n",
  "MISPUNCTUATED": "MISPUNCTUATE, to punctuate wrongly [v]\n",
  "MISPUNCTUATES": "MISPUNCTUATE, to punctuate wrongly [v]\n",
  "MISPUNCTUATING": "MISPUNCTUATE, to punctuate wrongly [v]\n",
  "MISPUNCTUATION": "a wrong punctuation [n -S]\n",
  "MISPUNCTUATIONS": "MISPUNCTUATION, a wrong punctuation [n]\n",
  "MISQUOTATION": "a wrong quotation [n -S]\n",
  "MISQUOTATIONS": "MISQUOTATION, a wrong quotation [n]\n",
  "MISQUOTE": "to quote incorrectly [v MISQUOTED, MISQUOTING, MISQUOTES]\n",
  "MISQUOTED": "MISQUOTE, to quote incorrectly [v]\n",
  "MISQUOTER": "one who misquotes [n -S]\n",
  "MISQUOTERS": "MISQUOTER, one who misquotes [n]\n",
  "MISQUOTES": "MISQUOTE, to quote incorrectly [v]\n",
  "MISQUOTING": "MISQUOTE, to quote incorrectly [v]\n",
  "MISRAISE": "to raise wrongly [v MISRAISED, MISRAISING, MISRAISES]\n",
  "MISRAISED": "MISRAISE, to raise wrongly [v]\n",
  "MISRAISES": "MISRAISE, to raise wrongly [v]\n",
  "MISRAISING": "MISRAISE, to raise wrongly [v]\n",
  "MISRATE": "to rate incorrectly [v MISRATED, MISRATING, MISRATES]\n",
  "MISRATED": "MISRATE, to rate incorrectly [v]\n",
  "MISRATES": "MISRATE, to rate incorrectly [v]\n",
  "MISRATING": "MISRATE, to rate incorrectly [v]\n",
  "MISREAD": "to read incorrectly [v MISREAD, MISREADING, MISREADS]\n",
  "MISREADING": "an incorrect reading [n -S]\n",
  "MISREADINGS": "MISREADING, an incorrect reading [n]\n",
  "MISREADS": "MISREAD, to read incorrectly [v]\n",
  "MISRECKON": "to reckon wrongly; to miscalculate [v -ED, -ING, -S]\n",
  "MISRECKONED": "MISRECKON, to reckon wrongly; to miscalculate [v]\n",
  "MISRECKONING": "a wrong reckoning [n -S]\n",
  "MISRECKONINGS": "MISRECKONING, a wrong reckoning [n]\n",
  "MISRECKONS": "MISRECKON, to reckon wrongly; to miscalculate [v]\n",
  "MISRECOLLECTION": "a false recollection [n]\n",
  "MISRECORD": "to record incorrectly [v -ED, -ING, -S]\n",
  "MISRECORDED": "MISRECORD, to record incorrectly [v]\n",
  "MISRECORDING": "MISRECORD, to record incorrectly [v]\n",
  "MISRECORDS": "MISRECORD, to record incorrectly [v]\n",
  "MISREFER": "to refer incorrectly [v MISREFERRED, MISREFERRING, MISREFERS]\n",
  "MISREFERENCE": "to reference inaccurately [v MISREFERENCED, MISREFERENCING, MISREFERENCES]\n",
  "MISREFERENCED": "MISREFERENCE, to reference inaccurately [v]\n",
  "MISREFERENCES": "MISREFERENCE, to reference inaccurately [v]\n",
  "MISREFERENCING": "MISREFERENCE, to reference inaccurately [v]\n",
  "MISREFERRED": "MISREFER, to refer incorrectly [v]\n",
  "MISREFERRING": "MISREFER, to refer incorrectly [v]\n",
  "MISREFERS": "MISREFER, to refer incorrectly [v]\n",
  "MISREGARD": "(Spenser) to have no regard for [v -ED, -ING, -S]\n",
  "MISREGARDED": "MISREGARD, (Spenser) to have no regard for [v]\n",
  "MISREGARDING": "MISREGARD, (Spenser) to have no regard for [v]\n",
  "MISREGARDS": "MISREGARD, (Spenser) to have no regard for [v]\n",
  "MISREGISTER": "to register wrongly [v -ED, -ING, -S]\n",
  "MISREGISTERED": "MISREGISTER, to register wrongly [v]\n",
  "MISREGISTERING": "MISREGISTER, to register wrongly [v]\n",
  "MISREGISTERS": "MISREGISTER, to register wrongly [v]\n",
  "MISREGISTRATION": "a wrong registration [n]\n",
  "MISRELATE": "to relate inaccurately [v MISRELATED, MISRELATING, MISRELATES]\n",
  "MISRELATED": "MISRELATE, to relate inaccurately [v]\n",
  "MISRELATES": "MISRELATE, to relate inaccurately [v]\n",
  "MISRELATING": "MISRELATE, to relate inaccurately [v]\n",
  "MISRELATION": "the act of misrelating [n -S]\n",
  "MISRELATIONS": "MISRELATION, the act of misrelating [n]\n",
  "MISRELIED": "MISRELY, to rely wrongly [v]\n",
  "MISRELIES": "MISRELY, to rely wrongly [v]\n",
  "MISRELY": "to rely wrongly [v MISRELIED, MISRELYING, MISRELIES]\n",
  "MISRELYING": "MISRELY, to rely wrongly [v]\n",
  "MISREMEMBER": "to remember wrongly [v -ED, -ING, -S]\n",
  "MISREMEMBERED": "MISREMEMBER, to remember wrongly [v]\n",
  "MISREMEMBERING": "MISREMEMBER, to remember wrongly [v]\n",
  "MISREMEMBERS": "MISREMEMBER, to remember wrongly [v]\n",
  "MISRENDER": "to render wrongly; to translate or recite wrongly [v -ED, -ING, -S]\n",
  "MISRENDERED": "MISRENDER, to render wrongly; to translate or recite wrongly [v]\n",
  "MISRENDERING": "MISRENDER, to render wrongly; to translate or recite wrongly [v]\n",
  "MISRENDERS": "MISRENDER, to render wrongly; to translate or recite wrongly [v]\n",
  "MISREPORT": "to report erroneously; to give an incorrect account of [v -ED, -ING, -S]\n",
  "MISREPORTED": "MISREPORT, to report erroneously; to give an incorrect account of [v]\n",
  "MISREPORTER": "one who misreports [n -S]\n",
  "MISREPORTERS": "MISREPORTER, one who misreports [n]\n",
  "MISREPORTING": "MISREPORT, to report erroneously; to give an incorrect account of [v]\n",
  "MISREPORTS": "MISREPORT, to report erroneously; to give an incorrect account of [v]\n",
  "MISREPRESENT": "to give a false or misleading representation of [v -ED, -ING, -S]\n",
  "MISREPRESENTED": "MISREPRESENT, to give a false or misleading representation of [v]\n",
  "MISREPRESENTER": "one who misrepresents [n -S]\n",
  "MISREPRESENTERS": "MISREPRESENTER, one who misrepresents [n]\n",
  "MISREPRESENTING": "MISREPRESENT, to give a false or misleading representation of [v]\n",
  "MISREPRESENTS": "MISREPRESENT, to give a false or misleading representation of [v]\n",
  "MISRHYMED": "badly rhymed [adj]\n",
  "MISROUTE": "to route incorrectly [v MISROUTED, MISROUTING or MISROUTEING, MISROUTES]\n",
  "MISROUTED": "MISROUTE, to route incorrectly [v]\n",
  "MISROUTEING": "MISROUTE, to route incorrectly [v]\n",
  "MISROUTES": "MISROUTE, to route incorrectly [v]\n",
  "MISROUTING": "MISROUTE, to route incorrectly [v]\n",
  "MISRULE": "to rule unwisely or unjustly [v MISRULED, MISRULING, MISRULES]\n",
  "MISRULED": "MISRULE, to rule unwisely or unjustly [v]\n",
  "MISRULES": "MISRULE, to rule unwisely or unjustly [v]\n",
  "MISRULING": "MISRULE, to rule unwisely or unjustly [v]\n",
  "MISS": "to fail to make contact with [v -ED, -ING, -ES]\n",
  "MISSA": "(Latin) the Mass [n MISSAE]\n",
  "MISSABLE": "able to be missed [adj]\n",
  "MISSAE": "MISSA, (Latin) the Mass [n]\n",
  "MISSAID": "MISSAY, to say incorrectly [v]\n",
  "MISSAL": "a book containing a complete service for mass [n -S]\n",
  "MISSALS": "MISSAL, a book containing a complete service for mass [n]\n",
  "MISSAW": "MISSEE, to see wrongly [v]\n",
  "MISSAY": "to say incorrectly [v MISSAID, MISSAYING, MISSAYS]\n",
  "MISSAYING": "the act of saying incorrectly [n -S]\n",
  "MISSAYINGS": "MISSAYING, the act of saying incorrectly [n]\n",
  "MISSAYS": "MISSAY, to say incorrectly [v]\n",
  "MISSEAT": "to seat wrongly [v -ED, -ING, -S]\n",
  "MISSEATED": "MISSEAT, to seat wrongly [v]\n",
  "MISSEATING": "MISSEAT, to seat wrongly [v]\n",
  "MISSEATS": "MISSEAT, to seat wrongly [v]\n",
  "MISSED": "MISS, to fail to make contact with [v]\n",
  "MISSEE": "to see wrongly [v MISSAW, MISSEEN, MISSEEING, MISSEES]\n",
  "MISSEEING": "MISSEE, to see wrongly [v]\n",
  "MISSEEM": "(Spenser) to be unbecoming to [v -ED, -ING, -S]\n",
  "MISSEEMED": "MISSEEM, (Spenser) to be unbecoming to [v]\n",
  "MISSEEMING": "(Spenser) a false appearance [n -S]\n",
  "MISSEEMINGS": "MISSEEMING, (Spenser) a false appearance [n]\n",
  "MISSEEMS": "MISSEEM, (Spenser) to be unbecoming to [v]\n",
  "MISSEEN": "MISSEE, to see wrongly [v]\n",
  "MISSEES": "MISSEE, to see wrongly [v]\n",
  "MISSEL": "the mistle-thrush [n -S]\n",
  "MISSELL": "to sell an inappropriate financial product, e.g. a personal pension [v MISSOLD, MISSELLING, MISSELLS]\n",
  "MISSELLING": "the act of selling an inappropriate financial product, e.g. a personal pension [n -S]\n",
  "MISSELLINGS": "MISSELLING, the act of selling an inappropriate financial product, e.g. a personal pension [n]\n",
  "MISSELLS": "MISSELL, to sell an inappropriate financial product, e.g. a personal pension [v]\n",
  "MISSELS": "MISSEL, the mistle-thrush [n]\n",
  "MISSEND": "to send incorrectly [v MISSENT, MISSENDING, MISSENDS]\n",
  "MISSENDING": "MISSEND, to send incorrectly [v]\n",
  "MISSENDS": "MISSEND, to send incorrectly [v]\n",
  "MISSENSE": "to sense wrongly [v MISSENSED, MISSENSING, MISSENSES]\n",
  "MISSENSED": "MISSENSE, to sense wrongly [v]\n",
  "MISSENSES": "MISSENSE, to sense wrongly [v]\n",
  "MISSENSING": "MISSENSE, to sense wrongly [v]\n",
  "MISSENT": "MISSEND, to send incorrectly [v]\n",
  "MISSES": "MISS, to fail to make contact with [v]\n",
  "MISSET": "to set incorrectly [v MISSET, MISSETTING, MISSETS]\n",
  "MISSETS": "MISSET, to set incorrectly [v]\n",
  "MISSETTING": "MISSET, to set incorrectly [v]\n",
  "MISSHAPE": "(Spenser) to shape badly [v MISSHAPED, MISSHAPEN, MISSHAPING, MISSHAPES]\n",
  "MISSHAPED": "MISSHAPE, (Spenser) to shape badly [v]\n",
  "MISSHAPEN": "MISSHAPE, (Spenser) to shape badly [v]\n",
  "MISSHAPENLY": "MISSHAPEN, MISSHAPE, (Spenser) to shape badly [adv]\n",
  "MISSHAPENNESS": "the state of being misshapen [n -ES]\n",
  "MISSHAPENNESSES": "MISSHAPENNESS, the state of being misshapen [n]\n",
  "MISSHAPER": "one who misshapes [n -S]\n",
  "MISSHAPERS": "MISSHAPER, one who misshapes [n]\n",
  "MISSHAPES": "MISSHAPE, (Spenser) to shape badly [v]\n",
  "MISSHAPING": "MISSHAPE, (Spenser) to shape badly [v]\n",
  "MISSHEATHED": "(Shakespeare) wrongly sheathed [adj]\n",
  "MISSHOD": "improperly shod [adj]\n",
  "MISSHOOD": "the state of being a miss [n -S]\n",
  "MISSHOODS": "MISSHOOD, the state of being a miss [n]\n",
  "MISSIER": "MISSY, like a miss [adj]\n",
  "MISSIES": "MISSY, a young girl [n]\n",
  "MISSIEST": "MISSY, like a miss [adj]\n",
  "MISSILE": "an object or weapon that is thrown or projected [n -S]\n",
  "MISSILEER": "one responsible for the firing of missiles [n -S]\n",
  "MISSILEERS": "MISSILEER, one responsible for the firing of missiles [n]\n",
  "MISSILEMAN": "one engaged in designing, building, or operating guided missiles [n MISSILEMEN]\n",
  "MISSILEMEN": "MISSILEMAN, one engaged in designing, building, or operating guided missiles [n]\n",
  "MISSILERIES": "MISSILERY, missiles collectively, also MISSILRY [n]\n",
  "MISSILERY": "missiles collectively, also MISSILRY [n MISSILERIES]\n",
  "MISSILES": "MISSILE, an object or weapon that is thrown or projected [n]\n",
  "MISSILRIES": "MISSILRY, missiles collectively, also MISSILERY [n]\n",
  "MISSILRY": "missiles collectively, also MISSILERY [n MISSILRIES]\n",
  "MISSING": "MISS, to fail to make contact with [v]\n",
  "MISSINGLY": "(Shakespeare) with a sense of loss [adv]\n",
  "MISSIOLOGIES": "MISSIOLOGY, the study of the church's mission esp. with respect to missionary activity [n]\n",
  "MISSIOLOGY": "the study of the church's mission esp. with respect to missionary activity [n MISSIOLOGIES]\n",
  "MISSION": "to send to perform a specific task [v -ED, -ING, -S]\n",
  "MISSIONAL": "emphasising preaching of the gospel [adj]\n",
  "MISSIONARIES": "MISSIONARY, a person undertaking a mission and esp. a religious mission [n]\n",
  "MISSIONARISE": "to do missionary work, also MISSIONARIZE, MISSIONISE, MISSIONIZE [v MISSIONARISED, MISSIONARISING, MISSIONARISES]\n",
  "MISSIONARISED": "MISSIONARISE, to do missionary work, also MISSIONARIZE, MISSIONISE, MISSIONIZE [v]\n",
  "MISSIONARISES": "MISSIONARISE, to do missionary work, also MISSIONARIZE, MISSIONISE, MISSIONIZE [v]\n",
  "MISSIONARISING": "MISSIONARISE, to do missionary work, also MISSIONARIZE, MISSIONISE, MISSIONIZE [v]\n",
  "MISSIONARIZE": "to do missionary work, also MISSIONARISE, MISSIONISE, MISSIONIZE [v MISSIONARIZED, MISSIONARIZING, MISSIONARIZES]\n",
  "MISSIONARIZED": "MISSIONARIZE, to do missionary work, also MISSIONARISE, MISSIONISE, MISSIONIZE [v]\n",
  "MISSIONARIZES": "MISSIONARIZE, to do missionary work, also MISSIONARISE, MISSIONISE, MISSIONIZE [v]\n",
  "MISSIONARIZING": "MISSIONARIZE, to do missionary work, also MISSIONARISE, MISSIONISE, MISSIONIZE [v]\n",
  "MISSIONARY": "a person undertaking a mission and esp. a religious mission [n MISSIONARIES]\n",
  "MISSIONED": "MISSION, to send to perform a specific task [v]\n",
  "MISSIONER": "a missionary; an envoy; one who conducts a mission [n -S]\n",
  "MISSIONERS": "MISSIONER, a missionary; an envoy; one who conducts a mission [n]\n",
  "MISSIONING": "MISSION, to send to perform a specific task [v]\n",
  "MISSIONISATION": "the act of missionising, also MISSIONIZATION [n -S]\n",
  "MISSIONISATIONS": "MISSIONISATION, the act of missionising, also MISSIONIZATION [n]\n",
  "MISSIONISE": "to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONIZE [v MISSIONISED, MISSIONISING, MISSIONISES]\n",
  "MISSIONISED": "MISSIONISE, to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONIZE [v]\n",
  "MISSIONISER": "one who does missionary work, also MISSIONIZER [n -S]\n",
  "MISSIONISERS": "MISSIONISER, one who does missionary work, also MISSIONIZER [n]\n",
  "MISSIONISES": "MISSIONISE, to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONIZE [v]\n",
  "MISSIONISING": "MISSIONISE, to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONIZE [v]\n",
  "MISSIONIZATION": "the act of missionizing, also MISSIONISATION [n -S]\n",
  "MISSIONIZATIONS": "MISSIONIZATION, the act of missionizing, also MISSIONISATION [n]\n",
  "MISSIONIZE": "to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONISE [v MISSIONIZED, MISSIONIZING, MISSIONIZES]\n",
  "MISSIONIZED": "MISSIONIZE, to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONISE [v]\n",
  "MISSIONIZER": "one who does missionary work, also MISSIONISER [n -S]\n",
  "MISSIONIZERS": "MISSIONIZER, one who does missionary work, also MISSIONISER [n]\n",
  "MISSIONIZES": "MISSIONIZE, to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONISE [v]\n",
  "MISSIONIZING": "MISSIONIZE, to do missionary work, also MISSIONARISE, MISSIONARIZE, MISSIONISE [v]\n",
  "MISSIONS": "MISSION, to send to perform a specific task [v]\n",
  "MISSIS": "(colloquial) wife, also MISSUS [n -ES]\n",
  "MISSISES": "MISSIS, (colloquial) wife, also MISSUS [n]\n",
  "MISSISH": "schoolgirlish [adj]\n",
  "MISSISHNESS": "the state of being missish, like a miss [n -ES]\n",
  "MISSISHNESSES": "MISSISHNESS, the state of being missish, like a miss [n]\n",
  "MISSIVE": "a written communication [n -S]\n",
  "MISSIVES": "MISSIVE, a written communication [n]\n",
  "MISSOLD": "MISSELL, to sell an inappropriate financial product, e.g. a personal pension [v]\n",
  "MISSORT": "to sort badly or improperly [v -ED, -ING, -S]\n",
  "MISSORTED": "MISSORT, to sort badly or improperly [v]\n",
  "MISSORTING": "MISSORT, to sort badly or improperly [v]\n",
  "MISSORTS": "MISSORT, to sort badly or improperly [v]\n",
  "MISSOUND": "to sound wrongly [v -ED, -ING, -S]\n",
  "MISSOUNDED": "MISSOUND, to sound wrongly [v]\n",
  "MISSOUNDING": "MISSOUND, to sound wrongly [v]\n",
  "MISSOUNDS": "MISSOUND, to sound wrongly [v]\n",
  "MISSOUT": "a losing throw of dice [n -S]\n",
  "MISSOUTS": "MISSOUT, a losing throw of dice [n]\n",
  "MISSPACE": "to space incorrectly [v MISSPACED, MISSPACING, MISSPACES]\n",
  "MISSPACED": "MISSPACE, to space incorrectly [v]\n",
  "MISSPACES": "MISSPACE, to space incorrectly [v]\n",
  "MISSPACING": "MISSPACE, to space incorrectly [v]\n",
  "MISSPEAK": "to speak incorrectly [v MISSPOKE, MISSPOKEN, MISSPEAKING, MISSPEAKS]\n",
  "MISSPEAKING": "MISSPEAK, to speak incorrectly [v]\n",
  "MISSPEAKS": "MISSPEAK, to speak incorrectly [v]\n",
  "MISSPELL": "to spell incorrectly [v MISSPELLED, MISSPELT, MISSPELLING, MISSPELLS]\n",
  "MISSPELLED": "MISSPELL, to spell incorrectly [v]\n",
  "MISSPELLING": "a wrong spelling [n -S]\n",
  "MISSPELLINGS": "MISSPELLING, a wrong spelling [n]\n",
  "MISSPELLS": "MISSPELL, to spell incorrectly [v]\n",
  "MISSPELT": "MISSPELL, to spell incorrectly [v]\n",
  "MISSPEND": "to spend unwisely [v MISSPENT, MISSPENDING, MISSPENDS]\n",
  "MISSPENDER": "one who misspends [n -S]\n",
  "MISSPENDERS": "MISSPENDER, one who misspends [n]\n",
  "MISSPENDING": "MISSPEND, to spend unwisely [v]\n",
  "MISSPENDS": "MISSPEND, to spend unwisely [v]\n",
  "MISSPENT": "MISSPEND, to spend unwisely [v]\n",
  "MISSPOKE": "MISSPEAK, to speak incorrectly [v]\n",
  "MISSPOKEN": "MISSPEAK, to speak incorrectly [v]\n",
  "MISSTAMP": "to stamp wrongly [v -ED, -ING, -S]\n",
  "MISSTAMPED": "MISSTAMP, to stamp wrongly [v]\n",
  "MISSTAMPING": "MISSTAMP, to stamp wrongly [v]\n",
  "MISSTAMPS": "MISSTAMP, to stamp wrongly [v]\n",
  "MISSTART": "to start off badly [v -ED, -ING, -S]\n",
  "MISSTARTED": "MISSTART, to start off badly [v]\n",
  "MISSTARTING": "MISSTART, to start off badly [v]\n",
  "MISSTARTS": "MISSTART, to start off badly [v]\n",
  "MISSTATE": "to state wrongly [v MISSTATED, MISSTATING, MISSTATES]\n",
  "MISSTATED": "MISSTATE, to state wrongly [v]\n",
  "MISSTATEMENT": "a false statement [n -S]\n",
  "MISSTATEMENTS": "MISSTATEMENT, a false statement [n]\n",
  "MISSTATES": "MISSTATE, to state wrongly [v]\n",
  "MISSTATING": "MISSTATE, to state wrongly [v]\n",
  "MISSTEER": "to steer wrongly [v -ED, -ING, -S]\n",
  "MISSTEERED": "MISSTEER, to steer wrongly [v]\n",
  "MISSTEERING": "MISSTEER, to steer wrongly [v]\n",
  "MISSTEERS": "MISSTEER, to steer wrongly [v]\n",
  "MISSTEP": "to make a wrong step [v MISSTEPPED, MISSTEPPING, MISSTEPS]\n",
  "MISSTEPPED": "MISSTEP, to make a wrong step [v]\n",
  "MISSTEPPING": "MISSTEP, to make a wrong step [v]\n",
  "MISSTEPS": "MISSTEP, to make a wrong step [v]\n",
  "MISSTOP": "to stop wrongly [v MISSTOPPED, MISSTOPPING, MISSTOPS]\n",
  "MISSTOPPED": "MISSTOP, to stop wrongly [v]\n",
  "MISSTOPPING": "MISSTOP, to stop wrongly [v]\n",
  "MISSTOPS": "MISSTOP, to stop wrongly [v]\n",
  "MISSTRICKEN": "MISSTRIKE, to strike wrongly [v]\n",
  "MISSTRIKE": "to strike wrongly [v MISSTRUCK, MISSTRICKEN, MISSTRIKING, MISSTRIKES]\n",
  "MISSTRIKES": "MISSTRIKE, to strike wrongly [v]\n",
  "MISSTRIKING": "MISSTRIKE, to strike wrongly [v]\n",
  "MISSTRUCK": "MISSTRIKE, to strike wrongly [v]\n",
  "MISSTYLE": "to style wrongly [v MISSTYLED, MISSTYLING, MISSTYLES]\n",
  "MISSTYLED": "MISSTYLE, to style wrongly [v]\n",
  "MISSTYLES": "MISSTYLE, to style wrongly [v]\n",
  "MISSTYLING": "MISSTYLE, to style wrongly [v]\n",
  "MISSUIT": "to suit badly [v -ED, -ING, -S]\n",
  "MISSUITED": "MISSUIT, to suit badly [v]\n",
  "MISSUITING": "MISSUIT, to suit badly [v]\n",
  "MISSUITS": "MISSUIT, to suit badly [v]\n",
  "MISSUMMATION": "wrong addition [n -S]\n",
  "MISSUMMATIONS": "MISSUMMATION, wrong addition [n]\n",
  "MISSUS": "(colloquial) a wife, also MISSIS [n -ES]\n",
  "MISSUSES": "MISSUS, (colloquial) a wife, also MISSIS [n]\n",
  "MISSY": "a young girl [n MISSIES] / like a miss [adj MISSIER, MISSIEST]\n",
  "MIST": "watery vapour seen in the atmosphere [n -S] / to become blurry [v -ED, -ING, -S]\n",
  "MISTAKABLE": "liable to be mistaken, also MISTAKEABLE [adj MISTAKABLY]\n",
  "MISTAKABLY": "MISTAKABLE, liable to be mistaken, also MISTAKEABLE [adv]\n",
  "MISTAKE": "to interpret wrongly [v MISTOOK or (obsolete) MISTEUK, MISTAKEN, MISTAKING, MISTAKES]\n",
  "MISTAKEABLE": "liable to be mistaken, also MISTAKABLE [adj MISTAKEABLY]\n",
  "MISTAKEABLY": "MISTAKEABLE, liable to be mistaken, also MISTAKABLE [adv]\n",
  "MISTAKEN": "MISTAKE, to interpret wrongly [v]\n",
  "MISTAKENLY": "MISTAKEN, MISTAKE, to interpret wrongly [adv]\n",
  "MISTAKENNESS": "the state of being mistaken [n -ES]\n",
  "MISTAKENNESSES": "MISTAKENNESS, the state of being mistaken [n]\n",
  "MISTAKER": "one who makes a mistake [n -S]\n",
  "MISTAKERS": "MISTAKER, one who makes a mistake [n]\n",
  "MISTAKES": "MISTAKE, to interpret wrongly [v]\n",
  "MISTAKING": "(Shakespeare) a mistake [n -S]\n",
  "MISTAKINGS": "MISTAKING, (Shakespeare) a mistake [n]\n",
  "MISTAL": "(English dialect) a cow shed [n -S]\n",
  "MISTALS": "MISTAL, (English dialect) a cow shed [n]\n",
  "MISTAUGHT": "MISTEACH, to teach wrongly or badly [v]\n",
  "MISTBOW": "a whitish arch like a rainbow, seen in mist, aka fogbow [n -S]\n",
  "MISTBOWS": "MISTBOW, a whitish arch like a rainbow, seen in mist, aka fogbow [n]\n",
  "MISTEACH": "to teach wrongly or badly [v MISTAUGHT, MISTEACHING, MISTEACHES]\n",
  "MISTEACHES": "MISTEACH, to teach wrongly or badly [v]\n",
  "MISTEACHING": "MISTEACH, to teach wrongly or badly [v]\n",
  "MISTED": "MIST, to become blurry [v]\n",
  "MISTELL": "to inform wrongly [v MISTOLD, MISTELLING, MISTELLS]\n",
  "MISTELLING": "MISTELL, to inform wrongly [v]\n",
  "MISTELLS": "MISTELL, to inform wrongly [v]\n",
  "MISTEMPER": "(obsolete) to temper ill; to disorder [v -ED, -ING, -S]\n",
  "MISTEMPERED": "MISTEMPER, (obsolete) to temper ill; to disorder [v]\n",
  "MISTEMPERING": "MISTEMPER, (obsolete) to temper ill; to disorder [v]\n",
  "MISTEMPERS": "MISTEMPER, (obsolete) to temper ill; to disorder [v]\n",
  "MISTEND": "to tend to improperly [v -ED, -ING, -S]\n",
  "MISTENDED": "MISTEND, to tend to improperly [v]\n",
  "MISTENDING": "MISTEND, to tend to improperly [v]\n",
  "MISTENDS": "MISTEND, to tend to improperly [v]\n",
  "MISTER": "to address as mister [v -ED, -ING, -S]\n",
  "MISTERED": "MISTER, to address as mister [v]\n",
  "MISTERIES": "MISTERY, mystery, in the sense of craft, trade [n]\n",
  "MISTERING": "MISTER, to address as mister [v]\n",
  "MISTERM": "to call by a wrong name [v -ED, -ING, -S]\n",
  "MISTERMED": "MISTERM, to call by a wrong name [v]\n",
  "MISTERMING": "MISTERM, to call by a wrong name [v]\n",
  "MISTERMS": "MISTERM, to call by a wrong name [v]\n",
  "MISTERS": "MISTER, to address as mister [v]\n",
  "MISTERY": "mystery, in the sense of craft, trade [n MISTERIES]\n",
  "MISTEUK": "MISTAKE, to interpret wrongly [v]\n",
  "MISTFUL": "clouded with, or as with, mist [adj]\n",
  "MISTHINK": "to think wrongly [v MISTHOUGHT, MISTHINKING, MISTHINKS]\n",
  "MISTHINKING": "MISTHINK, to think wrongly [v]\n",
  "MISTHINKS": "MISTHINK, to think wrongly [v]\n",
  "MISTHOUGHT": "a wrong thought [n -S]\n",
  "MISTHOUGHTS": "MISTHOUGHT, a wrong thought [n]\n",
  "MISTHREW": "MISTHROW, to throw errantly [v]\n",
  "MISTHROW": "to throw errantly [v MISTHREW, MISTHROWN, MISTHROWING, MISTHROWS]\n",
  "MISTHROWING": "MISTHROW, to throw errantly [v]\n",
  "MISTHROWN": "MISTHROW, to throw errantly [v]\n",
  "MISTHROWS": "MISTHROW, to throw errantly [v]\n",
  "MISTICO": "(Spanish) a kind of small sailing vessel used in the Mediterranean, rigged partly like a xebec, and partly like a felucca [n -S]\n",
  "MISTICOS": "MISTICO, (Spanish) a kind of small sailing vessel used in the Mediterranean, rigged partly like a xebec, and partly like a felucca [n]\n",
  "MISTIER": "MISTY, blurry [adj]\n",
  "MISTIEST": "MISTY, blurry [adj]\n",
  "MISTIGRIS": "(French) a variation of poker in which a joker or blank card can be given any value [n -ES]\n",
  "MISTIGRISES": "MISTIGRIS, (French) a variation of poker in which a joker or blank card can be given any value [n]\n",
  "MISTILY": "MISTY, blurry [adv]\n",
  "MISTIME": "to time wrongly [v MISTIMED, MISTIMING, MISTIMES]\n",
  "MISTIMED": "MISTIME, to time wrongly [v]\n",
  "MISTIMES": "MISTIME, to time wrongly [v]\n",
  "MISTIMING": "the act of timing wrongly [n -S]\n",
  "MISTIMINGS": "MISTIMING, the act of timing wrongly [n]\n",
  "MISTINESS": "the state of being misty [n -ES]\n",
  "MISTINESSES": "MISTINESS, the state of being misty [n]\n",
  "MISTING": "mist, mistiness [n -S]\n",
  "MISTINGS": "MISTING, mist, mistiness [n]\n",
  "MISTITLE": "to call by the wrong title [v MISTITLED, MISTITLING, MISTITLES]\n",
  "MISTITLED": "MISTITLE, to call by the wrong title [v]\n",
  "MISTITLES": "MISTITLE, to call by the wrong title [v]\n",
  "MISTITLING": "MISTITLE, to call by the wrong title [v]\n",
  "MISTLE": "to rain in small drops [v MISTLED, MISTLING, MISTLES]\n",
  "MISTLED": "MISTLE, to rain in small drops [v]\n",
  "MISTLES": "MISTLE, to rain in small drops [v]\n",
  "MISTLETOE": "a Eurasian evergreen shrub, with leathery leaves, yellowish flowers, and waxy white berries, grows as a partial parasite on various trees, also MISLETOE [n -S]\n",
  "MISTLETOES": "MISTLETOE, a Eurasian evergreen shrub, with leathery leaves, yellowish flowers, and waxy white berries, grows as a partial parasite on various trees, also MISLETOE [n]\n",
  "MISTLING": "MISTLE, to rain in small drops [v]\n",
  "MISTOLD": "MISTELL, to inform wrongly [v]\n",
  "MISTOOK": "MISTAKE, to interpret wrongly [v]\n",
  "MISTOUCH": "to touch improperly [v -ED, -ING, -ES]\n",
  "MISTOUCHED": "MISTOUCH, to touch improperly [v]\n",
  "MISTOUCHES": "MISTOUCH, to touch improperly [v]\n",
  "MISTOUCHING": "MISTOUCH, to touch improperly [v]\n",
  "MISTRACE": "to trace wrongly [v MISTRACED, MISTRACING, MISTRACES]\n",
  "MISTRACED": "MISTRACE, to trace wrongly [v]\n",
  "MISTRACES": "MISTRACE, to trace wrongly [v]\n",
  "MISTRACING": "MISTRACE, to trace wrongly [v]\n",
  "MISTRAIN": "to train improperly [v -ED, -ING, -S]\n",
  "MISTRAINED": "MISTRAIN, to train improperly [v]\n",
  "MISTRAINING": "MISTRAIN, to train improperly [v]\n",
  "MISTRAINS": "MISTRAIN, to train improperly [v]\n",
  "MISTRAL": "(French) a strong cold dry northeast wind that blows through the Rhone valley towards the Mediterranean [n -S]\n",
  "MISTRALS": "MISTRAL, (French) a strong cold dry northeast wind that blows through the Rhone valley towards the Mediterranean [n]\n",
  "MISTRANSCRIBE": "to transcribe wrongly [v MISTRANSCRIBED, MISTRANSCRIBING, MISTRANSCRIBES]\n",
  "MISTRANSCRIBED": "MISTRANSCRIBE, to transcribe wrongly [v]\n",
  "MISTRANSCRIBES": "MISTRANSCRIBE, to transcribe wrongly [v]\n",
  "MISTRANSCRIBING": "MISTRANSCRIBE, to transcribe wrongly [v]\n",
  "MISTRANSLATE": "to translate wrongly [v MISTRANSLATED, MISTRANSLATING, MISTRANSLATES]\n",
  "MISTRANSLATED": "MISTRANSLATE, to translate wrongly [v]\n",
  "MISTRANSLATES": "MISTRANSLATE, to translate wrongly [v]\n",
  "MISTRANSLATING": "MISTRANSLATE, to translate wrongly [v]\n",
  "MISTRANSLATION": "an erroneous translation [n -S]\n",
  "MISTRANSLATIONS": "MISTRANSLATION, an erroneous translation [n]\n",
  "MISTRAYNED": "(Spenser) drawn away, misled [adj]\n",
  "MISTREADING": "(Shakespeare) a false step, a misdeed [n -S]\n",
  "MISTREADINGS": "MISTREADING, (Shakespeare) a false step, a misdeed [n]\n",
  "MISTREAT": "to treat badly [v -ED, -ING, -S]\n",
  "MISTREATED": "MISTREAT, to treat badly [v]\n",
  "MISTREATING": "MISTREAT, to treat badly [v]\n",
  "MISTREATMENT": "wrong treatment [n -S]\n",
  "MISTREATMENTS": "MISTREATMENT, wrong treatment [n]\n",
  "MISTREATS": "MISTREAT, to treat badly [v]\n",
  "MISTRESS": "a woman employer of servants or head of a house or family [n -ES] / to make a mistress of [v -ED, -ING, -ES]\n",
  "MISTRESSED": "MISTRESS, to make a mistress of [v]\n",
  "MISTRESSES": "MISTRESS, to make a mistress of [v]\n",
  "MISTRESSING": "MISTRESS, to make a mistress of [v]\n",
  "MISTRESSLESS": "without a mistress [adj]\n",
  "MISTRESSLIER": "MISTRESSLY, like a mistress [adj]\n",
  "MISTRESSLIEST": "MISTRESSLY, like a mistress [adj]\n",
  "MISTRESSLY": "like a mistress [adj MISTRESSLIER, MISTRESSLIEST]\n",
  "MISTRIAL": "a trial made invalid because of some error in procedure [n -S]\n",
  "MISTRIALS": "MISTRIAL, a trial made invalid because of some error in procedure [n]\n",
  "MISTRUST": "to have no trust in, also DISTRUST [v -ED, -ING, -S]\n",
  "MISTRUSTED": "MISTRUST, to have no trust in, also DISTRUST [v]\n",
  "MISTRUSTER": "one who mistrusts [n -S]\n",
  "MISTRUSTERS": "MISTRUSTER, one who mistrusts [n]\n",
  "MISTRUSTFUL": "not trusting [adj MISTRUSTFULLY]\n",
  "MISTRUSTFULLY": "MISTRUSTFUL, not trusting [adv]\n",
  "MISTRUSTFULNESS": "MISTRUSTFUL, not trusting [n]\n",
  "MISTRUSTING": "MISTRUST, to have no trust in, also DISTRUST [v]\n",
  "MISTRUSTINGLY": "MISTRUSTING, MISTRUST, to have no trust in, also DISTRUST [adv]\n",
  "MISTRUSTLESS": "without mistrust [adj]\n",
  "MISTRUSTS": "MISTRUST, to have no trust in, also DISTRUST [v]\n",
  "MISTRUTH": "a lie [n -S]\n",
  "MISTRUTHS": "MISTRUTH, a lie [n]\n",
  "MISTRYST": "(Scots) to fail to keep an appointment with [v -ED, -ING, -S]\n",
  "MISTRYSTED": "MISTRYST, (Scots) to fail to keep an appointment with [v]\n",
  "MISTRYSTING": "MISTRYST, (Scots) to fail to keep an appointment with [v]\n",
  "MISTRYSTS": "MISTRYST, (Scots) to fail to keep an appointment with [v]\n",
  "MISTS": "MIST, to become blurry [v]\n",
  "MISTUNE": "to tune incorrectly [v MISTUNED, MISTUNING, MISTUNES]\n",
  "MISTUNED": "MISTUNE, to tune incorrectly [v]\n",
  "MISTUNES": "MISTUNE, to tune incorrectly [v]\n",
  "MISTUNING": "MISTUNE, to tune incorrectly [v]\n",
  "MISTUTOR": "to instruct badly [v -ED, -ING, -S]\n",
  "MISTUTORED": "MISTUTOR, to instruct badly [v]\n",
  "MISTUTORING": "MISTUTOR, to instruct badly [v]\n",
  "MISTUTORS": "MISTUTOR, to instruct badly [v]\n",
  "MISTY": "blurry [adj MISTIER, MISTIEST, MISTILY]\n",
  "MISTYPE": "to type incorrectly [v MISTYPED, MISTYPING, MISTYPES]\n",
  "MISTYPED": "MISTYPE, to type incorrectly [v]\n",
  "MISTYPES": "MISTYPE, to type incorrectly [v]\n",
  "MISTYPING": "MISTYPE, to type incorrectly [v]\n",
  "MISUNDERSTAND": "to fail to understand [v MISUNDERSTOOD, MISUNDERSTANDS]\n",
  "MISUNDERSTANDS": "MISUNDERSTAND, to fail to understand [v]\n",
  "MISUNDERSTOOD": "MISUNDERSTAND, to fail to understand [v]\n",
  "MISUNION": "a bad union [n -S]\n",
  "MISUNIONS": "MISUNION, a bad union [n]\n",
  "MISUSAGE": "incorrect use [n -S]\n",
  "MISUSAGES": "MISUSAGE, incorrect use [n]\n",
  "MISUSE": "to use incorrectly [v MISUSED, MISUSING, MISUSES]\n",
  "MISUSED": "MISUSE, to use incorrectly [v]\n",
  "MISUSER": "one who misuses [n -S]\n",
  "MISUSERS": "MISUSER, one who misuses [n]\n",
  "MISUSES": "MISUSE, to use incorrectly [v]\n",
  "MISUSING": "MISUSE, to use incorrectly [v]\n",
  "MISUST": "(Spenser) misused [v]\n",
  "MISUTILISATION": "a wrong utilisation, also MISUTILIZATION [n -S]\n",
  "MISUTILISATIONS": "MISUTILISATION, a wrong utilisation, also MISUTILIZATION [n]\n",
  "MISUTILIZATION": "a wrong utilization, also MISUTILISATION [n -S]\n",
  "MISUTILIZATIONS": "MISUTILIZATION, a wrong utilization, also MISUTILISATION [n]\n",
  "MISVALUE": "to value incorrectly [v MISVALUED, MISVALUING, MISVALUES]\n",
  "MISVALUED": "MISVALUE, to value incorrectly [v]\n",
  "MISVALUES": "MISVALUE, to value incorrectly [v]\n",
  "MISVALUING": "MISVALUE, to value incorrectly [v]\n",
  "MISVENTURE": "a misadventure, also MISADVENTURE [n -S]\n",
  "MISVENTURES": "MISVENTURE, a misadventure, also MISADVENTURE [n]\n",
  "MISVENTUROUS": "like a misventure [adj]\n",
  "MISVOCALISATION": "an incorrect vocalisation, also MISVOCALIZATION [n]\n",
  "MISVOCALIZATION": "an incorrect vocalization, also MISVOCALISATION [n]\n",
  "MISWANDRED": "(Spenser) strayed, gone astray [adj]\n",
  "MISWEEN": "(Spenser) to judge wrongly [v -ED, -ING, -S]\n",
  "MISWEENED": "MISWEEN, (Spenser) to judge wrongly [v]\n",
  "MISWEENING": "MISWEEN, (Spenser) to judge wrongly [v]\n",
  "MISWEENS": "MISWEEN, (Spenser) to judge wrongly [v]\n",
  "MISWEND": "(Spenser) to go wrong; to go astray [v MISWENT, MISWENDING, MISWENDS]\n",
  "MISWENDING": "MISWEND, (Spenser) to go wrong; to go astray [v]\n",
  "MISWENDS": "MISWEND, (Spenser) to go wrong; to go astray [v]\n",
  "MISWENT": "MISGO, (dialect) to go astray [v]\n",
  "MISWORD": "to word wrongly [v -ED, -ING, -S]\n",
  "MISWORDED": "MISWORD, to word wrongly [v]\n",
  "MISWORDING": "a wrong wording [n -S]\n",
  "MISWORDINGS": "MISWORDING, a wrong wording [n]\n",
  "MISWORDS": "MISWORD, to word wrongly [v]\n",
  "MISWORSHIP": "to worship in a false way [v MISWORSHIPPED, MISWORSHIPPING, MISWORSHIPS]\n",
  "MISWORSHIPPED": "MISWORSHIP, to worship in a false way [v]\n",
  "MISWORSHIPPING": "worshipping in a false way [n -S]\n",
  "MISWORSHIPPINGS": "MISWORSHIPPING, worshipping in a false way [n]\n",
  "MISWORSHIPS": "MISWORSHIP, to worship in a false way [v]\n",
  "MISWRIT": "MISWRITE, to write incorrectly [v]\n",
  "MISWRITE": "to write incorrectly [v MISWROTE, MISWRIT or MISWRITTEN, MISWRITING, MISWRITES]\n",
  "MISWRITES": "MISWRITE, to write incorrectly [v]\n",
  "MISWRITING": "MISWRITE, to write incorrectly [v]\n",
  "MISWRITTEN": "MISWRITE, to write incorrectly [v]\n",
  "MISWROTE": "MISWRITE, to write incorrectly [v]\n",
  "MISYOKE": "to yoke improperly [v MISYOKED, MISYOKING, MISYOKES]\n",
  "MISYOKED": "MISYOKE, to yoke improperly [v]\n",
  "MISYOKES": "MISYOKE, to yoke improperly [v]\n",
  "MISYOKING": "MISYOKE, to yoke improperly [v]\n",
  "MITCH": "to play truant, also MICH, MICHE [v -ED, -ING, -ES]\n",
  "MITCHED": "MITCH, to play truant, also MICH, MICHE [v]\n",
  "MITCHES": "MITCH, to play truant, also MICH, MICHE [v]\n",
  "MITCHING": "MITCH, to play truant, also MICH, MICHE [v]\n",
  "MITE": "any of various tiny arachnids of the order Acarida [n -S]\n",
  "MITER": "(US) to join with a type of woodworking joint, also MITRE [v -ED, -ING, -S]\n",
  "MITERED": "MITER, (US) to join with a type of woodworking joint, also MITRE [v]\n",
  "MITERER": "one that miters [n -S]\n",
  "MITERERS": "MITERER, one that miters [n]\n",
  "MITERING": "MITER, (US) to join with a type of woodworking joint, also MITRE [v]\n",
  "MITERS": "MITER, (US) to join with a type of woodworking joint, also MITRE [v]\n",
  "MITERWORT": "a slender, perennial herb with a pod slightly resembling a bishop's miter, also MITREWORT [n -S]\n",
  "MITERWORTS": "MITERWORT, a slender, perennial herb with a pod slightly resembling a bishop's miter, also MITREWORT [n]\n",
  "MITES": "MITE, any of various tiny arachnids of the order Acarida [n]\n",
  "MITHER": "to confuse, stupefy, also MOIDER, MOITHER [v -ED, -ING, -S]\n",
  "MITHERED": "MITHER, to confuse, stupefy, also MOIDER, MOITHER [v]\n",
  "MITHERING": "MITHER, to confuse, stupefy, also MOIDER, MOITHER [v]\n",
  "MITHERS": "MITHER, to confuse, stupefy, also MOIDER, MOITHER [v]\n",
  "MITHRADATIC": "antidotal, also MITHRIDATIC [adj]\n",
  "MITHRIDATE": "an antidote against poison [n -S]\n",
  "MITHRIDATES": "MITHRIDATE, an antidote against poison [n]\n",
  "MITHRIDATIC": "antidotal, also MITHRADATIC [adj]\n",
  "MITHRIDATISE": "to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATIZE [v MITHRIDATISED, MITHRIDATISING, MITHRIDATISES]\n",
  "MITHRIDATISED": "MITHRIDATISE, to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATIZE [v]\n",
  "MITHRIDATISES": "MITHRIDATISE, to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATIZE [v]\n",
  "MITHRIDATISING": "MITHRIDATISE, to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATIZE [v]\n",
  "MITHRIDATISM": "immunity to poison by taking increasingly large doses [n -S]\n",
  "MITHRIDATISMS": "MITHRIDATISM, immunity to poison by taking increasingly large doses [n]\n",
  "MITHRIDATIZE": "to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATISE [v MITHRIDATIZED, MITHRIDATIZING, MITHRIDATIZES]\n",
  "MITHRIDATIZED": "MITHRIDATIZE, to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATISE [v]\n",
  "MITHRIDATIZES": "MITHRIDATIZE, to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATISE [v]\n",
  "MITHRIDATIZING": "MITHRIDATIZE, to acquire immunity to a poison acquired by taking gradually increased doses of it, also MITHRIDATISE [v]\n",
  "MITICIDAL": "relating to a miticide, an agent which kills mites [adj]\n",
  "MITICIDE": "a substance used to kill mites [n -S]\n",
  "MITICIDES": "MITICIDE, a substance used to kill mites [n]\n",
  "MITIER": "MITY, infested with mites [adj]\n",
  "MITIEST": "MITY, infested with mites [adj]\n",
  "MITIGABLE": "that may be mitigated [adj]\n",
  "MITIGANT": "something that mitigates [n -S]\n",
  "MITIGANTS": "MITIGANT, something that mitigates [n]\n",
  "MITIGATE": "to make less severe, also MEASE [v MITIGATED, MITIGATING, MITIGATES]\n",
  "MITIGATED": "MITIGATE, to make less severe, also MEASE [v]\n",
  "MITIGATES": "MITIGATE, to make less severe, also MEASE [v]\n",
  "MITIGATING": "MITIGATE, to make less severe, also MEASE [v]\n",
  "MITIGATION": "the act of mitigating [n -S]\n",
  "MITIGATIONS": "MITIGATION, the act of mitigating [n]\n",
  "MITIGATIVE": "tending to mitigate [adj] / a mitigative drug [n -S]\n",
  "MITIGATIVES": "MITIGATIVE, a mitigative drug [n]\n",
  "MITIGATOR": "one who mitigates [n -S]\n",
  "MITIGATORS": "MITIGATOR, one who mitigates [n]\n",
  "MITIGATORY": "tending to mitigate [adj]\n",
  "MITIS": "a type of wrought iron [n -ES]\n",
  "MITISES": "MITIS, a type of wrought iron [n]\n",
  "MITOCHONDRIA": "MITOCHONDRION, a cell structure containing enzymes that provide the cell with energy [n]\n",
  "MITOCHONDRIAL": "of or like a mitochondrion [adj]\n",
  "MITOCHONDRION": "a cell structure containing enzymes that provide the cell with energy [n MITOCHONDRIA]\n",
  "MITOGEN": "a substance that causes cells to divide [n -S]\n",
  "MITOGENETIC": "relating to mitogens, a substance that causes cells to divide [adj]\n",
  "MITOGENIC": "causing cell division [adj]\n",
  "MITOGENICITIES": "MITOGENICITY, the state of being mitogenic [n]\n",
  "MITOGENICITY": "the state of being mitogenic [n MITOGENICITIES]\n",
  "MITOGENS": "MITOGEN, a substance that causes cells to divide [n]\n",
  "MITOMYCIN": "a kind of antibiotic [n -S]\n",
  "MITOMYCINS": "MITOMYCIN, a kind of antibiotic [n]\n",
  "MITOSES": "MITOSIS, (Greek) a type of cell division [n]\n",
  "MITOSIS": "(Greek) a type of cell division [n MITOSES]\n",
  "MITOTIC": "relating to mitosis, cell division [adj MITOTICALLY]\n",
  "MITOTICALLY": "MITOTIC, relating to mitosis, cell division [adv]\n",
  "MITRAILLE": "(French) shot or bits of iron used sometimes in loading cannon [n -S]\n",
  "MITRAILLES": "MITRAILLE, (French) shot or bits of iron used sometimes in loading cannon [n]\n",
  "MITRAILLEUR": "(French) a machine-gunner [n -S]\n",
  "MITRAILLEURS": "MITRAILLEUR, (French) a machine-gunner [n]\n",
  "MITRAILLEUSE": "(French) a machinegun [n -S]\n",
  "MITRAILLEUSES": "MITRAILLEUSE, (French) a machinegun [n]\n",
  "MITRAL": "pertaining to a valve of the heart [adj]\n",
  "MITRE": "a high, pointed headdress, cleft crosswise on top and with two ribbons hanging from the back, worn by archbishops and bishops [n -S] / to join with a mitre joint, also MITER [v MITRED, MITRING, MITRES]\n",
  "MITRED": "MITRE, to join with a mitre joint, also MITER [v]\n",
  "MITRES": "MITRE, to join with a mitre joint, also MITER [v]\n",
  "MITREWORT": "a slender, perennial herb with a pod slightly resembling a bishop's miter, also MITERWORT [n -S]\n",
  "MITREWORTS": "MITREWORT, a slender, perennial herb with a pod slightly resembling a bishop's miter, also MITERWORT [n]\n",
  "MITRIFORM": "mitre-shaped [adj]\n",
  "MITRING": "MITRE, to join with a mitre joint, also MITER [v]\n",
  "MITSVAH": "(Hebrew) a commandment of Jewish law, also MITZVAH [n MITSVAHS or MITSVOTH]\n",
  "MITSVAHS": "MITSVAH, (Hebrew) a commandment of Jewish law, also MITZVAH [n]\n",
  "MITSVOTH": "MITSVAH, (Hebrew) a commandment of Jewish law, also MITZVAH [n]\n",
  "MITT": "any of various glove-like hand coverings, such as one that does not cover the fingers, also MITTEN [n -S]\n",
  "MITTEN": "any of various glove-like hand coverings, such as one that does not cover the fingers, also MITT [n -S]\n",
  "MITTENED": "wearing mittens [adj]\n",
  "MITTENS": "MITTEN, any of various glove-like hand coverings, such as one that does not cover the fingers, also MITT [n]\n",
  "MITTIMUS": "(Latin) a warrant committing a person to prison [n -ES]\n",
  "MITTIMUSES": "MITTIMUS, (Latin) a warrant committing a person to prison [n]\n",
  "MITTS": "MITT, any of various glove-like hand coverings, such as one that does not cover the fingers, also MITTEN [n]\n",
  "MITUMBA": "(Swahili) used clothes from wealthy countries imported to Africa [n -S]\n",
  "MITUMBAS": "MITUMBA, (Swahili) used clothes from wealthy countries imported to Africa [n]\n",
  "MITY": "infested with mites [adj MITIER, MITIEST]\n",
  "MITZVAH": "(Hebrew) a commandment of Jewish law, also MITSVAH [n MITZVAHS or MITZVOTH]\n",
  "MITZVAHS": "MITZVAH, (Hebrew) a commandment of Jewish law, also MITSVAH [n]\n",
  "MITZVOTH": "MITZVAH, (Hebrew) a commandment of Jewish law, also MITSVAH [n]\n",
  "MIURUS": "(Greek) a hexameter with a short penultimate syllable [n -ES]\n",
  "MIURUSES": "MIURUS, (Greek) a hexameter with a short penultimate syllable [n]\n",
  "MIX": "to combine together [v MIXED or MIXT, MIXING, MIXES]\n",
  "MIXABILITIES": "MIXABILITY, the capacity to be mixed [n]\n",
  "MIXABILITY": "the capacity to be mixed [n MIXABILITIES]\n",
  "MIXABLE": "capable of being mixed, also MISCIBLE, MIXIBLE [adj]\n",
  "MIXDOWN": "mixing a multitrack recording down to just stereo [n -S]\n",
  "MIXDOWNS": "MIXDOWN, mixing a multitrack recording down to just stereo [n]\n",
  "MIXED": "MIX, to combine together [v]\n",
  "MIXEDLY": "MIXED, MIX, to combine together [adv]\n",
  "MIXEDNESS": "the state of being mixed [n -ES]\n",
  "MIXEDNESSES": "MIXEDNESS, the state of being mixed [n]\n",
  "MIXEN": "a dunghill [n -S]\n",
  "MIXENS": "MIXEN, a dunghill [n]\n",
  "MIXER": "one that mixes [n -S]\n",
  "MIXERS": "MIXER, one that mixes [n]\n",
  "MIXES": "MIX, to combine together [v]\n",
  "MIXIBLE": "capable of being mixed, also MISCIBLE, MIXABLE [adj]\n",
  "MIXIER": "MIXY, mixed [adj]\n",
  "MIXIEST": "MIXY, mixed [adj]\n",
  "MIXING": "the act of mixing [n -S]\n",
  "MIXINGS": "MIXING, the act of mixing [n]\n",
  "MIXMASTER": "a disc jockey [n -S]\n",
  "MIXMASTERS": "MIXMASTER, a disc jockey [n]\n",
  "MIXOBARBARIC": "part barbaric, part Greek [adj]\n",
  "MIXOLOGIES": "MIXOLOGY, the art of making mixed drinks [n]\n",
  "MIXOLOGIST": "a student of mixology, the art of making mixed drinks [n -S]\n",
  "MIXOLOGISTS": "MIXOLOGIST, a student of mixology, the art of making mixed drinks [n]\n",
  "MIXOLOGY": "the art of making mixed drinks [n MIXOLOGIES]\n",
  "MIXOLYDIAN": "denoting the seventh ecclesiastical mode, whose scale commences on G [adj]\n",
  "MIXOTROPHIC": "combining different modes of nutrition [adj]\n",
  "MIXT": "MIX, to combine together [v]\n",
  "MIXTAPE": "a compilation of songs from various sources [n -S]\n",
  "MIXTAPES": "MIXTAPE, a compilation of songs from various sources [n]\n",
  "MIXTE": "denoting a type of bicycle frame [adj]\n",
  "MIXTION": "a mixture of amber mastic and asphaltum [n -S]\n",
  "MIXTIONS": "MIXTION, a mixture of amber mastic and asphaltum [n]\n",
  "MIXTURE": "the product of mixing [n -S]\n",
  "MIXTURES": "MIXTURE, the product of mixing [n]\n",
  "MIXUP": "a state of confusion [n -S]\n",
  "MIXUPS": "MIXUP, a state of confusion [n]\n",
  "MIXY": "mixed [adj MIXIER, MIXIEST]\n",
  "MIZ": "(colloquial) misery, also MIZZ [n MIZZES]\n",
  "MIZEN": "in a three-masted vessel, the hindmost of the fore-and-aft sails, also MIZZEN [n -S]\n",
  "MIZENMAST": "the mast aft or next aft of the mainmast in a ship, also MIZZENMAST [n -S]\n",
  "MIZENMASTS": "MIZENMAST, the mast aft or next aft of the mainmast in a ship, also MIZZENMAST [n]\n",
  "MIZENS": "MIZEN, in a three-masted vessel, the hindmost of the fore-and-aft sails, also MIZZEN [n]\n",
  "MIZMAZE": "a labyrinth [n -S]\n",
  "MIZMAZES": "MIZMAZE, a labyrinth [n]\n",
  "MIZUNA": "(Japanese) a variety of lettuce with crisp green leaves [n -S]\n",
  "MIZUNAS": "MIZUNA, (Japanese) a variety of lettuce with crisp green leaves [n]\n",
  "MIZZ": "(colloquial) misery, also MIZ [n -ES]\n",
  "MIZZEN": "in a three-masted vessel, the hindmost of the fore-and-aft sails, also MIZEN [n -S]\n",
  "MIZZENMAST": "the mast aft or next aft of the mainmast in a ship, also MIZENMAST [n -S]\n",
  "MIZZENMASTS": "MIZZENMAST, the mast aft or next aft of the mainmast in a ship, also MIZENMAST [n]\n",
  "MIZZENS": "MIZZEN, in a three-masted vessel, the hindmost of the fore-and-aft sails, also MIZEN [n]\n",
  "MIZZES": "MIZZ, (colloquial) misery, also MIZ [n]\n",
  "MIZZLE": "to rain in fine droplets, also MISTLE [v MIZZLED, MIZZLING, MIZZLES]\n",
  "MIZZLED": "MIZZLE, to rain in fine droplets, also MISTLE [v]\n",
  "MIZZLES": "MIZZLE, to rain in fine droplets, also MISTLE [v]\n",
  "MIZZLIER": "MIZZLY, drizzly, raining in fine drops [adj]\n",
  "MIZZLIEST": "MIZZLY, drizzly, raining in fine drops [adj]\n",
  "MIZZLING": "drizzling [n -S]\n",
  "MIZZLINGS": "MIZZLING, drizzling [n]\n",
  "MIZZLY": "drizzly, raining in fine drops [adj MIZZLIER, MIZZLIEST]\n",
  "MIZZONITE": "a scapolite richer in sodium than meionite [n -S]\n",
  "MIZZONITES": "MIZZONITE, a scapolite richer in sodium than meionite [n]\n",
  "MIZZY": "as in mizzy maze, dialect for a state of confusion [adj]\n",
  "MM": "an interjection expressing agreement or enjoyment, also MMM [interj]\n",
  "MMM": "an interjection expressing agreement or enjoyment, also MM [interj]\n",
  "MNA": "a Greek weight [n -S]\n",
  "MNAS": "MNA, a Greek weight [n]\n",
  "MNEME": "the persisting effect of the memory of past events [n -S]\n",
  "MNEMES": "MNEME, the persisting effect of the memory of past events [n]\n",
  "MNEMIC": "relating to the mneme [adj]\n",
  "MNEMON": "(Greek) a hypothetical unit of memory [n -S]\n",
  "MNEMONIC": "relating to memory [adj MNEMONICALLY] / a device to assist the memory [n -S]\n",
  "MNEMONICAL": "assisting in memory [adj MNEMONICALLY]\n",
  "MNEMONICALLY": "MNEMONICAL, assisting in memory [adv]\n",
  "MNEMONICS": "MNEMONIC, a device to assist the memory [n]\n",
  "MNEMONIST": "an expert in mnemonics; a person who exhibits his or her powers of memory [n -S]\n",
  "MNEMONISTS": "MNEMONIST, an expert in mnemonics; a person who exhibits his or her powers of memory [n]\n",
  "MNEMONS": "MNEMON, (Greek) a hypothetical unit of memory [n]\n",
  "MNEMOTECHNIC": "a mnemonic [n -S]\n",
  "MNEMOTECHNICS": "MNEMOTECHNIC, a mnemonic [n]\n",
  "MNEMOTECHNIST": "a mnemonist [n -S]\n",
  "MNEMOTECHNISTS": "MNEMOTECHNIST, a mnemonist [n]\n",
  "MO": "a moment [n -S]\n",
  "MOA": "an extinct flightless bird [n -S]\n",
  "MOAI": "a huge carved figure on Easter Island [n MOAI]\n",
  "MOAN": "to utter a low, mournful sound, also MEANE, MEIN, MENE [v -ED, -ING, -S]\n",
  "MOANED": "MOAN, to utter a low, mournful sound, also MEANE, MEIN, MENE [v]\n",
  "MOANER": "one who moans [n -S]\n",
  "MOANERS": "MOANER, one who moans [n]\n",
  "MOANFUL": "full of moaning; expressing sorrow [adj MOANFULLY]\n",
  "MOANFULLY": "MOANFUL, full of moaning; expressing sorrow [adv]\n",
  "MOANING": "making a moaning sound [adj MOANINGLY] / the act of moaning [n -S]\n",
  "MOANINGLY": "MOANING, making a moaning sound [adv]\n",
  "MOANINGS": "MOANING, the act of moaning [n]\n",
  "MOANS": "MOAN, to utter a low, mournful sound, also MEANE, MEIN, MENE [v]\n",
  "MOAS": "MOA, an extinct flightless bird [n]\n",
  "MOAT": "to surround with a water-filled trench [v -ED, -ING, -S]\n",
  "MOATED": "MOAT, to surround with a water-filled trench [v]\n",
  "MOATING": "MOAT, to surround with a water-filled trench [v]\n",
  "MOATLIKE": "like a moat [adj]\n",
  "MOATS": "MOAT, to surround with a water-filled trench [v]\n",
  "MOB": "to crowd about [v MOBBED, MOBBING, MOBS]\n",
  "MOBBED": "MOB, to crowd about [v]\n",
  "MOBBER": "one that mobs [n -S]\n",
  "MOBBERS": "MOBBER, one that mobs [n]\n",
  "MOBBIE": "(Caribbean) a frothy beverage made from boiled tree-bark, also MAUBY, MOBBY [n -S]\n",
  "MOBBIES": "MOBBIE, (Caribbean) a frothy beverage made from boiled tree-bark, also MAUBY, MOBBY [n]\n",
  "MOBBING": "a form of harassment [n -S]\n",
  "MOBBINGS": "MOBBING, a form of harassment [n]\n",
  "MOBBISH": "in the way of a mob [adj MOBBISHLY]\n",
  "MOBBISHLY": "MOBBISH, in the way of a mob [adv]\n",
  "MOBBISM": "mobbish conduct [n -S]\n",
  "MOBBISMS": "MOBBISM, mobbish conduct [n]\n",
  "MOBBLE": "(obsolete) to muffle, also MOBLE [v MOBBLED, MOBBLING, MOBBLES]\n",
  "MOBBLED": "MOBBLE, (obsolete) to muffle, also MOBLE [v]\n",
  "MOBBLES": "MOBBLE, (obsolete) to muffle, also MOBLE [v]\n",
  "MOBBLING": "MOBBLE, (obsolete) to muffle, also MOBLE [v]\n",
  "MOBBY": "(Caribbean) a frothy beverage, also MOBBIE, MAUBY [n MOBBIES]\n",
  "MOBCAP": "a plain cap or headdress for women or girls; esp. one tying under the chin [n -S]\n",
  "MOBCAPS": "MOBCAP, a plain cap or headdress for women or girls; esp. one tying under the chin [n]\n",
  "MOBCAST": "to broadcast over mobile phones [v -ED, -ING, -S]\n",
  "MOBCASTED": "MOBCAST, to broadcast over mobile phones [v]\n",
  "MOBCASTING": "the act of broadcasting over mobile phones [n -S]\n",
  "MOBCASTINGS": "MOBCASTING, the act of broadcasting over mobile phones [n]\n",
  "MOBCASTS": "MOBCAST, to broadcast over mobile phones [v]\n",
  "MOBE": "(slang) a mobile phone, also MOBEY, MOBIE, MOBY [n -S]\n",
  "MOBES": "MOBE, (slang) a mobile phone, also MOBEY, MOBIE, MOBY [n]\n",
  "MOBEY": "(slang) a mobile phone, also MOBE, MOBIE, MOBY [n -S]\n",
  "MOBEYS": "MOBEY, (slang) a mobile phone, also MOBE, MOBIE, MOBY [n]\n",
  "MOBIE": "(slang) a mobile phone, also MOBE, MOBEY, MOBY [n -S]\n",
  "MOBIES": "MOBY, (slang) a mobile phone, also MOBE, MOBEY, MOBIE [n]\n",
  "MOBILE": "a form of sculpture [n -S]\n",
  "MOBILES": "MOBILE, a form of sculpture [n]\n",
  "MOBILISABLE": "that can be mobilised, also MOBILIZABLE [adj]\n",
  "MOBILISATION": "the act of mobilising, also MOBILIZATION [n -S]\n",
  "MOBILISATIONS": "MOBILISATION, the act of mobilising, also MOBILIZATION [n]\n",
  "MOBILISE": "to make moveable, also MOBILIZE [v MOBILISED, MOBILISING, MOBILISES]\n",
  "MOBILISED": "MOBILISE, to make moveable, also MOBILIZE [v]\n",
  "MOBILISER": "something that serves to mobilise, also MOBILIZER [n -S]\n",
  "MOBILISERS": "MOBILISER, something that serves to mobilise, also MOBILIZER [n]\n",
  "MOBILISES": "MOBILISE, to make moveable, also MOBILIZE [v]\n",
  "MOBILISING": "MOBILISE, to make moveable, also MOBILIZE [v]\n",
  "MOBILITIES": "MOBILITY, the ability to move [n]\n",
  "MOBILITY": "the ability to move [n MOBILITIES]\n",
  "MOBILIZABLE": "that can be mobilized, also MOBILISABLE [adj]\n",
  "MOBILIZATION": "the act of mobilizing, also MOBILISATION [n -S]\n",
  "MOBILIZATIONS": "MOBILIZATION, the act of mobilizing, also MOBILISATION [n]\n",
  "MOBILIZE": "to make moveable, also MOBILISE [v MOBILIZED, MOBILIZING, MOBILIZES]\n",
  "MOBILIZED": "MOBILIZE, to make moveable, also MOBILISE [v]\n",
  "MOBILIZER": "something that serves to mobilise, also MOBILISER [n -S]\n",
  "MOBILIZERS": "MOBILIZER, something that serves to mobilise, also MOBILISER [n]\n",
  "MOBILIZES": "MOBILIZE, to make moveable, also MOBILISE [v]\n",
  "MOBILIZING": "MOBILIZE, to make moveable, also MOBILISE [v]\n",
  "MOBISODE": "an episode of a TV show made for downloading and viewing on mobile phones [n -S]\n",
  "MOBISODES": "MOBISODE, an episode of a TV show made for downloading and viewing on mobile phones [n]\n",
  "MOBLE": "(obsolete) to muffle, also MOBBLE [v MOBLED, MOBLING, MOBLES]\n",
  "MOBLED": "MOBLE, (obsolete) to muffle, also MOBBLE [v]\n",
  "MOBLES": "MOBLE, (obsolete) to muffle, also MOBBLE [v]\n",
  "MOBLING": "MOBLE, (obsolete) to muffle, also MOBBLE [v]\n",
  "MOBLOG": "a blog of mobile phone messages and photos [n -S]\n",
  "MOBLOGGER": "one who keeps a moblog [n -S]\n",
  "MOBLOGGERS": "MOBLOGGER, one who keeps a moblog [n]\n",
  "MOBLOGS": "MOBLOG, a blog of mobile phone messages and photos [n]\n",
  "MOBOCRACIES": "MOBOCRACY, government by mobs or crowds [n]\n",
  "MOBOCRACY": "government by mobs or crowds [n MOBOCRACIES]\n",
  "MOBOCRAT": "one who favors a form of government in which the unintelligent populace rules without restraint [n -S]\n",
  "MOBOCRATIC": "relating to mobocracy, government by mobs or crowds, also MOBOCRATICAL [adj]\n",
  "MOBOCRATICAL": "relating to mobocracy, government by mobs or crowds, also MOBOCRATIC [adj]\n",
  "MOBOCRATS": "MOBOCRAT, one who favors a form of government in which the unintelligent populace rules without restraint [n]\n",
  "MOBS": "MOB, to crowd about [v]\n",
  "MOBSMAN": "a member of a mob [n MOBSMEN]\n",
  "MOBSMEN": "MOBSMAN, a member of a mob [n]\n",
  "MOBSTER": "a member of an organized criminal fraternity, also MOBSMAN [n -S]\n",
  "MOBSTERS": "MOBSTER, a member of an organized criminal fraternity, also MOBSMAN [n]\n",
  "MOBY": "(slang) a mobile phone, also MOBE, MOBEY, MOBIE [n MOBIES]\n",
  "MOC": "(short for) moccasin [n -S]\n",
  "MOCASSIN": "(Native American) a heelless shoe of deerskin or other soft leather, also MOCCASIN [n -S]\n",
  "MOCASSINS": "MOCASSIN, (Native American) a heelless shoe of deerskin or other soft leather, also MOCCASIN [n]\n",
  "MOCCASIN": "(Native American) a heelless shoe of deerskin or other soft leather, also MOCASSIN [n -S]\n",
  "MOCCASINS": "MOCCASIN, (Native American) a heelless shoe of deerskin or other soft leather, also MOCASSIN [n]\n",
  "MOCCIES": "(Australian slang) moccasins [n]\n",
  "MOCH": "(of foods) to become musty or spoiled [v -ED, -ING, -S]\n",
  "MOCHA": "a choice, pungent coffee [n -S]\n",
  "MOCHAS": "MOCHA, a choice, pungent coffee [n]\n",
  "MOCHED": "MOCH, (of foods) to become musty or spoiled [v]\n",
  "MOCHELL": "(Spenser) much, a great deal, also MEIKLE, MICKLE, MUCHEL, MUCHELL [n -S]\n",
  "MOCHELLS": "MOCHELL, (Spenser) much, a great deal, also MEIKLE, MICKLE, MUCHEL, MUCHELL [n]\n",
  "MOCHI": "(Japanese) a confection made with rice flour and sweetened bean paste [n -S]\n",
  "MOCHIE": "(Scots) mouldy, damp, also MOCHY [adj MOCHIER, MOCHIEST]\n",
  "MOCHIER": "MOCHY, (Scots) mouldy, damp, also MOCHIE [adj]\n",
  "MOCHIEST": "MOCHY, (Scots) mouldy, damp, also MOCHIE [adj]\n",
  "MOCHILA": "(Spanish) a leather covering for a saddle [n -S]\n",
  "MOCHILAS": "MOCHILA, (Spanish) a leather covering for a saddle [n]\n",
  "MOCHINESS": "(Scots) mouldiness, dampness [n -ES]\n",
  "MOCHINESSES": "MOCHINESS, (Scots) mouldiness, dampness [n]\n",
  "MOCHING": "MOCH, (of foods) to become musty or spoiled [v]\n",
  "MOCHIS": "MOCHI, (Japanese) a confection made with rice flour and sweetened bean paste [n]\n",
  "MOCHS": "MOCH, (of foods) to become musty or spoiled [v]\n",
  "MOCHY": "(Scots) mouldy, damp, also MOCHIE [adj MOCHIER, MOCHIEST]\n",
  "MOCK": "to ridicule [v -ED, -ING, -S]\n",
  "MOCKABLE": "able to be mocked [adj]\n",
  "MOCKADO": "(obsolete) an inferior quality woollen fabric [n -ES]\n",
  "MOCKADOES": "MOCKADO, (obsolete) an inferior quality woollen fabric [n]\n",
  "MOCKAGE": "(obsolete) mockery [n -S]\n",
  "MOCKAGES": "MOCKAGE, (obsolete) mockery [n]\n",
  "MOCKED": "MOCK, to ridicule [v]\n",
  "MOCKER": "to clothe [v -ED, -ING, -S]\n",
  "MOCKERED": "MOCKER, to clothe [v]\n",
  "MOCKERIES": "MOCKERY, the act of mocking [n]\n",
  "MOCKERING": "MOCKER, to clothe [v]\n",
  "MOCKERNUT": "a kind of hickory nut [n -S]\n",
  "MOCKERNUTS": "MOCKERNUT, a kind of hickory nut [n]\n",
  "MOCKERS": "MOCKER, to clothe [v]\n",
  "MOCKERY": "the act of mocking [n MOCKERIES]\n",
  "MOCKING": "derisive [adj MOCKINGLY] / the act of mocking [n -S]\n",
  "MOCKINGBIRD": "any of various long-tailed songbirds of the New World family Mimidae, noted for mimicking other birds' calls and other sounds [n -S]\n",
  "MOCKINGBIRDS": "MOCKINGBIRD, any of various long-tailed songbirds of the New World family Mimidae, noted for mimicking other birds' calls and other sounds [n]\n",
  "MOCKINGLY": "MOCKING, derisive [adv]\n",
  "MOCKINGS": "MOCKING, the act of mocking [n]\n",
  "MOCKNEY": "a person who affects a cockney accent [n -S]\n",
  "MOCKNEYS": "MOCKNEY, a person who affects a cockney accent [n]\n",
  "MOCKS": "MOCK, to ridicule [v]\n",
  "MOCKTAIL": "a cocktail with no alcohol [n -S]\n",
  "MOCKTAILS": "MOCKTAIL, a cocktail with no alcohol [n]\n",
  "MOCKUMENTARIES": "MOCKUMENTARY, a spoof documentary [n]\n",
  "MOCKUMENTARY": "a spoof documentary [n MOCKUMENTARIES]\n",
  "MOCKUP": "a full-sized model [n -S]\n",
  "MOCKUPS": "MOCKUP, a full-sized model [n]\n",
  "MOCOCK": "(Native American) a North American bark box, also MOCUCK [n -S]\n",
  "MOCOCKS": "MOCOCK, (Native American) a North American bark box, also MOCUCK [n]\n",
  "MOCS": "MOC, (short for) moccasin [n]\n",
  "MOCUCK": "(Native American) a North American bark box, also MOCOCK [n -S]\n",
  "MOCUCKS": "MOCUCK, (Native American) a North American bark box, also MOCOCK [n]\n",
  "MOCUDDUM": "(Arabic) a leader, headman, also MOKADDAM, MUQADDAM [n -S]\n",
  "MOCUDDUMS": "MOCUDDUM, (Arabic) a leader, headman, also MOKADDAM, MUQADDAM [n]\n",
  "MOD": "to modify a machine or piece of software [v MODDED, MODDING, MODS]\n",
  "MODAFINIL": "a stimulant drug that enhances wakefulness and vigilance, used in the treatment of narcolepsy [n -S]\n",
  "MODAFINILS": "MODAFINIL, a stimulant drug that enhances wakefulness and vigilance, used in the treatment of narcolepsy [n]\n",
  "MODAL": "related to mood [adj MODALLY] / a modal auxiliary [n -S]\n",
  "MODALISM": "belief in the unity of Father, Son and Holy Spirit [n -S]\n",
  "MODALISMS": "MODALISM, belief in the unity of Father, Son and Holy Spirit [n]\n",
  "MODALIST": "an adherent of modalism, i.e. one who regards Father, Son, and Spirit as modes of being, and not as persons [n -S]\n",
  "MODALISTIC": "relating to modalism [adj]\n",
  "MODALISTS": "MODALIST, an adherent of modalism, i.e. one who regards Father, Son, and Spirit as modes of being, and not as persons [n]\n",
  "MODALITIES": "MODALITY, the state of being modal [n]\n",
  "MODALITY": "the state of being modal [n MODALITIES]\n",
  "MODALLY": "MODAL, related to mood [adv]\n",
  "MODALS": "MODAL, a modal auxiliary [n]\n",
  "MODDED": "MOD, to modify a machine or piece of software [v]\n",
  "MODDER": "one who modifies a machine or piece of software [n -S]\n",
  "MODDERS": "MODDER, one who modifies a machine or piece of software [n]\n",
  "MODDING": "the practice of modifying a production car to alter its appearance or to increase performance [n -S]\n",
  "MODDINGS": "MODDING, the practice of modifying a production car to alter its appearance or to increase performance [n]\n",
  "MODE": "a way or manner of acting [n -S]\n",
  "MODEL": "to form a plan or design [v MODELED or MODELLED, MODELING or MODELLING, MODELS]\n",
  "MODELED": "MODEL, to form a plan or design [v]\n",
  "MODELER": "one that models, also MODELLER [n -S]\n",
  "MODELERS": "MODELER, one that models, also MODELLER [n]\n",
  "MODELING": "the art of making a model [n -S]\n",
  "MODELINGS": "MODELING, the art of making a model [n]\n",
  "MODELIST": "one who makes models, also MODELLIST [n -S]\n",
  "MODELISTS": "MODELIST, one who makes models, also MODELLIST [n]\n",
  "MODELLED": "MODEL, to form a plan or design [v]\n",
  "MODELLER": "one that models, also MODELER [n -S]\n",
  "MODELLERS": "MODELLER, one that models, also MODELER [n]\n",
  "MODELLI": "MODELLO, (Italian) an artist's detailed sketch [n]\n",
  "MODELLING": "the act of modelling [n -S]\n",
  "MODELLINGS": "MODELLING, the act of modelling [n]\n",
  "MODELLIST": "a person who constructs models, also MODELIST [n -S]\n",
  "MODELLISTS": "MODELLIST, a person who constructs models, also MODELIST [n]\n",
  "MODELLO": "(Italian) an artist's detailed sketch [n MODELLOS or MODELLI]\n",
  "MODELLOS": "MODELLO, (Italian) an artist's detailed sketch [n]\n",
  "MODELS": "MODEL, to form a plan or design [v]\n",
  "MODEM": "to transmit by electronic device [v -ED, -ING, -S]\n",
  "MODEMED": "MODEM, to transmit by electronic device [v]\n",
  "MODEMING": "MODEM, to transmit by electronic device [v]\n",
  "MODEMS": "MODEM, to transmit by electronic device [v]\n",
  "MODENA": "(Italian) a popular variety of domestic fancy pigeon originating in Modena [n -S]\n",
  "MODENAS": "MODENA, (Italian) a popular variety of domestic fancy pigeon originating in Modena [n]\n",
  "MODER": "(German) a layer of humus intermediate between mor and mull [n -S]\n",
  "MODERATE": "reasonable, not extreme [adj MODERATELY] / to make less extreme [v MODERATED, MODERATING, MODERATES]\n",
  "MODERATED": "MODERATE, to make less extreme [v]\n",
  "MODERATELY": "MODERATE, reasonable, not extreme [adv]\n",
  "MODERATENESS": "the state of being moderate [n -ES]\n",
  "MODERATENESSES": "MODERATENESS, the state of being moderate [n]\n",
  "MODERATES": "MODERATE, to make less extreme [v]\n",
  "MODERATING": "MODERATE, to make less extreme [v]\n",
  "MODERATION": "being moderate [n -S]\n",
  "MODERATIONS": "MODERATION, being moderate [n]\n",
  "MODERATISM": "moderation in doctrines or opinion, esp. in politics or religion [n -S]\n",
  "MODERATISMS": "MODERATISM, moderation in doctrines or opinion, esp. in politics or religion [n]\n",
  "MODERATO": "(Italian) a musical direction indicating a moderate degree of quickness [n -S]\n",
  "MODERATOR": "one who moderates [n -S]\n",
  "MODERATORS": "MODERATOR, one who moderates [n]\n",
  "MODERATORSHIP": "the office of moderator [n -S]\n",
  "MODERATORSHIPS": "MODERATORSHIP, the office of moderator [n]\n",
  "MODERATOS": "MODERATO, (Italian) a musical direction indicating a moderate degree of quickness [n]\n",
  "MODERATRICES": "MODERATRIX, (obsolete) a female moderator [n]\n",
  "MODERATRIX": "(obsolete) a female moderator [n MODERATRICES or MODERATRIXES]\n",
  "MODERATRIXES": "MODERATRIX, (obsolete) a female moderator [n]\n",
  "MODERN": "pertaining to the present time [adj MODERNER, MODERNEST, MODERNLY] / a person with up to date views [n -S]\n",
  "MODERNE": "(French) pretentiously modern [adj MODERNER, MODERNEST] / a design style of the 1920s and 1930s [n -S]\n",
  "MODERNER": "MODERN, pertaining to the present time [adj]\n",
  "MODERNES": "MODERNE, a design style of the 1920s and 1930s [n]\n",
  "MODERNEST": "MODERN, pertaining to the present time [adj]\n",
  "MODERNISATION": "the act of modernising, also MODERNIZATION [n -S]\n",
  "MODERNISATIONS": "MODERNISATION, the act of modernising, also MODERNIZATION [n]\n",
  "MODERNISE": "to make modern, also MODERNIZE [v MODERNISED, MODERNISING, MODERNISES]\n",
  "MODERNISED": "MODERNISE, to make modern, also MODERNIZE [v]\n",
  "MODERNISER": "one who modernises, also MODERNIZER [n -S]\n",
  "MODERNISERS": "MODERNISER, one who modernises, also MODERNIZER [n]\n",
  "MODERNISES": "MODERNISE, to make modern, also MODERNIZE [v]\n",
  "MODERNISING": "MODERNISE, to make modern, also MODERNIZE [v]\n",
  "MODERNISM": "a modern usage, expression, or trait [n -S]\n",
  "MODERNISMS": "MODERNISM, a modern usage, expression, or trait [n]\n",
  "MODERNIST": "an admirer of modern ideas, ways, literature, etc. [n -S]\n",
  "MODERNISTIC": "relating to modernism [adj MODERNISTICALLY]\n",
  "MODERNISTICALLY": "MODERNISTIC, relating to modernism [adv]\n",
  "MODERNISTS": "MODERNIST, an admirer of modern ideas, ways, literature, etc. [n]\n",
  "MODERNITIES": "MODERNITY, the quality of being modern [n]\n",
  "MODERNITY": "the quality of being modern [n MODERNITIES]\n",
  "MODERNIZATION": "the act of modernizing, also MODERNISATION [n -S]\n",
  "MODERNIZATIONS": "MODERNIZATION, the act of modernizing, also MODERNISATION [n]\n",
  "MODERNIZE": "to make modern, also MODERNISE [v MODERNIZED, MODERNIZING, MODERNIZES]\n",
  "MODERNIZED": "MODERNIZE, to make modern, also MODERNISE [v]\n",
  "MODERNIZER": "one who modernizes, also MODERNISER [n -S]\n",
  "MODERNIZERS": "MODERNIZER, one who modernizes, also MODERNISER [n]\n",
  "MODERNIZES": "MODERNIZE, to make modern, also MODERNISE [v]\n",
  "MODERNIZING": "MODERNIZE, to make modern, also MODERNISE [v]\n",
  "MODERNLY": "MODERN, pertaining to the present time [adv]\n",
  "MODERNNESS": "the state of being modern [n -ES]\n",
  "MODERNNESSES": "MODERNNESS, the state of being modern [n]\n",
  "MODERNS": "MODERN, a person with up to date views [n]\n",
  "MODERS": "MODER, (German) a layer of humus intermediate between mor and mull [n]\n",
  "MODES": "MODE, a way or manner of acting [n]\n",
  "MODEST": "unassuming [adj MODESTER, MODESTEST, MODESTLY]\n",
  "MODESTER": "MODEST, unassuming [adj]\n",
  "MODESTEST": "MODEST, unassuming [adj]\n",
  "MODESTIES": "MODESTY, the quality of being modest [n]\n",
  "MODESTLY": "MODEST, unassuming [adv]\n",
  "MODESTY": "the quality of being modest [n MODESTIES]\n",
  "MODGE": "(dialect) to do shoddy work [v MODGED, MODGING, MODGES]\n",
  "MODGED": "MODGE, (dialect) to do shoddy work [v]\n",
  "MODGES": "MODGE, (dialect) to do shoddy work [v]\n",
  "MODGING": "MODGE, (dialect) to do shoddy work [v]\n",
  "MODI": "MODUS, (Latin) the arrangement of, or mode of expressing, the terms of a contract or conveyance [n]\n",
  "MODICA": "MODICUM, (Latin) a small amount [n]\n",
  "MODICUM": "(Latin) a small amount [n MODICUMS or MODICA]\n",
  "MODICUMS": "MODICUM, (Latin) a small amount [n]\n",
  "MODIFIABILITIES": "MODIFIABILITY, the state of being modifiable [n]\n",
  "MODIFIABILITY": "the state of being modifiable [n MODIFIABILITIES]\n",
  "MODIFIABLE": "that can be modified [adj]\n",
  "MODIFIABLENESS": "MODIFIABLE, that can be modified [n]\n",
  "MODIFICATION": "an act of modifying [n -S]\n",
  "MODIFICATIONS": "MODIFICATION, an act of modifying [n]\n",
  "MODIFICATIVE": "tending to modify, also MODIFICATORY [adj]\n",
  "MODIFICATORY": "tending to modify, also MODIFICATIVE [adj]\n",
  "MODIFIED": "MODIFY, to alter slightly [v]\n",
  "MODIFIER": "one that modifies [n -S]\n",
  "MODIFIERS": "MODIFIER, one that modifies [n]\n",
  "MODIFIES": "MODIFY, to alter slightly [v]\n",
  "MODIFY": "to alter slightly [v MODIFIED, MODIFYING, MODIFIES]\n",
  "MODIFYING": "MODIFY, to alter slightly [v]\n",
  "MODII": "MODIUS, (Latin) a Roman dry measure [n]\n",
  "MODILLION": "(Italian) an ornamental bracket under a Corinthian or other column [n -S]\n",
  "MODILLIONS": "MODILLION, (Italian) an ornamental bracket under a Corinthian or other column [n]\n",
  "MODIOLAR": "pertaining to the modiolus [adj]\n",
  "MODIOLI": "MODIOLUS, (Latin) a bony shaft of the inner ear [n]\n",
  "MODIOLUS": "(Latin) a bony shaft of the inner ear [n MODIOLI]\n",
  "MODISH": "fashionable; stylish [adj MODISHLY]\n",
  "MODISHLY": "MODISH, fashionable; stylish [adv]\n",
  "MODISHNESS": "the state of being modish [n -ES]\n",
  "MODISHNESSES": "MODISHNESS, the state of being modish [n]\n",
  "MODIST": "a follower of fashion [n -S]\n",
  "MODISTE": "(French) a dealer in stylish women's clothing [n -S]\n",
  "MODISTES": "MODISTE, (French) a dealer in stylish women's clothing [n]\n",
  "MODISTS": "MODIST, a follower of fashion [n]\n",
  "MODIUS": "(Latin) a Roman dry measure [n MODII]\n",
  "MODIWORT": "(dialect) a mole, also MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MODIWORTS": "MODIWORT, (dialect) a mole, also MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MODS": "MOD, to modify a machine or piece of software [v]\n",
  "MODULABILITIES": "MODULABILITY, the capability of being modulated [n]\n",
  "MODULABILITY": "the capability of being modulated [n MODULABILITIES]\n",
  "MODULAR": "pertaining to a module [adj MODULARLY] / a thing composed of modules [n -S]\n",
  "MODULARISED": "containing or consisting of modules, also MODULARIZED [adj]\n",
  "MODULARITIES": "MODULARITY, the state of being modular [n]\n",
  "MODULARITY": "the state of being modular [n MODULARITIES]\n",
  "MODULARIZED": "containing or consisting of modules, also MODULARISED [adj]\n",
  "MODULARLY": "MODULAR, pertaining to a module [adv]\n",
  "MODULARS": "MODULAR, a thing composed of modules [n]\n",
  "MODULATE": "to adjust to a certain proportion [v MODULATED, MODULATING, MODULATES]\n",
  "MODULATED": "MODULATE, to adjust to a certain proportion [v]\n",
  "MODULATES": "MODULATE, to adjust to a certain proportion [v]\n",
  "MODULATING": "MODULATE, to adjust to a certain proportion [v]\n",
  "MODULATION": "an inflection of the tone or pitch of the voice [n -S]\n",
  "MODULATIONS": "MODULATION, an inflection of the tone or pitch of the voice [n]\n",
  "MODULATIVE": "relating to modulation [adj]\n",
  "MODULATOR": "a person who, or that which, modulates [n -S]\n",
  "MODULATORS": "MODULATOR, a person who, or that which, modulates [n]\n",
  "MODULATORY": "relating to modulation [adj]\n",
  "MODULE": "a standard of measurement [n -S]\n",
  "MODULES": "MODULE, a standard of measurement [n]\n",
  "MODULI": "MODULUS, (Latin) a constant multiplier [n]\n",
  "MODULO": "(Latin) with respect to a modulus (math) [adv]\n",
  "MODULUS": "(Latin) a constant multiplier [n MODULI]\n",
  "MODUS": "(Latin) the arrangement of, or mode of expressing, the terms of a contract or conveyance [n MODI]\n",
  "MOE": "(obsolete) a wry face [n -S]\n",
  "MOELLON": "(French) rubble in mason-work [n -S]\n",
  "MOELLONS": "MOELLON, (French) rubble in mason-work [n]\n",
  "MOER": "(South African) to attack someone [v -ED, -ING, -S]\n",
  "MOERED": "MOER, (South African) to attack someone [v]\n",
  "MOERING": "MOER, (South African) to attack someone [v]\n",
  "MOERS": "MOER, (South African) to attack someone [v]\n",
  "MOES": "MOE, (obsolete) a wry face [n]\n",
  "MOFETTE": "(French) a fissure in the earth emitting carbon dioxide, also MOFFETTE [n -S]\n",
  "MOFETTES": "MOFETTE, (French) a fissure in the earth emitting carbon dioxide, also MOFFETTE [n]\n",
  "MOFFETTE": "(French) a fissure in the earth emitting carbon dioxide, also MOFETTE [n -S]\n",
  "MOFFETTES": "MOFFETTE, (French) a fissure in the earth emitting carbon dioxide, also MOFETTE [n]\n",
  "MOFFIE": "(South African) a homosexual [n -S]\n",
  "MOFFIES": "MOFFIE, (South African) a homosexual [n]\n",
  "MOFO": "(offensive US slang) an obnoxious person[n -S]\n",
  "MOFOS": "MOFO, (offensive US slang) an obnoxious person [n]\n",
  "MOFUSSIL": "(Urdu) in India, the rural localities of a district as distinguished from the chief station or the town [n -S]\n",
  "MOFUSSILS": "MOFUSSIL, (Urdu) in India, the rural localities of a district as distinguished from the chief station or the town [n]\n",
  "MOG": "to move away [v MOGGED, MOGGING, MOGS]\n",
  "MOGGAN": "(Scots) a footless stocking [n -S]\n",
  "MOGGANS": "MOGGAN, (Scots) a footless stocking [n]\n",
  "MOGGED": "MOG, to move away [v]\n",
  "MOGGIE": "(colloquial) a cat, also MOGGY [n -S]\n",
  "MOGGIES": "MOGGY, a cat, also MOGGIE [n]\n",
  "MOGGING": "MOG, to move away [v]\n",
  "MOGGY": "a cat, also MOGGIE [n MOGGIES]\n",
  "MOGHUL": "(Persian) an important person, also MOGUL, MUGHAL [n -S]\n",
  "MOGHULS": "MOGHUL, (Persian) an important person, also MOGUL, MUGHAL [n]\n",
  "MOGS": "MOG, to move away [v]\n",
  "MOGUL": "(Persian) an influential person, a magnate, also MOGHUL, MUGHAL [n -S]\n",
  "MOGULED": "having obstacles on a ski slope [adj]\n",
  "MOGULS": "MOGUL, (Persian) an influential person, a magnate, also MOGHUL, MUGHAL [n]\n",
  "MOHAIR": "(Arabic) a fabric made from the silky hair of angora goats [n -S]\n",
  "MOHAIRS": "MOHAIR, (Arabic) a fabric made from the silky hair of angora goats [n]\n",
  "MOHALIM": "MOHEL, (Hebrew) a person who performs Jewish circumcisions [n]\n",
  "MOHAWK": "(Native American) a skating movement [n -S]\n",
  "MOHAWKS": "MOHAWK, (Native American) a skating movement [n]\n",
  "MOHEL": "(Hebrew) a person who performs Jewish circumcisions [n MOHELS or MOHALIM or MOHELIM]\n",
  "MOHELIM": "MOHEL, (Hebrew) a person who performs Jewish circumcisions [n]\n",
  "MOHELS": "MOHEL, (Hebrew) a person who performs Jewish circumcisions [n]\n",
  "MOHICAN": "a punk hairstyle [n -S]\n",
  "MOHICANS": "MOHICAN, a punk hairstyle [n]\n",
  "MOHO": "a boundary separating the earth's crust and the mantle [n -S]\n",
  "MOHOS": "MOHO, a boundary separating the earth's crust and the mantle [n]\n",
  "MOHR": "(Arabic) a West African gazelle, also MHORR [n -S]\n",
  "MOHRS": "MOHR, (Arabic) a West African gazelle, also MHORR [n]\n",
  "MOHUA": "(Maori) a small New Zealand bird with yellow head and breast [n -S]\n",
  "MOHUAS": "MOHUA, (Maori) a small New Zealand bird with yellow head and breast [n]\n",
  "MOHUR": "(Persian) a former gold coin of India [n -S]\n",
  "MOHURS": "MOHUR, (Persian) a former gold coin of India [n]\n",
  "MOI": "(French) used to express surprise [interj]\n",
  "MOIDER": "to confuse, stupefy, also MITHER, MOITHER [v -ED, -ING, -S]\n",
  "MOIDERED": "MOIDER, to confuse, stupefy, also MITHER, MOITHER [v]\n",
  "MOIDERING": "MOIDER, to confuse, stupefy, also MITHER, MOITHER [v]\n",
  "MOIDERS": "MOIDER, to confuse, stupefy, also MITHER, MOITHER [v]\n",
  "MOIDORE": "(Portuguese) a former gold coin of Portugal [n -S]\n",
  "MOIDORES": "MOIDORE, (Portuguese) a former gold coin of Portugal [n]\n",
  "MOIETIES": "MOIETY, a half, also MOYITY [n]\n",
  "MOIETY": "a half, also MOYITY [n MOIETIES]\n",
  "MOIL": "to drudge, work hard [v -ED, -ING, -S]\n",
  "MOILE": "a type of rice pudding made with almond milk [n -S]\n",
  "MOILED": "MOIL, to drudge, work hard [v]\n",
  "MOILER": "one who moils, drudges [n -S]\n",
  "MOILERS": "MOILER, one who moils, drudges [n]\n",
  "MOILES": "MOILE, a type of rice pudding made with almond milk [n]\n",
  "MOILING": "MOIL, to drudge, work hard [v]\n",
  "MOILINGLY": "MOILING, MOIL, to drudge, work hard [adv]\n",
  "MOILS": "MOIL, to drudge, work hard [v]\n",
  "MOINEAU": "(French) a small flat bastion to protect a fortress under construction [n -S]\n",
  "MOINEAUS": "MOINEAU, (French) a small flat bastion to protect a fortress under construction [n]\n",
  "MOIRA": "(Greek) fate or destiny, in ancient Greek religion [n MOIRAI]\n",
  "MOIRAI": "MOIRA, (Greek) fate or destiny, in ancient Greek religion [n]\n",
  "MOIRE": "(French) a fabric having a wavy pattern [n -S]\n",
  "MOIRES": "MOIRE, (French) a fabric having a wavy pattern [n]\n",
  "MOISER": "(Yiddish) an informer [n -S]\n",
  "MOISERS": "MOISER, (Yiddish) an informer [n]\n",
  "MOIST": "slightly wet [adj MOISTER, MOISTEST, MOISTLY] / to wet slightly [v -ED, -ING, -S]\n",
  "MOISTED": "MOIST, to wet slightly [v]\n",
  "MOISTEN": "to make or become moist [v -ED, -ING, -S]\n",
  "MOISTENED": "MOISTEN, to make or become moist [v]\n",
  "MOISTENER": "something that moistens [n -S]\n",
  "MOISTENERS": "MOISTENER, something that moistens [n]\n",
  "MOISTENING": "MOISTEN, to make or become moist [v]\n",
  "MOISTENS": "MOISTEN, to make or become moist [v]\n",
  "MOISTER": "MOIST, slightly wet [adj]\n",
  "MOISTEST": "MOIST, slightly wet [adj]\n",
  "MOISTFUL": "full of moisture [adj]\n",
  "MOISTIFIED": "MOISTIFY, to make moist [v]\n",
  "MOISTIFIES": "MOISTIFY, to make moist [v]\n",
  "MOISTIFY": "to make moist [v MOISTIFIED, MOISTIFYING, MOISTIFIES]\n",
  "MOISTIFYING": "MOISTIFY, to make moist [v]\n",
  "MOISTING": "MOIST, to wet slightly [v]\n",
  "MOISTLY": "MOIST, slightly wet [adv]\n",
  "MOISTNESS": "the state of being moist [n -ES]\n",
  "MOISTNESSES": "MOISTNESS, the state of being moist [n]\n",
  "MOISTS": "MOIST, to wet slightly [v]\n",
  "MOISTURE": "moistness from liquid [n -S]\n",
  "MOISTURELESS": "without moisture [adj]\n",
  "MOISTURES": "MOISTURE, moistness from liquid [n]\n",
  "MOISTURISE": "to add moisture to, also MOISTURIZE [v MOISTURISED, MOISTURISING, MOISTURISES]\n",
  "MOISTURISED": "MOISTURISE, to add moisture to, also MOISTURIZE [v]\n",
  "MOISTURISER": "an agent for moisturising, also MOISTURIZER [n -S]\n",
  "MOISTURISERS": "MOISTURISER, an agent for moisturising, also MOISTURIZER [n]\n",
  "MOISTURISES": "MOISTURISE, to add moisture to, also MOISTURIZE [v]\n",
  "MOISTURISING": "MOISTURISE, to add moisture to, also MOISTURIZE [v]\n",
  "MOISTURIZE": "to add moisture to, also MOISTURISE [v MOISTURIZED, MOISTURIZING, MOISTURIZES]\n",
  "MOISTURIZED": "MOISTURIZE, to add moisture to, also MOISTURISE [v]\n",
  "MOISTURIZER": "an agent for moisturising, also MOISTURISER [n -S]\n",
  "MOISTURIZERS": "MOISTURIZER, an agent for moisturising, also MOISTURISER [n]\n",
  "MOISTURIZES": "MOISTURIZE, to add moisture to, also MOISTURISE [v]\n",
  "MOISTURIZING": "MOISTURIZE, to add moisture to, also MOISTURISE [v]\n",
  "MOIT": "(dialect) a foreign particle in wool [n -S]\n",
  "MOITHER": "to confuse, stupefy, also MITHER, MOIDER [v -ED, -ING, -S]\n",
  "MOITHERED": "MOITHER, to confuse, stupefy, also MITHER, MOIDER [v]\n",
  "MOITHERING": "MOITHER, to confuse, stupefy, also MITHER, MOIDER [v]\n",
  "MOITHERS": "MOITHER, to confuse, stupefy, also MITHER, MOIDER [v]\n",
  "MOITS": "MOIT, (dialect) a foreign particle in wool [n]\n",
  "MOJAHEDIN": "fundamentalist Muslim guerrillas, also MUJAHEDDIN, MUJAHEDEEN, MUJAHEDIN, MUJAHIDEEN, MUJAHIDIN [n]\n",
  "MOJARRA": "(Spanish) any of various small percoid fishes of the family Gerreidae [n -S]\n",
  "MOJARRAS": "MOJARRA, (Spanish) any of various small percoid fishes of the family Gerreidae [n]\n",
  "MOJITO": "a traditional Cuban cocktail [n -S]\n",
  "MOJITOS": "MOJITO, a traditional Cuban cocktail [n]\n",
  "MOJO": "a magic charm [n -ES or -S]\n",
  "MOJOES": "MOJO, a magic charm [n]\n",
  "MOJOS": "MOJO, a magic charm [n]\n",
  "MOKADDAM": "(Arabic) a leader, headman, also MOCUDDUM, MUQADDAM [n -S]\n",
  "MOKADDAMS": "MOKADDAM, (Arabic) a leader, headman, also MOCUDDUM, MUQADDAM [n]\n",
  "MOKE": "a donkey [n -S]\n",
  "MOKES": "MOKE, a donkey [n]\n",
  "MOKI": "(Maori) a New Zealand sea fish, aka nanua [n -S]\n",
  "MOKIHI": "(Maori) a Maori raft [n -S]\n",
  "MOKIHIS": "MOKIHI, (Maori) a Maori raft [n]\n",
  "MOKIS": "MOKI, (Maori) a New Zealand sea fish, aka nanua [n]\n",
  "MOKO": "(Maori) a system of tattooing practised by the Maoris [n -S]\n",
  "MOKOMOKO": "(Maori) a type of skink found in New Zealand [n -S]\n",
  "MOKOMOKOS": "MOKOMOKO, (Maori) a type of skink found in New Zealand [n]\n",
  "MOKOPUNA": "(Maori) a grandchild or young person [n -S]\n",
  "MOKOPUNAS": "MOKOPUNA, (Maori) a grandchild or young person [n]\n",
  "MOKORO": "the traditional dugout canoe of the people of the Okavango Delta [n -S]\n",
  "MOKOROS": "MOKORO, the traditional dugout canoe of the people of the Okavango Delta [n]\n",
  "MOKOS": "MOKO, (Maori) a system of tattooing practised by the Maoris [n]\n",
  "MOKSHA": "(Hindu) freedom from the endless cycle of transmigration [n -S]\n",
  "MOKSHAS": "MOKSHA, (Hindu) freedom from the endless cycle of transmigration [n]\n",
  "MOL": "a unit of molecular concentration [n -S]\n",
  "MOLA": "a brightly-coloured applique or embroidered panel made by Cuna Indian women of Panama [n -S]\n",
  "MOLAL": "relating to a mole, a molecular weight [adj]\n",
  "MOLALITIES": "MOLALITY, the number of moles of solute per litre of solvent, also MOLARITY [n]\n",
  "MOLALITY": "the number of moles of solute per litre of solvent, also MOLARITY [n MOLALITIES]\n",
  "MOLAR": "a grinding tooth [n -S]\n",
  "MOLARITIES": "MOLARITY, the number of moles of solute per litre of solvent, also MOLALITY [n]\n",
  "MOLARITY": "the number of moles of solute per litre of solvent, also MOLALITY [n MOLARITIES]\n",
  "MOLARS": "MOLAR, a grinding tooth [n]\n",
  "MOLAS": "MOLA, a brightly-coloured applique or embroidered panel made by Cuna Indian women of Panama [n]\n",
  "MOLASSE": "soft sediment produced by the erosion of mountain ranges in the final stage of mountain building [n -S]\n",
  "MOLASSES": "a thick dark treacle that is drained from sugar during refining [n -ES]\n",
  "MOLASSESES": "MOLASSES, a thick dark treacle that is drained from sugar during refining [n]\n",
  "MOLD": "to work into a particular shape, also MOULD [v -ED, -ING, -S]\n",
  "MOLDABILITIES": "MOLDABILITY, the quality of being moldable, also MOULDABILITY [n]\n",
  "MOLDABILITY": "the quality of being moldable, also MOULDABILITY [n MOLDABILITIES]\n",
  "MOLDABLE": "able to be molded [adj]\n",
  "MOLDAVITE": "a green tektite found in the Czech republic, thought to be the product of an ancient meteorite impact in Germany [n -S]\n",
  "MOLDAVITES": "MOLDAVITE, a green tektite found in the Czech republic, thought to be the product of an ancient meteorite impact in Germany [n]\n",
  "MOLDBOARD": "a curved plate of iron (originally of wood) back of the share of a plow, which turns over the earth in plowing, also MOULDBOARD [n -S]\n",
  "MOLDBOARDS": "MOLDBOARD, a curved plate of iron (originally of wood) back of the share of a plow, which turns over the earth in plowing, also MOULDBOARD [n]\n",
  "MOLDED": "MOLD, to work into a particular shape, also MOULD [v]\n",
  "MOLDER": "to turn to dust by natural decay, also MOULDER [v -ED, -ING, -S]\n",
  "MOLDERED": "MOLDER, to turn to dust by natural decay, also MOULDER [v]\n",
  "MOLDERING": "MOLDER, to turn to dust by natural decay, also MOULDER [v]\n",
  "MOLDERS": "MOLDER, to turn to dust by natural decay, also MOULDER [v]\n",
  "MOLDIER": "MOLDY, mouldy [adj]\n",
  "MOLDIEST": "MOLDY, mouldy [adj]\n",
  "MOLDINESS": "the state of being moldy, also MOULDINESS [n -ES]\n",
  "MOLDINESSES": "MOLDINESS, the state of being moldy, also MOULDINESS [n]\n",
  "MOLDING": "a long, narrow strip used to decorate a surface, also MOULDING [n -S]\n",
  "MOLDINGS": "MOLDING, a long, narrow strip used to decorate a surface, also MOULDING [n]\n",
  "MOLDS": "MOLD, to work into a particular shape, also MOULD [v]\n",
  "MOLDWARP": "(dialect) a mole, also MODIWORT, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOLDWARPS": "MOLDWARP, (dialect) a mole, also MODIWORT, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOLDY": "mouldy [adj MOLDIER, MOLDIEST]\n",
  "MOLE": "the quantity of a compound that has a weight equal to the compound's molecular weight [n -S] / to elicit bit by bit [v MOLED, MOLING, MOLES]\n",
  "MOLECAST": "a little elevation of earth made by a mole, also MOLEHILL [n -S]\n",
  "MOLECASTS": "MOLECAST, a little elevation of earth made by a mole, also MOLEHILL [n]\n",
  "MOLECATCHER": "a person whose business is to catch moles [n -S]\n",
  "MOLECATCHERS": "MOLECATCHER, a person whose business is to catch moles [n]\n",
  "MOLECULAR": "relating to a molecule [adj MOLECULARLY]\n",
  "MOLECULARITIES": "MOLECULARITY, the state of being molecular [n]\n",
  "MOLECULARITY": "the state of being molecular [n MOLECULARITIES]\n",
  "MOLECULARLY": "MOLECULAR, relating to a molecule [adv]\n",
  "MOLECULE": "the smallest unit of matter that has the chemical and physical properties of a particular chemical compound [n -S]\n",
  "MOLECULES": "MOLECULE, the smallest unit of matter that has the chemical and physical properties of a particular chemical compound [n]\n",
  "MOLED": "MOLE, to elicit bit by bit [v]\n",
  "MOLEHILL": "a little elevation of earth made by a mole, also MOLECAST [n -S]\n",
  "MOLEHILLS": "MOLEHILL, a little elevation of earth made by a mole, also MOLECAST [n]\n",
  "MOLEHUNT": "a hunt for moles [n -S]\n",
  "MOLEHUNTS": "MOLEHUNT, a hunt for moles [n]\n",
  "MOLELIKE": "like a mole [adj]\n",
  "MOLENDINAR": "a molar tooth [n -S]\n",
  "MOLENDINARIES": "MOLENDINARY, a mill [n]\n",
  "MOLENDINARS": "MOLENDINAR, a molar tooth [n]\n",
  "MOLENDINARY": "belonging to a mill [adj] / a mill [n MOLENDINARIES]\n",
  "MOLES": "MOLE, the quantity of a compound that has a weight equal to the compound's molecular weight [n]\n",
  "MOLESKIN": "a heavy durable cotton [n -S]\n",
  "MOLESKINS": "MOLESKIN, a heavy durable cotton [n]\n",
  "MOLEST": "to touch or interfere with [v -ED, -ING, -S]\n",
  "MOLESTATION": "the act of molesting [n -S]\n",
  "MOLESTATIONS": "MOLESTATION, the act of molesting [n]\n",
  "MOLESTED": "MOLEST, to touch or interfere with [v]\n",
  "MOLESTER": "one who molests [n -S]\n",
  "MOLESTERS": "MOLESTER, one who molests [n]\n",
  "MOLESTFUL": "troublesome, vexatious [adj]\n",
  "MOLESTING": "MOLEST, to touch or interfere with [v]\n",
  "MOLESTS": "MOLEST, to touch or interfere with [v]\n",
  "MOLIES": "MOLY, a magical herb given by Hermes to Odysseus against the charms of Circe; a species of wild onion [n]\n",
  "MOLIMEN": "(Latin) a great effort, esp. any physical effort made by the body in carrying out a natural function [n -S]\n",
  "MOLIMENS": "MOLIMEN, (Latin) a great effort, esp. any physical effort made by the body in carrying out a natural function [n]\n",
  "MOLIMINOUS": "massive; laborious [adj]\n",
  "MOLINE": "a cross with two outward curving branches [n -S]\n",
  "MOLINES": "MOLINE, a cross with two outward curving branches [n]\n",
  "MOLINET": "(French) a stick used to whip drinking chocolate in the 18th century [n -S]\n",
  "MOLINETS": "MOLINET, (French) a stick used to whip drinking chocolate in the 18th century [n]\n",
  "MOLING": "MOLE, to elicit bit by bit [v]\n",
  "MOLL": "a gangster's girlfriend [n -S]\n",
  "MOLLA": "(Arabic) a Muslim learned in theology and law, also MOLLAH, MOOLAH, MULLA, MULLAH, MULLER [n -S]\n",
  "MOLLAH": "(Arabic) a Muslim learned in theology and law, also MOLLA, MOOLAH, MULLA, MULLAH, MULLER [n -S]\n",
  "MOLLAHS": "MOLLAH, (Arabic) a Muslim learned in theology and law, also MOLLA, MOOLAH, MULLA, MULLAH, MULLER [n]\n",
  "MOLLAS": "MOLLA, (Arabic) a Muslim learned in theology and law, also MOLLAH, MOOLAH, MULLA, MULLAH, MULLER [n]\n",
  "MOLLIE": "the carousing of seamen in icebound ships, also MALLEMAROKING [n -S]\n",
  "MOLLIES": "MOLLY, a kind of tropical fish [n]\n",
  "MOLLIFIABLE": "that can be mollified [adj]\n",
  "MOLLIFICATION": "the act of mollifying [n -S]\n",
  "MOLLIFICATIONS": "MOLLIFICATION, the act of mollifying [n]\n",
  "MOLLIFIED": "MOLLIFY, to soften, appease [v]\n",
  "MOLLIFIER": "one who mollifies [n -S]\n",
  "MOLLIFIERS": "MOLLIFIER, one who mollifies [n]\n",
  "MOLLIFIES": "MOLLIFY, to soften, appease [v]\n",
  "MOLLIFY": "to soften, appease [v MOLLIFIED, MOLLIFYING, MOLLIFIES]\n",
  "MOLLIFYING": "MOLLIFY, to soften, appease [v]\n",
  "MOLLITIES": "(archaic) in medicine, a softness, a softening [n]\n",
  "MOLLITIOUS": "softening; voluptuous [adj]\n",
  "MOLLS": "MOLL, a gangster's girlfriend [n]\n",
  "MOLLUSC": "(Latin) an animal belonging to a large phylum of invertebrates that includes snails, shellfish etc., also MOLLUSK [n -S]\n",
  "MOLLUSCA": "MOLLUSCUM, a childhood skin problem causing small raised spots [n]\n",
  "MOLLUSCAN": "related to the mollusc family [adj] / a member of the mollusc family, also MOLLUSKAN [n -S]\n",
  "MOLLUSCANS": "MOLLUSCAN, a member of the mollusc family, also MOLLUSKAN [n]\n",
  "MOLLUSCICIDAL": "relating to molluscicide, the killing of molluscs [adj]\n",
  "MOLLUSCICIDE": "the killing of molluscs [n -S]\n",
  "MOLLUSCICIDES": "MOLLUSCICIDE, the killing of molluscs [n]\n",
  "MOLLUSCOID": "a member of a now abandoned division of invertebrates of the Molluscoidea, Polyzoa and brachiopods [n -S]\n",
  "MOLLUSCOIDAL": "like a mollusc [adj]\n",
  "MOLLUSCOIDS": "MOLLUSCOID, a member of a now abandoned division of invertebrates of the Molluscoidea, Polyzoa and brachiopods [n]\n",
  "MOLLUSCOUS": "like a mollusc [adj]\n",
  "MOLLUSCS": "MOLLUSC, (Latin) an animal belonging to a large phylum of invertebrates that includes snails, shellfish etc., also MOLLUSK [n]\n",
  "MOLLUSCUM": "a childhood skin problem causing small raised spots [n MOLLUSCA]\n",
  "MOLLUSK": "(Latin) an animal belonging to the large phylum of invertebrates, also MOLLUSC [n -S]\n",
  "MOLLUSKAN": "related to the mollusc family [adj] / a member of the mollusc family, also MOLLUSCAN [n -S]\n",
  "MOLLUSKANS": "MOLLUSKAN, a member of the mollusc family, also MOLLUSCAN [n]\n",
  "MOLLUSKS": "MOLLUSK, (Latin) an animal belonging to the large phylum of invertebrates, also MOLLUSC [n]\n",
  "MOLLY": "a kind of tropical fish [n MOLLIES]\n",
  "MOLLYCODDLE": "an effeminate man [n -S] / to cosset someone [v MOLLYCODDLED, MOLLYCODDLING, MOLLYCODDLES]\n",
  "MOLLYCODDLED": "MOLLYCODDLE, to cosset someone [v]\n",
  "MOLLYCODDLER": "one who mollycoddles [n -S]\n",
  "MOLLYCODDLERS": "MOLLYCODDLER, one who mollycoddles [n]\n",
  "MOLLYCODDLES": "MOLLYCODDLE, an effeminate man [n]\n",
  "MOLLYCODDLING": "the act of cosseting [n -S]\n",
  "MOLLYCODDLINGS": "MOLLYCODDLING, the act of cosseting [n]\n",
  "MOLLYHAWK": "the juvenile of the southern black-backed gull [n -S]\n",
  "MOLLYHAWKS": "MOLLYHAWK, the juvenile of the southern black-backed gull [n]\n",
  "MOLLYMAWK": "(Dutch) the fulmar or similar bird, also MALLEMUCK [n -S]\n",
  "MOLLYMAWKS": "MOLLYMAWK, (Dutch) the fulmar or similar bird, also MALLEMUCK [n]\n",
  "MOLOCH": "a spiny Australian lizard [n -S]\n",
  "MOLOCHISE": "to sacrifice (as to Moloch), also MOLOCHIZE [v MOLOCHISED, MOLOCHISING, MOLOCHISES]\n",
  "MOLOCHISED": "MOLOCHISE, to sacrifice (as to Moloch), also MOLOCHIZE [v]\n",
  "MOLOCHISES": "MOLOCHISE, to sacrifice (as to Moloch), also MOLOCHIZE [v]\n",
  "MOLOCHISING": "MOLOCHISE, to sacrifice (as to Moloch), also MOLOCHIZE [v]\n",
  "MOLOCHIZE": "to sacrifice (as to Moloch), also MOLOCHISE [v MOLOCHIZED, MOLOCHIZING, MOLOCHIZES]\n",
  "MOLOCHIZED": "MOLOCHIZE, to sacrifice (as to Moloch), also MOLOCHISE [v]\n",
  "MOLOCHIZES": "MOLOCHIZE, to sacrifice (as to Moloch), also MOLOCHISE [v]\n",
  "MOLOCHIZING": "MOLOCHIZE, to sacrifice (as to Moloch), also MOLOCHISE [v]\n",
  "MOLOCHS": "MOLOCH, a spiny Australian lizard [n]\n",
  "MOLOSSI": "MOLOSSUS, (Greek) a metrical foot of three long syllables [n]\n",
  "MOLOSSUS": "(Greek) a metrical foot of three long syllables [n MOLOSSI]\n",
  "MOLS": "MOL, a unit of molecular concentration [n]\n",
  "MOLT": "to shed feathers or fur, also MOULT [v -ED, -ING, -S]\n",
  "MOLTED": "MOLT, to shed feathers or fur, also MOULT [v]\n",
  "MOLTEN": "made liquid by heat [adj MOLTENLY]\n",
  "MOLTENLY": "MOLTEN, made liquid by heat [adv]\n",
  "MOLTER": "one that molts, also MOULTER [n -S]\n",
  "MOLTERS": "MOLTER, one that molts, also MOULTER [n]\n",
  "MOLTING": "MOLT, to shed feathers or fur, also MOULT [v]\n",
  "MOLTO": "(Italian) very (music) [adv]\n",
  "MOLTS": "MOLT, to shed feathers or fur, also MOULT [v]\n",
  "MOLY": "a magical herb given by Hermes to Odysseus against the charms of Circe; a species of wild onion [n MOLIES] / (short for) molybdenum [n MOLYS]\n",
  "MOLYBDATE": "a salt of molybdic acid [n -S]\n",
  "MOLYBDATES": "MOLYBDATE, a salt of molybdic acid [n]\n",
  "MOLYBDENITE": "a sulphide of molybdenum [n -S]\n",
  "MOLYBDENITES": "MOLYBDENITE, a sulphide of molybdenum [n]\n",
  "MOLYBDENOSES": "MOLYBDENOSIS, a disease of cattle and sheep, caused by an excess of molybdenum in the diet [n]\n",
  "MOLYBDENOSIS": "a disease of cattle and sheep, caused by an excess of molybdenum in the diet [n MOLYBDENOSES]\n",
  "MOLYBDENOUS": "containing molybdenum [adj]\n",
  "MOLYBDENUM": "a rare element of the chromium group [n -S]\n",
  "MOLYBDENUMS": "MOLYBDENUM, a rare element of the chromium group [n]\n",
  "MOLYBDIC": "pertaining to a certain metallic element [adj]\n",
  "MOLYBDOSES": "MOLYBDOSIS, lead poisoning [n]\n",
  "MOLYBDOSIS": "lead poisoning [n MOLYBDOSES]\n",
  "MOLYBDOUS": "of molybdenum of lower valency [adj]\n",
  "MOLYS": "MOLY, a magical herb given by Hermes to Odysseus against the charms of Circe; a species of wild onion [n]\n",
  "MOM": "(US colloquial) mother [n -S]\n",
  "MOME": "(obsolete) a stupid person [n -S]\n",
  "MOMENT": "a brief period of time [n -S]\n",
  "MOMENTA": "MOMENTUM, (Latin) force of movement [n]\n",
  "MOMENTANEOUS": "momentary; instantaneous [adj]\n",
  "MOMENTANY": "(Shakespeare) momentary [adj]\n",
  "MOMENTARILY": "MOMENTARY, lasting for a moment [adv]\n",
  "MOMENTARINESS": "the state of being momentary [n -ES]\n",
  "MOMENTARINESSES": "MOMENTARINESS, the state of being momentary [n]\n",
  "MOMENTARY": "lasting for a moment [adj MOMENTARILY]\n",
  "MOMENTLY": "from moment to moment [adv]\n",
  "MOMENTO": "something kept or given as a reminder, also MEMENTO [n -ES or -S]\n",
  "MOMENTOES": "MOMENTO, something kept or given as a reminder, also MEMENTO [n]\n",
  "MOMENTOS": "MOMENTO, something kept or given as a reminder, also MEMENTO [n]\n",
  "MOMENTOUS": "of great consequence [adj MOMENTOUSLY]\n",
  "MOMENTOUSLY": "MOMENTOUS, of great consequence [adv]\n",
  "MOMENTOUSNESS": "MOMENTOUS, of great consequence [n]\n",
  "MOMENTOUSNESSES": "MOMENTOUSNESS, MOMENTOUS, of great consequence [n]\n",
  "MOMENTS": "MOMENT, a brief period of time [n]\n",
  "MOMENTUM": "(Latin) force of movement [n MOMENTUMS or MOMENTA]\n",
  "MOMENTUMS": "MOMENTUM, (Latin) force of movement [n]\n",
  "MOMES": "MOME, (obsolete) a stupid person [n]\n",
  "MOMI": "MOMUS, (Greek) a carping person [n]\n",
  "MOMISM": "an excessive dependence on mothers [n -S]\n",
  "MOMISMS": "MOMISM, an excessive dependence on mothers [n]\n",
  "MOMMA": "(colloquial) mother, also MOMMY [n -S]\n",
  "MOMMAS": "MOMMA, (colloquial) mother, also MOMMY [n]\n",
  "MOMMET": "a puppet; a doll, also MAMMET, MAUMET, MAWMET [n -S]\n",
  "MOMMETS": "MOMMET, a puppet; a doll, also MAMMET, MAUMET, MAWMET [n]\n",
  "MOMMIES": "MOMMY, (colloquial) mother, also MOMMA [n]\n",
  "MOMMY": "(colloquial) mother, also MOMMA [n MOMMIES]\n",
  "MOMOIR": "a memoir written by a mother, concentrating on the experience of motherhood [n -S]\n",
  "MOMOIRS": "MOMOIR, a memoir written by a mother, concentrating on the experience of motherhood [n]\n",
  "MOMPRENEUR": "a woman who combines running a business enterprise with looking after her children, also MUMPRENEUR [n -S]\n",
  "MOMPRENEURS": "MOMPRENEUR, a woman who combines running a business enterprise with looking after her children, also MUMPRENEUR [n]\n",
  "MOMS": "MOM, (US colloquial) mother [n]\n",
  "MOMSER": "(Yiddish) an illegitimate child; a despicable person, also MAMZER, MOMZER [n -S]\n",
  "MOMSERS": "MOMSER, (Yiddish) an illegitimate child; a despicable person, also MAMZER, MOMZER [n]\n",
  "MOMUS": "(Greek) a carping person [n MOMUSES or MOMI]\n",
  "MOMUSES": "MOMUS, (Greek) a carping person [n]\n",
  "MOMZER": "(Yiddish) an illegitimate child; a despicable person, also MAMZER, MOMSER [n MOMZERS or MOMZERIM]\n",
  "MOMZERIM": "MOMZER, (Yiddish) an illegitimate child; a despicable person, also MAMZER, MOMSER [n]\n",
  "MOMZERS": "MOMZER, (Yiddish) an illegitimate child; a despicable person, also MAMZER, MOMSER [n]\n",
  "MON": "(Japanese) a family badge or crest [n MON]\n",
  "MONA": "(Spanish) a West African monkey [n -S]\n",
  "MONACHAL": "of or pertaining to monks or a monastic life [adj]\n",
  "MONACHISM": "the monastic system or mode of life, also MONASTICISM [n -S]\n",
  "MONACHISMS": "MONACHISM, the monastic system or mode of life, also MONASTICISM [n]\n",
  "MONACHIST": "an adherent of monachism [n -S]\n",
  "MONACHISTS": "MONACHIST, an adherent of monachism [n]\n",
  "MONACID": "a compound having one hydrogen atom replaceable by a negative or acid atom or radical, also MONOACID [n -S]\n",
  "MONACIDIC": "designating a compound having one hydrogen atom replaceable by a negative or acid atom or radical [adj]\n",
  "MONACIDS": "MONACID, a compound having one hydrogen atom replaceable by a negative or acid atom or radical, also MONOACID [n]\n",
  "MONACT": "the spicule of a sponge that has a single-spiked structure, also MONACTINE [n -S]\n",
  "MONACTINAL": "of a sponge, having single-rayed spicules, also MONACT, MONACTINE [adj]\n",
  "MONACTINE": "the spicule of a sponge that has a single-spiked structure, also MONACT [n -S]\n",
  "MONACTINES": "MONACTINE, the spicule of a sponge that has a single-spiked structure, also MONACT [n]\n",
  "MONACTS": "MONACT, the spicule of a sponge that has a single-spiked structure, also MONACTINE [n]\n",
  "MONAD": "the number one; a unit; a single-celled organism, also MONAS [n MONADS or MONADES]\n",
  "MONADAL": "relating to a monad [adj]\n",
  "MONADELPHOUS": "united by filaments into a single stamen [adj]\n",
  "MONADES": "MONAS, the number one; a unit; a single-celled organism, also MONAD [n]\n",
  "MONADIC": "of a mathematical function, taking one argument, cf. polyadic [adj]\n",
  "MONADICAL": "of, pertaining to, or like, a monad, in any of its senses, also MONADIC [adj MONADICALLY]\n",
  "MONADICALLY": "MONADICAL, of, pertaining to, or like, a monad, in any of its senses, also MONADIC [adv]\n",
  "MONADIFORM": "having the form of a monad [adj]\n",
  "MONADISM": "the theory that there exist ultimate units of being [n -S]\n",
  "MONADISMS": "MONADISM, the theory that there exist ultimate units of being [n]\n",
  "MONADISTIC": "relating to monadism, the theory that there exist ultimate units of being [adj]\n",
  "MONADNOCK": "a mountain or rocky mass that has resisted erosion and stands isolated in an essentially level area, aka inselberg [n -S]\n",
  "MONADNOCKS": "MONADNOCK, a mountain or rocky mass that has resisted erosion and stands isolated in an essentially level area, aka inselberg [n]\n",
  "MONADOLOGIES": "MONADOLOGY, the doctrine or theory of monads [n]\n",
  "MONADOLOGY": "the doctrine or theory of monads [n MONADOLOGIES]\n",
  "MONADS": "MONAD, the number one; a unit; a single-celled organism, also MONAS [n]\n",
  "MONAL": "(Nepali) a Himalayan pheasant, also MONAUL [n -S]\n",
  "MONALS": "MONAL, (Nepali) a Himalayan pheasant, also MONAUL [n]\n",
  "MONAMINE": "an amine containing only one amino group [n -S]\n",
  "MONAMINES": "MONAMINE, an amine containing only one amino group [n]\n",
  "MONANDRIES": "MONANDRY, the condition of having one husband at a time [n]\n",
  "MONANDROUS": "having only one stamen [adj]\n",
  "MONANDRY": "the condition of having one husband at a time [n MONANDRIES]\n",
  "MONANTHOUS": "of certain plants, having or producing only one flower [adj]\n",
  "MONARCH": "an absolute ruler [n -S]\n",
  "MONARCHAL": "pertaining to a monarch, ruling alone, also MONARCHIC [adj MONARCHALLY]\n",
  "MONARCHALLY": "MONARCHAL, pertaining to a monarch, ruling alone, also MONARCHIC [adv]\n",
  "MONARCHIAL": "relating to monarchy, also MONARCHICAL [adj]\n",
  "MONARCHIC": "pertaining to a monarch, ruling alone, also MONARCHAL [adj MONARCHICALLY]\n",
  "MONARCHICAL": "relating to monarchy, also MONARCHIAL [adj MONARCHICALLY]\n",
  "MONARCHICALLY": "MONARCHICAL, relating to monarchy, also MONARCHIAL [adv]\n",
  "MONARCHIES": "MONARCHY, rule by a monarch [n]\n",
  "MONARCHISE": "to play the sovereign; to act the monarch, also MONARCHIZE [v MONARCHISED, MONARCHISING, MONARCHISES]\n",
  "MONARCHISED": "MONARCHISE, to play the sovereign; to act the monarch, also MONARCHIZE [v]\n",
  "MONARCHISES": "MONARCHISE, to play the sovereign; to act the monarch, also MONARCHIZE [v]\n",
  "MONARCHISING": "MONARCHISE, to play the sovereign; to act the monarch, also MONARCHIZE [v]\n",
  "MONARCHISM": "monarchical government or principles [n -S]\n",
  "MONARCHISMS": "MONARCHISM, monarchical government or principles [n]\n",
  "MONARCHIST": "a supporter of monarchism [n -S]\n",
  "MONARCHISTIC": "relating to monarchism, monarchical government or principles [adj]\n",
  "MONARCHISTS": "MONARCHIST, a supporter of monarchism [n]\n",
  "MONARCHIZE": "to play the sovereign; to act the monarch, also MONARCHISE [v MONARCHIZED, MONARCHIZING, MONARCHIZES]\n",
  "MONARCHIZED": "MONARCHIZE, to play the sovereign; to act the monarch, also MONARCHISE [v]\n",
  "MONARCHIZES": "MONARCHIZE, to play the sovereign; to act the monarch, also MONARCHISE [v]\n",
  "MONARCHIZING": "MONARCHIZE, to play the sovereign; to act the monarch, also MONARCHISE [v]\n",
  "MONARCHS": "MONARCH, an absolute ruler [n]\n",
  "MONARCHY": "rule by a monarch [n MONARCHIES]\n",
  "MONARDA": "a plant of the Monarda genus of North American aromatic herbs of the mint family [n -S]\n",
  "MONARDAS": "MONARDA, a plant of the Monarda genus of North American aromatic herbs of the mint family [n]\n",
  "MONAS": "the number one; a unit; a single-celled organism, also MONAD [n MONADES or MONASES]\n",
  "MONASES": "MONAS, the number one; a unit; a single-celled organism, also MONAD [n]\n",
  "MONASTERIAL": "relating to monasteries [adj]\n",
  "MONASTERIES": "MONASTERY, the residence of a religious community, esp. of monks, living in seclusion from secular society and bound by religious vows [n]\n",
  "MONASTERY": "the residence of a religious community, esp. of monks, living in seclusion from secular society and bound by religious vows [n MONASTERIES]\n",
  "MONASTIC": "relating to monks [adj MONASTICALLY] / a monk [n -S]\n",
  "MONASTICAL": "of or pertaining to monasteries [adj MONASTICALLY]\n",
  "MONASTICALLY": "MONASTICAL, of or pertaining to monasteries [adv]\n",
  "MONASTICISM": "the monastic system or mode of life, also MONACHISM [n -S]\n",
  "MONASTICISMS": "MONASTICISM, the monastic system or mode of life, also MONACHISM [n]\n",
  "MONASTICS": "MONASTIC, a monk [n]\n",
  "MONATOMIC": "consisting of, or containing, one atom; as, the molecule of mercury is monatomic, also MONOATOMIC [adj]\n",
  "MONAUL": "(Nepali) a kind of pheasant, native to the Himalayas, also MONAL [n -S]\n",
  "MONAULS": "MONAUL, (Nepali) a kind of pheasant, native to the Himalayas, also MONAL [n]\n",
  "MONAURAL": "monophonic, pertaining to one ear [adj MONAURALLY]\n",
  "MONAURALLY": "MONAURAL, monophonic, pertaining to one ear [adv]\n",
  "MONAXIAL": "having only one axis; developing along a single line, also MONAXONIC [adj]\n",
  "MONAXON": "a straight spicule in sponges [n -S]\n",
  "MONAXONIC": "having only one axis; developing along a single line, also MONAXIAL [adj]\n",
  "MONAXONS": "MONAXON, a straight spicule in sponges [n]\n",
  "MONAZITE": "a phosphate of cerium, lanthanum, other rare-earth elements, and thorium [n -S]\n",
  "MONAZITES": "MONAZITE, a phosphate of cerium, lanthanum, other rare-earth elements, and thorium [n]\n",
  "MONCHIQUITE": "a fine-grained rock composed of olivine and augite [n -S]\n",
  "MONCHIQUITES": "MONCHIQUITE, a fine-grained rock composed of olivine and augite [n]\n",
  "MONDAIN": "(French) a (male) person who lives in fashionable society, also MONDAINE [n -S]\n",
  "MONDAINE": "(French) a (female) person who lives in fashionable society, also MONDAIN [n -S]\n",
  "MONDAINES": "MONDAINE, (French) a (female) person who lives in fashionable society, also MONDAIN [n]\n",
  "MONDAINS": "MONDAIN, (French) a (male) person who lives in fashionable society, also MONDAINE [n]\n",
  "MONDE": "(French) the world; a globe as an ensign of royalty [n -S]\n",
  "MONDEGREEN": "a phrase, often humorous or nonsensical, that results from mishearing the lyric of a song [n -S]\n",
  "MONDEGREENS": "MONDEGREEN, a phrase, often humorous or nonsensical, that results from mishearing the lyric of a song [n]\n",
  "MONDES": "MONDE, (French) the world; a globe as an ensign of royalty [n]\n",
  "MONDIAL": "(French) worldwide [adj]\n",
  "MONDO": "a Zen Buddhism question and answer technique [n -S]\n",
  "MONDOS": "MONDO, a Zen Buddhism question and answer technique [n]\n",
  "MONECIAN": "having separate male and female flowers on the same plant, also MONECIOUS, MONOECIOUS, MONOICOUS [adj]\n",
  "MONECIOUS": "having separate male and female flowers on the same plant, also MONECIAN, MONOECIOUS, MONOICOUS [adj MONECIOUSLY]\n",
  "MONECIOUSLY": "MONECIOUS, having separate male and female flowers on the same plant, also MONECIAN, MONOECIOUS, MONOICOUS [adv]\n",
  "MONELLIN": "a protein extracted from a West African red berry [n -S]\n",
  "MONELLINS": "MONELLIN, a protein extracted from a West African red berry [n]\n",
  "MONEME": "a word or part of a word that contains no smaller unit of meaning [n -S]\n",
  "MONEMES": "MONEME, a word or part of a word that contains no smaller unit of meaning [n]\n",
  "MONER": "a hypothetical simplest protozoan, the organism on which Hackel's version of the evolution theory is based, also MONERAN, MONERON [n MONERA]\n",
  "MONERA": "MONER, a hypothetical simplest protozoan, the organism on which Hackel's version of the evolution theory is based, also MONERAN, MONERON [n]\n",
  "MONERAN": "a cellular organism that does not have a distinct nucleus [n -S]\n",
  "MONERANS": "MONERAN, a cellular organism that does not have a distinct nucleus [n]\n",
  "MONERGISM": "the theory that the Holy Spirit alone can act [n -S]\n",
  "MONERGISMS": "MONERGISM, the theory that the Holy Spirit alone can act [n]\n",
  "MONERON": "a hypothetical simplest protozoan, the organism on which Hackel's version of the evolution theory is based, also MONER, MONERAN [n MONERA]\n",
  "MONESTROUS": "of or related to mammals which experience one estrus (rut or period of heat) in a breeding season [adj]\n",
  "MONETARILY": "MONETARY, pertaining to money [adv]\n",
  "MONETARISM": "an economic policy based on control of the country's money supply [n -S]\n",
  "MONETARISMS": "MONETARISM, an economic policy based on control of the country's money supply [n]\n",
  "MONETARIST": "an advocate of monetarism [n -S]\n",
  "MONETARISTS": "MONETARIST, an advocate of monetarism [n]\n",
  "MONETARY": "pertaining to money [adj MONETARILY]\n",
  "MONETH": "(Spenser) a month [n -S]\n",
  "MONETHS": "MONETH, (Spenser) a month [n]\n",
  "MONETISATION": "the act of monetising, also MONETIZATION [n -S]\n",
  "MONETISATIONS": "MONETISATION, the act of monetising, also MONETIZATION [n]\n",
  "MONETISE": "to coin into money, also MONETIZE [v MONETISED, MONETISING, MONETISES]\n",
  "MONETISED": "MONETISE, to coin into money, also MONETIZE [v]\n",
  "MONETISES": "MONETISE, to coin into money, also MONETIZE [v]\n",
  "MONETISING": "MONETISE, to coin into money, also MONETIZE [v]\n",
  "MONETIZATION": "the act of monetizing, also MONETISATION [n -S]\n",
  "MONETIZATIONS": "MONETIZATION, the act of monetizing, also MONETISATION [n]\n",
  "MONETIZE": "to coin into money, also MONETISE [v MONETIZED, MONETIZING, MONETIZES]\n",
  "MONETIZED": "MONETIZE, to coin into money, also MONETISE [v]\n",
  "MONETIZES": "MONETIZE, to coin into money, also MONETISE [v]\n",
  "MONETIZING": "MONETIZE, to coin into money, also MONETISE [v]\n",
  "MONEY": "an official medium of exchange and measure of value [n MONEYS or MONIES]\n",
  "MONEYBAG": "a bag for holding money [n -S]\n",
  "MONEYBAGS": "MONEYBAG, a bag for holding money [n]\n",
  "MONEYBELT": "a belt for carrying money [n -S]\n",
  "MONEYBELTS": "MONEYBELT, a belt for carrying money [n]\n",
  "MONEYBOX": "a box for keeping money in [n -ES]\n",
  "MONEYBOXES": "MONEYBOX, a box for keeping money in [n]\n",
  "MONEYCHANGER": "a usurer [n -S]\n",
  "MONEYCHANGERS": "MONEYCHANGER, a usurer [n]\n",
  "MONEYED": "having lots of money, also MONIED [adj]\n",
  "MONEYER": "(archaic) a person who deals in money; a banker or broker [n -S]\n",
  "MONEYERS": "MONEYER, (archaic) a person who deals in money; a banker or broker [n]\n",
  "MONEYGRUBBING": "scraping and saving [n -S]\n",
  "MONEYGRUBBINGS": "MONEYGRUBBING, scraping and saving [n]\n",
  "MONEYLENDER": "one whose business is lending money [n -S]\n",
  "MONEYLENDERS": "MONEYLENDER, one whose business is lending money [n]\n",
  "MONEYLENDING": "the business of lending money [n -S]\n",
  "MONEYLENDINGS": "MONEYLENDING, the business of lending money [n]\n",
  "MONEYLESS": "having no money [adj]\n",
  "MONEYMAKER": "a profitable scheme or enterprise [n -S]\n",
  "MONEYMAKERS": "MONEYMAKER, a profitable scheme or enterprise [n]\n",
  "MONEYMAKING": "the business of making money [n -S]\n",
  "MONEYMAKINGS": "MONEYMAKING, the business of making money [n]\n",
  "MONEYMAN": "a person specializing in finance [n MONEYMEN]\n",
  "MONEYMEN": "MONEYMAN, a person specializing in finance [n]\n",
  "MONEYS": "MONEY, an official medium of exchange and measure of value [n]\n",
  "MONEYSPINNING": "serving to make much money [adj]\n",
  "MONEYWORT": "a trailing plant, with rounded opposite leaves and solitary yellow flowers in their axils [n -S]\n",
  "MONEYWORTS": "MONEYWORT, a trailing plant, with rounded opposite leaves and solitary yellow flowers in their axils [n]\n",
  "MONG": "(dialect) a throng or crowd; a mixture [n -S]\n",
  "MONGCORN": "a mixed grain, esp. rye and wheat, aka maslin, also MUNGCORN [n -S]\n",
  "MONGCORNS": "MONGCORN, a mixed grain, esp. rye and wheat, aka maslin, also MUNGCORN [n]\n",
  "MONGED": "(slang) under the influence of drugs [adj]\n",
  "MONGEESE": "MONGOOSE, (Marathi) a carnivorous mammal, also MUNGOOSE [n]\n",
  "MONGER": "a trader; a dealer; now chiefly in composition; as, fishmonger, ironmonger, newsmonger [n -S] / to peddle [v -ED, -ING, -S]\n",
  "MONGERED": "MONGER, to peddle [v]\n",
  "MONGERIES": "MONGERY, trading in a particular line of goods, also MONGERING [n]\n",
  "MONGERING": "trading in a particular line of goods, also MONGERY [n -S]\n",
  "MONGERINGS": "MONGERING, trading in a particular line of goods, also MONGERY [n]\n",
  "MONGERS": "MONGER, to peddle [v]\n",
  "MONGERY": "trading in a particular line of goods, also MONGERING [n MONGERIES]\n",
  "MONGO": "the waste produced in a woollen-mill from felted cloth, also MUNGO, MONGOE [n -ES or -S]\n",
  "MONGOE": "the waste produced in a woollen-mill from felted cloth, also MUNGO, MONGO [n -S]\n",
  "MONGOES": "MONGOE, the waste produced in a woollen-mill from felted cloth, also MUNGO, MONGO [n]\n",
  "MONGOL": "(offensive) a person affected by Down's syndrome [n -S]\n",
  "MONGOLIAN": "(offensive) affected by Down's syndrome, also MONGOLOID [adj]\n",
  "MONGOLISM": "(offensive) a medical condition, now known as Downs' Syndrome [n -S]\n",
  "MONGOLISMS": "MONGOLISM, (offensive) a medical condition, now known as Downs' Syndrome [n]\n",
  "MONGOLOID": "(offensive) a person affected with Down's syndrome, also MONGOLIAN [n -S]\n",
  "MONGOLOIDS": "MONGOLOID, (offensive) a person affected with Down's syndrome, also MONGOLIAN [n]\n",
  "MONGOLS": "MONGOL, (offensive) a person affected by Down's syndrome [n]\n",
  "MONGOOSE": "(Marathi) a carnivorous mammal, also MUNGOOSE [n MONGOOSES or MONGEESE]\n",
  "MONGOOSES": "MONGOOSE, (Marathi) a carnivorous mammal, also MUNGOOSE [n]\n",
  "MONGOS": "MONGO, the waste produced in a woollen-mill from felted cloth, also MUNGO, MONGOE [n]\n",
  "MONGREL": "a plant or animal of mixed breed [n -S]\n",
  "MONGRELISATION": "the process of mongrelising, also MONGRELIZATION [n -S]\n",
  "MONGRELISATIONS": "MONGRELISATION, the process of mongrelising, also MONGRELIZATION [n]\n",
  "MONGRELISE": "to make mongrel, also MONGRELIZE [v MONGRELISED, MONGRELISING, MONGRELISES]\n",
  "MONGRELISED": "MONGRELISE, to make mongrel, also MONGRELIZE [v]\n",
  "MONGRELISER": "one who mongrelises, also MONGRELIZER [n -S]\n",
  "MONGRELISERS": "MONGRELISER, one who mongrelises, also MONGRELIZER [n]\n",
  "MONGRELISES": "MONGRELISE, to make mongrel, also MONGRELIZE [v]\n",
  "MONGRELISING": "MONGRELISE, to make mongrel, also MONGRELIZE [v]\n",
  "MONGRELISM": "the state of being mongrel [n -S]\n",
  "MONGRELISMS": "MONGRELISM, the state of being mongrel [n]\n",
  "MONGRELIZATION": "the act of mongrelizing, also MONGRELISATION [n -S]\n",
  "MONGRELIZATIONS": "MONGRELIZATION, the act of mongrelizing, also MONGRELISATION [n]\n",
  "MONGRELIZE": "to make mongrel, also MONGRELISE [v MONGRELIZED, MONGRELIZING, MONGRELIZES]\n",
  "MONGRELIZED": "MONGRELIZE, to make mongrel, also MONGRELISE [v]\n",
  "MONGRELIZER": "one who mongrelizes, also MONGRELISER [n -S]\n",
  "MONGRELIZERS": "MONGRELIZER, one who mongrelizes, also MONGRELISER [n]\n",
  "MONGRELIZES": "MONGRELIZE, to make mongrel, also MONGRELISE [v]\n",
  "MONGRELIZING": "MONGRELIZE, to make mongrel, also MONGRELISE [v]\n",
  "MONGRELLIER": "MONGRELLY, like a mongrel [adj]\n",
  "MONGRELLIEST": "MONGRELLY, like a mongrel [adj]\n",
  "MONGRELLY": "like a mongrel [adj MONGRELLIER, MONGRELLIEST]\n",
  "MONGRELS": "MONGREL, a plant or animal of mixed breed [n]\n",
  "MONGS": "MONG, (dialect) a throng or crowd; a mixture [n]\n",
  "MONGST": "(obsolete) amongst, also EMONG, EMONGES, EMONGEST, EMONGST [prep]\n",
  "MONIAL": "a mullion, the upright division between the panes of a window [n -S]\n",
  "MONIALS": "MONIAL, a mullion, the upright division between the panes of a window [n]\n",
  "MONIC": "denoting a type of polynomial [adj]\n",
  "MONICKER": "(slang) a name; an alias, nickname, also MONIKER [n -S]\n",
  "MONICKERS": "MONICKER, (slang) a name; an alias, nickname, also MONIKER [n]\n",
  "MONIE": "(Scots) many, also MONY [adv]\n",
  "MONIED": "having lots of money, also MONEYED [adj]\n",
  "MONIES": "MONEY, an official medium of exchange and measure of value [n]\n",
  "MONIKER": "(slang) a name, a nickname, also MONICKER [n -S]\n",
  "MONIKERED": "having a moniker [adj]\n",
  "MONIKERS": "MONIKER, (slang) a name, a nickname, also MONICKER [n]\n",
  "MONILIA": "(Latin) a fungus of the Monilia genus, having conidia in branched chains [n MONILIAE or MONILIAS]\n",
  "MONILIAE": "MONILIA, (Latin) a fungus of the Monilia genus, having conidia in branched chains [n]\n",
  "MONILIAL": "relating to monilia, thrush [adj]\n",
  "MONILIAS": "MONILIA, (Latin) a fungus of the Monilia genus, having conidia in branched chains [n]\n",
  "MONILIASES": "MONILIASIS, candidiasis [n]\n",
  "MONILIASIS": "candidiasis [n MONILIASES]\n",
  "MONILIFORM": "having narrow intervals or joints resembling a string of beads [adj]\n",
  "MONIMENT": "(obsolete) something to preserve memory; a reminder; a monument [n -S]\n",
  "MONIMENTS": "MONIMENT, (obsolete) something to preserve memory; a reminder; a monument [n]\n",
  "MONIPLIES": "the third stomach of a ruminant, aka omasum or psalterium, also MANIPLIES, MANYPLIES, MONYPLIES [n]\n",
  "MONISH": "to admonish; to warn [v -ED, -ING, -ES]\n",
  "MONISHED": "MONISH, to admonish; to warn [v]\n",
  "MONISHES": "MONISH, to admonish; to warn [v]\n",
  "MONISHING": "MONISH, to admonish; to warn [v]\n",
  "MONISM": "the philosophical belief that matter, mind, etc., consist of one substance only, which is the only reality [n -S]\n",
  "MONISMS": "MONISM, the philosophical belief that matter, mind, etc., consist of one substance only, which is the only reality [n]\n",
  "MONIST": "a believer in monism, the philosophical belief that matter, mind, etc., consist of one substance only [n -S]\n",
  "MONISTIC": "of, pertaining to, or involving, monism, the philosophical belief that matter, mind, etc. consist of one substance only [adj MONISTICALLY]\n",
  "MONISTICAL": "of, pertaining to, or involving, monism [adj MONISTICALLY]\n",
  "MONISTICALLY": "MONISTICAL, of, pertaining to, or involving, monism [adv]\n",
  "MONISTS": "MONIST, a believer in monism, the philosophical belief that matter, mind, etc., consist of one substance only [n]\n",
  "MONITION": "a caution; a warning, esp. legal [n -S]\n",
  "MONITIONS": "MONITION, a caution; a warning, esp. legal [n]\n",
  "MONITIVE": "giving warning [adj]\n",
  "MONITOR": "to keep track of [v -ED, -ING, -S]\n",
  "MONITORED": "MONITOR, to keep track of [v]\n",
  "MONITORIAL": "of or pertaining to a monitor or monitors [adj MONITORIALLY]\n",
  "MONITORIALLY": "MONITORIAL, of or pertaining to a monitor or monitors [adv]\n",
  "MONITORIES": "MONITORY, a letter containing an admonition or warning, esp. one issued by a bishop or pope [n]\n",
  "MONITORING": "the act of keeping track of [n -S]\n",
  "MONITORINGS": "MONITORING, the act of keeping track of [n]\n",
  "MONITORS": "MONITOR, to keep track of [v]\n",
  "MONITORSHIP": "the office of monitor [n -S]\n",
  "MONITORSHIPS": "MONITORSHIP, the office of monitor [n]\n",
  "MONITORY": "a letter containing an admonition or warning, esp. one issued by a bishop or pope [n MONITORIES]\n",
  "MONITRESS": "a female monitor [n -ES]\n",
  "MONITRESSES": "MONITRESS, a female monitor [n]\n",
  "MONK": "a man who is a member of a religious order [n -S]\n",
  "MONKERIES": "MONKERY, the mode of life of monks [n]\n",
  "MONKERY": "the mode of life of monks [n MONKERIES]\n",
  "MONKEY": "to mimic [v -ED, -ING, -S]\n",
  "MONKEYED": "MONKEY, to mimic [v]\n",
  "MONKEYGLAND": "as in monkeygland extract [adj]\n",
  "MONKEYING": "MONKEY, to mimic [v]\n",
  "MONKEYISH": "like a monkey [adj]\n",
  "MONKEYISM": "being like a monkey [n -S]\n",
  "MONKEYISMS": "MONKEYISM, being like a monkey [n]\n",
  "MONKEYPOD": "the rain-tree [n -S]\n",
  "MONKEYPODS": "MONKEYPOD, the rain-tree [n]\n",
  "MONKEYPOT": "the round-lidded outer shell of the sapucaia nut [n -S]\n",
  "MONKEYPOTS": "MONKEYPOT, the round-lidded outer shell of the sapucaia nut [n]\n",
  "MONKEYPOX": "a rare virus disease especially of central and western Africa that is caused by a poxvirus [n -ES]\n",
  "MONKEYPOXES": "MONKEYPOX, a rare virus disease especially of central and western Africa that is caused by a poxvirus [n]\n",
  "MONKEYS": "MONKEY, to mimic [v]\n",
  "MONKEYSHINE": "a monkeyish trick [n -S]\n",
  "MONKEYSHINES": "MONKEYSHINE, a monkeyish trick [n]\n",
  "MONKFISH": "a large edible marine fish [n -ES]\n",
  "MONKFISHES": "MONKFISH, a large edible marine fish [n]\n",
  "MONKHOOD": "the state of being a monk [n -S]\n",
  "MONKHOODS": "MONKHOOD, the state of being a monk [n]\n",
  "MONKISH": "pertaining to monks [adj MONKISHLY]\n",
  "MONKISHLY": "MONKISH, pertaining to monks [adv]\n",
  "MONKISHNESS": "the state of being monkish [n -ES]\n",
  "MONKISHNESSES": "MONKISHNESS, the state of being monkish [n]\n",
  "MONKS": "MONK, a man who is a member of a religious order [n]\n",
  "MONKSHOOD": "a plant of the genus Aconitum, aka aconite [n -S]\n",
  "MONKSHOODS": "MONKSHOOD, a plant of the genus Aconitum, aka aconite [n]\n",
  "MONO": "the black howler monkey of Central America [n -S]\n",
  "MONOACID": "a compound having one hydrogen atom replaceable by a negative or acid atom or radical, also MONACID [n -S]\n",
  "MONOACIDIC": "of or like a monoacid [adj]\n",
  "MONOACIDS": "MONOACID, a compound having one hydrogen atom replaceable by a negative or acid atom or radical, also MONACID [n]\n",
  "MONOAMINE": "an amine containing only one amino group [n -S]\n",
  "MONOAMINERGIC": "liberating or involving monoamines (as serotonin or norepinephrine) in neural transmission [adj]\n",
  "MONOAMINES": "MONOAMINE, an amine containing only one amino group [n]\n",
  "MONOAO": "(Maori) a New Zealand plant of the heath family with rigid leaves, also MANOAO [n -S]\n",
  "MONOAOS": "MONOAO, (Maori) a New Zealand plant of the heath family with rigid leaves, also MANOAO [n]\n",
  "MONOATOMIC": "of a molecule, consisting of one atom only, also MONATOMIC [adj]\n",
  "MONOBASIC": "of an acid, such as hydrogen chloride, having only one replaceable hydrogen atom per molecule [adj]\n",
  "MONOBLEPSES": "MONOBLEPSIS, a condition in which vision is more distinct when one eye only is used [n]\n",
  "MONOBLEPSIS": "a condition in which vision is more distinct when one eye only is used [n MONOBLEPSES]\n",
  "MONOBLOC": "made from a single piece of material [adj]\n",
  "MONOBROW": "a derogatory word for eyebrows that meet, also UNIBROW [n -S]\n",
  "MONOBROWS": "MONOBROW, a derogatory word for eyebrows that meet, also UNIBROW [n]\n",
  "MONOCARBOXYLIC": "containing one carboxyl group [adj]\n",
  "MONOCARDIAN": "a creature that has only one heart [n -S]\n",
  "MONOCARDIANS": "MONOCARDIAN, a creature that has only one heart [n]\n",
  "MONOCARP": "a plant that yields fruit only once before dying [n -S]\n",
  "MONOCARPELLARY": "of or with only one carpel [adj]\n",
  "MONOCARPIC": "having only one ovary; producing one fruit, also MONOCARPOUS [adj]\n",
  "MONOCARPOUS": "having only one ovary; producing one fruit, also MONOCARPIC [adj]\n",
  "MONOCARPS": "MONOCARP, a plant that yields fruit only once before dying [n]\n",
  "MONOCEROS": "a one-horned creature; a unicorn; a sea monster with one horn [n -ES]\n",
  "MONOCEROSES": "MONOCEROS, a one-horned creature; a unicorn; a sea monster with one horn [n]\n",
  "MONOCEROUS": "having only one horn [adj]\n",
  "MONOCHASIA": "MONOCHASIUM, a cyme with a single main stem [n]\n",
  "MONOCHASIAL": "of or like a monochasium, a cyme with a single main stem [adj]\n",
  "MONOCHASIUM": "a cyme with a single main stem [n MONOCHASIA]\n",
  "MONOCHLAMYDEOUS": "having a one-whorled perianth [adj]\n",
  "MONOCHLORIDE": "a chloride containing one atom of chlorine per molecule [n -S]\n",
  "MONOCHLORIDES": "MONOCHLORIDE, a chloride containing one atom of chlorine per molecule [n]\n",
  "MONOCHORD": "a musical instrument having only one string [n -S]\n",
  "MONOCHORDS": "MONOCHORD, a musical instrument having only one string [n]\n",
  "MONOCHROIC": "of one colour [adj] / something of one colour [n -S]\n",
  "MONOCHROICS": "MONOCHROIC, something of one colour [n]\n",
  "MONOCHROMASIES": "MONOCHROMASY, complete colour-blindness [n]\n",
  "MONOCHROMASY": "complete colour-blindness [n MONOCHROMASIES]\n",
  "MONOCHROMAT": "a person who sees all colours as different shades of a single colour, also MONOCHROMATE [n -S]\n",
  "MONOCHROMATE": "a person who sees all colours as different shades of a single colour, also MONOCHROMAT [n -S]\n",
  "MONOCHROMATES": "MONOCHROMATE, a person who sees all colours as different shades of a single colour, also MONOCHROMAT [n]\n",
  "MONOCHROMATIC": "having or consisting of one color or hue [adj] / a monochromatic painting, drawing, garment, etc. [n -S]\n",
  "MONOCHROMATICS": "MONOCHROMATIC, a monochromatic painting, drawing, garment, etc. [n]\n",
  "MONOCHROMATISM": "complete color blindness in which all colors appear as shades of gray [n -S]\n",
  "MONOCHROMATISMS": "MONOCHROMATISM, complete color blindness in which all colors appear as shades of gray [n]\n",
  "MONOCHROMATOR": "a device for isolating a narrow portion of a spectrum [n -S]\n",
  "MONOCHROMATORS": "MONOCHROMATOR, a device for isolating a narrow portion of a spectrum [n]\n",
  "MONOCHROMATS": "MONOCHROMAT, a person who sees all colours as different shades of a single colour, also MONOCHROMATE [n]\n",
  "MONOCHROME": "of one colour only [adj] / a painting or drawing in a single color [n -S]\n",
  "MONOCHROMES": "MONOCHROME, a painting or drawing in a single color [n]\n",
  "MONOCHROMIC": "of one colour only, also MONOCHROMICAL [adj]\n",
  "MONOCHROMICAL": "of one colour only, also MONOCHROMIC [adj]\n",
  "MONOCHROMIES": "MONOCHROMY, the art of painting or drawing in monochrome [n]\n",
  "MONOCHROMIST": "a person who practises monochrome [n -S]\n",
  "MONOCHROMISTS": "MONOCHROMIST, a person who practises monochrome [n]\n",
  "MONOCHROMY": "the art of painting or drawing in monochrome [n MONOCHROMIES]\n",
  "MONOCLE": "an eyeglass for one eye [n -S]\n",
  "MONOCLED": "wearing a monocle [adj]\n",
  "MONOCLES": "MONOCLE, an eyeglass for one eye [n]\n",
  "MONOCLINAL": "relating to a monocline [adj MONOCLINALLY] / a monocline [n -S]\n",
  "MONOCLINALLY": "MONOCLINAL, relating to a monocline [adv]\n",
  "MONOCLINALS": "MONOCLINAL, a monocline [n]\n",
  "MONOCLINE": "a simple fold, described as a local steepening in strata with an otherwise uniform dip [n -S]\n",
  "MONOCLINES": "MONOCLINE, a simple fold, described as a local steepening in strata with an otherwise uniform dip [n]\n",
  "MONOCLINIC": "referable to three unequal axes, two intersecting each other obliquely and at right angles to the third [adj]\n",
  "MONOCLINISM": "the state of being monoclinous [n -S]\n",
  "MONOCLINISMS": "MONOCLINISM, the state of being monoclinous [n]\n",
  "MONOCLINOUS": "having pistils and stamens in same flower [adj]\n",
  "MONOCLONAL": "derived from a single cell clone that can reproduce itself in vast quantities [adj] / a monoclonal antibody [n -S]\n",
  "MONOCLONALS": "MONOCLONAL, a monoclonal antibody [n]\n",
  "MONOCOQUE": "(French) an aircraft structure in which the outer skin carries all or most of the torsional and bending stresses; a car structure in which the body is integral with and shares the stresses with the chassis [n -S]\n",
  "MONOCOQUES": "MONOCOQUE, (French) an aircraft structure in which the outer skin carries all or most of the torsional and bending stresses; a car structure in which the body is integral with and shares the stresses with the chassis [n]\n",
  "MONOCOT": "(short for) a monocotyledon, a plant having a single cotyledon, also MONOCOTYL, MONOCOTYLEDON [n -S]\n",
  "MONOCOTS": "MONOCOT, (short for) a monocotyledon, a plant having a single cotyledon, also MONOCOTYL, MONOCOTYLEDON [n]\n",
  "MONOCOTYL": "a plant having a single cotyledon, also MONOCOT, MONOCOTYLEDON [n -S]\n",
  "MONOCOTYLEDON": "a plant having a single cotyledon, also MONOCOT, MONOCOTYL [n -S]\n",
  "MONOCOTYLEDONS": "MONOCOTYLEDON, a plant having a single cotyledon, also MONOCOT, MONOCOTYL [n]\n",
  "MONOCOTYLS": "MONOCOTYL, a plant having a single cotyledon, also MONOCOT, MONOCOTYLEDON [n]\n",
  "MONOCRACIES": "MONOCRACY, rulership by one individual [n]\n",
  "MONOCRACY": "rulership by one individual [n MONOCRACIES]\n",
  "MONOCRAT": "one who governs alone [n -S]\n",
  "MONOCRATIC": "autocratic [adj]\n",
  "MONOCRATS": "MONOCRAT, one who governs alone [n]\n",
  "MONOCROP": "to plant the same crop in the same field year after year [v MONOCROPPED, MONOCROPPING, MONOCROPS]\n",
  "MONOCROPPED": "MONOCROP, to plant the same crop in the same field year after year [v]\n",
  "MONOCROPPING": "MONOCROP, to plant the same crop in the same field year after year [v]\n",
  "MONOCROPS": "MONOCROP, to plant the same crop in the same field year after year [v]\n",
  "MONOCRYSTAL": "a single crystal [n -S]\n",
  "MONOCRYSTALLINE": "of or like a monocrystal [adj]\n",
  "MONOCRYSTALS": "MONOCRYSTAL, a single crystal [n]\n",
  "MONOCULAR": "for use with one eye [adj MONOCULARLY] / a field glass or microscope for use with one eye [n -S]\n",
  "MONOCULARLY": "MONOCULAR, for use with one eye [adv]\n",
  "MONOCULARS": "MONOCULAR, a field glass or microscope for use with one eye [n]\n",
  "MONOCULOUS": "monocular [adj]\n",
  "MONOCULTURAL": "relating to monoculture [adj]\n",
  "MONOCULTURE": "growing of one agricultural crop only [n -S]\n",
  "MONOCULTURES": "MONOCULTURE, growing of one agricultural crop only [n]\n",
  "MONOCYCLE": "a cycle with only one wheel, also UNICYCLE [n -S]\n",
  "MONOCYCLES": "MONOCYCLE, a cycle with only one wheel, also UNICYCLE [n]\n",
  "MONOCYCLIC": "having one whorl or ring [adj]\n",
  "MONOCYTE": "a type of white blood cell [n -S]\n",
  "MONOCYTES": "MONOCYTE, a type of white blood cell [n]\n",
  "MONOCYTIC": "of or like a monocyte, a large white blood corpuscle [adj]\n",
  "MONOCYTOID": "of or like a monocyte, a large white blood corpuscle [adj]\n",
  "MONODACTYLOUS": "one-toed or one-fingered [adj]\n",
  "MONODELPHIAN": "any placental mammal that is a member of the group Monodelphi [n -S]\n",
  "MONODELPHIANS": "MONODELPHIAN, any placental mammal that is a member of the group Monodelphi [n]\n",
  "MONODELPHIC": "relating to the Monodelphia, placental mammals, also MONODELPHIAN [adj]\n",
  "MONODELPHOUS": "relating to the Monodelphia, placental mammals [adj]\n",
  "MONODIC": "of or like a monody, a mournful ode or poem performed by a single mourner, also MONODICAL [adj MONODICALLY]\n",
  "MONODICAL": "of or like a monody, a mournful ode or poem performed by a single mourner, also MONODIC [adj MONODICALLY]\n",
  "MONODICALLY": "MONODICAL, of or like a monody, a mournful ode or poem performed by a single mourner, also MONODIC [adv]\n",
  "MONODIES": "MONODY, an elegy performed by one person [n]\n",
  "MONODISPERSE": "characterized by particles of uniform size in a dispersed phase [adj]\n",
  "MONODIST": "a writer of a monody, a mournful ode or poem performed by a single mourner [n -S]\n",
  "MONODISTS": "MONODIST, a writer of a monody, a mournful ode or poem performed by a single mourner [n]\n",
  "MONODONT": "one-tusked, like a narwhal [adj]\n",
  "MONODRAMA": "a one-man show; a play having only one actor [n -S]\n",
  "MONODRAMAS": "MONODRAMA, a one-man show; a play having only one actor [n]\n",
  "MONODRAMATIC": "of or like a monodrama [adj]\n",
  "MONODY": "an elegy performed by one person [n MONODIES]\n",
  "MONOECIES": "MONOECY, the condition of being monecian, having both male and female reproductive organs [n]\n",
  "MONOECIOUS": "having separate male and female flowers on the same plant, also MONECIAN, MONECIOUS, MONOICOUS [adj MONOECIOUSLY]\n",
  "MONOECIOUSLY": "MONOECIOUS, having separate male and female flowers on the same plant, also MONECIAN, MONECIOUS, MONOICOUS [adv]\n",
  "MONOECISM": "the state or condition of being monoecious, having both male and female reproductive organs [n -S]\n",
  "MONOECISMS": "MONOECISM, the state or condition of being monoecious, having both male and female reproductive organs [n]\n",
  "MONOECY": "the condition of being monecian, having both male and female reproductive organs [n MONOECIES]\n",
  "MONOESTER": "an ester, as of a dibasic acid, that contains only one ester group [n -S]\n",
  "MONOESTERS": "MONOESTER, an ester, as of a dibasic acid, that contains only one ester group [n]\n",
  "MONOFIL": "a single filament of synthetic fibre, also MONOFILAMENT [n -S]\n",
  "MONOFILAMENT": "a single filament of synthetic fibre, also MONOFIL [n -S]\n",
  "MONOFILAMENTS": "MONOFILAMENT, a single filament of synthetic fibre, also MONOFIL [n]\n",
  "MONOFILS": "MONOFIL, a single filament of synthetic fibre, also MONOFILAMENT [n]\n",
  "MONOFUEL": "a type of rocket propellant [n -S]\n",
  "MONOFUELS": "MONOFUEL, a type of rocket propellant [n]\n",
  "MONOGAMIC": "pertaining to, or involving, monogamy [adj]\n",
  "MONOGAMIES": "MONOGAMY, marriage with one person at a time [n]\n",
  "MONOGAMIST": "one who practices or upholds monogamy [n -S]\n",
  "MONOGAMISTIC": "relating to monogamy, also MONOGAMOUS [adj]\n",
  "MONOGAMISTS": "MONOGAMIST, one who practices or upholds monogamy [n]\n",
  "MONOGAMOUS": "relating to monogamy, also MONOGAMISTIC [adj MONOGAMOUSLY]\n",
  "MONOGAMOUSLY": "MONOGAMOUS, relating to monogamy, also MONOGAMISTIC [adv]\n",
  "MONOGAMOUSNESS": "MONOGAMOUS, relating to monogamy, also MONOGAMISTIC [n]\n",
  "MONOGAMY": "marriage with one person at a time [n MONOGAMIES]\n",
  "MONOGASTRIC": "having a stomach with only a single compartment [adj]\n",
  "MONOGENEAN": "a monogenetic trematode, a kind of parasitic flatworm [n -S]\n",
  "MONOGENEANS": "MONOGENEAN, a monogenetic trematode, a kind of parasitic flatworm [n]\n",
  "MONOGENESES": "MONOGENESIS, the development of an offspring from a parent like itself [n]\n",
  "MONOGENESIS": "the development of an offspring from a parent like itself [n MONOGENESES]\n",
  "MONOGENETIC": "of e.g. rocks, having a single origin, formed in a single way or by a single process, also MONOGENIC [adj]\n",
  "MONOGENIC": "of e.g. rocks, having a single origin, formed in a single way or by a single process, also MONOGENETIC [adj MONOGENICALLY]\n",
  "MONOGENICALLY": "MONOGENIC, of e.g. rocks, having a single origin, formed in a single way or by a single process, also MONOGENETIC [adv]\n",
  "MONOGENIES": "MONOGENY, the (theoretical) common origin of the human species, esp. from one pair of ancestors [n]\n",
  "MONOGENISM": "the doctrine of the common descent of all living things, or of any particular group (esp. mankind) from one ancestor or pair [n -S]\n",
  "MONOGENISMS": "MONOGENISM, the doctrine of the common descent of all living things, or of any particular group (esp. mankind) from one ancestor or pair [n]\n",
  "MONOGENIST": "a believer in monogenism [n -S]\n",
  "MONOGENISTIC": "relating to monogenism, the doctrine of the common descent of all living things [adj]\n",
  "MONOGENISTS": "MONOGENIST, a believer in monogenism [n]\n",
  "MONOGENOUS": "of or pertaining to monogenesis; as, monogenous, or asexual, reproduction [adj]\n",
  "MONOGENY": "the (theoretical) common origin of the human species, esp. from one pair of ancestors [n MONOGENIES]\n",
  "MONOGERM": "of a fruit that produces a single plant [adj]\n",
  "MONOGLOT": "a person speaking or writing only one language [n -S]\n",
  "MONOGLOTS": "MONOGLOT, a person speaking or writing only one language [n]\n",
  "MONOGLYCERIDE": "any of various esters of glycerol in which only one of the three hydroxyl groups is esterified and which are often used as emulsifiers [n -S]\n",
  "MONOGLYCERIDES": "MONOGLYCERIDE, any of various esters of glycerol in which only one of the three hydroxyl groups is esterified and which are often used as emulsifiers [n]\n",
  "MONOGONIES": "MONOGONY, asexual reproduction [n]\n",
  "MONOGONY": "asexual reproduction [n MONOGONIES]\n",
  "MONOGRAM": "to mark with one's initials [v MONOGRAMED or MONOGRAMMED, MONOGRAMING or MONOGRAMMING, MONOGRAMS]\n",
  "MONOGRAMED": "MONOGRAM, to mark with one's initials [v]\n",
  "MONOGRAMING": "MONOGRAM, to mark with one's initials [v]\n",
  "MONOGRAMMATIC": "of or like a monogram [adj]\n",
  "MONOGRAMMED": "MONOGRAM, to mark with one's initials [v]\n",
  "MONOGRAMMER": "one who designs monograms [n -S]\n",
  "MONOGRAMMERS": "MONOGRAMMER, one who designs monograms [n]\n",
  "MONOGRAMMING": "MONOGRAM, to mark with one's initials [v]\n",
  "MONOGRAMS": "MONOGRAM, to mark with one's initials [v]\n",
  "MONOGRAPH": "a special treatise on a particular subject of limited range [n -S] / to write a monograph [v -ED, -ING, -S]\n",
  "MONOGRAPHED": "MONOGRAPH, to write a monograph [v]\n",
  "MONOGRAPHER": "one who writes monographs [n -S]\n",
  "MONOGRAPHERS": "MONOGRAPHER, one who writes monographs [n]\n",
  "MONOGRAPHIC": "of or like a monograph, also MONOGRAPHICAL [adj MONOGRAPHICALLY]\n",
  "MONOGRAPHICAL": "of or like a monograph, also MONOGRAPHIC [adj MONOGRAPHICALLY]\n",
  "MONOGRAPHICALLY": "MONOGRAPHICAL, of or like a monograph, also MONOGRAPHIC [adv]\n",
  "MONOGRAPHIES": "MONOGRAPHY, a monograph [n]\n",
  "MONOGRAPHING": "MONOGRAPH, to write a monograph [v]\n",
  "MONOGRAPHIST": "one who writes monographs [n -S]\n",
  "MONOGRAPHISTS": "MONOGRAPHIST, one who writes monographs [n]\n",
  "MONOGRAPHS": "MONOGRAPH, to write a monograph [v]\n",
  "MONOGRAPHY": "a monograph [n MONOGRAPHIES]\n",
  "MONOGYNIAN": "pertaining to the Monogynia [adj]\n",
  "MONOGYNIES": "MONOGYNY, the condition of having one wife at a time [n]\n",
  "MONOGYNIST": "one who practises monogyny, having only one wife at a time [n -S]\n",
  "MONOGYNISTS": "MONOGYNIST, one who practises monogyny, having only one wife at a time [n]\n",
  "MONOGYNOUS": "of or pertaining to Monogynia; having only one style or stigma [adj]\n",
  "MONOGYNY": "the condition of having one wife at a time [n MONOGYNIES]\n",
  "MONOHULL": "a vessel with one hull, as compared with a catamaran or trimaran [n -S]\n",
  "MONOHULLS": "MONOHULL, a vessel with one hull, as compared with a catamaran or trimaran [n]\n",
  "MONOHYBRID": "a cross between parents differing in one heritable character [n -S]\n",
  "MONOHYBRIDS": "MONOHYBRID, a cross between parents differing in one heritable character [n]\n",
  "MONOHYDRATE": "a hydrate containing one molecule of water per molecule of the compound [n -S]\n",
  "MONOHYDRATED": "like a monohydrate [adj]\n",
  "MONOHYDRATES": "MONOHYDRATE, a hydrate containing one molecule of water per molecule of the compound [n]\n",
  "MONOHYDRIC": "containing one hydroxyl group [adj]\n",
  "MONOHYDROGEN": "designating compounds containing one hydrogen atom or ion for each combining radical or ion, e.g. disodium monohydrogen orthophosphate [adj]\n",
  "MONOHYDROXY": "containing one hydroxyl group in the molecule [adj]\n",
  "MONOICOUS": "having separate male and female flowers on the same plant, also MONECIAN, MONECIOUS, MONOECIOUS [adj MONOICOUSLY]\n",
  "MONOICOUSLY": "MONOICOUS, having separate male and female flowers on the same plant, also MONECIAN, MONECIOUS, MONOECIOUS [adv]\n",
  "MONOKINE": "a substance secreted by white blood cells [n -S]\n",
  "MONOKINES": "MONOKINE, a substance secreted by white blood cells [n]\n",
  "MONOKINI": "swimwear comprising the bottom half of a bikini [n -S]\n",
  "MONOKINIS": "MONOKINI, swimwear comprising the bottom half of a bikini [n]\n",
  "MONOLATER": "one who worships one god only out of many believed to exist, also MONOLATRIST [n -S]\n",
  "MONOLATERS": "MONOLATER, one who worships one god only out of many believed to exist, also MONOLATRIST [n]\n",
  "MONOLATRIES": "MONOLATRY, worship of one god without excluding belief in others [n]\n",
  "MONOLATRIST": "one who worships one god only out of many believed to exist, also MONOLATER [n -S]\n",
  "MONOLATRISTS": "MONOLATRIST, one who worships one god only out of many believed to exist, also MONOLATER [n]\n",
  "MONOLATROUS": "worshipping one god only out of many believed to exist [adj]\n",
  "MONOLATRY": "worship of one god without excluding belief in others [n MONOLATRIES]\n",
  "MONOLAYER": "a single continuous layer or film that is one molecule in thickness [n -S]\n",
  "MONOLAYERS": "MONOLAYER, a single continuous layer or film that is one molecule in thickness [n]\n",
  "MONOLINE": "as in monoline insurer, an insurer who undertakes to pay the principal and interest on a bond should the issuer default [adj]\n",
  "MONOLINGUAL": "one who speaks one language only [n -S]\n",
  "MONOLINGUALISM": "the state of being monolingual, speaking one language only [n -S]\n",
  "MONOLINGUALISMS": "MONOLINGUALISM, the state of being monolingual, speaking one language only [n]\n",
  "MONOLINGUALS": "MONOLINGUAL, one who speaks one language only [n]\n",
  "MONOLINGUIST": "a monoglot [n -S]\n",
  "MONOLINGUISTS": "MONOLINGUIST, a monoglot [n]\n",
  "MONOLITH": "a large single stone in form of monument, obelisk or column [n -S]\n",
  "MONOLITHIC": "of or like a monolith [adj MONOLITHICALLY]\n",
  "MONOLITHICALLY": "MONOLITHIC, of or like a monolith [adv]\n",
  "MONOLITHS": "MONOLITH, a large single stone in form of monument, obelisk or column [n]\n",
  "MONOLOG": "a lengthy speech by one person [n -S] / to give a monolog, also MONOLOGUE [v MONOLOGGED, MONOLOGGING, MONOLOGS]\n",
  "MONOLOGGED": "MONOLOG, to give a monolog, also MONOLOGUE [v]\n",
  "MONOLOGGING": "MONOLOG, to give a monolog, also MONOLOGUE [v]\n",
  "MONOLOGIC": "relating to a monologue, also MONOLOGICAL [adj]\n",
  "MONOLOGICAL": "relating to a monologue, also MONOLOGIC [adj]\n",
  "MONOLOGIES": "MONOLOGY, the act of uttering a monolog [n]\n",
  "MONOLOGISE": "to engage in a monolog, also MONOLOGIZE, MONOLOGUISE, MONOLOGUIZE [v MONOLOGISED, MONOLOGISING, MONOLOGISES]\n",
  "MONOLOGISED": "MONOLOGISE, to engage in a monolog, also MONOLOGIZE, MONOLOGUISE, MONOLOGUIZE [v]\n",
  "MONOLOGISES": "MONOLOGISE, to engage in a monolog, also MONOLOGIZE, MONOLOGUISE, MONOLOGUIZE [v]\n",
  "MONOLOGISING": "MONOLOGISE, to engage in a monolog, also MONOLOGIZE, MONOLOGUISE, MONOLOGUIZE [v]\n",
  "MONOLOGIST": "one who soliloquizes; esp. one who monopolizes conversation in company, also MONOLOGUIST [n -S]\n",
  "MONOLOGISTS": "MONOLOGIST, one who soliloquizes; esp. one who monopolizes conversation in company, also MONOLOGUIST [n]\n",
  "MONOLOGIZE": "to engage in a monolog, also MONOLOGISE, MONOLOGUISE, MONOLOGUIZE [v MONOLOGIZED, MONOLOGIZING, MONOLOGIZES]\n",
  "MONOLOGIZED": "MONOLOGIZE, to engage in a monolog, also MONOLOGISE, MONOLOGUISE, MONOLOGUIZE [v]\n",
  "MONOLOGIZES": "MONOLOGIZE, to engage in a monolog, also MONOLOGISE, MONOLOGUISE, MONOLOGUIZE [v]\n",
  "MONOLOGIZING": "MONOLOGIZE, to engage in a monolog, also MONOLOGISE, MONOLOGUISE, MONOLOGUIZE [v]\n",
  "MONOLOGS": "MONOLOG, a lengthy speech by one person [n]\n",
  "MONOLOGUE": "a dramatic piece for a single performer, also MONOLOG [n -S] / to perform a monologue [v MONOLOGUED, MONOLOGUING, MONOLOGUES]\n",
  "MONOLOGUED": "MONOLOGUE, to perform a monologue [v]\n",
  "MONOLOGUES": "MONOLOGUE, a dramatic piece for a single performer, also MONOLOG [n]\n",
  "MONOLOGUING": "MONOLOGUE, to perform a monologue [v]\n",
  "MONOLOGUISE": "to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUIZE [v MONOLOGUISED, MONOLOGUISING, MONOLOGUISES]\n",
  "MONOLOGUISED": "MONOLOGUISE, to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUIZE [v]\n",
  "MONOLOGUISES": "MONOLOGUISE, to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUIZE [v]\n",
  "MONOLOGUISING": "MONOLOGUISE, to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUIZE [v]\n",
  "MONOLOGUIST": "one who gives monologues, also MONOLOGIST [n -S]\n",
  "MONOLOGUISTS": "MONOLOGUIST, one who gives monologues, also MONOLOGIST [n]\n",
  "MONOLOGUIZE": "to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUISE [v MONOLOGUIZED, MONOLOGUIZING, MONOLOGUIZES]\n",
  "MONOLOGUIZED": "MONOLOGUISE, to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUIZE [v]\n",
  "MONOLOGUIZES": "MONOLOGUIZE, to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUISE [v]\n",
  "MONOLOGUIZING": "MONOLOGUIZE, to engage in a monolog, also MONOLOGISE, MONOLOGIZE, MONOLOGUISE [v]\n",
  "MONOLOGY": "the act of uttering a monolog [n MONOLOGIES]\n",
  "MONOMACHIA": "single combat; a duel, also MONOMACHY [n -S]\n",
  "MONOMACHIAS": "MONOMACHIA, single combat; a duel, also MONOMACHY [n]\n",
  "MONOMACHIES": "MONOMACHY, single combat; a duel, also MONOMACHIA [n]\n",
  "MONOMACHY": "single combat; a duel, also MONOMACHIA [n MONOMACHIES]\n",
  "MONOMANIA": "an abnormal obsession with a single thought or idea [n -S]\n",
  "MONOMANIAC": "someone obsessed with one subject only [n -S]\n",
  "MONOMANIACAL": "obsessed with one subject only [adj MONOMANIACALLY]\n",
  "MONOMANIACALLY": "MONOMANIACAL, obsessed with one subject only [adv]\n",
  "MONOMANIACS": "MONOMANIAC, someone obsessed with one subject only [n]\n",
  "MONOMANIAS": "MONOMANIA, an abnormal obsession with a single thought or idea [n]\n",
  "MONOMARK": "a particular combination of letters, figures etc. as a mark of identification [n -S]\n",
  "MONOMARKS": "MONOMARK, a particular combination of letters, figures etc. as a mark of identification [n]\n",
  "MONOMER": "the simplest of any series of compounds having the same empirical formula [n -S]\n",
  "MONOMERIC": "of or like a monomer, the simplest of any series of compounds having the same empirical formula [adj]\n",
  "MONOMEROUS": "of flowers, having whorls consisting of only one member [adj]\n",
  "MONOMERS": "MONOMER, the simplest of any series of compounds having the same empirical formula [n]\n",
  "MONOMETALLIC": "of or relating to monometallism [adj]\n",
  "MONOMETALLISM": "use of one metal as currency standard; theory advocating this [n -S]\n",
  "MONOMETALLISMS": "MONOMETALLISM, use of one metal as currency standard; theory advocating this [n]\n",
  "MONOMETALLIST": "one advocating monometallism [n -S]\n",
  "MONOMETALLISTS": "MONOMETALLIST, one advocating monometallism [n]\n",
  "MONOMETER": "a rhythmic series, consisting of a single meter [n -S]\n",
  "MONOMETERS": "MONOMETER, a rhythmic series, consisting of a single meter [n]\n",
  "MONOMETRIC": "of verse, written in a single metre, also MONOMETRICAL [adj]\n",
  "MONOMETRICAL": "of verse, written in a single metre, also MONOMETRIC [adj]\n",
  "MONOMIAL": "an algebraic expression consisting of a single term [n -S]\n",
  "MONOMIALS": "MONOMIAL, an algebraic expression consisting of a single term [n]\n",
  "MONOMODE": "designating a very fine optical fibre (less than 10 micrometres in diameter), used in telecommunications [adj]\n",
  "MONOMOLECULAR": "being only one molecule thick [adj MONOMOLECULARLY]\n",
  "MONOMOLECULARLY": "MONOMOLECULAR, being only one molecule thick [adv]\n",
  "MONOMORPHEMIC": "consisting of only one morpheme [adj]\n",
  "MONOMORPHIC": "having or existing in only one form [adj]\n",
  "MONOMORPHISM": "existence in one form only [n -S]\n",
  "MONOMORPHISMS": "MONOMORPHISM, existence in one form only [n]\n",
  "MONOMORPHOUS": "existing in one form only [adj]\n",
  "MONOMYARIAN": "a kind of bivalve mollusc [n -S]\n",
  "MONOMYARIANS": "MONOMYARIAN, a kind of bivalve mollusc [n]\n",
  "MONONUCLEAR": "having only one nucleus [adj] / a mononuclear cell [n -S]\n",
  "MONONUCLEARS": "MONONUCLEAR, a mononuclear cell [n]\n",
  "MONONUCLEATE": "having a single nucleus, also MONONUCLEATED [adj]\n",
  "MONONUCLEATED": "having a single nucleus, also MONONUCLEATE [adj]\n",
  "MONONUCLEOSES": "MONONUCLEOSIS, an abnormal increase of mononuclear white blood cells in the blood [n]\n",
  "MONONUCLEOSIS": "an abnormal increase of mononuclear white blood cells in the blood [n MONONUCLEOSES]\n",
  "MONONUCLEOTIDE": "a nucleotide that is derived from one molecule each of a nitrogenous base, a sugar, and a phosphoric acid [n -S]\n",
  "MONONUCLEOTIDES": "MONONUCLEOTIDE, a nucleotide that is derived from one molecule each of a nitrogenous base, a sugar, and a phosphoric acid [n]\n",
  "MONONYM": "a person who is famous enough to be known by only one name, usually the first name [n -S]\n",
  "MONONYMS": "MONONYM, a person who is famous enough to be known by only one name, usually the first name [n]\n",
  "MONOPETALOUS": "having petals united [adj]\n",
  "MONOPHAGIES": "MONOPHAGY, the eating of one kind of food only [n]\n",
  "MONOPHAGOUS": "feeding on only one type of food [adj]\n",
  "MONOPHAGY": "the eating of one kind of food only [n MONOPHAGIES]\n",
  "MONOPHASE": "a type of matter or a compound that contains only one phase [n -S]\n",
  "MONOPHASES": "MONOPHASE, a type of matter or a compound that contains only one phase [n]\n",
  "MONOPHASIC": "of electric current, single-phase, also MONOPHASE [adj]\n",
  "MONOPHOBIA": "an irrational fear of being alone [n -S]\n",
  "MONOPHOBIAS": "MONOPHOBIA, an irrational fear of being alone [n]\n",
  "MONOPHOBIC": "one suffering from monophobia [n -S]\n",
  "MONOPHOBICS": "MONOPHOBIC, one suffering from monophobia [n]\n",
  "MONOPHONIC": "homophonic, monaural as opposed to stereo [adj MONOPHONICALLY]\n",
  "MONOPHONICALLY": "MONOPHONIC, homophonic, monaural as opposed to stereo [adv]\n",
  "MONOPHONIES": "MONOPHONY, a composition for one voice [n]\n",
  "MONOPHONY": "a composition for one voice [n MONOPHONIES]\n",
  "MONOPHOSPHATE": "an ester of phosphoric acid [n -S]\n",
  "MONOPHOSPHATES": "MONOPHOSPHATE, an ester of phosphoric acid [n]\n",
  "MONOPHTHONG": "two written vowels representing a single sound, e.g. 'oo', 'oa' [n -S]\n",
  "MONOPHTHONGAL": "of or like a monophthong [adj]\n",
  "MONOPHTHONGISE": "to pronounce as a monophthong, also MONOPHTHONGIZE [v MONOPHTHONGISED, MONOPHTHONGISES]\n",
  "MONOPHTHONGISED": "MONOPHTHONGISE, to pronounce as a monophthong, also MONOPHTHONGIZE [v]\n",
  "MONOPHTHONGISES": "MONOPHTHONGISE, to pronounce as a monophthong, also MONOPHTHONGIZE [v]\n",
  "MONOPHTHONGIZE": "to pronounce as a monophthong, also MONOPHTHONGISE [v MONOPHTHONGIZED, MONOPHTHONGIZES]\n",
  "MONOPHTHONGIZED": "MONOPHTHONGIZE, to pronounce as a monophthong, also MONOPHTHONGISE [v]\n",
  "MONOPHTHONGIZES": "MONOPHTHONGIZE, to pronounce as a monophthong, also MONOPHTHONGISE [v]\n",
  "MONOPHTHONGS": "MONOPHTHONG, two written vowels representing a single sound, e.g. 'oo', 'oa' [n]\n",
  "MONOPHYLETIC": "derived from a single ancestral line, as opposed to polyphyletic [adj]\n",
  "MONOPHYLIES": "MONOPHYLY, the state of being monophyletic [n]\n",
  "MONOPHYLLOUS": "having or consisting of only one leaf or leaflike part [adj]\n",
  "MONOPHYLY": "the state of being monophyletic [n MONOPHYLIES]\n",
  "MONOPHYODONT": "an animal with only one set of teeth [n -S]\n",
  "MONOPHYODONTS": "MONOPHYODONT, an animal with only one set of teeth [n]\n",
  "MONOPHYSITE": "one believing that Christ had but a single divine nature [n -S]\n",
  "MONOPHYSITES": "MONOPHYSITE, one believing that Christ had but a single divine nature [n]\n",
  "MONOPHYSITIC": "of or like a monophysite, one believing that Christ had but a single divine nature [adj]\n",
  "MONOPHYSITISM": "belief that Christ was primarily divine but in human form [n -S]\n",
  "MONOPHYSITISMS": "MONOPHYSITISM, belief that Christ was primarily divine but in human form [n]\n",
  "MONOPITCH": "a monotone [n -ES]\n",
  "MONOPITCHES": "MONOPITCH, a monotone [n]\n",
  "MONOPLANE": "an aeroplane or glider with one set of wings [n -S]\n",
  "MONOPLANES": "MONOPLANE, an aeroplane or glider with one set of wings [n]\n",
  "MONOPLEGIA": "paralysis affecting a single limb [n -S]\n",
  "MONOPLEGIAS": "MONOPLEGIA, paralysis affecting a single limb [n]\n",
  "MONOPLEGIC": "related to monoplegia, paralysis affecting a single limb [adj] / one suffering from monoplegia [n -S]\n",
  "MONOPLEGICS": "MONOPLEGIC, one suffering from monoplegia [n]\n",
  "MONOPLOID": "a haploid organism, a gametophyte [n -S]\n",
  "MONOPLOIDS": "MONOPLOID, a haploid organism, a gametophyte [n]\n",
  "MONOPOD": "a one-footed person of fabulous Ethiopian race, with foot large enough to be a sunshade, also MONOPODE [n -S]\n",
  "MONOPODE": "a one-footed person of fabulous Ethiopian race, with foot large enough to be a sunshade, also MONOPOD [n -S]\n",
  "MONOPODES": "MONOPODE, a one-footed person of fabulous Ethiopian race, with foot large enough to be a sunshade, also MONOPOD [n]\n",
  "MONOPODIA": "a physical deformity in which the lower limbs appear to be fused together [n -S]\n",
  "MONOPODIAL": "having a monopodium or a single and continuous axis, as a birchen twig or a cornstalk [adj MONOPODIALLY]\n",
  "MONOPODIALLY": "MONOPODIAL, having a monopodium or a single and continuous axis, as a birchen twig or a cornstalk [adv]\n",
  "MONOPODIAS": "MONOPODIA, a physical deformity in which the lower limbs appear to be fused together [n]\n",
  "MONOPODIES": "MONOPODY, a measure consisting of a single metrical food [n]\n",
  "MONOPODIUM": "a stem in which the growth is continued from year to year by the same growing point [n MONOPODIA]\n",
  "MONOPODS": "MONOPOD, a one-footed person of fabulous Ethiopian race, with foot large enough to be a sunshade, also MONOPODE [n]\n",
  "MONOPODY": "a measure consisting of a single metrical food [n MONOPODIES]\n",
  "MONOPOLE": "a particle, thought to exist, that has a single magnetic charge [n -S]\n",
  "MONOPOLES": "MONOPOLE, a particle, thought to exist, that has a single magnetic charge [n]\n",
  "MONOPOLIES": "MONOPOLY, exclusive control or power [n]\n",
  "MONOPOLISATION": "the act of monopolising, also MONOPOLIZATION [n -S]\n",
  "MONOPOLISATIONS": "MONOPOLISATION, the act of monopolising, also MONOPOLIZATION [n]\n",
  "MONOPOLISE": "to get a monopoly of, also MONOPOLIZE [v MONOPOLISED, MONOPOLISING, MONOPOLISES]\n",
  "MONOPOLISED": "MONOPOLISE, to get a monopoly of, also MONOPOLIZE [v]\n",
  "MONOPOLISER": "one who monopolises, also MONOPOLIZER [n -S]\n",
  "MONOPOLISERS": "MONOPOLISER, one who monopolises, also MONOPOLIZER [n]\n",
  "MONOPOLISES": "MONOPOLISE, to get a monopoly of, also MONOPOLIZE [v]\n",
  "MONOPOLISING": "MONOPOLISE, to get a monopoly of, also MONOPOLIZE [v]\n",
  "MONOPOLISM": "the practice of operating monopolies [n -S]\n",
  "MONOPOLISMS": "MONOPOLISM, the practice of operating monopolies [n]\n",
  "MONOPOLIST": "a person who monopolizes [n -S]\n",
  "MONOPOLISTIC": "relating to monopolism, the practice of operating monopolies [adj]\n",
  "MONOPOLISTS": "MONOPOLIST, a person who monopolizes [n]\n",
  "MONOPOLIZATION": "the act of monopolizing, also MONOPOLISATION [n -S]\n",
  "MONOPOLIZATIONS": "MONOPOLIZATION, the act of monopolizing, also MONOPOLISATION [n]\n",
  "MONOPOLIZE": "to get a monopoly of, also MONOPOLISE [v MONOPOLIZED, MONOPOLIZING, MONOPOLIZES]\n",
  "MONOPOLIZED": "MONOPOLIZE, to get a monopoly of, also MONOPOLISE [v]\n",
  "MONOPOLIZER": "one who monopolizes, also MONOPOLISER [n -S]\n",
  "MONOPOLIZERS": "MONOPOLIZER, one who monopolizes, also MONOPOLISER [n]\n",
  "MONOPOLIZES": "MONOPOLIZE, to get a monopoly of, also MONOPOLISE [v]\n",
  "MONOPOLIZING": "MONOPOLIZE, to get a monopoly of, also MONOPOLISE [v]\n",
  "MONOPOLY": "exclusive control or power [n MONOPOLIES]\n",
  "MONOPRINT": "a single print taken from a design created in oil paint or printing ink on glass [n -S]\n",
  "MONOPRINTS": "MONOPRINT, a single print taken from a design created in oil paint or printing ink on glass [n]\n",
  "MONOPRIONIDIAN": "of graptolites, serrated on one side [adj]\n",
  "MONOPROPELLANT": "a rocket propellant containing both the fuel and the oxidizer in a single substance [n -S]\n",
  "MONOPROPELLANTS": "MONOPROPELLANT, a rocket propellant containing both the fuel and the oxidizer in a single substance [n]\n",
  "MONOPSONIES": "MONOPSONY, a market condition with one buyer and many sellers [n]\n",
  "MONOPSONIST": "a participant in a monopsony [n -S]\n",
  "MONOPSONISTIC": "relating to monopsony, a market condition with one buyer and many sellers [adj]\n",
  "MONOPSONISTS": "MONOPSONIST, a participant in a monopsony [n]\n",
  "MONOPSONY": "a market condition with one buyer and many sellers [n MONOPSONIES]\n",
  "MONOPTERA": "MONOPTERON, a circular temple with one ring of columns [n]\n",
  "MONOPTERAL": "resembling a monopteron [adj]\n",
  "MONOPTEROI": "MONOPTEROS, a building with single ring of columns supporting a roof [n]\n",
  "MONOPTERON": "a circular temple with one ring of columns [n MONOPTERA]\n",
  "MONOPTEROS": "a building with single ring of columns supporting a roof [n MONOPTERA or MONOPTEROI]\n",
  "MONOPTEROSES": "MONOPTEROS, a building with single ring of columns supporting a roof [n]\n",
  "MONOPTOTE": "a noun that has one grammatical case only [n -S]\n",
  "MONOPTOTES": "MONOPTOTE, a noun that has one grammatical case only [n]\n",
  "MONOPULSE": "a type of radar system used in gun control [n -S]\n",
  "MONOPULSES": "MONOPULSE, a type of radar system used in gun control [n]\n",
  "MONORAIL": "a railway running on one track [n -S]\n",
  "MONORAILS": "MONORAIL, a railway running on one track [n]\n",
  "MONORCHID": "having only one testicle [adj] / someone with only one testicle [n -S]\n",
  "MONORCHIDISM": "the state of being monorchid, having one testicle, also MONORCHISM [n -S]\n",
  "MONORCHIDISMS": "MONORCHIDISM, the state of being monorchid, having one testicle, also MONORCHISM [n]\n",
  "MONORCHIDS": "MONORCHID, someone with only one testicle [n]\n",
  "MONORCHISM": "the state of being monorchid, having one testicle, also MONORCHIDISM [n -S]\n",
  "MONORCHISMS": "MONORCHISM, the state of being monorchid, having one testicle, also MONORCHIDISM [n]\n",
  "MONORHINAL": "having one nostril, also MONORHINE [adj]\n",
  "MONORHINE": "having one nostril, also MONORHINAL [adj] / an animal that has one nasal orifice [n -S]\n",
  "MONORHINES": "MONORHINE, an animal that has one nasal orifice [n]\n",
  "MONORHYME": "a series of lines all rhyming together [n -S]\n",
  "MONORHYMED": "rhymed on a single rhyme [adj]\n",
  "MONORHYMES": "MONORHYME, a series of lines all rhyming together [n]\n",
  "MONOS": "MONO, the black howler monkey of Central America [n]\n",
  "MONOSACCHARIDE": "a simple sugar e.g. glucose or fructose [n -S]\n",
  "MONOSACCHARIDES": "MONOSACCHARIDE, a simple sugar e.g. glucose or fructose [n]\n",
  "MONOSATURATED": "of or relating to fats that are liquid at room temperature, mostly deriving from nuts, avocados etc. [adj]\n",
  "MONOSEMIC": "having only a single meaning [adj]\n",
  "MONOSEMIES": "MONOSEMY, having a single meaning, as opposed to polysemy [n]\n",
  "MONOSEMY": "having a single meaning, as opposed to polysemy [n MONOSEMIES]\n",
  "MONOSEPALOUS": "sepals fused [adj]\n",
  "MONOSES": "MONOSIS, (Greek) a separation of parts normally fused, also MONOSY [n]\n",
  "MONOSIES": "MONOSY, a separation of parts normally fused, also MONOSIS [n]\n",
  "MONOSIS": "(Greek) a separation of parts normally fused, also MONOSY [n MONOSES]\n",
  "MONOSKI": "a wide ski on which a skier stands with both feet [n -S] / to ski on a monoski [v -ED, -ING, -S]\n",
  "MONOSKIED": "MONOSKI, to ski on a monoski [v]\n",
  "MONOSKIER": "one who skis on a monoski [n -S]\n",
  "MONOSKIERS": "MONOSKIER, one who skis on a monoski [n]\n",
  "MONOSKIING": "the sport of skiing on a wide ski on which a skier stands with both feet [n -S]\n",
  "MONOSKIINGS": "MONOSKIING, the sport of skiing on a wide ski on which a skier stands with both feet [n]\n",
  "MONOSKIS": "MONOSKI, to ski on a monoski [v]\n",
  "MONOSODIUM": "as in monosodium glutamate, a white crystalline salt which brings out the flavour of meat, widely used as an additive in the food industry [adj]\n",
  "MONOSOME": "an unpaired chromosome [n -S]\n",
  "MONOSOMES": "MONOSOME, an unpaired chromosome [n]\n",
  "MONOSOMIC": "relating to a monosome, an unpaired chromosome [adj] / a monosomic individual or variety [n -S]\n",
  "MONOSOMICS": "MONOSOMIC, a monosomic individual or variety [n]\n",
  "MONOSOMIES": "MONOSOMY, a condition of having one unpaired chromosome [n]\n",
  "MONOSOMY": "a condition of having one unpaired chromosome [n MONOSOMIES]\n",
  "MONOSPACED": "single-spaced [adj]\n",
  "MONOSPECIFIC": "specific for a single antigen or receptor site on an antigen [adj]\n",
  "MONOSPECIFICITY": "the state of being monospecific [n]\n",
  "MONOSPERMAL": "producing only one seed, also MONOSPERMOUS [adj]\n",
  "MONOSPERMOUS": "producing only one seed, also MONOSPERMAL [adj]\n",
  "MONOSTABLE": "of an electronic circuit, having only one stable state but able to pass into a second state in response to an input pulse [adj]\n",
  "MONOSTELE": "a single stele, also MONOSTELY [n -S]\n",
  "MONOSTELES": "MONOSTELE, a single stele, also MONOSTELY [n]\n",
  "MONOSTELIC": "with a single stele [adj]\n",
  "MONOSTELIES": "MONOSTELY, a single stele, also MONOSTELE [n]\n",
  "MONOSTELY": "a single stele, also MONOSTELE [n MONOSTELIES]\n",
  "MONOSTICH": "a composition consisting of one verse only [n -S]\n",
  "MONOSTICHIC": "like a monostich, a composition consisting of one verse only [adj]\n",
  "MONOSTICHOUS": "in one line; in one row [adj]\n",
  "MONOSTICHS": "MONOSTICH, a composition consisting of one verse only [n]\n",
  "MONOSTOME": "having only one mouth, pore or similar opening, also MONOSTOMOUS [adj]\n",
  "MONOSTOMOUS": "having only one mouth, pore or similar opening, also MONOSTOME [adj]\n",
  "MONOSTROPHE": "a poem in which all the stanzas or strophes are written in the same metre [n -S]\n",
  "MONOSTROPHES": "MONOSTROPHE, a poem in which all the stanzas or strophes are written in the same metre [n]\n",
  "MONOSTROPHIC": "having the same strophic or stanzaic structure throughout [adj]\n",
  "MONOSTROPHICS": "monostrophic verses [n]\n",
  "MONOSTYLAR": "consisting of a single shaft, also MONOSTYLE [adj]\n",
  "MONOSTYLE": "consisting of a single shaft, also MONOSTYLAR [adj]\n",
  "MONOSTYLOUS": "having only one style [adj]\n",
  "MONOSY": "a separation of parts normally fused, also MONOSIS [n MONOSIES]\n",
  "MONOSYLLABIC": "consisting of one syllable or of monosyllables [adj]\n",
  "MONOSYLLABICITY": "the state of being monosyllabic, also MONOSYLLABISM [n]\n",
  "MONOSYLLABISM": "the state of being monosyllabic, also MONOSYLLABICITY [n -S]\n",
  "MONOSYLLABISMS": "MONOSYLLABISM, the state of being monosyllabic, also MONOSYLLABICITY [n]\n",
  "MONOSYLLABLE": "a word of one syllable [n -S]\n",
  "MONOSYLLABLES": "MONOSYLLABLE, a word of one syllable [n]\n",
  "MONOSYMMETRIC": "having only one plane of symmetry, also MONOSYMMETRICAL [adj]\n",
  "MONOSYMMETRICAL": "having only one plane of symmetry, also MONOSYMMETRIC [adj]\n",
  "MONOSYMMETRIES": "MONOSYMMETRY, the state of being monosymmetric, having only one plane of symmetry [n]\n",
  "MONOSYMMETRY": "the state of being monosymmetric, having only one plane of symmetry [n MONOSYMMETRIES]\n",
  "MONOSYNAPTIC": "having or involving a single neural synapse [adj]\n",
  "MONOTASK": "to perform one task at a time [v -ED, -ING, -S]\n",
  "MONOTASKED": "MONOTASK, to perform one task at a time [v]\n",
  "MONOTASKING": "the act of performing one task at a time [n -S]\n",
  "MONOTASKINGS": "MONOTASKING, the act of performing one task at a time [n]\n",
  "MONOTASKS": "MONOTASK, to perform one task at a time [v]\n",
  "MONOTELEPHONE": "a telephone that transmits sounds of one pitch only [n -S]\n",
  "MONOTELEPHONES": "MONOTELEPHONE, a telephone that transmits sounds of one pitch only [n]\n",
  "MONOTERPENE": "any of a class of terpenes containing two isoprene units per molecule [n -S]\n",
  "MONOTERPENES": "MONOTERPENE, any of a class of terpenes containing two isoprene units per molecule [n]\n",
  "MONOTHALAMIC": "of fruit, formed from a single flower [adj]\n",
  "MONOTHALAMOUS": "of an animal or protist, having a shell, test, or skeleton with a single chamber [adj]\n",
  "MONOTHECAL": "having only one theca, also MONOTHECOUS [adj]\n",
  "MONOTHECOUS": "having only one theca, also MONOTHECAL [adj]\n",
  "MONOTHEISM": "belief in only one God [n -S]\n",
  "MONOTHEISMS": "MONOTHEISM, belief in only one God [n]\n",
  "MONOTHEIST": "one who believes that there is but one God [n -S]\n",
  "MONOTHEISTIC": "relating to monotheism, also MONOTHEISTICAL [adj]\n",
  "MONOTHEISTICAL": "relating to monotheism, also MONOTHEISTIC [adj]\n",
  "MONOTHEISTS": "MONOTHEIST, one who believes that there is but one God [n]\n",
  "MONOTHELETE": "a believer in Monotheletism [n -S]\n",
  "MONOTHELETES": "MONOTHELETE, a believer in Monotheletism [n]\n",
  "MONOTHELETIC": "like a monothelete, also MONOTHELETICAL [adj]\n",
  "MONOTHELETICAL": "like a monothelete, also MONOTHELETIC [adj]\n",
  "MONOTHELETISM": "the belief that Christ had only one will [n -S]\n",
  "MONOTHELETISMS": "MONOTHELETISM, the belief that Christ had only one will [n]\n",
  "MONOTHELISM": "the doctrine that Christ had only one will, also MONOTHELITISM [n -S]\n",
  "MONOTHELISMS": "MONOTHELISM, the doctrine that Christ had only one will, also MONOTHELITISM [n]\n",
  "MONOTHELITE": "a believer in monothelitism, the doctrine that Christ had only one will [n -S]\n",
  "MONOTHELITES": "MONOTHELITE, a believer in monothelitism, the doctrine that Christ had only one will [n]\n",
  "MONOTHELITISM": "the doctrine that Christ had only one will, also MONOTHELISM [n -S]\n",
  "MONOTHELITISMS": "MONOTHELITISM, the doctrine that Christ had only one will, also MONOTHELISM [n]\n",
  "MONOTHERAPIES": "MONOTHERAPY, a medical treatment using a single drug or therapy [n]\n",
  "MONOTHERAPY": "a medical treatment using a single drug or therapy [n MONOTHERAPIES]\n",
  "MONOTINT": "a painting done in different shades of one colour [n -S]\n",
  "MONOTINTS": "MONOTINT, a painting done in different shades of one colour [n]\n",
  "MONOTOCOUS": "producing only one offspring at any one time; fruiting once only [adj]\n",
  "MONOTONE": "to sing or speak in a single unvaried tone or pitch [v MONOTONED, MONOTONING, MONOTONES]\n",
  "MONOTONED": "MONOTONE, to sing or speak in a single unvaried tone or pitch [v]\n",
  "MONOTONES": "MONOTONE, to sing or speak in a single unvaried tone or pitch [v]\n",
  "MONOTONIC": "having one tone; of a mathematical series, increasing or decreasing evenly [adj MONOTONICALLY]\n",
  "MONOTONICALLY": "MONOTONIC, having one tone; of a mathematical series, increasing or decreasing evenly [adv]\n",
  "MONOTONICITIES": "MONOTONICITY, the state of being monotonic [n]\n",
  "MONOTONICITY": "the state of being monotonic [n MONOTONICITIES]\n",
  "MONOTONIES": "MONOTONY, tedious sameness [n]\n",
  "MONOTONING": "MONOTONE, to sing or speak in a single unvaried tone or pitch [v]\n",
  "MONOTONISE": "to make into a monotone, also MONOTONIZE [v MONOTONISED, MONOTONISING, MONOTONISES]\n",
  "MONOTONISED": "MONOTONISE, to make into a monotone, also MONOTONIZE [v]\n",
  "MONOTONISES": "MONOTONISE, to make into a monotone, also MONOTONIZE [v]\n",
  "MONOTONISING": "MONOTONISE, to make into a monotone, also MONOTONIZE [v]\n",
  "MONOTONIZE": "to make into a monotone, also MONOTONISE [v MONOTONIZED, MONOTONIZING, MONOTONIZES]\n",
  "MONOTONIZED": "MONOTONIZE, to make into a monotone, also MONOTONISE [v]\n",
  "MONOTONIZES": "MONOTONIZE, to make into a monotone, also MONOTONISE [v]\n",
  "MONOTONIZING": "MONOTONIZE, to make into a monotone, also MONOTONISE [v]\n",
  "MONOTONOUS": "uttered or sounded in one unvarying tone [adj MONOTONOUSLY]\n",
  "MONOTONOUSLY": "MONOTONOUS, uttered or sounded in one unvarying tone [adv]\n",
  "MONOTONOUSNESS": "MONOTONOUS, uttered or sounded in one unvarying tone [n]\n",
  "MONOTONY": "tedious sameness [n MONOTONIES]\n",
  "MONOTREMATOUS": "like a monotreme [adj]\n",
  "MONOTREME": "a primitive Australian egg-laying mammal, e.g. a duck-billed platypus [n -S]\n",
  "MONOTREMES": "MONOTREME, a primitive Australian egg-laying mammal, e.g. a duck-billed platypus [n]\n",
  "MONOTRICHIC": "of bacteria, having a single flagellum, also MONOTRICHOUS [adj]\n",
  "MONOTRICHOUS": "of bacteria, having a single flagellum, also MONOTRICHIC [adj]\n",
  "MONOTROCH": "(Scott) a wheelbarrow [n -S]\n",
  "MONOTROCHS": "MONOTROCH, (Scott) a wheelbarrow [n]\n",
  "MONOTYPE": "a monotypic genus or other taxon [n -S]\n",
  "MONOTYPES": "MONOTYPE, a monotypic genus or other taxon [n]\n",
  "MONOTYPIC": "of a genus, containing only one species [adj]\n",
  "MONOUNSATURATE": "a monounsaturated compound [n -S]\n",
  "MONOUNSATURATED": "containing one double or triple bond per molecule [adj]\n",
  "MONOUNSATURATES": "MONOUNSATURATE, a monounsaturated compound [n]\n",
  "MONOVALENCE": "the state of being monovalent, also MONOVALENCY [n -S]\n",
  "MONOVALENCES": "MONOVALENCE, the state of being monovalent, also MONOVALENCY [n]\n",
  "MONOVALENCIES": "MONOVALENCY, the state of being monovalent, also MONOVALENCE [n]\n",
  "MONOVALENCY": "the state of being monovalent, also MONOVALENCE [n MONOVALENCIES]\n",
  "MONOVALENT": "having a valence of one [adj]\n",
  "MONOVULAR": "having one ovule [adj]\n",
  "MONOXIDE": "an oxide containing one atom of oxygen in the molecule or empirical formula [n -S]\n",
  "MONOXIDES": "MONOXIDE, an oxide containing one atom of oxygen in the molecule or empirical formula [n]\n",
  "MONOXYLON": "a canoe made from one log [n -S]\n",
  "MONOXYLONS": "MONOXYLON, a canoe made from one log [n]\n",
  "MONOXYLOUS": "made of one piece of wood [adj]\n",
  "MONOZYGOTIC": "developed from one zygote only, also MONOZYGOUS [adj]\n",
  "MONOZYGOUS": "developed from one zygote only, also MONOZYGOTIC [adj]\n",
  "MONS": "(Latin) a protuberance of the body [n MONTES]\n",
  "MONSEIGNEUR": "(French) a French title of respect given to princes and prelates [n MESSEIGNEURS or MONSEIGNEURS]\n",
  "MONSEIGNEURS": "MONSEIGNEUR, (French) a French title of respect given to princes and prelates [n]\n",
  "MONSIEUR": "(French) a French title of courtesy for a man [n MESSIEURS]\n",
  "MONSIGNOR": "(Italian) an honorific title given to a Roman Catholic prelate, officer of the papal court and household, etc. [n MONSIGNORI or MONSIGNORS]\n",
  "MONSIGNORI": "MONSIGNOR, (Italian) an honorific title given to a Roman Catholic prelate, officer of the papal court and household, etc. [n]\n",
  "MONSIGNORIAL": "of or like a monsignor [adj]\n",
  "MONSIGNORS": "MONSIGNOR, (Italian) an honorific title given to a Roman Catholic prelate, officer of the papal court and household, etc. [n]\n",
  "MONSOON": "a wind system in SE Asia which changes direction seasonally, creating wet and dry seasons [n -S]\n",
  "MONSOONAL": "relating to a monsoon [adj]\n",
  "MONSOONS": "MONSOON, a wind system in SE Asia which changes direction seasonally, creating wet and dry seasons [n]\n",
  "MONSTER": "an extraordinary grotesque or gigantic animal [n -S] / to criticise devastatingly [v -ED, -ING, -S]\n",
  "MONSTERA": "a kind of fruit, grown in Queensland and the West Indies [n -S]\n",
  "MONSTERAS": "MONSTERA, a kind of fruit, grown in Queensland and the West Indies [n]\n",
  "MONSTERED": "MONSTER, to criticise devastatingly [v]\n",
  "MONSTERING": "the act of criticising severely [n -S]\n",
  "MONSTERINGS": "MONSTERING, the act of criticising severely [n]\n",
  "MONSTERS": "MONSTER, an extraordinary grotesque or gigantic animal [n]\n",
  "MONSTRANCE": "an ecclesiastical vessel to expose the Eucharist [n -S]\n",
  "MONSTRANCES": "MONSTRANCE, an ecclesiastical vessel to expose the Eucharist [n]\n",
  "MONSTROSITIES": "MONSTROSITY, a malformation of a plant or animal, also MONSTRUOSITY [n]\n",
  "MONSTROSITY": "a malformation of a plant or animal, also MONSTRUOSITY [n MONSTROSITIES]\n",
  "MONSTROUS": "huge, like a monster, also MONSTRUOUS [adj MONSTROUSLY]\n",
  "MONSTROUSLY": "MONSTROUS, huge, like a monster, also MONSTRUOUS [adv]\n",
  "MONSTROUSNESS": "the state of being monstrous [n -ES]\n",
  "MONSTROUSNESSES": "MONSTROUSNESS, the state of being monstrous [n]\n",
  "MONSTRUOSITIES": "MONSTRUOSITY, (obsolete) monstrosity [n]\n",
  "MONSTRUOSITY": "(obsolete) monstrosity [n MONSTRUOSITIES]\n",
  "MONSTRUOUS": "(obsolete) monstrous [adj]\n",
  "MONTADALE": "any of an American breed of white-faced hornless sheep [n -S]\n",
  "MONTADALES": "MONTADALE, any of an American breed of white-faced hornless sheep [n]\n",
  "MONTAGE": "(French) to combine into a composite picture [v MONTAGED, MONTAGING, MONTAGES]\n",
  "MONTAGED": "MONTAGE, (French) to combine into a composite picture [v]\n",
  "MONTAGES": "MONTAGE, (French) to combine into a composite picture [v]\n",
  "MONTAGING": "MONTAGE, (French) to combine into a composite picture [v]\n",
  "MONTAGNARD": "one of a mountain-dwelling people of Southern Vietnam on the Cambodian border [n -S]\n",
  "MONTAGNARDS": "MONTAGNARD, one of a mountain-dwelling people of Southern Vietnam on the Cambodian border [n]\n",
  "MONTAN": "as in montan wax, a hard wax obtained from peat and lignites [adj]\n",
  "MONTANE": "the lower vegetation belt of a mountain [n -S]\n",
  "MONTANES": "MONTANE, the lower vegetation belt of a mountain [n]\n",
  "MONTANT": "(French) a vertical member in framing, also MONTANTO [n -S]\n",
  "MONTANTO": "(Shakespeare) an upward blow in fencing, also MONTANT [n -S]\n",
  "MONTANTOS": "MONTANTO, (Shakespeare) an upward blow in fencing, also MONTANT [n]\n",
  "MONTANTS": "MONTANT, (French) a vertical member in framing, also MONTANTO [n]\n",
  "MONTARIA": "(Portuguese) in Brazil, a light canoe made of one log [n -S]\n",
  "MONTARIAS": "MONTARIA, (Portuguese) in Brazil, a light canoe made of one log [n]\n",
  "MONTBRETIA": "a widely cultivated plant of the African iridaceous genus Crocosmia [n -S]\n",
  "MONTBRETIAS": "MONTBRETIA, a widely cultivated plant of the African iridaceous genus Crocosmia [n]\n",
  "MONTE": "(Spanish) a favorite gambling game among Spaniards, played with dice or cards [n -S]\n",
  "MONTEITH": "(Scots) a large 17th or 18th century bowl, usually of silver, for cooling punch glasses [n -S]\n",
  "MONTEITHS": "MONTEITH, (Scots) a large 17th or 18th century bowl, usually of silver, for cooling punch glasses [n]\n",
  "MONTELIMAR": "a kind of chocolate [n -S]\n",
  "MONTELIMARS": "MONTELIMAR, a kind of chocolate [n]\n",
  "MONTEM": "(Latin) a custom, formerly practised by the scholars at Eton, of going every third year, on Whit Tuesday, to a hillock near the Bath road, and exacting money from passersby, to support at the university the senior scholar of the school [n -S]\n",
  "MONTEMS": "MONTEM, (Latin) a custom, formerly practised by the scholars at Eton, of going every third year, on Whit Tuesday, to a hillock near the Bath road, and exacting money from passersby, to support at the university the senior scholar of the school [n]\n",
  "MONTERO": "(Spanish) a huntsman's cap with side flaps [n -S]\n",
  "MONTEROS": "MONTERO, (Spanish) a huntsman's cap with side flaps [n]\n",
  "MONTES": "MONS, (Latin) a protuberance of the body [n]\n",
  "MONTGOLFIER": "(French) a balloon using fire for propulsion [n -S]\n",
  "MONTGOLFIERS": "MONTGOLFIER, (French) a balloon using fire for propulsion [n]\n",
  "MONTH": "one of the twelve conventional divisions of the year, or its length, also MONETH [n -S]\n",
  "MONTHLIES": "MONTHLY, a publication issued once a month [n]\n",
  "MONTHLING": "(archaic) a month-old child [n -S]\n",
  "MONTHLINGS": "MONTHLING, (archaic) a month-old child [n]\n",
  "MONTHLONG": "lasting for a month [adj]\n",
  "MONTHLY": "a publication issued once a month [n MONTHLIES]\n",
  "MONTHS": "MONTH, one of the twelve conventional divisions of the year, or its length, also MONETH [n]\n",
  "MONTICELLITE": "a calcium magnesium silicate [n -S]\n",
  "MONTICELLITES": "MONTICELLITE, a calcium magnesium silicate [n]\n",
  "MONTICLE": "a little hill, also MONTICULUS [n -S]\n",
  "MONTICLES": "MONTICLE, a little hill, also MONTICULUS [n]\n",
  "MONTICOLOUS": "mountain-dwelling [adj]\n",
  "MONTICULATE": "having small projections, also MONTICULOUS [adj]\n",
  "MONTICULE": "(French) a secondary volcanic cone [n -S]\n",
  "MONTICULES": "MONTICULE, (French) a secondary volcanic cone [n]\n",
  "MONTICULOUS": "having small projections, also MONTICULATE [adj]\n",
  "MONTICULUS": "a little hill, also MONTICLE [n -ES]\n",
  "MONTICULUSES": "MONTICULUS, a little hill, also MONTICLE [n]\n",
  "MONTIES": "MONTY, the whole lot, as in the phrase 'the full monty' [n]\n",
  "MONTMORILLONITE": "an alumina-rich clay mineral containing some sodium and magnesium [n]\n",
  "MONTRE": "(French) the visible pipes of an organ [n -S]\n",
  "MONTRES": "MONTRE, (French) the visible pipes of an organ [n]\n",
  "MONTURE": "(French) a mounting, setting or frame [n -S]\n",
  "MONTURES": "MONTURE, (French) a mounting, setting or frame [n]\n",
  "MONTY": "the whole lot, as in the phrase 'the full monty' [n MONTIES]\n",
  "MONUMENT": "anything that preserves the memory of a person or an event [n -S] / to mark with a monument [v -ED, -ING, -S]\n",
  "MONUMENTAL": "very large [adj MONUMENTALLY]\n",
  "MONUMENTALISE": "to record or memorialize lastingly by a monument, also MONUMENTALIZE [v MONUMENTALISED, MONUMENTALISING, MONUMENTALISES]\n",
  "MONUMENTALISED": "MONUMENTALISE, to record or memorialize lastingly by a monument, also MONUMENTALIZE [v]\n",
  "MONUMENTALISES": "MONUMENTALISE, to record or memorialize lastingly by a monument, also MONUMENTALIZE [v]\n",
  "MONUMENTALISING": "MONUMENTALISE, to record or memorialize lastingly by a monument, also MONUMENTALIZE [v]\n",
  "MONUMENTALITIES": "MONUMENTALITY, the state of being monumental [n]\n",
  "MONUMENTALITY": "the state of being monumental [n MONUMENTALITIES]\n",
  "MONUMENTALIZE": "to record or memorialize lastingly by a monument, also MONUMENTALISE [v MONUMENTALIZED, MONUMENTALIZING, MONUMENTALIZES]\n",
  "MONUMENTALIZED": "MONUMENTALIZE, to record or memorialize lastingly by a monument, also MONUMENTALISE [v]\n",
  "MONUMENTALIZES": "MONUMENTALIZE, to record or memorialize lastingly by a monument, also MONUMENTALISE [v]\n",
  "MONUMENTALIZING": "MONUMENTALIZE, to record or memorialize lastingly by a monument, also MONUMENTALISE [v]\n",
  "MONUMENTALLY": "MONUMENTAL, very large [adv]\n",
  "MONUMENTED": "MONUMENT, to mark with a monument [v]\n",
  "MONUMENTING": "MONUMENT, to mark with a monument [v]\n",
  "MONUMENTS": "MONUMENT, to mark with a monument [v]\n",
  "MONURON": "a herbicide [n -S]\n",
  "MONURONS": "MONURON, a herbicide [n]\n",
  "MONY": "(Scots) many, also MONIE [adj]\n",
  "MONYPLIES": "the third stomach of a ruminant, aka omasum or psalterium, also MANIPLIES, MANYPLIES, MONIPLIES [n]\n",
  "MONZONITE": "a coarse-grained intermediate igneous rock [n -S]\n",
  "MONZONITES": "MONZONITE, a coarse-grained intermediate igneous rock [n]\n",
  "MONZONITIC": "of or like monzonite, a type of igneous rock [adj]\n",
  "MOO": "to make the sound of a cow [v -ED, -ING, -S]\n",
  "MOOBIES": "overdeveloped breasts on a man, caused by excess weight or lack of exercise, also MOOBS [n]\n",
  "MOOBS": "overdeveloped breasts on a man, caused by excess weight or lack of exercise, also MOOBIES [n]\n",
  "MOOCH": "to play truant, also MICH, MICHE, MITCH, MOUCH [v -ED, -ING, -ES]\n",
  "MOOCHED": "MOOCH, to play truant, also MICH, MICHE, MITCH, MOUCH [v]\n",
  "MOOCHER": "a truant, also MICHER, MOUCHER [n -S]\n",
  "MOOCHERS": "MOOCHER, a truant, also MICHER, MOUCHER [n]\n",
  "MOOCHES": "MOOCH, to play truant, also MICH, MICHE, MITCH, MOUCH [v]\n",
  "MOOCHING": "MOOCH, to play truant, also MICH, MICHE, MITCH, MOUCH [v]\n",
  "MOOD": "a temporary state of the emotions or attitude [n -S]\n",
  "MOODIED": "MOODY, to persuade by flattery [v]\n",
  "MOODIER": "MOODY, given to changing attitudes [adj]\n",
  "MOODIES": "MOODY, to persuade by flattery [v]\n",
  "MOODIEST": "MOODY, given to changing attitudes [adj]\n",
  "MOODILY": "MOODY, given to changing attitudes [adv]\n",
  "MOODINESS": "the state of being moody [n -ES]\n",
  "MOODINESSES": "MOODINESS, the state of being moody [n]\n",
  "MOODS": "MOOD, a temporary state of the emotions or attitude [n]\n",
  "MOODY": "given to changing attitudes [adj MOODIER, MOODIEST, MOODILY] / to persuade by flattery [v MOODIED, MOODYING, MOODIES]\n",
  "MOODYING": "MOODY, to persuade by flattery [v]\n",
  "MOOED": "MOO, to make the sound of a cow [v]\n",
  "MOOI": "(South African) fine [adj]\n",
  "MOOING": "MOO, to make the sound of a cow [v]\n",
  "MOOK": "a book produced in magazine format [n -S]\n",
  "MOOKS": "MOOK, a book produced in magazine format [n]\n",
  "MOOKTAR": "(Arabic) an Indian lawyer; a Turkish local government official, also MUKHTAR [n -S]\n",
  "MOOKTARS": "MOOKTAR, (Arabic) an Indian lawyer; a Turkish local government official, also MUKHTAR [n]\n",
  "MOOL": "(Scots) to cover with soil [v -ED, -ING, -S]\n",
  "MOOLA": "(slang) money [n -S]\n",
  "MOOLAH": "(Arabic) a Muslim learned in theology and law, also MOLLA, MOLLAH, MULLA, MULLAH, MULLER [n -S]\n",
  "MOOLAHS": "MOOLAH, (Arabic) a Muslim learned in theology and law, also MOLLA, MOLLAH, MULLA, MULLAH, MULLER [n]\n",
  "MOOLAS": "MOOLA, (slang) money [n]\n",
  "MOOLED": "MOOL, (Scots) to cover with soil [v]\n",
  "MOOLEY": "a hornless cow, also MULEY, MOOLY, MULLEY [n -S]\n",
  "MOOLEYS": "MOOLEY, a hornless cow, also MULEY, MOOLY, MULLEY [n]\n",
  "MOOLI": "an East African vegetable like a radish [n -S]\n",
  "MOOLIES": "MOOLY, a hornless cow, also MULEY, MOOLEY, MULLEY [n]\n",
  "MOOLING": "MOOL, (Scots) to cover with soil [v]\n",
  "MOOLIS": "MOOLI, an East African vegetable like a radish [n]\n",
  "MOOLOO": "(New Zealand) someone from the Waikato [n -S]\n",
  "MOOLOOS": "MOOLOO, (New Zealand) someone from the Waikato [n]\n",
  "MOOLS": "MOOL, (Scots) to cover with soil [v]\n",
  "MOOLVI": "(Urdu) a teacher of Islamic law, also MAULVI, MOOLVIE [n -S]\n",
  "MOOLVIE": "(Urdu) a teacher of Islamic law, also MAULVI, MOOLVI [n -S]\n",
  "MOOLVIES": "MOOLVIE, (Urdu) a teacher of Islamic law, also MAULVI, MOOLVI [n]\n",
  "MOOLVIS": "MOOLVI, (Urdu) a teacher of Islamic law, also MAULVI, MOOLVIE [n]\n",
  "MOOLY": "a hornless cow, also MULEY, MOOLEY, MULLEY [n MOOLIES]\n",
  "MOON": "to wander about listlessly [v -ED, -ING, -S]\n",
  "MOONBEAM": "a ray of light from the moon [n -S]\n",
  "MOONBEAMS": "MOONBEAM, a ray of light from the moon [n]\n",
  "MOONBLIND": "dim-sighted; purblind [adj]\n",
  "MOONBOOTS": "thickly padded boots having a fabric outer covering [n]\n",
  "MOONBOW": "a rainbow formed by light from the moon [n -S]\n",
  "MOONBOWS": "MOONBOW, a rainbow formed by light from the moon [n]\n",
  "MOONCAKE": "a kind of Chinese pastry traditionally eaten during the Mid-Autumn Festival [n -S]\n",
  "MOONCAKES": "MOONCAKE, a kind of Chinese pastry traditionally eaten during the Mid-Autumn Festival [n]\n",
  "MOONCALF": "a foolish person [n MOONCALVES]\n",
  "MOONCALVES": "MOONCALF, a foolish person [n]\n",
  "MOONCHILD": "someone who is born under the Cancer star sign [n MOONCHILDREN]\n",
  "MOONCHILDREN": "MOONCHILD, someone who is born under the Cancer star sign [n]\n",
  "MOONCRAFT": "a lunar module [n -S]\n",
  "MOONCRAFTS": "MOONCRAFT, a lunar module [n]\n",
  "MOONDOG": "a bright spot in the sky formed by refracted moonlight [n -S]\n",
  "MOONDOGS": "MOONDOG, a bright spot in the sky formed by refracted moonlight [n]\n",
  "MOONDUST": "dust on the moon [n -S]\n",
  "MOONDUSTS": "MOONDUST, dust on the moon [n]\n",
  "MOONED": "MOON, to wander about listlessly [v]\n",
  "MOONER": "one who abstractedly wanders or gazes about, as if moonstruck [n -S]\n",
  "MOONERS": "MOONER, one who abstractedly wanders or gazes about, as if moonstruck [n]\n",
  "MOONEYE": "a freshwater fish of the shad family [n -S]\n",
  "MOONEYES": "MOONEYE, a freshwater fish of the shad family [n]\n",
  "MOONFACE": "a full round face [n -S]\n",
  "MOONFACED": "having a round, moonlike face [adj]\n",
  "MOONFACES": "MOONFACE, a full round face [n]\n",
  "MOONFISH": "the opah or other silvery disc-shaped fish [n -ES]\n",
  "MOONFISHES": "MOONFISH, the opah or other silvery disc-shaped fish [n]\n",
  "MOONFLOWER": "a tropical flower [n -S]\n",
  "MOONFLOWERS": "MOONFLOWER, a tropical flower [n]\n",
  "MOONG": "as in moong bean, a kind of bean [adj]\n",
  "MOONGATE": "a circular gate in a wall [n -S]\n",
  "MOONGATES": "MOONGATE, a circular gate in a wall [n]\n",
  "MOONIER": "MOONY, resembling the moon, dreamy [adj]\n",
  "MOONIES": "MOONY, a simpleton [n]\n",
  "MOONIEST": "MOONY, resembling the moon, dreamy [adj]\n",
  "MOONILY": "MOONY, resembling the moon, dreamy [adv]\n",
  "MOONINESS": "the state of being moony [n -ES]\n",
  "MOONINESSES": "MOONINESS, the state of being moony [n]\n",
  "MOONING": "MOON, to wander about listlessly [v]\n",
  "MOONISH": "like the moon; variable [adj MOONISHLY]\n",
  "MOONISHLY": "MOONISH, like the moon; variable [adv]\n",
  "MOONLESS": "lacking the light of the moon [adj]\n",
  "MOONLET": "a small satellite [n -S]\n",
  "MOONLETS": "MOONLET, a small satellite [n]\n",
  "MOONLIGHT": "the light of the moon [n -S] / to take a second job [v -ED, -ING, -S]\n",
  "MOONLIGHTED": "MOONLIGHT, to take a second job [v]\n",
  "MOONLIGHTER": "one who takes an additional job [n -S]\n",
  "MOONLIGHTERS": "MOONLIGHTER, one who takes an additional job [n]\n",
  "MOONLIGHTING": "taking a second job [n -S]\n",
  "MOONLIGHTINGS": "MOONLIGHTING, taking a second job [n]\n",
  "MOONLIGHTS": "MOONLIGHT, to take a second job [v]\n",
  "MOONLIKE": "like a moon [adj]\n",
  "MOONLIT": "lit by the moon [adj]\n",
  "MOONPHASE": "a phase of the moon [n -S]\n",
  "MOONPHASES": "MOONPHASE, a phase of the moon [n]\n",
  "MOONPORT": "a facility for launching spacecraft to the moon [n -S]\n",
  "MOONPORTS": "MOONPORT, a facility for launching spacecraft to the moon [n]\n",
  "MOONQUAKE": "a seismic disturbance on the moon [n -S]\n",
  "MOONQUAKES": "MOONQUAKE, a seismic disturbance on the moon [n]\n",
  "MOONRAKER": "a small sail sometimes carried above a skyscraper, aka a moonsail [n -S]\n",
  "MOONRAKERS": "MOONRAKER, a small sail sometimes carried above a skyscraper, aka a moonsail [n]\n",
  "MOONRAKING": "the following of crazy fancies [n -S]\n",
  "MOONRAKINGS": "MOONRAKING, the following of crazy fancies [n]\n",
  "MOONRISE": "the time when the moon appears [n -S]\n",
  "MOONRISES": "MOONRISE, the time when the moon appears [n]\n",
  "MOONROCK": "rock from the moon's surface [n -S]\n",
  "MOONROCKS": "MOONROCK, rock from the moon's surface [n]\n",
  "MOONROOF": "the transport roof of a motor car [n -S]\n",
  "MOONROOFS": "MOONROOF, the transport roof of a motor car [n]\n",
  "MOONS": "MOON, to wander about listlessly [v]\n",
  "MOONSAIL": "a sail sometimes carried in light winds, above a skysail [n -S]\n",
  "MOONSAILS": "MOONSAIL, a sail sometimes carried in light winds, above a skysail [n]\n",
  "MOONSCAPE": "a view of the moon's surface [n -S]\n",
  "MOONSCAPES": "MOONSCAPE, a view of the moon's surface [n]\n",
  "MOONSEED": "a plant of genus Menispermum with lunate seeds [n -S]\n",
  "MOONSEEDS": "MOONSEED, a plant of genus Menispermum with lunate seeds [n]\n",
  "MOONSET": "the time when the moon disappears [n -S]\n",
  "MOONSETS": "MOONSET, the time when the moon disappears [n]\n",
  "MOONSHEE": "(Hindi) a secretary, interpreter, also MUNSHI [n -S]\n",
  "MOONSHEES": "MOONSHEE, (Hindi) a secretary, interpreter, also MUNSHI [n]\n",
  "MOONSHINE": "(US) illegally distilled or smuggled whisky or other spirit; moonlight [n -S] / to distil illicit liquor [v MOONSHINED, MOONSHINING, MOONSHINES]\n",
  "MOONSHINED": "MOONSHINE, to distil illicit liquor [v]\n",
  "MOONSHINER": "a person engaged in illicit distilling, so called because the work is largely done at night [n -S]\n",
  "MOONSHINERS": "MOONSHINER, a person engaged in illicit distilling, so called because the work is largely done at night [n]\n",
  "MOONSHINES": "MOONSHINE, (US) illegally distilled or smuggled whisky or other spirit; moonlight [n]\n",
  "MOONSHINIER": "MOONSHINY, full of moonlight [adj]\n",
  "MOONSHINIEST": "MOONSHINY, full of moonlight [adj]\n",
  "MOONSHINING": "the making of illicitly distilled whisky [n -S]\n",
  "MOONSHININGS": "MOONSHINING, the making of illicitly distilled whisky [n]\n",
  "MOONSHINY": "full of moonlight [adj MOONSHINIER, MOONSHINIEST]\n",
  "MOONSHIP": "a lunar module [n -S]\n",
  "MOONSHIPS": "MOONSHIP, a lunar module [n]\n",
  "MOONSHOT": "the launching of a spacecraft to the moon [n -S]\n",
  "MOONSHOTS": "MOONSHOT, the launching of a spacecraft to the moon [n]\n",
  "MOONSTONE": "a nearly pellucid variety of feldspar, showing pearly or opaline reflections from within [n -S]\n",
  "MOONSTONES": "MOONSTONE, a nearly pellucid variety of feldspar, showing pearly or opaline reflections from within [n]\n",
  "MOONSTRICKEN": "simpleminded, as if affected by the moon, also MOONSTRUCK [adj]\n",
  "MOONSTRIKE": "the act of landing a spacecraft on the surface of the moon [n -S]\n",
  "MOONSTRIKES": "MOONSTRIKE, the act of landing a spacecraft on the surface of the moon [n]\n",
  "MOONSTRUCK": "simpleminded, as if affected by the moon, also MOONSTRICKEN [adj]\n",
  "MOONWALK": "an astronaut's walk on the surface of the moon; a style of dancing resembling weightless movement [n -S] / to perform a moonwalk [v -ED, -ING, -S]\n",
  "MOONWALKED": "MOONWALK, to perform a moonwalk [v]\n",
  "MOONWALKER": "one who performs the moonwalk [n -S]\n",
  "MOONWALKERS": "MOONWALKER, one who performs the moonwalk [n]\n",
  "MOONWALKING": "MOONWALK, to perform a moonwalk [v]\n",
  "MOONWALKS": "MOONWALK, to perform a moonwalk [v]\n",
  "MOONWARD": "in the direction of the moon, also MOONWARDS [adv]\n",
  "MOONWARDS": "in the direction of the moon, also MOONWARD [adv]\n",
  "MOONWORT": "the plant honesty (from its silvery septum) [n -S]\n",
  "MOONWORTS": "MOONWORT, the plant honesty (from its silvery septum) [n]\n",
  "MOONY": "resembling the moon, dreamy [adj MOONIER, MOONIEST, MOONILY] / a simpleton [n MOONIES]\n",
  "MOOP": "(Scots) to nibble, munch, also MOUP [v -ED, -ING, -S]\n",
  "MOOPED": "MOOP, (Scots) to nibble, munch, also MOUP [v]\n",
  "MOOPING": "MOOP, (Scots) to nibble, munch, also MOUP [v]\n",
  "MOOPS": "MOOP, (Scots) to nibble, munch, also MOUP [v]\n",
  "MOOR": "to secure a vessel by cable or anchor [v -ED, -ING, -S]\n",
  "MOORAGE": "the act of mooring [n -S]\n",
  "MOORAGES": "MOORAGE, the act of mooring [n]\n",
  "MOORBURN": "the seasonal burning of heather on moorland to promote new growth, also MUIRBURN [n -S]\n",
  "MOORBURNS": "MOORBURN, the seasonal burning of heather on moorland to promote new growth, also MUIRBURN [n]\n",
  "MOORBUZZARD": "the marsh harrier [n -S]\n",
  "MOORBUZZARDS": "MOORBUZZARD, the marsh harrier [n]\n",
  "MOORCOCK": "the male moorfowl [n -S]\n",
  "MOORCOCKS": "MOORCOCK, the male moorfowl [n]\n",
  "MOORED": "MOOR, to secure a vessel by cable or anchor [v]\n",
  "MOORFOWL": "a red, or black, grouse [n -S]\n",
  "MOORFOWLS": "MOORFOWL, a red, or black, grouse [n]\n",
  "MOORHEN": "a water bird, aka waterhen [n -S]\n",
  "MOORHENS": "MOORHEN, a water bird, aka waterhen [n]\n",
  "MOORIER": "MOORY, of or pertaining to moors [adj]\n",
  "MOORIEST": "MOORY, of or pertaining to moors [adj]\n",
  "MOORILL": "(Scots) a cattle disease of moorland districts, marked by haemoglobin in the urine [n -S]\n",
  "MOORILLS": "MOORILL, (Scots) a cattle disease of moorland districts, marked by haemoglobin in the urine [n]\n",
  "MOORING": "a place where a vessel may be moored [n -S]\n",
  "MOORINGS": "MOORING, a place where a vessel may be moored [n]\n",
  "MOORISH": "having the characteristics of a moor or heath [adj]\n",
  "MOORLAND": "a tract of marshy land [n -S]\n",
  "MOORLANDS": "MOORLAND, a tract of marshy land [n]\n",
  "MOORLOG": "a deposit of decayed woody material under a marsh [n -S]\n",
  "MOORLOGS": "MOORLOG, a deposit of decayed woody material under a marsh [n]\n",
  "MOORMAN": "an inhabitant of a moor [n MOORMEN]\n",
  "MOORMEN": "MOORMAN, an inhabitant of a moor [n]\n",
  "MOORS": "MOOR, to secure a vessel by cable or anchor [v]\n",
  "MOORVA": "(Sanskrit) a bowstring hemp, also MURVA [n -S]\n",
  "MOORVAS": "MOORVA, (Sanskrit) a bowstring hemp, also MURVA [n]\n",
  "MOORWORT": "a marsh flower, aka bog rosemary, bog asphodel [n -S]\n",
  "MOORWORTS": "MOORWORT, a marsh flower, aka bog rosemary, bog asphodel [n]\n",
  "MOORY": "of or pertaining to moors [adj MOORIER, MOORIEST]\n",
  "MOOS": "MOO, to make the sound of a cow [v]\n",
  "MOOSE": "a large deer found in Canada [n MOOSE]\n",
  "MOOSEBIRD": "a North American jay [n -S]\n",
  "MOOSEBIRDS": "MOOSEBIRD, a North American jay [n]\n",
  "MOOSEHAIR": "the hair of a moose [n -S]\n",
  "MOOSEHAIRS": "MOOSEHAIR, the hair of a moose [n]\n",
  "MOOSEHIDE": "the hide of a moose [n -S]\n",
  "MOOSEHIDES": "MOOSEHIDE, the hide of a moose [n]\n",
  "MOOSEWOOD": "a North American tree, aka striped maple [n -S]\n",
  "MOOSEWOODS": "MOOSEWOOD, a North American tree, aka striped maple [n]\n",
  "MOOSEYARD": "an area where a moose treads down the snow and spends the winter [n -S]\n",
  "MOOSEYARDS": "MOOSEYARD, an area where a moose treads down the snow and spends the winter [n]\n",
  "MOOT": "to bring up for discussion [v -ED, -ING, -S] / debatable [adj MOOTER, MOOTEST]\n",
  "MOOTABLE": "able to be mooted [adj]\n",
  "MOOTED": "MOOT, to bring up for discussion [v]\n",
  "MOOTER": "a disputer of a mooted case [n -S]\n",
  "MOOTERS": "MOOTER, a disputer of a mooted case [n]\n",
  "MOOTEST": "MOOT, debatable [adj]\n",
  "MOOTING": "a meeting, the holding of a moot [n -S]\n",
  "MOOTINGS": "MOOTING, a meeting, the holding of a moot [n]\n",
  "MOOTMAN": "a law student who argues in moots [n MOOTMEN]\n",
  "MOOTMEN": "MOOTMAN, a law student who argues in moots [n]\n",
  "MOOTNESS": "the state of being without legal significance [n -ES]\n",
  "MOOTNESSES": "MOOTNESS, the state of being without legal significance [n]\n",
  "MOOTS": "MOOT, to bring up for discussion [v]\n",
  "MOOVE": "(obsolete) to move, also AMOOVE, AMOVE, MEVE, MIEVE [v MOOVED, MOOVING, MOOVES]\n",
  "MOOVED": "MOOVE, (obsolete) to move, also AMOOVE, AMOVE, MEVE, MIEVE [v]\n",
  "MOOVES": "MOOVE, (obsolete) to move, also AMOOVE, AMOVE, MEVE, MIEVE [v]\n",
  "MOOVING": "MOOVE, (obsolete) to move, also AMOOVE, AMOVE, MEVE, MIEVE [v]\n",
  "MOP": "to clean with a sponge on a stick [v MOPPED, MOPPING, MOPS]\n",
  "MOPANE": "(Bantu) a small South African tree with racemes of greenish flowers, also MOPANI [n -S]\n",
  "MOPANES": "MOPANE, (Bantu) a small South African tree with racemes of greenish flowers, also MOPANI [n]\n",
  "MOPANI": "(Bantu) a small South African tree with racemes of greenish flowers, also MOPANE [n -S]\n",
  "MOPANIS": "MOPANI, (Bantu) a small South African tree with racemes of greenish flowers, also MOPANE [n]\n",
  "MOPBOARD": "a narrow board nailed against the wall of a room next to the floor; aka skirting board [n -S]\n",
  "MOPBOARDS": "MOPBOARD, a narrow board nailed against the wall of a room next to the floor; aka skirting board [n]\n",
  "MOPE": "to be listless or depressed [v MOPED, MOPING, MOPES]\n",
  "MOPED": "a type of motorbike [n -S]\n",
  "MOPEDS": "MOPED, a type of motorbike [n]\n",
  "MOPEHAWK": "an owl of Australia and New Zealand, also MOPOKE, MOREPORK [n -S]\n",
  "MOPEHAWKS": "MOPEHAWK, an owl of Australia and New Zealand, also MOPOKE, MOREPORK [n]\n",
  "MOPER": "one who mopes [n -S]\n",
  "MOPERIES": "MOPERY, violation of a trivial or imaginary law, for example, loitering, used to arrest someone when no other crime can be charged [n]\n",
  "MOPERS": "MOPER, one who mopes [n]\n",
  "MOPERY": "violation of a trivial or imaginary law, for example, loitering, used to arrest someone when no other crime can be charged [n MOPERIES]\n",
  "MOPES": "MOPE, to be listless or depressed [v]\n",
  "MOPEY": "dejected, also MOPY [adj MOPIER, MOPIEST]\n",
  "MOPHEAD": "a person with shaggy hair [n -S]\n",
  "MOPHEADS": "MOPHEAD, a person with shaggy hair [n]\n",
  "MOPIER": "MOPY, dejected, also MOPEY [adj]\n",
  "MOPIEST": "MOPY, dejected, also MOPEY [adj]\n",
  "MOPILY": "MOPY, dejected, also MOPEY [adv]\n",
  "MOPINESS": "the state of being mopy [n -ES]\n",
  "MOPINESSES": "MOPINESS, the state of being mopy [n]\n",
  "MOPING": "MOPE, to be listless or depressed [v]\n",
  "MOPINGLY": "MOPING, MOPE, to be listless or depressed [adv]\n",
  "MOPISH": "dull; spiritless; dejected [adj MOPISHLY]\n",
  "MOPISHLY": "MOPISH, dull; spiritless; dejected [adv]\n",
  "MOPISHNESS": "the state of being mopish [n -ES]\n",
  "MOPISHNESSES": "MOPISHNESS, the state of being mopish [n]\n",
  "MOPOKE": "an owl of Australia and New Zealand, also MOPEHAWK, MOREPORK [n -S]\n",
  "MOPOKES": "MOPOKE, an owl of Australia and New Zealand, also MOPEHAWK, MOREPORK [n]\n",
  "MOPPED": "MOP, to clean with a sponge on a stick [v]\n",
  "MOPPER": "one who mops [n -S]\n",
  "MOPPERS": "MOPPER, one who mops [n]\n",
  "MOPPET": "a baby, a darling [n -S]\n",
  "MOPPETS": "MOPPET, a baby, a darling [n]\n",
  "MOPPIER": "MOPPY, (obsolete) drunk [adj]\n",
  "MOPPIEST": "MOPPY, (obsolete) drunk [adj]\n",
  "MOPPING": "MOP, to clean with a sponge on a stick [v]\n",
  "MOPPY": "(obsolete) drunk [adj MOPPIER, MOPPIEST]\n",
  "MOPS": "MOP, to clean with a sponge on a stick [v]\n",
  "MOPSIES": "MOPSY, a woman who wears dowdy clothes [n]\n",
  "MOPSTICK": "the long handle of a mop, also MAPSTICK [n -S]\n",
  "MOPSTICKS": "MOPSTICK, the long handle of a mop, also MAPSTICK [n]\n",
  "MOPSY": "a woman who wears dowdy clothes [n MOPSIES]\n",
  "MOPUS": "(slang) a small coin, also MAWPUS [n -ES]\n",
  "MOPUSES": "MOPUS, (slang) a small coin, also MAWPUS [n]\n",
  "MOPY": "dejected, also MOPEY [adj MOPIER, MOPIEST, MOPILY]\n",
  "MOQUETTE": "(French) a thick piled fabric used in upholstery and carpeting [n -S]\n",
  "MOQUETTES": "MOQUETTE, (French) a thick piled fabric used in upholstery and carpeting [n]\n",
  "MOR": "a forest humus [n -S]\n",
  "MORA": "(Latin) a unit of metrical time in prosody [n MORAS or MORAE]\n",
  "MORACEOUS": "relating to the mulberry genus [adj]\n",
  "MORAE": "MORA, (Latin) a unit of metrical time in prosody [n]\n",
  "MORAINAL": "of or pertaining to a moraine, also MORAINIC [adj]\n",
  "MORAINE": "(French) an accumulation of debris deposited by a glacier [n -S]\n",
  "MORAINES": "MORAINE, (French) an accumulation of debris deposited by a glacier [n]\n",
  "MORAINIC": "of or pertaining to a moraine, also MORAINAL [adj]\n",
  "MORAL": "observing principles [adj MORALLY] / (archaic) to moralize [v MORALLED, MORALLING, MORALS]\n",
  "MORALE": "the state of the spirits of an individual or group [n -S]\n",
  "MORALES": "MORALE, the state of the spirits of an individual or group [n]\n",
  "MORALISATION": "the act of moralising, also MORALIZATION [n -S]\n",
  "MORALISATIONS": "MORALISATION, the act of moralising, also MORALIZATION [n]\n",
  "MORALISE": "to explain in a moral sense, also MORALIZE [v MORALISED, MORALISING, MORALISES]\n",
  "MORALISED": "MORALISE, to explain in a moral sense, also MORALIZE [v]\n",
  "MORALISER": "one who moralises, also MORALIZER [n -S]\n",
  "MORALISERS": "MORALISER, one who moralises, also MORALIZER [n]\n",
  "MORALISES": "MORALISE, to explain in a moral sense, also MORALIZE [v]\n",
  "MORALISING": "the preaching of morality [n -S]\n",
  "MORALISINGS": "MORALISING, the preaching of morality [n]\n",
  "MORALISM": "the practice of moralizing [n -S]\n",
  "MORALISMS": "MORALISM, the practice of moralizing [n]\n",
  "MORALIST": "a teacher of morality [n -S]\n",
  "MORALISTIC": "characterized by or expressive of a concern with morality [adj MORALISTICALLY]\n",
  "MORALISTICALLY": "MORALISTIC, characterized by or expressive of a concern with morality [adv]\n",
  "MORALISTS": "MORALIST, a teacher of morality [n]\n",
  "MORALITIES": "MORALITY, conformity to the rules of right conduct [n]\n",
  "MORALITY": "conformity to the rules of right conduct [n MORALITIES]\n",
  "MORALIZATION": "the act of moralizing, also MORALISATION [n -S]\n",
  "MORALIZATIONS": "MORALIZATION, the act of moralizing, also MORALISATION [n]\n",
  "MORALIZE": "to explain in a moral sense, also MORALISE [v MORALIZED, MORALIZING, MORALIZES]\n",
  "MORALIZED": "MORALIZE, to explain in a moral sense, also MORALISE [v]\n",
  "MORALIZER": "one who moralizes, also MORALISER [n -S]\n",
  "MORALIZERS": "MORALIZER, one who moralizes, also MORALISER [n]\n",
  "MORALIZES": "MORALIZE, to explain in a moral sense, also MORALISE [v]\n",
  "MORALIZING": "the preaching of morality [n -S]\n",
  "MORALIZINGS": "MORALIZING, the preaching of morality [n]\n",
  "MORALL": "(Shakespeare) a mural [n -S]\n",
  "MORALLED": "MORAL, (archaic) to moralize [v]\n",
  "MORALLER": "(Shakespeare) a moralist [n -S]\n",
  "MORALLERS": "MORALLER, (Shakespeare) a moralist [n]\n",
  "MORALLING": "MORAL, (archaic) to moralize [v]\n",
  "MORALLS": "MORALL, (Shakespeare) a mural [n]\n",
  "MORALLY": "MORAL, observing principles [adv]\n",
  "MORALS": "MORAL, (archaic) to moralize [v]\n",
  "MORAS": "MORA, (Latin) a unit of metrical time in prosody [n]\n",
  "MORASS": "a very wet or muddy area of ground [n -ES]\n",
  "MORASSES": "MORASS, a very wet or muddy area of ground [n]\n",
  "MORASSIER": "MORASSY, like a morass, marshy [adj]\n",
  "MORASSIEST": "MORASSY, like a morass, marshy [adj]\n",
  "MORASSY": "like a morass, marshy [adj MORASSIER, MORASSIEST]\n",
  "MORAT": "a drink made of honey and flavoured with mulberries [n -S]\n",
  "MORATORIA": "MORATORIUM, a legal authorization to a debtor to postpone payment for a certain time; the period of such a postponement [n]\n",
  "MORATORIUM": "a legal authorization to a debtor to postpone payment for a certain time; the period of such a postponement [n MORATORIA or MORATORIUMS]\n",
  "MORATORIUMS": "MORATORIUM, a legal authorization to a debtor to postpone payment for a certain time; the period of such a postponement [n]\n",
  "MORATORY": "authorizing delay of payment [adj]\n",
  "MORATS": "MORAT, a drink made of honey and flavoured with mulberries [n]\n",
  "MORAY": "a kind of eel, also MURRAY, MURREY, MURRY [n -S]\n",
  "MORAYS": "MORAY, a kind of eel, also MURRAY, MURREY, MURRY [n]\n",
  "MORBID": "of the nature of or indicative of disease [adj MORBIDER, MORBIDEST, MORBIDLY]\n",
  "MORBIDER": "MORBID, of the nature of or indicative of disease [adj]\n",
  "MORBIDEST": "MORBID, of the nature of or indicative of disease [adj]\n",
  "MORBIDEZZA": "(Italian) an extreme delicacy and softness e.g. in painting or music [n -S]\n",
  "MORBIDEZZAS": "MORBIDEZZA, (Italian) an extreme delicacy and softness e.g. in painting or music [n]\n",
  "MORBIDITIES": "MORBIDITY, the condition or state of being diseased, or being caused by disease [n]\n",
  "MORBIDITY": "the condition or state of being diseased, or being caused by disease [n MORBIDITIES]\n",
  "MORBIDLY": "MORBID, of the nature of or indicative of disease [adv]\n",
  "MORBIDNESS": "the state of being morbid [n -ES]\n",
  "MORBIDNESSES": "MORBIDNESS, the state of being morbid [n]\n",
  "MORBIFEROUS": "disease-bringing [adj]\n",
  "MORBIFIC": "causing disease [adj]\n",
  "MORBIFICALLY": "MORBIFIC, causing disease [adv]\n",
  "MORBILLI": "(Latin) measles [n]\n",
  "MORBILLIFORM": "like or resembling measles [adj]\n",
  "MORBILLIVIRUS": "a virus responsible for measles [n -ES]\n",
  "MORBILLIVIRUSES": "MORBILLIVIRUS, a virus responsible for measles [n]\n",
  "MORBILLOUS": "pertaining to the measles [adj]\n",
  "MORBUS": "(Latin) a disease, in phrases, e.g. morbus Gallicus, 'French disease'; syphilis [n -ES]\n",
  "MORBUSES": "MORBUS, (Latin) a disease, in phrases, e.g. morbus Gallicus, 'French disease'; syphilis [n]\n",
  "MORCEAU": "(French) a short literary or musical composition [n MORCEAUX]\n",
  "MORCEAUX": "MORCEAU, (French) a short literary or musical composition [n]\n",
  "MORCHA": "(Hindi) a hostile demonstration against the government [n -S]\n",
  "MORCHAS": "MORCHA, (Hindi) a hostile demonstration against the government [n]\n",
  "MORDACIOUS": "given to biting; biting in quality [adj MORDACIOUSLY]\n",
  "MORDACIOUSLY": "MORDACIOUS, given to biting; biting in quality [adv]\n",
  "MORDACIOUSNESS": "MORDACIOUS, given to biting; biting in quality [n]\n",
  "MORDACITIES": "MORDACITY, the quality of being mordacious, biting [n]\n",
  "MORDACITY": "the quality of being mordacious, biting [n MORDACITIES]\n",
  "MORDANCIES": "MORDANCY, the quality of being mordant [n]\n",
  "MORDANCY": "the quality of being mordant [n MORDANCIES]\n",
  "MORDANT": "biting [adj MORDANTLY] / to impregnate or treat with a substance that combines with and fixes a dyestuff [v -ED, -ING, -S]\n",
  "MORDANTED": "MORDANT, to impregnate or treat with a substance that combines with and fixes a dyestuff [v]\n",
  "MORDANTING": "MORDANT, to impregnate or treat with a substance that combines with and fixes a dyestuff [v]\n",
  "MORDANTLY": "MORDANT, biting [adv]\n",
  "MORDANTS": "MORDANT, to impregnate or treat with a substance that combines with and fixes a dyestuff [v]\n",
  "MORDENT": "(German) a rapidly alternating a tone with one halftone lower; a reverse trill [n -S]\n",
  "MORDENTS": "MORDENT, (German) a rapidly alternating a tone with one halftone lower; a reverse trill [n]\n",
  "MORE": "a greater amount [n -S]\n",
  "MOREEN": "a stout corded wool or cotton [n -S]\n",
  "MOREENS": "MOREEN, a stout corded wool or cotton [n]\n",
  "MOREISH": "such that one wants more [adj]\n",
  "MOREL": "a kind of edible fungus [n -S]\n",
  "MORELLE": "a flowering plant, aka nightshade [n -S]\n",
  "MORELLES": "MORELLE, a flowering plant, aka nightshade [n]\n",
  "MORELLO": "(Italian) a dark red cherry, much used in cooking [n -S]\n",
  "MORELLOS": "MORELLO, (Italian) a dark red cherry, much used in cooking [n]\n",
  "MORELS": "MOREL, a kind of edible fungus [n]\n",
  "MORENDO": "(Italian) a gentle decrescendo at the end of a musical strain [n -S]\n",
  "MORENDOS": "MORENDO, (Italian) a gentle decrescendo at the end of a musical strain [n]\n",
  "MORENESS": "the state of being more [n -ES]\n",
  "MORENESSES": "MORENESS, the state of being more [n]\n",
  "MOREOVER": "in addition [adv]\n",
  "MOREPORK": "an owl of Australia and New Zealand, also MOPEHAWK, MOPOKE [n -S]\n",
  "MOREPORKS": "MOREPORK, an owl of Australia and New Zealand, also MOPEHAWK, MOPOKE [n]\n",
  "MORES": "(Latin) the characteristic customs of a community [n]\n",
  "MORESQUE": "an ancient decorative style [n -S]\n",
  "MORESQUES": "MORESQUE, an ancient decorative style [n]\n",
  "MORGAN": "a unit of distance between genes [n -S]\n",
  "MORGANATIC": "relating to a marriage between people of unequal rank, the marriage being valid, the children legitimate, but unable to inherit the higher rank [adj MORGANATICALLY]\n",
  "MORGANATICALLY": "MORGANATIC, relating to a marriage between people of unequal rank, the marriage being valid, the children legitimate, but unable to inherit the higher rank [adv]\n",
  "MORGANITE": "a rosy pink semiprecious gem, a variety of beryl [n -S]\n",
  "MORGANITES": "MORGANITE, a rosy pink semiprecious gem, a variety of beryl [n]\n",
  "MORGANS": "MORGAN, a unit of distance between genes [n]\n",
  "MORGAY": "(Welsh) the small-spotted dogfish [n -S]\n",
  "MORGAYS": "MORGAY, (Welsh) the small-spotted dogfish [n]\n",
  "MORGELLONS": "a condition in which the sufferer experiences crawling, biting, and stinging sensations on the skin [n]\n",
  "MORGEN": "(Dutch) a Dutch unit of land area [n -S]\n",
  "MORGENS": "MORGEN, (Dutch) a Dutch unit of land area [n]\n",
  "MORGENSTERN": "a club with a spike-studded head, a morning-star [n -S]\n",
  "MORGENSTERNS": "MORGENSTERN, a club with a spike-studded head, a morning-star [n]\n",
  "MORGUE": "a place where dead bodies are kept for identification [n -S]\n",
  "MORGUES": "MORGUE, a place where dead bodies are kept for identification [n]\n",
  "MORIA": "(Greek) folly, foolishness [n -S]\n",
  "MORIAS": "MORIA, (Greek) folly, foolishness [n]\n",
  "MORIBUND": "being about to die [adj MORIBUNDLY]\n",
  "MORIBUNDITIES": "MORIBUNDITY, the state of being moribund [n]\n",
  "MORIBUNDITY": "the state of being moribund [n MORIBUNDITIES]\n",
  "MORIBUNDLY": "MORIBUND, being about to die [adv]\n",
  "MORICHE": "(Tupi) a tall South American palm, used as a source of sago, fibre, and (from the sap) wine [n -S]\n",
  "MORICHES": "MORICHE, (Tupi) a tall South American palm, used as a source of sago, fibre, and (from the sap) wine [n]\n",
  "MORIGERATE": "to conform [v MORIGERATED, MORIGERATING, MORIGERATES]\n",
  "MORIGERATED": "MORIGERATE, to conform [v]\n",
  "MORIGERATES": "MORIGERATE, to conform [v]\n",
  "MORIGERATING": "MORIGERATE, to conform [v]\n",
  "MORIGERATION": "deferential behaviour [n -S]\n",
  "MORIGERATIONS": "MORIGERATION, deferential behaviour [n]\n",
  "MORIGEROUS": "obsequious or deferent, also MORIGERATE [adj]\n",
  "MORION": "a type of helmet, also MORRION [n -S]\n",
  "MORIONS": "MORION, a type of helmet, also MORRION [n]\n",
  "MORISCO": "an arabesque [n -ES or -S]\n",
  "MORISCOES": "MORISCO, an arabesque [n]\n",
  "MORISCOS": "MORISCO, an arabesque [n]\n",
  "MORISH": "such that one wants more, also MOREISH [adj]\n",
  "MORKIN": "an animal that has died by accident [n -S]\n",
  "MORKINS": "MORKIN, an animal that has died by accident [n]\n",
  "MORLING": "a sheep that has died from disease, also MORTLING [n -S]\n",
  "MORLINGS": "MORLING, a sheep that has died from disease, also MORTLING [n]\n",
  "MORMAOR": "(Irish) a high-ranking chief steward, also MAORMOR [n -S]\n",
  "MORMAORS": "MORMAOR, (Irish) a high-ranking chief steward, also MAORMOR [n]\n",
  "MORN": "morning [n -S]\n",
  "MORNAY": "(French) a cream sauce with a cheese flavouring [n -S]\n",
  "MORNAYS": "MORNAY, (French) a cream sauce with a cheese flavouring [n]\n",
  "MORNE": "(French) the blunt end of a jousting lance [n -S]\n",
  "MORNED": "blunted [adj]\n",
  "MORNES": "MORNE, (French) the blunt end of a jousting lance [n]\n",
  "MORNING": "the early part of the day [n -S]\n",
  "MORNINGS": "MORNING, the early part of the day [n]\n",
  "MORNS": "MORN, morning [n]\n",
  "MOROCCO": "a fine goatskin leather tanned with sumac, first brought from Morocco [n -S]\n",
  "MOROCCOS": "MOROCCO, a fine goatskin leather tanned with sumac, first brought from Morocco [n]\n",
  "MORON": "a mentally deficient person [n -S]\n",
  "MORONIC": "like a moron [adj MORONICALLY]\n",
  "MORONICALLY": "MORONIC, like a moron [adv]\n",
  "MORONISM": "the condition of being a moron, also MORONITY [n -S]\n",
  "MORONISMS": "MORONISM, the condition of being a moron, also MORONITY [n]\n",
  "MORONITIES": "MORONITY, the condition of being a moron, also MORONISM [n]\n",
  "MORONITY": "the condition of being a moron, also MORONISM [n MORONITIES]\n",
  "MORONS": "MORON, a mentally deficient person [n]\n",
  "MOROSE": "sad, gloomy [adj MOROSER, MOROSEST, MOROSELY]\n",
  "MOROSELY": "MOROSE, sad, gloomy [adv]\n",
  "MOROSENESS": "the state of being morose [n -ES]\n",
  "MOROSENESSES": "MOROSENESS, the state of being morose [n]\n",
  "MOROSER": "MOROSE, sad, gloomy [adj]\n",
  "MOROSEST": "MOROSE, sad, gloomy [adj]\n",
  "MOROSITIES": "MOROSITY, (obsolete) moroseness [n]\n",
  "MOROSITY": "(obsolete) moroseness [n MOROSITIES]\n",
  "MORPH": "to gradually change shape and features, especially with computer graphics [v -ED, -ING, -S]\n",
  "MORPHACTIN": "a synthetic fluorine-containing compound [n -S]\n",
  "MORPHACTINS": "MORPHACTIN, a synthetic fluorine-containing compound [n]\n",
  "MORPHALLAXES": "MORPHALLAXIS, regeneration in a changed form [n]\n",
  "MORPHALLAXIS": "regeneration in a changed form [n MORPHALLAXES]\n",
  "MORPHEAN": "pertaining to Morpheus the Greek god of dreams [adj]\n",
  "MORPHED": "MORPH, to gradually change shape and features, especially with computer graphics [v]\n",
  "MORPHEME": "a word or part of a word that contains no smaller unit of meaning e.g. 'man' or the 'ed' in 'walked' [n -S]\n",
  "MORPHEMES": "MORPHEME, a word or part of a word that contains no smaller unit of meaning e.g. 'man' or the 'ed' in 'walked' [n]\n",
  "MORPHEMIC": "of or like a morpheme [adj MORPHEMICALLY]\n",
  "MORPHEMICALLY": "MORPHEMIC, of or like a morpheme [adv]\n",
  "MORPHEMICS": "the study of morphemes [n]\n",
  "MORPHETIC": "relating to Morpheus, the god of sleep, also MORPHEAN [adj]\n",
  "MORPHEW": "(Italian) a skin eruption [n -S]\n",
  "MORPHEWS": "MORPHEW, (Italian) a skin eruption [n]\n",
  "MORPHIA": "a painkilling drug, derived from opium [n -S]\n",
  "MORPHIAS": "MORPHIA, a painkilling drug, derived from opium [n]\n",
  "MORPHIC": "pertaining to form [adj]\n",
  "MORPHIN": "the principal alkaloid in opium, also MORPHINE [n -S]\n",
  "MORPHINE": "the principal alkaloid in opium, also MORPHIN [n -S]\n",
  "MORPHINES": "MORPHINE, the principal alkaloid in opium, also MORPHIN [n]\n",
  "MORPHING": "the technique of using computer graphics [n -S]\n",
  "MORPHINGS": "MORPHING, the technique of using computer graphics [n]\n",
  "MORPHINIC": "relating to morphine [adj]\n",
  "MORPHINISM": "a morbid condition produced by the excessive or prolonged use of morphine [n -S]\n",
  "MORPHINISMS": "MORPHINISM, a morbid condition produced by the excessive or prolonged use of morphine [n]\n",
  "MORPHINOMANIA": "a habitual craving or desire for morphine [n -S]\n",
  "MORPHINOMANIAC": "one excessively addicted to morphine [n -S]\n",
  "MORPHINOMANIACS": "MORPHINOMANIAC, one excessively addicted to morphine [n]\n",
  "MORPHINOMANIAS": "MORPHINOMANIA, a habitual craving or desire for morphine [n]\n",
  "MORPHINS": "MORPHIN, the principal alkaloid in opium, also MORPHINE [n]\n",
  "MORPHO": "(Greek) a kind of tropical butterfly [n -S]\n",
  "MORPHOGEN": "a chemical substance that exerts an influence on morphogenesis [n -S]\n",
  "MORPHOGENESES": "MORPHOGENESIS, the origin or development of a body part or organ [n]\n",
  "MORPHOGENESIS": "the origin or development of a body part or organ [n MORPHOGENESES]\n",
  "MORPHOGENETIC": "relating to morphogenesis, also MORPHOGENIC [adj]\n",
  "MORPHOGENIC": "relating to morphogenesis, also MORPHOGENETIC [adj]\n",
  "MORPHOGENIES": "MORPHOGENY, the history of the evolution of forms [n]\n",
  "MORPHOGENS": "MORPHOGEN, a chemical substance that exerts an influence on morphogenesis [n]\n",
  "MORPHOGENY": "the history of the evolution of forms [n MORPHOGENIES]\n",
  "MORPHOGRAPHER": "an artist who portrays forms [n -S]\n",
  "MORPHOGRAPHERS": "MORPHOGRAPHER, an artist who portrays forms [n]\n",
  "MORPHOGRAPHIES": "MORPHOGRAPHY, a morphological description or study [n]\n",
  "MORPHOGRAPHY": "a morphological description or study [n MORPHOGRAPHIES]\n",
  "MORPHOLINE": "a colourless liquid, formerly used as an emulsifier to provide a glossy coating to waxes [n -S]\n",
  "MORPHOLINES": "MORPHOLINE, a colourless liquid, formerly used as an emulsifier to provide a glossy coating to waxes [n]\n",
  "MORPHOLINO": "a type of molecule used in altering the development of genes by preventing the access of other molecules [n -S]\n",
  "MORPHOLINOS": "MORPHOLINO, a type of molecule used in altering the development of genes by preventing the access of other molecules [n]\n",
  "MORPHOLOGIC": "relating to morphology, also MORPHOLOGICAL [adj MORPHOLOGICALLY]\n",
  "MORPHOLOGICAL": "relating to morphology, also MORPHOLOGIC [adj MORPHOLOGICALLY]\n",
  "MORPHOLOGICALLY": "MORPHOLOGICAL, relating to morphology, also MORPHOLOGIC [adv]\n",
  "MORPHOLOGIES": "MORPHOLOGY, the study of forms e.g. of words [n]\n",
  "MORPHOLOGIST": "a student of morphology [n -S]\n",
  "MORPHOLOGISTS": "MORPHOLOGIST, a student of morphology [n]\n",
  "MORPHOLOGY": "the study of forms e.g. of words [n MORPHOLOGIES]\n",
  "MORPHOMETRIC": "relating to morphometry, measurement of form or shape [adj]\n",
  "MORPHOMETRICS": "morphometric features or properties; characteristics of shape, dimension, or proportion [n]\n",
  "MORPHOMETRIES": "MORPHOMETRY, measurement of form or shape [n]\n",
  "MORPHOMETRY": "measurement of form or shape [n MORPHOMETRIES]\n",
  "MORPHOPHONEME": "either or any of two or more phonemes which form variant morphs representing one morpheme (as in wife, wives) [n -S]\n",
  "MORPHOPHONEMES": "MORPHOPHONEME, either or any of two or more phonemes which form variant morphs representing one morpheme (as in wife, wives) [n]\n",
  "MORPHOPHONEMIC": "like a morphophoneme [adj]\n",
  "MORPHOPHONEMICS": "linguistic structure in terms of the phonological patterning of morphemes [n]\n",
  "MORPHOPHONOLOGY": "the study of the phonemic shape and the phonological representation of a language's morphemes [n]\n",
  "MORPHOS": "MORPHO, (Greek) a kind of tropical butterfly [n]\n",
  "MORPHOSES": "MORPHOSIS, the order or mode of development of an organ or part [n]\n",
  "MORPHOSIS": "the order or mode of development of an organ or part [n MORPHOSES]\n",
  "MORPHOSYNTAX": "the study of the interaction of morphology and syntax [n -ES]\n",
  "MORPHOSYNTAXES": "MORPHOSYNTAX, the study of the interaction of morphology and syntax [n]\n",
  "MORPHOTIC": "pertaining to formation or development [adj]\n",
  "MORPHOTROPIC": "relating to morphotropy [adj]\n",
  "MORPHOTROPIES": "MORPHOTROPY, the effect on crystalline form of the addition or substitution of an element or radical [n]\n",
  "MORPHOTROPY": "the effect on crystalline form of the addition or substitution of an element or radical [n MORPHOTROPIES]\n",
  "MORPHS": "MORPH, to gradually change shape and features, especially with computer graphics [v]\n",
  "MORRA": "a game of guessing how many fingers are held up, also MORA [n -S]\n",
  "MORRAS": "MORRA, a game of guessing how many fingers are held up, also MORA [n]\n",
  "MORRELL": "(Native Australian) a tall eucalyptus of SW Australia [n -S]\n",
  "MORRELLS": "MORRELL, (Native Australian) a tall eucalyptus of SW Australia [n]\n",
  "MORRHUA": "an old name for the cod [n -S]\n",
  "MORRHUAS": "MORRHUA, an old name for the cod [n]\n",
  "MORRICE": "(obsolete) a morris dance [n -S]\n",
  "MORRICES": "MORRICE, (obsolete) a morris dance [n]\n",
  "MORRION": "(historical) a crested metal helmet worn by soldiers in the 1500's and 1600's, also MORION [n -S]\n",
  "MORRIONS": "MORRION, (historical) a crested metal helmet worn by soldiers in the 1500's and 1600's, also MORION [n]\n",
  "MORRIS": "an English folk dance in which story is enacted by costumed dancers, also MORRICE [n -ES] / to dance the morris [v -ED, -ING, -ES]\n",
  "MORRISED": "MORRIS, to dance the morris [v]\n",
  "MORRISES": "MORRIS, to dance the morris [v]\n",
  "MORRISING": "MORRIS, to dance the morris [v]\n",
  "MORRO": "(Spanish) a rounded hill or headland [n -S]\n",
  "MORROS": "MORRO, (Spanish) a rounded hill or headland [n]\n",
  "MORROW": "the next day [n -S]\n",
  "MORROWS": "MORROW, the next day [n]\n",
  "MORS": "MOR, a forest humus [n]\n",
  "MORSAL": "a morsel [n -S]\n",
  "MORSALS": "MORSAL, a morsel [n]\n",
  "MORSE": "(French) a walrus [n -S]\n",
  "MORSEL": "to divide into small pieces [v MORSELED or MORSELLED, MORSELING or MORSELLING, MORSELS]\n",
  "MORSELED": "MORSEL, to divide into small pieces [v]\n",
  "MORSELING": "MORSEL, to divide into small pieces [v]\n",
  "MORSELLED": "MORSEL, to divide into small pieces [v]\n",
  "MORSELLING": "the act of dividing into morsels [n -S]\n",
  "MORSELLINGS": "MORSELLING, the act of dividing into morsels [n]\n",
  "MORSELS": "MORSEL, to divide into small pieces [v]\n",
  "MORSES": "MORSE, (French) a walrus [n]\n",
  "MORSURE": "(Latin) a bite [n -S]\n",
  "MORSURES": "MORSURE, (Latin) a bite [n]\n",
  "MORT": "a note on a hunting horn sounded to announce a kill [n -S]\n",
  "MORTADELLA": "(Italian) Italian pork sausage [n MORTADELLE or MORTADELLAS]\n",
  "MORTADELLAS": "MORTADELLA, (Italian) Italian pork sausage [n]\n",
  "MORTADELLE": "MORTADELLA, (Italian) Italian pork sausage [n]\n",
  "MORTAL": "fatal [adj MORTALLY] / a human being [n -S]\n",
  "MORTALISE": "to make mortal, also MORTALIZE [v MORTALISED, MORTALISING, MORTALISES]\n",
  "MORTALISED": "MORTALISE, to make mortal, also MORTALIZE [v]\n",
  "MORTALISES": "MORTALISE, to make mortal, also MORTALIZE [v]\n",
  "MORTALISING": "MORTALISE, to make mortal, also MORTALIZE [v]\n",
  "MORTALITIES": "MORTALITY, the state of being mortal [n]\n",
  "MORTALITY": "the state of being mortal [n MORTALITIES]\n",
  "MORTALIZE": "to make mortal, also MORTALISE [v MORTALIZED, MORTALIZING, MORTALIZES]\n",
  "MORTALIZED": "MORTALIZE, to make mortal, also MORTALISE [v]\n",
  "MORTALIZES": "MORTALIZE, to make mortal, also MORTALISE [v]\n",
  "MORTALIZING": "MORTALIZE, to make mortal, also MORTALISE [v]\n",
  "MORTALLY": "MORTAL, fatal [adv]\n",
  "MORTALS": "MORTAL, a human being [n]\n",
  "MORTAR": "to bind with a type of cement [v -ED, -ING, -S]\n",
  "MORTARBOARD": "a square-topped college cap [n -S]\n",
  "MORTARBOARDS": "MORTARBOARD, a square-topped college cap [n]\n",
  "MORTARED": "MORTAR, to bind with a type of cement [v]\n",
  "MORTARIER": "MORTARY, containing or resembling mortar [adj]\n",
  "MORTARIEST": "MORTARY, containing or resembling mortar [adj]\n",
  "MORTARING": "MORTAR, to bind with a type of cement [v]\n",
  "MORTARLESS": "without mortar [adj]\n",
  "MORTARMAN": "a person firing a mortar [n MORTARMEN]\n",
  "MORTARMEN": "MORTARMAN, a person firing a mortar [n]\n",
  "MORTARS": "MORTAR, to bind with a type of cement [v]\n",
  "MORTARY": "containing or resembling mortar [adj MORTARIER, MORTARIEST]\n",
  "MORTBELL": "a funeral bell [n -S]\n",
  "MORTBELLS": "MORTBELL, a funeral bell [n]\n",
  "MORTCLOTH": "a pall [n -S]\n",
  "MORTCLOTHS": "MORTCLOTH, a pall [n]\n",
  "MORTGAGE": "to pledge to a creditor as security [v MORTGAGED, MORTGAGING, MORTGAGES]\n",
  "MORTGAGEABLE": "that can be mortgaged [adj]\n",
  "MORTGAGED": "MORTGAGE, to pledge to a creditor as security [v]\n",
  "MORTGAGEE": "one who has a mortgage [n -S]\n",
  "MORTGAGEES": "MORTGAGEE, one who has a mortgage [n]\n",
  "MORTGAGER": "one who gives a mortgage, also MORTGAGOR [n -S]\n",
  "MORTGAGERS": "MORTGAGER, one who gives a mortgage, also MORTGAGOR [n]\n",
  "MORTGAGES": "MORTGAGE, to pledge to a creditor as security [v]\n",
  "MORTGAGING": "MORTGAGE, to pledge to a creditor as security [v]\n",
  "MORTGAGOR": "one who gives a mortgage, also MORTGAGER [n -S]\n",
  "MORTGAGORS": "MORTGAGOR, one who gives a mortgage, also MORTGAGER [n]\n",
  "MORTICE": "to join or fasten securely, also MORTISE [v MORTICED, MORTICING, MORTICES]\n",
  "MORTICED": "MORTICE, to join or fasten securely, also MORTISE [v]\n",
  "MORTICER": "one who makes mortice joints, also MORTISER [n -S]\n",
  "MORTICERS": "MORTICER, one who makes mortice joints, also MORTISER [n]\n",
  "MORTICES": "MORTICE, to join or fasten securely, also MORTISE [v]\n",
  "MORTICIAN": "(US) an undertaker [n -S]\n",
  "MORTICIANS": "MORTICIAN, (US) an undertaker [n]\n",
  "MORTICING": "MORTICE, to join or fasten securely, also MORTISE [v]\n",
  "MORTIFEROUS": "death-bringing; fatal [adj]\n",
  "MORTIFEROUSNESS": "MORTIFEROUS, death-bringing; fatal [n]\n",
  "MORTIFIC": "death-bringing, deadly [adj]\n",
  "MORTIFICATION": "the subjection and denial of bodily passions and appetites by abstinence or self-inflicted pain or discomfort [n -S]\n",
  "MORTIFICATIONS": "MORTIFICATION, the subjection and denial of bodily passions and appetites by abstinence or self-inflicted pain or discomfort [n]\n",
  "MORTIFIED": "MORTIFY, to humiliate [v]\n",
  "MORTIFIER": "one who mortifies [n -S]\n",
  "MORTIFIERS": "MORTIFIER, one who mortifies [n]\n",
  "MORTIFIES": "MORTIFY, to humiliate [v]\n",
  "MORTIFY": "to humiliate [v MORTIFIED, MORTIFYING, MORTIFIES]\n",
  "MORTIFYING": "humiliating [adj MORTIFYINGLY] / the act of mortifying [n -S]\n",
  "MORTIFYINGLY": "MORTIFYING, humiliating [adv]\n",
  "MORTIFYINGS": "MORTIFYING, the act of mortifying [n]\n",
  "MORTISE": "to join or fasten securely, also MORTICE [v MORTISED, MORTISING, MORTISES]\n",
  "MORTISED": "MORTISE, to join or fasten securely, also MORTICE [v]\n",
  "MORTISER": "one who makes mortise joints, also MORTICER [n -S]\n",
  "MORTISERS": "MORTISER, one who makes mortise joints, also MORTICER [n]\n",
  "MORTISES": "MORTISE, to join or fasten securely, also MORTICE [v]\n",
  "MORTISING": "MORTISE, to join or fasten securely, also MORTICE [v]\n",
  "MORTLING": "a sheep that has died from disease, also MORLING [n -S]\n",
  "MORTLINGS": "MORTLING, a sheep that has died from disease, also MORLING [n]\n",
  "MORTMAIN": "(French) the perpetual ownership of property by institutions such as churches [n -S]\n",
  "MORTMAINS": "MORTMAIN, (French) the perpetual ownership of property by institutions such as churches [n]\n",
  "MORTS": "MORT, a note on a hunting horn sounded to announce a kill [n]\n",
  "MORTSAFE": "a heavy iron cage placed over the grave of a newly buried person to deter body snatchers [n -S]\n",
  "MORTSAFES": "MORTSAFE, a heavy iron cage placed over the grave of a newly buried person to deter body snatchers [n]\n",
  "MORTUARIES": "MORTUARY, a place where dead bodies are kept until burial [n]\n",
  "MORTUARY": "a place where dead bodies are kept until burial [n MORTUARIES]\n",
  "MORULA": "(Latin) an embryonic mass of cells [n MORULAS or MORULAE]\n",
  "MORULAE": "MORULA, (Latin) an embryonic mass of cells [n]\n",
  "MORULAR": "of or like a morula, a solid spherical mass of cells resulting from the cleavage of an ovum [adj]\n",
  "MORULAS": "MORULA, (Latin) an embryonic mass of cells [n]\n",
  "MORULATION": "the process of cleavage, or segmentation, of the ovum, by which a morula is formed [n -S]\n",
  "MORULATIONS": "MORULATION, the process of cleavage, or segmentation, of the ovum, by which a morula is formed [n]\n",
  "MORWONG": "(Native Australian) an Australasian food fish [n -S]\n",
  "MORWONGS": "MORWONG, (Native Australian) an Australasian food fish [n]\n",
  "MORYAH": "(Irish) expressing annoyance, disbelief etc. [interj]\n",
  "MOS": "MO, a moment [n]\n",
  "MOSAIC": "in the form of a mosaic [adj MOSAICALLY] / to decorate with an inlaid surface [v MOSAICKED, MOSAICKING, MOSAICS]\n",
  "MOSAICALLY": "MOSAIC, in the form of a mosaic [adv]\n",
  "MOSAICISM": "the property or state of being composed of cells of two genetically different types [n -S]\n",
  "MOSAICISMS": "MOSAICISM, the property or state of being composed of cells of two genetically different types [n]\n",
  "MOSAICIST": "a worker in mosaic [n -S]\n",
  "MOSAICISTS": "MOSAICIST, a worker in mosaic [n]\n",
  "MOSAICKED": "MOSAIC, to decorate with an inlaid surface [v]\n",
  "MOSAICKING": "work in mosaic [n -S]\n",
  "MOSAICKINGS": "MOSAICKING, work in mosaic [n]\n",
  "MOSAICLIKE": "like a mosaic [adj]\n",
  "MOSAICS": "MOSAIC, to decorate with an inlaid surface [v]\n",
  "MOSASAUR": "a gigantic Cretaceous fossil pythonomorph reptile, also MOSASAURUS [n -S]\n",
  "MOSASAURI": "MOSASAURUS, a gigantic Cretaceous fossil pythonomorph reptile, also MOSASAUR [n]\n",
  "MOSASAURS": "MOSASAUR, a gigantic Cretaceous fossil pythonomorph reptile, also MOSASAURUS [n]\n",
  "MOSASAURUS": "a gigantic Cretaceous fossil pythonomorph reptile, also MOSASAUR [n MOSASAURI]\n",
  "MOSBOLLETJIE": "(South African) a sweet bun made of dough leavened with grape must [n -S]\n",
  "MOSBOLLETJIES": "MOSBOLLETJIE, (South African) a sweet bun made of dough leavened with grape must [n]\n",
  "MOSCATO": "a sweet dessert wine [n -S]\n",
  "MOSCATOS": "MOSCATO, a sweet dessert wine [n]\n",
  "MOSCHATE": "having a musky odour [adj]\n",
  "MOSCHATEL": "a plant of the genus Adoxa, the flowers of which are pale green, and have a faint musky smell [n -S]\n",
  "MOSCHATELS": "MOSCHATEL, a plant of the genus Adoxa, the flowers of which are pale green, and have a faint musky smell [n]\n",
  "MOSCHIFEROUS": "producing musk [adj]\n",
  "MOSCOVIUM": "a highly radioactive element, of which only a few atoms have ever been produced [n -S]\n",
  "MOSCOVIUMS": "MOSCOVIUM, a highly radioactive element, of which only a few atoms have ever been produced [n]\n",
  "MOSE": "(Shakespeare) to have glanders [v MOSED, MOSING, MOSES]\n",
  "MOSED": "MOSE, (Shakespeare) to have glanders [v]\n",
  "MOSELLE": "a German white wine from the Moselle valley [n -S]\n",
  "MOSELLES": "MOSELLE, a German white wine from the Moselle valley [n]\n",
  "MOSES": "MOSE, (Shakespeare) to have glanders [v]\n",
  "MOSEY": "to saunter [v -ED, -ING, -S]\n",
  "MOSEYED": "MOSEY, to saunter [v]\n",
  "MOSEYING": "MOSEY, to saunter [v]\n",
  "MOSEYS": "MOSEY, to saunter [v]\n",
  "MOSH": "to dance frantically to rock music [v -ED, -ING, -ES]\n",
  "MOSHAV": "(Hebrew) a cooperative settlement of small farms in Israel [n MOSHAVIM]\n",
  "MOSHAVIM": "MOSHAV, (Hebrew) a cooperative settlement of small farms in Israel [n]\n",
  "MOSHED": "MOSH, to dance frantically to rock music [v]\n",
  "MOSHER": "one who moshes, dances to loud rock music [n -S]\n",
  "MOSHERS": "MOSHER, one who moshes, dances to loud rock music [n]\n",
  "MOSHES": "MOSH, to dance frantically to rock music [v]\n",
  "MOSHING": "a style of energetic sinuous dancing [n -S]\n",
  "MOSHINGS": "MOSHING, a style of energetic sinuous dancing [n]\n",
  "MOSING": "MOSE, (Shakespeare) to have glanders [v]\n",
  "MOSK": "(Arabic) a Muslim place of worship, also MOSQUE [n -S]\n",
  "MOSKONFYT": "(South African) a thick syrup made from grapes [n -S]\n",
  "MOSKONFYTS": "MOSKONFYT, (South African) a thick syrup made from grapes [n]\n",
  "MOSKS": "MOSK, (Arabic) a Muslim place of worship, also MOSQUE [n]\n",
  "MOSLINGS": "thin shavings taken off by the currier in dressing skins [n]\n",
  "MOSQUE": "(Arabic) a Muslim place of worship, also MOSK [n -S]\n",
  "MOSQUES": "MOSQUE, (Arabic) a Muslim place of worship, also MOSK [n]\n",
  "MOSQUITO": "any dipterous insect of the family Culicidae [n -ES or -S]\n",
  "MOSQUITOES": "MOSQUITO, any dipterous insect of the family Culicidae [n]\n",
  "MOSQUITOEY": "full of mosquitoes [adj MOSQUITOIER, MOSQUITOIEST]\n",
  "MOSQUITOFISH": "a species of freshwater fish, native to the southeastern US [n -ES]\n",
  "MOSQUITOFISHES": "MOSQUITOFISH, a species of freshwater fish, native to the southeastern US [n]\n",
  "MOSQUITOIER": "MOSQUITOEY, full of mosquitoes [adj]\n",
  "MOSQUITOIEST": "MOSQUITOEY, full of mosquitoes [adj]\n",
  "MOSQUITOS": "MOSQUITO, any dipterous insect of the family Culicidae [n]\n",
  "MOSS": "a class of Bryophyta, small plants [n -ES] / to cover with moss [v -ED, -ING, -ES]\n",
  "MOSSBACK": "a person of antiquated views [n -S]\n",
  "MOSSBACKED": "conservative of opinion [adj]\n",
  "MOSSBACKS": "MOSSBACK, a person of antiquated views [n]\n",
  "MOSSBLUITER": "(Scots) the bittern [n -S]\n",
  "MOSSBLUITERS": "MOSSBLUITER, (Scots) the bittern [n]\n",
  "MOSSBUNKER": "(Dutch) an oily fish of the herring family, aka menhaden [n -S]\n",
  "MOSSBUNKERS": "MOSSBUNKER, (Dutch) an oily fish of the herring family, aka menhaden [n]\n",
  "MOSSED": "MOSS, to cover with moss [v]\n",
  "MOSSER": "a person who works in cutting and preparing peats [n -S]\n",
  "MOSSERS": "MOSSER, a person who works in cutting and preparing peats [n]\n",
  "MOSSES": "MOSS, to cover with moss [v]\n",
  "MOSSGROWN": "covered in moss [adj]\n",
  "MOSSIE": "(Australian colloquial) mosquito, also MOZZIE [n -S]\n",
  "MOSSIER": "MOSSY, covered with moss [adj]\n",
  "MOSSIES": "MOSSIE, (Australian colloquial) mosquito, also MOZZIE [n]\n",
  "MOSSIEST": "MOSSY, covered with moss [adj]\n",
  "MOSSINESS": "the state of being mossy [n -ES]\n",
  "MOSSINESSES": "MOSSINESS, the state of being mossy [n]\n",
  "MOSSING": "MOSS, to cover with moss [v]\n",
  "MOSSLAND": "wet land [n -S]\n",
  "MOSSLANDS": "MOSSLAND, wet land [n]\n",
  "MOSSLIKE": "like moss [adj]\n",
  "MOSSO": "(Italian) in music, with motion or animation [adv]\n",
  "MOSSPLANT": "a plant of moss [n -S]\n",
  "MOSSPLANTS": "MOSSPLANT, a plant of moss [n]\n",
  "MOSSTROOPER": "(historical) a 17th century border raider [n -S]\n",
  "MOSSTROOPERS": "MOSSTROOPER, (historical) a 17th century border raider [n]\n",
  "MOSSY": "covered with moss [adj MOSSIER, MOSSIEST]\n",
  "MOST": "in the highest degree [adj MOSTEST, MOSTLY] / the greatest part of [n -S]\n",
  "MOSTE": "MOTE, (obsolete) may, must [v]\n",
  "MOSTEST": "(facetious) the most [n -S]\n",
  "MOSTESTS": "MOSTEST, (facetious) the most [n]\n",
  "MOSTLY": "MOST, in the highest degree [adv]\n",
  "MOSTS": "MOST, the greatest part of [n]\n",
  "MOSTWHAT": "(Spenser) for the most part [adv]\n",
  "MOT": "(French) a witty saying [n -S]\n",
  "MOTE": "a speck of dust [n -S] / (obsolete) may, must [v]\n",
  "MOTED": "having a mote [adj]\n",
  "MOTEL": "a roadside hotel [n -S]\n",
  "MOTELIER": "(New Zealand) the owner or manager of a motel [n -S]\n",
  "MOTELIERS": "MOTELIER, (New Zealand) the owner or manager of a motel [n]\n",
  "MOTELS": "MOTEL, a roadside hotel [n]\n",
  "MOTEN": "(obsolete) 3rd person plural of MOTE, may, must [v]\n",
  "MOTES": "MOTE, a speck of dust [n]\n",
  "MOTET": "(French) a kind of unaccompanied part-song or anthem, also MOTETT [n -S]\n",
  "MOTETS": "MOTET, (French) a kind of unaccompanied part-song or anthem, also MOTETT [n]\n",
  "MOTETT": "(French) a kind of unaccompanied part-song or anthem, also MOTET [n -S]\n",
  "MOTETTIST": "one who writes motets [n -S]\n",
  "MOTETTISTS": "MOTETTIST, one who writes motets [n]\n",
  "MOTETTS": "MOTETT, (French) a kind of unaccompanied part-song or anthem, also MOTET [n]\n",
  "MOTEY": "full of motes [adj MOTIER, MOTIEST] / a pigment made from earth [n -S]\n",
  "MOTEYS": "MOTEY, a pigment made from earth [n]\n",
  "MOTH": "a winged insect [n -S]\n",
  "MOTHBALL": "a ball of naphthalene, or a similar substance, for keeping away clothes moths [n -S] / to put into mothballs [v -ED, -ING, -S]\n",
  "MOTHBALLED": "MOTHBALL, to put into mothballs [v]\n",
  "MOTHBALLING": "MOTHBALL, to put into mothballs [v]\n",
  "MOTHBALLS": "MOTHBALL, to put into mothballs [v]\n",
  "MOTHED": "moth-eaten [adj]\n",
  "MOTHER": "to give birth to [v -ED, -ING, -S]\n",
  "MOTHERBOARD": "the board containing the main circuits of an electronic device, especially in computers [n -S]\n",
  "MOTHERBOARDS": "MOTHERBOARD, the board containing the main circuits of an electronic device, especially in computers [n]\n",
  "MOTHERCRAFT": "the craft of being a mother [n -S]\n",
  "MOTHERCRAFTS": "MOTHERCRAFT, the craft of being a mother [n]\n",
  "MOTHERED": "MOTHER, to give birth to [v]\n",
  "MOTHERESE": "a simplified and repetitive type of speech used by adults in speaking to babies [n -S]\n",
  "MOTHERESES": "MOTHERESE, a simplified and repetitive type of speech used by adults in speaking to babies [n]\n",
  "MOTHERFUCKER": "(offensive) one that is formidable, contemptible, or offensive [n -S]\n",
  "MOTHERFUCKERS": "MOTHERFUCKER, (offensive) one that is formidable, contemptible, or offensive [n]\n",
  "MOTHERFUCKING": "(vulgar) objectionable; often used as an intensifier or meaningless qualification [adj]\n",
  "MOTHERHOOD": "the state of being a mother [n -S]\n",
  "MOTHERHOODS": "MOTHERHOOD, the state of being a mother [n]\n",
  "MOTHERHOUSE": "the convent in which the superior of a religious community resides [n -S]\n",
  "MOTHERHOUSES": "MOTHERHOUSE, the convent in which the superior of a religious community resides [n]\n",
  "MOTHERIER": "MOTHERY, consisting of, containing, or resembling, mother (in vinegar) [adj]\n",
  "MOTHERIEST": "MOTHERY, consisting of, containing, or resembling, mother (in vinegar) [adj]\n",
  "MOTHERING": "the act of mothering [n -S]\n",
  "MOTHERINGS": "MOTHERING, the act of mothering [n]\n",
  "MOTHERLAND": "a country regarded as a place of origin (as of an idea or a movement) [n -S]\n",
  "MOTHERLANDS": "MOTHERLAND, a country regarded as a place of origin (as of an idea or a movement) [n]\n",
  "MOTHERLESS": "without a mother [adj]\n",
  "MOTHERLESSNESS": "the state of being motherless [n]\n",
  "MOTHERLIER": "MOTHERLY, maternal [adj]\n",
  "MOTHERLIEST": "MOTHERLY, maternal [adj]\n",
  "MOTHERLINESS": "the state of being motherly [n -ES]\n",
  "MOTHERLINESSES": "MOTHERLINESS, the state of being motherly [n]\n",
  "MOTHERLY": "maternal [adj MOTHERLIER, MOTHERLIEST]\n",
  "MOTHERS": "MOTHER, to give birth to [v]\n",
  "MOTHERWORT": "a labiate herb, of a bitter taste, used popularly in medicine [n -S]\n",
  "MOTHERWORTS": "MOTHERWORT, a labiate herb, of a bitter taste, used popularly in medicine [n]\n",
  "MOTHERY": "consisting of, containing, or resembling, mother (in vinegar) [adj MOTHERIER, MOTHERIEST]\n",
  "MOTHIER": "MOTHY, full of moths [adj]\n",
  "MOTHIEST": "MOTHY, full of moths [adj]\n",
  "MOTHLIKE": "like a moth [adj]\n",
  "MOTHPROOF": "of clothes, chemically rendered resistant to moths [adj] / to proof against moths [v -ED, -ING, -S]\n",
  "MOTHPROOFED": "MOTHPROOF, to proof against moths [v]\n",
  "MOTHPROOFER": "a substance that keeps away moths [n -S]\n",
  "MOTHPROOFERS": "MOTHPROOFER, a substance that keeps away moths [n]\n",
  "MOTHPROOFING": "MOTHPROOF, to proof against moths [v]\n",
  "MOTHPROOFS": "MOTHPROOF, to proof against moths [v]\n",
  "MOTHS": "MOTH, a winged insect [n]\n",
  "MOTHY": "full of moths [adj MOTHIER, MOTHIEST]\n",
  "MOTI": "(Hindi) in India, a fat woman or girl [n -S]\n",
  "MOTIER": "MOTEY, full of motes [adj]\n",
  "MOTIEST": "MOTEY, full of motes [adj]\n",
  "MOTIF": "(French) a distinctive idea, esp. a theme elaborated on in a piece of music, literature, etc. [n -S]\n",
  "MOTIFIC": "producing motion [adj]\n",
  "MOTIFS": "MOTIF, (French) a distinctive idea, esp. a theme elaborated on in a piece of music, literature, etc. [n]\n",
  "MOTILE": "a person whose imagery takes the form of feelings of action [n -S]\n",
  "MOTILES": "MOTILE, a person whose imagery takes the form of feelings of action [n]\n",
  "MOTILITIES": "MOTILITY, the ability to move, also MOTIVITY [n]\n",
  "MOTILITY": "the ability to move, also MOTIVITY [n MOTILITIES]\n",
  "MOTION": "to direct by a gesture [v -ED, -ING, -S]\n",
  "MOTIONAL": "relating to motion [adj]\n",
  "MOTIONED": "MOTION, to direct by a gesture [v]\n",
  "MOTIONER": "one who makes a motion [n -S]\n",
  "MOTIONERS": "MOTIONER, one who makes a motion [n]\n",
  "MOTIONING": "MOTION, to direct by a gesture [v]\n",
  "MOTIONIST": "(Milton) a person who is good at making suggestions or recommendations [n -S]\n",
  "MOTIONISTS": "MOTIONIST, (Milton) a person who is good at making suggestions or recommendations [n]\n",
  "MOTIONLESS": "without motion [adj MOTIONLESSLY]\n",
  "MOTIONLESSLY": "MOTIONLESS, without motion [adv]\n",
  "MOTIONLESSNESS": "MOTIONLESS, without motion [n]\n",
  "MOTIONS": "MOTION, to direct by a gesture [v]\n",
  "MOTIS": "MOTI, (Hindi) in India, a fat woman or girl [n]\n",
  "MOTIVATE": "to inspire to action, also MOTIVE [v MOTIVATED, MOTIVATING, MOTIVATES]\n",
  "MOTIVATED": "MOTIVATE, to inspire to action, also MOTIVE [v]\n",
  "MOTIVATES": "MOTIVATE, to inspire to action, also MOTIVE [v]\n",
  "MOTIVATING": "MOTIVATE, to inspire to action, also MOTIVE [v]\n",
  "MOTIVATION": "the act of motivating [n -S]\n",
  "MOTIVATIONAL": "relating to motivation [adj MOTIVATIONALLY]\n",
  "MOTIVATIONALLY": "MOTIVATIONAL, relating to motivation [adv]\n",
  "MOTIVATIONS": "MOTIVATION, the act of motivating [n]\n",
  "MOTIVATIVE": "motivating [adj]\n",
  "MOTIVATOR": "one who motivates [n -S]\n",
  "MOTIVATORS": "MOTIVATOR, one who motivates [n]\n",
  "MOTIVE": "to inspire to action, also MOTIVATE [v MOTIVED, MOTIVING, MOTIVES]\n",
  "MOTIVED": "MOTIVE, to inspire to action, also MOTIVATE [v]\n",
  "MOTIVELESS": "without motive [adj MOTIVELESSLY]\n",
  "MOTIVELESSLY": "MOTIVELESS, without motive [adv]\n",
  "MOTIVELESSNESS": "the state of being motiveless [n]\n",
  "MOTIVES": "MOTIVE, to inspire to action, also MOTIVATE [v]\n",
  "MOTIVIC": "pertaining to a musical motif [adj]\n",
  "MOTIVING": "MOTIVE, to inspire to action, also MOTIVATE [v]\n",
  "MOTIVITIES": "MOTIVITY, the ability to move, also MOTILITY [n]\n",
  "MOTIVITY": "the ability to move, also MOTILITY [n MOTIVITIES]\n",
  "MOTLEY": "diversified in colour, multicoloured [adj MOTLEYER or MOTLIER, MOTLEYEST or MOTLIEST] / a variegated outfit, such as is worn by a jester [n -S]\n",
  "MOTLEYER": "MOTLEY, diversified in colour, multicoloured [adj]\n",
  "MOTLEYEST": "MOTLEY, diversified in colour, multicoloured [adj]\n",
  "MOTLEYS": "MOTLEY, a variegated outfit, such as is worn by a jester [n]\n",
  "MOTLIER": "MOTLEY, diversified in colour, multicoloured [adj]\n",
  "MOTLIEST": "MOTLEY, diversified in colour, multicoloured [adj]\n",
  "MOTMOT": "(Spanish) any of several mainly insectivorous passerine birds of the neotropic family Momotidae [n -S]\n",
  "MOTMOTS": "MOTMOT, (Spanish) any of several mainly insectivorous passerine birds of the neotropic family Momotidae [n]\n",
  "MOTOCROSS": "a form of scrambling, motorcycle racing round a rough circuit [n -ES]\n",
  "MOTOCROSSES": "MOTOCROSS, a form of scrambling, motorcycle racing round a rough circuit [n]\n",
  "MOTONEURON": "a neuron that passes from the central nervous system toward a muscle and conducts an impulse that causes movement [n -S]\n",
  "MOTONEURONAL": "relating to a motoneuron [adj]\n",
  "MOTONEURONS": "MOTONEURON, a neuron that passes from the central nervous system toward a muscle and conducts an impulse that causes movement [n]\n",
  "MOTOR": "to travel by automobile [v -ED, -ING, -S]\n",
  "MOTORABLE": "of roads, able to be used by motor vehicles [adj]\n",
  "MOTORAIL": "a train system [n -S]\n",
  "MOTORAILS": "MOTORAIL, a train system [n]\n",
  "MOTORBICYCLE": "a bicycle driven by a motor, also MOTORBIKE, MOTORCYCLE [n -S]\n",
  "MOTORBICYCLES": "MOTORBICYCLE, a bicycle driven by a motor, also MOTORBIKE, MOTORCYCLE [n]\n",
  "MOTORBIKE": "a bicycle driven by a motor [n -S] / to travel by motorbike, also MOTORBICYCLE, MOTORCYCLE [v MOTORBIKED, MOTORBIKING, MOTORBIKES]\n",
  "MOTORBIKED": "MOTORBIKE, to travel by motorbike, also MOTORBICYCLE, MOTORCYCLE [v]\n",
  "MOTORBIKES": "MOTORBIKE, to travel by motorbike, also MOTORBICYCLE, MOTORCYCLE [v]\n",
  "MOTORBIKING": "MOTORBIKE, to travel by motorbike, also MOTORBICYCLE, MOTORCYCLE [v]\n",
  "MOTORBOAT": "a boat with an inboard or outboard motor [n -S] / to travel by motorboat [v -ED, -ING, -S]\n",
  "MOTORBOATED": "MOTORBOAT, to travel by motorboat [v]\n",
  "MOTORBOATER": "one who drives a motorboat [n -S]\n",
  "MOTORBOATERS": "MOTORBOATER, one who drives a motorboat [n]\n",
  "MOTORBOATING": "travelling by motorboat [n -S]\n",
  "MOTORBOATINGS": "MOTORBOATING, travelling by motorboat [n]\n",
  "MOTORBOATS": "MOTORBOAT, a boat with an inboard or outboard motor [n]\n",
  "MOTORBUS": "a bus driven by an internal-combustion engine [n MOTORBUSES or MOTORBUSSES]\n",
  "MOTORBUSES": "MOTORBUS, a bus driven by an internal-combustion engine [n]\n",
  "MOTORBUSSES": "MOTORBUS, a bus driven by an internal-combustion engine [n]\n",
  "MOTORCADE": "a procession of motorcars [n -S] / to travel in a motorcade [v MOTORCADED, MOTORCADING, MOTORCADES]\n",
  "MOTORCADED": "MOTORCADE, to travel in a motorcade [v]\n",
  "MOTORCADES": "MOTORCADE, to travel in a motorcade [v]\n",
  "MOTORCADING": "MOTORCADE, to travel in a motorcade [v]\n",
  "MOTORCAR": "an automobile [n -S]\n",
  "MOTORCARS": "MOTORCAR, an automobile [n]\n",
  "MOTORCOACH": "a coach with a motor engine [n -ES]\n",
  "MOTORCOACHES": "MOTORCOACH, a coach with a motor engine [n]\n",
  "MOTORCYCLE": "to ride by motorcycle, a two-wheeled motor vehicle [v MOTORCYCLED, MOTORCYCLING, MOTORCYCLES]\n",
  "MOTORCYCLED": "MOTORCYCLE, to ride by motorcycle, a two-wheeled motor vehicle [v]\n",
  "MOTORCYCLES": "MOTORCYCLE, to ride by motorcycle, a two-wheeled motor vehicle [v]\n",
  "MOTORCYCLING": "the act of riding by motorcycle, a two-wheeled motor vehicle [n -S]\n",
  "MOTORCYCLINGS": "MOTORCYCLING, the act of riding by motorcycle, a two-wheeled motor vehicle [n]\n",
  "MOTORCYCLIST": "one who rides a motorcycle [n -S]\n",
  "MOTORCYCLISTS": "MOTORCYCLIST, one who rides a motorcycle [n]\n",
  "MOTORDOM": "the motor vehicle industry [n -S]\n",
  "MOTORDOMS": "MOTORDOM, the motor vehicle industry [n]\n",
  "MOTORED": "MOTOR, to travel by automobile [v]\n",
  "MOTORHOME": "a large motor vehicle with living quarters behind the driver's compartment [n -S]\n",
  "MOTORHOMES": "MOTORHOME, a large motor vehicle with living quarters behind the driver's compartment [n]\n",
  "MOTORIAL": "of or pertaining to motion; specifically of or pertaining to a motor nerve [adj]\n",
  "MOTORIC": "pertaining to muscular movement [adj MOTORICALLY]\n",
  "MOTORICALLY": "MOTORIC, pertaining to muscular movement [adv]\n",
  "MOTORICS": "the science of muscular movement [n]\n",
  "MOTORING": "the recreation of travelling by automobile [n -S]\n",
  "MOTORINGS": "MOTORING, the recreation of travelling by automobile [n]\n",
  "MOTORISATION": "the act of motorising, also MOTORIZATION [n -S]\n",
  "MOTORISATIONS": "MOTORISATION, the act of motorising, also MOTORIZATION [n]\n",
  "MOTORISE": "to provide with motors, also MOTORIZE [v MOTORISED, MOTORISING, MOTORISES]\n",
  "MOTORISED": "MOTORISE, to provide with motors, also MOTORIZE [v]\n",
  "MOTORISES": "MOTORISE, to provide with motors, also MOTORIZE [v]\n",
  "MOTORISING": "MOTORISE, to provide with motors, also MOTORIZE [v]\n",
  "MOTORIST": "one who travels by automobile [n -S]\n",
  "MOTORISTS": "MOTORIST, one who travels by automobile [n]\n",
  "MOTORIUM": "that part of the nervous system concerned with movement [n -S]\n",
  "MOTORIUMS": "MOTORIUM, that part of the nervous system concerned with movement [n]\n",
  "MOTORIZATION": "the act of motorizing, also MOTORISATION [n -S]\n",
  "MOTORIZATIONS": "MOTORIZATION, the act of motorizing, also MOTORISATION [n]\n",
  "MOTORIZE": "to provide with motors, also MOTORISE [v MOTORIZED, MOTORIZING, MOTORIZES]\n",
  "MOTORIZED": "MOTORIZE, to provide with motors, also MOTORISE [v]\n",
  "MOTORIZES": "MOTORIZE, to provide with motors, also MOTORISE [v]\n",
  "MOTORIZING": "MOTORIZE, to provide with motors, also MOTORISE [v]\n",
  "MOTORLESS": "without a motor [adj]\n",
  "MOTORMAN": "one who operates an electric streetcar or subway train [n MOTORMEN]\n",
  "MOTORMEN": "MOTORMAN, one who operates an electric streetcar or subway train [n]\n",
  "MOTORMOUTH": "(US slang) a nonstop talker [n -S]\n",
  "MOTORMOUTHS": "MOTORMOUTH, (US slang) a nonstop talker [n]\n",
  "MOTORS": "MOTOR, to travel by automobile [v]\n",
  "MOTORSHIP": "a ship with a motor [n -S]\n",
  "MOTORSHIPS": "MOTORSHIP, a ship with a motor [n]\n",
  "MOTORTRUCK": "a truck driven by a motor [n -S]\n",
  "MOTORTRUCKS": "MOTORTRUCK, a truck driven by a motor [n]\n",
  "MOTORWAY": "a type of highway [n -S]\n",
  "MOTORWAYS": "MOTORWAY, a type of highway [n]\n",
  "MOTORY": "conveying motion [adj]\n",
  "MOTOSCAFI": "MOTOSCAFO, (Italian) a motorboat [n]\n",
  "MOTOSCAFO": "(Italian) a motorboat [n MOTOSCAFI or MOTOSCAFOS]\n",
  "MOTOSCAFOS": "MOTOSCAFO, (Italian) a motorboat [n]\n",
  "MOTS": "MOT, (French) a witty saying [n]\n",
  "MOTSER": "(Australian slang) a large amount of money, esp. a gambling win, also MOTZA [n -S]\n",
  "MOTSERS": "MOTSER, (Australian slang) a large amount of money, esp. a gambling win, also MOTZA [n]\n",
  "MOTT": "(US) a clump of trees, esp. on a prairie [n -S]\n",
  "MOTTE": "an artificial mound upon which a castle is built [n -S]\n",
  "MOTTES": "MOTTE, an artificial mound upon which a castle is built [n]\n",
  "MOTTIER": "MOTTY, (Scots) containing motes [adj]\n",
  "MOTTIES": "MOTTY, a target at which coins are aimed in pitch-and-toss [n]\n",
  "MOTTIEST": "MOTTY, (Scots) containing motes [adj]\n",
  "MOTTLE": "to mark with spots or streaks [v MOTTLED, MOTTLING, MOTTLES]\n",
  "MOTTLED": "MOTTLE, to mark with spots or streaks [v]\n",
  "MOTTLER": "one who mottles [n -S]\n",
  "MOTTLERS": "MOTTLER, one who mottles [n]\n",
  "MOTTLES": "MOTTLE, to mark with spots or streaks [v]\n",
  "MOTTLING": "a blotched appearance [n -S]\n",
  "MOTTLINGS": "MOTTLING, a blotched appearance [n]\n",
  "MOTTO": "a short expression representing a principle [n -ES or -S]\n",
  "MOTTOED": "having a motto [adj]\n",
  "MOTTOES": "MOTTO, a short expression representing a principle [n]\n",
  "MOTTOS": "MOTTO, a short expression representing a principle [n]\n",
  "MOTTS": "MOTT, (US) a clump of trees, esp. on a prairie [n]\n",
  "MOTTY": "(Scots) containing motes [adj MOTTIER, MOTTIEST] / a target at which coins are aimed in pitch-and-toss [n MOTTIES]\n",
  "MOTU": "(Maori) a small reef island [n -S]\n",
  "MOTUCA": "(Tupi) a large Brazilian biting fly, also MUTUCA [n -S]\n",
  "MOTUCAS": "MOTUCA, (Tupi) a large Brazilian biting fly, also MUTUCA [n]\n",
  "MOTUS": "MOTU, (Maori) a small reef island [n]\n",
  "MOTZA": "(Australian slang) a large amount of money, esp. a gambling win, also MOTSER [n -S]\n",
  "MOTZAS": "MOTZA, (Australian slang) a large amount of money, esp. a gambling win, also MOTSER [n]\n",
  "MOU": "(Scots) a mouth [n -S]\n",
  "MOUCH": "to play truant, also MICH, MICHE, MITCH, MOOCH [v -ED, -ING, -ES]\n",
  "MOUCHARABIES": "MOUCHARABY, (Arabic) in North Africa, an external balcony enclosed with latticework [n]\n",
  "MOUCHARABY": "(Arabic) in North Africa, an external balcony enclosed with latticework [n MOUCHARABIES]\n",
  "MOUCHARD": "(French) a police spy [n -S]\n",
  "MOUCHARDS": "MOUCHARD, (French) a police spy [n]\n",
  "MOUCHED": "MOUCH, to play truant, also MICH, MICHE, MITCH, MOOCH [v]\n",
  "MOUCHER": "a truant, also MICHER, MOOCHER [n -S]\n",
  "MOUCHERS": "MOUCHER, a truant, also MICHER, MOOCHER [n]\n",
  "MOUCHES": "MOUCH, to play truant, also MICH, MICHE, MITCH, MOOCH [v]\n",
  "MOUCHING": "MOUCH, to play truant, also MICH, MICHE, MITCH, MOOCH [v]\n",
  "MOUCHOIR": "(French) a handkerchief [n -S]\n",
  "MOUCHOIRS": "MOUCHOIR, (French) a handkerchief [n]\n",
  "MOUDIEWART": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOUDIEWARTS": "MOUDIEWART, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOUDIEWORT": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOUDIEWORTS": "MOUDIEWORT, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOUDIWART": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOUDIWARTS": "MOUDIWART, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOUDIWORT": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOUDIWORTS": "MOUDIWORT, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOUE": "(French) a disdainful or pouting look [n -S]\n",
  "MOUES": "MOUE, (French) a disdainful or pouting look [n]\n",
  "MOUFFLON": "(French) a Corsican wild sheep, also MOUFLON, MUFLON, MUSIMON, MUSMON [n -S]\n",
  "MOUFFLONS": "MOUFFLON, (French) a Corsican wild sheep, also MOUFLON, MUFLON, MUSIMON, MUSMON [n]\n",
  "MOUFLON": "(French) a Corsican wild sheep, also MOUFFLON, MUFLON, MUSIMON, MUSMON [n -S]\n",
  "MOUFLONS": "MOUFLON, (French) a Corsican wild sheep, also MOUFFLON, MUFLON, MUSIMON, MUSMON [n]\n",
  "MOUGHT": "MAY, to gather flowers in the spring [v]\n",
  "MOUILLE": "(French) of certain consonants, having a 'liquid' or softened sound [adj]\n",
  "MOUJIK": "(Russian) a Russian peasant, also MUZHIK, MUJIK, MUZJIK [n -S]\n",
  "MOUJIKS": "MOUJIK, (Russian) a Russian peasant, also MUZHIK, MUJIK, MUZJIK [n]\n",
  "MOULAGE": "(French) an impression made for use as evidence in a criminal investigation [n -S]\n",
  "MOULAGES": "MOULAGE, (French) an impression made for use as evidence in a criminal investigation [n]\n",
  "MOULD": "to work into a particular shape, also MOLD [v -ED, -ING, -S]\n",
  "MOULDABILITIES": "MOULDABILITY, the quality of being mouldable, also MOLDABILITY [n]\n",
  "MOULDABILITY": "the quality of being mouldable, also MOLDABILITY [n MOULDABILITIES]\n",
  "MOULDABLE": "capable of being molded or formed [adj]\n",
  "MOULDBOARD": "a curved plate of iron (originally of wood) back of the share of a plow, which turns over the earth in plowing, also MOLDBOARD [n -S]\n",
  "MOULDBOARDS": "MOULDBOARD, a curved plate of iron (originally of wood) back of the share of a plow, which turns over the earth in plowing, also MOLDBOARD [n]\n",
  "MOULDED": "MOULD, to work into a particular shape, also MOLD [v]\n",
  "MOULDER": "to turn to dust by natural decay, also MOLDER [v -ED, -ING, -S]\n",
  "MOULDERED": "MOULDER, to turn to dust by natural decay, also MOLDER [v]\n",
  "MOULDERING": "MOULDER, to turn to dust by natural decay, also MOLDER [v]\n",
  "MOULDERS": "MOULDER, to turn to dust by natural decay, also MOLDER [v]\n",
  "MOULDIER": "MOULDY, covered with mould [adj]\n",
  "MOULDIEST": "MOULDY, covered with mould [adj]\n",
  "MOULDINESS": "the state of being mouldy, also MOLDINESS [n -ES]\n",
  "MOULDINESSES": "MOULDINESS, the state of being mouldy, also MOLDINESS [n]\n",
  "MOULDING": "a long, narrow strip used to decorate a surface, also MOLDING [n -S]\n",
  "MOULDINGS": "MOULDING, a long, narrow strip used to decorate a surface, also MOLDING [n]\n",
  "MOULDS": "MOULD, to work into a particular shape, also MOLD [v]\n",
  "MOULDWARP": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOULDWARPS": "MOULDWARP, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDYWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOULDY": "covered with mould [adj MOULDIER, MOULDIEST]\n",
  "MOULDYWARP": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOULDYWARPS": "MOULDYWARP, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOWDIE, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOULIN": "(French) a nearly vertical, cylindrical shaft or cavity worn in a glacier, carved by melted surface water falling through a crack in the ice [n -S]\n",
  "MOULINET": "(French) a machine for bending the crossbow [n -S]\n",
  "MOULINETS": "MOULINET, (French) a machine for bending the crossbow [n]\n",
  "MOULINS": "MOULIN, (French) a nearly vertical, cylindrical shaft or cavity worn in a glacier, carved by melted surface water falling through a crack in the ice [n]\n",
  "MOULS": "(Scots) clods, esp. in allusion to the grave [n]\n",
  "MOULT": "to shed feathers or fur, also MOLT [v -ED, -ING, -S]\n",
  "MOULTED": "MOULT, to shed feathers or fur, also MOLT [v]\n",
  "MOULTEN": "(Shakespeare) having moulted [adj]\n",
  "MOULTER": "one that molts, also MOLTER [n -S]\n",
  "MOULTERS": "MOULTER, one that molts, also MOLTER [n]\n",
  "MOULTING": "the act of shedding [n -S]\n",
  "MOULTINGS": "MOULTING, the act of shedding [n]\n",
  "MOULTS": "MOULT, to shed feathers or fur, also MOLT [v]\n",
  "MOUND": "to heap in a pile [v -ED, -ING, -S]\n",
  "MOUNDBIRD": "an Australian bird laying eggs in mounds [n -S]\n",
  "MOUNDBIRDS": "MOUNDBIRD, an Australian bird laying eggs in mounds [n]\n",
  "MOUNDED": "MOUND, to heap in a pile [v]\n",
  "MOUNDING": "MOUND, to heap in a pile [v]\n",
  "MOUNDS": "MOUND, to heap in a pile [v]\n",
  "MOUNSEER": "(archaic) a Frenchman [n -S]\n",
  "MOUNSEERS": "MOUNSEER, (archaic) a Frenchman [n]\n",
  "MOUNT": "to climb [v -ED, -ING, -S]\n",
  "MOUNTABLE": "such as can be mounted [adj]\n",
  "MOUNTAIN": "a large, natural elevation of the earth's surface [n -S]\n",
  "MOUNTAINBOARD": "a form of all-terrain skateboard derived from a snowboard [n -S]\n",
  "MOUNTAINBOARDER": "one who uses a mountainboard [n]\n",
  "MOUNTAINBOARDS": "MOUNTAINBOARD, a form of all-terrain skateboard derived from a snowboard [n]\n",
  "MOUNTAINED": "having mountains [adj]\n",
  "MOUNTAINEER": "one who climbs mountains [n -S] / to climb mountains [v -ED, -ING, -S]\n",
  "MOUNTAINEERED": "MOUNTAINEER, to climb mountains [v]\n",
  "MOUNTAINEERING": "the sport or technique of scaling mountains [n -S]\n",
  "MOUNTAINEERINGS": "MOUNTAINEERING, the sport or technique of scaling mountains [n]\n",
  "MOUNTAINEERS": "MOUNTAINEER, to climb mountains [v]\n",
  "MOUNTAINIER": "MOUNTAINY, mountainous [adj]\n",
  "MOUNTAINIEST": "MOUNTAINY, mountainous [adj]\n",
  "MOUNTAINOUS": "having mountains [adj MOUNTAINOUSLY]\n",
  "MOUNTAINOUSLY": "MOUNTAINOUS, having mountains [adv]\n",
  "MOUNTAINOUSNESS": "the state of being mountainous [n]\n",
  "MOUNTAINS": "MOUNTAIN, a large, natural elevation of the earth's surface [n]\n",
  "MOUNTAINSIDE": "the side of a mountain [n -S]\n",
  "MOUNTAINSIDES": "MOUNTAINSIDE, the side of a mountain [n]\n",
  "MOUNTAINTOP": "the summit of a mountain [n -S]\n",
  "MOUNTAINTOPS": "MOUNTAINTOP, the summit of a mountain [n]\n",
  "MOUNTAINY": "mountainous [adj MOUNTAINIER, MOUNTAINIEST]\n",
  "MOUNTANT": "an adhesive paste for mounting photographs etc. [n -S]\n",
  "MOUNTANTS": "MOUNTANT, an adhesive paste for mounting photographs etc. [n]\n",
  "MOUNTEBANK": "a person who sells quack medicines from a platform; a charlatan [n -S] / to act as a mountebank [v -ED, -ING, -S]\n",
  "MOUNTEBANKED": "MOUNTEBANK, to act as a mountebank [v]\n",
  "MOUNTEBANKERIES": "MOUNTEBANKERY, the activities of a mountebank [n]\n",
  "MOUNTEBANKERY": "the activities of a mountebank [n MOUNTEBANKERIES]\n",
  "MOUNTEBANKING": "acting as a mountebank [n -S]\n",
  "MOUNTEBANKINGS": "MOUNTEBANKING, acting as a mountebank [n]\n",
  "MOUNTEBANKISM": "the practice of a mountebank [n -S]\n",
  "MOUNTEBANKISMS": "MOUNTEBANKISM, the practice of a mountebank [n]\n",
  "MOUNTEBANKS": "MOUNTEBANK, a person who sells quack medicines from a platform; a charlatan [n]\n",
  "MOUNTED": "MOUNT, to climb [v]\n",
  "MOUNTENANCE": "(Spenser) amount; distance, also MOUNTENAUNCE [n -S]\n",
  "MOUNTENANCES": "MOUNTENANCE, (Spenser) amount; distance, also MOUNTENAUNCE [n]\n",
  "MOUNTENAUNCE": "(Spenser) amount; distance, also MOUNTENANCE [n -S]\n",
  "MOUNTENAUNCES": "MOUNTENAUNCE, (Spenser) amount; distance, also MOUNTENANCE [n]\n",
  "MOUNTER": "one who mounts [n -S]\n",
  "MOUNTERS": "MOUNTER, one who mounts [n]\n",
  "MOUNTING": "a backing for something else [n -S]\n",
  "MOUNTINGS": "MOUNTING, a backing for something else [n]\n",
  "MOUNTS": "MOUNT, to climb [v]\n",
  "MOUP": "(Scots) to nibble, munch, also MOOP [v -ED, -ING, -S]\n",
  "MOUPED": "MOUP, (Scots) to nibble, munch, also MOOP [v]\n",
  "MOUPING": "MOUP, (Scots) to nibble, munch, also MOOP [v]\n",
  "MOUPS": "MOUP, (Scots) to nibble, munch, also MOOP [v]\n",
  "MOURN": "to feel or express grief or sorrow [v -ED, -ING, -S]\n",
  "MOURNED": "MOURN, to feel or express grief or sorrow [v]\n",
  "MOURNER": "one that mourns [n -S]\n",
  "MOURNERS": "MOURNER, one that mourns [n]\n",
  "MOURNFUL": "sad, grieving [adj MOURNFULLER, MOURNFULLEST, MOURNFULLY]\n",
  "MOURNFULLER": "MOURNFUL, sad, grieving [adj]\n",
  "MOURNFULLEST": "MOURNFUL, sad, grieving [adj]\n",
  "MOURNFULLY": "MOURNFUL, sad, grieving [adv]\n",
  "MOURNFULNESS": "the state of being mournful [n -ES]\n",
  "MOURNFULNESSES": "MOURNFULNESS, the state of being mournful [n]\n",
  "MOURNING": "an outward sign of grief [n -S]\n",
  "MOURNINGLY": "MOURNING [adv]\n",
  "MOURNINGS": "MOURNING, an outward sign of grief [n]\n",
  "MOURNIVAL": "(French) a set of four, esp. a set of four court cards in one hand [n -S]\n",
  "MOURNIVALS": "MOURNIVAL, (French) a set of four, esp. a set of four court cards in one hand [n]\n",
  "MOURNS": "MOURN, to feel or express grief or sorrow [v]\n",
  "MOURVEDRE": "(French) a variety of red wine grape [n -S]\n",
  "MOURVEDRES": "MOURVEDRE, (French) a variety of red wine grape [n]\n",
  "MOUS": "MOU, (Scots) a mouth [n]\n",
  "MOUSAKA": "(Modern Greek) a Greek dish consisting of alternate layers of minced lamb, aubergines and tomatoes, also MOUSSAKA [n -S]\n",
  "MOUSAKAS": "MOUSAKA, (Modern Greek) a Greek dish consisting of alternate layers of minced lamb, aubergines and tomatoes, also MOUSSAKA [n]\n",
  "MOUSE": "a small rodent [n MICE] / to hunt mice [v MOUSED, MOUSING, MOUSES]\n",
  "MOUSEBIRD": "another name for the coly, an African bird [n -S]\n",
  "MOUSEBIRDS": "MOUSEBIRD, another name for the coly, an African bird [n]\n",
  "MOUSED": "MOUSE, to hunt mice [v]\n",
  "MOUSEKIN": "(archaic) a little mouse [n -S]\n",
  "MOUSEKINS": "MOUSEKIN, (archaic) a little mouse [n]\n",
  "MOUSELIKE": "like a mouse [adj]\n",
  "MOUSEMAT": "a piece of material on which a computer mouse is moved, also MOUSEPAD [n -S]\n",
  "MOUSEMATS": "MOUSEMAT, a piece of material on which a computer mouse is moved, also MOUSEPAD [n]\n",
  "MOUSEOVER": "on a web page, any item that changes or pops up when the pointer of a mouse moves over it [n -S]\n",
  "MOUSEOVERS": "MOUSEOVER, on a web page, any item that changes or pops up when the pointer of a mouse moves over it [n]\n",
  "MOUSEPAD": "a pad for a computer mouse, also MOUSEMAT [n -S]\n",
  "MOUSEPADS": "MOUSEPAD, a pad for a computer mouse, also MOUSEMAT [n]\n",
  "MOUSEPIECE": "(dialect) part of a hindleg of beef, next to the round [n -S]\n",
  "MOUSEPIECES": "MOUSEPIECE, (dialect) part of a hindleg of beef, next to the round [n]\n",
  "MOUSER": "a cat kept to catch mice [n -S]\n",
  "MOUSERIES": "MOUSERY, a place where mice gather [n]\n",
  "MOUSERS": "MOUSER, a cat kept to catch mice [n]\n",
  "MOUSERY": "a place where mice gather [n MOUSERIES]\n",
  "MOUSES": "MOUSE, to hunt mice [v]\n",
  "MOUSETAIL": "any of various temperate ranunculaceous plants of the genus Myosurus [n -S]\n",
  "MOUSETAILS": "MOUSETAIL, any of various temperate ranunculaceous plants of the genus Myosurus [n]\n",
  "MOUSETRAP": "a device for catching mice [n -S] / to catch in a mousetrap [v MOUSETRAPPED, MOUSETRAPPING, MOUSETRAPS]\n",
  "MOUSETRAPPED": "MOUSETRAP, to catch in a mousetrap [v]\n",
  "MOUSETRAPPING": "a range of techniques employed to stop users leaving a website [n -S]\n",
  "MOUSETRAPPINGS": "MOUSETRAPPING, a range of techniques employed to stop users leaving a website [n]\n",
  "MOUSETRAPS": "MOUSETRAP, to catch in a mousetrap [v]\n",
  "MOUSEY": "resembling a mouse, also MOUSY [adj MOUSIER, MOUSIEST]\n",
  "MOUSIE": "a young mouse [n -S]\n",
  "MOUSIER": "MOUSY, like a mouse; timid; grey, also MOUSEY [adj]\n",
  "MOUSIES": "MOUSIE, a young mouse [n]\n",
  "MOUSIEST": "MOUSY, like a mouse; timid; grey, also MOUSEY [adj]\n",
  "MOUSILY": "MOUSY, like a mouse; timid; grey, also MOUSEY [adv]\n",
  "MOUSINESS": "the state of being mousy [n -ES]\n",
  "MOUSINESSES": "MOUSINESS, the state of being mousy [n]\n",
  "MOUSING": "a wrapping around the shank end of a hook [n -S]\n",
  "MOUSINGS": "MOUSING, a wrapping around the shank end of a hook [n]\n",
  "MOUSLE": "to pull roughly [v MOUSLED, MOUSLING, MOUSLES]\n",
  "MOUSLED": "MOUSLE, to pull roughly [v]\n",
  "MOUSLES": "MOUSLE, to pull roughly [v]\n",
  "MOUSLING": "MOUSLE, to pull roughly [v]\n",
  "MOUSME": "(Japanese) a Japanese girl, esp. a waitress, also MOUSMEE [n -S]\n",
  "MOUSMEE": "(Japanese) a Japanese girl, esp. a waitress, also MOUSME [n -S]\n",
  "MOUSMEES": "MOUSMEE, (Japanese) a Japanese girl, esp. a waitress, also MOUSME [n]\n",
  "MOUSMES": "MOUSME, (Japanese) a Japanese girl, esp. a waitress, also MOUSMEE [n]\n",
  "MOUSQUETAIRE": "(French) a French musketeer; a kind of woman's cloak [n -S]\n",
  "MOUSQUETAIRES": "MOUSQUETAIRE, (French) a French musketeer; a kind of woman's cloak [n]\n",
  "MOUSSAKA": "(Modern Greek) a Greek dish consisting of alternate layers of minced lamb, aubergines and tomatoes, also MOUSAKA [n -S]\n",
  "MOUSSAKAS": "MOUSSAKA, (Modern Greek) a Greek dish consisting of alternate layers of minced lamb, aubergines and tomatoes, also MOUSAKA [n]\n",
  "MOUSSE": "(French) to apply a kind of hairstyling lotion [v MOUSSED, MOUSSING, MOUSSES]\n",
  "MOUSSED": "MOUSSE, (French) to apply a kind of hairstyling lotion [v]\n",
  "MOUSSELIKE": "like mousse [adj]\n",
  "MOUSSELINE": "(French) a French dress fabric; a hollandaise sauce with whipped cream or egg whites added [n -S]\n",
  "MOUSSELINES": "MOUSSELINE, (French) a French dress fabric; a hollandaise sauce with whipped cream or egg whites added [n]\n",
  "MOUSSES": "MOUSSE, (French) to apply a kind of hairstyling lotion [v]\n",
  "MOUSSEUX": "a sparkling wine [n MOUSSEUX]\n",
  "MOUSSING": "MOUSSE, (French) to apply a kind of hairstyling lotion [v]\n",
  "MOUST": "(Scots) a musk, hair-powder [n -S] / to powder, also MUIST [v -ED, -ING, -S]\n",
  "MOUSTACHE": "the unshaved hair on a man's upper lip, also MUSTACHE [n -S]\n",
  "MOUSTACHED": "having a moustache [adj]\n",
  "MOUSTACHES": "MOUSTACHE, the unshaved hair on a man's upper lip, also MUSTACHE [n]\n",
  "MOUSTACHIAL": "related to a moustache [adj]\n",
  "MOUSTACHIO": "(Spanish) a large, elegantly curling moustache, also MUSTACHIO [n -S]\n",
  "MOUSTACHIOED": "having a moustachio [adj]\n",
  "MOUSTACHIOS": "MOUSTACHIO, (Spanish) a large, elegantly curling moustache, also MUSTACHIO [n]\n",
  "MOUSTED": "MOUST, to powder, also MUIST [v]\n",
  "MOUSTING": "MOUST, to powder, also MUIST [v]\n",
  "MOUSTS": "MOUST, to powder, also MUIST [v]\n",
  "MOUSY": "like a mouse; timid; grey, also MOUSEY [adj MOUSIER, MOUSIEST, MOUSILY] / a diminutive of mouse [n MOUSIES]\n",
  "MOUTAN": "(Chinese) the Chinese tree peony, a shrub with large flowers of various colors [n -S]\n",
  "MOUTANS": "MOUTAN, (Chinese) the Chinese tree peony, a shrub with large flowers of various colors [n]\n",
  "MOUTER": "(Scots) a miller's fee for grinding corn [n -S] / to take mouter for, also MULTURE [v -ED, -ING, -S]\n",
  "MOUTERED": "MOUTER, to take mouter for, also MULTURE [v]\n",
  "MOUTERER": "(Scots) a person who pays or receives mouter, a miller's fee for grinding corn, also MULTURER [n -S]\n",
  "MOUTERERS": "MOUTERER, (Scots) a person who pays or receives mouter, a miller's fee for grinding corn, also MULTURER [n]\n",
  "MOUTERING": "MOUTER, to take mouter for, also MULTURE [v]\n",
  "MOUTERS": "MOUTER, to take mouter for, also MULTURE [v]\n",
  "MOUTH": "to feed into an opening in the head [v -ED, -ING, -S]\n",
  "MOUTHABLE": "lending itself to recitation or oratory [adj]\n",
  "MOUTHBREATHER": "a person who habitually breathes through the mouth [n -S]\n",
  "MOUTHBREATHERS": "MOUTHBREATHER, a person who habitually breathes through the mouth [n]\n",
  "MOUTHBREEDER": "a fish that carries eggs and young in its mouth, also MOUTHBROODER [n -S]\n",
  "MOUTHBREEDERS": "MOUTHBREEDER, a fish that carries eggs and young in its mouth, also MOUTHBROODER [n]\n",
  "MOUTHBROODER": "a cichlid fish that carries its young in its mouth for protection, also MOUTHBREEDER [n -S]\n",
  "MOUTHBROODERS": "MOUTHBROODER, a cichlid fish that carries its young in its mouth for protection, also MOUTHBREEDER [n]\n",
  "MOUTHED": "MOUTH, to feed into an opening in the head [v]\n",
  "MOUTHER": "one who mouths; an affected speaker [n -S]\n",
  "MOUTHERS": "MOUTHER, one who mouths; an affected speaker [n]\n",
  "MOUTHFEEL": "the sensory perception of a particular food while chewing [n -S]\n",
  "MOUTHFEELS": "MOUTHFEEL, the sensory perception of a particular food while chewing [n]\n",
  "MOUTHFUL": "as much as a mouth can hold [n -S]\n",
  "MOUTHFULS": "MOUTHFUL, as much as a mouth can hold [n]\n",
  "MOUTHIER": "MOUTHY, outspoken, obstreperous [adj]\n",
  "MOUTHIEST": "MOUTHY, outspoken, obstreperous [adj]\n",
  "MOUTHILY": "MOUTHY, outspoken, obstreperous [adv]\n",
  "MOUTHING": "MOUTH, to feed into an opening in the head [v]\n",
  "MOUTHLESS": "destitute of a mouth [adj]\n",
  "MOUTHLIKE": "like a mouth [adj]\n",
  "MOUTHPART": "part of a mouth [n -S]\n",
  "MOUTHPARTS": "MOUTHPART, part of a mouth [n]\n",
  "MOUTHPIECE": "something placed at or forming a mouth [n -S]\n",
  "MOUTHPIECES": "MOUTHPIECE, something placed at or forming a mouth [n]\n",
  "MOUTHS": "MOUTH, to feed into an opening in the head [v]\n",
  "MOUTHWASH": "an antiseptic solution for cleansing the mouth and for gargling with [n -ES]\n",
  "MOUTHWASHES": "MOUTHWASH, an antiseptic solution for cleansing the mouth and for gargling with [n]\n",
  "MOUTHWATERING": "arousing the appetite [adj MOUTHWATERINGLY]\n",
  "MOUTHWATERINGLY": "MOUTHWATERING, arousing the appetite [adv]\n",
  "MOUTHY": "outspoken, obstreperous [adj MOUTHIER, MOUTHIEST, MOUTHILY]\n",
  "MOUTON": "(French) a sheepskin processed to look like the fur of another animal [n -S]\n",
  "MOUTONNEE": "(French) of a rock, rounded by the action of a glacier [adj]\n",
  "MOUTONS": "MOUTON, (French) a sheepskin processed to look like the fur of another animal [n]\n",
  "MOUVEMENTE": "(French) full of movement, lively [adj]\n",
  "MOVABILITIES": "MOVABILITY, the ability to be moved, also MOVEABILITY [n]\n",
  "MOVABILITY": "the ability to be moved, also MOVEABILITY [n MOVABILITIES]\n",
  "MOVABLE": "something that can be moved, also MOVEABLE [n -S]\n",
  "MOVABLENESS": "the state of being movable, also MOVEABLENESS [n -ES]\n",
  "MOVABLENESSES": "MOVABLENESS, the state of being movable, also MOVEABLENESS [n]\n",
  "MOVABLES": "MOVABLE, something that can be moved, also MOVEABLE [n]\n",
  "MOVABLY": "so as to be capable of being moved, also MOVEABLY [adv]\n",
  "MOVANT": "a person who applies to a court for a favorable ruling [n -S]\n",
  "MOVANTS": "MOVANT, a person who applies to a court for a favorable ruling [n]\n",
  "MOVE": "to change from one position to another [v MOVED, MOVING, MOVES]\n",
  "MOVEABILITIES": "MOVEABILITY, the ability to be moved, also MOVABILITY [n]\n",
  "MOVEABILITY": "the ability to be moved, also MOVABILITY [n MOVEABILITIES]\n",
  "MOVEABLE": "something that can be moved, also MOVABLE [n -S]\n",
  "MOVEABLENESS": "the state of being moveable, also MOVABLENESS [n -ES]\n",
  "MOVEABLENESSES": "MOVEABLENESS, the state of being moveable, also MOVABLENESS [n]\n",
  "MOVEABLES": "MOVEABLE, something that can be moved, also MOVABLE [n]\n",
  "MOVEABLY": "so as to be capable of being moved, also MOVABLY [adv]\n",
  "MOVED": "MOVE, to change from one position to another [v]\n",
  "MOVELESS": "incapable of movement [adj MOVELESSLY]\n",
  "MOVELESSLY": "MOVELESS, incapable of movement [adv]\n",
  "MOVELESSNESS": "the state of being moveless [n -ES]\n",
  "MOVELESSNESSES": "MOVELESSNESS, the state of being moveless [n]\n",
  "MOVEMENT": "the act of moving [n -S]\n",
  "MOVEMENTS": "MOVEMENT, the act of moving [n]\n",
  "MOVER": "one that moves [n -S]\n",
  "MOVERS": "MOVER, one that moves [n]\n",
  "MOVES": "MOVE, to change from one position to another [v]\n",
  "MOVIE": "a motion picture [n -S]\n",
  "MOVIEDOM": "the world of the movies [n -S]\n",
  "MOVIEDOMS": "MOVIEDOM, the world of the movies [n]\n",
  "MOVIEGOER": "one who goes to the movies [n -S]\n",
  "MOVIEGOERS": "MOVIEGOER, one who goes to the movies [n]\n",
  "MOVIEGOING": "attendance at the movies [n -S]\n",
  "MOVIEGOINGS": "MOVIEGOING, attendance at the movies [n]\n",
  "MOVIELAND": "the world of the movies [n -S]\n",
  "MOVIELANDS": "MOVIELAND, the world of the movies [n]\n",
  "MOVIEMAKER": "one who makes movies [n -S]\n",
  "MOVIEMAKERS": "MOVIEMAKER, one who makes movies [n]\n",
  "MOVIEMAKING": "the act of making movies [n -S]\n",
  "MOVIEMAKINGS": "MOVIEMAKING, the act of making movies [n]\n",
  "MOVIEOKE": "an entertainment in which people act out scenes from movies that are silently playing in the background [n -S]\n",
  "MOVIEOKES": "MOVIEOKE, an entertainment in which people act out scenes from movies that are silently playing in the background [n]\n",
  "MOVIEOLA": "(tradename) a brand of film-editing machine, also MOVIOLA [n -S]\n",
  "MOVIEOLAS": "MOVIEOLA, (tradename) a brand of film-editing machine, also MOVIOLA [n]\n",
  "MOVIES": "MOVIE, a motion picture [n]\n",
  "MOVING": "MOVE, to change from one position to another [v]\n",
  "MOVINGLY": "so as to affect the emotions [adv]\n",
  "MOVIOLA": "(tradename) a brand of film-editing machine, also MOVIEOLA [n -S]\n",
  "MOVIOLAS": "MOVIOLA, (tradename) a brand of film-editing machine, also MOVIEOLA [n]\n",
  "MOW": "to cut down a crop [v MOWED, MOWN, MOWING, MOWS]\n",
  "MOWA": "(Hindi) a kind of butter-tree with edible flowers, also MAHUA, MAHWA, MOWRA [n -S]\n",
  "MOWAS": "MOWA, (Hindi) a kind of butter-tree with edible flowers, also MAHUA, MAHWA, MOWRA [n]\n",
  "MOWBURN": "to heat and ferment [v MOWBURNED, MOWBURNT, MOWBURNING, MOWBURNS]\n",
  "MOWBURNED": "MOWBURN, to heat and ferment [v]\n",
  "MOWBURNING": "the fermenting of hay when housed too green [n -S]\n",
  "MOWBURNINGS": "MOWBURNING, the fermenting of hay when housed too green [n]\n",
  "MOWBURNS": "MOWBURN, to heat and ferment [v]\n",
  "MOWBURNT": "MOWBURN, to heat and ferment [v]\n",
  "MOWDIE": "(Scots) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIEWART, MOWDIEWORT [n -S]\n",
  "MOWDIES": "MOWDIE, (Scots) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIEWART, MOWDIEWORT [n]\n",
  "MOWDIEWART": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWORT [n -S]\n",
  "MOWDIEWARTS": "MOWDIEWART, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWORT [n]\n",
  "MOWDIEWORT": "(dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART [n -S]\n",
  "MOWDIEWORTS": "MOWDIEWORT, (dialect) a mole, also MODIWORT, MOLDWARP, MOUDIEWART, MOUDIEWORT, MOUDIWART, MOUDIWORT, MOULDWARP, MOULDYWARP, MOWDIE, MOWDIEWART [n]\n",
  "MOWED": "MOW, to cut down a crop [v]\n",
  "MOWER": "one that mows [n -S]\n",
  "MOWERS": "MOWER, one that mows [n]\n",
  "MOWING": "the act of mowing [n -S]\n",
  "MOWINGS": "MOWING, the act of mowing [n]\n",
  "MOWN": "MOW, to cut down a crop [v]\n",
  "MOWRA": "(Hindi) a kind of butter-tree with edible flowers, also MAHUA, MAHWA, MOWA [n -S]\n",
  "MOWRAS": "MOWRA, (Hindi) a kind of butter-tree with edible flowers, also MAHUA, MAHWA, MOWA [n]\n",
  "MOWS": "MOW, to cut down a crop [v]\n",
  "MOXA": "(Japanese) a soft woolly mass prepared from the young leaves of Artemisia chinensis, and used as a cautery by burning it on the skin [n -S]\n",
  "MOXAS": "MOXA, (Japanese) a soft woolly mass prepared from the young leaves of Artemisia chinensis, and used as a cautery by burning it on the skin [n]\n",
  "MOXIBUSTION": "cauterization by use of moxa [n -S]\n",
  "MOXIBUSTIONS": "MOXIBUSTION, cauterization by use of moxa [n]\n",
  "MOXIE": "(US slang) courage, daring, vigour [n -S]\n",
  "MOXIES": "MOXIE, (US slang) courage, daring, vigour [n]\n",
  "MOY": "(Shakespeare) a coin or a measure [n -S]\n",
  "MOYA": "a volcanic mud [n -S]\n",
  "MOYAS": "MOYA, a volcanic mud [n]\n",
  "MOYGASHEL": "an Irish linen; a garment made from this type of Irish linen [n -S]\n",
  "MOYGASHELS": "MOYGASHEL, an Irish linen; a garment made from this type of Irish linen [n]\n",
  "MOYITIES": "MOYITY, (Spenser) moiety [n]\n",
  "MOYITY": "(Spenser) moiety [n MOYITIES]\n",
  "MOYL": "(obsolete) a mule, also MOIL, MOYLE, MULE [n -S]\n",
  "MOYLE": "to moil, toil [v MOYLED, MOYLING, MOYLES]\n",
  "MOYLED": "MOYLE, to moil, toil [v]\n",
  "MOYLES": "MOYLE, to moil, toil [v]\n",
  "MOYLING": "MOYLE, to moil, toil [v]\n",
  "MOYLS": "MOYL, (obsolete) a mule, also MOIL, MOYLE, MULE [n]\n",
  "MOYS": "MOY, (Shakespeare) a coin or a measure [n]\n",
  "MOZ": "(Australian slang) bad luck, also MOZZ [n MOZZES]\n",
  "MOZE": "to raise a nap on [v MOZED, MOZING, MOZES]\n",
  "MOZED": "MOZE, to raise a nap on [v]\n",
  "MOZES": "MOZE, to raise a nap on [v]\n",
  "MOZETTA": "(Italian) a hooded cape worn by bishops, also MOZZETTA [n MOZETTAS or MOZETTE]\n",
  "MOZETTAS": "MOZETTA, (Italian) a hooded cape worn by bishops, also MOZZETTA [n]\n",
  "MOZETTE": "MOZETTA, (Italian) a hooded cape worn by bishops, also MOZZETTA [n]\n",
  "MOZING": "MOZE, to raise a nap on [v]\n",
  "MOZO": "a manual labourer [n -S]\n",
  "MOZOS": "MOZO, a manual labourer [n]\n",
  "MOZZ": "(Australian slang) bad luck, also MOZ [n -ES]\n",
  "MOZZARELLA": "(Italian) a mild white Italian cheese [n -S]\n",
  "MOZZARELLAS": "MOZZARELLA, (Italian) a mild white Italian cheese [n]\n",
  "MOZZES": "MOZZ, (Australian slang) bad luck, also MOZ [n]\n",
  "MOZZETTA": "(Italian) a hooded cape worn by bishops, also MOZETTA [n MOZZETTAS or MOZZETTE]\n",
  "MOZZETTAS": "MOZZETTA, (Italian) a hooded cape worn by bishops, also MOZETTA [n]\n",
  "MOZZETTE": "MOZZETTA, (Italian) a hooded cape worn by bishops, also MOZETTA [n]\n",
  "MOZZIE": "(Australian slang) mosquito, also MOSSIE [n -S]\n",
  "MOZZIES": "MOZZIE, (Australian slang) mosquito, also MOSSIE [n]\n",
  "MOZZLE": "(Hebrew) to hamper or impede (someone); to hex or give bad luck to (someone) [v MOZZLED, MOZZLING, MOZZLES]\n",
  "MOZZLED": "MOZZLE, (Hebrew) to hamper or impede (someone); to hex or give bad luck to (someone) [v]\n",
  "MOZZLES": "MOZZLE, (Hebrew) to hamper or impede (someone); to hex or give bad luck to (someone) [v]\n",
  "MOZZLING": "MOZZLE, (Hebrew) to hamper or impede (someone); to hex or give bad luck to (someone) [v]\n",
  "MPRET": "(Albanian) a former title of the ruler of Albania [n -S]\n",
  "MPRETS": "MPRET, (Albanian) a former title of the ruler of Albania [n]\n",
  "MRIDAMGAM": "(Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDANG, MRIDANGA, MRIDANGAM [n -S]\n",
  "MRIDAMGAMS": "MRIDAMGAM, (Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDANG, MRIDANGA, MRIDANGAM [n]\n",
  "MRIDANG": "(Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDAMGAM, MRIDANGA, MRIDANGAM [n -S]\n",
  "MRIDANGA": "(Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDAMGAM, MRIDANG, MRIDANGAM [n -S]\n",
  "MRIDANGAM": "(Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDAMGAM, MRIDANG, MRIDANGA [n -S]\n",
  "MRIDANGAMS": "MRIDANGAM, (Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDAMGAM, MRIDANG, MRIDANGA [n]\n",
  "MRIDANGAS": "MRIDANGA, (Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDAMGAM, MRIDANG, MRIDANGAM [n]\n",
  "MRIDANGS": "MRIDANG, (Sanskrit) a two-headed Indian drum, one head being larger than the other, also MRIDAMGAM, MRIDANGA, MRIDANGAM [n]\n",
  "MU": "(Greek) a letter of the Greek alphabet [n -S]\n",
  "MUCATE": "a salt of mucic acid [n -S]\n",
  "MUCATES": "MUCATE, a salt of mucic acid [n]\n",
  "MUCEDINOUS": "mouldy; mildewy [adj]\n",
  "MUCH": "plentiful [adj MUCHLY] / a great deal [n -ES]\n",
  "MUCHACHA": "(Spanish) a young woman or female servant [n -S]\n",
  "MUCHACHAS": "MUCHACHA, (Spanish) a young woman or female servant [n]\n",
  "MUCHACHO": "(Spanish) a boy, manservant [n -S]\n",
  "MUCHACHOS": "MUCHACHO, (Spanish) a boy, manservant [n]\n",
  "MUCHEL": "(archaic) a great deal, also MOCHELL, MUCHELL [n -S]\n",
  "MUCHELL": "(Spenser) a great deal, also MOCHELL, MUCHEL [n -S]\n",
  "MUCHELLS": "MUCHELL, (Spenser) a great deal, also MOCHELL, MUCHEL [n]\n",
  "MUCHELS": "MUCHEL, (archaic) a great deal, also MOCHELL, MUCHELL [n]\n",
  "MUCHES": "MUCH, a great deal [n]\n",
  "MUCHLY": "MUCH, plentiful [adv]\n",
  "MUCHNESS": "greatness [n -ES]\n",
  "MUCHNESSES": "MUCHNESS, greatness [n]\n",
  "MUCHO": "(Spanish) very [adj]\n",
  "MUCIC": "as in mucic acid, a colourless crystalline solid carboxylic acid [adj]\n",
  "MUCID": "mouldy, musty [adj]\n",
  "MUCIDITIES": "MUCIDITY, mouldiness [n]\n",
  "MUCIDITY": "mouldiness [n MUCIDITIES]\n",
  "MUCIDNESS": "the state of being mucid [n -ES]\n",
  "MUCIDNESSES": "MUCIDNESS, the state of being mucid [n]\n",
  "MUCIFEROUS": "conveying or secreting mucus [adj]\n",
  "MUCIGEN": "a substance secreted by the cells of mucus membrane, also MUCINOGEN [n -S]\n",
  "MUCIGENS": "MUCIGEN, a substance secreted by the cells of mucus membrane, also MUCINOGEN [n]\n",
  "MUCILAGE": "an adhesive substance [n -S]\n",
  "MUCILAGES": "MUCILAGE, an adhesive substance [n]\n",
  "MUCILAGINOUS": "sticky, viscid [adj MUCILAGINOUSLY]\n",
  "MUCILAGINOUSLY": "MUCILAGINOUS, sticky, viscid [adv]\n",
  "MUCIN": "a protein secreted by the mucous membranes [n -S]\n",
  "MUCINOGEN": "a substance secreted by mucous membrane, also MUCIGEN [n -S]\n",
  "MUCINOGENS": "MUCINOGEN, a substance secreted by mucous membrane, also MUCIGEN [n]\n",
  "MUCINOID": "of or like mucin, a substance produced by mucous membranes, also MUCINOUS [adj]\n",
  "MUCINOUS": "of or like mucin, a substance produced by mucous membranes, also MUCINOID [adj]\n",
  "MUCINS": "MUCIN, a protein secreted by the mucous membranes [n]\n",
  "MUCK": "to manure with dung [v -ED, -ING, -S]\n",
  "MUCKAMUCK": "(Canadian) food [n -S] / to consume food [v -ED, -ING, -S]\n",
  "MUCKAMUCKED": "MUCKAMUCK, to consume food [v]\n",
  "MUCKAMUCKING": "MUCKAMUCK, to consume food [v]\n",
  "MUCKAMUCKS": "MUCKAMUCK, (Canadian) food [n]\n",
  "MUCKED": "MUCK, to manure with dung [v]\n",
  "MUCKENDER": "(obsolete) a handkerchief [n -S]\n",
  "MUCKENDERS": "MUCKENDER, (obsolete) a handkerchief [n]\n",
  "MUCKER": "to squander [v -ED, -ING, -S]\n",
  "MUCKERED": "MUCKER, to squander [v]\n",
  "MUCKERING": "MUCKER, to squander [v]\n",
  "MUCKERISH": "coarse [adj]\n",
  "MUCKERS": "MUCKER, to squander [v]\n",
  "MUCKHEAP": "a dunghill [n -S]\n",
  "MUCKHEAPS": "MUCKHEAP, a dunghill [n]\n",
  "MUCKIER": "MUCKY, dirty [adj]\n",
  "MUCKIEST": "MUCKY, dirty [adj]\n",
  "MUCKILY": "MUCKY, dirty [adv]\n",
  "MUCKINESS": "the quality of being mucky [n -ES]\n",
  "MUCKINESSES": "MUCKINESS, the quality of being mucky [n]\n",
  "MUCKING": "MUCK, to manure with dung [v]\n",
  "MUCKLE": "(Scots) great, much [adj MUCKLER, MUCKLEST] / a great deal [n -S]\n",
  "MUCKLER": "MUCKLE, (Scots) great, much [adj]\n",
  "MUCKLES": "MUCKLE, a great deal [n]\n",
  "MUCKLEST": "MUCKLE, (Scots) great, much [adj]\n",
  "MUCKLUCK": "(Inuit) a type of sealskin boot, also MUCLUC, MUKLUK [n -S]\n",
  "MUCKLUCKS": "MUCKLUCK, (Inuit) a type of sealskin boot, also MUCLUC, MUKLUK [n]\n",
  "MUCKRAKE": "to search for and expose corruption [v MUCKRAKED, MUCKRAKING, MUCKRAKES]\n",
  "MUCKRAKED": "MUCKRAKE, to search for and expose corruption [v]\n",
  "MUCKRAKER": "one who spreads defamatory gossip [n -S]\n",
  "MUCKRAKERS": "MUCKRAKER, one who spreads defamatory gossip [n]\n",
  "MUCKRAKES": "MUCKRAKE, to search for and expose corruption [v]\n",
  "MUCKRAKING": "the exposure of misconduct [n -S]\n",
  "MUCKRAKINGS": "MUCKRAKING, the exposure of misconduct [n]\n",
  "MUCKS": "MUCK, to manure with dung [v]\n",
  "MUCKSPREAD": "to spread manure on fields [v MUCKSPREAD, MUCKSPREADING, MUCKSPREADS]\n",
  "MUCKSPREADER": "an agricultural machine for spreading manure [n -S]\n",
  "MUCKSPREADERS": "MUCKSPREADER, an agricultural machine for spreading manure [n]\n",
  "MUCKSPREADING": "MUCKSPREAD, to spread manure on fields [v]\n",
  "MUCKSPREADS": "MUCKSPREAD, to spread manure on fields [v]\n",
  "MUCKSWEAT": "a profuse sweat [n -S]\n",
  "MUCKSWEATS": "MUCKSWEAT, a profuse sweat [n]\n",
  "MUCKWORM": "a worm found in manure [n -S]\n",
  "MUCKWORMS": "MUCKWORM, a worm found in manure [n]\n",
  "MUCKY": "dirty [adj MUCKIER, MUCKIEST, MUCKILY]\n",
  "MUCKYMUCK": "(Canadian) a person who is or looks very important [n -S]\n",
  "MUCKYMUCKS": "MUCKYMUCK, (Canadian) a person who is or looks very important [n]\n",
  "MUCLUC": "(Inuit) a type of sealskin boot, also MUCKLUCK, MUKLUK [n -S]\n",
  "MUCLUCS": "MUCLUC, (Inuit) a type of sealskin boot, also MUCKLUCK, MUKLUK [n]\n",
  "MUCOCUTANEOUS": "designating the junction between a mucous membrane and the skin, as at the mouth, anus, etc. [adj]\n",
  "MUCOID": "a substance like mucus, found in connective tissue [n -S]\n",
  "MUCOIDAL": "mucus-like [adj]\n",
  "MUCOIDS": "MUCOID, a substance like mucus, found in connective tissue [n]\n",
  "MUCOLYTIC": "an agent that is able to break down mucus [n -S]\n",
  "MUCOLYTICS": "MUCOLYTIC, an agent that is able to break down mucus [n]\n",
  "MUCOMEMBRANOUS": "relating to the mucous membrane [adj]\n",
  "MUCOPEPTIDE": "another name for peptidoglycan [n -S]\n",
  "MUCOPEPTIDES": "MUCOPEPTIDE, another name for peptidoglycan [n]\n",
  "MUCOPROTEIN": "any of various complex conjugated proteins that contain polysaccharides and occur in body fluids and tissues [n -S]\n",
  "MUCOPROTEINS": "MUCOPROTEIN, any of various complex conjugated proteins that contain polysaccharides and occur in body fluids and tissues [n]\n",
  "MUCOPURULENT": "containing a mixture of mucus and pus [adj]\n",
  "MUCOR": "(Latin) a genus of mould fungi [n -S]\n",
  "MUCORS": "MUCOR, (Latin) a genus of mould fungi [n]\n",
  "MUCOSA": "(Latin) a mucous membrane [n MUCOSAS or MUCOSAE]\n",
  "MUCOSAE": "MUCOSA, (Latin) a mucous membrane [n]\n",
  "MUCOSAL": "relating to mucosae, mucous membranes [adj]\n",
  "MUCOSANGUINEOUS": "consisting of mucus and blood [adj]\n",
  "MUCOSAS": "MUCOSA, (Latin) a mucous membrane [n]\n",
  "MUCOSE": "containing mucus, also MUCOUS [adj]\n",
  "MUCOSITIES": "MUCOSITY, the state of being mucous [n]\n",
  "MUCOSITY": "the state of being mucous [n MUCOSITIES]\n",
  "MUCOUS": "containing mucus, also MUCOSE [adj]\n",
  "MUCOVISCIDOSES": "MUCOVISCIDOSIS, cystic fibrosis [n]\n",
  "MUCOVISCIDOSIS": "cystic fibrosis [n MUCOVISCIDOSES]\n",
  "MUCRO": "(Latin) a sharp point at the end of certain plant and animal organs [n MUCROS or MUCRONES]\n",
  "MUCRONATE": "terminating in a sharp point, as a mucronate leaf, also MUCRONATED [adj]\n",
  "MUCRONATED": "terminating in a sharp point, also MUCRONATE [adj]\n",
  "MUCRONATION": "the state of being mucronate [n -S]\n",
  "MUCRONATIONS": "MUCRONATION, the state of being mucronate [n]\n",
  "MUCRONES": "MUCRO, (Latin) a sharp point at the end of certain plant and animal organs [n]\n",
  "MUCROS": "MUCRO, (Latin) a sharp point at the end of certain plant and animal organs [n]\n",
  "MUCULENT": "like mucus [adj]\n",
  "MUCUS": "the slimy fluid secreted by various membranes in the body, which it moistens and protects [n -ES]\n",
  "MUCUSES": "MUCUS, the slimy fluid secreted by various membranes in the body, which it moistens and protects [n]\n",
  "MUD": "to cover with soft wet earth [v MUDDED, MUDDING, MUDS]\n",
  "MUDBANK": "a sloping area of mud alongside a body of water [n -S]\n",
  "MUDBANKS": "MUDBANK, a sloping area of mud alongside a body of water [n]\n",
  "MUDBATH": "a medicinal or therapeutic bath of heated mud used esp. to relieve rheumatism [n -S]\n",
  "MUDBATHS": "MUDBATH, a medicinal or therapeutic bath of heated mud used esp. to relieve rheumatism [n]\n",
  "MUDBUG": "a crayfish [n -S]\n",
  "MUDBUGS": "MUDBUG, a crayfish [n]\n",
  "MUDCAP": "to cover an explosive with mud before detonating [v MUDCAPPED, MUDCAPPING, MUDCAPS]\n",
  "MUDCAPPED": "MUDCAP, to cover an explosive with mud before detonating [v]\n",
  "MUDCAPPING": "the act of covering an explosive with mud before detonating [n -S]\n",
  "MUDCAPPINGS": "MUDCAPPING, the act of covering an explosive with mud before detonating [n]\n",
  "MUDCAPS": "MUDCAP, to cover an explosive with mud before detonating [v]\n",
  "MUDCAT": "(US) a name given to several species of catfish [n -S]\n",
  "MUDCATS": "MUDCAT, (US) a name given to several species of catfish [n]\n",
  "MUDDED": "MUD, to cover with soft wet earth [v]\n",
  "MUDDER": "a racehorse that runs well on muddy tracks [n -S]\n",
  "MUDDERS": "MUDDER, a racehorse that runs well on muddy tracks [n]\n",
  "MUDDIED": "MUDDY, to cover with mud [v]\n",
  "MUDDIER": "MUDDY, covered with mud [adj]\n",
  "MUDDIES": "MUDDY, to cover with mud [v]\n",
  "MUDDIEST": "MUDDY, covered with mud [adj]\n",
  "MUDDILY": "MUDDY, covered with mud [adv]\n",
  "MUDDINESS": "the state of being muddy [n -ES]\n",
  "MUDDINESSES": "MUDDINESS, the state of being muddy [n]\n",
  "MUDDING": "MUD, to cover with soft wet earth [v]\n",
  "MUDDLE": "to mix up [v MUDDLED, MUDDLING, MUDDLES]\n",
  "MUDDLED": "MUDDLE, to mix up [v]\n",
  "MUDDLEDNESS": "the state of being muddled [n -ES]\n",
  "MUDDLEDNESSES": "MUDDLEDNESS, the state of being muddled [n]\n",
  "MUDDLEHEAD": "a muddled, confused, or foolish person [n -S]\n",
  "MUDDLEHEADED": "mentally confused [adj MUDDLEHEADEDLY]\n",
  "MUDDLEHEADEDLY": "MUDDLEHEADED, mentally confused [adv]\n",
  "MUDDLEHEADS": "MUDDLEHEAD, a muddled, confused, or foolish person [n]\n",
  "MUDDLEMENT": "the state of being muddled [n -S]\n",
  "MUDDLEMENTS": "MUDDLEMENT, the state of being muddled [n]\n",
  "MUDDLER": "one who muddles [n -S]\n",
  "MUDDLERS": "MUDDLER, one who muddles [n]\n",
  "MUDDLES": "MUDDLE, to mix up [v]\n",
  "MUDDLIER": "MUDDLY, disordered [adj]\n",
  "MUDDLIEST": "MUDDLY, disordered [adj]\n",
  "MUDDLING": "confused [adj MUDDLINGLY] / the act of creating a muddle [n -S]\n",
  "MUDDLINGLY": "MUDDLING, confused [adv]\n",
  "MUDDLINGS": "MUDDLING, the act of creating a muddle [n]\n",
  "MUDDLY": "disordered [adj MUDDLIER, MUDDLIEST]\n",
  "MUDDY": "covered with mud [adj MUDDIER, MUDDIEST, MUDDILY] / to cover with mud [v MUDDIED, MUDDYING, MUDDIES]\n",
  "MUDDYING": "MUDDY, to cover with mud [v]\n",
  "MUDEJAR": "(Arabic) a Spanish moor [n MUDEJARES]\n",
  "MUDEJARES": "MUDEJAR, (Arabic) a Spanish moor [n]\n",
  "MUDEYE": "(Australian) the larva of the dragonfly, commonly used as a fishing bait [n -S]\n",
  "MUDEYES": "MUDEYE, (Australian) the larva of the dragonfly, commonly used as a fishing bait [n]\n",
  "MUDFISH": "a fish that burrows in mud, esp. a lungfish [n -ES]\n",
  "MUDFISHES": "MUDFISH, a fish that burrows in mud, esp. a lungfish [n]\n",
  "MUDFLAP": "a flap fixed behind the wheels of a vehicle [n -S]\n",
  "MUDFLAPS": "MUDFLAP, a flap fixed behind the wheels of a vehicle [n]\n",
  "MUDFLAT": "a level tract alternately covered and left bare by the tide [n -S]\n",
  "MUDFLATS": "MUDFLAT, a level tract alternately covered and left bare by the tide [n]\n",
  "MUDFLOW": "a moving mass of mud [n -S]\n",
  "MUDFLOWS": "MUDFLOW, a moving mass of mud [n]\n",
  "MUDGE": "to move, shift; to bruise [v MUDGED, MUDGING, MUDGES]\n",
  "MUDGED": "MUDGE, to move, shift; to bruise [v]\n",
  "MUDGER": "one who mudges, equivocates [n -S]\n",
  "MUDGERS": "MUDGER, one who mudges, equivocates [n]\n",
  "MUDGES": "MUDGE, to move, shift; to bruise [v]\n",
  "MUDGING": "MUDGE, to move, shift; to bruise [v]\n",
  "MUDGUARD": "a fender [n -S]\n",
  "MUDGUARDS": "MUDGUARD, a fender [n]\n",
  "MUDHEN": "a water bird living in muddy places [n -S]\n",
  "MUDHENS": "MUDHEN, a water bird living in muddy places [n]\n",
  "MUDHOLE": "a hollow place full of mud [n -S]\n",
  "MUDHOLES": "MUDHOLE, a hollow place full of mud [n]\n",
  "MUDHOOK": "(slang) an anchor [n -S]\n",
  "MUDHOOKS": "MUDHOOK, (slang) an anchor [n]\n",
  "MUDHOPPER": "a fish of mud flats and mangrove swamps, also MUDSKIPPER [n -S]\n",
  "MUDHOPPERS": "MUDHOPPER, a fish of mud flats and mangrove swamps, also MUDSKIPPER [n]\n",
  "MUDIR": "(Arabic) a local governor [n -S]\n",
  "MUDIRIA": "(Arabic) the province or office of a mudir, a local governor, also MUDIRIEH [n -S]\n",
  "MUDIRIAS": "MUDIRIA, (Arabic) the province or office of a mudir, a local governor, also MUDIRIEH [n]\n",
  "MUDIRIEH": "(Arabic) the province or office of a mudir, a local governor, also MUDIRIA [n -S]\n",
  "MUDIRIEHS": "MUDIRIEH, (Arabic) the province or office of a mudir, a local governor, also MUDIRIA [n]\n",
  "MUDIRS": "MUDIR, (Arabic) a local governor [n]\n",
  "MUDLARK": "a person who scavenges for usable debris in the mud of a river or harbour [n -S] / to follow the occupation of a mudlark [v -ED, -ING, -S]\n",
  "MUDLARKED": "MUDLARK, to follow the occupation of a mudlark [v]\n",
  "MUDLARKING": "MUDLARK, to follow the occupation of a mudlark [v]\n",
  "MUDLARKS": "MUDLARK, to follow the occupation of a mudlark [v]\n",
  "MUDLOGGER": "a person who looks for oil, gas etc. in traces of mud excavated from a borehole [n -S]\n",
  "MUDLOGGERS": "MUDLOGGER, a person who looks for oil, gas etc. in traces of mud excavated from a borehole [n]\n",
  "MUDLOGGING": "looking for oil, gas etc. in traces of mud excavated from a borehole [n -S]\n",
  "MUDLOGGINGS": "MUDLOGGING, looking for oil, gas etc. in traces of mud excavated from a borehole [n]\n",
  "MUDPACK": "a cosmetic paste for the face [n -S]\n",
  "MUDPACKS": "MUDPACK, a cosmetic paste for the face [n]\n",
  "MUDPIE": "a small mass of mud formed into a pie shape [n -S]\n",
  "MUDPIES": "MUDPIE, a small mass of mud formed into a pie shape [n]\n",
  "MUDPUPPIES": "MUDPUPPY, a large salamander, the axolotl [n]\n",
  "MUDPUPPY": "a large salamander, the axolotl [n MUDPUPPIES]\n",
  "MUDRA": "(Sanskrit) a hand gesture in East Indian classical dancing [n -S]\n",
  "MUDRAS": "MUDRA, (Sanskrit) a hand gesture in East Indian classical dancing [n]\n",
  "MUDROCK": "a pelite, any rock derived from clay or mud [n -S]\n",
  "MUDROCKS": "MUDROCK, a pelite, any rock derived from clay or mud [n]\n",
  "MUDROOM": "a room for shedding muddy clothing [n -S]\n",
  "MUDROOMS": "MUDROOM, a room for shedding muddy clothing [n]\n",
  "MUDS": "MUD, to cover with soft wet earth [v]\n",
  "MUDSCOW": "a flat mud-boat [n -S]\n",
  "MUDSCOWS": "MUDSCOW, a flat mud-boat [n]\n",
  "MUDSILL": "the lowest supporting timber of a structure [n -S]\n",
  "MUDSILLS": "MUDSILL, the lowest supporting timber of a structure [n]\n",
  "MUDSKIPPER": "a fish of mud flats and mangrove swamps, also MUDHOPPER [n -S]\n",
  "MUDSKIPPERS": "MUDSKIPPER, a fish of mud flats and mangrove swamps, also MUDHOPPER [n]\n",
  "MUDSLIDE": "a slippage of mud down a hillside [n -S]\n",
  "MUDSLIDES": "MUDSLIDE, a slippage of mud down a hillside [n]\n",
  "MUDSLING": "to use insults and accusations against a rival candidate [v MUDSLUNG, MUDSLINGING, MUDSLINGS]\n",
  "MUDSLINGER": "one who engages in malicious slander intended to discredit another [n -S]\n",
  "MUDSLINGERS": "MUDSLINGER, one who engages in malicious slander intended to discredit another [n]\n",
  "MUDSLINGING": "vilification of character [n -S]\n",
  "MUDSLINGINGS": "MUDSLINGING, vilification of character [n]\n",
  "MUDSLINGS": "MUDSLING, to use insults and accusations against a rival candidate [v]\n",
  "MUDSLUNG": "MUDSLING, to use insults and accusations against a rival candidate [v]\n",
  "MUDSTONE": "a fine-grained detrital sedimentary rock made up of clay- and silt-sized particles [n -S]\n",
  "MUDSTONES": "MUDSTONE, a fine-grained detrital sedimentary rock made up of clay- and silt-sized particles [n]\n",
  "MUDWORT": "a small herbaceous plant growing on muddy shores [n -S]\n",
  "MUDWORTS": "MUDWORT, a small herbaceous plant growing on muddy shores [n]\n",
  "MUEDDIN": "(Arabic) the Muslim official who calls the faithful to prayer, also MUEZZIN [n -S]\n",
  "MUEDDINS": "MUEDDIN, (Arabic) the Muslim official who calls the faithful to prayer, also MUEZZIN [n]\n",
  "MUENSTER": "a semisoft cow's milk cheese from Munster in France, also MUNSTER [n -S]\n",
  "MUENSTERS": "MUENSTER, a semisoft cow's milk cheese from Munster in France, also MUNSTER [n]\n",
  "MUESLI": "(German) a dish of rolled oats, nuts etc. eaten as a breakfast cereal [n -S]\n",
  "MUESLIS": "MUESLI, (German) a dish of rolled oats, nuts etc. eaten as a breakfast cereal [n]\n",
  "MUEZZIN": "(Arabic) the Muslim official who calls the faithful to prayer, also MUEDDIN [n -S]\n",
  "MUEZZINS": "MUEZZIN, (Arabic) the Muslim official who calls the faithful to prayer, also MUEDDIN [n]\n",
  "MUFF": "to make a mess of, fail to catch [v -ED, -ING, -S]\n",
  "MUFFED": "MUFF, to make a mess of, fail to catch [v]\n",
  "MUFFETTEE": "(obsolete) a muffler, a woollen cuff [n -S]\n",
  "MUFFETTEES": "MUFFETTEE, (obsolete) a muffler, a woollen cuff [n]\n",
  "MUFFIN": "a thick round baked yeast roll, usually toasted and served with butter [n -S]\n",
  "MUFFINEER": "a dish for keeping muffins hot [n -S]\n",
  "MUFFINEERS": "MUFFINEER, a dish for keeping muffins hot [n]\n",
  "MUFFING": "MUFF, to make a mess of, fail to catch [v]\n",
  "MUFFINS": "MUFFIN, a thick round baked yeast roll, usually toasted and served with butter [n]\n",
  "MUFFISH": "stupid; awkward [adj]\n",
  "MUFFLE": "to dull the sound of [v MUFFLED, MUFFLING, MUFFLES]\n",
  "MUFFLED": "MUFFLE, to dull the sound of [v]\n",
  "MUFFLER": "a thick scarf, collar, etc. [n -S]\n",
  "MUFFLERED": "wearing a muffler [adj]\n",
  "MUFFLERS": "MUFFLER, a thick scarf, collar, etc. [n]\n",
  "MUFFLES": "MUFFLE, to dull the sound of [v]\n",
  "MUFFLING": "MUFFLE, to dull the sound of [v]\n",
  "MUFFS": "MUFF, to make a mess of, fail to catch [v]\n",
  "MUFLON": "(French) a Corsican wild sheep, also MOUFFLON, MOUFLON, MUSIMON, MUSMON [n -S]\n",
  "MUFLONS": "MUFLON, (French) a Corsican wild sheep, also MOUFFLON, MOUFLON, MUSIMON, MUSMON [n]\n",
  "MUFTI": "(Arabic) civilian clothes, esp when worn by someone who normally wears a uniform [n -S]\n",
  "MUFTIS": "MUFTI, (Arabic) civilian clothes, esp when worn by someone who normally wears a uniform [n]\n",
  "MUG": "to assault with intent to rob [v MUGGED, MUGGING, MUGS]\n",
  "MUGEARITE": "a dark, finely crystalline basic igneous rock [n -S]\n",
  "MUGEARITES": "MUGEARITE, a dark, finely crystalline basic igneous rock [n]\n",
  "MUGFUL": "as much as a mug can hold [n -S]\n",
  "MUGFULS": "MUGFUL, as much as a mug can hold [n]\n",
  "MUGG": "to make funny faces [v -ED, -ING, -S]\n",
  "MUGGA": "(Native Australian) an Australian eucalyptus with dark bark and pink flowers [n -S]\n",
  "MUGGAR": "(Hindi) a broad-snouted Indian crocodile, also MUGGER, MUGGUR [n -S]\n",
  "MUGGARS": "MUGGAR, (Hindi) a broad-snouted Indian crocodile, also MUGGER, MUGGUR [n]\n",
  "MUGGAS": "MUGGA, (Native Australian) an Australian eucalyptus with dark bark and pink flowers [n]\n",
  "MUGGED": "MUGG, to make funny faces [v]\n",
  "MUGGEE": "the victim of a mugger [n -S]\n",
  "MUGGEES": "MUGGEE, the victim of a mugger [n]\n",
  "MUGGER": "(Hindi) a broad-snouted Indian crocodile, also MUGGAR, MUGGUR [n -S]\n",
  "MUGGERS": "MUGGER, (Hindi) a broad-snouted Indian crocodile, also MUGGAR, MUGGUR [n]\n",
  "MUGGIER": "MUGGY, warm and humid [adj]\n",
  "MUGGIEST": "MUGGY, warm and humid [adj]\n",
  "MUGGILY": "MUGGY, warm and humid [adv]\n",
  "MUGGINESS": "the quality of being muggy [n -ES]\n",
  "MUGGINESSES": "MUGGINESS, the quality of being muggy [n]\n",
  "MUGGING": "a street assault [n -S]\n",
  "MUGGINGS": "MUGGING, a street assault [n]\n",
  "MUGGINS": "a fool, a sucker, esp. used facetiously to refer to oneself as such [n -ES]\n",
  "MUGGINSES": "MUGGINS, a fool, a sucker, esp. used facetiously to refer to oneself as such [n]\n",
  "MUGGISH": "somewhat muggy [adj]\n",
  "MUGGLE": "(in fantasy fiction) a person who does not possess supernatural powers [n -S]\n",
  "MUGGLES": "MUGGLE, (in fantasy fiction) a person who does not possess supernatural powers [n]\n",
  "MUGGS": "MUGG, to make funny faces [v]\n",
  "MUGGUR": "(Hindi) a broad-snouted Indian crocodile, also MUGGAR, MUGGER [n -S]\n",
  "MUGGURS": "MUGGUR, (Hindi) a broad-snouted Indian crocodile, also MUGGAR, MUGGER [n]\n",
  "MUGGY": "warm and humid [adj MUGGIER, MUGGIEST, MUGGILY]\n",
  "MUGHAL": "(Persian) an important person, also MOGUL, MOGHUL [n -S]\n",
  "MUGHALS": "MUGHAL, (Persian) an important person, also MOGUL, MOGHUL [n]\n",
  "MUGS": "MUG, to assault with intent to rob [v]\n",
  "MUGSHOT": "a photograph esp. of a police suspect's face [n -S]\n",
  "MUGSHOTS": "MUGSHOT, a photograph esp. of a police suspect's face [n]\n",
  "MUGWORT": "a common British plant of the wormwood family [n -S]\n",
  "MUGWORTS": "MUGWORT, a common British plant of the wormwood family [n]\n",
  "MUGWUMP": "(Native American) a bolter from the Republican party in 1884; a political independent [n -S]\n",
  "MUGWUMPERIES": "MUGWUMPERY, the acts and views of a mugwump, a bolter from the Republican party in 1884; a political independent [n]\n",
  "MUGWUMPERY": "the acts and views of a mugwump, a bolter from the Republican party in 1884; a political independent [n MUGWUMPERIES]\n",
  "MUGWUMPISH": "like a mugwump [adj]\n",
  "MUGWUMPISM": "being a mugwump [n -S]\n",
  "MUGWUMPISMS": "MUGWUMPISM, being a mugwump [n]\n",
  "MUGWUMPS": "MUGWUMP, (Native American) a bolter from the Republican party in 1884; a political independent [n]\n",
  "MUHLIES": "MUHLY, a perennial grass [n]\n",
  "MUHLY": "a perennial grass [n MUHLIES]\n",
  "MUID": "an old French measure of capacity [n -S]\n",
  "MUIDS": "MUID, an old French measure of capacity [n]\n",
  "MUIL": "(Scots) a mule, a backless slipper [n -S]\n",
  "MUILS": "MUIL, (Scots) a mule, a backless slipper [n]\n",
  "MUIR": "(Scots) a moor [n -S]\n",
  "MUIRBURN": "the seasonal burning of heather on moorland to promote new growth, also MOORBURN [n -S]\n",
  "MUIRBURNS": "MUIRBURN, the seasonal burning of heather on moorland to promote new growth, also MOORBURN [n]\n",
  "MUIRS": "MUIR, (Scots) a moor [n]\n",
  "MUIST": "(Scots) a musk, hair-powder [n -S] / to powder, also MOUST [v -ED, -ING, -S]\n",
  "MUISTED": "MUIST, to powder, also MOUST [v]\n",
  "MUISTING": "MUIST, to powder, also MOUST [v]\n",
  "MUISTS": "MUIST, to powder, also MOUST [v]\n",
  "MUJAHEDDIN": "(Arabic) Islamic fundamentalist freedom fighters, also MOJAHEDIN, MUJAHEDEEN, MUJAHEDIN, MUJAHIDEEN, MUJAHIDIN [n]\n",
  "MUJAHEDEEN": "(Arabic) Islamic fundamentalist freedom fighters, also MOJAHEDIN, MUJAHEDDIN, MUJAHEDIN, MUJAHIDEEN, MUJAHIDIN [n]\n",
  "MUJAHEDIN": "(Arabic) Islamic fundamentalist freedom fighters, also MOJAHEDIN, MUJAHEDDIN, MUJAHEDEEN, MUJAHIDEEN, MUJAHIDIN [n]\n",
  "MUJAHIDEEN": "(Arabic) Islamic fundamentalist freedom fighters, also MOJAHEDIN, MUJAHEDDIN, MUJAHEDEEN, MUJAHEDIN, MUJAHIDIN [n]\n",
  "MUJAHIDIN": "(Arabic) Islamic fundamentalist freedom fighters, also MOJAHEDIN, MUJAHEDDIN, MUJAHEDEEN, MUJAHEDIN, MUJAHIDEEN [n]\n",
  "MUJIK": "(Russian) a Russian peasant, also MOUJIK, MUZHIK, MUZJIK [n -S]\n",
  "MUJIKS": "MUJIK, (Russian) a Russian peasant, also MOUJIK, MUZHIK, MUZJIK [n]\n",
  "MUKHABARAT": "(in Middle Eastern countries) a secret police force [n -S]\n",
  "MUKHABARATS": "MUKHABARAT, (in Middle Eastern countries) a secret police force [n]\n",
  "MUKHTAR": "(Arabic) an Indian lawyer; a Turkish local government official, also MOOKTAR [n -S]\n",
  "MUKHTARS": "MUKHTAR, (Arabic) an Indian lawyer; a Turkish local government official, also MOOKTAR [n]\n",
  "MUKLUK": "(Inuit) a type of sealskin boot, also MUCKLUCK, MUCLUC [n -S]\n",
  "MUKLUKS": "MUKLUK, (Inuit) a type of sealskin boot, also MUCKLUCK, MUCLUC [n]\n",
  "MUKTUK": "(Inuit) whale skin used for food [n -S]\n",
  "MUKTUKS": "MUKTUK, (Inuit) whale skin used for food [n]\n",
  "MULATRESS": "a woman of mixed race having one Black and one White parent, also MULATTA, MULATTRESS [n -ES]\n",
  "MULATRESSES": "MULATRESS, a woman of mixed race having one Black and one White parent, also MULATTA, MULATTRESS [n]\n",
  "MULATTA": "(Spanish) the (female) offspring of a black person and a person of European descent, also MULATRESS, MULATTRESS [n -S]\n",
  "MULATTAS": "MULATTA, (Spanish) the (female) offspring of a black person and a person of European descent, also MULATRESS, MULATTRESS [n]\n",
  "MULATTO": "(Spanish) the offspring of one white and one black parent [n -ES or -S]\n",
  "MULATTOES": "MULATTO, (Spanish) the offspring of one white and one black parent [n]\n",
  "MULATTOS": "MULATTO, (Spanish) the offspring of one white and one black parent [n]\n",
  "MULATTRESS": "a female mulatto, also MULATRESS, MULATTA [n -ES]\n",
  "MULATTRESSES": "MULATTRESS, a female mulatto, also MULATRESS, MULATTA [n]\n",
  "MULBERRIES": "MULBERRY, any of various trees of the genus Morus, esp. Morus nigra, grown for its purple, succulent fruit [n]\n",
  "MULBERRY": "any of various trees of the genus Morus, esp. Morus nigra, grown for its purple, succulent fruit [n MULBERRIES]\n",
  "MULCH": "to provide with a protective coating for the soil, also MULSH [v MULCHED, MULCHING, MULCHES]\n",
  "MULCHED": "MULCH, to provide with a protective coating for the soil, also MULSH [v]\n",
  "MULCHES": "MULCH, to provide with a protective coating for the soil, also MULSH [v]\n",
  "MULCHING": "MULCH, to provide with a protective coating for the soil, also MULSH [v]\n",
  "MULCT": "to take money from, by taxation or by trickery [v -ED, -ING, -S]\n",
  "MULCTED": "MULCT, to take money from, by taxation or by trickery [v]\n",
  "MULCTING": "MULCT, to take money from, by taxation or by trickery [v]\n",
  "MULCTS": "MULCT, to take money from, by taxation or by trickery [v]\n",
  "MULE": "to strike a coin from dies belonging to two different issues as a coin [v MULED, MULING, MULES]\n",
  "MULED": "MULE, to strike a coin from dies belonging to two different issues as a coin [v]\n",
  "MULES": "(Australian) to perform the Mules operation on a sheep, removing anal wrinkles of a sheep to prevent flystrike [v -ED, -ING, -ES]\n",
  "MULESED": "MULES, (Australian) to perform the Mules operation on a sheep, removing anal wrinkles of a sheep to prevent flystrike [v]\n",
  "MULESES": "MULES, (Australian) to perform the Mules operation on a sheep, removing anal wrinkles of a sheep to prevent flystrike [v]\n",
  "MULESING": "(Australian) the practice of removing wool-bearing skin from around the tail of (esp. merino) sheep to prevent blowfly infestation [n -S]\n",
  "MULESINGS": "MULESING, (Australian) the practice of removing wool-bearing skin from around the tail of (esp. merino) sheep to prevent blowfly infestation [n]\n",
  "MULETA": "(Spanish) a small cape fixed to a stick used by a matador in a bullfight [n -S]\n",
  "MULETAS": "MULETA, (Spanish) a small cape fixed to a stick used by a matador in a bullfight [n]\n",
  "MULETEER": "a mule-driver [n -S]\n",
  "MULETEERS": "MULETEER, a mule-driver [n]\n",
  "MULEY": "a hornless cow, also MOOLEY, MOOLY, MULLEY [n -S]\n",
  "MULEYS": "MULEY, a hornless cow, also MOOLEY, MOOLY, MULLEY [n]\n",
  "MULGA": "(Native Australian) a kind of acacia found in arid regions of Australia [n -S]\n",
  "MULGAS": "MULGA, (Native Australian) a kind of acacia found in arid regions of Australia [n]\n",
  "MULIE": "a western North American deer [n -S]\n",
  "MULIEBRITIES": "MULIEBRITY, the state of being a woman; femininity [n]\n",
  "MULIEBRITY": "the state of being a woman; femininity [n MULIEBRITIES]\n",
  "MULIES": "MULIE, a western North American deer [n]\n",
  "MULING": "MULE, to strike a coin from dies belonging to two different issues as a coin [v]\n",
  "MULISH": "like a mule; stubborn [adj]\n",
  "MULISHLY": "MULISH, like a mule; stubborn [adv]\n",
  "MULISHNESS": "obstinacy [n -ES]\n",
  "MULISHNESSES": "MULISHNESS, obstinacy [n]\n",
  "MULL": "to ponder [v -ED, -ING, -S]\n",
  "MULLA": "(Arabic) a Muslim learned in theology and law, also MOLLA, MOLLAH, MOOLAH, MULLAH, MULLER [n -S]\n",
  "MULLAH": "(Arabic) a Muslim learned in theology and law, also MOLLA, MOLLAH, MOOLAH, MULLA [n -S] / to inflict a severe defeat upon, also MULLER [v -ED, -ING, -S]\n",
  "MULLAHED": "MULLAH, to inflict a severe defeat upon, also MULLER [v]\n",
  "MULLAHING": "MULLAH, to inflict a severe defeat upon, also MULLER [v]\n",
  "MULLAHISM": "the system of having mullahs [n -S]\n",
  "MULLAHISMS": "MULLAHISM, the system of having mullahs [n]\n",
  "MULLAHS": "MULLAH, to inflict a severe defeat upon, also MULLER [v]\n",
  "MULLARKIES": "MULLARKY, (US colloquial) absurd talk, nonsense, also MALARKEY, MALARKY [n]\n",
  "MULLARKY": "(US colloquial) absurd talk, nonsense, also MALARKEY, MALARKY [n MULLARKIES]\n",
  "MULLAS": "MULLA, (Arabic) a Muslim learned in theology and law, also MOLLA, MOLLAH, MOOLAH, MULLAH, MULLER [n]\n",
  "MULLED": "MULL, to ponder [v]\n",
  "MULLEIN": "a tall, stiff, yellow-flowered woolly plant of the Verbascum genus, also MULLEN [n -S]\n",
  "MULLEINS": "MULLEIN, a tall, stiff, yellow-flowered woolly plant of the Verbascum genus, also MULLEN [n]\n",
  "MULLEN": "a tall, stiff, yellow-flowered woolly plant of the Verbascum genus, also MULLEIN [n -S]\n",
  "MULLENS": "MULLEN, a tall, stiff, yellow-flowered woolly plant of the Verbascum genus, also MULLEIN [n]\n",
  "MULLER": "to inflict a severe defeat on, also MULLAH [v -ED, -ING, -S]\n",
  "MULLERED": "MULLER, to inflict a severe defeat on, also MULLAH [v]\n",
  "MULLERIAN": "of, relating to, or being mimicry that exists between two or more inedible or dangerous species (as of butterflies or bees) [adj]\n",
  "MULLERING": "MULLER, to inflict a severe defeat on, also MULLAH [v]\n",
  "MULLERS": "MULLER, to inflict a severe defeat on, also MULLAH [v]\n",
  "MULLET": "a kind of fish; a five-pointed star in heraldry [n -S]\n",
  "MULLETS": "MULLET, a kind of fish; a five-pointed star in heraldry [n]\n",
  "MULLEY": "a hornless cow, also MULEY, MOOLEY, MOOLY [n -S]\n",
  "MULLEYS": "MULLEY, a hornless cow, also MULEY, MOOLEY, MOOLY [n]\n",
  "MULLIGAN": "a stew of meat and vegetables [n -S]\n",
  "MULLIGANS": "MULLIGAN, a stew of meat and vegetables [n]\n",
  "MULLIGATAWNIES": "MULLIGATAWNY, (Tamil) an East Indian curry-soup [n]\n",
  "MULLIGATAWNY": "(Tamil) an East Indian curry-soup [n MULLIGATAWNIES]\n",
  "MULLIGRUBS": "(colloquial) grumpiness; colic; low spirits [n]\n",
  "MULLING": "MULL, to ponder [v]\n",
  "MULLION": "an upright division between window panes, also MUNNION [n -S] / to provide the upright division between the panes of a window [v -ED, -ING, -S]\n",
  "MULLIONED": "MULLION, to provide the upright division between the panes of a window [v]\n",
  "MULLIONING": "MULLION, to provide the upright division between the panes of a window [v]\n",
  "MULLIONS": "MULLION, to provide the upright division between the panes of a window [v]\n",
  "MULLITE": "an aluminium silicate used in refractory porcelains and bricks [n -S]\n",
  "MULLITES": "MULLITE, an aluminium silicate used in refractory porcelains and bricks [n]\n",
  "MULLOCK": "(Australian slang) waste earth or rock from a mine [n -S]\n",
  "MULLOCKIER": "MULLOCKY, (Australian slang) like mullock, waste earth or rock from a mine [adj]\n",
  "MULLOCKIEST": "MULLOCKY, (Australian slang) like mullock, waste earth or rock from a mine [adj]\n",
  "MULLOCKS": "MULLOCK, (Australian slang) waste earth or rock from a mine [n]\n",
  "MULLOCKY": "(Australian slang) like mullock, waste earth or rock from a mine [adj MULLOCKIER, MULLOCKIEST]\n",
  "MULLOWAY": "(Native Australian) a large Australian fish [n -S]\n",
  "MULLOWAYS": "MULLOWAY, (Native Australian) a large Australian fish [n]\n",
  "MULLS": "MULL, to ponder [v]\n",
  "MULMUL": "(Hindi) a fine, soft muslin, also MULMULL [n -S]\n",
  "MULMULL": "(Hindi) a fine, soft muslin, also MULMUL [n -S]\n",
  "MULMULLS": "MULMULL, (Hindi) a fine, soft muslin, also MULMUL [n]\n",
  "MULMULS": "MULMUL, (Hindi) a fine, soft muslin, also MULMULL [n]\n",
  "MULSE": "(obsolete) a drink of honey with wine or water [n -S]\n",
  "MULSES": "MULSE, (obsolete) a drink of honey with wine or water [n]\n",
  "MULSH": "loose material, strawy dung, etc., laid on the soil around plants, to protect roots [n -ES] / to cover with mulsh, also MULCH [v -ED, -ING, -ES]\n",
  "MULSHED": "MULSH, to cover with mulsh, also MULCH [v]\n",
  "MULSHES": "MULSH, to cover with mulsh, also MULCH [v]\n",
  "MULSHING": "MULSH, to cover with mulsh, also MULCH [v]\n",
  "MULTANGULAR": "having many angles, also MULTIANGULAR [adj]\n",
  "MULTANIMOUS": "having a many-sided mind [adj]\n",
  "MULTARTICULATE": "many-jointed, also MULTIARTICULATE [adj]\n",
  "MULTEITIES": "MULTEITY, manifoldness [n]\n",
  "MULTEITY": "manifoldness [n MULTEITIES]\n",
  "MULTIACCESS": "(relating to) a computer system that allows several users to access it at the same time [n -ES]\n",
  "MULTIACCESSES": "MULTIACCESS, (relating to) a computer system that allows several users to access it at the same time [n]\n",
  "MULTIAGE": "including people of various ages [adj]\n",
  "MULTIAGENCY": "related to many agencies [adj]\n",
  "MULTIANGULAR": "having many angles, also MULTANGULAR [adj]\n",
  "MULTIARMED": "having many arms [adj]\n",
  "MULTIARTICULATE": "many-jointed, also MULTARTICULATE [adj]\n",
  "MULTIATOM": "containing many atoms [adj]\n",
  "MULTIAUTHOR": "having many authors [adj]\n",
  "MULTIAXIAL": "having more than one axis [adj]\n",
  "MULTIBAND": "having many bands [adj]\n",
  "MULTIBANK": "comprising many banks [adj]\n",
  "MULTIBARREL": "a gun with many barrels [n -S]\n",
  "MULTIBARRELED": "of a gun, having many barrels, also MULTIBARRELLED [adj]\n",
  "MULTIBARRELLED": "of a gun, having many barrels, also MULTIBARRELED [adj]\n",
  "MULTIBARRELS": "MULTIBARREL, a gun with many barrels [n]\n",
  "MULTIBILLION": "comprising many billions [adj]\n",
  "MULTIBLADED": "having many blades [adj]\n",
  "MULTIBRANCHED": "having many branches [adj]\n",
  "MULTIBUILDING": "involving many buildings [adj]\n",
  "MULTICAMERATE": "having many chambers or cells [adj]\n",
  "MULTICAMPUS": "having many campuses [adj]\n",
  "MULTICAPITATE": "many-headed [adj]\n",
  "MULTICAR": "involving several cars [adj]\n",
  "MULTICARBON": "containing more than one kind of carbon [adj]\n",
  "MULTICAST": "a broadcast from one source simultaneously to several receivers [n -S]\n",
  "MULTICASTS": "MULTICAST, a broadcast from one source simultaneously to several receivers [n]\n",
  "MULTICAULINE": "having many stems [adj]\n",
  "MULTICAUSAL": "relating to more than one cause [adj]\n",
  "MULTICELL": "having or made up of many cells [adj]\n",
  "MULTICELLED": "having many cells [adj]\n",
  "MULTICELLULAR": "having many cells [adj]\n",
  "MULTICENTER": "involving more than one medical or research institution, also MULTICENTRE [adj]\n",
  "MULTICENTRAL": "having or proceeding from many centres, also MULTICENTRIC [adj]\n",
  "MULTICENTRE": "comprising or involving several centres, also MULTICENTER [adj]\n",
  "MULTICENTRIC": "having or proceeding from many centres, also MULTICENTRAL [adj]\n",
  "MULTICHAIN": "having many chains [adj]\n",
  "MULTICHAMBERED": "having many chambers [adj]\n",
  "MULTICHANNEL": "having many channels [adj]\n",
  "MULTICHARACTER": "having many characters [adj]\n",
  "MULTICIDE": "mass murder [n -S]\n",
  "MULTICIDES": "MULTICIDE, mass murder [n]\n",
  "MULTICIPITAL": "many-headed [adj]\n",
  "MULTICITY": "involving several cities [adj]\n",
  "MULTICLIENT": "having many clients [adj]\n",
  "MULTICOATED": "having many coats [adj]\n",
  "MULTICOLOR": "diversity or plurality of colour, also MULTICOLOUR [n -S]\n",
  "MULTICOLORED": "having many colors, also MULTICOLOURED [adj]\n",
  "MULTICOLORS": "MULTICOLOR, diversity or plurality of colour, also MULTICOLOUR [n]\n",
  "MULTICOLOUR": "diversity or plurality of colour, also MULTICOLOR [n -S]\n",
  "MULTICOLOURED": "having many colours, also MULTICOLORED [adj]\n",
  "MULTICOLOURS": "MULTICOLOUR, diversity or plurality of colour, also MULTICOLOR [n]\n",
  "MULTICOLUMN": "having many columns [adj]\n",
  "MULTICOMPONENT": "having many components [adj]\n",
  "MULTICONDUCTOR": "having many conductors [adj]\n",
  "MULTICOPIES": "MULTICOPY, any of several or many copies (of a book, document, record, etc.) [n]\n",
  "MULTICOPY": "any of several or many copies (of a book, document, record, etc.) [n MULTICOPIES]\n",
  "MULTICORE": "having, consisting of, or involving multiple cores [adj]\n",
  "MULTICOSTATE": "having many ribs [adj]\n",
  "MULTICOUNTY": "related to many counties [adj]\n",
  "MULTICOURSE": "having many courses [adj]\n",
  "MULTICULT": "(Canadian) multicultural [adj]\n",
  "MULTICULTI": "(short for) multiculturalism [n -S]\n",
  "MULTICULTIS": "MULTICULTI, (short for) multiculturalism [n]\n",
  "MULTICULTURAL": "of, relating to, or including several cultures [adj MULTICULTURALLY]\n",
  "MULTICULTURALLY": "MULTICULTURAL, of, relating to, or including several cultures [adv]\n",
  "MULTICURIE": "having many curies, units of radioactive decay and intensity [adj]\n",
  "MULTICURRENCIES": "MULTICURRENCY, the use of more than one currency [n]\n",
  "MULTICURRENCY": "the use of more than one currency [n MULTICURRENCIES]\n",
  "MULTICUSPID": "having more than two cusps, also MULTICUSPIDATE [adj] / a multicuspid tooth [n -S]\n",
  "MULTICUSPIDATE": "having two or more cusps, also MULTICUSPID [adj]\n",
  "MULTICUSPIDS": "MULTICUSPID, a multicuspid tooth [n]\n",
  "MULTICYCLE": "(obsolete) a velocipede with more than three wheels [n -S]\n",
  "MULTICYCLES": "MULTICYCLE, (obsolete) a velocipede with more than three wheels [n]\n",
  "MULTICYLINDER": "of an engine, having many cylinders [adj]\n",
  "MULTIDAY": "lasting for more than one day [adj]\n",
  "MULTIDENTATE": "having many teeth [adj]\n",
  "MULTIDIALECTAL": "having many dialects [adj]\n",
  "MULTIDIGITATE": "having many digits [adj]\n",
  "MULTIDISC": "involving more than one disc [adj]\n",
  "MULTIDISCIPLINE": "comprising many disciplines [adj]\n",
  "MULTIDISK": "using, holding, or involving multiple disks and especially optical disks [adj]\n",
  "MULTIDIVISIONAL": "comprising many divisions [adj]\n",
  "MULTIDOMAIN": "having many domains [adj]\n",
  "MULTIDRUG": "involving many different drugs [adj]\n",
  "MULTIELECTRODE": "having many electrodes [adj]\n",
  "MULTIELEMENT": "having many elements [adj]\n",
  "MULTIEMPLOYER": "one who employs many workers [n -S]\n",
  "MULTIEMPLOYERS": "MULTIEMPLOYER, one who employs many workers [n]\n",
  "MULTIENGINE": "having many engines, also MULTIENGINED [adj]\n",
  "MULTIENGINED": "having many engines, also MULTIENGINE [adj]\n",
  "MULTIENZYME": "composed of or involving two or more enzymes that function in a biosynthetic pathway [adj]\n",
  "MULTIETHNIC": "belonging to more than one ethnic group [adj] / someone belonging to more than one ethnic group [n -S]\n",
  "MULTIETHNICS": "MULTIETHNIC, someone belonging to more than one ethnic group [n]\n",
  "MULTIFACED": "having many faces [adj]\n",
  "MULTIFACETED": "having many facets or aspects [adj]\n",
  "MULTIFACTOR": "having many factors [adj]\n",
  "MULTIFACTORIAL": "having characters or a mode of inheritance dependent on a number of genes at different loci [adj]\n",
  "MULTIFAMILIES": "MULTIFAMILY, a building designed to house several families [n]\n",
  "MULTIFAMILY": "a building designed to house several families [n MULTIFAMILIES]\n",
  "MULTIFARIOUS": "having great diversity; manifold [adj MULTIFARIOUSLY]\n",
  "MULTIFARIOUSLY": "MULTIFARIOUS, having great diversity; manifold [adv]\n",
  "MULTIFID": "having many divisions, also MULTIFIDOUS [adj MULTIFIDLY]\n",
  "MULTIFIDLY": "MULTIFID, having many divisions, also MULTIFIDOUS [adv]\n",
  "MULTIFIDOUS": "having many divisions, also MULTIFID [adj]\n",
  "MULTIFIL": "a multiple strand of synthetic fibre [n -S]\n",
  "MULTIFILAMENT": "something containing many filaments [n -S]\n",
  "MULTIFILAMENTS": "MULTIFILAMENT, something containing many filaments [n]\n",
  "MULTIFILS": "MULTIFIL, a multiple strand of synthetic fibre [n]\n",
  "MULTIFLASH": "with many flashes [adj]\n",
  "MULTIFLORA": "a type of climbing rose having clusters of small flowers [n -S]\n",
  "MULTIFLORAS": "MULTIFLORA, a type of climbing rose having clusters of small flowers [n]\n",
  "MULTIFLOROUS": "many-flowered [adj]\n",
  "MULTIFOCAL": "of spectacles, having several different focal lengths [adj]\n",
  "MULTIFOCALS": "multifocal spectacles [n]\n",
  "MULTIFOIL": "an ornamental foliation consisting of more than five divisions or foils [n -S]\n",
  "MULTIFOILS": "MULTIFOIL, an ornamental foliation consisting of more than five divisions or foils [n]\n",
  "MULTIFOLD": "many times doubled; manifold [adj]\n",
  "MULTIFOLIATE": "having many leaves [adj]\n",
  "MULTIFOLIOLATE": "having many folioles [adj]\n",
  "MULTIFORM": "a multiform object; something exhibiting many and various forms [n -S]\n",
  "MULTIFORMITIES": "MULTIFORMITY, the state of being multiform [n]\n",
  "MULTIFORMITY": "the state of being multiform [n MULTIFORMITIES]\n",
  "MULTIFORMS": "MULTIFORM, a multiform object; something exhibiting many and various forms [n]\n",
  "MULTIFREQUENCY": "having many frequencies [adj]\n",
  "MULTIFUNCTION": "having many functions, also MULTIFUNCTIONAL [adj]\n",
  "MULTIFUNCTIONAL": "having many functions, also MULTIFUNCTION [adj]\n",
  "MULTIGENE": "each of a group of genes with closely related nucleotide sequences, apparently evolved from a common ancestor sequence and often having similar or related functions [n -S]\n",
  "MULTIGENES": "MULTIGENE, each of a group of genes with closely related nucleotide sequences, apparently evolved from a common ancestor sequence and often having similar or related functions [n]\n",
  "MULTIGENIC": "having many genes [adj]\n",
  "MULTIGERM": "producing or being a fruit cluster capable of giving rise to several plants [adj]\n",
  "MULTIGRADE": "a brand of black and white photographic paper coated with a mixture of emulsions which are sensitive to the colour of the printing light used and which produce different contrast grades as a result [n -S]\n",
  "MULTIGRADES": "MULTIGRADE, a brand of black and white photographic paper coated with a mixture of emulsions which are sensitive to the colour of the printing light used and which produce different contrast grades as a result [n]\n",
  "MULTIGRAIN": "comprising many types of grain [adj]\n",
  "MULTIGRAVIDA": "a woman pregnant for at least the third time [n MULTIGRAVIDAS or MULTIGRAVIDAE]\n",
  "MULTIGRAVIDAE": "MULTIGRAVIDA, a woman pregnant for at least the third time [n]\n",
  "MULTIGRAVIDAS": "MULTIGRAVIDA, a woman pregnant for at least the third time [n]\n",
  "MULTIGRID": "comprising many grids [adj]\n",
  "MULTIGROUP": "comprising many groups [adj]\n",
  "MULTIGYM": "an apparatus designed for various exercises [n -S]\n",
  "MULTIGYMS": "MULTIGYM, an apparatus designed for various exercises [n]\n",
  "MULTIHEADED": "having many heads [adj]\n",
  "MULTIHOSPITAL": "relating to many hospitals [adj]\n",
  "MULTIHUED": "with many hues [adj]\n",
  "MULTIHULL": "a boat having more than one hull, e.g. a catamaran [n -S]\n",
  "MULTIHULLS": "MULTIHULL, a boat having more than one hull, e.g. a catamaran [n]\n",
  "MULTIJET": "having more than two jets [adj]\n",
  "MULTIJUGATE": "consisting of many pairs of leaflets, also MULTIJUGOUS [adj]\n",
  "MULTIJUGOUS": "consisting of many pairs of leaflets, also MULTIJUGATE [adj]\n",
  "MULTILANE": "having several lanes [adj] / a highway having several lanes [n -S]\n",
  "MULTILANES": "MULTILANE, a highway having several lanes [n]\n",
  "MULTILATERAL": "having many sides [adj MULTILATERALLY]\n",
  "MULTILATERALISM": "the state of being multilateral, having many sides [n]\n",
  "MULTILATERALIST": "a supporter of multilateralism [n]\n",
  "MULTILATERALLY": "MULTILATERAL, having many sides [adv]\n",
  "MULTILAYER": "any structure or system with several layers [n -S]\n",
  "MULTILAYERED": "having or involving several distinct layers, strata, or levels [adj]\n",
  "MULTILAYERS": "MULTILAYER, any structure or system with several layers [n]\n",
  "MULTILEVEL": "having many levels, also MULTILEVELED, MULTILEVELLED [adj]\n",
  "MULTILEVELED": "having many levels, also MULTILEVEL, MULTILEVELLED [adj]\n",
  "MULTILEVELLED": "having many levels, also MULTILEVEL, MULTILEVELED [adj]\n",
  "MULTILINE": "a variety of crop with several lines, each having different genes to improve disease resistance [n -S]\n",
  "MULTILINEAL": "having many lines, also MULTILINEAR [adj]\n",
  "MULTILINEAR": "having many lines, also MULTILINEAL [adj]\n",
  "MULTILINES": "MULTILINE, a variety of crop with several lines, each having different genes to improve disease resistance [n]\n",
  "MULTILINGUAL": "of, having, or expressed in several languages [adj MULTILINGUALLY]\n",
  "MULTILINGUALISM": "the state of being multilingual [n]\n",
  "MULTILINGUALLY": "MULTILINGUAL, of, having, or expressed in several languages [adv]\n",
  "MULTILINGUIST": "a speaker of many languages [n -S]\n",
  "MULTILINGUISTS": "MULTILINGUIST, a speaker of many languages [n]\n",
  "MULTILOBATE": "having many lobes [adj]\n",
  "MULTILOBE": "having more than one lobe [adj] / something with more than one lobe [n -S]\n",
  "MULTILOBED": "having many lobes [adj]\n",
  "MULTILOBES": "MULTILOBE, something with more than one lobe [n]\n",
  "MULTILOBULAR": "having many lobules, also MULTILOBULATE [adj]\n",
  "MULTILOBULATE": "having many lobules, also MULTILOBULAR [adj]\n",
  "MULTILOCATIONAL": "existing or operating in several locations [adj]\n",
  "MULTILOCULAR": "many-chambered, also MULTILOCULATE [adj]\n",
  "MULTILOCULATE": "many-chambered, also MULTILOCULAR [adj]\n",
  "MULTILOQUENCE": "much speaking [n -S]\n",
  "MULTILOQUENCES": "MULTILOQUENCE, much speaking [n]\n",
  "MULTILOQUENT": "talkative; garrulous [adj]\n",
  "MULTILOQUIES": "MULTILOQUY, excess of words or talk [n]\n",
  "MULTILOQUOUS": "given to much speaking [adj]\n",
  "MULTILOQUY": "excess of words or talk [n MULTILOQUIES]\n",
  "MULTIMANNED": "of a spacecraft, space mission, etc., manned by more than one person [adj]\n",
  "MULTIMEDIA": "a technique (as the combining of sound, video, and text) for expressing ideas (as in communication, entertainment, or art) in which several media are employed [n -S]\n",
  "MULTIMEDIAS": "MULTIMEDIA, a technique (as the combining of sound, video, and text) for expressing ideas (as in communication, entertainment, or art) in which several media are employed [n]\n",
  "MULTIMEGATON": "having an explosive power of many megatons [adj]\n",
  "MULTIMEGAWATT": "many megawatts [n -S]\n",
  "MULTIMEGAWATTS": "MULTIMEGAWATT, many megawatts [n]\n",
  "MULTIMEMBER": "having many members [adj]\n",
  "MULTIMETALLIC": "made of several metals [adj]\n",
  "MULTIMETER": "an instrument allowing simultaneous measurement of several values [n -S]\n",
  "MULTIMETERS": "MULTIMETER, an instrument allowing simultaneous measurement of several values [n]\n",
  "MULTIMILLENNIAL": "extending over several millennia [adj]\n",
  "MULTIMILLION": "comprising many millions [adj]\n",
  "MULTIMODAL": "in many modes [adj]\n",
  "MULTIMODE": "an SLR camera or its light meter with more than one way of setting the exposure [n -S]\n",
  "MULTIMODES": "MULTIMODE, an SLR camera or its light meter with more than one way of setting the exposure [n]\n",
  "MULTIMOLECULAR": "comprising many molecules [adj]\n",
  "MULTINATION": "related to many nations [adj]\n",
  "MULTINATIONAL": "a large business company which operates in several countries [n -S]\n",
  "MULTINATIONALS": "MULTINATIONAL, a large business company which operates in several countries [n]\n",
  "MULTINOMIAL": "a mathematical expression that consists of the sum of several terms [n -S]\n",
  "MULTINOMIALS": "MULTINOMIAL, a mathematical expression that consists of the sum of several terms [n]\n",
  "MULTINOMINAL": "having many names [adj]\n",
  "MULTINUCLEAR": "having many nuclei [adj]\n",
  "MULTINUCLEATE": "having many nuclei, also MULTINUCLEATED [adj]\n",
  "MULTINUCLEATED": "having many nuclei, also MULTINUCLEATE [adj]\n",
  "MULTINUCLEOLAR": "having many nucleoles [adj]\n",
  "MULTINUCLEOLATE": "having several nucleoli [adj]\n",
  "MULTIORGASMIC": "experiencing more than one orgasm [adj]\n",
  "MULTIPACK": "a pack containing several of a given item, usually at a reduced price [n -S]\n",
  "MULTIPACKS": "MULTIPACK, a pack containing several of a given item, usually at a reduced price [n]\n",
  "MULTIPAGE": "having many pages [adj]\n",
  "MULTIPANED": "having many panes [adj]\n",
  "MULTIPARA": "a mother of two or more children, also PLURIPARA [n MULTIPARAE or MULTIPARAS]\n",
  "MULTIPARAE": "MULTIPARA, a mother of two or more children, also PLURIPARA [n]\n",
  "MULTIPARAMETER": "featuring many parameters [adj]\n",
  "MULTIPARAS": "MULTIPARA, a mother of two or more children, also PLURIPARA [n]\n",
  "MULTIPARITIES": "MULTIPARITY, the state of being a multipara, giving birth to two or more offspring [n]\n",
  "MULTIPARITY": "the state of being a multipara, giving birth to two or more offspring [n MULTIPARITIES]\n",
  "MULTIPAROUS": "having given birth to multiple children [adj]\n",
  "MULTIPART": "having many parts [adj]\n",
  "MULTIPARTICLE": "comprising many particles [adj]\n",
  "MULTIPARTITE": "divided into several or many parts [adj]\n",
  "MULTIPARTY": "comprising many parties [adj]\n",
  "MULTIPARTYISM": "the state of being multiparty [n -S]\n",
  "MULTIPARTYISMS": "MULTIPARTYISM, the state of being multiparty [n]\n",
  "MULTIPATH": "comprising many paths [adj]\n",
  "MULTIPED": "an insect having many feet, as a myriapod, also MULTIPEDE [n -S]\n",
  "MULTIPEDE": "an insect having many feet, as a myriapod, also MULTIPED [n -S]\n",
  "MULTIPEDES": "MULTIPEDE, an insect having many feet, as a myriapod, also MULTIPED [n]\n",
  "MULTIPEDS": "MULTIPED, an insect having many feet, as a myriapod, also MULTIPEDE [n]\n",
  "MULTIPHASE": "having many phases [adj]\n",
  "MULTIPHASIC": "having many phases [adj]\n",
  "MULTIPHOTON": "having many photons [adj]\n",
  "MULTIPICTURE": "featuring many pictures [adj]\n",
  "MULTIPIECE": "having many pieces [adj]\n",
  "MULTIPION": "comprising many pions, pi-meson particles [adj]\n",
  "MULTIPISTON": "having many pistons [adj]\n",
  "MULTIPLANE": "an aeroplane with more than two sets of supporting planes [n -S]\n",
  "MULTIPLANES": "MULTIPLANE, an aeroplane with more than two sets of supporting planes [n]\n",
  "MULTIPLANT": "consisting of many plants [adj]\n",
  "MULTIPLAYER": "having many players [adj] / a multiplayer game [n -S]\n",
  "MULTIPLAYERS": "MULTIPLAYER, a multiplayer game [n]\n",
  "MULTIPLE": "the product of a quantity by an integer [n -S]\n",
  "MULTIPLES": "MULTIPLE, the product of a quantity by an integer [n]\n",
  "MULTIPLET": "a group of elementary particles whose members differ only in electric charge [n -S]\n",
  "MULTIPLETS": "MULTIPLET, a group of elementary particles whose members differ only in electric charge [n]\n",
  "MULTIPLEX": "to incorporate into a multiplex signal or system [v -ED, -ING, -ES]\n",
  "MULTIPLEXED": "MULTIPLEX, to incorporate into a multiplex signal or system [v]\n",
  "MULTIPLEXER": "a device enabling a computer to transmit data to many terminals by switching quickly from one user's data to another, also MULTIPLEXOR [n -S]\n",
  "MULTIPLEXERS": "MULTIPLEXER, a device enabling a computer to transmit data to many terminals by switching quickly from one user's data to another, also MULTIPLEXOR [n]\n",
  "MULTIPLEXES": "MULTIPLEX, to incorporate into a multiplex signal or system [v]\n",
  "MULTIPLEXING": "the act of incorporating into a multiplex signal [n -S]\n",
  "MULTIPLEXINGS": "MULTIPLEXING, the act of incorporating into a multiplex signal [n]\n",
  "MULTIPLEXOR": "a device enabling a computer to transmit data to many terminals by switching quickly from one user's data to another, also MULTIPLEXER [n -S]\n",
  "MULTIPLEXORS": "MULTIPLEXOR, a device enabling a computer to transmit data to many terminals by switching quickly from one user's data to another, also MULTIPLEXER [n]\n",
  "MULTIPLIABLE": "that can be multiplied, also MULTIPLICABLE [adj]\n",
  "MULTIPLICABLE": "that can be multiplied, also MULTIPLIABLE [adj]\n",
  "MULTIPLICAND": "a number or amount to be multiplied [n -S]\n",
  "MULTIPLICANDS": "MULTIPLICAND, a number or amount to be multiplied [n]\n",
  "MULTIPLICATE": "the condition of being in many copies [n -S]\n",
  "MULTIPLICATES": "MULTIPLICATE, the condition of being in many copies [n]\n",
  "MULTIPLICATION": "the act of multiplying [n -S]\n",
  "MULTIPLICATIONS": "MULTIPLICATION, the act of multiplying [n]\n",
  "MULTIPLICATIVE": "tending or having the power to multiply [adj]\n",
  "MULTIPLICATOR": "a multiplier [n -S]\n",
  "MULTIPLICATORS": "MULTIPLICATOR, a multiplier [n]\n",
  "MULTIPLICITIES": "MULTIPLICITY, the state of being multiple [n]\n",
  "MULTIPLICITY": "the state of being multiple [n MULTIPLICITIES]\n",
  "MULTIPLIED": "MULTIPLY, to increase in number [v]\n",
  "MULTIPLIER": "one who multiplies [n -S]\n",
  "MULTIPLIERS": "MULTIPLIER, one who multiplies [n]\n",
  "MULTIPLIES": "MULTIPLY, to increase in number [v]\n",
  "MULTIPLY": "to increase in number [v MULTIPLIED, MULTIPLYING, MULTIPLIES]\n",
  "MULTIPLYING": "MULTIPLY, to increase in number [v]\n",
  "MULTIPOINT": "having, serving, or occupying many points or locations; spec. designating a water heater serving a number of hot-water taps [adj]\n",
  "MULTIPOLAR": "having many poles, e.g. of nerve cells [adj]\n",
  "MULTIPOLARITIES": "MULTIPOLARITY, the state of being multipolar [n]\n",
  "MULTIPOLARITY": "the state of being multipolar [n MULTIPOLARITIES]\n",
  "MULTIPOLE": "having many poles [adj] / something with many poles [n -S]\n",
  "MULTIPOLES": "MULTIPOLE, something with many poles [n]\n",
  "MULTIPORT": "involving more than one port [adj]\n",
  "MULTIPOTENT": "(Shakespeare) having the power to do many things [adj]\n",
  "MULTIPOTENTIAL": "having the potential of becoming any of several mature cell types [adj]\n",
  "MULTIPOWER": "having many powers [adj]\n",
  "MULTIPRESENCE": "the power of being in many places at once [n -S]\n",
  "MULTIPRESENCES": "MULTIPRESENCE, the power of being in many places at once [n]\n",
  "MULTIPRESENT": "being in many places at once [adj]\n",
  "MULTIPROBLEM": "featuring many problems [adj]\n",
  "MULTIPROCESSING": "the processing of several computer programs at the same time esp. by a computer system with two or more processors sharing a single memory [n]\n",
  "MULTIPROCESSOR": "a type of computer [n -S]\n",
  "MULTIPROCESSORS": "MULTIPROCESSOR, a type of computer [n]\n",
  "MULTIPRODUCT": "featuring many products [adj]\n",
  "MULTIPRONGED": "having several prongs [adj]\n",
  "MULTIPURPOSE": "having many purposes [adj]\n",
  "MULTIRACIAL": "made up of various races [adj MULTIRACIALLY]\n",
  "MULTIRACIALISM": "the state of being multiracial [n -S]\n",
  "MULTIRACIALISMS": "MULTIRACIALISM, the state of being multiracial [n]\n",
  "MULTIRACIALLY": "MULTIRACIAL, made up of various races [adv]\n",
  "MULTIRAMIFIED": "having many branches [adj]\n",
  "MULTIRANGE": "having many ranges [adj]\n",
  "MULTIREGIONAL": "extending over many regions [adj]\n",
  "MULTIRELIGIOUS": "comprising many religions [adj]\n",
  "MULTIRISK": "(of insurance) covering several risks [adj]\n",
  "MULTIROLE": "having a number of roles [adj]\n",
  "MULTIROOM": "having many rooms [adj]\n",
  "MULTIROOMED": "having many rooms [adj]\n",
  "MULTISCIENCE": "knowledge of many things [n -S]\n",
  "MULTISCIENCES": "MULTISCIENCE, knowledge of many things [n]\n",
  "MULTISCREEN": "a cinema with several screens [n -S]\n",
  "MULTISCREENS": "MULTISCREEN, a cinema with several screens [n]\n",
  "MULTISENSE": "having many senses [adj]\n",
  "MULTISENSORY": "relating to or involving several physiological senses [adj]\n",
  "MULTISEPTATE": "having many septa [adj]\n",
  "MULTISERIAL": "arranged in many rows, also MULTISERIATE [adj]\n",
  "MULTISERIATE": "arranged in many rows, also MULTISERIAL [adj]\n",
  "MULTISERVICE": "involving or serving more than one of the armed services [adj]\n",
  "MULTISIDED": "having many sides [adj]\n",
  "MULTISITE": "having many sites [adj]\n",
  "MULTISIZE": "coming in many sizes [adj]\n",
  "MULTISKILL": "to train (employees) in several skills [v -ED, -ING, -S]\n",
  "MULTISKILLED": "MULTISKILL, to train (employees) in several skills [v]\n",
  "MULTISKILLING": "in technologically advanced industries, the training of employees in a variety of skills [n -S]\n",
  "MULTISKILLINGS": "MULTISKILLING, in technologically advanced industries, the training of employees in a variety of skills [n]\n",
  "MULTISKILLS": "MULTISKILL, to train (employees) in several skills [v]\n",
  "MULTISONANT": "producing many or very loud sounds [adj]\n",
  "MULTISOURCE": "having many sources [adj]\n",
  "MULTISPECIES": "comprising many species [adj]\n",
  "MULTISPECTRAL": "of or relating to two or more ranges of frequencies or wavelengths in the electromagnetic spectrum [adj]\n",
  "MULTISPEED": "of e.g. a bicycle, having many gears [adj]\n",
  "MULTISPIRAL": "having many coils [adj]\n",
  "MULTISPORT": "catering for many sports [adj]\n",
  "MULTISTAGE": "having many stages [adj]\n",
  "MULTISTANDARD": "in electronics, able to process signals from several different systems [adj]\n",
  "MULTISTATE": "extending over, relating to, or involving a number of the states of a union, federation [adj]\n",
  "MULTISTEMMED": "having many stems [adj]\n",
  "MULTISTEP": "having many steps [adj]\n",
  "MULTISTOREY": "having many stories [adj] / a multistorey car park [n -S]\n",
  "MULTISTOREYS": "MULTISTOREY, a multistorey car park [n]\n",
  "MULTISTORIED": "having many storeys [adj]\n",
  "MULTISTORIES": "MULTISTORY, a multistory car park [n]\n",
  "MULTISTORY": "a multistory car park [n MULTISTORIES]\n",
  "MULTISTRANDED": "having many strands [adj]\n",
  "MULTISTRIKE": "an ink ribbon for use on an electronic typewriter or printer which is struck by keys at different points vertically, often used to produce bold print [n -S]\n",
  "MULTISTRIKES": "MULTISTRIKE, an ink ribbon for use on an electronic typewriter or printer which is struck by keys at different points vertically, often used to produce bold print [n]\n",
  "MULTISULCATE": "many-furrowed [adj]\n",
  "MULTISYLLABIC": "having many syllables [adj]\n",
  "MULTISYSTEM": "related to more than one system [adj]\n",
  "MULTITALENTED": "having many talents [adj]\n",
  "MULTITASK": "to work at several different tasks simultaneously [v -ED, -ING, -S]\n",
  "MULTITASKED": "MULTITASK, to work at several different tasks simultaneously [v]\n",
  "MULTITASKING": "the action of running several processes or jobs simultaneously on a system [n -S]\n",
  "MULTITASKINGS": "MULTITASKING, the action of running several processes or jobs simultaneously on a system [n]\n",
  "MULTITASKS": "MULTITASK, to work at several different tasks simultaneously [v]\n",
  "MULTITERMINAL": "comprising many terminals [adj]\n",
  "MULTITHREADING": "a programming system that enables actions to be carried out simultaneously [n -S]\n",
  "MULTITHREADINGS": "MULTITHREADING, a programming system that enables actions to be carried out simultaneously [n]\n",
  "MULTITIER": "having many tiers [adj]\n",
  "MULTITIERED": "having more than one tier [adj]\n",
  "MULTITON": "weighing many tons [adj]\n",
  "MULTITONE": "having many tones [adj] / a multitone sound [n -S]\n",
  "MULTITONED": "having many tones [adj]\n",
  "MULTITONES": "MULTITONE, a multitone sound [n]\n",
  "MULTITOOL": "a device that contains various tools attached to a single handle [n -S]\n",
  "MULTITOOLS": "MULTITOOL, a device that contains various tools attached to a single handle [n]\n",
  "MULTITOWERED": "having many towers [adj]\n",
  "MULTITRACK": "to make a recording using many tracks [v -ED, -ING, -S]\n",
  "MULTITRACKED": "MULTITRACK, to make a recording using many tracks [v]\n",
  "MULTITRACKING": "MULTITRACK, to make a recording using many tracks [v]\n",
  "MULTITRACKS": "MULTITRACK, to make a recording using many tracks [v]\n",
  "MULTITRILLION": "a number or amount equal to several trillion [n -S]\n",
  "MULTITRILLIONS": "MULTITRILLION, a number or amount equal to several trillion [n]\n",
  "MULTITUDE": "a great number of persons collected together [n -S]\n",
  "MULTITUDES": "MULTITUDE, a great number of persons collected together [n]\n",
  "MULTITUDINARY": "of or like a multitude [adj]\n",
  "MULTITUDINOUS": "existing in a great multitude [adj MULTITUDINOUSLY]\n",
  "MULTITUDINOUSLY": "MULTITUDINOUS, existing in a great multitude [adv]\n",
  "MULTIUNION": "comprising many unions [adj]\n",
  "MULTIUNIT": "having many units [adj]\n",
  "MULTIUSE": "having many uses [adj]\n",
  "MULTIUSER": "able to be used by many users at once [adj]\n",
  "MULTIUTILITIES": "MULTIUTILITY, a public utility that provides more than one essential service, such as gas and electricity [n]\n",
  "MULTIUTILITY": "a public utility that provides more than one essential service, such as gas and electricity [n MULTIUTILITIES]\n",
  "MULTIVALENCE": "the state of being multivalent, also MULTIVALENCY [n -S]\n",
  "MULTIVALENCES": "MULTIVALENCE, the state of being multivalent, also MULTIVALENCY [n]\n",
  "MULTIVALENCIES": "MULTIVALENCY, the state of being multivalent, also MULTIVALENCE [n]\n",
  "MULTIVALENCY": "the state of being multivalent, also MULTIVALENCE [n MULTIVALENCIES]\n",
  "MULTIVALENT": "having multiple valency, also POLYVALENT [adj] / a compound with multiple valency [n -S]\n",
  "MULTIVALENTS": "MULTIVALENT, a compound with multiple valency [n]\n",
  "MULTIVARIABLE": "containing, involving, or dependent on more than one variable [adj]\n",
  "MULTIVARIATE": "having or involving a number of independent mathematical or statistical variables [adj]\n",
  "MULTIVARIOUS": "differing widely [adj]\n",
  "MULTIVERSE": "the sum of all universes [n -S]\n",
  "MULTIVERSES": "MULTIVERSE, the sum of all universes [n]\n",
  "MULTIVERSITIES": "MULTIVERSITY, a major university [n]\n",
  "MULTIVERSITY": "a major university [n MULTIVERSITIES]\n",
  "MULTIVIBRATOR": "an electronic oscillating device using two transistors, the output of one providing the input of the other [n -S]\n",
  "MULTIVIBRATORS": "MULTIVIBRATOR, an electronic oscillating device using two transistors, the output of one providing the input of the other [n]\n",
  "MULTIVIOUS": "leading in many directions; offering many different paths [adj]\n",
  "MULTIVITAMIN": "a pill containing several vitamins [n -S]\n",
  "MULTIVITAMINS": "MULTIVITAMIN, a pill containing several vitamins [n]\n",
  "MULTIVOCAL": "a word with many meanings [n -S]\n",
  "MULTIVOCALS": "MULTIVOCAL, a word with many meanings [n]\n",
  "MULTIVOLTINE": "having several broods in one season [adj]\n",
  "MULTIVOLUME": "comprising more than one volume [adj]\n",
  "MULTIWALL": "made of three or more layers of special paper [adj]\n",
  "MULTIWARHEAD": "having many warheads [adj]\n",
  "MULTIWAVELENGTH": "extending over many wavelengths [adj]\n",
  "MULTIWAY": "having several paths or routes [adj]\n",
  "MULTIWINDOW": "having many windows [adj] / a multiwindow television set or monitor [n -S]\n",
  "MULTIWINDOWS": "MULTIWINDOW, a multiwindow television set or monitor [n]\n",
  "MULTIYEAR": "lasting many years [adj]\n",
  "MULTOCULAR": "having many eyes, or more than two [adj]\n",
  "MULTUM": "(Latin) an extract of quassia licorice, fraudulently used by brewers in order to economize malt and hops [n -S]\n",
  "MULTUMS": "MULTUM, (Latin) an extract of quassia licorice, fraudulently used by brewers in order to economize malt and hops [n]\n",
  "MULTUNGULATE": "having the hoof divided into more than two parts [adj] / a multungulate animal [n -S]\n",
  "MULTUNGULATES": "MULTUNGULATE, a multungulate animal [n]\n",
  "MULTURE": "to take a fee for grinding grain, also MOUTER [v MULTURED, MULTURING, MULTURES]\n",
  "MULTURED": "MULTURE, to take a fee for grinding grain, also MOUTER [v]\n",
  "MULTURER": "a person who pays or receives multure, a miller's fee for grinding corn, also MOUTERER [n -S]\n",
  "MULTURERS": "MULTURER, a person who pays or receives multure, a miller's fee for grinding corn, also MOUTERER [n]\n",
  "MULTURES": "MULTURE, to take a fee for grinding grain, also MOUTER [v]\n",
  "MULTURING": "MULTURE, to take a fee for grinding grain, also MOUTER [v]\n",
  "MUM": "to act in a disguise, also MUMM [v MUMMED, MUMMING, MUMS]\n",
  "MUMBLE": "to speak indistinctly [v MUMBLED, MUMBLING, MUMBLES]\n",
  "MUMBLED": "MUMBLE, to speak indistinctly [v]\n",
  "MUMBLEMENT": "(Carlyle) mumbling speech [n -S]\n",
  "MUMBLEMENTS": "MUMBLEMENT, (Carlyle) mumbling speech [n]\n",
  "MUMBLER": "one who mumbles [n -S]\n",
  "MUMBLERS": "MUMBLER, one who mumbles [n]\n",
  "MUMBLES": "MUMBLE, to speak indistinctly [v]\n",
  "MUMBLETYPEG": "a game of throwing knives to make them stick in the ground [n -S]\n",
  "MUMBLETYPEGS": "MUMBLETYPEG, a game of throwing knives to make them stick in the ground [n]\n",
  "MUMBLIER": "MUMBLY, given to mumbling [adj]\n",
  "MUMBLIEST": "MUMBLY, given to mumbling [adj]\n",
  "MUMBLING": "making a mumbling sound [adj MUMBLINGLY] / the act of mumbling [n -S]\n",
  "MUMBLINGLY": "MUMBLING, making a mumbling sound [adv]\n",
  "MUMBLINGS": "MUMBLING, the act of mumbling [n]\n",
  "MUMBLY": "given to mumbling [adj MUMBLIER, MUMBLIEST]\n",
  "MUMCHANCE": "a silent game with cards or dice [n -S]\n",
  "MUMCHANCES": "MUMCHANCE, a silent game with cards or dice [n]\n",
  "MUMM": "to act in a disguise, also MUM [v -ED, -ING, -S]\n",
  "MUMMED": "MUMM, to act in a disguise, also MUM [v]\n",
  "MUMMER": "to take part in mumming activities [v -ED, -ING, -S]\n",
  "MUMMERED": "MUMMER, to take part in mumming activities [v]\n",
  "MUMMERIES": "MUMMERY, a performance by mummers [n]\n",
  "MUMMERING": "a Christmas time house-visiting tradition still practiced in Newfoundland and Labrador [n -S]\n",
  "MUMMERINGS": "MUMMERING, a Christmas time house-visiting tradition still practiced in Newfoundland and Labrador [n]\n",
  "MUMMERS": "MUMMER, to take part in mumming activities [v]\n",
  "MUMMERY": "a performance by mummers [n MUMMERIES]\n",
  "MUMMIA": "(Latin) mummy as a drug or source of pigment [n -S]\n",
  "MUMMIAS": "MUMMIA, (Latin) mummy as a drug or source of pigment [n]\n",
  "MUMMICHOG": "(Native American) any one of several species of small American cyprinodont fishes, aka killifish [n -S]\n",
  "MUMMICHOGS": "MUMMICHOG, (Native American) any one of several species of small American cyprinodont fishes, aka killifish [n]\n",
  "MUMMIED": "MUMMY, to preserve by embalming, also MUMMIFY [v]\n",
  "MUMMIES": "MUMMY, to preserve by embalming, also MUMMIFY [v]\n",
  "MUMMIFICATION": "the act of mummifying [n -S]\n",
  "MUMMIFICATIONS": "MUMMIFICATION, the act of mummifying [n]\n",
  "MUMMIFIED": "MUMMIFY, to preserve by embalming, also MUMMY [v]\n",
  "MUMMIFIES": "MUMMIFY, to preserve by embalming, also MUMMY [v]\n",
  "MUMMIFORM": "a sarcophagus [n -S]\n",
  "MUMMIFORMS": "MUMMIFORM, a sarcophagus [n]\n",
  "MUMMIFY": "to preserve by embalming, also MUMMY [v MUMMIFIED, MUMMIFYING, MUMMIFIES]\n",
  "MUMMIFYING": "MUMMIFY, to preserve by embalming, also MUMMY [v]\n",
  "MUMMING": "the performance of a mumming play [n -S]\n",
  "MUMMINGS": "MUMMING, the performance of a mumming play [n]\n",
  "MUMMOCK": "(archaic) a piece, a shred, also MAMMOCK [n -S]\n",
  "MUMMOCKS": "MUMMOCK, (archaic) a piece, a shred, also MAMMOCK [n]\n",
  "MUMMS": "MUMM, to act in a disguise, also MUM [v]\n",
  "MUMMY": "to preserve by embalming, also MUMMIFY [v MUMMIED, MUMMYING, MUMMIES]\n",
  "MUMMYING": "MUMMY, to preserve by embalming, also MUMMIFY [v]\n",
  "MUMP": "to mumble, mutter [v -ED, -ING, -S]\n",
  "MUMPED": "MUMP, to mumble, mutter [v]\n",
  "MUMPER": "a beggar; a begging impostor [n -S]\n",
  "MUMPERS": "MUMPER, a beggar; a begging impostor [n]\n",
  "MUMPING": "MUMP, to mumble, mutter [v]\n",
  "MUMPISH": "sulky [adj MUMPISHLY]\n",
  "MUMPISHLY": "MUMPISH, sulky [adv]\n",
  "MUMPISHNESS": "the state of being mumpish, sulky [n -ES]\n",
  "MUMPISHNESSES": "MUMPISHNESS, the state of being mumpish, sulky [n]\n",
  "MUMPRENEUR": "a woman who combines running a business enterprise with looking after her children, also MOMPRENEUR [n -S]\n",
  "MUMPRENEURS": "MUMPRENEUR, a woman who combines running a business enterprise with looking after her children, also MOMPRENEUR [n]\n",
  "MUMPS": "MUMP, to mumble, mutter [v]\n",
  "MUMPSIMUS": "an erroneous word or spelling that, through long usage, has become absorbed into the language; an incorrect manuscript reading blindly adhered to by some scholar [n -ES]\n",
  "MUMPSIMUSES": "MUMPSIMUS, an erroneous word or spelling that, through long usage, has become absorbed into the language; an incorrect manuscript reading blindly adhered to by some scholar [n]\n",
  "MUMS": "MUM, to act in a disguise, also MUMM [v]\n",
  "MUMSIER": "MUMSY, old-fashioned; drab [adj]\n",
  "MUMSIES": "MUMSY, a mother [n]\n",
  "MUMSIEST": "MUMSY, old-fashioned; drab [adj]\n",
  "MUMSINESS": "the state of being mumsy [n -ES]\n",
  "MUMSINESSES": "MUMSINESS, the state of being mumsy [n]\n",
  "MUMSY": "old-fashioned; drab [adj MUMSIER, MUMSIEST] / a mother [n MUMSIES]\n",
  "MUMU": "(Hawaiian) a long, loose dress, also MUUMUU [n -S]\n",
  "MUMUS": "MUMU, (Hawaiian) a long, loose dress, also MUUMUU [n]\n",
  "MUN": "(dialect) a man [n -S]\n",
  "MUNCH": "to chew noisily [v -ED, -ING, -ES]\n",
  "MUNCHABLE": "that can be munched [adj] / a tasty item of food [n -S]\n",
  "MUNCHABLES": "MUNCHABLE, a tasty item of food [n]\n",
  "MUNCHED": "MUNCH, to chew noisily [v]\n",
  "MUNCHER": "one who munches [n -S]\n",
  "MUNCHERS": "MUNCHER, one who munches [n]\n",
  "MUNCHES": "MUNCH, to chew noisily [v]\n",
  "MUNCHIE": "a small amount of food eaten between meals [n -S]\n",
  "MUNCHIER": "MUNCHY, suitable for snacking [adj]\n",
  "MUNCHIES": "MUNCHIE, a small amount of food eaten between meals [n]\n",
  "MUNCHIEST": "MUNCHY, suitable for snacking [adj]\n",
  "MUNCHING": "MUNCH, to chew noisily [v]\n",
  "MUNCHKIN": "a very small person, esp. one with an elflike appearance [n -S]\n",
  "MUNCHKINS": "MUNCHKIN, a very small person, esp. one with an elflike appearance [n]\n",
  "MUNCHY": "suitable for snacking [adj MUNCHIER, MUNCHIEST]\n",
  "MUNDANE": "ordinary, banal [adj MUNDANER, MUNDANEST, MUNDANELY]\n",
  "MUNDANELY": "MUNDANE, ordinary, banal [adv]\n",
  "MUNDANENESS": "the state of being mundane [n -ES]\n",
  "MUNDANENESSES": "MUNDANENESS, the state of being mundane [n]\n",
  "MUNDANER": "MUNDANE, ordinary, banal [adj]\n",
  "MUNDANEST": "MUNDANE, ordinary, banal [adj]\n",
  "MUNDANITIES": "MUNDANITY, worldliness [n]\n",
  "MUNDANITY": "worldliness [n MUNDANITIES]\n",
  "MUNDIC": "iron pyrites [n -S]\n",
  "MUNDICS": "MUNDIC, iron pyrites [n]\n",
  "MUNDIFICATION": "the act of cleansing, purification [n -S]\n",
  "MUNDIFICATIONS": "MUNDIFICATION, the act of cleansing, purification [n]\n",
  "MUNDIFICATIVE": "a cleansing medicine or preparation [n -S]\n",
  "MUNDIFICATIVES": "MUNDIFICATIVE, a cleansing medicine or preparation [n]\n",
  "MUNDIFIED": "MUNDIFY, to cleanse, purify [v]\n",
  "MUNDIFIES": "MUNDIFY, to cleanse, purify [v]\n",
  "MUNDIFY": "to cleanse, purify [v MUNDIFIED, MUNDIFYING, MUNDIFIES]\n",
  "MUNDIFYING": "MUNDIFY, to cleanse, purify [v]\n",
  "MUNDUNGO": "(Spanish) a foul-smelling tobacco, also MUNDUNGUS [n -S]\n",
  "MUNDUNGOS": "MUNDUNGO, (Spanish) a foul-smelling tobacco, also MUNDUNGUS [n]\n",
  "MUNDUNGUS": "(archaic) a foul-smelling tobacco, also MUNDUNGO [n -ES]\n",
  "MUNDUNGUSES": "MUNDUNGUS, (archaic) a foul-smelling tobacco, also MUNDUNGO [n]\n",
  "MUNG": "to process computer data [v -ED, -ING, -S]\n",
  "MUNGA": "(New Zealand) an army canteen [n -S]\n",
  "MUNGAS": "MUNGA, (New Zealand) an army canteen [n]\n",
  "MUNGCORN": "a mixed grain, esp. rye and wheat, aka maslin, also MONGCORN [n -S]\n",
  "MUNGCORNS": "MUNGCORN, a mixed grain, esp. rye and wheat, aka maslin, also MONGCORN [n]\n",
  "MUNGE": "to create a strong, secure password through character substitution [v MUNGED, MUNGING, MUNGES]\n",
  "MUNGED": "MUNG, to process computer data [v]\n",
  "MUNGES": "MUNGE, to create a strong, secure password through character substitution [v]\n",
  "MUNGING": "MUNG, to process computer data [v]\n",
  "MUNGO": "the waste produced in a woollen-mill from felted cloth, also MONGO, MONGOE [n -ES or -S]\n",
  "MUNGOES": "MUNGO, the waste produced in a woollen-mill from felted cloth, also MONGO, MONGOE [n]\n",
  "MUNGOOSE": "(Marathi) a carnivorous mammal, also MONGOOSE [n -S]\n",
  "MUNGOOSES": "MUNGOOSE, (Marathi) a carnivorous mammal, also MONGOOSE [n]\n",
  "MUNGOS": "MUNGO, the waste produced in a woollen-mill from felted cloth, also MONGO, MONGOE [n]\n",
  "MUNGS": "MUNG, to process computer data [v]\n",
  "MUNI": "a security issued by a government [n -S]\n",
  "MUNICIPAL": "relating to (the government of) a borough, town or city [adj MUNICIPALLY] / a municipal bond [n -S]\n",
  "MUNICIPALISE": "to bring under municipal control or ownership, also MUNICIPALIZE [v MUNICIPALISED, MUNICIPALISING, MUNICIPALISES]\n",
  "MUNICIPALISED": "MUNICIPALISE, to bring under municipal control or ownership, also MUNICIPALIZE [v]\n",
  "MUNICIPALISES": "MUNICIPALISE, to bring under municipal control or ownership, also MUNICIPALIZE [v]\n",
  "MUNICIPALISING": "MUNICIPALISE, to bring under municipal control or ownership, also MUNICIPALIZE [v]\n",
  "MUNICIPALISM": "concern for the interests of one's municipality; belief in municipal control [n -S]\n",
  "MUNICIPALISMS": "MUNICIPALISM, concern for the interests of one's municipality; belief in municipal control [n]\n",
  "MUNICIPALIST": "a believer in municipalism [n -S]\n",
  "MUNICIPALISTS": "MUNICIPALIST, a believer in municipalism [n]\n",
  "MUNICIPALITIES": "MUNICIPALITY, a primarily urban political unit having corporate status and usually powers of self-government [n]\n",
  "MUNICIPALITY": "a primarily urban political unit having corporate status and usually powers of self-government [n MUNICIPALITIES]\n",
  "MUNICIPALIZE": "to bring under municipal ownership or supervision, also MUNICIPALISE [v MUNICIPALIZED, MUNICIPALIZING, MUNICIPALIZES]\n",
  "MUNICIPALIZED": "MUNICIPALIZE, to bring under municipal ownership or supervision, also MUNICIPALISE [v]\n",
  "MUNICIPALIZES": "MUNICIPALIZE, to bring under municipal ownership or supervision, also MUNICIPALISE [v]\n",
  "MUNICIPALIZING": "MUNICIPALIZE, to bring under municipal ownership or supervision, also MUNICIPALISE [v]\n",
  "MUNICIPALLY": "MUNICIPAL, relating to (the government of) a borough, town or city [adv]\n",
  "MUNICIPALS": "MUNICIPAL, a municipal bond [n]\n",
  "MUNIFICENCE": "magnificent liberality in giving [n -S]\n",
  "MUNIFICENCES": "MUNIFICENCE, magnificent liberality in giving [n]\n",
  "MUNIFICENT": "generous, liberal [adj MUNIFICENTLY]\n",
  "MUNIFICENTLY": "MUNIFICENT, generous, liberal [adv]\n",
  "MUNIFICENTNESS": "MUNIFICENT, generous, liberal [n]\n",
  "MUNIFIED": "MUNIFY, to fortify, also MUNITE [v]\n",
  "MUNIFIENCE": "(Spenser) defence, fortification [n -S]\n",
  "MUNIFIENCES": "MUNIFIENCE, (Spenser) defence, fortification [n]\n",
  "MUNIFIES": "MUNIFY, to fortify, also MUNITE [v]\n",
  "MUNIFY": "to fortify, also MUNITE [v MUNIFIED, MUNIFYING, MUNIFIES]\n",
  "MUNIFYING": "MUNIFY, to fortify, also MUNITE [v]\n",
  "MUNIMENT": "a means of defence, also MINIMENT [n -S]\n",
  "MUNIMENTS": "MUNIMENT, a means of defence, also MINIMENT [n]\n",
  "MUNIS": "MUNI, a security issued by a government [n]\n",
  "MUNITE": "to fortify, also MUNIFY [v MUNITED, MUNITING, MUNITES]\n",
  "MUNITED": "MUNITE, to fortify, also MUNIFY [v]\n",
  "MUNITES": "MUNITE, to fortify, also MUNIFY [v]\n",
  "MUNITING": "MUNITE, to fortify, also MUNIFY [v]\n",
  "MUNITION": "to furnish with war material [v -ED, -ING, -S]\n",
  "MUNITIONED": "MUNITION, to furnish with war material [v]\n",
  "MUNITIONEER": "a worker engaged in making munitions, also MUNITIONER [n -S]\n",
  "MUNITIONEERS": "MUNITIONEER, a worker engaged in making munitions, also MUNITIONER [n]\n",
  "MUNITIONER": "one who supplies munitions, also MUNITIONEER [n -S]\n",
  "MUNITIONERS": "MUNITIONER, one who supplies munitions, also MUNITIONEER [n]\n",
  "MUNITIONETTE": "(obsolete) a female munitions worker [n -S]\n",
  "MUNITIONETTES": "MUNITIONETTE, (obsolete) a female munitions worker [n]\n",
  "MUNITIONING": "MUNITION, to furnish with war material [v]\n",
  "MUNITIONS": "MUNITION, to furnish with war material [v]\n",
  "MUNNION": "an upright division between window panes, also MULLION [n -S]\n",
  "MUNNIONS": "MUNNION, an upright division between window panes, also MULLION [n]\n",
  "MUNS": "MUN, (dialect) a man [n]\n",
  "MUNSHI": "(Hindi) a secretary, an interpreter, also MOONSHEE [n -S]\n",
  "MUNSHIS": "MUNSHI, (Hindi) a secretary, an interpreter, also MOONSHEE [n]\n",
  "MUNSTER": "a semisoft cow's milk cheese from Munster in France, also MUENSTER [n -S]\n",
  "MUNSTERS": "MUNSTER, a semisoft cow's milk cheese from Munster in France, also MUENSTER [n]\n",
  "MUNT": "(Bantu) an offensive word for a black African, also MUNTU [n -S]\n",
  "MUNTED": "(New Zealand) destroyed or ruined; drunk [adj]\n",
  "MUNTER": "(colloquial) an unattractive person [n -S]\n",
  "MUNTERS": "MUNTER, (colloquial) an unattractive person [n]\n",
  "MUNTIN": "the vertical framing piece between door panels, also MUNTING [n -S]\n",
  "MUNTINED": "having a muntin, a dividing strip for window panels [adj]\n",
  "MUNTING": "the vertical framing piece between door panels, also MUNTIN [n -S]\n",
  "MUNTINGS": "MUNTING, the vertical framing piece between door panels, also MUNTIN [n]\n",
  "MUNTINS": "MUNTIN, the vertical framing piece between door panels, also MUNTING [n]\n",
  "MUNTJAC": "(Malay) a small Asian deer, also MUNTJAK [n -S]\n",
  "MUNTJACS": "MUNTJAC, (Malay) a small Asian deer, also MUNTJAK [n]\n",
  "MUNTJAK": "(Malay) a small Asian deer, also MUNTJAC [n -S]\n",
  "MUNTJAKS": "MUNTJAK, (Malay) a small Asian deer, also MUNTJAC [n]\n",
  "MUNTRIE": "(Native Australian) an Australian shrub with green-red edible berries [n -S]\n",
  "MUNTRIES": "MUNTRIE, (Native Australian) an Australian shrub with green-red edible berries [n]\n",
  "MUNTS": "MUNT, (Bantu) an offensive word for a black African, also MUNTU [n]\n",
  "MUNTU": "(Bantu) an offensive word for a black African, also MUNT [n -S]\n",
  "MUNTUS": "MUNTU, (Bantu) an offensive word for a black African, also MUNT [n]\n",
  "MUON": "a subatomic particle [n -S]\n",
  "MUONIC": "relating to a muon, a kind of subatomic particle [adj]\n",
  "MUONIUM": "an electron and a positive muon bound together [n -S]\n",
  "MUONIUMS": "MUONIUM, an electron and a positive muon bound together [n]\n",
  "MUONS": "MUON, a subatomic particle [n]\n",
  "MUPPET": "(slang) a stupid person [n -S]\n",
  "MUPPETS": "MUPPET, (slang) a stupid person [n]\n",
  "MUQADDAM": "(Arabic) a leader, headman, also MOCUDDUM, MOKADDAM [n -S]\n",
  "MUQADDAMS": "MUQADDAM, (Arabic) a leader, headman, also MOCUDDUM, MOKADDAM [n]\n",
  "MURA": "(Japanese) a Japanese village [n -S]\n",
  "MURAENA": "(Latin) a food fish of the Romans, also MURENA [n -S]\n",
  "MURAENAS": "MURAENA, (Latin) a food fish of the Romans, also MURENA [n]\n",
  "MURAENID": "an eel of the family Muraenidae [n -S]\n",
  "MURAENIDS": "MURAENID, an eel of the family Muraenidae [n]\n",
  "MURAGE": "(historical) a rate levied for the upkeep of a city's walls [n -S]\n",
  "MURAGES": "MURAGE, (historical) a rate levied for the upkeep of a city's walls [n]\n",
  "MURAL": "a painting on a wall or ceiling [n -S]\n",
  "MURALED": "decorated with a mural, also MURALLED [adj]\n",
  "MURALIST": "a painter of murals [n -S]\n",
  "MURALISTS": "MURALIST, a painter of murals [n]\n",
  "MURALLED": "decorated with a mural, also MURALED [adj]\n",
  "MURALS": "MURAL, a painting on a wall or ceiling [n]\n",
  "MURAS": "MURA, (Japanese) a Japanese village [n]\n",
  "MURDABAD": "(Urdu) death to, used in slogans [interj]\n",
  "MURDER": "to kill unlawfully with premeditated malice [v -ED, -ING, -S]\n",
  "MURDERABILIA": "objects that are regarded as valuable because of their connection with murders or other notorious crimes [n]\n",
  "MURDERBALL": "a form of rugby played in wheelchairs by people afflicted with quadriplegia [n -S]\n",
  "MURDERBALLS": "MURDERBALL, a form of rugby played in wheelchairs by people afflicted with quadriplegia [n]\n",
  "MURDERED": "MURDER, to kill unlawfully with premeditated malice [v]\n",
  "MURDEREE": "one who is murdered [n -S]\n",
  "MURDEREES": "MURDEREE, one who is murdered [n]\n",
  "MURDERER": "one who murders [n -S]\n",
  "MURDERERS": "MURDERER, one who murders [n]\n",
  "MURDERESS": "a female murderer [n -ES]\n",
  "MURDERESSES": "MURDERESS, a female murderer [n]\n",
  "MURDERING": "MURDER, to kill unlawfully with premeditated malice [v]\n",
  "MURDEROUS": "inclined to murder [adj MURDEROUSLY]\n",
  "MURDEROUSLY": "MURDEROUS, inclined to murder [adv]\n",
  "MURDEROUSNESS": "MURDEROUS, inclined to murder [n]\n",
  "MURDEROUSNESSES": "MURDEROUSNESS, MURDEROUS, inclined to murder [n]\n",
  "MURDERS": "MURDER, to kill unlawfully with premeditated malice [v]\n",
  "MURE": "to wall up the doors of; to stop (up) the means of access to [v MURED, MURING, MURES]\n",
  "MURED": "MURE, to wall up the doors of; to stop (up) the means of access to [v]\n",
  "MUREIN": "a peptidoglycan found in cell walls [n -S]\n",
  "MUREINS": "MUREIN, a peptidoglycan found in cell walls [n]\n",
  "MURENA": "(Latin) a genus of large eels of the family Muraenidae, also MURAENA [n -S]\n",
  "MURENAS": "MURENA, (Latin) a genus of large eels of the family Muraenidae, also MURAENA [n]\n",
  "MURES": "MURE, to wall up the doors of; to stop (up) the means of access to [v]\n",
  "MUREX": "(Latin) a genus of shellfish, yielding a purple dye [n MUREXES or MURICES]\n",
  "MUREXES": "MUREX, (Latin) a genus of shellfish, yielding a purple dye [n]\n",
  "MURGEON": "(Scots) to mock with grimaces [v -ED, -ING, -S]\n",
  "MURGEONED": "MURGEON, (Scots) to mock with grimaces [v]\n",
  "MURGEONING": "MURGEON, (Scots) to mock with grimaces [v]\n",
  "MURGEONS": "MURGEON, (Scots) to mock with grimaces [v]\n",
  "MURIATE": "(archaic) a chloride [n -S]\n",
  "MURIATED": "pickled [adj]\n",
  "MURIATES": "MURIATE, (archaic) a chloride [n]\n",
  "MURIATIC": "briny [adj]\n",
  "MURICATE": "rough or warty with short sharp points, also MURICATED [adj]\n",
  "MURICATED": "rough or warty with short sharp points, also MURICATE [adj]\n",
  "MURICES": "MUREX, (Latin) a genus of shellfish, yielding a purple dye [n]\n",
  "MURID": "any of the family of small rodents, also MURINE [n -S]\n",
  "MURIDS": "MURID, any of the family of small rodents, also MURINE [n]\n",
  "MURIFORM": "with cells arranged like bricks in a wall [adj]\n",
  "MURINE": "any of the family of small rodents, also MURID [n -S]\n",
  "MURINES": "MURINE, any of the family of small rodents, also MURID [n]\n",
  "MURING": "MURE, to wall up the doors of; to stop (up) the means of access to [v]\n",
  "MURK": "dark, gloomy, obscure, also MIRK [adj MURKER, MURKEST, MURKLY] / to murder, defeat convincingly [v MURKED, MURKING, MURKS]\n",
  "MURKED": "MURK, to murder, defeat convincingly [v]\n",
  "MURKER": "MURK, dark, gloomy, obscure, also MIRK [adj]\n",
  "MURKEST": "MURK, dark, gloomy, obscure, also MIRK [adj]\n",
  "MURKIER": "MURKY, dark, also MIRKY [adj]\n",
  "MURKIEST": "MURKY, dark, also MIRKY [adj]\n",
  "MURKILY": "MURKY, dark, also MIRKY [adv]\n",
  "MURKINESS": "the state of being murky, also MIRKINESS [n -ES]\n",
  "MURKINESSES": "MURKINESS, the state of being murky, also MIRKINESS [n]\n",
  "MURKING": "MURK, to murder, defeat convincingly [v]\n",
  "MURKISH": "somewhat murky [adj]\n",
  "MURKLY": "MURK, dark, gloomy, obscure, also MIRK [adj]\n",
  "MURKS": "MURK, to murder, defeat convincingly [v]\n",
  "MURKSOME": "murky [adj]\n",
  "MURKY": "dark, also MIRKY [adj MURKIER, MURKIEST, MURKILY]\n",
  "MURL": "(Scots) to crumble [v -ED, -ING, -S]\n",
  "MURLAIN": "(Gaelic) a narrow-mouthed basket, also MURLAN, MURLIN [n -S]\n",
  "MURLAINS": "MURLAIN, (Gaelic) a narrow-mouthed basket, also MURLAN, MURLIN [n]\n",
  "MURLAN": "(Gaelic) a narrow-mouthed basket, also MURLAIN, MURLIN [n -S]\n",
  "MURLANS": "MURLAN, (Gaelic) a narrow-mouthed basket, also MURLAIN, MURLIN [n]\n",
  "MURLED": "MURL, (Scots) to crumble [v]\n",
  "MURLIER": "MURLY, (Scots) crumbly [adj]\n",
  "MURLIEST": "MURLY, (Scots) crumbly [adj]\n",
  "MURLIN": "(Gaelic) a narrow-mouthed basket, also MURLAIN, MURLAN [n -S]\n",
  "MURLING": "MURL, (Scots) to crumble [v]\n",
  "MURLINS": "MURLIN, (Gaelic) a narrow-mouthed basket, also MURLAIN, MURLAN [n]\n",
  "MURLS": "MURL, (Scots) to crumble [v]\n",
  "MURLY": "(Scots) crumbly [adj MURLIER, MURLIEST]\n",
  "MURMUR": "to make a subdued muttered sound [v -ED, -ING, -S]\n",
  "MURMURATION": "murmuring [n -S]\n",
  "MURMURATIONS": "MURMURATION, murmuring [n]\n",
  "MURMURED": "MURMUR, to make a subdued muttered sound [v]\n",
  "MURMURER": "one who murmurs [n -S]\n",
  "MURMURERS": "MURMURER, one who murmurs [n]\n",
  "MURMURING": "making a murmur [adj MURMURINGLY] / the act of murmuring [n -S]\n",
  "MURMURINGLY": "MURMURING [adv]\n",
  "MURMURINGS": "MURMURING, the act of murmuring [n]\n",
  "MURMUROUS": "full of murmurs [adj MURMUROUSLY]\n",
  "MURMUROUSLY": "MURMUROUS, full of murmurs [adv]\n",
  "MURMURS": "MURMUR, to make a subdued muttered sound [v]\n",
  "MURPHIES": "MURPHY, (colloquial) a potato [n]\n",
  "MURPHY": "(colloquial) a potato [n MURPHIES]\n",
  "MURR": "a diving bird, also MURRE [n -S]\n",
  "MURRA": "(Latin) an ancient Roman substance used to make fine cups and vases, also MURRHA [n -S]\n",
  "MURRAGH": "a caddis fly which fishermen know that trout favour [n -S]\n",
  "MURRAGHS": "MURRAGH, a caddis fly which fishermen know that trout favour [n]\n",
  "MURRAIN": "a disease of cattle, also MURREN, MURRIN, MURRION [n -S]\n",
  "MURRAINED": "affected with the murrain, a cattle disease [adj]\n",
  "MURRAINS": "MURRAIN, a disease of cattle, also MURREN, MURRIN, MURRION [n]\n",
  "MURRAM": "a tough clayey gravel used as road metal in tropical Africa [n -S]\n",
  "MURRAMS": "MURRAM, a tough clayey gravel used as road metal in tropical Africa [n]\n",
  "MURRAS": "MURRA, (Latin) an ancient Roman substance used to make fine cups and vases, also MURRHA [n]\n",
  "MURRAY": "a kind of eel, also MORAY, MURREY, MURRY [n -S]\n",
  "MURRAYS": "MURRAY, a kind of eel, also MORAY, MURREY, MURRY [n]\n",
  "MURRE": "a guillemot, an auk, also MURR [n -S]\n",
  "MURREE": "(Native Australian) a native Australian, also MURRI [n -S]\n",
  "MURREES": "MURREE, (Native Australian) a native Australian, also MURRI [n]\n",
  "MURRELET": "any of several small auks of the North Pacific [n -S]\n",
  "MURRELETS": "MURRELET, any of several small auks of the North Pacific [n]\n",
  "MURREN": "(Shakespeare) a disease of cattle, also MURRAIN, MURRIN, MURRION [n -S]\n",
  "MURRENS": "MURREN, (Shakespeare) a disease of cattle, also MURRAIN, MURRIN, MURRION [n]\n",
  "MURRES": "MURRE, a guillemot, an auk, also MURR [n]\n",
  "MURREY": "a kind of eel, also MORAY, MURRAY, MURRY [n -S]\n",
  "MURREYS": "MURREY, a kind of eel, also MORAY, MURRAY, MURRY [n]\n",
  "MURRHA": "(Latin) an ancient Roman substance used to make fine cups and vases, also MURRA [n -S]\n",
  "MURRHAS": "MURRHA, (Latin) an ancient Roman substance used to make fine cups and vases, also MURRA [n]\n",
  "MURRHINE": "a kind of clear glassware used to make ancient Roman vases, also MURRINE, MYRRHINE [n -S]\n",
  "MURRHINES": "MURRHINE, a kind of clear glassware used to make ancient Roman vases, also MURRINE, MYRRHINE [n]\n",
  "MURRI": "(Native Australian) a native Australian, also MURREE [n -S]\n",
  "MURRIES": "MURRY, a kind of eel, also MORAY, MURRAY, MURREY [n]\n",
  "MURRIN": "(Spenser) a disease of cattle, also MURRAIN, MURREN, MURRION [n -S]\n",
  "MURRINE": "a kind of clear glassware used to make ancient Roman vases, also MURRHINE, MYRRHINE [n -S]\n",
  "MURRINES": "MURRINE, a kind of clear glassware used to make ancient Roman vases, also MURRHINE, MYRRHINE [n]\n",
  "MURRINS": "MURRIN, (Spenser) a disease of cattle, also MURRAIN, MURREN, MURRION [n]\n",
  "MURRION": "(Shakespeare) a disease of cattle, also MURRAIN, MURREN, MURRIN [n -S]\n",
  "MURRIONS": "MURRION, (Shakespeare) a disease of cattle, also MURRAIN, MURREN, MURRIN [n]\n",
  "MURRIS": "MURRI, (Native Australian) a native Australian, also MURREE [n]\n",
  "MURRS": "MURR, a diving bird, also MURRE [n]\n",
  "MURRY": "a kind of eel, also MORAY, MURRAY, MURREY [n MURRIES]\n",
  "MURSHID": "in Sufism: a spiritual guide who initiates into a mystical order a postulant wishing to follow the Sufi path to God [n -S]\n",
  "MURSHIDS": "MURSHID, in Sufism: a spiritual guide who initiates into a mystical order a postulant wishing to follow the Sufi path to God [n]\n",
  "MURTHER": "(dialect) to murder [v -ED, -ING, -S]\n",
  "MURTHERED": "MURTHER, (dialect) to murder [v]\n",
  "MURTHERER": "a murderer [n -S]\n",
  "MURTHERERS": "MURTHERER, a murderer [n]\n",
  "MURTHERING": "MURTHER, (dialect) to murder [v]\n",
  "MURTHERS": "MURTHER, (dialect) to murder [v]\n",
  "MURTI": "(Sanskrit) an image of a deity which is itself considered divine once consecrated [n -S]\n",
  "MURTIS": "MURTI, (Sanskrit) an image of a deity which is itself considered divine once consecrated [n]\n",
  "MURVA": "(Sanskrit) a bowstring hemp, also MOORVA [n -S]\n",
  "MURVAS": "MURVA, (Sanskrit) a bowstring hemp, also MOORVA [n]\n",
  "MUS": "MU, (Greek) a letter of the Greek alphabet [n]\n",
  "MUSACEOUS": "of, pertaining to, or resembling bananas or plantains [adj]\n",
  "MUSANG": "(Malay) a civetlike animal of South Asia, aka paradoxure [n -S]\n",
  "MUSANGS": "MUSANG, (Malay) a civetlike animal of South Asia, aka paradoxure [n]\n",
  "MUSAR": "(Yiddish) Rabbinic literature concerned with ethics, right conduct etc. [n -S]\n",
  "MUSARS": "MUSAR, (Yiddish) Rabbinic literature concerned with ethics, right conduct etc. [n]\n",
  "MUSCA": "(Latin) a genus of dipterous insects, including the common housefly [n MUSCAE]\n",
  "MUSCADEL": "a rich spicy wine derived from muscat grapes, also MUSCADELLE, MUSCATEL [n -S]\n",
  "MUSCADELLE": "a rich spicy wine derived from muscat grapes, also MUSCADEL, MUSCATEL [n -S]\n",
  "MUSCADELLES": "MUSCADELLE, a rich spicy wine derived from muscat grapes, also MUSCADEL, MUSCATEL [n]\n",
  "MUSCADELS": "MUSCADEL, a rich spicy wine derived from muscat grapes, also MUSCADELLE, MUSCATEL [n]\n",
  "MUSCADET": "(French) a dry, white French wine [n -S]\n",
  "MUSCADETS": "MUSCADET, (French) a dry, white French wine [n]\n",
  "MUSCADIN": "(French) a Parisian fop or dandy; a middle-class moderate in the French Revolution [n -S]\n",
  "MUSCADINE": "(archaic) a musk-scented purple grape, used to make wine [n -S]\n",
  "MUSCADINES": "MUSCADINE, (archaic) a musk-scented purple grape, used to make wine [n]\n",
  "MUSCADINS": "MUSCADIN, (French) a Parisian fop or dandy; a middle-class moderate in the French Revolution [n]\n",
  "MUSCAE": "MUSCA, (Latin) a genus of dipterous insects, including the common housefly [n]\n",
  "MUSCARDINE": "(French) a disease which is very destructive to silkworms, and which sometimes extends to other insects [n -S]\n",
  "MUSCARDINES": "MUSCARDINE, (French) a disease which is very destructive to silkworms, and which sometimes extends to other insects [n]\n",
  "MUSCARINE": "a poisonous alkaloid in fly agaric [n -S]\n",
  "MUSCARINES": "MUSCARINE, a poisonous alkaloid in fly agaric [n]\n",
  "MUSCARINIC": "of or like muscarine, a poisonous alkaloid in fly agaric [adj]\n",
  "MUSCAT": "(French) a sweet white grape used for raisins and muscatel wine [n -S]\n",
  "MUSCATEL": "a rich spicy wine derived from muscat grapes, also MUSCADEL, MUSCADELLE [n -S]\n",
  "MUSCATELS": "MUSCATEL, a rich spicy wine derived from muscat grapes, also MUSCADEL, MUSCADELLE [n]\n",
  "MUSCATORIA": "MUSCATORIUM, (Latin) a flabellum, a fan; esp. the fan carried before the pope on state occasions, made in ostrich and peacock feathers [n]\n",
  "MUSCATORIUM": "(Latin) a flabellum, a fan; esp. the fan carried before the pope on state occasions, made in ostrich and peacock feathers [n MUSCATORIA]\n",
  "MUSCATS": "MUSCAT, (French) a sweet white grape used for raisins and muscatel wine [n]\n",
  "MUSCAVADO": "(Spanish) raw or unrefined sugar obtained from the juice of the sugar cane by evaporation and draining off the molasses, also MUSCOVADO [n -S]\n",
  "MUSCAVADOS": "MUSCAVADO, (Spanish) raw or unrefined sugar obtained from the juice of the sugar cane by evaporation and draining off the molasses, also MUSCOVADO [n]\n",
  "MUSCID": "a member of the housefly family [n -S]\n",
  "MUSCIDS": "MUSCID, a member of the housefly family [n]\n",
  "MUSCLE": "to force one's way [v MUSCLED, MUSCLING, MUSCLES]\n",
  "MUSCLED": "MUSCLE, to force one's way [v]\n",
  "MUSCLEMAN": "a man of extravagant physical development, esp. one employed to intimidate people [n MUSCLEMEN]\n",
  "MUSCLEMEN": "MUSCLEMAN, a man of extravagant physical development, esp. one employed to intimidate people [n]\n",
  "MUSCLES": "MUSCLE, to force one's way [v]\n",
  "MUSCLEY": "of a muscular build, also MUSCLY [adj MUSCLIER, MUSCLIEST]\n",
  "MUSCLIER": "MUSCLY, of a muscular build, also MUSCLEY [adj]\n",
  "MUSCLIEST": "MUSCLY, of a muscular build, also MUSCLEY [adj]\n",
  "MUSCLING": "muscular structure or development [n -S]\n",
  "MUSCLINGS": "MUSCLING, muscular structure or development [n]\n",
  "MUSCLY": "of a muscular build, also MUSCLEY [adj MUSCLIER, MUSCLIEST]\n",
  "MUSCOID": "a mosslike plant [n -S]\n",
  "MUSCOIDS": "MUSCOID, a mosslike plant [n]\n",
  "MUSCOLOGIES": "MUSCOLOGY, the study of mosses [n]\n",
  "MUSCOLOGY": "the study of mosses [n MUSCOLOGIES]\n",
  "MUSCONE": "a macrocyclic ketone that gives musk its distinctive smell and is used in perfumes, also MUSKONE [n -S]\n",
  "MUSCONES": "MUSCONE, a macrocyclic ketone that gives musk its distinctive smell and is used in perfumes, also MUSKONE [n]\n",
  "MUSCOSE": "mosslike, also MUSCOID [adj]\n",
  "MUSCOVADO": "(Spanish) raw or unrefined sugar obtained from the juice of the sugar cane by evaporation and draining off the molasses, also MUSCAVADO [n -S]\n",
  "MUSCOVADOS": "MUSCOVADO, (Spanish) raw or unrefined sugar obtained from the juice of the sugar cane by evaporation and draining off the molasses, also MUSCAVADO [n]\n",
  "MUSCOVITE": "a type of mica, used as an insulator [n -S]\n",
  "MUSCOVITES": "MUSCOVITE, a type of mica, used as an insulator [n]\n",
  "MUSCOVY": "as in muscovy duck, a kind of duck [adj]\n",
  "MUSCULAR": "pertaining to muscle [adj MUSCULARLY]\n",
  "MUSCULARITIES": "MUSCULARITY, the state of being muscular [n]\n",
  "MUSCULARITY": "the state of being muscular [n MUSCULARITIES]\n",
  "MUSCULARLY": "MUSCULAR, pertaining to muscle [adv]\n",
  "MUSCULATION": "muscular action; musculature [n -S]\n",
  "MUSCULATIONS": "MUSCULATION, muscular action; musculature [n]\n",
  "MUSCULATURE": "the muscles of all or a part of the animal body [n -S]\n",
  "MUSCULATURES": "MUSCULATURE, the muscles of all or a part of the animal body [n]\n",
  "MUSCULOSKELETAL": "of, relating to, or involving both musculature and skeleton [adj]\n",
  "MUSCULOUS": "(obsolete) muscular [adj]\n",
  "MUSE": "to ponder [v MUSED, MUSING, MUSES]\n",
  "MUSED": "MUSE, to ponder [v]\n",
  "MUSEFUL": "meditative; thoughtfully silent [adj MUSEFULLY]\n",
  "MUSEFULLY": "MUSEFUL, meditative; thoughtfully silent [adv]\n",
  "MUSEOLOGICAL": "relating to museology [adj]\n",
  "MUSEOLOGIES": "MUSEOLOGY, the study of museums [n]\n",
  "MUSEOLOGIST": "a student of museology, the study of museums [n -S]\n",
  "MUSEOLOGISTS": "MUSEOLOGIST, a student of museology, the study of museums [n]\n",
  "MUSEOLOGY": "the study of museums [n MUSEOLOGIES]\n",
  "MUSER": "one who muses [n -S]\n",
  "MUSERS": "MUSER, one who muses [n]\n",
  "MUSES": "MUSE, to ponder [v]\n",
  "MUSET": "a gap in a fence through which animals pass, also MUSIT [n -S]\n",
  "MUSETS": "MUSET, a gap in a fence through which animals pass, also MUSIT [n]\n",
  "MUSETTE": "(French) a small bagpipe formerly in use, having a soft and sweet tone [n -S]\n",
  "MUSETTES": "MUSETTE, (French) a small bagpipe formerly in use, having a soft and sweet tone [n]\n",
  "MUSEUM": "a repository for the collection, exhibition and study of objects [n -S]\n",
  "MUSEUMS": "MUSEUM, a repository for the collection, exhibition and study of objects [n]\n",
  "MUSH": "to reduce to mush [v -ED, -ING, -ES]\n",
  "MUSHA": "(Irish) an interjection expressing surprise [interj]\n",
  "MUSHED": "MUSH, to reduce to mush [v]\n",
  "MUSHER": "a person who travels through snow on foot; a driver of a dog-sledge [n -S]\n",
  "MUSHERS": "MUSHER, a person who travels through snow on foot; a driver of a dog-sledge [n]\n",
  "MUSHES": "MUSH, to reduce to mush [v]\n",
  "MUSHIE": "(Australian slang) a mushroom [n -S]\n",
  "MUSHIER": "MUSHY, like mush, soft [adj]\n",
  "MUSHIES": "MUSHIE, (Australian slang) a mushroom [n]\n",
  "MUSHIEST": "MUSHY, like mush, soft [adj]\n",
  "MUSHILY": "MUSHY, like mush, soft [adv]\n",
  "MUSHINESS": "the state of being mushy [n -ES]\n",
  "MUSHINESSES": "MUSHINESS, the state of being mushy [n]\n",
  "MUSHING": "the act of reducing to mush [n -S]\n",
  "MUSHINGS": "MUSHING, the act of reducing to mush [n]\n",
  "MUSHMOUTH": "(US) a person who slurs or mumbles in speaking [n -S]\n",
  "MUSHMOUTHS": "MUSHMOUTH, (US) a person who slurs or mumbles in speaking [n]\n",
  "MUSHRAT": "a large semiaquatic North American rodent, resembling a beaver, also MUSKRAT, MUSQUASH [n -S]\n",
  "MUSHRATS": "MUSHRAT, a large semiaquatic North American rodent, resembling a beaver, also MUSKRAT, MUSQUASH [n]\n",
  "MUSHROOM": "to grow or spread rapidly [v -ED, -ING, -S]\n",
  "MUSHROOMED": "MUSHROOM, to grow or spread rapidly [v]\n",
  "MUSHROOMER": "something that mushrooms, expands rapidly [n -S]\n",
  "MUSHROOMERS": "MUSHROOMER, something that mushrooms, expands rapidly [n]\n",
  "MUSHROOMIER": "MUSHROOMY, of or like a mushroom [adj]\n",
  "MUSHROOMIEST": "MUSHROOMY, of or like a mushroom [adj]\n",
  "MUSHROOMING": "rapid growth [n -S]\n",
  "MUSHROOMINGS": "MUSHROOMING, rapid growth [n]\n",
  "MUSHROOMS": "MUSHROOM, to grow or spread rapidly [v]\n",
  "MUSHROOMY": "of or like a mushroom [adj MUSHROOMIER, MUSHROOMIEST]\n",
  "MUSHY": "like mush, soft [adj MUSHIER, MUSHIEST, MUSHILY]\n",
  "MUSIC": "to perform the art of expression in sound, also MUSICK [v MUSICKED, MUSICKING, MUSICS]\n",
  "MUSICAL": "relating to music [adj MUSICALLY] / a show punctuated by songs [n -S]\n",
  "MUSICALE": "(French) a program of music performed at a social gathering [n -S]\n",
  "MUSICALES": "MUSICALE, (French) a program of music performed at a social gathering [n]\n",
  "MUSICALISATION": "the process of musicalising, also MUSICALIZATION [n -S]\n",
  "MUSICALISATIONS": "MUSICALISATION, the process of musicalising, also MUSICALIZATION [n]\n",
  "MUSICALISE": "to make musical, also MUSICALIZE [v MUSICALISED, MUSICALISING, MUSICALISES]\n",
  "MUSICALISED": "MUSICALISE, to make musical, also MUSICALIZE [v]\n",
  "MUSICALISES": "MUSICALISE, to make musical, also MUSICALIZE [v]\n",
  "MUSICALISING": "MUSICALISE, to make musical, also MUSICALIZE [v]\n",
  "MUSICALITIES": "MUSICALITY, sensitivity to, knowledge of, or talent for music [n]\n",
  "MUSICALITY": "sensitivity to, knowledge of, or talent for music [n MUSICALITIES]\n",
  "MUSICALIZATION": "the process of musicalizing, also MUSICALISATION [n -S]\n",
  "MUSICALIZATIONS": "MUSICALIZATION, the process of musicalizing, also MUSICALISATION [n]\n",
  "MUSICALIZE": "to make musical, also MUSICALISE [v MUSICALIZED, MUSICALIZING, MUSICALIZES]\n",
  "MUSICALIZED": "MUSICALIZE, to make musical, also MUSICALISE [v]\n",
  "MUSICALIZES": "MUSICALIZE, to make musical, also MUSICALISE [v]\n",
  "MUSICALIZING": "MUSICALIZE, to make musical, also MUSICALISE [v]\n",
  "MUSICALLY": "MUSICAL, relating to music [adv]\n",
  "MUSICALNESS": "the state of being musical [n -ES]\n",
  "MUSICALNESSES": "MUSICALNESS, the state of being musical [n]\n",
  "MUSICALS": "MUSICAL, a show punctuated by songs [n]\n",
  "MUSICIAN": "one who performs or composes music [n -S]\n",
  "MUSICIANER": "(dialect) a musician [n -S]\n",
  "MUSICIANERS": "MUSICIANER, (dialect) a musician [n]\n",
  "MUSICIANLIER": "MUSICIANLY, like a musician [adj]\n",
  "MUSICIANLIEST": "MUSICIANLY, like a musician [adj]\n",
  "MUSICIANLY": "like a musician [adj MUSICIANLIER, MUSICIANLIEST]\n",
  "MUSICIANS": "MUSICIAN, one who performs or composes music [n]\n",
  "MUSICIANSHIP": "the skills of a musician [n -S]\n",
  "MUSICIANSHIPS": "MUSICIANSHIP, the skills of a musician [n]\n",
  "MUSICK": "to compose music for [v -ED, -ING, -S]\n",
  "MUSICKED": "MUSICK, to compose music for [v]\n",
  "MUSICKER": "(dialect) a musician [n -S]\n",
  "MUSICKERS": "MUSICKER, (dialect) a musician [n]\n",
  "MUSICKING": "MUSICK, to compose music for [v]\n",
  "MUSICKS": "MUSICK, to compose music for [v]\n",
  "MUSICLESS": "without music [adj]\n",
  "MUSICOLOGICAL": "related to musicology [adj MUSICOLOGICALLY]\n",
  "MUSICOLOGICALLY": "MUSICOLOGICAL, related to musicology [adv]\n",
  "MUSICOLOGIES": "MUSICOLOGY, the study of musical theory [n]\n",
  "MUSICOLOGIST": "a student of musicology [n -S]\n",
  "MUSICOLOGISTS": "MUSICOLOGIST, a student of musicology [n]\n",
  "MUSICOLOGY": "the study of musical theory [n MUSICOLOGIES]\n",
  "MUSICOTHERAPIES": "MUSICOTHERAPY, therapy involving the use of music [n]\n",
  "MUSICOTHERAPY": "therapy involving the use of music [n MUSICOTHERAPIES]\n",
  "MUSICS": "MUSIC, to perform the art of expression in sound, also MUSICK [v]\n",
  "MUSIMON": "a Corsican wild sheep, also MOUFFLON, MOUFLON, MUFLON, MUSMON [n -S]\n",
  "MUSIMONS": "MUSIMON, a Corsican wild sheep, also MOUFFLON, MOUFLON, MUFLON, MUSMON [n]\n",
  "MUSING": "reflective [adj MUSINGLY] / the act of musing [n -S]\n",
  "MUSINGLY": "MUSING, reflective [adv]\n",
  "MUSINGS": "MUSING, the act of musing [n]\n",
  "MUSIT": "(Shakespeare) a gap in a fence through which animals pass, also MUSET [n -S]\n",
  "MUSITS": "MUSIT, (Shakespeare) a gap in a fence through which animals pass, also MUSET [n]\n",
  "MUSIVE": "relating to mosaic [adj]\n",
  "MUSJID": "(Arabic) a mosque, also MASJID [n -S]\n",
  "MUSJIDS": "MUSJID, (Arabic) a mosque, also MASJID [n]\n",
  "MUSK": "to perfume with a strong-smelling substance [v -ED, -ING, -S]\n",
  "MUSKED": "MUSK, to perfume with a strong-smelling substance [v]\n",
  "MUSKEG": "(Native American) a marsh, also MASKEG [n -S]\n",
  "MUSKEGS": "MUSKEG, (Native American) a marsh, also MASKEG [n]\n",
  "MUSKELLUNGE": "a North American freshwater fish of the pike family, also MASKALLONGE, MASKALONGE, MASKANONGE, MASKINONGE, MUSKIE [n -S]\n",
  "MUSKELLUNGES": "MUSKELLUNGE, a North American freshwater fish of the pike family, also MASKALLONGE, MASKALONGE, MASKANONGE, MASKINONGE, MUSKIE [n]\n",
  "MUSKET": "a long-barrelled muzzle-loading shoulder gun used between the 16th and 18th centuries by infantry soldiers [n -S]\n",
  "MUSKETEER": "a soldier who uses a musket [n -S]\n",
  "MUSKETEERS": "MUSKETEER, a soldier who uses a musket [n]\n",
  "MUSKETOON": "a short musket; a soldier armed with one, also MUSQUETOON [n -S]\n",
  "MUSKETOONS": "MUSKETOON, a short musket; a soldier armed with one, also MUSQUETOON [n]\n",
  "MUSKETRIES": "MUSKETRY, the technique of firing small arms [n]\n",
  "MUSKETRY": "the technique of firing small arms [n MUSKETRIES]\n",
  "MUSKETS": "MUSKET, a long-barrelled muzzle-loading shoulder gun used between the 16th and 18th centuries by infantry soldiers [n]\n",
  "MUSKIE": "(short for) a muskellunge, a freshwater fish native to North America, also MASKALLONGE, MASKALONGE, MASKANONGE, MASKINONGE, MUSKELLUNGE [n -S]\n",
  "MUSKIER": "MUSKY, resembling musk [adj]\n",
  "MUSKIES": "MUSKIE, (short for) a muskellunge, a freshwater fish native to North America, also MASKALLONGE, MASKALONGE, MASKANONGE, MASKINONGE, MUSKELLUNGE [n]\n",
  "MUSKIEST": "MUSKY, resembling musk [adj]\n",
  "MUSKILY": "MUSKY, resembling musk [adv]\n",
  "MUSKINESS": "the state of being musky [n -ES]\n",
  "MUSKINESSES": "MUSKINESS, the state of being musky [n]\n",
  "MUSKING": "MUSK, to perfume with a strong-smelling substance [v]\n",
  "MUSKIT": "(Nahuatl) a name for two trees of the southwestern part of North America, the honey mesquite, and screw-pod mesquite, also MESQUIT, MESQUITE, MEZQUIT, MEZQUITE [n -S]\n",
  "MUSKITS": "MUSKIT, (Nahuatl) a name for two trees of the southwestern part of North America, the honey mesquite, and screw-pod mesquite, also MESQUIT, MESQUITE, MEZQUIT, MEZQUITE [n]\n",
  "MUSKLE": "(obsolete) a mussel, an edible marine shellfish [n -S]\n",
  "MUSKLES": "MUSKLE, (obsolete) a mussel, an edible marine shellfish [n]\n",
  "MUSKMELON": "the fruit of the melon, esp. a variety with netted rind and aromatic flesh [n -S]\n",
  "MUSKMELONS": "MUSKMELON, the fruit of the melon, esp. a variety with netted rind and aromatic flesh [n]\n",
  "MUSKONE": "a macrocyclic ketone, also MUSCONE [n -S]\n",
  "MUSKONES": "MUSKONE, a macrocyclic ketone, also MUSCONE [n]\n",
  "MUSKOX": "a large bovid of arctic regions [n MUSKOXEN]\n",
  "MUSKOXEN": "MUSKOX, a large bovid of arctic regions [n]\n",
  "MUSKRAT": "a large semiaquatic North American rodent, resembling a beaver, also MUSHRAT, MUSQUASH [n -S]\n",
  "MUSKRATS": "MUSKRAT, a large semiaquatic North American rodent, resembling a beaver, also MUSHRAT, MUSQUASH [n]\n",
  "MUSKROOT": "a plant of the genus Adoxa, the flowers of which are pale green, and have a faint musky smell [n -S]\n",
  "MUSKROOTS": "MUSKROOT, a plant of the genus Adoxa, the flowers of which are pale green, and have a faint musky smell [n]\n",
  "MUSKS": "MUSK, to perfume with a strong-smelling substance [v]\n",
  "MUSKY": "resembling musk [adj MUSKIER, MUSKIEST, MUSKILY]\n",
  "MUSLIN": "a cotton fabric [n -S]\n",
  "MUSLINED": "clothed with muslin [adj]\n",
  "MUSLINET": "a coarse kind of muslin [n -S]\n",
  "MUSLINETS": "MUSLINET, a coarse kind of muslin [n]\n",
  "MUSLINS": "MUSLIN, a cotton fabric [n]\n",
  "MUSMON": "a Corsican wild sheep, also MOUFFLON, MOUFLON, MUFLON, MUSIMON [n -S]\n",
  "MUSMONS": "MUSMON, a Corsican wild sheep, also MOUFFLON, MOUFLON, MUFLON, MUSIMON [n]\n",
  "MUSO": "(Australian slang) a musician [n -S]\n",
  "MUSOS": "MUSO, (Australian slang) a musician [n]\n",
  "MUSPIKE": "a freshwater fish [n -S]\n",
  "MUSPIKES": "MUSPIKE, a freshwater fish [n]\n",
  "MUSQUASH": "a large semiaquatic North American rodent, resembling a beaver, also MUSHRAT, MUSKRAT [n -ES]\n",
  "MUSQUASHES": "MUSQUASH, a large semiaquatic North American rodent, resembling a beaver, also MUSHRAT, MUSKRAT [n]\n",
  "MUSQUETOON": "a short musket; a soldier armed with one, also MUSKETOON [n -S]\n",
  "MUSQUETOONS": "MUSQUETOON, a short musket; a soldier armed with one, also MUSKETOON [n]\n",
  "MUSROL": "(obsolete) the noseband of a bridle [n -S]\n",
  "MUSROLS": "MUSROL, (obsolete) the noseband of a bridle [n]\n",
  "MUSS": "to disarrange, to mess, also MUSSE [v -ED, -ING, -ES]\n",
  "MUSSE": "to disarrange, to mess, also MUSS [v MUSSED, MUSSING, MUSSES]\n",
  "MUSSED": "MUSS, to disarrange, to mess, also MUSSE [v]\n",
  "MUSSEL": "any of various marine bivalves, also MUSKLE [n -S]\n",
  "MUSSELCRACKER": "a large sea bream that feeds on shellfish [n -S]\n",
  "MUSSELCRACKERS": "MUSSELCRACKER, a large sea bream that feeds on shellfish [n]\n",
  "MUSSELLED": "poisoned by eating an infected mussel [adj]\n",
  "MUSSELS": "MUSSEL, any of various marine bivalves, also MUSKLE [n]\n",
  "MUSSES": "MUSS, to disarrange, to mess, also MUSSE [v]\n",
  "MUSSIER": "MUSSY, disarranged, rumpled [adj]\n",
  "MUSSIEST": "MUSSY, disarranged, rumpled [adj]\n",
  "MUSSILY": "MUSSY, disarranged, rumpled [adv]\n",
  "MUSSINESS": "mess, confusion [n -ES]\n",
  "MUSSINESSES": "MUSSINESS, mess, confusion [n]\n",
  "MUSSING": "MUSS, to disarrange, to mess, also MUSSE [v]\n",
  "MUSSITATE": "(obsolete) to mutter [v MUSSITATED, MUSSITATING, MUSSITATES]\n",
  "MUSSITATED": "MUSSITATE, (obsolete) to mutter [v]\n",
  "MUSSITATES": "MUSSITATE, (obsolete) to mutter [v]\n",
  "MUSSITATING": "MUSSITATE, (obsolete) to mutter [v]\n",
  "MUSSITATION": "muttering to oneself soundlessly; murmuring [n -S]\n",
  "MUSSITATIONS": "MUSSITATION, muttering to oneself soundlessly; murmuring [n]\n",
  "MUSSY": "disarranged, rumpled [adj MUSSIER, MUSSIEST, MUSSILY]\n",
  "MUST": "to powder, also MOUST, MUIST [v -ED, -ING, -S]\n",
  "MUSTACHE": "the unshaved hair on a man's upper lip, also MOUSTACHE [n -S]\n",
  "MUSTACHED": "having a mustache [adj]\n",
  "MUSTACHES": "MUSTACHE, the unshaved hair on a man's upper lip, also MOUSTACHE [n]\n",
  "MUSTACHIO": "(Spanish) a large, elegantly curling moustache, also MOUSTACHIO [n -S]\n",
  "MUSTACHIOED": "having a mustachio [adj]\n",
  "MUSTACHIOS": "MUSTACHIO, (Spanish) a large, elegantly curling moustache, also MOUSTACHIO [n]\n",
  "MUSTANG": "the wild or half-wild horse of the American plains [n -S]\n",
  "MUSTANGS": "MUSTANG, the wild or half-wild horse of the American plains [n]\n",
  "MUSTARD": "a pungent condiment prepared from the seeds of the mustard plant [n -S]\n",
  "MUSTARDIER": "MUSTARDY, like mustard [adj]\n",
  "MUSTARDIEST": "MUSTARDY, like mustard [adj]\n",
  "MUSTARDS": "MUSTARD, a pungent condiment prepared from the seeds of the mustard plant [n]\n",
  "MUSTARDY": "like mustard [adj MUSTARDIER, MUSTARDIEST]\n",
  "MUSTED": "MUST, to powder, also MOUST, MUIST [v]\n",
  "MUSTEE": "in the West Indies, the offspring of a white person and a quadroon, aka octoroon, also MESTEE [n -S]\n",
  "MUSTEES": "MUSTEE, in the West Indies, the offspring of a white person and a quadroon, aka octoroon, also MESTEE [n]\n",
  "MUSTELID": "a mammal of the weasel family [n -S]\n",
  "MUSTELIDS": "MUSTELID, a mammal of the weasel family [n]\n",
  "MUSTELINE": "a weasel or similar fur-bearing mammal such as badger and otter [n -S]\n",
  "MUSTELINES": "MUSTELINE, a weasel or similar fur-bearing mammal such as badger and otter [n]\n",
  "MUSTER": "to gather together [v -ED, -ING, -S]\n",
  "MUSTERED": "MUSTER, to gather together [v]\n",
  "MUSTERER": "one who musters (livestock) [n -S]\n",
  "MUSTERERS": "MUSTERER, one who musters (livestock) [n]\n",
  "MUSTERING": "MUSTER, to gather together [v]\n",
  "MUSTERS": "MUSTER, to gather together [v]\n",
  "MUSTH": "(Hindi) a state of frenzy occurring in male elephants [n -S]\n",
  "MUSTHS": "MUSTH, (Hindi) a state of frenzy occurring in male elephants [n]\n",
  "MUSTIER": "MUSTY, having a stale odour [adj]\n",
  "MUSTIEST": "MUSTY, having a stale odour [adj]\n",
  "MUSTILY": "MUSTY, having a stale odour [adv]\n",
  "MUSTINESS": "the state of being musty [n -ES]\n",
  "MUSTINESSES": "MUSTINESS, the state of being musty [n]\n",
  "MUSTING": "MUST, to powder, also MOUST, MUIST [v]\n",
  "MUSTS": "MUST, to powder, also MOUST, MUIST [v]\n",
  "MUSTY": "having a stale odour [adj MUSTIER, MUSTIEST, MUSTILY]\n",
  "MUT": "a mongrel dog, also MUTT [n -S]\n",
  "MUTABILITIES": "MUTABILITY, the quality of being mutable [n]\n",
  "MUTABILITY": "the quality of being mutable [n MUTABILITIES]\n",
  "MUTABLE": "capable of change [adj MUTABLY]\n",
  "MUTABLENESS": "the state of being mutable [n -ES]\n",
  "MUTABLENESSES": "MUTABLENESS, the state of being mutable [n]\n",
  "MUTABLY": "MUTABLE, capable of change [adv]\n",
  "MUTAGEN": "a substance that causes biological mutation [n -S]\n",
  "MUTAGENESES": "MUTAGENESIS, the origin or induction of a mutation [n]\n",
  "MUTAGENESIS": "the origin or induction of a mutation [n MUTAGENESES]\n",
  "MUTAGENIC": "inducing mutations [adj MUTAGENICALLY]\n",
  "MUTAGENICALLY": "MUTAGENIC, inducing mutations [adv]\n",
  "MUTAGENICITIES": "MUTAGENICITY, the capacity to induce mutations [n]\n",
  "MUTAGENICITY": "the capacity to induce mutations [n MUTAGENICITIES]\n",
  "MUTAGENISE": "to treat with mutagens, also MUTAGENIZE [v MUTAGENISED, MUTAGENISING, MUTAGENISES]\n",
  "MUTAGENISED": "MUTAGENISE, to treat with mutagens, also MUTAGENIZE [v]\n",
  "MUTAGENISES": "MUTAGENISE, to treat with mutagens, also MUTAGENIZE [v]\n",
  "MUTAGENISING": "MUTAGENISE, to treat with mutagens, also MUTAGENIZE [v]\n",
  "MUTAGENIZE": "to treat with mutagens, also MUTAGENISE [v MUTAGENIZED, MUTAGENIZING, MUTAGENIZES]\n",
  "MUTAGENIZED": "MUTAGENIZE, to treat with mutagens, also MUTAGENISE [v]\n",
  "MUTAGENIZES": "MUTAGENIZE, to treat with mutagens, also MUTAGENISE [v]\n",
  "MUTAGENIZING": "MUTAGENIZE, to treat with mutagens, also MUTAGENISE [v]\n",
  "MUTAGENS": "MUTAGEN, a substance that causes biological mutation [n]\n",
  "MUTANDA": "MUTANDUM, (Latin) something to be altered [n]\n",
  "MUTANDUM": "(Latin) something to be altered [n MUTANDA]\n",
  "MUTANT": "something that undergoes mutation [n -S]\n",
  "MUTANTS": "MUTANT, something that undergoes mutation [n]\n",
  "MUTASE": "any of various enzymes that catalyze molecular rearrangements [n -S]\n",
  "MUTASES": "MUTASE, any of various enzymes that catalyze molecular rearrangements [n]\n",
  "MUTATE": "to undergo mutation [v MUTATED, MUTATING, MUTATES]\n",
  "MUTATED": "MUTATE, to undergo mutation [v]\n",
  "MUTATES": "MUTATE, to undergo mutation [v]\n",
  "MUTATING": "MUTATE, to undergo mutation [v]\n",
  "MUTATION": "the act of changing [n -S]\n",
  "MUTATIONAL": "relating to a mutation [adj MUTATIONALLY]\n",
  "MUTATIONALLY": "MUTATIONAL, relating to a mutation [adv]\n",
  "MUTATIONIST": "a believer in evolution by mutation [n -S]\n",
  "MUTATIONISTS": "MUTATIONIST, a believer in evolution by mutation [n]\n",
  "MUTATIONS": "MUTATION, the act of changing [n]\n",
  "MUTATIVE": "changing, mutable, also MUTATORY [adj]\n",
  "MUTATOR": "one that causes a change in form [n -S]\n",
  "MUTATORS": "MUTATOR, one that causes a change in form [n]\n",
  "MUTATORY": "changing, mutable, also MUTATIVE [adj]\n",
  "MUTCH": "a close-fitting cap [n -ES] / to cadge [v -ED, -ING, -ES]\n",
  "MUTCHED": "MUTCH, to cadge [v]\n",
  "MUTCHES": "MUTCH, to cadge [v]\n",
  "MUTCHING": "MUTCH, to cadge [v]\n",
  "MUTCHKIN": "(historical) an old unit of liquid measurement equal to 3/4 of an imperial pint [n -S]\n",
  "MUTCHKINS": "MUTCHKIN, (historical) an old unit of liquid measurement equal to 3/4 of an imperial pint [n]\n",
  "MUTE": "dumb [adj MUTER, MUTEST, MUTELY] / to deaden the sound of [v MUTED, MUTING, MUTES]\n",
  "MUTED": "MUTE, to deaden the sound of [v]\n",
  "MUTEDLY": "MUTED, MUTE, to deaden the sound of [adv]\n",
  "MUTELY": "MUTE, dumb [adv]\n",
  "MUTENESS": "the state of being mute [n -ES]\n",
  "MUTENESSES": "MUTENESS, the state of being mute [n]\n",
  "MUTER": "MUTE, dumb [adj]\n",
  "MUTES": "MUTE, to deaden the sound of [v]\n",
  "MUTESSARIF": "(Turkish) the head of a Turkish sanjak, a district or a subdivision of a vilayet [n -S]\n",
  "MUTESSARIFAT": "the office of a mutessarif, the head of a Turkish sanjak, a district or a subdivision of a vilayet [n -S]\n",
  "MUTESSARIFATS": "MUTESSARIFAT, the office of a mutessarif, the head of a Turkish sanjak, a district or a subdivision of a vilayet [n]\n",
  "MUTESSARIFS": "MUTESSARIF, (Turkish) the head of a Turkish sanjak, a district or a subdivision of a vilayet [n]\n",
  "MUTEST": "MUTE, dumb [adj]\n",
  "MUTHA": "(vulgar slang) an obnoxious person [n -S]\n",
  "MUTHAS": "MUTHA, (vulgar slang) an obnoxious person [n]\n",
  "MUTI": "(Zulu) a traditional medicine, associated with witch-doctors [n -S]\n",
  "MUTICATE": "in botany, having no point or awn, also MUTICOUS [adj]\n",
  "MUTICOUS": "in botany, having no point or awn, also MUTICATE [adj]\n",
  "MUTILATE": "to injure by cutting off limbs [v MUTILATED, MUTILATING, MUTILATES]\n",
  "MUTILATED": "MUTILATE, to injure by cutting off limbs [v]\n",
  "MUTILATES": "MUTILATE, to injure by cutting off limbs [v]\n",
  "MUTILATING": "MUTILATE, to injure by cutting off limbs [v]\n",
  "MUTILATION": "the act of mutilating [n -S]\n",
  "MUTILATIONS": "MUTILATION, the act of mutilating [n]\n",
  "MUTILATIVE": "causing mutilation [adj]\n",
  "MUTILATOR": "one who mutilates [n -S]\n",
  "MUTILATORS": "MUTILATOR, one who mutilates [n]\n",
  "MUTINE": "to revolt against constituted authority, also MUTINY, MUTINEER [v MUTINED, MUTINING, MUTINES]\n",
  "MUTINED": "MUTINE, to revolt against constituted authority, also MUTINY, MUTINEER [v]\n",
  "MUTINEER": "to revolt against constituted authority, also MUTINY, MUTINE [v -ED, -ING, -S]\n",
  "MUTINEERED": "MUTINEER, to revolt against constituted authority, also MUTINY, MUTINE [v]\n",
  "MUTINEERING": "MUTINEER, to revolt against constituted authority, also MUTINY, MUTINE [v]\n",
  "MUTINEERS": "MUTINEER, to revolt against constituted authority, also MUTINY, MUTINE [v]\n",
  "MUTINES": "MUTINE, to revolt against constituted authority, also MUTINY, MUTINEER [v]\n",
  "MUTING": "MUTE, to deaden the sound of [v]\n",
  "MUTINIED": "MUTINY, to revolt against constituted authority, also MUTINE, MUTINEER [v]\n",
  "MUTINIES": "MUTINY, to revolt against constituted authority, also MUTINE, MUTINEER [v]\n",
  "MUTINING": "MUTINE, to revolt against constituted authority, also MUTINY, MUTINEER [v]\n",
  "MUTINOUS": "disposed to mutiny [adj MUTINOUSLY]\n",
  "MUTINOUSLY": "MUTINOUS, disposed to mutiny [adv]\n",
  "MUTINOUSNESS": "the state of being mutinous [n -ES]\n",
  "MUTINOUSNESSES": "MUTINOUSNESS, the state of being mutinous [n]\n",
  "MUTINY": "to revolt against constituted authority, also MUTINE, MUTINEER [v MUTINIED, MUTINYING, MUTINIES]\n",
  "MUTINYING": "MUTINY, to revolt against constituted authority, also MUTINE, MUTINEER [v]\n",
  "MUTIS": "MUTI, (Zulu) a traditional medicine, associated with witch-doctors [n]\n",
  "MUTISM": "the condition of being mute [n -S]\n",
  "MUTISMS": "MUTISM, the condition of being mute [n]\n",
  "MUTON": "a unit of nucleic acid [n -S]\n",
  "MUTONS": "MUTON, a unit of nucleic acid [n]\n",
  "MUTOSCOPE": "an early form of cinematograph [n -S]\n",
  "MUTOSCOPES": "MUTOSCOPE, an early form of cinematograph [n]\n",
  "MUTS": "MUT, a mongrel dog, also MUTT [n]\n",
  "MUTT": "a mongrel dog, also MUT [n -S]\n",
  "MUTTER": "to speak unclearly [v -ED, -ING, -S]\n",
  "MUTTERATION": "(Richardson) complaining [n -S]\n",
  "MUTTERATIONS": "MUTTERATION, (Richardson) complaining [n]\n",
  "MUTTERED": "MUTTER, to speak unclearly [v]\n",
  "MUTTERER": "one who mutters [n -S]\n",
  "MUTTERERS": "MUTTERER, one who mutters [n]\n",
  "MUTTERING": "making a muttering sound [adj MUTTERINGLY] / the act of muttering [n -S]\n",
  "MUTTERINGLY": "MUTTERING, making a muttering sound [adv]\n",
  "MUTTERINGS": "MUTTERING, the act of muttering [n]\n",
  "MUTTERS": "MUTTER, to speak unclearly [v]\n",
  "MUTTON": "the flesh of sheep used as food [n -S]\n",
  "MUTTONBIRD": "an Australasian shearwater, esp. the short-tailed, said by some to taste like mutton [n -S]\n",
  "MUTTONBIRDER": "(New Zealand) a person who hunts muttonbirds [n -S]\n",
  "MUTTONBIRDERS": "MUTTONBIRDER, (New Zealand) a person who hunts muttonbirds [n]\n",
  "MUTTONBIRDS": "MUTTONBIRD, an Australasian shearwater, esp. the short-tailed, said by some to taste like mutton [n]\n",
  "MUTTONCHOPS": "(US) side whiskers that are narrow at the temple and broad and round by the lower jaws [n]\n",
  "MUTTONFISH": "a common food fish of the Western Atlantic [n -ES]\n",
  "MUTTONFISHES": "MUTTONFISH, a common food fish of the Western Atlantic [n]\n",
  "MUTTONHEAD": "a heavy, stupid person [n -S]\n",
  "MUTTONHEADED": "stupid [adj]\n",
  "MUTTONHEADS": "MUTTONHEAD, a heavy, stupid person [n]\n",
  "MUTTONIER": "MUTTONY, like mutton; having a flavor of mutton [adj]\n",
  "MUTTONIEST": "MUTTONY, like mutton; having a flavor of mutton [adj]\n",
  "MUTTONS": "MUTTON, the flesh of sheep used as food [n]\n",
  "MUTTONY": "like mutton; having a flavor of mutton [adj MUTTONIER, MUTTONIEST]\n",
  "MUTTS": "MUTT, a mongrel dog, also MUT [n]\n",
  "MUTUAL": "shared in common [adj MUTUALLY] / a financial institution owned by its customers [n -S]\n",
  "MUTUALISATION": "the process of mutualising, also MUTUALIZATION [n -S]\n",
  "MUTUALISATIONS": "MUTUALISATION, the process of mutualising, also MUTUALIZATION [n]\n",
  "MUTUALISE": "to organize (a company etc.) on cooperative or mutual principles, also MUTUALIZE [v MUTUALISED, MUTUALISING, MUTUALISES]\n",
  "MUTUALISED": "MUTUALISE, to organize (a company etc.) on cooperative or mutual principles, also MUTUALIZE [v]\n",
  "MUTUALISES": "MUTUALISE, to organize (a company etc.) on cooperative or mutual principles, also MUTUALIZE [v]\n",
  "MUTUALISING": "MUTUALISE, to organize (a company etc.) on cooperative or mutual principles, also MUTUALIZE [v]\n",
  "MUTUALISM": "a belief in the mutual dependence of society and the individual [n -S]\n",
  "MUTUALISMS": "MUTUALISM, a belief in the mutual dependence of society and the individual [n]\n",
  "MUTUALIST": "an advocate of mutualism, a belief in the mutual dependence of society and the individual [n -S]\n",
  "MUTUALISTIC": "relating to mutualism [adj]\n",
  "MUTUALISTS": "MUTUALIST, an advocate of mutualism, a belief in the mutual dependence of society and the individual [n]\n",
  "MUTUALITIES": "MUTUALITY, the state of being mutual [n]\n",
  "MUTUALITY": "the state of being mutual [n MUTUALITIES]\n",
  "MUTUALIZATION": "the process of mutualizing, also MUTUALISATION [n -S]\n",
  "MUTUALIZATIONS": "MUTUALIZATION, the process of mutualizing, also MUTUALISATION [n]\n",
  "MUTUALIZE": "to organize (a company etc.) on cooperative or mutual principles, also MUTUALISE [v MUTUALIZED, MUTUALIZING, MUTUALIZES]\n",
  "MUTUALIZED": "MUTUALIZE, to organize (a company etc.) on cooperative or mutual principles, also MUTUALISE [v]\n",
  "MUTUALIZES": "MUTUALIZE, to organize (a company etc.) on cooperative or mutual principles, also MUTUALISE [v]\n",
  "MUTUALIZING": "MUTUALIZE, to organize (a company etc.) on cooperative or mutual principles, also MUTUALISE [v]\n",
  "MUTUALLY": "MUTUAL, shared in common [adv]\n",
  "MUTUALNESS": "the state of being mutual [n -ES]\n",
  "MUTUALNESSES": "MUTUALNESS, the state of being mutual [n]\n",
  "MUTUALS": "MUTUAL, a financial institution owned by its customers [n]\n",
  "MUTUCA": "(Tupi) a large Brazilian biting fly, also MOTUCA [n -S]\n",
  "MUTUCAS": "MUTUCA, (Tupi) a large Brazilian biting fly, also MOTUCA [n]\n",
  "MUTUEL": "(French) a system of betting on races [n -S]\n",
  "MUTUELS": "MUTUEL, (French) a system of betting on races [n]\n",
  "MUTULAR": "relating to a mutule, a kind of square, flat bracket, in Doric architecture [adj]\n",
  "MUTULE": "(Latin) an ornamental block used in classical Greek architecture [n -S]\n",
  "MUTULES": "MUTULE, (Latin) an ornamental block used in classical Greek architecture [n]\n",
  "MUTUUM": "(historical) a bailment consisting of goods for consumption, such as corn, coal etc., to be returned in goods of the same amount [n -S]\n",
  "MUTUUMS": "MUTUUM, (historical) a bailment consisting of goods for consumption, such as corn, coal etc., to be returned in goods of the same amount [n]\n",
  "MUUMUU": "(Hawaiian) a long loose dress, also MUMU [n -S]\n",
  "MUUMUUS": "MUUMUU, (Hawaiian) a long loose dress, also MUMU [n]\n",
  "MUX": "to spoil, botch [v -ED, -ING, -ES]\n",
  "MUXED": "MUX, to spoil, botch [v]\n",
  "MUXES": "MUX, to spoil, botch [v]\n",
  "MUXING": "MUX, to spoil, botch [v]\n",
  "MUZAK": "piped background music [n -S]\n",
  "MUZAKIER": "MUZAKY, cheap and sentimental [adj]\n",
  "MUZAKIEST": "MUZAKY, cheap and sentimental [adj]\n",
  "MUZAKS": "MUZAK, piped background music [n]\n",
  "MUZAKY": "cheap and sentimental [adj MUZAKIER, MUZAKIEST]\n",
  "MUZHIK": "(Russian) a Russian peasant, also MOUJIK, MUJIK, MUZJIK [n -S]\n",
  "MUZHIKS": "MUZHIK, (Russian) a Russian peasant, also MOUJIK, MUJIK, MUZJIK [n]\n",
  "MUZJIK": "(Russian) a Russian peasant, also MUZHIK, MOUJIK, MUJIK [n -S]\n",
  "MUZJIKS": "MUZJIK, (Russian) a Russian peasant, also MUZHIK, MOUJIK, MUJIK [n]\n",
  "MUZZ": "to make muzzy (confused) [v -ED, -ING, -ES]\n",
  "MUZZED": "MUZZ, to make muzzy (confused) [v]\n",
  "MUZZES": "MUZZ, to make muzzy (confused) [v]\n",
  "MUZZIER": "MUZZY, confused [adj]\n",
  "MUZZIEST": "MUZZY, confused [adj]\n",
  "MUZZILY": "MUZZY, confused [adv]\n",
  "MUZZINESS": "the state of being muzzy [n -ES]\n",
  "MUZZINESSES": "MUZZINESS, the state of being muzzy [n]\n",
  "MUZZING": "MUZZ, to make muzzy (confused) [v]\n",
  "MUZZLE": "to cover the mouth of [v MUZZLED, MUZZLING, MUZZLES]\n",
  "MUZZLED": "MUZZLE, to cover the mouth of [v]\n",
  "MUZZLER": "a strong headwind [n -S]\n",
  "MUZZLERS": "MUZZLER, a strong headwind [n]\n",
  "MUZZLES": "MUZZLE, to cover the mouth of [v]\n",
  "MUZZLING": "MUZZLE, to cover the mouth of [v]\n",
  "MUZZY": "confused [adj MUZZIER, MUZZIEST, MUZZILY]\n",
  "MVULE": "(Swahili) an African tree [n -S]\n",
  "MVULES": "MVULE, (Swahili) an African tree [n]\n",
  "MWAH": "a representation of the sound of a kiss [interj]\n",
  "MWALIMU": "(Swahili) a teacher [n -S]\n",
  "MWALIMUS": "MWALIMU, (Swahili) a teacher [n]\n",
  "MY": "possessive form of I [adj]\n",
  "MYAL": "relating to myalism, a magic cult among West Indian blacks [adj]\n",
  "MYALGIA": "(Greek) muscular pain [n -S]\n",
  "MYALGIAS": "MYALGIA, (Greek) muscular pain [n]\n",
  "MYALGIC": "relating to myalgia, pain in the muscles [adj]\n",
  "MYALISM": "a magic cult among West Indian blacks [n -S]\n",
  "MYALISMS": "MYALISM, a magic cult among West Indian blacks [n]\n",
  "MYALIST": "one who practises myalism, a magic cult among West Indian blacks [n -S]\n",
  "MYALISTS": "MYALIST, one who practises myalism, a magic cult among West Indian blacks [n]\n",
  "MYALL": "(Native Australian) an Australian aborigine living traditionally [n -S]\n",
  "MYALLS": "MYALL, (Native Australian) an Australian aborigine living traditionally [n]\n",
  "MYASES": "MYASIS, infestation of human tissue by fly maggots, also MYIASIS [n]\n",
  "MYASIS": "infestation of human tissue by fly maggots, also MYIASIS [n MYASES]\n",
  "MYASTHENIA": "muscular weakness or debility [n -S]\n",
  "MYASTHENIAS": "MYASTHENIA, muscular weakness or debility [n]\n",
  "MYASTHENIC": "one suffering from myasthenia, muscular weakness or debility [n -S]\n",
  "MYASTHENICS": "MYASTHENIC, one suffering from myasthenia, muscular weakness or debility [n]\n",
  "MYC": "a cancer-causing gene [n -S]\n",
  "MYCELE": "the white threads or filamentous growth from which a mushroom or fungus is developed, also MYCELIUM [n -S]\n",
  "MYCELES": "MYCELE, the white threads or filamentous growth from which a mushroom or fungus is developed, also MYCELIUM [n]\n",
  "MYCELIA": "MYCELIUM, (Greek) the white threads or filamentous growth from which a mushroom or fungus is developed, also MYCELE [n]\n",
  "MYCELIAL": "relating to mycelium, the white threads or filamentous growth from which a mushroom or fungus is developed, also MYCELIAN [adj]\n",
  "MYCELIAN": "relating to mycelium, the white threads or filamentous growth from which a mushroom or fungus is developed, also MYCELIAL [adj]\n",
  "MYCELIUM": "(Greek) the white threads or filamentous growth from which a mushroom or fungus is developed, also MYCELE [n MYCELIA]\n",
  "MYCELLA": "a blue-veined Danish cream cheese [n -S]\n",
  "MYCELLAS": "MYCELLA, a blue-veined Danish cream cheese [n]\n",
  "MYCELOID": "resembling mycelium, the white threads or filamentous growth from which a mushroom or fungus is developed [adj]\n",
  "MYCETES": "(Greek) fungi [n]\n",
  "MYCETOLOGIES": "MYCETOLOGY, the study of fungi [n]\n",
  "MYCETOLOGY": "the study of fungi [n MYCETOLOGIES]\n",
  "MYCETOMA": "a chronic fungus infection leading to nodules that discharge oily pus [n MYCETOMATA or MYCETOMAS]\n",
  "MYCETOMAS": "MYCETOMA, a chronic fungus infection leading to nodules that discharge oily pus [n]\n",
  "MYCETOMATA": "MYCETOMA, a chronic fungus infection leading to nodules that discharge oily pus [n]\n",
  "MYCETOMATOUS": "of or like mycetoma, a chronic fungus infection [adj]\n",
  "MYCETOPHAGOUS": "eating fungi [adj]\n",
  "MYCETOZOAN": "slime mold [n -S]\n",
  "MYCETOZOANS": "MYCETOZOAN, slime mold [n]\n",
  "MYCOBACTERIA": "MYCOBACTERIUM, any of a genus of bacteria that includes the pathogens causing tuberculosis and leprosy [n]\n",
  "MYCOBACTERIAL": "relating to mycobacteria [adj]\n",
  "MYCOBACTERIUM": "any of a genus of bacteria that includes the pathogens causing tuberculosis and leprosy [n MYCOBACTERIA]\n",
  "MYCOBIONT": "the fungal constituent of a lichen [n -S]\n",
  "MYCOBIONTS": "MYCOBIONT, the fungal constituent of a lichen [n]\n",
  "MYCODOMATIA": "MYCODOMATIUM, a fungus gall [n]\n",
  "MYCODOMATIUM": "a fungus gall [n MYCODOMATIA]\n",
  "MYCOFLORA": "the fungi characteristic of a region [n MYCOFLORAE or MYCOFLORAS]\n",
  "MYCOFLORAE": "MYCOFLORA, the fungi characteristic of a region [n]\n",
  "MYCOFLORAS": "MYCOFLORA, the fungi characteristic of a region [n]\n",
  "MYCOLOGIC": "of or relating to mycology, the study of fungi, also MYCOLOGICAL [adj MYCOLOGICALLY]\n",
  "MYCOLOGICAL": "of or relating to mycology, the study of fungi, also MYCOLOGIC [adj MYCOLOGICALLY]\n",
  "MYCOLOGICALLY": "MYCOLOGICAL, of or relating to mycology, the study of fungi, also MYCOLOGIC [adv]\n",
  "MYCOLOGIES": "MYCOLOGY, the branch of botany dealing with fungi [n]\n",
  "MYCOLOGIST": "one who studies mycology [n -S]\n",
  "MYCOLOGISTS": "MYCOLOGIST, one who studies mycology [n]\n",
  "MYCOLOGY": "the branch of botany dealing with fungi [n MYCOLOGIES]\n",
  "MYCOPHAGIES": "MYCOPHAGY, the eating of mushrooms [n]\n",
  "MYCOPHAGIST": "an eater of mushrooms [n -S]\n",
  "MYCOPHAGISTS": "MYCOPHAGIST, an eater of mushrooms [n]\n",
  "MYCOPHAGOUS": "eating fungus [adj]\n",
  "MYCOPHAGY": "the eating of mushrooms [n MYCOPHAGIES]\n",
  "MYCOPHILE": "one who loves fungi [n -S]\n",
  "MYCOPHILES": "MYCOPHILE, one who loves fungi [n]\n",
  "MYCOPLASMA": "a member of the Mycoplasma, a variety of pathogenic agents apparently neither viruses not true bacteria [n MYCOPLASMAS or MYCOPLASMATA]\n",
  "MYCOPLASMAL": "relating to mycoplasma, a member of the Mycoplasma [adj]\n",
  "MYCOPLASMAS": "MYCOPLASMA, a member of the Mycoplasma, a variety of pathogenic agents apparently neither viruses not true bacteria [n]\n",
  "MYCOPLASMATA": "MYCOPLASMA, a member of the Mycoplasma, a variety of pathogenic agents apparently neither viruses not true bacteria [n]\n",
  "MYCOPLASMOSES": "MYCOPLASMOSIS, infection by Mycoplasma [n]\n",
  "MYCOPLASMOSIS": "infection by Mycoplasma [n MYCOPLASMOSES]\n",
  "MYCORHIZA": "a fungus associated with the root of a plant, the association of mutual benefit, also MYCORRHIZA [n MYCORHIZAS or MYCORHIZAE]\n",
  "MYCORHIZAE": "MYCORHIZA, a fungus associated with the root of a plant, the association of mutual benefit, also MYCORRHIZA [n]\n",
  "MYCORHIZAL": "of or like a mycorhiza, a fungus associated with the root of a plant, the association being of mutual benefit, also MYCORRHIZAL [adj]\n",
  "MYCORHIZAS": "MYCORHIZA, a fungus associated with the root of a plant, the association of mutual benefit, also MYCORRHIZA [n]\n",
  "MYCORRHIZA": "a fungus associated with the root of a plant, the association of mutual benefit, also MYCORHIZA [n MYCORRHIZAE or MYCORRHIZAS]\n",
  "MYCORRHIZAE": "MYCORRHIZA, a fungus associated with the root of a plant, the association of mutual benefit, also MYCORHIZA [n]\n",
  "MYCORRHIZAL": "of or like a mycorhiza, a fungus associated with the root of a plant, the association being of mutual benefit, also MYCORHIZAL [adj]\n",
  "MYCORRHIZAS": "MYCORRHIZA, a fungus associated with the root of a plant, the association of mutual benefit, also MYCORHIZA [n]\n",
  "MYCOSES": "MYCOSIS, a disease caused by a fungus [n]\n",
  "MYCOSIS": "a disease caused by a fungus [n MYCOSES]\n",
  "MYCOTIC": "relating to mycosis, a fungal disease [adj]\n",
  "MYCOTOXICOLOGY": "the study of fungal poisons [n]\n",
  "MYCOTOXICOSES": "MYCOTOXICOSIS, poisoning caused by a mycotoxin [n]\n",
  "MYCOTOXICOSIS": "poisoning caused by a mycotoxin [n MYCOTOXICOSES]\n",
  "MYCOTOXIN": "a poison derived from fungi [n -S]\n",
  "MYCOTOXINS": "MYCOTOXIN, a poison derived from fungi [n]\n",
  "MYCOTOXOLOGIES": "MYCOTOXOLOGY, the study of mycotoxins [n]\n",
  "MYCOTOXOLOGY": "the study of mycotoxins [n MYCOTOXOLOGIES]\n",
  "MYCOTROPHIC": "of a plant, living in symbiosis with a fungus [adj]\n",
  "MYCOVIRUS": "a virus attacking fungi [n -ES]\n",
  "MYCOVIRUSES": "MYCOVIRUS, a virus attacking fungi [n]\n",
  "MYCS": "MYC, a cancer-causing gene [n]\n",
  "MYDRIASES": "MYDRIASIS, morbid dilatation of the pupil of the eye [n]\n",
  "MYDRIASIS": "morbid dilatation of the pupil of the eye [n MYDRIASES]\n",
  "MYDRIATIC": "causing dilatation of the pupil of the eye [adj] / a substance causing dilatation of the pupil of the eye [n -S]\n",
  "MYDRIATICS": "MYDRIATIC, a substance causing dilatation of the pupil of the eye [n]\n",
  "MYELENCEPHALA": "MYELENCEPHALON, the posterior part of the developing vertebrate hindbrain or the corresponding part of the adult brain composed of the medulla oblongata [n]\n",
  "MYELENCEPHALIC": "of or like the myelencephalon [adj]\n",
  "MYELENCEPHALON": "the posterior part of the developing vertebrate hindbrain or the corresponding part of the adult brain composed of the medulla oblongata [n MYELENCEPHALA or MYELENCEPHALONS]\n",
  "MYELENCEPHALONS": "MYELENCEPHALON, the posterior part of the developing vertebrate hindbrain or the corresponding part of the adult brain composed of the medulla oblongata [n]\n",
  "MYELIN": "the fatty substance forming the medullary sheath of nerve-fibres, also MYELINE [n -S]\n",
  "MYELINATED": "of a nerve fibre, enclosed in a myelin sheath [adj]\n",
  "MYELINE": "the fatty substance forming the medullary sheath of nerve-fibres, also MYELIN [n -S]\n",
  "MYELINES": "MYELINE, the fatty substance forming the medullary sheath of nerve-fibres, also MYELIN [n]\n",
  "MYELINIC": "relating to myelin, the substance forming the medullary sheath of nerve-fibres [adj]\n",
  "MYELINS": "MYELIN, the fatty substance forming the medullary sheath of nerve-fibres, also MYELINE [n]\n",
  "MYELITES": "MYELITIS, inflammation of the spinal marrow or its membranes [n]\n",
  "MYELITIDES": "MYELITIS, inflammation of the spinal marrow or its membranes [n]\n",
  "MYELITIS": "inflammation of the spinal marrow or its membranes [n MYELITISES, MYELITIDES or MYELITES]\n",
  "MYELITISES": "MYELITIS, inflammation of the spinal marrow or its membranes [n]\n",
  "MYELOBLAST": "an immature cell of bone marrow [n -S]\n",
  "MYELOBLASTIC": "of or like a myeloblast [adj]\n",
  "MYELOBLASTS": "MYELOBLAST, an immature cell of bone marrow [n]\n",
  "MYELOCYTE": "a nerve-cell of the brain or spinal cord [n -S]\n",
  "MYELOCYTES": "MYELOCYTE, a nerve-cell of the brain or spinal cord [n]\n",
  "MYELOCYTIC": "pertaining to a myelocyte, a nerve-cell of the brain or spinal cord [adj]\n",
  "MYELOFIBROSES": "MYELOFIBROSIS, an anemic condition in which bone marrow becomes fibrotic [n]\n",
  "MYELOFIBROSIS": "an anemic condition in which bone marrow becomes fibrotic [n MYELOFIBROSES]\n",
  "MYELOFIBROTIC": "relating to myelofibrosis, an anemic condition in which bone marrow becomes fibrotic [adj]\n",
  "MYELOGENOUS": "of, relating to, originating in, or produced by the bone marrow [adj]\n",
  "MYELOGRAM": "an X-ray of the spinal cord, after injection with a radio-opaque medium [n -S]\n",
  "MYELOGRAMS": "MYELOGRAM, an X-ray of the spinal cord, after injection with a radio-opaque medium [n]\n",
  "MYELOGRAPHIES": "MYELOGRAPHY, the taking of myelograms [n]\n",
  "MYELOGRAPHY": "the taking of myelograms [n MYELOGRAPHIES]\n",
  "MYELOID": "resembling marrow in appearance or consistency; as, a myeloid tumor [adj]\n",
  "MYELOMA": "(Greek) a tumour of the bone marrow [n MYELOMAS or MYELOMATA]\n",
  "MYELOMAS": "MYELOMA, (Greek) a tumour of the bone marrow [n]\n",
  "MYELOMATA": "MYELOMA, (Greek) a tumour of the bone marrow [n]\n",
  "MYELOMATOID": "in the form of a myeloma [adj]\n",
  "MYELOMATOUS": "relating to a myeloma, a tumour of the bone marrow [adj]\n",
  "MYELON": "(Greek) the spinal cord [n -S]\n",
  "MYELONS": "MYELON, (Greek) the spinal cord [n]\n",
  "MYELOPATHIC": "relating to myelopathy [adj]\n",
  "MYELOPATHIES": "MYELOPATHY, a disease or disorder of the spinal cord or bone marrow [n]\n",
  "MYELOPATHY": "a disease or disorder of the spinal cord or bone marrow [n MYELOPATHIES]\n",
  "MYGALE": "(Greek) an American bird-catching spider [n -S]\n",
  "MYGALES": "MYGALE, (Greek) an American bird-catching spider [n]\n",
  "MYIASES": "MYIASIS, infestation of human tissue by fly maggots, also MYASIS [n]\n",
  "MYIASIS": "infestation of human tissue by fly maggots, also MYASIS [n MYIASES]\n",
  "MYIOPHILIES": "MYIOPHILY, pollination of plants by flies, also MYOPHILY [n]\n",
  "MYIOPHILOUS": "pollinated by flies, also MYOPHILOUS [adj]\n",
  "MYIOPHILY": "pollination of plants by flies, also MYOPHILY [n MYIOPHILIES]\n",
  "MYLAR": "strong polyester film [n -S]\n",
  "MYLARS": "MYLAR, strong polyester film [n]\n",
  "MYLODON": "(Greek) an extinct genus of large sloth-like American edentates, also MYLODONT [n -S]\n",
  "MYLODONS": "MYLODON, (Greek) an extinct genus of large sloth-like American edentates, also MYLODONT [n]\n",
  "MYLODONT": "(Greek) an extinct genus of large sloth-like American edentates, also MYLODON [n -S]\n",
  "MYLODONTS": "MYLODONT, (Greek) an extinct genus of large sloth-like American edentates, also MYLODON [n]\n",
  "MYLOHYOID": "a nerve in the region of the lower jaw and the hyoid apparatus [n -S]\n",
  "MYLOHYOIDS": "MYLOHYOID, a nerve in the region of the lower jaw and the hyoid apparatus [n]\n",
  "MYLONITE": "a hard, streaky, often granular rock produced by crushing [n -S]\n",
  "MYLONITES": "MYLONITE, a hard, streaky, often granular rock produced by crushing [n]\n",
  "MYLONITIC": "of or like mylonite, a hard, streaky, often granular rock produced by crushing [adj]\n",
  "MYLONITISATION": "the process of mylonitising, also MYLONITIZATION [n -S]\n",
  "MYLONITISATIONS": "MYLONITISATION, the process of mylonitising, also MYLONITIZATION [n]\n",
  "MYLONITISE": "to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITIZE [v MYLONITISED, MYLONITISING, MYLONITISES]\n",
  "MYLONITISED": "MYLONITISE, to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITIZE [v]\n",
  "MYLONITISES": "MYLONITISE, to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITIZE [v]\n",
  "MYLONITISING": "MYLONITISE, to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITIZE [v]\n",
  "MYLONITIZATION": "the process of mylonitizing, also MYLONITISATION [n -S]\n",
  "MYLONITIZATIONS": "MYLONITIZATION, the process of mylonitizing, also MYLONITISATION [n]\n",
  "MYLONITIZE": "to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITISE [v MYLONITIZED, MYLONITIZING, MYLONITIZES]\n",
  "MYLONITIZED": "MYLONITIZE, to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITISE [v]\n",
  "MYLONITIZES": "MYLONITIZE, to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITISE [v]\n",
  "MYLONITIZING": "MYLONITIZE, to turn into mylonite, a hard, streaky, often granular rock produced by crushing, also MYLONITISE [v]\n",
  "MYNA": "(Hindi) an Asiatic bird of the starling family, also MYNAH [n -S]\n",
  "MYNAH": "(Hindi) an Asiatic bird of the starling family, also MYNA [n -S]\n",
  "MYNAHS": "MYNAH, (Hindi) an Asiatic bird of the starling family, also MYNA [n]\n",
  "MYNAS": "MYNA, (Hindi) an Asiatic bird of the starling family, also MYNAH [n]\n",
  "MYNHEER": "(Dutch) the Dutch equivalent of Mr. or Sir; hence, a Dutchman, also MENEER, MIJNHEER [n -S]\n",
  "MYNHEERS": "MYNHEER, (Dutch) the Dutch equivalent of Mr. or Sir; hence, a Dutchman, also MENEER, MIJNHEER [n]\n",
  "MYOBLAST": "a cell capable of giving rise to muscle cells [n -S]\n",
  "MYOBLASTIC": "of or like a myoblast, a cell producing muscle tissue [adj]\n",
  "MYOBLASTS": "MYOBLAST, a cell capable of giving rise to muscle cells [n]\n",
  "MYOCARDIA": "MYOCARDIUM, the main substance of the muscular wall of the heart inclosed between the epicardium and endocardium [n]\n",
  "MYOCARDIAL": "relating to the myocardium, the main substance of the muscular wall of the heart inclosed between the epicardium and endocardium [adj]\n",
  "MYOCARDIOGRAPH": "an instrument for recording the movements of heart muscle [n -S]\n",
  "MYOCARDIOGRAPHS": "MYOCARDIOGRAPH, an instrument for recording the movements of heart muscle [n]\n",
  "MYOCARDIOPATHY": "any noninflammatory disease of the myocardium [n]\n",
  "MYOCARDITIS": "inflammation of the myocardium [n -ES]\n",
  "MYOCARDITISES": "MYOCARDITIS, inflammation of the myocardium [n]\n",
  "MYOCARDIUM": "the main substance of the muscular wall of the heart inclosed between the epicardium and endocardium [n MYOCARDIA]\n",
  "MYOCLONIC": "relating to myoclonus, muscle spasm [adj]\n",
  "MYOCLONUS": "muscle spasm [n MYOCLONUSES]\n",
  "MYOCLONUSES": "MYOCLONUS, muscle spasm [n]\n",
  "MYOELECTRIC": "of, relating to, or utilizing electricity generated by muscle, also MYOELECTRICAL [adj]\n",
  "MYOELECTRICAL": "of, relating to, or utilizing electricity generated by muscle, also MYOELECTRIC [adj]\n",
  "MYOFIBRIL": "a contractile element of a muscle cell [n -S]\n",
  "MYOFIBRILLAR": "relating to myofibrils [adj]\n",
  "MYOFIBRILS": "MYOFIBRIL, a contractile element of a muscle cell [n]\n",
  "MYOFILAMENT": "one of the individual filaments of actin or myosin that make up a myofibril [n -S]\n",
  "MYOFILAMENTS": "MYOFILAMENT, one of the individual filaments of actin or myosin that make up a myofibril [n]\n",
  "MYOGEN": "an albumin, soluble in water, found in muscle [n -S]\n",
  "MYOGENIC": "originating in the muscle tissue [adj]\n",
  "MYOGENS": "MYOGEN, an albumin, soluble in water, found in muscle [n]\n",
  "MYOGLOBIN": "a protein that stores oxygen in muscle [n -S]\n",
  "MYOGLOBINS": "MYOGLOBIN, a protein that stores oxygen in muscle [n]\n",
  "MYOGRAM": "a record made by a myograph [n -S]\n",
  "MYOGRAMS": "MYOGRAM, a record made by a myograph [n]\n",
  "MYOGRAPH": "an instrument for recording muscular contractions [n -S]\n",
  "MYOGRAPHIC": "relating to myography, the description of muscles, also MYOGRAPHICAL [adj MYOGRAPHICALLY]\n",
  "MYOGRAPHICAL": "relating to myography, the description of muscles, also MYOGRAPHIC [adj MYOGRAPHICALLY]\n",
  "MYOGRAPHICALLY": "MYOGRAPHICAL, relating to myography, the description of muscles, also MYOGRAPHIC [adv]\n",
  "MYOGRAPHIES": "MYOGRAPHY, the recording of muscle traces by use of a myograph [n]\n",
  "MYOGRAPHIST": "one who operates a myograph [n -S]\n",
  "MYOGRAPHISTS": "MYOGRAPHIST, one who operates a myograph [n]\n",
  "MYOGRAPHS": "MYOGRAPH, an instrument for recording muscular contractions [n]\n",
  "MYOGRAPHY": "the recording of muscle traces by use of a myograph [n MYOGRAPHIES]\n",
  "MYOID": "a section of a retinal cone or rod which is sensitive to changes in light intensity [n -S]\n",
  "MYOIDS": "MYOID, a section of a retinal cone or rod which is sensitive to changes in light intensity [n]\n",
  "MYOINOSITOL": "a biologically active inositol that is a component of many phospholipids and occurs widely in plants, animals, and microorganisms [n -S]\n",
  "MYOINOSITOLS": "MYOINOSITOL, a biologically active inositol that is a component of many phospholipids and occurs widely in plants, animals, and microorganisms [n]\n",
  "MYOLOGIC": "relating to myology, the study of muscles [adj]\n",
  "MYOLOGICAL": "of or pertaining to myology, the study of muscles [adj]\n",
  "MYOLOGIES": "MYOLOGY, the study of muscles [n]\n",
  "MYOLOGIST": "one who studies muscles [n -S]\n",
  "MYOLOGISTS": "MYOLOGIST, one who studies muscles [n]\n",
  "MYOLOGY": "the study of muscles [n MYOLOGIES]\n",
  "MYOMA": "a tumour composed of muscle tissue [n MYOMAS or MYOMATA]\n",
  "MYOMANCIES": "MYOMANCY, divination from the movements of mice [n]\n",
  "MYOMANCY": "divination from the movements of mice [n MYOMANCIES]\n",
  "MYOMANTIC": "relating to myomancy, divination from the movements of mice [adj]\n",
  "MYOMAS": "MYOMA, a tumour composed of muscle tissue [n]\n",
  "MYOMATA": "MYOMA, a tumour composed of muscle tissue [n]\n",
  "MYOMATOUS": "of or like a myoma, a tumor consisting of muscular tissue [adj]\n",
  "MYOMECTOMIES": "MYOMECTOMY, surgical removal of a myoma, esp. in the uterus [n]\n",
  "MYOMECTOMY": "surgical removal of a myoma, esp. in the uterus [n MYOMECTOMIES]\n",
  "MYOMERE": "part of a vertebrate embryo [n -S]\n",
  "MYOMERES": "MYOMERE, part of a vertebrate embryo [n]\n",
  "MYONEURAL": "relating to or connecting muscles and nerves [adj]\n",
  "MYOPATHIC": "of or pertaining to myopathy, a disorder of muscle tissue [adj]\n",
  "MYOPATHIES": "MYOPATHY, a disorder of muscle tissue [n]\n",
  "MYOPATHY": "a disorder of muscle tissue [n MYOPATHIES]\n",
  "MYOPE": "(Greek) a person having myopy, also MYOPS [n -S]\n",
  "MYOPES": "MYOPE, (Greek) a person having myopy, also MYOPS [n]\n",
  "MYOPHILIES": "MYOPHILY, pollination of plants by flies [n]\n",
  "MYOPHILOUS": "pollinated by flies, also MYIOPHILOUS [adj]\n",
  "MYOPHILY": "pollination of plants by flies [n MYOPHILIES]\n",
  "MYOPIA": "(Greek) a visual defect, also MYOPY [n -S]\n",
  "MYOPIAS": "MYOPIA, (Greek) a visual defect, also MYOPY [n]\n",
  "MYOPIC": "short-sighted [adj MYOPICALLY] / a shortsighted person [n -S]\n",
  "MYOPICALLY": "MYOPIC, short-sighted [adv]\n",
  "MYOPICS": "MYOPIC, a shortsighted person [n]\n",
  "MYOPIES": "MYOPY, (Greek) a visual defect, also MYOPIA [n]\n",
  "MYOPS": "(Greek) a short-sighted person, also MYOPE [n -ES]\n",
  "MYOPSES": "MYOPS, (Greek) a short-sighted person, also MYOPE [n]\n",
  "MYOPY": "(Greek) a visual defect, also MYOPIA [n MYOPIES]\n",
  "MYOSCOPE": "an instrument for observing muscular contractions [n -S]\n",
  "MYOSCOPES": "MYOSCOPE, an instrument for observing muscular contractions [n]\n",
  "MYOSES": "MYOSIS, (Greek) excessive contraction of the pupil of the eye, also MIOSIS [n]\n",
  "MYOSIN": "a protein found in muscle tissue [n -S]\n",
  "MYOSINS": "MYOSIN, a protein found in muscle tissue [n]\n",
  "MYOSIS": "(Greek) excessive contraction of the pupil of the eye, also MIOSIS [n MYOSES or MYOSISES]\n",
  "MYOSISES": "MYOSIS, (Greek) excessive contraction of the pupil of the eye, also MIOSIS [n]\n",
  "MYOSITIS": "muscular pain from infection [n -ES]\n",
  "MYOSITISES": "MYOSITIS, muscular pain from infection [n]\n",
  "MYOSOTE": "(Greek) a genus of flower, forget-me-not, also MYOSOTIS [n -S]\n",
  "MYOSOTES": "MYOSOTE, (Greek) a genus of flower, forget-me-not, also MYOSOTIS [n]\n",
  "MYOSOTIS": "(Greek) a genus of flower, forget-me-not, also MYOSOTE [n -ES]\n",
  "MYOSOTISES": "MYOSOTIS, (Greek) a genus of flower, forget-me-not, also MYOSOTE [n]\n",
  "MYOSTATIN": "a protein that prevents muscles from growing too large [n -S]\n",
  "MYOSTATINS": "MYOSTATIN, a protein that prevents muscles from growing too large [n]\n",
  "MYOTIC": "an agent that causes miosis, also MIOTIC [n -S]\n",
  "MYOTICS": "MYOTIC, an agent that causes miosis, also MIOTIC [n]\n",
  "MYOTOME": "a segment of the body formed by a region of muscle [n -S]\n",
  "MYOTOMES": "MYOTOME, a segment of the body formed by a region of muscle [n]\n",
  "MYOTONIA": "muscular spasm or rigidity [n -S]\n",
  "MYOTONIAS": "MYOTONIA, muscular spasm or rigidity [n]\n",
  "MYOTONIC": "relating to myotonia, temporary muscle rigidity [adj]\n",
  "MYOTUBE": "a cylindrical cell that develops from a myoblast [n -S]\n",
  "MYOTUBES": "MYOTUBE, a cylindrical cell that develops from a myoblast [n]\n",
  "MYRBANE": "an apparently meaningless word used in perfumery, as in oil of myrbane, a name of nitrobenzene, also MIRBANE [n -S]\n",
  "MYRBANES": "MYRBANE, an apparently meaningless word used in perfumery, as in oil of myrbane, a name of nitrobenzene, also MIRBANE [n]\n",
  "MYRIAD": "(Greek) ten thousand [n -S]\n",
  "MYRIADFOLD": "a myriad times [n -S]\n",
  "MYRIADFOLDS": "MYRIADFOLD, a myriad times [n]\n",
  "MYRIADS": "MYRIAD, (Greek) ten thousand [n]\n",
  "MYRIADTH": "one of a myriad equal part [n -S]\n",
  "MYRIADTHS": "MYRIADTH, one of a myriad equal part [n]\n",
  "MYRIAPOD": "a millepede or centipede, also MYRIOPOD [n -S]\n",
  "MYRIAPODAN": "of or like a myriapod [adj]\n",
  "MYRIAPODOUS": "like a myriapod [adj]\n",
  "MYRIAPODS": "MYRIAPOD, a millepede or centipede, also MYRIOPOD [n]\n",
  "MYRICA": "(Latin) a widely dispersed genus of shrubs and trees, usually with aromatic foliage [n -S]\n",
  "MYRICAS": "MYRICA, (Latin) a widely dispersed genus of shrubs and trees, usually with aromatic foliage [n]\n",
  "MYRINGA": "(Latin) the eardrum [n -S]\n",
  "MYRINGAS": "MYRINGA, (Latin) the eardrum [n]\n",
  "MYRINGITIS": "inflammation of the myringa, the eardrum [n -ES]\n",
  "MYRINGITISES": "MYRINGITIS, inflammation of the myringa, the eardrum [n]\n",
  "MYRINGOSCOPE": "an instrument for viewing the eardrum [n -S]\n",
  "MYRINGOSCOPES": "MYRINGOSCOPE, an instrument for viewing the eardrum [n]\n",
  "MYRINGOTOMIES": "MYRINGOTOMY, surgical removal of the myringa, the eardrum [n]\n",
  "MYRINGOTOMY": "surgical removal of the myringa, the eardrum [n MYRINGOTOMIES]\n",
  "MYRIOPOD": "a millepede or centipede, also MYRIAPOD [n -S]\n",
  "MYRIOPODS": "MYRIOPOD, a millepede or centipede, also MYRIAPOD [n]\n",
  "MYRIORAMA": "a picture consisting of many interchangeable parts [n -S]\n",
  "MYRIORAMAS": "MYRIORAMA, a picture consisting of many interchangeable parts [n]\n",
  "MYRIOSCOPE": "a form of kaleidoscope [n -S]\n",
  "MYRIOSCOPES": "MYRIOSCOPE, a form of kaleidoscope [n]\n",
  "MYRISTIC": "relating to the nutmeg genus of plants [adj]\n",
  "MYRISTICIVOROUS": "feeding upon nutmegs [adj]\n",
  "MYRMECOCHORIES": "MYRMECOCHORY, the dispersal of fruits and seeds by ants [n]\n",
  "MYRMECOCHORY": "the dispersal of fruits and seeds by ants [n MYRMECOCHORIES]\n",
  "MYRMECOID": "antlike [adj]\n",
  "MYRMECOLOGIC": "relating to myrmecology, the scientific study of ants, also MYRMECOLOGICAL [adj]\n",
  "MYRMECOLOGICAL": "relating to myrmecology, the scientific study of ants, also MYRMECOLOGIC [adj]\n",
  "MYRMECOLOGIES": "MYRMECOLOGY, the scientific study of ants [n]\n",
  "MYRMECOLOGIST": "one who studies ants [n -S]\n",
  "MYRMECOLOGISTS": "MYRMECOLOGIST, one who studies ants [n]\n",
  "MYRMECOLOGY": "the scientific study of ants [n MYRMECOLOGIES]\n",
  "MYRMECOPHAGOUS": "feeding on ants [adj]\n",
  "MYRMECOPHILE": "an organism that shares an ant colony [n -S]\n",
  "MYRMECOPHILES": "MYRMECOPHILE, an organism that shares an ant colony [n]\n",
  "MYRMECOPHILIES": "MYRMECOPHILY, a symbiotic relation with ants [n]\n",
  "MYRMECOPHILOUS": "ant-loving, of plants inhabited by ants and offering specialised shelters and food for them [adj]\n",
  "MYRMECOPHILY": "a symbiotic relation with ants [n MYRMECOPHILIES]\n",
  "MYRMIDON": "(Greek) a loyal follower, esp. a subordinate who follows orders unquestioningly or pitilessly [n MYRMIDONS or MYRMIDONES]\n",
  "MYRMIDONES": "MYRMIDON, (Greek) a loyal follower, esp. a subordinate who follows orders unquestioningly or pitilessly [n]\n",
  "MYRMIDONIAN": "like a myrmidon [adj]\n",
  "MYRMIDONS": "MYRMIDON, (Greek) a loyal follower, esp. a subordinate who follows orders unquestioningly or pitilessly [n]\n",
  "MYROBALAN": "the astringent fruit of an Indian tree, aka cherry-plum [n -S]\n",
  "MYROBALANS": "MYROBALAN, the astringent fruit of an Indian tree, aka cherry-plum [n]\n",
  "MYRRH": "an aromatic gum resin [n -S]\n",
  "MYRRHIC": "of, pertaining to, or obtained from, myrrh [adj]\n",
  "MYRRHIER": "MYRRHY, of or like myrrh [adj]\n",
  "MYRRHIEST": "MYRRHY, of or like myrrh [adj]\n",
  "MYRRHINE": "of a kind of clear glassware containing pieces of coloured glass, also MURRHINE, MURRINE [adj]\n",
  "MYRRHOL": "the volatile oil of myrrh [n -S]\n",
  "MYRRHOLS": "MYRRHOL, the volatile oil of myrrh [n]\n",
  "MYRRHS": "MYRRH, an aromatic gum resin [n]\n",
  "MYRRHY": "of or like myrrh [adj MYRRHIER, MYRRHIEST]\n",
  "MYRTACEOUS": "belonging to the myrtle family of plants [adj]\n",
  "MYRTLE": "any of various evergreen shrubs of the genus Myrtus, with beautiful and fragrant leaves [n -S]\n",
  "MYRTLES": "MYRTLE, any of various evergreen shrubs of the genus Myrtus, with beautiful and fragrant leaves [n]\n",
  "MYSELF": "a form of the 1st person sing pronoun [pron]\n",
  "MYSID": "a kind of small shrimp [n -S]\n",
  "MYSIDS": "MYSID, a kind of small shrimp [n]\n",
  "MYSOPHOBIA": "an irrational fear of dirt [n -S]\n",
  "MYSOPHOBIAS": "MYSOPHOBIA, an irrational fear of dirt [n]\n",
  "MYSOST": "(Norwegian) a mild cheese [n -S]\n",
  "MYSOSTS": "MYSOST, (Norwegian) a mild cheese [n]\n",
  "MYSPACE": "to search for a person's space on the MySpace website [v MYSPACED, MYSPACING, MYSPACES]\n",
  "MYSPACED": "MYSPACE, to search for a person's space on the MySpace website [v]\n",
  "MYSPACES": "MYSPACE, to search for a person's space on the MySpace website [v]\n",
  "MYSPACING": "MYSPACE, to search for a person's space on the MySpace website [v]\n",
  "MYSTAGOG": "one who teaches mystical doctrines or one who initiates others into religious cults, also MYSTAGOGUE, MYSTAGOGUS [n -S]\n",
  "MYSTAGOGIC": "relating to religious ritual initiation, also MYSTAGOGICAL [adj MYSTAGOGICALLY]\n",
  "MYSTAGOGICAL": "relating to religious ritual initiation, also MYSTAGOGIC [adj MYSTAGOGICALLY]\n",
  "MYSTAGOGICALLY": "MYSTAGOGICAL, relating to religious ritual initiation, also MYSTAGOGIC [adv]\n",
  "MYSTAGOGIES": "MYSTAGOGY, the doctrines, principles, or practice of a mystagogue [n]\n",
  "MYSTAGOGS": "MYSTAGOG, one who teaches mystical doctrines or one who initiates others into religious cults, also MYSTAGOGUE, MYSTAGOGUS [n]\n",
  "MYSTAGOGUE": "one who teaches mystical doctrines or one who initiates others into religious cults, also MYSTAGOG, MYSTAGOGUS [n -S]\n",
  "MYSTAGOGUES": "MYSTAGOGUE, one who teaches mystical doctrines or one who initiates others into religious cults, also MYSTAGOG, MYSTAGOGUS [n]\n",
  "MYSTAGOGUS": "one who teaches mystical doctrines or one who initiates others into religious cults, also MYSTAGOG, MYSTAGOGUE [n -ES]\n",
  "MYSTAGOGUSES": "MYSTAGOGUS, one who teaches mystical doctrines or one who initiates others into religious cults, also MYSTAGOG, MYSTAGOGUE [n]\n",
  "MYSTAGOGY": "the doctrines, principles, or practice of a mystagogue [n MYSTAGOGIES]\n",
  "MYSTERIES": "MYSTERY, something that cannot be understood or explained [n]\n",
  "MYSTERIOUS": "of, relating to, or constituting mystery [adj MYSTERIOUSLY]\n",
  "MYSTERIOUSLY": "MYSTERIOUS, of, relating to, or constituting mystery [adv]\n",
  "MYSTERIOUSNESS": "the state of being mysterious [n]\n",
  "MYSTERY": "something that cannot be understood or explained [n MYSTERIES]\n",
  "MYSTIC": "related to mystery [adj MYSTICLY or MYSTICALLY] / one who professes to have had mystical experiences [n -S]\n",
  "MYSTICAL": "spiritually significant or symbolic [adj MYSTICALLY]\n",
  "MYSTICALLY": "MYSTICAL, spiritually significant or symbolic [adv]\n",
  "MYSTICALNESS": "the state of being mystical [n -ES]\n",
  "MYSTICALNESSES": "MYSTICALNESS, the state of being mystical [n]\n",
  "MYSTICETE": "a species of whale [n -S]\n",
  "MYSTICETES": "MYSTICETE, a species of whale [n]\n",
  "MYSTICISM": "the habit or tendency of religious thought and feeling of those who seek direct communion with God or the divine [n -S]\n",
  "MYSTICISMS": "MYSTICISM, the habit or tendency of religious thought and feeling of those who seek direct communion with God or the divine [n]\n",
  "MYSTICLY": "MYSTIC, related to mystery [adv]\n",
  "MYSTICS": "MYSTIC, one who professes to have had mystical experiences [n]\n",
  "MYSTIFICATION": "an act or instance of mystifying [n -S]\n",
  "MYSTIFICATIONS": "MYSTIFICATION, an act or instance of mystifying [n]\n",
  "MYSTIFIED": "MYSTIFY, to perplex [v]\n",
  "MYSTIFIER": "one who mystifies [n -S]\n",
  "MYSTIFIERS": "MYSTIFIER, one who mystifies [n]\n",
  "MYSTIFIES": "MYSTIFY, to perplex [v]\n",
  "MYSTIFY": "to perplex [v MYSTIFIED, MYSTIFYING, MYSTIFIES]\n",
  "MYSTIFYING": "MYSTIFY, to perplex [v]\n",
  "MYSTIFYINGLY": "MYSTIFYING, MYSTIFY, to perplex [adv]\n",
  "MYSTIQUE": "(French) an aura of mystery [n -S]\n",
  "MYSTIQUES": "MYSTIQUE, (French) an aura of mystery [n]\n",
  "MYTH": "a type of traditional story, also MYTHOS, MYTHUS [n -S]\n",
  "MYTHI": "MYTHUS, (Latin) a type of traditional story, also MYTH, MYTHOS [n]\n",
  "MYTHIC": "relating to myth, also MYTHICAL [adj MYTHICALLY]\n",
  "MYTHICAL": "relating to myth, also MYTHIC [adj MYTHICALLY]\n",
  "MYTHICALLY": "MYTHICAL, relating to myth, also MYTHIC [adv]\n",
  "MYTHICISATION": "the process of mythicising, also MYTHICIZATION [n -S]\n",
  "MYTHICISATIONS": "MYTHICISATION, the process of mythicising, also MYTHICIZATION [n]\n",
  "MYTHICISE": "to make mythical, also MYTHICIZE [v MYTHICISED, MYTHICISING, MYTHICISES]\n",
  "MYTHICISED": "MYTHICISE, to make mythical, also MYTHICIZE [v]\n",
  "MYTHICISER": "one who mythicises, also MYTHICIZER [n -S]\n",
  "MYTHICISERS": "MYTHICISER, one who mythicises, also MYTHICIZER [n]\n",
  "MYTHICISES": "MYTHICISE, to make mythical, also MYTHICIZE [v]\n",
  "MYTHICISING": "MYTHICISE, to make mythical, also MYTHICIZE [v]\n",
  "MYTHICISM": "a theory that explains miraculous stories as myths, also MYTHISM [n -S]\n",
  "MYTHICISMS": "MYTHICISM, a theory that explains miraculous stories as myths, also MYTHISM [n]\n",
  "MYTHICIST": "an adherent of mythicism, also MYTHIST [n -S]\n",
  "MYTHICISTS": "MYTHICIST, an adherent of mythicism, also MYTHIST [n]\n",
  "MYTHICIZATION": "the process of mythicizing, also MYTHICISATION [n -S]\n",
  "MYTHICIZATIONS": "MYTHICIZATION, the process of mythicizing, also MYTHICISATION [n]\n",
  "MYTHICIZE": "to make mythical, also MYTHICISE [v MYTHICIZED, MYTHICIZING, MYTHICIZES]\n",
  "MYTHICIZED": "MYTHICIZE, to make mythical, also MYTHICISE [v]\n",
  "MYTHICIZER": "one who mythicizes, also MYTHICISER [n -S]\n",
  "MYTHICIZERS": "MYTHICIZER, one who mythicizes, also MYTHICISER [n]\n",
  "MYTHICIZES": "MYTHICIZE, to make mythical, also MYTHICISE [v]\n",
  "MYTHICIZING": "MYTHICIZE, to make mythical, also MYTHICISE [v]\n",
  "MYTHIER": "MYTHY, resembling myth [adj]\n",
  "MYTHIEST": "MYTHY, resembling myth [adj]\n",
  "MYTHISE": "to tell a traditional story, also MYTHIZE [v MYTHISED, MYTHISING, MYTHISES]\n",
  "MYTHISED": "MYTHISE, to tell a traditional story, also MYTHIZE [v]\n",
  "MYTHISES": "MYTHISE, to tell a traditional story, also MYTHIZE [v]\n",
  "MYTHISING": "MYTHISE, to tell a traditional story, also MYTHIZE [v]\n",
  "MYTHISM": "a theory that explains miraculous stories as myths, also MYTHICISM [n -S]\n",
  "MYTHISMS": "MYTHISM, a theory that explains miraculous stories as myths, also MYTHICISM [n]\n",
  "MYTHIST": "an adherent of mythism, also MYTHICIST [n -S]\n",
  "MYTHISTS": "MYTHIST, an adherent of mythism, also MYTHICIST [n]\n",
  "MYTHIZE": "to tell a traditional story, also MYTHISE [v MYTHIZED, MYTHIZING, MYTHIZES]\n",
  "MYTHIZED": "MYTHIZE, to tell a traditional story, also MYTHISE [v]\n",
  "MYTHIZES": "MYTHIZE, to tell a traditional story, also MYTHISE [v]\n",
  "MYTHIZING": "MYTHIZE, to tell a traditional story, also MYTHISE [v]\n",
  "MYTHMAKER": "a maker of myths [n -S]\n",
  "MYTHMAKERS": "MYTHMAKER, a maker of myths [n]\n",
  "MYTHMAKING": "the making of myths [n -S]\n",
  "MYTHMAKINGS": "MYTHMAKING, the making of myths [n]\n",
  "MYTHOGENESES": "MYTHOGENESIS, the origin of myths [n]\n",
  "MYTHOGENESIS": "the origin of myths [n MYTHOGENESES]\n",
  "MYTHOGRAPHER": "a student of mythography [n -S]\n",
  "MYTHOGRAPHERS": "MYTHOGRAPHER, a student of mythography [n]\n",
  "MYTHOGRAPHIES": "MYTHOGRAPHY, the descriptive study or representation of myths [n]\n",
  "MYTHOGRAPHY": "the descriptive study or representation of myths [n MYTHOGRAPHIES]\n",
  "MYTHOI": "MYTHOS, (Greek) a type of traditional story, also MYTH, MYTHUS [n]\n",
  "MYTHOLOGER": "a mythologist [n -S]\n",
  "MYTHOLOGERS": "MYTHOLOGER, a mythologist [n]\n",
  "MYTHOLOGIAN": "a mythologist [n -S]\n",
  "MYTHOLOGIANS": "MYTHOLOGIAN, a mythologist [n]\n",
  "MYTHOLOGIC": "of or relating to mythology or myths, also MYTHOLOGICAL [adj MYTHOLOGICALLY]\n",
  "MYTHOLOGICAL": "of or relating to mythology or myths, also MYTHOLOGIC [adj MYTHOLOGICALLY]\n",
  "MYTHOLOGICALLY": "MYTHOLOGICAL, of or relating to mythology or myths, also MYTHOLOGIC [adv]\n",
  "MYTHOLOGIES": "MYTHOLOGY, a body of myths; the scientific study of myths [n]\n",
  "MYTHOLOGISATION": "the process of mythologising, also MYTHOLOGIZATION [n]\n",
  "MYTHOLOGISE": "to make mythical, also MYTHOLOGIZE [v MYTHOLOGISED, MYTHOLOGISING, MYTHOLOGISES]\n",
  "MYTHOLOGISED": "MYTHOLOGISE, to make mythical, also MYTHOLOGIZE [v]\n",
  "MYTHOLOGISER": "one who mythologises, also MYTHOLOGIZER [n -S]\n",
  "MYTHOLOGISERS": "MYTHOLOGISER, one who mythologises, also MYTHOLOGIZER [n]\n",
  "MYTHOLOGISES": "MYTHOLOGISE, to make mythical, also MYTHOLOGIZE [v]\n",
  "MYTHOLOGISING": "MYTHOLOGISE, to make mythical, also MYTHOLOGIZE [v]\n",
  "MYTHOLOGIST": "a student of mythology [n -S]\n",
  "MYTHOLOGISTS": "MYTHOLOGIST, a student of mythology [n]\n",
  "MYTHOLOGIZATION": "the process of mythologizing, also MYTHOLOGISATION [n]\n",
  "MYTHOLOGIZE": "to make mythical, also MYTHOLOGISE [v MYTHOLOGIZED, MYTHOLOGIZING, MYTHOLOGIZES]\n",
  "MYTHOLOGIZED": "MYTHOLOGIZE, to make mythical, also MYTHOLOGISE [v]\n",
  "MYTHOLOGIZER": "one who mythologizes, also MYTHOLOGISER [n -S]\n",
  "MYTHOLOGIZERS": "MYTHOLOGIZER, one who mythologizes, also MYTHOLOGISER [n]\n",
  "MYTHOLOGIZES": "MYTHOLOGIZE, to make mythical, also MYTHOLOGISE [v]\n",
  "MYTHOLOGIZING": "MYTHOLOGIZE, to make mythical, also MYTHOLOGISE [v]\n",
  "MYTHOLOGY": "a body of myths; the scientific study of myths [n MYTHOLOGIES]\n",
  "MYTHOMANE": "someone who is prone to lie or believe in lies [n -S]\n",
  "MYTHOMANES": "MYTHOMANE, someone who is prone to lie or believe in lies [n]\n",
  "MYTHOMANIA": "an excessive or abnormal propensity for lying and exaggerating [n -S]\n",
  "MYTHOMANIAC": "a sufferer from mythomania, an excessive or abnormal propensity for lying and exaggerating [n -S]\n",
  "MYTHOMANIACS": "MYTHOMANIAC, a sufferer from mythomania, an excessive or abnormal propensity for lying and exaggerating [n]\n",
  "MYTHOMANIAS": "MYTHOMANIA, an excessive or abnormal propensity for lying and exaggerating [n]\n",
  "MYTHOPEIC": "mythmaking, also MYTHOPOEIC, MYTHOPOETIC [adj]\n",
  "MYTHOPOEIA": "the making of myths [n -S]\n",
  "MYTHOPOEIAS": "MYTHOPOEIA, the making of myths [n]\n",
  "MYTHOPOEIC": "mythmaking, also MYTHOPEIC, MYTHOPOETIC [adj]\n",
  "MYTHOPOEISM": "the making of myths [n -S]\n",
  "MYTHOPOEISMS": "MYTHOPOEISM, the making of myths [n]\n",
  "MYTHOPOEIST": "a mythmaker [n -S]\n",
  "MYTHOPOEISTS": "MYTHOPOEIST, a mythmaker [n]\n",
  "MYTHOPOESES": "MYTHOPOESIS, the making of myths [n]\n",
  "MYTHOPOESIS": "the making of myths [n MYTHOPOESES]\n",
  "MYTHOPOET": "a mythmaker; a writer of poems on mythical subjects [n -S]\n",
  "MYTHOPOETIC": "mythmaking, also MYTHOPEIC, MYTHOPOEIC [adj]\n",
  "MYTHOPOETICAL": "relating to mythopoeia [adj]\n",
  "MYTHOPOETS": "MYTHOPOET, a mythmaker; a writer of poems on mythical subjects [n]\n",
  "MYTHOS": "(Greek) a type of traditional story, also MYTH, MYTHUS [n MYTHOI]\n",
  "MYTHS": "MYTH, a type of traditional story, also MYTHOS, MYTHUS [n]\n",
  "MYTHUS": "(Latin) a type of traditional story, also MYTH, MYTHOS [n MYTHI]\n",
  "MYTHY": "resembling myth [adj MYTHIER, MYTHIEST]\n",
  "MYTILIFORM": "mussel-shaped [adj]\n",
  "MYTILOID": "mussel-shaped [adj]\n",
  "MYXAMEBA": "a cell produced by a spore, also MYXAMOEBA [n MYXAMEBAE or MYXAMEBAS]\n",
  "MYXAMEBAE": "MYXAMEBA, a cell produced by a spore, also MYXAMOEBA [n]\n",
  "MYXAMEBAS": "MYXAMEBA, a cell produced by a spore, also MYXAMOEBA [n]\n",
  "MYXAMOEBA": "a cell produced by a spore, also MYXAMEBA [n MYXAMOEBAS or MYXAMOEBAE]\n",
  "MYXAMOEBAE": "MYXAMOEBA, a cell produced by a spore, also MYXAMEBA [n]\n",
  "MYXAMOEBAS": "MYXAMOEBA, a cell produced by a spore, also MYXAMEBA [n]\n",
  "MYXEDEMA": "(US) a skin disease, marked by swelling and dryness, due to insufficient thyroid secretion, also MYXOEDEMA [n -S]\n",
  "MYXEDEMAS": "MYXEDEMA, (US) a skin disease, marked by swelling and dryness, due to insufficient thyroid secretion, also MYXOEDEMA [n]\n",
  "MYXEDEMATOUS": "(US) relating to myxedema, a skin disease, also MYXOEDEMATOUS [adj]\n",
  "MYXEDEMIC": "(US) relating to myxedema, a skin disease, marked by swelling and dryness, due to insufficient thyroid secretion, also MYXOEDEMIC [adj]\n",
  "MYXO": "(Australian slang) myxomatosis, a disease introduced to control rabbits [n -S]\n",
  "MYXOCYTE": "a large cell found in mucous tissue [n -S]\n",
  "MYXOCYTES": "MYXOCYTE, a large cell found in mucous tissue [n]\n",
  "MYXOEDEMA": "a skin disease, marked by swelling and dryness, due to insufficient thyroid secretion, also MYXEDEMA [n -S]\n",
  "MYXOEDEMAS": "MYXOEDEMA, a skin disease, marked by swelling and dryness, due to insufficient thyroid secretion, also MYXEDEMA [n]\n",
  "MYXOEDEMATOUS": "relating to myxoedema, a skin disease, also MYXEDEMATOUS [adj]\n",
  "MYXOEDEMIC": "relating to myxoedema, a skin disease, also MYXEDEMIC [adj]\n",
  "MYXOID": "containing mucus [adj]\n",
  "MYXOMA": "(Greek) a tumour composed of mucous tissue [n MYXOMAS or MYXOMATA]\n",
  "MYXOMAS": "MYXOMA, (Greek) a tumour composed of mucous tissue [n]\n",
  "MYXOMATA": "MYXOMA, (Greek) a tumour composed of mucous tissue [n]\n",
  "MYXOMATOSES": "MYXOMATOSIS, a fatal contagious disease of rabbits [n]\n",
  "MYXOMATOSIS": "a fatal contagious disease of rabbits [n MYXOMATOSES]\n",
  "MYXOMATOUS": "suffering from myxomatosis [adj]\n",
  "MYXOMYCETE": "slime mould [n -S]\n",
  "MYXOMYCETES": "MYXOMYCETE, slime mould [n]\n",
  "MYXOMYCETOUS": "of or like a myxomycete, a slime mould [adj]\n",
  "MYXOS": "MYXO, (Australian slang) myxomatosis, a disease introduced to control rabbits [n]\n",
  "MYXOVIRAL": "of or like a myxovirus, any of a group of related viruses causing influenza, mumps etc. [adj]\n",
  "MYXOVIRUS": "any of a group of related viruses causing influenza, mumps etc. [n -ES]\n",
  "MYXOVIRUSES": "MYXOVIRUS, any of a group of related viruses causing influenza, mumps etc. [n]\n",
  "MZEE": "(Swahili) an old person [n -S]\n",
  "MZEES": "MZEE, (Swahili) an old person [n]\n",
  "MZUNGU": "(Swahili) in East Africa, a white person [n -S]\n",
  "MZUNGUS": "MZUNGU, (Swahili) in East Africa, a white person [n]\n",
  "NA": "(Scots) no, not at all [adv]\n",
  "NAAM": "(historical) the action of taking another's goods by distraint; goods so taken, also NAM [n -S]\n",
  "NAAMS": "NAAM, (historical) the action of taking another's goods by distraint; goods so taken, also NAM [n]\n",
  "NAAN": "(Hindi) a kind of slightly leavened Indian bread, also NAN [n -S]\n",
  "NAANS": "NAAN, (Hindi) a kind of slightly leavened Indian bread, also NAN [n]\n",
  "NAARTJE": "(South African) a small sweet orange like the mandarin, also NAARTJIE, NARTJIE [n -S]\n",
  "NAARTJES": "NAARTJE, (South African) a small sweet orange like the mandarin, also NAARTJIE, NARTJIE [n]\n",
  "NAARTJIE": "(South African) a small sweet orange like the mandarin, also NAARTJE, NARTJIE [n -S]\n",
  "NAARTJIES": "NAARTJIE, (South African) a small sweet orange like the mandarin, also NAARTJE, NARTJIE [n]\n",
  "NAB": "to seize [v NABBED, NABBING, NABS]\n",
  "NABBED": "NAB, to seize [v]\n",
  "NABBER": "one who nabs [n -S]\n",
  "NABBERS": "NABBER, one who nabs [n]\n",
  "NABBING": "NAB, to seize [v]\n",
  "NABE": "a neighbourhood movie theatre [n -S]\n",
  "NABES": "NABE, a neighbourhood movie theatre [n]\n",
  "NABIS": "(French) a group of late nineteenth century French post-impressionists following the artistic theories of the French painter Paul Gauguin [n]\n",
  "NABK": "(Arabic) a prickly shrub, the Christ's-thorn, also NEBBUK, NEBECK, NEBEK [n -S]\n",
  "NABKS": "NABK, (Arabic) a prickly shrub, the Christ's-thorn, also NEBBUK, NEBECK, NEBEK [n]\n",
  "NABLA": "(Greek) in Cartesian coordinates, an inverted delta, aka del, representing a vector operator [n -S]\n",
  "NABLAS": "NABLA, (Greek) in Cartesian coordinates, an inverted delta, aka del, representing a vector operator [n]\n",
  "NABOB": "(Urdu) a provincial governor of the Mogul empire in India; a person of great wealth or prominence [n -S]\n",
  "NABOBERIES": "NABOBERY, (Urdu) the state of being a nabob [n]\n",
  "NABOBERY": "(Urdu) the state of being a nabob [n NABOBERIES]\n",
  "NABOBESS": "(Urdu) a female nabob [n -ES]\n",
  "NABOBESSES": "NABOBESS, (Urdu) a female nabob [n]\n",
  "NABOBISH": "like a nabob [adj]\n",
  "NABOBISM": "(Urdu) great wealth and luxury [n -S]\n",
  "NABOBISMS": "NABOBISM, (Urdu) great wealth and luxury [n]\n",
  "NABOBS": "NABOB, (Urdu) a provincial governor of the Mogul empire in India; a person of great wealth or prominence [n]\n",
  "NABS": "NAB, to seize [v]\n",
  "NACARAT": "(French) a bright orange-red; a fabric so coloured [n -S]\n",
  "NACARATS": "NACARAT, (French) a bright orange-red; a fabric so coloured [n]\n",
  "NACELLE": "(French) a structure on the wing of an airplane containing the engine [n -S]\n",
  "NACELLES": "NACELLE, (French) a structure on the wing of an airplane containing the engine [n]\n",
  "NACH": "(Hindi) an entertainment in India consisting chiefly of dancing by professional dancing girls, also NAUCH, NAUTCH [n -ES]\n",
  "NACHAS": "(Yiddish) pride in another's accomplishments [n NACHAS]\n",
  "NACHE": "(Spanish) the rump of beef; esp. the lower and back part of the rump, also NATCH [n -S]\n",
  "NACHES": "NACH, (Hindi) an entertainment in India consisting chiefly of dancing by professional dancing girls, also NAUCH, NAUTCH [n]\n",
  "NACHO": "(Spanish) a corn chip, topped with cheese or beans [n -S]\n",
  "NACHOS": "NACHO, (Spanish) a corn chip, topped with cheese or beans [n]\n",
  "NACHTMAAL": "(South African) a Dutch Reformed Church Sacrament, the Lord's Supper, also NAGMAAL [n -S]\n",
  "NACHTMAALS": "NACHTMAAL, (South African) a Dutch Reformed Church Sacrament, the Lord's Supper, also NAGMAAL [n]\n",
  "NACKET": "(Scots) a snack, a light lunch, also NOCKET [n -S]\n",
  "NACKETS": "NACKET, (Scots) a snack, a light lunch, also NOCKET [n]\n",
  "NACRE": "mother-of-pearl [n -S]\n",
  "NACRED": "having mother-of-pearl [adj]\n",
  "NACREOUS": "of or resembling mother-of-pearl, also NACROUS [adj]\n",
  "NACRES": "NACRE, mother-of-pearl [n]\n",
  "NACRITE": "a clay mineral [n -S]\n",
  "NACRITES": "NACRITE, a clay mineral [n]\n",
  "NACROUS": "pertaining to mother of pearl [adj]\n",
  "NADA": "(Spanish) nothingness [n -S]\n",
  "NADAS": "NADA, (Spanish) nothingness [n]\n",
  "NADIR": "(Arabic) the point of the heavens diametrically opposite to the zenith [n -S]\n",
  "NADIRAL": "of or like a nadir, the point of the heavens diametrically opposite to the zenith [adj]\n",
  "NADIRS": "NADIR, (Arabic) the point of the heavens diametrically opposite to the zenith [n]\n",
  "NADORS": "(South African) thirst brought on by excessive consumption of alcohol [n]\n",
  "NADS": "(slang) testicles [n]\n",
  "NAE": "(Scots) no [n NAES]\n",
  "NAEBODIES": "NAEBODY, (Scots) nobody [n]\n",
  "NAEBODY": "(Scots) nobody [n NAEBODIES]\n",
  "NAES": "NAE, (Scots) no [n]\n",
  "NAETHING": "(Scots) nothing [n -S]\n",
  "NAETHINGS": "NAETHING, (Scots) nothing [n]\n",
  "NAEVE": "(obsolete) a birthmark, also NAEVUS, NEVUS [n -S]\n",
  "NAEVES": "NAEVE, (obsolete) a birthmark, also NAEVUS, NEVUS [n]\n",
  "NAEVI": "NAEVUS, (Latin) a birthmark, also NAEVE, NEVUS [n]\n",
  "NAEVOID": "resembling a naevus or naevi [adj]\n",
  "NAEVUS": "(Latin) a birthmark, also NAEVE, NEVUS [n NAEVI]\n",
  "NAFF": "inferior, tacky [adj NAFFER, NAFFEST, NAFFLY] / to go away (as in naff off) [v -ED, -ING, -S]\n",
  "NAFFED": "NAFF, to go away (as in naff off) [v]\n",
  "NAFFER": "NAFF, inferior, tacky [adj]\n",
  "NAFFEST": "NAFF, inferior, tacky [adj]\n",
  "NAFFING": "NAFF, to go away (as in naff off) [v]\n",
  "NAFFLY": "NAFF, inferior, tacky [adv]\n",
  "NAFFNESS": "the quality of being naff [n -ES]\n",
  "NAFFNESSES": "NAFFNESS, the quality of being naff [n]\n",
  "NAFFS": "NAFF, to go away (as in naff off) [v]\n",
  "NAG": "to find fault incessantly [v NAGGED, NAGGING, NAGS]\n",
  "NAGA": "(Sanskrit) a snake, esp. the cobra; a divine snake in Hindu mythology [n -S]\n",
  "NAGANA": "(Zulu) a tropical disease of cattle transmitted by tsetse fly, also NGANA [n -S]\n",
  "NAGANAS": "NAGANA, (Zulu) a tropical disease of cattle transmitted by tsetse fly, also NGANA [n]\n",
  "NAGAPIE": "(South African) the bushbaby or nocturnal lemur [n -S]\n",
  "NAGAPIES": "NAGAPIE, (South African) the bushbaby or nocturnal lemur [n]\n",
  "NAGARI": "(Sanskrit) the character in which Sanskrit is usually printed, also DEVANAGARI [n -S]\n",
  "NAGARIS": "NAGARI, (Sanskrit) the character in which Sanskrit is usually printed, also DEVANAGARI [n]\n",
  "NAGAS": "NAGA, (Sanskrit) a snake, esp. the cobra; a divine snake in Hindu mythology [n]\n",
  "NAGGED": "NAG, to find fault incessantly [v]\n",
  "NAGGER": "one who nags, esp. a woman [n -S]\n",
  "NAGGERS": "NAGGER, one who nags, esp. a woman [n]\n",
  "NAGGIER": "NAGGY, given to nagging [adj]\n",
  "NAGGIEST": "NAGGY, given to nagging [adj]\n",
  "NAGGING": "the act of finding fault incessantly [n -S]\n",
  "NAGGINGLY": "NAGGING [adv]\n",
  "NAGGINGS": "NAGGING, the act of finding fault incessantly [n]\n",
  "NAGGY": "given to nagging [adj NAGGIER, NAGGIEST]\n",
  "NAGMAAL": "(South African) a Dutch Reformed Church Sacrament, the Lord's Supper, also NACHTMAAL [n -S]\n",
  "NAGMAALS": "NAGMAAL, (South African) a Dutch Reformed Church Sacrament, the Lord's Supper, also NACHTMAAL [n]\n",
  "NAGOR": "(French) a reedbuck of savannah in equatorial Africa, with short forward-curving horns [n -S]\n",
  "NAGORS": "NAGOR, (French) a reedbuck of savannah in equatorial Africa, with short forward-curving horns [n]\n",
  "NAGS": "NAG, to find fault incessantly [v]\n",
  "NAGWARE": "software that is free but then nags you to pay for it [n -S]\n",
  "NAGWARES": "NAGWARE, software that is free but then nags you to pay for it [n]\n",
  "NAH": "(colloquial) no [interj]\n",
  "NAHAL": "(Hebrew) in Israel, an agricultural settlement established and manned by soldiers [n -S]\n",
  "NAHALS": "NAHAL, (Hebrew) in Israel, an agricultural settlement established and manned by soldiers [n]\n",
  "NAIAD": "(Greek) a water nymph [n NAIADS or NAIADES]\n",
  "NAIADES": "NAIAD, (Greek) a water nymph [n]\n",
  "NAIADS": "NAIAD, (Greek) a water nymph [n]\n",
  "NAIANT": "in heraldry, swimming horizontally [adj]\n",
  "NAIF": "(French) ingenuous, also NAIVE [adj NAIFER, NAIFEST, NAIFLY] / a naive person [n -S]\n",
  "NAIFER": "NAIF, (French) ingenuous, also NAIVE [adj]\n",
  "NAIFEST": "NAIF, (French) ingenuous, also NAIVE [adj]\n",
  "NAIFLY": "NAIF, (French) ingenuous, also NAIVE [adv]\n",
  "NAIFNESS": "the state of being naif [n -ES]\n",
  "NAIFNESSES": "NAIFNESS, the state of being naif [n]\n",
  "NAIFS": "NAIF, a naive person [n]\n",
  "NAIK": "(Hindi) the rank of corporal in the Indian army [n -S]\n",
  "NAIKS": "NAIK, (Hindi) the rank of corporal in the Indian army [n]\n",
  "NAIL": "to fasten with a long slender piece of metal [v -ED, -ING, -S]\n",
  "NAILBITER": "someone who bites his or her nails [n -S]\n",
  "NAILBITERS": "NAILBITER, someone who bites his or her nails [n]\n",
  "NAILBRUSH": "a brush for cleaning the nails [n -ES]\n",
  "NAILBRUSHES": "NAILBRUSH, a brush for cleaning the nails [n]\n",
  "NAILED": "NAIL, to fasten with a long slender piece of metal [v]\n",
  "NAILER": "a maker of nails [n -S]\n",
  "NAILERIES": "NAILERY, a place where nails are made [n]\n",
  "NAILERS": "NAILER, a maker of nails [n]\n",
  "NAILERY": "a place where nails are made [n NAILERIES]\n",
  "NAILFILE": "a small file for smoothing the edges of fingernails or toenails [n -S]\n",
  "NAILFILES": "NAILFILE, a small file for smoothing the edges of fingernails or toenails [n]\n",
  "NAILFOLD": "a fold of skin around the fingernail [n -S]\n",
  "NAILFOLDS": "NAILFOLD, a fold of skin around the fingernail [n]\n",
  "NAILHEAD": "the top of a nail [n -S]\n",
  "NAILHEADS": "NAILHEAD, the top of a nail [n]\n",
  "NAILING": "making nails [n -S]\n",
  "NAILINGS": "NAILING, making nails [n]\n",
  "NAILLESS": "without nails [adj]\n",
  "NAILS": "NAIL, to fasten with a long slender piece of metal [v]\n",
  "NAILSET": "a tool for punching the head of a nail below or flush with the surface [n -S]\n",
  "NAILSETS": "NAILSET, a tool for punching the head of a nail below or flush with the surface [n]\n",
  "NAIN": "(Scots) one's own [adj]\n",
  "NAINSELL": "(Scots) one's own self, also AINSELL [n -S]\n",
  "NAINSELLS": "NAINSELL, (Scots) one's own self, also AINSELL [n]\n",
  "NAINSOOK": "(Hindi) a fine cotton fabric [n -S]\n",
  "NAINSOOKS": "NAINSOOK, (Hindi) a fine cotton fabric [n]\n",
  "NAIRA": "a Nigerian currency unit [n -S]\n",
  "NAIRAS": "NAIRA, a Nigerian currency unit [n]\n",
  "NAIRU": "an acronym for Non-Accelerating Inflation Rate of Unemployment [n -S]\n",
  "NAIRUS": "NAIRU, an acronym for Non-Accelerating Inflation Rate of Unemployment [n]\n",
  "NAISSANCE": "(French) birth [n -S]\n",
  "NAISSANCES": "NAISSANCE, (French) birth [n]\n",
  "NAISSANT": "(French) of a heraldic charge, esp. an animal, issuing from the middle of a fess or other ordinary [adj]\n",
  "NAIVE": "lacking sophistication [adj NAIVER, NAIVEST, NAIVELY] / an unsophisticated person [n -S]\n",
  "NAIVELY": "NAIVE, lacking sophistication [adv]\n",
  "NAIVENESS": "the state of being naive [n -ES]\n",
  "NAIVENESSES": "NAIVENESS, the state of being naive [n]\n",
  "NAIVER": "NAIVE, lacking sophistication [adj]\n",
  "NAIVES": "NAIVE, an unsophisticated person [n]\n",
  "NAIVEST": "NAIVE, lacking sophistication [adj]\n",
  "NAIVETE": "(French) the quality of being naive, also NAIVETY [n -S]\n",
  "NAIVETES": "NAIVETE, (French) the quality of being naive, also NAIVETY [n]\n",
  "NAIVETIES": "NAIVETY, the quality of being naive, also NAIVETE [n]\n",
  "NAIVETY": "the quality of being naive, also NAIVETE [n NAIVETIES]\n",
  "NAIVIST": "in a naive style [adj]\n",
  "NAKED": "without clothes [adj NAKEDER, NAKEDEST, NAKEDLY]\n",
  "NAKEDER": "NAKED, without clothes [adj]\n",
  "NAKEDEST": "NAKED, without clothes [adj]\n",
  "NAKEDLY": "NAKED, without clothes [adv]\n",
  "NAKEDNESS": "the state of being naked [n -ES]\n",
  "NAKEDNESSES": "NAKEDNESS, the state of being naked [n]\n",
  "NAKER": "a small kettledrum [n -S]\n",
  "NAKERS": "NAKER, a small kettledrum [n]\n",
  "NAKFA": "the standard currency unit of Eritrea [n -S]\n",
  "NAKFAS": "NAKFA, the standard currency unit of Eritrea [n]\n",
  "NALA": "(Hindi) a ravine, a watercourse, also NALLA, NALLAH, NULLA, NULLAH [n -S]\n",
  "NALAS": "NALA, (Hindi) a ravine, a watercourse, also NALLA, NALLAH, NULLA, NULLAH [n]\n",
  "NALBUPHINE": "a synthetic narcotic, an analgesic structurally similar to morphine [n -S]\n",
  "NALBUPHINES": "NALBUPHINE, a synthetic narcotic, an analgesic structurally similar to morphine [n]\n",
  "NALED": "an agricultural pesticide of low toxicity to mammals and rapidly degradable [n -S]\n",
  "NALEDS": "NALED, an agricultural pesticide of low toxicity to mammals and rapidly degradable [n]\n",
  "NALIDIXIC": "as in nalidixic acid, a synthetic compound used to treat infections of the urinary tract [adj]\n",
  "NALLA": "(Hindi) a ravine, a watercourse, also NALA, NALLAH, NULLA, NULLAH [n -S]\n",
  "NALLAH": "(Hindi) a ravine, a watercourse, also NALA, NALLA, NULLA, NULLAH [n -S]\n",
  "NALLAHS": "NALLAH, (Hindi) a ravine, a watercourse, also NALA, NALLA, NULLA, NULLAH [n]\n",
  "NALLAS": "NALLA, (Hindi) a ravine, a watercourse, also NALA, NALLAH, NULLA, NULLAH [n]\n",
  "NALORPHINE": "a derivative of morphine, used as an antidote to poisons [n -S]\n",
  "NALORPHINES": "NALORPHINE, a derivative of morphine, used as an antidote to poisons [n]\n",
  "NALOXONE": "a potent drug used as an antidote for various narcotics [n -S]\n",
  "NALOXONES": "NALOXONE, a potent drug used as an antidote for various narcotics [n]\n",
  "NALTREXONE": "a narcotic antagonist [n -S]\n",
  "NALTREXONES": "NALTREXONE, a narcotic antagonist [n]\n",
  "NAM": "the action of taking another's goods by distraint, also NAAM [n -S]\n",
  "NAMABLE": "able to be named, also NAMEABLE [adj]\n",
  "NAMASKAR": "(Sanskrit) a traditional Indian salutation, a slight bow with the palms pressed together, also NAMASTE [n -S]\n",
  "NAMASKARS": "NAMASKAR, (Sanskrit) a traditional Indian salutation, a slight bow with the palms pressed together, also NAMASTE [n]\n",
  "NAMASTE": "(Sanskrit) a traditional Indian salutation, a slight bow with the palms pressed together, also NAMASKAR [n -S]\n",
  "NAMASTES": "NAMASTE, (Sanskrit) a traditional Indian salutation, a slight bow with the palms pressed together, also NAMASKAR [n]\n",
  "NAMAYCUSH": "(Native American) a freshwater char living mainly in lakes in northern North America, aka tuladi or togue [n -ES]\n",
  "NAMAYCUSHES": "NAMAYCUSH, (Native American) a freshwater char living mainly in lakes in northern North America, aka tuladi or togue [n]\n",
  "NAME": "to give a title to [v NAMED, NAMING, NAMES]\n",
  "NAMEABLE": "able to be named, also NAMABLE [adj]\n",
  "NAMECHECK": "a mention of someone's name e.g. on a radio program [n -S] / to mention by name [v -ED, -ING, -S]\n",
  "NAMECHECKED": "NAMECHECK, to mention by name [v]\n",
  "NAMECHECKING": "NAMECHECK, to mention by name [v]\n",
  "NAMECHECKS": "NAMECHECK, to mention by name [v]\n",
  "NAMED": "NAME, to give a title to [v]\n",
  "NAMELESS": "anonymous [adj NAMELESSLY]\n",
  "NAMELESSLY": "NAMELESS, anonymous [adv]\n",
  "NAMELESSNESS": "the state of being nameless [n -ES]\n",
  "NAMELESSNESSES": "NAMELESSNESS, the state of being nameless [n]\n",
  "NAMELY": "that is to say [adv]\n",
  "NAMEPLATE": "an attached plate bearing the name of occupant, owner, manufacturer, etc. [n -S]\n",
  "NAMEPLATES": "NAMEPLATE, an attached plate bearing the name of occupant, owner, manufacturer, etc. [n]\n",
  "NAMER": "one who names [n -S]\n",
  "NAMERS": "NAMER, one who names [n]\n",
  "NAMES": "NAME, to give a title to [v]\n",
  "NAMESAKE": "one who is named after another [n -S]\n",
  "NAMESAKES": "NAMESAKE, one who is named after another [n]\n",
  "NAMETAG": "a tag bearing one's name [n -S]\n",
  "NAMETAGS": "NAMETAG, a tag bearing one's name [n]\n",
  "NAMETAPE": "a small bit of cloth with the owner's name [n -S]\n",
  "NAMETAPES": "NAMETAPE, a small bit of cloth with the owner's name [n]\n",
  "NAMEWORTHIER": "NAMEWORTHY, worth naming, distinguished [adj]\n",
  "NAMEWORTHIEST": "NAMEWORTHY, worth naming, distinguished [adj]\n",
  "NAMEWORTHY": "worth naming, distinguished [adj NAMEWORTHIER, NAMEWORTHIEST]\n",
  "NAMING": "the act of naming [n -S]\n",
  "NAMINGS": "NAMING, the act of naming [n]\n",
  "NAMMA": "as in namma hole, an Australian term for a natural well in rock, also GNAMMA [adj]\n",
  "NAMS": "NAM, the action of taking another's goods by distraint, also NAAM [n]\n",
  "NAMU": "(Maori) a black New Zealand sandfly [n -S]\n",
  "NAMUS": "NAMU, (Maori) a black New Zealand sandfly [n]\n",
  "NAN": "(Hindi) a kind of slightly leavened Indian bread, also NAAN [n -S]\n",
  "NANA": "(Australian slang) an idiot, a fool [n -S]\n",
  "NANAS": "NANA, (Australian slang) an idiot, a fool [n]\n",
  "NANCE": "(offensive) an effeminate young man, also NANCY [n -S]\n",
  "NANCES": "NANCE, (offensive) an effeminate young man, also NANCY [n]\n",
  "NANCIER": "NANCY, (slang) effeminate [adj]\n",
  "NANCIES": "NANCY, an effeminate boy; a male homosexual, also NANCE [n]\n",
  "NANCIEST": "NANCY, (slang) effeminate [adj]\n",
  "NANCIFIED": "(offensive) like a nancy, effeminate [adj]\n",
  "NANCY": "(slang) effeminate [adj NANCIER, NANCIEST] / an effeminate boy; a male homosexual, also NANCE [n NANCIES]\n",
  "NANDIN": "(Japanese) an evergreen Asiatic shrub of the barberry family, also NANDINA [n -S]\n",
  "NANDINA": "(Japanese) an evergreen Asiatic shrub of the barberry family, also NANDIN [n -S]\n",
  "NANDINAS": "NANDINA, (Japanese) an evergreen Asiatic shrub of the barberry family, also NANDIN [n]\n",
  "NANDINE": "a West African civet [n -S]\n",
  "NANDINES": "NANDINE, a West African civet [n]\n",
  "NANDINS": "NANDIN, (Japanese) an evergreen Asiatic shrub of the barberry family, also NANDINA [n]\n",
  "NANDOO": "(Tupi) the rhea, or South American ostrich, also NANDU, NHANDU [n -S]\n",
  "NANDOOS": "NANDOO, (Tupi) the rhea, or South American ostrich, also NANDU, NHANDU [n]\n",
  "NANDROLONE": "an androgenic anabolic steroid that is illegally used as a performance-enhancing drug by some athletes [n -S]\n",
  "NANDROLONES": "NANDROLONE, an androgenic anabolic steroid that is illegally used as a performance-enhancing drug by some athletes [n]\n",
  "NANDU": "(Tupi) the rhea, or South American ostrich, also NANDOO, NHANDU [n -S]\n",
  "NANDUS": "NANDU, (Tupi) the rhea, or South American ostrich, also NANDOO, NHANDU [n]\n",
  "NANE": "(Scots) none [adj]\n",
  "NANG": "(slang) excellent, cool [adj]\n",
  "NANISATION": "artificial dwarfing, also NANIZATION [n -S]\n",
  "NANISATIONS": "NANISATION, artificial dwarfing, also NANIZATION [n]\n",
  "NANISM": "abnormal smallness [n -S]\n",
  "NANISMS": "NANISM, abnormal smallness [n]\n",
  "NANITE": "a microscopically small machine or device, perhaps only a few atoms wide, manufactured using nanotechnology [n -S]\n",
  "NANITES": "NANITE, a microscopically small machine or device, perhaps only a few atoms wide, manufactured using nanotechnology [n]\n",
  "NANIZATION": "artificial dwarfing, also NANISATION [n -S]\n",
  "NANIZATIONS": "NANIZATION, artificial dwarfing, also NANISATION [n]\n",
  "NANKEEN": "(Chinese) a durable buff-coloured cotton, also NANKIN [n -S]\n",
  "NANKEENS": "NANKEEN, (Chinese) a durable buff-coloured cotton, also NANKIN [n]\n",
  "NANKIN": "(Chinese) a durable buff-coloured cotton, also NANKEEN [n -S]\n",
  "NANKINS": "NANKIN, (Chinese) a durable buff-coloured cotton, also NANKEEN [n]\n",
  "NANNA": "(colloquial) a grandmother [n -S]\n",
  "NANNAS": "NANNA, (colloquial) a grandmother [n]\n",
  "NANNIE": "a children's nurse; a grandmother, also NANNY [n -S]\n",
  "NANNIED": "NANNY, to look after someone else's children [v]\n",
  "NANNIES": "NANNY, to look after someone else's children [v]\n",
  "NANNOPLANKTON": "very small plankton, also NANOPLANKTON [n -S]\n",
  "NANNOPLANKTONS": "NANNOPLANKTON, very small plankton, also NANOPLANKTON [n]\n",
  "NANNY": "to look after someone else's children [v NANNIED, NANNYING, NANNIES]\n",
  "NANNYGAI": "(Native Australian) a large edible marine fish, also NENNIGAI [n -S]\n",
  "NANNYGAIS": "NANNYGAI, (Native Australian) a large edible marine fish, also NENNIGAI [n]\n",
  "NANNYING": "the act of treating with excessive caution [n -S]\n",
  "NANNYINGS": "NANNYING, the act of treating with excessive caution [n]\n",
  "NANNYISH": "overprotective [adj]\n",
  "NANO": "the science that deals with materials on an atomic or molecular scale [n -S]\n",
  "NANOBE": "a very small microbe [n -S]\n",
  "NANOBEE": "an artificial nanoparticle containing a toxin found in bee stings, used to target and destroy precancerous cells [n -S]\n",
  "NANOBEES": "NANOBEE, an artificial nanoparticle containing a toxin found in bee stings, used to target and destroy precancerous cells [n]\n",
  "NANOBES": "NANOBE, a very small microbe [n]\n",
  "NANOBOT": "a microscopically small robot [n -S]\n",
  "NANOBOTS": "NANOBOT, a microscopically small robot [n]\n",
  "NANODOT": "a small cluster of metal atoms which can store much data [n -S]\n",
  "NANODOTS": "NANODOT, a small cluster of metal atoms which can store much data [n]\n",
  "NANOGRAM": "a billionth of a gramme, also NANOGRAMME [n -S]\n",
  "NANOGRAMME": "a billionth of a gramme, also NANOGRAM [n -S]\n",
  "NANOGRAMMES": "NANOGRAMME, a billionth of a gramme, also NANOGRAM [n]\n",
  "NANOGRAMS": "NANOGRAM, a billionth of a gramme, also NANOGRAMME [n]\n",
  "NANOGRASS": "a synthetic surface consisting of minute upright blades of silicon that allow control of the way it interacts with liquids [n -ES]\n",
  "NANOGRASSES": "NANOGRASS, a synthetic surface consisting of minute upright blades of silicon that allow control of the way it interacts with liquids [n]\n",
  "NANOMATERIAL": "a microscopically small material [n -S]\n",
  "NANOMATERIALS": "NANOMATERIAL, a microscopically small material [n]\n",
  "NANOMETER": "a billionth of a metre, also NANOMETRE [n -S]\n",
  "NANOMETERS": "NANOMETER, a billionth of a metre, also NANOMETRE [n]\n",
  "NANOMETRE": "a billionth of a metre, also NANOMETER [n -S]\n",
  "NANOMETRES": "NANOMETRE, a billionth of a metre, also NANOMETER [n]\n",
  "NANOOK": "(Inuit) a polar bear [n -S]\n",
  "NANOOKS": "NANOOK, (Inuit) a polar bear [n]\n",
  "NANOPARTICLE": "a particle with dimensions of about 5-40 nanometres [n -S]\n",
  "NANOPARTICLES": "NANOPARTICLE, a particle with dimensions of about 5-40 nanometres [n]\n",
  "NANOPHYSICS": "physics on an atomic and molecular scale [n]\n",
  "NANOPLANKTON": "very small plankton, also NANNOPLANKTON [n -S]\n",
  "NANOPLANKTONS": "NANOPLANKTON, very small plankton, also NANNOPLANKTON [n]\n",
  "NANOPORE": "a microscopic pore [n -S]\n",
  "NANOPORES": "NANOPORE, a microscopic pore [n]\n",
  "NANOPUBLISHING": "online, low-cost publishing which utilizes blogs and techniques based on blogging in order to target a specific audience [n -S]\n",
  "NANOPUBLISHINGS": "NANOPUBLISHING, online, low-cost publishing which utilizes blogs and techniques based on blogging in order to target a specific audience [n]\n",
  "NANOS": "NANO, the science that deals with materials on an atomic or molecular scale [n]\n",
  "NANOSCALE": "on a very small scale [adj]\n",
  "NANOSECOND": "a billionth of a second [n -S]\n",
  "NANOSECONDS": "NANOSECOND, a billionth of a second [n]\n",
  "NANOTECH": "the art of manipulating materials on an atomic or molecular scale esp. to build microscopic devices (as robots), also NANOTECHNOLOGY [n -S]\n",
  "NANOTECHNOLOGY": "the art of manipulating materials on an atomic or molecular scale esp. to build microscopic devices (as robots), also NANOTECH [n]\n",
  "NANOTECHS": "NANOTECH, the art of manipulating materials on an atomic or molecular scale esp. to build microscopic devices (as robots), also NANOTECHNOLOGY [n]\n",
  "NANOTESLA": "a billionth of a tesla [n -S]\n",
  "NANOTESLAS": "NANOTESLA, a billionth of a tesla [n]\n",
  "NANOTUBE": "a cylindrical tube of carbon [n -S]\n",
  "NANOTUBES": "NANOTUBE, a cylindrical tube of carbon [n]\n",
  "NANOWATT": "a unit of power, one billionth of a watt [n -S]\n",
  "NANOWATTS": "NANOWATT, a unit of power, one billionth of a watt [n]\n",
  "NANOWIRE": "a wire of microscopic thickness [n -S]\n",
  "NANOWIRES": "NANOWIRE, a wire of microscopic thickness [n]\n",
  "NANOWORLD": "the world of the very small [n -S]\n",
  "NANOWORLDS": "NANOWORLD, the world of the very small [n]\n",
  "NANS": "NAN, (Hindi) a kind of slightly leavened Indian bread, also NAAN [n]\n",
  "NANUA": "(Maori) a New Zealand sea fish, aka moki [n -S]\n",
  "NANUAS": "NANUA, (Maori) a New Zealand sea fish, aka moki [n]\n",
  "NAOI": "NAOS, (Greek) the inner cell of a temple [n]\n",
  "NAOS": "(Greek) the inner cell of a temple [n NAOI or NAOSES]\n",
  "NAOSES": "NAOS, (Greek) the inner cell of a temple [n]\n",
  "NAP": "to sleep briefly [v NAPPED, NAPPING, NAPS]\n",
  "NAPA": "a kind of soft leather prepared from sheep- or goatskin by a special tawing process, also NAPPA [n -S]\n",
  "NAPALM": "to assault with a type of incendiary bomb [v -ED, -ING, -S]\n",
  "NAPALMED": "NAPALM, to assault with a type of incendiary bomb [v]\n",
  "NAPALMING": "NAPALM, to assault with a type of incendiary bomb [v]\n",
  "NAPALMS": "NAPALM, to assault with a type of incendiary bomb [v]\n",
  "NAPAS": "NAPA, a kind of soft leather prepared from sheep- or goatskin by a special tawing process, also NAPPA [n]\n",
  "NAPE": "to attack with napalm [v NAPED, NAPING, NAPES]\n",
  "NAPED": "NAPE, to attack with napalm [v]\n",
  "NAPERIES": "NAPERY, table and other household linen [n]\n",
  "NAPERY": "table and other household linen [n NAPERIES]\n",
  "NAPES": "NAPE, to attack with napalm [v]\n",
  "NAPHTHA": "(Greek) a vague name for the liquid inflammable distillates from coal-tar, wood, etc., esp. the lighter and more volatile ones [n -S]\n",
  "NAPHTHALENE": "a crystalline aromatic hydrocarbon usually obtained by distillation of coal tar [n -S]\n",
  "NAPHTHALENES": "NAPHTHALENE, a crystalline aromatic hydrocarbon usually obtained by distillation of coal tar [n]\n",
  "NAPHTHALIC": "as in naphthalic acid, an acid derived from naphthalene [adj]\n",
  "NAPHTHALIN": "a white crystalline volatile solid with a characteristic penetrating odour, an aromatic hydrocarbon, also NAPHTHALINE [n -S]\n",
  "NAPHTHALINE": "a white crystalline volatile solid with a characteristic penetrating odour, an aromatic hydrocarbon, also NAPHTHALIN [n -S]\n",
  "NAPHTHALINES": "NAPHTHALINE, a white crystalline volatile solid with a characteristic penetrating odour, an aromatic hydrocarbon, also NAPHTHALIN [n]\n",
  "NAPHTHALINS": "NAPHTHALIN, a white crystalline volatile solid with a characteristic penetrating odour, an aromatic hydrocarbon, also NAPHTHALINE [n]\n",
  "NAPHTHALISE": "to treat with naphtha, also NAPHTHALIZE [v NAPHTHALISED, NAPHTHALISING, NAPHTHALISES]\n",
  "NAPHTHALISED": "NAPHTHALISE, to treat with naphtha, also NAPHTHALIZE [v]\n",
  "NAPHTHALISES": "NAPHTHALISE, to treat with naphtha, also NAPHTHALIZE [v]\n",
  "NAPHTHALISING": "NAPHTHALISE, to treat with naphtha, also NAPHTHALIZE [v]\n",
  "NAPHTHALIZE": "to treat with naphtha, also NAPHTHALISE [v NAPHTHALIZED, NAPHTHALIZING, NAPHTHALIZES]\n",
  "NAPHTHALIZED": "NAPHTHALIZE, to treat with naphtha, also NAPHTHALISE [v]\n",
  "NAPHTHALIZES": "NAPHTHALIZE, to treat with naphtha, also NAPHTHALISE [v]\n",
  "NAPHTHALIZING": "NAPHTHALIZE, to treat with naphtha, also NAPHTHALISE [v]\n",
  "NAPHTHAS": "NAPHTHA, (Greek) a vague name for the liquid inflammable distillates from coal-tar, wood, etc., esp. the lighter and more volatile ones [n]\n",
  "NAPHTHENE": "a peculiar hydrocarbon occurring as an ingredient of Caucasian petroleum [n -S]\n",
  "NAPHTHENES": "NAPHTHENE, a peculiar hydrocarbon occurring as an ingredient of Caucasian petroleum [n]\n",
  "NAPHTHENIC": "of or like naphthene [adj]\n",
  "NAPHTHOL": "any one of a series of hydroxyl derivatives of naphthalene, analogous to phenol, also NAPHTOL [n -S]\n",
  "NAPHTHOLS": "NAPHTHOL, any one of a series of hydroxyl derivatives of naphthalene, analogous to phenol, also NAPHTOL [n]\n",
  "NAPHTHOUS": "containing naphtha [adj]\n",
  "NAPHTHYL": "a radical derived from naphthalene [n -S]\n",
  "NAPHTHYLAMINE": "either of two isomeric crystalline bases used esp. as dye intermediates [n -S]\n",
  "NAPHTHYLAMINES": "NAPHTHYLAMINE, either of two isomeric crystalline bases used esp. as dye intermediates [n]\n",
  "NAPHTHYLS": "NAPHTHYL, a radical derived from naphthalene [n]\n",
  "NAPHTOL": "any one of a series of hydroxyl derivatives of naphthalene, analogous to phenol, also NAPHTHOL [n -S]\n",
  "NAPHTOLS": "NAPHTOL, any one of a series of hydroxyl derivatives of naphthalene, analogous to phenol, also NAPHTHOL [n]\n",
  "NAPIFORM": "shaped like a turnip [adj]\n",
  "NAPING": "NAPE, to attack with napalm [v]\n",
  "NAPKIN": "a piece of material used to wipe hands and mouth [n -S]\n",
  "NAPKINS": "NAPKIN, a piece of material used to wipe hands and mouth [n]\n",
  "NAPLESS": "threadbare [adj]\n",
  "NAPOLEON": "(French) an obsolete French gold coin of twenty francs [n -S]\n",
  "NAPOLEONITE": "an orbicular diorite found in Corsica [n -S]\n",
  "NAPOLEONITES": "NAPOLEONITE, an orbicular diorite found in Corsica [n]\n",
  "NAPOLEONS": "NAPOLEON, (French) an obsolete French gold coin of twenty francs [n]\n",
  "NAPOO": "to use up [v -ED, -ING, -S]\n",
  "NAPOOED": "NAPOO, to use up [v]\n",
  "NAPOOING": "NAPOO, to use up [v]\n",
  "NAPOOS": "NAPOO, to use up [v]\n",
  "NAPPA": "a kind of soft leather prepared from sheep- or goatskin by a special tawing process, also NAPA [n -S]\n",
  "NAPPAS": "NAPPA, a kind of soft leather prepared from sheep- or goatskin by a special tawing process, also NAPA [n]\n",
  "NAPPE": "(French) a sheet of rock which has moved horizontally over neighbouring strata, as a result of overthrust or recumbent folding [n -S]\n",
  "NAPPED": "NAP, to sleep briefly [v]\n",
  "NAPPER": "one who naps cloth after it is fulled [n -S]\n",
  "NAPPERS": "NAPPER, one who naps cloth after it is fulled [n]\n",
  "NAPPES": "NAPPE, (French) a sheet of rock which has moved horizontally over neighbouring strata, as a result of overthrust or recumbent folding [n]\n",
  "NAPPIE": "an infant's diaper, also NAPPY [n -S]\n",
  "NAPPIER": "NAPPY, of beer, having a head, frothy [adj]\n",
  "NAPPIES": "NAPPIE, an infant's diaper, also NAPPY [n]\n",
  "NAPPIEST": "NAPPY, of beer, having a head, frothy [adj]\n",
  "NAPPINESS": "abundance of nap, as on cloth [n -ES]\n",
  "NAPPINESSES": "NAPPINESS, abundance of nap, as on cloth [n]\n",
  "NAPPING": "NAP, to sleep briefly [v]\n",
  "NAPPY": "of beer, having a head, frothy [adj NAPPIER, NAPPIEST] / an infant's diaper, also NAPPIE [n NAPPIES]\n",
  "NAPRAPATHIES": "NAPRAPATHY, (Czech) medical treatment by manipulation of spine, thorax or pelvis [n]\n",
  "NAPRAPATHY": "(Czech) medical treatment by manipulation of spine, thorax or pelvis [n NAPRAPATHIES]\n",
  "NAPRON": "(archaic) an apron [n -S]\n",
  "NAPRONS": "NAPRON, (archaic) an apron [n]\n",
  "NAPROXEN": "an anti-inflammatory drug [n -S]\n",
  "NAPROXENS": "NAPROXEN, an anti-inflammatory drug [n]\n",
  "NAPS": "NAP, to sleep briefly [v]\n",
  "NARAS": "(Hottentot) an edible melon-like fruit, also NARRAS [n -ES]\n",
  "NARASES": "NARAS, (Hottentot) an edible melon-like fruit, also NARRAS [n]\n",
  "NARC": "(short for) a narcotics agent, also NARCO [n -S]\n",
  "NARCEEN": "a narcotic component of opium, also NARCEINE, NARCEIN [n -S]\n",
  "NARCEENS": "NARCEEN, a narcotic component of opium, also NARCEINE, NARCEIN [n]\n",
  "NARCEIN": "a narcotic component of opium, also NARCEINE, NARCEEN [n -S]\n",
  "NARCEINE": "a narcotic component of opium, also NARCEEN, NARCEIN [n -S]\n",
  "NARCEINES": "NARCEINE, a narcotic component of opium, also NARCEEN, NARCEIN [n]\n",
  "NARCEINS": "NARCEIN, a narcotic component of opium, also NARCEINE, NARCEEN [n]\n",
  "NARCISM": "excessive love of oneself, also NARCISSISM [n -S]\n",
  "NARCISMS": "NARCISM, excessive love of oneself, also NARCISSISM [n]\n",
  "NARCISSI": "NARCISSUS, any of numerous bulbous spring-flowering plants of the genus Narcissus [n]\n",
  "NARCISSISM": "excessive love of oneself, also NARCISM [n -S]\n",
  "NARCISSISMS": "NARCISSISM, excessive love of oneself, also NARCISM [n]\n",
  "NARCISSIST": "one given to narcism, excessive love of oneself, also NARCIST [n -S]\n",
  "NARCISSISTIC": "relating to narcissism [adj]\n",
  "NARCISSISTS": "NARCISSIST, one given to narcism, excessive love of oneself, also NARCIST [n]\n",
  "NARCISSUS": "any of numerous bulbous spring-flowering plants of the genus Narcissus [n NARCISSI or NARCISSUSES]\n",
  "NARCISSUSES": "NARCISSUS, any of numerous bulbous spring-flowering plants of the genus Narcissus [n]\n",
  "NARCIST": "one given to narcism, excessive love of oneself, also NARCISSIST [n -S]\n",
  "NARCISTIC": "excessively admiring of oneself [adj]\n",
  "NARCISTS": "NARCIST, one given to narcism, excessive love of oneself, also NARCISSIST [n]\n",
  "NARCO": "(short for) a narcotics agent, also NARC [n -S]\n",
  "NARCOANALYSES": "NARCOANALYSIS, hypnoanalysis when narcotics are used in producing the hypnotic state [n]\n",
  "NARCOANALYSIS": "hypnoanalysis when narcotics are used in producing the hypnotic state [n NARCOANALYSES]\n",
  "NARCOCATHARSES": "NARCOCATHARSIS, hypnoanalysis when narcotics are used in producing the hypnotic state [n]\n",
  "NARCOCATHARSIS": "hypnoanalysis when narcotics are used in producing the hypnotic state [n NARCOCATHARSES]\n",
  "NARCOHYPNOSES": "NARCOHYPNOSIS, the use of narcotics to produce hypnosis [n]\n",
  "NARCOHYPNOSIS": "the use of narcotics to produce hypnosis [n NARCOHYPNOSES]\n",
  "NARCOLEPSIES": "NARCOLEPSY, pathological drowsiness [n]\n",
  "NARCOLEPSY": "pathological drowsiness [n NARCOLEPSIES]\n",
  "NARCOLEPTIC": "relating to narcolepsy [adj] / one suffering from narcolepsy [n -S]\n",
  "NARCOLEPTICS": "NARCOLEPTIC, one suffering from narcolepsy [n]\n",
  "NARCOMA": "a coma caused by the intake of narcotic drugs [n NARCOMAS or NARCOMATA]\n",
  "NARCOMAS": "NARCOMA, a coma caused by the intake of narcotic drugs [n]\n",
  "NARCOMATA": "NARCOMA, a coma caused by the intake of narcotic drugs [n]\n",
  "NARCOS": "NARCO, (short for) a narcotics agent, also NARC [n]\n",
  "NARCOSE": "experiencing a hallucinogenic stupor [adj]\n",
  "NARCOSES": "NARCOSIS, a drug-induced stupor [n]\n",
  "NARCOSIS": "a drug-induced stupor [n NARCOSES]\n",
  "NARCOSYNTHESES": "NARCOSYNTHESIS, narcoanalysis directed toward unearthing repressed memories [n]\n",
  "NARCOSYNTHESIS": "narcoanalysis directed toward unearthing repressed memories [n NARCOSYNTHESES]\n",
  "NARCOTERRORISM": "drug-related terrorism [n -S]\n",
  "NARCOTERRORISMS": "NARCOTERRORISM, drug-related terrorism [n]\n",
  "NARCOTERRORIST": "one who engages in narcoterrorism, drug-related terrorism [n -S]\n",
  "NARCOTERRORISTS": "NARCOTERRORIST, one who engages in narcoterrorism, drug-related terrorism [n]\n",
  "NARCOTIC": "dulling the senses [adj NARCOTICALLY] / a drug that dulls the senses [n -S]\n",
  "NARCOTICALLY": "NARCOTIC, dulling the senses [adv]\n",
  "NARCOTICS": "NARCOTIC, a drug that dulls the senses [n]\n",
  "NARCOTINE": "an alkaloid found in opium, and extracted as a white crystalline substance, tasteless and less poisonous than morphine [n -S]\n",
  "NARCOTINES": "NARCOTINE, an alkaloid found in opium, and extracted as a white crystalline substance, tasteless and less poisonous than morphine [n]\n",
  "NARCOTISATION": "the process of narcotising, also NARCOTIZATION [n -S]\n",
  "NARCOTISATIONS": "NARCOTISATION, the process of narcotising, also NARCOTIZATION [n]\n",
  "NARCOTISE": "to subject to the influence of a narcotic, also NARCOTIZE [v NARCOTISED, NARCOTISING, NARCOTISES]\n",
  "NARCOTISED": "NARCOTISE, to subject to the influence of a narcotic, also NARCOTIZE [v]\n",
  "NARCOTISES": "NARCOTISE, to subject to the influence of a narcotic, also NARCOTIZE [v]\n",
  "NARCOTISING": "NARCOTISE, to subject to the influence of a narcotic, also NARCOTIZE [v]\n",
  "NARCOTISM": "narcosis; the state of being narcotized [n -S]\n",
  "NARCOTISMS": "NARCOTISM, narcosis; the state of being narcotized [n]\n",
  "NARCOTIST": "one who takes narcotics [n -S]\n",
  "NARCOTISTS": "NARCOTIST, one who takes narcotics [n]\n",
  "NARCOTIZATION": "the process of narcotizing, also NARCOTISATION [n -S]\n",
  "NARCOTIZATIONS": "NARCOTIZATION, the process of narcotizing, also NARCOTISATION [n]\n",
  "NARCOTIZE": "to subject to the influence of a narcotic, also NARCOTISE [v NARCOTIZED, NARCOTIZING, NARCOTIZES]\n",
  "NARCOTIZED": "NARCOTIZE, to subject to the influence of a narcotic, also NARCOTISE [v]\n",
  "NARCOTIZES": "NARCOTIZE, to subject to the influence of a narcotic, also NARCOTISE [v]\n",
  "NARCOTIZING": "NARCOTIZE, to subject to the influence of a narcotic, also NARCOTISE [v]\n",
  "NARCS": "NARC, (short for) a narcotics agent, also NARCO [n]\n",
  "NARD": "to anoint with the aromatic oil spikenard [v -ED, -ING, -S]\n",
  "NARDED": "NARD, to anoint with the aromatic oil spikenard [v]\n",
  "NARDINE": "pertaining to nard [adj]\n",
  "NARDING": "NARD, to anoint with the aromatic oil spikenard [v]\n",
  "NARDOO": "(Native Australian) a four-leaved aquatic plant related to the ferns, sometimes used for food [n -S]\n",
  "NARDOOS": "NARDOO, (Native Australian) a four-leaved aquatic plant related to the ferns, sometimes used for food [n]\n",
  "NARDS": "NARD, to anoint with the aromatic oil spikenard [v]\n",
  "NARE": "(archaic) a nostril, esp. a hawk's [n -S]\n",
  "NARES": "NARE, (archaic) a nostril, esp. a hawk's [n]\n",
  "NARGHILE": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILLY, NARGHILY, NARGILE, NARGILEH, NARGILY, NARGUILEH [n -S]\n",
  "NARGHILES": "NARGHILE, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILLY, NARGHILY, NARGILE, NARGILEH, NARGILY, NARGUILEH [n]\n",
  "NARGHILIES": "NARGHILY, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGILE, NARGILEH, NARGILY, NARGUILEH [n]\n",
  "NARGHILLIES": "NARGHILLY, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILY, NARGILE, NARGILEH, NARGILY, NARGUILEH [n]\n",
  "NARGHILLY": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILY, NARGILE, NARGILEH, NARGILY, NARGUILEH [n NARGHILLIES]\n",
  "NARGHILY": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGILE, NARGILEH, NARGILY, NARGUILEH [n NARGHILIES]\n",
  "NARGILE": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILEH, NARGILY, NARGUILEH [n -S]\n",
  "NARGILEH": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILE, NARGILY, NARGUILEH [n -S]\n",
  "NARGILEHS": "NARGILEH, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILE, NARGILY, NARGUILEH [n]\n",
  "NARGILES": "NARGILE, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILEH, NARGILY, NARGUILEH [n]\n",
  "NARGILIES": "NARGILY, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILE, NARGILEH, NARGUILEH [n]\n",
  "NARGILY": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILE, NARGILEH, NARGUILEH [n NARGILIES]\n",
  "NARGUILEH": "(Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILE, NARGILEH, NARGILY [n -S]\n",
  "NARGUILEHS": "NARGUILEH, (Persian) a hookah, an Oriental tobacco pipe in which smoke is drawn through water by a long tube, also NARGHILE, NARGHILLY, NARGHILY, NARGILE, NARGILEH, NARGILY [n]\n",
  "NARIAL": "of or relating to the nostrils, also NARIC, NARINE [adj]\n",
  "NARIC": "of or relating to the nostrils, also NARIAL, NARINE [adj]\n",
  "NARICORN": "the horny termination of a bird's nostril [n -S]\n",
  "NARICORNS": "NARICORN, the horny termination of a bird's nostril [n]\n",
  "NARINE": "of or relating to the nostrils, also NARIAL, NARIC [adj]\n",
  "NARIS": "(Latin) a nostril [n NARES]\n",
  "NARK": "(Romany) to spy or inform [v -ED, -ING, -S]\n",
  "NARKED": "NARK, (Romany) to spy or inform [v]\n",
  "NARKIER": "NARKY, irritable [adj]\n",
  "NARKIEST": "NARKY, irritable [adj]\n",
  "NARKING": "NARK, (Romany) to spy or inform [v]\n",
  "NARKS": "NARK, (Romany) to spy or inform [v]\n",
  "NARKY": "irritable [adj NARKIER, NARKIEST]\n",
  "NARQUOIS": "(French) mocking; malicious [adj]\n",
  "NARRAS": "(Hottentot) an edible melon-like fruit of a South African shrub, also NARAS [n -ES]\n",
  "NARRASES": "NARRAS, (Hottentot) an edible melon-like fruit of a South African shrub, also NARAS [n]\n",
  "NARRATABLE": "that can be narrated [adj]\n",
  "NARRATE": "to tell a story [v NARRATED, NARRATING, NARRATES]\n",
  "NARRATED": "NARRATE, to tell a story [v]\n",
  "NARRATER": "one that narrates, also NARRATOR [n -S]\n",
  "NARRATERS": "NARRATER, one that narrates, also NARRATOR [n]\n",
  "NARRATES": "NARRATE, to tell a story [v]\n",
  "NARRATING": "NARRATE, to tell a story [v]\n",
  "NARRATION": "the act of narrating [n -S]\n",
  "NARRATIONAL": "relating to narration [adj]\n",
  "NARRATIONS": "NARRATION, the act of narrating [n]\n",
  "NARRATIVE": "relating to story [adj NARRATIVELY] / that which is narrated, a story [n -S]\n",
  "NARRATIVELY": "NARRATIVE, relating to story [adv]\n",
  "NARRATIVES": "NARRATIVE, that which is narrated, a story [n]\n",
  "NARRATOLOGICAL": "relating to narratology [adj]\n",
  "NARRATOLOGIES": "NARRATOLOGY, the study of narratives [n]\n",
  "NARRATOLOGIST": "one who studies narratology [n -S]\n",
  "NARRATOLOGISTS": "NARRATOLOGIST, one who studies narratology [n]\n",
  "NARRATOLOGY": "the study of narratives [n NARRATOLOGIES]\n",
  "NARRATOR": "one that narrates, also NARRATER [n -S]\n",
  "NARRATORS": "NARRATOR, one that narrates, also NARRATER [n]\n",
  "NARRATORY": "like narrative, consisting of narrative [adj]\n",
  "NARRE": "(Spenser) nearer [adv]\n",
  "NARROW": "of little width [adj NARROWER, NARROWEST, NARROWLY] / to make narrow [v -ED, -ING, -S]\n",
  "NARROWBAND": "a device operating at a narrow range of frequencies [n -S]\n",
  "NARROWBANDS": "NARROWBAND, a device operating at a narrow range of frequencies [n]\n",
  "NARROWCAST": "to distribute material on video tapes, cassettes etc. [v -ED, -ING, -S]\n",
  "NARROWCASTED": "NARROWCAST, to distribute material on video tapes, cassettes etc. [v]\n",
  "NARROWCASTING": "the distribution of material on video tapes, cassettes etc. [n -S]\n",
  "NARROWCASTINGS": "NARROWCASTING, the distribution of material on video tapes, cassettes etc. [n]\n",
  "NARROWCASTS": "NARROWCAST, to distribute material on video tapes, cassettes etc. [v]\n",
  "NARROWED": "NARROW, to make narrow [v]\n",
  "NARROWER": "NARROW, of little width [adj]\n",
  "NARROWEST": "NARROW, of little width [adj]\n",
  "NARROWING": "the act of making narrow [n -S]\n",
  "NARROWINGS": "NARROWING, the act of making narrow [n]\n",
  "NARROWISH": "somewhat narrow [adj]\n",
  "NARROWLY": "NARROW, of little width [adv]\n",
  "NARROWNESS": "the state of being narrow [n -ES]\n",
  "NARROWNESSES": "NARROWNESS, the state of being narrow [n]\n",
  "NARROWS": "NARROW, to make narrow [v]\n",
  "NARTHEX": "(Greek) a small entrance or porch to a church [n -ES]\n",
  "NARTHEXES": "NARTHEX, (Greek) a small entrance or porch to a church [n]\n",
  "NARTJIE": "(South African) a small sweet orange like the mandarin, also NAARTJE, NAARTJIE [n -S]\n",
  "NARTJIES": "NARTJIE, (South African) a small sweet orange like the mandarin, also NAARTJE, NAARTJIE [n]\n",
  "NARWAL": "(Danish) a kind of whale with a large projecting spiral tusk, also NARWHAL, NARWHALE [n -S]\n",
  "NARWALS": "NARWAL, (Danish) a kind of whale with a large projecting spiral tusk, also NARWHAL, NARWHALE [n]\n",
  "NARWHAL": "(Danish) a kind of whale with a large projecting spiral tusk, also NARWAL, NARWHALE [n -S]\n",
  "NARWHALE": "(Danish) a kind of whale with a large projecting spiral tusk, also NARWAL, NARWHAL [n -S]\n",
  "NARWHALES": "NARWHALE, (Danish) a kind of whale with a large projecting spiral tusk, also NARWAL, NARWHAL [n]\n",
  "NARWHALS": "NARWHAL, (Danish) a kind of whale with a large projecting spiral tusk, also NARWAL, NARWHALE [n]\n",
  "NARY": "(dialect) not any [adj]\n",
  "NAS": "(obsolete) contraction of ne has, has not and ne was, was not [v]\n",
  "NASAL": "through the nose [adj NASALLY] / a sound uttered through the nose [n -S]\n",
  "NASALISATION": "the act of nasalising, also NASALIZATION [n -S]\n",
  "NASALISATIONS": "NASALISATION, the act of nasalising, also NASALIZATION [n]\n",
  "NASALISE": "to produce sounds nasally, also NASALIZE [v NASALISED, NASALISING, NASALISES]\n",
  "NASALISED": "NASALISE, to produce sounds nasally, also NASALIZE [v]\n",
  "NASALISES": "NASALISE, to produce sounds nasally, also NASALIZE [v]\n",
  "NASALISING": "NASALISE, to produce sounds nasally, also NASALIZE [v]\n",
  "NASALISM": "making nasal sounds [n -S]\n",
  "NASALISMS": "NASALISM, making nasal sounds [n]\n",
  "NASALITIES": "NASALITY, an instance of being produced nasally [n]\n",
  "NASALITY": "an instance of being produced nasally [n NASALITIES]\n",
  "NASALIZATION": "the act of nasalizing, also NASALISATION [n -S]\n",
  "NASALIZATIONS": "NASALIZATION, the act of nasalizing, also NASALISATION [n]\n",
  "NASALIZE": "to produce sounds nasally, also NASALISE [v NASALIZED, NASALIZING, NASALIZES]\n",
  "NASALIZED": "NASALIZE, to produce sounds nasally, also NASALISE [v]\n",
  "NASALIZES": "NASALIZE, to produce sounds nasally, also NASALISE [v]\n",
  "NASALIZING": "NASALIZE, to produce sounds nasally, also NASALISE [v]\n",
  "NASALLY": "through the nose [adv]\n",
  "NASALS": "NASAL, a sound uttered through the nose [n]\n",
  "NASARD": "an organ stop [n -S]\n",
  "NASARDS": "NASARD, an organ stop [n]\n",
  "NASCENCE": "birth or origin, also NASCENCY [n -S]\n",
  "NASCENCES": "NASCENCE, birth or origin, also NASCENCY [n]\n",
  "NASCENCIES": "NASCENCY, birth or origin, also NASCENCE [n]\n",
  "NASCENCY": "birth or origin, also NASCENCE [n NASCENCIES]\n",
  "NASCENT": "coming into existence [adj]\n",
  "NASEBERRIES": "NASEBERRY, an edible fruit, aka sapodilla, also NEESBERRY, NISBERRY [n]\n",
  "NASEBERRY": "an edible fruit, aka sapodilla, also NEESBERRY, NISBERRY [n NASEBERRIES]\n",
  "NASHGAB": "(Scots) prattle, chatter, also GABNASH [n -S]\n",
  "NASHGABS": "NASHGAB, (Scots) prattle, chatter, also GABNASH [n]\n",
  "NASHI": "(Japanese) an Asian pear [n -S]\n",
  "NASHIS": "NASHI, (Japanese) an Asian pear [n]\n",
  "NASIAL": "relating to the nasion, the middle point of the nasofrontal suture [adj]\n",
  "NASION": "the middle point of the nasofrontal suture in the skull [n -S]\n",
  "NASIONS": "NASION, the middle point of the nasofrontal suture in the skull [n]\n",
  "NASOFRONTAL": "relating to the nose and the frontal bone [adj]\n",
  "NASOGASTRIC": "being or performed by intubation of the stomach through the nasal passages [adj]\n",
  "NASOLACRYMAL": "relating to the nose and tears, esp. in reference to the duct that carries tears from the eye and the nose [adj]\n",
  "NASOPHARYNGEAL": "of, relating to, or affecting the nose and pharynx or the nasopharynx [adj]\n",
  "NASOPHARYNGES": "NASOPHARYNX, the upper part of the pharynx continuous with the nasal passages [n]\n",
  "NASOPHARYNX": "the upper part of the pharynx continuous with the nasal passages [n NASOPHARYNGES or NASOPHARYNXES]\n",
  "NASOPHARYNXES": "NASOPHARYNX, the upper part of the pharynx continuous with the nasal passages [n]\n",
  "NASSELLA": "as in nassella tussock, a type of tussock grass [adj]\n",
  "NASTALIK": "(Arabic) a Persian cursive script, having long horizontal strokes and rounded characters [n -S]\n",
  "NASTALIKS": "NASTALIK, (Arabic) a Persian cursive script, having long horizontal strokes and rounded characters [n]\n",
  "NASTIC": "growing because of internal cell pressures rather than environmentally [adj]\n",
  "NASTIER": "NASTY, ill-natured [adj]\n",
  "NASTIES": "NASTY, something that is offensive [n]\n",
  "NASTIEST": "NASTY, ill-natured [adj]\n",
  "NASTILY": "NASTY, ill-natured [adv]\n",
  "NASTINESS": "the state of being nasty [n -ES]\n",
  "NASTINESSES": "NASTINESS, the state of being nasty [n]\n",
  "NASTURTIUM": "a genus of cruciferous plants, having white or yellowish flowers, including several species of cress [n -S]\n",
  "NASTURTIUMS": "NASTURTIUM, a genus of cruciferous plants, having white or yellowish flowers, including several species of cress [n]\n",
  "NASTY": "ill-natured [adj NASTIER, NASTIEST, NASTILY] / something that is offensive [n NASTIES]\n",
  "NASUTE": "a type of white ant [n -S]\n",
  "NASUTES": "NASUTE, a type of white ant [n]\n",
  "NAT": "(colloquial) a nationalist [n -S]\n",
  "NATAL": "pertaining to one's birth [adj]\n",
  "NATALITIAL": "of or pertaining to a birthday [adj]\n",
  "NATALITIES": "NATALITY, birthrate, the ratio of the number of births in a period to the size of the population [n]\n",
  "NATALITY": "birthrate, the ratio of the number of births in a period to the size of the population [n NATALITIES]\n",
  "NATANT": "floating in water, as the leaves of water lilies, or submersed, as those of many aquatic plants [adj]\n",
  "NATANTLY": "NATANT, floating in water, as the leaves of water lilies, or submersed, as those of many aquatic plants [adv]\n",
  "NATATION": "the act of swimming [n -S]\n",
  "NATATIONAL": "relating to swimming; adapted for swimming, also NATATORIAL, NATATORY [adj]\n",
  "NATATIONS": "NATATION, the act of swimming [n]\n",
  "NATATORIA": "NATATORIUM, (Latin) an indoor swimming-pool [n]\n",
  "NATATORIAL": "relating to swimming; adapted for swimming, also NATATIONAL, NATATORY [adj]\n",
  "NATATORIUM": "(Latin) an indoor swimming-pool [n NATATORIUMS or NATATORIA]\n",
  "NATATORIUMS": "NATATORIUM, (Latin) an indoor swimming-pool [n]\n",
  "NATATORY": "relating to swimming; adapted for swimming, also NATATIONAL, NATATORIAL [adj]\n",
  "NATCH": "the rump of beef; esp. the lower and back part of the rump, also NACHE [n -ES]\n",
  "NATCHES": "NATCH, the rump of beef; esp. the lower and back part of the rump, also NACHE [n]\n",
  "NATES": "NATIS, (Latin) a buttock [n]\n",
  "NATHELESS": "(archaic) nevertheless, also NATHELESSE, NATHLESS, NAYTHLES, NETHELESS, NEVERTHELESS [adv]\n",
  "NATHELESSE": "(archaic) nevertheless, also NATHELESS, NATHLESS, NAYTHLES, NETHELESS, NEVERTHELESS [adv]\n",
  "NATHEMO": "(Spenser) nevermore, also NATHEMORE, NEVERMORE [adv]\n",
  "NATHEMORE": "(Spenser) nevermore, also NATHEMO, NEVERMORE [adv]\n",
  "NATHLESS": "(archaic) nevertheless, also NATHELESS, NATHELESSE, NAYTHLES, NETHELESS [adv]\n",
  "NATIFORM": "shaped like a buttock [adj]\n",
  "NATION": "people who share common descent, language and culture [n -S]\n",
  "NATIONAL": "belonging to a nation [adj NATIONALLY] / a citizen of a nation [n -S]\n",
  "NATIONALISATION": "the act of nationalising, also NATIONALIZATION [n]\n",
  "NATIONALISE": "to put an industry under state control, also NATIONALIZE [v NATIONALISED, NATIONALISING, NATIONALISES]\n",
  "NATIONALISED": "NATIONALISE, to put an industry under state control, also NATIONALIZE [v]\n",
  "NATIONALISER": "one who nationalises, also NATIONALIZER [n -S]\n",
  "NATIONALISERS": "NATIONALISER, one who nationalises, also NATIONALIZER [n]\n",
  "NATIONALISES": "NATIONALISE, to put an industry under state control, also NATIONALIZE [v]\n",
  "NATIONALISING": "NATIONALISE, to put an industry under state control, also NATIONALIZE [v]\n",
  "NATIONALISM": "loyalty and devotion to a nation [n -S]\n",
  "NATIONALISMS": "NATIONALISM, loyalty and devotion to a nation [n]\n",
  "NATIONALIST": "an advocate of or believer in nationalism [n -S]\n",
  "NATIONALISTIC": "of, favoring, or characterized by nationalism [adj]\n",
  "NATIONALISTS": "NATIONALIST, an advocate of or believer in nationalism [n]\n",
  "NATIONALITIES": "NATIONALITY, membership of, or the fact or state of belonging to, a particular nation [n]\n",
  "NATIONALITY": "membership of, or the fact or state of belonging to, a particular nation [n NATIONALITIES]\n",
  "NATIONALIZATION": "the act of nationalizing, also NATIONALISATION [n]\n",
  "NATIONALIZE": "to put an industry under state control, also NATIONALISE [v NATIONALIZED, NATIONALIZING, NATIONALIZES]\n",
  "NATIONALIZED": "NATIONALIZE, to put an industry under state control, also NATIONALISE [v]\n",
  "NATIONALIZER": "one who nationalizes, also NATIONALISER [n -S]\n",
  "NATIONALIZERS": "NATIONALIZER, one who nationalizes, also NATIONALISER [n]\n",
  "NATIONALIZES": "NATIONALIZE, to put an industry under state control, also NATIONALISE [v]\n",
  "NATIONALIZING": "NATIONALIZE, to put an industry under state control, also NATIONALISE [v]\n",
  "NATIONALLY": "NATIONAL, belonging to a nation [adv]\n",
  "NATIONALS": "NATIONAL, a citizen of a nation [n]\n",
  "NATIONHOOD": "the state of being a nation [n -S]\n",
  "NATIONHOODS": "NATIONHOOD, the state of being a nation [n]\n",
  "NATIONLESS": "without a nation [adj]\n",
  "NATIONS": "NATION, people who share common descent, language and culture [n]\n",
  "NATIONWIDE": "extending throughout a nation [adj]\n",
  "NATIS": "(Latin) a buttock [n NATES]\n",
  "NATIVE": "inborn [adj NATIVELY] / an original inhabitant of an area [n -S]\n",
  "NATIVELY": "NATIVE, inborn [adv]\n",
  "NATIVENESS": "the state of being native [n -ES]\n",
  "NATIVENESSES": "NATIVENESS, the state of being native [n]\n",
  "NATIVES": "NATIVE, an original inhabitant of an area [n]\n",
  "NATIVISM": "the policy of favouring natives of a country [n -S]\n",
  "NATIVISMS": "NATIVISM, the policy of favouring natives of a country [n]\n",
  "NATIVIST": "an advocate of nativism, the belief that the mind possesses inborn thoughts [n -S]\n",
  "NATIVISTIC": "relating to nativism [adj]\n",
  "NATIVISTS": "NATIVIST, an advocate of nativism, the belief that the mind possesses inborn thoughts [n]\n",
  "NATIVITIES": "NATIVITY, the process of being born [n]\n",
  "NATIVITY": "the process of being born [n NATIVITIES]\n",
  "NATRIUM": "sodium [n -S]\n",
  "NATRIUMS": "NATRIUM, sodium [n]\n",
  "NATRIURESES": "NATRIURESIS, excessive loss of sodium in the urine [n]\n",
  "NATRIURESIS": "excessive loss of sodium in the urine [n NATRIURESES or NATRIURESISES]\n",
  "NATRIURESISES": "NATRIURESIS, excessive loss of sodium in the urine [n]\n",
  "NATRIURETIC": "a medicine used to treat natriuresis, excessive loss of sodium in the urine [n -S]\n",
  "NATRIURETICS": "NATRIURETIC, a medicine used to treat natriuresis, excessive loss of sodium in the urine [n]\n",
  "NATROLITE": "a common fibrous zeolite, hydrated sodium aluminium silicate [n -S]\n",
  "NATROLITES": "NATROLITE, a common fibrous zeolite, hydrated sodium aluminium silicate [n]\n",
  "NATRON": "(French) a mineral, native hydrous sodium carbonate [n -S]\n",
  "NATRONS": "NATRON, (French) a mineral, native hydrous sodium carbonate [n]\n",
  "NATS": "NAT, (colloquial) a nationalist [n]\n",
  "NATTER": "to chatter [v -ED, -ING, -S]\n",
  "NATTERED": "NATTER, to chatter [v]\n",
  "NATTERER": "someone who natters [n -S]\n",
  "NATTERERS": "NATTERER, someone who natters [n]\n",
  "NATTERIER": "NATTERY, peevish [adj]\n",
  "NATTERIEST": "NATTERY, peevish [adj]\n",
  "NATTERING": "NATTER, to chatter [v]\n",
  "NATTERJACK": "a kind of toad, having a yellow line along its back [n -S]\n",
  "NATTERJACKS": "NATTERJACK, a kind of toad, having a yellow line along its back [n]\n",
  "NATTERS": "NATTER, to chatter [v]\n",
  "NATTERY": "peevish [adj NATTERIER, NATTERIEST]\n",
  "NATTIER": "NATTY, neatly dressed [adj]\n",
  "NATTIEST": "NATTY, neatly dressed [adj]\n",
  "NATTILY": "NATTY, neatly dressed [adv]\n",
  "NATTINESS": "the state of being natty [n -ES]\n",
  "NATTINESSES": "NATTINESS, the state of being natty [n]\n",
  "NATTY": "neatly dressed [adj NATTIER, NATTIEST, NATTILY]\n",
  "NATURA": "(Latin) nature [n NATURAE]\n",
  "NATURAE": "NATURA, (Latin) nature [n]\n",
  "NATURAL": "according to nature [adj NATURALLY] / a type of musical note [n -S]\n",
  "NATURALISATION": "the act of naturalising, also NATURALIZATION [n -S]\n",
  "NATURALISATIONS": "NATURALISATION, the act of naturalising, also NATURALIZATION [n]\n",
  "NATURALISE": "to confer the rights of a national on, also NATURALIZE [v NATURALISED, NATURALISING, NATURALISES]\n",
  "NATURALISED": "NATURALISE, to confer the rights of a national on, also NATURALIZE [v]\n",
  "NATURALISES": "NATURALISE, to confer the rights of a national on, also NATURALIZE [v]\n",
  "NATURALISING": "NATURALISE, to confer the rights of a national on, also NATURALIZE [v]\n",
  "NATURALISM": "the belief that the world can be explained in terms of natural forces [n -S]\n",
  "NATURALISMS": "NATURALISM, the belief that the world can be explained in terms of natural forces [n]\n",
  "NATURALIST": "a student of the natural world [n -S]\n",
  "NATURALISTIC": "of, characterized by, or according with naturalism [adj]\n",
  "NATURALISTS": "NATURALIST, a student of the natural world [n]\n",
  "NATURALIZATION": "the act of naturalizing, also NATURALISATION [n -S]\n",
  "NATURALIZATIONS": "NATURALIZATION, the act of naturalizing, also NATURALISATION [n]\n",
  "NATURALIZE": "to confer the rights of a national on, also NATURALISE [v NATURALIZED, NATURALIZING, NATURALIZES]\n",
  "NATURALIZED": "NATURALIZE, to confer the rights of a national on, also NATURALISE [v]\n",
  "NATURALIZES": "NATURALIZE, to confer the rights of a national on, also NATURALISE [v]\n",
  "NATURALIZING": "NATURALIZE, to confer the rights of a national on, also NATURALISE [v]\n",
  "NATURALLY": "NATURAL, according to nature [adv]\n",
  "NATURALNESS": "the state of being natural [n -ES]\n",
  "NATURALNESSES": "NATURALNESS, the state of being natural [n]\n",
  "NATURALS": "NATURAL, a type of musical note [n]\n",
  "NATURE": "the qualities of anything which make it what it is [n -S] / to give a particular, or a new, nature to [v NATURED, NATURING, NATURES]\n",
  "NATURED": "having a certain disposition [adj]\n",
  "NATURES": "NATURE, to give a particular, or a new, nature to [v]\n",
  "NATURING": "NATURE, to give a particular, or a new, nature to [v]\n",
  "NATURISM": "communal nudism [n -S]\n",
  "NATURISMS": "NATURISM, communal nudism [n]\n",
  "NATURIST": "a practitioner of naturism, communal nudity [n -S]\n",
  "NATURISTIC": "relating to naturism [adj]\n",
  "NATURISTS": "NATURIST, a practitioner of naturism, communal nudity [n]\n",
  "NATUROPATH": "a person who practises naturopathy [n -S]\n",
  "NATUROPATHIC": "relating to naturopathy [adj]\n",
  "NATUROPATHIES": "NATUROPATHY, medical treatment by methods believed to aid nature [n]\n",
  "NATUROPATHS": "NATUROPATH, a person who practises naturopathy [n]\n",
  "NATUROPATHY": "medical treatment by methods believed to aid nature [n NATUROPATHIES]\n",
  "NAUCH": "(Hindi) an entertainment in India consisting chiefly of dancing by professional dancing girls, also NACH, NAUTCH [n -ES]\n",
  "NAUCHES": "NAUCH, (Hindi) an entertainment in India consisting chiefly of dancing by professional dancing girls, also NACH, NAUTCH [n]\n",
  "NAUGAHYDE": "(tradename) a type of vinyl-coated fabric [n -S]\n",
  "NAUGAHYDES": "NAUGAHYDE, (tradename) a type of vinyl-coated fabric [n]\n",
  "NAUGHT": "nothing, also NOUGHT [n -S]\n",
  "NAUGHTIER": "NAUGHTY, badly-behaved [adj]\n",
  "NAUGHTIES": "NAUGHTY, an act of sexual intercourse [n]\n",
  "NAUGHTIEST": "NAUGHTY, badly-behaved [adj]\n",
  "NAUGHTILY": "NAUGHTY, badly-behaved [adv]\n",
  "NAUGHTINESS": "the state of being naughty [n -ES]\n",
  "NAUGHTINESSES": "NAUGHTINESS, the state of being naughty [n]\n",
  "NAUGHTS": "NAUGHT, nothing, also NOUGHT [n]\n",
  "NAUGHTY": "badly-behaved [adj NAUGHTIER, NAUGHTIEST, NAUGHTILY] / an act of sexual intercourse [n NAUGHTIES]\n",
  "NAUMACHIA": "(Latin) a mock sea battle, performed as a spectacle among the ancient Romans, also NAUMACHY [n NAUMACHIAE or NAUMACHIAS]\n",
  "NAUMACHIAE": "NAUMACHIA, (Latin) a mock sea battle, performed as a spectacle among the ancient Romans, also NAUMACHY [n]\n",
  "NAUMACHIAS": "NAUMACHIA, (Latin) a mock sea battle, performed as a spectacle among the ancient Romans, also NAUMACHY [n]\n",
  "NAUMACHIES": "NAUMACHY, a mock sea battle, performed as a spectacle among the ancient Romans, also NAUMACHIA [n]\n",
  "NAUMACHY": "a mock sea battle, performed as a spectacle among the ancient Romans, also NAUMACHIA [n NAUMACHIES]\n",
  "NAUNT": "(archaic) an aunt [n -S]\n",
  "NAUNTS": "NAUNT, (archaic) an aunt [n]\n",
  "NAUPLIAL": "of or like a nauplius, the larval form of certain crustaceans [adj]\n",
  "NAUPLII": "NAUPLIUS, (Latin) a larval form in certain crustaceans [n]\n",
  "NAUPLIIFORM": "having the form of a nauplius, a larval form in crustaceans [adj]\n",
  "NAUPLIOID": "shaped like a nauplius, a larval form in crustaceans [adj]\n",
  "NAUPLIUS": "(Latin) a larval form in certain crustaceans [n NAUPLII]\n",
  "NAUSEA": "an inclination to vomit [n -S]\n",
  "NAUSEANT": "an agent that induces nausea [n -S]\n",
  "NAUSEANTS": "NAUSEANT, an agent that induces nausea [n]\n",
  "NAUSEAS": "NAUSEA, an inclination to vomit [n]\n",
  "NAUSEATE": "to affect with nausea [v NAUSEATED, NAUSEATING, NAUSEATES]\n",
  "NAUSEATED": "NAUSEATE, to affect with nausea [v]\n",
  "NAUSEATES": "NAUSEATE, to affect with nausea [v]\n",
  "NAUSEATING": "NAUSEATE, to affect with nausea [v]\n",
  "NAUSEATINGLY": "NAUSEATING, NAUSEATE, to affect with nausea [adv]\n",
  "NAUSEATION": "the act of arousing nausea [n -S]\n",
  "NAUSEATIONS": "NAUSEATION, the act of arousing nausea [n]\n",
  "NAUSEATIVE": "(obsolete) causing nausea [adj]\n",
  "NAUSEOUS": "causing nausea [adj NAUSEOUSLY]\n",
  "NAUSEOUSLY": "NAUSEOUS, causing nausea [adv]\n",
  "NAUSEOUSNESS": "the state of being nauseous [n -ES]\n",
  "NAUSEOUSNESSES": "NAUSEOUSNESS, the state of being nauseous [n]\n",
  "NAUTCH": "(Hindi) an entertainment in India consisting chiefly of dancing by professional dancing girls, also NACH, NAUCH [n -ES]\n",
  "NAUTCHES": "NAUTCH, (Hindi) an entertainment in India consisting chiefly of dancing by professional dancing girls, also NACH, NAUCH [n]\n",
  "NAUTIC": "relating to ships, also NAUTICAL [adj]\n",
  "NAUTICAL": "relating to ships, also NAUTIC [adj NAUTICALLY]\n",
  "NAUTICALLY": "NAUTICAL, relating to ships, also NAUTIC [adv]\n",
  "NAUTICS": "the art or science of sailing [n]\n",
  "NAUTILI": "NAUTILUS, (Greek) a spiral-shelled mollusk [n]\n",
  "NAUTILOID": "a mollusc of the subclass Nautiloidea, to which the nautilus and several extinct species belong [n -S]\n",
  "NAUTILOIDS": "NAUTILOID, a mollusc of the subclass Nautiloidea, to which the nautilus and several extinct species belong [n]\n",
  "NAUTILUS": "(Greek) a spiral-shelled mollusk [n NAUTILUSES or NAUTILI]\n",
  "NAUTILUSES": "NAUTILUS, (Greek) a spiral-shelled mollusk [n]\n",
  "NAV": "(short for) navigation [n -S]\n",
  "NAVAID": "any of the electronic devices designed to aid navigation in a ship or aircraft [n -S]\n",
  "NAVAIDS": "NAVAID, any of the electronic devices designed to aid navigation in a ship or aircraft [n]\n",
  "NAVAL": "pertaining to ships [adj NAVALLY]\n",
  "NAVALISM": "the cult of naval supremacy [n -S]\n",
  "NAVALISMS": "NAVALISM, the cult of naval supremacy [n]\n",
  "NAVALLY": "NAVAL, pertaining to ships [adv]\n",
  "NAVAR": "a system of air navigation [n -S]\n",
  "NAVARCH": "(Greek) the commander of a fleet [n -S]\n",
  "NAVARCHIES": "NAVARCHY, rulership over the seas [n]\n",
  "NAVARCHS": "NAVARCH, (Greek) the commander of a fleet [n]\n",
  "NAVARCHY": "rulership over the seas [n NAVARCHIES]\n",
  "NAVARHO": "a low-frequency, long-range radio navigation system for aircraft [n -S]\n",
  "NAVARHOS": "NAVARHO, a low-frequency, long-range radio navigation system for aircraft [n]\n",
  "NAVARIN": "(French) a stew containing mutton and turnips [n -S]\n",
  "NAVARINS": "NAVARIN, (French) a stew containing mutton and turnips [n]\n",
  "NAVARS": "NAVAR, a system of air navigation [n]\n",
  "NAVE": "the main body of a church [n -S]\n",
  "NAVEL": "a depression in the abdomen [n -S]\n",
  "NAVELS": "NAVEL, a depression in the abdomen [n]\n",
  "NAVELWORT": "a perennial succulent herb, having round, peltate leaves with a central depression, aka pennywort [n -S]\n",
  "NAVELWORTS": "NAVELWORT, a perennial succulent herb, having round, peltate leaves with a central depression, aka pennywort [n]\n",
  "NAVES": "NAVE, the main body of a church [n]\n",
  "NAVETTE": "(French) a gem cut in a pointed oval form [n -S]\n",
  "NAVETTES": "NAVETTE, (French) a gem cut in a pointed oval form [n]\n",
  "NAVEW": "a wild Swedish turnip [n -S]\n",
  "NAVEWS": "NAVEW, a wild Swedish turnip [n]\n",
  "NAVICERT": "a document permitting a neutral vessel passage through a naval blockade [n -S]\n",
  "NAVICERTS": "NAVICERT, a document permitting a neutral vessel passage through a naval blockade [n]\n",
  "NAVICULA": "(Latin) an incense-holder shaped like a boat [n -S]\n",
  "NAVICULAR": "pertaining to or like a boat [adj] / a boat-shaped bone of the wrist, also NAVICULARE [n -S]\n",
  "NAVICULARE": "a boat-shaped bone of the wrist, also NAVICULAR [n -S]\n",
  "NAVICULARES": "NAVICULARE, a boat-shaped bone of the wrist, also NAVICULAR [n]\n",
  "NAVICULARS": "NAVICULAR, a boat-shaped bone of the wrist, also NAVICULARE [n]\n",
  "NAVICULAS": "NAVICULA, (Latin) an incense-holder shaped like a boat [n]\n",
  "NAVIES": "NAVY, a nation's warships [n]\n",
  "NAVIGABILITIES": "NAVIGABILITY, the state of being navigable [n]\n",
  "NAVIGABILITY": "the state of being navigable [n NAVIGABILITIES]\n",
  "NAVIGABLE": "that can be navigated [adj NAVIGABLY]\n",
  "NAVIGABLENESS": "NAVIGABLE, that can be navigated [n]\n",
  "NAVIGABLENESSES": "NAVIGABLENESS, NAVIGABLE, that can be navigated [n]\n",
  "NAVIGABLY": "NAVIGABLE, that can be navigated [adv]\n",
  "NAVIGATE": "to conduct and manage a course [v NAVIGATED, NAVIGATING, NAVIGATES]\n",
  "NAVIGATED": "NAVIGATE, to conduct and manage a course [v]\n",
  "NAVIGATES": "NAVIGATE, to conduct and manage a course [v]\n",
  "NAVIGATING": "NAVIGATE, to conduct and manage a course [v]\n",
  "NAVIGATION": "the act or practice of navigating [n -S]\n",
  "NAVIGATIONAL": "relating to navigation [adj NAVIGATIONALLY]\n",
  "NAVIGATIONALLY": "NAVIGATIONAL, relating to navigation [adv]\n",
  "NAVIGATIONS": "NAVIGATION, the act or practice of navigating [n]\n",
  "NAVIGATOR": "a person who navigates or sails [n -S]\n",
  "NAVIGATORS": "NAVIGATOR, a person who navigates or sails [n]\n",
  "NAVS": "NAV, (short for) navigation [n]\n",
  "NAVVIED": "NAVVY, to work as a labourer [v]\n",
  "NAVVIES": "NAVVY, to work as a labourer [v]\n",
  "NAVVY": "to work as a labourer [v NAVVIED, NAVVYING, NAVVIES]\n",
  "NAVVYING": "NAVVY, to work as a labourer [v]\n",
  "NAVY": "a nation's warships [n NAVIES]\n",
  "NAW": "(colloquial) no [interj]\n",
  "NAWAB": "(Urdu) a governor of India under the British [n -S]\n",
  "NAWABS": "NAWAB, (Urdu) a governor of India under the British [n]\n",
  "NAY": "a negative vote [n -S]\n",
  "NAYS": "NAY, a negative vote [n]\n",
  "NAYSAID": "NAYSAY, to oppose or deny [v]\n",
  "NAYSAY": "to oppose or deny [v NAYSAID, NAYSAYING, NAYSAYS]\n",
  "NAYSAYER": "one that denies or opposes something [n -S]\n",
  "NAYSAYERS": "NAYSAYER, one that denies or opposes something [n]\n",
  "NAYSAYING": "the act of saying no [n -S]\n",
  "NAYSAYINGS": "NAYSAYING, the act of saying no [n]\n",
  "NAYSAYS": "NAYSAY, to oppose or deny [v]\n",
  "NAYTHLES": "(archaic) nevertheless, also NATHELESS, NATHELESSE, NATHLESS, NETHELESS [adv]\n",
  "NAYWARD": "(Shakespeare) the negative side [n -S]\n",
  "NAYWARDS": "NAYWARD, (Shakespeare) the negative side [n]\n",
  "NAYWORD": "a proverbial reproach [n -S]\n",
  "NAYWORDS": "NAYWORD, a proverbial reproach [n]\n",
  "NAZE": "a headland or cape [n -S]\n",
  "NAZES": "NAZE, a headland or cape [n]\n",
  "NAZI": "(German) a type of fascist [n -S]\n",
  "NAZIFICATION": "the act of making Nazi [n -S]\n",
  "NAZIFICATIONS": "NAZIFICATION, the act of making Nazi [n]\n",
  "NAZIFIED": "NAZIFY, to become like a nazi [v]\n",
  "NAZIFIES": "NAZIFY, to become like a nazi [v]\n",
  "NAZIFY": "to become like a nazi [v NAZIFIED, NAZIFYING, NAZIFIES]\n",
  "NAZIFYING": "NAZIFY, to become like a nazi [v]\n",
  "NAZIR": "(Arabic) an Indian court official [n -S]\n",
  "NAZIRS": "NAZIR, (Arabic) an Indian court official [n]\n",
  "NAZIS": "NAZI, (German) a type of fascist [n]\n",
  "NDUJA": "(Italian) a paste of cured pork, peppers, and spices, originating in Calabria in SW Italy [n -S]\n",
  "NDUJAS": "NDUJA, (Italian) a paste of cured pork, peppers, and spices, originating in Calabria in SW Italy [n]\n",
  "NE": "not (conj); nor [adv]\n",
  "NEAFE": "(Shakespeare) a fist, also NEAFFE, NEIF, NEIVE, NIEF, NIEVE [n -S]\n",
  "NEAFES": "NEAFE, (Shakespeare) a fist, also NEAFFE, NEIF, NEIVE, NIEF, NIEVE [n]\n",
  "NEAFFE": "(Shakespeare) a fist, also NEAFE, NEIF, NEIVE, NIEF, NIEVE [n -S]\n",
  "NEAFFES": "NEAFFE, (Shakespeare) a fist, also NEAFE, NEIF, NEIVE, NIEF, NIEVE [n]\n",
  "NEAL": "an aphetic form of anneal, to heat and cool metal gradually to temper [v -ED, -ING, -S]\n",
  "NEALED": "NEAL, an aphetic form of anneal, to heat and cool metal gradually to temper [v]\n",
  "NEALING": "NEAL, an aphetic form of anneal, to heat and cool metal gradually to temper [v]\n",
  "NEALS": "NEAL, an aphetic form of anneal, to heat and cool metal gradually to temper [v]\n",
  "NEANDERTAL": "(German) a primitive or reactionary person, also NEANDERTALER, NEANDERTHAL, NEANDERTHALER [n -S]\n",
  "NEANDERTALER": "a primitive or reactionary person, also NEANDERTAL, NEANDERTHAL, NEANDERTHALER [n -S]\n",
  "NEANDERTALERS": "NEANDERTALER, a primitive or reactionary person, also NEANDERTAL, NEANDERTHAL, NEANDERTHALER [n]\n",
  "NEANDERTALS": "NEANDERTAL, (German) a primitive or reactionary person, also NEANDERTALER, NEANDERTHAL, NEANDERTHALER [n]\n",
  "NEANDERTHAL": "(German) a primitive or reactionary person, also NEANDERTAL, NEANDERTALER, NEANDERTHALER [n -S]\n",
  "NEANDERTHALER": "a primitive or reactionary person, also NEANDERTAL, NEANDERTALER, NEANDERTHAL [n -S]\n",
  "NEANDERTHALERS": "NEANDERTHALER, a primitive or reactionary person, also NEANDERTAL, NEANDERTALER, NEANDERTHAL [n]\n",
  "NEANDERTHALOID": "of or like a neanderthaler [adj]\n",
  "NEANDERTHALS": "NEANDERTHAL, (German) a primitive or reactionary person, also NEANDERTAL, NEANDERTALER, NEANDERTHALER [n]\n",
  "NEANIC": "relating to the adolescent period in the life history of an individual [adj]\n",
  "NEAP": "to tend towards the tide of the smallest range [v -ED, -ING, -S]\n",
  "NEAPED": "NEAP, to tend towards the tide of the smallest range [v]\n",
  "NEAPING": "NEAP, to tend towards the tide of the smallest range [v]\n",
  "NEAPOLITAN": "a small rectangular chocolate [n -S]\n",
  "NEAPOLITANS": "NEAPOLITAN, a small rectangular chocolate [n]\n",
  "NEAPS": "NEAP, to tend towards the tide of the smallest range [v]\n",
  "NEAR": "situated within a short distance [adj NEARER, NEAREST, NEARLY] / to approach [v -ED, -ING, -S]\n",
  "NEARBY": "near [adv]\n",
  "NEARED": "NEAR, to approach [v]\n",
  "NEARER": "NEAR, situated within a short distance [adj]\n",
  "NEAREST": "NEAR, situated within a short distance [adj]\n",
  "NEARING": "NEAR, to approach [v]\n",
  "NEARISH": "somewhat near [adj]\n",
  "NEARLIER": "NEARLY, almost [adv]\n",
  "NEARLIEST": "NEARLY, almost [adv]\n",
  "NEARLY": "almost [adv NEARLIER, NEARLIEST]\n",
  "NEARNESS": "the state of being near [n -ES]\n",
  "NEARNESSES": "NEARNESS, the state of being near [n]\n",
  "NEARS": "NEAR, to approach [v]\n",
  "NEARSHORE": "(in business) to source service activities to a neighbouring country, esp. for economic reasons [v NEARSHORED, NEARSHORING, NEARSHORES]\n",
  "NEARSHORED": "NEARSHORE, (in business) to source service activities to a neighbouring country, esp. for economic reasons [v]\n",
  "NEARSHORES": "NEARSHORE, (in business) to source service activities to a neighbouring country, esp. for economic reasons [v]\n",
  "NEARSHORING": "NEARSHORE, (in business) to source service activities to a neighbouring country, esp. for economic reasons [v]\n",
  "NEARSIDE": "the passenger side of a car [n -S]\n",
  "NEARSIDES": "NEARSIDE, the passenger side of a car [n]\n",
  "NEARSIGHTED": "able to see near things more clearly than distant ones [adj NEARSIGHTEDLY]\n",
  "NEARSIGHTEDLY": "NEARSIGHTED, able to see near things more clearly than distant ones [adv]\n",
  "NEARSIGHTEDNESS": "NEARSIGHTED, able to see near things more clearly than distant ones [n]\n",
  "NEARTHROSES": "NEARTHROSIS, another name for pseudoarthrosis [n]\n",
  "NEARTHROSIS": "another name for pseudoarthrosis [n NEARTHROSES]\n",
  "NEAT": "tidy [adj NEATER, NEATEST, NEATLY] / cattle [n -S]\n",
  "NEATEN": "to make neat [v -ED, -ING, -S]\n",
  "NEATENED": "NEATEN, to make neat [v]\n",
  "NEATENING": "NEATEN, to make neat [v]\n",
  "NEATENS": "NEATEN, to make neat [v]\n",
  "NEATER": "NEAT, tidy [adj]\n",
  "NEATEST": "NEAT, tidy [adj]\n",
  "NEATH": "(dialect) beneath, also ANEATH, UNNEATH [prep]\n",
  "NEATHERD": "a herdsman [n -S]\n",
  "NEATHERDS": "NEATHERD, a herdsman [n]\n",
  "NEATLY": "NEAT, tidy [adv]\n",
  "NEATNESS": "the state of being neat [n -ES]\n",
  "NEATNESSES": "NEATNESS, the state of being neat [n]\n",
  "NEATNIK": "a compulsively neat person [n -S]\n",
  "NEATNIKS": "NEATNIK, a compulsively neat person [n]\n",
  "NEATS": "NEAT, cattle [n]\n",
  "NEB": "of birds, to touch bills [v NEBBED, NEBBING, NEBS]\n",
  "NEBBED": "NEB, of birds, to touch bills [v]\n",
  "NEBBICH": "(Yiddish) a colourless, insignificant person, also NEBBISH, NEBBISHE, NEBBISHER, NEBISH [n -S]\n",
  "NEBBICHS": "NEBBICH, (Yiddish) a colourless, insignificant person, also NEBBISH, NEBBISHE, NEBBISHER, NEBISH [n]\n",
  "NEBBING": "NEB, of birds, to touch bills [v]\n",
  "NEBBISH": "(Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISHE, NEBBISHER, NEBISH [n -ES]\n",
  "NEBBISHE": "(Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISH, NEBBISHER, NEBISH [n -S]\n",
  "NEBBISHER": "(Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISH, NEBBISHE, NEBISH [n -S]\n",
  "NEBBISHERS": "NEBBISHER, (Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISH, NEBBISHE, NEBISH [n]\n",
  "NEBBISHES": "NEBBISH, (Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISHE, NEBBISHER, NEBISH [n]\n",
  "NEBBISHIER": "NEBBISHY, like a nebbish, wimpy [adj]\n",
  "NEBBISHIEST": "NEBBISHY, like a nebbish, wimpy [adj]\n",
  "NEBBISHY": "like a nebbish, wimpy [adj NEBBISHIER, NEBBISHIEST]\n",
  "NEBBUK": "(Arabic) a prickly shrub, the Christ's-thorn, also NABK, NEBECK, NEBEK [n -S]\n",
  "NEBBUKS": "NEBBUK, (Arabic) a prickly shrub, the Christ's-thorn, also NABK, NEBECK, NEBEK [n]\n",
  "NEBECK": "(Arabic) a prickly shrub, the Christ's-thorn, also NABK, NEBBUK, NEBEK [n -S]\n",
  "NEBECKS": "NEBECK, (Arabic) a prickly shrub, the Christ's-thorn, also NABK, NEBBUK, NEBEK [n]\n",
  "NEBEK": "(Arabic) a prickly shrub, the Christ's-thorn, also NABK, NEBBUK, NEBECK [n -S]\n",
  "NEBEKS": "NEBEK, (Arabic) a prickly shrub, the Christ's-thorn, also NABK, NEBBUK, NEBECK [n]\n",
  "NEBEL": "(Hebrew) a Hebrew instrument, apparently a harp [n -S]\n",
  "NEBELS": "NEBEL, (Hebrew) a Hebrew instrument, apparently a harp [n]\n",
  "NEBENKERN": "(German) a two-stranded helical structure of the proximal tail region of a spermatozoon [n -S]\n",
  "NEBENKERNS": "NEBENKERN, (German) a two-stranded helical structure of the proximal tail region of a spermatozoon [n]\n",
  "NEBISH": "(Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISH, NEBBISHE, NEBBISHER [n -ES]\n",
  "NEBISHES": "NEBISH, (Yiddish) a colourless, insignificant person, also NEBBICH, NEBBISH, NEBBISHE, NEBBISHER [n]\n",
  "NEBRIS": "(Latin) a fawn-skin worn by Bacchus and his votaries [n -ES]\n",
  "NEBRISES": "NEBRIS, (Latin) a fawn-skin worn by Bacchus and his votaries [n]\n",
  "NEBS": "NEB, of birds, to touch bills [v]\n",
  "NEBUCHADNEZZAR": "an oversize wine bottle holding about 3.50 gallons [n -S]\n",
  "NEBUCHADNEZZARS": "NEBUCHADNEZZAR, an oversize wine bottle holding about 3.50 gallons [n]\n",
  "NEBULA": "(Latin) a hazy or indistinct luminous area in the night sky representing a distant cluster of stars [n NEBULAE or NEBULAS]\n",
  "NEBULAE": "NEBULA, (Latin) a hazy or indistinct luminous area in the night sky representing a distant cluster of stars [n]\n",
  "NEBULAR": "of or like a nebula, a hazy or indistinct luminous area in the night sky representing a distant cluster of stars [adj]\n",
  "NEBULAS": "NEBULA, (Latin) a hazy or indistinct luminous area in the night sky representing a distant cluster of stars [n]\n",
  "NEBULE": "in heraldry, a wavy moulding [n -S]\n",
  "NEBULES": "NEBULE, in heraldry, a wavy moulding [n]\n",
  "NEBULISATION": "the act of nebulizing, also NEBULIZATION [n -S]\n",
  "NEBULISATIONS": "NEBULISATION, the act of nebulizing, also NEBULIZATION [n]\n",
  "NEBULISE": "to reduce to a fine spray, also NEBULIZE [v NEBULISED, NEBULISING, NEBULISES]\n",
  "NEBULISED": "NEBULISE, to reduce to a fine spray, also NEBULIZE [v]\n",
  "NEBULISER": "a spraying apparatus, an atomiser, also NEBULIZER [n -S]\n",
  "NEBULISERS": "NEBULISER, a spraying apparatus, an atomiser, also NEBULIZER [n]\n",
  "NEBULISES": "NEBULISE, to reduce to a fine spray, also NEBULIZE [v]\n",
  "NEBULISING": "NEBULISE, to reduce to a fine spray, also NEBULIZE [v]\n",
  "NEBULIUM": "an element formerly assumed to explain certain lines in the spectra of gaseous nebulae, now known to be due to states of oxygen and nitrogen not possible under earthly conditions [n -S]\n",
  "NEBULIUMS": "NEBULIUM, an element formerly assumed to explain certain lines in the spectra of gaseous nebulae, now known to be due to states of oxygen and nitrogen not possible under earthly conditions [n]\n",
  "NEBULIZATION": "the act of nebulizing, also NEBULISATION [n -S]\n",
  "NEBULIZATIONS": "NEBULIZATION, the act of nebulizing, also NEBULISATION [n]\n",
  "NEBULIZE": "to reduce to a fine spray, also NEBULISE [v NEBULIZED, NEBULIZING, NEBULIZES]\n",
  "NEBULIZED": "NEBULIZE, to reduce to a fine spray, also NEBULISE [v]\n",
  "NEBULIZER": "a spraying apparatus, an atomiser, also NEBULISER [n -S]\n",
  "NEBULIZERS": "NEBULIZER, a spraying apparatus, an atomiser, also NEBULISER [n]\n",
  "NEBULIZES": "NEBULIZE, to reduce to a fine spray, also NEBULISE [v]\n",
  "NEBULIZING": "NEBULIZE, to reduce to a fine spray, also NEBULISE [v]\n",
  "NEBULOSE": "like a nebula, cloudy, also NEBULOUS [adj]\n",
  "NEBULOSITIES": "NEBULOSITY, the state of being nebulous, also NEBULOUSNESS [n]\n",
  "NEBULOSITY": "the state of being nebulous, also NEBULOUSNESS [n NEBULOSITIES]\n",
  "NEBULOUS": "like a nebula, cloudy, also NEBULOSE [adj NEBULOUSLY]\n",
  "NEBULOUSLY": "NEBULOUS, like a nebula, cloudy, also NEBULOSE [adv]\n",
  "NEBULOUSNESS": "the state of being nebulous, also NEBULOSITY [n -ES]\n",
  "NEBULOUSNESSES": "NEBULOUSNESS, the state of being nebulous, also NEBULOSITY [n]\n",
  "NEBULY": "in heraldry, composed of successive short curves, also NEBULE [adj]\n",
  "NECESSAIRE": "(French) a dressing-table; a workbox [n -S]\n",
  "NECESSAIRES": "NECESSAIRE, (French) a dressing-table; a workbox [n]\n",
  "NECESSARIAN": "a fatalist, also NECESSITARIAN [n -S]\n",
  "NECESSARIANISM": "the theory that actions are determined by prior history; fatalism [n -S]\n",
  "NECESSARIANISMS": "NECESSARIANISM, the theory that actions are determined by prior history; fatalism [n]\n",
  "NECESSARIANS": "NECESSARIAN, a fatalist, also NECESSITARIAN [n]\n",
  "NECESSARIES": "NECESSARY, something necessary [n]\n",
  "NECESSARILY": "NECESSARY, needed [adv]\n",
  "NECESSARINESS": "the state of being necessary [n -ES]\n",
  "NECESSARINESSES": "NECESSARINESS, the state of being necessary [n]\n",
  "NECESSARY": "needed [adj NECESSARILY] / something necessary [n NECESSARIES]\n",
  "NECESSITARIAN": "a fatalist, also NECESSARIAN [n -S]\n",
  "NECESSITARIANS": "NECESSITARIAN, a fatalist, also NECESSARIAN [n]\n",
  "NECESSITATE": "to make necessary [v NECESSITATED, NECESSITATING, NECESSITATES]\n",
  "NECESSITATED": "NECESSITATE, to make necessary [v]\n",
  "NECESSITATES": "NECESSITATE, to make necessary [v]\n",
  "NECESSITATING": "NECESSITATE, to make necessary [v]\n",
  "NECESSITATION": "the act of necessitating [n -S]\n",
  "NECESSITATIONS": "NECESSITATION, the act of necessitating [n]\n",
  "NECESSITATIVE": "relating to necessity [adj]\n",
  "NECESSITIED": "(Shakespeare) forced into a state of subjection or submissiveness as a result of poverty [adj]\n",
  "NECESSITIES": "NECESSITY, a state of being necessary [n]\n",
  "NECESSITOUS": "needful, in need [adj NECESSITOUSLY]\n",
  "NECESSITOUSLY": "NECESSITOUS, needful, in need [adv]\n",
  "NECESSITOUSNESS": "the state of being necessitous [n]\n",
  "NECESSITY": "a state of being necessary [n NECESSITIES]\n",
  "NECK": "to kiss and caress in lovemaking [v -ED, -ING, -S]\n",
  "NECKATEE": "(obsolete) a neckerchief [n -S]\n",
  "NECKATEES": "NECKATEE, (obsolete) a neckerchief [n]\n",
  "NECKBAND": "a band worn around the throat [n -S]\n",
  "NECKBANDS": "NECKBAND, a band worn around the throat [n]\n",
  "NECKBEEF": "the coarse flesh on the neck of cattle; inferior stuff [n -S]\n",
  "NECKBEEFS": "NECKBEEF, the coarse flesh on the neck of cattle; inferior stuff [n]\n",
  "NECKCLOTH": "a cloth worn round the neck [n -S]\n",
  "NECKCLOTHS": "NECKCLOTH, a cloth worn round the neck [n]\n",
  "NECKED": "NECK, to kiss and caress in lovemaking [v]\n",
  "NECKER": "a person who indulges in amorous fondling with another [n -S]\n",
  "NECKERCHIEF": "an ornamental cloth, a kerchief for the neck [n NECKERCHIEFS or NECKERCHIEVES]\n",
  "NECKERCHIEFS": "NECKERCHIEF, an ornamental cloth, a kerchief for the neck [n]\n",
  "NECKERCHIEVES": "NECKERCHIEF, an ornamental cloth, a kerchief for the neck [n]\n",
  "NECKERS": "NECKER, a person who indulges in amorous fondling with another [n]\n",
  "NECKGEAR": "apparel for the neck [n -S]\n",
  "NECKGEARS": "NECKGEAR, apparel for the neck [n]\n",
  "NECKING": "a small molding near the top of a column [n -S]\n",
  "NECKINGS": "NECKING, a small molding near the top of a column [n]\n",
  "NECKLACE": "to punish with a burning tyre around the neck [v NECKLACED, NECKLACING, NECKLACES]\n",
  "NECKLACED": "NECKLACE, to punish with a burning tyre around the neck [v]\n",
  "NECKLACES": "NECKLACE, to punish with a burning tyre around the neck [v]\n",
  "NECKLACING": "(South African) the punishment of having a petrol-soaked tyre placed round the neck or shoulders and set alight, traditionally used by black people on those thought to be government sympathizers [n -S]\n",
  "NECKLACINGS": "NECKLACING, (South African) the punishment of having a petrol-soaked tyre placed round the neck or shoulders and set alight, traditionally used by black people on those thought to be government sympathizers [n]\n",
  "NECKLESS": "without a neck [adj]\n",
  "NECKLET": "an ornament for wearing round the neck [n -S]\n",
  "NECKLETS": "NECKLET, an ornament for wearing round the neck [n]\n",
  "NECKLIKE": "resembling a neck [adj]\n",
  "NECKLINE": "the shape or position of the upper edge of a dress, blouse, etc. [n -S]\n",
  "NECKLINES": "NECKLINE, the shape or position of the upper edge of a dress, blouse, etc. [n]\n",
  "NECKPIECE": "a piece of cloth for the neck [n -S]\n",
  "NECKPIECES": "NECKPIECE, a piece of cloth for the neck [n]\n",
  "NECKS": "NECK, to kiss and caress in lovemaking [v]\n",
  "NECKSHOT": "a shot in the neck of an animal [n -S]\n",
  "NECKSHOTS": "NECKSHOT, a shot in the neck of an animal [n]\n",
  "NECKTIE": "a strip of fabric worn around the neck [n -S]\n",
  "NECKTIES": "NECKTIE, a strip of fabric worn around the neck [n]\n",
  "NECKVERSE": "the test of ability to read for those who claimed benefit of clergy, usually Psalm 51.1 [n -S]\n",
  "NECKVERSES": "NECKVERSE, the test of ability to read for those who claimed benefit of clergy, usually Psalm 51.1 [n]\n",
  "NECKWEAR": "something that is worn around the neck [n -S]\n",
  "NECKWEARS": "NECKWEAR, something that is worn around the neck [n]\n",
  "NECKWEED": "an American annual weed, with small white flowers and a roundish pod [n -S]\n",
  "NECKWEEDS": "NECKWEED, an American annual weed, with small white flowers and a roundish pod [n]\n",
  "NECROBIOSES": "NECROBIOSIS, the natural degeneration and death of a cell in living tissue [n]\n",
  "NECROBIOSIS": "the natural degeneration and death of a cell in living tissue [n NECROBIOSES]\n",
  "NECROBIOTIC": "relating to necrobiosis [adj]\n",
  "NECROGRAPHER": "a writer of obituaries [n -S]\n",
  "NECROGRAPHERS": "NECROGRAPHER, a writer of obituaries [n]\n",
  "NECROLATER": "one who practises necrolatry, worship of the dead [n -S]\n",
  "NECROLATERS": "NECROLATER, one who practises necrolatry, worship of the dead [n]\n",
  "NECROLATRIES": "NECROLATRY, worship of the dead [n]\n",
  "NECROLATRY": "worship of the dead [n NECROLATRIES]\n",
  "NECROLOGIC": "relating to necrology, the study of corpses, also NECROLOGICAL [adj]\n",
  "NECROLOGICAL": "relating to necrology, the study of corpses, also NECROLOGIC [adj]\n",
  "NECROLOGIES": "NECROLOGY, an obituary list [n]\n",
  "NECROLOGIST": "a person who writes obituaries or eulogies [n -S]\n",
  "NECROLOGISTS": "NECROLOGIST, a person who writes obituaries or eulogies [n]\n",
  "NECROLOGY": "an obituary list [n NECROLOGIES]\n",
  "NECROMANCER": "one who practises necromancy [n -S]\n",
  "NECROMANCERS": "NECROMANCER, one who practises necromancy [n]\n",
  "NECROMANCIES": "NECROMANCY, divination by trying to communicate with the spirits of the dead [n]\n",
  "NECROMANCY": "divination by trying to communicate with the spirits of the dead [n NECROMANCIES]\n",
  "NECROMANIA": "the erotic love of corpses, also NECROPHILIA, NECROPHILY [n -S]\n",
  "NECROMANIAC": "one suffering from necromania [n -S]\n",
  "NECROMANIACS": "NECROMANIAC, one suffering from necromania [n]\n",
  "NECROMANIAS": "NECROMANIA, the erotic love of corpses, also NECROPHILIA, NECROPHILY [n]\n",
  "NECROMANTIC": "relating to necromancy, divination by trying to communicate with the spirits of the dead, also NECROMANTICAL [adj NECROMANTICALLY]\n",
  "NECROMANTICAL": "relating to necromancy, divination by trying to communicate with the spirits of the dead, also NECROMANTIC [adj NECROMANTICALLY]\n",
  "NECROMANTICALLY": "NECROMANTICAL, relating to necromancy, divination by trying to communicate with the spirits of the dead, also NECROMANTIC [adv]\n",
  "NECROPHAGOUS": "feeding on the dead [adj]\n",
  "NECROPHIL": "someone who is morbidly attracted to corpses, also NECROPHILE [n -S]\n",
  "NECROPHILE": "someone who is morbidly attracted to corpses, also NECROPHIL [n -S]\n",
  "NECROPHILES": "NECROPHILE, someone who is morbidly attracted to corpses, also NECROPHIL [n]\n",
  "NECROPHILIA": "the erotic love of corpses, also NECROMANIA, NECROPHILISM, NECROPHILY [n -S]\n",
  "NECROPHILIAC": "one who practises necrophilia [n -S]\n",
  "NECROPHILIACS": "NECROPHILIAC, one who practises necrophilia [n]\n",
  "NECROPHILIAS": "NECROPHILIA, the erotic love of corpses, also NECROMANIA, NECROPHILISM, NECROPHILY [n]\n",
  "NECROPHILIC": "relating to necrophilia [adj]\n",
  "NECROPHILIES": "NECROPHILY, the erotic love of corpses, also NECROMANIA, NECROPHILIA, NECROPHILISM [n]\n",
  "NECROPHILISM": "the erotic love of corpses, also NECROMANIA, NECROPHILIA, NECROPHILY [n -S]\n",
  "NECROPHILISMS": "NECROPHILISM, the erotic love of corpses, also NECROMANIA, NECROPHILIA, NECROPHILY [n]\n",
  "NECROPHILOUS": "loving corpses [adj]\n",
  "NECROPHILS": "NECROPHIL, someone who is morbidly attracted to corpses, also NECROPHILE [n]\n",
  "NECROPHILY": "the erotic love of corpses, also NECROMANIA, NECROPHILIA, NECROPHILISM [n NECROPHILIES]\n",
  "NECROPHOBE": "an organism that eats dead matter [n -S]\n",
  "NECROPHOBES": "NECROPHOBE, an organism that eats dead matter [n]\n",
  "NECROPHOBIA": "a morbid fear of corpses [n -S]\n",
  "NECROPHOBIAS": "NECROPHOBIA, a morbid fear of corpses [n]\n",
  "NECROPHOBIC": "having a morbid fear of corpses [adj]\n",
  "NECROPHOROUS": "carrying away and burying dead bodies, as do burying beetles [adj]\n",
  "NECROPOLEIS": "NECROPOLIS, (Greek) a cemetery or burial place [n]\n",
  "NECROPOLES": "NECROPOLIS, (Greek) a cemetery or burial place [n]\n",
  "NECROPOLI": "NECROPOLIS, (Greek) a cemetery or burial place [n]\n",
  "NECROPOLIS": "(Greek) a cemetery or burial place [n NECROPOLI or NECROPOLEIS or NECROPOLISES or NECROPOLES]\n",
  "NECROPOLISES": "NECROPOLIS, (Greek) a cemetery or burial place [n]\n",
  "NECROPSIED": "NECROPSY, to perform an autopsy on [v]\n",
  "NECROPSIES": "NECROPSY, to perform an autopsy on [v]\n",
  "NECROPSY": "to perform an autopsy on [v NECROPSIED, NECROPSYING, NECROPSIES]\n",
  "NECROPSYING": "NECROPSY, to perform an autopsy on [v]\n",
  "NECROSCOPIC": "relating to necroscopy, also NECROSCOPICAL [adj]\n",
  "NECROSCOPICAL": "relating to necroscopy, also NECROSCOPIC [adj]\n",
  "NECROSCOPIES": "NECROSCOPY, an autopsy [n]\n",
  "NECROSCOPY": "an autopsy [n NECROSCOPIES]\n",
  "NECROSE": "to affect with necrosis [v NECROSED, NECROSING, NECROSES]\n",
  "NECROSED": "NECROSE, to affect with necrosis [v]\n",
  "NECROSES": "NECROSE, to affect with necrosis [v]\n",
  "NECROSING": "NECROSE, to affect with necrosis [v]\n",
  "NECROSIS": "death of part of the living body, e.g. as a symptom of gangrene [n NECROSES]\n",
  "NECROTIC": "undergoing death of part of the body [adj]\n",
  "NECROTISE": "to affect with or undergo necrosis, also NECROTIZE [v NECROTISED, NECROTISING, NECROTISES]\n",
  "NECROTISED": "NECROTISE, to affect with or undergo necrosis, also NECROTIZE [v]\n",
  "NECROTISES": "NECROTISE, to affect with or undergo necrosis, also NECROTIZE [v]\n",
  "NECROTISING": "NECROTISE, to affect with or undergo necrosis, also NECROTIZE [v]\n",
  "NECROTIZE": "to affect with or undergo necrosis, also NECROTISE [v NECROTIZED, NECROTIZING, NECROTIZES]\n",
  "NECROTIZED": "NECROTIZE, to affect with or undergo necrosis, also NECROTISE [v]\n",
  "NECROTIZES": "NECROTIZE, to affect with or undergo necrosis, also NECROTISE [v]\n",
  "NECROTIZING": "NECROTIZE, to affect with or undergo necrosis, also NECROTISE [v]\n",
  "NECROTOMIES": "NECROTOMY, the dissection of dead bodies; the removal of necrosed bone from a living body [n]\n",
  "NECROTOMY": "the dissection of dead bodies; the removal of necrosed bone from a living body [n NECROTOMIES]\n",
  "NECROTROPH": "a parasitic organism that kills the living cells of its host and then feeds on the dead material [n -S]\n",
  "NECROTROPHIC": "of or like a necrotroph, a parasitic organism that kills the living cells of its host and then feeds on the dead material [adj]\n",
  "NECROTROPHS": "NECROTROPH, a parasitic organism that kills the living cells of its host and then feeds on the dead material [n]\n",
  "NECTAR": "a delicious drink [n -S]\n",
  "NECTAREAL": "of or like nectar, also NECTAREAN, NECTAREOUS, NECTAROUS [adj]\n",
  "NECTAREAN": "of or like nectar, also NECTAREAL, NECTAREOUS, NECTAROUS [adj]\n",
  "NECTARED": "filled with nectar [adj]\n",
  "NECTAREOUS": "of or like nectar, also NECTAREAL, NECTAREAN, NECTAROUS [adj]\n",
  "NECTAREOUSNESS": "NECTAREOUS, of or like nectar, also NECTAREAL, NECTAREAN, NECTAROUS [n]\n",
  "NECTARIAL": "of or pertaining to the nectary of a plant [adj]\n",
  "NECTARIED": "having a nectary [adj]\n",
  "NECTARIES": "NECTARY, a gland in a flower which produces sugary fluid (nectar) to attract insects [n]\n",
  "NECTARIFEROUS": "producing nectar [adj]\n",
  "NECTARINE": "a fruit resembling a peach [n -S]\n",
  "NECTARINES": "NECTARINE, a fruit resembling a peach [n]\n",
  "NECTARIVOROUS": "eating nectar [adj]\n",
  "NECTAROUS": "of or like nectar, also NECTAREAL, NECTAREAN, NECTAREOUS [adj]\n",
  "NECTARS": "NECTAR, a delicious drink [n]\n",
  "NECTARY": "a gland in a flower which produces sugary fluid (nectar) to attract insects [n NECTARIES]\n",
  "NECTOCALYCES": "NECTOCALYX, the swimming bell or umbrella of a jellyfish of medusa [n]\n",
  "NECTOCALYX": "the swimming bell or umbrella of a jellyfish of medusa [n NECTOCALYCES]\n",
  "NED": "a young hooligan [n -S]\n",
  "NEDDIER": "NEDDY, like a ned, a hooligan [adj]\n",
  "NEDDIES": "NEDDY, a pet name for a donkey [n]\n",
  "NEDDIEST": "NEDDY, like a ned, a hooligan [adj]\n",
  "NEDDISH": "like a ned [adj]\n",
  "NEDDY": "like a ned, a hooligan [adj NEDDIER, NEDDIEST] / a pet name for a donkey [n NEDDIES]\n",
  "NEDETTE": "a female ned, hooligan [n -S]\n",
  "NEDETTES": "NEDETTE, a female ned, hooligan [n]\n",
  "NEDS": "NED, a young hooligan [n]\n",
  "NEE": "of a woman, born with the name of [adj]\n",
  "NEED": "to have an urgent or essential use for [v -ED, -ING, -S]\n",
  "NEEDCESSITIES": "NEEDCESSITY, (dialect) necessity [n]\n",
  "NEEDCESSITY": "(dialect) necessity [n NEEDCESSITIES]\n",
  "NEEDED": "NEED, to have an urgent or essential use for [v]\n",
  "NEEDER": "one who needs [n -S]\n",
  "NEEDERS": "NEEDER, one who needs [n]\n",
  "NEEDFIRE": "fire produced by friction, to which a certain virtue is superstitiously ascribed [n -S]\n",
  "NEEDFIRES": "NEEDFIRE, fire produced by friction, to which a certain virtue is superstitiously ascribed [n]\n",
  "NEEDFUL": "necessary [adj NEEDFULLY] / something that is needful [n -S]\n",
  "NEEDFULLY": "NEEDFUL, necessary [adv]\n",
  "NEEDFULNESS": "the state of being needful [n -ES]\n",
  "NEEDFULNESSES": "NEEDFULNESS, the state of being needful [n]\n",
  "NEEDFULS": "NEEDFUL, something that is needful [n]\n",
  "NEEDIER": "NEEDY, in a state of poverty [adj]\n",
  "NEEDIEST": "NEEDY, in a state of poverty [adj]\n",
  "NEEDILY": "NEEDY, in a state of poverty [adv]\n",
  "NEEDINESS": "the state of being needy [n -ES]\n",
  "NEEDINESSES": "NEEDINESS, the state of being needy [n]\n",
  "NEEDING": "NEED, to have an urgent or essential use for [v]\n",
  "NEEDLE": "to sew with a slender, pointed instrument [v NEEDLED, NEEDLING, NEEDLES]\n",
  "NEEDLECORD": "thinly ribbed cotton [n -S]\n",
  "NEEDLECORDS": "NEEDLECORD, thinly ribbed cotton [n]\n",
  "NEEDLECRAFT": "the art of sewing [n -S]\n",
  "NEEDLECRAFTS": "NEEDLECRAFT, the art of sewing [n]\n",
  "NEEDLED": "NEEDLE, to sew with a slender, pointed instrument [v]\n",
  "NEEDLEFISH": "the European great pipefish [n -ES]\n",
  "NEEDLEFISHES": "NEEDLEFISH, the European great pipefish [n]\n",
  "NEEDLEFUL": "as much thread as is used in a needle at one time [n -S]\n",
  "NEEDLEFULS": "NEEDLEFUL, as much thread as is used in a needle at one time [n]\n",
  "NEEDLELESS": "without a needle [adj]\n",
  "NEEDLELIKE": "like a needle [adj]\n",
  "NEEDLEPOINT": "to do a kind of embroidery [v -ED, -ING, -S]\n",
  "NEEDLEPOINTED": "NEEDLEPOINT, to do a kind of embroidery [v]\n",
  "NEEDLEPOINTING": "NEEDLEPOINT, to do a kind of embroidery [v]\n",
  "NEEDLEPOINTS": "NEEDLEPOINT, to do a kind of embroidery [v]\n",
  "NEEDLER": "a needle-maker [n -S]\n",
  "NEEDLERS": "NEEDLER, a needle-maker [n]\n",
  "NEEDLES": "NEEDLE, to sew with a slender, pointed instrument [v]\n",
  "NEEDLESS": "not necessary [adj NEEDLESSLY]\n",
  "NEEDLESSLY": "NEEDLESS, not necessary [adv]\n",
  "NEEDLESSNESS": "the state of being needless [n -ES]\n",
  "NEEDLESSNESSES": "NEEDLESSNESS, the state of being needless [n]\n",
  "NEEDLESTICK": "an accidental puncture of the skin with an unsterilized instrument (such as a syringe) [n -S]\n",
  "NEEDLESTICKS": "NEEDLESTICK, an accidental puncture of the skin with an unsterilized instrument (such as a syringe) [n]\n",
  "NEEDLEWOMAN": "a woman who does needlework [n NEEDLEWOMEN]\n",
  "NEEDLEWOMEN": "NEEDLEWOMAN, a woman who does needlework [n]\n",
  "NEEDLEWORK": "work executed with a needle [n -S]\n",
  "NEEDLEWORKER": "one who practises needlework [n -S]\n",
  "NEEDLEWORKERS": "NEEDLEWORKER, one who practises needlework [n]\n",
  "NEEDLEWORKS": "NEEDLEWORK, work executed with a needle [n]\n",
  "NEEDLIER": "NEEDLY, like needles [adj]\n",
  "NEEDLIEST": "NEEDLY, like needles [adj]\n",
  "NEEDLING": "the act of pricking with a needle [n -S]\n",
  "NEEDLINGS": "NEEDLING, the act of pricking with a needle [n]\n",
  "NEEDLY": "like needles [adj NEEDLIER, NEEDLIEST]\n",
  "NEEDMENT": "(Spenser) something needed [n -S]\n",
  "NEEDMENTS": "NEEDMENT, (Spenser) something needed [n]\n",
  "NEEDS": "NEED, to have an urgent or essential use for [v]\n",
  "NEEDY": "in a state of poverty [adj NEEDIER, NEEDIEST, NEEDILY]\n",
  "NEELD": "a needle, also NEELE [n -S]\n",
  "NEELDS": "NEELD, a needle, also NEELE [n]\n",
  "NEELE": "(obsolete) a needle, also NEELD [n -S]\n",
  "NEELES": "NEELE, (obsolete) a needle, also NEELD [n]\n",
  "NEEM": "(Hindi) an East Indian tree, also NEEMB, NIMB [n -S]\n",
  "NEEMB": "(Hindi) an East Indian tree, also NEEM, NIMB [n -S]\n",
  "NEEMBS": "NEEMB, (Hindi) an East Indian tree, also NEEM, NIMB [n]\n",
  "NEEMS": "NEEM, (Hindi) an East Indian tree, also NEEMB, NIMB [n]\n",
  "NEEP": "(Scots) a turnip [n -S]\n",
  "NEEPS": "NEEP, (Scots) a turnip [n]\n",
  "NEESBERRIES": "NEESBERRY, an edible fruit, aka sapodilla, also NASEBERRY, NISBERRY [n]\n",
  "NEESBERRY": "an edible fruit, aka sapodilla, also NASEBERRY, NISBERRY [n NEESBERRIES]\n",
  "NEESE": "(Scots) to sneeze, also NEEZE [v NEESED, NEESING, NEESES]\n",
  "NEESED": "NEESE, (Scots) to sneeze, also NEEZE [v]\n",
  "NEESES": "NEESE, (Scots) to sneeze, also NEEZE [v]\n",
  "NEESING": "NEESE, (Scots) to sneeze, also NEEZE [v]\n",
  "NEEZE": "(Scots) to sneeze, also NEESE [v NEEZED, NEEZING, NEEZES]\n",
  "NEEZED": "NEEZE, (Scots) to sneeze, also NEESE [v]\n",
  "NEEZES": "NEEZE, (Scots) to sneeze, also NEESE [v]\n",
  "NEEZING": "NEEZE, (Scots) to sneeze, also NEESE [v]\n",
  "NEF": "an elaborate table decoration in the shape of a ship for holding such things as table napkins and condiments [n -S]\n",
  "NEFANDOUS": "unspeakable, unmentionable [adj]\n",
  "NEFARIOUS": "evil, wicked [adj NEFARIOUSLY]\n",
  "NEFARIOUSLY": "NEFARIOUS, evil, wicked [adv]\n",
  "NEFARIOUSNESS": "NEFARIOUS, evil, wicked [n]\n",
  "NEFARIOUSNESSES": "NEFARIOUSNESS, NEFARIOUS, evil, wicked [n]\n",
  "NEFAST": "(Latin) abominable [adj]\n",
  "NEFS": "NEF, an elaborate table decoration in the shape of a ship for holding such things as table napkins and condiments [n]\n",
  "NEG": "a photographic negative [n -S]\n",
  "NEGATE": "to nullify [v NEGATED, NEGATING, NEGATES]\n",
  "NEGATED": "NEGATE, to nullify [v]\n",
  "NEGATER": "one that negates, also NEGATOR [n -S]\n",
  "NEGATERS": "NEGATER, one that negates, also NEGATOR [n]\n",
  "NEGATES": "NEGATE, to nullify [v]\n",
  "NEGATING": "NEGATE, to nullify [v]\n",
  "NEGATION": "the act of negating [n -S]\n",
  "NEGATIONAL": "relating to negation [adj]\n",
  "NEGATIONIST": "someone who merely denies, without offering any positive assertion [n -S]\n",
  "NEGATIONISTS": "NEGATIONIST, someone who merely denies, without offering any positive assertion [n]\n",
  "NEGATIONS": "NEGATION, the act of negating [n]\n",
  "NEGATIVE": "not positive [adj NEGATIVELY] / to disprove, make ineffective [v NEGATIVED, NEGATIVING, NEGATIVES]\n",
  "NEGATIVED": "NEGATIVE, to disprove, make ineffective [v]\n",
  "NEGATIVELY": "NEGATIVE, not positive [adv]\n",
  "NEGATIVENESS": "the state of being negative [n -ES]\n",
  "NEGATIVENESSES": "NEGATIVENESS, the state of being negative [n]\n",
  "NEGATIVES": "NEGATIVE, to disprove, make ineffective [v]\n",
  "NEGATIVING": "NEGATIVE, to disprove, make ineffective [v]\n",
  "NEGATIVISM": "a tendency to deny and criticise, without offering positive suggestions [n -S]\n",
  "NEGATIVISMS": "NEGATIVISM, a tendency to deny and criticise, without offering positive suggestions [n]\n",
  "NEGATIVIST": "one who practises negativism, a tendency to deny and criticise, without offering positive suggestions [n -S]\n",
  "NEGATIVISTIC": "relating to negativism [adj]\n",
  "NEGATIVISTS": "NEGATIVIST, one who practises negativism, a tendency to deny and criticise, without offering positive suggestions [n]\n",
  "NEGATIVITIES": "NEGATIVITY, the state of being negative [n]\n",
  "NEGATIVITY": "the state of being negative [n NEGATIVITIES]\n",
  "NEGATON": "a hypothetical atomic particle with mass equal to that of a proton, but with a negative charge equal to that of an electron, also NEGATRON [n -S]\n",
  "NEGATONS": "NEGATON, a hypothetical atomic particle with mass equal to that of a proton, but with a negative charge equal to that of an electron, also NEGATRON [n]\n",
  "NEGATOR": "one that negates, also NEGATER [n -S]\n",
  "NEGATORS": "NEGATOR, one that negates, also NEGATER [n]\n",
  "NEGATORY": "expressing denial [adj]\n",
  "NEGATRON": "a hypothetical atomic particle with mass equal to that of a proton, but with a negative charge equal to that of an electron, also NEGATON [n -S]\n",
  "NEGATRONS": "NEGATRON, a hypothetical atomic particle with mass equal to that of a proton, but with a negative charge equal to that of an electron, also NEGATON [n]\n",
  "NEGLECT": "to treat carelessly [v -ED, -ING, -S]\n",
  "NEGLECTABLE": "that can be neglected [adj]\n",
  "NEGLECTED": "NEGLECT, to treat carelessly [v]\n",
  "NEGLECTEDNESS": "the state of being neglected [n -ES]\n",
  "NEGLECTEDNESSES": "NEGLECTEDNESS, the state of being neglected [n]\n",
  "NEGLECTER": "one who neglects, also NEGLECTOR [n -S]\n",
  "NEGLECTERS": "NEGLECTER, one who neglects, also NEGLECTOR [n]\n",
  "NEGLECTFUL": "full of neglect [adj NEGLECTFULLY]\n",
  "NEGLECTFULLY": "NEGLECTFUL, full of neglect [adv]\n",
  "NEGLECTFULNESS": "NEGLECTFUL, full of neglect [n]\n",
  "NEGLECTING": "NEGLECT, to treat carelessly [v]\n",
  "NEGLECTINGLY": "NEGLECTING, NEGLECT, to treat carelessly [adv]\n",
  "NEGLECTION": "(Shakespeare) negligence [n -S]\n",
  "NEGLECTIONS": "NEGLECTION, (Shakespeare) negligence [n]\n",
  "NEGLECTIVE": "neglectful [adj]\n",
  "NEGLECTOR": "one who neglects, also NEGLECTER [n -S]\n",
  "NEGLECTORS": "NEGLECTOR, one who neglects, also NEGLECTER [n]\n",
  "NEGLECTS": "NEGLECT, to treat carelessly [v]\n",
  "NEGLIGE": "(French) a woman's loose decorative dressing-gown of flimsy material, also NEGLIGEE [n -S]\n",
  "NEGLIGEABLE": "that may neglected or left out of consideration, also NEGLIGIBLE [adj]\n",
  "NEGLIGEE": "(French) a woman's loose decorative dressing-gown of flimsy material, also NEGLIGE [n -S]\n",
  "NEGLIGEES": "NEGLIGEE, (French) a woman's loose decorative dressing-gown of flimsy material, also NEGLIGE [n]\n",
  "NEGLIGENCE": "the state of being negligent [n -S]\n",
  "NEGLIGENCES": "NEGLIGENCE, the state of being negligent [n]\n",
  "NEGLIGENT": "careless [adj NEGLIGENTLY]\n",
  "NEGLIGENTLY": "NEGLIGENT, careless [adv]\n",
  "NEGLIGES": "NEGLIGE, (French) a woman's loose decorative dressing-gown of flimsy material, also NEGLIGEE [n]\n",
  "NEGLIGIBILITIES": "NEGLIGIBILITY, the state of being negligible [n]\n",
  "NEGLIGIBILITY": "the state of being negligible [n NEGLIGIBILITIES]\n",
  "NEGLIGIBLE": "that may neglected or left out of consideration, also NEGLIGEABLE [adj NEGLIGIBLY]\n",
  "NEGLIGIBLENESS": "NEGLIGIBLE, that may neglected or left out of consideration, also NEGLIGEABLE [n]\n",
  "NEGLIGIBLY": "NEGLIGIBLE, that may neglected or left out of consideration, also NEGLIGEABLE [adv]\n",
  "NEGOCIANT": "(French) a merchant esp. a wine merchant [n -S]\n",
  "NEGOCIANTS": "NEGOCIANT, (French) a merchant esp. a wine merchant [n]\n",
  "NEGOTIABILITIES": "NEGOTIABILITY, the state of being negotiable [n]\n",
  "NEGOTIABILITY": "the state of being negotiable [n NEGOTIABILITIES]\n",
  "NEGOTIABLE": "capable of being negotiated [adj]\n",
  "NEGOTIANT": "a person, organization or state, etc. involved in negotiations [n -S]\n",
  "NEGOTIANTS": "NEGOTIANT, a person, organization or state, etc. involved in negotiations [n]\n",
  "NEGOTIATE": "to confer for the purpose of mutual arrangement [v NEGOTIATED, NEGOTIATING, NEGOTIATES]\n",
  "NEGOTIATED": "NEGOTIATE, to confer for the purpose of mutual arrangement [v]\n",
  "NEGOTIATES": "NEGOTIATE, to confer for the purpose of mutual arrangement [v]\n",
  "NEGOTIATING": "NEGOTIATE, to confer for the purpose of mutual arrangement [v]\n",
  "NEGOTIATION": "the act of negotiating [n -S]\n",
  "NEGOTIATIONS": "NEGOTIATION, the act of negotiating [n]\n",
  "NEGOTIATOR": "one who negotiates [n -S]\n",
  "NEGOTIATORS": "NEGOTIATOR, one who negotiates [n]\n",
  "NEGOTIATORY": "relating to negotiation [adj]\n",
  "NEGOTIATRESS": "(archaic) a female negotiator, also NEGOTIATRIX [n -ES]\n",
  "NEGOTIATRESSES": "NEGOTIATRESS, (archaic) a female negotiator, also NEGOTIATRIX [n]\n",
  "NEGOTIATRICES": "NEGOTIATRIX, (archaic) a female negotiator, also NEGOTIATRESS [n]\n",
  "NEGOTIATRIX": "(archaic) a female negotiator, also NEGOTIATRESS [n NEGOTIATRIXES or NEGOTIATRICES]\n",
  "NEGOTIATRIXES": "NEGOTIATRIX, (archaic) a female negotiator, also NEGOTIATRESS [n]\n",
  "NEGRESS": "a female negro [n -ES]\n",
  "NEGRESSES": "NEGRESS, a female negro [n]\n",
  "NEGRITUDE": "(French) the essential quality of the Negro genius, also NIGRITUDE [n -S]\n",
  "NEGRITUDES": "NEGRITUDE, (French) the essential quality of the Negro genius, also NIGRITUDE [n]\n",
  "NEGRO": "a member of any of the dark-skinned peoples of Africa or a person racially descended from one of them [n -ES]\n",
  "NEGROES": "NEGRO, a member of any of the dark-skinned peoples of Africa or a person racially descended from one of them [n]\n",
  "NEGROHEAD": "tobacco soaked in molasses and pressed into cake [n -S]\n",
  "NEGROHEADS": "NEGROHEAD, tobacco soaked in molasses and pressed into cake [n]\n",
  "NEGROID": "typical of black or African peoples, also NEGROIDAL [adj] / a negroid person [n -S]\n",
  "NEGROIDAL": "typical of black or African peoples, also NEGROID [adj]\n",
  "NEGROIDS": "NEGROID, a negroid person [n]\n",
  "NEGROISM": "devotion to the black civil rights movement [n -S]\n",
  "NEGROISMS": "NEGROISM, devotion to the black civil rights movement [n]\n",
  "NEGRONI": "(Italian) an alcoholic beverage, also NEGUS [n -S]\n",
  "NEGRONIS": "NEGRONI, (Italian) an alcoholic beverage, also NEGUS [n]\n",
  "NEGROPHIL": "a person who has sympathy for the plight of Black people, also NEGROPHILE [n -S]\n",
  "NEGROPHILE": "a person who has sympathy for the plight of Black people, also NEGROPHIL [n -S]\n",
  "NEGROPHILES": "NEGROPHILE, a person who has sympathy for the plight of Black people, also NEGROPHIL [n]\n",
  "NEGROPHILISM": "sympathy for the plight of black people [n -S]\n",
  "NEGROPHILISMS": "NEGROPHILISM, sympathy for the plight of black people [n]\n",
  "NEGROPHILIST": "a supporter of the negro cause [n -S]\n",
  "NEGROPHILISTS": "NEGROPHILIST, a supporter of the negro cause [n]\n",
  "NEGROPHILS": "NEGROPHIL, a person who has sympathy for the plight of Black people, also NEGROPHILE [n]\n",
  "NEGROPHOBE": "one with an irrational fear of negroes [n -S]\n",
  "NEGROPHOBES": "NEGROPHOBE, one with an irrational fear of negroes [n]\n",
  "NEGROPHOBIA": "fear of blacks [n -S]\n",
  "NEGROPHOBIAS": "NEGROPHOBIA, fear of blacks [n]\n",
  "NEGS": "NEG, a photographic negative [n]\n",
  "NEGUS": "an alcoholic beverage, also NEGRONI [n -ES]\n",
  "NEGUSES": "NEGUS, an alcoholic beverage, also NEGRONI [n]\n",
  "NEIF": "(archaic) the fist, also NEAFE, NEAFFE, NEIVE, NIEF, NIEVE [n -S]\n",
  "NEIFS": "NEIF, (archaic) the fist, also NEAFE, NEAFFE, NEIVE, NIEF, NIEVE [n]\n",
  "NEIGH": "to utter the cry of a horse [v -ED, -ING, -S]\n",
  "NEIGHBOR": "to live close by, border on, also NEIGHBOUR [v -ED, -ING, -S]\n",
  "NEIGHBORED": "NEIGHBOR, to live close by, border on, also NEIGHBOUR [v]\n",
  "NEIGHBORHOOD": "(US) neighbourhood [n -S]\n",
  "NEIGHBORHOODS": "NEIGHBORHOOD, (US) neighbourhood [n]\n",
  "NEIGHBORING": "NEIGHBOR, to live close by, border on, also NEIGHBOUR [v]\n",
  "NEIGHBORLESS": "without neighbors [adj]\n",
  "NEIGHBORLIER": "NEIGHBORLY, like a neighbor, also NEIGHBOURLY [adj]\n",
  "NEIGHBORLIEST": "NEIGHBORLY, like a neighbor, also NEIGHBOURLY [adj]\n",
  "NEIGHBORLINESS": "the state of being neighborly [n]\n",
  "NEIGHBORLY": "like a neighbor, also NEIGHBOURLY [adj NEIGHBORLIER, NEIGHBORLIEST]\n",
  "NEIGHBORS": "NEIGHBOR, to live close by, border on, also NEIGHBOUR [v]\n",
  "NEIGHBOUR": "to live close by, border on, also NEIGHBOR [v -ED, -ING, -S]\n",
  "NEIGHBOURED": "NEIGHBOUR, to live close by, border on, also NEIGHBOR [v]\n",
  "NEIGHBOURHOOD": "a district, locality, esp. with reference to its inhabitants as a community, also NEIGHBORHOOD [n -S]\n",
  "NEIGHBOURHOODS": "NEIGHBOURHOOD, a district, locality, esp. with reference to its inhabitants as a community, also NEIGHBORHOOD [n]\n",
  "NEIGHBOURING": "NEIGHBOUR, to live close by, border on, also NEIGHBOR [v]\n",
  "NEIGHBOURLESS": "without a neighbour, also NEIGHBORLESS [adj]\n",
  "NEIGHBOURLIER": "NEIGHBOURLY, like a neighbour, also NEIGHBORLY [adj]\n",
  "NEIGHBOURLIEST": "NEIGHBOURLY, like a neighbour, also NEIGHBORLY [adj]\n",
  "NEIGHBOURLINESS": "the state of being neighbourly, also NEIGHBORLINESS [n]\n",
  "NEIGHBOURLY": "like a neighbour, also NEIGHBORLY [adj NEIGHBOURLIER, NEIGHBOURLIEST]\n",
  "NEIGHBOURS": "NEIGHBOUR, to live close by, border on, also NEIGHBOR [v]\n",
  "NEIGHED": "NEIGH, to utter the cry of a horse [v]\n",
  "NEIGHING": "the sound a horse makes [n -S]\n",
  "NEIGHINGS": "NEIGHING, the sound a horse makes [n]\n",
  "NEIGHS": "NEIGH, to utter the cry of a horse [v]\n",
  "NEINEI": "(Maori) a New Zealand shrub [n -S]\n",
  "NEINEIS": "NEINEI, (Maori) a New Zealand shrub [n]\n",
  "NEIST": "(Scots) next, nearest [adj]\n",
  "NEITHER": "not one or the other [adj]\n",
  "NEIVE": "(archaic) the fist, also NEAFE, NEAFFE, NEIF, NIEF, NIEVE [n -S]\n",
  "NEIVES": "NEIVE, (archaic) the fist, also NEAFE, NEAFFE, NEIF, NIEF, NIEVE [n]\n",
  "NEK": "(South African) a col, a pass in a mountain range [n -S]\n",
  "NEKS": "NEK, (South African) a col, a pass in a mountain range [n]\n",
  "NEKTON": "(Greek) the totality of swimming organisms in a body of water [n -S]\n",
  "NEKTONIC": "pertaining to nekton, the totality of swimming organisms in a body of water [adj]\n",
  "NEKTONS": "NEKTON, (Greek) the totality of swimming organisms in a body of water [n]\n",
  "NELIES": "a winter pear, also NELIS [n NELIES]\n",
  "NELIS": "a winter pear, also NELIES [n NELIS]\n",
  "NELLIE": "an effeminate male, also NELLY [n -S]\n",
  "NELLIES": "NELLY, an effeminate male, also NELLIE [n]\n",
  "NELLY": "an effeminate male, also NELLIE [n NELLIES]\n",
  "NELSON": "a wrestling hold [n -S]\n",
  "NELSONS": "NELSON, a wrestling hold [n]\n",
  "NELUMBIUM": "(Tamil) a plant of the Nelumbium genus of waterlilies that includes the sacred lotus, also NELUMBO [n -S]\n",
  "NELUMBIUMS": "NELUMBIUM, (Tamil) a plant of the Nelumbium genus of waterlilies that includes the sacred lotus, also NELUMBO [n]\n",
  "NELUMBO": "(Tamil) a plant of the Nelumbium genus of waterlilies that includes the sacred lotus, also NELUMBIUM [n -S]\n",
  "NELUMBOS": "NELUMBO, (Tamil) a plant of the Nelumbium genus of waterlilies that includes the sacred lotus, also NELUMBIUM [n]\n",
  "NEMA": "(short for) a nematode, a parasitic worm with an unsegmented, cylindrical body [n -S]\n",
  "NEMAS": "NEMA, (short for) a nematode, a parasitic worm with an unsegmented, cylindrical body [n]\n",
  "NEMATHELMINTH": "a member of the Nemathelminthes, a phylum of worms including nematodes [n -S]\n",
  "NEMATHELMINTHIC": "of or like a nemathelminth, a member of the Nemathelminthes, a phylum of worms including nematodes [adj]\n",
  "NEMATHELMINTHS": "NEMATHELMINTH, a member of the Nemathelminthes, a phylum of worms including nematodes [n]\n",
  "NEMATIC": "a liquid crystal in a particular phase [n -S]\n",
  "NEMATICIDAL": "of or like a nematicide [adj]\n",
  "NEMATICIDE": "a substance used to kill nematodes, also NEMATOCIDE [n -S]\n",
  "NEMATICIDES": "NEMATICIDE, a substance used to kill nematodes, also NEMATOCIDE [n]\n",
  "NEMATICS": "NEMATIC, a liquid crystal in a particular phase [n]\n",
  "NEMATOBLAST": "a stinging thread cell containing a nematocyst, aka cnidoblast [n -S]\n",
  "NEMATOBLASTS": "NEMATOBLAST, a stinging thread cell containing a nematocyst, aka cnidoblast [n]\n",
  "NEMATOCIDAL": "relating to a nematocide, a substance used to kill nematodes [adj]\n",
  "NEMATOCIDE": "a substance used to kill nematodes, also NEMATICIDE [n -S]\n",
  "NEMATOCIDES": "NEMATOCIDE, a substance used to kill nematodes, also NEMATICIDE [n]\n",
  "NEMATOCYST": "an older name for a cnidoblast, a stinging cell in e.g. jellyfish [n -S]\n",
  "NEMATOCYSTIC": "of or like a nematocyst, a stinging cell in e.g. a jellyfish [adj]\n",
  "NEMATOCYSTS": "NEMATOCYST, an older name for a cnidoblast, a stinging cell in e.g. jellyfish [n]\n",
  "NEMATODE": "a parasitic worm with an unsegmented, cylindrical body [n -S]\n",
  "NEMATODES": "NEMATODE, a parasitic worm with an unsegmented, cylindrical body [n]\n",
  "NEMATODIRIASES": "NEMATODIRIASIS, a disease of young lambs caused by nematodirus larvae [n]\n",
  "NEMATODIRIASIS": "a disease of young lambs caused by nematodirus larvae [n NEMATODIRIASES]\n",
  "NEMATODIRUS": "any of a genus of parasitic nematode worms found in the intestines of mammals [n -ES]\n",
  "NEMATODIRUSES": "NEMATODIRUS, any of a genus of parasitic nematode worms found in the intestines of mammals [n]\n",
  "NEMATOID": "pertaining to worms parasitic on the intestines [adj]\n",
  "NEMATOLOGICAL": "relating to nematology [adj]\n",
  "NEMATOLOGIES": "NEMATOLOGY, the study of nematodes [n]\n",
  "NEMATOLOGIST": "a student of nematodes [n -S]\n",
  "NEMATOLOGISTS": "NEMATOLOGIST, a student of nematodes [n]\n",
  "NEMATOLOGY": "the study of nematodes [n NEMATOLOGIES]\n",
  "NEMATOPHORE": "a mouthless type of hydrozoan polyp [n -S]\n",
  "NEMATOPHORES": "NEMATOPHORE, a mouthless type of hydrozoan polyp [n]\n",
  "NEMERTEAN": "any of a phylum of wormlike animals, mostly marine, ciliated, often brightly coloured, also NEMERTIAN, NEMERTINE [n -S]\n",
  "NEMERTEANS": "NEMERTEAN, any of a phylum of wormlike animals, mostly marine, ciliated, often brightly coloured, also NEMERTIAN, NEMERTINE [n]\n",
  "NEMERTIAN": "any of a phylum of wormlike animals, mostly marine, ciliated, often brightly coloured, also NEMERTEAN, NEMERTINE [n -S]\n",
  "NEMERTIANS": "NEMERTIAN, any of a phylum of wormlike animals, mostly marine, ciliated, often brightly coloured, also NEMERTEAN, NEMERTINE [n]\n",
  "NEMERTINE": "any of a phylum of wormlike animals, mostly marine, ciliated, often brightly coloured, also NEMERTEAN, NEMERTIAN [n -S]\n",
  "NEMERTINES": "NEMERTINE, any of a phylum of wormlike animals, mostly marine, ciliated, often brightly coloured, also NEMERTEAN, NEMERTIAN [n]\n",
  "NEMESES": "NEMESIS, (Greek) retributive justice [n]\n",
  "NEMESIA": "(Greek) a South African flowering plant [n -S]\n",
  "NEMESIAS": "NEMESIA, (Greek) a South African flowering plant [n]\n",
  "NEMESIS": "(Greek) retributive justice [n NEMESES]\n",
  "NEMN": "(obsolete) to name [v NEMNED, NEMPT, NEMNING, NEMNS]\n",
  "NEMNED": "NEMN, (obsolete) to name [v]\n",
  "NEMNING": "NEMN, (obsolete) to name [v]\n",
  "NEMNS": "NEMN, (obsolete) to name [v]\n",
  "NEMOPHILA": "a plant of a North American genus of garden annuals [n -S]\n",
  "NEMOPHILAS": "NEMOPHILA, a plant of a North American genus of garden annuals [n]\n",
  "NEMORAL": "pertaining to or living in a grove or wood [adj]\n",
  "NEMOROUS": "wooded [adj]\n",
  "NEMPT": "NEMN, (obsolete) to name [v]\n",
  "NENE": "(Hawaiian) a kind of goose native to Hawaii [n -S]\n",
  "NENES": "NENE, (Hawaiian) a kind of goose native to Hawaii [n]\n",
  "NENNIGAI": "(Native Australian) a large edible marine fish, also NANNYGAI [n -S]\n",
  "NENNIGAIS": "NENNIGAI, (Native Australian) a large edible marine fish, also NANNYGAI [n]\n",
  "NENUPHAR": "a waterlily [n -S]\n",
  "NENUPHARS": "NENUPHAR, a waterlily [n]\n",
  "NEOANTHROPIC": "of, relating to, or resembling modern man [adj]\n",
  "NEOARSPHENAMINE": "a derivative of arsenic used in treating syphilis [n]\n",
  "NEOBLAST": "a cell important in regeneration of worms [n -S]\n",
  "NEOBLASTS": "NEOBLAST, a cell important in regeneration of worms [n]\n",
  "NEOCAPITALISM": "a politico-economic theory combining elements of capitalism and socialism [n -S]\n",
  "NEOCAPITALISMS": "NEOCAPITALISM, a politico-economic theory combining elements of capitalism and socialism [n]\n",
  "NEOCAPITALIST": "a person who advocates neocapitalism [n -S]\n",
  "NEOCAPITALISTS": "NEOCAPITALIST, a person who advocates neocapitalism [n]\n",
  "NEOCLASSIC": "belonging to a revival of the classical style [adj]\n",
  "NEOCLASSICAL": "relating to neoclassicism, a revival of the classical style in art and architecture [adj]\n",
  "NEOCLASSICISM": "a revival of the classical style in art and architecture [n -S]\n",
  "NEOCLASSICISMS": "NEOCLASSICISM, a revival of the classical style in art and architecture [n]\n",
  "NEOCLASSICIST": "an exponent of neoclassicism [n -S]\n",
  "NEOCLASSICISTS": "NEOCLASSICIST, an exponent of neoclassicism [n]\n",
  "NEOCOLONIAL": "of or like neocolonialism [adj]\n",
  "NEOCOLONIALISM": "the quasi-colonialism practised by strong powers in dominating weaker, though politically independent, states by means of economic pressure [n -S]\n",
  "NEOCOLONIALISMS": "NEOCOLONIALISM, the quasi-colonialism practised by strong powers in dominating weaker, though politically independent, states by means of economic pressure [n]\n",
  "NEOCOLONIALIST": "an upholder of neocolonialism [n -S]\n",
  "NEOCOLONIALISTS": "NEOCOLONIALIST, an upholder of neocolonialism [n]\n",
  "NEOCON": "(short for) a neoconservative [n -S]\n",
  "NEOCONS": "NEOCON, (short for) a neoconservative [n]\n",
  "NEOCONSERVATISM": "the state of being a neoconservative, a former liberal espousing political conservatism [n]\n",
  "NEOCONSERVATIVE": "a former liberal espousing political conservatism [n]\n",
  "NEOCORTEX": "the back of the cortex [n NEOCORTEXES or NEOCORTICES]\n",
  "NEOCORTEXES": "NEOCORTEX, the back of the cortex [n]\n",
  "NEOCORTICAL": "relating to the neocortex [adj]\n",
  "NEOCORTICES": "NEOCORTEX, the back of the cortex [n]\n",
  "NEODYMIUM": "a rare metallic chemical element of the lanthanide series [n -S]\n",
  "NEODYMIUMS": "NEODYMIUM, a rare metallic chemical element of the lanthanide series [n]\n",
  "NEOGENE": "relating to the Miocene or Pliocene epochs [adj]\n",
  "NEOGENESES": "NEOGENESIS, the regeneration of tissue [n]\n",
  "NEOGENESIS": "the regeneration of tissue [n NEOGENESES]\n",
  "NEOGENETIC": "relating to neogenesis, the regeneration of tissue [adj]\n",
  "NEOGOTHIC": "a style of architecture popular in Britain in the 18th and 19th centuries [n -S]\n",
  "NEOGOTHICS": "NEOGOTHIC, a style of architecture popular in Britain in the 18th and 19th centuries [n]\n",
  "NEOGRAMMARIAN": "a philologist of the nineteenth century German school that introduced scientific exactitude into the study of sound change [n -S]\n",
  "NEOGRAMMARIANS": "NEOGRAMMARIAN, a philologist of the nineteenth century German school that introduced scientific exactitude into the study of sound change [n]\n",
  "NEOLIBERAL": "a liberal who de-emphasizes traditional liberal values in order to make progress by more pragmatic means [n -S]\n",
  "NEOLIBERALISM": "the state of being a neoliberal, a liberal who de-emphasizes traditional liberal values in order to make progress by more pragmatic means [n -S]\n",
  "NEOLIBERALISMS": "NEOLIBERALISM, the state of being a neoliberal, a liberal who de-emphasizes traditional liberal values in order to make progress by more pragmatic means [n]\n",
  "NEOLIBERALS": "NEOLIBERAL, a liberal who de-emphasizes traditional liberal values in order to make progress by more pragmatic means [n]\n",
  "NEOLITH": "an ancient stone implement [n -S]\n",
  "NEOLITHIC": "the later, more advanced, Stone Age [n -S]\n",
  "NEOLITHICS": "NEOLITHIC, the later, more advanced, Stone Age [n]\n",
  "NEOLITHS": "NEOLITH, an ancient stone implement [n]\n",
  "NEOLOGIAN": "one who introduces new words or new senses of old words into a language, also NEOLOGIST [n -S]\n",
  "NEOLOGIANS": "NEOLOGIAN, one who introduces new words or new senses of old words into a language, also NEOLOGIST [n]\n",
  "NEOLOGIC": "of or pertaining to neology; employing new words, also NEOLOGICAL [adj NEOLOGICALLY]\n",
  "NEOLOGICAL": "of or pertaining to neology; employing new words, also NEOLOGIC [adj NEOLOGICALLY]\n",
  "NEOLOGICALLY": "NEOLOGICAL, of or pertaining to neology; employing new words, also NEOLOGIC [adv]\n",
  "NEOLOGIES": "NEOLOGY, a new word, phrase or doctrine; a new use of an established word, also NEOLOGISM [n]\n",
  "NEOLOGISE": "to introduce or use new words or terms or new uses of old words, also NEOLOGIZE [v NEOLOGISED, NEOLOGISING, NEOLOGISES]\n",
  "NEOLOGISED": "NEOLOGISE, to introduce or use new words or terms or new uses of old words, also NEOLOGIZE [v]\n",
  "NEOLOGISES": "NEOLOGISE, to introduce or use new words or terms or new uses of old words, also NEOLOGIZE [v]\n",
  "NEOLOGISING": "NEOLOGISE, to introduce or use new words or terms or new uses of old words, also NEOLOGIZE [v]\n",
  "NEOLOGISM": "a new word, phrase or doctrine; a new use of an established word, also NEOLOGY [n -S]\n",
  "NEOLOGISMS": "NEOLOGISM, a new word, phrase or doctrine; a new use of an established word, also NEOLOGY [n]\n",
  "NEOLOGIST": "one who introduces new words or new senses of old words into a language, also NEOLOGIAN [n -S]\n",
  "NEOLOGISTIC": "relating to neologism, also NEOLOGISTICAL [adj NEOLOGISTICALLY]\n",
  "NEOLOGISTICAL": "relating to neologism, also NEOLOGISTIC [adj NEOLOGISTICALLY]\n",
  "NEOLOGISTICALLY": "NEOLOGISTICAL, relating to neologism, also NEOLOGISTIC [adv]\n",
  "NEOLOGISTS": "NEOLOGIST, one who introduces new words or new senses of old words into a language, also NEOLOGIAN [n]\n",
  "NEOLOGIZE": "to introduce or use new words or terms or new uses of old words, also NEOLOGISE [v NEOLOGIZED, NEOLOGIZING, NEOLOGIZES]\n",
  "NEOLOGIZED": "NEOLOGIZE, to introduce or use new words or terms or new uses of old words, also NEOLOGISE [v]\n",
  "NEOLOGIZES": "NEOLOGIZE, to introduce or use new words or terms or new uses of old words, also NEOLOGISE [v]\n",
  "NEOLOGIZING": "NEOLOGIZE, to introduce or use new words or terms or new uses of old words, also NEOLOGISE [v]\n",
  "NEOLOGY": "a new word, phrase or doctrine; a new use of an established word, also NEOLOGISM [n NEOLOGIES]\n",
  "NEOMORPH": "a structure, part, or organ developed independently, that is, not derived from a similar structure, part, or organ, in a preexisting form [n -S]\n",
  "NEOMORPHS": "NEOMORPH, a structure, part, or organ developed independently, that is, not derived from a similar structure, part, or organ, in a preexisting form [n]\n",
  "NEOMYCIN": "an antibiotic used to treat skin and eye infections [n -S]\n",
  "NEOMYCINS": "NEOMYCIN, an antibiotic used to treat skin and eye infections [n]\n",
  "NEON": "a gaseous element [n -S]\n",
  "NEONATAL": "pertaining to a newborn child [adj NEONATALLY]\n",
  "NEONATALLY": "NEONATAL, pertaining to a newborn child [adv]\n",
  "NEONATE": "a newborn child [n -S]\n",
  "NEONATES": "NEONATE, a newborn child [n]\n",
  "NEONATICIDE": "the killing of the newborn [n -S]\n",
  "NEONATICIDES": "NEONATICIDE, the killing of the newborn [n]\n",
  "NEONATOLOGIES": "NEONATOLOGY, the study of newborn babies [n]\n",
  "NEONATOLOGIST": "a specialist in neonatology [n -S]\n",
  "NEONATOLOGISTS": "NEONATOLOGIST, a specialist in neonatology [n]\n",
  "NEONATOLOGY": "the study of newborn babies [n NEONATOLOGIES]\n",
  "NEONED": "having a gaseous element [adj]\n",
  "NEONOMIAN": "one who advocates adherence to new laws; esp. one who holds or believes that the gospel is a new law [n -S]\n",
  "NEONOMIANISM": "the theory that the gospel abrogates earlier moral codes [n -S]\n",
  "NEONOMIANISMS": "NEONOMIANISM, the theory that the gospel abrogates earlier moral codes [n]\n",
  "NEONOMIANS": "NEONOMIAN, one who advocates adherence to new laws; esp. one who holds or believes that the gospel is a new law [n]\n",
  "NEONS": "NEON, a gaseous element [n]\n",
  "NEOORTHODOX": "of or relating to a 20th century movement in Protestant theology characterized by a reaction against liberalism and emphasis on various scripturally based Reformation doctrines [adj]\n",
  "NEOORTHODOXIES": "NEOORTHODOXY, reactionaryism [n]\n",
  "NEOORTHODOXY": "reactionaryism [n NEOORTHODOXIES]\n",
  "NEOPAGAN": "a modern believer in paganism [n -S]\n",
  "NEOPAGANISE": "to make neopagan, also NEOPAGANIZE [v NEOPAGANISED, NEOPAGANISING, NEOPAGANISES]\n",
  "NEOPAGANISED": "NEOPAGANISE, to make neopagan, also NEOPAGANIZE [v]\n",
  "NEOPAGANISES": "NEOPAGANISE, to make neopagan, also NEOPAGANIZE [v]\n",
  "NEOPAGANISING": "NEOPAGANISE, to make neopagan, also NEOPAGANIZE [v]\n",
  "NEOPAGANISM": "a revival of paganism, or its spirit [n -S]\n",
  "NEOPAGANISMS": "NEOPAGANISM, a revival of paganism, or its spirit [n]\n",
  "NEOPAGANIZE": "to make neopagan, also NEOPAGANISE [v NEOPAGANIZED, NEOPAGANIZING, NEOPAGANIZES]\n",
  "NEOPAGANIZED": "NEOPAGANIZE, to make neopagan, also NEOPAGANISE [v]\n",
  "NEOPAGANIZES": "NEOPAGANIZE, to make neopagan, also NEOPAGANISE [v]\n",
  "NEOPAGANIZING": "NEOPAGANIZE, to make neopagan, also NEOPAGANISE [v]\n",
  "NEOPAGANS": "NEOPAGAN, a modern believer in paganism [n]\n",
  "NEOPHILE": "one who loves novelty [n -S]\n",
  "NEOPHILES": "NEOPHILE, one who loves novelty [n]\n",
  "NEOPHILIA": "an obsessive love of novelty [n -S]\n",
  "NEOPHILIAC": "one suffering from neophilia, an obsessive love of novelty [n -S]\n",
  "NEOPHILIACS": "NEOPHILIAC, one suffering from neophilia, an obsessive love of novelty [n]\n",
  "NEOPHILIAS": "NEOPHILIA, an obsessive love of novelty [n]\n",
  "NEOPHOBE": "one who hates novelty [n -S]\n",
  "NEOPHOBES": "NEOPHOBE, one who hates novelty [n]\n",
  "NEOPHOBIA": "fear of novelty [n -S]\n",
  "NEOPHOBIAS": "NEOPHOBIA, fear of novelty [n]\n",
  "NEOPHOBIC": "hating novelty [adj]\n",
  "NEOPHYTE": "a beginner, a novice, esp. a religious novice [n -S]\n",
  "NEOPHYTES": "NEOPHYTE, a beginner, a novice, esp. a religious novice [n]\n",
  "NEOPHYTIC": "of or like a neophyte, a person who is new to a subject [adj]\n",
  "NEOPILINA": "a mollusc of the genus Neopilina [n -S]\n",
  "NEOPILINAS": "NEOPILINA, a mollusc of the genus Neopilina [n]\n",
  "NEOPLASIA": "the formation or presence of a morbid growth of tissue [n -S]\n",
  "NEOPLASIAS": "NEOPLASIA, the formation or presence of a morbid growth of tissue [n]\n",
  "NEOPLASM": "a new formation or tissue, the product of morbid action [n -S]\n",
  "NEOPLASMS": "NEOPLASM, a new formation or tissue, the product of morbid action [n]\n",
  "NEOPLASTIC": "of or pertaining to neoplasty, or neoplasia [adj]\n",
  "NEOPLASTICISM": "a style of abstract painting in which geometrical patterns are formed of patches of flat colour enclosed by intersecting vertical and horizontal lines [n -S]\n",
  "NEOPLASTICISMS": "NEOPLASTICISM, a style of abstract painting in which geometrical patterns are formed of patches of flat colour enclosed by intersecting vertical and horizontal lines [n]\n",
  "NEOPLASTICIST": "an exponent of neoplasticism [n -S]\n",
  "NEOPLASTICISTS": "NEOPLASTICIST, an exponent of neoplasticism [n]\n",
  "NEOPLASTIES": "NEOPLASTY, the surgical formation of new tissues or repair of damaged tissues [n]\n",
  "NEOPLASTY": "the surgical formation of new tissues or repair of damaged tissues [n NEOPLASTIES]\n",
  "NEOPRENE": "(tradename) an oil-resisting and heat-resisting synthetic rubber [n -S]\n",
  "NEOPRENES": "NEOPRENE, (tradename) an oil-resisting and heat-resisting synthetic rubber [n]\n",
  "NEOREALISM": "a modern form of realism in the arts and literature [n -S]\n",
  "NEOREALISMS": "NEOREALISM, a modern form of realism in the arts and literature [n]\n",
  "NEOREALIST": "a practitioner of neorealism [n -S]\n",
  "NEOREALISTIC": "relating to neorealism [adj]\n",
  "NEOREALISTS": "NEOREALIST, a practitioner of neorealism [n]\n",
  "NEOSOUL": "a style of popular music combining traditional soul music with elements from other genres [n -S]\n",
  "NEOSOULS": "NEOSOUL, a style of popular music combining traditional soul music with elements from other genres [n]\n",
  "NEOSTIGMINE": "a synthetic compound used as a drug in treating myasthenia gravis [n -S]\n",
  "NEOSTIGMINES": "NEOSTIGMINE, a synthetic compound used as a drug in treating myasthenia gravis [n]\n",
  "NEOTEINIA": "prolonged retention of larval or immature characteristics or features in the adult form, also NEOTENY [n -S]\n",
  "NEOTEINIAS": "NEOTEINIA, prolonged retention of larval or immature characteristics or features in the adult form, also NEOTENY [n]\n",
  "NEOTENIC": "exhibiting neoteny, retention of infantile or juvenile characteristics into adulthood, also NEOTENOUS [adj]\n",
  "NEOTENIES": "NEOTENY, attainment of sexual maturity in the larval stage [n]\n",
  "NEOTENOUS": "exhibiting neoteny, retention of infantile or juvenile characteristics into adulthood, also NEOTENIC [adj]\n",
  "NEOTENY": "attainment of sexual maturity in the larval stage [n NEOTENIES]\n",
  "NEOTERIC": "recent in origin, modern, also NEOTERICAL [adj NEOTERICALLY] / a modern writer or philosopher [n -S]\n",
  "NEOTERICAL": "recent in origin, modern, also NEOTERIC [adj NEOTERICALLY] / something modern [n -S]\n",
  "NEOTERICALLY": "NEOTERICAL, recent in origin, modern, also NEOTERIC [adv]\n",
  "NEOTERICALS": "NEOTERICAL, something modern [n]\n",
  "NEOTERICS": "NEOTERIC, a modern writer or philosopher [n]\n",
  "NEOTERISE": "to innovate; to coin or introduce new words, also NEOTERIZE [v NEOTERISED, NEOTERISING, NEOTERISES]\n",
  "NEOTERISED": "NEOTERISE, to innovate; to coin or introduce new words, also NEOTERIZE [v]\n",
  "NEOTERISES": "NEOTERISE, to innovate; to coin or introduce new words, also NEOTERIZE [v]\n",
  "NEOTERISING": "NEOTERISE, to innovate; to coin or introduce new words, also NEOTERIZE [v]\n",
  "NEOTERISM": "the introduction of new things, esp. words [n -S]\n",
  "NEOTERISMS": "NEOTERISM, the introduction of new things, esp. words [n]\n",
  "NEOTERIST": "one who introduces new words or phrases [n -S]\n",
  "NEOTERISTS": "NEOTERIST, one who introduces new words or phrases [n]\n",
  "NEOTERIZE": "to innovate; to coin or introduce new words, also NEOTERISE [v NEOTERIZED, NEOTERIZING, NEOTERIZES]\n",
  "NEOTERIZED": "NEOTERIZE, to innovate; to coin or introduce new words, also NEOTERISE [v]\n",
  "NEOTERIZES": "NEOTERIZE, to innovate; to coin or introduce new words, also NEOTERISE [v]\n",
  "NEOTERIZING": "NEOTERIZE, to innovate; to coin or introduce new words, also NEOTERISE [v]\n",
  "NEOTOXIN": "any harmful substance in the environment causing illness or allergy [n -S]\n",
  "NEOTOXINS": "NEOTOXIN, any harmful substance in the environment causing illness or allergy [n]\n",
  "NEOTROPIC": "of tropical America [adj]\n",
  "NEOTROPICS": "the tropics of the New World, Central America [n]\n",
  "NEOTYPE": "a specimen selected to serve as the nomenclatural type as long as the original material is missing [n -S]\n",
  "NEOTYPES": "NEOTYPE, a specimen selected to serve as the nomenclatural type as long as the original material is missing [n]\n",
  "NEOVITALISM": "the theory or belief that complete causal explanation of vital phenomena cannot be reached without invoking some extra-material concept [n -S]\n",
  "NEOVITALISMS": "NEOVITALISM, the theory or belief that complete causal explanation of vital phenomena cannot be reached without invoking some extra-material concept [n]\n",
  "NEOVITALIST": "a supporter of neovitalism [n -S]\n",
  "NEOVITALISTS": "NEOVITALIST, a supporter of neovitalism [n]\n",
  "NEP": "(dialect) catmint, a plant attractive to cats [n -S]\n",
  "NEPENTHE": "(Greek) a drug used by the ancients to give relief from pain and sorrow; hence anything soothing and comforting [n -S]\n",
  "NEPENTHEAN": "relating to nepenthe, soothing, comforting [adj]\n",
  "NEPENTHES": "NEPENTHE, (Greek) a drug used by the ancients to give relief from pain and sorrow; hence anything soothing and comforting [n]\n",
  "NEPER": "a unit for expressing the ratio of two currents or voltages [n -S]\n",
  "NEPERS": "NEPER, a unit for expressing the ratio of two currents or voltages [n]\n",
  "NEPETA": "(Latin) any of various labiate plants of the genus Nepeta, aka catmint [n -S]\n",
  "NEPETAS": "NEPETA, (Latin) any of various labiate plants of the genus Nepeta, aka catmint [n]\n",
  "NEPHALISM": "total abstinence from alcoholic drinks [n -S]\n",
  "NEPHALISMS": "NEPHALISM, total abstinence from alcoholic drinks [n]\n",
  "NEPHALIST": "one who advocates or practices nephalism, total abstinence from alcoholic drinks [n -S]\n",
  "NEPHALISTS": "NEPHALIST, one who advocates or practices nephalism, total abstinence from alcoholic drinks [n]\n",
  "NEPHELINE": "a rock-forming mineral, silicate of sodium, potassium and aluminium, colourless, usually crystallizing in hexagonal prisms, also NEPHELITE [n -S]\n",
  "NEPHELINES": "NEPHELINE, a rock-forming mineral, silicate of sodium, potassium and aluminium, colourless, usually crystallizing in hexagonal prisms, also NEPHELITE [n]\n",
  "NEPHELINIC": "of or like nepheline, a mineral found in igneous rocks and used for ceramics and enamels [adj]\n",
  "NEPHELINITE": "a basalt-like rock compound of pyroxene and nepheline [n -S]\n",
  "NEPHELINITES": "NEPHELINITE, a basalt-like rock compound of pyroxene and nepheline [n]\n",
  "NEPHELINITIC": "relating to nephelinite [adj]\n",
  "NEPHELITE": "a rock-forming mineral, silicate of sodium, potassium and aluminium, colourless, usually crystallizing in hexagonal prisms, also NEPHELINE [n -S]\n",
  "NEPHELITES": "NEPHELITE, a rock-forming mineral, silicate of sodium, potassium and aluminium, colourless, usually crystallizing in hexagonal prisms, also NEPHELINE [n]\n",
  "NEPHELOMETER": "an instrument for measuring cloudiness [n -S]\n",
  "NEPHELOMETERS": "NEPHELOMETER, an instrument for measuring cloudiness [n]\n",
  "NEPHELOMETRIC": "relating to measurement by nephelometer, an instrument for measuring cloudiness [adj]\n",
  "NEPHELOMETRIES": "NEPHELOMETRY, the measurement of the cloudiness of liquids [n]\n",
  "NEPHELOMETRY": "the measurement of the cloudiness of liquids [n NEPHELOMETRIES]\n",
  "NEPHEW": "the son of one's brother or sister [n -S]\n",
  "NEPHEWS": "NEPHEW, the son of one's brother or sister [n]\n",
  "NEPHOGRAM": "a photograph of clouds [n -S]\n",
  "NEPHOGRAMS": "NEPHOGRAM, a photograph of clouds [n]\n",
  "NEPHOGRAPH": "an instrument for photographing clouds [n -S]\n",
  "NEPHOGRAPHS": "NEPHOGRAPH, an instrument for photographing clouds [n]\n",
  "NEPHOLOGIC": "relating to nephology, the study of clouds, also NEPHOLOGICAL [adj]\n",
  "NEPHOLOGICAL": "relating to nephology, the study of clouds, also NEPHOLOGIC [adj]\n",
  "NEPHOLOGIES": "NEPHOLOGY, the study of clouds [n]\n",
  "NEPHOLOGIST": "a practitioner of nephology, the study of clouds [n -S]\n",
  "NEPHOLOGISTS": "NEPHOLOGIST, a practitioner of nephology, the study of clouds [n]\n",
  "NEPHOLOGY": "the study of clouds [n NEPHOLOGIES]\n",
  "NEPHOSCOPE": "an instrument for observing direction and velocity of clouds [n -S]\n",
  "NEPHOSCOPES": "NEPHOSCOPE, an instrument for observing direction and velocity of clouds [n]\n",
  "NEPHRALGIA": "pain in the kidneys, also NEPHRALGY [n -S]\n",
  "NEPHRALGIAS": "NEPHRALGIA, pain in the kidneys, also NEPHRALGY [n]\n",
  "NEPHRALGIC": "relating to nephralgia, neuralgia of the kidneys [adj]\n",
  "NEPHRALGIES": "NEPHRALGY, pain in the kidneys, also NEPHRALGIA [n]\n",
  "NEPHRALGY": "pain in the kidneys, also NEPHRALGIA [n NEPHRALGIES]\n",
  "NEPHRECTOMIES": "NEPHRECTOMY, the surgical removal of kidney [n]\n",
  "NEPHRECTOMISE": "to perform a nephrectomy, also NEPHRECTOMIZE [v NEPHRECTOMISED, NEPHRECTOMISING, NEPHRECTOMISES]\n",
  "NEPHRECTOMISED": "NEPHRECTOMISE, to perform a nephrectomy, also NEPHRECTOMIZE [v]\n",
  "NEPHRECTOMISES": "NEPHRECTOMISE, to perform a nephrectomy, also NEPHRECTOMIZE [v]\n",
  "NEPHRECTOMISING": "NEPHRECTOMISE, to perform a nephrectomy, also NEPHRECTOMIZE [v]\n",
  "NEPHRECTOMIZE": "to perform a nephrectomy, also NEPHRECTOMISE [v NEPHRECTOMIZED, NEPHRECTOMIZING, NEPHRECTOMIZES]\n",
  "NEPHRECTOMIZED": "NEPHRECTOMIZE, to perform a nephrectomy, also NEPHRECTOMISE [v]\n",
  "NEPHRECTOMIZES": "NEPHRECTOMIZE, to perform a nephrectomy, also NEPHRECTOMISE [v]\n",
  "NEPHRECTOMIZING": "NEPHRECTOMIZE, to perform a nephrectomy, also NEPHRECTOMISE [v]\n",
  "NEPHRECTOMY": "the surgical removal of kidney [n NEPHRECTOMIES]\n",
  "NEPHRIC": "of or pertaining to the kidneys [adj]\n",
  "NEPHRIDIA": "NEPHRIDIUM, in invertebrates and lower chordates, an organ serving the function of a kidney [n]\n",
  "NEPHRIDIAL": "of or pertaining to a nephridium, a segmental tubule [adj]\n",
  "NEPHRIDIUM": "in invertebrates and lower chordates, an organ serving the function of a kidney [n NEPHRIDIA]\n",
  "NEPHRISM": "ill health caused by kidney disease [n -S]\n",
  "NEPHRISMS": "NEPHRISM, ill health caused by kidney disease [n]\n",
  "NEPHRITE": "a kind of jade used as charm against kidney disease, aka kidney stone [n -S]\n",
  "NEPHRITES": "NEPHRITE, a kind of jade used as charm against kidney disease, aka kidney stone [n]\n",
  "NEPHRITIC": "relating to the kidneys, also NEPHRITICAL [adj] / a medicine alleviating kidney conditions [n -S]\n",
  "NEPHRITICAL": "relating to the kidneys, also NEPHRITIC [adj]\n",
  "NEPHRITICS": "NEPHRITIC, a medicine alleviating kidney conditions [n]\n",
  "NEPHRITIDES": "NEPHRITIS, an inflammation of the kidneys [n]\n",
  "NEPHRITIS": "an inflammation of the kidneys [n NEPHRITIDES or NEPHRITISES]\n",
  "NEPHRITISES": "NEPHRITIS, an inflammation of the kidneys [n]\n",
  "NEPHROBLASTOMA": "a tumour on the kidneys [n -S]\n",
  "NEPHROBLASTOMAS": "NEPHROBLASTOMA, a tumour on the kidneys [n]\n",
  "NEPHROID": "kidney-shaped [adj]\n",
  "NEPHROLEPIS": "any fern of the genus Nephrolepis, some being grown as house plants [n NEPHROLEPISES]\n",
  "NEPHROLEPISES": "NEPHROLEPIS, any fern of the genus Nephrolepis, some being grown as house plants [n]\n",
  "NEPHROLOGICAL": "related to nephrology, the study of the kidneys [adj]\n",
  "NEPHROLOGIES": "NEPHROLOGY, the study of the kidneys [n]\n",
  "NEPHROLOGIST": "a student of nephrology [n -S]\n",
  "NEPHROLOGISTS": "NEPHROLOGIST, a student of nephrology [n]\n",
  "NEPHROLOGY": "the study of the kidneys [n NEPHROLOGIES]\n",
  "NEPHRON": "(Greek) an excretory unit of the kidney [n -S]\n",
  "NEPHRONS": "NEPHRON, (Greek) an excretory unit of the kidney [n]\n",
  "NEPHROPATHIC": "relating to nephropathy, kidney disease [adj]\n",
  "NEPHROPATHIES": "NEPHROPATHY, kidney disease [n]\n",
  "NEPHROPATHY": "kidney disease [n NEPHROPATHIES]\n",
  "NEPHROPEXIES": "NEPHROPEXY, the fixation of a floating kidney [n]\n",
  "NEPHROPEXY": "the fixation of a floating kidney [n NEPHROPEXIES]\n",
  "NEPHROPTOSES": "NEPHROPTOSIS, floating kidney [n]\n",
  "NEPHROPTOSIS": "floating kidney [n NEPHROPTOSES]\n",
  "NEPHROSCOPE": "a tubular medical instrument inserted through an incision in the skin to enable examination of a kidney [n -S]\n",
  "NEPHROSCOPES": "NEPHROSCOPE, a tubular medical instrument inserted through an incision in the skin to enable examination of a kidney [n]\n",
  "NEPHROSCOPIES": "NEPHROSCOPY, use of the nephroscope [n]\n",
  "NEPHROSCOPY": "use of the nephroscope [n NEPHROSCOPIES]\n",
  "NEPHROSES": "NEPHROSIS, degenerative lesions of the renal tubules [n]\n",
  "NEPHROSIS": "degenerative lesions of the renal tubules [n NEPHROSES]\n",
  "NEPHROSTOME": "the funnel-shaped coelomic opening of a typical nephridium [n -S]\n",
  "NEPHROSTOMES": "NEPHROSTOME, the funnel-shaped coelomic opening of a typical nephridium [n]\n",
  "NEPHROTIC": "of or like nephrosis, a disease of the kidneys [adj] / a disease of the kidneys [n -S]\n",
  "NEPHROTICS": "NEPHROTIC, a disease of the kidneys [n]\n",
  "NEPHROTOMIES": "NEPHROTOMY, the extraction of a stone from the kidney by cutting [n]\n",
  "NEPHROTOMY": "the extraction of a stone from the kidney by cutting [n NEPHROTOMIES]\n",
  "NEPHROTOXIC": "poisonous to the kidney [adj]\n",
  "NEPHROTOXICITY": "the state of being nephrotoxic [n]\n",
  "NEPIONIC": "of or relating to the embryonic period of development [adj]\n",
  "NEPIT": "a unit of information, 1.44 bits [n -S]\n",
  "NEPITS": "NEPIT, a unit of information, 1.44 bits [n]\n",
  "NEPOTIC": "showing nepotism, also NEPOTISTIC [adj]\n",
  "NEPOTISM": "favouritism shown to a relative [n -S]\n",
  "NEPOTISMS": "NEPOTISM, favouritism shown to a relative [n]\n",
  "NEPOTIST": "one who indulges in nepotism [n -S]\n",
  "NEPOTISTIC": "showing nepotism, also NEPOTIC [adj]\n",
  "NEPOTISTS": "NEPOTIST, one who indulges in nepotism [n]\n",
  "NEPS": "NEP, (dialect) catmint, a plant attractive to cats [n]\n",
  "NEPTUNIUM": "a radioactive metallic chemical element of the lanthanide series [n -S]\n",
  "NEPTUNIUMS": "NEPTUNIUM, a radioactive metallic chemical element of the lanthanide series [n]\n",
  "NERAL": "the trans-isomer of citral [n -S]\n",
  "NERALS": "NERAL, the trans-isomer of citral [n]\n",
  "NERD": "a person obsessed with computers at the expense of human interaction, also NURD [n -S]\n",
  "NERDIC": "another name for geekspeak [n -S]\n",
  "NERDICS": "NERDIC, another name for geekspeak [n]\n",
  "NERDIER": "NERDY, socially inept, also NURDY, NURDISH, NERDISH [adj]\n",
  "NERDIEST": "NERDY, socially inept, also NURDY, NURDISH, NERDISH [adj]\n",
  "NERDINESS": "the state of being nerdy [n -ES]\n",
  "NERDINESSES": "NERDINESS, the state of being nerdy [n]\n",
  "NERDISH": "socially inept, also NERDY, NURDY, NURDISH [adj]\n",
  "NERDS": "NERD, a person obsessed with computers at the expense of human interaction, also NURD [n]\n",
  "NERDY": "socially inept, also NURDY, NURDISH, NERDISH [adj NERDIER, NERDIEST]\n",
  "NEREID": "(Latin) a sea nymph, one of the daughters of Nereus, attendant upon Neptune, also NEREIS [n NEREIDS or NEREIDES]\n",
  "NEREIDES": "NEREIS, a marine worm [n]\n",
  "NEREIDS": "NEREID, (Latin) a sea nymph, one of the daughters of Nereus, attendant upon Neptune, also NEREIS [n]\n",
  "NEREIS": "a marine worm [n NEREIDES]\n",
  "NERINE": "(Latin) a S. African plant related to the amaryllis [n -S]\n",
  "NERINES": "NERINE, (Latin) a S. African plant related to the amaryllis [n]\n",
  "NERITE": "(Greek) a type of sea snail [n -S]\n",
  "NERITES": "NERITE, (Greek) a type of sea snail [n]\n",
  "NERITIC": "pertaining to shallow water [adj]\n",
  "NERK": "a bothersome idiot [n -S]\n",
  "NERKA": "the sockeye salmon [n -S]\n",
  "NERKAS": "NERKA, the sockeye salmon [n]\n",
  "NERKS": "NERK, a bothersome idiot [n]\n",
  "NEROL": "a fragrant alcohol [n -S]\n",
  "NEROLI": "(French) an oil distilled from orange flowers [n -S]\n",
  "NEROLIS": "NEROLI, (French) an oil distilled from orange flowers [n]\n",
  "NEROLS": "NEROL, a fragrant alcohol [n]\n",
  "NERTS": "used to express defiance, also NERTZ [interj]\n",
  "NERTZ": "used to express defiance, also NERTS [interj]\n",
  "NERVAL": "of the nerves, also NEURAL [adj]\n",
  "NERVATE": "having veins [adj]\n",
  "NERVATION": "the arrangement of nerves and veins, esp. those of leaves, also NERVATURE, NEURATION [n -S]\n",
  "NERVATIONS": "NERVATION, the arrangement of nerves and veins, esp. those of leaves, also NERVATURE, NEURATION [n]\n",
  "NERVATURE": "the arrangement of nerves and veins, esp. those of leaves, also NERVATION, NEURATION [n -S]\n",
  "NERVATURES": "NERVATURE, the arrangement of nerves and veins, esp. those of leaves, also NERVATION, NEURATION [n]\n",
  "NERVE": "to give courage to [v NERVED, NERVING, NERVES]\n",
  "NERVED": "NERVE, to give courage to [v]\n",
  "NERVELESS": "without nerves [adj NERVELESSLY]\n",
  "NERVELESSLY": "NERVELESS, without nerves [adv]\n",
  "NERVELESSNESS": "the state of being nerveless [n -ES]\n",
  "NERVELESSNESSES": "NERVELESSNESS, the state of being nerveless [n]\n",
  "NERVELET": "a little nerve [n -S]\n",
  "NERVELETS": "NERVELET, a little nerve [n]\n",
  "NERVER": "something which gives one courage, especially drink [n -S]\n",
  "NERVERS": "NERVER, something which gives one courage, especially drink [n]\n",
  "NERVES": "NERVE, to give courage to [v]\n",
  "NERVIER": "NERVY, nervous [adj]\n",
  "NERVIEST": "NERVY, nervous [adj]\n",
  "NERVILY": "NERVY, nervous [adv]\n",
  "NERVINE": "a soothing medicine [n -S]\n",
  "NERVINES": "NERVINE, a soothing medicine [n]\n",
  "NERVINESS": "the state of being nervy [n -ES]\n",
  "NERVINESSES": "NERVINESS, the state of being nervy [n]\n",
  "NERVING": "a type of veterinary operation [n -S]\n",
  "NERVINGS": "NERVING, a type of veterinary operation [n]\n",
  "NERVOSITIES": "NERVOSITY, nervousness [n]\n",
  "NERVOSITY": "nervousness [n NERVOSITIES]\n",
  "NERVOUS": "easily excited [adj NERVOUSLY]\n",
  "NERVOUSLY": "NERVOUS, easily excited [adv]\n",
  "NERVOUSNESS": "the state of being nervous [n -ES]\n",
  "NERVOUSNESSES": "NERVOUSNESS, the state of being nervous [n]\n",
  "NERVULAR": "relating to a nervule, a small branch of a nerve [adj]\n",
  "NERVULE": "a vascular ridge on a leaf, also NERVURE [n -S]\n",
  "NERVULES": "NERVULE, a vascular ridge on a leaf, also NERVURE [n]\n",
  "NERVURATION": "the state of having nervures [n -S]\n",
  "NERVURATIONS": "NERVURATION, the state of having nervures [n]\n",
  "NERVURE": "a vascular ridge on a leaf, also NERVULE [n -S]\n",
  "NERVURES": "NERVURE, a vascular ridge on a leaf, also NERVULE [n]\n",
  "NERVY": "nervous [adj NERVIER, NERVIEST, NERVILY]\n",
  "NESCIENCE": "lack of knowledge or awareness; the doctrine that nothing is truly knowable [n -S]\n",
  "NESCIENCES": "NESCIENCE, lack of knowledge or awareness; the doctrine that nothing is truly knowable [n]\n",
  "NESCIENT": "one who is ignorant [n -S]\n",
  "NESCIENTS": "NESCIENT, one who is ignorant [n]\n",
  "NESH": "soft, crumbly; tender [adj NESHER, NESHEST]\n",
  "NESHER": "NESH, soft, crumbly; tender [adj]\n",
  "NESHEST": "NESH, soft, crumbly; tender [adj]\n",
  "NESHNESS": "the quality of being nesh, soft, crumbly [n -ES]\n",
  "NESHNESSES": "NESHNESS, the quality of being nesh, soft, crumbly [n]\n",
  "NESS": "a headland [n -ES]\n",
  "NESSELRODE": "a rich frozen pudding made of chestnuts, eggs, cream etc. [n -S]\n",
  "NESSELRODES": "NESSELRODE, a rich frozen pudding made of chestnuts, eggs, cream etc. [n]\n",
  "NESSES": "NESS, a headland [n]\n",
  "NEST": "to build a structure for holding eggs [v -ED, -ING, -S]\n",
  "NESTABLE": "capable of being fitted closely together [adj]\n",
  "NESTED": "NEST, to build a structure for holding eggs [v]\n",
  "NESTER": "one who nests [n -S]\n",
  "NESTERS": "NESTER, one who nests [n]\n",
  "NESTFUL": "enough to fill a nest [n -S]\n",
  "NESTFULS": "NESTFUL, enough to fill a nest [n]\n",
  "NESTING": "the act of making nests [n -S]\n",
  "NESTINGS": "NESTING, the act of making nests [n]\n",
  "NESTLE": "to lie snugly together [v NESTLED, NESTLING, NESTLES]\n",
  "NESTLED": "NESTLE, to lie snugly together [v]\n",
  "NESTLER": "one who nestles [n -S]\n",
  "NESTLERS": "NESTLER, one who nestles [n]\n",
  "NESTLES": "NESTLE, to lie snugly together [v]\n",
  "NESTLIKE": "like a nest [adj]\n",
  "NESTLING": "a young bird [n -S]\n",
  "NESTLINGS": "NESTLING, a young bird [n]\n",
  "NESTMATE": "a bird sharing a nest with another [n -S]\n",
  "NESTMATES": "NESTMATE, a bird sharing a nest with another [n]\n",
  "NESTOR": "(Greek) a genus of parrots with gray heads, of New Zealand and Papua, allied to the cockatoos [n -S]\n",
  "NESTORS": "NESTOR, (Greek) a genus of parrots with gray heads, of New Zealand and Papua, allied to the cockatoos [n]\n",
  "NESTS": "NEST, to build a structure for holding eggs [v]\n",
  "NET": "to catch in an openwork fabric [v NETTED, NETTING, NETS]\n",
  "NETBALL": "a team game [n -S]\n",
  "NETBALLER": "one who plays netball [n -S]\n",
  "NETBALLERS": "NETBALLER, one who plays netball [n]\n",
  "NETBALLS": "NETBALL, a team game [n]\n",
  "NETBOOK": "a portable computer smaller than a laptop [n -S]\n",
  "NETBOOKS": "NETBOOK, a portable computer smaller than a laptop [n]\n",
  "NETE": "(Greek) the highest note of the lyre [n -S]\n",
  "NETES": "NETE, (Greek) the highest note of the lyre [n]\n",
  "NETFUL": "enough to fill a net [n -S]\n",
  "NETFULS": "NETFUL, enough to fill a net [n]\n",
  "NETHEAD": "an enthusiast or expert on the internet [n -S]\n",
  "NETHEADS": "NETHEAD, an enthusiast or expert on the internet [n]\n",
  "NETHELESS": "(Spenser) nevertheless, also NATHELESS, NATHELESSE, NATHLESS, NAYTHLES [adv]\n",
  "NETHER": "situated below [adj]\n",
  "NETHERLINGS": "stockings [n]\n",
  "NETHERMORE": "the weaker or inferior party [n -S]\n",
  "NETHERMORES": "NETHERMORE, the weaker or inferior party [n]\n",
  "NETHERMOST": "lowest [adj]\n",
  "NETHERSTOCK": "(obsolete) a stocking [n -S]\n",
  "NETHERSTOCKS": "NETHERSTOCK, (obsolete) a stocking [n]\n",
  "NETHERWARD": "in a downward direction, also NETHERWARDS [adv]\n",
  "NETHERWARDS": "in a downward direction, also NETHERWARD [adv]\n",
  "NETHERWORLD": "the world of the dead; Hades; the lower depths of society [n -S]\n",
  "NETHERWORLDS": "NETHERWORLD, the world of the dead; Hades; the lower depths of society [n]\n",
  "NETIQUETTE": "etiquette appropriate to the Internet [n -S]\n",
  "NETIQUETTES": "NETIQUETTE, etiquette appropriate to the Internet [n]\n",
  "NETIZEN": "a citizen of the Internet [n -S]\n",
  "NETIZENS": "NETIZEN, a citizen of the Internet [n]\n",
  "NETLESS": "without a net [adj]\n",
  "NETLIKE": "like a net [adj]\n",
  "NETMINDER": "a goalkeeper [n -S]\n",
  "NETMINDERS": "NETMINDER, a goalkeeper [n]\n",
  "NETOP": "(Native American) a friend, companion [n -S]\n",
  "NETOPS": "NETOP, (Native American) a friend, companion [n]\n",
  "NETROOT": "a political activist who promotes his or her cause via the internet [n -S]\n",
  "NETROOTS": "NETROOT, a political activist who promotes his or her cause via the internet [n]\n",
  "NETS": "NET, to catch in an openwork fabric [v]\n",
  "NETSPEAK": "the jargon of internet users [n -S]\n",
  "NETSPEAKS": "NETSPEAK, the jargon of internet users [n]\n",
  "NETSUKE": "(Japanese) a small Japanese carved ornament [n -S]\n",
  "NETSUKES": "NETSUKE, (Japanese) a small Japanese carved ornament [n]\n",
  "NETSURF": "to browse the internet for information [v -ED, -ING, -S]\n",
  "NETSURFED": "NETSURF, to browse the internet for information [v]\n",
  "NETSURFER": "one who engages in the activity of looking at many different websites on the internet [n -S]\n",
  "NETSURFERS": "NETSURFER, one who engages in the activity of looking at many different websites on the internet [n]\n",
  "NETSURFING": "the act of browsing the internet for information [n -S]\n",
  "NETSURFINGS": "NETSURFING, the act of browsing the internet for information [n]\n",
  "NETSURFS": "NETSURF, to browse the internet for information [v]\n",
  "NETT": "to gain or produce a clear profit [v -ED, -ING, -S]\n",
  "NETTABLE": "able to be netted [adj]\n",
  "NETTED": "NET, to catch in an openwork fabric [v]\n",
  "NETTER": "one who nets [n -S]\n",
  "NETTERS": "NETTER, one who nets [n]\n",
  "NETTIE": "an internet aficionado [n -S]\n",
  "NETTIER": "NETTY, resembling a net [adj]\n",
  "NETTIES": "NETTIE, an internet aficionado [n]\n",
  "NETTIEST": "NETTY, resembling a net [adj]\n",
  "NETTING": "a net [n -S]\n",
  "NETTINGS": "NETTING, a net [n]\n",
  "NETTLE": "to annoy [v NETTLED, NETTLING, NETTLES]\n",
  "NETTLED": "NETTLE, to annoy [v]\n",
  "NETTLELIKE": "like a nettle [adj]\n",
  "NETTLER": "one that nettles [n -S]\n",
  "NETTLERS": "NETTLER, one that nettles [n]\n",
  "NETTLES": "NETTLE, to annoy [v]\n",
  "NETTLESOME": "causing vexation [adj]\n",
  "NETTLIER": "NETTLY, like a nettle [adj]\n",
  "NETTLIEST": "NETTLY, like a nettle [adj]\n",
  "NETTLING": "NETTLE, to annoy [v]\n",
  "NETTLY": "like a nettle [adj NETTLIER, NETTLIEST]\n",
  "NETTS": "NETT, to gain or produce a clear profit [v]\n",
  "NETTY": "resembling a net [adj NETTIER, NETTIEST]\n",
  "NETWORK": "to form a structure like a net [v -ED, -ING, -S]\n",
  "NETWORKED": "NETWORK, to form a structure like a net [v]\n",
  "NETWORKER": "one who networks, establishes social contacts [n -S]\n",
  "NETWORKERS": "NETWORKER, one who networks, establishes social contacts [n]\n",
  "NETWORKING": "the making of social contacts [n -S]\n",
  "NETWORKINGS": "NETWORKING, the making of social contacts [n]\n",
  "NETWORKS": "NETWORK, to form a structure like a net [v]\n",
  "NEUK": "(Scots) a nook, a corner [n -S]\n",
  "NEUKS": "NEUK, (Scots) a nook, a corner [n]\n",
  "NEUM": "a sign used in musical notation, also NEUME [n -S]\n",
  "NEUMATIC": "relating to a neume, a sign used in musical notation, also NEUMIC [adj]\n",
  "NEUME": "a succession of notes sung to one syllable, also NEUM [n -S]\n",
  "NEUMES": "NEUME, a succession of notes sung to one syllable, also NEUM [n]\n",
  "NEUMIC": "relating to a neume, a sign used in musical notation, also NEUMATIC [adj]\n",
  "NEUMS": "NEUM, a sign used in musical notation, also NEUME [n]\n",
  "NEURAL": "pertaining to the nervous system, also NERVAL [adj NEURALLY]\n",
  "NEURALGIA": "intense burning or stabbing pain, typically along the line of a nerve, esp. in the face [n -S]\n",
  "NEURALGIAS": "NEURALGIA, intense burning or stabbing pain, typically along the line of a nerve, esp. in the face [n]\n",
  "NEURALGIC": "of or pertaining to, or having the character of, neuralgia [adj]\n",
  "NEURALLY": "NEURAL, pertaining to the nervous system, also NERVAL [adv]\n",
  "NEURAMINIC": "as in neuraminic acid, a carboxylic acid which is an amino sugar [adj]\n",
  "NEURAMINIDASE": "an enzyme found on the surface of several viruses [n -S]\n",
  "NEURAMINIDASES": "NEURAMINIDASE, an enzyme found on the surface of several viruses [n]\n",
  "NEURASTHENIA": "nervous debility or breakdown [n -S]\n",
  "NEURASTHENIAC": "one suffering from neurasthenia, also NEURASTHENIC [n -S]\n",
  "NEURASTHENIACS": "NEURASTHENIAC, one suffering from neurasthenia, also NEURASTHENIC [n]\n",
  "NEURASTHENIAS": "NEURASTHENIA, nervous debility or breakdown [n]\n",
  "NEURASTHENIC": "one suffering from neurasthenia, also NEURASTHENIAC [n -S]\n",
  "NEURASTHENICS": "NEURASTHENIC, one suffering from neurasthenia, also NEURASTHENIAC [n]\n",
  "NEURATION": "the arrangement of nerves and veins, esp. those of leaves, also NERVATION, NERVATURE [n -S]\n",
  "NEURATIONS": "NEURATION, the arrangement of nerves and veins, esp. those of leaves, also NERVATION, NERVATURE [n]\n",
  "NEURAXON": "a part of a neuron [n -S]\n",
  "NEURAXONS": "NEURAXON, a part of a neuron [n]\n",
  "NEURECTOMIES": "NEURECTOMY, the surgical excision of part of a nerve [n]\n",
  "NEURECTOMY": "the surgical excision of part of a nerve [n NEURECTOMIES]\n",
  "NEURILEMMA": "the delicate outer sheath of a nerve fiber, also NEUROLEMMA [n -S]\n",
  "NEURILEMMAL": "of or like a neurilemma, the delicate outer sheath of a nerve fiber; the primitive sheath [adj]\n",
  "NEURILEMMAS": "NEURILEMMA, the delicate outer sheath of a nerve fiber, also NEUROLEMMA [n]\n",
  "NEURILITIES": "NEURILITY, the essential character of nerve [n]\n",
  "NEURILITY": "the essential character of nerve [n NEURILITIES]\n",
  "NEURINE": "a very poisonous ptomaine formed in putrefying flesh [n -S]\n",
  "NEURINES": "NEURINE, a very poisonous ptomaine formed in putrefying flesh [n]\n",
  "NEURISM": "a hypothetical nerve force acting on evolution [n -S]\n",
  "NEURISMS": "NEURISM, a hypothetical nerve force acting on evolution [n]\n",
  "NEURITE": "an axon or dendrite of a nerve cell [n -S]\n",
  "NEURITES": "NEURITE, an axon or dendrite of a nerve cell [n]\n",
  "NEURITIC": "one affected with neuritis [n -S]\n",
  "NEURITICS": "NEURITIC, one affected with neuritis [n]\n",
  "NEURITIDES": "NEURITIS, inflammation of a nerve [n]\n",
  "NEURITIS": "inflammation of a nerve [n NEURITISES or NEURITIDES]\n",
  "NEURITISES": "NEURITIS, inflammation of a nerve [n]\n",
  "NEUROACTIVE": "stimulating neural tissue [adj]\n",
  "NEUROANATOMIC": "relating to neuroanatomy, also NEUROANATOMICAL [adj]\n",
  "NEUROANATOMICAL": "relating to neuroanatomy, also NEUROANATOMIC [adj]\n",
  "NEUROANATOMIES": "NEUROANATOMY, the anatomy of nervous tissue and the nervous system [n]\n",
  "NEUROANATOMIST": "one who studies neuroanatomy [n -S]\n",
  "NEUROANATOMISTS": "NEUROANATOMIST, one who studies neuroanatomy [n]\n",
  "NEUROANATOMY": "the anatomy of nervous tissue and the nervous system [n NEUROANATOMIES]\n",
  "NEUROBIOLOGICAL": "relating to neurobiology [adj]\n",
  "NEUROBIOLOGIES": "NEUROBIOLOGY, the study of the anatomy of the nervous system [n]\n",
  "NEUROBIOLOGIST": "one who studies neurobiology [n -S]\n",
  "NEUROBIOLOGISTS": "NEUROBIOLOGIST, one who studies neurobiology [n]\n",
  "NEUROBIOLOGY": "the study of the anatomy of the nervous system [n NEUROBIOLOGIES]\n",
  "NEUROBLAST": "an embryonic nerve cell [n -S]\n",
  "NEUROBLASTOMA": "a tumour of the nervous system [n NEUROBLASTOMAS or NEUROBLASTOMATA]\n",
  "NEUROBLASTOMAS": "NEUROBLASTOMA, a tumour of the nervous system [n]\n",
  "NEUROBLASTOMATA": "NEUROBLASTOMA, a tumour of the nervous system [n]\n",
  "NEUROBLASTS": "NEUROBLAST, an embryonic nerve cell [n]\n",
  "NEUROCHEMICAL": "an organic molecule, such as serotonin, dopamine, or nerve growth factor, that participates in neural activity [n -S]\n",
  "NEUROCHEMICALS": "NEUROCHEMICAL, an organic molecule, such as serotonin, dopamine, or nerve growth factor, that participates in neural activity [n]\n",
  "NEUROCHEMIST": "a student of neurochemistry [n -S]\n",
  "NEUROCHEMISTRY": "the study of the chemical makeup and activities of nervous tissue [n]\n",
  "NEUROCHEMISTS": "NEUROCHEMIST, a student of neurochemistry [n]\n",
  "NEUROCHIP": "a microchip used in neural networks [n -S]\n",
  "NEUROCHIPS": "NEUROCHIP, a microchip used in neural networks [n]\n",
  "NEUROCOEL": "a cavity in the brain, also NEUROCOELE [n -S]\n",
  "NEUROCOELE": "a cavity in the brain, also NEUROCOEL [n -S]\n",
  "NEUROCOELES": "NEUROCOELE, a cavity in the brain, also NEUROCOEL [n]\n",
  "NEUROCOELS": "NEUROCOEL, a cavity in the brain, also NEUROCOELE [n]\n",
  "NEUROCOGNITIVE": "relating to cognitive functions closely linked to the function of particular areas, neural pathways, or cortical networks in the brain [adj]\n",
  "NEUROCOMPUTER": "a computer that uses neural networks to mimic the action of the human brain [n -S]\n",
  "NEUROCOMPUTERS": "NEUROCOMPUTER, a computer that uses neural networks to mimic the action of the human brain [n]\n",
  "NEUROCOMPUTING": "computing using neural networks to mimic the action of the human brain [n -S]\n",
  "NEUROCOMPUTINGS": "NEUROCOMPUTING, computing using neural networks to mimic the action of the human brain [n]\n",
  "NEURODIVERSITY": "variety in human behavioural traits and brain function, viewed as normal variation within the population; used esp with reference to autistic spectrum conditions [n]\n",
  "NEUROECTODERMAL": "as in peripheral primitive neuroectodermal tumour, another name for Ewing's sarcoma [adj]\n",
  "NEUROENDOCRINE": "of, relating to, or being a hormonal substance that influences the activity of nerves [adj]\n",
  "NEUROETHOLOGIES": "NEUROETHOLOGY, the description of features of animal behaviour in terms of the mechanisms of the nervous system [n]\n",
  "NEUROETHOLOGY": "the description of features of animal behaviour in terms of the mechanisms of the nervous system [n NEUROETHOLOGIES]\n",
  "NEUROFEEDBACK": "a therapy technique that presents the user with realtime feedback on brainwave activity [n -S]\n",
  "NEUROFEEDBACKS": "NEUROFEEDBACK, a therapy technique that presents the user with realtime feedback on brainwave activity [n]\n",
  "NEUROFIBRIL": "one of a large number of fine fibres present in the cytoplasm of a nerve cell [n -S]\n",
  "NEUROFIBRILAR": "of or like a neurofibril, also NEUROFIBRILLAR, NEUROFIBRILLARY [adj]\n",
  "NEUROFIBRILLAR": "of or like a neurofibril, also NEUROFIBRILAR, NEUROFIBRILLARY [adj]\n",
  "NEUROFIBRILLARY": "of or like a neurofibril, also NEUROFIBRILAR, NEUROFIBRILLAR [adj]\n",
  "NEUROFIBRILS": "NEUROFIBRIL, one of a large number of fine fibres present in the cytoplasm of a nerve cell [n]\n",
  "NEUROFIBROMA": "a tumour of the nervous fibre [n NEUROFIBROMAS or NEUROFIBROMATA]\n",
  "NEUROFIBROMAS": "NEUROFIBROMA, a tumour of the nervous fibre [n]\n",
  "NEUROFIBROMATA": "NEUROFIBROMA, a tumour of the nervous fibre [n]\n",
  "NEUROGENESES": "NEUROGENESIS, the production or generation of nerves [n]\n",
  "NEUROGENESIS": "the production or generation of nerves [n NEUROGENESES]\n",
  "NEUROGENIC": "caused or stimulated by the nervous system, as opposed to myogenic, having a muscular origin [adj NEUROGENICALLY]\n",
  "NEUROGENICALLY": "NEUROGENIC, caused or stimulated by the nervous system, as opposed to myogenic, having a muscular origin [adv]\n",
  "NEUROGLIA": "the supporting tissue of the brain and spinal cord, etc., also GLIA [n -S]\n",
  "NEUROGLIAL": "relating to the neuroglia, the delicate connective tissue framework which supports the nervous matter and blood vessels of the brain and spinal cord [adj]\n",
  "NEUROGLIAS": "NEUROGLIA, the supporting tissue of the brain and spinal cord, etc., also GLIA [n]\n",
  "NEUROGRAM": "a modification in nerve structure to which memory is due [n -S]\n",
  "NEUROGRAMS": "NEUROGRAM, a modification in nerve structure to which memory is due [n]\n",
  "NEUROHORMONAL": "involving both neural and hormonal mechanisms [adj]\n",
  "NEUROHORMONE": "a hormone (as acetylcholine or norepinephrine) produced by or acting on nervous tissue [n -S]\n",
  "NEUROHORMONES": "NEUROHORMONE, a hormone (as acetylcholine or norepinephrine) produced by or acting on nervous tissue [n]\n",
  "NEUROHUMOR": "a neurohormone, esp. a neurotransmitter, also NEUROHUMOUR [n -S]\n",
  "NEUROHUMORAL": "relating to neurohumor [adj]\n",
  "NEUROHUMORS": "NEUROHUMOR, a neurohormone, esp. a neurotransmitter, also NEUROHUMOUR [n]\n",
  "NEUROHUMOUR": "a neurohormone, esp. a neurotransmitter, also NEUROHUMOR [n -S]\n",
  "NEUROHUMOURS": "NEUROHUMOUR, a neurohormone, esp. a neurotransmitter, also NEUROHUMOR [n]\n",
  "NEUROHYPNOLOGY": "an old name for the science of hypnotism, also NEURYPNOLOGY [n]\n",
  "NEUROHYPOPHYSES": "NEUROHYPOPHYSIS, the portion of the pituitary gland that is composed of the infundibulum and posterior lobe and is concerned with the secretion of various hormones [n]\n",
  "NEUROHYPOPHYSIS": "the portion of the pituitary gland that is composed of the infundibulum and posterior lobe and is concerned with the secretion of various hormones [n NEUROHYPOPHYSES]\n",
  "NEUROID": "either of the halves of a neural arch [n -S]\n",
  "NEUROIDS": "NEUROID, either of the halves of a neural arch [n]\n",
  "NEUROLEMMA": "the delicate outer sheath of a nerve fiber, also NEURILEMMA [n -S]\n",
  "NEUROLEMMAS": "NEUROLEMMA, the delicate outer sheath of a nerve fiber, also NEURILEMMA [n]\n",
  "NEUROLEPTIC": "capable of having an effect on the brain, esp. tranquillising [adj] / a neuroleptic drug [n -S]\n",
  "NEUROLEPTICS": "NEUROLEPTIC, a neuroleptic drug [n]\n",
  "NEUROLINGUIST": "a practitioner of neurolinguistics, the branch of linguistics which deals with the processing and storage of language in the brain [n -S]\n",
  "NEUROLINGUISTIC": "relating to neurolinguistics, the branch of linguistics which deals with the processing and storage of language in the brain [adj]\n",
  "NEUROLINGUISTS": "NEUROLINGUIST, a practitioner of neurolinguistics, the branch of linguistics which deals with the processing and storage of language in the brain [n]\n",
  "NEUROLOGIC": "relating to neurology, the study of nerves, also NEUROLOGICAL [adj NEUROLOGICALLY]\n",
  "NEUROLOGICAL": "relating to neurology, the study of nerves, also NEUROLOGIC [adj NEUROLOGICALLY]\n",
  "NEUROLOGICALLY": "NEUROLOGICAL, relating to neurology, the study of nerves, also NEUROLOGIC [adv]\n",
  "NEUROLOGIES": "NEUROLOGY, the branch of science which treats of the nervous system [n]\n",
  "NEUROLOGIST": "one specializing in neurology [n -S]\n",
  "NEUROLOGISTS": "NEUROLOGIST, one specializing in neurology [n]\n",
  "NEUROLOGY": "the branch of science which treats of the nervous system [n NEUROLOGIES]\n",
  "NEUROLYSES": "NEUROLYSIS, disintegration of nerve substance; surgical liberation of nerve [n]\n",
  "NEUROLYSIS": "disintegration of nerve substance; surgical liberation of nerve [n NEUROLYSES]\n",
  "NEUROMA": "a tumor developed on, or connected with, a nerve [n NEUROMAS or NEUROMATA]\n",
  "NEUROMARKETING": "a field of marketing that studies consumers' sensorimotor, cognitive, and affective response to marketing stimuli [n -S]\n",
  "NEUROMARKETINGS": "NEUROMARKETING, a field of marketing that studies consumers' sensorimotor, cognitive, and affective response to marketing stimuli [n]\n",
  "NEUROMAS": "NEUROMA, a tumor developed on, or connected with, a nerve [n]\n",
  "NEUROMAST": "a sensory cell in fish [n -S]\n",
  "NEUROMASTS": "NEUROMAST, a sensory cell in fish [n]\n",
  "NEUROMATA": "NEUROMA, a tumor developed on, or connected with, a nerve [n]\n",
  "NEUROMATOUS": "like a neuroma [adj]\n",
  "NEUROMOTOR": "of or relating to nerves and effectors, esp. muscles [adj]\n",
  "NEUROMUSCULAR": "of or relating to nerves and muscles [adj]\n",
  "NEURON": "(Greek) the basic cellular unit of the nervous system, also NEURONE [n -S]\n",
  "NEURONAL": "of or like a neuron, also NEURONIC [adj]\n",
  "NEURONE": "the basic cellular unit of the nervous system, also NEURON [n -S]\n",
  "NEURONES": "NEURONE, the basic cellular unit of the nervous system, also NEURON [n]\n",
  "NEURONIC": "of or like a neuron, also NEURONAL [adj]\n",
  "NEURONS": "NEURON, (Greek) the basic cellular unit of the nervous system, also NEURONE [n]\n",
  "NEUROPATH": "one who believes in nervous origin of most diseases [n -S]\n",
  "NEUROPATHIC": "of or like a neuropathy, an affection of the nervous system or of a nerve, also NEUROPATHICAL [adj NEUROPATHICALLY]\n",
  "NEUROPATHICAL": "of or like a neuropathy, an affection of the nervous system or of a nerve, also NEUROPATHIC [adj NEUROPATHICALLY]\n",
  "NEUROPATHICALLY": "NEUROPATHICAL, of or like a neuropathy, an affection of the nervous system or of a nerve, also NEUROPATHIC [adv]\n",
  "NEUROPATHIES": "NEUROPATHY, an affection of the nervous system or of a nerve [n]\n",
  "NEUROPATHIST": "a specialist in nervous diseases [n -S]\n",
  "NEUROPATHISTS": "NEUROPATHIST, a specialist in nervous diseases [n]\n",
  "NEUROPATHOLOGIC": "relating to neuropathology [adj]\n",
  "NEUROPATHOLOGY": "pathology of the nervous system [n]\n",
  "NEUROPATHS": "NEUROPATH, one who believes in nervous origin of most diseases [n]\n",
  "NEUROPATHY": "an affection of the nervous system or of a nerve [n NEUROPATHIES]\n",
  "NEUROPEPTIDE": "a peptide that influences neural activity or functioning [n -S]\n",
  "NEUROPEPTIDES": "NEUROPEPTIDE, a peptide that influences neural activity or functioning [n]\n",
  "NEUROPHYSIOLOGY": "the physiology of the nervous system [n]\n",
  "NEUROPIL": "a network of axons, dendrites and synapses within the central nervous system [n -S]\n",
  "NEUROPILS": "NEUROPIL, a network of axons, dendrites and synapses within the central nervous system [n]\n",
  "NEUROPLASM": "the protoplasm of a nerve cell [n -S]\n",
  "NEUROPLASMS": "NEUROPLASM, the protoplasm of a nerve cell [n]\n",
  "NEUROPSYCHIATRY": "a branch of medicine concerned with both neurology and psychiatry [n]\n",
  "NEUROPSYCHOLOGY": "the study of the relation between brain and behaviour [n]\n",
  "NEUROPTERA": "NEUROPTERAN, any of an order of insect including lacewing flies, also NEUROPTERON [n]\n",
  "NEUROPTERAN": "any of an order of insect including lacewing flies, also NEUROPTERON [n -S]\n",
  "NEUROPTERANS": "NEUROPTERAN, any of an order of insect including lacewing flies, also NEUROPTERON [n]\n",
  "NEUROPTERIST": "a person who studies the Neuropteroidea, lacewing flies [n -S]\n",
  "NEUROPTERISTS": "NEUROPTERIST, a person who studies the Neuropteroidea, lacewing flies [n]\n",
  "NEUROPTERON": "any of an order of insect including lacewing flies, also NEUROPTERAN [n NEUROPTERA or NEUROPTERONS]\n",
  "NEUROPTERONS": "NEUROPTERON, any of an order of insect including lacewing flies, also NEUROPTERAN [n]\n",
  "NEUROPTEROUS": "pertaining or belonging to insect order including lacewing flies [adj]\n",
  "NEURORADIOLOGY": "radiology of the nervous system [n]\n",
  "NEUROSAL": "relating to neurosis [adj]\n",
  "NEUROSCIENCE": "a branch (as neurophysiology) of the life sciences that deals with the anatomy, physiology, biochemistry, or molecular biology of nerves and nervous tissue and esp. with their relation to behavior and learning [n -S]\n",
  "NEUROSCIENCES": "NEUROSCIENCE, a branch (as neurophysiology) of the life sciences that deals with the anatomy, physiology, biochemistry, or molecular biology of nerves and nervous tissue and esp. with their relation to behavior and learning [n]\n",
  "NEUROSCIENTIFIC": "relating to neuroscience [adj]\n",
  "NEUROSCIENTIST": "a practitioner of neuroscience [n -S]\n",
  "NEUROSCIENTISTS": "NEUROSCIENTIST, a practitioner of neuroscience [n]\n",
  "NEUROSECRETION": "the process of producing a secretion by neurons [n -S]\n",
  "NEUROSECRETIONS": "NEUROSECRETION, the process of producing a secretion by neurons [n]\n",
  "NEUROSECRETORY": "relating to neurosecretion [adj]\n",
  "NEUROSENSORY": "of or relating to afferent nerves [adj]\n",
  "NEUROSES": "NEUROSIS, a type of emotional disturbance [n]\n",
  "NEUROSIS": "a type of emotional disturbance [n NEUROSES]\n",
  "NEUROSPORA": "any of a genus of ascomycetous fungi, used extensively in genetic research [n -S]\n",
  "NEUROSPORAS": "NEUROSPORA, any of a genus of ascomycetous fungi, used extensively in genetic research [n]\n",
  "NEUROSURGEON": "a surgeon specialising in neurosurgery [n -S]\n",
  "NEUROSURGEONS": "NEUROSURGEON, a surgeon specialising in neurosurgery [n]\n",
  "NEUROSURGERIES": "NEUROSURGERY, surgery of nervous structures (as nerves, the brain, or the spinal cord) [n]\n",
  "NEUROSURGERY": "surgery of nervous structures (as nerves, the brain, or the spinal cord) [n NEUROSURGERIES]\n",
  "NEUROSURGICAL": "relating to neurosurgery [adj NEUROSURGICALLY]\n",
  "NEUROSURGICALLY": "NEUROSURGICAL, relating to neurosurgery [adv]\n",
  "NEUROSYPHILIS": "a syphilitic infection affecting the central nervous system [n -ES]\n",
  "NEUROSYPHILISES": "NEUROSYPHILIS, a syphilitic infection affecting the central nervous system [n]\n",
  "NEUROTIC": "suffering from a neurosis [adj NEUROTICALLY] / someone given to neurosis [n -S]\n",
  "NEUROTICALLY": "NEUROTIC, suffering from a neurosis [adv]\n",
  "NEUROTICISM": "a neurotic character, condition, or trait [n -S]\n",
  "NEUROTICISMS": "NEUROTICISM, a neurotic character, condition, or trait [n]\n",
  "NEUROTICS": "NEUROTIC, someone given to neurosis [n]\n",
  "NEUROTOMIES": "NEUROTOMY, the dissection, or anatomy, of the nervous system [n]\n",
  "NEUROTOMIST": "one who practises neurotomy, the dissection, or anatomy, of the nervous system [n -S]\n",
  "NEUROTOMISTS": "NEUROTOMIST, one who practises neurotomy, the dissection, or anatomy, of the nervous system [n]\n",
  "NEUROTOMY": "the dissection, or anatomy, of the nervous system [n NEUROTOMIES]\n",
  "NEUROTOXIC": "toxic to the nerves or nervous tissue [adj]\n",
  "NEUROTOXICITIES": "NEUROTOXICITY, the state of being neurotoxic [n]\n",
  "NEUROTOXICITY": "the state of being neurotoxic [n NEUROTOXICITIES]\n",
  "NEUROTOXIN": "a nerve poison [n -S]\n",
  "NEUROTOXINS": "NEUROTOXIN, a nerve poison [n]\n",
  "NEUROTROPHIC": "relating to the nutrition of the nervous system, or to nutritional changes influenced by the nervous system [adj]\n",
  "NEUROTROPHIES": "NEUROTROPHY, nutrition of the nervous system; the influence of the nervous system on nutrition [n]\n",
  "NEUROTROPHY": "nutrition of the nervous system; the influence of the nervous system on nutrition [n NEUROTROPHIES]\n",
  "NEUROTROPIC": "having a special affinity for or growing in nerve cells [adj]\n",
  "NEUROTYPICAL": "having normal brain activity, esp as opposed to an autistic person [adj]\n",
  "NEUROVASCULAR": "relating to or affecting both nerves and blood vessels [adj]\n",
  "NEURULA": "(Greek) an embryo at the stage succeeding the gastrula, when the neural tube develops from the neural plate [n NEURULAE or NEURULAS]\n",
  "NEURULAE": "NEURULA, (Greek) an embryo at the stage succeeding the gastrula, when the neural tube develops from the neural plate [n]\n",
  "NEURULAR": "of or like a neurula, an embryo at the stage succeeding the gastrula [adj]\n",
  "NEURULAS": "NEURULA, (Greek) an embryo at the stage succeeding the gastrula, when the neural tube develops from the neural plate [n]\n",
  "NEURULATION": "the formation of a neurula [n -S]\n",
  "NEURULATIONS": "NEURULATION, the formation of a neurula [n]\n",
  "NEURYPNOLOGIES": "NEURYPNOLOGY, an old name for the science of hypnotism, also NEUROHYPNOLOGY [n]\n",
  "NEURYPNOLOGY": "an old name for the science of hypnotism, also NEUROHYPNOLOGY [n NEURYPNOLOGIES]\n",
  "NEUSTIC": "the part of the sentence that differs with the mood of the sentence [n -S]\n",
  "NEUSTICS": "NEUSTIC, the part of the sentence that differs with the mood of the sentence [n]\n",
  "NEUSTON": "(Greek) the aggregate of minute aquatic organisms that inhabit the surface of a body of water [n -S]\n",
  "NEUSTONIC": "of or like neuston, minute organisms floating or swimming on water's surface, also NEUSTIC [adj]\n",
  "NEUSTONS": "NEUSTON, (Greek) the aggregate of minute aquatic organisms that inhabit the surface of a body of water [n]\n",
  "NEUTER": "to castrate [v -ED, -ING, -S]\n",
  "NEUTERED": "NEUTER, to castrate [v]\n",
  "NEUTERING": "the act of castrating [n -S]\n",
  "NEUTERINGS": "NEUTERING, the act of castrating [n]\n",
  "NEUTERS": "NEUTER, to castrate [v]\n",
  "NEUTRAL": "taking no part on either side [adj NEUTRALLY] / one that is impartial [n -S]\n",
  "NEUTRALISATION": "the act of neutralising, also NEUTRALIZATION [n -S]\n",
  "NEUTRALISATIONS": "NEUTRALISATION, the act of neutralising, also NEUTRALIZATION [n]\n",
  "NEUTRALISE": "to render neutral, also NEUTRALIZE [v NEUTRALISED, NEUTRALISING, NEUTRALISES]\n",
  "NEUTRALISED": "NEUTRALISE, to render neutral, also NEUTRALIZE [v]\n",
  "NEUTRALISER": "something or someone that neutralises, also NEUTRALIZER [n -S]\n",
  "NEUTRALISERS": "NEUTRALISER, something or someone that neutralises, also NEUTRALIZER [n]\n",
  "NEUTRALISES": "NEUTRALISE, to render neutral, also NEUTRALIZE [v]\n",
  "NEUTRALISING": "NEUTRALISE, to render neutral, also NEUTRALIZE [v]\n",
  "NEUTRALISM": "a position or doctrine of neutrality [n -S]\n",
  "NEUTRALISMS": "NEUTRALISM, a position or doctrine of neutrality [n]\n",
  "NEUTRALIST": "a neutral; one who professes or practices neutrality [n -S]\n",
  "NEUTRALISTIC": "relating to neutralism [adj]\n",
  "NEUTRALISTS": "NEUTRALIST, a neutral; one who professes or practices neutrality [n]\n",
  "NEUTRALITIES": "NEUTRALITY, the state of being neutral [n]\n",
  "NEUTRALITY": "the state of being neutral [n NEUTRALITIES]\n",
  "NEUTRALIZATION": "the act of neutralizing, also NEUTRALISATION [n -S]\n",
  "NEUTRALIZATIONS": "NEUTRALIZATION, the act of neutralizing, also NEUTRALISATION [n]\n",
  "NEUTRALIZE": "to render neutral, also NEUTRALISE [v NEUTRALIZED, NEUTRALIZING, NEUTRALIZES]\n",
  "NEUTRALIZED": "NEUTRALIZE, to render neutral, also NEUTRALISE [v]\n",
  "NEUTRALIZER": "something or someone that neutralizes, also NEUTRALISER [n -S]\n",
  "NEUTRALIZERS": "NEUTRALIZER, something or someone that neutralizes, also NEUTRALISER [n]\n",
  "NEUTRALIZES": "NEUTRALIZE, to render neutral, also NEUTRALISE [v]\n",
  "NEUTRALIZING": "NEUTRALIZE, to render neutral, also NEUTRALISE [v]\n",
  "NEUTRALLY": "NEUTRAL, taking no part on either side [adv]\n",
  "NEUTRALNESS": "the state of being neutral [n -ES]\n",
  "NEUTRALNESSES": "NEUTRALNESS, the state of being neutral [n]\n",
  "NEUTRALS": "NEUTRAL, one that is impartial [n]\n",
  "NEUTRETTO": "a name suggested for a neutral meson; a type of neutrino [n -S]\n",
  "NEUTRETTOS": "NEUTRETTO, a name suggested for a neutral meson; a type of neutrino [n]\n",
  "NEUTRINO": "an uncharged subatomic particle with zero mass when at rest [n -S]\n",
  "NEUTRINOLESS": "without neutrinos [adj]\n",
  "NEUTRINOS": "NEUTRINO, an uncharged subatomic particle with zero mass when at rest [n]\n",
  "NEUTRON": "a particle in the nucleus of an atom, which is without electrical charge and with approximately the same mass as a proton [n -S]\n",
  "NEUTRONIC": "of or like a neutron [adj]\n",
  "NEUTRONS": "NEUTRON, a particle in the nucleus of an atom, which is without electrical charge and with approximately the same mass as a proton [n]\n",
  "NEUTROPENIA": "an abnormal reduction in the number of neutrophils in the blood, as seen in certain anaemias and leukaemias [n -S]\n",
  "NEUTROPENIAS": "NEUTROPENIA, an abnormal reduction in the number of neutrophils in the blood, as seen in certain anaemias and leukaemias [n]\n",
  "NEUTROPHIL": "a leukophyte that is easily stained, also NEUTROPHILE [n -S]\n",
  "NEUTROPHILE": "a leukophyte that is easily stained, also NEUTROPHIL [n -S]\n",
  "NEUTROPHILES": "NEUTROPHILE, a leukophyte that is easily stained, also NEUTROPHIL [n]\n",
  "NEUTROPHILIC": "of leukophytes, easily stained [adj]\n",
  "NEUTROPHILS": "NEUTROPHIL, a leukophyte that is easily stained, also NEUTROPHILE [n]\n",
  "NEVE": "(French) old compressed snow, aka firn [n -S]\n",
  "NEVEL": "(Scots) to pound with the fists, also KNEVELL [v NEVELLED, NEVELLING, NEVELS]\n",
  "NEVELLED": "NEVEL, (Scots) to pound with the fists, also KNEVELL [v]\n",
  "NEVELLING": "NEVEL, (Scots) to pound with the fists, also KNEVELL [v]\n",
  "NEVELS": "NEVEL, (Scots) to pound with the fists, also KNEVELL [v]\n",
  "NEVER": "at no time [adv]\n",
  "NEVERMIND": "(US) a matter of importance [n -S]\n",
  "NEVERMINDS": "NEVERMIND, (US) a matter of importance [n]\n",
  "NEVERMORE": "never again, also NATHEMO, NATHEMORE [adv]\n",
  "NEVERTHELESS": "in spite of that, also NATHELESS, NATHELESSE, NATHLESS, NAYTHLES, NETHELESS [adv]\n",
  "NEVERTHEMORE": "none the more [adv]\n",
  "NEVES": "NEVE, (French) old compressed snow, aka firn [n]\n",
  "NEVI": "NEVUS, (Latin) a birthmark, also NAEVE, NAEVUS [n]\n",
  "NEVOID": "of or like a nevus, a birthmark [adj]\n",
  "NEVUS": "(Latin) a birthmark, also NAEVE, NAEVUS [n NEVI]\n",
  "NEW": "of recent origin [adj NEWER, NEWEST, NEWLY] / to renew [v -ED, -ING, -S]\n",
  "NEWB": "a newbie, also NEWBIE [n NEWBS]\n",
  "NEWBIE": "a new arrival such as on the Internet, also NEWB [n -S]\n",
  "NEWBIES": "NEWBIE, a new arrival such as on the Internet, also NEWB [n]\n",
  "NEWBORN": "a recently born baby [n -S]\n",
  "NEWBORNS": "NEWBORN, a recently born baby [n]\n",
  "NEWBS": "NEWB, a newbie, also NEWBIE [n]\n",
  "NEWCOME": "recently arrived [adj]\n",
  "NEWCOMER": "one who has recently arrived [n -S]\n",
  "NEWCOMERS": "NEWCOMER, one who has recently arrived [n]\n",
  "NEWED": "NEW, to renew [v]\n",
  "NEWEL": "a post supporting the handrail of a staircase [n -S]\n",
  "NEWELL": "(Spenser) a new thing [n -S]\n",
  "NEWELLED": "having a newel, an upright column in the middle of a circular staircase [adj]\n",
  "NEWELLS": "NEWELL, (Spenser) a new thing [n]\n",
  "NEWELS": "NEWEL, a post supporting the handrail of a staircase [n]\n",
  "NEWER": "NEW, of recent origin [adj]\n",
  "NEWEST": "NEW, of recent origin [adj]\n",
  "NEWFANGLE": "an excessively or ostentatiously modern thing [n -S]\n",
  "NEWFANGLED": "excessively or ostentatiously modern [adj NEWFANGLEDLY]\n",
  "NEWFANGLEDLY": "NEWFANGLED, excessively or ostentatiously modern [adv]\n",
  "NEWFANGLEDNESS": "the state of being newfangled [n]\n",
  "NEWFANGLENESS": "the state of being newfangled [n -ES]\n",
  "NEWFANGLENESSES": "NEWFANGLENESS, the state of being newfangled [n]\n",
  "NEWFANGLES": "NEWFANGLE, an excessively or ostentatiously modern thing [n]\n",
  "NEWFOUND": "newly found [adj]\n",
  "NEWIE": "(Australian slang) a newcomer [n -S]\n",
  "NEWIES": "NEWIE, (Australian slang) a newcomer [n]\n",
  "NEWING": "NEW, to renew [v]\n",
  "NEWISH": "somewhat new [adj NEWISHLY]\n",
  "NEWISHLY": "NEWISH, somewhat new [adv]\n",
  "NEWISHNESS": "the state of being somewhat new [n -ES]\n",
  "NEWISHNESSES": "NEWISHNESS, the state of being somewhat new [n]\n",
  "NEWLY": "NEW, of recent origin [adv]\n",
  "NEWLYWED": "a person recently married [n -S]\n",
  "NEWLYWEDS": "NEWLYWED, a person recently married [n]\n",
  "NEWMARKET": "a long, closely fitting cloak [n -S]\n",
  "NEWMARKETS": "NEWMARKET, a long, closely fitting cloak [n]\n",
  "NEWMOWN": "recently mown [adj]\n",
  "NEWNESS": "the state of being new [n -ES]\n",
  "NEWNESSES": "NEWNESS, the state of being new [n]\n",
  "NEWS": "to report recent events [v -ED, -ING, -ES]\n",
  "NEWSAGENCIES": "NEWSAGENCY, an agency that collects and distributes news [n]\n",
  "NEWSAGENCY": "an agency that collects and distributes news [n NEWSAGENCIES]\n",
  "NEWSAGENT": "one who sells newspapers etc. [n -S]\n",
  "NEWSAGENTS": "NEWSAGENT, one who sells newspapers etc. [n]\n",
  "NEWSBEAT": "a news source that a reporter is assigned to cover [n -S]\n",
  "NEWSBEATS": "NEWSBEAT, a news source that a reporter is assigned to cover [n]\n",
  "NEWSBOY": "a boy who delivers newspapers [n -S]\n",
  "NEWSBOYS": "NEWSBOY, a boy who delivers newspapers [n]\n",
  "NEWSBREAK": "a newsworthy event [n -S]\n",
  "NEWSBREAKS": "NEWSBREAK, a newsworthy event [n]\n",
  "NEWSCAST": "a news broadcast [n -S]\n",
  "NEWSCASTER": "one who reads news [n -S]\n",
  "NEWSCASTERS": "NEWSCASTER, one who reads news [n]\n",
  "NEWSCASTING": "the broadcasting of news [n -S]\n",
  "NEWSCASTINGS": "NEWSCASTING, the broadcasting of news [n]\n",
  "NEWSCASTS": "NEWSCAST, a news broadcast [n]\n",
  "NEWSCLIP": "a brief extract from broadcast or published news [n -S]\n",
  "NEWSCLIPS": "NEWSCLIP, a brief extract from broadcast or published news [n]\n",
  "NEWSDEALER": "(US) a newsagent [n -S]\n",
  "NEWSDEALERS": "NEWSDEALER, (US) a newsagent [n]\n",
  "NEWSDESK": "the department that receives late-breaking news [n -S]\n",
  "NEWSDESKS": "NEWSDESK, the department that receives late-breaking news [n]\n",
  "NEWSED": "NEWS, to report recent events [v]\n",
  "NEWSES": "NEWS, to report recent events [v]\n",
  "NEWSFEED": "a service that provides news articles for distribution [n -S]\n",
  "NEWSFEEDS": "NEWSFEED, a service that provides news articles for distribution [n]\n",
  "NEWSFLASH": "a brief preliminary dispatch about news just becoming known [n -ES]\n",
  "NEWSFLASHES": "NEWSFLASH, a brief preliminary dispatch about news just becoming known [n]\n",
  "NEWSGIRL": "a girl who delivers or sells newspapers [n -S]\n",
  "NEWSGIRLS": "NEWSGIRL, a girl who delivers or sells newspapers [n]\n",
  "NEWSGROUP": "a group on the Internet who subscribe to receive mail on a particular topic [n -S]\n",
  "NEWSGROUPS": "NEWSGROUP, a group on the Internet who subscribe to receive mail on a particular topic [n]\n",
  "NEWSHAWK": "a newspaper reporter [n -S]\n",
  "NEWSHAWKS": "NEWSHAWK, a newspaper reporter [n]\n",
  "NEWSHOUND": "(colloquial) a reporter [n -S]\n",
  "NEWSHOUNDS": "NEWSHOUND, (colloquial) a reporter [n]\n",
  "NEWSIE": "(US) a newsboy, also NEWSY [n -S]\n",
  "NEWSIER": "NEWSY, full of news [adj]\n",
  "NEWSIES": "NEWSIE, (US) a newsboy, also NEWSY [n]\n",
  "NEWSIEST": "NEWSY, full of news [adj]\n",
  "NEWSINESS": "the quality of being newsy [n -ES]\n",
  "NEWSINESSES": "NEWSINESS, the quality of being newsy [n]\n",
  "NEWSING": "NEWS, to report recent events [v]\n",
  "NEWSLESS": "without news [adj]\n",
  "NEWSLETTER": "a small publication (as a leaflet or newspaper) containing news of interest chiefly to a special group [n -S]\n",
  "NEWSLETTERS": "NEWSLETTER, a small publication (as a leaflet or newspaper) containing news of interest chiefly to a special group [n]\n",
  "NEWSMAGAZINE": "a usually weekly magazine devoted chiefly to summarizing and analyzing news [n -S]\n",
  "NEWSMAGAZINES": "NEWSMAGAZINE, a usually weekly magazine devoted chiefly to summarizing and analyzing news [n]\n",
  "NEWSMAKER": "a person whose activities are reported in news [n -S]\n",
  "NEWSMAKERS": "NEWSMAKER, a person whose activities are reported in news [n]\n",
  "NEWSMAN": "a news reporter [n NEWSMEN]\n",
  "NEWSMEN": "NEWSMAN, a news reporter [n]\n",
  "NEWSMONGER": "a person who deals in news; a gossip [n -S]\n",
  "NEWSMONGERS": "NEWSMONGER, a person who deals in news; a gossip [n]\n",
  "NEWSPAPER": "to work on a newspaper [v -ED, -ING, -S]\n",
  "NEWSPAPERDOM": "the world of newspapers [n -S]\n",
  "NEWSPAPERDOMS": "NEWSPAPERDOM, the world of newspapers [n]\n",
  "NEWSPAPERED": "NEWSPAPER, to work on a newspaper [v]\n",
  "NEWSPAPERING": "NEWSPAPER, to work on a newspaper [v]\n",
  "NEWSPAPERISM": "the system of having newspapers [n -S]\n",
  "NEWSPAPERISMS": "NEWSPAPERISM, the system of having newspapers [n]\n",
  "NEWSPAPERMAN": "a person who owns or is employed by a newspaper [n NEWSPAPERMEN]\n",
  "NEWSPAPERMEN": "NEWSPAPERMAN, a person who owns or is employed by a newspaper [n]\n",
  "NEWSPAPERS": "NEWSPAPER, to work on a newspaper [v]\n",
  "NEWSPAPERWOMAN": "a woman who owns or is employed by a newspaper [n NEWSPAPERWOMEN]\n",
  "NEWSPAPERWOMEN": "NEWSPAPERWOMAN, a woman who owns or is employed by a newspaper [n]\n",
  "NEWSPEAK": "deliberately ambiguous and contradictory language used to mislead and manipulate the public [n -S]\n",
  "NEWSPEAKS": "NEWSPEAK, deliberately ambiguous and contradictory language used to mislead and manipulate the public [n]\n",
  "NEWSPEOPLE": "people who report the news [n]\n",
  "NEWSPERSON": "a reporter [n NEWSPERSONS or NEWSPEOPLE]\n",
  "NEWSPERSONS": "NEWSPERSON, a reporter [n]\n",
  "NEWSPRINT": "inexpensive paper for printing newspapers on [n -S]\n",
  "NEWSPRINTS": "NEWSPRINT, inexpensive paper for printing newspapers on [n]\n",
  "NEWSREADER": "a news broadcaster [n -S]\n",
  "NEWSREADERS": "NEWSREADER, a news broadcaster [n]\n",
  "NEWSREEL": "a short movie presenting current events [n -S]\n",
  "NEWSREELS": "NEWSREEL, a short movie presenting current events [n]\n",
  "NEWSROOM": "a room where the news is gathered [n -S]\n",
  "NEWSROOMS": "NEWSROOM, a room where the news is gathered [n]\n",
  "NEWSSHEET": "a simple form of document or publication giving news and information [n -S]\n",
  "NEWSSHEETS": "NEWSSHEET, a simple form of document or publication giving news and information [n]\n",
  "NEWSSTAND": "a stand from which newspapers are sold [n -S]\n",
  "NEWSSTANDS": "NEWSSTAND, a stand from which newspapers are sold [n]\n",
  "NEWSTRADE": "the business of newsagents [n -S]\n",
  "NEWSTRADES": "NEWSTRADE, the business of newsagents [n]\n",
  "NEWSWEEKLIES": "NEWSWEEKLY, a weekly newspaper or magazine [n]\n",
  "NEWSWEEKLY": "a weekly newspaper or magazine [n NEWSWEEKLIES]\n",
  "NEWSWIRE": "a teleprinter which transmits news stories as they occur [n -S]\n",
  "NEWSWIRES": "NEWSWIRE, a teleprinter which transmits news stories as they occur [n]\n",
  "NEWSWOMAN": "a female newsman [n NEWSWOMEN]\n",
  "NEWSWOMEN": "NEWSWOMAN, a female newsman [n]\n",
  "NEWSWORTHIER": "NEWSWORTHY, interesting enough to the general public to warrant reporting [adj]\n",
  "NEWSWORTHIEST": "NEWSWORTHY, interesting enough to the general public to warrant reporting [adj]\n",
  "NEWSWORTHINESS": "the state of being newsworthy [n]\n",
  "NEWSWORTHY": "interesting enough to the general public to warrant reporting [adj NEWSWORTHIER, NEWSWORTHIEST]\n",
  "NEWSWRITING": "journalism [n -S]\n",
  "NEWSWRITINGS": "NEWSWRITING, journalism [n]\n",
  "NEWSY": "full of news [adj NEWSIER, NEWSIEST] / a newsagent; a newsboy, also NEWSIE [n NEWSIES]\n",
  "NEWT": "a tailed amphibian of the salamander family, also EWT [n -S]\n",
  "NEWTON": "a unit of force [n -S]\n",
  "NEWTONS": "NEWTON, a unit of force [n]\n",
  "NEWTS": "NEWT, a tailed amphibian of the salamander family, also EWT [n]\n",
  "NEWWAVER": "a member of a new-wave movement [n -S]\n",
  "NEWWAVERS": "NEWWAVER, a member of a new-wave movement [n]\n",
  "NEXT": "nearest [adj NEXTLY] / the next thing or person [n -S]\n",
  "NEXTDOOR": "located in the adjoining room or building [adj]\n",
  "NEXTLY": "NEXT, nearest [adv]\n",
  "NEXTNESS": "the state of being next [n -ES]\n",
  "NEXTNESSES": "NEXTNESS, the state of being next [n]\n",
  "NEXTS": "NEXT, the next thing or person [n]\n",
  "NEXUS": "(Latin) a link [n -ES]\n",
  "NEXUSES": "NEXUS, (Latin) a link [n]\n",
  "NGAI": "clan or tribe, as used before the names of certain Maori tribes [n]\n",
  "NGAIO": "(Maori) a New Zealand tree with white wood [n -S]\n",
  "NGAIOS": "NGAIO, (Maori) a New Zealand tree with white wood [n]\n",
  "NGANA": "(Zulu) a tropical disease of cattle transmitted by tsetse fly, also NAGANA [n -S]\n",
  "NGANAS": "NGANA, (Zulu) a tropical disease of cattle transmitted by tsetse fly, also NAGANA [n]\n",
  "NGARARA": "(Maori) a lizard found in New Zealand [n -S]\n",
  "NGARARAS": "NGARARA, (Maori) a lizard found in New Zealand [n]\n",
  "NGATI": "(Maori) a tribe or clan [n -S]\n",
  "NGATIS": "NGATI, (Maori) a tribe or clan [n]\n",
  "NGOMA": "(Swahili) a type of drum [n -S]\n",
  "NGOMAS": "NGOMA, (Swahili) a type of drum [n]\n",
  "NGULTRUM": "a monetary unit of Bhutan [n -S]\n",
  "NGULTRUMS": "NGULTRUM, a monetary unit of Bhutan [n]\n",
  "NGWEE": "(Bantu) a Zambian monetary unit, the hundredth part of a kwacha [n -S]\n",
  "NGWEES": "NGWEE, (Bantu) a Zambian monetary unit, the hundredth part of a kwacha [n]\n",
  "NHANDU": "(Tupi) the rhea, a South American ostrich, also NANDU, NANDOO [n -S]\n",
  "NHANDUS": "NHANDU, (Tupi) the rhea, a South American ostrich, also NANDU, NANDOO [n]\n",
  "NIACIN": "a nicotinic acid, a vitamin, a deficiency of which causes the disease pellagra [n -S]\n",
  "NIACINAMIDE": "a compound of the vitamin B complex [n -S]\n",
  "NIACINAMIDES": "NIACINAMIDE, a compound of the vitamin B complex [n]\n",
  "NIACINS": "NIACIN, a nicotinic acid, a vitamin, a deficiency of which causes the disease pellagra [n]\n",
  "NIAGARA": "a deluge or outpouring [n -S]\n",
  "NIAGARAS": "NIAGARA, a deluge or outpouring [n]\n",
  "NIAISERIE": "(French) simplicity; foolishness [n -S]\n",
  "NIAISERIES": "NIAISERIE, (French) simplicity; foolishness [n]\n",
  "NIALAMIDE": "a synthetic antidepressant drug [n -S]\n",
  "NIALAMIDES": "NIALAMIDE, a synthetic antidepressant drug [n]\n",
  "NIB": "to provide with a penpoint [v NIBBED, NIBBING, NIBS]\n",
  "NIBBED": "NIB, to provide with a penpoint [v]\n",
  "NIBBING": "NIB, to provide with a penpoint [v]\n",
  "NIBBLE": "to eat with small bites [v NIBBLED, NIBBLING, NIBBLES]\n",
  "NIBBLED": "NIBBLE, to eat with small bites [v]\n",
  "NIBBLER": "one who nibbles [n -S]\n",
  "NIBBLERS": "NIBBLER, one who nibbles [n]\n",
  "NIBBLES": "NIBBLE, to eat with small bites [v]\n",
  "NIBBLIES": "NIBBLY, a small food item [n]\n",
  "NIBBLING": "the act of biting gently [n -S]\n",
  "NIBBLINGLY": "NIBBLING [adv]\n",
  "NIBBLINGS": "NIBBLING, the act of biting gently [n]\n",
  "NIBBLY": "a small food item [n NIBBLIES]\n",
  "NIBLET": "a small piece of food, in particular a kernel of sweetcorn [n -S]\n",
  "NIBLETS": "NIBLET, a small piece of food, in particular a kernel of sweetcorn [n]\n",
  "NIBLICK": "an iron-headed golf club with a steeply angled face, for playing out of bunkers [n -S]\n",
  "NIBLICKS": "NIBLICK, an iron-headed golf club with a steeply angled face, for playing out of bunkers [n]\n",
  "NIBLIKE": "like a nib [adj]\n",
  "NIBS": "NIB, to provide with a penpoint [v]\n",
  "NICAD": "(short for) nickel-cadmium, as applied to batteries [n -S]\n",
  "NICADS": "NICAD, (short for) nickel-cadmium, as applied to batteries [n]\n",
  "NICCOLITE": "an arsenide of nickel, of a copper-red color and metallic luster [n -S]\n",
  "NICCOLITES": "NICCOLITE, an arsenide of nickel, of a copper-red color and metallic luster [n]\n",
  "NICE": "agreeable; precise [adj NICER, NICEST, NICELY]\n",
  "NICEISH": "somewhat nice [adj]\n",
  "NICELY": "NICE, agreeable; precise [adv]\n",
  "NICENESS": "the quality of being nice [n -ES]\n",
  "NICENESSES": "NICENESS, the quality of being nice [n]\n",
  "NICER": "NICE, agreeable; precise [adj]\n",
  "NICEST": "NICE, agreeable; precise [adj]\n",
  "NICETIES": "NICETY, a fine point or distinction [n]\n",
  "NICETY": "a fine point or distinction [n NICETIES]\n",
  "NICHE": "to place in a hollow [v NICHED, NICHING, NICHES]\n",
  "NICHED": "NICHE, to place in a hollow [v]\n",
  "NICHER": "(Scots) to neigh, also NICKER [v -ED, -ING, -S]\n",
  "NICHERED": "NICHER, (Scots) to neigh, also NICKER [v]\n",
  "NICHERING": "NICHER, (Scots) to neigh, also NICKER [v]\n",
  "NICHERS": "NICHER, (Scots) to neigh, also NICKER [v]\n",
  "NICHES": "NICHE, to place in a hollow [v]\n",
  "NICHING": "NICHE, to place in a hollow [v]\n",
  "NICHROME": "(tradename) an alloy of nickel and chrome [n -S]\n",
  "NICHROMES": "NICHROME, (tradename) an alloy of nickel and chrome [n]\n",
  "NICHT": "(Scots) night [n -S]\n",
  "NICHTS": "NICHT, (Scots) night [n]\n",
  "NICISH": "somewhat nice, also NICEISH [adj]\n",
  "NICK": "to make a shallow cut in [v -ED, -ING, -S]\n",
  "NICKAR": "the round seed of a tropical tree, used for playing marbles, also KNICKER, NICKERNUT [n -S]\n",
  "NICKARS": "NICKAR, the round seed of a tropical tree, used for playing marbles, also KNICKER, NICKERNUT [n]\n",
  "NICKED": "NICK, to make a shallow cut in [v]\n",
  "NICKEL": "to plate with a metallic element, also NICKLE [v NICKELED or NICKELLED, NICKELING or NICKELLING, NICKELS]\n",
  "NICKELED": "NICKEL, to plate with a metallic element, also NICKLE [v]\n",
  "NICKELIC": "pertaining to nickel [adj]\n",
  "NICKELIFEROUS": "bearing nickel [adj]\n",
  "NICKELINE": "(obsolete) an alloy of nickel, now called niccolite [n -S]\n",
  "NICKELINES": "NICKELINE, (obsolete) an alloy of nickel, now called niccolite [n]\n",
  "NICKELING": "NICKEL, to plate with a metallic element, also NICKLE [v]\n",
  "NICKELISE": "to plate with nickel, also NICKELIZE [v NICKELISED, NICKELISING, NICKELISES]\n",
  "NICKELISED": "NICKELISE, to plate with nickel, also NICKELIZE [v]\n",
  "NICKELISES": "NICKELISE, to plate with nickel, also NICKELIZE [v]\n",
  "NICKELISING": "NICKELISE, to plate with nickel, also NICKELIZE [v]\n",
  "NICKELIZE": "to plate with nickel, also NICKELISE [v NICKELIZED, NICKELIZING, NICKELIZES]\n",
  "NICKELIZED": "NICKELIZE, to plate with nickel, also NICKELISE [v]\n",
  "NICKELIZES": "NICKELIZE, to plate with nickel, also NICKELISE [v]\n",
  "NICKELIZING": "NICKELIZE, to plate with nickel, also NICKELISE [v]\n",
  "NICKELLED": "NICKEL, to plate with a metallic element, also NICKLE [v]\n",
  "NICKELLING": "NICKEL, to plate with a metallic element, also NICKLE [v]\n",
  "NICKELODEON": "an early form of cinema [n -S]\n",
  "NICKELODEONS": "NICKELODEON, an early form of cinema [n]\n",
  "NICKELOUS": "of bivalent nickel [adj]\n",
  "NICKELS": "NICKEL, to plate with a metallic element, also NICKLE [v]\n",
  "NICKER": "(Scots) to neigh, also NICHER [v -ED, -ING, -S]\n",
  "NICKERED": "NICKER, (Scots) to neigh, also NICHER [v]\n",
  "NICKERING": "NICKER, (Scots) to neigh, also NICHER [v]\n",
  "NICKERNUT": "the round seed of a tropical tree, used for playing marbles, also KNICKER, NICKAR [n -S]\n",
  "NICKERNUTS": "NICKERNUT, the round seed of a tropical tree, used for playing marbles, also KNICKER, NICKAR [n]\n",
  "NICKERS": "NICKER, (Scots) to neigh, also NICHER [v]\n",
  "NICKING": "NICK, to make a shallow cut in [v]\n",
  "NICKLE": "to plate with a metallic element, also NICKEL [v NICKLED, NICKLING, NICKLES]\n",
  "NICKLED": "NICKLE, to plate with a metallic element, also NICKEL [v]\n",
  "NICKLES": "NICKLE, to plate with a metallic element, also NICKEL [v]\n",
  "NICKLING": "NICKLE, to plate with a metallic element, also NICKEL [v]\n",
  "NICKNACK": "a small ornament, a gewgaw, also KNICKKNACK [n -S]\n",
  "NICKNACKS": "NICKNACK, a small ornament, a gewgaw, also KNICKKNACK [n]\n",
  "NICKNAME": "to give a pet name to [v NICKNAMED, NICKNAMING, NICKNAMES]\n",
  "NICKNAMED": "NICKNAME, to give a pet name to [v]\n",
  "NICKNAMER": "one who gives nicknames [n -S]\n",
  "NICKNAMERS": "NICKNAMER, one who gives nicknames [n]\n",
  "NICKNAMES": "NICKNAME, to give a pet name to [v]\n",
  "NICKNAMING": "NICKNAME, to give a pet name to [v]\n",
  "NICKPOINT": "a break of slope in a river profile, esp. where a new curve of erosion arising from rejuvenation intersects an earlier curve, also KNICKPOINT [n -S]\n",
  "NICKPOINTS": "NICKPOINT, a break of slope in a river profile, esp. where a new curve of erosion arising from rejuvenation intersects an earlier curve, also KNICKPOINT [n]\n",
  "NICKS": "NICK, to make a shallow cut in [v]\n",
  "NICKSTICK": "(archaic) a tally [n -S]\n",
  "NICKSTICKS": "NICKSTICK, (archaic) a tally [n]\n",
  "NICKUM": "(Scots) a mischievous boy [n -S]\n",
  "NICKUMPOOP": "a fool; a silly or stupid person, also NICOMPOOP, NINCOMPOOP [n -S]\n",
  "NICKUMPOOPS": "NICKUMPOOP, a fool; a silly or stupid person, also NICOMPOOP, NINCOMPOOP [n]\n",
  "NICKUMS": "NICKUM, (Scots) a mischievous boy [n]\n",
  "NICOISE": "made or garnished with tomatoes and olive oil, literally from Nice [adj]\n",
  "NICOL": "a crystal of calcium carbonate cut and cemented in such a way as to transmit only the extraordinary ray, used for polarising light [n -S]\n",
  "NICOLS": "NICOL, a crystal of calcium carbonate cut and cemented in such a way as to transmit only the extraordinary ray, used for polarising light [n]\n",
  "NICOMPOOP": "a fool; a silly or stupid person, also NICKUMPOOP, NINCOMPOOP [n -S]\n",
  "NICOMPOOPS": "NICOMPOOP, a fool; a silly or stupid person, also NICKUMPOOP, NINCOMPOOP [n]\n",
  "NICOTIAN": "a tobacco smoker [n -S]\n",
  "NICOTIANA": "any plant of the tobacco genus Nicotiana, of the family Solanaceae [n -S]\n",
  "NICOTIANAS": "NICOTIANA, any plant of the tobacco genus Nicotiana, of the family Solanaceae [n]\n",
  "NICOTIANS": "NICOTIAN, a tobacco smoker [n]\n",
  "NICOTIN": "a poisonous alkaloid in tobacco, also NICOTINE [n -S]\n",
  "NICOTINAMIDE": "a member of the vitamin B complex, deficiency of which can lead to the development of the disease pellagra [n -S]\n",
  "NICOTINAMIDES": "NICOTINAMIDE, a member of the vitamin B complex, deficiency of which can lead to the development of the disease pellagra [n]\n",
  "NICOTINE": "a poisonous alkaloid in tobacco, also NICOTIN [n -S]\n",
  "NICOTINED": "containing nicotine [adj]\n",
  "NICOTINES": "NICOTINE, a poisonous alkaloid in tobacco, also NICOTIN [n]\n",
  "NICOTINIC": "pertaining to, or derived from, nicotine [adj]\n",
  "NICOTINISM": "a morbid state induced by excessive use of tobacco [n -S]\n",
  "NICOTINISMS": "NICOTINISM, a morbid state induced by excessive use of tobacco [n]\n",
  "NICOTINS": "NICOTIN, a poisonous alkaloid in tobacco, also NICOTINE [n]\n",
  "NICROSILAL": "a cast-iron alloy containing nickel, chromium and silicon [n -S]\n",
  "NICROSILALS": "NICROSILAL, a cast-iron alloy containing nickel, chromium and silicon [n]\n",
  "NICTATE": "to wink [v NICTATED, NICTATING, NICTATES]\n",
  "NICTATED": "NICTATE, to wink [v]\n",
  "NICTATES": "NICTATE, to wink [v]\n",
  "NICTATING": "NICTATE, to wink [v]\n",
  "NICTATION": "the act of winking, also NICTITATION [n -S]\n",
  "NICTATIONS": "NICTATION, the act of winking, also NICTITATION [n]\n",
  "NICTITANT": "blinking [adj]\n",
  "NICTITATE": "to wink or blink [v NICTITATED, NICTITATING, NICTITATES]\n",
  "NICTITATED": "NICTITATE, to wink or blink [v]\n",
  "NICTITATES": "NICTITATE, to wink or blink [v]\n",
  "NICTITATING": "NICTITATE, to wink or blink [v]\n",
  "NICTITATION": "the act of winking, also NICTATION [n -S]\n",
  "NICTITATIONS": "NICTITATION, the act of winking, also NICTATION [n]\n",
  "NID": "a pheasant's nest or brood, also NIDE [n -S]\n",
  "NIDAL": "pertaining to a nest or nidus [adj]\n",
  "NIDAMENTA": "NIDAMENTUM, an egg-capsule [n]\n",
  "NIDAMENTAL": "nest-forming [adj]\n",
  "NIDAMENTUM": "an egg-capsule [n NIDAMENTA]\n",
  "NIDATE": "to become implanted in the uterus [v NIDATED, NIDATING, NIDATES]\n",
  "NIDATED": "NIDATE, to become implanted in the uterus [v]\n",
  "NIDATES": "NIDATE, to become implanted in the uterus [v]\n",
  "NIDATING": "NIDATE, to become implanted in the uterus [v]\n",
  "NIDATION": "the process by which the blastocyst becomes attached to the wall of the uterus [n -S]\n",
  "NIDATIONS": "NIDATION, the process by which the blastocyst becomes attached to the wall of the uterus [n]\n",
  "NIDDERING": "(Old English) an infamous person; an abject coward, also NIDDERLING, NIDERING, NIDERLING, NIDING, NITHING [n -S]\n",
  "NIDDERINGS": "NIDDERING, (Old English) an infamous person; an abject coward, also NIDDERLING, NIDERING, NIDERLING, NIDING, NITHING [n]\n",
  "NIDDERLING": "an infamous person; an abject coward, also NIDDERING, NIDERING, NIDERLING, NIDING, NITHING [n -S]\n",
  "NIDDERLINGS": "NIDDERLING, an infamous person; an abject coward, also NIDDERING, NIDERING, NIDERLING, NIDING, NITHING [n]\n",
  "NIDDICK": "(English dialect) the nape of the neck [n -S]\n",
  "NIDDICKS": "NIDDICK, (English dialect) the nape of the neck [n]\n",
  "NIDE": "to nest [v NIDED, NIDING, NIDES]\n",
  "NIDED": "NIDE, to nest [v]\n",
  "NIDERING": "an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERLING, NIDING, NITHING [n -S]\n",
  "NIDERINGS": "NIDERING, an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERLING, NIDING, NITHING [n]\n",
  "NIDERLING": "(Old English) an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERING, NIDING, NITHING [n -S]\n",
  "NIDERLINGS": "NIDERLING, (Old English) an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERING, NIDING, NITHING [n]\n",
  "NIDES": "NIDE, to nest [v]\n",
  "NIDGET": "to assist a woman in labour [v -ED, -ING, -S]\n",
  "NIDGETED": "NIDGET, to assist a woman in labour [v]\n",
  "NIDGETING": "NIDGET, to assist a woman in labour [v]\n",
  "NIDGETS": "NIDGET, to assist a woman in labour [v]\n",
  "NIDI": "NIDUS, (Latin) a breeding place [n]\n",
  "NIDICOLOUS": "remaining in the nest with the parents for a long time after birth [adj]\n",
  "NIDIFICATE": "to construct a nest [v NIDIFICATED, NIDIFICATING, NIDIFICATES]\n",
  "NIDIFICATED": "NIDIFICATE, to construct a nest [v]\n",
  "NIDIFICATES": "NIDIFICATE, to construct a nest [v]\n",
  "NIDIFICATING": "NIDIFICATE, to construct a nest [v]\n",
  "NIDIFICATION": "the act, process or technique of building a nest [n -S]\n",
  "NIDIFICATIONS": "NIDIFICATION, the act, process or technique of building a nest [n]\n",
  "NIDIFIED": "NIDIFY, to nest [v]\n",
  "NIDIFIES": "NIDIFY, to nest [v]\n",
  "NIDIFUGOUS": "leaving the nest soon after hatching [adj]\n",
  "NIDIFY": "to nest [v NIDIFIED, NIDIFYING, NIDIFIES]\n",
  "NIDIFYING": "NIDIFY, to nest [v]\n",
  "NIDING": "an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERING, NIDERLING, NITHING [n -S]\n",
  "NIDINGS": "NIDING, an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERING, NIDERLING, NITHING [n]\n",
  "NIDOR": "(Latin) the savory aroma of cooked food, esp. meat [n -S]\n",
  "NIDOROUS": "resembling the smell or taste of roast meat, or of corrupt animal matter [adj]\n",
  "NIDORS": "NIDOR, (Latin) the savory aroma of cooked food, esp. meat [n]\n",
  "NIDS": "NID, a pheasant's nest or brood, also NIDE [n]\n",
  "NIDULATION": "nest-building [n -S]\n",
  "NIDULATIONS": "NIDULATION, nest-building [n]\n",
  "NIDUS": "(Latin) a breeding place [n NIDUSES or NIDI]\n",
  "NIDUSES": "NIDUS, (Latin) a breeding place [n]\n",
  "NIE": "(obsolete) to nigh, approach, also NIGH, NY, NYE [v NIED, NYING, NIES]\n",
  "NIECE": "a daughter of one's brother of sister [n -S]\n",
  "NIECES": "NIECE, a daughter of one's brother of sister [n]\n",
  "NIED": "NY, to approach, also NIE, NIGH, NYE [v]\n",
  "NIEF": "(archaic) the fist, also NEAFE, NEAFFE, NEIF, NEIVE, NIEVE [n -S]\n",
  "NIEFS": "NIEF, (archaic) the fist, also NEAFE, NEAFFE, NEIF, NEIVE, NIEVE [n]\n",
  "NIELLATED": "inlaid in niello [adj]\n",
  "NIELLI": "NIELLO, (Italian) a black metallic substance [n]\n",
  "NIELLIST": "one who practices the style of ornamentation called niello [n -S]\n",
  "NIELLISTS": "NIELLIST, one who practices the style of ornamentation called niello [n]\n",
  "NIELLO": "(Italian) a black metallic substance [n NIELLOS or NIELLI] / to decorate with a black metallic substance [v -ED, -ING, -S]\n",
  "NIELLOED": "NIELLO, to decorate with a black metallic substance [v]\n",
  "NIELLOING": "NIELLO, to decorate with a black metallic substance [v]\n",
  "NIELLOS": "NIELLO, to decorate with a black metallic substance [v]\n",
  "NIENTE": "(Italian) softly fading away - used as a musical direction [adv]\n",
  "NIES": "NY, to approach, also NIE, NIGH, NYE [v]\n",
  "NIEVE": "(archaic) the fist, also NEAFE, NEAFFE, NEIF, NEIVE, NIEF [n -S]\n",
  "NIEVEFUL": "a closed handful [n -S]\n",
  "NIEVEFULS": "NIEVEFUL, a closed handful [n]\n",
  "NIEVES": "NIEVE, (archaic) the fist, also NEAFE, NEAFFE, NEIF, NEIVE, NIEF [n]\n",
  "NIFE": "the earth's hypothetical core of nickel and iron [n -S]\n",
  "NIFEDIPINE": "a coronary vasodilator used esp. in the treatment of angina pectoris [n -S]\n",
  "NIFEDIPINES": "NIFEDIPINE, a coronary vasodilator used esp. in the treatment of angina pectoris [n]\n",
  "NIFES": "NIFE, the earth's hypothetical core of nickel and iron [n]\n",
  "NIFF": "to smell bad [v -ED, -ING, -S]\n",
  "NIFFED": "NIFF, to smell bad [v]\n",
  "NIFFER": "(Scots) to barter, to haggle [v -ED, -ING, -S]\n",
  "NIFFERED": "NIFFER, (Scots) to barter, to haggle [v]\n",
  "NIFFERING": "NIFFER, (Scots) to barter, to haggle [v]\n",
  "NIFFERS": "NIFFER, (Scots) to barter, to haggle [v]\n",
  "NIFFIER": "NIFFY, smelly [adj]\n",
  "NIFFIEST": "NIFFY, smelly [adj]\n",
  "NIFFING": "NIFF, to smell bad [v]\n",
  "NIFFNAFF": "to trifle [v -ED, -ING, -S]\n",
  "NIFFNAFFED": "NIFFNAFF, to trifle [v]\n",
  "NIFFNAFFING": "NIFFNAFF, to trifle [v]\n",
  "NIFFNAFFS": "NIFFNAFF, to trifle [v]\n",
  "NIFFS": "NIFF, to smell bad [v]\n",
  "NIFFY": "smelly [adj NIFFIER, NIFFIEST]\n",
  "NIFTIER": "NIFTY, apt, agile; stylish [adj]\n",
  "NIFTIES": "NIFTY, a joke, a witty remark or story [n]\n",
  "NIFTIEST": "NIFTY, apt, agile; stylish [adj]\n",
  "NIFTILY": "NIFTY, apt, agile; stylish [adv]\n",
  "NIFTINESS": "the state of being nifty [n -ES]\n",
  "NIFTINESSES": "NIFTINESS, the state of being nifty [n]\n",
  "NIFTY": "apt, agile; stylish [adj NIFTIER, NIFTIEST, NIFTILY] / a joke, a witty remark or story [n NIFTIES]\n",
  "NIGELLA": "(Latin) a garden flower [n -S]\n",
  "NIGELLAS": "NIGELLA, (Latin) a garden flower [n]\n",
  "NIGER": "(obsolete) a negro, also NIGGER [n -S]\n",
  "NIGERS": "NIGER, (obsolete) a negro, also NIGGER [n]\n",
  "NIGGARD": "to act in a miserly way [v -ED, -ING, -S]\n",
  "NIGGARDED": "NIGGARD, to act in a miserly way [v]\n",
  "NIGGARDING": "NIGGARD, to act in a miserly way [v]\n",
  "NIGGARDISE": "(archaic) niggardliness, meanness, also NIGGARDIZE [n -S]\n",
  "NIGGARDISES": "NIGGARDISE, (archaic) niggardliness, meanness, also NIGGARDIZE [n]\n",
  "NIGGARDIZE": "(archaic) niggardliness, meanness, also NIGGARDISE [n -S]\n",
  "NIGGARDIZES": "NIGGARDIZE, (archaic) niggardliness, meanness, also NIGGARDISE [n]\n",
  "NIGGARDLIER": "NIGGARDLY, like a niggard, stingy [adj]\n",
  "NIGGARDLIEST": "NIGGARDLY, like a niggard, stingy [adj]\n",
  "NIGGARDLINESS": "the state of being niggardly [n -ES]\n",
  "NIGGARDLINESSES": "NIGGARDLINESS, the state of being niggardly [n]\n",
  "NIGGARDLY": "like a niggard, stingy [adj NIGGARDLIER, NIGGARDLIEST]\n",
  "NIGGARDS": "NIGGARD, to act in a miserly way [v]\n",
  "NIGGER": "to exhaust by overcropping; to char, blacken [v -ED, -ING, -S]\n",
  "NIGGERDOM": "(offensive) black people collectively [n -S]\n",
  "NIGGERDOMS": "NIGGERDOM, (offensive) black people collectively [n]\n",
  "NIGGERED": "NIGGER, to exhaust by overcropping; to char, blacken [v]\n",
  "NIGGERHEAD": "a nodule or boss of dark-coloured rock; an American river-mussel [n -S]\n",
  "NIGGERHEADS": "NIGGERHEAD, a nodule or boss of dark-coloured rock; an American river-mussel [n]\n",
  "NIGGERIER": "NIGGERY, (offensive) like a nigger [adj]\n",
  "NIGGERIEST": "NIGGERY, (offensive) like a nigger [adj]\n",
  "NIGGERING": "NIGGER, to exhaust by overcropping; to char, blacken [v]\n",
  "NIGGERISH": "(offensive) like a nigger [adj]\n",
  "NIGGERISM": "(offensive) an expression regarded as characteristic of a negro [n -S]\n",
  "NIGGERISMS": "NIGGERISM, (offensive) an expression regarded as characteristic of a negro [n]\n",
  "NIGGERLING": "a little Black person [n -S]\n",
  "NIGGERLINGS": "NIGGERLING, a little Black person [n]\n",
  "NIGGERS": "NIGGER, to exhaust by overcropping; to char, blacken [v]\n",
  "NIGGERY": "(offensive) like a nigger [adj NIGGERIER, NIGGERIEST]\n",
  "NIGGLE": "to worry over petty details [v NIGGLED, NIGGLING, NIGGLES]\n",
  "NIGGLED": "NIGGLE, to worry over petty details [v]\n",
  "NIGGLER": "one who niggles [n -S]\n",
  "NIGGLERS": "NIGGLER, one who niggles [n]\n",
  "NIGGLES": "NIGGLE, to worry over petty details [v]\n",
  "NIGGLIER": "NIGGLY, trifling [adj]\n",
  "NIGGLIEST": "NIGGLY, trifling [adj]\n",
  "NIGGLING": "petty or meticulous work [n -S]\n",
  "NIGGLINGLY": "NIGGLING [adv]\n",
  "NIGGLINGS": "NIGGLING, petty or meticulous work [n]\n",
  "NIGGLY": "trifling [adj NIGGLIER, NIGGLIEST]\n",
  "NIGH": "near [adj NIGHER, NIGHEST, NIGHLY] / to draw near to, also NIE, NY, NYE [v -ED, -ING, -S]\n",
  "NIGHED": "NIGH, to draw near to, also NIE, NY, NYE [v]\n",
  "NIGHER": "NIGH, near [adj]\n",
  "NIGHEST": "NIGH, near [adj]\n",
  "NIGHING": "NIGH, to draw near to, also NIE, NY, NYE [v]\n",
  "NIGHLY": "NIGH, near [adv]\n",
  "NIGHNESS": "(obsolete) nearness [n -ES]\n",
  "NIGHNESSES": "NIGHNESS, (obsolete) nearness [n]\n",
  "NIGHS": "NIGH, to draw near to, also NIE, NY, NYE [v]\n",
  "NIGHT": "the period from sunset to sunrise [n -S]\n",
  "NIGHTBIRD": "a bird that flies or sings at night [n -S]\n",
  "NIGHTBIRDS": "NIGHTBIRD, a bird that flies or sings at night [n]\n",
  "NIGHTBLIND": "unable to see in the dark [adj]\n",
  "NIGHTCAP": "a cap worn to bed; a drink taken last thing at night [n -S]\n",
  "NIGHTCAPS": "NIGHTCAP, a cap worn to bed; a drink taken last thing at night [n]\n",
  "NIGHTCLASS": "a class at night school [n -ES]\n",
  "NIGHTCLASSES": "NIGHTCLASS, a class at night school [n]\n",
  "NIGHTCLOTHES": "clothes worn for bed [n]\n",
  "NIGHTCLUB": "a club for drinking and entertainment, etc., open between evening and morning [n -S] / to visit nightclubs [v NIGHTCLUBBED, NIGHTCLUBBING, NIGHTCLUBS]\n",
  "NIGHTCLUBBED": "NIGHTCLUB, to visit nightclubs [v]\n",
  "NIGHTCLUBBER": "one who attends nightclubs [n -S]\n",
  "NIGHTCLUBBERS": "NIGHTCLUBBER, one who attends nightclubs [n]\n",
  "NIGHTCLUBBING": "visiting nightclubs [n -S]\n",
  "NIGHTCLUBBINGS": "NIGHTCLUBBING, visiting nightclubs [n]\n",
  "NIGHTCLUBS": "NIGHTCLUB, to visit nightclubs [v]\n",
  "NIGHTDRESS": "a garment worn at night [n -ES]\n",
  "NIGHTDRESSES": "NIGHTDRESS, a garment worn at night [n]\n",
  "NIGHTED": "benighted, lost in darkness [adj]\n",
  "NIGHTFALL": "the onset or beginning of the night [n -S]\n",
  "NIGHTFALLS": "NIGHTFALL, the onset or beginning of the night [n]\n",
  "NIGHTFARING": "travelling by night [adj]\n",
  "NIGHTFIRE": "a fire burning at night; a will-o'-the-wisp [n -S]\n",
  "NIGHTFIRES": "NIGHTFIRE, a fire burning at night; a will-o'-the-wisp [n]\n",
  "NIGHTGEAR": "clothes worn at night [n -S]\n",
  "NIGHTGEARS": "NIGHTGEAR, clothes worn at night [n]\n",
  "NIGHTGLOW": "an airglow seen during the night [n -S]\n",
  "NIGHTGLOWS": "NIGHTGLOW, an airglow seen during the night [n]\n",
  "NIGHTGOWN": "a gown worn for bed [n -S]\n",
  "NIGHTGOWNS": "NIGHTGOWN, a gown worn for bed [n]\n",
  "NIGHTHAWK": "the American nightjar [n -S]\n",
  "NIGHTHAWKS": "NIGHTHAWK, the American nightjar [n]\n",
  "NIGHTIE": "a nightgown, also NIGHTY [n -S]\n",
  "NIGHTIES": "NIGHTY, a nightgown, also NIGHTIE [n]\n",
  "NIGHTINGALE": "a small bird of the thrush family, celebrated for its song [n -S]\n",
  "NIGHTINGALES": "NIGHTINGALE, a small bird of the thrush family, celebrated for its song [n]\n",
  "NIGHTJAR": "a nocturnal bird with a distinctive churring call [n -S]\n",
  "NIGHTJARS": "NIGHTJAR, a nocturnal bird with a distinctive churring call [n]\n",
  "NIGHTLESS": "having no night [adj]\n",
  "NIGHTLIFE": "life that goes on at night [n NIGHTLIFES or NIGHTLIVES]\n",
  "NIGHTLIFES": "NIGHTLIFE, life that goes on at night [n]\n",
  "NIGHTLIKE": "like the night [adj]\n",
  "NIGHTLIVES": "NIGHTLIFE, life that goes on at night [n]\n",
  "NIGHTLONG": "lasting all night [adj]\n",
  "NIGHTLY": "taking place every night [adv]\n",
  "NIGHTMARE": "a bad dream [n -S]\n",
  "NIGHTMARES": "NIGHTMARE, a bad dream [n]\n",
  "NIGHTMARIER": "NIGHTMARY, like a nightmare, also NIGHTMARISH [adj]\n",
  "NIGHTMARIEST": "NIGHTMARY, like a nightmare, also NIGHTMARISH [adj]\n",
  "NIGHTMARISH": "like a nightmare, also NIGHTMARY [adj NIGHTMARISHLY]\n",
  "NIGHTMARISHLY": "NIGHTMARISH, like a nightmare, also NIGHTMARY [adv]\n",
  "NIGHTMARISHNESS": "NIGHTMARISH, like a nightmare, also NIGHTMARY [n]\n",
  "NIGHTMARY": "like a nightmare, also NIGHTMARISH [adj NIGHTMARIER, NIGHTMARIEST]\n",
  "NIGHTPIECE": "a work of art describing a night scene [n -S]\n",
  "NIGHTPIECES": "NIGHTPIECE, a work of art describing a night scene [n]\n",
  "NIGHTRIDER": "a member of a secret band of white men who carried out lynchings in the southern USA [n -S]\n",
  "NIGHTRIDERS": "NIGHTRIDER, a member of a secret band of white men who carried out lynchings in the southern USA [n]\n",
  "NIGHTRIDING": "the activity of a nightrider, a member of a secret band of white men who carried out lynchings in the southern USA [n -S]\n",
  "NIGHTRIDINGS": "NIGHTRIDING, the activity of a nightrider, a member of a secret band of white men who carried out lynchings in the southern USA [n]\n",
  "NIGHTS": "NIGHT, the period from sunset to sunrise [n]\n",
  "NIGHTSCOPE": "a device fitted to a rifle to gather light at night [n -S]\n",
  "NIGHTSCOPES": "NIGHTSCOPE, a device fitted to a rifle to gather light at night [n]\n",
  "NIGHTSHADE": "a name given to various plants, esp. of the Solanaceae family and chiefly poisonous or narcotic [n -S]\n",
  "NIGHTSHADES": "NIGHTSHADE, a name given to various plants, esp. of the Solanaceae family and chiefly poisonous or narcotic [n]\n",
  "NIGHTSHIRT": "a nightgown resembling a shirt [n -S]\n",
  "NIGHTSHIRTS": "NIGHTSHIRT, a nightgown resembling a shirt [n]\n",
  "NIGHTSIDE": "the dark, mysterious or gloomy side of anything [n -S]\n",
  "NIGHTSIDES": "NIGHTSIDE, the dark, mysterious or gloomy side of anything [n]\n",
  "NIGHTSPOT": "a nightclub [n -S]\n",
  "NIGHTSPOTS": "NIGHTSPOT, a nightclub [n]\n",
  "NIGHTSTAND": "a bedside table [n -S]\n",
  "NIGHTSTANDS": "NIGHTSTAND, a bedside table [n]\n",
  "NIGHTSTICK": "(US) a truncheon [n -S]\n",
  "NIGHTSTICKS": "NIGHTSTICK, (US) a truncheon [n]\n",
  "NIGHTTIDE": "the time during which it is night, also NIGHTTIME [n -S]\n",
  "NIGHTTIDES": "NIGHTTIDE, the time during which it is night, also NIGHTTIME [n]\n",
  "NIGHTTIME": "the time during which it is night, also NIGHTTIDE [n -S]\n",
  "NIGHTTIMES": "NIGHTTIME, the time during which it is night, also NIGHTTIDE [n]\n",
  "NIGHTWALKER": "a person who roams about at night esp. with criminal intent [n -S]\n",
  "NIGHTWALKERS": "NIGHTWALKER, a person who roams about at night esp. with criminal intent [n]\n",
  "NIGHTWARD": "approaching night [adv]\n",
  "NIGHTWATCHMAN": "a person who keeps watch at night [n NIGHTWATCHMEN]\n",
  "NIGHTWATCHMEN": "NIGHTWATCHMAN, a person who keeps watch at night [n]\n",
  "NIGHTWEAR": "clothes worn at night [n -S]\n",
  "NIGHTWEARS": "NIGHTWEAR, clothes worn at night [n]\n",
  "NIGHTY": "a nightgown, also NIGHTIE [n NIGHTIES]\n",
  "NIGIRI": "(Japanese) a small oval block of cold rice, wasabi and fish [n -S]\n",
  "NIGIRIS": "NIGIRI, (Japanese) a small oval block of cold rice, wasabi and fish [n]\n",
  "NIGRESCENCE": "blackness; dark colouring or pigmentation [n -S]\n",
  "NIGRESCENCES": "NIGRESCENCE, blackness; dark colouring or pigmentation [n]\n",
  "NIGRESCENT": "growing black; changing to a black color [adj]\n",
  "NIGRICANT": "of a blackish colour [adj]\n",
  "NIGRIFIED": "NIGRIFY, to blacken [v]\n",
  "NIGRIFIES": "NIGRIFY, to blacken [v]\n",
  "NIGRIFY": "to blacken [v NIGRIFIED, NIGRIFYING, NIGRIFIES]\n",
  "NIGRIFYING": "NIGRIFY, to blacken [v]\n",
  "NIGRITUDE": "the essential quality of the Negro genius, also NEGRITUDE [n -S]\n",
  "NIGRITUDES": "NIGRITUDE, the essential quality of the Negro genius, also NEGRITUDE [n]\n",
  "NIGROMANCIES": "NIGROMANCY, divination using black magic or the dead [n]\n",
  "NIGROMANCY": "divination using black magic or the dead [n NIGROMANCIES]\n",
  "NIGROSIN": "a blackish coal-tar colour dye, also NIGROSINE [n -S]\n",
  "NIGROSINE": "a blackish coal-tar colour dye, also NIGROSIN [n -S]\n",
  "NIGROSINES": "NIGROSINE, a blackish coal-tar colour dye, also NIGROSIN [n]\n",
  "NIGROSINS": "NIGROSIN, a blackish coal-tar colour dye, also NIGROSINE [n]\n",
  "NIHIL": "(Latin) nothing [n -S]\n",
  "NIHILISM": "a doctrine that denies traditional values [n -S]\n",
  "NIHILISMS": "NIHILISM, a doctrine that denies traditional values [n]\n",
  "NIHILIST": "an adherent of nihilism [n -S]\n",
  "NIHILISTIC": "relating to nihilism [adj]\n",
  "NIHILISTS": "NIHILIST, an adherent of nihilism [n]\n",
  "NIHILITIES": "NIHILITY, the state of being nothing [n]\n",
  "NIHILITY": "the state of being nothing [n NIHILITIES]\n",
  "NIHILS": "NIHIL, (Latin) nothing [n]\n",
  "NIHONGA": "(Japanese) a Japanese style of painting, using bright colours and traditional images [n -S]\n",
  "NIHONGAS": "NIHONGA, (Japanese) a Japanese style of painting, using bright colours and traditional images [n]\n",
  "NIHONIUM": "a highly radioactive element, of which only a few atoms have ever been produced [n -S]\n",
  "NIHONIUMS": "NIHONIUM, a highly radioactive element, of which only a few atoms have ever been produced [n]\n",
  "NIKAB": "a veil covering the face, worn by Muslim women, also NIQAAB, NIQAB [n -S]\n",
  "NIKABS": "NIKAB, a veil covering the face, worn by Muslim women, also NIQAAB, NIQAB [n]\n",
  "NIKAH": "in Islamic marriage, the contract between bride and bridegroom [n -S]\n",
  "NIKAHS": "NIKAH, in Islamic marriage, the contract between bride and bridegroom [n]\n",
  "NIKAU": "(Maori) a type of palm tree, native to New Zealand [n -S]\n",
  "NIKAUS": "NIKAU, (Maori) a type of palm tree, native to New Zealand [n]\n",
  "NIKETHAMIDE": "a drug used as a heart stimulant, aka coramine [n -S]\n",
  "NIKETHAMIDES": "NIKETHAMIDE, a drug used as a heart stimulant, aka coramine [n]\n",
  "NIL": "nothing [n -S]\n",
  "NILGAI": "(Hindi) a large antelope, also NILGAU, NILGHAI, NILGHAU, NYLGHAI, NYLGHAU [n -S]\n",
  "NILGAIS": "NILGAI, (Hindi) a large antelope, also NILGAU, NILGHAI, NILGHAU, NYLGHAI, NYLGHAU [n]\n",
  "NILGAU": "(Hindi) a kind of antelope, also NILGAI, NILGHAI, NILGHAU, NYLGHAI, NYLGHAU [n -S]\n",
  "NILGAUS": "NILGAU, (Hindi) a kind of antelope, also NILGAI, NILGHAI, NILGHAU, NYLGHAI, NYLGHAU [n]\n",
  "NILGHAI": "(Hindi) a kind of antelope, also NILGAI, NILGAU, NILGHAU, NYLGHAI, NYLGHAU [n -S]\n",
  "NILGHAIS": "NILGHAI, (Hindi) a kind of antelope, also NILGAI, NILGAU, NILGHAU, NYLGHAI, NYLGHAU [n]\n",
  "NILGHAU": "(Hindi) a kind of antelope, also NILGAI, NILGAU, NILGHAI, NYLGHAI, NYLGHAU [n -S]\n",
  "NILGHAUS": "NILGHAU, (Hindi) a kind of antelope, also NILGAI, NILGAU, NILGHAI, NYLGHAI, NYLGHAU [n]\n",
  "NILL": "to be unwilling [v NOULD or NOULDE or NILLED, NILLING, NILLS]\n",
  "NILLED": "NILL, to be unwilling [v]\n",
  "NILLING": "NILL, to be unwilling [v]\n",
  "NILLS": "NILL, to be unwilling [v]\n",
  "NILPOTENT": "a quantity which equals zero when multiplied by itself [n -S]\n",
  "NILPOTENTS": "NILPOTENT, a quantity which equals zero when multiplied by itself [n]\n",
  "NILS": "NIL, nothing [n]\n",
  "NIM": "to take or steal [v NIMMED, NIMMING, NIMS]\n",
  "NIMB": "(Hindi) an East Indian tree yielding an aromatic oil, also NEEM, NEEMB [n -S]\n",
  "NIMBED": "having a halo [adj]\n",
  "NIMBI": "NIMBUS, (Latin) a halo; a type of cloud [n]\n",
  "NIMBLE": "agile [adj NIMBLER, NIMBLEST, NIMBLY]\n",
  "NIMBLENESS": "the state of being nimble, also NIMBLESSE [n -ES]\n",
  "NIMBLENESSES": "NIMBLENESS, the state of being nimble, also NIMBLESSE [n]\n",
  "NIMBLER": "NIMBLE, agile [adj]\n",
  "NIMBLESSE": "(Spenser) quickness of motion in body or mind, also NIMBLENESS [n -S]\n",
  "NIMBLESSES": "NIMBLESSE, (Spenser) quickness of motion in body or mind, also NIMBLENESS [n]\n",
  "NIMBLEST": "NIMBLE, agile [adj]\n",
  "NIMBLEWIT": "an alert and clever person [n -S]\n",
  "NIMBLEWITS": "NIMBLEWIT, an alert and clever person [n]\n",
  "NIMBLEWITTED": "alert, intelligent [adj]\n",
  "NIMBLY": "NIMBLE, agile [adv]\n",
  "NIMBOSTRATI": "NIMBOSTRATUS, a type of cloud [n]\n",
  "NIMBOSTRATUS": "a type of cloud [n NIMBOSTRATI]\n",
  "NIMBS": "NIMB, (Hindi) an East Indian tree yielding an aromatic oil, also NEEM, NEEMB [n]\n",
  "NIMBUS": "(Latin) a halo; a type of cloud [n NIMBUSES or NIMBI]\n",
  "NIMBUSED": "surrounded with a nimbus, a halo [adj]\n",
  "NIMBUSES": "NIMBUS, (Latin) a halo; a type of cloud [n]\n",
  "NIMBYISM": "adherence to the doctrine of 'not in my back-yard', also NIMBYNESS [n -S]\n",
  "NIMBYISMS": "NIMBYISM, adherence to the doctrine of 'not in my back-yard', also NIMBYNESS [n]\n",
  "NIMBYNESS": "adherence to the doctrine of 'not in my backyard', also NIMBYISM [n -ES]\n",
  "NIMBYNESSES": "NIMBYNESS, adherence to the doctrine of 'not in my backyard', also NIMBYISM [n]\n",
  "NIMIETIES": "NIMIETY, excess [n]\n",
  "NIMIETY": "excess [n NIMIETIES]\n",
  "NIMIOUS": "overmuch, excessive; inordinate (now chiefly as a Scots legal term) [adj]\n",
  "NIMMED": "NIM, to take or steal [v]\n",
  "NIMMER": "a thief [n -S]\n",
  "NIMMERS": "NIMMER, a thief [n]\n",
  "NIMMING": "NIM, to take or steal [v]\n",
  "NIMONIC": "of alloys used in high-temperature work, e.g. gas turbine blades, chiefly nickel, with chromium, titanium and aluminium [adj]\n",
  "NIMPS": "(Liverpool dialect) easy [adj]\n",
  "NIMROD": "a hunter; a stupid person [n -S]\n",
  "NIMRODS": "NIMROD, a hunter; a stupid person [n]\n",
  "NIMS": "NIM, to take or steal [v]\n",
  "NINCOM": "(short for) nincompoop, also NINCUM [n -S]\n",
  "NINCOMPOOP": "a fool; a silly or stupid person, also NICKUMPOOP, NICOMPOOP [n -S]\n",
  "NINCOMPOOPERIES": "NINCOMPOOPERY, the state of being a nincompoop [n]\n",
  "NINCOMPOOPERY": "the state of being a nincompoop [n NINCOMPOOPERIES]\n",
  "NINCOMPOOPS": "NINCOMPOOP, a fool; a silly or stupid person, also NICKUMPOOP, NICOMPOOP [n]\n",
  "NINCOMS": "NINCOM, (short for) nincompoop, also NINCUM [n]\n",
  "NINCUM": "(short for) nincompoop, also NINCOM [n -S]\n",
  "NINCUMS": "NINCUM, (short for) nincompoop, also NINCOM [n]\n",
  "NINE": "the cardinal number above eight [n -S]\n",
  "NINEBARK": "a flowering shrub [n -S]\n",
  "NINEBARKS": "NINEBARK, a flowering shrub [n]\n",
  "NINEFOLD": "nine times as great [adj]\n",
  "NINEHOLES": "a game in which nine holes are made in the ground, into which a ball is bowled [n]\n",
  "NINEPENCE": "nine pennies [n -S]\n",
  "NINEPENCES": "NINEPENCE, nine pennies [n]\n",
  "NINEPENNIES": "NINEPENNY, a coin worth nine pence [n]\n",
  "NINEPENNY": "a coin worth nine pence [n NINEPENNIES]\n",
  "NINEPIN": "a wooden pin used in a bowling game [n -S]\n",
  "NINEPINS": "NINEPIN, a wooden pin used in a bowling game [n]\n",
  "NINER": "a student in the ninth grade [n -S]\n",
  "NINERS": "NINER, a student in the ninth grade [n]\n",
  "NINES": "NINE, the cardinal number above eight [n]\n",
  "NINESCORE": "nine times twenty [n -S]\n",
  "NINESCORES": "NINESCORE, nine times twenty [n]\n",
  "NINETEEN": "a number, ten and nine [n -S]\n",
  "NINETEENS": "NINETEEN, a number, ten and nine [n]\n",
  "NINETEENTH": "number nineteen in sequence [adj NINETEENTHLY] / a nineteenth part [n -S]\n",
  "NINETEENTHLIES": "NINETEENTHLY, a nineteenth thing in sequence [n]\n",
  "NINETEENTHLY": "a nineteenth thing in sequence [n NINETEENTHLIES]\n",
  "NINETEENTHS": "NINETEENTH, a nineteenth part [n]\n",
  "NINETIES": "NINETY, a number, nine times ten [n]\n",
  "NINETIETH": "the ordinal of ninety [adj] / one of ninety equal parts [n -S]\n",
  "NINETIETHS": "NINETIETH, one of ninety equal parts [n]\n",
  "NINETY": "a number, nine times ten [n NINETIES]\n",
  "NINHYDRIN": "a poisonous crystalline oxidizing agent used as an analytical reagent [n -S]\n",
  "NINHYDRINS": "NINHYDRIN, a poisonous crystalline oxidizing agent used as an analytical reagent [n]\n",
  "NINJA": "(Japanese) one of a body of trained assassins and spies in feudal Japan, skilled in ninjitsu [n -S]\n",
  "NINJAS": "NINJA, (Japanese) one of a body of trained assassins and spies in feudal Japan, skilled in ninjitsu [n]\n",
  "NINJITSU": "(Japanese) a martial art, teaching stealth and camouflage, also NINJUTSU [n -S]\n",
  "NINJITSUS": "NINJITSU, (Japanese) a martial art, teaching stealth and camouflage, also NINJUTSU [n]\n",
  "NINJUTSU": "(Japanese) a martial art, teaching stealth and camouflage, also NINJITSU [n -S]\n",
  "NINJUTSUS": "NINJUTSU, (Japanese) a martial art, teaching stealth and camouflage, also NINJITSU [n]\n",
  "NINNIES": "NINNY, a fool [n]\n",
  "NINNY": "a fool [n NINNIES]\n",
  "NINNYHAMMER": "a ninny, a foolish person [n -S]\n",
  "NINNYHAMMERS": "NINNYHAMMER, a ninny, a foolish person [n]\n",
  "NINNYISH": "like a ninny [adj]\n",
  "NINON": "(French) a sheer fabric [n -S]\n",
  "NINONS": "NINON, (French) a sheer fabric [n]\n",
  "NINTH": "one of nine equal parts [n -S]\n",
  "NINTHLY": "in the ninth place [adv]\n",
  "NINTHS": "NINTH, one of nine equal parts [n]\n",
  "NIOBATE": "a salt of niobium [n -S]\n",
  "NIOBATES": "NIOBATE, a salt of niobium [n]\n",
  "NIOBIC": "relating to the element niobium [adj]\n",
  "NIOBITE": "the chief ore of niobium, aka columbite [n -S]\n",
  "NIOBITES": "NIOBITE, the chief ore of niobium, aka columbite [n]\n",
  "NIOBIUM": "a metallic element, formerly called columbium [n -S]\n",
  "NIOBIUMS": "NIOBIUM, a metallic element, formerly called columbium [n]\n",
  "NIOBOUS": "containing niobium with a valency of less than five [adj]\n",
  "NIP": "to pinch lightly [v NIPPED, NIPPING, NIPS]\n",
  "NIPA": "(Malay) a low-growing East Indian palm, aka attap or atap [n -S]\n",
  "NIPAS": "NIPA, (Malay) a low-growing East Indian palm, aka attap or atap [n]\n",
  "NIPCHEESE": "(slang) a ship's purser; a skinflint [n -S]\n",
  "NIPCHEESES": "NIPCHEESE, (slang) a ship's purser; a skinflint [n]\n",
  "NIPPED": "NIP, to pinch lightly [v]\n",
  "NIPPER": "to seize two ropes together [v -ED, -ING, -S]\n",
  "NIPPERED": "NIPPER, to seize two ropes together [v]\n",
  "NIPPERING": "NIPPER, to seize two ropes together [v]\n",
  "NIPPERKIN": "(archaic) a small measure of alcoholic drink [n -S]\n",
  "NIPPERKINS": "NIPPERKIN, (archaic) a small measure of alcoholic drink [n]\n",
  "NIPPERS": "NIPPER, to seize two ropes together [v]\n",
  "NIPPIER": "NIPPY, quick [adj]\n",
  "NIPPIEST": "NIPPY, quick [adj]\n",
  "NIPPILY": "NIPPY, quick [adv]\n",
  "NIPPINESS": "the state of being nippy [n -ES]\n",
  "NIPPINESSES": "NIPPINESS, the state of being nippy [n]\n",
  "NIPPING": "NIP, to pinch lightly [v]\n",
  "NIPPINGLY": "NIPPING, NIP, to pinch lightly [adv]\n",
  "NIPPLE": "a small projection with an orifice, esp. for regulating flow [n -S] / to provide with a nipple [v NIPPLED, NIPPLING, NIPPLES]\n",
  "NIPPLED": "NIPPLE, to provide with a nipple [v]\n",
  "NIPPLES": "NIPPLE, to provide with a nipple [v]\n",
  "NIPPLEWORT": "a yellow-flowered composite herb, formerly used as an external application to the nipples of women [n -S]\n",
  "NIPPLEWORTS": "NIPPLEWORT, a yellow-flowered composite herb, formerly used as an external application to the nipples of women [n]\n",
  "NIPPLING": "NIPPLE, to provide with a nipple [v]\n",
  "NIPPY": "quick [adj NIPPIER, NIPPIEST, NIPPILY]\n",
  "NIPS": "NIP, to pinch lightly [v]\n",
  "NIPTER": "(Greek) an ecclesiastical ceremony of washing the feet [n -S]\n",
  "NIPTERS": "NIPTER, (Greek) an ecclesiastical ceremony of washing the feet [n]\n",
  "NIQAAB": "(Arabic) a veil worn by some Muslim women, also NIKAB, NIQAB [n -S]\n",
  "NIQAABS": "NIQAAB, (Arabic) a veil worn by some Muslim women, also NIKAB, NIQAB [n]\n",
  "NIQAB": "(Arabic) a veil covering the face, worn by Muslim women, also NIKAB, NIQAAB [n -S]\n",
  "NIQABS": "NIQAB, (Arabic) a veil covering the face, worn by Muslim women, also NIKAB, NIQAAB [n]\n",
  "NIRAMIAI": "(Japanese) in sumo wrestling, a period of stamping and glaring to cow the opponent [n -S]\n",
  "NIRAMIAIS": "NIRAMIAI, (Japanese) in sumo wrestling, a period of stamping and glaring to cow the opponent [n]\n",
  "NIRL": "(Scots) to stunt, shrivel [v -ED, -ING, -S]\n",
  "NIRLED": "(Scots) knotty, stunted, also NIRLIE, NIRLIT, NIRLY [adj]\n",
  "NIRLIE": "(Scots) knotty, stunted, also NIRLED, NIRLIT, NIRLY [adj NIRLIER, NIRLIEST]\n",
  "NIRLIER": "NIRLY, (Scots) knotty, stunted, also NIRLED, NIRLIE, NIRLIT [adj]\n",
  "NIRLIEST": "NIRLY, (Scots) knotty, stunted, also NIRLED, NIRLIE, NIRLIT [adj]\n",
  "NIRLING": "NIRL, (Scots) to stunt, shrivel [v]\n",
  "NIRLIT": "(Scots) knotty, stunted, also NIRLED, NIRLIE, NIRLY [adj]\n",
  "NIRLS": "NIRL, (Scots) to stunt, shrivel [v]\n",
  "NIRLY": "(Scots) knotty, stunted, also NIRLED, NIRLIE, NIRLIT [adj NIRLIER, NIRLIEST]\n",
  "NIRVANA": "(Sanskrit) freedom from the endless cycle of birth and death and related suffering, in Hindu and Buddhist religions [n -S]\n",
  "NIRVANAS": "NIRVANA, (Sanskrit) freedom from the endless cycle of birth and death and related suffering, in Hindu and Buddhist religions [n]\n",
  "NIRVANIC": "pertaining to Buddhism [adj]\n",
  "NIS": "in Scandinavian folklore, a brownie or goblin, also NISSE [n NISSES]\n",
  "NISBERRIES": "NISBERRY, an edible fruit, the sapodilla, also NASEBERRY, NEESBERRY [n]\n",
  "NISBERRY": "an edible fruit, the sapodilla, also NASEBERRY, NEESBERRY [n NISBERRIES]\n",
  "NISEI": "(Japanese) a second-generation Japanese immigrant [n -S]\n",
  "NISEIS": "NISEI, (Japanese) a second-generation Japanese immigrant [n]\n",
  "NISGUL": "(dialect) the smallest and weakest in a brood of chickens [n -S]\n",
  "NISGULS": "NISGUL, (dialect) the smallest and weakest in a brood of chickens [n]\n",
  "NISH": "(colloquial) nothing [n -ES]\n",
  "NISHES": "NISH, (colloquial) nothing [n]\n",
  "NISI": "(Latin) taking effect at a specified date unless cause is shown otherwise, as in decree nisi [adj]\n",
  "NISSE": "in Scandinavian folklore, a brownie or goblin, also NIS [n -S]\n",
  "NISSES": "NISSE, in Scandinavian folklore, a brownie or goblin, also NIS [n]\n",
  "NISUS": "(Latin) a mental or physical effort to attain an end, a striving [n NISUS]\n",
  "NIT": "the egg of a parasitic insect [n -S]\n",
  "NITCHIE": "(Canadian) an offensive term for a North American Indian [n -S]\n",
  "NITCHIES": "NITCHIE, (Canadian) an offensive term for a North American Indian [n]\n",
  "NITE": "(colloquial) night [n -S]\n",
  "NITER": "potassium nitrate or saltpetre, also NITRE [n -S]\n",
  "NITERIE": "(colloquial) a nightclub, also NITERY [n -S]\n",
  "NITERIES": "NITERIE, (colloquial) a nightclub, also NITERY [n]\n",
  "NITERS": "NITER, potassium nitrate or saltpetre, also NITRE [n]\n",
  "NITERY": "(colloquial) a nightclub, also NITERIE [n NITERIES]\n",
  "NITES": "NITE, (colloquial) night [n]\n",
  "NITHER": "(dialect) to shiver [v -ED, -ING, -S]\n",
  "NITHERED": "NITHER, (dialect) to shiver [v]\n",
  "NITHERING": "NITHER, (dialect) to shiver [v]\n",
  "NITHERS": "NITHER, (dialect) to shiver [v]\n",
  "NITHING": "(Old English) an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERING, NIDERLING, NIDING [n -S]\n",
  "NITHINGS": "NITHING, (Old English) an infamous person; an abject coward, also NIDDERING, NIDDERLING, NIDERING, NIDERLING, NIDING [n]\n",
  "NITID": "bright, shining [adj]\n",
  "NITINOL": "an alloy of nickel and titanium [n -S]\n",
  "NITINOLS": "NITINOL, an alloy of nickel and titanium [n]\n",
  "NITON": "an old name for the inert gas element radon [n -S]\n",
  "NITONS": "NITON, an old name for the inert gas element radon [n]\n",
  "NITPICK": "to fuss over petty details [v -ED, -ING, -S]\n",
  "NITPICKED": "NITPICK, to fuss over petty details [v]\n",
  "NITPICKER": "one who makes petty criticisms of minor details [n -S]\n",
  "NITPICKERS": "NITPICKER, one who makes petty criticisms of minor details [n]\n",
  "NITPICKIER": "NITPICKY, tending to nitpick [adj]\n",
  "NITPICKIEST": "NITPICKY, tending to nitpick [adj]\n",
  "NITPICKING": "the act of finding trifling fault with [n -S]\n",
  "NITPICKINGS": "NITPICKING, the act of finding trifling fault with [n]\n",
  "NITPICKS": "NITPICK, to fuss over petty details [v]\n",
  "NITPICKY": "tending to nitpick [adj NITPICKIER, NITPICKIEST]\n",
  "NITRAMINE": "a yellow crystalline explosive, aka tetryl [n -S]\n",
  "NITRAMINES": "NITRAMINE, a yellow crystalline explosive, aka tetryl [n]\n",
  "NITRANILINE": "any nitro-derivative of aniline [n -S]\n",
  "NITRANILINES": "NITRANILINE, any nitro-derivative of aniline [n]\n",
  "NITRATE": "a salt or ester of nitric acid [n -S] / to treat with nitrates [v NITRATED, NITRATING, NITRATES]\n",
  "NITRATED": "NITRATE, to treat with nitrates [v]\n",
  "NITRATES": "NITRATE, to treat with nitrates [v]\n",
  "NITRATINE": "a mineral occurring in transparent crystals, native sodium nitrate [n -S]\n",
  "NITRATINES": "NITRATINE, a mineral occurring in transparent crystals, native sodium nitrate [n]\n",
  "NITRATING": "NITRATE, to treat with nitrates [v]\n",
  "NITRATION": "conversion into a nitrate [n -S]\n",
  "NITRATIONS": "NITRATION, conversion into a nitrate [n]\n",
  "NITRATOR": "one that nitrates [n -S]\n",
  "NITRATORS": "NITRATOR, one that nitrates [n]\n",
  "NITRAZEPAM": "a hypnotic and tranquillizing drug used for the relief of insomnia [n -S]\n",
  "NITRAZEPAMS": "NITRAZEPAM, a hypnotic and tranquillizing drug used for the relief of insomnia [n]\n",
  "NITRE": "potassium nitrate or saltpetre, also NITER [n -S]\n",
  "NITREOUS": "as in nitreous silica, another name for quartz glass [adj]\n",
  "NITRES": "NITRE, potassium nitrate or saltpetre, also NITER [n]\n",
  "NITRIC": "containing nitrogen [adj]\n",
  "NITRID": "a compound of nitrogen with a more metallic element or radical, also NITRIDE [n -S]\n",
  "NITRIDE": "a compound of nitrogen with a more metallic element or radical, also NITRID [n -S] / to convert into such a compound [v NITRIDED, NITRIDING, NITRIDES]\n",
  "NITRIDED": "NITRIDE, to convert into such a compound [v]\n",
  "NITRIDES": "NITRIDE, to convert into such a compound [v]\n",
  "NITRIDING": "conversion into a nitride [n -S]\n",
  "NITRIDINGS": "NITRIDING, conversion into a nitride [n]\n",
  "NITRIDS": "NITRID, a compound of nitrogen with a more metallic element or radical, also NITRIDE [n]\n",
  "NITRIFIABLE": "that can be nitrified [adj]\n",
  "NITRIFICATION": "the oxidation (as by bacteria) of ammonium salts to nitrites and the further oxidation of nitrites to nitrates [n -S]\n",
  "NITRIFICATIONS": "NITRIFICATION, the oxidation (as by bacteria) of ammonium salts to nitrites and the further oxidation of nitrites to nitrates [n]\n",
  "NITRIFIED": "NITRIFY, to combine with nitrogen [v]\n",
  "NITRIFIER": "an agent employed in nitrification [n -S]\n",
  "NITRIFIERS": "NITRIFIER, an agent employed in nitrification [n]\n",
  "NITRIFIES": "NITRIFY, to combine with nitrogen [v]\n",
  "NITRIFY": "to combine with nitrogen [v NITRIFIED, NITRIFYING, NITRIFIES]\n",
  "NITRIFYING": "NITRIFY, to combine with nitrogen [v]\n",
  "NITRIL": "any organic cyanide compound in which an alkyl group is directly attached to the carbon of a cyanide group, also NITRILE [n -S]\n",
  "NITRILE": "any organic cyanide compound in which an alkyl group is directly attached to the carbon of a cyanide group, also NITRIL [n -S]\n",
  "NITRILES": "NITRILE, any organic cyanide compound in which an alkyl group is directly attached to the carbon of a cyanide group, also NITRIL [n]\n",
  "NITRILS": "NITRIL, any organic cyanide compound in which an alkyl group is directly attached to the carbon of a cyanide group, also NITRILE [n]\n",
  "NITRITE": "a salt of nitrous acid [n -S]\n",
  "NITRITES": "NITRITE, a salt of nitrous acid [n]\n",
  "NITRO": "(short for) nitroglycerine, an explosive [n -S]\n",
  "NITROBACTERIA": "NITROBACTERIUM, a bacterium that convert ammonium compounds into nitrites, and esp. those that convert nitrites into nitrates [n]\n",
  "NITROBACTERIUM": "a bacterium that convert ammonium compounds into nitrites, and esp. those that convert nitrites into nitrates [n NITROBACTERIA]\n",
  "NITROBENZENE": "a poisonous yellow oily liquid with an almond odor that is used esp. in chemical synthesis, as of aniline [n -S]\n",
  "NITROBENZENES": "NITROBENZENE, a poisonous yellow oily liquid with an almond odor that is used esp. in chemical synthesis, as of aniline [n]\n",
  "NITROCELLULOSE": "any of several esters of cellulose used esp. for making explosives, plastics, and varnishes [n -S]\n",
  "NITROCELLULOSES": "NITROCELLULOSE, any of several esters of cellulose used esp. for making explosives, plastics, and varnishes [n]\n",
  "NITROCHLOROFORM": "a toxic lachrymatory liquid used as a pesticide and a tear gas [n]\n",
  "NITROCOTTON": "guncotton, an explosive made from cotton soaked in nitric and sulphuric acids [n -S]\n",
  "NITROCOTTONS": "NITROCOTTON, guncotton, an explosive made from cotton soaked in nitric and sulphuric acids [n]\n",
  "NITROFURAN": "any of several furan derivatives used as bacteria-inhibiting agents [n -S]\n",
  "NITROFURANS": "NITROFURAN, any of several furan derivatives used as bacteria-inhibiting agents [n]\n",
  "NITROGELATIN": "an explosive, consisting mainly of nitroglycerine, that is used in the production of gelignite, also NITROGELATINE [n -S]\n",
  "NITROGELATINE": "an explosive, consisting mainly of nitroglycerine, that is used in the production of gelignite, also NITROGELATIN [n -S]\n",
  "NITROGELATINES": "NITROGELATINE, an explosive, consisting mainly of nitroglycerine, that is used in the production of gelignite, also NITROGELATIN [n]\n",
  "NITROGELATINS": "NITROGELATIN, an explosive, consisting mainly of nitroglycerine, that is used in the production of gelignite, also NITROGELATINE [n]\n",
  "NITROGEN": "a gaseous element [n -S]\n",
  "NITROGENASE": "an enzyme complex that catalyses nitrogen in the nitrogen fixation process [n -S]\n",
  "NITROGENASES": "NITROGENASE, an enzyme complex that catalyses nitrogen in the nitrogen fixation process [n]\n",
  "NITROGENISATION": "the process of nitrogenising, also NITROGENIZATION [n]\n",
  "NITROGENISE": "to combine or supply with nitrogen, also NITROGENIZE [v NITROGENISED, NITROGENISING, NITROGENISES]\n",
  "NITROGENISED": "NITROGENISE, to combine or supply with nitrogen, also NITROGENIZE [v]\n",
  "NITROGENISES": "NITROGENISE, to combine or supply with nitrogen, also NITROGENIZE [v]\n",
  "NITROGENISING": "NITROGENISE, to combine or supply with nitrogen, also NITROGENIZE [v]\n",
  "NITROGENIZATION": "the process of nitrogenizing, also NITROGENISATION [n]\n",
  "NITROGENIZE": "to combine or supply with nitrogen, also NITROGENISE [v NITROGENIZED, NITROGENIZING, NITROGENIZES]\n",
  "NITROGENIZED": "NITROGENIZE, to combine or supply with nitrogen, also NITROGENISE [v]\n",
  "NITROGENIZES": "NITROGENIZE, to combine or supply with nitrogen, also NITROGENISE [v]\n",
  "NITROGENIZING": "NITROGENIZE, to combine or supply with nitrogen, also NITROGENISE [v]\n",
  "NITROGENOUS": "containing nitrogen [adj]\n",
  "NITROGENS": "NITROGEN, a gaseous element [n]\n",
  "NITROGLYCERIN": "a powerful explosive, also NITROGLYCERINE [n -S]\n",
  "NITROGLYCERINE": "a powerful explosive, also NITROGLYCERIN [n -S]\n",
  "NITROGLYCERINES": "NITROGLYCERINE, a powerful explosive, also NITROGLYCERIN [n]\n",
  "NITROGLYCERINS": "NITROGLYCERIN, a powerful explosive, also NITROGLYCERINE [n]\n",
  "NITROLIC": "pertaining to a class of acids [adj]\n",
  "NITROMETER": "an instrument for measuring nitrogen and its compounds [n -S]\n",
  "NITROMETERS": "NITROMETER, an instrument for measuring nitrogen and its compounds [n]\n",
  "NITROMETHANE": "a liquid nitroparaffin used as an industrial solvent and as a fuel for rockets and high-performance engines [n -S]\n",
  "NITROMETHANES": "NITROMETHANE, a liquid nitroparaffin used as an industrial solvent and as a fuel for rockets and high-performance engines [n]\n",
  "NITROMETRIC": "relating to the use of a nitrometer, an instrument for measuring nitrogen and its compounds [adj]\n",
  "NITROPARAFFIN": "any of various nitro derivatives of alkanes [n -S]\n",
  "NITROPARAFFINS": "NITROPARAFFIN, any of various nitro derivatives of alkanes [n]\n",
  "NITROPHILOUS": "of plants, growing in a place where there is a good supply of nitrogen [adj]\n",
  "NITROS": "NITRO, (short for) nitroglycerine, an explosive [n]\n",
  "NITROSAMINE": "a liquid obtained from chloroacetic acid and sodium nitrate and used as a solvent and as a fuel [n -S]\n",
  "NITROSAMINES": "NITROSAMINE, a liquid obtained from chloroacetic acid and sodium nitrate and used as a solvent and as a fuel [n]\n",
  "NITROSATION": "conversion of ammonium salts into nitrites [n -S]\n",
  "NITROSATIONS": "NITROSATION, conversion of ammonium salts into nitrites [n]\n",
  "NITROSO": "containing nitrosyl [adj]\n",
  "NITROSYL": "the radical NO, called also the nitroso group [n -S]\n",
  "NITROSYLS": "NITROSYL, the radical NO, called also the nitroso group [n]\n",
  "NITROTOLUENE": "a nitro-derivative of toluene [n -S]\n",
  "NITROTOLUENES": "NITROTOLUENE, a nitro-derivative of toluene [n]\n",
  "NITROUS": "containing nitrogen [adj]\n",
  "NITROX": "a mixture of nitrogen and oxygen, used in underwater breathing apparatus [n -ES]\n",
  "NITROXES": "NITROX, a mixture of nitrogen and oxygen, used in underwater breathing apparatus [n]\n",
  "NITROXYL": "the group NO2, usually called the nitro group, also NITRYL [n -S]\n",
  "NITROXYLS": "NITROXYL, the group NO2, usually called the nitro group, also NITRYL [n]\n",
  "NITRY": "(obsolete) containing nitre [adj]\n",
  "NITRYL": "the group NO2, usually called the nitro group, also NITROXYL [n -S]\n",
  "NITRYLS": "NITRYL, the group NO2, usually called the nitro group, also NITROXYL [n]\n",
  "NITS": "NIT, the egg of a parasitic insect [n]\n",
  "NITTIER": "NITTY, full of nits [adj]\n",
  "NITTIEST": "NITTY, full of nits [adj]\n",
  "NITTY": "full of nits [adj NITTIER, NITTIEST]\n",
  "NITWIT": "a stupid person [n -S]\n",
  "NITWITS": "NITWIT, a stupid person [n]\n",
  "NITWITTED": "stupid [adj]\n",
  "NITWITTEDNESS": "NITWITTED, stupid [n]\n",
  "NITWITTEDNESSES": "NITWITTEDNESS, NITWITTED, stupid [n]\n",
  "NITWITTERIES": "NITWITTERY, the state of being a nitwit [n]\n",
  "NITWITTERY": "the state of being a nitwit [n NITWITTERIES]\n",
  "NIVAL": "pertaining to snow [adj]\n",
  "NIVATION": "weathering of rock when snow alternately freezes and thaws [n -S]\n",
  "NIVATIONS": "NIVATION, weathering of rock when snow alternately freezes and thaws [n]\n",
  "NIVEOUS": "resembling snow [adj]\n",
  "NIX": "to veto [v -ED, -ING, -ES] / a water sprite [n NIXE or NIXES]\n",
  "NIXE": "NIX, a water sprite [n]\n",
  "NIXED": "NIX, to veto [v]\n",
  "NIXER": "(Australian slang) a spare-time job [n -S]\n",
  "NIXERS": "NIXER, (Australian slang) a spare-time job [n]\n",
  "NIXES": "NIX, to veto [v]\n",
  "NIXIE": "a female nix or malignant water-spirit, also NIXY [n -S]\n",
  "NIXIES": "NIXY, a female nix or malignant water-spirit, also NIXIE [n]\n",
  "NIXING": "NIX, to veto [v]\n",
  "NIXY": "a female nix or malignant water-spirit, also NIXIE [n NIXIES]\n",
  "NIZAM": "(Hindi) the title of the native sovereigns of Hyderabad, in India, since 1719 [n -S]\n",
  "NIZAMATE": "(Hindi) the territory of a nizam [n -S]\n",
  "NIZAMATES": "NIZAMATE, (Hindi) the territory of a nizam [n]\n",
  "NIZAMS": "NIZAM, (Hindi) the title of the native sovereigns of Hyderabad, in India, since 1719 [n]\n",
  "NKOSI": "(South African) term of address to a superior [n -S]\n",
  "NKOSIS": "NKOSI, (South African) term of address to a superior [n]\n",
  "NO": "a negative reply or vote [n NOS or NOES]\n",
  "NOAH": "(Australian slang) a shark [n -S]\n",
  "NOAHS": "NOAH, (Australian slang) a shark [n]\n",
  "NOB": "a wealthy person [n -S]\n",
  "NOBBIER": "NOBBY, stylish, modish; elegant [adj]\n",
  "NOBBIEST": "NOBBY, stylish, modish; elegant [adj]\n",
  "NOBBILY": "NOBBY, stylish, modish; elegant [adv]\n",
  "NOBBINESS": "the state of being nobby, stylish [n -ES]\n",
  "NOBBINESSES": "NOBBINESS, the state of being nobby, stylish [n]\n",
  "NOBBLE": "to disable a racehorse [v NOBBLED, NOBBLING, NOBBLES]\n",
  "NOBBLED": "NOBBLE, to disable a racehorse [v]\n",
  "NOBBLER": "one who nobbles [n -S]\n",
  "NOBBLERS": "NOBBLER, one who nobbles [n]\n",
  "NOBBLES": "NOBBLE, to disable a racehorse [v]\n",
  "NOBBLING": "NOBBLE, to disable a racehorse [v]\n",
  "NOBBUT": "(dialect) only, except; nothing but [adj]\n",
  "NOBBY": "stylish, modish; elegant [adj NOBBIER, NOBBIEST, NOBBILY]\n",
  "NOBELIUM": "a name given to transuranic element 102 [n -S]\n",
  "NOBELIUMS": "NOBELIUM, a name given to transuranic element 102 [n]\n",
  "NOBILESSE": "(Spenser) nobility, nobleness, also NOBLESSE [n -S]\n",
  "NOBILESSES": "NOBILESSE, (Spenser) nobility, nobleness, also NOBLESSE [n]\n",
  "NOBILIARY": "of or relating to nobility [adj]\n",
  "NOBILITATE": "to ennoble [v NOBILITATED, NOBILITATING, NOBILITATES]\n",
  "NOBILITATED": "NOBILITATE, to ennoble [v]\n",
  "NOBILITATES": "NOBILITATE, to ennoble [v]\n",
  "NOBILITATING": "NOBILITATE, to ennoble [v]\n",
  "NOBILITATION": "the act of nobilitating, ennobling [n -S]\n",
  "NOBILITATIONS": "NOBILITATION, the act of nobilitating, ennobling [n]\n",
  "NOBILITIES": "NOBILITY, the social class composed of nobles [n]\n",
  "NOBILITY": "the social class composed of nobles [n NOBILITIES]\n",
  "NOBLE": "possessing qualities of excellence [adj NOBLER, NOBLEST, NOBLY] / a person of high birth, rank, or title [n -S]\n",
  "NOBLEMAN": "a noble [n NOBLEMEN]\n",
  "NOBLEMEN": "NOBLEMAN, a noble [n]\n",
  "NOBLENESS": "the state of being noble [n -ES]\n",
  "NOBLENESSES": "NOBLENESS, the state of being noble [n]\n",
  "NOBLER": "NOBLE, possessing qualities of excellence [adj]\n",
  "NOBLES": "NOBLE, a person of high birth, rank, or title [n]\n",
  "NOBLESSE": "(French) nobility, nobleness, also NOBILESSE [n -S]\n",
  "NOBLESSES": "NOBLESSE, (French) nobility, nobleness, also NOBILESSE [n]\n",
  "NOBLEST": "NOBLE, possessing qualities of excellence [adj]\n",
  "NOBLEWOMAN": "a woman of noble rank [n NOBLEWOMEN]\n",
  "NOBLEWOMEN": "NOBLEWOMAN, a woman of noble rank [n]\n",
  "NOBLY": "NOBLE, possessing qualities of excellence [adv]\n",
  "NOBODIES": "NOBODY, an unimportant person [n]\n",
  "NOBODY": "an unimportant person [n NOBODIES]\n",
  "NOBS": "NOB, a wealthy person [n]\n",
  "NOCAKE": "(Native American) a meal made from parched maize [n -S]\n",
  "NOCAKES": "NOCAKE, (Native American) a meal made from parched maize [n]\n",
  "NOCEBO": "(Latin) a harmless substance that induces harmful effects in patients having negative expectations [n -S]\n",
  "NOCEBOS": "NOCEBO, (Latin) a harmless substance that induces harmful effects in patients having negative expectations [n]\n",
  "NOCENT": "causing injury; harmful [adj NOCENTLY] / a person who is guilty [n -S]\n",
  "NOCENTLY": "hurtfully [adv]\n",
  "NOCENTS": "NOCENT, a person who is guilty [n]\n",
  "NOCHEL": "to repudiate the debts of someone, also NOTCHEL [v NOCHELED or NOCHELLED, NOCHELING or NOCHELLING, NOCHELS]\n",
  "NOCHELED": "NOCHEL, to repudiate the debts of someone, also NOTCHEL [v]\n",
  "NOCHELING": "NOCHEL, to repudiate the debts of someone, also NOTCHEL [v]\n",
  "NOCHELLED": "NOCHEL, to repudiate the debts of someone, also NOTCHEL [v]\n",
  "NOCHELLING": "NOCHEL, to repudiate the debts of someone, also NOTCHEL [v]\n",
  "NOCHELS": "NOCHEL, to repudiate the debts of someone, also NOTCHEL [v]\n",
  "NOCICEPTIVE": "sensitive to pain; causing pain [adj]\n",
  "NOCICEPTOR": "a receptor sensitive to pain, also NOCIRECEPTOR [n -S]\n",
  "NOCICEPTORS": "NOCICEPTOR, a receptor sensitive to pain, also NOCIRECEPTOR [n]\n",
  "NOCIRECEPTOR": "a receptor sensitive to pain, also NOCICEPTOR [n -S]\n",
  "NOCIRECEPTORS": "NOCIRECEPTOR, a receptor sensitive to pain, also NOCICEPTOR [n]\n",
  "NOCK": "to fit an arrow to a bowstring [v -ED, -ING, -S]\n",
  "NOCKED": "NOCK, to fit an arrow to a bowstring [v]\n",
  "NOCKET": "a light lunch, also NACKET [n -S]\n",
  "NOCKETS": "NOCKET, a light lunch, also NACKET [n]\n",
  "NOCKING": "NOCK, to fit an arrow to a bowstring [v]\n",
  "NOCKS": "NOCK, to fit an arrow to a bowstring [v]\n",
  "NOCTAMBULATION": "sleepwalking [n -S]\n",
  "NOCTAMBULATIONS": "NOCTAMBULATION, sleepwalking [n]\n",
  "NOCTAMBULISM": "somnambulism [n -S]\n",
  "NOCTAMBULISMS": "NOCTAMBULISM, somnambulism [n]\n",
  "NOCTAMBULIST": "a sleepwalker, a somnambulist [n -S]\n",
  "NOCTAMBULISTS": "NOCTAMBULIST, a sleepwalker, a somnambulist [n]\n",
  "NOCTILIO": "any member of the South American genus Noctilio, the harelipped bat [n -S]\n",
  "NOCTILIOS": "NOCTILIO, any member of the South American genus Noctilio, the harelipped bat [n]\n",
  "NOCTILUCA": "(Latin) a roughly spherical marine dinoflagellate of the genus Noctiluca, which is strongly phosphorescent [n NOCTILUCAE or NOCTILUCAS]\n",
  "NOCTILUCAE": "NOCTILUCA, (Latin) a roughly spherical marine dinoflagellate of the genus Noctiluca, which is strongly phosphorescent [n]\n",
  "NOCTILUCAS": "NOCTILUCA, (Latin) a roughly spherical marine dinoflagellate of the genus Noctiluca, which is strongly phosphorescent [n]\n",
  "NOCTILUCENCE": "the quality of being noctilucent, shining in the dark [n -S]\n",
  "NOCTILUCENCES": "NOCTILUCENCE, the quality of being noctilucent, shining in the dark [n]\n",
  "NOCTILUCENT": "shining in the dark, often used of clouds that are luminous at night, also NOCTILUCOUS [adj]\n",
  "NOCTILUCOUS": "shining in the dark, often used of clouds that are luminous at night, also NOCTILUCENT [adj]\n",
  "NOCTIVAGANT": "someone who wanders in the night [n -S]\n",
  "NOCTIVAGANTS": "NOCTIVAGANT, someone who wanders in the night [n]\n",
  "NOCTIVAGATION": "wandering around at night [n -S]\n",
  "NOCTIVAGATIONS": "NOCTIVAGATION, wandering around at night [n]\n",
  "NOCTIVAGOUS": "wandering in the night, also NOCTIVAGANT [adj]\n",
  "NOCTUA": "(Latin) a general name for any moth of the family Noctuidae [n -S]\n",
  "NOCTUARIES": "NOCTUARY, a diary for night jottings [n]\n",
  "NOCTUARY": "a diary for night jottings [n NOCTUARIES]\n",
  "NOCTUAS": "NOCTUA, (Latin) a general name for any moth of the family Noctuidae [n]\n",
  "NOCTUID": "a night-flying moth [n -S]\n",
  "NOCTUIDS": "NOCTUID, a night-flying moth [n]\n",
  "NOCTULE": "a large bat [n -S]\n",
  "NOCTULES": "NOCTULE, a large bat [n]\n",
  "NOCTUOID": "one of a family of night-flying moths [n -S]\n",
  "NOCTUOIDS": "NOCTUOID, one of a family of night-flying moths [n]\n",
  "NOCTURIA": "excessive urination during the night [n -S]\n",
  "NOCTURIAS": "NOCTURIA, excessive urination during the night [n]\n",
  "NOCTURN": "any one of the three sections of the service of Matins [n -S]\n",
  "NOCTURNAL": "relating to night [adj NOCTURNALLY] / a nocturnal creature [n -S]\n",
  "NOCTURNALITIES": "NOCTURNALITY, being nocturnal [n]\n",
  "NOCTURNALITY": "being nocturnal [n NOCTURNALITIES]\n",
  "NOCTURNALLY": "NOCTURNAL, relating to night [adv]\n",
  "NOCTURNALS": "NOCTURNAL, a nocturnal creature [n]\n",
  "NOCTURNE": "(French) a musical composition of a dreamy character; a painting of a night scene [n -S]\n",
  "NOCTURNES": "NOCTURNE, (French) a musical composition of a dreamy character; a painting of a night scene [n]\n",
  "NOCTURNS": "NOCTURN, any one of the three sections of the service of Matins [n]\n",
  "NOCUOUS": "hurtful, noxious [adj NOCUOUSLY]\n",
  "NOCUOUSLY": "NOCUOUS, hurtful, noxious [adv]\n",
  "NOCUOUSNESS": "the quality of being nocuous [n -ES]\n",
  "NOCUOUSNESSES": "NOCUOUSNESS, the quality of being nocuous [n]\n",
  "NOD": "to give a quick forward motion of the head [v NODDED, NODDING, NODS]\n",
  "NODAL": "of the nature of a node [adj NODALLY]\n",
  "NODALISE": "to form nodes, also NODALIZE [v NODALISED, NODALISING, NODALISES]\n",
  "NODALISED": "NODALISE, to form nodes, also NODALIZE [v]\n",
  "NODALISES": "NODALISE, to form nodes, also NODALIZE [v]\n",
  "NODALISING": "NODALISE, to form nodes, also NODALIZE [v]\n",
  "NODALITIES": "NODALITY, the state of being nodal [n]\n",
  "NODALITY": "the state of being nodal [n NODALITIES]\n",
  "NODALIZE": "to form nodes, also NODALISE [v NODALIZED, NODALIZING, NODALIZES]\n",
  "NODALIZED": "NODALIZE, to form nodes, also NODALISE [v]\n",
  "NODALIZES": "NODALIZE, to form nodes, also NODALISE [v]\n",
  "NODALIZING": "NODALIZE, to form nodes, also NODALISE [v]\n",
  "NODALLY": "NODAL, of the nature of a node [adv]\n",
  "NODATED": "knotted [adj]\n",
  "NODATION": "the act of making a knot, or state of being knotted [n -S]\n",
  "NODATIONS": "NODATION, the act of making a knot, or state of being knotted [n]\n",
  "NODDED": "NOD, to give a quick forward motion of the head [v]\n",
  "NODDER": "one who nods; a drowsy person [n -S]\n",
  "NODDERS": "NODDER, one who nods; a drowsy person [n]\n",
  "NODDIER": "NODDY, easy to understand [adj]\n",
  "NODDIES": "NODDY, a fool [n]\n",
  "NODDIEST": "NODDY, easy to understand [adj]\n",
  "NODDING": "inclining, rocking [adj NODDINGLY] / the act of nodding [n -S]\n",
  "NODDINGLY": "NODDING, inclining, rocking [adv]\n",
  "NODDINGS": "NODDING, the act of nodding [n]\n",
  "NODDLE": "to nod frequently [v NODDLED, NODDLING, NODDLES]\n",
  "NODDLED": "NODDLE, to nod frequently [v]\n",
  "NODDLES": "NODDLE, to nod frequently [v]\n",
  "NODDLING": "NODDLE, to nod frequently [v]\n",
  "NODDY": "a fool [n NODDIES] / easy to understand [adj NODDIER, NODDIEST]\n",
  "NODE": "a swollen enlargement [n -S]\n",
  "NODES": "NODE, a swollen enlargement [n]\n",
  "NODI": "NODUS, (Latin) a knotty point, a difficulty [n]\n",
  "NODICAL": "pertaining to an astronomical point [adj]\n",
  "NODOSE": "having nodes, also NODOUS [adj]\n",
  "NODOSITIES": "NODOSITY, knottiness; a knotty swelling [n]\n",
  "NODOSITY": "knottiness; a knotty swelling [n NODOSITIES]\n",
  "NODOUS": "having nodes, also NODOSE [adj]\n",
  "NODS": "NOD, to give a quick forward motion of the head [v]\n",
  "NODULAR": "composed of nodules [adj]\n",
  "NODULATED": "having or characterized by nodular growths, esp. root nodules [adj]\n",
  "NODULATION": "the state of having nodules [n -S]\n",
  "NODULATIONS": "NODULATION, the state of having nodules [n]\n",
  "NODULE": "a little rounded lump or swelling [n -S]\n",
  "NODULED": "having a nodule or nodules [adj]\n",
  "NODULES": "NODULE, a little rounded lump or swelling [n]\n",
  "NODULOSE": "having small nodes or knots, also NODULOUS [adj]\n",
  "NODULOUS": "having small nodes or knots, also NODULOSE [adj]\n",
  "NODUS": "(Latin) a knotty point, a difficulty [n NODI]\n",
  "NOEL": "a Christmas carol [n -S]\n",
  "NOELS": "NOEL, a Christmas carol [n]\n",
  "NOEMATICAL": "of or pertaining to the understanding [adj NOEMATICALLY]\n",
  "NOEMATICALLY": "NOEMATICAL, of or pertaining to the understanding [adv]\n",
  "NOES": "NO, a negative reply or vote [n]\n",
  "NOESES": "NOESIS, (Greek) intellectual reasoning [n]\n",
  "NOESIS": "(Greek) intellectual reasoning [n NOESISES or NOESES]\n",
  "NOESISES": "NOESIS, (Greek) intellectual reasoning [n]\n",
  "NOETIC": "pertaining to reason [adj]\n",
  "NOG": "to fill a space in a wall with bricks [v NOGGED, NOGGING, NOGS]\n",
  "NOGAKU": "(Japanese) a traditional Japanese style of drama, aka noh [n NOGAKU]\n",
  "NOGG": "an eggnog or similar drink [n -S]\n",
  "NOGGED": "NOG, to fill a space in a wall with bricks [v]\n",
  "NOGGIN": "a small mug or cup; a measure of about a gill [n -S]\n",
  "NOGGING": "masonry or brickwork between wooden frame [n -S]\n",
  "NOGGINGS": "NOGGING, masonry or brickwork between wooden frame [n]\n",
  "NOGGINS": "NOGGIN, a small mug or cup; a measure of about a gill [n]\n",
  "NOGGS": "NOGG, an eggnog or similar drink [n]\n",
  "NOGOODNIK": "a worthless character [n -S]\n",
  "NOGOODNIKS": "NOGOODNIK, a worthless character [n]\n",
  "NOGS": "NOG, to fill a space in a wall with bricks [v]\n",
  "NOH": "(Japanese) the classical drama of Japan [n NOH]\n",
  "NOHOW": "in no way [adv]\n",
  "NOHOWISH": "out of sorts [adj]\n",
  "NOIL": "short fibers combed from long fibers during textile preparation [n -S]\n",
  "NOILIER": "NOILY, of or like noil [adj]\n",
  "NOILIES": "NOILY, a kind of dry white vermouth drink [n]\n",
  "NOILIEST": "NOILY, of or like noil [adj]\n",
  "NOILS": "NOIL, short fibers combed from long fibers during textile preparation [n]\n",
  "NOILY": "of or like noil [adj NOILIER, NOILIEST] / a kind of dry white vermouth drink [n NOILIES]\n",
  "NOINT": "to anoint [v -ED, -ING, -S]\n",
  "NOINTED": "NOINT, to anoint [v]\n",
  "NOINTER": "(Australian slang) a mischievous child, a rascal [n -S]\n",
  "NOINTERS": "NOINTER, (Australian slang) a mischievous child, a rascal [n]\n",
  "NOINTING": "NOINT, to anoint [v]\n",
  "NOINTS": "NOINT, to anoint [v]\n",
  "NOIR": "(French) a type of crime fiction [n -S]\n",
  "NOIRISH": "pertaining to noir, a type of crime fiction [adj]\n",
  "NOIRS": "NOIR, (French) a type of crime fiction [n]\n",
  "NOISE": "to spread as a rumour or report [v NOISED, NOISING, NOISES]\n",
  "NOISED": "NOISE, to spread as a rumour or report [v]\n",
  "NOISEFUL": "full of noise [adj]\n",
  "NOISELESS": "without noise [adj NOISELESSLY]\n",
  "NOISELESSLY": "NOISELESS, without noise [adv]\n",
  "NOISELESSNESS": "NOISELESS, without noise [n]\n",
  "NOISELESSNESSES": "NOISELESSNESS, NOISELESS, without noise [n]\n",
  "NOISEMAKER": "a device for making a loud noise at a football match, festivity etc. [n -S]\n",
  "NOISEMAKERS": "NOISEMAKER, a device for making a loud noise at a football match, festivity etc. [n]\n",
  "NOISEMAKING": "the act of making a noise [n -S]\n",
  "NOISEMAKINGS": "NOISEMAKING, the act of making a noise [n]\n",
  "NOISENIK": "a rock musician who performs loud harsh music [n -S]\n",
  "NOISENIKS": "NOISENIK, a rock musician who performs loud harsh music [n]\n",
  "NOISES": "NOISE, to spread as a rumour or report [v]\n",
  "NOISETTE": "(French) a small thick round slice of boneless meat, esp. lamb [n -S]\n",
  "NOISETTES": "NOISETTE, (French) a small thick round slice of boneless meat, esp. lamb [n]\n",
  "NOISIER": "NOISY, making loud sounds [adj]\n",
  "NOISIEST": "NOISY, making loud sounds [adj]\n",
  "NOISILY": "NOISY, making loud sounds [adv]\n",
  "NOISINESS": "the state of being noisy [n -ES]\n",
  "NOISINESSES": "NOISINESS, the state of being noisy [n]\n",
  "NOISING": "NOISE, to spread as a rumour or report [v]\n",
  "NOISOME": "noxious, unwholesome; offensive to the senses, esp. smell, also NOYSOME [adj NOISOMELY]\n",
  "NOISOMELY": "NOISOME, noxious, unwholesome; offensive to the senses, esp. smell, also NOYSOME [adv]\n",
  "NOISOMENESS": "the state of being noisome [n -ES]\n",
  "NOISOMENESSES": "NOISOMENESS, the state of being noisome [n]\n",
  "NOISY": "making loud sounds [adj NOISIER, NOISIEST, NOISILY]\n",
  "NOLE": "(Shakespeare) the top of the head, also NOLL, NOUL, NOULE, NOWL [n -S]\n",
  "NOLES": "NOLE, (Shakespeare) the top of the head, also NOLL, NOUL, NOULE, NOWL [n]\n",
  "NOLITION": "unwillingness [n -S]\n",
  "NOLITIONS": "NOLITION, unwillingness [n]\n",
  "NOLL": "the top of the head, also NOLE, NOUL, NOULE, NOWL [n -S]\n",
  "NOLLS": "NOLL, the top of the head, also NOLE, NOUL, NOULE, NOWL [n]\n",
  "NOLO": "(Latin) a type of legal plea, in full 'nolo contendere', a plea which accepts punishment without conceding guilt [n -S]\n",
  "NOLOS": "NOLO, (Latin) a type of legal plea, in full 'nolo contendere', a plea which accepts punishment without conceding guilt [n]\n",
  "NOM": "(French) a name [n -S]\n",
  "NOMA": "an ulceration of the cheek [n -S]\n",
  "NOMAD": "a member of a wandering pastoral community, also NOMADE [n -S]\n",
  "NOMADE": "a member of a wandering pastoral community, also NOMAD [n -S]\n",
  "NOMADES": "NOMADE, a member of a wandering pastoral community, also NOMAD [n]\n",
  "NOMADIC": "like a nomad [adj NOMADICALLY]\n",
  "NOMADICALLY": "NOMADIC, like a nomad [adv]\n",
  "NOMADIES": "NOMADY, the life of a nomad [n]\n",
  "NOMADISATION": "the act of nomadising, also NOMADIZATION [n -S]\n",
  "NOMADISATIONS": "NOMADISATION, the act of nomadising, also NOMADIZATION [n]\n",
  "NOMADISE": "to lead a nomadic life, also NOMADIZE [v NOMADISED, NOMADISING, NOMADISES]\n",
  "NOMADISED": "NOMADISE, to lead a nomadic life, also NOMADIZE [v]\n",
  "NOMADISES": "NOMADISE, to lead a nomadic life, also NOMADIZE [v]\n",
  "NOMADISING": "NOMADISE, to lead a nomadic life, also NOMADIZE [v]\n",
  "NOMADISM": "the mode of life of a nomad [n -S]\n",
  "NOMADISMS": "NOMADISM, the mode of life of a nomad [n]\n",
  "NOMADIZATION": "the act of nomadizing, also NOMADISATION [n -S]\n",
  "NOMADIZATIONS": "NOMADIZATION, the act of nomadizing, also NOMADISATION [n]\n",
  "NOMADIZE": "to lead a nomadic life, also NOMADISE [v NOMADIZED, NOMADIZING, NOMADIZES]\n",
  "NOMADIZED": "NOMADIZE, to lead a nomadic life, also NOMADISE [v]\n",
  "NOMADIZES": "NOMADIZE, to lead a nomadic life, also NOMADISE [v]\n",
  "NOMADIZING": "NOMADIZE, to lead a nomadic life, also NOMADISE [v]\n",
  "NOMADS": "NOMAD, a member of a wandering pastoral community, also NOMADE [n]\n",
  "NOMADY": "the life of a nomad [n NOMADIES]\n",
  "NOMARCH": "(Greek) the chief magistrate of a nome or nomarchy [n -S]\n",
  "NOMARCHIES": "NOMARCHY, (Greek) a province of modern Greece, also NOME [n]\n",
  "NOMARCHS": "NOMARCH, (Greek) the chief magistrate of a nome or nomarchy [n]\n",
  "NOMARCHY": "(Greek) a province of modern Greece, also NOME [n NOMARCHIES]\n",
  "NOMAS": "NOMA, an ulceration of the cheek [n]\n",
  "NOMBLES": "a deer's entrails, also NUMBLES, UMBLES [n]\n",
  "NOMBRIL": "(French) the point on an escutcheon between the fess point and the base point [n -S]\n",
  "NOMBRILS": "NOMBRIL, (French) the point on an escutcheon between the fess point and the base point [n]\n",
  "NOME": "(Greek) a province or department esp. in ancient Greece, also NOMOS [n -S]\n",
  "NOMEN": "(Latin) a name, esp. of the gens or clan [n NOMINA or NOMENS]\n",
  "NOMENCLATIVE": "relating to nomenclature [adj]\n",
  "NOMENCLATOR": "a book containing collections or lists of words; one who gives names to things [n -S]\n",
  "NOMENCLATORIAL": "relating to or connected with nomenclature, also NOMENCLATURAL [adj]\n",
  "NOMENCLATORS": "NOMENCLATOR, a book containing collections or lists of words; one who gives names to things [n]\n",
  "NOMENCLATURAL": "relating to or connected with nomenclature, also NOMENCLATORIAL [adj]\n",
  "NOMENCLATURE": "the study of the application of the names of taxa [n -S]\n",
  "NOMENCLATURES": "NOMENCLATURE, the study of the application of the names of taxa [n]\n",
  "NOMENKLATURA": "(Russian) officeholders and managers in a communist regime [n -S]\n",
  "NOMENKLATURAS": "NOMENKLATURA, (Russian) officeholders and managers in a communist regime [n]\n",
  "NOMENS": "NOMEN, (Latin) a name, esp. of the gens or clan [n]\n",
  "NOMES": "NOME, (Greek) a province or department esp. in ancient Greece, also NOMOS [n]\n",
  "NOMIC": "pertaining to or concerned with a discoverable scientific or logical law [adj]\n",
  "NOMINA": "NOMEN, (Latin) a name, esp. of the gens or clan [n]\n",
  "NOMINABLE": "that can be nominated [adj]\n",
  "NOMINAL": "in name only [adj NOMINALLY] / a noun or phrase etc. standing as a noun [n -S]\n",
  "NOMINALISATION": "the process of nominalising, also NOMINALIZATION [n -S]\n",
  "NOMINALISATIONS": "NOMINALISATION, the process of nominalising, also NOMINALIZATION [n]\n",
  "NOMINALISE": "to form a noun from, also NOMINALIZE [v NOMINALISED, NOMINALISING, NOMINALISES]\n",
  "NOMINALISED": "NOMINALISE, to form a noun from, also NOMINALIZE [v]\n",
  "NOMINALISES": "NOMINALISE, to form a noun from, also NOMINALIZE [v]\n",
  "NOMINALISING": "NOMINALISE, to form a noun from, also NOMINALIZE [v]\n",
  "NOMINALISM": "the doctrine that naming of things defines reality [n -S]\n",
  "NOMINALISMS": "NOMINALISM, the doctrine that naming of things defines reality [n]\n",
  "NOMINALIST": "one of a sect of philosophers in the Middle Ages, who adopted the opinion of Roscelin, that general conceptions, or universals, exist in name only [n -S]\n",
  "NOMINALISTIC": "relating to nominalism [adj]\n",
  "NOMINALISTS": "NOMINALIST, one of a sect of philosophers in the Middle Ages, who adopted the opinion of Roscelin, that general conceptions, or universals, exist in name only [n]\n",
  "NOMINALIZATION": "the process of nominalizing, also NOMINALISATION [n -S]\n",
  "NOMINALIZATIONS": "NOMINALIZATION, the process of nominalizing, also NOMINALISATION [n]\n",
  "NOMINALIZE": "to form a noun from, also NOMINALISE [v NOMINALIZED, NOMINALIZING, NOMINALIZES]\n",
  "NOMINALIZED": "NOMINALIZE, to form a noun from, also NOMINALISE [v]\n",
  "NOMINALIZES": "NOMINALIZE, to form a noun from, also NOMINALISE [v]\n",
  "NOMINALIZING": "NOMINALIZE, to form a noun from, also NOMINALISE [v]\n",
  "NOMINALLY": "NOMINAL, in name only [adv]\n",
  "NOMINALS": "NOMINAL, a noun or phrase etc. standing as a noun [n]\n",
  "NOMINATE": "by name [adj NOMINATELY] / to name as a candidate [v NOMINATED, NOMINATING, NOMINATES]\n",
  "NOMINATED": "NOMINATE, to name as a candidate [v]\n",
  "NOMINATELY": "NOMINATE, by name [adv]\n",
  "NOMINATES": "NOMINATE, to name as a candidate [v]\n",
  "NOMINATING": "NOMINATE, to name as a candidate [v]\n",
  "NOMINATION": "the act, process, or an instance of nominating [n -S]\n",
  "NOMINATIONS": "NOMINATION, the act, process, or an instance of nominating [n]\n",
  "NOMINATIVAL": "relating to the nominative [adj NOMINATIVALLY]\n",
  "NOMINATIVALLY": "NOMINATIVAL, relating to the nominative [adv]\n",
  "NOMINATIVE": "naming the subject [adj NOMINATIVELY] / a case indicating the subject of a verb [n -S]\n",
  "NOMINATIVELY": "NOMINATIVE, naming the subject [adv]\n",
  "NOMINATIVES": "NOMINATIVE, a case indicating the subject of a verb [n]\n",
  "NOMINATOR": "one who nominates [n -S]\n",
  "NOMINATORS": "NOMINATOR, one who nominates [n]\n",
  "NOMINEE": "one that is nominated [n -S]\n",
  "NOMINEES": "NOMINEE, one that is nominated [n]\n",
  "NOMISM": "the view that moral conduct consists in observance of laws [n -S]\n",
  "NOMISMS": "NOMISM, the view that moral conduct consists in observance of laws [n]\n",
  "NOMISTIC": "relating to nomism [adj]\n",
  "NOMOCRACIES": "NOMOCRACY, the rule of law; government based on legal system [n]\n",
  "NOMOCRACY": "the rule of law; government based on legal system [n NOMOCRACIES]\n",
  "NOMOGENIES": "NOMOGENY, natural rather than religious account of the origin of life [n]\n",
  "NOMOGENY": "natural rather than religious account of the origin of life [n NOMOGENIES]\n",
  "NOMOGRAM": "a chart or diagram of scaled lines or curves used to assist in mathematical calculations, also NOMOGRAPH [n -S]\n",
  "NOMOGRAMS": "NOMOGRAM, a chart or diagram of scaled lines or curves used to assist in mathematical calculations, also NOMOGRAPH [n]\n",
  "NOMOGRAPH": "a chart or diagram of scaled lines or curves used to assist in mathematical calculations, also NOMOGRAM [n -S]\n",
  "NOMOGRAPHER": "a writer of laws [n -S]\n",
  "NOMOGRAPHERS": "NOMOGRAPHER, a writer of laws [n]\n",
  "NOMOGRAPHIC": "of or like a nomograph, also NOMOGRAPHICAL [adj NOMOGRAPHICALLY]\n",
  "NOMOGRAPHICAL": "of or like a nomograph, also NOMOGRAPHIC [adj NOMOGRAPHICALLY]\n",
  "NOMOGRAPHICALLY": "NOMOGRAPHICAL, of or like a nomograph, also NOMOGRAPHIC [adv]\n",
  "NOMOGRAPHIES": "NOMOGRAPHY, a treatise on laws; an exposition of the form proper for laws [n]\n",
  "NOMOGRAPHS": "NOMOGRAPH, a chart or diagram of scaled lines or curves used to assist in mathematical calculations, also NOMOGRAM [n]\n",
  "NOMOGRAPHY": "a treatise on laws; an exposition of the form proper for laws [n NOMOGRAPHIES]\n",
  "NOMOI": "NOMOS, (Greek) a province or department, esp. in ancient Greece, also NOME [n]\n",
  "NOMOLOGIC": "relating to nomology, the science of reasoning, also NOMOLOGICAL [adj NOMOLOGICALLY]\n",
  "NOMOLOGICAL": "relating to nomology, the science of reasoning, also NOMOLOGIC [adj NOMOLOGICALLY]\n",
  "NOMOLOGICALLY": "NOMOLOGICAL, relating to nomology, the science of reasoning, also NOMOLOGIC [adv]\n",
  "NOMOLOGIES": "NOMOLOGY, the science of law [n]\n",
  "NOMOLOGIST": "a student of nomology, the science of law [n -S]\n",
  "NOMOLOGISTS": "NOMOLOGIST, a student of nomology, the science of law [n]\n",
  "NOMOLOGY": "the science of law [n NOMOLOGIES]\n",
  "NOMOS": "(Greek) a province or department, esp. in ancient Greece, also NOME [n NOMOI]\n",
  "NOMOTHETE": "a lawgiver [n -S]\n",
  "NOMOTHETES": "NOMOTHETE, a lawgiver [n]\n",
  "NOMOTHETIC": "legislative; based on law, also NOMOTHETICAL [adj]\n",
  "NOMOTHETICAL": "legislative; based on law, also NOMOTHETIC [adj]\n",
  "NOMS": "NOM, (French) a name [n]\n",
  "NON": "(Latin) not [adj]\n",
  "NONA": "a virus disease [n -S]\n",
  "NONABRASIVE": "not abrasive [adj]\n",
  "NONABSORBABLE": "not absorbable [adj]\n",
  "NONABSORBENT": "not absorbent [adj]\n",
  "NONABSORPTIVE": "not absorptive [adj]\n",
  "NONABSTRACT": "not abstract [adj]\n",
  "NONACADEMIC": "not academic [adj] / one who is not academic [n -S]\n",
  "NONACADEMICS": "NONACADEMIC, one who is not academic [n]\n",
  "NONACCEPTANCE": "lack of acceptance [n NONACCEPTANCES]\n",
  "NONACCEPTANCES": "NONACCEPTANCE, lack of acceptance [n]\n",
  "NONACCIDENTAL": "not accidental [adj]\n",
  "NONACCOUNTABLE": "not accountable [adj]\n",
  "NONACCREDITED": "not accredited [adj]\n",
  "NONACCRUAL": "not causing accrual [adj]\n",
  "NONACHIEVEMENT": "something that is not an achievement [n -S]\n",
  "NONACHIEVEMENTS": "NONACHIEVEMENT, something that is not an achievement [n]\n",
  "NONACID": "a substance that is not an acid [n -S]\n",
  "NONACIDIC": "not acidic [adj]\n",
  "NONACIDS": "NONACID, a substance that is not an acid [n]\n",
  "NONACQUISITIVE": "not acquisitive [adj]\n",
  "NONACTING": "acting that is of poor quality or does not conform to conventional ideas of what constitutes acting [n -S]\n",
  "NONACTINGS": "NONACTING, acting that is of poor quality or does not conform to conventional ideas of what constitutes acting [n]\n",
  "NONACTION": "not action [n -S]\n",
  "NONACTIONS": "NONACTION, not action [n]\n",
  "NONACTIVATED": "not activated [adj]\n",
  "NONACTIVE": "not active [adj]\n",
  "NONACTOR": "a person who is not an actor [n -S]\n",
  "NONACTORS": "NONACTOR, a person who is not an actor [n]\n",
  "NONADAPTIVE": "not adaptive [adj]\n",
  "NONADDICT": "one who is not an addict [n -S]\n",
  "NONADDICTIVE": "not addictive [adj]\n",
  "NONADDICTS": "NONADDICT, one who is not an addict [n]\n",
  "NONADDITIVE": "not having a numerical value equal to the sum of values for the component parts [adj]\n",
  "NONADDITIVITIES": "NONADDITIVITY, the state of being nonadditive [n]\n",
  "NONADDITIVITY": "the state of being nonadditive [n NONADDITIVITIES]\n",
  "NONADHESIVE": "not adhesive [adj]\n",
  "NONADIABATIC": "not adiabatic [adj]\n",
  "NONADJACENT": "not adjacent [adj]\n",
  "NONADMIRER": "one who does not admire something or someone [n -S]\n",
  "NONADMIRERS": "NONADMIRER, one who does not admire something or someone [n]\n",
  "NONADMISSION": "refusal of admission [n -S]\n",
  "NONADMISSIONS": "NONADMISSION, refusal of admission [n]\n",
  "NONADULT": "a person who is not an adult [n -S]\n",
  "NONADULTS": "NONADULT, a person who is not an adult [n]\n",
  "NONAESTHETIC": "not aesthetic [adj]\n",
  "NONAFFILIATED": "not affiliated [adj]\n",
  "NONAFFLUENT": "not affluent [adj]\n",
  "NONAGE": "legal infancy, minority [n -S]\n",
  "NONAGED": "having the quality of nonage; being a minor [adj]\n",
  "NONAGENARIAN": "a person whose age is in the nineties [n -S]\n",
  "NONAGENARIANS": "NONAGENARIAN, a person whose age is in the nineties [n]\n",
  "NONAGES": "NONAGE, legal infancy, minority [n]\n",
  "NONAGESIMAL": "ninetieth [adj] / the point of the ecliptic 90 degrees from its intersection by the horizon [n -S]\n",
  "NONAGESIMALS": "NONAGESIMAL, the point of the ecliptic 90 degrees from its intersection by the horizon [n]\n",
  "NONAGGRESSION": "lack of aggression [n -S]\n",
  "NONAGGRESSIONS": "NONAGGRESSION, lack of aggression [n]\n",
  "NONAGGRESSIVE": "not aggressive [adj]\n",
  "NONAGON": "a nine-sided polygon [n -S]\n",
  "NONAGONAL": "with nine angles [adj]\n",
  "NONAGONS": "NONAGON, a nine-sided polygon [n]\n",
  "NONAGRICULTURAL": "not agricultural [adj]\n",
  "NONALCOHOLIC": "not alcoholic [adj]\n",
  "NONALGEBRAIC": "not algebraic [adj]\n",
  "NONALIGNED": "not aligned [adj]\n",
  "NONALIGNMENT": "the state of being nonaligned [n -S]\n",
  "NONALIGNMENTS": "NONALIGNMENT, the state of being nonaligned [n]\n",
  "NONALLELIC": "not allelic [adj]\n",
  "NONALLERGENIC": "not allergenic [adj]\n",
  "NONALLERGIC": "not allergic [adj]\n",
  "NONALPHABETIC": "not alphabetic [adj]\n",
  "NONALUMINIUM": "not made of aluminium, also NONALUMINUM [adj]\n",
  "NONALUMINUM": "not made of aluminum, also NONALUMINIUM [adj]\n",
  "NONAMBIGUOUS": "not ambiguous [adj]\n",
  "NONANALYTIC": "not analytic [adj]\n",
  "NONANATOMIC": "not anatomic [adj]\n",
  "NONANE": "a hydrocarbon of the alkane series [n -S]\n",
  "NONANES": "NONANE, a hydrocarbon of the alkane series [n]\n",
  "NONANIMAL": "not animal [adj]\n",
  "NONANOIC": "as in nonanoic acid, a colourless fatty acid [adj]\n",
  "NONANSWER": "to answer in an unsatisfactory way [v -ED, -ING, -S]\n",
  "NONANSWERED": "NONANSWER, to answer in an unsatisfactory way [v]\n",
  "NONANSWERING": "NONANSWER, to answer in an unsatisfactory way [v]\n",
  "NONANSWERS": "NONANSWER, to answer in an unsatisfactory way [v]\n",
  "NONANTAGONISTIC": "not antagonistic [adj]\n",
  "NONANTIBIOTIC": "something that is not antibiotic [n -S]\n",
  "NONANTIBIOTICS": "NONANTIBIOTIC, something that is not antibiotic [n]\n",
  "NONANTIGENIC": "not antigenic [adj]\n",
  "NONAPPEARANCE": "lack of an appearance [n -S]\n",
  "NONAPPEARANCES": "NONAPPEARANCE, lack of an appearance [n]\n",
  "NONAQUATIC": "not living in the water [adj]\n",
  "NONAQUEOUS": "not watery [adj]\n",
  "NONARABLE": "not arable [adj]\n",
  "NONARBITRARY": "not arbitrary [adj]\n",
  "NONARCHITECT": "one who is not an architect [n -S]\n",
  "NONARCHITECTS": "NONARCHITECT, one who is not an architect [n]\n",
  "NONARCHITECTURE": "what is not architecture [n]\n",
  "NONARGUMENT": "something that is not an argument [n -S]\n",
  "NONARGUMENTS": "NONARGUMENT, something that is not an argument [n]\n",
  "NONARIES": "NONARY, a group of nine [n]\n",
  "NONARISTOCRATIC": "not aristocratic [adj]\n",
  "NONAROMATIC": "not aromatic [adj] / a nonaromatic substance [n -S]\n",
  "NONAROMATICS": "NONAROMATIC, a nonaromatic substance [n]\n",
  "NONARRIVAL": "a failure to arrival [n -S]\n",
  "NONARRIVALS": "NONARRIVAL, a failure to arrival [n]\n",
  "NONART": "something that is not art [n -S]\n",
  "NONARTIST": "one who is not an artist [n -S]\n",
  "NONARTISTIC": "not artistic [adj]\n",
  "NONARTISTS": "NONARTIST, one who is not an artist [n]\n",
  "NONARTS": "NONART, something that is not art [n]\n",
  "NONARY": "a group of nine [n NONARIES]\n",
  "NONAS": "NONA, a virus disease [n]\n",
  "NONASCETIC": "one who is not ascetic [n -S]\n",
  "NONASCETICS": "NONASCETIC, one who is not ascetic [n]\n",
  "NONASPIRIN": "not containing aspirin [adj]\n",
  "NONASSERTIVE": "not assertive [adj]\n",
  "NONASSOCIATED": "not associated [adj]\n",
  "NONASTRONOMICAL": "not astronomical [adj]\n",
  "NONATHLETE": "one who is not an athlete [n -S]\n",
  "NONATHLETES": "NONATHLETE, one who is not an athlete [n]\n",
  "NONATHLETIC": "not athletic [adj]\n",
  "NONATOMIC": "not atomic [adj]\n",
  "NONATTACHED": "not attached [adj]\n",
  "NONATTACHMENT": "absence of an attachment [n -S]\n",
  "NONATTACHMENTS": "NONATTACHMENT, absence of an attachment [n]\n",
  "NONATTENDANCE": "the act of not attending [n -S]\n",
  "NONATTENDANCES": "NONATTENDANCE, the act of not attending [n]\n",
  "NONATTENDER": "one who does not attend [n -S]\n",
  "NONATTENDERS": "NONATTENDER, one who does not attend [n]\n",
  "NONATTRIBUTABLE": "that cannot be attributed [adj]\n",
  "NONAUDITORY": "not auditory [adj]\n",
  "NONAUTHOR": "one who is not an author [n -S]\n",
  "NONAUTHORS": "NONAUTHOR, one who is not an author [n]\n",
  "NONAUTOMATED": "not automated [adj]\n",
  "NONAUTOMATIC": "not automatic [adj]\n",
  "NONAUTOMOTIVE": "not automotive [adj]\n",
  "NONAUTONOMOUS": "not autonomous [adj]\n",
  "NONAVAILABILITY": "the state of not being available [n]\n",
  "NONAVIAN": "not of or relating to birds [adj]\n",
  "NONBACTERIAL": "not bacterial [adj]\n",
  "NONBANK": "an alternative provider of bank services [n -S]\n",
  "NONBANKING": "not connected with banking [adj]\n",
  "NONBANKS": "NONBANK, an alternative provider of bank services [n]\n",
  "NONBARBITURATE": "something that is not barbiturate [n -S]\n",
  "NONBARBITURATES": "NONBARBITURATE, something that is not barbiturate [n]\n",
  "NONBASIC": "not basic [adj]\n",
  "NONBEARING": "not taking a load [adj]\n",
  "NONBEHAVIORAL": "not behavioral, also NONBEHAVIOURAL [adj]\n",
  "NONBEHAVIOURAL": "not behavioural, also NONBEHAVIORAL [adj]\n",
  "NONBEING": "lack of being [n -S]\n",
  "NONBEINGS": "NONBEING, lack of being [n]\n",
  "NONBELIEF": "absence of belief [n -S]\n",
  "NONBELIEFS": "NONBELIEF, absence of belief [n]\n",
  "NONBELIEVER": "one who does not believe [n -S]\n",
  "NONBELIEVERS": "NONBELIEVER, one who does not believe [n]\n",
  "NONBELLIGERENCY": "not belligerency [n]\n",
  "NONBELLIGERENT": "one who is not a belligerent [n -S]\n",
  "NONBELLIGERENTS": "NONBELLIGERENT, one who is not a belligerent [n]\n",
  "NONBETTING": "not given to betting [adj]\n",
  "NONBINARY": "not binary [adj]\n",
  "NONBINDING": "not binding e.g. an agreement [adj]\n",
  "NONBIOGRAPHICAL": "not biographical [adj]\n",
  "NONBIOLOGICAL": "not biological [adj NONBIOLOGICALLY]\n",
  "NONBIOLOGICALLY": "NONBIOLOGICAL, not biological [adv]\n",
  "NONBIOLOGIST": "one who is not a biologist [n -S]\n",
  "NONBIOLOGISTS": "NONBIOLOGIST, one who is not a biologist [n]\n",
  "NONBITING": "not biting [adj]\n",
  "NONBLACK": "one that is not black [n -S]\n",
  "NONBLACKS": "NONBLACK, one that is not black [n]\n",
  "NONBODIES": "NONBODY, a person's nonphysical nature [n]\n",
  "NONBODY": "a person's nonphysical nature [n NONBODIES]\n",
  "NONBONDED": "not bonded [adj]\n",
  "NONBONDING": "not bonding [adj]\n",
  "NONBOOK": "a book of little literary merit [n -S]\n",
  "NONBOOKS": "NONBOOK, a book of little literary merit [n]\n",
  "NONBOTANIST": "one who is not a botanist [n -S]\n",
  "NONBOTANISTS": "NONBOTANIST, one who is not a botanist [n]\n",
  "NONBRAND": "lacking a brand name [adj]\n",
  "NONBREAKABLE": "not breakable [adj]\n",
  "NONBREATHING": "not breathing [adj]\n",
  "NONBREEDER": "an animal that does not breed [n -S]\n",
  "NONBREEDERS": "NONBREEDER, an animal that does not breed [n]\n",
  "NONBREEDING": "not breeding [adj]\n",
  "NONBROADCAST": "not broadcast [adj]\n",
  "NONBUILDING": "not building [adj]\n",
  "NONBURNABLE": "that cannot be burnt [adj]\n",
  "NONBUSINESS": "not related to business [adj]\n",
  "NONBUYING": "not buying [adj]\n",
  "NONCABINET": "denoting one who is not a member of the Cabinet [adj]\n",
  "NONCAKING": "not caking [adj]\n",
  "NONCALLABLE": "that cannot be called [adj]\n",
  "NONCALORIC": "free from or very low in calories [adj]\n",
  "NONCAMPUS": "not on campus [adj]\n",
  "NONCANCELABLE": "not cancelable, also NONCANCELLABLE [adj]\n",
  "NONCANCELLABLE": "not cancellable, also NONCANCELABLE [adj]\n",
  "NONCANCEROUS": "not cancerous [adj]\n",
  "NONCANDIDACIES": "NONCANDIDACY, the fact of not being a candidate [n]\n",
  "NONCANDIDACY": "the fact of not being a candidate [n NONCANDIDACIES]\n",
  "NONCANDIDATE": "a person who is not a candidate [n -S]\n",
  "NONCANDIDATES": "NONCANDIDATE, a person who is not a candidate [n]\n",
  "NONCAPITAL": "not capital, lower case [adj]\n",
  "NONCAPITALIST": "one who is not a capitalist [n -S]\n",
  "NONCAPITALISTS": "NONCAPITALIST, one who is not a capitalist [n]\n",
  "NONCARBOHYDRATE": "relating to something that is not a carbohydrate [adj]\n",
  "NONCARCINOGEN": "a substance that is not a carcinogen [n -S]\n",
  "NONCARCINOGENIC": "not carcinogenic [adj]\n",
  "NONCARCINOGENS": "NONCARCINOGEN, a substance that is not a carcinogen [n]\n",
  "NONCARDIAC": "not related to the heart [adj]\n",
  "NONCAREER": "not related to a career [adj]\n",
  "NONCARRIER": "someone who does not carry (a genetic disease) [n -S]\n",
  "NONCARRIERS": "NONCARRIER, someone who does not carry (a genetic disease) [n]\n",
  "NONCASH": "other than cash [adj]\n",
  "NONCASUAL": "not casual [adj]\n",
  "NONCAUSAL": "not causal [adj]\n",
  "NONCE": "the present occasion [n -S]\n",
  "NONCELEBRATION": "something that is not celebration [n -S]\n",
  "NONCELEBRATIONS": "NONCELEBRATION, something that is not celebration [n]\n",
  "NONCELEBRITIES": "NONCELEBRITY, one who is not a celebrity [n]\n",
  "NONCELEBRITY": "one who is not a celebrity [n NONCELEBRITIES]\n",
  "NONCELLULAR": "not cellular [adj]\n",
  "NONCELLULOSIC": "a compound that does not contain cellulose [n -S]\n",
  "NONCELLULOSICS": "NONCELLULOSIC, a compound that does not contain cellulose [n]\n",
  "NONCENTRAL": "not central [adj]\n",
  "NONCEREAL": "not cereal [adj]\n",
  "NONCERTIFICATED": "not certificated [adj]\n",
  "NONCERTIFIED": "not certified [adj]\n",
  "NONCES": "NONCE, the present occasion [n]\n",
  "NONCHALANCE": "the state of being nonchalant [n -S]\n",
  "NONCHALANCES": "NONCHALANCE, the state of being nonchalant [n]\n",
  "NONCHALANT": "having an air of easy unconcern or indifference [adj NONCHALANTLY]\n",
  "NONCHALANTLY": "NONCHALANT, having an air of easy unconcern or indifference [adv]\n",
  "NONCHARACTER": "one who is not a character [n -S]\n",
  "NONCHARACTERS": "NONCHARACTER, one who is not a character [n]\n",
  "NONCHARISMATIC": "not charismatic [adj] / one who is not charismatic [n -S]\n",
  "NONCHARISMATICS": "NONCHARISMATIC, one who is not charismatic [n]\n",
  "NONCHAUVINIST": "a person who is not a chauvinist [n -S]\n",
  "NONCHAUVINISTS": "NONCHAUVINIST, a person who is not a chauvinist [n]\n",
  "NONCHEMICAL": "not chemical [adj] / something that is not a chemical [n -S]\n",
  "NONCHEMICALS": "NONCHEMICAL, something that is not a chemical [n]\n",
  "NONCHROMOSOMAL": "not situated on a chromosome [adj]\n",
  "NONCHURCH": "to take away a church's status as a church [v -ED, -ING, -ES]\n",
  "NONCHURCHED": "NONCHURCH, to take away a church's status as a church [v]\n",
  "NONCHURCHES": "NONCHURCH, to take away a church's status as a church [v]\n",
  "NONCHURCHGOER": "one who does not attend church [n -S]\n",
  "NONCHURCHGOERS": "NONCHURCHGOER, one who does not attend church [n]\n",
  "NONCHURCHING": "NONCHURCH, to take away a church's status as a church [v]\n",
  "NONCIRCULAR": "not circular [adj]\n",
  "NONCIRCULATING": "not circulating [adj]\n",
  "NONCITIZEN": "one who is not a citizen [n -S]\n",
  "NONCITIZENS": "NONCITIZEN, one who is not a citizen [n]\n",
  "NONCLANDESTINE": "not clandestine [adj]\n",
  "NONCLASS": "a lack of class [n -ES]\n",
  "NONCLASSES": "NONCLASS, a lack of class [n]\n",
  "NONCLASSICAL": "not classical [adj]\n",
  "NONCLASSIFIED": "not classified [adj]\n",
  "NONCLASSROOM": "not classroom [adj]\n",
  "NONCLERICAL": "not clerical [adj]\n",
  "NONCLING": "of a material, that does not cling [adj]\n",
  "NONCLINICAL": "not clinical [adj]\n",
  "NONCLOGGING": "not liable to clogging [adj]\n",
  "NONCODING": "of DNA, not contributing to the code [adj]\n",
  "NONCOERCIVE": "not coercive [adj]\n",
  "NONCOGNITIVE": "not cognitive [adj]\n",
  "NONCOGNITIVISM": "something that is not cognitivism [n -S]\n",
  "NONCOGNITIVISMS": "NONCOGNITIVISM, something that is not cognitivism [n]\n",
  "NONCOHERENT": "not coherent [adj]\n",
  "NONCOINCIDENCE": "something that is not coincidence [n -S]\n",
  "NONCOINCIDENCES": "NONCOINCIDENCE, something that is not coincidence [n]\n",
  "NONCOITAL": "not related to coition [adj]\n",
  "NONCOKING": "not coking [adj]\n",
  "NONCOLA": "a soft drink not containing cola [n -S]\n",
  "NONCOLAS": "NONCOLA, a soft drink not containing cola [n]\n",
  "NONCOLLECTOR": "someone who is not a collector [n -S]\n",
  "NONCOLLECTORS": "NONCOLLECTOR, someone who is not a collector [n]\n",
  "NONCOLLEGE": "not associated with a college [adj]\n",
  "NONCOLLEGIATE": "not collegiate [adj]\n",
  "NONCOLLINEAR": "not collinear [adj]\n",
  "NONCOLOR": "an achromatic colour such as black or white, also NONCOLOUR [n -S]\n",
  "NONCOLORED": "not coloured, also NONCOLOURED [adj]\n",
  "NONCOLORFAST": "not colorfast, also NONCOLOURFAST [adj]\n",
  "NONCOLORS": "NONCOLOR, an achromatic colour such as black or white, also NONCOLOUR [n]\n",
  "NONCOLOUR": "an achromatic colour such as black or white, also NONCOLOR [n -S]\n",
  "NONCOLOURED": "not coloured, also NONCOLORED [adj]\n",
  "NONCOLOURFAST": "not colourfast, also NONCOLORFAST [adj]\n",
  "NONCOLOURS": "NONCOLOUR, an achromatic colour such as black or white, also NONCOLOR [n]\n",
  "NONCOM": "(short for) a noncommissioned officer [n -S]\n",
  "NONCOMBAT": "not engaged in combat [adj]\n",
  "NONCOMBATANT": "one that does not engage in combat [n -S]\n",
  "NONCOMBATANTS": "NONCOMBATANT, one that does not engage in combat [n]\n",
  "NONCOMBATIVE": "not combative [adj]\n",
  "NONCOMBUSTIBLE": "something that is not combustible [n -S]\n",
  "NONCOMBUSTIBLES": "NONCOMBUSTIBLE, something that is not combustible [n]\n",
  "NONCOMMERCIAL": "not commercial [adj]\n",
  "NONCOMMISSIONED": "not commissioned [adj]\n",
  "NONCOMMITMENT": "lack of commitment [n -S]\n",
  "NONCOMMITMENTS": "NONCOMMITMENT, lack of commitment [n]\n",
  "NONCOMMITTAL": "giving no clear indication of attitude or feeling [adj NONCOMMITTALLY] / something giving no clear indication of attitude or feeling [n -S]\n",
  "NONCOMMITTALLY": "NONCOMMITTAL, giving no clear indication of attitude or feeling [adv]\n",
  "NONCOMMITTALS": "NONCOMMITTAL, something giving no clear indication of attitude or feeling [n]\n",
  "NONCOMMITTED": "not committed [adj]\n",
  "NONCOMMUNICANT": "a person who has not received communion [n -S]\n",
  "NONCOMMUNICANTS": "NONCOMMUNICANT, a person who has not received communion [n]\n",
  "NONCOMMUNIST": "one who is not a communist [n -S]\n",
  "NONCOMMUNISTS": "NONCOMMUNIST, one who is not a communist [n]\n",
  "NONCOMMUNITY": "not belonging to the community [adj]\n",
  "NONCOMMUTATIVE": "not commutative [adj]\n",
  "NONCOMPARABLE": "not comparable [adj]\n",
  "NONCOMPATIBLE": "not compatible [adj]\n",
  "NONCOMPETITION": "something that is not a competition [n -S]\n",
  "NONCOMPETITIONS": "NONCOMPETITION, something that is not a competition [n]\n",
  "NONCOMPETITIVE": "not competitive [adj]\n",
  "NONCOMPETITOR": "one who is not a competitor [n -S]\n",
  "NONCOMPETITORS": "NONCOMPETITOR, one who is not a competitor [n]\n",
  "NONCOMPLETION": "failure to complete something [n -S]\n",
  "NONCOMPLETIONS": "NONCOMPLETION, failure to complete something [n]\n",
  "NONCOMPLEX": "not complex [adj]\n",
  "NONCOMPLIANCE": "lack of compliance [n -S]\n",
  "NONCOMPLIANCES": "NONCOMPLIANCE, lack of compliance [n]\n",
  "NONCOMPLICATED": "not complicated [adj]\n",
  "NONCOMPLYING": "the failure to comply; noncompliance [n -S]\n",
  "NONCOMPLYINGS": "NONCOMPLYING, the failure to comply; noncompliance [n]\n",
  "NONCOMPOSER": "one who is not a composer [n -S]\n",
  "NONCOMPOSERS": "NONCOMPOSER, one who is not a composer [n]\n",
  "NONCOMPOUND": "not compound [adj]\n",
  "NONCOMPRESSIBLE": "not compressible [adj]\n",
  "NONCOMPUTER": "not related to computers [adj]\n",
  "NONCOMPUTERISED": "not computerised, also NONCOMPUTERIZED [adj]\n",
  "NONCOMPUTERIZED": "not computerized, also NONCOMPUTERISED [adj]\n",
  "NONCOMS": "NONCOM, (short for) a noncommissioned officer [n]\n",
  "NONCONCEPTUAL": "not conceptual [adj]\n",
  "NONCONCERN": "lack of concern [n -S]\n",
  "NONCONCERNS": "NONCONCERN, lack of concern [n]\n",
  "NONCONCLUSION": "the lack of a conclusion [n -S]\n",
  "NONCONCLUSIONS": "NONCONCLUSION, the lack of a conclusion [n]\n",
  "NONCONCUR": "to dissent or refuse to concur [v NONCONCURRED, NONCONCURRING, NONCONCURS]\n",
  "NONCONCURRED": "NONCONCUR, to dissent or refuse to concur [v]\n",
  "NONCONCURRENCE": "lack of concurrence [n -S]\n",
  "NONCONCURRENCES": "NONCONCURRENCE, lack of concurrence [n]\n",
  "NONCONCURRENT": "not concurrent [adj]\n",
  "NONCONCURRING": "NONCONCUR, to dissent or refuse to concur [v]\n",
  "NONCONCURS": "NONCONCUR, to dissent or refuse to concur [v]\n",
  "NONCONDENSABLE": "not condensable [adj]\n",
  "NONCONDITIONED": "not conditioned [adj]\n",
  "NONCONDUCTING": "not conducting [adj]\n",
  "NONCONDUCTION": "the quality of not conducting [n -S]\n",
  "NONCONDUCTIONS": "NONCONDUCTION, the quality of not conducting [n]\n",
  "NONCONDUCTIVE": "not conductive [adj]\n",
  "NONCONDUCTOR": "a substance that conducts heat, electricity, or sound only in very small degree [n -S]\n",
  "NONCONDUCTORS": "NONCONDUCTOR, a substance that conducts heat, electricity, or sound only in very small degree [n]\n",
  "NONCONFERENCE": "not related to a conference [adj]\n",
  "NONCONFIDENCE": "lack of confidence [n -S]\n",
  "NONCONFIDENCES": "NONCONFIDENCE, lack of confidence [n]\n",
  "NONCONFIDENTIAL": "not confidential [adj]\n",
  "NONCONFLICTING": "not conflicting [adj]\n",
  "NONCONFORM": "to fail to conform [v -ED, -ING, -S]\n",
  "NONCONFORMANCE": "failure to conform [n -S]\n",
  "NONCONFORMANCES": "NONCONFORMANCE, failure to conform [n]\n",
  "NONCONFORMED": "NONCONFORM, to fail to conform [v]\n",
  "NONCONFORMER": "one who does not conform [n -S]\n",
  "NONCONFORMERS": "NONCONFORMER, one who does not conform [n]\n",
  "NONCONFORMING": "the act of not conforming [n -S]\n",
  "NONCONFORMINGS": "NONCONFORMING, the act of not conforming [n]\n",
  "NONCONFORMISM": "nonconformity [n -S]\n",
  "NONCONFORMISMS": "NONCONFORMISM, nonconformity [n]\n",
  "NONCONFORMIST": "a person who does not conform [n -S]\n",
  "NONCONFORMISTS": "NONCONFORMIST, a person who does not conform [n]\n",
  "NONCONFORMITIES": "NONCONFORMITY, an unconformity that separates profoundly different rock types, such as sedimentary rocks from metamorphic rocks [n]\n",
  "NONCONFORMITY": "an unconformity that separates profoundly different rock types, such as sedimentary rocks from metamorphic rocks [n NONCONFORMITIES]\n",
  "NONCONFORMS": "NONCONFORM, to fail to conform [v]\n",
  "NONCONGRUENT": "not congruent [adj]\n",
  "NONCONJUGATED": "not conjugated [adj]\n",
  "NONCONNECTION": "lack of a connection [n -S]\n",
  "NONCONNECTIONS": "NONCONNECTION, lack of a connection [n]\n",
  "NONCONSCIOUS": "not conscious [adj]\n",
  "NONCONSECUTIVE": "not consecutive [adj]\n",
  "NONCONSENSUAL": "not consensual [adj]\n",
  "NONCONSERVATION": "not conservation [n]\n",
  "NONCONSERVATIVE": "not conservative [adj]\n",
  "NONCONSOLIDATED": "not consolidated [adj]\n",
  "NONCONSTANT": "not constant [adj]\n",
  "NONCONSTRUCTION": "not related to construction [adj]\n",
  "NONCONSTRUCTIVE": "not constructive [adj]\n",
  "NONCONSUMER": "one who is not a consumer [n -S]\n",
  "NONCONSUMERS": "NONCONSUMER, one who is not a consumer [n]\n",
  "NONCONSUMING": "not consuming [adj]\n",
  "NONCONSUMPTION": "something that is not consumption [n -S]\n",
  "NONCONSUMPTIONS": "NONCONSUMPTION, something that is not consumption [n]\n",
  "NONCONSUMPTIVE": "not consumptive [adj]\n",
  "NONCONTACT": "the state of not making contact [n -S]\n",
  "NONCONTACTS": "NONCONTACT, the state of not making contact [n]\n",
  "NONCONTAGIOUS": "not contagious [adj]\n",
  "NONCONTEMPORARY": "not contemporary [adj]\n",
  "NONCONTIGUOUS": "not contiguous [adj]\n",
  "NONCONTINGENT": "not contingent [adj]\n",
  "NONCONTINUOUS": "not continuous [adj]\n",
  "NONCONTRACT": "not employed by contract [adj]\n",
  "NONCONTRACTUAL": "not contractual [adj]\n",
  "NONCONTRIBUTING": "not contributing [adj]\n",
  "NONCONTRIBUTORY": "not contributory [adj]\n",
  "NONCONTROLLABLE": "not controllable [adj]\n",
  "NONCONTROLLED": "not controlled [adj]\n",
  "NONCONTROLLING": "not controlling [adj]\n",
  "NONCONVENTIONAL": "not conventional [adj]\n",
  "NONCONVERTIBLE": "not convertible [adj]\n",
  "NONCOOPERATION": "failure or refusal to cooperate [n -S]\n",
  "NONCOOPERATIONS": "NONCOOPERATION, failure or refusal to cooperate [n]\n",
  "NONCOOPERATIVE": "of, relating to, or characterized by noncooperation [adj]\n",
  "NONCOOPERATOR": "one who does not cooperate [n -S]\n",
  "NONCOOPERATORS": "NONCOOPERATOR, one who does not cooperate [n]\n",
  "NONCOPLANAR": "not coplanar [adj]\n",
  "NONCORE": "not core [adj]\n",
  "NONCORPORATE": "not corporate [adj]\n",
  "NONCORRELATION": "a lack of correlation [n -S]\n",
  "NONCORRELATIONS": "NONCORRELATION, a lack of correlation [n]\n",
  "NONCORRODIBLE": "not corrodible [adj]\n",
  "NONCORRODING": "not corroding [adj]\n",
  "NONCORROSIVE": "not corrosive [adj]\n",
  "NONCOUNT": "not capable of being counted [adj]\n",
  "NONCOUNTRIES": "NONCOUNTRY, a region, administrative entity, or principality that does not have nation or country status [n]\n",
  "NONCOUNTRY": "a region, administrative entity, or principality that does not have nation or country status [n NONCOUNTRIES]\n",
  "NONCOUNTY": "not part of the county set [adj]\n",
  "NONCOVERAGE": "lack of coverage [n -S]\n",
  "NONCOVERAGES": "NONCOVERAGE, lack of coverage [n]\n",
  "NONCREATIVE": "not creative [adj]\n",
  "NONCREATIVITIES": "NONCREATIVITY, an absence of creativity [n]\n",
  "NONCREATIVITY": "an absence of creativity [n NONCREATIVITIES]\n",
  "NONCREDENTIALED": "not having credentials [adj]\n",
  "NONCREDIT": "not involving credit [adj]\n",
  "NONCRIME": "something that is not a crime [n -S]\n",
  "NONCRIMES": "NONCRIME, something that is not a crime [n]\n",
  "NONCRIMINAL": "one who is not a criminal [n -S]\n",
  "NONCRIMINALS": "NONCRIMINAL, one who is not a criminal [n]\n",
  "NONCRISES": "NONCRISIS, something that is not a crisis [n]\n",
  "NONCRISIS": "something that is not a crisis [n NONCRISES]\n",
  "NONCRITICAL": "not critical [adj]\n",
  "NONCROSSOVER": "a chromosome that has not crossed over during meiosis [n -S]\n",
  "NONCROSSOVERS": "NONCROSSOVER, a chromosome that has not crossed over during meiosis [n]\n",
  "NONCRUSHABLE": "not crushable [adj]\n",
  "NONCRYSTALLINE": "not crystalline [adj]\n",
  "NONCULINARY": "not culinary [adj]\n",
  "NONCULTIVATED": "not cultivated [adj]\n",
  "NONCULTIVATION": "something that is not cultivation [n -S]\n",
  "NONCULTIVATIONS": "NONCULTIVATION, something that is not cultivation [n]\n",
  "NONCULTURAL": "not cultural [adj]\n",
  "NONCUMULATIVE": "not cumulative [adj]\n",
  "NONCURRENT": "not current [adj]\n",
  "NONCUSTODIAL": "of or being a parent who does not have sole custody of a child or who has custody a smaller portion of the time [adj]\n",
  "NONCUSTOMER": "one who is not a customer [n -S]\n",
  "NONCUSTOMERS": "NONCUSTOMER, one who is not a customer [n]\n",
  "NONCYCLIC": "not cyclic, also NONCYCLICAL [adj]\n",
  "NONCYCLICAL": "not cyclical, also NONCYCLIC [adj]\n",
  "NONDAIRY": "having no milk products [adj]\n",
  "NONDANCE": "an unrhythmic dance [n -S]\n",
  "NONDANCER": "someone who does not dance [n -S]\n",
  "NONDANCERS": "NONDANCER, someone who does not dance [n]\n",
  "NONDANCES": "NONDANCE, an unrhythmic dance [n]\n",
  "NONDEALER": "one who is not a (drug) dealer [n -S]\n",
  "NONDEALERS": "NONDEALER, one who is not a (drug) dealer [n]\n",
  "NONDECEPTIVE": "not deceptive [adj]\n",
  "NONDECISION": "something that is not a decision [n -S]\n",
  "NONDECISIONS": "NONDECISION, something that is not a decision [n]\n",
  "NONDECREASING": "not decreasing [adj]\n",
  "NONDEDUCTIBLE": "not deductible [adj]\n",
  "NONDEDUCTIVE": "not deductive [adj]\n",
  "NONDEFENCE": "not related to defence, also NONDEFENSE [adj]\n",
  "NONDEFENSE": "not related to defense, also NONDEFENCE [adj]\n",
  "NONDEFERRABLE": "not deferrable [adj]\n",
  "NONDEFORMING": "not subject to deformation [adj]\n",
  "NONDEGENERATE": "not degenerate [adj]\n",
  "NONDEGRADABLE": "not degradable [adj]\n",
  "NONDEGREE": "of a course of study, that does not lead to a degree [adj]\n",
  "NONDELEGATE": "one who is not a delegate [n -S]\n",
  "NONDELEGATES": "NONDELEGATE, one who is not a delegate [n]\n",
  "NONDELIBERATE": "not deliberate [adj]\n",
  "NONDELINQUENT": "one who is not a delinquent [n -S]\n",
  "NONDELINQUENTS": "NONDELINQUENT, one who is not a delinquent [n]\n",
  "NONDELIVERIES": "NONDELIVERY, a ball that does not count as a delivery [n]\n",
  "NONDELIVERY": "a ball that does not count as a delivery [n NONDELIVERIES]\n",
  "NONDEMAND": "something that is not a demand [n -S]\n",
  "NONDEMANDING": "not demanding [adj]\n",
  "NONDEMANDS": "NONDEMAND, something that is not a demand [n]\n",
  "NONDEMOCRATIC": "not democratic [adj]\n",
  "NONDEPARTMENTAL": "not departmental [adj]\n",
  "NONDEPENDENT": "one who is not a dependent [n -S]\n",
  "NONDEPENDENTS": "NONDEPENDENT, one who is not a dependent [n]\n",
  "NONDEPLETABLE": "not depletable [adj]\n",
  "NONDEPLETING": "not depleting [adj]\n",
  "NONDEPOSITION": "something that is not a deposition [n -S]\n",
  "NONDEPOSITIONS": "NONDEPOSITION, something that is not a deposition [n]\n",
  "NONDEPRESSED": "not depressed [adj]\n",
  "NONDERIVATIVE": "not derivative [adj]\n",
  "NONDESCRIPT": "belonging or appearing to belong to no particular class or kind [adj NONDESCRIPTLY] / a featureless person or thing, or one not easily described [n -S]\n",
  "NONDESCRIPTIVE": "not descriptive [adj]\n",
  "NONDESCRIPTLY": "NONDESCRIPT, belonging or appearing to belong to no particular class or kind [adv]\n",
  "NONDESCRIPTNESS": "NONDESCRIPT, belonging or appearing to belong to no particular class or kind [n]\n",
  "NONDESCRIPTS": "NONDESCRIPT, a featureless person or thing, or one not easily described [n]\n",
  "NONDESERT": "not related to or living in a desert [adj]\n",
  "NONDESTRUCTIVE": "not destructive [adj]\n",
  "NONDETACHABLE": "not detachable [adj]\n",
  "NONDEVELOPMENT": "something that is not development [n -S]\n",
  "NONDEVELOPMENTS": "NONDEVELOPMENT, something that is not development [n]\n",
  "NONDEVIANT": "not deviant [adj]\n",
  "NONDIABETIC": "not diabetic [adj] / one who is not a diabetic [n -S]\n",
  "NONDIABETICS": "NONDIABETIC, one who is not a diabetic [n]\n",
  "NONDIALYSABLE": "not dialysable, also NONDIALYZABLE [adj]\n",
  "NONDIALYZABLE": "not dialyzable, also NONDIALYSABLE [adj]\n",
  "NONDIAPAUSING": "not having a diapause [adj]\n",
  "NONDIDACTIC": "not didactic [adj]\n",
  "NONDIFFUSIBLE": "not diffusible [adj]\n",
  "NONDIMENSIONAL": "not dimensional [adj]\n",
  "NONDIPLOMATIC": "not diplomatic [adj]\n",
  "NONDIRECTED": "not directed [adj]\n",
  "NONDIRECTIONAL": "not directional [adj]\n",
  "NONDIRECTIVE": "of, relating to, or being psychotherapy, counseling, or interviewing in which the counselor refrains from interpretation or explanation but encourages the client (as by repeating phrases) to talk freely [adj]\n",
  "NONDISABLED": "not disabled [adj]\n",
  "NONDISCLOSURE": "as in a nondisclosure agreement [n -S]\n",
  "NONDISCLOSURES": "NONDISCLOSURE, as in a nondisclosure agreement [n]\n",
  "NONDISCOUNT": "not discounted [adj]\n",
  "NONDISCURSIVE": "not discursive [adj]\n",
  "NONDISJUNCTION": "the failure of paired chromosomes to separate during mitosis [n -S]\n",
  "NONDISJUNCTIONS": "NONDISJUNCTION, the failure of paired chromosomes to separate during mitosis [n]\n",
  "NONDISPERSIVE": "not dispersive [adj]\n",
  "NONDISRUPTIVE": "not disruptive [adj]\n",
  "NONDISTINCTIVE": "having no signaling value [adj]\n",
  "NONDIVERGENT": "not divergent [adj]\n",
  "NONDIVERSIFIED": "not diversified [adj]\n",
  "NONDIVIDING": "not dividing [adj]\n",
  "NONDOCTOR": "someone who is not a doctor [n -S]\n",
  "NONDOCTORS": "NONDOCTOR, someone who is not a doctor [n]\n",
  "NONDOCTRINAIRE": "not doctrinaire [adj]\n",
  "NONDOCUMENTARY": "not documentary [adj]\n",
  "NONDOGMATIC": "not dogmatic [adj]\n",
  "NONDOLLAR": "of a currency, not using the dollar [adj]\n",
  "NONDOMESTIC": "not domestic [adj]\n",
  "NONDOMICILED": "not domiciled [adj]\n",
  "NONDOMINANT": "not dominant [adj]\n",
  "NONDORMANT": "not dormant [adj]\n",
  "NONDRAMATIC": "not dramatic [adj]\n",
  "NONDRINKER": "one who does not drink [n -S]\n",
  "NONDRINKERS": "NONDRINKER, one who does not drink [n]\n",
  "NONDRINKING": "not drinking [adj]\n",
  "NONDRIP": "not liable to drip [adj]\n",
  "NONDRIVER": "one who does not drive [n -S]\n",
  "NONDRIVERS": "NONDRIVER, one who does not drive [n]\n",
  "NONDRUG": "not involving drugs [adj]\n",
  "NONDRYING": "that does not dry [adj]\n",
  "NONDURABLE": "goods that are not durable [n -S]\n",
  "NONDURABLES": "NONDURABLE, goods that are not durable [n]\n",
  "NONE": "not one, also NANE [pron]\n",
  "NONEARNING": "not earning [adj]\n",
  "NONECONOMIC": "not economic [adj]\n",
  "NONECONOMIST": "one who is not an economist [n -S]\n",
  "NONECONOMISTS": "NONECONOMIST, one who is not an economist [n]\n",
  "NONEDIBLE": "not edible [adj] / something not edible [n -S]\n",
  "NONEDIBLES": "NONEDIBLE, something not edible [n]\n",
  "NONEDITORIAL": "not editorial [adj]\n",
  "NONEDUCATION": "not related to education [adj]\n",
  "NONEDUCATIONAL": "not educational [adj]\n",
  "NONEFFECTIVE": "a person who is not effective [n -S]\n",
  "NONEFFECTIVES": "NONEFFECTIVE, a person who is not effective [n]\n",
  "NONEGO": "all that is not part of the ego [n -S]\n",
  "NONEGOS": "NONEGO, all that is not part of the ego [n]\n",
  "NONELASTIC": "not having elasticity [adj]\n",
  "NONELECT": "those not chosen for salvation [n -S]\n",
  "NONELECTED": "not elected [adj]\n",
  "NONELECTION": "something that is not an election [n -S]\n",
  "NONELECTIONS": "NONELECTION, something that is not an election [n]\n",
  "NONELECTIVE": "not elective [adj]\n",
  "NONELECTRIC": "not electric, also NONELECTRICAL [adj] / a substance that does not generate or conduct electricity [n -S]\n",
  "NONELECTRICAL": "a substance that does not generate or conduct electricity, also NONELECTRIC [n -S]\n",
  "NONELECTRICALS": "NONELECTRICAL, a substance that does not generate or conduct electricity, also NONELECTRIC [n]\n",
  "NONELECTRICS": "NONELECTRIC, a substance that does not generate or conduct electricity [n]\n",
  "NONELECTROLYTE": "a substance that does not readily ionize when dissolved or melted and is a poor conductor of electricity [n -S]\n",
  "NONELECTROLYTES": "NONELECTROLYTE, a substance that does not readily ionize when dissolved or melted and is a poor conductor of electricity [n]\n",
  "NONELECTRONIC": "not electronic [adj]\n",
  "NONELECTS": "NONELECT, those not chosen for salvation [n]\n",
  "NONELEMENTARY": "not elementary [adj]\n",
  "NONELITE": "not belonging to an elite group [adj]\n",
  "NONEMERGENCIES": "NONEMERGENCY, something not an emergency [n]\n",
  "NONEMERGENCY": "something not an emergency [n NONEMERGENCIES]\n",
  "NONEMOTIONAL": "not emotional [adj]\n",
  "NONEMPHATIC": "not emphatic [adj]\n",
  "NONEMPIRICAL": "not empirical [adj]\n",
  "NONEMPLOYEE": "one who is not an employee [n -S]\n",
  "NONEMPLOYEES": "NONEMPLOYEE, one who is not an employee [n]\n",
  "NONEMPLOYMENT": "something that is not employment [n -S]\n",
  "NONEMPLOYMENTS": "NONEMPLOYMENT, something that is not employment [n]\n",
  "NONEMPTY": "not empty [adj]\n",
  "NONENCAPSULATED": "not encapsulated [adj]\n",
  "NONENDING": "not ending [adj]\n",
  "NONENERGY": "relating to the absence of energy [adj]\n",
  "NONENFORCEMENT": "something that is not enforcement [n -S]\n",
  "NONENFORCEMENTS": "NONENFORCEMENT, something that is not enforcement [n]\n",
  "NONENGAGEMENT": "something that is not an engagement [n -S]\n",
  "NONENGAGEMENTS": "NONENGAGEMENT, something that is not an engagement [n]\n",
  "NONENGINEERING": "not related to engineering [adj]\n",
  "NONENTITIES": "NONENTITY, a person or thing of no importance [n]\n",
  "NONENTITY": "a person or thing of no importance [n NONENTITIES]\n",
  "NONENTRIES": "NONENTRY, the fact of not entering [n]\n",
  "NONENTRY": "the fact of not entering [n NONENTRIES]\n",
  "NONENZYMATIC": "not enzymatic [adj]\n",
  "NONENZYMIC": "not enzymic [adj]\n",
  "NONEQUAL": "one that is not equal [n -S]\n",
  "NONEQUALS": "NONEQUAL, one that is not equal [n]\n",
  "NONEQUILIBRIA": "NONEQUILIBRIUM, lack of equilibrium [n]\n",
  "NONEQUILIBRIUM": "lack of equilibrium [n NONEQUILIBRIUMS or NONEQUILIBRIA]\n",
  "NONEQUILIBRIUMS": "NONEQUILIBRIUM, lack of equilibrium [n]\n",
  "NONEQUIVALENCE": "something that is not equivalence [n -S]\n",
  "NONEQUIVALENCES": "NONEQUIVALENCE, something that is not equivalence [n]\n",
  "NONEQUIVALENT": "not equivalent [adj]\n",
  "NONEROTIC": "not erotic [adj]\n",
  "NONES": "a prayer service held at 3 p.m. [n]\n",
  "NONESSENTIAL": "something not essential [n -S]\n",
  "NONESSENTIALS": "NONESSENTIAL, something not essential [n]\n",
  "NONESTABLISHED": "not established [adj]\n",
  "NONESTERIFIED": "not esterified [adj]\n",
  "NONESUCH": "a person or thing without an equal, also NONSUCH [n -ES]\n",
  "NONESUCHES": "NONESUCH, a person or thing without an equal, also NONSUCH [n]\n",
  "NONET": "a musical piece for nine players, also NONETTE, NONETTO [n -S]\n",
  "NONETHELESS": "nevertheless [adj]\n",
  "NONETHICAL": "not ethical [adj]\n",
  "NONETHNIC": "not ethnic [adj] / someone not of ethnic origin [n -S]\n",
  "NONETHNICS": "NONETHNIC, someone not of ethnic origin [n]\n",
  "NONETS": "NONET, a musical piece for nine players, also NONETTE, NONETTO [n]\n",
  "NONETTE": "a musical piece for nine players, also NONET, NONETTO [n -S]\n",
  "NONETTES": "NONETTE, a musical piece for nine players, also NONET, NONETTO [n]\n",
  "NONETTI": "NONETTO, (Italian) a musical piece for nine players, also NONET, NONETTE [n]\n",
  "NONETTO": "(Italian) a musical piece for nine players, also NONET, NONETTE [n NONETTOS or NONETTI]\n",
  "NONETTOS": "NONETTO, (Italian) a musical piece for nine players, also NONET, NONETTE [n]\n",
  "NONEVALUATIVE": "not evaluative [adj]\n",
  "NONEVENT": "an expected event that does not occur [n -S]\n",
  "NONEVENTS": "NONEVENT, an expected event that does not occur [n]\n",
  "NONEVIDENCE": "something that is not evidence [n -S]\n",
  "NONEVIDENCES": "NONEVIDENCE, something that is not evidence [n]\n",
  "NONEXCLUSIVE": "not exclusive [adj]\n",
  "NONEXECUTIVE": "one who is not in an executive position [n -S]\n",
  "NONEXECUTIVES": "NONEXECUTIVE, one who is not in an executive position [n]\n",
  "NONEXEMPT": "not exempt [adj] / one who is not exempt [n -S]\n",
  "NONEXEMPTS": "NONEXEMPT, one who is not exempt [n]\n",
  "NONEXISTENCE": "absence of existence [n -S]\n",
  "NONEXISTENCES": "NONEXISTENCE, absence of existence [n]\n",
  "NONEXISTENT": "something having no existence [n -S]\n",
  "NONEXISTENTIAL": "not existential [adj]\n",
  "NONEXISTENTS": "NONEXISTENT, something having no existence [n]\n",
  "NONEXOTIC": "not exotic [adj]\n",
  "NONEXPENDABLE": "not expendable [adj]\n",
  "NONEXPERIMENTAL": "not experimental [adj]\n",
  "NONEXPERT": "not expert [adj] / one who is not an expert [n -S]\n",
  "NONEXPERTS": "NONEXPERT, one who is not an expert [n]\n",
  "NONEXPLANATORY": "not explanatory [adj]\n",
  "NONEXPLOITATION": "not exploitation [adj]\n",
  "NONEXPLOITATIVE": "not exploitative, also NONEXPLOITIVE [adj]\n",
  "NONEXPLOITIVE": "not exploitive, also NONEXPLOITATIVE [adj]\n",
  "NONEXPLOSIVE": "not explosive [adj]\n",
  "NONEXPOSED": "not exposed [adj]\n",
  "NONEXTANT": "not extant [adj]\n",
  "NONFACT": "a statement not based on fact [n -S]\n",
  "NONFACTOR": "something that is not a factor [n -S]\n",
  "NONFACTORS": "NONFACTOR, something that is not a factor [n]\n",
  "NONFACTS": "NONFACT, a statement not based on fact [n]\n",
  "NONFACTUAL": "not factual [adj]\n",
  "NONFACULTIES": "NONFACULTY, a position that is not part of an academic faculty [n]\n",
  "NONFACULTY": "a position that is not part of an academic faculty [n NONFACULTIES]\n",
  "NONFADING": "not fading [adj]\n",
  "NONFAMILIAL": "not familial [adj]\n",
  "NONFAMILIES": "NONFAMILY, something that is not a family [n]\n",
  "NONFAMILY": "something that is not a family [n NONFAMILIES]\n",
  "NONFAN": "a person who is not an enthusiast [n -S]\n",
  "NONFANS": "NONFAN, a person who is not an enthusiast [n]\n",
  "NONFARM": "not pertaining to a farm [adj]\n",
  "NONFARMER": "someone who is not a farmer [n -S]\n",
  "NONFARMERS": "NONFARMER, someone who is not a farmer [n]\n",
  "NONFAT": "having no fat solids [adj]\n",
  "NONFATAL": "not fatal [adj]\n",
  "NONFATTENING": "not fattening [adj]\n",
  "NONFATTY": "not fatty [adj]\n",
  "NONFEASANCE": "failure to perform an act or obligation [n -S]\n",
  "NONFEASANCES": "NONFEASANCE, failure to perform an act or obligation [n]\n",
  "NONFEDERAL": "not federal [adj]\n",
  "NONFEDERATED": "not federated [adj]\n",
  "NONFEEDING": "not feeding [adj]\n",
  "NONFEMINIST": "one who is not a feminist [n -S]\n",
  "NONFEMINISTS": "NONFEMINIST, one who is not a feminist [n]\n",
  "NONFERROUS": "not ferrous [adj]\n",
  "NONFEUDAL": "not feudal [adj]\n",
  "NONFICTION": "literature or cinema that is not fictional [n -S]\n",
  "NONFICTIONAL": "not fictional [adj NONFICTIONALLY]\n",
  "NONFICTIONALLY": "NONFICTIONAL, not fictional [adv]\n",
  "NONFICTIONS": "NONFICTION, literature or cinema that is not fictional [n]\n",
  "NONFIGURATIVE": "not figurative [adj]\n",
  "NONFILAMENTOUS": "not filamentous [adj]\n",
  "NONFILIAL": "not filial [adj]\n",
  "NONFILTERABLE": "not filterable [adj]\n",
  "NONFINAL": "not being the last [adj]\n",
  "NONFINANCIAL": "not financial [adj]\n",
  "NONFINITE": "not finite [adj]\n",
  "NONFISCAL": "not fiscal [adj]\n",
  "NONFISSIONABLE": "not fissionable [adj]\n",
  "NONFLAMMABILITY": "the state of being nonflammable [n]\n",
  "NONFLAMMABLE": "not flammable [adj]\n",
  "NONFLOWERING": "not flowering [adj]\n",
  "NONFLUENCIES": "NONFLUENCY, an absence of fluency [n]\n",
  "NONFLUENCY": "an absence of fluency [n NONFLUENCIES]\n",
  "NONFLUID": "a substance that is not a fluid [n -S]\n",
  "NONFLUIDS": "NONFLUID, a substance that is not a fluid [n]\n",
  "NONFLUORESCENT": "not fluorescent [adj]\n",
  "NONFLYING": "not flying [adj]\n",
  "NONFOCAL": "not focal [adj]\n",
  "NONFOOD": "an item that is not food or is inedible [n -S]\n",
  "NONFOODS": "NONFOOD, an item that is not food or is inedible [n]\n",
  "NONFORFEITABLE": "not forfeitable [adj]\n",
  "NONFORFEITURE": "something that is not forfeiture [n -S]\n",
  "NONFORFEITURES": "NONFORFEITURE, something that is not forfeiture [n]\n",
  "NONFORMAL": "not formal [adj]\n",
  "NONFOSSIL": "not fossil [adj]\n",
  "NONFREEZING": "not freezing [adj]\n",
  "NONFRIVOLOUS": "not frivolous [adj]\n",
  "NONFROZEN": "not frozen [adj]\n",
  "NONFUEL": "a type of energy not used for generating heat, power, or electricity [n -S]\n",
  "NONFUELS": "NONFUEL, a type of energy not used for generating heat, power, or electricity [n]\n",
  "NONFULFILLMENT": "something that is not fulfillment, also NONFULFILMENT [n -S]\n",
  "NONFULFILLMENTS": "NONFULFILLMENT, something that is not fulfillment, also NONFULFILMENT [n]\n",
  "NONFULFILMENT": "the event or act of a promise, threat, request, hope, duty, etc. not happening, also NONFULFILLMENT [n -S]\n",
  "NONFULFILMENTS": "NONFULFILMENT, the event or act of a promise, threat, request, hope, duty, etc. not happening, also NONFULFILLMENT [n]\n",
  "NONFUNCTIONAL": "not functional [adj]\n",
  "NONFUNCTIONING": "not functioning [adj]\n",
  "NONFUNDED": "not funded [adj]\n",
  "NONG": "(Australian slang) a fool, an idiot [n -S]\n",
  "NONGAME": "not hunted for food, sport, or fur [adj]\n",
  "NONGASEOUS": "not gaseous [adj]\n",
  "NONGAY": "a person who is not homosexual [n -S]\n",
  "NONGAYS": "NONGAY, a person who is not homosexual [n]\n",
  "NONGENETIC": "not genetic [adj]\n",
  "NONGENITAL": "not genital [adj]\n",
  "NONGEOMETRICAL": "not geometrical [adj]\n",
  "NONGHETTO": "not related to a ghetto [adj]\n",
  "NONGLAMOROUS": "not glamorous [adj]\n",
  "NONGLARE": "a material designed to eliminate glare [n -S]\n",
  "NONGLARES": "NONGLARE, a material designed to eliminate glare [n]\n",
  "NONGLAZED": "not glazed [adj]\n",
  "NONGLOSSY": "not glossy [adj]\n",
  "NONGOLFER": "someone who is not a golfer [n -S]\n",
  "NONGOLFERS": "NONGOLFER, someone who is not a golfer [n]\n",
  "NONGONOCOCCAL": "not caused by a gonococcus [adj]\n",
  "NONGOVERNMENT": "not related to government, also NONGOVERNMENTAL [adj]\n",
  "NONGOVERNMENTAL": "not governmental, also NONGOVERNMENT [adj]\n",
  "NONGRADED": "not graded [adj]\n",
  "NONGRADUATE": "one who is not a graduate [n -S]\n",
  "NONGRADUATES": "NONGRADUATE, one who is not a graduate [n]\n",
  "NONGRAMMATICAL": "not grammatical [adj]\n",
  "NONGRANULAR": "not granular [adj]\n",
  "NONGREASY": "not greasy [adj]\n",
  "NONGREEN": "not green [adj]\n",
  "NONGREGARIOUS": "not gregarious [adj]\n",
  "NONGROWING": "not growing [adj]\n",
  "NONGROWTH": "the failure to grow [n -S]\n",
  "NONGROWTHS": "NONGROWTH, the failure to grow [n]\n",
  "NONGS": "NONG, (Australian slang) a fool, an idiot [n]\n",
  "NONGUEST": "someone who is not a guest [n -S]\n",
  "NONGUESTS": "NONGUEST, someone who is not a guest [n]\n",
  "NONGUILT": "the absence of guilt [n -S]\n",
  "NONGUILTS": "NONGUILT, the absence of guilt [n]\n",
  "NONHAEMOLYTIC": "not haemolytic, also NONHEMOLYTIC [adj]\n",
  "NONHALOGENATED": "not halogenated [adj]\n",
  "NONHANDICAPPED": "not handicapped [adj]\n",
  "NONHAPPENING": "an event of no importance [n -S]\n",
  "NONHAPPENINGS": "NONHAPPENING, an event of no importance [n]\n",
  "NONHARDY": "not hardy [adj]\n",
  "NONHARMONIC": "not harmonic [adj]\n",
  "NONHAZARDOUS": "not hazardous [adj]\n",
  "NONHEME": "not containing iron bound like heme [adj]\n",
  "NONHEMOLYTIC": "not hemolytic, also NONHAEMOLYTIC [adj]\n",
  "NONHEREDITARY": "not hereditary [adj]\n",
  "NONHERO": "one who is not a hero [n -ES]\n",
  "NONHEROES": "NONHERO, one who is not a hero [n]\n",
  "NONHEROIC": "not heroic [adj]\n",
  "NONHIERARCHICAL": "not hierarchical [adj]\n",
  "NONHISTONE": "denoting a substance that is not a histone [adj]\n",
  "NONHISTORICAL": "not historical [adj]\n",
  "NONHOME": "not taking place in the home [adj]\n",
  "NONHOMOGENEITY": "the state of being not homogeneous [n]\n",
  "NONHOMOGENEOUS": "not homogeneous [adj]\n",
  "NONHOMOLOGOUS": "not homologous [adj]\n",
  "NONHOMOSEXUAL": "one who is not homosexual [n -S]\n",
  "NONHOMOSEXUALS": "NONHOMOSEXUAL, one who is not homosexual [n]\n",
  "NONHORMONAL": "not hormonal [adj]\n",
  "NONHOSPITAL": "not linked to a hospital [adj]\n",
  "NONHOSPITALISED": "not hospitalised, also NONHOSPITALIZED [adj]\n",
  "NONHOSPITALIZED": "not hospitalized, also NONHOSPITALISED [adj]\n",
  "NONHOSTILE": "not hostile [adj]\n",
  "NONHOUSING": "of a development, not related to housing [adj]\n",
  "NONHUMAN": "a creature that is not human [n -S]\n",
  "NONHUMANS": "NONHUMAN, a creature that is not human [n]\n",
  "NONHUNTER": "one who does not hunt [n -S]\n",
  "NONHUNTERS": "NONHUNTER, one who does not hunt [n]\n",
  "NONHUNTING": "not given to hunting [adj]\n",
  "NONHYGROSCOPIC": "not hygroscopic [adj]\n",
  "NONHYSTERICAL": "not hysterical [adj]\n",
  "NONI": "(Hawaiian) a tree of SE Asia whose fruit provides a possibly health-promoting juice [n -S]\n",
  "NONIDEAL": "not ideal [adj]\n",
  "NONIDENTICAL": "not identical [adj]\n",
  "NONIDENTITIES": "NONIDENTITY, something that is not an identity [n]\n",
  "NONIDENTITY": "something that is not an identity [n NONIDENTITIES]\n",
  "NONIDEOLOGICAL": "not ideological [adj]\n",
  "NONILLION": "the 10th power of a thousand [n -S]\n",
  "NONILLIONS": "NONILLION, the 10th power of a thousand [n]\n",
  "NONILLIONTH": "the ordinal of nonillion [n -S]\n",
  "NONILLIONTHS": "NONILLIONTH, the ordinal of nonillion [n]\n",
  "NONIMAGE": "a person who has no image i.e. is not a celebrity [n -S]\n",
  "NONIMAGES": "NONIMAGE, a person who has no image i.e. is not a celebrity [n]\n",
  "NONIMITATIVE": "not imitative [adj]\n",
  "NONIMMIGRANT": "one who is not an immigrant [n -S]\n",
  "NONIMMIGRANTS": "NONIMMIGRANT, one who is not an immigrant [n]\n",
  "NONIMMUNE": "not immune [adj]\n",
  "NONIMPACT": "a lack of impact [n -S]\n",
  "NONIMPACTS": "NONIMPACT, a lack of impact [n]\n",
  "NONIMPLICATION": "the fact of not being implicated [n -S]\n",
  "NONIMPLICATIONS": "NONIMPLICATION, the fact of not being implicated [n]\n",
  "NONIMPORTATION": "something that is not importation [n -S]\n",
  "NONIMPORTATIONS": "NONIMPORTATION, something that is not importation [n]\n",
  "NONINCLUSION": "something that is not an inclusion [n -S]\n",
  "NONINCLUSIONS": "NONINCLUSION, something that is not an inclusion [n]\n",
  "NONINCREASING": "not increasing [adj]\n",
  "NONINCUMBENT": "one who is not an incumbent [n -S]\n",
  "NONINCUMBENTS": "NONINCUMBENT, one who is not an incumbent [n]\n",
  "NONINDEPENDENCE": "not independence [n]\n",
  "NONINDICTABLE": "of an offence, not indictable [adj]\n",
  "NONINDIGENOUS": "not indigenous [adj]\n",
  "NONINDIVIDUAL": "an entity that is not an individual [n -S]\n",
  "NONINDIVIDUALS": "NONINDIVIDUAL, an entity that is not an individual [n]\n",
  "NONINDUCTIVE": "not inductive [adj]\n",
  "NONINDUSTRIAL": "not industrial [adj]\n",
  "NONINDUSTRY": "not related to industry [adj]\n",
  "NONINERT": "not inert [adj]\n",
  "NONINFECTED": "not infected [adj]\n",
  "NONINFECTIOUS": "not infectious [adj]\n",
  "NONINFECTIVE": "not infective [adj]\n",
  "NONINFESTED": "not infested [adj]\n",
  "NONINFLAMMABLE": "not inflammable [adj]\n",
  "NONINFLAMMATORY": "not inflammatory [adj]\n",
  "NONINFLATIONARY": "not inflationary [adj]\n",
  "NONINFLECTIONAL": "not inflectional [adj]\n",
  "NONINFLUENCE": "something that is not an influence [n -S]\n",
  "NONINFLUENCES": "NONINFLUENCE, something that is not an influence [n]\n",
  "NONINFORMATION": "something that is not information [n -S]\n",
  "NONINFORMATIONS": "NONINFORMATION, something that is not information [n]\n",
  "NONINFRINGEMENT": "something that is not an infringement [n]\n",
  "NONINITIAL": "not initial [adj]\n",
  "NONINITIATE": "one who is not an initiate [n -S]\n",
  "NONINITIATES": "NONINITIATE, one who is not an initiate [n]\n",
  "NONINJURY": "relating to something that is not an injury [adj]\n",
  "NONINSECT": "a creature that is not an insect [n -S]\n",
  "NONINSECTICIDAL": "not insecticidal [adj]\n",
  "NONINSECTS": "NONINSECT, a creature that is not an insect [n]\n",
  "NONINSTALLMENT": "something that is not an installment [n -S]\n",
  "NONINSTALLMENTS": "NONINSTALLMENT, something that is not an installment [n]\n",
  "NONINSTALMENT": "(of a loan) not payable in instalments [adj]\n",
  "NONINSTRUMENTAL": "of music, not using instruments [adj]\n",
  "NONINSURANCE": "the condition or state of not having insurance [n -S]\n",
  "NONINSURANCES": "NONINSURANCE, the condition or state of not having insurance [n]\n",
  "NONINSURED": "not insured [adj]\n",
  "NONINTEGRAL": "not integral [adj]\n",
  "NONINTEGRATED": "not integrated [adj]\n",
  "NONINTELLECTUAL": "not intellectual [adj]\n",
  "NONINTERACTING": "not interacting [adj]\n",
  "NONINTERACTIVE": "not interactive [adj]\n",
  "NONINTERCOURSE": "something that is not intercourse [n -S]\n",
  "NONINTERCOURSES": "NONINTERCOURSE, something that is not intercourse [n]\n",
  "NONINTEREST": "of a payment, not related to interest [adj]\n",
  "NONINTERFERENCE": "absence of interference [n]\n",
  "NONINTERSECTING": "not intersecting [adj]\n",
  "NONINTERVENTION": "the state or policy of not intervening [n]\n",
  "NONINTIMIDATING": "not intimidating [adj]\n",
  "NONINTOXICANT": "a substance that is not an intoxicant [n -S]\n",
  "NONINTOXICANTS": "NONINTOXICANT, a substance that is not an intoxicant [n]\n",
  "NONINTOXICATING": "not intoxicating [adj]\n",
  "NONINTRUSIVE": "not intrusive [adj]\n",
  "NONINTUITIVE": "not intuitive [adj]\n",
  "NONINVASIVE": "not tending to spread [adj]\n",
  "NONINVOLVED": "not involved [adj]\n",
  "NONINVOLVEMENT": "absence of involvement or emotional attachment [n -S]\n",
  "NONINVOLVEMENTS": "NONINVOLVEMENT, absence of involvement or emotional attachment [n]\n",
  "NONIONIC": "not ionic [adj]\n",
  "NONIONISING": "not resulting in ionization, also NONIONIZING [adj]\n",
  "NONIONIZING": "not ionizing, also NONIONISING [adj]\n",
  "NONIRON": "not needing to be ironed [adj]\n",
  "NONIRRADIATED": "not irradiated [adj]\n",
  "NONIRRIGATED": "not irrigated [adj]\n",
  "NONIRRITANT": "something that is not an irritant [n -S]\n",
  "NONIRRITANTS": "NONIRRITANT, something that is not an irritant [n]\n",
  "NONIRRITATING": "not irritating [adj]\n",
  "NONIS": "NONI, (Hawaiian) a tree of SE Asia whose fruit provides a possibly health-promoting juice [n]\n",
  "NONISSUE": "a topic that is not controversial [n -S]\n",
  "NONISSUES": "NONISSUE, a topic that is not controversial [n]\n",
  "NONJOINDER": "the omission of some person who ought to have been made a plaintiff or defendant in a suit, or of some cause of action which ought to be joined [n -S]\n",
  "NONJOINDERS": "NONJOINDER, the omission of some person who ought to have been made a plaintiff or defendant in a suit, or of some cause of action which ought to be joined [n]\n",
  "NONJOINER": "one who does not join [n -S]\n",
  "NONJOINERS": "NONJOINER, one who does not join [n]\n",
  "NONJUDGEMENTAL": "avoiding judgments based on one's personal and esp. moral standards, also NONJUDGMENTAL [adj]\n",
  "NONJUDGMENTAL": "avoiding judgments based on one's personal and esp. moral standards, also NONJUDGEMENTAL [adj]\n",
  "NONJUDICIAL": "not judicial [adj]\n",
  "NONJURIES": "NONJURY, a trial without jury [n]\n",
  "NONJURING": "not swearing allegiance; applied to the party in Great Britain that would not swear allegiance to William and Mary, or their successors [adj]\n",
  "NONJUROR": "one of those adherents of James II who refused to take the oath of allegiance to William and Mary, or to their successors, after the revolution of 1688; a Jacobite [n -S]\n",
  "NONJURORS": "NONJUROR, one of those adherents of James II who refused to take the oath of allegiance to William and Mary, or to their successors, after the revolution of 1688; a Jacobite [n]\n",
  "NONJURY": "not involving a jury [adj] / a trial without jury [n NONJURIES]\n",
  "NONJUSTICIABLE": "not justiciable, liable to trial [adj]\n",
  "NONKIN": "those who are not kin [n -S]\n",
  "NONKINS": "NONKIN, those who are not kin [n]\n",
  "NONKOSHER": "not kosher [adj] / food that is not kosher [n -S]\n",
  "NONKOSHERS": "NONKOSHER, food that is not kosher [n]\n",
  "NONLABOR": "not relating to or concerned with work, also NONLABOUR [adj]\n",
  "NONLABOUR": "not relating to or concerned with work, also NONLABOR [adj]\n",
  "NONLADDERING": "of e.g. tights, not given to laddering [adj]\n",
  "NONLANDOWNER": "one who is not a landowner [n -S]\n",
  "NONLANDOWNERS": "NONLANDOWNER, one who is not a landowner [n]\n",
  "NONLANGUAGE": "something that is not a language [n -S]\n",
  "NONLANGUAGES": "NONLANGUAGE, something that is not a language [n]\n",
  "NONLAWYER": "one who is not a lawyer [n -S]\n",
  "NONLAWYERS": "NONLAWYER, one who is not a lawyer [n]\n",
  "NONLEADED": "not leaded [adj]\n",
  "NONLEAFY": "having no leaves [adj]\n",
  "NONLEAGUE": "of a sporting club, not in the league [adj]\n",
  "NONLEGAL": "not legal [adj]\n",
  "NONLEGUME": "a plant that is not a legume [n -S]\n",
  "NONLEGUMES": "NONLEGUME, a plant that is not a legume [n]\n",
  "NONLEGUMINOUS": "not leguminous [adj]\n",
  "NONLETHAL": "not lethal [adj]\n",
  "NONLEVEL": "not level [adj]\n",
  "NONLEXICAL": "not lexical [adj]\n",
  "NONLIABLE": "not liable [adj]\n",
  "NONLIBRARIAN": "one who is not a librarian [n -S]\n",
  "NONLIBRARIANS": "NONLIBRARIAN, one who is not a librarian [n]\n",
  "NONLIBRARY": "not associated with a library [adj]\n",
  "NONLIFE": "the absence of life [n NONLIVES]\n",
  "NONLINEAL": "not lineal [adj]\n",
  "NONLINEAR": "not linear [adj]\n",
  "NONLINEARITIES": "NONLINEARITY, the state of being nonlinear [n]\n",
  "NONLINEARITY": "the state of being nonlinear [n NONLINEARITIES]\n",
  "NONLINGUISTIC": "not linguistic [adj]\n",
  "NONLIQUID": "something that is not a liquid [n -S]\n",
  "NONLIQUIDS": "NONLIQUID, something that is not a liquid [n]\n",
  "NONLITERAL": "not literal [adj]\n",
  "NONLITERARY": "not literary [adj]\n",
  "NONLITERATE": "one who is not literate [n -S]\n",
  "NONLITERATES": "NONLITERATE, one who is not literate [n]\n",
  "NONLIVES": "NONLIFE, the absence of life [n]\n",
  "NONLIVING": "not living [adj] / something not living [n -S]\n",
  "NONLIVINGS": "NONLIVING, something not living [n]\n",
  "NONLOCAL": "one that is not local [n -S]\n",
  "NONLOCALS": "NONLOCAL, one that is not local [n]\n",
  "NONLOGICAL": "not logical [adj NONLOGICALLY]\n",
  "NONLOGICALLY": "NONLOGICAL, not logical [adv]\n",
  "NONLOVING": "not loving [adj]\n",
  "NONLOYAL": "not loyal [adj]\n",
  "NONLUMINOUS": "not luminous [adj]\n",
  "NONLYRIC": "of music, not having lyrics [adj]\n",
  "NONMAGNETIC": "not magnetic [adj]\n",
  "NONMAINSTREAM": "not mainstream [adj]\n",
  "NONMAJOR": "a student who is not majoring in a specific subject [n -S]\n",
  "NONMAJORS": "NONMAJOR, a student who is not majoring in a specific subject [n]\n",
  "NONMALICIOUS": "not malicious [adj]\n",
  "NONMALIGNANT": "not malignant [adj]\n",
  "NONMALLEABLE": "not malleable [adj]\n",
  "NONMAN": "a being that is not a man [n NONMEN]\n",
  "NONMANAGEMENT": "not related to management [adj]\n",
  "NONMANAGERIAL": "not managerial [adj]\n",
  "NONMANDATORY": "not mandatory [adj]\n",
  "NONMANUAL": "not manual [adj]\n",
  "NONMARITAL": "not marital [adj]\n",
  "NONMARKET": "not part of the market [adj] / something that is not a market [n -S]\n",
  "NONMARKETS": "NONMARKET, something that is not a market [n]\n",
  "NONMATERIAL": "not material [adj]\n",
  "NONMATHEMATICAL": "not mathematical [adj]\n",
  "NONMATRICULATED": "not matriculated [adj]\n",
  "NONMATURE": "not mature [adj]\n",
  "NONMEANINGFUL": "not meaningful [adj]\n",
  "NONMEASURABLE": "not measurable [adj]\n",
  "NONMEAT": "a substance that does not contain meat [n -S]\n",
  "NONMEATS": "NONMEAT, a substance that does not contain meat [n]\n",
  "NONMECHANICAL": "not mechanical [adj]\n",
  "NONMECHANISTIC": "not mechanistic [adj]\n",
  "NONMEDICAL": "not medical [adj]\n",
  "NONMEETING": "something that is not a meeting [n -S]\n",
  "NONMEETINGS": "NONMEETING, something that is not a meeting [n]\n",
  "NONMEMBER": "one who is not a member [n -S]\n",
  "NONMEMBERS": "NONMEMBER, one who is not a member [n]\n",
  "NONMEMBERSHIP": "the state of being a nonmember [n -S]\n",
  "NONMEMBERSHIPS": "NONMEMBERSHIP, the state of being a nonmember [n]\n",
  "NONMEN": "NONMAN, a being that is not a man [n]\n",
  "NONMENTAL": "not mental [adj]\n",
  "NONMERCURIAL": "not mercurial [adj]\n",
  "NONMETAL": "an element that lacks metallic properties [n -S]\n",
  "NONMETALLIC": "not metallic [adj]\n",
  "NONMETALS": "NONMETAL, an element that lacks metallic properties [n]\n",
  "NONMETAMERIC": "not metameric [adj]\n",
  "NONMETAPHORICAL": "not metaphorical [adj]\n",
  "NONMETRIC": "not metric [adj]\n",
  "NONMETRICAL": "not metrical [adj]\n",
  "NONMETRO": "not metropolitan [adj]\n",
  "NONMETROPOLITAN": "not metropolitan [adj]\n",
  "NONMICROBIAL": "not microbial [adj]\n",
  "NONMIGRANT": "a person or animal that does not move around [n -S]\n",
  "NONMIGRANTS": "NONMIGRANT, a person or animal that does not move around [n]\n",
  "NONMIGRATORY": "not migratory [adj]\n",
  "NONMILITANT": "one who is not militant [n -S]\n",
  "NONMILITANTS": "NONMILITANT, one who is not militant [n]\n",
  "NONMILITARY": "not military [adj]\n",
  "NONMIMETIC": "not mimetic [adj]\n",
  "NONMINORITIES": "NONMINORITY, something that is not a minority [n]\n",
  "NONMINORITY": "something that is not a minority [n NONMINORITIES]\n",
  "NONMOBILE": "not mobile [adj]\n",
  "NONMODAL": "not modal [adj]\n",
  "NONMODERN": "not modern [adj] / one who is not modern [n -S]\n",
  "NONMODERNS": "NONMODERN, one who is not modern [n]\n",
  "NONMOLECULAR": "not molecular [adj]\n",
  "NONMONETARIST": "something that is not monetarist [n -S]\n",
  "NONMONETARISTS": "NONMONETARIST, something that is not monetarist [n]\n",
  "NONMONETARY": "not monetary [adj]\n",
  "NONMONEY": "not involving money [adj]\n",
  "NONMONOGAMOUS": "not monogamous [adj]\n",
  "NONMORAL": "not pertaining to morals [adj]\n",
  "NONMORTAL": "not mortal [adj] / one who is not mortal [n -S]\n",
  "NONMORTALS": "NONMORTAL, one who is not mortal [n]\n",
  "NONMOTILE": "not motile [adj]\n",
  "NONMOTILITIES": "NONMOTILITY, the state of being nonmotile [n]\n",
  "NONMOTILITY": "the state of being nonmotile [n NONMOTILITIES]\n",
  "NONMOTORISED": "not motorised, also NONMOTORIZED [adj]\n",
  "NONMOTORIZED": "not motorized, also NONMOTORISED [adj]\n",
  "NONMOVING": "not moving [adj]\n",
  "NONMUNICIPAL": "not municipal [adj]\n",
  "NONMUSIC": "inferior music [n -S]\n",
  "NONMUSICAL": "not musical [adj] / a show that is not a musical [n -S]\n",
  "NONMUSICALS": "NONMUSICAL, a show that is not a musical [n]\n",
  "NONMUSICIAN": "one who is not a musician [n -S]\n",
  "NONMUSICIANS": "NONMUSICIAN, one who is not a musician [n]\n",
  "NONMUSICS": "NONMUSIC, inferior music [n]\n",
  "NONMUTANT": "one who is not a mutant [n -S]\n",
  "NONMUTANTS": "NONMUTANT, one who is not a mutant [n]\n",
  "NONMUTUAL": "not mutual [adj]\n",
  "NONMYELINATED": "not myelinated [adj]\n",
  "NONMYSTICAL": "not mystical [adj]\n",
  "NONNARRATIVE": "not narrative [adj]\n",
  "NONNASAL": "not nasal [adj]\n",
  "NONNATIONAL": "one who is not a national [n -S]\n",
  "NONNATIONALS": "NONNATIONAL, one who is not a national [n]\n",
  "NONNATIVE": "one who is not a native [n -S]\n",
  "NONNATIVES": "NONNATIVE, one who is not a native [n]\n",
  "NONNATURAL": "not natural [adj]\n",
  "NONNAVAL": "not naval [adj]\n",
  "NONNECESSITIES": "NONNECESSITY, something that is not a necessity [n]\n",
  "NONNECESSITY": "something that is not a necessity [n NONNECESSITIES]\n",
  "NONNEGATIVE": "not negative [adj]\n",
  "NONNEGLIGENT": "not negligent [adj]\n",
  "NONNEGOTIABLE": "not negotiable [adj] / a condition that must be observed [n -S]\n",
  "NONNEGOTIABLES": "NONNEGOTIABLE, a condition that must be observed [n]\n",
  "NONNETWORK": "not included in a network [adj]\n",
  "NONNEURAL": "not neural [adj]\n",
  "NONNEWS": "not being news [adj]\n",
  "NONNIES": "NONNY, a meaningless word in ballads [n]\n",
  "NONNITROGENOUS": "not nitrogenous [adj]\n",
  "NONNOBLE": "not noble [adj]\n",
  "NONNORMAL": "not normal [adj]\n",
  "NONNORMATIVE": "not normative [adj]\n",
  "NONNOVEL": "a literary work that is not a novel [n -S]\n",
  "NONNOVELS": "NONNOVEL, a literary work that is not a novel [n]\n",
  "NONNUCLEAR": "not nuclear [adj]\n",
  "NONNUCLEATED": "not nucleated [adj]\n",
  "NONNUMERICAL": "not numerical [adj]\n",
  "NONNUTRITIOUS": "not nutritious [adj]\n",
  "NONNUTRITIVE": "not nutritive [adj]\n",
  "NONNY": "a meaningless word in ballads [n NONNIES]\n",
  "NONOBESE": "not obese [adj]\n",
  "NONOBJECTIVE": "not objective [adj]\n",
  "NONOBJECTIVISM": "the state of being nonobjective [n -S]\n",
  "NONOBJECTIVISMS": "NONOBJECTIVISM, the state of being nonobjective [n]\n",
  "NONOBJECTIVIST": "a practitioner of nonobjective art [n -S]\n",
  "NONOBJECTIVISTS": "NONOBJECTIVIST, a practitioner of nonobjective art [n]\n",
  "NONOBJECTIVITY": "the state of being nonobjective [n]\n",
  "NONOBSCENE": "not obscene [adj]\n",
  "NONOBSERVANCE": "a lack of observance [n -S]\n",
  "NONOBSERVANCES": "NONOBSERVANCE, a lack of observance [n]\n",
  "NONOBSERVANT": "not observant [adj]\n",
  "NONOBVIOUS": "that which is not obvious [n -ES]\n",
  "NONOBVIOUSES": "NONOBVIOUS, that which is not obvious [n]\n",
  "NONOCCUPATIONAL": "not occupational [adj]\n",
  "NONOCCURRENCE": "something that is not occurrence [n -S]\n",
  "NONOCCURRENCES": "NONOCCURRENCE, something that is not occurrence [n]\n",
  "NONOFFICIAL": "one who is not an official [n -S]\n",
  "NONOFFICIALS": "NONOFFICIAL, one who is not an official [n]\n",
  "NONOHMIC": "not measured in ohms [adj]\n",
  "NONOILY": "not oily [adj]\n",
  "NONOPERATIC": "not operatic [adj]\n",
  "NONOPERATING": "not in operation [adj]\n",
  "NONOPERATIONAL": "not operational [adj]\n",
  "NONOPERATIVE": "not operative [adj]\n",
  "NONOPTIMAL": "not optimal [adj]\n",
  "NONORAL": "not oral [adj NONORALLY]\n",
  "NONORALLY": "NONORAL, not oral [adv]\n",
  "NONORGANIC": "not organic [adj]\n",
  "NONORGASMIC": "not capable of experiencing orgasm [adj]\n",
  "NONORTHODOX": "not orthodox [adj]\n",
  "NONOVERLAPPING": "not overlapping [adj]\n",
  "NONOWNER": "one who is not the owner [n -S]\n",
  "NONOWNERS": "NONOWNER, one who is not the owner [n]\n",
  "NONOXIDISING": "not oxidising, also NONOXIDIZING [adj]\n",
  "NONOXIDIZING": "not oxidizing, also NONOXIDISING [adj]\n",
  "NONPAGAN": "one who is not a pagan [n -S]\n",
  "NONPAGANS": "NONPAGAN, one who is not a pagan [n]\n",
  "NONPAID": "not paid [adj]\n",
  "NONPAPAL": "not connected with the papacy [adj]\n",
  "NONPAPIST": "one who is not a papist [n -S]\n",
  "NONPAPISTS": "NONPAPIST, one who is not a papist [n]\n",
  "NONPAR": "being a stock that has no face value [adj]\n",
  "NONPARALLEL": "not parallel [adj]\n",
  "NONPARAMETRIC": "not involving the estimation of parameters of a statistical function [adj]\n",
  "NONPARASITIC": "not parasitic [adj]\n",
  "NONPAREIL": "(French) of unparalleled excellence [adj] / a fine variety of apple; also, generally, a thing of unequalled excellence; a paragon [n -S]\n",
  "NONPAREILS": "NONPAREIL, a fine variety of apple; also, generally, a thing of unequalled excellence; a paragon [n]\n",
  "NONPARENT": "one who is not a parent [n -S]\n",
  "NONPARENTS": "NONPARENT, one who is not a parent [n]\n",
  "NONPARITIES": "NONPARITY, the state of not being equal [n]\n",
  "NONPARITY": "the state of not being equal [n NONPARITIES]\n",
  "NONPAROUS": "having not given birth to any offspring [adj]\n",
  "NONPARTICIPANT": "one who is not a participant [n -S]\n",
  "NONPARTICIPANTS": "NONPARTICIPANT, one who is not a participant [n]\n",
  "NONPARTIES": "NONPARTY, an organisation which is not a political party [n]\n",
  "NONPARTISAN": "not partisan [adj]\n",
  "NONPARTISANSHIP": "the state of being nonpartisan [n]\n",
  "NONPARTIZAN": "not partizan [adj]\n",
  "NONPARTIZANSHIP": "an absence of partizanship [n]\n",
  "NONPARTY": "not affiliated with any political party [adj] / an organisation which is not a political party [n NONPARTIES]\n",
  "NONPASSERINE": "not passerine [adj]\n",
  "NONPASSIVE": "not passive [adj]\n",
  "NONPAST": "a verb form that lacks a past tense inflection [n -S]\n",
  "NONPASTS": "NONPAST, a verb form that lacks a past tense inflection [n]\n",
  "NONPATHOGENIC": "not causing disease [adj]\n",
  "NONPAYING": "not paying [adj]\n",
  "NONPAYMENT": "neglect or failure to pay [n -S]\n",
  "NONPAYMENTS": "NONPAYMENT, neglect or failure to pay [n]\n",
  "NONPEAK": "a period of low demand [n -S]\n",
  "NONPEAKS": "NONPEAK, a period of low demand [n]\n",
  "NONPECUNIARY": "not pecuniary [adj]\n",
  "NONPERFORMANCE": "something that is not a performance [n -S]\n",
  "NONPERFORMANCES": "NONPERFORMANCE, something that is not a performance [n]\n",
  "NONPERFORMER": "one who is not a performer [n -S]\n",
  "NONPERFORMERS": "NONPERFORMER, one who is not a performer [n]\n",
  "NONPERFORMING": "not producing the expected return [adj]\n",
  "NONPERISHABLE": "not perishable [adj] / something that is not perishable [n -S]\n",
  "NONPERISHABLES": "NONPERISHABLE, something that is not perishable [n]\n",
  "NONPERMANENT": "not permanent [adj]\n",
  "NONPERMISSIVE": "not permissive [adj]\n",
  "NONPERSISTENT": "not persistent [adj]\n",
  "NONPERSON": "someone without the rights of a person [n -S]\n",
  "NONPERSONAL": "not personal [adj]\n",
  "NONPERSONS": "NONPERSON, someone without the rights of a person [n]\n",
  "NONPETROLEUM": "not derived from petroleum [adj]\n",
  "NONPHILOSOPHER": "someone who is not a philosopher [n -S]\n",
  "NONPHILOSOPHERS": "NONPHILOSOPHER, someone who is not a philosopher [n]\n",
  "NONPHONEMIC": "not phonemic [adj]\n",
  "NONPHONETIC": "not phonetic [adj]\n",
  "NONPHOSPHATE": "not phosphate [adj]\n",
  "NONPHOTOGRAPHIC": "not photographic [adj]\n",
  "NONPHYSICAL": "not physical [adj]\n",
  "NONPHYSICIAN": "one who is not a physician [n -S]\n",
  "NONPHYSICIANS": "NONPHYSICIAN, one who is not a physician [n]\n",
  "NONPLANAR": "not planar [adj]\n",
  "NONPLASTIC": "something that is not a plastic [n -S]\n",
  "NONPLASTICS": "NONPLASTIC, something that is not a plastic [n]\n",
  "NONPLAY": "a theatrical work that is not a play [n -S]\n",
  "NONPLAYER": "one who is not a player [n -S]\n",
  "NONPLAYERS": "NONPLAYER, one who is not a player [n]\n",
  "NONPLAYING": "not playing [adj]\n",
  "NONPLAYS": "NONPLAY, a theatrical work that is not a play [n]\n",
  "NONPLIANT": "not pliant [adj]\n",
  "NONPLUS": "to take aback, baffle [v NONPLUSSED or NONPLUSED, NONPLUSSING or NONPLUSING, NONPLUSSES or NONPLUSES]\n",
  "NONPLUSED": "NONPLUS, to take aback, baffle [v]\n",
  "NONPLUSES": "NONPLUS, to take aback, baffle [v]\n",
  "NONPLUSING": "NONPLUS, to take aback, baffle [v]\n",
  "NONPLUSSED": "NONPLUS, to take aback, baffle [v]\n",
  "NONPLUSSES": "NONPLUS, to take aback, baffle [v]\n",
  "NONPLUSSING": "NONPLUS, to take aback, baffle [v]\n",
  "NONPOETIC": "not poetic [adj]\n",
  "NONPOINT": "not occurring at a definite point [adj]\n",
  "NONPOISONOUS": "not poisonous [adj]\n",
  "NONPOLAR": "not polar [adj]\n",
  "NONPOLARISABLE": "not polarisable, also NONPOLARIZABLE [adj]\n",
  "NONPOLARIZABLE": "not polarizable, also NONPOLARISABLE [adj]\n",
  "NONPOLICE": "not police [adj]\n",
  "NONPOLITICAL": "not political [adj NONPOLITICALLY]\n",
  "NONPOLITICALLY": "NONPOLITICAL, not political [adv]\n",
  "NONPOLITICIAN": "someone who is not a politician [n -S]\n",
  "NONPOLITICIANS": "NONPOLITICIAN, someone who is not a politician [n]\n",
  "NONPOLLUTING": "not causing pollution [adj]\n",
  "NONPOOR": "a person who is not poor [n -S]\n",
  "NONPOORS": "NONPOOR, a person who is not poor [n]\n",
  "NONPOPULAR": "not popular [adj]\n",
  "NONPOROUS": "not porous [adj]\n",
  "NONPORTABLE": "not portable [adj]\n",
  "NONPOSSESSION": "something that is not a possession [n -S]\n",
  "NONPOSSESSIONS": "NONPOSSESSION, something that is not a possession [n]\n",
  "NONPOSTAL": "not postal [adj]\n",
  "NONPRACTICAL": "not practical [adj]\n",
  "NONPRACTICING": "not practicing [adj]\n",
  "NONPRACTISING": "not practising [adj]\n",
  "NONPREGNANT": "not pregnant [adj]\n",
  "NONPREHENSILE": "not prehensile [adj]\n",
  "NONPRESCRIPTION": "capable of being bought without a doctor's prescription [adj]\n",
  "NONPRINT": "not involving printed matter [adj]\n",
  "NONPRINTING": "not printing [adj]\n",
  "NONPROBLEM": "something that is not a problem [n -S]\n",
  "NONPROBLEMS": "NONPROBLEM, something that is not a problem [n]\n",
  "NONPRODUCING": "not productive [adj]\n",
  "NONPRODUCTIVE": "not productive [adj]\n",
  "NONPRODUCTIVITY": "the state of being nonproductive [n]\n",
  "NONPROFESSIONAL": "not professional [adj]\n",
  "NONPROFESSORIAL": "not professorial [adj]\n",
  "NONPROFIT": "not making a profit [adj] / something that is not profit [n -S]\n",
  "NONPROFITS": "NONPROFIT, something that is not profit [n]\n",
  "NONPROGRAM": "not relating to a program [adj]\n",
  "NONPROGRAMMER": "someone who is not a programmer [n -S]\n",
  "NONPROGRAMMERS": "NONPROGRAMMER, someone who is not a programmer [n]\n",
  "NONPROGRESSIVE": "not progressive [adj]\n",
  "NONPROPRIETARY": "not proprietary [adj]\n",
  "NONPROS": "to enter judgement against a plaintiff [v NONPROSSED, NONPROSSING, NONPROSSES]\n",
  "NONPROSSED": "NONPROS, to enter judgement against a plaintiff [v]\n",
  "NONPROSSES": "NONPROS, to enter judgement against a plaintiff [v]\n",
  "NONPROSSING": "NONPROS, to enter judgement against a plaintiff [v]\n",
  "NONPROTEIN": "not protein [adj]\n",
  "NONPROVEN": "not proven [adj]\n",
  "NONPSYCHIATRIC": "not psychiatric [adj]\n",
  "NONPSYCHIATRIST": "someone who is not a psychiatrist [n]\n",
  "NONPSYCHOTIC": "not psychotic [adj]\n",
  "NONPUBLIC": "not public [adj]\n",
  "NONPUNITIVE": "not punitive [adj]\n",
  "NONPURPOSIVE": "not purposive [adj]\n",
  "NONQUANTIFIABLE": "not quantifiable [adj]\n",
  "NONQUANTITATIVE": "not quantitative [adj]\n",
  "NONQUOTA": "not included in or subject to a quota [adj]\n",
  "NONRACIAL": "not racial [adj NONRACIALLY]\n",
  "NONRACIALLY": "NONRACIAL, not racial [adv]\n",
  "NONRACISM": "an absence or racism [n -S]\n",
  "NONRACISMS": "NONRACISM, an absence or racism [n]\n",
  "NONRADIOACTIVE": "not radioactive [adj]\n",
  "NONRAILROAD": "not related to a railroad [adj]\n",
  "NONRANDOM": "not random [adj]\n",
  "NONRANDOMNESS": "the state of being nonrandom [n -ES]\n",
  "NONRANDOMNESSES": "NONRANDOMNESS, the state of being nonrandom [n]\n",
  "NONRATED": "not rated [adj]\n",
  "NONRATIONAL": "not rational [adj]\n",
  "NONREACTIVE": "not reactive [adj]\n",
  "NONREACTOR": "someone who does not react [n -S]\n",
  "NONREACTORS": "NONREACTOR, someone who does not react [n]\n",
  "NONREADER": "one who is not a reader [n -S]\n",
  "NONREADERS": "NONREADER, one who is not a reader [n]\n",
  "NONREADING": "an inability or disinclination to read [n -S]\n",
  "NONREADINGS": "NONREADING, an inability or disinclination to read [n]\n",
  "NONREALISTIC": "not realistic [adj]\n",
  "NONRECEIPT": "something that is not a receipt [n -S]\n",
  "NONRECEIPTS": "NONRECEIPT, something that is not a receipt [n]\n",
  "NONRECIPROCAL": "not reciprocal [adj]\n",
  "NONRECOGNITION": "something that is not recognition [n -S]\n",
  "NONRECOGNITIONS": "NONRECOGNITION, something that is not recognition [n]\n",
  "NONRECOMBINANT": "a gene not exhibiting the results of genetic recombination [n -S]\n",
  "NONRECOMBINANTS": "NONRECOMBINANT, a gene not exhibiting the results of genetic recombination [n]\n",
  "NONRECOURSE": "being or based on an agreement in which the lender has no right of recourse to the borrower's assets beyond stated limits [adj]\n",
  "NONRECOVERABLE": "that cannot be recovered [adj]\n",
  "NONRECURRENT": "not recurring [adj]\n",
  "NONRECURRING": "not recurring [adj]\n",
  "NONRECYCLABLE": "not recyclable [adj] / something not recyclable [n -S]\n",
  "NONRECYCLABLES": "NONRECYCLABLE, something not recyclable [n]\n",
  "NONREDUCING": "not reducing [adj]\n",
  "NONREDUNDANT": "not redundant [adj]\n",
  "NONREFILLABLE": "not refillable [adj]\n",
  "NONREFLECTING": "not reflecting [adj]\n",
  "NONREFLECTIVE": "not reflective [adj]\n",
  "NONREFLEXIVE": "not reflexive [adj]\n",
  "NONREFUNDABLE": "not subject to refunding or being refunded [adj]\n",
  "NONREGIMENTAL": "not regimental [adj]\n",
  "NONREGULATED": "not regulated [adj]\n",
  "NONREGULATION": "not according to regulations [adj]\n",
  "NONREIGNING": "not reigning [adj]\n",
  "NONRELATIVE": "one who is not a relative [n -S]\n",
  "NONRELATIVES": "NONRELATIVE, one who is not a relative [n]\n",
  "NONRELATIVISTIC": "not based on or involving the theory of relativity [adj]\n",
  "NONRELEVANT": "not relevant [adj]\n",
  "NONRELIGIOUS": "not religious [adj]\n",
  "NONRENEWABLE": "not renewable [adj]\n",
  "NONRENEWAL": "the fact or act of not renewing [n -S]\n",
  "NONRENEWALS": "NONRENEWAL, the fact or act of not renewing [n]\n",
  "NONREPAYABLE": "not repayable [adj]\n",
  "NONREPRODUCTIVE": "not reproductive [adj]\n",
  "NONRESIDENCE": "the state or fact of being nonresident [n -S]\n",
  "NONRESIDENCES": "NONRESIDENCE, the state or fact of being nonresident [n]\n",
  "NONRESIDENCIES": "NONRESIDENCY, the state of not being residential [n]\n",
  "NONRESIDENCY": "the state of not being residential [n NONRESIDENCIES]\n",
  "NONRESIDENT": "one not residing in a particular place [n -S]\n",
  "NONRESIDENTIAL": "not residential [adj]\n",
  "NONRESIDENTS": "NONRESIDENT, one not residing in a particular place [n]\n",
  "NONRESISTANCE": "the principles or practice of passive submission to constituted authority even when unjust or oppressive [n -S]\n",
  "NONRESISTANCES": "NONRESISTANCE, the principles or practice of passive submission to constituted authority even when unjust or oppressive [n]\n",
  "NONRESISTANT": "something not resistant [n -S]\n",
  "NONRESISTANTS": "NONRESISTANT, something not resistant [n]\n",
  "NONRESONANT": "not resonant [adj]\n",
  "NONRESPONDENT": "someone who is not a respondent [n -S]\n",
  "NONRESPONDENTS": "NONRESPONDENT, someone who is not a respondent [n]\n",
  "NONRESPONDER": "one who is not a responder [n -S]\n",
  "NONRESPONDERS": "NONRESPONDER, one who is not a responder [n]\n",
  "NONRESPONSE": "something that is not a response [n -S]\n",
  "NONRESPONSES": "NONRESPONSE, something that is not a response [n]\n",
  "NONRESPONSIVE": "not responsive [adj]\n",
  "NONRESTRICTED": "not restricted [adj]\n",
  "NONRESTRICTIVE": "not restrictive [adj]\n",
  "NONRETRACTILE": "not retractile [adj]\n",
  "NONRETROACTIVE": "not retroactive [adj]\n",
  "NONRETURN": "denoting a mechanism that permits flow in a pipe in one direction only [adj]\n",
  "NONRETURNABLE": "not returnable [adj] / something not returnable [n -S]\n",
  "NONRETURNABLES": "NONRETURNABLE, something not returnable [n]\n",
  "NONREUSABLE": "that cannot be reused [adj]\n",
  "NONREVERSIBLE": "not reversible [adj]\n",
  "NONRHOTIC": "denoting or speaking a dialect of English in which preconsonantal r's are not pronounced [adj]\n",
  "NONRHOTICITIES": "NONRHOTICITY, the state of being nonrhotic, denoting or speaking a dialect of English in which preconsonantal r's are not pronounced [n]\n",
  "NONRHOTICITY": "the state of being nonrhotic, denoting or speaking a dialect of English in which preconsonantal r's are not pronounced [n NONRHOTICITIES]\n",
  "NONRIGID": "not rigid [adj]\n",
  "NONRIOTER": "one who is not a rioter [n -S]\n",
  "NONRIOTERS": "NONRIOTER, one who is not a rioter [n]\n",
  "NONRIOTING": "not rioting [adj]\n",
  "NONRIVAL": "one who is not a rival [n -S]\n",
  "NONRIVALS": "NONRIVAL, one who is not a rival [n]\n",
  "NONROTATING": "not rotating [adj]\n",
  "NONROUTINE": "not routine [adj]\n",
  "NONROYAL": "one who is not of royal birth [n -S]\n",
  "NONROYALS": "NONROYAL, one who is not of royal birth [n]\n",
  "NONRUBBER": "not made of rubber [adj]\n",
  "NONRULING": "not ruling [adj]\n",
  "NONRUMINANT": "an animal that is not a ruminant [n -S]\n",
  "NONRUMINANTS": "NONRUMINANT, an animal that is not a ruminant [n]\n",
  "NONRUN": "of e.g. tights, not given to laddering [adj]\n",
  "NONRUNNER": "one who is not a runner [n -S]\n",
  "NONRUNNERS": "NONRUNNER, one who is not a runner [n]\n",
  "NONRURAL": "not the country [adj]\n",
  "NONSACRED": "not sacred [adj]\n",
  "NONSALABLE": "not salable, also NONSALEABLE [adj]\n",
  "NONSALEABLE": "not capable of being sold, also NONSALABLE [adj]\n",
  "NONSALINE": "not saline [adj]\n",
  "NONSAPONIFIABLE": "not saponifiable, capable of being converted into soap [adj]\n",
  "NONSCHEDULED": "not scheduled [adj]\n",
  "NONSCHOOL": "not related to school [adj]\n",
  "NONSCIENCE": "something that is not a science [n -S]\n",
  "NONSCIENCES": "NONSCIENCE, something that is not a science [n]\n",
  "NONSCIENTIFIC": "not scientific [adj]\n",
  "NONSCIENTIST": "one who is not a scientist [n -S]\n",
  "NONSCIENTISTS": "NONSCIENTIST, one who is not a scientist [n]\n",
  "NONSEASONAL": "not seasonal [adj]\n",
  "NONSECRET": "not secret [adj] / something that is not a secret [n -S]\n",
  "NONSECRETOR": "an individual of blood group A, B, or AB who does not secrete the antigens characteristic of these blood groups [n -S]\n",
  "NONSECRETORS": "NONSECRETOR, an individual of blood group A, B, or AB who does not secrete the antigens characteristic of these blood groups [n]\n",
  "NONSECRETORY": "not secretory [adj]\n",
  "NONSECRETS": "NONSECRET, something that is not a secret [n]\n",
  "NONSECTARIAN": "not having a sectarian character [adj]\n",
  "NONSECURE": "not secure [adj]\n",
  "NONSEDIMENTABLE": "not sedimentable, capable of being sedimented by centrifugation [adj]\n",
  "NONSEGREGATED": "not segregated [adj]\n",
  "NONSEGREGATION": "something that is not segregation [n -S]\n",
  "NONSEGREGATIONS": "NONSEGREGATION, something that is not segregation [n]\n",
  "NONSELECTED": "not selected [adj]\n",
  "NONSELECTIVE": "not selective [adj]\n",
  "NONSELF": "not connected with the self [adj] / something that is not the self [n NONSELVES]\n",
  "NONSELVES": "NONSELF, something that is not the self [n]\n",
  "NONSENSATIONAL": "not sensational [adj]\n",
  "NONSENSE": "anything which makes no sense [n -S]\n",
  "NONSENSES": "NONSENSE, anything which makes no sense [n]\n",
  "NONSENSICAL": "relating to nonsense [adj NONSENSICALLY]\n",
  "NONSENSICALITY": "the state of being nonsensical [n]\n",
  "NONSENSICALLY": "NONSENSICAL, relating to nonsense [adv]\n",
  "NONSENSICALNESS": "the state of being nonsensical [n]\n",
  "NONSENSITIVE": "not sensitive [adj]\n",
  "NONSENSUOUS": "not sensuous [adj]\n",
  "NONSENTENCE": "something that is not a sentence [n -S]\n",
  "NONSENTENCES": "NONSENTENCE, something that is not a sentence [n]\n",
  "NONSEPTATE": "not having a septum [adj]\n",
  "NONSEQUENTIAL": "not sequential [adj]\n",
  "NONSERIAL": "something that is not a serial [n -S]\n",
  "NONSERIALS": "NONSERIAL, something that is not a serial [n]\n",
  "NONSERIOUS": "not serious [adj]\n",
  "NONSEXIST": "not sexist [adj]\n",
  "NONSEXUAL": "having no distinction of sex [adj]\n",
  "NONSHRINK": "of a fabric, resistant to shrinking [adj]\n",
  "NONSHRINKABLE": "not shrinkable [adj]\n",
  "NONSIGNER": "one who does not sign [n -S]\n",
  "NONSIGNERS": "NONSIGNER, one who does not sign [n]\n",
  "NONSIGNIFICANT": "(in cryptography) a symbol or sign without meaning [n -S]\n",
  "NONSIGNIFICANTS": "NONSIGNIFICANT, (in cryptography) a symbol or sign without meaning [n]\n",
  "NONSIMULTANEOUS": "not simultaneous [adj]\n",
  "NONSINKABLE": "that cannot be sunk [adj]\n",
  "NONSINUSOIDAL": "not in the shape of a sinusoid [adj]\n",
  "NONSKATER": "one who is not a skater [n -S]\n",
  "NONSKATERS": "NONSKATER, one who is not a skater [n]\n",
  "NONSKED": "an airline without scheduled flying times [n -S]\n",
  "NONSKEDS": "NONSKED, an airline without scheduled flying times [n]\n",
  "NONSKELETAL": "not skeletal [adj]\n",
  "NONSKID": "designed to inhibit skidding [adj]\n",
  "NONSKIER": "one who does not ski [n -S]\n",
  "NONSKIERS": "NONSKIER, one who does not ski [n]\n",
  "NONSKILLED": "not skilled [adj]\n",
  "NONSLIP": "designed to prevent slipping [adj]\n",
  "NONSMOKER": "one who is not a smoker [n -S]\n",
  "NONSMOKERS": "NONSMOKER, one who is not a smoker [n]\n",
  "NONSMOKING": "not smoking [adj]\n",
  "NONSOCIAL": "not social [adj]\n",
  "NONSOCIALIST": "one who is not a socialist [n -S]\n",
  "NONSOCIALISTS": "NONSOCIALIST, one who is not a socialist [n]\n",
  "NONSOLAR": "not solar [adj]\n",
  "NONSOLID": "a substance that is not a solid [n -S]\n",
  "NONSOLIDS": "NONSOLID, a substance that is not a solid [n]\n",
  "NONSOLUTION": "something that is not a solution [n -S]\n",
  "NONSOLUTIONS": "NONSOLUTION, something that is not a solution [n]\n",
  "NONSOLVENT": "not solvent [adj]\n",
  "NONSPATIAL": "not spatial [adj]\n",
  "NONSPEAKER": "someone who does not speak [n -S]\n",
  "NONSPEAKERS": "NONSPEAKER, someone who does not speak [n]\n",
  "NONSPEAKING": "not speaking [adj]\n",
  "NONSPECIALIST": "one who is not a specialist [n -S]\n",
  "NONSPECIALISTS": "NONSPECIALIST, one who is not a specialist [n]\n",
  "NONSPECIFIC": "of a disease, not caused by any specific, identifiable agent [adj NONSPECIFICALLY]\n",
  "NONSPECIFICALLY": "NONSPECIFIC, of a disease, not caused by any specific, identifiable agent [adv]\n",
  "NONSPECIFICITY": "the state of being nonspecific [n]\n",
  "NONSPECTACULAR": "not spectacular [adj]\n",
  "NONSPECTRAL": "not spectral [adj]\n",
  "NONSPECULAR": "not specular [adj]\n",
  "NONSPECULATIVE": "not speculative [adj]\n",
  "NONSPEECH": "absence of speech [n -ES]\n",
  "NONSPEECHES": "NONSPEECH, absence of speech [n]\n",
  "NONSPHERICAL": "not spherical [adj]\n",
  "NONSPORTING": "lacking the qualities characteristic of a hunting dog [adj]\n",
  "NONSTAINING": "not staining [adj]\n",
  "NONSTANDARD": "not standard [adj]\n",
  "NONSTAPLE": "not staple [adj] / a nonstaple item of food [n -S]\n",
  "NONSTAPLES": "NONSTAPLE, a nonstaple item of food [n]\n",
  "NONSTARTER": "a competitor in a sporting event who does not start; something or someone who has no chance [n -S]\n",
  "NONSTARTERS": "NONSTARTER, a competitor in a sporting event who does not start; something or someone who has no chance [n]\n",
  "NONSTATE": "not relating to the state [adj]\n",
  "NONSTATIC": "not static [adj]\n",
  "NONSTATIONARY": "not stationary [adj]\n",
  "NONSTATISTICAL": "not statistical [adj]\n",
  "NONSTATIVE": "a verb describing an action rather than a state, as for example throw or thank as opposed to know or hate [n -S]\n",
  "NONSTATIVES": "NONSTATIVE, a verb describing an action rather than a state, as for example throw or thank as opposed to know or hate [n]\n",
  "NONSTATUTORY": "not statutory [adj]\n",
  "NONSTEADY": "not steady [adj]\n",
  "NONSTELLAR": "not stellar [adj]\n",
  "NONSTEROID": "a drug that is not a steroid [n -S]\n",
  "NONSTEROIDAL": "of, relating to, or being a compound and esp. a drug that is not a steroid [adj]\n",
  "NONSTEROIDS": "NONSTEROID, a drug that is not a steroid [n]\n",
  "NONSTICK": "designed to prevent sticking [adj]\n",
  "NONSTICKY": "not sticky [adj]\n",
  "NONSTOP": "continuous [adj] / a nonstop flight [n -S]\n",
  "NONSTOPS": "NONSTOP, a nonstop flight [n]\n",
  "NONSTORIES": "NONSTORY, an insignificant news story [n]\n",
  "NONSTORY": "an insignificant news story [n NONSTORIES]\n",
  "NONSTRATEGIC": "not strategic [adj]\n",
  "NONSTRIATED": "not striated [adj]\n",
  "NONSTRIKING": "not striking [adj]\n",
  "NONSTRUCTURAL": "not structural [adj]\n",
  "NONSTRUCTURED": "not structured [adj]\n",
  "NONSTUDENT": "someone who is not a student [n -S]\n",
  "NONSTUDENTS": "NONSTUDENT, someone who is not a student [n]\n",
  "NONSTYLE": "a style which is not identifiable [n -S]\n",
  "NONSTYLES": "NONSTYLE, a style which is not identifiable [n]\n",
  "NONSUBJECT": "one who is not a subject (of a particular country) [n -S]\n",
  "NONSUBJECTIVE": "not subjective [adj]\n",
  "NONSUBJECTS": "NONSUBJECT, one who is not a subject (of a particular country) [n]\n",
  "NONSUBSIDISED": "not subsidised [adj]\n",
  "NONSUBSIDIZED": "not subsidized [adj]\n",
  "NONSUCCESS": "a failure [n -ES]\n",
  "NONSUCCESSES": "NONSUCCESS, a failure [n]\n",
  "NONSUCH": "a person or thing without an equal, also NONESUCH [n -ES]\n",
  "NONSUCHES": "NONSUCH, a person or thing without an equal, also NONESUCH [n]\n",
  "NONSUGAR": "a substance that is not a sugar [n -S]\n",
  "NONSUGARS": "NONSUGAR, a substance that is not a sugar [n]\n",
  "NONSUIT": "to dismiss the lawsuit of [v -ED, -ING, -S]\n",
  "NONSUITED": "NONSUIT, to dismiss the lawsuit of [v]\n",
  "NONSUITING": "NONSUIT, to dismiss the lawsuit of [v]\n",
  "NONSUITS": "NONSUIT, to dismiss the lawsuit of [v]\n",
  "NONSUPERVISORY": "not supervisory [adj]\n",
  "NONSUPPORT": "a lack of support [n -S]\n",
  "NONSUPPORTS": "NONSUPPORT, a lack of support [n]\n",
  "NONSURGICAL": "not surgical [adj]\n",
  "NONSWIMMER": "someone who does not swim [n -S]\n",
  "NONSWIMMERS": "NONSWIMMER, someone who does not swim [n]\n",
  "NONSYLLABIC": "a sound in speech that does not qualify as a syllable [n -S]\n",
  "NONSYLLABICS": "NONSYLLABIC, a sound in speech that does not qualify as a syllable [n]\n",
  "NONSYMBOLIC": "not symbolic [adj]\n",
  "NONSYMMETRIC": "not symmetric, also NONSYMMETRICAL [adj]\n",
  "NONSYMMETRICAL": "not symmetrical, also NONSYMMETRIC [adj]\n",
  "NONSYNCHRONOUS": "not synchronous [adj]\n",
  "NONSYSTEM": "something that is not part of a system [n -S]\n",
  "NONSYSTEMATIC": "not systematic [adj]\n",
  "NONSYSTEMIC": "not systemic [adj]\n",
  "NONSYSTEMS": "NONSYSTEM, something that is not part of a system [n]\n",
  "NONTACTICAL": "not tactical [adj]\n",
  "NONTALKER": "someone who does not talk [n -S]\n",
  "NONTALKERS": "NONTALKER, someone who does not talk [n]\n",
  "NONTARGET": "describing something that is not a target [adj]\n",
  "NONTARIFF": "not involving a tariff [adj]\n",
  "NONTAX": "a tax of little consequence [n -ES]\n",
  "NONTAXABLE": "not taxable [adj]\n",
  "NONTAXES": "NONTAX, a tax of little consequence [n]\n",
  "NONTEACHING": "that do not teach, e.g. members of staff [adj]\n",
  "NONTECHNICAL": "not technical [adj]\n",
  "NONTEMPORAL": "not temporal [adj]\n",
  "NONTENURED": "not having tenure [adj]\n",
  "NONTERMINAL": "something that is not a terminal [n -S]\n",
  "NONTERMINALS": "NONTERMINAL, something that is not a terminal [n]\n",
  "NONTERMINATING": "not terminating or ending [adj]\n",
  "NONTEXTUAL": "not textual [adj]\n",
  "NONTHEATRICAL": "not theatrical [adj]\n",
  "NONTHEISM": "absence of belief in a god or gods [n -S]\n",
  "NONTHEISMS": "NONTHEISM, absence of belief in a god or gods [n]\n",
  "NONTHEIST": "one who is not a theist [n -S]\n",
  "NONTHEISTIC": "not theistic [adj]\n",
  "NONTHEISTS": "NONTHEIST, one who is not a theist [n]\n",
  "NONTHEOLOGICAL": "not theological [adj]\n",
  "NONTHEORETICAL": "not theoretical [adj]\n",
  "NONTHERAPEUTIC": "not therapeutic [adj]\n",
  "NONTHERMAL": "not thermal [adj]\n",
  "NONTHINKING": "an act of not thinking or choosing not to think, an absence of thought [n -S]\n",
  "NONTHINKINGS": "NONTHINKING, an act of not thinking or choosing not to think, an absence of thought [n]\n",
  "NONTHREATENING": "not constituting a threat [adj]\n",
  "NONTIDAL": "not tidal [adj]\n",
  "NONTITLE": "pertaining to an event where the title is not at stake [adj]\n",
  "NONTOBACCO": "denoting a product not containing tobacco [adj]\n",
  "NONTONAL": "lacking tonality [adj]\n",
  "NONTONIC": "in music and poetry, not tonic [adj]\n",
  "NONTOTALITARIAN": "not totalitarian [adj]\n",
  "NONTOXIC": "a substance that is not toxic [n -S]\n",
  "NONTOXICS": "NONTOXIC, a substance that is not toxic [n]\n",
  "NONTRADING": "not trading [adj]\n",
  "NONTRADITIONAL": "not traditional [adj]\n",
  "NONTRAGIC": "not tragic [adj]\n",
  "NONTRANSFERABLE": "not transferable [adj]\n",
  "NONTRANSITIVE": "not transitive [adj]\n",
  "NONTREATMENT": "absence of treatment [n -S]\n",
  "NONTREATMENTS": "NONTREATMENT, absence of treatment [n]\n",
  "NONTRIBAL": "not tribal [adj]\n",
  "NONTRIVIAL": "not trivial [adj]\n",
  "NONTROPICAL": "not tropical [adj]\n",
  "NONTRUMP": "having no trumps [adj]\n",
  "NONTRUTH": "something that is not true [n -S]\n",
  "NONTRUTHS": "NONTRUTH, something that is not true [n]\n",
  "NONTURBULENT": "not turbulent [adj]\n",
  "NONTYPICAL": "not typical [adj]\n",
  "NONUNANIMOUS": "not unanimous [adj]\n",
  "NONUNIFORM": "not uniform [adj]\n",
  "NONUNIFORMITIES": "NONUNIFORMITY, the state of being nonuniform [n]\n",
  "NONUNIFORMITY": "the state of being nonuniform [n NONUNIFORMITIES]\n",
  "NONUNION": "failure of a broken bone to heal [n -S]\n",
  "NONUNIONISED": "not unionised, also NONUNIONIZED [adj]\n",
  "NONUNIONISM": "opposition to trade unionism [n -S]\n",
  "NONUNIONISMS": "NONUNIONISM, opposition to trade unionism [n]\n",
  "NONUNIONIST": "a supporter of nonunionism [n -S]\n",
  "NONUNIONISTS": "NONUNIONIST, a supporter of nonunionism [n]\n",
  "NONUNIONIZED": "not unionized, also NONUNIONISED [adj]\n",
  "NONUNIONS": "NONUNION, failure of a broken bone to heal [n]\n",
  "NONUNIQUE": "not unique [adj]\n",
  "NONUNIQUENESS": "NONUNIQUE, not unique [n]\n",
  "NONUNIQUENESSES": "NONUNIQUENESS, NONUNIQUE, not unique [n]\n",
  "NONUNIVERSAL": "not universal [adj]\n",
  "NONUNIVERSITY": "denoting an institution that is not a university [adj]\n",
  "NONUPLE": "a set of nine [n -S]\n",
  "NONUPLES": "NONUPLE, a set of nine [n]\n",
  "NONUPLET": "a group of nine notes to be performed in the time of eight or six [n -S]\n",
  "NONUPLETS": "NONUPLET, a group of nine notes to be performed in the time of eight or six [n]\n",
  "NONURBAN": "not the city [adj]\n",
  "NONURGENT": "not urgent [adj]\n",
  "NONUSABLE": "not usable [adj]\n",
  "NONUSE": "failure to use [n -S]\n",
  "NONUSER": "one that is not a user [n -S]\n",
  "NONUSERS": "NONUSER, one that is not a user [n]\n",
  "NONUSES": "NONUSE, failure to use [n]\n",
  "NONUSING": "not using [adj]\n",
  "NONUTILITARIAN": "not utilitarian [adj]\n",
  "NONUTILITIES": "NONUTILITY, a lack of utility [n]\n",
  "NONUTILITY": "a lack of utility [n NONUTILITIES]\n",
  "NONUTOPIAN": "not utopian [adj]\n",
  "NONVACANT": "not vacant [adj]\n",
  "NONVALID": "not valid [adj]\n",
  "NONVALIDITIES": "NONVALIDITY, the state of not being valid [n]\n",
  "NONVALIDITY": "the state of not being valid [n NONVALIDITIES]\n",
  "NONVANISHING": "not zero or becoming zero [adj]\n",
  "NONVASCULAR": "not vascular [adj]\n",
  "NONVECTOR": "something that is not a vector [n -S]\n",
  "NONVECTORS": "NONVECTOR, something that is not a vector [n]\n",
  "NONVEGETARIAN": "someone who is not a vegetarian [n -S]\n",
  "NONVEGETARIANS": "NONVEGETARIAN, someone who is not a vegetarian [n]\n",
  "NONVENEREAL": "not venereal [adj]\n",
  "NONVENOMOUS": "not venomous [adj]\n",
  "NONVENOUS": "not venous [adj]\n",
  "NONVERBAL": "not verbal [adj NONVERBALLY]\n",
  "NONVERBALLY": "NONVERBAL, not verbal [adv]\n",
  "NONVESTED": "not vested [adj]\n",
  "NONVETERAN": "not veteran [adj] / one who is not a veteran [n -S]\n",
  "NONVETERANS": "NONVETERAN, one who is not a veteran [n]\n",
  "NONVIABLE": "not viable [adj]\n",
  "NONVIEWER": "someone who is not a viewer [n -S]\n",
  "NONVIEWERS": "NONVIEWER, someone who is not a viewer [n]\n",
  "NONVINTAGE": "a wine that is not vintage [n -S]\n",
  "NONVINTAGES": "NONVINTAGE, a wine that is not vintage [n]\n",
  "NONVIOLENCE": "abstention from violence as a matter of principle [n -S]\n",
  "NONVIOLENCES": "NONVIOLENCE, abstention from violence as a matter of principle [n]\n",
  "NONVIOLENT": "abstaining or free from violence [adj NONVIOLENTLY]\n",
  "NONVIOLENTLY": "NONVIOLENT, abstaining or free from violence [adv]\n",
  "NONVIRAL": "not viral [adj]\n",
  "NONVIRGIN": "someone who is not a virgin [n -S]\n",
  "NONVIRGINS": "NONVIRGIN, someone who is not a virgin [n]\n",
  "NONVIRILE": "not virile [adj]\n",
  "NONVISCOUS": "not viscous [adj]\n",
  "NONVISUAL": "not visual [adj]\n",
  "NONVITAL": "not vital [adj]\n",
  "NONVOCAL": "not vocal [adj] / a music track with no vocals [n -S]\n",
  "NONVOCALS": "NONVOCAL, a music track with no vocals [n]\n",
  "NONVOCATIONAL": "not vocational [adj]\n",
  "NONVOLATILE": "not volatile [adj]\n",
  "NONVOLCANIC": "not volcanic [adj]\n",
  "NONVOLUNTARY": "not voluntary [adj]\n",
  "NONVOTER": "one who does not vote [n -S]\n",
  "NONVOTERS": "NONVOTER, one who does not vote [n]\n",
  "NONVOTING": "not voting [adj]\n",
  "NONWAGE": "not obtained from a wage [adj]\n",
  "NONWAR": "a war that has not been declared [n -S]\n",
  "NONWARS": "NONWAR, a war that has not been declared [n]\n",
  "NONWHITE": "a person who is not of the white race [n -S]\n",
  "NONWHITES": "NONWHITE, a person who is not of the white race [n]\n",
  "NONWINGED": "not winged [adj]\n",
  "NONWINNING": "not winning [adj]\n",
  "NONWOODY": "not woody [adj]\n",
  "NONWOOL": "not made of wool [adj]\n",
  "NONWORD": "a word that has no meaning [n -S]\n",
  "NONWORDS": "NONWORD, a word that has no meaning [n]\n",
  "NONWORK": "that part of life which does not involve work [n -S]\n",
  "NONWORKER": "someone who is not a worker [n -S]\n",
  "NONWORKERS": "NONWORKER, someone who is not a worker [n]\n",
  "NONWORKING": "not working [adj]\n",
  "NONWORKS": "NONWORK, that part of life which does not involve work [n]\n",
  "NONWOVEN": "a fabric not made by weaving [n -S]\n",
  "NONWOVENS": "NONWOVEN, a fabric not made by weaving [n]\n",
  "NONWRITER": "someone who is not a writer [n -S]\n",
  "NONWRITERS": "NONWRITER, someone who is not a writer [n]\n",
  "NONYELLOWING": "not yellowing [adj]\n",
  "NONYL": "a hydrocarbon radical derived from nonane [n -S]\n",
  "NONYLS": "NONYL, a hydrocarbon radical derived from nonane [n]\n",
  "NONZERO": "having a value other than zero [adj]\n",
  "NOO": "(Scots) now [adv]\n",
  "NOOB": "an Internet novice, a NEWBIE [n -S]\n",
  "NOOBS": "NOOB, an Internet novice, a NEWBIE [n]\n",
  "NOODGE": "(Yiddish) to nag, also NUDZH [v NOODGED, NOODGING, NOODGES]\n",
  "NOODGED": "NOODGE, (Yiddish) to nag, also NUDZH [v]\n",
  "NOODGES": "NOODGE, (Yiddish) to nag, also NUDZH [v]\n",
  "NOODGING": "NOODGE, (Yiddish) to nag, also NUDZH [v]\n",
  "NOODLE": "to play idly on a musical instrument [v NOODLED, NOODLING, NOODLES]\n",
  "NOODLED": "NOODLE, to play idly on a musical instrument [v]\n",
  "NOODLEDOM": "the state of being a blockhead [n -S]\n",
  "NOODLEDOMS": "NOODLEDOM, the state of being a blockhead [n]\n",
  "NOODLES": "NOODLE, to play idly on a musical instrument [v]\n",
  "NOODLING": "playing idly on a musical instrument [n -S]\n",
  "NOODLINGS": "NOODLING, playing idly on a musical instrument [n]\n",
  "NOOGENESES": "NOOGENESIS, evolution of the mind [n]\n",
  "NOOGENESIS": "evolution of the mind [n NOOGENESES]\n",
  "NOOGIE": "the act of inflicting pain by rubbing someone's head hard [n -S]\n",
  "NOOGIES": "NOOGIE, the act of inflicting pain by rubbing someone's head hard [n]\n",
  "NOOIT": "(South African) expressing pleased or shocked surprise [interj]\n",
  "NOOK": "a corner in a room, also NEUK [n -S]\n",
  "NOOKIE": "(colloquial) sexual intercourse, also NOOKY [n -S]\n",
  "NOOKIER": "NOOKY, full of nooks [adj]\n",
  "NOOKIES": "NOOKIE, (colloquial) sexual intercourse, also NOOKY [n]\n",
  "NOOKIEST": "NOOKY, full of nooks [adj]\n",
  "NOOKLIKE": "like a nook [adj]\n",
  "NOOKS": "NOOK, a corner in a room, also NEUK [n]\n",
  "NOOKY": "full of nooks [adj NOOKIER, NOOKIEST] / sexual intercourse, also NOOKIE [n NOOKIES]\n",
  "NOOLOGIES": "NOOLOGY, the science of the intellect [n]\n",
  "NOOLOGY": "the science of the intellect [n NOOLOGIES]\n",
  "NOOMETRIES": "NOOMETRY, mind-measurement [n]\n",
  "NOOMETRY": "mind-measurement [n NOOMETRIES]\n",
  "NOON": "to rest at midday [v -ED, -ING, -S]\n",
  "NOONDAY": "the middle of the day [n -S]\n",
  "NOONDAYS": "NOONDAY, the middle of the day [n]\n",
  "NOONED": "NOON, to rest at midday [v]\n",
  "NOONER": "a brief sexual encounter during the lunchbreak [n -S]\n",
  "NOONERS": "NOONER, a brief sexual encounter during the lunchbreak [n]\n",
  "NOONING": "(US) an interval for a meal or rest about midday [n -S]\n",
  "NOONINGS": "NOONING, (US) an interval for a meal or rest about midday [n]\n",
  "NOONS": "NOON, to rest at midday [v]\n",
  "NOONTIDE": "noon [n -S]\n",
  "NOONTIDES": "NOONTIDE, noon [n]\n",
  "NOONTIME": "the time of noon, midday [n -S]\n",
  "NOONTIMES": "NOONTIME, the time of noon, midday [n]\n",
  "NOOP": "(Scott) a knob, the tip of the elbow [n -S]\n",
  "NOOPS": "NOOP, (Scott) a knob, the tip of the elbow [n]\n",
  "NOOSE": "to secure with a type of loop [v NOOSED, NOOSING, NOOSES]\n",
  "NOOSED": "NOOSE, to secure with a type of loop [v]\n",
  "NOOSELIKE": "like noose [adj]\n",
  "NOOSER": "one who nooses [n -S]\n",
  "NOOSERS": "NOOSER, one who nooses [n]\n",
  "NOOSES": "NOOSE, to secure with a type of loop [v]\n",
  "NOOSING": "NOOSE, to secure with a type of loop [v]\n",
  "NOOSPHERE": "the sum of human knowledge, thought and culture [n -S]\n",
  "NOOSPHERES": "NOOSPHERE, the sum of human knowledge, thought and culture [n]\n",
  "NOOTROPIC": "acting on the mind [adj] / a nootropic drug [n -S]\n",
  "NOOTROPICS": "NOOTROPIC, a nootropic drug [n]\n",
  "NOPAL": "(Nahuatl) a Central American cactus plant, on which the cochineal insect feeds, and from which it is collected [n -ES or -S]\n",
  "NOPALES": "NOPAL, (Nahuatl) a Central American cactus plant, on which the cochineal insect feeds, and from which it is collected [n]\n",
  "NOPALITO": "(Spanish) a vegetable prepared from the branches of the prickly pear cactus [n -S]\n",
  "NOPALITOS": "NOPALITO, (Spanish) a vegetable prepared from the branches of the prickly pear cactus [n]\n",
  "NOPALS": "NOPAL, (Nahuatl) a Central American cactus plant, on which the cochineal insect feeds, and from which it is collected [n]\n",
  "NOPE": "(colloquial) no [interj]\n",
  "NOPLACE": "not at any place, nowhere [adv]\n",
  "NOR": "and not [conj]\n",
  "NORADRENALIN": "a neurotransmitter hormone related to adrenalin, produced by the adrenal glands, also NORADRENALINE [n -S]\n",
  "NORADRENALINE": "a neurotransmitter hormone related to adrenalin, produced by the adrenal glands, also NORADRENALIN [n -S]\n",
  "NORADRENALINES": "NORADRENALINE, a neurotransmitter hormone related to adrenalin, produced by the adrenal glands, also NORADRENALIN [n]\n",
  "NORADRENALINS": "NORADRENALIN, a neurotransmitter hormone related to adrenalin, produced by the adrenal glands, also NORADRENALINE [n]\n",
  "NORADRENERGIC": "liberating, activated by, or involving norepinephrine in the transmission of nerve impulses [adj]\n",
  "NORDIC": "pertaining to cross-country sports [adj]\n",
  "NORDICITIES": "NORDICITY, the quality of being nordic [n]\n",
  "NORDICITY": "the quality of being nordic [n NORDICITIES]\n",
  "NOREPINEPHRINE": "(US) a neurotransmitter hormone related to adrenalin, produced by the adrenal glands [n -S]\n",
  "NOREPINEPHRINES": "NOREPINEPHRINE, (US) a neurotransmitter hormone related to adrenalin, produced by the adrenal glands [n]\n",
  "NORETHINDRONE": "a synthetic progestational hormone used in birth control pills [n -S]\n",
  "NORETHINDRONES": "NORETHINDRONE, a synthetic progestational hormone used in birth control pills [n]\n",
  "NORETHISTERONE": "a molecule used in some combined oral contraceptive pills [n -S]\n",
  "NORETHISTERONES": "NORETHISTERONE, a molecule used in some combined oral contraceptive pills [n]\n",
  "NORI": "(Japanese) a kind of seaweed, used as a foodstuff in Japan [n -S]\n",
  "NORIA": "(Arabic) esp. in Spain and the East, a device for raising water from a stream etc., consisting of a chain of pots or buckets, revolving round a wheel driven by the water current [n -S]\n",
  "NORIAS": "NORIA, (Arabic) esp. in Spain and the East, a device for raising water from a stream etc., consisting of a chain of pots or buckets, revolving round a wheel driven by the water current [n]\n",
  "NORIMON": "(Japanese) a covered litter, carried by men [n -S]\n",
  "NORIMONS": "NORIMON, (Japanese) a covered litter, carried by men [n]\n",
  "NORIS": "NORI, (Japanese) a kind of seaweed, used as a foodstuff in Japan [n]\n",
  "NORITE": "a type of rock, a gabbro with rhombic pyroxene [n -S]\n",
  "NORITES": "NORITE, a type of rock, a gabbro with rhombic pyroxene [n]\n",
  "NORITIC": "of or like norite, a gabbro with rhombic pyroxine [adj]\n",
  "NORK": "(Australian slang) a woman's breast [n -S]\n",
  "NORKS": "NORK, (Australian slang) a woman's breast [n]\n",
  "NORLAND": "a region in the north [n -S]\n",
  "NORLANDS": "NORLAND, a region in the north [n]\n",
  "NORM": "a standard regarded as typical for a specific group [n -S]\n",
  "NORMA": "(Latin) a norm; a principle or rule [n -S]\n",
  "NORMAL": "usual [adj NORMALLY] / a normal or usual value [n -S]\n",
  "NORMALCIES": "NORMALCY, conformity with the norm [n]\n",
  "NORMALCY": "conformity with the norm [n NORMALCIES]\n",
  "NORMALISABLE": "capable of being normalised, also NORMALIZABLE [adj]\n",
  "NORMALISATION": "the act of normalising, also NORMALIZATION [n -S]\n",
  "NORMALISATIONS": "NORMALISATION, the act of normalising, also NORMALIZATION [n]\n",
  "NORMALISE": "to make normal; to bring within or cause to conform to normal standards or limits, also NORMALIZE [v NORMALISED, NORMALISING, NORMALISES]\n",
  "NORMALISED": "NORMALISE, to make normal; to bring within or cause to conform to normal standards or limits, also NORMALIZE [v]\n",
  "NORMALISER": "one who normalises, also NORMALIZER [n -S]\n",
  "NORMALISERS": "NORMALISER, one who normalises, also NORMALIZER [n]\n",
  "NORMALISES": "NORMALISE, to make normal; to bring within or cause to conform to normal standards or limits, also NORMALIZE [v]\n",
  "NORMALISING": "NORMALISE, to make normal; to bring within or cause to conform to normal standards or limits, also NORMALIZE [v]\n",
  "NORMALITIES": "NORMALITY, the state of being normal [n]\n",
  "NORMALITY": "the state of being normal [n NORMALITIES]\n",
  "NORMALIZABLE": "capable of being normalized, also NORMALISABLE [adj]\n",
  "NORMALIZATION": "the act of normalizing, also NORMALISATION [n -S]\n",
  "NORMALIZATIONS": "NORMALIZATION, the act of normalizing, also NORMALISATION [n]\n",
  "NORMALIZE": "to make normal; to bring within or cause to conform to normal standards or limits, also NORMALISE [v NORMALIZED, NORMALIZING, NORMALIZES]\n",
  "NORMALIZED": "NORMALIZE, to make normal; to bring within or cause to conform to normal standards or limits, also NORMALISE [v]\n",
  "NORMALIZER": "one that normalizes, also NORMALISER [n -S]\n",
  "NORMALIZERS": "NORMALIZER, one that normalizes, also NORMALISER [n]\n",
  "NORMALIZES": "NORMALIZE, to make normal; to bring within or cause to conform to normal standards or limits, also NORMALISE [v]\n",
  "NORMALIZING": "NORMALIZE, to make normal; to bring within or cause to conform to normal standards or limits, also NORMALISE [v]\n",
  "NORMALLY": "NORMAL, usual [adv]\n",
  "NORMALS": "NORMAL, a normal or usual value [n]\n",
  "NORMAN": "a tethering bar inserted in a ship's windlass [n -S]\n",
  "NORMANDE": "(French) a breed of cattle originating in Normand [n -S]\n",
  "NORMANDES": "NORMANDE, (French) a breed of cattle originating in Normand [n]\n",
  "NORMANS": "NORMAN, a tethering bar inserted in a ship's windlass [n]\n",
  "NORMAS": "NORMA, (Latin) a norm; a principle or rule [n]\n",
  "NORMATIVE": "of or relating to a norm; establishing a standard [adj NORMATIVELY]\n",
  "NORMATIVELY": "NORMATIVE, of or relating to a norm; establishing a standard [adv]\n",
  "NORMATIVENESS": "NORMATIVE, of or relating to a norm; establishing a standard [n]\n",
  "NORMATIVENESSES": "NORMATIVENESS, NORMATIVE, of or relating to a norm; establishing a standard [n]\n",
  "NORMCORE": "a consciously unobtrusive style of dress [n -S]\n",
  "NORMCORES": "NORMCORE, a consciously unobtrusive style of dress [n]\n",
  "NORMED": "having a norm [adj]\n",
  "NORMLESS": "without a norm [adj]\n",
  "NORMOGLYCAEMIA": "the condition of having a normal blood sugar level, also NORMOGLYCEMIA [n -S]\n",
  "NORMOGLYCAEMIAS": "NORMOGLYCAEMIA, the condition of having a normal blood sugar level, also NORMOGLYCEMIA [n]\n",
  "NORMOGLYCAEMIC": "having a normal level of blood sugar, also NORMOGLYCEMIC [adj]\n",
  "NORMOGLYCEMIA": "a normal level of blood sugar, also NORMOGLYCAEMIA [n -S]\n",
  "NORMOGLYCEMIAS": "NORMOGLYCEMIA, a normal level of blood sugar, also NORMOGLYCAEMIA [n]\n",
  "NORMOGLYCEMIC": "having a normal level of blood sugar, also NORMOGLYCAEMIC [adj]\n",
  "NORMOTENSION": "normal blood pressure [n -S]\n",
  "NORMOTENSIONS": "NORMOTENSION, normal blood pressure [n]\n",
  "NORMOTENSIVE": "having normal blood pressure [adj] / someone with normal pressure [n -S]\n",
  "NORMOTENSIVES": "NORMOTENSIVE, someone with normal pressure [n]\n",
  "NORMOTHERMIA": "normal body temperature [n -S]\n",
  "NORMOTHERMIAS": "NORMOTHERMIA, normal body temperature [n]\n",
  "NORMOTHERMIC": "relating to normothermia, normal body temperature [adj]\n",
  "NORMS": "NORM, a standard regarded as typical for a specific group [n]\n",
  "NOROVIRUS": "any of a group of viruses responsible for gastroenteritis [n -ES]\n",
  "NOROVIRUSES": "NOROVIRUS, any of a group of viruses responsible for gastroenteritis [n]\n",
  "NORSEL": "a short piece of line for fastening fishhooks [n -S] / (obsolete) to fish with a norsel [v NORSELLED, NORSELLING, NORSELS]\n",
  "NORSELLED": "NORSEL, (obsolete) to fish with a norsel [v]\n",
  "NORSELLER": "(obsolete) one who fishes with a norsel [n -S]\n",
  "NORSELLERS": "NORSELLER, (obsolete) one who fishes with a norsel [n]\n",
  "NORSELLING": "NORSEL, (obsolete) to fish with a norsel [v]\n",
  "NORSELS": "NORSEL, (obsolete) to fish with a norsel [v]\n",
  "NORTENA": "(Spanish) among Latin Americans, a female North American [n -S]\n",
  "NORTENAS": "NORTENA, (Spanish) among Latin Americans, a female North American [n]\n",
  "NORTENO": "(Spanish) among Latin Americans, a male North American [n -S]\n",
  "NORTENOS": "NORTENO, (Spanish) among Latin Americans, a male North American [n]\n",
  "NORTH": "to head northwards [v -ED, -ING, -S]\n",
  "NORTHBOUND": "heading north [adj]\n",
  "NORTHCOUNTRYMAN": "one living in the north [n NORTHCOUNTRYMEN]\n",
  "NORTHCOUNTRYMEN": "NORTHCOUNTRYMAN, one living in the north [n]\n",
  "NORTHEAST": "the direction between north and east [n -S]\n",
  "NORTHEASTER": "a strong northeast wind [n -S]\n",
  "NORTHEASTERLIES": "NORTHEASTERLY, a wind from the northeast [n]\n",
  "NORTHEASTERLY": "from the northeast [adj] / a wind from the northeast [n NORTHEASTERLIES]\n",
  "NORTHEASTERN": "of, relating to, or characteristic of a region conventionally designated northeast [adj]\n",
  "NORTHEASTERS": "NORTHEASTER, a strong northeast wind [n]\n",
  "NORTHEASTS": "NORTHEAST, the direction between north and east [n]\n",
  "NORTHEASTWARD": "in a northeasterly direction, also NORTHEASTWARDS [adv]\n",
  "NORTHEASTWARDLY": "in a northeasterly direction [adv]\n",
  "NORTHEASTWARDS": "in a northeasterly direction, also NORTHEASTWARD [adv]\n",
  "NORTHED": "NORTH, to head northwards [v]\n",
  "NORTHER": "to veer north [v -ED, -ING, -S]\n",
  "NORTHERED": "NORTHER, to veer north [v]\n",
  "NORTHERING": "NORTHER, to veer north [v]\n",
  "NORTHERLIES": "NORTHERLY, a northerly wind [n]\n",
  "NORTHERLINESS": "the state of being northerly [n -ES]\n",
  "NORTHERLINESSES": "NORTHERLINESS, the state of being northerly [n]\n",
  "NORTHERLY": "situated in the north; towards the north; (esp. of the wind) coming from the north [adj] / a northerly wind [n NORTHERLIES]\n",
  "NORTHERMOST": "most northerly, also NORTHERNMOST, NORTHMOST [adj]\n",
  "NORTHERN": "a person living in the north [n -S]\n",
  "NORTHERNER": "one born or living in the north [n -S]\n",
  "NORTHERNERS": "NORTHERNER, one born or living in the north [n]\n",
  "NORTHERNISE": "to make northern, also NORTHERNIZE [v NORTHERNISED, NORTHERNISING, NORTHERNISES]\n",
  "NORTHERNISED": "NORTHERNISE, to make northern, also NORTHERNIZE [v]\n",
  "NORTHERNISES": "NORTHERNISE, to make northern, also NORTHERNIZE [v]\n",
  "NORTHERNISING": "NORTHERNISE, to make northern, also NORTHERNIZE [v]\n",
  "NORTHERNISM": "a northern expression [n -S]\n",
  "NORTHERNISMS": "NORTHERNISM, a northern expression [n]\n",
  "NORTHERNIZE": "to make northern, also NORTHERNISE [v NORTHERNIZED, NORTHERNIZING, NORTHERNIZES]\n",
  "NORTHERNIZED": "NORTHERNIZE, to make northern, also NORTHERNISE [v]\n",
  "NORTHERNIZES": "NORTHERNIZE, to make northern, also NORTHERNISE [v]\n",
  "NORTHERNIZING": "NORTHERNIZE, to make northern, also NORTHERNISE [v]\n",
  "NORTHERNMOST": "most northerly, also NORTHERMOST, NORTHMOST [adj]\n",
  "NORTHERNS": "NORTHERN, a person living in the north [n]\n",
  "NORTHERS": "NORTHER, to veer north [v]\n",
  "NORTHING": "distance northward [n -S]\n",
  "NORTHINGS": "NORTHING, distance northward [n]\n",
  "NORTHLAND": "the northern part of a country [n -S]\n",
  "NORTHLANDS": "NORTHLAND, the northern part of a country [n]\n",
  "NORTHMOST": "most northerly, also NORTHERMOST, NORTHERNMOST [adj]\n",
  "NORTHS": "NORTH, to head northwards [v]\n",
  "NORTHWARD": "towards the north, also NORTHWARDS [adv NORTHWARDLY]\n",
  "NORTHWARDLY": "in a northward direction [adv]\n",
  "NORTHWARDS": "towards the north, also NORTHWARD [adv]\n",
  "NORTHWEST": "between west and north [adj] / the region between north and west [n -S]\n",
  "NORTHWESTER": "a strong northwest wind [n -S]\n",
  "NORTHWESTERLIES": "NORTHWESTERLY, a wind from the northwest [n]\n",
  "NORTHWESTERLY": "from the northwest [adj] / a wind from the northwest [n NORTHWESTERLIES]\n",
  "NORTHWESTERN": "of, relating to, or characteristic of a region conventionally designated northwest [adj]\n",
  "NORTHWESTERS": "NORTHWESTER, a strong northwest wind [n]\n",
  "NORTHWESTS": "NORTHWEST, the region between north and west [n]\n",
  "NORTHWESTWARD": "in a northwesterly direction, also NORTHWESTWARDS [adv]\n",
  "NORTHWESTWARDLY": "NORTHWESTWARD [adv]\n",
  "NORTHWESTWARDS": "in a northwesterly direction, also NORTHWESTWARD [adv]\n",
  "NORTRIPTYLINE": "a tricyclic antidepressant used in the form of its hydrochloride [n -S]\n",
  "NORTRIPTYLINES": "NORTRIPTYLINE, a tricyclic antidepressant used in the form of its hydrochloride [n]\n",
  "NORWARD": "same as northward [n -S]\n",
  "NORWARDS": "in a northerly direction, also NORWARD [adv]\n",
  "NOS": "NO, a negative reply or vote [n]\n",
  "NOSE": "to sniff with a smelling organ [v NOSED, NOSING, NOSES]\n",
  "NOSEAN": "a cubic mineral, aluminum sodium silicate and sulphur, also NOSELITE [n -S]\n",
  "NOSEANS": "NOSEAN, a cubic mineral, aluminum sodium silicate and sulphur, also NOSELITE [n]\n",
  "NOSEBAG": "a food bag hung over a horse's head [n -S]\n",
  "NOSEBAGS": "NOSEBAG, a food bag hung over a horse's head [n]\n",
  "NOSEBAND": "a strap passing round the nose of a horse, suspended by its own headpiece fitted under the bridle [n -S]\n",
  "NOSEBANDED": "wearing a noseband [adj]\n",
  "NOSEBANDS": "NOSEBAND, a strap passing round the nose of a horse, suspended by its own headpiece fitted under the bridle [n]\n",
  "NOSEBLEED": "bleeding from the nose, also NOSEBLEEDING [n -S]\n",
  "NOSEBLEEDING": "bleeding from the nose, also NOSEBLEED [n -S]\n",
  "NOSEBLEEDINGS": "NOSEBLEEDING, bleeding from the nose, also NOSEBLEED [n]\n",
  "NOSEBLEEDS": "NOSEBLEED, bleeding from the nose, also NOSEBLEEDING [n]\n",
  "NOSED": "NOSE, to sniff with a smelling organ [v]\n",
  "NOSEDIVE": "to plunge nose first [v NOSEDIVED or NOSEDOVE, NOSEDIVING, NOSEDIVES]\n",
  "NOSEDIVED": "NOSEDIVE, to plunge nose first [v]\n",
  "NOSEDIVES": "NOSEDIVE, to plunge nose first [v]\n",
  "NOSEDIVING": "NOSEDIVE, to plunge nose first [v]\n",
  "NOSEDOVE": "NOSEDIVE, to plunge nose first [v]\n",
  "NOSEGAY": "a bouquet of fragrant flowers [n -S]\n",
  "NOSEGAYS": "NOSEGAY, a bouquet of fragrant flowers [n]\n",
  "NOSEGUARD": "a protection for the nose; in American football, the innermost of five linesmen on a defensive team [n -S]\n",
  "NOSEGUARDS": "NOSEGUARD, a protection for the nose; in American football, the innermost of five linesmen on a defensive team [n]\n",
  "NOSELESS": "without a nose [adj]\n",
  "NOSELIKE": "like a nose [adj]\n",
  "NOSELITE": "a cubic mineral, aluminum sodium silicate and sulphur, also NOSEAN [n -S]\n",
  "NOSELITES": "NOSELITE, a cubic mineral, aluminum sodium silicate and sulphur, also NOSEAN [n]\n",
  "NOSEPIECE": "a nozzle; the end of a microscope tube [n -S]\n",
  "NOSEPIECES": "NOSEPIECE, a nozzle; the end of a microscope tube [n]\n",
  "NOSER": "(slang) a blow or fall on the nose; a strong head wind [n -S]\n",
  "NOSERS": "NOSER, (slang) a blow or fall on the nose; a strong head wind [n]\n",
  "NOSES": "NOSE, to sniff with a smelling organ [v]\n",
  "NOSEWHEEL": "the single wheel at the front of an aircraft [n -S]\n",
  "NOSEWHEELS": "NOSEWHEEL, the single wheel at the front of an aircraft [n]\n",
  "NOSEY": "unduly curious, also NOSY [adj NOSIER, NOSIEST, NOSILY] / a prying person [n -S]\n",
  "NOSEYS": "NOSEY, a prying person [n]\n",
  "NOSH": "(Yiddish) to eat snacks between meals [v -ED, -ING, -ES]\n",
  "NOSHED": "NOSH, (Yiddish) to eat snacks between meals [v]\n",
  "NOSHER": "one who noshes, nibbles between meals [n -S]\n",
  "NOSHERIE": "(colloquial) a cafe or restaurant, also NOSHERY [n -S]\n",
  "NOSHERIES": "NOSHERY, (colloquial) a cafe or restaurant, also NOSHERIE [n]\n",
  "NOSHERS": "NOSHER, one who noshes, nibbles between meals [n]\n",
  "NOSHERY": "(colloquial) a cafe or restaurant, also NOSHERIE [n NOSHERIES]\n",
  "NOSHES": "NOSH, (Yiddish) to eat snacks between meals [v]\n",
  "NOSHING": "NOSH, (Yiddish) to eat snacks between meals [v]\n",
  "NOSIER": "NOSEY, unduly curious, also NOSY [adj]\n",
  "NOSIES": "NOSY, a prying person [n]\n",
  "NOSIEST": "NOSEY, unduly curious, also NOSY [adj]\n",
  "NOSILY": "NOSY, unduly curious [adv]\n",
  "NOSINESS": "the quality of being nosy [n -ES]\n",
  "NOSINESSES": "NOSINESS, the quality of being nosy [n]\n",
  "NOSING": "a projecting edge of a stair, sill etc. [n -S]\n",
  "NOSINGS": "NOSING, a projecting edge of a stair, sill etc. [n]\n",
  "NOSOCOMIAL": "of or relating to a hospital, e.g. a nosocomial infection is one picked up in hospital [adj]\n",
  "NOSODE": "a homeopathic remedy consisting of diluted discharge [n -S]\n",
  "NOSODES": "NOSODE, a homeopathic remedy consisting of diluted discharge [n]\n",
  "NOSOGRAPHER": "one who describes diseases [n -S]\n",
  "NOSOGRAPHERS": "NOSOGRAPHER, one who describes diseases [n]\n",
  "NOSOGRAPHIC": "relating to nosography, the description of diseases [adj]\n",
  "NOSOGRAPHIES": "NOSOGRAPHY, the description of diseases [n]\n",
  "NOSOGRAPHY": "the description of diseases [n NOSOGRAPHIES]\n",
  "NOSOLOGIC": "relating to nosology, the science of diseases, also NOSOLOGICAL [adj NOSOLOGICALLY]\n",
  "NOSOLOGICAL": "relating to nosology, the science of diseases, also NOSOLOGIC [adj NOSOLOGICALLY]\n",
  "NOSOLOGICALLY": "NOSOLOGICAL, relating to nosology, the science of diseases, also NOSOLOGIC [adv]\n",
  "NOSOLOGIES": "NOSOLOGY, a classification of diseases [n]\n",
  "NOSOLOGIST": "one versed in nosology [n -S]\n",
  "NOSOLOGISTS": "NOSOLOGIST, one versed in nosology [n]\n",
  "NOSOLOGY": "a classification of diseases [n NOSOLOGIES]\n",
  "NOSOPHOBIA": "an irrational fear of contracting diseases [n -S]\n",
  "NOSOPHOBIAS": "NOSOPHOBIA, an irrational fear of contracting diseases [n]\n",
  "NOSTALGIA": "homesickness; the desire to return to some earlier time in one's life [n -S]\n",
  "NOSTALGIAS": "NOSTALGIA, homesickness; the desire to return to some earlier time in one's life [n]\n",
  "NOSTALGIC": "missing the past [adj NOSTALGICALLY] / one who is nostalgic [n -S]\n",
  "NOSTALGICALLY": "NOSTALGIC, missing the past [adv]\n",
  "NOSTALGICS": "NOSTALGIC, one who is nostalgic [n]\n",
  "NOSTALGIST": "one who indulges in nostalgia [n -S]\n",
  "NOSTALGISTS": "NOSTALGIST, one who indulges in nostalgia [n]\n",
  "NOSTOC": "a blue-green alga [n -S]\n",
  "NOSTOCS": "NOSTOC, a blue-green alga [n]\n",
  "NOSTOI": "NOSTOS, (Greek) a poem describing a return journey [n]\n",
  "NOSTOLOGIC": "relating to nostology, the study of senility, also NOSTOLOGICAL [adj]\n",
  "NOSTOLOGICAL": "relating to nostology, the study of senility, also NOSTOLOGIC [adj]\n",
  "NOSTOLOGIES": "NOSTOLOGY, the study of senility [n]\n",
  "NOSTOLOGY": "the study of senility [n NOSTOLOGIES]\n",
  "NOSTOMANIA": "an overwhelming desire to return home or to go back to familiar places [n -S]\n",
  "NOSTOMANIAS": "NOSTOMANIA, an overwhelming desire to return home or to go back to familiar places [n]\n",
  "NOSTOPATHIES": "NOSTOPATHY, the morbid fear of returning to familiar places [n]\n",
  "NOSTOPATHY": "the morbid fear of returning to familiar places [n NOSTOPATHIES]\n",
  "NOSTOS": "(Greek) a poem describing a return journey [n NOSTOI]\n",
  "NOSTRADAMIC": "relating to prophesy in the manner of Nostradamus [adj]\n",
  "NOSTRIL": "an external opening of the nose [n -S]\n",
  "NOSTRILS": "NOSTRIL, an external opening of the nose [n]\n",
  "NOSTRO": "of a bank account, 'our' record of an overseas account [adj]\n",
  "NOSTRUM": "(Latin) any secret, quack or patent medicine; any favourite remedy or scheme [n -S]\n",
  "NOSTRUMS": "NOSTRUM, (Latin) any secret, quack or patent medicine; any favourite remedy or scheme [n]\n",
  "NOSY": "unduly curious [adj NOSIER, NOSIEST, NOSILY] / a prying person [n NOSIES]\n",
  "NOT": "in no way [adv]\n",
  "NOTA": "NOTUM, (Greek) part of the thorax of an insect [n]\n",
  "NOTABILIA": "(Latin) notable sayings; things worthy of notice [n]\n",
  "NOTABILITIES": "NOTABILITY, a notable or prominent person [n]\n",
  "NOTABILITY": "a notable or prominent person [n NOTABILITIES]\n",
  "NOTABLE": "famous [adj NOTABLY] / a person of distinction [n -S]\n",
  "NOTABLENESS": "the state of being notable [n -ES]\n",
  "NOTABLENESSES": "NOTABLENESS, the state of being notable [n]\n",
  "NOTABLES": "NOTABLE, a person of distinction [n]\n",
  "NOTABLY": "NOTABLE, famous [adv]\n",
  "NOTAEUM": "(Greek) the upper surface of a bird's trunk [n -S]\n",
  "NOTAEUMS": "NOTAEUM, (Greek) the upper surface of a bird's trunk [n]\n",
  "NOTAIRE": "in France, a public official authorized by the state to attest and certify certain legal documents, oversee property transactions, etc. [n -S]\n",
  "NOTAIRES": "NOTAIRE, in France, a public official authorized by the state to attest and certify certain legal documents, oversee property transactions, etc. [n]\n",
  "NOTAL": "pertaining to the notum, the dorsal aspect of the thorax in insects [adj]\n",
  "NOTANDA": "NOTANDUM, (Latin) something to be specially noted [n]\n",
  "NOTANDUM": "(Latin) something to be specially noted [n NOTANDA]\n",
  "NOTAPHILIC": "relating to notaphily, the collecting of banknotes and cheques [adj]\n",
  "NOTAPHILIES": "NOTAPHILY, the collecting of banknotes and cheques as a hobby, also NOTAPHILISM [n]\n",
  "NOTAPHILISM": "the collecting of banknotes and cheques as a hobby, also NOTAPHILY [n -S]\n",
  "NOTAPHILISMS": "NOTAPHILISM, the collecting of banknotes and cheques as a hobby, also NOTAPHILY [n]\n",
  "NOTAPHILIST": "one who collects banknotes and cheques as a hobby [n -S]\n",
  "NOTAPHILISTS": "NOTAPHILIST, one who collects banknotes and cheques as a hobby [n]\n",
  "NOTAPHILY": "the collecting of banknotes and cheques as a hobby, also NOTAPHILISM [n NOTAPHILIES]\n",
  "NOTARIAL": "of or pertaining to a notary [adj NOTARIALLY]\n",
  "NOTARIALLY": "NOTARIAL, of or pertaining to a notary [adv]\n",
  "NOTARIES": "NOTARY, a public official who can certify documents [n]\n",
  "NOTARISATION": "the act of notarising, also NOTARIZATION [n -S]\n",
  "NOTARISATIONS": "NOTARISATION, the act of notarising, also NOTARIZATION [n]\n",
  "NOTARISE": "to attest to as a notary, also NOTARIZE [v NOTARISED, NOTARISING, NOTARISES]\n",
  "NOTARISED": "NOTARISE, to attest to as a notary, also NOTARIZE [v]\n",
  "NOTARISES": "NOTARISE, to attest to as a notary, also NOTARIZE [v]\n",
  "NOTARISING": "NOTARISE, to attest to as a notary, also NOTARIZE [v]\n",
  "NOTARIZATION": "the act of notarizing, also NOTARISATION [n -S]\n",
  "NOTARIZATIONS": "NOTARIZATION, the act of notarizing, also NOTARISATION [n]\n",
  "NOTARIZE": "to attest to as a notary, also NOTARISE [v NOTARIZED, NOTARIZING, NOTARIZES]\n",
  "NOTARIZED": "NOTARIZE, to attest to as a notary, also NOTARISE [v]\n",
  "NOTARIZES": "NOTARIZE, to attest to as a notary, also NOTARISE [v]\n",
  "NOTARIZING": "NOTARIZE, to attest to as a notary, also NOTARISE [v]\n",
  "NOTARY": "a public official who can certify documents [n NOTARIES]\n",
  "NOTARYSHIP": "the office of notary [n -S]\n",
  "NOTARYSHIPS": "NOTARYSHIP, the office of notary [n]\n",
  "NOTATE": "to put into a system of symbols [v NOTATED, NOTATING, NOTATES]\n",
  "NOTATED": "NOTATE, to put into a system of symbols [v]\n",
  "NOTATES": "NOTATE, to put into a system of symbols [v]\n",
  "NOTATING": "NOTATE, to put into a system of symbols [v]\n",
  "NOTATION": "a system of symbols [n -S]\n",
  "NOTATIONAL": "relating to notation [adj]\n",
  "NOTATIONS": "NOTATION, a system of symbols [n]\n",
  "NOTATOR": "one that notates [n -S]\n",
  "NOTATORS": "NOTATOR, one that notates [n]\n",
  "NOTCH": "to make an angular cut in [v -ED, -ING, -ES]\n",
  "NOTCHBACK": "a car whose roof does not slope continuously from the roof to the bumper, but juts out from the bottom of the rear window [n -S]\n",
  "NOTCHBACKS": "NOTCHBACK, a car whose roof does not slope continuously from the roof to the bumper, but juts out from the bottom of the rear window [n]\n",
  "NOTCHED": "NOTCH, to make an angular cut in [v]\n",
  "NOTCHEL": "to repudiate the debts of someone, also NOCHEL [v NOTCHELED or NOTCHELLED, NOTCHELING or NOTCHELLING, NOTCHELS]\n",
  "NOTCHELED": "NOTCHEL, to repudiate the debts of someone, also NOCHEL [v]\n",
  "NOTCHELING": "NOTCHEL, to repudiate the debts of someone, also NOCHEL [v]\n",
  "NOTCHELLED": "NOTCHEL, to repudiate the debts of someone, also NOCHEL [v]\n",
  "NOTCHELLING": "NOTCHEL, to repudiate the debts of someone, also NOCHEL [v]\n",
  "NOTCHELS": "NOTCHEL, to repudiate the debts of someone, also NOCHEL [v]\n",
  "NOTCHER": "one who notches [n -S]\n",
  "NOTCHERS": "NOTCHER, one who notches [n]\n",
  "NOTCHES": "NOTCH, to make an angular cut in [v]\n",
  "NOTCHIER": "NOTCHY, having notches [adj]\n",
  "NOTCHIEST": "NOTCHY, having notches [adj]\n",
  "NOTCHING": "a method of joining timbers, by fitting into a groove or grooves [n -S]\n",
  "NOTCHINGS": "NOTCHING, a method of joining timbers, by fitting into a groove or grooves [n]\n",
  "NOTCHY": "having notches [adj NOTCHIER, NOTCHIEST]\n",
  "NOTE": "to write down [v NOTED, NOTING, NOTES]\n",
  "NOTEBANDI": "(Hindi) (in India) the withdrawal of certain banknotes from use as currency; demonetization [n -S]\n",
  "NOTEBANDIS": "NOTEBANDI, (Hindi) (in India) the withdrawal of certain banknotes from use as currency; demonetization [n]\n",
  "NOTEBOOK": "a book in which to write [n -S]\n",
  "NOTEBOOKS": "NOTEBOOK, a book in which to write [n]\n",
  "NOTECARD": "a card used for sending short messages [n -S]\n",
  "NOTECARDS": "NOTECARD, a card used for sending short messages [n]\n",
  "NOTECASE": "a case for holding notes [n -S]\n",
  "NOTECASES": "NOTECASE, a case for holding notes [n]\n",
  "NOTED": "NOTE, to write down [v]\n",
  "NOTEDLY": "NOTED, NOTE, to write down [adv]\n",
  "NOTEDNESS": "the state of being noted [n -ES]\n",
  "NOTEDNESSES": "NOTEDNESS, the state of being noted [n]\n",
  "NOTELESS": "without notes [adj]\n",
  "NOTELET": "a short letter [n -S]\n",
  "NOTELETS": "NOTELET, a short letter [n]\n",
  "NOTEPAD": "a number of sheets of paper glued together at one end [n -S]\n",
  "NOTEPADS": "NOTEPAD, a number of sheets of paper glued together at one end [n]\n",
  "NOTEPAPER": "writing paper intended for letters [n -S]\n",
  "NOTEPAPERS": "NOTEPAPER, writing paper intended for letters [n]\n",
  "NOTER": "a person who makes notes [n -S]\n",
  "NOTERS": "NOTER, a person who makes notes [n]\n",
  "NOTES": "NOTE, to write down [v]\n",
  "NOTEWORTHIER": "NOTEWORTHY, worthy of or attracting attention esp because of some special excellence [adj]\n",
  "NOTEWORTHIEST": "NOTEWORTHY, worthy of or attracting attention esp because of some special excellence [adj]\n",
  "NOTEWORTHILY": "NOTEWORTHY, worthy of or attracting attention esp because of some special excellence [adv]\n",
  "NOTEWORTHINESS": "the state of being noteworthy [n]\n",
  "NOTEWORTHY": "worthy of or attracting attention esp because of some special excellence [adj NOTEWORTHIER, NOTEWORTHIEST; NOTEWORTHILY]\n",
  "NOTHER": "neither; nor [adj]\n",
  "NOTHING": "the absence of all quantity or magnitude, also NAETHING, NUTHIN [n -S]\n",
  "NOTHINGARIAN": "a person who has no particular belief [n -S]\n",
  "NOTHINGARIANISM": "having no particular belief, esp. in religion [n]\n",
  "NOTHINGARIANS": "NOTHINGARIAN, a person who has no particular belief [n]\n",
  "NOTHINGISM": "nihility; nothingness [n -S]\n",
  "NOTHINGISMS": "NOTHINGISM, nihility; nothingness [n]\n",
  "NOTHINGNESS": "nonexistence [n -ES]\n",
  "NOTHINGNESSES": "NOTHINGNESS, nonexistence [n]\n",
  "NOTHINGS": "NOTHING, the absence of all quantity or magnitude, also NAETHING, NUTHIN [n]\n",
  "NOTICE": "to become aware of [v NOTICED, NOTICING, NOTICES]\n",
  "NOTICEABILITIES": "NOTICEABILITY, the quality of being noticeable [n]\n",
  "NOTICEABILITY": "the quality of being noticeable [n NOTICEABILITIES]\n",
  "NOTICEABLE": "that can be noticed [adj NOTICEABLY]\n",
  "NOTICEABLY": "NOTICEABLE, that can be noticed [adv]\n",
  "NOTICEBOARD": "a board for the display of notices [n -S]\n",
  "NOTICEBOARDS": "NOTICEBOARD, a board for the display of notices [n]\n",
  "NOTICED": "NOTICE, to become aware of [v]\n",
  "NOTICER": "one who notices [n -S]\n",
  "NOTICERS": "NOTICER, one who notices [n]\n",
  "NOTICES": "NOTICE, to become aware of [v]\n",
  "NOTICING": "NOTICE, to become aware of [v]\n",
  "NOTIFIABLE": "of a diseased, required by law to be reported to official health authorities [adj]\n",
  "NOTIFICATION": "the act or an instance of notifying [n -S]\n",
  "NOTIFICATIONS": "NOTIFICATION, the act or an instance of notifying [n]\n",
  "NOTIFIED": "NOTIFY, to inform [v]\n",
  "NOTIFIER": "one who notifies [n -S]\n",
  "NOTIFIERS": "NOTIFIER, one who notifies [n]\n",
  "NOTIFIES": "NOTIFY, to inform [v]\n",
  "NOTIFY": "to inform [v NOTIFIED, NOTIFYING, NOTIFIES]\n",
  "NOTIFYING": "NOTIFY, to inform [v]\n",
  "NOTING": "NOTE, to write down [v]\n",
  "NOTION": "a general idea [n -S]\n",
  "NOTIONAL": "of the nature of a notion [adj NOTIONALLY]\n",
  "NOTIONALIST": "a theorist [n -S]\n",
  "NOTIONALISTS": "NOTIONALIST, a theorist [n]\n",
  "NOTIONALITIES": "NOTIONALITY, the state of being notional [n]\n",
  "NOTIONALITY": "the state of being notional [n NOTIONALITIES]\n",
  "NOTIONALLY": "NOTIONAL, of the nature of a notion [adv]\n",
  "NOTIONIST": "one whose opinions are ungrounded notions [n -S]\n",
  "NOTIONISTS": "NOTIONIST, one whose opinions are ungrounded notions [n]\n",
  "NOTIONS": "NOTION, a general idea [n]\n",
  "NOTITIA": "(Latin) a roll, list or register [n NOTITIAE or NOTITIAS]\n",
  "NOTITIAE": "NOTITIA, (Latin) a roll, list or register [n]\n",
  "NOTITIAS": "NOTITIA, (Latin) a roll, list or register [n]\n",
  "NOTOCHORD": "a backbone-like series of cells in the lowest vertebrates [n -S]\n",
  "NOTOCHORDAL": "relating to the notochord, a backbone-like series of cells in the lowest vertebrates [adj]\n",
  "NOTOCHORDS": "NOTOCHORD, a backbone-like series of cells in the lowest vertebrates [n]\n",
  "NOTODONTID": "a member of the Notodontidae genus of moths [n -S]\n",
  "NOTODONTIDS": "NOTODONTID, a member of the Notodontidae genus of moths [n]\n",
  "NOTONECTAL": "swimming on the back [adj]\n",
  "NOTORIETIES": "NOTORIETY, the state of being notorious [n]\n",
  "NOTORIETY": "the state of being notorious [n NOTORIETIES]\n",
  "NOTORIOUS": "infamous [adj NOTORIOUSLY]\n",
  "NOTORIOUSLY": "NOTORIOUS, infamous [adv]\n",
  "NOTORIOUSNESS": "NOTORIOUS, infamous [n]\n",
  "NOTORIOUSNESSES": "NOTORIOUSNESS, NOTORIOUS, infamous [n]\n",
  "NOTORNIS": "(Greek) a domestic-fowl-like bird of New Zealand, aka takahe [n -ES]\n",
  "NOTORNISES": "NOTORNIS, (Greek) a domestic-fowl-like bird of New Zealand, aka takahe [n]\n",
  "NOTOTHERIUM": "an extinct Pleistocene rhinoceros-sized marsupial of the genus Nototherium, related to the wombats [n -S]\n",
  "NOTOTHERIUMS": "NOTOTHERIUM, an extinct Pleistocene rhinoceros-sized marsupial of the genus Nototherium, related to the wombats [n]\n",
  "NOTOUNGULATE": "any one of an extinct group of herbivorous, hoofed mammals common in South America between the Palaeocene and Pleistocene eras, also NOTUNGULATE [n -S]\n",
  "NOTOUNGULATES": "NOTOUNGULATE, any one of an extinct group of herbivorous, hoofed mammals common in South America between the Palaeocene and Pleistocene eras, also NOTUNGULATE [n]\n",
  "NOTOUR": "in Scots law, notorious [adj]\n",
  "NOTT": "with short cropped hair [adj]\n",
  "NOTTURNI": "NOTTURNO, (Italian) a musical composition, also NOCTURNE [n]\n",
  "NOTTURNO": "(Italian) a musical composition, also NOCTURNE [n NOTTURNI]\n",
  "NOTUM": "(Greek) part of the thorax of an insect [n NOTA]\n",
  "NOTUNGULATE": "any one of an extinct group of herbivorous, hoofed mammals, also NOTOUNGULATE [n -S]\n",
  "NOTUNGULATES": "NOTUNGULATE, any one of an extinct group of herbivorous, hoofed mammals, also NOTOUNGULATE [n]\n",
  "NOTWITHSTANDING": "nevertheless, despite that [adv]\n",
  "NOTWORKING": "as in social notworking, the practice of spending time unproductively on social networking websites, esp. when one should be working [n -S]\n",
  "NOTWORKINGS": "NOTWORKING, as in social notworking, the practice of spending time unproductively on social networking websites, esp. when one should be working [n]\n",
  "NOUGAT": "(French) a sweet made from egg-white sweetened with sugar or honey and mixed with nuts and sometimes pieces of fruit [n -S]\n",
  "NOUGATINE": "nougat covered with chocolate [n -S]\n",
  "NOUGATINES": "NOUGATINE, nougat covered with chocolate [n]\n",
  "NOUGATS": "NOUGAT, (French) a sweet made from egg-white sweetened with sugar or honey and mixed with nuts and sometimes pieces of fruit [n]\n",
  "NOUGHT": "nothing, also NAUGHT [n -S]\n",
  "NOUGHTIES": "the decade from 2000 to 2009 [n]\n",
  "NOUGHTS": "NOUGHT, nothing, also NAUGHT [n]\n",
  "NOUL": "the top of the head, also NOLL, NOLE, NOULE, NOWL [n -S]\n",
  "NOULD": "NILL, to be unwilling [v]\n",
  "NOULDE": "NILL, to be unwilling [v]\n",
  "NOULE": "(Spenser) the top of the head, also NOLL, NOLE, NOUL, NOWL [n -S]\n",
  "NOULES": "NOULE, (Spenser) the top of the head, also NOLL, NOLE, NOUL, NOWL [n]\n",
  "NOULS": "NOUL, the top of the head, also NOLL, NOLE, NOULE, NOWL [n]\n",
  "NOUMENA": "NOUMENON, (Greek) an object of purely intellectual intuition as opposed to an object of sensuous perception phenomenon [n]\n",
  "NOUMENAL": "of or pertaining to the noumenon; real as opposed to phenomenal [adj]\n",
  "NOUMENALISM": "Kant's philosophy of the noumenon [n -S]\n",
  "NOUMENALISMS": "NOUMENALISM, Kant's philosophy of the noumenon [n]\n",
  "NOUMENALIST": "a believer in noumenalism [n -S]\n",
  "NOUMENALISTS": "NOUMENALIST, a believer in noumenalism [n]\n",
  "NOUMENALITIES": "NOUMENALITY, the state of being noumenal [n]\n",
  "NOUMENALITY": "the state of being noumenal [n NOUMENALITIES]\n",
  "NOUMENALLY": "NOUMENAL, of or pertaining to the noumenon; real as opposed to phenomenal [adv]\n",
  "NOUMENON": "(Greek) an object of purely intellectual intuition as opposed to an object of sensuous perception phenomenon [n NOUMENA]\n",
  "NOUN": "a word used to denote the name of something [n -S]\n",
  "NOUNAL": "relating to a noun [adj NOUNALLY]\n",
  "NOUNALLY": "NOUNAL, relating to a noun [adv]\n",
  "NOUNIER": "NOUNY, having many nouns [adj]\n",
  "NOUNIEST": "NOUNY, having many nouns [adj]\n",
  "NOUNLESS": "without a noun [adj]\n",
  "NOUNS": "NOUN, a word used to denote the name of something [n]\n",
  "NOUNY": "having many nouns [adj NOUNIER, NOUNIEST]\n",
  "NOUP": "(obsolete) in the Shetlands, a crag, a steep headland [n -S]\n",
  "NOUPS": "NOUP, (obsolete) in the Shetlands, a crag, a steep headland [n]\n",
  "NOURICE": "(obsolete) a nurse [n -S]\n",
  "NOURICES": "NOURICE, (obsolete) a nurse [n]\n",
  "NOURISH": "to sustain with food [v -ED, -ING, -ES]\n",
  "NOURISHABLE": "that can be nourished [adj]\n",
  "NOURISHED": "NOURISH, to sustain with food [v]\n",
  "NOURISHER": "one who nourishes [n -S]\n",
  "NOURISHERS": "NOURISHER, one who nourishes [n]\n",
  "NOURISHES": "NOURISH, to sustain with food [v]\n",
  "NOURISHING": "NOURISH, to sustain with food [v]\n",
  "NOURISHINGLY": "NOURISHING, NOURISH, to sustain with food [adv]\n",
  "NOURISHMENT": "food, nutriment [n -S]\n",
  "NOURISHMENTS": "NOURISHMENT, food, nutriment [n]\n",
  "NOURITURE": "nourishment, nurture, also NOURRITURE [n -S]\n",
  "NOURITURES": "NOURITURE, nourishment, nurture, also NOURRITURE [n]\n",
  "NOURRITURE": "nourishment, nurture, also NOURITURE [n -S]\n",
  "NOURRITURES": "NOURRITURE, nourishment, nurture, also NOURITURE [n]\n",
  "NOURSLE": "(Spenser) to foster, also NOUSELL, NOUSLE, NURSLE [v NOURSLED, NOURSLING, NOURSLES]\n",
  "NOURSLED": "NOURSLE, (Spenser) to foster, also NOUSELL, NOUSLE, NURSLE [v]\n",
  "NOURSLES": "NOURSLE, (Spenser) to foster, also NOUSELL, NOUSLE, NURSLE [v]\n",
  "NOURSLING": "NOURSLE, (Spenser) to foster, also NOUSELL, NOUSLE, NURSLE [v]\n",
  "NOUS": "(Greek) intellect, common sense [n -ES]\n",
  "NOUSELL": "(Spenser) to foster, also NOURSLE, NOUSLE, NURSLE [v -ED, -ING, -S]\n",
  "NOUSELLED": "NOUSELL, (Spenser) to foster, also NOURSLE, NOUSLE, NURSLE [v]\n",
  "NOUSELLING": "NOUSELL, (Spenser) to foster, also NOURSLE, NOUSLE, NURSLE [v]\n",
  "NOUSELLS": "NOUSELL, (Spenser) to foster, also NOURSLE, NOUSLE, NURSLE [v]\n",
  "NOUSES": "NOUS, (Greek) intellect, common sense [n]\n",
  "NOUSLE": "(Spenser) to foster, also NOURSLE, NOUSELL, NURSLE [v NOUSLED, NOUSLING, NOUSLES]\n",
  "NOUSLED": "NOUSLE, (Spenser) to foster, also NOURSLE, NOUSELL, NURSLE [v]\n",
  "NOUSLES": "NOUSLE, (Spenser) to foster, also NOURSLE, NOUSELL, NURSLE [v]\n",
  "NOUSLING": "NOUSLE, (Spenser) to foster, also NOURSLE, NOUSELL, NURSLE [v]\n",
  "NOUT": "(dialect) cattle [n]\n",
  "NOUVEAU": "(French) something new [n NOUVEAUX]\n",
  "NOUVEAUX": "NOUVEAU, (French) something new [n]\n",
  "NOUVELLE": "(French) a long short story [n -S]\n",
  "NOUVELLES": "NOUVELLE, (French) a long short story [n]\n",
  "NOVA": "(Latin) an exploding star [n NOVAE or NOVAS]\n",
  "NOVACULITE": "a variety of siliceous slate, of which hones are made [n -S]\n",
  "NOVACULITES": "NOVACULITE, a variety of siliceous slate, of which hones are made [n]\n",
  "NOVAE": "NOVA, (Latin) an exploding star [n]\n",
  "NOVALIA": "in Scots law, waste lands newly reclaimed [n]\n",
  "NOVALIKE": "like a nova [adj]\n",
  "NOVAS": "NOVA, (Latin) an exploding star [n]\n",
  "NOVATE": "to substitute a new obligation for an existing one [v NOVATED, NOVATING, NOVATES]\n",
  "NOVATED": "NOVATE, to substitute a new obligation for an existing one [v]\n",
  "NOVATES": "NOVATE, to substitute a new obligation for an existing one [v]\n",
  "NOVATING": "NOVATE, to substitute a new obligation for an existing one [v]\n",
  "NOVATION": "the substitution of a new legal obligation for an old one [n -S]\n",
  "NOVATIONS": "NOVATION, the substitution of a new legal obligation for an old one [n]\n",
  "NOVEL": "new [adj NOVELLY] / a fictional prose narrative [n -S]\n",
  "NOVELDOM": "the world of fiction [n -S]\n",
  "NOVELDOMS": "NOVELDOM, the world of fiction [n]\n",
  "NOVELESE": "the trite style of poorly written novels [n -S]\n",
  "NOVELESES": "NOVELESE, the trite style of poorly written novels [n]\n",
  "NOVELETTE": "a short novel [n -S]\n",
  "NOVELETTES": "NOVELETTE, a short novel [n]\n",
  "NOVELETTISH": "having the properties of a novelette [adj]\n",
  "NOVELETTIST": "one who writes novelettes [n -S]\n",
  "NOVELETTISTS": "NOVELETTIST, one who writes novelettes [n]\n",
  "NOVELISATION": "the act of making into a novel, also NOVELIZATION [n -S]\n",
  "NOVELISATIONS": "NOVELISATION, the act of making into a novel, also NOVELIZATION [n]\n",
  "NOVELISE": "to put into the form of a novel, also NOVELIZE [v NOVELISED, NOVELISING, NOVELISES]\n",
  "NOVELISED": "NOVELISE, to put into the form of a novel, also NOVELIZE [v]\n",
  "NOVELISER": "one who makes a novel of something, also NOVELIZER [n -S]\n",
  "NOVELISERS": "NOVELISER, one who makes a novel of something, also NOVELIZER [n]\n",
  "NOVELISES": "NOVELISE, to put into the form of a novel, also NOVELIZE [v]\n",
  "NOVELISH": "somewhat like a novel [adj]\n",
  "NOVELISING": "NOVELISE, to put into the form of a novel, also NOVELIZE [v]\n",
  "NOVELISM": "innovation [n -S]\n",
  "NOVELISMS": "NOVELISM, innovation [n]\n",
  "NOVELIST": "one who writes novels [n -S]\n",
  "NOVELISTIC": "relating to a novel e.g. a novelistic device [adj NOVELISTICALLY]\n",
  "NOVELISTICALLY": "NOVELISTIC, relating to a novel e.g. a novelistic device [adv]\n",
  "NOVELISTS": "NOVELIST, one who writes novels [n]\n",
  "NOVELIZATION": "the act of making into a novel, also NOVELISATION [n -S]\n",
  "NOVELIZATIONS": "NOVELIZATION, the act of making into a novel, also NOVELISATION [n]\n",
  "NOVELIZE": "to put into the form of a novel, also NOVELISE [v NOVELIZED, NOVELIZING, NOVELIZES]\n",
  "NOVELIZED": "NOVELIZE, to put into the form of a novel, also NOVELISE [v]\n",
  "NOVELIZER": "one who makes a novel of something, also NOVELISER [n -S]\n",
  "NOVELIZERS": "NOVELIZER, one who makes a novel of something, also NOVELISER [n]\n",
  "NOVELIZES": "NOVELIZE, to put into the form of a novel, also NOVELISE [v]\n",
  "NOVELIZING": "NOVELIZE, to put into the form of a novel, also NOVELISE [v]\n",
  "NOVELLA": "(Italian) a short novel [n NOVELLAS or NOVELLE] / a Roman Emperor's decree [n NOVELLAE]\n",
  "NOVELLAE": "NOVELLA, (Italian) a short novel [n]\n",
  "NOVELLAS": "NOVELLA, (Italian) a short novel [n]\n",
  "NOVELLE": "NOVELLA, (Italian) a short novel [n]\n",
  "NOVELLY": "NOVEL, new [adv]\n",
  "NOVELS": "NOVEL, a fictional prose narrative [n]\n",
  "NOVELTIES": "NOVELTY, something unusual [n]\n",
  "NOVELTY": "something unusual [n NOVELTIES]\n",
  "NOVEMBER": "(in international radio communication) a code word for the letter n [n -S]\n",
  "NOVEMBERS": "NOVEMBER, (in international radio communication) a code word for the letter n [n]\n",
  "NOVEMDECILLION": "ten to the 114th power [n -S]\n",
  "NOVEMDECILLIONS": "NOVEMDECILLION, ten to the 114th power [n]\n",
  "NOVENA": "(Latin) a series of Catholic church services held on nine successive days [n NOVENAE or NOVENAS]\n",
  "NOVENAE": "NOVENA, (Latin) a series of Catholic church services held on nine successive days [n]\n",
  "NOVENARIES": "NOVENARY, a set of nine things [n]\n",
  "NOVENARY": "a set of nine things [n NOVENARIES]\n",
  "NOVENAS": "NOVENA, (Latin) a series of Catholic church services held on nine successive days [n]\n",
  "NOVENNIAL": "recurring every ninth year [adj]\n",
  "NOVERCAL": "pertaining to a stepmother [adj]\n",
  "NOVERINT": "(Latin) a writ, beginning with the words 'noverint universi', let all men know [n -S]\n",
  "NOVERINTS": "NOVERINT, (Latin) a writ, beginning with the words 'noverint universi', let all men know [n]\n",
  "NOVICE": "a person new to any field or activity [n -S]\n",
  "NOVICEHOOD": "the state of being a novice [n -S]\n",
  "NOVICEHOODS": "NOVICEHOOD, the state of being a novice [n]\n",
  "NOVICES": "NOVICE, a person new to any field or activity [n]\n",
  "NOVICESHIP": "the state of being a novice [n -S]\n",
  "NOVICESHIPS": "NOVICESHIP, the state of being a novice [n]\n",
  "NOVICHOK": "any of a group of powerful nerve agents developed in the former Soviet Union [n -S]\n",
  "NOVICHOKS": "NOVICHOK, any of a group of powerful nerve agents developed in the former Soviet Union [n]\n",
  "NOVICIATE": "the state of being a (religious) novice, also NOVITIATE [n -S]\n",
  "NOVICIATES": "NOVICIATE, the state of being a (religious) novice, also NOVITIATE [n]\n",
  "NOVITIATE": "the state of being a (religious) novice, also NOVICIATE [n -S]\n",
  "NOVITIATES": "NOVITIATE, the state of being a (religious) novice, also NOVICIATE [n]\n",
  "NOVITIES": "NOVITY, innovation [n]\n",
  "NOVITY": "innovation [n NOVITIES]\n",
  "NOVOBIOCIN": "an antimicrobial drug used in some cases of staphylococcic or urinary tract infection [n -S]\n",
  "NOVOBIOCINS": "NOVOBIOCIN, an antimicrobial drug used in some cases of staphylococcic or urinary tract infection [n]\n",
  "NOVOCAINE": "(tradename) a proprietary name for cocaine, as a dental anaesthetic [n -S]\n",
  "NOVOCAINES": "NOVOCAINE, (tradename) a proprietary name for cocaine, as a dental anaesthetic [n]\n",
  "NOVOCENTENARIES": "NOVOCENTENARY, a 900th anniversary [n]\n",
  "NOVOCENTENARY": "a 900th anniversary [n NOVOCENTENARIES]\n",
  "NOVODAMUS": "in Scots law, a charter or single document containing a clause by which certain rights, privileges etc. are granted anew; the clause itself [n -ES]\n",
  "NOVODAMUSES": "NOVODAMUS, in Scots law, a charter or single document containing a clause by which certain rights, privileges etc. are granted anew; the clause itself [n]\n",
  "NOVUM": "(Shakespeare) a dice game in which the chief throws were nine and five [n -S]\n",
  "NOVUMS": "NOVUM, (Shakespeare) a dice game in which the chief throws were nine and five [n]\n",
  "NOW": "the present time [n -S]\n",
  "NOWADAYS": "in these times [adv]\n",
  "NOWAY": "in no way, also NOWAYS, NOWISE [adv]\n",
  "NOWAYS": "in no way, also NOWAY, NOWISE [adv]\n",
  "NOWCAST": "a report on current weather conditions [n -S]\n",
  "NOWCASTING": "broadcasting events as they happen [n -S]\n",
  "NOWCASTINGS": "NOWCASTING, broadcasting events as they happen [n]\n",
  "NOWCASTS": "NOWCAST, a report on current weather conditions [n]\n",
  "NOWED": "knotted [adj]\n",
  "NOWHENCE": "(archaic) from no place [adv]\n",
  "NOWHERE": "a nonexistent place [n -S]\n",
  "NOWHERES": "NOWHERE, a nonexistent place [n]\n",
  "NOWHITHER": "(archaic) in no direction [adv]\n",
  "NOWISE": "in no manner or degree, also NOWAY, NOWAYS [adv]\n",
  "NOWL": "(Shakespeare) the top of the head, also NOLL, NOLE, NOUL, NOULE [n -S]\n",
  "NOWLS": "NOWL, (Shakespeare) the top of the head, also NOLL, NOLE, NOUL, NOULE [n]\n",
  "NOWN": "(obsolete) own [adj]\n",
  "NOWNESS": "the state of existing at the present time [n -ES]\n",
  "NOWNESSES": "NOWNESS, the state of existing at the present time [n]\n",
  "NOWS": "NOW, the present time [n]\n",
  "NOWT": "(dialect) nothing [n -S]\n",
  "NOWTIER": "NOWTY, bad-tempered [adj]\n",
  "NOWTIEST": "NOWTY, bad-tempered [adj]\n",
  "NOWTS": "NOWT, (dialect) nothing [n]\n",
  "NOWTY": "bad-tempered [adj NOWTIER, NOWTIEST]\n",
  "NOWY": "having a convex curvature near the middle [adj]\n",
  "NOX": "(short for) nitrogen oxide [n -ES]\n",
  "NOXAL": "relating to wrongful injury by an animal or person belonging to another [adj]\n",
  "NOXES": "NOX, (short for) nitrogen oxide [n]\n",
  "NOXIOUS": "harmful to health [adj NOXIOUSLY]\n",
  "NOXIOUSLY": "NOXIOUS, harmful to health [adv]\n",
  "NOXIOUSNESS": "the state of being noxious [n -ES]\n",
  "NOXIOUSNESSES": "NOXIOUSNESS, the state of being noxious [n]\n",
  "NOY": "(Spenser) to annoy [v -ED, -ING, -S]\n",
  "NOYADE": "(French) drowning, esp. of many persons together as form of execution [n -S]\n",
  "NOYADES": "NOYADE, (French) drowning, esp. of many persons together as form of execution [n]\n",
  "NOYANCE": "(Spenser) annoyance [n -S]\n",
  "NOYANCES": "NOYANCE, (Spenser) annoyance [n]\n",
  "NOYAU": "(French) a liqueur made from brandy flavoured with bitter almonds or peach-stones [n NOYAUS or NOYAUX]\n",
  "NOYAUS": "NOYAU, (French) a liqueur made from brandy flavoured with bitter almonds or peach-stones [n]\n",
  "NOYAUX": "NOYAU, (French) a liqueur made from brandy flavoured with bitter almonds or peach-stones [n]\n",
  "NOYED": "NOY, (Spenser) to annoy [v]\n",
  "NOYES": "(Spenser) noise [n -ES]\n",
  "NOYESES": "NOYES, (Spenser) noise [n]\n",
  "NOYING": "NOY, (Spenser) to annoy [v]\n",
  "NOYOUS": "(Spenser) vexatious, grievous [adj]\n",
  "NOYS": "NOY, (Spenser) to annoy [v]\n",
  "NOYSOME": "(obsolete) noisome, hurtful, also NOISOME [adj]\n",
  "NOZZER": "(slang) a raw naval recruit [n -S]\n",
  "NOZZERS": "NOZZER, (slang) a raw naval recruit [n]\n",
  "NOZZLE": "a projecting spout [n -S]\n",
  "NOZZLES": "NOZZLE, a projecting spout [n]\n",
  "NTH": "pertaining to an indefinitely large ordinal number [adj]\n",
  "NU": "(Greek) a Greek letter [n -S]\n",
  "NUANCE": "to give subtle shades of meaning to [v NUANCED, NUANCING, NUANCES]\n",
  "NUANCED": "NUANCE, to give subtle shades of meaning to [v]\n",
  "NUANCES": "NUANCE, to give subtle shades of meaning to [v]\n",
  "NUANCING": "NUANCE, to give subtle shades of meaning to [v]\n",
  "NUB": "(obsolete) to hang [v NUBBED, NUBBING, NUBS]\n",
  "NUBBED": "NUB, (obsolete) to hang [v]\n",
  "NUBBER": "in baseball, a weakly hit ball [n -S]\n",
  "NUBBERS": "NUBBER, in baseball, a weakly hit ball [n]\n",
  "NUBBIER": "NUBBY, having small protuberances, also NUBBLY [adj]\n",
  "NUBBIEST": "NUBBY, having small protuberances, also NUBBLY [adj]\n",
  "NUBBIN": "a stunted or imperfect ear of maize etc.; (figurative) a residual part, a stub, a stump [n -S]\n",
  "NUBBINESS": "the state of being nubby [n -ES]\n",
  "NUBBINESSES": "NUBBINESS, the state of being nubby [n]\n",
  "NUBBING": "an execution by hanging [n -S]\n",
  "NUBBINGS": "NUBBING, an execution by hanging [n]\n",
  "NUBBINS": "NUBBIN, a stunted or imperfect ear of maize etc.; (figurative) a residual part, a stub, a stump [n]\n",
  "NUBBLE": "to beat with the fists, also KNUBBLE, KNOBBLE [v NUBBLED, NUBBLING, NUBBLES]\n",
  "NUBBLED": "NUBBLE, to beat with the fists, also KNUBBLE, KNOBBLE [v]\n",
  "NUBBLES": "NUBBLE, to beat with the fists, also KNUBBLE, KNOBBLE [v]\n",
  "NUBBLIER": "NUBBLY, having small protuberances, also NUBBY [adj]\n",
  "NUBBLIEST": "NUBBLY, having small protuberances, also NUBBY [adj]\n",
  "NUBBLING": "NUBBLE, to beat with the fists, also KNUBBLE, KNOBBLE [v]\n",
  "NUBBLY": "having small protuberances, also NUBBY [adj NUBBLIER, NUBBLIEST]\n",
  "NUBBY": "having small protuberances, also NUBBLY [adj NUBBIER, NUBBIEST]\n",
  "NUBECULA": "(Latin) a cloudy formation in urine [n NUBECULAE]\n",
  "NUBECULAE": "NUBECULA, (Latin) a cloudy formation in urine [n]\n",
  "NUBIA": "a woman's soft fleecy scarf for the head and neck [n -S]\n",
  "NUBIAS": "NUBIA, a woman's soft fleecy scarf for the head and neck [n]\n",
  "NUBIFEROUS": "cloud-bringing [adj]\n",
  "NUBIFORM": "cloudlike [adj]\n",
  "NUBIGENOUS": "cloud-born [adj]\n",
  "NUBILE": "suitable for marriage [adj]\n",
  "NUBILITIES": "NUBILITY, the quality of being nubile [n]\n",
  "NUBILITY": "the quality of being nubile [n NUBILITIES]\n",
  "NUBILOSE": "cloudy; vague, also NUBILOUS [adj]\n",
  "NUBILOUS": "cloudy; vague, also NUBILOSE [adj]\n",
  "NUBS": "NUB, (obsolete) to hang [v]\n",
  "NUBUCK": "a type of leather with a velvety finish [n -S]\n",
  "NUBUCKS": "NUBUCK, a type of leather with a velvety finish [n]\n",
  "NUCELLAR": "relating to the nucellus, the mass of tissues within the integuments of a plant's ovule, containing the embryo sac [adj]\n",
  "NUCELLI": "NUCELLUS, (Latin) the mass of tissues within the integuments of a plant's ovule, containing the embryo sac [n]\n",
  "NUCELLUS": "(Latin) the mass of tissues within the integuments of a plant's ovule, containing the embryo sac [n NUCELLI]\n",
  "NUCHA": "(Latin) the nape of the neck, also NUCHAL [n NUCHAE]\n",
  "NUCHAE": "NUCHA, (Latin) the nape of the neck, also NUCHAL [n]\n",
  "NUCHAL": "the nape of the neck, also NUCHA [n -S]\n",
  "NUCHALS": "NUCHAL, the nape of the neck, also NUCHA [n]\n",
  "NUCIFEROUS": "nut-bearing [adj]\n",
  "NUCIVOROUS": "nut-eating [adj]\n",
  "NUCLEAL": "of or like a nucleus [adj]\n",
  "NUCLEAR": "pertaining to a nucleus [adj]\n",
  "NUCLEARISATION": "the process of nuclearising, also NUCLEARIZATION [n -S]\n",
  "NUCLEARISATIONS": "NUCLEARISATION, the process of nuclearising, also NUCLEARIZATION [n]\n",
  "NUCLEARISE": "to make nuclear; to fit nuclear weapons, also NUCLEARIZE [v NUCLEARISED, NUCLEARISING, NUCLEARISES]\n",
  "NUCLEARISED": "NUCLEARISE, to make nuclear; to fit nuclear weapons, also NUCLEARIZE [v]\n",
  "NUCLEARISES": "NUCLEARISE, to make nuclear; to fit nuclear weapons, also NUCLEARIZE [v]\n",
  "NUCLEARISING": "NUCLEARISE, to make nuclear; to fit nuclear weapons, also NUCLEARIZE [v]\n",
  "NUCLEARIZATION": "the process of nuclearizing, also NUCLEARISATION [n -S]\n",
  "NUCLEARIZATIONS": "NUCLEARIZATION, the process of nuclearizing, also NUCLEARISATION [n]\n",
  "NUCLEARIZE": "to make nuclear; to fit nuclear weapons, also NUCLEARISE [v NUCLEARIZED, NUCLEARIZING, NUCLEARIZES]\n",
  "NUCLEARIZED": "NUCLEARIZE, to make nuclear; to fit nuclear weapons, also NUCLEARISE [v]\n",
  "NUCLEARIZES": "NUCLEARIZE, to make nuclear; to fit nuclear weapons, also NUCLEARISE [v]\n",
  "NUCLEARIZING": "NUCLEARIZE, to make nuclear; to fit nuclear weapons, also NUCLEARISE [v]\n",
  "NUCLEASE": "any of a number of enzymes producing hydrolysis in nucleic acids [n -S]\n",
  "NUCLEASES": "NUCLEASE, any of a number of enzymes producing hydrolysis in nucleic acids [n]\n",
  "NUCLEATE": "to form into a nucleus [v NUCLEATED, NUCLEATING, NUCLEATES]\n",
  "NUCLEATED": "NUCLEATE, to form into a nucleus [v]\n",
  "NUCLEATES": "NUCLEATE, to form into a nucleus [v]\n",
  "NUCLEATING": "NUCLEATE, to form into a nucleus [v]\n",
  "NUCLEATION": "the act of nucleating [n -S]\n",
  "NUCLEATIONS": "NUCLEATION, the act of nucleating [n]\n",
  "NUCLEATOR": "a device for nucleating [n -S]\n",
  "NUCLEATORS": "NUCLEATOR, a device for nucleating [n]\n",
  "NUCLEI": "NUCLEUS, (Latin) an essential part of a cell [n]\n",
  "NUCLEIC": "as in nucleic acid, a class of acid including those in DNA and RNA [adj]\n",
  "NUCLEIDE": "an atom of specified atomic number and mass number, also NUCLIDE [n -S]\n",
  "NUCLEIDES": "NUCLEIDE, an atom of specified atomic number and mass number, also NUCLIDE [n]\n",
  "NUCLEIN": "a protein found in cell nuclei [n -S]\n",
  "NUCLEINIC": "relating to nuclein, a colourless amorphous substance of varying composition, obtained from cell nuclei [adj]\n",
  "NUCLEINS": "NUCLEIN, a protein found in cell nuclei [n]\n",
  "NUCLEOCAPSID": "the nucleic acid and surrounding protein coat in a virus [n -S]\n",
  "NUCLEOCAPSIDS": "NUCLEOCAPSID, the nucleic acid and surrounding protein coat in a virus [n]\n",
  "NUCLEOID": "the DNA-containing area of certain cells [n -S]\n",
  "NUCLEOIDS": "NUCLEOID, the DNA-containing area of certain cells [n]\n",
  "NUCLEOLAR": "of or pertaining to the nucleolus of a cell [adj]\n",
  "NUCLEOLATE": "having a nucleus or nucleolus, also NUCLEOLATED [adj]\n",
  "NUCLEOLATED": "having a nucleus or nucleolus, also NUCLEOLATE [adj]\n",
  "NUCLEOLE": "a minute rounded body within the nucleus of a cell, associated with RNA synthesis, also NUCLEOLUS [n -S]\n",
  "NUCLEOLES": "NUCLEOLE, a minute rounded body within the nucleus of a cell, associated with RNA synthesis, also NUCLEOLUS [n]\n",
  "NUCLEOLI": "NUCLEOLUS, a minute rounded body within the nucleus of a cell, associated with RNA synthesis, also NUCLEOLE [n]\n",
  "NUCLEOLUS": "a minute rounded body within the nucleus of a cell, associated with RNA synthesis, also NUCLEOLE [n NUCLEOLI]\n",
  "NUCLEON": "a general name for a neutron or proton [n -S]\n",
  "NUCLEONIC": "pertaining to nuclear physics [adj NUCLEONICALLY]\n",
  "NUCLEONICALLY": "NUCLEONIC, pertaining to nuclear physics [adv]\n",
  "NUCLEONICS": "nuclear physics, esp. in its practical applications [n]\n",
  "NUCLEONS": "NUCLEON, a general name for a neutron or proton [n]\n",
  "NUCLEOPHILE": "a substance that donates electrons [n -S]\n",
  "NUCLEOPHILES": "NUCLEOPHILE, a substance that donates electrons [n]\n",
  "NUCLEOPHILIC": "having an affinity for atomic nuclei [adj]\n",
  "NUCLEOPHILICITY": "the state of being nucleophilic [n]\n",
  "NUCLEOPLASM": "the protoplasm in the nucleus of a cell [n -S]\n",
  "NUCLEOPLASMATIC": "relating to nucleoplasm, the protoplasm in the nucleus of a cell, also NUCLEOPLASMIC [adj]\n",
  "NUCLEOPLASMIC": "relating to nucleoplasm, the protoplasm in the nucleus of a cell, also NUCLEOPLASMATIC [adj]\n",
  "NUCLEOPLASMS": "NUCLEOPLASM, the protoplasm in the nucleus of a cell [n]\n",
  "NUCLEOPROTEIN": "a compound that consists of a protein (as a histone) conjugated with a nucleic acid (as a DNA) and that is the principal constituent of the hereditary material in chromosomes [n -S]\n",
  "NUCLEOPROTEINS": "NUCLEOPROTEIN, a compound that consists of a protein (as a histone) conjugated with a nucleic acid (as a DNA) and that is the principal constituent of the hereditary material in chromosomes [n]\n",
  "NUCLEOSIDE": "a deoxyribose or ribose sugar molecule to which a pruine or pyrimidine base is covalently bound [n -S]\n",
  "NUCLEOSIDES": "NUCLEOSIDE, a deoxyribose or ribose sugar molecule to which a pruine or pyrimidine base is covalently bound [n]\n",
  "NUCLEOSOMAL": "of or like a nucleosome [adj]\n",
  "NUCLEOSOME": "a repeating unit of chromatin occurring along a strand of DNA [n -S]\n",
  "NUCLEOSOMES": "NUCLEOSOME, a repeating unit of chromatin occurring along a strand of DNA [n]\n",
  "NUCLEOSYNTHESES": "NUCLEOSYNTHESIS, the production of a chemical element from simpler nuclei, as of hydrogen, esp. in a star [n]\n",
  "NUCLEOSYNTHESIS": "the production of a chemical element from simpler nuclei, as of hydrogen, esp. in a star [n NUCLEOSYNTHESES]\n",
  "NUCLEOSYNTHETIC": "relating to nucleosynthesis [adj]\n",
  "NUCLEOTIDASE": "a phosphatase that promotes hydrolysis of a nucleotide (as into a nucleoside and phosphoric acid) [n -S]\n",
  "NUCLEOTIDASES": "NUCLEOTIDASE, a phosphatase that promotes hydrolysis of a nucleotide (as into a nucleoside and phosphoric acid) [n]\n",
  "NUCLEOTIDE": "a nucleoside with a phosphate group attached to the sugar [n -S]\n",
  "NUCLEOTIDES": "NUCLEOTIDE, a nucleoside with a phosphate group attached to the sugar [n]\n",
  "NUCLEUS": "(Latin) an essential part of a cell [n NUCLEUSES or NUCLEI]\n",
  "NUCLEUSES": "NUCLEUS, (Latin) an essential part of a cell [n]\n",
  "NUCLIDE": "an atom of specified atomic number and mass number, also NUCLEIDE [n -S]\n",
  "NUCLIDES": "NUCLIDE, an atom of specified atomic number and mass number, also NUCLEIDE [n]\n",
  "NUCLIDIC": "of or like a nuclide, an atom of specified atomic number and mass number [adj]\n",
  "NUCULE": "the stone of a fleshy fruit [n -S]\n",
  "NUCULES": "NUCULE, the stone of a fleshy fruit [n]\n",
  "NUDATION": "the act of making bare [n -S]\n",
  "NUDATIONS": "NUDATION, the act of making bare [n]\n",
  "NUDDIES": "NUDDY, (Australian slang) state of nakedness (e.g. in the nuddy) [n]\n",
  "NUDDY": "(Australian slang) state of nakedness (e.g. in the nuddy) [n NUDDIES]\n",
  "NUDE": "without clothes [adj NUDER, NUDEST, NUDELY] / a naked figure [n -S]\n",
  "NUDELY": "NUDE, without clothes [adv]\n",
  "NUDENESS": "nudity [n -ES]\n",
  "NUDENESSES": "NUDENESS, nudity [n]\n",
  "NUDER": "NUDE, without clothes [adj]\n",
  "NUDES": "NUDE, a naked figure [n]\n",
  "NUDEST": "NUDE, without clothes [adj]\n",
  "NUDGE": "to poke gently [v NUDGED, NUDGING, NUDGES]\n",
  "NUDGED": "NUDGE, to poke gently [v]\n",
  "NUDGER": "one who nudges [n -S]\n",
  "NUDGERS": "NUDGER, one who nudges [n]\n",
  "NUDGES": "NUDGE, to poke gently [v]\n",
  "NUDGING": "NUDGE, to poke gently [v]\n",
  "NUDIBRANCH": "a member of the Nudibranchiata, sea slugs, also NUDIBRANCHIATE [n -S]\n",
  "NUDIBRANCHIATE": "a member of the Nudibranchiata, sea slugs, also NUDIBRANCH [n -S]\n",
  "NUDIBRANCHIATES": "NUDIBRANCHIATE, a member of the Nudibranchiata, sea slugs, also NUDIBRANCH [n]\n",
  "NUDIBRANCHS": "NUDIBRANCH, a member of the Nudibranchiata, sea slugs, also NUDIBRANCHIATE [n]\n",
  "NUDICAUDATE": "with hairless tail [adj]\n",
  "NUDICAUL": "having a leafless stem, also NUDICAULOUS [adj]\n",
  "NUDICAULOUS": "having a leafless stem, also NUDICAUL [adj]\n",
  "NUDIE": "(slang) a film featuring nudity [n -S]\n",
  "NUDIES": "NUDIE, (slang) a film featuring nudity [n]\n",
  "NUDISM": "the practice of going nude [n -S]\n",
  "NUDISMS": "NUDISM, the practice of going nude [n]\n",
  "NUDIST": "an advocate of nudism [n -S]\n",
  "NUDISTS": "NUDIST, an advocate of nudism [n]\n",
  "NUDITIES": "NUDITY, the state of being nude [n]\n",
  "NUDITY": "the state of being nude [n NUDITIES]\n",
  "NUDNICK": "(Yiddish) a dense, boring, or bothersome person, also NUDNIK [n -S]\n",
  "NUDNICKS": "NUDNICK, (Yiddish) a dense, boring, or bothersome person, also NUDNIK [n]\n",
  "NUDNIK": "(Yiddish) a dense, boring, or bothersome person, also NUDNICK [n -S]\n",
  "NUDNIKS": "NUDNIK, (Yiddish) a dense, boring, or bothersome person, also NUDNICK [n]\n",
  "NUDZH": "(Yiddish) to nag, also NOODGE [v -ED, -ING, -ES]\n",
  "NUDZHED": "NUDZH, (Yiddish) to nag, also NOODGE [v]\n",
  "NUDZHES": "NUDZH, (Yiddish) to nag, also NOODGE [v]\n",
  "NUDZHING": "NUDZH, (Yiddish) to nag, also NOODGE [v]\n",
  "NUFF": "(slang) enough [n -S]\n",
  "NUFFIN": "(slang) nothing [n -S]\n",
  "NUFFINS": "NUFFIN, (slang) nothing [n]\n",
  "NUFFS": "NUFF, (slang) enough [n]\n",
  "NUG": "a chunk of wood sawn from a log [n -S]\n",
  "NUGAE": "(Latin) trifles, jests [n]\n",
  "NUGATORINESS": "the state of being nugatory [n -ES]\n",
  "NUGATORINESSES": "NUGATORINESS, the state of being nugatory [n]\n",
  "NUGATORY": "of little or no consequence, trifling [adj]\n",
  "NUGGAR": "(Arabic) a large boat used to carry cargo on the Nile [n -S]\n",
  "NUGGARS": "NUGGAR, (Arabic) a large boat used to carry cargo on the Nile [n]\n",
  "NUGGET": "to polish shoes or boots [v NUGGETTED or NUGGETED, NUGGETTING or NUGGETING, NUGGETS]\n",
  "NUGGETED": "NUGGET, to polish shoes or boots [v]\n",
  "NUGGETIER": "NUGGETY, in nuggets [adj]\n",
  "NUGGETIEST": "NUGGETY, in nuggets [adj]\n",
  "NUGGETING": "NUGGET, to polish shoes or boots [v]\n",
  "NUGGETS": "NUGGET, to polish shoes or boots [v]\n",
  "NUGGETTED": "NUGGET, to polish shoes or boots [v]\n",
  "NUGGETTING": "NUGGET, to polish shoes or boots [v]\n",
  "NUGGETY": "in nuggets [adj NUGGETIER, NUGGETIEST]\n",
  "NUGS": "NUG, a chunk of wood sawn from a log [n]\n",
  "NUISANCE": "a source of annoyance [n -S]\n",
  "NUISANCER": "one who makes or causes a nuisance [n -S]\n",
  "NUISANCERS": "NUISANCER, one who makes or causes a nuisance [n]\n",
  "NUISANCES": "NUISANCE, a source of annoyance [n]\n",
  "NUKE": "to attack with nuclear weapons [v NUKED, NUKING, NUKES]\n",
  "NUKED": "NUKE, to attack with nuclear weapons [v]\n",
  "NUKES": "NUKE, to attack with nuclear weapons [v]\n",
  "NUKING": "NUKE, to attack with nuclear weapons [v]\n",
  "NULL": "to annul, make void [v -ED, -ING, -S]\n",
  "NULLA": "(Hindi) a ravine, a watercourse, also NALA, NALLA, NALLAH, NULLAH [n -S]\n",
  "NULLAH": "(Hindi) a ravine, a watercourse, also NALA, NALLA, NALLAH, NULLA [n -S]\n",
  "NULLAHS": "NULLAH, (Hindi) a ravine, a watercourse, also NALA, NALLA, NALLAH, NULLA [n]\n",
  "NULLAS": "NULLA, (Hindi) a ravine, a watercourse, also NALA, NALLA, NALLAH, NULLAH [n]\n",
  "NULLED": "NULL, to annul, make void [v]\n",
  "NULLIFICATION": "the act of nullifying [n -S]\n",
  "NULLIFICATIONS": "NULLIFICATION, the act of nullifying [n]\n",
  "NULLIFIDIAN": "one of no faith or religion; a skeptic in matters of religion [n -S]\n",
  "NULLIFIDIANS": "NULLIFIDIAN, one of no faith or religion; a skeptic in matters of religion [n]\n",
  "NULLIFIED": "NULLIFY, to make useless or ineffective [v]\n",
  "NULLIFIER": "one who nullifies or makes void; one who maintains the right to nullify a contract by one of the parties [n -S]\n",
  "NULLIFIERS": "NULLIFIER, one who nullifies or makes void; one who maintains the right to nullify a contract by one of the parties [n]\n",
  "NULLIFIES": "NULLIFY, to make useless or ineffective [v]\n",
  "NULLIFY": "to make useless or ineffective [v NULLIFIED, NULLIFYING, NULLIFIES]\n",
  "NULLIFYING": "NULLIFY, to make useless or ineffective [v]\n",
  "NULLING": "knurled work in woodcarving, also KNURLING [n -S]\n",
  "NULLINGS": "NULLING, knurled work in woodcarving, also KNURLING [n]\n",
  "NULLIPARA": "(Latin) a woman with no children [n NULLIPARAE or NULLIPARAS]\n",
  "NULLIPARAE": "NULLIPARA, (Latin) a woman with no children [n]\n",
  "NULLIPARAS": "NULLIPARA, (Latin) a woman with no children [n]\n",
  "NULLIPARITIES": "NULLIPARITY, the state of being a nullipara [n]\n",
  "NULLIPARITY": "the state of being a nullipara [n NULLIPARITIES]\n",
  "NULLIPAROUS": "having not borne children [adj]\n",
  "NULLIPORE": "(Latin) any of various red algae which secrete a crust of calcium carbonate [n -S]\n",
  "NULLIPORES": "NULLIPORE, (Latin) any of various red algae which secrete a crust of calcium carbonate [n]\n",
  "NULLITIES": "NULLITY, nothingness, also NULLNESS [n]\n",
  "NULLITY": "nothingness, also NULLNESS [n NULLITIES]\n",
  "NULLNESS": "nothingness, also NULLITY [n -ES]\n",
  "NULLNESSES": "NULLNESS, nothingness, also NULLITY [n]\n",
  "NULLS": "NULL, to annul, make void [v]\n",
  "NUMB": "lacking feeling [adj NUMBER, NUMBEST, NUMBLY] / to deprive of feeling [v -ED, -ING, -S]\n",
  "NUMBAT": "(Native Australian) a small Australian marsupial that feeds on termites [n -S]\n",
  "NUMBATS": "NUMBAT, (Native Australian) a small Australian marsupial that feeds on termites [n]\n",
  "NUMBED": "NUMB, to deprive of feeling [v]\n",
  "NUMBER": "to count [v -ED, -ING, -S]\n",
  "NUMBERABLE": "that can be numbered [adj]\n",
  "NUMBERED": "NUMBER, to count [v]\n",
  "NUMBERER": "one who numbers [n -S]\n",
  "NUMBERERS": "NUMBERER, one who numbers [n]\n",
  "NUMBERING": "the act of numbering [n -S]\n",
  "NUMBERINGS": "NUMBERING, the act of numbering [n]\n",
  "NUMBERLESS": "without number, countless [adj NUMBERLESSLY]\n",
  "NUMBERLESSLY": "NUMBERLESS, without number, countless [adv]\n",
  "NUMBERLESSNESS": "NUMBERLESS, without number, countless [n]\n",
  "NUMBERPLATE": "an identifying plate on a car [n -S]\n",
  "NUMBERPLATES": "NUMBERPLATE, an identifying plate on a car [n]\n",
  "NUMBERS": "NUMBER, to count [v]\n",
  "NUMBEST": "NUMB, lacking feeling [adj]\n",
  "NUMBFISH": "the torpedo fish, which numbs by the electric shocks which it gives [n -ES]\n",
  "NUMBFISHES": "NUMBFISH, the torpedo fish, which numbs by the electric shocks which it gives [n]\n",
  "NUMBHEAD": "a stupid person, a blockhead [n -S]\n",
  "NUMBHEADS": "NUMBHEAD, a stupid person, a blockhead [n]\n",
  "NUMBING": "NUMB, to deprive of feeling [v]\n",
  "NUMBINGLY": "NUMBING, NUMB, to deprive of feeling [adv]\n",
  "NUMBLES": "a deer's entrails, also NOMBLES, UMBLES [n]\n",
  "NUMBLY": "NUMB, lacking feeling [adv]\n",
  "NUMBNESS": "the state of being numb [n -ES]\n",
  "NUMBNESSES": "NUMBNESS, the state of being numb [n]\n",
  "NUMBNUT": "an idiot [n -S]\n",
  "NUMBNUTS": "an idiot [n -ES]\n",
  "NUMBNUTSES": "NUMBNUTS, an idiot [n]\n",
  "NUMBS": "NUMB, to deprive of feeling [v]\n",
  "NUMBSKULL": "a stupid person, also NUMSKULL [n -S]\n",
  "NUMBSKULLED": "stupid, doltish, also NUMSKULLED [adj]\n",
  "NUMBSKULLS": "NUMBSKULL, a stupid person, also NUMSKULL [n]\n",
  "NUMCHUCK": "(Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUNCHAKU, NUNCHUCK, NUNCHUK [n -S]\n",
  "NUMCHUCKS": "NUMCHUCK, (Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUNCHAKU, NUNCHUCK, NUNCHUK [n]\n",
  "NUMDAH": "(Urdu) an embroidered felt rug made in India [n -S]\n",
  "NUMDAHS": "NUMDAH, (Urdu) an embroidered felt rug made in India [n]\n",
  "NUMEN": "(Latin) a local or presiding divinity; a god in human form [n NUMINA]\n",
  "NUMERABILITIES": "NUMERABILITY, the quality of being numerable [n]\n",
  "NUMERABILITY": "the quality of being numerable [n NUMERABILITIES]\n",
  "NUMERABLE": "that can be numbered [adj NUMERABLY]\n",
  "NUMERABLY": "NUMERABLE, that can be numbered [adv]\n",
  "NUMERACIES": "NUMERACY, the state of understanding basic mathematics [n]\n",
  "NUMERACY": "the state of understanding basic mathematics [n NUMERACIES]\n",
  "NUMERAIRE": "(French) a standard for currency exchange rates [n -S]\n",
  "NUMERAIRES": "NUMERAIRE, (French) a standard for currency exchange rates [n]\n",
  "NUMERAL": "according to number [adj NUMERALLY] / a symbol that expresses a number [n -S]\n",
  "NUMERALLY": "NUMERAL, according to number [adv]\n",
  "NUMERALS": "NUMERAL, a symbol that expresses a number [n]\n",
  "NUMERARY": "pertaining to numbers [adj]\n",
  "NUMERATE": "to compute, calculate, also ENUMERATE [v NUMERATED, NUMERATING, NUMERATES]\n",
  "NUMERATED": "NUMERATE, to compute, calculate, also ENUMERATE [v]\n",
  "NUMERATES": "NUMERATE, to compute, calculate, also ENUMERATE [v]\n",
  "NUMERATING": "NUMERATE, to compute, calculate, also ENUMERATE [v]\n",
  "NUMERATION": "the act of counting or numbering [n -S]\n",
  "NUMERATIONS": "NUMERATION, the act of counting or numbering [n]\n",
  "NUMERATIVE": "relating to numeration [adj]\n",
  "NUMERATOR": "one who numbers [n -S]\n",
  "NUMERATORS": "NUMERATOR, one who numbers [n]\n",
  "NUMERIC": "relating to number, also NUMERICAL [adj NUMERICALLY] / a numeral [n -S]\n",
  "NUMERICAL": "relating to number, also NUMERIC [adj NUMERICALLY]\n",
  "NUMERICALLY": "NUMERICAL, relating to number, also NUMERIC [adv]\n",
  "NUMERICS": "NUMERIC, a numeral [n]\n",
  "NUMEROLOGICAL": "relating to numerology [adj]\n",
  "NUMEROLOGIES": "NUMEROLOGY, the study of the occult significance of numbers [n]\n",
  "NUMEROLOGIST": "a student of numerology [n -S]\n",
  "NUMEROLOGISTS": "NUMEROLOGIST, a student of numerology [n]\n",
  "NUMEROLOGY": "the study of the occult significance of numbers [n NUMEROLOGIES]\n",
  "NUMEROSITIES": "NUMEROSITY, the state of being numerous [n]\n",
  "NUMEROSITY": "the state of being numerous [n NUMEROSITIES]\n",
  "NUMEROUS": "many [adj NUMEROUSLY]\n",
  "NUMEROUSLY": "NUMEROUS, many [adv]\n",
  "NUMEROUSNESS": "the state of being numerous [n -ES]\n",
  "NUMEROUSNESSES": "NUMEROUSNESS, the state of being numerous [n]\n",
  "NUMINA": "NUMEN, (Latin) a local or presiding divinity; a god in human form [n]\n",
  "NUMINOUS": "filled with a sense of the presence of divinity [adj] / something filled with a sense of the presence of divinity [n NUMINOUSES]\n",
  "NUMINOUSES": "NUMINOUS, something filled with a sense of the presence of divinity [n]\n",
  "NUMINOUSNESS": "the quality of being numinous [n -ES]\n",
  "NUMINOUSNESSES": "NUMINOUSNESS, the quality of being numinous [n]\n",
  "NUMISMATIC": "relating to numismatics, the study of coins [adj NUMISMATICALLY]\n",
  "NUMISMATICALLY": "NUMISMATIC, relating to numismatics, the study of coins [adv]\n",
  "NUMISMATICS": "the study of coins [n]\n",
  "NUMISMATIST": "a coin collector [n -S]\n",
  "NUMISMATISTS": "NUMISMATIST, a coin collector [n]\n",
  "NUMISMATOLOGIES": "NUMISMATOLOGY, the study or collection of coins and medals [n]\n",
  "NUMISMATOLOGIST": "a specialist in numismatology [n]\n",
  "NUMISMATOLOGY": "the study or collection of coins and medals [n NUMISMATOLOGIES]\n",
  "NUMMARY": "relating to coins or money, also NUMMULARY [adj]\n",
  "NUMMIER": "NUMMY, delicious [adj]\n",
  "NUMMIEST": "NUMMY, delicious [adj]\n",
  "NUMMULAR": "shaped like a coin [adj]\n",
  "NUMMULARY": "relating to coins or money, also NUMMARY [adj]\n",
  "NUMMULATED": "coin-shaped [adj]\n",
  "NUMMULATION": "the arrangement of blood corpuscles in rouleaus [n -S]\n",
  "NUMMULATIONS": "NUMMULATION, the arrangement of blood corpuscles in rouleaus [n]\n",
  "NUMMULINE": "any of large fossil protozoans [n -S]\n",
  "NUMMULINES": "NUMMULINE, any of large fossil protozoans [n]\n",
  "NUMMULITE": "a fossil of the genus Nummulites and allied genera [n -S]\n",
  "NUMMULITES": "NUMMULITE, a fossil of the genus Nummulites and allied genera [n]\n",
  "NUMMULITIC": "of, like, composed of, containing, nummulites; as, nummulitic beds [adj]\n",
  "NUMMY": "delicious [adj NUMMIER, NUMMIEST]\n",
  "NUMNAH": "(Urdu) a pad under the saddle to prevent chafing [n -S]\n",
  "NUMNAHS": "NUMNAH, (Urdu) a pad under the saddle to prevent chafing [n]\n",
  "NUMPKIN": "a stupid person [n -S]\n",
  "NUMPKINS": "NUMPKIN, a stupid person [n]\n",
  "NUMPTIES": "NUMPTY, (Scots) an idiot [n]\n",
  "NUMPTY": "(Scots) an idiot [n NUMPTIES]\n",
  "NUMSKULL": "a stupid person, also NUMBSKULL [n -S]\n",
  "NUMSKULLED": "stupid; doltish, also NUMBSKULLED [adj]\n",
  "NUMSKULLS": "NUMSKULL, a stupid person, also NUMBSKULL [n]\n",
  "NUN": "a woman belonging to a religious order [n -S]\n",
  "NUNATAK": "(Inuit) a point of rock appearing above the surface of land ice [n NUNATAKS or NUNATAKER]\n",
  "NUNATAKER": "NUNATAK, (Inuit) a point of rock appearing above the surface of land ice [n]\n",
  "NUNATAKS": "NUNATAK, (Inuit) a point of rock appearing above the surface of land ice [n]\n",
  "NUNCHAKU": "(Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUMCHUCK, NUNCHUCK, NUNCHUK [n -S]\n",
  "NUNCHAKUS": "NUNCHAKU, (Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUMCHUCK, NUNCHUCK, NUNCHUK [n]\n",
  "NUNCHEON": "a light meal [n -S]\n",
  "NUNCHEONS": "NUNCHEON, a light meal [n]\n",
  "NUNCHUCK": "(Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUMCHUCK, NUNCHAKU, NUNCHUK [n -S]\n",
  "NUNCHUCKS": "NUNCHUCK, (Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUMCHUCK, NUNCHAKU, NUNCHUK [n]\n",
  "NUNCHUK": "(Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUMCHUCK, NUNCHAKU, NUNCHUCK [n -S]\n",
  "NUNCHUKS": "NUNCHUK, (Japanese) a martial arts weapon consisting of two sticks joined by a length of chain, used as a flail or garotte, also NUMCHUCK, NUNCHAKU, NUNCHUCK [n]\n",
  "NUNCIATURE": "the office of a nuncio [n -S]\n",
  "NUNCIATURES": "NUNCIATURE, the office of a nuncio [n]\n",
  "NUNCIO": "(Italian) an ambassador from the pope [n -S]\n",
  "NUNCIOS": "NUNCIO, (Italian) an ambassador from the pope [n]\n",
  "NUNCLE": "(Shakespeare) an uncle [n -S]\n",
  "NUNCLES": "NUNCLE, (Shakespeare) an uncle [n]\n",
  "NUNCUPATE": "to utter as a vow [v NUNCUPATED, NUNCUPATING, NUNCUPATES]\n",
  "NUNCUPATED": "NUNCUPATE, to utter as a vow [v]\n",
  "NUNCUPATES": "NUNCUPATE, to utter as a vow [v]\n",
  "NUNCUPATING": "NUNCUPATE, to utter as a vow [v]\n",
  "NUNCUPATION": "the act of uttering a vow [n -S]\n",
  "NUNCUPATIONS": "NUNCUPATION, the act of uttering a vow [n]\n",
  "NUNCUPATIVE": "of a will or testament, made before oral witnesses only, also NUNCUPATORY [adj]\n",
  "NUNCUPATORY": "(obsolete) of a will or testament, made before oral witnesses only, also NUNCUPATIVE [adj]\n",
  "NUNDINAL": "any of the letters from A to H relating to days of the ancient Roman calendar [n -S]\n",
  "NUNDINALS": "NUNDINAL, any of the letters from A to H relating to days of the ancient Roman calendar [n]\n",
  "NUNDINE": "(Latin) the ancient Roman market-day, every eighth day [n -S]\n",
  "NUNDINES": "NUNDINE, (Latin) the ancient Roman market-day, every eighth day [n]\n",
  "NUNHOOD": "the condition of a nun [n -S]\n",
  "NUNHOODS": "NUNHOOD, the condition of a nun [n]\n",
  "NUNLIKE": "like a nun [adj]\n",
  "NUNNATION": "the addition of a final n in the declension of nouns [n -S]\n",
  "NUNNATIONS": "NUNNATION, the addition of a final n in the declension of nouns [n]\n",
  "NUNNERIES": "NUNNERY, a religious house for nuns [n]\n",
  "NUNNERY": "a religious house for nuns [n NUNNERIES]\n",
  "NUNNISH": "of, pertaining to, or resembling a nun [adj]\n",
  "NUNNISHNESS": "the quality of being like a nun [n -ES]\n",
  "NUNNISHNESSES": "NUNNISHNESS, the quality of being like a nun [n]\n",
  "NUNNY": "as in nunny bag, a small sealskin haversack [adj]\n",
  "NUNS": "NUN, a woman belonging to a religious order [n]\n",
  "NUNSHIP": "the condition of a nun [n -S]\n",
  "NUNSHIPS": "NUNSHIP, the condition of a nun [n]\n",
  "NUPTIAL": "relating to weddings [adj NUPTIALLY] / a wedding ceremony [n -S]\n",
  "NUPTIALITIES": "NUPTIALITY, nuptial character or quality [n]\n",
  "NUPTIALITY": "nuptial character or quality [n NUPTIALITIES]\n",
  "NUPTIALLY": "NUPTIAL, relating to weddings [adv]\n",
  "NUPTIALS": "NUPTIAL, a wedding ceremony [n]\n",
  "NUR": "a knot in wood, also KNAR, KNAUR, KNUR, KNURR, NURR [n -S]\n",
  "NURAGHE": "a broch-like Sardinian round tower, probably of the Bronze Age, also NURHAG [n NURAGHI]\n",
  "NURAGHI": "NURAGHE, a broch-like Sardinian round tower, probably of the Bronze Age, also NURHAG [n]\n",
  "NURAGHIC": "relating to nuraghi, Sardinian round towers [adj]\n",
  "NURD": "a socially inept person, also NERD [n -S]\n",
  "NURDIER": "NURDY, socially inept, also NERDY, NURDISH, NERDISH [adj]\n",
  "NURDIEST": "NURDY, socially inept, also NERDY, NURDISH, NERDISH [adj]\n",
  "NURDISH": "socially inept, also NERDY, NURDY, NERDISH [adj]\n",
  "NURDLE": "in cricket, to score runs by gently pushing with the bat rather than hitting hard [v NURDLED, NURDLING, NURDLES]\n",
  "NURDLED": "NURDLE, in cricket, to score runs by gently pushing with the bat rather than hitting hard [v]\n",
  "NURDLES": "NURDLE, in cricket, to score runs by gently pushing with the bat rather than hitting hard [v]\n",
  "NURDLING": "NURDLE, in cricket, to score runs by gently pushing with the bat rather than hitting hard [v]\n",
  "NURDS": "NURD, a socially inept person, also NERD [n]\n",
  "NURDY": "socially inept, also NERDY, NURDISH, NERDISH [adj NURDIER, NURDIEST]\n",
  "NURHAG": "a broch-like Sardinian round tower, probably of the Bronze Age, also NURAGHE [n -S]\n",
  "NURHAGS": "NURHAG, a broch-like Sardinian round tower, probably of the Bronze Age, also NURAGHE [n]\n",
  "NURL": "a small excrescence or protuberance [n -S] / to make nurls on, also KNURL [v -ED, -ING, -S]\n",
  "NURLED": "NURL, to make nurls on, also KNURL [v]\n",
  "NURLING": "NURL, to make nurls on, also KNURL [v]\n",
  "NURLS": "NURL, to make nurls on, also KNURL [v]\n",
  "NURR": "a knot in wood, also KNAR, KNAUR, KNUR, KNURR, NUR [n -S]\n",
  "NURRS": "NURR, a knot in wood, also KNAR, KNAUR, KNUR, KNURR, NUR [n]\n",
  "NURS": "NUR, a knot in wood, also KNAR, KNAUR, KNUR, KNURR, NURR [n]\n",
  "NURSE": "to care for the sick [v NURSED, NURSING, NURSES]\n",
  "NURSED": "NURSE, to care for the sick [v]\n",
  "NURSEHOUND": "a kind of shark [n -S]\n",
  "NURSEHOUNDS": "NURSEHOUND, a kind of shark [n]\n",
  "NURSELIKE": "like a nurse [adj]\n",
  "NURSELING": "an infant that is being suckled, also NURSLING [n -S]\n",
  "NURSELINGS": "NURSELING, an infant that is being suckled, also NURSLING [n]\n",
  "NURSEMAID": "a woman employed to take care of children [n -S] / to look after as a nursemaid [v -ED, -ING, -S]\n",
  "NURSEMAIDED": "NURSEMAID, to look after as a nursemaid [v]\n",
  "NURSEMAIDING": "NURSEMAID, to look after as a nursemaid [v]\n",
  "NURSEMAIDS": "NURSEMAID, to look after as a nursemaid [v]\n",
  "NURSER": "one who nurses; one who cherishes or encourages growth [n -S]\n",
  "NURSERIES": "NURSERY, a room for young children [n]\n",
  "NURSERS": "NURSER, one who nurses; one who cherishes or encourages growth [n]\n",
  "NURSERY": "a room for young children [n NURSERIES]\n",
  "NURSERYMAID": "one employed to look after small children [n -S]\n",
  "NURSERYMAIDS": "NURSERYMAID, one employed to look after small children [n]\n",
  "NURSERYMAN": "one whose occupation is the cultivation of plants (as trees and shrubs) esp. for sale [n NURSERYMEN]\n",
  "NURSERYMEN": "NURSERYMAN, one whose occupation is the cultivation of plants (as trees and shrubs) esp. for sale [n]\n",
  "NURSES": "NURSE, to care for the sick [v]\n",
  "NURSING": "the profession of one who nurses [n -S]\n",
  "NURSINGS": "NURSING, the profession of one who nurses [n]\n",
  "NURSLE": "to foster, also NOURSLE, NOUSELL, NOUSLE [v NURSLED, NURSLING, NURSLES]\n",
  "NURSLED": "NURSLE, to foster, also NOURSLE, NOUSELL, NOUSLE [v]\n",
  "NURSLES": "NURSLE, to foster, also NOURSLE, NOUSELL, NOUSLE [v]\n",
  "NURSLING": "an infant that is being suckled, also NURSELING [n -S]\n",
  "NURSLINGS": "NURSLING, an infant that is being suckled, also NURSELING [n]\n",
  "NURTURABLE": "that can be nurtured [adj]\n",
  "NURTURAL": "relating to the process of nurturing [adj]\n",
  "NURTURANCE": "nurture [n -S]\n",
  "NURTURANCES": "NURTURANCE, nurture [n]\n",
  "NURTURANT": "tending to nurture [adj]\n",
  "NURTURE": "to nourish [v NURTURED, NURTURING, NURTURES]\n",
  "NURTURED": "NURTURE, to nourish [v]\n",
  "NURTURER": "one who nurtures [n -S]\n",
  "NURTURERS": "NURTURER, one who nurtures [n]\n",
  "NURTURES": "NURTURE, to nourish [v]\n",
  "NURTURING": "NURTURE, to nourish [v]\n",
  "NUS": "NU, (Greek) a Greek letter [n]\n",
  "NUT": "to gather hard-shelled dry fruit [v NUTTED, NUTTING, NUTS]\n",
  "NUTANT": "drooping [adj]\n",
  "NUTARIAN": "an advocate of nuts as nutritious food [n -S]\n",
  "NUTARIANS": "NUTARIAN, an advocate of nuts as nutritious food [n]\n",
  "NUTATE": "to nod, to droop [v NUTATED, NUTATING, NUTATES]\n",
  "NUTATED": "NUTATE, to nod, to droop [v]\n",
  "NUTATES": "NUTATE, to nod, to droop [v]\n",
  "NUTATING": "NUTATE, to nod, to droop [v]\n",
  "NUTATION": "a nodding [n -S]\n",
  "NUTATIONAL": "relating to nutation, a fluctuation or nodding in movement of earth's pole [adj]\n",
  "NUTATIONS": "NUTATION, a nodding [n]\n",
  "NUTBAR": "a bar made from chopped nuts [n -S]\n",
  "NUTBARS": "NUTBAR, a bar made from chopped nuts [n]\n",
  "NUTBROWN": "of a dark brown [adj]\n",
  "NUTBUTTER": "a butter substitute or spread made from nuts [n -S]\n",
  "NUTBUTTERS": "NUTBUTTER, a butter substitute or spread made from nuts [n]\n",
  "NUTCASE": "(offensive) a crazy person [n -S]\n",
  "NUTCASES": "NUTCASE, (offensive) a crazy person [n]\n",
  "NUTCRACKER": "a bird of the crow family [n -S]\n",
  "NUTCRACKERS": "NUTCRACKER, a bird of the crow family [n]\n",
  "NUTGALL": "a round gall produced on the leaves and shoots of various species of the oak tree, also GALLNUT [n -S]\n",
  "NUTGALLS": "NUTGALL, a round gall produced on the leaves and shoots of various species of the oak tree, also GALLNUT [n]\n",
  "NUTGRASS": "any of various American sedges, also NUTSEDGE [n -ES]\n",
  "NUTGRASSES": "NUTGRASS, any of various American sedges, also NUTSEDGE [n]\n",
  "NUTHATCH": "any of various small passerine birds of the genus Sitta [n -ES]\n",
  "NUTHATCHES": "NUTHATCH, any of various small passerine birds of the genus Sitta [n]\n",
  "NUTHIN": "(colloquial) nothing, also NAETHING, NOTHING [n]\n",
  "NUTHOUSE": "(offensive colloquial) a lunatic asylum [n -S]\n",
  "NUTHOUSES": "NUTHOUSE, (offensive colloquial) a lunatic asylum [n]\n",
  "NUTJOB": "(slang) a crazy person [n -S]\n",
  "NUTJOBBER": "the nuthatch [n -S]\n",
  "NUTJOBBERS": "NUTJOBBER, the nuthatch [n]\n",
  "NUTJOBS": "NUTJOB, (slang) a crazy person [n]\n",
  "NUTLET": "a small nut [n -S]\n",
  "NUTLETS": "NUTLET, a small nut [n]\n",
  "NUTLIKE": "like a nut [adj]\n",
  "NUTLOAF": "a savoury loaf made from nuts, vegetables, rice, etc. [n NUTLOAVES]\n",
  "NUTLOAVES": "NUTLOAF, a savoury loaf made from nuts, vegetables, rice, etc. [n]\n",
  "NUTMEAL": "meal made from nuts [n -S]\n",
  "NUTMEALS": "NUTMEAL, meal made from nuts [n]\n",
  "NUTMEAT": "the edible kernel of a nut [n -S]\n",
  "NUTMEATS": "NUTMEAT, the edible kernel of a nut [n]\n",
  "NUTMEG": "in football, to kick the ball between an opponent's legs [v NUTMEGGED, NUTMEGGING, NUTMEGS]\n",
  "NUTMEGGED": "NUTMEG, in football, to kick the ball between an opponent's legs [v]\n",
  "NUTMEGGIER": "NUTMEGGY, full of or tasting like nutmeg [adj]\n",
  "NUTMEGGIEST": "NUTMEGGY, full of or tasting like nutmeg [adj]\n",
  "NUTMEGGING": "NUTMEG, in football, to kick the ball between an opponent's legs [v]\n",
  "NUTMEGGY": "full of or tasting like nutmeg [adj NUTMEGGIER, NUTMEGGIEST]\n",
  "NUTMEGS": "NUTMEG, in football, to kick the ball between an opponent's legs [v]\n",
  "NUTPECKER": "the nuthatch [n -S]\n",
  "NUTPECKERS": "NUTPECKER, the nuthatch [n]\n",
  "NUTPICK": "a device for extracting the kernels from nuts [n -S]\n",
  "NUTPICKS": "NUTPICK, a device for extracting the kernels from nuts [n]\n",
  "NUTRACEUTICAL": "a food with (or believed to have) medicinal properties [n -S]\n",
  "NUTRACEUTICALS": "NUTRACEUTICAL, a food with (or believed to have) medicinal properties [n]\n",
  "NUTRIA": "(Spanish) the coypu, or its fur [n -S]\n",
  "NUTRIAS": "NUTRIA, (Spanish) the coypu, or its fur [n]\n",
  "NUTRIENT": "a nourishing substance [n -S]\n",
  "NUTRIENTS": "NUTRIENT, a nourishing substance [n]\n",
  "NUTRIGENETICS": "the branch of science concerned with the effect of heredity on diet and nutrition [n]\n",
  "NUTRIGENOMICS": "the study of how food affects people according to their genetic constitution [n]\n",
  "NUTRIMENT": "anything which nourishes [n -S]\n",
  "NUTRIMENTAL": "relating to nutriment [adj]\n",
  "NUTRIMENTS": "NUTRIMENT, anything which nourishes [n]\n",
  "NUTRITION": "the act of nourishing; food [n -S]\n",
  "NUTRITIONAL": "relating to nutrition [adj NUTRITIONALLY]\n",
  "NUTRITIONALLY": "NUTRITIONAL, relating to nutrition [adv]\n",
  "NUTRITIONARY": "relating to nutrition [adj]\n",
  "NUTRITIONIST": "a specialist in the study of nutrition [n -S]\n",
  "NUTRITIONISTS": "NUTRITIONIST, a specialist in the study of nutrition [n]\n",
  "NUTRITIONS": "NUTRITION, the act of nourishing; food [n]\n",
  "NUTRITIOUS": "giving nourishment [adj NUTRITIOUSLY]\n",
  "NUTRITIOUSLY": "NUTRITIOUS, giving nourishment [adv]\n",
  "NUTRITIOUSNESS": "the state of being nutritious [n]\n",
  "NUTRITIVE": "relating to nutrition [adj NUTRITIVELY] / a substance that nourishes [n -S]\n",
  "NUTRITIVELY": "NUTRITIVE, relating to nutrition [adv]\n",
  "NUTRITIVES": "NUTRITIVE, a substance that nourishes [n]\n",
  "NUTS": "NUT, to gather hard-shelled dry fruit [v]\n",
  "NUTSEDGE": "any of various American sedges, also NUTGRASS [n -S]\n",
  "NUTSEDGES": "NUTSEDGE, any of various American sedges, also NUTGRASS [n]\n",
  "NUTSHELL": "the shell of a nut [n -S]\n",
  "NUTSHELLS": "NUTSHELL, the shell of a nut [n]\n",
  "NUTSIER": "NUTSY, (slang) crazy [adj]\n",
  "NUTSIEST": "NUTSY, (slang) crazy [adj]\n",
  "NUTSO": "(offensive Australian slang) a crazy person [n -S]\n",
  "NUTSOS": "NUTSO, (offensive Australian slang) a crazy person [n]\n",
  "NUTSY": "(slang) crazy [adj NUTSIER, NUTSIEST]\n",
  "NUTTED": "NUT, to gather hard-shelled dry fruit [v]\n",
  "NUTTER": "a crazy person [n -S]\n",
  "NUTTERIES": "NUTTERY, an area of nut-trees [n]\n",
  "NUTTERS": "NUTTER, a crazy person [n]\n",
  "NUTTERY": "an area of nut-trees [n NUTTERIES]\n",
  "NUTTIER": "NUTTY, tasting of nuts; crazy [adj]\n",
  "NUTTIEST": "NUTTY, tasting of nuts; crazy [adj]\n",
  "NUTTILY": "NUTTY, tasting of nuts; crazy [adv]\n",
  "NUTTINESS": "the quality of being nutty [n -ES]\n",
  "NUTTINESSES": "NUTTINESS, the quality of being nutty [n]\n",
  "NUTTING": "the act of gathering nuts [n -S]\n",
  "NUTTINGS": "NUTTING, the act of gathering nuts [n]\n",
  "NUTTY": "tasting of nuts; crazy [adj NUTTIER, NUTTIEST, NUTTILY]\n",
  "NUTWOOD": "a nut-bearing tree [n -S]\n",
  "NUTWOODS": "NUTWOOD, a nut-bearing tree [n]\n",
  "NUZZER": "(Hindi) a present to a superior [n -S]\n",
  "NUZZERS": "NUZZER, (Hindi) a present to a superior [n]\n",
  "NUZZLE": "to caress with the nose, also SNUZZLE [v NUZZLED, NUZZLING, NUZZLES]\n",
  "NUZZLED": "NUZZLE, to caress with the nose, also SNUZZLE [v]\n",
  "NUZZLER": "one who nuzzles [n -S]\n",
  "NUZZLERS": "NUZZLER, one who nuzzles [n]\n",
  "NUZZLES": "NUZZLE, to caress with the nose, also SNUZZLE [v]\n",
  "NUZZLING": "NUZZLE, to caress with the nose, also SNUZZLE [v]\n",
  "NY": "to approach, also NIE, NIGH, NYE [v NIED or NYED, NYING, NIES]\n",
  "NYAFF": "to yelp, yap [v -ED, -ING, -S]\n",
  "NYAFFED": "NYAFF, to yelp, yap [v]\n",
  "NYAFFING": "NYAFF, to yelp, yap [v]\n",
  "NYAFFS": "NYAFF, to yelp, yap [v]\n",
  "NYAH": "an interjection used to express contempt for another [interj]\n",
  "NYALA": "(Zulu) a kind of antelope, also INYALA [n -S]\n",
  "NYALAS": "NYALA, (Zulu) a kind of antelope, also INYALA [n]\n",
  "NYANZA": "(Bantu) in Africa, a lake [n -S]\n",
  "NYANZAS": "NYANZA, (Bantu) in Africa, a lake [n]\n",
  "NYAOPE": "(South African) another name for the drug whoonga [n -S]\n",
  "NYAOPES": "NYAOPE, (South African) another name for the drug whoonga [n]\n",
  "NYAS": "(obsolete) a young hawk taken from the nest for training, also EYAS, EYASS [n -ES]\n",
  "NYASES": "NYAS, (obsolete) a young hawk taken from the nest for training, also EYAS, EYASS [n]\n",
  "NYBBLE": "a measure of computer information, half a byte [n -S]\n",
  "NYBBLES": "NYBBLE, a measure of computer information, half a byte [n]\n",
  "NYCHTHEMERAL": "(Greek) of or relating to a nychthemeron or 24-hour period [adj]\n",
  "NYCHTHEMERON": "(Greek) a full period of a day and night [n -S]\n",
  "NYCHTHEMERONS": "NYCHTHEMERON, (Greek) a full period of a day and night [n]\n",
  "NYCTAGINACEOUS": "belonging to the Nyctaginaceae, a family of mainly tropical American plants, including bougainvillea [adj]\n",
  "NYCTALOPE": "(Greek) one afflicted with nyctalopia, the condition of seeing poorly at night or in partial darkness, while the day sight is normal; erroneously, the opposite condition, also NYCTALOPS [n -S]\n",
  "NYCTALOPES": "NYCTALOPS, (Greek) one afflicted with nyctalopia, the condition of seeing poorly at night or in partial darkness, while the day sight is normal; erroneously, the opposite condition [n]\n",
  "NYCTALOPIA": "reduced visual capacity in faint light (as at night), night blindness [n -S]\n",
  "NYCTALOPIAS": "NYCTALOPIA, reduced visual capacity in faint light (as at night), night blindness [n]\n",
  "NYCTALOPIC": "suffering from nyctalopia, night blindness [adj]\n",
  "NYCTALOPS": "(Greek) one afflicted with nyctalopia, the condition of seeing poorly at night or in partial darkness, while the day sight is normal; erroneously, the opposite condition [n NYCTALOPES]\n",
  "NYCTANTHOUS": "flowering at night [adj]\n",
  "NYCTINASTIC": "relating to nyctinasty, sleep-movement in plants [adj]\n",
  "NYCTINASTIES": "NYCTINASTY, sleep-movement in plants, e.g. the closing of petals [n]\n",
  "NYCTINASTY": "sleep-movement in plants, e.g. the closing of petals [n NYCTINASTIES]\n",
  "NYCTITROPIC": "showing nyctitropism [adj]\n",
  "NYCTITROPISM": "the assumption by plants of certain positions at night, esp. ones different from daytime positions [n -S]\n",
  "NYCTITROPISMS": "NYCTITROPISM, the assumption by plants of certain positions at night, esp. ones different from daytime positions [n]\n",
  "NYCTOPHOBIA": "an irrational fear of the night or darkness [n -S]\n",
  "NYCTOPHOBIAS": "NYCTOPHOBIA, an irrational fear of the night or darkness [n]\n",
  "NYCTOPHOBIC": "suffering from nyctophobia, an irrational fear of the night [adj]\n",
  "NYE": "to draw near, approach, also NIE, NIGH, NY [v NYED, NYING, NYES]\n",
  "NYED": "NYE, to draw near, approach, also NIE, NIGH, NY [v]\n",
  "NYES": "NYE, to draw near, approach, also NIE, NIGH, NY [v]\n",
  "NYING": "NYE, to draw near, approach, also NIE, NIGH, NY [v]\n",
  "NYLGHAI": "(Hindi) a large antelope, also NILGAI, NILGAU, NILGHAI, NILGHAU, NYLGHAU [n -S]\n",
  "NYLGHAIS": "NYLGHAI, (Hindi) a large antelope, also NILGAI, NILGAU, NILGHAI, NILGHAU, NYLGHAU [n]\n",
  "NYLGHAU": "(Hindi) a large antelope, also NILGAI, NILGAU, NILGHAI, NILGHAU, NYLGHAI [n -S]\n",
  "NYLGHAUS": "NYLGHAU, (Hindi) a large antelope, also NILGAI, NILGAU, NILGHAI, NILGHAU, NYLGHAI [n]\n",
  "NYLON": "(tradename) a synthetic material; a stocking made from this [n -S]\n",
  "NYLONED": "wearing nylons [adj]\n",
  "NYLONS": "NYLON, (tradename) a synthetic material; a stocking made from this [n]\n",
  "NYM": "as in nym war, a dispute about the right to publish material on the internet under a fictitious name [adj]\n",
  "NYMPH": "to fish using a fly that is shaped like a larva [v -ED, -ING, -S]\n",
  "NYMPHA": "(Latin) a fold of the vulva [n NYMPHAE]\n",
  "NYMPHAE": "NYMPHA, (Latin) a fold of the vulva [n]\n",
  "NYMPHAEA": "any plant of the waterlily genus [n -S]\n",
  "NYMPHAEACEOUS": "belonging to the Nymphaea family, waterlilies [adj]\n",
  "NYMPHAEAS": "NYMPHAEA, any plant of the waterlily genus [n]\n",
  "NYMPHAEUM": "a temple for nymphs [n NYMPHAEUMS or NYMPHAEA]\n",
  "NYMPHAEUMS": "NYMPHAEUM, a temple for nymphs [n]\n",
  "NYMPHAL": "of or pertaining to a nymph or nymphs, also NYMPHEAN [adj]\n",
  "NYMPHALID": "any butterfly of the family Nymphalidae [n -S]\n",
  "NYMPHALIDS": "NYMPHALID, any butterfly of the family Nymphalidae [n]\n",
  "NYMPHEAN": "of or relating to a nymph, also NYMPHAL [adj]\n",
  "NYMPHED": "NYMPH, to fish using a fly that is shaped like a larva [v]\n",
  "NYMPHET": "a sexually desirable pubescent girl, also NYMPHETTE [n -S]\n",
  "NYMPHETIC": "of or like a nymphet [adj]\n",
  "NYMPHETS": "NYMPHET, a sexually desirable pubescent girl, also NYMPHETTE [n]\n",
  "NYMPHETTE": "a sexually desirable pubescent girl, also NYMPHET [n -S]\n",
  "NYMPHETTES": "NYMPHETTE, a sexually desirable pubescent girl, also NYMPHET [n]\n",
  "NYMPHIC": "of or pertaining to nymphs, also NYMPHICAL [adj]\n",
  "NYMPHICAL": "of or pertaining to nymphs, also NYMPHIC [adj]\n",
  "NYMPHING": "NYMPH, to fish using a fly that is shaped like a larva [v]\n",
  "NYMPHISH": "like a nymph [adj]\n",
  "NYMPHLIER": "NYMPHLY, resembling, or characteristic of, a nymph [adj]\n",
  "NYMPHLIEST": "NYMPHLY, resembling, or characteristic of, a nymph [adj]\n",
  "NYMPHLIKE": "like a nymph [adj]\n",
  "NYMPHLY": "resembling, or characteristic of, a nymph [adj NYMPHLIER, NYMPHLIEST]\n",
  "NYMPHO": "(short for) a nymphomaniac, a woman obsessed by sexual desire [n -S]\n",
  "NYMPHOLEPSIES": "NYMPHOLEPSY, a trance incurred by erotic daydreams [n]\n",
  "NYMPHOLEPSY": "a trance incurred by erotic daydreams [n NYMPHOLEPSIES]\n",
  "NYMPHOLEPT": "one in state of nympholepsy, a trance incurred by erotic daydreams [n -S]\n",
  "NYMPHOLEPTIC": "relating to nympholepsy [adj]\n",
  "NYMPHOLEPTS": "NYMPHOLEPT, one in state of nympholepsy, a trance incurred by erotic daydreams [n]\n",
  "NYMPHOMANIA": "sexual mania in females [n -S]\n",
  "NYMPHOMANIAC": "one afflicted with nymphomania [n -S]\n",
  "NYMPHOMANIACAL": "relating to nymphomania [adj]\n",
  "NYMPHOMANIACS": "NYMPHOMANIAC, one afflicted with nymphomania [n]\n",
  "NYMPHOMANIAS": "NYMPHOMANIA, sexual mania in females [n]\n",
  "NYMPHOS": "NYMPHO, (short for) a nymphomaniac, a woman obsessed by sexual desire [n]\n",
  "NYMPHS": "NYMPH, to fish using a fly that is shaped like a larva [v]\n",
  "NYS": "(Spenser) is not [v]\n",
  "NYSSA": "a tree of a genus of small American and Asiatic trees with overlapping petals [n -S]\n",
  "NYSSAS": "NYSSA, a tree of a genus of small American and Asiatic trees with overlapping petals [n]\n",
  "NYSTAGMIC": "relating to nystagmus, involuntary lateral movement of the eyeballs, also NYSTAGMOID [adj]\n",
  "NYSTAGMOID": "relating to nystagmus, an involuntary lateral movement of the eyeballs, also NYSTAGMIC [adj]\n",
  "NYSTAGMUS": "an involuntary lateral movement of the eyeballs [n -ES]\n",
  "NYSTAGMUSES": "NYSTAGMUS, an involuntary lateral movement of the eyeballs [n]\n",
  "NYSTATIN": "an antifungal antibiotic, used in treating monilia and candida [n -S]\n",
  "NYSTATINS": "NYSTATIN, an antifungal antibiotic, used in treating monilia and candida [n]\n",
  "OAF": "a clumsy, stupid person [n OAFS or OAVES]\n",
  "OAFISH": "like an oaf [adj OAFISHLY]\n",
  "OAFISHLY": "OAFISH, like an oaf [adv]\n",
  "OAFISHNESS": "the state of being oafish [n -ES]\n",
  "OAFISHNESSES": "OAFISHNESS, the state of being oafish [n]\n",
  "OAFS": "OAF, a clumsy, stupid person [n]\n",
  "OAK": "a hardwood tree [n -S]\n",
  "OAKED": "(of wine) stored for a time in oak barrels before bottling [adj]\n",
  "OAKEN": "like an oak [adj]\n",
  "OAKENSHAW": "an oak wood [n -S]\n",
  "OAKENSHAWS": "OAKENSHAW, an oak wood [n]\n",
  "OAKER": "(Spenser) ochre, a pigment derived from natural clays [n -S]\n",
  "OAKERS": "OAKER, (Spenser) ochre, a pigment derived from natural clays [n]\n",
  "OAKIER": "OAKY, like an oak [adj]\n",
  "OAKIES": "OAKY, an ice-cream [n]\n",
  "OAKIEST": "OAKY, like an oak [adj]\n",
  "OAKINESS": "the quality or state of being oaky [n -ES]\n",
  "OAKINESSES": "OAKINESS, the quality or state of being oaky [n]\n",
  "OAKLEAF": "the leaf of the oak [n OAKLEAVES]\n",
  "OAKLEAVES": "OAKLEAF, the leaf of the oak [n]\n",
  "OAKLIKE": "like an oak [adj]\n",
  "OAKLING": "a young oak [n -S]\n",
  "OAKLINGS": "OAKLING, a young oak [n]\n",
  "OAKMOSS": "a lichen that grows on oak trees [n -ES]\n",
  "OAKMOSSES": "OAKMOSS, a lichen that grows on oak trees [n]\n",
  "OAKS": "OAK, a hardwood tree [n]\n",
  "OAKUM": "old ropes untwisted for caulking the seams of ships [n -S]\n",
  "OAKUMS": "OAKUM, old ropes untwisted for caulking the seams of ships [n]\n",
  "OAKWOOD": "the wood of the oak [n -S]\n",
  "OAKWOODS": "OAKWOOD, the wood of the oak [n]\n",
  "OAKY": "like an oak [adj OAKIER, OAKIEST] / an ice-cream [n OAKIES]\n",
  "OANSHAGH": "(Irish) a foolish woman or girl [n -S]\n",
  "OANSHAGHS": "OANSHAGH, (Irish) a foolish woman or girl [n]\n",
  "OAR": "to propel a boat with long, broad-bladed poles [v -ED, -ING, -S]\n",
  "OARAGE": "a rowing movement [n -S]\n",
  "OARAGES": "OARAGE, a rowing movement [n]\n",
  "OARED": "OAR, to propel a boat with long, broad-bladed poles [v]\n",
  "OARFISH": "a long slender fish, aka ribbonfish [n -ES]\n",
  "OARFISHES": "OARFISH, a long slender fish, aka ribbonfish [n]\n",
  "OARIER": "OARY, having the form of or using oars [adj]\n",
  "OARIEST": "OARY, having the form of or using oars [adj]\n",
  "OARING": "OAR, to propel a boat with long, broad-bladed poles [v]\n",
  "OARLESS": "without oars [adj]\n",
  "OARLIKE": "like an oar [adj]\n",
  "OARLOCK": "a device for holding an oar in place [n -S]\n",
  "OARLOCKS": "OARLOCK, a device for holding an oar in place [n]\n",
  "OARS": "OAR, to propel a boat with long, broad-bladed poles [v]\n",
  "OARSMAN": "a person who rows a boat [n OARSMEN]\n",
  "OARSMANSHIP": "the craft of rowing with oars [n -S]\n",
  "OARSMANSHIPS": "OARSMANSHIP, the craft of rowing with oars [n]\n",
  "OARSMEN": "OARSMAN, a person who rows a boat [n]\n",
  "OARSWOMAN": "a woman who rows [n OARSWOMEN]\n",
  "OARSWOMEN": "OARSWOMAN, a woman who rows [n]\n",
  "OARWEED": "a kind of seaweed, also OREWEED [n -S]\n",
  "OARWEEDS": "OARWEED, a kind of seaweed, also OREWEED [n]\n",
  "OARY": "having the form of or using oars [adj OARIER, OARIEST]\n",
  "OASES": "OASIS, a green area in a desert region [n]\n",
  "OASIS": "a green area in a desert region [n OASES]\n",
  "OAST": "a kiln for drying hops or malt [n -S]\n",
  "OASTHOUSE": "a house where hops are dried [n -S]\n",
  "OASTHOUSES": "OASTHOUSE, a house where hops are dried [n]\n",
  "OASTS": "OAST, a kiln for drying hops or malt [n]\n",
  "OAT": "a kind of cereal grass [n -S]\n",
  "OATCAKE": "a thin unleavened cake similar to a biscuit, made with oatmeal [n -S]\n",
  "OATCAKES": "OATCAKE, a thin unleavened cake similar to a biscuit, made with oatmeal [n]\n",
  "OATEN": "made of oats or an oat-stem [adj]\n",
  "OATER": "a cowboy movie [n -S]\n",
  "OATERS": "OATER, a cowboy movie [n]\n",
  "OATH": "a formal declaration or promise to fulfill a pledge [n -S]\n",
  "OATHABLE": "(Shakespeare) capable of taking an oath [adj]\n",
  "OATHS": "OATH, a formal declaration or promise to fulfill a pledge [n]\n",
  "OATIER": "OATY, like oats [adj]\n",
  "OATIEST": "OATY, like oats [adj]\n",
  "OATLIKE": "like an oat [adj]\n",
  "OATMEAL": "meal made from oats [n -S]\n",
  "OATMEALS": "OATMEAL, meal made from oats [n]\n",
  "OATS": "OAT, a kind of cereal grass [n]\n",
  "OATY": "like oats [adj OATIER, OATIEST]\n",
  "OAVES": "OAF, a clumsy, stupid person [n]\n",
  "OB": "(short for) an objection [n -S]\n",
  "OBA": "a West African ruler [n -S]\n",
  "OBANG": "(Japanese) an obsolete Japanese gold coin, also KOBAN, KOBANG [n -S]\n",
  "OBANGS": "OBANG, (Japanese) an obsolete Japanese gold coin, also KOBAN, KOBANG [n]\n",
  "OBAS": "OBA, a West African ruler [n]\n",
  "OBBLIGATI": "OBBLIGATO, (Italian) a musical accompaniment of independent importance, esp. that of a single instrument to a vocal piece, also OBLIGATO [n]\n",
  "OBBLIGATO": "(Italian) a musical accompaniment of independent importance, esp. that of a single instrument to a vocal piece, also OBLIGATO [n OBBLIGATI or OBBLIGATOS]\n",
  "OBBLIGATOS": "OBBLIGATO, (Italian) a musical accompaniment of independent importance, esp. that of a single instrument to a vocal piece, also OBLIGATO [n]\n",
  "OBCOMPRESSED": "flattened from front to back [adj]\n",
  "OBCONIC": "conical with the apex below [adj]\n",
  "OBCONICAL": "conical, but having the apex downward; inversely conical, also OBCONIC [adj]\n",
  "OBCORDATE": "of e.g. a leaf, inversely heart-shaped and attached by the point [adj]\n",
  "OBDURACIES": "OBDURACY, the quality of hardness of heart [n]\n",
  "OBDURACY": "the quality of hardness of heart [n OBDURACIES]\n",
  "OBDURATE": "stubbornly persistent in wrongdoing [adj OBDURATELY] / to make obdurate, harden physically [v OBDURATED, OBDURATING, OBDURATES]\n",
  "OBDURATED": "OBDURATE, to make obdurate, harden physically [v]\n",
  "OBDURATELY": "OBDURATE, stubbornly persistent in wrongdoing [adv]\n",
  "OBDURATENESS": "the state of being obdurate [n -ES]\n",
  "OBDURATENESSES": "OBDURATENESS, the state of being obdurate [n]\n",
  "OBDURATES": "OBDURATE, to make obdurate, harden physically [v]\n",
  "OBDURATING": "OBDURATE, to make obdurate, harden physically [v]\n",
  "OBDURATION": "a hardening of the heart [n -S]\n",
  "OBDURATIONS": "OBDURATION, a hardening of the heart [n]\n",
  "OBDURE": "to harden, also OBDURATE [v OBDURED, OBDURING, OBDURES]\n",
  "OBDURED": "OBDURE, to harden, also OBDURATE [v]\n",
  "OBDURES": "OBDURE, to harden, also OBDURATE [v]\n",
  "OBDURING": "OBDURE, to harden, also OBDURATE [v]\n",
  "OBE": "a form of West Indian witchcraft, also OBEAH, OBI, OBIA [n -S]\n",
  "OBEAH": "a form of West Indian witchcraft, also OBE, OBI, OBIA [n -S] / to bewitch [v -ED, -ING, -S]\n",
  "OBEAHED": "OBEAH, to bewitch [v]\n",
  "OBEAHING": "OBEAH, to bewitch [v]\n",
  "OBEAHISM": "belief in obia, also OBEISM, OBIISM [n -S]\n",
  "OBEAHISMS": "OBEAHISM, belief in obia, also OBEISM, OBIISM [n]\n",
  "OBEAHS": "OBEAH, to bewitch [v]\n",
  "OBECHE": "a large West African tree or its whitish wood [n -S]\n",
  "OBECHES": "OBECHE, a large West African tree or its whitish wood [n]\n",
  "OBEDIENCE": "the act or practice of doing what one is told [n -S]\n",
  "OBEDIENCES": "OBEDIENCE, the act or practice of doing what one is told [n]\n",
  "OBEDIENT": "obeying or willing to obey [adj OBEDIENTLY]\n",
  "OBEDIENTIAL": "relating to or of the nature of obedience [adj]\n",
  "OBEDIENTIARIES": "OBEDIENTIARY, someone subject to obedience [n]\n",
  "OBEDIENTIARY": "someone subject to obedience [n OBEDIENTIARIES]\n",
  "OBEDIENTLY": "OBEDIENT, obeying or willing to obey [adv]\n",
  "OBEISANCE": "a bow or curtsey, a paying of homage [n -S]\n",
  "OBEISANCES": "OBEISANCE, a bow or curtsey, a paying of homage [n]\n",
  "OBEISANT": "showing respect [adj OBEISANTLY]\n",
  "OBEISANTLY": "OBEISANT, showing respect [adv]\n",
  "OBEISM": "a form of West Indian witchcraft, also OBEAHISM, OBIISM [n -S]\n",
  "OBEISMS": "OBEISM, a form of West Indian witchcraft, also OBEAHISM, OBIISM [n]\n",
  "OBELI": "OBELUS, (Latin) a symbol used in ancient manuscripts [n]\n",
  "OBELIA": "any of a genus of small marine colonial hydroids [n -S]\n",
  "OBELIAS": "OBELIA, any of a genus of small marine colonial hydroids [n]\n",
  "OBELION": "a part of the skull [n OBELIA]\n",
  "OBELISCAL": "formed like an obelisk [adj]\n",
  "OBELISCOID": "shaped like an obelisk, also OBELISKOID [adj]\n",
  "OBELISE": "to mark with an obelus, also OBELIZE [v OBELISED, OBELISING, OBELISES]\n",
  "OBELISED": "OBELISE, to mark with an obelus, also OBELIZE [v]\n",
  "OBELISES": "OBELISE, to mark with an obelus, also OBELIZE [v]\n",
  "OBELISING": "OBELISE, to mark with an obelus, also OBELIZE [v]\n",
  "OBELISK": "a four-sided shaft of stone with a pyramidal top [n -S]\n",
  "OBELISKOID": "shaped like an obelisk, also OBELISCOID [adj]\n",
  "OBELISKS": "OBELISK, a four-sided shaft of stone with a pyramidal top [n]\n",
  "OBELISM": "the act of obelizing [n -S]\n",
  "OBELISMS": "OBELISM, the act of obelizing [n]\n",
  "OBELIZE": "to mark with an obelus, also OBELISE [v OBELIZED, OBELIZING, OBELIZES]\n",
  "OBELIZED": "OBELIZE, to mark with an obelus, also OBELISE [v]\n",
  "OBELIZES": "OBELIZE, to mark with an obelus, also OBELISE [v]\n",
  "OBELIZING": "OBELIZE, to mark with an obelus, also OBELISE [v]\n",
  "OBELUS": "(Latin) a symbol used in ancient manuscripts [n OBELI]\n",
  "OBENTO": "(Japanese) a thin lightweight compartmented box containing a meal, also BENTO [n -S]\n",
  "OBENTOS": "OBENTO, (Japanese) a thin lightweight compartmented box containing a meal, also BENTO [n]\n",
  "OBES": "OBE, a form of West Indian witchcraft, also OBEAH, OBI, OBIA [n]\n",
  "OBESE": "very fat [adj OBESER, OBESEST, OBESELY]\n",
  "OBESELY": "OBESE, very fat [adv]\n",
  "OBESENESS": "the state of being obese [n -ES]\n",
  "OBESENESSES": "OBESENESS, the state of being obese [n]\n",
  "OBESER": "OBESE, very fat [adj]\n",
  "OBESEST": "OBESE, very fat [adj]\n",
  "OBESITIES": "OBESITY, the condition of being obese [n]\n",
  "OBESITY": "the condition of being obese [n OBESITIES]\n",
  "OBESOGEN": "a substance that causes abnormal weight gain [n -S]\n",
  "OBESOGENIC": "causing obesity [adj]\n",
  "OBESOGENS": "OBESOGEN, a substance that causes abnormal weight gain [n]\n",
  "OBEY": "to do as one is told [v -ED, -ING, -S]\n",
  "OBEYABLE": "able to be obeyed [adj]\n",
  "OBEYED": "OBEY, to do as one is told [v]\n",
  "OBEYER": "one who obeys [n -S]\n",
  "OBEYERS": "OBEYER, one who obeys [n]\n",
  "OBEYING": "OBEY, to do as one is told [v]\n",
  "OBEYS": "OBEY, to do as one is told [v]\n",
  "OBFUSCATE": "to darken, make obscure, confuse [v OBFUSCATED, OBFUSCATING, OBFUSCATES]\n",
  "OBFUSCATED": "OBFUSCATE, to darken, make obscure, confuse [v]\n",
  "OBFUSCATES": "OBFUSCATE, to darken, make obscure, confuse [v]\n",
  "OBFUSCATING": "OBFUSCATE, to darken, make obscure, confuse [v]\n",
  "OBFUSCATION": "the act of obfuscating [n -S]\n",
  "OBFUSCATIONS": "OBFUSCATION, the act of obfuscating [n]\n",
  "OBFUSCATORY": "serving to obfuscate [adj]\n",
  "OBI": "a form of West Indian witchcraft, also OBE, OBEAH, OBIA [n -S] / to bewitch [v -ED, -ING, -S]\n",
  "OBIA": "a form of West Indian witchcraft, also OBE, OBEAH, OBI [n -S]\n",
  "OBIAS": "OBIA, a form of West Indian witchcraft, also OBE, OBEAH, OBI [n]\n",
  "OBIED": "OBI, to bewitch [v]\n",
  "OBIING": "OBI, to bewitch [v]\n",
  "OBIISM": "a form of West Indian witchcraft, also OBEAHISM, OBEISM [n -S]\n",
  "OBIISMS": "OBIISM, a form of West Indian witchcraft, also OBEAHISM, OBEISM [n]\n",
  "OBIIT": "(Latin) he/she died [v]\n",
  "OBIS": "OBI, to bewitch [v]\n",
  "OBIT": "(Latin) a religious office for a dead person [n -S]\n",
  "OBITAL": "relating to an obit, a religious office for a dead person, also OBITUAL [adj]\n",
  "OBITER": "(Latin) in passing; incidentally; by the way [adv]\n",
  "OBITS": "OBIT, (Latin) a religious office for a dead person [n]\n",
  "OBITUAL": "relating to an obit, a religious office for a dead person, also OBITAL [adj]\n",
  "OBITUARIES": "OBITUARY, a published notice of death [n]\n",
  "OBITUARIST": "one who writes obituaries [n -S]\n",
  "OBITUARISTS": "OBITUARIST, one who writes obituaries [n]\n",
  "OBITUARY": "a published notice of death [n OBITUARIES]\n",
  "OBJECT": "to argue in opposition [v -ED, -ING, -S]\n",
  "OBJECTED": "OBJECT, to argue in opposition [v]\n",
  "OBJECTIFICATION": "the act of objectifying [n]\n",
  "OBJECTIFIED": "OBJECTIFY, to make objective [v]\n",
  "OBJECTIFIES": "OBJECTIFY, to make objective [v]\n",
  "OBJECTIFY": "to make objective [v OBJECTIFIED, OBJECTIFYING, OBJECTIFIES]\n",
  "OBJECTIFYING": "OBJECTIFY, to make objective [v]\n",
  "OBJECTING": "OBJECT, to argue in opposition [v]\n",
  "OBJECTION": "the act of objecting; anything said or done in opposition [n -S]\n",
  "OBJECTIONABLE": "undesirable, offensive [adj OBJECTIONABLY]\n",
  "OBJECTIONABLY": "OBJECTIONABLE, undesirable, offensive [adv]\n",
  "OBJECTIONS": "OBJECTION, the act of objecting; anything said or done in opposition [n]\n",
  "OBJECTIVAL": "relating to an objective [adj]\n",
  "OBJECTIVATE": "to render objective [v OBJECTIVATED, OBJECTIVATING, OBJECTIVATES]\n",
  "OBJECTIVATED": "OBJECTIVATE, to render objective [v]\n",
  "OBJECTIVATES": "OBJECTIVATE, to render objective [v]\n",
  "OBJECTIVATING": "OBJECTIVATE, to render objective [v]\n",
  "OBJECTIVATION": "the act of rendering objective [n -S]\n",
  "OBJECTIVATIONS": "OBJECTIVATION, the act of rendering objective [n]\n",
  "OBJECTIVE": "relating to or constituting an object [adj OBJECTIVELY] / a goal or aim [n -S]\n",
  "OBJECTIVELY": "OBJECTIVE, relating to or constituting an object [adv]\n",
  "OBJECTIVENESS": "the state of being objective [n -ES]\n",
  "OBJECTIVENESSES": "OBJECTIVENESS, the state of being objective [n]\n",
  "OBJECTIVES": "OBJECTIVE, a goal or aim [n]\n",
  "OBJECTIVISE": "to make objective, also OBJECTIVIZE [v OBJECTIVISED, OBJECTIVISING, OBJECTIVISES]\n",
  "OBJECTIVISED": "OBJECTIVISE, to make objective, also OBJECTIVIZE [v]\n",
  "OBJECTIVISES": "OBJECTIVISE, to make objective, also OBJECTIVIZE [v]\n",
  "OBJECTIVISING": "OBJECTIVISE, to make objective, also OBJECTIVIZE [v]\n",
  "OBJECTIVISM": "the doctrine that reality is real [n -S]\n",
  "OBJECTIVISMS": "OBJECTIVISM, the doctrine that reality is real [n]\n",
  "OBJECTIVIST": "a believer in objectivism, the doctrine that reality is real [n -S]\n",
  "OBJECTIVISTIC": "relating to objectivism [adj]\n",
  "OBJECTIVISTS": "OBJECTIVIST, a believer in objectivism, the doctrine that reality is real [n]\n",
  "OBJECTIVITIES": "OBJECTIVITY, the state of being objective [n]\n",
  "OBJECTIVITY": "the state of being objective [n OBJECTIVITIES]\n",
  "OBJECTIVIZE": "to make objective, also OBJECTIVISE [v OBJECTIVIZED, OBJECTIVIZING, OBJECTIVIZES]\n",
  "OBJECTIVIZED": "OBJECTIVIZE, to make objective, also OBJECTIVISE [v]\n",
  "OBJECTIVIZES": "OBJECTIVIZE, to make objective, also OBJECTIVISE [v]\n",
  "OBJECTIVIZING": "OBJECTIVIZE, to make objective, also OBJECTIVISE [v]\n",
  "OBJECTLESS": "having no object; purposeless [adj]\n",
  "OBJECTLESSNESS": "OBJECTLESS, having no object; purposeless [n]\n",
  "OBJECTOR": "one that objects [n -S]\n",
  "OBJECTORS": "OBJECTOR, one that objects [n]\n",
  "OBJECTS": "OBJECT, to argue in opposition [v]\n",
  "OBJET": "(French) an object [n -S]\n",
  "OBJETS": "OBJET, (French) an object [n]\n",
  "OBJURATION": "the act of binding by oath; a solemn charge [n -S]\n",
  "OBJURATIONS": "OBJURATION, the act of binding by oath; a solemn charge [n]\n",
  "OBJURE": "to bind by oath; to entreat solemnly [v OBJURED, OBJURING, OBJURES]\n",
  "OBJURED": "OBJURE, to bind by oath; to entreat solemnly [v]\n",
  "OBJURES": "OBJURE, to bind by oath; to entreat solemnly [v]\n",
  "OBJURGATE": "to scold or rebuke sharply, to berate [v OBJURGATED, OBJURGATING, OBJURGATES]\n",
  "OBJURGATED": "OBJURGATE, to scold or rebuke sharply, to berate [v]\n",
  "OBJURGATES": "OBJURGATE, to scold or rebuke sharply, to berate [v]\n",
  "OBJURGATING": "OBJURGATE, to scold or rebuke sharply, to berate [v]\n",
  "OBJURGATION": "a rebuke, a scolding [n -S]\n",
  "OBJURGATIONS": "OBJURGATION, a rebuke, a scolding [n]\n",
  "OBJURGATIVE": "chiding, scolding, also OBJURGATORY [adj]\n",
  "OBJURGATOR": "one who objurgates [n -S]\n",
  "OBJURGATORS": "OBJURGATOR, one who objurgates [n]\n",
  "OBJURGATORY": "chiding, scolding, also OBJURGATIVE [adj]\n",
  "OBJURING": "OBJURE, to bind by oath; to entreat solemnly [v]\n",
  "OBLANCEOLATE": "of e.g. a leaf, like a lance-head reversed [adj]\n",
  "OBLAST": "(Russian) a political subdivision of a republic in the former USSR [n OBLASTS or OBLASTI]\n",
  "OBLASTI": "OBLAST, (Russian) a political subdivision of a republic in the former USSR [n]\n",
  "OBLASTS": "OBLAST, (Russian) a political subdivision of a republic in the former USSR [n]\n",
  "OBLATE": "flattened at the poles [adj OBLATELY] / (obsolete) a person dedicated to monastic or religious life or work [n -S]\n",
  "OBLATELY": "OBLATE, flattened at the poles [adv]\n",
  "OBLATENESS": "the state of being oblate [n -ES]\n",
  "OBLATENESSES": "OBLATENESS, the state of being oblate [n]\n",
  "OBLATES": "OBLATE, (obsolete) a person dedicated to monastic or religious life or work [n]\n",
  "OBLATION": "the act of making a religious offering [n -S]\n",
  "OBLATIONAL": "relating to oblation, the act of offering [adj]\n",
  "OBLATIONS": "OBLATION, the act of making a religious offering [n]\n",
  "OBLATORY": "relating to oblation [adj]\n",
  "OBLIGABLE": "that can be obligated [adj]\n",
  "OBLIGANT": "in Scots law, one who binds himself or herself to another to pay or perform something [n -S]\n",
  "OBLIGANTS": "OBLIGANT, in Scots law, one who binds himself or herself to another to pay or perform something [n]\n",
  "OBLIGATE": "obliged [adj OBLIGATELY] / to bind morally or legally [v OBLIGATED, OBLIGATING, OBLIGATES]\n",
  "OBLIGATED": "OBLIGATE, to bind morally or legally [v]\n",
  "OBLIGATELY": "OBLIGATE, obliged [adv]\n",
  "OBLIGATES": "OBLIGATE, to bind morally or legally [v]\n",
  "OBLIGATI": "OBLIGATO, (Italian) a musical accompaniment of independent importance, esp. that of a single instrument to a vocal piece, also OBBLIGATO [n]\n",
  "OBLIGATING": "OBLIGATE, to bind morally or legally [v]\n",
  "OBLIGATION": "the act of obliging [n -S]\n",
  "OBLIGATIONAL": "relating to an obligation [adj]\n",
  "OBLIGATIONS": "OBLIGATION, the act of obliging [n]\n",
  "OBLIGATIVE": "causing obligation [adj]\n",
  "OBLIGATO": "(Italian) a musical accompaniment of independent importance, esp. that of a single instrument to a vocal piece, also OBBLIGATO [n OBLIGATI or OBLIGATOS]\n",
  "OBLIGATOR": "one who obligates [n -S]\n",
  "OBLIGATORILY": "OBLIGATORY, binding in law or conscience [adv]\n",
  "OBLIGATORINESS": "the state of being obligatory [n]\n",
  "OBLIGATORS": "OBLIGATOR, one who obligates [n]\n",
  "OBLIGATORY": "binding in law or conscience [adj OBLIGATORILY]\n",
  "OBLIGATOS": "OBLIGATO, (Italian) a musical accompaniment of independent importance, esp. that of a single instrument to a vocal piece, also OBBLIGATO [n]\n",
  "OBLIGE": "to bind by some favour rendered, also OBLIGATE [v OBLIGED, OBLIGING, OBLIGES]\n",
  "OBLIGED": "OBLIGE, to bind by some favour rendered, also OBLIGATE [v]\n",
  "OBLIGEE": "one who is obliged [n -S]\n",
  "OBLIGEES": "OBLIGEE, one who is obliged [n]\n",
  "OBLIGEMENT": "(Scots) a helpful action, a favour [n -S]\n",
  "OBLIGEMENTS": "OBLIGEMENT, (Scots) a helpful action, a favour [n]\n",
  "OBLIGER": "one who obliges, also OBLIGOR [n -S]\n",
  "OBLIGERS": "OBLIGER, one who obliges, also OBLIGOR [n]\n",
  "OBLIGES": "OBLIGE, to bind by some favour rendered, also OBLIGATE [v]\n",
  "OBLIGING": "OBLIGE, to bind by some favour rendered, also OBLIGATE [v]\n",
  "OBLIGINGLY": "OBLIGING, OBLIGE, to bind by some favour rendered, also OBLIGATE [adv]\n",
  "OBLIGINGNESS": "the state of being obliging [n -ES]\n",
  "OBLIGINGNESSES": "OBLIGINGNESS, the state of being obliging [n]\n",
  "OBLIGOR": "the person who binds himself, or gives his bond to another, also OBLIGER [n -S]\n",
  "OBLIGORS": "OBLIGOR, the person who binds himself, or gives his bond to another, also OBLIGER [n]\n",
  "OBLIQUATION": "(obsolete) obliqueness [n -S]\n",
  "OBLIQUATIONS": "OBLIQUATION, (obsolete) obliqueness [n]\n",
  "OBLIQUE": "slanting [adj OBLIQUER, OBLIQUEST, OBLIQUELY] / (obsolete) to deviate from a direct line [v OBLIQUED, OBLIQUING, OBLIQUES]\n",
  "OBLIQUED": "OBLIQUE, (obsolete) to deviate from a direct line [v]\n",
  "OBLIQUELY": "OBLIQUE, slanting [adv]\n",
  "OBLIQUENESS": "the state of being oblique [n -ES]\n",
  "OBLIQUENESSES": "OBLIQUENESS, the state of being oblique [n]\n",
  "OBLIQUER": "OBLIQUE, slanting [adj]\n",
  "OBLIQUES": "OBLIQUE, (obsolete) to deviate from a direct line [v]\n",
  "OBLIQUEST": "OBLIQUE, slanting [adj]\n",
  "OBLIQUID": "(Spenser) oblique [adj]\n",
  "OBLIQUING": "OBLIQUE, (obsolete) to deviate from a direct line [v]\n",
  "OBLIQUITIES": "OBLIQUITY, the state of being oblique [n]\n",
  "OBLIQUITOUS": "relating to obliquity [adj]\n",
  "OBLIQUITY": "the state of being oblique [n OBLIQUITIES]\n",
  "OBLITERATE": "to erase or blot out [v OBLITERATED, OBLITERATING, OBLITERATES]\n",
  "OBLITERATED": "OBLITERATE, to erase or blot out [v]\n",
  "OBLITERATES": "OBLITERATE, to erase or blot out [v]\n",
  "OBLITERATING": "OBLITERATE, to erase or blot out [v]\n",
  "OBLITERATION": "the act of obliterating [n -S]\n",
  "OBLITERATIONS": "OBLITERATION, the act of obliterating [n]\n",
  "OBLITERATIVE": "inducing or characterized by obliteration [adj]\n",
  "OBLITERATOR": "one who obliterates [n -S]\n",
  "OBLITERATORS": "OBLITERATOR, one who obliterates [n]\n",
  "OBLIVION": "a state of having forgotten [n -S]\n",
  "OBLIVIONS": "OBLIVION, a state of having forgotten [n]\n",
  "OBLIVIOUS": "forgetful [adj OBLIVIOUSLY]\n",
  "OBLIVIOUSLY": "OBLIVIOUS, forgetful [adv]\n",
  "OBLIVIOUSNESS": "OBLIVIOUS, forgetful [n]\n",
  "OBLIVIOUSNESSES": "OBLIVIOUSNESS, OBLIVIOUS, forgetful [n]\n",
  "OBLIVISCENCE": "forgetfulness [n -S]\n",
  "OBLIVISCENCES": "OBLIVISCENCE, forgetfulness [n]\n",
  "OBLONG": "long in one direction [adj OBLONGLY] / something that is oblong [n -S]\n",
  "OBLONGLY": "OBLONG, long in one direction [adv]\n",
  "OBLONGS": "OBLONG, something that is oblong [n]\n",
  "OBLOQUIAL": "relating to obloquy [adj]\n",
  "OBLOQUIES": "OBLOQUY, abusive language [n]\n",
  "OBLOQUY": "abusive language [n OBLOQUIES]\n",
  "OBMUTESCENCE": "the act of becoming or keeping silent or mute [n -S]\n",
  "OBMUTESCENCES": "OBMUTESCENCE, the act of becoming or keeping silent or mute [n]\n",
  "OBMUTESCENT": "speechless; persistently silent [adj]\n",
  "OBNOXIOUS": "unpleasant [adj OBNOXIOUSLY]\n",
  "OBNOXIOUSLY": "OBNOXIOUS, unpleasant [adv]\n",
  "OBNOXIOUSNESS": "the state of being obnoxious [n -ES]\n",
  "OBNOXIOUSNESSES": "OBNOXIOUSNESS, the state of being obnoxious [n]\n",
  "OBNUBILATE": "(obsolete) to darken, cloud over [v OBNUBILATED, OBNUBILATING, OBNUBILATES]\n",
  "OBNUBILATED": "OBNUBILATE, (obsolete) to darken, cloud over [v]\n",
  "OBNUBILATES": "OBNUBILATE, (obsolete) to darken, cloud over [v]\n",
  "OBNUBILATING": "OBNUBILATE, (obsolete) to darken, cloud over [v]\n",
  "OBNUBILATION": "beclouding or obscuring [n -S]\n",
  "OBNUBILATIONS": "OBNUBILATION, beclouding or obscuring [n]\n",
  "OBO": "a vessel for carrying oil and bulk ore [n -S]\n",
  "OBOE": "a kind of woodwind instrument [n -S]\n",
  "OBOES": "OBOE, a kind of woodwind instrument [n]\n",
  "OBOIST": "one who plays the oboe [n -S]\n",
  "OBOISTS": "OBOIST, one who plays the oboe [n]\n",
  "OBOL": "(Greek) an ancient Greek coin, also OBOLUS [n -S]\n",
  "OBOLARY": "extremely poor [adj]\n",
  "OBOLE": "(French) a medieval French coin [n -S]\n",
  "OBOLES": "OBOLE, (French) a medieval French coin [n]\n",
  "OBOLI": "OBOLUS, (Latin) in the Middle Ages, various small coins including a halfpenny, also OBOL [n]\n",
  "OBOLS": "OBOL, (Greek) an ancient Greek coin, also OBOLUS [n]\n",
  "OBOLUS": "(Latin) in the Middle Ages, various small coins including a halfpenny, also OBOL [n OBOLI]\n",
  "OBOS": "OBO, a vessel for carrying oil and bulk ore [n]\n",
  "OBOVATE": "of a leaf, egg-shaped in outline, with the narrow end next to the base [adj OBOVATELY]\n",
  "OBOVATELY": "OBOVATE, of a leaf, egg-shaped in outline, with the narrow end next to the base [adv]\n",
  "OBOVOID": "ovoid with the narrow end at the base [adj]\n",
  "OBREPTION": "(obsolete) an attempt to obtain ecclesiastical dispensation, etc. fraudulently [n -S]\n",
  "OBREPTIONS": "OBREPTION, (obsolete) an attempt to obtain ecclesiastical dispensation, etc. fraudulently [n]\n",
  "OBREPTITIOUS": "done or obtained by trickery, or by concealing the truth [adj]\n",
  "OBS": "OB, (short for) an objection [n]\n",
  "OBSCENE": "offensive, disgusting [adj OBSCENER, OBSCENEST, OBSCENELY]\n",
  "OBSCENELY": "OBSCENE, offensive, disgusting [adv]\n",
  "OBSCENENESS": "the state of being obscene [n -ES]\n",
  "OBSCENENESSES": "OBSCENENESS, the state of being obscene [n]\n",
  "OBSCENER": "OBSCENE, offensive, disgusting [adj]\n",
  "OBSCENEST": "OBSCENE, offensive, disgusting [adj]\n",
  "OBSCENITIES": "OBSCENITY, something offensive, unclean [n]\n",
  "OBSCENITY": "something offensive, unclean [n OBSCENITIES]\n",
  "OBSCURANT": "one who obscures; one who prevents enlightenment or hinders the progress of knowledge and wisdom [n -S]\n",
  "OBSCURANTIC": "deliberately obscure [adj]\n",
  "OBSCURANTISM": "opposition to the spread of knowledge; deliberate vagueness or abstruseness [n -S]\n",
  "OBSCURANTISMS": "OBSCURANTISM, opposition to the spread of knowledge; deliberate vagueness or abstruseness [n]\n",
  "OBSCURANTIST": "one who employs deliberate obscurity [n -S]\n",
  "OBSCURANTISTS": "OBSCURANTIST, one who employs deliberate obscurity [n]\n",
  "OBSCURANTS": "OBSCURANT, one who obscures; one who prevents enlightenment or hinders the progress of knowledge and wisdom [n]\n",
  "OBSCURATION": "the act of obscuring [n -S]\n",
  "OBSCURATIONS": "OBSCURATION, the act of obscuring [n]\n",
  "OBSCURE": "indistinct [adj OBSCURER, OBSCUREST, OBSCURELY] / to make indistinct [v OBSCURED, OBSCURING, OBSCURES]\n",
  "OBSCURED": "OBSCURE, to make indistinct [v]\n",
  "OBSCURELY": "OBSCURE, indistinct [adv]\n",
  "OBSCUREMENT": "the act of obscuring [n -S]\n",
  "OBSCUREMENTS": "OBSCUREMENT, the act of obscuring [n]\n",
  "OBSCURENESS": "the state of being obscure [n -ES]\n",
  "OBSCURENESSES": "OBSCURENESS, the state of being obscure [n]\n",
  "OBSCURER": "one who obscures [n -S]\n",
  "OBSCURERS": "OBSCURER, one who obscures [n]\n",
  "OBSCURES": "OBSCURE, to make indistinct [v]\n",
  "OBSCUREST": "OBSCURE, indistinct [adj]\n",
  "OBSCURING": "OBSCURE, to make indistinct [v]\n",
  "OBSCURITIES": "OBSCURITY, the state of being obscure [n]\n",
  "OBSCURITY": "the state of being obscure [n OBSCURITIES]\n",
  "OBSECRATE": "to beseech, supplicate or beg [v OBSECRATED, OBSECRATING, OBSECRATES]\n",
  "OBSECRATED": "OBSECRATE, to beseech, supplicate or beg [v]\n",
  "OBSECRATES": "OBSECRATE, to beseech, supplicate or beg [v]\n",
  "OBSECRATING": "OBSECRATE, to beseech, supplicate or beg [v]\n",
  "OBSECRATION": "an entreaty [n -S]\n",
  "OBSECRATIONS": "OBSECRATION, an entreaty [n]\n",
  "OBSEQUENT": "of a river, flowing in a contrary direction to the original slope of the land, parallel to the consequent and perpendicular to the subsequent streams [adj]\n",
  "OBSEQUIAL": "(Shakespeare) relating to obsequies, funerals [adj]\n",
  "OBSEQUIE": "(Milton) an obsequy, a funeral rite [n -S]\n",
  "OBSEQUIES": "OBSEQUIE, (Milton) an obsequy, a funeral rite [n]\n",
  "OBSEQUIOUS": "servilely ingratiating; fawning [adj OBSEQUIOUSLY]\n",
  "OBSEQUIOUSLY": "OBSEQUIOUS, servilely ingratiating; fawning [adv]\n",
  "OBSEQUIOUSNESS": "the state of being obsequious [n]\n",
  "OBSEQUY": "a funeral rite, also OBSEQUIE [n OBSEQUIES]\n",
  "OBSERVABILITIES": "OBSERVABILITY, the state of being observable [n]\n",
  "OBSERVABILITY": "the state of being observable [n OBSERVABILITIES]\n",
  "OBSERVABLE": "that can be observed [adj OBSERVABLY] / something that can be observed [n -S]\n",
  "OBSERVABLENESS": "the state of being observable [n]\n",
  "OBSERVABLES": "OBSERVABLE, something that can be observed [n]\n",
  "OBSERVABLY": "OBSERVABLE, that can be observed [adv]\n",
  "OBSERVANCE": "the keeping of a customary practice, rite, or ceremony, also OBSERVANCY [n -S]\n",
  "OBSERVANCES": "OBSERVANCE, the keeping of a customary practice, rite, or ceremony, also OBSERVANCY [n]\n",
  "OBSERVANCIES": "OBSERVANCY, the keeping of a customary practice, rite, or ceremony, also OBSERVANCE [n]\n",
  "OBSERVANCY": "the keeping of a customary practice, rite, or ceremony, also OBSERVANCE [n OBSERVANCIES]\n",
  "OBSERVANT": "carefully attentive [adj OBSERVANTLY] / a person who observes a law, custom etc. [n -S]\n",
  "OBSERVANTLY": "OBSERVANT, carefully attentive [adv]\n",
  "OBSERVANTS": "OBSERVANT, a person who observes a law, custom etc. [n]\n",
  "OBSERVATION": "an act or instance of observing a custom, rule, or law [n -S]\n",
  "OBSERVATIONAL": "related to observation [adj OBSERVATIONALLY]\n",
  "OBSERVATIONALLY": "OBSERVATIONAL, related to observation [adv]\n",
  "OBSERVATIONS": "OBSERVATION, an act or instance of observing a custom, rule, or law [n]\n",
  "OBSERVATIVE": "observant, observational [adj]\n",
  "OBSERVATOR": "one who observes or takes notice [n -S]\n",
  "OBSERVATORIES": "OBSERVATORY, a building or place given over to or equipped for observation of natural phenomena (as in astronomy) [n]\n",
  "OBSERVATORS": "OBSERVATOR, one who observes or takes notice [n]\n",
  "OBSERVATORY": "a building or place given over to or equipped for observation of natural phenomena (as in astronomy) [n OBSERVATORIES]\n",
  "OBSERVE": "to look attentively [v OBSERVED, OBSERVING, OBSERVES]\n",
  "OBSERVED": "OBSERVE, to look attentively [v]\n",
  "OBSERVER": "one that observes [n -S]\n",
  "OBSERVERS": "OBSERVER, one that observes [n]\n",
  "OBSERVES": "OBSERVE, to look attentively [v]\n",
  "OBSERVING": "OBSERVE, to look attentively [v]\n",
  "OBSERVINGLY": "OBSERVING, OBSERVE, to look attentively [adv]\n",
  "OBSESS": "to dominate the thoughts of [v -ED, -ING, -ES]\n",
  "OBSESSED": "OBSESS, to dominate the thoughts of [v]\n",
  "OBSESSES": "OBSESS, to dominate the thoughts of [v]\n",
  "OBSESSING": "OBSESS, to dominate the thoughts of [v]\n",
  "OBSESSION": "the morbid persistence of an idea in the mind [n -S]\n",
  "OBSESSIONAL": "relating to obsession [adj OBSESSIONALLY]\n",
  "OBSESSIONALLY": "OBSESSIONAL, relating to obsession [adv]\n",
  "OBSESSIONIST": "someone who is obsessed by a fixed idea [n -S]\n",
  "OBSESSIONISTS": "OBSESSIONIST, someone who is obsessed by a fixed idea [n]\n",
  "OBSESSIONS": "OBSESSION, the morbid persistence of an idea in the mind [n]\n",
  "OBSESSIVE": "subject to obsession [adj OBSESSIVELY] / someone affected or characterized by obsessive behaviour [n -S]\n",
  "OBSESSIVELY": "OBSESSIVE, subject to obsession [adv]\n",
  "OBSESSIVENESS": "OBSESSIVE, subject to obsession [n]\n",
  "OBSESSIVENESSES": "OBSESSIVENESS, OBSESSIVE, subject to obsession [n]\n",
  "OBSESSIVES": "OBSESSIVE, someone affected or characterized by obsessive behaviour [n]\n",
  "OBSESSOR": "something that obsesses [n -S]\n",
  "OBSESSORS": "OBSESSOR, something that obsesses [n]\n",
  "OBSIDIAN": "a dark-coloured vitreous lava or volcanic rock [n -S]\n",
  "OBSIDIANS": "OBSIDIAN, a dark-coloured vitreous lava or volcanic rock [n]\n",
  "OBSIDIONAL": "of or relating to a siege, also OBSIDIONARY [adj]\n",
  "OBSIDIONARY": "of or relating to a siege, also OBSIDIONAL [adj]\n",
  "OBSIGN": "to seal or confirm, also OBSIGNATE [v -ED, -ING, -S]\n",
  "OBSIGNATE": "to seal or confirm, also OBSIGN [v OBSIGNATED, OBSIGNATING, OBSIGNATES]\n",
  "OBSIGNATED": "OBSIGNATE, to seal or confirm, also OBSIGN [v]\n",
  "OBSIGNATES": "OBSIGNATE, to seal or confirm, also OBSIGN [v]\n",
  "OBSIGNATING": "OBSIGNATE, to seal or confirm, also OBSIGN [v]\n",
  "OBSIGNATION": "the act of obsigning [n -S]\n",
  "OBSIGNATIONS": "OBSIGNATION, the act of obsigning [n]\n",
  "OBSIGNATORY": "relating to obsignation [adj]\n",
  "OBSIGNED": "OBSIGN, to seal or confirm, also OBSIGNATE [v]\n",
  "OBSIGNING": "OBSIGN, to seal or confirm, also OBSIGNATE [v]\n",
  "OBSIGNS": "OBSIGN, to seal or confirm, also OBSIGNATE [v]\n",
  "OBSOLESCE": "to grow obsolescent [v OBSOLESCED, OBSOLESCING, OBSOLESCES]\n",
  "OBSOLESCED": "OBSOLESCE, to grow obsolescent [v]\n",
  "OBSOLESCENCE": "the process of becoming obsolete or the condition of being nearly obsolete [n -S]\n",
  "OBSOLESCENCES": "OBSOLESCENCE, the process of becoming obsolete or the condition of being nearly obsolete [n]\n",
  "OBSOLESCENT": "not functional, but not reduced to a rudiment [adj OBSOLESCENTLY]\n",
  "OBSOLESCENTLY": "OBSOLESCENT, not functional, but not reduced to a rudiment [adv]\n",
  "OBSOLESCES": "OBSOLESCE, to grow obsolescent [v]\n",
  "OBSOLESCING": "OBSOLESCE, to grow obsolescent [v]\n",
  "OBSOLETE": "outmoded [adj OBSOLETELY] / to make or consider as obsolete [v OBSOLETED, OBSOLETING, OBSOLETES]\n",
  "OBSOLETED": "OBSOLETE, to make or consider as obsolete [v]\n",
  "OBSOLETELY": "OBSOLETE, outmoded [adv]\n",
  "OBSOLETENESS": "the state of being obsolete [n -ES]\n",
  "OBSOLETENESSES": "OBSOLETENESS, the state of being obsolete [n]\n",
  "OBSOLETES": "OBSOLETE, to make or consider as obsolete [v]\n",
  "OBSOLETING": "OBSOLETE, to make or consider as obsolete [v]\n",
  "OBSOLETION": "obsolescence [n -S]\n",
  "OBSOLETIONS": "OBSOLETION, obsolescence [n]\n",
  "OBSOLETISM": "a disused word or phrase; an archaism [n -S]\n",
  "OBSOLETISMS": "OBSOLETISM, a disused word or phrase; an archaism [n]\n",
  "OBSTACLE": "something that obstructs [n -S]\n",
  "OBSTACLES": "OBSTACLE, something that obstructs [n]\n",
  "OBSTETRIC": "relating to the care of women during pregnancy, also OBSTETRICAL [adj OBSTETRICALLY]\n",
  "OBSTETRICAL": "relating to the care of women during pregnancy, also OBSTETRIC [adj OBSTETRICALLY]\n",
  "OBSTETRICALLY": "OBSTETRICAL, relating to the care of women during pregnancy, also OBSTETRIC [adv]\n",
  "OBSTETRICIAN": "one who specialises in the care of women during pregnancy [n -S]\n",
  "OBSTETRICIANS": "OBSTETRICIAN, one who specialises in the care of women during pregnancy [n]\n",
  "OBSTETRICS": "the care of women during pregnancy [n]\n",
  "OBSTINACIES": "OBSTINACY, stubbornness [n]\n",
  "OBSTINACY": "stubbornness [n OBSTINACIES]\n",
  "OBSTINATE": "stubborn [adj OBSTINATELY]\n",
  "OBSTINATELY": "OBSTINATE, stubborn [adv]\n",
  "OBSTINATENESS": "OBSTINATE, stubborn [n]\n",
  "OBSTINATENESSES": "OBSTINATENESS, OBSTINATE, stubborn [n]\n",
  "OBSTIPATION": "a severe and obstinate constipation [n -S]\n",
  "OBSTIPATIONS": "OBSTIPATION, a severe and obstinate constipation [n]\n",
  "OBSTREPERATE": "(Sterne) to make an unruly noise [v OBSTREPERATED, OBSTREPERATING, OBSTREPERATES]\n",
  "OBSTREPERATED": "OBSTREPERATE, (Sterne) to make an unruly noise [v]\n",
  "OBSTREPERATES": "OBSTREPERATE, (Sterne) to make an unruly noise [v]\n",
  "OBSTREPERATING": "OBSTREPERATE, (Sterne) to make an unruly noise [v]\n",
  "OBSTREPEROUS": "noisy, unruly, also OBSTROPALOUS, OBSTROPULOUS [adj OBSTREPEROUSLY]\n",
  "OBSTREPEROUSLY": "OBSTREPEROUS, noisy, unruly, also OBSTROPALOUS, OBSTROPULOUS [adv]\n",
  "OBSTRICTION": "(obsolete) obligation [n -S]\n",
  "OBSTRICTIONS": "OBSTRICTION, (obsolete) obligation [n]\n",
  "OBSTROPALOUS": "(colloquial) noisy, unruly, also OBSTREPEROUS, OBSTROPULOUS [adj]\n",
  "OBSTROPULOUS": "(colloquial) noisy, unruly, also OBSTREPEROUS, OBSTROPALOUS [adj]\n",
  "OBSTRUCT": "to get in the way of [v -ED, -ING, -S]\n",
  "OBSTRUCTED": "OBSTRUCT, to get in the way of [v]\n",
  "OBSTRUCTER": "one who obstructs, also OBSTRUCTOR [n -S]\n",
  "OBSTRUCTERS": "OBSTRUCTER, one who obstructs, also OBSTRUCTOR [n]\n",
  "OBSTRUCTING": "OBSTRUCT, to get in the way of [v]\n",
  "OBSTRUCTINGLY": "in an obstructing manner [adv]\n",
  "OBSTRUCTION": "the state of being obstructed [n -S]\n",
  "OBSTRUCTIONAL": "relating to obstruction [adj OBSTRUCTIONALLY]\n",
  "OBSTRUCTIONALLY": "OBSTRUCTIONAL, relating to obstruction [adv]\n",
  "OBSTRUCTIONISM": "deliberate interference with the progress or business esp. of a legislative body [n -S]\n",
  "OBSTRUCTIONISMS": "OBSTRUCTIONISM, deliberate interference with the progress or business esp. of a legislative body [n]\n",
  "OBSTRUCTIONIST": "someone, esp. a politician in a legislative assembly, who practises obstruction [n -S]\n",
  "OBSTRUCTIONISTS": "OBSTRUCTIONIST, someone, esp. a politician in a legislative assembly, who practises obstruction [n]\n",
  "OBSTRUCTIONS": "OBSTRUCTION, the state of being obstructed [n]\n",
  "OBSTRUCTIVE": "serving to obstruct [adj OBSTRUCTIVELY] / a hindrance [n -S]\n",
  "OBSTRUCTIVELY": "OBSTRUCTIVE, serving to obstruct [adv]\n",
  "OBSTRUCTIVENESS": "OBSTRUCTIVE, serving to obstruct [n]\n",
  "OBSTRUCTIVES": "OBSTRUCTIVE, a hindrance [n]\n",
  "OBSTRUCTOR": "one who obstructs, also OBSTRUCTER [n -S]\n",
  "OBSTRUCTORS": "OBSTRUCTOR, one who obstructs, also OBSTRUCTER [n]\n",
  "OBSTRUCTS": "OBSTRUCT, to get in the way of [v]\n",
  "OBSTRUENT": "a sound characterized by obstruction of the airstream, a plosive, fricative, or affricate [n -S]\n",
  "OBSTRUENTS": "OBSTRUENT, a sound characterized by obstruction of the airstream, a plosive, fricative, or affricate [n]\n",
  "OBTAIN": "to gain possession of [v -ED, -ING, -S]\n",
  "OBTAINABILITIES": "OBTAINABILITY, the state of being obtainable [n]\n",
  "OBTAINABILITY": "the state of being obtainable [n OBTAINABILITIES]\n",
  "OBTAINABLE": "that can be obtained [adj]\n",
  "OBTAINED": "OBTAIN, to gain possession of [v]\n",
  "OBTAINER": "one who obtains [n -S]\n",
  "OBTAINERS": "OBTAINER, one who obtains [n]\n",
  "OBTAINING": "OBTAIN, to gain possession of [v]\n",
  "OBTAINMENT": "the act of obtaining [n -S]\n",
  "OBTAINMENTS": "OBTAINMENT, the act of obtaining [n]\n",
  "OBTAINS": "OBTAIN, to gain possession of [v]\n",
  "OBTECT": "of an insect, having wings and legs immovably pressed against the body in a hard chitinous case, also OBTECTED [adj]\n",
  "OBTECTED": "of an insect, having wings and legs immovably pressed against the body in a hard chitinous case, also OBTECT [adj]\n",
  "OBTEMPER": "to yield obedience to, also OBTEMPERATE [v -ED, -ING, -S]\n",
  "OBTEMPERATE": "to obey (a judgment or decree), also OBTEMPER [v OBTEMPERATED, OBTEMPERATING, OBTEMPERATES]\n",
  "OBTEMPERATED": "OBTEMPERATE, to obey (a judgment or decree), also OBTEMPER [v]\n",
  "OBTEMPERATES": "OBTEMPERATE, to obey (a judgment or decree), also OBTEMPER [v]\n",
  "OBTEMPERATING": "OBTEMPERATE, to obey (a judgment or decree), also OBTEMPER [v]\n",
  "OBTEMPERED": "OBTEMPER, to yield obedience to, also OBTEMPERATE [v]\n",
  "OBTEMPERING": "OBTEMPER, to yield obedience to, also OBTEMPERATE [v]\n",
  "OBTEMPERS": "OBTEMPER, to yield obedience to, also OBTEMPERATE [v]\n",
  "OBTEND": "(obsolete) to put forward or allege [v -ED, -ING, -S]\n",
  "OBTENDED": "OBTEND, (obsolete) to put forward or allege [v]\n",
  "OBTENDING": "OBTEND, (obsolete) to put forward or allege [v]\n",
  "OBTENDS": "OBTEND, (obsolete) to put forward or allege [v]\n",
  "OBTENTION": "the act of obtending [n -S]\n",
  "OBTENTIONS": "OBTENTION, the act of obtending [n]\n",
  "OBTEST": "to beseech, supplicate [v -ED, -ING, -S]\n",
  "OBTESTATION": "the act of obtesting [n -S]\n",
  "OBTESTATIONS": "OBTESTATION, the act of obtesting [n]\n",
  "OBTESTED": "OBTEST, to beseech, supplicate [v]\n",
  "OBTESTING": "OBTEST, to beseech, supplicate [v]\n",
  "OBTESTS": "OBTEST, to beseech, supplicate [v]\n",
  "OBTRUDE": "to thrust forward [v OBTRUDED, OBTRUDING, OBTRUDES]\n",
  "OBTRUDED": "OBTRUDE, to thrust forward [v]\n",
  "OBTRUDER": "one who obtrudes [n -S]\n",
  "OBTRUDERS": "OBTRUDER, one who obtrudes [n]\n",
  "OBTRUDES": "OBTRUDE, to thrust forward [v]\n",
  "OBTRUDING": "the act of obtruding [n -S]\n",
  "OBTRUDINGS": "OBTRUDING, the act of obtruding [n]\n",
  "OBTRUNCATE": "to cut or lop off the head of [v OBTRUNCATED, OBTRUNCATING, OBTRUNCATES]\n",
  "OBTRUNCATED": "OBTRUNCATE, to cut or lop off the head of [v]\n",
  "OBTRUNCATES": "OBTRUNCATE, to cut or lop off the head of [v]\n",
  "OBTRUNCATING": "OBTRUNCATE, to cut or lop off the head of [v]\n",
  "OBTRUSION": "an unwanted thrusting in, forward or upon [n -S]\n",
  "OBTRUSIONS": "OBTRUSION, an unwanted thrusting in, forward or upon [n]\n",
  "OBTRUSIVE": "thrusting forward [adj OBTRUSIVELY]\n",
  "OBTRUSIVELY": "OBTRUSIVE, thrusting forward [adv]\n",
  "OBTRUSIVENESS": "OBTRUSIVE, thrusting forward [n]\n",
  "OBTRUSIVENESSES": "OBTRUSIVENESS, OBTRUSIVE, thrusting forward [n]\n",
  "OBTUND": "to blunt, deaden [v -ED, -ING, -S]\n",
  "OBTUNDED": "OBTUND, to blunt, deaden [v]\n",
  "OBTUNDENT": "having the property of dulling sensitivity [adj] / an obtundent substance [n -S]\n",
  "OBTUNDENTS": "OBTUNDENT, an obtundent substance [n]\n",
  "OBTUNDING": "OBTUND, to blunt, deaden [v]\n",
  "OBTUNDITIES": "OBTUNDITY, the state of being obtund [n]\n",
  "OBTUNDITY": "the state of being obtund [n OBTUNDITIES]\n",
  "OBTUNDS": "OBTUND, to blunt, deaden [v]\n",
  "OBTURATE": "to stop up [v OBTURATED, OBTURATING, OBTURATES]\n",
  "OBTURATED": "OBTURATE, to stop up [v]\n",
  "OBTURATES": "OBTURATE, to stop up [v]\n",
  "OBTURATING": "OBTURATE, to stop up [v]\n",
  "OBTURATION": "an obstruction [n -S]\n",
  "OBTURATIONS": "OBTURATION, an obstruction [n]\n",
  "OBTURATOR": "a structure or device that closes a cavity [n -S]\n",
  "OBTURATORS": "OBTURATOR, a structure or device that closes a cavity [n]\n",
  "OBTUSE": "stupid [adj OBTUSER, OBTUSEST, OBTUSELY]\n",
  "OBTUSELY": "OBTUSE, stupid [adv]\n",
  "OBTUSENESS": "the state of being obtuse [n -ES]\n",
  "OBTUSENESSES": "OBTUSENESS, the state of being obtuse [n]\n",
  "OBTUSER": "OBTUSE, stupid [adj]\n",
  "OBTUSEST": "OBTUSE, stupid [adj]\n",
  "OBTUSITIES": "OBTUSITY, the state of being obtuse [n]\n",
  "OBTUSITY": "the state of being obtuse [n OBTUSITIES]\n",
  "OBUMBRATE": "to overshadow [v OBUMBRATED, OBUMBRATING, OBUMBRATES]\n",
  "OBUMBRATED": "OBUMBRATE, to overshadow [v]\n",
  "OBUMBRATES": "OBUMBRATE, to overshadow [v]\n",
  "OBUMBRATING": "OBUMBRATE, to overshadow [v]\n",
  "OBUMBRATION": "the act of obumbrating [n -S]\n",
  "OBUMBRATIONS": "OBUMBRATION, the act of obumbrating [n]\n",
  "OBVENTION": "(obsolete) any incidental occurrence or advantage [n -S]\n",
  "OBVENTIONS": "OBVENTION, (obsolete) any incidental occurrence or advantage [n]\n",
  "OBVERSE": "turned towards one [adj OBVERSELY] / the side of the coin bearing the main design [n -S]\n",
  "OBVERSELY": "OBVERSE, turned towards one [adv]\n",
  "OBVERSES": "OBVERSE, the side of the coin bearing the main design [n]\n",
  "OBVERSION": "the act of turning toward or downward [n -S]\n",
  "OBVERSIONS": "OBVERSION, the act of turning toward or downward [n]\n",
  "OBVERT": "to turn, to show a different surface [v -ED, -ING, -S]\n",
  "OBVERTED": "OBVERT, to turn, to show a different surface [v]\n",
  "OBVERTING": "OBVERT, to turn, to show a different surface [v]\n",
  "OBVERTS": "OBVERT, to turn, to show a different surface [v]\n",
  "OBVIABLE": "able to be obviated [adj]\n",
  "OBVIATE": "to forestall [v OBVIATED, OBVIATING, OBVIATES]\n",
  "OBVIATED": "OBVIATE, to forestall [v]\n",
  "OBVIATES": "OBVIATE, to forestall [v]\n",
  "OBVIATING": "OBVIATE, to forestall [v]\n",
  "OBVIATION": "the action of obviating something [n -S]\n",
  "OBVIATIONS": "OBVIATION, the action of obviating something [n]\n",
  "OBVIATOR": "one who obviates [n -S]\n",
  "OBVIATORS": "OBVIATOR, one who obviates [n]\n",
  "OBVIOUS": "easily understood [adj OBVIOUSLY]\n",
  "OBVIOUSLY": "OBVIOUS, easily understood [adv]\n",
  "OBVIOUSNESS": "the state of being obvious [n -ES]\n",
  "OBVIOUSNESSES": "OBVIOUSNESS, the state of being obvious [n]\n",
  "OBVOLUTE": "of a leaf etc., having a margin that alternately overlaps and is overlapped by that of an opposing leaf, also OBVOLUTED, OBVOLUTIVE [adj]\n",
  "OBVOLUTED": "of a leaf etc., having a margin that alternately overlaps and is overlapped by that of an opposing leaf, also OBVOLUTE, OBVOLUTIVE [adj]\n",
  "OBVOLUTION": "the state of being obvolute, having a margin that alternately overlaps and is overlapped by that of an opposing leaf [n -S]\n",
  "OBVOLUTIONS": "OBVOLUTION, the state of being obvolute, having a margin that alternately overlaps and is overlapped by that of an opposing leaf [n]\n",
  "OBVOLUTIVE": "of a leaf etc., having a margin that alternately overlaps and is overlapped by that of an opposing leaf, also OBVOLUTE, OBVOLUTED [adj]\n",
  "OBVOLVENT": "enwrapping; curved downward or inward [adj]\n",
  "OBVS": "(colloquial) obviously [adv]\n",
  "OCA": "a South American wood-sorrel with edible tubers [n -S]\n",
  "OCARINA": "(Italian) an egg-shaped flutelike wind instrument [n -S]\n",
  "OCARINAS": "OCARINA, (Italian) an egg-shaped flutelike wind instrument [n]\n",
  "OCAS": "OCA, a South American wood-sorrel with edible tubers [n]\n",
  "OCCAM": "a computer programming language [n -S]\n",
  "OCCAMIES": "OCCAMY, an alloy imitating gold or silver [n]\n",
  "OCCAMS": "OCCAM, a computer programming language [n]\n",
  "OCCAMY": "an alloy imitating gold or silver [n OCCAMIES]\n",
  "OCCASION": "to cause [v -ED, -ING, -S]\n",
  "OCCASIONAL": "of or relating to a particular occasion [adj OCCASIONALLY]\n",
  "OCCASIONALISM": "the Cartesian explanation of the apparent interaction of mind and matter by the direct intervention of God on the occasion of certain changes occurring in one or the other [n -S]\n",
  "OCCASIONALISMS": "OCCASIONALISM, the Cartesian explanation of the apparent interaction of mind and matter by the direct intervention of God on the occasion of certain changes occurring in one or the other [n]\n",
  "OCCASIONALIST": "a believer in occasionalism [n -S]\n",
  "OCCASIONALISTS": "OCCASIONALIST, a believer in occasionalism [n]\n",
  "OCCASIONALITIES": "OCCASIONALITY, the state of being occasional [n]\n",
  "OCCASIONALITY": "the state of being occasional [n OCCASIONALITIES]\n",
  "OCCASIONALLY": "OCCASIONAL, of or relating to a particular occasion [adv]\n",
  "OCCASIONED": "OCCASION, to cause [v]\n",
  "OCCASIONER": "one who, or that which, occasions [n -S]\n",
  "OCCASIONERS": "OCCASIONER, one who, or that which, occasions [n]\n",
  "OCCASIONING": "OCCASION, to cause [v]\n",
  "OCCASIONS": "OCCASION, to cause [v]\n",
  "OCCIDENT": "the part of the world to the west of some recognized part [n -S]\n",
  "OCCIDENTAL": "western [adj OCCIDENTALLY] / one who lives in the west [n -S]\n",
  "OCCIDENTALISE": "to make occidental, also OCCIDENTALIZE [v OCCIDENTALISED, OCCIDENTALISING, OCCIDENTALISES]\n",
  "OCCIDENTALISED": "OCCIDENTALISE, to make occidental, also OCCIDENTALIZE [v]\n",
  "OCCIDENTALISES": "OCCIDENTALISE, to make occidental, also OCCIDENTALIZE [v]\n",
  "OCCIDENTALISING": "OCCIDENTALISE, to make occidental, also OCCIDENTALIZE [v]\n",
  "OCCIDENTALISM": "the study of the Occident [n -S]\n",
  "OCCIDENTALISMS": "OCCIDENTALISM, the study of the Occident [n]\n",
  "OCCIDENTALIST": "one who studies the Occident [n -S]\n",
  "OCCIDENTALISTS": "OCCIDENTALIST, one who studies the Occident [n]\n",
  "OCCIDENTALIZE": "to make occidental, also OCCIDENTALISE [v OCCIDENTALIZED, OCCIDENTALIZING, OCCIDENTALIZES]\n",
  "OCCIDENTALIZED": "OCCIDENTALIZE, to make occidental, also OCCIDENTALISE [v]\n",
  "OCCIDENTALIZES": "OCCIDENTALIZE, to make occidental, also OCCIDENTALISE [v]\n",
  "OCCIDENTALIZING": "OCCIDENTALIZE, to make occidental, also OCCIDENTALISE [v]\n",
  "OCCIDENTALLY": "OCCIDENTAL, western [adv]\n",
  "OCCIDENTALS": "OCCIDENTAL, one who lives in the west [n]\n",
  "OCCIDENTS": "OCCIDENT, the part of the world to the west of some recognized part [n]\n",
  "OCCIES": "OCCY, in the phrase all over the occy, all over the place [n]\n",
  "OCCIPITA": "OCCIPUT, (Latin) the back part of the skull [n]\n",
  "OCCIPITAL": "relating to the back of the head [adj OCCIPITALLY] / the bone forming the back of the head [n -S]\n",
  "OCCIPITALLY": "OCCIPITAL, relating to the back of the head [adv]\n",
  "OCCIPITALS": "OCCIPITAL, the bone forming the back of the head [n]\n",
  "OCCIPUT": "(Latin) the back part of the skull [n OCCIPUTS or OCCIPITA]\n",
  "OCCIPUTS": "OCCIPUT, (Latin) the back part of the skull [n]\n",
  "OCCLUDE": "to stop up [v OCCLUDED, OCCLUDING, OCCLUDES]\n",
  "OCCLUDED": "OCCLUDE, to stop up [v]\n",
  "OCCLUDENT": "causing or resulting in occlusion [adj] / something serving to close; shutting up [n -S]\n",
  "OCCLUDENTS": "OCCLUDENT, something serving to close; shutting up [n]\n",
  "OCCLUDER": "a medical closing device [n -S]\n",
  "OCCLUDERS": "OCCLUDER, a medical closing device [n]\n",
  "OCCLUDES": "OCCLUDE, to stop up [v]\n",
  "OCCLUDING": "OCCLUDE, to stop up [v]\n",
  "OCCLUSAL": "pertaining to the biting surface of a tooth [adj]\n",
  "OCCLUSION": "the closing of an opening, passage or cavity [n -S]\n",
  "OCCLUSIONS": "OCCLUSION, the closing of an opening, passage or cavity [n]\n",
  "OCCLUSIVE": "a consonantal sound produced with stoppage of breath [n -S]\n",
  "OCCLUSIVENESS": "the state of being occlusive [n -ES]\n",
  "OCCLUSIVENESSES": "OCCLUSIVENESS, the state of being occlusive [n]\n",
  "OCCLUSIVES": "OCCLUSIVE, a consonantal sound produced with stoppage of breath [n]\n",
  "OCCLUSOR": "a muscle etc. which closes an opening [n -S]\n",
  "OCCLUSORS": "OCCLUSOR, a muscle etc. which closes an opening [n]\n",
  "OCCULT": "secret [adj OCCULTLY] / to hide or make disappear [v -ED, -ING, -S]\n",
  "OCCULTATION": "a concealing, esp. of one of the heavenly bodies by another [n -S]\n",
  "OCCULTATIONS": "OCCULTATION, a concealing, esp. of one of the heavenly bodies by another [n]\n",
  "OCCULTED": "OCCULT, to hide or make disappear [v]\n",
  "OCCULTER": "something or someone that occults [n -S]\n",
  "OCCULTERS": "OCCULTER, something or someone that occults [n]\n",
  "OCCULTING": "OCCULT, to hide or make disappear [v]\n",
  "OCCULTISM": "the study of the occult [n -S]\n",
  "OCCULTISMS": "OCCULTISM, the study of the occult [n]\n",
  "OCCULTIST": "one who studies the occult [n -S]\n",
  "OCCULTISTS": "OCCULTIST, one who studies the occult [n]\n",
  "OCCULTLY": "OCCULT, secret [adv]\n",
  "OCCULTNESS": "the state of being occult [n -ES]\n",
  "OCCULTNESSES": "OCCULTNESS, the state of being occult [n]\n",
  "OCCULTS": "OCCULT, to hide or make disappear [v]\n",
  "OCCUPANCE": "the act or fact of occupying, also OCCUPANCY [n -S]\n",
  "OCCUPANCES": "OCCUPANCE, the act or fact of occupying, also OCCUPANCY [n]\n",
  "OCCUPANCIES": "OCCUPANCY, the act or fact of occupying, also OCCUPANCE [n]\n",
  "OCCUPANCY": "the act or fact of occupying, also OCCUPANCE [n OCCUPANCIES]\n",
  "OCCUPANT": "one who occupies [n -S]\n",
  "OCCUPANTS": "OCCUPANT, one who occupies [n]\n",
  "OCCUPATE": "to reside in, also OCCUPY [v OCCUPATED, OCCUPATING, OCCUPATES]\n",
  "OCCUPATED": "OCCUPATE, to reside in, also OCCUPY [v]\n",
  "OCCUPATES": "OCCUPATE, to reside in, also OCCUPY [v]\n",
  "OCCUPATING": "OCCUPATE, to reside in, also OCCUPY [v]\n",
  "OCCUPATION": "an activity in which one engages [n -S]\n",
  "OCCUPATIONAL": "related to occupation [adj OCCUPATIONALLY]\n",
  "OCCUPATIONALLY": "OCCUPATIONAL, related to occupation [adv]\n",
  "OCCUPATIONS": "OCCUPATION, an activity in which one engages [n]\n",
  "OCCUPATIVE": "held by tenure based on occupation [adj]\n",
  "OCCUPIED": "OCCUPY, to reside in, also OCCUPATE [v]\n",
  "OCCUPIER": "one who occupies [n -S]\n",
  "OCCUPIERS": "OCCUPIER, one who occupies [n]\n",
  "OCCUPIES": "OCCUPY, to reside in, also OCCUPATE [v]\n",
  "OCCUPY": "to reside in, also OCCUPATE [v OCCUPIED, OCCUPYING, OCCUPIES]\n",
  "OCCUPYING": "OCCUPY, to reside in, also OCCUPATE [v]\n",
  "OCCUR": "to take place [v OCCURRED, OCCURRING, OCCURS]\n",
  "OCCURRED": "OCCUR, to take place [v]\n",
  "OCCURRENCE": "something that occurs [n -S]\n",
  "OCCURRENCES": "OCCURRENCE, something that occurs [n]\n",
  "OCCURRENT": "occurring [adj] / an occurrence [n -S]\n",
  "OCCURRENTS": "OCCURRENT, an occurrence [n]\n",
  "OCCURRING": "OCCUR, to take place [v]\n",
  "OCCURS": "OCCUR, to take place [v]\n",
  "OCCY": "in the phrase all over the occy, all over the place [n OCCIES]\n",
  "OCEAN": "one of the vast bodies of salt water that covers most of the earth's surface [n -S]\n",
  "OCEANARIA": "OCEANARIUM, an enclosed part of the sea in which dolphins, porpoises etc. are kept for display [n]\n",
  "OCEANARIUM": "an enclosed part of the sea in which dolphins, porpoises etc. are kept for display [n OCEANARIA or OCEANARIUMS]\n",
  "OCEANARIUMS": "OCEANARIUM, an enclosed part of the sea in which dolphins, porpoises etc. are kept for display [n]\n",
  "OCEANAUT": "someone who lives for periods under the sea, to observe and explore [n -S]\n",
  "OCEANAUTS": "OCEANAUT, someone who lives for periods under the sea, to observe and explore [n]\n",
  "OCEANFRONT": "a strip of land bordering on the ocean [n -S]\n",
  "OCEANFRONTS": "OCEANFRONT, a strip of land bordering on the ocean [n]\n",
  "OCEANGOING": "of, relating to, or designed for travel on the ocean [adj]\n",
  "OCEANIC": "pertaining to the ocean [adj]\n",
  "OCEANID": "(Greek) an ocean nymph [n OCEANIDS or OCEANIDES]\n",
  "OCEANIDES": "OCEANID, (Greek) an ocean nymph [n]\n",
  "OCEANIDS": "OCEANID, (Greek) an ocean nymph [n]\n",
  "OCEANOGRAPHER": "one who maps the oceans [n -S]\n",
  "OCEANOGRAPHERS": "OCEANOGRAPHER, one who maps the oceans [n]\n",
  "OCEANOGRAPHIC": "relating to oceanography, also OCEANOGRAPHICAL [adj]\n",
  "OCEANOGRAPHICAL": "relating to oceanography, also OCEANOGRAPHIC [adj]\n",
  "OCEANOGRAPHIES": "OCEANOGRAPHY, the study of the oceans [n]\n",
  "OCEANOGRAPHY": "the study of the oceans [n OCEANOGRAPHIES]\n",
  "OCEANOLOGICAL": "related to oceanology [adj]\n",
  "OCEANOLOGIES": "OCEANOLOGY, the science of the oceans [n]\n",
  "OCEANOLOGIST": "a student of oceanology [n -S]\n",
  "OCEANOLOGISTS": "OCEANOLOGIST, a student of oceanology [n]\n",
  "OCEANOLOGY": "the science of the oceans [n OCEANOLOGIES]\n",
  "OCEANS": "OCEAN, one of the vast bodies of salt water that covers most of the earth's surface [n]\n",
  "OCEANSIDE": "situated beside the ocean [adj]\n",
  "OCEANVIEW": "having a view of the ocean [adj]\n",
  "OCEANWARD": "in the direction of the ocean [adv]\n",
  "OCELLAR": "of the nature of an ocellus, a small simple eye found in many invertebrates [adj]\n",
  "OCELLATE": "eyelike and ringed; having an eyelike spot or spots, also OCELLATED [adj]\n",
  "OCELLATED": "eyelike and ringed; having an eyelike spot or spots, also OCELLATE [adj]\n",
  "OCELLATION": "the state of being ocellated [n -S]\n",
  "OCELLATIONS": "OCELLATION, the state of being ocellated [n]\n",
  "OCELLI": "OCELLUS, (Latin) a small simple eye found in many invertebrates; an eyelike marking [n]\n",
  "OCELLUS": "(Latin) a small simple eye found in many invertebrates; an eyelike marking [n OCELLI]\n",
  "OCELOID": "resembling the ocelot [adj]\n",
  "OCELOT": "(Nahuatl) an American wildcat [n -S]\n",
  "OCELOTS": "OCELOT, (Nahuatl) an American wildcat [n]\n",
  "OCH": "(Scots) an interjection expressing regret or impatience, also ACH [interj]\n",
  "OCHE": "in darts, the line from which players throw [n -S]\n",
  "OCHER": "a native pigment composed of fine earth and an iron oxide, also OCHRE [n -S] / to colour with ochre [v -ED, -ING, -S]\n",
  "OCHERED": "OCHER, to colour with ochre [v]\n",
  "OCHERIER": "OCHERY, containing or resembling ocher, also OCHERISH, OCHEROID, OCHEROUS, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHERIEST": "OCHERY, containing or resembling ocher, also OCHERISH, OCHEROID, OCHEROUS, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHERING": "OCHER, to colour with ochre [v]\n",
  "OCHERISH": "resembling ocher, also OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHEROID": "of or like ocher, also OCHERISH, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHEROUS": "containing or resembling ochre, also OCHERISH, OCHEROID, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHERS": "OCHER, a native pigment composed of fine earth and an iron oxide, also OCHRE [n]\n",
  "OCHERY": "containing or resembling ocher, also OCHERISH, OCHEROID, OCHEROUS, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj OCHERIER, OCHERIEST]\n",
  "OCHES": "OCHE, in darts, the line from which players throw [n]\n",
  "OCHIDORE": "Charles Kingsley's name (not otherwise known) for a shore-crab [n -S]\n",
  "OCHIDORES": "OCHIDORE, Charles Kingsley's name (not otherwise known) for a shore-crab [n]\n",
  "OCHLOCRACIES": "OCHLOCRACY, government by the mob [n]\n",
  "OCHLOCRACY": "government by the mob [n OCHLOCRACIES]\n",
  "OCHLOCRAT": "a mob ruler [n -S]\n",
  "OCHLOCRATIC": "relating to ochlocracy, rule by the mob, also OCHLOCRATICAL [adj OCHLOCRATICALLY]\n",
  "OCHLOCRATICAL": "relating to ochlocracy, rule by the mob, also OCHLOCRATIC [adj OCHLOCRATICALLY]\n",
  "OCHLOCRATICALLY": "OCHLOCRATICAL, relating to ochlocracy, rule by the mob, also OCHLOCRATIC [adv]\n",
  "OCHLOCRATS": "OCHLOCRAT, a mob ruler [n]\n",
  "OCHLOPHOBIA": "the fear of crowds [n -S]\n",
  "OCHLOPHOBIAC": "one who suffers from ochlophobia, a morbid fear of crowds [n -S]\n",
  "OCHLOPHOBIACS": "OCHLOPHOBIAC, one who suffers from ochlophobia, a morbid fear of crowds [n]\n",
  "OCHLOPHOBIAS": "OCHLOPHOBIA, the fear of crowds [n]\n",
  "OCHLOPHOBIC": "a person who suffers from ochlophobia [n -S]\n",
  "OCHLOPHOBICS": "OCHLOPHOBIC, a person who suffers from ochlophobia [n]\n",
  "OCHONE": "(Irish) an interjection of lamentation, also OHONE [interj]\n",
  "OCHRACEOUS": "containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHREOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHRE": "a native pigment composed of fine earth and an iron oxide, also OCHER [n -S] / to colour with ochre [v OCHRED, OCHRING, OCHRES]\n",
  "OCHREA": "(Latin) a sheath of stipules enclosing the leafstalks of certain plants, also OCREA [n OCHREAE or OCHREAS]\n",
  "OCHREAE": "OCHREA, (Latin) a sheath of stipules enclosing the leafstalks of certain plants, also OCREA [n]\n",
  "OCHREAS": "OCHREA, (Latin) a sheath of stipules enclosing the leafstalks of certain plants, also OCREA [n]\n",
  "OCHREATE": "having an ochrea, a scarious sheath round a stem, also OCREATE [adj]\n",
  "OCHRED": "OCHRE, to colour with ochre [v]\n",
  "OCHREOUS": "containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREY, OCHROID, OCHROUS, OCHRY [adj]\n",
  "OCHRES": "OCHRE, to colour with ochre [v]\n",
  "OCHREY": "containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHROID, OCHROUS, OCHRY [adj OCHRIER, OCHRIEST]\n",
  "OCHRIER": "OCHRY, containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS [adj]\n",
  "OCHRIEST": "OCHRY, containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS [adj]\n",
  "OCHRING": "OCHRE, to colour with ochre [v]\n",
  "OCHROID": "containing or resembling ochre, also OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROUS, OCHRY [adj]\n",
  "OCHROLEUCOUS": "yellowish white [adj]\n",
  "OCHROUS": "containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHRY [adj]\n",
  "OCHRY": "containing or resembling ochre, also OCHERISH, OCHEROID, OCHEROUS, OCHERY, OCHRACEOUS, OCHREOUS, OCHREY, OCHROID, OCHROUS [adj OCHRIER, OCHRIEST]\n",
  "OCICAT": "a large shorthaired cat with a spotted coat [n -S]\n",
  "OCICATS": "OCICAT, a large shorthaired cat with a spotted coat [n]\n",
  "OCKER": "(Australian slang) an oafish uncultured Australian [n -S]\n",
  "OCKERISM": "(Australian slang) boorishness in Australians [n -S]\n",
  "OCKERISMS": "OCKERISM, (Australian slang) boorishness in Australians [n]\n",
  "OCKERS": "OCKER, (Australian slang) an oafish uncultured Australian [n]\n",
  "OCKODOLS": "(dialect) one's feet when wearing boots [n]\n",
  "OCOTILLO": "(Nahuatl) a cactus-like Mexican tree [n -S]\n",
  "OCOTILLOS": "OCOTILLO, (Nahuatl) a cactus-like Mexican tree [n]\n",
  "OCREA": "(Latin) a sheath of stipules enclosing the leafstalks of certain plants, also OCHREA [n OCREAE or OCREAS]\n",
  "OCREAE": "OCREA, (Latin) a sheath of stipules enclosing the leafstalks of certain plants, also OCHREA [n]\n",
  "OCREAS": "OCREA, (Latin) a sheath of stipules enclosing the leafstalks of certain plants, also OCHREA [n]\n",
  "OCREATE": "having an ocrea, a scarious sheath round a stem, also OCHREATE [adj]\n",
  "OCTA": "a unit of cloud-cover, one-eighth sky, also OKTA [n -S]\n",
  "OCTACHORD": "an instrument of eight strings; a system of eight tones [n -S]\n",
  "OCTACHORDAL": "relating to an octachord [adj]\n",
  "OCTACHORDS": "OCTACHORD, an instrument of eight strings; a system of eight tones [n]\n",
  "OCTAD": "a group of eight [n -S]\n",
  "OCTADIC": "relating to an octad [adj]\n",
  "OCTADS": "OCTAD, a group of eight [n]\n",
  "OCTAGON": "an eight-sided plane figure [n -S]\n",
  "OCTAGONAL": "having eight sides and eight angles [adj OCTAGONALLY]\n",
  "OCTAGONALLY": "OCTAGONAL, having eight sides and eight angles [adv]\n",
  "OCTAGONS": "OCTAGON, an eight-sided plane figure [n]\n",
  "OCTAHEDRA": "OCTAHEDRON, (Greek) a solid bounded by eight plane faces, also OCTOHEDRON [n]\n",
  "OCTAHEDRAL": "having eight faces or sides [adj OCTAHEDRALLY]\n",
  "OCTAHEDRALLY": "OCTAHEDRAL, having eight faces or sides [adv]\n",
  "OCTAHEDRITE": "a variety of anatase, crystallising in square bipyramids [n -S]\n",
  "OCTAHEDRITES": "OCTAHEDRITE, a variety of anatase, crystallising in square bipyramids [n]\n",
  "OCTAHEDRON": "(Greek) a solid bounded by eight plane faces, also OCTOHEDRON [n OCTAHEDRONS or OCTAHEDRA]\n",
  "OCTAHEDRONS": "OCTAHEDRON, (Greek) a solid bounded by eight plane faces, also OCTOHEDRON [n]\n",
  "OCTAL": "a number system with a base of eight [n -S]\n",
  "OCTALS": "OCTAL, a number system with a base of eight [n]\n",
  "OCTAMEROUS": "having eight parts or organs [adj]\n",
  "OCTAMETER": "a verse-line of eight feet [n -S]\n",
  "OCTAMETERS": "OCTAMETER, a verse-line of eight feet [n]\n",
  "OCTAN": "a fever recurring every eight day [n -S]\n",
  "OCTANDRIAN": "of or pertaining to the Octandria; having eight distinct stamens, also OCTANDROUS [adj]\n",
  "OCTANDROUS": "of or pertaining to the Octandria; having eight distinct stamens, also OCTANDRIAN [adj]\n",
  "OCTANE": "any of a series of saturated hydrocarbons [n -S]\n",
  "OCTANEDIOIC": "designating a type of acid found in suberin and castor oil [adj]\n",
  "OCTANES": "OCTANE, any of a series of saturated hydrocarbons [n]\n",
  "OCTANGLE": "an octagon [n -S]\n",
  "OCTANGLES": "OCTANGLE, an octagon [n]\n",
  "OCTANGULAR": "having eight angles [adj]\n",
  "OCTANOL": "an alcohol [n -S]\n",
  "OCTANOLS": "OCTANOL, an alcohol [n]\n",
  "OCTANS": "OCTAN, a fever recurring every eight day [n]\n",
  "OCTANT": "an eighth part of a circle [n -S]\n",
  "OCTANTAL": "relating to an octant [adj]\n",
  "OCTANTS": "OCTANT, an eighth part of a circle [n]\n",
  "OCTAPEPTIDE": "a protein fragment or molecule that consists of eight amino acids linked in a polypeptide chain [n -S]\n",
  "OCTAPEPTIDES": "OCTAPEPTIDE, a protein fragment or molecule that consists of eight amino acids linked in a polypeptide chain [n]\n",
  "OCTAPLA": "(Greek) a book of eight (especially Biblical) parallel texts [n -S]\n",
  "OCTAPLAS": "OCTAPLA, (Greek) a book of eight (especially Biblical) parallel texts [n]\n",
  "OCTAPLOID": "eightfold [adj] / a cell, organism or form with eight sets of chromosomes, also OCTOPLOID [n -S]\n",
  "OCTAPLOIDIES": "OCTAPLOIDY, the condition of being octaploid, eightfold [n]\n",
  "OCTAPLOIDS": "OCTAPLOID, a cell, organism or form with eight sets of chromosomes, also OCTOPLOID [n]\n",
  "OCTAPLOIDY": "the condition of being octaploid, eightfold [n OCTAPLOIDIES]\n",
  "OCTAPODIC": "of a verse line, having eight feet [adj]\n",
  "OCTAPODIES": "OCTAPODY, in verse, a line of eight feet [n]\n",
  "OCTAPODY": "in verse, a line of eight feet [n OCTAPODIES]\n",
  "OCTARCHIES": "OCTARCHY, a government by eight people [n]\n",
  "OCTARCHY": "a government by eight people [n OCTARCHIES]\n",
  "OCTAROON": "a person having one-eighth Black blood; the offspring of a quadroon and a White, also OCTOROON [n -S]\n",
  "OCTAROONS": "OCTAROON, a person having one-eighth Black blood; the offspring of a quadroon and a White, also OCTOROON [n]\n",
  "OCTAS": "OCTA, a unit of cloud-cover, one-eighth sky, also OKTA [n]\n",
  "OCTASTICH": "a poem or stanza of eight lines, also OCTASTICHON [n -S]\n",
  "OCTASTICHON": "a poem or stanza of eight lines, also OCTASTICH [n -S]\n",
  "OCTASTICHONS": "OCTASTICHON, a poem or stanza of eight lines, also OCTASTICH [n]\n",
  "OCTASTICHOUS": "in eight rows, also OCTOSTICHOUS [adj]\n",
  "OCTASTICHS": "OCTASTICH, a poem or stanza of eight lines, also OCTASTICHON [n]\n",
  "OCTASTROPHIC": "consisting of eight strophes [adj]\n",
  "OCTASTYLE": "having eight columns at the end [adj] / an octastyle building, also OCTOSTYLE [n -S]\n",
  "OCTASTYLES": "OCTASTYLE, an octastyle building, also OCTOSTYLE [n]\n",
  "OCTAVAL": "relating to an octave [adj]\n",
  "OCTAVALENT": "having a valency of eight [adj]\n",
  "OCTAVE": "a set of eight musical notes [n -S]\n",
  "OCTAVES": "OCTAVE, a set of eight musical notes [n]\n",
  "OCTAVO": "(Latin) a page size, also EIGHTVO [n -S]\n",
  "OCTAVOS": "OCTAVO, (Latin) a page size, also EIGHTVO [n]\n",
  "OCTENNIAL": "recurring every eighth year [adj OCTENNIALLY]\n",
  "OCTENNIALLY": "OCTENNIAL, recurring every eighth year [adv]\n",
  "OCTET": "a composition for eight players, also OCTETT, OCTETTE [n -S]\n",
  "OCTETS": "OCTET, a composition for eight players, also OCTETT, OCTETTE [n]\n",
  "OCTETT": "a composition for eight players, also OCTET, OCTETTE [n -S]\n",
  "OCTETTE": "a composition for eight players, also OCTET, OCTETT [n -S]\n",
  "OCTETTES": "OCTETTE, a composition for eight players, also OCTET, OCTETT [n]\n",
  "OCTETTS": "OCTETT, a composition for eight players, also OCTET, OCTETTE [n]\n",
  "OCTILLION": "the ninth power of a thousand [n -S]\n",
  "OCTILLIONS": "OCTILLION, the ninth power of a thousand [n]\n",
  "OCTILLIONTH": "the ordinal of a thousand raised to the ninth power part [adj] / one of an octillion equal parts [n -S]\n",
  "OCTILLIONTHS": "OCTILLIONTH, one of an octillion equal parts [n]\n",
  "OCTINGENARIES": "OCTINGENARY, an eight-hundredth anniversary, also OCTINGENTENARY, OCTOCENTENARY [n]\n",
  "OCTINGENARY": "an eight-hundredth anniversary, also OCTINGENTENARY, OCTOCENTENARY [n OCTINGENARIES]\n",
  "OCTINGENTENARY": "an eight-hundredth anniversary, also OCTINGENARY, OCTOCENTENARY [n]\n",
  "OCTOCENTENARIES": "OCTOCENTENARY, an eight-hundredth anniversary, also OCTINGENARY, OCTINGENTENARY [n]\n",
  "OCTOCENTENARY": "an eight-hundredth anniversary, also OCTINGENARY, OCTINGENTENARY [n OCTOCENTENARIES]\n",
  "OCTODECILLION": "ten to the 108th power [n -S]\n",
  "OCTODECILLIONS": "OCTODECILLION, ten to the 108th power [n]\n",
  "OCTODECIMO": "having eighteen leaves to the sheet [adj] / a book with sheets so folded [n -S]\n",
  "OCTODECIMOS": "OCTODECIMO, a book with sheets so folded [n]\n",
  "OCTOFID": "cleft or separated into eight segments, as a calyx [adj]\n",
  "OCTOGENARIAN": "a person whose age is in the eighties [n -S]\n",
  "OCTOGENARIANS": "OCTOGENARIAN, a person whose age is in the eighties [n]\n",
  "OCTOGENARIES": "OCTOGENARY, someone eighty years old [n]\n",
  "OCTOGENARY": "of eighty years of age [adj] / someone eighty years old [n OCTOGENARIES]\n",
  "OCTOGYNOUS": "having eight pistils [adj]\n",
  "OCTOHEDRA": "OCTOHEDRON, (Greek) a solid bounded by eight plane faces, also OCTAHEDRON [n]\n",
  "OCTOHEDRON": "(Greek) a solid bounded by eight plane faces, also OCTAHEDRON [n OCTOHEDRA or OCTOHEDRONS]\n",
  "OCTOHEDRONS": "OCTOHEDRON, (Greek) a solid bounded by eight plane faces, also OCTAHEDRON [n]\n",
  "OCTONARIAN": "in prosody, a line having eight feet, also OCTONARIUS [n -S]\n",
  "OCTONARIANS": "OCTONARIAN, in prosody, a line having eight feet, also OCTONARIUS [n]\n",
  "OCTONARIES": "OCTONARY, a stanza of eight lines [n]\n",
  "OCTONARII": "OCTONARIUS, in prosody, a line having eight feet, also OCTONARIAN [n]\n",
  "OCTONARIUS": "in prosody, a line having eight feet, also OCTONARIAN [n OCTONARII]\n",
  "OCTONARY": "a stanza of eight lines [n OCTONARIES]\n",
  "OCTONOCULAR": "having eight eyes [adj]\n",
  "OCTOPETALOUS": "having eight petals [adj]\n",
  "OCTOPI": "OCTOPUS, (Greek) a nocturnal eight-armed mollusk [n]\n",
  "OCTOPLOID": "eightfold [adj] / a cell, organism or form with eight sets of chromosomes, also OCTAPLOID [n -S]\n",
  "OCTOPLOIDS": "OCTOPLOID, a cell, organism or form with eight sets of chromosomes, also OCTAPLOID [n]\n",
  "OCTOPOD": "any of an order of eight-armed mollusks [n -S]\n",
  "OCTOPODAN": "an octopus or other eight-armed creature, also OCTOPOD [n -S]\n",
  "OCTOPODANS": "OCTOPODAN, an octopus or other eight-armed creature, also OCTOPOD [n]\n",
  "OCTOPODES": "OCTOPUS, (Greek) a nocturnal eight-armed mollusk [n]\n",
  "OCTOPODOUS": "relating to an octopod, an octopus or other eight-armed creature [adj]\n",
  "OCTOPODS": "OCTOPOD, any of an order of eight-armed mollusks [n]\n",
  "OCTOPOID": "octopus-like [adj]\n",
  "OCTOPUS": "(Greek) a nocturnal eight-armed mollusk [n OCTOPUSES or OCTOPI or OCTOPODES]\n",
  "OCTOPUSES": "OCTOPUS, (Greek) a nocturnal eight-armed mollusk [n]\n",
  "OCTOPUSH": "a type of underwater hockey [n -ES]\n",
  "OCTOPUSHER": "one who plays octopush, a kind of underwater hockey [n -S]\n",
  "OCTOPUSHERS": "OCTOPUSHER, one who plays octopush, a kind of underwater hockey [n]\n",
  "OCTOPUSHES": "OCTOPUSH, a type of underwater hockey [n]\n",
  "OCTOROON": "a person having one-eighth Black blood; the offspring of a quadroon and a White, also OCTAROON [n -S]\n",
  "OCTOROONS": "OCTOROON, a person having one-eighth Black blood; the offspring of a quadroon and a White, also OCTAROON [n]\n",
  "OCTOSEPALOUS": "having eight sepals [adj]\n",
  "OCTOSTICHOUS": "in eight rows, also OCTASTICHOUS [adj]\n",
  "OCTOSTYLE": "a building with eight columns, also OCTASTYLE [n -S]\n",
  "OCTOSTYLES": "OCTOSTYLE, a building with eight columns, also OCTASTYLE [n]\n",
  "OCTOSYLLABIC": "consisting of eight syllables [adj] / an octosyllabic line [n -S]\n",
  "OCTOSYLLABICS": "OCTOSYLLABIC, an octosyllabic line [n]\n",
  "OCTOSYLLABLE": "a word or line of eight syllables [n -S]\n",
  "OCTOSYLLABLES": "OCTOSYLLABLE, a word or line of eight syllables [n]\n",
  "OCTOTHORP": "the symbol # on a telephone or keyboard (hash mark, pound sign, number sign) [n -S]\n",
  "OCTOTHORPS": "OCTOTHORP, the symbol # on a telephone or keyboard (hash mark, pound sign, number sign) [n]\n",
  "OCTROI": "(French) a duty levied on certain goods entering a town, esp. in some European countries [n -S]\n",
  "OCTROIS": "OCTROI, (French) a duty levied on certain goods entering a town, esp. in some European countries [n]\n",
  "OCTUOR": "(French) an octet [n -S]\n",
  "OCTUORS": "OCTUOR, (French) an octet [n]\n",
  "OCTUPLE": "eightfold [adj OCTUPLY] / to multiply by eight [v OCTUPLED, OCTUPLING, OCTUPLES]\n",
  "OCTUPLED": "OCTUPLE, to multiply by eight [v]\n",
  "OCTUPLES": "OCTUPLE, to multiply by eight [v]\n",
  "OCTUPLET": "one of eight children born at one birth [n -S]\n",
  "OCTUPLETS": "OCTUPLET, one of eight children born at one birth [n]\n",
  "OCTUPLEX": "being eight times as great [adj]\n",
  "OCTUPLICATE": "one of eight corresponding things [n -S]\n",
  "OCTUPLICATES": "OCTUPLICATE, one of eight corresponding things [n]\n",
  "OCTUPLING": "OCTUPLE, to multiply by eight [v]\n",
  "OCTUPLY": "OCTUPLE, eightfold [adv]\n",
  "OCTYL": "a type of hydrocarbon radical [n -S]\n",
  "OCTYLS": "OCTYL, a type of hydrocarbon radical [n]\n",
  "OCULAR": "perceived by the eye [adj OCULARLY] / the eyepiece of an optical instrument [n -S]\n",
  "OCULARIST": "a person who makes artificial eyes [n -S]\n",
  "OCULARISTS": "OCULARIST, a person who makes artificial eyes [n]\n",
  "OCULARLY": "OCULAR, perceived by the eye [adv]\n",
  "OCULARS": "OCULAR, the eyepiece of an optical instrument [n]\n",
  "OCULATE": "having eyes, also OCULATED [adj]\n",
  "OCULATED": "having eyes, also OCULATE [adj]\n",
  "OCULI": "OCULUS, (Latin) any eyelike feature, esp. a large circular window at the west end of a church [n]\n",
  "OCULIST": "an eye specialist [n -S]\n",
  "OCULISTS": "OCULIST, an eye specialist [n]\n",
  "OCULOMOTOR": "relating to or causing movements of the eye [adj]\n",
  "OCULUS": "(Latin) any eyelike feature, esp. a large circular window at the west end of a church [n OCULI]\n",
  "OD": "a hypothetical force supposed by Reichenbach to account for magnetism etc. [n -S]\n",
  "ODA": "(Turkish) a room in a harem, also ODAH [n -S]\n",
  "ODAH": "(Turkish) a room in a harem, also ODA [n -S]\n",
  "ODAHS": "ODAH, (Turkish) a room in a harem, also ODA [n]\n",
  "ODAL": "a Scottish estate without feudal superior, also UDAL [n -S]\n",
  "ODALIQUE": "(French) a female slave; a concubine in a harem, also ODALISK, ODALISQUE [n -S]\n",
  "ODALIQUES": "ODALIQUE, (French) a female slave; a concubine in a harem, also ODALISK, ODALISQUE [n]\n",
  "ODALISK": "(French) a female slave; a concubine in a harem, also ODALIQUE, ODALISQUE [n -S]\n",
  "ODALISKS": "ODALISK, (French) a female slave; a concubine in a harem, also ODALIQUE, ODALISQUE [n]\n",
  "ODALISQUE": "(French) a female slave; a concubine in a harem, also ODALIQUE, ODALISK [n -S]\n",
  "ODALISQUES": "ODALISQUE, (French) a female slave; a concubine in a harem, also ODALIQUE, ODALISK [n]\n",
  "ODALLER": "in the Orkneys and Shetlands, one who holds a udal estate, also UDALLER [n -S]\n",
  "ODALLERS": "ODALLER, in the Orkneys and Shetlands, one who holds a udal estate, also UDALLER [n]\n",
  "ODALS": "ODAL, a Scottish estate without feudal superior, also UDAL [n]\n",
  "ODAS": "ODA, (Turkish) a room in a harem, also ODAH [n]\n",
  "ODD": "strange, unpaired [adj ODDER, ODDEST, ODDLY] / in golf, an additional or allowed stroke [n -S]\n",
  "ODDBALL": "an eccentric person [n -S]\n",
  "ODDBALLS": "ODDBALL, an eccentric person [n]\n",
  "ODDER": "ODD, strange, unpaired [adj]\n",
  "ODDEST": "ODD, strange, unpaired [adj]\n",
  "ODDISH": "somewhat odd [adj]\n",
  "ODDITIES": "ODDITY, one that is odd [n]\n",
  "ODDITY": "one that is odd [n ODDITIES]\n",
  "ODDLY": "ODD, strange, unpaired [adv]\n",
  "ODDMENT": "a remnant [n -S]\n",
  "ODDMENTS": "ODDMENT, a remnant [n]\n",
  "ODDNESS": "the state of being odd [n -ES]\n",
  "ODDNESSES": "ODDNESS, the state of being odd [n]\n",
  "ODDS": "ODD, in golf, an additional or allowed stroke [n]\n",
  "ODDSMAKER": "one who figures odds [n -S]\n",
  "ODDSMAKERS": "ODDSMAKER, one who figures odds [n]\n",
  "ODDSMAN": "(Scots) an umpire or arbiter [n ODDSMEN]\n",
  "ODDSMEN": "ODDSMAN, (Scots) an umpire or arbiter [n]\n",
  "ODE": "an elaborate lyric addressed to someone or something [n -S]\n",
  "ODEA": "ODEUM, (Latin) a building for the performance of vocal and instrumental music, esp. among the ancient Greeks and Romans, also ODEON [n]\n",
  "ODEON": "(Greek) a building for the performance of vocal and instrumental music, esp. among the ancient Greeks and Romans, also ODEUM [n -S]\n",
  "ODEONS": "ODEON, (Greek) a building for the performance of vocal and instrumental music, esp. among the ancient Greeks and Romans, also ODEUM [n]\n",
  "ODES": "ODE, an elaborate lyric addressed to someone or something [n]\n",
  "ODEUM": "(Latin) a building for the performance of vocal and instrumental music, esp. among the ancient Greeks and Romans, also ODEON [n ODEUMS or ODEA]\n",
  "ODEUMS": "ODEUM, (Latin) a building for the performance of vocal and instrumental music, esp. among the ancient Greeks and Romans, also ODEON [n]\n",
  "ODIC": "of or pertaining to an ode [adj]\n",
  "ODIFEROUS": "having odour, also ODORIFEROUS [adj]\n",
  "ODIOUS": "hateful, repugnant [adj ODIOUSLY]\n",
  "ODIOUSLY": "ODIOUS, hateful, repugnant [adv]\n",
  "ODIOUSNESS": "the state of being odious [n -ES]\n",
  "ODIOUSNESSES": "ODIOUSNESS, the state of being odious [n]\n",
  "ODISM": "belief in the power of od, also ODYLISM [n -S]\n",
  "ODISMS": "ODISM, belief in the power of od, also ODYLISM [n]\n",
  "ODIST": "one who writes odes [n -S]\n",
  "ODISTS": "ODIST, one who writes odes [n]\n",
  "ODIUM": "(Latin) hatred accompanied by contempt [n -S]\n",
  "ODIUMS": "ODIUM, (Latin) hatred accompanied by contempt [n]\n",
  "ODOGRAPH": "a device for measuring distance travelled, also ODOMETER [n -S]\n",
  "ODOGRAPHS": "ODOGRAPH, a device for measuring distance travelled, also ODOMETER [n]\n",
  "ODOMETER": "a device for measuring distance travelled, also ODOGRAPH [n -S]\n",
  "ODOMETERS": "ODOMETER, a device for measuring distance travelled, also ODOGRAPH [n]\n",
  "ODOMETRIES": "ODOMETRY, the process of using an odometer [n]\n",
  "ODOMETRY": "the process of using an odometer [n ODOMETRIES]\n",
  "ODONATA": "insects of an order of predacious insects that includes dragonflies [n]\n",
  "ODONATE": "any member of the order Odonata, dragonflies and damselflies [n -S]\n",
  "ODONATES": "ODONATE, any member of the order Odonata, dragonflies and damselflies [n]\n",
  "ODONATIST": "an expert on dragonflies [n -S]\n",
  "ODONATISTS": "ODONATIST, an expert on dragonflies [n]\n",
  "ODONATOLOGIES": "ODONATOLOGY, the study of dragonflies [n]\n",
  "ODONATOLOGIST": "one who studies dragonflies [n -S]\n",
  "ODONATOLOGISTS": "ODONATOLOGIST, one who studies dragonflies [n]\n",
  "ODONATOLOGY": "the study of dragonflies [n ODONATOLOGIES]\n",
  "ODONTALGIA": "toothache, also ODONTALGY [n -S]\n",
  "ODONTALGIAS": "ODONTALGIA, toothache, also ODONTALGY [n]\n",
  "ODONTALGIC": "of or pertaining to odontalgia, toothache [adj]\n",
  "ODONTALGIES": "ODONTALGY, toothache, also ODONTALGIA [n]\n",
  "ODONTALGY": "toothache, also ODONTALGIA [n ODONTALGIES]\n",
  "ODONTIC": "dental [adj]\n",
  "ODONTIST": "(jocular) a dentist [n -S]\n",
  "ODONTISTS": "ODONTIST, (jocular) a dentist [n]\n",
  "ODONTOBLAST": "a tooth cell in the surface of dental pulp that produces dentine [n -S]\n",
  "ODONTOBLASTIC": "of or like an odontoblast, a tooth cell in the surface of dental pulp that produces dentine [adj]\n",
  "ODONTOBLASTS": "ODONTOBLAST, a tooth cell in the surface of dental pulp that produces dentine [n]\n",
  "ODONTOCETE": "a subdivision of Cetacea, including the sperm whale, dolphins, etc.; the toothed whales [n -S]\n",
  "ODONTOCETES": "ODONTOCETE, a subdivision of Cetacea, including the sperm whale, dolphins, etc.; the toothed whales [n]\n",
  "ODONTOGENIC": "relating to odontogeny, the origin and development of teeth [adj]\n",
  "ODONTOGENIES": "ODONTOGENY, the origin and development of teeth [n]\n",
  "ODONTOGENY": "the origin and development of teeth [n ODONTOGENIES]\n",
  "ODONTOGLOSSUM": "any of a genus of widely cultivated tropical American orchids [n -S]\n",
  "ODONTOGLOSSUMS": "ODONTOGLOSSUM, any of a genus of widely cultivated tropical American orchids [n]\n",
  "ODONTOGRAPH": "an instrument for obtaining curves for gear-teeth [n -S]\n",
  "ODONTOGRAPHIES": "ODONTOGRAPHY, a description or history of teeth [n]\n",
  "ODONTOGRAPHS": "ODONTOGRAPH, an instrument for obtaining curves for gear-teeth [n]\n",
  "ODONTOGRAPHY": "a description or history of teeth [n ODONTOGRAPHIES]\n",
  "ODONTOID": "a toothlike projection from the second vertebra of the neck [n -S]\n",
  "ODONTOIDS": "ODONTOID, a toothlike projection from the second vertebra of the neck [n]\n",
  "ODONTOLITE": "a fossil bone or tooth coloured blue with phosphate of iron, aka bone-turquoise [n -S]\n",
  "ODONTOLITES": "ODONTOLITE, a fossil bone or tooth coloured blue with phosphate of iron, aka bone-turquoise [n]\n",
  "ODONTOLOGIC": "relating to odontology, also ODONTOLOGICAL [adj]\n",
  "ODONTOLOGICAL": "relating to odontology, also ODONTOLOGIC [adj]\n",
  "ODONTOLOGIES": "ODONTOLOGY, the study of teeth [n]\n",
  "ODONTOLOGIST": "a student of odontology [n -S]\n",
  "ODONTOLOGISTS": "ODONTOLOGIST, a student of odontology [n]\n",
  "ODONTOLOGY": "the study of teeth [n ODONTOLOGIES]\n",
  "ODONTOMA": "a tooth tumour [n ODONTOMAS or ODONTOMATA]\n",
  "ODONTOMAS": "ODONTOMA, a tooth tumour [n]\n",
  "ODONTOMATA": "ODONTOMA, a tooth tumour [n]\n",
  "ODONTOMATOUS": "like an odontoma, a tumour arising in connection with the teeth [adj]\n",
  "ODONTOPHOBIA": "the fear of teeth [n -S]\n",
  "ODONTOPHOBIAS": "ODONTOPHOBIA, the fear of teeth [n]\n",
  "ODONTOPHORAL": "of or like an odontophore, the rasping apparatus in molluscs, also ODONTOPHORAN [adj]\n",
  "ODONTOPHORAN": "an odontophore, the rasping apparatus in molluscs [n -S]\n",
  "ODONTOPHORANS": "ODONTOPHORAN, an odontophore, the rasping apparatus in molluscs [n]\n",
  "ODONTOPHORE": "the rasping apparatus in molluscs [n -S]\n",
  "ODONTOPHORES": "ODONTOPHORE, the rasping apparatus in molluscs [n]\n",
  "ODONTOPHOROUS": "of or like an odontophore, the rasping apparatus in molluscs [adj]\n",
  "ODONTORHYNCHOUS": "of birds, having toothlike ridges inside the beak [adj]\n",
  "ODONTORNITHES": "fossil birds with teeth [n]\n",
  "ODONTOSTOMATOUS": "having biting or toothed jaws [adj]\n",
  "ODOR": "any smell, whether fragrant or offensive, also ODOUR [n -S]\n",
  "ODORANT": "an odorous substance [n -S]\n",
  "ODORANTS": "ODORANT, an odorous substance [n]\n",
  "ODORATE": "emitting a smell [adj]\n",
  "ODORED": "having an odor, also ODOURED [adj]\n",
  "ODORFUL": "strong smelling, also ODOURFUL [adj]\n",
  "ODORIFEROUS": "giving off an odour; morally offensive, also ODIFEROUS [adj ODORIFEROUSLY]\n",
  "ODORIFEROUSLY": "ODORIFEROUS, giving off an odour; morally offensive, also ODIFEROUS [adv]\n",
  "ODORIFEROUSNESS": "ODORIFEROUS, giving off an odour; morally offensive, also ODIFEROUS [n]\n",
  "ODORIMETRIES": "ODORIMETRY, the measurement of the strength and persistence of odours [n]\n",
  "ODORIMETRY": "the measurement of the strength and persistence of odours [n ODORIMETRIES]\n",
  "ODORIPHORE": "the group of atoms in an odorous molecule responsible for its odour [n -S]\n",
  "ODORIPHORES": "ODORIPHORE, the group of atoms in an odorous molecule responsible for its odour [n]\n",
  "ODORISE": "to make odorous, also ODORIZE [v ODORISED, ODORISING, ODORISES]\n",
  "ODORISED": "ODORISE, to make odorous, also ODORIZE [v]\n",
  "ODORISER": "something that odorises, also ODORIZER [n -S]\n",
  "ODORISERS": "ODORISER, something that odorises, also ODORIZER [n]\n",
  "ODORISES": "ODORISE, to make odorous, also ODORIZE [v]\n",
  "ODORISING": "ODORISE, to make odorous, also ODORIZE [v]\n",
  "ODORIZE": "to make odorous, also ODORISE [v ODORIZED, ODORIZING, ODORIZES]\n",
  "ODORIZED": "ODORIZE, to make odorous, also ODORISE [v]\n",
  "ODORIZER": "something that odorizes, also ODORISER [n -S]\n",
  "ODORIZERS": "ODORIZER, something that odorizes, also ODORISER [n]\n",
  "ODORIZES": "ODORIZE, to make odorous, also ODORISE [v]\n",
  "ODORIZING": "ODORIZE, to make odorous, also ODORISE [v]\n",
  "ODORLESS": "without odor, also ODOURLESS [adj]\n",
  "ODOROUS": "having an odor [adj ODOROUSLY]\n",
  "ODOROUSLY": "ODOROUS, having an odor [adv]\n",
  "ODOROUSNESS": "the state of being odorous [n -ES]\n",
  "ODOROUSNESSES": "ODOROUSNESS, the state of being odorous [n]\n",
  "ODORS": "ODOR, any smell, whether fragrant or offensive, also ODOUR [n]\n",
  "ODOUR": "any smell, whether fragrant or offensive, also ODOR [n -S]\n",
  "ODOURED": "having an odour [adj]\n",
  "ODOURFUL": "strong smelling, also ODORFUL [adj]\n",
  "ODOURLESS": "without odour, also ODORLESS [adj]\n",
  "ODOURS": "ODOUR, any smell, whether fragrant or offensive, also ODOR [n]\n",
  "ODS": "OD, a hypothetical force supposed by Reichenbach to account for magnetism etc. [n]\n",
  "ODSO": "an expression of surprise [interj]\n",
  "ODYL": "a mystical pervasive force, also OD, ODYLE [n -S]\n",
  "ODYLE": "a mystical pervasive force, also OD, ODYL [n -S]\n",
  "ODYLES": "ODYLE, a mystical pervasive force, also OD, ODYL [n]\n",
  "ODYLISM": "belief in the power of od, also ODISM [n -S]\n",
  "ODYLISMS": "ODYLISM, belief in the power of od, also ODISM [n]\n",
  "ODYLS": "ODYL, a mystical pervasive force, also OD, ODYLE [n]\n",
  "ODYSSEAN": "of or like an odyssey, a long wandering journey [adj]\n",
  "ODYSSEY": "(Greek) a long wandering usually marked by many changes of fortune [n -S]\n",
  "ODYSSEYS": "ODYSSEY, (Greek) a long wandering usually marked by many changes of fortune [n]\n",
  "ODZOOKS": "a mild oath, also GADZOOKS, ZOOKS [interj]\n",
  "OE": "(Scots) a grandchild, also OY, OYE [n -S]\n",
  "OECIST": "(historical) the founder of a colony, also OIKIST [n -S]\n",
  "OECISTS": "OECIST, (historical) the founder of a colony, also OIKIST [n]\n",
  "OECOLOGIC": "relating to oecology, also ECOLOGIC, ECOLOGICAL, OECOLOGICAL [adj OECOLOGICALLY]\n",
  "OECOLOGICAL": "relating to ecology, also ECOLOGIC, ECOLOGICAL, OECOLOGIC [adj OECOLOGICALLY]\n",
  "OECOLOGICALLY": "OECOLOGICAL, relating to ecology, also ECOLOGIC, ECOLOGICAL, OECOLOGIC [adv]\n",
  "OECOLOGIES": "OECOLOGY, the study of the interrelationships between life forms and their environment, also ECOLOGY [n]\n",
  "OECOLOGIST": "a student of oecology, also ECOLOGIST [n -S]\n",
  "OECOLOGISTS": "OECOLOGIST, a student of oecology, also ECOLOGIST [n]\n",
  "OECOLOGY": "the study of the interrelationships between life forms and their environment, also ECOLOGY [n OECOLOGIES]\n",
  "OECUMENIC": "general; universal; in ecclesiastical usage, that which concerns the whole church, also ECUMENIC, ECUMENICAL, OECUMENICAL [adj OECUMENICALLY]\n",
  "OECUMENICAL": "general; universal; in ecclesiastical usage, that which concerns the whole church, also ECUMENIC, ECUMENICAL, OECUMENIC [adj OECUMENICALLY]\n",
  "OECUMENICALLY": "OECUMENICAL, general; universal; in ecclesiastical usage, that which concerns the whole church, also ECUMENIC, ECUMENICAL, OECUMENIC [adv]\n",
  "OEDEMA": "(Greek) a pathological accumulation of fluid in tissue spaces, also EDEMA [n OEDEMAS or OEDEMATA]\n",
  "OEDEMAS": "OEDEMA, (Greek) a pathological accumulation of fluid in tissue spaces, also EDEMA [n]\n",
  "OEDEMATA": "OEDEMA, (Greek) a pathological accumulation of fluid in tissue spaces, also EDEMA [n]\n",
  "OEDEMATOSE": "pertaining to, or of the nature of, oedema, also EDEMATOSE, EDEMATOUS, OEDEMATOUS [adj]\n",
  "OEDEMATOUS": "pertaining to, or of the nature of, oedema, also EDEMATOSE, EDEMATOUS, OEDEMATOSE [adj]\n",
  "OEDIPAL": "pertaining to the libidinous feelings of a son towards his mother, also OEDIPEAN [adj OEDIPALLY]\n",
  "OEDIPALLY": "OEDIPAL, pertaining to the libidinous feelings of a son towards his mother, also OEDIPEAN [adv]\n",
  "OEDIPEAN": "pertaining to the libidinous feelings of a son towards his mother, also OEDIPAL [adj]\n",
  "OEDOMETER": "an instrument for measuring the consolidation of a soil specimen under pressure [n -S]\n",
  "OEDOMETERS": "OEDOMETER, an instrument for measuring the consolidation of a soil specimen under pressure [n]\n",
  "OEILLADE": "(French) an amorous glance, also ELIAD, EYELIAD, EYLIAD, ILLIAD [n -S]\n",
  "OEILLADES": "OEILLADE, (French) an amorous glance, also ELIAD, EYELIAD, EYLIAD, ILLIAD [n]\n",
  "OENANTHIC": "having or imparting the characteristic odour of wine [adj]\n",
  "OENOLOGICAL": "relating to oenology, the study of wine, also ENOLOGICAL [adj]\n",
  "OENOLOGIES": "OENOLOGY, the science dealing with wine and winemaking, also ENOLOGY, OINOLOGY [n]\n",
  "OENOLOGIST": "one versed in oenology, a student of wine [n -S]\n",
  "OENOLOGISTS": "OENOLOGIST, one versed in oenology, a student of wine [n]\n",
  "OENOLOGY": "the science dealing with wine and winemaking, also ENOLOGY, OINOLOGY [n OENOLOGIES]\n",
  "OENOMANCIES": "OENOMANCY, divination by studying the appearance of wine [n]\n",
  "OENOMANCY": "divination by studying the appearance of wine [n OENOMANCIES]\n",
  "OENOMANIA": "an obsession or craze for wine [n -S]\n",
  "OENOMANIAS": "OENOMANIA, an obsession or craze for wine [n]\n",
  "OENOMEL": "(Greek) an ancient Greek beverage, also OINOMEL [n -S]\n",
  "OENOMELS": "OENOMEL, (Greek) an ancient Greek beverage, also OINOMEL [n]\n",
  "OENOMETER": "an instrument for measuring alcoholic strength of wine [n -S]\n",
  "OENOMETERS": "OENOMETER, an instrument for measuring alcoholic strength of wine [n]\n",
  "OENOPHIL": "a wine connoisseur, also ENOPHILE, OENOPHILE [n -S]\n",
  "OENOPHILE": "a wine connoisseur, also ENOPHILE, OENOPHIL [n -S]\n",
  "OENOPHILES": "OENOPHILE, a wine connoisseur, also ENOPHILE, OENOPHIL [n]\n",
  "OENOPHILIES": "OENOPHILY, the love of wine [n]\n",
  "OENOPHILIST": "lover of wine [n -S]\n",
  "OENOPHILISTS": "OENOPHILIST, lover of wine [n]\n",
  "OENOPHILS": "OENOPHIL, a wine connoisseur, also ENOPHILE, OENOPHILE [n]\n",
  "OENOPHILY": "the love of wine [n OENOPHILIES]\n",
  "OENOTHERA": "a type of South American plant with yellow flowers that open in the evening [n -S]\n",
  "OENOTHERAS": "OENOTHERA, a type of South American plant with yellow flowers that open in the evening [n]\n",
  "OERLIKON": "(Swiss) a type of antiaircraft cannon [n -S]\n",
  "OERLIKONS": "OERLIKON, (Swiss) a type of antiaircraft cannon [n]\n",
  "OERSTED": "a unit of magnetic intensity [n -S]\n",
  "OERSTEDS": "OERSTED, a unit of magnetic intensity [n]\n",
  "OES": "OE, (Scots) a grandchild, also OY, OYE [n]\n",
  "OESOPHAGEAL": "pertaining to the esophagus, also ESOPHAGEAL [adj]\n",
  "OESOPHAGI": "OESOPHAGUS, that portion of the gut which connects the pharynx to the stomach, also ESOPHAGUS [n]\n",
  "OESOPHAGITIS": "inflammation of the oesophagus, also ESOPHAGITIS [n -ES]\n",
  "OESOPHAGITISES": "OESOPHAGITIS, inflammation of the oesophagus, also ESOPHAGITIS [n]\n",
  "OESOPHAGOSCOPE": "an instrument for examining the oesophagus [n -S]\n",
  "OESOPHAGOSCOPES": "OESOPHAGOSCOPE, an instrument for examining the oesophagus [n]\n",
  "OESOPHAGOSCOPY": "examination of the oesophagus, also ESOPHAGOSCOPY [n]\n",
  "OESOPHAGUS": "that portion of the gut which connects the pharynx to the stomach, also ESOPHAGUS [n OESOPHAGI or OESOPHAGUSES]\n",
  "OESOPHAGUSES": "OESOPHAGUS, that portion of the gut which connects the pharynx to the stomach, also ESOPHAGUS [n]\n",
  "OESTRADIOL": "a natural oestrogen also synthesised for use in cancer treatment [n -S]\n",
  "OESTRADIOLS": "OESTRADIOL, a natural oestrogen also synthesised for use in cancer treatment [n]\n",
  "OESTRAL": "pertaining to oestrus, a period of sexual excitement and ovulation in animals, also ESTRAL, ESTROUS, OESTROUS, ESTRUAL [adj]\n",
  "OESTRIN": "an estrogen, also ESTRIN, ESTRONE, OESTRONE [n -S]\n",
  "OESTRINS": "OESTRIN, an estrogen, also ESTRIN, ESTRONE, OESTRONE [n]\n",
  "OESTRIOL": "an estrogen, also ESTRIOL [n -S]\n",
  "OESTRIOLS": "OESTRIOL, an estrogen, also ESTRIOL [n]\n",
  "OESTROGEN": "a female sex-hormone, also ESTROGEN [n -S]\n",
  "OESTROGENIC": "producing female sex hormones, also ESTROGENIC [adj OESTROGENICALLY]\n",
  "OESTROGENICALLY": "OESTROGENIC, producing female sex hormones, also ESTROGENIC [adv]\n",
  "OESTROGENS": "OESTROGEN, a female sex-hormone, also ESTROGEN [n]\n",
  "OESTRONE": "an estrogen, also ESTRIN, ESTRONE, OESTRIN [n -S]\n",
  "OESTRONES": "OESTRONE, an estrogen, also ESTRIN, ESTRONE, OESTRIN [n]\n",
  "OESTROUS": "pertaining to oestrus, a period of sexual excitement and ovulation in animals, also ESTRAL, ESTROUS, ESTRUAL, OESTRAL [adj]\n",
  "OESTRUAL": "pertaining to oestrus, a period of sexual excitement and ovulation in animals, also ESTRAL, ESTROUS, OESTRAL, OESTROUS [adj]\n",
  "OESTRUM": "(Latin) the period of heat in female mammals, also ESTRUM, ESTRUS, OESTRUS [n -S]\n",
  "OESTRUMS": "OESTRUM, (Latin) the period of heat in female mammals, also ESTRUM, ESTRUS, OESTRUS [n]\n",
  "OESTRUS": "(Latin) the period of heat in female mammals, also ESTRUM, OESTRUM, ESTRUS [n -ES]\n",
  "OESTRUSES": "OESTRUS, (Latin) the period of heat in female mammals, also ESTRUM, OESTRUM, ESTRUS [n]\n",
  "OEUVRE": "(French) the sum of an artist's life work [n -S]\n",
  "OEUVRES": "OEUVRE, (French) the sum of an artist's life work [n]\n",
  "OF": "belonging to [prep]\n",
  "OFAY": "(offensive US slang) a white person [n -S]\n",
  "OFAYS": "OFAY, (offensive US slang) a white person [n]\n",
  "OFF": "to go away [v -ED, -ING, -S]\n",
  "OFFA": "off, off from [prep]\n",
  "OFFAL": "waste or rejected parts, esp. of a carcase [n -S]\n",
  "OFFALS": "OFFAL, waste or rejected parts, esp. of a carcase [n]\n",
  "OFFBEAT": "an unaccented beat in a musical measure [n -S]\n",
  "OFFBEATS": "OFFBEAT, an unaccented beat in a musical measure [n]\n",
  "OFFCAST": "an item of clothing one no longer wishes to wear, and passes on to another, also CASTOFF [n -S]\n",
  "OFFCASTS": "OFFCAST, an item of clothing one no longer wishes to wear, and passes on to another, also CASTOFF [n]\n",
  "OFFCUT": "a small piece cut off or left over from a larger piece of some material [n -S]\n",
  "OFFCUTS": "OFFCUT, a small piece cut off or left over from a larger piece of some material [n]\n",
  "OFFED": "OFF, to go away [v]\n",
  "OFFENCE": "a transgression [n -S]\n",
  "OFFENCEFUL": "(Shakespeare) giving offence, injurious [adj]\n",
  "OFFENCELESS": "(Milton) without giving offence, innocent [adj]\n",
  "OFFENCES": "OFFENCE, a transgression [n]\n",
  "OFFEND": "to commit a violation [v -ED, -ING, -S]\n",
  "OFFENDED": "OFFEND, to commit a violation [v]\n",
  "OFFENDEDLY": "OFFENDED, OFFEND, to commit a violation [adv]\n",
  "OFFENDER": "one who offends [n -S]\n",
  "OFFENDERS": "OFFENDER, one who offends [n]\n",
  "OFFENDING": "OFFEND, to commit a violation [v]\n",
  "OFFENDRESS": "(Shakespeare) a female offender [n -ES]\n",
  "OFFENDRESSES": "OFFENDRESS, (Shakespeare) a female offender [n]\n",
  "OFFENDS": "OFFEND, to commit a violation [v]\n",
  "OFFENSE": "(US) an offence, a violation of a moral or social code [n -S]\n",
  "OFFENSELESS": "without offense [adj]\n",
  "OFFENSES": "OFFENSE, (US) an offence, a violation of a moral or social code [n]\n",
  "OFFENSIVE": "causing offence [adj OFFENSIVELY] / a military attack [n -S]\n",
  "OFFENSIVELY": "OFFENSIVE, causing offence [adv]\n",
  "OFFENSIVENESS": "the state of being offensive [n -ES]\n",
  "OFFENSIVENESSES": "OFFENSIVENESS, the state of being offensive [n]\n",
  "OFFENSIVES": "OFFENSIVE, a military attack [n]\n",
  "OFFER": "to present for consideration [v -ED, -ING, -S]\n",
  "OFFERABLE": "capable of being offered; suitable or worthy to be offered [adj]\n",
  "OFFERED": "OFFER, to present for consideration [v]\n",
  "OFFEREE": "someone who is offered something [n -S]\n",
  "OFFEREES": "OFFEREE, someone who is offered something [n]\n",
  "OFFERER": "one who offers, also OFFEROR [n -S]\n",
  "OFFERERS": "OFFERER, one who offers, also OFFEROR [n]\n",
  "OFFERING": "a contribution [n -S]\n",
  "OFFERINGS": "OFFERING, a contribution [n]\n",
  "OFFEROR": "one who offers, also OFFERER [n -S]\n",
  "OFFERORS": "OFFEROR, one who offers, also OFFERER [n]\n",
  "OFFERS": "OFFER, to present for consideration [v]\n",
  "OFFERTORIES": "OFFERTORY, the part of the Eucharist during which the bread and wine are placed on the altar and any collection is taken [n]\n",
  "OFFERTORY": "the part of the Eucharist during which the bread and wine are placed on the altar and any collection is taken [n OFFERTORIES]\n",
  "OFFHAND": "ungraciously curt, also OFFHANDED [adj]\n",
  "OFFHANDED": "ungraciously curt, also OFFHAND [adj OFFHANDEDLY]\n",
  "OFFHANDEDLY": "OFFHANDED, ungraciously curt, also OFFHAND [adv]\n",
  "OFFHANDEDNESS": "the state of being offhanded [n -ES]\n",
  "OFFHANDEDNESSES": "OFFHANDEDNESS, the state of being offhanded [n]\n",
  "OFFICE": "a position of authority [n -S]\n",
  "OFFICEHOLDER": "one holding a public office [n -S]\n",
  "OFFICEHOLDERS": "OFFICEHOLDER, one holding a public office [n]\n",
  "OFFICER": "to command or lead [v -ED, -ING, -S]\n",
  "OFFICERED": "OFFICER, to command or lead [v]\n",
  "OFFICERING": "OFFICER, to command or lead [v]\n",
  "OFFICERS": "OFFICER, to command or lead [v]\n",
  "OFFICES": "OFFICE, a position of authority [n]\n",
  "OFFICIAL": "sanctioned by authority [adj OFFICIALLY] / one that holds a position of authority [n -S]\n",
  "OFFICIALDOM": "officials as a class [n -S]\n",
  "OFFICIALDOMS": "OFFICIALDOM, officials as a class [n]\n",
  "OFFICIALESE": "the characteristic language of official statements [n -S]\n",
  "OFFICIALESES": "OFFICIALESE, the characteristic language of official statements [n]\n",
  "OFFICIALISM": "excessive devotion to routine or position [n -S]\n",
  "OFFICIALISMS": "OFFICIALISM, excessive devotion to routine or position [n]\n",
  "OFFICIALITIES": "OFFICIALITY, the charge, office, court, or jurisdiction of an official, also OFFICIALTY [n]\n",
  "OFFICIALITY": "the charge, office, court, or jurisdiction of an official, also OFFICIALTY [n OFFICIALITIES]\n",
  "OFFICIALLY": "OFFICIAL, sanctioned by authority [adv]\n",
  "OFFICIALS": "OFFICIAL, one that holds a position of authority [n]\n",
  "OFFICIALTIES": "OFFICIALTY, the charge, office, court, or jurisdiction of an official, also OFFICIALITY [n]\n",
  "OFFICIALTY": "the charge, office, court, or jurisdiction of an official, also OFFICIALITY [n OFFICIALTIES]\n",
  "OFFICIANT": "the officer who officiates or performs an office, as the burial office [n -S]\n",
  "OFFICIANTS": "OFFICIANT, the officer who officiates or performs an office, as the burial office [n]\n",
  "OFFICIARIES": "OFFICIARY, a body of officers; an official body [n]\n",
  "OFFICIARY": "a body of officers; an official body [n OFFICIARIES]\n",
  "OFFICIATE": "to perform the duties of an office [v OFFICIATED, OFFICIATING, OFFICIATES]\n",
  "OFFICIATED": "OFFICIATE, to perform the duties of an office [v]\n",
  "OFFICIATES": "OFFICIATE, to perform the duties of an office [v]\n",
  "OFFICIATING": "OFFICIATE, to perform the duties of an office [v]\n",
  "OFFICIATION": "the act of officiating [n -S]\n",
  "OFFICIATIONS": "OFFICIATION, the act of officiating [n]\n",
  "OFFICIATOR": "one who officiates [n -S]\n",
  "OFFICIATORS": "OFFICIATOR, one who officiates [n]\n",
  "OFFICINAL": "tending or used to cure disease or relieve pain [adj OFFICINALLY] / a medicine sold on prescription [n -S]\n",
  "OFFICINALLY": "OFFICINAL, tending or used to cure disease or relieve pain [adv]\n",
  "OFFICINALS": "OFFICINAL, a medicine sold on prescription [n]\n",
  "OFFICIOUS": "volunteering one's services too eagerly [adj OFFICIOUSLY]\n",
  "OFFICIOUSLY": "OFFICIOUS, volunteering one's services too eagerly [adv]\n",
  "OFFICIOUSNESS": "OFFICIOUS, volunteering one's services too eagerly [n]\n",
  "OFFICIOUSNESSES": "OFFICIOUSNESS, OFFICIOUS, volunteering one's services too eagerly [n]\n",
  "OFFIE": "(slang) an off-licence, also OFFY [n -S]\n",
  "OFFIES": "OFFIE, (slang) an off-licence, also OFFY [n]\n",
  "OFFING": "that part of the sea that is visible from the shore but beyond anchoring ground [n -S]\n",
  "OFFINGS": "OFFING, that part of the sea that is visible from the shore but beyond anchoring ground [n]\n",
  "OFFISH": "shy or distant in manner [adj OFFISHLY]\n",
  "OFFISHLY": "OFFISH, shy or distant in manner [adv]\n",
  "OFFISHNESS": "the state of being offish [n -ES]\n",
  "OFFISHNESSES": "OFFISHNESS, the state of being offish [n]\n",
  "OFFKEY": "out of tune [adj]\n",
  "OFFLINE": "taking place when the computer is not connected to a network e.g. the Internet [adj]\n",
  "OFFLOAD": "to unload [v -ED, -ING, -S]\n",
  "OFFLOADED": "OFFLOAD, to unload [v]\n",
  "OFFLOADING": "OFFLOAD, to unload [v]\n",
  "OFFLOADS": "OFFLOAD, to unload [v]\n",
  "OFFPEAK": "not at the time of highest demand [adj]\n",
  "OFFPRINT": "to reprint an excerpt [v -ED, -ING, -S]\n",
  "OFFPRINTED": "OFFPRINT, to reprint an excerpt [v]\n",
  "OFFPRINTING": "OFFPRINT, to reprint an excerpt [v]\n",
  "OFFPRINTS": "OFFPRINT, to reprint an excerpt [v]\n",
  "OFFPUT": "(Scots) the act of putting off [n -S]\n",
  "OFFPUTS": "OFFPUT, (Scots) the act of putting off [n]\n",
  "OFFRAMP": "a road leading off an expressway [n -S]\n",
  "OFFRAMPS": "OFFRAMP, a road leading off an expressway [n]\n",
  "OFFS": "OFF, to go away [v]\n",
  "OFFSADDLE": "to unsaddle [v OFFSADDLED, OFFSADDLING, OFFSADDLES]\n",
  "OFFSADDLED": "OFFSADDLE, to unsaddle [v]\n",
  "OFFSADDLES": "OFFSADDLE, to unsaddle [v]\n",
  "OFFSADDLING": "OFFSADDLE, to unsaddle [v]\n",
  "OFFSCOURING": "someone rejected by society [n -S]\n",
  "OFFSCOURINGS": "OFFSCOURING, someone rejected by society [n]\n",
  "OFFSCREEN": "in a film, not actually shown on the screen [adj]\n",
  "OFFSCUM": "scum, refuse [n -S]\n",
  "OFFSCUMS": "OFFSCUM, scum, refuse [n]\n",
  "OFFSEASON": "the season when there is no play, or no hunting [n -S]\n",
  "OFFSEASONS": "OFFSEASON, the season when there is no play, or no hunting [n]\n",
  "OFFSET": "to compensate for [v OFFSET, OFFSETTING, OFFSETS]\n",
  "OFFSETABLE": "that can be offset [adj]\n",
  "OFFSETS": "OFFSET, to compensate for [v]\n",
  "OFFSETTING": "the act of setting something off against e.g. a debt [n -S]\n",
  "OFFSETTINGS": "OFFSETTING, the act of setting something off against e.g. a debt [n]\n",
  "OFFSHOOT": "a lateral shoot from a main stem [n -S]\n",
  "OFFSHOOTS": "OFFSHOOT, a lateral shoot from a main stem [n]\n",
  "OFFSHORE": "to transfer jobs to another country [v OFFSHORED, OFFSHORING, OFFSHORES]\n",
  "OFFSHORED": "OFFSHORE, to transfer jobs to another country [v]\n",
  "OFFSHORES": "OFFSHORE, to transfer jobs to another country [v]\n",
  "OFFSHORING": "the practice of substituting foreign labour for domestic [n -S]\n",
  "OFFSHORINGS": "OFFSHORING, the practice of substituting foreign labour for domestic [n]\n",
  "OFFSIDE": "between the ball, or the last player who had it, and the opponents' goal [adj] / that part of the pitch where this can happen [n -S]\n",
  "OFFSIDER": "(Australian) a bullock-driver's assistant [n -S]\n",
  "OFFSIDERS": "OFFSIDER, (Australian) a bullock-driver's assistant [n]\n",
  "OFFSIDES": "OFFSIDE, that part of the pitch where this can happen [n]\n",
  "OFFSPRING": "progeny [n -S]\n",
  "OFFSPRINGS": "OFFSPRING, progeny [n]\n",
  "OFFSTAGE": "the part of the stage not visible to the audience [n -S]\n",
  "OFFSTAGES": "OFFSTAGE, the part of the stage not visible to the audience [n]\n",
  "OFFTAKE": "a pipe or channel for removing fluid [n -S]\n",
  "OFFTAKES": "OFFTAKE, a pipe or channel for removing fluid [n]\n",
  "OFFTRACK": "away from a racetrack [adj]\n",
  "OFFY": "(slang) an off-licence, also OFFIE [n OFFIES]\n",
  "OFLAG": "(German) a prisoner of war camp for officers [n -S]\n",
  "OFLAGS": "OFLAG, (German) a prisoner of war camp for officers [n]\n",
  "OFT": "often [adv OFTER, OFTEST]\n",
  "OFTEN": "happening many times [adv OFTENER, OFTENEST]\n",
  "OFTENER": "OFTEN, happening many times [adv]\n",
  "OFTENEST": "OFTEN, happening many times [adv]\n",
  "OFTENNESS": "frequency [n -ES]\n",
  "OFTENNESSES": "OFTENNESS, frequency [n]\n",
  "OFTENTIMES": "often, repeatedly, also OFTTIMES [adv]\n",
  "OFTER": "OFT, often [adv]\n",
  "OFTEST": "OFT, often [adv]\n",
  "OFTTIMES": "often, also OFTENTIMES [adv]\n",
  "OGAM": "(Irish) a 6th century Irish writing alphabet, also OGHAM [n -S]\n",
  "OGAMIC": "written using ogam, also OGMIC [adj]\n",
  "OGAMS": "OGAM, (Irish) a 6th century Irish writing alphabet, also OGHAM [n]\n",
  "OGANESSON": "a highly radioactive element, of which only a few atoms have ever been produced [n -S]\n",
  "OGANESSONS": "OGANESSON, a highly radioactive element, of which only a few atoms have ever been produced [n]\n",
  "OGDOAD": "a group of eight [n -S]\n",
  "OGDOADS": "OGDOAD, a group of eight [n]\n",
  "OGEE": "an arch of two curves meeting at a point [n -S]\n",
  "OGEED": "having an ogee [adj]\n",
  "OGEES": "OGEE, an arch of two curves meeting at a point [n]\n",
  "OGGIN": "(slang) naval slang for the sea [n -S]\n",
  "OGGINS": "OGGIN, (slang) naval slang for the sea [n]\n",
  "OGHAM": "(Irish) a 6th century Irish writing alphabet, also OGAM [n -S]\n",
  "OGHAMIC": "of or like ogham, also OGAMIC, OGMIC [adj]\n",
  "OGHAMIST": "one who writes in ogham [n -S]\n",
  "OGHAMISTS": "OGHAMIST, one who writes in ogham [n]\n",
  "OGHAMS": "OGHAM, (Irish) a 6th century Irish writing alphabet, also OGAM [n]\n",
  "OGIVAL": "of or like an ogive [adj]\n",
  "OGIVE": "a pointed arch [n -S]\n",
  "OGIVES": "OGIVE, a pointed arch [n]\n",
  "OGLE": "to stare at lecherously [v OGLED, OGLING, OGLES]\n",
  "OGLED": "OGLE, to stare at lecherously [v]\n",
  "OGLER": "one who ogles [n -S]\n",
  "OGLERS": "OGLER, one who ogles [n]\n",
  "OGLES": "OGLE, to stare at lecherously [v]\n",
  "OGLING": "the act of ogling [n -S]\n",
  "OGLINGS": "OGLING, the act of ogling [n]\n",
  "OGMIC": "relating to ogam, a 6th century Irish writing alphabet, also OGAMIC, OGHAMIC [adj]\n",
  "OGRE": "a cannibalistic giant [n -S]\n",
  "OGREISH": "resembling an ogre, also OGRISH [adj OGREISHLY]\n",
  "OGREISHLY": "OGREISH, resembling an ogre, also OGRISH [adv]\n",
  "OGREISM": "the state of being ogreish, also OGRISM [n -S]\n",
  "OGREISMS": "OGREISM, the state of being ogreish, also OGRISM [n]\n",
  "OGRES": "OGRE, a cannibalistic giant [n]\n",
  "OGRESS": "a female ogre [n -ES]\n",
  "OGRESSES": "OGRESS, a female ogre [n]\n",
  "OGRISH": "resembling an ogre, also OGREISH [adj OGRISHLY]\n",
  "OGRISHLY": "OGRISH, resembling an ogre, also OGREISH [adv]\n",
  "OGRISM": "the state of being ogreish, also OGREISM [n -S]\n",
  "OGRISMS": "OGRISM, the state of being ogreish, also OGREISM [n]\n",
  "OH": "to exclaim in surprise [v -ED, -ING, -S]\n",
  "OHED": "OH, to exclaim in surprise [v]\n",
  "OHIA": "(Hawaiian) a Polynesian tree of the myrtle family with bright red flowers, aka lehua [n -S]\n",
  "OHIAS": "OHIA, (Hawaiian) a Polynesian tree of the myrtle family with bright red flowers, aka lehua [n]\n",
  "OHING": "OH, to exclaim in surprise [v]\n",
  "OHM": "a unit of electrical resistance [n -S]\n",
  "OHMAGE": "electrical resistance expressed in ohms [n -S]\n",
  "OHMAGES": "OHMAGE, electrical resistance expressed in ohms [n]\n",
  "OHMIC": "of or pertaining to electrical resistance [adj OHMICALLY]\n",
  "OHMICALLY": "OHMIC, of or pertaining to electrical resistance [adv]\n",
  "OHMMETER": "an instrument for measuring ohmage [n -S]\n",
  "OHMMETERS": "OHMMETER, an instrument for measuring ohmage [n]\n",
  "OHMS": "OHM, a unit of electrical resistance [n]\n",
  "OHO": "an expression of surprise [interj]\n",
  "OHONE": "(Irish) an Irish interjection of lamentation, also OCHONE [interj]\n",
  "OHS": "OH, to exclaim in surprise [v]\n",
  "OI": "a New Zealand bird, the grey-faced petrel [n -S]\n",
  "OIDIA": "OIDIUM, (Greek) a thin-walled fungal spore [n]\n",
  "OIDIOID": "relating to an oidium [adj]\n",
  "OIDIUM": "(Greek) a thin-walled fungal spore [n OIDIA]\n",
  "OIK": "an inferior person [n -S]\n",
  "OIKIST": "(historical) the founder of a colony, also OECIST [n -S]\n",
  "OIKISTS": "OIKIST, (historical) the founder of a colony, also OECIST [n]\n",
  "OIKS": "OIK, an inferior person [n]\n",
  "OIL": "to lubricate with a greasy substance [v -ED, -ING, -S]\n",
  "OILBIRD": "a nocturnal bird of South America and Trinidad, aka guacharo [n -S]\n",
  "OILBIRDS": "OILBIRD, a nocturnal bird of South America and Trinidad, aka guacharo [n]\n",
  "OILCAMP": "a living area for workers at an oil well [n -S]\n",
  "OILCAMPS": "OILCAMP, a living area for workers at an oil well [n]\n",
  "OILCAN": "a can containing oil [n -S]\n",
  "OILCANS": "OILCAN, a can containing oil [n]\n",
  "OILCLOTH": "a fabric, usually of cotton, waterproofed with an oil or resin and used for clothing etc. [n -S]\n",
  "OILCLOTHS": "OILCLOTH, a fabric, usually of cotton, waterproofed with an oil or resin and used for clothing etc. [n]\n",
  "OILCUP": "a closed cup for supplying lubricant [n -S]\n",
  "OILCUPS": "OILCUP, a closed cup for supplying lubricant [n]\n",
  "OILED": "OIL, to lubricate with a greasy substance [v]\n",
  "OILER": "someone who or something that oils [n -S]\n",
  "OILERIES": "OILERY, an oil business [n]\n",
  "OILERS": "OILER, someone who or something that oils [n]\n",
  "OILERY": "an oil business [n OILERIES]\n",
  "OILFIELD": "an area of mineral oil production [n -S]\n",
  "OILFIELDS": "OILFIELD, an area of mineral oil production [n]\n",
  "OILFIRED": "using oil as fuel [adj]\n",
  "OILGAS": "a gaseous mixture of hydrocarbons used as a fuel [n -ES]\n",
  "OILGASES": "OILGAS, a gaseous mixture of hydrocarbons used as a fuel [n]\n",
  "OILHOLE": "a hole through which oil is injected [n -S]\n",
  "OILHOLES": "OILHOLE, a hole through which oil is injected [n]\n",
  "OILIER": "OILY, covered in oil [adj]\n",
  "OILIEST": "OILY, covered in oil [adj]\n",
  "OILILY": "OILY, covered in oil [adv]\n",
  "OILINESS": "the state of being oily [n -ES]\n",
  "OILINESSES": "OILINESS, the state of being oily [n]\n",
  "OILING": "OIL, to lubricate with a greasy substance [v]\n",
  "OILLET": "(obsolete) an eyelet [n -S]\n",
  "OILLETS": "OILLET, (obsolete) an eyelet [n]\n",
  "OILMAN": "one who owns or operates an oil well [n OILMEN]\n",
  "OILMEN": "OILMAN, one who owns or operates an oil well [n]\n",
  "OILNUT": "a North American butternut [n -S]\n",
  "OILNUTS": "OILNUT, a North American butternut [n]\n",
  "OILPAN": "(US) a sump [n -S]\n",
  "OILPANS": "OILPAN, (US) a sump [n]\n",
  "OILPAPER": "paper which has been oiled, e.g. to make it waterproof [n -S]\n",
  "OILPAPERS": "OILPAPER, paper which has been oiled, e.g. to make it waterproof [n]\n",
  "OILPROOF": "impervious to oil [adj]\n",
  "OILS": "OIL, to lubricate with a greasy substance [v]\n",
  "OILSEED": "a kind of rape, the seeds of which contain oil [n -S]\n",
  "OILSEEDS": "OILSEED, a kind of rape, the seeds of which contain oil [n]\n",
  "OILSKIN": "a waterproof fabric [n -S]\n",
  "OILSKINS": "OILSKIN, a waterproof fabric [n]\n",
  "OILSTONE": "a stone for sharpening tools [n -S]\n",
  "OILSTONES": "OILSTONE, a stone for sharpening tools [n]\n",
  "OILTIGHT": "having the ability to exclude oil [adj]\n",
  "OILWAY": "a channel for the passage of oil [n -S]\n",
  "OILWAYS": "OILWAY, a channel for the passage of oil [n]\n",
  "OILY": "covered in oil [adj OILIER, OILIEST, OILILY]\n",
  "OINK": "to grunt like a hog [v -ED, -ING, -S]\n",
  "OINKED": "OINK, to grunt like a hog [v]\n",
  "OINKING": "OINK, to grunt like a hog [v]\n",
  "OINKS": "OINK, to grunt like a hog [v]\n",
  "OINOLOGIES": "OINOLOGY, the study of wines, also OENOLOGY, ENOLOGY [n]\n",
  "OINOLOGY": "the study of wines, also OENOLOGY, ENOLOGY [n OINOLOGIES]\n",
  "OINOMEL": "(Greek) a beverage of ancient Greece consisting of wine and honey, also OENOMEL [n -S]\n",
  "OINOMELS": "OINOMEL, (Greek) a beverage of ancient Greece consisting of wine and honey, also OENOMEL [n]\n",
  "OINT": "(Dryden) to anoint [v -ED, -ING, -S]\n",
  "OINTED": "OINT, (Dryden) to anoint [v]\n",
  "OINTING": "OINT, (Dryden) to anoint [v]\n",
  "OINTMENT": "a viscous preparation applied to the skin as a medicine or cosmetic [n -S]\n",
  "OINTMENTS": "OINTMENT, a viscous preparation applied to the skin as a medicine or cosmetic [n]\n",
  "OINTS": "OINT, (Dryden) to anoint [v]\n",
  "OIS": "OI, a New Zealand bird, the grey-faced petrel [n]\n",
  "OITICICA": "(Tupi) any of several tropical South American trees, whose crushed seeds yield an oil used in paints and varnishes [n -S]\n",
  "OITICICAS": "OITICICA, (Tupi) any of several tropical South American trees, whose crushed seeds yield an oil used in paints and varnishes [n]\n",
  "OJIME": "(Japanese) a carved bead through which to pass the two cords attached to a Japanese inro and which when slid down keeps the cords fastened [n -S]\n",
  "OJIMES": "OJIME, (Japanese) a carved bead through which to pass the two cords attached to a Japanese inro and which when slid down keeps the cords fastened [n]\n",
  "OK": "expressing assent [interj]\n",
  "OKA": "a Turkish unit of weight, also OKE [n -S]\n",
  "OKAPI": "an animal like a giraffe but with a short neck and smaller [n -S]\n",
  "OKAPIS": "OKAPI, an animal like a giraffe but with a short neck and smaller [n]\n",
  "OKAS": "OKA, a Turkish unit of weight, also OKE [n]\n",
  "OKAY": "to approve, pass as OK [v -ED, -ING, -S]\n",
  "OKAYED": "OKAY, to approve, pass as OK [v]\n",
  "OKAYING": "OKAY, to approve, pass as OK [v]\n",
  "OKAYS": "OKAY, to approve, pass as OK [v]\n",
  "OKE": "a Turkish unit of weight, also OKA [n -S]\n",
  "OKEH": "an expression of approval, also OKAY [n -S]\n",
  "OKEHS": "OKEH, an expression of approval, also OKAY [n]\n",
  "OKES": "OKE, a Turkish unit of weight, also OKA [n]\n",
  "OKEYDOKE": "perfectly all right, also OKEYDOKEY [interj]\n",
  "OKEYDOKEY": "perfectly all right, also OKEYDOKE [interj]\n",
  "OKIMONO": "(Japanese) a Japanese ornament [n -S]\n",
  "OKIMONOS": "OKIMONO, (Japanese) a Japanese ornament [n]\n",
  "OKRA": "a tropical plant of the mallow family, with edible pods, aka gumbo [n -S]\n",
  "OKRAS": "OKRA, a tropical plant of the mallow family, with edible pods, aka gumbo [n]\n",
  "OKTA": "a unit of cloud-cover, one-eighth sky, also OCTA [n -S]\n",
  "OKTAS": "OKTA, a unit of cloud-cover, one-eighth sky, also OCTA [n]\n",
  "OLD": "a person of a specified age [n -S] / living for a long time [adj OLDER, OLDEST]\n",
  "OLDE": "(facetious) old [adj]\n",
  "OLDEN": "to grow old [v -ED, -ING, -S]\n",
  "OLDENED": "OLDEN, to grow old [v]\n",
  "OLDENING": "OLDEN, to grow old [v]\n",
  "OLDENS": "OLDEN, to grow old [v]\n",
  "OLDER": "OLD, living for a long time [adj]\n",
  "OLDEST": "OLD, living for a long time [adj]\n",
  "OLDFANGLED": "old-fashioned [adj]\n",
  "OLDIE": "(colloquial) an old person or thing, also OLDY [n -S]\n",
  "OLDIES": "OLDY, (colloquial) an old person or thing, also OLDIE [n]\n",
  "OLDISH": "somewhat old [adj]\n",
  "OLDNESS": "the state of being old [n -ES]\n",
  "OLDNESSES": "OLDNESS, the state of being old [n]\n",
  "OLDS": "OLD, a person of a specified age [n]\n",
  "OLDSQUAW": "a kind of sea duck, aka hareld, also OLDWIFE [n -S]\n",
  "OLDSQUAWS": "OLDSQUAW, a kind of sea duck, aka hareld, also OLDWIFE [n]\n",
  "OLDSTER": "an old person [n -S]\n",
  "OLDSTERS": "OLDSTER, an old person [n]\n",
  "OLDSTYLE": "a style of printing type [n -S]\n",
  "OLDSTYLES": "OLDSTYLE, a style of printing type [n]\n",
  "OLDWIFE": "a kind of duck, aka hareld, also OLDSQUAW [n OLDWIVES]\n",
  "OLDWIVES": "OLDWIFE, a kind of duck, aka hareld, also OLDSQUAW [n]\n",
  "OLDY": "(colloquial) an old person or thing, also OLDIE [n OLDIES]\n",
  "OLE": "(Spanish) a shout of approval [n -S]\n",
  "OLEA": "OLEUM, (Latin) fuming sulphuric acid [n]\n",
  "OLEACEOUS": "of or pertaining to the family Oleaceae, which includes olive, jasmine, lilac, privet, ash, and other trees and shrubs [adj]\n",
  "OLEAGINOUS": "resembling or having the properties of oil [adj OLEAGINOUSLY]\n",
  "OLEAGINOUSLY": "OLEAGINOUS, resembling or having the properties of oil [adv]\n",
  "OLEAGINOUSNESS": "the state of being oleaginous [n]\n",
  "OLEANDER": "a poisonous evergreen shrub [n -S]\n",
  "OLEANDERS": "OLEANDER, a poisonous evergreen shrub [n]\n",
  "OLEANDOMYCIN": "an antibiotic produced by a streptomyces [n -S]\n",
  "OLEANDOMYCINS": "OLEANDOMYCIN, an antibiotic produced by a streptomyces [n]\n",
  "OLEARIA": "a genus of evergreen shrubs [n -S]\n",
  "OLEARIAS": "OLEARIA, a genus of evergreen shrubs [n]\n",
  "OLEASTER": "(Latin) a yellow-flowered, olive-like shrub of South Europe [n -S]\n",
  "OLEASTERS": "OLEASTER, (Latin) a yellow-flowered, olive-like shrub of South Europe [n]\n",
  "OLEATE": "a salt of oleic acid [n -S]\n",
  "OLEATES": "OLEATE, a salt of oleic acid [n]\n",
  "OLECRANAL": "relating to the olecranon, the projecting bone of the elbow [adj]\n",
  "OLECRANON": "(Greek) the projecting bone of the elbow [n -S]\n",
  "OLECRANONS": "OLECRANON, (Greek) the projecting bone of the elbow [n]\n",
  "OLEFIANT": "oil-forming, as in olefiant ethylene [adj]\n",
  "OLEFIN": "a hydrocarbon of the ethylene series, also OLEFINE [n -S]\n",
  "OLEFINE": "a hydrocarbon of the ethylene series, also OLEFIN [n -S]\n",
  "OLEFINES": "OLEFINE, a hydrocarbon of the ethylene series, also OLEFIN [n]\n",
  "OLEFINIC": "of or like an olefin, a hydrocarbon of the ethylene series [adj]\n",
  "OLEFINS": "OLEFIN, a hydrocarbon of the ethylene series, also OLEFINE [n]\n",
  "OLEIC": "pertaining to or derived from oil [adj]\n",
  "OLEIFEROUS": "producing oil [adj]\n",
  "OLEIN": "a glycerine ester of oleic acid, also OLEINE [n -S]\n",
  "OLEINE": "a glycerine ester of oleic acid, also OLEIN [n -S]\n",
  "OLEINES": "OLEINE, a glycerine ester of oleic acid, also OLEIN [n]\n",
  "OLEINS": "OLEIN, a glycerine ester of oleic acid, also OLEINE [n]\n",
  "OLENT": "having a smell [adj]\n",
  "OLEO": "(short for) oleograph, a lithographic reproduction of an oil painting [n -S]\n",
  "OLEOGRAPH": "a lithographic reproduction of an oil painting [n -S]\n",
  "OLEOGRAPHIC": "like an oleograph [adj]\n",
  "OLEOGRAPHIES": "OLEOGRAPHY, the art of lithographic reproduction of oil painting [n]\n",
  "OLEOGRAPHS": "OLEOGRAPH, a lithographic reproduction of an oil painting [n]\n",
  "OLEOGRAPHY": "the art of lithographic reproduction of oil painting [n OLEOGRAPHIES]\n",
  "OLEOMARGARIN": "margarine, also OLEOMARGARINE [n -S]\n",
  "OLEOMARGARINE": "margarine, also OLEOMARGARIN [n -S]\n",
  "OLEOMARGARINES": "OLEOMARGARINE, margarine, also OLEOMARGARIN [n]\n",
  "OLEOMARGARINS": "OLEOMARGARIN, margarine, also OLEOMARGARINE [n]\n",
  "OLEOPHILIC": "having affinity for oils; wetted by oils in preference to water [adj]\n",
  "OLEORESIN": "a solution of a resin in an oil [n -S]\n",
  "OLEORESINOUS": "of or like an oleoresin [adj]\n",
  "OLEORESINS": "OLEORESIN, a solution of a resin in an oil [n]\n",
  "OLEOS": "OLEO, (short for) oleograph, a lithographic reproduction of an oil painting [n]\n",
  "OLERACEOUS": "of the nature of a potherb; for kitchen use; edible [adj]\n",
  "OLES": "OLE, (Spanish) a shout of approval [n]\n",
  "OLESTRA": "(tradename) a noncaloric fat substitute [n -S]\n",
  "OLESTRAS": "OLESTRA, (tradename) a noncaloric fat substitute [n]\n",
  "OLEUM": "(Latin) fuming sulphuric acid [n OLEUMS or OLEA]\n",
  "OLEUMS": "OLEUM, (Latin) fuming sulphuric acid [n]\n",
  "OLFACT": "to smell something [v -ED, -ING, -S]\n",
  "OLFACTED": "OLFACT, to smell something [v]\n",
  "OLFACTIBLE": "able to be smelled [adj]\n",
  "OLFACTING": "OLFACT, to smell something [v]\n",
  "OLFACTION": "the act of perceiving by smell [n -S]\n",
  "OLFACTIONS": "OLFACTION, the act of perceiving by smell [n]\n",
  "OLFACTIVE": "related to the sense of smell [adj]\n",
  "OLFACTOLOGIES": "OLFACTOLOGY, the study of the sense of smell [n]\n",
  "OLFACTOLOGIST": "one who studies smells and the sense of smell [n -S]\n",
  "OLFACTOLOGISTS": "OLFACTOLOGIST, one who studies smells and the sense of smell [n]\n",
  "OLFACTOLOGY": "the study of the sense of smell [n OLFACTOLOGIES]\n",
  "OLFACTOMETER": "an instrument measuring intensity of odour of a substance [n -S]\n",
  "OLFACTOMETERS": "OLFACTOMETER, an instrument measuring intensity of odour of a substance [n]\n",
  "OLFACTOMETRIES": "OLFACTOMETRY, the measurement of the sharpness of the sense of smell [n]\n",
  "OLFACTOMETRY": "the measurement of the sharpness of the sense of smell [n OLFACTOMETRIES]\n",
  "OLFACTORIES": "OLFACTORY, an organ or nerve concerned with the sense of smell [n]\n",
  "OLFACTORY": "concerned with the sense of smell [adj] / an organ or nerve concerned with the sense of smell [n OLFACTORIES]\n",
  "OLFACTRONICS": "the precise measurement, analysis and detection of odours by means of electronic instruments [n]\n",
  "OLFACTS": "OLFACT, to smell something [v]\n",
  "OLIBANUM": "an aromatic gum from a North African tree, formerly used in medicine but now chiefly as incense [n -S]\n",
  "OLIBANUMS": "OLIBANUM, an aromatic gum from a North African tree, formerly used in medicine but now chiefly as incense [n]\n",
  "OLICOOK": "(Dutch) a type of doughnut, also OLYCOOK, OLYKOEK [n -S]\n",
  "OLICOOKS": "OLICOOK, (Dutch) a type of doughnut, also OLYCOOK, OLYKOEK [n]\n",
  "OLID": "rank-smelling [adj]\n",
  "OLIGAEMIA": "abnormal deficiency of blood, also OLIGEMIA [n -S]\n",
  "OLIGAEMIAS": "OLIGAEMIA, abnormal deficiency of blood, also OLIGEMIA [n]\n",
  "OLIGAEMIC": "relating to oligaemia, abnormal deficiency of blood, also OLIGEMIC [adj]\n",
  "OLIGARCH": "a ruler in a government by the few [n -S]\n",
  "OLIGARCHAL": "of or like an oligarchy, also OLIGARCHIC [adj]\n",
  "OLIGARCHIC": "of or like an oligarchy, also OLIGARCHAL [adj OLIGARCHICALLY]\n",
  "OLIGARCHICAL": "of or like an oligarchy, also OLIGARCHIC [adj OLIGARCHICALLY]\n",
  "OLIGARCHICALLY": "OLIGARCHICAL, of or like an oligarchy, also OLIGARCHIC [adv]\n",
  "OLIGARCHIES": "OLIGARCHY, a government in which a few people control all power [n]\n",
  "OLIGARCHS": "OLIGARCH, a ruler in a government by the few [n]\n",
  "OLIGARCHY": "a government in which a few people control all power [n OLIGARCHIES]\n",
  "OLIGEMIA": "loss of blood after haemorrhage, also OLIGAEMIA [n -S]\n",
  "OLIGEMIAS": "OLIGEMIA, loss of blood after haemorrhage, also OLIGAEMIA [n]\n",
  "OLIGEMIC": "suffering loss of blood after haemorrhage, also OLIGAEMIC [adj]\n",
  "OLIGIST": "crystallized haematite [n -S]\n",
  "OLIGISTS": "OLIGIST, crystallized haematite [n]\n",
  "OLIGOCENE": "belonging to a certain geological time period [adj]\n",
  "OLIGOCHAETE": "any worm of the Oligochaeta, chaetopods in which the locomotor organs are reduced to bristles, e.g. earthworms, etc. [n -S]\n",
  "OLIGOCHAETES": "OLIGOCHAETE, any worm of the Oligochaeta, chaetopods in which the locomotor organs are reduced to bristles, e.g. earthworms, etc. [n]\n",
  "OLIGOCHROME": "(trademark) the brand name of a light-filtering device used in photography [n -S]\n",
  "OLIGOCHROMES": "OLIGOCHROME, (trademark) the brand name of a light-filtering device used in photography [n]\n",
  "OLIGOCLASE": "a triclinic soda-lime feldspar, plagioclase [n -S]\n",
  "OLIGOCLASES": "OLIGOCLASE, a triclinic soda-lime feldspar, plagioclase [n]\n",
  "OLIGOCYTHAEMIA": "deficiency of red corpuscles in blood [n -S]\n",
  "OLIGOCYTHAEMIAS": "OLIGOCYTHAEMIA, deficiency of red corpuscles in blood [n]\n",
  "OLIGODENDROCYTE": "a glial cell resembling an astrocyte but smaller with few and slender processes having few branches [n]\n",
  "OLIGODENDROGLIA": "a glia made up of oligodendrocytes that forms the myelin sheath around axons in the central nervous system [n]\n",
  "OLIGOGENE": "a type of gene [n -S]\n",
  "OLIGOGENES": "OLIGOGENE, a type of gene [n]\n",
  "OLIGOMER": "a type of complex chemical compound [n -S]\n",
  "OLIGOMERIC": "of or like an oligomer [adj]\n",
  "OLIGOMERISATION": "the process of converting into an oligomer, also OLIGOMERIZATION [n]\n",
  "OLIGOMERIZATION": "the process of converting into an oligomer, also OLIGOMERISATION [n]\n",
  "OLIGOMEROUS": "having few parts; having fewer members than the other whorls of a flower [adj]\n",
  "OLIGOMERS": "OLIGOMER, a type of complex chemical compound [n]\n",
  "OLIGONUCLEOTIDE": "a short nucleic-acid chain usually consisting of up to approximately 20 nucleotides [n]\n",
  "OLIGOPEPTIDE": "a peptide comprising less than ten amino acids [n -S]\n",
  "OLIGOPEPTIDES": "OLIGOPEPTIDE, a peptide comprising less than ten amino acids [n]\n",
  "OLIGOPHAGIES": "OLIGOPHAGY, the state of being oligophagous, eating only a few specific kinds of food [n]\n",
  "OLIGOPHAGOUS": "eating only a few specific kinds of food [adj]\n",
  "OLIGOPHAGY": "the state of being oligophagous, eating only a few specific kinds of food [n OLIGOPHAGIES]\n",
  "OLIGOPOLIES": "OLIGOPOLY, a market situation in which a few producers control the demand from a large number of buyers [n]\n",
  "OLIGOPOLISTIC": "relating to oligopoly [adj]\n",
  "OLIGOPOLY": "a market situation in which a few producers control the demand from a large number of buyers [n OLIGOPOLIES]\n",
  "OLIGOPSONIES": "OLIGOPSONY, a market situation in which each of a few buyers exerts a disproportionate influence on the market [n]\n",
  "OLIGOPSONISTIC": "relating to oligopsony [adj]\n",
  "OLIGOPSONY": "a market situation in which each of a few buyers exerts a disproportionate influence on the market [n OLIGOPSONIES]\n",
  "OLIGOSACCHARIDE": "a saccharide (as a disaccharide) that contains a known small number of monosaccharide units [n]\n",
  "OLIGOSPERMIA": "the condition of having less than the normal number of spermatozoa in the semen, a cause of infertility in men [n -S]\n",
  "OLIGOSPERMIAS": "OLIGOSPERMIA, the condition of having less than the normal number of spermatozoa in the semen, a cause of infertility in men [n]\n",
  "OLIGOTROPHIC": "having a deficiency of plant nutrients that is usually accompanied by an abundance of dissolved oxygen [adj]\n",
  "OLIGOTROPHIES": "OLIGOTROPHY, the state of being oligotrophic [n]\n",
  "OLIGOTROPHY": "the state of being oligotrophic [n OLIGOTROPHIES]\n",
  "OLIGURESES": "OLIGURESIS, scantiness of urine in proportion to liquid intake, also OLIGURIA [n]\n",
  "OLIGURESIS": "scantiness of urine in proportion to liquid intake, also OLIGURIA [n OLIGURESES]\n",
  "OLIGURETIC": "relating to oliguresis, scantiness of urine in proportion to liquid intake [adj]\n",
  "OLIGURIA": "scantiness of urine in proportion to liquid intake, also OLIGURESIS [n -S]\n",
  "OLIGURIAS": "OLIGURIA, scantiness of urine in proportion to liquid intake, also OLIGURESIS [n]\n",
  "OLIGURIC": "relating to oliguria [adj]\n",
  "OLINGO": "(Spanish) a small mammal of Central and South America [n -S]\n",
  "OLINGOS": "OLINGO, (Spanish) a small mammal of Central and South America [n]\n",
  "OLINGUITO": "(Spanish) a small animal related to the olingo, living in the forests of Colombia and Ecuador [n -S]\n",
  "OLINGUITOS": "OLINGUITO, (Spanish) a small animal related to the olingo, living in the forests of Colombia and Ecuador [n]\n",
  "OLIO": "a savoury dish of meat and vegetables [n -S]\n",
  "OLIOS": "OLIO, a savoury dish of meat and vegetables [n]\n",
  "OLIPHANT": "(obsolete) an ancient ivory hunting-horn [n -S]\n",
  "OLIPHANTS": "OLIPHANT, (obsolete) an ancient ivory hunting-horn [n]\n",
  "OLITORIES": "OLITORY, (archaic) a potherb, a kitchen garden [n]\n",
  "OLITORY": "(archaic) a potherb, a kitchen garden [n OLITORIES]\n",
  "OLIVACEOUS": "olive-coloured [adj]\n",
  "OLIVARY": "shaped like an olive [adj]\n",
  "OLIVE": "the small oval fruit of a Mediterranean tree [n -S]\n",
  "OLIVENITE": "an olive-green hydrous arseniate of copper [n -S]\n",
  "OLIVENITES": "OLIVENITE, an olive-green hydrous arseniate of copper [n]\n",
  "OLIVER": "a forge-hammer worked by the foot [n -S]\n",
  "OLIVERS": "OLIVER, a forge-hammer worked by the foot [n]\n",
  "OLIVES": "OLIVE, the small oval fruit of a Mediterranean tree [n]\n",
  "OLIVET": "a button shaped like an olive [n -S]\n",
  "OLIVETS": "OLIVET, a button shaped like an olive [n]\n",
  "OLIVEWOOD": "the wood of the olive tree [n -S]\n",
  "OLIVEWOODS": "OLIVEWOOD, the wood of the olive tree [n]\n",
  "OLIVINE": "a mineral, iron and magnesium silicate, used as a refractory and in cements [n -S]\n",
  "OLIVINES": "OLIVINE, a mineral, iron and magnesium silicate, used as a refractory and in cements [n]\n",
  "OLIVINIC": "of or like olivine, a mineral, iron and magnesium silicate [adj]\n",
  "OLIVINITIC": "of or like olivenite [adj]\n",
  "OLLA": "(Spanish) a jar or urn with a wide mouth [n -S]\n",
  "OLLAMH": "(Irish) an Irish master poet, also OLLAV [n -S]\n",
  "OLLAMHS": "OLLAMH, (Irish) an Irish master poet, also OLLAV [n]\n",
  "OLLAS": "OLLA, (Spanish) a jar or urn with a wide mouth [n]\n",
  "OLLAV": "(Irish) an Irish master poet, also OLLAMH [n -S]\n",
  "OLLAVS": "OLLAV, (Irish) an Irish master poet, also OLLAMH [n]\n",
  "OLLER": "(dialect) waste ground [n -S]\n",
  "OLLERS": "OLLER, (dialect) waste ground [n]\n",
  "OLLIE": "to perform a certain kind of jump into the air in skateboarding [v OLLIED, OLLIEING, OLLIES]\n",
  "OLLIED": "OLLIE, to perform a certain kind of jump into the air in skateboarding [v]\n",
  "OLLIEING": "OLLIE, to perform a certain kind of jump into the air in skateboarding [v]\n",
  "OLLIES": "OLLIE, to perform a certain kind of jump into the air in skateboarding [v]\n",
  "OLM": "a kind of blind cave-dwelling salamander [n -S]\n",
  "OLMS": "OLM, a kind of blind cave-dwelling salamander [n]\n",
  "OLOGIES": "OLOGY, a science whose name ends in -ology [n]\n",
  "OLOGIST": "an expert in a particular ology [n -S]\n",
  "OLOGISTS": "OLOGIST, an expert in a particular ology [n]\n",
  "OLOGOAN": "(Irish) to complain loudly without cause [v -ED, -ING, -S]\n",
  "OLOGOANED": "OLOGOAN, (Irish) to complain loudly without cause [v]\n",
  "OLOGOANING": "OLOGOAN, (Irish) to complain loudly without cause [v]\n",
  "OLOGOANS": "OLOGOAN, (Irish) to complain loudly without cause [v]\n",
  "OLOGY": "a science whose name ends in -ology [n OLOGIES]\n",
  "OLOLIUQUI": "a woody-stemmed Mexican vine of the morning glory family [n -S]\n",
  "OLOLIUQUIS": "OLOLIUQUI, a woody-stemmed Mexican vine of the morning glory family [n]\n",
  "OLOROSO": "(Spanish) a golden-coloured medium-sweet sherry [n -S]\n",
  "OLOROSOS": "OLOROSO, (Spanish) a golden-coloured medium-sweet sherry [n]\n",
  "OLPAE": "OLPE, (Greek) a Greek jug [n]\n",
  "OLPE": "(Greek) a Greek jug [n OLPES or OLPAE]\n",
  "OLPES": "OLPE, (Greek) a Greek jug [n]\n",
  "OLYCOOK": "(Dutch) a type of doughnut, also OLICOOK, OLYKOEK [n -S]\n",
  "OLYCOOKS": "OLYCOOK, (Dutch) a type of doughnut, also OLICOOK, OLYKOEK [n]\n",
  "OLYKOEK": "(Dutch) a type of doughnut, also OLICOOK, OLICOOK [n -S]\n",
  "OLYKOEKS": "OLYKOEK, (Dutch) a type of doughnut, also OLICOOK, OLICOOK [n]\n",
  "OLYMPIAD": "a celebration of the Olympic Games [n -S]\n",
  "OLYMPIADS": "OLYMPIAD, a celebration of the Olympic Games [n]\n",
  "OLYMPICS": "an International competition in chess etc. [n]\n",
  "OM": "an intoned Hindu sacred symbol [n -S]\n",
  "OMA": "(German) a grandmother, also OUMA [n -S]\n",
  "OMADHAUN": "(Irish) a fool, idiot, simpleton [n -S]\n",
  "OMADHAUNS": "OMADHAUN, (Irish) a fool, idiot, simpleton [n]\n",
  "OMAS": "OMA, (German) a grandmother, also OUMA [n]\n",
  "OMASA": "OMASUM, (Latin) the third stomach of a ruminant [n]\n",
  "OMASAL": "relating to the omasum, the third of the four stomachs of a ruminant [adj]\n",
  "OMASUM": "(Latin) the third stomach of a ruminant [n OMASA]\n",
  "OMBER": "(Spanish) a card game, also OMBRE [n -S]\n",
  "OMBERS": "OMBER, (Spanish) a card game, also OMBRE [n]\n",
  "OMBRE": "a card game, also OMBER [n -S]\n",
  "OMBRELLA": "an umbrella [n -S]\n",
  "OMBRELLAS": "OMBRELLA, an umbrella [n]\n",
  "OMBRES": "OMBRE, a card game, also OMBER [n]\n",
  "OMBROGENOUS": "of plants, able to flourish in wet conditions [adj]\n",
  "OMBROMETER": "a rain-gauge [n -S]\n",
  "OMBROMETERS": "OMBROMETER, a rain-gauge [n]\n",
  "OMBROPHIL": "a plant flourishing in extremely rainy conditions, also OMBROPHILE [n -S]\n",
  "OMBROPHILE": "a plant flourishing in extremely rainy conditions, also OMBROPHIL [n -S]\n",
  "OMBROPHILES": "OMBROPHILE, a plant flourishing in extremely rainy conditions, also OMBROPHIL [n]\n",
  "OMBROPHILOUS": "capable of withstanding long periods of rain [adj]\n",
  "OMBROPHILS": "OMBROPHIL, a plant flourishing in extremely rainy conditions, also OMBROPHILE [n]\n",
  "OMBROPHOBE": "a plant thriving only in desert conditions [n -S]\n",
  "OMBROPHOBES": "OMBROPHOBE, a plant thriving only in desert conditions [n]\n",
  "OMBROPHOBOUS": "of or like an ombrophobe, a plant thriving only in desert conditions [adj]\n",
  "OMBU": "a type of South American tree [n -S]\n",
  "OMBUDSMAN": "(Swedish) a government official who investigates complaints against government departments [n OMBUDSMEN]\n",
  "OMBUDSMANSHIP": "the office of ombudsman [n -S]\n",
  "OMBUDSMANSHIPS": "OMBUDSMANSHIP, the office of ombudsman [n]\n",
  "OMBUDSMEN": "OMBUDSMAN, (Swedish) a government official who investigates complaints against government departments [n]\n",
  "OMBUS": "OMBU, a type of South American tree [n]\n",
  "OMEGA": "(Greek) a Greek letter [n -S]\n",
  "OMEGAS": "OMEGA, (Greek) a Greek letter [n]\n",
  "OMELET": "a dish made with beaten eggs, also OMELETTE [n -S]\n",
  "OMELETS": "OMELET, a dish made with beaten eggs, also OMELETTE [n]\n",
  "OMELETTE": "a dish made with beaten eggs, also OMELET [n -S]\n",
  "OMELETTES": "OMELETTE, a dish made with beaten eggs, also OMELET [n]\n",
  "OMEN": "to provide with a prophetic sign [v -ED, -ING, -S]\n",
  "OMENED": "OMEN, to provide with a prophetic sign [v]\n",
  "OMENING": "OMEN, to provide with a prophetic sign [v]\n",
  "OMENS": "OMEN, to provide with a prophetic sign [v]\n",
  "OMENTA": "OMENTUM, (Latin) a fold of the peritoneum proceeding from one of the abdominal viscera to another [n]\n",
  "OMENTAL": "of or pertaining to an omentum, a free fold of the peritoneum [adj]\n",
  "OMENTUM": "(Latin) a fold of the peritoneum proceeding from one of the abdominal viscera to another [n OMENTA or OMENTUMS]\n",
  "OMENTUMS": "OMENTUM, (Latin) a fold of the peritoneum proceeding from one of the abdominal viscera to another [n]\n",
  "OMER": "(Hebrew) a Hebrew unit of dry measure [n -S]\n",
  "OMERS": "OMER, (Hebrew) a Hebrew unit of dry measure [n]\n",
  "OMERTA": "(Italian) the Mafia code of honour requiring silence about criminal activities [n -S]\n",
  "OMERTAS": "OMERTA, (Italian) the Mafia code of honour requiring silence about criminal activities [n]\n",
  "OMICRON": "(Greek) a Greek letter, also OMIKRON [n -S]\n",
  "OMICRONS": "OMICRON, (Greek) a Greek letter, also OMIKRON [n]\n",
  "OMIGOD": "an interjection of surprise, dismay, pleasure etc., also MIGAWD [interj]\n",
  "OMIKRON": "(Greek) a Greek letter, also OMICRON [n -S]\n",
  "OMIKRONS": "OMIKRON, (Greek) a Greek letter, also OMICRON [n]\n",
  "OMINOUS": "portending evil [adj OMINOUSLY]\n",
  "OMINOUSLY": "OMINOUS, portending evil [adv]\n",
  "OMINOUSNESS": "the state of being ominous [n -ES]\n",
  "OMINOUSNESSES": "OMINOUSNESS, the state of being ominous [n]\n",
  "OMISSIBLE": "that can be omitted [adj]\n",
  "OMISSION": "something left out [n -S]\n",
  "OMISSIONS": "OMISSION, something left out [n]\n",
  "OMISSIVE": "marked by omission [adj]\n",
  "OMISSIVENESS": "the state of being omissive [n -ES]\n",
  "OMISSIVENESSES": "OMISSIVENESS, the state of being omissive [n]\n",
  "OMIT": "to leave out [v OMITTED, OMITTING, OMITS]\n",
  "OMITS": "OMIT, to leave out [v]\n",
  "OMITTANCE": "(Shakespeare) omission [n -S]\n",
  "OMITTANCES": "OMITTANCE, (Shakespeare) omission [n]\n",
  "OMITTED": "OMIT, to leave out [v]\n",
  "OMITTER": "one who omits [n -S]\n",
  "OMITTERS": "OMITTER, one who omits [n]\n",
  "OMITTING": "OMIT, to leave out [v]\n",
  "OMLAH": "(Arabic) an Indian staff of officials [n -S]\n",
  "OMLAHS": "OMLAH, (Arabic) an Indian staff of officials [n]\n",
  "OMMATEA": "OMMATEUM, (Greek) a compound eye [n]\n",
  "OMMATEUM": "(Greek) a compound eye [n OMMATEA]\n",
  "OMMATIDIA": "OMMATIDIUM, a simple element of a compound eye [n]\n",
  "OMMATIDIAL": "relating to an ommatidium [adj]\n",
  "OMMATIDIUM": "a simple element of a compound eye [n OMMATIDIA]\n",
  "OMMATOPHORE": "an eyestalk, as in snails [n -S]\n",
  "OMMATOPHORES": "OMMATOPHORE, an eyestalk, as in snails [n]\n",
  "OMMATOPHOROUS": "of or like ommatophore, an eyestalk, as in snails [adj]\n",
  "OMNEITIES": "OMNEITY, allness, also OMNIETY [n]\n",
  "OMNEITY": "allness, also OMNIETY [n OMNEITIES]\n",
  "OMNIANA": "(Latin) miscellaneous collectable items about all sorts of things [n -S]\n",
  "OMNIANAS": "OMNIANA, (Latin) miscellaneous collectable items about all sorts of things [n]\n",
  "OMNIARCH": "an almighty ruler [n -S]\n",
  "OMNIARCHS": "OMNIARCH, an almighty ruler [n]\n",
  "OMNIBENEVOLENCE": "universal good will [n]\n",
  "OMNIBENEVOLENT": "showing universal good will [adj]\n",
  "OMNIBUS": "a large public road vehicle for carrying numerous passengers, running on a fixed route [n OMNIBUSES or OMNIBUSSES]\n",
  "OMNIBUSES": "OMNIBUS, a large public road vehicle for carrying numerous passengers, running on a fixed route [n]\n",
  "OMNIBUSSES": "OMNIBUS, a large public road vehicle for carrying numerous passengers, running on a fixed route [n]\n",
  "OMNICOMPETENCE": "the state of being omnicompetent [n -S]\n",
  "OMNICOMPETENCES": "OMNICOMPETENCE, the state of being omnicompetent [n]\n",
  "OMNICOMPETENT": "legally competent in all matters [adj]\n",
  "OMNIDIRECTIONAL": "in all directions [adj]\n",
  "OMNIETIES": "OMNIETY, allness, also OMNEITY [n]\n",
  "OMNIETY": "allness, also OMNEITY [n OMNIETIES]\n",
  "OMNIFARIOUS": "of all kinds [adj OMNIFARIOUSLY]\n",
  "OMNIFARIOUSLY": "OMNIFARIOUS, of all kinds [adv]\n",
  "OMNIFARIOUSNESS": "OMNIFARIOUS, of all kinds [n]\n",
  "OMNIFEROUS": "bearing everything [adj]\n",
  "OMNIFIC": "(Latin) unlimited in creative power [adj]\n",
  "OMNIFICENCE": "the state of being omnificent [n -S]\n",
  "OMNIFICENCES": "OMNIFICENCE, the state of being omnificent [n]\n",
  "OMNIFICENT": "doing everything [adj]\n",
  "OMNIFIED": "OMNIFY, to make universal [v]\n",
  "OMNIFIES": "OMNIFY, to make universal [v]\n",
  "OMNIFORM": "in all forms [adj]\n",
  "OMNIFORMITIES": "OMNIFORMITY, the state of having every form [n]\n",
  "OMNIFORMITY": "the state of having every form [n OMNIFORMITIES]\n",
  "OMNIFY": "to make universal [v OMNIFIED, OMNIFYING, OMNIFIES]\n",
  "OMNIFYING": "OMNIFY, to make universal [v]\n",
  "OMNIGENOUS": "of all kinds [adj]\n",
  "OMNIMODE": "of all modes [adj]\n",
  "OMNIPARITIES": "OMNIPARITY, general equality [n]\n",
  "OMNIPARITY": "general equality [n OMNIPARITIES]\n",
  "OMNIPAROUS": "producing all things [adj]\n",
  "OMNIPATIENT": "enduring all things [adj]\n",
  "OMNIPOTENCE": "the state of being omnipotent, also OMNIPOTENCY [n -S]\n",
  "OMNIPOTENCES": "OMNIPOTENCE, the state of being omnipotent, also OMNIPOTENCY [n]\n",
  "OMNIPOTENCIES": "OMNIPOTENCY, the state of being omnipotent, also OMNIPOTENCE [n]\n",
  "OMNIPOTENCY": "the state of being omnipotent, also OMNIPOTENCE [n OMNIPOTENCIES]\n",
  "OMNIPOTENT": "all-powerful [adj OMNIPOTENTLY] / one who is all-powerful [n -S]\n",
  "OMNIPOTENTLY": "OMNIPOTENT, all-powerful [adv]\n",
  "OMNIPOTENTS": "OMNIPOTENT, one who is all-powerful [n]\n",
  "OMNIPRESENCE": "the state of being omnipresent [n -S]\n",
  "OMNIPRESENCES": "OMNIPRESENCE, the state of being omnipresent [n]\n",
  "OMNIPRESENT": "present everywhere [adj]\n",
  "OMNIRANGE": "a system of radio navigation [n -S]\n",
  "OMNIRANGES": "OMNIRANGE, a system of radio navigation [n]\n",
  "OMNISCIENCE": "the state of being omniscient [n -S]\n",
  "OMNISCIENCES": "OMNISCIENCE, the state of being omniscient [n]\n",
  "OMNISCIENT": "knowing everything [adj OMNISCIENTLY]\n",
  "OMNISCIENTLY": "OMNISCIENT, knowing everything [adv]\n",
  "OMNISHAMBLES": "a situation that has been completely mismanaged [n OMNISHAMBLES]\n",
  "OMNIUM": "(Latin) the aggregate value of the different stocks in which a loan to government is now usually funded [n -S]\n",
  "OMNIUMS": "OMNIUM, (Latin) the aggregate value of the different stocks in which a loan to government is now usually funded [n]\n",
  "OMNIVORA": "omnivores as a group [n]\n",
  "OMNIVORE": "an omnivorous person or animal, one that feeds on both animal and vegetable food [n -S]\n",
  "OMNIVORES": "OMNIVORE, an omnivorous person or animal, one that feeds on both animal and vegetable food [n]\n",
  "OMNIVORIES": "OMNIVORY, a practice of eating both animal and vegetable foods [n]\n",
  "OMNIVOROUS": "feeding on all kinds of food [adj OMNIVOROUSLY]\n",
  "OMNIVOROUSLY": "OMNIVOROUS, feeding on all kinds of food [adv]\n",
  "OMNIVOROUSNESS": "OMNIVOROUS, feeding on all kinds of food [n]\n",
  "OMNIVORY": "a practice of eating both animal and vegetable foods [n OMNIVORIES]\n",
  "OMOHYOID": "a shoulder-blade muscle [n -S]\n",
  "OMOHYOIDS": "OMOHYOID, a shoulder-blade muscle [n]\n",
  "OMOPHAGIA": "the eating of raw flesh, also OMOPHAGY [n -S]\n",
  "OMOPHAGIAS": "OMOPHAGIA, the eating of raw flesh, also OMOPHAGY [n]\n",
  "OMOPHAGIC": "relating to omophagia, the eating of raw flesh [adj]\n",
  "OMOPHAGIES": "OMOPHAGY, the eating of raw flesh [n]\n",
  "OMOPHAGOUS": "eating raw flesh [adj]\n",
  "OMOPHAGY": "the eating of raw flesh [n OMOPHAGIES]\n",
  "OMOPHORIA": "OMOPHORION, an Eastern bishop's vestment like the pallium [n]\n",
  "OMOPHORION": "an Eastern bishop's vestment like the pallium [n OMOPHORIA]\n",
  "OMOPLATE": "the shoulder-blade [n -S]\n",
  "OMOPLATES": "OMOPLATE, the shoulder-blade [n]\n",
  "OMOPLATOSCOPIES": "OMOPLATOSCOPY, divination by observing the cracks in a burning shoulder-blade [n]\n",
  "OMOPLATOSCOPY": "divination by observing the cracks in a burning shoulder-blade [n OMOPLATOSCOPIES]\n",
  "OMOV": "a voting system of one man, one vote [n -S]\n",
  "OMOVS": "OMOV, a voting system of one man, one vote [n]\n",
  "OMPHACITE": "a grass-green pyroxene [n -S]\n",
  "OMPHACITES": "OMPHACITE, a grass-green pyroxene [n]\n",
  "OMPHALI": "OMPHALOS, (Greek) a central point, a navel [n]\n",
  "OMPHALIC": "pertaining to the navel [adj]\n",
  "OMPHALOI": "OMPHALOS, (Greek) a central point, a navel [n]\n",
  "OMPHALOID": "of or pertaining to the omphalos, the umbilicus, or navel, also OMPHALIC [adj]\n",
  "OMPHALOMANCIES": "OMPHALOMANCY, predicting the number of children a mother will bear by counting the knots in her firstborn's umbilical cord [n]\n",
  "OMPHALOMANCY": "predicting the number of children a mother will bear by counting the knots in her firstborn's umbilical cord [n OMPHALOMANCIES]\n",
  "OMPHALOS": "(Greek) a central point, a navel [n OMPHALI or OMPHALOI]\n",
  "OMPHALOSKEPSES": "OMPHALOSKEPSIS, the contemplation of one's own navel to induce a mental trance [n]\n",
  "OMPHALOSKEPSIS": "the contemplation of one's own navel to induce a mental trance [n OMPHALOSKEPSES]\n",
  "OMRAH": "(Hindi) a Muslim lord [n -S]\n",
  "OMRAHS": "OMRAH, (Hindi) a Muslim lord [n]\n",
  "OMS": "OM, an intoned Hindu sacred symbol [n]\n",
  "ON": "to go on [v ONNED, ONNING, ONS]\n",
  "ONAGER": "a wild ass of Asia [n -S] / a military engine for throwing great stones [n ONAGRI]\n",
  "ONAGERS": "ONAGER, a wild ass of Asia [n]\n",
  "ONAGRACEOUS": "belonging to evening primrose family of plants [adj]\n",
  "ONAGRI": "ONAGER, a wild ass of Asia [n]\n",
  "ONANISM": "coitus interrupted to prevent insemination [n -S]\n",
  "ONANISMS": "ONANISM, coitus interrupted to prevent insemination [n]\n",
  "ONANIST": "one who practises onanism [n -S]\n",
  "ONANISTIC": "relating to onanism [adj]\n",
  "ONANISTS": "ONANIST, one who practises onanism [n]\n",
  "ONBEAT": "the first and third beats in a bar of four-four time [n -S]\n",
  "ONBEATS": "ONBEAT, the first and third beats in a bar of four-four time [n]\n",
  "ONBOARD": "to train a new person to do a job [v -ED, -ING, -S]\n",
  "ONBOARDED": "ONBOARD, to train a new person to do a job [v]\n",
  "ONBOARDING": "the induction and assimilation of a new employee into a company or organization [n -S]\n",
  "ONBOARDINGS": "ONBOARDING, the induction and assimilation of a new employee into a company or organization [n]\n",
  "ONBOARDS": "ONBOARD, to train a new person to do a job [v]\n",
  "ONCE": "one time [n -S]\n",
  "ONCER": "(slang) a one-pound note [n -S]\n",
  "ONCERS": "ONCER, (slang) a one-pound note [n]\n",
  "ONCES": "ONCE, one time [n]\n",
  "ONCET": "(Southern US dialect) once [adv]\n",
  "ONCHOCERCIASES": "ONCHOCERCIASIS, infestation with or disease caused by filarial worms [n]\n",
  "ONCHOCERCIASIS": "infestation with or disease caused by filarial worms [n ONCHOCERCIASES]\n",
  "ONCIDIUM": "any of a genus of tropical orchidaceous plants [n -S]\n",
  "ONCIDIUMS": "ONCIDIUM, any of a genus of tropical orchidaceous plants [n]\n",
  "ONCOGEN": "an agent producing cancerous tumours, also ONCOGENE [n -S]\n",
  "ONCOGENE": "a gene that causes a cell to become cancerous [n -S]\n",
  "ONCOGENES": "ONCOGENE, a gene that causes a cell to become cancerous [n]\n",
  "ONCOGENESES": "ONCOGENESIS, the production of cancerous tumours [n]\n",
  "ONCOGENESIS": "the production of cancerous tumours [n ONCOGENESES]\n",
  "ONCOGENETICIST": "someone who studies oncogenes [n -S]\n",
  "ONCOGENETICISTS": "ONCOGENETICIST, someone who studies oncogenes [n]\n",
  "ONCOGENIC": "relating to oncogenesis, the production of cancerous tumours [adj]\n",
  "ONCOGENICITIES": "ONCOGENICITY, the state of being oncogenic [n]\n",
  "ONCOGENICITY": "the state of being oncogenic [n ONCOGENICITIES]\n",
  "ONCOGENOUS": "relating to an oncogene, an agent producing cancerous tumours [adj]\n",
  "ONCOGENS": "ONCOGEN, an agent producing cancerous tumours, also ONCOGENE [n]\n",
  "ONCOLOGIC": "relating to oncology, the study of tumours, also ONCOLOGICAL [adj]\n",
  "ONCOLOGICAL": "relating to oncology, the study of tumours, also ONCOLOGIC [adj]\n",
  "ONCOLOGIES": "ONCOLOGY, the science of tumors [n]\n",
  "ONCOLOGIST": "one who studies oncology [n -S]\n",
  "ONCOLOGISTS": "ONCOLOGIST, one who studies oncology [n]\n",
  "ONCOLOGY": "the science of tumors [n ONCOLOGIES]\n",
  "ONCOLYSES": "ONCOLYSIS, the destruction of tumours [n]\n",
  "ONCOLYSIS": "the destruction of tumours [n ONCOLYSES]\n",
  "ONCOLYTIC": "an agent that destroys tumours [n -S]\n",
  "ONCOLYTICS": "ONCOLYTIC, an agent that destroys tumours [n]\n",
  "ONCOME": "(Scots) a coming on, a sudden onset, e.g. of rain, also ONDING [n -S]\n",
  "ONCOMES": "ONCOME, (Scots) a coming on, a sudden onset, e.g. of rain, also ONDING [n]\n",
  "ONCOMETER": "an instrument measuring change in the size of internal organs [n -S]\n",
  "ONCOMETERS": "ONCOMETER, an instrument measuring change in the size of internal organs [n]\n",
  "ONCOMICE": "ONCOMOUSE, (US) a mouse bred for cancer treatment research [n]\n",
  "ONCOMING": "an approach [n -S]\n",
  "ONCOMINGS": "ONCOMING, an approach [n]\n",
  "ONCOMOUSE": "(US) a mouse bred for cancer treatment research [n ONCOMICE]\n",
  "ONCORNAVIRUS": "an oncogenic RNA virus [n -ES]\n",
  "ONCORNAVIRUSES": "ONCORNAVIRUS, an oncogenic RNA virus [n]\n",
  "ONCOST": "(Scots) an overhead expense [n -S]\n",
  "ONCOSTMAN": "a mine worker paid by the day [n ONCOSTMEN]\n",
  "ONCOSTMEN": "ONCOSTMAN, a mine worker paid by the day [n]\n",
  "ONCOSTS": "ONCOST, (Scots) an overhead expense [n]\n",
  "ONCOTOMIES": "ONCOTOMY, incision into a tumour [n]\n",
  "ONCOTOMY": "incision into a tumour [n ONCOTOMIES]\n",
  "ONCOVIRUS": "a virus causing cancer [n -ES]\n",
  "ONCOVIRUSES": "ONCOVIRUS, a virus causing cancer [n]\n",
  "ONCUS": "(Australian slang) disordered, bad, also ONKUS [adj]\n",
  "ONDATRA": "(Native American) the musquash [n -S]\n",
  "ONDATRAS": "ONDATRA, (Native American) the musquash [n]\n",
  "ONDINE": "a female water spirit, also UNDINE [n -S]\n",
  "ONDINES": "ONDINE, a female water spirit, also UNDINE [n]\n",
  "ONDING": "(Scots) a sudden onset of rain or snow, also ONCOME [n -S]\n",
  "ONDINGS": "ONDING, (Scots) a sudden onset of rain or snow, also ONCOME [n]\n",
  "ONDOGRAM": "a graph of electric wave forms [n -S]\n",
  "ONDOGRAMS": "ONDOGRAM, a graph of electric wave forms [n]\n",
  "ONDOGRAPH": "an instrument for producing a graphical recording of an alternating current [n -S]\n",
  "ONDOGRAPHS": "ONDOGRAPH, an instrument for producing a graphical recording of an alternating current [n]\n",
  "ONE": "an individual thing or person; the number or figure 1 [n -S]\n",
  "ONEFOLD": "single-minded [adj]\n",
  "ONEIRIC": "belonging to dreams, also ONIRIC [adj ONEIRICALLY]\n",
  "ONEIRICALLY": "ONEIRIC, belonging to dreams, also ONIRIC [adv]\n",
  "ONEIROCRITIC": "one who interprets dreams [n -S]\n",
  "ONEIROCRITICAL": "of, relating to or specializing in the interpretation of dreams [adj]\n",
  "ONEIROCRITICISM": "dream interpretation [n]\n",
  "ONEIROCRITICS": "ONEIROCRITIC, one who interprets dreams [n]\n",
  "ONEIRODYNIA": "a nightmare [n -S]\n",
  "ONEIRODYNIAS": "ONEIRODYNIA, a nightmare [n]\n",
  "ONEIROLOGIES": "ONEIROLOGY, the study of dreams [n]\n",
  "ONEIROLOGY": "the study of dreams [n ONEIROLOGIES]\n",
  "ONEIROMANCER": "one who practises oneiromancy, divination by dreams [n -S]\n",
  "ONEIROMANCERS": "ONEIROMANCER, one who practises oneiromancy, divination by dreams [n]\n",
  "ONEIROMANCIES": "ONEIROMANCY, the practice of predicting the future by interpreting dreams [n]\n",
  "ONEIROMANCY": "the practice of predicting the future by interpreting dreams [n ONEIROMANCIES]\n",
  "ONEIROSCOPIES": "ONEIROSCOPY, judging a dream [n]\n",
  "ONEIROSCOPIST": "one who practises oneiroscopy [n -S]\n",
  "ONEIROSCOPISTS": "ONEIROSCOPIST, one who practises oneiroscopy [n]\n",
  "ONEIROSCOPY": "judging a dream [n ONEIROSCOPIES]\n",
  "ONELY": "(Spenser) only [adv]\n",
  "ONENESS": "unity [n -ES]\n",
  "ONENESSES": "ONENESS, unity [n]\n",
  "ONER": "something unique [n -S]\n",
  "ONERIER": "ONERY, (colloquial) cantankerous, also ORNERY [adj]\n",
  "ONERIEST": "ONERY, (colloquial) cantankerous, also ORNERY [adj]\n",
  "ONEROUS": "burdensome [adj ONEROUSLY]\n",
  "ONEROUSLY": "ONEROUS, burdensome [adv]\n",
  "ONEROUSNESS": "the state of being onerous [n -ES]\n",
  "ONEROUSNESSES": "ONEROUSNESS, the state of being onerous [n]\n",
  "ONERS": "ONER, something unique [n]\n",
  "ONERY": "(colloquial) cantankerous, also ORNERY [adj ONERIER, ONERIEST]\n",
  "ONES": "ONE, an individual thing or person; the number or figure 1 [n]\n",
  "ONESELF": "a person's self [pron]\n",
  "ONESIE": "a soft, loose-fitting, one-piece garment worn by adults for sleeping or lounging [n -S]\n",
  "ONESIES": "ONESIE, a soft, loose-fitting, one-piece garment worn by adults for sleeping or lounging [n]\n",
  "ONETIME": "former [adj]\n",
  "ONEYER": "(Shakespeare) a (great) one, also ONEYRE [n -S]\n",
  "ONEYERS": "ONEYER, (Shakespeare) a (great) one, also ONEYRE [n]\n",
  "ONEYRE": "(Shakespeare) a (great) one, also ONEYER [n -S]\n",
  "ONEYRES": "ONEYRE, (Shakespeare) a (great) one, also ONEYER [n]\n",
  "ONFALL": "an attack [n -S]\n",
  "ONFALLS": "ONFALL, an attack [n]\n",
  "ONFLOW": "a flowing on [n -S]\n",
  "ONFLOWS": "ONFLOW, a flowing on [n]\n",
  "ONGAONGA": "(Maori) a New Zealand nettle with a severe or fatal sting [n -S]\n",
  "ONGAONGAS": "ONGAONGA, (Maori) a New Zealand nettle with a severe or fatal sting [n]\n",
  "ONGOING": "a course of conduct [n -S]\n",
  "ONGOINGNESS": "the state of being ongoing [n -ES]\n",
  "ONGOINGNESSES": "ONGOINGNESS, the state of being ongoing [n]\n",
  "ONGOINGS": "ONGOING, a course of conduct [n]\n",
  "ONIE": "(Scots) any, also ONY [adj]\n",
  "ONION": "to apply an onion, an edible bulb, to [v -ED, -ING, -S]\n",
  "ONIONED": "ONION, to apply an onion, an edible bulb, to [v]\n",
  "ONIONIER": "ONIONY, like an onion [adj]\n",
  "ONIONIEST": "ONIONY, like an onion [adj]\n",
  "ONIONING": "ONION, to apply an onion, an edible bulb, to [v]\n",
  "ONIONS": "ONION, to apply an onion, an edible bulb, to [v]\n",
  "ONIONSKIN": "a very thin variety of paper [n -S]\n",
  "ONIONSKINS": "ONIONSKIN, a very thin variety of paper [n]\n",
  "ONIONY": "like an onion [adj ONIONIER, ONIONIEST]\n",
  "ONIRIC": "belonging to dreams, also ONEIRIC [adj]\n",
  "ONISCOID": "like a woodlouse [adj]\n",
  "ONIUM": "a compound containing ions of the kind with names ending in -onium [n -S]\n",
  "ONIUMS": "ONIUM, a compound containing ions of the kind with names ending in -onium [n]\n",
  "ONKUS": "(Australian slang) disordered, bad, also ONCUS [adj]\n",
  "ONLAY": "an artificial veneer for a tooth [n -S]\n",
  "ONLAYS": "ONLAY, an artificial veneer for a tooth [n]\n",
  "ONLIEST": "ONLY, standing alone [adj]\n",
  "ONLINE": "carried out while connected to a computer and under its direct control [adj]\n",
  "ONLINER": "a user of the internet [n -S]\n",
  "ONLINERS": "ONLINER, a user of the internet [n]\n",
  "ONLOAD": "to load a vehicle or container [v -ED, -ING, -S]\n",
  "ONLOADED": "ONLOAD, to load a vehicle or container [v]\n",
  "ONLOADING": "ONLOAD, to load a vehicle or container [v]\n",
  "ONLOADS": "ONLOAD, to load a vehicle or container [v]\n",
  "ONLOOKER": "a spectator [n -S]\n",
  "ONLOOKERS": "ONLOOKER, a spectator [n]\n",
  "ONLOOKING": "watching [adj]\n",
  "ONLY": "standing alone [adj]\n",
  "ONNED": "ON, to go on [v]\n",
  "ONNING": "ON, to go on [v]\n",
  "ONO": "(Hawaiian) a kind of fish [n -S]\n",
  "ONOCENTAUR": "a kind of centaur, half-man and half-ass [n -S]\n",
  "ONOCENTAURS": "ONOCENTAUR, a kind of centaur, half-man and half-ass [n]\n",
  "ONOMASIOLOGIES": "ONOMASIOLOGY, the branch of semantics concerned with the meanings of and meaning relations between individual words [n]\n",
  "ONOMASIOLOGY": "the branch of semantics concerned with the meanings of and meaning relations between individual words [n ONOMASIOLOGIES]\n",
  "ONOMAST": "a person who studies proper names, especially personal names [n -S]\n",
  "ONOMASTIC": "relating to a name, esp. relating to the signature on a document written in another person's hand [adj ONOMASTICALLY]\n",
  "ONOMASTICALLY": "ONOMASTIC, relating to a name, esp. relating to the signature on a document written in another person's hand [adv]\n",
  "ONOMASTICIAN": "one who practises onomastics, the study of proper names [n -S]\n",
  "ONOMASTICIANS": "ONOMASTICIAN, one who practises onomastics, the study of proper names [n]\n",
  "ONOMASTICON": "a dictionary of names, esp. personal names or place names [n -S]\n",
  "ONOMASTICONS": "ONOMASTICON, a dictionary of names, esp. personal names or place names [n]\n",
  "ONOMASTICS": "the study of proper names or of terms used in a specialized field [n]\n",
  "ONOMASTS": "ONOMAST, a person who studies proper names, especially personal names [n]\n",
  "ONOMATOLOGIES": "ONOMATOLOGY, the science of names [n]\n",
  "ONOMATOLOGIST": "one who studies onomatology, the science of names [n -S]\n",
  "ONOMATOLOGISTS": "ONOMATOLOGIST, one who studies onomatology, the science of names [n]\n",
  "ONOMATOLOGY": "the science of names [n ONOMATOLOGIES]\n",
  "ONOMATOPOEIA": "the naming of a thing or action by a vocal imitation of the sound associated with it, also ONOMATOPOESIS, ONOMATOPOIESIS [n -S]\n",
  "ONOMATOPOEIAS": "ONOMATOPOEIA, the naming of a thing or action by a vocal imitation of the sound associated with it, also ONOMATOPOESIS, ONOMATOPOIESIS [n]\n",
  "ONOMATOPOEIC": "relating to onomatopoeia [adj]\n",
  "ONOMATOPOESES": "ONOMATOPOESIS, onomatopoeia, also ONOMATOPOEIA, ONOMATOPOIESIS [n]\n",
  "ONOMATOPOESIS": "onomatopoeia, also ONOMATOPOEIA, ONOMATOPOIESIS [n ONOMATOPOESES]\n",
  "ONOMATOPOETIC": "onomatopoeic [adj]\n",
  "ONOMATOPOIESES": "ONOMATOPOIESIS, onomatopoeia, also ONOMATOPOEIA, ONOMATOPOESIS [n]\n",
  "ONOMATOPOIESIS": "onomatopoeia, also ONOMATOPOEIA, ONOMATOPOESIS [n ONOMATOPOIESES]\n",
  "ONOS": "ONO, (Hawaiian) a kind of fish [n]\n",
  "ONRUSH": "a forward rush [n -ES]\n",
  "ONRUSHES": "ONRUSH, a forward rush [n]\n",
  "ONRUSHING": "rushing forward [adj]\n",
  "ONS": "ON, to go on [v]\n",
  "ONSCREEN": "as shown on television or film [adj]\n",
  "ONSET": "a beginning [n -S]\n",
  "ONSETS": "ONSET, a beginning [n]\n",
  "ONSETTER": "(archaic) an assailant [n -S]\n",
  "ONSETTERS": "ONSETTER, (archaic) an assailant [n]\n",
  "ONSETTING": "an incitement [n -S]\n",
  "ONSETTINGS": "ONSETTING, an incitement [n]\n",
  "ONSHORE": "towards the shore [adv]\n",
  "ONSHORING": "the practice of employing white-collar workers from abroad [n -S]\n",
  "ONSHORINGS": "ONSHORING, the practice of employing white-collar workers from abroad [n]\n",
  "ONSIDE": "a cricket term, one side of the batsman [n -S]\n",
  "ONSIDES": "ONSIDE, a cricket term, one side of the batsman [n]\n",
  "ONSLAUGHT": "an attack [n -S]\n",
  "ONSLAUGHTS": "ONSLAUGHT, an attack [n]\n",
  "ONST": "(dialect) once, also ONCET [adv]\n",
  "ONSTAGE": "being a part of the stage visible to the audience [adj]\n",
  "ONSTEAD": "a single farmhouse; a steading [n -S]\n",
  "ONSTEADS": "ONSTEAD, a single farmhouse; a steading [n]\n",
  "ONSTREAM": "in production [adv]\n",
  "ONTIC": "having real existence [adj ONTICALLY]\n",
  "ONTICALLY": "ONTIC, having real existence [adv]\n",
  "ONTO": "forward to [prep]\n",
  "ONTOGENESES": "ONTOGENESIS, the origin and development of a single individual organism [n]\n",
  "ONTOGENESIS": "the origin and development of a single individual organism [n ONTOGENESES]\n",
  "ONTOGENETIC": "relating to ontogenesis, also ONTOGENIC [adj ONTOGENETICALLY]\n",
  "ONTOGENETICALLY": "ONTOGENETIC, relating to ontogenesis, also ONTOGENIC [adv]\n",
  "ONTOGENIC": "relating to ontogenesis, the origin and development of a single individual organism, also ONTOGENETIC [adj ONTOGENICALLY]\n",
  "ONTOGENICALLY": "ONTOGENIC, relating to ontogenesis, the origin and development of a single individual organism, also ONTOGENETIC [adv]\n",
  "ONTOGENIES": "ONTOGENY, the development of an individual organism [n]\n",
  "ONTOGENY": "the development of an individual organism [n ONTOGENIES]\n",
  "ONTOLOGIC": "based upon being or existence, also ONTOLOGICAL [adj ONTOLOGICALLY]\n",
  "ONTOLOGICAL": "based upon being or existence, also ONTOLOGIC [adj ONTOLOGICALLY]\n",
  "ONTOLOGICALLY": "ONTOLOGICAL, based upon being or existence, also ONTOLOGIC [adv]\n",
  "ONTOLOGIES": "ONTOLOGY, the branch of philosophy the deals with being [n]\n",
  "ONTOLOGIST": "one who is versed in or treats of ontology [n -S]\n",
  "ONTOLOGISTS": "ONTOLOGIST, one who is versed in or treats of ontology [n]\n",
  "ONTOLOGY": "the branch of philosophy the deals with being [n ONTOLOGIES]\n",
  "ONUS": "(Latin) responsibility [n -ES]\n",
  "ONUSES": "ONUS, (Latin) responsibility [n]\n",
  "ONWARD": "towards the front, also ONWARDS [adv]\n",
  "ONWARDLY": "going on [adv]\n",
  "ONWARDS": "towards the front, also ONWARD [adv]\n",
  "ONY": "(Scots) any, also ONIE [adj]\n",
  "ONYCHA": "(Greek) an ingredient in ancient Jewish incense; the nail-like operculum of a mollusc [n -S]\n",
  "ONYCHAS": "ONYCHA, (Greek) an ingredient in ancient Jewish incense; the nail-like operculum of a mollusc [n]\n",
  "ONYCHIA": "(Greek) inflammation of the root or side of the nail, aka whitlow [n -S]\n",
  "ONYCHIAS": "ONYCHIA, (Greek) inflammation of the root or side of the nail, aka whitlow [n]\n",
  "ONYCHITE": "onyx marble [n -S]\n",
  "ONYCHITES": "ONYCHITE, onyx marble [n]\n",
  "ONYCHITIS": "inflammation of the root or side of the nail [n -ES]\n",
  "ONYCHITISES": "ONYCHITIS, inflammation of the root or side of the nail [n]\n",
  "ONYCHIUM": "a pad on an insect's foot [n -S]\n",
  "ONYCHIUMS": "ONYCHIUM, a pad on an insect's foot [n]\n",
  "ONYCHOCRYPTOSES": "ONYCHOCRYPTOSIS, the condition of having an ingrowing toenail [n]\n",
  "ONYCHOCRYPTOSIS": "the condition of having an ingrowing toenail [n ONYCHOCRYPTOSES]\n",
  "ONYCHOMANCIES": "ONYCHOMANCY, divination by studying the fingernails [n]\n",
  "ONYCHOMANCY": "divination by studying the fingernails [n ONYCHOMANCIES]\n",
  "ONYCHOPHAGIES": "ONYCHOPHAGY, the habit of biting one's fingernails [n]\n",
  "ONYCHOPHAGIST": "one who bites their fingernails [n -S]\n",
  "ONYCHOPHAGISTS": "ONYCHOPHAGIST, one who bites their fingernails [n]\n",
  "ONYCHOPHAGY": "the habit of biting one's fingernails [n ONYCHOPHAGIES]\n",
  "ONYCHOPHORAN": "any of numerous velvety-skinned wormlike carnivorous animals common in tropical forests having characteristics of both arthropods and annelid worms [n -S]\n",
  "ONYCHOPHORANS": "ONYCHOPHORAN, any of numerous velvety-skinned wormlike carnivorous animals common in tropical forests having characteristics of both arthropods and annelid worms [n]\n",
  "ONYMOUS": "bearing the author's name, not anonymous [adj]\n",
  "ONYX": "a form of chalcedony consisting of plane layers of different colours [n -ES]\n",
  "ONYXES": "ONYX, a form of chalcedony consisting of plane layers of different colours [n]\n",
  "OO": "(Scots) wool [n -S]\n",
  "OOBIT": "a hairy caterpillar, esp. of the tiger moth, also OUBIT, WOOBUT, WOUBIT [n -S]\n",
  "OOBITS": "OOBIT, a hairy caterpillar, esp. of the tiger moth, also OUBIT, WOOBUT, WOUBIT [n]\n",
  "OOCYST": "an encysted form of some sporozoan zygotes [n -S]\n",
  "OOCYSTS": "OOCYST, an encysted form of some sporozoan zygotes [n]\n",
  "OOCYTE": "an ovum before it matures and begins to divide [n -S]\n",
  "OOCYTES": "OOCYTE, an ovum before it matures and begins to divide [n]\n",
  "OODLES": "a large amount, also OODLINS [n]\n",
  "OODLINS": "a large amount, also OODLES [n]\n",
  "OOF": "(Yiddish) money, also OOFTISH [n -S]\n",
  "OOFIER": "OOFY, expensive, ostentatious [adj]\n",
  "OOFIEST": "OOFY, expensive, ostentatious [adj]\n",
  "OOFS": "OOF, (Yiddish) money, also OOFTISH [n]\n",
  "OOFTISH": "(Yiddish) money, also OOF [n -ES]\n",
  "OOFTISHES": "OOFTISH, (Yiddish) money, also OOF [n]\n",
  "OOFY": "expensive, ostentatious [adj OOFIER, OOFIEST]\n",
  "OOGAMETE": "a female gamete of certain protozoa [n -S]\n",
  "OOGAMETES": "OOGAMETE, a female gamete of certain protozoa [n]\n",
  "OOGAMIES": "OOGAMY, the state of having dissimilar gametes [n]\n",
  "OOGAMOUS": "having structurally dissimilar gametes [adj OOGAMOUSLY]\n",
  "OOGAMOUSLY": "OOGAMOUS, having structurally dissimilar gametes [adv]\n",
  "OOGAMY": "the state of having dissimilar gametes [n OOGAMIES]\n",
  "OOGENESES": "OOGENESIS, the enlargement and meiosis of an oogonium that produces an ovum, also OOGENY [n]\n",
  "OOGENESIS": "the enlargement and meiosis of an oogonium that produces an ovum, also OOGENY [n OOGENESES]\n",
  "OOGENETIC": "relating to oogenesis, the enlargement and meiosis of an oogonium that produces an ovum [adj]\n",
  "OOGENIES": "OOGENY, the development of ova [n]\n",
  "OOGENY": "the development of ova [n OOGENIES]\n",
  "OOGONIA": "OOGONIUM, a female sexual organ in algae and fungi [n]\n",
  "OOGONIAL": "relating to oogonia, the female reproductive organs in fungi or seaweed [adj]\n",
  "OOGONIUM": "a female sexual organ in algae and fungi [n OOGONIUMS or OOGONIA]\n",
  "OOGONIUMS": "OOGONIUM, a female sexual organ in algae and fungi [n]\n",
  "OOH": "to express surprise [v -ED, -ING, -S]\n",
  "OOHED": "OOH, to express surprise [v]\n",
  "OOHING": "the act of saying ooh [n -S]\n",
  "OOHINGS": "OOHING, the act of saying ooh [n]\n",
  "OOHS": "OOH, to express surprise [v]\n",
  "OOIDAL": "egg-shaped [adj]\n",
  "OOJAMAFLIP": "a thing whose name is temporarily forgotten [n -S]\n",
  "OOJAMAFLIPS": "OOJAMAFLIP, a thing whose name is temporarily forgotten [n]\n",
  "OOLACHAN": "(Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n -S]\n",
  "OOLACHANS": "OOLACHAN, (Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n]\n",
  "OOLAKAN": "(Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n -S]\n",
  "OOLAKANS": "OOLAKAN, (Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLICHAN, OULACHON, OULAKAN, ULICON, ULIKON [n]\n",
  "OOLICHAN": "(Native American) the north Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OULACHON, OULAKAN, ULICON, ULIKON [n -S]\n",
  "OOLICHANS": "OOLICHAN, (Native American) the north Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OULACHON, OULAKAN, ULICON, ULIKON [n]\n",
  "OOLITE": "a kind of limestone comprising small egg-like grains [n -S]\n",
  "OOLITES": "OOLITE, a kind of limestone comprising small egg-like grains [n]\n",
  "OOLITH": "any of the small rounded granules of which oolite is composed [n -S]\n",
  "OOLITHS": "OOLITH, any of the small rounded granules of which oolite is composed [n]\n",
  "OOLITIC": "of or like oolite [adj]\n",
  "OOLOGIC": "relating to oology, the collection and study of birds' eggs, also OOLOGICAL [adj]\n",
  "OOLOGICAL": "relating to oology, the collection and study of birds' eggs, also OOLOGIC [adj]\n",
  "OOLOGIES": "OOLOGY, the study of birds' eggs [n]\n",
  "OOLOGIST": "an expert in oology [n -S]\n",
  "OOLOGISTS": "OOLOGIST, an expert in oology [n]\n",
  "OOLOGY": "the study of birds' eggs [n OOLOGIES]\n",
  "OOLONG": "(Chinese) a variety of black tea, also OULONG [n -S]\n",
  "OOLONGS": "OOLONG, (Chinese) a variety of black tea, also OULONG [n]\n",
  "OOM": "(South African) uncle [n -S]\n",
  "OOMIAC": "(Inuit) an Inuit canoe, also OOMIACK, OOMIAK, UMIAC, UMIACK, UMIAK, UMIAQ [n -S]\n",
  "OOMIACK": "(Inuit) an Inuit canoe, also OOMIAC, OOMIAK, UMIAC, UMIACK, UMIAK, UMIAQ [n -S]\n",
  "OOMIACKS": "OOMIACK, (Inuit) an Inuit canoe, also OOMIAC, OOMIAK, UMIAC, UMIACK, UMIAK, UMIAQ [n]\n",
  "OOMIACS": "OOMIAC, (Inuit) an Inuit canoe, also OOMIACK, OOMIAK, UMIAC, UMIACK, UMIAK, UMIAQ [n]\n",
  "OOMIAK": "(Inuit) an Inuit canoe, also OOMIAC, OOMIACK, UMIAC, UMIACK, UMIAK, UMIAQ [n -S]\n",
  "OOMIAKS": "OOMIAK, (Inuit) an Inuit canoe, also OOMIAC, OOMIACK, UMIAC, UMIACK, UMIAK, UMIAQ [n]\n",
  "OOMPAH": "to play a repeated rhythmic deep sound [v -ED, -ING, -S]\n",
  "OOMPAHED": "OOMPAH, to play a repeated rhythmic deep sound [v]\n",
  "OOMPAHING": "OOMPAH, to play a repeated rhythmic deep sound [v]\n",
  "OOMPAHPAH": "an imitation of the sound of a tuba [n -S]\n",
  "OOMPAHPAHS": "OOMPAHPAH, an imitation of the sound of a tuba [n]\n",
  "OOMPAHS": "OOMPAH, to play a repeated rhythmic deep sound [v]\n",
  "OOMPH": "spirited vigor [n -S]\n",
  "OOMPHS": "OOMPH, spirited vigor [n]\n",
  "OOMS": "OOM, (South African) uncle [n]\n",
  "OOMYCETE": "an organism such as water mould [n -S]\n",
  "OOMYCETES": "OOMYCETE, an organism such as water mould [n]\n",
  "OON": "(Scots) an oven [n -S]\n",
  "OONS": "OON, (Scots) an oven [n]\n",
  "OONT": "(Hindi) a camel [n -S]\n",
  "OONTS": "OONT, (Hindi) a camel [n]\n",
  "OOP": "to bind with thread, also OUP [v -ED, -ING, -S]\n",
  "OOPED": "OOP, to bind with thread, also OUP [v]\n",
  "OOPHORECTOMIES": "OOPHORECTOMY, the operation of removing one or both of the ovaries, aka ovariotomy [n]\n",
  "OOPHORECTOMISE": "to perform an oophorectomy, removal of one or both ovaries, also OOPHORECTOMIZE [v OOPHORECTOMISED, OOPHORECTOMISES]\n",
  "OOPHORECTOMISED": "OOPHORECTOMISE, to perform an oophorectomy, removal of one or both ovaries, also OOPHORECTOMIZE [v]\n",
  "OOPHORECTOMISES": "OOPHORECTOMISE, to perform an oophorectomy, removal of one or both ovaries, also OOPHORECTOMIZE [v]\n",
  "OOPHORECTOMIZE": "to perform an oophorectomy, removal of one or both ovaries, also OOPHORECTOMISE [v OOPHORECTOMIZED, OOPHORECTOMIZES]\n",
  "OOPHORECTOMIZED": "OOPHORECTOMIZE, to perform an oophorectomy, removal of one or both ovaries, also OOPHORECTOMISE [v]\n",
  "OOPHORECTOMIZES": "OOPHORECTOMIZE, to perform an oophorectomy, removal of one or both ovaries, also OOPHORECTOMISE [v]\n",
  "OOPHORECTOMY": "the operation of removing one or both of the ovaries, aka ovariotomy [n OOPHORECTOMIES]\n",
  "OOPHORITIC": "relating to oophoritis, inflammation of the ovaries [adj]\n",
  "OOPHORITIS": "inflammation of the ovaries [n -ES]\n",
  "OOPHORITISES": "OOPHORITIS, inflammation of the ovaries [n]\n",
  "OOPHORON": "an ovary [n -S]\n",
  "OOPHORONS": "OOPHORON, an ovary [n]\n",
  "OOPHYTE": "a stage of development in certain plants [n -S]\n",
  "OOPHYTES": "OOPHYTE, a stage of development in certain plants [n]\n",
  "OOPHYTIC": "of or pertaining to an oophyte, a division of plants [adj]\n",
  "OOPING": "OOP, to bind with thread, also OUP [v]\n",
  "OOPS": "OOP, to bind with thread, also OUP [v]\n",
  "OOR": "(Scots) our, belonging to us [adj]\n",
  "OORALI": "(Caribbean) the plant yielding curare, also OURALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n -S]\n",
  "OORALIS": "OORALI, (Caribbean) the plant yielding curare, also OURALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n]\n",
  "OORIAL": "(Punjabi) a kind of Himalayan sheep, also URIAL [n -S]\n",
  "OORIALS": "OORIAL, (Punjabi) a kind of Himalayan sheep, also URIAL [n]\n",
  "OORIE": "(Scots) dingy, shabby, also OURIE, OWRIE [adj OORIER, OORIEST]\n",
  "OORIER": "OORIE, (Scots) dingy, shabby, also OURIE, OWRIE [adj]\n",
  "OORIEST": "OORIE, (Scots) dingy, shabby, also OURIE, OWRIE [adj]\n",
  "OOS": "OO, (Scots) wool [n]\n",
  "OOSE": "(Scots) fluff, nap [n -S]\n",
  "OOSES": "OOSE, (Scots) fluff, nap [n]\n",
  "OOSIER": "OOSY, (Scots) having fluff [adj]\n",
  "OOSIEST": "OOSY, (Scots) having fluff [adj]\n",
  "OOSPERM": "a fertilized egg [n -S]\n",
  "OOSPERMS": "OOSPERM, a fertilized egg [n]\n",
  "OOSPHERE": "an unfertilized egg within an oogonium [n -S]\n",
  "OOSPHERES": "OOSPHERE, an unfertilized egg within an oogonium [n]\n",
  "OOSPORE": "a fertilized egg within an oogonium [n -S]\n",
  "OOSPORES": "OOSPORE, a fertilized egg within an oogonium [n]\n",
  "OOSPORIC": "of or pertaining to an oospore, a special kind of spore resulting from the fertilization of an oosphere by antherozoids, also OOSPOROUS [adj]\n",
  "OOSPOROUS": "of or pertaining to an oospore, a special kind of spore resulting from the fertilization of an oosphere by antherozoids, also OOSPORIC [adj]\n",
  "OOSY": "(Scots) having fluff [adj OOSIER, OOSIEST]\n",
  "OOT": "(Scots) out [n -S]\n",
  "OOTHECA": "(Greek) the egg case of certain insects [n OOTHECAE]\n",
  "OOTHECAE": "OOTHECA, (Greek) the egg case of certain insects [n]\n",
  "OOTHECAL": "pertaining to an ootheca, the firm-walled egg-case of some molluscs and insects [adj]\n",
  "OOTID": "one of the four sections into which a mature ovum divides [n -S]\n",
  "OOTIDS": "OOTID, one of the four sections into which a mature ovum divides [n]\n",
  "OOTS": "OOT, (Scots) out [n]\n",
  "OOZE": "to leak slowly [v OOZED, OOZING, OOZES]\n",
  "OOZED": "OOZE, to leak slowly [v]\n",
  "OOZES": "OOZE, to leak slowly [v]\n",
  "OOZIER": "OOZY, oozing [adj]\n",
  "OOZIEST": "OOZY, oozing [adj]\n",
  "OOZILY": "OOZY, oozing [adv]\n",
  "OOZINESS": "the state of being oozy [n -ES]\n",
  "OOZINESSES": "OOZINESS, the state of being oozy [n]\n",
  "OOZING": "OOZE, to leak slowly [v]\n",
  "OOZY": "oozing [adj OOZIER, OOZIEST, OOZILY]\n",
  "OP": "(short for) an operation [n -S]\n",
  "OPA": "(German) a grandfather, also OUPA [n -S]\n",
  "OPACIFIED": "OPACIFY, to make opaque [v]\n",
  "OPACIFIER": "something that opacifies [n -S]\n",
  "OPACIFIERS": "OPACIFIER, something that opacifies [n]\n",
  "OPACIFIES": "OPACIFY, to make opaque [v]\n",
  "OPACIFY": "to make opaque [v OPACIFIED, OPACIFYING, OPACIFIES]\n",
  "OPACIFYING": "OPACIFY, to make opaque [v]\n",
  "OPACITIES": "OPACITY, something that is opaque [n]\n",
  "OPACITY": "something that is opaque [n OPACITIES]\n",
  "OPACOUS": "(archaic) opaque [adj]\n",
  "OPAH": "a large sea-fish with laterally flattened body, aka sunfish, kingfish [n -S]\n",
  "OPAHS": "OPAH, a large sea-fish with laterally flattened body, aka sunfish, kingfish [n]\n",
  "OPAL": "an amorphous variety of silica [n -S]\n",
  "OPALED": "decorated with opal [adj]\n",
  "OPALESCE": "to emit an iridescent shimmer of colors [v OPALESCED, OPALESCING, OPALESCES]\n",
  "OPALESCED": "OPALESCE, to emit an iridescent shimmer of colors [v]\n",
  "OPALESCENCE": "a milky iridescence [n -S]\n",
  "OPALESCENCES": "OPALESCENCE, a milky iridescence [n]\n",
  "OPALESCENT": "reflecting a milky or pearly light from the interior [adj OPALESCENTLY]\n",
  "OPALESCENTLY": "OPALESCENT, reflecting a milky or pearly light from the interior [adv]\n",
  "OPALESCES": "OPALESCE, to emit an iridescent shimmer of colors [v]\n",
  "OPALESCING": "OPALESCE, to emit an iridescent shimmer of colors [v]\n",
  "OPALINE": "an opaque white glass [n -S]\n",
  "OPALINES": "OPALINE, an opaque white glass [n]\n",
  "OPALISED": "made smooth, like opal, also OPALIZED [adj]\n",
  "OPALIZED": "made smooth, like opal, also OPALISED [adj]\n",
  "OPALS": "OPAL, an amorphous variety of silica [n]\n",
  "OPAQUE": "impervious to light [adj OPAQUER, OPAQUEST, OPAQUELY] / to make opaque [v OPAQUED, OPAQUING, OPAQUES]\n",
  "OPAQUED": "OPAQUE, to make opaque [v]\n",
  "OPAQUELY": "OPAQUE, impervious to light [adv]\n",
  "OPAQUENESS": "the state of being opaque [n -ES]\n",
  "OPAQUENESSES": "OPAQUENESS, the state of being opaque [n]\n",
  "OPAQUER": "OPAQUE, impervious to light [adj]\n",
  "OPAQUES": "OPAQUE, to make opaque [v]\n",
  "OPAQUEST": "OPAQUE, impervious to light [adj]\n",
  "OPAQUING": "OPAQUE, to make opaque [v]\n",
  "OPAS": "OPA, (German) a grandfather, also OUPA [n]\n",
  "OPCODE": "a code containing operation instructions for a microprocessor [n -S]\n",
  "OPCODES": "OPCODE, a code containing operation instructions for a microprocessor [n]\n",
  "OPE": "to open [v OPED, OPING, OPES]\n",
  "OPED": "OPE, to open [v]\n",
  "OPEIDOSCOPE": "an instrument for illustrating sound by means of light [n -S]\n",
  "OPEIDOSCOPES": "OPEIDOSCOPE, an instrument for illustrating sound by means of light [n]\n",
  "OPEN": "affording unobstructed access, passage, or view [adj OPENER, OPENEST, OPENLY] / to cause to become open [v -ED, -ING, -S]\n",
  "OPENABILITIES": "OPENABILITY, the ability to be opened [n]\n",
  "OPENABILITY": "the ability to be opened [n OPENABILITIES]\n",
  "OPENABLE": "able to be opened [adj]\n",
  "OPENCAST": "excavated from an open air site [adj]\n",
  "OPENED": "OPEN, to cause to become open [v]\n",
  "OPENER": "one that opens [n -S]\n",
  "OPENERS": "OPENER, one that opens [n]\n",
  "OPENEST": "OPEN, affording unobstructed access, passage, or view [adj]\n",
  "OPENHANDED": "generous [adj OPENHANDEDLY]\n",
  "OPENHANDEDLY": "OPENHANDED, generous [adv]\n",
  "OPENHANDEDNESS": "OPENHANDED, generous [n]\n",
  "OPENHEARTED": "candidly straightforward [adj OPENHEARTEDLY]\n",
  "OPENHEARTEDLY": "OPENHEARTED, candidly straightforward [adv]\n",
  "OPENHEARTEDNESS": "OPENHEARTED, candidly straightforward [n]\n",
  "OPENING": "a vacant space [n -S]\n",
  "OPENINGS": "OPENING, a vacant space [n]\n",
  "OPENLY": "OPEN, affording unobstructed access, passage, or view [adv]\n",
  "OPENMOUTHED": "vociferous [adj OPENMOUTHEDLY]\n",
  "OPENMOUTHEDLY": "OPENMOUTHED, vociferous [adv]\n",
  "OPENMOUTHEDNESS": "the state of being openmouthed [n]\n",
  "OPENNESS": "the state of being open [n -ES]\n",
  "OPENNESSES": "OPENNESS, the state of being open [n]\n",
  "OPENS": "OPEN, to cause to become open [v]\n",
  "OPENSIDE": "a rugby player who plays on the open side of a scrum [n -S]\n",
  "OPENSIDES": "OPENSIDE, a rugby player who plays on the open side of a scrum [n]\n",
  "OPENWORK": "ornamental work with numerous openings [n -S]\n",
  "OPENWORKS": "OPENWORK, ornamental work with numerous openings [n]\n",
  "OPEPE": "(Yoruba) a West African tree yielding a hard yellowish wood used as a substitute for teak [n -S]\n",
  "OPEPES": "OPEPE, (Yoruba) a West African tree yielding a hard yellowish wood used as a substitute for teak [n]\n",
  "OPERA": "a form of musical drama [n -S]\n",
  "OPERABILITIES": "OPERABILITY, the ability to be operated [n]\n",
  "OPERABILITY": "the ability to be operated [n OPERABILITIES]\n",
  "OPERABLE": "that can be operated [adj OPERABLY]\n",
  "OPERABLY": "OPERABLE, that can be operated [adv]\n",
  "OPERAGOER": "one who attends the opera [n -S]\n",
  "OPERAGOERS": "OPERAGOER, one who attends the opera [n]\n",
  "OPERAGOING": "attending the opera [n -S]\n",
  "OPERAGOINGS": "OPERAGOING, attending the opera [n]\n",
  "OPERAND": "a quantity on which a mathematical or logical operation is (to be) performed [n -S]\n",
  "OPERANDS": "OPERAND, a quantity on which a mathematical or logical operation is (to be) performed [n]\n",
  "OPERANT": "operative [adj OPERANTLY] / an operator [n -S]\n",
  "OPERANTLY": "OPERANT, operative [adv]\n",
  "OPERANTS": "OPERANT, an operator [n]\n",
  "OPERAS": "OPERA, a form of musical drama [n]\n",
  "OPERATE": "to perform a function [v OPERATED, OPERATING, OPERATES]\n",
  "OPERATED": "OPERATE, to perform a function [v]\n",
  "OPERATES": "OPERATE, to perform a function [v]\n",
  "OPERATIC": "relating to opera [adj OPERATICALLY]\n",
  "OPERATICALLY": "OPERATIC, relating to opera [adv]\n",
  "OPERATICS": "the study of opera; histrionic behaviour [n]\n",
  "OPERATING": "OPERATE, to perform a function [v]\n",
  "OPERATION": "the act of operating [n -S]\n",
  "OPERATIONAL": "of or relating to operation or to an operation [adj OPERATIONALLY]\n",
  "OPERATIONALISM": "the theory that defines scientific concepts by means of the operations used to prove or determine them, also OPERATIONISM [n -S]\n",
  "OPERATIONALISMS": "OPERATIONALISM, the theory that defines scientific concepts by means of the operations used to prove or determine them, also OPERATIONISM [n]\n",
  "OPERATIONALIST": "an exponent of operationalism [n -S]\n",
  "OPERATIONALISTS": "OPERATIONALIST, an exponent of operationalism [n]\n",
  "OPERATIONALLY": "OPERATIONAL, of or relating to operation or to an operation [adv]\n",
  "OPERATIONISM": "the theory that defines scientific concepts by means of the operations used to prove or determine them, also OPERATIONALISM [n -S]\n",
  "OPERATIONISMS": "OPERATIONISM, the theory that defines scientific concepts by means of the operations used to prove or determine them, also OPERATIONALISM [n]\n",
  "OPERATIONIST": "an adherent of operationism [n -S]\n",
  "OPERATIONISTS": "OPERATIONIST, an adherent of operationism [n]\n",
  "OPERATIONS": "OPERATION, the act of operating [n]\n",
  "OPERATISE": "to turn a play etc. into an opera, also OPERATIZE [v OPERATISED, OPERATISING, OPERATISES]\n",
  "OPERATISED": "OPERATISE, to turn a play etc. into an opera, also OPERATIZE [v]\n",
  "OPERATISES": "OPERATISE, to turn a play etc. into an opera, also OPERATIZE [v]\n",
  "OPERATISING": "OPERATISE, to turn a play etc. into an opera, also OPERATIZE [v]\n",
  "OPERATIVE": "having the power of operating or acting [adj OPERATIVELY] / a worker, esp. one with special skills [n -S]\n",
  "OPERATIVELY": "OPERATIVE, having the power of operating or acting [adv]\n",
  "OPERATIVENESS": "OPERATIVE, having the power of operating or acting [n]\n",
  "OPERATIVENESSES": "OPERATIVENESS, OPERATIVE, having the power of operating or acting [n]\n",
  "OPERATIVES": "OPERATIVE, a worker, esp. one with special skills [n]\n",
  "OPERATIVITIES": "OPERATIVITY, the state of being operative [n]\n",
  "OPERATIVITY": "the state of being operative [n OPERATIVITIES]\n",
  "OPERATIZE": "to turn a play etc. into an opera, also OPERATISE [v OPERATIZED, OPERATIZING, OPERATIZES]\n",
  "OPERATIZED": "OPERATIZE, to turn a play etc. into an opera, also OPERATISE [v]\n",
  "OPERATIZES": "OPERATIZE, to turn a play etc. into an opera, also OPERATISE [v]\n",
  "OPERATIZING": "OPERATIZE, to turn a play etc. into an opera, also OPERATISE [v]\n",
  "OPERATOR": "one who operates [n -S]\n",
  "OPERATORLESS": "without an operator [adj]\n",
  "OPERATORS": "OPERATOR, one who operates [n]\n",
  "OPERCELE": "an anatomical part that serves as a lid or cover, also OPERCULE, OPERCULUM [n -S]\n",
  "OPERCELES": "OPERCELE, an anatomical part that serves as a lid or cover, also OPERCULE, OPERCULUM [n]\n",
  "OPERCULA": "OPERCULUM, (Latin) an anatomical part that serves as a lid or cover, also OPERCELE, OPERCULE [n]\n",
  "OPERCULAR": "belonging to the operculum [adj] / the opercular bone [n -S]\n",
  "OPERCULARS": "OPERCULAR, the opercular bone [n]\n",
  "OPERCULATE": "relating to the operculum, also OPERCULATED [adj]\n",
  "OPERCULATED": "relating to the operculum, also OPERCULATE [adj]\n",
  "OPERCULE": "an anatomical part that serves as a lid or cover, also OPERCELE, OPERCULUM [n -S]\n",
  "OPERCULES": "OPERCULE, an anatomical part that serves as a lid or cover, also OPERCELE, OPERCULUM [n]\n",
  "OPERCULUM": "(Latin) an anatomical part that serves as a lid or cover, also OPERCELE, OPERCULE [n OPERCULUMS or OPERCULA]\n",
  "OPERCULUMS": "OPERCULUM, (Latin) an anatomical part that serves as a lid or cover, also OPERCELE, OPERCULE [n]\n",
  "OPERETTA": "(Italian) a light musical drama with dialogue [n -S]\n",
  "OPERETTAS": "OPERETTA, (Italian) a light musical drama with dialogue [n]\n",
  "OPERETTIST": "a composer of operettas [n -S]\n",
  "OPERETTISTS": "OPERETTIST, a composer of operettas [n]\n",
  "OPERON": "a group of genes operating as a unit [n -S]\n",
  "OPERONS": "OPERON, a group of genes operating as a unit [n]\n",
  "OPEROSE": "involving great labour [adj OPEROSELY]\n",
  "OPEROSELY": "OPEROSE, involving great labour [adv]\n",
  "OPEROSENESS": "the state of being operose [n -ES]\n",
  "OPEROSENESSES": "OPEROSENESS, the state of being operose [n]\n",
  "OPEROSITIES": "OPEROSITY, laboriousness [n]\n",
  "OPEROSITY": "laboriousness [n OPEROSITIES]\n",
  "OPES": "OPE, to open [v]\n",
  "OPGEFOK": "(South African) badly damaged, messed up [adj]\n",
  "OPHICALCITE": "a kind of marble, containing green serpentine [n -S]\n",
  "OPHICALCITES": "OPHICALCITE, a kind of marble, containing green serpentine [n]\n",
  "OPHICLEIDE": "a bass bugle-like keyed brass musical instrument [n -S]\n",
  "OPHICLEIDES": "OPHICLEIDE, a bass bugle-like keyed brass musical instrument [n]\n",
  "OPHIDIAN": "a snake [n -S]\n",
  "OPHIDIANS": "OPHIDIAN, a snake [n]\n",
  "OPHIDIARIA": "OPHIDIARIUM, a snake-house [n]\n",
  "OPHIDIARIUM": "a snake-house [n OPHIDIARIA or OPHIDIARIUMS]\n",
  "OPHIDIARIUMS": "OPHIDIARIUM, a snake-house [n]\n",
  "OPHIOLATER": "a snake-worshipper [n -S]\n",
  "OPHIOLATERS": "OPHIOLATER, a snake-worshipper [n]\n",
  "OPHIOLATRIES": "OPHIOLATRY, worship of snakes [n]\n",
  "OPHIOLATROUS": "worshipping snakes [adj]\n",
  "OPHIOLATRY": "worship of snakes [n OPHIOLATRIES]\n",
  "OPHIOLITE": "a slice of oceanic rock and upper mantle that has been thrust over the edge of a continent [n -S]\n",
  "OPHIOLITES": "OPHIOLITE, a slice of oceanic rock and upper mantle that has been thrust over the edge of a continent [n]\n",
  "OPHIOLITIC": "of or like ophiolite, serpentine [adj]\n",
  "OPHIOLOGIC": "relating to ophiology, the study of snakes, also OPHIOLOGICAL [adj]\n",
  "OPHIOLOGICAL": "relating to ophiology, the study of snakes, also OPHIOLOGIC [adj]\n",
  "OPHIOLOGIES": "OPHIOLOGY, the study of snakes [n]\n",
  "OPHIOLOGIST": "a student of ophiology [n -S]\n",
  "OPHIOLOGISTS": "OPHIOLOGIST, a student of ophiology [n]\n",
  "OPHIOLOGY": "the study of snakes [n OPHIOLOGIES]\n",
  "OPHIOMORPH": "a caecilian amphibian [n -S]\n",
  "OPHIOMORPHIC": "snakelike, also OPHIOMORPHOUS [adj]\n",
  "OPHIOMORPHOUS": "snakelike, also OPHIOMORPHIC [adj]\n",
  "OPHIOMORPHS": "OPHIOMORPH, a caecilian amphibian [n]\n",
  "OPHIOPHAGOUS": "eating snakes [adj]\n",
  "OPHIOPHILIST": "a snake-lover [n -S]\n",
  "OPHIOPHILISTS": "OPHIOPHILIST, a snake-lover [n]\n",
  "OPHITE": "a name given to various green-mottled rocks such as diabase and serpentine [n -S]\n",
  "OPHITES": "OPHITE, a name given to various green-mottled rocks such as diabase and serpentine [n]\n",
  "OPHITIC": "of or like an ophite, a name given to various green-mottled rocks such as diabase and serpentine [adj]\n",
  "OPHIURA": "a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURAN, OPHIURID, OPHIUROID [n -S]\n",
  "OPHIURAN": "a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURA, OPHIURID, OPHIUROID [n -S]\n",
  "OPHIURANS": "OPHIURAN, a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURA, OPHIURID, OPHIUROID [n]\n",
  "OPHIURAS": "OPHIURA, a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURAN, OPHIURID, OPHIUROID [n]\n",
  "OPHIURID": "a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURA, OPHIURAN, OPHIUROID [n -S]\n",
  "OPHIURIDS": "OPHIURID, a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURA, OPHIURAN, OPHIUROID [n]\n",
  "OPHIUROID": "a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURA, OPHIURAN, OPHIURID [n -S]\n",
  "OPHIUROIDS": "OPHIUROID, a member of the Ophiura genus of brittle-stars or sand-stars, also OPHIURA, OPHIURAN, OPHIURID [n]\n",
  "OPHTHALMIA": "an inflammation of the membranes or coats of the eye or of the eyeball [n -S]\n",
  "OPHTHALMIAS": "OPHTHALMIA, an inflammation of the membranes or coats of the eye or of the eyeball [n]\n",
  "OPHTHALMIC": "pertaining to or connected with the eye [adj]\n",
  "OPHTHALMIST": "an ophthalmologist [n -S]\n",
  "OPHTHALMISTS": "OPHTHALMIST, an ophthalmologist [n]\n",
  "OPHTHALMITIS": "ophthalmia [n -ES]\n",
  "OPHTHALMITISES": "OPHTHALMITIS, ophthalmia [n]\n",
  "OPHTHALMOLOGIC": "relating to ophthalmology [adj]\n",
  "OPHTHALMOLOGIES": "OPHTHALMOLOGY, the study of eye and its diseases [n]\n",
  "OPHTHALMOLOGIST": "one who studies ophthalmology, the science of the eye [n]\n",
  "OPHTHALMOLOGY": "the study of eye and its diseases [n OPHTHALMOLOGIES]\n",
  "OPHTHALMOMETER": "an instrument for measuring the eye [n -S]\n",
  "OPHTHALMOMETERS": "OPHTHALMOMETER, an instrument for measuring the eye [n]\n",
  "OPHTHALMOMETRY": "measurement of the eye [n]\n",
  "OPHTHALMOPHOBIA": "a morbid fear of being stared at [n]\n",
  "OPHTHALMOPLEGIA": "paralysis of the ocular muscles [n]\n",
  "OPHTHALMOSCOPE": "an instrument for viewing the interior of the eye [n -S]\n",
  "OPHTHALMOSCOPES": "OPHTHALMOSCOPE, an instrument for viewing the interior of the eye [n]\n",
  "OPHTHALMOSCOPIC": "relating to ophthalmoscope [adj]\n",
  "OPHTHALMOSCOPY": "an examination by use of an ophthalmoscope [n]\n",
  "OPIATE": "to treat with opium [v OPIATED, OPIATING, OPIATES]\n",
  "OPIATED": "OPIATE, to treat with opium [v]\n",
  "OPIATES": "OPIATE, to treat with opium [v]\n",
  "OPIATING": "OPIATE, to treat with opium [v]\n",
  "OPIFICER": "(obsolete) an artificer [n -S]\n",
  "OPIFICERS": "OPIFICER, (obsolete) an artificer [n]\n",
  "OPINABLE": "able to be thought [adj]\n",
  "OPINE": "to hold as an opinion [v OPINED, OPINING, OPINES]\n",
  "OPINED": "OPINE, to hold as an opinion [v]\n",
  "OPINES": "OPINE, to hold as an opinion [v]\n",
  "OPING": "OPE, to open [v]\n",
  "OPINICUS": "a composite heraldic beast, part lion, part dragon, with features of other animals [n -ES]\n",
  "OPINICUSES": "OPINICUS, a composite heraldic beast, part lion, part dragon, with features of other animals [n]\n",
  "OPINING": "OPINE, to hold as an opinion [v]\n",
  "OPINION": "a judgement one holds to be true [n -S]\n",
  "OPINIONATE": "to hold an opinion [v OPINIONATED, OPINIONATING, OPINIONATES]\n",
  "OPINIONATED": "unduly adhering to one's own opinion or to preconceived notions [adj OPINIONATEDLY]\n",
  "OPINIONATEDLY": "OPINIONATED, unduly adhering to one's own opinion or to preconceived notions [adv]\n",
  "OPINIONATEDNESS": "OPINIONATED, unduly adhering to one's own opinion or to preconceived notions [n]\n",
  "OPINIONATELY": "(obsolete) in an opinionated way [adv]\n",
  "OPINIONATES": "OPINIONATE, to hold an opinion [v]\n",
  "OPINIONATING": "OPINIONATE, to hold an opinion [v]\n",
  "OPINIONATIVE": "of, relating to, or consisting of opinion [adj OPINIONATIVELY]\n",
  "OPINIONATIVELY": "OPINIONATIVE, of, relating to, or consisting of opinion [adv]\n",
  "OPINIONATOR": "one who holds or gives an opinion [n -S]\n",
  "OPINIONATORS": "OPINIONATOR, one who holds or gives an opinion [n]\n",
  "OPINIONED": "opinionated; conceited [adj]\n",
  "OPINIONIST": "one fond of his own notions, or unduly attached to his own opinions [n -S]\n",
  "OPINIONISTS": "OPINIONIST, one fond of his own notions, or unduly attached to his own opinions [n]\n",
  "OPINIONS": "OPINION, a judgement one holds to be true [n]\n",
  "OPIOID": "a peptide that acts like opium [n -S]\n",
  "OPIOIDS": "OPIOID, a peptide that acts like opium [n]\n",
  "OPISOMETER": "an instrument for measuring curved lines [n -S]\n",
  "OPISOMETERS": "OPISOMETER, an instrument for measuring curved lines [n]\n",
  "OPISTHOBRANCH": "a type of mollusc having gills, little or no shell, two pairs of tentacles [n -S]\n",
  "OPISTHOBRANCHS": "OPISTHOBRANCH, a type of mollusc having gills, little or no shell, two pairs of tentacles [n]\n",
  "OPISTHOCOELIAN": "hollow or concave behind, as e.g. a vertebra is, also OPISTHOCOELOUS [adj]\n",
  "OPISTHOCOELOUS": "hollow or concave behind, as e.g. a vertebra is, also OPISTHOCOELIAN [adj]\n",
  "OPISTHODOMOI": "OPISTHODOMOS, (Greek) a portico or apartment at the back of an ancient Greek or Roman temple [n]\n",
  "OPISTHODOMOS": "(Greek) a portico or apartment at the back of an ancient Greek or Roman temple [n OPISTHODOMOI]\n",
  "OPISTHOGLOSSAL": "having the tongue attached in front, free behind, as in frogs [adj]\n",
  "OPISTHOGNATHISM": "the state of being opisthognathous, having receding jaws [n]\n",
  "OPISTHOGNATHOUS": "with receding jaws [adj]\n",
  "OPISTHOGRAPH": "a manuscript or slab inscribed on both back and front [n -S]\n",
  "OPISTHOGRAPHIC": "like an opisthograph, a manuscript or slab inscribed on the back as well as the front [adj]\n",
  "OPISTHOGRAPHIES": "OPISTHOGRAPHY, inscribing on the back as well as the front [n]\n",
  "OPISTHOGRAPHS": "OPISTHOGRAPH, a manuscript or slab inscribed on both back and front [n]\n",
  "OPISTHOGRAPHY": "inscribing on the back as well as the front [n OPISTHOGRAPHIES]\n",
  "OPISTHOSOMA": "the abdomen of a spider or other arachnid [n OPISTHOSOMATA]\n",
  "OPISTHOSOMATA": "OPISTHOSOMA, the abdomen of a spider or other arachnid [n]\n",
  "OPISTHOTONIC": "of or like opisthotonos, extreme arching backwards of the spine and neck as a result of spasm of the muscles in that region [adj]\n",
  "OPISTHOTONOS": "extreme arching backwards of the spine and neck as a result of spasm of the muscles in that region, etc. [n -ES]\n",
  "OPISTHOTONOSES": "OPISTHOTONOS, extreme arching backwards of the spine and neck as a result of spasm of the muscles in that region, etc. [n]\n",
  "OPIUM": "an addictive narcotic [n -S]\n",
  "OPIUMISM": "opium addiction [n -S]\n",
  "OPIUMISMS": "OPIUMISM, opium addiction [n]\n",
  "OPIUMS": "OPIUM, an addictive narcotic [n]\n",
  "OPOBALSAM": "balm of Gilead, the resinous exudation of certain trees [n -S]\n",
  "OPOBALSAMS": "OPOBALSAM, balm of Gilead, the resinous exudation of certain trees [n]\n",
  "OPODELDOC": "a name given by Paracelsus to various local medical applications, now used for a liniment based on soap dissolved in alcohol, with herbs and aromatic oils added [n -S]\n",
  "OPODELDOCS": "OPODELDOC, a name given by Paracelsus to various local medical applications, now used for a liniment based on soap dissolved in alcohol, with herbs and aromatic oils added [n]\n",
  "OPOPANAX": "(Greek) a medicinal gum-resin [n -ES]\n",
  "OPOPANAXES": "OPOPANAX, (Greek) a medicinal gum-resin [n]\n",
  "OPORICE": "(Greek) an old medicine made from summer fruits [n -S]\n",
  "OPORICES": "OPORICE, (Greek) an old medicine made from summer fruits [n]\n",
  "OPOSSUM": "(Native American) any of various small or medium-sized marsupial mammals, mostly arboreal [n -S]\n",
  "OPOSSUMS": "OPOSSUM, (Native American) any of various small or medium-sized marsupial mammals, mostly arboreal [n]\n",
  "OPOTHERAPIES": "OPOTHERAPY, treatment by administration of extracts of animal organs, esp. ductless glands [n]\n",
  "OPOTHERAPY": "treatment by administration of extracts of animal organs, esp. ductless glands [n OPOTHERAPIES]\n",
  "OPPIDAN": "a town-dweller; a student at Eton boarding in the town [n -S]\n",
  "OPPIDANS": "OPPIDAN, a town-dweller; a student at Eton boarding in the town [n]\n",
  "OPPIGNERATE": "(obsolete) to pawn, also OPPIGNORATE [v OPPIGNERATED, OPPIGNERATING, OPPIGNERATES]\n",
  "OPPIGNERATED": "OPPIGNERATE, (obsolete) to pawn, also OPPIGNORATE [v]\n",
  "OPPIGNERATES": "OPPIGNERATE, (obsolete) to pawn, also OPPIGNORATE [v]\n",
  "OPPIGNERATING": "OPPIGNERATE, (obsolete) to pawn, also OPPIGNORATE [v]\n",
  "OPPIGNERATION": "the act or an instance of pawning or pledging, also OPPIGNORATION [n -S]\n",
  "OPPIGNERATIONS": "OPPIGNERATION, the act or an instance of pawning or pledging, also OPPIGNORATION [n]\n",
  "OPPIGNORATE": "(obsolete) to pawn, also OPPIGNERATE [v OPPIGNORATED, OPPIGNORATING, OPPIGNORATES]\n",
  "OPPIGNORATED": "OPPIGNORATE, (obsolete) to pawn, also OPPIGNERATE [v]\n",
  "OPPIGNORATES": "OPPIGNORATE, (obsolete) to pawn, also OPPIGNERATE [v]\n",
  "OPPIGNORATING": "OPPIGNORATE, (obsolete) to pawn, also OPPIGNERATE [v]\n",
  "OPPIGNORATION": "the act of pawning, also OPPIGNERATION [n -S]\n",
  "OPPIGNORATIONS": "OPPIGNORATION, the act of pawning, also OPPIGNERATION [n]\n",
  "OPPILANT": "obstructed [adj]\n",
  "OPPILATE": "to block up [v OPPILATED, OPPILATING, OPPILATES]\n",
  "OPPILATED": "OPPILATE, to block up [v]\n",
  "OPPILATES": "OPPILATE, to block up [v]\n",
  "OPPILATING": "OPPILATE, to block up [v]\n",
  "OPPILATION": "a blockage, an obstruction [n -S]\n",
  "OPPILATIONS": "OPPILATION, a blockage, an obstruction [n]\n",
  "OPPILATIVE": "obstructive [adj]\n",
  "OPPO": "an opposite number or an opponent [n -S]\n",
  "OPPONENCIES": "OPPONENCY, the act of being an opponent [n]\n",
  "OPPONENCY": "the act of being an opponent [n OPPONENCIES]\n",
  "OPPONENS": "a muscle of the thumb [n OPPONENS]\n",
  "OPPONENT": "one that opposes another [n -S]\n",
  "OPPONENTS": "OPPONENT, one that opposes another [n]\n",
  "OPPORTUNE": "happening at the right time [adj OPPORTUNELY]\n",
  "OPPORTUNELY": "OPPORTUNE, happening at the right time [adv]\n",
  "OPPORTUNENESS": "OPPORTUNE, happening at the right time [n]\n",
  "OPPORTUNENESSES": "OPPORTUNENESS, OPPORTUNE, happening at the right time [n]\n",
  "OPPORTUNISM": "the practice of regulating actions by favourable opportunities rather than consistent principles [n -S]\n",
  "OPPORTUNISMS": "OPPORTUNISM, the practice of regulating actions by favourable opportunities rather than consistent principles [n]\n",
  "OPPORTUNIST": "one that is opportunistic or that practices opportunism [n -S]\n",
  "OPPORTUNISTIC": "taking advantage of opportunities as they arise [adj]\n",
  "OPPORTUNISTS": "OPPORTUNIST, one that is opportunistic or that practices opportunism [n]\n",
  "OPPORTUNITIES": "OPPORTUNITY, a favorable juncture of circumstances [n]\n",
  "OPPORTUNITY": "a favorable juncture of circumstances [n OPPORTUNITIES]\n",
  "OPPOS": "OPPO, an opposite number or an opponent [n]\n",
  "OPPOSABILITIES": "OPPOSABILITY, the state of being opposable [n]\n",
  "OPPOSABILITY": "the state of being opposable [n OPPOSABILITIES]\n",
  "OPPOSABLE": "that can be opposed [adj OPPOSABLY]\n",
  "OPPOSABLY": "OPPOSABLE, that can be opposed [adv]\n",
  "OPPOSE": "to conflict with [v OPPOSED, OPPOSING, OPPOSES]\n",
  "OPPOSED": "OPPOSE, to conflict with [v]\n",
  "OPPOSELESS": "(Shakespeare) not to be opposed; irresistible [adj]\n",
  "OPPOSER": "one who opposes [n -S]\n",
  "OPPOSERS": "OPPOSER, one who opposes [n]\n",
  "OPPOSES": "OPPOSE, to conflict with [v]\n",
  "OPPOSING": "OPPOSE, to conflict with [v]\n",
  "OPPOSINGLY": "OPPOSING, OPPOSE, to conflict with [adv]\n",
  "OPPOSITE": "radically different from another in some related way [adj OPPOSITELY] / something opposite [n -S]\n",
  "OPPOSITELY": "OPPOSITE, radically different from another in some related way [adv]\n",
  "OPPOSITENESS": "the state of being opposite [n -ES]\n",
  "OPPOSITENESSES": "OPPOSITENESS, the state of being opposite [n]\n",
  "OPPOSITES": "OPPOSITE, something opposite [n]\n",
  "OPPOSITION": "the act of opposing [n -S]\n",
  "OPPOSITIONAL": "relating to opposition [adj]\n",
  "OPPOSITIONIST": "a member of an opposition [n -S]\n",
  "OPPOSITIONISTS": "OPPOSITIONIST, a member of an opposition [n]\n",
  "OPPOSITIONLESS": "without opposition [adj]\n",
  "OPPOSITIONS": "OPPOSITION, the act of opposing [n]\n",
  "OPPOSITIVE": "capable of being put in opposition [adj]\n",
  "OPPRESS": "to treat with tyrannical injustice [v -ED, -ING, -ES]\n",
  "OPPRESSED": "OPPRESS, to treat with tyrannical injustice [v]\n",
  "OPPRESSES": "OPPRESS, to treat with tyrannical injustice [v]\n",
  "OPPRESSING": "OPPRESS, to treat with tyrannical injustice [v]\n",
  "OPPRESSINGLY": "OPPRESSING, OPPRESS, to treat with tyrannical injustice [adv]\n",
  "OPPRESSION": "unjust or cruel exercise of authority or power [n -S]\n",
  "OPPRESSIONS": "OPPRESSION, unjust or cruel exercise of authority or power [n]\n",
  "OPPRESSIVE": "unreasonably burdensome or severe [adj OPPRESSIVELY]\n",
  "OPPRESSIVELY": "OPPRESSIVE, unreasonably burdensome or severe [adv]\n",
  "OPPRESSIVENESS": "OPPRESSIVE, unreasonably burdensome or severe [n]\n",
  "OPPRESSOR": "one that oppresses [n -S]\n",
  "OPPRESSORS": "OPPRESSOR, one that oppresses [n]\n",
  "OPPROBRIOUS": "expressing contemptuous reproach; bringing disgrace [adj OPPROBRIOUSLY]\n",
  "OPPROBRIOUSLY": "OPPROBRIOUS, expressing contemptuous reproach; bringing disgrace [adv]\n",
  "OPPROBRIOUSNESS": "OPPROBRIOUS, expressing contemptuous reproach; bringing disgrace [n]\n",
  "OPPROBRIUM": "something that brings disgrace; infamy, contempt [n -S]\n",
  "OPPROBRIUMS": "OPPROBRIUM, something that brings disgrace; infamy, contempt [n]\n",
  "OPPUGN": "to assail with argument [v -ED, -ING, -S]\n",
  "OPPUGNANCIES": "OPPUGNANCY, (Shakespeare) antagonism [n]\n",
  "OPPUGNANCY": "(Shakespeare) antagonism [n OPPUGNANCIES]\n",
  "OPPUGNANT": "opposing [adj OPPUGNANTLY] / an opponent [n -S]\n",
  "OPPUGNANTLY": "OPPUGNANT, opposing [adv]\n",
  "OPPUGNANTS": "OPPUGNANT, an opponent [n]\n",
  "OPPUGNED": "OPPUGN, to assail with argument [v]\n",
  "OPPUGNER": "one who oppugns [n -S]\n",
  "OPPUGNERS": "OPPUGNER, one who oppugns [n]\n",
  "OPPUGNING": "OPPUGN, to assail with argument [v]\n",
  "OPPUGNS": "OPPUGN, to assail with argument [v]\n",
  "OPS": "OP, (short for) an operation [n]\n",
  "OPSIMATH": "one who learns late in life [n -S]\n",
  "OPSIMATHIES": "OPSIMATHY, education late in life [n]\n",
  "OPSIMATHS": "OPSIMATH, one who learns late in life [n]\n",
  "OPSIMATHY": "education late in life [n OPSIMATHIES]\n",
  "OPSIN": "a protein which forms part of the visual pigment rhodopsin [n -S]\n",
  "OPSINS": "OPSIN, a protein which forms part of the visual pigment rhodopsin [n]\n",
  "OPSIOMETER": "an instrument for testing vision [n -S]\n",
  "OPSIOMETERS": "OPSIOMETER, an instrument for testing vision [n]\n",
  "OPSOMANIA": "an abnormal love for one kind of food [n -S]\n",
  "OPSOMANIAC": "one who loves a certain kind of food, bordering on madness [n -S]\n",
  "OPSOMANIACS": "OPSOMANIAC, one who loves a certain kind of food, bordering on madness [n]\n",
  "OPSOMANIAS": "OPSOMANIA, an abnormal love for one kind of food [n]\n",
  "OPSONIC": "relating to opsonin, a substance of blood serum making bacteria vulnerable to phagocytic action [adj]\n",
  "OPSONIFICATION": "the process of opsonifying [n -S]\n",
  "OPSONIFICATIONS": "OPSONIFICATION, the process of opsonifying [n]\n",
  "OPSONIFIED": "OPSONIFY, to form opsonins in, a substance of blood serum making bacteria vulnerable to phagocytic action [v]\n",
  "OPSONIFIES": "OPSONIFY, to form opsonins in, a substance of blood serum making bacteria vulnerable to phagocytic action [v]\n",
  "OPSONIFY": "to form opsonins in, a substance of blood serum making bacteria vulnerable to phagocytic action [v OPSONIFIED, OPSONIFYING, OPSONIFIES]\n",
  "OPSONIFYING": "OPSONIFY, to form opsonins in, a substance of blood serum making bacteria vulnerable to phagocytic action [v]\n",
  "OPSONIN": "a substance of blood serum making bacteria vulnerable to phagocytic action [n -S]\n",
  "OPSONINS": "OPSONIN, a substance of blood serum making bacteria vulnerable to phagocytic action [n]\n",
  "OPSONISATION": "the process of opsonising, also OPSONIZATION [n -S]\n",
  "OPSONISATIONS": "OPSONISATION, the process of opsonising, also OPSONIZATION [n]\n",
  "OPSONISE": "to make (bacteria) more susceptible to consumption by phagocytes, also OPSONIZE [v OPSONISED, OPSONISING, OPSONISES]\n",
  "OPSONISED": "OPSONISE, to make (bacteria) more susceptible to consumption by phagocytes, also OPSONIZE [v]\n",
  "OPSONISES": "OPSONISE, to make (bacteria) more susceptible to consumption by phagocytes, also OPSONIZE [v]\n",
  "OPSONISING": "OPSONISE, to make (bacteria) more susceptible to consumption by phagocytes, also OPSONIZE [v]\n",
  "OPSONIUM": "anything eaten with bread as a relish [n -S]\n",
  "OPSONIUMS": "OPSONIUM, anything eaten with bread as a relish [n]\n",
  "OPSONIZATION": "the process of opsonizing, also OPSONISATION [n -S]\n",
  "OPSONIZATIONS": "OPSONIZATION, the process of opsonizing, also OPSONISATION [n]\n",
  "OPSONIZE": "to make (bacteria) more susceptible to consumption by phagocytes, also OPSONISE, OPSONIFY [v OPSONIZED, OPSONIZING, OPSONIZES]\n",
  "OPSONIZED": "OPSONIZE, to make (bacteria) more susceptible to consumption by phagocytes, also OPSONISE, OPSONIFY [v]\n",
  "OPSONIZES": "OPSONIZE, to make (bacteria) more susceptible to consumption by phagocytes, also OPSONISE, OPSONIFY [v]\n",
  "OPSONIZING": "OPSONIZE, to make (bacteria) more susceptible to consumption by phagocytes, also OPSONISE, OPSONIFY [v]\n",
  "OPT": "to decide or choose [v -ED, -ING, -S]\n",
  "OPTANT": "a person who opts, esp. one who chooses a nationality [n -S]\n",
  "OPTANTS": "OPTANT, a person who opts, esp. one who chooses a nationality [n]\n",
  "OPTATIVE": "expressing a wish [adj OPTATIVELY] / a grammatical mood expressing a desire or wish [n -S]\n",
  "OPTATIVELY": "OPTATIVE, expressing a wish [adv]\n",
  "OPTATIVES": "OPTATIVE, a grammatical mood expressing a desire or wish [n]\n",
  "OPTED": "OPT, to decide or choose [v]\n",
  "OPTER": "someone who opts [n -S]\n",
  "OPTERS": "OPTER, someone who opts [n]\n",
  "OPTIC": "relating to vision [adj OPTICALLY] / an eye [n -S]\n",
  "OPTICAL": "pertaining to sight [adj OPTICALLY]\n",
  "OPTICALLY": "OPTICAL, pertaining to sight [adv]\n",
  "OPTICIAN": "one who deals in optical goods [n -S]\n",
  "OPTICIANS": "OPTICIAN, one who deals in optical goods [n]\n",
  "OPTICIST": "one engaged in the study of light and vision [n -S]\n",
  "OPTICISTS": "OPTICIST, one engaged in the study of light and vision [n]\n",
  "OPTICS": "OPTIC, an eye [n]\n",
  "OPTIMA": "OPTIMUM, (Latin) the most favourable point of any condition [n]\n",
  "OPTIMAL": "best, most desirable [adj OPTIMALLY]\n",
  "OPTIMALISATION": "the process of optimalising, also OPTIMALIZATION [n -S]\n",
  "OPTIMALISATIONS": "OPTIMALISATION, the process of optimalising, also OPTIMALIZATION [n]\n",
  "OPTIMALISE": "to bring to the most desirable or most efficient state, also OPTIMALIZE [v OPTIMALISED, OPTIMALISING, OPTIMALISES]\n",
  "OPTIMALISED": "OPTIMALISE, to bring to the most desirable or most efficient state, also OPTIMALIZE [v]\n",
  "OPTIMALISES": "OPTIMALISE, to bring to the most desirable or most efficient state, also OPTIMALIZE [v]\n",
  "OPTIMALISING": "OPTIMALISE, to bring to the most desirable or most efficient state, also OPTIMALIZE [v]\n",
  "OPTIMALITIES": "OPTIMALITY, the state of being optimal [n]\n",
  "OPTIMALITY": "the state of being optimal [n OPTIMALITIES]\n",
  "OPTIMALIZATION": "the process of optimalizing, also OPTIMALISATION [n -S]\n",
  "OPTIMALIZATIONS": "OPTIMALIZATION, the process of optimalizing, also OPTIMALISATION [n]\n",
  "OPTIMALIZE": "to bring to the most desirable or most efficient state, also OPTIMALISE [v OPTIMALIZED, OPTIMALIZING, OPTIMALIZES]\n",
  "OPTIMALIZED": "OPTIMALIZE, to bring to the most desirable or most efficient state, also OPTIMALISE [v]\n",
  "OPTIMALIZES": "OPTIMALIZE, to bring to the most desirable or most efficient state, also OPTIMALISE [v]\n",
  "OPTIMALIZING": "OPTIMALIZE, to bring to the most desirable or most efficient state, also OPTIMALISE [v]\n",
  "OPTIMALLY": "OPTIMAL, best, most desirable [adv]\n",
  "OPTIMATE": "a member of the aristocracy [n -S]\n",
  "OPTIMATES": "OPTIMATE, a member of the aristocracy [n]\n",
  "OPTIME": "(Latin) an honour student in mathematics at Cambridge University [n -S]\n",
  "OPTIMES": "OPTIME, (Latin) an honour student in mathematics at Cambridge University [n]\n",
  "OPTIMISATION": "the act of optimising, also OPTIMIZATION [n -S]\n",
  "OPTIMISATIONS": "OPTIMISATION, the act of optimising, also OPTIMIZATION [n]\n",
  "OPTIMISE": "to make as effective as possible, also OPTIMIZE [v OPTIMISED, OPTIMISING, OPTIMISES]\n",
  "OPTIMISED": "OPTIMISE, to make as effective as possible, also OPTIMIZE [v]\n",
  "OPTIMISER": "one who optimises, also OPTIMIZER [n -S]\n",
  "OPTIMISERS": "OPTIMISER, one who optimises, also OPTIMIZER [n]\n",
  "OPTIMISES": "OPTIMISE, to make as effective as possible, also OPTIMIZE [v]\n",
  "OPTIMISING": "OPTIMISE, to make as effective as possible, also OPTIMIZE [v]\n",
  "OPTIMISM": "a disposition that looks on the sunny side [n -S]\n",
  "OPTIMISMS": "OPTIMISM, a disposition that looks on the sunny side [n]\n",
  "OPTIMIST": "one who exhibits optimism [n -S]\n",
  "OPTIMISTIC": "having optimism, also OPTIMISTICAL [adj OPTIMISTICALLY]\n",
  "OPTIMISTICAL": "optimistic, also OPTIMISTIC [adj OPTIMISTICALLY]\n",
  "OPTIMISTICALLY": "OPTIMISTICAL, optimistic, also OPTIMISTIC [adv]\n",
  "OPTIMISTS": "OPTIMIST, one who exhibits optimism [n]\n",
  "OPTIMIZATION": "the act of optimizing, also OPTIMISATION [n -S]\n",
  "OPTIMIZATIONS": "OPTIMIZATION, the act of optimizing, also OPTIMISATION [n]\n",
  "OPTIMIZE": "to make as effective as possible, also OPTIMISE [v OPTIMIZED, OPTIMIZING, OPTIMIZES]\n",
  "OPTIMIZED": "OPTIMIZE, to make as effective as possible, also OPTIMISE [v]\n",
  "OPTIMIZER": "one who optimises, also OPTIMISER [n -S]\n",
  "OPTIMIZERS": "OPTIMIZER, one who optimises, also OPTIMISER [n]\n",
  "OPTIMIZES": "OPTIMIZE, to make as effective as possible, also OPTIMISE [v]\n",
  "OPTIMIZING": "OPTIMIZE, to make as effective as possible, also OPTIMISE [v]\n",
  "OPTIMUM": "(Latin) the most favourable point of any condition [n OPTIMUMS or OPTIMA]\n",
  "OPTIMUMS": "OPTIMUM, (Latin) the most favourable point of any condition [n]\n",
  "OPTING": "OPT, to decide or choose [v]\n",
  "OPTION": "to grant the act of choosing [v -ED, -ING, -S]\n",
  "OPTIONAL": "not compulsory [adj OPTIONALLY] / an elective course of study [n -S]\n",
  "OPTIONALITIES": "OPTIONALITY, the state of being optional [n]\n",
  "OPTIONALITY": "the state of being optional [n OPTIONALITIES]\n",
  "OPTIONALLY": "OPTIONAL, not compulsory [adv]\n",
  "OPTIONALS": "OPTIONAL, an elective course of study [n]\n",
  "OPTIONED": "OPTION, to grant the act of choosing [v]\n",
  "OPTIONEE": "one who holds a legal option [n -S]\n",
  "OPTIONEES": "OPTIONEE, one who holds a legal option [n]\n",
  "OPTIONING": "OPTION, to grant the act of choosing [v]\n",
  "OPTIONS": "OPTION, to grant the act of choosing [v]\n",
  "OPTOACOUSTIC": "relating to or combining both vision and hearing [adj]\n",
  "OPTOELECTRONIC": "relating to optoelectronics [adj]\n",
  "OPTOELECTRONICS": "a branch of electronics that deals with electronic devices for emitting, modulating, transmitting, and sensing light [n]\n",
  "OPTOKINETIC": "of, relating to, or involving movements of the eyes [adj]\n",
  "OPTOLOGIES": "OPTOLOGY, the study of sight [n]\n",
  "OPTOLOGIST": "an optician [n -S]\n",
  "OPTOLOGISTS": "OPTOLOGIST, an optician [n]\n",
  "OPTOLOGY": "the study of sight [n OPTOLOGIES]\n",
  "OPTOMETER": "an instrument for testing vision [n -S]\n",
  "OPTOMETERS": "OPTOMETER, an instrument for testing vision [n]\n",
  "OPTOMETRIC": "relating to optometry, also OPTOMETRICAL [adj]\n",
  "OPTOMETRICAL": "relating to optometry, also OPTOMETRIC [adj]\n",
  "OPTOMETRIES": "OPTOMETRY, the science of vision and eye-care [n]\n",
  "OPTOMETRIST": "an ophthalmic optician; a person qualified to practise optometry [n -S]\n",
  "OPTOMETRISTS": "OPTOMETRIST, an ophthalmic optician; a person qualified to practise optometry [n]\n",
  "OPTOMETRY": "the science of vision and eye-care [n OPTOMETRIES]\n",
  "OPTOPHONE": "a device transforming light into sound [n -S]\n",
  "OPTOPHONES": "OPTOPHONE, a device transforming light into sound [n]\n",
  "OPTRONIC": "pertaining to the science concerned with electronics and light [adj]\n",
  "OPTRONICS": "the study or use of devices involving the interaction of electronic and light signals [n]\n",
  "OPTS": "OPT, to decide or choose [v]\n",
  "OPULENCE": "conspicuous wealth, also OPULENCY [n -S]\n",
  "OPULENCES": "OPULENCE, conspicuous wealth, also OPULENCY [n]\n",
  "OPULENCIES": "OPULENCY, conspicuous wealth, also OPULENCE [n]\n",
  "OPULENCY": "conspicuous wealth, also OPULENCE [n OPULENCIES]\n",
  "OPULENT": "wealthy [adj OPULENTLY]\n",
  "OPULENTLY": "OPULENT, wealthy [adv]\n",
  "OPULUS": "(Latin) the guelder-rose [n -ES]\n",
  "OPULUSES": "OPULUS, (Latin) the guelder-rose [n]\n",
  "OPUNTIA": "(Latin) a genus of cactaceous plants, the prickly pear, or Indian fig [n -S]\n",
  "OPUNTIAS": "OPUNTIA, (Latin) a genus of cactaceous plants, the prickly pear, or Indian fig [n]\n",
  "OPUS": "(Latin) a work, esp. an artistic or literary work [n OPUSES or OPERA]\n",
  "OPUSCLE": "a short work, also OPUSCULE, OPUSCULUM [n -S]\n",
  "OPUSCLES": "OPUSCLE, a short work, also OPUSCULE, OPUSCULUM [n]\n",
  "OPUSCULA": "OPUSCULE, a short work, also OPUSCLE, OPUSCULUM [n]\n",
  "OPUSCULAR": "of or like an opuscule [adj]\n",
  "OPUSCULE": "a short work, also OPUSCLE, OPUSCULUM [n -S]\n",
  "OPUSCULES": "OPUSCULE, a short work, also OPUSCLE, OPUSCULUM [n]\n",
  "OPUSCULUM": "a short work, also OPUSCLE, OPUSCULE [n OPUSCULA]\n",
  "OPUSES": "OPUS, (Latin) a work, esp. an artistic or literary work [n]\n",
  "OQUASSA": "(Native American) a small, handsome trout, found in some of the lakes in Maine [n -S]\n",
  "OQUASSAS": "OQUASSA, (Native American) a small, handsome trout, found in some of the lakes in Maine [n]\n",
  "OR": "the heraldic tincture gold [n -S]\n",
  "ORA": "OS, (Latin) a bone [n]\n",
  "ORACH": "a plant of the goosefoot family, also ORACHE [n -ES]\n",
  "ORACHE": "a plant of the goosefoot family, also ORACH [n -S]\n",
  "ORACHES": "ORACHE, a plant of the goosefoot family, also ORACH [n]\n",
  "ORACIES": "ORACY, skill in oral communication [n]\n",
  "ORACLE": "to utter as an oracle [v ORACLED, ORACLING, ORACLES]\n",
  "ORACLED": "ORACLE, to utter as an oracle [v]\n",
  "ORACLES": "ORACLE, to utter as an oracle [v]\n",
  "ORACLING": "ORACLE, to utter as an oracle [v]\n",
  "ORACULAR": "of the nature of an oracle, also ORACULOUS [adj ORACULARLY]\n",
  "ORACULARITIES": "ORACULARITY, the state of being oracular [n]\n",
  "ORACULARITY": "the state of being oracular [n ORACULARITIES]\n",
  "ORACULARLY": "ORACULAR, of the nature of an oracle, also ORACULOUS [adv]\n",
  "ORACULARNESS": "the state of being oracular [n -ES]\n",
  "ORACULARNESSES": "ORACULARNESS, the state of being oracular [n]\n",
  "ORACULOUS": "of the nature of an oracle, also ORACULAR [adj ORACULOUSLY]\n",
  "ORACULOUSLY": "ORACULOUS, of the nature of an oracle, also ORACULAR [adv]\n",
  "ORACULOUSNESS": "ORACULOUS, of the nature of an oracle, also ORACULAR [n]\n",
  "ORACULOUSNESSES": "ORACULOUSNESS, ORACULOUS, of the nature of an oracle, also ORACULAR [n]\n",
  "ORACY": "skill in oral communication [n ORACIES]\n",
  "ORAD": "towards the mouth [adv]\n",
  "ORAGIOUS": "stormy [adj]\n",
  "ORAL": "relating to the mouth; uttered by the mouth [adj ORALLY] / an oral examination [n -S]\n",
  "ORALISM": "the use of the oral method for teaching the deaf [n -S]\n",
  "ORALISMS": "ORALISM, the use of the oral method for teaching the deaf [n]\n",
  "ORALIST": "one who practises oralism, the use of oral methods of teaching the deaf [n -S]\n",
  "ORALISTS": "ORALIST, one who practises oralism, the use of oral methods of teaching the deaf [n]\n",
  "ORALITIES": "ORALITY, the state of being produced orally [n]\n",
  "ORALITY": "the state of being produced orally [n ORALITIES]\n",
  "ORALLY": "ORAL, relating to the mouth; uttered by the mouth [adv]\n",
  "ORALS": "ORAL, an oral examination [n]\n",
  "ORANG": "(Malay) a reddish-brown, tree-dwelling anthropoid ape, found only in the forests of Sumatra and Borneo, also ORANGUTAN, OURANG [n -S]\n",
  "ORANGE": "a citrus fruit [n -S] / the colour of an orange (a fruit) [adj ORANGER, ORANGEST]\n",
  "ORANGEADE": "a soft drink made from oranges [n -S]\n",
  "ORANGEADES": "ORANGEADE, a soft drink made from oranges [n]\n",
  "ORANGER": "ORANGE, the colour of an orange (a fruit) [adj]\n",
  "ORANGERIE": "(French) a building for growing orange trees in a cool climate, also ORANGERY [n -S]\n",
  "ORANGERIES": "ORANGERY, a building for growing orange trees in a cool climate, also ORANGERIE [n]\n",
  "ORANGERY": "a building for growing orange trees in a cool climate, also ORANGERIE [n ORANGERIES]\n",
  "ORANGES": "ORANGE, a citrus fruit [n]\n",
  "ORANGEST": "ORANGE, the colour of an orange (a fruit) [adj]\n",
  "ORANGEWOOD": "the wood of the orange-tree [n -S]\n",
  "ORANGEWOODS": "ORANGEWOOD, the wood of the orange-tree [n]\n",
  "ORANGEY": "somewhat orange, also ORANGY [adj ORANGIER, ORANGIEST]\n",
  "ORANGIER": "ORANGY, resembling the colour of an orange, also ORANGEY [adj]\n",
  "ORANGIEST": "ORANGY, resembling the colour of an orange, also ORANGEY [adj]\n",
  "ORANGISH": "somewhat orange in colour [adj]\n",
  "ORANGS": "ORANG, (Malay) a reddish-brown, tree-dwelling anthropoid ape, found only in the forests of Sumatra and Borneo, also ORANGUTAN, OURANG [n]\n",
  "ORANGUTAN": "(Malay) a reddish-brown, tree-dwelling anthropoid ape, found only in the forests of Sumatra and Borneo, also ORANG, OURANG [n -S]\n",
  "ORANGUTANS": "ORANGUTAN, (Malay) a reddish-brown, tree-dwelling anthropoid ape, found only in the forests of Sumatra and Borneo, also ORANG, OURANG [n]\n",
  "ORANGY": "resembling the colour of an orange, also ORANGEY [adj ORANGIER, ORANGIEST]\n",
  "ORANT": "a representation of a praying figure in early art [n -S]\n",
  "ORANTS": "ORANT, a representation of a praying figure in early art [n]\n",
  "ORARIA": "ORARION, in the Orthodox Church, a deacon's stole, also ORARIUM [n]\n",
  "ORARIAN": "a coast-dweller [n -S]\n",
  "ORARIANS": "ORARIAN, a coast-dweller [n]\n",
  "ORARION": "in the Orthodox Church, a deacon's stole, also ORARIUM [n -S]\n",
  "ORARIONS": "ORARION, in the Orthodox Church, a deacon's stole, also ORARIUM [n]\n",
  "ORARIUM": "(Latin) in the Orthodox Church, a deacon's stole, also ORARION [n ORARIA]\n",
  "ORATE": "to speak formally [v ORATED, ORATING, ORATES]\n",
  "ORATED": "ORATE, to speak formally [v]\n",
  "ORATES": "ORATE, to speak formally [v]\n",
  "ORATING": "ORATE, to speak formally [v]\n",
  "ORATION": "a formal speech [n -S]\n",
  "ORATIONS": "ORATION, a formal speech [n]\n",
  "ORATOR": "one that orates [n -S]\n",
  "ORATORIAL": "of an orator or an oratory [adj]\n",
  "ORATORIAN": "a father or priest of an oratory, a Roman Catholic school [n -S]\n",
  "ORATORIANS": "ORATORIAN, a father or priest of an oratory, a Roman Catholic school [n]\n",
  "ORATORICAL": "of or like an orator [adj ORATORICALLY]\n",
  "ORATORICALLY": "ORATORICAL, of or like an orator [adv]\n",
  "ORATORIES": "ORATORY, the art of public speaking [n]\n",
  "ORATORIO": "(Italian) a choral work usually on a scriptural subject [n -S]\n",
  "ORATORIOS": "ORATORIO, (Italian) a choral work usually on a scriptural subject [n]\n",
  "ORATORS": "ORATOR, one that orates [n]\n",
  "ORATORY": "the art of public speaking [n ORATORIES]\n",
  "ORATRESS": "a female orator, also ORATRIX [n -ES]\n",
  "ORATRESSES": "ORATRESS, a female orator, also ORATRIX [n]\n",
  "ORATRICES": "ORATRIX, (Latin) a female orator, also ORATRESS [n]\n",
  "ORATRIX": "(Latin) a female orator, also ORATRESS [n ORATRIXES or ORATRICES]\n",
  "ORATRIXES": "ORATRIX, (Latin) a female orator, also ORATRESS [n]\n",
  "ORATURE": "oral forms of literature such as folklore [n -S]\n",
  "ORATURES": "ORATURE, oral forms of literature such as folklore [n]\n",
  "ORB": "to form into a sphere [v -ED, -ING, -S]\n",
  "ORBED": "ORB, to form into a sphere [v]\n",
  "ORBICULAR": "spherical [adj ORBICULARLY]\n",
  "ORBICULARES": "ORBICULARIS, a muscle surrounding an opening [n]\n",
  "ORBICULARIS": "a muscle surrounding an opening [n ORBICULARES]\n",
  "ORBICULARITIES": "ORBICULARITY, the state of being orbicular [n]\n",
  "ORBICULARITY": "the state of being orbicular [n ORBICULARITIES]\n",
  "ORBICULARLY": "ORBICULAR, spherical [adv]\n",
  "ORBICULATE": "having the shape of a solid the vertical section of which is oval, and the horizontal section circular, also ORBICULATED [adj]\n",
  "ORBICULATED": "having the shape of a solid the vertical section of which is oval, and the horizontal section circular, also ORBICULATE [adj]\n",
  "ORBIER": "ORBY, resembling a sphere [adj]\n",
  "ORBIEST": "ORBY, resembling a sphere [adj]\n",
  "ORBING": "ORB, to form into a sphere [v]\n",
  "ORBIT": "to revolve around [v -ED, -ING, -S]\n",
  "ORBITA": "(Latin) the hollow in which the eyeball rests [n -S]\n",
  "ORBITAL": "relating to an orbit [adj ORBITALLY] / an orbit [n -S]\n",
  "ORBITALLY": "ORBITAL, relating to an orbit [adv]\n",
  "ORBITALS": "ORBITAL, an orbit [n]\n",
  "ORBITAS": "ORBITA, (Latin) the hollow in which the eyeball rests [n]\n",
  "ORBITED": "ORBIT, to revolve around [v]\n",
  "ORBITER": "a spacecraft that orbits [n -S]\n",
  "ORBITERS": "ORBITER, a spacecraft that orbits [n]\n",
  "ORBITIES": "ORBITY, (obsolete) bereavement, esp. of children [n]\n",
  "ORBITING": "ORBIT, to revolve around [v]\n",
  "ORBITS": "ORBIT, to revolve around [v]\n",
  "ORBITY": "(obsolete) bereavement, esp. of children [n ORBITIES]\n",
  "ORBLESS": "not having an orb [adj]\n",
  "ORBLIKE": "like an orb [adj]\n",
  "ORBS": "ORB, to form into a sphere [v]\n",
  "ORBY": "resembling a sphere [adj ORBIER, ORBIEST]\n",
  "ORC": "a killer whale, also ORCA [n -S]\n",
  "ORCA": "a marine mammal, also ORC [n -S]\n",
  "ORCAS": "ORCA, a marine mammal, also ORC [n]\n",
  "ORCEIN": "a purple dyestuff obtained from orcinol, forming the essential coloring matter of cudbear and archil [n -S]\n",
  "ORCEINS": "ORCEIN, a purple dyestuff obtained from orcinol, forming the essential coloring matter of cudbear and archil [n]\n",
  "ORCHARD": "an area where fruit trees are grown, also ORCHAT [n -S]\n",
  "ORCHARDING": "the cultivation of orchards [n -S]\n",
  "ORCHARDINGS": "ORCHARDING, the cultivation of orchards [n]\n",
  "ORCHARDIST": "one who cultivates an orchard [n -S]\n",
  "ORCHARDISTS": "ORCHARDIST, one who cultivates an orchard [n]\n",
  "ORCHARDMAN": "one who grows and sells orchard fruits [n ORCHARDMEN]\n",
  "ORCHARDMEN": "ORCHARDMAN, one who grows and sells orchard fruits [n]\n",
  "ORCHARDS": "ORCHARD, an area where fruit trees are grown, also ORCHAT [n]\n",
  "ORCHAT": "an area where fruit trees are grown, also ORCHARD [n -S]\n",
  "ORCHATS": "ORCHAT, an area where fruit trees are grown, also ORCHARD [n]\n",
  "ORCHEL": "a dye obtained from certain lichens, also ARCHIL, ORCHELLA, ORCHIL, ORCHILLA, ORSEILLE [n -S]\n",
  "ORCHELLA": "a dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHIL, ORCHILLA, ORSEILLE [n -S]\n",
  "ORCHELLAS": "ORCHELLA, a dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHIL, ORCHILLA, ORSEILLE [n]\n",
  "ORCHELS": "ORCHEL, a dye obtained from certain lichens, also ARCHIL, ORCHELLA, ORCHIL, ORCHILLA, ORSEILLE [n]\n",
  "ORCHESES": "ORCHESIS, an art of dancing [n]\n",
  "ORCHESIS": "an art of dancing [n ORCHESES]\n",
  "ORCHESOGRAPHIES": "ORCHESOGRAPHY, notation of dancing [n]\n",
  "ORCHESOGRAPHY": "notation of dancing [n ORCHESOGRAPHIES]\n",
  "ORCHESTIC": "relating to dancing [adj]\n",
  "ORCHESTICS": "the art of dancing [n]\n",
  "ORCHESTRA": "a large company of musicians (strings, woodwind, brass, and percussion) playing together under a conductor [n -S]\n",
  "ORCHESTRAL": "relating to or composed for an orchestra, also ORCHESTRIC [adj ORCHESTRALLY]\n",
  "ORCHESTRALIST": "an orchestral composer [n -S]\n",
  "ORCHESTRALISTS": "ORCHESTRALIST, an orchestral composer [n]\n",
  "ORCHESTRALLY": "ORCHESTRAL, relating to or composed for an orchestra, also ORCHESTRIC [adv]\n",
  "ORCHESTRAS": "ORCHESTRA, a large company of musicians (strings, woodwind, brass, and percussion) playing together under a conductor [n]\n",
  "ORCHESTRATE": "to compose or arrange (music) for an orchestra [v ORCHESTRATED, ORCHESTRATING, ORCHESTRATES]\n",
  "ORCHESTRATED": "ORCHESTRATE, to compose or arrange (music) for an orchestra [v]\n",
  "ORCHESTRATER": "one who orchestrates, also ORCHESTRATOR [n -S]\n",
  "ORCHESTRATERS": "ORCHESTRATER, one who orchestrates, also ORCHESTRATOR [n]\n",
  "ORCHESTRATES": "ORCHESTRATE, to compose or arrange (music) for an orchestra [v]\n",
  "ORCHESTRATING": "ORCHESTRATE, to compose or arrange (music) for an orchestra [v]\n",
  "ORCHESTRATION": "the arrangement of a musical composition for performance by an orchestra [n -S]\n",
  "ORCHESTRATIONAL": "relating to orchestration [adj]\n",
  "ORCHESTRATIONS": "ORCHESTRATION, the arrangement of a musical composition for performance by an orchestra [n]\n",
  "ORCHESTRATOR": "one who orchestrates, also ORCHESTRATER [n -S]\n",
  "ORCHESTRATORS": "ORCHESTRATOR, one who orchestrates, also ORCHESTRATER [n]\n",
  "ORCHESTRIC": "relating to or composed for an orchestra, also ORCHESTRAL [adj]\n",
  "ORCHESTRINA": "a name given to various keyboard or barrel organ instruments designed to imitate an orchestra, also ORCHESTRION [n -S]\n",
  "ORCHESTRINAS": "ORCHESTRINA, a name given to various keyboard or barrel organ instruments designed to imitate an orchestra, also ORCHESTRION [n]\n",
  "ORCHESTRION": "a name given to various keyboard or barrel organ instruments designed to imitate an orchestra, also ORCHESTRINA [n -S]\n",
  "ORCHESTRIONS": "ORCHESTRION, a name given to various keyboard or barrel organ instruments designed to imitate an orchestra, also ORCHESTRINA [n]\n",
  "ORCHID": "any plant or flower of the Orchidaceae, a family of monocotyledons, including many tropical epiphytes [n -S]\n",
  "ORCHIDACEOUS": "relating to orchids, also ORCHIDEOUS [adj]\n",
  "ORCHIDECTOMIES": "ORCHIDECTOMY, excision of one or both testicles, also ORCHIECTOMY [n]\n",
  "ORCHIDECTOMY": "excision of one or both testicles, also ORCHIECTOMY [n ORCHIDECTOMIES]\n",
  "ORCHIDEOUS": "relating to orchids, also ORCHIDACEOUS [adj]\n",
  "ORCHIDIST": "a fancier or grower of orchids [n -S]\n",
  "ORCHIDISTS": "ORCHIDIST, a fancier or grower of orchids [n]\n",
  "ORCHIDLIKE": "like an orchid [adj]\n",
  "ORCHIDOLOGIES": "ORCHIDOLOGY, the study of orchids [n]\n",
  "ORCHIDOLOGIST": "one who studies orchids [n -S]\n",
  "ORCHIDOLOGISTS": "ORCHIDOLOGIST, one who studies orchids [n]\n",
  "ORCHIDOLOGY": "the study of orchids [n ORCHIDOLOGIES]\n",
  "ORCHIDOMANIA": "an obsession with orchids [n -S]\n",
  "ORCHIDOMANIAC": "one with an excessive enthusiasm for orchids [n -S]\n",
  "ORCHIDOMANIACS": "ORCHIDOMANIAC, one with an excessive enthusiasm for orchids [n]\n",
  "ORCHIDOMANIAS": "ORCHIDOMANIA, an obsession with orchids [n]\n",
  "ORCHIDS": "ORCHID, any plant or flower of the Orchidaceae, a family of monocotyledons, including many tropical epiphytes [n]\n",
  "ORCHIECTOMIES": "ORCHIECTOMY, excision of one or both testicles, also ORCHIDECTOMY [n]\n",
  "ORCHIECTOMY": "excision of one or both testicles, also ORCHIDECTOMY [n ORCHIECTOMIES]\n",
  "ORCHIL": "a dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHELLA, ORCHILLA, ORSEILLE [n -S]\n",
  "ORCHILLA": "a red dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHELLA, ORCHIL, ORSEILLE [n -S]\n",
  "ORCHILLAS": "ORCHILLA, a red dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHELLA, ORCHIL, ORSEILLE [n]\n",
  "ORCHILS": "ORCHIL, a dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHELLA, ORCHILLA, ORSEILLE [n]\n",
  "ORCHIS": "(Greek) any flower of the Orchis genus [n -ES]\n",
  "ORCHISES": "ORCHIS, (Greek) any flower of the Orchis genus [n]\n",
  "ORCHITIC": "relating to orchitis, inflammation of the testicles [adj]\n",
  "ORCHITIS": "inflammation of the testicle [n -ES]\n",
  "ORCHITISES": "ORCHITIS, inflammation of the testicle [n]\n",
  "ORCIN": "a chemical compound obtained from archil and other lichens, also ORCINE, ORCINOL [n -S]\n",
  "ORCINE": "a chemical compound obtained from archil and other lichens, also ORCIN, ORCINOL [n -S]\n",
  "ORCINES": "ORCINE, a chemical compound obtained from archil and other lichens, also ORCIN, ORCINOL [n]\n",
  "ORCINOL": "a chemical compound obtained from archil and other lichens, also ORCIN, ORCINE [n -S]\n",
  "ORCINOLS": "ORCINOL, a chemical compound obtained from archil and other lichens, also ORCIN, ORCINE [n]\n",
  "ORCINS": "ORCIN, a chemical compound obtained from archil and other lichens, also ORCINE, ORCINOL [n]\n",
  "ORCS": "ORC, a killer whale, also ORCA [n]\n",
  "ORD": "(obsolete) a point of a weapon [n -S]\n",
  "ORDAIN": "to invest with holy authority [v -ED, -ING, -S]\n",
  "ORDAINABLE": "capable of being ordained [adj]\n",
  "ORDAINED": "ORDAIN, to invest with holy authority [v]\n",
  "ORDAINER": "one who ordains [n -S]\n",
  "ORDAINERS": "ORDAINER, one who ordains [n]\n",
  "ORDAINING": "ORDAIN, to invest with holy authority [v]\n",
  "ORDAINMENT": "the act of ordaining [n -S]\n",
  "ORDAINMENTS": "ORDAINMENT, the act of ordaining [n]\n",
  "ORDAINS": "ORDAIN, to invest with holy authority [v]\n",
  "ORDALIAN": "of or relating to an ordeal [adj]\n",
  "ORDALIUM": "(Latin) the process of resolving a disputed question by divination [n -S]\n",
  "ORDALIUMS": "ORDALIUM, (Latin) the process of resolving a disputed question by divination [n]\n",
  "ORDEAL": "a severely difficult or painful experience [n -S]\n",
  "ORDEALS": "ORDEAL, a severely difficult or painful experience [n]\n",
  "ORDER": "to give a command to [v -ED, -ING, -S]\n",
  "ORDERABLE": "that can be ordered [adj]\n",
  "ORDERED": "ORDER, to give a command to [v]\n",
  "ORDERER": "one who orders [n -S]\n",
  "ORDERERS": "ORDERER, one who orders [n]\n",
  "ORDERING": "arrangement [n -S]\n",
  "ORDERINGS": "ORDERING, arrangement [n]\n",
  "ORDERLESS": "without orders [adj]\n",
  "ORDERLIES": "ORDERLY, a male attendant [n]\n",
  "ORDERLINESS": "the state of being orderly [n -ES]\n",
  "ORDERLINESSES": "ORDERLINESS, the state of being orderly [n]\n",
  "ORDERLY": "a male attendant [n ORDERLIES]\n",
  "ORDERS": "ORDER, to give a command to [v]\n",
  "ORDINAIRE": "(French) vin ordinaire, table wine [n -S]\n",
  "ORDINAIRES": "ORDINAIRE, (French) vin ordinaire, table wine [n]\n",
  "ORDINAL": "indicating order of sequence [adj ORDINALLY] / a book containing religious rites, esp. for ordination [n -S]\n",
  "ORDINALLY": "ORDINAL, indicating order of sequence [adv]\n",
  "ORDINALS": "ORDINAL, a book containing religious rites, esp. for ordination [n]\n",
  "ORDINANCE": "that which is ordained by authority, fate, etc.; a regulation [n -S]\n",
  "ORDINANCES": "ORDINANCE, that which is ordained by authority, fate, etc.; a regulation [n]\n",
  "ORDINAND": "one who is undertaking ordination [n -S]\n",
  "ORDINANDS": "ORDINAND, one who is undertaking ordination [n]\n",
  "ORDINANT": "one who ordains [n -S]\n",
  "ORDINANTS": "ORDINANT, one who ordains [n]\n",
  "ORDINAR": "(Scots) something quite usual, also ORDINARY [n -S]\n",
  "ORDINARIER": "ORDINARY, according to the common type [adj]\n",
  "ORDINARIES": "ORDINARY, a rule, an ordinance [n]\n",
  "ORDINARIEST": "ORDINARY, according to the common type [adj]\n",
  "ORDINARILY": "ORDINARY, according to the common type [adv]\n",
  "ORDINARINESS": "the state of being ordinary [n -ES]\n",
  "ORDINARINESSES": "ORDINARINESS, the state of being ordinary [n]\n",
  "ORDINARS": "ORDINAR, (Scots) something quite usual, also ORDINARY [n]\n",
  "ORDINARY": "according to the common type [adj ORDINARIER, ORDINARIEST, ORDINARILY] / a rule, an ordinance [n ORDINARIES]\n",
  "ORDINATE": "ordered [adj ORDINATELY] / to subject to (statistical) ordination [v ORDINATED, ORDINATING, ORDINATES]\n",
  "ORDINATED": "ORDINATE, to subject to (statistical) ordination [v]\n",
  "ORDINATELY": "ORDINATE, ordered [adv]\n",
  "ORDINATES": "ORDINATE, to subject to (statistical) ordination [v]\n",
  "ORDINATING": "ORDINATE, to subject to (statistical) ordination [v]\n",
  "ORDINATION": "the act of ordaining [n -S]\n",
  "ORDINATIONS": "ORDINATION, the act of ordaining [n]\n",
  "ORDINEE": "one that is being ordained [n -S]\n",
  "ORDINEES": "ORDINEE, one that is being ordained [n]\n",
  "ORDINES": "ORDO, an annual religious calendar with instructions for Mass and office for each day [n]\n",
  "ORDNANCE": "military stores or supplies; missiles discharged in war; artillery [n -S]\n",
  "ORDNANCES": "ORDNANCE, military stores or supplies; missiles discharged in war; artillery [n]\n",
  "ORDO": "an annual religious calendar with instructions for Mass and office for each day [n ORDINES or ORDOS]\n",
  "ORDONNANCE": "coordination, esp. the proper disposition of figures in a picture, parts of a building, etc. [n -S]\n",
  "ORDONNANCES": "ORDONNANCE, coordination, esp. the proper disposition of figures in a picture, parts of a building, etc. [n]\n",
  "ORDOS": "ORDO, an annual religious calendar with instructions for Mass and office for each day [n]\n",
  "ORDS": "ORD, (obsolete) a point of a weapon [n]\n",
  "ORDURE": "manure [n -S]\n",
  "ORDURES": "ORDURE, manure [n]\n",
  "ORDUROUS": "of or pertaining to ordure [adj]\n",
  "ORE": "rock containing a valuable metal, also OWRE [n -S]\n",
  "OREAD": "(Latin) a mountain nymph [n OREADS or OREADES]\n",
  "OREADES": "OREAD, (Latin) a mountain nymph [n]\n",
  "OREADS": "OREAD, (Latin) a mountain nymph [n]\n",
  "OREBODIES": "OREBODY, a mass of ore in a mine [n]\n",
  "OREBODY": "a mass of ore in a mine [n OREBODIES]\n",
  "ORECCHIETTE": "pasta in the form of small oval ears [n ORECCHIETTI or ORECCHIETTES]\n",
  "ORECCHIETTES": "ORECCHIETTE, pasta in the form of small oval ears [n]\n",
  "ORECCHIETTI": "ORECCHIETTE, pasta in the form of small oval ears [n]\n",
  "ORECTIC": "pertaining to desires and their satisfaction, also ORECTIVE [adj]\n",
  "ORECTIVE": "pertaining to desires and their satisfaction, also ORECTIC [adj]\n",
  "OREGANO": "(Spanish) wild marjoram, also ORIGAN, ORIGANE, ORIGANUM [n -S]\n",
  "OREGANOS": "OREGANO, (Spanish) wild marjoram, also ORIGAN, ORIGANE, ORIGANUM [n]\n",
  "OREIDE": "an alloy used in imitation gold jewelry, also OROIDE [n -S]\n",
  "OREIDES": "OREIDE, an alloy used in imitation gold jewelry, also OROIDE [n]\n",
  "OREODONT": "an extinct prehistoric mammal [n -S]\n",
  "OREODONTS": "OREODONT, an extinct prehistoric mammal [n]\n",
  "OREOGRAPHIC": "relating to oreography, the science of mountains, also OREOGRAPHICAL [adj OREOGRAPHICALLY]\n",
  "OREOGRAPHICAL": "relating to oreography, the science of mountains, also OREOGRAPHIC [adj]\n",
  "OREOGRAPHICALLY": "OREOGRAPHIC, relating to oreography, the science of mountains, also OREOGRAPHICAL [adv]\n",
  "OREOGRAPHIES": "OREOGRAPHY, the science of mountains, also OROGRAPHY [n]\n",
  "OREOGRAPHY": "the science of mountains, also OROGRAPHY [n OREOGRAPHIES]\n",
  "OREOLOGICAL": "relating to oreology [adj]\n",
  "OREOLOGIES": "OREOLOGY, the scientific study of mountains, also OROLOGY [n]\n",
  "OREOLOGIST": "one versed in oreology, the study of mountains, also OROLOGIST [n -S]\n",
  "OREOLOGISTS": "OREOLOGIST, one versed in oreology, the study of mountains, also OROLOGIST [n]\n",
  "OREOLOGY": "the scientific study of mountains, also OROLOGY [n OREOLOGIES]\n",
  "OREPEARCH": "(Shakespeare) to fly up and perch on, also OVERPERCH [v OREPEARCHED, OREPEARCHING, OREPEARCHES]\n",
  "OREPEARCHED": "OREPEARCH, (Shakespeare) to fly up and perch on, also OVERPERCH [v]\n",
  "OREPEARCHES": "OREPEARCH, (Shakespeare) to fly up and perch on, also OVERPERCH [v]\n",
  "OREPEARCHING": "OREPEARCH, (Shakespeare) to fly up and perch on, also OVERPERCH [v]\n",
  "ORES": "ORE, rock containing a valuable metal, also OWRE [n]\n",
  "ORESTUNCK": "OVERSTINK, (Shakespeare) to stink more than [v]\n",
  "OREWEED": "a kind of seaweed, also OARWEED [n -S]\n",
  "OREWEEDS": "OREWEED, a kind of seaweed, also OARWEED [n]\n",
  "OREXIN": "a hormone that stimulates the appetite and is thought to be important for sleep regulation [n -S]\n",
  "OREXINS": "OREXIN, a hormone that stimulates the appetite and is thought to be important for sleep regulation [n]\n",
  "OREXIS": "(Greek) an appetite [n -ES]\n",
  "OREXISES": "OREXIS, (Greek) an appetite [n]\n",
  "ORF": "a viral infection of sheep [n -S]\n",
  "ORFE": "(German) a golden-yellow fish, a kind of carp [n -S]\n",
  "ORFES": "ORFE, (German) a golden-yellow fish, a kind of carp [n]\n",
  "ORFRAY": "gold or other rich embroidery on clerical robes, also ORPHREY [n -S]\n",
  "ORFRAYS": "ORFRAY, gold or other rich embroidery on clerical robes, also ORPHREY [n]\n",
  "ORFS": "ORF, a viral infection of sheep [n]\n",
  "ORG": "(short for) an organization [n -S]\n",
  "ORGAN": "a musical instrument [n -S]\n",
  "ORGANA": "ORGANON, (Greek) a system of rules for scientific investigation, also ORGANUM [n]\n",
  "ORGANDIE": "(French) a cotton fabric, also ORGANDY [n -S]\n",
  "ORGANDIES": "ORGANDY, a cotton fabric, also ORGANDIE [n]\n",
  "ORGANDY": "a cotton fabric, also ORGANDIE [n ORGANDIES]\n",
  "ORGANELLE": "a specialized part of a cell that acts like an organ [n -S]\n",
  "ORGANELLES": "ORGANELLE, a specialized part of a cell that acts like an organ [n]\n",
  "ORGANIC": "relating to living matter, also ORGANICAL [adj ORGANICALLY] / an organic substance [n -S]\n",
  "ORGANICAL": "(obsolete) relating to, derived from, like or of the nature of an organ, also ORGANIC [adj ORGANICALLY]\n",
  "ORGANICALLY": "ORGANICAL, (obsolete) relating to, derived from, like or of the nature of an organ, also ORGANIC [adv]\n",
  "ORGANICISM": "the conception of life or society as an organism [n -S]\n",
  "ORGANICISMS": "ORGANICISM, the conception of life or society as an organism [n]\n",
  "ORGANICIST": "a believer in organicism [n -S]\n",
  "ORGANICISTIC": "related to organicism, the conception of life or society as an organism [adj]\n",
  "ORGANICISTS": "ORGANICIST, a believer in organicism [n]\n",
  "ORGANICITIES": "ORGANICITY, the state of life or society as an organism [n]\n",
  "ORGANICITY": "the state of life or society as an organism [n ORGANICITIES]\n",
  "ORGANICS": "ORGANIC, an organic substance [n]\n",
  "ORGANISABILITY": "the quality of being organisable, also ORGANIZABILITY [n]\n",
  "ORGANISABLE": "that can be organised, also ORGANIZABLE [adj]\n",
  "ORGANISATION": "the act of organising, also ORGANIZATION [n -S]\n",
  "ORGANISATIONAL": "relating to organisation, also ORGANIZATIONAL [adj]\n",
  "ORGANISATIONS": "ORGANISATION, the act of organising, also ORGANIZATION [n]\n",
  "ORGANISE": "to form into an organic whole, also ORGANIZE [v ORGANISED, ORGANISING, ORGANISES]\n",
  "ORGANISED": "ORGANISE, to form into an organic whole, also ORGANIZE [v]\n",
  "ORGANISER": "one who organises, also ORGANIZER [n -S]\n",
  "ORGANISERS": "ORGANISER, one who organises, also ORGANIZER [n]\n",
  "ORGANISES": "ORGANISE, to form into an organic whole, also ORGANIZE [v]\n",
  "ORGANISING": "the act of arranging something [n -S]\n",
  "ORGANISINGS": "ORGANISING, the act of arranging something [n]\n",
  "ORGANISM": "any form of animal or plant life [n -S]\n",
  "ORGANISMAL": "relating to an organism, also ORGANISMIC [adj ORGANISMALLY]\n",
  "ORGANISMALLY": "ORGANISMAL, relating to an organism, also ORGANISMIC [adv]\n",
  "ORGANISMIC": "relating to an organism, also ORGANISMAL [adj ORGANISMICALLY]\n",
  "ORGANISMICALLY": "ORGANISMIC, relating to an organism, also ORGANISMAL [adv]\n",
  "ORGANISMS": "ORGANISM, any form of animal or plant life [n]\n",
  "ORGANIST": "one who plays the organ [n -S]\n",
  "ORGANISTRUM": "an early musical instrument resembling the hurdy-gurdy [n -S]\n",
  "ORGANISTRUMS": "ORGANISTRUM, an early musical instrument resembling the hurdy-gurdy [n]\n",
  "ORGANISTS": "ORGANIST, one who plays the organ [n]\n",
  "ORGANITIES": "ORGANITY, an organized whole [n]\n",
  "ORGANITY": "an organized whole [n ORGANITIES]\n",
  "ORGANIZABILITY": "the quality of being organizable, also ORGANISABILITY [n]\n",
  "ORGANIZABLE": "that can be organized, also ORGANISABLE [adj]\n",
  "ORGANIZATION": "the act of organizing, also ORGANISATION [n -S]\n",
  "ORGANIZATIONAL": "relating to organization, also ORGANISATIONAL [adj]\n",
  "ORGANIZATIONS": "ORGANIZATION, the act of organizing, also ORGANISATION [n]\n",
  "ORGANIZE": "to form into an organic whole, also ORGANISE [v ORGANIZED, ORGANIZING, ORGANIZES]\n",
  "ORGANIZED": "ORGANIZE, to form into an organic whole, also ORGANISE [v]\n",
  "ORGANIZER": "one who organizes, also ORGANISER [n -S]\n",
  "ORGANIZERS": "ORGANIZER, one who organizes, also ORGANISER [n]\n",
  "ORGANIZES": "ORGANIZE, to form into an organic whole, also ORGANISE [v]\n",
  "ORGANIZING": "the act of arranging something [n -S]\n",
  "ORGANIZINGS": "ORGANIZING, the act of arranging something [n]\n",
  "ORGANOCHLORINE": "a compound of chlorine and an organic radical [n -S]\n",
  "ORGANOCHLORINES": "ORGANOCHLORINE, a compound of chlorine and an organic radical [n]\n",
  "ORGANOGENESES": "ORGANOGENESIS, the origin or development of living organs [n]\n",
  "ORGANOGENESIS": "the origin or development of living organs [n ORGANOGENESES]\n",
  "ORGANOGENETIC": "relating to organogenesis [adj]\n",
  "ORGANOGENIES": "ORGANOGENY, the development of living organisms [n]\n",
  "ORGANOGENY": "the development of living organisms [n ORGANOGENIES]\n",
  "ORGANOGRAM": "a chart showing a graded arrangement of personnel in an organisation [n -S]\n",
  "ORGANOGRAMS": "ORGANOGRAM, a chart showing a graded arrangement of personnel in an organisation [n]\n",
  "ORGANOGRAPHIC": "related to organography, a description of the organs of plants or animals, also ORGANOGRAPHICAL [adj]\n",
  "ORGANOGRAPHICAL": "related to organography, a description of the organs of plants or animals, also ORGANOGRAPHIC [adj]\n",
  "ORGANOGRAPHIES": "ORGANOGRAPHY, a description of the organs of plants or animals [n]\n",
  "ORGANOGRAPHIST": "one who practises organography, a description of the organs of plants or animals [n -S]\n",
  "ORGANOGRAPHISTS": "ORGANOGRAPHIST, one who practises organography, a description of the organs of plants or animals [n]\n",
  "ORGANOGRAPHY": "a description of the organs of plants or animals [n ORGANOGRAPHIES]\n",
  "ORGANOLEPTIC": "involving use of the sense organs [adj]\n",
  "ORGANOLOGICAL": "related to organology [adj]\n",
  "ORGANOLOGIES": "ORGANOLOGY, the science of organs or of anything considered as an organic structure [n]\n",
  "ORGANOLOGIST": "a specialist in organology [n -S]\n",
  "ORGANOLOGISTS": "ORGANOLOGIST, a specialist in organology [n]\n",
  "ORGANOLOGY": "the science of organs or of anything considered as an organic structure [n ORGANOLOGIES]\n",
  "ORGANOMERCURIAL": "an organic compound or a pharmaceutical preparation containing mercury [n]\n",
  "ORGANOMETALLIC": "containing a metal or metalloid bonded directly to carbon [adj] / an organometallic compound [n -S]\n",
  "ORGANOMETALLICS": "ORGANOMETALLIC, an organometallic compound [n]\n",
  "ORGANON": "(Greek) a system of rules for scientific investigation, also ORGANUM [n ORGANONS or ORGANA]\n",
  "ORGANONS": "ORGANON, (Greek) a system of rules for scientific investigation, also ORGANUM [n]\n",
  "ORGANOPHOSPHATE": "an organophosphorus compound (as a pesticide) [n]\n",
  "ORGANOSOL": "a resin-based coating [n -S]\n",
  "ORGANOSOLS": "ORGANOSOL, a resin-based coating [n]\n",
  "ORGANOTHERAPIES": "ORGANOTHERAPY, treatment of disease by administration of animal organs or extracts of them, esp. of ductless gland extracts [n]\n",
  "ORGANOTHERAPY": "treatment of disease by administration of animal organs or extracts of them, esp. of ductless gland extracts [n ORGANOTHERAPIES]\n",
  "ORGANOTIN": "of an organic compound used as a pesticide [adj]\n",
  "ORGANS": "ORGAN, a musical instrument [n]\n",
  "ORGANUM": "(Latin) a method of philosophical or scientific investigation, also ORGANON [n ORGANA or ORGANUMS]\n",
  "ORGANUMS": "ORGANUM, (Latin) a method of philosophical or scientific investigation, also ORGANON [n]\n",
  "ORGANZA": "a transparent thin silk or nylon [n -S]\n",
  "ORGANZAS": "ORGANZA, a transparent thin silk or nylon [n]\n",
  "ORGANZINE": "a silk yarn of two or more threads put together with a slight twist; a fabric made of this yarn [n -S]\n",
  "ORGANZINES": "ORGANZINE, a silk yarn of two or more threads put together with a slight twist; a fabric made of this yarn [n]\n",
  "ORGASM": "to experience the height of sexual excitement [v -ED, -ING, -S]\n",
  "ORGASMED": "ORGASM, to experience the height of sexual excitement [v]\n",
  "ORGASMIC": "pertaining to orgasm, also ORGASTIC [adj ORGASMICALLY]\n",
  "ORGASMICALLY": "ORGASMIC, pertaining to orgasm, also ORGASTIC [adv]\n",
  "ORGASMING": "ORGASM, to experience the height of sexual excitement [v]\n",
  "ORGASMS": "ORGASM, to experience the height of sexual excitement [v]\n",
  "ORGASTIC": "pertaining to orgasm [adj ORGASTICALLY]\n",
  "ORGASTICALLY": "ORGASTIC, pertaining to orgasm [adv]\n",
  "ORGEAT": "(French) a syrup or drink made from almonds, sugar etc., formerly from barley [n -S]\n",
  "ORGEATS": "ORGEAT, (French) a syrup or drink made from almonds, sugar etc., formerly from barley [n]\n",
  "ORGIA": "(Latin) a revel of debauchery, also ORGY [n -S]\n",
  "ORGIAC": "of the nature of an orgy, also ORGIC [adj]\n",
  "ORGIAS": "ORGIA, (Latin) a revel of debauchery, also ORGY [n]\n",
  "ORGIAST": "one who takes place in orgies [n -S]\n",
  "ORGIASTIC": "relating to orgies, also ORGIC [adj ORGIASTICALLY]\n",
  "ORGIASTICALLY": "ORGIASTIC, relating to orgies, also ORGIC [adv]\n",
  "ORGIASTS": "ORGIAST, one who takes place in orgies [n]\n",
  "ORGIC": "of the nature of an orgy, also ORGIAC [adj]\n",
  "ORGIES": "ORGY, a revel of debauchery, also ORGIA [n]\n",
  "ORGILLOUS": "(Shakespeare) proud, also ORGULOUS [adj]\n",
  "ORGONE": "according to Wilhelm Reich, a vital force permeating the universe [n -S]\n",
  "ORGONES": "ORGONE, according to Wilhelm Reich, a vital force permeating the universe [n]\n",
  "ORGS": "ORG, (short for) an organization [n]\n",
  "ORGUE": "(obsolete) a row of stakes let down like a portcullis [n -S]\n",
  "ORGUES": "ORGUE, (obsolete) a row of stakes let down like a portcullis [n]\n",
  "ORGULOUS": "(Shakespeare) proud, also ORGILLOUS [adj]\n",
  "ORGY": "a revel of debauchery, also ORGIA [n ORGIES]\n",
  "ORIBATID": "any of a family of eyeless mites [n -S]\n",
  "ORIBATIDS": "ORIBATID, any of a family of eyeless mites [n]\n",
  "ORIBI": "(South African) an African antelope, also OUREBI [n -S]\n",
  "ORIBIS": "ORIBI, (South African) an African antelope, also OUREBI [n]\n",
  "ORICALCHE": "(Spenser) a gold-coloured alloy, also ORICHALC [n -S]\n",
  "ORICALCHES": "ORICALCHE, (Spenser) a gold-coloured alloy, also ORICHALC [n]\n",
  "ORICHALC": "a gold-coloured alloy, also ORICALCHE [n -S]\n",
  "ORICHALCEOUS": "of or like orichalc [adj]\n",
  "ORICHALCS": "ORICHALC, a gold-coloured alloy, also ORICALCHE [n]\n",
  "ORIEL": "a projecting bay window supported with corbel or bracket [n -S]\n",
  "ORIELLED": "having an oriel, a projecting bay window supported with corbel or bracket [adj]\n",
  "ORIELS": "ORIEL, a projecting bay window supported with corbel or bracket [n]\n",
  "ORIENCIES": "ORIENCY, brightness or strength of color [n]\n",
  "ORIENCY": "brightness or strength of color [n ORIENCIES]\n",
  "ORIENT": "to determine the position of, relatively to fixed or known directions, also ORIENTATE [v -ED, -ING, -S]\n",
  "ORIENTAL": "from the Orient [adj ORIENTALLY] / a precious stone, esp. a pearl; an Oriental rug [n -S]\n",
  "ORIENTALISE": "to make oriental, also ORIENTALIZE [v ORIENTALISED, ORIENTALISING, ORIENTALISES]\n",
  "ORIENTALISED": "ORIENTALISE, to make oriental, also ORIENTALIZE [v]\n",
  "ORIENTALISES": "ORIENTALISE, to make oriental, also ORIENTALIZE [v]\n",
  "ORIENTALISING": "ORIENTALISE, to make oriental, also ORIENTALIZE [v]\n",
  "ORIENTALISM": "a style or manner associated with or characteristic of Asia or Asians [n -S]\n",
  "ORIENTALISMS": "ORIENTALISM, a style or manner associated with or characteristic of Asia or Asians [n]\n",
  "ORIENTALIST": "a specialist in orientalism [n -S]\n",
  "ORIENTALISTS": "ORIENTALIST, a specialist in orientalism [n]\n",
  "ORIENTALITIES": "ORIENTALITY, the quality of being oriental [n]\n",
  "ORIENTALITY": "the quality of being oriental [n ORIENTALITIES]\n",
  "ORIENTALIZE": "to make oriental, also ORIENTALISE [v ORIENTALIZED, ORIENTALIZING, ORIENTALIZES]\n",
  "ORIENTALIZED": "ORIENTALIZE, to make oriental, also ORIENTALISE [v]\n",
  "ORIENTALIZES": "ORIENTALIZE, to make oriental, also ORIENTALISE [v]\n",
  "ORIENTALIZING": "ORIENTALIZE, to make oriental, also ORIENTALISE [v]\n",
  "ORIENTALLY": "ORIENTAL, from the Orient [adv]\n",
  "ORIENTALS": "ORIENTAL, a precious stone, esp. a pearl; an Oriental rug [n]\n",
  "ORIENTATE": "to determine the position of, relatively to fixed or known directions, also ORIENT [v ORIENTATED, ORIENTATING, ORIENTATES]\n",
  "ORIENTATED": "ORIENTATE, to determine the position of, relatively to fixed or known directions, also ORIENT [v]\n",
  "ORIENTATES": "ORIENTATE, to determine the position of, relatively to fixed or known directions, also ORIENT [v]\n",
  "ORIENTATING": "ORIENTATE, to determine the position of, relatively to fixed or known directions, also ORIENT [v]\n",
  "ORIENTATION": "the act of orienting [n -S]\n",
  "ORIENTATIONAL": "relating to orientation [adj ORIENTATIONALLY]\n",
  "ORIENTATIONALLY": "ORIENTATIONAL, relating to orientation [adv]\n",
  "ORIENTATIONS": "ORIENTATION, the act of orienting [n]\n",
  "ORIENTATOR": "an instrument for orientating [n -S]\n",
  "ORIENTATORS": "ORIENTATOR, an instrument for orientating [n]\n",
  "ORIENTED": "ORIENT, to determine the position of, relatively to fixed or known directions, also ORIENTATE [v]\n",
  "ORIENTEER": "to take part in orienteering, the sport of making one's way quickly across difficult country with the help of map and compass [v -ED, -ING, -S]\n",
  "ORIENTEERED": "ORIENTEER, to take part in orienteering, the sport of making one's way quickly across difficult country with the help of map and compass [v]\n",
  "ORIENTEERING": "a cross-country race in which each participant uses a map and compass to navigate between checkpoints along an unfamiliar course [n -S]\n",
  "ORIENTEERINGS": "ORIENTEERING, a cross-country race in which each participant uses a map and compass to navigate between checkpoints along an unfamiliar course [n]\n",
  "ORIENTEERS": "ORIENTEER, to take part in orienteering, the sport of making one's way quickly across difficult country with the help of map and compass [v]\n",
  "ORIENTER": "one who helps another to adjust to surroundings [n -S]\n",
  "ORIENTERS": "ORIENTER, one who helps another to adjust to surroundings [n]\n",
  "ORIENTING": "ORIENT, to determine the position of, relatively to fixed or known directions, also ORIENTATE [v]\n",
  "ORIENTS": "ORIENT, to determine the position of, relatively to fixed or known directions, also ORIENTATE [v]\n",
  "ORIFEX": "(Shakespeare) an orifice [n -ES]\n",
  "ORIFEXES": "ORIFEX, (Shakespeare) an orifice [n]\n",
  "ORIFICE": "an opening, esp. anatomical [n -S]\n",
  "ORIFICES": "ORIFICE, an opening, esp. anatomical [n]\n",
  "ORIFICIAL": "relating to an orifice [adj]\n",
  "ORIFLAMME": "an inspiring standard or symbol; the orange-red flag of the Abbey of St Denis, used as standard by the early kings of France [n -S]\n",
  "ORIFLAMMES": "ORIFLAMME, an inspiring standard or symbol; the orange-red flag of the Abbey of St Denis, used as standard by the early kings of France [n]\n",
  "ORIGAMI": "(Japanese) the art of paper folding [n -S]\n",
  "ORIGAMIS": "ORIGAMI, (Japanese) the art of paper folding [n]\n",
  "ORIGAN": "(Spanish) wild marjoram, also OREGANO, ORIGANE, ORIGANUM [n -S]\n",
  "ORIGANE": "(Spanish) wild marjoram, also OREGANO, ORIGAN, ORIGANUM [n -S]\n",
  "ORIGANES": "ORIGANE, (Spanish) wild marjoram, also OREGANO, ORIGAN, ORIGANUM [n]\n",
  "ORIGANS": "ORIGAN, (Spanish) wild marjoram, also OREGANO, ORIGANE, ORIGANUM [n]\n",
  "ORIGANUM": "wild marjoram, also OREGANO, ORIGAN, ORIGANE [n -S]\n",
  "ORIGANUMS": "ORIGANUM, wild marjoram, also OREGANO, ORIGAN, ORIGANE [n]\n",
  "ORIGIN": "a coming into being [n -S]\n",
  "ORIGINAL": "relating to the origin [adj ORIGINALLY] / the first form of something [n -S]\n",
  "ORIGINALITIES": "ORIGINALITY, the state of being original [n]\n",
  "ORIGINALITY": "the state of being original [n ORIGINALITIES]\n",
  "ORIGINALLY": "ORIGINAL, relating to the origin [adv]\n",
  "ORIGINALS": "ORIGINAL, the first form of something [n]\n",
  "ORIGINARY": "that is the origin or source of a person or thing [adj]\n",
  "ORIGINATE": "to have an origin [v ORIGINATED, ORIGINATING, ORIGINATES]\n",
  "ORIGINATED": "ORIGINATE, to have an origin [v]\n",
  "ORIGINATES": "ORIGINATE, to have an origin [v]\n",
  "ORIGINATING": "ORIGINATE, to have an origin [v]\n",
  "ORIGINATION": "the act of originating [n -S]\n",
  "ORIGINATIONS": "ORIGINATION, the act of originating [n]\n",
  "ORIGINATIVE": "having power to originate or bring into existence [adj ORIGINATIVELY]\n",
  "ORIGINATIVELY": "ORIGINATIVE, having power to originate or bring into existence [adv]\n",
  "ORIGINATOR": "one who originates [n -S]\n",
  "ORIGINATORS": "ORIGINATOR, one who originates [n]\n",
  "ORIGINS": "ORIGIN, a coming into being [n]\n",
  "ORIHOU": "(Maori) a small New Zealand tree [n -S]\n",
  "ORIHOUS": "ORIHOU, (Maori) a small New Zealand tree [n]\n",
  "ORILLION": "part of a fortification which shields guns [n -S]\n",
  "ORILLIONS": "ORILLION, part of a fortification which shields guns [n]\n",
  "ORINASAL": "of or relating to the mouth and nose, also ORONASAL [adj ORINASALLY] / a sound pronounced through both the mouth and nose [n -S]\n",
  "ORINASALLY": "ORINASAL, of or relating to the mouth and nose, also ORONASAL [adv]\n",
  "ORINASALS": "ORINASAL, a sound pronounced through both the mouth and nose [n]\n",
  "ORIOLE": "any of various mainly tropical Old World passerine birds, noted for the melodious song and brilliant plumage of the males [n -S]\n",
  "ORIOLES": "ORIOLE, any of various mainly tropical Old World passerine birds, noted for the melodious song and brilliant plumage of the males [n]\n",
  "ORISHA": "(Yoruba) any of the minor gods or spirits of traditional Yoruba religion, also ORIXA [n -S]\n",
  "ORISHAS": "ORISHA, (Yoruba) any of the minor gods or spirits of traditional Yoruba religion, also ORIXA [n]\n",
  "ORISMOLOGICAL": "relating to orismology, the science of defining technical terms [adj]\n",
  "ORISMOLOGIES": "ORISMOLOGY, the science of defining technical terms [n]\n",
  "ORISMOLOGY": "the science of defining technical terms [n ORISMOLOGIES]\n",
  "ORISON": "a short prayer [n -S]\n",
  "ORISONS": "ORISON, a short prayer [n]\n",
  "ORIXA": "(Yoruba) any of the minor gods or spirits of traditional Yoruba religion, also ORISHA [n -S]\n",
  "ORIXAS": "ORIXA, (Yoruba) any of the minor gods or spirits of traditional Yoruba religion, also ORISHA [n]\n",
  "ORLE": "a border within a heraldic shield at a short distance from the edge [n -S]\n",
  "ORLEANS": "a variety of plum [n -ES]\n",
  "ORLEANSES": "ORLEANS, a variety of plum [n]\n",
  "ORLES": "ORLE, a border within a heraldic shield at a short distance from the edge [n]\n",
  "ORLISTAT": "an orally administered drug that reduces the absorption of dietary fat by inhibiting the action of enzymes in the digestive system, used to treat obesity [n -S]\n",
  "ORLISTATS": "ORLISTAT, an orally administered drug that reduces the absorption of dietary fat by inhibiting the action of enzymes in the digestive system, used to treat obesity [n]\n",
  "ORLON": "(tradename) a crease-resistant acrylic fibre or fabric used for clothing, furnishing etc. [n -S]\n",
  "ORLONS": "ORLON, (tradename) a crease-resistant acrylic fibre or fabric used for clothing, furnishing etc. [n]\n",
  "ORLOP": "(Dutch) the lowest deck of a ship having four or more decks [n -S]\n",
  "ORLOPS": "ORLOP, (Dutch) the lowest deck of a ship having four or more decks [n]\n",
  "ORMER": "a sea snail of rocky coasts, aka abalone [n -S]\n",
  "ORMERS": "ORMER, a sea snail of rocky coasts, aka abalone [n]\n",
  "ORMOLU": "(French) an alloy of copper, zinc, and sometimes tin, used to imitate gold [n -S]\n",
  "ORMOLUS": "ORMOLU, (French) an alloy of copper, zinc, and sometimes tin, used to imitate gold [n]\n",
  "ORNAMENT": "to decorate [v -ED, -ING, -S]\n",
  "ORNAMENTAL": "decorative [adj ORNAMENTALLY] / a plant grown for ornament [n -S]\n",
  "ORNAMENTALLY": "ORNAMENTAL, decorative [adv]\n",
  "ORNAMENTALS": "ORNAMENTAL, a plant grown for ornament [n]\n",
  "ORNAMENTATION": "something that ornaments [n -S]\n",
  "ORNAMENTATIONS": "ORNAMENTATION, something that ornaments [n]\n",
  "ORNAMENTED": "ORNAMENT, to decorate [v]\n",
  "ORNAMENTER": "one who makes ornaments, also ORNAMENTIST [n -S]\n",
  "ORNAMENTERS": "ORNAMENTER, one who makes ornaments, also ORNAMENTIST [n]\n",
  "ORNAMENTING": "ORNAMENT, to decorate [v]\n",
  "ORNAMENTIST": "one who makes ornaments, also ORNAMENTER [n -S]\n",
  "ORNAMENTISTS": "ORNAMENTIST, one who makes ornaments, also ORNAMENTER [n]\n",
  "ORNAMENTS": "ORNAMENT, to decorate [v]\n",
  "ORNATE": "decorated [adj ORNATER, ORNATEST, ORNATELY]\n",
  "ORNATELY": "ORNATE, decorated [adv]\n",
  "ORNATENESS": "the state of being ornate [n -ES]\n",
  "ORNATENESSES": "ORNATENESS, the state of being ornate [n]\n",
  "ORNATER": "ORNATE, decorated [adj]\n",
  "ORNATEST": "ORNATE, decorated [adj]\n",
  "ORNERIER": "ORNERY, stubborn and mean spirited [adj]\n",
  "ORNERIEST": "ORNERY, stubborn and mean spirited [adj]\n",
  "ORNERINESS": "the state of being ornery [n -ES]\n",
  "ORNERINESSES": "ORNERINESS, the state of being ornery [n]\n",
  "ORNERY": "stubborn and mean spirited [adj ORNERIER, ORNERIEST]\n",
  "ORNIS": "(Greek) the collection of birds of a region [n ORNISES or ORNITHES]\n",
  "ORNISES": "ORNIS, (Greek) the collection of birds of a region [n]\n",
  "ORNITHES": "ORNIS, (Greek) the collection of birds of a region [n]\n",
  "ORNITHIC": "pertaining to birds [adj]\n",
  "ORNITHICHNITE": "a fossil footprint of a bird [n -S]\n",
  "ORNITHICHNITES": "ORNITHICHNITE, a fossil footprint of a bird [n]\n",
  "ORNITHINE": "a bird [n -S]\n",
  "ORNITHINES": "ORNITHINE, a bird [n]\n",
  "ORNITHISCHIAN": "any of an order of herbivorous dinosaurs [n -S]\n",
  "ORNITHISCHIANS": "ORNITHISCHIAN, any of an order of herbivorous dinosaurs [n]\n",
  "ORNITHODELPHIAN": "of or like the Ornithodelphia, monotremes, also ORNITHODELPHIC, ORNITHODELPHOUS [adj]\n",
  "ORNITHODELPHIC": "of or like the Ornithodelphia, monotremes, also ORNITHODELPHIAN, ORNITHODELPHOUS [adj]\n",
  "ORNITHODELPHOUS": "of or like the Ornithodelphia, monotremes, also ORNITHODELPHIAN, ORNITHODELPHIC [adj]\n",
  "ORNITHOGALUM": "a plant of a large genus of herbs of the family Liliaceae [n -S]\n",
  "ORNITHOGALUMS": "ORNITHOGALUM, a plant of a large genus of herbs of the family Liliaceae [n]\n",
  "ORNITHOID": "birdlike [adj]\n",
  "ORNITHOLOGIC": "relating to ornithology, also ORNITHOLOGICAL [adj]\n",
  "ORNITHOLOGICAL": "relating to ornithology, also ORNITHOLOGIC [adj]\n",
  "ORNITHOLOGIES": "ORNITHOLOGY, the study of birds [n]\n",
  "ORNITHOLOGIST": "one who studies birds [n -S]\n",
  "ORNITHOLOGISTS": "ORNITHOLOGIST, one who studies birds [n]\n",
  "ORNITHOLOGY": "the study of birds [n ORNITHOLOGIES]\n",
  "ORNITHOMANCIES": "ORNITHOMANCY, divination by observing flight of birds [n]\n",
  "ORNITHOMANCY": "divination by observing flight of birds [n ORNITHOMANCIES]\n",
  "ORNITHOMANTIC": "relating to ornithomancy, divination by observing flight of birds [adj]\n",
  "ORNITHOMORPH": "a figure or design in the form of a bird [n -S]\n",
  "ORNITHOMORPHIC": "shaped like bird [adj]\n",
  "ORNITHOMORPHS": "ORNITHOMORPH, a figure or design in the form of a bird [n]\n",
  "ORNITHOPHILIES": "ORNITHOPHILY, pollination by birds [n]\n",
  "ORNITHOPHILOUS": "of flowers, pollinated by birds [adj]\n",
  "ORNITHOPHILY": "pollination by birds [n ORNITHOPHILIES]\n",
  "ORNITHOPHOBIA": "fear of birds [n -S]\n",
  "ORNITHOPHOBIAS": "ORNITHOPHOBIA, fear of birds [n]\n",
  "ORNITHOPOD": "a member of a suborder of bipedal ornithischian (bird-hipped) dinosaurs [n -S]\n",
  "ORNITHOPODS": "ORNITHOPOD, a member of a suborder of bipedal ornithischian (bird-hipped) dinosaurs [n]\n",
  "ORNITHOPTER": "a birdlike archaic flying machine [n -S]\n",
  "ORNITHOPTERS": "ORNITHOPTER, a birdlike archaic flying machine [n]\n",
  "ORNITHORHYNCHUS": "the duckbill platypus [n]\n",
  "ORNITHOSAUR": "a pterodactyl [n -S]\n",
  "ORNITHOSAURS": "ORNITHOSAUR, a pterodactyl [n]\n",
  "ORNITHOSCOPIES": "ORNITHOSCOPY, bird watching [n]\n",
  "ORNITHOSCOPY": "bird watching [n ORNITHOSCOPIES]\n",
  "ORNITHOSES": "ORNITHOSIS, a disease like psittacosis, infecting domestic fowl, transmissible to man [n]\n",
  "ORNITHOSIS": "a disease like psittacosis, infecting domestic fowl, transmissible to man [n ORNITHOSES]\n",
  "OROBANCHACEOUS": "belonging to the broomrape family [adj]\n",
  "OROGEN": "an orogenic belt, a mountain-forming area [n -S]\n",
  "OROGENESES": "OROGENESIS, the process of mountain making, esp by folding of the earth's crust [n]\n",
  "OROGENESIS": "the process of mountain making, esp by folding of the earth's crust [n OROGENESES]\n",
  "OROGENETIC": "relating to orogenesis, mountain-building [adj OROGENETICALLY]\n",
  "OROGENETICALLY": "OROGENETIC, relating to orogenesis, mountain-building [adv]\n",
  "OROGENIC": "relating to the formation of mountains [adj OROGENICALLY]\n",
  "OROGENICALLY": "OROGENIC, relating to the formation of mountains [adv]\n",
  "OROGENIES": "OROGENY, the process of mountain making, esp. by folding of the earth's crust [n]\n",
  "OROGENS": "OROGEN, an orogenic belt, a mountain-forming area [n]\n",
  "OROGENY": "the process of mountain making, esp. by folding of the earth's crust [n OROGENIES]\n",
  "OROGRAPHER": "one who practises orography, the science of mountains [n -S]\n",
  "OROGRAPHERS": "OROGRAPHER, one who practises orography, the science of mountains [n]\n",
  "OROGRAPHIC": "relating to orography, the description of mountains, also OROGRAPHICAL [adj OROGRAPHICALLY]\n",
  "OROGRAPHICAL": "relating to orography, the description of mountains, also OROGRAPHIC [adj OROGRAPHICALLY]\n",
  "OROGRAPHICALLY": "OROGRAPHICAL, relating to orography, the description of mountains, also OROGRAPHIC [adv]\n",
  "OROGRAPHIES": "OROGRAPHY, the branch of physical geography which deals with the formation and features of mountains, also OREOGRAPHY [n]\n",
  "OROGRAPHY": "the branch of physical geography which deals with the formation and features of mountains, also OREOGRAPHY [n OROGRAPHIES]\n",
  "OROIDE": "an alloy used in imitation gold jewelry, also OREIDE [n -S]\n",
  "OROIDES": "OROIDE, an alloy used in imitation gold jewelry, also OREIDE [n]\n",
  "OROLOGICAL": "of or pertaining to orology [adj OROLOGICALLY]\n",
  "OROLOGICALLY": "OROLOGICAL, of or pertaining to orology [adv]\n",
  "OROLOGIES": "OROLOGY, the scientific study of mountains, also OREOLOGY [n]\n",
  "OROLOGIST": "one versed in orology, the study of mountains, also OREOLOGIST [n -S]\n",
  "OROLOGISTS": "OROLOGIST, one versed in orology, the study of mountains, also OREOLOGIST [n]\n",
  "OROLOGY": "the scientific study of mountains, also OREOLOGY [n OROLOGIES]\n",
  "OROMAXILLARY": "relating to the passages between the sinuses and the roof of the mouth [adj]\n",
  "OROMETER": "a barometer showing height above sea-level [n -S]\n",
  "OROMETERS": "OROMETER, a barometer showing height above sea-level [n]\n",
  "ORONASAL": "of or relating to the mouth and nose, also ORINASAL [adj]\n",
  "OROPESA": "a fish-shaped float used in marine minesweeping to support the sweeping wire [n -S]\n",
  "OROPESAS": "OROPESA, a fish-shaped float used in marine minesweeping to support the sweeping wire [n]\n",
  "OROPHARYNGEAL": "relating to the oropharynx [adj]\n",
  "OROPHARYNGES": "OROPHARYNX, the part of the pharynx between the soft palate and the epiglottis [n]\n",
  "OROPHARYNX": "the part of the pharynx between the soft palate and the epiglottis [n OROPHARYNGES or OROPHARYNXES]\n",
  "OROPHARYNXES": "OROPHARYNX, the part of the pharynx between the soft palate and the epiglottis [n]\n",
  "OROROTUNDITIES": "OROROTUNDITY, the orotund mode of intonation, also OROTUNDITY [n]\n",
  "OROROTUNDITY": "the orotund mode of intonation, also OROTUNDITY [n OROROTUNDITIES]\n",
  "OROTUND": "marked by fullness and clarity of sound; pompous [adj OROTUNDLY]\n",
  "OROTUNDITIES": "OROTUNDITY, the orotund mode of intonation, also OROROTUNDITY [n]\n",
  "OROTUNDITY": "the orotund mode of intonation, also OROROTUNDITY [n OROTUNDITIES]\n",
  "OROTUNDLY": "OROTUND, marked by fullness and clarity of sound; pompous [adv]\n",
  "ORPHAN": "to deprive of both parents [v -ED, -ING, -S]\n",
  "ORPHANAGE": "a place where orphans are housed [n -S]\n",
  "ORPHANAGES": "ORPHANAGE, a place where orphans are housed [n]\n",
  "ORPHANED": "ORPHAN, to deprive of both parents [v]\n",
  "ORPHANHOOD": "the state of being an orphan, also ORPHANISM [n -S]\n",
  "ORPHANHOODS": "ORPHANHOOD, the state of being an orphan, also ORPHANISM [n]\n",
  "ORPHANING": "ORPHAN, to deprive of both parents [v]\n",
  "ORPHANISM": "the state of being an orphan, also ORPHANHOOD [n -S]\n",
  "ORPHANISMS": "ORPHANISM, the state of being an orphan, also ORPHANHOOD [n]\n",
  "ORPHANS": "ORPHAN, to deprive of both parents [v]\n",
  "ORPHARION": "a large lute-like stringed instrument with six to nine metal strings, also ORPHEOREON [n -S]\n",
  "ORPHARIONS": "ORPHARION, a large lute-like stringed instrument with six to nine metal strings, also ORPHEOREON [n]\n",
  "ORPHEOREON": "a large lute-like stringed instrument with six to nine metal strings, also ORPHARION [n -S]\n",
  "ORPHEOREONS": "ORPHEOREON, a large lute-like stringed instrument with six to nine metal strings, also ORPHARION [n]\n",
  "ORPHIC": "mystical, oracular, also ORPHICAL [adj ORPHICALLY]\n",
  "ORPHICAL": "mystical, oracular, also ORPHIC [adj ORPHICALLY]\n",
  "ORPHICALLY": "ORPHICAL, mystical, oracular, also ORPHIC [adv]\n",
  "ORPHISM": "a style of abstract art [n -S]\n",
  "ORPHISMS": "ORPHISM, a style of abstract art [n]\n",
  "ORPHREY": "gold or other rich embroidery on clerical robes, also ORFRAY [n -S]\n",
  "ORPHREYED": "embroidered with orphrey, gold [adj]\n",
  "ORPHREYS": "ORPHREY, gold or other rich embroidery on clerical robes, also ORFRAY [n]\n",
  "ORPIMENT": "a yellow arsenic compound used as a pigment [n -S]\n",
  "ORPIMENTS": "ORPIMENT, a yellow arsenic compound used as a pigment [n]\n",
  "ORPIN": "a yellow pigment of various degrees of intensity, approaching also to red [n -S]\n",
  "ORPINE": "a kind of stonecrop, aka livelong [n -S]\n",
  "ORPINES": "ORPINE, a kind of stonecrop, aka livelong [n]\n",
  "ORPINS": "ORPIN, a yellow pigment of various degrees of intensity, approaching also to red [n]\n",
  "ORRA": "(Scots) odd, not matched [adj]\n",
  "ORRAMAN": "(Scots) a worker, esp. on a farm, who does odd jobs [n ORRAMEN]\n",
  "ORRAMEN": "ORRAMAN, (Scots) a worker, esp. on a farm, who does odd jobs [n]\n",
  "ORRERIES": "ORRERY, a mechanical model of the solar system [n]\n",
  "ORRERY": "a mechanical model of the solar system [n ORRERIES]\n",
  "ORRICE": "the Florentine or other iris; its dried rootstock smelling of violets, used in perfumery, also ORRIS [n -S]\n",
  "ORRICES": "ORRICE, the Florentine or other iris; its dried rootstock smelling of violets, used in perfumery, also ORRIS [n]\n",
  "ORRIS": "the Florentine or other iris; its dried rootstock smelling of violets, used in perfumery, also ORRICE [n -ES]\n",
  "ORRISES": "ORRIS, the Florentine or other iris; its dried rootstock smelling of violets, used in perfumery, also ORRICE [n]\n",
  "ORRISROOT": "the root of orris, used in perfumery [n -S]\n",
  "ORRISROOTS": "ORRISROOT, the root of orris, used in perfumery [n]\n",
  "ORS": "OR, the heraldic tincture gold [n]\n",
  "ORSEILLE": "(French) a dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHELLA, ORCHIL, ORCHILLA [n -S]\n",
  "ORSEILLES": "ORSEILLE, (French) a dye obtained from certain lichens, also ARCHIL, ORCHEL, ORCHELLA, ORCHIL, ORCHILLA [n]\n",
  "ORSELLIC": "pertaining to, or designating, orseille, an acid found in certain lichens [adj]\n",
  "ORT": "a leftover from a meal [n -S]\n",
  "ORTANIQUE": "(French) a cross between an orange and a tangerine [n -S]\n",
  "ORTANIQUES": "ORTANIQUE, (French) a cross between an orange and a tangerine [n]\n",
  "ORTHIAN": "of singing etc., very high-pitched [adj]\n",
  "ORTHICON": "a kind of television camera tube [n -S]\n",
  "ORTHICONS": "ORTHICON, a kind of television camera tube [n]\n",
  "ORTHO": "short for orthochromatic plate (a photographic plate) [n -S]\n",
  "ORTHOAXES": "ORTHOAXIS, in crystallography, the orthodiagonal [n]\n",
  "ORTHOAXIS": "in crystallography, the orthodiagonal [n ORTHOAXES]\n",
  "ORTHOBORATE": "a salt of orthoboric acid [n -S]\n",
  "ORTHOBORATES": "ORTHOBORATE, a salt of orthoboric acid [n]\n",
  "ORTHOBORIC": "as in orthoboric acid, a white or colorless slightly acid [adj]\n",
  "ORTHOCAINE": "a white crystalline substance used as a local anaesthetic [n -S]\n",
  "ORTHOCAINES": "ORTHOCAINE, a white crystalline substance used as a local anaesthetic [n]\n",
  "ORTHOCENTER": "the point of intersection of the altitudes of a triangle, also ORTHOCENTRE [n -S]\n",
  "ORTHOCENTERS": "ORTHOCENTER, the point of intersection of the altitudes of a triangle, also ORTHOCENTRE [n]\n",
  "ORTHOCENTRE": "the point of intersection of the altitudes of a triangle, also ORTHOCENTER [n -S]\n",
  "ORTHOCENTRES": "ORTHOCENTRE, the point of intersection of the altitudes of a triangle, also ORTHOCENTER [n]\n",
  "ORTHOCEPHALIC": "having a skull whose breadth is between 70 and 75 per cent of its length, also ORTHOCEPHALOUS [adj]\n",
  "ORTHOCEPHALIES": "ORTHOCEPHALY, the state of being orthocephalic [n]\n",
  "ORTHOCEPHALOUS": "having a skull whose breadth is between 70 and 75 per cent of its length, also ORTHOCEPHALIC [adj]\n",
  "ORTHOCEPHALY": "the state of being orthocephalic [n ORTHOCEPHALIES]\n",
  "ORTHOCHROMATIC": "of photographic film, sensitive to all colours except red [adj]\n",
  "ORTHOCHROMATISM": "the state of being orthochromatic, of photographic film, sensitive to all colours except red [n]\n",
  "ORTHOCLASE": "common or potash feldspar crystallizing in the monoclinic system and having two cleavages at right angles to each other [n -S]\n",
  "ORTHOCLASES": "ORTHOCLASE, common or potash feldspar crystallizing in the monoclinic system and having two cleavages at right angles to each other [n]\n",
  "ORTHOCLASTIC": "chiefly of feldspar, having cleavages at right angles [adj]\n",
  "ORTHOCOUSINS": "the children of two brothers or two sisters [n]\n",
  "ORTHODIAGONAL": "in a monoclinic crystal, that lateral axis which is perpendicular to the vertical axis [n -S]\n",
  "ORTHODIAGONALS": "ORTHODIAGONAL, in a monoclinic crystal, that lateral axis which is perpendicular to the vertical axis [n]\n",
  "ORTHODONTIA": "the rectification of crookedness in the teeth, also ORTHODONTICS [n -S]\n",
  "ORTHODONTIAS": "ORTHODONTIA, the rectification of crookedness in the teeth, also ORTHODONTICS [n]\n",
  "ORTHODONTIC": "relating to orthodontics, the rectification of crookedness in the teeth [adj ORTHODONTICALLY]\n",
  "ORTHODONTICALLY": "ORTHODONTIC, relating to orthodontics, the rectification of crookedness in the teeth [adv]\n",
  "ORTHODONTICS": "the rectification of crookedness in the teeth, also ORTHODONTIA [n]\n",
  "ORTHODONTIST": "one who practises orthodontics [n -S]\n",
  "ORTHODONTISTS": "ORTHODONTIST, one who practises orthodontics [n]\n",
  "ORTHODOX": "sound in doctrine [adj ORTHODOXLY] / an orthodox person [n -ES]\n",
  "ORTHODOXES": "ORTHODOX, an orthodox person [n]\n",
  "ORTHODOXIES": "ORTHODOXY, the state of being orthodox [n]\n",
  "ORTHODOXLY": "ORTHODOX, sound in doctrine [adv]\n",
  "ORTHODOXY": "the state of being orthodox [n ORTHODOXIES]\n",
  "ORTHODROMIC": "having great circles represented as straight lines [adj]\n",
  "ORTHODROMICS": "the act or art of sailing on a great circle, also ORTHODROMY [n]\n",
  "ORTHODROMIES": "ORTHODROMY, the act or art of sailing on a great circle, also ORTHODROMICS [n]\n",
  "ORTHODROMY": "the act or art of sailing on a great circle, also ORTHODROMICS [n ORTHODROMIES]\n",
  "ORTHOEPIC": "relating to orthoepy, the study of correct pronunciation, also ORTHOEPICAL [adj ORTHOEPICALLY]\n",
  "ORTHOEPICAL": "relating to orthoepy, the study of correct pronunciation, also ORTHOEPIC [adj ORTHOEPICALLY]\n",
  "ORTHOEPICALLY": "ORTHOEPICAL, relating to orthoepy, the study of correct pronunciation, also ORTHOEPIC [adv]\n",
  "ORTHOEPIES": "ORTHOEPY, the study of correct pronunciation [n]\n",
  "ORTHOEPIST": "one who is skilled in orthoepy [n -S]\n",
  "ORTHOEPISTS": "ORTHOEPIST, one who is skilled in orthoepy [n]\n",
  "ORTHOEPY": "the study of correct pronunciation [n ORTHOEPIES]\n",
  "ORTHOGENESES": "ORTHOGENESIS, the belief that biological variation results in new species, always along the same path [n]\n",
  "ORTHOGENESIS": "the belief that biological variation results in new species, always along the same path [n ORTHOGENESES]\n",
  "ORTHOGENETIC": "pertaining to correction of children's mental defects [adj]\n",
  "ORTHOGENIC": "pertaining to correction of children's mental defects [adj ORTHOGENICALLY]\n",
  "ORTHOGENICALLY": "ORTHOGENIC, pertaining to correction of children's mental defects [adv]\n",
  "ORTHOGENICS": "the treatment of mentally and emotionally disturbed children [n]\n",
  "ORTHOGNATHIC": "having a lower jaw that neither projects nor recedes, also ORTHOGNATHOUS [adj]\n",
  "ORTHOGNATHIES": "ORTHOGNATHY, the state of having normally aligned jaws [n]\n",
  "ORTHOGNATHISM": "the state of having straight jaws [n -S]\n",
  "ORTHOGNATHISMS": "ORTHOGNATHISM, the state of having straight jaws [n]\n",
  "ORTHOGNATHOUS": "having a lower jaw that neither projects nor recedes, also ORTHOGNATHIC [adj]\n",
  "ORTHOGNATHY": "the state of having normally aligned jaws [n ORTHOGNATHIES]\n",
  "ORTHOGONAL": "at right angles; unrelated or independent of each other [adj]\n",
  "ORTHOGONALISE": "to make orthogonal, also ORTHOGONALIZE [v ORTHOGONALISED, ORTHOGONALISING, ORTHOGONALISES]\n",
  "ORTHOGONALISED": "ORTHOGONALISE, to make orthogonal, also ORTHOGONALIZE [v]\n",
  "ORTHOGONALISES": "ORTHOGONALISE, to make orthogonal, also ORTHOGONALIZE [v]\n",
  "ORTHOGONALISING": "ORTHOGONALISE, to make orthogonal, also ORTHOGONALIZE [v]\n",
  "ORTHOGONALITIES": "ORTHOGONALITY, the state of being orthogonal [n]\n",
  "ORTHOGONALITY": "the state of being orthogonal [n ORTHOGONALITIES]\n",
  "ORTHOGONALIZE": "to make orthogonal, also ORTHOGONALISE [v ORTHOGONALIZED, ORTHOGONALIZING, ORTHOGONALIZES]\n",
  "ORTHOGONALIZED": "ORTHOGONALIZE, to make orthogonal, also ORTHOGONALISE [v]\n",
  "ORTHOGONALIZES": "ORTHOGONALIZE, to make orthogonal, also ORTHOGONALISE [v]\n",
  "ORTHOGONALIZING": "ORTHOGONALIZE, to make orthogonal, also ORTHOGONALISE [v]\n",
  "ORTHOGONALLY": "ORTHOGONAL, at right angles; unrelated or independent of each other [adv]\n",
  "ORTHOGRADE": "walking with the body upright [adj]\n",
  "ORTHOGRAPH": "a drawing in orthographic projection [n -S]\n",
  "ORTHOGRAPHER": "a correct speller [n -S]\n",
  "ORTHOGRAPHERS": "ORTHOGRAPHER, a correct speller [n]\n",
  "ORTHOGRAPHIC": "relating to orthography, the part of language study that deals with letters and spelling, also ORTHOGRAPHICAL [adj]\n",
  "ORTHOGRAPHICAL": "relating to orthography, the part of language study that deals with letters and spelling, also ORTHOGRAPHIC [adj]\n",
  "ORTHOGRAPHIES": "ORTHOGRAPHY, the branch of knowledge concerned with the study of spelling and representing sounds of a language by letters and diacritics [n]\n",
  "ORTHOGRAPHIST": "an orthographer [n -S]\n",
  "ORTHOGRAPHISTS": "ORTHOGRAPHIST, an orthographer [n]\n",
  "ORTHOGRAPHS": "ORTHOGRAPH, a drawing in orthographic projection [n]\n",
  "ORTHOGRAPHY": "the branch of knowledge concerned with the study of spelling and representing sounds of a language by letters and diacritics [n ORTHOGRAPHIES]\n",
  "ORTHOHYDROGEN": "the form of molecular hydrogen, constituting about 75 per cent of the total at normal temperatures, in which the nuclei of the atoms spin in the same direction [n -S]\n",
  "ORTHOHYDROGENS": "ORTHOHYDROGEN, the form of molecular hydrogen, constituting about 75 per cent of the total at normal temperatures, in which the nuclei of the atoms spin in the same direction [n]\n",
  "ORTHOMOLECULAR": "relating to the theory that mental illness is chemical [adj]\n",
  "ORTHOMORPHIC": "of a map projection, maintaining true shape over a small area and scale in every direction [adj]\n",
  "ORTHONORMAL": "orthogonal with the integral of the square of each function over a specified interval equal to one [adj]\n",
  "ORTHOPAEDIC": "relating to orthopaedics, also ORTHOPAEDICAL, ORTHOPEDIC [adj ORTHOPAEDICALLY]\n",
  "ORTHOPAEDICAL": "relating to orthopaedics, also ORTHOPAEDIC, ORTHOPEDIC [adj ORTHOPAEDICALLY]\n",
  "ORTHOPAEDICALLY": "ORTHOPAEDIC, relating to orthopaedics, also ORTHOPAEDICAL, ORTHOPEDIC [adv]\n",
  "ORTHOPAEDICS": "the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDY, ORTHOPEDIA, ORTHOPEDICS, ORTHOPEDY [n]\n",
  "ORTHOPAEDIES": "ORTHOPAEDY, the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPEDIA, ORTHOPEDICS, ORTHOPEDY [n]\n",
  "ORTHOPAEDIST": "a specialist in orthopaedy, also ORTHOPEDIST [n -S]\n",
  "ORTHOPAEDISTS": "ORTHOPAEDIST, a specialist in orthopaedy, also ORTHOPEDIST [n]\n",
  "ORTHOPAEDY": "the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPEDIA, ORTHOPEDICS, ORTHOPEDY [n ORTHOPAEDIES]\n",
  "ORTHOPEDIA": "the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPAEDY, ORTHOPEDICS, ORTHOPEDY [n -S]\n",
  "ORTHOPEDIAS": "ORTHOPEDIA, the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPAEDY, ORTHOPEDICS, ORTHOPEDY [n]\n",
  "ORTHOPEDIC": "of, relating to, or employed in orthopedics, also ORTHOPAEDIC, ORTHOPAEDICAL [adj]\n",
  "ORTHOPEDICAL": "related to orthopedics [adj ORTHOPEDICALLY]\n",
  "ORTHOPEDICALLY": "ORTHOPEDICAL, related to orthopedics [adv]\n",
  "ORTHOPEDICS": "the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPAEDY, ORTHOPEDIA, ORTHOPEDY [n]\n",
  "ORTHOPEDIES": "ORTHOPEDY, the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPAEDY, ORTHOPEDIA, ORTHOPEDICS [n]\n",
  "ORTHOPEDIST": "a specialist in orthopedics, also ORTHOPAEDIST [n -S]\n",
  "ORTHOPEDISTS": "ORTHOPEDIST, a specialist in orthopedics, also ORTHOPAEDIST [n]\n",
  "ORTHOPEDY": "the art or process of curing deformities arising from (originally childhood) disease or injury, also ORTHOPAEDICS, ORTHOPAEDY, ORTHOPEDIA, ORTHOPEDICS [n ORTHOPEDIES]\n",
  "ORTHOPHOSPHATE": "a salt or ester of orthophosphoric acid [n -S]\n",
  "ORTHOPHOSPHATES": "ORTHOPHOSPHATE, a salt or ester of orthophosphoric acid [n]\n",
  "ORTHOPHOSPHORIC": "phosphoric [adj]\n",
  "ORTHOPHYRE": "a fine-grained syenitic rock with orthoclase crystals [n -S]\n",
  "ORTHOPHYRES": "ORTHOPHYRE, a fine-grained syenitic rock with orthoclase crystals [n]\n",
  "ORTHOPHYRIC": "relating to orthophyre, a fine-grained syenitic rock with orthoclase crystals [adj]\n",
  "ORTHOPINAKOID": "in monoclinic crystals, a form consisting of two faces parallel to the orthodiagonal and the vertical axis [n -S]\n",
  "ORTHOPINAKOIDS": "ORTHOPINAKOID, in monoclinic crystals, a form consisting of two faces parallel to the orthodiagonal and the vertical axis [n]\n",
  "ORTHOPNOEA": "the ability to breathe in an upright position only [n -S]\n",
  "ORTHOPNOEAS": "ORTHOPNOEA, the ability to breathe in an upright position only [n]\n",
  "ORTHOPOD": "(slang) an orthopaedic surgeon [n -S]\n",
  "ORTHOPODS": "ORTHOPOD, (slang) an orthopaedic surgeon [n]\n",
  "ORTHOPRAXES": "ORTHOPRAXIS, correct practice in religion [n]\n",
  "ORTHOPRAXIES": "ORTHOPRAXY, the treatment of deformities in the human body by mechanical appliances [n]\n",
  "ORTHOPRAXIS": "correct practice in religion [n ORTHOPRAXES]\n",
  "ORTHOPRAXY": "the treatment of deformities in the human body by mechanical appliances [n ORTHOPRAXIES]\n",
  "ORTHOPRISM": "in monoclinic crystals, a form consisting of two faces parallel to the orthodiagonal [n -S]\n",
  "ORTHOPRISMS": "ORTHOPRISM, in monoclinic crystals, a form consisting of two faces parallel to the orthodiagonal [n]\n",
  "ORTHOPSYCHIATRY": "preventive psychiatry for young people [n]\n",
  "ORTHOPTER": "a type of aircraft propelled with flapping wings [n -S]\n",
  "ORTHOPTERA": "ORTHOPTERON, any member of the Orthoptera, an order of mandibulate insects, also ORTHOPTERAN [n]\n",
  "ORTHOPTERAN": "any member of the Orthoptera, an order of mandibulate insects, also ORTHOPTERON [n -S]\n",
  "ORTHOPTERANS": "ORTHOPTERAN, any member of the Orthoptera, an order of mandibulate insects, also ORTHOPTERON [n]\n",
  "ORTHOPTERIST": "a student of insects [n -S]\n",
  "ORTHOPTERISTS": "ORTHOPTERIST, a student of insects [n]\n",
  "ORTHOPTEROID": "a member of the Orthoptera, cockroaches [n -S]\n",
  "ORTHOPTEROIDS": "ORTHOPTEROID, a member of the Orthoptera, cockroaches [n]\n",
  "ORTHOPTEROLOGY": "the study of cockroaches [n]\n",
  "ORTHOPTERON": "any member of the Orthoptera, an order of mandibulate insects, also ORTHOPTERAN [n ORTHOPTERA]\n",
  "ORTHOPTEROUS": "pertaining or belonging to insect order including grasshoppers, crickets, etc. [adj]\n",
  "ORTHOPTERS": "ORTHOPTER, a type of aircraft propelled with flapping wings [n]\n",
  "ORTHOPTIC": "pertaining to correct vision [adj]\n",
  "ORTHOPTICS": "the science of correct vision [n]\n",
  "ORTHOPTIST": "one who practises orthoptics, the science of correct vision [n -S]\n",
  "ORTHOPTISTS": "ORTHOPTIST, one who practises orthoptics, the science of correct vision [n]\n",
  "ORTHOPYROXENE": "a member of the pyroxene group of minerals having an orthorhombic crystal structure, such as enstatite and hypersthene [n -S]\n",
  "ORTHOPYROXENES": "ORTHOPYROXENE, a member of the pyroxene group of minerals having an orthorhombic crystal structure, such as enstatite and hypersthene [n]\n",
  "ORTHOREXIA": "an eating disorder characterized by excessive focus on eating healthy foods [n -S]\n",
  "ORTHOREXIAS": "ORTHOREXIA, an eating disorder characterized by excessive focus on eating healthy foods [n]\n",
  "ORTHORHOMBIC": "three mutually perpendicular axes of different lengths [adj]\n",
  "ORTHOS": "ORTHO, short for orthochromatic plate (a photographic plate) [n]\n",
  "ORTHOSCOPE": "a nineteenth century instrument for viewing the fundus of the eye through a layer of water, which eliminates distortion caused by the cornea [n -S]\n",
  "ORTHOSCOPES": "ORTHOSCOPE, a nineteenth century instrument for viewing the fundus of the eye through a layer of water, which eliminates distortion caused by the cornea [n]\n",
  "ORTHOSCOPIC": "giving undistorted vision [adj]\n",
  "ORTHOSES": "ORTHOSIS, (Greek) a device which supports or corrects deformities [n]\n",
  "ORTHOSILICATE": "a salt of orthosilicic acid [n -S]\n",
  "ORTHOSILICATES": "ORTHOSILICATE, a salt of orthosilicic acid [n]\n",
  "ORTHOSILICIC": "as in orthosilicic acid, a weak acid made in solution by acidifying solutions of silicates [adj]\n",
  "ORTHOSIS": "(Greek) a device which supports or corrects deformities [n ORTHOSES]\n",
  "ORTHOSTATIC": "pertaining to erect or standing position [adj]\n",
  "ORTHOSTICHIES": "ORTHOSTICHY, a straight row, e.g. of leaves vertically over one another on an axis [n]\n",
  "ORTHOSTICHOUS": "arranged in vertical rows [adj]\n",
  "ORTHOSTICHY": "a straight row, e.g. of leaves vertically over one another on an axis [n ORTHOSTICHIES]\n",
  "ORTHOTIC": "relating to orthosis, the correction of neurotic state [adj]\n",
  "ORTHOTICS": "the branch of medicine that uses prosthetics to support weakened limbs [n]\n",
  "ORTHOTIST": "one skilled in orthotics [n -S]\n",
  "ORTHOTISTS": "ORTHOTIST, one skilled in orthotics [n]\n",
  "ORTHOTONE": "taking an accent in certain positions but not in others, also ORTHOTONIC [adj] / an orthotone word [n -S]\n",
  "ORTHOTONES": "ORTHOTONE, an orthotone word [n]\n",
  "ORTHOTONESES": "ORTHOTONESIS, accentuation of a proclitic or enclitic, as opposed to enclisis [n]\n",
  "ORTHOTONESIS": "accentuation of a proclitic or enclitic, as opposed to enclisis [n ORTHOTONESES]\n",
  "ORTHOTONIC": "taking an accent in certain positions but not in others, also ORTHOTONE [adj]\n",
  "ORTHOTOPIC": "of tissue grafts etc., done at the normal place [adj]\n",
  "ORTHOTROPIC": "growing along a vertical axis [adj]\n",
  "ORTHOTROPIES": "ORTHOTROPY, the state of being orthotropic, growing along a vertical axis [n]\n",
  "ORTHOTROPISM": "vertical growth [n -S]\n",
  "ORTHOTROPISMS": "ORTHOTROPISM, vertical growth [n]\n",
  "ORTHOTROPOUS": "growing straight, so that the micropyle is opposite the stalk [adj]\n",
  "ORTHOTROPY": "the state of being orthotropic, growing along a vertical axis [n ORTHOTROPIES]\n",
  "ORTHOTUNGSTIC": "as in orthotungstic acid [adj]\n",
  "ORTHOVANADIC": "as in orthovanadic acid [adj]\n",
  "ORTHROS": "(Greek) one of the Greek canonical hours [n -ES]\n",
  "ORTHROSES": "ORTHROS, (Greek) one of the Greek canonical hours [n]\n",
  "ORTOLAN": "(French) a kind of bunting, common in Europe and eaten as a delicacy [n -S]\n",
  "ORTOLANS": "ORTOLAN, (French) a kind of bunting, common in Europe and eaten as a delicacy [n]\n",
  "ORTS": "ORT, a leftover from a meal [n]\n",
  "ORVAL": "a plant of the sage genus [n -S]\n",
  "ORVALS": "ORVAL, a plant of the sage genus [n]\n",
  "ORYCTOLOGIES": "ORYCTOLOGY, (obsolete) mineralogy or paleontology [n]\n",
  "ORYCTOLOGY": "(obsolete) mineralogy or paleontology [n ORYCTOLOGIES]\n",
  "ORYX": "a kind of African antelope [n -ES]\n",
  "ORYXES": "ORYX, a kind of African antelope [n]\n",
  "ORZO": "(Italian) pasta in the form of small pieces like barley [n -S]\n",
  "ORZOS": "ORZO, (Italian) pasta in the form of small pieces like barley [n]\n",
  "OS": "(Latin) a bone [n OSSA] / a mouthlike opening [n ORA] / an esker [n OSAR]\n",
  "OSAR": "OS, (Latin) a bone [n]\n",
  "OSCAR": "(Australian slang) cash, money [n -S]\n",
  "OSCARS": "OSCAR, (Australian slang) cash, money [n]\n",
  "OSCHEAL": "pertaining to the scrotum [adj]\n",
  "OSCILLATE": "to swing to and fro like a pendulum [v OSCILLATED, OSCILLATING, OSCILLATES]\n",
  "OSCILLATED": "OSCILLATE, to swing to and fro like a pendulum [v]\n",
  "OSCILLATES": "OSCILLATE, to swing to and fro like a pendulum [v]\n",
  "OSCILLATING": "OSCILLATE, to swing to and fro like a pendulum [v]\n",
  "OSCILLATION": "the action or state of oscillating [n -S]\n",
  "OSCILLATIONAL": "relating to oscillation [adj]\n",
  "OSCILLATIONS": "OSCILLATION, the action or state of oscillating [n]\n",
  "OSCILLATIVE": "having a tendency to vibrate [adj]\n",
  "OSCILLATOR": "one that oscillates [n -S]\n",
  "OSCILLATORS": "OSCILLATOR, one that oscillates [n]\n",
  "OSCILLATORY": "tending to oscillate [adj]\n",
  "OSCILLOGRAM": "a record made by an oscillograph [n -S]\n",
  "OSCILLOGRAMS": "OSCILLOGRAM, a record made by an oscillograph [n]\n",
  "OSCILLOGRAPH": "an instrument for recording alternating current wave forms [n -S]\n",
  "OSCILLOGRAPHIC": "relating to an oscillograph [adj]\n",
  "OSCILLOGRAPHIES": "OSCILLOGRAPHY, use of an oscillograph [n]\n",
  "OSCILLOGRAPHS": "OSCILLOGRAPH, an instrument for recording alternating current wave forms [n]\n",
  "OSCILLOGRAPHY": "use of an oscillograph [n OSCILLOGRAPHIES]\n",
  "OSCILLOSCOPE": "an instrument for detecting electrical fluctuations [n -S]\n",
  "OSCILLOSCOPES": "OSCILLOSCOPE, an instrument for detecting electrical fluctuations [n]\n",
  "OSCILLOSCOPIC": "relating to use of the oscilloscope [adj]\n",
  "OSCINE": "belonging to the suborder of birds including singing birds, also OSCININE [adj] / a singing bird [n -S]\n",
  "OSCINES": "OSCINE, a singing bird [n]\n",
  "OSCININE": "belonging to the suborder of birds including singing birds, also OSCINE [adj]\n",
  "OSCITANCE": "yawning, sleepiness, also OSCITANCY [n -S]\n",
  "OSCITANCES": "OSCITANCE, yawning, sleepiness, also OSCITANCY [n]\n",
  "OSCITANCIES": "OSCITANCY, yawning, sleepiness, also OSCITANCE [n]\n",
  "OSCITANCY": "yawning, sleepiness, also OSCITANCE [n OSCITANCIES]\n",
  "OSCITANT": "yawning; gaping [adj OSCITANTLY]\n",
  "OSCITANTLY": "OSCITANT, yawning; gaping [adv]\n",
  "OSCITATE": "to yawn [v OSCITATED, OSCITATING, OSCITATES]\n",
  "OSCITATED": "OSCITATE, to yawn [v]\n",
  "OSCITATES": "OSCITATE, to yawn [v]\n",
  "OSCITATING": "OSCITATE, to yawn [v]\n",
  "OSCITATION": "yawning, sleepiness [n -S]\n",
  "OSCITATIONS": "OSCITATION, yawning, sleepiness [n]\n",
  "OSCULA": "OSCULUM, (Latin) a small mouthlike opening e.g. in a sponge, also OSCULE [n]\n",
  "OSCULANT": "adhering closely [adj]\n",
  "OSCULAR": "pertaining to the mouth [adj]\n",
  "OSCULATE": "to kiss [v OSCULATED, OSCULATING, OSCULATES]\n",
  "OSCULATED": "OSCULATE, to kiss [v]\n",
  "OSCULATES": "OSCULATE, to kiss [v]\n",
  "OSCULATING": "OSCULATE, to kiss [v]\n",
  "OSCULATION": "a kiss; the point where two branches of a curve share, follow a common tangent [n -S]\n",
  "OSCULATIONS": "OSCULATION, a kiss; the point where two branches of a curve share, follow a common tangent [n]\n",
  "OSCULATORIES": "OSCULATORY, a carved tablet kissed by priest during celebration of mass [n]\n",
  "OSCULATORY": "a carved tablet kissed by priest during celebration of mass [n OSCULATORIES]\n",
  "OSCULE": "a small mouthlike aperture e.g. in a sponge [n -S]\n",
  "OSCULES": "OSCULE, a small mouthlike aperture e.g. in a sponge [n]\n",
  "OSCULUM": "(Latin) a small mouthlike opening e.g. in a sponge, also OSCULE [n OSCULA]\n",
  "OSE": "an esker, a narrow ridge of gravel and sand [n -S]\n",
  "OSES": "OSE, an esker, a narrow ridge of gravel and sand [n]\n",
  "OSETRA": "(Russian) a type of caviar, also OSSETRA [n -S]\n",
  "OSETRAS": "OSETRA, (Russian) a type of caviar, also OSSETRA [n]\n",
  "OSHAC": "(Arabic) the ammoniac plant [n -S]\n",
  "OSHACS": "OSHAC, (Arabic) the ammoniac plant [n]\n",
  "OSIER": "a species of willow whose twigs are used in making baskets [n -S]\n",
  "OSIERED": "covered or fringed with osiers [adj]\n",
  "OSIERIES": "OSIERY, an osier bed [n]\n",
  "OSIERS": "OSIER, a species of willow whose twigs are used in making baskets [n]\n",
  "OSIERY": "an osier bed [n OSIERIES]\n",
  "OSMATE": "a salt of osmic acid, also OSMIATE [n -S]\n",
  "OSMATES": "OSMATE, a salt of osmic acid, also OSMIATE [n]\n",
  "OSMATIC": "relying chiefly upon smell [adj]\n",
  "OSMETERIA": "OSMETERIUM, a forked process behind the head of certain caterpillars, giving out a foul smell [n]\n",
  "OSMETERIUM": "a forked process behind the head of certain caterpillars, giving out a foul smell [n OSMETERIA]\n",
  "OSMIATE": "a salt of osmic acid, also OSMATE [n -S]\n",
  "OSMIATES": "OSMIATE, a salt of osmic acid, also OSMATE [n]\n",
  "OSMIC": "containing osmium in higher valency [adj OSMICALLY]\n",
  "OSMICALLY": "relating to the sense of smell [adv]\n",
  "OSMICS": "the study of the sense of smell [n]\n",
  "OSMIDROSES": "OSMIDROSIS, the emission of ill-smelling sweat [n]\n",
  "OSMIDROSIS": "the emission of ill-smelling sweat [n OSMIDROSES]\n",
  "OSMIOUS": "containing osmium in lower valency, also OSMOUS [adj]\n",
  "OSMIRIDIUM": "a very hard corrosion-resistant white or grey natural alloy of osmium and iridium, also IRIDOSMINE, IRIDOSMIUM [n -S]\n",
  "OSMIRIDIUMS": "OSMIRIDIUM, a very hard corrosion-resistant white or grey natural alloy of osmium and iridium, also IRIDOSMINE, IRIDOSMIUM [n]\n",
  "OSMIUM": "a metallic element [n -S]\n",
  "OSMIUMS": "OSMIUM, a metallic element [n]\n",
  "OSMOL": "a unit of osmotic pressure, also OSMOLE [n -S]\n",
  "OSMOLAL": "relating to an osmol, a unit of osmotic pressure [adj]\n",
  "OSMOLALITIES": "OSMOLALITY, the quality of being osmotic [n]\n",
  "OSMOLALITY": "the quality of being osmotic [n OSMOLALITIES]\n",
  "OSMOLAR": "pertaining to, or having the property of, osmosis; as, osmolar force, also OSMOTIC [adj]\n",
  "OSMOLARITIES": "OSMOLARITY, the quality of being osmotic [n]\n",
  "OSMOLARITY": "the quality of being osmotic [n OSMOLARITIES]\n",
  "OSMOLE": "a unit of osmotic pressure, also OSMOL [n -S]\n",
  "OSMOLES": "OSMOLE, a unit of osmotic pressure, also OSMOL [n]\n",
  "OSMOLS": "OSMOL, a unit of osmotic pressure, also OSMOLE [n]\n",
  "OSMOMETER": "an instrument for measuring osmotic pressure [n -S]\n",
  "OSMOMETERS": "OSMOMETER, an instrument for measuring osmotic pressure [n]\n",
  "OSMOMETRIC": "relating to osmometry [adj OSMOMETRICALLY]\n",
  "OSMOMETRICALLY": "OSMOMETRIC, relating to osmometry [adv]\n",
  "OSMOMETRIES": "OSMOMETRY, the use of an osmometer, an instrument for measuring osmotic pressure [n]\n",
  "OSMOMETRY": "the use of an osmometer, an instrument for measuring osmotic pressure [n OSMOMETRIES]\n",
  "OSMOREGULATION": "regulation of osmotic pressure esp. in the body of a living organism [n -S]\n",
  "OSMOREGULATIONS": "OSMOREGULATION, regulation of osmotic pressure esp. in the body of a living organism [n]\n",
  "OSMOREGULATORY": "relating to osmoregulation [adj]\n",
  "OSMOSE": "to undergo osmosis [v OSMOSED, OSMOSING, OSMOSES]\n",
  "OSMOSED": "OSMOSE, to undergo osmosis [v]\n",
  "OSMOSES": "OSMOSE, to undergo osmosis [v]\n",
  "OSMOSING": "OSMOSE, to undergo osmosis [v]\n",
  "OSMOSIS": "diffusion of liquids through a semipermeable membrane [n OSMOSES]\n",
  "OSMOTIC": "pertaining to, or having the property of, osmosis; as, osmotic force, also OSMOLAR [adj OSMOTICALLY]\n",
  "OSMOTICALLY": "OSMOTIC, pertaining to, or having the property of, osmosis; as, osmotic force, also OSMOLAR [adv]\n",
  "OSMOUS": "containing osmium in lower valency, also OSMIOUS [adj]\n",
  "OSMUND": "any fern of the genus Osmunda, that includes royal fern, also OSMUNDA [n -S]\n",
  "OSMUNDA": "any fern of the genus Osmunda, that includes royal fern, also OSMUND [n -S]\n",
  "OSMUNDAS": "OSMUNDA, any fern of the genus Osmunda, that includes royal fern, also OSMUND [n]\n",
  "OSMUNDINE": "a type of compost made from dried fern moss [n -S]\n",
  "OSMUNDINES": "OSMUNDINE, a type of compost made from dried fern moss [n]\n",
  "OSMUNDS": "OSMUND, any fern of the genus Osmunda, that includes royal fern, also OSMUNDA [n]\n",
  "OSNABURG": "(German) a coarse linen or cotton [n -S]\n",
  "OSNABURGS": "OSNABURG, (German) a coarse linen or cotton [n]\n",
  "OSPREY": "a bird of prey that feeds on fish [n -S]\n",
  "OSPREYS": "OSPREY, a bird of prey that feeds on fish [n]\n",
  "OSSA": "OS, (Latin) a bone [n]\n",
  "OSSARIUM": "(Latin) a depository for the bones of the dead, also OSSUARY [n -S]\n",
  "OSSARIUMS": "OSSARIUM, (Latin) a depository for the bones of the dead, also OSSUARY [n]\n",
  "OSSATURE": "a skeleton [n -S]\n",
  "OSSATURES": "OSSATURE, a skeleton [n]\n",
  "OSSEIN": "a gelatinous bone residue used for gelatin and glue [n -S]\n",
  "OSSEINS": "OSSEIN, a gelatinous bone residue used for gelatin and glue [n]\n",
  "OSSELET": "a hard substance growing on the inside of a horse's knee [n -S]\n",
  "OSSELETS": "OSSELET, a hard substance growing on the inside of a horse's knee [n]\n",
  "OSSEOUS": "composed of bone; resembling bone [adj OSSEOUSLY]\n",
  "OSSEOUSLY": "OSSEOUS, composed of bone; resembling bone [adv]\n",
  "OSSETER": "(Russian) a species of sturgeon [n -S]\n",
  "OSSETERS": "OSSETER, (Russian) a species of sturgeon [n]\n",
  "OSSETRA": "(Russian) a type of caviar, also OSETRA [n -S]\n",
  "OSSETRAS": "OSSETRA, (Russian) a type of caviar, also OSETRA [n]\n",
  "OSSIA": "(Italian) in music, an alternative passage [n -S]\n",
  "OSSIAS": "OSSIA, (Italian) in music, an alternative passage [n]\n",
  "OSSICLE": "a small bone [n -S]\n",
  "OSSICLES": "OSSICLE, a small bone [n]\n",
  "OSSICULAR": "relating to an ossicle, a little bone or bone-like plate [adj]\n",
  "OSSIFEROUS": "bearing bones [adj]\n",
  "OSSIFIC": "capable of producing bone; having the power to change cartilage or other tissue into bone [adj]\n",
  "OSSIFICATION": "the natural process of bone formation [n -S]\n",
  "OSSIFICATIONS": "OSSIFICATION, the natural process of bone formation [n]\n",
  "OSSIFIED": "OSSIFY, to change into bone; to become callous or conventional [v]\n",
  "OSSIFIER": "an agent that causes ossification [n -S]\n",
  "OSSIFIERS": "OSSIFIER, an agent that causes ossification [n]\n",
  "OSSIFIES": "OSSIFY, to change into bone; to become callous or conventional [v]\n",
  "OSSIFRAGA": "(Latin) the giant fulmar [n -S]\n",
  "OSSIFRAGAS": "OSSIFRAGA, (Latin) the giant fulmar [n]\n",
  "OSSIFRAGE": "(Biblical) a large bird of prey, e.g. a hawk, buzzard, vulture, or eagle [n -S]\n",
  "OSSIFRAGES": "OSSIFRAGE, (Biblical) a large bird of prey, e.g. a hawk, buzzard, vulture, or eagle [n]\n",
  "OSSIFY": "to change into bone; to become callous or conventional [v OSSIFIED, OSSIFYING, OSSIFIES]\n",
  "OSSIFYING": "OSSIFY, to change into bone; to become callous or conventional [v]\n",
  "OSSIVOROUS": "feeding on bones [adj]\n",
  "OSSOBUCO": "(Italian) an Italian dish of veal knuckle cooked with the bone and stewed in wine, herbs etc. [n -S]\n",
  "OSSOBUCOS": "OSSOBUCO, (Italian) an Italian dish of veal knuckle cooked with the bone and stewed in wine, herbs etc. [n]\n",
  "OSSUARIES": "OSSUARY, a depository for the bones of the dead, also OSSARIUM [n]\n",
  "OSSUARY": "a depository for the bones of the dead, also OSSARIUM [n OSSUARIES]\n",
  "OSTEAL": "relating to, of or comprised of bone [adj]\n",
  "OSTEICHTHYAN": "a bony fish [n -S]\n",
  "OSTEICHTHYANS": "OSTEICHTHYAN, a bony fish [n]\n",
  "OSTEITIC": "pertaining to inflammation of the bone [adj]\n",
  "OSTEITIDES": "OSTEITIS, inflammation of the bone [n]\n",
  "OSTEITIS": "inflammation of the bone [n OSTEITISES or OSTEITIDES]\n",
  "OSTEITISES": "OSTEITIS, inflammation of the bone [n]\n",
  "OSTENSIBILITIES": "OSTENSIBILITY, the state of being ostensible, intended for display [n]\n",
  "OSTENSIBILITY": "the state of being ostensible, intended for display [n OSTENSIBILITIES]\n",
  "OSTENSIBLE": "intended for display, plausible rather than demonstrably true or real [adj OSTENSIBLY]\n",
  "OSTENSIBLY": "OSTENSIBLE, intended for display, plausible rather than demonstrably true or real [adv]\n",
  "OSTENSIVE": "showing, exhibiting [adj OSTENSIVELY]\n",
  "OSTENSIVELY": "OSTENSIVE, showing, exhibiting [adv]\n",
  "OSTENSORIA": "OSTENSORIUM, a monstrance (a receptacle for the Eucharist) [n]\n",
  "OSTENSORIES": "OSTENSORY, a container for holding consecrated Communion wafers [n]\n",
  "OSTENSORIUM": "a monstrance (a receptacle for the Eucharist) [n OSTENSORIA]\n",
  "OSTENSORY": "a container for holding consecrated Communion wafers [n OSTENSORIES]\n",
  "OSTENT": "to show off [v -ED, -ING, -S]\n",
  "OSTENTATION": "excessive display [n -S]\n",
  "OSTENTATIONS": "OSTENTATION, excessive display [n]\n",
  "OSTENTATIOUS": "marked by conspicuous display [adj OSTENTATIOUSLY]\n",
  "OSTENTATIOUSLY": "OSTENTATIOUS, marked by conspicuous display [adv]\n",
  "OSTENTED": "OSTENT, to show off [v]\n",
  "OSTENTING": "OSTENT, to show off [v]\n",
  "OSTENTS": "OSTENT, to show off [v]\n",
  "OSTEOARTHRITIC": "suffering from osteoarthritis [adj] / one suffering from osteoarthritis [n -S]\n",
  "OSTEOARTHRITICS": "OSTEOARTHRITIC, one suffering from osteoarthritis [n]\n",
  "OSTEOARTHRITIS": "arthritis marked by degeneration of the cartilage and bone of joints [n]\n",
  "OSTEOARTHROSES": "OSTEOARTHROSIS, chronic noninflammatory disease of the joints and the bone adjacent [n]\n",
  "OSTEOARTHROSIS": "chronic noninflammatory disease of the joints and the bone adjacent [n OSTEOARTHROSES]\n",
  "OSTEOBLAST": "one of the protoplasmic cells from or around which the matrix of the bone is developed [n -S]\n",
  "OSTEOBLASTIC": "of or like an osteoblast [adj]\n",
  "OSTEOBLASTS": "OSTEOBLAST, one of the protoplasmic cells from or around which the matrix of the bone is developed [n]\n",
  "OSTEOCLASES": "OSTEOCLASIS, the surgical breaking of a bone [n]\n",
  "OSTEOCLASIS": "the surgical breaking of a bone [n OSTEOCLASES]\n",
  "OSTEOCLAST": "an instrument used in osteoclasis [n -S]\n",
  "OSTEOCLASTIC": "of or like an osteoclast, an instrument used to break bones [adj]\n",
  "OSTEOCLASTS": "OSTEOCLAST, an instrument used in osteoclasis [n]\n",
  "OSTEOCOLLA": "a kind of glue obtained from bones [n -S]\n",
  "OSTEOCOLLAS": "OSTEOCOLLA, a kind of glue obtained from bones [n]\n",
  "OSTEOCYTE": "a cell that is characteristic of adult bone [n -S]\n",
  "OSTEOCYTES": "OSTEOCYTE, a cell that is characteristic of adult bone [n]\n",
  "OSTEODERM": "a bony dermal plate [n -S]\n",
  "OSTEODERMAL": "of or like an osteoderm, also OSTEODERMATOUS, OSTEODERMIC, OSTEODERMOUS [adj]\n",
  "OSTEODERMATOUS": "of or like an osteoderm, also OSTEODERMAL, OSTEODERMIC, OSTEODERMOUS [adj]\n",
  "OSTEODERMIC": "of or like an osteoderm, also OSTEODERMAL, OSTEODERMATOUS, OSTEODERMOUS [adj]\n",
  "OSTEODERMOUS": "of or like an osteoderm, also OSTEODERMAL, OSTEODERMATOUS, OSTEODERMIC [adj]\n",
  "OSTEODERMS": "OSTEODERM, a bony dermal plate [n]\n",
  "OSTEOFIBROSES": "OSTEOFIBROSIS, fibrosis of the bone [n]\n",
  "OSTEOFIBROSIS": "fibrosis of the bone [n OSTEOFIBROSES]\n",
  "OSTEOGEN": "a substance from which bone is formed [n -S]\n",
  "OSTEOGENESES": "OSTEOGENESIS, the production or formation of bone [n]\n",
  "OSTEOGENESIS": "the production or formation of bone [n OSTEOGENESES]\n",
  "OSTEOGENETIC": "relating to the formation of bone, also OSTEOGENIC [adj]\n",
  "OSTEOGENIC": "relating to the formation of bone, also OSTEOGENETIC [adj]\n",
  "OSTEOGENIES": "OSTEOGENY, the formation or growth of bone [n]\n",
  "OSTEOGENOUS": "of or like an osteogen [adj]\n",
  "OSTEOGENS": "OSTEOGEN, a substance from which bone is formed [n]\n",
  "OSTEOGENY": "the formation or growth of bone [n OSTEOGENIES]\n",
  "OSTEOGRAPHIES": "OSTEOGRAPHY, a description of bones [n]\n",
  "OSTEOGRAPHY": "a description of bones [n OSTEOGRAPHIES]\n",
  "OSTEOID": "an uncalcified bone matrix [n -S]\n",
  "OSTEOIDS": "OSTEOID, an uncalcified bone matrix [n]\n",
  "OSTEOLOGICAL": "relating to osteology [adj OSTEOLOGICALLY]\n",
  "OSTEOLOGICALLY": "OSTEOLOGICAL, relating to osteology [adv]\n",
  "OSTEOLOGIES": "OSTEOLOGY, the study of bones [n]\n",
  "OSTEOLOGIST": "one who practises osteology [n -S]\n",
  "OSTEOLOGISTS": "OSTEOLOGIST, one who practises osteology [n]\n",
  "OSTEOLOGY": "the study of bones [n OSTEOLOGIES]\n",
  "OSTEOMA": "(Greek) a tumor composed of bone or bone-like tissue [n OSTEOMAS or OSTEOMATA]\n",
  "OSTEOMALACIA": "softening of the skull due to calcium deficiency [n -S]\n",
  "OSTEOMALACIAL": "relating to osteomalacia, softening of the skull due to calcium deficiency, also OSTEOMALACIC [adj]\n",
  "OSTEOMALACIAS": "OSTEOMALACIA, softening of the skull due to calcium deficiency [n]\n",
  "OSTEOMALACIC": "relating to osteomalacia, softening of the skull due to calcium deficiency, also OSTEOMALACIAL [adj]\n",
  "OSTEOMAS": "OSTEOMA, (Greek) a tumor composed of bone or bone-like tissue [n]\n",
  "OSTEOMATA": "OSTEOMA, (Greek) a tumor composed of bone or bone-like tissue [n]\n",
  "OSTEOMYELITIS": "inflammation of bone marrow [n -ES]\n",
  "OSTEOMYELITISES": "OSTEOMYELITIS, inflammation of bone marrow [n]\n",
  "OSTEOPATH": "a practitioner of osteopathy, also OSTEOPATHIST [n -S]\n",
  "OSTEOPATHIC": "relating to osteopathy [adj OSTEOPATHICALLY]\n",
  "OSTEOPATHICALLY": "OSTEOPATHIC, relating to osteopathy [adv]\n",
  "OSTEOPATHIES": "OSTEOPATHY, a system of healing or treatment consisting largely of manipulation of the bones, and massage [n]\n",
  "OSTEOPATHIST": "a practitioner of osteopathy, also OSTEOPATH [n -S]\n",
  "OSTEOPATHISTS": "OSTEOPATHIST, a practitioner of osteopathy, also OSTEOPATH [n]\n",
  "OSTEOPATHS": "OSTEOPATH, a practitioner of osteopathy, also OSTEOPATHIST [n]\n",
  "OSTEOPATHY": "a system of healing or treatment consisting largely of manipulation of the bones, and massage [n OSTEOPATHIES]\n",
  "OSTEOPETROSES": "OSTEOPETROSIS, a general name for a group of hereditary bone diseases, including marble bone disease, in which bone becomes abnormally dense [n]\n",
  "OSTEOPETROSIS": "a general name for a group of hereditary bone diseases, including marble bone disease, in which bone becomes abnormally dense [n OSTEOPETROSES]\n",
  "OSTEOPHYTE": "an abnormal bony outgrowth [n -S]\n",
  "OSTEOPHYTES": "OSTEOPHYTE, an abnormal bony outgrowth [n]\n",
  "OSTEOPHYTIC": "like an osteophyte, an abnormal bony outgrowth [adj]\n",
  "OSTEOPLASTIC": "relating to osteoplasty [adj]\n",
  "OSTEOPLASTIES": "OSTEOPLASTY, plastic surgery on bone [n]\n",
  "OSTEOPLASTY": "plastic surgery on bone [n OSTEOPLASTIES]\n",
  "OSTEOPOROSES": "OSTEOPOROSIS, development of a porous structure in bone due to loss of calcium, resulting in brittleness [n]\n",
  "OSTEOPOROSIS": "development of a porous structure in bone due to loss of calcium, resulting in brittleness [n OSTEOPOROSES]\n",
  "OSTEOPOROTIC": "relating to osteoporosis [adj]\n",
  "OSTEOSARCOMA": "a malignant tumour derived from osteoblasts, composed of bone and sarcoma cells [n OSTEOSARCOMAS or OSTEOSARCOMATA]\n",
  "OSTEOSARCOMAS": "OSTEOSARCOMA, a malignant tumour derived from osteoblasts, composed of bone and sarcoma cells [n]\n",
  "OSTEOSARCOMATA": "OSTEOSARCOMA, a malignant tumour derived from osteoblasts, composed of bone and sarcoma cells [n]\n",
  "OSTEOSES": "OSTEOSIS, the formation of bone [n]\n",
  "OSTEOSIS": "the formation of bone [n OSTEOSISES or OSTEOSES]\n",
  "OSTEOSISES": "OSTEOSIS, the formation of bone [n]\n",
  "OSTEOTOME": "strong nippers or a chisel for dividing bone [n -S]\n",
  "OSTEOTOMES": "OSTEOTOME, strong nippers or a chisel for dividing bone [n]\n",
  "OSTEOTOMIES": "OSTEOTOMY, the dissection or anatomy of bones [n]\n",
  "OSTEOTOMY": "the dissection or anatomy of bones [n OSTEOTOMIES]\n",
  "OSTIA": "OSTIUM, (Latin) the mouth of a river; a mouthlike opening [n]\n",
  "OSTIAL": "relating to an ostium, the mouth of a river or a mouthlike opening [adj]\n",
  "OSTIARIES": "OSTIARY, a doorkeeper at a church [n]\n",
  "OSTIARY": "a doorkeeper at a church [n OSTIARIES]\n",
  "OSTIATE": "having an ostium (a mouthlike opening) [adj]\n",
  "OSTINATI": "OSTINATO, (Italian) a constantly recurring melodic fragment [n]\n",
  "OSTINATO": "(Italian) a constantly recurring melodic fragment [n OSTINATOS or OSTINATI]\n",
  "OSTINATOS": "OSTINATO, (Italian) a constantly recurring melodic fragment [n]\n",
  "OSTIOLAR": "relating to an ostiole, a small opening [adj]\n",
  "OSTIOLATE": "having an opening [adj]\n",
  "OSTIOLE": "a small bodily opening [n -S]\n",
  "OSTIOLES": "OSTIOLE, a small bodily opening [n]\n",
  "OSTIUM": "(Latin) the mouth of a river; a mouthlike opening [n OSTIA]\n",
  "OSTLER": "a horse tender at an inn [n -S]\n",
  "OSTLERESS": "a female ostler [n -ES]\n",
  "OSTLERESSES": "OSTLERESS, a female ostler [n]\n",
  "OSTLERS": "OSTLER, a horse tender at an inn [n]\n",
  "OSTMARK": "(German) a former East German monetary unit [n -S]\n",
  "OSTMARKS": "OSTMARK, (German) a former East German monetary unit [n]\n",
  "OSTOMATE": "one who has had an ostomy, a type of surgical operation [n -S]\n",
  "OSTOMATES": "OSTOMATE, one who has had an ostomy, a type of surgical operation [n]\n",
  "OSTOMIES": "OSTOMY, a type of surgical operation [n]\n",
  "OSTOMY": "a type of surgical operation [n OSTOMIES]\n",
  "OSTOSES": "OSTOSIS, the formation of bone [n]\n",
  "OSTOSIS": "the formation of bone [n OSTOSISES or OSTOSES]\n",
  "OSTOSISES": "OSTOSIS, the formation of bone [n]\n",
  "OSTRACA": "OSTRACON, (Greek) a piece of tile for writing a message upon, also OSTRAKON [n]\n",
  "OSTRACEAN": "of or relating to oysters, also OSTRACEOUS [adj] / a member of the oyster family formerly called Ostracea [n -S]\n",
  "OSTRACEANS": "OSTRACEAN, a member of the oyster family formerly called Ostracea [n]\n",
  "OSTRACEOUS": "of or relating to oysters, also OSTRACEAN [adj]\n",
  "OSTRACISABLE": "worthy of being ostracised, also OSTRACIZABLE [adj]\n",
  "OSTRACISE": "to exclude from a group by common consent, also OSTRACIZE [v OSTRACISED, OSTRACISING, OSTRACISES]\n",
  "OSTRACISED": "OSTRACISE, to exclude from a group by common consent, also OSTRACIZE [v]\n",
  "OSTRACISER": "one who ostracises, also OSTRACIZER [n -S]\n",
  "OSTRACISERS": "OSTRACISER, one who ostracises, also OSTRACIZER [n]\n",
  "OSTRACISES": "OSTRACISE, to exclude from a group by common consent, also OSTRACIZE [v]\n",
  "OSTRACISING": "OSTRACISE, to exclude from a group by common consent, also OSTRACIZE [v]\n",
  "OSTRACISM": "expulsion from society [n -S]\n",
  "OSTRACISMS": "OSTRACISM, expulsion from society [n]\n",
  "OSTRACIZABLE": "worthy of being ostracised, also OSTRACISABLE [adj]\n",
  "OSTRACIZE": "to exclude from a group by common consent, also OSTRACISE [v OSTRACIZED, OSTRACIZING, OSTRACIZES]\n",
  "OSTRACIZED": "OSTRACIZE, to exclude from a group by common consent, also OSTRACISE [v]\n",
  "OSTRACIZER": "one who ostracises, also OSTRACISER [n -S]\n",
  "OSTRACIZERS": "OSTRACIZER, one who ostracises, also OSTRACISER [n]\n",
  "OSTRACIZES": "OSTRACIZE, to exclude from a group by common consent, also OSTRACISE [v]\n",
  "OSTRACIZING": "OSTRACIZE, to exclude from a group by common consent, also OSTRACISE [v]\n",
  "OSTRACOD": "a minute freshwater crustacean with a bivalve carapace, also OSTRACODE [n -S]\n",
  "OSTRACODAN": "relating to a class of minute crustacea with bivalve shells [adj]\n",
  "OSTRACODE": "a minute freshwater crustacean with a bivalve carapace, also OSTRACOD [n -S]\n",
  "OSTRACODERM": "any of the early fossil jawless fishes of the Lower Paleozoic usually having a bony covering of plates or scales [n -S]\n",
  "OSTRACODERMS": "OSTRACODERM, any of the early fossil jawless fishes of the Lower Paleozoic usually having a bony covering of plates or scales [n]\n",
  "OSTRACODES": "OSTRACODE, a minute freshwater crustacean with a bivalve carapace, also OSTRACOD [n]\n",
  "OSTRACODOUS": "like an ostracod [adj]\n",
  "OSTRACODS": "OSTRACOD, a minute freshwater crustacean with a bivalve carapace, also OSTRACODE [n]\n",
  "OSTRACON": "(Greek) a piece of tile for writing a message upon, also OSTRAKON [n OSTRACA]\n",
  "OSTRAKA": "OSTRAKON, (Greek) a piece of tile for writing a message upon, also OSTRACON [n]\n",
  "OSTRAKON": "(Greek) a piece of tile for writing a message upon, also OSTRACON [n OSTRAKA]\n",
  "OSTREACEOUS": "of or relating to oysters [adj]\n",
  "OSTREGER": "a falconer who keeps a goshawk, also ASTRINGER, AUSTRINGER [n -S]\n",
  "OSTREGERS": "OSTREGER, a falconer who keeps a goshawk, also ASTRINGER, AUSTRINGER [n]\n",
  "OSTREICULTURE": "oyster-breeding [n -S]\n",
  "OSTREICULTURES": "OSTREICULTURE, oyster-breeding [n]\n",
  "OSTREICULTURIST": "one who breeds oysters [n]\n",
  "OSTREOPHAGE": "an oyster-eater [n -S]\n",
  "OSTREOPHAGES": "OSTREOPHAGE, an oyster-eater [n]\n",
  "OSTREOPHAGIES": "OSTREOPHAGY, the eating of oysters [n]\n",
  "OSTREOPHAGOUS": "oyster-eating [adj]\n",
  "OSTREOPHAGY": "the eating of oysters [n OSTREOPHAGIES]\n",
  "OSTRICH": "a large, flightless bird, also ESTRICH, ESTRIDGE, OYSTRIGE [n -ES]\n",
  "OSTRICHES": "OSTRICH, a large, flightless bird, also ESTRICH, ESTRIDGE, OYSTRIGE [n]\n",
  "OSTRICHISM": "the habit or policy of refusing to face unpleasant facts [n -S]\n",
  "OSTRICHISMS": "OSTRICHISM, the habit or policy of refusing to face unpleasant facts [n]\n",
  "OSTRICHLIKE": "like an ostrich [adj]\n",
  "OTAKU": "in Japan, a young computer nerd [n -S]\n",
  "OTAKUS": "OTAKU, in Japan, a young computer nerd [n]\n",
  "OTALGIA": "pain in the ear, also OTALGY [n -S]\n",
  "OTALGIAS": "OTALGIA, pain in the ear, also OTALGY [n]\n",
  "OTALGIC": "relating to or curative of otalgy, earache [adj]\n",
  "OTALGIES": "OTALGY, pain in the ear, also OTALGIA [n]\n",
  "OTALGY": "pain in the ear, also OTALGIA [n OTALGIES]\n",
  "OTARID": "of or like an otary, an eared seal [adj]\n",
  "OTARIES": "OTARY, a big-eared seal [n]\n",
  "OTARINE": "relating to the otary, the eared seal [adj]\n",
  "OTARY": "a big-eared seal [n OTARIES]\n",
  "OTHER": "to treat a person as being very different from oneself [v -ED, -ING, -S]\n",
  "OTHERED": "OTHER, to treat a person as being very different from oneself [v]\n",
  "OTHERGATES": "(obsolete) in another manner, also OTHERGUESS [adv]\n",
  "OTHERGUESS": "(obsolete) in another manner, also OTHERGATES [adv]\n",
  "OTHERING": "OTHER, to treat a person as being very different from oneself [v]\n",
  "OTHERNESS": "the state of being other [n -ES]\n",
  "OTHERNESSES": "OTHERNESS, the state of being other [n]\n",
  "OTHERS": "OTHER, to treat a person as being very different from oneself [v]\n",
  "OTHERWHERE": "(archaic) elsewhere [adj]\n",
  "OTHERWHILE": "(archaic) at other times, sometimes, also OTHERWHILES [adv]\n",
  "OTHERWHILES": "(archaic) at other times, sometimes, also OTHERWHILE [adv]\n",
  "OTHERWISE": "differently, alternatively [adv]\n",
  "OTHERWORLD": "a world beyond death or beyond present reality [n -S]\n",
  "OTHERWORLDISH": "of, relating to, or resembling that of a world other than the actual world, also OTHERWORLDLY [adj]\n",
  "OTHERWORLDLIER": "OTHERWORLDLY, of, relating to, or resembling that of a world other than the actual world, also OTHERWORLDISH [adj]\n",
  "OTHERWORLDLIEST": "OTHERWORLDLY, of, relating to, or resembling that of a world other than the actual world, also OTHERWORLDISH [adj]\n",
  "OTHERWORLDLY": "of, relating to, or resembling that of a world other than the actual world, also OTHERWORLDISH [adj OTHERWORLDLIER, OTHERWORLDLIEST]\n",
  "OTHERWORLDS": "OTHERWORLD, a world beyond death or beyond present reality [n]\n",
  "OTIC": "pertaining to the ear [adj]\n",
  "OTIOSE": "futile, idle [adj OTIOSELY]\n",
  "OTIOSELY": "OTIOSE, futile, idle [adv]\n",
  "OTIOSENESS": "the state of being otiose [n -ES]\n",
  "OTIOSENESSES": "OTIOSENESS, the state of being otiose [n]\n",
  "OTIOSITIES": "OTIOSITY, the state of being otiose [n]\n",
  "OTIOSITY": "the state of being otiose [n OTIOSITIES]\n",
  "OTITIC": "relating to otitis, inflammation of the ear [adj]\n",
  "OTITIDES": "OTITIS, inflammation of the ear [n]\n",
  "OTITIS": "inflammation of the ear [n OTITISES or OTITIDES]\n",
  "OTITISES": "OTITIS, inflammation of the ear [n]\n",
  "OTOCYST": "an organ of balance in many invertebrates [n -S]\n",
  "OTOCYSTIC": "relating to an otocyst, an auditory cyst or vesicle [adj]\n",
  "OTOCYSTS": "OTOCYST, an organ of balance in many invertebrates [n]\n",
  "OTOLARYNGOLOGY": "the branch of medicine that deals with the ear, nose, and throat [n]\n",
  "OTOLITH": "a calcium concretion in the inside of a vertebrate's ear to aid in equilibrium [n -S]\n",
  "OTOLITHIC": "of or like an otolith, a calcium concretion in inside of vertebrate's ear to aid in equilibrium [adj]\n",
  "OTOLITHS": "OTOLITH, a calcium concretion in the inside of a vertebrate's ear to aid in equilibrium [n]\n",
  "OTOLOGIC": "relating to otology, the science of the ear, also OTOLOGICAL [adj]\n",
  "OTOLOGICAL": "relating to otology, the study of the ear, also OTOLOGIC [adj]\n",
  "OTOLOGIES": "OTOLOGY, the science of the ear [n]\n",
  "OTOLOGIST": "a practitioner of otology, the study of the ear [n -S]\n",
  "OTOLOGISTS": "OTOLOGIST, a practitioner of otology, the study of the ear [n]\n",
  "OTOLOGY": "the science of the ear [n OTOLOGIES]\n",
  "OTOPLASTIES": "OTOPLASTY, cosmetic surgery on the ears [n]\n",
  "OTOPLASTY": "cosmetic surgery on the ears [n OTOPLASTIES]\n",
  "OTORRHOEA": "a discharge from the ear [n -S]\n",
  "OTORRHOEAS": "OTORRHOEA, a discharge from the ear [n]\n",
  "OTOSCLEROSES": "OTOSCLEROSIS, growth of new bone in inner ear, leading to deafness [n]\n",
  "OTOSCLEROSIS": "growth of new bone in inner ear, leading to deafness [n OTOSCLEROSES]\n",
  "OTOSCOPE": "an instrument for examining the ear [n -S]\n",
  "OTOSCOPES": "OTOSCOPE, an instrument for examining the ear [n]\n",
  "OTOSCOPIC": "relating to otoscopy, the examination of the ear [adj]\n",
  "OTOSCOPIES": "OTOSCOPY, the examination of the ear by otoscope [n]\n",
  "OTOSCOPY": "the examination of the ear by otoscope [n OTOSCOPIES]\n",
  "OTOTOXIC": "adversely affecting hearing or balance [adj]\n",
  "OTOTOXICITIES": "OTOTOXICITY, the state of being ototoxic [n]\n",
  "OTOTOXICITY": "the state of being ototoxic [n OTOTOXICITIES]\n",
  "OTTAR": "(Persian) a fragrant essential oil made from the damask rose, also ATTAR, OTTO [n -S]\n",
  "OTTARS": "OTTAR, (Persian) a fragrant essential oil made from the damask rose, also ATTAR, OTTO [n]\n",
  "OTTAVA": "(Italian) an octave higher than indicated [n -S]\n",
  "OTTAVAS": "OTTAVA, (Italian) an octave higher than indicated [n]\n",
  "OTTAVINO": "(Italian) the piccolo [n -S]\n",
  "OTTAVINOS": "OTTAVINO, (Italian) the piccolo [n]\n",
  "OTTER": "to fish with a board of baited lines [v -ED, -ING, -S]\n",
  "OTTERED": "OTTER, to fish with a board of baited lines [v]\n",
  "OTTERHOUND": "a hound used to hunt otters [n -S]\n",
  "OTTERHOUNDS": "OTTERHOUND, a hound used to hunt otters [n]\n",
  "OTTERING": "OTTER, to fish with a board of baited lines [v]\n",
  "OTTERS": "OTTER, to fish with a board of baited lines [v]\n",
  "OTTO": "(Persian) a fragrant essential oil made from the damask rose, also ATTAR, OTTAR [n -S]\n",
  "OTTOMAN": "(Turkish) a low, stuffed seat [n -S]\n",
  "OTTOMANS": "OTTOMAN, (Turkish) a low, stuffed seat [n]\n",
  "OTTOS": "OTTO, (Persian) a fragrant essential oil made from the damask rose, also ATTAR, OTTAR [n]\n",
  "OTTRELITE": "a mineral like chlorite but harder [n -S]\n",
  "OTTRELITES": "OTTRELITE, a mineral like chlorite but harder [n]\n",
  "OU": "(South African) a man, a bloke [n OUS or OUENS]\n",
  "OUABAIN": "(Somali) a poisonous alkaloid, also WABAIN [n -S]\n",
  "OUABAINS": "OUABAIN, (Somali) a poisonous alkaloid, also WABAIN [n]\n",
  "OUAKARI": "(Tupi) a short-tailed, longhaired monkey, also UAKARI [n -S]\n",
  "OUAKARIS": "OUAKARI, (Tupi) a short-tailed, longhaired monkey, also UAKARI [n]\n",
  "OUANANICHE": "a landlocked variety of the Atlantic salmon, found in lakes in SE Canada [n -S]\n",
  "OUANANICHES": "OUANANICHE, a landlocked variety of the Atlantic salmon, found in lakes in SE Canada [n]\n",
  "OUBAAS": "(South African) someone senior in years or rank [n -ES]\n",
  "OUBAASES": "OUBAAS, (South African) someone senior in years or rank [n]\n",
  "OUBIT": "a hairy caterpillar, esp. of the tiger moth, also OOBIT, WOOBUT, WOUBIT [n -S]\n",
  "OUBITS": "OUBIT, a hairy caterpillar, esp. of the tiger moth, also OOBIT, WOOBUT, WOUBIT [n]\n",
  "OUBLIETTE": "(French) a dungeon with an opening only at the top [n -S]\n",
  "OUBLIETTES": "OUBLIETTE, (French) a dungeon with an opening only at the top [n]\n",
  "OUCH": "a socket in which a precious stone is set, also OWCHE [n -ES] / to set a precious stone in a socket [v -ED, -ING, -ES]\n",
  "OUCHED": "OUCH, to set a precious stone in a socket [v]\n",
  "OUCHES": "OUCH, to set a precious stone in a socket [v]\n",
  "OUCHING": "OUCH, to set a precious stone in a socket [v]\n",
  "OUCHT": "(Scots) anything, also AUGHT, OWT [n -S]\n",
  "OUCHTS": "OUCHT, (Scots) anything, also AUGHT, OWT [n]\n",
  "OUD": "an African stringed instrument [n -S]\n",
  "OUDS": "OUD, an African stringed instrument [n]\n",
  "OUENS": "OU, (South African) a man, a bloke [n]\n",
  "OUGHLIED": "OUGHLY, to make ugly, also OUGLIE [v]\n",
  "OUGHLIES": "OUGHLY, to make ugly, also OUGLIE [v]\n",
  "OUGHLY": "to make ugly, also OUGLIE [v OUGHLIED, OUGHLYING, OUGHLIES]\n",
  "OUGHLYING": "OUGHLY, to make ugly, also OUGLIE [v]\n",
  "OUGHT": "to owe [v -ED, -ING, -S]\n",
  "OUGHTED": "OUGHT, to owe [v]\n",
  "OUGHTING": "OUGHT, to owe [v]\n",
  "OUGHTLINGS": "(Scots) at all [adv]\n",
  "OUGHTNESS": "(archaic) rightness [n -ES]\n",
  "OUGHTNESSES": "OUGHTNESS, (archaic) rightness [n]\n",
  "OUGHTS": "OUGHT, to owe [v]\n",
  "OUGIYA": "a monetary unit of Mauretania, also OUGUIYA [n -S]\n",
  "OUGIYAS": "OUGIYA, a monetary unit of Mauretania, also OUGUIYA [n]\n",
  "OUGLIE": "to make ugly, also OUGHLY [v OUGLIED, OUGLIEING, OUGLIES]\n",
  "OUGLIED": "OUGLIE, to make ugly, also OUGHLY [v]\n",
  "OUGLIEING": "OUGLIE, to make ugly, also OUGHLY [v]\n",
  "OUGLIES": "OUGLIE, to make ugly, also OUGHLY [v]\n",
  "OUGUIYA": "(Arabic) a monetary unit of Mauritania, also OUGIYA [n -S]\n",
  "OUGUIYAS": "OUGUIYA, (Arabic) a monetary unit of Mauritania, also OUGIYA [n]\n",
  "OUIJA": "(tradename) a board with signs and letters on it, used with a planchette to receive alleged messages from the dead [n -S]\n",
  "OUIJAS": "OUIJA, (tradename) a board with signs and letters on it, used with a planchette to receive alleged messages from the dead [n]\n",
  "OUISTITI": "(French) a marmoset, also WISTITI [n -S]\n",
  "OUISTITIS": "OUISTITI, (French) a marmoset, also WISTITI [n]\n",
  "OUK": "(Scots) a week, also OULK [n -S]\n",
  "OUKS": "OUK, (Scots) a week, also OULK [n]\n",
  "OULACHON": "(Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULAKAN, ULICON, ULIKON [n -S]\n",
  "OULACHONS": "OULACHON, (Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULAKAN, ULICON, ULIKON [n]\n",
  "OULAKAN": "(Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, ULICON, ULIKON [n -S]\n",
  "OULAKANS": "OULAKAN, (Native American) the North Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, ULICON, ULIKON [n]\n",
  "OULD": "(Irish) old [adj OULDER, OULDEST]\n",
  "OULDER": "OULD, (Irish) old [adj]\n",
  "OULDEST": "OULD, (Irish) old [adj]\n",
  "OULK": "(Scots) a week, also OUK [n -S]\n",
  "OULKS": "OULK, (Scots) a week, also OUK [n]\n",
  "OULONG": "(Chinese) a kind of black tea, also OOLONG [n -S]\n",
  "OULONGS": "OULONG, (Chinese) a kind of black tea, also OOLONG [n]\n",
  "OUMA": "(South African) a grandmother, also OMA [n -S]\n",
  "OUMAS": "OUMA, (South African) a grandmother, also OMA [n]\n",
  "OUNCE": "a measurement of weight, 1/16th of a pound, also UNCE [n -S]\n",
  "OUNCES": "OUNCE, a measurement of weight, 1/16th of a pound, also UNCE [n]\n",
  "OUNDIER": "OUNDY, (obsolete) wavy, also UNDE, UNDEE, UNDY [adj]\n",
  "OUNDIEST": "OUNDY, (obsolete) wavy, also UNDE, UNDEE, UNDY [adj]\n",
  "OUNDY": "(obsolete) wavy, also UNDE, UNDEE, UNDY [adj OUNDIER, OUNDIEST]\n",
  "OUP": "to bind with thread, also OOP [v -ED, -ING, -S]\n",
  "OUPA": "(South African) a grandfather, also OPA [n -S]\n",
  "OUPAS": "OUPA, (South African) a grandfather, also OPA [n]\n",
  "OUPED": "OUP, to bind with thread, also OOP [v]\n",
  "OUPH": "(Shakespeare) an oaf, a changeling, also OUPHE [n -S]\n",
  "OUPHE": "(Shakespeare) an oaf, a changeling, also OUPH [n -S]\n",
  "OUPHES": "OUPHE, (Shakespeare) an oaf, a changeling, also OUPH [n]\n",
  "OUPHS": "OUPH, (Shakespeare) an oaf, a changeling, also OUPHE [n]\n",
  "OUPING": "OUP, to bind with thread, also OOP [v]\n",
  "OUPS": "OUP, to bind with thread, also OOP [v]\n",
  "OUR": "belonging to us, also OOR [adj]\n",
  "OURALI": "(Caribbean) the plant yielding curare, also OORALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n -S]\n",
  "OURALIS": "OURALI, (Caribbean) the plant yielding curare, also OORALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n]\n",
  "OURANG": "(Malay) a reddish-brown, tree-dwelling anthropoid ape, found only in the forests of Sumatra and Borneo, also ORANG, ORANGUTAN [n -S]\n",
  "OURANGS": "OURANG, (Malay) a reddish-brown, tree-dwelling anthropoid ape, found only in the forests of Sumatra and Borneo, also ORANG, ORANGUTAN [n]\n",
  "OURARI": "(Caribbean) the plant yielding curare, also OORALI, OURALI, URALI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n -S]\n",
  "OURARIS": "OURARI, (Caribbean) the plant yielding curare, also OORALI, OURALI, URALI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n]\n",
  "OUREBI": "(South African) an African antelope, also ORIBI [n -S]\n",
  "OUREBIS": "OUREBI, (South African) an African antelope, also ORIBI [n]\n",
  "OURIE": "(Scots) dingy, also OORIE, OWRIE [adj OURIER, OURIEST]\n",
  "OURIER": "OURIE, (Scots) dingy, also OORIE, OWRIE [adj]\n",
  "OURIEST": "OURIE, (Scots) dingy, also OORIE, OWRIE [adj]\n",
  "OURN": "belonging to us, also OURS [pron]\n",
  "OUROBOROS": "(Greek) a snake eating its own tail, symbolizing totality or completion, also UROBOROS [n -ES]\n",
  "OUROBOROSES": "OUROBOROS, (Greek) a snake eating its own tail, symbolizing totality or completion, also UROBOROS [n]\n",
  "OUROLOGIES": "OUROLOGY, the study of urine or the urinary tract, also URINOLOGY, UROLOGY [n]\n",
  "OUROLOGY": "the study of urine or the urinary tract, also URINOLOGY, UROLOGY [n OUROLOGIES]\n",
  "OUROSCOPIES": "OUROSCOPY, the diagnosis of diseases by inspection of urine, also UROSCOPY [n]\n",
  "OUROSCOPY": "the diagnosis of diseases by inspection of urine, also UROSCOPY [n OUROSCOPIES]\n",
  "OURS": "belonging to us, also OURN [pron]\n",
  "OURSELF": "myself, used in formal or regal contexts [pron OURSELVES]\n",
  "OURSELVES": "OURSELF, myself, used in formal or regal contexts [pron]\n",
  "OUS": "OU, (South African) a man, a bloke [n]\n",
  "OUSEL": "a European bird of the thrush family, also OUZEL, WOOSEL, WOOSELL [n -S]\n",
  "OUSELS": "OUSEL, a European bird of the thrush family, also OUZEL, WOOSEL, WOOSELL [n]\n",
  "OUST": "to expel or remove from a position or place [v -ED, -ING, -S]\n",
  "OUSTED": "OUST, to expel or remove from a position or place [v]\n",
  "OUSTER": "ejection or dispossession [n -S]\n",
  "OUSTERS": "OUSTER, ejection or dispossession [n]\n",
  "OUSTING": "OUST, to expel or remove from a position or place [v]\n",
  "OUSTITI": "(French) a lock-opening tool [n -S]\n",
  "OUSTITIS": "OUSTITI, (French) a lock-opening tool [n]\n",
  "OUSTS": "OUST, to expel or remove from a position or place [v]\n",
  "OUT": "to reveal [v -ED, -ING, -S]\n",
  "OUTA": "an informal contraction of out of, also OUTTA [prep]\n",
  "OUTACHIEVE": "to surpass in achievement [v OUTACHIEVED, OUTACHIEVING, OUTACHIEVES]\n",
  "OUTACHIEVED": "OUTACHIEVE, to surpass in achievement [v]\n",
  "OUTACHIEVES": "OUTACHIEVE, to surpass in achievement [v]\n",
  "OUTACHIEVING": "OUTACHIEVE, to surpass in achievement [v]\n",
  "OUTACT": "to surpass in acting [v -ED, -ING, -S]\n",
  "OUTACTED": "OUTACT, to surpass in acting [v]\n",
  "OUTACTING": "OUTACT, to surpass in acting [v]\n",
  "OUTACTS": "OUTACT, to surpass in acting [v]\n",
  "OUTADD": "to surpass in adding [v -ED, -ING, -S]\n",
  "OUTADDED": "OUTADD, to surpass in adding [v]\n",
  "OUTADDING": "OUTADD, to surpass in adding [v]\n",
  "OUTADDS": "OUTADD, to surpass in adding [v]\n",
  "OUTAGE": "a failure in use [n -S]\n",
  "OUTAGES": "OUTAGE, a failure in use [n]\n",
  "OUTARGUE": "to get the better of by arguing [v OUTARGUED, OUTARGUING, OUTARGUES]\n",
  "OUTARGUED": "OUTARGUE, to get the better of by arguing [v]\n",
  "OUTARGUES": "OUTARGUE, to get the better of by arguing [v]\n",
  "OUTARGUING": "OUTARGUE, to get the better of by arguing [v]\n",
  "OUTASIGHT": "amazing, excellent, also OUTASITE [adj]\n",
  "OUTASITE": "amazing, excellent, also OUTASIGHT [adj]\n",
  "OUTASK": "to surpass in asking [v -ED, -ING, -S]\n",
  "OUTASKED": "OUTASK, to surpass in asking [v]\n",
  "OUTASKING": "OUTASK, to surpass in asking [v]\n",
  "OUTASKS": "OUTASK, to surpass in asking [v]\n",
  "OUTATE": "OUTEAT, to surpass in eating [v]\n",
  "OUTBACK": "isolated rural country [n -S]\n",
  "OUTBACKER": "one who lives in the outback [n -S]\n",
  "OUTBACKERS": "OUTBACKER, one who lives in the outback [n]\n",
  "OUTBACKS": "OUTBACK, isolated rural country [n]\n",
  "OUTBAKE": "to surpass in baking [v OUTBAKED, OUTBAKING, OUTBAKES]\n",
  "OUTBAKED": "OUTBAKE, to surpass in baking [v]\n",
  "OUTBAKES": "OUTBAKE, to surpass in baking [v]\n",
  "OUTBAKING": "OUTBAKE, to surpass in baking [v]\n",
  "OUTBALANCE": "to outweigh; to exceed in weight or effect [v OUTBALANCED, OUTBALANCING, OUTBALANCES]\n",
  "OUTBALANCED": "OUTBALANCE, to outweigh; to exceed in weight or effect [v]\n",
  "OUTBALANCES": "OUTBALANCE, to outweigh; to exceed in weight or effect [v]\n",
  "OUTBALANCING": "OUTBALANCE, to outweigh; to exceed in weight or effect [v]\n",
  "OUTBAR": "to form a barrier [v OUTBARRED, OUTBARRING, OUTBARS]\n",
  "OUTBARGAIN": "to surpass in bargaining [v -ED, -ING, -S]\n",
  "OUTBARGAINED": "OUTBARGAIN, to surpass in bargaining [v]\n",
  "OUTBARGAINING": "OUTBARGAIN, to surpass in bargaining [v]\n",
  "OUTBARGAINS": "OUTBARGAIN, to surpass in bargaining [v]\n",
  "OUTBARK": "to surpass in barking [v -ED, -ING, -S]\n",
  "OUTBARKED": "OUTBARK, to surpass in barking [v]\n",
  "OUTBARKING": "OUTBARK, to surpass in barking [v]\n",
  "OUTBARKS": "OUTBARK, to surpass in barking [v]\n",
  "OUTBARRED": "OUTBAR, to form a barrier [v]\n",
  "OUTBARRING": "OUTBAR, to form a barrier [v]\n",
  "OUTBARS": "OUTBAR, to form a barrier [v]\n",
  "OUTBAWL": "to surpass in bawling [v -ED, -ING, -S]\n",
  "OUTBAWLED": "OUTBAWL, to surpass in bawling [v]\n",
  "OUTBAWLING": "OUTBAWL, to surpass in bawling [v]\n",
  "OUTBAWLS": "OUTBAWL, to surpass in bawling [v]\n",
  "OUTBEAM": "to surpass in beaming [v -ED, -ING, -S]\n",
  "OUTBEAMED": "OUTBEAM, to surpass in beaming [v]\n",
  "OUTBEAMING": "OUTBEAM, to surpass in beaming [v]\n",
  "OUTBEAMS": "OUTBEAM, to surpass in beaming [v]\n",
  "OUTBEG": "to surpass in begging [v OUTBEGGED, OUTBEGGING, OUTBEGS]\n",
  "OUTBEGGED": "OUTBEG, to surpass in begging [v]\n",
  "OUTBEGGING": "OUTBEG, to surpass in begging [v]\n",
  "OUTBEGS": "OUTBEG, to surpass in begging [v]\n",
  "OUTBID": "to bid higher than [v OUTBID, OUTBIDDEN, OUTBIDDING, OUTBIDS]\n",
  "OUTBIDDEN": "OUTBID, to bid higher than [v]\n",
  "OUTBIDDER": "one who outbids [n -S]\n",
  "OUTBIDDERS": "OUTBIDDER, one who outbids [n]\n",
  "OUTBIDDING": "OUTBID, to bid higher than [v]\n",
  "OUTBIDS": "OUTBID, to bid higher than [v]\n",
  "OUTBITCH": "to surpass in bitching, complaining [v -ED, -ING, -ES]\n",
  "OUTBITCHED": "OUTBITCH, to surpass in bitching, complaining [v]\n",
  "OUTBITCHES": "OUTBITCH, to surpass in bitching, complaining [v]\n",
  "OUTBITCHING": "OUTBITCH, to surpass in bitching, complaining [v]\n",
  "OUTBLAZE": "to surpass in brilliance of light [v OUTBLAZED, OUTBLAZING, OUTBLAZES]\n",
  "OUTBLAZED": "OUTBLAZE, to surpass in brilliance of light [v]\n",
  "OUTBLAZES": "OUTBLAZE, to surpass in brilliance of light [v]\n",
  "OUTBLAZING": "OUTBLAZE, to surpass in brilliance of light [v]\n",
  "OUTBLEAT": "to surpass in bleating [v -ED, -ING, -S]\n",
  "OUTBLEATED": "OUTBLEAT, to surpass in bleating [v]\n",
  "OUTBLEATING": "OUTBLEAT, to surpass in bleating [v]\n",
  "OUTBLEATS": "OUTBLEAT, to surpass in bleating [v]\n",
  "OUTBLESS": "to surpass in blessing [v -ED, -ING, -ES]\n",
  "OUTBLESSED": "OUTBLESS, to surpass in blessing [v]\n",
  "OUTBLESSES": "OUTBLESS, to surpass in blessing [v]\n",
  "OUTBLESSING": "OUTBLESS, to surpass in blessing [v]\n",
  "OUTBLOOM": "to surpass in blooming [v -ED, -ING, -S]\n",
  "OUTBLOOMED": "OUTBLOOM, to surpass in blooming [v]\n",
  "OUTBLOOMING": "OUTBLOOM, to surpass in blooming [v]\n",
  "OUTBLOOMS": "OUTBLOOM, to surpass in blooming [v]\n",
  "OUTBLUFF": "to surpass in bluffing [v -ED, -ING, -S]\n",
  "OUTBLUFFED": "OUTBLUFF, to surpass in bluffing [v]\n",
  "OUTBLUFFING": "OUTBLUFF, to surpass in bluffing [v]\n",
  "OUTBLUFFS": "OUTBLUFF, to surpass in bluffing [v]\n",
  "OUTBLUSH": "to surpass in blushing [v -ED, -ING, -ES]\n",
  "OUTBLUSHED": "OUTBLUSH, to surpass in blushing [v]\n",
  "OUTBLUSHES": "OUTBLUSH, to surpass in blushing [v]\n",
  "OUTBLUSHING": "OUTBLUSH, to surpass in blushing [v]\n",
  "OUTBLUSTER": "to surpass in bluster [v -ED, -ING, -S]\n",
  "OUTBLUSTERED": "OUTBLUSTER, to surpass in bluster [v]\n",
  "OUTBLUSTERING": "OUTBLUSTER, to surpass in bluster [v]\n",
  "OUTBLUSTERS": "OUTBLUSTER, to surpass in bluster [v]\n",
  "OUTBOARD": "a type of motor designed to be attached to the outside of a boat etc. [n -S]\n",
  "OUTBOARDS": "OUTBOARD, a type of motor designed to be attached to the outside of a boat etc. [n]\n",
  "OUTBOAST": "to surpass in boasting [v -ED, -ING, -S]\n",
  "OUTBOASTED": "OUTBOAST, to surpass in boasting [v]\n",
  "OUTBOASTING": "OUTBOAST, to surpass in boasting [v]\n",
  "OUTBOASTS": "OUTBOAST, to surpass in boasting [v]\n",
  "OUTBOUGHT": "OUTBUY, to surpass in buying [v]\n",
  "OUTBOUND": "outward bound [adj]\n",
  "OUTBOUNDS": "(Spenser) boundaries [n]\n",
  "OUTBOX": "to surpass in boxing [v -ED, -ING, -ES]\n",
  "OUTBOXED": "OUTBOX, to surpass in boxing [v]\n",
  "OUTBOXES": "OUTBOX, to surpass in boxing [v]\n",
  "OUTBOXING": "OUTBOX, to surpass in boxing [v]\n",
  "OUTBRAG": "to surpass in bragging [v OUTBRAGGED, OUTBRAGGING, OUTBRAGS]\n",
  "OUTBRAGGED": "OUTBRAG, to surpass in bragging [v]\n",
  "OUTBRAGGING": "OUTBRAG, to surpass in bragging [v]\n",
  "OUTBRAGS": "OUTBRAG, to surpass in bragging [v]\n",
  "OUTBRAVE": "to surpass in courage [v OUTBRAVED, OUTBRAVING, OUTBRAVES]\n",
  "OUTBRAVED": "OUTBRAVE, to surpass in courage [v]\n",
  "OUTBRAVES": "OUTBRAVE, to surpass in courage [v]\n",
  "OUTBRAVING": "OUTBRAVE, to surpass in courage [v]\n",
  "OUTBRAWL": "to surpass in brawling [v -ED, -ING, -S]\n",
  "OUTBRAWLED": "OUTBRAWL, to surpass in brawling [v]\n",
  "OUTBRAWLING": "OUTBRAWL, to surpass in brawling [v]\n",
  "OUTBRAWLS": "OUTBRAWL, to surpass in brawling [v]\n",
  "OUTBRAZEN": "to be more brazen than [v -ED, -ING, -S]\n",
  "OUTBRAZENED": "OUTBRAZEN, to be more brazen than [v]\n",
  "OUTBRAZENING": "OUTBRAZEN, to be more brazen than [v]\n",
  "OUTBRAZENS": "OUTBRAZEN, to be more brazen than [v]\n",
  "OUTBREAK": "to burst forth [v OUTBROKE, OUTBROKEN, OUTBREAKING, OUTBREAKS]\n",
  "OUTBREAKING": "OUTBREAK, to burst forth [v]\n",
  "OUTBREAKS": "OUTBREAK, to burst forth [v]\n",
  "OUTBREATHE": "to breathe forth [v OUTBREATHED, OUTBREATHING, OUTBREATHES]\n",
  "OUTBREATHED": "OUTBREATHE, to breathe forth [v]\n",
  "OUTBREATHES": "OUTBREATHE, to breathe forth [v]\n",
  "OUTBREATHING": "OUTBREATHE, to breathe forth [v]\n",
  "OUTBRED": "OUTBREED, to interbreed relatively unrelated stocks [v]\n",
  "OUTBREED": "to interbreed relatively unrelated stocks [v OUTBRED, OUTBREEDING, OUTBREEDS]\n",
  "OUTBREEDING": "breeding from parents not closely related [n -S]\n",
  "OUTBREEDINGS": "OUTBREEDING, breeding from parents not closely related [n]\n",
  "OUTBREEDS": "OUTBREED, to interbreed relatively unrelated stocks [v]\n",
  "OUTBRIBE": "to surpass in bribing [v OUTBRIBED, OUTBRIBING, OUTBRIBES]\n",
  "OUTBRIBED": "OUTBRIBE, to surpass in bribing [v]\n",
  "OUTBRIBES": "OUTBRIBE, to surpass in bribing [v]\n",
  "OUTBRIBING": "OUTBRIBE, to surpass in bribing [v]\n",
  "OUTBROKE": "OUTBREAK, to burst forth [v]\n",
  "OUTBROKEN": "OUTBREAK, to burst forth [v]\n",
  "OUTBUILD": "to surpass in building [v OUTBUILT, OUTBUILDING, OUTBUILDS]\n",
  "OUTBUILDING": "a building such as a barn, stable, etc. separate from, but used in connection with, a dwelling-house or a main building [n -S]\n",
  "OUTBUILDINGS": "OUTBUILDING, a building such as a barn, stable, etc. separate from, but used in connection with, a dwelling-house or a main building [n]\n",
  "OUTBUILDS": "OUTBUILD, to surpass in building [v]\n",
  "OUTBUILT": "OUTBUILD, to surpass in building [v]\n",
  "OUTBULGE": "to bulge outwards [v OUTBULGED, OUTBULGING, OUTBULGES]\n",
  "OUTBULGED": "OUTBULGE, to bulge outwards [v]\n",
  "OUTBULGES": "OUTBULGE, to bulge outwards [v]\n",
  "OUTBULGING": "OUTBULGE, to bulge outwards [v]\n",
  "OUTBULK": "to surpass in bulking [v -ED, -ING, -S]\n",
  "OUTBULKED": "OUTBULK, to surpass in bulking [v]\n",
  "OUTBULKING": "OUTBULK, to surpass in bulking [v]\n",
  "OUTBULKS": "OUTBULK, to surpass in bulking [v]\n",
  "OUTBULLIED": "OUTBULLY, to surpass in bullying [v]\n",
  "OUTBULLIES": "OUTBULLY, to surpass in bullying [v]\n",
  "OUTBULLY": "to surpass in bullying [v OUTBULLIED, OUTBULLYING, OUTBULLIES]\n",
  "OUTBULLYING": "OUTBULLY, to surpass in bullying [v]\n",
  "OUTBURN": "to burn longer than [v OUTBURNED, OUTBURNT, OUTBURNING, OUTBURNS]\n",
  "OUTBURNED": "OUTBURN, to burn longer than [v]\n",
  "OUTBURNING": "OUTBURN, to burn longer than [v]\n",
  "OUTBURNS": "OUTBURN, to burn longer than [v]\n",
  "OUTBURNT": "OUTBURN, to burn longer than [v]\n",
  "OUTBURST": "to burst out [v OUTBURST, OUTBURSTING, OUTBURSTS]\n",
  "OUTBURSTING": "OUTBURST, to burst out [v]\n",
  "OUTBURSTS": "OUTBURST, to burst out [v]\n",
  "OUTBUY": "to surpass in buying [v OUTBOUGHT, OUTBUYING, OUTBUYS]\n",
  "OUTBUYING": "OUTBUY, to surpass in buying [v]\n",
  "OUTBUYS": "OUTBUY, to surpass in buying [v]\n",
  "OUTBY": "(Scots) out of doors; a little way off, also OUTBYE [adv]\n",
  "OUTBYE": "(Scots) out of doors; a little way off, also OUTBY [adv]\n",
  "OUTCALL": "to bid higher than in a card game [v -ED, -ING, -S]\n",
  "OUTCALLED": "OUTCALL, to bid higher than in a card game [v]\n",
  "OUTCALLING": "OUTCALL, to bid higher than in a card game [v]\n",
  "OUTCALLS": "OUTCALL, to bid higher than in a card game [v]\n",
  "OUTCAPER": "to surpass in capering [v -ED, -ING, -S]\n",
  "OUTCAPERED": "OUTCAPER, to surpass in capering [v]\n",
  "OUTCAPERING": "OUTCAPER, to surpass in capering [v]\n",
  "OUTCAPERS": "OUTCAPER, to surpass in capering [v]\n",
  "OUTCAST": "a person who is rejected or excluded from a social group [n -S]\n",
  "OUTCASTE": "to cause someone to lose his caste [v OUTCASTED, OUTCASTING or OUTCASTEING, OUTCASTES]\n",
  "OUTCASTED": "OUTCASTE, to cause someone to lose his caste [v]\n",
  "OUTCASTEING": "OUTCASTE, to cause someone to lose his caste [v]\n",
  "OUTCASTES": "OUTCASTE, to cause someone to lose his caste [v]\n",
  "OUTCASTING": "OUTCASTE, to cause someone to lose his caste [v]\n",
  "OUTCASTS": "OUTCAST, a person who is rejected or excluded from a social group [n]\n",
  "OUTCATCH": "to surpass in catching [v OUTCAUGHT, OUTCATCHING, OUTCATCHES]\n",
  "OUTCATCHES": "OUTCATCH, to surpass in catching [v]\n",
  "OUTCATCHING": "OUTCATCH, to surpass in catching [v]\n",
  "OUTCAUGHT": "OUTCATCH, to surpass in catching [v]\n",
  "OUTCAVIL": "to surpass in caviling [v OUTCAVILED or OUTCAVILLED, OUTCAVILING or OUTCAVILLING, OUTCAVILS]\n",
  "OUTCAVILED": "OUTCAVIL, to surpass in caviling [v]\n",
  "OUTCAVILING": "OUTCAVIL, to surpass in caviling [v]\n",
  "OUTCAVILLED": "OUTCAVIL, to surpass in caviling [v]\n",
  "OUTCAVILLING": "OUTCAVIL, to surpass in caviling [v]\n",
  "OUTCAVILS": "OUTCAVIL, to surpass in caviling [v]\n",
  "OUTCHARGE": "to surpass in charging [v OUTCHARGED, OUTCHARGING, OUTCHARGES]\n",
  "OUTCHARGED": "OUTCHARGE, to surpass in charging [v]\n",
  "OUTCHARGES": "OUTCHARGE, to surpass in charging [v]\n",
  "OUTCHARGING": "OUTCHARGE, to surpass in charging [v]\n",
  "OUTCHARM": "to surpass in charming [v -ED, -ING, -S]\n",
  "OUTCHARMED": "OUTCHARM, to surpass in charming [v]\n",
  "OUTCHARMING": "OUTCHARM, to surpass in charming [v]\n",
  "OUTCHARMS": "OUTCHARM, to surpass in charming [v]\n",
  "OUTCHEAT": "to exceed in cheating [v -ED, -ING, -S]\n",
  "OUTCHEATED": "OUTCHEAT, to exceed in cheating [v]\n",
  "OUTCHEATING": "OUTCHEAT, to exceed in cheating [v]\n",
  "OUTCHEATS": "OUTCHEAT, to exceed in cheating [v]\n",
  "OUTCHID": "OUTCHIDE, to surpass in chiding [v]\n",
  "OUTCHIDDEN": "OUTCHIDE, to surpass in chiding [v]\n",
  "OUTCHIDE": "to surpass in chiding [v OUTCHIDED, OUTCHID, OUTCHIDDEN, OUTCHIDING, OUTCHIDES]\n",
  "OUTCHIDED": "OUTCHIDE, to surpass in chiding [v]\n",
  "OUTCHIDES": "OUTCHIDE, to surpass in chiding [v]\n",
  "OUTCHIDING": "OUTCHIDE, to surpass in chiding [v]\n",
  "OUTCITIES": "OUTCITY, a city on the outskirts of a larger city [n]\n",
  "OUTCITY": "a city on the outskirts of a larger city [n OUTCITIES]\n",
  "OUTCLASS": "to be markedly better than [v -ED, -ING, -ES]\n",
  "OUTCLASSED": "OUTCLASS, to be markedly better than [v]\n",
  "OUTCLASSES": "OUTCLASS, to be markedly better than [v]\n",
  "OUTCLASSING": "OUTCLASS, to be markedly better than [v]\n",
  "OUTCLIMB": "to surpass in climbing [v OUTCLIMBED or (archaic) OUTCLOMB, OUTCLIMBING, OUTCLIMBS]\n",
  "OUTCLIMBED": "OUTCLIMB, to surpass in climbing [v]\n",
  "OUTCLIMBING": "OUTCLIMB, to surpass in climbing [v]\n",
  "OUTCLIMBS": "OUTCLIMB, to surpass in climbing [v]\n",
  "OUTCLOMB": "OUTCLIMB, to surpass in climbing [v]\n",
  "OUTCOACH": "to surpass in coaching [v -ED, -ING, -ES]\n",
  "OUTCOACHED": "OUTCOACH, to surpass in coaching [v]\n",
  "OUTCOACHES": "OUTCOACH, to surpass in coaching [v]\n",
  "OUTCOACHING": "OUTCOACH, to surpass in coaching [v]\n",
  "OUTCOME": "a result [n -S]\n",
  "OUTCOMES": "OUTCOME, a result [n]\n",
  "OUTCOMPETE": "to surpass in competing [v OUTCOMPETED, OUTCOMPETING, OUTCOMPETES]\n",
  "OUTCOMPETED": "OUTCOMPETE, to surpass in competing [v]\n",
  "OUTCOMPETES": "OUTCOMPETE, to surpass in competing [v]\n",
  "OUTCOMPETING": "OUTCOMPETE, to surpass in competing [v]\n",
  "OUTCOOK": "to surpass in cooking [v -ED, -ING, -S]\n",
  "OUTCOOKED": "OUTCOOK, to surpass in cooking [v]\n",
  "OUTCOOKING": "OUTCOOK, to surpass in cooking [v]\n",
  "OUTCOOKS": "OUTCOOK, to surpass in cooking [v]\n",
  "OUTCOUNT": "to surpass in counting [v -ED, -ING, -S]\n",
  "OUTCOUNTED": "OUTCOUNT, to surpass in counting [v]\n",
  "OUTCOUNTING": "OUTCOUNT, to surpass in counting [v]\n",
  "OUTCOUNTS": "OUTCOUNT, to surpass in counting [v]\n",
  "OUTCRAFTIED": "OUTCRAFTY, (Shakespeare) to exceed in cunning [v]\n",
  "OUTCRAFTIES": "OUTCRAFTY, (Shakespeare) to exceed in cunning [v]\n",
  "OUTCRAFTY": "(Shakespeare) to exceed in cunning [v OUTCRAFTIED, OUTCRAFTYING, OUTCRAFTIES]\n",
  "OUTCRAFTYING": "OUTCRAFTY, (Shakespeare) to exceed in cunning [v]\n",
  "OUTCRAWL": "to surpass in crawling [v -ED, -ING, -S]\n",
  "OUTCRAWLED": "OUTCRAWL, to surpass in crawling [v]\n",
  "OUTCRAWLING": "OUTCRAWL, to surpass in crawling [v]\n",
  "OUTCRAWLS": "OUTCRAWL, to surpass in crawling [v]\n",
  "OUTCRIED": "OUTCRY, to cry louder than [v]\n",
  "OUTCRIES": "OUTCRY, to cry louder than [v]\n",
  "OUTCROP": "to protrude above the soil [v OUTCROPPED, OUTCROPPING, OUTCROPS]\n",
  "OUTCROPPED": "OUTCROP, to protrude above the soil [v]\n",
  "OUTCROPPING": "an outcrop [n -S]\n",
  "OUTCROPPINGS": "OUTCROPPING, an outcrop [n]\n",
  "OUTCROPS": "OUTCROP, to protrude above the soil [v]\n",
  "OUTCROSS": "to cross the same breed with a different strain [v -ED, -ING, -ES]\n",
  "OUTCROSSED": "OUTCROSS, to cross the same breed with a different strain [v]\n",
  "OUTCROSSES": "OUTCROSS, to cross the same breed with a different strain [v]\n",
  "OUTCROSSING": "the act of crossing (an animal or plant, a breed or stock) with one not closely related [n -S]\n",
  "OUTCROSSINGS": "OUTCROSSING, the act of crossing (an animal or plant, a breed or stock) with one not closely related [n]\n",
  "OUTCROW": "to surpass in crowing [v -ED, -ING, -S]\n",
  "OUTCROWD": "to cause to be too crowded [v -ED, -ING, -S]\n",
  "OUTCROWDED": "OUTCROWD, to cause to be too crowded [v]\n",
  "OUTCROWDING": "OUTCROWD, to cause to be too crowded [v]\n",
  "OUTCROWDS": "OUTCROWD, to cause to be too crowded [v]\n",
  "OUTCROWED": "OUTCROW, to surpass in crowing [v]\n",
  "OUTCROWING": "OUTCROW, to surpass in crowing [v]\n",
  "OUTCROWS": "OUTCROW, to surpass in crowing [v]\n",
  "OUTCRY": "to cry louder than [v OUTCRIED, OUTCRYING, OUTCRIES]\n",
  "OUTCRYING": "OUTCRY, to cry louder than [v]\n",
  "OUTCURSE": "to surpass in cursing [v OUTCURSED, OUTCURSING, OUTCURSES]\n",
  "OUTCURSED": "OUTCURSE, to surpass in cursing [v]\n",
  "OUTCURSES": "OUTCURSE, to surpass in cursing [v]\n",
  "OUTCURSING": "OUTCURSE, to surpass in cursing [v]\n",
  "OUTCURVE": "a type of pitch in baseball [n -S]\n",
  "OUTCURVES": "OUTCURVE, a type of pitch in baseball [n]\n",
  "OUTDACIOUS": "(colloquial) audacious [adj]\n",
  "OUTDANCE": "to surpass in dancing [v OUTDANCED, OUTDANCING, OUTDANCES]\n",
  "OUTDANCED": "OUTDANCE, to surpass in dancing [v]\n",
  "OUTDANCES": "OUTDANCE, to surpass in dancing [v]\n",
  "OUTDANCING": "OUTDANCE, to surpass in dancing [v]\n",
  "OUTDARE": "to surpass in daring [v OUTDARED, OUTDARING, OUTDARES]\n",
  "OUTDARED": "OUTDARE, to surpass in daring [v]\n",
  "OUTDARES": "OUTDARE, to surpass in daring [v]\n",
  "OUTDARING": "OUTDARE, to surpass in daring [v]\n",
  "OUTDATE": "to make out-of-date [v OUTDATED, OUTDATING, OUTDATES]\n",
  "OUTDATED": "OUTDATE, to make out-of-date [v]\n",
  "OUTDATEDLY": "OUTDATED, OUTDATE, to make out-of-date [adv]\n",
  "OUTDATEDNESS": "the state of being outdated [n -ES]\n",
  "OUTDATEDNESSES": "OUTDATEDNESS, the state of being outdated [n]\n",
  "OUTDATES": "OUTDATE, to make out-of-date [v]\n",
  "OUTDATING": "OUTDATE, to make out-of-date [v]\n",
  "OUTDAZZLE": "to surpass in dazzling [v OUTDAZZLED, OUTDAZZLING, OUTDAZZLES]\n",
  "OUTDAZZLED": "OUTDAZZLE, to surpass in dazzling [v]\n",
  "OUTDAZZLES": "OUTDAZZLE, to surpass in dazzling [v]\n",
  "OUTDAZZLING": "OUTDAZZLE, to surpass in dazzling [v]\n",
  "OUTDEBATE": "to surpass in debating [v OUTDEBATED, OUTDEBATING, OUTDEBATES]\n",
  "OUTDEBATED": "OUTDEBATE, to surpass in debating [v]\n",
  "OUTDEBATES": "OUTDEBATE, to surpass in debating [v]\n",
  "OUTDEBATING": "OUTDEBATE, to surpass in debating [v]\n",
  "OUTDELIVER": "to surpass in delivering [v -ED, -ING, -S]\n",
  "OUTDELIVERED": "OUTDELIVER, to surpass in delivering [v]\n",
  "OUTDELIVERING": "OUTDELIVER, to surpass in delivering [v]\n",
  "OUTDELIVERS": "OUTDELIVER, to surpass in delivering [v]\n",
  "OUTDESIGN": "to surpass in designing [v -ED, -ING, -S]\n",
  "OUTDESIGNED": "OUTDESIGN, to surpass in designing [v]\n",
  "OUTDESIGNING": "OUTDESIGN, to surpass in designing [v]\n",
  "OUTDESIGNS": "OUTDESIGN, to surpass in designing [v]\n",
  "OUTDID": "OUTDO, to exceed in performance [v]\n",
  "OUTDISTANCE": "to go far ahead of, as in a race [v OUTDISTANCED, OUTDISTANCING, OUTDISTANCES]\n",
  "OUTDISTANCED": "OUTDISTANCE, to go far ahead of, as in a race [v]\n",
  "OUTDISTANCES": "OUTDISTANCE, to go far ahead of, as in a race [v]\n",
  "OUTDISTANCING": "OUTDISTANCE, to go far ahead of, as in a race [v]\n",
  "OUTDO": "to exceed in performance [v OUTDID, OUTDONE, OUTDOING, OUTDOES]\n",
  "OUTDODGE": "to surpass in dodging [v OUTDODGED, OUTDODGING, OUTDODGES]\n",
  "OUTDODGED": "OUTDODGE, to surpass in dodging [v]\n",
  "OUTDODGES": "OUTDODGE, to surpass in dodging [v]\n",
  "OUTDODGING": "OUTDODGE, to surpass in dodging [v]\n",
  "OUTDOER": "one who outdoes [n -S]\n",
  "OUTDOERS": "OUTDOER, one who outdoes [n]\n",
  "OUTDOES": "OUTDO, to exceed in performance [v]\n",
  "OUTDOING": "OUTDO, to exceed in performance [v]\n",
  "OUTDONE": "OUTDO, to exceed in performance [v]\n",
  "OUTDOOR": "pertaining to the open air [adj]\n",
  "OUTDOORS": "in the open air [adj]\n",
  "OUTDOORSIER": "OUTDOORSY, (colloq.) of an outdoors inclination [adj]\n",
  "OUTDOORSIEST": "OUTDOORSY, (colloq.) of an outdoors inclination [adj]\n",
  "OUTDOORSMAN": "one who spends much time in the outdoors or in outdoor activities [n OUTDOORSMEN]\n",
  "OUTDOORSMANSHIP": "the craft of the outdoorsman [n]\n",
  "OUTDOORSMEN": "OUTDOORSMAN, one who spends much time in the outdoors or in outdoor activities [n]\n",
  "OUTDOORSY": "(colloq.) of an outdoors inclination [adj OUTDOORSIER, OUTDOORSIEST]\n",
  "OUTDRAG": "to surpass in drag racing [v OUTDRAGGED, OUTDRAGGING, OUTDRAGS]\n",
  "OUTDRAGGED": "OUTDRAG, to surpass in drag racing [v]\n",
  "OUTDRAGGING": "OUTDRAG, to surpass in drag racing [v]\n",
  "OUTDRAGS": "OUTDRAG, to surpass in drag racing [v]\n",
  "OUTDRANK": "OUTDRINK, to surpass in drinking [v]\n",
  "OUTDRAW": "to attract a larger audience than [v OUTDREW, OUTDRAWN, OUTDRAWING, OUTDRAWS]\n",
  "OUTDRAWING": "OUTDRAW, to attract a larger audience than [v]\n",
  "OUTDRAWN": "OUTDRAW, to attract a larger audience than [v]\n",
  "OUTDRAWS": "OUTDRAW, to attract a larger audience than [v]\n",
  "OUTDREAM": "to surpass in dreaming [v OUTDREAMED, OUTDREAMT, OUTDREAMING, OUTDREAMS]\n",
  "OUTDREAMED": "OUTDREAM, to surpass in dreaming [v]\n",
  "OUTDREAMING": "OUTDREAM, to surpass in dreaming [v]\n",
  "OUTDREAMS": "OUTDREAM, to surpass in dreaming [v]\n",
  "OUTDREAMT": "OUTDREAM, to surpass in dreaming [v]\n",
  "OUTDRESS": "to surpass in dressing [v -ED, -ING, -ES]\n",
  "OUTDRESSED": "OUTDRESS, to surpass in dressing [v]\n",
  "OUTDRESSES": "OUTDRESS, to surpass in dressing [v]\n",
  "OUTDRESSING": "OUTDRESS, to surpass in dressing [v]\n",
  "OUTDREW": "OUTDRAW, to attract a larger audience than [v]\n",
  "OUTDRINK": "to surpass in drinking [v OUTDRANK, OUTDRUNK, OUTDRINKING, OUTDRINKS]\n",
  "OUTDRINKING": "OUTDRINK, to surpass in drinking [v]\n",
  "OUTDRINKS": "OUTDRINK, to surpass in drinking [v]\n",
  "OUTDRIVE": "to drive a golf ball farther than [v OUTDROVE, OUTDRIVEN, OUTDRIVING, OUTDRIVES]\n",
  "OUTDRIVEN": "OUTDRIVE, to drive a golf ball farther than [v]\n",
  "OUTDRIVES": "OUTDRIVE, to drive a golf ball farther than [v]\n",
  "OUTDRIVING": "OUTDRIVE, to drive a golf ball farther than [v]\n",
  "OUTDROP": "to surpass in dropping [v OUTDROPPED, OUTDROPPING, OUTDROPS]\n",
  "OUTDROPPED": "OUTDROP, to surpass in dropping [v]\n",
  "OUTDROPPING": "OUTDROP, to surpass in dropping [v]\n",
  "OUTDROPS": "OUTDROP, to surpass in dropping [v]\n",
  "OUTDROVE": "OUTDRIVE, to drive a golf ball farther than [v]\n",
  "OUTDRUNK": "OUTDRINK, to surpass in drinking [v]\n",
  "OUTDUEL": "to surpass in dueling [v OUTDUELED or OUTDUELLED, OUTDUELING or OUTDUELLING, OUTDUELS]\n",
  "OUTDUELED": "OUTDUEL, to surpass in dueling [v]\n",
  "OUTDUELING": "OUTDUEL, to surpass in dueling [v]\n",
  "OUTDUELLED": "OUTDUEL, to surpass in dueling [v]\n",
  "OUTDUELLING": "OUTDUEL, to surpass in dueling [v]\n",
  "OUTDUELS": "OUTDUEL, to surpass in dueling [v]\n",
  "OUTDURE": "(obsolete) to outlast [v OUTDURED, OUTDURING, OUTDURES]\n",
  "OUTDURED": "OUTDURE, (obsolete) to outlast [v]\n",
  "OUTDURES": "OUTDURE, (obsolete) to outlast [v]\n",
  "OUTDURING": "OUTDURE, (obsolete) to outlast [v]\n",
  "OUTDWELL": "(Shakespeare) to stay beyond [v OUTDWELT or OUTDWELLED, OUTDWELLING, OUTDWELLS]\n",
  "OUTDWELLED": "OUTDWELL, (Shakespeare) to stay beyond [v]\n",
  "OUTDWELLING": "OUTDWELL, (Shakespeare) to stay beyond [v]\n",
  "OUTDWELLS": "OUTDWELL, (Shakespeare) to stay beyond [v]\n",
  "OUTDWELT": "OUTDWELL, (Shakespeare) to stay beyond [v]\n",
  "OUTEARN": "to surpass in earning [v -ED, -ING, -S]\n",
  "OUTEARNED": "OUTEARN, to surpass in earning [v]\n",
  "OUTEARNING": "OUTEARN, to surpass in earning [v]\n",
  "OUTEARNS": "OUTEARN, to surpass in earning [v]\n",
  "OUTEAT": "to surpass in eating [v OUTATE, OUTEATEN, OUTEATING, OUTEATS]\n",
  "OUTEATEN": "OUTEAT, to surpass in eating [v]\n",
  "OUTEATING": "OUTEAT, to surpass in eating [v]\n",
  "OUTEATS": "OUTEAT, to surpass in eating [v]\n",
  "OUTECHO": "to surpass in echoing [v -ED, -ING, -ES]\n",
  "OUTECHOED": "OUTECHO, to surpass in echoing [v]\n",
  "OUTECHOES": "OUTECHO, to surpass in echoing [v]\n",
  "OUTECHOING": "OUTECHO, to surpass in echoing [v]\n",
  "OUTED": "OUT, to reveal [v]\n",
  "OUTEDGE": "the farthermost bound [n -S]\n",
  "OUTEDGES": "OUTEDGE, the farthermost bound [n]\n",
  "OUTER": "a part of an archery target [n -S]\n",
  "OUTERCOAT": "a coat [n -S]\n",
  "OUTERCOATS": "OUTERCOAT, a coat [n]\n",
  "OUTERCOURSE": "sexual activity without vaginal or anal penetration [n -S]\n",
  "OUTERCOURSES": "OUTERCOURSE, sexual activity without vaginal or anal penetration [n]\n",
  "OUTERMOST": "farthest from the middle or interior, also OUTMOST [adj]\n",
  "OUTERS": "OUTER, a part of an archery target [n]\n",
  "OUTERWEAR": "outer clothing [n -S]\n",
  "OUTERWEARS": "OUTERWEAR, outer clothing [n]\n",
  "OUTFABLE": "to surpass in fabling [v OUTFABLED, OUTFABLING, OUTFABLES]\n",
  "OUTFABLED": "OUTFABLE, to surpass in fabling [v]\n",
  "OUTFABLES": "OUTFABLE, to surpass in fabling [v]\n",
  "OUTFABLING": "OUTFABLE, to surpass in fabling [v]\n",
  "OUTFACE": "to confront unflinchingly [v OUTFACED, OUTFACING, OUTFACES]\n",
  "OUTFACED": "OUTFACE, to confront unflinchingly [v]\n",
  "OUTFACES": "OUTFACE, to confront unflinchingly [v]\n",
  "OUTFACING": "OUTFACE, to confront unflinchingly [v]\n",
  "OUTFALL": "the outlet of a body of water [n -S]\n",
  "OUTFALLS": "OUTFALL, the outlet of a body of water [n]\n",
  "OUTFANGTHIEF": "(historical) the right of judging and fining thieves pursued and brought back from outside one's own jurisdiction [n OUTFANGTHIEVES]\n",
  "OUTFANGTHIEVES": "OUTFANGTHIEF, (historical) the right of judging and fining thieves pursued and brought back from outside one's own jurisdiction [n]\n",
  "OUTFAST": "to surpass in fasting [v -ED, -ING, -S]\n",
  "OUTFASTED": "OUTFAST, to surpass in fasting [v]\n",
  "OUTFASTING": "OUTFAST, to surpass in fasting [v]\n",
  "OUTFASTS": "OUTFAST, to surpass in fasting [v]\n",
  "OUTFAWN": "to surpass in fawning [v -ED, -ING, -S]\n",
  "OUTFAWNED": "OUTFAWN, to surpass in fawning [v]\n",
  "OUTFAWNING": "OUTFAWN, to surpass in fawning [v]\n",
  "OUTFAWNS": "OUTFAWN, to surpass in fawning [v]\n",
  "OUTFEAST": "to surpass in feasting [v -ED, -ING, -S]\n",
  "OUTFEASTED": "OUTFEAST, to surpass in feasting [v]\n",
  "OUTFEASTING": "OUTFEAST, to surpass in feasting [v]\n",
  "OUTFEASTS": "OUTFEAST, to surpass in feasting [v]\n",
  "OUTFEEL": "to surpass in feeling [v OUTFELT, OUTFEELING, OUTFEELS]\n",
  "OUTFEELING": "OUTFEEL, to surpass in feeling [v]\n",
  "OUTFEELS": "OUTFEEL, to surpass in feeling [v]\n",
  "OUTFELT": "OUTFEEL, to surpass in feeling [v]\n",
  "OUTFENCE": "to surpass in fencing [v OUTFENCED, OUTFENCING, OUTFENCES]\n",
  "OUTFENCED": "OUTFENCE, to surpass in fencing [v]\n",
  "OUTFENCES": "OUTFENCE, to surpass in fencing [v]\n",
  "OUTFENCING": "OUTFENCE, to surpass in fencing [v]\n",
  "OUTFIELD": "a part of a baseball field [n -S]\n",
  "OUTFIELDER": "one who plays in the outfield [n -S]\n",
  "OUTFIELDERS": "OUTFIELDER, one who plays in the outfield [n]\n",
  "OUTFIELDS": "OUTFIELD, a part of a baseball field [n]\n",
  "OUTFIGHT": "to surpass in fighting [v OUTFOUGHT, OUTFIGHTING, OUTFIGHTS]\n",
  "OUTFIGHTING": "fighting at a distance, not at close range [n -S]\n",
  "OUTFIGHTINGS": "OUTFIGHTING, fighting at a distance, not at close range [n]\n",
  "OUTFIGHTS": "OUTFIGHT, to surpass in fighting [v]\n",
  "OUTFIGURE": "to surpass in figuring [v OUTFIGURED, OUTFIGURING, OUTFIGURES]\n",
  "OUTFIGURED": "OUTFIGURE, to surpass in figuring [v]\n",
  "OUTFIGURES": "OUTFIGURE, to surpass in figuring [v]\n",
  "OUTFIGURING": "OUTFIGURE, to surpass in figuring [v]\n",
  "OUTFIND": "to surpass in finding [v OUTFOUND, OUTFINDING, OUTFINDS]\n",
  "OUTFINDING": "OUTFIND, to surpass in finding [v]\n",
  "OUTFINDS": "OUTFIND, to surpass in finding [v]\n",
  "OUTFIRE": "to surpass in firing [v OUTFIRED, OUTFIRING, OUTFIRES]\n",
  "OUTFIRED": "OUTFIRE, to surpass in firing [v]\n",
  "OUTFIRES": "OUTFIRE, to surpass in firing [v]\n",
  "OUTFIRING": "OUTFIRE, to surpass in firing [v]\n",
  "OUTFISH": "to surpass in fishing [v -ED, -ING, -ES]\n",
  "OUTFISHED": "OUTFISH, to surpass in fishing [v]\n",
  "OUTFISHES": "OUTFISH, to surpass in fishing [v]\n",
  "OUTFISHING": "OUTFISH, to surpass in fishing [v]\n",
  "OUTFIT": "to equip [v OUTFITTED, OUTFITTING, OUTFITS]\n",
  "OUTFITS": "OUTFIT, to equip [v]\n",
  "OUTFITTED": "OUTFIT, to equip [v]\n",
  "OUTFITTER": "a person who deals in clothing, haberdashery, sporting equipment, etc. [n -S]\n",
  "OUTFITTERS": "OUTFITTER, a person who deals in clothing, haberdashery, sporting equipment, etc. [n]\n",
  "OUTFITTING": "the act of outfitting [n -S]\n",
  "OUTFITTINGS": "OUTFITTING, the act of outfitting [n]\n",
  "OUTFLANK": "to circumvent [v -ED, -ING, -S]\n",
  "OUTFLANKED": "OUTFLANK, to circumvent [v]\n",
  "OUTFLANKING": "OUTFLANK, to circumvent [v]\n",
  "OUTFLANKS": "OUTFLANK, to circumvent [v]\n",
  "OUTFLASH": "to flash more brightly [v -ED, -ING, -ES]\n",
  "OUTFLASHED": "OUTFLASH, to flash more brightly [v]\n",
  "OUTFLASHES": "OUTFLASH, to flash more brightly [v]\n",
  "OUTFLASHING": "OUTFLASH, to flash more brightly [v]\n",
  "OUTFLEW": "OUTFLY, to surpass in speed of flight [v]\n",
  "OUTFLIES": "OUTFLY, to surpass in speed of flight [v]\n",
  "OUTFLING": "to whip out [v OUTFLUNG, OUTFLINGING, OUTFLINGS]\n",
  "OUTFLINGING": "OUTFLING, to whip out [v]\n",
  "OUTFLINGS": "OUTFLING, to whip out [v]\n",
  "OUTFLOAT": "to float longer than [v -ED, -ING, -S]\n",
  "OUTFLOATED": "OUTFLOAT, to float longer than [v]\n",
  "OUTFLOATING": "OUTFLOAT, to float longer than [v]\n",
  "OUTFLOATS": "OUTFLOAT, to float longer than [v]\n",
  "OUTFLOW": "to flow out [v -ED, -ING, -S]\n",
  "OUTFLOWED": "OUTFLOW, to flow out [v]\n",
  "OUTFLOWING": "the act of outflowing [n -S]\n",
  "OUTFLOWINGS": "OUTFLOWING, the act of outflowing [n]\n",
  "OUTFLOWN": "OUTFLY, to surpass in speed of flight [v]\n",
  "OUTFLOWS": "OUTFLOW, to flow out [v]\n",
  "OUTFLUNG": "OUTFLING, to whip out [v]\n",
  "OUTFLUSH": "to flush more strongly [v -ED, -ING, -ES]\n",
  "OUTFLUSHED": "OUTFLUSH, to flush more strongly [v]\n",
  "OUTFLUSHES": "OUTFLUSH, to flush more strongly [v]\n",
  "OUTFLUSHING": "OUTFLUSH, to flush more strongly [v]\n",
  "OUTFLY": "to surpass in speed of flight [v OUTFLEW, OUTFLOWN, OUTFLYING, OUTFLIES]\n",
  "OUTFLYING": "OUTFLY, to surpass in speed of flight [v]\n",
  "OUTFOOL": "to surpass in fooling [v -ED, -ING, -S]\n",
  "OUTFOOLED": "OUTFOOL, to surpass in fooling [v]\n",
  "OUTFOOLING": "OUTFOOL, to surpass in fooling [v]\n",
  "OUTFOOLS": "OUTFOOL, to surpass in fooling [v]\n",
  "OUTFOOT": "to surpass in speed [v -ED, -ING, -S]\n",
  "OUTFOOTED": "OUTFOOT, to surpass in speed [v]\n",
  "OUTFOOTING": "OUTFOOT, to surpass in speed [v]\n",
  "OUTFOOTS": "OUTFOOT, to surpass in speed [v]\n",
  "OUTFOUGHT": "OUTFIGHT, to surpass in fighting [v]\n",
  "OUTFOUND": "OUTFIND, to surpass in finding [v]\n",
  "OUTFOX": "to outwit [v -ED, -ING, -ES]\n",
  "OUTFOXED": "OUTFOX, to outwit [v]\n",
  "OUTFOXES": "OUTFOX, to outwit [v]\n",
  "OUTFOXING": "OUTFOX, to outwit [v]\n",
  "OUTFROWN": "to frown more than [v -ED, -ING, -S]\n",
  "OUTFROWNED": "OUTFROWN, to frown more than [v]\n",
  "OUTFROWNING": "OUTFROWN, to frown more than [v]\n",
  "OUTFROWNS": "OUTFROWN, to frown more than [v]\n",
  "OUTFUMBLE": "to surpass in fumbling [v OUTFUMBLED, OUTFUMBLING, OUTFUMBLES]\n",
  "OUTFUMBLED": "OUTFUMBLE, to surpass in fumbling [v]\n",
  "OUTFUMBLES": "OUTFUMBLE, to surpass in fumbling [v]\n",
  "OUTFUMBLING": "OUTFUMBLE, to surpass in fumbling [v]\n",
  "OUTGAIN": "to gain more than [v -ED, -ING, -S]\n",
  "OUTGAINED": "OUTGAIN, to gain more than [v]\n",
  "OUTGAINING": "OUTGAIN, to gain more than [v]\n",
  "OUTGAINS": "OUTGAIN, to gain more than [v]\n",
  "OUTGALLOP": "to surpass at galloping [v -ED, -ING, -S]\n",
  "OUTGALLOPED": "OUTGALLOP, to surpass at galloping [v]\n",
  "OUTGALLOPING": "OUTGALLOP, to surpass at galloping [v]\n",
  "OUTGALLOPS": "OUTGALLOP, to surpass at galloping [v]\n",
  "OUTGAMBLE": "to surpass at gambling [v OUTGAMBLED, OUTGAMBLING, OUTGAMBLES]\n",
  "OUTGAMBLED": "OUTGAMBLE, to surpass at gambling [v]\n",
  "OUTGAMBLES": "OUTGAMBLE, to surpass at gambling [v]\n",
  "OUTGAMBLING": "OUTGAMBLE, to surpass at gambling [v]\n",
  "OUTGAS": "to remove gas from [v OUTGASSED, OUTGASSING, OUTGASSES or OUTGASES]\n",
  "OUTGASES": "OUTGAS, to remove gas from [v]\n",
  "OUTGASSED": "OUTGAS, to remove gas from [v]\n",
  "OUTGASSES": "OUTGAS, to remove gas from [v]\n",
  "OUTGASSING": "the release of occluded gas [n -S]\n",
  "OUTGASSINGS": "OUTGASSING, the release of occluded gas [n]\n",
  "OUTGATE": "an exit [n -S]\n",
  "OUTGATES": "OUTGATE, an exit [n]\n",
  "OUTGAVE": "OUTGIVE, to give more than [v]\n",
  "OUTGAZE": "to surpass in gazing [v OUTGAZED, OUTGAZING, OUTGAZES]\n",
  "OUTGAZED": "OUTGAZE, to surpass in gazing [v]\n",
  "OUTGAZES": "OUTGAZE, to surpass in gazing [v]\n",
  "OUTGAZING": "OUTGAZE, to surpass in gazing [v]\n",
  "OUTGENERAL": "to surpass in terms of military command [v OUTGENERALED or OUTGENERALLED, OUTGENERALING or OUTGENERALLING, OUTGENERALS]\n",
  "OUTGENERALED": "OUTGENERAL, to surpass in terms of military command [v]\n",
  "OUTGENERALING": "OUTGENERAL, to surpass in terms of military command [v]\n",
  "OUTGENERALLED": "OUTGENERAL, to surpass in terms of military command [v]\n",
  "OUTGENERALLING": "OUTGENERAL, to surpass in terms of military command [v]\n",
  "OUTGENERALS": "OUTGENERAL, to surpass in terms of military command [v]\n",
  "OUTGIVE": "to give more than [v OUTGAVE, OUTGIVEN, OUTGIVING, OUTGIVES]\n",
  "OUTGIVEN": "OUTGIVE, to give more than [v]\n",
  "OUTGIVES": "OUTGIVE, to give more than [v]\n",
  "OUTGIVING": "the act of outgiving [n -S]\n",
  "OUTGIVINGS": "OUTGIVING, the act of outgiving [n]\n",
  "OUTGLARE": "to surpass in glaring [v OUTGLARED, OUTGLARING, OUTGLARES]\n",
  "OUTGLARED": "OUTGLARE, to surpass in glaring [v]\n",
  "OUTGLARES": "OUTGLARE, to surpass in glaring [v]\n",
  "OUTGLARING": "OUTGLARE, to surpass in glaring [v]\n",
  "OUTGLEAM": "to surpass in gleaming [v -ED, -ING, -S]\n",
  "OUTGLEAMED": "OUTGLEAM, to surpass in gleaming [v]\n",
  "OUTGLEAMING": "OUTGLEAM, to surpass in gleaming [v]\n",
  "OUTGLEAMS": "OUTGLEAM, to surpass in gleaming [v]\n",
  "OUTGLITTER": "to surpass in glittering [v -ED, -ING, -S]\n",
  "OUTGLITTERED": "OUTGLITTER, to surpass in glittering [v]\n",
  "OUTGLITTERING": "OUTGLITTER, to surpass in glittering [v]\n",
  "OUTGLITTERS": "OUTGLITTER, to surpass in glittering [v]\n",
  "OUTGLOW": "to surpass in glowing [v -ED, -ING, -S]\n",
  "OUTGLOWED": "OUTGLOW, to surpass in glowing [v]\n",
  "OUTGLOWING": "OUTGLOW, to surpass in glowing [v]\n",
  "OUTGLOWS": "OUTGLOW, to surpass in glowing [v]\n",
  "OUTGNAW": "to surpass in gnawing [v OUTGNAWED, OUTGNAWN, OUTGNAWING, OUTGNAWS]\n",
  "OUTGNAWED": "OUTGNAW, to surpass in gnawing [v]\n",
  "OUTGNAWING": "OUTGNAW, to surpass in gnawing [v]\n",
  "OUTGNAWN": "OUTGNAW, to surpass in gnawing [v]\n",
  "OUTGNAWS": "OUTGNAW, to surpass in gnawing [v]\n",
  "OUTGO": "to go beyond [v OUTWENT, OUTGONE, OUTGOING, OUTGOES]\n",
  "OUTGOER": "someone who is outgoing [n -S]\n",
  "OUTGOERS": "OUTGOER, someone who is outgoing [n]\n",
  "OUTGOES": "OUTGO, to go beyond [v]\n",
  "OUTGOING": "a departure; an expenditure [n -S]\n",
  "OUTGOINGNESS": "the state of being outgoing [n -ES]\n",
  "OUTGOINGNESSES": "OUTGOINGNESS, the state of being outgoing [n]\n",
  "OUTGOINGS": "OUTGOING, a departure; an expenditure [n]\n",
  "OUTGONE": "OUTGO, to go beyond [v]\n",
  "OUTGREW": "OUTGROW, to grow too large for [v]\n",
  "OUTGRIN": "to surpass in grinning [v OUTGRINNED, OUTGRINNING, OUTGRINS]\n",
  "OUTGRINNED": "OUTGRIN, to surpass in grinning [v]\n",
  "OUTGRINNING": "OUTGRIN, to surpass in grinning [v]\n",
  "OUTGRINS": "OUTGRIN, to surpass in grinning [v]\n",
  "OUTGROSS": "to surpass in gross earnings [v -ED, -ING, -ES]\n",
  "OUTGROSSED": "OUTGROSS, to surpass in gross earnings [v]\n",
  "OUTGROSSES": "OUTGROSS, to surpass in gross earnings [v]\n",
  "OUTGROSSING": "OUTGROSS, to surpass in gross earnings [v]\n",
  "OUTGROUP": "a group of people outside one's own group [n -S]\n",
  "OUTGROUPS": "OUTGROUP, a group of people outside one's own group [n]\n",
  "OUTGROW": "to grow too large for [v OUTGREW, OUTGROWN, OUTGROWING, OUTGROWS]\n",
  "OUTGROWING": "OUTGROW, to grow too large for [v]\n",
  "OUTGROWN": "OUTGROW, to grow too large for [v]\n",
  "OUTGROWS": "OUTGROW, to grow too large for [v]\n",
  "OUTGROWTH": "that which grows out from anything [n -S]\n",
  "OUTGROWTHS": "OUTGROWTH, that which grows out from anything [n]\n",
  "OUTGUARD": "a guard or small body of troops at a distance from the main body of an army [n -S]\n",
  "OUTGUARDS": "OUTGUARD, a guard or small body of troops at a distance from the main body of an army [n]\n",
  "OUTGUESS": "to anticipate the actions of [v -ED, -ING, -ES]\n",
  "OUTGUESSED": "OUTGUESS, to anticipate the actions of [v]\n",
  "OUTGUESSES": "OUTGUESS, to anticipate the actions of [v]\n",
  "OUTGUESSING": "OUTGUESS, to anticipate the actions of [v]\n",
  "OUTGUIDE": "to surpass in guiding [v OUTGUIDED, OUTGUIDING, OUTGUIDES]\n",
  "OUTGUIDED": "OUTGUIDE, to surpass in guiding [v]\n",
  "OUTGUIDES": "OUTGUIDE, to surpass in guiding [v]\n",
  "OUTGUIDING": "OUTGUIDE, to surpass in guiding [v]\n",
  "OUTGUN": "to surpass in fire power [v OUTGUNNED, OUTGUNNING, OUTGUNS]\n",
  "OUTGUNNED": "OUTGUN, to surpass in fire power [v]\n",
  "OUTGUNNING": "OUTGUN, to surpass in fire power [v]\n",
  "OUTGUNS": "OUTGUN, to surpass in fire power [v]\n",
  "OUTGUSH": "to gush over [v -ED, -ING, -ES]\n",
  "OUTGUSHED": "OUTGUSH, to gush over [v]\n",
  "OUTGUSHES": "OUTGUSH, to gush over [v]\n",
  "OUTGUSHING": "OUTGUSH, to gush over [v]\n",
  "OUTHANDLE": "to handle better than [v OUTHANDLED, OUTHANDLING, OUTHANDLES]\n",
  "OUTHANDLED": "OUTHANDLE, to handle better than [v]\n",
  "OUTHANDLES": "OUTHANDLE, to handle better than [v]\n",
  "OUTHANDLING": "OUTHANDLE, to handle better than [v]\n",
  "OUTHARBOR": "(Canadian) in Newfoundland, any city or town having a harbor other than the main city of St . John's [n -S]\n",
  "OUTHARBORS": "OUTHARBOR, (Canadian) in Newfoundland, any city or town having a harbor other than the main city of St . John's [n]\n",
  "OUTHAUL": "a rope used to haul a sail taut along a spar, also OUTHAULER [n -S]\n",
  "OUTHAULER": "a rope used to haul a sail taut along a spar, also OUTHAUL [n -S]\n",
  "OUTHAULERS": "OUTHAULER, a rope used to haul a sail taut along a spar, also OUTHAUL [n]\n",
  "OUTHAULS": "OUTHAUL, a rope used to haul a sail taut along a spar, also OUTHAULER [n]\n",
  "OUTHEAR": "to surpass in hearing [v OUTHEARD, OUTHEARING, OUTHEARS]\n",
  "OUTHEARD": "OUTHEAR, to surpass in hearing [v]\n",
  "OUTHEARING": "OUTHEAR, to surpass in hearing [v]\n",
  "OUTHEARS": "OUTHEAR, to surpass in hearing [v]\n",
  "OUTHER": "(dialect) either [adj]\n",
  "OUTHIRE": "to hire out, also OUTHYRE [v OUTHIRED, OUTHIRING, OUTHIRES]\n",
  "OUTHIRED": "OUTHIRE, to hire out, also OUTHYRE [v]\n",
  "OUTHIRES": "OUTHIRE, to hire out, also OUTHYRE [v]\n",
  "OUTHIRING": "OUTHIRE, to hire out, also OUTHYRE [v]\n",
  "OUTHIT": "to surpass in hitting [v OUTHIT, OUTHITTING, OUTHITS]\n",
  "OUTHITS": "OUTHIT, to surpass in hitting [v]\n",
  "OUTHITTING": "OUTHIT, to surpass in hitting [v]\n",
  "OUTHOMER": "to surpass in hitting home runs [v -ED, -ING, -S]\n",
  "OUTHOMERED": "OUTHOMER, to surpass in hitting home runs [v]\n",
  "OUTHOMERING": "OUTHOMER, to surpass in hitting home runs [v]\n",
  "OUTHOMERS": "OUTHOMER, to surpass in hitting home runs [v]\n",
  "OUTHOUSE": "a building near to or up against a main building [n -S]\n",
  "OUTHOUSES": "OUTHOUSE, a building near to or up against a main building [n]\n",
  "OUTHOWL": "to surpass in howling [v -ED, -ING, -S]\n",
  "OUTHOWLED": "OUTHOWL, to surpass in howling [v]\n",
  "OUTHOWLING": "OUTHOWL, to surpass in howling [v]\n",
  "OUTHOWLS": "OUTHOWL, to surpass in howling [v]\n",
  "OUTHUMOR": "to surpass in humoring, also OUTHUMOUR [v -ED, -ING, -S]\n",
  "OUTHUMORED": "OUTHUMOR, to surpass in humoring, also OUTHUMOUR [v]\n",
  "OUTHUMORING": "OUTHUMOR, to surpass in humoring, also OUTHUMOUR [v]\n",
  "OUTHUMORS": "OUTHUMOR, to surpass in humoring, also OUTHUMOUR [v]\n",
  "OUTHUMOUR": "to surpass in humoring, also OUTHUMOR [v -ED, -ING, -S]\n",
  "OUTHUMOURED": "OUTHUMOUR, to surpass in humoring, also OUTHUMOR [v]\n",
  "OUTHUMOURING": "OUTHUMOUR, to surpass in humoring, also OUTHUMOR [v]\n",
  "OUTHUMOURS": "OUTHUMOUR, to surpass in humoring, also OUTHUMOR [v]\n",
  "OUTHUNT": "to surpass in hunting [v -ED, -ING, -S]\n",
  "OUTHUNTED": "OUTHUNT, to surpass in hunting [v]\n",
  "OUTHUNTING": "OUTHUNT, to surpass in hunting [v]\n",
  "OUTHUNTS": "OUTHUNT, to surpass in hunting [v]\n",
  "OUTHUSTLE": "to surpass in hustling [v OUTHUSTLED, OUTHUSTLING, OUTHUSTLES]\n",
  "OUTHUSTLED": "OUTHUSTLE, to surpass in hustling [v]\n",
  "OUTHUSTLES": "OUTHUSTLE, to surpass in hustling [v]\n",
  "OUTHUSTLING": "OUTHUSTLE, to surpass in hustling [v]\n",
  "OUTHYRE": "(Spenser) to hire out [v OUTHYRED, OUTHYRING, OUTHYRES]\n",
  "OUTHYRED": "OUTHYRE, (Spenser) to hire out [v]\n",
  "OUTHYRES": "OUTHYRE, (Spenser) to hire out [v]\n",
  "OUTHYRING": "OUTHYRE, (Spenser) to hire out [v]\n",
  "OUTING": "a short pleasure trip [n -S]\n",
  "OUTINGS": "OUTING, a short pleasure trip [n]\n",
  "OUTINTRIGUE": "to surpass in intrigue [v OUTINTRIGUED, OUTINTRIGUING, OUTINTRIGUES]\n",
  "OUTINTRIGUED": "OUTINTRIGUE, to surpass in intrigue [v]\n",
  "OUTINTRIGUES": "OUTINTRIGUE, to surpass in intrigue [v]\n",
  "OUTINTRIGUING": "OUTINTRIGUE, to surpass in intrigue [v]\n",
  "OUTJEST": "to excel in jesting [v -ED, -ING, -S]\n",
  "OUTJESTED": "OUTJEST, to excel in jesting [v]\n",
  "OUTJESTING": "OUTJEST, to excel in jesting [v]\n",
  "OUTJESTS": "OUTJEST, to excel in jesting [v]\n",
  "OUTJET": "a projection, also OUTJUT [n -S]\n",
  "OUTJETS": "OUTJET, a projection, also OUTJUT [n]\n",
  "OUTJETTING": "a projection, also OUTJUTTING [n -S]\n",
  "OUTJETTINGS": "OUTJETTING, a projection, also OUTJUTTING [n]\n",
  "OUTJINX": "to surpass in jinxing [v -ED, -ING, -ES]\n",
  "OUTJINXED": "OUTJINX, to surpass in jinxing [v]\n",
  "OUTJINXES": "OUTJINX, to surpass in jinxing [v]\n",
  "OUTJINXING": "OUTJINX, to surpass in jinxing [v]\n",
  "OUTJOCKEY": "to surpass in jockeying [v -ED, -ING, -S]\n",
  "OUTJOCKEYED": "OUTJOCKEY, to surpass in jockeying [v]\n",
  "OUTJOCKEYING": "OUTJOCKEY, to surpass in jockeying [v]\n",
  "OUTJOCKEYS": "OUTJOCKEY, to surpass in jockeying [v]\n",
  "OUTJUGGLE": "to surpass at juggling [v OUTJUGGLED, OUTJUGGLING, OUTJUGGLES]\n",
  "OUTJUGGLED": "OUTJUGGLE, to surpass at juggling [v]\n",
  "OUTJUGGLES": "OUTJUGGLE, to surpass at juggling [v]\n",
  "OUTJUGGLING": "OUTJUGGLE, to surpass at juggling [v]\n",
  "OUTJUMP": "to surpass in jumping [v -ED, -ING, -S]\n",
  "OUTJUMPED": "OUTJUMP, to surpass in jumping [v]\n",
  "OUTJUMPING": "OUTJUMP, to surpass in jumping [v]\n",
  "OUTJUMPS": "OUTJUMP, to surpass in jumping [v]\n",
  "OUTJUT": "to stick out [v OUTJUTTED, OUTJUTTING, OUTJUTS]\n",
  "OUTJUTS": "OUTJUT, to stick out [v]\n",
  "OUTJUTTED": "OUTJUT, to stick out [v]\n",
  "OUTJUTTING": "a projection, also OUTJETTING [n -S]\n",
  "OUTJUTTINGS": "OUTJUTTING, a projection, also OUTJETTING [n]\n",
  "OUTKEEP": "to surpass in keeping [v OUTKEPT, OUTKEEPING, OUTKEEPS]\n",
  "OUTKEEPING": "OUTKEEP, to surpass in keeping [v]\n",
  "OUTKEEPS": "OUTKEEP, to surpass in keeping [v]\n",
  "OUTKEPT": "OUTKEEP, to surpass in keeping [v]\n",
  "OUTKICK": "to surpass in kicking [v -ED, -ING, -S]\n",
  "OUTKICKED": "OUTKICK, to surpass in kicking [v]\n",
  "OUTKICKING": "OUTKICK, to surpass in kicking [v]\n",
  "OUTKICKS": "OUTKICK, to surpass in kicking [v]\n",
  "OUTKILL": "to surpass in killing [v -ED, -ING, -S]\n",
  "OUTKILLED": "OUTKILL, to surpass in killing [v]\n",
  "OUTKILLING": "OUTKILL, to surpass in killing [v]\n",
  "OUTKILLS": "OUTKILL, to surpass in killing [v]\n",
  "OUTKISS": "to surpass in kissing [v -ED, -ING, -ES]\n",
  "OUTKISSED": "OUTKISS, to surpass in kissing [v]\n",
  "OUTKISSES": "OUTKISS, to surpass in kissing [v]\n",
  "OUTKISSING": "OUTKISS, to surpass in kissing [v]\n",
  "OUTLAID": "OUTLAY, to pay out [v]\n",
  "OUTLAIN": "OUTLIE, to lie outside, be outlying [v]\n",
  "OUTLAND": "an outlying land or territory [n -S]\n",
  "OUTLANDER": "a foreigner, also UITLANDER [n -S]\n",
  "OUTLANDERS": "OUTLANDER, a foreigner, also UITLANDER [n]\n",
  "OUTLANDISH": "of or relating to another country [adj OUTLANDISHLY]\n",
  "OUTLANDISHLY": "OUTLANDISH, of or relating to another country [adv]\n",
  "OUTLANDISHNESS": "OUTLANDISH, of or relating to another country [n]\n",
  "OUTLANDS": "OUTLAND, an outlying land or territory [n]\n",
  "OUTLASH": "to lash out, shed tears [v -ED, -ING, -ES]\n",
  "OUTLASHED": "OUTLASH, to lash out, shed tears [v]\n",
  "OUTLASHES": "OUTLASH, to lash out, shed tears [v]\n",
  "OUTLASHING": "OUTLASH, to lash out, shed tears [v]\n",
  "OUTLAST": "to last longer than [v -ED, -ING, -S]\n",
  "OUTLASTED": "OUTLAST, to last longer than [v]\n",
  "OUTLASTING": "OUTLAST, to last longer than [v]\n",
  "OUTLASTS": "OUTLAST, to last longer than [v]\n",
  "OUTLAUGH": "to surpass in laughing [v -ED, -ING, -S]\n",
  "OUTLAUGHED": "OUTLAUGH, to surpass in laughing [v]\n",
  "OUTLAUGHING": "OUTLAUGH, to surpass in laughing [v]\n",
  "OUTLAUGHS": "OUTLAUGH, to surpass in laughing [v]\n",
  "OUTLAUNCE": "(Spenser) to launch forth, also OUTLAUNCH [v OUTLAUNCED, OUTLAUNCING, OUTLAUNCES]\n",
  "OUTLAUNCED": "OUTLAUNCE, (Spenser) to launch forth, also OUTLAUNCH [v]\n",
  "OUTLAUNCES": "OUTLAUNCE, (Spenser) to launch forth, also OUTLAUNCH [v]\n",
  "OUTLAUNCH": "to launch forth, also OUTLAUNCE [v -ED, -ING, -ES]\n",
  "OUTLAUNCHED": "OUTLAUNCH, to launch forth, also OUTLAUNCE [v]\n",
  "OUTLAUNCHES": "OUTLAUNCH, to launch forth, also OUTLAUNCE [v]\n",
  "OUTLAUNCHING": "OUTLAUNCH, to launch forth, also OUTLAUNCE [v]\n",
  "OUTLAUNCING": "OUTLAUNCE, (Spenser) to launch forth, also OUTLAUNCH [v]\n",
  "OUTLAW": "to prohibit [v -ED, -ING, -S]\n",
  "OUTLAWED": "OUTLAW, to prohibit [v]\n",
  "OUTLAWING": "OUTLAW, to prohibit [v]\n",
  "OUTLAWRIES": "OUTLAWRY, the state of being an outlaw [n]\n",
  "OUTLAWRY": "the state of being an outlaw [n OUTLAWRIES]\n",
  "OUTLAWS": "OUTLAW, to prohibit [v]\n",
  "OUTLAY": "to pay out [v OUTLAID, OUTLAYING, OUTLAYS]\n",
  "OUTLAYING": "OUTLAY, to pay out [v]\n",
  "OUTLAYS": "OUTLAY, to pay out [v]\n",
  "OUTLEAD": "to surpass in leading [v OUTLED, OUTLEADING, OUTLEADS]\n",
  "OUTLEADING": "OUTLEAD, to surpass in leading [v]\n",
  "OUTLEADS": "OUTLEAD, to surpass in leading [v]\n",
  "OUTLEAP": "to surpass in leaping [v OUTLEAPED, OUTLEAPT, OUTLEAPING, OUTLEAPS]\n",
  "OUTLEAPED": "OUTLEAP, to surpass in leaping [v]\n",
  "OUTLEAPING": "OUTLEAP, to surpass in leaping [v]\n",
  "OUTLEAPS": "OUTLEAP, to surpass in leaping [v]\n",
  "OUTLEAPT": "OUTLEAP, to surpass in leaping [v]\n",
  "OUTLEARN": "to surpass in learning [v OUTLEARNED, OUTLEARNT, OUTLEARNING, OUTLEARNS]\n",
  "OUTLEARNED": "OUTLEARN, to surpass in learning [v]\n",
  "OUTLEARNING": "OUTLEARN, to surpass in learning [v]\n",
  "OUTLEARNS": "OUTLEARN, to surpass in learning [v]\n",
  "OUTLEARNT": "OUTLEARN, to surpass in learning [v]\n",
  "OUTLED": "OUTLEAD, to surpass in leading [v]\n",
  "OUTLER": "someone who is out of office [n -S]\n",
  "OUTLERS": "OUTLER, someone who is out of office [n]\n",
  "OUTLET": "a vent or passage [n -S]\n",
  "OUTLETS": "OUTLET, a vent or passage [n]\n",
  "OUTLIE": "to lie outside, be outlying [v OUTLAY, OUTLAIN, OUTLYING, OUTLIES] / to surpass in lying [v OUTLIED, OUTLYING, OUTLIES]\n",
  "OUTLIED": "OUTLIE, to lie outside, be outlying [v]\n",
  "OUTLIER": "a detached portion of anything lying some way off or out, e.g. a rock [n -S]\n",
  "OUTLIERS": "OUTLIER, a detached portion of anything lying some way off or out, e.g. a rock [n]\n",
  "OUTLIES": "OUTLIE, to lie outside, be outlying [v]\n",
  "OUTLINE": "to make a general statement without details [v OUTLINED, OUTLINING, OUTLINES]\n",
  "OUTLINEAR": "like an outline [adj]\n",
  "OUTLINED": "OUTLINE, to make a general statement without details [v]\n",
  "OUTLINER": "one that outlines [n -S]\n",
  "OUTLINERS": "OUTLINER, one that outlines [n]\n",
  "OUTLINES": "OUTLINE, to make a general statement without details [v]\n",
  "OUTLINING": "OUTLINE, to make a general statement without details [v]\n",
  "OUTLIVE": "to live longer than [v OUTLIVED, OUTLIVING, OUTLIVES]\n",
  "OUTLIVED": "OUTLIVE, to live longer than [v]\n",
  "OUTLIVER": "one who outlives [n -S]\n",
  "OUTLIVERS": "OUTLIVER, one who outlives [n]\n",
  "OUTLIVES": "OUTLIVE, to live longer than [v]\n",
  "OUTLIVING": "OUTLIVE, to live longer than [v]\n",
  "OUTLODGING": "a lodging beyond bounds [n -S]\n",
  "OUTLODGINGS": "OUTLODGING, a lodging beyond bounds [n]\n",
  "OUTLOOK": "to look out [v -ED, -ING, -S]\n",
  "OUTLOOKED": "OUTLOOK, to look out [v]\n",
  "OUTLOOKING": "OUTLOOK, to look out [v]\n",
  "OUTLOOKS": "OUTLOOK, to look out [v]\n",
  "OUTLOVE": "to surpass in loving [v OUTLOVED, OUTLOVING, OUTLOVES]\n",
  "OUTLOVED": "OUTLOVE, to surpass in loving [v]\n",
  "OUTLOVES": "OUTLOVE, to surpass in loving [v]\n",
  "OUTLOVING": "OUTLOVE, to surpass in loving [v]\n",
  "OUTLUSTER": "to exceed in luster, also OUTLUSTRE [v -ED, -ING, -S]\n",
  "OUTLUSTERED": "OUTLUSTER, to exceed in luster, also OUTLUSTRE [v]\n",
  "OUTLUSTERING": "OUTLUSTER, to exceed in luster, also OUTLUSTRE [v]\n",
  "OUTLUSTERS": "OUTLUSTER, to exceed in luster, also OUTLUSTRE [v]\n",
  "OUTLUSTRE": "(Shakespeare) to exceed in lustre, also OUTLUSTER [v OUTLUSTRED, OUTLUSTRING, OUTLUSTRES]\n",
  "OUTLUSTRED": "OUTLUSTRE, (Shakespeare) to exceed in lustre, also OUTLUSTER [v]\n",
  "OUTLUSTRES": "OUTLUSTRE, (Shakespeare) to exceed in lustre, also OUTLUSTER [v]\n",
  "OUTLUSTRING": "OUTLUSTRE, (Shakespeare) to exceed in lustre, also OUTLUSTER [v]\n",
  "OUTLYING": "OUTLIE, to lie outside, be outlying [v]\n",
  "OUTMAN": "to surpass in manpower [v OUTMANNED, OUTMANNING, OUTMANS]\n",
  "OUTMANEUVER": "to surpass in maneuvering, also OUTMANOEUVRE [v -ED, -ING, -S]\n",
  "OUTMANEUVERED": "OUTMANEUVER, to surpass in maneuvering, also OUTMANOEUVRE [v]\n",
  "OUTMANEUVERING": "OUTMANEUVER, to surpass in maneuvering, also OUTMANOEUVRE [v]\n",
  "OUTMANEUVERS": "OUTMANEUVER, to surpass in maneuvering, also OUTMANOEUVRE [v]\n",
  "OUTMANIPULATE": "to surpass in manipulation [v OUTMANIPULATED, OUTMANIPULATING, OUTMANIPULATES]\n",
  "OUTMANIPULATED": "OUTMANIPULATE, to surpass in manipulation [v]\n",
  "OUTMANIPULATES": "OUTMANIPULATE, to surpass in manipulation [v]\n",
  "OUTMANIPULATING": "OUTMANIPULATE, to surpass in manipulation [v]\n",
  "OUTMANNED": "OUTMAN, to surpass in manpower [v]\n",
  "OUTMANNING": "OUTMAN, to surpass in manpower [v]\n",
  "OUTMANOEUVRE": "to surpass in manoeuvring, also OUTMANEUVER [v OUTMANOEUVRED, OUTMANOEUVRING, OUTMANOEUVRES]\n",
  "OUTMANOEUVRED": "OUTMANOEUVRE, to surpass in manoeuvring, also OUTMANEUVER [v]\n",
  "OUTMANOEUVRES": "OUTMANOEUVRE, to surpass in manoeuvring, also OUTMANEUVER [v]\n",
  "OUTMANOEUVRING": "OUTMANOEUVRE, to surpass in manoeuvring, also OUTMANEUVER [v]\n",
  "OUTMANS": "OUTMAN, to surpass in manpower [v]\n",
  "OUTMANTLE": "(archaic) to exceed in dress or ornament [v OUTMANTLED, OUTMANTLING, OUTMANTLES]\n",
  "OUTMANTLED": "OUTMANTLE, (archaic) to exceed in dress or ornament [v]\n",
  "OUTMANTLES": "OUTMANTLE, (archaic) to exceed in dress or ornament [v]\n",
  "OUTMANTLING": "OUTMANTLE, (archaic) to exceed in dress or ornament [v]\n",
  "OUTMARCH": "to surpass in marching [v -ED, -ING, -ES]\n",
  "OUTMARCHED": "OUTMARCH, to surpass in marching [v]\n",
  "OUTMARCHES": "OUTMARCH, to surpass in marching [v]\n",
  "OUTMARCHING": "OUTMARCH, to surpass in marching [v]\n",
  "OUTMARRIAGE": "marriage outside the social group [n -S]\n",
  "OUTMARRIAGES": "OUTMARRIAGE, marriage outside the social group [n]\n",
  "OUTMASTER": "to surpass [v -ED, -ING, -S]\n",
  "OUTMASTERED": "OUTMASTER, to surpass [v]\n",
  "OUTMASTERING": "OUTMASTER, to surpass [v]\n",
  "OUTMASTERS": "OUTMASTER, to surpass [v]\n",
  "OUTMATCH": "to surpass [v -ED, -ING, -ES]\n",
  "OUTMATCHED": "OUTMATCH, to surpass [v]\n",
  "OUTMATCHES": "OUTMATCH, to surpass [v]\n",
  "OUTMATCHING": "OUTMATCH, to surpass [v]\n",
  "OUTMEASURE": "to exceed in measure or extent [v OUTMEASURED, OUTMEASURING, OUTMEASURES]\n",
  "OUTMEASURED": "OUTMEASURE, to exceed in measure or extent [v]\n",
  "OUTMEASURES": "OUTMEASURE, to exceed in measure or extent [v]\n",
  "OUTMEASURING": "OUTMEASURE, to exceed in measure or extent [v]\n",
  "OUTMODE": "to put out of fashion [v OUTMODED, OUTMODING, OUTMODES]\n",
  "OUTMODED": "OUTMODE, to put out of fashion [v]\n",
  "OUTMODEDLY": "OUTMODED, OUTMODE, to put out of fashion [adv]\n",
  "OUTMODEDNESS": "the state of being outmoded [n -ES]\n",
  "OUTMODEDNESSES": "OUTMODEDNESS, the state of being outmoded [n]\n",
  "OUTMODES": "OUTMODE, to put out of fashion [v]\n",
  "OUTMODING": "OUTMODE, to put out of fashion [v]\n",
  "OUTMOST": "farthest from the middle or interior, also OUTERMOST [adj]\n",
  "OUTMOVE": "to move faster than [v OUTMOVED, OUTMOVING, OUTMOVES]\n",
  "OUTMOVED": "OUTMOVE, to move faster than [v]\n",
  "OUTMOVES": "OUTMOVE, to move faster than [v]\n",
  "OUTMOVING": "OUTMOVE, to move faster than [v]\n",
  "OUTMUSCLE": "to surpass in muscle-power [v OUTMUSCLED, OUTMUSCLING, OUTMUSCLES]\n",
  "OUTMUSCLED": "OUTMUSCLE, to surpass in muscle-power [v]\n",
  "OUTMUSCLES": "OUTMUSCLE, to surpass in muscle-power [v]\n",
  "OUTMUSCLING": "OUTMUSCLE, to surpass in muscle-power [v]\n",
  "OUTNAME": "to exceed in naming or describing [v OUTNAMED, OUTNAMING, OUTNAMES]\n",
  "OUTNAMED": "OUTNAME, to exceed in naming or describing [v]\n",
  "OUTNAMES": "OUTNAME, to exceed in naming or describing [v]\n",
  "OUTNAMING": "OUTNAME, to exceed in naming or describing [v]\n",
  "OUTNESS": "the state of being out [n -ES]\n",
  "OUTNESSES": "OUTNESS, the state of being out [n]\n",
  "OUTNIGHT": "(Shakespeare) to surpass in mentioning nights [v -ED, -ING, -S]\n",
  "OUTNIGHTED": "OUTNIGHT, (Shakespeare) to surpass in mentioning nights [v]\n",
  "OUTNIGHTING": "OUTNIGHT, (Shakespeare) to surpass in mentioning nights [v]\n",
  "OUTNIGHTS": "OUTNIGHT, (Shakespeare) to surpass in mentioning nights [v]\n",
  "OUTNUMBER": "to surpass in number [v -ED, -ING, -S]\n",
  "OUTNUMBERED": "OUTNUMBER, to surpass in number [v]\n",
  "OUTNUMBERING": "OUTNUMBER, to surpass in number [v]\n",
  "OUTNUMBERS": "OUTNUMBER, to surpass in number [v]\n",
  "OUTOFFICE": "an outbuilding [n -S]\n",
  "OUTOFFICES": "OUTOFFICE, an outbuilding [n]\n",
  "OUTORGANISE": "to surpass at organisation, also OUTORGANIZE [v OUTORGANISED, OUTORGANISING, OUTORGANISES]\n",
  "OUTORGANISED": "OUTORGANISE, to surpass at organisation, also OUTORGANIZE [v]\n",
  "OUTORGANISES": "OUTORGANISE, to surpass at organisation, also OUTORGANIZE [v]\n",
  "OUTORGANISING": "OUTORGANISE, to surpass at organisation, also OUTORGANIZE [v]\n",
  "OUTORGANIZE": "to surpass in organization, also OUTORGANISE [v OUTORGANIZED, OUTORGANIZING, OUTORGANIZES]\n",
  "OUTORGANIZED": "OUTORGANIZE, to surpass in organization, also OUTORGANISE [v]\n",
  "OUTORGANIZES": "OUTORGANIZE, to surpass in organization, also OUTORGANISE [v]\n",
  "OUTORGANIZING": "OUTORGANIZE, to surpass in organization, also OUTORGANISE [v]\n",
  "OUTPACE": "to move faster than [v OUTPACED, OUTPACING, OUTPACES]\n",
  "OUTPACED": "OUTPACE, to move faster than [v]\n",
  "OUTPACES": "OUTPACE, to move faster than [v]\n",
  "OUTPACING": "OUTPACE, to move faster than [v]\n",
  "OUTPAINT": "to surpass in painting [v -ED, -ING, -S]\n",
  "OUTPAINTED": "OUTPAINT, to surpass in painting [v]\n",
  "OUTPAINTING": "OUTPAINT, to surpass in painting [v]\n",
  "OUTPAINTS": "OUTPAINT, to surpass in painting [v]\n",
  "OUTPART": "(obsolete) an outlying part [n -S]\n",
  "OUTPARTS": "OUTPART, (obsolete) an outlying part [n]\n",
  "OUTPASS": "to excel in passing in football [v -ED, -ING, -ES]\n",
  "OUTPASSED": "OUTPASS, to excel in passing in football [v]\n",
  "OUTPASSES": "OUTPASS, to excel in passing in football [v]\n",
  "OUTPASSING": "OUTPASS, to excel in passing in football [v]\n",
  "OUTPASSION": "to exceed in passion [v -ED, -ING, -S]\n",
  "OUTPASSIONED": "OUTPASSION, to exceed in passion [v]\n",
  "OUTPASSIONING": "OUTPASSION, to exceed in passion [v]\n",
  "OUTPASSIONS": "OUTPASSION, to exceed in passion [v]\n",
  "OUTPATIENT": "a patient who is not hospitalized overnight but who visits a hospital, clinic, or associated facility for diagnosis or treatment [n -S]\n",
  "OUTPATIENTS": "OUTPATIENT, a patient who is not hospitalized overnight but who visits a hospital, clinic, or associated facility for diagnosis or treatment [n]\n",
  "OUTPEEP": "to peep out [v -ED, -ING, -S]\n",
  "OUTPEEPED": "OUTPEEP, to peep out [v]\n",
  "OUTPEEPING": "OUTPEEP, to peep out [v]\n",
  "OUTPEEPS": "OUTPEEP, to peep out [v]\n",
  "OUTPEER": "(Shakespeare) to surpass, excel [v -ED, -ING, -S]\n",
  "OUTPEERED": "OUTPEER, (Shakespeare) to surpass, excel [v]\n",
  "OUTPEERING": "OUTPEER, (Shakespeare) to surpass, excel [v]\n",
  "OUTPEERS": "OUTPEER, (Shakespeare) to surpass, excel [v]\n",
  "OUTPEOPLE": "to rid a country of its people [v OUTPEOPLED, OUTPEOPLING, OUTPEOPLES]\n",
  "OUTPEOPLED": "OUTPEOPLE, to rid a country of its people [v]\n",
  "OUTPEOPLES": "OUTPEOPLE, to rid a country of its people [v]\n",
  "OUTPEOPLING": "OUTPEOPLE, to rid a country of its people [v]\n",
  "OUTPERFORM": "to exceed in performance [v -ED, -ING, -S]\n",
  "OUTPERFORMED": "OUTPERFORM, to exceed in performance [v]\n",
  "OUTPERFORMING": "OUTPERFORM, to exceed in performance [v]\n",
  "OUTPERFORMS": "OUTPERFORM, to exceed in performance [v]\n",
  "OUTPITCH": "to surpass in pitching [v -ED, -ING, -ES]\n",
  "OUTPITCHED": "OUTPITCH, to surpass in pitching [v]\n",
  "OUTPITCHES": "OUTPITCH, to surpass in pitching [v]\n",
  "OUTPITCHING": "OUTPITCH, to surpass in pitching [v]\n",
  "OUTPITIED": "OUTPITY, to surpass in pitying [v]\n",
  "OUTPITIES": "OUTPITY, to surpass in pitying [v]\n",
  "OUTPITY": "to surpass in pitying [v OUTPITIED, OUTPITYING, OUTPITIES]\n",
  "OUTPITYING": "OUTPITY, to surpass in pitying [v]\n",
  "OUTPLACE": "to find new employment for a redundant worker [v OUTPLACED, OUTPLACING, OUTPLACES]\n",
  "OUTPLACED": "OUTPLACE, to find new employment for a redundant worker [v]\n",
  "OUTPLACEMENT": "the process of easing unwanted or unneeded executives out of a company by providing company-paid assistance in finding them new jobs [n -S]\n",
  "OUTPLACEMENTS": "OUTPLACEMENT, the process of easing unwanted or unneeded executives out of a company by providing company-paid assistance in finding them new jobs [n]\n",
  "OUTPLACER": "one who outplaces [n -S]\n",
  "OUTPLACERS": "OUTPLACER, one who outplaces [n]\n",
  "OUTPLACES": "OUTPLACE, to find new employment for a redundant worker [v]\n",
  "OUTPLACING": "OUTPLACE, to find new employment for a redundant worker [v]\n",
  "OUTPLAN": "to surpass in planning [v OUTPLANNED, OUTPLANNING, OUTPLANS]\n",
  "OUTPLANNED": "OUTPLAN, to surpass in planning [v]\n",
  "OUTPLANNING": "OUTPLAN, to surpass in planning [v]\n",
  "OUTPLANS": "OUTPLAN, to surpass in planning [v]\n",
  "OUTPLAY": "to excel or defeat in a game [v -ED, -ING, -S]\n",
  "OUTPLAYED": "OUTPLAY, to excel or defeat in a game [v]\n",
  "OUTPLAYING": "OUTPLAY, to excel or defeat in a game [v]\n",
  "OUTPLAYS": "OUTPLAY, to excel or defeat in a game [v]\n",
  "OUTPLOD": "to surpass in plodding [v OUTPLODDED, OUTPLODDING, OUTPLODS]\n",
  "OUTPLODDED": "OUTPLOD, to surpass in plodding [v]\n",
  "OUTPLODDING": "OUTPLOD, to surpass in plodding [v]\n",
  "OUTPLODS": "OUTPLOD, to surpass in plodding [v]\n",
  "OUTPLOT": "to surpass in plotting [v OUTPLOTTED, OUTPLOTTING, OUTPLOTS]\n",
  "OUTPLOTS": "OUTPLOT, to surpass in plotting [v]\n",
  "OUTPLOTTED": "OUTPLOT, to surpass in plotting [v]\n",
  "OUTPLOTTING": "OUTPLOT, to surpass in plotting [v]\n",
  "OUTPOINT": "to score more points than [v -ED, -ING, -S]\n",
  "OUTPOINTED": "OUTPOINT, to score more points than [v]\n",
  "OUTPOINTING": "OUTPOINT, to score more points than [v]\n",
  "OUTPOINTS": "OUTPOINT, to score more points than [v]\n",
  "OUTPOLITICK": "to surpass in politicking [v -ED, -ING, -S]\n",
  "OUTPOLITICKED": "OUTPOLITICK, to surpass in politicking [v]\n",
  "OUTPOLITICKING": "OUTPOLITICK, to surpass in politicking [v]\n",
  "OUTPOLITICKS": "OUTPOLITICK, to surpass in politicking [v]\n",
  "OUTPOLL": "to get more votes than [v -ED, -ING, -S]\n",
  "OUTPOLLED": "OUTPOLL, to get more votes than [v]\n",
  "OUTPOLLING": "OUTPOLL, to get more votes than [v]\n",
  "OUTPOLLS": "OUTPOLL, to get more votes than [v]\n",
  "OUTPOPULATE": "to surpass in population [v OUTPOPULATED, OUTPOPULATING, OUTPOPULATES]\n",
  "OUTPOPULATED": "OUTPOPULATE, to surpass in population [v]\n",
  "OUTPOPULATES": "OUTPOPULATE, to surpass in population [v]\n",
  "OUTPOPULATING": "OUTPOPULATE, to surpass in population [v]\n",
  "OUTPORT": "a port out of or remote from the chief port [n -S]\n",
  "OUTPORTER": "(Canadian) an inhabitant or native of a Newfoundland outport [n -S]\n",
  "OUTPORTERS": "OUTPORTER, (Canadian) an inhabitant or native of a Newfoundland outport [n]\n",
  "OUTPORTS": "OUTPORT, a port out of or remote from the chief port [n]\n",
  "OUTPOST": "a remote settlement or stronghold [n -S]\n",
  "OUTPOSTS": "OUTPOST, a remote settlement or stronghold [n]\n",
  "OUTPOUR": "to pour out [v -ED, -ING, -S]\n",
  "OUTPOURED": "OUTPOUR, to pour out [v]\n",
  "OUTPOURER": "one who pours out [n -S]\n",
  "OUTPOURERS": "OUTPOURER, one who pours out [n]\n",
  "OUTPOURING": "the act of outpouring [n -S]\n",
  "OUTPOURINGS": "OUTPOURING, the act of outpouring [n]\n",
  "OUTPOURS": "OUTPOUR, to pour out [v]\n",
  "OUTPOWER": "to surpass in power [v -ED, -ING, -S]\n",
  "OUTPOWERED": "OUTPOWER, to surpass in power [v]\n",
  "OUTPOWERING": "OUTPOWER, to surpass in power [v]\n",
  "OUTPOWERS": "OUTPOWER, to surpass in power [v]\n",
  "OUTPRAY": "to surpass in praying [v -ED, -ING, -S]\n",
  "OUTPRAYED": "OUTPRAY, to surpass in praying [v]\n",
  "OUTPRAYING": "OUTPRAY, to surpass in praying [v]\n",
  "OUTPRAYS": "OUTPRAY, to surpass in praying [v]\n",
  "OUTPREACH": "to surpass in preaching [v -ED, -ING, -ES]\n",
  "OUTPREACHED": "OUTPREACH, to surpass in preaching [v]\n",
  "OUTPREACHES": "OUTPREACH, to surpass in preaching [v]\n",
  "OUTPREACHING": "OUTPREACH, to surpass in preaching [v]\n",
  "OUTPREEN": "to surpass in preening [v -ED, -ING, -S]\n",
  "OUTPREENED": "OUTPREEN, to surpass in preening [v]\n",
  "OUTPREENING": "OUTPREEN, to surpass in preening [v]\n",
  "OUTPREENS": "OUTPREEN, to surpass in preening [v]\n",
  "OUTPRESS": "to surpass in pressing [v -ED, -ING, -ES]\n",
  "OUTPRESSED": "OUTPRESS, to surpass in pressing [v]\n",
  "OUTPRESSES": "OUTPRESS, to surpass in pressing [v]\n",
  "OUTPRESSING": "OUTPRESS, to surpass in pressing [v]\n",
  "OUTPRICE": "to offer a better price [v OUTPRICED, OUTPRICING, OUTPRICES]\n",
  "OUTPRICED": "OUTPRICE, to offer a better price [v]\n",
  "OUTPRICES": "OUTPRICE, to offer a better price [v]\n",
  "OUTPRICING": "OUTPRICE, to offer a better price [v]\n",
  "OUTPRIZE": "(Shakespeare) to exceed in estimation [v OUTPRIZED, OUTPRIZING, OUTPRIZES]\n",
  "OUTPRIZED": "OUTPRIZE, (Shakespeare) to exceed in estimation [v]\n",
  "OUTPRIZES": "OUTPRIZE, (Shakespeare) to exceed in estimation [v]\n",
  "OUTPRIZING": "OUTPRIZE, (Shakespeare) to exceed in estimation [v]\n",
  "OUTPRODUCE": "to surpass in production [v OUTPRODUCED, OUTPRODUCING, OUTPRODUCES]\n",
  "OUTPRODUCED": "OUTPRODUCE, to surpass in production [v]\n",
  "OUTPRODUCES": "OUTPRODUCE, to surpass in production [v]\n",
  "OUTPRODUCING": "OUTPRODUCE, to surpass in production [v]\n",
  "OUTPROMISE": "to surpass in promising [v OUTPROMISED, OUTPROMISING, OUTPROMISES]\n",
  "OUTPROMISED": "OUTPROMISE, to surpass in promising [v]\n",
  "OUTPROMISES": "OUTPROMISE, to surpass in promising [v]\n",
  "OUTPROMISING": "OUTPROMISE, to surpass in promising [v]\n",
  "OUTPSYCH": "to defeat by psychological means [v -ED, -ING, -S]\n",
  "OUTPSYCHED": "OUTPSYCH, to defeat by psychological means [v]\n",
  "OUTPSYCHING": "OUTPSYCH, to defeat by psychological means [v]\n",
  "OUTPSYCHS": "OUTPSYCH, to defeat by psychological means [v]\n",
  "OUTPULL": "to attract a larger audience than [v -ED, -ING, -S]\n",
  "OUTPULLED": "OUTPULL, to attract a larger audience than [v]\n",
  "OUTPULLING": "OUTPULL, to attract a larger audience than [v]\n",
  "OUTPULLS": "OUTPULL, to attract a larger audience than [v]\n",
  "OUTPUNCH": "to surpass in punching [v -ED, -ING, -ES]\n",
  "OUTPUNCHED": "OUTPUNCH, to surpass in punching [v]\n",
  "OUTPUNCHES": "OUTPUNCH, to surpass in punching [v]\n",
  "OUTPUNCHING": "OUTPUNCH, to surpass in punching [v]\n",
  "OUTPUPIL": "a student sent to a different school from the one he or she would normally attend [n -S]\n",
  "OUTPUPILS": "OUTPUPIL, a student sent to a different school from the one he or she would normally attend [n]\n",
  "OUTPURSUE": "to pursue further than [v OUTPURSUED, OUTPURSUING, OUTPURSUES]\n",
  "OUTPURSUED": "OUTPURSUE, to pursue further than [v]\n",
  "OUTPURSUES": "OUTPURSUE, to pursue further than [v]\n",
  "OUTPURSUING": "OUTPURSUE, to pursue further than [v]\n",
  "OUTPUSH": "to surpass in pushing [v -ED, -ING, -ES]\n",
  "OUTPUSHED": "OUTPUSH, to surpass in pushing [v]\n",
  "OUTPUSHES": "OUTPUSH, to surpass in pushing [v]\n",
  "OUTPUSHING": "OUTPUSH, to surpass in pushing [v]\n",
  "OUTPUT": "to produce [v OUTPUTTED, OUTPUTTING, OUTPUTS]\n",
  "OUTPUTS": "OUTPUT, to produce [v]\n",
  "OUTPUTTED": "OUTPUT, to produce [v]\n",
  "OUTPUTTING": "OUTPUT, to produce [v]\n",
  "OUTQUARTERS": "quarters situated away from headquarters [n]\n",
  "OUTQUOTE": "to surpass in quoting [v OUTQUOTED, OUTQUOTING, OUTQUOTES]\n",
  "OUTQUOTED": "OUTQUOTE, to surpass in quoting [v]\n",
  "OUTQUOTES": "OUTQUOTE, to surpass in quoting [v]\n",
  "OUTQUOTING": "OUTQUOTE, to surpass in quoting [v]\n",
  "OUTRACE": "to run faster than [v OUTRACED, OUTRACING, OUTRACES]\n",
  "OUTRACED": "OUTRACE, to run faster than [v]\n",
  "OUTRACES": "OUTRACE, to run faster than [v]\n",
  "OUTRACING": "OUTRACE, to run faster than [v]\n",
  "OUTRAGE": "to arouse anger or resentment in [v OUTRAGED, OUTRAGING, OUTRAGES]\n",
  "OUTRAGED": "OUTRAGE, to arouse anger or resentment in [v]\n",
  "OUTRAGEOUS": "exceeding the limits of what is usual [adj OUTRAGEOUSLY]\n",
  "OUTRAGEOUSLY": "OUTRAGEOUS, exceeding the limits of what is usual [adv]\n",
  "OUTRAGEOUSNESS": "OUTRAGEOUS, exceeding the limits of what is usual [n]\n",
  "OUTRAGES": "OUTRAGE, to arouse anger or resentment in [v]\n",
  "OUTRAGING": "OUTRAGE, to arouse anger or resentment in [v]\n",
  "OUTRAISE": "to surpass in raising [v OUTRAISED, OUTRAISING, OUTRAISES]\n",
  "OUTRAISED": "OUTRAISE, to surpass in raising [v]\n",
  "OUTRAISES": "OUTRAISE, to surpass in raising [v]\n",
  "OUTRAISING": "OUTRAISE, to surpass in raising [v]\n",
  "OUTRAN": "OUTRUN, to run faster than [v]\n",
  "OUTRANCE": "(French) the last extremity [n -S]\n",
  "OUTRANCES": "OUTRANCE, (French) the last extremity [n]\n",
  "OUTRANG": "OUTRING, to ring louder than [v]\n",
  "OUTRANGE": "to surpass in range [v OUTRANGED, OUTRANGING, OUTRANGES]\n",
  "OUTRANGED": "OUTRANGE, to surpass in range [v]\n",
  "OUTRANGES": "OUTRANGE, to surpass in range [v]\n",
  "OUTRANGING": "OUTRANGE, to surpass in range [v]\n",
  "OUTRANK": "to rank higher than [v -ED, -ING, -S]\n",
  "OUTRANKED": "OUTRANK, to rank higher than [v]\n",
  "OUTRANKING": "OUTRANK, to rank higher than [v]\n",
  "OUTRANKS": "OUTRANK, to rank higher than [v]\n",
  "OUTRATE": "to surpass in rating [v OUTRATED, OUTRATING, OUTRATES]\n",
  "OUTRATED": "OUTRATE, to surpass in rating [v]\n",
  "OUTRATES": "OUTRATE, to surpass in rating [v]\n",
  "OUTRATING": "OUTRATE, to surpass in rating [v]\n",
  "OUTRAVE": "to surpass in raving [v OUTRAVED, OUTRAVING, OUTRAVES]\n",
  "OUTRAVED": "OUTRAVE, to surpass in raving [v]\n",
  "OUTRAVES": "OUTRAVE, to surpass in raving [v]\n",
  "OUTRAVING": "OUTRAVE, to surpass in raving [v]\n",
  "OUTRE": "(French) deviating from what is right or proper [adj]\n",
  "OUTREACH": "to reach beyond [v -ED, -ING, -ES]\n",
  "OUTREACHED": "OUTREACH, to reach beyond [v]\n",
  "OUTREACHES": "OUTREACH, to reach beyond [v]\n",
  "OUTREACHING": "OUTREACH, to reach beyond [v]\n",
  "OUTREAD": "to surpass in reading [v OUTREAD, OUTREADING, OUTREADS]\n",
  "OUTREADING": "OUTREAD, to surpass in reading [v]\n",
  "OUTREADS": "OUTREAD, to surpass in reading [v]\n",
  "OUTREASON": "to surpass in reasoning [v -ED, -ING, -S]\n",
  "OUTREASONED": "OUTREASON, to surpass in reasoning [v]\n",
  "OUTREASONING": "OUTREASON, to surpass in reasoning [v]\n",
  "OUTREASONS": "OUTREASON, to surpass in reasoning [v]\n",
  "OUTREBOUND": "to rebound more than [v -ED, -ING, -S]\n",
  "OUTREBOUNDED": "OUTREBOUND, to rebound more than [v]\n",
  "OUTREBOUNDING": "OUTREBOUND, to rebound more than [v]\n",
  "OUTREBOUNDS": "OUTREBOUND, to rebound more than [v]\n",
  "OUTRECKON": "to surpass in reckoning [v -ED, -ING, -S]\n",
  "OUTRECKONED": "OUTRECKON, to surpass in reckoning [v]\n",
  "OUTRECKONING": "OUTRECKON, to surpass in reckoning [v]\n",
  "OUTRECKONS": "OUTRECKON, to surpass in reckoning [v]\n",
  "OUTRECUIDANCE": "(Scott) presumption or overweening [n -S]\n",
  "OUTRECUIDANCES": "OUTRECUIDANCE, (Scott) presumption or overweening [n]\n",
  "OUTRED": "to surpass in redness [v OUTREDDED, OUTREDDING, OUTREDS]\n",
  "OUTREDDED": "OUTRED, to surpass in redness [v]\n",
  "OUTREDDEN": "to surpass in redness, also OUTRED [v -ED, -ING, -S]\n",
  "OUTREDDENED": "OUTREDDEN, to surpass in redness, also OUTRED [v]\n",
  "OUTREDDENING": "OUTREDDEN, to surpass in redness, also OUTRED [v]\n",
  "OUTREDDENS": "OUTREDDEN, to surpass in redness, also OUTRED [v]\n",
  "OUTREDDING": "the act of exceeding redness [n -S]\n",
  "OUTREDDINGS": "OUTREDDING, the act of exceeding redness [n]\n",
  "OUTREDS": "OUTRED, to surpass in redness [v]\n",
  "OUTREIGN": "to reign longer than [v -ED, -ING, -S]\n",
  "OUTREIGNED": "OUTREIGN, to reign longer than [v]\n",
  "OUTREIGNING": "OUTREIGN, to reign longer than [v]\n",
  "OUTREIGNS": "OUTREIGN, to reign longer than [v]\n",
  "OUTRELIEF": "outdoor relief [n -S]\n",
  "OUTRELIEFS": "OUTRELIEF, outdoor relief [n]\n",
  "OUTREMER": "(French) the region beyond the sea [n -S]\n",
  "OUTREMERS": "OUTREMER, (French) the region beyond the sea [n]\n",
  "OUTREPRODUCE": "to surpass in reproducing [v OUTREPRODUCED, OUTREPRODUCING, OUTREPRODUCES]\n",
  "OUTREPRODUCED": "OUTREPRODUCE, to surpass in reproducing [v]\n",
  "OUTREPRODUCES": "OUTREPRODUCE, to surpass in reproducing [v]\n",
  "OUTREPRODUCING": "OUTREPRODUCE, to surpass in reproducing [v]\n",
  "OUTRIDDEN": "OUTRIDE, to ride faster than [v]\n",
  "OUTRIDE": "to ride faster than [v OUTRODE, OUTRIDDEN, OUTRIDING, OUTRIDES]\n",
  "OUTRIDER": "a mounted carriage attendant [n -S]\n",
  "OUTRIDERS": "OUTRIDER, a mounted carriage attendant [n]\n",
  "OUTRIDES": "OUTRIDE, to ride faster than [v]\n",
  "OUTRIDING": "the act of riding out [n -S]\n",
  "OUTRIDINGS": "OUTRIDING, the act of riding out [n]\n",
  "OUTRIG": "to equip (a boat) with outriggers (projections having floats) [v OUTRIGGED, OUTRIGGING, OUTRIGS]\n",
  "OUTRIGGED": "OUTRIG, to equip (a boat) with outriggers (projections having floats) [v]\n",
  "OUTRIGGER": "a spar extended from the side of a ship to help secure the mast [n -S]\n",
  "OUTRIGGERS": "OUTRIGGER, a spar extended from the side of a ship to help secure the mast [n]\n",
  "OUTRIGGING": "the act of rigging out [n -S]\n",
  "OUTRIGGINGS": "OUTRIGGING, the act of rigging out [n]\n",
  "OUTRIGHT": "totally, completely [adj OUTRIGHTLY]\n",
  "OUTRIGHTLY": "OUTRIGHT, totally, completely [adv]\n",
  "OUTRIGS": "OUTRIG, to equip (a boat) with outriggers (projections having floats) [v]\n",
  "OUTRING": "to ring louder than [v OUTRANG or OUTRUNG, OUTRINGING, OUTRINGS]\n",
  "OUTRINGING": "OUTRING, to ring louder than [v]\n",
  "OUTRINGS": "OUTRING, to ring louder than [v]\n",
  "OUTRIVAL": "to outdo in rivalry [v OUTRIVALED or OUTRIVALLED, OUTRIVALING or OUTRIVALLING, OUTRIVALS]\n",
  "OUTRIVALED": "OUTRIVAL, to outdo in rivalry [v]\n",
  "OUTRIVALING": "OUTRIVAL, to outdo in rivalry [v]\n",
  "OUTRIVALLED": "OUTRIVAL, to outdo in rivalry [v]\n",
  "OUTRIVALLING": "OUTRIVAL, to outdo in rivalry [v]\n",
  "OUTRIVALS": "OUTRIVAL, to outdo in rivalry [v]\n",
  "OUTRO": "an instrumental passage that concludes a piece of music [n -S]\n",
  "OUTROAR": "(Shakespeare) to roar louder than [v -ED, -ING, -S]\n",
  "OUTROARED": "OUTROAR, (Shakespeare) to roar louder than [v]\n",
  "OUTROARING": "OUTROAR, (Shakespeare) to roar louder than [v]\n",
  "OUTROARS": "OUTROAR, (Shakespeare) to roar louder than [v]\n",
  "OUTROCK": "to surpass in rocking [v -ED, -ING, -S]\n",
  "OUTROCKED": "OUTROCK, to surpass in rocking [v]\n",
  "OUTROCKING": "OUTROCK, to surpass in rocking [v]\n",
  "OUTROCKS": "OUTROCK, to surpass in rocking [v]\n",
  "OUTRODE": "OUTRIDE, to ride faster than [v]\n",
  "OUTROLL": "to roll out [v -ED, -ING, -S]\n",
  "OUTROLLED": "OUTROLL, to roll out [v]\n",
  "OUTROLLING": "OUTROLL, to roll out [v]\n",
  "OUTROLLS": "OUTROLL, to roll out [v]\n",
  "OUTROOP": "(obsolete) an auction sale, also OUTROPE [n -S]\n",
  "OUTROOPER": "(obsolete) an auctioneer; the Common Crier of the City, also OUTROPER [n -S]\n",
  "OUTROOPERS": "OUTROOPER, (obsolete) an auctioneer; the Common Crier of the City, also OUTROPER [n]\n",
  "OUTROOPS": "OUTROOP, (obsolete) an auction sale, also OUTROPE [n]\n",
  "OUTROOT": "to pull up by the roots [v -ED, -ING, -S]\n",
  "OUTROOTED": "OUTROOT, to pull up by the roots [v]\n",
  "OUTROOTING": "OUTROOT, to pull up by the roots [v]\n",
  "OUTROOTS": "OUTROOT, to pull up by the roots [v]\n",
  "OUTROPE": "an auction sale, also OUTROOP [n -S]\n",
  "OUTROPER": "(obsolete) an auctioneer; the Common Crier of the City, also OUTROOPER [n -S]\n",
  "OUTROPERS": "OUTROPER, (obsolete) an auctioneer; the Common Crier of the City, also OUTROOPER [n]\n",
  "OUTROPES": "OUTROPE, an auction sale, also OUTROOP [n]\n",
  "OUTROS": "OUTRO, an instrumental passage that concludes a piece of music [n]\n",
  "OUTROW": "to surpass in rowing [v -ED, -ING, -S]\n",
  "OUTROWED": "OUTROW, to surpass in rowing [v]\n",
  "OUTROWING": "OUTROW, to surpass in rowing [v]\n",
  "OUTROWS": "OUTROW, to surpass in rowing [v]\n",
  "OUTRUN": "to run faster than [v OUTRAN, OUTRUN, OUTRUNNING, OUTRUNS]\n",
  "OUTRUNG": "OUTRING, to ring louder than [v]\n",
  "OUTRUNNER": "one who outruns [n -S]\n",
  "OUTRUNNERS": "OUTRUNNER, one who outruns [n]\n",
  "OUTRUNNING": "OUTRUN, to run faster than [v]\n",
  "OUTRUNS": "OUTRUN, to run faster than [v]\n",
  "OUTRUSH": "to surpass in rushing [v -ED, -ING, -ES]\n",
  "OUTRUSHED": "OUTRUSH, to surpass in rushing [v]\n",
  "OUTRUSHES": "OUTRUSH, to surpass in rushing [v]\n",
  "OUTRUSHING": "OUTRUSH, to surpass in rushing [v]\n",
  "OUTS": "OUT, to reveal [v]\n",
  "OUTSAID": "OUTSAY, to surpass in saying [v]\n",
  "OUTSAIL": "to sail faster than [v -ED, -ING, -S]\n",
  "OUTSAILED": "OUTSAIL, to sail faster than [v]\n",
  "OUTSAILING": "OUTSAIL, to sail faster than [v]\n",
  "OUTSAILS": "OUTSAIL, to sail faster than [v]\n",
  "OUTSANG": "OUTSING, to surpass in singing [v]\n",
  "OUTSAT": "OUTSIT, to sit longer than [v]\n",
  "OUTSAVOR": "(US) to surpass in savor, also OUTSAVOUR [v -ED, -ING, -S]\n",
  "OUTSAVORED": "OUTSAVOR, (US) to surpass in savor, also OUTSAVOUR [v]\n",
  "OUTSAVORING": "OUTSAVOR, (US) to surpass in savor, also OUTSAVOUR [v]\n",
  "OUTSAVORS": "OUTSAVOR, (US) to surpass in savor, also OUTSAVOUR [v]\n",
  "OUTSAVOUR": "to exceed in savouring, also OUTSAVOR [v -ED, -ING, -S]\n",
  "OUTSAVOURED": "OUTSAVOUR, to exceed in savouring, also OUTSAVOR [v]\n",
  "OUTSAVOURING": "OUTSAVOUR, to exceed in savouring, also OUTSAVOR [v]\n",
  "OUTSAVOURS": "OUTSAVOUR, to exceed in savouring, also OUTSAVOR [v]\n",
  "OUTSAW": "OUTSEE, to see beyond [v]\n",
  "OUTSAY": "to surpass in saying [v OUTSAID, OUTSAYING, OUTSAYS]\n",
  "OUTSAYING": "OUTSAY, to surpass in saying [v]\n",
  "OUTSAYS": "OUTSAY, to surpass in saying [v]\n",
  "OUTSCHEME": "to surpass in scheming [v OUTSCHEMED, OUTSCHEMING, OUTSCHEMES]\n",
  "OUTSCHEMED": "OUTSCHEME, to surpass in scheming [v]\n",
  "OUTSCHEMES": "OUTSCHEME, to surpass in scheming [v]\n",
  "OUTSCHEMING": "OUTSCHEME, to surpass in scheming [v]\n",
  "OUTSCOLD": "(Shakespeare) to surpass in scolding [v -ED, -ING, -S]\n",
  "OUTSCOLDED": "OUTSCOLD, (Shakespeare) to surpass in scolding [v]\n",
  "OUTSCOLDING": "OUTSCOLD, (Shakespeare) to surpass in scolding [v]\n",
  "OUTSCOLDS": "OUTSCOLD, (Shakespeare) to surpass in scolding [v]\n",
  "OUTSCOOP": "to surpass in scooping [v -ED, -ING, -S]\n",
  "OUTSCOOPED": "OUTSCOOP, to surpass in scooping [v]\n",
  "OUTSCOOPING": "OUTSCOOP, to surpass in scooping [v]\n",
  "OUTSCOOPS": "OUTSCOOP, to surpass in scooping [v]\n",
  "OUTSCORE": "to score more points than [v OUTSCORED, OUTSCORING, OUTSCORES]\n",
  "OUTSCORED": "OUTSCORE, to score more points than [v]\n",
  "OUTSCORES": "OUTSCORE, to score more points than [v]\n",
  "OUTSCORING": "OUTSCORE, to score more points than [v]\n",
  "OUTSCORN": "(Shakespeare) to surpass in scorning [v -ED, -ING, -S]\n",
  "OUTSCORNED": "OUTSCORN, (Shakespeare) to surpass in scorning [v]\n",
  "OUTSCORNING": "OUTSCORN, (Shakespeare) to surpass in scorning [v]\n",
  "OUTSCORNS": "OUTSCORN, (Shakespeare) to surpass in scorning [v]\n",
  "OUTSCREAM": "to surpass at screaming [v -ED, -ING, -S]\n",
  "OUTSCREAMED": "OUTSCREAM, to surpass at screaming [v]\n",
  "OUTSCREAMING": "OUTSCREAM, to surpass at screaming [v]\n",
  "OUTSCREAMS": "OUTSCREAM, to surpass at screaming [v]\n",
  "OUTSEE": "to see beyond [v OUTSAW, OUTSEEN, OUTSEEING, OUTSEES]\n",
  "OUTSEEING": "OUTSEE, to see beyond [v]\n",
  "OUTSEEN": "OUTSEE, to see beyond [v]\n",
  "OUTSEES": "OUTSEE, to see beyond [v]\n",
  "OUTSELL": "to sell more than [v OUTSOLD, OUTSELLING, OUTSELLS]\n",
  "OUTSELLING": "OUTSELL, to sell more than [v]\n",
  "OUTSELLS": "OUTSELL, to sell more than [v]\n",
  "OUTSERT": "a sheet enclosing a folded article [n -S]\n",
  "OUTSERTS": "OUTSERT, a sheet enclosing a folded article [n]\n",
  "OUTSERVE": "to surpass in serving [v OUTSERVED, OUTSERVING, OUTSERVES]\n",
  "OUTSERVED": "OUTSERVE, to surpass in serving [v]\n",
  "OUTSERVES": "OUTSERVE, to surpass in serving [v]\n",
  "OUTSERVING": "OUTSERVE, to surpass in serving [v]\n",
  "OUTSET": "a beginning [n -S]\n",
  "OUTSETS": "OUTSET, a beginning [n]\n",
  "OUTSETTING": "a setting out [n -S]\n",
  "OUTSETTINGS": "OUTSETTING, a setting out [n]\n",
  "OUTSETTLEMENT": "an outlying settlement [n -S]\n",
  "OUTSETTLEMENTS": "OUTSETTLEMENT, an outlying settlement [n]\n",
  "OUTSHAME": "to surpass in shaming [v OUTSHAMED, OUTSHAMING, OUTSHAMES]\n",
  "OUTSHAMED": "OUTSHAME, to surpass in shaming [v]\n",
  "OUTSHAMES": "OUTSHAME, to surpass in shaming [v]\n",
  "OUTSHAMING": "OUTSHAME, to surpass in shaming [v]\n",
  "OUTSHINE": "to shine brighter than [v OUTSHONE or OUTSHINED, OUTSHINING, OUTSHINES]\n",
  "OUTSHINED": "OUTSHINE, to shine brighter than [v]\n",
  "OUTSHINES": "OUTSHINE, to shine brighter than [v]\n",
  "OUTSHINING": "OUTSHINE, to shine brighter than [v]\n",
  "OUTSHONE": "OUTSHINE, to shine brighter than [v]\n",
  "OUTSHOOT": "to surpass in shooting [v OUTSHOT, OUTSHOOTING, OUTSHOOTS]\n",
  "OUTSHOOTING": "OUTSHOOT, to surpass in shooting [v]\n",
  "OUTSHOOTS": "OUTSHOOT, to surpass in shooting [v]\n",
  "OUTSHOT": "(Scots) a projection in a building or a recess made in the wall of a room [n -S]\n",
  "OUTSHOTS": "OUTSHOT, (Scots) a projection in a building or a recess made in the wall of a room [n]\n",
  "OUTSHOUT": "to shout louder than [v -ED, -ING, -S]\n",
  "OUTSHOUTED": "OUTSHOUT, to shout louder than [v]\n",
  "OUTSHOUTING": "OUTSHOUT, to shout louder than [v]\n",
  "OUTSHOUTS": "OUTSHOUT, to shout louder than [v]\n",
  "OUTSIDE": "the outer side [n -S]\n",
  "OUTSIDER": "one who does not belong to a particular group [n -S]\n",
  "OUTSIDERNESS": "the state of being an outsider [n -ES]\n",
  "OUTSIDERNESSES": "OUTSIDERNESS, the state of being an outsider [n]\n",
  "OUTSIDERS": "OUTSIDER, one who does not belong to a particular group [n]\n",
  "OUTSIDES": "OUTSIDE, the outer side [n]\n",
  "OUTSIGHT": "the power of perceiving external things [n -S]\n",
  "OUTSIGHTS": "OUTSIGHT, the power of perceiving external things [n]\n",
  "OUTSIN": "to surpass in sinning [v OUTSINNED, OUTSINNING, OUTSINS]\n",
  "OUTSING": "to surpass in singing [v OUTSANG, OUTSUNG, OUTSINGING, OUTSINGS]\n",
  "OUTSINGING": "OUTSING, to surpass in singing [v]\n",
  "OUTSINGS": "OUTSING, to surpass in singing [v]\n",
  "OUTSINNED": "OUTSIN, to surpass in sinning [v]\n",
  "OUTSINNING": "OUTSIN, to surpass in sinning [v]\n",
  "OUTSINS": "OUTSIN, to surpass in sinning [v]\n",
  "OUTSIT": "to sit longer than [v OUTSAT, OUTSITTING, OUTSITS]\n",
  "OUTSITS": "OUTSIT, to sit longer than [v]\n",
  "OUTSITTING": "OUTSIT, to sit longer than [v]\n",
  "OUTSIZE": "an exceptionally large size [n -S]\n",
  "OUTSIZED": "exceptionally large [adj]\n",
  "OUTSIZES": "OUTSIZE, an exceptionally large size [n]\n",
  "OUTSKATE": "to surpass in skating [v OUTSKATED, OUTSKATING, OUTSKATES]\n",
  "OUTSKATED": "OUTSKATE, to surpass in skating [v]\n",
  "OUTSKATES": "OUTSKATE, to surpass in skating [v]\n",
  "OUTSKATING": "OUTSKATE, to surpass in skating [v]\n",
  "OUTSKIRT": "an outlying area [n -S]\n",
  "OUTSKIRTS": "OUTSKIRT, an outlying area [n]\n",
  "OUTSLEEP": "to sleep later than [v OUTSLEPT, OUTSLEEPING, OUTSLEEPS]\n",
  "OUTSLEEPING": "OUTSLEEP, to sleep later than [v]\n",
  "OUTSLEEPS": "OUTSLEEP, to sleep later than [v]\n",
  "OUTSLEPT": "OUTSLEEP, to sleep later than [v]\n",
  "OUTSLICK": "to get the better of by cunning [v -ED, -ING, -S]\n",
  "OUTSLICKED": "OUTSLICK, to get the better of by cunning [v]\n",
  "OUTSLICKING": "OUTSLICK, to get the better of by cunning [v]\n",
  "OUTSLICKS": "OUTSLICK, to get the better of by cunning [v]\n",
  "OUTSMART": "to outwit [v -ED, -ING, -S]\n",
  "OUTSMARTED": "OUTSMART, to outwit [v]\n",
  "OUTSMARTING": "OUTSMART, to outwit [v]\n",
  "OUTSMARTS": "OUTSMART, to outwit [v]\n",
  "OUTSMELL": "to surpass in smelling [v OUTSMELT or OUTSMELLED, OUTSMELLING, OUTSMELLS]\n",
  "OUTSMELLED": "OUTSMELL, to surpass in smelling [v]\n",
  "OUTSMELLING": "OUTSMELL, to surpass in smelling [v]\n",
  "OUTSMELLS": "OUTSMELL, to surpass in smelling [v]\n",
  "OUTSMELT": "OUTSMELL, to surpass in smelling [v]\n",
  "OUTSMILE": "to surpass in smiling [v OUTSMILED, OUTSMILING, OUTSMILES]\n",
  "OUTSMILED": "OUTSMILE, to surpass in smiling [v]\n",
  "OUTSMILES": "OUTSMILE, to surpass in smiling [v]\n",
  "OUTSMILING": "OUTSMILE, to surpass in smiling [v]\n",
  "OUTSMOKE": "to surpass in smoking [v OUTSMOKED, OUTSMOKING, OUTSMOKES]\n",
  "OUTSMOKED": "OUTSMOKE, to surpass in smoking [v]\n",
  "OUTSMOKES": "OUTSMOKE, to surpass in smoking [v]\n",
  "OUTSMOKING": "OUTSMOKE, to surpass in smoking [v]\n",
  "OUTSNORE": "to surpass in snoring [v OUTSNORED, OUTSNORING, OUTSNORES]\n",
  "OUTSNORED": "OUTSNORE, to surpass in snoring [v]\n",
  "OUTSNORES": "OUTSNORE, to surpass in snoring [v]\n",
  "OUTSNORING": "OUTSNORE, to surpass in snoring [v]\n",
  "OUTSOAR": "to soar beyond [v -ED, -ING, -S]\n",
  "OUTSOARED": "OUTSOAR, to soar beyond [v]\n",
  "OUTSOARING": "OUTSOAR, to soar beyond [v]\n",
  "OUTSOARS": "OUTSOAR, to soar beyond [v]\n",
  "OUTSOLD": "OUTSELL, to sell more than [v]\n",
  "OUTSOLE": "the outer sole of a boot or shoe [n -S]\n",
  "OUTSOLES": "OUTSOLE, the outer sole of a boot or shoe [n]\n",
  "OUTSOURCE": "to source a contract from outside a company [v OUTSOURCED, OUTSOURCING, OUTSOURCES]\n",
  "OUTSOURCED": "OUTSOURCE, to source a contract from outside a company [v]\n",
  "OUTSOURCES": "OUTSOURCE, to source a contract from outside a company [v]\n",
  "OUTSOURCING": "the act of sourcing work from outside a company [n -S]\n",
  "OUTSOURCINGS": "OUTSOURCING, the act of sourcing work from outside a company [n]\n",
  "OUTSPAN": "(South African) to unharness a draft animal [v OUTSPANNED, OUTSPANNING, OUTSPANS]\n",
  "OUTSPANNED": "OUTSPAN, (South African) to unharness a draft animal [v]\n",
  "OUTSPANNING": "OUTSPAN, (South African) to unharness a draft animal [v]\n",
  "OUTSPANS": "OUTSPAN, (South African) to unharness a draft animal [v]\n",
  "OUTSPARKLE": "to exceed in sparkling [v OUTSPARKLED, OUTSPARKLING, OUTSPARKLES]\n",
  "OUTSPARKLED": "OUTSPARKLE, to exceed in sparkling [v]\n",
  "OUTSPARKLES": "OUTSPARKLE, to exceed in sparkling [v]\n",
  "OUTSPARKLING": "OUTSPARKLE, to exceed in sparkling [v]\n",
  "OUTSPEAK": "to outdo in speaking [v OUTSPOKE, OUTSPOKEN, OUTSPEAKING, OUTSPEAKS]\n",
  "OUTSPEAKING": "OUTSPEAK, to outdo in speaking [v]\n",
  "OUTSPEAKS": "OUTSPEAK, to outdo in speaking [v]\n",
  "OUTSPECKLE": "(Scots) a laughing stock, a spectacle [n -S]\n",
  "OUTSPECKLES": "OUTSPECKLE, (Scots) a laughing stock, a spectacle [n]\n",
  "OUTSPED": "OUTSPEED, to go faster than [v]\n",
  "OUTSPEED": "to go faster than [v OUTSPEEDED or OUTSPED, OUTSPEEDING, OUTSPEEDS]\n",
  "OUTSPEEDED": "OUTSPEED, to go faster than [v]\n",
  "OUTSPEEDING": "OUTSPEED, to go faster than [v]\n",
  "OUTSPEEDS": "OUTSPEED, to go faster than [v]\n",
  "OUTSPELL": "to surpass in spelling [v OUTSPELT or OUTSPELLED, OUTSPELLING, OUTSPELLS]\n",
  "OUTSPELLED": "OUTSPELL, to surpass in spelling [v]\n",
  "OUTSPELLING": "OUTSPELL, to surpass in spelling [v]\n",
  "OUTSPELLS": "OUTSPELL, to surpass in spelling [v]\n",
  "OUTSPELT": "OUTSPELL, to surpass in spelling [v]\n",
  "OUTSPEND": "to exceed the limits of in spending [v OUTSPENT, OUTSPENDING, OUTSPENDS]\n",
  "OUTSPENDING": "OUTSPEND, to exceed the limits of in spending [v]\n",
  "OUTSPENDS": "OUTSPEND, to exceed the limits of in spending [v]\n",
  "OUTSPENT": "OUTSPEND, to exceed the limits of in spending [v]\n",
  "OUTSPOKE": "OUTSPEAK, to outdo in speaking [v]\n",
  "OUTSPOKEN": "frank, speaking one's mind [adj OUTSPOKENLY]\n",
  "OUTSPOKENLY": "OUTSPOKEN, frank, speaking one's mind [adv]\n",
  "OUTSPOKENNESS": "the state of being outspoken [n -ES]\n",
  "OUTSPOKENNESSES": "OUTSPOKENNESS, the state of being outspoken [n]\n",
  "OUTSPORT": "(Shakespeare) to sport beyond the limits of [v -ED, -ING, -S]\n",
  "OUTSPORTED": "OUTSPORT, (Shakespeare) to sport beyond the limits of [v]\n",
  "OUTSPORTING": "OUTSPORT, (Shakespeare) to sport beyond the limits of [v]\n",
  "OUTSPORTS": "OUTSPORT, (Shakespeare) to sport beyond the limits of [v]\n",
  "OUTSPRANG": "OUTSPRING, to spring out [v]\n",
  "OUTSPREAD": "to spread out [v OUTSPREAD, OUTSPREADING, OUTSPREADS]\n",
  "OUTSPREADING": "OUTSPREAD, to spread out [v]\n",
  "OUTSPREADS": "OUTSPREAD, to spread out [v]\n",
  "OUTSPRING": "to spring out [v OUTSPRANG, OUTSPRUNG, OUTSPRINGING, OUTSPRINGS]\n",
  "OUTSPRINGING": "OUTSPRING, to spring out [v]\n",
  "OUTSPRINGS": "OUTSPRING, to spring out [v]\n",
  "OUTSPRINT": "to excel in sprinting [v -ED, -ING, -S]\n",
  "OUTSPRINTED": "OUTSPRINT, to excel in sprinting [v]\n",
  "OUTSPRINTING": "OUTSPRINT, to excel in sprinting [v]\n",
  "OUTSPRINTS": "OUTSPRINT, to excel in sprinting [v]\n",
  "OUTSPRUNG": "OUTSPRING, to spring out [v]\n",
  "OUTSTAND": "to stand out, or project, from a surface or mass [v OUTSTOOD, OUTSTANDING, OUTSTANDS]\n",
  "OUTSTANDING": "OUTSTAND, to stand out, or project, from a surface or mass [v]\n",
  "OUTSTANDINGLY": "OUTSTANDING, OUTSTAND, to stand out, or project, from a surface or mass [adv]\n",
  "OUTSTANDS": "OUTSTAND, to stand out, or project, from a surface or mass [v]\n",
  "OUTSTARE": "to outdo in staring [v OUTSTARED, OUTSTARING, OUTSTARES]\n",
  "OUTSTARED": "OUTSTARE, to outdo in staring [v]\n",
  "OUTSTARES": "OUTSTARE, to outdo in staring [v]\n",
  "OUTSTARING": "OUTSTARE, to outdo in staring [v]\n",
  "OUTSTART": "to get ahead of at the start [v -ED, -ING, -S]\n",
  "OUTSTARTED": "OUTSTART, to get ahead of at the start [v]\n",
  "OUTSTARTING": "OUTSTART, to get ahead of at the start [v]\n",
  "OUTSTARTS": "OUTSTART, to get ahead of at the start [v]\n",
  "OUTSTATE": "to surpass in stating [v OUTSTATED, OUTSTATING, OUTSTATES]\n",
  "OUTSTATED": "OUTSTATE, to surpass in stating [v]\n",
  "OUTSTATES": "OUTSTATE, to surpass in stating [v]\n",
  "OUTSTATING": "OUTSTATE, to surpass in stating [v]\n",
  "OUTSTATION": "a remote or outlying station [n -S]\n",
  "OUTSTATIONS": "OUTSTATION, a remote or outlying station [n]\n",
  "OUTSTAY": "to surpass in staying power [v -ED, -ING, -S]\n",
  "OUTSTAYED": "OUTSTAY, to surpass in staying power [v]\n",
  "OUTSTAYING": "OUTSTAY, to surpass in staying power [v]\n",
  "OUTSTAYS": "OUTSTAY, to surpass in staying power [v]\n",
  "OUTSTEER": "to surpass in steering [v -ED, -ING, -S]\n",
  "OUTSTEERED": "OUTSTEER, to surpass in steering [v]\n",
  "OUTSTEERING": "OUTSTEER, to surpass in steering [v]\n",
  "OUTSTEERS": "OUTSTEER, to surpass in steering [v]\n",
  "OUTSTEP": "to step beyond [v OUTSTEPPED, OUTSTEPPING, OUTSTEPS]\n",
  "OUTSTEPPED": "OUTSTEP, to step beyond [v]\n",
  "OUTSTEPPING": "OUTSTEP, to step beyond [v]\n",
  "OUTSTEPS": "OUTSTEP, to step beyond [v]\n",
  "OUTSTOOD": "OUTSTAND, to stand out, or project, from a surface or mass [v]\n",
  "OUTSTRAIN": "to surpass in straining [v -ED, -ING, -S]\n",
  "OUTSTRAINED": "OUTSTRAIN, to surpass in straining [v]\n",
  "OUTSTRAINING": "OUTSTRAIN, to surpass in straining [v]\n",
  "OUTSTRAINS": "OUTSTRAIN, to surpass in straining [v]\n",
  "OUTSTRETCH": "to stretch out [v -ED, -ING, -ES]\n",
  "OUTSTRETCHED": "OUTSTRETCH, to stretch out [v]\n",
  "OUTSTRETCHES": "OUTSTRETCH, to stretch out [v]\n",
  "OUTSTRETCHING": "OUTSTRETCH, to stretch out [v]\n",
  "OUTSTRIDDEN": "OUTSTRIDE, to surpass in striding [v]\n",
  "OUTSTRIDE": "to surpass in striding [v OUTSTRODE or OUTSTRIDED, OUTSTRIDDEN, OUTSTRIDING, OUTSTRIDES]\n",
  "OUTSTRIDED": "OUTSTRIDE, to surpass in striding [v]\n",
  "OUTSTRIDES": "OUTSTRIDE, to surpass in striding [v]\n",
  "OUTSTRIDING": "OUTSTRIDE, to surpass in striding [v]\n",
  "OUTSTRIKE": "to outdo in striking [v OUTSTRUCK, OUTSTRIKING, OUTSTRIKES]\n",
  "OUTSTRIKES": "OUTSTRIKE, to outdo in striking [v]\n",
  "OUTSTRIKING": "OUTSTRIKE, to outdo in striking [v]\n",
  "OUTSTRIP": "to go faster or further than [v OUTSTRIPPED, OUTSTRIPPING, OUTSTRIPS]\n",
  "OUTSTRIPPED": "OUTSTRIP, to go faster or further than [v]\n",
  "OUTSTRIPPING": "OUTSTRIP, to go faster or further than [v]\n",
  "OUTSTRIPS": "OUTSTRIP, to go faster or further than [v]\n",
  "OUTSTRIVE": "to surpass in striving [v OUTSTROVE, OUTSTRIVEN, OUTSTRIVING, OUTSTRIVES]\n",
  "OUTSTRIVEN": "OUTSTRIVE, to surpass in striving [v]\n",
  "OUTSTRIVES": "OUTSTRIVE, to surpass in striving [v]\n",
  "OUTSTRIVING": "OUTSTRIVE, to surpass in striving [v]\n",
  "OUTSTRODE": "OUTSTRIDE, to surpass in striding [v]\n",
  "OUTSTROKE": "an outward stroke [n -S]\n",
  "OUTSTROKES": "OUTSTROKE, an outward stroke [n]\n",
  "OUTSTROVE": "OUTSTRIVE, to surpass in striving [v]\n",
  "OUTSTRUCK": "OUTSTRIKE, to outdo in striking [v]\n",
  "OUTSTUDIED": "OUTSTUDY, to surpass in studying [v]\n",
  "OUTSTUDIES": "OUTSTUDY, to surpass in studying [v]\n",
  "OUTSTUDY": "to surpass in studying [v OUTSTUDIED, OUTSTUDYING, OUTSTUDIES]\n",
  "OUTSTUDYING": "OUTSTUDY, to surpass in studying [v]\n",
  "OUTSTUNT": "to surpass in stunting [v -ED, -ING, -S]\n",
  "OUTSTUNTED": "OUTSTUNT, to surpass in stunting [v]\n",
  "OUTSTUNTING": "OUTSTUNT, to surpass in stunting [v]\n",
  "OUTSTUNTS": "OUTSTUNT, to surpass in stunting [v]\n",
  "OUTSULK": "to surpass in sulking [v -ED, -ING, -S]\n",
  "OUTSULKED": "OUTSULK, to surpass in sulking [v]\n",
  "OUTSULKING": "OUTSULK, to surpass in sulking [v]\n",
  "OUTSULKS": "OUTSULK, to surpass in sulking [v]\n",
  "OUTSUM": "to outnumber [v OUTSUMMED, OUTSUMMING, OUTSUMS]\n",
  "OUTSUMMED": "OUTSUM, to outnumber [v]\n",
  "OUTSUMMING": "OUTSUM, to outnumber [v]\n",
  "OUTSUMS": "OUTSUM, to outnumber [v]\n",
  "OUTSUNG": "OUTSING, to surpass in singing [v]\n",
  "OUTSWAM": "OUTSWIM, to swim faster or further than [v]\n",
  "OUTSWARE": "OUTSWEAR, to surpass in swearing [v]\n",
  "OUTSWEAR": "to surpass in swearing [v OUTSWARE or OUTSWORE, OUTSWORN, OUTSWEARING, OUTSWEARS]\n",
  "OUTSWEARING": "OUTSWEAR, to surpass in swearing [v]\n",
  "OUTSWEARS": "OUTSWEAR, to surpass in swearing [v]\n",
  "OUTSWEEP": "to surpass in sweeping [v OUTSWEPT, OUTSWEEPING, OUTSWEEPS]\n",
  "OUTSWEEPING": "OUTSWEEP, to surpass in sweeping [v]\n",
  "OUTSWEEPS": "OUTSWEEP, to surpass in sweeping [v]\n",
  "OUTSWEETEN": "to surpass in sweetness [v -ED, -ING, -S]\n",
  "OUTSWEETENED": "OUTSWEETEN, to surpass in sweetness [v]\n",
  "OUTSWEETENING": "OUTSWEETEN, to surpass in sweetness [v]\n",
  "OUTSWEETENS": "OUTSWEETEN, to surpass in sweetness [v]\n",
  "OUTSWELL": "to exceed in swelling [v OUTSWELLED, OUTSWOLLEN, OUTSWELLING, OUTSWELLS]\n",
  "OUTSWELLED": "OUTSWELL, to exceed in swelling [v]\n",
  "OUTSWELLING": "OUTSWELL, to exceed in swelling [v]\n",
  "OUTSWELLS": "OUTSWELL, to exceed in swelling [v]\n",
  "OUTSWEPT": "OUTSWEEP, to surpass in sweeping [v]\n",
  "OUTSWIM": "to swim faster or further than [v OUTSWAM or OUTSWUM, OUTSWUM, OUTSWIMMING, OUTSWIMS]\n",
  "OUTSWIMMING": "OUTSWIM, to swim faster or further than [v]\n",
  "OUTSWIMS": "OUTSWIM, to swim faster or further than [v]\n",
  "OUTSWING": "an outward swing of a ball [n -S] / to cause a ball to swing outward [v OUTSWUNG, OUTSWINGING, OUTSWINGS]\n",
  "OUTSWINGER": "a ball in cricket that swings outwards [n -S]\n",
  "OUTSWINGERS": "OUTSWINGER, a ball in cricket that swings outwards [n]\n",
  "OUTSWINGING": "OUTSWING, to cause a ball to swing outward [v]\n",
  "OUTSWINGS": "OUTSWING, an outward swing of a ball [n]\n",
  "OUTSWOLLEN": "OUTSWELL, to exceed in swelling [v]\n",
  "OUTSWORE": "OUTSWEAR, to surpass in swearing [v]\n",
  "OUTSWORN": "OUTSWEAR, to surpass in swearing [v]\n",
  "OUTSWUM": "OUTSWIM, to swim faster or further than [v]\n",
  "OUTSWUNG": "OUTSWING, to cause a ball to swing outward [v]\n",
  "OUTTA": "an informal contraction of out of, also OUTA [prep]\n",
  "OUTTAKE": "to take out, except [v OUTTOOK, OUTTAKEN, OUTTAKING, OUTTAKES]\n",
  "OUTTAKEN": "OUTTAKE, to take out, except [v]\n",
  "OUTTAKES": "OUTTAKE, to take out, except [v]\n",
  "OUTTAKING": "OUTTAKE, to take out, except [v]\n",
  "OUTTALK": "to surpass in talking [v -ED, -ING, -S]\n",
  "OUTTALKED": "OUTTALK, to surpass in talking [v]\n",
  "OUTTALKING": "OUTTALK, to surpass in talking [v]\n",
  "OUTTALKS": "OUTTALK, to surpass in talking [v]\n",
  "OUTTASK": "to surpass in tasking [v -ED, -ING, -S]\n",
  "OUTTASKED": "OUTTASK, to surpass in tasking [v]\n",
  "OUTTASKING": "OUTTASK, to surpass in tasking [v]\n",
  "OUTTASKS": "OUTTASK, to surpass in tasking [v]\n",
  "OUTTELL": "to say openly [v OUTTOLD, OUTTELLING, OUTTELLS]\n",
  "OUTTELLING": "OUTTELL, to say openly [v]\n",
  "OUTTELLS": "OUTTELL, to say openly [v]\n",
  "OUTTHANK": "to surpass in thanking [v -ED, -ING, -S]\n",
  "OUTTHANKED": "OUTTHANK, to surpass in thanking [v]\n",
  "OUTTHANKING": "OUTTHANK, to surpass in thanking [v]\n",
  "OUTTHANKS": "OUTTHANK, to surpass in thanking [v]\n",
  "OUTTHIEVE": "to surpass at thieving [v OUTTHIEVED, OUTTHIEVING, OUTTHIEVES]\n",
  "OUTTHIEVED": "OUTTHIEVE, to surpass at thieving [v]\n",
  "OUTTHIEVES": "OUTTHIEVE, to surpass at thieving [v]\n",
  "OUTTHIEVING": "OUTTHIEVE, to surpass at thieving [v]\n",
  "OUTTHINK": "to surpass in thinking [v OUTTHOUGHT, OUTTHINKING, OUTTHINKS]\n",
  "OUTTHINKING": "OUTTHINK, to surpass in thinking [v]\n",
  "OUTTHINKS": "OUTTHINK, to surpass in thinking [v]\n",
  "OUTTHOUGHT": "OUTTHINK, to surpass in thinking [v]\n",
  "OUTTHREW": "OUTTHROW, to throw farther than [v]\n",
  "OUTTHROB": "to surpass in throbbing [v OUTTHROBBED, OUTTHROBBING, OUTTHROBS]\n",
  "OUTTHROBBED": "OUTTHROB, to surpass in throbbing [v]\n",
  "OUTTHROBBING": "OUTTHROB, to surpass in throbbing [v]\n",
  "OUTTHROBS": "OUTTHROB, to surpass in throbbing [v]\n",
  "OUTTHROW": "to throw farther than [v OUTTHREW, OUTTHROWN, OUTTHROWING, OUTTHROWS]\n",
  "OUTTHROWING": "OUTTHROW, to throw farther than [v]\n",
  "OUTTHROWN": "OUTTHROW, to throw farther than [v]\n",
  "OUTTHROWS": "OUTTHROW, to throw farther than [v]\n",
  "OUTTHRUST": "to extend outwards [v -ED, -ING, -S]\n",
  "OUTTHRUSTED": "OUTTHRUST, to extend outwards [v]\n",
  "OUTTHRUSTING": "OUTTHRUST, to extend outwards [v]\n",
  "OUTTHRUSTS": "OUTTHRUST, to extend outwards [v]\n",
  "OUTTOLD": "OUTTELL, to say openly [v]\n",
  "OUTTONGUE": "(Shakespeare) to speak louder than [v OUTTONGUED, OUTTONGUING, OUTTONGUES]\n",
  "OUTTONGUED": "OUTTONGUE, (Shakespeare) to speak louder than [v]\n",
  "OUTTONGUES": "OUTTONGUE, (Shakespeare) to speak louder than [v]\n",
  "OUTTONGUING": "OUTTONGUE, (Shakespeare) to speak louder than [v]\n",
  "OUTTOOK": "OUTTAKE, to take out, except [v]\n",
  "OUTTOP": "to overtop [v OUTTOPPED, OUTTOPPING, OUTTOPS]\n",
  "OUTTOPPED": "OUTTOP, to overtop [v]\n",
  "OUTTOPPING": "OUTTOP, to overtop [v]\n",
  "OUTTOPS": "OUTTOP, to overtop [v]\n",
  "OUTTOWER": "to tower above [v -ED, -ING, -S]\n",
  "OUTTOWERED": "OUTTOWER, to tower above [v]\n",
  "OUTTOWERING": "OUTTOWER, to tower above [v]\n",
  "OUTTOWERS": "OUTTOWER, to tower above [v]\n",
  "OUTTRADE": "to get the better of in a trade [v OUTTRADED, OUTTRADING, OUTTRADES]\n",
  "OUTTRADED": "OUTTRADE, to get the better of in a trade [v]\n",
  "OUTTRADES": "OUTTRADE, to get the better of in a trade [v]\n",
  "OUTTRADING": "OUTTRADE, to get the better of in a trade [v]\n",
  "OUTTRAVEL": "to exceed in speed or distance traveled [v OUTTRAVELLED or OUTTRAVELED, OUTTRAVELLING or OUTTRAVELING, OUTTRAVELS]\n",
  "OUTTRAVELED": "OUTTRAVEL, to exceed in speed or distance traveled [v]\n",
  "OUTTRAVELING": "OUTTRAVEL, to exceed in speed or distance traveled [v]\n",
  "OUTTRAVELLED": "OUTTRAVEL, to exceed in speed or distance traveled [v]\n",
  "OUTTRAVELLING": "OUTTRAVEL, to exceed in speed or distance traveled [v]\n",
  "OUTTRAVELS": "OUTTRAVEL, to exceed in speed or distance traveled [v]\n",
  "OUTTRICK": "to get the better of by trickery [v -ED, -ING, -S]\n",
  "OUTTRICKED": "OUTTRICK, to get the better of by trickery [v]\n",
  "OUTTRICKING": "OUTTRICK, to get the better of by trickery [v]\n",
  "OUTTRICKS": "OUTTRICK, to get the better of by trickery [v]\n",
  "OUTTROT": "to surpass in trotting [v OUTTROTTED, OUTTROTTING, OUTTROTS]\n",
  "OUTTROTS": "OUTTROT, to surpass in trotting [v]\n",
  "OUTTROTTED": "OUTTROT, to surpass in trotting [v]\n",
  "OUTTROTTING": "OUTTROT, to surpass in trotting [v]\n",
  "OUTTRUMP": "to surpass in trumping [v -ED, -ING, -S]\n",
  "OUTTRUMPED": "OUTTRUMP, to surpass in trumping [v]\n",
  "OUTTRUMPING": "OUTTRUMP, to surpass in trumping [v]\n",
  "OUTTRUMPS": "OUTTRUMP, to surpass in trumping [v]\n",
  "OUTTURN": "a quantity produced [n -S]\n",
  "OUTTURNS": "OUTTURN, a quantity produced [n]\n",
  "OUTVALUE": "to be worth more than [v OUTVALUED, OUTVALUING, OUTVALUES]\n",
  "OUTVALUED": "OUTVALUE, to be worth more than [v]\n",
  "OUTVALUES": "OUTVALUE, to be worth more than [v]\n",
  "OUTVALUING": "OUTVALUE, to be worth more than [v]\n",
  "OUTVAUNT": "to surpass in vaunting [v -ED, -ING, -S]\n",
  "OUTVAUNTED": "OUTVAUNT, to surpass in vaunting [v]\n",
  "OUTVAUNTING": "OUTVAUNT, to surpass in vaunting [v]\n",
  "OUTVAUNTS": "OUTVAUNT, to surpass in vaunting [v]\n",
  "OUTVENOM": "(Shakespeare) to exceed in venom [v -ED, -ING, -S]\n",
  "OUTVENOMED": "OUTVENOM, (Shakespeare) to exceed in venom [v]\n",
  "OUTVENOMING": "OUTVENOM, (Shakespeare) to exceed in venom [v]\n",
  "OUTVENOMS": "OUTVENOM, (Shakespeare) to exceed in venom [v]\n",
  "OUTVIE": "to surpass in competition [v OUTVIED, OUTVYING, OUTVIES]\n",
  "OUTVIED": "OUTVIE, to surpass in competition [v]\n",
  "OUTVIES": "OUTVIE, to surpass in competition [v]\n",
  "OUTVILLAIN": "(Shakespeare) to exceed in villainy [v -ED, -ING, -S]\n",
  "OUTVILLAINED": "OUTVILLAIN, (Shakespeare) to exceed in villainy [v]\n",
  "OUTVILLAINING": "OUTVILLAIN, (Shakespeare) to exceed in villainy [v]\n",
  "OUTVILLAINS": "OUTVILLAIN, (Shakespeare) to exceed in villainy [v]\n",
  "OUTVOICE": "(Shakespeare) to surpass in loudness of voice [v OUTVOICED, OUTVOICING, OUTVOICES]\n",
  "OUTVOICED": "OUTVOICE, (Shakespeare) to surpass in loudness of voice [v]\n",
  "OUTVOICES": "OUTVOICE, (Shakespeare) to surpass in loudness of voice [v]\n",
  "OUTVOICING": "OUTVOICE, (Shakespeare) to surpass in loudness of voice [v]\n",
  "OUTVOTE": "to defeat by a majority of votes [v OUTVOTED, OUTVOTING, OUTVOTES]\n",
  "OUTVOTED": "OUTVOTE, to defeat by a majority of votes [v]\n",
  "OUTVOTER": "a voter from outside the electorate [n -S]\n",
  "OUTVOTERS": "OUTVOTER, a voter from outside the electorate [n]\n",
  "OUTVOTES": "OUTVOTE, to defeat by a majority of votes [v]\n",
  "OUTVOTING": "OUTVOTE, to defeat by a majority of votes [v]\n",
  "OUTVYING": "OUTVIE, to surpass in competition [v]\n",
  "OUTWAIT": "to exceed in patience [v -ED, -ING, -S]\n",
  "OUTWAITED": "OUTWAIT, to exceed in patience [v]\n",
  "OUTWAITING": "OUTWAIT, to exceed in patience [v]\n",
  "OUTWAITS": "OUTWAIT, to exceed in patience [v]\n",
  "OUTWALK": "to surpass in walking [v -ED, -ING, -S]\n",
  "OUTWALKED": "OUTWALK, to surpass in walking [v]\n",
  "OUTWALKING": "OUTWALK, to surpass in walking [v]\n",
  "OUTWALKS": "OUTWALK, to surpass in walking [v]\n",
  "OUTWAR": "to surpass in warring [v OUTWARRED, OUTWARRING, OUTWARS]\n",
  "OUTWARD": "toward the outside, also OUTWARDS [adv OUTWARDLY]\n",
  "OUTWARDLY": "OUTWARD, toward the outside, also OUTWARDS [adv]\n",
  "OUTWARDNESS": "the state of being outward [n -ES]\n",
  "OUTWARDNESSES": "OUTWARDNESS, the state of being outward [n]\n",
  "OUTWARDS": "towards the outside, also OUTWARD [adv]\n",
  "OUTWARRED": "OUTWAR, to surpass in warring [v]\n",
  "OUTWARRING": "OUTWAR, to surpass in warring [v]\n",
  "OUTWARS": "OUTWAR, to surpass in warring [v]\n",
  "OUTWASH": "detritus washed from a glacier [n -ES]\n",
  "OUTWASHES": "OUTWASH, detritus washed from a glacier [n]\n",
  "OUTWASTE": "to surpass in wasting [v OUTWASTED, OUTWASTING, OUTWASTES]\n",
  "OUTWASTED": "OUTWASTE, to surpass in wasting [v]\n",
  "OUTWASTES": "OUTWASTE, to surpass in wasting [v]\n",
  "OUTWASTING": "OUTWASTE, to surpass in wasting [v]\n",
  "OUTWATCH": "to watch longer than [v -ED, -ING, -ES]\n",
  "OUTWATCHED": "OUTWATCH, to watch longer than [v]\n",
  "OUTWATCHES": "OUTWATCH, to watch longer than [v]\n",
  "OUTWATCHING": "OUTWATCH, to watch longer than [v]\n",
  "OUTWEAR": "to last longer than [v OUTWORE, OUTWORN, OUTWEARING, OUTWEARS]\n",
  "OUTWEARIED": "OUTWEARY, to weary out [v]\n",
  "OUTWEARIES": "OUTWEARY, to weary out [v]\n",
  "OUTWEARING": "OUTWEAR, to last longer than [v]\n",
  "OUTWEARS": "OUTWEAR, to last longer than [v]\n",
  "OUTWEARY": "to weary out [v OUTWEARIED, OUTWEARYING, OUTWEARIES]\n",
  "OUTWEARYING": "OUTWEARY, to weary out [v]\n",
  "OUTWEED": "(Spenser) to root out [v -ED, -ING, -S]\n",
  "OUTWEEDED": "OUTWEED, (Spenser) to root out [v]\n",
  "OUTWEEDING": "OUTWEED, (Spenser) to root out [v]\n",
  "OUTWEEDS": "OUTWEED, (Spenser) to root out [v]\n",
  "OUTWEEP": "to weep more than [v OUTWEPT, OUTWEEPING, OUTWEEPS]\n",
  "OUTWEEPING": "OUTWEEP, to weep more than [v]\n",
  "OUTWEEPS": "OUTWEEP, to weep more than [v]\n",
  "OUTWEIGH": "to weigh more than [v -ED, -ING, -S]\n",
  "OUTWEIGHED": "OUTWEIGH, to weigh more than [v]\n",
  "OUTWEIGHING": "OUTWEIGH, to weigh more than [v]\n",
  "OUTWEIGHS": "OUTWEIGH, to weigh more than [v]\n",
  "OUTWELL": "to pour out [v -ED, -ING, -S]\n",
  "OUTWELLED": "OUTWELL, to pour out [v]\n",
  "OUTWELLING": "OUTWELL, to pour out [v]\n",
  "OUTWELLS": "OUTWELL, to pour out [v]\n",
  "OUTWENT": "OUTGO, to go beyond [v]\n",
  "OUTWEPT": "OUTWEEP, to weep more than [v]\n",
  "OUTWHIRL": "to surpass in whirling [v -ED, -ING, -S]\n",
  "OUTWHIRLED": "OUTWHIRL, to surpass in whirling [v]\n",
  "OUTWHIRLING": "OUTWHIRL, to surpass in whirling [v]\n",
  "OUTWHIRLS": "OUTWHIRL, to surpass in whirling [v]\n",
  "OUTWICK": "in the sport of curling, to strike the outside of another stone and send it within a circle [n -S] / to make such a stroke [v -ED, -ING, -S]\n",
  "OUTWICKED": "OUTWICK, to make such a stroke [v]\n",
  "OUTWICKING": "OUTWICK, to make such a stroke [v]\n",
  "OUTWICKS": "OUTWICK, to make such a stroke [v]\n",
  "OUTWILE": "to surpass in wiling [v OUTWILED, OUTWILING, OUTWILES]\n",
  "OUTWILED": "OUTWILE, to surpass in wiling [v]\n",
  "OUTWILES": "OUTWILE, to surpass in wiling [v]\n",
  "OUTWILING": "OUTWILE, to surpass in wiling [v]\n",
  "OUTWILL": "to surpass in willpower [v -ED, -ING, -S]\n",
  "OUTWILLED": "OUTWILL, to surpass in willpower [v]\n",
  "OUTWILLING": "OUTWILL, to surpass in willpower [v]\n",
  "OUTWILLS": "OUTWILL, to surpass in willpower [v]\n",
  "OUTWIN": "(Spenser) to win a way out of [v OUTWON, OUTWINNING, OUTWINS]\n",
  "OUTWIND": "to unwind [v OUTWOUND, OUTWINDING, OUTWINDS] / to make breathless [v OUTWINDED, OUTWINDING, OUTWINDS]\n",
  "OUTWINDED": "OUTWIND, to unwind [v]\n",
  "OUTWINDING": "OUTWIND, to unwind [v]\n",
  "OUTWINDS": "OUTWIND, to unwind [v]\n",
  "OUTWING": "to fly beyond [v -ED, -ING, -S]\n",
  "OUTWINGED": "OUTWING, to fly beyond [v]\n",
  "OUTWINGING": "OUTWING, to fly beyond [v]\n",
  "OUTWINGS": "OUTWING, to fly beyond [v]\n",
  "OUTWINNING": "OUTWIN, (Spenser) to win a way out of [v]\n",
  "OUTWINS": "OUTWIN, (Spenser) to win a way out of [v]\n",
  "OUTWISH": "to surpass in wishing [v -ED, -ING, -ES]\n",
  "OUTWISHED": "OUTWISH, to surpass in wishing [v]\n",
  "OUTWISHES": "OUTWISH, to surpass in wishing [v]\n",
  "OUTWISHING": "OUTWISH, to surpass in wishing [v]\n",
  "OUTWIT": "to defeat by superior ingenuity [v OUTWITTED, OUTWITTING, OUTWITS]\n",
  "OUTWITH": "(Scots) outside of [adv]\n",
  "OUTWITS": "OUTWIT, to defeat by superior ingenuity [v]\n",
  "OUTWITTED": "OUTWIT, to defeat by superior ingenuity [v]\n",
  "OUTWITTING": "OUTWIT, to defeat by superior ingenuity [v]\n",
  "OUTWON": "OUTWIN, (Spenser) to win a way out of [v]\n",
  "OUTWORE": "OUTWEAR, to last longer than [v]\n",
  "OUTWORK": "to work faster than [v OUTWROUGHT or OUTWORKED, OUTWORKING, OUTWORKS]\n",
  "OUTWORKED": "OUTWORK, to work faster than [v]\n",
  "OUTWORKER": "one who works away from a factory, office etc. [n -S]\n",
  "OUTWORKERS": "OUTWORKER, one who works away from a factory, office etc. [n]\n",
  "OUTWORKING": "OUTWORK, to work faster than [v]\n",
  "OUTWORKS": "OUTWORK, to work faster than [v]\n",
  "OUTWORN": "OUTWEAR, to last longer than [v]\n",
  "OUTWORTH": "(Shakespeare) to exceed in worth [v -ED, -ING, -S]\n",
  "OUTWORTHED": "OUTWORTH, (Shakespeare) to exceed in worth [v]\n",
  "OUTWORTHING": "OUTWORTH, (Shakespeare) to exceed in worth [v]\n",
  "OUTWORTHS": "OUTWORTH, (Shakespeare) to exceed in worth [v]\n",
  "OUTWOUND": "OUTWIND, to unwind [v]\n",
  "OUTWREST": "(Spenser) to extort [v -ED, -ING, -S]\n",
  "OUTWRESTED": "OUTWREST, (Spenser) to extort [v]\n",
  "OUTWRESTING": "OUTWREST, (Spenser) to extort [v]\n",
  "OUTWRESTLE": "to surpass in wrestle [v OUTWRESTLED, OUTWRESTLING, OUTWRESTLES]\n",
  "OUTWRESTLED": "OUTWRESTLE, to surpass in wrestle [v]\n",
  "OUTWRESTLES": "OUTWRESTLE, to surpass in wrestle [v]\n",
  "OUTWRESTLING": "OUTWRESTLE, to surpass in wrestle [v]\n",
  "OUTWRESTS": "OUTWREST, (Spenser) to extort [v]\n",
  "OUTWRIT": "OUTWRITE, to write better than [v]\n",
  "OUTWRITE": "to write better than [v OUTWROTE, OUTWRIT or OUTWRITTEN, OUTWRITING, OUTWRITES]\n",
  "OUTWRITES": "OUTWRITE, to write better than [v]\n",
  "OUTWRITING": "OUTWRITE, to write better than [v]\n",
  "OUTWRITTEN": "OUTWRITE, to write better than [v]\n",
  "OUTWROTE": "OUTWRITE, to write better than [v]\n",
  "OUTWROUGHT": "OUTWORK, to work faster than [v]\n",
  "OUTYELL": "to yell louder than [v -ED, -ING, -S]\n",
  "OUTYELLED": "OUTYELL, to yell louder than [v]\n",
  "OUTYELLING": "OUTYELL, to yell louder than [v]\n",
  "OUTYELLS": "OUTYELL, to yell louder than [v]\n",
  "OUTYELP": "to surpass in yelping [v -ED, -ING, -S]\n",
  "OUTYELPED": "OUTYELP, to surpass in yelping [v]\n",
  "OUTYELPING": "OUTYELP, to surpass in yelping [v]\n",
  "OUTYELPS": "OUTYELP, to surpass in yelping [v]\n",
  "OUTYIELD": "to surpass in yielding [v -ED, -ING, -S]\n",
  "OUTYIELDED": "OUTYIELD, to surpass in yielding [v]\n",
  "OUTYIELDING": "OUTYIELD, to surpass in yielding [v]\n",
  "OUTYIELDS": "OUTYIELD, to surpass in yielding [v]\n",
  "OUVERT": "(French) open, also OUVERTE [adj]\n",
  "OUVERTE": "(French) open, also OUVERT [adj]\n",
  "OUVIRANDRA": "(Malagasy) a water-plant of Madagascar, aka lattice-leaf [n -S]\n",
  "OUVIRANDRAS": "OUVIRANDRA, (Malagasy) a water-plant of Madagascar, aka lattice-leaf [n]\n",
  "OUVRAGE": "(French) work [n -S]\n",
  "OUVRAGES": "OUVRAGE, (French) work [n]\n",
  "OUVRIER": "(French) a (male) manual or industrial worker, also OUVRIERE [n -S]\n",
  "OUVRIERE": "(French) a (female) manual or industrial worker, also OUVRIER [n -S]\n",
  "OUVRIERES": "OUVRIERE, (French) a (female) manual or industrial worker, also OUVRIER [n]\n",
  "OUVRIERS": "OUVRIER, (French) a (male) manual or industrial worker, also OUVRIERE [n]\n",
  "OUZEL": "a European bird of the thrush family, also OUSEL, WOOSEL, WOOSELL [n -S]\n",
  "OUZELS": "OUZEL, a European bird of the thrush family, also OUSEL, WOOSEL, WOOSELL [n]\n",
  "OUZO": "(Modern Greek) an aniseed-flavored Greek liqueur [n -S]\n",
  "OUZOS": "OUZO, (Modern Greek) an aniseed-flavored Greek liqueur [n]\n",
  "OVA": "OVUM, the female reproductive cell [n]\n",
  "OVAL": "egg-shaped [adj OVALLY] / an oval (egg-shaped) figure or object [n -S]\n",
  "OVALBUMIN": "the albumin in egg-whites [n -S]\n",
  "OVALBUMINS": "OVALBUMIN, the albumin in egg-whites [n]\n",
  "OVALITIES": "OVALITY, the state of being oval [n]\n",
  "OVALITY": "the state of being oval [n OVALITIES]\n",
  "OVALLY": "OVAL, egg-shaped [adv]\n",
  "OVALNESS": "the state of being oval [n -ES]\n",
  "OVALNESSES": "OVALNESS, the state of being oval [n]\n",
  "OVALS": "OVAL, an oval (egg-shaped) figure or object [n]\n",
  "OVARIAL": "pertaining to an ovary, also OVARIAN [adj]\n",
  "OVARIAN": "pertaining to an ovary, also OVARIAL [adj]\n",
  "OVARIECTOMIES": "OVARIECTOMY, the surgical removal of the ovaries [n]\n",
  "OVARIECTOMISED": "having undergone an ovariectomy, the surgical removal of the ovaries, also OVARIECTOMIZED [adj]\n",
  "OVARIECTOMIZED": "having undergone an ovariectomy, the surgical removal of the ovaries, also OVARIECTOMISED [adj]\n",
  "OVARIECTOMY": "the surgical removal of the ovaries [n OVARIECTOMIES]\n",
  "OVARIES": "OVARY, a female reproduction gland [n]\n",
  "OVARIOLE": "one of the egg-tubes forming an insect's ovary [n -S]\n",
  "OVARIOLES": "OVARIOLE, one of the egg-tubes forming an insect's ovary [n]\n",
  "OVARIOTOMIES": "OVARIOTOMY, the operation of removing one or both of the ovaries, aka oophorectomy [n]\n",
  "OVARIOTOMIST": "one who carries out ovariotomies [n -S]\n",
  "OVARIOTOMISTS": "OVARIOTOMIST, one who carries out ovariotomies [n]\n",
  "OVARIOTOMY": "the operation of removing one or both of the ovaries, aka oophorectomy [n OVARIOTOMIES]\n",
  "OVARIOUS": "consisting of eggs [adj]\n",
  "OVARITIDES": "OVARITIS, inflammation of an ovary [n]\n",
  "OVARITIS": "inflammation of an ovary [n OVARITISES or OVARITIDES]\n",
  "OVARITISES": "OVARITIS, inflammation of an ovary [n]\n",
  "OVARY": "a female reproduction gland [n OVARIES]\n",
  "OVATE": "egg-shaped [adj OVATELY] / to receive with an ovation [v OVATED, OVATING, OVATES]\n",
  "OVATED": "OVATE, to receive with an ovation [v]\n",
  "OVATELY": "OVATE, egg-shaped [adv]\n",
  "OVATES": "OVATE, to receive with an ovation [v]\n",
  "OVATING": "OVATE, to receive with an ovation [v]\n",
  "OVATION": "a demonstration of popular acclaim [n -S]\n",
  "OVATIONAL": "relating to ovation, an outburst of popular applause [adj]\n",
  "OVATIONS": "OVATION, a demonstration of popular acclaim [n]\n",
  "OVATOR": "one who gives an ovation [n -S]\n",
  "OVATORS": "OVATOR, one who gives an ovation [n]\n",
  "OVEL": "(Hebrew) a mourner esp. during the first seven days after a death, also AVEL [n -S]\n",
  "OVELS": "OVEL, (Hebrew) a mourner esp. during the first seven days after a death, also AVEL [n]\n",
  "OVEN": "a closed space for baking [n -S] / to cook in an oven [v -ED, -ING, -S]\n",
  "OVENABLE": "able to be cooked in an oven [adj]\n",
  "OVENBIRD": "an American songbird [n -S]\n",
  "OVENBIRDS": "OVENBIRD, an American songbird [n]\n",
  "OVENED": "OVEN, to cook in an oven [v]\n",
  "OVENING": "OVEN, to cook in an oven [v]\n",
  "OVENLIKE": "like an oven [adj]\n",
  "OVENPROOF": "resistant to the heat of an oven [adj]\n",
  "OVENS": "OVEN, to cook in an oven [v]\n",
  "OVENWARE": "heat-resistant baking dishes [n -S]\n",
  "OVENWARES": "OVENWARE, heat-resistant baking dishes [n]\n",
  "OVENWOOD": "brushwood [n -S]\n",
  "OVENWOODS": "OVENWOOD, brushwood [n]\n",
  "OVER": "above, in excess, also OWER, OWRE [adj OVERLY] / to go, leap or vault over [v -ED, -ING, -S]\n",
  "OVERABLE": "excessively able [adj]\n",
  "OVERABOUND": "to be exceedingly plenty [v -ED, -ING, -S]\n",
  "OVERABOUNDED": "OVERABOUND, to be exceedingly plenty [v]\n",
  "OVERABOUNDING": "OVERABOUND, to be exceedingly plenty [v]\n",
  "OVERABOUNDS": "OVERABOUND, to be exceedingly plenty [v]\n",
  "OVERABSTRACT": "excessively abstract [adj]\n",
  "OVERABUNDANCE": "an excessive abundance [n -S]\n",
  "OVERABUNDANCES": "OVERABUNDANCE, an excessive abundance [n]\n",
  "OVERABUNDANT": "excessively abundant [adj]\n",
  "OVERACCENTUATE": "to accentuate excessively [v OVERACCENTUATED, OVERACCENTUATES]\n",
  "OVERACCENTUATED": "OVERACCENTUATE, to accentuate excessively [v]\n",
  "OVERACCENTUATES": "OVERACCENTUATE, to accentuate excessively [v]\n",
  "OVERACHIEVE": "to achieve to excess [v OVERACHIEVED, OVERACHIEVING, OVERACHIEVES]\n",
  "OVERACHIEVED": "OVERACHIEVE, to achieve to excess [v]\n",
  "OVERACHIEVEMENT": "excessive achievement [n]\n",
  "OVERACHIEVER": "one who achieves success over and above the standard or expected level esp. at an early age [n -S]\n",
  "OVERACHIEVERS": "OVERACHIEVER, one who achieves success over and above the standard or expected level esp. at an early age [n]\n",
  "OVERACHIEVES": "OVERACHIEVE, to achieve to excess [v]\n",
  "OVERACHIEVING": "OVERACHIEVE, to achieve to excess [v]\n",
  "OVERACT": "to act with exaggeration [v -ED, -ING, -S]\n",
  "OVERACTED": "OVERACT, to act with exaggeration [v]\n",
  "OVERACTING": "OVERACT, to act with exaggeration [v]\n",
  "OVERACTION": "exaggerated or excessive action [n -S]\n",
  "OVERACTIONS": "OVERACTION, exaggerated or excessive action [n]\n",
  "OVERACTIVE": "excessively or abnormally active [adj]\n",
  "OVERACTIVITIES": "OVERACTIVITY, excessive activity [n]\n",
  "OVERACTIVITY": "excessive activity [n OVERACTIVITIES]\n",
  "OVERACTS": "OVERACT, to act with exaggeration [v]\n",
  "OVERACUTE": "too acute [adj]\n",
  "OVERADJUSTMENT": "an excessive adjustment [n -S]\n",
  "OVERADJUSTMENTS": "OVERADJUSTMENT, an excessive adjustment [n]\n",
  "OVERADVERTISE": "to advertise to excess, also OVERADVERTIZE [v OVERADVERTISED, OVERADVERTISING, OVERADVERTISES]\n",
  "OVERADVERTISED": "OVERADVERTISE, to advertise to excess, also OVERADVERTIZE [v]\n",
  "OVERADVERTISES": "OVERADVERTISE, to advertise to excess, also OVERADVERTIZE [v]\n",
  "OVERADVERTISING": "OVERADVERTISE, to advertise to excess, also OVERADVERTIZE [v]\n",
  "OVERADVERTIZE": "to advertise to excess, also OVERADVERTISE [v OVERADVERTIZED, OVERADVERTIZING, OVERADVERTIZES]\n",
  "OVERADVERTIZED": "OVERADVERTIZE, to advertise to excess, also OVERADVERTISE [v]\n",
  "OVERADVERTIZES": "OVERADVERTIZE, to advertise to excess, also OVERADVERTISE [v]\n",
  "OVERADVERTIZING": "OVERADVERTIZE, to advertise to excess, also OVERADVERTISE [v]\n",
  "OVERAGE": "an excess, a surplus [n -S]\n",
  "OVERAGED": "too old to be useful [adj]\n",
  "OVERAGES": "OVERAGE, an excess, a surplus [n]\n",
  "OVERAGGRESSIVE": "excessively aggressive [adj]\n",
  "OVERALERT": "excessively alert [adj]\n",
  "OVERALL": "a loose coverall [n -S]\n",
  "OVERALLED": "wearing overalls [adj]\n",
  "OVERALLS": "OVERALL, a loose coverall [n]\n",
  "OVERAMBITIOUS": "excessively ambitious [adj]\n",
  "OVERAMPLIFIED": "excessively amplified [adj]\n",
  "OVERANALYSE": "to analyse excessively, also OVERANALYZE [v OVERANALYSED, OVERANALYSING, OVERANALYSES]\n",
  "OVERANALYSED": "OVERANALYSE, to analyse excessively, also OVERANALYZE [v]\n",
  "OVERANALYSES": "OVERANALYSE, to analyse excessively, also OVERANALYZE [v]\n",
  "OVERANALYSING": "OVERANALYSE, to analyse excessively, also OVERANALYZE [v]\n",
  "OVERANALYSIS": "excessive analysis [n OVERANALYSES]\n",
  "OVERANALYTICAL": "excessively analytical [adj]\n",
  "OVERANALYZE": "to analyze excessively, also OVERANALYSE [v OVERANALYZED, OVERANALYZING, OVERANALYZES]\n",
  "OVERANALYZED": "OVERANALYZE, to analyze excessively, also OVERANALYSE [v]\n",
  "OVERANALYZES": "OVERANALYZE, to analyze excessively, also OVERANALYSE [v]\n",
  "OVERANALYZING": "OVERANALYZE, to analyze excessively, also OVERANALYSE [v]\n",
  "OVERANXIETIES": "OVERANXIETY, excessive anxiety [n]\n",
  "OVERANXIETY": "excessive anxiety [n OVERANXIETIES]\n",
  "OVERANXIOUS": "excessively anxious [adj]\n",
  "OVERAPPLICATION": "excessive application [n]\n",
  "OVERAPT": "excessively apt [adj]\n",
  "OVERARCH": "to form an arch over [v -ED, -ING, -ES]\n",
  "OVERARCHED": "OVERARCH, to form an arch over [v]\n",
  "OVERARCHES": "OVERARCH, to form an arch over [v]\n",
  "OVERARCHING": "OVERARCH, to form an arch over [v]\n",
  "OVERARM": "done with the arm above the shoulder [adj] / to throw a ball overarm [v -ED, -ING, -S]\n",
  "OVERARMED": "OVERARM, to throw a ball overarm [v]\n",
  "OVERARMING": "OVERARM, to throw a ball overarm [v]\n",
  "OVERARMS": "OVERARM, to throw a ball overarm [v]\n",
  "OVERAROUSAL": "excessive arousal [n -S]\n",
  "OVERAROUSALS": "OVERAROUSAL, excessive arousal [n]\n",
  "OVERARRANGE": "to arrange to excess [v OVERARRANGED, OVERARRANGING, OVERARRANGES]\n",
  "OVERARRANGED": "OVERARRANGE, to arrange to excess [v]\n",
  "OVERARRANGES": "OVERARRANGE, to arrange to excess [v]\n",
  "OVERARRANGING": "OVERARRANGE, to arrange to excess [v]\n",
  "OVERARTICULATE": "to articulate excessively [v OVERARTICULATED, OVERARTICULATES]\n",
  "OVERARTICULATED": "OVERARTICULATE, to articulate excessively [v]\n",
  "OVERARTICULATES": "OVERARTICULATE, to articulate excessively [v]\n",
  "OVERASSERT": "to assert to excess [v -ED, -ING, -S]\n",
  "OVERASSERTED": "OVERASSERT, to assert to excess [v]\n",
  "OVERASSERTING": "OVERASSERT, to assert to excess [v]\n",
  "OVERASSERTION": "an excessive assertion [n -S]\n",
  "OVERASSERTIONS": "OVERASSERTION, an excessive assertion [n]\n",
  "OVERASSERTIVE": "excessively assertive [adj]\n",
  "OVERASSERTS": "OVERASSERT, to assert to excess [v]\n",
  "OVERASSESSMENT": "excessive assessment [n -S]\n",
  "OVERASSESSMENTS": "OVERASSESSMENT, excessive assessment [n]\n",
  "OVERATE": "OVEREAT, to eat to excess [v]\n",
  "OVERATTENTION": "excessive attention [n -S]\n",
  "OVERATTENTIONS": "OVERATTENTION, excessive attention [n]\n",
  "OVERATTENTIVE": "excessively attentive [adj]\n",
  "OVERAWE": "to subdue by inspiring awe [v OVERAWED, OVERAWING, OVERAWES]\n",
  "OVERAWED": "OVERAWE, to subdue by inspiring awe [v]\n",
  "OVERAWES": "OVERAWE, to subdue by inspiring awe [v]\n",
  "OVERAWING": "OVERAWE, to subdue by inspiring awe [v]\n",
  "OVERBAKE": "to bake too long [v OVERBAKED, OVERBAKING, OVERBAKES]\n",
  "OVERBAKED": "OVERBAKE, to bake too long [v]\n",
  "OVERBAKES": "OVERBAKE, to bake too long [v]\n",
  "OVERBAKING": "OVERBAKE, to bake too long [v]\n",
  "OVERBALANCE": "to topple over [v OVERBALANCED, OVERBALANCING, OVERBALANCES]\n",
  "OVERBALANCED": "OVERBALANCE, to topple over [v]\n",
  "OVERBALANCES": "OVERBALANCE, to topple over [v]\n",
  "OVERBALANCING": "OVERBALANCE, to topple over [v]\n",
  "OVERBANK": "a stage of a river where it overflows its bank [n -S]\n",
  "OVERBANKS": "OVERBANK, a stage of a river where it overflows its bank [n]\n",
  "OVERBEAR": "to bring down by superior force [v OVERBORE, OVERBORN or OVERBORNE, OVERBEARING, OVERBEARS]\n",
  "OVERBEARING": "OVERBEAR, to bring down by superior force [v]\n",
  "OVERBEARINGLY": "OVERBEARING, OVERBEAR, to bring down by superior force [adv]\n",
  "OVERBEARINGNESS": "the state of being overbearing [n]\n",
  "OVERBEARS": "OVERBEAR, to bring down by superior force [v]\n",
  "OVERBEAT": "to beat too much [v OVERBEAT, OVERBEATEN, OVERBEATING, OVERBEATS]\n",
  "OVERBEATEN": "OVERBEAT, to beat too much [v]\n",
  "OVERBEATING": "OVERBEAT, to beat too much [v]\n",
  "OVERBEATS": "OVERBEAT, to beat too much [v]\n",
  "OVERBED": "spanning a bed [adj]\n",
  "OVERBEJEWELED": "excessively adorned with jewels, also OVERBEJEWELLED [adj]\n",
  "OVERBEJEWELLED": "excessively adorned with jewels, also OVERBEJEWELED [adj]\n",
  "OVERBET": "to bet too much [v OVERBETTED, OVERBETTING, OVERBETS]\n",
  "OVERBETS": "OVERBET, to bet too much [v]\n",
  "OVERBETTED": "OVERBET, to bet too much [v]\n",
  "OVERBETTING": "betting to excess [n -S]\n",
  "OVERBETTINGS": "OVERBETTING, betting to excess [n]\n",
  "OVERBID": "to bid or offer beyond, or in excess of [v OVERBID, OVERBIDDEN, OVERBIDDING, OVERBIDS]\n",
  "OVERBIDDEN": "OVERBID, to bid or offer beyond, or in excess of [v]\n",
  "OVERBIDDER": "one who makes unduly high bids [n -S]\n",
  "OVERBIDDERS": "OVERBIDDER, one who makes unduly high bids [n]\n",
  "OVERBIDDING": "the act of bidding more trumps than a hand justifies [n -S]\n",
  "OVERBIDDINGS": "OVERBIDDING, the act of bidding more trumps than a hand justifies [n]\n",
  "OVERBIDS": "OVERBID, to bid or offer beyond, or in excess of [v]\n",
  "OVERBIG": "too big [adj]\n",
  "OVERBILL": "to bill too much [v -ED, -ING, -S]\n",
  "OVERBILLED": "OVERBILL, to bill too much [v]\n",
  "OVERBILLING": "OVERBILL, to bill too much [v]\n",
  "OVERBILLS": "OVERBILL, to bill too much [v]\n",
  "OVERBITE": "the overlapping of the lower by the upper teeth; esp. vertical overlapping of the incisors [n -S]\n",
  "OVERBITES": "OVERBITE, the overlapping of the lower by the upper teeth; esp. vertical overlapping of the incisors [n]\n",
  "OVERBLANKET": "a covering blanket [n -S]\n",
  "OVERBLANKETS": "OVERBLANKET, a covering blanket [n]\n",
  "OVERBLEACH": "to bleach to excess [v -ED, -ING, -ES]\n",
  "OVERBLEACHED": "OVERBLEACH, to bleach to excess [v]\n",
  "OVERBLEACHES": "OVERBLEACH, to bleach to excess [v]\n",
  "OVERBLEACHING": "OVERBLEACH, to bleach to excess [v]\n",
  "OVERBLEW": "OVERBLOW, to give excess importance to [v]\n",
  "OVERBLOUSE": "a garment worn over a blouse [n -S]\n",
  "OVERBLOUSES": "OVERBLOUSE, a garment worn over a blouse [n]\n",
  "OVERBLOW": "to give excess importance to [v OVERBLEW, OVERBLOWN, OVERBLOWING, OVERBLOWS]\n",
  "OVERBLOWING": "OVERBLOW, to give excess importance to [v]\n",
  "OVERBLOWN": "OVERBLOW, to give excess importance to [v]\n",
  "OVERBLOWS": "OVERBLOW, to give excess importance to [v]\n",
  "OVERBOARD": "from on board, over the side of a ship or boat [adv]\n",
  "OVERBOIL": "to boil too long [v -ED, -ING, -S]\n",
  "OVERBOILED": "OVERBOIL, to boil too long [v]\n",
  "OVERBOILING": "OVERBOIL, to boil too long [v]\n",
  "OVERBOILS": "OVERBOIL, to boil too long [v]\n",
  "OVERBOLD": "excessively bold [adj OVERBOLDLY]\n",
  "OVERBOLDLY": "OVERBOLD, excessively bold [adv]\n",
  "OVERBOOK": "to book in excess of space available [v -ED, -ING, -S]\n",
  "OVERBOOKED": "OVERBOOK, to book in excess of space available [v]\n",
  "OVERBOOKING": "the act of booking more than necessary [n -S]\n",
  "OVERBOOKINGS": "OVERBOOKING, the act of booking more than necessary [n]\n",
  "OVERBOOKS": "OVERBOOK, to book in excess of space available [v]\n",
  "OVERBOOT": "a protective boot worn over an ordinary boot or shoe [n -S]\n",
  "OVERBOOTS": "OVERBOOT, a protective boot worn over an ordinary boot or shoe [n]\n",
  "OVERBORE": "OVERBEAR, to bring down by superior force [v]\n",
  "OVERBORN": "OVERBEAR, to bring down by superior force [v]\n",
  "OVERBORNE": "OVERBEAR, to bring down by superior force [v]\n",
  "OVERBORROW": "to borrow to excess [v -ED, -ING, -S]\n",
  "OVERBORROWED": "OVERBORROW, to borrow to excess [v]\n",
  "OVERBORROWING": "OVERBORROW, to borrow to excess [v]\n",
  "OVERBORROWS": "OVERBORROW, to borrow to excess [v]\n",
  "OVERBOUGHT": "OVERBUY, to buy too much [v]\n",
  "OVERBOUND": "to bound excessively [v -ED, -ING, -S]\n",
  "OVERBOUNDED": "OVERBOUND, to bound excessively [v]\n",
  "OVERBOUNDING": "OVERBOUND, to bound excessively [v]\n",
  "OVERBOUNDS": "OVERBOUND, to bound excessively [v]\n",
  "OVERBRAKE": "to brake too much [v OVERBRAKED, OVERBRAKING, OVERBRAKES]\n",
  "OVERBRAKED": "OVERBRAKE, to brake too much [v]\n",
  "OVERBRAKES": "OVERBRAKE, to brake too much [v]\n",
  "OVERBRAKING": "OVERBRAKE, to brake too much [v]\n",
  "OVERBREATHING": "hyperventilation [n -S]\n",
  "OVERBREATHINGS": "OVERBREATHING, hyperventilation [n]\n",
  "OVERBRED": "bred too finely [adj]\n",
  "OVERBREED": "to breed too much [v OVERBRED, OVERBREEDING, OVERBREEDS]\n",
  "OVERBREEDING": "OVERBREED, to breed too much [v]\n",
  "OVERBREEDS": "OVERBREED, to breed too much [v]\n",
  "OVERBRIDGE": "to span with a bridge [v OVERBRIDGED, OVERBRIDGING, OVERBRIDGES]\n",
  "OVERBRIDGED": "OVERBRIDGE, to span with a bridge [v]\n",
  "OVERBRIDGES": "OVERBRIDGE, to span with a bridge [v]\n",
  "OVERBRIDGING": "OVERBRIDGE, to span with a bridge [v]\n",
  "OVERBRIEF": "excessively brief [adj] / to brief excessively [v -ED, -ING, -S]\n",
  "OVERBRIEFED": "OVERBRIEF, to brief excessively [v]\n",
  "OVERBRIEFING": "OVERBRIEF, to brief excessively [v]\n",
  "OVERBRIEFS": "OVERBRIEF, to brief excessively [v]\n",
  "OVERBRIGHT": "excessively bright [adj]\n",
  "OVERBRIM": "to flow over [v OVERBRIMMED, OVERBRIMMING, OVERBRIMS]\n",
  "OVERBRIMMED": "OVERBRIM, to flow over [v]\n",
  "OVERBRIMMING": "OVERBRIM, to flow over [v]\n",
  "OVERBRIMS": "OVERBRIM, to flow over [v]\n",
  "OVERBROAD": "excessively broad [adj]\n",
  "OVERBROW": "(archaic) to overhang like a brow [v -ED, -ING, -S]\n",
  "OVERBROWED": "OVERBROW, (archaic) to overhang like a brow [v]\n",
  "OVERBROWING": "OVERBROW, (archaic) to overhang like a brow [v]\n",
  "OVERBROWS": "OVERBROW, (archaic) to overhang like a brow [v]\n",
  "OVERBROWSE": "to browse to excess [v OVERBROWSED, OVERBROWSING, OVERBROWSES]\n",
  "OVERBROWSED": "OVERBROWSE, to browse to excess [v]\n",
  "OVERBROWSES": "OVERBROWSE, to browse to excess [v]\n",
  "OVERBROWSING": "OVERBROWSE, to browse to excess [v]\n",
  "OVERBRUTAL": "excessively brutal [adj]\n",
  "OVERBUILD": "to build over [v OVERBUILT, OVERBUILDING, OVERBUILDS]\n",
  "OVERBUILDING": "OVERBUILD, to build over [v]\n",
  "OVERBUILDS": "OVERBUILD, to build over [v]\n",
  "OVERBUILT": "OVERBUILD, to build over [v]\n",
  "OVERBULK": "(Shakespeare) to oppress by bulk [v -ED, -ING, -S]\n",
  "OVERBULKED": "OVERBULK, (Shakespeare) to oppress by bulk [v]\n",
  "OVERBULKING": "OVERBULK, (Shakespeare) to oppress by bulk [v]\n",
  "OVERBULKS": "OVERBULK, (Shakespeare) to oppress by bulk [v]\n",
  "OVERBURDEN": "to overload, also OVERBURTHEN [v -ED, -ING, -S]\n",
  "OVERBURDENED": "OVERBURDEN, to overload, also OVERBURTHEN [v]\n",
  "OVERBURDENING": "OVERBURDEN, to overload, also OVERBURTHEN [v]\n",
  "OVERBURDENS": "OVERBURDEN, to overload, also OVERBURTHEN [v]\n",
  "OVERBURDENSOME": "excessively burdensome [adj]\n",
  "OVERBURN": "to burn too much; to be overzealous [v OVERBURNED, OVERBURNT, OVERBURNING, OVERBURNS]\n",
  "OVERBURNED": "OVERBURN, to burn too much; to be overzealous [v]\n",
  "OVERBURNING": "OVERBURN, to burn too much; to be overzealous [v]\n",
  "OVERBURNS": "OVERBURN, to burn too much; to be overzealous [v]\n",
  "OVERBURNT": "OVERBURN, to burn too much; to be overzealous [v]\n",
  "OVERBURTHEN": "(archaic) to overburden, also OVERBURDEN [v -ED, -ING, -S]\n",
  "OVERBURTHENED": "OVERBURTHEN, (archaic) to overburden, also OVERBURDEN [v]\n",
  "OVERBURTHENING": "OVERBURTHEN, (archaic) to overburden, also OVERBURDEN [v]\n",
  "OVERBURTHENS": "OVERBURTHEN, (archaic) to overburden, also OVERBURDEN [v]\n",
  "OVERBUSIED": "OVERBUSY, to occupy oneself too much [v]\n",
  "OVERBUSIES": "OVERBUSY, to occupy oneself too much [v]\n",
  "OVERBUSY": "to occupy oneself too much [v OVERBUSIED, OVERBUSYING, OVERBUSIES]\n",
  "OVERBUSYING": "OVERBUSY, to occupy oneself too much [v]\n",
  "OVERBUY": "to buy too much [v OVERBOUGHT, OVERBUYING, OVERBUYS]\n",
  "OVERBUYING": "OVERBUY, to buy too much [v]\n",
  "OVERBUYS": "OVERBUY, to buy too much [v]\n",
  "OVERBY": "(Scots) a little way over, also OWERBY [adv]\n",
  "OVERCALL": "in bridge, to outbid [v -ED, -ING, -S]\n",
  "OVERCALLED": "OVERCALL, in bridge, to outbid [v]\n",
  "OVERCALLING": "OVERCALL, in bridge, to outbid [v]\n",
  "OVERCALLS": "OVERCALL, in bridge, to outbid [v]\n",
  "OVERCAME": "OVERCOME, to get the better of [v]\n",
  "OVERCANOPIED": "OVERCANOPY, to cover as with a canopy [v]\n",
  "OVERCANOPIES": "OVERCANOPY, to cover as with a canopy [v]\n",
  "OVERCANOPY": "to cover as with a canopy [v OVERCANOPIED, OVERCANOPYING, OVERCANOPIES]\n",
  "OVERCANOPYING": "OVERCANOPY, to cover as with a canopy [v]\n",
  "OVERCAPACITIES": "OVERCAPACITY, excessive capacity for production or services in relation to demand [n]\n",
  "OVERCAPACITY": "excessive capacity for production or services in relation to demand [n OVERCAPACITIES]\n",
  "OVERCAPITALISE": "to put a nominal value on the capital of (a corporation) higher than actual cost or fair market value, also OVERCAPITALIZE [v OVERCAPITALISED, OVERCAPITALISES]\n",
  "OVERCAPITALISED": "OVERCAPITALISE, to put a nominal value on the capital of (a corporation) higher than actual cost or fair market value, also OVERCAPITALIZE [v]\n",
  "OVERCAPITALISES": "OVERCAPITALISE, to put a nominal value on the capital of (a corporation) higher than actual cost or fair market value, also OVERCAPITALIZE [v]\n",
  "OVERCAPITALIZE": "to put a nominal value on the capital of (a corporation) higher than actual cost or fair market value also OVERCAPITALISE [v OVERCAPITALIZED, OVERCAPITALIZES]\n",
  "OVERCAPITALIZED": "OVERCAPITALIZE, to put a nominal value on the capital of (a corporation) higher than actual cost or fair market value also OVERCAPITALISE [v]\n",
  "OVERCAPITALIZES": "OVERCAPITALIZE, to put a nominal value on the capital of (a corporation) higher than actual cost or fair market value also OVERCAPITALISE [v]\n",
  "OVERCAREFUL": "too careful [adj]\n",
  "OVERCARRIED": "OVERCARRY, to carry too far [v]\n",
  "OVERCARRIES": "OVERCARRY, to carry too far [v]\n",
  "OVERCARRY": "to carry too far [v OVERCARRIED, OVERCARRYING, OVERCARRIES]\n",
  "OVERCARRYING": "OVERCARRY, to carry too far [v]\n",
  "OVERCAST": "to sew stitches over a raw edge; to cover with stitches [v -ED, -ING, -S]\n",
  "OVERCASTED": "OVERCAST, to sew stitches over a raw edge; to cover with stitches [v]\n",
  "OVERCASTING": "stitches sewn over a raw edge [n -S]\n",
  "OVERCASTINGS": "OVERCASTING, stitches sewn over a raw edge [n]\n",
  "OVERCASTS": "OVERCAST, to sew stitches over a raw edge; to cover with stitches [v]\n",
  "OVERCATCH": "to overtake [v OVERCAUGHT, OVERCATCHING, OVERCATCHES]\n",
  "OVERCATCHES": "OVERCATCH, to overtake [v]\n",
  "OVERCATCHING": "OVERCATCH, to overtake [v]\n",
  "OVERCAUGHT": "OVERCATCH, to overtake [v]\n",
  "OVERCAUTION": "excessive caution [n -S]\n",
  "OVERCAUTIONS": "OVERCAUTION, excessive caution [n]\n",
  "OVERCAUTIOUS": "excessively cautious [adj OVERCAUTIOUSLY]\n",
  "OVERCAUTIOUSLY": "OVERCAUTIOUS, excessively cautious [adv]\n",
  "OVERCENTRALISE": "to centralise excessively, also OVERCENTRALIZE [v OVERCENTRALISED, OVERCENTRALISES]\n",
  "OVERCENTRALISED": "OVERCENTRALISE, to centralise excessively, also OVERCENTRALIZE [v]\n",
  "OVERCENTRALISES": "OVERCENTRALISE, to centralise excessively, also OVERCENTRALIZE [v]\n",
  "OVERCENTRALIZE": "to centralize to excess, also OVERCENTRALISE [v OVERCENTRALIZED, OVERCENTRALIZES]\n",
  "OVERCENTRALIZED": "OVERCENTRALIZE, to centralize to excess, also OVERCENTRALISE [v]\n",
  "OVERCENTRALIZES": "OVERCENTRALIZE, to centralize to excess, also OVERCENTRALISE [v]\n",
  "OVERCHARGE": "to charge too much [v OVERCHARGED, OVERCHARGING, OVERCHARGES]\n",
  "OVERCHARGED": "OVERCHARGE, to charge too much [v]\n",
  "OVERCHARGES": "OVERCHARGE, to charge too much [v]\n",
  "OVERCHARGING": "the making of an excessive charge [n -S]\n",
  "OVERCHARGINGS": "OVERCHARGING, the making of an excessive charge [n]\n",
  "OVERCHEAP": "too cheap [adj]\n",
  "OVERCHECK": "a large prominent check pattern overlaid with a smaller [n -S]\n",
  "OVERCHECKS": "OVERCHECK, a large prominent check pattern overlaid with a smaller [n]\n",
  "OVERCHILL": "to chill to excess [v -ED, -ING, -S]\n",
  "OVERCHILLED": "OVERCHILL, to chill to excess [v]\n",
  "OVERCHILLING": "OVERCHILL, to chill to excess [v]\n",
  "OVERCHILLS": "OVERCHILL, to chill to excess [v]\n",
  "OVERCIVIL": "too civil [adj]\n",
  "OVERCIVILISED": "excessively civilised, also OVERCIVILIZED [adj]\n",
  "OVERCIVILIZED": "excessively civilized, also OVERCIVILISED [adj]\n",
  "OVERCLAD": "overdressed [adj]\n",
  "OVERCLAIM": "to claim excessively [v -ED, -ING, -S]\n",
  "OVERCLAIMED": "OVERCLAIM, to claim excessively [v]\n",
  "OVERCLAIMING": "OVERCLAIM, to claim excessively [v]\n",
  "OVERCLAIMS": "OVERCLAIM, to claim excessively [v]\n",
  "OVERCLASS": "a dominant group in society [n -ES]\n",
  "OVERCLASSES": "OVERCLASS, a dominant group in society [n]\n",
  "OVERCLASSIFIED": "OVERCLASSIFY, to classify to excess [v]\n",
  "OVERCLASSIFIES": "OVERCLASSIFY, to classify to excess [v]\n",
  "OVERCLASSIFY": "to classify to excess [v OVERCLASSIFIED, OVERCLASSIFYING, OVERCLASSIFIES]\n",
  "OVERCLASSIFYING": "OVERCLASSIFY, to classify to excess [v]\n",
  "OVERCLEAN": "to clean to excess [v -ED, -ING, -S]\n",
  "OVERCLEANED": "OVERCLEAN, to clean to excess [v]\n",
  "OVERCLEANING": "OVERCLEAN, to clean to excess [v]\n",
  "OVERCLEANS": "OVERCLEAN, to clean to excess [v]\n",
  "OVERCLEAR": "to clear to excess [v -ED, -ING, -S]\n",
  "OVERCLEARED": "OVERCLEAR, to clear to excess [v]\n",
  "OVERCLEARING": "OVERCLEAR, to clear to excess [v]\n",
  "OVERCLEARS": "OVERCLEAR, to clear to excess [v]\n",
  "OVERCLEVER": "excessively clever [adj]\n",
  "OVERCLOCK": "to run a computer component at a higher clock rate than it was designed for or was specified by the manufacturer [v -ED, -ING, -S]\n",
  "OVERCLOCKED": "OVERCLOCK, to run a computer component at a higher clock rate than it was designed for or was specified by the manufacturer [v]\n",
  "OVERCLOCKER": "one who overclocks [n -S]\n",
  "OVERCLOCKERS": "OVERCLOCKER, one who overclocks [n]\n",
  "OVERCLOCKING": "the act of running a computer component at a higher clock rate than it was designed for or was specified by the manufacturer [n -S]\n",
  "OVERCLOCKINGS": "OVERCLOCKING, the act of running a computer component at a higher clock rate than it was designed for or was specified by the manufacturer [n]\n",
  "OVERCLOCKS": "OVERCLOCK, to run a computer component at a higher clock rate than it was designed for or was specified by the manufacturer [v]\n",
  "OVERCLOSE": "too close [adj]\n",
  "OVERCLOUD": "to cover or overspread with clouds [v -ED, -ING, -S]\n",
  "OVERCLOUDED": "OVERCLOUD, to cover or overspread with clouds [v]\n",
  "OVERCLOUDING": "OVERCLOUD, to cover or overspread with clouds [v]\n",
  "OVERCLOUDS": "OVERCLOUD, to cover or overspread with clouds [v]\n",
  "OVERCLOY": "to eat to excess [v -ED, -ING, -S]\n",
  "OVERCLOYED": "OVERCLOY, to eat to excess [v]\n",
  "OVERCLOYING": "OVERCLOY, to eat to excess [v]\n",
  "OVERCLOYS": "OVERCLOY, to eat to excess [v]\n",
  "OVERCLUB": "to hit a shot too far through using a club with insufficient loft [v OVERCLUBBED, OVERCLUBBING, OVERCLUBS]\n",
  "OVERCLUBBED": "OVERCLUB, to hit a shot too far through using a club with insufficient loft [v]\n",
  "OVERCLUBBING": "OVERCLUB, to hit a shot too far through using a club with insufficient loft [v]\n",
  "OVERCLUBS": "OVERCLUB, to hit a shot too far through using a club with insufficient loft [v]\n",
  "OVERCOACH": "to coach to excess [v -ED, -ING, -ES]\n",
  "OVERCOACHED": "OVERCOACH, to coach to excess [v]\n",
  "OVERCOACHES": "OVERCOACH, to coach to excess [v]\n",
  "OVERCOACHING": "OVERCOACH, to coach to excess [v]\n",
  "OVERCOAT": "a warm coat worn over clothing [n -S]\n",
  "OVERCOATING": "cloth for overcoats [n -S]\n",
  "OVERCOATINGS": "OVERCOATING, cloth for overcoats [n]\n",
  "OVERCOATS": "OVERCOAT, a warm coat worn over clothing [n]\n",
  "OVERCOLD": "cold to excess [adj]\n",
  "OVERCOLOR": "to color too highly, also OVERCOLOUR [v -ED, -ING, -S]\n",
  "OVERCOLORED": "OVERCOLOR, to color too highly, also OVERCOLOUR [v]\n",
  "OVERCOLORING": "OVERCOLOR, to color too highly, also OVERCOLOUR [v]\n",
  "OVERCOLORS": "OVERCOLOR, to color too highly, also OVERCOLOUR [v]\n",
  "OVERCOLOUR": "to colour to excess, also OVERCOLOR [v -ED, -ING, -S]\n",
  "OVERCOLOURED": "OVERCOLOUR, to colour to excess, also OVERCOLOR [v]\n",
  "OVERCOLOURING": "OVERCOLOUR, to colour to excess, also OVERCOLOR [v]\n",
  "OVERCOLOURS": "OVERCOLOUR, to colour to excess, also OVERCOLOR [v]\n",
  "OVERCOME": "to get the better of [v OVERCAME, OVERCOMING, OVERCOMES]\n",
  "OVERCOMER": "one who overcomes [n -S]\n",
  "OVERCOMERS": "OVERCOMER, one who overcomes [n]\n",
  "OVERCOMES": "OVERCOME, to get the better of [v]\n",
  "OVERCOMING": "OVERCOME, to get the better of [v]\n",
  "OVERCOMMIT": "to commit excessively [v OVERCOMMITTED, OVERCOMMITTING, OVERCOMMITS]\n",
  "OVERCOMMITMENT": "excessive commitment [n -S]\n",
  "OVERCOMMITMENTS": "OVERCOMMITMENT, excessive commitment [n]\n",
  "OVERCOMMITS": "OVERCOMMIT, to commit excessively [v]\n",
  "OVERCOMMITTED": "OVERCOMMIT, to commit excessively [v]\n",
  "OVERCOMMITTING": "OVERCOMMIT, to commit excessively [v]\n",
  "OVERCOMMUNICATE": "to communicate excessively [v]\n",
  "OVERCOMPENSATE": "to compensate excessively [v OVERCOMPENSATED, OVERCOMPENSATES]\n",
  "OVERCOMPENSATED": "OVERCOMPENSATE, to compensate excessively [v]\n",
  "OVERCOMPENSATES": "OVERCOMPENSATE, to compensate excessively [v]\n",
  "OVERCOMPLEX": "excessively complex [adj]\n",
  "OVERCOMPLIANCE": "excessive compliance [n -S]\n",
  "OVERCOMPLIANCES": "OVERCOMPLIANCE, excessive compliance [n]\n",
  "OVERCOMPLICATE": "to complicate excessively [v OVERCOMPLICATED, OVERCOMPLICATES]\n",
  "OVERCOMPLICATED": "OVERCOMPLICATE, to complicate excessively [v]\n",
  "OVERCOMPLICATES": "OVERCOMPLICATE, to complicate excessively [v]\n",
  "OVERCOMPRESS": "to compress excessively [v -ED, -ING, -ES]\n",
  "OVERCOMPRESSED": "OVERCOMPRESS, to compress excessively [v]\n",
  "OVERCOMPRESSES": "OVERCOMPRESS, to compress excessively [v]\n",
  "OVERCOMPRESSING": "OVERCOMPRESS, to compress excessively [v]\n",
  "OVERCONCERN": "to concern excessively [v -ED, -ING, -S]\n",
  "OVERCONCERNED": "OVERCONCERN, to concern excessively [v]\n",
  "OVERCONCERNING": "OVERCONCERN, to concern excessively [v]\n",
  "OVERCONCERNS": "OVERCONCERN, to concern excessively [v]\n",
  "OVERCONFIDENCE": "excessive confidence [n -S]\n",
  "OVERCONFIDENCES": "OVERCONFIDENCE, excessive confidence [n]\n",
  "OVERCONFIDENT": "excessively confident [adj OVERCONFIDENTLY]\n",
  "OVERCONFIDENTLY": "OVERCONFIDENT, excessively confident [adv]\n",
  "OVERCONSCIOUS": "excessively conscious [adj]\n",
  "OVERCONSTRUCT": "to construct excessively [v OVERCONSTRUCTED, OVERCONSTRUCTS]\n",
  "OVERCONSTRUCTED": "OVERCONSTRUCT, to construct excessively [v]\n",
  "OVERCONSTRUCTS": "OVERCONSTRUCT, to construct excessively [v]\n",
  "OVERCONSUME": "to consume to excess [v OVERCONSUMED, OVERCONSUMING, OVERCONSUMES]\n",
  "OVERCONSUMED": "OVERCONSUME, to consume to excess [v]\n",
  "OVERCONSUMES": "OVERCONSUME, to consume to excess [v]\n",
  "OVERCONSUMING": "OVERCONSUME, to consume to excess [v]\n",
  "OVERCONSUMPTION": "excessive consumption [n]\n",
  "OVERCONTROL": "to control excessively [v OVERCONTROLLED, OVERCONTROLLING, OVERCONTROLS]\n",
  "OVERCONTROLLED": "OVERCONTROL, to control excessively [v]\n",
  "OVERCONTROLLING": "OVERCONTROL, to control excessively [v]\n",
  "OVERCONTROLS": "OVERCONTROL, to control excessively [v]\n",
  "OVERCOOK": "to cook too long [v -ED, -ING, -S]\n",
  "OVERCOOKED": "OVERCOOK, to cook too long [v]\n",
  "OVERCOOKING": "OVERCOOK, to cook too long [v]\n",
  "OVERCOOKS": "OVERCOOK, to cook too long [v]\n",
  "OVERCOOL": "to make too cool [v -ED, -ING, -S]\n",
  "OVERCOOLED": "OVERCOOL, to make too cool [v]\n",
  "OVERCOOLING": "OVERCOOL, to make too cool [v]\n",
  "OVERCOOLS": "OVERCOOL, to make too cool [v]\n",
  "OVERCORRECT": "to correct to excess [v -ED, -ING, -S]\n",
  "OVERCORRECTED": "OVERCORRECT, to correct to excess [v]\n",
  "OVERCORRECTING": "OVERCORRECT, to correct to excess [v]\n",
  "OVERCORRECTION": "excessive correction [n -S]\n",
  "OVERCORRECTIONS": "OVERCORRECTION, excessive correction [n]\n",
  "OVERCORRECTS": "OVERCORRECT, to correct to excess [v]\n",
  "OVERCOUNT": "to rate too high; to outnumber [v -ED, -ING, -S]\n",
  "OVERCOUNTED": "OVERCOUNT, to rate too high; to outnumber [v]\n",
  "OVERCOUNTING": "OVERCOUNT, to rate too high; to outnumber [v]\n",
  "OVERCOUNTS": "OVERCOUNT, to rate too high; to outnumber [v]\n",
  "OVERCOVER": "to cover up [v -ED, -ING, -S]\n",
  "OVERCOVERED": "OVERCOVER, to cover up [v]\n",
  "OVERCOVERING": "OVERCOVER, to cover up [v]\n",
  "OVERCOVERS": "OVERCOVER, to cover up [v]\n",
  "OVERCOY": "excessively coy [adj]\n",
  "OVERCRAM": "to stuff to excess [v OVERCRAMMED, OVERCRAMMING, OVERCRAMS]\n",
  "OVERCRAMMED": "OVERCRAM, to stuff to excess [v]\n",
  "OVERCRAMMING": "the act of cramming to excess [n -S]\n",
  "OVERCRAMMINGS": "OVERCRAMMING, the act of cramming to excess [n]\n",
  "OVERCRAMS": "OVERCRAM, to stuff to excess [v]\n",
  "OVERCRAW": "(Spenser) to triumph over, also OVERCROW [v -ED, -ING, -S]\n",
  "OVERCRAWED": "OVERCRAW, (Spenser) to triumph over, also OVERCROW [v]\n",
  "OVERCRAWING": "OVERCRAW, (Spenser) to triumph over, also OVERCROW [v]\n",
  "OVERCRAWS": "OVERCRAW, (Spenser) to triumph over, also OVERCROW [v]\n",
  "OVERCREDULITIES": "OVERCREDULITY, the state of being overcredulous [n]\n",
  "OVERCREDULITY": "the state of being overcredulous [n OVERCREDULITIES]\n",
  "OVERCREDULOUS": "excessively credulous [adj]\n",
  "OVERCRITICAL": "excessively critical [adj]\n",
  "OVERCROP": "to exhaust the land [v OVERCROPPED, OVERCROPPING, OVERCROPS]\n",
  "OVERCROPPED": "OVERCROP, to exhaust the land [v]\n",
  "OVERCROPPING": "OVERCROP, to exhaust the land [v]\n",
  "OVERCROPS": "OVERCROP, to exhaust the land [v]\n",
  "OVERCROW": "to triumph over, also OVERCRAW [v -ED, -ING, -S]\n",
  "OVERCROWD": "to crowd excessively [v -ED, -ING, -S]\n",
  "OVERCROWDED": "OVERCROWD, to crowd excessively [v]\n",
  "OVERCROWDING": "the act of crowding to excess [n -S]\n",
  "OVERCROWDINGS": "OVERCROWDING, the act of crowding to excess [n]\n",
  "OVERCROWDS": "OVERCROWD, to crowd excessively [v]\n",
  "OVERCROWED": "OVERCROW, to triumph over, also OVERCRAW [v]\n",
  "OVERCROWING": "OVERCROW, to triumph over, also OVERCRAW [v]\n",
  "OVERCROWS": "OVERCROW, to triumph over, also OVERCRAW [v]\n",
  "OVERCULTIVATION": "excessively cultivation [n]\n",
  "OVERCURE": "to cure too long [v OVERCURED, OVERCURING, OVERCURES]\n",
  "OVERCURED": "OVERCURE, to cure too long [v]\n",
  "OVERCURES": "OVERCURE, to cure too long [v]\n",
  "OVERCURING": "OVERCURE, to cure too long [v]\n",
  "OVERCUT": "to cut too much [v OVERCUT, OVERCUTTING, OVERCUTS]\n",
  "OVERCUTS": "OVERCUT, to cut too much [v]\n",
  "OVERCUTTING": "excessive pruning [n -S]\n",
  "OVERCUTTINGS": "OVERCUTTING, excessive pruning [n]\n",
  "OVERDARE": "to become too daring [v OVERDARED, OVERDARING, OVERDARES]\n",
  "OVERDARED": "OVERDARE, to become too daring [v]\n",
  "OVERDARES": "OVERDARE, to become too daring [v]\n",
  "OVERDARING": "OVERDARE, to become too daring [v]\n",
  "OVERDATED": "out of date [adj]\n",
  "OVERDEAR": "excessively dear [adj]\n",
  "OVERDECK": "to adorn extravagantly [v -ED, -ING, -S]\n",
  "OVERDECKED": "OVERDECK, to adorn extravagantly [v]\n",
  "OVERDECKING": "OVERDECK, to adorn extravagantly [v]\n",
  "OVERDECKS": "OVERDECK, to adorn extravagantly [v]\n",
  "OVERDECORATE": "to decorate to excess [v OVERDECORATED, OVERDECORATING, OVERDECORATES]\n",
  "OVERDECORATED": "OVERDECORATE, to decorate to excess [v]\n",
  "OVERDECORATES": "OVERDECORATE, to decorate to excess [v]\n",
  "OVERDECORATING": "OVERDECORATE, to decorate to excess [v]\n",
  "OVERDECORATION": "excessively decoration [n -S]\n",
  "OVERDECORATIONS": "OVERDECORATION, excessively decoration [n]\n",
  "OVERDEEPENING": "excessively deepening [adj]\n",
  "OVERDELICATE": "excessively delicate [adj]\n",
  "OVERDEMANDING": "excessively demanding [adj]\n",
  "OVERDEPENDENCE": "excessive dependence [n -S]\n",
  "OVERDEPENDENCES": "OVERDEPENDENCE, excessive dependence [n]\n",
  "OVERDEPENDENT": "excessively dependent [adj]\n",
  "OVERDESIGN": "to design to excess [v -ED, -ING, -S]\n",
  "OVERDESIGNED": "OVERDESIGN, to design to excess [v]\n",
  "OVERDESIGNING": "OVERDESIGN, to design to excess [v]\n",
  "OVERDESIGNS": "OVERDESIGN, to design to excess [v]\n",
  "OVERDETERMINED": "excessively determined [adj]\n",
  "OVERDEVELOP": "to develop excessively [v -ED, -ING, -S]\n",
  "OVERDEVELOPED": "OVERDEVELOP, to develop excessively [v]\n",
  "OVERDEVELOPING": "OVERDEVELOP, to develop excessively [v]\n",
  "OVERDEVELOPMENT": "excessive development [n]\n",
  "OVERDEVELOPS": "OVERDEVELOP, to develop excessively [v]\n",
  "OVERDEVIATE": "to deviate excessively [v OVERDEVIATED, OVERDEVIATING, OVERDEVIATES]\n",
  "OVERDEVIATED": "OVERDEVIATE, to deviate excessively [v]\n",
  "OVERDEVIATES": "OVERDEVIATE, to deviate excessively [v]\n",
  "OVERDEVIATING": "OVERDEVIATE, to deviate excessively [v]\n",
  "OVERDIAGNOSES": "OVERDIAGNOSIS, excessive diagnosis [n]\n",
  "OVERDIAGNOSIS": "excessive diagnosis [n OVERDIAGNOSES]\n",
  "OVERDID": "OVERDO, to do to excess [v]\n",
  "OVERDIGHT": "(Spenser) covered over [adj]\n",
  "OVERDILUTED": "excessively diluted [adj]\n",
  "OVERDIRECT": "to direct excessively [v -ED, -ING, -S]\n",
  "OVERDIRECTED": "OVERDIRECT, to direct excessively [v]\n",
  "OVERDIRECTING": "OVERDIRECT, to direct excessively [v]\n",
  "OVERDIRECTS": "OVERDIRECT, to direct excessively [v]\n",
  "OVERDISCOUNT": "to discount excessively [v -ED, -ING, -S]\n",
  "OVERDISCOUNTED": "OVERDISCOUNT, to discount excessively [v]\n",
  "OVERDISCOUNTING": "OVERDISCOUNT, to discount excessively [v]\n",
  "OVERDISCOUNTS": "OVERDISCOUNT, to discount excessively [v]\n",
  "OVERDIVERSITIES": "OVERDIVERSITY, excessive diversity [n]\n",
  "OVERDIVERSITY": "excessive diversity [n OVERDIVERSITIES]\n",
  "OVERDO": "to do to excess [v OVERDID, OVERDONE, OVERDOING, OVERDOES]\n",
  "OVERDOCUMENT": "to document to excess [v -ED, -ING, -S]\n",
  "OVERDOCUMENTED": "OVERDOCUMENT, to document to excess [v]\n",
  "OVERDOCUMENTING": "OVERDOCUMENT, to document to excess [v]\n",
  "OVERDOCUMENTS": "OVERDOCUMENT, to document to excess [v]\n",
  "OVERDOER": "one who overdoes [n -S]\n",
  "OVERDOERS": "OVERDOER, one who overdoes [n]\n",
  "OVERDOES": "OVERDO, to do to excess [v]\n",
  "OVERDOG": "one that is dominant [n -S]\n",
  "OVERDOGS": "OVERDOG, one that is dominant [n]\n",
  "OVERDOING": "OVERDO, to do to excess [v]\n",
  "OVERDOMINANCE": "the situation where a heterozygote has a phenotype that is better adapted than either homozygote [n -S]\n",
  "OVERDOMINANCES": "OVERDOMINANCE, the situation where a heterozygote has a phenotype that is better adapted than either homozygote [n]\n",
  "OVERDOMINANT": "excessively dominant [adj]\n",
  "OVERDONE": "OVERDO, to do to excess [v]\n",
  "OVERDOSAGE": "an overdose [n -S]\n",
  "OVERDOSAGES": "OVERDOSAGE, an overdose [n]\n",
  "OVERDOSE": "to give an excessive dose to [v OVERDOSED, OVERDOSING, OVERDOSES]\n",
  "OVERDOSED": "OVERDOSE, to give an excessive dose to [v]\n",
  "OVERDOSES": "OVERDOSE, to give an excessive dose to [v]\n",
  "OVERDOSING": "OVERDOSE, to give an excessive dose to [v]\n",
  "OVERDRAFT": "the overdrawing of a bank account [n -S]\n",
  "OVERDRAFTS": "OVERDRAFT, the overdrawing of a bank account [n]\n",
  "OVERDRAMATIC": "excessively dramatic [adj]\n",
  "OVERDRAMATISE": "to dramatise to excess, also OVERDRAMATIZE [v OVERDRAMATISED, OVERDRAMATISING, OVERDRAMATISES]\n",
  "OVERDRAMATISED": "OVERDRAMATISE, to dramatise to excess, also OVERDRAMATIZE [v]\n",
  "OVERDRAMATISES": "OVERDRAMATISE, to dramatise to excess, also OVERDRAMATIZE [v]\n",
  "OVERDRAMATISING": "OVERDRAMATISE, to dramatise to excess, also OVERDRAMATIZE [v]\n",
  "OVERDRAMATIZE": "to dramatize to excess, also OVERDRAMATISE [v OVERDRAMATIZED, OVERDRAMATIZING, OVERDRAMATIZES]\n",
  "OVERDRAMATIZED": "OVERDRAMATIZE, to dramatize to excess, also OVERDRAMATISE [v]\n",
  "OVERDRAMATIZES": "OVERDRAMATIZE, to dramatize to excess, also OVERDRAMATISE [v]\n",
  "OVERDRAMATIZING": "OVERDRAMATIZE, to dramatize to excess, also OVERDRAMATISE [v]\n",
  "OVERDRANK": "OVERDRINK, to drink to excess [v]\n",
  "OVERDRAUGHT": "a current of air passing over, or coming from above, a fire in a furnace, kiln, etc. [n -S]\n",
  "OVERDRAUGHTS": "OVERDRAUGHT, a current of air passing over, or coming from above, a fire in a furnace, kiln, etc. [n]\n",
  "OVERDRAW": "to draw beyond one's credit [v OVERDREW, OVERDRAWN, OVERDRAWING, OVERDRAWS]\n",
  "OVERDRAWING": "OVERDRAW, to draw beyond one's credit [v]\n",
  "OVERDRAWN": "OVERDRAW, to draw beyond one's credit [v]\n",
  "OVERDRAWS": "OVERDRAW, to draw beyond one's credit [v]\n",
  "OVERDRESS": "to dress or adorn to excess; to dress too much [v -ED, -ING, -ES]\n",
  "OVERDRESSED": "OVERDRESS, to dress or adorn to excess; to dress too much [v]\n",
  "OVERDRESSES": "OVERDRESS, to dress or adorn to excess; to dress too much [v]\n",
  "OVERDRESSING": "OVERDRESS, to dress or adorn to excess; to dress too much [v]\n",
  "OVERDREW": "OVERDRAW, to draw beyond one's credit [v]\n",
  "OVERDRIED": "OVERDRY, to dry too much [v]\n",
  "OVERDRIES": "OVERDRY, to dry too much [v]\n",
  "OVERDRINK": "to drink to excess [v OVERDRANK, OVERDRUNK, OVERDRINKING, OVERDRINKS]\n",
  "OVERDRINKING": "OVERDRINK, to drink to excess [v]\n",
  "OVERDRINKS": "OVERDRINK, to drink to excess [v]\n",
  "OVERDRIVE": "to drive to excess [v OVERDROVE, OVERDRIVEN, OVERDRIVING, OVERDRIVES]\n",
  "OVERDRIVEN": "OVERDRIVE, to drive to excess [v]\n",
  "OVERDRIVES": "OVERDRIVE, to drive to excess [v]\n",
  "OVERDRIVING": "OVERDRIVE, to drive to excess [v]\n",
  "OVERDROVE": "OVERDRIVE, to drive to excess [v]\n",
  "OVERDRUNK": "OVERDRINK, to drink to excess [v]\n",
  "OVERDRY": "to dry too much [v OVERDRIED, OVERDRYING, OVERDRIES]\n",
  "OVERDRYING": "OVERDRY, to dry too much [v]\n",
  "OVERDUB": "to add sound to a recording [v OVERDUBBED, OVERDUBBING, OVERDUBS]\n",
  "OVERDUBBED": "OVERDUB, to add sound to a recording [v]\n",
  "OVERDUBBING": "OVERDUB, to add sound to a recording [v]\n",
  "OVERDUBS": "OVERDUB, to add sound to a recording [v]\n",
  "OVERDUE": "due and more than due [adj]\n",
  "OVERDUST": "to dust over [v -ED, -ING, -S]\n",
  "OVERDUSTED": "OVERDUST, to dust over [v]\n",
  "OVERDUSTING": "OVERDUST, to dust over [v]\n",
  "OVERDUSTS": "OVERDUST, to dust over [v]\n",
  "OVERDYE": "to dye with too much colour [v OVERDYED, OVERDYEING, OVERDYES]\n",
  "OVERDYED": "OVERDYE, to dye with too much colour [v]\n",
  "OVERDYEING": "OVERDYE, to dye with too much colour [v]\n",
  "OVERDYER": "one who overdyes [n -S]\n",
  "OVERDYERS": "OVERDYER, one who overdyes [n]\n",
  "OVERDYES": "OVERDYE, to dye with too much colour [v]\n",
  "OVEREAGER": "too eager; too impatient [adj]\n",
  "OVEREAGERNESS": "OVEREAGER, too eager; too impatient [n]\n",
  "OVEREAGERNESSES": "OVEREAGERNESS, OVEREAGER, too eager; too impatient [n]\n",
  "OVEREARNEST": "excessively earnest [adj]\n",
  "OVEREASIER": "OVEREASY, too easy [adj]\n",
  "OVEREASIEST": "OVEREASY, too easy [adj]\n",
  "OVEREASY": "too easy [adj OVEREASIER, OVEREASIEST]\n",
  "OVEREAT": "to eat to excess [v OVERATE, OVEREATEN, OVEREATING, OVEREATS]\n",
  "OVEREATEN": "OVEREAT, to eat to excess [v]\n",
  "OVEREATER": "one who overeats [n -S]\n",
  "OVEREATERS": "OVEREATER, one who overeats [n]\n",
  "OVEREATING": "excessive eating [n -S]\n",
  "OVEREATINGS": "OVEREATING, excessive eating [n]\n",
  "OVEREATS": "OVEREAT, to eat to excess [v]\n",
  "OVERED": "OVER, to go, leap or vault over [v]\n",
  "OVEREDIT": "to edit more than necessary [v -ED, -ING, -S]\n",
  "OVEREDITED": "OVEREDIT, to edit more than necessary [v]\n",
  "OVEREDITING": "OVEREDIT, to edit more than necessary [v]\n",
  "OVEREDITS": "OVEREDIT, to edit more than necessary [v]\n",
  "OVEREDUCATE": "to educate to excess [v OVEREDUCATED, OVEREDUCATING, OVEREDUCATES]\n",
  "OVEREDUCATED": "OVEREDUCATE, to educate to excess [v]\n",
  "OVEREDUCATES": "OVEREDUCATE, to educate to excess [v]\n",
  "OVEREDUCATING": "OVEREDUCATE, to educate to excess [v]\n",
  "OVEREDUCATION": "excessive education [n -S]\n",
  "OVEREDUCATIONS": "OVEREDUCATION, excessive education [n]\n",
  "OVEREFFUSIVE": "excessively effusive [adj]\n",
  "OVEREGG": "to exaggerate absurdly [v -ED, -ING, -S]\n",
  "OVEREGGED": "OVEREGG, to exaggerate absurdly [v]\n",
  "OVEREGGING": "OVEREGG, to exaggerate absurdly [v]\n",
  "OVEREGGS": "OVEREGG, to exaggerate absurdly [v]\n",
  "OVERELABORATE": "to elaborate excessively [v OVERELABORATED, OVERELABORATING, OVERELABORATES]\n",
  "OVERELABORATED": "OVERELABORATE, to elaborate excessively [v]\n",
  "OVERELABORATES": "OVERELABORATE, to elaborate excessively [v]\n",
  "OVERELABORATING": "OVERELABORATE, to elaborate excessively [v]\n",
  "OVERELABORATION": "excessive elaboration [n]\n",
  "OVEREMBELLISH": "to embellish to excess [v OVEREMBELLISHED, OVEREMBELLISHES]\n",
  "OVEREMBELLISHED": "OVEREMBELLISH, to embellish to excess [v]\n",
  "OVEREMBELLISHES": "OVEREMBELLISH, to embellish to excess [v]\n",
  "OVEREMOTE": "to emote excessively [v OVEREMOTED, OVEREMOTING, OVEREMOTES]\n",
  "OVEREMOTED": "OVEREMOTE, to emote excessively [v]\n",
  "OVEREMOTES": "OVEREMOTE, to emote excessively [v]\n",
  "OVEREMOTING": "OVEREMOTE, to emote excessively [v]\n",
  "OVEREMOTIONAL": "excessively emotional [adj]\n",
  "OVEREMPHASES": "OVEREMPHASIS, excessive emphasis [n]\n",
  "OVEREMPHASIS": "excessive emphasis [n OVEREMPHASES]\n",
  "OVEREMPHASISE": "to emphasise to excess, also OVEREMPHASIZE [v OVEREMPHASISED, OVEREMPHASISING, OVEREMPHASISES]\n",
  "OVEREMPHASISED": "OVEREMPHASISE, to emphasise to excess, also OVEREMPHASIZE [v]\n",
  "OVEREMPHASISES": "OVEREMPHASISE, to emphasise to excess, also OVEREMPHASIZE [v]\n",
  "OVEREMPHASISING": "OVEREMPHASISE, to emphasise to excess, also OVEREMPHASIZE [v]\n",
  "OVEREMPHASIZE": "to emphasise to excess, also OVEREMPHASISE [v OVEREMPHASIZED, OVEREMPHASIZING, OVEREMPHASIZES]\n",
  "OVEREMPHASIZED": "OVEREMPHASIZE, to emphasise to excess, also OVEREMPHASISE [v]\n",
  "OVEREMPHASIZES": "OVEREMPHASIZE, to emphasise to excess, also OVEREMPHASISE [v]\n",
  "OVEREMPHASIZING": "OVEREMPHASIZE, to emphasise to excess, also OVEREMPHASISE [v]\n",
  "OVEREMPHATIC": "excessively emphatic [adj]\n",
  "OVEREMPLOYMENT": "the situation where workers cannot reduce the time or the number of hours they spend earning an income [n -S]\n",
  "OVEREMPLOYMENTS": "OVEREMPLOYMENT, the situation where workers cannot reduce the time or the number of hours they spend earning an income [n]\n",
  "OVERENAMORED": "excessively enamored, also OVERENAMOURED [adj]\n",
  "OVERENAMOURED": "excessively enamoured, also OVERENAMORED [adj]\n",
  "OVERENCOURAGE": "to encourage to excess [v OVERENCOURAGED, OVERENCOURAGING, OVERENCOURAGES]\n",
  "OVERENCOURAGED": "OVERENCOURAGE, to encourage to excess [v]\n",
  "OVERENCOURAGES": "OVERENCOURAGE, to encourage to excess [v]\n",
  "OVERENCOURAGING": "OVERENCOURAGE, to encourage to excess [v]\n",
  "OVERENERGETIC": "excessively energetic [adj]\n",
  "OVERENGINEER": "to engineer excessively [v -ED, -ING, -S]\n",
  "OVERENGINEERED": "OVERENGINEER, to engineer excessively [v]\n",
  "OVERENGINEERING": "OVERENGINEER, to engineer excessively [v]\n",
  "OVERENGINEERS": "OVERENGINEER, to engineer excessively [v]\n",
  "OVERENROLLED": "with too many enrolments [adj]\n",
  "OVERENTERTAINED": "excessively entertained [adj]\n",
  "OVERENTHUSIASM": "an excessive enthusiasm [n -S]\n",
  "OVERENTHUSIASMS": "OVERENTHUSIASM, an excessive enthusiasm [n]\n",
  "OVEREQUIP": "to equip, furnish with, or supply excessively [v OVEREQUIPPED, OVEREQUIPPING, OVEREQUIPS]\n",
  "OVEREQUIPPED": "excessively equipped [adj]\n",
  "OVEREQUIPPING": "OVEREQUIP, to equip, furnish with, or supply excessively [v]\n",
  "OVEREQUIPS": "OVEREQUIP, to equip, furnish with, or supply excessively [v]\n",
  "OVERESTIMATE": "to estimate too high [v OVERESTIMATED, OVERESTIMATING, OVERESTIMATES]\n",
  "OVERESTIMATED": "OVERESTIMATE, to estimate too high [v]\n",
  "OVERESTIMATES": "OVERESTIMATE, to estimate too high [v]\n",
  "OVERESTIMATING": "OVERESTIMATE, to estimate too high [v]\n",
  "OVERESTIMATION": "the act of overestimating [n -S]\n",
  "OVERESTIMATIONS": "OVERESTIMATION, the act of overestimating [n]\n",
  "OVEREVALUATION": "excessive evaluation [n -S]\n",
  "OVEREVALUATIONS": "OVEREVALUATION, excessive evaluation [n]\n",
  "OVEREXAGGERATE": "to exaggerate excessively [v OVEREXAGGERATED, OVEREXAGGERATES]\n",
  "OVEREXAGGERATED": "OVEREXAGGERATE, to exaggerate excessively [v]\n",
  "OVEREXAGGERATES": "OVEREXAGGERATE, to exaggerate excessively [v]\n",
  "OVEREXCITABLE": "excessively excitable [adj]\n",
  "OVEREXCITE": "to excite too much [v OVEREXCITED, OVEREXCITING, OVEREXCITES]\n",
  "OVEREXCITED": "OVEREXCITE, to excite too much [v]\n",
  "OVEREXCITEMENT": "excessive excitement [n -S]\n",
  "OVEREXCITEMENTS": "OVEREXCITEMENT, excessive excitement [n]\n",
  "OVEREXCITES": "OVEREXCITE, to excite too much [v]\n",
  "OVEREXCITING": "OVEREXCITE, to excite too much [v]\n",
  "OVEREXERCISE": "to exercise to excess [v OVEREXERCISED, OVEREXERCISING, OVEREXERCISES]\n",
  "OVEREXERCISED": "OVEREXERCISE, to exercise to excess [v]\n",
  "OVEREXERCISES": "OVEREXERCISE, to exercise to excess [v]\n",
  "OVEREXERCISING": "OVEREXERCISE, to exercise to excess [v]\n",
  "OVEREXERT": "to exert oneself to excess [v -ED, -ING, -S]\n",
  "OVEREXERTED": "OVEREXERT, to exert oneself to excess [v]\n",
  "OVEREXERTING": "OVEREXERT, to exert oneself to excess [v]\n",
  "OVEREXERTION": "excessive exertion [n -S]\n",
  "OVEREXERTIONS": "OVEREXERTION, excessive exertion [n]\n",
  "OVEREXERTS": "OVEREXERT, to exert oneself to excess [v]\n",
  "OVEREXPAND": "to expand excessively [v -ED, -ING, -S]\n",
  "OVEREXPANDED": "OVEREXPAND, to expand excessively [v]\n",
  "OVEREXPANDING": "OVEREXPAND, to expand excessively [v]\n",
  "OVEREXPANDS": "OVEREXPAND, to expand excessively [v]\n",
  "OVEREXPANSION": "excessive expansion [n -S]\n",
  "OVEREXPANSIONS": "OVEREXPANSION, excessive expansion [n]\n",
  "OVEREXPECTATION": "excessive expectation [n]\n",
  "OVEREXPLAIN": "to explain to excess [v -ED, -ING, -S]\n",
  "OVEREXPLAINED": "OVEREXPLAIN, to explain to excess [v]\n",
  "OVEREXPLAINING": "OVEREXPLAIN, to explain to excess [v]\n",
  "OVEREXPLAINS": "OVEREXPLAIN, to explain to excess [v]\n",
  "OVEREXPLICIT": "excessively explicit [adj]\n",
  "OVEREXPLOIT": "to exploit to excess [v -ED, -ING, -S]\n",
  "OVEREXPLOITED": "OVEREXPLOIT, to exploit to excess [v]\n",
  "OVEREXPLOITING": "OVEREXPLOIT, to exploit to excess [v]\n",
  "OVEREXPLOITS": "OVEREXPLOIT, to exploit to excess [v]\n",
  "OVEREXPOSE": "to expose excessively [v OVEREXPOSED, OVEREXPOSING, OVEREXPOSES]\n",
  "OVEREXPOSED": "OVEREXPOSE, to expose excessively [v]\n",
  "OVEREXPOSES": "OVEREXPOSE, to expose excessively [v]\n",
  "OVEREXPOSING": "OVEREXPOSE, to expose excessively [v]\n",
  "OVEREXPOSURE": "excessive exposure [n -S]\n",
  "OVEREXPOSURES": "OVEREXPOSURE, excessive exposure [n]\n",
  "OVEREXTEND": "to extend beyond a safe or reasonable point [v -ED, -ING, -S]\n",
  "OVEREXTENDED": "OVEREXTEND, to extend beyond a safe or reasonable point [v]\n",
  "OVEREXTENDING": "OVEREXTEND, to extend beyond a safe or reasonable point [v]\n",
  "OVEREXTENDS": "OVEREXTEND, to extend beyond a safe or reasonable point [v]\n",
  "OVEREXTENSION": "an excessive extension [n -S]\n",
  "OVEREXTENSIONS": "OVEREXTENSION, an excessive extension [n]\n",
  "OVEREXTRACTION": "excessive extraction [n -S]\n",
  "OVEREXTRACTIONS": "OVEREXTRACTION, excessive extraction [n]\n",
  "OVEREXTRAVAGANT": "excessively extravagant [adj]\n",
  "OVEREXUBERANT": "excessively exuberant [adj]\n",
  "OVEREYE": "to survey [v OVEREYED, OVEREYING or OVEREYEING, OVEREYES]\n",
  "OVEREYED": "OVEREYE, to survey [v]\n",
  "OVEREYEING": "OVEREYE, to survey [v]\n",
  "OVEREYES": "OVEREYE, to survey [v]\n",
  "OVEREYING": "OVEREYE, to survey [v]\n",
  "OVERFACILE": "too facile [adj]\n",
  "OVERFALL": "to fall over [v OVERFELL, OVERFALLEN, OVERFALLING, OVERFALLS]\n",
  "OVERFALLEN": "OVERFALL, to fall over [v]\n",
  "OVERFALLING": "OVERFALL, to fall over [v]\n",
  "OVERFALLS": "OVERFALL, to fall over [v]\n",
  "OVERFAMILIAR": "excessively familiar [adj]\n",
  "OVERFAMILIARITY": "the state of being overfamiliar [n]\n",
  "OVERFAR": "too far [adj]\n",
  "OVERFAST": "too fast [adj]\n",
  "OVERFASTIDIOUS": "excessively fastidious [adj]\n",
  "OVERFAT": "too fat [adj]\n",
  "OVERFATIGUE": "a state of excessive fatigue [n -S]\n",
  "OVERFATIGUED": "excessively fatigued [adj]\n",
  "OVERFATIGUES": "OVERFATIGUE, a state of excessive fatigue [n]\n",
  "OVERFATIGUING": "excessively fatiguing [adj]\n",
  "OVERFAVOR": "to favor excessively [v -ED, -ING, -S]\n",
  "OVERFAVORED": "OVERFAVOR, to favor excessively [v]\n",
  "OVERFAVORING": "OVERFAVOR, to favor excessively [v]\n",
  "OVERFAVORS": "OVERFAVOR, to favor excessively [v]\n",
  "OVERFAVOUR": "to favour excessively [v -ED, -ING, -S]\n",
  "OVERFAVOURED": "OVERFAVOUR, to favour excessively [v]\n",
  "OVERFAVOURING": "OVERFAVOUR, to favour excessively [v]\n",
  "OVERFAVOURS": "OVERFAVOUR, to favour excessively [v]\n",
  "OVERFEAR": "to fear too much [v -ED, -ING, -S]\n",
  "OVERFEARED": "OVERFEAR, to fear too much [v]\n",
  "OVERFEARING": "OVERFEAR, to fear too much [v]\n",
  "OVERFEARS": "OVERFEAR, to fear too much [v]\n",
  "OVERFED": "OVERFEED, to feed too much [v]\n",
  "OVERFEED": "to feed too much [v OVERFED, OVERFEEDING, OVERFEEDS]\n",
  "OVERFEEDING": "excessive feeding [n -S]\n",
  "OVERFEEDINGS": "OVERFEEDING, excessive feeding [n]\n",
  "OVERFEEDS": "OVERFEED, to feed too much [v]\n",
  "OVERFELL": "OVERFALL, to fall over [v]\n",
  "OVERFERTILISE": "to fertilise excessively, also OVERFERTILIZE [v OVERFERTILISED, OVERFERTILISING, OVERFERTILISES]\n",
  "OVERFERTILISED": "OVERFERTILISE, to fertilise excessively, also OVERFERTILIZE [v]\n",
  "OVERFERTILISES": "OVERFERTILISE, to fertilise excessively, also OVERFERTILIZE [v]\n",
  "OVERFERTILISING": "OVERFERTILISE, to fertilise excessively, also OVERFERTILIZE [v]\n",
  "OVERFERTILIZE": "to fertilise excessively, also OVERFERTILISE [v OVERFERTILIZED, OVERFERTILIZING, OVERFERTILIZES]\n",
  "OVERFERTILIZED": "OVERFERTILIZE, to fertilise excessively, also OVERFERTILISE [v]\n",
  "OVERFERTILIZES": "OVERFERTILIZE, to fertilise excessively, also OVERFERTILISE [v]\n",
  "OVERFERTILIZING": "OVERFERTILIZE, to fertilise excessively, also OVERFERTILISE [v]\n",
  "OVERFILL": "to fill to overflowing [v -ED, -ING, -S]\n",
  "OVERFILLED": "OVERFILL, to fill to overflowing [v]\n",
  "OVERFILLING": "OVERFILL, to fill to overflowing [v]\n",
  "OVERFILLS": "OVERFILL, to fill to overflowing [v]\n",
  "OVERFINE": "too refined [adj]\n",
  "OVERFINENESS": "the state of being overfine [n -ES]\n",
  "OVERFINENESSES": "OVERFINENESS, the state of being overfine [n]\n",
  "OVERFINISHED": "excessively finished [adj]\n",
  "OVERFISH": "to deplete the fish supply too much [v -ED, -ING, -ES]\n",
  "OVERFISHED": "OVERFISH, to deplete the fish supply too much [v]\n",
  "OVERFISHES": "OVERFISH, to deplete the fish supply too much [v]\n",
  "OVERFISHING": "excessive fishing [n -S]\n",
  "OVERFISHINGS": "OVERFISHING, excessive fishing [n]\n",
  "OVERFIT": "excessively fit [adj]\n",
  "OVERFLEW": "OVERFLY, to fly over [v]\n",
  "OVERFLIES": "OVERFLY, to fly over [v]\n",
  "OVERFLIGHT": "a passage over an area in an aircraft [n -S]\n",
  "OVERFLIGHTS": "OVERFLIGHT, a passage over an area in an aircraft [n]\n",
  "OVERFLOOD": "to flood excessively [v -ED, -ING, -S]\n",
  "OVERFLOODED": "OVERFLOOD, to flood excessively [v]\n",
  "OVERFLOODING": "OVERFLOOD, to flood excessively [v]\n",
  "OVERFLOODS": "OVERFLOOD, to flood excessively [v]\n",
  "OVERFLOURISH": "to cover with blossom, or with flourishes or ornament [v -ED, -ING, -ES]\n",
  "OVERFLOURISHED": "OVERFLOURISH, to cover with blossom, or with flourishes or ornament [v]\n",
  "OVERFLOURISHES": "OVERFLOURISH, to cover with blossom, or with flourishes or ornament [v]\n",
  "OVERFLOURISHING": "OVERFLOURISH, to cover with blossom, or with flourishes or ornament [v]\n",
  "OVERFLOW": "to flow over the top of [v -ED, -ING, -S]\n",
  "OVERFLOWED": "OVERFLOW, to flow over the top of [v]\n",
  "OVERFLOWING": "abundant to excess [adj OVERFLOWINGLY] / the act of overflowing [n -S]\n",
  "OVERFLOWINGLY": "OVERFLOWING, abundant to excess [adv]\n",
  "OVERFLOWINGS": "OVERFLOWING, the act of overflowing [n]\n",
  "OVERFLOWN": "OVERFLY, to fly over [v]\n",
  "OVERFLOWS": "OVERFLOW, to flow over the top of [v]\n",
  "OVERFLUSH": "too flush [adj] / superfluity [n -ES]\n",
  "OVERFLUSHES": "OVERFLUSH, superfluity [n]\n",
  "OVERFLY": "to fly over [v OVERFLEW, OVERFLOWN, OVERFLYING, OVERFLIES]\n",
  "OVERFLYING": "OVERFLY, to fly over [v]\n",
  "OVERFOCUS": "to focus to excess [v OVERFOCUSED or OVERFOCUSSED, OVERFOCUSING or OVERFOCUSSING, OVERFOCUSES or OVERFOCUSSES]\n",
  "OVERFOCUSED": "OVERFOCUS, to focus to excess [v]\n",
  "OVERFOCUSES": "OVERFOCUS, to focus to excess [v]\n",
  "OVERFOCUSING": "OVERFOCUS, to focus to excess [v]\n",
  "OVERFOCUSSED": "OVERFOCUS, to focus to excess [v]\n",
  "OVERFOCUSSES": "OVERFOCUS, to focus to excess [v]\n",
  "OVERFOCUSSING": "OVERFOCUS, to focus to excess [v]\n",
  "OVERFOLD": "to fold over [v -ED, -ING, -S]\n",
  "OVERFOLDED": "OVERFOLD, to fold over [v]\n",
  "OVERFOLDING": "OVERFOLD, to fold over [v]\n",
  "OVERFOLDS": "OVERFOLD, to fold over [v]\n",
  "OVERFOND": "foolish to excess [adj OVERFONDLY]\n",
  "OVERFONDLY": "OVERFOND, foolish to excess [adv]\n",
  "OVERFONDNESS": "the state of being overfond [n -ES]\n",
  "OVERFONDNESSES": "OVERFONDNESS, the state of being overfond [n]\n",
  "OVERFORWARD": "excessively forward [adj]\n",
  "OVERFORWARDNESS": "OVERFORWARD, excessively forward [n]\n",
  "OVERFOUL": "excessively foul [adj]\n",
  "OVERFRANK": "too frank [adj]\n",
  "OVERFRAUGHT": "OVERFREIGHT, to overload [v]\n",
  "OVERFREE": "too liberal [adj OVERFREELY]\n",
  "OVERFREEDOM": "an excess of freedom [n -S]\n",
  "OVERFREEDOMS": "OVERFREEDOM, an excess of freedom [n]\n",
  "OVERFREELY": "OVERFREE, too liberal [adv]\n",
  "OVERFREIGHT": "to overload [v OVERFRAUGHT, OVERFREIGHTING, OVERFREIGHTS]\n",
  "OVERFREIGHTING": "OVERFREIGHT, to overload [v]\n",
  "OVERFREIGHTS": "OVERFREIGHT, to overload [v]\n",
  "OVERFULFIL": "to fulfil excessively [v OVERFULFILLED, OVERFULFILLING, OVERFULFILS]\n",
  "OVERFULFILL": "to fulfill to excess [v -ED, -ING, -S]\n",
  "OVERFULFILLED": "OVERFULFILL, to fulfill to excess [v]\n",
  "OVERFULFILLING": "OVERFULFILL, to fulfill to excess [v]\n",
  "OVERFULFILLS": "OVERFULFILL, to fulfill to excess [v]\n",
  "OVERFULFILS": "OVERFULFIL, to fulfil excessively [v]\n",
  "OVERFULL": "too full [adj]\n",
  "OVERFULLNESS": "the state of being overfull [n -ES]\n",
  "OVERFULLNESSES": "OVERFULLNESS, the state of being overfull [n]\n",
  "OVERFULNESS": "the state of being overfull [n -ES]\n",
  "OVERFULNESSES": "OVERFULNESS, the state of being overfull [n]\n",
  "OVERFUND": "to fund more than required [v -ED, -ING, -S]\n",
  "OVERFUNDED": "OVERFUND, to fund more than required [v]\n",
  "OVERFUNDING": "the act of funding to excess [n -S]\n",
  "OVERFUNDINGS": "OVERFUNDING, the act of funding to excess [n]\n",
  "OVERFUNDS": "OVERFUND, to fund more than required [v]\n",
  "OVERFUSSIER": "OVERFUSSY, too fussy [adj]\n",
  "OVERFUSSIEST": "OVERFUSSY, too fussy [adj]\n",
  "OVERFUSSY": "too fussy [adj OVERFUSSIER, OVERFUSSIEST]\n",
  "OVERGALL": "to greatly blister [v -ED, -ING, -S]\n",
  "OVERGALLED": "OVERGALL, to greatly blister [v]\n",
  "OVERGALLING": "OVERGALL, to greatly blister [v]\n",
  "OVERGALLS": "OVERGALL, to greatly blister [v]\n",
  "OVERGANG": "(Scots) to dominate; to overspread [v OVERWENT, OVERGONE, OVERGANGING, OVERGANGS]\n",
  "OVERGANGING": "OVERGANG, (Scots) to dominate; to overspread [v]\n",
  "OVERGANGS": "OVERGANG, (Scots) to dominate; to overspread [v]\n",
  "OVERGARMENT": "an outer garment [n -S]\n",
  "OVERGARMENTS": "OVERGARMENT, an outer garment [n]\n",
  "OVERGAVE": "OVERGIVE, (Spenser) to give up [v]\n",
  "OVERGEAR": "to cause a company to have too high a proportion of loan stock [v -ED, -ING, -S]\n",
  "OVERGEARED": "OVERGEAR, to cause a company to have too high a proportion of loan stock [v]\n",
  "OVERGEARING": "OVERGEAR, to cause a company to have too high a proportion of loan stock [v]\n",
  "OVERGEARS": "OVERGEAR, to cause a company to have too high a proportion of loan stock [v]\n",
  "OVERGENERALISE": "to generalise to excess, also OVERGENERALIZE [v OVERGENERALISED, OVERGENERALISES]\n",
  "OVERGENERALISED": "OVERGENERALISE, to generalise to excess, also OVERGENERALIZE [v]\n",
  "OVERGENERALISES": "OVERGENERALISE, to generalise to excess, also OVERGENERALIZE [v]\n",
  "OVERGENERALIZE": "to generalize to excess, also OVERGENERALISE [v OVERGENERALIZED, OVERGENERALIZES]\n",
  "OVERGENERALIZED": "OVERGENERALIZE, to generalize to excess, also OVERGENERALISE [v]\n",
  "OVERGENERALIZES": "OVERGENERALIZE, to generalize to excess, also OVERGENERALISE [v]\n",
  "OVERGENEROSITY": "excessive generosity [n]\n",
  "OVERGENEROUS": "excessively generous [adj OVERGENEROUSLY]\n",
  "OVERGENEROUSLY": "OVERGENEROUS, excessively generous [adv]\n",
  "OVERGET": "to get over, recover from [v OVERGOT, OVERGETTING, OVERGETS]\n",
  "OVERGETS": "OVERGET, to get over, recover from [v]\n",
  "OVERGETTING": "OVERGET, to get over, recover from [v]\n",
  "OVERGILD": "to gild over [v OVERGILT or OVERGILDED, OVERGILDING, OVERGILDS]\n",
  "OVERGILDED": "OVERGILD, to gild over [v]\n",
  "OVERGILDING": "OVERGILD, to gild over [v]\n",
  "OVERGILDS": "OVERGILD, to gild over [v]\n",
  "OVERGILT": "OVERGILD, to gild over [v]\n",
  "OVERGIRD": "to gird to excess [v OVERGIRT or OVERGIRDED, OVERGIRDING, OVERGIRDS]\n",
  "OVERGIRDED": "OVERGIRD, to gird to excess [v]\n",
  "OVERGIRDING": "OVERGIRD, to gird to excess [v]\n",
  "OVERGIRDS": "OVERGIRD, to gird to excess [v]\n",
  "OVERGIRT": "OVERGIRD, to gird to excess [v]\n",
  "OVERGIVE": "(Spenser) to give up [v OVERGAVE, OVERGIVEN, OVERGIVING, OVERGIVES]\n",
  "OVERGIVEN": "OVERGIVE, (Spenser) to give up [v]\n",
  "OVERGIVES": "OVERGIVE, (Spenser) to give up [v]\n",
  "OVERGIVING": "OVERGIVE, (Spenser) to give up [v]\n",
  "OVERGLAD": "excessively or unduly glad [adj]\n",
  "OVERGLAMORISE": "to glamorize to excess, also OVERGLAMORIZE [v OVERGLAMORISED, OVERGLAMORISING, OVERGLAMORISES]\n",
  "OVERGLAMORISED": "OVERGLAMORISE, to glamorize to excess, also OVERGLAMORIZE [v]\n",
  "OVERGLAMORISES": "OVERGLAMORISE, to glamorize to excess, also OVERGLAMORIZE [v]\n",
  "OVERGLAMORISING": "OVERGLAMORISE, to glamorize to excess, also OVERGLAMORIZE [v]\n",
  "OVERGLAMORIZE": "to glamorize to excess, also OVERGLAMORISE [v OVERGLAMORIZED, OVERGLAMORIZING, OVERGLAMORIZES]\n",
  "OVERGLAMORIZED": "OVERGLAMORIZE, to glamorize to excess, also OVERGLAMORISE [v]\n",
  "OVERGLAMORIZES": "OVERGLAMORIZE, to glamorize to excess, also OVERGLAMORISE [v]\n",
  "OVERGLAMORIZING": "OVERGLAMORIZE, to glamorize to excess, also OVERGLAMORISE [v]\n",
  "OVERGLANCE": "to glance over [v OVERGLANCED, OVERGLANCING, OVERGLANCES]\n",
  "OVERGLANCED": "OVERGLANCE, to glance over [v]\n",
  "OVERGLANCES": "OVERGLANCE, to glance over [v]\n",
  "OVERGLANCING": "OVERGLANCE, to glance over [v]\n",
  "OVERGLAZE": "to cover with a glaze [v OVERGLAZED, OVERGLAZING, OVERGLAZES]\n",
  "OVERGLAZED": "OVERGLAZE, to cover with a glaze [v]\n",
  "OVERGLAZES": "OVERGLAZE, to cover with a glaze [v]\n",
  "OVERGLAZING": "OVERGLAZE, to cover with a glaze [v]\n",
  "OVERGLOOM": "to cover with gloom [v -ED, -ING, -S]\n",
  "OVERGLOOMED": "OVERGLOOM, to cover with gloom [v]\n",
  "OVERGLOOMING": "OVERGLOOM, to cover with gloom [v]\n",
  "OVERGLOOMS": "OVERGLOOM, to cover with gloom [v]\n",
  "OVERGO": "to travel over [v OVERWENT, OVERGONE, OVERGOING, OVERGOES]\n",
  "OVERGOAD": "to goad too much [v -ED, -ING, -S]\n",
  "OVERGOADED": "OVERGOAD, to goad too much [v]\n",
  "OVERGOADING": "OVERGOAD, to goad too much [v]\n",
  "OVERGOADS": "OVERGOAD, to goad too much [v]\n",
  "OVERGOES": "OVERGO, to travel over [v]\n",
  "OVERGOING": "a passing over [n -S]\n",
  "OVERGOINGS": "OVERGOING, a passing over [n]\n",
  "OVERGONE": "OVERGO, to travel over [v]\n",
  "OVERGORGE": "(Shakespeare) to gorge to excess [v OVERGORGED, OVERGORGING, OVERGORGES]\n",
  "OVERGORGED": "OVERGORGE, (Shakespeare) to gorge to excess [v]\n",
  "OVERGORGES": "OVERGORGE, (Shakespeare) to gorge to excess [v]\n",
  "OVERGORGING": "OVERGORGE, (Shakespeare) to gorge to excess [v]\n",
  "OVERGOT": "OVERGET, to get over, recover from [v]\n",
  "OVERGOVERN": "to govern to excess [v -ED, -ING, -S]\n",
  "OVERGOVERNED": "OVERGOVERN, to govern to excess [v]\n",
  "OVERGOVERNING": "OVERGOVERN, to govern to excess [v]\n",
  "OVERGOVERNS": "OVERGOVERN, to govern to excess [v]\n",
  "OVERGRADE": "to grade too highly [v OVERGRADED, OVERGRADING, OVERGRADES]\n",
  "OVERGRADED": "OVERGRADE, to grade too highly [v]\n",
  "OVERGRADES": "OVERGRADE, to grade too highly [v]\n",
  "OVERGRADING": "OVERGRADE, to grade too highly [v]\n",
  "OVERGRAIN": "in painting, to grain over a surface already grained [v -ED, -ING, -S]\n",
  "OVERGRAINED": "OVERGRAIN, in painting, to grain over a surface already grained [v]\n",
  "OVERGRAINER": "a brush for overgraining [n -S]\n",
  "OVERGRAINERS": "OVERGRAINER, a brush for overgraining [n]\n",
  "OVERGRAINING": "OVERGRAIN, in painting, to grain over a surface already grained [v]\n",
  "OVERGRAINS": "OVERGRAIN, in painting, to grain over a surface already grained [v]\n",
  "OVERGRASS": "to grass over, conceal with grass [v -ED, -ING, -ES]\n",
  "OVERGRASSED": "OVERGRASS, to grass over, conceal with grass [v]\n",
  "OVERGRASSES": "OVERGRASS, to grass over, conceal with grass [v]\n",
  "OVERGRASSING": "OVERGRASS, to grass over, conceal with grass [v]\n",
  "OVERGRAZE": "to graze to excess [v OVERGRAZED, OVERGRAZING, OVERGRAZES]\n",
  "OVERGRAZED": "OVERGRAZE, to graze to excess [v]\n",
  "OVERGRAZES": "OVERGRAZE, to graze to excess [v]\n",
  "OVERGRAZING": "grazing to excess [n -S]\n",
  "OVERGRAZINGS": "OVERGRAZING, grazing to excess [n]\n",
  "OVERGREAT": "too great [adj]\n",
  "OVERGREEDIER": "OVERGREEDY, excessively greedy [adj]\n",
  "OVERGREEDIEST": "OVERGREEDY, excessively greedy [adj]\n",
  "OVERGREEDY": "excessively greedy [adj OVERGREEDIER, OVERGREEDIEST]\n",
  "OVERGREEN": "to cover with green or verdure [v -ED, -ING, -S]\n",
  "OVERGREENED": "OVERGREEN, to cover with green or verdure [v]\n",
  "OVERGREENING": "OVERGREEN, to cover with green or verdure [v]\n",
  "OVERGREENS": "OVERGREEN, to cover with green or verdure [v]\n",
  "OVERGREW": "OVERGROW, to grow over [v]\n",
  "OVERGROUND": "situated over or above ground; as, the overground portion of a plant [adj]\n",
  "OVERGROW": "to grow over [v OVERGREW, OVERGROWN, OVERGROWING, OVERGROWS]\n",
  "OVERGROWING": "OVERGROW, to grow over [v]\n",
  "OVERGROWN": "OVERGROW, to grow over [v]\n",
  "OVERGROWS": "OVERGROW, to grow over [v]\n",
  "OVERGROWTH": "excessive growth [n -S]\n",
  "OVERGROWTHS": "OVERGROWTH, excessive growth [n]\n",
  "OVERHAILE": "(Spenser) to overtake, also OVERHALE [v OVERHAILED, OVERHAILING, OVERHAILES]\n",
  "OVERHAILED": "OVERHAILE, (Spenser) to overtake, also OVERHALE [v]\n",
  "OVERHAILES": "OVERHAILE, (Spenser) to overtake, also OVERHALE [v]\n",
  "OVERHAILING": "OVERHAILE, (Spenser) to overtake, also OVERHALE [v]\n",
  "OVERHAIR": "fur covering of some animals [n -S]\n",
  "OVERHAIRS": "OVERHAIR, fur covering of some animals [n]\n",
  "OVERHALE": "(Spenser) to overtake, also OVERHAILE [v OVERHALED, OVERHALING, OVERHALES]\n",
  "OVERHALED": "OVERHALE, (Spenser) to overtake, also OVERHAILE [v]\n",
  "OVERHALES": "OVERHALE, (Spenser) to overtake, also OVERHAILE [v]\n",
  "OVERHALING": "OVERHALE, (Spenser) to overtake, also OVERHAILE [v]\n",
  "OVERHAND": "to sew with short vertical stitches [v -ED, -ING, -S]\n",
  "OVERHANDED": "OVERHAND, to sew with short vertical stitches [v]\n",
  "OVERHANDING": "OVERHAND, to sew with short vertical stitches [v]\n",
  "OVERHANDLE": "to handle, or use, too much [v OVERHANDLED, OVERHANDLING, OVERHANDLES]\n",
  "OVERHANDLED": "OVERHANDLE, to handle, or use, too much [v]\n",
  "OVERHANDLES": "OVERHANDLE, to handle, or use, too much [v]\n",
  "OVERHANDLING": "OVERHANDLE, to handle, or use, too much [v]\n",
  "OVERHANDS": "OVERHAND, to sew with short vertical stitches [v]\n",
  "OVERHANG": "to protrude over [v OVERHUNG, OVERHANGING, OVERHANGS]\n",
  "OVERHANGING": "OVERHANG, to protrude over [v]\n",
  "OVERHANGS": "OVERHANG, to protrude over [v]\n",
  "OVERHAPPIER": "OVERHAPPY, exceedingly happy [adj]\n",
  "OVERHAPPIEST": "OVERHAPPY, exceedingly happy [adj]\n",
  "OVERHAPPY": "exceedingly happy [adj OVERHAPPIER, OVERHAPPIEST]\n",
  "OVERHARD": "excessively hard [adj]\n",
  "OVERHARVEST": "to harvest to excess [v -ED, -ING, -S]\n",
  "OVERHARVESTED": "OVERHARVEST, to harvest to excess [v]\n",
  "OVERHARVESTING": "OVERHARVEST, to harvest to excess [v]\n",
  "OVERHARVESTS": "OVERHARVEST, to harvest to excess [v]\n",
  "OVERHASTE": "too great haste [n -S]\n",
  "OVERHASTES": "OVERHASTE, too great haste [n]\n",
  "OVERHASTILY": "OVERHASTY, too hasty [adv]\n",
  "OVERHASTINESS": "the state of being overhasty [n -ES]\n",
  "OVERHASTINESSES": "OVERHASTINESS, the state of being overhasty [n]\n",
  "OVERHASTY": "too hasty [adj OVERHASTILY]\n",
  "OVERHATE": "to hate to excess [v OVERHATED, OVERHATING, OVERHATES]\n",
  "OVERHATED": "OVERHATE, to hate to excess [v]\n",
  "OVERHATES": "OVERHATE, to hate to excess [v]\n",
  "OVERHATING": "OVERHATE, to hate to excess [v]\n",
  "OVERHAUL": "to examine carefully for needed repairs [v -ED, -ING, -S]\n",
  "OVERHAULED": "OVERHAUL, to examine carefully for needed repairs [v]\n",
  "OVERHAULING": "OVERHAUL, to examine carefully for needed repairs [v]\n",
  "OVERHAULS": "OVERHAUL, to examine carefully for needed repairs [v]\n",
  "OVERHEAD": "the general cost of running a business [n -S]\n",
  "OVERHEADS": "OVERHEAD, the general cost of running a business [n]\n",
  "OVERHEAP": "to heap up to excess [v -ED, -ING, -S]\n",
  "OVERHEAPED": "OVERHEAP, to heap up to excess [v]\n",
  "OVERHEAPING": "OVERHEAP, to heap up to excess [v]\n",
  "OVERHEAPS": "OVERHEAP, to heap up to excess [v]\n",
  "OVERHEAR": "to hear without the speaker's knowledge or intention [v OVERHEARD, OVERHEARING, OVERHEARS]\n",
  "OVERHEARD": "OVERHEAR, to hear without the speaker's knowledge or intention [v]\n",
  "OVERHEARING": "OVERHEAR, to hear without the speaker's knowledge or intention [v]\n",
  "OVERHEARS": "OVERHEAR, to hear without the speaker's knowledge or intention [v]\n",
  "OVERHEAT": "to heat to excess [v -ED, -ING, -S]\n",
  "OVERHEATED": "OVERHEAT, to heat to excess [v]\n",
  "OVERHEATING": "heating to excess [n -S]\n",
  "OVERHEATINGS": "OVERHEATING, heating to excess [n]\n",
  "OVERHEATS": "OVERHEAT, to heat to excess [v]\n",
  "OVERHELD": "OVERHOLD, (Shakespeare) to rate too highly [v]\n",
  "OVERHENT": "(Spenser) to overtake [v OVERHENT, OVERHENTING, OVERHENTS]\n",
  "OVERHENTING": "OVERHENT, (Spenser) to overtake [v]\n",
  "OVERHENTS": "OVERHENT, (Spenser) to overtake [v]\n",
  "OVERHIGH": "too high [adj]\n",
  "OVERHIT": "to hit a ball beyond a target [v OVERHIT, OVERHITTING, OVERHITS]\n",
  "OVERHITS": "OVERHIT, to hit a ball beyond a target [v]\n",
  "OVERHITTING": "OVERHIT, to hit a ball beyond a target [v]\n",
  "OVERHOLD": "(Shakespeare) to rate too highly [v OVERHELD, OVERHOLDING, OVERHOLDS]\n",
  "OVERHOLDING": "OVERHOLD, (Shakespeare) to rate too highly [v]\n",
  "OVERHOLDS": "OVERHOLD, (Shakespeare) to rate too highly [v]\n",
  "OVERHOLIER": "OVERHOLY, too holy [adj]\n",
  "OVERHOLIEST": "OVERHOLY, too holy [adj]\n",
  "OVERHOLY": "too holy [adj OVERHOLIER, OVERHOLIEST]\n",
  "OVERHOMOGENISE": "to homogenise excessively, also OVERHOMOGENIZE [v OVERHOMOGENISED, OVERHOMOGENISES]\n",
  "OVERHOMOGENISED": "OVERHOMOGENISE, to homogenise excessively, also OVERHOMOGENIZE [v]\n",
  "OVERHOMOGENISES": "OVERHOMOGENISE, to homogenise excessively, also OVERHOMOGENIZE [v]\n",
  "OVERHOMOGENIZE": "to homogenize to excess, also OVERHOMOGENISE [v OVERHOMOGENIZED, OVERHOMOGENIZES]\n",
  "OVERHOMOGENIZED": "OVERHOMOGENIZE, to homogenize to excess, also OVERHOMOGENISE [v]\n",
  "OVERHOMOGENIZES": "OVERHOMOGENIZE, to homogenize to excess, also OVERHOMOGENISE [v]\n",
  "OVERHONOR": "to honor too highly, also OVERHONOUR [v -ED, -ING, -S]\n",
  "OVERHONORED": "OVERHONOR, to honor too highly, also OVERHONOUR [v]\n",
  "OVERHONORING": "OVERHONOR, to honor too highly, also OVERHONOUR [v]\n",
  "OVERHONORS": "OVERHONOR, to honor too highly, also OVERHONOUR [v]\n",
  "OVERHONOUR": "to honour excessively, also OVERHONOR [v -ED, -ING, -S]\n",
  "OVERHONOURED": "OVERHONOUR, to honour excessively, also OVERHONOR [v]\n",
  "OVERHONOURING": "OVERHONOUR, to honour excessively, also OVERHONOR [v]\n",
  "OVERHONOURS": "OVERHONOUR, to honour excessively, also OVERHONOR [v]\n",
  "OVERHOPE": "to hope exceedingly [v OVERHOPED, OVERHOPING, OVERHOPES]\n",
  "OVERHOPED": "OVERHOPE, to hope exceedingly [v]\n",
  "OVERHOPES": "OVERHOPE, to hope exceedingly [v]\n",
  "OVERHOPING": "OVERHOPE, to hope exceedingly [v]\n",
  "OVERHOT": "excessively hot [adj]\n",
  "OVERHUNG": "OVERHANG, to protrude over [v]\n",
  "OVERHUNT": "to deplete game in an area [v -ED, -ING, -S]\n",
  "OVERHUNTED": "OVERHUNT, to deplete game in an area [v]\n",
  "OVERHUNTING": "hunting to excess [n -S]\n",
  "OVERHUNTINGS": "OVERHUNTING, hunting to excess [n]\n",
  "OVERHUNTS": "OVERHUNT, to deplete game in an area [v]\n",
  "OVERHYPE": "to hype to excess [v OVERHYPED, OVERHYPING, OVERHYPES]\n",
  "OVERHYPED": "OVERHYPE, to hype to excess [v]\n",
  "OVERHYPES": "OVERHYPE, to hype to excess [v]\n",
  "OVERHYPING": "OVERHYPE, to hype to excess [v]\n",
  "OVERIDEALISE": "to idealise to excess, also OVERIDEALIZE [v OVERIDEALISED, OVERIDEALISING, OVERIDEALISES]\n",
  "OVERIDEALISED": "OVERIDEALISE, to idealise to excess, also OVERIDEALIZE [v]\n",
  "OVERIDEALISES": "OVERIDEALISE, to idealise to excess, also OVERIDEALIZE [v]\n",
  "OVERIDEALISING": "OVERIDEALISE, to idealise to excess, also OVERIDEALIZE [v]\n",
  "OVERIDEALIZE": "to idealize to excess, also OVERIDEALISE [v OVERIDEALIZED, OVERIDEALIZING, OVERIDEALIZES]\n",
  "OVERIDEALIZED": "OVERIDEALIZE, to idealize to excess, also OVERIDEALISE [v]\n",
  "OVERIDEALIZES": "OVERIDEALIZE, to idealize to excess, also OVERIDEALISE [v]\n",
  "OVERIDEALIZING": "OVERIDEALIZE, to idealize to excess, also OVERIDEALISE [v]\n",
  "OVERIDENTIFIED": "OVERIDENTIFY, to identify to excess [v]\n",
  "OVERIDENTIFIES": "OVERIDENTIFY, to identify to excess [v]\n",
  "OVERIDENTIFY": "to identify to excess [v OVERIDENTIFIED, OVERIDENTIFYING, OVERIDENTIFIES]\n",
  "OVERIDENTIFYING": "OVERIDENTIFY, to identify to excess [v]\n",
  "OVERIDLE": "too idle [adj]\n",
  "OVERIMAGINATIVE": "excessively imaginative [adj]\n",
  "OVERIMPRESS": "to impress excessively [v -ED, -ING, -ES]\n",
  "OVERIMPRESSED": "OVERIMPRESS, to impress excessively [v]\n",
  "OVERIMPRESSES": "OVERIMPRESS, to impress excessively [v]\n",
  "OVERIMPRESSING": "OVERIMPRESS, to impress excessively [v]\n",
  "OVERINCLINED": "inclined to excess [adj]\n",
  "OVERINDULGE": "to indulge to excess [v OVERINDULGED, OVERINDULGING, OVERINDULGES]\n",
  "OVERINDULGED": "OVERINDULGE, to indulge to excess [v]\n",
  "OVERINDULGENCE": "excessive indulgence [n -S]\n",
  "OVERINDULGENCES": "OVERINDULGENCE, excessive indulgence [n]\n",
  "OVERINDULGENT": "excessively indulgent [adj]\n",
  "OVERINDULGES": "OVERINDULGE, to indulge to excess [v]\n",
  "OVERINDULGING": "OVERINDULGE, to indulge to excess [v]\n",
  "OVERINFLATE": "to inflate excessively [v OVERINFLATED, OVERINFLATING, OVERINFLATES]\n",
  "OVERINFLATED": "OVERINFLATE, to inflate excessively [v]\n",
  "OVERINFLATES": "OVERINFLATE, to inflate excessively [v]\n",
  "OVERINFLATING": "OVERINFLATE, to inflate excessively [v]\n",
  "OVERINFLATION": "excessive inflation [n -S]\n",
  "OVERINFLATIONS": "OVERINFLATION, excessive inflation [n]\n",
  "OVERINFORM": "to inform excessively [v -ED, -ING, -S]\n",
  "OVERINFORMED": "OVERINFORM, to inform excessively [v]\n",
  "OVERINFORMING": "OVERINFORM, to inform excessively [v]\n",
  "OVERINFORMS": "OVERINFORM, to inform excessively [v]\n",
  "OVERING": "OVER, to go, leap or vault over [v]\n",
  "OVERINGENIOUS": "excessively ingenious [adj]\n",
  "OVERINGENUITIES": "OVERINGENUITY, the state of being overingenious [n]\n",
  "OVERINGENUITY": "the state of being overingenious [n OVERINGENUITIES]\n",
  "OVERINKED": "concealed by the use of ink [adj]\n",
  "OVERINSISTENT": "excessively insistent [adj]\n",
  "OVERINSURANCE": "excessive insurance [n -S]\n",
  "OVERINSURANCES": "OVERINSURANCE, excessive insurance [n]\n",
  "OVERINSURE": "to insure to excess [v OVERINSURED, OVERINSURING, OVERINSURES]\n",
  "OVERINSURED": "OVERINSURE, to insure to excess [v]\n",
  "OVERINSURES": "OVERINSURE, to insure to excess [v]\n",
  "OVERINSURING": "OVERINSURE, to insure to excess [v]\n",
  "OVERINTENSE": "excessively intense [adj]\n",
  "OVERINTENSITIES": "OVERINTENSITY, excessive intensity [n]\n",
  "OVERINTENSITY": "excessive intensity [n OVERINTENSITIES]\n",
  "OVERINVESTMENT": "excessive investment [n -S]\n",
  "OVERINVESTMENTS": "OVERINVESTMENT, excessive investment [n]\n",
  "OVERISSUANCE": "excessive issuance [n -S]\n",
  "OVERISSUANCES": "OVERISSUANCE, excessive issuance [n]\n",
  "OVERISSUE": "to issue in excess (e.g. banknotes or bills of exchange) [v OVERISSUED, OVERISSUING, OVERISSUES]\n",
  "OVERISSUED": "OVERISSUE, to issue in excess (e.g. banknotes or bills of exchange) [v]\n",
  "OVERISSUES": "OVERISSUE, to issue in excess (e.g. banknotes or bills of exchange) [v]\n",
  "OVERISSUING": "OVERISSUE, to issue in excess (e.g. banknotes or bills of exchange) [v]\n",
  "OVERJOY": "to fill with great joy [v -ED, -ING, -S]\n",
  "OVERJOYED": "OVERJOY, to fill with great joy [v]\n",
  "OVERJOYING": "OVERJOY, to fill with great joy [v]\n",
  "OVERJOYS": "OVERJOY, to fill with great joy [v]\n",
  "OVERJUMP": "to jump too far [v -ED, -ING, -S]\n",
  "OVERJUMPED": "OVERJUMP, to jump too far [v]\n",
  "OVERJUMPING": "OVERJUMP, to jump too far [v]\n",
  "OVERJUMPS": "OVERJUMP, to jump too far [v]\n",
  "OVERJUST": "excessively just [adj]\n",
  "OVERKEEN": "excessively keen [adj]\n",
  "OVERKEEP": "to keep too long or too much [v OVERKEPT, OVERKEEPING, OVERKEEPS]\n",
  "OVERKEEPING": "OVERKEEP, to keep too long or too much [v]\n",
  "OVERKEEPS": "OVERKEEP, to keep too long or too much [v]\n",
  "OVERKEPT": "OVERKEEP, to keep too long or too much [v]\n",
  "OVERKEST": "(Spenser) overcast [adj]\n",
  "OVERKILL": "to destroy with more nuclear force than required [v -ED, -ING, -S]\n",
  "OVERKILLED": "OVERKILL, to destroy with more nuclear force than required [v]\n",
  "OVERKILLING": "OVERKILL, to destroy with more nuclear force than required [v]\n",
  "OVERKILLS": "OVERKILL, to destroy with more nuclear force than required [v]\n",
  "OVERKIND": "excessively kind [adj]\n",
  "OVERKINDNESS": "the state of being overkind [n -ES]\n",
  "OVERKINDNESSES": "OVERKINDNESS, the state of being overkind [n]\n",
  "OVERKING": "a king who has sovereignty over inferior kings or ruling princes [n -S]\n",
  "OVERKINGS": "OVERKING, a king who has sovereignty over inferior kings or ruling princes [n]\n",
  "OVERKNEE": "reaching above the knee [adj]\n",
  "OVERLABOR": "to cause to labor excessively; to overwork, also OVERLABOUR [v -ED, -ING, -S]\n",
  "OVERLABORED": "OVERLABOR, to cause to labor excessively; to overwork, also OVERLABOUR [v]\n",
  "OVERLABORING": "OVERLABOR, to cause to labor excessively; to overwork, also OVERLABOUR [v]\n",
  "OVERLABORS": "OVERLABOR, to cause to labor excessively; to overwork, also OVERLABOUR [v]\n",
  "OVERLABOUR": "(archaic) to labour excessively, also OVERLABOR [v -ED, -ING, -S]\n",
  "OVERLABOURED": "OVERLABOUR, (archaic) to labour excessively, also OVERLABOR [v]\n",
  "OVERLABOURING": "OVERLABOUR, (archaic) to labour excessively, also OVERLABOR [v]\n",
  "OVERLABOURS": "OVERLABOUR, (archaic) to labour excessively, also OVERLABOR [v]\n",
  "OVERLADE": "to load with too great a burden, also OVERLOAD [v OVERLADED, OVERLADING, OVERLADES]\n",
  "OVERLADED": "OVERLADE, to load with too great a burden, also OVERLOAD [v]\n",
  "OVERLADEN": "OVERLADE, to load with too great a burden, also OVERLOAD [v]\n",
  "OVERLADES": "OVERLADE, to load with too great a burden, also OVERLOAD [v]\n",
  "OVERLADING": "OVERLADE, to load with too great a burden, also OVERLOAD [v]\n",
  "OVERLAID": "OVERLAY, to lay over [v]\n",
  "OVERLAIN": "OVERLAY, to lay over [v]\n",
  "OVERLAND": "to drive stock overland [v -ED, -ING, -S]\n",
  "OVERLANDED": "OVERLAND, to drive stock overland [v]\n",
  "OVERLANDER": "(Australian) a person who drives livestock overland, esp. for long distances [n -S]\n",
  "OVERLANDERS": "OVERLANDER, (Australian) a person who drives livestock overland, esp. for long distances [n]\n",
  "OVERLANDING": "OVERLAND, to drive stock overland [v]\n",
  "OVERLANDS": "OVERLAND, to drive stock overland [v]\n",
  "OVERLAP": "to extend over and cover [v OVERLAPPED, OVERLAPPING, OVERLAPS]\n",
  "OVERLAPPED": "OVERLAP, to extend over and cover [v]\n",
  "OVERLAPPING": "OVERLAP, to extend over and cover [v]\n",
  "OVERLAPS": "OVERLAP, to extend over and cover [v]\n",
  "OVERLARD": "to smear over as if with lard [v -ED, -ING, -S]\n",
  "OVERLARDED": "OVERLARD, to smear over as if with lard [v]\n",
  "OVERLARDING": "OVERLARD, to smear over as if with lard [v]\n",
  "OVERLARDS": "OVERLARD, to smear over as if with lard [v]\n",
  "OVERLARGE": "excessively large [adj]\n",
  "OVERLATE": "too late; exceedingly late [adj]\n",
  "OVERLAUNCH": "in shipbuilding, to join by long splices or scarfs [v -ED, -ING, -ES]\n",
  "OVERLAUNCHED": "OVERLAUNCH, in shipbuilding, to join by long splices or scarfs [v]\n",
  "OVERLAUNCHES": "OVERLAUNCH, in shipbuilding, to join by long splices or scarfs [v]\n",
  "OVERLAUNCHING": "OVERLAUNCH, in shipbuilding, to join by long splices or scarfs [v]\n",
  "OVERLAVISH": "lavish to excess [adj]\n",
  "OVERLAX": "excessively lax [adj]\n",
  "OVERLAY": "to lay over [v OVERLAID, OVERLAYING, OVERLAYS]\n",
  "OVERLAYING": "the act of overlaying [n -S]\n",
  "OVERLAYINGS": "OVERLAYING, the act of overlaying [n]\n",
  "OVERLAYS": "OVERLAY, to lay over [v]\n",
  "OVERLEAF": "on the other side of the page [adv]\n",
  "OVERLEAP": "to leap over, also OWERLOUP [v OVERLEAPED, OVERLEAPT, OVERLEAPING, OVERLEAPS]\n",
  "OVERLEAPED": "OVERLEAP, to leap over, also OWERLOUP [v]\n",
  "OVERLEAPING": "OVERLEAP, to leap over, also OWERLOUP [v]\n",
  "OVERLEAPS": "OVERLEAP, to leap over, also OWERLOUP [v]\n",
  "OVERLEAPT": "OVERLEAP, to leap over, also OWERLOUP [v]\n",
  "OVERLEARN": "to continue to study or practice after attaining proficiency [v OVERLEARNED or OVERLEARNT, OVERLEARNING, OVERLEARNS]\n",
  "OVERLEARNED": "OVERLEARN, to continue to study or practice after attaining proficiency [v]\n",
  "OVERLEARNING": "OVERLEARN, to continue to study or practice after attaining proficiency [v]\n",
  "OVERLEARNS": "OVERLEARN, to continue to study or practice after attaining proficiency [v]\n",
  "OVERLEARNT": "OVERLEARN, to continue to study or practice after attaining proficiency [v]\n",
  "OVERLEATHER": "(Shakespeare) the upper part of a shoe [n -S]\n",
  "OVERLEATHERS": "OVERLEATHER, (Shakespeare) the upper part of a shoe [n]\n",
  "OVERLEAVEN": "to leaven too much [v -ED, -ING, -S]\n",
  "OVERLEAVENED": "OVERLEAVEN, to leaven too much [v]\n",
  "OVERLEAVENING": "OVERLEAVEN, to leaven too much [v]\n",
  "OVERLEAVENS": "OVERLEAVEN, to leaven too much [v]\n",
  "OVERLEND": "to lend too much [v OVERLENT, OVERLENDING, OVERLENDS]\n",
  "OVERLENDING": "OVERLEND, to lend too much [v]\n",
  "OVERLENDS": "OVERLEND, to lend too much [v]\n",
  "OVERLENGTH": "excessive length [n -S]\n",
  "OVERLENGTHEN": "to lengthen excessively [v -ED, -ING, -S]\n",
  "OVERLENGTHENED": "OVERLENGTHEN, to lengthen excessively [v]\n",
  "OVERLENGTHENING": "OVERLENGTHEN, to lengthen excessively [v]\n",
  "OVERLENGTHENS": "OVERLENGTHEN, to lengthen excessively [v]\n",
  "OVERLENGTHS": "OVERLENGTH, excessive length [n]\n",
  "OVERLENT": "OVERLEND, to lend too much [v]\n",
  "OVERLET": "to let to excess [v OVERLET, OVERLETTING, OVERLETS]\n",
  "OVERLETS": "OVERLET, to let to excess [v]\n",
  "OVERLETTING": "OVERLET, to let to excess [v]\n",
  "OVERLEVERAGED": "(of a business organization) having an excessively high ratio of debt capital to equity capital [adj]\n",
  "OVERLEWD": "too lewd [adj]\n",
  "OVERLIE": "to lie above [v OVERLAY, OVERLAIN, OVERLYING, OVERLIES]\n",
  "OVERLIER": "one that lies above [n -S]\n",
  "OVERLIERS": "OVERLIER, one that lies above [n]\n",
  "OVERLIES": "OVERLIE, to lie above [v]\n",
  "OVERLIGHT": "to light too much [v OVERLIT or OVERLIGHTED, OVERLIGHTING, OVERLIGHTS]\n",
  "OVERLIGHTED": "OVERLIGHT, to light too much [v]\n",
  "OVERLIGHTING": "OVERLIGHT, to light too much [v]\n",
  "OVERLIGHTS": "OVERLIGHT, to light too much [v]\n",
  "OVERLIT": "OVERLIGHT, to light too much [v]\n",
  "OVERLITERAL": "too literal [adj]\n",
  "OVERLITERARY": "excessively literary [adj]\n",
  "OVERLIVE": "to outlive [v OVERLIVED, OVERLIVING, OVERLIVES]\n",
  "OVERLIVED": "OVERLIVE, to outlive [v]\n",
  "OVERLIVES": "OVERLIVE, to outlive [v]\n",
  "OVERLIVING": "OVERLIVE, to outlive [v]\n",
  "OVERLOAD": "to load to excess, also OVERLADE [v -ED, -ING, -S]\n",
  "OVERLOADED": "OVERLOAD, to load to excess, also OVERLADE [v]\n",
  "OVERLOADING": "OVERLOAD, to load to excess, also OVERLADE [v]\n",
  "OVERLOADS": "OVERLOAD, to load to excess, also OVERLADE [v]\n",
  "OVERLOCK": "to oversew to prevent fraying [v -ED, -ING, -S]\n",
  "OVERLOCKED": "OVERLOCK, to oversew to prevent fraying [v]\n",
  "OVERLOCKER": "a person or machine that overlocks, oversews a hem or fabric edge to prevent fraying [n -S]\n",
  "OVERLOCKERS": "OVERLOCKER, a person or machine that overlocks, oversews a hem or fabric edge to prevent fraying [n]\n",
  "OVERLOCKING": "oversewing a hem or fabric edge to prevent fraying [n -S]\n",
  "OVERLOCKINGS": "OVERLOCKING, oversewing a hem or fabric edge to prevent fraying [n]\n",
  "OVERLOCKS": "OVERLOCK, to oversew to prevent fraying [v]\n",
  "OVERLONG": "too long [adj]\n",
  "OVERLOOK": "to fail to notice [v -ED, -ING, -S]\n",
  "OVERLOOKED": "OVERLOOK, to fail to notice [v]\n",
  "OVERLOOKER": "one who overlooks [n -S]\n",
  "OVERLOOKERS": "OVERLOOKER, one who overlooks [n]\n",
  "OVERLOOKING": "OVERLOOK, to fail to notice [v]\n",
  "OVERLOOKS": "OVERLOOK, to fail to notice [v]\n",
  "OVERLORD": "to rule tyrannically [v -ED, -ING, -S]\n",
  "OVERLORDED": "OVERLORD, to rule tyrannically [v]\n",
  "OVERLORDING": "OVERLORD, to rule tyrannically [v]\n",
  "OVERLORDS": "OVERLORD, to rule tyrannically [v]\n",
  "OVERLORDSHIP": "the position of overlord [n -S]\n",
  "OVERLORDSHIPS": "OVERLORDSHIP, the position of overlord [n]\n",
  "OVERLOUD": "excessively loud [adj]\n",
  "OVERLOVE": "to love to excess [v OVERLOVED, OVERLOVING, OVERLOVES]\n",
  "OVERLOVED": "OVERLOVE, to love to excess [v]\n",
  "OVERLOVES": "OVERLOVE, to love to excess [v]\n",
  "OVERLOVING": "OVERLOVE, to love to excess [v]\n",
  "OVERLUSH": "excessively lush [adj]\n",
  "OVERLUSTY": "(Shakespeare) too lusty [adj]\n",
  "OVERLY": "to an excessive degree [adv]\n",
  "OVERLYING": "OVERLIE, to lie above [v]\n",
  "OVERMAN": "to provide with more men than needed [v OVERMANNED, OVERMANNING, OVERMANS] / a foreman [n OVERMEN]\n",
  "OVERMANAGE": "to manage to excess [v OVERMANAGED, OVERMANAGING, OVERMANAGES]\n",
  "OVERMANAGED": "OVERMANAGE, to manage to excess [v]\n",
  "OVERMANAGES": "OVERMANAGE, to manage to excess [v]\n",
  "OVERMANAGING": "OVERMANAGE, to manage to excess [v]\n",
  "OVERMANIES": "OVERMANY, an excess of people [n]\n",
  "OVERMANNED": "OVERMAN, to provide with more men than needed [v]\n",
  "OVERMANNERED": "excessively mannered [adj]\n",
  "OVERMANNING": "excessive manning [n -S]\n",
  "OVERMANNINGS": "OVERMANNING, excessive manning [n]\n",
  "OVERMANS": "OVERMAN, to provide with more men than needed [v]\n",
  "OVERMANTEL": "an ornamental structure set on a mantelshelf [n -S]\n",
  "OVERMANTELS": "OVERMANTEL, an ornamental structure set on a mantelshelf [n]\n",
  "OVERMANY": "an excess of people [n OVERMANIES]\n",
  "OVERMAST": "to provide with too long masts [v -ED, -ING, -S]\n",
  "OVERMASTED": "OVERMAST, to provide with too long masts [v]\n",
  "OVERMASTER": "to overpower [v -ED, -ING, -S]\n",
  "OVERMASTERED": "OVERMASTER, to overpower [v]\n",
  "OVERMASTERING": "OVERMASTER, to overpower [v]\n",
  "OVERMASTERS": "OVERMASTER, to overpower [v]\n",
  "OVERMASTING": "OVERMAST, to provide with too long masts [v]\n",
  "OVERMASTS": "OVERMAST, to provide with too long masts [v]\n",
  "OVERMATCH": "to be more than a match for [v -ED, -ING, -ES]\n",
  "OVERMATCHED": "OVERMATCH, to be more than a match for [v]\n",
  "OVERMATCHES": "OVERMATCH, to be more than a match for [v]\n",
  "OVERMATCHING": "OVERMATCH, to be more than a match for [v]\n",
  "OVERMATTER": "overset type matter, i.e. text that has been set but cannot be printed due to lack of space [n -S]\n",
  "OVERMATTERS": "OVERMATTER, overset type matter, i.e. text that has been set but cannot be printed due to lack of space [n]\n",
  "OVERMATURE": "excessively mature [adj]\n",
  "OVERMATURITIES": "OVERMATURITY, excessive maturity [n]\n",
  "OVERMATURITY": "excessive maturity [n OVERMATURITIES]\n",
  "OVERMEASURE": "to measure excessively [v OVERMEASURED, OVERMEASURING, OVERMEASURES]\n",
  "OVERMEASURED": "OVERMEASURE, to measure excessively [v]\n",
  "OVERMEASURES": "OVERMEASURE, to measure excessively [v]\n",
  "OVERMEASURING": "OVERMEASURE, to measure excessively [v]\n",
  "OVERMEDICATE": "to medicate to excess [v OVERMEDICATED, OVERMEDICATING, OVERMEDICATES]\n",
  "OVERMEDICATED": "OVERMEDICATE, to medicate to excess [v]\n",
  "OVERMEDICATES": "OVERMEDICATE, to medicate to excess [v]\n",
  "OVERMEDICATING": "OVERMEDICATE, to medicate to excess [v]\n",
  "OVERMEDICATION": "excessive medication [n -S]\n",
  "OVERMEDICATIONS": "OVERMEDICATION, excessive medication [n]\n",
  "OVERMEEK": "excessively meek [adj]\n",
  "OVERMELT": "to melt too much [v -ED, -ING, -S]\n",
  "OVERMELTED": "OVERMELT, to melt too much [v]\n",
  "OVERMELTING": "OVERMELT, to melt too much [v]\n",
  "OVERMELTS": "OVERMELT, to melt too much [v]\n",
  "OVERMEN": "OVERMAN, a foreman [n]\n",
  "OVERMERRIER": "OVERMERRY, excessively merry [adj]\n",
  "OVERMERRIEST": "OVERMERRY, excessively merry [adj]\n",
  "OVERMERRY": "excessively merry [adj OVERMERRIER, OVERMERRIEST]\n",
  "OVERMIGHTIER": "OVERMIGHTY, too powerful [adj]\n",
  "OVERMIGHTIEST": "OVERMIGHTY, too powerful [adj]\n",
  "OVERMIGHTY": "too powerful [adj OVERMIGHTIER, OVERMIGHTIEST]\n",
  "OVERMILD": "too mild [adj]\n",
  "OVERMILK": "to milk to excess [v -ED, -ING, -S]\n",
  "OVERMILKED": "OVERMILK, to milk to excess [v]\n",
  "OVERMILKING": "OVERMILK, to milk to excess [v]\n",
  "OVERMILKS": "OVERMILK, to milk to excess [v]\n",
  "OVERMINE": "to mine to excess [v OVERMINED, OVERMINING, OVERMINES]\n",
  "OVERMINED": "OVERMINE, to mine to excess [v]\n",
  "OVERMINES": "OVERMINE, to mine to excess [v]\n",
  "OVERMINING": "OVERMINE, to mine to excess [v]\n",
  "OVERMIX": "to mix too much [v -ED, -ING, -ES]\n",
  "OVERMIXED": "OVERMIX, to mix too much [v]\n",
  "OVERMIXES": "OVERMIX, to mix too much [v]\n",
  "OVERMIXING": "OVERMIX, to mix too much [v]\n",
  "OVERMODEST": "modest to excess [adj OVERMODESTLY]\n",
  "OVERMODESTLY": "OVERMODEST, modest to excess [adv]\n",
  "OVERMOUNT": "to rise above [v -ED, -ING, -S]\n",
  "OVERMOUNTED": "OVERMOUNT, to rise above [v]\n",
  "OVERMOUNTING": "OVERMOUNT, to rise above [v]\n",
  "OVERMOUNTS": "OVERMOUNT, to rise above [v]\n",
  "OVERMUCH": "an excess [n -ES]\n",
  "OVERMUCHES": "OVERMUCH, an excess [n]\n",
  "OVERMULTIPLIED": "OVERMULTIPLY, to become too numerous [v]\n",
  "OVERMULTIPLIES": "OVERMULTIPLY, to become too numerous [v]\n",
  "OVERMULTIPLY": "to become too numerous [v OVERMULTIPLIED, OVERMULTIPLYING, OVERMULTIPLIES]\n",
  "OVERMULTIPLYING": "OVERMULTIPLY, to become too numerous [v]\n",
  "OVERMULTITUDE": "(Milton) to outnumber [v OVERMULTITUDED, OVERMULTITUDING, OVERMULTITUDES]\n",
  "OVERMULTITUDED": "OVERMULTITUDE, (Milton) to outnumber [v]\n",
  "OVERMULTITUDES": "OVERMULTITUDE, (Milton) to outnumber [v]\n",
  "OVERMULTITUDING": "OVERMULTITUDE, (Milton) to outnumber [v]\n",
  "OVERMUSCLED": "with an excessive amount of muscle [adj]\n",
  "OVERNAME": "(Shakespeare) to repeat the names of [v OVERNAMED, OVERNAMING, OVERNAMES]\n",
  "OVERNAMED": "OVERNAME, (Shakespeare) to repeat the names of [v]\n",
  "OVERNAMES": "OVERNAME, (Shakespeare) to repeat the names of [v]\n",
  "OVERNAMING": "OVERNAME, (Shakespeare) to repeat the names of [v]\n",
  "OVERNEAR": "too near [adj]\n",
  "OVERNEAT": "too neat [adj]\n",
  "OVERNET": "to cover with a net [v OVERNETTED, OVERNETTING, OVERNETS]\n",
  "OVERNETS": "OVERNET, to cover with a net [v]\n",
  "OVERNETTED": "OVERNET, to cover with a net [v]\n",
  "OVERNETTING": "the act of covering with a net [n -S]\n",
  "OVERNETTINGS": "OVERNETTING, the act of covering with a net [n]\n",
  "OVERNEW": "excessively new [adj]\n",
  "OVERNICE": "excessively nice; fastidious [adj]\n",
  "OVERNICELY": "OVERNICE, excessively nice; fastidious [adv]\n",
  "OVERNICENESS": "the state of being overnice [n -ES]\n",
  "OVERNICENESSES": "OVERNICENESS, the state of being overnice [n]\n",
  "OVERNIGHT": "lasting a night, for a night [adj] / to stay overnight [v -ED, -ING, -S]\n",
  "OVERNIGHTED": "OVERNIGHT, to stay overnight [v]\n",
  "OVERNIGHTER": "a person staying overnight; an overnight bag [n -S]\n",
  "OVERNIGHTERS": "OVERNIGHTER, a person staying overnight; an overnight bag [n]\n",
  "OVERNIGHTING": "OVERNIGHT, to stay overnight [v]\n",
  "OVERNIGHTS": "OVERNIGHT, to stay overnight [v]\n",
  "OVERNOURISH": "to nourish excessively [v -ED, -ING, -ES]\n",
  "OVERNOURISHED": "OVERNOURISH, to nourish excessively [v]\n",
  "OVERNOURISHES": "OVERNOURISH, to nourish excessively [v]\n",
  "OVERNOURISHING": "OVERNOURISH, to nourish excessively [v]\n",
  "OVERNUTRITION": "excessive nutrition [n -S]\n",
  "OVERNUTRITIONS": "OVERNUTRITION, excessive nutrition [n]\n",
  "OVEROBVIOUS": "too obvious [adj]\n",
  "OVEROFFICE": "to domineer over by virtue of office [v OVEROFFICED, OVEROFFICING, OVEROFFICES]\n",
  "OVEROFFICED": "OVEROFFICE, to domineer over by virtue of office [v]\n",
  "OVEROFFICES": "OVEROFFICE, to domineer over by virtue of office [v]\n",
  "OVEROFFICING": "OVEROFFICE, to domineer over by virtue of office [v]\n",
  "OVEROPERATE": "to operate to excess [v OVEROPERATED, OVEROPERATING, OVEROPERATES]\n",
  "OVEROPERATED": "OVEROPERATE, to operate to excess [v]\n",
  "OVEROPERATES": "OVEROPERATE, to operate to excess [v]\n",
  "OVEROPERATING": "OVEROPERATE, to operate to excess [v]\n",
  "OVEROPINIONATED": "excessively opinionated [adj]\n",
  "OVEROPTIMISM": "excessive optimism [n -S]\n",
  "OVEROPTIMISMS": "OVEROPTIMISM, excessive optimism [n]\n",
  "OVEROPTIMIST": "one who is excessively optimistic [n -S]\n",
  "OVEROPTIMISTIC": "excessively optimistic [adj]\n",
  "OVEROPTIMISTS": "OVEROPTIMIST, one who is excessively optimistic [n]\n",
  "OVERORCHESTRATE": "to orchestrate excessively [v]\n",
  "OVERORGANISE": "to organise to excess, also OVERORGANIZE [v OVERORGANISED, OVERORGANISING, OVERORGANISES]\n",
  "OVERORGANISED": "OVERORGANISE, to organise to excess, also OVERORGANIZE [v]\n",
  "OVERORGANISES": "OVERORGANISE, to organise to excess, also OVERORGANIZE [v]\n",
  "OVERORGANISING": "OVERORGANISE, to organise to excess, also OVERORGANIZE [v]\n",
  "OVERORGANIZE": "to organize to excess, also OVERORGANISE [v OVERORGANIZED, OVERORGANIZING, OVERORGANIZES]\n",
  "OVERORGANIZED": "OVERORGANIZE, to organize to excess, also OVERORGANISE [v]\n",
  "OVERORGANIZES": "OVERORGANIZE, to organize to excess, also OVERORGANISE [v]\n",
  "OVERORGANIZING": "OVERORGANIZE, to organize to excess, also OVERORGANISE [v]\n",
  "OVERORNAMENT": "to ornament excessively [v -ED, -ING, -S]\n",
  "OVERORNAMENTED": "OVERORNAMENT, to ornament excessively [v]\n",
  "OVERORNAMENTING": "OVERORNAMENT, to ornament excessively [v]\n",
  "OVERORNAMENTS": "OVERORNAMENT, to ornament excessively [v]\n",
  "OVERPACK": "to pack to excess [v -ED, -ING, -S]\n",
  "OVERPACKAGE": "to package excessively [v OVERPACKAGED, OVERPACKAGING, OVERPACKAGES]\n",
  "OVERPACKAGED": "OVERPACKAGE, to package excessively [v]\n",
  "OVERPACKAGES": "OVERPACKAGE, to package excessively [v]\n",
  "OVERPACKAGING": "OVERPACKAGE, to package excessively [v]\n",
  "OVERPACKED": "OVERPACK, to pack to excess [v]\n",
  "OVERPACKING": "OVERPACK, to pack to excess [v]\n",
  "OVERPACKS": "OVERPACK, to pack to excess [v]\n",
  "OVERPAGE": "overleaf [adj]\n",
  "OVERPAID": "OVERPAY, to pay too much [v]\n",
  "OVERPAINT": "to color or describe too strongly [v -ED, -ING, -S]\n",
  "OVERPAINTED": "OVERPAINT, to color or describe too strongly [v]\n",
  "OVERPAINTING": "OVERPAINT, to color or describe too strongly [v]\n",
  "OVERPAINTS": "OVERPAINT, to color or describe too strongly [v]\n",
  "OVERPART": "to give an actor too difficult a part [v -ED, -ING, -S]\n",
  "OVERPARTED": "OVERPART, to give an actor too difficult a part [v]\n",
  "OVERPARTICULAR": "excessively particular [adj]\n",
  "OVERPARTING": "OVERPART, to give an actor too difficult a part [v]\n",
  "OVERPARTS": "OVERPART, to give an actor too difficult a part [v]\n",
  "OVERPASS": "to pass over [v -ED, -ING, -ES]\n",
  "OVERPASSED": "OVERPASS, to pass over [v]\n",
  "OVERPASSES": "OVERPASS, to pass over [v]\n",
  "OVERPASSING": "OVERPASS, to pass over [v]\n",
  "OVERPAST": "completely finished [adj]\n",
  "OVERPAY": "to pay too much [v OVERPAID, OVERPAYING, OVERPAYS]\n",
  "OVERPAYING": "OVERPAY, to pay too much [v]\n",
  "OVERPAYMENT": "an excessive payment [n -S]\n",
  "OVERPAYMENTS": "OVERPAYMENT, an excessive payment [n]\n",
  "OVERPAYS": "OVERPAY, to pay too much [v]\n",
  "OVERPEDAL": "to make excessive use of the sustaining pedal of a piano [v OVERPEDALED or OVERPEDALLED, OVERPEDALING or OVERPEDALLING, OVERPEDALS]\n",
  "OVERPEDALED": "OVERPEDAL, to make excessive use of the sustaining pedal of a piano [v]\n",
  "OVERPEDALING": "OVERPEDAL, to make excessive use of the sustaining pedal of a piano [v]\n",
  "OVERPEDALLED": "OVERPEDAL, to make excessive use of the sustaining pedal of a piano [v]\n",
  "OVERPEDALLING": "excessive pedalling [n -S]\n",
  "OVERPEDALLINGS": "OVERPEDALLING, excessive pedalling [n]\n",
  "OVERPEDALS": "OVERPEDAL, to make excessive use of the sustaining pedal of a piano [v]\n",
  "OVERPEER": "to peer over [v -ED, -ING, -S]\n",
  "OVERPEERED": "OVERPEER, to peer over [v]\n",
  "OVERPEERING": "OVERPEER, to peer over [v]\n",
  "OVERPEERS": "OVERPEER, to peer over [v]\n",
  "OVERPEOPLE": "to people too densely [v OVERPEOPLED, OVERPEOPLING, OVERPEOPLES]\n",
  "OVERPEOPLED": "OVERPEOPLE, to people too densely [v]\n",
  "OVERPEOPLES": "OVERPEOPLE, to people too densely [v]\n",
  "OVERPEOPLING": "OVERPEOPLE, to people too densely [v]\n",
  "OVERPERCH": "to fly up and perch on, also OREPEARCH [v -ED, -ING, -ES]\n",
  "OVERPERCHED": "OVERPERCH, to fly up and perch on, also OREPEARCH [v]\n",
  "OVERPERCHES": "OVERPERCH, to fly up and perch on, also OREPEARCH [v]\n",
  "OVERPERCHING": "OVERPERCH, to fly up and perch on, also OREPEARCH [v]\n",
  "OVERPERSUADE": "to persuade to act contrary to one's conviction or preference [v OVERPERSUADED, OVERPERSUADING, OVERPERSUADES]\n",
  "OVERPERSUADED": "OVERPERSUADE, to persuade to act contrary to one's conviction or preference [v]\n",
  "OVERPERSUADES": "OVERPERSUADE, to persuade to act contrary to one's conviction or preference [v]\n",
  "OVERPERSUADING": "OVERPERSUADE, to persuade to act contrary to one's conviction or preference [v]\n",
  "OVERPERSUASION": "excessive persuasion [n -S]\n",
  "OVERPERSUASIONS": "OVERPERSUASION, excessive persuasion [n]\n",
  "OVERPERT": "excessively pert [adj]\n",
  "OVERPESSIMISTIC": "excessively pessimistic [adj]\n",
  "OVERPICTURE": "to picture to excess [v OVERPICTURED, OVERPICTURING, OVERPICTURES]\n",
  "OVERPICTURED": "OVERPICTURE, to picture to excess [v]\n",
  "OVERPICTURES": "OVERPICTURE, to picture to excess [v]\n",
  "OVERPICTURING": "OVERPICTURE, to picture to excess [v]\n",
  "OVERPITCH": "in cricket, to bowl a ball so that its trajectory brings it too close to the stumps [v -ED, -ING, -ES]\n",
  "OVERPITCHED": "OVERPITCH, in cricket, to bowl a ball so that its trajectory brings it too close to the stumps [v]\n",
  "OVERPITCHES": "OVERPITCH, in cricket, to bowl a ball so that its trajectory brings it too close to the stumps [v]\n",
  "OVERPITCHING": "OVERPITCH, in cricket, to bowl a ball so that its trajectory brings it too close to the stumps [v]\n",
  "OVERPLACED": "placed above [adj]\n",
  "OVERPLAID": "a textile design consisting of a plaid pattern superimposed on another plaid [n -S]\n",
  "OVERPLAIDED": "covered with a textile design consisting of a plaid pattern superimposed on another plaid [adj]\n",
  "OVERPLAIDS": "OVERPLAID, a textile design consisting of a plaid pattern superimposed on another plaid [n]\n",
  "OVERPLAN": "to plan to excess [v OVERPLANNED, OVERPLANNING, OVERPLANS]\n",
  "OVERPLANNED": "OVERPLAN, to plan to excess [v]\n",
  "OVERPLANNING": "excessive planning [n -S]\n",
  "OVERPLANNINGS": "OVERPLANNING, excessive planning [n]\n",
  "OVERPLANS": "OVERPLAN, to plan to excess [v]\n",
  "OVERPLANT": "to plant to excess [v -ED, -ING, -S]\n",
  "OVERPLANTED": "OVERPLANT, to plant to excess [v]\n",
  "OVERPLANTING": "OVERPLANT, to plant to excess [v]\n",
  "OVERPLANTS": "OVERPLANT, to plant to excess [v]\n",
  "OVERPLAST": "(Spenser) overplaced, placed above [adj]\n",
  "OVERPLAY": "to exaggerate [v -ED, -ING, -S]\n",
  "OVERPLAYED": "OVERPLAY, to exaggerate [v]\n",
  "OVERPLAYING": "OVERPLAY, to exaggerate [v]\n",
  "OVERPLAYS": "OVERPLAY, to exaggerate [v]\n",
  "OVERPLIED": "OVERPLY, to ply to excess; overwork [v]\n",
  "OVERPLIES": "OVERPLY, to ply to excess; overwork [v]\n",
  "OVERPLOT": "to devise an overly complex plot for [v OVERPLOTTED, OVERPLOTTING, OVERPLOTS]\n",
  "OVERPLOTS": "OVERPLOT, to devise an overly complex plot for [v]\n",
  "OVERPLOTTED": "OVERPLOT, to devise an overly complex plot for [v]\n",
  "OVERPLOTTING": "excessive plotting [n -S]\n",
  "OVERPLOTTINGS": "OVERPLOTTING, excessive plotting [n]\n",
  "OVERPLUS": "a surplus [n OVERPLUSES or OVERPLUSSES]\n",
  "OVERPLUSES": "OVERPLUS, a surplus [n]\n",
  "OVERPLUSSES": "OVERPLUS, a surplus [n]\n",
  "OVERPLY": "to ply to excess; overwork [v OVERPLIED, OVERPLYING, OVERPLIES]\n",
  "OVERPLYING": "OVERPLY, to ply to excess; overwork [v]\n",
  "OVERPOISE": "to burden with weight sufficient to weigh another down [v OVERPOISED, OVERPOISING, OVERPOISES]\n",
  "OVERPOISED": "OVERPOISE, to burden with weight sufficient to weigh another down [v]\n",
  "OVERPOISES": "OVERPOISE, to burden with weight sufficient to weigh another down [v]\n",
  "OVERPOISING": "OVERPOISE, to burden with weight sufficient to weigh another down [v]\n",
  "OVERPOPULATE": "to populate too densely [v OVERPOPULATED, OVERPOPULATING, OVERPOPULATES]\n",
  "OVERPOPULATED": "OVERPOPULATE, to populate too densely [v]\n",
  "OVERPOPULATES": "OVERPOPULATE, to populate too densely [v]\n",
  "OVERPOPULATING": "OVERPOPULATE, to populate too densely [v]\n",
  "OVERPOPULATION": "population so dense as to cause environmental deterioration [n -S]\n",
  "OVERPOPULATIONS": "OVERPOPULATION, population so dense as to cause environmental deterioration [n]\n",
  "OVERPOST": "to hasten over quickly [v -ED, -ING, -S]\n",
  "OVERPOSTED": "OVERPOST, to hasten over quickly [v]\n",
  "OVERPOSTING": "OVERPOST, to hasten over quickly [v]\n",
  "OVERPOSTS": "OVERPOST, to hasten over quickly [v]\n",
  "OVERPOTENT": "too potent or powerful [adj]\n",
  "OVERPOWER": "to overcome or reduce to helplessness [v -ED, -ING, -S]\n",
  "OVERPOWERED": "OVERPOWER, to overcome or reduce to helplessness [v]\n",
  "OVERPOWERING": "OVERPOWER, to overcome or reduce to helplessness [v]\n",
  "OVERPOWERINGLY": "OVERPOWERING, OVERPOWER, to overcome or reduce to helplessness [adv]\n",
  "OVERPOWERS": "OVERPOWER, to overcome or reduce to helplessness [v]\n",
  "OVERPRAISE": "to praise excessively [v OVERPRAISED, OVERPRAISING, OVERPRAISES]\n",
  "OVERPRAISED": "OVERPRAISE, to praise excessively [v]\n",
  "OVERPRAISES": "OVERPRAISE, to praise excessively [v]\n",
  "OVERPRAISING": "OVERPRAISE, to praise excessively [v]\n",
  "OVERPRECISE": "too precise [adj]\n",
  "OVERPREPARATION": "excessive preparation [n]\n",
  "OVERPREPARE": "to prepare excessively [v OVERPREPARED, OVERPREPARING, OVERPREPARES]\n",
  "OVERPREPARED": "OVERPREPARE, to prepare excessively [v]\n",
  "OVERPREPARES": "OVERPREPARE, to prepare excessively [v]\n",
  "OVERPREPARING": "OVERPREPARE, to prepare excessively [v]\n",
  "OVERPRESCRIBE": "to prescribe excessively [v OVERPRESCRIBED, OVERPRESCRIBING, OVERPRESCRIBES]\n",
  "OVERPRESCRIBED": "OVERPRESCRIBE, to prescribe excessively [v]\n",
  "OVERPRESCRIBES": "OVERPRESCRIBE, to prescribe excessively [v]\n",
  "OVERPRESCRIBING": "OVERPRESCRIBE, to prescribe excessively [v]\n",
  "OVERPRESS": "to oppress, burden too heavily [v -ED, -ING, -ES]\n",
  "OVERPRESSED": "OVERPRESS, to oppress, burden too heavily [v]\n",
  "OVERPRESSES": "OVERPRESS, to oppress, burden too heavily [v]\n",
  "OVERPRESSING": "OVERPRESS, to oppress, burden too heavily [v]\n",
  "OVERPRESSURE": "pressure significantly above what is usual or normal [n -S]\n",
  "OVERPRESSURES": "OVERPRESSURE, pressure significantly above what is usual or normal [n]\n",
  "OVERPRICE": "to set an excessive price on [v OVERPRICED, OVERPRICING, OVERPRICES]\n",
  "OVERPRICED": "OVERPRICE, to set an excessive price on [v]\n",
  "OVERPRICES": "OVERPRICE, to set an excessive price on [v]\n",
  "OVERPRICING": "OVERPRICE, to set an excessive price on [v]\n",
  "OVERPRINT": "to print over something already printed [v -ED, -ING, -S]\n",
  "OVERPRINTED": "OVERPRINT, to print over something already printed [v]\n",
  "OVERPRINTING": "OVERPRINT, to print over something already printed [v]\n",
  "OVERPRINTS": "OVERPRINT, to print over something already printed [v]\n",
  "OVERPRIVILEGED": "excessively privileged [adj]\n",
  "OVERPRIZE": "to prize excessively; to overvalue [v OVERPRIZED, OVERPRIZING, OVERPRIZES]\n",
  "OVERPRIZED": "OVERPRIZE, to prize excessively; to overvalue [v]\n",
  "OVERPRIZES": "OVERPRIZE, to prize excessively; to overvalue [v]\n",
  "OVERPRIZING": "OVERPRIZE, to prize excessively; to overvalue [v]\n",
  "OVERPROCESS": "to process excessively [v -ED, -ING, -ES]\n",
  "OVERPROCESSED": "OVERPROCESS, to process excessively [v]\n",
  "OVERPROCESSES": "OVERPROCESS, to process excessively [v]\n",
  "OVERPROCESSING": "OVERPROCESS, to process excessively [v]\n",
  "OVERPRODUCE": "to produce to excess [v OVERPRODUCED, OVERPRODUCING, OVERPRODUCES]\n",
  "OVERPRODUCED": "OVERPRODUCE, to produce to excess [v]\n",
  "OVERPRODUCES": "OVERPRODUCE, to produce to excess [v]\n",
  "OVERPRODUCING": "OVERPRODUCE, to produce to excess [v]\n",
  "OVERPRODUCTION": "excessive production [n -S]\n",
  "OVERPRODUCTIONS": "OVERPRODUCTION, excessive production [n]\n",
  "OVERPROGRAM": "to program excessively [v OVERPROGRAMED or OVERPROGRAMMED, OVERPROGRAMING or OVERPROGRAMMING, OVERPROGRAMS]\n",
  "OVERPROGRAMED": "OVERPROGRAM, to program excessively [v]\n",
  "OVERPROGRAMING": "OVERPROGRAM, to program excessively [v]\n",
  "OVERPROGRAMMED": "OVERPROGRAM, to program excessively [v]\n",
  "OVERPROGRAMMING": "OVERPROGRAM, to program excessively [v]\n",
  "OVERPROGRAMS": "OVERPROGRAM, to program excessively [v]\n",
  "OVERPROMISE": "to promise too much [v OVERPROMISED, OVERPROMISING, OVERPROMISES]\n",
  "OVERPROMISED": "OVERPROMISE, to promise too much [v]\n",
  "OVERPROMISES": "OVERPROMISE, to promise too much [v]\n",
  "OVERPROMISING": "OVERPROMISE, to promise too much [v]\n",
  "OVERPROMOTE": "to promote excessively [v OVERPROMOTED, OVERPROMOTING, OVERPROMOTES]\n",
  "OVERPROMOTED": "OVERPROMOTE, to promote excessively [v]\n",
  "OVERPROMOTES": "OVERPROMOTE, to promote excessively [v]\n",
  "OVERPROMOTING": "OVERPROMOTE, to promote excessively [v]\n",
  "OVERPROOF": "a spirit with a higher content of alcohol than standard spirit [n -S]\n",
  "OVERPROOFS": "OVERPROOF, a spirit with a higher content of alcohol than standard spirit [n]\n",
  "OVERPROPORTION": "to make disproportionately large [v -S]\n",
  "OVERPROPORTIONS": "OVERPROPORTION, to make disproportionately large [v]\n",
  "OVERPROTECT": "to protect to excess [v -ED, -ING, -S]\n",
  "OVERPROTECTED": "OVERPROTECT, to protect to excess [v]\n",
  "OVERPROTECTING": "OVERPROTECT, to protect to excess [v]\n",
  "OVERPROTECTION": "excessive protection [n -S]\n",
  "OVERPROTECTIONS": "OVERPROTECTION, excessive protection [n]\n",
  "OVERPROTECTIVE": "OVERPROTECT, to protect to excess [adj]\n",
  "OVERPROTECTS": "OVERPROTECT, to protect to excess [v]\n",
  "OVERPROUD": "exceedingly or unduly proud [adj]\n",
  "OVERPUMP": "to pump to excess [v -ED, -ING, -S]\n",
  "OVERPUMPED": "OVERPUMP, to pump to excess [v]\n",
  "OVERPUMPING": "OVERPUMP, to pump to excess [v]\n",
  "OVERPUMPS": "OVERPUMP, to pump to excess [v]\n",
  "OVERQUALIFIED": "having more education, training, or experience than a job calls for [adj]\n",
  "OVERQUICK": "too quick [adj]\n",
  "OVERRACK": "to overstrain [v -ED, -ING, -S]\n",
  "OVERRACKED": "OVERRACK, to overstrain [v]\n",
  "OVERRACKING": "OVERRACK, to overstrain [v]\n",
  "OVERRACKS": "OVERRACK, to overstrain [v]\n",
  "OVERRAKE": "to sweep over [v OVERRAKED, OVERRAKING, OVERRAKES]\n",
  "OVERRAKED": "OVERRAKE, to sweep over [v]\n",
  "OVERRAKES": "OVERRAKE, to sweep over [v]\n",
  "OVERRAKING": "OVERRAKE, to sweep over [v]\n",
  "OVERRAN": "OVERRUN, to swarm over [v]\n",
  "OVERRANK": "to assign an unnecessarily high rank to [v -ED, -ING, -S]\n",
  "OVERRANKED": "OVERRANK, to assign an unnecessarily high rank to [v]\n",
  "OVERRANKING": "OVERRANK, to assign an unnecessarily high rank to [v]\n",
  "OVERRANKS": "OVERRANK, to assign an unnecessarily high rank to [v]\n",
  "OVERRASH": "excessively rash [adj OVERRASHLY]\n",
  "OVERRASHLY": "OVERRASH, excessively rash [adv]\n",
  "OVERRASHNESS": "the state of being overrash [n -ES]\n",
  "OVERRASHNESSES": "OVERRASHNESS, the state of being overrash [n]\n",
  "OVERRATE": "to rate too highly [v OVERRATED, OVERRATING, OVERRATES]\n",
  "OVERRATED": "OVERRATE, to rate too highly [v]\n",
  "OVERRATES": "OVERRATE, to rate too highly [v]\n",
  "OVERRATING": "OVERRATE, to rate too highly [v]\n",
  "OVERRAUGHT": "OVERREACH, to reach beyond, to overtake [v]\n",
  "OVERREACH": "to reach beyond, to overtake [v OVERREACHED or (archaic) OVERRAUGHT, OVERREACHING, OVERREACHES]\n",
  "OVERREACHED": "OVERREACH, to reach beyond, to overtake [v]\n",
  "OVERREACHER": "one who overreaches [n -S]\n",
  "OVERREACHERS": "OVERREACHER, one who overreaches [n]\n",
  "OVERREACHES": "OVERREACH, to reach beyond, to overtake [v]\n",
  "OVERREACHING": "OVERREACH, to reach beyond, to overtake [v]\n",
  "OVERREACT": "to react or respond excessively [v -ED, -ING, -S]\n",
  "OVERREACTED": "OVERREACT, to react or respond excessively [v]\n",
  "OVERREACTING": "OVERREACT, to react or respond excessively [v]\n",
  "OVERREACTION": "excessive reaction [n -S]\n",
  "OVERREACTIONS": "OVERREACTION, excessive reaction [n]\n",
  "OVERREACTS": "OVERREACT, to react or respond excessively [v]\n",
  "OVERREAD": "to read over, or peruse [v OVERREAD, OVERREADING, OVERREADS]\n",
  "OVERREADING": "OVERREAD, to read over, or peruse [v]\n",
  "OVERREADS": "OVERREAD, to read over, or peruse [v]\n",
  "OVERRECKON": "to reckon too highly [v -ED, -ING, -S]\n",
  "OVERRECKONED": "OVERRECKON, to reckon too highly [v]\n",
  "OVERRECKONING": "OVERRECKON, to reckon too highly [v]\n",
  "OVERRECKONS": "OVERRECKON, to reckon too highly [v]\n",
  "OVERRED": "(Shakespeare) to cover with a red colour [v OVERREDDED, OVERREDDING, OVERREDS]\n",
  "OVERREDDED": "OVERRED, (Shakespeare) to cover with a red colour [v]\n",
  "OVERREDDING": "OVERRED, (Shakespeare) to cover with a red colour [v]\n",
  "OVERREDS": "OVERRED, (Shakespeare) to cover with a red colour [v]\n",
  "OVERREFINE": "to refine excessively [v OVERREFINED, OVERREFINING, OVERREFINES]\n",
  "OVERREFINED": "OVERREFINE, to refine excessively [v]\n",
  "OVERREFINEMENT": "excessive refinement [n -S]\n",
  "OVERREFINEMENTS": "OVERREFINEMENT, excessive refinement [n]\n",
  "OVERREFINES": "OVERREFINE, to refine excessively [v]\n",
  "OVERREFINING": "OVERREFINE, to refine excessively [v]\n",
  "OVERREGULATE": "to regulate to excess [v OVERREGULATED, OVERREGULATING, OVERREGULATES]\n",
  "OVERREGULATED": "OVERREGULATE, to regulate to excess [v]\n",
  "OVERREGULATES": "OVERREGULATE, to regulate to excess [v]\n",
  "OVERREGULATING": "OVERREGULATE, to regulate to excess [v]\n",
  "OVERREGULATION": "excessive regulation [n -S]\n",
  "OVERREGULATIONS": "OVERREGULATION, excessive regulation [n]\n",
  "OVERRELIANCE": "an excessive reliance [n -S]\n",
  "OVERRELIANCES": "OVERRELIANCE, an excessive reliance [n]\n",
  "OVERREN": "(archaic) to overrun [v OVERRAN, OVERRUN, OVERRENNING, OVERRENS]\n",
  "OVERRENNING": "OVERREN, (archaic) to overrun [v]\n",
  "OVERRENS": "OVERREN, (archaic) to overrun [v]\n",
  "OVERREPORT": "to report to excess [v -ED, -ING, -S]\n",
  "OVERREPORTED": "OVERREPORT, to report to excess [v]\n",
  "OVERREPORTING": "OVERREPORT, to report to excess [v]\n",
  "OVERREPORTS": "OVERREPORT, to report to excess [v]\n",
  "OVERREPRESENTED": "represented excessively [adj]\n",
  "OVERRESPOND": "to respond excessively [v -ED, -ING, -S]\n",
  "OVERRESPONDED": "OVERRESPOND, to respond excessively [v]\n",
  "OVERRESPONDING": "OVERRESPOND, to respond excessively [v]\n",
  "OVERRESPONDS": "OVERRESPOND, to respond excessively [v]\n",
  "OVERRICH": "excessively rich [adj]\n",
  "OVERRIDDEN": "OVERRIDE, to ride over [v]\n",
  "OVERRIDE": "to ride over [v OVERRODE, OVERRIDDEN, OVERRIDING, OVERRIDES]\n",
  "OVERRIDER": "either of two projecting pieces fitted to the bumper of a motor vehicle for extra protection to the bodywork [n -S]\n",
  "OVERRIDERS": "OVERRIDER, either of two projecting pieces fitted to the bumper of a motor vehicle for extra protection to the bodywork [n]\n",
  "OVERRIDES": "OVERRIDE, to ride over [v]\n",
  "OVERRIDING": "OVERRIDE, to ride over [v]\n",
  "OVERRIFE": "excessively rife [adj]\n",
  "OVERRIGID": "too rigid; too severe [adj]\n",
  "OVERRIPE": "too ripe [adj]\n",
  "OVERRIPEN": "to become too ripe [v -ED, -ING, -S]\n",
  "OVERRIPENED": "OVERRIPEN, to become too ripe [v]\n",
  "OVERRIPENESS": "the state of being overripe [n -ES]\n",
  "OVERRIPENESSES": "OVERRIPENESS, the state of being overripe [n]\n",
  "OVERRIPENING": "OVERRIPEN, to become too ripe [v]\n",
  "OVERRIPENS": "OVERRIPEN, to become too ripe [v]\n",
  "OVERROAST": "to roast too much [v -ED, -ING, -S]\n",
  "OVERROASTED": "OVERROAST, to roast too much [v]\n",
  "OVERROASTING": "OVERROAST, to roast too much [v]\n",
  "OVERROASTS": "OVERROAST, to roast too much [v]\n",
  "OVERRODE": "OVERRIDE, to ride over [v]\n",
  "OVERRUDE": "excessively rude [adj]\n",
  "OVERRUFF": "at cards, to trump with a higher card than those already played [v -ED, -ING, -S]\n",
  "OVERRUFFED": "OVERRUFF, at cards, to trump with a higher card than those already played [v]\n",
  "OVERRUFFING": "OVERRUFF, at cards, to trump with a higher card than those already played [v]\n",
  "OVERRUFFS": "OVERRUFF, at cards, to trump with a higher card than those already played [v]\n",
  "OVERRULE": "to disallow the arguments of [v OVERRULED, OVERRULING, OVERRULES]\n",
  "OVERRULED": "OVERRULE, to disallow the arguments of [v]\n",
  "OVERRULER": "one who overrules [n -S]\n",
  "OVERRULERS": "OVERRULER, one who overrules [n]\n",
  "OVERRULES": "OVERRULE, to disallow the arguments of [v]\n",
  "OVERRULING": "the act of overruling [n -S]\n",
  "OVERRULINGS": "OVERRULING, the act of overruling [n]\n",
  "OVERRUN": "to swarm over [v OVERRAN, OVERRUN, OVERRUNNING, OVERRUNS]\n",
  "OVERRUNNER": "one that overruns [n -S]\n",
  "OVERRUNNERS": "OVERRUNNER, one that overruns [n]\n",
  "OVERRUNNING": "OVERRUN, to swarm over [v]\n",
  "OVERRUNS": "OVERRUN, to swarm over [v]\n",
  "OVERS": "OVER, to go, leap or vault over [v]\n",
  "OVERSAD": "excessively sad [adj]\n",
  "OVERSAIL": "to project [v -ED, -ING, -S]\n",
  "OVERSAILED": "OVERSAIL, to project [v]\n",
  "OVERSAILING": "OVERSAIL, to project [v]\n",
  "OVERSAILS": "OVERSAIL, to project [v]\n",
  "OVERSALE": "the act of overselling [n -S]\n",
  "OVERSALES": "OVERSALE, the act of overselling [n]\n",
  "OVERSALT": "to salt to excess [v -ED, -ING, -S]\n",
  "OVERSALTED": "OVERSALT, to salt to excess [v]\n",
  "OVERSALTING": "OVERSALT, to salt to excess [v]\n",
  "OVERSALTS": "OVERSALT, to salt to excess [v]\n",
  "OVERSANGUINE": "excessively sanguine [adj]\n",
  "OVERSATURATE": "to saturate to excess [v OVERSATURATED, OVERSATURATING, OVERSATURATES]\n",
  "OVERSATURATED": "OVERSATURATE, to saturate to excess [v]\n",
  "OVERSATURATES": "OVERSATURATE, to saturate to excess [v]\n",
  "OVERSATURATING": "OVERSATURATE, to saturate to excess [v]\n",
  "OVERSATURATION": "excessive saturation [n -S]\n",
  "OVERSATURATIONS": "OVERSATURATION, excessive saturation [n]\n",
  "OVERSAUCE": "to sauce excessively [v OVERSAUCED, OVERSAUCING, OVERSAUCES]\n",
  "OVERSAUCED": "OVERSAUCE, to sauce excessively [v]\n",
  "OVERSAUCES": "OVERSAUCE, to sauce excessively [v]\n",
  "OVERSAUCING": "OVERSAUCE, to sauce excessively [v]\n",
  "OVERSAVE": "to save too much [v OVERSAVED, OVERSAVING, OVERSAVES]\n",
  "OVERSAVED": "OVERSAVE, to save too much [v]\n",
  "OVERSAVES": "OVERSAVE, to save too much [v]\n",
  "OVERSAVING": "OVERSAVE, to save too much [v]\n",
  "OVERSAW": "OVERSEE, to watch over and direct [v]\n",
  "OVERSCALE": "oversize, also OVERSCALED [adj]\n",
  "OVERSCALED": "oversize, also OVERSCALE [adj]\n",
  "OVERSCHUTCHT": "(Shakespeare) variously conjectured to mean overworn in service or whipped at the cart's tail, also OVERSCUTCHED [adj]\n",
  "OVERSCORE": "to score or draw lines across; to obliterate in this way [v OVERSCORED, OVERSCORING, OVERSCORES]\n",
  "OVERSCORED": "OVERSCORE, to score or draw lines across; to obliterate in this way [v]\n",
  "OVERSCORES": "OVERSCORE, to score or draw lines across; to obliterate in this way [v]\n",
  "OVERSCORING": "OVERSCORE, to score or draw lines across; to obliterate in this way [v]\n",
  "OVERSCRUPULOUS": "excessively scrupulous [adj]\n",
  "OVERSCUTCHED": "(Shakespeare) variously conjectured to mean overworn in service or whipped at the cart's tail, also OVERSCHUTCHT [adj]\n",
  "OVERSEA": "across the sea [adv]\n",
  "OVERSEAS": "beyond or across the sea [adv]\n",
  "OVERSECRETION": "excessive secretion [n -S]\n",
  "OVERSECRETIONS": "OVERSECRETION, excessive secretion [n]\n",
  "OVERSEE": "to watch over and direct [v OVERSAW or OVERSEEN or OVERSEED, OVERSEEN, OVERSEEING, OVERSEES]\n",
  "OVERSEED": "to seed to excess [v -ED, -ING, -S]\n",
  "OVERSEEDED": "OVERSEED, to seed to excess [v]\n",
  "OVERSEEDING": "OVERSEED, to seed to excess [v]\n",
  "OVERSEEDS": "OVERSEED, to seed to excess [v]\n",
  "OVERSEEING": "OVERSEE, to watch over and direct [v]\n",
  "OVERSEEN": "OVERSEE, to watch over and direct [v]\n",
  "OVERSEER": "one that oversees [n -S]\n",
  "OVERSEERS": "OVERSEER, one that oversees [n]\n",
  "OVERSEES": "OVERSEE, to watch over and direct [v]\n",
  "OVERSELL": "to sell more than can be delivered [v OVERSOLD, OVERSELLING, OVERSELLS]\n",
  "OVERSELLING": "OVERSELL, to sell more than can be delivered [v]\n",
  "OVERSELLS": "OVERSELL, to sell more than can be delivered [v]\n",
  "OVERSENSITIVE": "excessively sensitive [adj]\n",
  "OVERSENSITIVITY": "the state of being oversensitive [n]\n",
  "OVERSERIOUS": "excessively serious [adj OVERSERIOUSLY]\n",
  "OVERSERIOUSLY": "OVERSERIOUS, excessively serious [adv]\n",
  "OVERSERVICE": "to service to excess [v OVERSERVICED, OVERSERVICING, OVERSERVICES]\n",
  "OVERSERVICED": "OVERSERVICE, to service to excess [v]\n",
  "OVERSERVICES": "OVERSERVICE, to service to excess [v]\n",
  "OVERSERVICING": "OVERSERVICE, to service to excess [v]\n",
  "OVERSET": "to upset; to disorder [v OVERSET, OVERSETTING, OVERSETS]\n",
  "OVERSETS": "OVERSET, to upset; to disorder [v]\n",
  "OVERSETTING": "OVERSET, to upset; to disorder [v]\n",
  "OVERSEW": "to sew overhand [v OVERSEWED, OVERSEWN, OVERSEWING, OVERSEWS]\n",
  "OVERSEWED": "OVERSEW, to sew overhand [v]\n",
  "OVERSEWING": "OVERSEW, to sew overhand [v]\n",
  "OVERSEWN": "OVERSEW, to sew overhand [v]\n",
  "OVERSEWS": "OVERSEW, to sew overhand [v]\n",
  "OVERSEXED": "excessively sexual [adj]\n",
  "OVERSHADE": "to cover with shade [v OVERSHADED, OVERSHADING, OVERSHADES]\n",
  "OVERSHADED": "OVERSHADE, to cover with shade [v]\n",
  "OVERSHADES": "OVERSHADE, to cover with shade [v]\n",
  "OVERSHADING": "OVERSHADE, to cover with shade [v]\n",
  "OVERSHADOW": "to cast a shadow over [v -ED, -ING, -S]\n",
  "OVERSHADOWED": "OVERSHADOW, to cast a shadow over [v]\n",
  "OVERSHADOWING": "OVERSHADOW, to cast a shadow over [v]\n",
  "OVERSHADOWS": "OVERSHADOW, to cast a shadow over [v]\n",
  "OVERSHARE": "to reveal an inappropriate amount of detail about one's private life [v OVERSHARED, OVERSHARING, OVERSHARES]\n",
  "OVERSHARED": "OVERSHARE, to reveal an inappropriate amount of detail about one's private life [v]\n",
  "OVERSHARES": "OVERSHARE, to reveal an inappropriate amount of detail about one's private life [v]\n",
  "OVERSHARING": "OVERSHARE, to reveal an inappropriate amount of detail about one's private life [v]\n",
  "OVERSHARP": "too sharp [adj]\n",
  "OVERSHINE": "(Shakespeare) to shine over or upon [v OVERSHONE, OVERSHINING, OVERSHINES]\n",
  "OVERSHINES": "OVERSHINE, (Shakespeare) to shine over or upon [v]\n",
  "OVERSHINING": "OVERSHINE, (Shakespeare) to shine over or upon [v]\n",
  "OVERSHIRT": "a shirt worn over another shirt without being tucked in [n -S]\n",
  "OVERSHIRTS": "OVERSHIRT, a shirt worn over another shirt without being tucked in [n]\n",
  "OVERSHOE": "a protective outer shoe [n -S]\n",
  "OVERSHOES": "OVERSHOE, a protective outer shoe [n]\n",
  "OVERSHONE": "OVERSHINE, (Shakespeare) to shine over or upon [v]\n",
  "OVERSHOOT": "to shoot over or beyond one's target [v OVERSHOT, OVERSHOOTING, OVERSHOOTS]\n",
  "OVERSHOOTING": "OVERSHOOT, to shoot over or beyond one's target [v]\n",
  "OVERSHOOTS": "OVERSHOOT, to shoot over or beyond one's target [v]\n",
  "OVERSHOT": "a type of fabric weave [n -S]\n",
  "OVERSHOTS": "OVERSHOT, a type of fabric weave [n]\n",
  "OVERSHOWER": "to shower over [v -ED, -ING, -S]\n",
  "OVERSHOWERED": "OVERSHOWER, to shower over [v]\n",
  "OVERSHOWERING": "OVERSHOWER, to shower over [v]\n",
  "OVERSHOWERS": "OVERSHOWER, to shower over [v]\n",
  "OVERSICK": "too sick [adj]\n",
  "OVERSIDE": "the other side of the phonograph record [n -S]\n",
  "OVERSIDES": "OVERSIDE, the other side of the phonograph record [n]\n",
  "OVERSIGHT": "a failure to notice something, a mistake [n -S]\n",
  "OVERSIGHTS": "OVERSIGHT, a failure to notice something, a mistake [n]\n",
  "OVERSIMPLE": "too simple [adj OVERSIMPLY]\n",
  "OVERSIMPLIFIED": "OVERSIMPLIFY, to simplify to such an extent as to bring about distortion, misunderstanding, or error [v]\n",
  "OVERSIMPLIFIES": "OVERSIMPLIFY, to simplify to such an extent as to bring about distortion, misunderstanding, or error [v]\n",
  "OVERSIMPLIFY": "to simplify to such an extent as to bring about distortion, misunderstanding, or error [v OVERSIMPLIFIED, OVERSIMPLIFYING, OVERSIMPLIFIES]\n",
  "OVERSIMPLIFYING": "OVERSIMPLIFY, to simplify to such an extent as to bring about distortion, misunderstanding, or error [v]\n",
  "OVERSIMPLISTIC": "excessively simplistic [adj]\n",
  "OVERSIMPLY": "OVERSIMPLE, too simple [adv]\n",
  "OVERSIZE": "to cover with size [v OVERSIZED, OVERSIZING, OVERSIZES]\n",
  "OVERSIZED": "OVERSIZE, to cover with size [v]\n",
  "OVERSIZES": "OVERSIZE, to cover with size [v]\n",
  "OVERSIZING": "OVERSIZE, to cover with size [v]\n",
  "OVERSKATE": "in ice hockey, to skate beyond the puck, thus losing control of it [v OVERSKATED, OVERSKATING, OVERSKATES]\n",
  "OVERSKATED": "OVERSKATE, in ice hockey, to skate beyond the puck, thus losing control of it [v]\n",
  "OVERSKATES": "OVERSKATE, in ice hockey, to skate beyond the puck, thus losing control of it [v]\n",
  "OVERSKATING": "OVERSKATE, in ice hockey, to skate beyond the puck, thus losing control of it [v]\n",
  "OVERSKIP": "to skip over [v OVERSKIPPED, OVERSKIPPING, OVERSKIPS]\n",
  "OVERSKIPPED": "OVERSKIP, to skip over [v]\n",
  "OVERSKIPPING": "OVERSKIP, to skip over [v]\n",
  "OVERSKIPS": "OVERSKIP, to skip over [v]\n",
  "OVERSKIRT": "an upper skirt, shorter than the dress, and usually draped [n -S]\n",
  "OVERSKIRTS": "OVERSKIRT, an upper skirt, shorter than the dress, and usually draped [n]\n",
  "OVERSLAUGH": "exemption from duty when employed on something else [n -S] / to pass over someone in favor of another, as in a promotion [v -ED, -ING, -S]\n",
  "OVERSLAUGHED": "OVERSLAUGH, to pass over someone in favor of another, as in a promotion [v]\n",
  "OVERSLAUGHING": "OVERSLAUGH, to pass over someone in favor of another, as in a promotion [v]\n",
  "OVERSLAUGHS": "OVERSLAUGH, to pass over someone in favor of another, as in a promotion [v]\n",
  "OVERSLEEP": "to sleep past a planned time for waking [v OVERSLEPT, OVERSLEEPING, OVERSLEEPS]\n",
  "OVERSLEEPING": "OVERSLEEP, to sleep past a planned time for waking [v]\n",
  "OVERSLEEPS": "OVERSLEEP, to sleep past a planned time for waking [v]\n",
  "OVERSLEEVE": "a sleeve that goes over another sleeve [n -S]\n",
  "OVERSLEEVES": "OVERSLEEVE, a sleeve that goes over another sleeve [n]\n",
  "OVERSLEPT": "OVERSLEEP, to sleep past a planned time for waking [v]\n",
  "OVERSLIP": "to leave out [v OVERSLIPPED, OVERSLIPPING, OVERSLIPS]\n",
  "OVERSLIPPED": "OVERSLIP, to leave out [v]\n",
  "OVERSLIPPING": "OVERSLIP, to leave out [v]\n",
  "OVERSLIPS": "OVERSLIP, to leave out [v]\n",
  "OVERSLIPT": "OVERSLIP, to leave out [v]\n",
  "OVERSLOW": "excessively slow [adj]\n",
  "OVERSMAN": "an umpire [n OVERSMEN]\n",
  "OVERSMEN": "OVERSMAN, an umpire [n]\n",
  "OVERSMOKE": "to smoke excessively [v OVERSMOKED, OVERSMOKING, OVERSMOKES]\n",
  "OVERSMOKED": "OVERSMOKE, to smoke excessively [v]\n",
  "OVERSMOKES": "OVERSMOKE, to smoke excessively [v]\n",
  "OVERSMOKING": "OVERSMOKE, to smoke excessively [v]\n",
  "OVERSOAK": "to soak too much [v -ED, -ING, -S]\n",
  "OVERSOAKED": "OVERSOAK, to soak too much [v]\n",
  "OVERSOAKING": "OVERSOAK, to soak too much [v]\n",
  "OVERSOAKS": "OVERSOAK, to soak too much [v]\n",
  "OVERSOFT": "excessively soft [adj]\n",
  "OVERSOLD": "OVERSELL, to sell more than can be delivered [v]\n",
  "OVERSOLICITOUS": "excessively solicitous [adj]\n",
  "OVERSOON": "too soon [adv]\n",
  "OVERSOUL": "the divine principle forming the spiritual unity of all [n -S]\n",
  "OVERSOULS": "OVERSOUL, the divine principle forming the spiritual unity of all [n]\n",
  "OVERSOW": "to sow over [v OVERSOWED, OVERSOWN, OVERSOWING, OVERSOWS]\n",
  "OVERSOWED": "OVERSOW, to sow over [v]\n",
  "OVERSOWING": "OVERSOW, to sow over [v]\n",
  "OVERSOWN": "OVERSOW, to sow over [v]\n",
  "OVERSOWS": "OVERSOW, to sow over [v]\n",
  "OVERSPECIALISE": "to specialise to excess, also OVERSPECIALIZE [v OVERSPECIALISED, OVERSPECIALISES]\n",
  "OVERSPECIALISED": "OVERSPECIALISE, to specialise to excess, also OVERSPECIALIZE [v]\n",
  "OVERSPECIALISES": "OVERSPECIALISE, to specialise to excess, also OVERSPECIALIZE [v]\n",
  "OVERSPECIALIZE": "to specialize to excess, also OVERSPECIALISE [v OVERSPECIALIZED, OVERSPECIALIZES]\n",
  "OVERSPECIALIZED": "OVERSPECIALIZE, to specialize to excess, also OVERSPECIALISE [v]\n",
  "OVERSPECIALIZES": "OVERSPECIALIZE, to specialize to excess, also OVERSPECIALISE [v]\n",
  "OVERSPECULATE": "to speculate excessively [v OVERSPECULATED, OVERSPECULATING, OVERSPECULATES]\n",
  "OVERSPECULATED": "OVERSPECULATE, to speculate excessively [v]\n",
  "OVERSPECULATES": "OVERSPECULATE, to speculate excessively [v]\n",
  "OVERSPECULATING": "OVERSPECULATE, to speculate excessively [v]\n",
  "OVERSPECULATION": "excessive speculation [n]\n",
  "OVERSPEND": "to spend to excess [v OVERSPENT, OVERSPENDING, OVERSPENDS]\n",
  "OVERSPENDER": "one who overspends [n -S]\n",
  "OVERSPENDERS": "OVERSPENDER, one who overspends [n]\n",
  "OVERSPENDING": "excessive spending [n -S]\n",
  "OVERSPENDINGS": "OVERSPENDING, excessive spending [n]\n",
  "OVERSPENDS": "OVERSPEND, to spend to excess [v]\n",
  "OVERSPENT": "OVERSPEND, to spend to excess [v]\n",
  "OVERSPICE": "to spice excessively [v OVERSPICED, OVERSPICING, OVERSPICES]\n",
  "OVERSPICED": "OVERSPICE, to spice excessively [v]\n",
  "OVERSPICES": "OVERSPICE, to spice excessively [v]\n",
  "OVERSPICING": "OVERSPICE, to spice excessively [v]\n",
  "OVERSPILL": "the proportion of a population that leaves a district due to housing pressures [n -S] / to spill over [v OVERSPILT or OVERSPILLED, OVERSPILLING, OVERSPILLS]\n",
  "OVERSPILLED": "OVERSPILL, to spill over [v]\n",
  "OVERSPILLING": "OVERSPILL, to spill over [v]\n",
  "OVERSPILLS": "OVERSPILL, to spill over [v]\n",
  "OVERSPILT": "OVERSPILL, to spill over [v]\n",
  "OVERSPIN": "a forward spin imparted to a ball [n -S]\n",
  "OVERSPINS": "OVERSPIN, a forward spin imparted to a ball [n]\n",
  "OVERSPREAD": "to spread over or above [v OVERSPREAD, OVERSPREADING, OVERSPREADS]\n",
  "OVERSPREADING": "OVERSPREAD, to spread over or above [v]\n",
  "OVERSPREADS": "OVERSPREAD, to spread over or above [v]\n",
  "OVERSTABILITIES": "OVERSTABILITY, the state of being excessively stable [n]\n",
  "OVERSTABILITY": "the state of being excessively stable [n OVERSTABILITIES]\n",
  "OVERSTAFF": "to employ too many staff [v -ED, -ING, -S]\n",
  "OVERSTAFFED": "OVERSTAFF, to employ too many staff [v]\n",
  "OVERSTAFFING": "excessive staffing [n -S]\n",
  "OVERSTAFFINGS": "OVERSTAFFING, excessive staffing [n]\n",
  "OVERSTAFFS": "OVERSTAFF, to employ too many staff [v]\n",
  "OVERSTAIN": "to cover with a stain [v -ED, -ING, -S]\n",
  "OVERSTAINED": "OVERSTAIN, to cover with a stain [v]\n",
  "OVERSTAINING": "OVERSTAIN, to cover with a stain [v]\n",
  "OVERSTAINS": "OVERSTAIN, to cover with a stain [v]\n",
  "OVERSTAND": "(archaic) to endure to the end, to outstay [v OVERSTOOD, OVERSTANDING, OVERSTANDS]\n",
  "OVERSTANDING": "OVERSTAND, (archaic) to endure to the end, to outstay [v]\n",
  "OVERSTANDS": "OVERSTAND, (archaic) to endure to the end, to outstay [v]\n",
  "OVERSTANK": "OVERSTINK, (Shakespeare) to stink more than [v]\n",
  "OVERSTARE": "to outstare [v OVERSTARED, OVERSTARING, OVERSTARES]\n",
  "OVERSTARED": "OVERSTARE, to outstare [v]\n",
  "OVERSTARES": "OVERSTARE, to outstare [v]\n",
  "OVERSTARING": "OVERSTARE, to outstare [v]\n",
  "OVERSTATE": "to state in too strong terms; to exaggerate [v OVERSTATED, OVERSTATING, OVERSTATES]\n",
  "OVERSTATED": "OVERSTATE, to state in too strong terms; to exaggerate [v]\n",
  "OVERSTATEMENT": "an exaggeration [n -S]\n",
  "OVERSTATEMENTS": "OVERSTATEMENT, an exaggeration [n]\n",
  "OVERSTATES": "OVERSTATE, to state in too strong terms; to exaggerate [v]\n",
  "OVERSTATING": "OVERSTATE, to state in too strong terms; to exaggerate [v]\n",
  "OVERSTAY": "to stay beyond a time limit [v -ED, -ING, -S]\n",
  "OVERSTAYED": "OVERSTAY, to stay beyond a time limit [v]\n",
  "OVERSTAYER": "an immigrant worker who stays over the time allowed by his or her work permit [n -S]\n",
  "OVERSTAYERS": "OVERSTAYER, an immigrant worker who stays over the time allowed by his or her work permit [n]\n",
  "OVERSTAYING": "OVERSTAY, to stay beyond a time limit [v]\n",
  "OVERSTAYS": "OVERSTAY, to stay beyond a time limit [v]\n",
  "OVERSTEER": "to steer excessively [v -ED, -ING, -S]\n",
  "OVERSTEERED": "OVERSTEER, to steer excessively [v]\n",
  "OVERSTEERING": "OVERSTEER, to steer excessively [v]\n",
  "OVERSTEERS": "OVERSTEER, to steer excessively [v]\n",
  "OVERSTEP": "to go beyond [v OVERSTEPPED, OVERSTEPPING, OVERSTEPS]\n",
  "OVERSTEPPED": "OVERSTEP, to go beyond [v]\n",
  "OVERSTEPPING": "OVERSTEP, to go beyond [v]\n",
  "OVERSTEPS": "OVERSTEP, to go beyond [v]\n",
  "OVERSTIMULATE": "to stimulate excessively [v OVERSTIMULATED, OVERSTIMULATING, OVERSTIMULATES]\n",
  "OVERSTIMULATED": "OVERSTIMULATE, to stimulate excessively [v]\n",
  "OVERSTIMULATES": "OVERSTIMULATE, to stimulate excessively [v]\n",
  "OVERSTIMULATING": "OVERSTIMULATE, to stimulate excessively [v]\n",
  "OVERSTIMULATION": "excessive stimulation [n]\n",
  "OVERSTINK": "(Shakespeare) to stink more than [v OVERSTANK, OVERSTUNK or ORESTUNCK, OVERSTINKING, OVERSTINKS]\n",
  "OVERSTINKING": "OVERSTINK, (Shakespeare) to stink more than [v]\n",
  "OVERSTINKS": "OVERSTINK, (Shakespeare) to stink more than [v]\n",
  "OVERSTIR": "to stir too much [v OVERSTIRRED, OVERSTIRRING, OVERSTIRS]\n",
  "OVERSTIRRED": "OVERSTIR, to stir too much [v]\n",
  "OVERSTIRRING": "OVERSTIR, to stir too much [v]\n",
  "OVERSTIRS": "OVERSTIR, to stir too much [v]\n",
  "OVERSTOCK": "to stock in excess [v -ED, -ING, -S]\n",
  "OVERSTOCKED": "OVERSTOCK, to stock in excess [v]\n",
  "OVERSTOCKING": "OVERSTOCK, to stock in excess [v]\n",
  "OVERSTOCKS": "OVERSTOCK, to stock in excess [v]\n",
  "OVERSTOOD": "OVERSTAND, (archaic) to endure to the end, to outstay [v]\n",
  "OVERSTOREY": "the highest level of trees in a rainforest, also OVERSTORY [n -S]\n",
  "OVERSTOREYS": "OVERSTOREY, the highest level of trees in a rainforest, also OVERSTORY [n]\n",
  "OVERSTORIES": "OVERSTORY, the highest level of trees in a rainforest, also OVERSTOREY [n]\n",
  "OVERSTORY": "the highest level of trees in a rainforest, also OVERSTOREY [n OVERSTORIES]\n",
  "OVERSTRAIN": "to strain to excess [v -ED, -ING, -S]\n",
  "OVERSTRAINED": "OVERSTRAIN, to strain to excess [v]\n",
  "OVERSTRAINING": "OVERSTRAIN, to strain to excess [v]\n",
  "OVERSTRAINS": "OVERSTRAIN, to strain to excess [v]\n",
  "OVERSTRESS": "to stress to excess [v -ED, -ING, -ES]\n",
  "OVERSTRESSED": "OVERSTRESS, to stress to excess [v]\n",
  "OVERSTRESSES": "OVERSTRESS, to stress to excess [v]\n",
  "OVERSTRESSING": "OVERSTRESS, to stress to excess [v]\n",
  "OVERSTRETCH": "to stretch excessively [v -ED, -ING, -ES]\n",
  "OVERSTRETCHED": "OVERSTRETCH, to stretch excessively [v]\n",
  "OVERSTRETCHES": "OVERSTRETCH, to stretch excessively [v]\n",
  "OVERSTRETCHING": "OVERSTRETCH, to stretch excessively [v]\n",
  "OVERSTREW": "to strew or scatter over [v OVERSTREWED, OVERSTREWN, OVERSTREWING, OVERSTREWS]\n",
  "OVERSTREWED": "OVERSTREW, to strew or scatter over [v]\n",
  "OVERSTREWING": "OVERSTREW, to strew or scatter over [v]\n",
  "OVERSTREWN": "OVERSTREW, to strew or scatter over [v]\n",
  "OVERSTREWS": "OVERSTREW, to strew or scatter over [v]\n",
  "OVERSTRIDDEN": "OVERSTRIDE, to stride over, across, or beyond [v]\n",
  "OVERSTRIDE": "to stride over, across, or beyond [v OVERSTRODE, OVERSTRIDDEN, OVERSTRIDING, OVERSTRIDES]\n",
  "OVERSTRIDES": "OVERSTRIDE, to stride over, across, or beyond [v]\n",
  "OVERSTRIDING": "OVERSTRIDE, to stride over, across, or beyond [v]\n",
  "OVERSTRIKE": "to strike beyond [v OVERSTRUCK or (archaic) OVERSTROOKE, OVERSTRIKING, OVERSTRIKES]\n",
  "OVERSTRIKES": "OVERSTRIKE, to strike beyond [v]\n",
  "OVERSTRIKING": "OVERSTRIKE, to strike beyond [v]\n",
  "OVERSTRODE": "OVERSTRIDE, to stride over, across, or beyond [v]\n",
  "OVERSTRONG": "too strong [adj]\n",
  "OVERSTROOKE": "OVERSTRIKE, to strike beyond [v]\n",
  "OVERSTRUCK": "OVERSTRIKE, to strike beyond [v]\n",
  "OVERSTRUCTURED": "excessively structured [adj]\n",
  "OVERSTRUNG": "too highly strung [adj]\n",
  "OVERSTUDIED": "OVERSTUDY, to study to excess [v]\n",
  "OVERSTUDIES": "OVERSTUDY, to study to excess [v]\n",
  "OVERSTUDY": "to study to excess [v OVERSTUDIED, OVERSTUDYING, OVERSTUDIES]\n",
  "OVERSTUDYING": "OVERSTUDY, to study to excess [v]\n",
  "OVERSTUFF": "to stuff to excess [v -ED, -ING, -S]\n",
  "OVERSTUFFED": "OVERSTUFF, to stuff to excess [v]\n",
  "OVERSTUFFING": "OVERSTUFF, to stuff to excess [v]\n",
  "OVERSTUFFS": "OVERSTUFF, to stuff to excess [v]\n",
  "OVERSTUNK": "OVERSTINK, (Shakespeare) to stink more than [v]\n",
  "OVERSUBSCRIBE": "to subscribe for more of than is available [v OVERSUBSCRIBED, OVERSUBSCRIBING, OVERSUBSCRIBES]\n",
  "OVERSUBSCRIBED": "OVERSUBSCRIBE, to subscribe for more of than is available [v]\n",
  "OVERSUBSCRIBES": "OVERSUBSCRIBE, to subscribe for more of than is available [v]\n",
  "OVERSUBSCRIBING": "OVERSUBSCRIBE, to subscribe for more of than is available [v]\n",
  "OVERSUBTLE": "too subtle [adj]\n",
  "OVERSUBTLETIES": "OVERSUBTLETY, an excess of subtlety [n]\n",
  "OVERSUBTLETY": "an excess of subtlety [n OVERSUBTLETIES]\n",
  "OVERSUDS": "to form an excessive amount of suds [v -ED, -ING, -ES]\n",
  "OVERSUDSED": "OVERSUDS, to form an excessive amount of suds [v]\n",
  "OVERSUDSES": "OVERSUDS, to form an excessive amount of suds [v]\n",
  "OVERSUDSING": "OVERSUDS, to form an excessive amount of suds [v]\n",
  "OVERSUP": "to sup to excess [v OVERSUPPED, OVERSUPPING, OVERSUPS]\n",
  "OVERSUPPED": "OVERSUP, to sup to excess [v]\n",
  "OVERSUPPING": "OVERSUP, to sup to excess [v]\n",
  "OVERSUPPLIED": "OVERSUPPLY, to supply to excess [v]\n",
  "OVERSUPPLIES": "OVERSUPPLY, to supply to excess [v]\n",
  "OVERSUPPLY": "to supply to excess [v OVERSUPPLIED, OVERSUPPLYING, OVERSUPPLIES]\n",
  "OVERSUPPLYING": "OVERSUPPLY, to supply to excess [v]\n",
  "OVERSUPS": "OVERSUP, to sup to excess [v]\n",
  "OVERSURE": "excessively sure [adj]\n",
  "OVERSUSPICIOUS": "excessively suspicious [adj]\n",
  "OVERSWAM": "OVERSWIM, to swim across [v]\n",
  "OVERSWAY": "to bear down [v -ED, -ING, -S]\n",
  "OVERSWAYED": "OVERSWAY, to bear down [v]\n",
  "OVERSWAYING": "OVERSWAY, to bear down [v]\n",
  "OVERSWAYS": "OVERSWAY, to bear down [v]\n",
  "OVERSWEAR": "to swear anew [v OVERSWORE, OVERSWORN, OVERSWEARING, OVERSWEARS]\n",
  "OVERSWEARING": "OVERSWEAR, to swear anew [v]\n",
  "OVERSWEARS": "OVERSWEAR, to swear anew [v]\n",
  "OVERSWEET": "excessively sweet [adj]\n",
  "OVERSWEETEN": "to sweeten to excess [v -ED, -ING, -S]\n",
  "OVERSWEETENED": "OVERSWEETEN, to sweeten to excess [v]\n",
  "OVERSWEETENING": "OVERSWEETEN, to sweeten to excess [v]\n",
  "OVERSWEETENS": "OVERSWEETEN, to sweeten to excess [v]\n",
  "OVERSWEETNESS": "the state of being oversweet [n -ES]\n",
  "OVERSWEETNESSES": "OVERSWEETNESS, the state of being oversweet [n]\n",
  "OVERSWELL": "to swell or rise above; to overflow [v OVERSWELLED, OVERSWOLLEN, OVERSWELLING, OVERSWELLS]\n",
  "OVERSWELLED": "OVERSWELL, to swell or rise above; to overflow [v]\n",
  "OVERSWELLING": "OVERSWELL, to swell or rise above; to overflow [v]\n",
  "OVERSWELLS": "OVERSWELL, to swell or rise above; to overflow [v]\n",
  "OVERSWIM": "to swim across [v OVERSWAM, OVERSWUM, OVERSWIMMING, OVERSWIMS]\n",
  "OVERSWIMMING": "OVERSWIM, to swim across [v]\n",
  "OVERSWIMS": "OVERSWIM, to swim across [v]\n",
  "OVERSWING": "to swing excessively, as in golf [v OVERSWUNG, OVERSWINGING, OVERSWINGS]\n",
  "OVERSWINGING": "OVERSWING, to swing excessively, as in golf [v]\n",
  "OVERSWINGS": "OVERSWING, to swing excessively, as in golf [v]\n",
  "OVERSWOLLEN": "OVERSWELL, to swell or rise above; to overflow [v]\n",
  "OVERSWORE": "OVERSWEAR, to swear anew [v]\n",
  "OVERSWORN": "OVERSWEAR, to swear anew [v]\n",
  "OVERSWUM": "OVERSWIM, to swim across [v]\n",
  "OVERSWUNG": "OVERSWING, to swing excessively, as in golf [v]\n",
  "OVERT": "open to view [adj OVERTLY]\n",
  "OVERTAKE": "to catch up with [v OVERTOOK, OVERTAKEN, OVERTAKING, OVERTAKES]\n",
  "OVERTAKEN": "OVERTAKE, to catch up with [v]\n",
  "OVERTAKES": "OVERTAKE, to catch up with [v]\n",
  "OVERTAKING": "the act of catching up with and going past [n -S]\n",
  "OVERTAKINGS": "OVERTAKING, the act of catching up with and going past [n]\n",
  "OVERTALK": "to talk to excess [v -ED, -ING, -S]\n",
  "OVERTALKATIVE": "excessively talkative [adj]\n",
  "OVERTALKED": "OVERTALK, to talk to excess [v]\n",
  "OVERTALKING": "OVERTALK, to talk to excess [v]\n",
  "OVERTALKS": "OVERTALK, to talk to excess [v]\n",
  "OVERTAME": "excessively tame [adj]\n",
  "OVERTART": "too tart [adj]\n",
  "OVERTASK": "to impose too many tasks on [v -ED, -ING, -S]\n",
  "OVERTASKED": "OVERTASK, to impose too many tasks on [v]\n",
  "OVERTASKING": "OVERTASK, to impose too many tasks on [v]\n",
  "OVERTASKS": "OVERTASK, to impose too many tasks on [v]\n",
  "OVERTAUGHT": "OVERTEACH, to teach too much [v]\n",
  "OVERTAX": "to tax too heavily [v -ED, -ING, -ES]\n",
  "OVERTAXATION": "excessive taxation [n -S]\n",
  "OVERTAXATIONS": "OVERTAXATION, excessive taxation [n]\n",
  "OVERTAXED": "OVERTAX, to tax too heavily [v]\n",
  "OVERTAXES": "OVERTAX, to tax too heavily [v]\n",
  "OVERTAXING": "OVERTAX, to tax too heavily [v]\n",
  "OVERTEACH": "to teach too much [v OVERTAUGHT, OVERTEACHING, OVERTEACHES]\n",
  "OVERTEACHES": "OVERTEACH, to teach too much [v]\n",
  "OVERTEACHING": "OVERTEACH, to teach too much [v]\n",
  "OVERTEDIOUS": "(Shakespeare) too tedious [adj]\n",
  "OVERTEEM": "to produce in excess [v -ED, -ING, -S]\n",
  "OVERTEEMED": "OVERTEEM, to produce in excess [v]\n",
  "OVERTEEMING": "OVERTEEM, to produce in excess [v]\n",
  "OVERTEEMS": "OVERTEEM, to produce in excess [v]\n",
  "OVERTHICK": "too thick [adj]\n",
  "OVERTHIN": "to make too thin [v OVERTHINNED, OVERTHINNING, OVERTHINS]\n",
  "OVERTHINK": "to think to excess [v OVERTHOUGHT, OVERTHINKING, OVERTHINKS]\n",
  "OVERTHINKING": "OVERTHINK, to think to excess [v]\n",
  "OVERTHINKS": "OVERTHINK, to think to excess [v]\n",
  "OVERTHINNED": "OVERTHIN, to make too thin [v]\n",
  "OVERTHINNING": "OVERTHIN, to make too thin [v]\n",
  "OVERTHINS": "OVERTHIN, to make too thin [v]\n",
  "OVERTHOUGHT": "OVERTHINK, to think to excess [v]\n",
  "OVERTHREW": "OVERTHROW, to throw over, defeat [v]\n",
  "OVERTHROW": "to throw over, defeat [v OVERTHREW, OVERTHROWN, OVERTHROWING, OVERTHROWS]\n",
  "OVERTHROWER": "one who overthrows [n -S]\n",
  "OVERTHROWERS": "OVERTHROWER, one who overthrows [n]\n",
  "OVERTHROWING": "OVERTHROW, to throw over, defeat [v]\n",
  "OVERTHROWN": "OVERTHROW, to throw over, defeat [v]\n",
  "OVERTHROWS": "OVERTHROW, to throw over, defeat [v]\n",
  "OVERTHRUST": "a fault at a low angle from the horizontal in which the rocks on the upper side of the fault plane have moved upwards in relation to the rocks on the lower side of the fault plane [n -S]\n",
  "OVERTHRUSTS": "OVERTHRUST, a fault at a low angle from the horizontal in which the rocks on the upper side of the fault plane have moved upwards in relation to the rocks on the lower side of the fault plane [n]\n",
  "OVERTHWART": "to lie athwart [v OVERTHWARTED, OVERTHWARTING, OVERTHWARTS]\n",
  "OVERTHWARTED": "OVERTHWART, to lie athwart [v]\n",
  "OVERTHWARTING": "OVERTHWART, to lie athwart [v]\n",
  "OVERTHWARTS": "OVERTHWART, to lie athwart [v]\n",
  "OVERTIGHT": "too tight [adj]\n",
  "OVERTIGHTEN": "to tighten to excess [v -ED, -ING, -S]\n",
  "OVERTIGHTENED": "OVERTIGHTEN, to tighten to excess [v]\n",
  "OVERTIGHTENING": "OVERTIGHTEN, to tighten to excess [v]\n",
  "OVERTIGHTENS": "OVERTIGHTEN, to tighten to excess [v]\n",
  "OVERTIME": "to exceed the correct allowance of time [v OVERTIMED, OVERTIMING, OVERTIMES]\n",
  "OVERTIMED": "OVERTIME, to exceed the correct allowance of time [v]\n",
  "OVERTIMELY": "(obsolete) too timely [adj]\n",
  "OVERTIMER": "one who works overtime [n -S]\n",
  "OVERTIMERS": "OVERTIMER, one who works overtime [n]\n",
  "OVERTIMES": "OVERTIME, to exceed the correct allowance of time [v]\n",
  "OVERTIMID": "too timid [adj]\n",
  "OVERTIMING": "OVERTIME, to exceed the correct allowance of time [v]\n",
  "OVERTIP": "to tip more than is normal [v OVERTIPPED, OVERTIPPING, OVERTIPS]\n",
  "OVERTIPPED": "OVERTIP, to tip more than is normal [v]\n",
  "OVERTIPPING": "OVERTIP, to tip more than is normal [v]\n",
  "OVERTIPS": "OVERTIP, to tip more than is normal [v]\n",
  "OVERTIRE": "to tire excessively [v OVERTIRED, OVERTIRING, OVERTIRES]\n",
  "OVERTIRED": "OVERTIRE, to tire excessively [v]\n",
  "OVERTIRES": "OVERTIRE, to tire excessively [v]\n",
  "OVERTIRING": "OVERTIRE, to tire excessively [v]\n",
  "OVERTLY": "OVERT, open to view [adv]\n",
  "OVERTNESS": "the state of being overt [n -ES]\n",
  "OVERTNESSES": "OVERTNESS, the state of being overt [n]\n",
  "OVERTOIL": "to exhaust by excessive toil [v -ED, -ING, -S]\n",
  "OVERTOILED": "OVERTOIL, to exhaust by excessive toil [v]\n",
  "OVERTOILING": "OVERTOIL, to exhaust by excessive toil [v]\n",
  "OVERTOILS": "OVERTOIL, to exhaust by excessive toil [v]\n",
  "OVERTONE": "in music, a higher partial tone [n -S]\n",
  "OVERTONES": "OVERTONE, in music, a higher partial tone [n]\n",
  "OVERTOOK": "OVERTAKE, to catch up with [v]\n",
  "OVERTOP": "to rise above the top of [v OVERTOPPED, OVERTOPPING, OVERTOPS]\n",
  "OVERTOPPED": "OVERTOP, to rise above the top of [v]\n",
  "OVERTOPPING": "the act of rising above the top [n -S]\n",
  "OVERTOPPINGS": "OVERTOPPING, the act of rising above the top [n]\n",
  "OVERTOPS": "OVERTOP, to rise above the top of [v]\n",
  "OVERTOWER": "to tower over or above [v -ED, -ING, -S]\n",
  "OVERTOWERED": "OVERTOWER, to tower over or above [v]\n",
  "OVERTOWERING": "OVERTOWER, to tower over or above [v]\n",
  "OVERTOWERS": "OVERTOWER, to tower over or above [v]\n",
  "OVERTRADE": "to trade beyond one's capital; to buy goods beyond the means of paying for them [v OVERTRADED, OVERTRADING, OVERTRADES]\n",
  "OVERTRADED": "OVERTRADE, to trade beyond one's capital; to buy goods beyond the means of paying for them [v]\n",
  "OVERTRADES": "OVERTRADE, to trade beyond one's capital; to buy goods beyond the means of paying for them [v]\n",
  "OVERTRADING": "trading beyond one's capital [n -S]\n",
  "OVERTRADINGS": "OVERTRADING, trading beyond one's capital [n]\n",
  "OVERTRAIN": "to train to excess [v -ED, -ING, -S]\n",
  "OVERTRAINED": "OVERTRAIN, to train to excess [v]\n",
  "OVERTRAINING": "OVERTRAIN, to train to excess [v]\n",
  "OVERTRAINS": "OVERTRAIN, to train to excess [v]\n",
  "OVERTREAT": "to treat excessively [v -ED, -ING, -S]\n",
  "OVERTREATED": "OVERTREAT, to treat excessively [v]\n",
  "OVERTREATING": "OVERTREAT, to treat excessively [v]\n",
  "OVERTREATMENT": "an excess of treatment [n -S]\n",
  "OVERTREATMENTS": "OVERTREATMENT, an excess of treatment [n]\n",
  "OVERTREATS": "OVERTREAT, to treat excessively [v]\n",
  "OVERTRICK": "at bridge, a trick in excess of those contracted for [n -S]\n",
  "OVERTRICKS": "OVERTRICK, at bridge, a trick in excess of those contracted for [n]\n",
  "OVERTRIM": "to trim too much [v OVERTRIMMED, OVERTRIMMING, OVERTRIMS]\n",
  "OVERTRIMMED": "OVERTRIM, to trim too much [v]\n",
  "OVERTRIMMING": "OVERTRIM, to trim too much [v]\n",
  "OVERTRIMS": "OVERTRIM, to trim too much [v]\n",
  "OVERTRIP": "to trip nimbly over [v OVERTRIPPED, OVERTRIPPING, OVERTRIPS]\n",
  "OVERTRIPPED": "OVERTRIP, to trip nimbly over [v]\n",
  "OVERTRIPPING": "OVERTRIP, to trip nimbly over [v]\n",
  "OVERTRIPS": "OVERTRIP, to trip nimbly over [v]\n",
  "OVERTRUMP": "to trump with a higher card than the trump already played [v -ED, -ING, -S]\n",
  "OVERTRUMPED": "OVERTRUMP, to trump with a higher card than the trump already played [v]\n",
  "OVERTRUMPING": "OVERTRUMP, to trump with a higher card than the trump already played [v]\n",
  "OVERTRUMPS": "OVERTRUMP, to trump with a higher card than the trump already played [v]\n",
  "OVERTRUST": "to trust excessively [v -ED, -ING, -S]\n",
  "OVERTRUSTED": "OVERTRUST, to trust excessively [v]\n",
  "OVERTRUSTING": "OVERTRUST, to trust excessively [v]\n",
  "OVERTRUSTS": "OVERTRUST, to trust excessively [v]\n",
  "OVERTURE": "an instrumental prelude to an opera, oratorio [n -S] / to put forward as an overture [v OVERTURED, OVERTURING, OVERTURES]\n",
  "OVERTURED": "OVERTURE, to put forward as an overture [v]\n",
  "OVERTURES": "OVERTURE, to put forward as an overture [v]\n",
  "OVERTURING": "OVERTURE, to put forward as an overture [v]\n",
  "OVERTURN": "to turn over [v -ED, -ING, -S]\n",
  "OVERTURNED": "OVERTURN, to turn over [v]\n",
  "OVERTURNER": "one who overturns [n -S]\n",
  "OVERTURNERS": "OVERTURNER, one who overturns [n]\n",
  "OVERTURNING": "OVERTURN, to turn over [v]\n",
  "OVERTURNS": "OVERTURN, to turn over [v]\n",
  "OVERTYPE": "to type over the top of [v OVERTYPED, OVERTYPING, OVERTYPES]\n",
  "OVERTYPED": "OVERTYPE, to type over the top of [v]\n",
  "OVERTYPES": "OVERTYPE, to type over the top of [v]\n",
  "OVERTYPING": "OVERTYPE, to type over the top of [v]\n",
  "OVERURGE": "to urge too much [v OVERURGED, OVERURGING, OVERURGES]\n",
  "OVERURGED": "OVERURGE, to urge too much [v]\n",
  "OVERURGES": "OVERURGE, to urge too much [v]\n",
  "OVERURGING": "OVERURGE, to urge too much [v]\n",
  "OVERUSE": "to use too much [v OVERUSED, OVERUSING, OVERUSES]\n",
  "OVERUSED": "OVERUSE, to use too much [v]\n",
  "OVERUSES": "OVERUSE, to use too much [v]\n",
  "OVERUSING": "OVERUSE, to use too much [v]\n",
  "OVERUTILISATION": "the act of overutilising, also OVERUTILIZATION [n]\n",
  "OVERUTILISE": "to utilise excessively, also OVERUTILIZE [v OVERUTILISED, OVERUTILISING, OVERUTILISES]\n",
  "OVERUTILISED": "OVERUTILISE, to utilise excessively, also OVERUTILIZE [v]\n",
  "OVERUTILISES": "OVERUTILISE, to utilise excessively, also OVERUTILIZE [v]\n",
  "OVERUTILISING": "OVERUTILISE, to utilise excessively, also OVERUTILIZE [v]\n",
  "OVERUTILIZATION": "the act of overutilizing, also OVERUTILISATION [n]\n",
  "OVERUTILIZE": "to utilize excessively, also OVERUTILISE [v OVERUTILIZED, OVERUTILIZING, OVERUTILIZES]\n",
  "OVERUTILIZED": "OVERUTILIZE, to utilize excessively, also OVERUTILISE [v]\n",
  "OVERUTILIZES": "OVERUTILIZE, to utilize excessively, also OVERUTILISE [v]\n",
  "OVERUTILIZING": "OVERUTILIZE, to utilize excessively, also OVERUTILISE [v]\n",
  "OVERVALUATION": "excessive valuation [n -S]\n",
  "OVERVALUATIONS": "OVERVALUATION, excessive valuation [n]\n",
  "OVERVALUE": "to value too highly [v OVERVALUED, OVERVALUING, OVERVALUES]\n",
  "OVERVALUED": "OVERVALUE, to value too highly [v]\n",
  "OVERVALUES": "OVERVALUE, to value too highly [v]\n",
  "OVERVALUING": "OVERVALUE, to value too highly [v]\n",
  "OVERVEIL": "to veil over [v -ED, -ING, -S]\n",
  "OVERVEILED": "OVERVEIL, to veil over [v]\n",
  "OVERVEILING": "OVERVEIL, to veil over [v]\n",
  "OVERVEILS": "OVERVEIL, to veil over [v]\n",
  "OVERVIEW": "a summary [n -S]\n",
  "OVERVIEWS": "OVERVIEW, a summary [n]\n",
  "OVERVIOLENT": "excessively violent [adj]\n",
  "OVERVIVID": "excessively vivid [adj]\n",
  "OVERVOLTAGE": "the excess potential required for the discharge of an ion at an electrode over and above the equilibrium potential of the electrode [n -S]\n",
  "OVERVOLTAGES": "OVERVOLTAGE, the excess potential required for the discharge of an ion at an electrode over and above the equilibrium potential of the electrode [n]\n",
  "OVERVOTE": "to defeat by a majority of votes [v OVERVOTED, OVERVOTING, OVERVOTES]\n",
  "OVERVOTED": "OVERVOTE, to defeat by a majority of votes [v]\n",
  "OVERVOTES": "OVERVOTE, to defeat by a majority of votes [v]\n",
  "OVERVOTING": "OVERVOTE, to defeat by a majority of votes [v]\n",
  "OVERWARIER": "OVERWARY, too wary; too cautious [adj]\n",
  "OVERWARIEST": "OVERWARY, too wary; too cautious [adj]\n",
  "OVERWARM": "to warm too much [v -ED, -ING, -S]\n",
  "OVERWARMED": "OVERWARM, to warm too much [v]\n",
  "OVERWARMING": "OVERWARM, to warm too much [v]\n",
  "OVERWARMS": "OVERWARM, to warm too much [v]\n",
  "OVERWARY": "too wary; too cautious [adj OVERWARIER, OVERWARIEST]\n",
  "OVERWASH": "material carried by glacier streams over a frontal moraine [n -ES]\n",
  "OVERWASHES": "OVERWASH, material carried by glacier streams over a frontal moraine [n]\n",
  "OVERWATCH": "to watch too much [v -ED, -ING, -ES]\n",
  "OVERWATCHED": "OVERWATCH, to watch too much [v]\n",
  "OVERWATCHES": "OVERWATCH, to watch too much [v]\n",
  "OVERWATCHING": "OVERWATCH, to watch too much [v]\n",
  "OVERWATER": "to water excessively [v -ED, -ING, -S]\n",
  "OVERWATERED": "OVERWATER, to water excessively [v]\n",
  "OVERWATERING": "OVERWATER, to water excessively [v]\n",
  "OVERWATERS": "OVERWATER, to water excessively [v]\n",
  "OVERWEAK": "too weak [adj]\n",
  "OVERWEAR": "to wear out [v OVERWORE, OVERWORN, OVERWEARING, OVERWEARS]\n",
  "OVERWEARIED": "OVERWEARY, to weary too much; to tire out [v]\n",
  "OVERWEARIES": "OVERWEARY, to weary too much; to tire out [v]\n",
  "OVERWEARING": "OVERWEAR, to wear out [v]\n",
  "OVERWEARS": "OVERWEAR, to wear out [v]\n",
  "OVERWEARY": "to weary too much; to tire out [v OVERWEARIED, OVERWEARYING, OVERWEARIES]\n",
  "OVERWEARYING": "OVERWEARY, to weary too much; to tire out [v]\n",
  "OVERWEATHER": "(Shakespeare) to batter by violence of weather [v -ED, -ING, -S]\n",
  "OVERWEATHERED": "OVERWEATHER, (Shakespeare) to batter by violence of weather [v]\n",
  "OVERWEATHERING": "OVERWEATHER, (Shakespeare) to batter by violence of weather [v]\n",
  "OVERWEATHERS": "OVERWEATHER, (Shakespeare) to batter by violence of weather [v]\n",
  "OVERWEEN": "to expect too much; to be presumptuous or arrogant [v -ED, -ING, -S]\n",
  "OVERWEENED": "OVERWEEN, to expect too much; to be presumptuous or arrogant [v]\n",
  "OVERWEENING": "arrogant, presumptuous [adj OVERWEENINGLY] / the act of being excessively arrogant [n -S]\n",
  "OVERWEENINGLY": "OVERWEENING [adv]\n",
  "OVERWEENINGNESS": "the state of being overweening [n]\n",
  "OVERWEENINGS": "OVERWEENING, the act of being excessively arrogant [n]\n",
  "OVERWEENS": "OVERWEEN, to expect too much; to be presumptuous or arrogant [v]\n",
  "OVERWEIGH": "to exceed in weight; to overbalance [v -ED, -ING, -S]\n",
  "OVERWEIGHED": "OVERWEIGH, to exceed in weight; to overbalance [v]\n",
  "OVERWEIGHING": "OVERWEIGH, to exceed in weight; to overbalance [v]\n",
  "OVERWEIGHS": "OVERWEIGH, to exceed in weight; to overbalance [v]\n",
  "OVERWEIGHT": "to give too much weight or consideration to [v -ED, -ING, -S]\n",
  "OVERWEIGHTED": "OVERWEIGHT, to give too much weight or consideration to [v]\n",
  "OVERWEIGHTING": "OVERWEIGHT, to give too much weight or consideration to [v]\n",
  "OVERWEIGHTS": "OVERWEIGHT, to give too much weight or consideration to [v]\n",
  "OVERWENT": "OVERGO, to travel over [v]\n",
  "OVERWET": "to wet too much [v OVERWETTED, OVERWETTING, OVERWETS]\n",
  "OVERWETS": "OVERWET, to wet too much [v]\n",
  "OVERWETTED": "OVERWET, to wet too much [v]\n",
  "OVERWETTING": "OVERWET, to wet too much [v]\n",
  "OVERWHELM": "to crush with something strong or heavy [v -ED, -ING, -S]\n",
  "OVERWHELMED": "OVERWHELM, to crush with something strong or heavy [v]\n",
  "OVERWHELMING": "crushing [adj OVERWHELMINGLY] / the act of inflicting a crushing defeat [n -S]\n",
  "OVERWHELMINGLY": "OVERWHELMING, crushing [adv]\n",
  "OVERWHELMINGS": "OVERWHELMING, the act of inflicting a crushing defeat [n]\n",
  "OVERWHELMS": "OVERWHELM, to crush with something strong or heavy [v]\n",
  "OVERWIDE": "excessively wide [adj]\n",
  "OVERWILIER": "OVERWILY, excessively wily [adj]\n",
  "OVERWILIEST": "OVERWILY, excessively wily [adj]\n",
  "OVERWILY": "excessively wily [adj OVERWILIER, OVERWILIEST]\n",
  "OVERWIND": "to wind too much, as a watch [v OVERWOUND or OVERWINDED, OVERWINDING, OVERWINDS]\n",
  "OVERWINDED": "OVERWIND, to wind too much, as a watch [v]\n",
  "OVERWINDING": "OVERWIND, to wind too much, as a watch [v]\n",
  "OVERWINDS": "OVERWIND, to wind too much, as a watch [v]\n",
  "OVERWING": "to fly over [v -ED, -ING, -S]\n",
  "OVERWINGED": "OVERWING, to fly over [v]\n",
  "OVERWINGING": "OVERWING, to fly over [v]\n",
  "OVERWINGS": "OVERWING, to fly over [v]\n",
  "OVERWINTER": "to last through or pass the winter [v -ED, -ING, -S]\n",
  "OVERWINTERED": "OVERWINTER, to last through or pass the winter [v]\n",
  "OVERWINTERING": "OVERWINTER, to last through or pass the winter [v]\n",
  "OVERWINTERS": "OVERWINTER, to last through or pass the winter [v]\n",
  "OVERWISE": "too wise; affectedly wise [adj OVERWISELY]\n",
  "OVERWISELY": "OVERWISE, too wise; affectedly wise [adv]\n",
  "OVERWITHHELD": "OVERWITHHOLD, to withhold excessively [v]\n",
  "OVERWITHHOLD": "to withhold excessively [v OVERWITHHELD, OVERWITHHOLDING, OVERWITHHOLDS]\n",
  "OVERWITHHOLDING": "OVERWITHHOLD, to withhold excessively [v]\n",
  "OVERWITHHOLDS": "OVERWITHHOLD, to withhold excessively [v]\n",
  "OVERWORD": "(Scots) the refrain of a song, also OWREWORD [n -S]\n",
  "OVERWORDS": "OVERWORD, (Scots) the refrain of a song, also OWREWORD [n]\n",
  "OVERWORE": "OVERWEAR, to wear out [v]\n",
  "OVERWORK": "to cause to work too hard [v OVERWORKED, OVERWROUGHT, OVERWORKING, OVERWORKS]\n",
  "OVERWORKED": "OVERWORK, to cause to work too hard [v]\n",
  "OVERWORKING": "OVERWORK, to cause to work too hard [v]\n",
  "OVERWORKS": "OVERWORK, to cause to work too hard [v]\n",
  "OVERWORN": "OVERWEAR, to wear out [v]\n",
  "OVERWOUND": "OVERWIND, to wind too much, as a watch [v]\n",
  "OVERWRAP": "to wrap excessively [v OVERWRAPPED or OVERWRAPT, OVERWRAPPING, OVERWRAPS]\n",
  "OVERWRAPPED": "OVERWRAP, to wrap excessively [v]\n",
  "OVERWRAPPING": "OVERWRAP, to wrap excessively [v]\n",
  "OVERWRAPS": "OVERWRAP, to wrap excessively [v]\n",
  "OVERWRAPT": "OVERWRAP, to wrap excessively [v]\n",
  "OVERWREST": "to wrest or force from the natural or proper position [v -ED, -ING, -S]\n",
  "OVERWRESTED": "OVERWREST, to wrest or force from the natural or proper position [v]\n",
  "OVERWRESTING": "OVERWREST, to wrest or force from the natural or proper position [v]\n",
  "OVERWRESTLE": "(Spenser) to overcome by wrestling [v OVERWRESTLED, OVERWRESTLING, OVERWRESTLES]\n",
  "OVERWRESTLED": "OVERWRESTLE, (Spenser) to overcome by wrestling [v]\n",
  "OVERWRESTLES": "OVERWRESTLE, (Spenser) to overcome by wrestling [v]\n",
  "OVERWRESTLING": "OVERWRESTLE, (Spenser) to overcome by wrestling [v]\n",
  "OVERWRESTS": "OVERWREST, to wrest or force from the natural or proper position [v]\n",
  "OVERWRITE": "to write in a laboured manner [v OVERWROTE, OVERWRITTEN, OVERWRITING, OVERWRITES]\n",
  "OVERWRITES": "OVERWRITE, to write in a laboured manner [v]\n",
  "OVERWRITING": "OVERWRITE, to write in a laboured manner [v]\n",
  "OVERWRITTEN": "OVERWRITE, to write in a laboured manner [v]\n",
  "OVERWROTE": "OVERWRITE, to write in a laboured manner [v]\n",
  "OVERWROUGHT": "OVERWORK, to cause to work too hard [v]\n",
  "OVERYEAR": "to keep into a further year or more [v -ED, -ING, -S]\n",
  "OVERYEARED": "OVERYEAR, to keep into a further year or more [v]\n",
  "OVERYEARING": "OVERYEAR, to keep into a further year or more [v]\n",
  "OVERYEARS": "OVERYEAR, to keep into a further year or more [v]\n",
  "OVERZEAL": "excess of zeal [n -S]\n",
  "OVERZEALOUS": "excessively zealous [adj OVERZEALOUSLY]\n",
  "OVERZEALOUSLY": "OVERZEALOUS, excessively zealous [adv]\n",
  "OVERZEALOUSNESS": "the state of being overzealous [n]\n",
  "OVERZEALS": "OVERZEAL, excess of zeal [n]\n",
  "OVIBOS": "(Latin) the musk ox [n -ES]\n",
  "OVIBOSES": "OVIBOS, (Latin) the musk ox [n]\n",
  "OVIBOVINE": "of or relating to the ovibos, muskox [adj]\n",
  "OVICIDAL": "relating to ovicide, sheep-killing [adj]\n",
  "OVICIDE": "an agent that kills eggs [n -S]\n",
  "OVICIDES": "OVICIDE, an agent that kills eggs [n]\n",
  "OVIDUCAL": "relating to the oviduct, a passage conveying eggs to their place of fertilization, also OVIDUCTAL [adj]\n",
  "OVIDUCT": "a tube through which ova travel from an ovary [n -S]\n",
  "OVIDUCTAL": "relating to the oviduct, a passage conveying eggs to their place of fertilization, also OVIDUCAL [adj]\n",
  "OVIDUCTS": "OVIDUCT, a tube through which ova travel from an ovary [n]\n",
  "OVIFEROUS": "egg-carrying, also OVIGEROUS [adj]\n",
  "OVIFORM": "shaped like an egg [adj]\n",
  "OVIGEROUS": "egg-carrying, also OVIFEROUS [adj]\n",
  "OVINE": "a sheep or similar animal [n -S]\n",
  "OVINES": "OVINE, a sheep or similar animal [n]\n",
  "OVIPARA": "an artificial division of vertebrates, including those that lay eggs [n]\n",
  "OVIPARITIES": "OVIPARITY, the production of offspring via eggs [n]\n",
  "OVIPARITY": "the production of offspring via eggs [n OVIPARITIES]\n",
  "OVIPAROUS": "producing offspring through laying eggs which are incubated outside the body [adj OVIPAROUSLY]\n",
  "OVIPAROUSLY": "OVIPAROUS, producing offspring through laying eggs which are incubated outside the body [adv]\n",
  "OVIPOSIT": "to lay or deposit eggs, esp. of insects [v -ED, -ING, -S]\n",
  "OVIPOSITED": "OVIPOSIT, to lay or deposit eggs, esp. of insects [v]\n",
  "OVIPOSITING": "OVIPOSIT, to lay or deposit eggs, esp. of insects [v]\n",
  "OVIPOSITION": "the act of ovipositing [n -S]\n",
  "OVIPOSITIONAL": "relating to oviposition [adj]\n",
  "OVIPOSITIONS": "OVIPOSITION, the act of ovipositing [n]\n",
  "OVIPOSITOR": "the organ with which many insects and some other animals deposit their eggs [n -S]\n",
  "OVIPOSITORS": "OVIPOSITOR, the organ with which many insects and some other animals deposit their eggs [n]\n",
  "OVIPOSITS": "OVIPOSIT, to lay or deposit eggs, esp. of insects [v]\n",
  "OVIRAPTOR": "a small two-footed dinosaur [n -S]\n",
  "OVIRAPTORS": "OVIRAPTOR, a small two-footed dinosaur [n]\n",
  "OVISAC": "a brood-pouch; an egg capsule [n -S]\n",
  "OVISACS": "OVISAC, a brood-pouch; an egg capsule [n]\n",
  "OVIST": "a believer that the ovum has the germ of all future generations [n -S]\n",
  "OVISTS": "OVIST, a believer that the ovum has the germ of all future generations [n]\n",
  "OVOID": "an egg-shaped body [n -S]\n",
  "OVOIDAL": "egg-shaped [adj] / an egg-shaped object [n -S]\n",
  "OVOIDALS": "OVOIDAL, an egg-shaped object [n]\n",
  "OVOIDS": "OVOID, an egg-shaped body [n]\n",
  "OVOLI": "OVOLO, (Italian) a moulding with the rounded part comprised of a quarter circle [n]\n",
  "OVOLO": "(Italian) a moulding with the rounded part comprised of a quarter circle [n OVOLI or OVOLOS]\n",
  "OVOLOS": "OVOLO, (Italian) a moulding with the rounded part comprised of a quarter circle [n]\n",
  "OVONIC": "related to ovonics, a branch of electronics [adj]\n",
  "OVONICS": "a particular branch of electronics [n]\n",
  "OVOTESTES": "OVOTESTIS, an organ which produces both ova and spermatozoa [n]\n",
  "OVOTESTIS": "an organ which produces both ova and spermatozoa [n OVOTESTES]\n",
  "OVOVIVIPARITIES": "OVOVIVIPARITY, the state of being ovoviviparous [n]\n",
  "OVOVIVIPARITY": "the state of being ovoviviparous [n OVOVIVIPARITIES]\n",
  "OVOVIVIPAROUS": "producing eggs which are hatched in the parent's body [adj OVOVIVIPAROUSLY]\n",
  "OVOVIVIPAROUSLY": "OVOVIVIPAROUS, producing eggs which are hatched in the parent's body [adv]\n",
  "OVULAR": "relating or belonging to an ovule, also OVULARY [adj]\n",
  "OVULARY": "relating or belonging to an ovule, also OVULAR [adj]\n",
  "OVULATE": "to produce ova [v OVULATED, OVULATING, OVULATES]\n",
  "OVULATED": "OVULATE, to produce ova [v]\n",
  "OVULATES": "OVULATE, to produce ova [v]\n",
  "OVULATING": "OVULATE, to produce ova [v]\n",
  "OVULATION": "the act of releasing ova from the ovary [n -S]\n",
  "OVULATIONS": "OVULATION, the act of releasing ova from the ovary [n]\n",
  "OVULATORY": "relating to ovulation [adj]\n",
  "OVULE": "the structure inside an ovary which contains a female egg cell [n -S]\n",
  "OVULES": "OVULE, the structure inside an ovary which contains a female egg cell [n]\n",
  "OVULIFEROUS": "bearing ovules [adj]\n",
  "OVUM": "the female reproductive cell [n OVA]\n",
  "OW": "an interjection expressing pain [interj]\n",
  "OWCHE": "(archaic) a socket in which a precious stone is set, also OUCH [n -S]\n",
  "OWCHES": "OWCHE, (archaic) a socket in which a precious stone is set, also OUCH [n]\n",
  "OWE": "to be indebted for [v OWED, OWING, OWES]\n",
  "OWED": "OWE, to be indebted for [v]\n",
  "OWELTIES": "OWELTY, equality [n]\n",
  "OWELTY": "equality [n OWELTIES]\n",
  "OWER": "(Scots) over, also OWRE [adv]\n",
  "OWERBY": "(Scots) a little way over, also OVERBY [adv]\n",
  "OWERLOUP": "(Scots) to leap over, also OVERLEAP [v OWERLOUPIT or OWERLOUPEN, OWERLOUPING, OWERLOUPS]\n",
  "OWERLOUPEN": "OWERLOUP, (Scots) to leap over, also OVERLEAP [v]\n",
  "OWERLOUPING": "OWERLOUP, (Scots) to leap over, also OVERLEAP [v]\n",
  "OWERLOUPIT": "OWERLOUP, (Scots) to leap over, also OVERLEAP [v]\n",
  "OWERLOUPS": "OWERLOUP, (Scots) to leap over, also OVERLEAP [v]\n",
  "OWES": "OWE, to be indebted for [v]\n",
  "OWIE": "an injury that is not serious [n -S]\n",
  "OWIES": "OWIE, an injury that is not serious [n]\n",
  "OWING": "OWE, to be indebted for [v]\n",
  "OWL": "to smuggle wool or sheep [v -ED, -ING, -S]\n",
  "OWLED": "OWL, to smuggle wool or sheep [v]\n",
  "OWLER": "a smuggler of wool or sheep [n -S]\n",
  "OWLERIES": "OWLERY, a place inhabited by owls [n]\n",
  "OWLERS": "OWLER, a smuggler of wool or sheep [n]\n",
  "OWLERY": "a place inhabited by owls [n OWLERIES]\n",
  "OWLET": "a young owl, also HOWLET [n -S]\n",
  "OWLETS": "OWLET, a young owl, also HOWLET [n]\n",
  "OWLIER": "OWLY, owlish, like an owl [adj]\n",
  "OWLIEST": "OWLY, owlish, like an owl [adj]\n",
  "OWLING": "OWL, to smuggle wool or sheep [v]\n",
  "OWLISH": "like an owl [adj OWLISHLY]\n",
  "OWLISHLY": "OWLISH, like an owl [adv]\n",
  "OWLISHNESS": "the quality of being owlish, solemn [n -ES]\n",
  "OWLISHNESSES": "OWLISHNESS, the quality of being owlish, solemn [n]\n",
  "OWLLIKE": "like an owl [adj]\n",
  "OWLS": "OWL, to smuggle wool or sheep [v]\n",
  "OWLY": "owlish, like an owl [adj OWLIER, OWLIEST]\n",
  "OWN": "to have as a possession [v -ED, -ING, -S]\n",
  "OWNABLE": "able to be owned [adj]\n",
  "OWNED": "OWN, to have as a possession [v]\n",
  "OWNER": "one that owns [n -S]\n",
  "OWNERLESS": "without an owner [adj]\n",
  "OWNERS": "OWNER, one that owns [n]\n",
  "OWNERSHIP": "the state of being an owner [n -S]\n",
  "OWNERSHIPS": "OWNERSHIP, the state of being an owner [n]\n",
  "OWNING": "OWN, to have as a possession [v]\n",
  "OWNS": "OWN, to have as a possession [v]\n",
  "OWNSOME": "a solitary state [n -S]\n",
  "OWNSOMES": "OWNSOME, a solitary state [n]\n",
  "OWRE": "(Spenser) ore, rock containing a valuable metal [n -S]\n",
  "OWRECAME": "OWRECOME, (Scots) to overcome [v]\n",
  "OWRECOME": "(Scots) to overcome [v OWRECAME, OWRECOMING, OWRECOMES]\n",
  "OWRECOMES": "OWRECOME, (Scots) to overcome [v]\n",
  "OWRECOMING": "OWRECOME, (Scots) to overcome [v]\n",
  "OWRELAY": "(Scots) a large cravat [n -S]\n",
  "OWRELAYS": "OWRELAY, (Scots) a large cravat [n]\n",
  "OWRES": "OWRE, (Spenser) ore, rock containing a valuable metal [n]\n",
  "OWREWORD": "(Scots) the refrain of a song, also OVERWORD [n -S]\n",
  "OWREWORDS": "OWREWORD, (Scots) the refrain of a song, also OVERWORD [n]\n",
  "OWRIE": "(Scots) dingy, shabby, also OORIE, OURIE [adj OWRIER, OWRIEST]\n",
  "OWRIER": "OWRIE, (Scots) dingy, shabby, also OORIE, OURIE [adj]\n",
  "OWRIEST": "OWRIE, (Scots) dingy, shabby, also OORIE, OURIE [adj]\n",
  "OWSE": "(Scots) an ox [n OWSEN]\n",
  "OWSEN": "OWSE, (Scots) an ox [n]\n",
  "OWT": "(dialect) anything, also AUGHT, OUCHT [n -S]\n",
  "OWTS": "OWT, (dialect) anything, also AUGHT, OUCHT [n]\n",
  "OX": "a hoofed mammal [n OXEN] / a clumsy person [n OXES]\n",
  "OXACILLIN": "a semisynthetic penicillin, used in the treatment of penicillin-resistant conditions [n -S]\n",
  "OXACILLINS": "OXACILLIN, a semisynthetic penicillin, used in the treatment of penicillin-resistant conditions [n]\n",
  "OXALACETATE": "a salt or ester of oxaloacetic acid, also OXALOACETATE [n -S]\n",
  "OXALACETATES": "OXALACETATE, a salt or ester of oxaloacetic acid, also OXALOACETATE [n]\n",
  "OXALATE": "a salt of oxalic acid [n -S] / to treat with an oxalate [v OXALATED, OXALATING, OXALATES]\n",
  "OXALATED": "OXALATE, to treat with an oxalate [v]\n",
  "OXALATES": "OXALATE, to treat with an oxalate [v]\n",
  "OXALATING": "OXALATE, to treat with an oxalate [v]\n",
  "OXALIC": "applied to an acid obtained from wood sorrel and other plants, used for cleaning metals and as a bleaching agent [adj]\n",
  "OXALIS": "(Greek) a plant of the wood-sorrel genus [n -ES]\n",
  "OXALISES": "OXALIS, (Greek) a plant of the wood-sorrel genus [n]\n",
  "OXALOACETATE": "a salt or ester of oxaloacetic acid, also OXALACETATE [n -S]\n",
  "OXALOACETATES": "OXALOACETATE, a salt or ester of oxaloacetic acid, also OXALACETATE [n]\n",
  "OXALOACETIC": "as in oxaloacetic acid [adj]\n",
  "OXAZEPAM": "a tranquilizing drug [n -S]\n",
  "OXAZEPAMS": "OXAZEPAM, a tranquilizing drug [n]\n",
  "OXAZINE": "any of various heterocyclic chemical compound [n -S]\n",
  "OXAZINES": "OXAZINE, any of various heterocyclic chemical compound [n]\n",
  "OXAZOLE": "a liquid chemical compound [n -S]\n",
  "OXAZOLES": "OXAZOLE, a liquid chemical compound [n]\n",
  "OXBLOOD": "a dark reddish-brown colour [n -S]\n",
  "OXBLOODS": "OXBLOOD, a dark reddish-brown colour [n]\n",
  "OXBOW": "a pronounced meander or horseshoe-shaped loop in a river [n -S]\n",
  "OXBOWS": "OXBOW, a pronounced meander or horseshoe-shaped loop in a river [n]\n",
  "OXCART": "a cart drawn by an ox [n -S]\n",
  "OXCARTS": "OXCART, a cart drawn by an ox [n]\n",
  "OXEN": "OX, a hoofed mammal [n]\n",
  "OXER": "in foxhunting, an ox-fence [n -S]\n",
  "OXERS": "OXER, in foxhunting, an ox-fence [n]\n",
  "OXES": "OX, a hoofed mammal [n]\n",
  "OXEYE": "a wild chrysanthemum with a yellow disc and white rays [n -S]\n",
  "OXEYES": "OXEYE, a wild chrysanthemum with a yellow disc and white rays [n]\n",
  "OXFORD": "a soft durable plain-woven cotton [n -S]\n",
  "OXFORDS": "OXFORD, a soft durable plain-woven cotton [n]\n",
  "OXGANG": "as much land as one ox could plough, also OXGATE, OXLAND [n -S]\n",
  "OXGANGS": "OXGANG, as much land as one ox could plough, also OXGATE, OXLAND [n]\n",
  "OXGATE": "as much land as one ox could plough, also OXGANG, OXLAND [n -S]\n",
  "OXGATES": "OXGATE, as much land as one ox could plough, also OXGANG, OXLAND [n]\n",
  "OXHEAD": "a blockhead [n -S]\n",
  "OXHEADS": "OXHEAD, a blockhead [n]\n",
  "OXHEART": "a large heart-shaped cherry, either black, red, or white [n -S]\n",
  "OXHEARTS": "OXHEART, a large heart-shaped cherry, either black, red, or white [n]\n",
  "OXHERD": "one who tends oxen [n -S]\n",
  "OXHERDS": "OXHERD, one who tends oxen [n]\n",
  "OXHIDE": "leather from the hide of an ox [n -S]\n",
  "OXHIDES": "OXHIDE, leather from the hide of an ox [n]\n",
  "OXIC": "denoting a process involving oxygen [adj]\n",
  "OXID": "a compound containing oxygen, also OXIDE [n -S]\n",
  "OXIDABLE": "capable of being oxidized [adj]\n",
  "OXIDANT": "an oxidizing agent [n -S]\n",
  "OXIDANTS": "OXIDANT, an oxidizing agent [n]\n",
  "OXIDASE": "any of a group of enzymes that promote oxidation in plant and animal cells [n -S]\n",
  "OXIDASES": "OXIDASE, any of a group of enzymes that promote oxidation in plant and animal cells [n]\n",
  "OXIDASIC": "of or like an oxidase, a group of enzymes that promote oxidation in plant and animal cells [adj]\n",
  "OXIDATE": "to combine with oxygen, also OXIDISE, OXIDIZE [v OXIDATED, OXIDATING, OXIDATES]\n",
  "OXIDATED": "OXIDATE, to combine with oxygen, also OXIDISE, OXIDIZE [v]\n",
  "OXIDATES": "OXIDATE, to combine with oxygen, also OXIDISE, OXIDIZE [v]\n",
  "OXIDATING": "OXIDATE, to combine with oxygen, also OXIDISE, OXIDIZE [v]\n",
  "OXIDATION": "the act of oxidizing [n -S]\n",
  "OXIDATIONAL": "relating to oxidation [adj]\n",
  "OXIDATIONS": "OXIDATION, the act of oxidizing [n]\n",
  "OXIDATIVE": "relating to oxidation [adj OXIDATIVELY]\n",
  "OXIDATIVELY": "OXIDATIVE, relating to oxidation [adv]\n",
  "OXIDE": "a compound containing oxygen, also OXID [n -S]\n",
  "OXIDES": "OXIDE, a compound containing oxygen, also OXID [n]\n",
  "OXIDIC": "of or like an oxide, a compound containing oxygen [adj]\n",
  "OXIDIMETRIC": "relating to oxidimetry, a branch of volumetric analysis in which oxidizing agents are used in titrations [adj]\n",
  "OXIDIMETRIES": "OXIDIMETRY, a branch of volumetric analysis in which oxidizing agents are used in titrations [n]\n",
  "OXIDIMETRY": "a branch of volumetric analysis in which oxidizing agents are used in titrations [n OXIDIMETRIES]\n",
  "OXIDISABLE": "that can be oxidised, also OXIDIZABLE [adj]\n",
  "OXIDISATION": "the act of oxidising, also OXIDIZATION [n -S]\n",
  "OXIDISATIONS": "OXIDISATION, the act of oxidising, also OXIDIZATION [n]\n",
  "OXIDISE": "to combine with oxygen, also OXIDATE, OXIDIZE [v OXIDISED, OXIDISING, OXIDISES]\n",
  "OXIDISED": "OXIDISE, to combine with oxygen, also OXIDATE, OXIDIZE [v]\n",
  "OXIDISER": "an oxidant, also OXIDIZER [n -S]\n",
  "OXIDISERS": "OXIDISER, an oxidant, also OXIDIZER [n]\n",
  "OXIDISES": "OXIDISE, to combine with oxygen, also OXIDATE, OXIDIZE [v]\n",
  "OXIDISING": "OXIDISE, to combine with oxygen, also OXIDATE, OXIDIZE [v]\n",
  "OXIDIZABLE": "that can be oxidized, also OXIDISABLE [adj]\n",
  "OXIDIZATION": "the act of oxidizing, also OXIDISATION [n -S]\n",
  "OXIDIZATIONS": "OXIDIZATION, the act of oxidizing, also OXIDISATION [n]\n",
  "OXIDIZE": "to combine with oxygen, also OXIDATE, OXIDISE [v OXIDIZED, OXIDIZING, OXIDIZES]\n",
  "OXIDIZED": "OXIDIZE, to combine with oxygen, also OXIDATE, OXIDISE [v]\n",
  "OXIDIZER": "an oxidant, also OXIDISER [n -S]\n",
  "OXIDIZERS": "OXIDIZER, an oxidant, also OXIDISER [n]\n",
  "OXIDIZES": "OXIDIZE, to combine with oxygen, also OXIDATE, OXIDISE [v]\n",
  "OXIDIZING": "OXIDIZE, to combine with oxygen, also OXIDATE, OXIDISE [v]\n",
  "OXIDOREDUCTASE": "an enzyme that catalyzes an oxidationreduction reaction [n -S]\n",
  "OXIDOREDUCTASES": "OXIDOREDUCTASE, an enzyme that catalyzes an oxidationreduction reaction [n]\n",
  "OXIDS": "OXID, a compound containing oxygen, also OXIDE [n]\n",
  "OXIES": "OXY, a powerful analgesic drug, synthesized from thebaine [n]\n",
  "OXIM": "any of a number of compounds obtained by the action of hydroxylamine on aldehydes or ketones, also OXIME [n -S]\n",
  "OXIME": "any of a number of compounds obtained by the action of hydroxylamine on aldehydes or ketones, also OXIM [n -S]\n",
  "OXIMES": "OXIME, any of a number of compounds obtained by the action of hydroxylamine on aldehydes or ketones, also OXIM [n]\n",
  "OXIMETER": "a photoelectric instrument for measuring the oxygen saturation of the blood [n -S]\n",
  "OXIMETERS": "OXIMETER, a photoelectric instrument for measuring the oxygen saturation of the blood [n]\n",
  "OXIMETRIES": "OXIMETRY, measurement with an oximeter, a photoelectric instrument for measuring the oxygen saturation of the blood [n]\n",
  "OXIMETRY": "measurement with an oximeter, a photoelectric instrument for measuring the oxygen saturation of the blood [n OXIMETRIES]\n",
  "OXIMS": "OXIM, any of a number of compounds obtained by the action of hydroxylamine on aldehydes or ketones, also OXIME [n]\n",
  "OXLAND": "as much land as one ox could plough, also OXGANG, OXGATE [n -S]\n",
  "OXLANDS": "OXLAND, as much land as one ox could plough, also OXGANG, OXGATE [n]\n",
  "OXLIKE": "like an ox [adj]\n",
  "OXLIP": "a flower like the cowslip, also OXSLIP [n -S]\n",
  "OXLIPS": "OXLIP, a flower like the cowslip, also OXSLIP [n]\n",
  "OXO": "of compounds, containing oxygen, also OXY [adj]\n",
  "OXONIUM": "a certain grouping of oxygen and hydrogen atoms [n -S]\n",
  "OXONIUMS": "OXONIUM, a certain grouping of oxygen and hydrogen atoms [n]\n",
  "OXPECKER": "an African bird, aka beefeater [n -S]\n",
  "OXPECKERS": "OXPECKER, an African bird, aka beefeater [n]\n",
  "OXSLIP": "(Shakespeare) an oxlip [n -S]\n",
  "OXSLIPS": "OXSLIP, (Shakespeare) an oxlip [n]\n",
  "OXTAIL": "the tail of an ox, esp. as used in soup [n -S]\n",
  "OXTAILS": "OXTAIL, the tail of an ox, esp. as used in soup [n]\n",
  "OXTER": "(Scots) to take under the arm [v -ED, -ING, -S]\n",
  "OXTERED": "OXTER, (Scots) to take under the arm [v]\n",
  "OXTERING": "OXTER, (Scots) to take under the arm [v]\n",
  "OXTERS": "OXTER, (Scots) to take under the arm [v]\n",
  "OXTONGUE": "any of several plants with rough tongue-shaped leaves [n -S]\n",
  "OXTONGUES": "OXTONGUE, any of several plants with rough tongue-shaped leaves [n]\n",
  "OXY": "a powerful analgesic drug, synthesized from thebaine [n OXIES]\n",
  "OXYACETYLENE": "a mixture of oxygen and acetylene, esp. for cutting or welding [n -S]\n",
  "OXYACETYLENES": "OXYACETYLENE, a mixture of oxygen and acetylene, esp. for cutting or welding [n]\n",
  "OXYACID": "an acid that contains oxygen [n -S]\n",
  "OXYACIDS": "OXYACID, an acid that contains oxygen [n]\n",
  "OXYANION": "an anion containing one or more oxygen atoms bonded to another element (as in the sulphate and carbonate ions) [n -S]\n",
  "OXYANIONS": "OXYANION, an anion containing one or more oxygen atoms bonded to another element (as in the sulphate and carbonate ions) [n]\n",
  "OXYCEPHALIC": "having a conical skull, also OXYCEPHALOUS [adj]\n",
  "OXYCEPHALIES": "OXYCEPHALY, the condition of having a conical skull [n]\n",
  "OXYCEPHALOUS": "having a conical skull, also OXYCEPHALIC [adj]\n",
  "OXYCEPHALY": "the condition of having a conical skull [n OXYCEPHALIES]\n",
  "OXYCODONE": "an opiate drug used as a painkiller [n -S]\n",
  "OXYCODONES": "OXYCODONE, an opiate drug used as a painkiller [n]\n",
  "OXYGEN": "a gaseous element [n -S]\n",
  "OXYGENASE": "an enzyme [n -S]\n",
  "OXYGENASES": "OXYGENASE, an enzyme [n]\n",
  "OXYGENATE": "to impregnate or treat with oxygen [v OXYGENATED, OXYGENATING, OXYGENATES]\n",
  "OXYGENATED": "OXYGENATE, to impregnate or treat with oxygen [v]\n",
  "OXYGENATES": "OXYGENATE, to impregnate or treat with oxygen [v]\n",
  "OXYGENATING": "OXYGENATE, to impregnate or treat with oxygen [v]\n",
  "OXYGENATION": "the act of oxygenating [n -S]\n",
  "OXYGENATIONS": "OXYGENATION, the act of oxygenating [n]\n",
  "OXYGENATOR": "an oxidizer [n -S]\n",
  "OXYGENATORS": "OXYGENATOR, an oxidizer [n]\n",
  "OXYGENIC": "pertaining to or containing oxygen [adj]\n",
  "OXYGENISE": "to oxygenate, also OXYGENIZE [v OXYGENISED, OXYGENISING, OXYGENISES]\n",
  "OXYGENISED": "OXYGENISE, to oxygenate, also OXYGENIZE [v]\n",
  "OXYGENISER": "an agent that oxygenises, also OXYGENIZER [n -S]\n",
  "OXYGENISERS": "OXYGENISER, an agent that oxygenises, also OXYGENIZER [n]\n",
  "OXYGENISES": "OXYGENISE, to oxygenate, also OXYGENIZE [v]\n",
  "OXYGENISING": "OXYGENISE, to oxygenate, also OXYGENIZE [v]\n",
  "OXYGENIZE": "to oxygenate, also OXYGENISE [v OXYGENIZED, OXYGENIZING, OXYGENIZES]\n",
  "OXYGENIZED": "OXYGENIZE, to oxygenate, also OXYGENISE [v]\n",
  "OXYGENIZER": "an agent that oxygenizes, also OXYGENISER [n -S]\n",
  "OXYGENIZERS": "OXYGENIZER, an agent that oxygenizes, also OXYGENISER [n]\n",
  "OXYGENIZES": "OXYGENIZE, to oxygenate, also OXYGENISE [v]\n",
  "OXYGENIZING": "OXYGENIZE, to oxygenate, also OXYGENISE [v]\n",
  "OXYGENLESS": "without oxygen [adj]\n",
  "OXYGENOUS": "consisting of or containing oxygen [adj]\n",
  "OXYGENS": "OXYGEN, a gaseous element [n]\n",
  "OXYHAEMOGLOBIN": "a loose compound of oxygen and haemoglobin, also OXYHEMOGLOBIN [n -S]\n",
  "OXYHAEMOGLOBINS": "OXYHAEMOGLOBIN, a loose compound of oxygen and haemoglobin, also OXYHEMOGLOBIN [n]\n",
  "OXYHEMOGLOBIN": "a loose compound of oxygen and haemoglobin, also OXYHAEMOGLOBIN [n -S]\n",
  "OXYHEMOGLOBINS": "OXYHEMOGLOBIN, a loose compound of oxygen and haemoglobin, also OXYHAEMOGLOBIN [n]\n",
  "OXYHYDROGEN": "a mixture of hydrogen and oxygen used to provide an intense flame for welding [n -S]\n",
  "OXYHYDROGENS": "OXYHYDROGEN, a mixture of hydrogen and oxygen used to provide an intense flame for welding [n]\n",
  "OXYMEL": "(Greek) a mixture of honey, water, vinegar, and spice, boiled to a syrup [n -S]\n",
  "OXYMELS": "OXYMEL, (Greek) a mixture of honey, water, vinegar, and spice, boiled to a syrup [n]\n",
  "OXYMORA": "OXYMORON, (Greek) a self-contradictory expression [n]\n",
  "OXYMORON": "(Greek) a self-contradictory expression [n OXYMORONS or OXYMORA]\n",
  "OXYMORONIC": "of or like an oxymoron, an apparent paradox achieved by the juxtaposition of words which seem to contradict one another [adj OXYMORONICALLY]\n",
  "OXYMORONICALLY": "OXYMORONIC, of or like an oxymoron, an apparent paradox achieved by the juxtaposition of words which seem to contradict one another [adv]\n",
  "OXYMORONS": "OXYMORON, (Greek) a self-contradictory expression [n]\n",
  "OXYNTIC": "of stomach cells, secreting acid [adj]\n",
  "OXYPHENBUTAZONE": "a phenylbutazone derivative having antiinflammatory, analgesic, and antipyretic effects [n]\n",
  "OXYPHIL": "an organism that thrives on an acid environment, also OXYPHILE [n -S]\n",
  "OXYPHILE": "an organism that thrives on an acid environment, also OXYPHIL [n -S]\n",
  "OXYPHILES": "OXYPHILE, an organism that thrives on an acid environment, also OXYPHIL [n]\n",
  "OXYPHILIC": "thriving in an acid environment [adj]\n",
  "OXYPHILS": "OXYPHIL, an organism that thrives on an acid environment, also OXYPHILE [n]\n",
  "OXYRHYNCHUS": "an Egyptian fish, sacred to the goddess Hathor, represented on coins and sculptures [n -ES]\n",
  "OXYRHYNCHUSES": "OXYRHYNCHUS, an Egyptian fish, sacred to the goddess Hathor, represented on coins and sculptures [n]\n",
  "OXYSALT": "a salt of an oxyacid [n -S]\n",
  "OXYSALTS": "OXYSALT, a salt of an oxyacid [n]\n",
  "OXYSOME": "a structural unit of cellular cristae [n -S]\n",
  "OXYSOMES": "OXYSOME, a structural unit of cellular cristae [n]\n",
  "OXYSULPHIDE": "a compound containing an element combined with oxygen and sulphur [n -S]\n",
  "OXYSULPHIDES": "OXYSULPHIDE, a compound containing an element combined with oxygen and sulphur [n]\n",
  "OXYTETRACYCLINE": "a yellow crystalline broad-spectrum antibiotic produced by a soil actinomycete [n]\n",
  "OXYTOCIC": "a drug that hastens childbirth [n -S]\n",
  "OXYTOCICS": "OXYTOCIC, a drug that hastens childbirth [n]\n",
  "OXYTOCIN": "a pituitary hormone that stimulates uterine muscle contraction [n -S]\n",
  "OXYTOCINS": "OXYTOCIN, a pituitary hormone that stimulates uterine muscle contraction [n]\n",
  "OXYTONE": "(Greek) a word bearing an acute accent on the last syllable [n -S]\n",
  "OXYTONES": "OXYTONE, (Greek) a word bearing an acute accent on the last syllable [n]\n",
  "OXYTONIC": "like an oxytone [adj]\n",
  "OXYTROPE": "a genus of plants in the legume family, including locoweed [n -S]\n",
  "OXYTROPES": "OXYTROPE, a genus of plants in the legume family, including locoweed [n]\n",
  "OXYURIASES": "OXYURIASIS, pinworm infestation [n]\n",
  "OXYURIASIS": "pinworm infestation [n OXYURIASES]\n",
  "OY": "(Scots) a grandchild, also OE, OYE [n -S]\n",
  "OYE": "a grandchild, also OE, OY [n -S]\n",
  "OYER": "(obsolete) a hearing in a lawcourt, an assize [n -S]\n",
  "OYERS": "OYER, (obsolete) a hearing in a lawcourt, an assize [n]\n",
  "OYES": "a proclamation, also OYEZ [n OYESES or OYESSES]\n",
  "OYESES": "OYES, a proclamation, also OYEZ [n]\n",
  "OYESSES": "OYES, a proclamation, also OYEZ [n]\n",
  "OYEZ": "a proclamation, also OYES [n -ES]\n",
  "OYEZES": "OYEZ, a proclamation, also OYES [n]\n",
  "OYS": "OY, (Scots) a grandchild, also OE, OYE [n]\n",
  "OYSTER": "a bivalve shellfish, used as food [n -S] / to gather oysters [v -ED, -ING, -S]\n",
  "OYSTERCATCHER": "a black and white wading bird, with red bill and feet, feeding on limpets and mussels (not oysters) [n -S]\n",
  "OYSTERCATCHERS": "OYSTERCATCHER, a black and white wading bird, with red bill and feet, feeding on limpets and mussels (not oysters) [n]\n",
  "OYSTERED": "OYSTER, to gather oysters [v]\n",
  "OYSTERER": "one who deals in oysters [n -S]\n",
  "OYSTERERS": "OYSTERER, one who deals in oysters [n]\n",
  "OYSTERING": "gathering oysters [n -S]\n",
  "OYSTERINGS": "OYSTERING, gathering oysters [n]\n",
  "OYSTERMAN": "one who gathers or breeds oysters [n OYSTERMEN]\n",
  "OYSTERMEN": "OYSTERMAN, one who gathers or breeds oysters [n]\n",
  "OYSTERS": "OYSTER, to gather oysters [v]\n",
  "OYSTRIGE": "(Spenser) an ostrich, also ESTRICH, ESTRIDGE [n -S]\n",
  "OYSTRIGES": "OYSTRIGE, (Spenser) an ostrich, also ESTRICH, ESTRIDGE [n]\n",
  "OZAENA": "(Latin) a fetid discharge from the nostrils [n -S]\n",
  "OZAENAS": "OZAENA, (Latin) a fetid discharge from the nostrils [n]\n",
  "OZALID": "a process of printing positive images from film [n -S]\n",
  "OZALIDS": "OZALID, a process of printing positive images from film [n]\n",
  "OZEKI": "(Japanese) a champion sumo wrestler [n -S]\n",
  "OZEKIS": "OZEKI, (Japanese) a champion sumo wrestler [n]\n",
  "OZOCERITE": "a waxy natural paraffin, also OZOKERITE [n -S]\n",
  "OZOCERITES": "OZOCERITE, a waxy natural paraffin, also OZOKERITE [n]\n",
  "OZOKERITE": "a waxy natural paraffin, also OZOCERITE [n -S]\n",
  "OZOKERITES": "OZOKERITE, a waxy natural paraffin, also OZOCERITE [n]\n",
  "OZONATE": "to treat with ozone [v OZONATED, OZONATING, OZONATES]\n",
  "OZONATED": "OZONATE, to treat with ozone [v]\n",
  "OZONATES": "OZONATE, to treat with ozone [v]\n",
  "OZONATING": "OZONATE, to treat with ozone [v]\n",
  "OZONATION": "the act of treating with ozone, also OZONISATION, OZONIZATION [n -S]\n",
  "OZONATIONS": "OZONATION, the act of treating with ozone, also OZONISATION, OZONIZATION [n]\n",
  "OZONE": "an allotropic form of oxygen present in the atmosphere [n -S]\n",
  "OZONES": "OZONE, an allotropic form of oxygen present in the atmosphere [n]\n",
  "OZONIC": "pertaining to ozone [adj]\n",
  "OZONIDE": "a compound of ozone [n -S]\n",
  "OZONIDES": "OZONIDE, a compound of ozone [n]\n",
  "OZONIFEROUS": "producing ozone [adj]\n",
  "OZONISATION": "the act of treating with ozone, also OZONATION, OZONIZATION [n -S]\n",
  "OZONISATIONS": "OZONISATION, the act of treating with ozone, also OZONATION, OZONIZATION [n]\n",
  "OZONISE": "to convert into ozone, also OZONIZE [v OZONISED, OZONISING, OZONISES]\n",
  "OZONISED": "OZONISE, to convert into ozone, also OZONIZE [v]\n",
  "OZONISER": "a device for turning oxygen into ozone, also OZONIZER [n -S]\n",
  "OZONISERS": "OZONISER, a device for turning oxygen into ozone, also OZONIZER [n]\n",
  "OZONISES": "OZONISE, to convert into ozone, also OZONIZE [v]\n",
  "OZONISING": "OZONISE, to convert into ozone, also OZONIZE [v]\n",
  "OZONIZATION": "the act of treating with ozone, also OZONATION, OZONISATION [n -S]\n",
  "OZONIZATIONS": "OZONIZATION, the act of treating with ozone, also OZONATION, OZONISATION [n]\n",
  "OZONIZE": "to convert into ozone, also OZONISE [v OZONIZED, OZONIZING, OZONIZES]\n",
  "OZONIZED": "OZONIZE, to convert into ozone, also OZONISE [v]\n",
  "OZONIZER": "a device for turning oxygen into ozone, also OZONISER [n -S]\n",
  "OZONIZERS": "OZONIZER, a device for turning oxygen into ozone, also OZONISER [n]\n",
  "OZONIZES": "OZONIZE, to convert into ozone, also OZONISE [v]\n",
  "OZONIZING": "OZONIZE, to convert into ozone, also OZONISE [v]\n",
  "OZONOLYSES": "OZONOLYSIS, the process of treating an organic compound with ozone to form an ozonide, used to locate double bonds in molecules [n]\n",
  "OZONOLYSIS": "the process of treating an organic compound with ozone to form an ozonide, used to locate double bonds in molecules [n OZONOLYSES]\n",
  "OZONOSPHERE": "the ozone layer [n -S]\n",
  "OZONOSPHERES": "OZONOSPHERE, the ozone layer [n]\n",
  "OZONOUS": "pertaining to or containing, ozone [adj]\n",
  "OZZIE": "(dialect) a hospital [n -S]\n",
  "OZZIES": "OZZIE, (dialect) a hospital [n]\n",
  "PA": "(Maori) a hill fort, also PAH [n -S]\n",
  "PAAL": "(Dutch) in the Caribbean, a stake driven into the ground [n -S]\n",
  "PAALS": "PAAL, (Dutch) in the Caribbean, a stake driven into the ground [n]\n",
  "PAAN": "betel leaf [n -S]\n",
  "PAANS": "PAAN, betel leaf [n]\n",
  "PABLUM": "(Latin) food, esp. a suspension or solution of nutrients in a state suitable for absorption; something (as writing or speech) that is insipid, simplistic, or bland, also PABULUM [n -S]\n",
  "PABLUMS": "PABLUM, (Latin) food, esp. a suspension or solution of nutrients in a state suitable for absorption; something (as writing or speech) that is insipid, simplistic, or bland, also PABULUM [n]\n",
  "PABOUCHE": "(French) an Oriental heelless slipper, also BABOOSH, BABOUCHE, BABUCHE [n -S]\n",
  "PABOUCHES": "PABOUCHE, (French) an Oriental heelless slipper, also BABOOSH, BABOUCHE, BABUCHE [n]\n",
  "PABULAR": "of or relating to nourishment, also PABULOUS [adj]\n",
  "PABULOUS": "of or relating to nourishment, also PABULAR [adj]\n",
  "PABULUM": "(Latin) food, esp. a suspension or solution of nutrients in a state suitable for absorption; something (as writing or speech) that is insipid, simplistic, or bland, also PABLUM [n -S]\n",
  "PABULUMS": "PABULUM, (Latin) food, esp. a suspension or solution of nutrients in a state suitable for absorption; something (as writing or speech) that is insipid, simplistic, or bland, also PABLUM [n]\n",
  "PAC": "a shoe patterned after a moccasin [n -S]\n",
  "PACA": "(Tupi) a South American rodent, the spotted cavy [n -S]\n",
  "PACABLE": "(archaic) able to be appeased; willing to forgive [adj]\n",
  "PACAS": "PACA, (Tupi) a South American rodent, the spotted cavy [n]\n",
  "PACATION": "appeasement [n -S]\n",
  "PACATIONS": "PACATION, appeasement [n]\n",
  "PACE": "to walk with measured steps [v PACED, PACING, PACES]\n",
  "PACED": "PACE, to walk with measured steps [v]\n",
  "PACEMAKER": "a person who sets the pace in a race [n -S]\n",
  "PACEMAKERS": "PACEMAKER, a person who sets the pace in a race [n]\n",
  "PACEMAKING": "performing the function as of a pacemaker [n -S]\n",
  "PACEMAKINGS": "PACEMAKING, performing the function as of a pacemaker [n]\n",
  "PACEMAN": "in cricket, a pace bowler [n PACEMEN]\n",
  "PACEMEN": "PACEMAN, in cricket, a pace bowler [n]\n",
  "PACER": "a horse whose gait is a pace [n -S]\n",
  "PACERS": "PACER, a horse whose gait is a pace [n]\n",
  "PACES": "PACE, to walk with measured steps [v]\n",
  "PACESETTER": "one who sets the pace [n -S]\n",
  "PACESETTERS": "PACESETTER, one who sets the pace [n]\n",
  "PACESETTING": "the act of setting a pace [n -S]\n",
  "PACESETTINGS": "PACESETTING, the act of setting a pace [n]\n",
  "PACEWAY": "(Australian) a racecourse for pacing and trotting [n -S]\n",
  "PACEWAYS": "PACEWAY, (Australian) a racecourse for pacing and trotting [n]\n",
  "PACEY": "fast, lively, smart, also PACY [adj PACIER, PACIEST]\n",
  "PACHA": "(Turkish) a former Turkish high official, also PASHA [n -S]\n",
  "PACHADOM": "(Turkish) the rank of a pasha, also PASHADOM [n -S]\n",
  "PACHADOMS": "PACHADOM, (Turkish) the rank of a pasha, also PASHADOM [n]\n",
  "PACHAK": "(Hindi) an aromatic root resembling ginger, also PUTCHOCK, PUTCHUK [n -S]\n",
  "PACHAKS": "PACHAK, (Hindi) an aromatic root resembling ginger, also PUTCHOCK, PUTCHUK [n]\n",
  "PACHALIC": "(Turkish) the territory of a pasha, also PASHALIK, PASHALIC [n -S]\n",
  "PACHALICS": "PACHALIC, (Turkish) the territory of a pasha, also PASHALIK, PASHALIC [n]\n",
  "PACHAS": "PACHA, (Turkish) a former Turkish high official, also PASHA [n]\n",
  "PACHINKO": "(Japanese) a Japanese pinball game [n -S]\n",
  "PACHINKOS": "PACHINKO, (Japanese) a Japanese pinball game [n]\n",
  "PACHISI": "(Hindi) an Indian board game, also PARCHESI, PARCHISI [n -S]\n",
  "PACHISIS": "PACHISI, (Hindi) an Indian board game, also PARCHESI, PARCHISI [n]\n",
  "PACHOULI": "(Tamil) an Asiatic tree with a fragrant perfume oil; the resulting perfume, also PATCHOULI, PATCHOULY [n -S]\n",
  "PACHOULIS": "PACHOULI, (Tamil) an Asiatic tree with a fragrant perfume oil; the resulting perfume, also PATCHOULI, PATCHOULY [n]\n",
  "PACHUCO": "(Spanish) a flashy Mexican-American youth [n -S]\n",
  "PACHUCOS": "PACHUCO, (Spanish) a flashy Mexican-American youth [n]\n",
  "PACHYCARPOUS": "having a thick pericarp [adj]\n",
  "PACHYDACTYL": "having thick digits, also PACHYDACTYLOUS [adj]\n",
  "PACHYDACTYLOUS": "having thick digits, also PACHYDACTYL [adj]\n",
  "PACHYDERM": "a thick-skinned quadruped, esp. an elephant, a hippopotamus, or a rhinoceros [n -S]\n",
  "PACHYDERMAL": "of or like a pachyderm [adj]\n",
  "PACHYDERMATOUS": "thick-skinned, also PACHYDERMOUS [adj]\n",
  "PACHYDERMIA": "elephantiasis [n -S]\n",
  "PACHYDERMIAS": "PACHYDERMIA, elephantiasis [n]\n",
  "PACHYDERMIC": "like a pachyderm [adj]\n",
  "PACHYDERMOUS": "thick-skinned, also PACHYDERMATOUS [adj]\n",
  "PACHYDERMS": "PACHYDERM, a thick-skinned quadruped, esp. an elephant, a hippopotamus, or a rhinoceros [n]\n",
  "PACHYMENINGITIS": "a form of meningitis [n]\n",
  "PACHYMETER": "an instrument for measuring small thicknesses [n -S]\n",
  "PACHYMETERS": "PACHYMETER, an instrument for measuring small thicknesses [n]\n",
  "PACHYSANDRA": "(Greek) a Japanese tree with evergreen leaves [n -S]\n",
  "PACHYSANDRAS": "PACHYSANDRA, (Greek) a Japanese tree with evergreen leaves [n]\n",
  "PACHYTENE": "the stage of the prophase of meiosis following zygotene [n -S]\n",
  "PACHYTENES": "PACHYTENE, the stage of the prophase of meiosis following zygotene [n]\n",
  "PACIER": "PACY, fast, also PACEY [adj]\n",
  "PACIEST": "PACY, fast, also PACEY [adj]\n",
  "PACIFIABLE": "capable of being pacified [adj]\n",
  "PACIFIC": "peacemaking, peaceful [adj PACIFICALLY]\n",
  "PACIFICAE": "letters recommending the bearer as being at peace with the Church, aka letters pacifical [n]\n",
  "PACIFICAL": "pacific, esp. in Letters pacifical, letters recommending the bearer as being one at peace with the church [adj]\n",
  "PACIFICALLY": "PACIFICAL, pacific, esp. in Letters pacifical, letters recommending the bearer as being one at peace with the church [adv]\n",
  "PACIFICATE": "to give peace to [v PACIFICATED, PACIFICATING, PACIFICATES]\n",
  "PACIFICATED": "PACIFICATE, to give peace to [v]\n",
  "PACIFICATES": "PACIFICATE, to give peace to [v]\n",
  "PACIFICATING": "PACIFICATE, to give peace to [v]\n",
  "PACIFICATION": "the act of pacifying [n -S]\n",
  "PACIFICATIONS": "PACIFICATION, the act of pacifying [n]\n",
  "PACIFICATOR": "a peacemaker [n -S]\n",
  "PACIFICATORS": "PACIFICATOR, a peacemaker [n]\n",
  "PACIFICATORY": "tending to make peace [adj]\n",
  "PACIFICISM": "opposition to war or violence, also PACIFISM [n -S]\n",
  "PACIFICISMS": "PACIFICISM, opposition to war or violence, also PACIFISM [n]\n",
  "PACIFICIST": "one who adheres to the beliefs and principles of pacifists [n PACIFICISTS]\n",
  "PACIFICISTS": "PACIFICIST, one who adheres to the beliefs and principles of pacifists [n]\n",
  "PACIFIED": "PACIFY, to make peaceful [v]\n",
  "PACIFIER": "something that pacifies e.g. a child's dummy [n -S]\n",
  "PACIFIERS": "PACIFIER, something that pacifies e.g. a child's dummy [n]\n",
  "PACIFIES": "PACIFY, to make peaceful [v]\n",
  "PACIFISM": "opposition to war or violence, also PACIFICISM [n -S]\n",
  "PACIFISMS": "PACIFISM, opposition to war or violence, also PACIFICISM [n]\n",
  "PACIFIST": "an advocate of pacifism [n -S]\n",
  "PACIFISTIC": "relating to the beliefs and principles of pacifists [adj PACIFISTICALLY]\n",
  "PACIFISTICALLY": "PACIFISTIC, relating to the beliefs and principles of pacifists [adv]\n",
  "PACIFISTS": "PACIFIST, an advocate of pacifism [n]\n",
  "PACIFY": "to make peaceful [v PACIFIED, PACIFYING, PACIFIES]\n",
  "PACIFYING": "PACIFY, to make peaceful [v]\n",
  "PACING": "the act of setting a pace [n -S]\n",
  "PACINGS": "PACING, the act of setting a pace [n]\n",
  "PACK": "to enclose for transportation or storage [v -ED, -ING, -S]\n",
  "PACKABILITIES": "PACKABILITY, the ability to be packed [n]\n",
  "PACKABILITY": "the ability to be packed [n PACKABILITIES]\n",
  "PACKABLE": "able to be packed [adj]\n",
  "PACKAGE": "to put into a container or wrapping [v PACKAGED, PACKAGING, PACKAGES]\n",
  "PACKAGED": "PACKAGE, to put into a container or wrapping [v]\n",
  "PACKAGER": "one who packages [n -S]\n",
  "PACKAGERS": "PACKAGER, one who packages [n]\n",
  "PACKAGES": "PACKAGE, to put into a container or wrapping [v]\n",
  "PACKAGING": "anything used to package goods; the total presentation of a product for sale [n -S]\n",
  "PACKAGINGS": "PACKAGING, anything used to package goods; the total presentation of a product for sale [n]\n",
  "PACKBOARD": "a canvas-covered wooden or metal frame for carrying goods etc. [n -S]\n",
  "PACKBOARDS": "PACKBOARD, a canvas-covered wooden or metal frame for carrying goods etc. [n]\n",
  "PACKCLOTH": "a cloth in which goods are enclosed [n -S]\n",
  "PACKCLOTHS": "PACKCLOTH, a cloth in which goods are enclosed [n]\n",
  "PACKED": "PACK, to enclose for transportation or storage [v]\n",
  "PACKER": "one who packs [n -S]\n",
  "PACKERS": "PACKER, one who packs [n]\n",
  "PACKET": "to make into a small package [v -ED, -ING, -S]\n",
  "PACKETED": "PACKET, to make into a small package [v]\n",
  "PACKETING": "PACKET, to make into a small package [v]\n",
  "PACKETISE": "to form data into packets, or bundled units, according to a specific protocol, also PACKETIZE [v PACKETISED, PACKETISING, PACKETISES]\n",
  "PACKETISED": "PACKETISE, to form data into packets, or bundled units, according to a specific protocol, also PACKETIZE [v]\n",
  "PACKETISES": "PACKETISE, to form data into packets, or bundled units, according to a specific protocol, also PACKETIZE [v]\n",
  "PACKETISING": "PACKETISE, to form data into packets, or bundled units, according to a specific protocol, also PACKETIZE [v]\n",
  "PACKETIZE": "to form data into packets, or bundled units, according to a specific protocol, also PACKETISE [v PACKETIZED, PACKETIZING, PACKETIZES]\n",
  "PACKETIZED": "PACKETIZE, to form data into packets, or bundled units, according to a specific protocol, also PACKETISE [v]\n",
  "PACKETIZES": "PACKETISE, to form data into packets, or bundled units, according to a specific protocol, also PACKETIZE [v]\n",
  "PACKETIZING": "PACKETISE, to form data into packets, or bundled units, according to a specific protocol, also PACKETIZE [v]\n",
  "PACKETS": "PACKET, to make into a small package [v]\n",
  "PACKFONG": "(Chinese) a Chinese alloy of nickel, zinc, and copper, also PAKFONG, PAKTHONG, PAKTONG [n -S]\n",
  "PACKFONGS": "PACKFONG, (Chinese) a Chinese alloy of nickel, zinc, and copper, also PAKFONG, PAKTHONG, PAKTONG [n]\n",
  "PACKFRAME": "a light metal frame with shoulder straps, used for carrying heavy loads [n -S]\n",
  "PACKFRAMES": "PACKFRAME, a light metal frame with shoulder straps, used for carrying heavy loads [n]\n",
  "PACKHORSE": "a horse used for carrying packs of goods or belongings [n -S]\n",
  "PACKHORSES": "PACKHORSE, a horse used for carrying packs of goods or belongings [n]\n",
  "PACKING": "material used to pack [n -S]\n",
  "PACKINGHOUSE": "an establishment for slaughtering livestock and processing packed meat [n -S]\n",
  "PACKINGHOUSES": "PACKINGHOUSE, an establishment for slaughtering livestock and processing packed meat [n]\n",
  "PACKINGS": "PACKING, material used to pack [n]\n",
  "PACKLY": "intimately [adv]\n",
  "PACKMAN": "one who bears a pack; a peddler [n PACKMEN]\n",
  "PACKMEN": "PACKMAN, one who bears a pack; a peddler [n]\n",
  "PACKMULE": "a mule used for carrying burdens [n -S]\n",
  "PACKMULES": "PACKMULE, a mule used for carrying burdens [n]\n",
  "PACKNESS": "intimacy [n -ES]\n",
  "PACKNESSES": "PACKNESS, intimacy [n]\n",
  "PACKS": "PACK, to enclose for transportation or storage [v]\n",
  "PACKSACK": "a carrying bag worn on the back [n -S]\n",
  "PACKSACKS": "PACKSACK, a carrying bag worn on the back [n]\n",
  "PACKSADDLE": "a saddle designed to support loads on the backs of pack animals [n -S]\n",
  "PACKSADDLES": "PACKSADDLE, a saddle designed to support loads on the backs of pack animals [n]\n",
  "PACKSHEET": "a list of things for packing [n -S]\n",
  "PACKSHEETS": "PACKSHEET, a list of things for packing [n]\n",
  "PACKSTAFF": "a staff for supporting a pedlar's pack when he or she rests [n -S]\n",
  "PACKSTAFFS": "PACKSTAFF, a staff for supporting a pedlar's pack when he or she rests [n]\n",
  "PACKTHREAD": "a strong two- or three ply thread [n -S]\n",
  "PACKTHREADS": "PACKTHREAD, a strong two- or three ply thread [n]\n",
  "PACKWAX": "the strong tendon in an animal's neck, also PAXWAX [n -ES]\n",
  "PACKWAXES": "PACKWAX, the strong tendon in an animal's neck, also PAXWAX [n]\n",
  "PACKWAY": "a narrow path for packhorses [n -S]\n",
  "PACKWAYS": "PACKWAY, a narrow path for packhorses [n]\n",
  "PACLITAXEL": "a drug used to treat ovarian cancer [n -S]\n",
  "PACLITAXELS": "PACLITAXEL, a drug used to treat ovarian cancer [n]\n",
  "PACO": "(Quechua) an alpaca [n -S]\n",
  "PACOS": "PACO, (Quechua) an alpaca [n]\n",
  "PACS": "PAC, a shoe patterned after a moccasin [n]\n",
  "PACT": "an agreement [n -S]\n",
  "PACTA": "PACTUM, (Latin) a pact [n]\n",
  "PACTION": "to agree, make a pact [v -ED, -ING, -S]\n",
  "PACTIONAL": "of the nature of, or by means of, a paction, an agreement, a compact [adj]\n",
  "PACTIONED": "PACTION, to agree, make a pact [v]\n",
  "PACTIONING": "PACTION, to agree, make a pact [v]\n",
  "PACTIONS": "PACTION, to agree, make a pact [v]\n",
  "PACTS": "PACT, an agreement [n]\n",
  "PACTUM": "(Latin) a pact [n PACTA]\n",
  "PACY": "fast, also PACEY [adj PACIER, PACIEST]\n",
  "PACZKI": "(Polish) a round, filled doughnut [n -S]\n",
  "PACZKIS": "PACZKI, (Polish) a round, filled doughnut [n]\n",
  "PAD": "to stuff or fill with soft material [v PADDED, PADDING, PADS]\n",
  "PADANG": "(Malay) a field, esp a playing field [n -S]\n",
  "PADANGS": "PADANG, (Malay) a field, esp a playing field [n]\n",
  "PADAUK": "(Burmese) a Burmese timber-tree, also PADOUK [n -S]\n",
  "PADAUKS": "PADAUK, (Burmese) a Burmese timber-tree, also PADOUK [n]\n",
  "PADDED": "PAD, to stuff or fill with soft material [v]\n",
  "PADDER": "a highwayman who steals on foot [n -S]\n",
  "PADDERS": "PADDER, a highwayman who steals on foot [n]\n",
  "PADDIES": "PADDY, a rice field, also PADI [n]\n",
  "PADDING": "material with which to pad [n -S]\n",
  "PADDINGS": "PADDING, material with which to pad [n]\n",
  "PADDLE": "to propel with an oar [v PADDLED, PADDLING, PADDLES]\n",
  "PADDLEBALL": "a game like handball played by hitting the ball with a paddle [n -S]\n",
  "PADDLEBALLS": "PADDLEBALL, a game like handball played by hitting the ball with a paddle [n]\n",
  "PADDLEBOARD": "a long narrow buoyant board used for riding the surf or in rescuing swimmers [n -S]\n",
  "PADDLEBOARDS": "PADDLEBOARD, a long narrow buoyant board used for riding the surf or in rescuing swimmers [n]\n",
  "PADDLEBOAT": "a paddle-steamer [n -S]\n",
  "PADDLEBOATS": "PADDLEBOAT, a paddle-steamer [n]\n",
  "PADDLED": "PADDLE, to propel with an oar [v]\n",
  "PADDLEFISH": "a member of the sturgeon family, aka spadefish [n -ES]\n",
  "PADDLEFISHES": "PADDLEFISH, a member of the sturgeon family, aka spadefish [n]\n",
  "PADDLER": "one who paddles [n -S]\n",
  "PADDLERS": "PADDLER, one who paddles [n]\n",
  "PADDLES": "PADDLE, to propel with an oar [v]\n",
  "PADDLING": "the act of propelling with a paddle [n -S]\n",
  "PADDLINGS": "PADDLING, the act of propelling with a paddle [n]\n",
  "PADDOCK": "to confine in a grassed enclosure [v -ED, -ING, -S]\n",
  "PADDOCKED": "PADDOCK, to confine in a grassed enclosure [v]\n",
  "PADDOCKING": "PADDOCK, to confine in a grassed enclosure [v]\n",
  "PADDOCKS": "PADDOCK, to confine in a grassed enclosure [v]\n",
  "PADDY": "a rice field, also PADI [n PADDIES]\n",
  "PADDYMELON": "(Native Australian) any of several small wallabies, also PADEMELON, PADYMELON [n -S]\n",
  "PADDYMELONS": "PADDYMELON, (Native Australian) any of several small wallabies, also PADEMELON, PADYMELON [n]\n",
  "PADDYWACK": "a slap or smack, also PADDYWHACK [n -S] / to spank or smack [v -ED, -ING, -S]\n",
  "PADDYWACKED": "PADDYWACK, to spank or smack [v]\n",
  "PADDYWACKING": "PADDYWACK, to spank or smack [v]\n",
  "PADDYWACKS": "PADDYWACK, to spank or smack [v]\n",
  "PADDYWHACK": "a slap or smack, also PADDYWACK [n -S]\n",
  "PADDYWHACKS": "PADDYWHACK, a slap or smack, also PADDYWACK [n]\n",
  "PADELLA": "(Italian) a candle made from a shallow dish of fat [n -S]\n",
  "PADELLAS": "PADELLA, (Italian) a candle made from a shallow dish of fat [n]\n",
  "PADEMELON": "(Native Australian) any of several small wallabies, also PADDYMELON, PADYMELON [n -S]\n",
  "PADEMELONS": "PADEMELON, (Native Australian) any of several small wallabies, also PADDYMELON, PADYMELON [n]\n",
  "PADERERO": "(Spanish) a type of old gun, also PEDRERO, PATERERO, PEDERERO [n -ES or -S]\n",
  "PADEREROES": "PADERERO, (Spanish) a type of old gun, also PEDRERO, PATERERO, PEDERERO [n]\n",
  "PADEREROS": "PADERERO, (Spanish) a type of old gun, also PEDRERO, PATERERO, PEDERERO [n]\n",
  "PADI": "(Malay) a rice field, also PADDY [n -S]\n",
  "PADIS": "PADI, (Malay) a rice field, also PADDY [n]\n",
  "PADISHAH": "(Persian) a chief ruler; monarch; sovereign, also PADSHAH [n -S]\n",
  "PADISHAHS": "PADISHAH, (Persian) a chief ruler; monarch; sovereign, also PADSHAH [n]\n",
  "PADKOS": "(South African) snacks and provisions for a journey [n]\n",
  "PADLE": "(Scots) a fish, aka lumpsucker, also PAIDLE [n -S]\n",
  "PADLES": "PADLE, (Scots) a fish, aka lumpsucker, also PAIDLE [n]\n",
  "PADLOCK": "to lock securely [v -ED, -ING, -S]\n",
  "PADLOCKED": "PADLOCK, to lock securely [v]\n",
  "PADLOCKING": "PADLOCK, to lock securely [v]\n",
  "PADLOCKS": "PADLOCK, to lock securely [v]\n",
  "PADMA": "(Sanskrit) the sacred lotus [n -S]\n",
  "PADMAS": "PADMA, (Sanskrit) the sacred lotus [n]\n",
  "PADNAG": "a horse that moves along at an easy pace [n -S]\n",
  "PADNAGS": "PADNAG, a horse that moves along at an easy pace [n]\n",
  "PADOUK": "(Burmese) a Burmese timber-tree, also PADAUK [n -S]\n",
  "PADOUKS": "PADOUK, (Burmese) a Burmese timber-tree, also PADAUK [n]\n",
  "PADRE": "(Italian) father; a title given to priests; an army chaplain [n PADRI or PADRES]\n",
  "PADRES": "PADRE, (Italian) father; a title given to priests; an army chaplain [n]\n",
  "PADRI": "PADRE, (Italian) father; a title given to priests; an army chaplain [n]\n",
  "PADRONA": "(Italian) a female boss or employer [n -S]\n",
  "PADRONAS": "PADRONA, (Italian) a female boss or employer [n]\n",
  "PADRONE": "(Italian) an innkeeper; an employer [n PADRONI or PADRONES]\n",
  "PADRONES": "PADRONE, (Italian) an innkeeper; an employer [n]\n",
  "PADRONI": "PADRONE, (Italian) an innkeeper; an employer [n]\n",
  "PADRONISM": "a system of work controlled by a padrone [n -S]\n",
  "PADRONISMS": "PADRONISM, a system of work controlled by a padrone [n]\n",
  "PADS": "PAD, to stuff or fill with soft material [v]\n",
  "PADSAW": "a small sawblade with a detachable handle [n -S]\n",
  "PADSAWS": "PADSAW, a small sawblade with a detachable handle [n]\n",
  "PADSHAH": "(Persian) a chief ruler; monarch; sovereign, also PADISHAH [n -S]\n",
  "PADSHAHS": "PADSHAH, (Persian) a chief ruler; monarch; sovereign, also PADISHAH [n]\n",
  "PADUASOY": "(French) corded silk; a garment of this [n -S]\n",
  "PADUASOYS": "PADUASOY, (French) corded silk; a garment of this [n]\n",
  "PADYMELON": "(Native Australian) any of several small wallabies, also PADDYMELON, PADEMELON [n -S]\n",
  "PADYMELONS": "PADYMELON, (Native Australian) any of several small wallabies, also PADDYMELON, PADEMELON [n]\n",
  "PAEAN": "(Latin) a song of thanksgiving [n -S]\n",
  "PAEANISM": "the chanting of a paean [n -S]\n",
  "PAEANISMS": "PAEANISM, the chanting of a paean [n]\n",
  "PAEANS": "PAEAN, (Latin) a song of thanksgiving [n]\n",
  "PAEDAGOGIC": "like a paedagogue, also PEDAGOGIC, PEDAGOGICAL [adj]\n",
  "PAEDAGOGUE": "one who teaches; by extension, a pedant, also PEDAGOG, PEDAGOGUE [n -S]\n",
  "PAEDAGOGUES": "PAEDAGOGUE, one who teaches; by extension, a pedant, also PEDAGOG, PEDAGOGUE [n]\n",
  "PAEDERAST": "one who has anal sex with a boy, also PEDERAST [n -S]\n",
  "PAEDERASTIC": "of or pertaining to pederasty, also PEDERASTIC [adj]\n",
  "PAEDERASTIES": "PAEDERASTY, anal intercourse between a man and a boy, also PEDERASTY [n]\n",
  "PAEDERASTS": "PAEDERAST, one who has anal sex with a boy, also PEDERAST [n]\n",
  "PAEDERASTY": "anal intercourse between a man and a boy, also PEDERASTY [n PAEDERASTIES]\n",
  "PAEDEUTIC": "relating to paideutics, the science or art of teaching, also PAIDEUTIC [adj]\n",
  "PAEDEUTICS": "educational method or theory, also PAIDEUTICS [n]\n",
  "PAEDIATRIC": "relating to the care of children, also PEDIATRIC [adj]\n",
  "PAEDIATRICIAN": "a specialist in children's ailments [n -S]\n",
  "PAEDIATRICIANS": "PAEDIATRICIAN, a specialist in children's ailments [n]\n",
  "PAEDIATRICS": "the care of children, also PEDIATRICS [n]\n",
  "PAEDIATRIES": "PAEDIATRY, the care of children [n]\n",
  "PAEDIATRIST": "a specialist in child care, also PEDIATRIST [n -S]\n",
  "PAEDIATRISTS": "PAEDIATRIST, a specialist in child care, also PEDIATRIST [n]\n",
  "PAEDIATRY": "the care of children [n PAEDIATRIES]\n",
  "PAEDO": "(short for) a paedophile [n -S]\n",
  "PAEDOBAPTISM": "the doctrine of infant baptism [n -S]\n",
  "PAEDOBAPTISMS": "PAEDOBAPTISM, the doctrine of infant baptism [n]\n",
  "PAEDOBAPTIST": "a believer in paedobaptism [n -S]\n",
  "PAEDOBAPTISTS": "PAEDOBAPTIST, a believer in paedobaptism [n]\n",
  "PAEDODONTIC": "relating to the branch of dentistry concerned with care of children's teeth [adj]\n",
  "PAEDODONTICS": "the branch of dentistry concerned with care of children's teeth [n]\n",
  "PAEDOGENESES": "PAEDOGENESIS, reproduction by an infant or larval organism [n]\n",
  "PAEDOGENESIS": "reproduction by an infant or larval organism [n PAEDOGENESES]\n",
  "PAEDOGENETIC": "relating to paedogenesis, reproduction by an infant or larval organism [adj]\n",
  "PAEDOGENIC": "of an animal, reproducing in the larval stage [adj]\n",
  "PAEDOLOGICAL": "related to paedology [adj]\n",
  "PAEDOLOGIES": "PAEDOLOGY, the study of the growth and development of children, also PEDOLOGY [n]\n",
  "PAEDOLOGIST": "one who studies the growth and development of children, also PEDOLOGIST [n -S]\n",
  "PAEDOLOGISTS": "PAEDOLOGIST, one who studies the growth and development of children, also PEDOLOGIST [n]\n",
  "PAEDOLOGY": "the study of the growth and development of children, also PEDOLOGY [n PAEDOLOGIES]\n",
  "PAEDOMORPHIC": "of, relating to, involving, or exhibiting paedomorphosis or paedomorphism [adj]\n",
  "PAEDOMORPHISM": "retention in the adult of infantile or juvenile characters, also PAEDOMORPHOSIS [n -S]\n",
  "PAEDOMORPHISMS": "PAEDOMORPHISM, retention in the adult of infantile or juvenile characters, also PAEDOMORPHOSIS [n]\n",
  "PAEDOMORPHOSES": "PAEDOMORPHOSIS, retention in the adult of infantile or juvenile characters, also PAEDOMORPHISM [n]\n",
  "PAEDOMORPHOSIS": "retention in the adult of infantile or juvenile characters, also PAEDOMORPHISM [n PAEDOMORPHOSES]\n",
  "PAEDOPHILE": "one with a perverted sexual desire for children, also PEDOPHILE [n -S]\n",
  "PAEDOPHILES": "PAEDOPHILE, one with a perverted sexual desire for children, also PEDOPHILE [n]\n",
  "PAEDOPHILIA": "the sexual love of children [n -S]\n",
  "PAEDOPHILIAC": "relating to paedophilia [adj] / a paedophile [n -S]\n",
  "PAEDOPHILIACS": "PAEDOPHILIAC, a paedophile [n]\n",
  "PAEDOPHILIAS": "PAEDOPHILIA, the sexual love of children [n]\n",
  "PAEDOPHILIC": "relating to paedophilia [adj] / a paedophile, also PEDOPHILIC [n -S]\n",
  "PAEDOPHILICS": "PAEDOPHILIC, a paedophile, also PEDOPHILIC [n]\n",
  "PAEDOS": "PAEDO, (short for) a paedophile [n]\n",
  "PAEDOTRIBE": "in ancient Greece, a gymnastic teacher [n -S]\n",
  "PAEDOTRIBES": "PAEDOTRIBE, in ancient Greece, a gymnastic teacher [n]\n",
  "PAEDOTROPHIES": "PAEDOTROPHY, the art of rearing children [n]\n",
  "PAEDOTROPHY": "the art of rearing children [n PAEDOTROPHIES]\n",
  "PAELLA": "(Spanish) a saffron-flavored Spanish dish of rice and vegetable, meat, chicken, or seafood [n -S]\n",
  "PAELLAS": "PAELLA, (Spanish) a saffron-flavored Spanish dish of rice and vegetable, meat, chicken, or seafood [n]\n",
  "PAENULA": "(Latin) a Roman travelling cloak [n PAENULAS or PAENULAE]\n",
  "PAENULAE": "PAENULA, (Latin) a Roman travelling cloak [n]\n",
  "PAENULAS": "PAENULA, (Latin) a Roman travelling cloak [n]\n",
  "PAEON": "(Latin) a foot of four syllables, one long and three short, also PAEONIC [n -S]\n",
  "PAEONIC": "a foot of four syllables, one long and three short, also PAEON [n -S]\n",
  "PAEONICS": "PAEONIC, a foot of four syllables, one long and three short, also PAEON [n]\n",
  "PAEONIES": "PAEONY, a showy flower, also PEONY, PINY, PIONEY, PIONY [n]\n",
  "PAEONS": "PAEON, (Latin) a foot of four syllables, one long and three short, also PAEONIC [n]\n",
  "PAEONY": "a showy flower, also PEONY, PINY, PIONEY, PIONY [n PAEONIES]\n",
  "PAESAN": "(Spanish) a fellow countryman, also PAESANO, PAISAN, PAISANO [n -S]\n",
  "PAESANI": "PAESANO, (Spanish) a fellow countryman, also PAESAN, PAISAN, PAISANO [n]\n",
  "PAESANO": "(Spanish) a fellow countryman, also PAESAN, PAISAN, PAISANO [n PAESANI or PAESANOS]\n",
  "PAESANOS": "PAESANO, (Spanish) a fellow countryman, also PAESAN, PAISAN, PAISANO [n]\n",
  "PAESANS": "PAESAN, (Spanish) a fellow countryman, also PAESANO, PAISAN, PAISANO [n]\n",
  "PAGAN": "an irreligious person [n -S]\n",
  "PAGANDOM": "the realm of pagans [n -S]\n",
  "PAGANDOMS": "PAGANDOM, the realm of pagans [n]\n",
  "PAGANISATION": "the act of paganising, also PAGANIZATION [n -S]\n",
  "PAGANISATIONS": "PAGANISATION, the act of paganising, also PAGANIZATION [n]\n",
  "PAGANISE": "to make irreligious, also PAGANIZE [v PAGANISED, PAGANISING, PAGANISES]\n",
  "PAGANISED": "PAGANISE, to make irreligious, also PAGANIZE [v]\n",
  "PAGANISER": "one who converts others to paganism, also PAGANIZER [n -S]\n",
  "PAGANISERS": "PAGANISER, one who converts others to paganism, also PAGANIZER [n]\n",
  "PAGANISES": "PAGANISE, to make irreligious, also PAGANIZE [v]\n",
  "PAGANISH": "of or pertaining to pagans [adj]\n",
  "PAGANISING": "PAGANISE, to make irreligious, also PAGANIZE [v]\n",
  "PAGANISM": "an irreligious attitude [n -S]\n",
  "PAGANISMS": "PAGANISM, an irreligious attitude [n]\n",
  "PAGANIST": "a student of pagans or paganism [n -S]\n",
  "PAGANISTIC": "relating to paganism [adj PAGANISTICALLY]\n",
  "PAGANISTICALLY": "PAGANISTIC, relating to paganism [adv]\n",
  "PAGANISTS": "PAGANIST, a student of pagans or paganism [n]\n",
  "PAGANIZATION": "the act of paganizing, also PAGANISATION [n -S]\n",
  "PAGANIZATIONS": "PAGANIZATION, the act of paganizing, also PAGANISATION [n]\n",
  "PAGANIZE": "to make irreligious, also PAGANISE [v PAGANIZED, PAGANIZING, PAGANIZES]\n",
  "PAGANIZED": "PAGANIZE, to make irreligious, also PAGANISE [v]\n",
  "PAGANIZER": "one who converts others to paganism, also PAGANISER [n -S]\n",
  "PAGANIZERS": "PAGANIZER, one who converts others to paganism, also PAGANISER [n]\n",
  "PAGANIZES": "PAGANIZE, to make irreligious, also PAGANISE [v]\n",
  "PAGANIZING": "PAGANIZE, to make irreligious, also PAGANISE [v]\n",
  "PAGANS": "PAGAN, an irreligious person [n]\n",
  "PAGE": "to summon by calling by name [v PAGED, PAGING, PAGES]\n",
  "PAGEANT": "an elaborate public spectacle [n -S]\n",
  "PAGEANTRIES": "PAGEANTRY, splendid display; pompous spectacle [n]\n",
  "PAGEANTRY": "splendid display; pompous spectacle [n PAGEANTRIES]\n",
  "PAGEANTS": "PAGEANT, an elaborate public spectacle [n]\n",
  "PAGEBOY": "a boy attendant [n -S]\n",
  "PAGEBOYS": "PAGEBOY, a boy attendant [n]\n",
  "PAGED": "PAGE, to summon by calling by name [v]\n",
  "PAGEFUL": "as much as a page can hold [n -S]\n",
  "PAGEFULS": "PAGEFUL, as much as a page can hold [n]\n",
  "PAGEHOOD": "the condition of a page [n -S]\n",
  "PAGEHOODS": "PAGEHOOD, the condition of a page [n]\n",
  "PAGER": "an electronic device, esp. portable, which pages a person, e.g. by means of a bleep, visual display etc. [n -S]\n",
  "PAGERS": "PAGER, an electronic device, esp. portable, which pages a person, e.g. by means of a bleep, visual display etc. [n]\n",
  "PAGES": "PAGE, to summon by calling by name [v]\n",
  "PAGEVIEW": "an electronic display of one page of information [n -S]\n",
  "PAGEVIEWS": "PAGEVIEW, an electronic display of one page of information [n]\n",
  "PAGINAL": "pertaining to the pages of a book [adj]\n",
  "PAGINATE": "to mark with consecutive numbers [v PAGINATED, PAGINATING, PAGINATES]\n",
  "PAGINATED": "PAGINATE, to mark with consecutive numbers [v]\n",
  "PAGINATES": "PAGINATE, to mark with consecutive numbers [v]\n",
  "PAGINATING": "PAGINATE, to mark with consecutive numbers [v]\n",
  "PAGINATION": "the action of paging [n -S]\n",
  "PAGINATIONS": "PAGINATION, the action of paging [n]\n",
  "PAGING": "a transfer of computer pages [n -S]\n",
  "PAGINGS": "PAGING, a transfer of computer pages [n]\n",
  "PAGLE": "(dialect) the cowslip, also PAIGLE [n -S]\n",
  "PAGLES": "PAGLE, (dialect) the cowslip, also PAIGLE [n]\n",
  "PAGOD": "(Persian) an Eastern temple, esp. in the form of a many-storeyed tapering tower, also PAGODA [n -S]\n",
  "PAGODA": "(Persian) an Eastern temple, esp. in the form of a many-storeyed tapering tower, also PAGOD [n -S]\n",
  "PAGODAS": "PAGODA, (Persian) an Eastern temple, esp. in the form of a many-storeyed tapering tower, also PAGOD [n]\n",
  "PAGODITE": "a soft, greenish, greyish or yellowish mineral, thought to be a variety of pinite, known particularly for its use by the Chinese for carving [n -S]\n",
  "PAGODITES": "PAGODITE, a soft, greenish, greyish or yellowish mineral, thought to be a variety of pinite, known particularly for its use by the Chinese for carving [n]\n",
  "PAGODS": "PAGOD, (Persian) an Eastern temple, esp. in the form of a many-storeyed tapering tower, also PAGODA [n]\n",
  "PAGRI": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PUGAREE, PUGGAREE, PUGGERY, PUGGREE, PUGGRY, PUGREE [n -S]\n",
  "PAGRIS": "PAGRI, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PUGAREE, PUGGAREE, PUGGERY, PUGGREE, PUGGRY, PUGREE [n]\n",
  "PAGURIAN": "a hermit crab, also PAGURID [n -S]\n",
  "PAGURIANS": "PAGURIAN, a hermit crab, also PAGURID [n]\n",
  "PAGURID": "a hermit crab, also PAGURIAN [n -S]\n",
  "PAGURIDS": "PAGURID, a hermit crab, also PAGURIAN [n]\n",
  "PAH": "(Maori) a hill fort, also PA [n -S]\n",
  "PAHAUTEA": "(Maori) a small pyramid-shaped New Zealand conifer [n -S]\n",
  "PAHAUTEAS": "PAHAUTEA, (Maori) a small pyramid-shaped New Zealand conifer [n]\n",
  "PAHLAVI": "(Persian) a former coin of Iran [n -S]\n",
  "PAHLAVIS": "PAHLAVI, (Persian) a former coin of Iran [n]\n",
  "PAHOEHOE": "(Hawaiian) a hardened lava with a smooth or ropy surface [n -S]\n",
  "PAHOEHOES": "PAHOEHOE, (Hawaiian) a hardened lava with a smooth or ropy surface [n]\n",
  "PAHS": "PAH, (Maori) a hill fort, also PA [n]\n",
  "PAID": "PAY, to give money in exchange for goods or services [v]\n",
  "PAIDEUTIC": "relating to paideutics, the science or art of teaching, also PAEDEUTIC [adj]\n",
  "PAIDEUTICS": "educational method or theory, also PAEDEUTICS [n]\n",
  "PAIDLE": "(Scots) a fish, aka lumpsucker, also PADLE [n -S]\n",
  "PAIDLES": "PAIDLE, (Scots) a fish, aka lumpsucker, also PADLE [n]\n",
  "PAIGLE": "(dialect) the cowslip, also PAGLE [n -S]\n",
  "PAIGLES": "PAIGLE, (dialect) the cowslip, also PAGLE [n]\n",
  "PAIK": "(Scots) to thump, drub [v -ED, -ING, -S]\n",
  "PAIKED": "PAIK, (Scots) to thump, drub [v]\n",
  "PAIKING": "PAIK, (Scots) to thump, drub [v]\n",
  "PAIKS": "PAIK, (Scots) to thump, drub [v]\n",
  "PAIL": "a watertight cylindrical container [n -S]\n",
  "PAILFUL": "as much as a pail can hold [n PAILFULS or PAILSFUL]\n",
  "PAILFULS": "PAILFUL, as much as a pail can hold [n]\n",
  "PAILLARD": "(French) a slice of meat pounded flat and grilled [n -S]\n",
  "PAILLARDS": "PAILLARD, (French) a slice of meat pounded flat and grilled [n]\n",
  "PAILLASSE": "(French) a hard straw mattress, also PALLIASSE [n -S]\n",
  "PAILLASSES": "PAILLASSE, (French) a hard straw mattress, also PALLIASSE [n]\n",
  "PAILLETTE": "(French) a piece of foil used in enamel painting; a spangle [n -S]\n",
  "PAILLETTES": "PAILLETTE, (French) a piece of foil used in enamel painting; a spangle [n]\n",
  "PAILLON": "(French) a decorative metallic scale or spangle; specifically a small piece of bright metal foil, used in enamel work [n -S]\n",
  "PAILLONS": "PAILLON, (French) a decorative metallic scale or spangle; specifically a small piece of bright metal foil, used in enamel work [n]\n",
  "PAILS": "PAIL, a watertight cylindrical container [n]\n",
  "PAILSFUL": "PAILFUL, as much as a pail can hold [n]\n",
  "PAIN": "to cause suffering or distress [v -ED, -ING, -S]\n",
  "PAINCH": "(Scots) the paunch [n -ES]\n",
  "PAINCHES": "PAINCH, (Scots) the paunch [n]\n",
  "PAINED": "PAIN, to cause suffering or distress [v]\n",
  "PAINFUL": "causing pain [adj PAINFULLER, PAINFULLEST, PAINFULLY]\n",
  "PAINFULLER": "PAINFUL, causing pain [adj]\n",
  "PAINFULLEST": "PAINFUL, causing pain [adj]\n",
  "PAINFULLY": "PAINFUL, causing pain [adv]\n",
  "PAINFULNESS": "the state of being painful [n -ES]\n",
  "PAINFULNESSES": "PAINFULNESS, the state of being painful [n]\n",
  "PAINIM": "(obsolete) a pagan, also PANIM, PAYNIM [n -S]\n",
  "PAINIMS": "PAINIM, (obsolete) a pagan, also PANIM, PAYNIM [n]\n",
  "PAINING": "PAIN, to cause suffering or distress [v]\n",
  "PAINKILLER": "something (as a drug) that relieves pain [n -S]\n",
  "PAINKILLERS": "PAINKILLER, something (as a drug) that relieves pain [n]\n",
  "PAINKILLING": "of drugs, killing pain [adj]\n",
  "PAINLESS": "without pain [adj PAINLESSLY]\n",
  "PAINLESSLY": "PAINLESS, without pain [adv]\n",
  "PAINLESSNESS": "the state of being painless [n -ES]\n",
  "PAINLESSNESSES": "PAINLESSNESS, the state of being painless [n]\n",
  "PAINS": "PAIN, to cause suffering or distress [v]\n",
  "PAINSTAKER": "one who takes pains [n -S]\n",
  "PAINSTAKERS": "PAINSTAKER, one who takes pains [n]\n",
  "PAINSTAKING": "taking pains [adj PAINSTAKINGLY] / careful diligence [n -S]\n",
  "PAINSTAKINGLY": "PAINSTAKING, taking pains [adv]\n",
  "PAINSTAKINGNESS": "PAINSTAKING, taking pains [n]\n",
  "PAINSTAKINGS": "PAINSTAKING, careful diligence [n]\n",
  "PAINT": "to apply colour with a brush [v -ED, -ING, -S]\n",
  "PAINTABLE": "able to be painted [adj]\n",
  "PAINTBALL": "a type of war game where the ammunition used is paint fired from compressed-air guns [n -S]\n",
  "PAINTBALLING": "a game in which teams of players simulate a military skirmish, shooting each other with paint pellets that explode on impact, marking the players who have been shot [n -S]\n",
  "PAINTBALLINGS": "PAINTBALLING, a game in which teams of players simulate a military skirmish, shooting each other with paint pellets that explode on impact, marking the players who have been shot [n]\n",
  "PAINTBALLS": "PAINTBALL, a type of war game where the ammunition used is paint fired from compressed-air guns [n]\n",
  "PAINTBOX": "a box containing paints [n -ES]\n",
  "PAINTBOXES": "PAINTBOX, a box containing paints [n]\n",
  "PAINTBRUSH": "a brush for applying paint [n -ES]\n",
  "PAINTBRUSHES": "PAINTBRUSH, a brush for applying paint [n]\n",
  "PAINTED": "PAINT, to apply colour with a brush [v]\n",
  "PAINTER": "one who paints [n -S]\n",
  "PAINTERLINESS": "the state of being painterly [n -ES]\n",
  "PAINTERLINESSES": "PAINTERLINESS, the state of being painterly [n]\n",
  "PAINTERLY": "having the qualities of a painter [adj]\n",
  "PAINTERS": "PAINTER, one who paints [n]\n",
  "PAINTIER": "PAINTY, covered with paint [adj]\n",
  "PAINTIEST": "PAINTY, covered with paint [adj]\n",
  "PAINTINESS": "the state of being painty [n -ES]\n",
  "PAINTINESSES": "PAINTINESS, the state of being painty [n]\n",
  "PAINTING": "a painted picture [n -S]\n",
  "PAINTINGS": "PAINTING, a painted picture [n]\n",
  "PAINTPOT": "a pot for holding paint [n -S]\n",
  "PAINTPOTS": "PAINTPOT, a pot for holding paint [n]\n",
  "PAINTRESS": "a female painter [n -ES]\n",
  "PAINTRESSES": "PAINTRESS, a female painter [n]\n",
  "PAINTS": "PAINT, to apply colour with a brush [v]\n",
  "PAINTURE": "the art of painting [n -S]\n",
  "PAINTURES": "PAINTURE, the art of painting [n]\n",
  "PAINTWORK": "painted fixtures in a building; painted surfaces on a vehicle [n -S]\n",
  "PAINTWORKS": "PAINTWORK, painted fixtures in a building; painted surfaces on a vehicle [n]\n",
  "PAINTY": "covered with paint [adj PAINTIER, PAINTIEST]\n",
  "PAIOCK": "(Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCKE, PAJOCK, PAJOCKE [n -S]\n",
  "PAIOCKE": "(Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCK, PAJOCK, PAJOCKE [n -S]\n",
  "PAIOCKES": "PAIOCKE, (Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCK, PAJOCK, PAJOCKE [n]\n",
  "PAIOCKS": "PAIOCK, (Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCKE, PAJOCK, PAJOCKE [n]\n",
  "PAIR": "to arrange in sets of two [v -ED, -ING, -S] / (Scots) poor [adj PAIRER, PAIREST]\n",
  "PAIRE": "(obsolete) an aphetic form of appair, to impair [v PAIRED, PAIRING, PAIRES]\n",
  "PAIRED": "PAIRE, (obsolete) an aphetic form of appair, to impair [v]\n",
  "PAIRER": "PAIR, (Scots) poor [adj]\n",
  "PAIRES": "PAIRE, (obsolete) an aphetic form of appair, to impair [v]\n",
  "PAIREST": "PAIR, (Scots) poor [adj]\n",
  "PAIRIAL": "a pair-royal, a throw of three dice all the same, also PARIAL, PRIAL [n -S]\n",
  "PAIRIALS": "PAIRIAL, a pair-royal, a throw of three dice all the same, also PARIAL, PRIAL [n]\n",
  "PAIRING": "a matching of two opponents in a tournament [n -S]\n",
  "PAIRINGS": "PAIRING, a matching of two opponents in a tournament [n]\n",
  "PAIRS": "PAIR, to arrange in sets of two [v]\n",
  "PAIRWISE": "in pairs [adv]\n",
  "PAIS": "(archaic) the people from whom a jury is drawn [n]\n",
  "PAISA": "(Hindi) an Indian coin, 1/100 of a rupee [n PAISE or PAISAS]\n",
  "PAISAN": "(Spanish) a fellow countryman, also PAESAN, PAESANO, PAISANO [n -S]\n",
  "PAISANA": "(Spanish) a fellow countrywoman [n -S]\n",
  "PAISANAS": "PAISANA, (Spanish) a fellow countrywoman [n]\n",
  "PAISANO": "(Spanish) a fellow countryman, also PAESAN, PAESANO, PAISAN [n -S]\n",
  "PAISANOS": "PAISANO, (Spanish) a fellow countryman, also PAESAN, PAESANO, PAISAN [n]\n",
  "PAISANS": "PAISAN, (Spanish) a fellow countryman, also PAESAN, PAESANO, PAISANO [n]\n",
  "PAISAS": "PAISA, (Hindi) an Indian coin, 1/100 of a rupee [n]\n",
  "PAISE": "PAISA, (Hindi) an Indian coin, 1/100 of a rupee [n]\n",
  "PAISLEY": "a woollen or other fabric with a pattern resembling Paisley pattern [n -S]\n",
  "PAISLEYS": "PAISLEY, a woollen or other fabric with a pattern resembling Paisley pattern [n]\n",
  "PAITRICK": "(Scots) a partridge [n -S]\n",
  "PAITRICKS": "PAITRICK, (Scots) a partridge [n]\n",
  "PAJAMA": "a garment for sleeping or lounging, also PYJAMA [n -S]\n",
  "PAJAMAED": "wearing pajamas [adj]\n",
  "PAJAMAS": "PAJAMA, a garment for sleeping or lounging, also PYJAMA [n]\n",
  "PAJOCK": "(Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCK, PAIOCKE, PAJOCKE [n -S]\n",
  "PAJOCKE": "(Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCK, PAIOCKE, PAJOCK [n -S]\n",
  "PAJOCKES": "PAJOCKE, (Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCK, PAIOCKE, PAJOCK [n]\n",
  "PAJOCKS": "PAJOCK, (Shakespeare) an obscure word conjectured to be a misprint for peacock, also PAIOCK, PAIOCKE, PAJOCKE [n]\n",
  "PAK": "(colloquial) a pack [n PAKS]\n",
  "PAKAHI": "(Maori) acid land unfit for cultivation, also PAKIHI [n -S]\n",
  "PAKAHIS": "PAKAHI, (Maori) acid land unfit for cultivation, also PAKIHI [n]\n",
  "PAKAPOO": "(Chinese) a Chinese version of lotto [n -S]\n",
  "PAKAPOOS": "PAKAPOO, (Chinese) a Chinese version of lotto [n]\n",
  "PAKEHA": "(Maori) a white man; a non-Polynesian citizen [n -S]\n",
  "PAKEHAS": "PAKEHA, (Maori) a white man; a non-Polynesian citizen [n]\n",
  "PAKFONG": "(Chinese) a Chinese alloy of nickel, zinc, and copper, also PACKFONG, PAKTHONG, PAKTONG [n -S]\n",
  "PAKFONGS": "PAKFONG, (Chinese) a Chinese alloy of nickel, zinc, and copper, also PACKFONG, PAKTHONG, PAKTONG [n]\n",
  "PAKIHI": "(Maori) acid land unfit for cultivation, also PAKAHI [n -S]\n",
  "PAKIHIS": "PAKIHI, (Maori) acid land unfit for cultivation, also PAKAHI [n]\n",
  "PAKIRIKIRI": "(Maori) the blue cod [n -S]\n",
  "PAKIRIKIRIS": "PAKIRIKIRI, (Maori) the blue cod [n]\n",
  "PAKKA": "(Hindi) genuine; first-class, also PUCKA, PUKKA, PUKKAH [adj]\n",
  "PAKOKO": "(Maori) a small fish, aka bully [n -S]\n",
  "PAKOKOS": "PAKOKO, (Maori) a small fish, aka bully [n]\n",
  "PAKORA": "(Hindi) an Indian dish of chopped vegetables fried in batter [n -S]\n",
  "PAKORAS": "PAKORA, (Hindi) an Indian dish of chopped vegetables fried in batter [n]\n",
  "PAKS": "PAK, (colloquial) a pack [n]\n",
  "PAKTHONG": "(Chinese) a Chinese alloy of nickel, zinc, and copper, resembling German silver, also PACKFONG, PAKFONG, PAKTONG [n -S]\n",
  "PAKTHONGS": "PAKTHONG, (Chinese) a Chinese alloy of nickel, zinc, and copper, resembling German silver, also PACKFONG, PAKFONG, PAKTONG [n]\n",
  "PAKTONG": "(Chinese) a Chinese alloy of nickel, zinc, and copper, also PACKFONG, PAKFONG, PAKTHONG [n -S]\n",
  "PAKTONGS": "PAKTONG, (Chinese) a Chinese alloy of nickel, zinc, and copper, also PACKFONG, PAKFONG, PAKTHONG [n]\n",
  "PAL": "to associate as friends [v PALLED, PALLING, PALS]\n",
  "PALABRA": "(Spanish) a word, talk [n -S]\n",
  "PALABRAS": "PALABRA, (Spanish) a word, talk [n]\n",
  "PALACE": "a royal residence [n -S]\n",
  "PALACED": "residing in a palace [adj]\n",
  "PALACES": "PALACE, a royal residence [n]\n",
  "PALACINKE": "a thin crjpe-like variety of pancake common in Central and Eastern Europe [n -S]\n",
  "PALACINKES": "PALACINKE, a thin crjpe-like variety of pancake common in Central and Eastern Europe [n]\n",
  "PALADIN": "a knightly champion [n -S]\n",
  "PALADINS": "PALADIN, a knightly champion [n]\n",
  "PALAEANTHROPIC": "of or relating to the earliest types of man, also PALAEOANTHROPIC [adj]\n",
  "PALAEBIOLOGIES": "PALAEBIOLOGY, the study of fossil plants and animals, also PALAEOBIOLOGY, PALEOBIOLOGY [n]\n",
  "PALAEBIOLOGIST": "a student of palaebiology [n -S]\n",
  "PALAEBIOLOGISTS": "PALAEBIOLOGIST, a student of palaebiology [n]\n",
  "PALAEBIOLOGY": "the study of fossil plants and animals, also PALAEOBIOLOGY, PALEOBIOLOGY [n PALAEBIOLOGIES]\n",
  "PALAEETHNOLOGY": "the study of prehistoric man [n]\n",
  "PALAEOANTHROPIC": "of or relating to the earliest types of man, also PALAEANTHROPIC [adj]\n",
  "PALAEOBIOLOGIC": "related to palaeobiology [adj]\n",
  "PALAEOBIOLOGIES": "PALAEOBIOLOGY, the study of fossil plants and animals, also PALAEBIOLOGY, PALEOBIOLOGY [n]\n",
  "PALAEOBIOLOGIST": "a student of palaeobiology [n]\n",
  "PALAEOBIOLOGY": "the study of fossil plants and animals, also PALAEBIOLOGY, PALEOBIOLOGY [n PALAEOBIOLOGIES]\n",
  "PALAEOBOTANIC": "relating to palaeobotany, the study of fossil plants, also PALAEOBOTANICAL [adj]\n",
  "PALAEOBOTANICAL": "relating to palaeobotany, the study of fossil plants, also PALAEOBOTANIC [adj]\n",
  "PALAEOBOTANIES": "PALAEOBOTANY, the study of fossil plants, also PALEOBOTANY [n]\n",
  "PALAEOBOTANIST": "one who studies palaeobotany [n -S]\n",
  "PALAEOBOTANISTS": "PALAEOBOTANIST, one who studies palaeobotany [n]\n",
  "PALAEOBOTANY": "the study of fossil plants, also PALEOBOTANY [n PALAEOBOTANIES]\n",
  "PALAEOCLIMATE": "the climate at any stage in the geological development of the earth [n -S]\n",
  "PALAEOCLIMATES": "PALAEOCLIMATE, the climate at any stage in the geological development of the earth [n]\n",
  "PALAEOCLIMATIC": "of or relating to a palaeoclimate [adj]\n",
  "PALAEOCRYSTIC": "consisting of ancient ice [adj]\n",
  "PALAEOCURRENT": "a current that existed at a particular stage in the geological development of the earth, as evinced by sedimentary rock formations [n -S]\n",
  "PALAEOCURRENTS": "PALAEOCURRENT, a current that existed at a particular stage in the geological development of the earth, as evinced by sedimentary rock formations [n]\n",
  "PALAEOECOLOGIC": "relating to palaeoecology [adj]\n",
  "PALAEOECOLOGIES": "PALAEOECOLOGY, the study of early ecology [n]\n",
  "PALAEOECOLOGIST": "a specialist in palaeoecology [n]\n",
  "PALAEOECOLOGY": "the study of early ecology [n PALAEOECOLOGIES]\n",
  "PALAEOETHNOLOGY": "the science of early man [n]\n",
  "PALAEOGAEA": "the Old World as a biological region [n -S]\n",
  "PALAEOGAEAS": "PALAEOGAEA, the Old World as a biological region [n]\n",
  "PALAEOGEOGRAPHY": "the study of the geography of geological periods [n]\n",
  "PALAEOGRAPHER": "a student of palaeography, also PALAEOGRAPHIST [n -S]\n",
  "PALAEOGRAPHERS": "PALAEOGRAPHER, a student of palaeography, also PALAEOGRAPHIST [n]\n",
  "PALAEOGRAPHIC": "related to palaeography, the study of ancient writings, also PALEOGRAPHICAL [adj]\n",
  "PALAEOGRAPHICAL": "related to palaeography, the study of ancient writings, also PALEOGRAPHIC [adj]\n",
  "PALAEOGRAPHIES": "PALAEOGRAPHY, the study of ancient writings, also PALEOGRAPHY [n]\n",
  "PALAEOGRAPHIST": "a student of palaeography, also PALAEOGRAPHER [n -S]\n",
  "PALAEOGRAPHISTS": "PALAEOGRAPHIST, a student of palaeography, also PALAEOGRAPHER [n]\n",
  "PALAEOGRAPHY": "the study of ancient writings, also PALEOGRAPHY [n PALAEOGRAPHIES]\n",
  "PALAEOLIMNOLOGY": "the study of ancient lakes [n]\n",
  "PALAEOLITH": "a Stone Age artefact, also PALEOLITH [n -S]\n",
  "PALAEOLITHIC": "of the earlier Stone Age, also PALEOLITHIC [adj]\n",
  "PALAEOLITHS": "PALAEOLITH, a Stone Age artefact, also PALEOLITH [n]\n",
  "PALAEOLOGIES": "PALAEOLOGY, the study of prehistory, also PALEOLOGY [n]\n",
  "PALAEOLOGY": "the study of prehistory, also PALEOLOGY [n PALAEOLOGIES]\n",
  "PALAEOMAGNETIC": "relating to palaeomagnetism [adj]\n",
  "PALAEOMAGNETISM": "a study of the magnetism of ancient rocks and fossils, and of bricks, pottery, etc. made in past ages [n]\n",
  "PALAEOMAGNETIST": "a student of or expert in palaeomagnetism [n]\n",
  "PALAEONTOGRAPHY": "descriptive palaeontology, the description of fossil remains [n]\n",
  "PALAEONTOLOGIES": "PALAEONTOLOGY, the study of fossils, also PALEONTOLOGY [n]\n",
  "PALAEONTOLOGIST": "a student of palaeontology, also PALEONTOLOGIST [n]\n",
  "PALAEONTOLOGY": "the study of fossils, also PALEONTOLOGY [n PALAEONTOLOGIES]\n",
  "PALAEOPATHOLOGY": "the pathological study of the ancient remains of animals and humans [n]\n",
  "PALAEOPEDOLOGY": "the study of early soils [n]\n",
  "PALAEOPHYTOLOGY": "the study of fossil plants, palaeobotany [n]\n",
  "PALAEOSOL": "an ancient soil horizon, also PALEOSOL [n -S]\n",
  "PALAEOSOLS": "PALAEOSOL, an ancient soil horizon, also PALEOSOL [n]\n",
  "PALAEOTYPE": "a nineteenth century phonetic adaptation of ordinary alphabetical type [n -S]\n",
  "PALAEOTYPES": "PALAEOTYPE, a nineteenth century phonetic adaptation of ordinary alphabetical type [n]\n",
  "PALAEOTYPIC": "of or like a palaeotype, a nineteenth century phonetic adaptation of ordinary alphabetical type [adj]\n",
  "PALAEOZOOLOGIES": "PALAEOZOOLOGY, the study of fossil animals, also PALEOZOOLOGY [n]\n",
  "PALAEOZOOLOGIST": "a student of palaeozoology [n]\n",
  "PALAEOZOOLOGY": "the study of fossil animals, also PALEOZOOLOGY [n PALAEOZOOLOGIES]\n",
  "PALAESTRA": "(historical) a wrestling school; hence, a gymnasium, or place for athletic exercise in general, also PALESTRA [n PALAESTRAE or PALAESTRAS]\n",
  "PALAESTRAE": "PALAESTRA, (historical) a wrestling school; hence, a gymnasium, or place for athletic exercise in general, also PALESTRA [n]\n",
  "PALAESTRAL": "related to a palaestra, a wrestling school [adj]\n",
  "PALAESTRAS": "PALAESTRA, (historical) a wrestling school; hence, a gymnasium, or place for athletic exercise in general, also PALESTRA [n]\n",
  "PALAESTRIC": "relating to a palaestra, a wrestling school, also PALAESTRICAL [adj]\n",
  "PALAESTRICAL": "relating to a palaestra, a wrestling school, also PALAESTRIC [adj]\n",
  "PALAFITTE": "a prehistoric hut or settlement built on stakes driven into the bed of a lake, esp. in Switzerland or northern Italy; a lake village [n -S]\n",
  "PALAFITTES": "PALAFITTE, a prehistoric hut or settlement built on stakes driven into the bed of a lake, esp. in Switzerland or northern Italy; a lake village [n]\n",
  "PALAGI": "(Samoan) a Samoan word for a person from outside the Pacific islands, esp. a European [n -S]\n",
  "PALAGIS": "PALAGI, (Samoan) a Samoan word for a person from outside the Pacific islands, esp. a European [n]\n",
  "PALAGONITE": "an altered vitreous basic lava [n -S]\n",
  "PALAGONITES": "PALAGONITE, an altered vitreous basic lava [n]\n",
  "PALAIS": "(French) a palace [n PALAIS]\n",
  "PALAMA": "(Latin) the webbing of a waterbird's foot [n PALAMAE]\n",
  "PALAMAE": "PALAMA, (Latin) the webbing of a waterbird's foot [n]\n",
  "PALAMATE": "webbed like a waterbird's foot [adj]\n",
  "PALAMINO": "(Spanish) a horse of largely Arab blood, pale tan, yellow, or gold, with a white or silver mane and tail, also PALOMINO [n -S]\n",
  "PALAMINOS": "PALAMINO, (Spanish) a horse of largely Arab blood, pale tan, yellow, or gold, with a white or silver mane and tail, also PALOMINO [n]\n",
  "PALAMPORE": "a flowered chintz bedcover common in Asia, also PALEMPORE [n -S]\n",
  "PALAMPORES": "PALAMPORE, a flowered chintz bedcover common in Asia, also PALEMPORE [n]\n",
  "PALANKEEN": "(Malay) a light litter for one passenger, also PALANQUIN [n -S]\n",
  "PALANKEENS": "PALANKEEN, (Malay) a light litter for one passenger, also PALANQUIN [n]\n",
  "PALANQUIN": "(Malay) a light litter for one passenger, also PALANKEEN [n -S]\n",
  "PALANQUINS": "PALANQUIN, (Malay) a light litter for one passenger, also PALANKEEN [n]\n",
  "PALAPA": "an open-sided dwelling with a thatched roof made of palm leaves [n -S]\n",
  "PALAPAS": "PALAPA, an open-sided dwelling with a thatched roof made of palm leaves [n]\n",
  "PALAS": "(Hindi) a leguminous tree of eastern India and Myanmar, the dhak trees [n -ES]\n",
  "PALASES": "PALAS, (Hindi) a leguminous tree of eastern India and Myanmar, the dhak trees [n]\n",
  "PALATABILITIES": "PALATABILITY, the state of being palatable [n]\n",
  "PALATABILITY": "the state of being palatable [n PALATABILITIES]\n",
  "PALATABLE": "pleasant to taste [adj PALATABLY]\n",
  "PALATABLENESS": "the state of being palatable [n -ES]\n",
  "PALATABLENESSES": "PALATABLENESS, the state of being palatable [n]\n",
  "PALATABLY": "PALATABLE, pleasant to taste [adv]\n",
  "PALATAL": "of or pertaining to the palate [adj PALATALLY] / a sound made with the palate [n -S]\n",
  "PALATALISATION": "the process of palatalising, also PALATALIZATION [n -S]\n",
  "PALATALISATIONS": "PALATALISATION, the process of palatalising, also PALATALIZATION [n]\n",
  "PALATALISE": "to make (a sound) palatal, also PALATALIZE [v PALATALISED, PALATALISING, PALATALISES]\n",
  "PALATALISED": "PALATALISE, to make (a sound) palatal, also PALATALIZE [v]\n",
  "PALATALISES": "PALATALISE, to make (a sound) palatal, also PALATALIZE [v]\n",
  "PALATALISING": "PALATALISE, to make (a sound) palatal, also PALATALIZE [v]\n",
  "PALATALIZATION": "the process of palatalizing, also PALATALISATION [n -S]\n",
  "PALATALIZATIONS": "PALATALIZATION, the process of palatalizing, also PALATALISATION [n]\n",
  "PALATALIZE": "to make (a sound) palatal, also PALATALISE [v PALATALIZED, PALATALIZING, PALATALIZES]\n",
  "PALATALIZED": "PALATALIZE, to make (a sound) palatal, also PALATALISE [v]\n",
  "PALATALIZES": "PALATALIZE, to make (a sound) palatal, also PALATALISE [v]\n",
  "PALATALIZING": "PALATALIZE, to make (a sound) palatal, also PALATALISE [v]\n",
  "PALATALLY": "PALATAL, of or pertaining to the palate [adv]\n",
  "PALATALS": "PALATAL, a sound made with the palate [n]\n",
  "PALATE": "the roof of the mouth [n -S] / (Shakespeare) to relish [v PALATED, PALATING, PALATES]\n",
  "PALATED": "PALATE, (Shakespeare) to relish [v]\n",
  "PALATES": "PALATE, (Shakespeare) to relish [v]\n",
  "PALATIAL": "of or like a palace [adj PALATIALLY]\n",
  "PALATIALLY": "PALATIAL, of or like a palace [adv]\n",
  "PALATIALNESS": "the state of being palatial [n -ES]\n",
  "PALATIALNESSES": "PALATIALNESS, the state of being palatial [n]\n",
  "PALATINATE": "the province or seigniory of a palatine [n -S]\n",
  "PALATINATES": "PALATINATE, the province or seigniory of a palatine [n]\n",
  "PALATINE": "a high officer having royal authority over a region [n -S]\n",
  "PALATINES": "PALATINE, a high officer having royal authority over a region [n]\n",
  "PALATING": "PALATE, (Shakespeare) to relish [v]\n",
  "PALAVER": "to talk profusely or idly [v -ED, -ING, -S]\n",
  "PALAVERED": "PALAVER, to talk profusely or idly [v]\n",
  "PALAVERER": "one who palavers [n -S]\n",
  "PALAVERERS": "PALAVERER, one who palavers [n]\n",
  "PALAVERING": "PALAVER, to talk profusely or idly [v]\n",
  "PALAVERS": "PALAVER, to talk profusely or idly [v]\n",
  "PALAY": "(Tamil) the ivory tree, a small South Indian tree of the dogbane family [n -S]\n",
  "PALAYS": "PALAY, (Tamil) the ivory tree, a small South Indian tree of the dogbane family [n]\n",
  "PALAZZI": "PALAZZO, (Italian) an Italian palace, often one converted into a museum [n]\n",
  "PALAZZO": "(Italian) an Italian palace, often one converted into a museum [n PALAZZI or PALAZZOS]\n",
  "PALAZZOS": "PALAZZO, (Italian) an Italian palace, often one converted into a museum [n]\n",
  "PALE": "lacking colour [adj PALER, PALEST, PALELY] / to lose colour [v PALED, PALING, PALES]\n",
  "PALEA": "(Latin) the membranous inner bract of a grass flower, also PALET [n PALEAE]\n",
  "PALEACEOUS": "chaffy; like or resembling chaff [adj]\n",
  "PALEAE": "PALEA, (Latin) the membranous inner bract of a grass flower, also PALET [n]\n",
  "PALEAL": "relating to the palea, the membranous inner bract of a grass flower [adj]\n",
  "PALEATE": "like a palea [adj]\n",
  "PALEBUCK": "a kind of antelope, aka oribi [n -S]\n",
  "PALEBUCKS": "PALEBUCK, a kind of antelope, aka oribi [n]\n",
  "PALED": "PALE, to lose colour [v]\n",
  "PALEFACE": "a white person [n -S]\n",
  "PALEFACES": "PALEFACE, a white person [n]\n",
  "PALELY": "PALE, lacking colour [adv]\n",
  "PALEMPORE": "a flowered chintz bedcover common in Asia, also PALAMPORE [n -S]\n",
  "PALEMPORES": "PALEMPORE, a flowered chintz bedcover common in Asia, also PALAMPORE [n]\n",
  "PALENESS": "the quality of being pale [n -ES]\n",
  "PALENESSES": "PALENESS, the quality of being pale [n]\n",
  "PALEOBIOLOGIC": "relating to paleobiology, also PALEOBIOLOGICAL [adj]\n",
  "PALEOBIOLOGICAL": "relating to paleobiology, also PALEOBIOLOGIC [adj]\n",
  "PALEOBIOLOGIES": "PALEOBIOLOGY, a branch of paleontology concerned with the biology of fossil organisms, also PALAEBIOLOGY, PALAEOBIOLOGY [n]\n",
  "PALEOBIOLOGIST": "one who studies paleobiology [n -S]\n",
  "PALEOBIOLOGISTS": "PALEOBIOLOGIST, one who studies paleobiology [n]\n",
  "PALEOBIOLOGY": "a branch of paleontology concerned with the biology of fossil organisms, also PALAEBIOLOGY, PALAEOBIOLOGY [n PALEOBIOLOGIES]\n",
  "PALEOBOTANIC": "relating to paleobotany, also PALEOBOTANICAL [adj]\n",
  "PALEOBOTANICAL": "relating to paleobotany, also PALEOBOTANIC [adj]\n",
  "PALEOBOTANIES": "PALEOBOTANY, the study of fossil plants, also PALAEOBOTANY [n]\n",
  "PALEOBOTANIST": "a student of paleobotany [n -S]\n",
  "PALEOBOTANISTS": "PALEOBOTANIST, a student of paleobotany [n]\n",
  "PALEOBOTANY": "the study of fossil plants, also PALAEOBOTANY [n PALEOBOTANIES]\n",
  "PALEOCENE": "belonging to a certain geological time period, also PALEOGENE [adj]\n",
  "PALEOCON": "an extremely right-wing conservative [n -S]\n",
  "PALEOCONS": "PALEOCON, an extremely right-wing conservative [n]\n",
  "PALEOECOLOGIC": "relating to paleoecology, also PALEOECOLOGICAL [adj]\n",
  "PALEOECOLOGICAL": "relating to paleoecology, also PALEOECOLOGIC [adj]\n",
  "PALEOECOLOGIES": "PALEOECOLOGY, a branch of ecology that is concerned with the characteristics of ancient environments and with their relationships to ancient plants and animals [n]\n",
  "PALEOECOLOGIST": "one who studies paleoecology [n -S]\n",
  "PALEOECOLOGISTS": "PALEOECOLOGIST, one who studies paleoecology [n]\n",
  "PALEOECOLOGY": "a branch of ecology that is concerned with the characteristics of ancient environments and with their relationships to ancient plants and animals [n PALEOECOLOGIES]\n",
  "PALEOGENE": "belonging to a certain geological time period, also PALEOCENE [adj]\n",
  "PALEOGEOGRAPHIC": "relating to paleogeography [adj]\n",
  "PALEOGEOGRAPHY": "the geography of ancient times or of a particular past geological epoch [n]\n",
  "PALEOGRAPHER": "a student of paleography [n -S]\n",
  "PALEOGRAPHERS": "PALEOGRAPHER, a student of paleography [n]\n",
  "PALEOGRAPHIC": "relating to writings of former times, also PALAEOGRAPHICAL [adj]\n",
  "PALEOGRAPHICAL": "related to paleography, the study of ancient writings, also PALAEOGRAPHIC [adj]\n",
  "PALEOGRAPHIES": "PALEOGRAPHY, the study of ancient writings, also PALAEOGRAPHY [n]\n",
  "PALEOGRAPHY": "the study of ancient writings, also PALAEOGRAPHY [n PALEOGRAPHIES]\n",
  "PALEOLITH": "a Stone Age artifact, also PALAEOLITH [n -S]\n",
  "PALEOLITHIC": "of or relating to the earliest period of the Stone Age characterized by rough or chipped stone implements, also PALAEOLITHIC [adj]\n",
  "PALEOLITHS": "PALEOLITH, a Stone Age artifact, also PALAEOLITH [n]\n",
  "PALEOLOGIES": "PALEOLOGY, the study of prehistory, also PALAEOLOGY [n]\n",
  "PALEOLOGY": "the study of prehistory, also PALAEOLOGY [n PALEOLOGIES]\n",
  "PALEOMAGNETIC": "relating to paleomagnetism [adj]\n",
  "PALEOMAGNETISM": "the study of the Earth's past magnetism as it is recorded in the rocks [n -S]\n",
  "PALEOMAGNETISMS": "PALEOMAGNETISM, the study of the Earth's past magnetism as it is recorded in the rocks [n]\n",
  "PALEOMAGNETIST": "a student of paleomagnetism [n -S]\n",
  "PALEOMAGNETISTS": "PALEOMAGNETIST, a student of paleomagnetism [n]\n",
  "PALEONTOLOGIC": "relating to paleontology, also PALEONTOLOGICAL [adj]\n",
  "PALEONTOLOGICAL": "relating to paleontology, also PALEONTOLOGIC [adj]\n",
  "PALEONTOLOGIES": "PALEONTOLOGY, the study of fossils, also PALAEONTOLOGY [n]\n",
  "PALEONTOLOGIST": "one who studies paleontology, also PALAEONTOLOGIST [n -S]\n",
  "PALEONTOLOGISTS": "PALEONTOLOGIST, one who studies paleontology, also PALAEONTOLOGIST [n]\n",
  "PALEONTOLOGY": "the study of fossils, also PALAEONTOLOGY [n PALEONTOLOGIES]\n",
  "PALEOPATHOLOGY": "a branch of pathology concerned with ancient diseases as evidenced esp. in fossil or other remains [n]\n",
  "PALEOSOL": "a buried soil horizon of the geologic past, also PALAEOSOL [n PALEOSOLS]\n",
  "PALEOSOLS": "PALEOSOL, a buried soil horizon of the geologic past, also PALAEOSOL [n]\n",
  "PALEOZOIC": "belonging to a certain geological time period [adj]\n",
  "PALEOZOOLOGICAL": "relating to paleozoology [adj]\n",
  "PALEOZOOLOGIES": "PALEOZOOLOGY, the study of fossil animals, also PALAEOZOOLOGY [n]\n",
  "PALEOZOOLOGIST": "one who studies paleozoology [n -S]\n",
  "PALEOZOOLOGISTS": "PALEOZOOLOGIST, one who studies paleozoology [n]\n",
  "PALEOZOOLOGY": "the study of fossil animals, also PALAEOZOOLOGY [n PALEOZOOLOGIES]\n",
  "PALER": "PALE, lacking colour [adj]\n",
  "PALES": "PALE, to lose colour [v]\n",
  "PALEST": "PALE, lacking colour [adj]\n",
  "PALESTRA": "(Latin) a school for athletics in ancient Greece [n PALESTRAS or PALESTRAE]\n",
  "PALESTRAE": "PALESTRA, (Latin) a school for athletics in ancient Greece [n]\n",
  "PALESTRAL": "relating to a palestra, a wrestling school [adj]\n",
  "PALESTRAS": "PALESTRA, (Latin) a school for athletics in ancient Greece [n]\n",
  "PALET": "the membranous inner bract of a grass flower, also PALEA [n -S]\n",
  "PALETOT": "(French) a loose overcoat [n -S]\n",
  "PALETOTS": "PALETOT, (French) a loose overcoat [n]\n",
  "PALETS": "PALET, the membranous inner bract of a grass flower, also PALEA [n]\n",
  "PALETTE": "(French) a board on which an artist mixes colours [n -S]\n",
  "PALETTES": "PALETTE, (French) a board on which an artist mixes colours [n]\n",
  "PALEWAYS": "in heraldry, vertically, like a pale, also PALEWISE [adv]\n",
  "PALEWISE": "in heraldry, vertically, like a pale, also PALEWAYS [adv]\n",
  "PALFRENIER": "a groom [n -S]\n",
  "PALFRENIERS": "PALFRENIER, a groom [n]\n",
  "PALFREY": "a saddle horse, esp. a light easy-gaited horse suitable for a woman [n -S]\n",
  "PALFREYED": "riding on a palfrey, a saddle horse [adj]\n",
  "PALFREYS": "PALFREY, a saddle horse, esp. a light easy-gaited horse suitable for a woman [n]\n",
  "PALI": "(Hawaiian) a cliff in Hawaii [n -S]\n",
  "PALIER": "PALY, somewhat pale [adj]\n",
  "PALIEST": "PALY, somewhat pale [adj]\n",
  "PALIFICATION": "the act of strengthening with stakes [n -S]\n",
  "PALIFICATIONS": "PALIFICATION, the act of strengthening with stakes [n]\n",
  "PALIFORM": "resembling a stake [adj]\n",
  "PALIKAR": "(Modern Greek) a Greek soldier [n -S]\n",
  "PALIKARS": "PALIKAR, (Modern Greek) a Greek soldier [n]\n",
  "PALILALIA": "a speech disorder characterized by rapid repetition of words [n -S]\n",
  "PALILALIAS": "PALILALIA, a speech disorder characterized by rapid repetition of words [n]\n",
  "PALILLOGIES": "PALILLOGY, the repetition of a word or word or phrase [n]\n",
  "PALILLOGY": "the repetition of a word or word or phrase [n PALILLOGIES]\n",
  "PALIMONIES": "PALIMONY, alimony paid after separation by one person [n]\n",
  "PALIMONY": "alimony paid after separation by one person [n PALIMONIES]\n",
  "PALIMPSEST": "writing material (as a parchment or tablet) used one or more times [n -S]\n",
  "PALIMPSESTS": "PALIMPSEST, writing material (as a parchment or tablet) used one or more times [n]\n",
  "PALINDROME": "a word or statement that communicates the same message when the letters of which it is composed are read in reverse order [n -S]\n",
  "PALINDROMES": "PALINDROME, a word or statement that communicates the same message when the letters of which it is composed are read in reverse order [n]\n",
  "PALINDROMIC": "of or like a palindrome, also PALINDROMICAL [adj]\n",
  "PALINDROMICAL": "of or like a palindrome, also PALINDROMIC [adj]\n",
  "PALINDROMIST": "one who composes palindromes [n -S]\n",
  "PALINDROMISTS": "PALINDROMIST, one who composes palindromes [n]\n",
  "PALING": "a picket fence [n -S]\n",
  "PALINGENESES": "PALINGENESIS, the remelting of rock followed by solidification into a different form, also PALINGENESIA, PALINGENESY [n]\n",
  "PALINGENESIA": "the remelting of rock followed by solidification into a different form, also PALINGENESIS, PALINGENESY [n -S]\n",
  "PALINGENESIAS": "PALINGENESIA, the remelting of rock followed by solidification into a different form, also PALINGENESIS, PALINGENESY [n]\n",
  "PALINGENESIES": "PALINGENESY, the remelting of rock followed by solidification into a different form, also PALINGENESIA, PALINGENESIS [n]\n",
  "PALINGENESIS": "the remelting of rock followed by solidification into a different form, also PALINGENESIA, PALINGENESY [n PALINGENESES]\n",
  "PALINGENESIST": "a student of palingenesis [n -S]\n",
  "PALINGENESISTS": "PALINGENESIST, a student of palingenesis [n]\n",
  "PALINGENESY": "the remelting of rock followed by solidification into a different form, also PALINGENESIA, PALINGENESIS [n PALINGENESIES]\n",
  "PALINGENETIC": "relating to palingenesis, the remelting of rock followed by solidification into a different form, also PALINGENETICAL [adj]\n",
  "PALINGENETICAL": "relating to palingenesis, the remelting of rock followed by solidification into a different form, also PALINGENETIC [adj]\n",
  "PALINGS": "PALING, a picket fence [n]\n",
  "PALINKA": "a type of apricot brandy from East Europe [n -S]\n",
  "PALINKAS": "PALINKA, a type of apricot brandy from East Europe [n]\n",
  "PALINODE": "a poem which retracts an earlier poem, also PALINODY [n -S]\n",
  "PALINODES": "PALINODE, a poem which retracts an earlier poem, also PALINODY [n]\n",
  "PALINODIES": "PALINODY, a poem which retracts an earlier poem, also PALINODE [n]\n",
  "PALINODY": "a poem which retracts an earlier poem, also PALINODE [n PALINODIES]\n",
  "PALINOPIA": "a visual disorder in which the patient perceives a prolonged afterimage, also PALINOPSIA [n -S]\n",
  "PALINOPIAS": "PALINOPIA, a visual disorder in which the patient perceives a prolonged afterimage, also PALINOPSIA [n]\n",
  "PALINOPSIA": "a visual disorder in which the patient perceives a prolonged afterimage, also PALINOPIA [n -S]\n",
  "PALINOPSIAS": "PALINOPSIA, a visual disorder in which the patient perceives a prolonged afterimage, also PALINOPIA [n]\n",
  "PALIS": "PALI, (Hawaiian) a cliff in Hawaii [n]\n",
  "PALISADE": "to fortify with a fence of stakes, also PALISADO [v PALISADED, PALISADING, PALISADES]\n",
  "PALISADED": "PALISADE, to fortify with a fence of stakes, also PALISADO [v]\n",
  "PALISADES": "PALISADE, to fortify with a fence of stakes, also PALISADO [v]\n",
  "PALISADING": "PALISADE, to fortify with a fence of stakes, also PALISADO [v]\n",
  "PALISADO": "to fortify with a fence of stakes, also PALISADE [v -ED, -ING, -ES]\n",
  "PALISADOED": "PALISADO, to fortify with a fence of stakes, also PALISADE [v]\n",
  "PALISADOES": "PALISADO, to fortify with a fence of stakes, also PALISADE [v]\n",
  "PALISADOING": "PALISADO, to fortify with a fence of stakes, also PALISADE [v]\n",
  "PALISANDER": "(French) a jacaranda tree or other rosewood [n -S]\n",
  "PALISANDERS": "PALISANDER, (French) a jacaranda tree or other rosewood [n]\n",
  "PALISH": "somewhat pale [adj]\n",
  "PALKEE": "(Hindi) a palanquin, also PALKI [n -S]\n",
  "PALKEES": "PALKEE, (Hindi) a palanquin, also PALKI [n]\n",
  "PALKI": "(Hindi) a palanquin, also PALKEE [n -S]\n",
  "PALKIS": "PALKI, (Hindi) a palanquin, also PALKEE [n]\n",
  "PALL": "to grow wearisome [v -ED, -ING, -S]\n",
  "PALLA": "(Latin) an oblong rectangular piece of cloth, worn by Roman ladies, and fastened with brooches [n PALLAE]\n",
  "PALLADIA": "PALLADIUM, a metallic element resembling platinum [n]\n",
  "PALLADIC": "of or containing palladium in the trivalent or tetravalent state [adj]\n",
  "PALLADIOUS": "containing palladium [adj]\n",
  "PALLADIUM": "a metallic element resembling platinum [n -S] / a safeguard [n PALLADIA]\n",
  "PALLADIUMS": "PALLADIUM, a metallic element resembling platinum [n]\n",
  "PALLADOUS": "containing palladium, a metallic element resembling platinum [adj]\n",
  "PALLAE": "PALLA, (Latin) an oblong rectangular piece of cloth, worn by Roman ladies, and fastened with brooches [n]\n",
  "PALLAH": "(Setswana) a large South African antelope with lyrated horns [n -S]\n",
  "PALLAHS": "PALLAH, (Setswana) a large South African antelope with lyrated horns [n]\n",
  "PALLASITE": "any of a class of stony-iron meteorites composed largely of olivine crystals enclosed in a network of nickel-iron [n -S]\n",
  "PALLASITES": "PALLASITE, any of a class of stony-iron meteorites composed largely of olivine crystals enclosed in a network of nickel-iron [n]\n",
  "PALLBEARER": "a person who helps to carry the coffin at a funeral [n -S]\n",
  "PALLBEARERS": "PALLBEARER, a person who helps to carry the coffin at a funeral [n]\n",
  "PALLED": "PALL, to grow wearisome [v]\n",
  "PALLESCENCE": "a becoming pale [n -S]\n",
  "PALLESCENCES": "PALLESCENCE, a becoming pale [n]\n",
  "PALLESCENT": "turning pale [adj]\n",
  "PALLET": "a bed or mattress or straw [n -S] / to load onto a pallet [v -ED, -ING, -S]\n",
  "PALLETED": "PALLET, to load onto a pallet [v]\n",
  "PALLETING": "PALLET, to load onto a pallet [v]\n",
  "PALLETISATION": "the process of palletising, also PALLETIZATION [n -S]\n",
  "PALLETISATIONS": "PALLETISATION, the process of palletising, also PALLETIZATION [n]\n",
  "PALLETISE": "to use pallets for moving goods, also PALLETIZE [v PALLETISED, PALLETISING, PALLETISES]\n",
  "PALLETISED": "PALLETISE, to use pallets for moving goods, also PALLETIZE [v]\n",
  "PALLETISER": "one who palletises, also PALLETIZER [n -S]\n",
  "PALLETISERS": "PALLETISER, one who palletises, also PALLETIZER [n]\n",
  "PALLETISES": "PALLETISE, to use pallets for moving goods, also PALLETIZE [v]\n",
  "PALLETISING": "PALLETISE, to use pallets for moving goods, also PALLETIZE [v]\n",
  "PALLETIZATION": "the act of palletizing, also PALLETISATION [n -S]\n",
  "PALLETIZATIONS": "PALLETIZATION, the act of palletizing, also PALLETISATION [n]\n",
  "PALLETIZE": "to use pallets for moving goods, also PALLETISE [v PALLETIZED, PALLETIZING, PALLETIZES]\n",
  "PALLETIZED": "PALLETIZE, to use pallets for moving goods, also PALLETISE [v]\n",
  "PALLETIZER": "one who palletizes, also PALLETISER [n -S]\n",
  "PALLETIZERS": "PALLETIZER, one who palletizes, also PALLETISER [n]\n",
  "PALLETIZES": "PALLETIZE, to use pallets for moving goods, also PALLETISE [v]\n",
  "PALLETIZING": "PALLETIZE, to use pallets for moving goods, also PALLETISE [v]\n",
  "PALLETS": "PALLET, to load onto a pallet [v]\n",
  "PALLETTE": "a piece of armour protecting the armpit [n -S]\n",
  "PALLETTES": "PALLETTE, a piece of armour protecting the armpit [n]\n",
  "PALLIA": "PALLIUM, (Latin) a cloak worn in ancient Rome [n]\n",
  "PALLIAL": "of or pertaining to the pallium or mantle of a mollusc [adj]\n",
  "PALLIAMENT": "(Shakespeare) a Roman consular candidate's robe [n -S]\n",
  "PALLIAMENTS": "PALLIAMENT, (Shakespeare) a Roman consular candidate's robe [n]\n",
  "PALLIARD": "(obsolete) a professional beggar; a vagabond [n -S]\n",
  "PALLIARDS": "PALLIARD, (obsolete) a professional beggar; a vagabond [n]\n",
  "PALLIASSE": "(French) a hard straw mattress, also PAILLASSE [n -S]\n",
  "PALLIASSES": "PALLIASSE, (French) a hard straw mattress, also PAILLASSE [n]\n",
  "PALLIATE": "to cloak or disguise [v PALLIATED, PALLIATING, PALLIATES]\n",
  "PALLIATED": "PALLIATE, to cloak or disguise [v]\n",
  "PALLIATES": "PALLIATE, to cloak or disguise [v]\n",
  "PALLIATING": "PALLIATE, to cloak or disguise [v]\n",
  "PALLIATION": "the act of palliating [n -S]\n",
  "PALLIATIONS": "PALLIATION, the act of palliating [n]\n",
  "PALLIATIVE": "serving to palliate [adj PALLIATIVELY] / something that palliates [n -S]\n",
  "PALLIATIVELY": "PALLIATIVE, serving to palliate [adv]\n",
  "PALLIATIVES": "PALLIATIVE, something that palliates [n]\n",
  "PALLIATOR": "one who palliates [n -S]\n",
  "PALLIATORS": "PALLIATOR, one who palliates [n]\n",
  "PALLIATORY": "palliative; extenuating [adj]\n",
  "PALLID": "pale, wan [adj PALLIDER, PALLIDEST, PALLIDLY]\n",
  "PALLIDER": "PALLID, pale, wan [adj]\n",
  "PALLIDEST": "PALLID, pale, wan [adj]\n",
  "PALLIDITIES": "PALLIDITY, pallidness; paleness [n]\n",
  "PALLIDITY": "pallidness; paleness [n PALLIDITIES]\n",
  "PALLIDLY": "PALLID, pale, wan [adv]\n",
  "PALLIDNESS": "the state of being pallid [n -ES]\n",
  "PALLIDNESSES": "PALLIDNESS, the state of being pallid [n]\n",
  "PALLIED": "PALLY, as in to pally up with, to become friends [v]\n",
  "PALLIER": "PALLY, marked by close friendship [adj]\n",
  "PALLIES": "PALLY, as in to pally up with, to become friends [v]\n",
  "PALLIEST": "PALLY, marked by close friendship [adj]\n",
  "PALLING": "PALL, to grow wearisome [v]\n",
  "PALLIUM": "(Latin) a cloak worn in ancient Rome [n PALLIUMS or PALLIA]\n",
  "PALLIUMS": "PALLIUM, (Latin) a cloak worn in ancient Rome [n]\n",
  "PALLONE": "(Italian) an Italian game, played with a large leather ball [n -S]\n",
  "PALLONES": "PALLONE, (Italian) an Italian game, played with a large leather ball [n]\n",
  "PALLOR": "paleness esp. of the complexion [n -S]\n",
  "PALLORS": "PALLOR, paleness esp. of the complexion [n]\n",
  "PALLS": "PALL, to grow wearisome [v]\n",
  "PALLY": "marked by close friendship [adj PALLIER, PALLIEST] / as in to pally up with, to become friends [v PALLIED, PALLYING, PALLIES]\n",
  "PALLYING": "PALLY, as in to pally up with, to become friends [v]\n",
  "PALM": "to touch with the inside of the hand [v -ED, -ING, -S]\n",
  "PALMACEOUS": "of or pertaining to palms [adj]\n",
  "PALMAR": "pertaining to the palm [adj]\n",
  "PALMARIAN": "worthy of the ceremonial palm; preeminent, also PALMARY [adj]\n",
  "PALMARY": "worthy of the ceremonial palm; preeminent, also PALMARIAN [adj]\n",
  "PALMATE": "resembling an open hand, also PALMATED [adj PALMATELY]\n",
  "PALMATED": "resembling an open hand, also PALMATE [adj]\n",
  "PALMATELY": "PALMATE, resembling an open hand, also PALMATED [adv]\n",
  "PALMATIFID": "shaped like the hand, with the divisions extending about halfway down [adj]\n",
  "PALMATION": "all or part of a palmate structure [n -S]\n",
  "PALMATIONS": "PALMATION, all or part of a palmate structure [n]\n",
  "PALMATIPARTITE": "palmately divided rather more than halfway [adj]\n",
  "PALMATISECT": "deeply cut in a palmate manner [adj]\n",
  "PALMBALL": "a baseball pitched from the palm and thumb [n -S]\n",
  "PALMBALLS": "PALMBALL, a baseball pitched from the palm and thumb [n]\n",
  "PALMCORDER": "a small camcorder which can be held in the palm of the hand [n -S]\n",
  "PALMCORDERS": "PALMCORDER, a small camcorder which can be held in the palm of the hand [n]\n",
  "PALMED": "PALM, to touch with the inside of the hand [v]\n",
  "PALMER": "one who bears a palm-branch, in token of having made a pilgrimage to Palestine [n -S]\n",
  "PALMERS": "PALMER, one who bears a palm-branch, in token of having made a pilgrimage to Palestine [n]\n",
  "PALMERWORM": "(Biblical) any destructive caterpillar [n -S]\n",
  "PALMERWORMS": "PALMERWORM, (Biblical) any destructive caterpillar [n]\n",
  "PALMETTE": "(French) an ornament (in sculpture or painting) with radiating petals like a palm leaf [n -S]\n",
  "PALMETTES": "PALMETTE, (French) an ornament (in sculpture or painting) with radiating petals like a palm leaf [n]\n",
  "PALMETTO": "(Spanish) any of various usually small and sometimes stemless fan palms [n -ES or -S]\n",
  "PALMETTOES": "PALMETTO, (Spanish) any of various usually small and sometimes stemless fan palms [n]\n",
  "PALMETTOS": "PALMETTO, (Spanish) any of various usually small and sometimes stemless fan palms [n]\n",
  "PALMFUL": "as much as a palm can hold [n -S]\n",
  "PALMFULS": "PALMFUL, as much as a palm can hold [n]\n",
  "PALMHOUSE": "a glasshouse for palms and other plants [n -S]\n",
  "PALMHOUSES": "PALMHOUSE, a glasshouse for palms and other plants [n]\n",
  "PALMIE": "(Scots) a stroke of the tawse on the palm, also PALMY [n -S]\n",
  "PALMIER": "a pastry shaped like a palm leaf [n -S]\n",
  "PALMIERS": "PALMIER, a pastry shaped like a palm leaf [n]\n",
  "PALMIES": "PALMY, a stroke on the palm with a strap, also PALMIE [n]\n",
  "PALMIEST": "PALMY, marked by prosperity [adj]\n",
  "PALMIET": "(South African) an aloe-like riverside plant of the rush family [n -S]\n",
  "PALMIETS": "PALMIET, (South African) an aloe-like riverside plant of the rush family [n]\n",
  "PALMIFICATION": "the artificial fertilization of dates by hanging a wild male flower cluster on a cultivated female tree [n -S]\n",
  "PALMIFICATIONS": "PALMIFICATION, the artificial fertilization of dates by hanging a wild male flower cluster on a cultivated female tree [n]\n",
  "PALMING": "PALM, to touch with the inside of the hand [v]\n",
  "PALMIPED": "a webfooted bird, also PALMIPEDE [n -S]\n",
  "PALMIPEDE": "a webfooted bird, also PALMIPED [n -S]\n",
  "PALMIPEDES": "PALMIPEDE, a webfooted bird, also PALMIPED [n]\n",
  "PALMIPEDS": "PALMIPED, a webfooted bird, also PALMIPEDE [n]\n",
  "PALMIST": "a person who tells fortunes by reading palms, also PALMISTER [n -S]\n",
  "PALMISTER": "a person who tells fortunes by reading palms, also PALMIST [n -S]\n",
  "PALMISTERS": "PALMISTER, a person who tells fortunes by reading palms, also PALMIST [n]\n",
  "PALMISTRIES": "PALMISTRY, foretelling a person's future from the lines on their palms [n]\n",
  "PALMISTRY": "foretelling a person's future from the lines on their palms [n PALMISTRIES]\n",
  "PALMISTS": "PALMIST, a person who tells fortunes by reading palms, also PALMISTER [n]\n",
  "PALMITATE": "a salt of palmitic acid [n -S]\n",
  "PALMITATES": "PALMITATE, a salt of palmitic acid [n]\n",
  "PALMITIC": "as in palmitic acid, an ingredient of some soaps [adj]\n",
  "PALMITIN": "a glyceride of palmitic acid [n -S]\n",
  "PALMITINS": "PALMITIN, a glyceride of palmitic acid [n]\n",
  "PALMLIKE": "resembling a palm tree [adj]\n",
  "PALMPRINT": "the print of a palm [n -S]\n",
  "PALMPRINTS": "PALMPRINT, the print of a palm [n]\n",
  "PALMS": "PALM, to touch with the inside of the hand [v]\n",
  "PALMTOP": "a small handheld computer [n -S]\n",
  "PALMTOPS": "PALMTOP, a small handheld computer [n]\n",
  "PALMY": "a stroke on the palm with a strap, also PALMIE [n PALMIES] / marked by prosperity [adj PALMIER, PALMIEST]\n",
  "PALMYRA": "(Portuguese) a species of palm having a straight, black, upright trunk, with palmate leaves [n -S]\n",
  "PALMYRAS": "PALMYRA, (Portuguese) a species of palm having a straight, black, upright trunk, with palmate leaves [n]\n",
  "PALOLO": "(Samoan) a type of seaworm, found in the Pacific [n -S]\n",
  "PALOLOS": "PALOLO, (Samoan) a type of seaworm, found in the Pacific [n]\n",
  "PALOMINO": "(Spanish) a horse of largely Arab blood, pale tan, yellow, or gold, with a white or silver mane and tail, also PALAMINO [n -S]\n",
  "PALOMINOS": "PALOMINO, (Spanish) a horse of largely Arab blood, pale tan, yellow, or gold, with a white or silver mane and tail, also PALAMINO [n]\n",
  "PALOOKA": "a clumsy, inept, or untalented boxer; a stupid, clumsy, or obnoxious person [n -S]\n",
  "PALOOKAS": "PALOOKA, a clumsy, inept, or untalented boxer; a stupid, clumsy, or obnoxious person [n]\n",
  "PALOVERDE": "(Spanish) a desert shrub with spiny, yellow flowers [n -S]\n",
  "PALOVERDES": "PALOVERDE, (Spanish) a desert shrub with spiny, yellow flowers [n]\n",
  "PALP": "to sense by touch [v -ED, -ING, -S]\n",
  "PALPABILITIES": "PALPABILITY, the quality of being palpable [n]\n",
  "PALPABILITY": "the quality of being palpable [n PALPABILITIES]\n",
  "PALPABLE": "capable of being felt [adj]\n",
  "PALPABLENESS": "the state of being palpable [n -ES]\n",
  "PALPABLENESSES": "PALPABLENESS, the state of being palpable [n]\n",
  "PALPABLY": "PALPABLE, capable of being felt [adv]\n",
  "PALPAL": "relating to a palp, an elongated sense organ, usually near mouth, in insects, mollusks, crustaceans [adj]\n",
  "PALPATE": "to examine by touch [v PALPATED, PALPATING, PALPATES]\n",
  "PALPATED": "PALPATE, to examine by touch [v]\n",
  "PALPATES": "PALPATE, to examine by touch [v]\n",
  "PALPATING": "PALPATE, to examine by touch [v]\n",
  "PALPATION": "the act of touching or feeling [n -S]\n",
  "PALPATIONS": "PALPATION, the act of touching or feeling [n]\n",
  "PALPATOR": "one who palpates [n -S]\n",
  "PALPATORS": "PALPATOR, one who palpates [n]\n",
  "PALPATORY": "relating to palpation [adj]\n",
  "PALPEBRA": "(Latin) the eyelid [n PALPEBRAE or PALPEBRAS]\n",
  "PALPEBRAE": "PALPEBRA, (Latin) the eyelid [n]\n",
  "PALPEBRAL": "of or relating to the palpebra, the eyelid [adj]\n",
  "PALPEBRAS": "PALPEBRA, (Latin) the eyelid [n]\n",
  "PALPEBRATE": "to wink or blink repeatedly [v PALPEBRATED, PALPEBRATING, PALPEBRATES]\n",
  "PALPEBRATED": "PALPEBRATE, to wink or blink repeatedly [v]\n",
  "PALPEBRATES": "PALPEBRATE, to wink or blink repeatedly [v]\n",
  "PALPEBRATING": "PALPEBRATE, to wink or blink repeatedly [v]\n",
  "PALPED": "PALP, to sense by touch [v]\n",
  "PALPI": "PALPUS, (Latin) a sense organ attached to mouthparts of certain insects and crustacea, also PALP [n]\n",
  "PALPING": "PALP, to sense by touch [v]\n",
  "PALPITANT": "palpitating; throbbing; trembling [adj]\n",
  "PALPITATE": "to throb, beat rapidly [v PALPITATED, PALPITATING, PALPITATES]\n",
  "PALPITATED": "PALPITATE, to throb, beat rapidly [v]\n",
  "PALPITATES": "PALPITATE, to throb, beat rapidly [v]\n",
  "PALPITATING": "PALPITATE, to throb, beat rapidly [v]\n",
  "PALPITATION": "a nervous throbbing [n -S]\n",
  "PALPITATIONS": "PALPITATION, a nervous throbbing [n]\n",
  "PALPS": "PALP, to sense by touch [v]\n",
  "PALPUS": "(Latin) a sense organ attached to mouthparts of certain insects and crustacea, also PALP [n PALPI or PALPUSES]\n",
  "PALPUSES": "PALPUS, (Latin) a sense organ attached to mouthparts of certain insects and crustacea, also PALP [n]\n",
  "PALS": "PAL, to associate as friends [v]\n",
  "PALSA": "(Finnish) a landform of subarctic regions [n -S]\n",
  "PALSAS": "PALSA, (Finnish) a landform of subarctic regions [n]\n",
  "PALSGRAVE": "(Dutch) a count palatine [n -S]\n",
  "PALSGRAVES": "PALSGRAVE, (Dutch) a count palatine [n]\n",
  "PALSGRAVINE": "the domain of a palsgrave, a count palatine [n -S]\n",
  "PALSGRAVINES": "PALSGRAVINE, the domain of a palsgrave, a count palatine [n]\n",
  "PALSHIP": "the relationship existing between close friends [n -S]\n",
  "PALSHIPS": "PALSHIP, the relationship existing between close friends [n]\n",
  "PALSIED": "PALSY, to affect with palsy (a loss of control or of feeling in the muscles of the body) [v]\n",
  "PALSIER": "PALSY, pally, being pals [adj]\n",
  "PALSIES": "PALSY, to affect with palsy (a loss of control or of feeling in the muscles of the body) [v]\n",
  "PALSIEST": "PALSY, pally, being pals [adj]\n",
  "PALSTAFF": "(Dutch) a peculiar bronze adz, used in prehistoric Europe about the middle of the Bronze Age, also PALSTAVE [n -S]\n",
  "PALSTAFFS": "PALSTAFF, (Dutch) a peculiar bronze adz, used in prehistoric Europe about the middle of the Bronze Age, also PALSTAVE [n]\n",
  "PALSTAVE": "(Dutch) a peculiar bronze adz, used in prehistoric Europe about the middle of the Bronze Age, also PALSTAFF [n -S]\n",
  "PALSTAVES": "PALSTAVE, (Dutch) a peculiar bronze adz, used in prehistoric Europe about the middle of the Bronze Age, also PALSTAFF [n]\n",
  "PALSY": "pally, being pals [adj PALSIER, PALSIEST] / to affect with palsy (a loss of control or of feeling in the muscles of the body) [v PALSIED, PALSYING, PALSIES]\n",
  "PALSYING": "PALSY, to affect with palsy (a loss of control or of feeling in the muscles of the body) [v]\n",
  "PALSYLIKE": "like the palsy [adj]\n",
  "PALTER": "to talk or act insincerely [v -ED, -ING, -S]\n",
  "PALTERED": "PALTER, to talk or act insincerely [v]\n",
  "PALTERER": "one who palters, talks in a deceitful manner [n -S]\n",
  "PALTERERS": "PALTERER, one who palters, talks in a deceitful manner [n]\n",
  "PALTERING": "PALTER, to talk or act insincerely [v]\n",
  "PALTERS": "PALTER, to talk or act insincerely [v]\n",
  "PALTRIER": "PALTRY, meagre, mean [adj]\n",
  "PALTRIEST": "PALTRY, meagre, mean [adj]\n",
  "PALTRILY": "PALTRY, meagre, mean [adv]\n",
  "PALTRINESS": "the state of being paltry [n -ES]\n",
  "PALTRINESSES": "PALTRINESS, the state of being paltry [n]\n",
  "PALTRY": "meagre, mean [adj PALTRIER, PALTRIEST, PALTRILY]\n",
  "PALUDAL": "of marshes, also PALUDIC, PALUDINAL, PALUDINE, PALUDINOUS [adj]\n",
  "PALUDAMENT": "a Roman general's or high military officer's cloak, also PALUDAMENTUM [n -S]\n",
  "PALUDAMENTA": "PALUDAMENTUM, a Roman general's or high military officer's cloak, also PALUDAMENT [n]\n",
  "PALUDAMENTS": "PALUDAMENT, a Roman general's or high military officer's cloak, also PALUDAMENTUM [n]\n",
  "PALUDAMENTUM": "a Roman general's or high military officer's cloak, also PALUDAMENT [n PALUDAMENTA or PALUDAMENTUMS]\n",
  "PALUDAMENTUMS": "PALUDAMENTUM, a Roman general's or high military officer's cloak, also PALUDAMENT [n]\n",
  "PALUDIC": "of marshes, also PALUDAL, PALUDINAL, PALUDINE, PALUDINOUS [adj]\n",
  "PALUDICOLOUS": "growing in marshes; marsh-dwelling [adj]\n",
  "PALUDINAL": "of marshes, also PALUDAL, PALUDIC, PALUDINE, PALUDINOUS [adj]\n",
  "PALUDINE": "of marshes, also PALUDAL, PALUDIC, PALUDINAL, PALUDINOUS [adj]\n",
  "PALUDINOUS": "of marshes, also PALUDAL, PALUDIC, PALUDINAL, PALUDINE [adj]\n",
  "PALUDISM": "marsh fever; malaria [n -S]\n",
  "PALUDISMS": "PALUDISM, marsh fever; malaria [n]\n",
  "PALUDOSE": "marshy; living in marshes, also PALUDOUS [adj]\n",
  "PALUDOUS": "marshy; living in marshes, also PALUDOSE [adj]\n",
  "PALUSTRAL": "of marshes, inhabiting marshes, also PALUSTRIAN, PALUSTRINE [adj]\n",
  "PALUSTRIAN": "of marshes, inhabiting marshes, also PALUSTRAL, PALUSTRINE [adj]\n",
  "PALUSTRINE": "of marshes, inhabiting marshes, also PALUSTRAL, PALUSTRIAN [adj]\n",
  "PALY": "somewhat pale [adj PALIER, PALIEST]\n",
  "PALYNOLOGIC": "relating to palynology, the scientific study of spores and pollen, also PALYNOLOGICAL [adj]\n",
  "PALYNOLOGICAL": "relating to palynology, the scientific study of spores and pollen, also PALYNOLOGIC [adj PALYNOLOGICALLY]\n",
  "PALYNOLOGICALLY": "PALYNOLOGICAL, relating to palynology, the scientific study of spores and pollen, also PALYNOLOGIC [adv]\n",
  "PALYNOLOGIES": "PALYNOLOGY, the scientific study of spores and pollen [n]\n",
  "PALYNOLOGIST": "a student of palynology [n -S]\n",
  "PALYNOLOGISTS": "PALYNOLOGIST, a student of palynology [n]\n",
  "PALYNOLOGY": "the scientific study of spores and pollen [n PALYNOLOGIES]\n",
  "PAM": "the jack of clubs in certain card games [n -S]\n",
  "PAMPA": "(Quechua) a treeless plain, also PAMPAS [n -S]\n",
  "PAMPAS": "(Quechua) a treeless plain, also PAMPA [n -ES]\n",
  "PAMPASES": "PAMPAS, (Quechua) a treeless plain, also PAMPA [n]\n",
  "PAMPEAN": "a native of the pampas [n -S]\n",
  "PAMPEANS": "PAMPEAN, a native of the pampas [n]\n",
  "PAMPELMOOSE": "(Dutch) the shaddock or grapefruit, also PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n -S]\n",
  "PAMPELMOOSES": "PAMPELMOOSE, (Dutch) the shaddock or grapefruit, also PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n]\n",
  "PAMPELMOUSE": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n -S]\n",
  "PAMPELMOUSES": "PAMPELMOUSE, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n]\n",
  "PAMPER": "to treat with excessive indulgence [v -ED, -ING, -S]\n",
  "PAMPERED": "PAMPER, to treat with excessive indulgence [v]\n",
  "PAMPEREDNESS": "the state of being pampered [n -ES]\n",
  "PAMPEREDNESSES": "PAMPEREDNESS, the state of being pampered [n]\n",
  "PAMPERER": "one who pampers [n -S]\n",
  "PAMPERERS": "PAMPERER, one who pampers [n]\n",
  "PAMPERING": "the act of treating with extreme or excessive indulgence [n -S]\n",
  "PAMPERINGS": "PAMPERING, the act of treating with extreme or excessive indulgence [n]\n",
  "PAMPERO": "(Spanish) a violent SW wind on and from the pampas [n -S]\n",
  "PAMPEROS": "PAMPERO, (Spanish) a violent SW wind on and from the pampas [n]\n",
  "PAMPERS": "PAMPER, to treat with excessive indulgence [v]\n",
  "PAMPHLET": "to circulate a small unbound printed work to [v -ED, -ING, -S]\n",
  "PAMPHLETED": "PAMPHLET, to circulate a small unbound printed work to [v]\n",
  "PAMPHLETEER": "to write and/or distribute pamphlets [v -ED, -ING, -S]\n",
  "PAMPHLETEERED": "PAMPHLETEER, to write and/or distribute pamphlets [v]\n",
  "PAMPHLETEERING": "the writing and/or distribution of pamphlets [n -S]\n",
  "PAMPHLETEERINGS": "PAMPHLETEERING, the writing and/or distribution of pamphlets [n]\n",
  "PAMPHLETEERS": "PAMPHLETEER, to write and/or distribute pamphlets [v]\n",
  "PAMPHLETING": "PAMPHLET, to circulate a small unbound printed work to [v]\n",
  "PAMPHLETS": "PAMPHLET, to circulate a small unbound printed work to [v]\n",
  "PAMPHREY": "(Irish) a cabbage [n -S]\n",
  "PAMPHREYS": "PAMPHREY, (Irish) a cabbage [n]\n",
  "PAMPOEN": "(South African) a pumpkin [n -S]\n",
  "PAMPOENS": "PAMPOEN, (South African) a pumpkin [n]\n",
  "PAMPOOTIE": "a rawhide slipper worn by men in the Aran Islands [n -S]\n",
  "PAMPOOTIES": "PAMPOOTIE, a rawhide slipper worn by men in the Aran Islands [n]\n",
  "PAMS": "PAM, the jack of clubs in certain card games [n]\n",
  "PAN": "to criticize harshly [v PANNED, PANNING, PANS]\n",
  "PANACEA": "(Greek) a remedy for all diseases, also PANACHAEA [n -S]\n",
  "PANACEAN": "having the properties of a panacea [adj]\n",
  "PANACEAS": "PANACEA, (Greek) a remedy for all diseases, also PANACHAEA [n]\n",
  "PANACHAEA": "(Spenser) a remedy for all diseases, also PANACEA [n -S]\n",
  "PANACHAEAS": "PANACHAEA, (Spenser) a remedy for all diseases, also PANACEA [n]\n",
  "PANACHE": "(French) dash or flamboyance in style; verve [n -S]\n",
  "PANACHES": "PANACHE, (French) dash or flamboyance in style; verve [n]\n",
  "PANADA": "(Spanish) a thick sauce used to bind quenelles, forcemeats and rissoles [n -S]\n",
  "PANADAS": "PANADA, (Spanish) a thick sauce used to bind quenelles, forcemeats and rissoles [n]\n",
  "PANAESTHESIA": "totality of perception; general awareness, also PANAESTHETISM [n -S]\n",
  "PANAESTHESIAS": "PANAESTHESIA, totality of perception; general awareness, also PANAESTHETISM [n]\n",
  "PANAESTHETISM": "totality of perception; general awareness, also PANAESTHESIA [n -S]\n",
  "PANAESTHETISMS": "PANAESTHETISM, totality of perception; general awareness, also PANAESTHESIA [n]\n",
  "PANAMA": "a lightweight plaited man's hat [n -S]\n",
  "PANAMAS": "PANAMA, a lightweight plaited man's hat [n]\n",
  "PANARIES": "PANARY, a bread store [n]\n",
  "PANARITIUM": "a whitlow [n -S]\n",
  "PANARITIUMS": "PANARITIUM, a whitlow [n]\n",
  "PANARTHRITIS": "arthritis of all joints of body, or of the whole of one joint [n -ES]\n",
  "PANARTHRITISES": "PANARTHRITIS, arthritis of all joints of body, or of the whole of one joint [n]\n",
  "PANARY": "a bread store [n PANARIES]\n",
  "PANATELA": "(Spanish) a long thin cigar, also PANATELLA, PANETELA, PANETELLA [n -S]\n",
  "PANATELAS": "PANATELA, (Spanish) a long thin cigar, also PANATELLA, PANETELA, PANETELLA [n]\n",
  "PANATELLA": "(Spanish) a long thin cigar, also PANATELA, PANETELA, PANETELLA [n -S]\n",
  "PANATELLAS": "PANATELLA, (Spanish) a long thin cigar, also PANATELA, PANETELA, PANETELLA [n]\n",
  "PANAX": "(Greek) a tree of the Aralia family [n -ES]\n",
  "PANAXES": "PANAX, (Greek) a tree of the Aralia family [n]\n",
  "PANBROIL": "to fry in a pan with little or no fat [v -ED, -ING, -S]\n",
  "PANBROILED": "PANBROIL, to fry in a pan with little or no fat [v]\n",
  "PANBROILING": "PANBROIL, to fry in a pan with little or no fat [v]\n",
  "PANBROILS": "PANBROIL, to fry in a pan with little or no fat [v]\n",
  "PANCAKE": "to land an aircraft without wheels [v PANCAKED, PANCAKING, PANCAKES]\n",
  "PANCAKED": "PANCAKE, to land an aircraft without wheels [v]\n",
  "PANCAKES": "PANCAKE, to land an aircraft without wheels [v]\n",
  "PANCAKING": "PANCAKE, to land an aircraft without wheels [v]\n",
  "PANCE": "(obsolete) the pansy, also PAUNCE, PAWNCE [n -S]\n",
  "PANCES": "PANCE, (obsolete) the pansy, also PAUNCE, PAWNCE [n]\n",
  "PANCETTA": "(Italian) unsmoked Italian bacon [n -S]\n",
  "PANCETTAS": "PANCETTA, (Italian) unsmoked Italian bacon [n]\n",
  "PANCHAX": "(Latin) any of several kinds of brightly coloured fish, often stocked in aquariums [n -ES]\n",
  "PANCHAXES": "PANCHAX, (Latin) any of several kinds of brightly coloured fish, often stocked in aquariums [n]\n",
  "PANCHAYAT": "(Hindi) five elders, a council of five that is the basis for Indian village government [n -S]\n",
  "PANCHAYATS": "PANCHAYAT, (Hindi) five elders, a council of five that is the basis for Indian village government [n]\n",
  "PANCHEON": "a wide-brimmed, shallow vessel into which milk was poured and left to settle, so that the cream could separate, also PANCHION, PUNCHEON [n -S]\n",
  "PANCHEONS": "PANCHEON, a wide-brimmed, shallow vessel into which milk was poured and left to settle, so that the cream could separate, also PANCHION, PUNCHEON [n]\n",
  "PANCHION": "a wide-brimmed, shallow vessel into which milk was poured and left to settle, so that the cream could separate, also PANCHEON, PUNCHEON [n -S]\n",
  "PANCHIONS": "PANCHION, a wide-brimmed, shallow vessel into which milk was poured and left to settle, so that the cream could separate, also PANCHEON, PUNCHEON [n]\n",
  "PANCHROMATIC": "of photographic film, sensitive to all colours [adj]\n",
  "PANCHROMATISM": "being equally sensitive to all colours [n -S]\n",
  "PANCHROMATISMS": "PANCHROMATISM, being equally sensitive to all colours [n]\n",
  "PANCOSMIC": "pertaining to pancosmism, the theory that the material universe is all that exists [adj]\n",
  "PANCOSMISM": "the theory that the material universe is all that exists [n -S]\n",
  "PANCOSMISMS": "PANCOSMISM, the theory that the material universe is all that exists [n]\n",
  "PANCRATIA": "PANCRATIUM, an athletic contest involving both boxing and wrestling [n]\n",
  "PANCRATIAN": "pancratic; athletic [adj]\n",
  "PANCRATIAST": "a competitor or victor in the pancratium, an athletic contest involving both boxing and wrestling [n -S]\n",
  "PANCRATIASTS": "PANCRATIAST, a competitor or victor in the pancratium, an athletic contest involving both boxing and wrestling [n]\n",
  "PANCRATIC": "excelling all round in athletics or accomplishments [adj]\n",
  "PANCRATIST": "an athlete; a gymnast [n -S]\n",
  "PANCRATISTS": "PANCRATIST, an athlete; a gymnast [n]\n",
  "PANCRATIUM": "an athletic contest involving both boxing and wrestling [n PANCRATIUMS or PANCRATIA]\n",
  "PANCRATIUMS": "PANCRATIUM, an athletic contest involving both boxing and wrestling [n]\n",
  "PANCREAS": "a large gland discharging into the duodenum and containing islands of endocrine gland tissue [n -ES]\n",
  "PANCREASES": "PANCREAS, a large gland discharging into the duodenum and containing islands of endocrine gland tissue [n]\n",
  "PANCREATECTOMY": "surgical removal of all or part of the pancreas [n]\n",
  "PANCREATIC": "of or pertaining to the pancreas [adj]\n",
  "PANCREATIN": "the pancreatic juice [n -S]\n",
  "PANCREATINS": "PANCREATIN, the pancreatic juice [n]\n",
  "PANCREATITIDES": "PANCREATITIS, inflammation of the pancreas [n]\n",
  "PANCREATITIS": "inflammation of the pancreas [n PANCREATITIDES or PANCREATITISES]\n",
  "PANCREATITISES": "PANCREATITIS, inflammation of the pancreas [n]\n",
  "PANCREOZYMIN": "a hormone that stimulates enzyme production by the pancreas [n -S]\n",
  "PANCREOZYMINS": "PANCREOZYMIN, a hormone that stimulates enzyme production by the pancreas [n]\n",
  "PANCYTOPENIA": "an abnormal reduction in the number of erythrocytes, white blood cells, and blood platelets in the blood [n -S]\n",
  "PANCYTOPENIAS": "PANCYTOPENIA, an abnormal reduction in the number of erythrocytes, white blood cells, and blood platelets in the blood [n]\n",
  "PAND": "(Scots) the valance of a bed [n -S]\n",
  "PANDA": "(Nepali) a raccoon-like animal of the Himalayas; a similar but much larger bearlike animal of Tibet and China [n -S]\n",
  "PANDAEMONIUM": "riotous uproar, also PANDEMONIUM [n -S]\n",
  "PANDAEMONIUMS": "PANDAEMONIUM, riotous uproar, also PANDEMONIUM [n]\n",
  "PANDAN": "(Malay) a palm of SE Asia, the leaves of which are used to weave mats, also PANDANUS [n -S]\n",
  "PANDANACEOUS": "belonging to the Pandanaceae, a family of trees and bushes related to the bulrushes and bur-reeds [adj]\n",
  "PANDANI": "a tropical, palmlike tree of Tasmania [n -S]\n",
  "PANDANIS": "PANDANI, a tropical, palmlike tree of Tasmania [n]\n",
  "PANDANS": "PANDAN, (Malay) a palm of SE Asia, the leaves of which are used to weave mats, also PANDANUS [n]\n",
  "PANDANUS": "(Malay) a palm of SE Asia, the leaves of which are used to weave mats, also PANDAN [n PANDANUSES or PANDANI]\n",
  "PANDANUSES": "PANDANUS, (Malay) a palm of SE Asia, the leaves of which are used to weave mats, also PANDAN [n]\n",
  "PANDAR": "to act as a procurer of sexual favours, also PANDER [v -ED, -ING, -S]\n",
  "PANDARED": "PANDAR, to act as a procurer of sexual favours, also PANDER [v]\n",
  "PANDARING": "PANDAR, to act as a procurer of sexual favours, also PANDER [v]\n",
  "PANDARS": "PANDAR, to act as a procurer of sexual favours, also PANDER [v]\n",
  "PANDAS": "PANDA, (Nepali) a raccoon-like animal of the Himalayas; a similar but much larger bearlike animal of Tibet and China [n]\n",
  "PANDATION": "(archaic) warping [n -S]\n",
  "PANDATIONS": "PANDATION, (archaic) warping [n]\n",
  "PANDECT": "a treatise covering the whole of any subject, esp. the complete laws of a country [n -S]\n",
  "PANDECTIST": "one who writes a pandect, a treatise covering a subject exhaustively [n -S]\n",
  "PANDECTISTS": "PANDECTIST, one who writes a pandect, a treatise covering a subject exhaustively [n]\n",
  "PANDECTS": "PANDECT, a treatise covering the whole of any subject, esp. the complete laws of a country [n]\n",
  "PANDEMIA": "a widespread epidemic [n -S]\n",
  "PANDEMIAN": "vulgar; sensual [adj]\n",
  "PANDEMIAS": "PANDEMIA, a widespread epidemic [n]\n",
  "PANDEMIC": "a widespread disease [n -S]\n",
  "PANDEMICS": "PANDEMIC, a widespread disease [n]\n",
  "PANDEMONIAC": "pertaining to pandemonium, general tumult, also PANDEMONIACAL, PANDEMONIAN, PANDEMONIC [adj]\n",
  "PANDEMONIACAL": "pertaining to pandemonium, general tumult, also PANDEMONIAC, PANDEMONIAN, PANDEMONIC [adj]\n",
  "PANDEMONIAN": "a noisy and disorderly person [n -S]\n",
  "PANDEMONIANS": "PANDEMONIAN, a noisy and disorderly person [n]\n",
  "PANDEMONIC": "pertaining to pandemonium, general tumult, also PANDEMONIAC, PANDEMONIACAL, PANDEMONIAN [adj]\n",
  "PANDEMONIUM": "riotous uproar, also PANDAEMONIUM [n -S]\n",
  "PANDEMONIUMS": "PANDEMONIUM, riotous uproar, also PANDAEMONIUM [n]\n",
  "PANDER": "to act as a procurer of sexual favours, also PANDAR [v -ED, -ING, -S]\n",
  "PANDERED": "PANDER, to act as a procurer of sexual favours, also PANDAR [v]\n",
  "PANDERER": "one who panders, procures sexual favours [n -S]\n",
  "PANDERERS": "PANDERER, one who panders, procures sexual favours [n]\n",
  "PANDERESS": "a female pander [n -ES]\n",
  "PANDERESSES": "PANDERESS, a female pander [n]\n",
  "PANDERING": "the procuring of sexual favours [n -S]\n",
  "PANDERINGS": "PANDERING, the procuring of sexual favours [n]\n",
  "PANDERISM": "the employment, arts, or practices of a pander [n -S]\n",
  "PANDERISMS": "PANDERISM, the employment, arts, or practices of a pander [n]\n",
  "PANDERLY": "(Shakespeare) acting as a procurer [adj]\n",
  "PANDERMITE": "a hydrogen calcium borate [n -S]\n",
  "PANDERMITES": "PANDERMITE, a hydrogen calcium borate [n]\n",
  "PANDEROUS": "of or relating to a pander [adj]\n",
  "PANDERS": "PANDER, to act as a procurer of sexual favours, also PANDAR [v]\n",
  "PANDICULATION": "a stretching out when drowsy or when waking [n -S]\n",
  "PANDICULATIONS": "PANDICULATION, a stretching out when drowsy or when waking [n]\n",
  "PANDIED": "PANDY, to punish by striking the hand [v]\n",
  "PANDIES": "PANDY, to punish by striking the hand [v]\n",
  "PANDIT": "(Sanskrit) a Hindu learned in Sanskrit, also PUNDIT [n -S]\n",
  "PANDITS": "PANDIT, (Sanskrit) a Hindu learned in Sanskrit, also PUNDIT [n]\n",
  "PANDOOR": "one of a class of Hungarian mountaineers serving in the Austrian army, also PANDOUR [n -S]\n",
  "PANDOORS": "PANDOOR, one of a class of Hungarian mountaineers serving in the Austrian army, also PANDOUR [n]\n",
  "PANDORA": "(Spanish) an ancient musical instrument, also BANDORA, BANDORE, PANDORE, PANDURA [n -S]\n",
  "PANDORAS": "PANDORA, (Spanish) an ancient musical instrument, also BANDORA, BANDORE, PANDORE, PANDURA [n]\n",
  "PANDORE": "(Spanish) an ancient musical instrument, also BANDORA, BANDORE, PANDORA, PANDURA [n -S]\n",
  "PANDORES": "PANDORE, (Spanish) an ancient musical instrument, also BANDORA, BANDORE, PANDORA, PANDURA [n]\n",
  "PANDOUR": "one of a class of Hungarian mountaineers serving in the Austrian army, also PANDOOR [n -S]\n",
  "PANDOURS": "PANDOUR, one of a class of Hungarian mountaineers serving in the Austrian army, also PANDOOR [n]\n",
  "PANDOWDIES": "PANDOWDY, a deep pie or pudding made of baked apples, or of sliced bread and apples baked together, with no bottom crust [n]\n",
  "PANDOWDY": "a deep pie or pudding made of baked apples, or of sliced bread and apples baked together, with no bottom crust [n PANDOWDIES]\n",
  "PANDROP": "(Scots) a hard mint-flavoured sweet [n -S]\n",
  "PANDROPS": "PANDROP, (Scots) a hard mint-flavoured sweet [n]\n",
  "PANDS": "PAND, (Scots) the valance of a bed [n]\n",
  "PANDURA": "(Spanish) an ancient musical instrument, also BANDORA, BANDORE, PANDORA, PANDORE [n -S]\n",
  "PANDURAS": "PANDURA, (Spanish) an ancient musical instrument, also BANDORA, BANDORE, PANDORA, PANDORE [n]\n",
  "PANDURATE": "fiddle-shaped, e.g. of leaves, also PANDURATED, PANDURIFORM [adj]\n",
  "PANDURATED": "fiddle-shaped, e.g. of leaves, also PANDURATE, PANDURIFORM [adj]\n",
  "PANDURIFORM": "fiddle-shaped, e.g. of leaves, also PANDURATE, PANDURATED [adj]\n",
  "PANDY": "to punish by striking the hand [v PANDIED, PANDYING, PANDIES]\n",
  "PANDYING": "PANDY, to punish by striking the hand [v]\n",
  "PANE": "to insert panels in [v PANED, PANING, PANES]\n",
  "PANED": "PANE, to insert panels in [v]\n",
  "PANEER": "(Hindi) a soft white cheese used in Indian cookery [n -S]\n",
  "PANEERS": "PANEER, (Hindi) a soft white cheese used in Indian cookery [n]\n",
  "PANEGOISM": "solipsism [n -S]\n",
  "PANEGOISMS": "PANEGOISM, solipsism [n]\n",
  "PANEGYRIC": "a eulogistic oration or writing; a formal or elaborate praise [n -S]\n",
  "PANEGYRICA": "PANEGYRICON, a collection of sermons for Orthodox church festivals [n]\n",
  "PANEGYRICAL": "of or like a panegyric [adj PANEGYRICALLY]\n",
  "PANEGYRICALLY": "PANEGYRICAL, of or like a panegyric [adv]\n",
  "PANEGYRICON": "a collection of sermons for Orthodox church festivals [n PANEGYRICA]\n",
  "PANEGYRICS": "PANEGYRIC, a eulogistic oration or writing; a formal or elaborate praise [n]\n",
  "PANEGYRIES": "PANEGYRY, a great assembly [n]\n",
  "PANEGYRISE": "to deliver a panegyric upon, also PANEGYRIZE [v PANEGYRISED, PANEGYRISING, PANEGYRISES]\n",
  "PANEGYRISED": "PANEGYRISE, to deliver a panegyric upon, also PANEGYRIZE [v]\n",
  "PANEGYRISES": "PANEGYRISE, to deliver a panegyric upon, also PANEGYRIZE [v]\n",
  "PANEGYRISING": "PANEGYRISE, to deliver a panegyric upon, also PANEGYRIZE [v]\n",
  "PANEGYRIST": "one who delivers a panegyric [n -S]\n",
  "PANEGYRISTS": "PANEGYRIST, one who delivers a panegyric [n]\n",
  "PANEGYRIZE": "to deliver a panegyric upon, also PANEGYRISE [v PANEGYRIZED, PANEGYRIZING, PANEGYRIZES]\n",
  "PANEGYRIZED": "PANEGYRIZE, to deliver a panegyric upon, also PANEGYRISE [v]\n",
  "PANEGYRIZES": "PANEGYRIZE, to deliver a panegyric upon, also PANEGYRISE [v]\n",
  "PANEGYRIZING": "PANEGYRIZE, to deliver a panegyric upon, also PANEGYRISE [v]\n",
  "PANEGYRY": "a great assembly [n PANEGYRIES]\n",
  "PANEITIES": "PANEITY, the state of being bread [n]\n",
  "PANEITY": "the state of being bread [n PANEITIES]\n",
  "PANEL": "to decorate with thin sheets of material [v PANELED or PANELLED, PANELING or PANELLING, PANELS]\n",
  "PANELED": "PANEL, to decorate with thin sheets of material [v]\n",
  "PANELESS": "without a pane [adj]\n",
  "PANELING": "material with which to panel, also PANELLING [n -S]\n",
  "PANELINGS": "PANELING, material with which to panel, also PANELLING [n]\n",
  "PANELISED": "made in sections for quick assembly, also PANELIZED, PANELLISED, PANELLIZED [adj]\n",
  "PANELIST": "one who serves on a panel, also PANELLIST [n -S]\n",
  "PANELISTS": "PANELIST, one who serves on a panel, also PANELLIST [n]\n",
  "PANELIZED": "made in sections for quick assembly, also PANELISED, PANELLISED, PANELLIZED [adj]\n",
  "PANELLED": "PANEL, to decorate with thin sheets of material [v]\n",
  "PANELLING": "material with which to panel, also PANELING [n -S]\n",
  "PANELLINGS": "PANELLING, material with which to panel, also PANELING [n]\n",
  "PANELLISED": "made in sections for quick assembly, also PANELISED, PANELIZED, PANELLIZED [adj]\n",
  "PANELLIST": "one who serves on a panel, also PANELIST [n -S]\n",
  "PANELLISTS": "PANELLIST, one who serves on a panel, also PANELIST [n]\n",
  "PANELLIZED": "made in sections for quick assembly, also PANELISED, PANELIZED, PANELLISED [adj]\n",
  "PANELS": "PANEL, to decorate with thin sheets of material [v]\n",
  "PANENTHEISM": "the belief that world is part but not all of God's being [n -S]\n",
  "PANENTHEISMS": "PANENTHEISM, the belief that world is part but not all of God's being [n]\n",
  "PANENTHEIST": "a believer in panentheism [n -S]\n",
  "PANENTHEISTS": "PANENTHEIST, a believer in panentheism [n]\n",
  "PANES": "PANE, to insert panels in [v]\n",
  "PANESTHESIA": "totality of perception; general awareness [n -S]\n",
  "PANESTHESIAS": "PANESTHESIA, totality of perception; general awareness [n]\n",
  "PANETELA": "(Spanish) a long thin cigar, also PANATELA, PANATELLA, PANETELLA [n -S]\n",
  "PANETELAS": "PANETELA, (Spanish) a long thin cigar, also PANATELA, PANATELLA, PANETELLA [n]\n",
  "PANETELLA": "(Spanish) a long thin cigar, also PANATELA, PANATELLA, PANETELA [n -S]\n",
  "PANETELLAS": "PANETELLA, (Spanish) a long thin cigar, also PANATELA, PANATELLA, PANETELA [n]\n",
  "PANETTONE": "(Italian) a kind of spiced cake, usually made with sultanas [n PANETTONES or PANETTONI]\n",
  "PANETTONES": "PANETTONE, (Italian) a kind of spiced cake, usually made with sultanas [n]\n",
  "PANETTONI": "PANETTONE, (Italian) a kind of spiced cake, usually made with sultanas [n]\n",
  "PANFISH": "any small fish that can be fried whole [n -ES] / to fish for any small fish that can be fried whole [v -ED, -ING, -ES]\n",
  "PANFISHED": "PANFISH, to fish for any small fish that can be fried whole [v]\n",
  "PANFISHES": "PANFISH, any small fish that can be fried whole [n]\n",
  "PANFISHING": "fishing for any small fish that can be fried whole [n -S]\n",
  "PANFISHINGS": "PANFISHING, fishing for any small fish that can be fried whole [n]\n",
  "PANFORTE": "(Italian) a hard spicy cake [n -S]\n",
  "PANFORTES": "PANFORTE, (Italian) a hard spicy cake [n]\n",
  "PANFRIED": "PANFRY, to fry in a frying pan [v]\n",
  "PANFRIES": "PANFRY, to fry in a frying pan [v]\n",
  "PANFRY": "to fry in a frying pan [v PANFRIED, PANFRYING, PANFRIES]\n",
  "PANFRYING": "PANFRY, to fry in a frying pan [v]\n",
  "PANFUL": "as much as a pan can hold [n -S]\n",
  "PANFULS": "PANFUL, as much as a pan can hold [n]\n",
  "PANG": "to inflict a violent but brief pain [v -ED, -ING, -S]\n",
  "PANGA": "(Swahili) an African knife, like a machete [n -S]\n",
  "PANGAMIC": "characterised by random mating [adj]\n",
  "PANGAMIES": "PANGAMY, (Greek) random mating [n]\n",
  "PANGAMY": "(Greek) random mating [n PANGAMIES]\n",
  "PANGAS": "PANGA, (Swahili) an African knife, like a machete [n]\n",
  "PANGED": "PANG, to inflict a violent but brief pain [v]\n",
  "PANGEN": "a hypothetical unit of living matter, also PANGENE [n -S]\n",
  "PANGENE": "(Greek) a hypothetical unit of living matter, also PANGEN [n -S]\n",
  "PANGENES": "PANGENE, (Greek) a hypothetical unit of living matter, also PANGEN [n]\n",
  "PANGENESES": "PANGENESIS, Darwin's theory that every cell of the body contributes gemmules to the germ-cells and so shares in the transmission of inherited characters [n]\n",
  "PANGENESIS": "Darwin's theory that every cell of the body contributes gemmules to the germ-cells and so shares in the transmission of inherited characters [n PANGENESES]\n",
  "PANGENETIC": "of or pertaining to pangenesis [adj PANGENETICALLY]\n",
  "PANGENETICALLY": "PANGENETIC, of or pertaining to pangenesis [adv]\n",
  "PANGENS": "PANGEN, a hypothetical unit of living matter, also PANGENE [n]\n",
  "PANGING": "PANG, to inflict a violent but brief pain [v]\n",
  "PANGLESS": "without a pang; painless [adj]\n",
  "PANGOLIN": "(Malay) the scaly anteater [n -S]\n",
  "PANGOLINS": "PANGOLIN, (Malay) the scaly anteater [n]\n",
  "PANGRAM": "a sentence containing all the letters of the alphabet [n -S]\n",
  "PANGRAMMATIST": "a person composing sentences, verses, etc., containing all the letters of the alphabet [n -S]\n",
  "PANGRAMMATISTS": "PANGRAMMATIST, a person composing sentences, verses, etc., containing all the letters of the alphabet [n]\n",
  "PANGRAMS": "PANGRAM, a sentence containing all the letters of the alphabet [n]\n",
  "PANGS": "PANG, to inflict a violent but brief pain [v]\n",
  "PANHANDLE": "a strip of territory stretching out from the main body like a handle on a pan [n -S] / to beg from someone esp. on the street [v PANHANDLED, PANHANDLING, PANHANDLES]\n",
  "PANHANDLED": "PANHANDLE, to beg from someone esp. on the street [v]\n",
  "PANHANDLER": "(US) someone who begs from someone esp. on the street [n -S]\n",
  "PANHANDLERS": "PANHANDLER, (US) someone who begs from someone esp. on the street [n]\n",
  "PANHANDLES": "PANHANDLE, a strip of territory stretching out from the main body like a handle on a pan [n]\n",
  "PANHANDLING": "PANHANDLE, to beg from someone esp. on the street [v]\n",
  "PANHARMONICON": "a mechanical musical instrument mimicking an orchestra [n -S]\n",
  "PANHARMONICONS": "PANHARMONICON, a mechanical musical instrument mimicking an orchestra [n]\n",
  "PANHELLENIC": "relating to all Greece [adj]\n",
  "PANHELLENION": "a council representing all the sections of the Greeks, also PANHELLENIUM [n -S]\n",
  "PANHELLENIONS": "PANHELLENION, a council representing all the sections of the Greeks, also PANHELLENIUM [n]\n",
  "PANHELLENIUM": "a council representing all the sections of the Greeks, also PANHELLENION [n -S]\n",
  "PANHELLENIUMS": "PANHELLENIUM, a council representing all the sections of the Greeks, also PANHELLENION [n]\n",
  "PANHUMAN": "pertaining to all humanity [adj]\n",
  "PANIC": "to experience great terror [v PANICKED, PANICKING, PANICS]\n",
  "PANICALLY": "in a panicking manner [adv]\n",
  "PANICK": "any grass of the genus Panicum, that includes millet, also PANICUM, PANNICK [n -S]\n",
  "PANICKED": "PANIC, to experience great terror [v]\n",
  "PANICKIER": "PANICKY, tending to panic [adj]\n",
  "PANICKIEST": "PANICKY, tending to panic [adj]\n",
  "PANICKING": "PANIC, to experience great terror [v]\n",
  "PANICKS": "PANICK, any grass of the genus Panicum, that includes millet, also PANICUM, PANNICK [n]\n",
  "PANICKY": "tending to panic [adj PANICKIER, PANICKIEST]\n",
  "PANICLE": "a loosely branched flower cluster [n -S]\n",
  "PANICLED": "having a panicle [adj]\n",
  "PANICLES": "PANICLE, a loosely branched flower cluster [n]\n",
  "PANICMONGER": "one who spreads panic [n -S]\n",
  "PANICMONGERS": "PANICMONGER, one who spreads panic [n]\n",
  "PANICS": "PANIC, to experience great terror [v]\n",
  "PANICULATE": "having or arranged in panicles, also PANICULATED [adj PANICULATELY]\n",
  "PANICULATED": "having or arranged in panicles, also PANICULATE [adj]\n",
  "PANICULATELY": "PANICULATE, having or arranged in panicles, also PANICULATED [adv]\n",
  "PANICUM": "(Latin) any grass of the genus Panicum, that includes millet, also PANICK, PANNICK [n -S]\n",
  "PANICUMS": "PANICUM, (Latin) any grass of the genus Panicum, that includes millet, also PANICK, PANNICK [n]\n",
  "PANIDIOMORPHIC": "of igneous rocks, having well-developed crystals [adj]\n",
  "PANIER": "a large basket, also PANNIER [n -S]\n",
  "PANIERS": "PANIER, a large basket, also PANNIER [n]\n",
  "PANIFICATION": "transformation into bread [n -S]\n",
  "PANIFICATIONS": "PANIFICATION, transformation into bread [n]\n",
  "PANIM": "a heathen, also PAYNIM, PAINIM [n -S]\n",
  "PANIMS": "PANIM, a heathen, also PAYNIM, PAINIM [n]\n",
  "PANING": "PANE, to insert panels in [v]\n",
  "PANINI": "(Italian) grilled, Italian-style sandwiches [n -S]\n",
  "PANINIS": "PANINI, (Italian) grilled, Italian-style sandwiches [n]\n",
  "PANINO": "(Italian) a sandwich made with a small bread roll [n PANINI]\n",
  "PANISC": "(Greek) an inferior god, attendant upon Pan, also PANISK [n -S]\n",
  "PANISCS": "PANISC, (Greek) an inferior god, attendant upon Pan, also PANISK [n]\n",
  "PANISK": "(Greek) an inferior god, attendant upon Pan, also PANISC [n -S]\n",
  "PANISKS": "PANISK, (Greek) an inferior god, attendant upon Pan, also PANISC [n]\n",
  "PANISLAM": "all of Islam or the Muslim world [n -S]\n",
  "PANISLAMIST": "of or relating to the doctrine that all Muslims should be united under one Islamic state [adj]\n",
  "PANISLAMS": "PANISLAM, all of Islam or the Muslim world [n]\n",
  "PANJANDARUM": "a powerful personage or pretentious official, also PANJANDRUM [n -S]\n",
  "PANJANDARUMS": "PANJANDARUM, a powerful personage or pretentious official, also PANJANDRUM [n]\n",
  "PANJANDRA": "PANJANDRUM, a powerful personage or pretentious official, also PANJANDARUM [n]\n",
  "PANJANDRUM": "a powerful personage or pretentious official, also PANJANDARUM [n PANJANDRUMS or PANJANDRA]\n",
  "PANJANDRUMS": "PANJANDRUM, a powerful personage or pretentious official, also PANJANDARUM [n]\n",
  "PANKO": "(Japanese) a variety of breadcrumb from Japanese and French cuisine used to create a crunchy coating for fried foods [n -S]\n",
  "PANKOS": "PANKO, (Japanese) a variety of breadcrumb from Japanese and French cuisine used to create a crunchy coating for fried foods [n]\n",
  "PANLEUCOPENIA": "a viral disease of cats marked by a deficiency of white blood cells, also PANLEUKOPENIA [n -S]\n",
  "PANLEUCOPENIAS": "PANLEUCOPENIA, a viral disease of cats marked by a deficiency of white blood cells, also PANLEUKOPENIA [n]\n",
  "PANLEUKOPENIA": "a viral disease of cats marked by a deficiency of white blood cells, also PANLEUCOPENIA [n -S]\n",
  "PANLEUKOPENIAS": "PANLEUKOPENIA, a viral disease of cats marked by a deficiency of white blood cells, also PANLEUCOPENIA [n]\n",
  "PANLIKE": "resembling a pan, a container used for cooking [adj]\n",
  "PANLOGISM": "the theory that the Universe is an outward manifestation of the Logos [n -S]\n",
  "PANLOGISMS": "PANLOGISM, the theory that the Universe is an outward manifestation of the Logos [n]\n",
  "PANMICTIC": "connected with or exhibiting panmixia, cessation of the influence of natural selection [adj]\n",
  "PANMIXES": "PANMIXIS, (Greek) random mating within a breeding population, also PANMIXIA [n]\n",
  "PANMIXIA": "random mating within a breeding population, also PANMIXIS [n -S]\n",
  "PANMIXIAS": "PANMIXIA, random mating within a breeding population, also PANMIXIS [n]\n",
  "PANMIXIS": "(Greek) random mating within a breeding population, also PANMIXIA [n PANMIXISES or PANMIXES]\n",
  "PANMIXISES": "PANMIXIS, (Greek) random mating within a breeding population, also PANMIXIA [n]\n",
  "PANNAGE": "the right to pasture swine in a forest [n -S]\n",
  "PANNAGES": "PANNAGE, the right to pasture swine in a forest [n]\n",
  "PANNE": "(French) a heavy lustrous silk or rayon with a waxy feel [n -S]\n",
  "PANNED": "PAN, to criticize harshly [v]\n",
  "PANNELLED": "(Shakespeare) conjectured to be a misprint for spanielled [adj]\n",
  "PANNER": "one who pans for gold [n -S]\n",
  "PANNERS": "PANNER, one who pans for gold [n]\n",
  "PANNES": "PANNE, (French) a heavy lustrous silk or rayon with a waxy feel [n]\n",
  "PANNI": "PANNUS, (Latin) a layer of vascular fibrous tissue extending over the surface of a specialized structure, esp the cornea [n]\n",
  "PANNICK": "any grass of the genus Panicum, that includes millet, also PANICK, PANICUM [n -S]\n",
  "PANNICKS": "PANNICK, any grass of the genus Panicum, that includes millet, also PANICK, PANICUM [n]\n",
  "PANNICLE": "a thin, sheetlike garment, also PANNICULUS, PANNIKEL [n -S]\n",
  "PANNICLES": "PANNICLE, a thin, sheetlike garment, also PANNICULUS, PANNIKEL [n]\n",
  "PANNICULUS": "a thin, sheetlike garment, also PANNICLE, PANNIKEL [n -ES]\n",
  "PANNICULUSES": "PANNICULUS, a thin, sheetlike garment, also PANNICLE, PANNIKEL [n]\n",
  "PANNIER": "a large basket, also PANIER [n -S]\n",
  "PANNIERED": "fitted with panniers, baskets carried over the back [adj]\n",
  "PANNIERS": "PANNIER, a large basket, also PANIER [n]\n",
  "PANNIKEL": "(obsolete) a thin, sheetlike garment, also PANNICLE, PANNICULUS [n -S]\n",
  "PANNIKELL": "(Spenser) the skull [n -S]\n",
  "PANNIKELLS": "PANNIKELL, (Spenser) the skull [n]\n",
  "PANNIKELS": "PANNIKEL, (obsolete) a thin, sheetlike garment, also PANNICLE, PANNICULUS [n]\n",
  "PANNIKIN": "a small metal cup [n -S]\n",
  "PANNIKINS": "PANNIKIN, a small metal cup [n]\n",
  "PANNING": "harsh criticism [n -S]\n",
  "PANNINGS": "PANNING, harsh criticism [n]\n",
  "PANNIST": "a person who plays a steel drum [n -S]\n",
  "PANNISTS": "PANNIST, a person who plays a steel drum [n]\n",
  "PANNOSE": "like felt [adj]\n",
  "PANNUS": "(Latin) a layer of vascular fibrous tissue extending over the surface of a specialized structure, esp the cornea [n PANNUSES or PANNI]\n",
  "PANNUSES": "PANNUS, (Latin) a layer of vascular fibrous tissue extending over the surface of a specialized structure, esp the cornea [n]\n",
  "PANOCHA": "(Spanish) a type of fudge, also PANOCHE, PENOCHE, PENUCHE, PENUCHI [n -S]\n",
  "PANOCHAS": "PANOCHA, (Spanish) a type of fudge, also PANOCHE, PENOCHE, PENUCHE, PENUCHI [n]\n",
  "PANOCHE": "(Spanish) a type of fudge, also PANOCHA, PENOCHE, PENUCHE, PENUCHI [n -S]\n",
  "PANOCHES": "PANOCHE, (Spanish) a type of fudge, also PANOCHA, PENOCHE, PENUCHE, PENUCHI [n]\n",
  "PANOISTIC": "of an ovary, producing ova only, not yolk-forming cells, as opposed to meroistic [adj]\n",
  "PANOMPHAEAN": "all-oracular [adj]\n",
  "PANOPHOBIA": "the morbid fear of everything, also PANTOPHOBIA [n -S]\n",
  "PANOPHOBIAS": "PANOPHOBIA, the morbid fear of everything, also PANTOPHOBIA [n]\n",
  "PANOPHTHALMIA": "inflammation of the whole eye, also PANOPHTHALMITIS [n -S]\n",
  "PANOPHTHALMIAS": "PANOPHTHALMIA, inflammation of the whole eye, also PANOPHTHALMITIS [n]\n",
  "PANOPHTHALMITIS": "inflammation of the whole eye, also PANOPHTHALMIA [n]\n",
  "PANOPLIED": "arrayed in full armour [adj]\n",
  "PANOPLIES": "PANOPLY, an impressive, dazzling, or ostentatious array [n]\n",
  "PANOPLY": "an impressive, dazzling, or ostentatious array [n PANOPLIES]\n",
  "PANOPTIC": "all-embracing; viewing all aspects, also PANOPTICAL [adj PANOPTICALLY]\n",
  "PANOPTICAL": "all-embracing; viewing all aspects, also PANOPTIC [adj PANOPTICALLY]\n",
  "PANOPTICALLY": "PANOPTICAL, all-embracing; viewing all aspects, also PANOPTIC [adv]\n",
  "PANOPTICON": "a prison in which all prisoners can be watched from one point [n -S]\n",
  "PANOPTICONS": "PANOPTICON, a prison in which all prisoners can be watched from one point [n]\n",
  "PANORAMA": "a wide or complete view [n -S]\n",
  "PANORAMAS": "PANORAMA, a wide or complete view [n]\n",
  "PANORAMIC": "relating to a panorama, a wide or complete view [adj PANORAMICALLY]\n",
  "PANORAMICALLY": "PANORAMIC, relating to a panorama, a wide or complete view [adv]\n",
  "PANPHARMACON": "a universal remedy [n -S]\n",
  "PANPHARMACONS": "PANPHARMACON, a universal remedy [n]\n",
  "PANPIPE": "a musical instrument [n -S]\n",
  "PANPIPES": "PANPIPE, a musical instrument [n]\n",
  "PANPSYCHISM": "the theory that all nature has a psychic side [n -S]\n",
  "PANPSYCHISMS": "PANPSYCHISM, the theory that all nature has a psychic side [n]\n",
  "PANPSYCHIST": "a believer in panpsychism [n -S]\n",
  "PANPSYCHISTIC": "relating to panpsychism, the theory that all nature has a psychic side [adj]\n",
  "PANPSYCHISTS": "PANPSYCHIST, a believer in panpsychism [n]\n",
  "PANRADIOMETER": "an instrument used for measuring radiant heat independently of wavelength [n -S]\n",
  "PANRADIOMETERS": "PANRADIOMETER, an instrument used for measuring radiant heat independently of wavelength [n]\n",
  "PANS": "PAN, to criticize harshly [v]\n",
  "PANSEXUAL": "relating to pansexualism, the view that mental activity is derived from the sexual instinct [adj] / an adherent of this [n -S]\n",
  "PANSEXUALISM": "the theory that all thought derives from the sexual instinct [n -S]\n",
  "PANSEXUALISMS": "PANSEXUALISM, the theory that all thought derives from the sexual instinct [n]\n",
  "PANSEXUALIST": "a believer in pansexualism [n -S]\n",
  "PANSEXUALISTS": "PANSEXUALIST, a believer in pansexualism [n]\n",
  "PANSEXUALITIES": "PANSEXUALITY, the state of being pansexual [n]\n",
  "PANSEXUALITY": "the state of being pansexual [n PANSEXUALITIES]\n",
  "PANSEXUALS": "PANSEXUAL, an adherent of this [n]\n",
  "PANSIED": "bedecked with pansies [adj]\n",
  "PANSIES": "PANSY, a name for various species of violet, also PANCE, PAUNCE, PAWNCE [n]\n",
  "PANSOPHIC": "relating to pansophy, knowledge of everything, also PANSOPHICAL [adj PANSOPHICALLY]\n",
  "PANSOPHICAL": "relating to pansophy, knowledge of everything, also PANSOPHIC [adj PANSOPHICALLY]\n",
  "PANSOPHICALLY": "PANSOPHICAL, relating to pansophy, knowledge of everything, also PANSOPHIC [adv]\n",
  "PANSOPHIES": "PANSOPHY, (Greek) universal knowledge [n]\n",
  "PANSOPHISM": "the claim to know everything [n -S]\n",
  "PANSOPHISMS": "PANSOPHISM, the claim to know everything [n]\n",
  "PANSOPHIST": "one who claims to know everything [n -S]\n",
  "PANSOPHISTS": "PANSOPHIST, one who claims to know everything [n]\n",
  "PANSOPHY": "(Greek) universal knowledge [n PANSOPHIES]\n",
  "PANSPERMATIC": "relating to panspermia [adj]\n",
  "PANSPERMATISM": "the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMIA, PANSPERMISM, PANSPERMY [n -S]\n",
  "PANSPERMATISMS": "PANSPERMATISM, the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMIA, PANSPERMISM, PANSPERMY [n]\n",
  "PANSPERMATIST": "a believer in panspermia [n -S]\n",
  "PANSPERMATISTS": "PANSPERMATIST, a believer in panspermia [n]\n",
  "PANSPERMIA": "(Greek) the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMATISM, PANSPERMISM, PANSPERMY [n -S]\n",
  "PANSPERMIAS": "PANSPERMIA, (Greek) the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMATISM, PANSPERMISM, PANSPERMY [n]\n",
  "PANSPERMIC": "of or pertaining to panspermy; as, the panspermic hypothesis [adj]\n",
  "PANSPERMIES": "PANSPERMY, the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMATISM, PANSPERMIA, PANSPERMISM [n]\n",
  "PANSPERMISM": "the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMATISM, PANSPERMIA, PANSPERMY [n -S]\n",
  "PANSPERMISMS": "PANSPERMISM, the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMATISM, PANSPERMIA, PANSPERMY [n]\n",
  "PANSPERMIST": "a believer in panspermism [n -S]\n",
  "PANSPERMISTS": "PANSPERMIST, a believer in panspermism [n]\n",
  "PANSPERMY": "the theory that life could be diffused through the universe by means of germs carried by meteorites, also PANSPERMATISM, PANSPERMIA, PANSPERMISM [n PANSPERMIES]\n",
  "PANSTICK": "foundation makeup like pancake makeup but in stick form [n -S]\n",
  "PANSTICKS": "PANSTICK, foundation makeup like pancake makeup but in stick form [n]\n",
  "PANSY": "a name for various species of violet, also PANCE, PAUNCE, PAWNCE [n PANSIES]\n",
  "PANT": "to breathe quickly and with difficulty [v -ED, -ING, -S]\n",
  "PANTABLE": "a slipper, an overshoe, also PANTOFFLE, PANTOFLE, PANTOUFLE [n -S]\n",
  "PANTABLES": "PANTABLE, a slipper, an overshoe, also PANTOFFLE, PANTOFLE, PANTOUFLE [n]\n",
  "PANTAGAMIES": "PANTAGAMY, marriage in which all spouses are held in common [n]\n",
  "PANTAGAMY": "marriage in which all spouses are held in common [n PANTAGAMIES]\n",
  "PANTAGRAPH": "a jointed framework of rods, based on the geometry of a parallelogram, for copying drawings, plans, etc., also PANTOGRAPH [n -S]\n",
  "PANTAGRAPHS": "PANTAGRAPH, a jointed framework of rods, based on the geometry of a parallelogram, for copying drawings, plans, etc., also PANTOGRAPH [n]\n",
  "PANTALEON": "a kind of large dulcimer with one or two hundred strings of metal and gut [n -S]\n",
  "PANTALEONS": "PANTALEON, a kind of large dulcimer with one or two hundred strings of metal and gut [n]\n",
  "PANTALET": "long underpants trimmed with ruffles [n -S]\n",
  "PANTALETS": "PANTALET, long underpants trimmed with ruffles [n]\n",
  "PANTALETTED": "wearing pantalettes, long frilled drawers [adj]\n",
  "PANTALETTES": "long drawers, usually trimmed with ruffles, extending below the skirts, also PANTALET [n]\n",
  "PANTALON": "(French) a movement in a quadrille, also PANTALONE [n -S]\n",
  "PANTALONE": "(French) a movement in a quadrille, also PANTALON [n -S]\n",
  "PANTALONES": "PANTALONE, (French) a movement in a quadrille, also PANTALON [n]\n",
  "PANTALONS": "PANTALON, (French) a movement in a quadrille, also PANTALONE [n]\n",
  "PANTALOON": "(Shakespeare) a feeble old man [n -S]\n",
  "PANTALOONED": "wearing pantaloons [adj]\n",
  "PANTALOONERIES": "PANTALOONERY, buffoonery [n]\n",
  "PANTALOONERY": "buffoonery [n PANTALOONERIES]\n",
  "PANTALOONS": "PANTALOON, (Shakespeare) a feeble old man [n]\n",
  "PANTDRESS": "a dress having a divided skirt [n -ES]\n",
  "PANTDRESSES": "PANTDRESS, a dress having a divided skirt [n]\n",
  "PANTECHNICON": "a usually enclosed wagon or motortruck used for transportation of goods or animals [n -S]\n",
  "PANTECHNICONS": "PANTECHNICON, a usually enclosed wagon or motortruck used for transportation of goods or animals [n]\n",
  "PANTED": "PANT, to breathe quickly and with difficulty [v]\n",
  "PANTER": "(Shakespeare) the officer in a great family who had charge of the bread and other provisions, also PANTLER [n -S]\n",
  "PANTERS": "PANTER, (Shakespeare) the officer in a great family who had charge of the bread and other provisions, also PANTLER [n]\n",
  "PANTHEISM": "the belief that the universe is God; belief in many gods [n -S]\n",
  "PANTHEISMS": "PANTHEISM, the belief that the universe is God; belief in many gods [n]\n",
  "PANTHEIST": "one who holds to pantheism, the belief that the universe is God [n -S]\n",
  "PANTHEISTIC": "relating to pantheism, also PANTHEISTICAL [adj PANTHEISTICALLY]\n",
  "PANTHEISTICAL": "relating to pantheism, also PANTHEISTIC [adj PANTHEISTICALLY]\n",
  "PANTHEISTICALLY": "PANTHEISTICAL, relating to pantheism, also PANTHEISTIC [adv]\n",
  "PANTHEISTS": "PANTHEIST, one who holds to pantheism, the belief that the universe is God [n]\n",
  "PANTHENOL": "a vitamin of the B-complex affecting the growth of hair [n -S]\n",
  "PANTHENOLS": "PANTHENOL, a vitamin of the B-complex affecting the growth of hair [n]\n",
  "PANTHEOLOGIES": "PANTHEOLOGY, a synthesis of all religions and the knowledge of all gods [n]\n",
  "PANTHEOLOGIST": "a specialist in pantheology [n -S]\n",
  "PANTHEOLOGISTS": "PANTHEOLOGIST, a specialist in pantheology [n]\n",
  "PANTHEOLOGY": "a synthesis of all religions and the knowledge of all gods [n PANTHEOLOGIES]\n",
  "PANTHEON": "(Greek) a temple dedicated to all the gods [n -S]\n",
  "PANTHEONS": "PANTHEON, (Greek) a temple dedicated to all the gods [n]\n",
  "PANTHER": "a leopard, esp. a black one [n -S]\n",
  "PANTHERESS": "a female panther [n -ES]\n",
  "PANTHERESSES": "PANTHERESS, a female panther [n]\n",
  "PANTHERINE": "like a panther, esp. in color; as, the pantherine snake of Brazil [adj]\n",
  "PANTHERISH": "like a panther [adj]\n",
  "PANTHERS": "PANTHER, a leopard, esp. a black one [n]\n",
  "PANTIE": "a woman's or child's undergarment, also PANTY [n -S]\n",
  "PANTIES": "PANTIE, a woman's or child's undergarment, also PANTY [n]\n",
  "PANTIHOSE": "tights worn by women or children with ordinary dress, also PANTYHOSE [n -S]\n",
  "PANTIHOSES": "PANTIHOSE, tights worn by women or children with ordinary dress, also PANTYHOSE [n]\n",
  "PANTILE": "an overlapping, S-shaped roofing tile [n -S]\n",
  "PANTILED": "roofed with pantiles [adj]\n",
  "PANTILES": "PANTILE, an overlapping, S-shaped roofing tile [n]\n",
  "PANTILING": "pantiles collectively [n -S]\n",
  "PANTILINGS": "PANTILING, pantiles collectively [n]\n",
  "PANTINE": "(obsolete) a pasteboard jumping-jack, fashionable in the 18th century [n -S]\n",
  "PANTINES": "PANTINE, (obsolete) a pasteboard jumping-jack, fashionable in the 18th century [n]\n",
  "PANTING": "breathless [adj PANTINGLY] / the act of panting [n -S]\n",
  "PANTINGLY": "PANTING, breathless [adv]\n",
  "PANTINGS": "PANTING, the act of panting [n]\n",
  "PANTISOCRACIES": "PANTISOCRACY, government by all equally [n]\n",
  "PANTISOCRACY": "government by all equally [n PANTISOCRACIES]\n",
  "PANTISOCRAT": "a member of a pantisocracy [n -S]\n",
  "PANTISOCRATIC": "relating to pantisocracy, also PANTISOCRATICAL [adj]\n",
  "PANTISOCRATICAL": "relating to pantisocracy, also PANTISOCRATIC [adj]\n",
  "PANTISOCRATIST": "an upholder of pantisocracy, government by all equally [n -S]\n",
  "PANTISOCRATISTS": "PANTISOCRATIST, an upholder of pantisocracy, government by all equally [n]\n",
  "PANTISOCRATS": "PANTISOCRAT, a member of a pantisocracy [n]\n",
  "PANTLEG": "the leg part of a pair of trousers or pants [n -S]\n",
  "PANTLEGS": "PANTLEG, the leg part of a pair of trousers or pants [n]\n",
  "PANTLER": "(Shakespeare) the officer in a great family who had charge of the bread and other provisions, also PANTER [n -S]\n",
  "PANTLERS": "PANTLER, (Shakespeare) the officer in a great family who had charge of the bread and other provisions, also PANTER [n]\n",
  "PANTO": "(short for) pantomime [n -S]\n",
  "PANTOFFLE": "a slipper, an overshoe, also PANTABLE, PANTOFLE, PANTOUFLE [n -S]\n",
  "PANTOFFLES": "PANTOFFLE, a slipper, an overshoe, also PANTABLE, PANTOFLE, PANTOUFLE [n]\n",
  "PANTOFLE": "a slipper, an overshoe, also PANTABLE, PANTOFFLE, PANTOUFLE [n -S]\n",
  "PANTOFLES": "PANTOFLE, a slipper, an overshoe, also PANTABLE, PANTOFFLE, PANTOUFLE [n]\n",
  "PANTOGRAPH": "a jointed framework of rods, based on the geometry of a parallelogram, for copying drawings, plans, etc., also PANTAGRAPH [n -S]\n",
  "PANTOGRAPHER": "one who uses a pantograph [n -S]\n",
  "PANTOGRAPHERS": "PANTOGRAPHER, one who uses a pantograph [n]\n",
  "PANTOGRAPHIC": "relating to pantography, also PANTOGRAPHICAL [adj]\n",
  "PANTOGRAPHICAL": "relating to pantography, also PANTOGRAPHIC [adj]\n",
  "PANTOGRAPHIES": "PANTOGRAPHY, copying by the use of a pantograph [n]\n",
  "PANTOGRAPHS": "PANTOGRAPH, a jointed framework of rods, based on the geometry of a parallelogram, for copying drawings, plans, etc., also PANTAGRAPH [n]\n",
  "PANTOGRAPHY": "copying by the use of a pantograph [n PANTOGRAPHIES]\n",
  "PANTOMIME": "a type of theatrical entertainment [n -S] / to portray or communicate by exaggerated silent gestures or expressions [v PANTOMIMED, PANTOMIMING, PANTOMIMES]\n",
  "PANTOMIMED": "PANTOMIME, to portray or communicate by exaggerated silent gestures or expressions [v]\n",
  "PANTOMIMES": "PANTOMIME, to portray or communicate by exaggerated silent gestures or expressions [v]\n",
  "PANTOMIMIC": "like a pantomime, also PANTOMIMICAL [adj PANTOMIMICALLY]\n",
  "PANTOMIMICAL": "like a pantomime, also PANTOMIMIC [adj PANTOMIMICALLY]\n",
  "PANTOMIMICALLY": "PANTOMIMICAL, like a pantomime, also PANTOMIMIC [adv]\n",
  "PANTOMIMING": "PANTOMIME, to portray or communicate by exaggerated silent gestures or expressions [v]\n",
  "PANTOMIMIST": "an actor or dancer in pantomimes [n -S]\n",
  "PANTOMIMISTS": "PANTOMIMIST, an actor or dancer in pantomimes [n]\n",
  "PANTON": "(Scots) a slipper [n -S]\n",
  "PANTONS": "PANTON, (Scots) a slipper [n]\n",
  "PANTOPHAGIES": "PANTOPHAGY, omnivorousness [n]\n",
  "PANTOPHAGIST": "an omnivore [n -S]\n",
  "PANTOPHAGISTS": "PANTOPHAGIST, an omnivore [n]\n",
  "PANTOPHAGOUS": "eating or requiring a variety of foods [adj]\n",
  "PANTOPHAGY": "omnivorousness [n PANTOPHAGIES]\n",
  "PANTOPHOBIA": "the morbid fear of everything, also PANOPHOBIA [n -S]\n",
  "PANTOPHOBIAS": "PANTOPHOBIA, the morbid fear of everything, also PANOPHOBIA [n]\n",
  "PANTOPRAGMATIC": "meddling in everybody's business [adj]\n",
  "PANTOPRAGMATICS": "the science of universal benevolent interference [n]\n",
  "PANTOS": "PANTO, (short for) pantomime [n]\n",
  "PANTOSCOPE": "a panoramic camera [n -S]\n",
  "PANTOSCOPES": "PANTOSCOPE, a panoramic camera [n]\n",
  "PANTOSCOPIC": "of or like a pantoscope, a panoramic camera [adj]\n",
  "PANTOTHENATE": "a salt or ester of pantothenic acid [n -S]\n",
  "PANTOTHENATES": "PANTOTHENATE, a salt or ester of pantothenic acid [n]\n",
  "PANTOTHENIC": "denoting an acid which is a growth-promoting vitamin of vitamin B complex [adj]\n",
  "PANTOUFLE": "a slipper, an overshoe, also PANTABLE, PANTOFFLE, PANTOFLE [n -S]\n",
  "PANTOUFLES": "PANTOUFLE, a slipper, an overshoe, also PANTABLE, PANTOFFLE, PANTOFLE [n]\n",
  "PANTOUM": "(Malay) a Malayan verse form [n -S]\n",
  "PANTOUMS": "PANTOUM, (Malay) a Malayan verse form [n]\n",
  "PANTRIES": "PANTRY, a small room or a cupboard in which provisions, crockery, cutlery, table linen, etc., are kept [n]\n",
  "PANTROPIC": "occurring or distributed throughout the tropical regions of the earth, also PANTROPICAL [adj]\n",
  "PANTROPICAL": "occurring or distributed throughout the tropical regions of the earth, also PANTROPIC [adj]\n",
  "PANTRY": "a small room or a cupboard in which provisions, crockery, cutlery, table linen, etc., are kept [n PANTRIES]\n",
  "PANTRYMAID": "a maid in charge of a pantry [n -S]\n",
  "PANTRYMAIDS": "PANTRYMAID, a maid in charge of a pantry [n]\n",
  "PANTRYMAN": "one who looks after a pantry [n PANTRYMEN]\n",
  "PANTRYMEN": "PANTRYMAN, one who looks after a pantry [n]\n",
  "PANTS": "PANT, to breathe quickly and with difficulty [v]\n",
  "PANTSUIT": "a woman's suit with trousers [n -S]\n",
  "PANTSUITED": "wearing a pantsuit [adj]\n",
  "PANTSUITS": "PANTSUIT, a woman's suit with trousers [n]\n",
  "PANTUN": "(Malay) a Malayan verse form, also PANTOUM [n -S]\n",
  "PANTUNS": "PANTUN, (Malay) a Malayan verse form, also PANTOUM [n]\n",
  "PANTY": "a woman's or child's undergarment, also PANTIE [n PANTIES]\n",
  "PANTYHOSE": "tights worn by women or children with ordinary dress, also PANTIHOSE [n -S]\n",
  "PANTYHOSES": "PANTYHOSE, tights worn by women or children with ordinary dress, also PANTIHOSE [n]\n",
  "PANTYWAIST": "an effeminate or cowardly man [n -S]\n",
  "PANTYWAISTS": "PANTYWAIST, an effeminate or cowardly man [n]\n",
  "PANZER": "(German) a German tank [n -S]\n",
  "PANZEROTTI": "PANZEROTTO, (Canadian) a baked turnover with a folded, sealed pocket containing tomato, cheese, and sometimes other fillings [n]\n",
  "PANZEROTTO": "(Canadian) a baked turnover with a folded, sealed pocket containing tomato, cheese, and sometimes other fillings [n PANZEROTTI or PANZEROTTOS]\n",
  "PANZEROTTOS": "PANZEROTTO, (Canadian) a baked turnover with a folded, sealed pocket containing tomato, cheese, and sometimes other fillings [n]\n",
  "PANZERS": "PANZER, (German) a German tank [n]\n",
  "PANZOOTIC": "affecting all the animals in a given area [adj] / a panzootic disease [n -S]\n",
  "PANZOOTICS": "PANZOOTIC, a panzootic disease [n]\n",
  "PAOLI": "PAOLO, (Italian) an obsolete papal coin, also PAUL [n]\n",
  "PAOLO": "(Italian) an obsolete papal coin, also PAUL [n PAOLI]\n",
  "PAP": "to feed with soft mash [v PAPPED, PAPPING, PAPS]\n",
  "PAPA": "a father [n -S]\n",
  "PAPABLE": "capable of being a pope [adj]\n",
  "PAPACIES": "PAPACY, the office of the pope [n]\n",
  "PAPACY": "the office of the pope [n PAPACIES]\n",
  "PAPADAM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "PAPADAMS": "PAPADAM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "PAPADOM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "PAPADOMS": "PAPADOM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "PAPADUM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "PAPADUMS": "PAPADUM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "PAPAIN": "an enzyme that digests proteins, found in papaws [n -S]\n",
  "PAPAINS": "PAPAIN, an enzyme that digests proteins, found in papaws [n]\n",
  "PAPAL": "of or relating to the Pope or the papacy [adj PAPALLY]\n",
  "PAPALISE": "to render papal, also PAPALIZE [v PAPALISED, PAPALISING, PAPALISES]\n",
  "PAPALISED": "PAPALISE, to render papal, also PAPALIZE [v]\n",
  "PAPALISES": "PAPALISE, to render papal, also PAPALIZE [v]\n",
  "PAPALISING": "PAPALISE, to render papal, also PAPALIZE [v]\n",
  "PAPALISM": "the papal system [n -S]\n",
  "PAPALISMS": "PAPALISM, the papal system [n]\n",
  "PAPALIST": "a supporter of the pope [n -S]\n",
  "PAPALISTS": "PAPALIST, a supporter of the pope [n]\n",
  "PAPALIZE": "to render papal, also PAPALISE [v PAPALIZED, PAPALIZING, PAPALIZES]\n",
  "PAPALIZED": "PAPALIZE, to render papal, also PAPALISE [v]\n",
  "PAPALIZES": "PAPALIZE, to render papal, also PAPALISE [v]\n",
  "PAPALIZING": "PAPALIZE, to render papal, also PAPALISE [v]\n",
  "PAPALLY": "PAPAL, of or relating to the Pope or the papacy [adv]\n",
  "PAPAPRELATIST": "(Scott) a supporter of popish prelates [n -S]\n",
  "PAPAPRELATISTS": "PAPAPRELATIST, (Scott) a supporter of popish prelates [n]\n",
  "PAPARAZZI": "PAPARAZZO, (Italian) a photographer who pursues celebrities [n]\n",
  "PAPARAZZO": "(Italian) a photographer who pursues celebrities [n PAPARAZZI]\n",
  "PAPAS": "PAPA, a father [n]\n",
  "PAPASAN": "a chair shaped like a boat [n -S]\n",
  "PAPASANS": "PAPASAN, a chair shaped like a boat [n]\n",
  "PAPAUMA": "(Maori) a large evergreen tree of New Zealand [n -S]\n",
  "PAPAUMAS": "PAPAUMA, (Maori) a large evergreen tree of New Zealand [n]\n",
  "PAPAVER": "a genus of poppies including over 120 species [n -S]\n",
  "PAPAVERACEOUS": "pertaining to or like a poppy; belonging to the poppy family of plants [adj]\n",
  "PAPAVERINE": "an alkaloid derived from poppy juice and used medicinally [n -S]\n",
  "PAPAVERINES": "PAPAVERINE, an alkaloid derived from poppy juice and used medicinally [n]\n",
  "PAPAVEROUS": "of or relating to poppies [adj]\n",
  "PAPAVERS": "PAPAVER, a genus of poppies including over 120 species [n]\n",
  "PAPAW": "a tree of the custard-apple family; its fruit, also PAPAYA, PAWPAW [n -S]\n",
  "PAPAWS": "PAPAW, a tree of the custard-apple family; its fruit, also PAPAYA, PAWPAW [n]\n",
  "PAPAYA": "(Spanish) a tree of the custard-apple family; its fruit, also PAPAW, PAWPAW [n -S]\n",
  "PAPAYAN": "like a papaya [adj]\n",
  "PAPAYAS": "PAPAYA, (Spanish) a tree of the custard-apple family; its fruit, also PAPAW, PAWPAW [n]\n",
  "PAPE": "(Scots) a pope [n -S]\n",
  "PAPER": "to cover with a thin sheet material made of cellulose pulp [v -ED, -ING, -S]\n",
  "PAPERBACK": "a book with a flexible paper cover [n -S] / to bring out in paperback [v -ED, -ING, -S]\n",
  "PAPERBACKED": "PAPERBACK, to bring out in paperback [v]\n",
  "PAPERBACKER": "one who publishes in paperback [n -S]\n",
  "PAPERBACKERS": "PAPERBACKER, one who publishes in paperback [n]\n",
  "PAPERBACKING": "PAPERBACK, to bring out in paperback [v]\n",
  "PAPERBACKS": "PAPERBACK, to bring out in paperback [v]\n",
  "PAPERBARK": "an Australian tree with spear-shaped leaves and a papery bark [n -S]\n",
  "PAPERBARKS": "PAPERBARK, an Australian tree with spear-shaped leaves and a papery bark [n]\n",
  "PAPERBOARD": "a type of strong thick cardboard; pasteboard [n -S]\n",
  "PAPERBOARDS": "PAPERBOARD, a type of strong thick cardboard; pasteboard [n]\n",
  "PAPERBOUND": "a book bound in paper rather than hardback [n -S]\n",
  "PAPERBOUNDS": "PAPERBOUND, a book bound in paper rather than hardback [n]\n",
  "PAPERBOY": "a newsboy [n -S]\n",
  "PAPERBOYS": "PAPERBOY, a newsboy [n]\n",
  "PAPERCLIP": "a bent wire clip for holding papers together [n -S]\n",
  "PAPERCLIPS": "PAPERCLIP, a bent wire clip for holding papers together [n]\n",
  "PAPERED": "PAPER, to cover with a thin sheet material made of cellulose pulp [v]\n",
  "PAPERER": "one who papers [n -S]\n",
  "PAPERERS": "PAPERER, one who papers [n]\n",
  "PAPERGIRL": "a female paperboy [n -S]\n",
  "PAPERGIRLS": "PAPERGIRL, a female paperboy [n]\n",
  "PAPERHANGER": "one that applies wallpaper [n -S]\n",
  "PAPERHANGERS": "PAPERHANGER, one that applies wallpaper [n]\n",
  "PAPERHANGING": "decorative paper used for covering interior walls [n -S]\n",
  "PAPERHANGINGS": "PAPERHANGING, decorative paper used for covering interior walls [n]\n",
  "PAPERIER": "PAPERY, resembling paper [adj]\n",
  "PAPERIEST": "PAPERY, resembling paper [adj]\n",
  "PAPERINESS": "the state of being papery [n -ES]\n",
  "PAPERINESSES": "PAPERINESS, the state of being papery [n]\n",
  "PAPERING": "the act of covering with paper [n -S]\n",
  "PAPERINGS": "PAPERING, the act of covering with paper [n]\n",
  "PAPERKNIFE": "a knife for cutting paper [n PAPERKNIVES]\n",
  "PAPERKNIVES": "PAPERKNIFE, a knife for cutting paper [n]\n",
  "PAPERLESS": "using esp. electronic means instead of paper for communication, recording, etc. [adj]\n",
  "PAPERMAKER": "one that makes paper [n -S]\n",
  "PAPERMAKERS": "PAPERMAKER, one that makes paper [n]\n",
  "PAPERMAKING": "the business of making paper [n -S]\n",
  "PAPERMAKINGS": "PAPERMAKING, the business of making paper [n]\n",
  "PAPERS": "PAPER, to cover with a thin sheet material made of cellulose pulp [v]\n",
  "PAPERWARE": "articles made of paper [n -S]\n",
  "PAPERWARES": "PAPERWARE, articles made of paper [n]\n",
  "PAPERWEIGHT": "a usually small heavy object used to hold down loose papers [n -S]\n",
  "PAPERWEIGHTS": "PAPERWEIGHT, a usually small heavy object used to hold down loose papers [n]\n",
  "PAPERWORK": "clerical work; the keeping of records as part of a job [n -S]\n",
  "PAPERWORKS": "PAPERWORK, clerical work; the keeping of records as part of a job [n]\n",
  "PAPERY": "resembling paper [adj PAPERIER, PAPERIEST]\n",
  "PAPES": "PAPE, (Scots) a pope [n]\n",
  "PAPETERIE": "(French) a stationery-case [n -S]\n",
  "PAPETERIES": "PAPETERIE, (French) a stationery-case [n]\n",
  "PAPHIAN": "a prostitute [n -S]\n",
  "PAPHIANS": "PAPHIAN, a prostitute [n]\n",
  "PAPILIO": "(Latin) a type of butterfly [n -S]\n",
  "PAPILIONACEOUS": "resembling the butterfly; having a winged corolla somewhat resembling a butterfly, as in the blossoms of the bean and pea [adj]\n",
  "PAPILIOS": "PAPILIO, (Latin) a type of butterfly [n]\n",
  "PAPILLA": "(Latin) a nipple-like projection [n PAPILLAE]\n",
  "PAPILLAE": "PAPILLA, (Latin) a nipple-like projection [n]\n",
  "PAPILLAR": "like, of the nature of, or having, papillae, also PAPILLARY [adj]\n",
  "PAPILLARY": "like, of the nature of, or having, papillae, also PAPILLAR [adj]\n",
  "PAPILLATE": "having papillae, nipple-like projections, also PAPILLATED [adj]\n",
  "PAPILLATED": "having papillae, nipple-like projections, also PAPILLATE [adj]\n",
  "PAPILLIFEROUS": "bearing papillae [adj]\n",
  "PAPILLIFORM": "nipple-shaped [adj]\n",
  "PAPILLITIS": "inflammation of the head of the optic nerve [n -ES]\n",
  "PAPILLITISES": "PAPILLITIS, inflammation of the head of the optic nerve [n]\n",
  "PAPILLOMA": "a tumour formed by hypertrophy of a papilla or papillae, such as a wart, etc. [n PAPILLOMAS or PAPILLOMATA]\n",
  "PAPILLOMAS": "PAPILLOMA, a tumour formed by hypertrophy of a papilla or papillae, such as a wart, etc. [n]\n",
  "PAPILLOMATA": "PAPILLOMA, a tumour formed by hypertrophy of a papilla or papillae, such as a wart, etc. [n]\n",
  "PAPILLOMATOSES": "PAPILLOMATOSIS, the condition of having papillomata [n]\n",
  "PAPILLOMATOSIS": "the condition of having papillomata [n PAPILLOMATOSES]\n",
  "PAPILLOMATOUS": "of or like a papilloma [adj]\n",
  "PAPILLOMAVIRUS": "any of a genus of double-stranded DNA viruses that cause papillomas and are sometimes associated with human cancers of the genital tract and esp. of the cervix [n]\n",
  "PAPILLON": "(French) a breed of toy spaniel with erect ears [n -S]\n",
  "PAPILLONS": "PAPILLON, (French) a breed of toy spaniel with erect ears [n]\n",
  "PAPILLOSE": "covered with papules or papillae, also PAPILLOUS [adj]\n",
  "PAPILLOTE": "(French) a paper frill decorating the end of a cutlet or other bone [n -S]\n",
  "PAPILLOTES": "PAPILLOTE, (French) a paper frill decorating the end of a cutlet or other bone [n]\n",
  "PAPILLOUS": "covered with papules or papillae, also PAPILLOSE [adj]\n",
  "PAPILLULATE": "finely papillose [adj]\n",
  "PAPILLULE": "a small papilla, a nipple-like projection [n -S]\n",
  "PAPILLULES": "PAPILLULE, a small papilla, a nipple-like projection [n]\n",
  "PAPISH": "a supporter of the Pope, also PAPISHER, PAPIST [n -ES]\n",
  "PAPISHER": "a supporter of the pope, also PAPISH, PAPIST [n -S]\n",
  "PAPISHERS": "PAPISHER, a supporter of the pope, also PAPISH, PAPIST [n]\n",
  "PAPISHES": "PAPISH, a supporter of the Pope, also PAPISHER, PAPIST [n]\n",
  "PAPISM": "adherence to the Pope [n -S]\n",
  "PAPISMS": "PAPISM, adherence to the Pope [n]\n",
  "PAPIST": "a supporter of the Pope, also PAPISH, PAPISHER [n -S]\n",
  "PAPISTIC": "relating to popery, also PAPISTICAL [adj PAPISTICALLY]\n",
  "PAPISTICAL": "relating to popery, also PAPISTIC [adj PAPISTICALLY]\n",
  "PAPISTICALLY": "PAPISTICAL, relating to popery, also PAPISTIC [adv]\n",
  "PAPISTRIES": "PAPISTRY, roman Catholicism [n]\n",
  "PAPISTRY": "roman Catholicism [n PAPISTRIES]\n",
  "PAPISTS": "PAPIST, a supporter of the Pope, also PAPISH, PAPISHER [n]\n",
  "PAPOOSE": "(Native American) a baby, also PAPPOOSE [n -S]\n",
  "PAPOOSES": "PAPOOSE, (Native American) a baby, also PAPPOOSE [n]\n",
  "PAPOVAVIRUS": "any of a group of DNA-containing oncogenic viruses [n -ES]\n",
  "PAPOVAVIRUSES": "PAPOVAVIRUS, any of a group of DNA-containing oncogenic viruses [n]\n",
  "PAPPADAM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "PAPPADAMS": "PAPPADAM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "PAPPADOM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "PAPPADOMS": "PAPPADOM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADUM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "PAPPADUM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "PAPPADUMS": "PAPPADUM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, POPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "PAPPARDELLE": "a type of pasta in the form of broad ribbons [n -S]\n",
  "PAPPARDELLES": "PAPPARDELLE, a type of pasta in the form of broad ribbons [n]\n",
  "PAPPED": "PAP, to feed with soft mash [v]\n",
  "PAPPI": "PAPPUS, (Latin) a ring of downy hair on a seed [n]\n",
  "PAPPIER": "PAPPY, resembling pap [adj]\n",
  "PAPPIES": "PAPPY, a father [n]\n",
  "PAPPIEST": "PAPPY, resembling pap [adj]\n",
  "PAPPING": "PAP, to feed with soft mash [v]\n",
  "PAPPOOSE": "(Native American) a baby, also PAPOOSE [n -S]\n",
  "PAPPOOSES": "PAPPOOSE, (Native American) a baby, also PAPOOSE [n]\n",
  "PAPPOSE": "furnished with a pappus; downy, also PAPPOUS [adj]\n",
  "PAPPOUS": "furnished with a pappus; downy, also PAPPOSE [adj]\n",
  "PAPPUS": "(Latin) a ring of downy hair on a seed [n PAPPUSES or PAPPI]\n",
  "PAPPUSES": "PAPPUS, (Latin) a ring of downy hair on a seed [n]\n",
  "PAPPY": "a father [n PAPPIES] / resembling pap [adj PAPPIER, PAPPIEST]\n",
  "PAPRICA": "(Hungarian) a seasoning made from red peppers, also PAPRIKA [n -S]\n",
  "PAPRICAS": "PAPRICA, (Hungarian) a seasoning made from red peppers, also PAPRIKA [n]\n",
  "PAPRIKA": "(Hungarian) a seasoning made from red peppers, also PAPRICA [n -S]\n",
  "PAPRIKAS": "a chicken dish of Hungarian origin, also PAPRIKASH [n -ES]\n",
  "PAPRIKASES": "PAPRIKAS, a chicken dish of Hungarian origin, also PAPRIKASH [n]\n",
  "PAPRIKASH": "a chicken dish of Hungarian origin, also PAPRIKAS [n -ES]\n",
  "PAPRIKASHES": "PAPRIKASH, a chicken dish of Hungarian origin, also PAPRIKAS [n]\n",
  "PAPS": "PAP, to feed with soft mash [v]\n",
  "PAPULA": "(Latin) a pimple, also PAPULE [n PAPULAE or PAPULAS]\n",
  "PAPULAE": "PAPULA, (Latin) a pimple, also PAPULE [n]\n",
  "PAPULAR": "pertaining to, characterized by, or of the nature of papules or pimples [adj]\n",
  "PAPULAS": "PAPULA, (Latin) a pimple, also PAPULE [n]\n",
  "PAPULATION": "the development of papillae or pimples [n -S]\n",
  "PAPULATIONS": "PAPULATION, the development of papillae or pimples [n]\n",
  "PAPULE": "a pimple, also PAPULA [n -S]\n",
  "PAPULES": "PAPULE, a pimple, also PAPULA [n]\n",
  "PAPULIFEROUS": "pimply [adj]\n",
  "PAPULOSE": "having pimples, also PAPULOUS [adj]\n",
  "PAPULOUS": "having pimples, also PAPULOSE [adj]\n",
  "PAPYRACEOUS": "like paper; papery [adj]\n",
  "PAPYRAL": "relating to a papyrus [adj]\n",
  "PAPYRI": "PAPYRUS, (Latin) a parchment made from reeds [n]\n",
  "PAPYRIAN": "like papyrus, a parchment made from reeds, also PAPYRINE [adj]\n",
  "PAPYRINE": "like papyrus, a parchment made from reeds, also PAPYRIAN [adj]\n",
  "PAPYROLOGICAL": "related to papyrology [adj]\n",
  "PAPYROLOGIES": "PAPYROLOGY, the study of paper [n]\n",
  "PAPYROLOGIST": "a student of papyrology [n -S]\n",
  "PAPYROLOGISTS": "PAPYROLOGIST, a student of papyrology [n]\n",
  "PAPYROLOGY": "the study of paper [n PAPYROLOGIES]\n",
  "PAPYRUS": "(Latin) a parchment made from reeds [n PAPYRI or PAPYRUSES]\n",
  "PAPYRUSES": "PAPYRUS, (Latin) a parchment made from reeds [n]\n",
  "PAR": "to score a certain number of golf strokes [v PARRED, PARRING, PARS]\n",
  "PARA": "(Turkish) a small Turkish coin [n PARAS] / a woman's status as regards the production of offspring [n PARAS or PARAE]\n",
  "PARABAPTISM": "uncanonical baptism [n -S]\n",
  "PARABAPTISMS": "PARABAPTISM, uncanonical baptism [n]\n",
  "PARABASES": "PARABASIS, (Greek) a speech in Greek drama where the chorus advances and addresses the audience [n]\n",
  "PARABASIS": "(Greek) a speech in Greek drama where the chorus advances and addresses the audience [n PARABASES]\n",
  "PARABEMA": "(Greek) in Byzantine architecture, a chapel walled off from the bema [n PARABEMATA]\n",
  "PARABEMATA": "PARABEMA, (Greek) in Byzantine architecture, a chapel walled off from the bema [n]\n",
  "PARABEMATIC": "of or like a parabema [adj]\n",
  "PARABEN": "any of a group of chemicals widely used as preservatives in the cosmetic and pharmaceutical industries [n -S]\n",
  "PARABENS": "PARABEN, any of a group of chemicals widely used as preservatives in the cosmetic and pharmaceutical industries [n]\n",
  "PARABIOSES": "PARABIOSIS, the fusion of two organisms, like Siamese twins or animals joined for research [n]\n",
  "PARABIOSIS": "the fusion of two organisms, like Siamese twins or animals joined for research [n PARABIOSES]\n",
  "PARABIOTIC": "relating to parabiosis [adj PARABIOTICALLY]\n",
  "PARABIOTICALLY": "PARABIOTIC, relating to parabiosis [adv]\n",
  "PARABLAST": "the yolk of an egg, such as a hen's egg, that undergoes meroblastic cleavage [n -S]\n",
  "PARABLASTIC": "like a parablast [adj]\n",
  "PARABLASTS": "PARABLAST, the yolk of an egg, such as a hen's egg, that undergoes meroblastic cleavage [n]\n",
  "PARABLE": "to represent by a moral tale [v PARABLED, PARABLING, PARABLES]\n",
  "PARABLED": "PARABLE, to represent by a moral tale [v]\n",
  "PARABLEPSES": "PARABLEPSIS, false vision; oversight, also PARABLEPSY [n]\n",
  "PARABLEPSIES": "PARABLEPSY, false vision; oversight, also PARABLEPSIS [n]\n",
  "PARABLEPSIS": "false vision; oversight, also PARABLEPSY [n PARABLEPSES]\n",
  "PARABLEPSY": "false vision; oversight, also PARABLEPSIS [n PARABLEPSIES]\n",
  "PARABLEPTIC": "relating to parablepsy, false vision; oversight [adj]\n",
  "PARABLES": "PARABLE, to represent by a moral tale [v]\n",
  "PARABLING": "PARABLE, to represent by a moral tale [v]\n",
  "PARABOLA": "(Greek) a type of curve, one of the conic sections [n PARABOLAE or PARABOLAS]\n",
  "PARABOLAE": "PARABOLA, (Greek) a type of curve, one of the conic sections [n]\n",
  "PARABOLANUS": "in the early eastern church, a layman who tends the sick [n -ES]\n",
  "PARABOLANUSES": "PARABOLANUS, in the early eastern church, a layman who tends the sick [n]\n",
  "PARABOLAS": "PARABOLA, (Greek) a type of curve, one of the conic sections [n]\n",
  "PARABOLE": "a rhetorical comparison [n -S]\n",
  "PARABOLES": "PARABOLE, a rhetorical comparison [n]\n",
  "PARABOLIC": "of or like a parabola, also PARABOLICAL [adj PARABOLICALLY]\n",
  "PARABOLICAL": "of or like a parabola, also PARABOLIC [adj PARABOLICALLY]\n",
  "PARABOLICALLY": "PARABOLICAL, of or like a parabola, also PARABOLIC [adv]\n",
  "PARABOLISATION": "the process of parabolising, also PARABOLIZATION [n -S]\n",
  "PARABOLISATIONS": "PARABOLISATION, the process of parabolising, also PARABOLIZATION [n]\n",
  "PARABOLISE": "to set forth by parable; to treat as a parable, also PARABOLIZE [v PARABOLISED, PARABOLISING, PARABOLISES]\n",
  "PARABOLISED": "PARABOLISE, to set forth by parable; to treat as a parable, also PARABOLIZE [v]\n",
  "PARABOLISES": "PARABOLISE, to set forth by parable; to treat as a parable, also PARABOLIZE [v]\n",
  "PARABOLISING": "PARABOLISE, to set forth by parable; to treat as a parable, also PARABOLIZE [v]\n",
  "PARABOLIST": "a teller of parables [n -S]\n",
  "PARABOLISTS": "PARABOLIST, a teller of parables [n]\n",
  "PARABOLIZATION": "the process of parabolizing, also PARABOLISATION [n -S]\n",
  "PARABOLIZATIONS": "PARABOLIZATION, the process of parabolizing, also PARABOLISATION [n]\n",
  "PARABOLIZE": "to set forth by parable; to treat as a parable, also PARABOLISE [v PARABOLIZED, PARABOLIZING, PARABOLIZES]\n",
  "PARABOLIZED": "PARABOLIZE, to set forth by parable; to treat as a parable, also PARABOLISE [v]\n",
  "PARABOLIZES": "PARABOLIZE, to set forth by parable; to treat as a parable, also PARABOLISE [v]\n",
  "PARABOLIZING": "PARABOLIZE, to set forth by parable; to treat as a parable, also PARABOLISE [v]\n",
  "PARABOLOID": "a surface or solid generated by the rotation of a parabola about its axis [n -S]\n",
  "PARABOLOIDAL": "of or like a paraboloid [adj]\n",
  "PARABOLOIDS": "PARABOLOID, a surface or solid generated by the rotation of a parabola about its axis [n]\n",
  "PARABRAKE": "a parachute as used to slow an aeroplane [n -S]\n",
  "PARABRAKES": "PARABRAKE, a parachute as used to slow an aeroplane [n]\n",
  "PARACASEIN": "another name for casein [n -S]\n",
  "PARACASEINS": "PARACASEIN, another name for casein [n]\n",
  "PARACENTESES": "PARACENTESIS, the tapping of body fluid [n]\n",
  "PARACENTESIS": "the tapping of body fluid [n PARACENTESES]\n",
  "PARACETAMOL": "a mild analgesic and antipyretic drug, often recommended instead of aspirin [n -S]\n",
  "PARACETAMOLS": "PARACETAMOL, a mild analgesic and antipyretic drug, often recommended instead of aspirin [n]\n",
  "PARACHOR": "a mathematical constant relating to surface tension [n -S]\n",
  "PARACHORS": "PARACHOR, a mathematical constant relating to surface tension [n]\n",
  "PARACHRONISM": "the representation of something as being newer than it is [n -S]\n",
  "PARACHRONISMS": "PARACHRONISM, the representation of something as being newer than it is [n]\n",
  "PARACHUTE": "a large fabric umbrella-like canopy, used where resistance to air is needed [n -S] / to descend by parachute [v PARACHUTED, PARACHUTING, PARACHUTES]\n",
  "PARACHUTED": "PARACHUTE, to descend by parachute [v]\n",
  "PARACHUTES": "PARACHUTE, to descend by parachute [v]\n",
  "PARACHUTIC": "relating to a parachute [adj]\n",
  "PARACHUTING": "the act of descending by parachute [n -S]\n",
  "PARACHUTINGS": "PARACHUTING, the act of descending by parachute [n]\n",
  "PARACHUTIST": "one that parachutes [n -S]\n",
  "PARACHUTISTS": "PARACHUTIST, one that parachutes [n]\n",
  "PARACLETE": "(Greek) an advocate or intercessor; the Holy Spirit acting in such a role [n -S]\n",
  "PARACLETES": "PARACLETE, (Greek) an advocate or intercessor; the Holy Spirit acting in such a role [n]\n",
  "PARACME": "(Greek) a stage of decline [n -S]\n",
  "PARACMES": "PARACME, (Greek) a stage of decline [n]\n",
  "PARACRINE": "of signalling between biological senses [adj]\n",
  "PARACROSTIC": "a poem whose initial letters reproduce its first verse [n -S]\n",
  "PARACROSTICS": "PARACROSTIC, a poem whose initial letters reproduce its first verse [n]\n",
  "PARACUSES": "PARACUSIS, disordered hearing [n]\n",
  "PARACUSIS": "disordered hearing [n PARACUSES]\n",
  "PARACYANOGEN": "a polymer of cyanogen [n -S]\n",
  "PARACYANOGENS": "PARACYANOGEN, a polymer of cyanogen [n]\n",
  "PARADE": "to march in a public procession [v PARADED, PARADING, PARADES]\n",
  "PARADED": "PARADE, to march in a public procession [v]\n",
  "PARADER": "one who parades [n -S]\n",
  "PARADERS": "PARADER, one who parades [n]\n",
  "PARADES": "PARADE, to march in a public procession [v]\n",
  "PARADIDDLE": "to make a kind of drum roll using left and right sticks alternately [v PARADIDDLED, PARADIDDLING, PARADIDDLES]\n",
  "PARADIDDLED": "PARADIDDLE, to make a kind of drum roll using left and right sticks alternately [v]\n",
  "PARADIDDLES": "PARADIDDLE, to make a kind of drum roll using left and right sticks alternately [v]\n",
  "PARADIDDLING": "PARADIDDLE, to make a kind of drum roll using left and right sticks alternately [v]\n",
  "PARADIGM": "an example that serves as a pattern or model [n -S]\n",
  "PARADIGMATIC": "in the form of a paradigm, also PARADIGMATICAL [adj]\n",
  "PARADIGMATICAL": "in the form of a paradigm, also PARADIGMATIC [adj]\n",
  "PARADIGMS": "PARADIGM, an example that serves as a pattern or model [n]\n",
  "PARADING": "PARADE, to march in a public procession [v]\n",
  "PARADISAIC": "of or like paradise, also PARADISAICAL, PARADISEAN, PARADISIAC, PARADISIACAL, PARADISIAL, PARADISIAN, PARADISICAL [adj PARADISAICALLY]\n",
  "PARADISAICAL": "of or like paradise, also PARADISAIC, PARADISEAN, PARADISIAC, PARADISIACAL, PARADISIAL, PARADISIAN, PARADISICAL [adj PARADISAICALLY]\n",
  "PARADISAICALLY": "PARADISAICAL, of or like paradise, also PARADISAIC, PARADISEAN, PARADISIAC, PARADISIACAL, PARADISIAL, PARADISIAN, PARADISICAL [adv]\n",
  "PARADISAL": "relating to paradise, also PARADISIC [adj]\n",
  "PARADISE": "a place of extreme beauty and delight [n -S]\n",
  "PARADISEAN": "of or like paradise, also PARADISAIC, PARADISAICAL, PARADISIAC, PARADISIACAL, PARADISIAL, PARADISIAN, PARADISICAL [adj]\n",
  "PARADISES": "PARADISE, a place of extreme beauty and delight [n]\n",
  "PARADISIAC": "of or like paradise, also PARADISAIC, PARADISAICAL, PARADISEAN, PARADISIACAL, PARADISIAL, PARADISIAN, PARADISICAL [adj PARADISIACALLY]\n",
  "PARADISIACAL": "of or like paradise, also PARADISAIC, PARADISAICAL, PARADISEAN, PARADISIAC, PARADISIAL, PARADISIAN, PARADISICAL [adj PARADISIACALLY]\n",
  "PARADISIACALLY": "PARADISIACAL, of or like paradise, also PARADISAIC, PARADISAICAL, PARADISEAN, PARADISIAC, PARADISIAL, PARADISIAN, PARADISICAL [adv]\n",
  "PARADISIAL": "of or like paradise, also PARADISAIC, PARADISAICAL, PARADISEAN, PARADISIAC, PARADISIACAL, PARADISIAN, PARADISICAL [adj]\n",
  "PARADISIAN": "of or like paradise, also PARADISAIC, PARADISAICAL, PARADISEAN, PARADISIAC, PARADISIACAL, PARADISIAL, PARADISICAL [adj]\n",
  "PARADISIC": "relating to paradise, also PARADISAL [adj]\n",
  "PARADISICAL": "of or like paradise, also PARADISAIC, PARADISAICAL, PARADISEAN, PARADISIAC, PARADISIACAL, PARADISIAL, PARADISIAN [adj]\n",
  "PARADOCTOR": "a doctor who parachutes to patients in remote areas [n -S]\n",
  "PARADOCTORS": "PARADOCTOR, a doctor who parachutes to patients in remote areas [n]\n",
  "PARADOR": "(Spanish) a building such as a convent converted to a hotel [n -ES or -S]\n",
  "PARADORES": "PARADOR, (Spanish) a building such as a convent converted to a hotel [n]\n",
  "PARADORS": "PARADOR, (Spanish) a building such as a convent converted to a hotel [n]\n",
  "PARADOS": "(French) an earthworks defending against a rear attack [n -ES]\n",
  "PARADOSES": "PARADOS, (French) an earthworks defending against a rear attack [n]\n",
  "PARADOX": "(Greek) something which is contrary to conventional opinion [n -ES]\n",
  "PARADOXAL": "of the nature of paradox, also PARADOXICAL [adj]\n",
  "PARADOXER": "one who engages in paradox [n -S]\n",
  "PARADOXERS": "PARADOXER, one who engages in paradox [n]\n",
  "PARADOXES": "PARADOX, (Greek) something which is contrary to conventional opinion [n]\n",
  "PARADOXICAL": "of the nature of a paradox, also PARADOXAL [adj PARADOXICALLY]\n",
  "PARADOXICALITY": "the state of being paradoxical [n]\n",
  "PARADOXICALLY": "PARADOXICAL, of the nature of a paradox, also PARADOXAL [adv]\n",
  "PARADOXICALNESS": "PARADOXICAL, of the nature of a paradox, also PARADOXAL [n]\n",
  "PARADOXIDIAN": "belonging to the Paradoxides, a Middle Cambrian genus of trilobites [adj]\n",
  "PARADOXIES": "PARADOXY, the quality of being paradoxical [n]\n",
  "PARADOXIST": "one who proposes a paradox [n -S]\n",
  "PARADOXISTS": "PARADOXIST, one who proposes a paradox [n]\n",
  "PARADOXOLOGIES": "PARADOXOLOGY, the holding or maintaining of paradoxes [n]\n",
  "PARADOXOLOGY": "the holding or maintaining of paradoxes [n PARADOXOLOGIES]\n",
  "PARADOXURE": "a civetlike animal of South Asia [n -S]\n",
  "PARADOXURES": "PARADOXURE, a civetlike animal of South Asia [n]\n",
  "PARADOXURINE": "any of a number of palm civet species [n -S]\n",
  "PARADOXURINES": "PARADOXURINE, any of a number of palm civet species [n]\n",
  "PARADOXY": "the quality of being paradoxical [n PARADOXIES]\n",
  "PARADROP": "to deliver by parachute [v PARADROPPED, PARADROPPING, PARADROPS]\n",
  "PARADROPPED": "PARADROP, to deliver by parachute [v]\n",
  "PARADROPPING": "PARADROP, to deliver by parachute [v]\n",
  "PARADROPS": "PARADROP, to deliver by parachute [v]\n",
  "PARAE": "PARA, (Turkish) a small Turkish coin [n]\n",
  "PARAENESES": "PARAENESIS, an exhortation, also PARENESIS [n]\n",
  "PARAENESIS": "an exhortation, also PARENESIS [n PARAENESES]\n",
  "PARAENETIC": "exhortatory, also PARAENETICAL [adj]\n",
  "PARAENETICAL": "exhortatory, also PARAENETIC [adj]\n",
  "PARAESTHESIA": "a tingling sensation on the skin, also PARESTHESIA [n -S]\n",
  "PARAESTHESIAS": "PARAESTHESIA, a tingling sensation on the skin, also PARESTHESIA [n]\n",
  "PARAESTHETIC": "relating to paraesthesia, a tingling sensation on the skin [adj]\n",
  "PARAFFIN": "any saturated hydrocarbon of the methane series, also PARAFFINE [n -S] / to treat with paraffin [v -ED, -ING, -S]\n",
  "PARAFFINE": "any saturated hydrocarbon of the methane series, also PARAFFIN [n -S]\n",
  "PARAFFINED": "PARAFFIN, to treat with paraffin [v]\n",
  "PARAFFINES": "PARAFFINE, any saturated hydrocarbon of the methane series, also PARAFFIN [n]\n",
  "PARAFFINIC": "of or like paraffin, also PARAFFINOID [adj]\n",
  "PARAFFINIER": "PARAFFINY, of or like paraffin [adj]\n",
  "PARAFFINIEST": "PARAFFINY, of or like paraffin [adj]\n",
  "PARAFFINING": "PARAFFIN, to treat with paraffin [v]\n",
  "PARAFFINOID": "of or like paraffin, also PARAFFINIC [adj]\n",
  "PARAFFINS": "PARAFFIN, to treat with paraffin [v]\n",
  "PARAFFINY": "of or like paraffin [adj PARAFFINIER, PARAFFINIEST]\n",
  "PARAFFLE": "(Scots) a pretentious display, a fuss, also PARAFLE [n -S]\n",
  "PARAFFLES": "PARAFFLE, (Scots) a pretentious display, a fuss, also PARAFLE [n]\n",
  "PARAFLE": "(Scots) a pretentious display, a fuss, also PARAFFLE [n -S]\n",
  "PARAFLES": "PARAFLE, (Scots) a pretentious display, a fuss, also PARAFFLE [n]\n",
  "PARAFOIL": "a type of steerable parachute [n -S]\n",
  "PARAFOILS": "PARAFOIL, a type of steerable parachute [n]\n",
  "PARAFORM": "a substance used as an antiseptic [n -S]\n",
  "PARAFORMS": "PARAFORM, a substance used as an antiseptic [n]\n",
  "PARAGE": "equality of birth or rank [n -S]\n",
  "PARAGENESES": "PARAGENESIS, the order in which minerals have developed in a given mass of rock, also PARAGENESIA [n]\n",
  "PARAGENESIA": "the order in which minerals have developed in a given mass of rock, also PARAGENESIS [n -S]\n",
  "PARAGENESIAS": "PARAGENESIA, the order in which minerals have developed in a given mass of rock, also PARAGENESIS [n]\n",
  "PARAGENESIS": "the order in which minerals have developed in a given mass of rock, also PARAGENESIA [n PARAGENESES]\n",
  "PARAGENETIC": "relating to paragenesis [adj PARAGENETICALLY]\n",
  "PARAGENETICALLY": "PARAGENETIC, relating to paragenesis [adv]\n",
  "PARAGES": "PARAGE, equality of birth or rank [n]\n",
  "PARAGLIDE": "to glide through the air on a special parachute [v PARAGLIDED, PARAGLIDING, PARAGLIDES]\n",
  "PARAGLIDED": "PARAGLIDE, to glide through the air on a special parachute [v]\n",
  "PARAGLIDER": "a glider with inflatable wings [n -S]\n",
  "PARAGLIDERS": "PARAGLIDER, a glider with inflatable wings [n]\n",
  "PARAGLIDES": "PARAGLIDE, to glide through the air on a special parachute [v]\n",
  "PARAGLIDING": "the sport of drifting through the air to the ground while wearing a modified type of parachute, after having been towed into the air by, or jumping from, a plane [n -S]\n",
  "PARAGLIDINGS": "PARAGLIDING, the sport of drifting through the air to the ground while wearing a modified type of parachute, after having been towed into the air by, or jumping from, a plane [n]\n",
  "PARAGLOSSA": "one of a pair of small appendages of the lingua or labium of certain insects [n PARAGLOSSAE]\n",
  "PARAGLOSSAE": "PARAGLOSSA, one of a pair of small appendages of the lingua or labium of certain insects [n]\n",
  "PARAGLOSSAL": "relating to the paraglossae, small appendages of the lingua or labium of certain insects, also PARAGLOSSATE [adj]\n",
  "PARAGLOSSATE": "relating to the paraglossae, small appendages of the lingua or labium of certain insects, also PARAGLOSSAL [adj]\n",
  "PARAGNATHISM": "having equal mandibles [n -S]\n",
  "PARAGNATHISMS": "PARAGNATHISM, having equal mandibles [n]\n",
  "PARAGNATHOUS": "having equal mandibles [adj]\n",
  "PARAGNOSES": "PARAGNOSIS, knowledge of matters immune to scientific investigation [n]\n",
  "PARAGNOSIS": "knowledge of matters immune to scientific investigation [n PARAGNOSES]\n",
  "PARAGOGE": "the addition of a sound to the end of a word e.g. heighth for height, also PARAGOGUE [n -S]\n",
  "PARAGOGES": "PARAGOGE, the addition of a sound to the end of a word e.g. heighth for height, also PARAGOGUE [n]\n",
  "PARAGOGIC": "relating to a paragoge, the addition of a sound to the end of a word, also PARAGOGICAL [adj PARAGOGICALLY]\n",
  "PARAGOGICAL": "relating to a paragoge, the addition of a sound to the end of a word, also PARAGOGIC [adj PARAGOGICALLY]\n",
  "PARAGOGICALLY": "PARAGOGICAL, relating to a paragoge, the addition of a sound to the end of a word, also PARAGOGIC [adv]\n",
  "PARAGOGUE": "the addition of a sound to the end of a word e.g. heighth for height, also PARAGOGE [n -S]\n",
  "PARAGOGUES": "PARAGOGUE, the addition of a sound to the end of a word e.g. heighth for height, also PARAGOGE [n]\n",
  "PARAGON": "a model of perfection [n -S] / (archaic) to compare, match [v -ED, -ING, -S]\n",
  "PARAGONED": "PARAGON, (archaic) to compare, match [v]\n",
  "PARAGONING": "PARAGON, (archaic) to compare, match [v]\n",
  "PARAGONITE": "a kind of mica related to muscovite, but containing soda instead of potash [n -S]\n",
  "PARAGONITES": "PARAGONITE, a kind of mica related to muscovite, but containing soda instead of potash [n]\n",
  "PARAGONS": "PARAGON, (archaic) to compare, match [v]\n",
  "PARAGRAM": "a play on words consisting in the alteration of one letter or group of letters of a word, esp. an initial letter [n -S]\n",
  "PARAGRAMMATIST": "a punster [n -S]\n",
  "PARAGRAMMATISTS": "PARAGRAMMATIST, a punster [n]\n",
  "PARAGRAMS": "PARAGRAM, a play on words consisting in the alteration of one letter or group of letters of a word, esp. an initial letter [n]\n",
  "PARAGRAPH": "a distinct part of a discourse or writing marked by a sign or indentation [n -S] / to split up into paragraphs [v -ED, -ING, -S]\n",
  "PARAGRAPHED": "PARAGRAPH, to split up into paragraphs [v]\n",
  "PARAGRAPHER": "one who paragraphs [n -S]\n",
  "PARAGRAPHERS": "PARAGRAPHER, one who paragraphs [n]\n",
  "PARAGRAPHIA": "writing of different letters and words than intended [n -S]\n",
  "PARAGRAPHIAS": "PARAGRAPHIA, writing of different letters and words than intended [n]\n",
  "PARAGRAPHIC": "relating to paragraphs, also PARAGRAPHICAL [adj PARAGRAPHICALLY]\n",
  "PARAGRAPHICAL": "relating to paragraphs, also PARAGRAPHIC [adj PARAGRAPHICALLY]\n",
  "PARAGRAPHICALLY": "PARAGRAPHICAL, relating to paragraphs, also PARAGRAPHIC [adv]\n",
  "PARAGRAPHING": "PARAGRAPH, to split up into paragraphs [v]\n",
  "PARAGRAPHIST": "a person who writes paragraphs, news items esp. for newspapers [n -S]\n",
  "PARAGRAPHISTS": "PARAGRAPHIST, a person who writes paragraphs, news items esp. for newspapers [n]\n",
  "PARAGRAPHS": "PARAGRAPH, to split up into paragraphs [v]\n",
  "PARAHELIOTROPIC": "turning edgewise to the light [adj]\n",
  "PARAHYDROGEN": "a spin isomer of hydrogen [n -S]\n",
  "PARAHYDROGENS": "PARAHYDROGEN, a spin isomer of hydrogen [n]\n",
  "PARAINFLUENZA": "as in parainfluenza virus, any of a number of viruses causing influenza-like symptoms [n -S]\n",
  "PARAINFLUENZAS": "PARAINFLUENZA, as in parainfluenza virus, any of a number of viruses causing influenza-like symptoms [n]\n",
  "PARAJOURNALISM": "journalism that is heavily colored by the opinions of the reporter [n -S]\n",
  "PARAJOURNALISMS": "PARAJOURNALISM, journalism that is heavily colored by the opinions of the reporter [n]\n",
  "PARAKEELYA": "(Native Australian) a succulent Australian herb, also PARAKELIA [n -S]\n",
  "PARAKEELYAS": "PARAKEELYA, (Native Australian) a succulent Australian herb, also PARAKELIA [n]\n",
  "PARAKEET": "a small long-tailed parrot, also PARAQUET, PARAQUITO, PAROQUET, PARRAKEET, PARROKET, PARROQUET [n -S]\n",
  "PARAKEETS": "PARAKEET, a small long-tailed parrot, also PARAQUET, PARAQUITO, PAROQUET, PARRAKEET, PARROKET, PARROQUET [n]\n",
  "PARAKELIA": "(Native Australian) a succulent Australian herb, also PARAKEELYA [n -S]\n",
  "PARAKELIAS": "PARAKELIA, (Native Australian) a succulent Australian herb, also PARAKEELYA [n]\n",
  "PARAKITE": "a kite used for holding up a person towed by a motorboat [n -S]\n",
  "PARAKITES": "PARAKITE, a kite used for holding up a person towed by a motorboat [n]\n",
  "PARAKITING": "the sport of soaring suspended from a parachute which is being towed [n -S]\n",
  "PARAKITINGS": "PARAKITING, the sport of soaring suspended from a parachute which is being towed [n]\n",
  "PARALALIA": "abnormality of speech sounds [n -S]\n",
  "PARALALIAS": "PARALALIA, abnormality of speech sounds [n]\n",
  "PARALANGUAGE": "nonverbal elements which affect meaning of speech, as intonation, etc. [n -S]\n",
  "PARALANGUAGES": "PARALANGUAGE, nonverbal elements which affect meaning of speech, as intonation, etc. [n]\n",
  "PARALDEHYDE": "a sleep-inducing drug [n -S]\n",
  "PARALDEHYDES": "PARALDEHYDE, a sleep-inducing drug [n]\n",
  "PARALEGAL": "assisting a professional lawyer [adj] / a person who assists a professional lawyer [n -S]\n",
  "PARALEGALS": "PARALEGAL, a person who assists a professional lawyer [n]\n",
  "PARALEIPOMENA": "PARALEIPOMENON, a thing added as a supplement to a main text, also PARALIPOMENON [n]\n",
  "PARALEIPOMENON": "a thing added as a supplement to a main text, also PARALIPOMENON [n PARALEIPOMENA]\n",
  "PARALEIPSES": "PARALEIPSIS, a rhetorical figure by which one fixes attention on a subject by pretending to neglect it, also PARALIPSIS [n]\n",
  "PARALEIPSIS": "a rhetorical figure by which one fixes attention on a subject by pretending to neglect it, also PARALIPSIS [n PARALEIPSES]\n",
  "PARALEXIA": "transposition of words or syllables in reading, due to brain damage [n -S]\n",
  "PARALEXIAS": "PARALEXIA, transposition of words or syllables in reading, due to brain damage [n]\n",
  "PARALEXIC": "relating to paralexia, transposition of words or syllables in reading, due to brain damage [adj]\n",
  "PARALIMNION": "the region of a lake floor between the shoreline or water's edge and the zone of rooted vegetation [n -S]\n",
  "PARALIMNIONS": "PARALIMNION, the region of a lake floor between the shoreline or water's edge and the zone of rooted vegetation [n]\n",
  "PARALINGUISTIC": "relating to paralinguistics [adj]\n",
  "PARALINGUISTICS": "the study of paralanguage [n]\n",
  "PARALIPOMENA": "PARALIPOMENON, a thing added as a supplement to a main text, also PARALEIPOMENON [n]\n",
  "PARALIPOMENON": "a thing added as a supplement to a main text, also PARALEIPOMENON [n PARALIPOMENA]\n",
  "PARALIPSES": "PARALIPSIS, a rhetorical figure by which one fixes attention on a subject by pretending to neglect it, also PARALEIPSIS [n]\n",
  "PARALIPSIS": "a rhetorical figure by which one fixes attention on a subject by pretending to neglect it, also PARALEIPSIS [n PARALIPSES]\n",
  "PARALLACTIC": "relating to parallax, also PARALLACTICAL [adj PARALLACTICALLY]\n",
  "PARALLACTICAL": "relating to parallax, also PARALLACTIC [adj PARALLACTICALLY]\n",
  "PARALLACTICALLY": "PARALLACTICAL, relating to parallax, also PARALLACTIC [adv]\n",
  "PARALLAX": "an apparent optical displacement of an object [n -ES]\n",
  "PARALLAXES": "PARALLAX, an apparent optical displacement of an object [n]\n",
  "PARALLEL": "of lines etc., extended in the same direction and equidistant in all parts [adj PARALLELLY] / to be extended in the same direction [v PARALLELED or PARALLELLED, PARALLELING or PARALLELLING, PARALLELS]\n",
  "PARALLELED": "PARALLEL, to be extended in the same direction [v]\n",
  "PARALLELEPIPED": "a solid figure with each face a parallelogram [n -S]\n",
  "PARALLELEPIPEDA": "solid figures bounded by six parallelograms, opposite pairs being identical and parallel (plural of parallelipedon*, which has 16 letters) [n]\n",
  "PARALLELEPIPEDS": "PARALLELEPIPED, a solid figure with each face a parallelogram [n]\n",
  "PARALLELING": "a commercial practice whereby companies buy highly priced goods (e.g. perfume) in markets where prices are relatively low and sell them on in markets where prices are higher [n -S]\n",
  "PARALLELINGS": "PARALLELING, a commercial practice whereby companies buy highly priced goods (e.g. perfume) in markets where prices are relatively low and sell them on in markets where prices are higher [n]\n",
  "PARALLELISE": "to provide a parallel to, also PARALLELIZE [v PARALLELISED, PARALLELISING, PARALLELISES]\n",
  "PARALLELISED": "PARALLELISE, to provide a parallel to, also PARALLELIZE [v]\n",
  "PARALLELISES": "PARALLELISE, to provide a parallel to, also PARALLELIZE [v]\n",
  "PARALLELISING": "PARALLELISE, to provide a parallel to, also PARALLELIZE [v]\n",
  "PARALLELISM": "the belief that matter and mind don't interact but relate [n -S]\n",
  "PARALLELISMS": "PARALLELISM, the belief that matter and mind don't interact but relate [n]\n",
  "PARALLELIST": "a person who draws a parallel or comparison; a believer in psychophysical parallelism [n -S]\n",
  "PARALLELISTIC": "related to parallelism, the belief that matter and mind don't interact but relate [adj]\n",
  "PARALLELISTS": "PARALLELIST, a person who draws a parallel or comparison; a believer in psychophysical parallelism [n]\n",
  "PARALLELIZE": "to provide a parallel to, also PARALLELISE [v PARALLELIZED, PARALLELIZING, PARALLELIZES]\n",
  "PARALLELIZED": "PARALLELIZE, to provide a parallel to, also PARALLELISE [v]\n",
  "PARALLELIZES": "PARALLELIZE, to provide a parallel to, also PARALLELISE [v]\n",
  "PARALLELIZING": "PARALLELIZE, to provide a parallel to, also PARALLELISE [v]\n",
  "PARALLELLED": "PARALLEL, to be extended in the same direction [v]\n",
  "PARALLELLING": "PARALLEL, to be extended in the same direction [v]\n",
  "PARALLELLY": "PARALLEL, of lines etc., extended in the same direction and equidistant in all parts [adv]\n",
  "PARALLELOGRAM": "a quadrilateral with opposite sides parallel and equal [n -S]\n",
  "PARALLELOGRAMS": "PARALLELOGRAM, a quadrilateral with opposite sides parallel and equal [n]\n",
  "PARALLELOPIPED": "a solid figure bounded by six parallelograms, opposite pairs being identical and parallel [n -S]\n",
  "PARALLELOPIPEDA": "plural of parallelopipedon* (which has sixteen letters), a solid figure bounded by six parallelograms, opposite pairs being identical and parallel.\n",
  "PARALLELOPIPEDS": "PARALLELOPIPED, a solid figure bounded by six parallelograms, opposite pairs being identical and parallel [n]\n",
  "PARALLELS": "PARALLEL, to be extended in the same direction [v]\n",
  "PARALLELWISE": "in parallel fashion [adv]\n",
  "PARALOGIA": "the impairment of reasoning power characterized by difficulty in expressing logical ideas in speech [n -S]\n",
  "PARALOGIAS": "PARALOGIA, the impairment of reasoning power characterized by difficulty in expressing logical ideas in speech [n]\n",
  "PARALOGIES": "PARALOGY, false reasoning [n]\n",
  "PARALOGISE": "to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGIZE [v PARALOGISED, PARALOGISING, PARALOGISES]\n",
  "PARALOGISED": "PARALOGISE, to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGIZE [v]\n",
  "PARALOGISES": "PARALOGISE, to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGIZE [v]\n",
  "PARALOGISING": "PARALOGISE, to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGIZE [v]\n",
  "PARALOGISM": "false reasoning, also PARALOGY [n -S]\n",
  "PARALOGISMS": "PARALOGISM, false reasoning, also PARALOGY [n]\n",
  "PARALOGIST": "a practitioner of paralogism [n -S]\n",
  "PARALOGISTIC": "of or like paralogism, false reasoning [adj]\n",
  "PARALOGISTS": "PARALOGIST, a practitioner of paralogism [n]\n",
  "PARALOGIZE": "to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGISE [v PARALOGIZED, PARALOGIZING, PARALOGIZES]\n",
  "PARALOGIZED": "PARALOGIZE, to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGISE [v]\n",
  "PARALOGIZES": "PARALOGIZE, to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGISE [v]\n",
  "PARALOGIZING": "PARALOGIZE, to draw conclusions that do not follow logically from a given set of assumptions, also PARALOGISE [v]\n",
  "PARALOGUE": "either of a pair of genes that derive from the same ancestral gene [n -S]\n",
  "PARALOGUES": "PARALOGUE, either of a pair of genes that derive from the same ancestral gene [n]\n",
  "PARALOGY": "false reasoning [n PARALOGIES]\n",
  "PARALYMPIC": "relating to the paralympics, an Olympic games for sportspeople with physical disabilities [adj]\n",
  "PARALYMPICS": "an Olympic games for sportspeople with physical disabilities [n]\n",
  "PARALYSATION": "the act of paralysing, also PARALYZATION [n -S]\n",
  "PARALYSATIONS": "PARALYSATION, the act of paralysing, also PARALYZATION [n]\n",
  "PARALYSE": "to render incapable of movement, also PARALYZE [v PARALYSED, PARALYSING, PARALYSES]\n",
  "PARALYSED": "PARALYSE, to render incapable of movement, also PARALYZE [v]\n",
  "PARALYSER": "a paralysing agent, also PARALYZER [n -S]\n",
  "PARALYSERS": "PARALYSER, a paralysing agent, also PARALYZER [n]\n",
  "PARALYSES": "PARALYSE, to render incapable of movement, also PARALYZE [v]\n",
  "PARALYSING": "PARALYSE, to render incapable of movement, also PARALYZE [v]\n",
  "PARALYSINGLY": "PARALYSING, PARALYSE, to render incapable of movement, also PARALYZE [adv]\n",
  "PARALYSIS": "the state of being unable to move [n PARALYSES]\n",
  "PARALYTIC": "suffering from paralysis [adj PARALYTICALLY] / one suffering from paralysis [n -S]\n",
  "PARALYTICALLY": "PARALYTIC, suffering from paralysis [adv]\n",
  "PARALYTICS": "PARALYTIC, one suffering from paralysis [n]\n",
  "PARALYZATION": "the act of paralyzing, also PARALYSATION [n -S]\n",
  "PARALYZATIONS": "PARALYZATION, the act of paralyzing, also PARALYSATION [n]\n",
  "PARALYZE": "to render incapable of movement, also PARALYSE [v PARALYZED, PARALYZING, PARALYZES]\n",
  "PARALYZED": "PARALYZE, to render incapable of movement, also PARALYSE [v]\n",
  "PARALYZER": "a paralysing agent, also PARALYSER [n -S]\n",
  "PARALYZERS": "PARALYZER, a paralysing agent, also PARALYSER [n]\n",
  "PARALYZES": "PARALYZE, to render incapable of movement, also PARALYSE [v]\n",
  "PARALYZING": "PARALYZE, to render incapable of movement, also PARALYSE [v]\n",
  "PARALYZINGLY": "PARALYZING, PARALYZE, to render incapable of movement, also PARALYSE [adv]\n",
  "PARAMAECIA": "PARAMAECIUM, a microscopic unicellular ciliate protozoa, also PARAMECIUM, PARAMOECIUM [n]\n",
  "PARAMAECIUM": "a microscopic unicellular ciliate protozoa, also PARAMECIUM, PARAMOECIUM [n PARAMAECIA]\n",
  "PARAMAGNET": "an ordinary magnet as opposed to a diamagnet [n -S]\n",
  "PARAMAGNETIC": "applied to any substance of which a rod suspended between the poles of a magnet arranges itself parallel to the lines of force, as opposed to diamagnetic [adj]\n",
  "PARAMAGNETISM": "the state of being paramagnetic [n -S]\n",
  "PARAMAGNETISMS": "PARAMAGNETISM, the state of being paramagnetic [n]\n",
  "PARAMAGNETS": "PARAMAGNET, an ordinary magnet as opposed to a diamagnet [n]\n",
  "PARAMASTOID": "situated near the mastoid, paroccipital [adj] / a paramastoid process or projecting part [n -S]\n",
  "PARAMASTOIDS": "PARAMASTOID, a paramastoid process or projecting part [n]\n",
  "PARAMATTA": "a cotton or silk and wool dress material, also PARRAMATTA [n -S]\n",
  "PARAMATTAS": "PARAMATTA, a cotton or silk and wool dress material, also PARRAMATTA [n]\n",
  "PARAMECIA": "PARAMECIUM, a genus of tiny animals including the slipper animalcule, also PARAMAECIUM, PARAMOECIUM [n]\n",
  "PARAMECIUM": "a genus of tiny animals including the slipper animalcule, also PARAMAECIUM, PARAMOECIUM [n PARAMECIA or PARAMECIUMS]\n",
  "PARAMECIUMS": "PARAMECIUM, a genus of tiny animals including the slipper animalcule, also PARAMAECIUM, PARAMOECIUM [n]\n",
  "PARAMEDIC": "helping doctors or supplementing medical work [adj] / a paramedical worker, also PARAMEDICAL, PARAMEDICO [n -S]\n",
  "PARAMEDICAL": "helping doctors or supplementing medical work [adj] / a paramedical worker, also PARAMEDIC, PARAMEDICO [n -S]\n",
  "PARAMEDICALS": "PARAMEDICAL, a paramedical worker, also PARAMEDIC, PARAMEDICO [n]\n",
  "PARAMEDICO": "a paradoctor, a doctor who parachutes to patients in remote areas, also PARAMEDIC, PARAMEDICAL [n -S]\n",
  "PARAMEDICOS": "PARAMEDICO, a paradoctor, a doctor who parachutes to patients in remote areas, also PARAMEDIC, PARAMEDICAL [n]\n",
  "PARAMEDICS": "PARAMEDIC, a paramedical worker, also PARAMEDICAL, PARAMEDICO [n]\n",
  "PARAMENSTRUA": "PARAMENSTRUUM, the four days before and the four days after the onset of menstruation [n]\n",
  "PARAMENSTRUUM": "the four days before and the four days after the onset of menstruation [n PARAMENSTRUA or PARAMENSTRUUMS]\n",
  "PARAMENSTRUUMS": "PARAMENSTRUUM, the four days before and the four days after the onset of menstruation [n]\n",
  "PARAMENT": "(obsolete) a rich decoration, hanging or robe [n PARAMENTA or PARAMENTS]\n",
  "PARAMENTA": "PARAMENT, (obsolete) a rich decoration, hanging or robe [n]\n",
  "PARAMENTS": "PARAMENT, (obsolete) a rich decoration, hanging or robe [n]\n",
  "PARAMESE": "in Greek music, the string or tone above the mese [n -S]\n",
  "PARAMESES": "PARAMESE, in Greek music, the string or tone above the mese [n]\n",
  "PARAMETER": "a boundary or limit to the scope of something [n -S]\n",
  "PARAMETERISE": "to set parameters for, also PARAMETERIZE [v PARAMETERISED, PARAMETERISING, PARAMETERISES]\n",
  "PARAMETERISED": "PARAMETERISE, to set parameters for, also PARAMETERIZE [v]\n",
  "PARAMETERISES": "PARAMETERISE, to set parameters for, also PARAMETERIZE [v]\n",
  "PARAMETERISING": "PARAMETERISE, to set parameters for, also PARAMETERIZE [v]\n",
  "PARAMETERIZE": "to set parameters for, also PARAMETERISE [v PARAMETERIZED, PARAMETERIZING, PARAMETERIZES]\n",
  "PARAMETERIZED": "PARAMETERIZE, to set parameters for, also PARAMETERISE [v]\n",
  "PARAMETERIZES": "PARAMETERIZE, to set parameters for, also PARAMETERISE [v]\n",
  "PARAMETERIZING": "PARAMETERIZE, to set parameters for, also PARAMETERISE [v]\n",
  "PARAMETERS": "PARAMETER, a boundary or limit to the scope of something [n]\n",
  "PARAMETRAL": "relating to parameters, also PARAMETRIC, PARAMETRICAL [adj]\n",
  "PARAMETRIC": "relating to parameters, also PARAMETRAL, PARAMETRICAL [adj PARAMETRICALLY]\n",
  "PARAMETRICAL": "relating to parameters, also PARAMETRAL, PARAMETRIC [adj PARAMETRICALLY]\n",
  "PARAMETRICALLY": "PARAMETRICAL, relating to parameters, also PARAMETRAL, PARAMETRIC [adv]\n",
  "PARAMETRISATION": "the act of parametrising, also PARAMETRIZATION [n]\n",
  "PARAMETRISE": "to express in terms of parameters, also PARAMETRIZE [v PARAMETRISED, PARAMETRISING, PARAMETRISES]\n",
  "PARAMETRISED": "PARAMETRISE, to express in terms of parameters, also PARAMETRIZE [v]\n",
  "PARAMETRISES": "PARAMETRISE, to express in terms of parameters, also PARAMETRIZE [v]\n",
  "PARAMETRISING": "PARAMETRISE, to express in terms of parameters, also PARAMETRIZE [v]\n",
  "PARAMETRIZATION": "the act of parameterizing, also PARAMETRISATION [n]\n",
  "PARAMETRIZE": "to express in terms of parameters, also PARAMETRISE [v PARAMETRIZED, PARAMETRIZING, PARAMETRIZES]\n",
  "PARAMETRIZED": "PARAMETRIZE, to express in terms of parameters, also PARAMETRISE [v]\n",
  "PARAMETRIZES": "PARAMETRIZE, to express in terms of parameters, also PARAMETRISE [v]\n",
  "PARAMETRIZING": "PARAMETRIZE, to express in terms of parameters, also PARAMETRISE [v]\n",
  "PARAMILITARIES": "PARAMILITARY, a force formed on a military pattern esp. as a potential auxiliary military force [n]\n",
  "PARAMILITARY": "a force formed on a military pattern esp. as a potential auxiliary military force [n PARAMILITARIES]\n",
  "PARAMNESIA": "abnormality of memory, esp. forgetting of meaning of words [n -S]\n",
  "PARAMNESIAS": "PARAMNESIA, abnormality of memory, esp. forgetting of meaning of words [n]\n",
  "PARAMO": "(Spanish) a bare windswept elevated plain in South America [n -S]\n",
  "PARAMOECIA": "PARAMOECIUM, any freshwater protozoan of the genus Paramecium, having an oval body covered with cilia, also PARAMAECIUM, PARAMECIUM [n]\n",
  "PARAMOECIUM": "any freshwater protozoan of the genus Paramecium, having an oval body covered with cilia, also PARAMAECIUM, PARAMECIUM [n PARAMOECIA]\n",
  "PARAMORPH": "a pseudomorph formed by a change in molecular structure without change of chemical composition [n -S]\n",
  "PARAMORPHIC": "relating to a paramorph [adj]\n",
  "PARAMORPHINE": "a poisonous white crystalline alkaloid, extracted from opium and used in medicine, aka thebaine [n -S]\n",
  "PARAMORPHINES": "PARAMORPHINE, a poisonous white crystalline alkaloid, extracted from opium and used in medicine, aka thebaine [n]\n",
  "PARAMORPHISM": "the state of being a paramorph [n -S]\n",
  "PARAMORPHISMS": "PARAMORPHISM, the state of being a paramorph [n]\n",
  "PARAMORPHOUS": "of or like a paramorph [adj]\n",
  "PARAMORPHS": "PARAMORPH, a pseudomorph formed by a change in molecular structure without change of chemical composition [n]\n",
  "PARAMOS": "PARAMO, (Spanish) a bare windswept elevated plain in South America [n]\n",
  "PARAMOUNCIES": "PARAMOUNCY, the state of being paramount, also PARAMOUNTCY [n]\n",
  "PARAMOUNCY": "the state of being paramount, also PARAMOUNTCY [n PARAMOUNCIES]\n",
  "PARAMOUNT": "supreme [adj PARAMOUNTLY] / an overlord; a supreme ruler or proprietor [n -S]\n",
  "PARAMOUNTCIES": "PARAMOUNTCY, the state of being paramount, also PARAMOUNCY [n]\n",
  "PARAMOUNTCY": "the state of being paramount, also PARAMOUNCY [n PARAMOUNTCIES]\n",
  "PARAMOUNTLY": "PARAMOUNT, supreme [adv]\n",
  "PARAMOUNTS": "PARAMOUNT, an overlord; a supreme ruler or proprietor [n]\n",
  "PARAMOUR": "a lover of either sex, formerly in an innocent, now usually in the illicit, sense [n -S]\n",
  "PARAMOURS": "PARAMOUR, a lover of either sex, formerly in an innocent, now usually in the illicit, sense [n]\n",
  "PARAMYLUM": "a substance resembling starch, found in the green frothy scum formed on the surface of stagnant water [n -S]\n",
  "PARAMYLUMS": "PARAMYLUM, a substance resembling starch, found in the green frothy scum formed on the surface of stagnant water [n]\n",
  "PARAMYXOVIRUS": "any of a group of viruses which includes the mumps and measles viruses [n -ES]\n",
  "PARAMYXOVIRUSES": "PARAMYXOVIRUS, any of a group of viruses which includes the mumps and measles viruses [n]\n",
  "PARANEPHRIC": "near the kidney; suprarenal [adj]\n",
  "PARANEPHROS": "the suprarenal gland, near the kidney [n -ES]\n",
  "PARANEPHROSES": "PARANEPHROS, the suprarenal gland, near the kidney [n]\n",
  "PARANETE": "a tone in Greek music [n -S]\n",
  "PARANETES": "PARANETE, a tone in Greek music [n]\n",
  "PARANG": "(Malay) a large sheath-knife [n -S]\n",
  "PARANGS": "PARANG, (Malay) a large sheath-knife [n]\n",
  "PARANOEA": "a mental disorder, also PARANOIA [n -S]\n",
  "PARANOEAS": "PARANOEA, a mental disorder, also PARANOIA [n]\n",
  "PARANOEIC": "suffering from paranoia [adj] / someone suffering from paranoia, also PARANOIAC, PARANOIC [n -S]\n",
  "PARANOEICS": "PARANOEIC, someone suffering from paranoia, also PARANOIAC, PARANOIC [n]\n",
  "PARANOIA": "a mental disorder, also PARANOEA [n -S]\n",
  "PARANOIAC": "suffering from paranoia [adj] / someone suffering from paranoia, also PARANOEIC, PARANOIC [n -S]\n",
  "PARANOIACS": "PARANOIAC, someone suffering from paranoia, also PARANOEIC, PARANOIC [n]\n",
  "PARANOIAS": "PARANOIA, a mental disorder, also PARANOEA [n]\n",
  "PARANOIC": "suffering from paranoia [adj PARANOICALLY] / someone suffering from paranoia, also PARANOEIC, PARANOIAC [n -S]\n",
  "PARANOICALLY": "PARANOIC, suffering from paranoia [adv]\n",
  "PARANOICS": "PARANOIC, someone suffering from paranoia, also PARANOEIC, PARANOIAC [n]\n",
  "PARANOID": "suffering from paranoia, also PARANOIDAL [adj] / someone suffering from paranoia [n -S]\n",
  "PARANOIDAL": "suffering from paranoia, also PARANOID [adj]\n",
  "PARANOIDS": "PARANOID, someone suffering from paranoia [n]\n",
  "PARANORMAL": "not scientifically explainable [adj PARANORMALLY] / something not scientifically explainable [n -S]\n",
  "PARANORMALITIES": "PARANORMALITY, the state of being paranormal [n]\n",
  "PARANORMALITY": "the state of being paranormal [n PARANORMALITIES]\n",
  "PARANORMALLY": "PARANORMAL, not scientifically explainable [adv]\n",
  "PARANORMALS": "PARANORMAL, something not scientifically explainable [n]\n",
  "PARANTHELIA": "PARANTHELION, a diffuse whitish image of the sun, having the same altitude [n]\n",
  "PARANTHELION": "a diffuse whitish image of the sun, having the same altitude [n PARANTHELIA]\n",
  "PARANTHROPUS": "an Olduvai anthropoid ape [n -ES]\n",
  "PARANTHROPUSES": "PARANTHROPUS, an Olduvai anthropoid ape [n]\n",
  "PARANYM": "a euphemism; a word whose meaning is altered to conceal an evasion or untruth e.g. liberation for conquest [n -S]\n",
  "PARANYMPH": "(historical) a best man or bridesmaid [n -S]\n",
  "PARANYMPHS": "PARANYMPH, (historical) a best man or bridesmaid [n]\n",
  "PARANYMS": "PARANYM, a euphemism; a word whose meaning is altered to conceal an evasion or untruth e.g. liberation for conquest [n]\n",
  "PARAPARA": "(Maori) a small New Zealand tree with sticky buds that can trap seabirds [n -S]\n",
  "PARAPARAS": "PARAPARA, (Maori) a small New Zealand tree with sticky buds that can trap seabirds [n]\n",
  "PARAPARESES": "PARAPARESIS, paralysis of the lower limbs [n]\n",
  "PARAPARESIS": "paralysis of the lower limbs [n PARAPARESES]\n",
  "PARAPARETIC": "relating to paraparesis, paralysis of the lower limbs [adj]\n",
  "PARAPENTE": "the sport of jumping off mountains wearing skis and a light parachute, aka paraskiing [n -S]\n",
  "PARAPENTES": "PARAPENTE, the sport of jumping off mountains wearing skis and a light parachute, aka paraskiing [n]\n",
  "PARAPENTING": "a cross between hang-gliding and parachuting, a sport in which the participant jumps from a high place wearing a modified type of parachute, which is then used as a hang-glider [n -S]\n",
  "PARAPENTINGS": "PARAPENTING, a cross between hang-gliding and parachuting, a sport in which the participant jumps from a high place wearing a modified type of parachute, which is then used as a hang-glider [n]\n",
  "PARAPERIODIC": "as in paraperiodic acid [adj]\n",
  "PARAPET": "a protective wall [n -S]\n",
  "PARAPETED": "having a parapet [adj]\n",
  "PARAPETS": "PARAPET, a protective wall [n]\n",
  "PARAPH": "a flourish at the end of a signature [n -S] / to append a paragraph to, to initial [v -ED, -ING, -S]\n",
  "PARAPHASIA": "a disorder in which one word substituted for another [n -S]\n",
  "PARAPHASIAS": "PARAPHASIA, a disorder in which one word substituted for another [n]\n",
  "PARAPHASIC": "of or like paraphasia, a disorder in which one word substituted for another [adj]\n",
  "PARAPHED": "PARAPH, to append a paragraph to, to initial [v]\n",
  "PARAPHERNALIA": "trappings, equipment, miscellaneous accessories [n]\n",
  "PARAPHILIA": "abnormal sexual practices [n -S]\n",
  "PARAPHILIAC": "a person who indulges in paraphilia, abnormal sexual practices [n -S]\n",
  "PARAPHILIACS": "PARAPHILIAC, a person who indulges in paraphilia, abnormal sexual practices [n]\n",
  "PARAPHILIAS": "PARAPHILIA, abnormal sexual practices [n]\n",
  "PARAPHIMOSES": "PARAPHIMOSIS, strangulation of the glans penis by constriction of the prepuce [n]\n",
  "PARAPHIMOSIS": "strangulation of the glans penis by constriction of the prepuce [n PARAPHIMOSES]\n",
  "PARAPHING": "PARAPH, to append a paragraph to, to initial [v]\n",
  "PARAPHONIA": "alteration of the voice; as at puberty [n -S]\n",
  "PARAPHONIAS": "PARAPHONIA, alteration of the voice; as at puberty [n]\n",
  "PARAPHONIC": "relating to paraphonia, alteration of the voice; as at puberty [adj]\n",
  "PARAPHRASABLE": "capable of being paraphrased [adj]\n",
  "PARAPHRASE": "to restate in different words [v PARAPHRASED, PARAPHRASING, PARAPHRASES]\n",
  "PARAPHRASED": "PARAPHRASE, to restate in different words [v]\n",
  "PARAPHRASER": "one who paraphrases [n -S]\n",
  "PARAPHRASERS": "PARAPHRASER, one who paraphrases [n]\n",
  "PARAPHRASES": "PARAPHRASE, to restate in different words [v]\n",
  "PARAPHRASING": "PARAPHRASE, to restate in different words [v]\n",
  "PARAPHRAST": "a paraphraser [n -S]\n",
  "PARAPHRASTIC": "of the nature of a paraphrase, also PARAPHRASTICAL [adj]\n",
  "PARAPHRASTICAL": "of the nature of a paraphrase, also PARAPHRASTIC [adj]\n",
  "PARAPHRASTS": "PARAPHRAST, a paraphraser [n]\n",
  "PARAPHRAXES": "PARAPHRAXIS, the inability to perform purposive movements properly, also PARAPHRAXIA [n]\n",
  "PARAPHRAXIA": "the inability to perform purposive movements properly, also PARAPHRAXIS [n -S]\n",
  "PARAPHRAXIAS": "PARAPHRAXIA, the inability to perform purposive movements properly, also PARAPHRAXIS [n]\n",
  "PARAPHRAXIS": "the inability to perform purposive movements properly, also PARAPHRAXIA [n PARAPHRAXES]\n",
  "PARAPHRENIA": "any mental disorder of the paranoid type [n -S]\n",
  "PARAPHRENIAS": "PARAPHRENIA, any mental disorder of the paranoid type [n]\n",
  "PARAPHS": "PARAPH, to append a paragraph to, to initial [v]\n",
  "PARAPHYSATE": "relating to paraphysis, a sterile filament or hair borne among the sporangia [adj]\n",
  "PARAPHYSES": "PARAPHYSIS, a sterile filament or hair borne among the sporangia [n]\n",
  "PARAPHYSIS": "a sterile filament or hair borne among the sporangia [n PARAPHYSES]\n",
  "PARAPINEAL": "beside the pineal gland [adj]\n",
  "PARAPLANNER": "a person who assists a financial planner, especially in compiling reports and conducting research [n -S]\n",
  "PARAPLANNERS": "PARAPLANNER, a person who assists a financial planner, especially in compiling reports and conducting research [n]\n",
  "PARAPLEGIA": "paralysis of lower half of body [n -S]\n",
  "PARAPLEGIAS": "PARAPLEGIA, paralysis of lower half of body [n]\n",
  "PARAPLEGIC": "paralysed in the lower half of the body [adj] / someone paralysed in the lower half of the body [n -S]\n",
  "PARAPLEGICS": "PARAPLEGIC, someone paralysed in the lower half of the body [n]\n",
  "PARAPODIA": "PARAPODIUM, a jointless muscular lateral appendage occurring in pairs in polychaete worms [n]\n",
  "PARAPODIAL": "relating to a parapodium, one of the lateral appendages of an annelid [adj]\n",
  "PARAPODIUM": "a jointless muscular lateral appendage occurring in pairs in polychaete worms [n PARAPODIA]\n",
  "PARAPOPHYSES": "PARAPOPHYSIS, a ventral transverse process of a vertebra [n]\n",
  "PARAPOPHYSIAL": "of or like a parapophysis, a ventral transverse process of a vertebra [adj]\n",
  "PARAPOPHYSIS": "a ventral transverse process of a vertebra [n PARAPOPHYSES]\n",
  "PARAPRAXES": "PARAPRAXIS, a slip of the tongue or pen that reveals the unconscious mind [n]\n",
  "PARAPRAXIS": "a slip of the tongue or pen that reveals the unconscious mind [n PARAPRAXES or PARAPRAXISES]\n",
  "PARAPRAXISES": "PARAPRAXIS, a slip of the tongue or pen that reveals the unconscious mind [n]\n",
  "PARAPSYCHIC": "related to parapsychism, also PARAPSYCHICAL [adj]\n",
  "PARAPSYCHICAL": "related to parapsychism, also PARAPSYCHIC [adj]\n",
  "PARAPSYCHISM": "panpsychistic parallelism [n -S]\n",
  "PARAPSYCHISMS": "PARAPSYCHISM, panpsychistic parallelism [n]\n",
  "PARAPSYCHOLOGY": "the study of unexplained mental phenomena [n]\n",
  "PARAPSYCHOSES": "PARAPSYCHOSIS, an abnormal psychosis [n]\n",
  "PARAPSYCHOSIS": "an abnormal psychosis [n PARAPSYCHOSES]\n",
  "PARAQUADRATE": "a paired membrane bone of the vertebrate skull [n -S]\n",
  "PARAQUADRATES": "PARAQUADRATE, a paired membrane bone of the vertebrate skull [n]\n",
  "PARAQUAT": "(tradename) a herbicide that kills green vegetation by interfering with photosynthesis [n -S]\n",
  "PARAQUATS": "PARAQUAT, (tradename) a herbicide that kills green vegetation by interfering with photosynthesis [n]\n",
  "PARAQUET": "a small long-tailed parrot, also PARAKEET, PARAQUITO, PAROQUET, PARRAKEET, PARROKET, PARROQUET [n -S]\n",
  "PARAQUETS": "PARAQUET, a small long-tailed parrot, also PARAKEET, PARAQUITO, PAROQUET, PARRAKEET, PARROKET, PARROQUET [n]\n",
  "PARAQUITO": "a small long-tailed parrot, also PARAKEET, PARAQUET, PAROQUET, PARRAKEET, PARROKET, PARROQUET [n -S]\n",
  "PARAQUITOS": "PARAQUITO, a small long-tailed parrot, also PARAKEET, PARAQUET, PAROQUET, PARRAKEET, PARROKET, PARROQUET [n]\n",
  "PARARHYME": "a form of rhyme in which the consonants but not the vowels of the last stressed syllable are identical [n -S]\n",
  "PARARHYMES": "PARARHYME, a form of rhyme in which the consonants but not the vowels of the last stressed syllable are identical [n]\n",
  "PARAROSANILINE": "a white crystalline base that is the parent compound of many dyes [n -S]\n",
  "PARAROSANILINES": "PARAROSANILINE, a white crystalline base that is the parent compound of many dyes [n]\n",
  "PARARTHRIA": "disordered articulation of speech [n -S]\n",
  "PARARTHRIAS": "PARARTHRIA, disordered articulation of speech [n]\n",
  "PARAS": "PARA, (Turkish) a small Turkish coin [n]\n",
  "PARASAIL": "to soar while harnessed to a parachute towed by a car or boat [v -ED, -ING, -S]\n",
  "PARASAILED": "PARASAIL, to soar while harnessed to a parachute towed by a car or boat [v]\n",
  "PARASAILING": "the recreational sport of soaring in a parachute while being towed usually by a motorboat [n -S]\n",
  "PARASAILINGS": "PARASAILING, the recreational sport of soaring in a parachute while being towed usually by a motorboat [n]\n",
  "PARASAILS": "PARASAIL, to soar while harnessed to a parachute towed by a car or boat [v]\n",
  "PARASANG": "(Greek) an old Persian unit of distance [n -S]\n",
  "PARASANGS": "PARASANG, (Greek) an old Persian unit of distance [n]\n",
  "PARASCENDER": "a person who takes part in parascending [n -S]\n",
  "PARASCENDERS": "PARASCENDER, a person who takes part in parascending [n]\n",
  "PARASCENDING": "a sport similar to paragliding, the participant being towed into the wind behind a motor vehicle [n -S]\n",
  "PARASCENDINGS": "PARASCENDING, a sport similar to paragliding, the participant being towed into the wind behind a motor vehicle [n]\n",
  "PARASCENIA": "PARASCENIUM, in the Greek theatre, a wing, a side-scene [n]\n",
  "PARASCENIUM": "in the Greek theatre, a wing, a side-scene [n PARASCENIA]\n",
  "PARASCEVE": "among the Jews, the evening before the Sabbath [n -S]\n",
  "PARASCEVES": "PARASCEVE, among the Jews, the evening before the Sabbath [n]\n",
  "PARASCIENCE": "the study of phenomena which cannot be investigated by rigorous traditional scientific method [n -S]\n",
  "PARASCIENCES": "PARASCIENCE, the study of phenomena which cannot be investigated by rigorous traditional scientific method [n]\n",
  "PARASELENAE": "PARASELENE, a mock moon; bright patch on a lunar halo [n]\n",
  "PARASELENE": "a mock moon; bright patch on a lunar halo [n PARASELENAE]\n",
  "PARASELENIC": "relating to the paraselene, a mock moon; a bright patch on a lunar halo [adj]\n",
  "PARASEXUAL": "relating to reproduction that results in recombination of genes from different individuals [adj]\n",
  "PARASEXUALITIES": "PARASEXUALITY, the state of being parasexual [n]\n",
  "PARASEXUALITY": "the state of being parasexual [n PARASEXUALITIES]\n",
  "PARASHAH": "(Hebrew) a passage in Jewish literature [n PARASHOTH, PARASHIOTH, PARASHAHS or PARASHOT]\n",
  "PARASHAHS": "PARASHAH, (Hebrew) a passage in Jewish literature [n]\n",
  "PARASHIOTH": "PARASHAH, (Hebrew) a passage in Jewish literature [n]\n",
  "PARASHOT": "PARASHAH, (Hebrew) a passage in Jewish literature [n]\n",
  "PARASHOTH": "PARASHAH, (Hebrew) a passage in Jewish literature [n]\n",
  "PARASITAEMIA": "the presence of parasites in the blood [n -S]\n",
  "PARASITAEMIAS": "PARASITAEMIA, the presence of parasites in the blood [n]\n",
  "PARASITE": "an organism that lives and feeds on another [n -S]\n",
  "PARASITES": "PARASITE, an organism that lives and feeds on another [n]\n",
  "PARASITIC": "of or like a parasite, also PARASITICAL [adj PARASITICALLY]\n",
  "PARASITICAL": "of or like a parasite, also PARASITIC [adj PARASITICALLY]\n",
  "PARASITICALLY": "PARASITICAL, of or like a parasite, also PARASITIC [adv]\n",
  "PARASITICALNESS": "PARASITICAL, of or like a parasite, also PARASITIC [n]\n",
  "PARASITICIDAL": "destructive to parasites [adj]\n",
  "PARASITICIDE": "the killing of parasites [n -S]\n",
  "PARASITICIDES": "PARASITICIDE, the killing of parasites [n]\n",
  "PARASITISATION": "the act of parasitising, also PARASITIZATION [n -S]\n",
  "PARASITISATIONS": "PARASITISATION, the act of parasitising, also PARASITIZATION [n]\n",
  "PARASITISE": "to infest or live on or with as a parasite, also PARASITIZE [v PARASITISED, PARASITISING, PARASITISES]\n",
  "PARASITISED": "PARASITISE, to infest or live on or with as a parasite, also PARASITIZE [v]\n",
  "PARASITISES": "PARASITISE, to infest or live on or with as a parasite, also PARASITIZE [v]\n",
  "PARASITISING": "PARASITISE, to infest or live on or with as a parasite, also PARASITIZE [v]\n",
  "PARASITISM": "the behavior of a parasite [n -S]\n",
  "PARASITISMS": "PARASITISM, the behavior of a parasite [n]\n",
  "PARASITIZATION": "the act of parasitizing, also PARASITISATION [n -S]\n",
  "PARASITIZATIONS": "PARASITIZATION, the act of parasitizing, also PARASITISATION [n]\n",
  "PARASITIZE": "to infest or live on or with as a parasite, also PARASITISE [v PARASITIZED, PARASITIZING, PARASITIZES]\n",
  "PARASITIZED": "PARASITIZE, to infest or live on or with as a parasite, also PARASITISE [v]\n",
  "PARASITIZES": "PARASITIZE, to infest or live on or with as a parasite, also PARASITISE [v]\n",
  "PARASITIZING": "PARASITIZE, to infest or live on or with as a parasite, also PARASITISE [v]\n",
  "PARASITOID": "an insect parasitic in one phase of the life history, thereafter independent [n -S]\n",
  "PARASITOIDS": "PARASITOID, an insect parasitic in one phase of the life history, thereafter independent [n]\n",
  "PARASITOLOGIC": "relating to parasitology, also PARASITOLOGICAL [adj]\n",
  "PARASITOLOGICAL": "relating to parasitology, also PARASITOLOGIC [adj]\n",
  "PARASITOLOGIES": "PARASITOLOGY, a branch of biology dealing with parasites and parasitism esp. among animals [n]\n",
  "PARASITOLOGIST": "one who studies parasitology [n -S]\n",
  "PARASITOLOGISTS": "PARASITOLOGIST, one who studies parasitology [n]\n",
  "PARASITOLOGY": "a branch of biology dealing with parasites and parasitism esp. among animals [n PARASITOLOGIES]\n",
  "PARASITOSES": "PARASITOSIS, a disease resulting from parasites [n]\n",
  "PARASITOSIS": "a disease resulting from parasites [n PARASITOSES]\n",
  "PARASKIING": "the sport of jumping off high mountains wearing skis and a light parachute composed of inflatable fabric tubes that form a semirigid wing [n -S]\n",
  "PARASKIINGS": "PARASKIING, the sport of jumping off high mountains wearing skis and a light parachute composed of inflatable fabric tubes that form a semirigid wing [n]\n",
  "PARASOL": "a small, light umbrella [n -S]\n",
  "PARASOLED": "having a parasol [adj]\n",
  "PARASOLS": "PARASOL, a small, light umbrella [n]\n",
  "PARASOMNIA": "any of several sleep disorders characterized by abnormal or unusual behaviour of the nervous system during any of the stages of sleep [n -S]\n",
  "PARASOMNIAS": "PARASOMNIA, any of several sleep disorders characterized by abnormal or unusual behaviour of the nervous system during any of the stages of sleep [n]\n",
  "PARASPHENOID": "a bone of the skull, part of the cranial floor [n -S]\n",
  "PARASPHENOIDS": "PARASPHENOID, a bone of the skull, part of the cranial floor [n]\n",
  "PARASTATAL": "indirectly controlled by the state [adj] / a parastatal concern [n -S]\n",
  "PARASTATALS": "PARASTATAL, a parastatal concern [n]\n",
  "PARASTICHIES": "PARASTICHY, a secondary helix joining leaf-bases on an axis, visible where the leaves are crowded together, e.g. the scales of a pine cone [n]\n",
  "PARASTICHOUS": "characterised by parastichy, i.e. having a secondary helix joining leaf-bases on an axis [adj]\n",
  "PARASTICHY": "a secondary helix joining leaf-bases on an axis, visible where the leaves are crowded together, e.g. the scales of a pine cone [n PARASTICHIES]\n",
  "PARASUICIDE": "a harmful act appearing to be an attempt at suicide [n -S]\n",
  "PARASUICIDES": "PARASUICIDE, a harmful act appearing to be an attempt at suicide [n]\n",
  "PARASYMBIONT": "a partner in parasymbiosis [n -S]\n",
  "PARASYMBIONTS": "PARASYMBIONT, a partner in parasymbiosis [n]\n",
  "PARASYMBIOSES": "PARASYMBIOSIS, the symbiotic relationship that occurs between certain species of fungi and lichens [n]\n",
  "PARASYMBIOSIS": "the symbiotic relationship that occurs between certain species of fungi and lichens [n PARASYMBIOSES]\n",
  "PARASYMBIOTIC": "relating to parasymbiosis [adj]\n",
  "PARASYMPATHETIC": "designating part of the nervous system [adj]\n",
  "PARASYNAPSES": "PARASYNAPSIS, the pairing of chromosomes of paternal and maternal origin before the reducing division [n]\n",
  "PARASYNAPSIS": "the pairing of chromosomes of paternal and maternal origin before the reducing division [n PARASYNAPSES]\n",
  "PARASYNAPTIC": "of or like a parasynapsis [adj]\n",
  "PARASYNTHESES": "PARASYNTHESIS, the derivation of words using hyphenated compounds [n]\n",
  "PARASYNTHESIS": "the derivation of words using hyphenated compounds [n PARASYNTHESES]\n",
  "PARASYNTHETA": "PARASYNTHETON, a word derived from a compound, e.g. come-at-able [n]\n",
  "PARASYNTHETIC": "relating to parasynthesis [adj]\n",
  "PARASYNTHETON": "a word derived from a compound, e.g. come-at-able [n PARASYNTHETA]\n",
  "PARATACTIC": "of pertaining to, or characterized by, parataxis, also PARATACTICAL [adj PARATACTICALLY]\n",
  "PARATACTICAL": "of pertaining to, or characterized by, parataxis, also PARATACTIC [adj PARATACTICALLY]\n",
  "PARATACTICALLY": "PARATACTICAL, of pertaining to, or characterized by, parataxis, also PARATACTIC [adv]\n",
  "PARATANIWHA": "(Maori) a New Zealand plant with pink and red serrated leaves [n -S]\n",
  "PARATANIWHAS": "PARATANIWHA, (Maori) a New Zealand plant with pink and red serrated leaves [n]\n",
  "PARATAXES": "PARATAXIS, the juxtaposition of clauses or phrases without the use of coordinating or subordinating conjunctions, as 'It was cold; the snows came' [n]\n",
  "PARATAXIS": "the juxtaposition of clauses or phrases without the use of coordinating or subordinating conjunctions, as 'It was cold; the snows came' [n PARATAXES]\n",
  "PARATHA": "(Hindi) a flat round cake of unleavened bread, traditionally eaten as an accompaniment to Indian food [n -S]\n",
  "PARATHAS": "PARATHA, (Hindi) a flat round cake of unleavened bread, traditionally eaten as an accompaniment to Indian food [n]\n",
  "PARATHESES": "PARATHESIS, apposition; the compounding of words without change [n]\n",
  "PARATHESIS": "apposition; the compounding of words without change [n PARATHESES]\n",
  "PARATHION": "an extremely toxic insecticide [n -S]\n",
  "PARATHIONS": "PARATHION, an extremely toxic insecticide [n]\n",
  "PARATHORMONE": "a parathyroid hormone [n -S]\n",
  "PARATHORMONES": "PARATHORMONE, a parathyroid hormone [n]\n",
  "PARATHYROID": "near the thyroid gland, esp. applied to such small glands whose hormone controls calcium content of body [adj] / such a gland [n -S]\n",
  "PARATHYROIDS": "PARATHYROID, such a gland [n]\n",
  "PARATONIC": "resulting from external impulse [adj]\n",
  "PARATROOP": "relating to paratroops, troops trained to drop by parachute [adj]\n",
  "PARATROOPER": "a member of the paratroops [n -S]\n",
  "PARATROOPERS": "PARATROOPER, a member of the paratroops [n]\n",
  "PARATROOPS": "troops carried by air [n]\n",
  "PARATUNGSTIC": "as in paratungstic acid [adj]\n",
  "PARATYPHOID": "a disease resembling typhoid but caused by different bacillus [n -S]\n",
  "PARATYPHOIDS": "PARATYPHOID, a disease resembling typhoid but caused by different bacillus [n]\n",
  "PARAVAIL": "below others in rank, as in tenant paravail: a tenant who held from another who was himself a tenant [adj]\n",
  "PARAVANE": "an underwater device used to cut cables [n -S]\n",
  "PARAVANES": "PARAVANE, an underwater device used to cut cables [n]\n",
  "PARAVANT": "(Spenser) before, in front, also PARAVAUNT [adv] / a preeminent person or thing [n -S]\n",
  "PARAVANTS": "PARAVANT, a preeminent person or thing [n]\n",
  "PARAVAUNT": "(Spenser) before, in front, also PARAVANT [adv]\n",
  "PARAWALKER": "a metal structure like an external skeleton worn by a paraplegic to enable him or her to walk [n -S]\n",
  "PARAWALKERS": "PARAWALKER, a metal structure like an external skeleton worn by a paraplegic to enable him or her to walk [n]\n",
  "PARAWING": "a winglike parachute [n -S]\n",
  "PARAWINGS": "PARAWING, a winglike parachute [n]\n",
  "PARAXIAL": "parallel to the axis of an optical system [adj]\n",
  "PARAZOA": "PARAZOON, any member of the Parazoa, sponges, also PARAZOAN [n]\n",
  "PARAZOAN": "any of a major division of multicellular animals [n -S]\n",
  "PARAZOANS": "PARAZOAN, any of a major division of multicellular animals [n]\n",
  "PARAZOON": "any member of the Parazoa, sponges, also PARAZOAN [n PARAZOA]\n",
  "PARBAKE": "to bake partially [v PARBAKED, PARBAKING, PARBAKES]\n",
  "PARBAKED": "PARBAKE, to bake partially [v]\n",
  "PARBAKES": "PARBAKE, to bake partially [v]\n",
  "PARBAKING": "PARBAKE, to bake partially [v]\n",
  "PARBOIL": "to cook partially by boiling for a short time [v -ED, -ING, -S]\n",
  "PARBOILED": "PARBOIL, to cook partially by boiling for a short time [v]\n",
  "PARBOILING": "PARBOIL, to cook partially by boiling for a short time [v]\n",
  "PARBOILS": "PARBOIL, to cook partially by boiling for a short time [v]\n",
  "PARBREAK": "(archaic) to vomit [v -ED, -ING, -S]\n",
  "PARBREAKED": "PARBREAK, (archaic) to vomit [v]\n",
  "PARBREAKING": "PARBREAK, (archaic) to vomit [v]\n",
  "PARBREAKS": "PARBREAK, (archaic) to vomit [v]\n",
  "PARBUCKLE": "to raise or lower (a cask, gun, etc.) with a parbuckle, a sling made by wrapping both ends of rope around object [v PARBUCKLED, PARBUCKLING, PARBUCKLES]\n",
  "PARBUCKLED": "PARBUCKLE, to raise or lower (a cask, gun, etc.) with a parbuckle, a sling made by wrapping both ends of rope around object [v]\n",
  "PARBUCKLES": "PARBUCKLE, to raise or lower (a cask, gun, etc.) with a parbuckle, a sling made by wrapping both ends of rope around object [v]\n",
  "PARBUCKLING": "PARBUCKLE, to raise or lower (a cask, gun, etc.) with a parbuckle, a sling made by wrapping both ends of rope around object [v]\n",
  "PARCEL": "to divide into parts or shares [v PARCELED or PARCELLED, PARCELING or PARCELLING, PARCELS]\n",
  "PARCELED": "PARCEL, to divide into parts or shares [v]\n",
  "PARCELING": "PARCEL, to divide into parts or shares [v]\n",
  "PARCELLED": "PARCEL, to divide into parts or shares [v]\n",
  "PARCELLING": "PARCEL, to divide into parts or shares [v]\n",
  "PARCELS": "PARCEL, to divide into parts or shares [v]\n",
  "PARCELWISE": "by parcels, piecemeal [adv]\n",
  "PARCENARIES": "PARCENARY, the state of being a parcener, a joint heir [n]\n",
  "PARCENARY": "the state of being a parcener, a joint heir [n PARCENARIES]\n",
  "PARCENER": "a coheir, or one of two or more persons to whom an estate of inheritance descends jointly, and by whom it is held as one estate [n -S]\n",
  "PARCENERS": "PARCENER, a coheir, or one of two or more persons to whom an estate of inheritance descends jointly, and by whom it is held as one estate [n]\n",
  "PARCH": "to make very dry [v -ED, -ING, -ES]\n",
  "PARCHED": "PARCH, to make very dry [v]\n",
  "PARCHEDLY": "PARCHED, PARCH, to make very dry [adv]\n",
  "PARCHEDNESS": "the state of being parched [n -ES]\n",
  "PARCHEDNESSES": "PARCHEDNESS, the state of being parched [n]\n",
  "PARCHEESI": "(Hindi) a game, somewhat resembling backgammon, originating in India, also PACHISI, PARCHESI, PARCHISI [n -S]\n",
  "PARCHEESIS": "PARCHEESI, (Hindi) a game, somewhat resembling backgammon, originating in India, also PACHISI, PARCHESI, PARCHISI [n]\n",
  "PARCHES": "PARCH, to make very dry [v]\n",
  "PARCHESI": "(Hindi) a game, somewhat resembling backgammon, originating in India, also PACHISI, PARCHEESI, PARCHISI [n -S]\n",
  "PARCHESIS": "PARCHESI, (Hindi) a game, somewhat resembling backgammon, originating in India, also PACHISI, PARCHEESI, PARCHISI [n]\n",
  "PARCHING": "PARCH, to make very dry [v]\n",
  "PARCHISI": "(Hindi) a game, somewhat resembling backgammon, originating in India, also PACHISI, PARCHEESI, PARCHESI [n -S]\n",
  "PARCHISIS": "PARCHISI, (Hindi) a game, somewhat resembling backgammon, originating in India, also PACHISI, PARCHEESI, PARCHESI [n]\n",
  "PARCHMENT": "the skin of a sheep, goat, or other animal prepared for writing on, etc. [n -S]\n",
  "PARCHMENTIER": "PARCHMENTY, like parchment [adj]\n",
  "PARCHMENTIEST": "PARCHMENTY, like parchment [adj]\n",
  "PARCHMENTISE": "to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTIZE [v PARCHMENTISED, PARCHMENTISING, PARCHMENTISES]\n",
  "PARCHMENTISED": "PARCHMENTISE, to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTIZE [v]\n",
  "PARCHMENTISES": "PARCHMENTISE, to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTIZE [v]\n",
  "PARCHMENTISING": "PARCHMENTISE, to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTIZE [v]\n",
  "PARCHMENTIZE": "to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTISE [v PARCHMENTIZED, PARCHMENTIZING, PARCHMENTIZES]\n",
  "PARCHMENTIZED": "PARCHMENTIZE, to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTISE [v]\n",
  "PARCHMENTIZES": "PARCHMENTIZE, to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTISE [v]\n",
  "PARCHMENTIZING": "PARCHMENTIZE, to make like parchment, e.g. by treating with sulphuric acid, also PARCHMENTISE [v]\n",
  "PARCHMENTS": "PARCHMENT, the skin of a sheep, goat, or other animal prepared for writing on, etc. [n]\n",
  "PARCHMENTY": "like parchment [adj PARCHMENTIER, PARCHMENTIEST]\n",
  "PARCIMONIES": "PARCIMONY, (archaic) sparingness or reluctance in the spending of money, also PARSIMONY [n]\n",
  "PARCIMONY": "(archaic) sparingness or reluctance in the spending of money, also PARSIMONY [n PARCIMONIES]\n",
  "PARCLOSE": "a railing in a church enclosing altar, chapel or tomb [n -S]\n",
  "PARCLOSES": "PARCLOSE, a railing in a church enclosing altar, chapel or tomb [n]\n",
  "PARD": "a leopard, also PARDAL, PARDALE, PARDALIS [n -S]\n",
  "PARDAH": "(Urdu) the seclusion of women from public observation among Muslims and some Hindus, also PURDA, PURDAH [n -S]\n",
  "PARDAHS": "PARDAH, (Urdu) the seclusion of women from public observation among Muslims and some Hindus, also PURDA, PURDAH [n]\n",
  "PARDAL": "a leopard, also PARD, PARDALE, PARDALIS [n -S]\n",
  "PARDALE": "a leopard, also PARD, PARDAL, PARDALIS [n -S]\n",
  "PARDALES": "PARDALE, a leopard, also PARD, PARDAL, PARDALIS [n]\n",
  "PARDALIS": "a leopard, also PARD, PARDAL, PARDALE [n -ES]\n",
  "PARDALISES": "PARDALIS, a leopard, also PARD, PARDAL, PARDALE [n]\n",
  "PARDALOTE": "a small Australian songbird [n -S]\n",
  "PARDALOTES": "PARDALOTE, a small Australian songbird [n]\n",
  "PARDALS": "PARDAL, a leopard, also PARD, PARDALE, PARDALIS [n]\n",
  "PARDED": "spotted [adj]\n",
  "PARDEE": "(Shakespeare) assuredly, by God, used as a mild oath, also PARDI, PARDIE, PARDY, PERDIE, PERDY [interj]\n",
  "PARDI": "(Shakespeare) assuredly, by God, used as a mild oath, also PARDEE, PARDIE, PARDY, PERDIE, PERDY [interj]\n",
  "PARDIE": "(Shakespeare) assuredly, by God, used as a mild oath, also PARDI, PARDEE, PARDY, PERDIE, PERDY [interj]\n",
  "PARDINE": "pertaining to or like a leopard [adj]\n",
  "PARDNER": "(colloquial) partner, friend [n -S]\n",
  "PARDNERS": "PARDNER, (colloquial) partner, friend [n]\n",
  "PARDON": "to release from liability for an offence [v -ED, -ING, -S]\n",
  "PARDONABLE": "that can be pardoned [adj PARDONABLY]\n",
  "PARDONABLENESS": "the state of being pardonable [n]\n",
  "PARDONABLY": "PARDONABLE, that can be pardoned [adv]\n",
  "PARDONED": "PARDON, to release from liability for an offence [v]\n",
  "PARDONER": "one who raises money for religious works by selling indulgences [n -S]\n",
  "PARDONERS": "PARDONER, one who raises money for religious works by selling indulgences [n]\n",
  "PARDONING": "the act of pardoning [n -S]\n",
  "PARDONINGS": "PARDONING, the act of pardoning [n]\n",
  "PARDONLESS": "without a pardon [adj]\n",
  "PARDONS": "PARDON, to release from liability for an offence [v]\n",
  "PARDS": "PARD, a leopard, also PARDAL, PARDALE, PARDALIS [n]\n",
  "PARDY": "(Shakespeare) assuredly, by God, used as a mild oath, also PARDI, PARDEE, PARDIE, PERDIE, PERDY [interj]\n",
  "PARE": "to shave or cut off the outer surface [v PARED, PARING, PARES]\n",
  "PARECIOUS": "of certain mosses, having the male and female reproductive organs near one another, also PAROECIOUS, PAROICOUS [adj]\n",
  "PARECISM": "the state of being parecious, of certain mosses, having the male and female reproductive organs near one another, also PAROECISM [n -S]\n",
  "PARECISMS": "PARECISM, the state of being parecious, of certain mosses, having the male and female reproductive organs near one another, also PAROECISM [n]\n",
  "PARED": "PARE, to shave or cut off the outer surface [v]\n",
  "PAREGORIC": "soothing, lessening pain [adj] / a medicine that soothes, assuages pain [n -S]\n",
  "PAREGORICS": "PAREGORIC, a medicine that soothes, assuages pain [n]\n",
  "PAREIDOLIA": "a psychological phenomenon involving a vague and random stimulus being perceived as significant e.g. seeing faces in clouds [n -S]\n",
  "PAREIDOLIAS": "PAREIDOLIA, a psychological phenomenon involving a vague and random stimulus being perceived as significant e.g. seeing faces in clouds [n]\n",
  "PAREIRA": "a medicinal plant root [n -S]\n",
  "PAREIRAS": "PAREIRA, a medicinal plant root [n]\n",
  "PARELLA": "(French) a lichen which yields archil, a red dye, also PARELLE [n -S]\n",
  "PARELLAS": "PARELLA, (French) a lichen which yields archil, a red dye, also PARELLE [n]\n",
  "PARELLE": "a lichen which yields archil, a red dye, also PARELLA [n -S]\n",
  "PARELLES": "PARELLE, a lichen which yields archil, a red dye, also PARELLA [n]\n",
  "PAREN": "(short for) parenthesis [n -S]\n",
  "PARENCEPHALA": "PARENCEPHALON, a cerebral hemisphere [n]\n",
  "PARENCEPHALON": "a cerebral hemisphere [n PARENCEPHALA]\n",
  "PARENCHYMA": "the ordinary soft thin-walled tissue of plants, not differentiated into conducting or mechanical tissue [n -S]\n",
  "PARENCHYMAL": "of or like a parenchyma, a generalized cell or tissue in a plant, also PARENCHYMATOUS [adj]\n",
  "PARENCHYMAS": "PARENCHYMA, the ordinary soft thin-walled tissue of plants, not differentiated into conducting or mechanical tissue [n]\n",
  "PARENCHYMATA": "PARENCHYMA, the ordinary soft thin-walled tissue of plants, not differentiated into conducting or mechanical tissue [n]\n",
  "PARENCHYMATOUS": "relating to parenchyma, a generalized cell or tissue in a plant, also PARENCHYMAL [adj]\n",
  "PARENESES": "PARENESIS, an exhortation, also PARAENESIS [n]\n",
  "PARENESIS": "an exhortation, also PARAENESIS [n PARENESES]\n",
  "PARENS": "PAREN, (short for) parenthesis [n]\n",
  "PARENT": "to act as father or mother [v -ED, -ING, -S]\n",
  "PARENTAGE": "descent from parents, extraction [n -S]\n",
  "PARENTAGES": "PARENTAGE, descent from parents, extraction [n]\n",
  "PARENTAL": "pertaining to a parent [adj PARENTALLY]\n",
  "PARENTALLY": "PARENTAL, pertaining to a parent [adv]\n",
  "PARENTED": "PARENT, to act as father or mother [v]\n",
  "PARENTERAL": "entering the body by injection rather than through digestion [adj PARENTERALLY]\n",
  "PARENTERALLY": "PARENTERAL, entering the body by injection rather than through digestion [adv]\n",
  "PARENTHESES": "PARENTHESIS, an amplifying or explanatory word, phrase, or sentence inserted in a passage from which it is usually set off by punctuation [n]\n",
  "PARENTHESIS": "an amplifying or explanatory word, phrase, or sentence inserted in a passage from which it is usually set off by punctuation [n PARENTHESES]\n",
  "PARENTHESISE": "to put in parentheses, also PARENTHESIZE [v PARENTHESISED, PARENTHESISING, PARENTHESISES]\n",
  "PARENTHESISED": "PARENTHESISE, to put in parentheses, also PARENTHESIZE [v]\n",
  "PARENTHESISES": "PARENTHESISE, to put in parentheses, also PARENTHESIZE [v]\n",
  "PARENTHESISING": "PARENTHESISE, to put in parentheses, also PARENTHESIZE [v]\n",
  "PARENTHESIZE": "to put in parentheses, also PARENTHESISE [v PARENTHESIZED, PARENTHESIZING, PARENTHESIZES]\n",
  "PARENTHESIZED": "PARENTHESIZE, to put in parentheses, also PARENTHESISE [v]\n",
  "PARENTHESIZES": "PARENTHESIZE, to put in parentheses, also PARENTHESISE [v]\n",
  "PARENTHESIZING": "PARENTHESIZE, to put in parentheses, also PARENTHESISE [v]\n",
  "PARENTHETIC": "relating to parenthesis, also PARENTHETICAL [adj PARENTHETICALLY]\n",
  "PARENTHETICAL": "relating to parenthesis, also PARENTHETIC [adj PARENTHETICALLY]\n",
  "PARENTHETICALLY": "PARENTHETICAL, relating to parenthesis, also PARENTHETIC [adv]\n",
  "PARENTHOOD": "the state of being a parent [n -S]\n",
  "PARENTHOODS": "PARENTHOOD, the state of being a parent [n]\n",
  "PARENTING": "the act of parenting [n -S]\n",
  "PARENTINGS": "PARENTING, the act of parenting [n]\n",
  "PARENTLESS": "without parents [adj]\n",
  "PARENTS": "PARENT, to act as father or mother [v]\n",
  "PAREO": "(Tahitian) a Polynesian wraparound skirt, also PAREU [n -S]\n",
  "PAREOS": "PAREO, (Tahitian) a Polynesian wraparound skirt, also PAREU [n]\n",
  "PARER": "an instrument for paring e.g. apples [n -S]\n",
  "PARERA": "(Maori) a New Zealand duck with brown-edged grey feathers [n -S]\n",
  "PARERAS": "PARERA, (Maori) a New Zealand duck with brown-edged grey feathers [n]\n",
  "PARERGA": "PARERGON, (Greek) a piece of work undertaken in addition to one's principal employment [n]\n",
  "PARERGON": "(Greek) a piece of work undertaken in addition to one's principal employment [n PARERGA]\n",
  "PARERS": "PARER, an instrument for paring e.g. apples [n]\n",
  "PARES": "PARE, to shave or cut off the outer surface [v]\n",
  "PARESES": "PARESIS, (Greek) a partial form of paralysis affecting muscle movements but not diminishing sensation [n]\n",
  "PARESIS": "(Greek) a partial form of paralysis affecting muscle movements but not diminishing sensation [n PARESES]\n",
  "PARESTHESIA": "a tingling sensation on the skin, also PARAESTHESIA [n -S]\n",
  "PARESTHESIAS": "PARESTHESIA, a tingling sensation on the skin, also PARAESTHESIA [n]\n",
  "PARESTHETIC": "relating to paresthesia [adj]\n",
  "PARETIC": "one affected with paresis [n -S]\n",
  "PARETICS": "PARETIC, one affected with paresis [n]\n",
  "PAREU": "(Tahitian) a Polynesian wraparound skirt, also PAREO [n -S]\n",
  "PAREUS": "PAREU, (Tahitian) a Polynesian wraparound skirt, also PAREO [n]\n",
  "PAREV": "(Yiddish) of food, containing neither dairy nor meat ingredients, also PAREVE, PARVE [adj]\n",
  "PAREVE": "(Yiddish) of food, containing neither dairy nor meat ingredients; (slang) wishy-washy, also PAREV, PARVE [adj]\n",
  "PARFAIT": "(French) a dessert mousse or ice-cream pudding [n -S]\n",
  "PARFAITS": "PARFAIT, (French) a dessert mousse or ice-cream pudding [n]\n",
  "PARFLECHE": "(French) rawhide soaked in lye and water, then dried on a stretcher for shields, also PARFLESH [n -S]\n",
  "PARFLECHES": "PARFLECHE, (French) rawhide soaked in lye and water, then dried on a stretcher for shields, also PARFLESH [n]\n",
  "PARFLESH": "a rawhide soaked in lye and dried [n -ES]\n",
  "PARFLESHES": "PARFLESH, a rawhide soaked in lye and dried [n]\n",
  "PARFOCAL": "having lenses with corresponding focal points in the same plane [adj]\n",
  "PARFOCALISE": "to make parfocal, also PARFOCALIZE [v PARFOCALISED, PARFOCALISING, PARFOCALISES]\n",
  "PARFOCALISED": "PARFOCALISE, to make parfocal, also PARFOCALIZE [v]\n",
  "PARFOCALISES": "PARFOCALISE, to make parfocal, also PARFOCALIZE [v]\n",
  "PARFOCALISING": "PARFOCALISE, to make parfocal, also PARFOCALIZE [v]\n",
  "PARFOCALITIES": "PARFOCALITY, the state of being parfocal [n]\n",
  "PARFOCALITY": "the state of being parfocal [n PARFOCALITIES]\n",
  "PARFOCALIZE": "to make parfocal, also PARFOCALISE [v PARFOCALIZED, PARFOCALIZING, PARFOCALIZES]\n",
  "PARFOCALIZED": "PARFOCALIZE, to make parfocal, also PARFOCALISE [v]\n",
  "PARFOCALIZES": "PARFOCALIZE, to make parfocal, also PARFOCALISE [v]\n",
  "PARFOCALIZING": "PARFOCALIZE, to make parfocal, also PARFOCALISE [v]\n",
  "PARGANA": "(Hindi) a division of an administrative district or zillah in India, also PERGUNNAH [n -S]\n",
  "PARGANAS": "PARGANA, (Hindi) a division of an administrative district or zillah in India, also PERGUNNAH [n]\n",
  "PARGASITE": "a dark green aluminous variety of amphibole, or hornblende [n -S]\n",
  "PARGASITES": "PARGASITE, a dark green aluminous variety of amphibole, or hornblende [n]\n",
  "PARGE": "to cover with plaster, also PARGET [v PARGED, PARGING, PARGES]\n",
  "PARGED": "PARGE, to cover with plaster, also PARGET [v]\n",
  "PARGES": "PARGE, to cover with plaster, also PARGET [v]\n",
  "PARGET": "to cover with plaster, also PARGE [v PARGETTED or PARGETED, PARGETTING or PARGETING, PARGETS]\n",
  "PARGETED": "PARGET, to cover with plaster, also PARGE [v]\n",
  "PARGETER": "one who pargets, plasters, also PARGETTER [n -S]\n",
  "PARGETERS": "PARGETER, one who pargets, plasters, also PARGETTER [n]\n",
  "PARGETING": "ornamental plasterwork [n -S]\n",
  "PARGETINGS": "PARGETING, ornamental plasterwork [n]\n",
  "PARGETS": "PARGET, to cover with plaster, also PARGE [v]\n",
  "PARGETTED": "PARGET, to cover with plaster, also PARGE [v]\n",
  "PARGETTER": "one who pargets, plasters, also PARGETER [n -S]\n",
  "PARGETTERS": "PARGETTER, one who pargets, plasters, also PARGETER [n]\n",
  "PARGETTING": "ornamental plasterwork, also PARGETING [n -S]\n",
  "PARGETTINGS": "PARGETTING, ornamental plasterwork, also PARGETING [n]\n",
  "PARGING": "a thin coat of mortar for sealing masonry [n -S]\n",
  "PARGINGS": "PARGING, a thin coat of mortar for sealing masonry [n]\n",
  "PARGO": "(Spanish) a kind of food fish [n -ES or -S]\n",
  "PARGOES": "PARGO, (Spanish) a kind of food fish [n]\n",
  "PARGOS": "PARGO, (Spanish) a kind of food fish [n]\n",
  "PARGYLINE": "a monoamine oxidase inhibitor [n -S]\n",
  "PARGYLINES": "PARGYLINE, a monoamine oxidase inhibitor [n]\n",
  "PARHELIA": "PARHELION, a halolike light seen in sky opposite the sun [n]\n",
  "PARHELIACAL": "of or pertaining to a parhelion, a halolike light seen in sky opposite the sun, also PARHELIC [adj]\n",
  "PARHELIC": "of or pertaining to a parhelion, a halolike light seen in sky opposite the sun, also PARHELIACAL [adj]\n",
  "PARHELION": "a halolike light seen in sky opposite the sun [n PARHELIA or PARHELIONS]\n",
  "PARHELIONS": "PARHELION, a halolike light seen in sky opposite the sun [n]\n",
  "PARHYPATE": "(Greek) in Greek music, the lowest note but one in a tetrachord [n -S]\n",
  "PARHYPATES": "PARHYPATE, (Greek) in Greek music, the lowest note but one in a tetrachord [n]\n",
  "PARIAH": "(Tamil) a person of low or no caste; a social outcast [n -S]\n",
  "PARIAHS": "PARIAH, (Tamil) a person of low or no caste; a social outcast [n]\n",
  "PARIAL": "a pair-royal, a throw of three dice all the same, also PAIRIAL, PRIAL [n -S]\n",
  "PARIALS": "PARIAL, a pair-royal, a throw of three dice all the same, also PAIRIAL, PRIAL [n]\n",
  "PARIAN": "a hard white porcelain from Paros, an island in the Aegean Sea [n -S]\n",
  "PARIANS": "PARIAN, a hard white porcelain from Paros, an island in the Aegean Sea [n]\n",
  "PARIES": "(Latin) the wall of an organ [n PARIETES]\n",
  "PARIETAL": "a bone of the skull [n -S]\n",
  "PARIETALS": "PARIETAL, a bone of the skull [n]\n",
  "PARIETES": "PARIES, (Latin) the wall of an organ [n]\n",
  "PARING": "something pared off [n -S]\n",
  "PARINGS": "PARING, something pared off [n]\n",
  "PARIPINNATE": "pinnate without a terminal leaflet [adj]\n",
  "PARIS": "a plant, herb Paris, once used as a narcotic [n -ES]\n",
  "PARISCHAN": "(Scots) a parish, also PARISCHANE, PARISHEN, PAROCHIN, PAROCHINE [n -S]\n",
  "PARISCHANE": "(Scots) a parish, also PARISCHAN, PARISHEN, PAROCHIN, PAROCHINE [n -S]\n",
  "PARISCHANES": "PARISCHANE, (Scots) a parish, also PARISCHAN, PARISHEN, PAROCHIN, PAROCHINE [n]\n",
  "PARISCHANS": "PARISCHAN, (Scots) a parish, also PARISCHANE, PARISHEN, PAROCHIN, PAROCHINE [n]\n",
  "PARISES": "PARIS, a plant, herb Paris, once used as a narcotic [n]\n",
  "PARISH": "a subdivision of a diocese, usually having its own church and a priest or pastor [n -ES]\n",
  "PARISHAD": "(Hindi) an Indian assembly [n -S]\n",
  "PARISHADS": "PARISHAD, (Hindi) an Indian assembly [n]\n",
  "PARISHEN": "(Scots) a parish, also PARISCHAN, PARISCHANE, PAROCHIN, PAROCHINE [n -S]\n",
  "PARISHENS": "PARISHEN, (Scots) a parish, also PARISCHAN, PARISCHANE, PAROCHIN, PAROCHINE [n]\n",
  "PARISHES": "PARISH, a subdivision of a diocese, usually having its own church and a priest or pastor [n]\n",
  "PARISHIONER": "a member or inhabitant of a parish [n -S]\n",
  "PARISHIONERS": "PARISHIONER, a member or inhabitant of a parish [n]\n",
  "PARISON": "(French) a lump of glass before it is moulded into its final shape [n -S]\n",
  "PARISONS": "PARISON, (French) a lump of glass before it is moulded into its final shape [n]\n",
  "PARISYLLABIC": "having the same number of syllables in all forms [adj]\n",
  "PARITIES": "PARITY, equality of status; the condition or fact of having born children [n]\n",
  "PARITOR": "(Shakespeare) an officer in court who attends to execute orders, also APPARITOR [n -S]\n",
  "PARITORS": "PARITOR, (Shakespeare) an officer in court who attends to execute orders, also APPARITOR [n]\n",
  "PARITY": "equality of status; the condition or fact of having born children [n PARITIES]\n",
  "PARK": "to leave a vehicle in a certain location for a time [v -ED, -ING, -S]\n",
  "PARKA": "a fur shirt or coat with a hood, also PARKEE, PARKI [n -S]\n",
  "PARKADE": "(Canadian) a multilevel structure for parking vehicles [n -S]\n",
  "PARKADES": "PARKADE, (Canadian) a multilevel structure for parking vehicles [n]\n",
  "PARKAS": "PARKA, a fur shirt or coat with a hood, also PARKEE, PARKI [n]\n",
  "PARKED": "PARK, to leave a vehicle in a certain location for a time [v]\n",
  "PARKEE": "a fur shirt or coat with a hood, also PARKA, PARKI [n -S]\n",
  "PARKEES": "PARKEE, a fur shirt or coat with a hood, also PARKA, PARKI [n]\n",
  "PARKER": "a park-keeper [n -S]\n",
  "PARKERS": "PARKER, a park-keeper [n]\n",
  "PARKETTE": "(Canadian) a small public park [n -S]\n",
  "PARKETTES": "PARKETTE, (Canadian) a small public park [n]\n",
  "PARKI": "a fur shirt or coat with a hood, also PARKA, PARKEE [n -S]\n",
  "PARKIE": "(colloquial) a park-keeper [n -S]\n",
  "PARKIER": "PARKY, (colloquial) chilly [adj]\n",
  "PARKIES": "PARKIE, (colloquial) a park-keeper [n]\n",
  "PARKIEST": "PARKY, (colloquial) chilly [adj]\n",
  "PARKIN": "a north of England ginger cake made with treacle and oatmeal, also PERKIN [n -S]\n",
  "PARKING": "an area in which vehicles may be left [n -S]\n",
  "PARKINGS": "PARKING, an area in which vehicles may be left [n]\n",
  "PARKINS": "PARKIN, a north of England ginger cake made with treacle and oatmeal, also PERKIN [n]\n",
  "PARKINSONIAN": "one suffering from Parkinson's disease [n -S]\n",
  "PARKINSONIANS": "PARKINSONIAN, one suffering from Parkinson's disease [n]\n",
  "PARKINSONISM": "Parkinson's disease [n -S]\n",
  "PARKINSONISMS": "PARKINSONISM, Parkinson's disease [n]\n",
  "PARKIS": "PARKI, a fur shirt or coat with a hood, also PARKA, PARKEE [n]\n",
  "PARKISH": "resembling a park [adj]\n",
  "PARKLAND": "a cared-for area with lawn, trees and shrubs [n -S]\n",
  "PARKLANDS": "PARKLAND, a cared-for area with lawn, trees and shrubs [n]\n",
  "PARKLEAVES": "a European species of Saint John's-wort, aka tutsan [n PARKLEAVES]\n",
  "PARKLIKE": "like a park [adj]\n",
  "PARKLY": "like a park [adj]\n",
  "PARKOUR": "a recreational pursuit in which participants traverse urban structures by running, jumping, vaulting, rolling, etc. [n -S]\n",
  "PARKOURS": "PARKOUR, a recreational pursuit in which participants traverse urban structures by running, jumping, vaulting, rolling, etc. [n]\n",
  "PARKS": "PARK, to leave a vehicle in a certain location for a time [v]\n",
  "PARKWARD": "towards a park, also PARKWARDS [adv]\n",
  "PARKWARDS": "towards a park, also PARKWARD [adv]\n",
  "PARKWAY": "a broad road adorned with turf and trees [n -S]\n",
  "PARKWAYS": "PARKWAY, a broad road adorned with turf and trees [n]\n",
  "PARKY": "(colloquial) chilly [adj PARKIER, PARKIEST]\n",
  "PARLANCE": "a manner of speaking [n -S]\n",
  "PARLANCES": "PARLANCE, a manner of speaking [n]\n",
  "PARLANDO": "(Italian) sung in a manner suggestive of speech, also PARLANTE [adj]\n",
  "PARLANTE": "(Italian) sung in a manner suggestive of speech, also PARLANDO [adj]\n",
  "PARLAY": "to wager original winnings on a new bet [v -ED, -ING, -S]\n",
  "PARLAYED": "PARLAY, to wager original winnings on a new bet [v]\n",
  "PARLAYING": "PARLAY, to wager original winnings on a new bet [v]\n",
  "PARLAYS": "PARLAY, to wager original winnings on a new bet [v]\n",
  "PARLE": "to discuss terms with an enemy, also PARLEY [v PARLED, PARLING, PARLES]\n",
  "PARLED": "PARLE, to discuss terms with an enemy, also PARLEY [v]\n",
  "PARLEMENT": "parliament [n -S]\n",
  "PARLEMENTS": "PARLEMENT, parliament [n]\n",
  "PARLES": "PARLE, to discuss terms with an enemy, also PARLEY [v]\n",
  "PARLEY": "to discuss terms with an enemy, also PARLE [v -ED, -ING, -S]\n",
  "PARLEYED": "PARLEY, to discuss terms with an enemy, also PARLE [v]\n",
  "PARLEYER": "one who parleys [n -S]\n",
  "PARLEYERS": "PARLEYER, one who parleys [n]\n",
  "PARLEYING": "PARLEY, to discuss terms with an enemy, also PARLE [v]\n",
  "PARLEYS": "PARLEY, to discuss terms with an enemy, also PARLE [v]\n",
  "PARLEYVOO": "(slang) to speak French [v -ED, -ING, -S]\n",
  "PARLEYVOOED": "PARLEYVOO, (slang) to speak French [v]\n",
  "PARLEYVOOING": "PARLEYVOO, (slang) to speak French [v]\n",
  "PARLEYVOOS": "PARLEYVOO, (slang) to speak French [v]\n",
  "PARLIAMENT": "a formal conference for the discussion of public affairs [n -S]\n",
  "PARLIAMENTARIAN": "an adherent of the parliament in opposition to the king during the English Civil War [n]\n",
  "PARLIAMENTARILY": "PARLIAMENTARY, of or relating to a parliament [adv]\n",
  "PARLIAMENTARISM": "belief in the parliamentary system [n]\n",
  "PARLIAMENTARY": "of or relating to a parliament [adj PARLIAMENTARILY]\n",
  "PARLIAMENTING": "acting as a member of parliament; debating [n -S]\n",
  "PARLIAMENTINGS": "PARLIAMENTING, acting as a member of parliament; debating [n]\n",
  "PARLIAMENTS": "PARLIAMENT, a formal conference for the discussion of public affairs [n]\n",
  "PARLIES": "PARLY, (Scots) a gingerbread cake in biscuit form [n]\n",
  "PARLING": "PARLE, to discuss terms with an enemy, also PARLEY [v]\n",
  "PARLOR": "a room for the entertainment of visitors, also PARLOUR [n -S]\n",
  "PARLORS": "PARLOR, a room for the entertainment of visitors, also PARLOUR [n]\n",
  "PARLOUR": "a room for the entertainment of visitors, also PARLOR [n -S]\n",
  "PARLOURMAID": "a female servant in a private home who serves at the table, keeps the house clean and answers the door to guests [n -S]\n",
  "PARLOURMAIDS": "PARLOURMAID, a female servant in a private home who serves at the table, keeps the house clean and answers the door to guests [n]\n",
  "PARLOURS": "PARLOUR, a room for the entertainment of visitors, also PARLOR [n]\n",
  "PARLOUS": "perilous, also PERICULOUS, PERILOUS, PERLOUS [adj PARLOUSLY]\n",
  "PARLOUSLY": "PARLOUS, perilous, also PERICULOUS, PERILOUS, PERLOUS [adv]\n",
  "PARLOUSNESS": "the state of being parlous [n -ES]\n",
  "PARLOUSNESSES": "PARLOUSNESS, the state of being parlous [n]\n",
  "PARLY": "(Scots) a gingerbread cake in biscuit form [n PARLIES]\n",
  "PARMA": "(Australian) a dish of chicken in breadcrumbs, topped with Parmesan cheese and a tomato sauce, and served with ham or bacon [n -S]\n",
  "PARMACITIE": "(Shakespeare) spermaceti, also SPERMACETI [n -S]\n",
  "PARMACITIES": "PARMACITIE, (Shakespeare) spermaceti, also SPERMACETI [n]\n",
  "PARMAS": "PARMA, (Australian) a dish of chicken in breadcrumbs, topped with Parmesan cheese and a tomato sauce, and served with ham or bacon [n]\n",
  "PARMESAN": "(Italian) a hard, dry Italian cheese [n -S]\n",
  "PARMESANS": "PARMESAN, (Italian) a hard, dry Italian cheese [n]\n",
  "PARMIGIANA": "(Italian) made or covered with Parmesan cheese, also PARMIGIANO [adj]\n",
  "PARMIGIANO": "(Italian) parmesan cheese, also PARMIGIANA [n -S]\n",
  "PARMIGIANOS": "PARMIGIANO, (Italian) parmesan cheese, also PARMIGIANA [n]\n",
  "PAROCCIPITAL": "the area next to the mastoid process [n -S]\n",
  "PAROCCIPITALS": "PAROCCIPITAL, the area next to the mastoid process [n]\n",
  "PAROCHIAL": "local; confined to one region [adj PAROCHIALLY]\n",
  "PAROCHIALISE": "to make parochial, also PAROCHIALIZE [v PAROCHIALISED, PAROCHIALISING, PAROCHIALISES]\n",
  "PAROCHIALISED": "PAROCHIALISE, to make parochial, also PAROCHIALIZE [v]\n",
  "PAROCHIALISES": "PAROCHIALISE, to make parochial, also PAROCHIALIZE [v]\n",
  "PAROCHIALISING": "PAROCHIALISE, to make parochial, also PAROCHIALIZE [v]\n",
  "PAROCHIALISM": "the state of being parochial [n -S]\n",
  "PAROCHIALISMS": "PAROCHIALISM, the state of being parochial [n]\n",
  "PAROCHIALITIES": "PAROCHIALITY, the state of being parochial [n]\n",
  "PAROCHIALITY": "the state of being parochial [n PAROCHIALITIES]\n",
  "PAROCHIALIZE": "to make parochial, also PAROCHIALISE [v PAROCHIALIZED, PAROCHIALIZING, PAROCHIALIZES]\n",
  "PAROCHIALIZED": "PAROCHIALIZE, to make parochial, also PAROCHIALISE [v]\n",
  "PAROCHIALIZES": "PAROCHIALIZE, to make parochial, also PAROCHIALISE [v]\n",
  "PAROCHIALIZING": "PAROCHIALIZE, to make parochial, also PAROCHIALISE [v]\n",
  "PAROCHIALLY": "PAROCHIAL, local; confined to one region [adv]\n",
  "PAROCHIN": "(Scots) a parish, also PARISCHAN, PARISCHANE, PARISHEN, PAROCHINE [n -S]\n",
  "PAROCHINE": "(Scots) a parish, also PARISCHAN, PARISCHANE, PARISHEN, PAROCHIN [n -S]\n",
  "PAROCHINES": "PAROCHINE, (Scots) a parish, also PARISCHAN, PARISCHANE, PARISHEN, PAROCHIN [n]\n",
  "PAROCHINS": "PAROCHIN, (Scots) a parish, also PARISCHAN, PARISCHANE, PARISHEN, PAROCHINE [n]\n",
  "PARODIC": "having the character of parody, also PARODICAL [adj]\n",
  "PARODICAL": "having the character of parody, also PARODIC [adj]\n",
  "PARODIED": "PARODY, to imitate in a satirical manner for comic effect [v]\n",
  "PARODIES": "PARODY, to imitate in a satirical manner for comic effect [v]\n",
  "PARODIST": "one who composes parodies [n -S]\n",
  "PARODISTIC": "relating to parody [adj]\n",
  "PARODISTS": "PARODIST, one who composes parodies [n]\n",
  "PARODOI": "PARODOS, (Greek) an ode sung in ancient Greek drama [n]\n",
  "PARODOS": "(Greek) an ode sung in ancient Greek drama [n PARODOI]\n",
  "PARODY": "to imitate in a satirical manner for comic effect [v PARODIED, PARODYING, PARODIES]\n",
  "PARODYING": "PARODY, to imitate in a satirical manner for comic effect [v]\n",
  "PAROECIOUS": "of certain mosses, having the male and female reproductive organs near one another, also PARECIOUS, PAROICOUS [adj]\n",
  "PAROECISM": "the state of having the male and female reproductive organs at different levels on the same stem, also PARECISM [n -S]\n",
  "PAROECISMS": "PAROECISM, the state of having the male and female reproductive organs at different levels on the same stem, also PARECISM [n]\n",
  "PAROEMIA": "(Greek) a proverb, adage or saying [n -S]\n",
  "PAROEMIAC": "the anapaestic dimeter catalectic [n -S]\n",
  "PAROEMIACS": "PAROEMIAC, the anapaestic dimeter catalectic [n]\n",
  "PAROEMIAL": "relating to paroemia, a proverb, adage or saying [adj]\n",
  "PAROEMIAS": "PAROEMIA, (Greek) a proverb, adage or saying [n]\n",
  "PAROEMIOGRAPHER": "a writer of proverbs [n]\n",
  "PAROEMIOGRAPHY": "the study of proverbs [n]\n",
  "PAROEMIOLOGIES": "PAROEMIOLOGY, the study of proverbs [n]\n",
  "PAROEMIOLOGY": "the study of proverbs [n PAROEMIOLOGIES]\n",
  "PAROICOUS": "of certain mosses, having the male and female reproductive organs near one another, also PARECIOUS, PAROECIOUS [adj]\n",
  "PAROL": "given by word of mouth, as in parol evidence [adj] / a parole [n -S]\n",
  "PAROLABLE": "that can be paroled [adj]\n",
  "PAROLE": "to give a conditional release of a prisoner [v PAROLED, PAROLING, PAROLES]\n",
  "PAROLED": "PAROLE, to give a conditional release of a prisoner [v]\n",
  "PAROLEE": "one who is paroled [n -S]\n",
  "PAROLEES": "PAROLEE, one who is paroled [n]\n",
  "PAROLES": "PAROLE, to give a conditional release of a prisoner [v]\n",
  "PAROLING": "PAROLE, to give a conditional release of a prisoner [v]\n",
  "PAROLS": "PAROL, a parole [n]\n",
  "PARONOMASIA": "a play on words, a pun [n -S]\n",
  "PARONOMASIAS": "PARONOMASIA, a play on words, a pun [n]\n",
  "PARONOMASIES": "PARONOMASY, (obsolete) paronomasia [n]\n",
  "PARONOMASTIC": "relating to paronomasia, play on words, also PARONOMASTICAL [adj]\n",
  "PARONOMASTICAL": "relating to paronomasia, play on words, also PARONOMASTIC [adj]\n",
  "PARONOMASY": "(obsolete) paronomasia [n PARONOMASIES]\n",
  "PARONYCHIA": "a whitlow, or felon [n -S]\n",
  "PARONYCHIAL": "relating to a paronychia, a whitlow [adj]\n",
  "PARONYCHIAS": "PARONYCHIA, a whitlow, or felon [n]\n",
  "PARONYM": "a word having the same root as another [n -S]\n",
  "PARONYMIC": "of or like a paronym [adj]\n",
  "PARONYMIES": "PARONYMY, a relationship of two words having the same sound [n]\n",
  "PARONYMOUS": "having the nature of a paronym [adj PARONYMOUSLY]\n",
  "PARONYMOUSLY": "PARONYMOUS, having the nature of a paronym [adv]\n",
  "PARONYMS": "PARONYM, a word having the same root as another [n]\n",
  "PARONYMY": "a relationship of two words having the same sound [n PARONYMIES]\n",
  "PAROQUET": "a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PARRAKEET, PARROKET, PARROQUET [n -S]\n",
  "PAROQUETS": "PAROQUET, a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PARRAKEET, PARROKET, PARROQUET [n]\n",
  "PARORE": "(Maori) a type of fish found around New Zealand and Australia [n -S]\n",
  "PARORES": "PARORE, (Maori) a type of fish found around New Zealand and Australia [n]\n",
  "PAROSMIA": "a distortion of the sense of smell [n -S]\n",
  "PAROSMIAS": "PAROSMIA, a distortion of the sense of smell [n]\n",
  "PAROTIC": "situated near the ear, also PAROTID, PAROTIS [adj]\n",
  "PAROTID": "near the ear, also PAROTIC [adj] / a gland situated near the ear, also PAROTIS [n -S]\n",
  "PAROTIDES": "PAROTIS, (Greek) the parotid gland, near the ear, also PAROTID [n]\n",
  "PAROTIDITIC": "relating to parotiditis, inflammation of the parotid gland [adj]\n",
  "PAROTIDITIS": "inflammation of the parotid gland, as in mumps, also PAROTITIS [n -ES]\n",
  "PAROTIDITISES": "PAROTIDITIS, inflammation of the parotid gland, as in mumps, also PAROTITIS [n]\n",
  "PAROTIDS": "PAROTID, a gland situated near the ear, also PAROTIS [n]\n",
  "PAROTIS": "(Greek) the parotid gland, near the ear, also PAROTID [n PAROTIDES or PAROTISES]\n",
  "PAROTISES": "PAROTIS, (Greek) the parotid gland, near the ear, also PAROTID [n]\n",
  "PAROTITIC": "of or like parotitis, inflammation of the parotid glands [adj]\n",
  "PAROTITIDES": "PAROTITIS, inflammation of the parotid glands, as in mumps, also PAROTIDITIS [n]\n",
  "PAROTITIS": "inflammation of the parotid glands, as in mumps, also PAROTIDITIS [n PAROTITISES or PAROTITIDES]\n",
  "PAROTITISES": "PAROTITIS, inflammation of the parotid glands, as in mumps, also PAROTIDITIS [n]\n",
  "PAROTOID": "any of various glands which form warty excrescences behind the eyes in some amphibians, esp. toads [n -S]\n",
  "PAROTOIDS": "PAROTOID, any of various glands which form warty excrescences behind the eyes in some amphibians, esp. toads [n]\n",
  "PAROUS": "bearing or having borne offspring [adj]\n",
  "PAROUSIA": "(Greek) a coming, esp. the second coming of Christ [n -S]\n",
  "PAROUSIAS": "PAROUSIA, (Greek) a coming, esp. the second coming of Christ [n]\n",
  "PAROXETINE": "a kind of antidepressant drug [n -S]\n",
  "PAROXETINES": "PAROXETINE, a kind of antidepressant drug [n]\n",
  "PAROXYSM": "a sudden fit or attack [n -S]\n",
  "PAROXYSMAL": "of the nature of a paroxysm [adj PAROXYSMALLY]\n",
  "PAROXYSMALLY": "PAROXYSMAL, of the nature of a paroxysm [adv]\n",
  "PAROXYSMIC": "relating to paroxysm [adj]\n",
  "PAROXYSMS": "PAROXYSM, a sudden fit or attack [n]\n",
  "PAROXYTONE": "a word having an acute accent on the penultimate syllable [n -S]\n",
  "PAROXYTONES": "PAROXYTONE, a word having an acute accent on the penultimate syllable [n]\n",
  "PAROXYTONIC": "like a paroxytone [adj]\n",
  "PARP": "to sound a car horn; to toot [v -ED, -ING, -S]\n",
  "PARPANE": "a stone passing through a wall from face to face, also PARPEN, PARPEND, PARPENT, PARPOINT, PERPENT [n -S]\n",
  "PARPANES": "PARPANE, a stone passing through a wall from face to face, also PARPEN, PARPEND, PARPENT, PARPOINT, PERPENT [n]\n",
  "PARPED": "PARP, to sound a car horn; to toot [v]\n",
  "PARPEN": "a stone passing through a wall from face to face, also PARPANE, PARPEND, PARPENT, PARPOINT, PERPENT [n -S]\n",
  "PARPEND": "a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPENT, PARPOINT, PERPENT [n -S]\n",
  "PARPENDS": "PARPEND, a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPENT, PARPOINT, PERPENT [n]\n",
  "PARPENS": "PARPEN, a stone passing through a wall from face to face, also PARPANE, PARPEND, PARPENT, PARPOINT, PERPENT [n]\n",
  "PARPENT": "a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPEND, PARPOINT, PERPENT [n -S]\n",
  "PARPENTS": "PARPENT, a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPEND, PARPOINT, PERPENT [n]\n",
  "PARPING": "PARP, to sound a car horn; to toot [v]\n",
  "PARPOINT": "a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPEND, PARPENT, PERPENT [n -S]\n",
  "PARPOINTS": "PARPOINT, a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPEND, PARPENT, PERPENT [n]\n",
  "PARPS": "PARP, to sound a car horn; to toot [v]\n",
  "PARQUET": "(French) to cover a floor with an inlaid design [v PARQUETED or PARQUETTED, PARQUETING or PARQUETTING, PARQUETS]\n",
  "PARQUETED": "PARQUET, (French) to cover a floor with an inlaid design [v]\n",
  "PARQUETING": "PARQUET, (French) to cover a floor with an inlaid design [v]\n",
  "PARQUETRIES": "PARQUETRY, the art of making parquet, a floor-covering of fitted wooden blocks [n]\n",
  "PARQUETRY": "the art of making parquet, a floor-covering of fitted wooden blocks [n PARQUETRIES]\n",
  "PARQUETS": "PARQUET, (French) to cover a floor with an inlaid design [v]\n",
  "PARQUETTED": "PARQUET, (French) to cover a floor with an inlaid design [v]\n",
  "PARQUETTING": "PARQUET, (French) to cover a floor with an inlaid design [v]\n",
  "PARR": "a young salmon, during its freshwater days [n -S]\n",
  "PARRA": "(Australian slang) a tourist or nonresident on a beach [n -S]\n",
  "PARRAKEET": "a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PAROQUET, PARROKET, PARROQUET [n -S]\n",
  "PARRAKEETS": "PARRAKEET, a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PAROQUET, PARROKET, PARROQUET [n]\n",
  "PARRAL": "a sliding loop of rope or chain used on a ship, also PARREL [n -S]\n",
  "PARRALS": "PARRAL, a sliding loop of rope or chain used on a ship, also PARREL [n]\n",
  "PARRAMATTA": "a cotton or silk and wool dress material, also PARAMATTA [n -S]\n",
  "PARRAMATTAS": "PARRAMATTA, a cotton or silk and wool dress material, also PARAMATTA [n]\n",
  "PARRAS": "PARRA, (Australian slang) a tourist or nonresident on a beach [n]\n",
  "PARRED": "PAR, to score a certain number of golf strokes [v]\n",
  "PARREL": "a sliding loop of rope or chain used on a ship, also PARRAL [n -S]\n",
  "PARRELS": "PARREL, a sliding loop of rope or chain used on a ship, also PARRAL [n]\n",
  "PARRHESIA": "freedom or boldness of speech [n -S]\n",
  "PARRHESIAS": "PARRHESIA, freedom or boldness of speech [n]\n",
  "PARRICIDAL": "of or pertaining to parricide, also PATRICIDAL [adj]\n",
  "PARRICIDE": "the killing of a parent or close relative, also PATRICIDE [n -S]\n",
  "PARRICIDES": "PARRICIDE, the killing of a parent or close relative, also PATRICIDE [n]\n",
  "PARRIDGE": "(Scots) a soft meal of oatmeal, also PORRIDGE, PARRITCH [n -S]\n",
  "PARRIDGES": "PARRIDGE, (Scots) a soft meal of oatmeal, also PORRIDGE, PARRITCH [n]\n",
  "PARRIED": "PARRY, to ward off a blow [v]\n",
  "PARRIER": "one who parries [n -S]\n",
  "PARRIERS": "PARRIER, one who parries [n]\n",
  "PARRIES": "PARRY, to ward off a blow [v]\n",
  "PARRING": "PAR, to score a certain number of golf strokes [v]\n",
  "PARRITCH": "(Scots) a soft meal of oatmeal, also PORRIDGE, PARRIDGE [n -ES]\n",
  "PARRITCHES": "PARRITCH, (Scots) a soft meal of oatmeal, also PORRIDGE, PARRIDGE [n]\n",
  "PARROCK": "(Scots) a croft, or small field; a paddock [n -S] / to confine in a parrock [v -ED, -ING, -S]\n",
  "PARROCKED": "PARROCK, to confine in a parrock [v]\n",
  "PARROCKING": "PARROCK, to confine in a parrock [v]\n",
  "PARROCKS": "PARROCK, to confine in a parrock [v]\n",
  "PARROKET": "a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PAROQUET, PARRAKEET, PARROQUET [n -S]\n",
  "PARROKETS": "PARROKET, a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PAROQUET, PARRAKEET, PARROQUET [n]\n",
  "PARROQUET": "a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PAROQUET, PARRAKEET, PARROKET [n -S]\n",
  "PARROQUETS": "PARROQUET, a small long-tailed parrot, also PARAKEET, PARAQUET, PARAQUITO, PAROQUET, PARRAKEET, PARROKET [n]\n",
  "PARROT": "to repeat without thought or understanding [v -ED, -ING, -S]\n",
  "PARROTED": "PARROT, to repeat without thought or understanding [v]\n",
  "PARROTER": "one who simply repeats what he has heard [n -S]\n",
  "PARROTERS": "PARROTER, one who simply repeats what he has heard [n]\n",
  "PARROTFISH": "a brightly coloured tropical fish, having parrot-like jaws [n -ES]\n",
  "PARROTFISHES": "PARROTFISH, a brightly coloured tropical fish, having parrot-like jaws [n]\n",
  "PARROTIER": "PARROTY, of or like a parrot [adj]\n",
  "PARROTIEST": "PARROTY, of or like a parrot [adj]\n",
  "PARROTING": "PARROT, to repeat without thought or understanding [v]\n",
  "PARROTRIES": "PARROTRY, unintelligent imitation [n]\n",
  "PARROTRY": "unintelligent imitation [n PARROTRIES]\n",
  "PARROTS": "PARROT, to repeat without thought or understanding [v]\n",
  "PARROTY": "of or like a parrot [adj PARROTIER, PARROTIEST]\n",
  "PARRS": "PARR, a young salmon, during its freshwater days [n]\n",
  "PARRY": "to ward off a blow [v PARRIED, PARRYING, PARRIES]\n",
  "PARRYING": "PARRY, to ward off a blow [v]\n",
  "PARS": "PAR, to score a certain number of golf strokes [v]\n",
  "PARSABLE": "able to be parsed [adj]\n",
  "PARSE": "to describe and analyze grammatically [v PARSED, PARSING, PARSES]\n",
  "PARSEC": "a unit of astronomical distance [n -S]\n",
  "PARSECS": "PARSEC, a unit of astronomical distance [n]\n",
  "PARSED": "PARSE, to describe and analyze grammatically [v]\n",
  "PARSER": "a program or routine for parsing [n -S]\n",
  "PARSERS": "PARSER, a program or routine for parsing [n]\n",
  "PARSES": "PARSE, to describe and analyze grammatically [v]\n",
  "PARSIMONIES": "PARSIMONY, sparingness or reluctance in the spending of money, also PARCIMONY [n]\n",
  "PARSIMONIOUS": "excessively sparing or frugal [adj PARSIMONIOUSLY]\n",
  "PARSIMONIOUSLY": "PARSIMONIOUS, excessively sparing or frugal [adv]\n",
  "PARSIMONY": "sparingness or reluctance in the spending of money, also PARCIMONY [n PARSIMONIES]\n",
  "PARSING": "the syntactic analysis of a sentence [n -S]\n",
  "PARSINGS": "PARSING, the syntactic analysis of a sentence [n]\n",
  "PARSLEY": "a cultivated herb [n -S]\n",
  "PARSLEYED": "adorned with parsley, also PARSLIED [adj]\n",
  "PARSLEYS": "PARSLEY, a cultivated herb [n]\n",
  "PARSLIED": "adorned with parsley, also PARSLEYED [adj]\n",
  "PARSNEP": "(obsolete) an umbelliferous plant or its edible carrot-like root, also PARSNIP [n -S]\n",
  "PARSNEPS": "PARSNEP, (obsolete) an umbelliferous plant or its edible carrot-like root, also PARSNIP [n]\n",
  "PARSNIP": "an umbelliferous plant or its edible carrot-like root, also PARSNEP [n -S]\n",
  "PARSNIPS": "PARSNIP, an umbelliferous plant or its edible carrot-like root, also PARSNEP [n]\n",
  "PARSON": "a clergyman [n -S]\n",
  "PARSONAGE": "the home of a parson [n -S]\n",
  "PARSONAGES": "PARSONAGE, the home of a parson [n]\n",
  "PARSONIC": "of or pertaining to a parson, also PARSONICAL [adj]\n",
  "PARSONICAL": "of or pertaining to a parson, also PARSONIC [adj]\n",
  "PARSONISH": "appropriate to, or like, a parson [adj]\n",
  "PARSONS": "PARSON, a clergyman [n]\n",
  "PART": "to divide, separate or break [v -ED, -ING, -S]\n",
  "PARTAKE": "to participate, also PERTAKE [v PARTOOK, PARTAKEN, PARTAKING, PARTAKES]\n",
  "PARTAKEN": "PARTAKE, to participate, also PERTAKE [v]\n",
  "PARTAKER": "one who partakes [n -S]\n",
  "PARTAKERS": "PARTAKER, one who partakes [n]\n",
  "PARTAKES": "PARTAKE, to participate, also PERTAKE [v]\n",
  "PARTAKING": "the act of partaking [n -S]\n",
  "PARTAKINGS": "PARTAKING, the act of partaking [n]\n",
  "PARTAN": "(Gaelic) a kind of edible crab [n -S]\n",
  "PARTANS": "PARTAN, (Gaelic) a kind of edible crab [n]\n",
  "PARTED": "PART, to divide, separate or break [v]\n",
  "PARTER": "one who, or which, parts or separates [n -S]\n",
  "PARTERRE": "(French) a flower garden in which beds and paths form a pattern [n -S]\n",
  "PARTERRES": "PARTERRE, (French) a flower garden in which beds and paths form a pattern [n]\n",
  "PARTERS": "PARTER, one who, or which, parts or separates [n]\n",
  "PARTHENOCARPIC": "relating to parthenocarpy [adj]\n",
  "PARTHENOCARPIES": "PARTHENOCARPY, fruit production without fertilization [n]\n",
  "PARTHENOCARPOUS": "relating to parthenocarpy [adj]\n",
  "PARTHENOCARPY": "fruit production without fertilization [n PARTHENOCARPIES]\n",
  "PARTHENOGENESES": "PARTHENOGENESIS, reproduction by a virgin or by means of an unfertilized egg [n]\n",
  "PARTHENOGENESIS": "reproduction by a virgin or by means of an unfertilized egg [n PARTHENOGENESES]\n",
  "PARTHENOGENETIC": "reproducing by parthenogenesis, reproduction by a virgin or by means of an unfertilized egg [adj]\n",
  "PARTHENOSPORE": "a thick-walled spore produced by parthenogenesis in certain algae and fungi [n -S]\n",
  "PARTHENOSPORES": "PARTHENOSPORE, a thick-walled spore produced by parthenogenesis in certain algae and fungi [n]\n",
  "PARTI": "(French) a group of people; a decision; a marriageable person considered as a match [n -S]\n",
  "PARTIAL": "not whole [adj PARTIALLY] / as in partial out, to eliminate a factor in statistics [v PARTIALLED, PARTIALLING, PARTIALS]\n",
  "PARTIALISE": "(Shakespeare) to bias, make partial, also PARTIALIZE [v PARTIALISED, PARTIALISING, PARTIALISES]\n",
  "PARTIALISED": "PARTIALISE, (Shakespeare) to bias, make partial, also PARTIALIZE [v]\n",
  "PARTIALISES": "PARTIALISE, (Shakespeare) to bias, make partial, also PARTIALIZE [v]\n",
  "PARTIALISING": "PARTIALISE, (Shakespeare) to bias, make partial, also PARTIALIZE [v]\n",
  "PARTIALISM": "partiality; specifically (theology), the doctrine of the Partialists [n -S]\n",
  "PARTIALISMS": "PARTIALISM, partiality; specifically (theology), the doctrine of the Partialists [n]\n",
  "PARTIALIST": "someone who is biased, partial [n -S]\n",
  "PARTIALISTS": "PARTIALIST, someone who is biased, partial [n]\n",
  "PARTIALITIES": "PARTIALITY, the state of being partial [n]\n",
  "PARTIALITY": "the state of being partial [n PARTIALITIES]\n",
  "PARTIALIZE": "(Shakespeare) to bias, make partial, also PARTIALISE [v PARTIALIZED, PARTIALIZING, PARTIALIZES]\n",
  "PARTIALIZED": "PARTIALIZE, (Shakespeare) to bias, make partial, also PARTIALISE [v]\n",
  "PARTIALIZES": "PARTIALIZE, (Shakespeare) to bias, make partial, also PARTIALISE [v]\n",
  "PARTIALIZING": "PARTIALIZE, (Shakespeare) to bias, make partial, also PARTIALISE [v]\n",
  "PARTIALLED": "PARTIAL, as in partial out, to eliminate a factor in statistics [v]\n",
  "PARTIALLING": "PARTIAL, as in partial out, to eliminate a factor in statistics [v]\n",
  "PARTIALLY": "PARTIAL, not whole [adv]\n",
  "PARTIALNESS": "the state of being partial [n -ES]\n",
  "PARTIALNESSES": "PARTIALNESS, the state of being partial [n]\n",
  "PARTIALS": "PARTIAL, as in partial out, to eliminate a factor in statistics [v]\n",
  "PARTIBILITIES": "PARTIBILITY, the state of being partible [n]\n",
  "PARTIBILITY": "the state of being partible [n PARTIBILITIES]\n",
  "PARTIBLE": "divisible [adj]\n",
  "PARTICIPABLE": "capable of being participated in or shared [adj]\n",
  "PARTICIPANT": "taking part [adj PARTICIPANTLY] / one that participates [n -S]\n",
  "PARTICIPANTLY": "PARTICIPANT, taking part [adv]\n",
  "PARTICIPANTS": "PARTICIPANT, one that participates [n]\n",
  "PARTICIPATE": "to take part in [v PARTICIPATED, PARTICIPATING, PARTICIPATES]\n",
  "PARTICIPATED": "PARTICIPATE, to take part in [v]\n",
  "PARTICIPATES": "PARTICIPATE, to take part in [v]\n",
  "PARTICIPATING": "PARTICIPATE, to take part in [v]\n",
  "PARTICIPATION": "the act of participating [n -S]\n",
  "PARTICIPATIONAL": "relating to participation [adj]\n",
  "PARTICIPATIONS": "PARTICIPATION, the act of participating [n]\n",
  "PARTICIPATIVE": "relating to or involving participation [adj]\n",
  "PARTICIPATOR": "one who participates [n -S]\n",
  "PARTICIPATORS": "PARTICIPATOR, one who participates [n]\n",
  "PARTICIPATORY": "characterized by or involving participation [adj]\n",
  "PARTICIPIAL": "relating to a participle [adj PARTICIPIALLY] / a clause involving a participle [n -S]\n",
  "PARTICIPIALLY": "PARTICIPIAL, relating to a participle [adv]\n",
  "PARTICIPIALS": "PARTICIPIAL, a clause involving a participle [n]\n",
  "PARTICIPLE": "a word having the characteristics of both verb and adjective [n -S]\n",
  "PARTICIPLES": "PARTICIPLE, a word having the characteristics of both verb and adjective [n]\n",
  "PARTICLE": "a very small piece or part [n -S]\n",
  "PARTICLEBOARD": "a composition board made of very small pieces of wood bonded together [n -S]\n",
  "PARTICLEBOARDS": "PARTICLEBOARD, a composition board made of very small pieces of wood bonded together [n]\n",
  "PARTICLES": "PARTICLE, a very small piece or part [n]\n",
  "PARTICOLORED": "having many colours, also PARTICOLOURED [adj]\n",
  "PARTICOLOURED": "having many colours, also PARTICOLORED [adj]\n",
  "PARTICULAR": "especial [adj PARTICULARLY] / an individual fact, point, circumstance, or detail [n -S]\n",
  "PARTICULARISE": "to state in detail, also PARTICULARIZE [v PARTICULARISED, PARTICULARISING, PARTICULARISES]\n",
  "PARTICULARISED": "PARTICULARISE, to state in detail, also PARTICULARIZE [v]\n",
  "PARTICULARISER": "one who particularises, also PARTICULARIZER [n -S]\n",
  "PARTICULARISERS": "PARTICULARISER, one who particularises, also PARTICULARIZER [n]\n",
  "PARTICULARISES": "PARTICULARISE, to state in detail, also PARTICULARIZE [v]\n",
  "PARTICULARISING": "PARTICULARISE, to state in detail, also PARTICULARIZE [v]\n",
  "PARTICULARISM": "exclusive or special devotion to a particular interest [n -S]\n",
  "PARTICULARISMS": "PARTICULARISM, exclusive or special devotion to a particular interest [n]\n",
  "PARTICULARIST": "an upholder of particularism [n -S]\n",
  "PARTICULARISTIC": "relating to particularism [adj]\n",
  "PARTICULARISTS": "PARTICULARIST, an upholder of particularism [n]\n",
  "PARTICULARITIES": "PARTICULARITY, a minute detail [n]\n",
  "PARTICULARITY": "a minute detail [n PARTICULARITIES]\n",
  "PARTICULARIZE": "to state in detail, also PARTICULARISE [v PARTICULARIZED, PARTICULARIZING, PARTICULARIZES]\n",
  "PARTICULARIZED": "PARTICULARIZE, to state in detail, also PARTICULARISE [v]\n",
  "PARTICULARIZER": "one who particularizes, also PARTICULARISER [n -S]\n",
  "PARTICULARIZERS": "PARTICULARIZER, one who particularizes, also PARTICULARISER [n]\n",
  "PARTICULARIZES": "PARTICULARIZE, to state in detail, also PARTICULARISE [v]\n",
  "PARTICULARIZING": "PARTICULARIZE, to state in detail, also PARTICULARISE [v]\n",
  "PARTICULARLY": "PARTICULAR, especial [adv]\n",
  "PARTICULARNESS": "PARTICULAR, especial [n]\n",
  "PARTICULARS": "PARTICULAR, an individual fact, point, circumstance, or detail [n]\n",
  "PARTICULATE": "having the form of particles [adj] / a particulate substance [n -S]\n",
  "PARTICULATES": "PARTICULATE, a particulate substance [n]\n",
  "PARTIED": "PARTY, to attend a social gathering [v]\n",
  "PARTIER": "one who parties, also PARTYER [n -S]\n",
  "PARTIERS": "PARTIER, one who parties, also PARTYER [n]\n",
  "PARTIES": "PARTY, to attend a social gathering [v]\n",
  "PARTIEST": "PARTY, having a party atmosphere [adj]\n",
  "PARTIM": "(Latin) in part [adv]\n",
  "PARTING": "a division or separation [n -S]\n",
  "PARTINGS": "PARTING, a division or separation [n]\n",
  "PARTIS": "PARTI, (French) a group of people; a decision; a marriageable person considered as a match [n]\n",
  "PARTISAN": "biased [adj PARTISANLY] / an adherent, esp. a blind or unreasoning adherent, of a party or a faction, also PARTIZAN [n -S]\n",
  "PARTISANLY": "in a partisan manner, also PARTIZANLY [adv]\n",
  "PARTISANS": "PARTISAN, an adherent, esp. a blind or unreasoning adherent, of a party or a faction, also PARTIZAN [n]\n",
  "PARTISANSHIP": "being a partisan, also PARTIZANSHIP [n -S]\n",
  "PARTISANSHIPS": "PARTISANSHIP, being a partisan, also PARTIZANSHIP [n]\n",
  "PARTITA": "(Italian) a suite; a set of variations [n PARTITE or PARTITAS]\n",
  "PARTITAS": "PARTITA, (Italian) a suite; a set of variations [n]\n",
  "PARTITE": "divided; (esp. of plant leaves) cut nearly to the base [adj]\n",
  "PARTITION": "the act of dividing [n -S] / to divide into shares [v -ED, -ING, -S]\n",
  "PARTITIONED": "PARTITION, to divide into shares [v]\n",
  "PARTITIONER": "one who partitions [n -S]\n",
  "PARTITIONERS": "PARTITIONER, one who partitions [n]\n",
  "PARTITIONING": "PARTITION, to divide into shares [v]\n",
  "PARTITIONIST": "an advocate of political partition [n -S]\n",
  "PARTITIONISTS": "PARTITIONIST, an advocate of political partition [n]\n",
  "PARTITIONMENT": "the act of partitioning [n -S]\n",
  "PARTITIONMENTS": "PARTITIONMENT, the act of partitioning [n]\n",
  "PARTITIONS": "PARTITION, to divide into shares [v]\n",
  "PARTITIVE": "parting, distributing [adj PARTITIVELY] / a word indicating a part of a larger whole [n -S]\n",
  "PARTITIVELY": "PARTITIVE, parting, distributing [adv]\n",
  "PARTITIVES": "PARTITIVE, a word indicating a part of a larger whole [n]\n",
  "PARTITURA": "(Italian) a score in music [n -S]\n",
  "PARTITURAS": "PARTITURA, (Italian) a score in music [n]\n",
  "PARTIZAN": "an adherent of a person, party or cause, also PARTISAN [n -S]\n",
  "PARTIZANLY": "in a partizan manner, also PARTISANLY [adv]\n",
  "PARTIZANS": "PARTIZAN, an adherent of a person, party or cause, also PARTISAN [n]\n",
  "PARTIZANSHIP": "being a partizan, also PARTISANSHIP [n -S]\n",
  "PARTIZANSHIPS": "PARTIZANSHIP, being a partizan, also PARTISANSHIP [n]\n",
  "PARTLET": "(obsolete) a covering for the neck, and sometimes for the shoulders and breast; originally worn by both sexes, but later by women alone [n -S]\n",
  "PARTLETS": "PARTLET, (obsolete) a covering for the neck, and sometimes for the shoulders and breast; originally worn by both sexes, but later by women alone [n]\n",
  "PARTLY": "in some degree [adv]\n",
  "PARTNER": "to join with in a common interest [v -ED, -ING, -S]\n",
  "PARTNERED": "PARTNER, to join with in a common interest [v]\n",
  "PARTNERING": "the act of associating with in some activity of common interest [n -S]\n",
  "PARTNERINGS": "PARTNERING, the act of associating with in some activity of common interest [n]\n",
  "PARTNERLESS": "without a partner [adj]\n",
  "PARTNERS": "PARTNER, to join with in a common interest [v]\n",
  "PARTNERSHIP": "the state of being a partner [n -S]\n",
  "PARTNERSHIPS": "PARTNERSHIP, the state of being a partner [n]\n",
  "PARTON": "a hypothetical particle that is held to be a constituent of nucleons [n -S]\n",
  "PARTONS": "PARTON, a hypothetical particle that is held to be a constituent of nucleons [n]\n",
  "PARTOOK": "PARTAKE, to participate, also PERTAKE [v]\n",
  "PARTRIDGE": "any member of a genus of game birds of the pheasant family, also PAITRICK [n -S]\n",
  "PARTRIDGEBERRY": "a North American trailing plant of the madder family [n]\n",
  "PARTRIDGES": "PARTRIDGE, any member of a genus of game birds of the pheasant family, also PAITRICK [n]\n",
  "PARTS": "PART, to divide, separate or break [v]\n",
  "PARTURE": "(Spenser) a departure [n -S]\n",
  "PARTURES": "PARTURE, (Spenser) a departure [n]\n",
  "PARTURIENCIES": "PARTURIENCY, the condition of being ready to give birth [n]\n",
  "PARTURIENCY": "the condition of being ready to give birth [n PARTURIENCIES]\n",
  "PARTURIENT": "about to bring forth young [adj] / one who is about to bring forth young [n -S]\n",
  "PARTURIENTS": "PARTURIENT, one who is about to bring forth young [n]\n",
  "PARTURIFACIENT": "an oxytocic drug or agent, used to accelerate childbirth by stimulating uterine contractions [n -S]\n",
  "PARTURIFACIENTS": "PARTURIFACIENT, an oxytocic drug or agent, used to accelerate childbirth by stimulating uterine contractions [n]\n",
  "PARTURITION": "the act of giving birth [n -S]\n",
  "PARTURITIONS": "PARTURITION, the act of giving birth [n]\n",
  "PARTWAY": "to some extent [adv]\n",
  "PARTWORK": "one of a magazine series which builds to a complete work [n -S]\n",
  "PARTWORKS": "PARTWORK, one of a magazine series which builds to a complete work [n]\n",
  "PARTY": "having a party atmosphere [adj PARTIER, PARTIEST] / to attend a social gathering [v PARTIED, PARTYING, PARTIES]\n",
  "PARTYER": "one who parties, also PARTIER [n -S]\n",
  "PARTYERS": "PARTYER, one who parties, also PARTIER [n]\n",
  "PARTYGOER": "one who attends parties [n -S]\n",
  "PARTYGOERS": "PARTYGOER, one who attends parties [n]\n",
  "PARTYING": "the act of attending a social gathering [n -S]\n",
  "PARTYINGS": "PARTYING, the act of attending a social gathering [n]\n",
  "PARTYISM": "devotion to a political party [n -S]\n",
  "PARTYISMS": "PARTYISM, devotion to a political party [n]\n",
  "PARULIDES": "PARULIS, (Greek) a small suppurating inflamed spot on the gum, aka gumboil [n]\n",
  "PARULIS": "(Greek) a small suppurating inflamed spot on the gum, aka gumboil [n PARULISES or PARULIDES]\n",
  "PARULISES": "PARULIS, (Greek) a small suppurating inflamed spot on the gum, aka gumboil [n]\n",
  "PARURA": "a set of matched jewelry, also PARURE [n -S]\n",
  "PARURAS": "PARURA, a set of matched jewelry, also PARURE [n]\n",
  "PARURE": "(French) a set of matched jewelry, also PARURA [n -S]\n",
  "PARURES": "PARURE, (French) a set of matched jewelry, also PARURA [n]\n",
  "PARURESES": "PARURESIS, a type of phobia in which the sufferer is unable to urinate in the presence of others [n]\n",
  "PARURESIS": "a type of phobia in which the sufferer is unable to urinate in the presence of others [n PARURESES]\n",
  "PARURETIC": "one who suffers from an inability to urinate in the presence of others [n -S]\n",
  "PARURETICS": "PARURETIC, one who suffers from an inability to urinate in the presence of others [n]\n",
  "PARVANIMITIES": "PARVANIMITY, pettiness, meanness [n]\n",
  "PARVANIMITY": "pettiness, meanness [n PARVANIMITIES]\n",
  "PARVE": "(Yiddish) of food, containing neither dairy nor meat ingredients, also PAREV, PAREVE [adj]\n",
  "PARVENU": "(French) one that has suddenly risen to an unaccustomed position of wealth or power and has not yet gained the manner associated with it [n -S]\n",
  "PARVENUE": "(French) a female parvenu [n -S]\n",
  "PARVENUES": "PARVENUE, (French) a female parvenu [n]\n",
  "PARVENUS": "PARVENU, (French) one that has suddenly risen to an unaccustomed position of wealth or power and has not yet gained the manner associated with it [n]\n",
  "PARVIFOLIATE": "of plants, having small leaves in comparison with the size of the stem [adj]\n",
  "PARVIS": "an enclosed area in front of a church, also PARVISE [n -ES]\n",
  "PARVISE": "an enclosed area in front of a church, also PARVIS [n -S]\n",
  "PARVISES": "PARVISE, an enclosed area in front of a church, also PARVIS [n]\n",
  "PARVO": "(short for) a parvovirus, a virus causing disease in dogs [n -S]\n",
  "PARVOLIN": "a ptomaine formed in the putrefaction of albuminous matters, esp. of horseflesh and mackerel [n -S]\n",
  "PARVOLINE": "a liquid derived from coal tar [n -S]\n",
  "PARVOLINES": "PARVOLINE, a liquid derived from coal tar [n]\n",
  "PARVOLINS": "PARVOLIN, a ptomaine formed in the putrefaction of albuminous matters, esp. of horseflesh and mackerel [n]\n",
  "PARVOS": "PARVO, (short for) a parvovirus, a virus causing disease in dogs [n]\n",
  "PARVOVIRUS": "a DNA-containing animal virus [n -ES]\n",
  "PARVOVIRUSES": "PARVOVIRUS, a DNA-containing animal virus [n]\n",
  "PAS": "(French) a step [n PAS]\n",
  "PASCAL": "a unit of pressure, one newton per square meter [n -S]\n",
  "PASCALS": "PASCAL, a unit of pressure, one newton per square meter [n]\n",
  "PASCHAL": "a candle used in religious ceremonies [n -S]\n",
  "PASCHALS": "PASCHAL, a candle used in religious ceremonies [n]\n",
  "PASCUAL": "a plant that grows in pasture [n -S]\n",
  "PASCUALS": "PASCUAL, a plant that grows in pasture [n]\n",
  "PASE": "(Spanish) a movement of a matador's cap [n -S]\n",
  "PASEAR": "to take a walk [v -ED, -ING, -S]\n",
  "PASEARED": "PASEAR, to take a walk [v]\n",
  "PASEARING": "PASEAR, to take a walk [v]\n",
  "PASEARS": "PASEAR, to take a walk [v]\n",
  "PASELA": "(Zulu) a gratuity to a black South African, also BONSELA, BONSELLA, BANSELA [n -S]\n",
  "PASELAS": "PASELA, (Zulu) a gratuity to a black South African, also BONSELA, BONSELLA, BANSELA [n]\n",
  "PASEO": "(Spanish) a walk; a street or promenade [n -S]\n",
  "PASEOS": "PASEO, (Spanish) a walk; a street or promenade [n]\n",
  "PASES": "PASE, (Spanish) a movement of a matador's cap [n]\n",
  "PASH": "to strike violently [v -ED, -ING, -ES]\n",
  "PASHA": "(Turkish) a former Turkish high official, also PACHA [n -S]\n",
  "PASHADOM": "(Turkish) the rank of a pasha, also PACHADOM [n -S]\n",
  "PASHADOMS": "PASHADOM, (Turkish) the rank of a pasha, also PACHADOM [n]\n",
  "PASHALIC": "(Turkish) the territory of a pasha, also PASHALIK, PACHALIC [n -S]\n",
  "PASHALICS": "PASHALIC, (Turkish) the territory of a pasha, also PASHALIK, PACHALIC [n]\n",
  "PASHALIK": "(Turkish) the territory of a pasha, also PACHALIC, PASHALIC [n -S]\n",
  "PASHALIKS": "PASHALIK, (Turkish) the territory of a pasha, also PACHALIC, PASHALIC [n]\n",
  "PASHAS": "PASHA, (Turkish) a former Turkish high official, also PACHA [n]\n",
  "PASHED": "PASH, to strike violently [v]\n",
  "PASHES": "PASH, to strike violently [v]\n",
  "PASHIM": "(Persian) the fine under-fleece of the goats of North India, used for making rugs, shawls etc., also PASHM [n -S]\n",
  "PASHIMS": "PASHIM, (Persian) the fine under-fleece of the goats of North India, used for making rugs, shawls etc., also PASHM [n]\n",
  "PASHING": "PASH, to strike violently [v]\n",
  "PASHKA": "(Russian) a rich dessert of cottage cheese, cream, almonds, raisins etc. traditionally served at Easter, also PASKA, PASKHA [n -S]\n",
  "PASHKAS": "PASHKA, (Russian) a rich dessert of cottage cheese, cream, almonds, raisins etc. traditionally served at Easter, also PASKA, PASKHA [n]\n",
  "PASHM": "(Persian) the fine under-fleece of the goats of North India, used for making rugs, shawls etc., also PASHIM [n -S]\n",
  "PASHMINA": "(Persian) a shawl made from pashm, the fine under-fleece of the goats of North India [n -S]\n",
  "PASHMINAS": "PASHMINA, (Persian) a shawl made from pashm, the fine under-fleece of the goats of North India [n]\n",
  "PASHMS": "PASHM, (Persian) the fine under-fleece of the goats of North India, used for making rugs, shawls etc., also PASHIM [n]\n",
  "PASIGRAPHIC": "relating to pasigraphy, a system of universal ideographic writing, also PASIGRAPHICAL [adj]\n",
  "PASIGRAPHICAL": "relating to pasigraphy, a system of universal ideographic writing, also PASIGRAPHIC [adj]\n",
  "PASIGRAPHIES": "PASIGRAPHY, a system of universal ideographic writing [n]\n",
  "PASIGRAPHY": "a system of universal ideographic writing [n PASIGRAPHIES]\n",
  "PASKA": "(Russian) a Russian dessert eaten at Easter, also PASHKA, PASKHA [n -S]\n",
  "PASKAS": "PASKA, (Russian) a Russian dessert eaten at Easter, also PASHKA, PASKHA [n]\n",
  "PASKHA": "(Russian) a Russian dessert eaten at Easter, also PASHKA, PASKA [n -S]\n",
  "PASKHAS": "PASKHA, (Russian) a Russian dessert eaten at Easter, also PASHKA, PASKA [n]\n",
  "PASODOBLE": "(Spanish) a fast modern ballroom dance [n -S]\n",
  "PASODOBLES": "PASODOBLE, (Spanish) a fast modern ballroom dance [n]\n",
  "PASPALUM": "any plant of the tropical genus Paspalum of pasture grasses, e.g. pampas-grass [n -S]\n",
  "PASPALUMS": "PASPALUM, any plant of the tropical genus Paspalum of pasture grasses, e.g. pampas-grass [n]\n",
  "PASPIES": "PASPY, (French) a Breton dance resembling a quick minuet, also PASSEPIED [n]\n",
  "PASPY": "(French) a Breton dance resembling a quick minuet, also PASSEPIED [n PASPIES]\n",
  "PASQUEFLOWER": "a species of anemone with bell-shaped purple flowers [n -S]\n",
  "PASQUEFLOWERS": "PASQUEFLOWER, a species of anemone with bell-shaped purple flowers [n]\n",
  "PASQUIL": "(Italian) a satire or lampoon [n -S] / to satirise with a pasquil [v PASQUILLED, PASQUILLING, PASQUILS]\n",
  "PASQUILANT": "a lampooner [n -S]\n",
  "PASQUILANTS": "PASQUILANT, a lampooner [n]\n",
  "PASQUILER": "a writer of pasquils, a lampooner [n -S]\n",
  "PASQUILERS": "PASQUILER, a writer of pasquils, a lampooner [n]\n",
  "PASQUILLED": "PASQUIL, to satirise with a pasquil [v]\n",
  "PASQUILLING": "PASQUIL, to satirise with a pasquil [v]\n",
  "PASQUILS": "PASQUIL, to satirise with a pasquil [v]\n",
  "PASQUINADE": "(French) a lampoon posted in a public place [n -S] / to compose a pasquinade [v PASQUINADED, PASQUINADING, PASQUINADES]\n",
  "PASQUINADED": "PASQUINADE, to compose a pasquinade [v]\n",
  "PASQUINADER": "one who composes pasquinades [n -S]\n",
  "PASQUINADERS": "PASQUINADER, one who composes pasquinades [n]\n",
  "PASQUINADES": "PASQUINADE, (French) a lampoon posted in a public place [n]\n",
  "PASQUINADING": "PASQUINADE, to compose a pasquinade [v]\n",
  "PASS": "to go by [v -ED, -ING, -ES]\n",
  "PASSABLE": "fairly good or acceptable [adj PASSABLY]\n",
  "PASSABLENESS": "the state of being passable [n -ES]\n",
  "PASSABLENESSES": "PASSABLENESS, the state of being passable [n]\n",
  "PASSABLY": "PASSABLE, fairly good or acceptable [adv]\n",
  "PASSACAGLIA": "(Italian) an old slow Italian or Spanish dance; variations on a theme over a continuously repeated ground bass [n -S]\n",
  "PASSACAGLIAS": "PASSACAGLIA, (Italian) an old slow Italian or Spanish dance; variations on a theme over a continuously repeated ground bass [n]\n",
  "PASSADE": "(French) a turn of a horse backward or forward on the same ground [n -S]\n",
  "PASSADES": "PASSADE, (French) a turn of a horse backward or forward on the same ground [n]\n",
  "PASSADO": "(Spanish) a forward thrust in fencing [n -ES or -S]\n",
  "PASSADOES": "PASSADO, (Spanish) a forward thrust in fencing [n]\n",
  "PASSADOS": "PASSADO, (Spanish) a forward thrust in fencing [n]\n",
  "PASSAGE": "to make a voyage [v PASSAGED, PASSAGING, PASSAGES]\n",
  "PASSAGED": "PASSAGE, to make a voyage [v]\n",
  "PASSAGER": "as in passager hawk [adj]\n",
  "PASSAGES": "PASSAGE, to make a voyage [v]\n",
  "PASSAGEWAY": "a way that allows passage [n -S]\n",
  "PASSAGEWAYS": "PASSAGEWAY, a way that allows passage [n]\n",
  "PASSAGEWORK": "music that allows a performer to display virtuosity [n -S]\n",
  "PASSAGEWORKS": "PASSAGEWORK, music that allows a performer to display virtuosity [n]\n",
  "PASSAGING": "PASSAGE, to make a voyage [v]\n",
  "PASSALONG": "easily propagated and given to others [adj] / an easily propagated plant [n -S]\n",
  "PASSALONGS": "PASSALONG, an easily propagated plant [n]\n",
  "PASSAMENT": "(French) a decorative trimming of beads or braid, also PASSEMENT, PASSEMENTERIE, PASSMENT [n -S] / to trim with braid [v -ED, -ING, -S]\n",
  "PASSAMENTED": "PASSAMENT, to trim with braid [v]\n",
  "PASSAMENTING": "PASSAMENT, to trim with braid [v]\n",
  "PASSAMENTS": "PASSAMENT, (French) a decorative trimming of beads or braid, also PASSEMENT, PASSEMENTERIE, PASSMENT [n]\n",
  "PASSAMEZZO": "an old dance, a pavan in quick time, also PASSEMEASURE [n -S]\n",
  "PASSAMEZZOS": "PASSAMEZZO, an old dance, a pavan in quick time, also PASSEMEASURE [n]\n",
  "PASSANT": "in heraldry, walking towards the dexter side, with dexter forepaw raised [adj]\n",
  "PASSATA": "(Italian) an Italian sauce of pureed tomatoes [n -S]\n",
  "PASSATAS": "PASSATA, (Italian) an Italian sauce of pureed tomatoes [n]\n",
  "PASSBAND": "a frequency band that transmits efficiently [n -S]\n",
  "PASSBANDS": "PASSBAND, a frequency band that transmits efficiently [n]\n",
  "PASSBOOK": "a bankbook [n -S]\n",
  "PASSBOOKS": "PASSBOOK, a bankbook [n]\n",
  "PASSCODE": "a sequence of digits used to gain access to a building, computer system, etc [n -S]\n",
  "PASSCODES": "PASSCODE, a sequence of digits used to gain access to a building, computer system, etc [n]\n",
  "PASSE": "(French) out of date, or nearly so, also PASSEE [adj]\n",
  "PASSED": "PASS, to go by [v]\n",
  "PASSEE": "(French) out of date, or nearly so, also PASSE [adj]\n",
  "PASSEL": "a large number [n -S]\n",
  "PASSELS": "PASSEL, a large number [n]\n",
  "PASSEMEASURE": "an old dance, a pavan in quicker time, also PASSAMEZZO [n -S]\n",
  "PASSEMEASURES": "PASSEMEASURE, an old dance, a pavan in quicker time, also PASSAMEZZO [n]\n",
  "PASSEMENT": "(French) a decorative trimming of beads or braid, also PASSAMENT, PASSEMENTERIE, PASSMENT [n -S] / to trim with braid [v -ED, -ING, -S]\n",
  "PASSEMENTED": "PASSEMENT, to trim with braid [v]\n",
  "PASSEMENTERIE": "(French) a decorative trimming of beads or braid, also PASSAMENT, PASSEMENT, PASSMENT [n -S]\n",
  "PASSEMENTERIES": "PASSEMENTERIE, (French) a decorative trimming of beads or braid, also PASSAMENT, PASSEMENT, PASSMENT [n]\n",
  "PASSEMENTING": "PASSEMENT, to trim with braid [v]\n",
  "PASSEMENTS": "PASSEMENT, (French) a decorative trimming of beads or braid, also PASSAMENT, PASSEMENTERIE, PASSMENT [n]\n",
  "PASSENGER": "someone who travels in a private or public conveyance [n -S]\n",
  "PASSENGERS": "PASSENGER, someone who travels in a private or public conveyance [n]\n",
  "PASSEPIED": "(French) a Breton dance resembling a quick minuet, also PASPY [n -S]\n",
  "PASSEPIEDS": "PASSEPIED, (French) a Breton dance resembling a quick minuet, also PASPY [n]\n",
  "PASSER": "one that passes [n -S]\n",
  "PASSERBY": "one who passes by [n PASSERSBY]\n",
  "PASSERIFORM": "having the form of a perching bird [adj]\n",
  "PASSERINE": "a perching bird [n -S]\n",
  "PASSERINES": "PASSERINE, a perching bird [n]\n",
  "PASSERS": "PASSER, one that passes [n]\n",
  "PASSERSBY": "PASSERBY, one who passes by [n]\n",
  "PASSES": "PASS, to go by [v]\n",
  "PASSIBILITIES": "PASSIBILITY, the state of being passible [n]\n",
  "PASSIBILITY": "the state of being passible [n PASSIBILITIES]\n",
  "PASSIBLE": "capable of feeling [adj]\n",
  "PASSIBLENESS": "the state of being passible [n -ES]\n",
  "PASSIBLENESSES": "PASSIBLENESS, the state of being passible [n]\n",
  "PASSIBLY": "PASSIBLE, capable of feeling [adv]\n",
  "PASSIFLORA": "a genus of plants, including the passion flower [n -S]\n",
  "PASSIFLORACEOUS": "belonging to the passionflower family [adj]\n",
  "PASSIFLORAS": "PASSIFLORA, a genus of plants, including the passion flower [n]\n",
  "PASSIM": "(Latin) here and there [adv]\n",
  "PASSIMETER": "a machine for issuing automatic tickets [n -S]\n",
  "PASSIMETERS": "PASSIMETER, a machine for issuing automatic tickets [n]\n",
  "PASSING": "incidental, casual [adj PASSINGLY] / the act of passing [n -S]\n",
  "PASSINGLY": "PASSING, incidental, casual [adv]\n",
  "PASSINGS": "PASSING, the act of passing [n]\n",
  "PASSION": "to exhibit strong feeling [v -ED, -ING, -S]\n",
  "PASSIONAL": "a book containing accounts of the sufferings of saints and martyrs, for reading on their feast days [n -S]\n",
  "PASSIONALS": "PASSIONAL, a book containing accounts of the sufferings of saints and martyrs, for reading on their feast days [n]\n",
  "PASSIONARIES": "PASSIONARY, a book in which are described the sufferings of saints and martyrs [n]\n",
  "PASSIONARY": "a book in which are described the sufferings of saints and martyrs [n PASSIONARIES]\n",
  "PASSIONATE": "full of passion [adj PASSIONATELY] / to express with passion; to impassion [v PASSIONATED, PASSIONATING, PASSIONATES]\n",
  "PASSIONATED": "PASSIONATE, to express with passion; to impassion [v]\n",
  "PASSIONATELY": "PASSIONATE, full of passion [adv]\n",
  "PASSIONATENESS": "the state of being passionate [n]\n",
  "PASSIONATES": "PASSIONATE, to express with passion; to impassion [v]\n",
  "PASSIONATING": "PASSIONATE, to express with passion; to impassion [v]\n",
  "PASSIONED": "PASSION, to exhibit strong feeling [v]\n",
  "PASSIONFLOWER": "any flower or plant of the genus Passiflora [n -S]\n",
  "PASSIONFLOWERS": "PASSIONFLOWER, any flower or plant of the genus Passiflora [n]\n",
  "PASSIONING": "PASSION, to exhibit strong feeling [v]\n",
  "PASSIONLESS": "without passion [adj PASSIONLESSLY]\n",
  "PASSIONLESSLY": "PASSIONLESS, without passion [adv]\n",
  "PASSIONLESSNESS": "PASSIONLESS, without passion [n]\n",
  "PASSIONS": "PASSION, to exhibit strong feeling [v]\n",
  "PASSIVATE": "to coat metal with oxides to protect from corrosion [v PASSIVATED, PASSIVATING, PASSIVATES]\n",
  "PASSIVATED": "PASSIVATE, to coat metal with oxides to protect from corrosion [v]\n",
  "PASSIVATES": "PASSIVATE, to coat metal with oxides to protect from corrosion [v]\n",
  "PASSIVATING": "PASSIVATE, to coat metal with oxides to protect from corrosion [v]\n",
  "PASSIVATION": "the act of passivating [n -S]\n",
  "PASSIVATIONS": "PASSIVATION, the act of passivating [n]\n",
  "PASSIVE": "not active [adj PASSIVELY] / the passive mood of a verb [n -S]\n",
  "PASSIVELY": "PASSIVE, not active [adv]\n",
  "PASSIVENESS": "the state of being passive [n -ES]\n",
  "PASSIVENESSES": "PASSIVENESS, the state of being passive [n]\n",
  "PASSIVES": "PASSIVE, the passive mood of a verb [n]\n",
  "PASSIVISM": "the doctrine of being passive [n -S]\n",
  "PASSIVISMS": "PASSIVISM, the doctrine of being passive [n]\n",
  "PASSIVIST": "one who believes in passivism, the doctrine of being passive [n -S]\n",
  "PASSIVISTS": "PASSIVIST, one who believes in passivism, the doctrine of being passive [n]\n",
  "PASSIVITIES": "PASSIVITY, the state of being passive [n]\n",
  "PASSIVITY": "the state of being passive [n PASSIVITIES]\n",
  "PASSKEY": "a key that opens several different locks [n -S]\n",
  "PASSKEYS": "PASSKEY, a key that opens several different locks [n]\n",
  "PASSLESS": "unable to be negotiated [adj]\n",
  "PASSMAN": "someone who graduates without honours [n PASSMEN]\n",
  "PASSMEN": "PASSMAN, someone who graduates without honours [n]\n",
  "PASSMENT": "(French) a decorative trimming of beads or braid, also PASSAMENT, PASSEMENT, PASSEMENTERIE [n -S] / to trim with braid [v -ED, -ING, -S]\n",
  "PASSMENTED": "PASSMENT, to trim with braid [v]\n",
  "PASSMENTING": "PASSMENT, to trim with braid [v]\n",
  "PASSMENTS": "PASSMENT, to trim with braid [v]\n",
  "PASSOUT": "in ice hockey, a pass by an attacking player from behind the opposition goal line [n -S]\n",
  "PASSOUTS": "PASSOUT, in ice hockey, a pass by an attacking player from behind the opposition goal line [n]\n",
  "PASSOVER": "the lamb eaten at the Jewish festival of Passover [n -S]\n",
  "PASSOVERS": "PASSOVER, the lamb eaten at the Jewish festival of Passover [n]\n",
  "PASSPORT": "in the European Economic Area) to award a firm that is registered in one member state the right to do business in every other member state without applying to each country for authorization [v -ED, -ING, -S]\n",
  "PASSPORTED": "PASSPORT, in the European Economic Area) to award a firm that is registered in one member state the right to do business in every other member state without applying to each country for authorization [v]\n",
  "PASSPORTING": "PASSPORT, in the European Economic Area) to award a firm that is registered in one member state the right to do business in every other member state without applying to each country for authorization [v]\n",
  "PASSPORTS": "PASSPORT, in the European Economic Area) to award a firm that is registered in one member state the right to do business in every other member state without applying to each country for authorization [v]\n",
  "PASSUS": "(Latin) a section of a poem or story [n -ES]\n",
  "PASSUSES": "PASSUS, (Latin) a section of a poem or story [n]\n",
  "PASSWORD": "a secret word that must be given to gain admission [n -S]\n",
  "PASSWORDS": "PASSWORD, a secret word that must be given to gain admission [n]\n",
  "PAST": "time gone by [n -S]\n",
  "PASTA": "a food made of dough [n -S]\n",
  "PASTALIKE": "like pasta [adj]\n",
  "PASTANCE": "(archaic) a pastime [n -S]\n",
  "PASTANCES": "PASTANCE, (archaic) a pastime [n]\n",
  "PASTAS": "PASTA, a food made of dough [n]\n",
  "PASTE": "to fasten with a sticky mixture [v PASTED, PASTING, PASTES]\n",
  "PASTEBOARD": "a stiff thick kind of paper board, formed of several single sheets pasted one upon another [n -S]\n",
  "PASTEBOARDS": "PASTEBOARD, a stiff thick kind of paper board, formed of several single sheets pasted one upon another [n]\n",
  "PASTED": "PASTE, to fasten with a sticky mixture [v]\n",
  "PASTEDOWN": "the outer leaf of an end-cover that is pasted down over a book [n -S]\n",
  "PASTEDOWNS": "PASTEDOWN, the outer leaf of an end-cover that is pasted down over a book [n]\n",
  "PASTEL": "a soft, delicate hue [n -S]\n",
  "PASTELIKE": "like paste [adj]\n",
  "PASTELIST": "an artist who works in pastel, also PASTELLIST [n -S]\n",
  "PASTELISTS": "PASTELIST, an artist who works in pastel, also PASTELLIST [n]\n",
  "PASTELLIST": "an artist who works in pastel, also PASTELIST [n -S]\n",
  "PASTELLISTS": "PASTELLIST, an artist who works in pastel, also PASTELIST [n]\n",
  "PASTELS": "PASTEL, a soft, delicate hue [n]\n",
  "PASTER": "one who pastes [n -S]\n",
  "PASTERN": "the part of horse's foot between the fetlock joint and the upper edge of the hoof [n -S]\n",
  "PASTERNS": "PASTERN, the part of horse's foot between the fetlock joint and the upper edge of the hoof [n]\n",
  "PASTERS": "PASTER, one who pastes [n]\n",
  "PASTES": "PASTE, to fasten with a sticky mixture [v]\n",
  "PASTEUP": "a finished copy for making a printing plate [n -S]\n",
  "PASTEUPS": "PASTEUP, a finished copy for making a printing plate [n]\n",
  "PASTEURELLA": "a small rodlike bacterium of the genus Pasteurella [n PASTEURELLAE or PASTEURELLAS]\n",
  "PASTEURELLAE": "PASTEURELLA, a small rodlike bacterium of the genus Pasteurella [n]\n",
  "PASTEURELLAS": "PASTEURELLA, a small rodlike bacterium of the genus Pasteurella [n]\n",
  "PASTEURISATION": "sterilization of milk, etc., by heating, also PASTEURIZATION [n -S]\n",
  "PASTEURISATIONS": "PASTEURISATION, sterilization of milk, etc., by heating, also PASTEURIZATION [n]\n",
  "PASTEURISE": "to treat milk so as to kill germs, also PASTEURIZE [v PASTEURISED, PASTEURISING, PASTEURISES]\n",
  "PASTEURISED": "PASTEURISE, to treat milk so as to kill germs, also PASTEURIZE [v]\n",
  "PASTEURISER": "an apparatus for pasteurising, also PASTEURIZER [n -S]\n",
  "PASTEURISERS": "PASTEURISER, an apparatus for pasteurising, also PASTEURIZER [n]\n",
  "PASTEURISES": "PASTEURISE, to treat milk so as to kill germs, also PASTEURIZE [v]\n",
  "PASTEURISING": "PASTEURISE, to treat milk so as to kill germs, also PASTEURIZE [v]\n",
  "PASTEURISM": "a method of treatment, devised by Pasteur, for preventing certain diseases, as hydrophobia, by successive inoculations with an attenuated virus of gradually increasing strength [n -S]\n",
  "PASTEURISMS": "PASTEURISM, a method of treatment, devised by Pasteur, for preventing certain diseases, as hydrophobia, by successive inoculations with an attenuated virus of gradually increasing strength [n]\n",
  "PASTEURIZATION": "sterilization of milk, etc., by heating, also PASTEURISATION [n -S]\n",
  "PASTEURIZATIONS": "PASTEURIZATION, sterilization of milk, etc., by heating, also PASTEURISATION [n]\n",
  "PASTEURIZE": "to treat milk so as to kill germs, also PASTEURISE [v PASTEURIZED, PASTEURIZING, PASTEURIZES]\n",
  "PASTEURIZED": "PASTEURIZE, to treat milk so as to kill germs, also PASTEURISE [v]\n",
  "PASTEURIZER": "an apparatus for pasteurizing, also PASTEURISER [n -S]\n",
  "PASTEURIZERS": "PASTEURIZER, an apparatus for pasteurizing, also PASTEURISER [n]\n",
  "PASTEURIZES": "PASTEURIZE, to treat milk so as to kill germs, also PASTEURISE [v]\n",
  "PASTEURIZING": "PASTEURIZE, to treat milk so as to kill germs, also PASTEURISE [v]\n",
  "PASTICCI": "PASTICCIO, (Italian) a medley, a pastiche [n]\n",
  "PASTICCIO": "(Italian) a medley, a pastiche [n PASTICCI or PASTICCIOS]\n",
  "PASTICCIOS": "PASTICCIO, (Italian) a medley, a pastiche [n]\n",
  "PASTICHE": "(French) an artistic work made of fragments from various sources [n -S]\n",
  "PASTICHES": "PASTICHE, (French) an artistic work made of fragments from various sources [n]\n",
  "PASTICHEUR": "(French) one who does pastiches [n -S]\n",
  "PASTICHEURS": "PASTICHEUR, (French) one who does pastiches [n]\n",
  "PASTIE": "a meat pie, also PASTY [n -S]\n",
  "PASTIER": "PASTY, pale and unhealthy in appearance, also PASTIE [adj]\n",
  "PASTIES": "PASTIE, a meat pie, also PASTY [n]\n",
  "PASTIEST": "PASTY, pale and unhealthy in appearance, also PASTIE [adj]\n",
  "PASTIL": "a small, often medicated, sweet, also PASTILLE [n -S]\n",
  "PASTILLE": "a small, often medicated, sweet, also PASTIL [n -S]\n",
  "PASTILLES": "PASTILLE, a small, often medicated, sweet, also PASTIL [n]\n",
  "PASTILS": "PASTIL, a small, often medicated, sweet, also PASTILLE [n]\n",
  "PASTILY": "PASTY, pale and unhealthy in appearance, also PASTIE [adv]\n",
  "PASTIME": "a recreational activity, also PASTANCE [n -S]\n",
  "PASTIMES": "PASTIME, a recreational activity, also PASTANCE [n]\n",
  "PASTINA": "(Italian) tiny pieces of pasta cooked in soups or used as baby food [n -S]\n",
  "PASTINAS": "PASTINA, (Italian) tiny pieces of pasta cooked in soups or used as baby food [n]\n",
  "PASTINESS": "the state of being pasty [n -ES]\n",
  "PASTINESSES": "PASTINESS, the state of being pasty [n]\n",
  "PASTING": "a beating, a defeat [n -S]\n",
  "PASTINGS": "PASTING, a beating, a defeat [n]\n",
  "PASTIS": "(French) a French aniseed-flavoured aperitif [n -ES]\n",
  "PASTISES": "PASTIS, (French) a French aniseed-flavoured aperitif [n]\n",
  "PASTITSIO": "(Modern Greek) a dish of mincemeat and macaroni topped with bechamel sauce, also PASTITSO [n -S]\n",
  "PASTITSIOS": "PASTITSIO, (Modern Greek) a dish of mincemeat and macaroni topped with bechamel sauce, also PASTITSO [n]\n",
  "PASTITSO": "(Modern Greek) a dish of mincemeat and macaroni topped with bechamel sauce, also PASTITSIO [n -S]\n",
  "PASTITSOS": "PASTITSO, (Modern Greek) a dish of mincemeat and macaroni topped with bechamel sauce, also PASTITSIO [n]\n",
  "PASTLESS": "having no past [adj]\n",
  "PASTNESS": "the state or being past or gone by [n -ES]\n",
  "PASTNESSES": "PASTNESS, the state or being past or gone by [n]\n",
  "PASTOR": "a person who has care of a flock or of a congregation [n -S] / to serve as the spiritual overseer of [v -ED, -ING, -S]\n",
  "PASTORAL": "of literature, music, or works of art, portraying rural life or the life of shepherds, esp. in an idealized or romantic form [adj PASTORALLY] / a pastoral poem, play etc. [n -S]\n",
  "PASTORALE": "(Italian) a composition in a soft, rural style, generally in 6-8 or 12-8 time [n PASTORALI or PASTORALES]\n",
  "PASTORALES": "PASTORALE, (Italian) a composition in a soft, rural style, generally in 6-8 or 12-8 time [n]\n",
  "PASTORALI": "PASTORALE, (Italian) a composition in a soft, rural style, generally in 6-8 or 12-8 time [n]\n",
  "PASTORALISM": "pastoral character, fashion, cult or mode of writing [n -S]\n",
  "PASTORALISMS": "PASTORALISM, pastoral character, fashion, cult or mode of writing [n]\n",
  "PASTORALIST": "a proponent of pastoralism [n -S]\n",
  "PASTORALISTS": "PASTORALIST, a proponent of pastoralism [n]\n",
  "PASTORALLY": "PASTORAL, of literature, music, or works of art, portraying rural life or the life of shepherds, esp. in an idealized or romantic form [adv]\n",
  "PASTORALNESS": "the state of being pastoral [n -ES]\n",
  "PASTORALNESSES": "PASTORALNESS, the state of being pastoral [n]\n",
  "PASTORALS": "PASTORAL, a pastoral poem, play etc. [n]\n",
  "PASTORATE": "the office, state, or jurisdiction of a pastor [n -S]\n",
  "PASTORATES": "PASTORATE, the office, state, or jurisdiction of a pastor [n]\n",
  "PASTORED": "PASTOR, to serve as the spiritual overseer of [v]\n",
  "PASTORING": "PASTOR, to serve as the spiritual overseer of [v]\n",
  "PASTORIUM": "the residence of a pastor [n -S]\n",
  "PASTORIUMS": "PASTORIUM, the residence of a pastor [n]\n",
  "PASTORLIER": "PASTORLY, appropriate to a pastor [adj]\n",
  "PASTORLIEST": "PASTORLY, appropriate to a pastor [adj]\n",
  "PASTORLY": "appropriate to a pastor [adj PASTORLIER, PASTORLIEST]\n",
  "PASTORS": "PASTOR, to serve as the spiritual overseer of [v]\n",
  "PASTORSHIP": "the office of pastor [n -S]\n",
  "PASTORSHIPS": "PASTORSHIP, the office of pastor [n]\n",
  "PASTOURELLE": "(French) a medieval poem between a knight and a shepherdess [n -S]\n",
  "PASTOURELLES": "PASTOURELLE, (French) a medieval poem between a knight and a shepherdess [n]\n",
  "PASTRAMI": "(Yiddish) a highly seasoned smoked beef, also PASTROMI [n -S]\n",
  "PASTRAMIS": "PASTRAMI, (Yiddish) a highly seasoned smoked beef, also PASTROMI [n]\n",
  "PASTRIES": "PASTRY, articles made of dough [n]\n",
  "PASTROMI": "(Yiddish) a highly seasoned smoked beef, also PASTRAMI [n -S]\n",
  "PASTROMIS": "PASTROMI, (Yiddish) a highly seasoned smoked beef, also PASTRAMI [n]\n",
  "PASTRY": "articles made of dough [n PASTRIES]\n",
  "PASTRYCOOK": "a maker or seller of pastry [n -S]\n",
  "PASTRYCOOKS": "PASTRYCOOK, a maker or seller of pastry [n]\n",
  "PASTS": "PAST, time gone by [n]\n",
  "PASTURABLE": "fit for pasture [adj]\n",
  "PASTURAGE": "the business of feeding or grazing cattle [n -S]\n",
  "PASTURAGES": "PASTURAGE, the business of feeding or grazing cattle [n]\n",
  "PASTURAL": "pertaining to a pasture [adj]\n",
  "PASTURE": "to put out to graze [v PASTURED, PASTURING, PASTURES]\n",
  "PASTURED": "PASTURE, to put out to graze [v]\n",
  "PASTURELAND": "land used for pasture [n -S]\n",
  "PASTURELANDS": "PASTURELAND, land used for pasture [n]\n",
  "PASTURELESS": "without pasture [adj]\n",
  "PASTURER": "one who pastures livestock [n -S]\n",
  "PASTURERS": "PASTURER, one who pastures livestock [n]\n",
  "PASTURES": "PASTURE, to put out to graze [v]\n",
  "PASTURING": "PASTURE, to put out to graze [v]\n",
  "PASTY": "pale and unhealthy in appearance, also PASTIE [adj PASTIER, PASTIEST, PASTILY] / a meat pie, also PASTIE [n PASTIES]\n",
  "PAT": "hitting the mark precisely [adj PATTER, PATTEST, PATLY] / to stroke gently [v PATTED, PATTING, PATS]\n",
  "PATACA": "(Portuguese) a monetary unit of Macao [n -S]\n",
  "PATACAS": "PATACA, (Portuguese) a monetary unit of Macao [n]\n",
  "PATAGIA": "PATAGIUM, (Latin) a wing membrane of a bat [n]\n",
  "PATAGIAL": "of or like a patagium, a web of skin between the forelimbs and hind-limbs of tree-dwelling creatures [adj]\n",
  "PATAGIUM": "(Latin) a wing membrane of a bat [n PATAGIA]\n",
  "PATAKA": "(Maori) a building on stilts, used to store provisions [n -S]\n",
  "PATAKAS": "PATAKA, (Maori) a building on stilts, used to store provisions [n]\n",
  "PATAMAR": "(Portuguese) a vessel resembling a grab, used in the coasting trade of Bombay and Ceylon, also PATTAMAR [n -S]\n",
  "PATAMARS": "PATAMAR, (Portuguese) a vessel resembling a grab, used in the coasting trade of Bombay and Ceylon, also PATTAMAR [n]\n",
  "PATAPHYSICS": "'The science of imaginary solutions' invented by the French dramatist Alfred Jarry (1873-1907), writer of symbolic farce, from which is descended the theatre of the absurd [n]\n",
  "PATBALL": "a gentle ball game such as rounders [n -S]\n",
  "PATBALLS": "PATBALL, a gentle ball game such as rounders [n]\n",
  "PATCH": "to mend or cover a hole [v -ED, -ING, -ES]\n",
  "PATCHABLE": "that can be patched [adj]\n",
  "PATCHBOARD": "a panel with multiple electrical terminals [n -S]\n",
  "PATCHBOARDS": "PATCHBOARD, a panel with multiple electrical terminals [n]\n",
  "PATCHCOCKE": "(Spenser) perhaps a clown, also PATCHOCKE [n -S]\n",
  "PATCHCOCKES": "PATCHCOCKE, (Spenser) perhaps a clown, also PATCHOCKE [n]\n",
  "PATCHED": "PATCH, to mend or cover a hole [v]\n",
  "PATCHER": "one who patches [n -S]\n",
  "PATCHERIES": "PATCHERY, (Shakespeare) knavery [n]\n",
  "PATCHERS": "PATCHER, one who patches [n]\n",
  "PATCHERY": "(Shakespeare) knavery [n PATCHERIES]\n",
  "PATCHES": "PATCH, to mend or cover a hole [v]\n",
  "PATCHIER": "PATCHY, uneven in quality [adj]\n",
  "PATCHIEST": "PATCHY, uneven in quality [adj]\n",
  "PATCHILY": "PATCHY, uneven in quality [adv]\n",
  "PATCHINESS": "the state of being patchy [n -ES]\n",
  "PATCHINESSES": "PATCHINESS, the state of being patchy [n]\n",
  "PATCHING": "the act of patching [n -S]\n",
  "PATCHINGS": "PATCHING, the act of patching [n]\n",
  "PATCHOCKE": "(Spenser) perhaps a clown, also PATCHCOCKE [n -S]\n",
  "PATCHOCKES": "PATCHOCKE, (Spenser) perhaps a clown, also PATCHCOCKE [n]\n",
  "PATCHOULI": "(Tamil) an Asiatic tree with a fragrant perfume oil; the resulting perfume, also PACHOULI, PATCHOULY [n -S]\n",
  "PATCHOULIES": "PATCHOULY, (Tamil) an Asiatic tree with a fragrant perfume oil; the resulting perfume, also PACHOULI, PATCHOULI [n]\n",
  "PATCHOULIS": "PATCHOULI, (Tamil) an Asiatic tree with a fragrant perfume oil; the resulting perfume, also PACHOULI, PATCHOULY [n]\n",
  "PATCHOULY": "(Tamil) an Asiatic tree with a fragrant perfume oil; the resulting perfume, also PACHOULI, PATCHOULI [n PATCHOULIES]\n",
  "PATCHWORK": "in needlework, to sew pieces together [v -ED, -ING, -S]\n",
  "PATCHWORKED": "PATCHWORK, in needlework, to sew pieces together [v]\n",
  "PATCHWORKING": "PATCHWORK, in needlework, to sew pieces together [v]\n",
  "PATCHWORKS": "PATCHWORK, in needlework, to sew pieces together [v]\n",
  "PATCHY": "uneven in quality [adj PATCHIER, PATCHIEST, PATCHILY]\n",
  "PATE": "the top of the head [n -S]\n",
  "PATED": "having a pate [adj]\n",
  "PATELLA": "(Latin) the kneecap [n PATELLAS or PATELLAE]\n",
  "PATELLAE": "PATELLA, (Latin) the kneecap [n]\n",
  "PATELLAR": "pertaining to the patella [adj]\n",
  "PATELLAS": "PATELLA, (Latin) the kneecap [n]\n",
  "PATELLATE": "relating to the patella, the kneecap [adj]\n",
  "PATELLECTOMIES": "PATELLECTOMY, the surgical removal of the kneecap [n]\n",
  "PATELLECTOMY": "the surgical removal of the kneecap [n PATELLECTOMIES]\n",
  "PATELLIFORM": "shaped like a saucer or kneecap [adj]\n",
  "PATEN": "a plate; a metal disk used to hold Communion bread, also PATIN [n -S]\n",
  "PATENCIES": "PATENCY, the condition of being open, enlarged, or spread [n]\n",
  "PATENCY": "the condition of being open, enlarged, or spread [n PATENCIES]\n",
  "PATENS": "PATEN, a plate; a metal disk used to hold Communion bread, also PATIN [n]\n",
  "PATENT": "obvious [adj PATENTLY] / to obtain a patent (a government grant protecting the rights of an inventor) on [v -ED, -ING, -S]\n",
  "PATENTABILITIES": "PATENTABILITY, the state of being patentable [n]\n",
  "PATENTABILITY": "the state of being patentable [n PATENTABILITIES]\n",
  "PATENTABLE": "suitable to be patented [adj]\n",
  "PATENTED": "PATENT, to obtain a patent (a government grant protecting the rights of an inventor) on [v]\n",
  "PATENTEE": "one who holds a patent [n -S]\n",
  "PATENTEES": "PATENTEE, one who holds a patent [n]\n",
  "PATENTING": "PATENT, to obtain a patent (a government grant protecting the rights of an inventor) on [v]\n",
  "PATENTLY": "PATENT, obvious [adv]\n",
  "PATENTOR": "one who grants a patent [n -S]\n",
  "PATENTORS": "PATENTOR, one who grants a patent [n]\n",
  "PATENTS": "PATENT, to obtain a patent (a government grant protecting the rights of an inventor) on [v]\n",
  "PATER": "(Latin) a father [n -S]\n",
  "PATERA": "(Latin) a type of Roman shallow dish [n PATERAE]\n",
  "PATERAE": "PATERA, (Latin) a type of Roman shallow dish [n]\n",
  "PATERCOVE": "(slang) a hedge-priest, also PATRICO [n -S]\n",
  "PATERCOVES": "PATERCOVE, (slang) a hedge-priest, also PATRICO [n]\n",
  "PATERERO": "(Spanish) a type of old gun, also PEDRERO, PADERERO, PEDERERO [n -ES or -S]\n",
  "PATEREROES": "PATERERO, (Spanish) a type of old gun, also PEDRERO, PADERERO, PEDERERO [n]\n",
  "PATEREROS": "PATERERO, (Spanish) a type of old gun, also PEDRERO, PADERERO, PEDERERO [n]\n",
  "PATERFAMILIAS": "(Latin) the head of the family [n PATRESFAMILIAS or PATERFAMILIASES]\n",
  "PATERFAMILIASES": "PATERFAMILIAS, (Latin) the head of the family [n]\n",
  "PATERNAL": "pertaining to a father [adj PATERNALLY]\n",
  "PATERNALISM": "a system or tendency in which well-meaning supervision and/or regulation, etc. is apt to become unwelcome interference [n -S]\n",
  "PATERNALISMS": "PATERNALISM, a system or tendency in which well-meaning supervision and/or regulation, etc. is apt to become unwelcome interference [n]\n",
  "PATERNALIST": "a believer in paternalism [n -S]\n",
  "PATERNALISTIC": "relating to paternalism [adj]\n",
  "PATERNALISTS": "PATERNALIST, a believer in paternalism [n]\n",
  "PATERNALLY": "PATERNAL, pertaining to a father [adv]\n",
  "PATERNITIES": "PATERNITY, fatherhood [n]\n",
  "PATERNITY": "fatherhood [n PATERNITIES]\n",
  "PATERNOSTER": "the Lord's Prayer, or a recital of it [n -S]\n",
  "PATERNOSTERS": "PATERNOSTER, the Lord's Prayer, or a recital of it [n]\n",
  "PATERS": "PATER, (Latin) a father [n]\n",
  "PATES": "PATE, the top of the head [n]\n",
  "PATH": "a way trodden out by the feet [n -S] / (Shakespeare) to go [v -ED, -ING, -S]\n",
  "PATHBREAKING": "trailblazing [adj]\n",
  "PATHED": "PATH, (Shakespeare) to go [v]\n",
  "PATHETIC": "arousing pity, also PATHETICAL [adj PATHETICALLY]\n",
  "PATHETICAL": "arousing pity, also PATHETIC [adj PATHETICALLY]\n",
  "PATHETICALLY": "PATHETICAL, arousing pity, also PATHETIC [adv]\n",
  "PATHETICS": "the branch of knowledge that deals with human emotions [n]\n",
  "PATHFINDER": "one that discovers a way [n -S]\n",
  "PATHFINDERS": "PATHFINDER, one that discovers a way [n]\n",
  "PATHFINDING": "the act of marking the way e.g. by flares [n -S]\n",
  "PATHFINDINGS": "PATHFINDING, the act of marking the way e.g. by flares [n]\n",
  "PATHIC": "a passive subject [n -S]\n",
  "PATHICS": "PATHIC, a passive subject [n]\n",
  "PATHING": "PATH, (Shakespeare) to go [v]\n",
  "PATHLESS": "having no path [adj]\n",
  "PATHLESSNESS": "the state of being pathless [n -ES]\n",
  "PATHLESSNESSES": "PATHLESSNESS, the state of being pathless [n]\n",
  "PATHNAME": "the name of a file or directory together with its position in relation to other directories [n -S]\n",
  "PATHNAMES": "PATHNAME, the name of a file or directory together with its position in relation to other directories [n]\n",
  "PATHOBIOLOGIES": "PATHOBIOLOGY, the biology of disease [n]\n",
  "PATHOBIOLOGY": "the biology of disease [n PATHOBIOLOGIES]\n",
  "PATHOGEN": "a disease-producing organism, also PATHOGENE [n -S]\n",
  "PATHOGENE": "a disease-producing organism, also PATHOGEN [n -S]\n",
  "PATHOGENES": "PATHOGENE, a disease-producing organism, also PATHOGEN [n]\n",
  "PATHOGENESES": "PATHOGENESIS, the production and development of disease, also PATHOGENY [n]\n",
  "PATHOGENESIS": "the production and development of disease, also PATHOGENY [n PATHOGENESES]\n",
  "PATHOGENETIC": "producing disease, also PATHOGENIC, PATHOGENOUS [adj]\n",
  "PATHOGENIC": "producing disease, also PATHOGENETIC, PATHOGENOUS [adj]\n",
  "PATHOGENICITIES": "PATHOGENICITY, the state of being pathogenic [n]\n",
  "PATHOGENICITY": "the state of being pathogenic [n PATHOGENICITIES]\n",
  "PATHOGENIES": "PATHOGENY, the production and development of disease, also PATHOGENESIS [n]\n",
  "PATHOGENOUS": "producing disease, also PATHOGENETIC, PATHOGENIC [adj]\n",
  "PATHOGENS": "PATHOGEN, a disease-producing organism, also PATHOGENE [n]\n",
  "PATHOGENY": "the production and development of disease, also PATHOGENESIS [n PATHOGENIES]\n",
  "PATHOGNOMIES": "PATHOGNOMY, the science of the signs by which human diseases are indicated [n]\n",
  "PATHOGNOMONIC": "distinctively characteristic of a particular disease [adj]\n",
  "PATHOGNOMY": "the science of the signs by which human diseases are indicated [n PATHOGNOMIES]\n",
  "PATHOGRAPHIES": "PATHOGRAPHY, a description of or article on a disease; a biography that focuses on the negative [n]\n",
  "PATHOGRAPHY": "a description of or article on a disease; a biography that focuses on the negative [n PATHOGRAPHIES]\n",
  "PATHOLOGIC": "relating to pathology, also PATHOLOGICAL [adj PATHOLOGICALLY]\n",
  "PATHOLOGICAL": "relating to pathology, also PATHOLOGIC [adj PATHOLOGICALLY]\n",
  "PATHOLOGICALLY": "PATHOLOGICAL, relating to pathology, also PATHOLOGIC [adv]\n",
  "PATHOLOGIES": "PATHOLOGY, the study of diseases or abnormalities or, more particularly, of the changes in tissues or organs that are associated with disease [n]\n",
  "PATHOLOGISE": "to make pathological, also PATHOLOGIZE [v PATHOLOGISED, PATHOLOGISING, PATHOLOGISES]\n",
  "PATHOLOGISED": "PATHOLOGISE, to make pathological, also PATHOLOGIZE [v]\n",
  "PATHOLOGISES": "PATHOLOGISE, to make pathological, also PATHOLOGIZE [v]\n",
  "PATHOLOGISING": "PATHOLOGISE, to make pathological, also PATHOLOGIZE [v]\n",
  "PATHOLOGIST": "a specialist in pathology [n -S]\n",
  "PATHOLOGISTS": "PATHOLOGIST, a specialist in pathology [n]\n",
  "PATHOLOGIZE": "to make pathological, also PATHOLOGISE [v PATHOLOGIZED, PATHOLOGIZING, PATHOLOGIZES]\n",
  "PATHOLOGIZED": "PATHOLOGIZE, to make pathological, also PATHOLOGISE [v]\n",
  "PATHOLOGIZES": "PATHOLOGIZE, to make pathological, also PATHOLOGISE [v]\n",
  "PATHOLOGIZING": "PATHOLOGIZE, to make pathological, also PATHOLOGISE [v]\n",
  "PATHOLOGY": "the study of diseases or abnormalities or, more particularly, of the changes in tissues or organs that are associated with disease [n PATHOLOGIES]\n",
  "PATHOPHOBIA": "fear of disease [n -S]\n",
  "PATHOPHOBIAS": "PATHOPHOBIA, fear of disease [n]\n",
  "PATHOPHYSIOLOGY": "the physiology of abnormal states [n]\n",
  "PATHOS": "(Greek) a quality that arouses feelings of pity or compassion [n -ES]\n",
  "PATHOSES": "PATHOS, (Greek) a quality that arouses feelings of pity or compassion [n]\n",
  "PATHS": "PATH, (Shakespeare) to go [v]\n",
  "PATHWAY": "a path [n -S]\n",
  "PATHWAYS": "PATHWAY, a path [n]\n",
  "PATIBLE": "capable of suffering or being acted on, also PASSIBLE [adj]\n",
  "PATIBULARY": "of or pertaining to the gallows [adj]\n",
  "PATIENCE": "the quality of enduring calmly [n -S]\n",
  "PATIENCES": "PATIENCE, the quality of enduring calmly [n]\n",
  "PATIENT": "calm and uncomplaining [adj PATIENTER, PATIENTEST, PATIENTLY] / (Shakespeare) to make calm and uncomplaining [v -ED, -ING, -S]\n",
  "PATIENTED": "PATIENT, (Shakespeare) to make calm and uncomplaining [v]\n",
  "PATIENTER": "PATIENT, calm and uncomplaining [adj]\n",
  "PATIENTEST": "PATIENT, calm and uncomplaining [adj]\n",
  "PATIENTING": "PATIENT, (Shakespeare) to make calm and uncomplaining [v]\n",
  "PATIENTLY": "PATIENT, calm and uncomplaining [adv]\n",
  "PATIENTS": "PATIENT, (Shakespeare) to make calm and uncomplaining [v]\n",
  "PATIKI": "(Maori) the New Zealand sand flounder or dab [n -S]\n",
  "PATIKIS": "PATIKI, (Maori) the New Zealand sand flounder or dab [n]\n",
  "PATIN": "(obsolete) a plate; a metal disk used to hold Communion bread, also PATEN [n -S]\n",
  "PATINA": "(Latin) a film or surface that forms on surface of metal or wood [n -S] / a shallow bowl used in ancient Rome [n PATINAE]\n",
  "PATINAE": "PATINA, (Latin) a film or surface that forms on surface of metal or wood [n]\n",
  "PATINAED": "having a patina [adj]\n",
  "PATINAS": "PATINA, (Latin) a film or surface that forms on surface of metal or wood [n]\n",
  "PATINATE": "to give a patina to, also PATINISE, PATINIZE [v PATINATED, PATINATING, PATINATES]\n",
  "PATINATED": "PATINATE, to give a patina to, also PATINISE, PATINIZE [v]\n",
  "PATINATES": "PATINATE, to give a patina to, also PATINISE, PATINIZE [v]\n",
  "PATINATING": "PATINATE, to give a patina to, also PATINISE, PATINIZE [v]\n",
  "PATINATION": "the formation of a film on copper from exposure [n -S]\n",
  "PATINATIONS": "PATINATION, the formation of a film on copper from exposure [n]\n",
  "PATINE": "to cover with a patina [v PATINED, PATINING, PATINES]\n",
  "PATINED": "PATINE, to cover with a patina [v]\n",
  "PATINES": "PATINE, to cover with a patina [v]\n",
  "PATINING": "PATINE, to cover with a patina [v]\n",
  "PATINISE": "to give a patina to, also PATINATE, PATINIZE [v PATINISED, PATINISING, PATINISES]\n",
  "PATINISED": "PATINISE, to give a patina to, also PATINATE, PATINIZE [v]\n",
  "PATINISES": "PATINISE, to give a patina to, also PATINATE, PATINIZE [v]\n",
  "PATINISING": "PATINISE, to give a patina to, also PATINATE, PATINIZE [v]\n",
  "PATINIZE": "to give a patina to, also PATINATE, PATINISE [v PATINIZED, PATINIZING, PATINIZES]\n",
  "PATINIZED": "PATINIZE, to give a patina to, also PATINATE, PATINISE [v]\n",
  "PATINIZES": "PATINIZE, to give a patina to, also PATINATE, PATINISE [v]\n",
  "PATINIZING": "PATINIZE, to give a patina to, also PATINATE, PATINISE [v]\n",
  "PATINS": "PATIN, (obsolete) a plate; a metal disk used to hold Communion bread, also PATEN [n]\n",
  "PATIO": "an outdoor paved area adjoining a house [n -S]\n",
  "PATIOS": "PATIO, an outdoor paved area adjoining a house [n]\n",
  "PATISSERIE": "(French) a shop which sells fancy cakes etc. [n -S]\n",
  "PATISSERIES": "PATISSERIE, (French) a shop which sells fancy cakes etc. [n]\n",
  "PATISSIER": "(French) a maker or seller of fancy cakes [n -S]\n",
  "PATISSIERS": "PATISSIER, (French) a maker or seller of fancy cakes [n]\n",
  "PATKA": "a scarf worn as a head-covering by Sikh men in place of a turban [n -S]\n",
  "PATKAS": "PATKA, a scarf worn as a head-covering by Sikh men in place of a turban [n]\n",
  "PATLY": "PAT, hitting the mark precisely [adv]\n",
  "PATNESS": "suitability [n -ES]\n",
  "PATNESSES": "PATNESS, suitability [n]\n",
  "PATOIS": "(French) a spoken regional dialect [n PATOIS]\n",
  "PATONCE": "of a heraldic cross, having arms expanding in curves from the centre, with floriated ends [adj]\n",
  "PATOOT": "the buttocks, also PATOOTIE [n -S]\n",
  "PATOOTIE": "(colloquial) the buttocks, also PATOOT [n -S]\n",
  "PATOOTIES": "PATOOTIE, (colloquial) the buttocks, also PATOOT [n]\n",
  "PATOOTS": "PATOOT, the buttocks, also PATOOTIE [n]\n",
  "PATRESFAMILIAS": "PATERFAMILIAS, (Latin) the head of the family [n]\n",
  "PATRIAL": "one who is entitled to stay in the UK because of a British parent [n -S]\n",
  "PATRIALISATION": "the process of patrialising, also PATRIALIZATION [n -S]\n",
  "PATRIALISATIONS": "PATRIALISATION, the process of patrialising, also PATRIALIZATION [n]\n",
  "PATRIALISE": "to make patrial, one with a legal right to enter and stay in the UK, also PATRIALIZE [v PATRIALISED, PATRIALISING, PATRIALISES]\n",
  "PATRIALISED": "PATRIALISE, to make patrial, one with a legal right to enter and stay in the UK, also PATRIALIZE [v]\n",
  "PATRIALISES": "PATRIALISE, to make patrial, one with a legal right to enter and stay in the UK, also PATRIALIZE [v]\n",
  "PATRIALISING": "PATRIALISE, to make patrial, one with a legal right to enter and stay in the UK, also PATRIALIZE [v]\n",
  "PATRIALISM": "the state of being a patrial, one with a legal right to enter and stay in the UK [n -S]\n",
  "PATRIALISMS": "PATRIALISM, the state of being a patrial, one with a legal right to enter and stay in the UK [n]\n",
  "PATRIALITIES": "PATRIALITY, the condition of being a patrial [n]\n",
  "PATRIALITY": "the condition of being a patrial [n PATRIALITIES]\n",
  "PATRIALIZATION": "the process of patrializing, also PATRIALISATION [n -S]\n",
  "PATRIALIZATIONS": "PATRIALIZATION, the process of patrializing, also PATRIALISATION [n]\n",
  "PATRIALIZE": "to make patrial, one with a legal right to enter and stay in the UK, also PATRIALISE [v PATRIALIZED, PATRIALIZING, PATRIALIZES]\n",
  "PATRIALIZED": "PATRIALIZE, to make patrial, one with a legal right to enter and stay in the UK, also PATRIALISE [v]\n",
  "PATRIALIZES": "PATRIALIZE, to make patrial, one with a legal right to enter and stay in the UK, also PATRIALISE [v]\n",
  "PATRIALIZING": "PATRIALIZE, to make patrial, one with a legal right to enter and stay in the UK, also PATRIALISE [v]\n",
  "PATRIALS": "PATRIAL, one who is entitled to stay in the UK because of a British parent [n]\n",
  "PATRIARCH": "a man who is the head of a family [n -S]\n",
  "PATRIARCHAL": "of, relating to, or being a patriarch or patriarchy [adj PATRIARCHALLY]\n",
  "PATRIARCHALISM": "a patriarchic system [n -S]\n",
  "PATRIARCHALISMS": "PATRIARCHALISM, a patriarchic system [n]\n",
  "PATRIARCHALLY": "PATRIARCHAL, of, relating to, or being a patriarch or patriarchy [adv]\n",
  "PATRIARCHATE": "the office of a patriarch [n -S]\n",
  "PATRIARCHATES": "PATRIARCHATE, the office of a patriarch [n]\n",
  "PATRIARCHIES": "PATRIARCHY, the jurisdiction of a patriarch [n]\n",
  "PATRIARCHISM": "government by a patriarch [n -S]\n",
  "PATRIARCHISMS": "PATRIARCHISM, government by a patriarch [n]\n",
  "PATRIARCHS": "PATRIARCH, a man who is the head of a family [n]\n",
  "PATRIARCHY": "the jurisdiction of a patriarch [n PATRIARCHIES]\n",
  "PATRIATE": "to transfer constitutional responsibility from England to Canada [v PATRIATED, PATRIATING, PATRIATES]\n",
  "PATRIATED": "PATRIATE, to transfer constitutional responsibility from England to Canada [v]\n",
  "PATRIATES": "PATRIATE, to transfer constitutional responsibility from England to Canada [v]\n",
  "PATRIATING": "PATRIATE, to transfer constitutional responsibility from England to Canada [v]\n",
  "PATRIATION": "the transference of responsibilities for the Canadian constitution from the British parliament to the Canadian parliament [n -S]\n",
  "PATRIATIONS": "PATRIATION, the transference of responsibilities for the Canadian constitution from the British parliament to the Canadian parliament [n]\n",
  "PATRICIAN": "aristocratic [adj PATRICIANLY] / a member or descendant by blood or adoption of one of the original families of citizens forming the Roman people; an aristocrat [n -S]\n",
  "PATRICIANLY": "PATRICIAN, aristocratic [adv]\n",
  "PATRICIANS": "PATRICIAN, a member or descendant by blood or adoption of one of the original families of citizens forming the Roman people; an aristocrat [n]\n",
  "PATRICIATE": "the patrician class; the aristocracy [n -S]\n",
  "PATRICIATES": "PATRICIATE, the patrician class; the aristocracy [n]\n",
  "PATRICIDAL": "of or pertaining to patricide, also PARRICIDAL [adj]\n",
  "PATRICIDE": "the killing of a father, also PARRICIDE [n -S]\n",
  "PATRICIDES": "PATRICIDE, the killing of a father, also PARRICIDE [n]\n",
  "PATRICK": "(Irish) a seventeenth century Irish halfpenny [n -S]\n",
  "PATRICKS": "PATRICK, (Irish) a seventeenth century Irish halfpenny [n]\n",
  "PATRICLINIC": "of animals and plants, showing the characters of the male parent, also PATROCLINAL, PATROCLINOUS [adj]\n",
  "PATRICLINOUS": "descending in the paternal line [adj]\n",
  "PATRICO": "(slang) a hedge-priest, also PATERCOVE [n PATRICOES or PATRICOS]\n",
  "PATRICOES": "PATRICO, (slang) a hedge-priest, also PATERCOVE [n]\n",
  "PATRICOS": "PATRICO, (slang) a hedge-priest, also PATERCOVE [n]\n",
  "PATRIFOCAL": "centred on the father [adj]\n",
  "PATRIFOCALITIES": "PATRIFOCALITY, the state of being patrifocal, centred on the father [n]\n",
  "PATRIFOCALITY": "the state of being patrifocal, centred on the father [n PATRIFOCALITIES]\n",
  "PATRILINEAGE": "descent through the male line [n -S]\n",
  "PATRILINEAGES": "PATRILINEAGE, descent through the male line [n]\n",
  "PATRILINEAL": "traced through the father or through males alone, also PATRILINEAR [adj PATRILINEALLY]\n",
  "PATRILINEALLY": "PATRILINEAL, traced through the father or through males alone, also PATRILINEAR [adv]\n",
  "PATRILINEAR": "traced through the father or through males alone, also PATRILINEAL [adj]\n",
  "PATRILINEARLY": "PATRILINEAR, traced through the father or through males alone, also PATRILINEAL [adv]\n",
  "PATRILINIES": "PATRILINY, descent reckoned through the father [n]\n",
  "PATRILINY": "descent reckoned through the father [n PATRILINIES]\n",
  "PATRILOCAL": "designating a form of marriage in which the wife goes to live with the husband's group [adj PATRILOCALLY]\n",
  "PATRILOCALLY": "PATRILOCAL, designating a form of marriage in which the wife goes to live with the husband's group [adv]\n",
  "PATRIMONIAL": "relating to patrimony [adj PATRIMONIALLY]\n",
  "PATRIMONIALLY": "PATRIMONIAL, relating to patrimony [adv]\n",
  "PATRIMONIES": "PATRIMONY, an inheritance from one's father or ancestors [n]\n",
  "PATRIMONY": "an inheritance from one's father or ancestors [n PATRIMONIES]\n",
  "PATRIOT": "one who loves his country [n -S]\n",
  "PATRIOTIC": "devoted to one's country [adj PATRIOTICALLY]\n",
  "PATRIOTICALLY": "PATRIOTIC, devoted to one's country [adv]\n",
  "PATRIOTISM": "love for or devotion to one's country [n -S]\n",
  "PATRIOTISMS": "PATRIOTISM, love for or devotion to one's country [n]\n",
  "PATRIOTS": "PATRIOT, one who loves his country [n]\n",
  "PATRISTIC": "pertaining to the Fathers of the Church, also PATRISTICAL [adj PATRISTICALLY]\n",
  "PATRISTICAL": "pertaining to the Fathers of the Church, also PATRISTIC [adj PATRISTICALLY]\n",
  "PATRISTICALLY": "PATRISTICAL, pertaining to the Fathers of the Church, also PATRISTIC [adv]\n",
  "PATRISTICISM": "the mode of thought, etc., of the fathers of the Christian church [n -S]\n",
  "PATRISTICISMS": "PATRISTICISM, the mode of thought, etc., of the fathers of the Christian church [n]\n",
  "PATRISTICS": "the study of the Church Fathers' lives and works [n]\n",
  "PATROCLINAL": "of animals and plants, showing the characters of the male parent, also PATRICLINIC, PATROCLINOUS [adj]\n",
  "PATROCLINIC": "of animals and plants, showing the characters of the male parent, also PATROCLINAL, PATROCLINOUS [adj]\n",
  "PATROCLINIES": "PATROCLINY, the inheritance of traits primarily from the father [n]\n",
  "PATROCLINOUS": "of animals and plants, showing the characters of the male parent, also PATRICLINIC, PATROCLINAL [adj]\n",
  "PATROCLINY": "the inheritance of traits primarily from the father [n PATROCLINIES]\n",
  "PATROL": "to guard by moving and watching [v PATROLLED, PATROLLING, PATROLS]\n",
  "PATROLLED": "PATROL, to guard by moving and watching [v]\n",
  "PATROLLER": "one who patrols [n -S]\n",
  "PATROLLERS": "PATROLLER, one who patrols [n]\n",
  "PATROLLING": "PATROL, to guard by moving and watching [v]\n",
  "PATROLMAN": "a police officer on duty on a beat [n PATROLMEN]\n",
  "PATROLMEN": "PATROLMAN, a police officer on duty on a beat [n]\n",
  "PATROLOGICAL": "related to patrology [adj]\n",
  "PATROLOGIES": "PATROLOGY, the study of early Christianity [n]\n",
  "PATROLOGIST": "one who practises patrology, the study of early Christianity [n -S]\n",
  "PATROLOGISTS": "PATROLOGIST, one who practises patrology, the study of early Christianity [n]\n",
  "PATROLOGY": "the study of early Christianity [n PATROLOGIES]\n",
  "PATROLS": "PATROL, to guard by moving and watching [v]\n",
  "PATROLWOMAN": "a female police officer on duty on a beat [n PATROLWOMEN]\n",
  "PATROLWOMEN": "PATROLWOMAN, a female police officer on duty on a beat [n]\n",
  "PATRON": "a regular customer [n -S]\n",
  "PATRONAGE": "(Shakespeare) to countenance [v PATRONAGED, PATRONAGING, PATRONAGES]\n",
  "PATRONAGED": "PATRONAGE, (Shakespeare) to countenance [v]\n",
  "PATRONAGES": "PATRONAGE, (Shakespeare) to countenance [v]\n",
  "PATRONAGING": "PATRONAGE, (Shakespeare) to countenance [v]\n",
  "PATRONAL": "of or like a patron [adj]\n",
  "PATRONESS": "a female patron [n -ES]\n",
  "PATRONESSES": "PATRONESS, a female patron [n]\n",
  "PATRONISATION": "the act of patronising, also PATRONIZATION [n -S]\n",
  "PATRONISATIONS": "PATRONISATION, the act of patronising, also PATRONIZATION [n]\n",
  "PATRONISE": "to assume the condescending air of a patron towards, also PATRONIZE [v PATRONISED, PATRONISING, PATRONISES]\n",
  "PATRONISED": "PATRONISE, to assume the condescending air of a patron towards, also PATRONIZE [v]\n",
  "PATRONISER": "one who patronises, also PATRONIZER [n -S]\n",
  "PATRONISERS": "PATRONISER, one who patronises, also PATRONIZER [n]\n",
  "PATRONISES": "PATRONISE, to assume the condescending air of a patron towards, also PATRONIZE [v]\n",
  "PATRONISING": "condescending [adj PATRONISINGLY]\n",
  "PATRONISINGLY": "PATRONISING, condescending [adv]\n",
  "PATRONIZATION": "the act of patronizing, also PATRONISATION [n -S]\n",
  "PATRONIZATIONS": "PATRONIZATION, the act of patronizing, also PATRONISATION [n]\n",
  "PATRONIZE": "to assume the condescending air of a patron towards, also PATRONISE [v PATRONIZED, PATRONIZING, PATRONIZES]\n",
  "PATRONIZED": "PATRONIZE, to assume the condescending air of a patron towards, also PATRONISE [v]\n",
  "PATRONIZER": "one who patronizes, also PATRONISER [n -S]\n",
  "PATRONIZERS": "PATRONIZER, one who patronizes, also PATRONISER [n]\n",
  "PATRONIZES": "PATRONIZE, to assume the condescending air of a patron towards, also PATRONISE [v]\n",
  "PATRONIZING": "PATRONIZE, to assume the condescending air of a patron towards, also PATRONISE [v]\n",
  "PATRONIZINGLY": "PATRONIZING, PATRONIZE, to assume the condescending air of a patron towards, also PATRONISE [adv]\n",
  "PATRONLESS": "destitute of a patron [adj]\n",
  "PATRONLIER": "PATRONLY, like a patron [adj]\n",
  "PATRONLIEST": "PATRONLY, like a patron [adj]\n",
  "PATRONLY": "like a patron [adj PATRONLIER, PATRONLIEST]\n",
  "PATRONNE": "(French) a (female) proprietor of a restaurant [n -S]\n",
  "PATRONNES": "PATRONNE, (French) a (female) proprietor of a restaurant [n]\n",
  "PATRONS": "PATRON, a regular customer [n]\n",
  "PATRONYMIC": "derived from the name of a father or an ancestor [adj] / a name so derived [n -S]\n",
  "PATRONYMICS": "PATRONYMIC, a name so derived [n]\n",
  "PATROON": "(Dutch) a landowner granted manorial rights under old Dutch law [n -S]\n",
  "PATROONS": "PATROON, (Dutch) a landowner granted manorial rights under old Dutch law [n]\n",
  "PATROONSHIP": "the office of patroon, a ship's captain; a holder of a grant of land from the Dutch governor of New York [n -S]\n",
  "PATROONSHIPS": "PATROONSHIP, the office of patroon, a ship's captain; a holder of a grant of land from the Dutch governor of New York [n]\n",
  "PATS": "PAT, to stroke gently [v]\n",
  "PATSIES": "PATSY, a person who is easily fooled [n]\n",
  "PATSY": "a person who is easily fooled [n PATSIES]\n",
  "PATTAMAR": "(Portuguese) a vessel resembling a grab, used in the coasting trade of Bombay and Ceylon, also PATAMAR [n -S]\n",
  "PATTAMARS": "PATTAMAR, (Portuguese) a vessel resembling a grab, used in the coasting trade of Bombay and Ceylon, also PATAMAR [n]\n",
  "PATTE": "(French) a narrow band keeping a belt in place [n -S]\n",
  "PATTED": "PAT, to stroke gently [v]\n",
  "PATTEE": "of a heraldic cross, having narrow arms, but expanding at the ends, also PATY [adj]\n",
  "PATTEN": "a wooden shoe; a clog [n -S] / (obsolete) to go on pattens [v -ED, -ING, -S]\n",
  "PATTENED": "PATTEN, (obsolete) to go on pattens [v]\n",
  "PATTENING": "PATTEN, (obsolete) to go on pattens [v]\n",
  "PATTENS": "PATTEN, (obsolete) to go on pattens [v]\n",
  "PATTER": "to talk rapidly and glibly [v -ED, -ING, -S]\n",
  "PATTERED": "PATTER, to talk rapidly and glibly [v]\n",
  "PATTERER": "one who patters [n -S]\n",
  "PATTERERS": "PATTERER, one who patters [n]\n",
  "PATTERING": "PATTER, to talk rapidly and glibly [v]\n",
  "PATTERN": "to copy a design [v -ED, -ING, -S]\n",
  "PATTERNED": "PATTERN, to copy a design [v]\n",
  "PATTERNING": "the act of patterning [n -S]\n",
  "PATTERNINGS": "PATTERNING, the act of patterning [n]\n",
  "PATTERNLESS": "without a pattern [adj]\n",
  "PATTERNS": "PATTERN, to copy a design [v]\n",
  "PATTERS": "PATTER, to talk rapidly and glibly [v]\n",
  "PATTES": "PATTE, (French) a narrow band keeping a belt in place [n]\n",
  "PATTEST": "PAT, hitting the mark precisely [adj]\n",
  "PATTIE": "a small, flat cake of chopped food, also PATTY [n -S]\n",
  "PATTIES": "PATTY, a small, flat cake of chopped food, also PATTIE [n]\n",
  "PATTING": "PAT, to stroke gently [v]\n",
  "PATTLE": "(Scots) a small long-handled spade for cleaning a plough, also PETTLE [n -S]\n",
  "PATTLES": "PATTLE, (Scots) a small long-handled spade for cleaning a plough, also PETTLE [n]\n",
  "PATTRESS": "a container for the space behind electrical fittings such as power outlet sockets and light switches [n -ES]\n",
  "PATTRESSES": "PATTRESS, a container for the space behind electrical fittings such as power outlet sockets and light switches [n]\n",
  "PATTY": "a small, flat cake of chopped food, also PATTIE [n PATTIES]\n",
  "PATTYPAN": "a pan in which patties are baked [n -S]\n",
  "PATTYPANS": "PATTYPAN, a pan in which patties are baked [n]\n",
  "PATU": "(Maori) a short club [n -S]\n",
  "PATULENT": "spreading, open, also PATULOUS [adj]\n",
  "PATULIN": "a drug derived from penicillin [n -S]\n",
  "PATULINS": "PATULIN, a drug derived from penicillin [n]\n",
  "PATULOUS": "spreading, open, also PATULENT [adj PATULOUSLY]\n",
  "PATULOUSLY": "PATULOUS, spreading, open, also PATULENT [adv]\n",
  "PATULOUSNESS": "the state of being patulous [n -ES]\n",
  "PATULOUSNESSES": "PATULOUSNESS, the state of being patulous [n]\n",
  "PATUS": "PATU, (Maori) a short club [n]\n",
  "PATUTUKI": "(New Zealand) the blue cod [n -S]\n",
  "PATUTUKIS": "PATUTUKI, (New Zealand) the blue cod [n]\n",
  "PATY": "of a heraldic cross, having narrow arms, but expanding at the ends, also PATTEE [adj]\n",
  "PATZER": "(German) an inept chess player, also POTZER [n -S]\n",
  "PATZERS": "PATZER, (German) an inept chess player, also POTZER [n]\n",
  "PAUA": "(Maori) the abalone shell, also PAWA [n -S]\n",
  "PAUAS": "PAUA, (Maori) the abalone shell, also PAWA [n]\n",
  "PAUCAL": "a grammatical number in some languages representing a few [n -S]\n",
  "PAUCALS": "PAUCAL, a grammatical number in some languages representing a few [n]\n",
  "PAUCILOQUENT": "of few words; speaking little [adj]\n",
  "PAUCITIES": "PAUCITY, smallness of number or quantity [n]\n",
  "PAUCITY": "smallness of number or quantity [n PAUCITIES]\n",
  "PAUGHTIER": "PAUGHTY, (Scots) haughty [adj]\n",
  "PAUGHTIEST": "PAUGHTY, (Scots) haughty [adj]\n",
  "PAUGHTY": "(Scots) haughty [adj PAUGHTIER, PAUGHTIEST]\n",
  "PAUL": "an obsolete papal coin, also PAOLO [n -S]\n",
  "PAULDRON": "a shoulder plate for armour, also PULDRON [n -S]\n",
  "PAULDRONS": "PAULDRON, a shoulder plate for armour, also PULDRON [n]\n",
  "PAULIN": "a sheet of waterproof material [n -S]\n",
  "PAULINS": "PAULIN, a sheet of waterproof material [n]\n",
  "PAULOWNIA": "any tree of the Chinese and Japanese genus Paulownia, of the figwort family, with showy flowers [n -S]\n",
  "PAULOWNIAS": "PAULOWNIA, any tree of the Chinese and Japanese genus Paulownia, of the figwort family, with showy flowers [n]\n",
  "PAULS": "PAUL, an obsolete papal coin, also PAOLO [n]\n",
  "PAUNCE": "a pansy flower, also PANCE, PAWNCE [n -S]\n",
  "PAUNCES": "PAUNCE, a pansy flower, also PANCE, PAWNCE [n]\n",
  "PAUNCH": "to disembowel [v -ED, -ING, -ES]\n",
  "PAUNCHED": "PAUNCH, to disembowel [v]\n",
  "PAUNCHES": "PAUNCH, to disembowel [v]\n",
  "PAUNCHIER": "PAUNCHY, having a protruding belly [adj]\n",
  "PAUNCHIEST": "PAUNCHY, having a protruding belly [adj]\n",
  "PAUNCHINESS": "the state of being paunchy [n -ES]\n",
  "PAUNCHINESSES": "PAUNCHINESS, the state of being paunchy [n]\n",
  "PAUNCHING": "PAUNCH, to disembowel [v]\n",
  "PAUNCHY": "having a protruding belly [adj PAUNCHIER, PAUNCHIEST]\n",
  "PAUPER": "to reduce to poverty [v -ED, -ING, -S]\n",
  "PAUPERDOM": "the state of being a pauper [n -S]\n",
  "PAUPERDOMS": "PAUPERDOM, the state of being a pauper [n]\n",
  "PAUPERED": "PAUPER, to reduce to poverty [v]\n",
  "PAUPERESS": "a female pauper [n -ES]\n",
  "PAUPERESSES": "PAUPERESS, a female pauper [n]\n",
  "PAUPERING": "PAUPER, to reduce to poverty [v]\n",
  "PAUPERISATION": "the process of pauperising, also PAUPERIZATION [n -S]\n",
  "PAUPERISATIONS": "PAUPERISATION, the process of pauperising, also PAUPERIZATION [n]\n",
  "PAUPERISE": "to reduce to pauperism; as, to pauperise the peasantry, also PAUPERIZE [v PAUPERISED, PAUPERISING, PAUPERISES]\n",
  "PAUPERISED": "PAUPERISE, to reduce to pauperism; as, to pauperise the peasantry, also PAUPERIZE [v]\n",
  "PAUPERISES": "PAUPERISE, to reduce to pauperism; as, to pauperise the peasantry, also PAUPERIZE [v]\n",
  "PAUPERISING": "PAUPERISE, to reduce to pauperism; as, to pauperise the peasantry, also PAUPERIZE [v]\n",
  "PAUPERISM": "the state of being a pauper [n -S]\n",
  "PAUPERISMS": "PAUPERISM, the state of being a pauper [n]\n",
  "PAUPERIZATION": "the process of pauperizing, also PAUPERISATION [n -S]\n",
  "PAUPERIZATIONS": "PAUPERIZATION, the process of pauperizing, also PAUPERISATION [n]\n",
  "PAUPERIZE": "to reduce to pauperism; as, to pauperize the peasantry, also PAUPERISE [v PAUPERIZED, PAUPERIZING, PAUPERIZES]\n",
  "PAUPERIZED": "PAUPERIZE, to reduce to pauperism; as, to pauperize the peasantry, also PAUPERISE [v]\n",
  "PAUPERIZES": "PAUPERIZE, to reduce to pauperism; as, to pauperize the peasantry, also PAUPERISE [v]\n",
  "PAUPERIZING": "PAUPERIZE, to reduce to pauperism; as, to pauperize the peasantry, also PAUPERISE [v]\n",
  "PAUPERS": "PAUPER, to reduce to poverty [v]\n",
  "PAUPIETTE": "(French) a thinly sliced piece of meat used as a wrapper for various meat or forcemeat fillings [n -S]\n",
  "PAUPIETTES": "PAUPIETTE, (French) a thinly sliced piece of meat used as a wrapper for various meat or forcemeat fillings [n]\n",
  "PAURAQUE": "a long-tailed nocturnal bird [n -S]\n",
  "PAURAQUES": "PAURAQUE, a long-tailed nocturnal bird [n]\n",
  "PAUROPOD": "a minute myriapod, a millepede or centipede [n -S]\n",
  "PAUROPODS": "PAUROPOD, a minute myriapod, a millepede or centipede [n]\n",
  "PAUSAL": "pertaining to a break or rest in speaking or writing [adj]\n",
  "PAUSE": "to stop temporarily [v PAUSED, PAUSING, PAUSES]\n",
  "PAUSED": "PAUSE, to stop temporarily [v]\n",
  "PAUSEFUL": "full of pauses [adj PAUSEFULLY]\n",
  "PAUSEFULLY": "PAUSEFUL, full of pauses [adv]\n",
  "PAUSELESS": "without a pause [adj PAUSELESSLY]\n",
  "PAUSELESSLY": "PAUSELESS, without a pause [adv]\n",
  "PAUSER": "one who pauses [n -S]\n",
  "PAUSERS": "PAUSER, one who pauses [n]\n",
  "PAUSES": "PAUSE, to stop temporarily [v]\n",
  "PAUSING": "hesitating [adj PAUSINGLY] / the act of pausing [n -S]\n",
  "PAUSINGLY": "PAUSING, hesitating [adv]\n",
  "PAUSINGS": "PAUSING, the act of pausing [n]\n",
  "PAV": "(short for) a pavlova, a type of dessert consisting of a meringue base topped with whipped cream [n -S]\n",
  "PAVAGE": "a charge for paving streets [n -S]\n",
  "PAVAGES": "PAVAGE, a charge for paving streets [n]\n",
  "PAVAN": "a slow, stately dance, also PAVIN [n -S]\n",
  "PAVANE": "(French) a stately English Renaissance court dance, also PAVAN, PAVEN, PAVIN [n -S]\n",
  "PAVANES": "PAVANE, (French) a stately English Renaissance court dance, also PAVAN, PAVEN, PAVIN [n]\n",
  "PAVANS": "PAVAN, a slow, stately dance, also PAVIN [n]\n",
  "PAVE": "to cover with material that forms a firm, level surface [v PAVED, PAVING, PAVES]\n",
  "PAVED": "PAVE, to cover with material that forms a firm, level surface [v]\n",
  "PAVEED": "set close together to conceal a metal base [adj]\n",
  "PAVEMENT": "a paved surface [n -S] / to provide with a pavement [v -ED, -ING, -S]\n",
  "PAVEMENTED": "PAVEMENT, to provide with a pavement [v]\n",
  "PAVEMENTING": "PAVEMENT, to provide with a pavement [v]\n",
  "PAVEMENTS": "PAVEMENT, to provide with a pavement [v]\n",
  "PAVEN": "a stately English Renaissance court dance, also PAVAN, PAVANE, PAVIN [n -S]\n",
  "PAVENS": "PAVEN, a stately English Renaissance court dance, also PAVAN, PAVANE, PAVIN [n]\n",
  "PAVER": "a person who lays paving-stones; a machine for tamping down paving-stones, also PAVIOR, PAVIOUR [n -S]\n",
  "PAVERS": "PAVER, a person who lays paving-stones; a machine for tamping down paving-stones, also PAVIOR, PAVIOUR [n]\n",
  "PAVES": "PAVE, to cover with material that forms a firm, level surface [v]\n",
  "PAVID": "afraid; timid [adj]\n",
  "PAVILION": "to cover with a large tent [v -ED, -ING, -S]\n",
  "PAVILIONED": "PAVILION, to cover with a large tent [v]\n",
  "PAVILIONING": "PAVILION, to cover with a large tent [v]\n",
  "PAVILIONS": "PAVILION, to cover with a large tent [v]\n",
  "PAVILLON": "(French) the bell of a wind instrument [n -S]\n",
  "PAVILLONS": "PAVILLON, (French) the bell of a wind instrument [n]\n",
  "PAVIN": "a stately English Renaissance court dance, also PAVAN, PAVANE, PAVEN [n -S]\n",
  "PAVING": "a pavement [n -S]\n",
  "PAVINGS": "PAVING, a pavement [n]\n",
  "PAVINS": "PAVIN, a stately English Renaissance court dance, also PAVAN, PAVANE, PAVEN [n]\n",
  "PAVIOR": "a person who lays paving-stones; a machine for tamping down paving-stones, also PAVER, PAVIOUR [n -S]\n",
  "PAVIORS": "PAVIOR, a person who lays paving-stones; a machine for tamping down paving-stones, also PAVER, PAVIOUR [n]\n",
  "PAVIOUR": "a person who lays paving-stones; a machine for tamping down paving-stones, also PAVER, PAVIOR [n -S]\n",
  "PAVIOURS": "PAVIOUR, a person who lays paving-stones; a machine for tamping down paving-stones, also PAVER, PAVIOR [n]\n",
  "PAVIS": "a large medieval shield, also PAVISSE, PAVISE [n PAVISES or PAVISSES]\n",
  "PAVISE": "a large medieval shield, also PAVIS, PAVISSE [n -S]\n",
  "PAVISER": "a soldier carrying a pavis [n -S]\n",
  "PAVISERS": "PAVISER, a soldier carrying a pavis [n]\n",
  "PAVISES": "PAVISE, a large medieval shield, also PAVIS, PAVISSE [n]\n",
  "PAVISSE": "a large medieval shield, also PAVIS, PAVISE [n -S]\n",
  "PAVISSES": "PAVIS, a large medieval shield, also PAVISSE, PAVISE [n]\n",
  "PAVLOVA": "(Russian) a type of dessert consisting of a meringue base topped with whipped cream [n -S]\n",
  "PAVLOVAS": "PAVLOVA, (Russian) a type of dessert consisting of a meringue base topped with whipped cream [n]\n",
  "PAVONAZZO": "(Italian) a brightly coloured marble [n -S]\n",
  "PAVONAZZOS": "PAVONAZZO, (Italian) a brightly coloured marble [n]\n",
  "PAVONE": "(Spenser) a peacock [n -S]\n",
  "PAVONES": "PAVONE, (Spenser) a peacock [n]\n",
  "PAVONIAN": "of or relating to peacocks, also PAVONINE [adj]\n",
  "PAVONINE": "of or relating to peacocks, also PAVONIAN [adj]\n",
  "PAVS": "PAV, (short for) a pavlova, a type of dessert consisting of a meringue base topped with whipped cream [n]\n",
  "PAW": "to draw the forefoot along the ground [v -ED, -ING, -S]\n",
  "PAWA": "(Maori) the abalone shell, also PAUA [n -S]\n",
  "PAWAS": "PAWA, (Maori) the abalone shell, also PAUA [n]\n",
  "PAWAW": "(Native American) a conference between American Indians [n -S] / to hold such a conference, also POWWOW [v -ED, -ING, -S]\n",
  "PAWAWED": "PAWAW, to hold such a conference, also POWWOW [v]\n",
  "PAWAWING": "PAWAW, to hold such a conference, also POWWOW [v]\n",
  "PAWAWS": "PAWAW, to hold such a conference, also POWWOW [v]\n",
  "PAWED": "PAW, to draw the forefoot along the ground [v]\n",
  "PAWER": "one who paws [n -S]\n",
  "PAWERS": "PAWER, one who paws [n]\n",
  "PAWING": "PAW, to draw the forefoot along the ground [v]\n",
  "PAWK": "(Scots) a trick [n -S]\n",
  "PAWKIER": "PAWKY, (Scots) drily or slily humorous [adj]\n",
  "PAWKIEST": "PAWKY, (Scots) drily or slily humorous [adj]\n",
  "PAWKILY": "PAWKY, (Scots) drily or slily humorous [adv]\n",
  "PAWKINESS": "being pawky, drily or slily humorous [n -ES]\n",
  "PAWKINESSES": "PAWKINESS, being pawky, drily or slily humorous [n]\n",
  "PAWKS": "PAWK, (Scots) a trick [n]\n",
  "PAWKY": "(Scots) drily or slily humorous [adj PAWKIER, PAWKIEST, PAWKILY]\n",
  "PAWL": "a lever which engages with a ratchet wheel so as to permit movement in one direction only [n -S]\n",
  "PAWLS": "PAWL, a lever which engages with a ratchet wheel so as to permit movement in one direction only [n]\n",
  "PAWN": "to deposit as security for something borrowed [v -ED, -ING, -S]\n",
  "PAWNABLE": "able to be pawned [adj]\n",
  "PAWNAGE": "an act of pawning [n -S]\n",
  "PAWNAGES": "PAWNAGE, an act of pawning [n]\n",
  "PAWNBROKER": "one who lends money on the security of personal property pledged in his keeping [n -S]\n",
  "PAWNBROKERS": "PAWNBROKER, one who lends money on the security of personal property pledged in his keeping [n]\n",
  "PAWNBROKING": "the activity of a pawnbroker [n -S]\n",
  "PAWNBROKINGS": "PAWNBROKING, the activity of a pawnbroker [n]\n",
  "PAWNCE": "(obsolete) a pansy flower, also PANCE, PAUNCE [n -S]\n",
  "PAWNCES": "PAWNCE, (obsolete) a pansy flower, also PANCE, PAUNCE [n]\n",
  "PAWNED": "PAWN, to deposit as security for something borrowed [v]\n",
  "PAWNEE": "one to whom something is pawned [n -S]\n",
  "PAWNEES": "PAWNEE, one to whom something is pawned [n]\n",
  "PAWNER": "one who pawns something, also PAWNOR [n -S]\n",
  "PAWNERS": "PAWNER, one who pawns something, also PAWNOR [n]\n",
  "PAWNING": "PAWN, to deposit as security for something borrowed [v]\n",
  "PAWNOR": "one who pawns something, also PAWNER [n -S]\n",
  "PAWNORS": "PAWNOR, one who pawns something, also PAWNER [n]\n",
  "PAWNS": "PAWN, to deposit as security for something borrowed [v]\n",
  "PAWNSHOP": "a shop where thing are pawned [n -S]\n",
  "PAWNSHOPS": "PAWNSHOP, a shop where thing are pawned [n]\n",
  "PAWNTICKET": "a ticket issued by a pawnbroker [n -S]\n",
  "PAWNTICKETS": "PAWNTICKET, a ticket issued by a pawnbroker [n]\n",
  "PAWPAW": "a tree of the custard-apple family; its fruit, also PAPAW, PAPAYA [n -S]\n",
  "PAWPAWS": "PAWPAW, a tree of the custard-apple family; its fruit, also PAPAW, PAPAYA [n]\n",
  "PAWS": "PAW, to draw the forefoot along the ground [v]\n",
  "PAX": "(Latin) peace, a truce [n -ES]\n",
  "PAXES": "PAX, (Latin) peace, a truce [n]\n",
  "PAXIUBA": "(Portuguese) a Brazilian palm with stilt-roots [n -S]\n",
  "PAXIUBAS": "PAXIUBA, (Portuguese) a Brazilian palm with stilt-roots [n]\n",
  "PAXWAX": "the strong tendon in an animal's neck, also PACKWAX [n -ES]\n",
  "PAXWAXES": "PAXWAX, the strong tendon in an animal's neck, also PACKWAX [n]\n",
  "PAY": "to give money in exchange for goods or services [v PAID, PAYING, PAYS] / to seal with tar [v -ED, -ING, -S]\n",
  "PAYABLE": "able to be paid [adj PAYABLY] / what is due to be paid [n -S]\n",
  "PAYABLES": "PAYABLE, what is due to be paid [n]\n",
  "PAYABLY": "PAYABLE, able to be paid [adv]\n",
  "PAYBACK": "a return on an investment equal to the original capital outlay [n -S]\n",
  "PAYBACKS": "PAYBACK, a return on an investment equal to the original capital outlay [n]\n",
  "PAYCHECK": "a check in payment of wages or salary, also PAYCHEQUE [n -S]\n",
  "PAYCHECKS": "PAYCHECK, a check in payment of wages or salary, also PAYCHEQUE [n]\n",
  "PAYCHEQUE": "a payment for work done, also PAYCHECK [n -S]\n",
  "PAYCHEQUES": "PAYCHEQUE, a payment for work done, also PAYCHECK [n]\n",
  "PAYDAY": "the day on which wages are paid [n -S]\n",
  "PAYDAYS": "PAYDAY, the day on which wages are paid [n]\n",
  "PAYDOWN": "the reduction of debt through repayment [n -S]\n",
  "PAYDOWNS": "PAYDOWN, the reduction of debt through repayment [n]\n",
  "PAYED": "PAY, to give money in exchange for goods or services [v]\n",
  "PAYEE": "one to whom money is paid [n -S]\n",
  "PAYEES": "PAYEE, one to whom money is paid [n]\n",
  "PAYER": "one who pays, also PAYOR [n -S]\n",
  "PAYERS": "PAYER, one who pays, also PAYOR [n]\n",
  "PAYESS": "(Yiddish) uncut sideburns worn by some Jews [n]\n",
  "PAYFONE": "a coin-operated public telephone, also PAYPHONE [n -S]\n",
  "PAYFONES": "PAYFONE, a coin-operated public telephone, also PAYPHONE [n]\n",
  "PAYGRADE": "the grade of military personnel according to a base pay scale [n -S]\n",
  "PAYGRADES": "PAYGRADE, the grade of military personnel according to a base pay scale [n]\n",
  "PAYING": "the act of sealing with tar [n -S]\n",
  "PAYINGS": "PAYING, the act of sealing with tar [n]\n",
  "PAYLIST": "a list of people entitled to receive pay, with the amounts due to each [n -S]\n",
  "PAYLISTS": "PAYLIST, a list of people entitled to receive pay, with the amounts due to each [n]\n",
  "PAYLOAD": "the part of a cargo producing income [n -S]\n",
  "PAYLOADS": "PAYLOAD, the part of a cargo producing income [n]\n",
  "PAYMASTER": "the official in an organization, government etc. who pays out money [n -S]\n",
  "PAYMASTERS": "PAYMASTER, the official in an organization, government etc. who pays out money [n]\n",
  "PAYMENT": "something that is paid [n -S]\n",
  "PAYMENTS": "PAYMENT, something that is paid [n]\n",
  "PAYNIM": "a heathen, also PAINIM, PANIM [n -S]\n",
  "PAYNIMRIES": "PAYNIMRY, heathendom [n]\n",
  "PAYNIMRY": "heathendom [n PAYNIMRIES]\n",
  "PAYNIMS": "PAYNIM, a heathen, also PAINIM, PANIM [n]\n",
  "PAYOFF": "the act of distributing gains [n -S]\n",
  "PAYOFFS": "PAYOFF, the act of distributing gains [n]\n",
  "PAYOLA": "a secret payment or bribe to secure a favour, esp. to a disc-jockey [n -S]\n",
  "PAYOLAS": "PAYOLA, a secret payment or bribe to secure a favour, esp. to a disc-jockey [n]\n",
  "PAYOR": "one who pays, also PAYER [n -S]\n",
  "PAYORS": "PAYOR, one who pays, also PAYER [n]\n",
  "PAYOUT": "money that is paid out [n -S]\n",
  "PAYOUTS": "PAYOUT, money that is paid out [n]\n",
  "PAYPHONE": "a coin-operated public telephone, also PAYFONE [n -S]\n",
  "PAYPHONES": "PAYPHONE, a coin-operated public telephone, also PAYFONE [n]\n",
  "PAYROLL": "a list of employees entitled to payment [n -S]\n",
  "PAYROLLS": "PAYROLL, a list of employees entitled to payment [n]\n",
  "PAYS": "PAY, to give money in exchange for goods or services [v]\n",
  "PAYSAGE": "(French) a rural scene or landscape, or representation of this [n -S]\n",
  "PAYSAGES": "PAYSAGE, (French) a rural scene or landscape, or representation of this [n]\n",
  "PAYSAGIST": "a painter of landscapes [n -S]\n",
  "PAYSAGISTS": "PAYSAGIST, a painter of landscapes [n]\n",
  "PAYSD": "(Spenser) poised [v]\n",
  "PAYSLIP": "a note indicating the breakdown of wages [n -S]\n",
  "PAYSLIPS": "PAYSLIP, a note indicating the breakdown of wages [n]\n",
  "PAYWALL": "an arrangement allowing access to a website only to users who have paid to subscribe to it [n -S]\n",
  "PAYWALLS": "PAYWALL, an arrangement allowing access to a website only to users who have paid to subscribe to it [n]\n",
  "PAZAZZ": "flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "PAZAZZES": "PAZAZZ, flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n]\n",
  "PAZZAZZ": "flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "PAZZAZZES": "PAZZAZZ, flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZAZZ, PIZAZZ, PIZZAZ, PIZZAZZ, PZAZZ [n]\n",
  "PE": "(Hebrew) a Hebrew letter, also FE, FEH, PEH [n -S]\n",
  "PEA": "the edible seed of an annual herb [n -S]\n",
  "PEABERRIES": "PEABERRY, a type of coffee seed [n]\n",
  "PEABERRY": "a type of coffee seed [n PEABERRIES]\n",
  "PEABRAIN": "a stupid person [n -S]\n",
  "PEABRAINS": "PEABRAIN, a stupid person [n]\n",
  "PEACE": "a state of quiet [n -S] / (Shakespeare) to be silent [v PEACED, PEACING, PEACES]\n",
  "PEACEABLE": "inclined to peace [adj PEACEABLY]\n",
  "PEACEABLENESS": "PEACEABLE, inclined to peace [n]\n",
  "PEACEABLENESSES": "PEACEABLENESS, PEACEABLE, inclined to peace [n]\n",
  "PEACEABLY": "PEACEABLE, inclined to peace [adv]\n",
  "PEACED": "PEACE, (Shakespeare) to be silent [v]\n",
  "PEACEFUL": "undisturbed, calm [adj PEACEFULLER, PEACEFULLEST, PEACEFULLY]\n",
  "PEACEFULLER": "PEACEFUL, undisturbed, calm [adj]\n",
  "PEACEFULLEST": "PEACEFUL, undisturbed, calm [adj]\n",
  "PEACEFULLY": "PEACEFUL, undisturbed, calm [adv]\n",
  "PEACEFULNESS": "the state of being peaceful [n -ES]\n",
  "PEACEFULNESSES": "PEACEFULNESS, the state of being peaceful [n]\n",
  "PEACEKEEPER": "one who keeps the peace [n -S]\n",
  "PEACEKEEPERS": "PEACEKEEPER, one who keeps the peace [n]\n",
  "PEACEKEEPING": "the preserving of peace [n -S]\n",
  "PEACEKEEPINGS": "PEACEKEEPING, the preserving of peace [n]\n",
  "PEACELESS": "without peace; disturbed [adj]\n",
  "PEACELESSNESS": "the state of being peaceless [n -ES]\n",
  "PEACELESSNESSES": "PEACELESSNESS, the state of being peaceless [n]\n",
  "PEACEMAKER": "one who makes peace esp. by reconciling parties at variance [n -S]\n",
  "PEACEMAKERS": "PEACEMAKER, one who makes peace esp. by reconciling parties at variance [n]\n",
  "PEACEMAKING": "activities relating to making peace [n -S]\n",
  "PEACEMAKINGS": "PEACEMAKING, activities relating to making peace [n]\n",
  "PEACENIK": "one who demonstrates against a war [n -S]\n",
  "PEACENIKS": "PEACENIK, one who demonstrates against a war [n]\n",
  "PEACES": "PEACE, (Shakespeare) to be silent [v]\n",
  "PEACETIME": "a period of time between wars [n -S]\n",
  "PEACETIMES": "PEACETIME, a period of time between wars [n]\n",
  "PEACH": "to inform against someone [v -ED, -ING, -ES]\n",
  "PEACHBLOW": "a delicate purplish-pink colour, used as a glaze on porcelain [n -S]\n",
  "PEACHBLOWS": "PEACHBLOW, a delicate purplish-pink colour, used as a glaze on porcelain [n]\n",
  "PEACHED": "PEACH, to inform against someone [v]\n",
  "PEACHER": "one who peaches [n -S]\n",
  "PEACHERINO": "(US slang) a girl [n -S]\n",
  "PEACHERINOS": "PEACHERINO, (US slang) a girl [n]\n",
  "PEACHERS": "PEACHER, one who peaches [n]\n",
  "PEACHES": "PEACH, to inform against someone [v]\n",
  "PEACHICK": "a young peafowl [n -S]\n",
  "PEACHICKS": "PEACHICK, a young peafowl [n]\n",
  "PEACHIER": "PEACHY, coloured or tasting somewhat of peach [adj]\n",
  "PEACHIEST": "PEACHY, coloured or tasting somewhat of peach [adj]\n",
  "PEACHILY": "PEACHY, coloured or tasting somewhat of peach [adv]\n",
  "PEACHINESS": "the state of being peachy [n -ES]\n",
  "PEACHINESSES": "PEACHINESS, the state of being peachy [n]\n",
  "PEACHING": "PEACH, to inform against someone [v]\n",
  "PEACHY": "coloured or tasting somewhat of peach [adj PEACHIER, PEACHIEST, PEACHILY]\n",
  "PEACING": "PEACE, (Shakespeare) to be silent [v]\n",
  "PEACOAT": "a heavy woollen jacket [n -S]\n",
  "PEACOATS": "PEACOAT, a heavy woollen jacket [n]\n",
  "PEACOCK": "to strut vainly [v -ED, -ING, -S]\n",
  "PEACOCKED": "PEACOCK, to strut vainly [v]\n",
  "PEACOCKERIES": "PEACOCKERY, vain ostentation [n]\n",
  "PEACOCKERY": "vain ostentation [n PEACOCKERIES]\n",
  "PEACOCKIER": "PEACOCKY, vain, strutting [adj]\n",
  "PEACOCKIEST": "PEACOCKY, vain, strutting [adj]\n",
  "PEACOCKING": "PEACOCK, to strut vainly [v]\n",
  "PEACOCKISH": "like a peacock [adj]\n",
  "PEACOCKS": "PEACOCK, to strut vainly [v]\n",
  "PEACOCKY": "vain, strutting [adj PEACOCKIER, PEACOCKIEST]\n",
  "PEACOD": "the pod of the pea, also PEAPOD, PEASCOD, PEASECOD [n -S]\n",
  "PEACODS": "PEACOD, the pod of the pea, also PEAPOD, PEASCOD, PEASECOD [n]\n",
  "PEAFOWL": "a large pheasant [n -S]\n",
  "PEAFOWLS": "PEAFOWL, a large pheasant [n]\n",
  "PEAG": "(Native American) a form of currency once used by North American Indians, also PEAGE [n -S]\n",
  "PEAGE": "(Native American) a form of currency once used by North American Indians, also PEAG [n -S]\n",
  "PEAGES": "PEAGE, (Native American) a form of currency once used by North American Indians, also PEAG [n]\n",
  "PEAGS": "PEAG, (Native American) a form of currency once used by North American Indians, also PEAGE [n]\n",
  "PEAHEN": "a female peacock [n -S]\n",
  "PEAHENS": "PEAHEN, a female peacock [n]\n",
  "PEAK": "to reach a maximum [v -ED, -ING, -S]\n",
  "PEAKED": "PEAK, to reach a maximum [v]\n",
  "PEAKEDNESS": "the state of being peaked [n -ES]\n",
  "PEAKEDNESSES": "PEAKEDNESS, the state of being peaked [n]\n",
  "PEAKIER": "PEAKY, off-colour, unwell [adj]\n",
  "PEAKIEST": "PEAKY, off-colour, unwell [adj]\n",
  "PEAKINESS": "the state of being peaky, somewhat unwell [n -ES]\n",
  "PEAKINESSES": "PEAKINESS, the state of being peaky, somewhat unwell [n]\n",
  "PEAKING": "the act of coming to a peak [n -S]\n",
  "PEAKINGS": "PEAKING, the act of coming to a peak [n]\n",
  "PEAKISH": "somewhat sickly [adj]\n",
  "PEAKLESS": "having no pointed top [adj]\n",
  "PEAKLIKE": "resembling a peak [adj]\n",
  "PEAKS": "PEAK, to reach a maximum [v]\n",
  "PEAKY": "off-colour, unwell [adj PEAKIER, PEAKIEST]\n",
  "PEAL": "to ring out [v -ED, -ING, -S]\n",
  "PEALED": "PEAL, to ring out [v]\n",
  "PEALIKE": "like a pea [adj]\n",
  "PEALING": "PEAL, to ring out [v]\n",
  "PEALS": "PEAL, to ring out [v]\n",
  "PEAN": "to beat with a rounded hammer head, also PEEN, PEIN, PENE [v -ED, -ING, -S]\n",
  "PEANED": "PEAN, to beat with a rounded hammer head, also PEEN, PEIN, PENE [v]\n",
  "PEANING": "PEAN, to beat with a rounded hammer head, also PEEN, PEIN, PENE [v]\n",
  "PEANS": "PEAN, to beat with a rounded hammer head, also PEEN, PEIN, PENE [v]\n",
  "PEANUT": "the monkey-nut or groundnut [n -S]\n",
  "PEANUTS": "PEANUT, the monkey-nut or groundnut [n]\n",
  "PEANUTTIER": "PEANUTTY, having the taste of peanuts [adj]\n",
  "PEANUTTIEST": "PEANUTTY, having the taste of peanuts [adj]\n",
  "PEANUTTY": "having the taste of peanuts [adj PEANUTTIER, PEANUTTIEST]\n",
  "PEAPOD": "the pod of the pea, also PEACOD, PEASCOD, PEASECOD [n -S]\n",
  "PEAPODS": "PEAPOD, the pod of the pea, also PEACOD, PEASCOD, PEASECOD [n]\n",
  "PEAR": "a fleshy fruit [n -S]\n",
  "PEARCE": "(Spenser) to pierce, also PERCE, PERCEN, PERSE [v PEARCED, PEARCING, PEARCES]\n",
  "PEARCED": "PEARCE, (Spenser) to pierce, also PERCE, PERCEN, PERSE [v]\n",
  "PEARCES": "PEARCE, (Spenser) to pierce, also PERCE, PERCEN, PERSE [v]\n",
  "PEARCING": "PEARCE, (Spenser) to pierce, also PERCE, PERCEN, PERSE [v]\n",
  "PEARE": "(Spenser) a peer, an equal [n -S]\n",
  "PEARES": "PEARE, (Spenser) a peer, an equal [n]\n",
  "PEARL": "to adorn with a milky-white concretion of nacre [v -ED, -ING, -S]\n",
  "PEARLASH": "an alkaline compound obtained from wood ash [n -ES]\n",
  "PEARLASHES": "PEARLASH, an alkaline compound obtained from wood ash [n]\n",
  "PEARLED": "PEARL, to adorn with a milky-white concretion of nacre [v]\n",
  "PEARLER": "one who dives for pearls [n -S]\n",
  "PEARLERS": "PEARLER, one who dives for pearls [n]\n",
  "PEARLESCENCE": "the state of being pearlescent [n -S]\n",
  "PEARLESCENCES": "PEARLESCENCE, the state of being pearlescent [n]\n",
  "PEARLESCENT": "having a pearly sheen [adj]\n",
  "PEARLIER": "PEARLY, like a pearl [adj]\n",
  "PEARLIES": "PEARLY, a costermonger dressed in pearl-buttoned clothes [n]\n",
  "PEARLIEST": "PEARLY, like a pearl [adj]\n",
  "PEARLIN": "(Scots) a lace of silk or thread, used as edging, also PEARLING [n -S]\n",
  "PEARLINESS": "the state of being pearly [n -ES]\n",
  "PEARLINESSES": "PEARLINESS, the state of being pearly [n]\n",
  "PEARLING": "(Scots) a lace of silk or thread, used as edging, also PEARLIN [n -S]\n",
  "PEARLINGS": "PEARLING, (Scots) a lace of silk or thread, used as edging, also PEARLIN [n]\n",
  "PEARLINS": "PEARLIN, (Scots) a lace of silk or thread, used as edging, also PEARLING [n]\n",
  "PEARLISED": "treated so as to give a pearly or lustrous surface, also PEARLIZED [adj]\n",
  "PEARLITE": "ferrite and cementite showing distinct bands [n -S]\n",
  "PEARLITES": "PEARLITE, ferrite and cementite showing distinct bands [n]\n",
  "PEARLITIC": "relating to pearlite, ferrite and cementite showing distinct bands [adj]\n",
  "PEARLIZED": "treated so as to give a pearly or lustrous surface, also PEARLISED [adj]\n",
  "PEARLS": "PEARL, to adorn with a milky-white concretion of nacre [v]\n",
  "PEARLWARE": "goods made from pearl [n -S]\n",
  "PEARLWARES": "PEARLWARE, goods made from pearl [n]\n",
  "PEARLWORT": "a name given to several low and inconspicuous herbs of the Chickweed family [n -S]\n",
  "PEARLWORTS": "PEARLWORT, a name given to several low and inconspicuous herbs of the Chickweed family [n]\n",
  "PEARLY": "like a pearl [adj PEARLIER, PEARLIEST] / a costermonger dressed in pearl-buttoned clothes [n PEARLIES]\n",
  "PEARMAIN": "a variety of apple [n -S]\n",
  "PEARMAINS": "PEARMAIN, a variety of apple [n]\n",
  "PEARMONGER": "a seller of pears [n -S]\n",
  "PEARMONGERS": "PEARMONGER, a seller of pears [n]\n",
  "PEARS": "PEAR, a fleshy fruit [n]\n",
  "PEARST": "(Spenser) pierced, also PERST, PIERST [v]\n",
  "PEART": "active, lively, brisk [adj PEARTER, PEARTEST, PEARTLY]\n",
  "PEARTER": "PEART, active, lively, brisk [adj]\n",
  "PEARTEST": "PEART, active, lively, brisk [adj]\n",
  "PEARTLY": "PEART, active, lively, brisk [adv]\n",
  "PEARTNESS": "the state of being peart [n -ES]\n",
  "PEARTNESSES": "PEARTNESS, the state of being peart [n]\n",
  "PEARWOOD": "the wood of the pear tree [n -S]\n",
  "PEARWOODS": "PEARWOOD, the wood of the pear tree [n]\n",
  "PEAS": "PEA, the edible seed of an annual herb [n]\n",
  "PEASANT": "a person of inferior social rank, also PESANT, PESAUNT, PEZANT [n -S]\n",
  "PEASANTIER": "PEASANTY, in the style of a peasant [adj]\n",
  "PEASANTIEST": "PEASANTY, in the style of a peasant [adj]\n",
  "PEASANTRIES": "PEASANTRY, peasants as a class; the condition or quality of a peasant [n]\n",
  "PEASANTRY": "peasants as a class; the condition or quality of a peasant [n PEASANTRIES]\n",
  "PEASANTS": "PEASANT, a person of inferior social rank, also PESANT, PESAUNT, PEZANT [n]\n",
  "PEASANTY": "in the style of a peasant [adj PEASANTIER, PEASANTIEST]\n",
  "PEASCOD": "a pea pod, also PEASECOD, PEACOD [n -S]\n",
  "PEASCODS": "PEASCOD, a pea pod, also PEASECOD, PEACOD [n]\n",
  "PEASE": "(obsolete) to balance, poise, also PEISE, PEAZE, PEIZE, PEYSE, POYSE [v PEASED, PEASING, PEASES] / (archaic) a pea [n PEASEN or PEASON]\n",
  "PEASECOD": "the pod of the pea, also PEACOD, PEAPOD, PEASCOD [n -S]\n",
  "PEASECODS": "PEASECOD, the pod of the pea, also PEACOD, PEAPOD, PEASCOD [n]\n",
  "PEASED": "PEASE, (obsolete) to balance, poise, also PEISE, PEAZE, PEIZE, PEYSE, POYSE [v]\n",
  "PEASEN": "PEASE, (archaic) a pea [n]\n",
  "PEASES": "PEASE, (obsolete) to balance, poise, also PEISE, PEAZE, PEIZE, PEYSE, POYSE [v]\n",
  "PEASHOOTER": "a toy blowgun that uses peas for projectiles [n -S]\n",
  "PEASHOOTERS": "PEASHOOTER, a toy blowgun that uses peas for projectiles [n]\n",
  "PEASING": "PEASE, (obsolete) to balance, poise, also PEISE, PEAZE, PEIZE, PEYSE, POYSE [v]\n",
  "PEASON": "PEASE, (archaic) a pea [n]\n",
  "PEASOUPER": "a thick fog [n -S]\n",
  "PEASOUPERS": "PEASOUPER, a thick fog [n]\n",
  "PEAT": "a substance composed of partially decayed vegetable matter [n -S]\n",
  "PEATARIES": "PEATARY, a region covered with peat, also PEATERY, PETARY [n]\n",
  "PEATARY": "a region covered with peat, also PEATERY, PETARY [n PEATARIES]\n",
  "PEATERIES": "PEATERY, a region covered with peat, also PEATARY, PETARY [n]\n",
  "PEATERY": "a region covered with peat, also PEATARY, PETARY [n PEATERIES]\n",
  "PEATIER": "PEATY, of or like peat [adj]\n",
  "PEATIEST": "PEATY, of or like peat [adj]\n",
  "PEATLAND": "an area of land consisting of peat bogs [n -S]\n",
  "PEATLANDS": "PEATLAND, an area of land consisting of peat bogs [n]\n",
  "PEATMAN": "a peat seller [n PEATMEN]\n",
  "PEATMEN": "PEATMAN, a peat seller [n]\n",
  "PEATS": "PEAT, a substance composed of partially decayed vegetable matter [n]\n",
  "PEATSHIP": "the state of being a peat, a lawyer allegedly under the patronage of a particular judge [n -S]\n",
  "PEATSHIPS": "PEATSHIP, the state of being a peat, a lawyer allegedly under the patronage of a particular judge [n]\n",
  "PEATY": "of or like peat [adj PEATIER, PEATIEST]\n",
  "PEAVEY": "a lever used to move logs, also PEAVY [n -S]\n",
  "PEAVEYS": "PEAVEY, a lever used to move logs, also PEAVY [n]\n",
  "PEAVIES": "PEAVY, a lever used to move logs, also PEAVEY [n]\n",
  "PEAVY": "a lever used to move logs, also PEAVEY [n PEAVIES]\n",
  "PEAZE": "to weigh, also PEISE, PEASE, PEIZE, PEYSE, POYSE [v PEAZED, PEAZING, PEAZES]\n",
  "PEAZED": "PEAZE, to weigh, also PEISE, PEASE, PEIZE, PEYSE, POYSE [v]\n",
  "PEAZES": "PEAZE, to weigh, also PEISE, PEASE, PEIZE, PEYSE, POYSE [v]\n",
  "PEAZING": "PEAZE, to weigh, also PEISE, PEASE, PEIZE, PEYSE, POYSE [v]\n",
  "PEBA": "(Tupi) a large armadillo of tropical South America, aka tatouay [n -S]\n",
  "PEBAS": "PEBA, (Tupi) a large armadillo of tropical South America, aka tatouay [n]\n",
  "PEBBLE": "to cover with small, rounded stones [v PEBBLED, PEBBLING, PEBBLES]\n",
  "PEBBLED": "PEBBLE, to cover with small, rounded stones [v]\n",
  "PEBBLEDASH": "to treat with pebbledash, a method of coating exterior walls with small pebbles set in mortar [v -ED, -ING, -ES]\n",
  "PEBBLEDASHED": "PEBBLEDASH, to treat with pebbledash, a method of coating exterior walls with small pebbles set in mortar [v]\n",
  "PEBBLEDASHES": "PEBBLEDASH, to treat with pebbledash, a method of coating exterior walls with small pebbles set in mortar [v]\n",
  "PEBBLEDASHING": "PEBBLEDASH, to treat with pebbledash, a method of coating exterior walls with small pebbles set in mortar [v]\n",
  "PEBBLES": "PEBBLE, to cover with small, rounded stones [v]\n",
  "PEBBLEWEAVE": "an irregularly textured material made from twisted yarn [n -S]\n",
  "PEBBLEWEAVES": "PEBBLEWEAVE, an irregularly textured material made from twisted yarn [n]\n",
  "PEBBLIER": "PEBBLY, resembling pebbles [adj]\n",
  "PEBBLIEST": "PEBBLY, resembling pebbles [adj]\n",
  "PEBBLING": "in the sport of curling, the act of sprinkling the ice with drops of hot water to slow the stone down [n -S]\n",
  "PEBBLINGS": "PEBBLING, in the sport of curling, the act of sprinkling the ice with drops of hot water to slow the stone down [n]\n",
  "PEBBLY": "resembling pebbles [adj PEBBLIER, PEBBLIEST]\n",
  "PEBIBYTE": "two to the power of fifty bytes [n -S]\n",
  "PEBIBYTES": "PEBIBYTE, two to the power of fifty bytes [n]\n",
  "PEBRINE": "(French) a disease of silkworms [n -S]\n",
  "PEBRINES": "PEBRINE, (French) a disease of silkworms [n]\n",
  "PEC": "(colloquial) a pectoral muscle [n -S]\n",
  "PECAN": "(Native American) a nut-bearing tree [n -S]\n",
  "PECANS": "PECAN, (Native American) a nut-bearing tree [n]\n",
  "PECCABILITIES": "PECCABILITY, the state of being peccable, liable or prone to sin [n]\n",
  "PECCABILITY": "the state of being peccable, liable or prone to sin [n PECCABILITIES]\n",
  "PECCABLE": "liable to sin [adj]\n",
  "PECCADILLO": "(Spanish) a slight offence or sin [n -ES or -S]\n",
  "PECCADILLOES": "PECCADILLO, (Spanish) a slight offence or sin [n]\n",
  "PECCADILLOS": "PECCADILLO, (Spanish) a slight offence or sin [n]\n",
  "PECCANCIES": "PECCANCY, sinfulness; transgression [n]\n",
  "PECCANCY": "sinfulness; transgression [n PECCANCIES]\n",
  "PECCANT": "sinning; guilty of transgression [adj PECCANTLY]\n",
  "PECCANTLY": "PECCANT, sinning; guilty of transgression [adv]\n",
  "PECCARIES": "PECCARY, (Caribbean) a kind of wild pig [n]\n",
  "PECCARY": "(Caribbean) a kind of wild pig [n PECCARIES]\n",
  "PECCAVI": "(Latin) a confession of sin or guilt [n -S]\n",
  "PECCAVIS": "PECCAVI, (Latin) a confession of sin or guilt [n]\n",
  "PECH": "(Scots) to pant, also PEGH [v -ED, -ING, -S]\n",
  "PECHAN": "(Scots) the stomach [n -S]\n",
  "PECHANS": "PECHAN, (Scots) the stomach [n]\n",
  "PECHED": "PECH, (Scots) to pant, also PEGH [v]\n",
  "PECHING": "PECH, (Scots) to pant, also PEGH [v]\n",
  "PECHS": "PECH, (Scots) to pant, also PEGH [v]\n",
  "PECK": "to strike with a beak [v -ED, -ING, -S]\n",
  "PECKE": "(Shakespeare) to pitch; to jerk [v PECKED, PECKING, PECKES]\n",
  "PECKED": "PECKE, (Shakespeare) to pitch; to jerk [v]\n",
  "PECKER": "that which pecks; (slang) the penis [n -S]\n",
  "PECKERS": "PECKER, that which pecks; (slang) the penis [n]\n",
  "PECKERWOOD": "a southern term for poor Anglo-Saxon protestants [n -S]\n",
  "PECKERWOODS": "PECKERWOOD, a southern term for poor Anglo-Saxon protestants [n]\n",
  "PECKES": "PECKE, (Shakespeare) to pitch; to jerk [v]\n",
  "PECKIER": "PECKY, marked by decay caused by fungi [adj]\n",
  "PECKIEST": "PECKY, marked by decay caused by fungi [adj]\n",
  "PECKING": "the act of pecking [n -S]\n",
  "PECKINGS": "PECKING, the act of pecking [n]\n",
  "PECKISH": "somewhat hungry [adj PECKISHLY]\n",
  "PECKISHLY": "PECKISH, somewhat hungry [adv]\n",
  "PECKISHNESS": "the state of being peckish [n -ES]\n",
  "PECKISHNESSES": "PECKISHNESS, the state of being peckish [n]\n",
  "PECKS": "PECK, to strike with a beak [v]\n",
  "PECKY": "marked by decay caused by fungi [adj PECKIER, PECKIEST]\n",
  "PECORINI": "PECORINO, (Italian) a hard cheese made from sheep's milk [n]\n",
  "PECORINO": "(Italian) a hard cheese made from sheep's milk [n PECORINOS or PECORINI]\n",
  "PECORINOS": "PECORINO, (Italian) a hard cheese made from sheep's milk [n]\n",
  "PECS": "PEC, (colloquial) a pectoral muscle [n]\n",
  "PECTASE": "an enzyme [n -S]\n",
  "PECTASES": "PECTASE, an enzyme [n]\n",
  "PECTATE": "a salt of pectic acid [n -S]\n",
  "PECTATES": "PECTATE, a salt of pectic acid [n]\n",
  "PECTEN": "(Latin) a comblike anatomical part [n PECTENS or PECTINES]\n",
  "PECTENS": "PECTEN, (Latin) a comblike anatomical part [n]\n",
  "PECTIC": "of, relating to, or derived from pectin [adj]\n",
  "PECTIN": "a mixture of carbohydrates found in the cell walls of fruits, used for the setting of jams and jellies [n -S]\n",
  "PECTINACEOUS": "of, relating to, or containing pectin [adj]\n",
  "PECTINAL": "a fish with bones or a spine resembling a comb [n -S]\n",
  "PECTINALS": "PECTINAL, a fish with bones or a spine resembling a comb [n]\n",
  "PECTINATE": "toothed like a comb, also PECTINATED [adj PECTINATELY]\n",
  "PECTINATED": "toothed like a comb, also PECTINATE [adj]\n",
  "PECTINATELY": "PECTINATE, toothed like a comb, also PECTINATED [adv]\n",
  "PECTINATION": "a comblike structure [n -S]\n",
  "PECTINATIONS": "PECTINATION, a comblike structure [n]\n",
  "PECTINEAL": "of the pubic bone [adj]\n",
  "PECTINEI": "PECTINEUS, a large flat muscle in the thigh [n]\n",
  "PECTINES": "PECTEN, (Latin) a comblike anatomical part [n]\n",
  "PECTINESTERASE": "an enzyme that catalyzes the hydrolysis of pectins into pectic acids and methanol [n -S]\n",
  "PECTINESTERASES": "PECTINESTERASE, an enzyme that catalyzes the hydrolysis of pectins into pectic acids and methanol [n]\n",
  "PECTINEUS": "a large flat muscle in the thigh [n PECTINEI or PECTINEUSES]\n",
  "PECTINEUSES": "PECTINEUS, a large flat muscle in the thigh [n]\n",
  "PECTINOUS": "of or like pectin [adj]\n",
  "PECTINS": "PECTIN, a mixture of carbohydrates found in the cell walls of fruits, used for the setting of jams and jellies [n]\n",
  "PECTISABLE": "that can be pectised, also PECTIZABLE [adj]\n",
  "PECTISATION": "the act of pectising, also PECTIZATION [n -S]\n",
  "PECTISATIONS": "PECTISATION, the act of pectising, also PECTIZATION [n]\n",
  "PECTISE": "to congeal to a jelly, also PECTIZE [v PECTISED, PECTISING, PECTISES]\n",
  "PECTISED": "PECTISE, to congeal to a jelly, also PECTIZE [v]\n",
  "PECTISES": "PECTISE, to congeal to a jelly, also PECTIZE [v]\n",
  "PECTISING": "PECTISE, to congeal to a jelly, also PECTIZE [v]\n",
  "PECTIZABLE": "that can be pectized, also PECTISABLE [adj]\n",
  "PECTIZATION": "the act of pectizing, also PECTISATION [n -S]\n",
  "PECTIZATIONS": "PECTIZATION, the act of pectizing, also PECTISATION [n]\n",
  "PECTIZE": "to congeal to a jelly, also PECTISE [v PECTIZED, PECTIZING, PECTIZES]\n",
  "PECTIZED": "PECTIZE, to congeal to a jelly, also PECTISE [v]\n",
  "PECTIZES": "PECTIZE, to congeal to a jelly, also PECTISE [v]\n",
  "PECTIZING": "PECTIZE, to congeal to a jelly, also PECTISE [v]\n",
  "PECTOLITE": "a hydrous silicate of lime and soda, occurring in radiated or fibrous crystalline masses [n -S]\n",
  "PECTOLITES": "PECTOLITE, a hydrous silicate of lime and soda, occurring in radiated or fibrous crystalline masses [n]\n",
  "PECTORAL": "related to the chest [adj PECTORALLY] / a pectoral muscle [n -S]\n",
  "PECTORALLY": "PECTORAL, related to the chest [adv]\n",
  "PECTORALS": "PECTORAL, a pectoral muscle [n]\n",
  "PECTORILOQUIES": "PECTORILOQUY, the sound of a patient's voice as heard through a stethoscope [n]\n",
  "PECTORILOQUY": "the sound of a patient's voice as heard through a stethoscope [n PECTORILOQUIES]\n",
  "PECTOSE": "a pectin-yielding substance contained in the fleshy pulp of unripe fruit [n -S]\n",
  "PECTOSES": "PECTOSE, a pectin-yielding substance contained in the fleshy pulp of unripe fruit [n]\n",
  "PECULATE": "to embezzle [v PECULATED, PECULATING, PECULATES]\n",
  "PECULATED": "PECULATE, to embezzle [v]\n",
  "PECULATES": "PECULATE, to embezzle [v]\n",
  "PECULATING": "PECULATE, to embezzle [v]\n",
  "PECULATION": "embezzlement [n -S]\n",
  "PECULATIONS": "PECULATION, embezzlement [n]\n",
  "PECULATOR": "one who peculates [n -S]\n",
  "PECULATORS": "PECULATOR, one who peculates [n]\n",
  "PECULIA": "PECULIUM, (Latin) private property [n]\n",
  "PECULIAR": "strange [adj PECULIARLY] / a parish or church exempt from the jurisdiction of the diocese in which it lies [n -S]\n",
  "PECULIARISE": "to set apart, also PECULIARIZE [v PECULIARISED, PECULIARISING, PECULIARISES]\n",
  "PECULIARISED": "PECULIARISE, to set apart, also PECULIARIZE [v]\n",
  "PECULIARISES": "PECULIARISE, to set apart, also PECULIARIZE [v]\n",
  "PECULIARISING": "PECULIARISE, to set apart, also PECULIARIZE [v]\n",
  "PECULIARITIES": "PECULIARITY, the state of being peculiar [n]\n",
  "PECULIARITY": "the state of being peculiar [n PECULIARITIES]\n",
  "PECULIARIZE": "to set apart, also PECULIARISE [v PECULIARIZED, PECULIARIZING, PECULIARIZES]\n",
  "PECULIARIZED": "PECULIARIZE, to set apart, also PECULIARISE [v]\n",
  "PECULIARIZES": "PECULIARIZE, to set apart, also PECULIARISE [v]\n",
  "PECULIARIZING": "PECULIARIZE, to set apart, also PECULIARISE [v]\n",
  "PECULIARLY": "PECULIAR, strange [adv]\n",
  "PECULIARS": "PECULIAR, a parish or church exempt from the jurisdiction of the diocese in which it lies [n]\n",
  "PECULIUM": "(Latin) private property [n PECULIA]\n",
  "PECUNIARILY": "PECUNIARY, pertaining to money [adv]\n",
  "PECUNIARY": "pertaining to money [adj PECUNIARILY]\n",
  "PECUNIOUS": "having a lot of money [adj]\n",
  "PED": "a natural soil aggregate [n -S]\n",
  "PEDAGOG": "one who teaches; by extension, a pedant, also PAEDAGOGUE, PEDAGOGUE [n -S]\n",
  "PEDAGOGIC": "like a pedagogue, also PAEDAGOGIC, PEDAGOGICAL [adj PEDAGOGICALLY]\n",
  "PEDAGOGICAL": "of, relating to, or befitting a teacher or education, also PAEDAGOGIC, PEDAGOGIC [adj PEDAGOGICALLY]\n",
  "PEDAGOGICALLY": "PEDAGOGICAL, of, relating to, or befitting a teacher or education, also PAEDAGOGIC, PEDAGOGIC [adv]\n",
  "PEDAGOGICS": "the science and principles of teaching [n]\n",
  "PEDAGOGIES": "PEDAGOGY, the work of a teacher [n]\n",
  "PEDAGOGISM": "the spirit or system of pedagogues [n -S]\n",
  "PEDAGOGISMS": "PEDAGOGISM, the spirit or system of pedagogues [n]\n",
  "PEDAGOGS": "PEDAGOG, one who teaches; by extension, a pedant, also PAEDAGOGUE, PEDAGOGUE [n]\n",
  "PEDAGOGUE": "one who teaches; by extension, a pedant, also PAEDAGOGUE, PEDAGOG [n -S] / to teach [v PEDAGOGUED, PEDAGOGUING, PEDAGOGUES]\n",
  "PEDAGOGUED": "PEDAGOGUE, to teach [v]\n",
  "PEDAGOGUERIES": "PEDAGOGUERY, schoolmastering, teaching [n]\n",
  "PEDAGOGUERY": "schoolmastering, teaching [n PEDAGOGUERIES]\n",
  "PEDAGOGUES": "PEDAGOGUE, one who teaches; by extension, a pedant, also PAEDAGOGUE, PEDAGOG [n]\n",
  "PEDAGOGUING": "PEDAGOGUE, to teach [v]\n",
  "PEDAGOGUISH": "in the manner of a pedagogue [adj]\n",
  "PEDAGOGUISHNESS": "PEDAGOGUISH, in the manner of a pedagogue [n]\n",
  "PEDAGOGUISM": "the state of being a pedagogue [n -S]\n",
  "PEDAGOGUISMS": "PEDAGOGUISM, the state of being a pedagogue [n]\n",
  "PEDAGOGY": "the work of a teacher [n PEDAGOGIES]\n",
  "PEDAL": "to operate by means of foot levers [v PEDALED or PEDALLED, PEDALING or PEDALLING, PEDALS]\n",
  "PEDALBOAT": "a boat that is propelled by operating the pedals, usually one hired for pleasure [n -S]\n",
  "PEDALBOATS": "PEDALBOAT, a boat that is propelled by operating the pedals, usually one hired for pleasure [n]\n",
  "PEDALCAR": "a four-wheeled vehicle that is operated by pedals, usually a child's toy [n -S]\n",
  "PEDALCARS": "PEDALCAR, a four-wheeled vehicle that is operated by pedals, usually a child's toy [n]\n",
  "PEDALED": "PEDAL, to operate by means of foot levers [v]\n",
  "PEDALER": "someone who uses pedals, also PEDALLER [n -S]\n",
  "PEDALERS": "PEDALER, someone who uses pedals, also PEDALLER [n]\n",
  "PEDALFER": "a type of soil, typical of a humid region [n -S]\n",
  "PEDALFERS": "PEDALFER, a type of soil, typical of a humid region [n]\n",
  "PEDALIER": "the pedal keyboard of an organ [n -S]\n",
  "PEDALIERS": "PEDALIER, the pedal keyboard of an organ [n]\n",
  "PEDALING": "PEDAL, to operate by means of foot levers [v]\n",
  "PEDALLED": "PEDAL, to operate by means of foot levers [v]\n",
  "PEDALLER": "someone who uses pedals, also PEDALER [n -S]\n",
  "PEDALLERS": "PEDALLER, someone who uses pedals, also PEDALER [n]\n",
  "PEDALLING": "the act of pedalling [n -S]\n",
  "PEDALLINGS": "PEDALLING, the act of pedalling [n]\n",
  "PEDALO": "a type of pleasure boat powered by pedalling [n -S or -ES]\n",
  "PEDALOES": "PEDALO, a type of pleasure boat powered by pedalling [n]\n",
  "PEDALOS": "PEDALO, a type of pleasure boat powered by pedalling [n]\n",
  "PEDALS": "PEDAL, to operate by means of foot levers [v]\n",
  "PEDANT": "a person who parades or reveres excessively academic learning or technical knowledge [n -S]\n",
  "PEDANTIC": "in the manner of a pedant, also PEDANTICAL [adj PEDANTICALLY]\n",
  "PEDANTICAL": "in the manner of a pedant, also PEDANTIC [adj PEDANTICALLY]\n",
  "PEDANTICALLY": "PEDANTICAL, in the manner of a pedant, also PEDANTIC [adv]\n",
  "PEDANTICISE": "to be pedantic, also PEDANTICIZE [v PEDANTICISED, PEDANTICISING, PEDANTICISES]\n",
  "PEDANTICISED": "PEDANTICISE, to be pedantic, also PEDANTICIZE [v]\n",
  "PEDANTICISES": "PEDANTICISE, to be pedantic, also PEDANTICIZE [v]\n",
  "PEDANTICISING": "PEDANTICISE, to be pedantic, also PEDANTICIZE [v]\n",
  "PEDANTICISM": "pedantry, also PEDANTISM [n -S]\n",
  "PEDANTICISMS": "PEDANTICISM, pedantry, also PEDANTISM [n]\n",
  "PEDANTICIZE": "to be pedantic, also PEDANTICISE [v PEDANTICIZED, PEDANTICIZING, PEDANTICIZES]\n",
  "PEDANTICIZED": "PEDANTICIZE, to be pedantic, also PEDANTICISE [v]\n",
  "PEDANTICIZES": "PEDANTICIZE, to be pedantic, also PEDANTICISE [v]\n",
  "PEDANTICIZING": "PEDANTICIZE, to be pedantic, also PEDANTICISE [v]\n",
  "PEDANTISE": "to play the pedant, also PEDANTIZE [v PEDANTISED, PEDANTISING, PEDANTISES]\n",
  "PEDANTISED": "PEDANTISE, to play the pedant, also PEDANTIZE [v]\n",
  "PEDANTISES": "PEDANTISE, to play the pedant, also PEDANTIZE [v]\n",
  "PEDANTISING": "PEDANTISE, to play the pedant, also PEDANTIZE [v]\n",
  "PEDANTISM": "pedantry, also PEDANTICISM [n -S]\n",
  "PEDANTISMS": "PEDANTISM, pedantry, also PEDANTICISM [n]\n",
  "PEDANTIZE": "to play the pedant, also PEDANTISE [v PEDANTIZED, PEDANTIZING, PEDANTIZES]\n",
  "PEDANTIZED": "PEDANTIZE, to play the pedant, also PEDANTISE [v]\n",
  "PEDANTIZES": "PEDANTIZE, to play the pedant, also PEDANTISE [v]\n",
  "PEDANTIZING": "PEDANTIZE, to play the pedant, also PEDANTISE [v]\n",
  "PEDANTOCRACIES": "PEDANTOCRACY, government by pedants or strict rule-bound scholars [n]\n",
  "PEDANTOCRACY": "government by pedants or strict rule-bound scholars [n PEDANTOCRACIES]\n",
  "PEDANTOCRAT": "a member of the pedantocracy [n -S]\n",
  "PEDANTOCRATIC": "relating to pedantocracy, government by pedants [adj]\n",
  "PEDANTOCRATS": "PEDANTOCRAT, a member of the pedantocracy [n]\n",
  "PEDANTRIES": "PEDANTRY, ostentatious display of knowledge [n]\n",
  "PEDANTRY": "ostentatious display of knowledge [n PEDANTRIES]\n",
  "PEDANTS": "PEDANT, a person who parades or reveres excessively academic learning or technical knowledge [n]\n",
  "PEDATE": "footed, footlike [adj PEDATELY]\n",
  "PEDATELY": "PEDATE, footed, footlike [adv]\n",
  "PEDATIFID": "of a leaf, cleft in a pedate manner, but having the lobes distinctly connected at the base [adj]\n",
  "PEDDER": "(Scots) a pedlar [n -S]\n",
  "PEDDERS": "PEDDER, (Scots) a pedlar [n]\n",
  "PEDDLE": "to sell or offer for sale [v PEDDLED, PEDDLING, PEDDLES]\n",
  "PEDDLED": "PEDDLE, to sell or offer for sale [v]\n",
  "PEDDLER": "a person who goes about carrying small goods for sale, esp. one who goes from door to door with the goods in a pack, also PEDDER, PEDLAR, PEDLER, PETHER [n -S]\n",
  "PEDDLERIES": "PEDDLERY, the trade of a peddler, also PEDLARY, PEDLERY [n]\n",
  "PEDDLERS": "PEDDLER, a person who goes about carrying small goods for sale, esp. one who goes from door to door with the goods in a pack, also PEDDER, PEDLAR, PEDLER, PETHER [n]\n",
  "PEDDLERY": "the trade of a peddler, also PEDLARY, PEDLERY [n PEDDLERIES]\n",
  "PEDDLES": "PEDDLE, to sell or offer for sale [v]\n",
  "PEDDLING": "the act of peddling [n -S]\n",
  "PEDDLINGS": "PEDDLING, the act of peddling [n]\n",
  "PEDERAST": "a man who engages in sexual activity with boys [n -S]\n",
  "PEDERASTIC": "of or pertaining to pederasty, also PAEDERASTIC [adj]\n",
  "PEDERASTIES": "PEDERASTY, anal intercourse between a man and a boy, also PAEDERASTY [n]\n",
  "PEDERASTS": "PEDERAST, a man who engages in sexual activity with boys [n]\n",
  "PEDERASTY": "anal intercourse between a man and a boy, also PAEDERASTY [n PEDERASTIES]\n",
  "PEDERERO": "(Spanish) a type of old gun, also PEDRERO, PADERERO, PATERERO [n PEDEREROS or PEDEREROES]\n",
  "PEDEREROES": "PEDERERO, (Spanish) a type of old gun, also PEDRERO, PADERERO, PATERERO [n]\n",
  "PEDEREROS": "PEDERERO, (Spanish) a type of old gun, also PEDRERO, PADERERO, PATERERO [n]\n",
  "PEDES": "PES, a foot or footlike part [n]\n",
  "PEDESES": "PEDESIS, (Greek) a Brownian movement [n]\n",
  "PEDESIS": "(Greek) a Brownian movement [n PEDESES]\n",
  "PEDESTAL": "to provide with an architectural support [v PEDESTALED or PEDESTALLED, PEDESTALING or PEDESTALLING, PEDESTALS]\n",
  "PEDESTALED": "PEDESTAL, to provide with an architectural support [v]\n",
  "PEDESTALING": "PEDESTAL, to provide with an architectural support [v]\n",
  "PEDESTALLED": "PEDESTAL, to provide with an architectural support [v]\n",
  "PEDESTALLING": "PEDESTAL, to provide with an architectural support [v]\n",
  "PEDESTALS": "PEDESTAL, to provide with an architectural support [v]\n",
  "PEDESTRIAN": "a person going on foot [n -S]\n",
  "PEDESTRIANISE": "to make pedestrian, also PEDESTRIANIZE [v PEDESTRIANISED, PEDESTRIANISING, PEDESTRIANISES]\n",
  "PEDESTRIANISED": "PEDESTRIANISE, to make pedestrian, also PEDESTRIANIZE [v]\n",
  "PEDESTRIANISES": "PEDESTRIANISE, to make pedestrian, also PEDESTRIANIZE [v]\n",
  "PEDESTRIANISING": "PEDESTRIANISE, to make pedestrian, also PEDESTRIANIZE [v]\n",
  "PEDESTRIANISM": "the practice of walking [n -S]\n",
  "PEDESTRIANISMS": "PEDESTRIANISM, the practice of walking [n]\n",
  "PEDESTRIANIZE": "to make pedestrian, also PEDESTRIANISE [v PEDESTRIANIZED, PEDESTRIANIZING, PEDESTRIANIZES]\n",
  "PEDESTRIANIZED": "PEDESTRIANIZE, to make pedestrian, also PEDESTRIANISE [v]\n",
  "PEDESTRIANIZES": "PEDESTRIANIZE, to make pedestrian, also PEDESTRIANISE [v]\n",
  "PEDESTRIANIZING": "PEDESTRIANIZE, to make pedestrian, also PEDESTRIANISE [v]\n",
  "PEDESTRIANS": "PEDESTRIAN, a person going on foot [n]\n",
  "PEDETENTOUS": "proceeding slowly [adj]\n",
  "PEDETIC": "relating to pedesis, Brownian movement [adj]\n",
  "PEDI": "(short for) pedicure [n -S]\n",
  "PEDIATRIC": "relating to the care of children, also PAEDIATRIC [adj]\n",
  "PEDIATRICIAN": "a specialist in pediatrics [n -S]\n",
  "PEDIATRICIANS": "PEDIATRICIAN, a specialist in pediatrics [n]\n",
  "PEDIATRICS": "the care of children, also PAEDIATRICS [n]\n",
  "PEDIATRIST": "a specialist in child care, also PAEDIATRIST [n -S]\n",
  "PEDIATRISTS": "PEDIATRIST, a specialist in child care, also PAEDIATRIST [n]\n",
  "PEDICAB": "a light vehicle consisting of a tricycle with the addition of a covered seat for a passenger [n -S]\n",
  "PEDICABS": "PEDICAB, a light vehicle consisting of a tricycle with the addition of a covered seat for a passenger [n]\n",
  "PEDICEL": "a slender basal part of an organism, also PEDICLE [n -S]\n",
  "PEDICELLARIA": "each of numerous organs like small pincers on the outside of an echinoderm [n PEDICELLARIAE]\n",
  "PEDICELLARIAE": "PEDICELLARIA, each of numerous organs like small pincers on the outside of an echinoderm [n]\n",
  "PEDICELLATE": "having a pedicel, a short stalk [adj]\n",
  "PEDICELS": "PEDICEL, a slender basal part of an organism, also PEDICLE [n]\n",
  "PEDICLE": "a slender basal part of an organism, also PEDICEL [n -S]\n",
  "PEDICLED": "having a pedicle [adj]\n",
  "PEDICLES": "PEDICLE, a slender basal part of an organism, also PEDICEL [n]\n",
  "PEDICULAR": "of or pertaining to lice [adj]\n",
  "PEDICULATE": "stalked, also PEDICULATED [adj] / any of the angler fishes, whose pectoral fins have a wrist-like articulation [n -S]\n",
  "PEDICULATED": "stalked, also PEDICULATE [adj]\n",
  "PEDICULATES": "PEDICULATE, any of the angler fishes, whose pectoral fins have a wrist-like articulation [n]\n",
  "PEDICULATION": "lousiness [n -S]\n",
  "PEDICULATIONS": "PEDICULATION, lousiness [n]\n",
  "PEDICULI": "PEDICULUS, (Latin) any member of the louse genus [n]\n",
  "PEDICULOSES": "PEDICULOSIS, infestation with lice [n]\n",
  "PEDICULOSIS": "infestation with lice [n PEDICULOSES]\n",
  "PEDICULOUS": "infested with lice, lousy [adj]\n",
  "PEDICULUS": "(Latin) any member of the louse genus [n PEDICULI]\n",
  "PEDICURE": "to apply foot-treatment to [v PEDICURED, PEDICURING, PEDICURES]\n",
  "PEDICURED": "PEDICURE, to apply foot-treatment to [v]\n",
  "PEDICURES": "PEDICURE, to apply foot-treatment to [v]\n",
  "PEDICURING": "PEDICURE, to apply foot-treatment to [v]\n",
  "PEDICURIST": "one who cares for the feet [n -S]\n",
  "PEDICURISTS": "PEDICURIST, one who cares for the feet [n]\n",
  "PEDIFORM": "shaped like a foot [adj]\n",
  "PEDIGREE": "a line of ancestors [n -S]\n",
  "PEDIGREED": "having a pedigree [adj]\n",
  "PEDIGREES": "PEDIGREE, a line of ancestors [n]\n",
  "PEDIMENT": "a triangular structure crowning front of a Greek building [n -S]\n",
  "PEDIMENTAL": "of or pertaining to a pediment [adj]\n",
  "PEDIMENTED": "having a pediment [adj]\n",
  "PEDIMENTS": "PEDIMENT, a triangular structure crowning front of a Greek building [n]\n",
  "PEDIPALP": "one of the second pair of appendages of an arachnoid, also PEDIPALPUS [n -S]\n",
  "PEDIPALPI": "PEDIPALPUS, one of the second pair of appendages of an arachnoid, also PEDIPALP [n]\n",
  "PEDIPALPS": "PEDIPALP, one of the second pair of appendages of an arachnoid, also PEDIPALPUS [n]\n",
  "PEDIPALPUS": "one of the second pair of appendages of an arachnoid, also PEDIPALP [n PEDIPALPI]\n",
  "PEDIS": "PEDI, (short for) pedicure [n]\n",
  "PEDLAR": "a person who goes about carrying small goods for sale, esp. one who goes from door to door with the goods in a pack, also PEDDER, PEDDLER, PEDLER, PETHER [n -S]\n",
  "PEDLARIES": "PEDLARY, the trade of a peddler, also PEDDLERY, PEDLERY [n]\n",
  "PEDLARS": "PEDLAR, a person who goes about carrying small goods for sale, esp. one who goes from door to door with the goods in a pack, also PEDDER, PEDDLER, PEDLER, PETHER [n]\n",
  "PEDLARY": "the trade of a peddler, also PEDDLERY, PEDLERY [n PEDLARIES]\n",
  "PEDLER": "a person who goes about carrying small goods for sale, esp. one who goes from door to door with the goods in a pack, also PEDDER, PEDDLER, PEDLAR, PETHER [n -S]\n",
  "PEDLERIES": "PEDLERY, the trade of a peddler, also PEDDLERY, PEDLARY [n]\n",
  "PEDLERS": "PEDLER, a person who goes about carrying small goods for sale, esp. one who goes from door to door with the goods in a pack, also PEDDER, PEDDLER, PEDLAR, PETHER [n]\n",
  "PEDLERY": "the trade of a peddler, also PEDDLERY, PEDLARY [n PEDLERIES]\n",
  "PEDOCAL": "a type of soil typical of an arid or semiarid region [n -S]\n",
  "PEDOCALIC": "of or like pedocal, a generic term used to describe the soils typically found in an arid or semiarid region [adj]\n",
  "PEDOCALS": "PEDOCAL, a type of soil typical of an arid or semiarid region [n]\n",
  "PEDOGENESES": "PEDOGENESIS, the process of soil generation [n]\n",
  "PEDOGENESIS": "the process of soil generation [n PEDOGENESES]\n",
  "PEDOGENETIC": "relating to pedogenesis, the process of soil generation [adj]\n",
  "PEDOGENIC": "relating to pedogenesis, the process of soil generation [adj]\n",
  "PEDOLOGIC": "relating to pedology, the study of the growth and development of children [adj]\n",
  "PEDOLOGICAL": "of or relating to soils [adj]\n",
  "PEDOLOGIES": "PEDOLOGY, the study of the growth and development of children, also PAEDOLOGY [n]\n",
  "PEDOLOGIST": "one who studies the growth and development of children, also PAEDOLOGIST [n -S]\n",
  "PEDOLOGISTS": "PEDOLOGIST, one who studies the growth and development of children, also PAEDOLOGIST [n]\n",
  "PEDOLOGY": "the study of the growth and development of children, also PAEDOLOGY [n PEDOLOGIES]\n",
  "PEDOMETER": "an instrument for measuring distance travelled on foot [n -S]\n",
  "PEDOMETERS": "PEDOMETER, an instrument for measuring distance travelled on foot [n]\n",
  "PEDOPHILE": "one with a perverted sexual desire for children, also PAEDOPHILE [n -S]\n",
  "PEDOPHILES": "PEDOPHILE, one with a perverted sexual desire for children, also PAEDOPHILE [n]\n",
  "PEDOPHILIA": "sexual desire for children [n -S]\n",
  "PEDOPHILIAC": "one who suffers from pedophilia, sexual desire for children [n -S]\n",
  "PEDOPHILIACS": "PEDOPHILIAC, one who suffers from pedophilia, sexual desire for children [n]\n",
  "PEDOPHILIAS": "PEDOPHILIA, sexual desire for children [n]\n",
  "PEDOPHILIC": "a pedophile, also PAEDOPHILIC [n -S]\n",
  "PEDOPHILICS": "PEDOPHILIC, a pedophile, also PAEDOPHILIC [n]\n",
  "PEDORTHIC": "of footwear, designed to alleviate foot problems [adj]\n",
  "PEDRAIL": "a tractor with footlike pieces on the circumference of its wheels [n -S]\n",
  "PEDRAILS": "PEDRAIL, a tractor with footlike pieces on the circumference of its wheels [n]\n",
  "PEDRERO": "(Spanish) a type of old gun, also PADERERO, PATERERO, PEDERERO [n -ES or -S]\n",
  "PEDREROES": "PEDRERO, (Spanish) a type of old gun, also PADERERO, PATERERO, PEDERERO [n]\n",
  "PEDREROS": "PEDRERO, (Spanish) a type of old gun, also PADERERO, PATERERO, PEDERERO [n]\n",
  "PEDRO": "a card game [n -S]\n",
  "PEDROS": "PEDRO, a card game [n]\n",
  "PEDS": "PED, a natural soil aggregate [n]\n",
  "PEDUNCLE": "the stalk of an inflorescence or solitary flower [n -S]\n",
  "PEDUNCLED": "having a peduncle [adj]\n",
  "PEDUNCLES": "PEDUNCLE, the stalk of an inflorescence or solitary flower [n]\n",
  "PEDUNCULAR": "of or pertaining to a peduncle [adj]\n",
  "PEDUNCULATE": "having a peduncle or stalk, also PEDUNCULATED [adj]\n",
  "PEDUNCULATED": "having a peduncle or stalk, also PEDUNCULATE [adj]\n",
  "PEDUNCULATION": "the state of being pedunculate [n -S]\n",
  "PEDUNCULATIONS": "PEDUNCULATION, the state of being pedunculate [n]\n",
  "PEDWAY": "a walkway for pedestrians only [n -S]\n",
  "PEDWAYS": "PEDWAY, a walkway for pedestrians only [n]\n",
  "PEE": "to urinate [v PEED, PEEING, PEES]\n",
  "PEEBEEN": "a large, hardwood, evergreen tree [n -S]\n",
  "PEEBEENS": "PEEBEEN, a large, hardwood, evergreen tree [n]\n",
  "PEECE": "(obsolete) a piece [n -S]\n",
  "PEECES": "PEECE, (obsolete) a piece [n]\n",
  "PEED": "PEE, to urinate [v]\n",
  "PEEING": "PEE, to urinate [v]\n",
  "PEEK": "to sneak a sly look [v -ED, -ING, -S]\n",
  "PEEKABO": "a peeping game played by small children, also PEEKABOO [n -S]\n",
  "PEEKABOO": "a peeping game played by small children, also PEEKABO [n -S]\n",
  "PEEKABOOS": "PEEKABOO, a peeping game played by small children, also PEEKABO [n]\n",
  "PEEKABOS": "PEEKABO, a peeping game played by small children, also PEEKABOO [n]\n",
  "PEEKAPOO": "a dog that is a cross between a Pekingese and a poodle, also PEKEPOO [n -S]\n",
  "PEEKAPOOS": "PEEKAPOO, a dog that is a cross between a Pekingese and a poodle, also PEKEPOO [n]\n",
  "PEEKED": "PEEK, to sneak a sly look [v]\n",
  "PEEKING": "PEEK, to sneak a sly look [v]\n",
  "PEEKS": "PEEK, to sneak a sly look [v]\n",
  "PEEL": "to remove the outer covering of a fruit [v -ED, -ING, -S]\n",
  "PEELABLE": "able to be peeled [adj]\n",
  "PEELED": "PEEL, to remove the outer covering of a fruit [v]\n",
  "PEELER": "(colloquial) a policeman [n -S]\n",
  "PEELERS": "PEELER, (colloquial) a policeman [n]\n",
  "PEELGARLIC": "a bald person; a person looked upon with humorous contempt or mock pity, also PILGARLIC, PILGARLICK [n -S]\n",
  "PEELGARLICS": "PEELGARLIC, a bald person; a person looked upon with humorous contempt or mock pity, also PILGARLIC, PILGARLICK [n]\n",
  "PEELING": "a piece or strip that has been peeled off [n -S]\n",
  "PEELINGS": "PEELING, a piece or strip that has been peeled off [n]\n",
  "PEELS": "PEEL, to remove the outer covering of a fruit [v]\n",
  "PEEN": "to beat with a rounded hammer head, also PEAN, PEIN, PENE [v -ED, -ING, -S]\n",
  "PEENED": "PEEN, to beat with a rounded hammer head, also PEAN, PEIN, PENE [v]\n",
  "PEENGE": "(Scots) to whine like a peevish child [v PEENGED, PEENGING or PEENGEING, PEENGES]\n",
  "PEENGED": "PEENGE, (Scots) to whine like a peevish child [v]\n",
  "PEENGEING": "PEENGE, (Scots) to whine like a peevish child [v]\n",
  "PEENGES": "PEENGE, (Scots) to whine like a peevish child [v]\n",
  "PEENGING": "PEENGE, (Scots) to whine like a peevish child [v]\n",
  "PEENING": "the act of beating thin with a hammer [n -S]\n",
  "PEENINGS": "PEENING, the act of beating thin with a hammer [n]\n",
  "PEENS": "PEEN, to beat with a rounded hammer head, also PEAN, PEIN, PENE [v]\n",
  "PEEOY": "(Scots) a homemade firework, also PIOY, PIOYE [n -S]\n",
  "PEEOYS": "PEEOY, (Scots) a homemade firework, also PIOY, PIOYE [n]\n",
  "PEEP": "to cheep like a chicken [v -ED, -ING, -S]\n",
  "PEEPBO": "the game of peekaboo [n -S]\n",
  "PEEPBOS": "PEEPBO, the game of peekaboo [n]\n",
  "PEEPE": "(Shakespeare) a pip [n -S]\n",
  "PEEPED": "PEEP, to cheep like a chicken [v]\n",
  "PEEPER": "a kind of tree-frog [n -S]\n",
  "PEEPERS": "PEEPER, a kind of tree-frog [n]\n",
  "PEEPES": "PEEPE, (Shakespeare) a pip [n]\n",
  "PEEPHOLE": "a small opening through which one may look [n -S]\n",
  "PEEPHOLES": "PEEPHOLE, a small opening through which one may look [n]\n",
  "PEEPING": "PEEP, to cheep like a chicken [v]\n",
  "PEEPS": "PEEP, to cheep like a chicken [v]\n",
  "PEEPSHOW": "a small display of pictures etc. viewed through a lens or hole set in a box or machine [n -S]\n",
  "PEEPSHOWS": "PEEPSHOW, a small display of pictures etc. viewed through a lens or hole set in a box or machine [n]\n",
  "PEEPTOE": "denoting a shoe or sandal in which the toe is not covered [adj]\n",
  "PEEPUL": "(Hindi) a fig tree from India, aka bo tree, also PIPAL, PIPUL [n -S]\n",
  "PEEPULS": "PEEPUL, (Hindi) a fig tree from India, aka bo tree, also PIPAL, PIPUL [n]\n",
  "PEER": "to look narrowly or searchingly [v -ED, -ING, -S]\n",
  "PEERAGE": "the rank of a nobleman [n -S]\n",
  "PEERAGES": "PEERAGE, the rank of a nobleman [n]\n",
  "PEERED": "PEER, to look narrowly or searchingly [v]\n",
  "PEERESS": "a noblewoman [n -ES]\n",
  "PEERESSES": "PEERESS, a noblewoman [n]\n",
  "PEERIE": "(Scots) small [adj PEERIER, PEERIEST] / a wooden spinning top, also PEERY [n -S]\n",
  "PEERIER": "PEERIE, (Scots) small [adj]\n",
  "PEERIES": "PEERY, a wooden spinning top, also PEERIE [n]\n",
  "PEERIEST": "PEERIE, (Scots) small [adj]\n",
  "PEERING": "PEER, to look narrowly or searchingly [v]\n",
  "PEERLESS": "having no equal [adj PEERLESSLY]\n",
  "PEERLESSLY": "PEERLESS, having no equal [adv]\n",
  "PEERLESSNESS": "the state of being peerless [n -ES]\n",
  "PEERLESSNESSES": "PEERLESSNESS, the state of being peerless [n]\n",
  "PEERS": "PEER, to look narrowly or searchingly [v]\n",
  "PEERY": "a wooden spinning top, also PEERIE [n PEERIES]\n",
  "PEES": "PEE, to urinate [v]\n",
  "PEESWEEP": "(Scots) the peewit [n -S]\n",
  "PEESWEEPS": "PEESWEEP, (Scots) the peewit [n]\n",
  "PEETWEET": "a wading bird [n -S]\n",
  "PEETWEETS": "PEETWEET, a wading bird [n]\n",
  "PEEVE": "to irritate [v PEEVED, PEEVING, PEEVES]\n",
  "PEEVED": "PEEVE, to irritate [v]\n",
  "PEEVER": "(Scots) a tile, tin lid etc. used in playing hopscotch [n -S]\n",
  "PEEVERS": "PEEVER, (Scots) a tile, tin lid etc. used in playing hopscotch [n]\n",
  "PEEVES": "PEEVE, to irritate [v]\n",
  "PEEVING": "PEEVE, to irritate [v]\n",
  "PEEVISH": "irritable [adj PEEVISHLY]\n",
  "PEEVISHLY": "PEEVISH, irritable [adv]\n",
  "PEEVISHNESS": "the state of being peevish [n -ES]\n",
  "PEEVISHNESSES": "PEEVISHNESS, the state of being peevish [n]\n",
  "PEEWEE": "a bird, the lapwing or plover, also PEEWIT, PEWIT [n -S]\n",
  "PEEWEES": "PEEWEE, a bird, the lapwing or plover, also PEEWIT, PEWIT [n]\n",
  "PEEWIT": "a bird, the lapwing or plover, also PEEWEE, PEWIT [n -S]\n",
  "PEEWITS": "PEEWIT, a bird, the lapwing or plover, also PEEWEE, PEWIT [n]\n",
  "PEG": "to fasten with a wooden pin [v PEGGED, PEGGING, PEGS]\n",
  "PEGASUS": "(Latin) a member of a genus of small fishes superficially like seahorses [n -ES]\n",
  "PEGASUSES": "PEGASUS, (Latin) a member of a genus of small fishes superficially like seahorses [n]\n",
  "PEGBOARD": "a board with holes for pegs [n -S]\n",
  "PEGBOARDS": "PEGBOARD, a board with holes for pegs [n]\n",
  "PEGBOX": "the part of some stringed instruments that holds the tuning pegs [n -ES]\n",
  "PEGBOXES": "PEGBOX, the part of some stringed instruments that holds the tuning pegs [n]\n",
  "PEGGED": "PEG, to fasten with a wooden pin [v]\n",
  "PEGGIER": "PEGGY, resembling a peg [adj]\n",
  "PEGGIES": "PEGGY, a small warbler of various kinds [n]\n",
  "PEGGIEST": "PEGGY, resembling a peg [adj]\n",
  "PEGGING": "the act of pegging [n -S]\n",
  "PEGGINGS": "PEGGING, the act of pegging [n]\n",
  "PEGGY": "resembling a peg [adj PEGGIER, PEGGIEST] / a small warbler of various kinds [n PEGGIES]\n",
  "PEGH": "(Scots) to pant, also PECH [v -ED, -ING, -S]\n",
  "PEGHED": "PEGH, (Scots) to pant, also PECH [v]\n",
  "PEGHING": "PEGH, (Scots) to pant, also PECH [v]\n",
  "PEGHS": "PEGH, (Scots) to pant, also PECH [v]\n",
  "PEGLEGGED": "having a wooden leg [adj]\n",
  "PEGLESS": "lacking a peg [adj]\n",
  "PEGLIKE": "like a peg [adj]\n",
  "PEGMATITE": "a coarsely crystallized rock commonly occurring in igneous intrusions, esp. dykes, and consisting mainly of feldspar and quartz [n -S]\n",
  "PEGMATITES": "PEGMATITE, a coarsely crystallized rock commonly occurring in igneous intrusions, esp. dykes, and consisting mainly of feldspar and quartz [n]\n",
  "PEGMATITIC": "having the texture of a pegmatite [adj]\n",
  "PEGS": "PEG, to fasten with a wooden pin [v]\n",
  "PEGTOP": "a spinning top having a peg wound with string [n -S]\n",
  "PEGTOPS": "PEGTOP, a spinning top having a peg wound with string [n]\n",
  "PEH": "a Hebrew letter, also FE, FEH, PE [n -S]\n",
  "PEHS": "PEH, a Hebrew letter, also FE, FEH, PE [n]\n",
  "PEIGNOIR": "(French) a woman's dressing-gown [n -S]\n",
  "PEIGNOIRS": "PEIGNOIR, (French) a woman's dressing-gown [n]\n",
  "PEIN": "to beat with a rounded hammer head, also PEEN, PEAN, PENE [v -ED, -ING, -S]\n",
  "PEINCT": "(obsolete) to paint [v -ED, -ING, -S]\n",
  "PEINCTED": "PEINCT, (obsolete) to paint [v]\n",
  "PEINCTING": "PEINCT, (obsolete) to paint [v]\n",
  "PEINCTS": "PEINCT, (obsolete) to paint [v]\n",
  "PEINED": "PEIN, to beat with a rounded hammer head, also PEEN, PEAN, PENE [v]\n",
  "PEINING": "PEIN, to beat with a rounded hammer head, also PEEN, PEAN, PENE [v]\n",
  "PEINS": "PEIN, to beat with a rounded hammer head, also PEEN, PEAN, PENE [v]\n",
  "PEIRASTIC": "experimental; tentative [adj PEIRASTICALLY]\n",
  "PEIRASTICALLY": "PEIRASTIC, experimental; tentative [adv]\n",
  "PEISE": "to weigh, also PEASE, PEAZE, PEIZE, PEYSE, POYSE [v PEISED, PEISING, PEISES]\n",
  "PEISED": "PEISE, to weigh, also PEASE, PEAZE, PEIZE, PEYSE, POYSE [v]\n",
  "PEISES": "PEISE, to weigh, also PEASE, PEAZE, PEIZE, PEYSE, POYSE [v]\n",
  "PEISHWA": "(Persian) a chief minister of the Mahrattas, also PEISHWAH, PESHWA [n -S]\n",
  "PEISHWAH": "a chief minister of the Mahrattas, also PEISHWA, PESHWA [n -S]\n",
  "PEISHWAHS": "PEISHWAH, a chief minister of the Mahrattas, also PEISHWA, PESHWA [n]\n",
  "PEISHWAS": "PEISHWA, (Persian) a chief minister of the Mahrattas, also PEISHWAH, PESHWA [n]\n",
  "PEISING": "PEISE, to weigh, also PEASE, PEAZE, PEIZE, PEYSE, POYSE [v]\n",
  "PEIZE": "to weigh, also PEISE, PEASE, PEAZE, PEYSE, POYSE [v PEIZED, PEIZING, PEIZES]\n",
  "PEIZED": "PEIZE, to weigh, also PEISE, PEASE, PEAZE, PEYSE, POYSE [v]\n",
  "PEIZES": "PEIZE, to weigh, also PEISE, PEASE, PEAZE, PEYSE, POYSE [v]\n",
  "PEIZING": "PEIZE, to weigh, also PEISE, PEASE, PEAZE, PEYSE, POYSE [v]\n",
  "PEJORATE": "to make worse [v PEJORATED, PEJORATING, PEJORATES]\n",
  "PEJORATED": "PEJORATE, to make worse [v]\n",
  "PEJORATES": "PEJORATE, to make worse [v]\n",
  "PEJORATING": "PEJORATE, to make worse [v]\n",
  "PEJORATION": "the degeneration of a word or term e.g. \"hector\" has degenerated from \"hero\" to bully [n -S]\n",
  "PEJORATIONS": "PEJORATION, the degeneration of a word or term e.g. \"hector\" has degenerated from \"hero\" to bully [n]\n",
  "PEJORATIVE": "implying or imputing evil [adj PEJORATIVELY] / an expression implying or imputing evil [n -S]\n",
  "PEJORATIVELY": "PEJORATIVE, implying or imputing evil [adv]\n",
  "PEJORATIVES": "PEJORATIVE, an expression implying or imputing evil [n]\n",
  "PEKAN": "a large North American arboreal carnivore of the weasel family; aka fisher [n -S]\n",
  "PEKANS": "PEKAN, a large North American arboreal carnivore of the weasel family; aka fisher [n]\n",
  "PEKE": "a small, longhaired dog [n -S]\n",
  "PEKEPOO": "a dog that is a cross between a Pekingese and a poodle, also PEEKAPOO [n -S]\n",
  "PEKEPOOS": "PEKEPOO, a dog that is a cross between a Pekingese and a poodle, also PEEKAPOO [n]\n",
  "PEKES": "PEKE, a small, longhaired dog [n]\n",
  "PEKIN": "(Chinese) a fine soft silk fabric [n -S]\n",
  "PEKINS": "PEKIN, (Chinese) a fine soft silk fabric [n]\n",
  "PEKOE": "(Chinese) a kind of scented black tea [n -S]\n",
  "PEKOES": "PEKOE, (Chinese) a kind of scented black tea [n]\n",
  "PEL": "an earlier, now less common, word for a pixel [n -S]\n",
  "PELA": "(Chinese) a type of white wax from a scale insect [n -S]\n",
  "PELAGE": "(French) the coat or covering of a mammal [n -S]\n",
  "PELAGES": "PELAGE, (French) the coat or covering of a mammal [n]\n",
  "PELAGIAL": "of or pertaining to the sea, also PELAGIAN [adj] / an open body of water such as a lake or the sea, as opposed to the shore or the bed [n -S]\n",
  "PELAGIALS": "PELAGIAL, an open body of water such as a lake or the sea, as opposed to the shore or the bed [n]\n",
  "PELAGIAN": "of or pertaining to the sea [adj] / an inhabitant of the open sea, also PELAGIAL [n -S]\n",
  "PELAGIANS": "PELAGIAN, an inhabitant of the open sea, also PELAGIAL [n]\n",
  "PELAGIC": "living in the open sea [adj] / a creature living in the open sea [n -S]\n",
  "PELAGICS": "PELAGIC, a creature living in the open sea [n]\n",
  "PELARGONIC": "as in pelargonic acid, an oily fatty acid, obtained esp. from the leaves of plants of the Pelargonium genus (also called nonanoic acid) [adj]\n",
  "PELARGONIUM": "a kind of geranium [n -S]\n",
  "PELARGONIUMS": "PELARGONIUM, a kind of geranium [n]\n",
  "PELAS": "PELA, (Chinese) a type of white wax from a scale insect [n]\n",
  "PELAU": "a dish made with meat, rice, and pigeon peas, also PILAF, PILAFF, PILAO, PILAU, PILAW, PILLAU, PILOW, PULAO [n -S]\n",
  "PELAUS": "PELAU, a dish made with meat, rice, and pigeon peas, also PILAF, PILAFF, PILAO, PILAU, PILAW, PILLAU, PILOW, PULAO [n]\n",
  "PELE": "(historical) a palisaded enclosure [n -S]\n",
  "PELECYPOD": "designating or pertaining to a bivalve mollusc [adj] / a pelecypod mollusc, a bivalve [n -S]\n",
  "PELECYPODS": "PELECYPOD, a pelecypod mollusc, a bivalve [n]\n",
  "PELERINE": "(French) a woman's cape, usually short, with points in front [n -S]\n",
  "PELERINES": "PELERINE, (French) a woman's cape, usually short, with points in front [n]\n",
  "PELES": "PELE, (historical) a palisaded enclosure [n]\n",
  "PELF": "wealth or riches, esp. when dishonestly acquired [n -S]\n",
  "PELFS": "PELF, wealth or riches, esp. when dishonestly acquired [n]\n",
  "PELHAM": "a type of horse's bit [n -S]\n",
  "PELHAMS": "PELHAM, a type of horse's bit [n]\n",
  "PELICAN": "a large, webfooted bird [n -S]\n",
  "PELICANS": "PELICAN, a large, webfooted bird [n]\n",
  "PELISSE": "(French) a fur-lined or fur garment, esp. a military cloak [n -S]\n",
  "PELISSES": "PELISSE, (French) a fur-lined or fur garment, esp. a military cloak [n]\n",
  "PELITE": "any rock derived from clay or mud [n -S]\n",
  "PELITES": "PELITE, any rock derived from clay or mud [n]\n",
  "PELITIC": "relating to pelite, any rock derived from clay or mud [adj]\n",
  "PELL": "to strike or thump violently [v -ED, -ING, -S]\n",
  "PELLACH": "(Scots) a porpoise, also PELLOCK, PELLACK [n -S]\n",
  "PELLACHS": "PELLACH, (Scots) a porpoise, also PELLOCK, PELLACK [n]\n",
  "PELLACK": "(Scots) a porpoise, also PELLOCK, PELLACH [n -S]\n",
  "PELLACKS": "PELLACK, (Scots) a porpoise, also PELLOCK, PELLACH [n]\n",
  "PELLAGRA": "a niacin-deficiency disease [n -S]\n",
  "PELLAGRAS": "PELLAGRA, a niacin-deficiency disease [n]\n",
  "PELLAGRIN": "one who is afflicted with pellagra, a nervous and digestive disease due to deficiency of nicotinic acid in the diet [n -S]\n",
  "PELLAGRINS": "PELLAGRIN, one who is afflicted with pellagra, a nervous and digestive disease due to deficiency of nicotinic acid in the diet [n]\n",
  "PELLAGROUS": "like or afflicted with pellagra [adj]\n",
  "PELLED": "PELL, to strike or thump violently [v]\n",
  "PELLET": "to hit with small, rounded masses [v -ED, -ING, -S]\n",
  "PELLETAL": "resembling a pellet [adj]\n",
  "PELLETED": "PELLET, to hit with small, rounded masses [v]\n",
  "PELLETIFIED": "PELLETIFY, to make into a pellet [v]\n",
  "PELLETIFIES": "PELLETIFY, to make into a pellet [v]\n",
  "PELLETIFY": "to make into a pellet [v PELLETIFIED, PELLETIFYING, PELLETIFIES]\n",
  "PELLETIFYING": "PELLETIFY, to make into a pellet [v]\n",
  "PELLETING": "PELLET, to hit with small, rounded masses [v]\n",
  "PELLETISATION": "the act of pelletising, also PELLETIZATION [n -S]\n",
  "PELLETISATIONS": "PELLETISATION, the act of pelletising, also PELLETIZATION [n]\n",
  "PELLETISE": "to make into a pellet, also PELLETIZE [v PELLETISED, PELLETISING, PELLETISES]\n",
  "PELLETISED": "PELLETISE, to make into a pellet, also PELLETIZE [v]\n",
  "PELLETISER": "a device for making pellets, also PELLETIZER [n -S]\n",
  "PELLETISERS": "PELLETISER, a device for making pellets, also PELLETIZER [n]\n",
  "PELLETISES": "PELLETISE, to make into a pellet, also PELLETIZE [v]\n",
  "PELLETISING": "PELLETISE, to make into a pellet, also PELLETIZE [v]\n",
  "PELLETIZATION": "the act of pelletizing, also PELLETISATION [n -S]\n",
  "PELLETIZATIONS": "PELLETIZATION, the act of pelletizing, also PELLETISATION [n]\n",
  "PELLETIZE": "to make into a pellet, also PELLETISE [v PELLETIZED, PELLETIZING, PELLETIZES]\n",
  "PELLETIZED": "PELLETIZE, to make into a pellet, also PELLETISE [v]\n",
  "PELLETIZER": "a device for making pellets, also PELLETISER [n -S]\n",
  "PELLETIZERS": "PELLETIZER, a device for making pellets, also PELLETISER [n]\n",
  "PELLETIZES": "PELLETIZE, to make into a pellet, also PELLETISE [v]\n",
  "PELLETIZING": "PELLETIZE, to make into a pellet, also PELLETISE [v]\n",
  "PELLETS": "PELLET, to hit with small, rounded masses [v]\n",
  "PELLICLE": "a thin skin or film [n -S]\n",
  "PELLICLES": "PELLICLE, a thin skin or film [n]\n",
  "PELLICULAR": "of or pertaining to a pellicle [adj]\n",
  "PELLING": "PELL, to strike or thump violently [v]\n",
  "PELLITORIES": "PELLITORY, a low, harmless weed of the nettle family [n]\n",
  "PELLITORY": "a low, harmless weed of the nettle family [n PELLITORIES]\n",
  "PELLMELL": "a jumbled mass [n -S]\n",
  "PELLMELLS": "PELLMELL, a jumbled mass [n]\n",
  "PELLOCK": "(Scots) a porpoise, also PELLACH, PELLACK [n -S]\n",
  "PELLOCKS": "PELLOCK, (Scots) a porpoise, also PELLACH, PELLACK [n]\n",
  "PELLS": "PELL, to strike or thump violently [v]\n",
  "PELLUCID": "transparent [adj PELLUCIDLY]\n",
  "PELLUCIDITIES": "PELLUCIDITY, the state of being pellucid [n]\n",
  "PELLUCIDITY": "the state of being pellucid [n PELLUCIDITIES]\n",
  "PELLUCIDLY": "PELLUCID, transparent [adv]\n",
  "PELLUCIDNESS": "the state of being pellucid [n -ES]\n",
  "PELLUCIDNESSES": "PELLUCIDNESS, the state of being pellucid [n]\n",
  "PELLUM": "(dialect) dust [n -S]\n",
  "PELLUMS": "PELLUM, (dialect) dust [n]\n",
  "PELMA": "(Greek) the sole of the foot [n -S]\n",
  "PELMANISM": "a card game in which the cards are spread out face down and have to be picked up in matching pairs [n -S]\n",
  "PELMANISMS": "PELMANISM, a card game in which the cards are spread out face down and have to be picked up in matching pairs [n]\n",
  "PELMAS": "PELMA, (Greek) the sole of the foot [n]\n",
  "PELMATIC": "pertaining to the sole of the foot [adj]\n",
  "PELMET": "a fringe or valance for hiding a curtain rod [n -S]\n",
  "PELMETS": "PELMET, a fringe or valance for hiding a curtain rod [n]\n",
  "PELOID": "a mud or other natural medium used as a medicinal plaster [n -S]\n",
  "PELOIDS": "PELOID, a mud or other natural medium used as a medicinal plaster [n]\n",
  "PELOLOGIES": "PELOLOGY, study of mud and its curative effects [n]\n",
  "PELOLOGY": "study of mud and its curative effects [n PELOLOGIES]\n",
  "PELON": "a hairless person or animal [n -S]\n",
  "PELONS": "PELON, a hairless person or animal [n]\n",
  "PELORIA": "(Greek) abnormal symmetry of structure in flowers normally zygomorphic (e.g. toadflax), also PELORISM, PELORY [n -S]\n",
  "PELORIAN": "showing peloria, an abnormal regularity in flowers, also PELORIC [adj]\n",
  "PELORIAS": "PELORIA, (Greek) abnormal symmetry of structure in flowers normally zygomorphic (e.g. toadflax), also PELORISM, PELORY [n]\n",
  "PELORIC": "showing peloria, an abnormal regularity in flowers, also PELORIAN [adj]\n",
  "PELORIES": "PELORY, abnormal symmetry of structure in flowers normally zygomorphic (e.g. toadflax), also PELORIA, PELORISM [n]\n",
  "PELORISED": "affected with peloria, also PELORIZED [adj]\n",
  "PELORISM": "abnormal symmetry of structure in flowers normally zygomorphic (e.g. toadflax), also PELORIA, PELORY [n -S]\n",
  "PELORISMS": "PELORISM, abnormal symmetry of structure in flowers normally zygomorphic (e.g. toadflax), also PELORIA, PELORY [n]\n",
  "PELORIZED": "affected with peloria, also PELORISED [adj]\n",
  "PELORUS": "(Latin) a kind of compass from which bearings can be taken [n -ES]\n",
  "PELORUSES": "PELORUS, (Latin) a kind of compass from which bearings can be taken [n]\n",
  "PELORY": "abnormal symmetry of structure in flowers normally zygomorphic (e.g. toadflax), also PELORIA, PELORISM [n PELORIES]\n",
  "PELOTA": "(Spanish) a Basque game played with rackets [n -S]\n",
  "PELOTAS": "PELOTA, (Spanish) a Basque game played with rackets [n]\n",
  "PELOTHERAPIES": "PELOTHERAPY, medical treatment by mud baths [n]\n",
  "PELOTHERAPY": "medical treatment by mud baths [n PELOTHERAPIES]\n",
  "PELOTON": "the main body of riders in a bicycle race [n -S]\n",
  "PELOTONS": "PELOTON, the main body of riders in a bicycle race [n]\n",
  "PELS": "PEL, an earlier, now less common, word for a pixel [n]\n",
  "PELT": "to shower blows or missiles, also PELTER [v -ED, -ING, -S]\n",
  "PELTA": "(Latin) an ancient small shield [n PELTAS or PELTAE]\n",
  "PELTAE": "PELTA, (Latin) an ancient small shield [n]\n",
  "PELTAS": "PELTA, (Latin) an ancient small shield [n]\n",
  "PELTAST": "(Greek) an ancient Greek soldier armed with a pelta [n -S]\n",
  "PELTASTS": "PELTAST, (Greek) an ancient Greek soldier armed with a pelta [n]\n",
  "PELTATE": "having the stalk attached to the edge but near the middle of the undersurface [adj PELTATELY]\n",
  "PELTATELY": "PELTATE, having the stalk attached to the edge but near the middle of the undersurface [adv]\n",
  "PELTATION": "the state of being peltate [n -S]\n",
  "PELTATIONS": "PELTATION, the state of being peltate [n]\n",
  "PELTED": "PELT, to shower blows or missiles, also PELTER [v]\n",
  "PELTER": "to shower blows or missiles, also PELT [v -ED, -ING, -S]\n",
  "PELTERED": "PELTER, to shower blows or missiles, also PELT [v]\n",
  "PELTERING": "PELTER, to shower blows or missiles, also PELT [v]\n",
  "PELTERS": "PELTER, to shower blows or missiles, also PELT [v]\n",
  "PELTING": "of rain, very heavy [adj PELTINGLY] / the act of pelting [n -S]\n",
  "PELTINGLY": "(Shakespeare) in a paltry fashion [adv]\n",
  "PELTINGS": "PELTING, the act of pelting [n]\n",
  "PELTLESS": "lacking a pelt [adj]\n",
  "PELTMONGER": "a dealer in skins [n -S]\n",
  "PELTMONGERS": "PELTMONGER, a dealer in skins [n]\n",
  "PELTRIES": "PELTRY, the skins of animals with the fur on them [n]\n",
  "PELTRY": "the skins of animals with the fur on them [n PELTRIES]\n",
  "PELTS": "PELT, to shower blows or missiles, also PELTER [v]\n",
  "PELVES": "PELVIS, (Latin) a part of the skeleton [n]\n",
  "PELVIC": "a bone of the pelvis [n -S]\n",
  "PELVICS": "PELVIC, a bone of the pelvis [n]\n",
  "PELVIFORM": "basin-shaped [adj]\n",
  "PELVIMETER": "an instrument for measuring the pelvis [n -S]\n",
  "PELVIMETERS": "PELVIMETER, an instrument for measuring the pelvis [n]\n",
  "PELVIMETRIES": "PELVIMETRY, measurement of the pelvis [n]\n",
  "PELVIMETRY": "measurement of the pelvis [n PELVIMETRIES]\n",
  "PELVIS": "(Latin) a part of the skeleton [n PELVISES or PELVES]\n",
  "PELVISES": "PELVIS, (Latin) a part of the skeleton [n]\n",
  "PELYCOSAUR": "a kind of dinosaur [n -S]\n",
  "PELYCOSAURS": "PELYCOSAUR, a kind of dinosaur [n]\n",
  "PEMBINA": "(Native American) a variety of cranberry [n -S]\n",
  "PEMBINAS": "PEMBINA, (Native American) a variety of cranberry [n]\n",
  "PEMBROKE": "a small four-legged table with hinged flaps [n -S]\n",
  "PEMBROKES": "PEMBROKE, a small four-legged table with hinged flaps [n]\n",
  "PEMICAN": "(Native American) a food prepared by North American Indians, also PEMMICAN [n -S]\n",
  "PEMICANS": "PEMICAN, (Native American) a food prepared by North American Indians, also PEMMICAN [n]\n",
  "PEMMICAN": "(Native American) a food prepared by North American Indians, also PEMICAN [n -S]\n",
  "PEMMICANS": "PEMMICAN, (Native American) a food prepared by North American Indians, also PEMICAN [n]\n",
  "PEMOLINE": "a white crystalline powder used to stimulate the central nervous system [n -S]\n",
  "PEMOLINES": "PEMOLINE, a white crystalline powder used to stimulate the central nervous system [n]\n",
  "PEMPHIGI": "PEMPHIGUS, (Greek) a somewhat rare skin disease, characterized by the development of blebs upon different parts of the body, also PEMPHIX [n]\n",
  "PEMPHIGOID": "relating to pemphigus, a skin disease, characterized by the development of blebs upon different part of the body, also PEMPHIGOUS [adj] / any of a group of skin diseases, also PEMPHIGOUS [n -S]\n",
  "PEMPHIGOIDS": "PEMPHIGOID, any of a group of skin diseases, also PEMPHIGOUS [n]\n",
  "PEMPHIGOUS": "relating to pemphigus, a skin disease, characterized by the development of blebs upon different part of the body, also PEMPHIGOID [adj]\n",
  "PEMPHIGUS": "(Greek) a somewhat rare skin disease, characterized by the development of blebs upon different parts of the body, also PEMPHIX [n PEMPHIGI or PEMPHIGUSES]\n",
  "PEMPHIGUSES": "PEMPHIGUS, (Greek) a somewhat rare skin disease, characterized by the development of blebs upon different parts of the body, also PEMPHIX [n]\n",
  "PEMPHIX": "(Greek) a somewhat rare skin disease, characterized by the development of blebs upon different part of the body, also PEMPHIGUS [n -ES]\n",
  "PEMPHIXES": "PEMPHIX, (Greek) a somewhat rare skin disease, characterized by the development of blebs upon different part of the body, also PEMPHIGUS [n]\n",
  "PEN": "to write, or commit to paper [v PENNED, PENNING, PENS]\n",
  "PENAL": "pertaining to punishment [adj PENALLY]\n",
  "PENALISATION": "the act of penalising, also PENALIZATION [n -S]\n",
  "PENALISATIONS": "PENALISATION, the act of penalising, also PENALIZATION [n]\n",
  "PENALISE": "to subject to penalty, also PENALIZE [v PENALISED, PENALISING, PENALISES]\n",
  "PENALISED": "PENALISE, to subject to penalty, also PENALIZE [v]\n",
  "PENALISES": "PENALISE, to subject to penalty, also PENALIZE [v]\n",
  "PENALISING": "PENALISE, to subject to penalty, also PENALIZE [v]\n",
  "PENALITIES": "PENALITY, liability to punishment [n]\n",
  "PENALITY": "liability to punishment [n PENALITIES]\n",
  "PENALIZATION": "the act of penalizing, also PENALISATION [n -S]\n",
  "PENALIZATIONS": "PENALIZATION, the act of penalizing, also PENALISATION [n]\n",
  "PENALIZE": "to subject to penalty, also PENALISE [v PENALIZED, PENALIZING, PENALIZES]\n",
  "PENALIZED": "PENALIZE, to subject to penalty, also PENALISE [v]\n",
  "PENALIZES": "PENALIZE, to subject to penalty, also PENALISE [v]\n",
  "PENALIZING": "PENALIZE, to subject to penalty, also PENALISE [v]\n",
  "PENALLY": "PENAL, pertaining to punishment [adv]\n",
  "PENALTIES": "PENALTY, punishment imposed for breach of a law, rule or agreement [n]\n",
  "PENALTY": "punishment imposed for breach of a law, rule or agreement [n PENALTIES]\n",
  "PENANCE": "to impose a type of punishment upon [v PENANCED, PENANCING, PENANCES]\n",
  "PENANCED": "PENANCE, to impose a type of punishment upon [v]\n",
  "PENANCES": "PENANCE, to impose a type of punishment upon [v]\n",
  "PENANCING": "PENANCE, to impose a type of punishment upon [v]\n",
  "PENANG": "(Malay) a cotton fabric [n -S]\n",
  "PENANGS": "PENANG, (Malay) a cotton fabric [n]\n",
  "PENANNULAR": "in the form of an almost complete ring [adj]\n",
  "PENATES": "(Latin) the Roman gods of the household [n]\n",
  "PENCE": "in the United Kingdom, a new penny [n -S]\n",
  "PENCEL": "a small pennon, also PENSEL, PENSIL [n -S]\n",
  "PENCELS": "PENCEL, a small pennon, also PENSEL, PENSIL [n]\n",
  "PENCES": "PENCE, in the United Kingdom, a new penny [n]\n",
  "PENCHANT": "(French) a strong liking for something [n -S]\n",
  "PENCHANTS": "PENCHANT, (French) a strong liking for something [n]\n",
  "PENCIL": "to write or draw with graphite or lead [v PENCILED or PENCILLED, PENCILING or PENCILLING, PENCILS]\n",
  "PENCILED": "PENCIL, to write or draw with graphite or lead [v]\n",
  "PENCILER": "one who pencils, also PENCILLER [n -S]\n",
  "PENCILERS": "PENCILER, one who pencils, also PENCILLER [n]\n",
  "PENCILING": "the art or act of painting, writing, sketching, or marking with a pencil, also PENCILLING [n -S]\n",
  "PENCILINGS": "PENCILING, the art or act of painting, writing, sketching, or marking with a pencil, also PENCILLING [n]\n",
  "PENCILLED": "PENCIL, to write or draw with graphite or lead [v]\n",
  "PENCILLER": "one who pencils, also PENCILER [n -S]\n",
  "PENCILLERS": "PENCILLER, one who pencils, also PENCILER [n]\n",
  "PENCILLING": "the art or act of painting, writing, sketching, or marking with a pencil, also PENCILING [n -S]\n",
  "PENCILLINGS": "PENCILLING, the art or act of painting, writing, sketching, or marking with a pencil, also PENCILING [n]\n",
  "PENCILS": "PENCIL, to write or draw with graphite or lead [v]\n",
  "PENCRAFT": "penmanship [n -S]\n",
  "PENCRAFTS": "PENCRAFT, penmanship [n]\n",
  "PEND": "to remain unsettled or undecided [v -ED, -ING, -S]\n",
  "PENDANT": "hanging, also PENDENT [adj PENDANTLY] / anything hanging, esp. for ornament [n -S]\n",
  "PENDANTLY": "PENDANT, hanging, also PENDENT [adv]\n",
  "PENDANTS": "PENDANT, anything hanging, esp. for ornament [n]\n",
  "PENDED": "PEND, to remain unsettled or undecided [v]\n",
  "PENDENCIES": "PENDENCY, a pending state [n]\n",
  "PENDENCY": "a pending state [n PENDENCIES]\n",
  "PENDENT": "hanging; drooping, also PENDANT [adj PENDENTLY] / anything hanging, esp. for ornament [n -S]\n",
  "PENDENTIVE": "one of four spherical triangles formed by a dome springing from a square base [n -S]\n",
  "PENDENTIVES": "PENDENTIVE, one of four spherical triangles formed by a dome springing from a square base [n]\n",
  "PENDENTLY": "PENDENT, hanging; drooping, also PENDANT [adv]\n",
  "PENDENTS": "PENDENT, anything hanging, esp. for ornament [n]\n",
  "PENDICLE": "(Scots) a piece of land or other property forming a subsidiary part of an estate [n -S]\n",
  "PENDICLER": "the tenant of a pendicle [n -S]\n",
  "PENDICLERS": "PENDICLER, the tenant of a pendicle [n]\n",
  "PENDICLES": "PENDICLE, (Scots) a piece of land or other property forming a subsidiary part of an estate [n]\n",
  "PENDING": "PEND, to remain unsettled or undecided [v]\n",
  "PENDRAGON": "(Welsh) an ancient British or Welsh prince holding or claiming supreme power, a chief leader or ruler [n -S]\n",
  "PENDRAGONS": "PENDRAGON, (Welsh) an ancient British or Welsh prince holding or claiming supreme power, a chief leader or ruler [n]\n",
  "PENDRAGONSHIP": "the office of pendragon [n -S]\n",
  "PENDRAGONSHIPS": "PENDRAGONSHIP, the office of pendragon [n]\n",
  "PENDS": "PEND, to remain unsettled or undecided [v]\n",
  "PENDU": "(Hinglish) culturally backward [adj]\n",
  "PENDULAR": "of or relating to a pendulum [adj]\n",
  "PENDULATE": "to swing as a pendulum [v PENDULATED, PENDULATING, PENDULATES]\n",
  "PENDULATED": "PENDULATE, to swing as a pendulum [v]\n",
  "PENDULATES": "PENDULATE, to swing as a pendulum [v]\n",
  "PENDULATING": "PENDULATE, to swing as a pendulum [v]\n",
  "PENDULE": "a manoeuvre in climbing by which a climber swings from a rope in order to reach another line of ascent [n -S]\n",
  "PENDULES": "PENDULE, a manoeuvre in climbing by which a climber swings from a rope in order to reach another line of ascent [n]\n",
  "PENDULINE": "building a pendulous nest, as in penduline tit [adj]\n",
  "PENDULOSITIES": "PENDULOSITY, the state of being pendulous [n]\n",
  "PENDULOSITY": "the state of being pendulous [n PENDULOSITIES]\n",
  "PENDULOUS": "hanging loosely; swinging freely [adj PENDULOUSLY]\n",
  "PENDULOUSLY": "PENDULOUS, hanging loosely; swinging freely [adv]\n",
  "PENDULOUSNESS": "the state of being pendulous [n -ES]\n",
  "PENDULOUSNESSES": "PENDULOUSNESS, the state of being pendulous [n]\n",
  "PENDULUM": "a type of free swinging body [n -S]\n",
  "PENDULUMS": "PENDULUM, a type of free swinging body [n]\n",
  "PENE": "to beat with a rounded hammer head, also PEEN, PEAN, PEIN [v PENED, PENING, PENES]\n",
  "PENED": "PENE, to beat with a rounded hammer head, also PEEN, PEAN, PEIN [v]\n",
  "PENELOPISE": "to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPIZE [v PENELOPISED, PENELOPISING, PENELOPISES]\n",
  "PENELOPISED": "PENELOPISE, to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPIZE [v]\n",
  "PENELOPISES": "PENELOPISE, to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPIZE [v]\n",
  "PENELOPISING": "PENELOPISE, to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPIZE [v]\n",
  "PENELOPIZE": "to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPISE [v PENELOPIZED, PENELOPIZING, PENELOPIZES]\n",
  "PENELOPIZED": "PENELOPIZE, to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPISE [v]\n",
  "PENELOPIZES": "PENELOPIZE, to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPISE [v]\n",
  "PENELOPIZING": "PENELOPIZE, to undo what you have earlier done, in so delaying a decision due upon completion, also PENELOPISE [v]\n",
  "PENEPLAIN": "a low gently, rolling landscape produced by long-continued erosion, also PENEPLANE [n -S]\n",
  "PENEPLAINS": "PENEPLAIN, a low gently, rolling landscape produced by long-continued erosion, also PENEPLANE [n]\n",
  "PENEPLANATION": "the state of being a peneplain [n -S]\n",
  "PENEPLANATIONS": "PENEPLANATION, the state of being a peneplain [n]\n",
  "PENEPLANE": "a low gently, rolling landscape produced by long-continued erosion, also PENEPLAIN [n -S]\n",
  "PENEPLANES": "PENEPLANE, a low gently, rolling landscape produced by long-continued erosion, also PENEPLAIN [n]\n",
  "PENES": "PENE, to beat with a rounded hammer head, also PEEN, PEAN, PEIN [v]\n",
  "PENETRABILITIES": "PENETRABILITY, the state of being penetrable [n]\n",
  "PENETRABILITY": "the state of being penetrable [n PENETRABILITIES]\n",
  "PENETRABLE": "that can be penetrated [adj PENETRABLY]\n",
  "PENETRABLENESS": "PENETRABLE, that can be penetrated [n]\n",
  "PENETRABLY": "PENETRABLE, that can be penetrated [adv]\n",
  "PENETRALIA": "the innermost or most private parts, esp. of a temple or palace; hidden things or secrets [n]\n",
  "PENETRALIAN": "relating to penetralia, the innermost or most private parts e.g. of a temple [adj]\n",
  "PENETRANCE": "the degree or frequency with which a gene manifests its effect [n -S]\n",
  "PENETRANCES": "PENETRANCE, the degree or frequency with which a gene manifests its effect [n]\n",
  "PENETRANCIES": "PENETRANCY, the state of being penetrant [n]\n",
  "PENETRANCY": "the state of being penetrant [n PENETRANCIES]\n",
  "PENETRANT": "penetrating [adj] / a substance which increases the penetrating power of a liquid [n -S]\n",
  "PENETRANTS": "PENETRANT, a substance which increases the penetrating power of a liquid [n]\n",
  "PENETRATE": "to thrust or force a way into the inside of [v PENETRATED, PENETRATING, PENETRATES]\n",
  "PENETRATED": "PENETRATE, to thrust or force a way into the inside of [v]\n",
  "PENETRATES": "PENETRATE, to thrust or force a way into the inside of [v]\n",
  "PENETRATING": "PENETRATE, to thrust or force a way into the inside of [v]\n",
  "PENETRATINGLY": "PENETRATING, PENETRATE, to thrust or force a way into the inside of [adv]\n",
  "PENETRATION": "the act of penetrating [n -S]\n",
  "PENETRATIONS": "PENETRATION, the act of penetrating [n]\n",
  "PENETRATIVE": "tending to penetrate [adj PENETRATIVELY]\n",
  "PENETRATIVELY": "PENETRATIVE, tending to penetrate [adv]\n",
  "PENETRATIVENESS": "the state of being penetrative [n]\n",
  "PENETRATOR": "something or someone that penetrates [n -S]\n",
  "PENETRATORS": "PENETRATOR, something or someone that penetrates [n]\n",
  "PENETROMETER": "an instrument for measuring the firmness or consistency of substances [n -S]\n",
  "PENETROMETERS": "PENETROMETER, an instrument for measuring the firmness or consistency of substances [n]\n",
  "PENFOLD": "a place in which stray cattle or domestic animals are confined, also PINFOLD [n -S]\n",
  "PENFOLDS": "PENFOLD, a place in which stray cattle or domestic animals are confined, also PINFOLD [n]\n",
  "PENFRIEND": "a friend by correspondence [n -S]\n",
  "PENFRIENDS": "PENFRIEND, a friend by correspondence [n]\n",
  "PENFUL": "the amount of ink a pen can hold [n -S]\n",
  "PENFULS": "PENFUL, the amount of ink a pen can hold [n]\n",
  "PENGO": "(Hungarian) a former monetary unit of Hungary [n -S]\n",
  "PENGOS": "PENGO, (Hungarian) a former monetary unit of Hungary [n]\n",
  "PENGUIN": "a flightless, aquatic bird, also PINGUIN [n -S]\n",
  "PENGUINERIES": "PENGUINERY, a breeding place, or rookery, of penguins, also PENGUINRY [n]\n",
  "PENGUINERY": "a breeding place, or rookery, of penguins, also PENGUINRY [n PENGUINERIES]\n",
  "PENGUINRIES": "PENGUINRY, a breeding place, or rookery, of penguins, also PENGUINERY [n]\n",
  "PENGUINRY": "a breeding place, or rookery, of penguins, also PENGUINERY [n PENGUINRIES]\n",
  "PENGUINS": "PENGUIN, a flightless, aquatic bird, also PINGUIN [n]\n",
  "PENHOLDER": "a holder for pens [n -S]\n",
  "PENHOLDERS": "PENHOLDER, a holder for pens [n]\n",
  "PENI": "(Spenser) a penny, also PENIE [n -S]\n",
  "PENIAL": "relating to the penis, also PENILE [adj]\n",
  "PENICIL": "a tent or pledget for wounds or ulcers, also PENICILLUS [n -S]\n",
  "PENICILLAMINE": "an amino acid obtained from penicillins, used in the treatment of rheumatoid arthritis [n -S]\n",
  "PENICILLAMINES": "PENICILLAMINE, an amino acid obtained from penicillins, used in the treatment of rheumatoid arthritis [n]\n",
  "PENICILLATE": "like a tuft of hairs [adj PENICILLATELY]\n",
  "PENICILLATELY": "PENICILLATE, like a tuft of hairs [adv]\n",
  "PENICILLATION": "the state of being penicillate, like a tuft of hairs [n -S]\n",
  "PENICILLATIONS": "PENICILLATION, the state of being penicillate, like a tuft of hairs [n]\n",
  "PENICILLI": "PENICILLUS, a small pad for wounds, also PENICIL [n]\n",
  "PENICILLIA": "PENICILLIUM, any of a genus of fungus which includes mould on jam, cheese etc. [n]\n",
  "PENICILLIFORM": "paintbrush-shaped [adj]\n",
  "PENICILLIN": "any of a group of substances that stop the growth of bacteria, extracted from moulds, esp. from Penicillium notatum [n -S]\n",
  "PENICILLINASE": "an enzyme, produced by certain bacteria, that inactivates the effect of some penicillins [n -S]\n",
  "PENICILLINASES": "PENICILLINASE, an enzyme, produced by certain bacteria, that inactivates the effect of some penicillins [n]\n",
  "PENICILLINS": "PENICILLIN, any of a group of substances that stop the growth of bacteria, extracted from moulds, esp. from Penicillium notatum [n]\n",
  "PENICILLIUM": "any of a genus of fungus which includes mould on jam, cheese etc. [n PENICILLIA or PENICILLIUMS]\n",
  "PENICILLIUMS": "PENICILLIUM, any of a genus of fungus which includes mould on jam, cheese etc. [n]\n",
  "PENICILLUS": "a small pad for wounds, also PENICIL [n PENICILLI]\n",
  "PENICILS": "PENICIL, a tent or pledget for wounds or ulcers, also PENICILLUS [n]\n",
  "PENIE": "(Spenser) a penny, also PENI [n -S]\n",
  "PENIES": "PENIE, (Spenser) a penny, also PENI [n]\n",
  "PENILE": "relating to the penis, also PENIAL [adj]\n",
  "PENILL": "(Welsh) a verse or stanza in Welsh poetry, also PENNILL [n PENILLION]\n",
  "PENILLION": "PENILL, (Welsh) a verse or stanza in Welsh poetry, also PENNILL [n]\n",
  "PENING": "PENE, to beat with a rounded hammer head, also PEEN, PEAN, PEIN [v]\n",
  "PENINSULA": "a strip of land jutting out into water, a near-island [n -S]\n",
  "PENINSULAR": "relating to a peninsula [adj]\n",
  "PENINSULARITIES": "PENINSULARITY, the state of being peninsular [n]\n",
  "PENINSULARITY": "the state of being peninsular [n PENINSULARITIES]\n",
  "PENINSULAS": "PENINSULA, a strip of land jutting out into water, a near-island [n]\n",
  "PENINSULATE": "to form into a peninsula [v PENINSULATED, PENINSULATING, PENINSULATES]\n",
  "PENINSULATED": "PENINSULATE, to form into a peninsula [v]\n",
  "PENINSULATES": "PENINSULATE, to form into a peninsula [v]\n",
  "PENINSULATING": "PENINSULATE, to form into a peninsula [v]\n",
  "PENIS": "the male organ used for copulation [n PENISES or PENES]\n",
  "PENISES": "PENIS, the male organ used for copulation [n]\n",
  "PENISTONE": "a cloth, a coarse frieze [n -S]\n",
  "PENISTONES": "PENISTONE, a cloth, a coarse frieze [n]\n",
  "PENITENCE": "the state of being penitent, also PENITENCY [n -S]\n",
  "PENITENCES": "PENITENCE, the state of being penitent, also PENITENCY [n]\n",
  "PENITENCIES": "PENITENCY, the state of being penitent, also PENITENCE [n]\n",
  "PENITENCY": "the state of being penitent, also PENITENCE [n PENITENCIES]\n",
  "PENITENT": "repentant [adj PENITENTLY] / a person who repents his sins [n -S]\n",
  "PENITENTIAL": "relating to penitence [adj PENITENTIALLY] / a book of rules relating to penance [n -S]\n",
  "PENITENTIALLY": "PENITENTIAL, relating to penitence [adv]\n",
  "PENITENTIALS": "PENITENTIAL, a book of rules relating to penance [n]\n",
  "PENITENTIARIES": "PENITENTIARY, in North America, a prison [n]\n",
  "PENITENTIARY": "in North America, a prison [n PENITENTIARIES]\n",
  "PENITENTLY": "PENITENT, repentant [adv]\n",
  "PENITENTS": "PENITENT, a person who repents his sins [n]\n",
  "PENK": "(German) a minnow, a small fish [n -S]\n",
  "PENKNIFE": "a small pocketknife [n PENKNIVES]\n",
  "PENKNIVES": "PENKNIFE, a small pocketknife [n]\n",
  "PENKS": "PENK, (German) a minnow, a small fish [n]\n",
  "PENLIGHT": "a small torch, also PENLITE [n -S]\n",
  "PENLIGHTS": "PENLIGHT, a small torch, also PENLITE [n]\n",
  "PENLIKE": "like a pen [adj]\n",
  "PENLITE": "a small torch, also PENLIGHT [n -S]\n",
  "PENLITES": "PENLITE, a small torch, also PENLIGHT [n]\n",
  "PENMAN": "an author [n PENMEN]\n",
  "PENMANSHIP": "the art or practice of writing with the pen [n -S]\n",
  "PENMANSHIPS": "PENMANSHIP, the art or practice of writing with the pen [n]\n",
  "PENMEN": "PENMAN, an author [n]\n",
  "PENNA": "(Latin) any of the feathers that determine a bird's shape [n PENNAE]\n",
  "PENNACEOUS": "feather-like [adj]\n",
  "PENNAE": "PENNA, (Latin) any of the feathers that determine a bird's shape [n]\n",
  "PENNAL": "(German) a freshman at a German university [n -S]\n",
  "PENNALISM": "a system of fagging in use at a German university [n -S]\n",
  "PENNALISMS": "PENNALISM, a system of fagging in use at a German university [n]\n",
  "PENNALS": "PENNAL, (German) a freshman at a German university [n]\n",
  "PENNAME": "a name used by an author instead of his real name [n -S]\n",
  "PENNAMES": "PENNAME, a name used by an author instead of his real name [n]\n",
  "PENNANT": "a long narrow flag; a signalling or identifying flag, also PENNON [n -S]\n",
  "PENNANTS": "PENNANT, a long narrow flag; a signalling or identifying flag, also PENNON [n]\n",
  "PENNATE": "having wings or feathers, also PENNATED [adj]\n",
  "PENNATED": "having wings or feathers, also PENNATE [adj]\n",
  "PENNATULA": "a sea-pen [n PENNATULAE or PENNATULAS]\n",
  "PENNATULACEOUS": "of or like a pennatula, a sea-pen [adj]\n",
  "PENNATULAE": "PENNATULA, a sea-pen [n]\n",
  "PENNATULAS": "PENNATULA, a sea-pen [n]\n",
  "PENNE": "(Spenser) a pen, a pinion [n -S]\n",
  "PENNED": "PEN, to write, or commit to paper [v]\n",
  "PENNEECH": "an old card game, also PENNEECK [n -S]\n",
  "PENNEECHS": "PENNEECH, an old card game, also PENNEECK [n]\n",
  "PENNEECK": "an old card game, also PENNEECH [n -S]\n",
  "PENNEECKS": "PENNEECK, an old card game, also PENNEECH [n]\n",
  "PENNER": "one who pens [n -S]\n",
  "PENNERS": "PENNER, one who pens [n]\n",
  "PENNES": "PENNE, (Spenser) a pen, a pinion [n]\n",
  "PENNI": "(Finnish) a Finnish monetary unit [n PENNIS or PENNIA]\n",
  "PENNIA": "PENNI, (Finnish) a Finnish monetary unit [n]\n",
  "PENNIED": "wealthy to the extent of at least a penny [adj]\n",
  "PENNIES": "PENNY, a coin of the United Kingdom, in pre-decimal coinage, 1/240 of a pound [n]\n",
  "PENNIFORM": "feather-shaped [adj]\n",
  "PENNILESS": "without a penny, destitute [adj PENNILESSLY]\n",
  "PENNILESSLY": "PENNILESS, without a penny, destitute [adv]\n",
  "PENNILESSNESS": "PENNILESS, without a penny, destitute [n]\n",
  "PENNILESSNESSES": "PENNILESSNESS, PENNILESS, without a penny, destitute [n]\n",
  "PENNILL": "(Welsh) a verse or stanza in Welsh poetry, also PENILL [n PENNILLION]\n",
  "PENNILLION": "PENNILL, (Welsh) a verse or stanza in Welsh poetry, also PENILL [n]\n",
  "PENNINE": "a mineral of the chlorite group, also PENNINITE [n -S]\n",
  "PENNINES": "PENNINE, a mineral of the chlorite group, also PENNINITE [n]\n",
  "PENNING": "PEN, to write, or commit to paper [v]\n",
  "PENNINITE": "a mineral of the chlorite group, also PENNINE [n -S]\n",
  "PENNINITES": "PENNINITE, a mineral of the chlorite group, also PENNINE [n]\n",
  "PENNIS": "PENNI, (Finnish) a Finnish monetary unit [n]\n",
  "PENNON": "a long, narrow flag, also PENNANT [n -S]\n",
  "PENNONCEL": "a small flag like a pennon, also PENNONCELLE, PENONCEL, PENONCELLE [n -S]\n",
  "PENNONCELLE": "(French) a small flag like a pennon, also PENNONCEL, PENONCEL, PENONCELLE [n -S]\n",
  "PENNONCELLES": "PENNONCELLE, (French) a small flag like a pennon, also PENNONCEL, PENONCEL, PENONCELLE [n]\n",
  "PENNONCELS": "PENNONCEL, a small flag like a pennon, also PENNONCELLE, PENONCEL, PENONCELLE [n]\n",
  "PENNONED": "flying a pennon [adj]\n",
  "PENNONS": "PENNON, a long, narrow flag, also PENNANT [n]\n",
  "PENNY": "a coin of the United Kingdom, in pre-decimal coinage, 1/240 of a pound [n PENNIES or PENCE]\n",
  "PENNYBOY": "an employee whose duties include menial tasks such as running errands [n -S]\n",
  "PENNYBOYS": "PENNYBOY, an employee whose duties include menial tasks such as running errands [n]\n",
  "PENNYCRESS": "a cruciferous plant with round leaves [n -ES]\n",
  "PENNYCRESSES": "PENNYCRESS, a cruciferous plant with round leaves [n]\n",
  "PENNYFEE": "(Scots) a small wage [n -S]\n",
  "PENNYFEES": "PENNYFEE, (Scots) a small wage [n]\n",
  "PENNYLAND": "(historical) land valued at a penny a year [n -S]\n",
  "PENNYLANDS": "PENNYLAND, (historical) land valued at a penny a year [n]\n",
  "PENNYROYAL": "an aromatic herb of Europe; also, a North American plant resembling it in flavour [n -S]\n",
  "PENNYROYALS": "PENNYROYAL, an aromatic herb of Europe; also, a North American plant resembling it in flavour [n]\n",
  "PENNYWEIGHT": "an old unit of weight, the twentieth part of an ounce [n -S]\n",
  "PENNYWEIGHTS": "PENNYWEIGHT, an old unit of weight, the twentieth part of an ounce [n]\n",
  "PENNYWHISTLE": "a cheap toy whistle originally sold for a penny [n -S]\n",
  "PENNYWHISTLES": "PENNYWHISTLE, a cheap toy whistle originally sold for a penny [n]\n",
  "PENNYWINKLE": "a kind of marine snail, also PERIWINKLE [n -S]\n",
  "PENNYWINKLES": "PENNYWINKLE, a kind of marine snail, also PERIWINKLE [n]\n",
  "PENNYWISE": "careful with small amounts of money [adj]\n",
  "PENNYWORT": "a perennial succulent herb, having round, peltate leaves with a central depression, aka navelwort [n -S]\n",
  "PENNYWORTH": "a penny's worth [n -S]\n",
  "PENNYWORTHS": "PENNYWORTH, a penny's worth [n]\n",
  "PENNYWORTS": "PENNYWORT, a perennial succulent herb, having round, peltate leaves with a central depression, aka navelwort [n]\n",
  "PENOCHE": "(Spanish) a type of fudge, also PANOCHA, PANOCHE, PENUCHE, PENUCHI [n -S]\n",
  "PENOCHES": "PENOCHE, (Spanish) a type of fudge, also PANOCHA, PANOCHE, PENUCHE, PENUCHI [n]\n",
  "PENOLOGICAL": "relating to penology, the study of crime and punishment [adj PENOLOGICALLY]\n",
  "PENOLOGICALLY": "PENOLOGICAL, relating to penology, the study of crime and punishment [adv]\n",
  "PENOLOGIES": "PENOLOGY, the science of the punishment of crime [n]\n",
  "PENOLOGIST": "one versed in, or a student of, penology [n -S]\n",
  "PENOLOGISTS": "PENOLOGIST, one versed in, or a student of, penology [n]\n",
  "PENOLOGY": "the science of the punishment of crime [n PENOLOGIES]\n",
  "PENONCEL": "a small flag like a pennon, also PENNONCEL, PENNONCELLE, PENONCELLE [n -S]\n",
  "PENONCELLE": "(French) a small flag like a pennon, also PENNONCEL, PENNONCELLE, PENONCEL [n -S]\n",
  "PENONCELLES": "PENONCELLE, (French) a small flag like a pennon, also PENNONCEL, PENNONCELLE, PENONCEL [n]\n",
  "PENONCELS": "PENONCEL, a small flag like a pennon, also PENNONCEL, PENNONCELLE, PENONCELLE [n]\n",
  "PENPOINT": "the point of a pen [n -S]\n",
  "PENPOINTS": "PENPOINT, the point of a pen [n]\n",
  "PENPUSHER": "a person whose work involves a lot of boring paperwork [n -S]\n",
  "PENPUSHERS": "PENPUSHER, a person whose work involves a lot of boring paperwork [n]\n",
  "PENPUSHING": "boring paperwork involving much writing [n -S]\n",
  "PENPUSHINGS": "PENPUSHING, boring paperwork involving much writing [n]\n",
  "PENS": "PEN, to write, or commit to paper [v]\n",
  "PENSEE": "(French) a thought [n -S]\n",
  "PENSEES": "PENSEE, (French) a thought [n]\n",
  "PENSEL": "a small pennon, also PENCEL, PENSIL [n -S]\n",
  "PENSELS": "PENSEL, a small pennon, also PENCEL, PENSIL [n]\n",
  "PENSEROSO": "(Italian) brooding, thoughtful, also PENSIEROSO [adj] / a pensive, brooding, or thoughtful person [n -S]\n",
  "PENSEROSOS": "PENSEROSO, a pensive, brooding, or thoughtful person [n]\n",
  "PENSIEROSO": "(Italian) melancholy, thoughtful, also PENSEROSO [adj]\n",
  "PENSIL": "a small pennon, also PENCEL, PENSEL [n -S]\n",
  "PENSILE": "hanging loosely [adj]\n",
  "PENSILENESS": "the state of being pensile [n -ES]\n",
  "PENSILENESSES": "PENSILENESS, the state of being pensile [n]\n",
  "PENSILITIES": "PENSILITY, being pensile, hanging; suspended [n]\n",
  "PENSILITY": "being pensile, hanging; suspended [n PENSILITIES]\n",
  "PENSILS": "PENSIL, a small pennon, also PENCEL, PENSEL [n]\n",
  "PENSION": "to grant a retirement allowance to [v -ED, -ING, -S]\n",
  "PENSIONABLE": "of, relating to, qualified for, or qualifying for a pension [adj]\n",
  "PENSIONARIES": "PENSIONARY, someone maintained by a pension [n]\n",
  "PENSIONARY": "receiving a pension [adj] / someone maintained by a pension [n PENSIONARIES]\n",
  "PENSIONE": "(Italian) a boardinghouse [n PENSIONI or PENSIONES]\n",
  "PENSIONED": "PENSION, to grant a retirement allowance to [v]\n",
  "PENSIONEER": "as in pensioneer trustee [adj]\n",
  "PENSIONER": "one receiving a pension [n -S]\n",
  "PENSIONERS": "PENSIONER, one receiving a pension [n]\n",
  "PENSIONES": "PENSIONE, (Italian) a boardinghouse [n]\n",
  "PENSIONI": "PENSIONE, (Italian) a boardinghouse [n]\n",
  "PENSIONING": "PENSION, to grant a retirement allowance to [v]\n",
  "PENSIONLESS": "without a pension [adj]\n",
  "PENSIONNAT": "(French) a boarding-school [n -S]\n",
  "PENSIONNATS": "PENSIONNAT, (French) a boarding-school [n]\n",
  "PENSIONS": "PENSION, to grant a retirement allowance to [v]\n",
  "PENSIVE": "engaged in deep thought [adj PENSIVELY]\n",
  "PENSIVELY": "PENSIVE, engaged in deep thought [adv]\n",
  "PENSIVENESS": "the state of being pensive [n -ES]\n",
  "PENSIVENESSES": "PENSIVENESS, the state of being pensive [n]\n",
  "PENSTEMON": "a genus of showy flowers, also PENTSTEMON [n -S]\n",
  "PENSTEMONS": "PENSTEMON, a genus of showy flowers, also PENTSTEMON [n]\n",
  "PENSTER": "a writer [n -S]\n",
  "PENSTERS": "PENSTER, a writer [n]\n",
  "PENSTOCK": "a valve-controlled water conduit [n -S]\n",
  "PENSTOCKS": "PENSTOCK, a valve-controlled water conduit [n]\n",
  "PENSUM": "(Latin) a task; a school imposition [n -S]\n",
  "PENSUMS": "PENSUM, (Latin) a task; a school imposition [n]\n",
  "PENT": "a penthouse [n -S]\n",
  "PENTABARBITAL": "a barbiturate drug with hypnotic, sedative, and anticonvulsant effects, also PENTOBARBITAL [n -S]\n",
  "PENTABARBITALS": "PENTABARBITAL, a barbiturate drug with hypnotic, sedative, and anticonvulsant effects, also PENTOBARBITAL [n]\n",
  "PENTACHORD": "an ancient musical instrument with five strings [n -S]\n",
  "PENTACHORDS": "PENTACHORD, an ancient musical instrument with five strings [n]\n",
  "PENTACLE": "a five-pointed star, esp. as a magical symbol [n -S]\n",
  "PENTACLES": "PENTACLE, a five-pointed star, esp. as a magical symbol [n]\n",
  "PENTACRINOID": "a young form of some crinoids that resembles Pentacrinus [n -S]\n",
  "PENTACRINOIDS": "PENTACRINOID, a young form of some crinoids that resembles Pentacrinus [n]\n",
  "PENTACT": "a five-rayed structure in a sponge [n -S]\n",
  "PENTACTINAL": "relating to a pentact [adj]\n",
  "PENTACTS": "PENTACT, a five-rayed structure in a sponge [n]\n",
  "PENTACYCLIC": "having five whorls [adj]\n",
  "PENTAD": "a group of five [n -S]\n",
  "PENTADACTYL": "having five fingers or toes to each hand or foot, also PENTADACTYLIC, PENTADACTYLOUS [adj] / a pentadactyl animal, also PENTADACTYLE [n -S]\n",
  "PENTADACTYLE": "having five fingers or toes to each hand or foot, also PENTADACTYLIC, PENTADACTYLOUS [adj] / a pentadactyle animal, also PENTADACTYL [n -S]\n",
  "PENTADACTYLES": "PENTADACTYLE, a pentadactyle animal, also PENTADACTYL [n]\n",
  "PENTADACTYLIC": "having five digits, also PENTADACTYL, PENTADACTYLE, PENTADACTYLOUS [adj]\n",
  "PENTADACTYLIES": "PENTADACTYLY, the state of being pentadactyl, having five fingers [n]\n",
  "PENTADACTYLISM": "the state of being pentadactylic [n -S]\n",
  "PENTADACTYLISMS": "PENTADACTYLISM, the state of being pentadactylic [n]\n",
  "PENTADACTYLOUS": "having five digits, also PENTADACTYL, PENTADACTYLE, PENTADACTYLIC [adj]\n",
  "PENTADACTYLS": "PENTADACTYL, a pentadactyl animal, also PENTADACTYLE [n]\n",
  "PENTADACTYLY": "the state of being pentadactyl, having five fingers [n PENTADACTYLIES]\n",
  "PENTADELPHOUS": "having five bundles of stamens; united in five bundles [adj]\n",
  "PENTADIC": "within the scope of a pentad [adj]\n",
  "PENTADS": "PENTAD, a group of five [n]\n",
  "PENTAGON": "a five-sided polygon [n -S]\n",
  "PENTAGONAL": "having five corners or angles [adj PENTAGONALLY] / a pentagonal shape [n -S]\n",
  "PENTAGONALLY": "PENTAGONAL, having five corners or angles [adv]\n",
  "PENTAGONALS": "PENTAGONAL, a pentagonal shape [n]\n",
  "PENTAGONS": "PENTAGON, a five-sided polygon [n]\n",
  "PENTAGRAM": "a five-pointed star, formerly used as a mystic or magical symbol [n -S]\n",
  "PENTAGRAMS": "PENTAGRAM, a five-pointed star, formerly used as a mystic or magical symbol [n]\n",
  "PENTAGRAPH": "an erroneous form of pantograph [n -S]\n",
  "PENTAGRAPHS": "PENTAGRAPH, an erroneous form of pantograph [n]\n",
  "PENTAGYNIAN": "relating to the Pentagynia, an order of plants with five pistils, also PENTAGYNOUS [adj]\n",
  "PENTAGYNOUS": "relating to the Pentagynia, an order of plants with five pistils, also PENTAGYNIAN [adj]\n",
  "PENTAHEDRA": "PENTAHEDRON, a five-sided solid figure [n]\n",
  "PENTAHEDRAL": "of or like a pentahedron, a five-sided solid figure [adj]\n",
  "PENTAHEDRON": "a five-sided solid figure [n -S]\n",
  "PENTAHEDRONS": "PENTAHEDRON, a five-sided solid figure [n]\n",
  "PENTAHYDRATE": "a hydrated compound containing five moles of water per mole of the compound; a hydrated species containing five water molecules [n -S]\n",
  "PENTAHYDRATES": "PENTAHYDRATE, a hydrated compound containing five moles of water per mole of the compound; a hydrated species containing five water molecules [n]\n",
  "PENTALOGIES": "PENTALOGY, the state of being in five parts [n]\n",
  "PENTALOGY": "the state of being in five parts [n PENTALOGIES]\n",
  "PENTALPHA": "a five-pointed star, resembling five alphas joined at their bases [n -S]\n",
  "PENTALPHAS": "PENTALPHA, a five-pointed star, resembling five alphas joined at their bases [n]\n",
  "PENTAMERIES": "PENTAMERY, the condition of being pentamerous, having parts arranged in fives, also PENTAMERISM [n]\n",
  "PENTAMERISM": "the condition of being pentamerous, having parts arranged in fives, also PENTAMERY [n -S]\n",
  "PENTAMERISMS": "PENTAMERISM, the condition of being pentamerous, having parts arranged in fives, also PENTAMERY [n]\n",
  "PENTAMEROUS": "having five parts or members [adj]\n",
  "PENTAMERY": "the condition of being pentamerous, having parts arranged in fives, also PENTAMERISM [n PENTAMERIES]\n",
  "PENTAMETER": "a line of verse consisting of five metrical feet [n -S]\n",
  "PENTAMETERS": "PENTAMETER, a line of verse consisting of five metrical feet [n]\n",
  "PENTAMIDINE": "a drug used esp. to treat protozoal infections, such as leishmaniasis [n -S]\n",
  "PENTAMIDINES": "PENTAMIDINE, a drug used esp. to treat protozoal infections, such as leishmaniasis [n]\n",
  "PENTANDRIAN": "relating to the Pentandria, a class of plants with five stamens, also PENTANDROUS [adj]\n",
  "PENTANDROUS": "relating to the Pentandria, a class of plants with five stamens, also PENTANDRIAN [adj]\n",
  "PENTANE": "any of three hydrocarbons of the methane or paraffin series [n -S]\n",
  "PENTANES": "PENTANE, any of three hydrocarbons of the methane or paraffin series [n]\n",
  "PENTANGLE": "a five-pointed star, formerly used as a mystic or magical symbol [n -S]\n",
  "PENTANGLES": "PENTANGLE, a five-pointed star, formerly used as a mystic or magical symbol [n]\n",
  "PENTANGULAR": "having the shape of a pentangle [adj]\n",
  "PENTANOIC": "as in pentanoic acid [adj]\n",
  "PENTANOL": "one of the simple alcohols [n -S]\n",
  "PENTANOLS": "PENTANOL, one of the simple alcohols [n]\n",
  "PENTAPEPTIDE": "a polypeptide that contains five amino acid residues [n -S]\n",
  "PENTAPEPTIDES": "PENTAPEPTIDE, a polypeptide that contains five amino acid residues [n]\n",
  "PENTAPLOID": "a cell, organism, or form with five sets of chromosomes [n -S]\n",
  "PENTAPLOIDIES": "PENTAPLOIDY, the state of being pentaploid [n]\n",
  "PENTAPLOIDS": "PENTAPLOID, a cell, organism, or form with five sets of chromosomes [n]\n",
  "PENTAPLOIDY": "the state of being pentaploid [n PENTAPLOIDIES]\n",
  "PENTAPODIC": "relating to pentapody, a measure of five feet [adj]\n",
  "PENTAPODIES": "PENTAPODY, a measure or series consisting of five feet [n]\n",
  "PENTAPODY": "a measure or series consisting of five feet [n PENTAPODIES]\n",
  "PENTAPOLIS": "an alliance of five cities [n -ES]\n",
  "PENTAPOLISES": "PENTAPOLIS, an alliance of five cities [n]\n",
  "PENTAPOLITAN": "relating to a pentapolis, an alliance of five cities [adj]\n",
  "PENTAPRISM": "a five-sided prism used in photography [n -S]\n",
  "PENTAPRISMS": "PENTAPRISM, a five-sided prism used in photography [n]\n",
  "PENTAQUARK": "a hypothetical subatomic particle consisting of a group of five quarks (as compared to the usual three quarks) [n -S]\n",
  "PENTAQUARKS": "PENTAQUARK, a hypothetical subatomic particle consisting of a group of five quarks (as compared to the usual three quarks) [n]\n",
  "PENTARCH": "a member of a pentarchy, government by five persons [n -S]\n",
  "PENTARCHICAL": "relating to a pentarchy, government by five individuals [adj]\n",
  "PENTARCHIES": "PENTARCHY, government by five individuals [n]\n",
  "PENTARCHS": "PENTARCH, a member of a pentarchy, government by five persons [n]\n",
  "PENTARCHY": "government by five individuals [n PENTARCHIES]\n",
  "PENTASTICH": "a composition consisting of five verses [n -S]\n",
  "PENTASTICHOUS": "arranged in five rows [adj]\n",
  "PENTASTICHS": "PENTASTICH, a composition consisting of five verses [n]\n",
  "PENTASTYLE": "a building or portico with five columns [n -S]\n",
  "PENTASTYLES": "PENTASTYLE, a building or portico with five columns [n]\n",
  "PENTASYLLABIC": "having five syllables [adj]\n",
  "PENTATEUCHAL": "relating to the Pentateuch, the Mosaic book of the law [adj]\n",
  "PENTATHLA": "PENTATHLUM, a pentathlon [n]\n",
  "PENTATHLETE": "an athlete participating in a pentathlon [n -S]\n",
  "PENTATHLETES": "PENTATHLETE, an athlete participating in a pentathlon [n]\n",
  "PENTATHLON": "an athletic contest involving participation by each contestant in five different events [n -S]\n",
  "PENTATHLONS": "PENTATHLON, an athletic contest involving participation by each contestant in five different events [n]\n",
  "PENTATHLUM": "a pentathlon [n PENTATHLA or PENTATHLUMS]\n",
  "PENTATHLUMS": "PENTATHLUM, a pentathlon [n]\n",
  "PENTATOMIC": "having five atoms in the molecule [adj]\n",
  "PENTATONIC": "consisting of five tones or notes [adj]\n",
  "PENTAVALENCE": "the condition of having a valency of five, also PENTAVALENCY [n -S]\n",
  "PENTAVALENCES": "PENTAVALENCE, the condition of having a valency of five, also PENTAVALENCY [n]\n",
  "PENTAVALENCIES": "PENTAVALENCY, the condition of having a valency of five, also PENTAVALENCE [n]\n",
  "PENTAVALENCY": "the condition of having a valency of five, also PENTAVALENCE [n PENTAVALENCIES]\n",
  "PENTAVALENT": "having a valence of five [adj]\n",
  "PENTAZOCINE": "a synthetic analgesic drug, less addictive than morphine [n -S]\n",
  "PENTAZOCINES": "PENTAZOCINE, a synthetic analgesic drug, less addictive than morphine [n]\n",
  "PENTECONTER": "a commander of a troop of fifty men [n -S]\n",
  "PENTECONTERS": "PENTECONTER, a commander of a troop of fifty men [n]\n",
  "PENTEL": "a kind of pen [n -S]\n",
  "PENTELS": "PENTEL, a kind of pen [n]\n",
  "PENTENE": "an unsaturated hydrocarbon of the olefine series, also PENTYLENE [n -S]\n",
  "PENTENES": "PENTENE, an unsaturated hydrocarbon of the olefine series, also PENTYLENE [n]\n",
  "PENTETERIC": "occurring every fourth year [adj]\n",
  "PENTHEMIMER": "a metrical group of two and a half feet [n -S]\n",
  "PENTHEMIMERAL": "of or like a penthemimer, a metrical group of two and a half feet [adj]\n",
  "PENTHEMIMERS": "PENTHEMIMER, a metrical group of two and a half feet [n]\n",
  "PENTHIA": "(Spenser) another name for the unidentified plant astrophel [n -S]\n",
  "PENTHIAS": "PENTHIA, (Spenser) another name for the unidentified plant astrophel [n]\n",
  "PENTHOUSE": "a flat or maisonette built onto the top floor or roof of a block of flats [n -S] / to cover or shelter as in a penthouse [v PENTHOUSED, PENTHOUSING, PENTHOUSES]\n",
  "PENTHOUSED": "PENTHOUSE, to cover or shelter as in a penthouse [v]\n",
  "PENTHOUSES": "PENTHOUSE, to cover or shelter as in a penthouse [v]\n",
  "PENTHOUSING": "PENTHOUSE, to cover or shelter as in a penthouse [v]\n",
  "PENTICE": "to provide with a penthouse, also PENTISE [v PENTICED, PENTICING, PENTICES]\n",
  "PENTICED": "PENTICE, to provide with a penthouse, also PENTISE [v]\n",
  "PENTICES": "PENTICE, to provide with a penthouse, also PENTISE [v]\n",
  "PENTICING": "PENTICE, to provide with a penthouse, also PENTISE [v]\n",
  "PENTIMENTI": "PENTIMENTO, (Italian) a painting or drawing that has been painted over and shows through it [n]\n",
  "PENTIMENTO": "(Italian) a painting or drawing that has been painted over and shows through it [n PENTIMENTI]\n",
  "PENTISE": "to provide with a penthouse, also PENTICE [v PENTISED, PENTISING, PENTISES]\n",
  "PENTISED": "PENTISE, to provide with a penthouse, also PENTICE [v]\n",
  "PENTISES": "PENTISE, to provide with a penthouse, also PENTICE [v]\n",
  "PENTISING": "PENTISE, to provide with a penthouse, also PENTICE [v]\n",
  "PENTITI": "PENTITO, (Italian) in Italy, a Mafia criminal who has become a police informer [n]\n",
  "PENTITO": "(Italian) in Italy, a Mafia criminal who has become a police informer [n PENTITI]\n",
  "PENTLANDITE": "a principal ore of nickel [n -S]\n",
  "PENTLANDITES": "PENTLANDITE, a principal ore of nickel [n]\n",
  "PENTOBARBITAL": "a barbiturate drug with hypnotic, sedative, and anticonvulsant effects, also PENTABARBITAL [n -S]\n",
  "PENTOBARBITALS": "PENTOBARBITAL, a barbiturate drug with hypnotic, sedative, and anticonvulsant effects, also PENTABARBITAL [n]\n",
  "PENTOBARBITONE": "a barbiturate drug, with hypnotic, sedative, and anticonvulsant effects [n -S]\n",
  "PENTOBARBITONES": "PENTOBARBITONE, a barbiturate drug, with hypnotic, sedative, and anticonvulsant effects [n]\n",
  "PENTODE": "a type of electron tube [n -S]\n",
  "PENTODES": "PENTODE, a type of electron tube [n]\n",
  "PENTOMIC": "of an army division, formed in five units, esp. when using atomic weapons [adj]\n",
  "PENTOSAN": "a complex carbohydrate found in cellulose, also PENTOSANE [n -S]\n",
  "PENTOSANE": "a complex carbohydrate found in cellulose, also PENTOSAN [n -S]\n",
  "PENTOSANES": "PENTOSANE, a complex carbohydrate found in cellulose, also PENTOSAN [n]\n",
  "PENTOSANS": "PENTOSAN, a complex carbohydrate found in cellulose, also PENTOSANE [n]\n",
  "PENTOSE": "a sugar with five carbon atoms per molecule [n -S]\n",
  "PENTOSES": "PENTOSE, a sugar with five carbon atoms per molecule [n]\n",
  "PENTOSIDE": "a compound containing sugar [n -S]\n",
  "PENTOSIDES": "PENTOSIDE, a compound containing sugar [n]\n",
  "PENTOXIDE": "an oxide containing five atoms of oxygen in each molecule; as, phosphorus pentoxide [n -S]\n",
  "PENTOXIDES": "PENTOXIDE, an oxide containing five atoms of oxygen in each molecule; as, phosphorus pentoxide [n]\n",
  "PENTROOF": "a roof that slopes one way only [n -S]\n",
  "PENTROOFS": "PENTROOF, a roof that slopes one way only [n]\n",
  "PENTS": "PENT, a penthouse [n]\n",
  "PENTSTEMON": "a genus of showy flowers, also PENSTEMON [n -S]\n",
  "PENTSTEMONS": "PENTSTEMON, a genus of showy flowers, also PENSTEMON [n]\n",
  "PENTYL": "a radical derived from a pentane [n -S]\n",
  "PENTYLENE": "an unsaturated hydrocarbon of the olefine series, also PENTENE [n -S]\n",
  "PENTYLENES": "PENTYLENE, an unsaturated hydrocarbon of the olefine series, also PENTENE [n]\n",
  "PENTYLS": "PENTYL, a radical derived from a pentane [n]\n",
  "PENUCHE": "(Spanish) a fudge-like candy, also PENOCHE, PENUCHI [n -S]\n",
  "PENUCHES": "PENUCHE, (Spanish) a fudge-like candy, also PENOCHE, PENUCHI [n]\n",
  "PENUCHI": "(Spanish) a fudge-like candy, also PENUCHE, PENOCHE [n -S]\n",
  "PENUCHIS": "PENUCHI, (Spanish) a fudge-like candy, also PENUCHE, PENOCHE [n]\n",
  "PENUCHLE": "a card game, also PINOCHLE, PENUCKLE, PINOCLE [n -S]\n",
  "PENUCHLES": "PENUCHLE, a card game, also PINOCHLE, PENUCKLE, PINOCLE [n]\n",
  "PENUCKLE": "a card game, also PINOCHLE, PENUCHLE, PINOCLE [n -S]\n",
  "PENUCKLES": "PENUCKLE, a card game, also PINOCHLE, PENUCHLE, PINOCLE [n]\n",
  "PENULT": "(Latin) the last but one syllable, also PENULTIMA [n -S]\n",
  "PENULTIMA": "(Latin) the last but one syllable, also PENULT [n -S]\n",
  "PENULTIMAS": "PENULTIMA, (Latin) the last but one syllable, also PENULT [n]\n",
  "PENULTIMATE": "next to the last [adj PENULTIMATELY] / the last but one [n -S]\n",
  "PENULTIMATELY": "PENULTIMATE, next to the last [adv]\n",
  "PENULTIMATES": "PENULTIMATE, the last but one [n]\n",
  "PENULTS": "PENULT, (Latin) the last but one syllable, also PENULTIMA [n]\n",
  "PENUMBRA": "(Latin) a partial shadow [n PENUMBRAS or PENUMBRAE]\n",
  "PENUMBRAE": "PENUMBRA, (Latin) a partial shadow [n]\n",
  "PENUMBRAL": "relating to the penumbra [adj]\n",
  "PENUMBRAS": "PENUMBRA, (Latin) a partial shadow [n]\n",
  "PENUMBROUS": "relating to penumbra, partial shade [adj]\n",
  "PENURIES": "PENURY, extreme poverty [n]\n",
  "PENURIOUS": "poor; mean [adj PENURIOUSLY]\n",
  "PENURIOUSLY": "PENURIOUS, poor; mean [adv]\n",
  "PENURIOUSNESS": "PENURIOUS, poor; mean [n]\n",
  "PENURIOUSNESSES": "PENURIOUSNESS, PENURIOUS, poor; mean [n]\n",
  "PENURY": "extreme poverty [n PENURIES]\n",
  "PENWIPER": "a piece of equipment for cleaning the ink from a pen [n -S]\n",
  "PENWIPERS": "PENWIPER, a piece of equipment for cleaning the ink from a pen [n]\n",
  "PENWOMAN": "a female person skilled in handwriting [n PENWOMEN]\n",
  "PENWOMEN": "PENWOMAN, a female person skilled in handwriting [n]\n",
  "PEON": "(Spanish) a day-labourer, esp. in Spanish-speaking America [n PEONS or PEONES]\n",
  "PEONAGE": "the condition of being a peon, also PEONISM [n -S]\n",
  "PEONAGES": "PEONAGE, the condition of being a peon, also PEONISM [n]\n",
  "PEONES": "PEON, (Spanish) a day-labourer, esp. in Spanish-speaking America [n]\n",
  "PEONIES": "PEONY, a showy flower, also PAEONY, PINY, PIONEY, PIONY [n]\n",
  "PEONISM": "the condition of being a peon, also PEONAGE [n -S]\n",
  "PEONISMS": "PEONISM, the condition of being a peon, also PEONAGE [n]\n",
  "PEONS": "PEON, (Spanish) a day-labourer, esp. in Spanish-speaking America [n]\n",
  "PEONY": "a showy flower, also PAEONY, PINY, PIONEY, PIONY [n PEONIES]\n",
  "PEOPLE": "to stock with inhabitants [v PEOPLED, PEOPLING, PEOPLES]\n",
  "PEOPLED": "PEOPLE, to stock with inhabitants [v]\n",
  "PEOPLEHOOD": "the state of constituting a people [n -S]\n",
  "PEOPLEHOODS": "PEOPLEHOOD, the state of constituting a people [n]\n",
  "PEOPLELESS": "destitute of people [adj]\n",
  "PEOPLER": "a settler; an inhabitant [n -S]\n",
  "PEOPLERS": "PEOPLER, a settler; an inhabitant [n]\n",
  "PEOPLES": "PEOPLE, to stock with inhabitants [v]\n",
  "PEOPLING": "PEOPLE, to stock with inhabitants [v]\n",
  "PEP": "to fill with energy [v PEPPED, PEPPING, PEPS]\n",
  "PEPERINO": "(Italian) a type of volcanic rock, formed by the cementing together of sand, scoria, cinders, etc. [n -S]\n",
  "PEPERINOS": "PEPERINO, (Italian) a type of volcanic rock, formed by the cementing together of sand, scoria, cinders, etc. [n]\n",
  "PEPEROMIA": "a genus of subtropical herbaceous plants [n -S]\n",
  "PEPEROMIAS": "PEPEROMIA, a genus of subtropical herbaceous plants [n]\n",
  "PEPERONI": "(Italian) a highly seasoned sausage [n -S]\n",
  "PEPERONIS": "PEPERONI, (Italian) a highly seasoned sausage [n]\n",
  "PEPFUL": "full of vigour [adj]\n",
  "PEPINO": "(Spanish) a purple-striped pale yellow fruit with sweet flesh [n -S]\n",
  "PEPINOS": "PEPINO, (Spanish) a purple-striped pale yellow fruit with sweet flesh [n]\n",
  "PEPITA": "(Spanish) the edible dried seed of a pumpkin or squash [n -S]\n",
  "PEPITAS": "PEPITA, (Spanish) the edible dried seed of a pumpkin or squash [n]\n",
  "PEPLA": "PEPLUM, (Latin) a flounce attached to the waistline of a garment [n]\n",
  "PEPLOS": "(Greek) a garment worn by women in ancient Greece, also PEPLUS [n -ES]\n",
  "PEPLOSES": "PEPLOS, (Greek) a garment worn by women in ancient Greece, also PEPLUS [n]\n",
  "PEPLUM": "(Latin) a flounce attached to the waistline of a garment [n PEPLUMS or PEPLA]\n",
  "PEPLUMED": "having a peplum [adj]\n",
  "PEPLUMS": "PEPLUM, (Latin) a flounce attached to the waistline of a garment [n]\n",
  "PEPLUS": "(Greek) a garment worn by women in ancient Greece, also PEPLOS [n -ES]\n",
  "PEPLUSES": "PEPLUS, (Greek) a garment worn by women in ancient Greece, also PEPLOS [n]\n",
  "PEPO": "a fruit having a fleshy interior and a hard rind, also PEPONIDA, PEPONIUM [n -S]\n",
  "PEPONIDA": "a fruit having a fleshy interior and a hard rind, also PEPO, PEPONIUM [n -S]\n",
  "PEPONIDAS": "PEPONIDA, a fruit having a fleshy interior and a hard rind, also PEPO, PEPONIUM [n]\n",
  "PEPONIUM": "a fruit having a fleshy interior and a hard rind, also PEPO, PEPONIDA [n -S]\n",
  "PEPONIUMS": "PEPONIUM, a fruit having a fleshy interior and a hard rind, also PEPO, PEPONIDA [n]\n",
  "PEPOS": "PEPO, a fruit having a fleshy interior and a hard rind, also PEPONIDA, PEPONIUM [n]\n",
  "PEPPED": "PEP, to fill with energy [v]\n",
  "PEPPER": "to season with a pungent condiment [v -ED, -ING, -S]\n",
  "PEPPERBOX": "a pepper-pot; an early type of gun [n -ES]\n",
  "PEPPERBOXES": "PEPPERBOX, a pepper-pot; an early type of gun [n]\n",
  "PEPPERCORN": "the dried berry of the pepper plant [n -S]\n",
  "PEPPERCORNIER": "PEPPERCORNY, containing or tasting like peppercorn [adj]\n",
  "PEPPERCORNIEST": "PEPPERCORNY, containing or tasting like peppercorn [adj]\n",
  "PEPPERCORNS": "PEPPERCORN, the dried berry of the pepper plant [n]\n",
  "PEPPERCORNY": "containing or tasting like peppercorn [adj PEPPERCORNIER, PEPPERCORNIEST]\n",
  "PEPPERED": "PEPPER, to season with a pungent condiment [v]\n",
  "PEPPERER": "a dealer in pepper and spices [n -S]\n",
  "PEPPERERS": "PEPPERER, a dealer in pepper and spices [n]\n",
  "PEPPERGRASS": "a wild plant, aka pepperwort [n -ES]\n",
  "PEPPERGRASSES": "PEPPERGRASS, a wild plant, aka pepperwort [n]\n",
  "PEPPERIDGE": "a North American tree of the Dogwood family, having brilliant, glossy foliage and acid red berries, aka tupelo [n -S]\n",
  "PEPPERIDGES": "PEPPERIDGE, a North American tree of the Dogwood family, having brilliant, glossy foliage and acid red berries, aka tupelo [n]\n",
  "PEPPERIER": "PEPPERY, resembling pepper [adj]\n",
  "PEPPERIEST": "PEPPERY, resembling pepper [adj]\n",
  "PEPPERINESS": "the state of being peppery [n -ES]\n",
  "PEPPERINESSES": "PEPPERINESS, the state of being peppery [n]\n",
  "PEPPERING": "a seasoning with pepper [n -S]\n",
  "PEPPERINGS": "PEPPERING, a seasoning with pepper [n]\n",
  "PEPPERMILL": "a small hand-mill in which peppercorns are ground [n -S]\n",
  "PEPPERMILLS": "PEPPERMILL, a small hand-mill in which peppercorns are ground [n]\n",
  "PEPPERMINT": "a pungent and aromatic mint with dark green lanceolate leaves and whorls of small pink flowers in spikes [n -S]\n",
  "PEPPERMINTIER": "PEPPERMINTY, tasting of peppermint [adj]\n",
  "PEPPERMINTIEST": "PEPPERMINTY, tasting of peppermint [adj]\n",
  "PEPPERMINTS": "PEPPERMINT, a pungent and aromatic mint with dark green lanceolate leaves and whorls of small pink flowers in spikes [n]\n",
  "PEPPERMINTY": "tasting of peppermint [adj PEPPERMINTIER, PEPPERMINTIEST]\n",
  "PEPPERONI": "(Italian) a hard, spicy pork and beef sausage, also PEPERONI [n -S]\n",
  "PEPPERONIS": "PEPPERONI, (Italian) a hard, spicy pork and beef sausage, also PEPERONI [n]\n",
  "PEPPERS": "PEPPER, to season with a pungent condiment [v]\n",
  "PEPPERTREE": "an evergreen tree native to tropical America [n -S]\n",
  "PEPPERTREES": "PEPPERTREE, an evergreen tree native to tropical America [n]\n",
  "PEPPERWORT": "a wild plant, aka peppergrass [n -S]\n",
  "PEPPERWORTS": "PEPPERWORT, a wild plant, aka peppergrass [n]\n",
  "PEPPERY": "resembling pepper [adj PEPPERIER, PEPPERIEST]\n",
  "PEPPIER": "PEPPY, full of energy [adj]\n",
  "PEPPIEST": "PEPPY, full of energy [adj]\n",
  "PEPPILY": "PEPPY, full of energy [adv]\n",
  "PEPPINESS": "being peppy [n -ES]\n",
  "PEPPINESSES": "PEPPINESS, being peppy [n]\n",
  "PEPPING": "PEP, to fill with energy [v]\n",
  "PEPPY": "full of energy [adj PEPPIER, PEPPIEST, PEPPILY]\n",
  "PEPS": "PEP, to fill with energy [v]\n",
  "PEPSI": "(offensive) a French Canadian [n -S]\n",
  "PEPSIN": "a digestive enzyme of the stomach, also PEPSINE [n -S]\n",
  "PEPSINATE": "to treat or mix with pepsin [v PEPSINATED, PEPSINATING, PEPSINATES]\n",
  "PEPSINATED": "PEPSINATE, to treat or mix with pepsin [v]\n",
  "PEPSINATES": "PEPSINATE, to treat or mix with pepsin [v]\n",
  "PEPSINATING": "PEPSINATE, to treat or mix with pepsin [v]\n",
  "PEPSINE": "a digestive enzyme of the stomach, also PEPSIN [n -S]\n",
  "PEPSINES": "PEPSINE, a digestive enzyme of the stomach, also PEPSIN [n]\n",
  "PEPSINOGEN": "a substance in the mucous membrane of the stomach which converts into pepsin in a slightly acid medium [n -S]\n",
  "PEPSINOGENS": "PEPSINOGEN, a substance in the mucous membrane of the stomach which converts into pepsin in a slightly acid medium [n]\n",
  "PEPSINS": "PEPSIN, a digestive enzyme of the stomach, also PEPSINE [n]\n",
  "PEPSIS": "PEPSI, (offensive) a French Canadian [n]\n",
  "PEPTALK": "to inspire enthusiasm in by an intense, emotional talk [v -ED, -ING, -S]\n",
  "PEPTALKED": "PEPTALK, to inspire enthusiasm in by an intense, emotional talk [v]\n",
  "PEPTALKING": "PEPTALK, to inspire enthusiasm in by an intense, emotional talk [v]\n",
  "PEPTALKS": "PEPTALK, to inspire enthusiasm in by an intense, emotional talk [v]\n",
  "PEPTIC": "a substance that promotes digestion [n -S]\n",
  "PEPTICITIES": "PEPTICITY, being peptic [n]\n",
  "PEPTICITY": "being peptic [n PEPTICITIES]\n",
  "PEPTICS": "PEPTIC, a substance that promotes digestion [n]\n",
  "PEPTID": "a combination of amino acids, also PEPTIDE [n -S]\n",
  "PEPTIDASE": "an enzyme which breaks down peptides [n -S]\n",
  "PEPTIDASES": "PEPTIDASE, an enzyme which breaks down peptides [n]\n",
  "PEPTIDE": "a combination of amino acids, also PEPTID [n -S]\n",
  "PEPTIDES": "PEPTIDE, a combination of amino acids, also PEPTID [n]\n",
  "PEPTIDIC": "relating to a peptide, a combination of amino acids [adj]\n",
  "PEPTIDOGLYCAN": "a polymer in the cell walls of procaryotes [n -S]\n",
  "PEPTIDOGLYCANS": "PEPTIDOGLYCAN, a polymer in the cell walls of procaryotes [n]\n",
  "PEPTIDS": "PEPTID, a combination of amino acids, also PEPTIDE [n]\n",
  "PEPTISABLE": "that can be peptised, also PEPTIZABLE [adj]\n",
  "PEPTISATION": "the act of peptising, also PEPTIZATION [n -S]\n",
  "PEPTISATIONS": "PEPTISATION, the act of peptising, also PEPTIZATION [n]\n",
  "PEPTISE": "to form a colloidal solution, also PEPTIZE [v PEPTISED, PEPTISING, PEPTISES]\n",
  "PEPTISED": "PEPTISE, to form a colloidal solution, also PEPTIZE [v]\n",
  "PEPTISER": "one that peptises, also PEPTIZER [n -S]\n",
  "PEPTISERS": "PEPTISER, one that peptises, also PEPTIZER [n]\n",
  "PEPTISES": "PEPTISE, to form a colloidal solution, also PEPTIZE [v]\n",
  "PEPTISING": "PEPTISE, to form a colloidal solution, also PEPTIZE [v]\n",
  "PEPTIZABLE": "that can be peptized, also PEPTISABLE [adj]\n",
  "PEPTIZATION": "the act of peptizing, also PEPTISATION [n -S]\n",
  "PEPTIZATIONS": "PEPTIZATION, the act of peptizing, also PEPTISATION [n]\n",
  "PEPTIZE": "to form a colloidal solution, also PEPTISE [v PEPTIZED, PEPTIZING, PEPTIZES]\n",
  "PEPTIZED": "PEPTIZE, to form a colloidal solution, also PEPTISE [v]\n",
  "PEPTIZER": "one that peptizes, also PEPTISER [n -S]\n",
  "PEPTIZERS": "PEPTIZER, one that peptizes, also PEPTISER [n]\n",
  "PEPTIZES": "PEPTIZE, to form a colloidal solution, also PEPTISE [v]\n",
  "PEPTIZING": "PEPTIZE, to form a colloidal solution, also PEPTISE [v]\n",
  "PEPTONE": "a substance resulting from the digestion of protein by pepsin [n -S]\n",
  "PEPTONES": "PEPTONE, a substance resulting from the digestion of protein by pepsin [n]\n",
  "PEPTONIC": "relating to peptone, a substance resulting from the digestion of protein by pepsin [adj]\n",
  "PEPTONISATION": "the process of peptonising, also PEPTONIZATION [n -S]\n",
  "PEPTONISATIONS": "PEPTONISATION, the process of peptonising, also PEPTONIZATION [n]\n",
  "PEPTONISE": "to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONIZE [v PEPTONISED, PEPTONISING, PEPTONISES]\n",
  "PEPTONISED": "PEPTONISE, to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONIZE [v]\n",
  "PEPTONISER": "an agent that peptonises, also PEPTONIZER [n -S]\n",
  "PEPTONISERS": "PEPTONISER, an agent that peptonises, also PEPTONIZER [n]\n",
  "PEPTONISES": "PEPTONISE, to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONIZE [v]\n",
  "PEPTONISING": "PEPTONISE, to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONIZE [v]\n",
  "PEPTONIZATION": "the process of peptonizing, also PEPTONISATION [n -S]\n",
  "PEPTONIZATIONS": "PEPTONIZATION, the process of peptonizing, also PEPTONISATION [n]\n",
  "PEPTONIZE": "to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONISE [v PEPTONIZED, PEPTONIZING, PEPTONIZES]\n",
  "PEPTONIZED": "PEPTONIZE, to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONISE [v]\n",
  "PEPTONIZER": "an agent that peptonizes, also PEPTONISER [n -S]\n",
  "PEPTONIZERS": "PEPTONIZER, an agent that peptonizes, also PEPTONISER [n]\n",
  "PEPTONIZES": "PEPTONIZE, to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONISE [v]\n",
  "PEPTONIZING": "PEPTONIZE, to make (a protein) soluble by partial predigestion, esp. in the treatment of food, also PEPTONISE [v]\n",
  "PEQUISTE": "(Canadian) in Canada, a supporter of the Parti Quebecois [n -S]\n",
  "PEQUISTES": "PEQUISTE, (Canadian) in Canada, a supporter of the Parti Quebecois [n]\n",
  "PER": "for each [prep]\n",
  "PERACID": "a type of acid [n -S]\n",
  "PERACIDITIES": "PERACIDITY, the state of being peracid [n]\n",
  "PERACIDITY": "the state of being peracid [n PERACIDITIES]\n",
  "PERACIDS": "PERACID, a type of acid [n]\n",
  "PERACUTE": "violent [adj]\n",
  "PERADVENTURE": "by chance [adj] / doubt, uncertainty [n -S]\n",
  "PERADVENTURES": "PERADVENTURE, doubt, uncertainty [n]\n",
  "PERAEA": "PERAEON, (Greek) a crustacean's thorax, also PEREION, PEREON [n]\n",
  "PERAEON": "(Greek) a crustacean's thorax, also PEREION, PEREON [n PERAEONS or PERAEA]\n",
  "PERAEONS": "PERAEON, (Greek) a crustacean's thorax, also PEREION, PEREON [n]\n",
  "PERAEOPOD": "each of the eight walking limbs of a crustacean such as a crab or lobster, growing from the thorax, also PEREIOPOD, PEREOPOD [n -S]\n",
  "PERAEOPODS": "PERAEOPOD, each of the eight walking limbs of a crustacean such as a crab or lobster, growing from the thorax, also PEREIOPOD, PEREOPOD [n]\n",
  "PERAI": "(Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PIRAI, PIRANA, PIRAYA [n -S]\n",
  "PERAIS": "PERAI, (Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PIRAI, PIRANA, PIRAYA [n]\n",
  "PERAMBULATE": "to walk through, to inspect an area on foot [v PERAMBULATED, PERAMBULATING, PERAMBULATES]\n",
  "PERAMBULATED": "PERAMBULATE, to walk through, to inspect an area on foot [v]\n",
  "PERAMBULATES": "PERAMBULATE, to walk through, to inspect an area on foot [v]\n",
  "PERAMBULATING": "PERAMBULATE, to walk through, to inspect an area on foot [v]\n",
  "PERAMBULATION": "the act of perambulating [n -S]\n",
  "PERAMBULATIONS": "PERAMBULATION, the act of perambulating [n]\n",
  "PERAMBULATOR": "a pram [n -S]\n",
  "PERAMBULATORS": "PERAMBULATOR, a pram [n]\n",
  "PERAMBULATORY": "relating to perambulation [adj]\n",
  "PERBORATE": "a salt that is a compound of a borate with perchloric acid [n -S]\n",
  "PERBORATES": "PERBORATE, a salt that is a compound of a borate with perchloric acid [n]\n",
  "PERBORIC": "as in perboric acid, the supposed parent acid of the perborates [adj]\n",
  "PERC": "(short for) perchloride, a chemical used in dry cleaning [n -S]\n",
  "PERCALE": "(French) a closely woven French cambric [n -S]\n",
  "PERCALES": "PERCALE, (French) a closely woven French cambric [n]\n",
  "PERCALINE": "(French) a glossy lightweight cotton [n -S]\n",
  "PERCALINES": "PERCALINE, (French) a glossy lightweight cotton [n]\n",
  "PERCASE": "(obsolete) perhaps; perchance [adv]\n",
  "PERCE": "(Spenser) to pierce, also PEARCE, PERCEN, PERSE [v PERCED, PERCING, PERCES]\n",
  "PERCEABLE": "(Spenser) able to be pierced, also PIERCEABLE [adj]\n",
  "PERCEANT": "piercing, also PERSANT, PERSAUNT [adj]\n",
  "PERCED": "PERCE, (Spenser) to pierce, also PEARCE, PERCEN, PERSE [v]\n",
  "PERCEIVABILITY": "the quality of being perceivable [n]\n",
  "PERCEIVABLE": "able to be perceived [adj PERCEIVABLY]\n",
  "PERCEIVABLY": "PERCEIVABLE, able to be perceived [adv]\n",
  "PERCEIVE": "to become aware of through the senses [v PERCEIVED, PERCEIVING, PERCEIVES]\n",
  "PERCEIVED": "PERCEIVE, to become aware of through the senses [v]\n",
  "PERCEIVER": "one who perceives [n -S]\n",
  "PERCEIVERS": "PERCEIVER, one who perceives [n]\n",
  "PERCEIVES": "PERCEIVE, to become aware of through the senses [v]\n",
  "PERCEIVING": "the act of perceiving [n -S]\n",
  "PERCEIVINGS": "PERCEIVING, the act of perceiving [n]\n",
  "PERCEN": "(Spenser) to pierce [v]\n",
  "PERCENT": "one part in a hundred [n -S]\n",
  "PERCENTAGE": "a part of a whole expressed in hundredths [n -S]\n",
  "PERCENTAGES": "PERCENTAGE, a part of a whole expressed in hundredths [n]\n",
  "PERCENTAL": "relating to percentages [adj]\n",
  "PERCENTILE": "the value below which falls a large number of statistical units e.g. exam scores [n -S]\n",
  "PERCENTILES": "PERCENTILE, the value below which falls a large number of statistical units e.g. exam scores [n]\n",
  "PERCENTS": "PERCENT, one part in a hundred [n]\n",
  "PERCEPT": "something that is perceived [n -S]\n",
  "PERCEPTIBILITY": "the state of being perceptible [n]\n",
  "PERCEPTIBLE": "able to be perceived [adj PERCEPTIBLY]\n",
  "PERCEPTIBLY": "PERCEPTIBLE, able to be perceived [adv]\n",
  "PERCEPTION": "a result of perceiving [n -S]\n",
  "PERCEPTIONAL": "relating to perception [adj]\n",
  "PERCEPTIONS": "PERCEPTION, a result of perceiving [n]\n",
  "PERCEPTIVE": "responsive to sensory stimuli [adj PERCEPTIVELY]\n",
  "PERCEPTIVELY": "PERCEPTIVE, responsive to sensory stimuli [adv]\n",
  "PERCEPTIVENESS": "PERCEPTIVE, responsive to sensory stimuli [n]\n",
  "PERCEPTIVITIES": "PERCEPTIVITY, the state of being perceptive [n]\n",
  "PERCEPTIVITY": "the state of being perceptive [n PERCEPTIVITIES]\n",
  "PERCEPTS": "PERCEPT, something that is perceived [n]\n",
  "PERCEPTUAL": "of, relating to, or involving perception esp. in relation to immediate sensory experience [adj PERCEPTUALLY]\n",
  "PERCEPTUALLY": "PERCEPTUAL, of, relating to, or involving perception esp. in relation to immediate sensory experience [adv]\n",
  "PERCES": "PERCE, (Spenser) to pierce, also PEARCE, PERCEN, PERSE [v]\n",
  "PERCH": "to sit in an elevated place [v -ED, -ING, -ES]\n",
  "PERCHANCE": "by chance, as it may happen [adv]\n",
  "PERCHED": "PERCH, to sit in an elevated place [v]\n",
  "PERCHER": "one who perches [n -S]\n",
  "PERCHERIES": "PERCHERY, a barn where hens are free to perch [n]\n",
  "PERCHERON": "(French) a draught-horse of a breed originating in La Perche in Normandy [n -S]\n",
  "PERCHERONS": "PERCHERON, (French) a draught-horse of a breed originating in La Perche in Normandy [n]\n",
  "PERCHERS": "PERCHER, one who perches [n]\n",
  "PERCHERY": "a barn where hens are free to perch [n PERCHERIES]\n",
  "PERCHES": "PERCH, to sit in an elevated place [v]\n",
  "PERCHING": "a method of softening leather [n -S]\n",
  "PERCHINGS": "PERCHING, a method of softening leather [n]\n",
  "PERCHLORATE": "a salt or ester of perchloric acid [n -S]\n",
  "PERCHLORATES": "PERCHLORATE, a salt or ester of perchloric acid [n]\n",
  "PERCHLORIC": "containing more oxygen than chloric acid, esp. applied to an oily explosive acid, HClO4 [adj]\n",
  "PERCHLORIDE": "a chloride that contains more chlorine than other chlorides of the same element [n -S]\n",
  "PERCHLORIDES": "PERCHLORIDE, a chloride that contains more chlorine than other chlorides of the same element [n]\n",
  "PERCHLOROETHENE": "a chlorine-carbon compound widely used for the dry cleaning of fabrics [n]\n",
  "PERCID": "a freshwater fish of the perch family, also PERCINE, PERCOID, PERCOIDEAN [n -S]\n",
  "PERCIDS": "PERCID, a freshwater fish of the perch family, also PERCINE, PERCOID, PERCOIDEAN [n]\n",
  "PERCIFORM": "a perch-like fish [n -S]\n",
  "PERCIFORMS": "PERCIFORM, a perch-like fish [n]\n",
  "PERCINE": "of or like a perch, also PERCOID, PERCOIDEAN [adj] / a perch-like fish, esp. one belonging to the family Percidae, also PERCID [n -S]\n",
  "PERCINES": "PERCINE, a perch-like fish, esp. one belonging to the family Percidae, also PERCID [n]\n",
  "PERCING": "PERCE, (Spenser) to pierce, also PEARCE, PERCEN, PERSE [v]\n",
  "PERCIPIENCE": "the state of being percipient, also PERCIPIENCY [n -S]\n",
  "PERCIPIENCES": "PERCIPIENCE, the state of being percipient, also PERCIPIENCY [n]\n",
  "PERCIPIENCIES": "PERCIPIENCY, the state of being percipient, also PERCIPIENCE [n]\n",
  "PERCIPIENCY": "the state of being percipient, also PERCIPIENCE [n PERCIPIENCIES]\n",
  "PERCIPIENT": "perceiving; perceptive [adj PERCIPIENTLY] / one who perceives [n -S]\n",
  "PERCIPIENTLY": "PERCIPIENT, perceiving; perceptive [adv]\n",
  "PERCIPIENTS": "PERCIPIENT, one who perceives [n]\n",
  "PERCOCT": "to cook thoroughly [v -ED, -ING, -S]\n",
  "PERCOCTED": "PERCOCT, to cook thoroughly [v]\n",
  "PERCOCTING": "PERCOCT, to cook thoroughly [v]\n",
  "PERCOCTS": "PERCOCT, to cook thoroughly [v]\n",
  "PERCOID": "of the perch family, also PERCOIDEAN [adj] / a member of the perch family, also PERCID, PERCINE [n -S]\n",
  "PERCOIDEAN": "a fish of the perch family, also PERCID, PERCINE, PERCOID [n -S]\n",
  "PERCOIDEANS": "PERCOIDEAN, a fish of the perch family, also PERCID, PERCINE, PERCOID [n]\n",
  "PERCOIDS": "PERCOID, a member of the perch family, also PERCID, PERCINE [n]\n",
  "PERCOLABLE": "that can be percolated [adj]\n",
  "PERCOLATE": "to pass through pores, small openings, etc.; to filter [v PERCOLATED, PERCOLATING, PERCOLATES]\n",
  "PERCOLATED": "PERCOLATE, to pass through pores, small openings, etc.; to filter [v]\n",
  "PERCOLATES": "PERCOLATE, to pass through pores, small openings, etc.; to filter [v]\n",
  "PERCOLATING": "PERCOLATE, to pass through pores, small openings, etc.; to filter [v]\n",
  "PERCOLATION": "the act of percolating [n -S]\n",
  "PERCOLATIONS": "PERCOLATION, the act of percolating [n]\n",
  "PERCOLATIVE": "relating to percolation [adj]\n",
  "PERCOLATOR": "one that percolates [n -S]\n",
  "PERCOLATORS": "PERCOLATOR, one that percolates [n]\n",
  "PERCOLIN": "a small bird, a cross between a partridge and a quail [n -S]\n",
  "PERCOLINS": "PERCOLIN, a small bird, a cross between a partridge and a quail [n]\n",
  "PERCS": "PERC, (short for) perchloride, a chemical used in dry cleaning [n]\n",
  "PERCURRENT": "extending the whole length (of a leaf) [adj]\n",
  "PERCURSORY": "cursory [adj]\n",
  "PERCUSS": "to strike with force [v -ED, -ING, -ES]\n",
  "PERCUSSANT": "bent round and striking the side e.g. a lion's tail [adj]\n",
  "PERCUSSED": "PERCUSS, to strike with force [v]\n",
  "PERCUSSES": "PERCUSS, to strike with force [v]\n",
  "PERCUSSING": "PERCUSS, to strike with force [v]\n",
  "PERCUSSION": "the act of striking; musical instruments as drums, etc., sounded by being struck [n -S]\n",
  "PERCUSSIONAL": "relating to percussion [adj]\n",
  "PERCUSSIONIST": "one who plays one or more percussion instrument [n -S]\n",
  "PERCUSSIONISTS": "PERCUSSIONIST, one who plays one or more percussion instrument [n]\n",
  "PERCUSSIONS": "PERCUSSION, the act of striking; musical instruments as drums, etc., sounded by being struck [n]\n",
  "PERCUSSIVE": "of or relating to percussion [adj PERCUSSIVELY]\n",
  "PERCUSSIVELY": "PERCUSSIVE, of or relating to percussion [adv]\n",
  "PERCUSSIVENESS": "the state of being percussive [n]\n",
  "PERCUSSOR": "a percussion hammer [n -S]\n",
  "PERCUSSORS": "PERCUSSOR, a percussion hammer [n]\n",
  "PERCUTANEOUS": "done or applied through the skin [adj PERCUTANEOUSLY]\n",
  "PERCUTANEOUSLY": "PERCUTANEOUS, done or applied through the skin [adv]\n",
  "PERCUTIENT": "something that strikes or has the power to strike [n -S]\n",
  "PERCUTIENTS": "PERCUTIENT, something that strikes or has the power to strike [n]\n",
  "PERDENDO": "(Italian) slowing and softening at the same time, also PERDENDOSI [adv]\n",
  "PERDENDOSI": "(Italian) slowing and softening at the same time, also PERDENDO [adv]\n",
  "PERDIE": "(Shakespeare) assuredly, by God, also PARDEE, PARDI, PARDIE, PARDY, PERDY [interj]\n",
  "PERDITION": "everlasting misery after death, damnation [n -S]\n",
  "PERDITIONABLE": "worthy of perdition [adj]\n",
  "PERDITIONS": "PERDITION, everlasting misery after death, damnation [n]\n",
  "PERDU": "(Shakespeare) a soldier sent on a dangerous mission, also PERDUE [n -S]\n",
  "PERDUE": "(Shakespeare) a soldier sent on a dangerous mission, also PERDU [n -S]\n",
  "PERDUELLION": "(archaic) treason [n -S]\n",
  "PERDUELLIONS": "PERDUELLION, (archaic) treason [n]\n",
  "PERDUES": "PERDUE, (Shakespeare) a soldier sent on a dangerous mission, also PERDU [n]\n",
  "PERDURABILITIES": "PERDURABILITY, the state of being perdurable [n]\n",
  "PERDURABILITY": "the state of being perdurable [n PERDURABILITIES]\n",
  "PERDURABLE": "extremely durable, permanent [adj PERDURABLY]\n",
  "PERDURABLY": "PERDURABLE, extremely durable, permanent [adv]\n",
  "PERDURANCE": "lastingness, endurance, also PERDURATION [n -S]\n",
  "PERDURANCES": "PERDURANCE, lastingness, endurance, also PERDURATION [n]\n",
  "PERDURATION": "lastingness, endurance, also PERDURANCE [n -S]\n",
  "PERDURATIONS": "PERDURATION, lastingness, endurance, also PERDURANCE [n]\n",
  "PERDURE": "to continue to exist [v PERDURED, PERDURING, PERDURES]\n",
  "PERDURED": "PERDURE, to continue to exist [v]\n",
  "PERDURES": "PERDURE, to continue to exist [v]\n",
  "PERDURING": "PERDURE, to continue to exist [v]\n",
  "PERDUS": "PERDU, (Shakespeare) a soldier sent on a dangerous mission, also PERDUE [n]\n",
  "PERDY": "(Shakespeare) assuredly, by God, also PARDEE, PARDI, PARDIE, PARDY, PERDIE [interj]\n",
  "PERE": "(French) father [n -S]\n",
  "PEREA": "PEREON, a crustacean's thorax, also PEREION, PERAEON [n]\n",
  "PEREGAL": "(obsolete) an equal [n -S]\n",
  "PEREGALS": "PEREGAL, (obsolete) an equal [n]\n",
  "PEREGRIN": "a swift falcon much used in falconry, also PEREGRINE [n -S]\n",
  "PEREGRINATE": "to wander through [v PEREGRINATED, PEREGRINATING, PEREGRINATES]\n",
  "PEREGRINATED": "PEREGRINATE, to wander through [v]\n",
  "PEREGRINATES": "PEREGRINATE, to wander through [v]\n",
  "PEREGRINATING": "PEREGRINATE, to wander through [v]\n",
  "PEREGRINATION": "an excursion esp. on foot or to a foreign country [n -S]\n",
  "PEREGRINATIONS": "PEREGRINATION, an excursion esp. on foot or to a foreign country [n]\n",
  "PEREGRINATOR": "someone who travels about [n -S]\n",
  "PEREGRINATORS": "PEREGRINATOR, someone who travels about [n]\n",
  "PEREGRINATORY": "of or relating to a peregrinator; wandering [adj]\n",
  "PEREGRINE": "a swift falcon much used in falconry, also PEREGRIN [n -S]\n",
  "PEREGRINES": "PEREGRINE, a swift falcon much used in falconry, also PEREGRIN [n]\n",
  "PEREGRINITIES": "PEREGRINITY, foreignness, outlandishness [n]\n",
  "PEREGRINITY": "foreignness, outlandishness [n PEREGRINITIES]\n",
  "PEREGRINS": "PEREGRIN, a swift falcon much used in falconry, also PEREGRINE [n]\n",
  "PEREIA": "PEREION, (Greek) a crustacean's thorax, also PERAEON, PEREON [n]\n",
  "PEREION": "(Greek) a crustacean's thorax, also PERAEON, PEREON [n PEREIONS or PEREIA]\n",
  "PEREIONS": "PEREION, (Greek) a crustacean's thorax, also PERAEON, PEREON [n]\n",
  "PEREIOPOD": "each of the eight walking limbs of a crustacean such as a crab or lobster, growing from the thorax, also PERAEOPOD, PEREOPOD [n -S]\n",
  "PEREIOPODS": "PEREIOPOD, each of the eight walking limbs of a crustacean such as a crab or lobster, growing from the thorax, also PERAEOPOD, PEREOPOD [n]\n",
  "PEREIRA": "a Brazilian tree, the bark of which is used medicinally [n -S]\n",
  "PEREIRAS": "PEREIRA, a Brazilian tree, the bark of which is used medicinally [n]\n",
  "PEREMPTORILY": "PEREMPTORY, putting an end to or precluding a right of action, debate, or delay [adv]\n",
  "PEREMPTORINESS": "the state of being peremptory [n]\n",
  "PEREMPTORY": "putting an end to or precluding a right of action, debate, or delay [adj PEREMPTORILY]\n",
  "PERENNATE": "to last or live through a number of years, as a perennial plant [v PERENNATED, PERENNATING, PERENNATES]\n",
  "PERENNATED": "PERENNATE, to last or live through a number of years, as a perennial plant [v]\n",
  "PERENNATES": "PERENNATE, to last or live through a number of years, as a perennial plant [v]\n",
  "PERENNATING": "PERENNATE, to last or live through a number of years, as a perennial plant [v]\n",
  "PERENNATION": "the act of perennating, living perennially [n -S]\n",
  "PERENNATIONS": "PERENNATION, the act of perennating, living perennially [n]\n",
  "PERENNIAL": "lasting for many years [adj PERENNIALLY] / a plant that lives more than two years [n -S]\n",
  "PERENNIALITIES": "PERENNIALITY, the state of being perennial [n]\n",
  "PERENNIALITY": "the state of being perennial [n PERENNIALITIES]\n",
  "PERENNIALLY": "PERENNIAL, lasting for many years [adv]\n",
  "PERENNIALS": "PERENNIAL, a plant that lives more than two years [n]\n",
  "PERENNIBRANCH": "a creature that retains the gills throughout life [n -S]\n",
  "PERENNIBRANCHS": "PERENNIBRANCH, a creature that retains the gills throughout life [n]\n",
  "PERENNITIES": "PERENNITY, the quality of being perennial [n]\n",
  "PERENNITY": "the quality of being perennial [n PERENNITIES]\n",
  "PERENTIE": "(Native Australian) a large Australian monitor lizard, also PERENTY [n -S]\n",
  "PERENTIES": "PERENTY, (Native Australian) a large Australian monitor lizard, also PERENTIE [n]\n",
  "PERENTY": "(Native Australian) a large Australian monitor lizard, also PERENTIE [n PERENTIES]\n",
  "PEREON": "a crustacean's thorax, also PEREION, PERAEON [n PEREONS or PEREA]\n",
  "PEREONS": "PEREON, a crustacean's thorax, also PEREION, PERAEON [n]\n",
  "PEREOPOD": "an appendage of the pereion [n -S]\n",
  "PEREOPODS": "PEREOPOD, an appendage of the pereion [n]\n",
  "PERES": "PERE, (French) father [n]\n",
  "PERESTROIKA": "(Russian) the period of reconstruction in Russia under Mikhail Gorbachev [n -S]\n",
  "PERESTROIKAS": "PERESTROIKA, (Russian) the period of reconstruction in Russia under Mikhail Gorbachev [n]\n",
  "PERFAY": "(archaic) by my faith [interj]\n",
  "PERFECT": "lacking in fault or defect [adj PERFECTER, PERFECTEST, PERFECTLY] / to make faultless [v -ED, -ING, -S]\n",
  "PERFECTA": "(Spanish) a form of bet in which the punter has to select and place in order the first two horses, dogs etc [n -S]\n",
  "PERFECTAS": "PERFECTA, (Spanish) a form of bet in which the punter has to select and place in order the first two horses, dogs etc [n]\n",
  "PERFECTATION": "making perfect [n -S]\n",
  "PERFECTATIONS": "PERFECTATION, making perfect [n]\n",
  "PERFECTED": "PERFECT, to make faultless [v]\n",
  "PERFECTER": "a person who or thing which perfects something [n -S]\n",
  "PERFECTERS": "PERFECTER, a person who or thing which perfects something [n]\n",
  "PERFECTEST": "PERFECT, lacking in fault or defect [adj]\n",
  "PERFECTI": "a Catharist sect in the 12th and 13th centuries who led very strict lives [n]\n",
  "PERFECTIBILIAN": "a believer in the perfectibility of mankind, also PERFECTIBILIST [n -S]\n",
  "PERFECTIBILIANS": "PERFECTIBILIAN, a believer in the perfectibility of mankind, also PERFECTIBILIST [n]\n",
  "PERFECTIBILISM": "the doctrine that humans capable of becoming perfect [n -S]\n",
  "PERFECTIBILISMS": "PERFECTIBILISM, the doctrine that humans capable of becoming perfect [n]\n",
  "PERFECTIBILIST": "a believer in the perfectibility of mankind, also PERFECTIBILIAN [n -S]\n",
  "PERFECTIBILISTS": "PERFECTIBILIST, a believer in the perfectibility of mankind, also PERFECTIBILIAN [n]\n",
  "PERFECTIBILITY": "the state of being perfectible [n]\n",
  "PERFECTIBLE": "capable of improvement or perfection (as in moral state) [adj]\n",
  "PERFECTING": "PERFECT, to make faultless [v]\n",
  "PERFECTION": "freedom from fault or defect [n -S]\n",
  "PERFECTIONATE": "to bring to perfection [v PERFECTIONATED, PERFECTIONATING, PERFECTIONATES]\n",
  "PERFECTIONATED": "PERFECTIONATE, to bring to perfection [v]\n",
  "PERFECTIONATES": "PERFECTIONATE, to bring to perfection [v]\n",
  "PERFECTIONATING": "PERFECTIONATE, to bring to perfection [v]\n",
  "PERFECTIONISM": "the doctrine that moral perfection constitutes the highest value [n -S]\n",
  "PERFECTIONISMS": "PERFECTIONISM, the doctrine that moral perfection constitutes the highest value [n]\n",
  "PERFECTIONIST": "one who aspires to the perfect [n -S]\n",
  "PERFECTIONISTIC": "relating to perfectionism [adj]\n",
  "PERFECTIONISTS": "PERFECTIONIST, one who aspires to the perfect [n]\n",
  "PERFECTIONS": "PERFECTION, freedom from fault or defect [n]\n",
  "PERFECTIVE": "tending to make perfect [adj PERFECTIVELY] / a verb aspect denoting completed action [n -S]\n",
  "PERFECTIVELY": "PERFECTIVE, tending to make perfect [adv]\n",
  "PERFECTIVENESS": "PERFECTIVE, tending to make perfect [n]\n",
  "PERFECTIVES": "PERFECTIVE, a verb aspect denoting completed action [n]\n",
  "PERFECTIVITIES": "PERFECTIVITY, the state of being perfective [n]\n",
  "PERFECTIVITY": "the state of being perfective [n PERFECTIVITIES]\n",
  "PERFECTLY": "PERFECT, lacking in fault or defect [adv]\n",
  "PERFECTNESS": "the state of being perfect [n -ES]\n",
  "PERFECTNESSES": "PERFECTNESS, the state of being perfect [n]\n",
  "PERFECTO": "(Spanish) a large tapering cigar [n -S]\n",
  "PERFECTOR": "a machine for perfecting, printing both sides at once [n -S]\n",
  "PERFECTORS": "PERFECTOR, a machine for perfecting, printing both sides at once [n]\n",
  "PERFECTOS": "PERFECTO, (Spanish) a large tapering cigar [n]\n",
  "PERFECTS": "PERFECT, to make faultless [v]\n",
  "PERFERVID": "extremely or excessively passionate [adj PERFERVIDLY]\n",
  "PERFERVIDITIES": "PERFERVIDITY, the state of being perfervid, also PERFERVIDNESS [n]\n",
  "PERFERVIDITY": "the state of being perfervid, also PERFERVIDNESS [n PERFERVIDITIES]\n",
  "PERFERVIDLY": "PERFERVID, extremely or excessively passionate [adv]\n",
  "PERFERVIDNESS": "the state of being perfervid, also PERFERVIDITY [n -ES]\n",
  "PERFERVIDNESSES": "PERFERVIDNESS, the state of being perfervid, also PERFERVIDITY [n]\n",
  "PERFERVOR": "a state of great fervour, also PERFERVOUR [n -S]\n",
  "PERFERVORS": "PERFERVOR, a state of great fervour, also PERFERVOUR [n]\n",
  "PERFERVOUR": "great fervour, ardour, also PERFERVOR [n -S]\n",
  "PERFERVOURS": "PERFERVOUR, great fervour, ardour, also PERFERVOR [n]\n",
  "PERFET": "(Milton) perfect [adj]\n",
  "PERFICIENT": "someone who or something that accomplishes or completes a task, etc. [n -S]\n",
  "PERFICIENTS": "PERFICIENT, someone who or something that accomplishes or completes a task, etc. [n]\n",
  "PERFIDIES": "PERFIDY, deliberate breach of faith or trust [n]\n",
  "PERFIDIOUS": "characterized by faithlessness or disloyalty [adj PERFIDIOUSLY]\n",
  "PERFIDIOUSLY": "PERFIDIOUS, characterized by faithlessness or disloyalty [adv]\n",
  "PERFIDIOUSNESS": "the state of being perfidious [n]\n",
  "PERFIDY": "deliberate breach of faith or trust [n PERFIDIES]\n",
  "PERFIN": "a postage stamp perforated to identify theft by employees, also SPIF [n -S]\n",
  "PERFING": "(New Zealand) the practice of taking early retirement, with financial compensation, from the police force [n -S]\n",
  "PERFINGS": "PERFING, (New Zealand) the practice of taking early retirement, with financial compensation, from the police force [n]\n",
  "PERFINS": "PERFIN, a postage stamp perforated to identify theft by employees, also SPIF [n]\n",
  "PERFLUOROCARBON": "an organic compound in which much of the hydrogen has been replaced by fluorine [n]\n",
  "PERFOLIATE": "of a leaf or bract, completely encircling the axis and so the stem apparently passing through it [adj]\n",
  "PERFOLIATION": "the state of being perfoliate [n -S]\n",
  "PERFOLIATIONS": "PERFOLIATION, the state of being perfoliate [n]\n",
  "PERFORABLE": "that can be perforated [adj]\n",
  "PERFORANS": "the long flexor muscle of the toes [n -ES]\n",
  "PERFORANSES": "PERFORANS, the long flexor muscle of the toes [n]\n",
  "PERFORANT": "perforating [adj]\n",
  "PERFORATE": "to bore through or into [v PERFORATED, PERFORATING, PERFORATES]\n",
  "PERFORATED": "PERFORATE, to bore through or into [v]\n",
  "PERFORATES": "PERFORATE, to bore through or into [v]\n",
  "PERFORATING": "PERFORATE, to bore through or into [v]\n",
  "PERFORATION": "the act of perforating [n -S]\n",
  "PERFORATIONS": "PERFORATION, the act of perforating [n]\n",
  "PERFORATIVE": "causing perforation, also PERFORATORY [adj]\n",
  "PERFORATOR": "a machine for perforating [n -S]\n",
  "PERFORATORS": "PERFORATOR, a machine for perforating [n]\n",
  "PERFORATORY": "causing perforation, also PERFORATIVE [adj]\n",
  "PERFORATUS": "the short flexor of the toes or the superficial flexor of the finger [n -ES]\n",
  "PERFORATUSES": "PERFORATUS, the short flexor of the toes or the superficial flexor of the finger [n]\n",
  "PERFORCE": "of necessity [adv]\n",
  "PERFORM": "to begin and carry through to completion [v -ED, -ING, -S]\n",
  "PERFORMABILITY": "the state of being performable [n]\n",
  "PERFORMABLE": "that can be performed [adj]\n",
  "PERFORMANCE": "the execution of an action [n -S]\n",
  "PERFORMANCES": "PERFORMANCE, the execution of an action [n]\n",
  "PERFORMATIVE": "of a statement or verb that itself constitutes the action described, e.g. I confess my ignorance, also PERFORMATORY [adj PERFORMATIVELY] / such a statement, as opposed to constative [n -S]\n",
  "PERFORMATIVELY": "PERFORMATIVE, of a statement or verb that itself constitutes the action described, e.g. I confess my ignorance, also PERFORMATORY [adv]\n",
  "PERFORMATIVES": "PERFORMATIVE, such a statement, as opposed to constative [n]\n",
  "PERFORMATORY": "of a statement or verb that itself constitutes the action described, also PERFORMATIVE [adj]\n",
  "PERFORMED": "PERFORM, to begin and carry through to completion [v]\n",
  "PERFORMER": "one who performs [n -S]\n",
  "PERFORMERS": "PERFORMER, one who performs [n]\n",
  "PERFORMING": "the act of doing something [n -S]\n",
  "PERFORMINGS": "PERFORMING, the act of doing something [n]\n",
  "PERFORMS": "PERFORM, to begin and carry through to completion [v]\n",
  "PERFUME": "to fill with a fragrant odour [v PERFUMED, PERFUMING, PERFUMES]\n",
  "PERFUMED": "PERFUME, to fill with a fragrant odour [v]\n",
  "PERFUMELESS": "without perfume [adj]\n",
  "PERFUMER": "one who prepares perfumes, also PERFUMIER [n -S]\n",
  "PERFUMERIES": "PERFUMERY, a place where perfumes are made [n]\n",
  "PERFUMERS": "PERFUMER, one who prepares perfumes, also PERFUMIER [n]\n",
  "PERFUMERY": "a place where perfumes are made [n PERFUMERIES]\n",
  "PERFUMES": "PERFUME, to fill with a fragrant odour [v]\n",
  "PERFUMIER": "one who prepares perfumes, also PERFUMER [n -S]\n",
  "PERFUMIERS": "PERFUMIER, one who prepares perfumes, also PERFUMER [n]\n",
  "PERFUMIEST": "PERFUMY, like or full of perfume [adj]\n",
  "PERFUMING": "PERFUME, to fill with a fragrant odour [v]\n",
  "PERFUMY": "like or full of perfume [adj PERFUMIER, PERFUMIEST]\n",
  "PERFUNCTORILY": "PERFUNCTORY, characterized by routine or superficiality, mechanical [adv]\n",
  "PERFUNCTORINESS": "the state of being perfunctory [n]\n",
  "PERFUNCTORY": "characterized by routine or superficiality, mechanical [adj]\n",
  "PERFUSATE": "that which is perfused [n -S]\n",
  "PERFUSATES": "PERFUSATE, that which is perfused [n]\n",
  "PERFUSE": "to diffuse through or over [v PERFUSED, PERFUSING, PERFUSES]\n",
  "PERFUSED": "PERFUSE, to diffuse through or over [v]\n",
  "PERFUSES": "PERFUSE, to diffuse through or over [v]\n",
  "PERFUSING": "PERFUSE, to diffuse through or over [v]\n",
  "PERFUSION": "the act of perfusing [n -S]\n",
  "PERFUSIONIST": "the member of a surgical team administering continuous blood transfusion [n -S]\n",
  "PERFUSIONISTS": "PERFUSIONIST, the member of a surgical team administering continuous blood transfusion [n]\n",
  "PERFUSIONS": "PERFUSION, the act of perfusing [n]\n",
  "PERFUSIVE": "of a nature to flow over, or to spread through [adj]\n",
  "PERGAMENEOUS": "parchment-like, also PERGAMENTACEOUS [adj]\n",
  "PERGAMENTACEOUS": "parchment-like, also PERGAMENEOUS [adj]\n",
  "PERGOLA": "(Italian) an arbor formed of columns supporting trelliswork on which climbing plants are often trained [n -S]\n",
  "PERGOLAS": "PERGOLA, (Italian) an arbor formed of columns supporting trelliswork on which climbing plants are often trained [n]\n",
  "PERGUNNAH": "(Hindi) a division of an administrative district or zillah in India, also PARGANA [n -S]\n",
  "PERGUNNAHS": "PERGUNNAH, (Hindi) a division of an administrative district or zillah in India, also PARGANA [n]\n",
  "PERHAPS": "something open to doubt [n -ES]\n",
  "PERHAPSES": "PERHAPS, something open to doubt [n]\n",
  "PERI": "(Persian) a supernatural being of Persian mythology [n -S]\n",
  "PERIAGUA": "(Caribbean) a type of dugout canoe, also PIRAGUA, PIROGUE, PIROQUE [n -S]\n",
  "PERIAGUAS": "PERIAGUA, (Caribbean) a type of dugout canoe, also PIRAGUA, PIROGUE, PIROQUE [n]\n",
  "PERIAKTOI": "PERIAKTOS, (Greek) in the ancient Greek theatre, a tall revolving prism at the side of the stage, projecting a variety of backdrops [n]\n",
  "PERIAKTOS": "(Greek) in the ancient Greek theatre, a tall revolving prism at the side of the stage, projecting a variety of backdrops [n PERIAKTOI]\n",
  "PERIANTH": "an outer covering of a flower [n -S]\n",
  "PERIANTHS": "PERIANTH, an outer covering of a flower [n]\n",
  "PERIAPSES": "PERIAPSIS, the closest point to a central body reached by a body in orbit [n]\n",
  "PERIAPSIS": "the closest point to a central body reached by a body in orbit [n PERIAPSES]\n",
  "PERIAPT": "(Shakespeare) an amulet [n -S]\n",
  "PERIAPTS": "PERIAPT, (Shakespeare) an amulet [n]\n",
  "PERIASTRON": "that point, in the real or apparent orbit of one star revolving around another, at which the former is nearest to the latter [n -S]\n",
  "PERIASTRONS": "PERIASTRON, that point, in the real or apparent orbit of one star revolving around another, at which the former is nearest to the latter [n]\n",
  "PERIBLAST": "in meroblastic eggs, the margin of the blastoderm merging with the surrounding yolk [n -S]\n",
  "PERIBLASTS": "PERIBLAST, in meroblastic eggs, the margin of the blastoderm merging with the surrounding yolk [n]\n",
  "PERIBLEM": "a region of plant tissue [n -S]\n",
  "PERIBLEMS": "PERIBLEM, a region of plant tissue [n]\n",
  "PERIBOLI": "PERIBOLUS, a precinct; an enclosing wall of a precinct, also PERIBOLOS [n]\n",
  "PERIBOLOI": "PERIBOLOS, (Greek) a precinct; an enclosing wall of a precinct, also PERIBOLUS [n]\n",
  "PERIBOLOS": "(Greek) a precinct; an enclosing wall of a precinct, also PERIBOLUS [n PERIBOLOI]\n",
  "PERIBOLUS": "a precinct; an enclosing wall of a precinct, also PERIBOLOS [n PERIBOLI]\n",
  "PERICARDIA": "PERICARDIUM, a membranous sac containing the heart [n]\n",
  "PERICARDIAC": "relating to the pericardium, a membranous sac containing the heart, also PERICARDIAL, PERICARDIAN [adj]\n",
  "PERICARDIAL": "relating to the pericardium, a membranous sac containing the heart, also PERICARDIAC, PERICARDIAN [adj]\n",
  "PERICARDIAN": "relating to the pericardium, a membranous sac containing the heart, also PERICARDIAC, PERICARDIAL [adj]\n",
  "PERICARDITIC": "relating to pericarditis [adj]\n",
  "PERICARDITIDES": "PERICARDITIS, inflammation of the pericardium, the outer lining of the heart [n]\n",
  "PERICARDITIS": "inflammation of the pericardium, the outer lining of the heart [n PERICARDITIDES or PERICARDITISES]\n",
  "PERICARDITISES": "PERICARDITIS, inflammation of the pericardium, the outer lining of the heart [n]\n",
  "PERICARDIUM": "a membranous sac containing the heart [n PERICARDIA]\n",
  "PERICARDIUMS": "PERICARDIUM, a membranous sac containing the heart [n]\n",
  "PERICARP": "the wall of a ripened plant ovary or fruit [n -S]\n",
  "PERICARPIAL": "relating to the pericarp, also PERICARPIC [adj]\n",
  "PERICARPIC": "relating to the pericarp, also PERICARPIAL [adj]\n",
  "PERICARPS": "PERICARP, the wall of a ripened plant ovary or fruit [n]\n",
  "PERICENTER": "the point in the path of a body revolving round a centre at which it is nearest to the centre, also PERICENTRE [n -S]\n",
  "PERICENTERS": "PERICENTER, the point in the path of a body revolving round a centre at which it is nearest to the centre, also PERICENTRE [n]\n",
  "PERICENTRAL": "surrounding a centre or central body, also PERICENTRIC [adj]\n",
  "PERICENTRE": "the point in the path of a body revolving round a centre at which it is nearest to the centre, also PERICENTER [n -S]\n",
  "PERICENTRES": "PERICENTRE, the point in the path of a body revolving round a centre at which it is nearest to the centre, also PERICENTER [n]\n",
  "PERICENTRIC": "surrounding a centre or central body, also PERICENTRAL [adj]\n",
  "PERICHAETIA": "PERICHAETIUM, a sheath or cluster of leaves around the archegonia in mosses and liverworts [n]\n",
  "PERICHAETIAL": "relating to the perichaetium, a sheath or cluster of leaves around the archegonia in mosses and liverworts [adj]\n",
  "PERICHAETIUM": "a sheath or cluster of leaves around the archegonia in mosses and liverworts [n PERICHAETIA]\n",
  "PERICHONDRAL": "of or like a perichondrium [adj]\n",
  "PERICHONDRIA": "PERICHONDRIUM, a fibrous membrane covering cartilage except at joints [n]\n",
  "PERICHONDRIAL": "relating to the perichondrium, a fibrous membrane covering cartilage except at joints [adj]\n",
  "PERICHONDRIUM": "a fibrous membrane covering cartilage except at joints [n PERICHONDRIA]\n",
  "PERICHORESES": "PERICHORESIS, the reciprocity of existence in one another of the three persons of the Trinity [n]\n",
  "PERICHORESIS": "the reciprocity of existence in one another of the three persons of the Trinity [n PERICHORESES]\n",
  "PERICHYLOUS": "of a plant, having water-storing tissue outside the green tissue [adj]\n",
  "PERICLASE": "a naturally occurring magnesium oxide [n -S]\n",
  "PERICLASES": "PERICLASE, a naturally occurring magnesium oxide [n]\n",
  "PERICLASTIC": "like a periclase, a naturally occurring magnesium oxide [adj]\n",
  "PERICLINAL": "sloping downwards in all directions from a point [adj]\n",
  "PERICLINE": "a variety of albite occurring as large elongated white crystals [n -S]\n",
  "PERICLINES": "PERICLINE, a variety of albite occurring as large elongated white crystals [n]\n",
  "PERICLITATE": "(archaic) to endanger; to jeopardise [v PERICLITATED, PERICLITATING, PERICLITATES]\n",
  "PERICLITATED": "PERICLITATE, (archaic) to endanger; to jeopardise [v]\n",
  "PERICLITATES": "PERICLITATE, (archaic) to endanger; to jeopardise [v]\n",
  "PERICLITATING": "PERICLITATE, (archaic) to endanger; to jeopardise [v]\n",
  "PERICON": "(Spanish) an Argentinan folk-dance performed by couples dancing in a ring [n -ES]\n",
  "PERICONES": "PERICON, (Spanish) an Argentinan folk-dance performed by couples dancing in a ring [n]\n",
  "PERICOPAE": "PERICOPE, a section from a book [n]\n",
  "PERICOPAL": "relating to a pericope, an excerpt or passage read during religious services, also PERICOPIC [adj]\n",
  "PERICOPE": "a section from a book [n PERICOPES or PERICOPAE]\n",
  "PERICOPES": "PERICOPE, a section from a book [n]\n",
  "PERICOPIC": "relating to a pericope, an excerpt or passage read during religious services, also PERICOPAL [adj]\n",
  "PERICRANIA": "PERICRANIUM, a membrane covering the skull [n]\n",
  "PERICRANIAL": "relating to the pericranium, a membrane covering skull [adj]\n",
  "PERICRANIUM": "a membrane covering the skull [n -S]\n",
  "PERICRANIUMS": "PERICRANIUM, a membrane covering the skull [n]\n",
  "PERICULOUS": "(obsolete) dangerous, also PARLOUS, PERILOUS, PERLOUS [adj]\n",
  "PERICYCLE": "the outermost layer or layers of the central cylinder [n -S]\n",
  "PERICYCLES": "PERICYCLE, the outermost layer or layers of the central cylinder [n]\n",
  "PERICYCLIC": "relating to the pericycle, the outermost layer or layers of the central cylinder [adj]\n",
  "PERICYNTHIA": "PERICYNTHION, the point at which a spacecraft in lunar orbit is nearest to the moon [n]\n",
  "PERICYNTHION": "the point at which a spacecraft in lunar orbit is nearest to the moon [n PERICYNTHIA or PERICYNTHIONS]\n",
  "PERICYNTHIONS": "PERICYNTHION, the point at which a spacecraft in lunar orbit is nearest to the moon [n]\n",
  "PERIDERM": "an outer layer of plant tissue [n -S]\n",
  "PERIDERMAL": "relating to the periderm, the outer layer of bark, also PERIDERMIC [adj]\n",
  "PERIDERMIC": "relating to the periderm, the outer layer of bark, also PERIDERMAL [adj]\n",
  "PERIDERMS": "PERIDERM, an outer layer of plant tissue [n]\n",
  "PERIDESMIA": "PERIDESMIUM, the areolar tissue around a ligament [n]\n",
  "PERIDESMIUM": "the areolar tissue around a ligament [n PERIDESMIA]\n",
  "PERIDIA": "PERIDIUM, the outer coating of the spore carrier of a fungus [n]\n",
  "PERIDIAL": "relating to a peridium, the envelope or coat of certain fungi [adj]\n",
  "PERIDINIA": "PERIDINIUM, a dinoflagellate, a kind of marine protozoan, also PERIDINIAN [n]\n",
  "PERIDINIAN": "a dinoflagellate, a kind of marine protozoan, also PERIDINIUM [n -S]\n",
  "PERIDINIANS": "PERIDINIAN, a dinoflagellate, a kind of marine protozoan, also PERIDINIUM [n]\n",
  "PERIDINIUM": "a dinoflagellate, a kind of marine protozoan, also PERIDINIAN [n PERIDINIA or PERIDINIUMS]\n",
  "PERIDINIUMS": "PERIDINIUM, a dinoflagellate, a kind of marine protozoan, also PERIDINIAN [n]\n",
  "PERIDIUM": "the outer coating of the spore carrier of a fungus [n PERIDIUMS or PERIDIA]\n",
  "PERIDIUMS": "PERIDIUM, the outer coating of the spore carrier of a fungus [n]\n",
  "PERIDOT": "(French) a gemstone, a pale green variety of olivine, also PERIDOTE [n -S]\n",
  "PERIDOTE": "(French) a gemstone, a pale green variety of olivine, also PERIDOT [n -S]\n",
  "PERIDOTES": "PERIDOTE, (French) a gemstone, a pale green variety of olivine, also PERIDOT [n]\n",
  "PERIDOTIC": "relating to peridot [adj]\n",
  "PERIDOTITE": "an ultramafic igneous rock, the major constituent of the mantle [n -S]\n",
  "PERIDOTITES": "PERIDOTITE, an ultramafic igneous rock, the major constituent of the mantle [n]\n",
  "PERIDOTITIC": "of or like peridotite [adj]\n",
  "PERIDOTS": "PERIDOT, (French) a gemstone, a pale green variety of olivine, also PERIDOTE [n]\n",
  "PERIDROME": "a gallery or balcony that ran round all four sides of a classical building [n -S]\n",
  "PERIDROMES": "PERIDROME, a gallery or balcony that ran round all four sides of a classical building [n]\n",
  "PERIEGESES": "PERIEGESIS, a description in the manner of a tour; a journey through [n]\n",
  "PERIEGESIS": "a description in the manner of a tour; a journey through [n PERIEGESES]\n",
  "PERIGASTRIC": "surrounding the alimentary canal [adj]\n",
  "PERIGASTRITIS": "inflammation of the outer surface of the stomach [n -ES]\n",
  "PERIGASTRITISES": "PERIGASTRITIS, inflammation of the outer surface of the stomach [n]\n",
  "PERIGEAL": "relating to a perigee, the point of the moon's orbit at which it is nearest the earth, also PERIGEAN [adj]\n",
  "PERIGEAN": "relating to a perigee, the point of the moon's orbit at which it is nearest the earth, also PERIGEAL [adj]\n",
  "PERIGEE": "(Greek) the point at which a celestial body is nearest to earth [n -S]\n",
  "PERIGEES": "PERIGEE, (Greek) the point at which a celestial body is nearest to earth [n]\n",
  "PERIGENESES": "PERIGENESIS, reproduction (according to the theory of Ernst Haeckel) by transmission not only of chemical material but of vibrations of plastidules [n]\n",
  "PERIGENESIS": "reproduction (according to the theory of Ernst Haeckel) by transmission not only of chemical material but of vibrations of plastidules [n PERIGENESES]\n",
  "PERIGLACIAL": "bordering a glacier [adj]\n",
  "PERIGON": "(Greek) an angle equal to 360 degrees [n -S]\n",
  "PERIGONE": "any organ inclosing the essential organs of a flower, also PERIGONIUM [n -S]\n",
  "PERIGONES": "PERIGONE, any organ inclosing the essential organs of a flower, also PERIGONIUM [n]\n",
  "PERIGONIA": "PERIGONIUM, any organ inclosing the essential organs of a flower, also PERIGONE [n]\n",
  "PERIGONIAL": "of or like a perigone, an organ inclosing the essential organs of a flower; a perianth [adj]\n",
  "PERIGONIUM": "any organ inclosing the essential organs of a flower, also PERIGONE [n PERIGONIA]\n",
  "PERIGONS": "PERIGON, (Greek) an angle equal to 360 degrees [n]\n",
  "PERIGYNIES": "PERIGYNY, a receptacle developed as an open cup [n]\n",
  "PERIGYNOUS": "of a flower, having the perianth and stamens inserted on a flat or cup-shaped structure which arises below, and is not fused to, the ovary [adj]\n",
  "PERIGYNY": "a receptacle developed as an open cup [n PERIGYNIES]\n",
  "PERIHELIA": "PERIHELION, the point of the orbit of a planet or a comet at which it is nearest to the sun, as opposed to aphelion [n]\n",
  "PERIHELIAL": "relating to the perihelion [adj]\n",
  "PERIHELION": "the point of the orbit of a planet or a comet at which it is nearest to the sun, as opposed to aphelion [n PERIHELIA]\n",
  "PERIHEPATIC": "surrounding the liver [adj]\n",
  "PERIHEPATITIS": "inflammation of the peritoneum covering the liver [n -ES]\n",
  "PERIHEPATITISES": "PERIHEPATITIS, inflammation of the peritoneum covering the liver [n]\n",
  "PERIKARYA": "PERIKARYON, the cell body of a neuron containing the nucleus [n]\n",
  "PERIKARYAL": "relating to the perikaryon, the cell body of a neuron containing the nucleus [adj]\n",
  "PERIKARYON": "the cell body of a neuron containing the nucleus [n PERIKARYA]\n",
  "PERIL": "to put in danger, also IMPERIL [v PERILLED or PERILED, PERILLING or PERILING, PERILS]\n",
  "PERILED": "PERIL, to put in danger, also IMPERIL [v]\n",
  "PERILING": "PERIL, to put in danger, also IMPERIL [v]\n",
  "PERILLA": "(Latin) a genus of labiate herbs, of which one species is often cultivated for its purple or variegated foliage [n -S]\n",
  "PERILLAS": "PERILLA, (Latin) a genus of labiate herbs, of which one species is often cultivated for its purple or variegated foliage [n]\n",
  "PERILLED": "PERIL, to put in danger, also IMPERIL [v]\n",
  "PERILLING": "PERIL, to put in danger, also IMPERIL [v]\n",
  "PERILOUS": "dangerous, also PARLOUS, PERICULOUS, PERLOUS [adj PERILOUSLY]\n",
  "PERILOUSLY": "PERILOUS, dangerous, also PARLOUS, PERICULOUS, PERLOUS [adv]\n",
  "PERILOUSNESS": "the state of being perilous [n -ES]\n",
  "PERILOUSNESSES": "PERILOUSNESS, the state of being perilous [n]\n",
  "PERILS": "PERIL, to put in danger, also IMPERIL [v]\n",
  "PERILUNE": "the point at which a celestial body is nearest to the moon [n -S]\n",
  "PERILUNES": "PERILUNE, the point at which a celestial body is nearest to the moon [n]\n",
  "PERILYMPH": "the fluid surrounding the membranous labyrinth of the ear [n -S]\n",
  "PERILYMPHS": "PERILYMPH, the fluid surrounding the membranous labyrinth of the ear [n]\n",
  "PERIMENOPAUSAL": "relating to the perimenopause [adj]\n",
  "PERIMENOPAUSE": "the period around the onset of menopause that is often marked by various physical signs (as hot flashes and menstrual irregularity) [n -S]\n",
  "PERIMENOPAUSES": "PERIMENOPAUSE, the period around the onset of menopause that is often marked by various physical signs (as hot flashes and menstrual irregularity) [n]\n",
  "PERIMETER": "the circuit or boundary of any plane figure [n -S]\n",
  "PERIMETERS": "PERIMETER, the circuit or boundary of any plane figure [n]\n",
  "PERIMETRAL": "relating to a perimeter, also PERIMETRIC, PERIMETRICAL [adj]\n",
  "PERIMETRIC": "relating to a perimeter, also PERIMETRAL, PERIMETRICAL [adj PERIMETRICALLY]\n",
  "PERIMETRICAL": "relating to a perimeter, also PERIMETRAL, PERIMETRIC [adj PERIMETRICALLY]\n",
  "PERIMETRICALLY": "PERIMETRICAL, relating to a perimeter, also PERIMETRAL, PERIMETRIC [adv]\n",
  "PERIMETRIES": "PERIMETRY, measurement of the field of vision [n]\n",
  "PERIMETRY": "measurement of the field of vision [n PERIMETRIES]\n",
  "PERIMORPH": "a crystal of one species enclosing one of another species [n -S]\n",
  "PERIMORPHIC": "like a perimorph, also PERIMORPHOUS [adj]\n",
  "PERIMORPHISM": "the state of being a perimorph [n -S]\n",
  "PERIMORPHISMS": "PERIMORPHISM, the state of being a perimorph [n]\n",
  "PERIMORPHOUS": "like a perimorph, also PERIMORPHIC [adj]\n",
  "PERIMORPHS": "PERIMORPH, a crystal of one species enclosing one of another species [n]\n",
  "PERIMYSIA": "PERIMYSIUM, the connective tissue which surrounds and binds together muscle fibres [n]\n",
  "PERIMYSIUM": "the connective tissue which surrounds and binds together muscle fibres [n PERIMYSIA]\n",
  "PERINAEUM": "the lower part of the body between the genital organs and the anus, also PERINEUM [n -S]\n",
  "PERINAEUMS": "PERINAEUM, the lower part of the body between the genital organs and the anus, also PERINEUM [n]\n",
  "PERINATAL": "relating to the period between the seventh month of pregnancy and the first week of a baby's life [adj PERINATALLY]\n",
  "PERINATALLY": "PERINATAL, relating to the period between the seventh month of pregnancy and the first week of a baby's life [adv]\n",
  "PERINEA": "PERINEUM, the lower part of the body between the genital organs and the anus, also PERINAEUM [n]\n",
  "PERINEAL": "relating to a perineum [adj]\n",
  "PERINEPHRIA": "PERINEPHRIUM, the fatty tissue surrounding the kidney [n]\n",
  "PERINEPHRIC": "relating to the perinephrium, the fatty tissue surrounding the kidney [adj]\n",
  "PERINEPHRITIS": "inflammation of the perinephrium [n -ES]\n",
  "PERINEPHRITISES": "PERINEPHRITIS, inflammation of the perinephrium [n]\n",
  "PERINEPHRIUM": "the fatty tissue surrounding the kidney [n PERINEPHRIA]\n",
  "PERINEUM": "the lower part of the body between the genital organs and the anus, also PERINAEUM [n PERINEA or PERINEUMS]\n",
  "PERINEUMS": "PERINEUM, the lower part of the body between the genital organs and the anus, also PERINAEUM [n]\n",
  "PERINEURAL": "relating to the perineurium, connective tissue enclosing a nerve bundle, also PERINEURIAL [adj]\n",
  "PERINEURIA": "PERINEURIUM, the connective tissue forming a sheath around a single bundle of nerve fibres [n]\n",
  "PERINEURIAL": "related to the perineurium, connective tissue enclosing a nerve bundle, also PERINEURAL [adj]\n",
  "PERINEURITIC": "relating to perineuritis, inflammation of the perineurium [adj]\n",
  "PERINEURITIS": "inflammation of the perineurium [n -ES]\n",
  "PERINEURITISES": "PERINEURITIS, inflammation of the perineurium [n]\n",
  "PERINEURIUM": "the connective tissue forming a sheath around a single bundle of nerve fibres [n PERINEURIA]\n",
  "PERIOD": "one of the main divisions of geological time [n -S] / (Shakespeare) to put an end to [v -ED, -ING, -S]\n",
  "PERIODATE": "a salt of periodic acid [n -S]\n",
  "PERIODATES": "PERIODATE, a salt of periodic acid [n]\n",
  "PERIODED": "PERIOD, (Shakespeare) to put an end to [v]\n",
  "PERIODIC": "happening at set intervals [adj PERIODICALLY]\n",
  "PERIODICAL": "periodic [adj PERIODICALLY] / a periodical publication [n -S]\n",
  "PERIODICALIST": "a person who writes in a periodical [n -S]\n",
  "PERIODICALISTS": "PERIODICALIST, a person who writes in a periodical [n]\n",
  "PERIODICALLY": "PERIODICAL, periodic [adv]\n",
  "PERIODICALS": "PERIODICAL, a periodical publication [n]\n",
  "PERIODICITIES": "PERIODICITY, the state of being regularly recurrent or having periods [n]\n",
  "PERIODICITY": "the state of being regularly recurrent or having periods [n PERIODICITIES]\n",
  "PERIODID": "a compound of iodine, also PERIODIDE [n -S]\n",
  "PERIODIDE": "an iodid, a salt of hydriodic acid, also PERIODID [n -S]\n",
  "PERIODIDES": "PERIODIDE, an iodid, a salt of hydriodic acid, also PERIODID [n]\n",
  "PERIODIDS": "PERIODID, a compound of iodine, also PERIODIDE [n]\n",
  "PERIODING": "PERIOD, (Shakespeare) to put an end to [v]\n",
  "PERIODISATION": "division into periods, also PERIODIZATION [n -S]\n",
  "PERIODISATIONS": "PERIODISATION, division into periods, also PERIODIZATION [n]\n",
  "PERIODISE": "to divide into periods, also PERIODIZE [v PERIODISED, PERIODISING, PERIODISES]\n",
  "PERIODISED": "PERIODISE, to divide into periods, also PERIODIZE [v]\n",
  "PERIODISES": "PERIODISE, to divide into periods, also PERIODIZE [v]\n",
  "PERIODISING": "PERIODISE, to divide into periods, also PERIODIZE [v]\n",
  "PERIODIZATION": "division into periods, also PERIODISATION [n -S]\n",
  "PERIODIZATIONS": "PERIODIZATION, division into periods, also PERIODISATION [n]\n",
  "PERIODIZE": "to divide into periods, also PERIODISE [v PERIODIZED, PERIODIZING, PERIODIZES]\n",
  "PERIODIZED": "PERIODIZE, to divide into periods, also PERIODISE [v]\n",
  "PERIODIZES": "PERIODIZE, to divide into periods, also PERIODISE [v]\n",
  "PERIODIZING": "PERIODIZE, to divide into periods, also PERIODISE [v]\n",
  "PERIODONTAL": "investing or surrounding a tooth [adj PERIODONTALLY]\n",
  "PERIODONTALLY": "PERIODONTAL, investing or surrounding a tooth [adv]\n",
  "PERIODONTIA": "the branch of dentistry concerned with periodontal diseases [n -S]\n",
  "PERIODONTIAS": "PERIODONTIA, the branch of dentistry concerned with periodontal diseases [n]\n",
  "PERIODONTIC": "relating to periodontia, the branch of dentistry concerned with periodontal diseases [adj]\n",
  "PERIODONTICALLY": "PERIODONTIC, relating to periodontia, the branch of dentistry concerned with periodontal diseases [adv]\n",
  "PERIODONTICS": "the study of gums, as a branch of dentistry [n]\n",
  "PERIODONTIST": "a dentist specialising in periodontics [n -S]\n",
  "PERIODONTISTS": "PERIODONTIST, a dentist specialising in periodontics [n]\n",
  "PERIODONTITIS": "inflammation of the tissues surrounding the teeth [n -ES]\n",
  "PERIODONTITISES": "PERIODONTITIS, inflammation of the tissues surrounding the teeth [n]\n",
  "PERIODONTOLOGY": "the branch of dentistry concerned with periodontal diseases [n]\n",
  "PERIODS": "PERIOD, (Shakespeare) to put an end to [v]\n",
  "PERIONYCHIA": "PERIONYCHIUM, tissue surrounding a nail [n]\n",
  "PERIONYCHIUM": "tissue surrounding a nail [n PERIONYCHIA]\n",
  "PERIOST": "(Greek) a tough fibrous membrane covering the surface of bones, also PERIOSTEUM [n -S]\n",
  "PERIOSTEA": "PERIOSTEUM, a tough fibrous membrane covering the surface of bones, also PERIOST [n]\n",
  "PERIOSTEAL": "situated around bone; of or pertaining to the periosteum [adj]\n",
  "PERIOSTEUM": "a tough fibrous membrane covering the surface of bones, also PERIOST [n PERIOSTEA]\n",
  "PERIOSTITIC": "relating to periostitis, inflammation of the periosteum [adj]\n",
  "PERIOSTITIDES": "PERIOSTITIS, inflammation of the periosteum [n]\n",
  "PERIOSTITIS": "inflammation of the periosteum [n PERIOSTITIDES or PERIOSTITISES]\n",
  "PERIOSTITISES": "PERIOSTITIS, inflammation of the periosteum [n]\n",
  "PERIOSTRACUM": "the horny outer layer of a mollusc's shell [n -S]\n",
  "PERIOSTRACUMS": "PERIOSTRACUM, the horny outer layer of a mollusc's shell [n]\n",
  "PERIOSTS": "PERIOST, (Greek) a tough fibrous membrane covering the surface of bones, also PERIOSTEUM [n]\n",
  "PERIOTIC": "a bone of the middle ear [n -S]\n",
  "PERIOTICS": "PERIOTIC, a bone of the middle ear [n]\n",
  "PERIPATETIC": "walking about from place to place, itinerant, also PERIPATETICAL [adj] / an itinerant [n -S]\n",
  "PERIPATETICAL": "walking about from place to place, itinerant, also PERIPATETIC [adj PERIPATETICALLY]\n",
  "PERIPATETICALLY": "PERIPATETICAL, walking about from place to place, itinerant, also PERIPATETIC [adv]\n",
  "PERIPATETICISM": "the state of being peripatetic [n -S]\n",
  "PERIPATETICISMS": "PERIPATETICISM, the state of being peripatetic [n]\n",
  "PERIPATETICS": "PERIPATETIC, an itinerant [n]\n",
  "PERIPATUS": "a member of the genus Peripatus, having both arthropod and annelid characteristics [n -ES]\n",
  "PERIPATUSES": "PERIPATUS, a member of the genus Peripatus, having both arthropod and annelid characteristics [n]\n",
  "PERIPETEIA": "(Greek) a sudden and violent change in circumstances, esp. in drama, also PERIPETIA, PERIPETY [n -S]\n",
  "PERIPETEIAN": "of or like a peripeteia, a sudden or unexpected reversal of circumstances or situation, also PERIPETIAN [adj]\n",
  "PERIPETEIAS": "PERIPETEIA, (Greek) a sudden and violent change in circumstances, esp. in drama, also PERIPETIA, PERIPETY [n]\n",
  "PERIPETIA": "(Greek) a sudden and violent change in circumstances, esp. in drama, also PERIPETEIA, PERIPETY [n -S]\n",
  "PERIPETIAN": "of or like a peripeteia, a sudden or unexpected reversal of circumstances or situation, also PERIPETEIAN [adj]\n",
  "PERIPETIAS": "PERIPETIA, (Greek) a sudden and violent change in circumstances, esp. in drama, also PERIPETEIA, PERIPETY [n]\n",
  "PERIPETIES": "PERIPETY, (Greek) a sudden change in a course of events [n]\n",
  "PERIPETY": "(Greek) a sudden change in a course of events [n PERIPETIES]\n",
  "PERIPHERAL": "at the edge [adj PERIPHERALLY] / a device connected to a computer to provide communication (as input and output) or auxiliary functions (as additional storage) [n -S]\n",
  "PERIPHERALITIES": "PERIPHERALITY, the state of being peripheral [n]\n",
  "PERIPHERALITY": "the state of being peripheral [n PERIPHERALITIES]\n",
  "PERIPHERALLY": "PERIPHERAL, at the edge [adv]\n",
  "PERIPHERALS": "PERIPHERAL, a device connected to a computer to provide communication (as input and output) or auxiliary functions (as additional storage) [n]\n",
  "PERIPHERIC": "(archaic) relating to a periphery, also PERIPHERICAL [adj]\n",
  "PERIPHERICAL": "(archaic) relating to a periphery, also PERIPHERIC [adj]\n",
  "PERIPHERIES": "PERIPHERY, a line or surface acting as a boundary [n]\n",
  "PERIPHERY": "a line or surface acting as a boundary [n PERIPHERIES]\n",
  "PERIPHONIC": "relating to a sound system with many speakers [adj]\n",
  "PERIPHRASE": "to use more words than are necessary to express an idea [v PERIPHRASED, PERIPHRASING, PERIPHRASES]\n",
  "PERIPHRASED": "PERIPHRASE, to use more words than are necessary to express an idea [v]\n",
  "PERIPHRASES": "PERIPHRASE, to use more words than are necessary to express an idea [v]\n",
  "PERIPHRASING": "PERIPHRASE, to use more words than are necessary to express an idea [v]\n",
  "PERIPHRASIS": "the use of longer phrasing in place of a shorter form of expression [n PERIPHRASES]\n",
  "PERIPHRASTIC": "of or like periphrasis, the use of longer phrasing in place of shorter form of expression, also PERIPHRASTICAL [adj]\n",
  "PERIPHRASTICAL": "of or like periphrasis, the use of longer phrasing in place of shorter form of expression, also PERIPHRASTIC [adj]\n",
  "PERIPHYTIC": "relating to a periphyton [adj]\n",
  "PERIPHYTON": "aquatic organisms which are attached to, or cling to, stems and leaves of rooted plants, rocks, etc. [n -S]\n",
  "PERIPHYTONS": "PERIPHYTON, aquatic organisms which are attached to, or cling to, stems and leaves of rooted plants, rocks, etc. [n]\n",
  "PERIPLASM": "the region inside the wall of a biological cell [n -S]\n",
  "PERIPLASMS": "PERIPLASM, the region inside the wall of a biological cell [n]\n",
  "PERIPLAST": "an intercellular substance; the ectoplasm of flagellates [n -S]\n",
  "PERIPLASTS": "PERIPLAST, an intercellular substance; the ectoplasm of flagellates [n]\n",
  "PERIPLUS": "a voyage or trip around something [n -ES]\n",
  "PERIPLUSES": "PERIPLUS, a voyage or trip around something [n]\n",
  "PERIPROCT": "the region surrounding the anus, particularly of echinoderms [n -S]\n",
  "PERIPROCTS": "PERIPROCT, the region surrounding the anus, particularly of echinoderms [n]\n",
  "PERIPTER": "a structure with a row of columns around all sides [n -S]\n",
  "PERIPTERAL": "having a row of columns on every side [adj]\n",
  "PERIPTERIES": "PERIPTERY, a peripteral building; the turbulent air around a flying object [n]\n",
  "PERIPTERS": "PERIPTER, a structure with a row of columns around all sides [n]\n",
  "PERIPTERY": "a peripteral building; the turbulent air around a flying object [n PERIPTERIES]\n",
  "PERIQUE": "(French) a strong, black, Louisiana tobacco [n -S]\n",
  "PERIQUES": "PERIQUE, (French) a strong, black, Louisiana tobacco [n]\n",
  "PERIS": "PERI, (Persian) a supernatural being of Persian mythology [n]\n",
  "PERISARC": "a protective covering of certain hydrozoans [n -S]\n",
  "PERISARCAL": "relating to the perisarc, the outer, hardened integument which covers most hydroids, also PERISARCOUS [adj]\n",
  "PERISARCOUS": "relating to the perisarc, the outer, hardened integument which covers most hydroids, also PERISARCAL [adj]\n",
  "PERISARCS": "PERISARC, a protective covering of certain hydrozoans [n]\n",
  "PERISCIAN": "a person living inside the polar circle [n -S]\n",
  "PERISCIANS": "PERISCIAN, a person living inside the polar circle [n]\n",
  "PERISCOPE": "a device (e.g. a tube with mirrors) by which an observer can look at something which is not in the direct line of sight [n -S]\n",
  "PERISCOPES": "PERISCOPE, a device (e.g. a tube with mirrors) by which an observer can look at something which is not in the direct line of sight [n]\n",
  "PERISCOPIC": "viewing all around, or on all sides [adj PERISCOPICALLY]\n",
  "PERISCOPICALLY": "PERISCOPIC, viewing all around, or on all sides [adv]\n",
  "PERISELENIA": "PERISELENIUM, in an elliptical orbit about the moon, that point which is closest to the moon [n]\n",
  "PERISELENIUM": "in an elliptical orbit about the moon, that point which is closest to the moon [n PERISELENIA]\n",
  "PERISH": "to die [v -ED, -ING, -ES]\n",
  "PERISHABILITIES": "PERISHABILITY, the state of being perishable [n]\n",
  "PERISHABILITY": "the state of being perishable [n PERISHABILITIES]\n",
  "PERISHABLE": "liable to perish [adj PERISHABLY] / something liable to perish [n -S]\n",
  "PERISHABLENESS": "the state of being perishable [n]\n",
  "PERISHABLES": "PERISHABLE, something liable to perish [n]\n",
  "PERISHABLY": "PERISHABLE, liable to perish [adv]\n",
  "PERISHED": "PERISH, to die [v]\n",
  "PERISHER": "(colloquial) an annoying, contemptible, or pitiable person [n -S]\n",
  "PERISHERS": "PERISHER, (colloquial) an annoying, contemptible, or pitiable person [n]\n",
  "PERISHES": "PERISH, to die [v]\n",
  "PERISHING": "PERISH, to die [v]\n",
  "PERISHINGLY": "PERISHING, PERISH, to die [adv]\n",
  "PERISPERM": "the albumen of a seed, esp. that portion which is formed outside of the embryo sac [n -S]\n",
  "PERISPERMAL": "of or like a perisperm, also PERISPERMIC [adj]\n",
  "PERISPERMIC": "of or like a perisperm, also PERISPERMAL [adj]\n",
  "PERISPERMS": "PERISPERM, the albumen of a seed, esp. that portion which is formed outside of the embryo sac [n]\n",
  "PERISPOMENA": "PERISPOMENON, a word having a circumflex accent on the final syllable [n]\n",
  "PERISPOMENON": "a word having a circumflex accent on the final syllable [n PERISPOMENA or PERISPOMENONS]\n",
  "PERISPOMENONS": "PERISPOMENON, a word having a circumflex accent on the final syllable [n]\n",
  "PERISSODACTYL": "an animal of the Perissodactyla, a division of ungulates with an odd number of toes, including the horse, tapir and rhinoceros, also PERISSODACTYLE [n -S]\n",
  "PERISSODACTYLE": "an animal of the Perissodactyla, a division of ungulates with an odd number of toes, including the horse, tapir and rhinoceros, also PERISSODACTYL [n -S]\n",
  "PERISSODACTYLES": "PERISSODACTYLE, an animal of the Perissodactyla, a division of ungulates with an odd number of toes, including the horse, tapir and rhinoceros, also PERISSODACTYL [n]\n",
  "PERISSODACTYLIC": "of or like a perissodactyl [adj]\n",
  "PERISSODACTYLS": "PERISSODACTYL, an animal of the Perissodactyla, a division of ungulates with an odd number of toes, including the horse, tapir and rhinoceros, also PERISSODACTYLE [n]\n",
  "PERISSOLOGIES": "PERISSOLOGY, superfluity of words, pleonasm [n]\n",
  "PERISSOLOGY": "superfluity of words, pleonasm [n PERISSOLOGIES]\n",
  "PERISSOSYLLABIC": "having an additional syllable [adj]\n",
  "PERISTALITH": "a prehistoric stone circle [n -S]\n",
  "PERISTALITHS": "PERISTALITH, a prehistoric stone circle [n]\n",
  "PERISTALSES": "PERISTALSIS, the movement of the food through the gut [n]\n",
  "PERISTALSIS": "the movement of the food through the gut [n PERISTALSES]\n",
  "PERISTALTIC": "relating to peristalsis [adj PERISTALTICALLY]\n",
  "PERISTALTICALLY": "PERISTALTIC, relating to peristalsis [adv]\n",
  "PERISTERITE": "an albite feldspar with a pigeon-like play of colour [n -S]\n",
  "PERISTERITES": "PERISTERITE, an albite feldspar with a pigeon-like play of colour [n]\n",
  "PERISTERONIC": "of or relating to pigeons [adj]\n",
  "PERISTOMAL": "relating to the peristome, the area, or a structure, surrounding a mouth, also PERISTOMATIC, PERISTOMIAL [adj]\n",
  "PERISTOMATIC": "relating to the peristome, the area, or a structure, surrounding a mouth, also PERISTOMAL, PERISTOMIAL [adj]\n",
  "PERISTOME": "the area, or a structure, surrounding a mouth [n -S]\n",
  "PERISTOMES": "PERISTOME, the area, or a structure, surrounding a mouth [n]\n",
  "PERISTOMIAL": "relating to the peristome, the area, or a structure, surrounding a mouth, also PERISTOMAL, PERISTOMATIC [adj]\n",
  "PERISTREPHIC": "moving round; revolving; rotatory [adj]\n",
  "PERISTYLAR": "relating to a peristyle, a range of columns around a building or courtyard [adj]\n",
  "PERISTYLE": "a range of columns around a building or courtyard [n -S]\n",
  "PERISTYLES": "PERISTYLE, a range of columns around a building or courtyard [n]\n",
  "PERITECTIC": "a temperature at which a melting reaction takes place [n -S]\n",
  "PERITECTICS": "PERITECTIC, a temperature at which a melting reaction takes place [n]\n",
  "PERITHECIA": "PERITHECIUM, a small fruiting body containing ascospores [n]\n",
  "PERITHECIAL": "related to a perithecium, a small fruiting body containing ascospores [adj]\n",
  "PERITHECIUM": "a small fruiting body containing ascospores [n PERITHECIA]\n",
  "PERITI": "PERITUS, (Latin) a type of theological expert [n]\n",
  "PERITONAEA": "PERITONAEUM, a serous membrane enclosing the viscera in the abdominal and pelvic cavities, also PERITONEUM [n]\n",
  "PERITONAEAL": "relating to the peritonaeum, also PERITONEAL [adj]\n",
  "PERITONAEUM": "a serous membrane enclosing the viscera in the abdominal and pelvic cavities, also PERITONEUM [n PERITONAEA]\n",
  "PERITONAEUMS": "PERITONAEUM, a serous membrane enclosing the viscera in the abdominal and pelvic cavities, also PERITONEUM [n]\n",
  "PERITONEA": "PERITONEUM, the smooth serous membrane which lines the cavity of the abdomen [n]\n",
  "PERITONEAL": "relating to the peritoneum, also PERITONAEAL [adj PERITONEALLY]\n",
  "PERITONEALLY": "PERITONEAL, relating to the peritoneum, also PERITONAEAL [adv]\n",
  "PERITONEOSCOPY": "the visual examination of the peritoneal cavities by means of an endoscope inserted through an incision in the abdomen [n]\n",
  "PERITONEUM": "the smooth serous membrane which lines the cavity of the abdomen [n PERITONEA or PERITONEUMS]\n",
  "PERITONEUMS": "PERITONEUM, the smooth serous membrane which lines the cavity of the abdomen [n]\n",
  "PERITONITIC": "of or suffering from peritonitis [adj]\n",
  "PERITONITIS": "inflammation of the peritoneum [n -ES]\n",
  "PERITONITISES": "PERITONITIS, inflammation of the peritoneum [n]\n",
  "PERITRACK": "at an airport, a specially prepared track used for the movement of aircraft, aka taxiway [n -S]\n",
  "PERITRACKS": "PERITRACK, at an airport, a specially prepared track used for the movement of aircraft, aka taxiway [n]\n",
  "PERITRICH": "a bacterium bearing a ring of cilia around the body [n PERITRICHA or PERITRICHS]\n",
  "PERITRICHA": "PERITRICH, a bacterium bearing a ring of cilia around the body [n]\n",
  "PERITRICHOUS": "having flagella uniformly distributed over the body [adj PERITRICHOUSLY]\n",
  "PERITRICHOUSLY": "PERITRICHOUS, having flagella uniformly distributed over the body [adv]\n",
  "PERITRICHS": "PERITRICH, a bacterium bearing a ring of cilia around the body [n]\n",
  "PERITUS": "(Latin) a type of theological expert [n PERITI]\n",
  "PERITYPHLITIS": "inflammation of some part near the caecum or blindgut [n -ES]\n",
  "PERITYPHLITISES": "PERITYPHLITIS, inflammation of some part near the caecum or blindgut [n]\n",
  "PERIVITELLINE": "surrounding the yolk of an egg [adj]\n",
  "PERIWIG": "(historical) a wig or peruke [n -S] / to put on a periwig [v PERIWIGGED, PERIWIGGING, PERIWIGS]\n",
  "PERIWIGGED": "PERIWIG, to put on a periwig [v]\n",
  "PERIWIGGING": "PERIWIG, to put on a periwig [v]\n",
  "PERIWIGS": "PERIWIG, (historical) a wig or peruke [n]\n",
  "PERIWINKLE": "a creeping plant with blue flowers, also PENNYWINKLE [n -S]\n",
  "PERIWINKLES": "PERIWINKLE, a creeping plant with blue flowers, also PENNYWINKLE [n]\n",
  "PERJINK": "(Scots) prim, finical, also PERJINKETY, PREJINK [adj]\n",
  "PERJINKETY": "(Scots) prim, finical, also PERJINK, PREJINK [adj]\n",
  "PERJINKITIES": "PERJINKITY, (Scots) a nicety [n]\n",
  "PERJINKITY": "(Scots) a nicety [n PERJINKITIES]\n",
  "PERJURE": "to make a perjurer of [v PERJURED, PERJURING, PERJURES]\n",
  "PERJURED": "PERJURE, to make a perjurer of [v]\n",
  "PERJURER": "one guilty of perjury [n -S]\n",
  "PERJURERS": "PERJURER, one guilty of perjury [n]\n",
  "PERJURES": "PERJURE, to make a perjurer of [v]\n",
  "PERJURIES": "PERJURY, false swearing under oath in a judicial proceeding [n]\n",
  "PERJURING": "PERJURE, to make a perjurer of [v]\n",
  "PERJURIOUS": "guilty of perjury, also PERJUROUS [adj PERJURIOUSLY]\n",
  "PERJURIOUSLY": "PERJURIOUS, guilty of perjury, also PERJUROUS [adv]\n",
  "PERJUROUS": "(archaic) guilty of perjury, also PERJURIOUS [adj]\n",
  "PERJURY": "false swearing under oath in a judicial proceeding [n PERJURIES]\n",
  "PERK": "to carry oneself jauntily [v -ED, -ING, -S]\n",
  "PERKED": "PERK, to carry oneself jauntily [v]\n",
  "PERKIER": "PERKY, cheerful, lively [adj]\n",
  "PERKIEST": "PERKY, cheerful, lively [adj]\n",
  "PERKILY": "PERKY, cheerful, lively [adv]\n",
  "PERKIN": "an oatmeal biscuit, also PARKIN [n -S]\n",
  "PERKINESS": "the state of being perky [n -ES]\n",
  "PERKINESSES": "PERKINESS, the state of being perky [n]\n",
  "PERKING": "PERK, to carry oneself jauntily [v]\n",
  "PERKINS": "PERKIN, an oatmeal biscuit, also PARKIN [n]\n",
  "PERKISH": "somewhat perky [adj]\n",
  "PERKS": "PERK, to carry oneself jauntily [v]\n",
  "PERKY": "cheerful, lively [adj PERKIER, PERKIEST, PERKILY]\n",
  "PERLEMOEN": "(South African) another name for abalone [n -S]\n",
  "PERLEMOENS": "PERLEMOEN, (South African) another name for abalone [n]\n",
  "PERLITE": "a kind of volcanic glass [n -S]\n",
  "PERLITES": "PERLITE, a kind of volcanic glass [n]\n",
  "PERLITIC": "having a texture like that of perlite, volcanic glass [adj]\n",
  "PERLOCUTION": "the effect produced when a particular word is uttered [n -S]\n",
  "PERLOCUTIONARY": "relating to perlocution, the effect produced when a particular word is uttered [adj]\n",
  "PERLOCUTIONS": "PERLOCUTION, the effect produced when a particular word is uttered [n]\n",
  "PERLOUS": "(Spenser) perilous, also PARLOUS, PERICULOUS [adj]\n",
  "PERLUSTRATE": "(archaic) to traverse and inspect [v PERLUSTRATED, PERLUSTRATING, PERLUSTRATES]\n",
  "PERLUSTRATED": "PERLUSTRATE, (archaic) to traverse and inspect [v]\n",
  "PERLUSTRATES": "PERLUSTRATE, (archaic) to traverse and inspect [v]\n",
  "PERLUSTRATING": "PERLUSTRATE, (archaic) to traverse and inspect [v]\n",
  "PERLUSTRATION": "the act of perlustrating [n -S]\n",
  "PERLUSTRATIONS": "PERLUSTRATION, the act of perlustrating [n]\n",
  "PERM": "to permanent wave the hair [v -ED, -ING, -S]\n",
  "PERMABEAR": "an investor who consistently acts in the expectation that the value of stocks and shares will fall [n -S]\n",
  "PERMABEARS": "PERMABEAR, an investor who consistently acts in the expectation that the value of stocks and shares will fall [n]\n",
  "PERMABULL": "an investor who consistently acts in the expectation that the value of stocks and shares will rise [n -S]\n",
  "PERMABULLS": "PERMABULL, an investor who consistently acts in the expectation that the value of stocks and shares will rise [n]\n",
  "PERMACULTURE": "a system of self-sustaining natural agriculture [n -S]\n",
  "PERMACULTURES": "PERMACULTURE, a system of self-sustaining natural agriculture [n]\n",
  "PERMAFROST": "permanently frozen subsoil [n -S]\n",
  "PERMAFROSTS": "PERMAFROST, permanently frozen subsoil [n]\n",
  "PERMALINK": "an internet hyperlink that is intended to be permanent [n -S]\n",
  "PERMALINKS": "PERMALINK, an internet hyperlink that is intended to be permanent [n]\n",
  "PERMALLOY": "an alloy of nickel and iron, the most easily magnetized of all materials [n -S]\n",
  "PERMALLOYS": "PERMALLOY, an alloy of nickel and iron, the most easily magnetized of all materials [n]\n",
  "PERMANENCE": "the state of being permanent, also PERMANENCY [n -S]\n",
  "PERMANENCES": "PERMANENCE, the state of being permanent, also PERMANENCY [n]\n",
  "PERMANENCIES": "PERMANENCY, the state of being permanent, also PERMANENCE [n]\n",
  "PERMANENCY": "the state of being permanent, also PERMANENCE [n PERMANENCIES]\n",
  "PERMANENT": "remaining, or intended to remain, indefinitely [adj PERMANENTLY] / a permanent member of staff [n -S]\n",
  "PERMANENTLY": "PERMANENT, remaining, or intended to remain, indefinitely [adv]\n",
  "PERMANENTNESS": "the state of being permanent [n -ES]\n",
  "PERMANENTNESSES": "PERMANENTNESS, the state of being permanent [n]\n",
  "PERMANENTS": "PERMANENT, a permanent member of staff [n]\n",
  "PERMANGANATE": "a salt of permanganic acid [n -S]\n",
  "PERMANGANATES": "PERMANGANATE, a salt of permanganic acid [n]\n",
  "PERMANGANIC": "applied to an acid and its anhydride containing more oxygen than manganic acid and anhydride [adj]\n",
  "PERMATAN": "a permanent tan [n -S]\n",
  "PERMATANS": "PERMATAN, a permanent tan [n]\n",
  "PERMEABILITIES": "PERMEABILITY, the capacity of material to transmit water or other fluids [n]\n",
  "PERMEABILITY": "the capacity of material to transmit water or other fluids [n PERMEABILITIES]\n",
  "PERMEABLE": "allowing a gas or liquid to pass through [adj PERMEABLY]\n",
  "PERMEABLENESS": "the state of being permeable [n -ES]\n",
  "PERMEABLENESSES": "PERMEABLENESS, the state of being permeable [n]\n",
  "PERMEABLY": "PERMEABLE, allowing a gas or liquid to pass through [adv]\n",
  "PERMEAMETER": "instrument for measuring permeability [n -S]\n",
  "PERMEAMETERS": "PERMEAMETER, instrument for measuring permeability [n]\n",
  "PERMEANCE": "the property of allowing the passage of lines of magnetic flux [n -S]\n",
  "PERMEANCES": "PERMEANCE, the property of allowing the passage of lines of magnetic flux [n]\n",
  "PERMEANT": "passing through, permeating [adj] / something that permeates [n -S]\n",
  "PERMEANTS": "PERMEANT, something that permeates [n]\n",
  "PERMEASE": "an enzyme which assists the passage of a substrate into a cell through the cell membrane [n -S]\n",
  "PERMEASES": "PERMEASE, an enzyme which assists the passage of a substrate into a cell through the cell membrane [n]\n",
  "PERMEATE": "to spread through [v PERMEATED, PERMEATING, PERMEATES]\n",
  "PERMEATED": "PERMEATE, to spread through [v]\n",
  "PERMEATES": "PERMEATE, to spread through [v]\n",
  "PERMEATING": "PERMEATE, to spread through [v]\n",
  "PERMEATION": "the act of permeating [n -S]\n",
  "PERMEATIONS": "PERMEATION, the act of permeating [n]\n",
  "PERMEATIVE": "that permeates [adj]\n",
  "PERMEATOR": "something or someone that permeates [n -S]\n",
  "PERMEATORS": "PERMEATOR, something or someone that permeates [n]\n",
  "PERMED": "PERM, to permanent wave the hair [v]\n",
  "PERMETHRIN": "a garden pesticide [n -S]\n",
  "PERMETHRINS": "PERMETHRIN, a garden pesticide [n]\n",
  "PERMIAN": "relating to the last period of the Palaeozoic era [adj]\n",
  "PERMIE": "a permanent worker, as opposed to a temp [n -S]\n",
  "PERMIES": "PERMIE, a permanent worker, as opposed to a temp [n]\n",
  "PERMILLAGE": "reckoning by the thousand [n -S]\n",
  "PERMILLAGES": "PERMILLAGE, reckoning by the thousand [n]\n",
  "PERMING": "PERM, to permanent wave the hair [v]\n",
  "PERMISSIBILITY": "the state of being permissible [n]\n",
  "PERMISSIBLE": "that can be permitted [adj PERMISSIBLY]\n",
  "PERMISSIBLENESS": "PERMISSIBLE, that can be permitted [n]\n",
  "PERMISSIBLY": "PERMISSIBLE, that can be permitted [adv]\n",
  "PERMISSION": "the act of permitting [n -S]\n",
  "PERMISSIONS": "PERMISSION, the act of permitting [n]\n",
  "PERMISSIVE": "permitting; granting leave or liberty [adj PERMISSIVELY]\n",
  "PERMISSIVELY": "PERMISSIVE, permitting; granting leave or liberty [adv]\n",
  "PERMISSIVENESS": "PERMISSIVE, permitting; granting leave or liberty [n]\n",
  "PERMIT": "to allow [v PERMITTED, PERMITTING, PERMITS]\n",
  "PERMITS": "PERMIT, to allow [v]\n",
  "PERMITTANCE": "permission [n -S]\n",
  "PERMITTANCES": "PERMITTANCE, permission [n]\n",
  "PERMITTED": "PERMIT, to allow [v]\n",
  "PERMITTEE": "one to whom a permission or permit is given [n -S]\n",
  "PERMITTEES": "PERMITTEE, one to whom a permission or permit is given [n]\n",
  "PERMITTER": "one who permits [n -S]\n",
  "PERMITTERS": "PERMITTER, one who permits [n]\n",
  "PERMITTING": "PERMIT, to allow [v]\n",
  "PERMITTIVITIES": "PERMITTIVITY, the ratio of the electric displacement in a medium to the electric field intensity producing it [n]\n",
  "PERMITTIVITY": "the ratio of the electric displacement in a medium to the electric field intensity producing it [n PERMITTIVITIES]\n",
  "PERMS": "PERM, to permanent wave the hair [v]\n",
  "PERMUTABILITIES": "PERMUTABILITY, the quality of being permutable [n]\n",
  "PERMUTABILITY": "the quality of being permutable [n PERMUTABILITIES]\n",
  "PERMUTABLE": "that can be permuted [adj PERMUTABLY]\n",
  "PERMUTABLENESS": "PERMUTABLE, that can be permuted [n]\n",
  "PERMUTABLY": "PERMUTABLE, that can be permuted [adv]\n",
  "PERMUTATE": "to alter the order, sequence, or arrangement of, also PERMUTE [v PERMUTATED, PERMUTATING, PERMUTATES]\n",
  "PERMUTATED": "PERMUTATE, to alter the order, sequence, or arrangement of, also PERMUTE [v]\n",
  "PERMUTATES": "PERMUTATE, to alter the order, sequence, or arrangement of, also PERMUTE [v]\n",
  "PERMUTATING": "PERMUTATE, to alter the order, sequence, or arrangement of, also PERMUTE [v]\n",
  "PERMUTATION": "the arrangement of a set of things in every possible order [n -S]\n",
  "PERMUTATIONAL": "relating to permutation [adj]\n",
  "PERMUTATIONS": "PERMUTATION, the arrangement of a set of things in every possible order [n]\n",
  "PERMUTE": "to alter the order, sequence, or arrangement of, also PERMUTATE [v PERMUTED, PERMUTING, PERMUTES]\n",
  "PERMUTED": "PERMUTE, to alter the order, sequence, or arrangement of, also PERMUTATE [v]\n",
  "PERMUTES": "PERMUTE, to alter the order, sequence, or arrangement of, also PERMUTATE [v]\n",
  "PERMUTING": "PERMUTE, to alter the order, sequence, or arrangement of, also PERMUTATE [v]\n",
  "PERN": "to move with a spiralling motion [v -ED, -ING, -S]\n",
  "PERNANCIES": "PERNANCY, receiving, in legal terms [n]\n",
  "PERNANCY": "receiving, in legal terms [n PERNANCIES]\n",
  "PERNED": "PERN, to move with a spiralling motion [v]\n",
  "PERNICIOUS": "destructive; ruinous; fatal [adj PERNICIOUSLY]\n",
  "PERNICIOUSLY": "PERNICIOUS, destructive; ruinous; fatal [adv]\n",
  "PERNICIOUSNESS": "PERNICIOUS, destructive; ruinous; fatal [n]\n",
  "PERNICKETIER": "PERNICKETY, fussy about small details, also PERSNICKETY [adj]\n",
  "PERNICKETIEST": "PERNICKETY, fussy about small details, also PERSNICKETY [adj]\n",
  "PERNICKETINESS": "the state of being pernickety [n]\n",
  "PERNICKETY": "fussy about small details, also PERSNICKETY [adj PERNICKETIER, PERNICKETIEST]\n",
  "PERNING": "PERN, to move with a spiralling motion [v]\n",
  "PERNIO": "a chilblain [n PERNIONES]\n",
  "PERNIONES": "PERNIO, a chilblain [n]\n",
  "PERNOCTATE": "to pass the night in vigil or prayer [v PERNOCTATED, PERNOCTATING, PERNOCTATES]\n",
  "PERNOCTATED": "PERNOCTATE, to pass the night in vigil or prayer [v]\n",
  "PERNOCTATES": "PERNOCTATE, to pass the night in vigil or prayer [v]\n",
  "PERNOCTATING": "PERNOCTATE, to pass the night in vigil or prayer [v]\n",
  "PERNOCTATION": "the act of staying up all night doing work or attending a party [n -S]\n",
  "PERNOCTATIONS": "PERNOCTATION, the act of staying up all night doing work or attending a party [n]\n",
  "PERNOD": "(tradename) an aniseed-flavoured aperitif from France [n -S]\n",
  "PERNODS": "PERNOD, (tradename) an aniseed-flavoured aperitif from France [n]\n",
  "PERNS": "PERN, to move with a spiralling motion [v]\n",
  "PEROG": "(Russian) a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PIEROG, PIROG [n PEROGEN or PEROGS]\n",
  "PEROGEN": "PEROG, (Russian) a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PIEROG, PIROG [n]\n",
  "PEROGI": "(Polish) a traditional Polish dish, a semicircular filled dumpling, also PEROGIE, PEROGY, PIEROGI, PIROGI, PYROGY, PYROHY [n PEROGIES or PEROGIS]\n",
  "PEROGIE": "(Russian) a small dumpling with a filling, also PEROGI, PEROGY, PIEROGI, PIROGI, PYROGY, PYROHY [n -S]\n",
  "PEROGIES": "PEROGI, (Polish) a traditional Polish dish, a semicircular filled dumpling, also PEROGIE, PEROGY, PIEROGI, PIROGI, PYROGY, PYROHY [n]\n",
  "PEROGIS": "PEROGI, (Polish) a traditional Polish dish, a semicircular filled dumpling, also PEROGIE, PEROGY, PIEROGI, PIROGI, PYROGY, PYROHY [n]\n",
  "PEROGS": "PEROG, (Russian) a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PIEROG, PIROG [n]\n",
  "PEROGY": "(Russian) a small dumpling with a filling, also PEROGI, PEROGIE, PIEROGI, PIROGI, PYROGY, PYROHY [n PEROGIES]\n",
  "PERONE": "(Greek) the fibula, a bone of the leg [n -S]\n",
  "PERONEAL": "pertaining to the fibula [adj]\n",
  "PERONEI": "PERONEUS, one of several fibular muscles [n]\n",
  "PERONES": "PERONE, (Greek) the fibula, a bone of the leg [n]\n",
  "PERONEUS": "one of several fibular muscles [n PERONEI or PERONEUSES]\n",
  "PERONEUSES": "PERONEUS, one of several fibular muscles [n]\n",
  "PERORAL": "occurring through the mouth [adj PERORALLY]\n",
  "PERORALLY": "PERORAL, occurring through the mouth [adv]\n",
  "PERORATE": "to make a lengthy speech [v PERORATED, PERORATING, PERORATES]\n",
  "PERORATED": "PERORATE, to make a lengthy speech [v]\n",
  "PERORATES": "PERORATE, to make a lengthy speech [v]\n",
  "PERORATING": "PERORATE, to make a lengthy speech [v]\n",
  "PERORATION": "the concluding part of a discourse; a highly rhetorical speech [n -S]\n",
  "PERORATIONAL": "of or like a peroration [adj]\n",
  "PERORATIONS": "PERORATION, the concluding part of a discourse; a highly rhetorical speech [n]\n",
  "PERORATOR": "one who perorates [n -S]\n",
  "PERORATORS": "PERORATOR, one who perorates [n]\n",
  "PEROVSKIA": "a genus of hardy deciduous shrubs of the Labiatae family [n -S]\n",
  "PEROVSKIAS": "PEROVSKIA, a genus of hardy deciduous shrubs of the Labiatae family [n]\n",
  "PEROVSKITE": "a mineral form of calcium titanate [n -S]\n",
  "PEROVSKITES": "PEROVSKITE, a mineral form of calcium titanate [n]\n",
  "PEROXID": "a bleaching agent, also PEROXIDE [n -S]\n",
  "PEROXIDASE": "an enzyme found in many plants which acts as a catalyst in the oxidation of various substances by peroxides [n -S]\n",
  "PEROXIDASES": "PEROXIDASE, an enzyme found in many plants which acts as a catalyst in the oxidation of various substances by peroxides [n]\n",
  "PEROXIDATION": "the creation of a peroxide [n -S]\n",
  "PEROXIDATIONS": "PEROXIDATION, the creation of a peroxide [n]\n",
  "PEROXIDE": "a bleaching agent, also PEROXID [n -S] / to bleach with a bleaching agent [v PEROXIDED, PEROXIDING, PEROXIDES]\n",
  "PEROXIDED": "PEROXIDE, to bleach with a bleaching agent [v]\n",
  "PEROXIDES": "PEROXIDE, to bleach with a bleaching agent [v]\n",
  "PEROXIDIC": "relating to a peroxide, an oxide with the highest proportion of oxygen [adj]\n",
  "PEROXIDING": "PEROXIDE, to bleach with a bleaching agent [v]\n",
  "PEROXIDISE": "to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDIZE [v PEROXIDISED, PEROXIDISING, PEROXIDISES]\n",
  "PEROXIDISED": "PEROXIDISE, to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDIZE [v]\n",
  "PEROXIDISES": "PEROXIDISE, to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDIZE [v]\n",
  "PEROXIDISING": "PEROXIDISE, to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDIZE [v]\n",
  "PEROXIDIZE": "to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDISE [v PEROXIDIZED, PEROXIDIZING, PEROXIDIZES]\n",
  "PEROXIDIZED": "PEROXIDIZE, to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDISE [v]\n",
  "PEROXIDIZES": "PEROXIDIZE, to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDISE [v]\n",
  "PEROXIDIZING": "PEROXIDIZE, to oxidize to the utmost degree, so as to form a peroxide, also PEROXIDISE [v]\n",
  "PEROXIDS": "PEROXID, a bleaching agent, also PEROXIDE [n]\n",
  "PEROXISOMAL": "of or like a peroxisome [adj]\n",
  "PEROXISOME": "an organelle containing enzymes [n -S]\n",
  "PEROXISOMES": "PEROXISOME, an organelle containing enzymes [n]\n",
  "PEROXO": "containing the bivalent group of two oxygens, also PEROXY [adj]\n",
  "PEROXY": "containing the bivalent group of two oxygens, also PEROXO [adj]\n",
  "PEROXYSULPHURIC": "as in peroxysulphuric acid [adj]\n",
  "PERP": "(colloquial) short for perpetrator, one who has committed a crime [n -S]\n",
  "PERPEND": "to weigh in the mind; to consider carefully [v -ED, -ING, -S]\n",
  "PERPENDED": "PERPEND, to weigh in the mind; to consider carefully [v]\n",
  "PERPENDICULAR": "at right angles to a line or plane [adj PERPENDICULARLY] / a perpendicular line [n -S]\n",
  "PERPENDICULARLY": "PERPENDICULAR, at right angles to a line or plane [adv]\n",
  "PERPENDICULARS": "PERPENDICULAR, a perpendicular line [n]\n",
  "PERPENDING": "PERPEND, to weigh in the mind; to consider carefully [v]\n",
  "PERPENDS": "PERPEND, to weigh in the mind; to consider carefully [v]\n",
  "PERPENT": "a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPEND, PARPENT, PARPOINT [n -S]\n",
  "PERPENTS": "PERPENT, a stone passing through a wall from face to face, also PARPANE, PARPEN, PARPEND, PARPENT, PARPOINT [n]\n",
  "PERPETRABLE": "that can be perpetrated [adj]\n",
  "PERPETRATE": "to bring about or carry out, as a crime or deception [v PERPETRATED, PERPETRATING, PERPETRATES]\n",
  "PERPETRATED": "PERPETRATE, to bring about or carry out, as a crime or deception [v]\n",
  "PERPETRATES": "PERPETRATE, to bring about or carry out, as a crime or deception [v]\n",
  "PERPETRATING": "PERPETRATE, to bring about or carry out, as a crime or deception [v]\n",
  "PERPETRATION": "the act of perpetrating [n -S]\n",
  "PERPETRATIONS": "PERPETRATION, the act of perpetrating [n]\n",
  "PERPETRATOR": "one who perpetrates [n -S]\n",
  "PERPETRATORS": "PERPETRATOR, one who perpetrates [n]\n",
  "PERPETUABLE": "that can be perpetuated [adj]\n",
  "PERPETUAL": "lasting forever [adj PERPETUALLY] / a type of rose that flowers several times in one season [n -S]\n",
  "PERPETUALISM": "a belief in the perpetual continuance of things [n -S]\n",
  "PERPETUALISMS": "PERPETUALISM, a belief in the perpetual continuance of things [n]\n",
  "PERPETUALIST": "a person who advocates the perpetual continuation of anything [n -S]\n",
  "PERPETUALISTS": "PERPETUALIST, a person who advocates the perpetual continuation of anything [n]\n",
  "PERPETUALITIES": "PERPETUALITY, the state of being perpetual [n]\n",
  "PERPETUALITY": "the state of being perpetual [n PERPETUALITIES]\n",
  "PERPETUALLY": "PERPETUAL, lasting forever [adv]\n",
  "PERPETUALS": "PERPETUAL, a type of rose that flowers several times in one season [n]\n",
  "PERPETUANCE": "perpetuation [n -S]\n",
  "PERPETUANCES": "PERPETUANCE, perpetuation [n]\n",
  "PERPETUATE": "to make perpetual or cause to last indefinitely [v PERPETUATED, PERPETUATING, PERPETUATES]\n",
  "PERPETUATED": "PERPETUATE, to make perpetual or cause to last indefinitely [v]\n",
  "PERPETUATES": "PERPETUATE, to make perpetual or cause to last indefinitely [v]\n",
  "PERPETUATING": "PERPETUATE, to make perpetual or cause to last indefinitely [v]\n",
  "PERPETUATION": "continuation or preservation for ever, or a long time [n -S]\n",
  "PERPETUATIONS": "PERPETUATION, continuation or preservation for ever, or a long time [n]\n",
  "PERPETUATOR": "one who perpetuates [n -S]\n",
  "PERPETUATORS": "PERPETUATOR, one who perpetuates [n]\n",
  "PERPETUITIES": "PERPETUITY, the state of being perpetual [n]\n",
  "PERPETUITY": "the state of being perpetual [n PERPETUITIES]\n",
  "PERPHENAZINE": "a tranquillizer used esp. to control psychotic symptoms (as anxiety and agitation) [n -S]\n",
  "PERPHENAZINES": "PERPHENAZINE, a tranquillizer used esp. to control psychotic symptoms (as anxiety and agitation) [n]\n",
  "PERPLEX": "to puzzle [v -ED, -ING, -ES]\n",
  "PERPLEXED": "PERPLEX, to puzzle [v]\n",
  "PERPLEXEDLY": "PERPLEXED [adv]\n",
  "PERPLEXEDNESS": "the state of being perplexed [n -ES]\n",
  "PERPLEXEDNESSES": "PERPLEXEDNESS, the state of being perplexed [n]\n",
  "PERPLEXER": "one who perplexes [n -S]\n",
  "PERPLEXERS": "PERPLEXER, one who perplexes [n]\n",
  "PERPLEXES": "PERPLEX, to puzzle [v]\n",
  "PERPLEXING": "PERPLEX, to puzzle [v]\n",
  "PERPLEXINGLY": "PERPLEXING, PERPLEX, to puzzle [adv]\n",
  "PERPLEXITIES": "PERPLEXITY, the state of being perplexed [n]\n",
  "PERPLEXITY": "the state of being perplexed [n PERPLEXITIES]\n",
  "PERPS": "PERP, (colloquial) short for perpetrator, one who has committed a crime [n]\n",
  "PERQUISITE": "a privilege, gain, or profit incidental to regular salary or wages [n -S]\n",
  "PERQUISITES": "PERQUISITE, a privilege, gain, or profit incidental to regular salary or wages [n]\n",
  "PERQUISITION": "a diligent inquiry [n -S]\n",
  "PERQUISITIONS": "PERQUISITION, a diligent inquiry [n]\n",
  "PERQUISITOR": "the first purchaser of an estate [n -S]\n",
  "PERQUISITORS": "PERQUISITOR, the first purchaser of an estate [n]\n",
  "PERRADIAL": "situated around the radii, or radial tubes, of a radiate [adj]\n",
  "PERRADII": "PERRADIUS, the primary radius of a coelenterate [n]\n",
  "PERRADIUS": "the primary radius of a coelenterate [n PERRADII]\n",
  "PERRIER": "(obsolete) a short mortar used formerly for throwing stone shot [n -S]\n",
  "PERRIERS": "PERRIER, (obsolete) a short mortar used formerly for throwing stone shot [n]\n",
  "PERRIES": "PERRY, a beverage of pear juice often fermented [n]\n",
  "PERRON": "(French) a raised platform or terrace at an entrance door [n -S]\n",
  "PERRONS": "PERRON, (French) a raised platform or terrace at an entrance door [n]\n",
  "PERRUQUE": "a kind of wig, also PERUKE [n -S]\n",
  "PERRUQUES": "PERRUQUE, a kind of wig, also PERUKE [n]\n",
  "PERRUQUIER": "(French) a wigmaker [n -S]\n",
  "PERRUQUIERS": "PERRUQUIER, (French) a wigmaker [n]\n",
  "PERRY": "a beverage of pear juice often fermented [n PERRIES]\n",
  "PERSALT": "a term formerly given to the salts supposed to be formed respectively by neutralizing acids with certain peroxides [n -S]\n",
  "PERSALTS": "PERSALT, a term formerly given to the salts supposed to be formed respectively by neutralizing acids with certain peroxides [n]\n",
  "PERSANT": "(Spenser) piercing, also PERCEANT, PERSAUNT [adj]\n",
  "PERSAUNT": "(Spenser) piercing, also PERCEANT, PERSANT [adj]\n",
  "PERSCRUTATION": "a thorough search [n -S]\n",
  "PERSCRUTATIONS": "PERSCRUTATION, a thorough search [n]\n",
  "PERSE": "a dark blue colour [n -S] / (Spenser) to pierce, also PERCE, PEARCE [v PERST, PERSING, PERSES]\n",
  "PERSECUTE": "to harass, afflict, hunt down, or put to death, esp. for religious or political opinions [v PERSECUTED, PERSECUTING, PERSECUTES]\n",
  "PERSECUTED": "PERSECUTE, to harass, afflict, hunt down, or put to death, esp. for religious or political opinions [v]\n",
  "PERSECUTEE": "one who is persecuted [n -S]\n",
  "PERSECUTEES": "PERSECUTEE, one who is persecuted [n]\n",
  "PERSECUTES": "PERSECUTE, to harass, afflict, hunt down, or put to death, esp. for religious or political opinions [v]\n",
  "PERSECUTING": "PERSECUTE, to harass, afflict, hunt down, or put to death, esp. for religious or political opinions [v]\n",
  "PERSECUTION": "the act of persecuting [n -S]\n",
  "PERSECUTIONS": "PERSECUTION, the act of persecuting [n]\n",
  "PERSECUTIVE": "having the nature of persecution, also PERSECUTORY [adj]\n",
  "PERSECUTOR": "one who persecutes [n -S]\n",
  "PERSECUTORS": "PERSECUTOR, one who persecutes [n]\n",
  "PERSECUTORY": "having the nature of persecution, also PERSECUTIVE [adj]\n",
  "PERSEITIES": "PERSEITY, an independent existence per se [n]\n",
  "PERSEITY": "an independent existence per se [n PERSEITIES]\n",
  "PERSELINE": "(Spenser) purslane, also PURSLAIN [n -S]\n",
  "PERSELINES": "PERSELINE, (Spenser) purslane, also PURSLAIN [n]\n",
  "PERSES": "PERSE, (Spenser) to pierce, also PERCE, PEARCE [v]\n",
  "PERSEVERANCE": "the act of persevering [n -S]\n",
  "PERSEVERANCES": "PERSEVERANCE, the act of persevering [n]\n",
  "PERSEVERANT": "steadfast [adj]\n",
  "PERSEVERATE": "to repeat an action continually or habitually [v PERSEVERATED, PERSEVERATING, PERSEVERATES]\n",
  "PERSEVERATED": "PERSEVERATE, to repeat an action continually or habitually [v]\n",
  "PERSEVERATES": "PERSEVERATE, to repeat an action continually or habitually [v]\n",
  "PERSEVERATING": "PERSEVERATE, to repeat an action continually or habitually [v]\n",
  "PERSEVERATION": "continuation of something (as repetition of a word) usually to an exceptional degree or beyond a desired point [n -S]\n",
  "PERSEVERATIONS": "PERSEVERATION, continuation of something (as repetition of a word) usually to an exceptional degree or beyond a desired point [n]\n",
  "PERSEVERATIVE": "relating to perseveration [adj]\n",
  "PERSEVERATOR": "one who perseverates [n -S]\n",
  "PERSEVERATORS": "PERSEVERATOR, one who perseverates [n]\n",
  "PERSEVERE": "to continue steadfastly; to keep on striving [v PERSEVERED, PERSEVERING, PERSEVERES]\n",
  "PERSEVERED": "PERSEVERE, to continue steadfastly; to keep on striving [v]\n",
  "PERSEVERES": "PERSEVERE, to continue steadfastly; to keep on striving [v]\n",
  "PERSEVERING": "continuing steadfastly [adj PERSEVERINGLY]\n",
  "PERSEVERINGLY": "PERSEVERING, continuing steadfastly [adv]\n",
  "PERSICARIA": "a species of knotgrass with black-blotched leaves [n -S]\n",
  "PERSICARIAS": "PERSICARIA, a species of knotgrass with black-blotched leaves [n]\n",
  "PERSICO": "(French) a cordial made of the kernels of apricots, nectarines, etc. with refined spirit, also PERSICOT [n -S]\n",
  "PERSICOS": "PERSICO, (French) a cordial made of the kernels of apricots, nectarines, etc. with refined spirit, also PERSICOT [n]\n",
  "PERSICOT": "(French) a cordial made of the kernels of apricots, nectarines, etc. with refined spirit, also PERSICO [n -S]\n",
  "PERSICOTS": "PERSICOT, (French) a cordial made of the kernels of apricots, nectarines, etc. with refined spirit, also PERSICO [n]\n",
  "PERSIENNE": "(French) an Eastern cambric or muslin with a coloured printed pattern; (in plural) Persian blinds, outside shutters of thin movable slats [n -S]\n",
  "PERSIENNES": "PERSIENNE, (French) an Eastern cambric or muslin with a coloured printed pattern; (in plural) Persian blinds, outside shutters of thin movable slats [n]\n",
  "PERSIFLAGE": "(French) frivolous, bantering talk [n -S]\n",
  "PERSIFLAGES": "PERSIFLAGE, (French) frivolous, bantering talk [n]\n",
  "PERSIFLEUR": "(French) one who indulges in persiflage [n -S]\n",
  "PERSIFLEURS": "PERSIFLEUR, (French) one who indulges in persiflage [n]\n",
  "PERSIMMON": "a kind of plumlike fruit [n -S]\n",
  "PERSIMMONS": "PERSIMMON, a kind of plumlike fruit [n]\n",
  "PERSING": "PERSE, (Spenser) to pierce, also PERCE, PEARCE [v]\n",
  "PERSIST": "to continue resolutely [v -ED, -ING, -S]\n",
  "PERSISTED": "PERSIST, to continue resolutely [v]\n",
  "PERSISTENCE": "the action or fact of persisting, also PERSISTENCY [n -S]\n",
  "PERSISTENCES": "PERSISTENCE, the action or fact of persisting, also PERSISTENCY [n]\n",
  "PERSISTENCIES": "PERSISTENCY, the action or fact of persisting, also PERSISTENCE [n]\n",
  "PERSISTENCY": "the action or fact of persisting, also PERSISTENCE [n PERSISTENCIES]\n",
  "PERSISTENT": "persisting, lasting [adj PERSISTENTLY] / something that is persistent [n -S]\n",
  "PERSISTENTLY": "PERSISTENT, persisting, lasting [adv]\n",
  "PERSISTENTS": "PERSISTENT, something that is persistent [n]\n",
  "PERSISTER": "one who persists [n -S]\n",
  "PERSISTERS": "PERSISTER, one who persists [n]\n",
  "PERSISTING": "PERSIST, to continue resolutely [v]\n",
  "PERSISTINGLY": "PERSISTING, PERSIST, to continue resolutely [adv]\n",
  "PERSISTIVE": "(Shakespeare) persistent [adj]\n",
  "PERSISTS": "PERSIST, to continue resolutely [v]\n",
  "PERSNICKETIER": "PERSNICKETY, fussy about small details, also PERNICKETY [adj]\n",
  "PERSNICKETIEST": "PERSNICKETY, fussy about small details, also PERNICKETY [adj]\n",
  "PERSNICKETINESS": "the state of being persnickety, fussy about small details [n]\n",
  "PERSNICKETY": "fussy about small details, also PERNICKETY [adj PERSNICKETIER, PERSNICKETIEST]\n",
  "PERSON": "a human being [n -S]\n",
  "PERSONA": "(Latin) a character in a literary work or a public role [n PERSONAS or PERSONAE]\n",
  "PERSONABLE": "attractive in person [adj PERSONABLY]\n",
  "PERSONABLENESS": "PERSONABLE, attractive in person [n]\n",
  "PERSONABLY": "PERSONABLE, attractive in person [adv]\n",
  "PERSONAE": "PERSONA, (Latin) a character in a literary work or a public role [n]\n",
  "PERSONAGE": "a person, esp. an important or august one; a character in a play or story [n -S]\n",
  "PERSONAGES": "PERSONAGE, a person, esp. an important or august one; a character in a play or story [n]\n",
  "PERSONAL": "related to oneself [adj PERSONALLY] / an advertisement or notice in the personal column of a newspaper [n -S]\n",
  "PERSONALIA": "personal details, possessions or stories [n]\n",
  "PERSONALISATION": "the act of personalising, also PERSONALIZATION [n]\n",
  "PERSONALISE": "to make personal, also PERSONALIZE [v PERSONALISED, PERSONALISING, PERSONALISES]\n",
  "PERSONALISED": "PERSONALISE, to make personal, also PERSONALIZE [v]\n",
  "PERSONALISES": "PERSONALISE, to make personal, also PERSONALIZE [v]\n",
  "PERSONALISING": "PERSONALISE, to make personal, also PERSONALIZE [v]\n",
  "PERSONALISM": "the doctrine that humans possess spiritual freedom [n -S]\n",
  "PERSONALISMS": "PERSONALISM, the doctrine that humans possess spiritual freedom [n]\n",
  "PERSONALIST": "someone who writes personal notes; a believer in, or follower of, personalism [n -S]\n",
  "PERSONALISTIC": "relating to personalism [adj]\n",
  "PERSONALISTS": "PERSONALIST, someone who writes personal notes; a believer in, or follower of, personalism [n]\n",
  "PERSONALITIES": "PERSONALITY, the state of being a person [n]\n",
  "PERSONALITY": "the state of being a person [n PERSONALITIES]\n",
  "PERSONALIZATION": "the act of personalizing, also PERSONALISATION [n]\n",
  "PERSONALIZE": "to make personal, also PERSONALISE [v PERSONALIZED, PERSONALIZING, PERSONALIZES]\n",
  "PERSONALIZED": "PERSONALIZE, to make personal, also PERSONALISE [v]\n",
  "PERSONALIZES": "PERSONALIZE, to make personal, also PERSONALISE [v]\n",
  "PERSONALIZING": "PERSONALIZE, to make personal, also PERSONALISE [v]\n",
  "PERSONALLY": "PERSONAL, related to oneself [adv]\n",
  "PERSONALS": "PERSONAL, an advertisement or notice in the personal column of a newspaper [n]\n",
  "PERSONALTIES": "PERSONALTY, personal belongings and property [n]\n",
  "PERSONALTY": "personal belongings and property [n PERSONALTIES]\n",
  "PERSONAS": "PERSONA, (Latin) a character in a literary work or a public role [n]\n",
  "PERSONATE": "to assume the identity of, with intent to deceive [v PERSONATED, PERSONATING, PERSONATES]\n",
  "PERSONATED": "PERSONATE, to assume the identity of, with intent to deceive [v]\n",
  "PERSONATES": "PERSONATE, to assume the identity of, with intent to deceive [v]\n",
  "PERSONATING": "assume the identity of, with intent to deceive [n -S]\n",
  "PERSONATINGS": "PERSONATING, assume the identity of, with intent to deceive [n]\n",
  "PERSONATION": "the act of personating [n -S]\n",
  "PERSONATIONS": "PERSONATION, the act of personating [n]\n",
  "PERSONATIVE": "dramatic; presenting or presented through persons [adj]\n",
  "PERSONATOR": "one who personates [n -S]\n",
  "PERSONATORS": "PERSONATOR, one who personates [n]\n",
  "PERSONHOOD": "being a person [n -S]\n",
  "PERSONHOODS": "PERSONHOOD, being a person [n]\n",
  "PERSONIFIABLE": "that can be personified [adj]\n",
  "PERSONIFICATION": "the attribution of personality to an impersonal thing [n]\n",
  "PERSONIFIED": "PERSONIFY, to be the embodiment of [v]\n",
  "PERSONIFIER": "one who personifies [n -S]\n",
  "PERSONIFIERS": "PERSONIFIER, one who personifies [n]\n",
  "PERSONIFIES": "PERSONIFY, to be the embodiment of [v]\n",
  "PERSONIFY": "to be the embodiment of [v PERSONIFIED, PERSONIFYING, PERSONIFIES]\n",
  "PERSONIFYING": "PERSONIFY, to be the embodiment of [v]\n",
  "PERSONISE": "to personify, also PERSONIZE [v PERSONISED, PERSONISING, PERSONISES]\n",
  "PERSONISED": "PERSONISE, to personify, also PERSONIZE [v]\n",
  "PERSONISES": "PERSONISE, to personify, also PERSONIZE [v]\n",
  "PERSONISING": "PERSONISE, to personify, also PERSONIZE [v]\n",
  "PERSONIZE": "to personify, also PERSONISE [v PERSONIZED, PERSONIZING, PERSONIZES]\n",
  "PERSONIZED": "PERSONIZE, to personify, also PERSONISE [v]\n",
  "PERSONIZES": "PERSONIZE, to personify, also PERSONISE [v]\n",
  "PERSONIZING": "PERSONIZE, to personify, also PERSONISE [v]\n",
  "PERSONNED": "manned [adj]\n",
  "PERSONNEL": "the persons employed in any service [n -S]\n",
  "PERSONNELS": "PERSONNEL, the persons employed in any service [n]\n",
  "PERSONPOWER": "manpower, applying to either sex [n -S]\n",
  "PERSONPOWERS": "PERSONPOWER, manpower, applying to either sex [n]\n",
  "PERSONS": "PERSON, a human being [n]\n",
  "PERSPECTIVAL": "relating to perspective [adj]\n",
  "PERSPECTIVE": "a point of view [n -S] / relating or according to perspective [adj PERSPECTIVELY]\n",
  "PERSPECTIVELY": "PERSPECTIVE, relating or according to perspective [adv]\n",
  "PERSPECTIVES": "PERSPECTIVE, a point of view [n]\n",
  "PERSPECTIVISM": "the theory that things can only be known from an individual point of view at a particular time [n -S]\n",
  "PERSPECTIVISMS": "PERSPECTIVISM, the theory that things can only be known from an individual point of view at a particular time [n]\n",
  "PERSPECTIVIST": "a believer in perspectivism [n -S]\n",
  "PERSPECTIVISTS": "PERSPECTIVIST, a believer in perspectivism [n]\n",
  "PERSPEX": "an acrylic plastic consisting essentially of polymethyl methacrylate [n -ES]\n",
  "PERSPEXES": "PERSPEX, an acrylic plastic consisting essentially of polymethyl methacrylate [n]\n",
  "PERSPICACIOUS": "clear-minded; astute; perceptive [adj PERSPICACIOUSLY]\n",
  "PERSPICACIOUSLY": "PERSPICACIOUS, clear-minded; astute; perceptive [adv]\n",
  "PERSPICACITIES": "PERSPICACITY, the state of being perspicacious [n]\n",
  "PERSPICACITY": "the state of being perspicacious [n PERSPICACITIES]\n",
  "PERSPICUITIES": "PERSPICUITY, the state of being perspicuous, clear, easily understood [n]\n",
  "PERSPICUITY": "the state of being perspicuous, clear, easily understood [n PERSPICUITIES]\n",
  "PERSPICUOUS": "easily understood; clearly expressed [adj PERSPICUOUSLY]\n",
  "PERSPICUOUSLY": "PERSPICUOUS, easily understood; clearly expressed [adv]\n",
  "PERSPICUOUSNESS": "the state of being perspicuous [n]\n",
  "PERSPIRABLE": "capable of being perspired or of perspiring [adj]\n",
  "PERSPIRATE": "to sweat [v PERSPIRATED, PERSPIRATING, PERSPIRATES]\n",
  "PERSPIRATED": "PERSPIRATE, to sweat [v]\n",
  "PERSPIRATES": "PERSPIRATE, to sweat [v]\n",
  "PERSPIRATING": "PERSPIRATE, to sweat [v]\n",
  "PERSPIRATION": "the act of perspiring [n -S]\n",
  "PERSPIRATIONS": "PERSPIRATION, the act of perspiring [n]\n",
  "PERSPIRATORY": "of, relating to, secreting, or inducing perspiration [adj]\n",
  "PERSPIRE": "to exude sweat through the pores of the skin [v PERSPIRED, PERSPIRING, PERSPIRES]\n",
  "PERSPIRED": "PERSPIRE, to exude sweat through the pores of the skin [v]\n",
  "PERSPIRES": "PERSPIRE, to exude sweat through the pores of the skin [v]\n",
  "PERSPIRIER": "PERSPIRY, perspiring [adj]\n",
  "PERSPIRIEST": "PERSPIRY, perspiring [adj]\n",
  "PERSPIRING": "PERSPIRE, to exude sweat through the pores of the skin [v]\n",
  "PERSPIRINGLY": "PERSPIRING, PERSPIRE, to exude sweat through the pores of the skin [adv]\n",
  "PERSPIRY": "perspiring [adj PERSPIRIER, PERSPIRIEST]\n",
  "PERST": "(Spenser) pierced, also PEARST, PIERST [v]\n",
  "PERSTRINGE": "(obsolete) to constrain; to touch on; to censure [v PERSTRINGED, PERSTRINGING, PERSTRINGES]\n",
  "PERSTRINGED": "PERSTRINGE, (obsolete) to constrain; to touch on; to censure [v]\n",
  "PERSTRINGES": "PERSTRINGE, (obsolete) to constrain; to touch on; to censure [v]\n",
  "PERSTRINGING": "PERSTRINGE, (obsolete) to constrain; to touch on; to censure [v]\n",
  "PERSUADABILITY": "the quality of being persuadable [n]\n",
  "PERSUADABLE": "capable of being persuaded, also PERSUASIBLE [adj]\n",
  "PERSUADE": "to induce by reasoning or entreaty, also PERSWADE [v PERSUADED, PERSUADING, PERSUADES]\n",
  "PERSUADED": "PERSUADE, to induce by reasoning or entreaty, also PERSWADE [v]\n",
  "PERSUADER": "one who persuades [n -S]\n",
  "PERSUADERS": "PERSUADER, one who persuades [n]\n",
  "PERSUADES": "PERSUADE, to induce by reasoning or entreaty, also PERSWADE [v]\n",
  "PERSUADING": "PERSUADE, to induce by reasoning or entreaty, also PERSWADE [v]\n",
  "PERSUASIBILITY": "the state of being persuasible [n]\n",
  "PERSUASIBLE": "capable of being persuaded, also PERSUADABLE [adj]\n",
  "PERSUASION": "the act of persuading [n -S]\n",
  "PERSUASIONS": "PERSUASION, the act of persuading [n]\n",
  "PERSUASIVE": "tending to persuade [adj PERSUASIVELY] / that which persuades [n -S]\n",
  "PERSUASIVELY": "PERSUASIVE, tending to persuade [adv]\n",
  "PERSUASIVENESS": "PERSUASIVE, tending to persuade [n]\n",
  "PERSUASIVES": "PERSUASIVE, that which persuades [n]\n",
  "PERSUASORY": "persuasive [adj]\n",
  "PERSUE": "(Spenser) to follow, in order to overtake or capture, also POURSEW, POURSUE, PURSEW [v PERSUED, PERSUING, PERSUES]\n",
  "PERSUED": "PERSUE, (Spenser) to follow, in order to overtake or capture, also POURSEW, POURSUE, PURSEW [v]\n",
  "PERSUES": "PERSUE, (Spenser) to follow, in order to overtake or capture, also POURSEW, POURSUE, PURSEW [v]\n",
  "PERSUING": "PERSUE, (Spenser) to follow, in order to overtake or capture, also POURSEW, POURSUE, PURSEW [v]\n",
  "PERSULFATE": "a sulphuric acid salt of a base peroxide, also PERSULPHATE [n -S]\n",
  "PERSULFATES": "PERSULFATE, a sulphuric acid salt of a base peroxide, also PERSULPHATE [n]\n",
  "PERSULFURIC": "denoting a type of acid, also PERSULPHURIC [adj]\n",
  "PERSULPHATE": "that sulphate of a metal which contains the relatively greater quantity of oxygen or of the acid radical, also PERSULFATE [n -S]\n",
  "PERSULPHATES": "PERSULPHATE, that sulphate of a metal which contains the relatively greater quantity of oxygen or of the acid radical, also PERSULFATE [n]\n",
  "PERSULPHURIC": "denoting a type of acid, also PERSULFURIC [adj]\n",
  "PERSWADE": "to induce by reasoning or entreaty, also PERSUADE [v PERSWADED, PERSWADING, PERSWADES]\n",
  "PERSWADED": "PERSWADE, to induce by reasoning or entreaty, also PERSUADE [v]\n",
  "PERSWADES": "PERSWADE, to induce by reasoning or entreaty, also PERSUADE [v]\n",
  "PERSWADING": "PERSWADE, to induce by reasoning or entreaty, also PERSUADE [v]\n",
  "PERT": "impudent, jaunty [adj PERTER, PERTEST, PERTLY] / an impudent person [n -S]\n",
  "PERTAIN": "to have reference or relation [v -ED, -ING, -S]\n",
  "PERTAINED": "PERTAIN, to have reference or relation [v]\n",
  "PERTAINING": "PERTAIN, to have reference or relation [v]\n",
  "PERTAINS": "PERTAIN, to have reference or relation [v]\n",
  "PERTAKE": "(Shakespeare) to participate, also PARTAKE [v PERTOOK, PERTAKEN, PERTAKING, PERTAKES]\n",
  "PERTAKEN": "PERTAKE, (Shakespeare) to participate, also PARTAKE [v]\n",
  "PERTAKES": "PERTAKE, (Shakespeare) to participate, also PARTAKE [v]\n",
  "PERTAKING": "PERTAKE, (Shakespeare) to participate, also PARTAKE [v]\n",
  "PERTER": "PERT, impudent, jaunty [adj]\n",
  "PERTEST": "PERT, impudent, jaunty [adj]\n",
  "PERTHITE": "a variety of alkali feldspar [n -S]\n",
  "PERTHITES": "PERTHITE, a variety of alkali feldspar [n]\n",
  "PERTHITIC": "relating to perthite, a variety of alkali feldspar [adj]\n",
  "PERTINACIOUS": "stubbornly unyielding [adj PERTINACIOUSLY]\n",
  "PERTINACIOUSLY": "PERTINACIOUS, stubbornly unyielding [adv]\n",
  "PERTINACITIES": "PERTINACITY, the quality of holding unyieldingly to a position [n]\n",
  "PERTINACITY": "the quality of holding unyieldingly to a position [n PERTINACITIES]\n",
  "PERTINENCE": "the state of being pertinent, also PERTINENCY [n -S]\n",
  "PERTINENCES": "PERTINENCE, the state of being pertinent, also PERTINENCY [n]\n",
  "PERTINENCIES": "PERTINENCY, the state of being pertinent, also PERTINENCE [n]\n",
  "PERTINENCY": "the state of being pertinent, also PERTINENCE [n PERTINENCIES]\n",
  "PERTINENT": "belonging or related to the subject or matter in hand [adj PERTINENTLY] / a minor property forming part of a heritable estate [n -S]\n",
  "PERTINENTLY": "PERTINENT, belonging or related to the subject or matter in hand [adv]\n",
  "PERTINENTS": "PERTINENT, a minor property forming part of a heritable estate [n]\n",
  "PERTLY": "PERT, impudent, jaunty [adv]\n",
  "PERTNESS": "the quality of being pert [n -ES]\n",
  "PERTNESSES": "PERTNESS, the quality of being pert [n]\n",
  "PERTOOK": "PERTAKE, (Shakespeare) to participate, also PARTAKE [v]\n",
  "PERTS": "PERT, an impudent person [n]\n",
  "PERTURB": "to disturb greatly [v -ED, -ING, -S]\n",
  "PERTURBABLE": "able to be perturbed [adj PERTURBABLY]\n",
  "PERTURBABLY": "PERTURBABLE, able to be perturbed [adv]\n",
  "PERTURBANCE": "perturbation [n -S]\n",
  "PERTURBANCES": "PERTURBANCE, perturbation [n]\n",
  "PERTURBANT": "anything that perturbs [n -S]\n",
  "PERTURBANTS": "PERTURBANT, anything that perturbs [n]\n",
  "PERTURBATE": "to perturb [v PERTURBATED, PERTURBATING, PERTURBATES]\n",
  "PERTURBATED": "PERTURBATE, to perturb [v]\n",
  "PERTURBATES": "PERTURBATE, to perturb [v]\n",
  "PERTURBATING": "PERTURBATE, to perturb [v]\n",
  "PERTURBATION": "the action of perturbing [n -S]\n",
  "PERTURBATIONAL": "relating to perturbation [adj]\n",
  "PERTURBATIONS": "PERTURBATION, the action of perturbing [n]\n",
  "PERTURBATIVE": "tending to perturb [adj]\n",
  "PERTURBATOR": "one who perturbates [n -S]\n",
  "PERTURBATORIES": "PERTURBATORY, something tending to perturb [n]\n",
  "PERTURBATORS": "PERTURBATOR, one who perturbates [n]\n",
  "PERTURBATORY": "something tending to perturb [n PERTURBATORIES]\n",
  "PERTURBED": "PERTURB, to disturb greatly [v]\n",
  "PERTURBEDLY": "PERTURBED, PERTURB, to disturb greatly [adv]\n",
  "PERTURBER": "one who, or that which, perturbs [n -S]\n",
  "PERTURBERS": "PERTURBER, one who, or that which, perturbs [n]\n",
  "PERTURBING": "PERTURB, to disturb greatly [v]\n",
  "PERTURBINGLY": "PERTURBING, PERTURB, to disturb greatly [adv]\n",
  "PERTURBS": "PERTURB, to disturb greatly [v]\n",
  "PERTUSATE": "pierced at the apex [adj]\n",
  "PERTUSE": "punched or pierced, also PERTUSED [adj]\n",
  "PERTUSED": "punched or pierced, also PERTUSE [adj]\n",
  "PERTUSION": "the act of punching or piercing with a pointed instrument; as, pertusion of a vein [n -S]\n",
  "PERTUSIONS": "PERTUSION, the act of punching or piercing with a pointed instrument; as, pertusion of a vein [n]\n",
  "PERTUSSAL": "relating to pertussis, whooping cough [adj]\n",
  "PERTUSSES": "PERTUSSIS, (Latin) whooping cough [n]\n",
  "PERTUSSIS": "(Latin) whooping cough [n PERTUSSISES or PERTUSSES]\n",
  "PERTUSSISES": "PERTUSSIS, (Latin) whooping cough [n]\n",
  "PERUKE": "a kind of wig, also PERRUQUE [n -S]\n",
  "PERUKED": "adorned with a peruke [adj]\n",
  "PERUKES": "PERUKE, a kind of wig, also PERRUQUE [n]\n",
  "PERUSABLE": "that can be perused [adj]\n",
  "PERUSAL": "the act of perusing [n -S]\n",
  "PERUSALS": "PERUSAL, the act of perusing [n]\n",
  "PERUSE": "to read [v PERUSED, PERUSING, PERUSES]\n",
  "PERUSED": "PERUSE, to read [v]\n",
  "PERUSER": "one who peruses [n -S]\n",
  "PERUSERS": "PERUSER, one who peruses [n]\n",
  "PERUSES": "PERUSE, to read [v]\n",
  "PERUSING": "PERUSE, to read [v]\n",
  "PERV": "(short for) pervert, also PERVE, PERVO [n -S] / to behave as a sexual pervert [v -ED, -ING, -S]\n",
  "PERVADE": "to permeate the whole [v PERVADED, PERVADING, PERVADES]\n",
  "PERVADED": "PERVADE, to permeate the whole [v]\n",
  "PERVADER": "one who pervades [n -S]\n",
  "PERVADERS": "PERVADER, one who pervades [n]\n",
  "PERVADES": "PERVADE, to permeate the whole [v]\n",
  "PERVADING": "PERVADE, to permeate the whole [v]\n",
  "PERVASION": "the act of pervading [n -S]\n",
  "PERVASIONS": "PERVASION, the act of pervading [n]\n",
  "PERVASIVE": "tending to pervade [adj PERVASIVELY]\n",
  "PERVASIVELY": "PERVASIVE, tending to pervade [adv]\n",
  "PERVASIVENESS": "PERVASIVE, tending to pervade [n]\n",
  "PERVASIVENESSES": "PERVASIVENESS, PERVASIVE, tending to pervade [n]\n",
  "PERVE": "(short for) a pervert, also PERV, PERVO [n -S]\n",
  "PERVED": "PERV, to behave as a sexual pervert [v]\n",
  "PERVERSE": "wilfully deviating from desired or expected conduct [adj PERVERSER, PERVERSEST, PERVERSELY]\n",
  "PERVERSELY": "PERVERSE, wilfully deviating from desired or expected conduct [adv]\n",
  "PERVERSENESS": "the state of being perverse [n -ES]\n",
  "PERVERSENESSES": "PERVERSENESS, the state of being perverse [n]\n",
  "PERVERSER": "PERVERSE, wilfully deviating from desired or expected conduct [adj]\n",
  "PERVERSEST": "PERVERSE, wilfully deviating from desired or expected conduct [adj]\n",
  "PERVERSION": "the action of perverting [n -S]\n",
  "PERVERSIONS": "PERVERSION, the action of perverting [n]\n",
  "PERVERSITIES": "PERVERSITY, the quality of being perverse [n]\n",
  "PERVERSITY": "the quality of being perverse [n PERVERSITIES]\n",
  "PERVERSIVE": "tending to pervert [adj]\n",
  "PERVERT": "to turn away from the right course of action [v -ED, -ING, -S]\n",
  "PERVERTED": "PERVERT, to turn away from the right course of action [v]\n",
  "PERVERTEDLY": "PERVERTED, PERVERT, to turn away from the right course of action [adv]\n",
  "PERVERTEDNESS": "the state of being perverted [n -ES]\n",
  "PERVERTEDNESSES": "PERVERTEDNESS, the state of being perverted [n]\n",
  "PERVERTER": "one who perverts [n -S]\n",
  "PERVERTERS": "PERVERTER, one who perverts [n]\n",
  "PERVERTIBLE": "that can be perverted [adj]\n",
  "PERVERTING": "PERVERT, to turn away from the right course of action [v]\n",
  "PERVERTS": "PERVERT, to turn away from the right course of action [v]\n",
  "PERVES": "PERVE, (short for) a pervert, also PERV, PERVO [n]\n",
  "PERVIATE": "to make a way through [v PERVIATED, PERVIATING, PERVIATES]\n",
  "PERVIATED": "PERVIATE, to make a way through [v]\n",
  "PERVIATES": "PERVIATE, to make a way through [v]\n",
  "PERVIATING": "PERVIATE, to make a way through [v]\n",
  "PERVICACIES": "PERVICACY, (obsolete) the state of being pervicacious, stubborn, also PERVICACITY [n]\n",
  "PERVICACIOUS": "very stubborn [adj]\n",
  "PERVICACITIES": "PERVICACITY, the state of being pervicacious, stubborn, also PERVICACY [n]\n",
  "PERVICACITY": "the state of being pervicacious, stubborn, also PERVICACY [n PERVICACITIES]\n",
  "PERVICACY": "(obsolete) the state of being pervicacious, stubborn, also PERVICACITY [n PERVICACIES]\n",
  "PERVIER": "PERVY, perverted [adj]\n",
  "PERVIEST": "PERVY, perverted [adj]\n",
  "PERVING": "PERV, to behave as a sexual pervert [v]\n",
  "PERVIOUS": "capable of being penetrated [adj PERVIOUSLY]\n",
  "PERVIOUSLY": "PERVIOUS, capable of being penetrated [adv]\n",
  "PERVIOUSNESS": "the state of being pervious [n -ES]\n",
  "PERVIOUSNESSES": "PERVIOUSNESS, the state of being pervious [n]\n",
  "PERVO": "a pervert, also PERV, PERVE [n -S]\n",
  "PERVOS": "PERVO, a pervert, also PERV, PERVE [n]\n",
  "PERVS": "PERV, to behave as a sexual pervert [v]\n",
  "PERVY": "perverted [adj PERVIER, PERVIEST]\n",
  "PES": "a foot or footlike part [n PEDES]\n",
  "PESADE": "(French) a dressage manoeuvre in which a horse rears up on its hindlegs without forward movement [n -S]\n",
  "PESADES": "PESADE, (French) a dressage manoeuvre in which a horse rears up on its hindlegs without forward movement [n]\n",
  "PESANT": "(obsolete) a peasant, also PESAUNT, PEZANT [n -S]\n",
  "PESANTE": "(Italian) heavy in musical terms [adj]\n",
  "PESANTS": "PESANT, (obsolete) a peasant, also PESAUNT, PEZANT [n]\n",
  "PESAUNT": "(obsolete) a peasant, also PESANT, PEZANT [n -S]\n",
  "PESAUNTS": "PESAUNT, (obsolete) a peasant, also PESANT, PEZANT [n]\n",
  "PESCATARIAN": "one whose diet includes fish but no other meat, also PESCETARIAN [n -S]\n",
  "PESCATARIANS": "PESCATARIAN, one whose diet includes fish but no other meat, also PESCETARIAN [n]\n",
  "PESCETARIAN": "one whose diet includes fish but no other meat, also PESCATARIAN [n -S]\n",
  "PESCETARIANS": "PESCETARIAN, one whose diet includes fish but no other meat, also PESCATARIAN [n]\n",
  "PESETA": "(Spanish) a monetary unit of Spain [n -S]\n",
  "PESETAS": "PESETA, (Spanish) a monetary unit of Spain [n]\n",
  "PESEWA": "a monetary unit of Ghana [n -S]\n",
  "PESEWAS": "PESEWA, a monetary unit of Ghana [n]\n",
  "PESHMERGA": "the military forces of the autonomous region of Iraqi Kurdistan [n -S]\n",
  "PESHMERGAS": "PESHMERGA, the military forces of the autonomous region of Iraqi Kurdistan [n]\n",
  "PESHWA": "(Persian) a chief minister, also PEISHWA, PEISHWAH [n -S]\n",
  "PESHWAS": "PESHWA, (Persian) a chief minister, also PEISHWA, PEISHWAH [n]\n",
  "PESKIER": "PESKY, annoying [adj]\n",
  "PESKIEST": "PESKY, annoying [adj]\n",
  "PESKILY": "PESKY, annoying [adv]\n",
  "PESKINESS": "the state of being pesky [n -ES]\n",
  "PESKINESSES": "PESKINESS, the state of being pesky [n]\n",
  "PESKY": "annoying [adj PESKIER, PESKIEST, PESKILY]\n",
  "PESO": "(Spanish) a monetary unit of various Spanish-speaking countries [n -S]\n",
  "PESOS": "PESO, (Spanish) a monetary unit of various Spanish-speaking countries [n]\n",
  "PESSARIES": "PESSARY, a contraceptive device worn in the vagina [n]\n",
  "PESSARY": "a contraceptive device worn in the vagina [n PESSARIES]\n",
  "PESSIMA": "PESSIMUM, (Latin) a worst state, the opposite of optimum [n]\n",
  "PESSIMAL": "worst, the opposite of optimal [adj]\n",
  "PESSIMISM": "a tendency to look on the dark side of things [n -S]\n",
  "PESSIMISMS": "PESSIMISM, a tendency to look on the dark side of things [n]\n",
  "PESSIMIST": "one who tends to look on the dark side of things [n -S]\n",
  "PESSIMISTIC": "inclined to pessimism, also PESSIMISTICAL [adj PESSIMISTICALLY]\n",
  "PESSIMISTICAL": "inclined to pessimism, also PESSIMISTIC [adj PESSIMISTICALLY]\n",
  "PESSIMISTICALLY": "PESSIMISTICAL, inclined to pessimism, also PESSIMISTIC [adv]\n",
  "PESSIMISTS": "PESSIMIST, one who tends to look on the dark side of things [n]\n",
  "PESSIMUM": "(Latin) a worst state, the opposite of optimum [n PESSIMA]\n",
  "PEST": "an annoying person or thing [n -S]\n",
  "PESTER": "to bother [v -ED, -ING, -S]\n",
  "PESTERED": "PESTER, to bother [v]\n",
  "PESTERER": "one who pesters [n -S]\n",
  "PESTERERS": "PESTERER, one who pesters [n]\n",
  "PESTERING": "PESTER, to bother [v]\n",
  "PESTERINGLY": "PESTERING, PESTER, to bother [adv]\n",
  "PESTERMENT": "the act of pestering, or the state of being pestered [n -S]\n",
  "PESTERMENTS": "PESTERMENT, the act of pestering, or the state of being pestered [n]\n",
  "PESTEROUS": "inclined to pester [adj]\n",
  "PESTERS": "PESTER, to bother [v]\n",
  "PESTFUL": "pestilential [adj]\n",
  "PESTHOLE": "a place liable to epidemic disease [n -S]\n",
  "PESTHOLES": "PESTHOLE, a place liable to epidemic disease [n]\n",
  "PESTHOUSE": "(historical) a house or hospital for persons who are infected with any pestilential disease [n -S]\n",
  "PESTHOUSES": "PESTHOUSE, (historical) a house or hospital for persons who are infected with any pestilential disease [n]\n",
  "PESTICIDAL": "of or like a pesticide [adj]\n",
  "PESTICIDE": "a substance for killing pests [n -S]\n",
  "PESTICIDES": "PESTICIDE, a substance for killing pests [n]\n",
  "PESTIER": "PESTY, annoying [adj]\n",
  "PESTIEST": "PESTY, annoying [adj]\n",
  "PESTIFEROUS": "bringing plague or pestilence [adj PESTIFEROUSLY]\n",
  "PESTIFEROUSLY": "PESTIFEROUS, bringing plague or pestilence [adv]\n",
  "PESTIFEROUSNESS": "PESTIFEROUS, bringing plague or pestilence [n]\n",
  "PESTILENCE": "a fatal epidemic or disease, a plague [n -S]\n",
  "PESTILENCES": "PESTILENCE, a fatal epidemic or disease, a plague [n]\n",
  "PESTILENT": "deadly, producing pestilence [adj PESTILENTLY]\n",
  "PESTILENTIAL": "causing or tending to cause pestilence [adj PESTILENTIALLY]\n",
  "PESTILENTIALLY": "PESTILENTIAL, causing or tending to cause pestilence [adv]\n",
  "PESTILENTLY": "PESTILENT, deadly, producing pestilence [adv]\n",
  "PESTLE": "to crush with a club-shaped hand tool [v PESTLED, PESTLING, PESTLES]\n",
  "PESTLED": "PESTLE, to crush with a club-shaped hand tool [v]\n",
  "PESTLES": "PESTLE, to crush with a club-shaped hand tool [v]\n",
  "PESTLING": "PESTLE, to crush with a club-shaped hand tool [v]\n",
  "PESTO": "(Italian) an Italian sauce of basil, garlic and olive oil [n -S]\n",
  "PESTOLOGICAL": "related to pestology, the science of pests [adj]\n",
  "PESTOLOGIES": "PESTOLOGY, the science of pests [n]\n",
  "PESTOLOGIST": "one who studies pestology [n -S]\n",
  "PESTOLOGISTS": "PESTOLOGIST, one who studies pestology [n]\n",
  "PESTOLOGY": "the science of pests [n PESTOLOGIES]\n",
  "PESTOS": "PESTO, (Italian) an Italian sauce of basil, garlic and olive oil [n]\n",
  "PESTS": "PEST, an annoying person or thing [n]\n",
  "PESTY": "annoying [adj PESTIER, PESTIEST]\n",
  "PET": "to caress with the hand [v PETTED, PETTING, PETS]\n",
  "PETABYTE": "one quadrillion bytes [n -S]\n",
  "PETABYTES": "PETABYTE, one quadrillion bytes [n]\n",
  "PETAFLOP": "a unit of processing speed equal to 2 to the power of 50 floating-point operations per second [n -S]\n",
  "PETAFLOPS": "PETAFLOP, a unit of processing speed equal to 2 to the power of 50 floating-point operations per second [n]\n",
  "PETAHERTZ": "a very large unit of electrical frequency [n -ES]\n",
  "PETAHERTZES": "PETAHERTZ, a very large unit of electrical frequency [n]\n",
  "PETAL": "a leaflike part of a corolla [n -S]\n",
  "PETALED": "having petals, also PETALLED [adj]\n",
  "PETALIFEROUS": "bearing petals [adj]\n",
  "PETALINE": "of or like a petal, also PETALOID [adj]\n",
  "PETALISM": "a type of ostracism [n -S]\n",
  "PETALISMS": "PETALISM, a type of ostracism [n]\n",
  "PETALLED": "having petals, also PETALED [adj]\n",
  "PETALLIKE": "like a petal [adj]\n",
  "PETALODIC": "relating to petalody, the metamorphosis of various floral organs, usually stamens, into petals [adj]\n",
  "PETALODIES": "PETALODY, transformation of stamens into petals [n]\n",
  "PETALODY": "transformation of stamens into petals [n PETALODIES]\n",
  "PETALOID": "of or like a petal, also PETALINE [adj]\n",
  "PETALOMANIA": "an abnormal increase in number of petals [n -S]\n",
  "PETALOMANIAS": "PETALOMANIA, an abnormal increase in number of petals [n]\n",
  "PETALOUS": "having petals [adj]\n",
  "PETALS": "PETAL, a leaflike part of a corolla [n]\n",
  "PETAMETER": "ten to the power of fifteen metres, also PETAMETRE [n -S]\n",
  "PETAMETERS": "PETAMETER, ten to the power of fifteen metres, also PETAMETRE [n]\n",
  "PETAMETRE": "ten to the power of fifteen metres, also PETAMETER [n -S]\n",
  "PETAMETRES": "PETAMETRE, ten to the power of fifteen metres, also PETAMETER [n]\n",
  "PETANQUE": "(French) a game of bowls in which steel bowls are rolled towards a wooden post [n -S]\n",
  "PETANQUES": "PETANQUE, (French) a game of bowls in which steel bowls are rolled towards a wooden post [n]\n",
  "PETAR": "(Shakespeare) an explosive device, also PETARD [n -S]\n",
  "PETARA": "(Hindi) in India, a travelling box for clothes, also PITARA, PITARAH [n -S]\n",
  "PETARAS": "PETARA, (Hindi) in India, a travelling box for clothes, also PITARA, PITARAH [n]\n",
  "PETARD": "(French) an explosive device, also PETAR [n -S]\n",
  "PETARDS": "PETARD, (French) an explosive device, also PETAR [n]\n",
  "PETARIES": "PETARY, a region covered with peat, also PEATARY, PEATERY [n]\n",
  "PETARS": "PETAR, (Shakespeare) an explosive device, also PETARD [n]\n",
  "PETARY": "a region covered with peat, also PEATARY, PEATERY [n PETARIES]\n",
  "PETASOS": "(Greek) a broad-brimmed hat worn in ancient Greece, also PETASUS [n -ES]\n",
  "PETASOSES": "PETASOS, (Greek) a broad-brimmed hat worn in ancient Greece, also PETASUS [n]\n",
  "PETASUS": "(Latin) a broad-brimmed hat worn in ancient Greece, also PETASOS [n -ES]\n",
  "PETASUSES": "PETASUS, (Latin) a broad-brimmed hat worn in ancient Greece, also PETASOS [n]\n",
  "PETAURINE": "the flying phalanger [n -S]\n",
  "PETAURINES": "PETAURINE, the flying phalanger [n]\n",
  "PETAURIST": "a flying phalanger [n -S]\n",
  "PETAURISTS": "PETAURIST, a flying phalanger [n]\n",
  "PETCHARIES": "PETCHARY, the grey kingbird [n]\n",
  "PETCHARY": "the grey kingbird [n PETCHARIES]\n",
  "PETCOCK": "a valve for draining condensed steam from engine cylinders [n -S]\n",
  "PETCOCKS": "PETCOCK, a valve for draining condensed steam from engine cylinders [n]\n",
  "PETECHIA": "(Latin) a small hemorrhagic spot on a body surface [n PETECHIAE]\n",
  "PETECHIAE": "PETECHIA, (Latin) a small hemorrhagic spot on a body surface [n]\n",
  "PETECHIAL": "characterized by, or pertaining to, petechiae [adj]\n",
  "PETER": "to diminish gradually [v -ED, -ING, -S]\n",
  "PETERED": "PETER, to diminish gradually [v]\n",
  "PETERING": "PETER, to diminish gradually [v]\n",
  "PETERMAN": "a safe-blower [n PETERMEN]\n",
  "PETERMEN": "PETERMAN, a safe-blower [n]\n",
  "PETERS": "PETER, to diminish gradually [v]\n",
  "PETERSHAM": "a rough, knotted woollen cloth, used chiefly for men's overcoats [n -S]\n",
  "PETERSHAMS": "PETERSHAM, a rough, knotted woollen cloth, used chiefly for men's overcoats [n]\n",
  "PETHER": "(Scots) a pedlar, also PEDDER, PEDDLER, PEDLER [n -S]\n",
  "PETHERS": "PETHER, (Scots) a pedlar, also PEDDER, PEDDLER, PEDLER [n]\n",
  "PETHIDINE": "a pain-relieving drug used in childbirth, etc. [n -S]\n",
  "PETHIDINES": "PETHIDINE, a pain-relieving drug used in childbirth, etc. [n]\n",
  "PETILLANT": "(French) sparkling, used of wine [adj]\n",
  "PETIOLAR": "of or like a petiole, a leafstalk [adj]\n",
  "PETIOLATE": "having a petiole, a leafstalk, also PETIOLATED, PETIOLED [adj]\n",
  "PETIOLATED": "having a petiole, a leafstalk, also PETIOLATE, PETIOLED [adj]\n",
  "PETIOLE": "the stalk of a leaf [n -S]\n",
  "PETIOLED": "having a petiole [adj]\n",
  "PETIOLES": "PETIOLE, the stalk of a leaf [n]\n",
  "PETIOLULE": "a small petiole, or the petiole of a leaflet [n -S]\n",
  "PETIOLULES": "PETIOLULE, a small petiole, or the petiole of a leaflet [n]\n",
  "PETIT": "(French) small, esp. of build, also PETITE [adj]\n",
  "PETITE": "(French) a clothing size for small women [n -S]\n",
  "PETITENESS": "the state of being petite [n -ES]\n",
  "PETITENESSES": "PETITENESS, the state of being petite [n]\n",
  "PETITES": "PETITE, (French) a clothing size for small women [n]\n",
  "PETITIO": "a short form of petitio principii, a form of fallacious reasoning in which the conclusion has been assumed in the premises; begging the question [n -S]\n",
  "PETITION": "to make a formal request [v -ED, -ING, -S]\n",
  "PETITIONARY": "like a petition [adj]\n",
  "PETITIONED": "PETITION, to make a formal request [v]\n",
  "PETITIONER": "one who presents a petition [n -S]\n",
  "PETITIONERS": "PETITIONER, one who presents a petition [n]\n",
  "PETITIONING": "the act of making a petition [n -S]\n",
  "PETITIONINGS": "PETITIONING, the act of making a petition [n]\n",
  "PETITIONIST": "one who serves a petition [n -S]\n",
  "PETITIONISTS": "PETITIONIST, one who serves a petition [n]\n",
  "PETITIONS": "PETITION, to make a formal request [v]\n",
  "PETITIOS": "PETITIO, a short form of petitio principii, a form of fallacious reasoning in which the conclusion has been assumed in the premises; begging the question [n]\n",
  "PETITORY": "petitioning [adj]\n",
  "PETNAP": "to steal a pet for profit [v PETNAPPED, PETNAPING or PETNAPPING, PETNAPS]\n",
  "PETNAPER": "one who steals a pet [n -S]\n",
  "PETNAPERS": "PETNAPER, one who steals a pet [n]\n",
  "PETNAPING": "the kidnap of a pet [n -S]\n",
  "PETNAPINGS": "PETNAPING, the kidnap of a pet [n]\n",
  "PETNAPPED": "PETNAP, to steal a pet for profit [v]\n",
  "PETNAPPER": "one who kidnaps pets, also PETNAPER [n -S]\n",
  "PETNAPPERS": "PETNAPPER, one who kidnaps pets, also PETNAPER [n]\n",
  "PETNAPPING": "the kidnap of a pet [n -S]\n",
  "PETNAPPINGS": "PETNAPPING, the kidnap of a pet [n]\n",
  "PETNAPS": "PETNAP, to steal a pet for profit [v]\n",
  "PETRALE": "a food fish, a kind of sole [n -S]\n",
  "PETRALES": "PETRALE, a food fish, a kind of sole [n]\n",
  "PETRARIES": "PETRARY, a contrivance for hurling stones [n]\n",
  "PETRARY": "a contrivance for hurling stones [n PETRARIES]\n",
  "PETRE": "(colloquial) saltpetre [n -S]\n",
  "PETREL": "a kind of seabird [n -S]\n",
  "PETRELS": "PETREL, a kind of seabird [n]\n",
  "PETRES": "PETRE, (colloquial) saltpetre [n]\n",
  "PETRI": "as in petri dish, a shallow glass dish with an overlapping cover used for cultures of bacteria [adj]\n",
  "PETRICHOR": "a sweet smell that is produced when rain falls on parched earth [n -S]\n",
  "PETRICHORS": "PETRICHOR, a sweet smell that is produced when rain falls on parched earth [n]\n",
  "PETRIFACTION": "the process of petrifying [n -S]\n",
  "PETRIFACTIONS": "PETRIFACTION, the process of petrifying [n]\n",
  "PETRIFACTIVE": "petrifying, also PETRIFIC [adj]\n",
  "PETRIFIC": "petrifying [adj]\n",
  "PETRIFICATION": "turning to stone [n -S]\n",
  "PETRIFICATIONS": "PETRIFICATION, turning to stone [n]\n",
  "PETRIFIED": "PETRIFY, to convert into a stony substance [v]\n",
  "PETRIFIER": "an agent that petrifies [n -S]\n",
  "PETRIFIERS": "PETRIFIER, an agent that petrifies [n]\n",
  "PETRIFIES": "PETRIFY, to convert into a stony substance [v]\n",
  "PETRIFY": "to convert into a stony substance [v PETRIFIED, PETRIFYING, PETRIFIES]\n",
  "PETRIFYING": "PETRIFY, to convert into a stony substance [v]\n",
  "PETRISSAGE": "(French) massage by longitudinal rubbing and lateral squeezing [n -S]\n",
  "PETRISSAGES": "PETRISSAGE, (French) massage by longitudinal rubbing and lateral squeezing [n]\n",
  "PETROCHEMICAL": "of or relating to chemicals obtained from petroleum [adj PETROCHEMICALLY] / a chemical obtained from petroleum [n -S]\n",
  "PETROCHEMICALLY": "PETROCHEMICAL, of or relating to chemicals obtained from petroleum [adv]\n",
  "PETROCHEMICALS": "PETROCHEMICAL, a chemical obtained from petroleum [n]\n",
  "PETROCHEMIST": "someone who studies petrochemistry or works in the petrochemical industry [n -S]\n",
  "PETROCHEMISTRY": "the branch of chemistry concerned with the extraction of chemicals from petroleum [n]\n",
  "PETROCHEMISTS": "PETROCHEMIST, someone who studies petrochemistry or works in the petrochemical industry [n]\n",
  "PETROCURRENCIES": "PETROCURRENCY, currency, etc., acquired by the oil-producing countries as profit from the sale of their oil to the consumer countries [n]\n",
  "PETROCURRENCY": "currency, etc., acquired by the oil-producing countries as profit from the sale of their oil to the consumer countries [n PETROCURRENCIES]\n",
  "PETRODOLLAR": "a dollar's worth of foreign exchange obtained by a petroleum exporting country through sales abroad [n -S]\n",
  "PETRODOLLARS": "PETRODOLLAR, a dollar's worth of foreign exchange obtained by a petroleum exporting country through sales abroad [n]\n",
  "PETRODROME": "an African elephant shrew [n -S]\n",
  "PETRODROMES": "PETRODROME, an African elephant shrew [n]\n",
  "PETROGENESES": "PETROGENESIS, formation or development of rocks [n]\n",
  "PETROGENESIS": "formation or development of rocks [n PETROGENESES]\n",
  "PETROGENETIC": "relating to petrogenesis [adj]\n",
  "PETROGENIES": "PETROGENY, the study of the origin of rocks [n]\n",
  "PETROGENY": "the study of the origin of rocks [n PETROGENIES]\n",
  "PETROGLYPH": "an ancient rock-carving [n -S]\n",
  "PETROGLYPHIC": "of or like a petroglyph, an ancient rock-carving [adj]\n",
  "PETROGLYPHIES": "PETROGLYPHY, the art of carving on rocks [n]\n",
  "PETROGLYPHS": "PETROGLYPH, an ancient rock-carving [n]\n",
  "PETROGLYPHY": "the art of carving on rocks [n PETROGLYPHIES]\n",
  "PETROGRAM": "a picture on stone [n -S]\n",
  "PETROGRAMS": "PETROGRAM, a picture on stone [n]\n",
  "PETROGRAPHER": "a practitioner of petrography [n -S]\n",
  "PETROGRAPHERS": "PETROGRAPHER, a practitioner of petrography [n]\n",
  "PETROGRAPHIC": "relating to petrography, also PETROGRAPHICAL [adj]\n",
  "PETROGRAPHICAL": "relating to petrography, also PETROGRAPHIC [adj]\n",
  "PETROGRAPHIES": "PETROGRAPHY, the description and classification of rocks [n]\n",
  "PETROGRAPHY": "the description and classification of rocks [n PETROGRAPHIES]\n",
  "PETROL": "to supply with petrol (gasoline) [v PETROLLED, PETROLLING, PETROLS]\n",
  "PETROLAGE": "treatment with petrol to stamp out mosquitoes [n -S]\n",
  "PETROLAGES": "PETROLAGE, treatment with petrol to stamp out mosquitoes [n]\n",
  "PETROLATUM": "petroleum jelly [n -S]\n",
  "PETROLATUMS": "PETROLATUM, petroleum jelly [n]\n",
  "PETROLEOUS": "containing or rich in petroleum [adj]\n",
  "PETROLEUM": "a general term including both oil and natural gas [n -S]\n",
  "PETROLEUMS": "PETROLEUM, a general term including both oil and natural gas [n]\n",
  "PETROLEUR": "(French) a rioter who uses petroleum, as in the Paris uprising of 1871 [n -S]\n",
  "PETROLEURS": "PETROLEUR, (French) a rioter who uses petroleum, as in the Paris uprising of 1871 [n]\n",
  "PETROLEUSE": "(French) a female petroleur, one who makes use of petroleum for incendiary purposes [n -S]\n",
  "PETROLEUSES": "PETROLEUSE, (French) a female petroleur, one who makes use of petroleum for incendiary purposes [n]\n",
  "PETROLHEAD": "a motor vehicle enthusiast [n -S]\n",
  "PETROLHEADS": "PETROLHEAD, a motor vehicle enthusiast [n]\n",
  "PETROLIC": "derived from petroleum [adj]\n",
  "PETROLIFEROUS": "bearing petroleum [adj]\n",
  "PETROLLED": "PETROL, to supply with petrol (gasoline) [v]\n",
  "PETROLLING": "PETROL, to supply with petrol (gasoline) [v]\n",
  "PETROLOGIC": "relating to petrology, also PETROLOGICAL [adj PETROLOGICALLY]\n",
  "PETROLOGICAL": "relating to petrology, also PETROLOGIC [adj PETROLOGICALLY]\n",
  "PETROLOGICALLY": "PETROLOGICAL, relating to petrology, also PETROLOGIC [adv]\n",
  "PETROLOGIES": "PETROLOGY, the geological study of rocks [n]\n",
  "PETROLOGIST": "a student of petrology, the geological study of rocks [n -S]\n",
  "PETROLOGISTS": "PETROLOGIST, a student of petrology, the geological study of rocks [n]\n",
  "PETROLOGY": "the geological study of rocks [n PETROLOGIES]\n",
  "PETROLS": "PETROL, to supply with petrol (gasoline) [v]\n",
  "PETROMONEY": "money from oil revenues [n -S]\n",
  "PETROMONEYS": "PETROMONEY, money from oil revenues [n]\n",
  "PETROMONIES": "PETROMONEY, money from oil revenues [n]\n",
  "PETRONEL": "a sort of hand cannon, or portable firearm, used in France in the 15th century [n -S]\n",
  "PETRONELLA": "a Scottish country dance [n -S]\n",
  "PETRONELLAS": "PETRONELLA, a Scottish country dance [n]\n",
  "PETRONELS": "PETRONEL, a sort of hand cannon, or portable firearm, used in France in the 15th century [n]\n",
  "PETROPHYSICAL": "relating to petrophysics [adj]\n",
  "PETROPHYSICIST": "a student of petrophysics [n -S]\n",
  "PETROPHYSICISTS": "PETROPHYSICIST, a student of petrophysics [n]\n",
  "PETROPHYSICS": "that branch of physics relating to the physical properties of rocks [n]\n",
  "PETROPOUNDS": "money from oil revenues [n]\n",
  "PETROSAL": "the stony part of the temporal bone around the inner ear [n -S]\n",
  "PETROSALS": "PETROSAL, the stony part of the temporal bone around the inner ear [n]\n",
  "PETROSTATE": "a small oil-rich country in which institutions are weak and wealth and power are concentrated in the hands of the few [n -S]\n",
  "PETROSTATES": "PETROSTATE, a small oil-rich country in which institutions are weak and wealth and power are concentrated in the hands of the few [n]\n",
  "PETROUS": "resembling stone in hardness [adj]\n",
  "PETS": "PET, to caress with the hand [v]\n",
  "PETSAI": "(Chinese) Chinese cabbage [n -S]\n",
  "PETSAIS": "PETSAI, (Chinese) Chinese cabbage [n]\n",
  "PETTABLE": "able to be petted [adj]\n",
  "PETTED": "PET, to caress with the hand [v]\n",
  "PETTEDLY": "peevishly [adv]\n",
  "PETTEDNESS": "the state of being petted [n -ES]\n",
  "PETTEDNESSES": "PETTEDNESS, the state of being petted [n]\n",
  "PETTER": "one who pets [n -S]\n",
  "PETTERS": "PETTER, one who pets [n]\n",
  "PETTI": "(short for) petticoat [n -S]\n",
  "PETTICHAPS": "(dialect) the garden warbler [n -ES]\n",
  "PETTICHAPSES": "PETTICHAPS, (dialect) the garden warbler [n]\n",
  "PETTICOAT": "a skirt, esp. an underskirt, or a garment of which it forms part [n -S]\n",
  "PETTICOATED": "wearing a petticoat [adj]\n",
  "PETTICOATS": "PETTICOAT, a skirt, esp. an underskirt, or a garment of which it forms part [n]\n",
  "PETTIER": "PETTY, insignificant [adj]\n",
  "PETTIES": "PETTY, a junior schoolboy [n]\n",
  "PETTIEST": "PETTY, insignificant [adj]\n",
  "PETTIFOG": "to quibble [v PETTIFOGGED, PETTIFOGGING, PETTIFOGS]\n",
  "PETTIFOGGED": "PETTIFOG, to quibble [v]\n",
  "PETTIFOGGER": "a petty, quibbling, unscrupulous lawyer [n -S]\n",
  "PETTIFOGGERIES": "PETTIFOGGERY, dealing with trivial law cases [n]\n",
  "PETTIFOGGERS": "PETTIFOGGER, a petty, quibbling, unscrupulous lawyer [n]\n",
  "PETTIFOGGERY": "dealing with trivial law cases [n PETTIFOGGERIES]\n",
  "PETTIFOGGING": "the act of pettifogging [n -S]\n",
  "PETTIFOGGINGS": "PETTIFOGGING, the act of pettifogging [n]\n",
  "PETTIFOGS": "PETTIFOG, to quibble [v]\n",
  "PETTILY": "PETTY, insignificant [adv]\n",
  "PETTINESS": "the state of being petty [n -ES]\n",
  "PETTINESSES": "PETTINESS, the state of being petty [n]\n",
  "PETTING": "amorous caressing and kissing [n -S]\n",
  "PETTINGS": "PETTING, amorous caressing and kissing [n]\n",
  "PETTIS": "PETTI, (short for) petticoat [n]\n",
  "PETTISH": "sulky, petulant [adj PETTISHLY]\n",
  "PETTISHLY": "PETTISH, sulky, petulant [adv]\n",
  "PETTISHNESS": "the state of being pettish [n -ES]\n",
  "PETTISHNESSES": "PETTISHNESS, the state of being pettish [n]\n",
  "PETTITOES": "pigs' feet as food [n]\n",
  "PETTLE": "(Scots) to indulge, pet [v PETTLED, PETTLING, PETTLES]\n",
  "PETTLED": "PETTLE, (Scots) to indulge, pet [v]\n",
  "PETTLES": "PETTLE, (Scots) to indulge, pet [v]\n",
  "PETTLING": "PETTLE, (Scots) to indulge, pet [v]\n",
  "PETTO": "(Italian) breast, as in the phrase in petto, in one's secret thoughts [n PETTI]\n",
  "PETTY": "insignificant [adj PETTIER, PETTIEST, PETTILY] / a junior schoolboy [n PETTIES]\n",
  "PETULANCE": "peevish impatience, also PETULANCY [n -S]\n",
  "PETULANCES": "PETULANCE, peevish impatience, also PETULANCY [n]\n",
  "PETULANCIES": "PETULANCY, peevish impatience, also PETULANCE [n]\n",
  "PETULANCY": "peevish impatience, also PETULANCE [n PETULANCIES]\n",
  "PETULANT": "peevish [adj]\n",
  "PETULANTLY": "PETULANT, peevish [adv]\n",
  "PETUNIA": "(Tupi) a South American genus of ornamental plants closely related to tobacco [n -S]\n",
  "PETUNIAS": "PETUNIA, (Tupi) a South American genus of ornamental plants closely related to tobacco [n]\n",
  "PETUNTSE": "(Chinese) a feldspathic rock used in making Chinese porcelain, also PETUNTZE [n -S]\n",
  "PETUNTSES": "PETUNTSE, (Chinese) a feldspathic rock used in making Chinese porcelain, also PETUNTZE [n]\n",
  "PETUNTZE": "(Chinese) a feldspathic rock used in making Chinese porcelain, also PETUNTSE [n -S]\n",
  "PETUNTZES": "PETUNTZE, (Chinese) a feldspathic rock used in making Chinese porcelain, also PETUNTSE [n]\n",
  "PEW": "a bench for seating people in church [n -S]\n",
  "PEWEE": "a small, olive-brown North American bird [n -S]\n",
  "PEWEES": "PEWEE, a small, olive-brown North American bird [n]\n",
  "PEWHOLDER": "one who has his or her own pew in a church [n -S]\n",
  "PEWHOLDERS": "PEWHOLDER, one who has his or her own pew in a church [n]\n",
  "PEWIT": "a bird, the lapwing or plover, also PEEWEE, PEEWIT [n -S]\n",
  "PEWITS": "PEWIT, a bird, the lapwing or plover, also PEEWEE, PEEWIT [n]\n",
  "PEWS": "PEW, a bench for seating people in church [n]\n",
  "PEWTER": "an alloy of tin, antimony, and copper used for domestic utensils [n -S]\n",
  "PEWTERER": "one who makes articles of pewter [n -S]\n",
  "PEWTERERS": "PEWTERER, one who makes articles of pewter [n]\n",
  "PEWTERIER": "PEWTERY, of or like pewter [adj]\n",
  "PEWTERIEST": "PEWTERY, of or like pewter [adj]\n",
  "PEWTERS": "PEWTER, an alloy of tin, antimony, and copper used for domestic utensils [n]\n",
  "PEWTERY": "of or like pewter [adj PEWTERIER, PEWTERIEST]\n",
  "PEYOTE": "(Nahuatl) a hallucinogen derived from cactus [n -S]\n",
  "PEYOTES": "PEYOTE, (Nahuatl) a hallucinogen derived from cactus [n]\n",
  "PEYOTISM": "the ceremonial drinking of peyote [n -S]\n",
  "PEYOTISMS": "PEYOTISM, the ceremonial drinking of peyote [n]\n",
  "PEYOTIST": "one who practises peyotism, the taking of peyote, esp. as part of a religious ceremony [n -S]\n",
  "PEYOTISTS": "PEYOTIST, one who practises peyotism, the taking of peyote, esp. as part of a religious ceremony [n]\n",
  "PEYOTL": "(Nahuatl) a Mexican intoxicant made from cactus tops, also PEYOTE [n -S]\n",
  "PEYOTLS": "PEYOTL, (Nahuatl) a Mexican intoxicant made from cactus tops, also PEYOTE [n]\n",
  "PEYSE": "to weigh, also PEISE, PEASE, PEAZE, PEIZE, POYSE [v PEYSED, PEYSING, PEYSES]\n",
  "PEYSED": "PEYSE, to weigh, also PEISE, PEASE, PEAZE, PEIZE, POYSE [v]\n",
  "PEYSES": "PEYSE, to weigh, also PEISE, PEASE, PEAZE, PEIZE, POYSE [v]\n",
  "PEYSING": "PEYSE, to weigh, also PEISE, PEASE, PEAZE, PEIZE, POYSE [v]\n",
  "PEYTRAL": "a piece of armour for the breast of a horse, also PEYTREL, POITREL [n -S]\n",
  "PEYTRALS": "PEYTRAL, a piece of armour for the breast of a horse, also PEYTREL, POITREL [n]\n",
  "PEYTREL": "a piece of armour for the breast of a horse, also PEYTRAL, POITREL [n -S]\n",
  "PEYTRELS": "PEYTREL, a piece of armour for the breast of a horse, also PEYTRAL, POITREL [n]\n",
  "PEZANT": "a peasant, also PESANT, PESAUNT [n -S]\n",
  "PEZANTS": "PEZANT, a peasant, also PESANT, PESAUNT [n]\n",
  "PEZIZOID": "resembling fungi of the Peziza genus [adj]\n",
  "PFENNIG": "(German) a German coin, also PFENNING [n PFENNIGS or PFENNIGE]\n",
  "PFENNIGE": "PFENNIG, (German) a German coin, also PFENNING [n]\n",
  "PFENNIGS": "PFENNIG, (German) a German coin, also PFENNING [n]\n",
  "PFENNING": "(German) a German coin, also PFENNIG [n -S]\n",
  "PFENNINGS": "PFENNING, (German) a German coin, also PFENNIG [n]\n",
  "PFFT": "used to express a sudden ending [interj]\n",
  "PFUI": "an exclamation of contempt, scorn etc., also PHOOEY [interj]\n",
  "PHABLET": "a handheld personal computer between a smartphone and a tablet in size and which combines features of both, also FABLET [n -S]\n",
  "PHABLETS": "PHABLET, a handheld personal computer between a smartphone and a tablet in size and which combines features of both, also FABLET [n]\n",
  "PHACELIA": "any of various chiefly annual North American plants, with clustered blue, violet, or white flowers, frequently grown for ornament [n -S]\n",
  "PHACELIAS": "PHACELIA, any of various chiefly annual North American plants, with clustered blue, violet, or white flowers, frequently grown for ornament [n]\n",
  "PHACOID": "lens-shaped, lentil-shaped, also PHACOIDAL [adj]\n",
  "PHACOIDAL": "lens-shaped, lentil-shaped, also PHACOID [adj]\n",
  "PHACOLITE": "a colorless variety of chabazite, a mineral of the zeolite group [n -S]\n",
  "PHACOLITES": "PHACOLITE, a colorless variety of chabazite, a mineral of the zeolite group [n]\n",
  "PHACOLITH": "an intrusive mass of igneous rock situated between strata at the top of an anticline or the bottom of a syncline [n -S]\n",
  "PHACOLITHS": "PHACOLITH, an intrusive mass of igneous rock situated between strata at the top of an anticline or the bottom of a syncline [n]\n",
  "PHAEIC": "(Greek) dusky [adj]\n",
  "PHAEISM": "duskiness, incomplete melanism (in butterflies etc.) [n -S]\n",
  "PHAEISMS": "PHAEISM, duskiness, incomplete melanism (in butterflies etc.) [n]\n",
  "PHAELONION": "an Eastern vestment like a chasuble, also PHELONION [n -S]\n",
  "PHAELONIONS": "PHAELONION, an Eastern vestment like a chasuble, also PHELONION [n]\n",
  "PHAENOGAM": "(Greek) any plant of the class Phaenogamia, flowering plants, also PHENOGAM [n -S]\n",
  "PHAENOGAMIC": "of or like a phaenogam, a flowering plant, also PHAENOGAMOUS [adj]\n",
  "PHAENOGAMOUS": "of or like a phaenogam, a flowering plant, also PHAENOGAMIC [adj]\n",
  "PHAENOGAMS": "PHAENOGAM, (Greek) any plant of the class Phaenogamia, flowering plants, also PHENOGAM [n]\n",
  "PHAENOLOGIES": "PHAENOLOGY, the study of organisms as affected by climate, also PHENOLOGY [n]\n",
  "PHAENOLOGY": "the study of organisms as affected by climate, also PHENOLOGY [n PHAENOLOGIES]\n",
  "PHAENOMENA": "PHAENOMENON, anything directly apprehended by the senses or one of them, also PHENOMENON [n]\n",
  "PHAENOMENON": "anything directly apprehended by the senses or one of them, also PHENOMENON [n PHAENOMENA]\n",
  "PHAENOTYPE": "to categorise by phaenotype, the sum of the attributes of an individual, regarded as resulting from the interaction of its genotype with its environment, also PHENOTYPE [v PHAENOTYPED, PHAENOTYPING, PHAENOTYPES]\n",
  "PHAENOTYPED": "PHAENOTYPE, to categorise by phaenotype, the sum of the attributes of an individual, regarded as resulting from the interaction of its genotype with its environment, also PHENOTYPE [v]\n",
  "PHAENOTYPES": "PHAENOTYPE, to categorise by phaenotype, the sum of the attributes of an individual, regarded as resulting from the interaction of its genotype with its environment, also PHENOTYPE [v]\n",
  "PHAENOTYPING": "PHAENOTYPE, to categorise by phaenotype, the sum of the attributes of an individual, regarded as resulting from the interaction of its genotype with its environment, also PHENOTYPE [v]\n",
  "PHAEOMELANIN": "a reddish-brown pigment in animals, including birds [n -S]\n",
  "PHAEOMELANINS": "PHAEOMELANIN, a reddish-brown pigment in animals, including birds [n]\n",
  "PHAETON": "(Greek) a light two-horse four-wheeled open carriage [n -S]\n",
  "PHAETONS": "PHAETON, (Greek) a light two-horse four-wheeled open carriage [n]\n",
  "PHAGE": "(short for) a bacteriophage, a bacterium that eats other bacteria [n -S]\n",
  "PHAGEDAENA": "hospital gangrene, a rapidly spreading destructive ulcer, also PHAGEDENA [n -S]\n",
  "PHAGEDAENAS": "PHAGEDAENA, hospital gangrene, a rapidly spreading destructive ulcer, also PHAGEDENA [n]\n",
  "PHAGEDAENIC": "relating to phagedaena, hospital gangrene, also PHAGEDENIC [adj]\n",
  "PHAGEDENA": "hospital gangrene, a rapidly spreading destructive ulcer, also PHAGEDAENA [n -S]\n",
  "PHAGEDENAS": "PHAGEDENA, hospital gangrene, a rapidly spreading destructive ulcer, also PHAGEDAENA [n]\n",
  "PHAGEDENIC": "relating to phagedena, hospital gangrene, also PHAGEDAENIC [adj]\n",
  "PHAGES": "PHAGE, (short for) a bacteriophage, a bacterium that eats other bacteria [n]\n",
  "PHAGOCYTE": "a white blood corpuscle that engulfs bacteria and other harmful particles [n -S]\n",
  "PHAGOCYTES": "PHAGOCYTE, a white blood corpuscle that engulfs bacteria and other harmful particles [n]\n",
  "PHAGOCYTIC": "of or like a phagocyte, also PHAGOCYTICAL [adj]\n",
  "PHAGOCYTICAL": "of or like a phagocyte, also PHAGOCYTIC [adj]\n",
  "PHAGOCYTISE": "to consume by phagocytosis, also PHAGOCYTIZE [v PHAGOCYTISED, PHAGOCYTISING, PHAGOCYTISES]\n",
  "PHAGOCYTISED": "PHAGOCYTISE, to consume by phagocytosis, also PHAGOCYTIZE [v]\n",
  "PHAGOCYTISES": "PHAGOCYTISE, to consume by phagocytosis, also PHAGOCYTIZE [v]\n",
  "PHAGOCYTISING": "PHAGOCYTISE, to consume by phagocytosis, also PHAGOCYTIZE [v]\n",
  "PHAGOCYTISM": "the nature or function of a phagocyte [n -S]\n",
  "PHAGOCYTISMS": "PHAGOCYTISM, the nature or function of a phagocyte [n]\n",
  "PHAGOCYTIZE": "to consume by phagocytosis, also PHAGOCYTISE [v PHAGOCYTIZED, PHAGOCYTIZING, PHAGOCYTIZES]\n",
  "PHAGOCYTIZED": "PHAGOCYTIZE, to consume by phagocytosis, also PHAGOCYTISE [v]\n",
  "PHAGOCYTIZES": "PHAGOCYTIZE, to consume by phagocytosis, also PHAGOCYTISE [v]\n",
  "PHAGOCYTIZING": "PHAGOCYTIZE, to consume by phagocytosis, also PHAGOCYTISE [v]\n",
  "PHAGOCYTOSE": "to subject to phagocytic action [v PHAGOCYTOSED, PHAGOCYTOSING, PHAGOCYTOSES]\n",
  "PHAGOCYTOSED": "PHAGOCYTOSE, to subject to phagocytic action [v]\n",
  "PHAGOCYTOSES": "PHAGOCYTOSIS, the destruction of harmful elements by phagocytes [n]\n",
  "PHAGOCYTOSING": "PHAGOCYTOSE, to subject to phagocytic action [v]\n",
  "PHAGOCYTOSIS": "the destruction of harmful elements by phagocytes [n PHAGOCYTOSES]\n",
  "PHAGOCYTOTIC": "relating to phagocytosis [adj]\n",
  "PHAGOMANIA": "a compulsive desire to eat [n -S]\n",
  "PHAGOMANIAC": "one who suffers from phagomania, a compulsive desire to eat [n -S]\n",
  "PHAGOMANIACS": "PHAGOMANIAC, one who suffers from phagomania, a compulsive desire to eat [n]\n",
  "PHAGOMANIAS": "PHAGOMANIA, a compulsive desire to eat [n]\n",
  "PHAGOPHOBIA": "fear of eating [n -S]\n",
  "PHAGOPHOBIAS": "PHAGOPHOBIA, fear of eating [n]\n",
  "PHAGOSOME": "part of a biological cell [n -S]\n",
  "PHAGOSOMES": "PHAGOSOME, part of a biological cell [n]\n",
  "PHALANGAL": "of or pertaining to the phalanges, the bones of a digit [adj]\n",
  "PHALANGE": "any bone of a finger or toe [n -S]\n",
  "PHALANGEAL": "pertaining to a phalange, the bone of a digit (finger or toe) [adj]\n",
  "PHALANGER": "any of several kinds of long-tailed Australian marsupial [n -S]\n",
  "PHALANGERS": "PHALANGER, any of several kinds of long-tailed Australian marsupial [n]\n",
  "PHALANGES": "PHALANGE, any bone of a finger or toe [n]\n",
  "PHALANGID": "one of the Phalangoidea, a long-legged arachnid, a harvest-spider [n -S]\n",
  "PHALANGIDS": "PHALANGID, one of the Phalangoidea, a long-legged arachnid, a harvest-spider [n]\n",
  "PHALANGIST": "any arboreal marsupial of the genus Phalangista [n -S]\n",
  "PHALANGISTS": "PHALANGIST, any arboreal marsupial of the genus Phalangista [n]\n",
  "PHALANSTERIAN": "a person who supports the idea of phalansterism, the Fourier land system [n -S]\n",
  "PHALANSTERIANS": "PHALANSTERIAN, a person who supports the idea of phalansterism, the Fourier land system [n]\n",
  "PHALANSTERIES": "PHALANSTERY, a Fourierist cooperative community [n]\n",
  "PHALANSTERISM": "support for a system involving a phalanstery, a Fourierist cooperative community [n -S]\n",
  "PHALANSTERISMS": "PHALANSTERISM, support for a system involving a phalanstery, a Fourierist cooperative community [n]\n",
  "PHALANSTERIST": "a support of the Fourier system of land control [n -S]\n",
  "PHALANSTERISTS": "PHALANSTERIST, a support of the Fourier system of land control [n]\n",
  "PHALANSTERY": "a Fourierist cooperative community [n PHALANSTERIES]\n",
  "PHALANX": "a formation of infantry in ancient Greece [n PHALANXES] / a bone of the finger [n PHALANGES]\n",
  "PHALANXES": "PHALANX, a formation of infantry in ancient Greece [n]\n",
  "PHALAROPE": "a small sandpiper-like shore bird [n -S]\n",
  "PHALAROPES": "PHALAROPE, a small sandpiper-like shore bird [n]\n",
  "PHALLI": "PHALLUS, (Latin) the penis; a symbol of generation in primitive religions [n]\n",
  "PHALLIC": "pertaining to the phallus, the penis, a symbol of generation in primitive religions [adj PHALLICALLY]\n",
  "PHALLICALLY": "PHALLIC, pertaining to the phallus, the penis, a symbol of generation in primitive religions [adv]\n",
  "PHALLICISM": "worship of the phallus, or generative power of nature [n -S]\n",
  "PHALLICISMS": "PHALLICISM, worship of the phallus, or generative power of nature [n]\n",
  "PHALLICIST": "one who practises phallicism, worship of the phallus [n -S]\n",
  "PHALLICISTS": "PHALLICIST, one who practises phallicism, worship of the phallus [n]\n",
  "PHALLIN": "a type of fungal poison [n -S]\n",
  "PHALLINS": "PHALLIN, a type of fungal poison [n]\n",
  "PHALLISM": "worship of the phallus as symbolic of nature's creative power [n -S]\n",
  "PHALLISMS": "PHALLISM, worship of the phallus as symbolic of nature's creative power [n]\n",
  "PHALLIST": "an adherent of phallism [n -S]\n",
  "PHALLISTS": "PHALLIST, an adherent of phallism [n]\n",
  "PHALLOCENTRIC": "centered on or emphasizing the masculine point of view [adj]\n",
  "PHALLOCENTRISM": "the state of being phallocentric [n -S]\n",
  "PHALLOCENTRISMS": "PHALLOCENTRISM, the state of being phallocentric [n]\n",
  "PHALLOCRAT": "one who assumes the naturalness of male dominance [n -S]\n",
  "PHALLOCRATIC": "of or like a phallocrat, one who assumes the naturality of male dominance [adj]\n",
  "PHALLOCRATS": "PHALLOCRAT, one who assumes the naturalness of male dominance [n]\n",
  "PHALLOID": "phallus shaped [adj]\n",
  "PHALLOIDIN": "one of the poisons occurring in the fungus Amanita phalloides [n -S]\n",
  "PHALLOIDINS": "PHALLOIDIN, one of the poisons occurring in the fungus Amanita phalloides [n]\n",
  "PHALLUS": "(Latin) the penis; a symbol of generation in primitive religions [n PHALLI or PHALLUSES]\n",
  "PHALLUSES": "PHALLUS, (Latin) the penis; a symbol of generation in primitive religions [n]\n",
  "PHANEROGAM": "a seed-plant or spermatophyte, e.g. the flowering plants and gymnosperms [n -S]\n",
  "PHANEROGAMIC": "like a phanerogam, a seed-plant or spermatophyte, also PHANEROGAMOUS [adj]\n",
  "PHANEROGAMOUS": "like a phanerogam, a seed-plant or spermatophyte, also PHANEROGAMIC [adj]\n",
  "PHANEROGAMS": "PHANEROGAM, a seed-plant or spermatophyte, e.g. the flowering plants and gymnosperms [n]\n",
  "PHANEROPHYTE": "a perennial plant that bears its perennating buds well above the surface of the ground [n -S]\n",
  "PHANEROPHYTES": "PHANEROPHYTE, a perennial plant that bears its perennating buds well above the surface of the ground [n]\n",
  "PHANG": "(Shakespeare) to seize in the teeth [v -ED, -ING, -S]\n",
  "PHANGED": "PHANG, (Shakespeare) to seize in the teeth [v]\n",
  "PHANGING": "PHANG, (Shakespeare) to seize in the teeth [v]\n",
  "PHANGS": "PHANG, (Shakespeare) to seize in the teeth [v]\n",
  "PHANSIGAR": "(Hindi) formerly in India, a Thug [n -S]\n",
  "PHANSIGARS": "PHANSIGAR, (Hindi) formerly in India, a Thug [n]\n",
  "PHANTASIAST": "one of those Docetae who believed Christ's body to have been a mere phantom [n -S]\n",
  "PHANTASIASTS": "PHANTASIAST, one of those Docetae who believed Christ's body to have been a mere phantom [n]\n",
  "PHANTASIED": "PHANTASY, to imagine, also FANTASY [v]\n",
  "PHANTASIES": "PHANTASY, to imagine, also FANTASY [v]\n",
  "PHANTASIM": "(Shakespeare) a fantastic person, also PHANTASIME [n -S]\n",
  "PHANTASIME": "(Shakespeare) a fantastic person, also PHANTASIM [n -S]\n",
  "PHANTASIMES": "PHANTASIME, (Shakespeare) a fantastic person, also PHANTASIM [n]\n",
  "PHANTASIMS": "PHANTASIM, (Shakespeare) a fantastic person, also PHANTASIME [n]\n",
  "PHANTASM": "an airy or insubstantial figure, an apparition, also FANTASM [n -S]\n",
  "PHANTASMA": "a phantasm [n PHANTASMATA]\n",
  "PHANTASMAGORIA": "a fantastic sequence of haphazardly associative imagery, as seen in dreams or fever, also PHANTASMAGORY [n -S]\n",
  "PHANTASMAGORIAL": "of or like a phantasmagoria, also PHANTASMAGORIC [adj]\n",
  "PHANTASMAGORIAS": "PHANTASMAGORIA, a fantastic sequence of haphazardly associative imagery, as seen in dreams or fever, also PHANTASMAGORY [n]\n",
  "PHANTASMAGORIC": "of or like a phantasmagoria, also PHANTASMAGORIAL [adj]\n",
  "PHANTASMAGORIES": "PHANTASMAGORY, a fantastic sequence of haphazardly associative imagery, as seen in dreams or fever, also PHANTASMAGORIA [n]\n",
  "PHANTASMAGORY": "a fantastic sequence of haphazardly associative imagery, as seen in dreams or fever, also PHANTASMAGORIA [n PHANTASMAGORIES]\n",
  "PHANTASMAL": "of the nature of a phantasm, also PHANTASMIC, PHANTASMICAL [adj PHANTASMALLY]\n",
  "PHANTASMALIAN": "like a phantasm [adj]\n",
  "PHANTASMALITIES": "PHANTASMALITY, the state of being phantasmal [n]\n",
  "PHANTASMALITY": "the state of being phantasmal [n PHANTASMALITIES]\n",
  "PHANTASMALLY": "PHANTASMAL, of the nature of a phantasm, also PHANTASMIC, PHANTASMICAL [adv]\n",
  "PHANTASMATA": "PHANTASMA, a phantasm [n]\n",
  "PHANTASMIC": "of the nature of a phantasm, also PHANTASMAL, PHANTASMICAL [adj PHANTASMICALLY]\n",
  "PHANTASMICAL": "of the nature of a phantasm, also PHANTASMAL, PHANTASMIC [adj PHANTASMICALLY]\n",
  "PHANTASMICALLY": "PHANTASMICAL, of the nature of a phantasm, also PHANTASMAL, PHANTASMIC [adv]\n",
  "PHANTASMS": "PHANTASM, an airy or insubstantial figure, an apparition, also FANTASM [n]\n",
  "PHANTAST": "an impractical person, also FANTAST [n -S]\n",
  "PHANTASTIC": "a dandy, a fop [n -S]\n",
  "PHANTASTICS": "PHANTASTIC, a dandy, a fop [n]\n",
  "PHANTASTRIES": "PHANTASTRY, dandyism, also FANTASTRY [n]\n",
  "PHANTASTRY": "dandyism, also FANTASTRY [n PHANTASTRIES]\n",
  "PHANTASTS": "PHANTAST, an impractical person, also FANTAST [n]\n",
  "PHANTASY": "to imagine, also FANTASY [v PHANTASIED, PHANTASYING, PHANTASIES]\n",
  "PHANTASYING": "PHANTASY, to imagine, also FANTASY [v]\n",
  "PHANTOM": "an immaterial form, a spectre, also PHANTOSME [n -S]\n",
  "PHANTOMATIC": "(archaic) relating to a phantom [adj]\n",
  "PHANTOMISH": "(archaic) relating to a phantom [adj]\n",
  "PHANTOMLIKE": "like a phantom [adj]\n",
  "PHANTOMS": "PHANTOM, an immaterial form, a spectre, also PHANTOSME [n]\n",
  "PHANTOMY": "relating to a phantom [adj]\n",
  "PHANTOSME": "(Spenser) a phantom [n -S]\n",
  "PHANTOSMES": "PHANTOSME, (Spenser) a phantom [n]\n",
  "PHARAOH": "a ruler of ancient Egypt [n -S]\n",
  "PHARAOHS": "PHARAOH, a ruler of ancient Egypt [n]\n",
  "PHARAONIC": "of or pertaining to the Pharaohs, or kings of ancient Egypt [adj]\n",
  "PHARE": "a lighthouse or beacon, also PHAROS [n -S]\n",
  "PHARES": "PHARE, a lighthouse or beacon, also PHAROS [n]\n",
  "PHARISAIC": "characterized by hypocritical self-righteousness; putting emphasis on strict observance of rituals unrelated to the spirit or meaning of the ceremony, also PHARISAICAL [adj PHARISAICALLY]\n",
  "PHARISAICAL": "characterized by hypocritical self-righteousness; putting emphasis on strict observance of rituals unrelated to the spirit or meaning of the ceremony, also PHARISAIC [adj PHARISAICALLY]\n",
  "PHARISAICALLY": "PHARISAICAL, characterized by hypocritical self-righteousness; putting emphasis on strict observance of rituals unrelated to the spirit or meaning of the ceremony, also PHARISAIC [adv]\n",
  "PHARISAICALNESS": "PHARISAICAL, characterized by hypocritical self-righteousness; putting emphasis on strict observance of rituals unrelated to the spirit or meaning of the ceremony, also PHARISAIC [n]\n",
  "PHARISAISM": "the notions, doctrines, and conduct of the Pharisees, as a sect [n -S]\n",
  "PHARISAISMS": "PHARISAISM, the notions, doctrines, and conduct of the Pharisees, as a sect [n]\n",
  "PHARISEE": "a hypocritically self-righteous person [n -S]\n",
  "PHARISEEISM": "the state of being a pharisee, a self-righteous or hypocritical person [n -S]\n",
  "PHARISEEISMS": "PHARISEEISM, the state of being a pharisee, a self-righteous or hypocritical person [n]\n",
  "PHARISEES": "PHARISEE, a hypocritically self-righteous person [n]\n",
  "PHARM": "to redirect computer users from legitimate websites to counterfeit sites in order to gain confidential information about them [v -ED, -ING, -S]\n",
  "PHARMA": "pharmaceutical companies considered together as one company [n -S]\n",
  "PHARMACEUTIC": "relating to the knowledge or art of preparing medicines, also PHARMACEUTICAL [adj]\n",
  "PHARMACEUTICAL": "a medicinal drug, also PHARMACEUTIC [n -S]\n",
  "PHARMACEUTICALS": "PHARMACEUTICAL, a medicinal drug, also PHARMACEUTIC [n]\n",
  "PHARMACEUTICS": "the science of preparing medicines [n]\n",
  "PHARMACEUTIST": "one who prepares medicines [n -S]\n",
  "PHARMACEUTISTS": "PHARMACEUTIST, one who prepares medicines [n]\n",
  "PHARMACIES": "PHARMACY, a drugstore or chemist [n]\n",
  "PHARMACIST": "a person licensed to engage in pharmacy [n -S]\n",
  "PHARMACISTS": "PHARMACIST, a person licensed to engage in pharmacy [n]\n",
  "PHARMACODYNAMIC": "pertaining to action of drugs on body [adj]\n",
  "PHARMACOGENOMIC": "relating to pharmacogenomics, the branch of pharmacology which deals with the influence of genetic variation on drug response in patients [adj]\n",
  "PHARMACOGNOSIES": "PHARMACOGNOSY, the study of drugs of animal and plant origin [n]\n",
  "PHARMACOGNOSIST": "a practitioner of pharmacognosy, the study of drugs of animal and plant origin [n]\n",
  "PHARMACOGNOSTIC": "relating to pharmacognosy [adj]\n",
  "PHARMACOGNOSY": "the study of drugs of animal and plant origin [n PHARMACOGNOSIES]\n",
  "PHARMACOKINETIC": "relating to pharmacokinetics, the study of the way the body deals with drugs [adj]\n",
  "PHARMACOLOGIC": "relating to pharmacology, also PHARMACOLOGICAL [adj]\n",
  "PHARMACOLOGICAL": "relating to pharmacology, also PHARMACOLOGIC [adj]\n",
  "PHARMACOLOGIES": "PHARMACOLOGY, the study of drugs [n]\n",
  "PHARMACOLOGIST": "one who studies pharmacology [n -S]\n",
  "PHARMACOLOGISTS": "PHARMACOLOGIST, one who studies pharmacology [n]\n",
  "PHARMACOLOGY": "the study of drugs [n PHARMACOLOGIES]\n",
  "PHARMACOPEIA": "a book describing drugs and medicinal preparations; a stock of drugs, also PHARMACOPOEIA [n -S]\n",
  "PHARMACOPEIAL": "of or like a pharmacopeia, also PHARMACOPOEIAL, PHARMACOPOEIAN [adj]\n",
  "PHARMACOPEIAS": "PHARMACOPEIA, a book describing drugs and medicinal preparations; a stock of drugs, also PHARMACOPOEIA [n]\n",
  "PHARMACOPOEIA": "a book describing drugs and medicinal preparations; a stock of drugs, also PHARMACOPEIA [n -S]\n",
  "PHARMACOPOEIAL": "of or like a pharmacopoeia, also PHARMACOPEIAL, PHARMACOPOEIAN [adj]\n",
  "PHARMACOPOEIAN": "of or like a pharmacopoeia, also PHARMACOPEIAL, PHARMACOPOEIA [adj] / an individual who has expert knowledge of a pharmacopoeia [n -S]\n",
  "PHARMACOPOEIANS": "PHARMACOPOEIAN, an individual who has expert knowledge of a pharmacopoeia [n]\n",
  "PHARMACOPOEIAS": "PHARMACOPOEIA, a book describing drugs and medicinal preparations; a stock of drugs, also PHARMACOPEIA [n]\n",
  "PHARMACOPOEIC": "relating to a pharmacopoeia [adj]\n",
  "PHARMACOPOEIST": "one who compiles a pharmacopoeia [n -S]\n",
  "PHARMACOPOEISTS": "PHARMACOPOEIST, one who compiles a pharmacopoeia [n]\n",
  "PHARMACOPOLIST": "drug-seller; pharmacist; apothecary [n -S]\n",
  "PHARMACOPOLISTS": "PHARMACOPOLIST, drug-seller; pharmacist; apothecary [n]\n",
  "PHARMACOTHERAPY": "the treatment of disease and esp. mental illness with drugs [n]\n",
  "PHARMACY": "a drugstore or chemist [n PHARMACIES]\n",
  "PHARMAS": "PHARMA, pharmaceutical companies considered together as one company [n]\n",
  "PHARMED": "PHARM, to redirect computer users from legitimate websites to counterfeit sites in order to gain confidential information about them [v]\n",
  "PHARMER": "one who participates in pharming [n -S]\n",
  "PHARMERS": "PHARMER, one who participates in pharming [n]\n",
  "PHARMING": "the production of pharmaceuticals from genetically altered plants or animals [n -S]\n",
  "PHARMINGS": "PHARMING, the production of pharmaceuticals from genetically altered plants or animals [n]\n",
  "PHARMS": "PHARM, to redirect computer users from legitimate websites to counterfeit sites in order to gain confidential information about them [v]\n",
  "PHAROS": "(Greek) a lighthouse or beacon, also PHARE [n -ES]\n",
  "PHAROSES": "PHAROS, (Greek) a lighthouse or beacon, also PHARE [n]\n",
  "PHARYNGAL": "pertaining to the pharynx, or throat [adj] / a sound produced with the pharynx, also PHARYNGEAL [n -S]\n",
  "PHARYNGALS": "PHARYNGAL, a sound produced with the pharynx, also PHARYNGEAL [n]\n",
  "PHARYNGEAL": "pertaining to the pharynx, or throat [adj] / a pharyngeal speech sound, also PHARYNGAL [n -S]\n",
  "PHARYNGEALS": "PHARYNGEAL, a pharyngeal speech sound, also PHARYNGAL [n]\n",
  "PHARYNGES": "PHARYNX, (Greek) a section of the digestive tract [n]\n",
  "PHARYNGITIC": "relating to pharyngitis, inflammation of the pharynx [adj]\n",
  "PHARYNGITIDES": "PHARYNGITIS, inflammation of the pharynx [n]\n",
  "PHARYNGITIS": "inflammation of the pharynx [n PHARYNGITISES or PHARYNGITIDES]\n",
  "PHARYNGITISES": "PHARYNGITIS, inflammation of the pharynx [n]\n",
  "PHARYNGOLOGICAL": "relating to pharyngology, the study of the throat [adj]\n",
  "PHARYNGOLOGIES": "PHARYNGOLOGY, the study of the throat [n]\n",
  "PHARYNGOLOGIST": "a specialist in pharyngology, the study of the throat [n -S]\n",
  "PHARYNGOLOGISTS": "PHARYNGOLOGIST, a specialist in pharyngology, the study of the throat [n]\n",
  "PHARYNGOLOGY": "the study of the throat [n PHARYNGOLOGIES]\n",
  "PHARYNGOSCOPE": "an instrument for inspecting the pharynx [n -S]\n",
  "PHARYNGOSCOPES": "PHARYNGOSCOPE, an instrument for inspecting the pharynx [n]\n",
  "PHARYNGOSCOPIC": "relating to a pharyngoscope [adj]\n",
  "PHARYNGOSCOPIES": "PHARYNGOSCOPY, examination of the pharynx [n]\n",
  "PHARYNGOSCOPY": "examination of the pharynx [n PHARYNGOSCOPIES]\n",
  "PHARYNGOTOMIES": "PHARYNGOTOMY, the surgical removal of the pharynx [n]\n",
  "PHARYNGOTOMY": "the surgical removal of the pharynx [n PHARYNGOTOMIES]\n",
  "PHARYNX": "(Greek) a section of the digestive tract [n PHARYNXES or PHARYNGES]\n",
  "PHARYNXES": "PHARYNX, (Greek) a section of the digestive tract [n]\n",
  "PHASCOGALE": "a small insectivorous mouselike marsupial of the family Dasyuridae, native to Australia and New Guinea [n -S]\n",
  "PHASCOGALES": "PHASCOGALE, a small insectivorous mouselike marsupial of the family Dasyuridae, native to Australia and New Guinea [n]\n",
  "PHASE": "to carry out in distinct stages or development [v PHASED, PHASING, PHASES]\n",
  "PHASEAL": "pertaining to a phase [adj]\n",
  "PHASED": "PHASE, to carry out in distinct stages or development [v]\n",
  "PHASEDOWN": "a gradual reduction (as in operations) [n -S]\n",
  "PHASEDOWNS": "PHASEDOWN, a gradual reduction (as in operations) [n]\n",
  "PHASELESS": "without a phase, or visible form [adj]\n",
  "PHASEOLIN": "a protein found in kidney beans [n -S]\n",
  "PHASEOLINS": "PHASEOLIN, a protein found in kidney beans [n]\n",
  "PHASEOUT": "a gradual stopping of operations [n -S]\n",
  "PHASEOUTS": "PHASEOUT, a gradual stopping of operations [n]\n",
  "PHASER": "a type of science-fiction weapon [n -S]\n",
  "PHASERS": "PHASER, a type of science-fiction weapon [n]\n",
  "PHASES": "PHASIS, a stage in growth or development [n]\n",
  "PHASIC": "relating to a phase [adj]\n",
  "PHASING": "a type of electronic effect [n -S]\n",
  "PHASINGS": "PHASING, a type of electronic effect [n]\n",
  "PHASIS": "a stage in growth or development [n PHASES]\n",
  "PHASMID": "any orthopterous insect of the family Phasmidae, as a leaf insect or a stick insect [n -S]\n",
  "PHASMIDS": "PHASMID, any orthopterous insect of the family Phasmidae, as a leaf insect or a stick insect [n]\n",
  "PHASOR": "a rotating vector whose phase varies sinusoidally [n -S]\n",
  "PHASORS": "PHASOR, a rotating vector whose phase varies sinusoidally [n]\n",
  "PHAT": "susceptible of easy and rapid typesetting [adj PHATTER, PHATTEST]\n",
  "PHATIC": "relating to a communication meant to generate an atmosphere of social relationship rather than to convey some information [adj PHATICALLY]\n",
  "PHATICALLY": "PHATIC, relating to a communication meant to generate an atmosphere of social relationship rather than to convey some information [adv]\n",
  "PHATTER": "PHAT, susceptible of easy and rapid typesetting [adj]\n",
  "PHATTEST": "PHAT, susceptible of easy and rapid typesetting [adj]\n",
  "PHEASANT": "a large, long-tailed bird [n -S]\n",
  "PHEASANTRIES": "PHEASANTRY, a place for keeping and rearing pheasants [n]\n",
  "PHEASANTRY": "a place for keeping and rearing pheasants [n PHEASANTRIES]\n",
  "PHEASANTS": "PHEASANT, a large, long-tailed bird [n]\n",
  "PHEAZAR": "(Shakespeare) perhaps for vizier, also VEZIR, VISIER, VIZIER, VIZIR, WAZIR, WIZIER [n -S]\n",
  "PHEAZARS": "PHEAZAR, (Shakespeare) perhaps for vizier, also VEZIR, VISIER, VIZIER, VIZIR, WAZIR, WIZIER [n]\n",
  "PHEER": "a companion, also FERE, FEARE, FIER, FIERE, PHEERE [n -S]\n",
  "PHEERE": "a companion, also FERE, FEARE, FIER, FIERE, PHEER [n -S]\n",
  "PHEERES": "PHEERE, a companion, also FERE, FEARE, FIER, FIERE, PHEER [n]\n",
  "PHEERS": "PHEER, a companion, also FERE, FEARE, FIER, FIERE, PHEERE [n]\n",
  "PHEESE": "to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEEZE, PHESE [v PHEESED, PHEESING, PHEESES]\n",
  "PHEESED": "PHEESE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEEZE, PHESE [v]\n",
  "PHEESES": "PHEESE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEEZE, PHESE [v]\n",
  "PHEESING": "PHEESE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEEZE, PHESE [v]\n",
  "PHEEZE": "to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHESE [v PHEEZED, PHEEZING, PHEEZES]\n",
  "PHEEZED": "PHEEZE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHESE [v]\n",
  "PHEEZES": "PHEEZE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHESE [v]\n",
  "PHEEZING": "PHEEZE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHESE [v]\n",
  "PHELLEM": "(Greek) a layer of plant cells that make cork [n -S]\n",
  "PHELLEMS": "PHELLEM, (Greek) a layer of plant cells that make cork [n]\n",
  "PHELLODERM": "a layer of green parenchymatous cells formed on the inner side of the phellogen, the tissue of young cells which produces cork cells [n -S]\n",
  "PHELLODERMAL": "relating to the phelloderm [adj]\n",
  "PHELLODERMS": "PHELLODERM, a layer of green parenchymatous cells formed on the inner side of the phellogen, the tissue of young cells which produces cork cells [n]\n",
  "PHELLOGEN": "the tissue of young cells which produces cork cells [n -S]\n",
  "PHELLOGENETIC": "of or like phellogen, the tissue of young cells which produces cork cells, also PHELLOGENIC [adj]\n",
  "PHELLOGENIC": "of or like phellogen, the tissue of young cells which produces cork cells, also PHELLOGENETIC [adj]\n",
  "PHELLOGENS": "PHELLOGEN, the tissue of young cells which produces cork cells [n]\n",
  "PHELLOID": "resembling cork, but unable to shed water [adj]\n",
  "PHELLOPLASTIC": "a model in cork [n -S]\n",
  "PHELLOPLASTICS": "PHELLOPLASTIC, a model in cork [n]\n",
  "PHELONIA": "PHELONION, a liturgical vestment, also PHAELONION [n]\n",
  "PHELONION": "a liturgical vestment, also PHAELONION [n PHELONIONS or PHELONIA]\n",
  "PHELONIONS": "PHELONION, a liturgical vestment, also PHAELONION [n]\n",
  "PHENACAINE": "a crystalline base or its hydrochloride of local anaesthetic [n -S]\n",
  "PHENACAINES": "PHENACAINE, a crystalline base or its hydrochloride of local anaesthetic [n]\n",
  "PHENACETIN": "an antipyretic drug [n -S]\n",
  "PHENACETINS": "PHENACETIN, an antipyretic drug [n]\n",
  "PHENACITE": "a mineral, beryllium silicate, sometimes deceptively like quartz, also PHENAKITE [n -S]\n",
  "PHENACITES": "PHENACITE, a mineral, beryllium silicate, sometimes deceptively like quartz, also PHENAKITE [n]\n",
  "PHENAKISM": "deceit [n -S]\n",
  "PHENAKISMS": "PHENAKISM, deceit [n]\n",
  "PHENAKISTOSCOPE": "an early form of cinematograph [n]\n",
  "PHENAKITE": "a mineral, beryllium silicate, sometimes deceptively like quartz, also PHENACITE [n -S]\n",
  "PHENAKITES": "PHENAKITE, a mineral, beryllium silicate, sometimes deceptively like quartz, also PHENACITE [n]\n",
  "PHENANTHRENE": "an aromatic hydrocarbon of coal tar [n -S]\n",
  "PHENANTHRENES": "PHENANTHRENE, an aromatic hydrocarbon of coal tar [n]\n",
  "PHENARSAZINE": "an arsenic derivative used as a poison gas, aka adamsite [n -S]\n",
  "PHENARSAZINES": "PHENARSAZINE, an arsenic derivative used as a poison gas, aka adamsite [n]\n",
  "PHENATE": "a compound of phenol analogous to a salt, also PHENOLATE [n -S]\n",
  "PHENATES": "PHENATE, a compound of phenol analogous to a salt, also PHENOLATE [n]\n",
  "PHENAZIN": "a crystalline compound that is the basis of many azine dyes, also PHENAZINE [n -S]\n",
  "PHENAZINE": "a crystalline compound that is the basis of many azine dyes, also PHENAZIN [n -S]\n",
  "PHENAZINES": "PHENAZINE, a crystalline compound that is the basis of many azine dyes, also PHENAZIN [n]\n",
  "PHENAZINS": "PHENAZIN, a crystalline compound that is the basis of many azine dyes, also PHENAZINE [n]\n",
  "PHENCYCLIDINE": "a veterinary anesthetic, sometimes used illicitly as a psychedelic drug [n -S]\n",
  "PHENCYCLIDINES": "PHENCYCLIDINE, a veterinary anesthetic, sometimes used illicitly as a psychedelic drug [n]\n",
  "PHENE": "an old name for the hydrocarbon benzene [n -S]\n",
  "PHENES": "PHENE, an old name for the hydrocarbon benzene [n]\n",
  "PHENETIC": "pertaining to a type of classificatory system [adj]\n",
  "PHENETICIST": "a practitioner of phenetics [n -S]\n",
  "PHENETICISTS": "PHENETICIST, a practitioner of phenetics [n]\n",
  "PHENETICS": "a system of classification of organisms based on observable similarities irrespective of whether or not the organisms are related [n]\n",
  "PHENETIDINE": "a liquid amine used in the manufacture of dyestuffs [n -S]\n",
  "PHENETIDINES": "PHENETIDINE, a liquid amine used in the manufacture of dyestuffs [n]\n",
  "PHENETOL": "the ethyl ether of phenol, obtained as an aromatic liquid, also PHENETOLE [n -S]\n",
  "PHENETOLE": "the ethyl ether of phenol, obtained as an aromatic liquid, also PHENETOL [n -S]\n",
  "PHENETOLES": "PHENETOLE, the ethyl ether of phenol, obtained as an aromatic liquid, also PHENETOL [n]\n",
  "PHENETOLS": "PHENETOL, the ethyl ether of phenol, obtained as an aromatic liquid, also PHENETOLE [n]\n",
  "PHENFORMIN": "a biguanide administered orally in the treatment of diabetes to lower blood levels of glucose [n -S]\n",
  "PHENFORMINS": "PHENFORMIN, a biguanide administered orally in the treatment of diabetes to lower blood levels of glucose [n]\n",
  "PHENGITE": "a transparent stone used in ancient times for windows, probably selenite [n -S]\n",
  "PHENGITES": "PHENGITE, a transparent stone used in ancient times for windows, probably selenite [n]\n",
  "PHENGOPHOBIA": "fear of daylight [n -S]\n",
  "PHENGOPHOBIAS": "PHENGOPHOBIA, fear of daylight [n]\n",
  "PHENIC": "relating to benzene or phenyl [adj]\n",
  "PHENIX": "a bird fabled to exist single, to be consumed by fire by its own act, and to rise again from its ashes, also PHOENIX [n -ES]\n",
  "PHENIXES": "PHENIX, a bird fabled to exist single, to be consumed by fire by its own act, and to rise again from its ashes, also PHOENIX [n]\n",
  "PHENMETRAZINE": "a stimulant used in the form of its hydrochloride as an appetite suppressant [n -S]\n",
  "PHENMETRAZINES": "PHENMETRAZINE, a stimulant used in the form of its hydrochloride as an appetite suppressant [n]\n",
  "PHENOBARB": "(short for) phenobarbitol [n -S]\n",
  "PHENOBARBITAL": "a crystalline barbiturate used as a hypnotic, sedative, and anticonvulsant [n -S]\n",
  "PHENOBARBITALS": "PHENOBARBITAL, a crystalline barbiturate used as a hypnotic, sedative, and anticonvulsant [n]\n",
  "PHENOBARBITONE": "a sedative and hypnotic drug used to treat epilepsy [n -S]\n",
  "PHENOBARBITONES": "PHENOBARBITONE, a sedative and hypnotic drug used to treat epilepsy [n]\n",
  "PHENOBARBS": "PHENOBARB, (short for) phenobarbitol [n]\n",
  "PHENOCOPIES": "PHENOCOPY, a copy of a genetic abnormality that is produced by the environment and cannot be inherited [n]\n",
  "PHENOCOPY": "a copy of a genetic abnormality that is produced by the environment and cannot be inherited [n PHENOCOPIES]\n",
  "PHENOCRYST": "a larger crystal in a porphyritic rock [n -S]\n",
  "PHENOCRYSTIC": "of or like a phenocryst [adj]\n",
  "PHENOCRYSTS": "PHENOCRYST, a larger crystal in a porphyritic rock [n]\n",
  "PHENOGAM": "(Greek) any plant of the class Phaenogamia, flowering plants, also PHAENOGAM [n -S]\n",
  "PHENOGAMS": "PHENOGAM, (Greek) any plant of the class Phaenogamia, flowering plants, also PHAENOGAM [n]\n",
  "PHENOL": "a caustic compound [n -S]\n",
  "PHENOLATE": "a compound of phenol analogous to a salt, also PHENATE [n -S] / to subject to the action of a phenolate [v PHENOLATED, PHENOLATING, PHENOLATES]\n",
  "PHENOLATED": "PHENOLATE, to subject to the action of a phenolate [v]\n",
  "PHENOLATES": "PHENOLATE, a compound of phenol analogous to a salt, also PHENATE [n]\n",
  "PHENOLATING": "PHENOLATE, to subject to the action of a phenolate [v]\n",
  "PHENOLIC": "a synthetic resin [n -S]\n",
  "PHENOLICS": "PHENOLIC, a synthetic resin [n]\n",
  "PHENOLOGICAL": "relating to phenology [adj PHENOLOGICALLY]\n",
  "PHENOLOGICALLY": "PHENOLOGICAL, relating to phenology [adv]\n",
  "PHENOLOGIES": "PHENOLOGY, the study of organisms as affected by climate, also PHAENOLOGY [n]\n",
  "PHENOLOGIST": "a student of phenology [n -S]\n",
  "PHENOLOGISTS": "PHENOLOGIST, a student of phenology [n]\n",
  "PHENOLOGY": "the study of organisms as affected by climate, also PHAENOLOGY [n PHENOLOGIES]\n",
  "PHENOLPHTHALEIN": "a crystalline compound used as an indicator [n]\n",
  "PHENOLS": "PHENOL, a caustic compound [n]\n",
  "PHENOM": "a person of extraordinary ability or promise [n -S]\n",
  "PHENOME": "the complete set of phenotypes of an individual or group [n -S]\n",
  "PHENOMENA": "anything directly apprehended by the senses or one of them [n -S]\n",
  "PHENOMENAL": "relating to or being a phenomenon [adj PHENOMENALLY]\n",
  "PHENOMENALISE": "to represent as a phenomenon, also PHENOMENALIZE [v PHENOMENALISED, PHENOMENALISING, PHENOMENALISES]\n",
  "PHENOMENALISED": "PHENOMENALISE, to represent as a phenomenon, also PHENOMENALIZE [v]\n",
  "PHENOMENALISES": "PHENOMENALISE, to represent as a phenomenon, also PHENOMENALIZE [v]\n",
  "PHENOMENALISING": "PHENOMENALISE, to represent as a phenomenon, also PHENOMENALIZE [v]\n",
  "PHENOMENALISM": "the doctrine that knowledge can only comprehend phenomena, also PHENOMENISM [n -S]\n",
  "PHENOMENALISMS": "PHENOMENALISM, the doctrine that knowledge can only comprehend phenomena, also PHENOMENISM [n]\n",
  "PHENOMENALIST": "an adherent of the philosophical doctrine of phenomenalism, that knowledge can only comprehend phenomena [n -S]\n",
  "PHENOMENALISTIC": "relating to phenomenalism [adj]\n",
  "PHENOMENALISTS": "PHENOMENALIST, an adherent of the philosophical doctrine of phenomenalism, that knowledge can only comprehend phenomena [n]\n",
  "PHENOMENALITIES": "PHENOMENALITY, the state of being phenomenal [n]\n",
  "PHENOMENALITY": "the state of being phenomenal [n PHENOMENALITIES]\n",
  "PHENOMENALIZE": "to represent as a phenomenon, also PHENOMENALISE [v PHENOMENALIZED, PHENOMENALIZING, PHENOMENALIZES]\n",
  "PHENOMENALIZED": "PHENOMENALIZE, to represent as a phenomenon, also PHENOMENALISE [v]\n",
  "PHENOMENALIZES": "PHENOMENALIZE, to represent as a phenomenon, also PHENOMENALISE [v]\n",
  "PHENOMENALIZING": "PHENOMENALIZE, to represent as a phenomenon, also PHENOMENALISE [v]\n",
  "PHENOMENALLY": "PHENOMENAL, relating to or being a phenomenon [adv]\n",
  "PHENOMENAS": "PHENOMENA, anything directly apprehended by the senses or one of them [n]\n",
  "PHENOMENISE": "to bring into the world of experience, also PHENOMENIZE [v PHENOMENISED, PHENOMENISING, PHENOMENISES]\n",
  "PHENOMENISED": "PHENOMENISE, to bring into the world of experience, also PHENOMENIZE [v]\n",
  "PHENOMENISES": "PHENOMENISE, to bring into the world of experience, also PHENOMENIZE [v]\n",
  "PHENOMENISING": "PHENOMENISE, to bring into the world of experience, also PHENOMENIZE [v]\n",
  "PHENOMENISM": "the doctrine that knowledge can only comprehend phenomena, also PHENOMENALISM [n -S]\n",
  "PHENOMENISMS": "PHENOMENISM, the doctrine that knowledge can only comprehend phenomena, also PHENOMENALISM [n]\n",
  "PHENOMENIST": "a believer in phenomenism [n -S]\n",
  "PHENOMENISTS": "PHENOMENIST, a believer in phenomenism [n]\n",
  "PHENOMENIZE": "to bring into the world of experience, also PHENOMENISE [v PHENOMENIZED, PHENOMENIZING, PHENOMENIZES]\n",
  "PHENOMENIZED": "PHENOMENIZE, to bring into the world of experience, also PHENOMENISE [v]\n",
  "PHENOMENIZES": "PHENOMENIZE, to bring into the world of experience, also PHENOMENISE [v]\n",
  "PHENOMENIZING": "PHENOMENIZE, to bring into the world of experience, also PHENOMENISE [v]\n",
  "PHENOMENOLOGIES": "PHENOMENOLOGY, the study of phenomena [n]\n",
  "PHENOMENOLOGIST": "one who studies phenomenology [n]\n",
  "PHENOMENOLOGY": "the study of phenomena [n PHENOMENOLOGIES]\n",
  "PHENOMENON": "anything directly apprehended by the senses or one of them, also PHAENOMENON [n PHENOMENA or PHENOMENONS]\n",
  "PHENOMENONS": "PHENOMENON, anything directly apprehended by the senses or one of them, also PHAENOMENON [n]\n",
  "PHENOMES": "PHENOME, the complete set of phenotypes of an individual or group [n]\n",
  "PHENOMS": "PHENOM, a person of extraordinary ability or promise [n]\n",
  "PHENOTHIAZINE": "a crystalline compound used as an anthelmintic and insecticide esp. in veterinary practice [n -S]\n",
  "PHENOTHIAZINES": "PHENOTHIAZINE, a crystalline compound used as an anthelmintic and insecticide esp. in veterinary practice [n]\n",
  "PHENOTYPE": "the sum of the attributes of an individual, regarded as resulting from the interaction of its genotype with its environment [n -S] / to categorise by phenotype, also PHAENOTYPE [v PHENOTYPED, PHENOTYPING, PHENOTYPES]\n",
  "PHENOTYPED": "PHENOTYPE, to categorise by phenotype, also PHAENOTYPE [v]\n",
  "PHENOTYPES": "PHENOTYPE, to categorise by phenotype, also PHAENOTYPE [v]\n",
  "PHENOTYPIC": "relating to a phenotype, also PHENOTYPICAL [adj PHENOTYPICALLY]\n",
  "PHENOTYPICAL": "relating to a phenotype, also PHENOTYPIC [adj PHENOTYPICALLY]\n",
  "PHENOTYPICALLY": "PHENOTYPICAL, relating to a phenotype, also PHENOTYPIC [adv]\n",
  "PHENOTYPING": "PHENOTYPE, to categorise by phenotype, also PHAENOTYPE [v]\n",
  "PHENOXIDE": "a salt of a phenol, esp. in its capacity as a weak acid [n -S]\n",
  "PHENOXIDES": "PHENOXIDE, a salt of a phenol, esp. in its capacity as a weak acid [n]\n",
  "PHENOXY": "containing a radical derived from phenol [adj]\n",
  "PHENTOLAMINE": "an adrenergic blocking agent used esp. in the diagnosis and treatment of hypertension due to pheochromocytoma [n -S]\n",
  "PHENTOLAMINES": "PHENTOLAMINE, an adrenergic blocking agent used esp. in the diagnosis and treatment of hypertension due to pheochromocytoma [n]\n",
  "PHENYL": "a cyclic radical derived from benzene by the loss of one hydrogen atom [n -S]\n",
  "PHENYLALANIN": "an essential amino acid present in most proteins, also PHENYLALANINE [n -S]\n",
  "PHENYLALANINE": "an essential amino-acid present in most proteins, also PHENYLALANIN [n -S]\n",
  "PHENYLALANINES": "PHENYLALANINE, an essential amino-acid present in most proteins, also PHENYLALANIN [n]\n",
  "PHENYLALANINS": "PHENYLALANIN, an essential amino acid present in most proteins, also PHENYLALANINE [n]\n",
  "PHENYLAMINE": "another name for aniline [n -S]\n",
  "PHENYLAMINES": "PHENYLAMINE, another name for aniline [n]\n",
  "PHENYLBUTAZONE": "a drug formerly used as an analgesic, but now largely restricted to veterinary use [n -S]\n",
  "PHENYLBUTAZONES": "PHENYLBUTAZONE, a drug formerly used as an analgesic, but now largely restricted to veterinary use [n]\n",
  "PHENYLENE": "a compound derived from benzene [n -S]\n",
  "PHENYLENES": "PHENYLENE, a compound derived from benzene [n]\n",
  "PHENYLEPHRINE": "an agent used in the form of its hydrochloride as a vasoconstrictor [n -S]\n",
  "PHENYLEPHRINES": "PHENYLEPHRINE, an agent used in the form of its hydrochloride as a vasoconstrictor [n]\n",
  "PHENYLIC": "pertaining to, derived from, or containing, phenyl [adj]\n",
  "PHENYLKETONURIA": "an inherited metabolic disorder in infants [n]\n",
  "PHENYLKETONURIC": "suffering from phenylketonuria, an inherited metabolic disorder in infants [adj]\n",
  "PHENYLMETHYL": "an ester of benzene, aka benzyl [n -S]\n",
  "PHENYLMETHYLS": "PHENYLMETHYL, an ester of benzene, aka benzyl [n]\n",
  "PHENYLS": "PHENYL, a cyclic radical derived from benzene by the loss of one hydrogen atom [n]\n",
  "PHENYLTHIOUREA": "a crystalline compound used to test for the presence of a certain dominant gene (the compound tasting bitter to those who possess the gene) [n -S]\n",
  "PHENYLTHIOUREAS": "PHENYLTHIOUREA, a crystalline compound used to test for the presence of a certain dominant gene (the compound tasting bitter to those who possess the gene) [n]\n",
  "PHENYTOIN": "a crystalline anticonvulsant compound [n -S]\n",
  "PHENYTOINS": "PHENYTOIN, a crystalline anticonvulsant compound [n]\n",
  "PHEON": "the barbed head of a dart or arrow [n -S]\n",
  "PHEONS": "PHEON, the barbed head of a dart or arrow [n]\n",
  "PHERESES": "PHERESIS, a specialised form of blood donation, removing some components, and returning the remaining blood to the donor [n]\n",
  "PHERESIS": "a specialised form of blood donation, removing some components, and returning the remaining blood to the donor [n PHERESES]\n",
  "PHEROMONAL": "relating to a pheromone [adj]\n",
  "PHEROMONE": "a chemical substance secreted by an animal that influences the behaviour of others of its species [n -S]\n",
  "PHEROMONES": "PHEROMONE, a chemical substance secreted by an animal that influences the behaviour of others of its species [n]\n",
  "PHESE": "to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE [v PHESED, PHESING, PHESES]\n",
  "PHESED": "PHESE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE [v]\n",
  "PHESES": "PHESE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE [v]\n",
  "PHESING": "PHESE, to unsettle, also FAZE, FEASE, FEAZE, FEESE, FEEZE, PHEESE, PHEEZE [v]\n",
  "PHEW": "an exclamation of relief, astonishment etc. [interj]\n",
  "PHI": "a Greek letter [n -S]\n",
  "PHIAL": "to keep in a small bottle, also VIAL [v PHIALLED, PHIALLING, PHIALS]\n",
  "PHIALIFORM": "saucer-shaped [adj]\n",
  "PHIALLED": "PHIAL, to keep in a small bottle, also VIAL [v]\n",
  "PHIALLING": "PHIAL, to keep in a small bottle, also VIAL [v]\n",
  "PHIALS": "PHIAL, to keep in a small bottle, also VIAL [v]\n",
  "PHILABEG": "(Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILIBEG, PHILLABEG, PHILLIBEG [n -S]\n",
  "PHILABEGS": "PHILABEG, (Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILIBEG, PHILLABEG, PHILLIBEG [n]\n",
  "PHILADELPHUS": "a flowering shrub, aka mock orange [n -ES]\n",
  "PHILADELPHUSES": "PHILADELPHUS, a flowering shrub, aka mock orange [n]\n",
  "PHILAMOT": "(French) a dull brown colour, also FILEMOT, PHILOMOT [n -S]\n",
  "PHILAMOTS": "PHILAMOT, (French) a dull brown colour, also FILEMOT, PHILOMOT [n]\n",
  "PHILANDER": "to engage in frivolous love of women [v -ED, -ING, -S]\n",
  "PHILANDERED": "PHILANDER, to engage in frivolous love of women [v]\n",
  "PHILANDERER": "one who philanders [n -S]\n",
  "PHILANDERERS": "PHILANDERER, one who philanders [n]\n",
  "PHILANDERING": "engaging in a frivolous love of women [n -S]\n",
  "PHILANDERINGS": "PHILANDERING, engaging in a frivolous love of women [n]\n",
  "PHILANDERS": "PHILANDER, to engage in frivolous love of women [v]\n",
  "PHILANTHROPE": "someone who tries to benefit mankind [n -S]\n",
  "PHILANTHROPES": "PHILANTHROPE, someone who tries to benefit mankind [n]\n",
  "PHILANTHROPIC": "of, relating to, or characterized by philanthropy, also PHILANTHROPICAL [adj]\n",
  "PHILANTHROPICAL": "of, relating to, or characterized by philanthropy, also PHILANTHROPIC [adj]\n",
  "PHILANTHROPIES": "PHILANTHROPY, love of mankind [n]\n",
  "PHILANTHROPIST": "one who practices philanthropy [n -S]\n",
  "PHILANTHROPISTS": "PHILANTHROPIST, one who practices philanthropy [n]\n",
  "PHILANTHROPOID": "a person who works for a philanthropic organization [n -S]\n",
  "PHILANTHROPOIDS": "PHILANTHROPOID, a person who works for a philanthropic organization [n]\n",
  "PHILANTHROPY": "love of mankind [n PHILANTHROPIES]\n",
  "PHILATELIC": "of or pertaining to philately [adj PHILATELICALLY]\n",
  "PHILATELICALLY": "PHILATELIC, of or pertaining to philately [adv]\n",
  "PHILATELIES": "PHILATELY, the study of postage stamps [n]\n",
  "PHILATELIST": "a stamp collector [n -S]\n",
  "PHILATELISTS": "PHILATELIST, a stamp collector [n]\n",
  "PHILATELY": "the study of postage stamps [n PHILATELIES]\n",
  "PHILAVERIES": "PHILAVERY, an idiosyncratic collection of uncommon and pleasing words [n]\n",
  "PHILAVERY": "an idiosyncratic collection of uncommon and pleasing words [n PHILAVERIES]\n",
  "PHILHARMONIC": "fond of music [adj] / a choir or orchestra [n -S]\n",
  "PHILHARMONICS": "PHILHARMONIC, a choir or orchestra [n]\n",
  "PHILHELLENE": "one who loves Greece, also PHILHELLENIST [n -S]\n",
  "PHILHELLENES": "PHILHELLENE, one who loves Greece, also PHILHELLENIST [n]\n",
  "PHILHELLENIC": "loving Greece [adj]\n",
  "PHILHELLENISM": "a love of Greece [n -S]\n",
  "PHILHELLENISMS": "PHILHELLENISM, a love of Greece [n]\n",
  "PHILHELLENIST": "one who loves Greece, also PHILHELLENE [n -S]\n",
  "PHILHELLENISTS": "PHILHELLENIST, one who loves Greece, also PHILHELLENE [n]\n",
  "PHILHORSE": "(Shakespeare) a fill-horse, the horse in a team nearest to the carriage [n -S]\n",
  "PHILHORSES": "PHILHORSE, (Shakespeare) a fill-horse, the horse in a team nearest to the carriage [n]\n",
  "PHILIBEG": "(Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILABEG, PHILLABEG, PHILLIBEG [n -S]\n",
  "PHILIBEGS": "PHILIBEG, (Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILABEG, PHILLABEG, PHILLIBEG [n]\n",
  "PHILIPPIC": "a bitter condemnation, usually in a speech [n -S]\n",
  "PHILIPPICS": "PHILIPPIC, a bitter condemnation, usually in a speech [n]\n",
  "PHILIPPINA": "a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINE, PHILOPENA, PHILOPOENA [n -S]\n",
  "PHILIPPINAS": "PHILIPPINA, a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINE, PHILOPENA, PHILOPOENA [n]\n",
  "PHILIPPINE": "a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINA, PHILOPENA, PHILOPOENA [n -S]\n",
  "PHILIPPINES": "PHILIPPINE, a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINA, PHILOPENA, PHILOPOENA [n]\n",
  "PHILISTIA": "the class or world of cultured Philistines [n -S]\n",
  "PHILISTIAS": "PHILISTIA, the class or world of cultured Philistines [n]\n",
  "PHILISTINE": "materialistic in outlook; uncultured [adj] / one who is materialistic in outlook [n -S]\n",
  "PHILISTINES": "PHILISTINE, one who is materialistic in outlook [n]\n",
  "PHILISTINISM": "lack of culture, a materialistic outlook [n -S]\n",
  "PHILISTINISMS": "PHILISTINISM, lack of culture, a materialistic outlook [n]\n",
  "PHILLABEG": "(Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLIBEG [n -S]\n",
  "PHILLABEGS": "PHILLABEG, (Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLIBEG [n]\n",
  "PHILLIBEG": "(Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLABEG [n -S]\n",
  "PHILLIBEGS": "PHILLIBEG, (Gaelic) the kilt, also FILABEG, FILIBEG, FILLIBEG, PHILABEG, PHILIBEG, PHILLABEG [n]\n",
  "PHILLIPSITE": "a hydrated silicate of potassium, calcium and aluminum [n -S]\n",
  "PHILLIPSITES": "PHILLIPSITE, a hydrated silicate of potassium, calcium and aluminum [n]\n",
  "PHILLUMENIES": "PHILLUMENY, the hobby of collecting of matchbox labels [n]\n",
  "PHILLUMENIST": "a collector of matchbooks [n -S]\n",
  "PHILLUMENISTS": "PHILLUMENIST, a collector of matchbooks [n]\n",
  "PHILLUMENY": "the hobby of collecting of matchbox labels [n PHILLUMENIES]\n",
  "PHILODENDRA": "PHILODENDRON, any of various aroid plants cultivated for their showy foliage [n]\n",
  "PHILODENDRON": "any of various aroid plants cultivated for their showy foliage [n PHILODENDRA or PHILODENDRONS]\n",
  "PHILODENDRONS": "PHILODENDRON, any of various aroid plants cultivated for their showy foliage [n]\n",
  "PHILOGYNIES": "PHILOGYNY, the love of women [n]\n",
  "PHILOGYNIST": "a lover or friend of women; one who esteems women as the higher type of humanity [n -S]\n",
  "PHILOGYNISTS": "PHILOGYNIST, a lover or friend of women; one who esteems women as the higher type of humanity [n]\n",
  "PHILOGYNOUS": "loving women [adj]\n",
  "PHILOGYNY": "the love of women [n PHILOGYNIES]\n",
  "PHILOLOGER": "a person who studies or has knowledge of philology, also PHILOLOGIAN, PHILOLOGIST, PHILOLOGUE [n -S]\n",
  "PHILOLOGERS": "PHILOLOGER, a person who studies or has knowledge of philology, also PHILOLOGIAN, PHILOLOGIST, PHILOLOGUE [n]\n",
  "PHILOLOGIAN": "a person who studies or has knowledge of philology, also PHILOLOGER, PHILOLOGIST, PHILOLOGUE [n -S]\n",
  "PHILOLOGIANS": "PHILOLOGIAN, a person who studies or has knowledge of philology, also PHILOLOGER, PHILOLOGIST, PHILOLOGUE [n]\n",
  "PHILOLOGIC": "of or pertaining to philology, also PHILOLOGICAL [adj PHILOLOGICALLY]\n",
  "PHILOLOGICAL": "of or pertaining to philology, also PHILOLOGIC [adj PHILOLOGICALLY]\n",
  "PHILOLOGICALLY": "PHILOLOGICAL, of or pertaining to philology, also PHILOLOGIC [adv]\n",
  "PHILOLOGIES": "PHILOLOGY, the science of language, esp. of its historical development [n]\n",
  "PHILOLOGIST": "a person who studies or has knowledge of philology, also PHILOLOGER, PHILOLOGIAN, PHILOLOGUE [n -S]\n",
  "PHILOLOGISTS": "PHILOLOGIST, a person who studies or has knowledge of philology, also PHILOLOGER, PHILOLOGIAN, PHILOLOGUE [n]\n",
  "PHILOLOGUE": "a person who studies or has knowledge of philology, also PHILOLOGER, PHILOLOGIAN, PHILOLOGIST [n -S]\n",
  "PHILOLOGUES": "PHILOLOGUE, a person who studies or has knowledge of philology, also PHILOLOGER, PHILOLOGIAN, PHILOLOGIST [n]\n",
  "PHILOLOGY": "the science of language, esp. of its historical development [n PHILOLOGIES]\n",
  "PHILOMATH": "a lover of learning; a scholar [n -S]\n",
  "PHILOMATHIC": "loving learning, also PHILOMATHICAL [adj]\n",
  "PHILOMATHICAL": "loving learning, also PHILOMATHIC [adj]\n",
  "PHILOMATHIES": "PHILOMATHY, the love of learning or letters [n]\n",
  "PHILOMATHS": "PHILOMATH, a lover of learning; a scholar [n]\n",
  "PHILOMATHY": "the love of learning or letters [n PHILOMATHIES]\n",
  "PHILOMEL": "(Greek) a songbird, also PHILOMELA [n -S]\n",
  "PHILOMELA": "(Greek) a songbird, also PHILOMEL [n -S]\n",
  "PHILOMELAS": "PHILOMELA, (Greek) a songbird, also PHILOMEL [n]\n",
  "PHILOMELS": "PHILOMEL, (Greek) a songbird, also PHILOMELA [n]\n",
  "PHILOMOT": "(French) a dull brown colour, also FILEMOT, PHILAMOT [n -S]\n",
  "PHILOMOTS": "PHILOMOT, (French) a dull brown colour, also FILEMOT, PHILAMOT [n]\n",
  "PHILOPENA": "a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINA, PHILIPPINE, PHILOPOENA [n -S]\n",
  "PHILOPENAS": "PHILOPENA, a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINA, PHILIPPINE, PHILOPOENA [n]\n",
  "PHILOPOENA": "a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINA, PHILIPPINE, PHILOPENA [n -S]\n",
  "PHILOPOENAS": "PHILOPOENA, a present or gift which is made as a forfeit in a social game that is played in various ways; also, the game itself, also FILLIPEEN, PHILIPPINA, PHILIPPINE, PHILOPENA [n]\n",
  "PHILOSOPHASTER": "an amateur or superficial philosopher [n -S]\n",
  "PHILOSOPHASTERS": "PHILOSOPHASTER, an amateur or superficial philosopher [n]\n",
  "PHILOSOPHE": "(French) a philosopher [n -S]\n",
  "PHILOSOPHER": "a person who seeks wisdom or enlightenment [n -S]\n",
  "PHILOSOPHERESS": "a female philosopher, also PHILOSOPHESS [n]\n",
  "PHILOSOPHERS": "PHILOSOPHER, a person who seeks wisdom or enlightenment [n]\n",
  "PHILOSOPHES": "PHILOSOPHE, (French) a philosopher [n]\n",
  "PHILOSOPHESS": "a female philosopher, also PHILOSOPHERESS [n -ES]\n",
  "PHILOSOPHESSES": "PHILOSOPHESS, a female philosopher, also PHILOSOPHERESS [n]\n",
  "PHILOSOPHIC": "relating to philosophy, also PHILOSOPHICAL [adj PHILOSOPHICALLY]\n",
  "PHILOSOPHICAL": "relating to philosophy, also PHILOSOPHIC [adj PHILOSOPHICALLY]\n",
  "PHILOSOPHICALLY": "PHILOSOPHICAL, relating to philosophy, also PHILOSOPHIC [adv]\n",
  "PHILOSOPHIES": "PHILOSOPHY, all learning exclusive of technical precepts and practical arts [n]\n",
  "PHILOSOPHISE": "to reason in the manner of a philosopher, also PHILOSOPHIZE [v PHILOSOPHISED, PHILOSOPHISING, PHILOSOPHISES]\n",
  "PHILOSOPHISED": "PHILOSOPHISE, to reason in the manner of a philosopher, also PHILOSOPHIZE [v]\n",
  "PHILOSOPHISER": "one who philosophises, also PHILOSOPHIZER [n -S]\n",
  "PHILOSOPHISERS": "PHILOSOPHISER, one who philosophises, also PHILOSOPHIZER [n]\n",
  "PHILOSOPHISES": "PHILOSOPHISE, to reason in the manner of a philosopher, also PHILOSOPHIZE [v]\n",
  "PHILOSOPHISING": "the act of engaging in philosophy [n -S]\n",
  "PHILOSOPHISINGS": "PHILOSOPHISING, the act of engaging in philosophy [n]\n",
  "PHILOSOPHISM": "would-be philosophy [n -S]\n",
  "PHILOSOPHISMS": "PHILOSOPHISM, would-be philosophy [n]\n",
  "PHILOSOPHIST": "a would-be philosopher [n -S]\n",
  "PHILOSOPHISTIC": "relating to philosophism, would-be philosophy [adj]\n",
  "PHILOSOPHISTS": "PHILOSOPHIST, a would-be philosopher [n]\n",
  "PHILOSOPHIZE": "to reason in the manner of a philosopher, also PHILOSOPHISE [v PHILOSOPHIZED, PHILOSOPHIZING, PHILOSOPHIZES]\n",
  "PHILOSOPHIZED": "PHILOSOPHIZE, to reason in the manner of a philosopher, also PHILOSOPHISE [v]\n",
  "PHILOSOPHIZER": "one who philosophises, also PHILOSOPHISER [n -S]\n",
  "PHILOSOPHIZERS": "PHILOSOPHIZER, one who philosophises, also PHILOSOPHISER [n]\n",
  "PHILOSOPHIZES": "PHILOSOPHIZE, to reason in the manner of a philosopher, also PHILOSOPHISE [v]\n",
  "PHILOSOPHIZING": "the act of engaging in philosophy [n -S]\n",
  "PHILOSOPHIZINGS": "PHILOSOPHIZING, the act of engaging in philosophy [n]\n",
  "PHILOSOPHY": "all learning exclusive of technical precepts and practical arts [n PHILOSOPHIES]\n",
  "PHILOXENIA": "hospitality [n -S]\n",
  "PHILOXENIAS": "PHILOXENIA, hospitality [n]\n",
  "PHILTER": "to put under the spell of a love potion, also PHILTRE [v -ED, -ING, -S]\n",
  "PHILTERED": "PHILTER, to put under the spell of a love potion, also PHILTRE [v]\n",
  "PHILTERING": "PHILTER, to put under the spell of a love potion, also PHILTRE [v]\n",
  "PHILTERS": "PHILTER, to put under the spell of a love potion, also PHILTRE [v]\n",
  "PHILTRA": "PHILTRUM, (Greek) the indentation between the upper lip and the nose [n]\n",
  "PHILTRE": "to put under the spell of a love potion, also PHILTER [v PHILTRED, PHILTRING, PHILTRES]\n",
  "PHILTRED": "PHILTRE, to put under the spell of a love potion, also PHILTER [v]\n",
  "PHILTRES": "PHILTRE, to put under the spell of a love potion, also PHILTER [v]\n",
  "PHILTRING": "PHILTRE, to put under the spell of a love potion, also PHILTER [v]\n",
  "PHILTRUM": "(Greek) the indentation between the upper lip and the nose [n PHILTRA]\n",
  "PHIMOSES": "PHIMOSIS, (Greek) the abnormal constriction of the opening of the prepuce [n]\n",
  "PHIMOSIS": "(Greek) the abnormal constriction of the opening of the prepuce [n PHIMOSES]\n",
  "PHIMOTIC": "relating to phimosis, a condition of the penis in which the prepuce can not be drawn back so as to uncover the glans penis [adj]\n",
  "PHINNOCK": "(Gaelic) a young seatrout, also FINNAC, FINNACK, FINNOCK [n -S]\n",
  "PHINNOCKS": "PHINNOCK, (Gaelic) a young seatrout, also FINNAC, FINNACK, FINNOCK [n]\n",
  "PHIS": "PHI, a Greek letter [n]\n",
  "PHISH": "to engage in phishing, sending email that falsely claims to be from a legitimate organization [v -ED, -ING, -ES]\n",
  "PHISHED": "PHISH, to engage in phishing, sending email that falsely claims to be from a legitimate organization [v]\n",
  "PHISHER": "one that phishes [n -S]\n",
  "PHISHERS": "PHISHER, one that phishes [n]\n",
  "PHISHES": "PHISH, to engage in phishing, sending email that falsely claims to be from a legitimate organization [v]\n",
  "PHISHING": "the act of sending email that falsely claims to be from a legitimate organization [n -S]\n",
  "PHISHINGS": "PHISHING, the act of sending email that falsely claims to be from a legitimate organization [n]\n",
  "PHISNOMIES": "PHISNOMY, (obsolete) physiognomy, also FISNOMIE, VISNOMIE, VISNOMY [n]\n",
  "PHISNOMY": "(obsolete) physiognomy, also FISNOMIE, VISNOMIE, VISNOMY [n PHISNOMIES]\n",
  "PHIZ": "(colloquial) physiognomy, the face, also PHIZOG, PHIZZ [n PHIZES or PHIZZES]\n",
  "PHIZES": "PHIZ, (colloquial) physiognomy, the face, also PHIZOG, PHIZZ [n]\n",
  "PHIZOG": "(colloquial) physiognomy, the face, also PHIZ, PHIZZ [n -S]\n",
  "PHIZOGS": "PHIZOG, (colloquial) physiognomy, the face, also PHIZ, PHIZZ [n]\n",
  "PHIZZ": "(colloquial) physiognomy, face, also PHIZ, PHIZOG [n -ES]\n",
  "PHIZZES": "PHIZ, (colloquial) physiognomy, the face, also PHIZOG, PHIZZ [n]\n",
  "PHLEBECTOMIES": "PHLEBECTOMY, the surgical excision of a vein or part of a vein [n]\n",
  "PHLEBECTOMY": "the surgical excision of a vein or part of a vein [n PHLEBECTOMIES]\n",
  "PHLEBITIC": "relating to phlebitis, inflammation of a vein [adj]\n",
  "PHLEBITIDES": "PHLEBITIS, inflammation of a vein [n]\n",
  "PHLEBITIS": "inflammation of a vein [n PHLEBITIDES or PHLEBITISES]\n",
  "PHLEBITISES": "PHLEBITIS, inflammation of a vein [n]\n",
  "PHLEBOGRAM": "a tracing (with the sphygmograph) of the movements of a vein, or of the venous pulse [n -S]\n",
  "PHLEBOGRAMS": "PHLEBOGRAM, a tracing (with the sphygmograph) of the movements of a vein, or of the venous pulse [n]\n",
  "PHLEBOGRAPHIC": "relating to phlebography, radiography of a vein [adj]\n",
  "PHLEBOGRAPHIES": "PHLEBOGRAPHY, radiography of a vein after injection of a contrast medium, aka venography [n]\n",
  "PHLEBOGRAPHY": "radiography of a vein after injection of a contrast medium, aka venography [n PHLEBOGRAPHIES]\n",
  "PHLEBOLITE": "a calcareous concretion found in a vein [n -S]\n",
  "PHLEBOLITES": "PHLEBOLITE, a calcareous concretion found in a vein [n]\n",
  "PHLEBOLOGIES": "PHLEBOLOGY, a branch of anatomy which treats of the veins [n]\n",
  "PHLEBOLOGY": "a branch of anatomy which treats of the veins [n PHLEBOLOGIES]\n",
  "PHLEBOSCLEROSES": "PHLEBOSCLEROSIS, hardening and loss of elasticity of the veins [n]\n",
  "PHLEBOSCLEROSIS": "hardening and loss of elasticity of the veins [n PHLEBOSCLEROSES]\n",
  "PHLEBOTOMIC": "relating to phlebotomy, the surgical opening of a vein to draw blood, also PHLEBOTOMICAL [adj]\n",
  "PHLEBOTOMICAL": "relating to phlebotomy, the surgical opening of a vein to draw blood, also PHLEBOTOMIC [adj]\n",
  "PHLEBOTOMIES": "PHLEBOTOMY, the surgical opening of a vein to draw blood [n]\n",
  "PHLEBOTOMISE": "to perform phlebotomy on, also PHLEBOTOMIZE [v PHLEBOTOMISED, PHLEBOTOMISING, PHLEBOTOMISES]\n",
  "PHLEBOTOMISED": "PHLEBOTOMISE, to perform phlebotomy on, also PHLEBOTOMIZE [v]\n",
  "PHLEBOTOMISES": "PHLEBOTOMISE, to perform phlebotomy on, also PHLEBOTOMIZE [v]\n",
  "PHLEBOTOMISING": "PHLEBOTOMISE, to perform phlebotomy on, also PHLEBOTOMIZE [v]\n",
  "PHLEBOTOMIST": "one who carries out phlebotomies [n -S]\n",
  "PHLEBOTOMISTS": "PHLEBOTOMIST, one who carries out phlebotomies [n]\n",
  "PHLEBOTOMIZE": "to perform phlebotomy on, also PHLEBOTOMISE [v PHLEBOTOMIZED, PHLEBOTOMIZING, PHLEBOTOMIZES]\n",
  "PHLEBOTOMIZED": "PHLEBOTOMIZE, to perform phlebotomy on, also PHLEBOTOMISE [v]\n",
  "PHLEBOTOMIZES": "PHLEBOTOMIZE, to perform phlebotomy on, also PHLEBOTOMISE [v]\n",
  "PHLEBOTOMIZING": "PHLEBOTOMIZE, to perform phlebotomy on, also PHLEBOTOMISE [v]\n",
  "PHLEBOTOMY": "the surgical opening of a vein to draw blood [n PHLEBOTOMIES]\n",
  "PHLEGM": "a thick mucus secreted in the air passages [n -S]\n",
  "PHLEGMAGOGIC": "a medication that is intended to dislodge and evacuate mucus from the respiratory system [n -S]\n",
  "PHLEGMAGOGICS": "PHLEGMAGOGIC, a medication that is intended to dislodge and evacuate mucus from the respiratory system [n]\n",
  "PHLEGMAGOGUE": "a phlegm-expelling drug [n -S]\n",
  "PHLEGMAGOGUES": "PHLEGMAGOGUE, a phlegm-expelling drug [n]\n",
  "PHLEGMASIA": "an inflammation of the internal organs [n -S]\n",
  "PHLEGMASIAS": "PHLEGMASIA, an inflammation of the internal organs [n]\n",
  "PHLEGMATIC": "of a calm, unexcitable disposition, also PHLEGMATICAL [adj PHLEGMATICALLY]\n",
  "PHLEGMATICAL": "of a calm, unexcitable disposition, also PHLEGMATIC [adj PHLEGMATICALLY]\n",
  "PHLEGMATICALLY": "PHLEGMATICAL, of a calm, unexcitable disposition, also PHLEGMATIC [adv]\n",
  "PHLEGMATICNESS": "the state of being phlegmatic [n]\n",
  "PHLEGMIER": "PHLEGMY, full of phlegm [adj]\n",
  "PHLEGMIEST": "PHLEGMY, full of phlegm [adj]\n",
  "PHLEGMON": "an inflammation with pus [n -S]\n",
  "PHLEGMONIC": "of or like a phlegmon, also PHLEGMONOID, PHLEGMONOUS [adj]\n",
  "PHLEGMONOID": "of or like a phlegmon, also PHLEGMONIC, PHLEGMONOUS [adj]\n",
  "PHLEGMONOUS": "of or like a phlegmon, also PHLEGMONIC, PHLEGMONOID [adj]\n",
  "PHLEGMONS": "PHLEGMON, an inflammation with pus [n]\n",
  "PHLEGMS": "PHLEGM, a thick mucus secreted in the air passages [n]\n",
  "PHLEGMY": "full of phlegm [adj PHLEGMIER, PHLEGMIEST]\n",
  "PHLOEM": "(Greek) the nutrient-conducting tissue of vascular plants [n -S]\n",
  "PHLOEMS": "PHLOEM, (Greek) the nutrient-conducting tissue of vascular plants [n]\n",
  "PHLOGISTIC": "of or pertaining to phlogiston, or to belief in its existence [adj]\n",
  "PHLOGISTICATE": "to combine with phlogiston [v PHLOGISTICATED, PHLOGISTICATING, PHLOGISTICATES]\n",
  "PHLOGISTICATED": "PHLOGISTICATE, to combine with phlogiston [v]\n",
  "PHLOGISTICATES": "PHLOGISTICATE, to combine with phlogiston [v]\n",
  "PHLOGISTICATING": "PHLOGISTICATE, to combine with phlogiston [v]\n",
  "PHLOGISTON": "(Greek) the hypothetical principle of fire regarded formerly as a material substance [n -S]\n",
  "PHLOGISTONS": "PHLOGISTON, (Greek) the hypothetical principle of fire regarded formerly as a material substance [n]\n",
  "PHLOGOPITE": "a brown mica containing magnesium, a constituent of limestones and dolomites [n -S]\n",
  "PHLOGOPITES": "PHLOGOPITE, a brown mica containing magnesium, a constituent of limestones and dolomites [n]\n",
  "PHLOMIS": "(Greek) any plant of the Phlomis genus of labiate herbs [n -ES]\n",
  "PHLOMISES": "PHLOMIS, (Greek) any plant of the Phlomis genus of labiate herbs [n]\n",
  "PHLORIZIN": "a chemical found in the root bark of fruit trees [n -S]\n",
  "PHLORIZINS": "PHLORIZIN, a chemical found in the root bark of fruit trees [n]\n",
  "PHLOX": "(Greek) any plant of the North American genus Phlox [n -ES]\n",
  "PHLOXES": "PHLOX, (Greek) any plant of the North American genus Phlox [n]\n",
  "PHLYCTAENA": "(Greek) a small blister or vesicle, also PHLYCTENA [n PHLYCTAENAE]\n",
  "PHLYCTAENAE": "PHLYCTAENA, (Greek) a small blister or vesicle, also PHLYCTENA [n]\n",
  "PHLYCTENA": "(Greek) a small blister or vesicle, also PHLYCTAENA [n PHLYCTENAE]\n",
  "PHLYCTENAE": "PHLYCTENA, (Greek) a small blister or vesicle, also PHLYCTAENA [n]\n",
  "PHO": "a Vietnamese noodle soup [n -S]\n",
  "PHOBIA": "(Greek) an obsessive or irrational fear, also PHOBISM [n -S]\n",
  "PHOBIAS": "PHOBIA, (Greek) an obsessive or irrational fear, also PHOBISM [n]\n",
  "PHOBIC": "one affected with a phobia [n -S]\n",
  "PHOBICS": "PHOBIC, one affected with a phobia [n]\n",
  "PHOBISM": "an obsessive or irrational fear, also PHOBIA [n -S]\n",
  "PHOBISMS": "PHOBISM, an obsessive or irrational fear, also PHOBIA [n]\n",
  "PHOBIST": "someone with a phobia [n -S]\n",
  "PHOBISTS": "PHOBIST, someone with a phobia [n]\n",
  "PHOCA": "(Latin) a genus of seals that includes the common harbour seal [n PHOCAE or PHOCAS]\n",
  "PHOCAE": "PHOCA, (Latin) a genus of seals that includes the common harbour seal [n]\n",
  "PHOCAS": "PHOCA, (Latin) a genus of seals that includes the common harbour seal [n]\n",
  "PHOCINE": "pertaining to seals [adj]\n",
  "PHOCOMELIA": "a type of congenital deformity, with seallike limbs, also PHOCOMELY [n -S]\n",
  "PHOCOMELIAS": "PHOCOMELIA, a type of congenital deformity, with seallike limbs, also PHOCOMELY [n]\n",
  "PHOCOMELIC": "showing phocomely, a type of congenital deformity, with seallike limbs [adj]\n",
  "PHOCOMELIES": "PHOCOMELY, a type of congenital deformity, with seallike limbs [n]\n",
  "PHOCOMELY": "a type of congenital deformity, with seallike limbs [n PHOCOMELIES]\n",
  "PHOEBE": "a small bird, the pewee, or pewit [n -S]\n",
  "PHOEBES": "PHOEBE, a small bird, the pewee, or pewit [n]\n",
  "PHOEBUS": "(Latin) a sun god; the sun [n -ES]\n",
  "PHOEBUSES": "PHOEBUS, (Latin) a sun god; the sun [n]\n",
  "PHOENIX": "a bird fabled to exist single, to be consumed by fire by its own act, and to rise again from its ashes, also PHENIX [n -ES]\n",
  "PHOENIXES": "PHOENIX, a bird fabled to exist single, to be consumed by fire by its own act, and to rise again from its ashes, also PHENIX [n]\n",
  "PHOENIXISM": "the practice of forming a new company with same directors, workforce etc. from a bankrupt company [n -S]\n",
  "PHOENIXISMS": "PHOENIXISM, the practice of forming a new company with same directors, workforce etc. from a bankrupt company [n]\n",
  "PHOENIXLIKE": "like a phoenix [adj]\n",
  "PHOH": "an expression of disgust, also FOH [interj]\n",
  "PHOLADES": "PHOLAS, (Greek) a mollusc of the piddock genus of rock-boring molluscs [n]\n",
  "PHOLAS": "(Greek) a mollusc of the piddock genus of rock-boring molluscs [n PHOLADES]\n",
  "PHOLIDOSES": "PHOLIDOSIS, the arrangement of scales, as in fish and reptiles [n]\n",
  "PHOLIDOSIS": "the arrangement of scales, as in fish and reptiles [n PHOLIDOSES]\n",
  "PHON": "(Greek) a unit of loudness of sound as heard by listeners [n -S]\n",
  "PHONAL": "pertaining to speech sounds [adj]\n",
  "PHONASTHENIA": "weakness of voice [n -S]\n",
  "PHONASTHENIAS": "PHONASTHENIA, weakness of voice [n]\n",
  "PHONATE": "to produce speech sounds [v PHONATED, PHONATING, PHONATES]\n",
  "PHONATED": "PHONATE, to produce speech sounds [v]\n",
  "PHONATES": "PHONATE, to produce speech sounds [v]\n",
  "PHONATHON": "a telephone-based fundraising campaign [n -S]\n",
  "PHONATHONS": "PHONATHON, a telephone-based fundraising campaign [n]\n",
  "PHONATING": "PHONATE, to produce speech sounds [v]\n",
  "PHONATION": "the production of vocal sound [n -S]\n",
  "PHONATIONS": "PHONATION, the production of vocal sound [n]\n",
  "PHONATORY": "relating to phonation, the production of vocal sound [adj]\n",
  "PHONAUTOGRAPH": "an instrument for recording sound vibrations [n -S]\n",
  "PHONAUTOGRAPHIC": "relating to a phonautograph, an instrument for recording sound vibrations [adj]\n",
  "PHONAUTOGRAPHS": "PHONAUTOGRAPH, an instrument for recording sound vibrations [n]\n",
  "PHONE": "to telephone [v PHONED, PHONING, PHONES]\n",
  "PHONECAM": "a digital camera within a mobile phone [n -S]\n",
  "PHONECAMS": "PHONECAM, a digital camera within a mobile phone [n]\n",
  "PHONECARD": "a card used to make phone calls [n -S]\n",
  "PHONECARDS": "PHONECARD, a card used to make phone calls [n]\n",
  "PHONED": "PHONE, to telephone [v]\n",
  "PHONEMATIC": "relating to a phoneme [adj PHONEMATICALLY]\n",
  "PHONEMATICALLY": "PHONEMATIC, relating to a phoneme [adv]\n",
  "PHONEME": "the smallest significant unit of sound in a language [n -S]\n",
  "PHONEMES": "PHONEME, the smallest significant unit of sound in a language [n]\n",
  "PHONEMIC": "relating to a phoneme [adj PHONEMICALLY]\n",
  "PHONEMICALLY": "PHONEMIC, relating to a phoneme [adv]\n",
  "PHONEMICISATION": "the process of phonemicising, also PHONEMICIZATION [n]\n",
  "PHONEMICISE": "to analyse into phonemes, also PHONEMICIZE [v PHONEMICISED, PHONEMICISING, PHONEMICISES]\n",
  "PHONEMICISED": "PHONEMICISE, to analyse into phonemes, also PHONEMICIZE [v]\n",
  "PHONEMICISES": "PHONEMICISE, to analyse into phonemes, also PHONEMICIZE [v]\n",
  "PHONEMICISING": "PHONEMICISE, to analyse into phonemes, also PHONEMICIZE [v]\n",
  "PHONEMICIST": "a student of phonemics [n -S]\n",
  "PHONEMICISTS": "PHONEMICIST, a student of phonemics [n]\n",
  "PHONEMICIZATION": "the process of phonemicizing, also PHONEMICISATION [n]\n",
  "PHONEMICIZE": "to analyse into phonemes, also PHONEMICISE [v PHONEMICIZED, PHONEMICIZING, PHONEMICIZES]\n",
  "PHONEMICIZED": "PHONEMICIZE, to analyse into phonemes, also PHONEMICISE [v]\n",
  "PHONEMICIZES": "PHONEMICIZE, to analyse into phonemes, also PHONEMICISE [v]\n",
  "PHONEMICIZING": "PHONEMICIZE, to analyse into phonemes, also PHONEMICISE [v]\n",
  "PHONEMICS": "the branch of linguistics that deals with phonemes and phoneme systems [n]\n",
  "PHONENDOSCOPE": "a device which amplifies small sounds, especially within the human body [n -S]\n",
  "PHONENDOSCOPES": "PHONENDOSCOPE, a device which amplifies small sounds, especially within the human body [n]\n",
  "PHONER": "one that telephones [n -S]\n",
  "PHONERS": "PHONER, one that telephones [n]\n",
  "PHONES": "PHONE, to telephone [v]\n",
  "PHONETIC": "pertaining to the sounds of spoken language, also PHONETICAL [adj PHONETICALLY]\n",
  "PHONETICAL": "of, concerning, according to, or representing the sounds of spoken language, also PHONETIC [adj PHONETICALLY]\n",
  "PHONETICALLY": "PHONETICAL, of, concerning, according to, or representing the sounds of spoken language, also PHONETIC [adv]\n",
  "PHONETICIAN": "a student of phonetics [n -S]\n",
  "PHONETICIANS": "PHONETICIAN, a student of phonetics [n]\n",
  "PHONETICISATION": "the process of phoneticising, also PHONETICIZATION [n]\n",
  "PHONETICISE": "to represent phonetically, also PHONETICIZE, PHONETISE, PHONETIZE [v PHONETICISED, PHONETICISING, PHONETICISES]\n",
  "PHONETICISED": "PHONETICISE, to represent phonetically, also PHONETICIZE, PHONETISE, PHONETIZE [v]\n",
  "PHONETICISES": "PHONETICISE, to represent phonetically, also PHONETICIZE, PHONETISE, PHONETIZE [v]\n",
  "PHONETICISING": "PHONETICISE, to represent phonetically, also PHONETICIZE, PHONETISE, PHONETIZE [v]\n",
  "PHONETICISM": "phonetic character or representation [n -S]\n",
  "PHONETICISMS": "PHONETICISM, phonetic character or representation [n]\n",
  "PHONETICIST": "a student of phonetics [n -S]\n",
  "PHONETICISTS": "PHONETICIST, a student of phonetics [n]\n",
  "PHONETICIZATION": "the process of phoneticizing, also PHONETICISATION [n]\n",
  "PHONETICIZE": "to represent phonetically, also PHONETICISE, PHONETISE, PHONETIZE [v PHONETICIZED, PHONETICIZING, PHONETICIZES]\n",
  "PHONETICIZED": "PHONETICIZE, to represent phonetically, also PHONETICISE, PHONETISE, PHONETIZE [v]\n",
  "PHONETICIZES": "PHONETICIZE, to represent phonetically, also PHONETICISE, PHONETISE, PHONETIZE [v]\n",
  "PHONETICIZING": "PHONETICIZE, to represent phonetically, also PHONETICISE, PHONETISE, PHONETIZE [v]\n",
  "PHONETICS": "the branch of linguistics that deals with pronunciation and speech production, also PHONICS [n]\n",
  "PHONETISATION": "the process of phonetising, also PHONETIZATION [n -S]\n",
  "PHONETISATIONS": "PHONETISATION, the process of phonetising, also PHONETIZATION [n]\n",
  "PHONETISE": "to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETIZE [v PHONETISED, PHONETISING, PHONETISES]\n",
  "PHONETISED": "PHONETISE, to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETIZE [v]\n",
  "PHONETISES": "PHONETISE, to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETIZE [v]\n",
  "PHONETISING": "PHONETISE, to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETIZE [v]\n",
  "PHONETISM": "the science which treats of vocal sounds [n -S]\n",
  "PHONETISMS": "PHONETISM, the science which treats of vocal sounds [n]\n",
  "PHONETIST": "one versed in phonetics; a phonologist [n -S]\n",
  "PHONETISTS": "PHONETIST, one versed in phonetics; a phonologist [n]\n",
  "PHONETIZATION": "the process of phonetizing, also PHONETISATION [n -S]\n",
  "PHONETIZATIONS": "PHONETIZATION, the process of phonetizing, also PHONETISATION [n]\n",
  "PHONETIZE": "to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETISE [v PHONETIZED, PHONETIZING, PHONETIZES]\n",
  "PHONETIZED": "PHONETIZE, to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETISE [v]\n",
  "PHONETIZES": "PHONETIZE, to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETISE [v]\n",
  "PHONETIZING": "PHONETIZE, to represent phonetically, also PHONETICISE, PHONETICIZE, PHONETISE [v]\n",
  "PHONEY": "counterfeit, fake [adj PHONIER, PHONIEST, PHONILY] / to fake, counterfeit [v -ED, -ING, -S]\n",
  "PHONEYED": "PHONEY, to fake, counterfeit [v]\n",
  "PHONEYING": "PHONEY, to fake, counterfeit [v]\n",
  "PHONEYNESS": "the state of being phoney, also PHONINESS [n -ES]\n",
  "PHONEYNESSES": "PHONEYNESS, the state of being phoney, also PHONINESS [n]\n",
  "PHONEYS": "PHONEY, to fake, counterfeit [v]\n",
  "PHONIC": "pertaining to the nature of sound [adj PHONICALLY]\n",
  "PHONICALLY": "PHONIC, pertaining to the nature of sound [adv]\n",
  "PHONICS": "the science of sound [n]\n",
  "PHONIED": "PHONY, to alter, so as to appear genuine [v]\n",
  "PHONIER": "PHONY, not genuine or real, also PHONEY [adj]\n",
  "PHONIES": "PHONY, to alter, so as to appear genuine [v]\n",
  "PHONIEST": "PHONY, not genuine or real, also PHONEY [adj]\n",
  "PHONILY": "PHONY, not genuine or real, also PHONEY [adv]\n",
  "PHONINESS": "the state of being phony, also PHONEYNESS [n -ES]\n",
  "PHONINESSES": "PHONINESS, the state of being phony, also PHONEYNESS [n]\n",
  "PHONING": "PHONE, to telephone [v]\n",
  "PHONMETER": "an instrument for measuring sound levels, also PHONOMETER [n -S]\n",
  "PHONMETERS": "PHONMETER, an instrument for measuring sound levels, also PHONOMETER [n]\n",
  "PHONO": "(colloquial) a record-player [n -S]\n",
  "PHONOCAMPTIC": "reflecting sound, echoing; relating to echoes [adj]\n",
  "PHONOCAMPTICS": "the branch of acoustics dealing with echoes [n]\n",
  "PHONOCARDIOGRAM": "a record of heart sounds [n]\n",
  "PHONOCHEMISTRY": "the branch of chemistry concerned with the chemical effects of sound and ultrasonic waves [n]\n",
  "PHONOFIDDLE": "a one-stringed musical instrument which emits sounds through a metal amplifying horn [n -S]\n",
  "PHONOFIDDLES": "PHONOFIDDLE, a one-stringed musical instrument which emits sounds through a metal amplifying horn [n]\n",
  "PHONOGRAM": "a letter, character, or mark used to represent a particular sound [n -S]\n",
  "PHONOGRAMIC": "like a phonogram, a character representing a sound, also PHONOGRAMMIC [adj PHONOGRAMICALLY]\n",
  "PHONOGRAMICALLY": "PHONOGRAMIC, like a phonogram, a character representing a sound, also PHONOGRAMMIC [adv]\n",
  "PHONOGRAMMIC": "like a phonogram, a character representing a sound, also PHONOGRAMIC [adj]\n",
  "PHONOGRAMS": "PHONOGRAM, a letter, character, or mark used to represent a particular sound [n]\n",
  "PHONOGRAPH": "a character or symbol used to represent a sound, esp. one used in phonography; also, gramophone [n -S]\n",
  "PHONOGRAPHER": "a specialist in phonography [n -S]\n",
  "PHONOGRAPHERS": "PHONOGRAPHER, a specialist in phonography [n]\n",
  "PHONOGRAPHIC": "of or relating to phonography [adj]\n",
  "PHONOGRAPHIES": "PHONOGRAPHY, a system of spelling or shorthand based on speech sounds [n]\n",
  "PHONOGRAPHIST": "an exponent of phonography [n -S]\n",
  "PHONOGRAPHISTS": "PHONOGRAPHIST, an exponent of phonography [n]\n",
  "PHONOGRAPHS": "PHONOGRAPH, a character or symbol used to represent a sound, esp. one used in phonography; also, gramophone [n]\n",
  "PHONOGRAPHY": "a system of spelling or shorthand based on speech sounds [n PHONOGRAPHIES]\n",
  "PHONOLITE": "a fine-grained intermediate igneous rock that rings when struck by a hammer, aka clinkstone [n -S]\n",
  "PHONOLITES": "PHONOLITE, a fine-grained intermediate igneous rock that rings when struck by a hammer, aka clinkstone [n]\n",
  "PHONOLITIC": "of or like phonolite, a compact, feldspathic, igneous rock [adj]\n",
  "PHONOLOGIC": "relating to phonology, also PHONOLOGICAL [adj PHONOLOGICALLY]\n",
  "PHONOLOGICAL": "relating to phonology, also PHONOLOGIC [adj PHONOLOGICALLY]\n",
  "PHONOLOGICALLY": "PHONOLOGICAL, relating to phonology, also PHONOLOGIC [adv]\n",
  "PHONOLOGIES": "PHONOLOGY, the branch of linguistics that deals with systems of sounds [n]\n",
  "PHONOLOGIST": "a student of phonology, the branch of linguistics that deals with systems of sounds [n -S]\n",
  "PHONOLOGISTS": "PHONOLOGIST, a student of phonology, the branch of linguistics that deals with systems of sounds [n]\n",
  "PHONOLOGY": "the branch of linguistics that deals with systems of sounds [n PHONOLOGIES]\n",
  "PHONOMETER": "an instrument for measuring sound levels, also PHONMETER [n -S]\n",
  "PHONOMETERS": "PHONOMETER, an instrument for measuring sound levels, also PHONMETER [n]\n",
  "PHONOMETRIC": "relating to use of the phonometer, an instrument for measuring sound levels, also PHONOMETRICAL [adj]\n",
  "PHONOMETRICAL": "relating to use of the phonometer, an instrument for measuring sound levels, also PHONOMETRIC [adj]\n",
  "PHONON": "a quantum of vibrational energy [n -S]\n",
  "PHONONS": "PHONON, a quantum of vibrational energy [n]\n",
  "PHONOPHOBIA": "fear of noise or of speaking aloud [n -S]\n",
  "PHONOPHOBIAS": "PHONOPHOBIA, fear of noise or of speaking aloud [n]\n",
  "PHONOPHORE": "a sound-conducting apparatus, of various kinds; a device for telephoning and telegraphing simultaneously by the same wire [n -S]\n",
  "PHONOPHORES": "PHONOPHORE, a sound-conducting apparatus, of various kinds; a device for telephoning and telegraphing simultaneously by the same wire [n]\n",
  "PHONOPORE": "a kind of sound-conducting apparatus [n -S]\n",
  "PHONOPORES": "PHONOPORE, a kind of sound-conducting apparatus [n]\n",
  "PHONOS": "PHONO, (colloquial) a record-player [n]\n",
  "PHONOSCOPE": "a device that renders visible the vibrations of sound waves [n -S]\n",
  "PHONOSCOPES": "PHONOSCOPE, a device that renders visible the vibrations of sound waves [n]\n",
  "PHONOTACTIC": "relating to phonotactics, the area of phonology concerned with the analysis and description of the permitted sound sequences of a language [adj]\n",
  "PHONOTACTICS": "the area of phonology concerned with the analysis and description of the permitted sound sequences of a language [n]\n",
  "PHONOTYPE": "printing type for a phonetic alphabet [n -S] / to print in phonotype [v PHONOTYPED, PHONOTYPING, PHONOTYPES]\n",
  "PHONOTYPED": "PHONOTYPE, to print in phonotype [v]\n",
  "PHONOTYPER": "one who phonotypes, prints in phonotype [n -S]\n",
  "PHONOTYPERS": "PHONOTYPER, one who phonotypes, prints in phonotype [n]\n",
  "PHONOTYPES": "PHONOTYPE, to print in phonotype [v]\n",
  "PHONOTYPIC": "of or like a phonotype, a printing type of phonetic alphabet, also PHONOTYPICAL [adj]\n",
  "PHONOTYPICAL": "of or like a phonotype, a printing type of phonetic alphabet, also PHONOTYPIC [adj]\n",
  "PHONOTYPIES": "PHONOTYPY, the transcription into phonetic spelling advocated for ordinary use [n]\n",
  "PHONOTYPING": "PHONOTYPE, to print in phonotype [v]\n",
  "PHONOTYPIST": "one who practises phonotypy [n -S]\n",
  "PHONOTYPISTS": "PHONOTYPIST, one who practises phonotypy [n]\n",
  "PHONOTYPY": "the transcription into phonetic spelling advocated for ordinary use [n PHONOTYPIES]\n",
  "PHONS": "PHON, (Greek) a unit of loudness of sound as heard by listeners [n]\n",
  "PHONY": "not genuine or real, also PHONEY [adj PHONIER, PHONIEST, PHONILY] / to alter, so as to appear genuine [v PHONIED, PHONYING, PHONIES]\n",
  "PHONYING": "PHONY, to alter, so as to appear genuine [v]\n",
  "PHOOEY": "an exclamation of contempt, scorn etc., also PFUI [interj]\n",
  "PHORATE": "an insecticide [n -S]\n",
  "PHORATES": "PHORATE, an insecticide [n]\n",
  "PHORESIES": "PHORESY, a symbiotic relationship between some arthropods and fishes [n]\n",
  "PHORESY": "a symbiotic relationship between some arthropods and fishes [n PHORESIES]\n",
  "PHORETIC": "relating to phoresy, an association in which one animal clings to another to ensure movement from place to place, as some mites use insects [adj]\n",
  "PHORMINGES": "PHORMINX, (Greek) a kind of lyre used by the Greeks [n]\n",
  "PHORMINX": "(Greek) a kind of lyre used by the Greeks [n PHORMINGES]\n",
  "PHORMIUM": "a tall New Zealand evergreen plant of the agave family, with swordlike leaves [n -S]\n",
  "PHORMIUMS": "PHORMIUM, a tall New Zealand evergreen plant of the agave family, with swordlike leaves [n]\n",
  "PHORONID": "a wormlike marine animal [n -S]\n",
  "PHORONIDS": "PHORONID, a wormlike marine animal [n]\n",
  "PHOS": "PHO, a Vietnamese noodle soup [n]\n",
  "PHOSGENE": "a colorless poison gas made from chlorine and carbon monoxide [n -S]\n",
  "PHOSGENES": "PHOSGENE, a colorless poison gas made from chlorine and carbon monoxide [n]\n",
  "PHOSGENITE": "a rare fluorescent secondary mineral consisting of lead chlorine carbonate in the form of greyish tetragonal crystals [n -S]\n",
  "PHOSGENITES": "PHOSGENITE, a rare fluorescent secondary mineral consisting of lead chlorine carbonate in the form of greyish tetragonal crystals [n]\n",
  "PHOSPHATASE": "an enzyme that catalyses the hydrolysis of phosphate esters [n -S]\n",
  "PHOSPHATASES": "PHOSPHATASE, an enzyme that catalyses the hydrolysis of phosphate esters [n]\n",
  "PHOSPHATE": "a salt, ester, or organic derivative of a phosphoric acid [n -S] / to treat with phosphate [v PHOSPHATED, PHOSPHATING, PHOSPHATES]\n",
  "PHOSPHATED": "PHOSPHATE, to treat with phosphate [v]\n",
  "PHOSPHATES": "PHOSPHATE, to treat with phosphate [v]\n",
  "PHOSPHATIC": "containing phosphates; as in phosphatic acid [adj]\n",
  "PHOSPHATIDE": "a phospholipid [n -S]\n",
  "PHOSPHATIDES": "PHOSPHATIDE, a phospholipid [n]\n",
  "PHOSPHATIDIC": "in phosphatidic acid, a type of acid [adj]\n",
  "PHOSPHATIDYL": "any of several monovalent groups that are derived from phosphatidic acids [n -S]\n",
  "PHOSPHATIDYLS": "PHOSPHATIDYL, any of several monovalent groups that are derived from phosphatidic acids [n]\n",
  "PHOSPHATING": "PHOSPHATE, to treat with phosphate [v]\n",
  "PHOSPHATISATION": "the act of phosphatising, also PHOSPHATIZATION [n]\n",
  "PHOSPHATISE": "to phosphate, also PHOSPHATIZE [v PHOSPHATISED, PHOSPHATISING, PHOSPHATISES]\n",
  "PHOSPHATISED": "PHOSPHATISE, to phosphate, also PHOSPHATIZE [v]\n",
  "PHOSPHATISES": "PHOSPHATISE, to phosphate, also PHOSPHATIZE [v]\n",
  "PHOSPHATISING": "PHOSPHATISE, to phosphate, also PHOSPHATIZE [v]\n",
  "PHOSPHATIZATION": "the act of phosphatizing, also PHOSPHATISATION [n]\n",
  "PHOSPHATIZE": "to phosphate, also PHOSPHATISE [v PHOSPHATIZED, PHOSPHATIZING, PHOSPHATIZES]\n",
  "PHOSPHATIZED": "PHOSPHATIZE, to phosphate, also PHOSPHATISE [v]\n",
  "PHOSPHATIZES": "PHOSPHATIZE, to phosphate, also PHOSPHATISE [v]\n",
  "PHOSPHATIZING": "PHOSPHATIZE, to phosphate, also PHOSPHATISE [v]\n",
  "PHOSPHATURIA": "the excessive discharge of phosphates in the urine [n -S]\n",
  "PHOSPHATURIAS": "PHOSPHATURIA, the excessive discharge of phosphates in the urine [n]\n",
  "PHOSPHATURIC": "relating to phosphaturia, the excessive discharge of phosphates in the urine [adj]\n",
  "PHOSPHENE": "a visual sensation produced by mechanical stimulation of the retina, as by pressure on the eyeball [n -S]\n",
  "PHOSPHENES": "PHOSPHENE, a visual sensation produced by mechanical stimulation of the retina, as by pressure on the eyeball [n]\n",
  "PHOSPHID": "a binary compound of phosphorus, also PHOSPHIDE [n -S]\n",
  "PHOSPHIDE": "a binary compound of phosphorus, also PHOSPHID [n -S]\n",
  "PHOSPHIDES": "PHOSPHIDE, a binary compound of phosphorus, also PHOSPHID [n]\n",
  "PHOSPHIDS": "PHOSPHID, a binary compound of phosphorus, also PHOSPHIDE [n]\n",
  "PHOSPHIN": "a colorless gas analogous to ammonia, and having a disagreeable odor resembling that of garlic, also PHOSPHINE [n -S]\n",
  "PHOSPHINE": "a colorless gas analogous to ammonia, and having a disagreeable odor resembling that of garlic, also PHOSPHIN [n -S]\n",
  "PHOSPHINES": "PHOSPHINE, a colorless gas analogous to ammonia, and having a disagreeable odor resembling that of garlic, also PHOSPHIN [n]\n",
  "PHOSPHINS": "PHOSPHIN, a colorless gas analogous to ammonia, and having a disagreeable odor resembling that of garlic, also PHOSPHINE [n]\n",
  "PHOSPHITE": "a salt of phosphorous acid [n -S]\n",
  "PHOSPHITES": "PHOSPHITE, a salt of phosphorous acid [n]\n",
  "PHOSPHOCREATIN": "a compound of phosphoric acid and creatine found in vertebrate muscle, also PHOSPHOCREATINE [n -S]\n",
  "PHOSPHOCREATINE": "a compound of creatine and phosphoric acid found esp. in vertebrate muscle where it is an energy source for muscle contraction, also PHOSPHOCREATIN [n]\n",
  "PHOSPHOCREATINS": "PHOSPHOCREATIN, a compound of phosphoric acid and creatine found in vertebrate muscle, also PHOSPHOCREATINE [n]\n",
  "PHOSPHOKINASE": "a kind of enzyme, aka kinase [n -S]\n",
  "PHOSPHOKINASES": "PHOSPHOKINASE, a kind of enzyme, aka kinase [n]\n",
  "PHOSPHOLIPASE": "any of several enzymes that hydrolyze lecithins or phosphatidylethanolamines [n -S]\n",
  "PHOSPHOLIPASES": "PHOSPHOLIPASE, any of several enzymes that hydrolyze lecithins or phosphatidylethanolamines [n]\n",
  "PHOSPHOLIPID": "a lipid which contains a phosphate group and also a nitrogenous group [n -S]\n",
  "PHOSPHOLIPIDS": "PHOSPHOLIPID, a lipid which contains a phosphate group and also a nitrogenous group [n]\n",
  "PHOSPHONIC": "as in phosphonic acid, the same as phosphorous acid [adj]\n",
  "PHOSPHONIUM": "the radical PH4, analogous to ammonium [n -S]\n",
  "PHOSPHONIUMS": "PHOSPHONIUM, the radical PH4, analogous to ammonium [n]\n",
  "PHOSPHOPROTEIN": "any of various proteins, such as casein, that contain combined phosphoric acid [n -S]\n",
  "PHOSPHOPROTEINS": "PHOSPHOPROTEIN, any of various proteins, such as casein, that contain combined phosphoric acid [n]\n",
  "PHOSPHOR": "phosphorus; a phosphorescent or fluorescent substance generally, also PHOSPHORE [n -S]\n",
  "PHOSPHORATE": "to combine or impregnate with phosphorus [v PHOSPHORATED, PHOSPHORATING, PHOSPHORATES]\n",
  "PHOSPHORATED": "PHOSPHORATE, to combine or impregnate with phosphorus [v]\n",
  "PHOSPHORATES": "PHOSPHORATE, to combine or impregnate with phosphorus [v]\n",
  "PHOSPHORATING": "PHOSPHORATE, to combine or impregnate with phosphorus [v]\n",
  "PHOSPHORE": "phosphorus; a phosphorescent or fluorescent substance generally, also PHOSPHOR [n -S]\n",
  "PHOSPHORES": "PHOSPHORE, phosphorus; a phosphorescent or fluorescent substance generally, also PHOSPHOR [n]\n",
  "PHOSPHORESCE": "to exhibit phosphorescence [v PHOSPHORESCED, PHOSPHORESCING, PHOSPHORESCES]\n",
  "PHOSPHORESCED": "PHOSPHORESCE, to exhibit phosphorescence [v]\n",
  "PHOSPHORESCENCE": "luminescence that continues after the source of excitation has been removed [n]\n",
  "PHOSPHORESCENT": "exhibiting phosphorescence [adj]\n",
  "PHOSPHORESCES": "PHOSPHORESCE, to exhibit phosphorescence [v]\n",
  "PHOSPHORESCING": "PHOSPHORESCE, to exhibit phosphorescence [v]\n",
  "PHOSPHORET": "(obsolete) a phosphide, also PHOSPHURET [n -S]\n",
  "PHOSPHORETS": "PHOSPHORET, (obsolete) a phosphide, also PHOSPHURET [n]\n",
  "PHOSPHORETTED": "combined with phosphorus, also PHOSPHURETTED [adj]\n",
  "PHOSPHORI": "PHOSPHORUS, a chemical element [n]\n",
  "PHOSPHORIC": "of or like phosphorus [adj]\n",
  "PHOSPHORISE": "to combine or impregnate with phosphorus, also PHOSPHORIZE [v PHOSPHORISED, PHOSPHORISING, PHOSPHORISES]\n",
  "PHOSPHORISED": "PHOSPHORISE, to combine or impregnate with phosphorus, also PHOSPHORIZE [v]\n",
  "PHOSPHORISES": "PHOSPHORISE, to combine or impregnate with phosphorus, also PHOSPHORIZE [v]\n",
  "PHOSPHORISING": "PHOSPHORISE, to combine or impregnate with phosphorus, also PHOSPHORIZE [v]\n",
  "PHOSPHORISM": "(obsolete) chronic phosphorus poisoning [n -S]\n",
  "PHOSPHORISMS": "PHOSPHORISM, (obsolete) chronic phosphorus poisoning [n]\n",
  "PHOSPHORITE": "fibrous apatite [n -S]\n",
  "PHOSPHORITES": "PHOSPHORITE, fibrous apatite [n]\n",
  "PHOSPHORITIC": "of or like phosphorite [adj]\n",
  "PHOSPHORIZE": "to combine or impregnate with phosphorus, also PHOSPHORISE [v PHOSPHORIZED, PHOSPHORIZING, PHOSPHORIZES]\n",
  "PHOSPHORIZED": "PHOSPHORIZE, to combine or impregnate with phosphorus, also PHOSPHORISE [v]\n",
  "PHOSPHORIZES": "PHOSPHORIZE, to combine or impregnate with phosphorus, also PHOSPHORISE [v]\n",
  "PHOSPHORIZING": "PHOSPHORIZE, to combine or impregnate with phosphorus, also PHOSPHORISE [v]\n",
  "PHOSPHOROLYSES": "PHOSPHOROLYSIS, a reaction analogous to hydrolysis involving phosphoric acid [n]\n",
  "PHOSPHOROLYSIS": "a reaction analogous to hydrolysis involving phosphoric acid [n PHOSPHOROLYSES]\n",
  "PHOSPHOROLYTIC": "relating to phosphorolysis [adj]\n",
  "PHOSPHOROSCOPE": "an instrument for measuring the duration of phosphorescence after the source of radiation causing it has been removed [n -S]\n",
  "PHOSPHOROSCOPES": "PHOSPHOROSCOPE, an instrument for measuring the duration of phosphorescence after the source of radiation causing it has been removed [n]\n",
  "PHOSPHOROUS": "containing phosphorus [adj]\n",
  "PHOSPHORS": "PHOSPHOR, phosphorus; a phosphorescent or fluorescent substance generally, also PHOSPHORE [n]\n",
  "PHOSPHORUS": "a chemical element [n PHOSPHORUSES or PHOSPHORI]\n",
  "PHOSPHORUSES": "PHOSPHORUS, a chemical element [n]\n",
  "PHOSPHORYL": "the radical PO, regarded as the typical nucleus of certain compounds [n -S]\n",
  "PHOSPHORYLASE": "any of the enzymes that catalyze phosphorolysis with the formation of organic phosphates [n -S]\n",
  "PHOSPHORYLASES": "PHOSPHORYLASE, any of the enzymes that catalyze phosphorolysis with the formation of organic phosphates [n]\n",
  "PHOSPHORYLATE": "to cause (an organic compound) to take up or combine with phosphoric acid or a phosphorus-containing group [v PHOSPHORYLATED, PHOSPHORYLATING, PHOSPHORYLATES]\n",
  "PHOSPHORYLATED": "PHOSPHORYLATE, to cause (an organic compound) to take up or combine with phosphoric acid or a phosphorus-containing group [v]\n",
  "PHOSPHORYLATES": "PHOSPHORYLATE, to cause (an organic compound) to take up or combine with phosphoric acid or a phosphorus-containing group [v]\n",
  "PHOSPHORYLATING": "PHOSPHORYLATE, to cause (an organic compound) to take up or combine with phosphoric acid or a phosphorus-containing group [v]\n",
  "PHOSPHORYLATION": "the process of phosphorylating a chemical compound [n]\n",
  "PHOSPHORYLATIVE": "of or like phosphorylate [adj]\n",
  "PHOSPHORYLS": "PHOSPHORYL, the radical PO, regarded as the typical nucleus of certain compounds [n]\n",
  "PHOSPHURET": "(obsolete) a phosphide, also PHOSPHORET [n -S]\n",
  "PHOSPHURETS": "PHOSPHURET, (obsolete) a phosphide, also PHOSPHORET [n]\n",
  "PHOSPHURETTED": "combined with phosphorus, also PHOSPHORETTED [adj]\n",
  "PHOSSY": "as in phossy jaw, an affliction of match workers in the 19th century [adj]\n",
  "PHOT": "a unit of the product of illumination and duration, equal to one lux maintained for one second [n -S]\n",
  "PHOTIC": "pertaining to light [adj PHOTICALLY]\n",
  "PHOTICALLY": "PHOTIC, pertaining to light [adv]\n",
  "PHOTICS": "the science of light [n]\n",
  "PHOTINIA": "any of a genus of evergreen or deciduous trees or shrubs of the Rosaceae family [n -S]\n",
  "PHOTINIAS": "PHOTINIA, any of a genus of evergreen or deciduous trees or shrubs of the Rosaceae family [n]\n",
  "PHOTINO": "a hypothetical elementary particle [n -S]\n",
  "PHOTINOS": "PHOTINO, a hypothetical elementary particle [n]\n",
  "PHOTISM": "a hallucinatory sensation of light; a visual synaesthesia [n -S]\n",
  "PHOTISMS": "PHOTISM, a hallucinatory sensation of light; a visual synaesthesia [n]\n",
  "PHOTO": "(colloquial) to photograph [v -ED, -ING, -S]\n",
  "PHOTOACTINIC": "emitting actinic radiation [adj]\n",
  "PHOTOACTIVE": "affected physically or chemically by light or other radiation [adj]\n",
  "PHOTOAUTOTROPH": "an organism capable of synthesizing its own food from inorganic substances using light as an energy source [n -S]\n",
  "PHOTOAUTOTROPHS": "PHOTOAUTOTROPH, an organism capable of synthesizing its own food from inorganic substances using light as an energy source [n]\n",
  "PHOTOBATHIC": "designating the zone of the sea where photosynthesis takes place [adj]\n",
  "PHOTOBIOLOGIC": "relating to photobiology, also PHOTOBIOLOGICAL [adj]\n",
  "PHOTOBIOLOGICAL": "relating to photobiology, also PHOTOBIOLOGIC [adj]\n",
  "PHOTOBIOLOGIES": "PHOTOBIOLOGY, the study of the effects of light on organisms [n]\n",
  "PHOTOBIOLOGIST": "one who studies photobiology [n -S]\n",
  "PHOTOBIOLOGISTS": "PHOTOBIOLOGIST, one who studies photobiology [n]\n",
  "PHOTOBIOLOGY": "the study of the effects of light on organisms [n PHOTOBIOLOGIES]\n",
  "PHOTOBLOG": "a blog in the form of a series of photographs [n -S] / to keep a photoblog [v PHOTOBLOGGED, PHOTOBLOGGING, PHOTOBLOGS]\n",
  "PHOTOBLOGGED": "PHOTOBLOG, to keep a photoblog [v]\n",
  "PHOTOBLOGGING": "PHOTOBLOG, to keep a photoblog [v]\n",
  "PHOTOBLOGS": "PHOTOBLOG, to keep a photoblog [v]\n",
  "PHOTOBOMB": "to place oneself in the background of a photograph deliberately and without the knowledge of the photographer or subject [v -ED, -ING, -S]\n",
  "PHOTOBOMBED": "PHOTOBOMB, to place oneself in the background of a photograph deliberately and without the knowledge of the photographer or subject [v]\n",
  "PHOTOBOMBING": "PHOTOBOMB, to place oneself in the background of a photograph deliberately and without the knowledge of the photographer or subject [v]\n",
  "PHOTOBOMBS": "PHOTOBOMB, to place oneself in the background of a photograph deliberately and without the knowledge of the photographer or subject [v]\n",
  "PHOTOCALL": "an occasion when people at a formal event are asked to have their photograph taken together [n -S]\n",
  "PHOTOCALLS": "PHOTOCALL, an occasion when people at a formal event are asked to have their photograph taken together [n]\n",
  "PHOTOCARD": "an identity card containing a photograph of the bearer [n -S]\n",
  "PHOTOCARDS": "PHOTOCARD, an identity card containing a photograph of the bearer [n]\n",
  "PHOTOCATALYSES": "PHOTOCATALYSIS, the promotion, acceleration or retardation of a chemical reaction by light [n]\n",
  "PHOTOCATALYSIS": "the promotion, acceleration or retardation of a chemical reaction by light [n PHOTOCATALYSES]\n",
  "PHOTOCATALYTIC": "relating to photocatalysis [adj]\n",
  "PHOTOCATHODE": "a cathode that emits electrons when exposed to radiant energy and esp. light [n -S]\n",
  "PHOTOCATHODES": "PHOTOCATHODE, a cathode that emits electrons when exposed to radiant energy and esp. light [n]\n",
  "PHOTOCELL": "a photoelectric cell [n -S]\n",
  "PHOTOCELLS": "PHOTOCELL, a photoelectric cell [n]\n",
  "PHOTOCHEMICAL": "of, relating to, or resulting from the chemical action of radiant energy and esp. light [adj PHOTOCHEMICALLY]\n",
  "PHOTOCHEMICALLY": "PHOTOCHEMICAL, of, relating to, or resulting from the chemical action of radiant energy and esp. light [adv]\n",
  "PHOTOCHEMIST": "a practitioner of photochemistry [n -S]\n",
  "PHOTOCHEMISTRY": "science, processes and properties of chemical changes effected by light [n]\n",
  "PHOTOCHEMISTS": "PHOTOCHEMIST, a practitioner of photochemistry [n]\n",
  "PHOTOCHROMIC": "changing colour, and hence changing the amount of light transmitted when the incident light increases, or decreases [adj] / a photochromic material [n -S]\n",
  "PHOTOCHROMICS": "PHOTOCHROMIC, a photochromic material [n]\n",
  "PHOTOCHROMIES": "PHOTOCHROMY, a former process of colour photography [n]\n",
  "PHOTOCHROMISM": "the property of changing color on exposure to light or other radiation and of reverting to original color immediately the light or radiation source is removed [n -S]\n",
  "PHOTOCHROMISMS": "PHOTOCHROMISM, the property of changing color on exposure to light or other radiation and of reverting to original color immediately the light or radiation source is removed [n]\n",
  "PHOTOCHROMY": "a former process of colour photography [n PHOTOCHROMIES]\n",
  "PHOTOCOMPOSE": "to set (as reading matter) by photocomposition [v PHOTOCOMPOSED, PHOTOCOMPOSING, PHOTOCOMPOSES]\n",
  "PHOTOCOMPOSED": "PHOTOCOMPOSE, to set (as reading matter) by photocomposition [v]\n",
  "PHOTOCOMPOSER": "one who photocomposes [n -S]\n",
  "PHOTOCOMPOSERS": "PHOTOCOMPOSER, one who photocomposes [n]\n",
  "PHOTOCOMPOSES": "PHOTOCOMPOSE, to set (as reading matter) by photocomposition [v]\n",
  "PHOTOCOMPOSING": "PHOTOCOMPOSE, to set (as reading matter) by photocomposition [v]\n",
  "PHOTOCONDUCTING": "relating to, or showing, photoconductivity [adj]\n",
  "PHOTOCONDUCTION": "conduction of electricity resulting from the absorption of light [n]\n",
  "PHOTOCONDUCTIVE": "having, involving, or operating by photoconductivity [adj]\n",
  "PHOTOCONDUCTOR": "a photoconductive substance [n -S]\n",
  "PHOTOCONDUCTORS": "PHOTOCONDUCTOR, a photoconductive substance [n]\n",
  "PHOTOCOPIABLE": "that can be photocopied [adj]\n",
  "PHOTOCOPIED": "PHOTOCOPY, to make a photocopy of [v]\n",
  "PHOTOCOPIER": "a machine for copying [n -S]\n",
  "PHOTOCOPIERS": "PHOTOCOPIER, a machine for copying [n]\n",
  "PHOTOCOPIES": "PHOTOCOPY, to make a photocopy of [v]\n",
  "PHOTOCOPY": "a photographic reproduction of written matter, etc. [n PHOTOCOPIES] / to make a photocopy of [v PHOTOCOPIED, PHOTOCOPYING, PHOTOCOPIES]\n",
  "PHOTOCOPYING": "the act of making a photocopy [n -S]\n",
  "PHOTOCOPYINGS": "PHOTOCOPYING, the act of making a photocopy [n]\n",
  "PHOTOCURRENT": "a stream of electrons produced by photoelectric or photovoltaic effects [n -S]\n",
  "PHOTOCURRENTS": "PHOTOCURRENT, a stream of electrons produced by photoelectric or photovoltaic effects [n]\n",
  "PHOTODEGRADABLE": "chemically degradable by the action of light [adj]\n",
  "PHOTODETECTOR": "any of various devices for detecting and measuring the intensity of radiant energy through photoelectric action [n -S]\n",
  "PHOTODETECTORS": "PHOTODETECTOR, any of various devices for detecting and measuring the intensity of radiant energy through photoelectric action [n]\n",
  "PHOTODIODE": "a two-electrode semiconductor device [n -S]\n",
  "PHOTODIODES": "PHOTODIODE, a two-electrode semiconductor device [n]\n",
  "PHOTODISK": "a disk for use in a computer that contains photographs or can have photographs stored on it in a digitally coded manner [n -S]\n",
  "PHOTODISKS": "PHOTODISK, a disk for use in a computer that contains photographs or can have photographs stored on it in a digitally coded manner [n]\n",
  "PHOTODISSOCIATE": "to effect photodissociation, dissociation produced by the absorption of radiant energy [v]\n",
  "PHOTODUPLICATE": "to duplicate by photocopier [v PHOTODUPLICATED, PHOTODUPLICATES]\n",
  "PHOTODUPLICATED": "PHOTODUPLICATE, to duplicate by photocopier [v]\n",
  "PHOTODUPLICATES": "PHOTODUPLICATE, to duplicate by photocopier [v]\n",
  "PHOTODYNAMIC": "of, relating to, or having the property of intensifying or inducing a toxic reaction to light (as in the destruction of cancer cells stained with a light-sensitive dye) in a living system [adj]\n",
  "PHOTODYNAMICS": "the branch of biology concerned with the effects of light on the actions of plants and animals [n]\n",
  "PHOTOED": "PHOTO, (colloquial) to photograph [v]\n",
  "PHOTOELASTIC": "relating to or exhibiting photoelastic [adj]\n",
  "PHOTOELASTICITY": "the state of being photoelastic [n]\n",
  "PHOTOELECTRIC": "relating to photoelectricity, also PHOTOELECTRICAL [adj]\n",
  "PHOTOELECTRICAL": "relating to photoelectricity, also PHOTOELECTRIC [adj]\n",
  "PHOTOELECTRODE": "an electrode which can exhibit photoelectricity [n -S]\n",
  "PHOTOELECTRODES": "PHOTOELECTRODE, an electrode which can exhibit photoelectricity [n]\n",
  "PHOTOELECTRON": "an electron released from a surface by a photon [n -S]\n",
  "PHOTOELECTRONIC": "relating to photoelectronics [adj]\n",
  "PHOTOELECTRONS": "PHOTOELECTRON, an electron released from a surface by a photon [n]\n",
  "PHOTOEMISSION": "the release of electrons from a usually solid material (as a metal) by means of energy supplied by incidence of radiation and esp. light [n -S]\n",
  "PHOTOEMISSIONS": "PHOTOEMISSION, the release of electrons from a usually solid material (as a metal) by means of energy supplied by incidence of radiation and esp. light [n]\n",
  "PHOTOEMISSIVE": "relating to photoemission [adj]\n",
  "PHOTOENGRAVE": "to make a photoengraving of [v PHOTOENGRAVED, PHOTOENGRAVING, PHOTOENGRAVES]\n",
  "PHOTOENGRAVED": "PHOTOENGRAVE, to make a photoengraving of [v]\n",
  "PHOTOENGRAVER": "one who does photoengraving [n -S]\n",
  "PHOTOENGRAVERS": "PHOTOENGRAVER, one who does photoengraving [n]\n",
  "PHOTOENGRAVES": "PHOTOENGRAVE, to make a photoengraving of [v]\n",
  "PHOTOENGRAVING": "any process of engraving by aid of photography, esp. from relief plates [n -S]\n",
  "PHOTOENGRAVINGS": "PHOTOENGRAVING, any process of engraving by aid of photography, esp. from relief plates [n]\n",
  "PHOTOEXCITATION": "the process of exciting the atoms or molecules of a substance by the absorption of radiant energy [n]\n",
  "PHOTOEXCITED": "relating to photoexcitation [adj]\n",
  "PHOTOFINISHER": "one that develops and prints photographic film commercially [n -S]\n",
  "PHOTOFINISHERS": "PHOTOFINISHER, one that develops and prints photographic film commercially [n]\n",
  "PHOTOFINISHING": "the development and printing of photographic film commercially [n -S]\n",
  "PHOTOFINISHINGS": "PHOTOFINISHING, the development and printing of photographic film commercially [n]\n",
  "PHOTOFISSION": "nuclear fission induced by gamma rays [n -S]\n",
  "PHOTOFISSIONS": "PHOTOFISSION, nuclear fission induced by gamma rays [n]\n",
  "PHOTOFIT": "(tradename) a method of building up a picture of a person by assembling a number of photographs of individual facial features [n -S]\n",
  "PHOTOFITS": "PHOTOFIT, (tradename) a method of building up a picture of a person by assembling a number of photographs of individual facial features [n]\n",
  "PHOTOFLASH": "a photographic flash [n -ES]\n",
  "PHOTOFLASHES": "PHOTOFLASH, a photographic flash [n]\n",
  "PHOTOFLOOD": "an incandescent tungsten lamp [n -S]\n",
  "PHOTOFLOODS": "PHOTOFLOOD, an incandescent tungsten lamp [n]\n",
  "PHOTOFLUOROGRAM": "a photograph of a fluoroscopic image [n]\n",
  "PHOTOG": "(colloquial) one who takes photographs [n -S]\n",
  "PHOTOGELATIN": "as in photogelatin process, another name for collotype [adj]\n",
  "PHOTOGELATINE": "another name for collotype, a method of printing illustrations from hardened gelatin film [adj]\n",
  "PHOTOGEN": "a light-producing organ in animals [n -S]\n",
  "PHOTOGENE": "an afterimage [n -S]\n",
  "PHOTOGENES": "PHOTOGENE, an afterimage [n]\n",
  "PHOTOGENIC": "of or pertaining to photogeny; producing or generating light [adj PHOTOGENICALLY]\n",
  "PHOTOGENICALLY": "PHOTOGENIC, of or pertaining to photogeny; producing or generating light [adv]\n",
  "PHOTOGENIES": "PHOTOGENY, (obsolete) photography [n]\n",
  "PHOTOGENS": "PHOTOGEN, a light-producing organ in animals [n]\n",
  "PHOTOGENY": "(obsolete) photography [n PHOTOGENIES]\n",
  "PHOTOGEOLOGIC": "relating to photogeology, also PHOTOGEOLOGICAL [adj]\n",
  "PHOTOGEOLOGICAL": "relating to photogeology, also PHOTOGEOLOGIC [adj]\n",
  "PHOTOGEOLOGIES": "PHOTOGEOLOGY, a branch of geology concerned with the identification and study of geological features through the study of aerial or orbital photographs [n]\n",
  "PHOTOGEOLOGIST": "one who studies photogeology [n -S]\n",
  "PHOTOGEOLOGISTS": "PHOTOGEOLOGIST, one who studies photogeology [n]\n",
  "PHOTOGEOLOGY": "a branch of geology concerned with the identification and study of geological features through the study of aerial or orbital photographs [n PHOTOGEOLOGIES]\n",
  "PHOTOGLYPH": "photographic engraving [n -S]\n",
  "PHOTOGLYPHIC": "of or like a photoglyph, photographic engraving [adj]\n",
  "PHOTOGLYPHIES": "PHOTOGLYPHY, photography by photoglyph [n]\n",
  "PHOTOGLYPHS": "PHOTOGLYPH, photographic engraving [n]\n",
  "PHOTOGLYPHY": "photography by photoglyph [n PHOTOGLYPHIES]\n",
  "PHOTOGRAM": "a photograph [n -S]\n",
  "PHOTOGRAMMETRIC": "relating to measurement by photogrammetry [adj]\n",
  "PHOTOGRAMMETRY": "the science of making reliable measurements by the use of photographs and esp. aerial photographs (as in surveying) [n]\n",
  "PHOTOGRAMS": "PHOTOGRAM, a photograph [n]\n",
  "PHOTOGRAPH": "to take a photograph of [v -ED, -ING, -S]\n",
  "PHOTOGRAPHED": "PHOTOGRAPH, to take a photograph of [v]\n",
  "PHOTOGRAPHER": "one who practices photography [n -S]\n",
  "PHOTOGRAPHERS": "PHOTOGRAPHER, one who practices photography [n]\n",
  "PHOTOGRAPHIC": "relating to photography, also PHOTOGRAPHICAL [adj]\n",
  "PHOTOGRAPHICAL": "relating to photography, also PHOTOGRAPHIC [adj]\n",
  "PHOTOGRAPHIES": "PHOTOGRAPHY, the process of producing images by the action of radiant energy and esp. light on a sensitive surface [n]\n",
  "PHOTOGRAPHING": "PHOTOGRAPH, to take a photograph of [v]\n",
  "PHOTOGRAPHIST": "a photographer [n -S]\n",
  "PHOTOGRAPHISTS": "PHOTOGRAPHIST, a photographer [n]\n",
  "PHOTOGRAPHS": "PHOTOGRAPH, to take a photograph of [v]\n",
  "PHOTOGRAPHY": "the process of producing images by the action of radiant energy and esp. light on a sensitive surface [n PHOTOGRAPHIES]\n",
  "PHOTOGRAVURE": "printing from engraved plates photographically prepared [n -S]\n",
  "PHOTOGRAVURES": "PHOTOGRAVURE, printing from engraved plates photographically prepared [n]\n",
  "PHOTOGS": "PHOTOG, (colloquial) one who takes photographs [n]\n",
  "PHOTOINDUCED": "induced by the action of light [adj]\n",
  "PHOTOINDUCTION": "induction by the effect of light [n -S]\n",
  "PHOTOINDUCTIONS": "PHOTOINDUCTION, induction by the effect of light [n]\n",
  "PHOTOINDUCTIVE": "relating to photoinduction [adj]\n",
  "PHOTOING": "PHOTO, (colloquial) to photograph [v]\n",
  "PHOTOIONISATION": "ionization (as in the ionosphere) of a molecule or atom caused by absorption of radiant energy, also PHOTOIONIZATION [n]\n",
  "PHOTOIONISE": "to ionize by electromagnetic radiation, also PHOTOIONIZE [v PHOTOIONISED, PHOTOIONISING, PHOTOIONISES]\n",
  "PHOTOIONISED": "PHOTOIONISE, to ionize by electromagnetic radiation, also PHOTOIONIZE [v]\n",
  "PHOTOIONISES": "PHOTOIONISE, to ionize by electromagnetic radiation, also PHOTOIONIZE [v]\n",
  "PHOTOIONISING": "PHOTOIONISE, to ionize by electromagnetic radiation, also PHOTOIONIZE [v]\n",
  "PHOTOIONIZATION": "ionization (as in the ionosphere) of a molecule or atom caused by absorption of radiant energy, also PHOTOIONISATION [n]\n",
  "PHOTOIONIZE": "to ionize by electromagnetic radiation, also PHOTOIONISE [v PHOTOIONIZED, PHOTOIONIZING, PHOTOIONIZES]\n",
  "PHOTOIONIZED": "PHOTOIONIZE, to ionize by electromagnetic radiation, also PHOTOIONISE [v]\n",
  "PHOTOIONIZES": "PHOTOIONIZE, to ionize by electromagnetic radiation, also PHOTOIONISE [v]\n",
  "PHOTOIONIZING": "PHOTOIONIZE, to ionize by electromagnetic radiation, also PHOTOIONISE [v]\n",
  "PHOTOJOURNALISM": "journalism in which written copy is subordinate to pictorial usually photographic presentation of news stories or in which a high proportion of pictorial presentation is used [n]\n",
  "PHOTOJOURNALIST": "a practitioner of photojournalism [n]\n",
  "PHOTOKINESES": "PHOTOKINESIS, motion or activity induced by light [n]\n",
  "PHOTOKINESIS": "motion or activity induced by light [n PHOTOKINESES]\n",
  "PHOTOKINETIC": "relating to photokinesis [adj]\n",
  "PHOTOLITHO": "(short for) a photolithograph [n -S]\n",
  "PHOTOLITHOGRAPH": "a plate produced by photolithography [n]\n",
  "PHOTOLITHOS": "PHOTOLITHO, (short for) a photolithograph [n]\n",
  "PHOTOLUMINESCE": "to produce photoluminescence [v PHOTOLUMINESCED, PHOTOLUMINESCES]\n",
  "PHOTOLUMINESCED": "PHOTOLUMINESCE, to produce photoluminescence [v]\n",
  "PHOTOLUMINESCES": "PHOTOLUMINESCE, to produce photoluminescence [v]\n",
  "PHOTOLYSABLE": "capable of being photolysed, also PHOTOLYZABLE [adj]\n",
  "PHOTOLYSE": "to cause photolysis in, also PHOTOLYZE [v PHOTOLYSED, PHOTOLYSING, PHOTOLYSES]\n",
  "PHOTOLYSED": "PHOTOLYSE, to cause photolysis in, also PHOTOLYZE [v]\n",
  "PHOTOLYSES": "PHOTOLYSE, to cause photolysis in, also PHOTOLYZE [v]\n",
  "PHOTOLYSING": "PHOTOLYSE, to cause photolysis in, also PHOTOLYZE [v]\n",
  "PHOTOLYSIS": "decomposition or dissociation of molecules by the action of light; an instance of this [n PHOTOLYSES]\n",
  "PHOTOLYTIC": "relating to photolysis [adj PHOTOLYTICALLY]\n",
  "PHOTOLYTICALLY": "PHOTOLYTIC, relating to photolysis [adv]\n",
  "PHOTOLYZABLE": "capable of being photolyzed, also PHOTOLYSABLE [adj]\n",
  "PHOTOLYZE": "to cause photolysis in, also PHOTOLYSE [v PHOTOLYZED, PHOTOLYZING, PHOTOLYZES]\n",
  "PHOTOLYZED": "PHOTOLYZE, to cause photolysis in, also PHOTOLYSE [v]\n",
  "PHOTOLYZES": "PHOTOLYZE, to cause photolysis in, also PHOTOLYSE [v]\n",
  "PHOTOLYZING": "PHOTOLYZE, to cause photolysis in, also PHOTOLYSE [v]\n",
  "PHOTOMACHINE": "a machine that prints copies of digital photographs [n -S]\n",
  "PHOTOMACHINES": "PHOTOMACHINE, a machine that prints copies of digital photographs [n]\n",
  "PHOTOMACROGRAPH": "a photograph of an object that is unmagnified or only slightly magnified [n]\n",
  "PHOTOMAP": "to map by means of aerial photography [v PHOTOMAPPED, PHOTOMAPPING, PHOTOMAPS]\n",
  "PHOTOMAPPED": "PHOTOMAP, to map by means of aerial photography [v]\n",
  "PHOTOMAPPING": "PHOTOMAP, to map by means of aerial photography [v]\n",
  "PHOTOMAPS": "PHOTOMAP, to map by means of aerial photography [v]\n",
  "PHOTOMASK": "a mask used in photography [n -S]\n",
  "PHOTOMASKS": "PHOTOMASK, a mask used in photography [n]\n",
  "PHOTOMECHANICAL": "relating to or involving any of various processes for producing printed matter from a photographically prepared surface [adj]\n",
  "PHOTOMETER": "an instrument for measuring light intensity [n -S]\n",
  "PHOTOMETERS": "PHOTOMETER, an instrument for measuring light intensity [n]\n",
  "PHOTOMETRIC": "of or relating to photometry or the photometer [adj PHOTOMETRICALLY]\n",
  "PHOTOMETRICALLY": "PHOTOMETRIC, of or relating to photometry or the photometer [adv]\n",
  "PHOTOMETRIES": "PHOTOMETRY, that branch of science which treats of the measurement of the intensity of light [n]\n",
  "PHOTOMETRIST": "one who practises photometry, that branch of science which treats of the measurement of the intensity of light [n -S]\n",
  "PHOTOMETRISTS": "PHOTOMETRIST, one who practises photometry, that branch of science which treats of the measurement of the intensity of light [n]\n",
  "PHOTOMETRY": "that branch of science which treats of the measurement of the intensity of light [n PHOTOMETRIES]\n",
  "PHOTOMICROGRAPH": "a photograph of a microscope image [n]\n",
  "PHOTOMONTAGE": "montage using photographic images [n -S]\n",
  "PHOTOMONTAGES": "PHOTOMONTAGE, montage using photographic images [n]\n",
  "PHOTOMOSAIC": "an image composed of many smaller photographs [n -S]\n",
  "PHOTOMOSAICS": "PHOTOMOSAIC, an image composed of many smaller photographs [n]\n",
  "PHOTOMULTIPLIER": "a photocell with a series of dynodes which amplify the emission current by electron multiplication [n]\n",
  "PHOTOMURAL": "an enlarged photograph, usually several yards long [n -S]\n",
  "PHOTOMURALS": "PHOTOMURAL, an enlarged photograph, usually several yards long [n]\n",
  "PHOTON": "a quantum of light or other electromagnetic radiation [n -S]\n",
  "PHOTONASTIC": "related to photonasty, the adoption of a certain position due to the effect of light on growth [adj]\n",
  "PHOTONASTIES": "PHOTONASTY, the adoption of a certain position due to the effect of light on growth [n]\n",
  "PHOTONASTY": "the adoption of a certain position due to the effect of light on growth [n PHOTONASTIES]\n",
  "PHOTONEGATIVE": "exhibiting negative phototropism or phototaxis [adj]\n",
  "PHOTONEUTRON": "a neutron emitted from a nucleus as a result of photodisintegration [n -S]\n",
  "PHOTONEUTRONS": "PHOTONEUTRON, a neutron emitted from a nucleus as a result of photodisintegration [n]\n",
  "PHOTONIC": "relating to a photon [adj]\n",
  "PHOTONICS": "the study of the application of photons e.g. in communications technology [n]\n",
  "PHOTONOVEL": "a novel in the form of a series of photographs with speech balloons [n -S]\n",
  "PHOTONOVELS": "PHOTONOVEL, a novel in the form of a series of photographs with speech balloons [n]\n",
  "PHOTONS": "PHOTON, a quantum of light or other electromagnetic radiation [n]\n",
  "PHOTONUCLEAR": "relating to or caused by the incidence of radiant energy (as gamma rays) on atomic nuclei [adj]\n",
  "PHOTOOXIDATION": "oxidation under the influence of radiant energy, as light [n -S]\n",
  "PHOTOOXIDATIONS": "PHOTOOXIDATION, oxidation under the influence of radiant energy, as light [n]\n",
  "PHOTOOXIDATIVE": "relating to photooxidation [adj]\n",
  "PHOTOOXIDISE": "to undergo photooxidation, also PHOTOOXIDIZE [v PHOTOOXIDISED, PHOTOOXIDISING, PHOTOOXIDISES]\n",
  "PHOTOOXIDISED": "PHOTOOXIDISE, to undergo photooxidation, also PHOTOOXIDIZE [v]\n",
  "PHOTOOXIDISES": "PHOTOOXIDISE, to undergo photooxidation, also PHOTOOXIDIZE [v]\n",
  "PHOTOOXIDISING": "PHOTOOXIDISE, to undergo photooxidation, also PHOTOOXIDIZE [v]\n",
  "PHOTOOXIDIZE": "to undergo photooxidation, also PHOTOOXIDISE [v PHOTOOXIDIZED, PHOTOOXIDIZING, PHOTOOXIDIZES]\n",
  "PHOTOOXIDIZED": "PHOTOOXIDIZE, to undergo photooxidation, also PHOTOOXIDISE [v]\n",
  "PHOTOOXIDIZES": "PHOTOOXIDIZE, to undergo photooxidation, also PHOTOOXIDISE [v]\n",
  "PHOTOOXIDIZING": "PHOTOOXIDIZE, to undergo photooxidation, also PHOTOOXIDISE [v]\n",
  "PHOTOPERIOD": "the period during every 24 hours when an organism is exposed to daylight [n -S]\n",
  "PHOTOPERIODIC": "relating to a photoperiod [adj]\n",
  "PHOTOPERIODISM": "a plant or animal's response or capacity to respond to photoperiod [n -S]\n",
  "PHOTOPERIODISMS": "PHOTOPERIODISM, a plant or animal's response or capacity to respond to photoperiod [n]\n",
  "PHOTOPERIODS": "PHOTOPERIOD, the period during every 24 hours when an organism is exposed to daylight [n]\n",
  "PHOTOPHASE": "the light period of a photoperiodic cycle of light and dark [n -S]\n",
  "PHOTOPHASES": "PHOTOPHASE, the light period of a photoperiodic cycle of light and dark [n]\n",
  "PHOTOPHIL": "an organism that seeks the light [n -S]\n",
  "PHOTOPHILIC": "light-loving, turning towards the light, also PHOTOPHILOUS [adj]\n",
  "PHOTOPHILIES": "PHOTOPHILY, the state of being photophilic, light-loving, turning towards the light [n]\n",
  "PHOTOPHILOUS": "light-loving, turning towards the light, also PHOTOPHILIC [adj]\n",
  "PHOTOPHILS": "PHOTOPHIL, an organism that seeks the light [n]\n",
  "PHOTOPHILY": "the state of being photophilic, light-loving, turning towards the light [n PHOTOPHILIES]\n",
  "PHOTOPHOBE": "a plant that shuns or avoids light [n -S]\n",
  "PHOTOPHOBES": "PHOTOPHOBE, a plant that shuns or avoids light [n]\n",
  "PHOTOPHOBIA": "the morbid fear of light [n -S]\n",
  "PHOTOPHOBIAS": "PHOTOPHOBIA, the morbid fear of light [n]\n",
  "PHOTOPHOBIC": "having a fear of the light [adj]\n",
  "PHOTOPHONE": "an apparatus for the production of sound by the action of rays of light [n -S]\n",
  "PHOTOPHONES": "PHOTOPHONE, an apparatus for the production of sound by the action of rays of light [n]\n",
  "PHOTOPHONIC": "relating to photophony [adj]\n",
  "PHOTOPHONIES": "PHOTOPHONY, the art or practice of using the photophone [n]\n",
  "PHOTOPHONY": "the art or practice of using the photophone [n PHOTOPHONIES]\n",
  "PHOTOPHORE": "a luminiferous organ [n -S]\n",
  "PHOTOPHORES": "PHOTOPHORE, a luminiferous organ [n]\n",
  "PHOTOPHORESES": "PHOTOPHORESIS, migration of suspended particles under the influence of light [n]\n",
  "PHOTOPHORESIS": "migration of suspended particles under the influence of light [n PHOTOPHORESES]\n",
  "PHOTOPIA": "vision in illumination similar to daylight, believed to involve chiefly the cones of the retina [n -S]\n",
  "PHOTOPIAS": "PHOTOPIA, vision in illumination similar to daylight, believed to involve chiefly the cones of the retina [n]\n",
  "PHOTOPIC": "relating to photopia, vision in illumination similar to daylight, believed to involve chiefly the cones of the retina [adj]\n",
  "PHOTOPLAY": "a motion picture [n -S]\n",
  "PHOTOPLAYS": "PHOTOPLAY, a motion picture [n]\n",
  "PHOTOPOLYMER": "a photosensitive plastic used esp. in the manufacture of printing plates [n -S]\n",
  "PHOTOPOLYMERS": "PHOTOPOLYMER, a photosensitive plastic used esp. in the manufacture of printing plates [n]\n",
  "PHOTOPOSITIVE": "exhibiting positive phototropism or phototaxis [adj]\n",
  "PHOTOPRODUCT": "a product of a photochemical reaction [n -S]\n",
  "PHOTOPRODUCTION": "the production of one or more particles by the action of an incident photon [n]\n",
  "PHOTOPRODUCTS": "PHOTOPRODUCT, a product of a photochemical reaction [n]\n",
  "PHOTOPSIA": "the appearance of light flashes due to retinal irritation, also PHOTOPSY [n -S]\n",
  "PHOTOPSIAS": "PHOTOPSIA, the appearance of light flashes due to retinal irritation, also PHOTOPSY [n]\n",
  "PHOTOPSIES": "PHOTOPSY, the appearance of light flashes due to retinal irritation, also PHOTOPSIA [n]\n",
  "PHOTOPSY": "the appearance of light flashes due to retinal irritation, also PHOTOPSIA [n PHOTOPSIES]\n",
  "PHOTOREACTION": "a photochemical reaction [n -S]\n",
  "PHOTOREACTIONS": "PHOTOREACTION, a photochemical reaction [n]\n",
  "PHOTOREACTIVE": "reacting to light [adj]\n",
  "PHOTOREALISM": "an esp. detailed, precise painting style, giving an effect of (often exaggerated) realism [n -S]\n",
  "PHOTOREALISMS": "PHOTOREALISM, an esp. detailed, precise painting style, giving an effect of (often exaggerated) realism [n]\n",
  "PHOTOREALIST": "an exponent of photorealism [n -S]\n",
  "PHOTOREALISTIC": "relating to photorealism [adj]\n",
  "PHOTOREALISTS": "PHOTOREALIST, an exponent of photorealism [n]\n",
  "PHOTORECEPTION": "the perception of waves in the range of visible light [n -S]\n",
  "PHOTORECEPTIONS": "PHOTORECEPTION, the perception of waves in the range of visible light [n]\n",
  "PHOTORECEPTIVE": "relating to photoreception [adj]\n",
  "PHOTORECEPTOR": "a receptor for light stimuli [n -S]\n",
  "PHOTORECEPTORS": "PHOTORECEPTOR, a receptor for light stimuli [n]\n",
  "PHOTOREDUCE": "to photocopy with reduction of the image [v PHOTOREDUCED, PHOTOREDUCING, PHOTOREDUCES]\n",
  "PHOTOREDUCED": "PHOTOREDUCE, to photocopy with reduction of the image [v]\n",
  "PHOTOREDUCES": "PHOTOREDUCE, to photocopy with reduction of the image [v]\n",
  "PHOTOREDUCING": "PHOTOREDUCE, to photocopy with reduction of the image [v]\n",
  "PHOTOREDUCTION": "chemical reduction under the influence of radiant energy, as light [n -S]\n",
  "PHOTOREDUCTIONS": "PHOTOREDUCTION, chemical reduction under the influence of radiant energy, as light [n]\n",
  "PHOTOREFRACTIVE": "designating or relating to surgical procedures in which a laser is used to reshape the cornea and correct refractive errors such as myopia or astigmatism; esp. in photorefractive keratectomy [adj]\n",
  "PHOTORESIST": "an organic material that polymerizes on exposure to ultraviolet light and in that form resists attack by acids and solvents [n -S]\n",
  "PHOTORESISTS": "PHOTORESIST, an organic material that polymerizes on exposure to ultraviolet light and in that form resists attack by acids and solvents [n]\n",
  "PHOTOS": "PHOTO, (colloquial) to photograph [v]\n",
  "PHOTOSCAN": "to scan photographically [v PHOTOSCANNED, PHOTOSCANNING, PHOTOSCANS]\n",
  "PHOTOSCANNED": "PHOTOSCAN, to scan photographically [v]\n",
  "PHOTOSCANNING": "PHOTOSCAN, to scan photographically [v]\n",
  "PHOTOSCANS": "PHOTOSCAN, to scan photographically [v]\n",
  "PHOTOSENSITISE": "to make photosensitive by chemical or other means, also PHOTOSENSITIZE [v PHOTOSENSITISED, PHOTOSENSITISES]\n",
  "PHOTOSENSITISED": "PHOTOSENSITISE, to make photosensitive by chemical or other means, also PHOTOSENSITIZE [v]\n",
  "PHOTOSENSITISER": "an agent that photosensitises, also PHOTOSENSITIZER [n]\n",
  "PHOTOSENSITISES": "PHOTOSENSITISE, to make photosensitive by chemical or other means, also PHOTOSENSITIZE [v]\n",
  "PHOTOSENSITIVE": "sensitive or sensitized to the action of radiant energy [adj]\n",
  "PHOTOSENSITIZE": "to make photosensitive by chemical or other means, also PHOTOSENSITISE [v PHOTOSENSITIZED, PHOTOSENSITIZES]\n",
  "PHOTOSENSITIZED": "PHOTOSENSITIZE, to make photosensitive by chemical or other means, also PHOTOSENSITISE [v]\n",
  "PHOTOSENSITIZER": "an agent that photosensitises, also PHOTOSENSITISER [n]\n",
  "PHOTOSENSITIZES": "PHOTOSENSITIZE, to make photosensitive by chemical or other means, also PHOTOSENSITISE [v]\n",
  "PHOTOSENSOR": "a detector that is sensitive to electromagnetic radiation [n -S]\n",
  "PHOTOSENSORS": "PHOTOSENSOR, a detector that is sensitive to electromagnetic radiation [n]\n",
  "PHOTOSET": "to prepare for printing by photographic means [v PHOTOSET, PHOTOSETTING, PHOTOSETS]\n",
  "PHOTOSETS": "PHOTOSET, to prepare for printing by photographic means [v]\n",
  "PHOTOSETTER": "an apparatus for photosetting [n -S]\n",
  "PHOTOSETTERS": "PHOTOSETTER, an apparatus for photosetting [n]\n",
  "PHOTOSETTING": "composing (matter) by projecting film from which a printing plate is made [n -S]\n",
  "PHOTOSETTINGS": "PHOTOSETTING, composing (matter) by projecting film from which a printing plate is made [n]\n",
  "PHOTOSHOOT": "a session in which a photographer takes pictures of a celebrity, etc. [n -S]\n",
  "PHOTOSHOOTS": "PHOTOSHOOT, a session in which a photographer takes pictures of a celebrity, etc. [n]\n",
  "PHOTOSHOP": "to manipulate a digital image using editing software [v PHOTOSHOPPED, PHOTOSHOPPING, PHOTOSHOPS]\n",
  "PHOTOSHOPPED": "PHOTOSHOP, to manipulate a digital image using editing software [v]\n",
  "PHOTOSHOPPING": "PHOTOSHOP, to manipulate a digital image using editing software [v]\n",
  "PHOTOSHOPS": "PHOTOSHOP, to manipulate a digital image using editing software [v]\n",
  "PHOTOSPHERE": "the sun's luminous envelope [n -S]\n",
  "PHOTOSPHERES": "PHOTOSPHERE, the sun's luminous envelope [n]\n",
  "PHOTOSPHERIC": "relating to the photosphere [adj]\n",
  "PHOTOSTAT": "(tradename) a photographic apparatus for making facsimiles of documents [n -S] / to make facsimiles by this means [v PHOTOSTATED or PHOTOSTATTED, PHOTOSTATING or PHOTOSTATTING, PHOTOSTATS]\n",
  "PHOTOSTATED": "PHOTOSTAT, to make facsimiles by this means [v]\n",
  "PHOTOSTATIC": "of, made by, or using a photostat [adj]\n",
  "PHOTOSTATING": "PHOTOSTAT, to make facsimiles by this means [v]\n",
  "PHOTOSTATS": "PHOTOSTAT, (tradename) a photographic apparatus for making facsimiles of documents [n]\n",
  "PHOTOSTATTED": "PHOTOSTAT, to make facsimiles by this means [v]\n",
  "PHOTOSTATTING": "PHOTOSTAT, to make facsimiles by this means [v]\n",
  "PHOTOSYNTHATE": "a product of photosynthesis [n -S]\n",
  "PHOTOSYNTHATES": "PHOTOSYNTHATE, a product of photosynthesis [n]\n",
  "PHOTOSYNTHESES": "PHOTOSYNTHESIS, the biochemical process in which light energy is absorbed by chlorophyll, and is used to fuel the building of sugar molecules [n]\n",
  "PHOTOSYNTHESIS": "the biochemical process in which light energy is absorbed by chlorophyll, and is used to fuel the building of sugar molecules [n PHOTOSYNTHESES]\n",
  "PHOTOSYNTHESISE": "to carry out photosynthesis [v]\n",
  "PHOTOSYNTHESIZE": "to carry out photosynthesis, also PHOTOSYNTHESISE [v]\n",
  "PHOTOSYNTHETIC": "relating to photosynthesis [adj]\n",
  "PHOTOSYSTEM": "either of two photochemical reaction centers consisting chiefly of photosynthetic pigments complexed with protein and occurring in chloroplasts [n -S]\n",
  "PHOTOSYSTEMS": "PHOTOSYSTEM, either of two photochemical reaction centers consisting chiefly of photosynthetic pigments complexed with protein and occurring in chloroplasts [n]\n",
  "PHOTOTACTIC": "exhibiting phototaxis [adj PHOTOTACTICALLY]\n",
  "PHOTOTACTICALLY": "PHOTOTACTIC, exhibiting phototaxis [adv]\n",
  "PHOTOTAXES": "PHOTOTAXIS, growth or movement determined by light [n]\n",
  "PHOTOTAXIES": "PHOTOTAXY, the movement of an entire organism in response to light [n]\n",
  "PHOTOTAXIS": "growth or movement determined by light [n PHOTOTAXES]\n",
  "PHOTOTAXY": "the movement of an entire organism in response to light [n PHOTOTAXIES]\n",
  "PHOTOTELEGRAM": "a telegram that is sent by means of phototelegraphy [n -S]\n",
  "PHOTOTELEGRAMS": "PHOTOTELEGRAM, a telegram that is sent by means of phototelegraphy [n]\n",
  "PHOTOTELEGRAPH": "an instrument for transmitting drawings telegraphically [n -S]\n",
  "PHOTOTELEGRAPHS": "PHOTOTELEGRAPH, an instrument for transmitting drawings telegraphically [n]\n",
  "PHOTOTELEGRAPHY": "the transmission of drawings by phototelegraph [n]\n",
  "PHOTOTHERAPIES": "PHOTOTHERAPY, the treatment of disease by light [n]\n",
  "PHOTOTHERAPY": "the treatment of disease by light [n PHOTOTHERAPIES]\n",
  "PHOTOTHERMAL": "of or concerned with light and heat, esp. the production of heat by light, also PHOTOTHERMIC [adj PHOTOTHERMALLY]\n",
  "PHOTOTHERMALLY": "PHOTOTHERMAL, of or concerned with light and heat, esp. the production of heat by light, also PHOTOTHERMIC [adv]\n",
  "PHOTOTHERMIC": "of or concerned with light and heat, esp. the production of heat by light, also PHOTOTHERMAL [adj]\n",
  "PHOTOTONIC": "relating to phototonus, the sensitivity of a living organism to light [adj]\n",
  "PHOTOTONUS": "the sensitivity of a living organism to light [n -ES]\n",
  "PHOTOTONUSES": "PHOTOTONUS, the sensitivity of a living organism to light [n]\n",
  "PHOTOTOPOGRAPHY": "the preparation of topographic maps from photographs [n]\n",
  "PHOTOTOXIC": "rendering the skin susceptible to damage (as sunburn or blisters) [adj]\n",
  "PHOTOTOXICITIES": "PHOTOTOXICITY, the state of being phototoxic [n]\n",
  "PHOTOTOXICITY": "the state of being phototoxic [n PHOTOTOXICITIES]\n",
  "PHOTOTRANSISTOR": "a junction transistor, whose base signal is generated by illumination of the base [n]\n",
  "PHOTOTROPE": "a substance exhibiting phototropism, movement directed by light [n -S]\n",
  "PHOTOTROPES": "PHOTOTROPE, a substance exhibiting phototropism, movement directed by light [n]\n",
  "PHOTOTROPH": "a plant which uses light to generate energy needed to absorb nutrients [n -S]\n",
  "PHOTOTROPHIC": "relating to phototropism, movement directed by light [adj]\n",
  "PHOTOTROPHS": "PHOTOTROPH, a plant which uses light to generate energy needed to absorb nutrients [n]\n",
  "PHOTOTROPIC": "relating to phototropism, movement directed by light [adj PHOTOTROPICALLY]\n",
  "PHOTOTROPICALLY": "PHOTOTROPIC, relating to phototropism, movement directed by light [adv]\n",
  "PHOTOTROPIES": "PHOTOTROPY, change of colour due to wavelength of incident light [n]\n",
  "PHOTOTROPISM": "movement directed by light [n -S]\n",
  "PHOTOTROPISMS": "PHOTOTROPISM, movement directed by light [n]\n",
  "PHOTOTROPY": "change of colour due to wavelength of incident light [n PHOTOTROPIES]\n",
  "PHOTOTUBE": "an electron tube with a photoemissive cathode [n -S]\n",
  "PHOTOTUBES": "PHOTOTUBE, an electron tube with a photoemissive cathode [n]\n",
  "PHOTOTYPE": "a plate or block with a printing surface (usually in relief) obtained from a photograph [n -S] / to print by this means [v PHOTOTYPED, PHOTOTYPING, PHOTOTYPES]\n",
  "PHOTOTYPED": "PHOTOTYPE, to print by this means [v]\n",
  "PHOTOTYPES": "PHOTOTYPE, to print by this means [v]\n",
  "PHOTOTYPESET": "to set (type matter) by phototypesetting [v PHOTOTYPESET, PHOTOTYPESETS]\n",
  "PHOTOTYPESETS": "PHOTOTYPESET, to set (type matter) by phototypesetting [v]\n",
  "PHOTOTYPESETTER": "one who does phototypesetting [n]\n",
  "PHOTOTYPIC": "of or pertaining to a phototype or phototypy [adj PHOTOTYPICALLY]\n",
  "PHOTOTYPICALLY": "PHOTOTYPIC, of or pertaining to a phototype or phototypy [adv]\n",
  "PHOTOTYPIES": "PHOTOTYPY, the art or process of producing phototypes [n]\n",
  "PHOTOTYPING": "PHOTOTYPE, to print by this means [v]\n",
  "PHOTOTYPOGRAPHY": "any printing process involving the use of photography [n]\n",
  "PHOTOTYPY": "the art or process of producing phototypes [n PHOTOTYPIES]\n",
  "PHOTOVOLTAIC": "of, relating to, or utilizing the generation of a voltage when radiant energy falls on the boundary between dissimilar substances (as two different semiconductors) [adj]\n",
  "PHOTOVOLTAICS": "the science and technology of photovoltaic devices and substances [n]\n",
  "PHOTOXYLOGRAPHY": "wood engraving after a photographic impression on a woodblock [n]\n",
  "PHOTOZINCOGRAPH": "a picture produced by photozincography [n]\n",
  "PHOTS": "PHOT, a unit of the product of illumination and duration, equal to one lux maintained for one second [n]\n",
  "PHPHT": "used as an expression of annoyance, also PHT [interj]\n",
  "PHRAGMOPLAST": "the enlarged barrel-shaped spindle that is characteristic of the later stages of plant mitosis and within which the cell plate forms [n -S]\n",
  "PHRAGMOPLASTS": "PHRAGMOPLAST, the enlarged barrel-shaped spindle that is characteristic of the later stages of plant mitosis and within which the cell plate forms [n]\n",
  "PHRASAL": "pertaining to a group of two or more associated words [adj PHRASALLY]\n",
  "PHRASALLY": "PHRASAL, pertaining to a group of two or more associated words [adv]\n",
  "PHRASE": "to express in words [v PHRASED, PHRASING, PHRASES]\n",
  "PHRASED": "PHRASE, to express in words [v]\n",
  "PHRASELESS": "indescribable [adj]\n",
  "PHRASEMAKER": "a maker of wordy or fine-sounding phrases, also PHRASEMONGER [n -S]\n",
  "PHRASEMAKERS": "PHRASEMAKER, a maker of wordy or fine-sounding phrases, also PHRASEMONGER [n]\n",
  "PHRASEMAKING": "the act of making phrases [n -S]\n",
  "PHRASEMAKINGS": "PHRASEMAKING, the act of making phrases [n]\n",
  "PHRASEMAN": "a user or maker of fine phrases [n PHRASEMEN]\n",
  "PHRASEMEN": "PHRASEMAN, a user or maker of fine phrases [n]\n",
  "PHRASEMONGER": "a maker of wordy or fine-sounding phrases, also PHRASEMAKER [n -S]\n",
  "PHRASEMONGERING": "the making of fine phrases [n]\n",
  "PHRASEMONGERS": "PHRASEMONGER, a maker of wordy or fine-sounding phrases, also PHRASEMAKER [n]\n",
  "PHRASEOGRAM": "a single sign, written without lifting the pen, for a whole phrase (esp. in shorthand) [n -S]\n",
  "PHRASEOGRAMS": "PHRASEOGRAM, a single sign, written without lifting the pen, for a whole phrase (esp. in shorthand) [n]\n",
  "PHRASEOGRAPH": "a phrase for which there exists a phraseogram [n -S]\n",
  "PHRASEOGRAPHIC": "of or like a phraseograph [adj]\n",
  "PHRASEOGRAPHIES": "PHRASEOGRAPHY, the making of phraseographs [n]\n",
  "PHRASEOGRAPHS": "PHRASEOGRAPH, a phrase for which there exists a phraseogram [n]\n",
  "PHRASEOGRAPHY": "the making of phraseographs [n PHRASEOGRAPHIES]\n",
  "PHRASEOLOGIC": "expressed in formal often sententious phrases, also PHRASEOLOGICAL [adj]\n",
  "PHRASEOLOGICAL": "expressed in formal often sententious phrases, also PHRASEOLOGIC [adj]\n",
  "PHRASEOLOGIES": "PHRASEOLOGY, the manner or style of expression in words [n]\n",
  "PHRASEOLOGIST": "one who uses sententious or insincere phrases [n -S]\n",
  "PHRASEOLOGISTS": "PHRASEOLOGIST, one who uses sententious or insincere phrases [n]\n",
  "PHRASEOLOGY": "the manner or style of expression in words [n PHRASEOLOGIES]\n",
  "PHRASER": "a repeater of empty phrases [n -S]\n",
  "PHRASERS": "PHRASER, a repeater of empty phrases [n]\n",
  "PHRASES": "PHRASE, to express in words [v]\n",
  "PHRASIER": "PHRASY, inclined to use wordy phrases [adj]\n",
  "PHRASIEST": "PHRASY, inclined to use wordy phrases [adj]\n",
  "PHRASING": "a style of verbal expression [n -S]\n",
  "PHRASINGS": "PHRASING, a style of verbal expression [n]\n",
  "PHRASY": "inclined to use wordy phrases [adj PHRASIER, PHRASIEST]\n",
  "PHRATRAL": "relating to a phratry, a clan or tribe, also PHRATRIC [adj]\n",
  "PHRATRIC": "relating to a phratry, a clan or tribe, also PHRATRAL [adj]\n",
  "PHRATRIES": "PHRATRY, (Greek) a tribal unit among primitive peoples [n]\n",
  "PHRATRY": "(Greek) a tribal unit among primitive peoples [n PHRATRIES]\n",
  "PHREAK": "to hack into the phone network to get free phone calls [v -ED, -ING, -S]\n",
  "PHREAKED": "PHREAK, to hack into the phone network to get free phone calls [v]\n",
  "PHREAKER": "one who uses equipment to obtain free telephone calls [n -S]\n",
  "PHREAKERS": "PHREAKER, one who uses equipment to obtain free telephone calls [n]\n",
  "PHREAKING": "making illegal phone-calls [n -S]\n",
  "PHREAKINGS": "PHREAKING, making illegal phone-calls [n]\n",
  "PHREAKS": "PHREAK, to hack into the phone network to get free phone calls [v]\n",
  "PHREATIC": "pertaining to underground waters [adj]\n",
  "PHREATOPHYTE": "a plant with a deep root system that draws its water supply from near the water table [n -S]\n",
  "PHREATOPHYTES": "PHREATOPHYTE, a plant with a deep root system that draws its water supply from near the water table [n]\n",
  "PHREATOPHYTIC": "of or like a phreatophyte, a plant with a deep root system that draws its water supply from near the water table [adj]\n",
  "PHRENESES": "PHRENESIS, delirium, frenzy [n]\n",
  "PHRENESIAC": "(Scott) hypochondriac [adj]\n",
  "PHRENESIS": "delirium, frenzy [n PHRENESES]\n",
  "PHRENETIC": "frenzied, frenetic, also FRENETIC, PHRENETICAL, PHRENTICK [adj PHRENETICALLY] / a frenzied person [n -S]\n",
  "PHRENETICAL": "frenzied, frenetic, also FRENETIC, PHRENETIC, PHRENTICK [adj PHRENETICALLY]\n",
  "PHRENETICALLY": "PHRENETICAL, frenzied, frenetic, also FRENETIC, PHRENETIC, PHRENTICK [adv]\n",
  "PHRENETICNESS": "PHRENETIC, frenzied, frenetic, also FRENETIC, PHRENETICAL, PHRENTICK [n]\n",
  "PHRENETICNESSES": "PHRENETICNESS, PHRENETIC, frenzied, frenetic, also FRENETIC, PHRENETICAL, PHRENTICK [n]\n",
  "PHRENETICS": "PHRENETIC, a frenzied person [n]\n",
  "PHRENIC": "the diaphragm [n -S]\n",
  "PHRENICS": "PHRENIC, the diaphragm [n]\n",
  "PHRENISM": "a purported mind-force which directs evolution [n -S]\n",
  "PHRENISMS": "PHRENISM, a purported mind-force which directs evolution [n]\n",
  "PHRENITIC": "affected by phrenitis [adj]\n",
  "PHRENITIDES": "PHRENITIS, inflammation of the brain, attended with acute fever and delirium; aka cephalitis [n]\n",
  "PHRENITIS": "inflammation of the brain, attended with acute fever and delirium; aka cephalitis [n PHRENITISES or PHRENITIDES]\n",
  "PHRENITISES": "PHRENITIS, inflammation of the brain, attended with acute fever and delirium; aka cephalitis [n]\n",
  "PHRENOLOGIC": "relating to phrenology, also PHRENOLOGICAL [adj PHRENOLOGICALLY]\n",
  "PHRENOLOGICAL": "relating to phrenology, also PHRENOLOGIC [adj PHRENOLOGICALLY]\n",
  "PHRENOLOGICALLY": "PHRENOLOGICAL, relating to phrenology, also PHRENOLOGIC [adv]\n",
  "PHRENOLOGIES": "PHRENOLOGY, the study of bumps on the head [n]\n",
  "PHRENOLOGISE": "to examine phrenologically, also PHRENOLOGIZE [v PHRENOLOGISED, PHRENOLOGISING, PHRENOLOGISES]\n",
  "PHRENOLOGISED": "PHRENOLOGISE, to examine phrenologically, also PHRENOLOGIZE [v]\n",
  "PHRENOLOGISES": "PHRENOLOGISE, to examine phrenologically, also PHRENOLOGIZE [v]\n",
  "PHRENOLOGISING": "PHRENOLOGISE, to examine phrenologically, also PHRENOLOGIZE [v]\n",
  "PHRENOLOGIST": "a practitioner of phrenology [n -S]\n",
  "PHRENOLOGISTS": "PHRENOLOGIST, a practitioner of phrenology [n]\n",
  "PHRENOLOGIZE": "to examine phrenologically, also PHRENOLOGISE [v PHRENOLOGIZED, PHRENOLOGIZING, PHRENOLOGIZES]\n",
  "PHRENOLOGIZED": "PHRENOLOGIZE, to examine phrenologically, also PHRENOLOGISE [v]\n",
  "PHRENOLOGIZES": "PHRENOLOGIZE, to examine phrenologically, also PHRENOLOGISE [v]\n",
  "PHRENOLOGIZING": "PHRENOLOGIZE, to examine phrenologically, also PHRENOLOGISE [v]\n",
  "PHRENOLOGY": "the study of bumps on the head [n PHRENOLOGIES]\n",
  "PHRENSICAL": "(obsolete) frantic, also FRENZICAL [adj]\n",
  "PHRENSIED": "PHRENSY, to make frantic, also FRENZY [v]\n",
  "PHRENSIES": "PHRENSY, to make frantic, also FRENZY [v]\n",
  "PHRENSY": "to make frantic, also FRENZY [v PHRENSIED, PHRENSYING, PHRENSIES]\n",
  "PHRENSYING": "PHRENSY, to make frantic, also FRENZY [v]\n",
  "PHRENTICK": "(obsolete) frenetic, also FRENETIC, PHRENETIC, PHRENETICAL [adj]\n",
  "PHRONTISTERIES": "PHRONTISTERY, a place for study and contemplation [n]\n",
  "PHRONTISTERY": "a place for study and contemplation [n PHRONTISTERIES]\n",
  "PHRYGANA": "(Modern Greek) an uncultivated open scrubland of the Mediterranean region, aka garigue [n -S]\n",
  "PHRYGANAS": "PHRYGANA, (Modern Greek) an uncultivated open scrubland of the Mediterranean region, aka garigue [n]\n",
  "PHT": "used as an expression of annoyance, also PHPHT [interj]\n",
  "PHTHALATE": "a salt of phthalic acid [n -S]\n",
  "PHTHALATES": "PHTHALATE, a salt of phthalic acid [n]\n",
  "PHTHALEIN": "any one of a very important class of dye-yielding materials formed by the union of phenols with phthalic anhydride [n -S]\n",
  "PHTHALEINS": "PHTHALEIN, any one of a very important class of dye-yielding materials formed by the union of phenols with phthalic anhydride [n]\n",
  "PHTHALIC": "pertaining to, or designating, a dibasic acid obtained by the oxidation of naphthalene and allied substances [adj]\n",
  "PHTHALIN": "a colourless crystalline compound obtained by reducing a phthalein [n -S]\n",
  "PHTHALINS": "PHTHALIN, a colourless crystalline compound obtained by reducing a phthalein [n]\n",
  "PHTHALOCYANIN": "any of a group of green and blue organic colouring matters of great fastness and brilliance, also PHTHALOCYANINE [n -S]\n",
  "PHTHALOCYANINE": "any of a group of green and blue organic colouring matters of great fastness and brilliance, also PHTHALOCYANIN [n -S]\n",
  "PHTHALOCYANINES": "PHTHALOCYANINE, any of a group of green and blue organic colouring matters of great fastness and brilliance, also PHTHALOCYANIN [n]\n",
  "PHTHALOCYANINS": "PHTHALOCYANIN, any of a group of green and blue organic colouring matters of great fastness and brilliance, also PHTHALOCYANINE [n]\n",
  "PHTHIRIASES": "PHTHIRIASIS, infestation with lice [n]\n",
  "PHTHIRIASIS": "infestation with lice [n PHTHIRIASES]\n",
  "PHTHISES": "PHTHISIS, a disease of the lungs, also PHTHISIC [n]\n",
  "PHTHISIC": "a disease of the lungs, also PHTHISIS [n -S]\n",
  "PHTHISICAL": "of or pertaining to phthisis [adj]\n",
  "PHTHISICKY": "having phthisis, or some symptom of it, as difficulty in breathing [adj]\n",
  "PHTHISICS": "PHTHISIC, a disease of the lungs, also PHTHISIS [n]\n",
  "PHTHISIS": "a disease of the lungs, also PHTHISIC [n PHTHISES]\n",
  "PHUT": "to make a sound like a bullet [v PHUTTED, PHUTTING, PHUTS]\n",
  "PHUTS": "PHUT, to make a sound like a bullet [v]\n",
  "PHUTTED": "PHUT, to make a sound like a bullet [v]\n",
  "PHUTTING": "PHUT, to make a sound like a bullet [v]\n",
  "PHWOAH": "an expression of appreciation of the attractiveness of another person, also PHWOAR [interj]\n",
  "PHWOAR": "an expression of appreciation of the attractiveness of another person, also PHWOAH [interj]\n",
  "PHYCOBILIN": "any of a class of red or blue-green pigments found in the red algae and cyanobacteria [n -S]\n",
  "PHYCOBILINS": "PHYCOBILIN, any of a class of red or blue-green pigments found in the red algae and cyanobacteria [n]\n",
  "PHYCOBIONT": "the algal constituent of a lichen [n -S]\n",
  "PHYCOBIONTS": "PHYCOBIONT, the algal constituent of a lichen [n]\n",
  "PHYCOCYAN": "a blue pigment found in algae [n -S]\n",
  "PHYCOCYANIN": "any of various bluish-green protein pigments in the cells of cyanobacteria [n -S]\n",
  "PHYCOCYANINS": "PHYCOCYANIN, any of various bluish-green protein pigments in the cells of cyanobacteria [n]\n",
  "PHYCOCYANS": "PHYCOCYAN, a blue pigment found in algae [n]\n",
  "PHYCOERYTHRIN": "any of the red protein pigments in the cells of red algae [n -S]\n",
  "PHYCOERYTHRINS": "PHYCOERYTHRIN, any of the red protein pigments in the cells of red algae [n]\n",
  "PHYCOLOGICAL": "relating to phycology, the study of algae [adj]\n",
  "PHYCOLOGIES": "PHYCOLOGY, the study of algae, aka algology [n]\n",
  "PHYCOLOGIST": "a student of phycology, the study of algae and seaweeds [n -S]\n",
  "PHYCOLOGISTS": "PHYCOLOGIST, a student of phycology, the study of algae and seaweeds [n]\n",
  "PHYCOLOGY": "the study of algae, aka algology [n PHYCOLOGIES]\n",
  "PHYCOMYCETE": "a fungus resembling algae [n -S]\n",
  "PHYCOMYCETES": "PHYCOMYCETE, a fungus resembling algae [n]\n",
  "PHYCOMYCETOUS": "of or like a phycomycete [adj]\n",
  "PHYCOPHAEIN": "a brown pigment found in seaweeds [n -S]\n",
  "PHYCOPHAEINS": "PHYCOPHAEIN, a brown pigment found in seaweeds [n]\n",
  "PHYCOXANTHIN": "a yellow pigment found in diatoms, brown seaweeds etc. [n -S]\n",
  "PHYCOXANTHINS": "PHYCOXANTHIN, a yellow pigment found in diatoms, brown seaweeds etc. [n]\n",
  "PHYLA": "PHYLUM, (Latin) a main taxonomical division, also PHYLON [n]\n",
  "PHYLACTERIC": "of or like a phylactery, a slip of parchment inscribed with certain passages of Scripture, worn in a box on the left arm or forehead by Jewish men, also PHYLACTERICAL [adj]\n",
  "PHYLACTERICAL": "of or like a phylactery, a slip of parchment inscribed with certain passages of Scripture, worn in a box on the left arm or forehead by Jewish men, also PHYLACTERIC [adj]\n",
  "PHYLACTERIES": "PHYLACTERY, a small leather box containing scriptural extracts worn by Jews at prayer [n]\n",
  "PHYLACTERY": "a small leather box containing scriptural extracts worn by Jews at prayer [n PHYLACTERIES]\n",
  "PHYLACTIC": "defending or protecting against disease [adj]\n",
  "PHYLAE": "PHYLE, (Greek) in ancient Greece, a tribe or division of the people of a state into local clans [n]\n",
  "PHYLAR": "related to a phylum, a main division of the animal and vegetable kingdom, also PHYLIC [adj]\n",
  "PHYLARCH": "an ancient Greek commander of a tribe [n -S]\n",
  "PHYLARCHIES": "PHYLARCHY, the office of a phylarch; government of a class or tribe [n]\n",
  "PHYLARCHS": "PHYLARCH, an ancient Greek commander of a tribe [n]\n",
  "PHYLARCHY": "the office of a phylarch; government of a class or tribe [n PHYLARCHIES]\n",
  "PHYLAXIS": "an inhibiting of infection by the body [n -ES]\n",
  "PHYLAXISES": "PHYLAXIS, an inhibiting of infection by the body [n]\n",
  "PHYLE": "(Greek) in ancient Greece, a tribe or division of the people of a state into local clans [n PHYLAE]\n",
  "PHYLESES": "PHYLESIS, the course of evolutionary development [n]\n",
  "PHYLESIS": "the course of evolutionary development [n PHYLESISES or PHYLESES]\n",
  "PHYLESISES": "PHYLESIS, the course of evolutionary development [n]\n",
  "PHYLETIC": "relating to a phylum; according to presumed evolutionary descent [adj PHYLETICALLY]\n",
  "PHYLETICALLY": "PHYLETIC, relating to a phylum; according to presumed evolutionary descent [adv]\n",
  "PHYLETICS": "the study of the evolution of species [n]\n",
  "PHYLIC": "related to a phylum, a main division of the animal and vegetable kingdom, also PHYLAR [adj]\n",
  "PHYLLARIES": "PHYLLARY, a bract of certain plants [n]\n",
  "PHYLLARY": "a bract of certain plants [n PHYLLARIES]\n",
  "PHYLLID": "the leaf of a liverwort or moss [n -S]\n",
  "PHYLLIDS": "PHYLLID, the leaf of a liverwort or moss [n]\n",
  "PHYLLITE": "a foliated rock, a kind of metamorphosed mudstone [n -S]\n",
  "PHYLLITES": "PHYLLITE, a foliated rock, a kind of metamorphosed mudstone [n]\n",
  "PHYLLITIC": "of or like phyllite, a metamorphosed mudstone with a silky sheen [adj]\n",
  "PHYLLO": "(Greek) a kind of very thin pastry dough, also FILLO, FILO [n -S]\n",
  "PHYLLOCLAD": "another name for a cladode, also PHYLLOCLADE [n -S]\n",
  "PHYLLOCLADE": "another name for a cladode, also PHYLLOCLAD [n -S]\n",
  "PHYLLOCLADES": "PHYLLOCLADE, another name for a cladode, also PHYLLOCLAD [n]\n",
  "PHYLLOCLADS": "PHYLLOCLAD, another name for a cladode, also PHYLLOCLADE [n]\n",
  "PHYLLODE": "a flattened petiole that serves as a leaf [n -S]\n",
  "PHYLLODES": "PHYLLODE, a flattened petiole that serves as a leaf [n]\n",
  "PHYLLODIA": "PHYLLODIUM, a petiole dilated into the form of a blade, and usually with vertical edges, as in the Australian acacias [n]\n",
  "PHYLLODIAL": "relating to a phyllode, a flattened stem functioning as leaf [adj]\n",
  "PHYLLODIES": "PHYLLODY, a flower transformation [n]\n",
  "PHYLLODIUM": "a petiole dilated into the form of a blade, and usually with vertical edges, as in the Australian acacias [n PHYLLODIA]\n",
  "PHYLLODY": "a flower transformation [n PHYLLODIES]\n",
  "PHYLLOID": "a leaflike assimilatory organ in brown algae [n -S]\n",
  "PHYLLOIDS": "PHYLLOID, a leaflike assimilatory organ in brown algae [n]\n",
  "PHYLLOMANIA": "abnormal leaf-production [n -S]\n",
  "PHYLLOMANIAS": "PHYLLOMANIA, abnormal leaf-production [n]\n",
  "PHYLLOME": "a leaf of a plant [n -S]\n",
  "PHYLLOMES": "PHYLLOME, a leaf of a plant [n]\n",
  "PHYLLOMIC": "of or like a phyllome, a leaf or homologue of a leaf [adj]\n",
  "PHYLLOPHAGOUS": "leaf-eating [adj]\n",
  "PHYLLOPLANE": "the surface of a leaf considered as a habitat, esp. for microorganisms [n -S]\n",
  "PHYLLOPLANES": "PHYLLOPLANE, the surface of a leaf considered as a habitat, esp. for microorganisms [n]\n",
  "PHYLLOPOD": "one of an order of crustaceans whose swimming and respiratory appendages resemble leaves [n -S]\n",
  "PHYLLOPODS": "PHYLLOPOD, one of an order of crustaceans whose swimming and respiratory appendages resemble leaves [n]\n",
  "PHYLLOQUINONE": "vitamin K1, one of the fat-soluble vitamin K group, essential for normal blood coagulation [n -S]\n",
  "PHYLLOQUINONES": "PHYLLOQUINONE, vitamin K1, one of the fat-soluble vitamin K group, essential for normal blood coagulation [n]\n",
  "PHYLLOS": "PHYLLO, (Greek) a kind of very thin pastry dough, also FILLO, FILO [n]\n",
  "PHYLLOSILICATE": "any of a class of silicate minerals, including talc, consisting of thin sheets [n -S]\n",
  "PHYLLOSILICATES": "PHYLLOSILICATE, any of a class of silicate minerals, including talc, consisting of thin sheets [n]\n",
  "PHYLLOSPHERE": "the surface of a leaf considered as a habitat, esp. for microorganisms [n -S]\n",
  "PHYLLOSPHERES": "PHYLLOSPHERE, the surface of a leaf considered as a habitat, esp. for microorganisms [n]\n",
  "PHYLLOTACTIC": "of or relating to phyllotaxis, the arrangement of leaves on the stem, also PHYLLOTACTICAL [adj]\n",
  "PHYLLOTACTICAL": "of or relating to phyllotaxis, the arrangement of leaves on the stem, also PHYLLOTACTIC [adj]\n",
  "PHYLLOTAXES": "PHYLLOTAXIS, the arrangement of leaves on a stem and in relation to one another, also PHYLLOTAXY [n]\n",
  "PHYLLOTAXIES": "PHYLLOTAXY, the arrangement of leaves on a stem and in relation to one another, also PHYLLOTAXIS [n]\n",
  "PHYLLOTAXIS": "the arrangement of leaves on a stem and in relation to one another, also PHYLLOTAXY [n PHYLLOTAXES]\n",
  "PHYLLOTAXY": "the arrangement of leaves on a stem and in relation to one another, also PHYLLOTAXIS [n PHYLLOTAXIES]\n",
  "PHYLLOXERA": "a kind of beetle, a pest of vineyards [n PHYLLOXERAS or PHYLLOXERAE]\n",
  "PHYLLOXERAE": "PHYLLOXERA, a kind of beetle, a pest of vineyards [n]\n",
  "PHYLLOXERAS": "PHYLLOXERA, a kind of beetle, a pest of vineyards [n]\n",
  "PHYLOGENESES": "PHYLOGENESIS, the evolutionary development of a species or other group of organisms through a succession of forms [n]\n",
  "PHYLOGENESIS": "the evolutionary development of a species or other group of organisms through a succession of forms [n PHYLOGENESES]\n",
  "PHYLOGENETIC": "relating to phylogenesis, the evolutionary development of a species or other group of organisms through a succession of forms, also PHYLOGENIC [adj]\n",
  "PHYLOGENIC": "relating to phylogenesis, the evolutionary development of a species or other group of organisms through a succession of forms, also PHYLOGENETIC [adj]\n",
  "PHYLOGENIES": "PHYLOGENY, the evolutionary development of a species, a group of organisms, or a particular feature of an organism [n]\n",
  "PHYLOGENY": "the evolutionary development of a species, a group of organisms, or a particular feature of an organism [n PHYLOGENIES]\n",
  "PHYLON": "a main taxonomical division, also PHYLUM [n PHYLA]\n",
  "PHYLUM": "(Latin) a main taxonomical division, also PHYLON [n PHYLA]\n",
  "PHYSALIA": "a genus of large oceanic Siphonophora which includes the Portuguese man-of-war [n -S]\n",
  "PHYSALIAS": "PHYSALIA, a genus of large oceanic Siphonophora which includes the Portuguese man-of-war [n]\n",
  "PHYSALIS": "a type of gooseberry [n -ES]\n",
  "PHYSALISES": "PHYSALIS, a type of gooseberry [n]\n",
  "PHYSED": "(short for) physical education [n -S]\n",
  "PHYSEDS": "PHYSED, (short for) physical education [n]\n",
  "PHYSES": "PHYSIS, (Greek) the part of a bone that is responsible for lengthening, aka growth plate [n]\n",
  "PHYSETER": "(Greek) a whale which spouts, a sperm whale [n -S]\n",
  "PHYSETERS": "PHYSETER, (Greek) a whale which spouts, a sperm whale [n]\n",
  "PHYSHARMONICA": "an early form of harmonium [n -S]\n",
  "PHYSHARMONICAS": "PHYSHARMONICA, an early form of harmonium [n]\n",
  "PHYSIATRIC": "relating to physiatry, treatment of injury by physical means [adj]\n",
  "PHYSIATRICAL": "relating to physiatry, the treatment of injury by physical means [adj]\n",
  "PHYSIATRICS": "the treatment of injury by physical means [n]\n",
  "PHYSIATRIES": "PHYSIATRY, the treatment of injury by physical means [n]\n",
  "PHYSIATRIST": "a physician who specializes in physical medicine and rehabilitation [n -S]\n",
  "PHYSIATRISTS": "PHYSIATRIST, a physician who specializes in physical medicine and rehabilitation [n]\n",
  "PHYSIATRY": "the treatment of injury by physical means [n PHYSIATRIES]\n",
  "PHYSIC": "to treat with medicine [v PHYSICKED, PHYSICKING, PHYSICS]\n",
  "PHYSICAL": "related to the body [adj PHYSICALLY] / a physical examination [n -S]\n",
  "PHYSICALISM": "the belief that all phenomena reducible to verifiable assertions [n -S]\n",
  "PHYSICALISMS": "PHYSICALISM, the belief that all phenomena reducible to verifiable assertions [n]\n",
  "PHYSICALIST": "a believer in physicalism [n -S]\n",
  "PHYSICALISTIC": "relating to physicalism [adj]\n",
  "PHYSICALISTS": "PHYSICALIST, a believer in physicalism [n]\n",
  "PHYSICALITIES": "PHYSICALITY, the state of being physical [n]\n",
  "PHYSICALITY": "the state of being physical [n PHYSICALITIES]\n",
  "PHYSICALLY": "PHYSICAL, related to the body [adv]\n",
  "PHYSICALNESS": "the state of being physical [n -ES]\n",
  "PHYSICALNESSES": "PHYSICALNESS, the state of being physical [n]\n",
  "PHYSICALS": "PHYSICAL, a physical examination [n]\n",
  "PHYSICIAN": "a doctor; someone legally qualified to practise medicine, also PHYSICIANER [n -S]\n",
  "PHYSICIANCIES": "PHYSICIANCY, the post or office of physician [n]\n",
  "PHYSICIANCY": "the post or office of physician [n PHYSICIANCIES]\n",
  "PHYSICIANER": "a doctor; someone legally qualified to practise medicine, also PHYSICIAN [n -S]\n",
  "PHYSICIANERS": "PHYSICIANER, a doctor; someone legally qualified to practise medicine, also PHYSICIAN [n]\n",
  "PHYSICIANS": "PHYSICIAN, a doctor; someone legally qualified to practise medicine, also PHYSICIANER [n]\n",
  "PHYSICIANSHIP": "the office of physician [n -S]\n",
  "PHYSICIANSHIPS": "PHYSICIANSHIP, the office of physician [n]\n",
  "PHYSICISM": "belief in the material or physical as opposed to the spiritual [n -S]\n",
  "PHYSICISMS": "PHYSICISM, belief in the material or physical as opposed to the spiritual [n]\n",
  "PHYSICIST": "an expert in or student of physics [n -S]\n",
  "PHYSICISTS": "PHYSICIST, an expert in or student of physics [n]\n",
  "PHYSICKED": "PHYSIC, to treat with medicine [v]\n",
  "PHYSICKING": "PHYSIC, to treat with medicine [v]\n",
  "PHYSICKY": "like medicine [adj]\n",
  "PHYSICOCHEMICAL": "being physical and chemical [adj]\n",
  "PHYSICS": "PHYSIC, to treat with medicine [v]\n",
  "PHYSIO": "(short for) physiotherapy [n -S]\n",
  "PHYSIOCRACIES": "PHYSIOCRACY, government that does not interfere with the operation of supposed natural laws [n]\n",
  "PHYSIOCRACY": "government that does not interfere with the operation of supposed natural laws [n PHYSIOCRACIES]\n",
  "PHYSIOCRAT": "one of the followers of Quesnay of France, who, in the 18th century, founded a system of political economy based upon the supremacy of natural order [n -S]\n",
  "PHYSIOCRATIC": "of or like a physiocrat [adj]\n",
  "PHYSIOCRATS": "PHYSIOCRAT, one of the followers of Quesnay of France, who, in the 18th century, founded a system of political economy based upon the supremacy of natural order [n]\n",
  "PHYSIOGNOMIC": "relating to physiognomy, also PHYSIOGNOMICAL [adj]\n",
  "PHYSIOGNOMICAL": "relating to physiognomy, also PHYSIOGNOMIC [adj]\n",
  "PHYSIOGNOMIES": "PHYSIOGNOMY, the general appearance of anything, esp. the face, also FISNOMIE, PHISNOMY, VISNOMIE, VISNOMY [n]\n",
  "PHYSIOGNOMIST": "a student of physiognomy [n -S]\n",
  "PHYSIOGNOMISTS": "PHYSIOGNOMIST, a student of physiognomy [n]\n",
  "PHYSIOGNOMY": "the general appearance of anything, esp. the face, also FISNOMIE, PHISNOMY, VISNOMIE, VISNOMY [n PHYSIOGNOMIES]\n",
  "PHYSIOGRAPHER": "one who practises physiography [n -S]\n",
  "PHYSIOGRAPHERS": "PHYSIOGRAPHER, one who practises physiography [n]\n",
  "PHYSIOGRAPHIC": "relating to physiography, also PHYSIOGRAPHICAL [adj]\n",
  "PHYSIOGRAPHICAL": "relating to physiography, also PHYSIOGRAPHIC [adj]\n",
  "PHYSIOGRAPHIES": "PHYSIOGRAPHY, physical geography [n]\n",
  "PHYSIOGRAPHY": "physical geography [n PHYSIOGRAPHIES]\n",
  "PHYSIOLATER": "a nature-worshipper [n -S]\n",
  "PHYSIOLATERS": "PHYSIOLATER, a nature-worshipper [n]\n",
  "PHYSIOLATRIES": "PHYSIOLATRY, nature-worship [n]\n",
  "PHYSIOLATRY": "nature-worship [n PHYSIOLATRIES]\n",
  "PHYSIOLOGIC": "relating to physiology, also PHYSIOLOGICAL [adj PHYSIOLOGICALLY]\n",
  "PHYSIOLOGICAL": "relating to physiology, also PHYSIOLOGIC [adj PHYSIOLOGICALLY]\n",
  "PHYSIOLOGICALLY": "PHYSIOLOGICAL, relating to physiology, also PHYSIOLOGIC [adv]\n",
  "PHYSIOLOGIES": "PHYSIOLOGY, a branch of biology that deals with the functions and activities of life or of living matter (as organs, tissues, or cells) and of the physical and chemical phenomena involved [n]\n",
  "PHYSIOLOGIST": "a student of physiology [n -S]\n",
  "PHYSIOLOGISTS": "PHYSIOLOGIST, a student of physiology [n]\n",
  "PHYSIOLOGUS": "a work containing descriptions of animals; a bestiary [n -ES]\n",
  "PHYSIOLOGUSES": "PHYSIOLOGUS, a work containing descriptions of animals; a bestiary [n]\n",
  "PHYSIOLOGY": "a branch of biology that deals with the functions and activities of life or of living matter (as organs, tissues, or cells) and of the physical and chemical phenomena involved [n PHYSIOLOGIES]\n",
  "PHYSIOPATHOLOGY": "a branch of biology or medicine that combines physiology and pathology esp. in the study of altered bodily function in disease [n]\n",
  "PHYSIOS": "PHYSIO, (short for) physiotherapy [n]\n",
  "PHYSIOTHERAPIES": "PHYSIOTHERAPY, physical therapy [n]\n",
  "PHYSIOTHERAPIST": "one who practises physiotherapy [n]\n",
  "PHYSIOTHERAPY": "physical therapy [n PHYSIOTHERAPIES]\n",
  "PHYSIQUE": "the form or structure of the body [n -S]\n",
  "PHYSIQUED": "having a particular physique [adj]\n",
  "PHYSIQUES": "PHYSIQUE, the form or structure of the body [n]\n",
  "PHYSIS": "(Greek) the part of a bone that is responsible for lengthening, aka growth plate [n PHYSES]\n",
  "PHYSITHEISM": "the ascription of physical form and attributes to deity; the deification of the powers of nature [n -S]\n",
  "PHYSITHEISMS": "PHYSITHEISM, the ascription of physical form and attributes to deity; the deification of the powers of nature [n]\n",
  "PHYSITHEISTIC": "relating to physitheism [adj]\n",
  "PHYSOCLISTOUS": "of fishes, having an air bladder that is not connected to the alimentary canal [adj]\n",
  "PHYSOSTIGMIN": "an alkaloid found in the Calabar bean used esp. in eye drops to reduce pressure inside the eyeball, aka eserine, also PHYSOSTIGMINE [n -S]\n",
  "PHYSOSTIGMINE": "an alkaloid found in the Calabar bean used esp. in eye drops to reduce pressure inside the eyeball, aka eserine, also PHYSOSTIGMIN [n -S]\n",
  "PHYSOSTIGMINES": "PHYSOSTIGMINE, an alkaloid found in the Calabar bean used esp. in eye drops to reduce pressure inside the eyeball, aka eserine, also PHYSOSTIGMIN [n]\n",
  "PHYSOSTIGMINS": "PHYSOSTIGMIN, an alkaloid found in the Calabar bean used esp. in eye drops to reduce pressure inside the eyeball, aka eserine, also PHYSOSTIGMINE [n]\n",
  "PHYSOSTOMOUS": "of fishes, having a duct connecting the air bladder to part of the alimentary canal [adj]\n",
  "PHYTANE": "a hydrocarbon found in some fossilised plant remains [n -S]\n",
  "PHYTANES": "PHYTANE, a hydrocarbon found in some fossilised plant remains [n]\n",
  "PHYTIN": "a substance from plants used as an energy supplement [n -S]\n",
  "PHYTINS": "PHYTIN, a substance from plants used as an energy supplement [n]\n",
  "PHYTOALEXIN": "any substance produced by a plant as a defence against disease [n -S]\n",
  "PHYTOALEXINS": "PHYTOALEXIN, any substance produced by a plant as a defence against disease [n]\n",
  "PHYTOBENTHOS": "plants living at the bottom of water collectively [n -ES]\n",
  "PHYTOBENTHOSES": "PHYTOBENTHOS, plants living at the bottom of water collectively [n]\n",
  "PHYTOCHEMICAL": "relating to the chemistry of plants [adj PHYTOCHEMICALLY] / a chemical derived from a plant [n -S]\n",
  "PHYTOCHEMICALLY": "PHYTOCHEMICAL, relating to the chemistry of plants [adv]\n",
  "PHYTOCHEMICALS": "PHYTOCHEMICAL, a chemical derived from a plant [n]\n",
  "PHYTOCHEMIST": "a chemist specialising in plant [n -S]\n",
  "PHYTOCHEMISTRY": "the chemistry of plants [n]\n",
  "PHYTOCHEMISTS": "PHYTOCHEMIST, a chemist specialising in plant [n]\n",
  "PHYTOCHROME": "a plant pigment which absorbs red or infrared rays and acts as an enzyme controlling growth [n -S]\n",
  "PHYTOCHROMES": "PHYTOCHROME, a plant pigment which absorbs red or infrared rays and acts as an enzyme controlling growth [n]\n",
  "PHYTOESTROGEN": "a plant substance similar to a weak oestrogen [n -S]\n",
  "PHYTOESTROGENS": "PHYTOESTROGEN, a plant substance similar to a weak oestrogen [n]\n",
  "PHYTOFLAGELLATE": "any of various organisms (as dinoflagellates) that have many characteristics in common with typical algae [n]\n",
  "PHYTOGENESES": "PHYTOGENESIS, the origin and development of plants [n]\n",
  "PHYTOGENESIS": "the origin and development of plants [n PHYTOGENESES]\n",
  "PHYTOGENETIC": "relating to phytogenesis, also PHYTOGENETICAL [adj]\n",
  "PHYTOGENETICAL": "relating to phytogenesis, also PHYTOGENETIC [adj]\n",
  "PHYTOGENIC": "derived from plants [adj]\n",
  "PHYTOGENIES": "PHYTOGENY, the doctrine of the generation of plants [n]\n",
  "PHYTOGENY": "the doctrine of the generation of plants [n PHYTOGENIES]\n",
  "PHYTOGEOGRAPHER": "a student of phytogeography [n]\n",
  "PHYTOGEOGRAPHIC": "relating to phytogeography [adj]\n",
  "PHYTOGEOGRAPHY": "the geography of plant distribution [n]\n",
  "PHYTOGRAPHER": "a descriptive botanist [n -S]\n",
  "PHYTOGRAPHERS": "PHYTOGRAPHER, a descriptive botanist [n]\n",
  "PHYTOGRAPHIC": "relating to phytogeography [adj]\n",
  "PHYTOGRAPHIES": "PHYTOGRAPHY, descriptive botany [n]\n",
  "PHYTOGRAPHY": "descriptive botany [n PHYTOGRAPHIES]\n",
  "PHYTOHORMONE": "a plant hormone, regulating growth [n -S]\n",
  "PHYTOHORMONES": "PHYTOHORMONE, a plant hormone, regulating growth [n]\n",
  "PHYTOID": "resembling a plant [adj]\n",
  "PHYTOL": "a chemical alcohol that comes from plants and is used to synthesize vitamins E and K [n -S]\n",
  "PHYTOLITH": "a microscopic particle in plants [n -S]\n",
  "PHYTOLITHS": "PHYTOLITH, a microscopic particle in plants [n]\n",
  "PHYTOLOGICAL": "relating to phytology, botany [adj PHYTOLOGICALLY]\n",
  "PHYTOLOGICALLY": "PHYTOLOGICAL, relating to phytology, botany [adv]\n",
  "PHYTOLOGIES": "PHYTOLOGY, the study of plants [n]\n",
  "PHYTOLOGIST": "a botanist [n -S]\n",
  "PHYTOLOGISTS": "PHYTOLOGIST, a botanist [n]\n",
  "PHYTOLOGY": "the study of plants [n PHYTOLOGIES]\n",
  "PHYTOLS": "PHYTOL, a chemical alcohol that comes from plants and is used to synthesize vitamins E and K [n]\n",
  "PHYTON": "(Greek) the smallest part of a plant that when cut off may grow into a new plant [n -S]\n",
  "PHYTONADIONE": "phylloquinone, vitamin K1 [n -S]\n",
  "PHYTONADIONES": "PHYTONADIONE, phylloquinone, vitamin K1 [n]\n",
  "PHYTONIC": "relating to a phyton, one of the parts which by their repetition make up a flowering plant [adj]\n",
  "PHYTONS": "PHYTON, (Greek) the smallest part of a plant that when cut off may grow into a new plant [n]\n",
  "PHYTOPATHOGEN": "an organism parasitic on a plant host [n -S]\n",
  "PHYTOPATHOGENIC": "of or like a phytopathogen [adj]\n",
  "PHYTOPATHOGENS": "PHYTOPATHOGEN, an organism parasitic on a plant host [n]\n",
  "PHYTOPATHOLOGY": "plant pathology [n]\n",
  "PHYTOPHAGIC": "feeding on plants, also PHYTOPHAGOUS [adj]\n",
  "PHYTOPHAGIES": "PHYTOPHAGY, of insects, feeding on plants [n]\n",
  "PHYTOPHAGOUS": "feeding on plants, also PHYTOPHAGIC [adj]\n",
  "PHYTOPHAGY": "of insects, feeding on plants [n PHYTOPHAGIES]\n",
  "PHYTOPLANKTER": "a planktonic plant [n -S]\n",
  "PHYTOPLANKTERS": "PHYTOPLANKTER, a planktonic plant [n]\n",
  "PHYTOPLANKTON": "vegetable plankton, that includes diatoms, desmids, and dinoflagellates [n -S]\n",
  "PHYTOPLANKTONIC": "relating to phytoplankton [adj]\n",
  "PHYTOPLANKTONS": "PHYTOPLANKTON, vegetable plankton, that includes diatoms, desmids, and dinoflagellates [n]\n",
  "PHYTOSANITARY": "of or relating to the health of plants [adj]\n",
  "PHYTOSES": "PHYTOSIS, a disease caused by vegetable parasites [n]\n",
  "PHYTOSIS": "a disease caused by vegetable parasites [n PHYTOSES]\n",
  "PHYTOSOCIOLOGY": "a branch of ecology dealing with plant communities [n]\n",
  "PHYTOSTEROL": "any of various sterols derived from plants [n -S]\n",
  "PHYTOSTEROLS": "PHYTOSTEROL, any of various sterols derived from plants [n]\n",
  "PHYTOTHERAPIES": "PHYTOTHERAPY, the treatment of the diseases of plants [n]\n",
  "PHYTOTHERAPY": "the treatment of the diseases of plants [n PHYTOTHERAPIES]\n",
  "PHYTOTOMIES": "PHYTOTOMY, the dissection of plants; vegetable anatomy [n]\n",
  "PHYTOTOMIST": "a student of phytotomy [n -S]\n",
  "PHYTOTOMISTS": "PHYTOTOMIST, a student of phytotomy [n]\n",
  "PHYTOTOMY": "the dissection of plants; vegetable anatomy [n PHYTOTOMIES]\n",
  "PHYTOTOXIC": "harmful to plants [adj]\n",
  "PHYTOTOXICITIES": "PHYTOTOXICITY, the state of being phytotoxic [n]\n",
  "PHYTOTOXICITY": "the state of being phytotoxic [n PHYTOTOXICITIES]\n",
  "PHYTOTOXIN": "a poison produced by a plant [n -S]\n",
  "PHYTOTOXINS": "PHYTOTOXIN, a poison produced by a plant [n]\n",
  "PHYTOTRON": "an apparatus that produces climates artificially for the study of plant growth [n -S]\n",
  "PHYTOTRONS": "PHYTOTRON, an apparatus that produces climates artificially for the study of plant growth [n]\n",
  "PI": "(Greek) a letter in the Greek alphabet [n PIS] / to mix type indiscriminately [v PIED, PIEING or PIING, PIES]\n",
  "PIA": "a membrane of the brain [n -S]\n",
  "PIACEVOLE": "(Italian) pleasant, playful [adj]\n",
  "PIACULAR": "atoning, expiatory [adj]\n",
  "PIACULARITIES": "PIACULARITY, the state of being piacular [n]\n",
  "PIACULARITY": "the state of being piacular [n PIACULARITIES]\n",
  "PIAFFE": "(French) to perform a movement in horsemanship [v PIAFFED, PIAFFING, PIAFFES]\n",
  "PIAFFED": "PIAFFE, (French) to perform a movement in horsemanship [v]\n",
  "PIAFFER": "(French) a movement in horsemanship [n -S]\n",
  "PIAFFERS": "PIAFFER, (French) a movement in horsemanship [n]\n",
  "PIAFFES": "PIAFFE, (French) to perform a movement in horsemanship [v]\n",
  "PIAFFING": "PIAFFE, (French) to perform a movement in horsemanship [v]\n",
  "PIAL": "pertaining to a pia, a membrane of the brain [adj]\n",
  "PIAN": "a tropical disease [n -S]\n",
  "PIANETTE": "a small upright piano [n -S]\n",
  "PIANETTES": "PIANETTE, a small upright piano [n]\n",
  "PIANI": "PIANO, a pianoforte [n]\n",
  "PIANIC": "pertaining to the tropical disease pian [adj]\n",
  "PIANINO": "(Italian) a small piano, a pianette [n -S]\n",
  "PIANINOS": "PIANINO, (Italian) a small piano, a pianette [n]\n",
  "PIANISM": "performance on the piano [n -S]\n",
  "PIANISMS": "PIANISM, performance on the piano [n]\n",
  "PIANISSIMI": "PIANISSIMO, (Italian) a direction to execute a passage as softly as possible [n]\n",
  "PIANISSIMO": "(Italian) a direction to execute a passage as softly as possible [n PIANISSIMI or PIANISSIMOS]\n",
  "PIANISSIMOS": "PIANISSIMO, (Italian) a direction to execute a passage as softly as possible [n]\n",
  "PIANISSISSIMO": "as softly as possible [adv]\n",
  "PIANIST": "someone who plays the piano, also PIANISTE [n -S]\n",
  "PIANISTE": "someone who plays the piano, also PIANIST [n -S]\n",
  "PIANISTES": "PIANISTE, someone who plays the piano, also PIANIST [n]\n",
  "PIANISTIC": "relating to or skilled at the playing of the piano [adj PIANISTICALLY]\n",
  "PIANISTICALLY": "PIANISTIC, relating to or skilled at the playing of the piano [adv]\n",
  "PIANISTS": "PIANIST, someone who plays the piano, also PIANISTE [n]\n",
  "PIANO": "a pianoforte [n PIANOS] / a soft passage in music [n PIANI]\n",
  "PIANOFORTE": "(Italian) a large keyboard musical instrument [n -S]\n",
  "PIANOFORTES": "PIANOFORTE, (Italian) a large keyboard musical instrument [n]\n",
  "PIANOLA": "(tradename) a type of player piano [n -S]\n",
  "PIANOLAS": "PIANOLA, (tradename) a type of player piano [n]\n",
  "PIANOLESS": "lacking a piano [adj]\n",
  "PIANOLIST": "one who plays the Pianola [n -S]\n",
  "PIANOLISTS": "PIANOLIST, one who plays the Pianola [n]\n",
  "PIANOS": "PIANO, a pianoforte [n]\n",
  "PIANS": "PIAN, a tropical disease [n]\n",
  "PIARIST": "a member of a Christian group who educate the poor [n -S]\n",
  "PIARISTS": "PIARIST, a member of a Christian group who educate the poor [n]\n",
  "PIAS": "PIA, a membrane of the brain [n]\n",
  "PIASABA": "(Tupi) a coarse, stiff fibre, also PIASSAVA, PIASAVA, PIASSABA [n -S]\n",
  "PIASABAS": "PIASABA, (Tupi) a coarse, stiff fibre, also PIASSAVA, PIASAVA, PIASSABA [n]\n",
  "PIASAVA": "(Tupi) a coarse, stiff fibre, also PIASSAVA, PIASABA, PIASSABA [n -S]\n",
  "PIASAVAS": "PIASAVA, (Tupi) a coarse, stiff fibre, also PIASSAVA, PIASABA, PIASSABA [n]\n",
  "PIASSABA": "(Tupi) a coarse, stiff fibre, also PIASSAVA, PIASABA, PIASAVA [n -S]\n",
  "PIASSABAS": "PIASSABA, (Tupi) a coarse, stiff fibre, also PIASSAVA, PIASABA, PIASAVA [n]\n",
  "PIASSAVA": "(Tupi) a coarse, stiff fibre, also PIASABA, PIASAVA, PIASSABA [n -S]\n",
  "PIASSAVAS": "PIASSAVA, (Tupi) a coarse, stiff fibre, also PIASABA, PIASAVA, PIASSABA [n]\n",
  "PIASTER": "a monetary unit of several Arab countries, also PIASTRE [n -S]\n",
  "PIASTERS": "PIASTER, a monetary unit of several Arab countries, also PIASTRE [n]\n",
  "PIASTRE": "(French) a monetary unit of several Arab countries, also PIASTER [n -S]\n",
  "PIASTRES": "PIASTRE, (French) a monetary unit of several Arab countries, also PIASTER [n]\n",
  "PIAZZA": "(Italian) a public square in an Italian town [n PIAZZAS or PIAZZE]\n",
  "PIAZZAS": "PIAZZA, (Italian) a public square in an Italian town [n]\n",
  "PIAZZE": "PIAZZA, (Italian) a public square in an Italian town [n]\n",
  "PIAZZIAN": "relating to a piazza, in Italy, a public square [adj]\n",
  "PIBAL": "a small balloon for determining wind direction and speed [n -S]\n",
  "PIBALS": "PIBAL, a small balloon for determining wind direction and speed [n]\n",
  "PIBROCH": "(Gaelic) a dirge or martial theme for bagpipes [n -S]\n",
  "PIBROCHS": "PIBROCH, (Gaelic) a dirge or martial theme for bagpipes [n]\n",
  "PIC": "(colloquial) a picture [n PICS or PIX]\n",
  "PICA": "an old type size, approximately, and still used synonymously for, 12-point [n -S]\n",
  "PICACHO": "(Spanish) an isolated peak of a hill [n -S]\n",
  "PICACHOS": "PICACHO, (Spanish) an isolated peak of a hill [n]\n",
  "PICADILLO": "(Spanish) a traditional Mexican dish of ground meat, tomatoes etc., also PICCADILLO, PICKADILLO [n -S]\n",
  "PICADILLOS": "PICADILLO, (Spanish) a traditional Mexican dish of ground meat, tomatoes etc., also PICCADILLO, PICKADILLO [n]\n",
  "PICADOR": "(Spanish) a matador's assistant, a mounted bullfighter with a lance [n PICADORS or PICADORES]\n",
  "PICADORES": "PICADOR, (Spanish) a matador's assistant, a mounted bullfighter with a lance [n]\n",
  "PICADORS": "PICADOR, (Spanish) a matador's assistant, a mounted bullfighter with a lance [n]\n",
  "PICAL": "relating to pica, a size of type [adj]\n",
  "PICAMAR": "(Latin) a liquid obtained from tar [n -S]\n",
  "PICAMARS": "PICAMAR, (Latin) a liquid obtained from tar [n]\n",
  "PICANINNIES": "PICANINNY, a little child, esp. black, also PICCANIN, PICCANINNY, PICKNEY [n]\n",
  "PICANINNY": "a little child, esp. black, also PICCANIN, PICCANINNY, PICKNEY [n PICANINNIES]\n",
  "PICANTE": "hot and spicy [adj]\n",
  "PICARA": "(Spanish) a (female) rogue [n -S]\n",
  "PICARAS": "PICARA, (Spanish) a (female) rogue [n]\n",
  "PICARESQUE": "(French) pertaining to rogues, esp. applied to literature about rogues and vagabonds [adj] / a story of rogues [n -S]\n",
  "PICARESQUES": "PICARESQUE, a story of rogues [n]\n",
  "PICARIAN": "a woodpecker or similar bird [n -S]\n",
  "PICARIANS": "PICARIAN, a woodpecker or similar bird [n]\n",
  "PICARO": "(Spanish) a (male) rogue [n -S]\n",
  "PICAROON": "(Spanish) a pirate ship, also PICKAROON [n -S] / to act as a pirate [v -ED, -ING, -S]\n",
  "PICAROONED": "PICAROON, to act as a pirate [v]\n",
  "PICAROONING": "PICAROON, to act as a pirate [v]\n",
  "PICAROONS": "PICAROON, to act as a pirate [v]\n",
  "PICAROS": "PICARO, (Spanish) a (male) rogue [n]\n",
  "PICAS": "PICA, an old type size, approximately, and still used synonymously for, 12-point [n]\n",
  "PICAYUNE": "(French) a former Spanish-American coin [n -S]\n",
  "PICAYUNES": "PICAYUNE, (French) a former Spanish-American coin [n]\n",
  "PICAYUNISH": "petty, paltry [adj PICAYUNISHLY]\n",
  "PICAYUNISHLY": "PICAYUNISH, petty, paltry [adv]\n",
  "PICAYUNISHNESS": "PICAYUNISH, petty, paltry [n]\n",
  "PICCADILL": "(obsolete) a cut or vandyked edging, esp. to a woman's collar, also PICCADILLO, PICKADIL, PICKADILL, PICKADILLO [n -S]\n",
  "PICCADILLIES": "PICCADILLY, a high, stiff collar for the neck, also PICKADILLY [n]\n",
  "PICCADILLO": "(Spanish) a traditional Mexican dish of ground meat, tomatoes etc, also PICADILLO, PICKADILLO [n -ES or -S]\n",
  "PICCADILLOES": "PICCADILLO, (Spanish) a traditional Mexican dish of ground meat, tomatoes etc, also PICADILLO, PICKADILLO [n]\n",
  "PICCADILLOS": "PICCADILLO, (Spanish) a traditional Mexican dish of ground meat, tomatoes etc, also PICADILLO, PICKADILLO [n]\n",
  "PICCADILLS": "PICCADILL, (obsolete) a cut or vandyked edging, esp. to a woman's collar, also PICCADILLO, PICKADIL, PICKADILL, PICKADILLO [n]\n",
  "PICCADILLY": "a high, stiff collar for the neck, also PICKADILLY [n PICCADILLIES]\n",
  "PICCALILLI": "a mixed-vegetable pickle in a mustard sauce [n -S]\n",
  "PICCALILLIS": "PICCALILLI, a mixed-vegetable pickle in a mustard sauce [n]\n",
  "PICCANIN": "a little child, esp. black, also PICANINNY, PICCANINNY, PICKNEY [n -S]\n",
  "PICCANINNIES": "PICCANINNY, a little child, esp. black, also PICANINNY, PICCANIN, PICKNEY [n]\n",
  "PICCANINNY": "a little child, esp. black, also PICANINNY, PICCANIN, PICKNEY [n PICCANINNIES]\n",
  "PICCANINS": "PICCANIN, a little child, esp. black, also PICANINNY, PICCANINNY, PICKNEY [n]\n",
  "PICCATA": "(Italian) a dish of veal cutlets with a sauce of lemon, white wine and butter [n -S]\n",
  "PICCATAS": "PICCATA, (Italian) a dish of veal cutlets with a sauce of lemon, white wine and butter [n]\n",
  "PICCIES": "PICCY, (slang) a picture [n]\n",
  "PICCOLO": "(Italian) a small, shrill flute [n -S]\n",
  "PICCOLOIST": "one who plays the piccolo [n -S]\n",
  "PICCOLOISTS": "PICCOLOIST, one who plays the piccolo [n]\n",
  "PICCOLOS": "PICCOLO, (Italian) a small, shrill flute [n]\n",
  "PICCY": "(slang) a picture [n PICCIES]\n",
  "PICE": "(Hindi) an Indian coin, 1/4 anna [n PICE]\n",
  "PICENE": "a hydrocarbon [n -S]\n",
  "PICENES": "PICENE, a hydrocarbon [n]\n",
  "PICEOUS": "glossy-black in colour [adj]\n",
  "PICHICIAGO": "(Spanish) a fairy armadillo, esp. the lesser or pink fairy armadillo, also PICHICIEGO [n -S]\n",
  "PICHICIAGOS": "PICHICIAGO, (Spanish) a fairy armadillo, esp. the lesser or pink fairy armadillo, also PICHICIEGO [n]\n",
  "PICHICIEGO": "(Spanish) a fairy armadillo, esp. the lesser or pink fairy armadillo, also PICHICIAGO [n -S]\n",
  "PICHICIEGOS": "PICHICIEGO, (Spanish) a fairy armadillo, esp. the lesser or pink fairy armadillo, also PICHICIAGO [n]\n",
  "PICHOLINE": "a variety of olive [n -S]\n",
  "PICHOLINES": "PICHOLINE, a variety of olive [n]\n",
  "PICHURIM": "(Tupi) a South American tree of the laurel family [n -S]\n",
  "PICHURIMS": "PICHURIM, (Tupi) a South American tree of the laurel family [n]\n",
  "PICIFORM": "pertaining to an order of birds [adj]\n",
  "PICINE": "of the woodpecker family [adj]\n",
  "PICK": "to choose [v -ED, -ING, -S]\n",
  "PICKABACK": "a carry on one's back [n -S] / to carry someone on one's back, also PICKAPACK, PICKBACK, PIGGYBACK [v -ED, -ING, -S]\n",
  "PICKABACKED": "PICKABACK, to carry someone on one's back, also PICKAPACK, PICKBACK, PIGGYBACK [v]\n",
  "PICKABACKING": "PICKABACK, to carry someone on one's back, also PICKAPACK, PICKBACK, PIGGYBACK [v]\n",
  "PICKABACKS": "PICKABACK, to carry someone on one's back, also PICKAPACK, PICKBACK, PIGGYBACK [v]\n",
  "PICKABLE": "able to be picked [adj]\n",
  "PICKADIL": "(obsolete) a cut or vandyked edging, esp. to a woman's collar, also PICCADILLY, PICKADILLY [n -S]\n",
  "PICKADILL": "(obsolete) a cut or vandyked edging, esp. to a woman's collar, also PICCADILL, PICCADILLO, PICKADIL, PICKADILLO [n -S]\n",
  "PICKADILLIES": "PICKADILLY, a cut or vandyked edging, esp. to a woman's collar, also PICCADILLY, PICKADIL [n]\n",
  "PICKADILLO": "(Spanish) a traditional Mexican dish of ground meat, tomatoes etc, also PICADILLO, PICCADILLO [n -ES or -S]\n",
  "PICKADILLOES": "PICKADILLO, (Spanish) a traditional Mexican dish of ground meat, tomatoes etc, also PICADILLO, PICCADILLO [n]\n",
  "PICKADILLOS": "PICKADILLO, (Spanish) a traditional Mexican dish of ground meat, tomatoes etc, also PICADILLO, PICCADILLO [n]\n",
  "PICKADILLS": "PICKADILL, (obsolete) a cut or vandyked edging, esp. to a woman's collar, also PICCADILL, PICCADILLO, PICKADIL, PICKADILLO [n]\n",
  "PICKADILLY": "a cut or vandyked edging, esp. to a woman's collar, also PICCADILLY, PICKADIL [n PICKADILLIES]\n",
  "PICKADILS": "PICKADIL, (obsolete) a cut or vandyked edging, esp. to a woman's collar, also PICCADILLY, PICKADILLY [n]\n",
  "PICKANINNIES": "PICKANINNY, a small child; esp. a negro or mulatto infant [n]\n",
  "PICKANINNY": "a small child; esp. a negro or mulatto infant [n PICKANINNIES]\n",
  "PICKAPACK": "a carry on one's back [n -S] / to carry on one's back, also PICKABACK, PICKBACK, PIGGYBACK [v -ED, -ING, -S]\n",
  "PICKAPACKED": "PICKAPACK, to carry on one's back, also PICKABACK, PICKBACK, PIGGYBACK [v]\n",
  "PICKAPACKING": "PICKAPACK, to carry on one's back, also PICKABACK, PICKBACK, PIGGYBACK [v]\n",
  "PICKAPACKS": "PICKAPACK, to carry on one's back, also PICKABACK, PICKBACK, PIGGYBACK [v]\n",
  "PICKAROON": "(Spanish) a pirate ship, also PICAROON [n -S]\n",
  "PICKAROONS": "PICKAROON, (Spanish) a pirate ship, also PICAROON [n]\n",
  "PICKAX": "to use a tool for breaking hard surfaces, also PICKAXE [v -ED, -ING, -ES]\n",
  "PICKAXE": "to use a tool for breaking hard surfaces, also PICKAX [v PICKAXED, PICKAXING, PICKAXES]\n",
  "PICKAXED": "PICKAX, to use a tool for breaking hard surfaces, also PICKAXE [v]\n",
  "PICKAXES": "PICKAX, to use a tool for breaking hard surfaces, also PICKAXE [v]\n",
  "PICKAXING": "PICKAX, to use a tool for breaking hard surfaces, also PICKAXE [v]\n",
  "PICKBACK": "a carry on one's back [n -S] / to carry someone on one's back, also PICKABACK, PICKAPACK, PIGGYBACK [v -ED, -ING, -S]\n",
  "PICKBACKED": "PICKBACK, to carry someone on one's back, also PICKABACK, PICKAPACK, PIGGYBACK [v]\n",
  "PICKBACKING": "PICKBACK, to carry someone on one's back, also PICKABACK, PICKAPACK, PIGGYBACK [v]\n",
  "PICKBACKS": "PICKBACK, to carry someone on one's back, also PICKABACK, PICKAPACK, PIGGYBACK [v]\n",
  "PICKED": "PICK, to choose [v]\n",
  "PICKEDNESS": "the state of being sharpened [n -ES]\n",
  "PICKEDNESSES": "PICKEDNESS, the state of being sharpened [n]\n",
  "PICKEER": "to forage, to skirmish in advance of an army [v -ED, -ING, -S]\n",
  "PICKEERED": "PICKEER, to forage, to skirmish in advance of an army [v]\n",
  "PICKEERER": "one who pickeers, a marauder [n -S]\n",
  "PICKEERERS": "PICKEERER, one who pickeers, a marauder [n]\n",
  "PICKEERING": "PICKEER, to forage, to skirmish in advance of an army [v]\n",
  "PICKEERS": "PICKEER, to forage, to skirmish in advance of an army [v]\n",
  "PICKELHAUBE": "(German) the spiked helmet worn by German or Prussian soldiers before World War I [n -S]\n",
  "PICKELHAUBES": "PICKELHAUBE, (German) the spiked helmet worn by German or Prussian soldiers before World War I [n]\n",
  "PICKER": "one that picks [n -S]\n",
  "PICKEREL": "a young pike; a small American freshwater fish [n -S]\n",
  "PICKERELS": "PICKEREL, a young pike; a small American freshwater fish [n]\n",
  "PICKERELWEED": "a shallow-water perennial plant chiefly of the eastern United States and Canada with large leaves and a spike of purplish-blue flowers [n -S]\n",
  "PICKERELWEEDS": "PICKERELWEED, a shallow-water perennial plant chiefly of the eastern United States and Canada with large leaves and a spike of purplish-blue flowers [n]\n",
  "PICKERIES": "PICKERY, pilfering [n]\n",
  "PICKERS": "PICKER, one that picks [n]\n",
  "PICKERY": "pilfering [n PICKERIES]\n",
  "PICKET": "a person or group stationed to watch and dissuade those who go to work during a strike [n -S] / to act as a picket, also PICQUET, PIQUET [v -ED, -ING, -S]\n",
  "PICKETBOAT": "a craft used (as by the coastguard) for harbour patrol [n -S]\n",
  "PICKETBOATS": "PICKETBOAT, a craft used (as by the coastguard) for harbour patrol [n]\n",
  "PICKETED": "PICKET, to act as a picket, also PICQUET, PIQUET [v]\n",
  "PICKETER": "one who pickets [n -S]\n",
  "PICKETERS": "PICKETER, one who pickets [n]\n",
  "PICKETING": "standing outside some location, as a business, to publicize one's grievances against it [n -S]\n",
  "PICKETINGS": "PICKETING, standing outside some location, as a business, to publicize one's grievances against it [n]\n",
  "PICKETS": "PICKET, to act as a picket, also PICQUET, PIQUET [v]\n",
  "PICKIER": "PICKY, choosy, fastidious [adj]\n",
  "PICKIEST": "PICKY, choosy, fastidious [adj]\n",
  "PICKILY": "PICKY, choosy, fastidious [adv]\n",
  "PICKIN": "(West Africa) a small child, a pickaninny [n -S]\n",
  "PICKINESS": "the state of being picky [n -ES]\n",
  "PICKINESSES": "PICKINESS, the state of being picky [n]\n",
  "PICKING": "the act of one who picks [n -S]\n",
  "PICKINGS": "PICKING, the act of one who picks [n]\n",
  "PICKINS": "PICKIN, (West Africa) a small child, a pickaninny [n]\n",
  "PICKLE": "a liquid, esp. brine or vinegar, in which food is preserved [n -S] / to preserve food by pickling [v PICKLED, PICKLING, PICKLES]\n",
  "PICKLED": "PICKLE, to preserve food by pickling [v]\n",
  "PICKLER": "one who pickles [n -S]\n",
  "PICKLERS": "PICKLER, one who pickles [n]\n",
  "PICKLES": "PICKLE, to preserve food by pickling [v]\n",
  "PICKLING": "PICKLE, to preserve food by pickling [v]\n",
  "PICKLOCK": "an instrument for picking locks, also LOCKPICK [n -S]\n",
  "PICKLOCKS": "PICKLOCK, an instrument for picking locks, also LOCKPICK [n]\n",
  "PICKMAW": "(Scots) the blackheaded gull [n -S]\n",
  "PICKMAWS": "PICKMAW, (Scots) the blackheaded gull [n]\n",
  "PICKNEY": "in Jamaican patois, a child, also PICANINNY, PICCANIN, PICCANINNY [n -S]\n",
  "PICKNEYS": "PICKNEY, in Jamaican patois, a child, also PICANINNY, PICCANIN, PICCANINNY [n]\n",
  "PICKOFF": "a play in baseball [n -S]\n",
  "PICKOFFS": "PICKOFF, a play in baseball [n]\n",
  "PICKPOCKET": "to steal from pockets [v -ED, -ING, -S]\n",
  "PICKPOCKETED": "PICKPOCKET, to steal from pockets [v]\n",
  "PICKPOCKETING": "PICKPOCKET, to steal from pockets [v]\n",
  "PICKPOCKETS": "PICKPOCKET, to steal from pockets [v]\n",
  "PICKPROOF": "of a lock, proof against picking [adj]\n",
  "PICKS": "PICK, to choose [v]\n",
  "PICKTHANK": "someone who seeks to ingratiate himself or herself by officious favours, or by talebearing [n -S]\n",
  "PICKTHANKS": "PICKTHANK, someone who seeks to ingratiate himself or herself by officious favours, or by talebearing [n]\n",
  "PICKUP": "a small truck or van with an open body, used for carrying light loads [n -S]\n",
  "PICKUPS": "PICKUP, a small truck or van with an open body, used for carrying light loads [n]\n",
  "PICKWICK": "a device for raising wicks in oil lamps [n -S]\n",
  "PICKWICKS": "PICKWICK, a device for raising wicks in oil lamps [n]\n",
  "PICKY": "choosy, fastidious [adj PICKIER, PICKIEST, PICKILY]\n",
  "PICLORAM": "a herbicide [n -S]\n",
  "PICLORAMS": "PICLORAM, a herbicide [n]\n",
  "PICNIC": "to go on an outdoor excursion with food [v PICNICKED, PICNICKING, PICNICS]\n",
  "PICNICKED": "PICNIC, to go on an outdoor excursion with food [v]\n",
  "PICNICKER": "one who picnics [n -S]\n",
  "PICNICKERS": "PICNICKER, one who picnics [n]\n",
  "PICNICKIER": "PICNICKY, like a picnic [adj]\n",
  "PICNICKIEST": "PICNICKY, like a picnic [adj]\n",
  "PICNICKING": "PICNIC, to go on an outdoor excursion with food [v]\n",
  "PICNICKY": "like a picnic [adj PICNICKIER, PICNICKIEST]\n",
  "PICNICS": "PICNIC, to go on an outdoor excursion with food [v]\n",
  "PICOCURIE": "a millionth of a millionth of a curie [n -S]\n",
  "PICOCURIES": "PICOCURIE, a millionth of a millionth of a curie [n]\n",
  "PICOFARAD": "a millionth of a millionth of a farad [n -S]\n",
  "PICOFARADS": "PICOFARAD, a millionth of a millionth of a farad [n]\n",
  "PICOGRAM": "a millionth of a millionth of a gram [n -S]\n",
  "PICOGRAMS": "PICOGRAM, a millionth of a millionth of a gram [n]\n",
  "PICOLIN": "a compound related to pyridine, also PICOLINE [n -S]\n",
  "PICOLINE": "a compound related to pyridine, also PICOLIN [n -S]\n",
  "PICOLINES": "PICOLINE, a compound related to pyridine, also PICOLIN [n]\n",
  "PICOLINIC": "of or like picoline, a compound related to pyridine [adj]\n",
  "PICOLINS": "PICOLIN, a compound related to pyridine, also PICOLINE [n]\n",
  "PICOMETER": "a trillionth of a metre, also PICOMETRE [n -S]\n",
  "PICOMETERS": "PICOMETER, a trillionth of a metre, also PICOMETRE [n]\n",
  "PICOMETRE": "a trillionth of a metre, also PICOMETER [n -S]\n",
  "PICOMETRES": "PICOMETRE, a trillionth of a metre, also PICOMETER [n]\n",
  "PICOMOLE": "one trillionth of a mole [n -S]\n",
  "PICOMOLES": "PICOMOLE, one trillionth of a mole [n]\n",
  "PICONG": "(Caribbean) a teasing satire in a song [n -S]\n",
  "PICONGS": "PICONG, (Caribbean) a teasing satire in a song [n]\n",
  "PICORNAVIRUS": "one of a group of very small RNA viruses, including Cocksackle virus [n -ES]\n",
  "PICORNAVIRUSES": "PICORNAVIRUS, one of a group of very small RNA viruses, including Cocksackle virus [n]\n",
  "PICOSECOND": "a trillionth of a second [n -S]\n",
  "PICOSECONDS": "PICOSECOND, a trillionth of a second [n]\n",
  "PICOT": "(French) to edge with ornamental loops [v -ED, -ING, -S]\n",
  "PICOTE": "(French) embroidered with knotted loops [adj]\n",
  "PICOTED": "PICOT, (French) to edge with ornamental loops [v]\n",
  "PICOTEE": "(French) a variety of carnation, with petal margins of different color [n -S]\n",
  "PICOTEES": "PICOTEE, (French) a variety of carnation, with petal margins of different color [n]\n",
  "PICOTING": "PICOT, (French) to edge with ornamental loops [v]\n",
  "PICOTITE": "a dark spinel containing iron, magnesium and chromium [n -S]\n",
  "PICOTITES": "PICOTITE, a dark spinel containing iron, magnesium and chromium [n]\n",
  "PICOTS": "PICOT, (French) to edge with ornamental loops [v]\n",
  "PICOWAVE": "to irradiate (food) with gamma rays [v PICOWAVED, PICOWAVING, PICOWAVES]\n",
  "PICOWAVED": "PICOWAVE, to irradiate (food) with gamma rays [v]\n",
  "PICOWAVES": "PICOWAVE, to irradiate (food) with gamma rays [v]\n",
  "PICOWAVING": "PICOWAVE, to irradiate (food) with gamma rays [v]\n",
  "PICQUET": "a person or group stationed to watch and dissuade those who go to work during a strike [n -S] / to act as a picket, also PICKET, PIQUET [v -ED, -ING, -S]\n",
  "PICQUETED": "PICQUET, to act as a picket, also PICKET, PIQUET [v]\n",
  "PICQUETING": "PICQUET, to act as a picket, also PICKET, PIQUET [v]\n",
  "PICQUETS": "PICQUET, to act as a picket, also PICKET, PIQUET [v]\n",
  "PICRA": "a purgative made from aloes and bark [n -S]\n",
  "PICRAS": "PICRA, a purgative made from aloes and bark [n]\n",
  "PICRATE": "a chemical salt [n -S]\n",
  "PICRATED": "containing picrate [adj]\n",
  "PICRATES": "PICRATE, a chemical salt [n]\n",
  "PICRIC": "having a very bitter taste [adj]\n",
  "PICRITE": "a dark green igneous rock, consisting largely of chrysolite, with hornblende, augite, biotite, etc. [n -S]\n",
  "PICRITES": "PICRITE, a dark green igneous rock, consisting largely of chrysolite, with hornblende, augite, biotite, etc. [n]\n",
  "PICRITIC": "relating to picrite, a dark green igneous rock [adj]\n",
  "PICROCARMINE": "a stain for microscope work made from carmine, ammonia, water and picric acid [n -S]\n",
  "PICROCARMINES": "PICROCARMINE, a stain for microscope work made from carmine, ammonia, water and picric acid [n]\n",
  "PICROTOXIN": "a bitter toxin obtained from the seeds of the shrub Anamirta cocculus [n -S]\n",
  "PICROTOXINS": "PICROTOXIN, a bitter toxin obtained from the seeds of the shrub Anamirta cocculus [n]\n",
  "PICS": "PIC, (colloquial) a picture [n]\n",
  "PICTARNIE": "(Scott) a tern [n -S]\n",
  "PICTARNIES": "PICTARNIE, (Scott) a tern [n]\n",
  "PICTOGRAM": "a pictograph; a graphical representation [n -S]\n",
  "PICTOGRAMS": "PICTOGRAM, a pictograph; a graphical representation [n]\n",
  "PICTOGRAPH": "a picture used as a symbol for a word or phrase [n -S]\n",
  "PICTOGRAPHIC": "relating to pictography [adj]\n",
  "PICTOGRAPHIES": "PICTOGRAPHY, the use of pictographs [n]\n",
  "PICTOGRAPHS": "PICTOGRAPH, a picture used as a symbol for a word or phrase [n]\n",
  "PICTOGRAPHY": "the use of pictographs [n PICTOGRAPHIES]\n",
  "PICTORIAL": "relating to pictures [adj PICTORIALLY] / a pictorial representation [n -S]\n",
  "PICTORIALISE": "to represent by a picture or illustrate with pictures, also PICTORIALIZE [v PICTORIALISED, PICTORIALISING, PICTORIALISES]\n",
  "PICTORIALISED": "PICTORIALISE, to represent by a picture or illustrate with pictures, also PICTORIALIZE [v]\n",
  "PICTORIALISES": "PICTORIALISE, to represent by a picture or illustrate with pictures, also PICTORIALIZE [v]\n",
  "PICTORIALISING": "PICTORIALISE, to represent by a picture or illustrate with pictures, also PICTORIALIZE [v]\n",
  "PICTORIALISM": "the use or creation of pictures or visual images [n -S]\n",
  "PICTORIALISMS": "PICTORIALISM, the use or creation of pictures or visual images [n]\n",
  "PICTORIALIST": "a proponent of pictorialism [n -S]\n",
  "PICTORIALISTS": "PICTORIALIST, a proponent of pictorialism [n]\n",
  "PICTORIALIZE": "to represent by a picture or illustrate with pictures, also PICTORIALISE [v PICTORIALIZED, PICTORIALIZING, PICTORIALIZES]\n",
  "PICTORIALIZED": "PICTORIALIZE, to represent by a picture or illustrate with pictures, also PICTORIALISE [v]\n",
  "PICTORIALIZES": "PICTORIALIZE, to represent by a picture or illustrate with pictures, also PICTORIALISE [v]\n",
  "PICTORIALIZING": "PICTORIALIZE, to represent by a picture or illustrate with pictures, also PICTORIALISE [v]\n",
  "PICTORIALLY": "PICTORIAL, relating to pictures [adv]\n",
  "PICTORIALNESS": "PICTORIAL, relating to pictures [n]\n",
  "PICTORIALNESSES": "PICTORIALNESS, PICTORIAL, relating to pictures [n]\n",
  "PICTORIALS": "PICTORIAL, a pictorial representation [n]\n",
  "PICTORICAL": "pictorial [adj PICTORICALLY]\n",
  "PICTORICALLY": "PICTORICAL, pictorial [adv]\n",
  "PICTURAL": "(Spenser) a picture [n -S]\n",
  "PICTURALS": "PICTURAL, (Spenser) a picture [n]\n",
  "PICTURE": "to form a likeness of [v PICTURED, PICTURING, PICTURES]\n",
  "PICTURED": "PICTURE, to form a likeness of [v]\n",
  "PICTUREGOER": "one who goes to the cinema [n -S]\n",
  "PICTUREGOERS": "PICTUREGOER, one who goes to the cinema [n]\n",
  "PICTUREPHONE": "a device which allows speakers on the telephone to see each other [n -S]\n",
  "PICTUREPHONES": "PICTUREPHONE, a device which allows speakers on the telephone to see each other [n]\n",
  "PICTURES": "PICTURE, to form a likeness of [v]\n",
  "PICTURESQUE": "resembling a picture [adj PICTURESQUELY]\n",
  "PICTURESQUELY": "PICTURESQUE, resembling a picture [adv]\n",
  "PICTURESQUENESS": "PICTURESQUE, resembling a picture [n]\n",
  "PICTURING": "PICTURE, to form a likeness of [v]\n",
  "PICTURISATION": "the act of picturising, also PICTURIZATION [n -S]\n",
  "PICTURISATIONS": "PICTURISATION, the act of picturising, also PICTURIZATION [n]\n",
  "PICTURISE": "to picture, also PICTURIZE [v PICTURISED, PICTURISING, PICTURISES]\n",
  "PICTURISED": "PICTURISE, to picture, also PICTURIZE [v]\n",
  "PICTURISES": "PICTURISE, to picture, also PICTURIZE [v]\n",
  "PICTURISING": "PICTURISE, to picture, also PICTURIZE [v]\n",
  "PICTURIZATION": "the act of picturizing, also PICTURISATION [n -S]\n",
  "PICTURIZATIONS": "PICTURIZATION, the act of picturizing, also PICTURISATION [n]\n",
  "PICTURIZE": "to picture, also PICTURISE [v PICTURIZED, PICTURIZING, PICTURIZES]\n",
  "PICTURIZED": "PICTURIZE, to picture, also PICTURISE [v]\n",
  "PICTURIZES": "PICTURIZE, to picture, also PICTURISE [v]\n",
  "PICTURIZING": "PICTURIZE, to picture, also PICTURISE [v]\n",
  "PICUL": "(Malay) a Chinese weight, also PIKUL [n -S]\n",
  "PICULET": "a small tropical American woodpecker [n -S]\n",
  "PICULETS": "PICULET, a small tropical American woodpecker [n]\n",
  "PICULS": "PICUL, (Malay) a Chinese weight, also PIKUL [n]\n",
  "PIDDLE": "to deal in trifles [v PIDDLED, PIDDLING, PIDDLES]\n",
  "PIDDLED": "PIDDLE, to deal in trifles [v]\n",
  "PIDDLER": "one who piddles, wastes time [n -S]\n",
  "PIDDLERS": "PIDDLER, one who piddles, wastes time [n]\n",
  "PIDDLES": "PIDDLE, to deal in trifles [v]\n",
  "PIDDLIER": "PIDDLY, insignificant [adj]\n",
  "PIDDLIEST": "PIDDLY, insignificant [adj]\n",
  "PIDDLING": "PIDDLE, to deal in trifles [v]\n",
  "PIDDLINGLY": "PIDDLING, PIDDLE, to deal in trifles [adv]\n",
  "PIDDLY": "insignificant [adj PIDDLIER, PIDDLIEST]\n",
  "PIDDOCK": "a rough-shelled, boring, marine bivalve [n -S]\n",
  "PIDDOCKS": "PIDDOCK, a rough-shelled, boring, marine bivalve [n]\n",
  "PIDGEON": "a simplified speech used for communication between people with different languages, also PIDGIN [n -S]\n",
  "PIDGEONS": "PIDGEON, a simplified speech used for communication between people with different languages, also PIDGIN [n]\n",
  "PIDGIN": "a simplified speech used for communication between people with different languages, also PIDGEON [n -S]\n",
  "PIDGINISATION": "the process of pidginising, also PIDGINIZATION [n -S]\n",
  "PIDGINISATIONS": "PIDGINISATION, the process of pidginising, also PIDGINIZATION [n]\n",
  "PIDGINISE": "to make into pidgin, also PIDGINIZE [v PIDGINISED, PIDGINISING, PIDGINISES]\n",
  "PIDGINISED": "PIDGINISE, to make into pidgin, also PIDGINIZE [v]\n",
  "PIDGINISES": "PIDGINISE, to make into pidgin, also PIDGINIZE [v]\n",
  "PIDGINISING": "PIDGINISE, to make into pidgin, also PIDGINIZE [v]\n",
  "PIDGINIZATION": "the process of pidginizing, also PIDGINISATION [n -S]\n",
  "PIDGINIZATIONS": "PIDGINIZATION, the process of pidginizing, also PIDGINISATION [n]\n",
  "PIDGINIZE": "to make into pidgin, also PIDGINISE [v PIDGINIZED, PIDGINIZING, PIDGINIZES]\n",
  "PIDGINIZED": "PIDGINIZE, to make into pidgin, also PIDGINISE [v]\n",
  "PIDGINIZES": "PIDGINIZE, to make into pidgin, also PIDGINISE [v]\n",
  "PIDGINIZING": "PIDGINIZE, to make into pidgin, also PIDGINISE [v]\n",
  "PIDGINS": "PIDGIN, a simplified speech used for communication between people with different languages, also PIDGEON [n]\n",
  "PIE": "to mix printing type indiscriminately, also PI, PYE [v PIED, PIEING, PIES]\n",
  "PIEBALD": "a horse with patchy colours, also PYEBALD [n -S]\n",
  "PIEBALDS": "PIEBALD, a horse with patchy colours, also PYEBALD [n]\n",
  "PIECE": "to join into a whole [v PIECED, PIECING, PIECES]\n",
  "PIECED": "PIECE, to join into a whole [v]\n",
  "PIECELESS": "not made of pieces; whole; entire [adj]\n",
  "PIECEMEAL": "one part at a time [n -S] / to divide or distribute piecemeal [v -ED, -ING, -S]\n",
  "PIECEMEALED": "PIECEMEAL, to divide or distribute piecemeal [v]\n",
  "PIECEMEALING": "PIECEMEAL, to divide or distribute piecemeal [v]\n",
  "PIECEMEALS": "PIECEMEAL, to divide or distribute piecemeal [v]\n",
  "PIECEN": "to join the broken ends of (a thread) during spinning [v -ED, -ING, -S]\n",
  "PIECENED": "PIECEN, to join the broken ends of (a thread) during spinning [v]\n",
  "PIECENER": "a worker who joins broken threads, also PIECER [n -S]\n",
  "PIECENERS": "PIECENER, a worker who joins broken threads, also PIECER [n]\n",
  "PIECENING": "PIECEN, to join the broken ends of (a thread) during spinning [v]\n",
  "PIECENS": "PIECEN, to join the broken ends of (a thread) during spinning [v]\n",
  "PIECER": "a worker who joins broken threads, also PIECENER [n -S]\n",
  "PIECERS": "PIECER, a worker who joins broken threads, also PIECENER [n]\n",
  "PIECES": "PIECE, to join into a whole [v]\n",
  "PIECEWISE": "piece by piece [adv]\n",
  "PIECEWORK": "work paid for by the piece or quantity, not by time [n -S]\n",
  "PIECEWORKER": "one who does piecework [n -S]\n",
  "PIECEWORKERS": "PIECEWORKER, one who does piecework [n]\n",
  "PIECEWORKS": "PIECEWORK, work paid for by the piece or quantity, not by time [n]\n",
  "PIECING": "material to be sewn together [n -S]\n",
  "PIECINGS": "PIECING, material to be sewn together [n]\n",
  "PIECRUST": "the crust of a pie [n -S]\n",
  "PIECRUSTS": "PIECRUST, the crust of a pie [n]\n",
  "PIED": "PIE, to mix printing type indiscriminately, also PI, PYE [v]\n",
  "PIEDFORT": "an unusually thick coin, also PIEFORT [n -S]\n",
  "PIEDFORTS": "PIEDFORT, an unusually thick coin, also PIEFORT [n]\n",
  "PIEDISH": "a deep dish for pie-making [n -ES]\n",
  "PIEDISHES": "PIEDISH, a deep dish for pie-making [n]\n",
  "PIEDMONT": "an area lying at the foot of a mountain [n -S]\n",
  "PIEDMONTITE": "a dark red mineral, a hydrated silicate of calcium, aluminium, manganese and iron, also PIEMONTITE [n -S]\n",
  "PIEDMONTITES": "PIEDMONTITE, a dark red mineral, a hydrated silicate of calcium, aluminium, manganese and iron, also PIEMONTITE [n]\n",
  "PIEDMONTS": "PIEDMONT, an area lying at the foot of a mountain [n]\n",
  "PIEDNESS": "the state of being pied, having various colours [n -ES]\n",
  "PIEDNESSES": "PIEDNESS, the state of being pied, having various colours [n]\n",
  "PIEFORT": "an unusually thick coin, also PIEDFORT [n -S]\n",
  "PIEFORTS": "PIEFORT, an unusually thick coin, also PIEDFORT [n]\n",
  "PIEHOLE": "(slang) a person's mouth [n -S]\n",
  "PIEHOLES": "PIEHOLE, (slang) a person's mouth [n]\n",
  "PIEING": "the act of assaulting with a custard pie [n -S]\n",
  "PIEINGS": "PIEING, the act of assaulting with a custard pie [n]\n",
  "PIEMAN": "someone who sells pies [n PIEMEN]\n",
  "PIEMEN": "PIEMAN, someone who sells pies [n]\n",
  "PIEMONTITE": "a dark red mineral, a hydrated silicate of calcium, aluminium, manganese and iron, also PIEDMONTITE [n -S]\n",
  "PIEMONTITES": "PIEMONTITE, a dark red mineral, a hydrated silicate of calcium, aluminium, manganese and iron, also PIEDMONTITE [n]\n",
  "PIEND": "an outward pointing angle in a fortification [n -S]\n",
  "PIENDS": "PIEND, an outward pointing angle in a fortification [n]\n",
  "PIEPLANT": "(US) rhubarb [n -S]\n",
  "PIEPLANTS": "PIEPLANT, (US) rhubarb [n]\n",
  "PIEPOWDER": "(obsolete) a wayfarer, esp. an itinerant merchant or trader [n -S]\n",
  "PIEPOWDERS": "PIEPOWDER, (obsolete) a wayfarer, esp. an itinerant merchant or trader [n]\n",
  "PIER": "a structure extending from land out over water [n -S]\n",
  "PIERAGE": "a fee paid for the use of a pier [n -S]\n",
  "PIERAGES": "PIERAGE, a fee paid for the use of a pier [n]\n",
  "PIERCE": "to thrust, or make a hole through [v PIERCED, PIERCING, PIERCES]\n",
  "PIERCEABLE": "that may be pierced, also PERCEABLE [adj]\n",
  "PIERCED": "PIERCE, to thrust, or make a hole through [v]\n",
  "PIERCER": "something or someone that pierces [n -S]\n",
  "PIERCERS": "PIERCER, something or someone that pierces [n]\n",
  "PIERCES": "PIERCE, to thrust, or make a hole through [v]\n",
  "PIERCING": "penetrating, very acute [adj PIERCINGLY] / a hole made in body piercing [n -S]\n",
  "PIERCINGLY": "PIERCING, penetrating, very acute [adv]\n",
  "PIERCINGNESS": "the state of being piercing [n -ES]\n",
  "PIERCINGNESSES": "PIERCINGNESS, the state of being piercing [n]\n",
  "PIERCINGS": "PIERCING, a hole made in body piercing [n]\n",
  "PIERHEAD": "the seaward end of a pier [n -S]\n",
  "PIERHEADS": "PIERHEAD, the seaward end of a pier [n]\n",
  "PIERID": "any butterfly belonging to the family including cabbage white and other butterflies [n -S]\n",
  "PIERIDINE": "relating to the family Pieridae of butterflies, that includes the whites, brimstones, and sulphurs [adj]\n",
  "PIERIDS": "PIERID, any butterfly belonging to the family including cabbage white and other butterflies [n]\n",
  "PIERIS": "an American or Asiatic shrub [n -ES]\n",
  "PIERISES": "PIERIS, an American or Asiatic shrub [n]\n",
  "PIEROG": "a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PEROG, PIROG [n PIEROGEN or PIEROGS]\n",
  "PIEROGEN": "PIEROG, a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PEROG, PIROG [n]\n",
  "PIEROGI": "(Polish) a small dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIROGI, PYROGY, PYROHY [n -ES]\n",
  "PIEROGIES": "PIEROGI, (Polish) a small dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIROGI, PYROGY, PYROHY [n]\n",
  "PIEROGS": "PIEROG, a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PEROG, PIROG [n]\n",
  "PIERRETTE": "(French) a female performer in a pierrot group [n -S]\n",
  "PIERRETTES": "PIERRETTE, (French) a female performer in a pierrot group [n]\n",
  "PIERROT": "(French) a comic character in French pantomime, dressed in a floppy white suit [n -S]\n",
  "PIERROTS": "PIERROT, (French) a comic character in French pantomime, dressed in a floppy white suit [n]\n",
  "PIERS": "PIER, a structure extending from land out over water [n]\n",
  "PIERST": "(Spenser) pierced, also PEARST, PERST [v]\n",
  "PIERT": "a small plant with small greenish flowers [n -S]\n",
  "PIERTS": "PIERT, a small plant with small greenish flowers [n]\n",
  "PIES": "PIE, to mix printing type indiscriminately, also PI, PYE [v]\n",
  "PIET": "(Scots) a magpie, also PYAT, PYET, PYOT [n -S]\n",
  "PIETA": "(Italian) a representation of the dead Christ held and mourned by the Virgin Mary [n -S]\n",
  "PIETAS": "PIETA, (Italian) a representation of the dead Christ held and mourned by the Virgin Mary [n]\n",
  "PIETIES": "PIETY, the state of being pious, also PIETISM [n]\n",
  "PIETISM": "unquestioning or dogmatic religious devotion [n -S]\n",
  "PIETISMS": "PIETISM, unquestioning or dogmatic religious devotion [n]\n",
  "PIETIST": "a person characterized by or professing (often affected or exaggerated) piety [n -S]\n",
  "PIETISTIC": "relating to pietism, unquestioning or dogmatic religious devotion, also PIETISTICAL [adj PIETISTICALLY]\n",
  "PIETISTICAL": "relating to pietism, unquestioning or dogmatic religious devotion, also PIETISTIC [adj PIETISTICALLY]\n",
  "PIETISTICALLY": "PIETISTICAL, relating to pietism, unquestioning or dogmatic religious devotion, also PIETISTIC [adv]\n",
  "PIETISTS": "PIETIST, a person characterized by or professing (often affected or exaggerated) piety [n]\n",
  "PIETS": "PIET, (Scots) a magpie, also PYAT, PYET, PYOT [n]\n",
  "PIETY": "the state of being pious, also PIETISM [n PIETIES]\n",
  "PIEZO": "(short for) piezoelectric, relating to electric current generated by compression of crystals [adj]\n",
  "PIEZOCHEMISTRY": "the study of the chemical effects of pressure [n]\n",
  "PIEZOELECTRIC": "relating to electric current generated by compression of crystals [adj]\n",
  "PIEZOMAGNETIC": "relating to piezomagnetism [adj]\n",
  "PIEZOMAGNETISM": "magnetism developed in a similar way to piezoelectricity, using a magnetic instead of an electric field [n -S]\n",
  "PIEZOMAGNETISMS": "PIEZOMAGNETISM, magnetism developed in a similar way to piezoelectricity, using a magnetic instead of an electric field [n]\n",
  "PIEZOMETER": "an instrument for measuring pressure or compressibility [n -S]\n",
  "PIEZOMETERS": "PIEZOMETER, an instrument for measuring pressure or compressibility [n]\n",
  "PIEZOMETRIC": "relating measurement by piezometer [adj PIEZOMETRICALLY]\n",
  "PIEZOMETRICALLY": "PIEZOMETRIC, relating measurement by piezometer [adv]\n",
  "PIEZOMETRIES": "PIEZOMETRY, measurement by use of a piezometer, an instrument for measuring pressure or compressibility [n]\n",
  "PIEZOMETRY": "measurement by use of a piezometer, an instrument for measuring pressure or compressibility [n PIEZOMETRIES]\n",
  "PIFFERARI": "PIFFERARO, (Italian) a piffero player [n]\n",
  "PIFFERARO": "(Italian) a piffero player [n PIFFERARI or PIFFERAROS]\n",
  "PIFFERAROS": "PIFFERARO, (Italian) a piffero player [n]\n",
  "PIFFERO": "(Italian) a fife; an Italian bagpipe [n -S]\n",
  "PIFFEROS": "PIFFERO, (Italian) a fife; an Italian bagpipe [n]\n",
  "PIFFLE": "to talk in a feeble or futile way [v PIFFLED, PIFFLING, PIFFLES]\n",
  "PIFFLED": "PIFFLE, to talk in a feeble or futile way [v]\n",
  "PIFFLER": "one who talks nonsense [n -S]\n",
  "PIFFLERS": "PIFFLER, one who talks nonsense [n]\n",
  "PIFFLES": "PIFFLE, to talk in a feeble or futile way [v]\n",
  "PIFFLING": "PIFFLE, to talk in a feeble or futile way [v]\n",
  "PIG": "to give birth to cloven-hoofed mammals [v PIGGED, PIGGING, PIGS]\n",
  "PIGBOAT": "a submarine [n -S]\n",
  "PIGBOATS": "PIGBOAT, a submarine [n]\n",
  "PIGEON": "to gull or hoax [v -ED, -ING, -S]\n",
  "PIGEONED": "PIGEON, to gull or hoax [v]\n",
  "PIGEONHOLE": "a compartment for storing and classifying papers, for leaving letters etc. [n -S] / to place in or as if in the pigeonhole of a desk [v PIGEONHOLED, PIGEONHOLING, PIGEONHOLES]\n",
  "PIGEONHOLED": "PIGEONHOLE, to place in or as if in the pigeonhole of a desk [v]\n",
  "PIGEONHOLER": "one who pigeonholes [n -S]\n",
  "PIGEONHOLERS": "PIGEONHOLER, one who pigeonholes [n]\n",
  "PIGEONHOLES": "PIGEONHOLE, to place in or as if in the pigeonhole of a desk [v]\n",
  "PIGEONHOLING": "PIGEONHOLE, to place in or as if in the pigeonhole of a desk [v]\n",
  "PIGEONING": "PIGEON, to gull or hoax [v]\n",
  "PIGEONITE": "a monoclinic mineral of the pyroxene group [n -S]\n",
  "PIGEONITES": "PIGEONITE, a monoclinic mineral of the pyroxene group [n]\n",
  "PIGEONRIES": "PIGEONRY, a place for keeping pigeons [n]\n",
  "PIGEONRY": "a place for keeping pigeons [n PIGEONRIES]\n",
  "PIGEONS": "PIGEON, to gull or hoax [v]\n",
  "PIGEONWING": "a caper or leap in dancing, jumping and clapping feet together [n -S]\n",
  "PIGEONWINGS": "PIGEONWING, a caper or leap in dancing, jumping and clapping feet together [n]\n",
  "PIGFACE": "(Australian) a creeping succulent plant with brightly coloured flowers and red fruits [n -S]\n",
  "PIGFACES": "PIGFACE, (Australian) a creeping succulent plant with brightly coloured flowers and red fruits [n]\n",
  "PIGFEED": "food for pigs [n -S]\n",
  "PIGFEEDS": "PIGFEED, food for pigs [n]\n",
  "PIGFISH": "a large West Indian and Florida food fish, aka hogfish [n -ES]\n",
  "PIGFISHES": "PIGFISH, a large West Indian and Florida food fish, aka hogfish [n]\n",
  "PIGGED": "PIG, to give birth to cloven-hoofed mammals [v]\n",
  "PIGGERIES": "PIGGERY, a place where swine are kept [n]\n",
  "PIGGERY": "a place where swine are kept [n PIGGERIES]\n",
  "PIGGIE": "a small pig, also PIGGY [n -S]\n",
  "PIGGIER": "PIGGY, piggish [adj]\n",
  "PIGGIES": "PIGGIE, a small pig, also PIGGY [n]\n",
  "PIGGIEST": "PIGGY, piggish [adj]\n",
  "PIGGIN": "(Scots) a small pail or bowl made of staves and hoops [n -S]\n",
  "PIGGINESS": "the state of being piggy [n -ES]\n",
  "PIGGINESSES": "PIGGINESS, the state of being piggy [n]\n",
  "PIGGING": "operating a pig or running a pig along a pipeline [n -S]\n",
  "PIGGINGS": "PIGGING, operating a pig or running a pig along a pipeline [n]\n",
  "PIGGINS": "PIGGIN, (Scots) a small pail or bowl made of staves and hoops [n]\n",
  "PIGGISH": "greedy or dirty [adj PIGGISHLY]\n",
  "PIGGISHLY": "PIGGISH, greedy or dirty [adv]\n",
  "PIGGISHNESS": "the state of being piggish [n -ES]\n",
  "PIGGISHNESSES": "PIGGISHNESS, the state of being piggish [n]\n",
  "PIGGY": "piggish [adj PIGGIER, PIGGIEST] / a small pig, also PIGGIE [n PIGGIES]\n",
  "PIGGYBACK": "a carry on one's back [n -S] / to carry someone on one's back, also PICKABACK, PICKAPACK, PICKBACK [v -ED, -ING, -S]\n",
  "PIGGYBACKED": "PIGGYBACK, to carry someone on one's back, also PICKABACK, PICKAPACK, PICKBACK [v]\n",
  "PIGGYBACKING": "PIGGYBACK, to carry someone on one's back, also PICKABACK, PICKAPACK, PICKBACK [v]\n",
  "PIGGYBACKS": "PIGGYBACK, to carry someone on one's back, also PICKABACK, PICKAPACK, PICKBACK [v]\n",
  "PIGHEADED": "obstinate [adj PIGHEADEDLY]\n",
  "PIGHEADEDLY": "PIGHEADED, obstinate [adv]\n",
  "PIGHEADEDNESS": "PIGHEADED, obstinate [n]\n",
  "PIGHEADEDNESSES": "PIGHEADEDNESS, PIGHEADED, obstinate [n]\n",
  "PIGHT": "to pitch (e.g. a tent) [v -ED, -ING, -S]\n",
  "PIGHTED": "PIGHT, to pitch (e.g. a tent) [v]\n",
  "PIGHTING": "PIGHT, to pitch (e.g. a tent) [v]\n",
  "PIGHTLE": "a croft or small enclosure [n -S]\n",
  "PIGHTLES": "PIGHTLE, a croft or small enclosure [n]\n",
  "PIGHTS": "PIGHT, to pitch (e.g. a tent) [v]\n",
  "PIGLET": "a little pig, also PIGLING [n -S]\n",
  "PIGLETS": "PIGLET, a little pig, also PIGLING [n]\n",
  "PIGLIKE": "resembling a pig [adj]\n",
  "PIGLING": "a little pig, also PIGLET [n -S]\n",
  "PIGLINGS": "PIGLING, a little pig, also PIGLET [n]\n",
  "PIGMAEAN": "pygmy-like, also PIGMEAN, PYGMAEAN, PYGMEAN [adj]\n",
  "PIGMAN": "a male pig farmer [n PIGMEN]\n",
  "PIGMEAN": "pygmy-like, also PIGMAEAN, PYGMAEAN, PYGMEAN [adj]\n",
  "PIGMEAT": "the meat of the pig [n -S]\n",
  "PIGMEATS": "PIGMEAT, the meat of the pig [n]\n",
  "PIGMEN": "PIGMAN, a male pig farmer [n]\n",
  "PIGMENT": "to add a colouring matter to [v -ED, -ING, -S]\n",
  "PIGMENTAL": "of or pertaining to pigments [adj]\n",
  "PIGMENTARY": "of or pertaining to pigments [adj]\n",
  "PIGMENTATION": "coloration with or deposition of pigment [n -S]\n",
  "PIGMENTATIONS": "PIGMENTATION, coloration with or deposition of pigment [n]\n",
  "PIGMENTED": "PIGMENT, to add a colouring matter to [v]\n",
  "PIGMENTING": "PIGMENT, to add a colouring matter to [v]\n",
  "PIGMENTOSA": "as in retinite pigmentosa, a genetic eye condition [n -S]\n",
  "PIGMENTOSAS": "PIGMENTOSA, as in retinite pigmentosa, a genetic eye condition [n]\n",
  "PIGMENTS": "PIGMENT, to add a colouring matter to [v]\n",
  "PIGMIES": "PIGMY, a small person, also PYGMY [n]\n",
  "PIGMOID": "a pigmy [n -S]\n",
  "PIGMOIDS": "PIGMOID, a pigmy [n]\n",
  "PIGMY": "a small person, also PYGMY [n PIGMIES]\n",
  "PIGNERATE": "(archaic) to pledge or pawn, also PIGNORATE [v PIGNERATED, PIGNERATING, PIGNERATES]\n",
  "PIGNERATED": "PIGNERATE, (archaic) to pledge or pawn, also PIGNORATE [v]\n",
  "PIGNERATES": "PIGNERATE, (archaic) to pledge or pawn, also PIGNORATE [v]\n",
  "PIGNERATING": "PIGNERATE, (archaic) to pledge or pawn, also PIGNORATE [v]\n",
  "PIGNERATION": "the act or process of pledging or pawning, also PIGNORATION [n -S]\n",
  "PIGNERATIONS": "PIGNERATION, the act or process of pledging or pawning, also PIGNORATION [n]\n",
  "PIGNOLI": "(Italian) the edible seed of nut pines, also PIGNOLIA [n -S]\n",
  "PIGNOLIA": "(Italian) the edible seed of nut pines, also PIGNOLI [n -S]\n",
  "PIGNOLIAS": "PIGNOLIA, (Italian) the edible seed of nut pines, also PIGNOLI [n]\n",
  "PIGNOLIS": "PIGNOLI, (Italian) the edible seed of nut pines, also PIGNOLIA [n]\n",
  "PIGNORA": "PIGNUS, (Latin) property held as security for a debt [n]\n",
  "PIGNORATE": "(archaic) to pledge or pawn, also PIGNERATE [v PIGNORATED, PIGNORATING, PIGNORATES]\n",
  "PIGNORATED": "PIGNORATE, (archaic) to pledge or pawn, also PIGNERATE [v]\n",
  "PIGNORATES": "PIGNORATE, (archaic) to pledge or pawn, also PIGNERATE [v]\n",
  "PIGNORATING": "PIGNORATE, (archaic) to pledge or pawn, also PIGNERATE [v]\n",
  "PIGNORATION": "the act of pignorating, giving in pledge or pawn, also PIGNERATION [n -S]\n",
  "PIGNORATIONS": "PIGNORATION, the act of pignorating, giving in pledge or pawn, also PIGNERATION [n]\n",
  "PIGNUS": "(Latin) property held as security for a debt [n PIGNORA]\n",
  "PIGNUT": "an umbelliferous plant, aka earthnut [n -S]\n",
  "PIGNUTS": "PIGNUT, an umbelliferous plant, aka earthnut [n]\n",
  "PIGOUT": "(colloquial) an instance of eating to excess [n -S]\n",
  "PIGOUTS": "PIGOUT, (colloquial) an instance of eating to excess [n]\n",
  "PIGPEN": "a place where pigs are kept [n -S]\n",
  "PIGPENS": "PIGPEN, a place where pigs are kept [n]\n",
  "PIGS": "PIG, to give birth to cloven-hoofed mammals [v]\n",
  "PIGSCONCE": "a blockhead [n -S]\n",
  "PIGSCONCES": "PIGSCONCE, a blockhead [n]\n",
  "PIGSKIN": "the skin of a pig [n -S]\n",
  "PIGSKINS": "PIGSKIN, the skin of a pig [n]\n",
  "PIGSNEY": "(archaic) a term of endearment to a woman, also PIGSNIE, PIGSNY [n -S]\n",
  "PIGSNEYS": "PIGSNEY, (archaic) a term of endearment to a woman, also PIGSNIE, PIGSNY [n]\n",
  "PIGSNIE": "(archaic) a term of endearment to a woman, also PIGSNEY, PIGSNY [n -S]\n",
  "PIGSNIES": "PIGSNIE, (archaic) a term of endearment to a woman, also PIGSNEY, PIGSNY [n]\n",
  "PIGSNY": "(archaic) a term of endearment to a woman, also PIGSNEY, PIGSNIE [n PIGSNIES]\n",
  "PIGSTICK": "to hunt for wild boar [v PIGSTUCK or PIGSTICKED, PIGSTICKING, PIGSTICKS]\n",
  "PIGSTICKED": "PIGSTICK, to hunt for wild boar [v]\n",
  "PIGSTICKER": "one who sticks pigs [n -S]\n",
  "PIGSTICKERS": "PIGSTICKER, one who sticks pigs [n]\n",
  "PIGSTICKING": "the act of hunting for wild boar [n -S]\n",
  "PIGSTICKINGS": "PIGSTICKING, the act of hunting for wild boar [n]\n",
  "PIGSTICKS": "PIGSTICK, to hunt for wild boar [v]\n",
  "PIGSTIES": "PIGSTY, a place where pigs are kept [n]\n",
  "PIGSTUCK": "PIGSTICK, to hunt for wild boar [v]\n",
  "PIGSTY": "a place where pigs are kept [n PIGSTIES]\n",
  "PIGSWILL": "waste fed to pigs, also PIGWASH [n -S]\n",
  "PIGSWILLS": "PIGSWILL, waste fed to pigs, also PIGWASH [n]\n",
  "PIGTAIL": "a single plait hanging down at the back of the head [n -S]\n",
  "PIGTAILED": "having a pigtail [adj]\n",
  "PIGTAILS": "PIGTAIL, a single plait hanging down at the back of the head [n]\n",
  "PIGWASH": "waste fed to pigs, also PIGSWILL [n -ES]\n",
  "PIGWASHES": "PIGWASH, waste fed to pigs, also PIGSWILL [n]\n",
  "PIGWEED": "a weedy plant [n -S]\n",
  "PIGWEEDS": "PIGWEED, a weedy plant [n]\n",
  "PIHOIHOI": "(Maori) a variety of New Zealand pipit [n -S]\n",
  "PIHOIHOIS": "PIHOIHOI, (Maori) a variety of New Zealand pipit [n]\n",
  "PIING": "PI, to mix type indiscriminately [v]\n",
  "PIKA": "any of various small harelike mammals of western North America and central Asia [n -S]\n",
  "PIKAKE": "(Hawaiian) a Hawaiian shrub with small, white, very fragrant flowers [n -S]\n",
  "PIKAKES": "PIKAKE, (Hawaiian) a Hawaiian shrub with small, white, very fragrant flowers [n]\n",
  "PIKAS": "PIKA, any of various small harelike mammals of western North America and central Asia [n]\n",
  "PIKAU": "(Maori) a rucksack [n -S]\n",
  "PIKAUS": "PIKAU, (Maori) a rucksack [n]\n",
  "PIKE": "to pierce with a long spear [v PIKED, PIKING, PIKES]\n",
  "PIKED": "PIKE, to pierce with a long spear [v]\n",
  "PIKELET": "(Welsh) a kind of thin crumpet [n -S]\n",
  "PIKELETS": "PIKELET, (Welsh) a kind of thin crumpet [n]\n",
  "PIKELIKE": "like a pike [adj]\n",
  "PIKEMAN": "a soldier armed with a pike [n PIKEMEN]\n",
  "PIKEMEN": "PIKEMAN, a soldier armed with a pike [n]\n",
  "PIKEPERCH": "a pike-like freshwater fish [n -ES]\n",
  "PIKEPERCHES": "PIKEPERCH, a pike-like freshwater fish [n]\n",
  "PIKER": "a stingy person, a cautious gambler, or one who does things in a small way [n -S]\n",
  "PIKERS": "PIKER, a stingy person, a cautious gambler, or one who does things in a small way [n]\n",
  "PIKES": "PIKE, to pierce with a long spear [v]\n",
  "PIKESTAFF": "the staff, or shaft, of a pike [n PIKESTAFFS or PIKESTAVES]\n",
  "PIKESTAFFS": "PIKESTAFF, the staff, or shaft, of a pike [n]\n",
  "PIKESTAVES": "PIKESTAFF, the staff, or shaft, of a pike [n]\n",
  "PIKEY": "a derogatory word for a gypsy or vagrant [n -S]\n",
  "PIKEYS": "PIKEY, a derogatory word for a gypsy or vagrant [n]\n",
  "PIKI": "(Native American) maize-meal bread in the form of very thin sheets, made by the Hopi Indians of the southwestern US [n -S]\n",
  "PIKING": "piercing with a pike [n -S]\n",
  "PIKINGS": "PIKING, piercing with a pike [n]\n",
  "PIKIS": "PIKI, (Native American) maize-meal bread in the form of very thin sheets, made by the Hopi Indians of the southwestern US [n]\n",
  "PIKUL": "(Malay) a Chinese weight, also PICUL [n -S]\n",
  "PIKULS": "PIKUL, (Malay) a Chinese weight, also PICUL [n]\n",
  "PILA": "an anatomical structure like a pillar in form [n PILAE]\n",
  "PILAE": "PILA, an anatomical structure like a pillar in form [n]\n",
  "PILAF": "(Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAW, PILOW, PILLAU, PULAO [n -S]\n",
  "PILAFF": "(Persian) a dish made from seasoned rice and meat, also PELAU, PILAF, PILAO, PILAU, PILAW, PILLAU, PILOW, PULAO [n -S]\n",
  "PILAFFS": "PILAFF, (Persian) a dish made from seasoned rice and meat, also PELAU, PILAF, PILAO, PILAU, PILAW, PILLAU, PILOW, PULAO [n]\n",
  "PILAFS": "PILAF, (Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAW, PILOW, PILLAU, PULAO [n]\n",
  "PILAO": "(Persian) a dish made from seasoned rice and meat, also PILAU, PILAFF, PILAF, PILAW, PILOW, PILLAU, PULAO [n -S]\n",
  "PILAOS": "PILAO, (Persian) a dish made from seasoned rice and meat, also PILAU, PILAFF, PILAF, PILAW, PILOW, PILLAU, PULAO [n]\n",
  "PILAR": "pertaining to hair [adj]\n",
  "PILASTER": "a square column partially embedded in a wall [n -S]\n",
  "PILASTERED": "furnished with pilasters [adj]\n",
  "PILASTERS": "PILASTER, a square column partially embedded in a wall [n]\n",
  "PILAU": "(Persian) a dish of rice, also PELAU, PILAF, PILAFF, PILAO, PILAW, PILLAU, PILOW, PULAO [n -S]\n",
  "PILAUS": "PILAU, (Persian) a dish of rice, also PELAU, PILAF, PILAFF, PILAO, PILAW, PILLAU, PILOW, PULAO [n]\n",
  "PILAW": "(Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILOW, PILLAU, PULAO [n -S]\n",
  "PILAWS": "PILAW, (Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILOW, PILLAU, PULAO [n]\n",
  "PILCH": "(archaic) a gown or case of skin, or one trimmed or lined with fur [n -ES]\n",
  "PILCHARD": "a small marine fish [n -S]\n",
  "PILCHARDS": "PILCHARD, a small marine fish [n]\n",
  "PILCHER": "(Shakespeare) a scabbard [n -S]\n",
  "PILCHERS": "PILCHER, (Shakespeare) a scabbard [n]\n",
  "PILCHES": "PILCH, (archaic) a gown or case of skin, or one trimmed or lined with fur [n]\n",
  "PILCORN": "the naked oat, a variety in which the glume does not adhere to the grain [n -S]\n",
  "PILCORNS": "PILCORN, the naked oat, a variety in which the glume does not adhere to the grain [n]\n",
  "PILCROW": "a paragraph-mark [n -S]\n",
  "PILCROWS": "PILCROW, a paragraph-mark [n]\n",
  "PILE": "to lay one upon the other [v PILED, PILING, PILES]\n",
  "PILEA": "the gunpowder plant [n -S]\n",
  "PILEAS": "PILEA, the gunpowder plant [n]\n",
  "PILEATE": "of a mushroom, having a pileus, an umbrella-shaped portion, also PILEATED [adj]\n",
  "PILEATED": "of a mushroom, having a pileus, an umbrella-shaped portion, also PILEATE [adj]\n",
  "PILED": "PILE, to lay one upon the other [v]\n",
  "PILEI": "PILEUS, (Latin) the umbrella-shaped part of a mushroom [n]\n",
  "PILELESS": "without a raised surface of yarn [adj]\n",
  "PILEORHIZA": "a cap of cells which covers the growing extremity of a root, aka rootcap [n -S]\n",
  "PILEORHIZAS": "PILEORHIZA, a cap of cells which covers the growing extremity of a root, aka rootcap [n]\n",
  "PILEOUS": "consisting of, or covered with, hair, also PILOSE, PILOUS [adj]\n",
  "PILER": "one who places things in a pile [n -S]\n",
  "PILERS": "PILER, one who places things in a pile [n]\n",
  "PILES": "PILE, to lay one upon the other [v]\n",
  "PILEUM": "(Latin) the top of a bird's head [n PILEA]\n",
  "PILEUP": "a collision involving several motor vehicles [n -S]\n",
  "PILEUPS": "PILEUP, a collision involving several motor vehicles [n]\n",
  "PILEUS": "(Latin) the umbrella-shaped part of a mushroom [n PILEI]\n",
  "PILEWORK": "foundations made of piles [n -S]\n",
  "PILEWORKS": "PILEWORK, foundations made of piles [n]\n",
  "PILEWORT": "a wild plant, used to treats piles [n -S]\n",
  "PILEWORTS": "PILEWORT, a wild plant, used to treats piles [n]\n",
  "PILFER": "to steal [v -ED, -ING, -S]\n",
  "PILFERABLE": "that can be pilfered [adj]\n",
  "PILFERAGE": "the act of pilfering [n -S]\n",
  "PILFERAGES": "PILFERAGE, the act of pilfering [n]\n",
  "PILFERED": "PILFER, to steal [v]\n",
  "PILFERER": "one who pilfers [n -S]\n",
  "PILFERERS": "PILFERER, one who pilfers [n]\n",
  "PILFERIES": "PILFERY, petty theft [n]\n",
  "PILFERING": "petty theft [n -S]\n",
  "PILFERINGLY": "PILFERING [adv]\n",
  "PILFERINGS": "PILFERING, petty theft [n]\n",
  "PILFERPROOF": "secure against pilfering [adj]\n",
  "PILFERS": "PILFER, to steal [v]\n",
  "PILFERY": "petty theft [n PILFERIES]\n",
  "PILGARLIC": "a bald person; a person looked upon with humorous contempt or mock pity, also PEELGARLIC, PILGARLICK [n -S]\n",
  "PILGARLICK": "a bald person; a person looked upon with humorous contempt or mock pity, also PEELGARLIC, PILGARLIC [n -S]\n",
  "PILGARLICKS": "PILGARLICK, a bald person; a person looked upon with humorous contempt or mock pity, also PEELGARLIC, PILGARLIC [n]\n",
  "PILGARLICKY": "like a pilgarlick, a bald person; a person looked upon with humorous contempt or mock pity [adj]\n",
  "PILGARLICS": "PILGARLIC, a bald person; a person looked upon with humorous contempt or mock pity, also PEELGARLIC, PILGARLICK [n]\n",
  "PILGRIM": "someone who goes on a pilgrimage, also PILGRIMAGER, PILGRIMER [n -S] / to travel to a holy place for religious purposes, also PILGRIMAGE [v -ED, -ING, -S]\n",
  "PILGRIMAGE": "a journey to a shrine or other holy place [n -S] / to go on pilgrimage [v PILGRIMAGED, PILGRIMAGING, PILGRIMAGES]\n",
  "PILGRIMAGED": "PILGRIMAGE, to go on pilgrimage [v]\n",
  "PILGRIMAGER": "one who goes on a pilgrimage, also PILGRIM, PILGRIMER [n -S]\n",
  "PILGRIMAGERS": "PILGRIMAGER, one who goes on a pilgrimage, also PILGRIM, PILGRIMER [n]\n",
  "PILGRIMAGES": "PILGRIMAGE, to go on pilgrimage [v]\n",
  "PILGRIMAGING": "PILGRIMAGE, to go on pilgrimage [v]\n",
  "PILGRIMED": "PILGRIM, to travel to a holy place for religious purposes, also PILGRIMAGE [v]\n",
  "PILGRIMER": "someone who goes on a pilgrimage, also PILGRIM, PILGRIMAGER [n -S]\n",
  "PILGRIMERS": "PILGRIMER, someone who goes on a pilgrimage, also PILGRIM, PILGRIMAGER [n]\n",
  "PILGRIMING": "PILGRIM, to travel to a holy place for religious purposes, also PILGRIMAGE [v]\n",
  "PILGRIMISE": "to go on pilgrimage, also PILGRIMIZE [v PILGRIMISED, PILGRIMISING, PILGRIMISES]\n",
  "PILGRIMISED": "PILGRIMISE, to go on pilgrimage, also PILGRIMIZE [v]\n",
  "PILGRIMISES": "PILGRIMISE, to go on pilgrimage, also PILGRIMIZE [v]\n",
  "PILGRIMISING": "PILGRIMISE, to go on pilgrimage, also PILGRIMIZE [v]\n",
  "PILGRIMIZE": "to go on pilgrimage, also PILGRIMISE [v PILGRIMIZED, PILGRIMIZING, PILGRIMIZES]\n",
  "PILGRIMIZED": "PILGRIMIZE, to go on pilgrimage, also PILGRIMISE [v]\n",
  "PILGRIMIZES": "PILGRIMIZE, to go on pilgrimage, also PILGRIMISE [v]\n",
  "PILGRIMIZING": "PILGRIMIZE, to go on pilgrimage, also PILGRIMISE [v]\n",
  "PILGRIMS": "PILGRIM, someone who goes on a pilgrimage, also PILGRIMAGER, PILGRIMER [n]\n",
  "PILI": "(Tagalog) the nut of trees of the burseraceous genus, also PILINUT [n -S]\n",
  "PILIER": "PILY, of carpets, having a pile [adj]\n",
  "PILIEST": "PILY, of carpets, having a pile [adj]\n",
  "PILIFEROUS": "bearing or growing hair [adj]\n",
  "PILIFORM": "resembling a hair [adj]\n",
  "PILING": "a structure of building supports [n -S]\n",
  "PILINGS": "PILING, a structure of building supports [n]\n",
  "PILINUT": "the nut of trees of the burseraceous genus, also PILI [n -S]\n",
  "PILINUTS": "PILINUT, the nut of trees of the burseraceous genus, also PILI [n]\n",
  "PILIS": "PILI, (Tagalog) the nut of trees of the burseraceous genus, also PILINUT [n]\n",
  "PILL": "to administer small, rounded balls of medicine [v -ED, -ING, -S]\n",
  "PILLAGE": "to plunder [v PILLAGED, PILLAGING, PILLAGES]\n",
  "PILLAGED": "PILLAGE, to plunder [v]\n",
  "PILLAGER": "one who pillages [n -S]\n",
  "PILLAGERS": "PILLAGER, one who pillages [n]\n",
  "PILLAGES": "PILLAGE, to plunder [v]\n",
  "PILLAGING": "the act of plundering [n -S]\n",
  "PILLAGINGS": "PILLAGING, the act of plundering [n]\n",
  "PILLAR": "to supply with vertical building supports [v -ED, -ING, -S]\n",
  "PILLARED": "PILLAR, to supply with vertical building supports [v]\n",
  "PILLARING": "PILLAR, to supply with vertical building supports [v]\n",
  "PILLARIST": "an ascetic living on top of a pillar, a stylite [n -S]\n",
  "PILLARISTS": "PILLARIST, an ascetic living on top of a pillar, a stylite [n]\n",
  "PILLARLESS": "without pillars [adj]\n",
  "PILLARS": "PILLAR, to supply with vertical building supports [v]\n",
  "PILLAU": "(Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILAW, PILOW, PULAO [n -S]\n",
  "PILLAUS": "PILLAU, (Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILAW, PILOW, PULAO [n]\n",
  "PILLBOX": "a small box for pills [n -ES]\n",
  "PILLBOXES": "PILLBOX, a small box for pills [n]\n",
  "PILLBUG": "a wood louse that can roll itself into a ball [n -S]\n",
  "PILLBUGS": "PILLBUG, a wood louse that can roll itself into a ball [n]\n",
  "PILLED": "PILL, to administer small, rounded balls of medicine [v]\n",
  "PILLHEAD": "a regular, usually addicted taker of sedative or stimulant pills [n -S]\n",
  "PILLHEADS": "PILLHEAD, a regular, usually addicted taker of sedative or stimulant pills [n]\n",
  "PILLICOCK": "(old slang) the penis [n -S]\n",
  "PILLICOCKS": "PILLICOCK, (old slang) the penis [n]\n",
  "PILLIE": "(Australian slang) a pilchard [n -S]\n",
  "PILLIES": "PILLIE, (Australian slang) a pilchard [n]\n",
  "PILLING": "formation of little balls on fabric through rubbing [n -S]\n",
  "PILLINGS": "PILLING, formation of little balls on fabric through rubbing [n]\n",
  "PILLION": "to sit on a pillion (a passenger seat) [v -ED, -ING, -S]\n",
  "PILLIONED": "PILLION, to sit on a pillion (a passenger seat) [v]\n",
  "PILLIONING": "PILLION, to sit on a pillion (a passenger seat) [v]\n",
  "PILLIONIST": "one who rides pillion [n -S]\n",
  "PILLIONISTS": "PILLIONIST, one who rides pillion [n]\n",
  "PILLIONS": "PILLION, to sit on a pillion (a passenger seat) [v]\n",
  "PILLIWINKS": "an instrument of torture designed to crush fingers, also PILNIEWINKS, PINNIEWINKLE, PINNYWINKLE [n]\n",
  "PILLOCK": "a stupid person [n -S]\n",
  "PILLOCKS": "PILLOCK, a stupid person [n]\n",
  "PILLORIED": "PILLORY, to hold up to public ridicule [v]\n",
  "PILLORIES": "PILLORY, to hold up to public ridicule [v]\n",
  "PILLORISE": "to pillory, also PILLORIZE [v PILLORISED, PILLORISING, PILLORISES]\n",
  "PILLORISED": "PILLORISE, to pillory, also PILLORIZE [v]\n",
  "PILLORISES": "PILLORISE, to pillory, also PILLORIZE [v]\n",
  "PILLORISING": "PILLORISE, to pillory, also PILLORIZE [v]\n",
  "PILLORIZE": "to pillory, also PILLORISE [v PILLORIZED, PILLORIZING, PILLORIZES]\n",
  "PILLORIZED": "PILLORIZE, to pillory, also PILLORISE [v]\n",
  "PILLORIZES": "PILLORIZE, to pillory, also PILLORISE [v]\n",
  "PILLORIZING": "PILLORIZE, to pillory, also PILLORISE [v]\n",
  "PILLORY": "to hold up to public ridicule [v PILLORIED, PILLORYING, PILLORIES]\n",
  "PILLORYING": "PILLORY, to hold up to public ridicule [v]\n",
  "PILLOW": "to rest on a cushion for the head [v -ED, -ING, -S]\n",
  "PILLOWCASE": "a removable covering for a pillow [n -S]\n",
  "PILLOWCASES": "PILLOWCASE, a removable covering for a pillow [n]\n",
  "PILLOWED": "PILLOW, to rest on a cushion for the head [v]\n",
  "PILLOWIER": "PILLOWY, like a pillow in form or feel [adj]\n",
  "PILLOWIEST": "PILLOWY, like a pillow in form or feel [adj]\n",
  "PILLOWING": "PILLOW, to rest on a cushion for the head [v]\n",
  "PILLOWS": "PILLOW, to rest on a cushion for the head [v]\n",
  "PILLOWSLIP": "a cover for a pillow [n -S]\n",
  "PILLOWSLIPS": "PILLOWSLIP, a cover for a pillow [n]\n",
  "PILLOWY": "like a pillow in form or feel [adj PILLOWIER, PILLOWIEST]\n",
  "PILLS": "PILL, to administer small, rounded balls of medicine [v]\n",
  "PILLWORM": "a type of millipede [n -S]\n",
  "PILLWORMS": "PILLWORM, a type of millipede [n]\n",
  "PILLWORT": "a water-fern [n -S]\n",
  "PILLWORTS": "PILLWORT, a water-fern [n]\n",
  "PILNIEWINKS": "an instrument of torture designed to crush fingers, also PILLIWINKS, PINNIEWINKLE, PINNYWINKLE [n]\n",
  "PILOCARPIN": "an alkaloid obtained from jaborandi leaves, also PILOCARPINE [n -S]\n",
  "PILOCARPINE": "an alkaloid obtained from jaborandi leaves, also PILOCARPIN [n -S]\n",
  "PILOCARPINES": "PILOCARPINE, an alkaloid obtained from jaborandi leaves, also PILOCARPIN [n]\n",
  "PILOCARPINS": "PILOCARPIN, an alkaloid obtained from jaborandi leaves, also PILOCARPINE [n]\n",
  "PILOMOTOR": "causing movement of hairs, as in pilomotor nerves [adj]\n",
  "PILONIDAL": "relating to the crease above the buttocks [adj]\n",
  "PILOSE": "having scattered soft or moderately stiff hairs, also PILEOUS, PILOUS [adj]\n",
  "PILOSITIES": "PILOSITY, the state of being pilose; hairiness [n]\n",
  "PILOSITY": "the state of being pilose; hairiness [n PILOSITIES]\n",
  "PILOT": "to control the course of [v -ED, -ING, -S]\n",
  "PILOTAGE": "the act of piloting [n -S]\n",
  "PILOTAGES": "PILOTAGE, the act of piloting [n]\n",
  "PILOTED": "PILOT, to control the course of [v]\n",
  "PILOTFISH": "a tropical fish [n -ES]\n",
  "PILOTFISHES": "PILOTFISH, a tropical fish [n]\n",
  "PILOTHOUSE": "a shelter for steering gear and pilot [n -S]\n",
  "PILOTHOUSES": "PILOTHOUSE, a shelter for steering gear and pilot [n]\n",
  "PILOTING": "a branch of navigation [n -S]\n",
  "PILOTINGS": "PILOTING, a branch of navigation [n]\n",
  "PILOTIS": "(French) a series of columns or piles, used to raise the base of a building above ground level [n PILOTIS]\n",
  "PILOTLESS": "without a pilot [adj]\n",
  "PILOTMAN": "a railway employee assigned to guide trains [n PILOTMEN]\n",
  "PILOTMEN": "PILOTMAN, a railway employee assigned to guide trains [n]\n",
  "PILOTS": "PILOT, to control the course of [v]\n",
  "PILOUS": "having scattered soft or moderately stiff hairs, also PILEOUS, PILOSE [adj]\n",
  "PILOW": "(Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILAW, PILLAU, PULAO [n -S]\n",
  "PILOWS": "PILOW, (Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILAW, PILLAU, PULAO [n]\n",
  "PILSENER": "(German) a light-coloured flavoursome variety of lager, also PILSNER [n -S]\n",
  "PILSENERS": "PILSENER, (German) a light-coloured flavoursome variety of lager, also PILSNER [n]\n",
  "PILSNER": "(German) a light-coloured flavoursome variety of lager, also PILSENER [n -S]\n",
  "PILSNERS": "PILSNER, (German) a light-coloured flavoursome variety of lager, also PILSENER [n]\n",
  "PILULA": "(Latin) a small pill, also PILULE [n PILULAS or PILULAE]\n",
  "PILULAE": "PILULA, (Latin) a small pill, also PILULE [n]\n",
  "PILULAR": "like a pilule, a small pill [adj]\n",
  "PILULAS": "PILULA, (Latin) a small pill, also PILULE [n]\n",
  "PILULE": "a small pill, also PILULA [n -S]\n",
  "PILULES": "PILULE, a small pill, also PILULA [n]\n",
  "PILUM": "(Latin) a heavy Roman javelin [n PILA]\n",
  "PILUS": "(Latin) a hair or hairlike structure [n PILI]\n",
  "PILY": "of carpets, having a pile [adj PILIER, PILIEST]\n",
  "PIMA": "a strong, high-grade cotton [n -S]\n",
  "PIMAS": "PIMA, a strong, high-grade cotton [n]\n",
  "PIMENT": "spiced, sweetened wine [n -S]\n",
  "PIMENTO": "(Spanish) allspice or Jamaica pepper, the dried unripe fruits of a West Indian tree [n -S]\n",
  "PIMENTON": "smoked chilli powder [n -S]\n",
  "PIMENTONS": "PIMENTON, smoked chilli powder [n]\n",
  "PIMENTOS": "PIMENTO, (Spanish) allspice or Jamaica pepper, the dried unripe fruits of a West Indian tree [n]\n",
  "PIMENTS": "PIMENT, spiced, sweetened wine [n]\n",
  "PIMIENTO": "(Spanish) the sweet red, yellow or green pepper, capsicum [n -S]\n",
  "PIMIENTOS": "PIMIENTO, (Spanish) the sweet red, yellow or green pepper, capsicum [n]\n",
  "PIMP": "one who controls a prostitute or prostitute [n -S] / to solicit clients for a prostitute [v -ED, -ING, -S]\n",
  "PIMPED": "PIMP, to solicit clients for a prostitute [v]\n",
  "PIMPERNEL": "a small red flower of waste ground [n -S]\n",
  "PIMPERNELS": "PIMPERNEL, a small red flower of waste ground [n]\n",
  "PIMPING": "the business of soliciting clients for a prostitute [n -S]\n",
  "PIMPINGS": "PIMPING, the business of soliciting clients for a prostitute [n]\n",
  "PIMPLE": "an inflamed swelling of the skin [n -S]\n",
  "PIMPLED": "having pimples [adj]\n",
  "PIMPLES": "PIMPLE, an inflamed swelling of the skin [n]\n",
  "PIMPLIER": "PIMPLY, covered with pimples [adj]\n",
  "PIMPLIEST": "PIMPLY, covered with pimples [adj]\n",
  "PIMPLINESS": "the state of being pimply [n -ES]\n",
  "PIMPLINESSES": "PIMPLINESS, the state of being pimply [n]\n",
  "PIMPLY": "covered with pimples [adj PIMPLIER, PIMPLIEST]\n",
  "PIMPMOBILE": "a car used by a pimp [n -S]\n",
  "PIMPMOBILES": "PIMPMOBILE, a car used by a pimp [n]\n",
  "PIMPS": "PIMP, to solicit clients for a prostitute [v]\n",
  "PIN": "a piece of wood or metal used for fastening [n -S] / to fasten with a pin [v PINNED, PINNING, PINS]\n",
  "PINA": "a fine cloth woven of pineapple fibre [n -S]\n",
  "PINACEOUS": "relating to the Pinaceae, a family of conifers including pines, firs, spruces and larch [adj]\n",
  "PINACOID": "a type of crystal face, also PINAKOID [n -S]\n",
  "PINACOIDAL": "denoting a type of crystal face, also PINAKOIDAL [adj]\n",
  "PINACOIDS": "PINACOID, a type of crystal face, also PINAKOID [n]\n",
  "PINACOTHECA": "a picture-gallery [n PINACOTHECAE]\n",
  "PINACOTHECAE": "PINACOTHECA, a picture-gallery [n]\n",
  "PINAFORE": "a loose protective garment worn over a dress [n -S]\n",
  "PINAFORED": "wearing a pinafore [adj]\n",
  "PINAFORES": "PINAFORE, a loose protective garment worn over a dress [n]\n",
  "PINAKOID": "a type of crystal face, also PINACOID [n -S]\n",
  "PINAKOIDAL": "denoting a type of crystal face, also PINACOIDAL [adj]\n",
  "PINAKOIDS": "PINAKOID, a type of crystal face, also PINACOID [n]\n",
  "PINAKOTHEK": "(German) a picture gallery [n -S]\n",
  "PINAKOTHEKS": "PINAKOTHEK, (German) a picture gallery [n]\n",
  "PINANG": "(Malay) a palm tree [n -S]\n",
  "PINANGS": "PINANG, (Malay) a palm tree [n]\n",
  "PINAS": "PINA, a fine cloth woven of pineapple fibre [n]\n",
  "PINASTER": "a species of pine growing in Southern Europe [n -S]\n",
  "PINASTERS": "PINASTER, a species of pine growing in Southern Europe [n]\n",
  "PINATA": "(Spanish) a hollow pottery figure filled with sweets etc. and hung from the ceiling, at a Christmas or other party in Latin America [n -S]\n",
  "PINATAS": "PINATA, (Spanish) a hollow pottery figure filled with sweets etc. and hung from the ceiling, at a Christmas or other party in Latin America [n]\n",
  "PINBALL": "an electric game [n -S] / to bounce around like a pinball [v -ED, -ING, -S]\n",
  "PINBALLED": "PINBALL, to bounce around like a pinball [v]\n",
  "PINBALLING": "PINBALL, to bounce around like a pinball [v]\n",
  "PINBALLS": "PINBALL, to bounce around like a pinball [v]\n",
  "PINBOARD": "a board for pinning notices, pictures, etc. on [n -S]\n",
  "PINBOARDS": "PINBOARD, a board for pinning notices, pictures, etc. on [n]\n",
  "PINBONE": "the hipbone [n -S]\n",
  "PINBONES": "PINBONE, the hipbone [n]\n",
  "PINCASE": "a case for pins [n -S]\n",
  "PINCASES": "PINCASE, a case for pins [n]\n",
  "PINCER": "one of the two pivoted parts of a grasping tool [n -S] / to grip in pincers [v -ED, -ING, -S]\n",
  "PINCERED": "PINCER, to grip in pincers [v]\n",
  "PINCERING": "PINCER, to grip in pincers [v]\n",
  "PINCERLIKE": "like a pincer [adj]\n",
  "PINCERS": "PINCER, to grip in pincers [v]\n",
  "PINCH": "to squeeze between two surfaces [v -ED, -ING, -ES]\n",
  "PINCHBECK": "spurious; trashy [adj] / a gold-like alloy of copper and zinc; tawdry jewellery [n -S]\n",
  "PINCHBECKS": "PINCHBECK, a gold-like alloy of copper and zinc; tawdry jewellery [n]\n",
  "PINCHBUG": "a large beetle [n -S]\n",
  "PINCHBUGS": "PINCHBUG, a large beetle [n]\n",
  "PINCHCOCK": "a clamp on a flexible pipe to regulate the flow of a fluid through the pipe [n -S]\n",
  "PINCHCOCKS": "PINCHCOCK, a clamp on a flexible pipe to regulate the flow of a fluid through the pipe [n]\n",
  "PINCHCOMMONS": "a niggard with food [n -ES]\n",
  "PINCHCOMMONSES": "PINCHCOMMONS, a niggard with food [n]\n",
  "PINCHECK": "a fabric design [n -S]\n",
  "PINCHECKS": "PINCHECK, a fabric design [n]\n",
  "PINCHED": "PINCH, to squeeze between two surfaces [v]\n",
  "PINCHER": "one who pinches [n -S]\n",
  "PINCHERS": "PINCHER, one who pinches [n]\n",
  "PINCHES": "PINCH, to squeeze between two surfaces [v]\n",
  "PINCHFIST": "a closefisted person; a miser [n -S]\n",
  "PINCHFISTS": "PINCHFIST, a closefisted person; a miser [n]\n",
  "PINCHGUT": "a niggard [n -S]\n",
  "PINCHGUTS": "PINCHGUT, a niggard [n]\n",
  "PINCHING": "nipping [adj PINCHINGLY] / the act of pinching [n -S]\n",
  "PINCHINGLY": "PINCHING, nipping [adv]\n",
  "PINCHINGS": "PINCHING, the act of pinching [n]\n",
  "PINCHPENNIES": "PINCHPENNY, a miserly person [n]\n",
  "PINCHPENNY": "a miserly person [n PINCHPENNIES]\n",
  "PINCHPOINT": "a constricted or awkward point, esp. in traffic [n -S]\n",
  "PINCHPOINTS": "PINCHPOINT, a constricted or awkward point, esp. in traffic [n]\n",
  "PINCURL": "a curl held in place by a hairpin [n -S]\n",
  "PINCURLS": "PINCURL, a curl held in place by a hairpin [n]\n",
  "PINCUSHION": "a small cushion in which pins may be stuck ready for use [n -S]\n",
  "PINCUSHIONS": "PINCUSHION, a small cushion in which pins may be stuck ready for use [n]\n",
  "PINDAN": "(Native Australian) a desert region of Western Australia [n -S]\n",
  "PINDANS": "PINDAN, (Native Australian) a desert region of Western Australia [n]\n",
  "PINDAREE": "(Hindi) an Indian mercenary, also PINDARI [n -S]\n",
  "PINDAREES": "PINDAREE, (Hindi) an Indian mercenary, also PINDARI [n]\n",
  "PINDARI": "(Hindi) an Indian mercenary, also PINDAREE [n -S]\n",
  "PINDARIS": "PINDARI, (Hindi) an Indian mercenary, also PINDAREE [n]\n",
  "PINDER": "one who impounds cattle, also PINNER [n -S]\n",
  "PINDERS": "PINDER, one who impounds cattle, also PINNER [n]\n",
  "PINDLING": "puny or sickly [adj]\n",
  "PINDOWN": "a technique for controlling disruptive children in institutions [n -S]\n",
  "PINDOWNS": "PINDOWN, a technique for controlling disruptive children in institutions [n]\n",
  "PINE": "to languish with longing, also PYNE [v PINED, PINING, PINES]\n",
  "PINEAL": "a gland in the brain [n -S]\n",
  "PINEALECTOMIES": "PINEALECTOMY, the surgical removal of the pineal gland [n]\n",
  "PINEALECTOMISE": "to remove the pineal gland, also PINEALECTOMIZE [v PINEALECTOMISED, PINEALECTOMISES]\n",
  "PINEALECTOMISED": "PINEALECTOMISE, to remove the pineal gland, also PINEALECTOMIZE [v]\n",
  "PINEALECTOMISES": "PINEALECTOMISE, to remove the pineal gland, also PINEALECTOMIZE [v]\n",
  "PINEALECTOMIZE": "to remove the pineal gland, also PINEALECTOMISE [v PINEALECTOMIZED, PINEALECTOMIZES]\n",
  "PINEALECTOMIZED": "PINEALECTOMIZE, to remove the pineal gland, also PINEALECTOMISE [v]\n",
  "PINEALECTOMIZES": "PINEALECTOMIZE, to remove the pineal gland, also PINEALECTOMISE [v]\n",
  "PINEALECTOMY": "the surgical removal of the pineal gland [n PINEALECTOMIES]\n",
  "PINEALS": "PINEAL, a gland in the brain [n]\n",
  "PINEAPPLE": "a large South American multiple fruit with tough spiny skin [n -S]\n",
  "PINEAPPLES": "PINEAPPLE, a large South American multiple fruit with tough spiny skin [n]\n",
  "PINECONE": "a cone-shaped fruit of a pine tree [n -S]\n",
  "PINECONES": "PINECONE, a cone-shaped fruit of a pine tree [n]\n",
  "PINED": "PINE, to languish with longing, also PYNE [v]\n",
  "PINEDROPS": "a reddish herb of the United States, found parasitic on the roots of pine trees [n]\n",
  "PINELAND": "land forested with pine [n -S]\n",
  "PINELANDS": "PINELAND, land forested with pine [n]\n",
  "PINELIKE": "resembling pine [adj]\n",
  "PINENE": "the main constituent of turpentine [n -S]\n",
  "PINENES": "PINENE, the main constituent of turpentine [n]\n",
  "PINERIES": "PINERY, an area where pineapples are grown [n]\n",
  "PINERY": "an area where pineapples are grown [n PINERIES]\n",
  "PINES": "PINE, to languish with longing, also PYNE [v]\n",
  "PINESAP": "a reddish fleshy herb, formerly thought to be parasitic on the roots of pine trees [n -S]\n",
  "PINESAPS": "PINESAP, a reddish fleshy herb, formerly thought to be parasitic on the roots of pine trees [n]\n",
  "PINETA": "PINETUM, (Latin) a plantation of pine trees [n]\n",
  "PINETUM": "(Latin) a plantation of pine trees [n PINETA]\n",
  "PINEWOOD": "the wood of a pine tree [n -S]\n",
  "PINEWOODS": "PINEWOOD, the wood of a pine tree [n]\n",
  "PINEY": "covered with pine trees, also PINY [adj PINIER, PINIEST]\n",
  "PINFALL": "a wrestling fall which pins one's opponent [n -S]\n",
  "PINFALLS": "PINFALL, a wrestling fall which pins one's opponent [n]\n",
  "PINFEATHER": "a feather not fully developed; esp. a rudimentary feather just emerging through the skin [n -S]\n",
  "PINFEATHERS": "PINFEATHER, a feather not fully developed; esp. a rudimentary feather just emerging through the skin [n]\n",
  "PINFISH": "a small marine fish [n -ES]\n",
  "PINFISHES": "PINFISH, a small marine fish [n]\n",
  "PINFOLD": "a place in which stray cattle or domestic animals are confined [n -S] / to impound, also PENFOLD [v -ED, -ING, -S]\n",
  "PINFOLDED": "PINFOLD, to impound, also PENFOLD [v]\n",
  "PINFOLDING": "PINFOLD, to impound, also PENFOLD [v]\n",
  "PINFOLDS": "PINFOLD, to impound, also PENFOLD [v]\n",
  "PING": "to produce a brief, high-pitched sound [v -ED, -ING, -S]\n",
  "PINGED": "PING, to produce a brief, high-pitched sound [v]\n",
  "PINGER": "a device for producing pulses of sound [n -S]\n",
  "PINGERS": "PINGER, a device for producing pulses of sound [n]\n",
  "PINGING": "PING, to produce a brief, high-pitched sound [v]\n",
  "PINGLE": "(Scots) to strive, to struggle with difficulties [v PINGLED, PINGLING, PINGLES]\n",
  "PINGLED": "PINGLE, (Scots) to strive, to struggle with difficulties [v]\n",
  "PINGLER": "one who nibbles at food with little appetite [n -S]\n",
  "PINGLERS": "PINGLER, one who nibbles at food with little appetite [n]\n",
  "PINGLES": "PINGLE, (Scots) to strive, to struggle with difficulties [v]\n",
  "PINGLING": "PINGLE, (Scots) to strive, to struggle with difficulties [v]\n",
  "PINGO": "(Inuit) a cone-shaped mound [n -S or -ES]\n",
  "PINGOES": "PINGO, (Inuit) a cone-shaped mound [n]\n",
  "PINGOS": "PINGO, (Inuit) a cone-shaped mound [n]\n",
  "PINGPONG": "(colloquial) as in aerial pingpong, Australian rules football [n -S]\n",
  "PINGPONGS": "PINGPONG, (colloquial) as in aerial pingpong, Australian rules football [n]\n",
  "PINGRASS": "a European weed [n -ES]\n",
  "PINGRASSES": "PINGRASS, a European weed [n]\n",
  "PINGS": "PING, to produce a brief, high-pitched sound [v]\n",
  "PINGUEFIED": "PINGUEFY, to become or make fat or greasy; to make rich [v]\n",
  "PINGUEFIES": "PINGUEFY, to become or make fat or greasy; to make rich [v]\n",
  "PINGUEFY": "to become or make fat or greasy; to make rich [v PINGUEFIED, PINGUEFYING, PINGUEFIES]\n",
  "PINGUEFYING": "PINGUEFY, to become or make fat or greasy; to make rich [v]\n",
  "PINGUID": "fat; greasy [adj]\n",
  "PINGUIDITIES": "PINGUIDITY, the quality of being pinguid [n]\n",
  "PINGUIDITY": "the quality of being pinguid [n PINGUIDITIES]\n",
  "PINGUIN": "a flightless aquatic bird, also PENGUIN [n -S]\n",
  "PINGUINS": "PINGUIN, a flightless aquatic bird, also PENGUIN [n]\n",
  "PINGUITUDE": "fatness [n -S]\n",
  "PINGUITUDES": "PINGUITUDE, fatness [n]\n",
  "PINHEAD": "the head of a pin [n -S]\n",
  "PINHEADED": "stupid [adj]\n",
  "PINHEADEDNESS": "PINHEADED, stupid [n]\n",
  "PINHEADEDNESSES": "PINHEADEDNESS, PINHEADED, stupid [n]\n",
  "PINHEADS": "PINHEAD, the head of a pin [n]\n",
  "PINHOLE": "a small hole made by a pin [n -S]\n",
  "PINHOLES": "PINHOLE, a small hole made by a pin [n]\n",
  "PINHOOKER": "(slang) a speculator who buys up foals hoping to make a profit on them when selling them as yearlings for racing [n -S]\n",
  "PINHOOKERS": "PINHOOKER, (slang) a speculator who buys up foals hoping to make a profit on them when selling them as yearlings for racing [n]\n",
  "PINIER": "PINY, covered with pine trees, also PINEY [adj]\n",
  "PINIES": "PINY, a showy flower, also PEONY, PAEONY, PIONEY, PIONY [n]\n",
  "PINIEST": "PINY, covered with pine trees, also PINEY [adj]\n",
  "PINING": "PINE, to languish with longing, also PYNE [v]\n",
  "PINION": "to remove the wing feathers to prevent flight [v -ED, -ING, -S]\n",
  "PINIONED": "PINION, to remove the wing feathers to prevent flight [v]\n",
  "PINIONING": "PINION, to remove the wing feathers to prevent flight [v]\n",
  "PINIONS": "PINION, to remove the wing feathers to prevent flight [v]\n",
  "PINITE": "a greyish-green or brown mineral containing amorphous aluminium and potassium sulphates [n -S]\n",
  "PINITES": "PINITE, a greyish-green or brown mineral containing amorphous aluminium and potassium sulphates [n]\n",
  "PINITOL": "an alcohol [n -S]\n",
  "PINITOLS": "PINITOL, an alcohol [n]\n",
  "PINK": "of a pale red colour [adj PINKER, PINKEST, PINKLY] / to cut a saw-toothed edge on cloth [v -ED, -ING, -S]\n",
  "PINKED": "PINK, to cut a saw-toothed edge on cloth [v]\n",
  "PINKEN": "to become pink [v -ED, -ING, -S]\n",
  "PINKENED": "PINKEN, to become pink [v]\n",
  "PINKENING": "PINKEN, to become pink [v]\n",
  "PINKENS": "PINKEN, to become pink [v]\n",
  "PINKER": "a person who cuts or punches designs in cloth, leather, etc. [n -S]\n",
  "PINKERS": "PINKER, a person who cuts or punches designs in cloth, leather, etc. [n]\n",
  "PINKERTON": "a private detective [n -S]\n",
  "PINKERTONS": "PINKERTON, a private detective [n]\n",
  "PINKEST": "PINK, of a pale red colour [adj]\n",
  "PINKEY": "a small narrow-sterned ship [n -S]\n",
  "PINKEYE": "an inflammation of the eye [n -S]\n",
  "PINKEYES": "PINKEYE, an inflammation of the eye [n]\n",
  "PINKEYS": "PINKEY, a small narrow-sterned ship [n]\n",
  "PINKIE": "(Scots) the little finger, also PINKY [n -S]\n",
  "PINKIER": "PINKY, somewhat pink [adj]\n",
  "PINKIES": "PINKY, the little finger, also PINKIE [n]\n",
  "PINKIEST": "PINKY, somewhat pink [adj]\n",
  "PINKINESS": "the state of being pinky [n -ES]\n",
  "PINKINESSES": "PINKINESS, the state of being pinky [n]\n",
  "PINKING": "a method of cutting or decorating [n -S]\n",
  "PINKINGS": "PINKING, a method of cutting or decorating [n]\n",
  "PINKISH": "somewhat pink [adj]\n",
  "PINKISHNESS": "the state of being pinkish [n -ES]\n",
  "PINKISHNESSES": "PINKISHNESS, the state of being pinkish [n]\n",
  "PINKLY": "PINK, of a pale red colour [adv]\n",
  "PINKNESS": "the state of being pink [n -ES]\n",
  "PINKNESSES": "PINKNESS, the state of being pink [n]\n",
  "PINKO": "a person who is something of a socialist but hardly a red [n -ES or -S]\n",
  "PINKOES": "PINKO, a person who is something of a socialist but hardly a red [n]\n",
  "PINKOS": "PINKO, a person who is something of a socialist but hardly a red [n]\n",
  "PINKROOT": "a medicinal plant root, aka wormroot [n -S]\n",
  "PINKROOTS": "PINKROOT, a medicinal plant root, aka wormroot [n]\n",
  "PINKS": "PINK, to cut a saw-toothed edge on cloth [v]\n",
  "PINKY": "somewhat pink [adj PINKIER, PINKIEST] / the little finger, also PINKIE [n PINKIES]\n",
  "PINLESS": "lacking pins [adj]\n",
  "PINNA": "(Latin) a leaflet, wing or feather [n PINNAS or PINNAE]\n",
  "PINNACE": "a small vessel with oars and sails [n -S]\n",
  "PINNACES": "PINNACE, a small vessel with oars and sails [n]\n",
  "PINNACLE": "a slender turret or spiry structure in architecture [n -S] / to equip with a pinnacle [v PINNACLED, PINNACLING, PINNACLES]\n",
  "PINNACLED": "PINNACLE, to equip with a pinnacle [v]\n",
  "PINNACLES": "PINNACLE, to equip with a pinnacle [v]\n",
  "PINNACLING": "PINNACLE, to equip with a pinnacle [v]\n",
  "PINNAE": "PINNA, (Latin) a leaflet, wing or feather [n]\n",
  "PINNAL": "pertaining to a pinna, a projecting feather [adj]\n",
  "PINNAS": "PINNA, (Latin) a leaflet, wing or feather [n]\n",
  "PINNATE": "resembling a feather, also PINNATED [adj PINNATELY]\n",
  "PINNATED": "resembling a feather, also PINNATE [adj]\n",
  "PINNATELY": "PINNATE, resembling a feather, also PINNATED [adv]\n",
  "PINNATIFID": "of leaves, pinnately cut roughly halfway down [adj PINNATIFIDLY]\n",
  "PINNATIFIDLY": "PINNATIFID, of leaves, pinnately cut roughly halfway down [adv]\n",
  "PINNATION": "the state of being pinnate [n -S]\n",
  "PINNATIONS": "PINNATION, the state of being pinnate [n]\n",
  "PINNATIPARTITE": "pinnately lobed half to two thirds the depth of the lamina [adj]\n",
  "PINNATIPED": "having the toes bordered by membranes; fin-footed, as certain birds [adj]\n",
  "PINNATISECT": "pinnately lobed almost to the rachis [adj]\n",
  "PINNED": "PIN, to fasten with a pin [v]\n",
  "PINNER": "one who impounds cattle, also PINDER [n -S]\n",
  "PINNERS": "PINNER, one who impounds cattle, also PINDER [n]\n",
  "PINNET": "a pinnacle [n -S]\n",
  "PINNETS": "PINNET, a pinnacle [n]\n",
  "PINNIE": "(short for) pinafore, also PINNY [n -S]\n",
  "PINNIES": "PINNY, (short for) pinafore, also PINNIE [n]\n",
  "PINNIEWINKLE": "an instrument of torture designed to crush fingers, also PILLIWINKS, PILNIEWINKS, PINNYWINKLE [n -S]\n",
  "PINNIEWINKLES": "PINNIEWINKLE, an instrument of torture designed to crush fingers, also PILLIWINKS, PILNIEWINKS, PINNYWINKLE [n]\n",
  "PINNING": "a fastening [n -S]\n",
  "PINNINGS": "PINNING, a fastening [n]\n",
  "PINNIPED": "a member of the Pinnipeda, seals, walruses, and other such sea mammals, also PINNIPEDE [n -S]\n",
  "PINNIPEDE": "a member of the Pinnipeda, seals, walruses, and other such sea mammals, also PINNIPED [n -S]\n",
  "PINNIPEDES": "PINNIPEDE, a member of the Pinnipeda, seals, walruses, and other such sea mammals, also PINNIPED [n]\n",
  "PINNIPEDIAN": "a pinniped [n -S]\n",
  "PINNIPEDIANS": "PINNIPEDIAN, a pinniped [n]\n",
  "PINNIPEDS": "PINNIPED, a member of the Pinnipeda, seals, walruses, and other such sea mammals, also PINNIPEDE [n]\n",
  "PINNOCK": "the hedge-sparrow [n -S]\n",
  "PINNOCKS": "PINNOCK, the hedge-sparrow [n]\n",
  "PINNOED": "(Spenser) pinioned [adj]\n",
  "PINNULA": "(Latin) a pinnate part or organ, also PINNULE [n PINNULAS or PINNULAE]\n",
  "PINNULAE": "PINNULA, (Latin) a pinnate part or organ, also PINNULE [n]\n",
  "PINNULAR": "relating to a pinnula [adj]\n",
  "PINNULAS": "PINNULA, (Latin) a pinnate part or organ, also PINNULE [n]\n",
  "PINNULATE": "having each pinna subdivided, also PINNULATED [adj]\n",
  "PINNULATED": "having each pinna subdivided, also PINNULATE [adj]\n",
  "PINNULE": "one of the small divisions of a decompound frond or leaf, also PINNULA [n -S]\n",
  "PINNULES": "PINNULE, one of the small divisions of a decompound frond or leaf, also PINNULA [n]\n",
  "PINNY": "(short for) pinafore, also PINNIE [n PINNIES]\n",
  "PINNYWINKLE": "an instrument of torture designed to crush fingers, also PILLIWINKS, PILNIEWINKS, PINNIEWINKLE [n -S]\n",
  "PINNYWINKLES": "PINNYWINKLE, an instrument of torture designed to crush fingers, also PILLIWINKS, PILNIEWINKS, PINNIEWINKLE [n]\n",
  "PINOCHLE": "a card game, also PENUCHLE, PENUCKLE, PINOCLE [n -S]\n",
  "PINOCHLES": "PINOCHLE, a card game, also PENUCHLE, PENUCKLE, PINOCLE [n]\n",
  "PINOCLE": "a card game, also PINOCHLE, PENUCHLE, PENUCKLE [n -S]\n",
  "PINOCLES": "PINOCLE, a card game, also PINOCHLE, PENUCHLE, PENUCKLE [n]\n",
  "PINOCYTIC": "of or relating to pinocytosis, a process by which droplets of liquid are taken into a cell in small vesicles pinched off from the cell membrane [adj]\n",
  "PINOCYTOSES": "PINOCYTOSIS, a process by which droplets of liquid are taken into a cell in small vesicles pinched off from the cell membrane [n]\n",
  "PINOCYTOSIS": "a process by which droplets of liquid are taken into a cell in small vesicles pinched off from the cell membrane [n PINOCYTOSES]\n",
  "PINOCYTOTIC": "relating to pinocytosis, drinking by cells [adj PINOCYTOTICALLY]\n",
  "PINOCYTOTICALLY": "PINOCYTOTIC, relating to pinocytosis, drinking by cells [adv]\n",
  "PINOLE": "(Spanish) an American Indian food consisting of parched ground cereal grains [n -S]\n",
  "PINOLES": "PINOLE, (Spanish) an American Indian food consisting of parched ground cereal grains [n]\n",
  "PINON": "(Spanish) an edible pine seed; the tree bearing it, also PINYON [n PINONS or PINONES]\n",
  "PINONES": "PINON, (Spanish) an edible pine seed; the tree bearing it, also PINYON [n]\n",
  "PINONS": "PINON, (Spanish) an edible pine seed; the tree bearing it, also PINYON [n]\n",
  "PINOT": "(French) a variety of grape; a wine made from this [n -S]\n",
  "PINOTAGE": "a variety of grape grown mainly in South Africa, produced by crossing Pinot with another grape; a red wine made from this grape [n -S]\n",
  "PINOTAGES": "PINOTAGE, a variety of grape grown mainly in South Africa, produced by crossing Pinot with another grape; a red wine made from this grape [n]\n",
  "PINOTS": "PINOT, (French) a variety of grape; a wine made from this [n]\n",
  "PINPOINT": "to locate precisely [v -ED, -ING, -S]\n",
  "PINPOINTED": "PINPOINT, to locate precisely [v]\n",
  "PINPOINTING": "PINPOINT, to locate precisely [v]\n",
  "PINPOINTS": "PINPOINT, to locate precisely [v]\n",
  "PINPRICK": "to puncture with a pin [v -ED, -ING, -S]\n",
  "PINPRICKED": "PINPRICK, to puncture with a pin [v]\n",
  "PINPRICKING": "PINPRICK, to puncture with a pin [v]\n",
  "PINPRICKS": "PINPRICK, to puncture with a pin [v]\n",
  "PINS": "PIN, to fasten with a pin [v]\n",
  "PINSCHER": "(German) a breed of large dog [n -S]\n",
  "PINSCHERS": "PINSCHER, (German) a breed of large dog [n]\n",
  "PINSETTER": "an employee on a mechanical device that spots pins in a bowling alley, also PINSPOTTER [n -S]\n",
  "PINSETTERS": "PINSETTER, an employee on a mechanical device that spots pins in a bowling alley, also PINSPOTTER [n]\n",
  "PINSPOT": "a small powerful spotlight [n -S] / to illuminate with a pinspot [v PINSPOTTED, PINSPOTTING, PINSPOTS]\n",
  "PINSPOTS": "PINSPOT, to illuminate with a pinspot [v]\n",
  "PINSPOTTED": "PINSPOT, to illuminate with a pinspot [v]\n",
  "PINSPOTTER": "an employee on a mechanical device that spots pins in a bowling alley, also PINSETTER [n -S]\n",
  "PINSPOTTERS": "PINSPOTTER, an employee on a mechanical device that spots pins in a bowling alley, also PINSETTER [n]\n",
  "PINSPOTTING": "PINSPOT, to illuminate with a pinspot [v]\n",
  "PINSTRIPE": "a very narrow stripe in cloth [n -S]\n",
  "PINSTRIPED": "having a pinstripe, a very narrow stripe in cloth [adj]\n",
  "PINSTRIPES": "PINSTRIPE, a very narrow stripe in cloth [n]\n",
  "PINSWELL": "(dialect) a small boil [n -S]\n",
  "PINSWELLS": "PINSWELL, (dialect) a small boil [n]\n",
  "PINT": "a measure of capacity equal to half a quart or 4 gills [n -S]\n",
  "PINTA": "(Spanish) a skin disease widespread in tropical America, caused by a spirochaete and characterized by rough blotchy skin [n -S]\n",
  "PINTABLE": "a pinball machine [n -S]\n",
  "PINTABLES": "PINTABLE, a pinball machine [n]\n",
  "PINTADA": "(Portuguese) a kind of petrel; the Cape guinea fowl, also PINTADO [n -S]\n",
  "PINTADAS": "PINTADA, (Portuguese) a kind of petrel; the Cape guinea fowl, also PINTADO [n]\n",
  "PINTADERA": "(Spanish) a decorative stamp, usually made of clay, found in certain Neolithic cultures [n -S]\n",
  "PINTADERAS": "PINTADERA, (Spanish) a decorative stamp, usually made of clay, found in certain Neolithic cultures [n]\n",
  "PINTADO": "(Portuguese) a kind of petrel; the Cape guinea fowl, also PINTADA [n -ES or -S]\n",
  "PINTADOES": "PINTADO, (Portuguese) a kind of petrel; the Cape guinea fowl, also PINTADA [n]\n",
  "PINTADOS": "PINTADO, (Portuguese) a kind of petrel; the Cape guinea fowl, also PINTADA [n]\n",
  "PINTAIL": "a river duck [n -S]\n",
  "PINTAILED": "having a very long narrow tail [adj]\n",
  "PINTAILS": "PINTAIL, a river duck [n]\n",
  "PINTANO": "a dark-banded tropical fish [n -S]\n",
  "PINTANOS": "PINTANO, a dark-banded tropical fish [n]\n",
  "PINTAS": "PINTA, (Spanish) a skin disease widespread in tropical America, caused by a spirochaete and characterized by rough blotchy skin [n]\n",
  "PINTLE": "a pin on which something turns [n -S]\n",
  "PINTLES": "PINTLE, a pin on which something turns [n]\n",
  "PINTO": "(Spanish) a spotted horse [n -ES or -S]\n",
  "PINTOES": "PINTO, (Spanish) a spotted horse [n]\n",
  "PINTOS": "PINTO, (Spanish) a spotted horse [n]\n",
  "PINTS": "PINT, a measure of capacity equal to half a quart or 4 gills [n]\n",
  "PINTSIZE": "very small, also PINTSIZED [adj]\n",
  "PINTSIZED": "very small, also PINTSIZE [adj]\n",
  "PINTUCK": "a very narrow fold of fabric [n -S] / to tuck with a pintuck [v -ED, -ING, -S]\n",
  "PINTUCKED": "PINTUCK, to tuck with a pintuck [v]\n",
  "PINTUCKING": "the act of tucking with a pintuck [n -S]\n",
  "PINTUCKINGS": "PINTUCKING, the act of tucking with a pintuck [n]\n",
  "PINTUCKS": "PINTUCK, to tuck with a pintuck [v]\n",
  "PINUP": "a picture that may be pinned on a wall [n -S]\n",
  "PINUPS": "PINUP, a picture that may be pinned on a wall [n]\n",
  "PINWALE": "a type of fabric [n -S]\n",
  "PINWALES": "PINWALE, a type of fabric [n]\n",
  "PINWEED": "any plant of a genus of low North American herbs with branching stems, and very small and abundant leaves and flowers [n -S]\n",
  "PINWEEDS": "PINWEED, any plant of a genus of low North American herbs with branching stems, and very small and abundant leaves and flowers [n]\n",
  "PINWHEEL": "to rotate like a child's toy windmill [v -ED, -ING, -S]\n",
  "PINWHEELED": "PINWHEEL, to rotate like a child's toy windmill [v]\n",
  "PINWHEELING": "PINWHEEL, to rotate like a child's toy windmill [v]\n",
  "PINWHEELS": "PINWHEEL, to rotate like a child's toy windmill [v]\n",
  "PINWORK": "a type of embroidery [n -S]\n",
  "PINWORKS": "PINWORK, a type of embroidery [n]\n",
  "PINWORM": "a small nematoid worm, parasitic chiefly in the rectum of man [n -S]\n",
  "PINWORMS": "PINWORM, a small nematoid worm, parasitic chiefly in the rectum of man [n]\n",
  "PINWRENCH": "a wrench with a projection to fit a hole [n -ES]\n",
  "PINWRENCHES": "PINWRENCH, a wrench with a projection to fit a hole [n]\n",
  "PINXIT": "(Latin) a word appended to the artist's name or initials on a painting, or engraved copy of a painting: 'he painted (this)' [v]\n",
  "PINY": "covered with pine trees, also PINEY [adj PINIER, PINIEST] / a showy flower, also PEONY, PAEONY, PIONEY, PIONY [n PINIES]\n",
  "PINYIN": "(Chinese) a system for romanizing Chinese ideograms in which tones are indicated by diacritics and unaspirated consonants are transcribed as voiced [n -S]\n",
  "PINYINS": "PINYIN, (Chinese) a system for romanizing Chinese ideograms in which tones are indicated by diacritics and unaspirated consonants are transcribed as voiced [n]\n",
  "PINYON": "(Spanish) an edible pine seed; the tree bearing it, also PINON [n -S]\n",
  "PINYONS": "PINYON, (Spanish) an edible pine seed; the tree bearing it, also PINON [n]\n",
  "PIOLET": "(French) a mountain-climbing ice axe [n -S]\n",
  "PIOLETS": "PIOLET, (French) a mountain-climbing ice axe [n]\n",
  "PION": "an elementary particle of the meson family [n -S]\n",
  "PIONED": "(Shakespeare) perhaps trenched, perhaps overgrown with wild orchids [adj]\n",
  "PIONEER": "someone who is among the first in new fields of enterprise, exploration etc., also PIONER, PYONER [n -S] / to take part in the beginnings of [v -ED, -ING, -S]\n",
  "PIONEERED": "PIONEER, to take part in the beginnings of [v]\n",
  "PIONEERING": "PIONEER, to take part in the beginnings of [v]\n",
  "PIONEERS": "PIONEER, to take part in the beginnings of [v]\n",
  "PIONER": "(Shakespeare) a military pioneer, also PIONEER, PYONER [n -S]\n",
  "PIONERS": "PIONER, (Shakespeare) a military pioneer, also PIONEER, PYONER [n]\n",
  "PIONEY": "a showy flower, also PEONY, PAEONY, PINY, PIONY [n -S]\n",
  "PIONEYS": "PIONEY, a showy flower, also PEONY, PAEONY, PINY, PIONY [n]\n",
  "PIONIC": "relating to a pion, a pi-meson [adj]\n",
  "PIONIES": "PIONY, (obsolete) a peony, also PAEONY, PINEY, PINY, PIONEY [n]\n",
  "PIONING": "(archaic) pioneer work [n -S]\n",
  "PIONINGS": "PIONING, (archaic) pioneer work [n]\n",
  "PIONS": "PION, an elementary particle of the meson family [n]\n",
  "PIONY": "(obsolete) a peony, also PAEONY, PINEY, PINY, PIONEY [n PIONIES]\n",
  "PIOPIO": "(Maori) a New Zealand thrush, thought to be extinct [n -S]\n",
  "PIOPIOS": "PIOPIO, (Maori) a New Zealand thrush, thought to be extinct [n]\n",
  "PIOSITIES": "PIOSITY, an excessive show of piety [n]\n",
  "PIOSITY": "an excessive show of piety [n PIOSITIES]\n",
  "PIOTED": "(Scots) pied [adj]\n",
  "PIOUS": "marked by religious reverence [adj PIOUSLY]\n",
  "PIOUSLY": "PIOUS, marked by religious reverence [adv]\n",
  "PIOUSNESS": "piety [n -ES]\n",
  "PIOUSNESSES": "PIOUSNESS, piety [n]\n",
  "PIOY": "(Scots) a homemade firework, also PEEOY, PIOYE [n -S]\n",
  "PIOYE": "(Scots) a homemade firework, also PEEOY, PIOY [n -S]\n",
  "PIOYES": "PIOYE, (Scots) a homemade firework, also PEEOY, PIOY [n]\n",
  "PIOYS": "PIOY, (Scots) a homemade firework, also PEEOY, PIOYE [n]\n",
  "PIP": "to offend or disgust [v PIPPED, PIPPING, PIPS]\n",
  "PIPA": "the Surinam toad, noted for its peculiar breeding habits [n -S]\n",
  "PIPAGE": "transportation, as of petroleum oil, by means of a pipe conduit; also, the charge for such transportation, also PIPEAGE [n -S]\n",
  "PIPAGES": "PIPAGE, transportation, as of petroleum oil, by means of a pipe conduit; also, the charge for such transportation, also PIPEAGE [n]\n",
  "PIPAL": "(Hindi) the bo tree, also PEEPUL, PIPUL [n -S]\n",
  "PIPALS": "PIPAL, (Hindi) the bo tree, also PEEPUL, PIPUL [n]\n",
  "PIPAS": "PIPA, the Surinam toad, noted for its peculiar breeding habits [n]\n",
  "PIPE": "to convey by means of a hollow cylinder [v PIPED, PIPING, PIPES]\n",
  "PIPEAGE": "transportation, as of petroleum oil, by means of a pipe conduit; also, the charge for such transportation, also PIPAGE [n -S]\n",
  "PIPEAGES": "PIPEAGE, transportation, as of petroleum oil, by means of a pipe conduit; also, the charge for such transportation, also PIPAGE [n]\n",
  "PIPECLAY": "a fine white clay forming a ductile paste with water, used esp. for making tobacco-pipes and whitening leather etc. [n -S] / to whiten with pipeclay [v -ED, -ING, -S]\n",
  "PIPECLAYED": "PIPECLAY, to whiten with pipeclay [v]\n",
  "PIPECLAYING": "PIPECLAY, to whiten with pipeclay [v]\n",
  "PIPECLAYS": "PIPECLAY, to whiten with pipeclay [v]\n",
  "PIPED": "PIPE, to convey by means of a hollow cylinder [v]\n",
  "PIPEFISH": "any of numerous fishes having a long slender armoured body and a tubular snout [n -ES]\n",
  "PIPEFISHES": "PIPEFISH, any of numerous fishes having a long slender armoured body and a tubular snout [n]\n",
  "PIPEFITTER": "one whose job is to fit pipes [n -S]\n",
  "PIPEFITTERS": "PIPEFITTER, one whose job is to fit pipes [n]\n",
  "PIPEFITTING": "the occupation of fitting or repairing pipes [n -S]\n",
  "PIPEFITTINGS": "PIPEFITTING, the occupation of fitting or repairing pipes [n]\n",
  "PIPEFUL": "as much as a pipe can hold [n -S]\n",
  "PIPEFULS": "PIPEFUL, as much as a pipe can hold [n]\n",
  "PIPELESS": "without a pipe [adj]\n",
  "PIPELIKE": "like a pipe [adj]\n",
  "PIPELINE": "to convey by a line of pipes [v PIPELINED, PIPELINING, PIPELINES]\n",
  "PIPELINED": "PIPELINE, to convey by a line of pipes [v]\n",
  "PIPELINES": "PIPELINE, to convey by a line of pipes [v]\n",
  "PIPELINING": "the act of conveying by pipeline [n -S]\n",
  "PIPELININGS": "PIPELINING, the act of conveying by pipeline [n]\n",
  "PIPER": "one who plays the pipes [n -S]\n",
  "PIPERACEOUS": "pertaining to or like pepper plant; belonging to pepper family of plants [adj]\n",
  "PIPERAZINE": "a crystalline nitrogen compound used in medicine, insecticides etc. [n -S]\n",
  "PIPERAZINES": "PIPERAZINE, a crystalline nitrogen compound used in medicine, insecticides etc. [n]\n",
  "PIPERIC": "applied to an acid obtained from piperine, an alkaloid found in black pepper [adj]\n",
  "PIPERIDINE": "an oily liquid alkaloid having a hot, peppery, ammoniacal odor [n -S]\n",
  "PIPERIDINES": "PIPERIDINE, an oily liquid alkaloid having a hot, peppery, ammoniacal odor [n]\n",
  "PIPERINE": "an alkaloid found in black pepper [n -S]\n",
  "PIPERINES": "PIPERINE, an alkaloid found in black pepper [n]\n",
  "PIPERONAL": "a phenolic aldehyde of very pleasant odour, used as a perfume and in flavourings, etc. [n -S]\n",
  "PIPERONALS": "PIPERONAL, a phenolic aldehyde of very pleasant odour, used as a perfume and in flavourings, etc. [n]\n",
  "PIPERS": "PIPER, one who plays the pipes [n]\n",
  "PIPES": "PIPE, to convey by means of a hollow cylinder [v]\n",
  "PIPESTEM": "the stem of a tobacco pipe [n -S]\n",
  "PIPESTEMS": "PIPESTEM, the stem of a tobacco pipe [n]\n",
  "PIPESTONE": "a kind of clay slate, carved by the Indians into tobacco pipes [n -S]\n",
  "PIPESTONES": "PIPESTONE, a kind of clay slate, carved by the Indians into tobacco pipes [n]\n",
  "PIPET": "a tube for transferring and measuring fluids, also PIPETTE [n -S]\n",
  "PIPETS": "PIPET, a tube for transferring and measuring fluids, also PIPETTE [n]\n",
  "PIPETTE": "a tube for transferring and measuring fluids, also PIPET [n -S] / to transfer, measure, draw off or out, (a liquid or gas) with a pipette [v PIPETTED, PIPETTING, PIPETTES]\n",
  "PIPETTED": "PIPETTE, to transfer, measure, draw off or out, (a liquid or gas) with a pipette [v]\n",
  "PIPETTES": "PIPETTE, to transfer, measure, draw off or out, (a liquid or gas) with a pipette [v]\n",
  "PIPETTING": "PIPETTE, to transfer, measure, draw off or out, (a liquid or gas) with a pipette [v]\n",
  "PIPEWORK": "piping or pipes collectively; a vein of ore in the form of a pipe [n -S]\n",
  "PIPEWORKS": "PIPEWORK, piping or pipes collectively; a vein of ore in the form of a pipe [n]\n",
  "PIPEWORT": "an aquatic or marsh herb with soft grasslike leaves [n -S]\n",
  "PIPEWORTS": "PIPEWORT, an aquatic or marsh herb with soft grasslike leaves [n]\n",
  "PIPI": "(Maori) an edible shellfish of Australasia [n -S]\n",
  "PIPIER": "PIPY, like a pipe; hollow-stemmed [adj]\n",
  "PIPIEST": "PIPY, like a pipe; hollow-stemmed [adj]\n",
  "PIPINESS": "the quality of being pipy [n -ES]\n",
  "PIPINESSES": "PIPINESS, the quality of being pipy [n]\n",
  "PIPING": "shrill [adj PIPINGLY] / a system of pipes [n -S]\n",
  "PIPINGLY": "shrilly [adv]\n",
  "PIPINGS": "PIPING, a system of pipes [n]\n",
  "PIPIS": "PIPI, (Maori) an edible shellfish of Australasia [n]\n",
  "PIPISTREL": "a small reddish-brown bat, also PIPISTRELLE [n -S]\n",
  "PIPISTRELLE": "a small reddish-brown bat, also PIPISTREL [n -S]\n",
  "PIPISTRELLES": "PIPISTRELLE, a small reddish-brown bat, also PIPISTREL [n]\n",
  "PIPISTRELS": "PIPISTREL, a small reddish-brown bat, also PIPISTRELLE [n]\n",
  "PIPIT": "one of several lark-like singing birds [n -S]\n",
  "PIPITS": "PIPIT, one of several lark-like singing birds [n]\n",
  "PIPIWHARAUROA": "(Maori) a Pacific migratory bird with metallic gold-green plumage [n -S]\n",
  "PIPIWHARAUROAS": "PIPIWHARAUROA, (Maori) a Pacific migratory bird with metallic gold-green plumage [n]\n",
  "PIPKIN": "a small earthenware or metal cooking pot [n -S]\n",
  "PIPKINS": "PIPKIN, a small earthenware or metal cooking pot [n]\n",
  "PIPLESS": "having no pips [adj]\n",
  "PIPPED": "PIP, to offend or disgust [v]\n",
  "PIPPIER": "PIPPY, having pips [adj]\n",
  "PIPPIEST": "PIPPY, having pips [adj]\n",
  "PIPPIN": "any of numerous fine-flavoured varieties of dessert apple [n -S]\n",
  "PIPPING": "PIP, to offend or disgust [v]\n",
  "PIPPINS": "PIPPIN, any of numerous fine-flavoured varieties of dessert apple [n]\n",
  "PIPPY": "having pips [adj PIPPIER, PIPPIEST]\n",
  "PIPS": "PIP, to offend or disgust [v]\n",
  "PIPSISSEWA": "a Native American medicinal plant [n -S]\n",
  "PIPSISSEWAS": "PIPSISSEWA, a Native American medicinal plant [n]\n",
  "PIPSQUEAK": "something or someone contemptible [n -S]\n",
  "PIPSQUEAKS": "PIPSQUEAK, something or someone contemptible [n]\n",
  "PIPUL": "(Hindi) a fig tree from India, also PIPAL, PEEPUL [n -S]\n",
  "PIPULS": "PIPUL, (Hindi) a fig tree from India, also PIPAL, PEEPUL [n]\n",
  "PIPY": "like a pipe; hollow-stemmed [adj PIPIER, PIPIEST]\n",
  "PIQUANCE": "the quality of being piquant [n -S]\n",
  "PIQUANCES": "PIQUANCE, the quality of being piquant [n]\n",
  "PIQUANCIES": "PIQUANCY, the quality of being piquant [n]\n",
  "PIQUANCY": "the quality of being piquant [n PIQUANCIES]\n",
  "PIQUANT": "having an agreeably sharp taste [adj PIQUANTLY]\n",
  "PIQUANTLY": "PIQUANT, having an agreeably sharp taste [adv]\n",
  "PIQUANTNESS": "the state of being piquant [n -ES]\n",
  "PIQUANTNESSES": "PIQUANTNESS, the state of being piquant [n]\n",
  "PIQUE": "(French) to arouse anger or resentment [v PIQUED, PIQUING, PIQUES]\n",
  "PIQUED": "PIQUE, (French) to arouse anger or resentment [v]\n",
  "PIQUES": "PIQUE, (French) to arouse anger or resentment [v]\n",
  "PIQUET": "a person or group stationed to watch and dissuade those who go to work during a strike [n -S] / to act as a picket, also PICKET, PICQUET [v -ED, -ING, -S]\n",
  "PIQUETED": "PIQUET, to act as a picket, also PICKET, PICQUET [v]\n",
  "PIQUETING": "PIQUET, to act as a picket, also PICKET, PICQUET [v]\n",
  "PIQUETS": "PIQUET, to act as a picket, also PICKET, PICQUET [v]\n",
  "PIQUILLO": "(Spanish) a variety of sweet red pepper [n -S]\n",
  "PIQUILLOS": "PIQUILLO, (Spanish) a variety of sweet red pepper [n]\n",
  "PIQUING": "PIQUE, (French) to arouse anger or resentment [v]\n",
  "PIR": "a Muslim title of honour, given to a holy man [n -S]\n",
  "PIRACETAM": "a drug used to treat muscle spasm [n -S]\n",
  "PIRACETAMS": "PIRACETAM, a drug used to treat muscle spasm [n]\n",
  "PIRACIES": "PIRACY, robbery on the high seas [n]\n",
  "PIRACY": "robbery on the high seas [n PIRACIES]\n",
  "PIRAGUA": "(Caribbean) a dugout canoe, also PERIAGUA, PIROGUE, PIROQUE [n -S]\n",
  "PIRAGUAS": "PIRAGUA, (Caribbean) a dugout canoe, also PERIAGUA, PIROGUE, PIROQUE [n]\n",
  "PIRAI": "(Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PERAI, PIRANA, PIRAYA [n -S]\n",
  "PIRAIS": "PIRAI, (Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PERAI, PIRANA, PIRAYA [n]\n",
  "PIRANA": "(Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PERAI, PIRAI, PIRAYA [n -S]\n",
  "PIRANAS": "PIRANA, (Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PERAI, PIRAI, PIRAYA [n]\n",
  "PIRANHA": "(Tupi) a ferocious, carnivorous South American fish, also PERAI, PIRAI, PIRANA, PIRAYA [n -S]\n",
  "PIRANHAS": "PIRANHA, (Tupi) a ferocious, carnivorous South American fish, also PERAI, PIRAI, PIRANA, PIRAYA [n]\n",
  "PIRARUCU": "(Tupi) a large South American fish, aka arapaima [n -S]\n",
  "PIRARUCUS": "PIRARUCU, (Tupi) a large South American fish, aka arapaima [n]\n",
  "PIRATE": "a person who, without authority, attempts to capture ships at sea [n -S] / to make illegal copies of e.g. software [v PIRATED, PIRATING, PIRATES]\n",
  "PIRATED": "PIRATE, to make illegal copies of e.g. software [v]\n",
  "PIRATES": "PIRATE, to make illegal copies of e.g. software [v]\n",
  "PIRATIC": "of or pertaining to a pirate, also PIRATICAL [adj PIRATICALLY]\n",
  "PIRATICAL": "of or pertaining to a pirate, also PIRATIC [adj PIRATICALLY]\n",
  "PIRATICALLY": "PIRATICAL, of or pertaining to a pirate, also PIRATIC [adv]\n",
  "PIRATING": "acting as a pirate [n -S]\n",
  "PIRATINGS": "PIRATING, acting as a pirate [n]\n",
  "PIRAYA": "(Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PERAI, PIRAI, PIRANA [n -S]\n",
  "PIRAYAS": "PIRAYA, (Tupi) a ferocious, carnivorous South American fish, also PIRANHA, PERAI, PIRAI, PIRANA [n]\n",
  "PIRIFORM": "pear-shaped, also PYRIFORM [adj]\n",
  "PIRL": "a ripple [n -S]\n",
  "PIRLICUE": "to summarize in conclusion, also PURLICUE [v PIRLICUED, PIRLICUING, PIRLICUES]\n",
  "PIRLICUED": "PIRLICUE, to summarize in conclusion, also PURLICUE [v]\n",
  "PIRLICUES": "PIRLICUE, to summarize in conclusion, also PURLICUE [v]\n",
  "PIRLICUING": "PIRLICUE, to summarize in conclusion, also PURLICUE [v]\n",
  "PIRLS": "PIRL, a ripple [n]\n",
  "PIRN": "(Scots) a reel, a bobbin [n -S]\n",
  "PIRNIE": "(Scots) a striped woollen nightcap [n -S]\n",
  "PIRNIES": "PIRNIE, (Scots) a striped woollen nightcap [n]\n",
  "PIRNIT": "(Scots) unevenly wrought, striped [adj]\n",
  "PIRNS": "PIRN, (Scots) a reel, a bobbin [n]\n",
  "PIROG": "(Russian) a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PEROG, PIEROG [n PIROGI, PIROGHI, PIROGEN]\n",
  "PIROGEN": "PIROG, (Russian) a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PEROG, PIEROG [n]\n",
  "PIROGHI": "PIROG, (Russian) a large Russian pie, stuffed with meat, fish, eggs, or cabbage, also PEROG, PIEROG [n]\n",
  "PIROGI": "(Polish) a dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIEROGI, PYROGY, PYROHY [n -ES]\n",
  "PIROGIES": "PIROGI, (Polish) a dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIEROGI, PYROGY, PYROHY [n]\n",
  "PIROGUE": "(Caribbean) a dugout canoe, also PERIAGUA, PIRAGUA, PIROQUE [n -S]\n",
  "PIROGUES": "PIROGUE, (Caribbean) a dugout canoe, also PERIAGUA, PIRAGUA, PIROQUE [n]\n",
  "PIROJKI": "PIROZHOK, a small, Russian pastry [n]\n",
  "PIROPLASM": "a parasite causing cattle fever, aka babesia, also PIROPLASMA [n -S]\n",
  "PIROPLASMA": "a parasite causing cattle fever, aka babesia, also PIROPLASM [n PIROPLASMATA]\n",
  "PIROPLASMATA": "PIROPLASMA, a parasite causing cattle fever, aka babesia, also PIROPLASM [n]\n",
  "PIROPLASMS": "PIROPLASM, a parasite causing cattle fever, aka babesia, also PIROPLASMA [n]\n",
  "PIROQUE": "(Caribbean) a dugout canoe, also PERIAGUA, PIRAGUA, PIROGUE [n -S]\n",
  "PIROQUES": "PIROQUE, (Caribbean) a dugout canoe, also PERIAGUA, PIRAGUA, PIROGUE [n]\n",
  "PIROSHKI": "PIROZHOK, a small, Russian pastry [n]\n",
  "PIROUETTE": "(French) a twirling motion [n -S] / to make a pirouette [v PIROUETTED, PIROUETTING, PIROUETTES]\n",
  "PIROUETTED": "PIROUETTE, to make a pirouette [v]\n",
  "PIROUETTER": "one who pirouettes [n -S]\n",
  "PIROUETTERS": "PIROUETTER, one who pirouettes [n]\n",
  "PIROUETTES": "PIROUETTE, to make a pirouette [v]\n",
  "PIROUETTING": "PIROUETTE, to make a pirouette [v]\n",
  "PIROZHKI": "PIROZHOK, a small, Russian pastry [n]\n",
  "PIROZHOK": "a small, Russian pastry [n PIROJKI or PIROSHKI or PIROZHKI]\n",
  "PIRS": "PIR, a Muslim title of honour, given to a holy man [n]\n",
  "PIS": "PI, to mix type indiscriminately [v]\n",
  "PISCARIES": "PISCARY, a place for fishing [n]\n",
  "PISCARY": "a place for fishing [n PISCARIES]\n",
  "PISCATOR": "a fisherman [n -S]\n",
  "PISCATORIAL": "of or relating to fishing or fishers [adj PISCATORIALLY]\n",
  "PISCATORIALLY": "PISCATORIAL, of or relating to fishing or fishers [adv]\n",
  "PISCATORS": "PISCATOR, a fisherman [n]\n",
  "PISCATORY": "of or pertaining to fishes or fishing [adj]\n",
  "PISCATRIX": "a (female) angler [n PISCATRIXES]\n",
  "PISCATRIXES": "PISCATRIX, a (female) angler [n]\n",
  "PISCICOLOUS": "parasitic in or on fishes [adj]\n",
  "PISCICULTURAL": "relating to pisciculture [adj PISCICULTURALLY]\n",
  "PISCICULTURALLY": "PISCICULTURAL, relating to pisciculture [adv]\n",
  "PISCICULTURE": "the rearing of fish by artificial methods [n -S]\n",
  "PISCICULTURES": "PISCICULTURE, the rearing of fish by artificial methods [n]\n",
  "PISCICULTURIST": "one engaged in pisciculture, the rearing of fish by artificial methods [n -S]\n",
  "PISCICULTURISTS": "PISCICULTURIST, one engaged in pisciculture, the rearing of fish by artificial methods [n]\n",
  "PISCIFAUNA": "the fish life of an area [n PISCIFAUNAE or PISCIFAUNAS]\n",
  "PISCIFAUNAE": "PISCIFAUNA, the fish life of an area [n]\n",
  "PISCIFAUNAS": "PISCIFAUNA, the fish life of an area [n]\n",
  "PISCIFORM": "shaped like a fish [adj]\n",
  "PISCINA": "(Latin) a basin used in certain church ceremonies [n PISCINAS or PISCINAE]\n",
  "PISCINAE": "PISCINA, (Latin) a basin used in certain church ceremonies [n]\n",
  "PISCINAL": "belonging to a fishpond or a piscina [adj]\n",
  "PISCINAS": "PISCINA, (Latin) a basin used in certain church ceremonies [n]\n",
  "PISCINE": "a pool, a pond, esp. one for bathing or swimming [n -S]\n",
  "PISCINES": "PISCINE, a pool, a pond, esp. one for bathing or swimming [n]\n",
  "PISCIVORE": "an eater of fish [n -S]\n",
  "PISCIVORES": "PISCIVORE, an eater of fish [n]\n",
  "PISCIVOROUS": "fish-eating [adj]\n",
  "PISCO": "a Peruvian brandy [n -S]\n",
  "PISCOS": "PISCO, a Peruvian brandy [n]\n",
  "PISE": "(French) rammed earth or clay [n -S]\n",
  "PISES": "PISE, (French) rammed earth or clay [n]\n",
  "PISH": "to express contempt [v -ED, -ING, -ES]\n",
  "PISHED": "PISH, to express contempt [v]\n",
  "PISHEOG": "(Irish) sorcery, also PISHOGE, PISHOGUE [n -S]\n",
  "PISHEOGS": "PISHEOG, (Irish) sorcery, also PISHOGE, PISHOGUE [n]\n",
  "PISHER": "(Yiddish) a small boy; a young, inexperienced person [n -S]\n",
  "PISHERS": "PISHER, (Yiddish) a small boy; a young, inexperienced person [n]\n",
  "PISHES": "PISH, to express contempt [v]\n",
  "PISHING": "PISH, to express contempt [v]\n",
  "PISHOGE": "(Irish) sorcery, also PISHEOG, PISHOGUE [n -S]\n",
  "PISHOGES": "PISHOGE, (Irish) sorcery, also PISHEOG, PISHOGUE [n]\n",
  "PISHOGUE": "(Irish) sorcery, also PISHEOG, PISHOGE [n -S]\n",
  "PISHOGUES": "PISHOGUE, (Irish) sorcery, also PISHEOG, PISHOGE [n]\n",
  "PISIFORM": "a small bone of the wrist [n -S]\n",
  "PISIFORMS": "PISIFORM, a small bone of the wrist [n]\n",
  "PISKIES": "PISKY, a small fairy, also PIXIE [n]\n",
  "PISKY": "a small fairy, also PIXIE [n PISKIES]\n",
  "PISMIRE": "an ant [n -S]\n",
  "PISMIRES": "PISMIRE, an ant [n]\n",
  "PISO": "(Tagalog) the Philippines peso [n -S]\n",
  "PISOLITE": "a limestone with pea sized formations in circles, also PISOLITH [n -S]\n",
  "PISOLITES": "PISOLITE, a limestone with pea sized formations in circles, also PISOLITH [n]\n",
  "PISOLITH": "a limestone with pea sized formations in circles, also PISOLITE [n -S]\n",
  "PISOLITHS": "PISOLITH, a limestone with pea sized formations in circles, also PISOLITE [n]\n",
  "PISOLITIC": "composed of, containing, or resembling, pisolite, a variety of calcite [adj]\n",
  "PISOS": "PISO, (Tagalog) the Philippines peso [n]\n",
  "PISS": "(colloquial) urine [n PISSES] / to urinate [v -ED, -ING, -ES]\n",
  "PISSANT": "the wood ant, a large species which lives in nests made of pine needles or small twigs that often smell unpleasantly like urine [n -S]\n",
  "PISSANTS": "PISSANT, the wood ant, a large species which lives in nests made of pine needles or small twigs that often smell unpleasantly like urine [n]\n",
  "PISSASPHALT": "a semiliquid bitumen [n -S]\n",
  "PISSASPHALTS": "PISSASPHALT, a semiliquid bitumen [n]\n",
  "PISSED": "PISS, to urinate [v]\n",
  "PISSER": "something that pisses one off [n -S]\n",
  "PISSERS": "PISSER, something that pisses one off [n]\n",
  "PISSES": "PISS, to urinate [v]\n",
  "PISSHEAD": "(offensive slang) a heavy drinker [n -S]\n",
  "PISSHEADS": "PISSHEAD, (offensive slang) a heavy drinker [n]\n",
  "PISSHOLE": "a hole made in soluble matter, such as snow, by urinating [n -S]\n",
  "PISSHOLES": "PISSHOLE, a hole made in soluble matter, such as snow, by urinating [n]\n",
  "PISSIER": "PISSY, soiled with urine; inferior, nasty [adj]\n",
  "PISSIEST": "PISSY, soiled with urine; inferior, nasty [adj]\n",
  "PISSING": "PISS, to urinate [v]\n",
  "PISSOIR": "(French) a public urinal [n -S]\n",
  "PISSOIRS": "PISSOIR, (French) a public urinal [n]\n",
  "PISSY": "soiled with urine; inferior, nasty [adj PISSIER, PISSIEST]\n",
  "PISTACHE": "a shade of green [n -S]\n",
  "PISTACHES": "PISTACHE, a shade of green [n]\n",
  "PISTACHIO": "a kind of tree, or its edible nutlike fruit [n -S]\n",
  "PISTACHIOS": "PISTACHIO, a kind of tree, or its edible nutlike fruit [n]\n",
  "PISTAREEN": "(Spanish) an old Spanish silver coin of the value of about twenty cents [n -S]\n",
  "PISTAREENS": "PISTAREEN, (Spanish) an old Spanish silver coin of the value of about twenty cents [n]\n",
  "PISTE": "(French) a ski-trail [n -S]\n",
  "PISTED": "marked off into pistes [adj]\n",
  "PISTES": "PISTE, (French) a ski-trail [n]\n",
  "PISTIL": "the seed-bearing organ of flowering plants [n -S]\n",
  "PISTILLAR": "belonging or relating to a pistil, also PISTILLARY [adj]\n",
  "PISTILLARY": "of a flower, having pistils, also PISTILLAR [adj]\n",
  "PISTILLATE": "having a pistil or pistils; usually said of flowers having pistils but no stamens [adj]\n",
  "PISTILLODE": "an abortive pistil [n -S]\n",
  "PISTILLODES": "PISTILLODE, an abortive pistil [n]\n",
  "PISTILS": "PISTIL, the seed-bearing organ of flowering plants [n]\n",
  "PISTOL": "to shoot with a small firearm [v PISTOLED or PISTOLLED, PISTOLING or PISTOLLING, PISTOLS]\n",
  "PISTOLE": "(historical) any of numerous old gold coins of varying value [n -S]\n",
  "PISTOLED": "PISTOL, to shoot with a small firearm [v]\n",
  "PISTOLEER": "(obsolete) one who uses a pistol, also PISTOLERO, PISTOLIER [n -S]\n",
  "PISTOLEERS": "PISTOLEER, (obsolete) one who uses a pistol, also PISTOLERO, PISTOLIER [n]\n",
  "PISTOLERO": "one who uses a pistol, also PISTOLEER, PISTOLIER [n -S]\n",
  "PISTOLEROS": "PISTOLERO, one who uses a pistol, also PISTOLEER, PISTOLIER [n]\n",
  "PISTOLES": "PISTOLE, (historical) any of numerous old gold coins of varying value [n]\n",
  "PISTOLET": "(historical) a small pistol [n -S]\n",
  "PISTOLETS": "PISTOLET, (historical) a small pistol [n]\n",
  "PISTOLIER": "one who uses a pistol, also PISTOLEER, PISTOLERO [n -S]\n",
  "PISTOLIERS": "PISTOLIER, one who uses a pistol, also PISTOLEER, PISTOLERO [n]\n",
  "PISTOLING": "PISTOL, to shoot with a small firearm [v]\n",
  "PISTOLLED": "PISTOL, to shoot with a small firearm [v]\n",
  "PISTOLLING": "PISTOL, to shoot with a small firearm [v]\n",
  "PISTOLS": "PISTOL, to shoot with a small firearm [v]\n",
  "PISTON": "a part of an engine [n -S]\n",
  "PISTONS": "PISTON, a part of an engine [n]\n",
  "PISTOU": "(French) a French sauce made of olive oil, garlic, basil, and often cheese [n -S]\n",
  "PISTOUS": "PISTOU, (French) a French sauce made of olive oil, garlic, basil, and often cheese [n]\n",
  "PIT": "to mark with depressions [v PITTED, PITTEN or PUTTEN, PITTING, PITS]\n",
  "PITA": "(Quechua) the fibre of various species of bromelia [n -S]\n",
  "PITAHAYA": "(Spanish) a cactus of southwestern US and Mexico, also PITAYA [n -S]\n",
  "PITAHAYAS": "PITAHAYA, (Spanish) a cactus of southwestern US and Mexico, also PITAYA [n]\n",
  "PITAPAT": "to make a repeated tapping sound [v PITAPATTED, PITAPATTING, PITAPATS]\n",
  "PITAPATS": "PITAPAT, to make a repeated tapping sound [v]\n",
  "PITAPATTED": "PITAPAT, to make a repeated tapping sound [v]\n",
  "PITAPATTING": "PITAPAT, to make a repeated tapping sound [v]\n",
  "PITARA": "(Hindi) a type of clothes basket, also PETARA, PITARAH [n -S]\n",
  "PITARAH": "(Hindi) a type of clothes basket, also PETARA, PITARA [n -S]\n",
  "PITARAHS": "PITARAH, (Hindi) a type of clothes basket, also PETARA, PITARA [n]\n",
  "PITARAS": "PITARA, (Hindi) a type of clothes basket, also PETARA, PITARAH [n]\n",
  "PITAS": "PITA, (Quechua) the fibre of various species of bromelia [n]\n",
  "PITAYA": "(Spanish) a giant cactus of southwestern US and Mexico, also PITAHAYA [n -S]\n",
  "PITAYAS": "PITAYA, (Spanish) a giant cactus of southwestern US and Mexico, also PITAHAYA [n]\n",
  "PITCH": "to throw [v PITCHED, (obsolete) YPIGHT, PITCHING, PITCHES]\n",
  "PITCHBEND": "a device that enables a player to bend the pitch of a note on a synthesiser [n -S]\n",
  "PITCHBENDS": "PITCHBEND, a device that enables a player to bend the pitch of a note on a synthesiser [n]\n",
  "PITCHBLENDE": "a mineral, containing radium [n -S]\n",
  "PITCHBLENDES": "PITCHBLENDE, a mineral, containing radium [n]\n",
  "PITCHED": "PITCH, to throw [v]\n",
  "PITCHER": "a container for holding and pouring liquids [n -S]\n",
  "PITCHERFUL": "the quantity a pitcher will hold [n PITCHERFULS or PITCHERSFUL]\n",
  "PITCHERFULS": "PITCHERFUL, the quantity a pitcher will hold [n]\n",
  "PITCHERS": "PITCHER, a container for holding and pouring liquids [n]\n",
  "PITCHERSFUL": "PITCHERFUL, the quantity a pitcher will hold [n]\n",
  "PITCHES": "PITCH, to throw [v]\n",
  "PITCHFORK": "a fork for tossing hay [n -S] / to toss with a pitchfork [v -ED, -ING, -S]\n",
  "PITCHFORKED": "PITCHFORK, to toss with a pitchfork [v]\n",
  "PITCHFORKING": "PITCHFORK, to toss with a pitchfork [v]\n",
  "PITCHFORKS": "PITCHFORK, to toss with a pitchfork [v]\n",
  "PITCHIER": "PITCHY, like pitch [adj]\n",
  "PITCHIEST": "PITCHY, like pitch [adj]\n",
  "PITCHILY": "PITCHY, like pitch [adv]\n",
  "PITCHINESS": "blackness, as of pitch [n -ES]\n",
  "PITCHINESSES": "PITCHINESS, blackness, as of pitch [n]\n",
  "PITCHING": "a stone road surface [n -S]\n",
  "PITCHINGS": "PITCHING, a stone road surface [n]\n",
  "PITCHMAN": "a salesman of small wares [n PITCHMEN]\n",
  "PITCHMEN": "PITCHMAN, a salesman of small wares [n]\n",
  "PITCHOMETER": "an instrument embodying a clinometer, for measuring the pitch of a ship's propeller [n -S]\n",
  "PITCHOMETERS": "PITCHOMETER, an instrument embodying a clinometer, for measuring the pitch of a ship's propeller [n]\n",
  "PITCHOUT": "a type of pitch in baseball [n -S]\n",
  "PITCHOUTS": "PITCHOUT, a type of pitch in baseball [n]\n",
  "PITCHPERSON": "a street or market trader [n -S]\n",
  "PITCHPERSONS": "PITCHPERSON, a street or market trader [n]\n",
  "PITCHPINE": "a kind of pine tree [n -S]\n",
  "PITCHPINES": "PITCHPINE, a kind of pine tree [n]\n",
  "PITCHPIPE": "a small pipe used to pitch the voice or tune strings [n -S]\n",
  "PITCHPIPES": "PITCHPIPE, a small pipe used to pitch the voice or tune strings [n]\n",
  "PITCHPOLE": "to turn end over end [v PITCHPOLED, PITCHPOLING, PITCHPOLES]\n",
  "PITCHPOLED": "PITCHPOLE, to turn end over end [v]\n",
  "PITCHPOLES": "PITCHPOLE, to turn end over end [v]\n",
  "PITCHPOLING": "PITCHPOLE, to turn end over end [v]\n",
  "PITCHSTONE": "an igneous rock of semi-glassy nature, having a luster-like pitch [n -S]\n",
  "PITCHSTONES": "PITCHSTONE, an igneous rock of semi-glassy nature, having a luster-like pitch [n]\n",
  "PITCHWOMAN": "a (female) street or market trader [n PITCHWOMEN]\n",
  "PITCHWOMEN": "PITCHWOMAN, a (female) street or market trader [n]\n",
  "PITCHY": "like pitch [adj PITCHIER, PITCHIEST, PITCHILY]\n",
  "PITEOUS": "arousing pity, also PITIFUL [adj PITEOUSLY]\n",
  "PITEOUSLY": "PITEOUS, arousing pity, also PITIFUL [adv]\n",
  "PITEOUSNESS": "the state of being piteous [n -ES]\n",
  "PITEOUSNESSES": "PITEOUSNESS, the state of being piteous [n]\n",
  "PITFALL": "a hidden danger or difficulty [n -S]\n",
  "PITFALLS": "PITFALL, a hidden danger or difficulty [n]\n",
  "PITH": "to sever the central nervous system of [v -ED, -ING, -S]\n",
  "PITHBALL": "a pellet of pith [n -S]\n",
  "PITHBALLS": "PITHBALL, a pellet of pith [n]\n",
  "PITHEAD": "the top of a pit or shaft in a coalmine; the area immediately surrounding this [n -S]\n",
  "PITHEADS": "PITHEAD, the top of a pit or shaft in a coalmine; the area immediately surrounding this [n]\n",
  "PITHECANTHROPI": "PITHECANTHROPUS, any of several primitive extinct men from Java [n]\n",
  "PITHECANTHROPUS": "any of several primitive extinct men from Java [n PITHECANTHROPI]\n",
  "PITHECOID": "an ape, esp. a higher or anthropoid ape [n -S]\n",
  "PITHECOIDS": "PITHECOID, an ape, esp. a higher or anthropoid ape [n]\n",
  "PITHED": "PITH, to sever the central nervous system of [v]\n",
  "PITHFUL": "full of pith [adj]\n",
  "PITHIER": "PITHY, full of pith, to the point [adj]\n",
  "PITHIEST": "PITHY, full of pith, to the point [adj]\n",
  "PITHILY": "PITHY, full of pith, to the point [adv]\n",
  "PITHINESS": "the state of being pithy [n -ES]\n",
  "PITHINESSES": "PITHINESS, the state of being pithy [n]\n",
  "PITHING": "PITH, to sever the central nervous system of [v]\n",
  "PITHLESS": "lacking force [adj]\n",
  "PITHLIKE": "resembling pith [adj]\n",
  "PITHOI": "PITHOS, (Greek) a type of Greek storage jar [n]\n",
  "PITHOS": "(Greek) a type of Greek storage jar [n PITHOI]\n",
  "PITHS": "PITH, to sever the central nervous system of [v]\n",
  "PITHY": "full of pith, to the point [adj PITHIER, PITHIEST, PITHILY]\n",
  "PITIABLE": "arousing pity [adj PITIABLY]\n",
  "PITIABLENESS": "the state of being pitiable [n -ES]\n",
  "PITIABLENESSES": "PITIABLENESS, the state of being pitiable [n]\n",
  "PITIABLY": "PITIABLE, arousing pity [adv]\n",
  "PITIED": "PITY, to feel sorrow at another's misfortune [v]\n",
  "PITIER": "one who pities [n -S]\n",
  "PITIERS": "PITIER, one who pities [n]\n",
  "PITIES": "PITY, to feel sorrow at another's misfortune [v]\n",
  "PITIETH": "as in it pitieth me, i.e. it causes pity in me [v]\n",
  "PITIFUL": "arousing pity, also PITEOUS [adj PITIFULLER, PITIFULLEST, PITIFULLY]\n",
  "PITIFULLER": "PITIFUL, arousing pity, also PITEOUS [adj]\n",
  "PITIFULLEST": "PITIFUL, arousing pity, also PITEOUS [adj]\n",
  "PITIFULLY": "PITIFUL, arousing pity, also PITEOUS [adv]\n",
  "PITIFULNESS": "the state of being pitiful [n -ES]\n",
  "PITIFULNESSES": "PITIFULNESS, the state of being pitiful [n]\n",
  "PITIKINS": "diminutive of pity, as in ods pitikins [interj]\n",
  "PITILESS": "without pity [adj PITILESSLY]\n",
  "PITILESSLY": "PITILESS, without pity [adv]\n",
  "PITILESSNESS": "the state of being pitiless [n -ES]\n",
  "PITILESSNESSES": "PITILESSNESS, the state of being pitiless [n]\n",
  "PITLIKE": "like a pit [adj]\n",
  "PITMAN": "a mine worker [n PITMEN] / a connecting rod [n PITMANS]\n",
  "PITMANS": "PITMAN, a mine worker [n]\n",
  "PITMEN": "PITMAN, a mine worker [n]\n",
  "PITON": "(French) a metal spike used in mountain climbing [n -S]\n",
  "PITONS": "PITON, (French) a metal spike used in mountain climbing [n]\n",
  "PITOT": "a tube used to measure the pressure of a fluid stream [n -S]\n",
  "PITOTS": "PITOT, a tube used to measure the pressure of a fluid stream [n]\n",
  "PITPROP": "a timber support in a coalmine [n -S]\n",
  "PITPROPS": "PITPROP, a timber support in a coalmine [n]\n",
  "PITS": "PIT, to mark with depressions [v]\n",
  "PITSAW": "a large saw used for cutting logs [n -S]\n",
  "PITSAWS": "PITSAW, a large saw used for cutting logs [n]\n",
  "PITTA": "a type of slightly leavened bread, originating in the Middle East [n -S]\n",
  "PITTANCE": "a small allowance of money [n -S]\n",
  "PITTANCES": "PITTANCE, a small allowance of money [n]\n",
  "PITTAS": "PITTA, a type of slightly leavened bread, originating in the Middle East [n]\n",
  "PITTED": "PIT, to mark with depressions [v]\n",
  "PITTEN": "PIT, to mark with depressions [v]\n",
  "PITTER": "to sound like a grasshopper [v -ED, -ING, -S]\n",
  "PITTERED": "PITTER, to sound like a grasshopper [v]\n",
  "PITTERING": "PITTER, to sound like a grasshopper [v]\n",
  "PITTERS": "PITTER, to sound like a grasshopper [v]\n",
  "PITTING": "an arrangement of cavities or depressions [n -S]\n",
  "PITTINGS": "PITTING, an arrangement of cavities or depressions [n]\n",
  "PITTITE": "(obsolete) someone who frequents the pit of a theatre [n -S]\n",
  "PITTITES": "PITTITE, (obsolete) someone who frequents the pit of a theatre [n]\n",
  "PITTOSPORUM": "any of numerous chiefly subtropical evergreen shrubs or small trees [n -S]\n",
  "PITTOSPORUMS": "PITTOSPORUM, any of numerous chiefly subtropical evergreen shrubs or small trees [n]\n",
  "PITUITA": "(archaic) phlegm, mucus, also PITUITE [n -S]\n",
  "PITUITARIES": "PITUITARY, the pituitary gland [n]\n",
  "PITUITARY": "of or relating to phlegm or mucus [adj] / the pituitary gland [n PITUITARIES]\n",
  "PITUITAS": "PITUITA, (archaic) phlegm, mucus, also PITUITE [n]\n",
  "PITUITE": "(archaic) phlegm, mucus, also PITUITA [n -S]\n",
  "PITUITES": "PITUITE, (archaic) phlegm, mucus, also PITUITA [n]\n",
  "PITUITRIN": "a hormone produced by the pituitary gland [n -S]\n",
  "PITUITRINS": "PITUITRIN, a hormone produced by the pituitary gland [n]\n",
  "PITURI": "(Native Australian) a type of Australian shrub [n -S]\n",
  "PITURIS": "PITURI, (Native Australian) a type of Australian shrub [n]\n",
  "PITY": "to feel sorrow at another's misfortune [v PITIED, PITYING, PITIES or PITIETH]\n",
  "PITYING": "PITY, to feel sorrow at another's misfortune [v]\n",
  "PITYINGLY": "PITYING, PITY, to feel sorrow at another's misfortune [adv]\n",
  "PITYRIASES": "PITYRIASIS, a superficial affection of the skin, characterized by irregular patches of thin scales which are shed in bran-like particles [n]\n",
  "PITYRIASIS": "a superficial affection of the skin, characterized by irregular patches of thin scales which are shed in bran-like particles [n PITYRIASES]\n",
  "PITYROID": "bran-like [adj]\n",
  "PITYROSPORUM": "a yeastlike fungus which can cause pityriasis [n -S]\n",
  "PITYROSPORUMS": "PITYROSPORUM, a yeastlike fungus which can cause pityriasis [n]\n",
  "PIU": "(Italian) more (a musical direction) [adv]\n",
  "PIUM": "(Tupi) a Brazilian biting fly [n -S]\n",
  "PIUMS": "PIUM, (Tupi) a Brazilian biting fly [n]\n",
  "PIUPIU": "(Maori) a flax skirt [n -S]\n",
  "PIUPIUS": "PIUPIU, (Maori) a flax skirt [n]\n",
  "PIVOT": "to turn on a shaft or rod [v -ED, -ING, -S]\n",
  "PIVOTABLE": "that can be pivoted [adj]\n",
  "PIVOTAL": "critically important [adj PIVOTALLY]\n",
  "PIVOTALLY": "PIVOTAL, critically important [adv]\n",
  "PIVOTED": "PIVOT, to turn on a shaft or rod [v]\n",
  "PIVOTER": "someone who makes pivots [n -S]\n",
  "PIVOTERS": "PIVOTER, someone who makes pivots [n]\n",
  "PIVOTING": "the section of a machine which pivots [n -S]\n",
  "PIVOTINGS": "PIVOTING, the section of a machine which pivots [n]\n",
  "PIVOTMAN": "a centre on a basketball team [n PIVOTMEN]\n",
  "PIVOTMEN": "PIVOTMAN, a centre on a basketball team [n]\n",
  "PIVOTS": "PIVOT, to turn on a shaft or rod [v]\n",
  "PIWAKAWAKA": "(Maori) a New Zealand bird, aka the Grey Fantail [n -S]\n",
  "PIWAKAWAKAS": "PIWAKAWAKA, (Maori) a New Zealand bird, aka the Grey Fantail [n]\n",
  "PIX": "a container for communion bread, also PYX [n -ES]\n",
  "PIXEL": "a basic unit of a video image [n -S]\n",
  "PIXELATE": "to divide an image into pixels for display in a digital format, also PIXELLATE, PIXILATE, PIXILLATE [v PIXELATED, PIXELATING, PIXELATES]\n",
  "PIXELATED": "PIXELATE, to divide an image into pixels for display in a digital format, also PIXELLATE, PIXILATE, PIXILLATE [v]\n",
  "PIXELATES": "PIXELATE, to divide an image into pixels for display in a digital format, also PIXELLATE, PIXILATE, PIXILLATE [v]\n",
  "PIXELATING": "PIXELATE, to divide an image into pixels for display in a digital format, also PIXELLATE, PIXILATE, PIXILLATE [v]\n",
  "PIXELATION": "a video technique in which an image is blurred by being overlaid with a grid of squares, usually to disguise the identity of a person [n -S]\n",
  "PIXELATIONS": "PIXELATION, a video technique in which an image is blurred by being overlaid with a grid of squares, usually to disguise the identity of a person [n]\n",
  "PIXELLATE": "to divide an image into pixels for display in a digital format, also PIXELATE, PIXILATE, PIXILLATE [v PIXELLATED, PIXELLATING, PIXELLATES]\n",
  "PIXELLATED": "made up of pixels; displayed as enlarged pixels so as to distort or disguise [adj]\n",
  "PIXELLATES": "PIXELLATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXILATE, PIXILLATE [v]\n",
  "PIXELLATING": "PIXELLATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXILATE, PIXILLATE [v]\n",
  "PIXELLATION": "the act of dividing an image into pixels for display in a digital format, also PIXILATION, PIXILLATION [n -S]\n",
  "PIXELLATIONS": "PIXELLATION, the act of dividing an image into pixels for display in a digital format, also PIXILATION, PIXILLATION [n]\n",
  "PIXELS": "PIXEL, a basic unit of a video image [n]\n",
  "PIXES": "PIX, a container for communion bread, also PYX [n]\n",
  "PIXIE": "a small fairy, also PISKY [n -S]\n",
  "PIXIEISH": "like a pixie [adj]\n",
  "PIXIES": "PIXIE, a small fairy, also PISKY [n]\n",
  "PIXILATE": "to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILLATE [v PIXILATED, PIXILATING, PIXILATES]\n",
  "PIXILATED": "PIXILATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILLATE [v]\n",
  "PIXILATES": "PIXILATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILLATE [v]\n",
  "PIXILATING": "PIXILATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILLATE [v]\n",
  "PIXILATION": "a technique for making human figures and animals appear to be animated e.g. by the use of stop-frame methods, also PIXELLATION, PIXILLATION [n -S]\n",
  "PIXILATIONS": "PIXILATION, a technique for making human figures and animals appear to be animated e.g. by the use of stop-frame methods, also PIXELLATION, PIXILLATION [n]\n",
  "PIXILLATE": "to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILATE [v PIXILLATED, PIXILLATING, PIXILLATES]\n",
  "PIXILLATED": "slightly unbalanced mentally, bemused, also PIXILATED [adj]\n",
  "PIXILLATES": "PIXILLATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILATE [v]\n",
  "PIXILLATING": "PIXILLATE, to divide an image into pixels for display in a digital format, also PIXELATE, PIXELLATE, PIXILATE [v]\n",
  "PIXILLATION": "a technique for making human figures and animals appear to be animated artificially, e.g. by the use of stop-frame camera techniques, also PIXELLATION, PIXILATION [n -S]\n",
  "PIXILLATIONS": "PIXILLATION, a technique for making human figures and animals appear to be animated artificially, e.g. by the use of stop-frame camera techniques, also PIXELLATION, PIXILATION [n]\n",
  "PIXINESS": "the state of being playfully mischievous [n -ES]\n",
  "PIXINESSES": "PIXINESS, the state of being playfully mischievous [n]\n",
  "PIXY": "a small fairy, also PISKY, PIXIE [n PIXIES]\n",
  "PIXYISH": "like a pixy [adj]\n",
  "PIZAZZ": "flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZZAZ, PIZZAZZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "PIZAZZES": "PIZAZZ, flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZZAZ, PIZZAZZ, PIZZAZZ, PZAZZ [n]\n",
  "PIZAZZIER": "PIZAZZY, full of pizazz, also PIZZAZZY [adj]\n",
  "PIZAZZIEST": "PIZAZZY, full of pizazz, also PIZZAZZY [adj]\n",
  "PIZAZZY": "full of pizazz, also PIZZAZZY [adj PIZAZZIER, PIZAZZIEST]\n",
  "PIZE": "(dialect) to strike someone a blow [v PIZED, PIZING, PIZES]\n",
  "PIZED": "PIZE, (dialect) to strike someone a blow [v]\n",
  "PIZES": "PIZE, (dialect) to strike someone a blow [v]\n",
  "PIZING": "PIZE, (dialect) to strike someone a blow [v]\n",
  "PIZZA": "(Italian) a flat usually round base of dough baked with a topping of tomatoes, cheese, meat, olives, etc. [n -S]\n",
  "PIZZAIOLA": "(Italian) having a rich sauce made with tomatoes [adj]\n",
  "PIZZALIKE": "like a pizza [adj]\n",
  "PIZZAS": "PIZZA, (Italian) a flat usually round base of dough baked with a topping of tomatoes, cheese, meat, olives, etc. [n]\n",
  "PIZZAZ": "flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZZ, PIZZAZZ, PZAZZ [n -ES]\n",
  "PIZZAZES": "PIZZAZ, flamboyance, also BAZAZZ, BEZZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZZ, PIZZAZZ, PZAZZ [n]\n",
  "PIZZAZZ": "panache, flamboyance, also BAZAZZ, BEZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PZAZZ [n -ES]\n",
  "PIZZAZZES": "PIZZAZZ, panache, flamboyance, also BAZAZZ, BEZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PZAZZ [n]\n",
  "PIZZAZZIER": "PIZZAZZY, full of pizzazz, panache, flamboyance, also PIZAZZY [adj]\n",
  "PIZZAZZIEST": "PIZZAZZY, full of pizzazz, panache, flamboyance, also PIZAZZY [adj]\n",
  "PIZZAZZY": "full of pizzazz, panache, flamboyance, also PIZAZZY [adj PIZZAZZIER, PIZZAZZIEST]\n",
  "PIZZELLE": "(Italian) a thin, crisp Italian cookie [n -S]\n",
  "PIZZELLES": "PIZZELLE, (Italian) a thin, crisp Italian cookie [n]\n",
  "PIZZERIA": "(Italian) a place where pizzas are made and sold [n -S]\n",
  "PIZZERIAS": "PIZZERIA, (Italian) a place where pizzas are made and sold [n]\n",
  "PIZZICATI": "PIZZICATO, a tone so produced; a passage so played [n]\n",
  "PIZZICATO": "(Italian) played by plucking the string [adv] / a tone so produced; a passage so played [n PIZZICATI or PIZZICATOS]\n",
  "PIZZICATOS": "PIZZICATO, a tone so produced; a passage so played [n]\n",
  "PIZZLE": "a bull's penis used as instrument of punishment by flogging [n -S]\n",
  "PIZZLES": "PIZZLE, a bull's penis used as instrument of punishment by flogging [n]\n",
  "PLAAS": "(South African) a farm [n -ES]\n",
  "PLAASES": "PLAAS, (South African) a farm [n]\n",
  "PLACABILITIES": "PLACABILITY, the state of being placable [n]\n",
  "PLACABILITY": "the state of being placable [n PLACABILITIES]\n",
  "PLACABLE": "capable of being placated [adj]\n",
  "PLACABLENESS": "the state of being placable [n -ES]\n",
  "PLACABLENESSES": "PLACABLENESS, the state of being placable [n]\n",
  "PLACABLY": "PLACABLE, capable of being placated [adv]\n",
  "PLACARD": "a written or printed notice stuck on a wall or otherwise publicly displayed [n -S] / to publicise by means of posters [v -ED, -ING, -S]\n",
  "PLACARDED": "PLACARD, to publicise by means of posters [v]\n",
  "PLACARDING": "PLACARD, to publicise by means of posters [v]\n",
  "PLACARDS": "PLACARD, to publicise by means of posters [v]\n",
  "PLACATE": "to conciliate [v PLACATED, PLACATING, PLACATES]\n",
  "PLACATED": "PLACATE, to conciliate [v]\n",
  "PLACATER": "one who placates [n -S]\n",
  "PLACATERS": "PLACATER, one who placates [n]\n",
  "PLACATES": "PLACATE, to conciliate [v]\n",
  "PLACATING": "PLACATE, to conciliate [v]\n",
  "PLACATINGLY": "PLACATING, PLACATE, to conciliate [adv]\n",
  "PLACATION": "the act of placating [n -S]\n",
  "PLACATIONS": "PLACATION, the act of placating [n]\n",
  "PLACATIVE": "tending to placate, also PLACATORY [adj]\n",
  "PLACATORY": "tending to placate, also PLACATIVE [adj]\n",
  "PLACCAT": "(Shakespeare) a leather doublet with strips of steel, also PLACCATE, PLACKET [n -S]\n",
  "PLACCATE": "(obsolete) a leather doublet with strips of steel, also PLACCAT, PLACKET [n -S]\n",
  "PLACCATES": "PLACCATE, (obsolete) a leather doublet with strips of steel, also PLACCAT, PLACKET [n]\n",
  "PLACCATS": "PLACCAT, (Shakespeare) a leather doublet with strips of steel, also PLACCATE, PLACKET [n]\n",
  "PLACE": "to assign to a position [v PLACED or (obsolete) PLAST, PLASTE or YPLAST, PLACING, PLACES]\n",
  "PLACEABLE": "that can be placed [adj]\n",
  "PLACEBO": "(Latin) a medicine given to humour a patient [n -ES or -S]\n",
  "PLACEBOES": "PLACEBO, (Latin) a medicine given to humour a patient [n]\n",
  "PLACEBOS": "PLACEBO, (Latin) a medicine given to humour a patient [n]\n",
  "PLACED": "PLACE, to assign to a position [v]\n",
  "PLACEHOLDER": "a symbol in a mathematical or logical expression that may be replaced by the name of any element of a set [n -S]\n",
  "PLACEHOLDERS": "PLACEHOLDER, a symbol in a mathematical or logical expression that may be replaced by the name of any element of a set [n]\n",
  "PLACEKICK": "in football, a kick made when the ball has been placed on the ground for that purpose [n -S] / to make a placekick [v -ED, -ING, -S]\n",
  "PLACEKICKED": "PLACEKICK, to make a placekick [v]\n",
  "PLACEKICKER": "one who does placekicks [n -S]\n",
  "PLACEKICKERS": "PLACEKICKER, one who does placekicks [n]\n",
  "PLACEKICKING": "PLACEKICK, to make a placekick [v]\n",
  "PLACEKICKS": "PLACEKICK, in football, a kick made when the ball has been placed on the ground for that purpose [n]\n",
  "PLACELESS": "having no place or office [adj PLACELESSLY]\n",
  "PLACELESSLY": "PLACELESS, having no place or office [adv]\n",
  "PLACEMAN": "a political appointee to a public office [n PLACEMEN]\n",
  "PLACEMAT": "a table mat on which a place setting is laid [n -S]\n",
  "PLACEMATS": "PLACEMAT, a table mat on which a place setting is laid [n]\n",
  "PLACEMEN": "PLACEMAN, a political appointee to a public office [n]\n",
  "PLACEMENT": "the act of placing, or the state of being placed [n -S]\n",
  "PLACEMENTS": "PLACEMENT, the act of placing, or the state of being placed [n]\n",
  "PLACENTA": "(Latin) a round flat spongy vascular organ to which the foetus of most mammals is attached by the umbilical cord [n PLACENTAE or PLACENTAS]\n",
  "PLACENTAE": "PLACENTA, (Latin) a round flat spongy vascular organ to which the foetus of most mammals is attached by the umbilical cord [n]\n",
  "PLACENTAL": "relating to the placenta [adj] / a placental mammal [n -S]\n",
  "PLACENTALS": "PLACENTAL, a placental mammal [n]\n",
  "PLACENTAS": "PLACENTA, (Latin) a round flat spongy vascular organ to which the foetus of most mammals is attached by the umbilical cord [n]\n",
  "PLACENTATE": "having a placenta [adj]\n",
  "PLACENTATION": "the arrangement of placentas and ovules in a plant ovary [n -S]\n",
  "PLACENTATIONS": "PLACENTATION, the arrangement of placentas and ovules in a plant ovary [n]\n",
  "PLACENTIFORM": "cake-shaped [adj]\n",
  "PLACENTOLOGIES": "PLACENTOLOGY, the scientific study of placentae [n]\n",
  "PLACENTOLOGY": "the scientific study of placentae [n PLACENTOLOGIES]\n",
  "PLACER": "a person who places, sets, or arranges something [n -S]\n",
  "PLACERS": "PLACER, a person who places, sets, or arranges something [n]\n",
  "PLACES": "PLACE, to assign to a position [v]\n",
  "PLACET": "(Latin) a decision of a court or assembly, also PLACIT, PLACITUM [n -S]\n",
  "PLACETS": "PLACET, (Latin) a decision of a court or assembly, also PLACIT, PLACITUM [n]\n",
  "PLACID": "calm in nature [adj PLACIDER, PLACIDEST, PLACIDLY]\n",
  "PLACIDER": "PLACID, calm in nature [adj]\n",
  "PLACIDEST": "PLACID, calm in nature [adj]\n",
  "PLACIDITIES": "PLACIDITY, the state of being placid [n]\n",
  "PLACIDITY": "the state of being placid [n PLACIDITIES]\n",
  "PLACIDLY": "PLACID, calm in nature [adv]\n",
  "PLACIDNESS": "the state of being placid [n -ES]\n",
  "PLACIDNESSES": "PLACIDNESS, the state of being placid [n]\n",
  "PLACING": "a position [n -S]\n",
  "PLACINGS": "PLACING, a position [n]\n",
  "PLACIT": "(Latin) a court ruling, also PLACITUM, PLACET [n -S]\n",
  "PLACITA": "PLACITUM, (Latin) a court ruling, also PLACET, PLACIT [n]\n",
  "PLACITORY": "of or pertaining to pleas or pleading, in courts of law [adj]\n",
  "PLACITS": "PLACIT, (Latin) a court ruling, also PLACITUM, PLACET [n]\n",
  "PLACITUM": "(Latin) a court ruling, also PLACET, PLACIT [n PLACITA]\n",
  "PLACK": "(Scots) a small copper coin formerly current in Scotland [n -S]\n",
  "PLACKET": "a leather doublet with strips of steel, also PLACCAT, PLACCATE [n -S]\n",
  "PLACKETS": "PLACKET, a leather doublet with strips of steel, also PLACCAT, PLACCATE [n]\n",
  "PLACKLESS": "(Scots) destitute, not having a plack [adj]\n",
  "PLACKS": "PLACK, (Scots) a small copper coin formerly current in Scotland [n]\n",
  "PLACODERM": "covered with bony scales [adj] / a fish covered with bony scales [n -S]\n",
  "PLACODERMS": "PLACODERM, a fish covered with bony scales [n]\n",
  "PLACOID": "a fish having platelike scales [n -S]\n",
  "PLACOIDS": "PLACOID, a fish having platelike scales [n]\n",
  "PLAFOND": "(French) a decorated ceiling [n -S]\n",
  "PLAFONDS": "PLAFOND, (French) a decorated ceiling [n]\n",
  "PLAGAL": "designating a medieval musical mode [adj]\n",
  "PLAGE": "(French) a bright region on the sun [n -S]\n",
  "PLAGES": "PLAGE, (French) a bright region on the sun [n]\n",
  "PLAGIARIES": "PLAGIARY, the act of passing off another's work as one's own [n]\n",
  "PLAGIARISE": "to steal ideas or writings from another person and present them as one's own, also PLAGIARIZE [v PLAGIARISED, PLAGIARISING, PLAGIARISES]\n",
  "PLAGIARISED": "PLAGIARISE, to steal ideas or writings from another person and present them as one's own, also PLAGIARIZE [v]\n",
  "PLAGIARISER": "one who plagiarises, also PLAGIARIZER [n -S]\n",
  "PLAGIARISERS": "PLAGIARISER, one who plagiarises, also PLAGIARIZER [n]\n",
  "PLAGIARISES": "PLAGIARISE, to steal ideas or writings from another person and present them as one's own, also PLAGIARIZE [v]\n",
  "PLAGIARISING": "PLAGIARISE, to steal ideas or writings from another person and present them as one's own, also PLAGIARIZE [v]\n",
  "PLAGIARISM": "an act or instance of plagiarizing [n -S]\n",
  "PLAGIARISMS": "PLAGIARISM, an act or instance of plagiarizing [n]\n",
  "PLAGIARIST": "one who commits plagiarism [n -S]\n",
  "PLAGIARISTIC": "relating to plagiarism [adj]\n",
  "PLAGIARISTS": "PLAGIARIST, one who commits plagiarism [n]\n",
  "PLAGIARIZE": "to steal ideas or writings from another person and present them as one's own, also PLAGIARISE [v PLAGIARIZED, PLAGIARIZING, PLAGIARIZES]\n",
  "PLAGIARIZED": "PLAGIARIZE, to steal ideas or writings from another person and present them as one's own, also PLAGIARISE [v]\n",
  "PLAGIARIZER": "one who plagiarizes, also PLAGIARISER [n -S]\n",
  "PLAGIARIZERS": "PLAGIARIZER, one who plagiarizes, also PLAGIARISER [n]\n",
  "PLAGIARIZES": "PLAGIARIZE, to steal ideas or writings from another person and present them as one's own, also PLAGIARISE [v]\n",
  "PLAGIARIZING": "PLAGIARIZE, to steal ideas or writings from another person and present them as one's own, also PLAGIARISE [v]\n",
  "PLAGIARY": "the act of passing off another's work as one's own [n PLAGIARIES]\n",
  "PLAGIOCEPHALIES": "PLAGIOCEPHALY, a twisted condition of the head, the front of the skull being larger on one side, the back larger on the other [n]\n",
  "PLAGIOCEPHALY": "a twisted condition of the head, the front of the skull being larger on one side, the back larger on the other [n PLAGIOCEPHALIES]\n",
  "PLAGIOCLASE": "a fine-grained volcanic rock of intermediate composition, consisting largely of plagioclase and one or more mafic minerals [n -S]\n",
  "PLAGIOCLASES": "PLAGIOCLASE, a fine-grained volcanic rock of intermediate composition, consisting largely of plagioclase and one or more mafic minerals [n]\n",
  "PLAGIOCLASTIC": "of or like plagioclase [adj]\n",
  "PLAGIOCLIMAX": "the climax stage of a community, influenced by man or some other outside factor [n PLAGIOCLIMAXES]\n",
  "PLAGIOCLIMAXES": "PLAGIOCLIMAX, the climax stage of a community, influenced by man or some other outside factor [n]\n",
  "PLAGIOSTOMATOUS": "of or like a plagiostome, also PLAGIOSTOMOUS [adj]\n",
  "PLAGIOSTOME": "any fish families of the Plagiostomata or Plagiostomi, the cross-mouthed fishes, sharks and ray [n -S]\n",
  "PLAGIOSTOMES": "PLAGIOSTOME, any fish families of the Plagiostomata or Plagiostomi, the cross-mouthed fishes, sharks and ray [n]\n",
  "PLAGIOSTOMOUS": "of or like a plagiostome, also PLAGIOSTOMATOUS [adj]\n",
  "PLAGIOTROPIC": "of a plant, growing away from the vertical [adj]\n",
  "PLAGIOTROPISM": "the tendency to grow at an oblique or horizontal angle [n -S]\n",
  "PLAGIOTROPISMS": "PLAGIOTROPISM, the tendency to grow at an oblique or horizontal angle [n]\n",
  "PLAGIOTROPOUS": "showing plagiotropism, the tendency to grow at an oblique or horizontal angle [adj]\n",
  "PLAGIUM": "(Latin) the crime of kidnapping [n -S]\n",
  "PLAGIUMS": "PLAGIUM, (Latin) the crime of kidnapping [n]\n",
  "PLAGUE": "to pester or annoy [v PLAGUED, PLAGUING, PLAGUES]\n",
  "PLAGUED": "PLAGUE, to pester or annoy [v]\n",
  "PLAGUELIKE": "like a plague [adj]\n",
  "PLAGUER": "one who plagues [n -S]\n",
  "PLAGUERS": "PLAGUER, one who plagues [n]\n",
  "PLAGUES": "PLAGUE, to pester or annoy [v]\n",
  "PLAGUESOME": "(colloquial) troublesome, annoying [adj]\n",
  "PLAGUEY": "vexatious, also PLAGUY [adj PLAGUIER, PLAGUIEST]\n",
  "PLAGUIER": "PLAGUEY, vexatious, also PLAGUY [adj]\n",
  "PLAGUIEST": "PLAGUEY, vexatious, also PLAGUY [adj]\n",
  "PLAGUILY": "PLAGUY, vexatious, also PLAGUEY [adv]\n",
  "PLAGUING": "PLAGUE, to pester or annoy [v]\n",
  "PLAGUY": "vexatious, also PLAGUEY [adj]\n",
  "PLAICE": "a European flatfish [n -S]\n",
  "PLAICES": "PLAICE, a European flatfish [n]\n",
  "PLAID": "a long piece of twilled woollen cloth, usually with a chequered or tartan pattern, worn over the shoulder as the outer article of the traditional Highland dress [n -S]\n",
  "PLAIDED": "with a tartan design [adj]\n",
  "PLAIDING": "a strong woollen fabric [n -S]\n",
  "PLAIDINGS": "PLAIDING, a strong woollen fabric [n]\n",
  "PLAIDMAN": "a Highlander [n PLAIDMEN]\n",
  "PLAIDMEN": "PLAIDMAN, a Highlander [n]\n",
  "PLAIDS": "PLAID, a long piece of twilled woollen cloth, usually with a chequered or tartan pattern, worn over the shoulder as the outer article of the traditional Highland dress [n]\n",
  "PLAIN": "unadorned [adj PLAINER, PLAINEST, PLAINLY] / to complain [v -ED, -ING, -S]\n",
  "PLAINANT": "one who makes complaint; a plaintiff [n -S]\n",
  "PLAINANTS": "PLAINANT, one who makes complaint; a plaintiff [n]\n",
  "PLAINCHANT": "plainsong [n -S]\n",
  "PLAINCHANTS": "PLAINCHANT, plainsong [n]\n",
  "PLAINCLOTHES": "clothes worn rather than uniform [n]\n",
  "PLAINCLOTHESMAN": "a plainclothes police officer [n PLAINCLOTHESMEN]\n",
  "PLAINCLOTHESMEN": "PLAINCLOTHESMAN, a plainclothes police officer [n]\n",
  "PLAINED": "PLAIN, to complain [v]\n",
  "PLAINER": "PLAIN, unadorned [adj]\n",
  "PLAINEST": "PLAIN, unadorned [adj]\n",
  "PLAINFUL": "complaining, also PLAINTFUL [adj]\n",
  "PLAINING": "(Shakespeare) complaint [n -S]\n",
  "PLAININGS": "PLAINING, (Shakespeare) complaint [n]\n",
  "PLAINISH": "somewhat plain [adj]\n",
  "PLAINLY": "PLAIN, unadorned [adv]\n",
  "PLAINNESS": "the state of being plain [n -ES]\n",
  "PLAINNESSES": "PLAINNESS, the state of being plain [n]\n",
  "PLAINS": "PLAIN, to complain [v]\n",
  "PLAINSMAN": "a dweller in a plain, esp. in North America [n PLAINSMEN]\n",
  "PLAINSMEN": "PLAINSMAN, a dweller in a plain, esp. in North America [n]\n",
  "PLAINSONG": "unmeasured, unaccompanied music sung in unison in ecclesiastical modes from early times [n -S]\n",
  "PLAINSONGS": "PLAINSONG, unmeasured, unaccompanied music sung in unison in ecclesiastical modes from early times [n]\n",
  "PLAINSPOKEN": "candid, frank [adj]\n",
  "PLAINSPOKENNESS": "PLAINSPOKEN, candid, frank [n]\n",
  "PLAINSTANES": "(Scots) flagstones, pavement, also PLAINSTONES [n]\n",
  "PLAINSTONES": "(Scots) flagstones, pavement, also PLAINSTANES [n]\n",
  "PLAINT": "lamentation, complaint [n -S]\n",
  "PLAINTEXT": "text that is not encrypted in any way [n -S]\n",
  "PLAINTEXTS": "PLAINTEXT, text that is not encrypted in any way [n]\n",
  "PLAINTFUL": "(archaic) complaining, also PLAINFUL [adj]\n",
  "PLAINTIFF": "a person or body suing a defendant in a court of law [n -S]\n",
  "PLAINTIFFS": "PLAINTIFF, a person or body suing a defendant in a court of law [n]\n",
  "PLAINTIVE": "mournful, querulous [adj PLAINTIVELY]\n",
  "PLAINTIVELY": "PLAINTIVE, mournful, querulous [adv]\n",
  "PLAINTIVENESS": "PLAINTIVE, mournful, querulous [n]\n",
  "PLAINTIVENESSES": "PLAINTIVENESS, PLAINTIVE, mournful, querulous [n]\n",
  "PLAINTLESS": "without complaint; unrepining [adj]\n",
  "PLAINTS": "PLAINT, lamentation, complaint [n]\n",
  "PLAINWORK": "plain needlework, as distinct from embroidery [n -S]\n",
  "PLAINWORKS": "PLAINWORK, plain needlework, as distinct from embroidery [n]\n",
  "PLAISTER": "(Scots) to plaster [v -ED, -ING, -S]\n",
  "PLAISTERED": "PLAISTER, (Scots) to plaster [v]\n",
  "PLAISTERING": "PLAISTER, (Scots) to plaster [v]\n",
  "PLAISTERS": "PLAISTER, (Scots) to plaster [v]\n",
  "PLAIT": "to braid [v -ED, -ING, -S]\n",
  "PLAITED": "PLAIT, to braid [v]\n",
  "PLAITER": "one who plaits [n -S]\n",
  "PLAITERS": "PLAITER, one who plaits [n]\n",
  "PLAITING": "plaited braid, also PLATTING [n -S]\n",
  "PLAITINGS": "PLAITING, plaited braid, also PLATTING [n]\n",
  "PLAITS": "PLAIT, to braid [v]\n",
  "PLAN": "to formulate an idea [v PLANNED, PLANNING, PLANS]\n",
  "PLANAR": "relating to a plane, lying in a single plane [adj]\n",
  "PLANARIA": "a kind of aquatic flatworm, also PLANARIAN [n -S]\n",
  "PLANARIAN": "a kind of aquatic flatworm, also PLANARIA [n -S]\n",
  "PLANARIANS": "PLANARIAN, a kind of aquatic flatworm, also PLANARIA [n]\n",
  "PLANARIAS": "PLANARIA, a kind of aquatic flatworm, also PLANARIAN [n]\n",
  "PLANARITIES": "PLANARITY, the property of being planar, lying in a single plane [n]\n",
  "PLANARITY": "the property of being planar, lying in a single plane [n PLANARITIES]\n",
  "PLANATE": "having a flat surface [adj]\n",
  "PLANATION": "lateral erosion, as in a valley, by a running stream [n -S]\n",
  "PLANATIONS": "PLANATION, lateral erosion, as in a valley, by a running stream [n]\n",
  "PLANCH": "a plank, a board, also PLANCHE [n -ES] / to floor, board [v -ED, -ING, -ES]\n",
  "PLANCHE": "a plank, a board, also PLANCH [n -S]\n",
  "PLANCHED": "PLANCH, to floor, board [v]\n",
  "PLANCHES": "PLANCH, to floor, board [v]\n",
  "PLANCHET": "a blank metal disc to be stamped as a coin [n -S]\n",
  "PLANCHETS": "PLANCHET, a blank metal disc to be stamped as a coin [n]\n",
  "PLANCHETTE": "a board mounted on two castors and a pencil-point, used as a medium for automatic writing and supposed spirit-messages [n -S]\n",
  "PLANCHETTES": "PLANCHETTE, a board mounted on two castors and a pencil-point, used as a medium for automatic writing and supposed spirit-messages [n]\n",
  "PLANCHING": "PLANCH, to floor, board [v]\n",
  "PLANE": "to make smooth and even [v PLANED, PLANING, PLANES]\n",
  "PLANED": "PLANE, to make smooth and even [v]\n",
  "PLANELOAD": "as much as may be carried by a plane [n -S]\n",
  "PLANELOADS": "PLANELOAD, as much as may be carried by a plane [n]\n",
  "PLANENESS": "the state of being plane [n -ES]\n",
  "PLANENESSES": "PLANENESS, the state of being plane [n]\n",
  "PLANER": "a planing machine [n -S]\n",
  "PLANERS": "PLANER, a planing machine [n]\n",
  "PLANES": "PLANE, to make smooth and even [v]\n",
  "PLANESIDE": "the area next to an aeroplane [n -S]\n",
  "PLANESIDES": "PLANESIDE, the area next to an aeroplane [n]\n",
  "PLANET": "a celestial body [n -S]\n",
  "PLANETARIA": "PLANETARIUM, a model or representation of the solar system [n]\n",
  "PLANETARIES": "PLANETARY, a train of planetary gears [n]\n",
  "PLANETARIUM": "a model or representation of the solar system [n PLANETARIA or PLANETARIUMS]\n",
  "PLANETARIUMS": "PLANETARIUM, a model or representation of the solar system [n]\n",
  "PLANETARY": "of or pertaining to the planets [adj] / a train of planetary gears [n PLANETARIES]\n",
  "PLANETESIMAL": "an asteroid or similar tiny celestial body [n -S]\n",
  "PLANETESIMALS": "PLANETESIMAL, an asteroid or similar tiny celestial body [n]\n",
  "PLANETIC": "of or pertaining to planets, also PLANETICAL [adj]\n",
  "PLANETICAL": "of or pertaining to planets, also PLANETIC [adj]\n",
  "PLANETLIKE": "like a planet [adj]\n",
  "PLANETOID": "a body resembling a planet; an asteroid [n -S]\n",
  "PLANETOIDAL": "like a planetoid [adj]\n",
  "PLANETOIDS": "PLANETOID, a body resembling a planet; an asteroid [n]\n",
  "PLANETOLOGICAL": "relating to planetology [adj]\n",
  "PLANETOLOGIES": "PLANETOLOGY, the study of planets [n]\n",
  "PLANETOLOGIST": "one who studies planetology [n -S]\n",
  "PLANETOLOGISTS": "PLANETOLOGIST, one who studies planetology [n]\n",
  "PLANETOLOGY": "the study of planets [n PLANETOLOGIES]\n",
  "PLANETS": "PLANET, a celestial body [n]\n",
  "PLANETWIDE": "extending throughout or involving an entire planet [adj]\n",
  "PLANFORM": "the contour of an object as viewed from above [n -S]\n",
  "PLANFORMS": "PLANFORM, the contour of an object as viewed from above [n]\n",
  "PLANGENCIES": "PLANGENCY, resonance [n]\n",
  "PLANGENCY": "resonance [n PLANGENCIES]\n",
  "PLANGENT": "having an expressive esp. plaintive quality [adj PLANGENTLY]\n",
  "PLANGENTLY": "PLANGENT, having an expressive esp. plaintive quality [adv]\n",
  "PLANIGRAM": "an X-ray photograph of a selected plane section of the human body or some other solid object, aka tomogram [n -S]\n",
  "PLANIGRAMS": "PLANIGRAM, an X-ray photograph of a selected plane section of the human body or some other solid object, aka tomogram [n]\n",
  "PLANIGRAPH": "an instrument for copying drawings at a different scale [n -S]\n",
  "PLANIGRAPHIES": "PLANIGRAPHY, X-ray photography in which parts of body in front of, or behind, the part under examination are not shown, aka tomography [n]\n",
  "PLANIGRAPHS": "PLANIGRAPH, an instrument for copying drawings at a different scale [n]\n",
  "PLANIGRAPHY": "X-ray photography in which parts of body in front of, or behind, the part under examination are not shown, aka tomography [n PLANIGRAPHIES]\n",
  "PLANIMETER": "an instrument for measuring the area of plane figures [n -S]\n",
  "PLANIMETERS": "PLANIMETER, an instrument for measuring the area of plane figures [n]\n",
  "PLANIMETRIC": "relating to planimetry, also PLANIMETRICAL [adj PLANIMETRICALLY]\n",
  "PLANIMETRICAL": "relating to planimetry, also PLANIMETRIC [adj PLANIMETRICALLY]\n",
  "PLANIMETRICALLY": "PLANIMETRICAL, relating to planimetry, also PLANIMETRIC [adv]\n",
  "PLANIMETRIES": "PLANIMETRY, the mensuration of plane surfaces [n]\n",
  "PLANIMETRY": "the mensuration of plane surfaces [n PLANIMETRIES]\n",
  "PLANING": "PLANE, to make smooth and even [v]\n",
  "PLANISH": "to toughen and smooth by hammering lightly [v -ED, -ING, -ES]\n",
  "PLANISHED": "PLANISH, to toughen and smooth by hammering lightly [v]\n",
  "PLANISHER": "a person who or tool that planishes [n -S]\n",
  "PLANISHERS": "PLANISHER, a person who or tool that planishes [n]\n",
  "PLANISHES": "PLANISH, to toughen and smooth by hammering lightly [v]\n",
  "PLANISHING": "PLANISH, to toughen and smooth by hammering lightly [v]\n",
  "PLANISPHERE": "a sphere projected onto a plane; a map of the heavens [n -S]\n",
  "PLANISPHERES": "PLANISPHERE, a sphere projected onto a plane; a map of the heavens [n]\n",
  "PLANISPHERIC": "relating to the planisphere [adj]\n",
  "PLANK": "to cover with long, flat pieces of timber [v -ED, -ING, -S]\n",
  "PLANKED": "PLANK, to cover with long, flat pieces of timber [v]\n",
  "PLANKING": "a covering made of planks [n -S]\n",
  "PLANKINGS": "PLANKING, a covering made of planks [n]\n",
  "PLANKLIKE": "like a plank [adj]\n",
  "PLANKS": "PLANK, to cover with long, flat pieces of timber [v]\n",
  "PLANKTER": "an organism that is an element of plankton [n -S]\n",
  "PLANKTERS": "PLANKTER, an organism that is an element of plankton [n]\n",
  "PLANKTIC": "relating to plankton [adj]\n",
  "PLANKTON": "the minute animal and plant life of a body of water [n -S]\n",
  "PLANKTONIC": "relating to plankton [adj]\n",
  "PLANKTONS": "PLANKTON, the minute animal and plant life of a body of water [n]\n",
  "PLANLESS": "without a plan [adj PLANLESSLY]\n",
  "PLANLESSLY": "PLANLESS, without a plan [adv]\n",
  "PLANLESSNESS": "the state of being planless [n -ES]\n",
  "PLANLESSNESSES": "PLANLESSNESS, the state of being planless [n]\n",
  "PLANNED": "PLAN, to formulate an idea [v]\n",
  "PLANNER": "one who plans [n -S]\n",
  "PLANNERS": "PLANNER, one who plans [n]\n",
  "PLANNING": "the establishment of goals or policies [n -S]\n",
  "PLANNINGS": "PLANNING, the establishment of goals or policies [n]\n",
  "PLANOBLAST": "any free-swimming gonophore of a hydroid; a hydroid medusa [n -S]\n",
  "PLANOBLASTS": "PLANOBLAST, any free-swimming gonophore of a hydroid; a hydroid medusa [n]\n",
  "PLANOCONVEX": "of a lens, part of an animal or plant, etc.: having one surface plane and the opposite one convex [adj]\n",
  "PLANOGAMETE": "a motile gamete [n -S]\n",
  "PLANOGAMETES": "PLANOGAMETE, a motile gamete [n]\n",
  "PLANOGRAM": "a schematic drawing or plan for displaying merchandise in a store so as to maximize sales [n -S]\n",
  "PLANOGRAMS": "PLANOGRAM, a schematic drawing or plan for displaying merchandise in a store so as to maximize sales [n]\n",
  "PLANOGRAPHIC": "relating to planography [adj]\n",
  "PLANOGRAPHIES": "PLANOGRAPHY, cartography [n]\n",
  "PLANOGRAPHY": "cartography [n PLANOGRAPHIES]\n",
  "PLANOMETER": "an instrument for gauging or testing the flatness of a plane surface [n -S]\n",
  "PLANOMETERS": "PLANOMETER, an instrument for gauging or testing the flatness of a plane surface [n]\n",
  "PLANOMETRIC": "denoting a type of pictorial drawing [adj PLANOMETRICALLY]\n",
  "PLANOMETRICALLY": "PLANOMETRIC, denoting a type of pictorial drawing [adv]\n",
  "PLANOMETRIES": "PLANOMETRY, measurement by means of a planometer [n]\n",
  "PLANOMETRY": "measurement by means of a planometer [n PLANOMETRIES]\n",
  "PLANOSOL": "a type of soil [n -S]\n",
  "PLANOSOLS": "PLANOSOL, a type of soil [n]\n",
  "PLANS": "PLAN, to formulate an idea [v]\n",
  "PLANT": "to place in the ground for growing [v -ED, -ING, -S]\n",
  "PLANTA": "(Latin) the sole of the foot [n PLANTAS or PLANTAE]\n",
  "PLANTABLE": "capable of being planted [adj]\n",
  "PLANTAE": "PLANTA, (Latin) the sole of the foot [n]\n",
  "PLANTAGE": "(Shakespeare) plants in general [n -S]\n",
  "PLANTAGES": "PLANTAGE, (Shakespeare) plants in general [n]\n",
  "PLANTAGINACEOUS": "belonging to the plantain family [adj]\n",
  "PLANTAIN": "any of various low-growing plants constituting the genus Plantago [n -S]\n",
  "PLANTAINS": "PLANTAIN, any of various low-growing plants constituting the genus Plantago [n]\n",
  "PLANTAR": "of or relating to the planta, the sole of the foot [adj]\n",
  "PLANTAS": "PLANTA, (Latin) the sole of the foot [n]\n",
  "PLANTATION": "a usually large group of plants and esp. trees under cultivation [n -S]\n",
  "PLANTATIONS": "PLANTATION, a usually large group of plants and esp. trees under cultivation [n]\n",
  "PLANTED": "PLANT, to place in the ground for growing [v]\n",
  "PLANTER": "one who plants [n -S]\n",
  "PLANTERS": "PLANTER, one who plants [n]\n",
  "PLANTIGRADE": "walking on the soles of the feet, as humans do [adj] / a plantigrade animal [n -S]\n",
  "PLANTIGRADES": "PLANTIGRADE, a plantigrade animal [n]\n",
  "PLANTING": "a plantation [n -S]\n",
  "PLANTINGS": "PLANTING, a plantation [n]\n",
  "PLANTLESS": "without plants; barren of vegetation [adj]\n",
  "PLANTLET": "a small plant, also PLANTLING [n -S]\n",
  "PLANTLETS": "PLANTLET, a small plant, also PLANTLING [n]\n",
  "PLANTLIKE": "like a plant [adj]\n",
  "PLANTLING": "a small plant, also PLANTLET [n -S]\n",
  "PLANTLINGS": "PLANTLING, a small plant, also PLANTLET [n]\n",
  "PLANTOCRACIES": "PLANTOCRACY, government by plantation owners [n]\n",
  "PLANTOCRACY": "government by plantation owners [n PLANTOCRACIES]\n",
  "PLANTS": "PLANT, to place in the ground for growing [v]\n",
  "PLANTSMAN": "a person who has great knowledge of and experience in gardening [n PLANTSMEN]\n",
  "PLANTSMEN": "PLANTSMAN, a person who has great knowledge of and experience in gardening [n]\n",
  "PLANTSWOMAN": "a female person who has great knowledge of and experience in gardening [n PLANTSWOMEN]\n",
  "PLANTSWOMEN": "PLANTSWOMAN, a female person who has great knowledge of and experience in gardening [n]\n",
  "PLANTULE": "a plant embryo [n -S]\n",
  "PLANTULES": "PLANTULE, a plant embryo [n]\n",
  "PLANULA": "(Latin) the free-swimming larva of certain organisms [n PLANULAE]\n",
  "PLANULAE": "PLANULA, (Latin) the free-swimming larva of certain organisms [n]\n",
  "PLANULAR": "of or like a planula, a free-swimming, two-layered, often flattened larva of coelenterates etc. [adj]\n",
  "PLANULATE": "flat [adj]\n",
  "PLANULIFORM": "having the form of a planula [adj]\n",
  "PLANULOID": "of or like a planula, a free-swimming, two-layered, often flattened larva of coelenterates etc. [adj]\n",
  "PLANURIA": "the discharge of urine through an abnormal passage, also PLANURY [n -S]\n",
  "PLANURIAS": "PLANURIA, the discharge of urine through an abnormal passage, also PLANURY [n]\n",
  "PLANURIES": "PLANURY, the discharge of urine through an abnormal passage, also PLANURIA [n]\n",
  "PLANURY": "the discharge of urine through an abnormal passage, also PLANURIA [n PLANURIES]\n",
  "PLANXTIES": "PLANXTY, an Irish or Welsh melody for the harp, sometimes of a mournful character [n]\n",
  "PLANXTY": "an Irish or Welsh melody for the harp, sometimes of a mournful character [n PLANXTIES]\n",
  "PLAP": "to make a sound like a flat plop [v PLAPPED, PLAPPING, PLAPS]\n",
  "PLAPPED": "PLAP, to make a sound like a flat plop [v]\n",
  "PLAPPING": "PLAP, to make a sound like a flat plop [v]\n",
  "PLAPS": "PLAP, to make a sound like a flat plop [v]\n",
  "PLAQUE": "an ornamental plate or disk [n -S]\n",
  "PLAQUES": "PLAQUE, an ornamental plate or disk [n]\n",
  "PLAQUETTE": "(French) a small plaque [n -S]\n",
  "PLAQUETTES": "PLAQUETTE, (French) a small plaque [n]\n",
  "PLASH": "to weave together [v -ED, -ING, -ES]\n",
  "PLASHED": "PLASH, to weave together [v]\n",
  "PLASHER": "one who plashes [n -S]\n",
  "PLASHERS": "PLASHER, one who plashes [n]\n",
  "PLASHES": "PLASH, to weave together [v]\n",
  "PLASHET": "a small pond or pool [n -S]\n",
  "PLASHETS": "PLASHET, a small pond or pool [n]\n",
  "PLASHIER": "PLASHY, like a plash, a shallow pool or puddle [adj]\n",
  "PLASHIEST": "PLASHY, like a plash, a shallow pool or puddle [adj]\n",
  "PLASHING": "a process of hedge mending [n -S]\n",
  "PLASHINGS": "PLASHING, a process of hedge mending [n]\n",
  "PLASHY": "like a plash, a shallow pool or puddle [adj PLASHIER, PLASHIEST]\n",
  "PLASM": "the liquid part of the blood, also PLASMA [n -S]\n",
  "PLASMA": "(Greek) the liquid part of the blood, also PLASM [n -S]\n",
  "PLASMAGEL": "cytoplasm in the form of a gel, esp. surrounding the plasmasol in an amoeboid cell [n -S]\n",
  "PLASMAGELS": "PLASMAGEL, cytoplasm in the form of a gel, esp. surrounding the plasmasol in an amoeboid cell [n]\n",
  "PLASMAGENE": "a self-reproducing structure like the mitochondria [n -S]\n",
  "PLASMAGENES": "PLASMAGENE, a self-reproducing structure like the mitochondria [n]\n",
  "PLASMAGENIC": "of or like a plasmagene [adj]\n",
  "PLASMALEMMA": "a plasma membrane [n -S]\n",
  "PLASMALEMMAS": "PLASMALEMMA, a plasma membrane [n]\n",
  "PLASMAPHERESES": "PLASMAPHERESIS, the process of separating plasma from red blood cells in blood from donor, and returning red blood cells to donor [n]\n",
  "PLASMAPHERESIS": "the process of separating plasma from red blood cells in blood from donor, and returning red blood cells to donor [n PLASMAPHERESES]\n",
  "PLASMAS": "PLASMA, (Greek) the liquid part of the blood, also PLASM [n]\n",
  "PLASMASOL": "cytoplasm in the form of a sol, esp. in a pseudopodium [n -S]\n",
  "PLASMASOLS": "PLASMASOL, cytoplasm in the form of a sol, esp. in a pseudopodium [n]\n",
  "PLASMATIC": "of or like a plasma, an ionized gas containing electrons and free positive ions, also PLASMATICAL, PLASMIC [adj]\n",
  "PLASMATICAL": "of or like a plasma, an ionized gas containing electrons and free positive ions, also PLASMATIC, PLASMIC [adj]\n",
  "PLASMIC": "of or like a plasma, an ionized gas containing electrons and free positive ions, also PLASMATIC, PLASMATICAL [adj]\n",
  "PLASMID": "a hereditary structure of a cell [n -S]\n",
  "PLASMIDS": "PLASMID, a hereditary structure of a cell [n]\n",
  "PLASMIN": "a proteolytic enzyme that causes fibrinolysis in blood clots [n -S]\n",
  "PLASMINOGEN": "the precursor of plasmin that is found in blood plasma and serum [n -S]\n",
  "PLASMINOGENS": "PLASMINOGEN, the precursor of plasmin that is found in blood plasma and serum [n]\n",
  "PLASMINS": "PLASMIN, a proteolytic enzyme that causes fibrinolysis in blood clots [n]\n",
  "PLASMODESM": "a strand of living cytoplasm connecting two cells, also PLASMODESMA [n -S]\n",
  "PLASMODESMA": "a strand of living cytoplasm connecting two cells, also PLASMODESM [n PLASMODESMAS or PLASMODESMATA]\n",
  "PLASMODESMAS": "PLASMODESMA, a strand of living cytoplasm connecting two cells, also PLASMODESM [n]\n",
  "PLASMODESMATA": "PLASMODESMA, a strand of living cytoplasm connecting two cells, also PLASMODESM [n]\n",
  "PLASMODESMS": "PLASMODESM, a strand of living cytoplasm connecting two cells, also PLASMODESMA [n]\n",
  "PLASMODIA": "PLASMODIUM, a naked mass of protoplasm with many nuclei, as in myxomycetes [n]\n",
  "PLASMODIAL": "of or pertaining to, or like, a plasmodium; as, the plasmodial form of a life cycle [adj]\n",
  "PLASMODIUM": "a naked mass of protoplasm with many nuclei, as in myxomycetes [n PLASMODIA]\n",
  "PLASMOGAMIES": "PLASMOGAMY, a process of fusion of the cytoplasm of two cells; the first step in syngamy, also PLASTOGAMY [n]\n",
  "PLASMOGAMY": "a process of fusion of the cytoplasm of two cells; the first step in syngamy, also PLASTOGAMY [n PLASMOGAMIES]\n",
  "PLASMOID": "a type of high energy particle [n -S]\n",
  "PLASMOIDS": "PLASMOID, a type of high energy particle [n]\n",
  "PLASMOLYSE": "to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYZE [v PLASMOLYSED, PLASMOLYSING, PLASMOLYSES]\n",
  "PLASMOLYSED": "PLASMOLYSE, to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYZE [v]\n",
  "PLASMOLYSES": "PLASMOLYSE, to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYZE [v]\n",
  "PLASMOLYSING": "PLASMOLYSE, to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYZE [v]\n",
  "PLASMOLYSIS": "the removal of water from a cell by osmosis [n PLASMOLYSES]\n",
  "PLASMOLYTIC": "relating to plasmolysis [adj PLASMOLYTICALLY]\n",
  "PLASMOLYTICALLY": "PLASMOLYTIC, relating to plasmolysis [adv]\n",
  "PLASMOLYZE": "to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYSE [v PLASMOLYZED, PLASMOLYZING, PLASMOLYZES]\n",
  "PLASMOLYZED": "PLASMOLYZE, to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYSE [v]\n",
  "PLASMOLYZES": "PLASMOLYZE, to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYSE [v]\n",
  "PLASMOLYZING": "PLASMOLYZE, to undergo plasmolysis, the removal of water from a cell by osmosis, also PLASMOLYSE [v]\n",
  "PLASMON": "the total of the genetic material in a cell [n -S]\n",
  "PLASMONS": "PLASMON, the total of the genetic material in a cell [n]\n",
  "PLASMOSOMA": "a nucleolus, also PLASMOSOME [n PLASMOSOMATA]\n",
  "PLASMOSOMATA": "PLASMOSOMA, a nucleolus, also PLASMOSOME [n]\n",
  "PLASMOSOME": "a nucleolus, also PLASMOSOMA [n -S]\n",
  "PLASMOSOMES": "PLASMOSOME, a nucleolus, also PLASMOSOMA [n]\n",
  "PLASMS": "PLASM, the liquid part of the blood, also PLASMA [n]\n",
  "PLAST": "PLACE, to assign to a position [v]\n",
  "PLASTE": "PLACE, to assign to a position [v]\n",
  "PLASTER": "to cover with a mixture of lime, sand and water [v -ED, -ING, -S]\n",
  "PLASTERBOARD": "a thin rigid board, in the form of a layer of plaster compressed between two layers of fibreboard, used to form or cover walls [n -S]\n",
  "PLASTERBOARDS": "PLASTERBOARD, a thin rigid board, in the form of a layer of plaster compressed between two layers of fibreboard, used to form or cover walls [n]\n",
  "PLASTERED": "PLASTER, to cover with a mixture of lime, sand and water [v]\n",
  "PLASTERER": "one whose job is to plaster [n -S]\n",
  "PLASTERERS": "PLASTERER, one whose job is to plaster [n]\n",
  "PLASTERIER": "PLASTERY, of the nature of plaster [adj]\n",
  "PLASTERIEST": "PLASTERY, of the nature of plaster [adj]\n",
  "PLASTERINESS": "the state of being plastery [n -ES]\n",
  "PLASTERINESSES": "PLASTERINESS, the state of being plastery [n]\n",
  "PLASTERING": "the act of covering with plaster [n -S]\n",
  "PLASTERINGS": "PLASTERING, the act of covering with plaster [n]\n",
  "PLASTERS": "PLASTER, to cover with a mixture of lime, sand and water [v]\n",
  "PLASTERSTONE": "gypsum [n -S]\n",
  "PLASTERSTONES": "PLASTERSTONE, gypsum [n]\n",
  "PLASTERWORK": "plastering, often ornate in design, used to finish architectural constructions [n -S]\n",
  "PLASTERWORKS": "PLASTERWORK, plastering, often ornate in design, used to finish architectural constructions [n]\n",
  "PLASTERY": "of the nature of plaster [adj PLASTERIER, PLASTERIEST]\n",
  "PLASTIC": "easily moulded [adj PLASTICLY or PLASTICALLY] / any of a group of synthetic or natural mouldable materials [n -S]\n",
  "PLASTICALLY": "PLASTIC, easily moulded [adv]\n",
  "PLASTICATED": "covered with a layer of plastic [adj]\n",
  "PLASTICENE": "(tradename) a kind of modelling material that remains soft and can be reworked, used esp. by children, also PLASTICINE [n -S]\n",
  "PLASTICENES": "PLASTICENE, (tradename) a kind of modelling material that remains soft and can be reworked, used esp. by children, also PLASTICINE [n]\n",
  "PLASTICINE": "(tradename) a kind of modelling material that remains soft and can be reworked, used esp. by children, also PLASTICENE [n -S]\n",
  "PLASTICINES": "PLASTICINE, (tradename) a kind of modelling material that remains soft and can be reworked, used esp. by children, also PLASTICENE [n]\n",
  "PLASTICISATION": "the act of plasticising, also PLASTICIZATION [n -S]\n",
  "PLASTICISATIONS": "PLASTICISATION, the act of plasticising, also PLASTICIZATION [n]\n",
  "PLASTICISE": "to make plastic, also PLASTICIZE [v PLASTICISED, PLASTICISING, PLASTICISES]\n",
  "PLASTICISED": "PLASTICISE, to make plastic, also PLASTICIZE [v]\n",
  "PLASTICISER": "a substance that induces plasticity, also PLASTICIZER [n -S]\n",
  "PLASTICISERS": "PLASTICISER, a substance that induces plasticity, also PLASTICIZER [n]\n",
  "PLASTICISES": "PLASTICISE, to make plastic, also PLASTICIZE [v]\n",
  "PLASTICISING": "PLASTICISE, to make plastic, also PLASTICIZE [v]\n",
  "PLASTICITIES": "PLASTICITY, the state of being plastic [n]\n",
  "PLASTICITY": "the state of being plastic [n PLASTICITIES]\n",
  "PLASTICIZATION": "the act of plasticizing, also PLASTICISATION [n -S]\n",
  "PLASTICIZATIONS": "PLASTICIZATION, the act of plasticizing, also PLASTICISATION [n]\n",
  "PLASTICIZE": "to make plastic, also PLASTICISE [v PLASTICIZED, PLASTICIZING, PLASTICIZES]\n",
  "PLASTICIZED": "PLASTICIZE, to make plastic, also PLASTICISE [v]\n",
  "PLASTICIZER": "a substance that induces plasticity, also PLASTICISER [n -S]\n",
  "PLASTICIZERS": "PLASTICIZER, a substance that induces plasticity, also PLASTICISER [n]\n",
  "PLASTICIZES": "PLASTICIZE, to make plastic, also PLASTICISE [v]\n",
  "PLASTICIZING": "PLASTICIZE, to make plastic, also PLASTICISE [v]\n",
  "PLASTICKIER": "PLASTICKY, of a plastic nature [adj]\n",
  "PLASTICKIEST": "PLASTICKY, of a plastic nature [adj]\n",
  "PLASTICKY": "of a plastic nature [adj PLASTICKIER, PLASTICKIEST]\n",
  "PLASTICLY": "PLASTIC, easily moulded [adv]\n",
  "PLASTICS": "PLASTIC, any of a group of synthetic or natural mouldable materials [n]\n",
  "PLASTID": "a structure in plant cells [n -S]\n",
  "PLASTIDIAL": "relating to a plastid [adj]\n",
  "PLASTIDS": "PLASTID, a structure in plant cells [n]\n",
  "PLASTIDULE": "one of the small particles or organic molecules of protoplasm [n -S]\n",
  "PLASTIDULES": "PLASTIDULE, one of the small particles or organic molecules of protoplasm [n]\n",
  "PLASTILINA": "a mixture of clay with oil, zinc oxide, sulphur and wax for modelling [n -S]\n",
  "PLASTILINAS": "PLASTILINA, a mixture of clay with oil, zinc oxide, sulphur and wax for modelling [n]\n",
  "PLASTINATION": "a technique for the preservation of biological tissue that involves replacing water and fat in tissue with a polymer [n -S]\n",
  "PLASTINATIONS": "PLASTINATION, a technique for the preservation of biological tissue that involves replacing water and fat in tissue with a polymer [n]\n",
  "PLASTIQUE": "(French) graceful poise and movements in dancing [n -S]\n",
  "PLASTIQUES": "PLASTIQUE, (French) graceful poise and movements in dancing [n]\n",
  "PLASTISOL": "a suspension of powdered resin in a liquid plasticizer, convertible by heat into a solid plastic [n -S]\n",
  "PLASTISOLS": "PLASTISOL, a suspension of powdered resin in a liquid plasticizer, convertible by heat into a solid plastic [n]\n",
  "PLASTOCYANIN": "a copper-containing protein that acts as an intermediary in photosynthetic electron transport [n -S]\n",
  "PLASTOCYANINS": "PLASTOCYANIN, a copper-containing protein that acts as an intermediary in photosynthetic electron transport [n]\n",
  "PLASTOGAMIES": "PLASTOGAMY, a process of fusion of the cytoplasm of two cells, the first step in syngamy, also PLASMOGAMY [n]\n",
  "PLASTOGAMY": "a process of fusion of the cytoplasm of two cells, the first step in syngamy, also PLASMOGAMY [n PLASTOGAMIES]\n",
  "PLASTOMETER": "an instrument for measuring plasticity [n -S]\n",
  "PLASTOMETERS": "PLASTOMETER, an instrument for measuring plasticity [n]\n",
  "PLASTOMETRIC": "relating to plastometry, the measurement of plasticity [adj]\n",
  "PLASTOMETRIES": "PLASTOMETRY, measurement by plastometer [n]\n",
  "PLASTOMETRY": "measurement by plastometer [n PLASTOMETRIES]\n",
  "PLASTOQUINONE": "a plant substance that is related to vitamin K and plays a role in photosynthetic phosphorylation [n -S]\n",
  "PLASTOQUINONES": "PLASTOQUINONE, a plant substance that is related to vitamin K and plays a role in photosynthetic phosphorylation [n]\n",
  "PLASTRAL": "relating to a plastron, a fencer's padded breast-shield [adj]\n",
  "PLASTRON": "a fencer's padded breast-shield; the underside of a turtle's shell, also PLASTRUM [n -S]\n",
  "PLASTRONS": "PLASTRON, a fencer's padded breast-shield; the underside of a turtle's shell, also PLASTRUM [n]\n",
  "PLASTRUM": "a fencer's padded breast-shield; the underside of a turtle's shell, also PLASTRON [n -S]\n",
  "PLASTRUMS": "PLASTRUM, a fencer's padded breast-shield; the underside of a turtle's shell, also PLASTRON [n]\n",
  "PLAT": "to braid [v PLATTED, PLATTING, PLATS]\n",
  "PLATAN": "the plane tree, also PLATANE [n -S]\n",
  "PLATANACEOUS": "belonging to the family Platanaceae, plane trees etc. [adj]\n",
  "PLATANE": "a large tree, also PLATAN [n -S]\n",
  "PLATANES": "PLATANE, a large tree, also PLATAN [n]\n",
  "PLATANNA": "(South African) the African clawed frog [n -S]\n",
  "PLATANNAS": "PLATANNA, (South African) the African clawed frog [n]\n",
  "PLATANS": "PLATAN, the plane tree, also PLATANE [n]\n",
  "PLATBAND": "(French) a border of flowers in a garden, along a wall or a parterre [n -S]\n",
  "PLATBANDS": "PLATBAND, (French) a border of flowers in a garden, along a wall or a parterre [n]\n",
  "PLATE": "to cover with a thin layer of metal [v PLATED, PLATING, PLATES]\n",
  "PLATEASM": "a pronunciation with a wide mouth-opening, as in Doric Greek [n -S]\n",
  "PLATEASMS": "PLATEASM, a pronunciation with a wide mouth-opening, as in Doric Greek [n]\n",
  "PLATEAU": "(French) a level stretch of elevated land [n PLATEAUS or PLATEAUX] / to reach a period of stability [v -ED, -ING, -S]\n",
  "PLATEAUED": "PLATEAU, to reach a period of stability [v]\n",
  "PLATEAUING": "PLATEAU, to reach a period of stability [v]\n",
  "PLATEAUS": "PLATEAU, to reach a period of stability [v]\n",
  "PLATEAUX": "PLATEAU, (French) a level stretch of elevated land [n]\n",
  "PLATED": "PLATE, to cover with a thin layer of metal [v]\n",
  "PLATEFUL": "the quantity a plate can hold [n PLATEFULS or PLATESFUL]\n",
  "PLATEFULS": "PLATEFUL, the quantity a plate can hold [n]\n",
  "PLATEGLASS": "a kind of glass used for windows [n -ES]\n",
  "PLATEGLASSES": "PLATEGLASS, a kind of glass used for windows [n]\n",
  "PLATELAYER": "a workman who lays and maintains railway track [n -S]\n",
  "PLATELAYERS": "PLATELAYER, a workman who lays and maintains railway track [n]\n",
  "PLATELAYING": "the laying of rails for a railway [n -S]\n",
  "PLATELAYINGS": "PLATELAYING, the laying of rails for a railway [n]\n",
  "PLATELESS": "lacking a plate [adj]\n",
  "PLATELET": "a minute particle in blood, concerned in clotting [n -S]\n",
  "PLATELETS": "PLATELET, a minute particle in blood, concerned in clotting [n]\n",
  "PLATELIKE": "like a plate [adj]\n",
  "PLATEMAKER": "one who makes plates [n -S]\n",
  "PLATEMAKERS": "PLATEMAKER, one who makes plates [n]\n",
  "PLATEMAKING": "the act of making printing plates [n -S]\n",
  "PLATEMAKINGS": "PLATEMAKING, the act of making printing plates [n]\n",
  "PLATEMAN": "someone who is in charge of the silver-plate [n PLATEMEN]\n",
  "PLATEMARK": "a hallmark on a plate [n -S] / to mark with a platemark [v -ED, -ING, -S]\n",
  "PLATEMARKED": "PLATEMARK, to mark with a platemark [v]\n",
  "PLATEMARKING": "PLATEMARK, to mark with a platemark [v]\n",
  "PLATEMARKS": "PLATEMARK, a hallmark on a plate [n]\n",
  "PLATEMEN": "PLATEMAN, someone who is in charge of the silver-plate [n]\n",
  "PLATEN": "the part of a printing press which presses the paper against the type and by which the impression is made [n -S]\n",
  "PLATENS": "PLATEN, the part of a printing press which presses the paper against the type and by which the impression is made [n]\n",
  "PLATER": "a mediocre horse entered chiefly for minor races [n -S]\n",
  "PLATERESQUE": "of, relating to, or being a 16th century Spanish architectural style characterized by elaborate ornamentation suggestive of silver plate [adj]\n",
  "PLATERS": "PLATER, a mediocre horse entered chiefly for minor races [n]\n",
  "PLATES": "PLATE, to cover with a thin layer of metal [v]\n",
  "PLATESFUL": "PLATEFUL, the quantity a plate can hold [n]\n",
  "PLATFORM": "a raised floor for speakers, musicians, etc. [n -S] / to equip with a platform [v -ED, -ING, -S]\n",
  "PLATFORMED": "PLATFORM, to equip with a platform [v]\n",
  "PLATFORMER": "a platform game, a type of computer game that is played by moving a figure on the screen through a series of obstacles and problems [n -S]\n",
  "PLATFORMERS": "PLATFORMER, a platform game, a type of computer game that is played by moving a figure on the screen through a series of obstacles and problems [n]\n",
  "PLATFORMING": "a process for reforming petroleum using a platinum catalyst [n -S]\n",
  "PLATFORMINGS": "PLATFORMING, a process for reforming petroleum using a platinum catalyst [n]\n",
  "PLATFORMS": "PLATFORM, to equip with a platform [v]\n",
  "PLATIER": "PLATY, split into thin, flat pieces [adj]\n",
  "PLATIES": "PLATY, a small tropical fish, also PLATYFISH [n]\n",
  "PLATIEST": "PLATY, split into thin, flat pieces [adj]\n",
  "PLATINA": "(Spanish) platinum [n -S]\n",
  "PLATINAS": "PLATINA, (Spanish) platinum [n]\n",
  "PLATING": "a thin layer of metal [n -S]\n",
  "PLATINGS": "PLATING, a thin layer of metal [n]\n",
  "PLATINIC": "of or containing platinum in the tetravalent state [adj]\n",
  "PLATINIFEROUS": "bearing platinum [adj]\n",
  "PLATINIRIDIUM": "an alloy of platinum and iridium [n -S]\n",
  "PLATINIRIDIUMS": "PLATINIRIDIUM, an alloy of platinum and iridium [n]\n",
  "PLATINISATION": "the process of platinising, also PLATINIZATION [n -S]\n",
  "PLATINISATIONS": "PLATINISATION, the process of platinising, also PLATINIZATION [n]\n",
  "PLATINISE": "to coat with platinum, also PLATINIZE [v PLATINISED, PLATINISING, PLATINISES]\n",
  "PLATINISED": "PLATINISE, to coat with platinum, also PLATINIZE [v]\n",
  "PLATINISES": "PLATINISE, to coat with platinum, also PLATINIZE [v]\n",
  "PLATINISING": "PLATINISE, to coat with platinum, also PLATINIZE [v]\n",
  "PLATINIZATION": "the process of platinizing, also PLATINISATION [n -S]\n",
  "PLATINIZATIONS": "PLATINIZATION, the process of platinizing, also PLATINISATION [n]\n",
  "PLATINIZE": "to coat with platinum, also PLATINISE [v PLATINIZED, PLATINIZING, PLATINIZES]\n",
  "PLATINIZED": "PLATINIZE, to coat with platinum, also PLATINISE [v]\n",
  "PLATINIZES": "PLATINIZE, to coat with platinum, also PLATINISE [v]\n",
  "PLATINIZING": "PLATINIZE, to coat with platinum, also PLATINISE [v]\n",
  "PLATINOCYANIC": "as in platinocyanic acid [adj]\n",
  "PLATINOCYANIDE": "a fluorescent complex salt formed by the union of a compound of platinum and cyanide with another cyanide [n -S]\n",
  "PLATINOCYANIDES": "PLATINOCYANIDE, a fluorescent complex salt formed by the union of a compound of platinum and cyanide with another cyanide [n]\n",
  "PLATINOID": "an alloy of copper, zinc, nickel, and tungsten, resembling platinum and resistant to tarnishing [n -S]\n",
  "PLATINOIDS": "PLATINOID, an alloy of copper, zinc, nickel, and tungsten, resembling platinum and resistant to tarnishing [n]\n",
  "PLATINOTYPE": "an obsolete method of photography by reducing a compound of platinum [n -S]\n",
  "PLATINOTYPES": "PLATINOTYPE, an obsolete method of photography by reducing a compound of platinum [n]\n",
  "PLATINOUS": "of or containing platinum in the divalent state [adj]\n",
  "PLATINUM": "a metallic element, also PLATINA [n -S]\n",
  "PLATINUMS": "PLATINUM, a metallic element, also PLATINA [n]\n",
  "PLATITUDE": "a commonplace or trite remark made as if it were important [n -S]\n",
  "PLATITUDES": "PLATITUDE, a commonplace or trite remark made as if it were important [n]\n",
  "PLATITUDINAL": "of or like platitude, also PLATITUDINOUS [adj]\n",
  "PLATITUDINARIAN": "one who utters platitudes [n]\n",
  "PLATITUDINISE": "to utter platitudes, also PLATITUDINIZE [v PLATITUDINISED, PLATITUDINISING, PLATITUDINISES]\n",
  "PLATITUDINISED": "PLATITUDINISE, to utter platitudes, also PLATITUDINIZE [v]\n",
  "PLATITUDINISER": "one who utters platitudes, also PLATITUDINIZER [n -S]\n",
  "PLATITUDINISERS": "PLATITUDINISER, one who utters platitudes, also PLATITUDINIZER [n]\n",
  "PLATITUDINISES": "PLATITUDINISE, to utter platitudes, also PLATITUDINIZE [v]\n",
  "PLATITUDINISING": "PLATITUDINISE, to utter platitudes, also PLATITUDINIZE [v]\n",
  "PLATITUDINIZE": "to utter platitudes, also PLATITUDINISE [v PLATITUDINIZED, PLATITUDINIZING, PLATITUDINIZES]\n",
  "PLATITUDINIZED": "PLATITUDINIZE, to utter platitudes, also PLATITUDINISE [v]\n",
  "PLATITUDINIZER": "one who utters platitudes, also PLATITUDINISER [n -S]\n",
  "PLATITUDINIZERS": "PLATITUDINIZER, one who utters platitudes, also PLATITUDINISER [n]\n",
  "PLATITUDINIZES": "PLATITUDINIZE, to utter platitudes, also PLATITUDINISE [v]\n",
  "PLATITUDINIZING": "PLATITUDINIZE, to utter platitudes, also PLATITUDINISE [v]\n",
  "PLATITUDINOUS": "characterized by or resembling a platitude, also PLATITUDINAL [adj PLATITUDINOUSLY]\n",
  "PLATITUDINOUSLY": "PLATITUDINOUS, characterized by or resembling a platitude, also PLATITUDINAL [adv]\n",
  "PLATONIC": "not erotic [adj PLATONICALLY] / a platonic lover [n -S]\n",
  "PLATONICALLY": "PLATONIC, not erotic [adv]\n",
  "PLATONICS": "PLATONIC, a platonic lover [n]\n",
  "PLATONISM": "the philosophy of Plato [n -S]\n",
  "PLATONISMS": "PLATONISM, the philosophy of Plato [n]\n",
  "PLATOON": "in American football, to alternate with another player at the same position [v -ED, -ING, -S]\n",
  "PLATOONED": "PLATOON, in American football, to alternate with another player at the same position [v]\n",
  "PLATOONING": "PLATOON, in American football, to alternate with another player at the same position [v]\n",
  "PLATOONS": "PLATOON, in American football, to alternate with another player at the same position [v]\n",
  "PLATS": "PLAT, to braid [v]\n",
  "PLATT": "in Scots adjectival phrase 'scale and platt', applied to stairs with straight flights and landings [adj]\n",
  "PLATTED": "PLAT, to braid [v]\n",
  "PLATTELAND": "(South African) rural districts [n -S]\n",
  "PLATTELANDS": "PLATTELAND, (South African) rural districts [n]\n",
  "PLATTER": "a large, shallow dish [n -S]\n",
  "PLATTERFUL": "the contents of a platter [n PLATTERFULS or PLATTERSFUL]\n",
  "PLATTERFULS": "PLATTERFUL, the contents of a platter [n]\n",
  "PLATTERS": "PLATTER, a large, shallow dish [n]\n",
  "PLATTERSFUL": "PLATTERFUL, the contents of a platter [n]\n",
  "PLATTING": "plaited braid, also PLAITING [n -S]\n",
  "PLATTINGS": "PLATTING, plaited braid, also PLAITING [n]\n",
  "PLATY": "split into thin, flat pieces [adj PLATIER, PLATIEST] / a small tropical fish, also PLATYFISH [n PLATIES or PLATYS]\n",
  "PLATYCEPHALIC": "having the vault of the skull flattened, also PLATYCEPHALOUS [adj]\n",
  "PLATYCEPHALOUS": "having the vault of the skull flattened, also PLATYCEPHALIC [adj]\n",
  "PLATYFISH": "a small tropical fish, also PLATY [n -ES]\n",
  "PLATYFISHES": "PLATYFISH, a small tropical fish, also PLATY [n]\n",
  "PLATYHELMINTH": "a tapeworm or planarian [n -S]\n",
  "PLATYHELMINTHIC": "of or like a platyhelminth [adj]\n",
  "PLATYHELMINTHS": "PLATYHELMINTH, a tapeworm or planarian [n]\n",
  "PLATYKURTIC": "in statistics, referring to a distribution showing a particular type of kurtosis [adj]\n",
  "PLATYPI": "PLATYPUS, an aquatic mammal [n]\n",
  "PLATYPUS": "an aquatic mammal [n PLATYPUSES or PLATYPI]\n",
  "PLATYPUSES": "PLATYPUS, an aquatic mammal [n]\n",
  "PLATYRRHINE": "having a broad, flat nose [adj] / a New World monkey [n -S]\n",
  "PLATYRRHINES": "PLATYRRHINE, a New World monkey [n]\n",
  "PLATYRRHINIAN": "having a short, flat nose [adj] / someone with a short flat nose [n -S]\n",
  "PLATYRRHINIANS": "PLATYRRHINIAN, someone with a short flat nose [n]\n",
  "PLATYS": "PLATY, a small tropical fish, also PLATYFISH [n]\n",
  "PLATYSMA": "(Greek) a broad sheet of muscle in the neck [n -S]\n",
  "PLATYSMAS": "PLATYSMA, (Greek) a broad sheet of muscle in the neck [n]\n",
  "PLAUDIT": "(Latin) an expression of praise [n -S]\n",
  "PLAUDITE": "(Latin) an appeal for applause at the conclusion of a play or other performance [interj]\n",
  "PLAUDITORY": "issuing enthusiastic approval or applause [adj]\n",
  "PLAUDITS": "PLAUDIT, (Latin) an expression of praise [n]\n",
  "PLAUSIBILITIES": "PLAUSIBILITY, the state of being plausible [n]\n",
  "PLAUSIBILITY": "the state of being plausible [n PLAUSIBILITIES]\n",
  "PLAUSIBLE": "superficially pleasing or persuasive [adj PLAUSIBLY]\n",
  "PLAUSIBLENESS": "the state of being plausible [n -ES]\n",
  "PLAUSIBLENESSES": "PLAUSIBLENESS, the state of being plausible [n]\n",
  "PLAUSIBLY": "PLAUSIBLE, superficially pleasing or persuasive [adv]\n",
  "PLAUSIVE": "(Shakespeare) expressing praise [adj]\n",
  "PLAUSTRAL": "of or pertaining to a cart or wagon [adj]\n",
  "PLAY": "to engage in recreation [v -ED, -ING, -S]\n",
  "PLAYA": "(Spanish) a basin which becomes a shallow lake after heavy rain, and dries out again [n -S]\n",
  "PLAYABILITIES": "PLAYABILITY, the ability to be played [n]\n",
  "PLAYABILITY": "the ability to be played [n PLAYABILITIES]\n",
  "PLAYABLE": "able to be played [adj]\n",
  "PLAYACT": "to take part in a theatrical performance [v -ED, -ING, -S]\n",
  "PLAYACTED": "PLAYACT, to take part in a theatrical performance [v]\n",
  "PLAYACTING": "pretence [n -S]\n",
  "PLAYACTINGS": "PLAYACTING, pretence [n]\n",
  "PLAYACTOR": "one who playacts [n -S]\n",
  "PLAYACTORS": "PLAYACTOR, one who playacts [n]\n",
  "PLAYACTS": "PLAYACT, to take part in a theatrical performance [v]\n",
  "PLAYAS": "PLAYA, (Spanish) a basin which becomes a shallow lake after heavy rain, and dries out again [n]\n",
  "PLAYBACK": "the act of replaying a newly made recording [n -S]\n",
  "PLAYBACKS": "PLAYBACK, the act of replaying a newly made recording [n]\n",
  "PLAYBILL": "the programme for a theatrical performance [n -S]\n",
  "PLAYBILLS": "PLAYBILL, the programme for a theatrical performance [n]\n",
  "PLAYBOOK": "a printed book of plays [n -S]\n",
  "PLAYBOOKS": "PLAYBOOK, a printed book of plays [n]\n",
  "PLAYBOY": "a man devoted to pleasurable activities [n -S]\n",
  "PLAYBOYS": "PLAYBOY, a man devoted to pleasurable activities [n]\n",
  "PLAYBUS": "a mobile playground [n PLAYBUSES or PLAYBUSSES]\n",
  "PLAYBUSES": "PLAYBUS, a mobile playground [n]\n",
  "PLAYBUSSES": "PLAYBUS, a mobile playground [n]\n",
  "PLAYDATE": "the scheduled date for showing a theatrical production [n -S]\n",
  "PLAYDATES": "PLAYDATE, the scheduled date for showing a theatrical production [n]\n",
  "PLAYDAY": "a holiday [n -S]\n",
  "PLAYDAYS": "PLAYDAY, a holiday [n]\n",
  "PLAYDOUGH": "a soft reusable modelling material for young children [n -S]\n",
  "PLAYDOUGHS": "PLAYDOUGH, a soft reusable modelling material for young children [n]\n",
  "PLAYDOWN": "a playoff [n -S]\n",
  "PLAYDOWNS": "PLAYDOWN, a playoff [n]\n",
  "PLAYED": "PLAY, to engage in recreation [v]\n",
  "PLAYER": "one who plays [n -S]\n",
  "PLAYERS": "PLAYER, one who plays [n]\n",
  "PLAYFELLOW": "a companion in amusements or sports; a playmate [n -S]\n",
  "PLAYFELLOWS": "PLAYFELLOW, a companion in amusements or sports; a playmate [n]\n",
  "PLAYFIELD": "a playing field [n -S]\n",
  "PLAYFIELDS": "PLAYFIELD, a playing field [n]\n",
  "PLAYFUL": "full of fun [adj PLAYFULLY]\n",
  "PLAYFULLY": "PLAYFUL, full of fun [adv]\n",
  "PLAYFULNESS": "the state of being playful [n -ES]\n",
  "PLAYFULNESSES": "PLAYFULNESS, the state of being playful [n]\n",
  "PLAYGIRL": "a women devoted to pleasurable activities [n -S]\n",
  "PLAYGIRLS": "PLAYGIRL, a women devoted to pleasurable activities [n]\n",
  "PLAYGOER": "one who attends plays [n -S]\n",
  "PLAYGOERS": "PLAYGOER, one who attends plays [n]\n",
  "PLAYGOING": "the practice of visiting the theatre [n -S]\n",
  "PLAYGOINGS": "PLAYGOING, the practice of visiting the theatre [n]\n",
  "PLAYGROUND": "a piece of land used for and usually equipped with facilities for recreation esp. by children [n -S]\n",
  "PLAYGROUNDS": "PLAYGROUND, a piece of land used for and usually equipped with facilities for recreation esp. by children [n]\n",
  "PLAYGROUP": "an informal, sometimes voluntarily run group having morning or afternoon sessions attended by preschool children [n -S]\n",
  "PLAYGROUPS": "PLAYGROUP, an informal, sometimes voluntarily run group having morning or afternoon sessions attended by preschool children [n]\n",
  "PLAYHOUSE": "a child's miniature house for playing in [n -S]\n",
  "PLAYHOUSES": "PLAYHOUSE, a child's miniature house for playing in [n]\n",
  "PLAYING": "an act of play [n -S]\n",
  "PLAYINGS": "PLAYING, an act of play [n]\n",
  "PLAYLAND": "a recreational area [n -S]\n",
  "PLAYLANDS": "PLAYLAND, a recreational area [n]\n",
  "PLAYLEADER": "one who organises play [n -S]\n",
  "PLAYLEADERS": "PLAYLEADER, one who organises play [n]\n",
  "PLAYLESS": "lacking playfulness [adj]\n",
  "PLAYLET": "a short theatrical performance [n -S]\n",
  "PLAYLETS": "PLAYLET, a short theatrical performance [n]\n",
  "PLAYLIKE": "resembling a theatrical performance [adj]\n",
  "PLAYLIST": "a list of recordings to be played on the air [n -S] / to put onto a playlist [v -ED, -ING, -S]\n",
  "PLAYLISTED": "PLAYLIST, to put onto a playlist [v]\n",
  "PLAYLISTING": "PLAYLIST, to put onto a playlist [v]\n",
  "PLAYLISTS": "PLAYLIST, to put onto a playlist [v]\n",
  "PLAYMAKER": "a playwright [n -S]\n",
  "PLAYMAKERS": "PLAYMAKER, a playwright [n]\n",
  "PLAYMAKING": "the process of making a play [n -S]\n",
  "PLAYMAKINGS": "PLAYMAKING, the process of making a play [n]\n",
  "PLAYMATE": "a companion in play [n -S]\n",
  "PLAYMATES": "PLAYMATE, a companion in play [n]\n",
  "PLAYOFF": "a game to decide a tie [n -S]\n",
  "PLAYOFFS": "PLAYOFF, a game to decide a tie [n]\n",
  "PLAYPEN": "a safety device for a child's play [n -S]\n",
  "PLAYPENS": "PLAYPEN, a safety device for a child's play [n]\n",
  "PLAYREADER": "one who reads over the script of a play [n -S]\n",
  "PLAYREADERS": "PLAYREADER, one who reads over the script of a play [n]\n",
  "PLAYROOM": "a recreation room [n -S]\n",
  "PLAYROOMS": "PLAYROOM, a recreation room [n]\n",
  "PLAYS": "PLAY, to engage in recreation [v]\n",
  "PLAYSCHOOL": "a nursery school or playgroup [n -S]\n",
  "PLAYSCHOOLS": "PLAYSCHOOL, a nursery school or playgroup [n]\n",
  "PLAYSET": "an outdoor apparatus having equipment for children's activities [n -S]\n",
  "PLAYSETS": "PLAYSET, an outdoor apparatus having equipment for children's activities [n]\n",
  "PLAYSLIP": "a form on which a participant in a lottery draw indicates his or her chosen numbers [n -S]\n",
  "PLAYSLIPS": "PLAYSLIP, a form on which a participant in a lottery draw indicates his or her chosen numbers [n]\n",
  "PLAYSOME": "playful, sportive [adj]\n",
  "PLAYSUIT": "a sports outfit for women and children [n -S]\n",
  "PLAYSUITS": "PLAYSUIT, a sports outfit for women and children [n]\n",
  "PLAYTHING": "something to play with [n -S]\n",
  "PLAYTHINGS": "PLAYTHING, something to play with [n]\n",
  "PLAYTIME": "a time for play [n -S]\n",
  "PLAYTIMES": "PLAYTIME, a time for play [n]\n",
  "PLAYWEAR": "any clothing worn for play [n -S]\n",
  "PLAYWEARS": "PLAYWEAR, any clothing worn for play [n]\n",
  "PLAYWRIGHT": "a person who writes plays [n -S]\n",
  "PLAYWRIGHTING": "the writing of plays [n -S]\n",
  "PLAYWRIGHTINGS": "PLAYWRIGHTING, the writing of plays [n]\n",
  "PLAYWRIGHTS": "PLAYWRIGHT, a person who writes plays [n]\n",
  "PLAYWRITING": "the writing of plays [n -S]\n",
  "PLAYWRITINGS": "PLAYWRITING, the writing of plays [n]\n",
  "PLAZA": "(Spanish) a public square, e.g. in a town [n -S]\n",
  "PLAZAS": "PLAZA, (Spanish) a public square, e.g. in a town [n]\n",
  "PLEA": "to dispute in a court [v -ED, -ING, -S]\n",
  "PLEACH": "to weave together [v -ED, -ING, -ES]\n",
  "PLEACHED": "PLEACH, to weave together [v]\n",
  "PLEACHES": "PLEACH, to weave together [v]\n",
  "PLEACHING": "PLEACH, to weave together [v]\n",
  "PLEAD": "to beg for earnestly [v PLED or PLEADED, PLEADING, PLEADS]\n",
  "PLEADABLE": "capable of being pleaded [adj]\n",
  "PLEADED": "PLEAD, to beg for earnestly [v]\n",
  "PLEADER": "one who pleads; an advocate [n -S]\n",
  "PLEADERS": "PLEADER, one who pleads; an advocate [n]\n",
  "PLEADING": "the act of conducting a plea [n -S]\n",
  "PLEADINGLY": "PLEADING [adv]\n",
  "PLEADINGS": "PLEADING, the act of conducting a plea [n]\n",
  "PLEADS": "PLEAD, to beg for earnestly [v]\n",
  "PLEAED": "PLEA, to dispute in a court [v]\n",
  "PLEAING": "PLEA, to dispute in a court [v]\n",
  "PLEAS": "PLEA, to dispute in a court [v]\n",
  "PLEASABLE": "capable of being pleased [adj]\n",
  "PLEASANCE": "(archaic) a pleasure ground or specialized part of a garden [n -S]\n",
  "PLEASANCES": "PLEASANCE, (archaic) a pleasure ground or specialized part of a garden [n]\n",
  "PLEASANT": "pleasing [adj PLEASANTER, PLEASANTEST, PLEASANTLY]\n",
  "PLEASANTER": "PLEASANT, pleasing [adj]\n",
  "PLEASANTEST": "PLEASANT, pleasing [adj]\n",
  "PLEASANTLY": "PLEASANT, pleasing [adv]\n",
  "PLEASANTNESS": "the state of being pleasant [n -ES]\n",
  "PLEASANTNESSES": "PLEASANTNESS, the state of being pleasant [n]\n",
  "PLEASANTRIES": "PLEASANTRY, a humorous act or remark [n]\n",
  "PLEASANTRY": "a humorous act or remark [n PLEASANTRIES]\n",
  "PLEASE": "to give enjoyment or satisfaction to, also PLEASURE [v PLEASED, PLEASING, PLEASETH or PLEASES]\n",
  "PLEASED": "PLEASE, to give enjoyment or satisfaction to, also PLEASURE [v]\n",
  "PLEASEDLY": "PLEASED, PLEASE, to give enjoyment or satisfaction to, also PLEASURE [adv]\n",
  "PLEASEMAN": "(Shakespeare) an officious fellow; a pickthank [n PLEASEMEN]\n",
  "PLEASEMEN": "PLEASEMAN, (Shakespeare) an officious fellow; a pickthank [n]\n",
  "PLEASER": "one who pleases [n -S]\n",
  "PLEASERS": "PLEASER, one who pleases [n]\n",
  "PLEASES": "PLEASE, to give enjoyment or satisfaction to, also PLEASURE [v]\n",
  "PLEASETH": "(Shakespeare) 3rd person singular of please, to give enjoyment or satisfaction to [v]\n",
  "PLEASING": "gratifying [adj PLEASINGLY] / the act of pleasing [n -S]\n",
  "PLEASINGLY": "PLEASING, gratifying [adv]\n",
  "PLEASINGNESS": "the state of being pleasing [n -ES]\n",
  "PLEASINGNESSES": "PLEASINGNESS, the state of being pleasing [n]\n",
  "PLEASINGS": "PLEASING, the act of pleasing [n]\n",
  "PLEASURABILITY": "the state of being pleasurable [n]\n",
  "PLEASURABLE": "giving pleasure [adj PLEASURABLY]\n",
  "PLEASURABLENESS": "PLEASURABLE, giving pleasure [n]\n",
  "PLEASURABLY": "PLEASURABLE, giving pleasure [adv]\n",
  "PLEASURE": "to give enjoyment or satisfaction to [v PLEASURED, PLEASURING, PLEASURES]\n",
  "PLEASURED": "PLEASURE, to give enjoyment or satisfaction to [v]\n",
  "PLEASUREFUL": "full of pleasure [adj]\n",
  "PLEASURELESS": "giving no pleasure [adj]\n",
  "PLEASURER": "a pleasure seeker [n -S]\n",
  "PLEASURERS": "PLEASURER, a pleasure seeker [n]\n",
  "PLEASURES": "PLEASURE, to give enjoyment or satisfaction to [v]\n",
  "PLEASURING": "PLEASURE, to give enjoyment or satisfaction to [v]\n",
  "PLEAT": "to fold in an even manner [v -ED, -ING, -S]\n",
  "PLEATED": "PLEAT, to fold in an even manner [v]\n",
  "PLEATER": "one who pleats [n -S]\n",
  "PLEATERS": "PLEATER, one who pleats [n]\n",
  "PLEATHER": "a plastic fabric made to look like leather [n -S]\n",
  "PLEATHERS": "PLEATHER, a plastic fabric made to look like leather [n]\n",
  "PLEATING": "a set of pleats [n -S]\n",
  "PLEATINGS": "PLEATING, a set of pleats [n]\n",
  "PLEATLESS": "without pleats [adj]\n",
  "PLEATS": "PLEAT, to fold in an even manner [v]\n",
  "PLEB": "(short for) a plebeian, a commoner [n -S]\n",
  "PLEBBIER": "PLEBBY, (colloquial) vulgar, plebeian [adj]\n",
  "PLEBBIEST": "PLEBBY, (colloquial) vulgar, plebeian [adj]\n",
  "PLEBBY": "(colloquial) vulgar, plebeian [adj PLEBBIER, PLEBBIEST]\n",
  "PLEBE": "a freshman at a military or naval academy [n -S]\n",
  "PLEBEAN": "(Shakespeare) plebeian, of the common people [adj]\n",
  "PLEBEIAN": "relating to the common people or vulgar classes, also PLEBEAN [adj PLEBEIANLY] / one of the common people [n -S]\n",
  "PLEBEIANISE": "to make plebeian, also PLEBEIANIZE [v PLEBEIANISED, PLEBEIANISING, PLEBEIANISES]\n",
  "PLEBEIANISED": "PLEBEIANISE, to make plebeian, also PLEBEIANIZE [v]\n",
  "PLEBEIANISES": "PLEBEIANISE, to make plebeian, also PLEBEIANIZE [v]\n",
  "PLEBEIANISING": "PLEBEIANISE, to make plebeian, also PLEBEIANIZE [v]\n",
  "PLEBEIANISM": "the state of being plebeian [n -S]\n",
  "PLEBEIANISMS": "PLEBEIANISM, the state of being plebeian [n]\n",
  "PLEBEIANIZE": "to make plebeian, also PLEBEIANISE [v PLEBEIANIZED, PLEBEIANIZING, PLEBEIANIZES]\n",
  "PLEBEIANIZED": "PLEBEIANIZE, to make plebeian, also PLEBEIANISE [v]\n",
  "PLEBEIANIZES": "PLEBEIANIZE, to make plebeian, also PLEBEIANISE [v]\n",
  "PLEBEIANIZING": "PLEBEIANIZE, to make plebeian, also PLEBEIANISE [v]\n",
  "PLEBEIANLY": "PLEBEIAN, relating to the common people or vulgar classes, also PLEBEAN [adv]\n",
  "PLEBEIANS": "PLEBEIAN, one of the common people [n]\n",
  "PLEBES": "PLEBE, a freshman at a military or naval academy [n]\n",
  "PLEBIFICATION": "making something vulgar or plebeian [n -S]\n",
  "PLEBIFICATIONS": "PLEBIFICATION, making something vulgar or plebeian [n]\n",
  "PLEBIFIED": "PLEBIFY, to lower to vulgar standards [v]\n",
  "PLEBIFIES": "PLEBIFY, to lower to vulgar standards [v]\n",
  "PLEBIFY": "to lower to vulgar standards [v PLEBIFIED, PLEBIFYING, PLEBIFIES]\n",
  "PLEBIFYING": "PLEBIFY, to lower to vulgar standards [v]\n",
  "PLEBISCITARY": "relating to a plebiscite [adj]\n",
  "PLEBISCITE": "a direct vote of the whole nation or of the people of a district on a special point [n -S]\n",
  "PLEBISCITES": "PLEBISCITE, a direct vote of the whole nation or of the people of a district on a special point [n]\n",
  "PLEBS": "PLEB, (short for) a plebeian, a commoner [n]\n",
  "PLECOPTERAN": "a member of the Plecoptera, stoneflies [n -S]\n",
  "PLECOPTERANS": "PLECOPTERAN, a member of the Plecoptera, stoneflies [n]\n",
  "PLECOPTEROUS": "of or like the Plecoptera, stoneflies [adj]\n",
  "PLECTOGNATH": "any spiny-finned marine fish of the mainly tropical order Plectognathi, that includes puffers, triggerfish, trunkfish and sunfish [n -S]\n",
  "PLECTOGNATHIC": "belonging to an order of bony fishes including filefishes, also PLECTOGNATHOUS [adj]\n",
  "PLECTOGNATHOUS": "belonging to an order of bony fishes including filefishes, also PLECTOGNATHIC [adj]\n",
  "PLECTOGNATHS": "PLECTOGNATH, any spiny-finned marine fish of the mainly tropical order Plectognathi, that includes puffers, triggerfish, trunkfish and sunfish [n]\n",
  "PLECTOPTEROUS": "of or like the Plectoptera, mayflies [adj]\n",
  "PLECTRA": "PLECTRON, a small pointed object for plucking guitar strings, also PLECTRUM, PLECTRE [n]\n",
  "PLECTRE": "a small pointed object for plucking guitar strings, also PLECTRUM, PLECTRON [n -S]\n",
  "PLECTRES": "PLECTRE, a small pointed object for plucking guitar strings, also PLECTRUM, PLECTRON [n]\n",
  "PLECTRON": "a small pointed object for plucking guitar strings, also PLECTRUM, PLECTRE [n PLECTRONS or PLECTRA]\n",
  "PLECTRONS": "PLECTRON, a small pointed object for plucking guitar strings, also PLECTRUM, PLECTRE [n]\n",
  "PLECTRUM": "(Latin) a small pointed object for plucking guitar strings, also PLECTRE, PLECTRON [n -S]\n",
  "PLECTRUMS": "PLECTRUM, (Latin) a small pointed object for plucking guitar strings, also PLECTRE, PLECTRON [n]\n",
  "PLED": "PLEAD, to beg for earnestly [v]\n",
  "PLEDGABLE": "capable of being pledged [adj]\n",
  "PLEDGE": "to bind by solemn promise [v PLEDGED, PLEDGING, PLEDGES]\n",
  "PLEDGEABLE": "that can be pledged [adj]\n",
  "PLEDGED": "PLEDGE, to bind by solemn promise [v]\n",
  "PLEDGEE": "one to whom something is pledged [n -S]\n",
  "PLEDGEES": "PLEDGEE, one to whom something is pledged [n]\n",
  "PLEDGEOR": "one who pledges something, also PLEDGER, PLEDGOR [n -S]\n",
  "PLEDGEORS": "PLEDGEOR, one who pledges something, also PLEDGER, PLEDGOR [n]\n",
  "PLEDGER": "one who pledges something, also PLEDGEOR, PLEDGOR [n -S]\n",
  "PLEDGERS": "PLEDGER, one who pledges something, also PLEDGEOR, PLEDGOR [n]\n",
  "PLEDGES": "PLEDGE, to bind by solemn promise [v]\n",
  "PLEDGET": "a pad of absorbent cotton [n -S]\n",
  "PLEDGETS": "PLEDGET, a pad of absorbent cotton [n]\n",
  "PLEDGING": "PLEDGE, to bind by solemn promise [v]\n",
  "PLEDGOR": "one who pledges something, also PLEDGER, PLEDGEOR [n -S]\n",
  "PLEDGORS": "PLEDGOR, one who pledges something, also PLEDGER, PLEDGEOR [n]\n",
  "PLEIAD": "(Greek) a group of seven illustrious persons [n PLEIADS or PLEIADES]\n",
  "PLEIADES": "PLEIAD, (Greek) a group of seven illustrious persons [n]\n",
  "PLEIADS": "PLEIAD, (Greek) a group of seven illustrious persons [n]\n",
  "PLEINAIRISM": "painting in the open air [n -S]\n",
  "PLEINAIRISMS": "PLEINAIRISM, painting in the open air [n]\n",
  "PLEINAIRIST": "one who practises pleinairism, painting in the open air [n -S]\n",
  "PLEINAIRISTS": "PLEINAIRIST, one who practises pleinairism, painting in the open air [n]\n",
  "PLEIOCENE": "of the Pliocene geological time period, also PLIOCENE [adj]\n",
  "PLEIOCHASIA": "PLEIOCHASIUM, a cymose inflorescence in which each branch bears more than two lateral branches [n]\n",
  "PLEIOCHASIUM": "a cymose inflorescence in which each branch bears more than two lateral branches [n PLEIOCHASIA]\n",
  "PLEIOMERIES": "PLEIOMERY, the state of being pleiomerous, having more than the normal number of parts [n]\n",
  "PLEIOMEROUS": "of a floral whorl, having more than the normal number of parts [adj]\n",
  "PLEIOMERY": "the state of being pleiomerous, having more than the normal number of parts [n PLEIOMERIES]\n",
  "PLEIOTAXIES": "PLEIOTAXY, an increase in the whorls of a flower [n]\n",
  "PLEIOTAXY": "an increase in the whorls of a flower [n PLEIOTAXIES]\n",
  "PLEIOTROPIC": "of a gene, having an effect simultaneously on more than one character in the offspring [adj]\n",
  "PLEIOTROPIES": "PLEIOTROPY, the property of having an effect simultaneously on more than one characteristic of the offspring [n]\n",
  "PLEIOTROPISM": "the state of being pleiotropic, having an effect simultaneously on more than one character in the offspring [n -S]\n",
  "PLEIOTROPISMS": "PLEIOTROPISM, the state of being pleiotropic, having an effect simultaneously on more than one character in the offspring [n]\n",
  "PLEIOTROPY": "the property of having an effect simultaneously on more than one characteristic of the offspring [n PLEIOTROPIES]\n",
  "PLENA": "PLENUM, (Latin) space considered as fully occupied by matter [n]\n",
  "PLENARIES": "PLENARY, a book of gospels or epistles read at the Eucharist [n]\n",
  "PLENARILY": "PLENARY, attended by all members [adv]\n",
  "PLENARTIES": "PLENARTY, the state of an occupied benefice [n]\n",
  "PLENARTY": "the state of an occupied benefice [n PLENARTIES]\n",
  "PLENARY": "attended by all members [adj PLENARILY] / a book of gospels or epistles read at the Eucharist [n PLENARIES]\n",
  "PLENCH": "a tool serving as pliers and a wrench [n -ES]\n",
  "PLENCHES": "PLENCH, a tool serving as pliers and a wrench [n]\n",
  "PLENILUNAR": "of or relating to the full moon [adj]\n",
  "PLENILUNE": "the time of the full moon [n -S]\n",
  "PLENILUNES": "PLENILUNE, the time of the full moon [n]\n",
  "PLENIPO": "(archaic) a plenipotentiary, an envoy having full power [n PLENIPOS or PLENIPOES]\n",
  "PLENIPOES": "PLENIPO, (archaic) a plenipotentiary, an envoy having full power [n]\n",
  "PLENIPOS": "PLENIPO, (archaic) a plenipotentiary, an envoy having full power [n]\n",
  "PLENIPOTENCE": "absolute power, also PLENIPOTENCY [n -S]\n",
  "PLENIPOTENCES": "PLENIPOTENCE, absolute power, also PLENIPOTENCY [n]\n",
  "PLENIPOTENCIES": "PLENIPOTENCY, absolute power, also PLENIPOTENCE [n]\n",
  "PLENIPOTENCY": "absolute power, also PLENIPOTENCE [n PLENIPOTENCIES]\n",
  "PLENIPOTENT": "having absolute power, also PLENIPOTENTIAL [adj]\n",
  "PLENIPOTENTIAL": "having absolute power, also PLENIPOTENT [adj]\n",
  "PLENIPOTENTIARY": "of e.g. an envoy, having full power [adj]\n",
  "PLENISH": "to fill up [v -ED, -ING, -ES]\n",
  "PLENISHED": "PLENISH, to fill up [v]\n",
  "PLENISHER": "one who plenishes [n -S]\n",
  "PLENISHERS": "PLENISHER, one who plenishes [n]\n",
  "PLENISHES": "PLENISH, to fill up [v]\n",
  "PLENISHING": "(Scots) furniture [n -S]\n",
  "PLENISHINGS": "PLENISHING, (Scots) furniture [n]\n",
  "PLENISHMENT": "the act of plenishing [n -S]\n",
  "PLENISHMENTS": "PLENISHMENT, the act of plenishing [n]\n",
  "PLENISM": "the doctrine that space is fully occupied by matter [n -S]\n",
  "PLENISMS": "PLENISM, the doctrine that space is fully occupied by matter [n]\n",
  "PLENIST": "one who holds that all space is full of matter [n -S]\n",
  "PLENISTS": "PLENIST, one who holds that all space is full of matter [n]\n",
  "PLENITUDE": "fullness, completeness [n -S]\n",
  "PLENITUDES": "PLENITUDE, fullness, completeness [n]\n",
  "PLENITUDINOUS": "full, complete [adj]\n",
  "PLENTEOUS": "plentiful [adj PLENTEOUSLY]\n",
  "PLENTEOUSLY": "PLENTEOUS, plentiful [adv]\n",
  "PLENTEOUSNESS": "the state of being plenteous [n -ES]\n",
  "PLENTEOUSNESSES": "PLENTEOUSNESS, the state of being plenteous [n]\n",
  "PLENTIES": "PLENTY, an abundant amount [n]\n",
  "PLENTIFUL": "abundant [adj PLENTIFULLY]\n",
  "PLENTIFULLY": "PLENTIFUL, abundant [adv]\n",
  "PLENTIFULNESS": "the state of being plentiful [n -ES]\n",
  "PLENTIFULNESSES": "PLENTIFULNESS, the state of being plentiful [n]\n",
  "PLENTITUDE": "plenitude [n -S]\n",
  "PLENTITUDES": "PLENTITUDE, plenitude [n]\n",
  "PLENTY": "an abundant amount [n PLENTIES]\n",
  "PLENUM": "(Latin) space considered as fully occupied by matter [n PLENUMS or PLENA]\n",
  "PLENUMS": "PLENUM, (Latin) space considered as fully occupied by matter [n]\n",
  "PLEOCHROIC": "displaying different colours when seen from different directions, also POLYCHROIC [adj]\n",
  "PLEOCHROISM": "the property of differentially absorbing different wavelengths of light depending on their direction of incidence or state of polarization [n -S]\n",
  "PLEOCHROISMS": "PLEOCHROISM, the property of differentially absorbing different wavelengths of light depending on their direction of incidence or state of polarization [n]\n",
  "PLEOMORPHIC": "occurring in several different forms, also PLEOMORPHOUS [adj]\n",
  "PLEOMORPHIES": "PLEOMORPHY, the state of being pleomorphic, occurring in several different forms [n]\n",
  "PLEOMORPHISM": "polymorphism; the occurrence of two or more structural forms during a life cycle [n -S]\n",
  "PLEOMORPHISMS": "PLEOMORPHISM, polymorphism; the occurrence of two or more structural forms during a life cycle [n]\n",
  "PLEOMORPHOUS": "occurring in several different forms, also PLEOMORPHIC [adj]\n",
  "PLEOMORPHY": "the state of being pleomorphic, occurring in several different forms [n PLEOMORPHIES]\n",
  "PLEON": "(Greek) the abdomen of a crustacean, bearing the swimming legs [n -S]\n",
  "PLEONAL": "relating to the pleon, also PLEONIC [adj]\n",
  "PLEONASM": "the use of needless words [n -S]\n",
  "PLEONASMS": "PLEONASM, the use of needless words [n]\n",
  "PLEONAST": "someone who is prone to redundancy [n -S]\n",
  "PLEONASTE": "a dark-green to black variety of spinel [n -S]\n",
  "PLEONASTES": "PLEONASTE, a dark-green to black variety of spinel [n]\n",
  "PLEONASTIC": "relating to pleonasm, also PLEONASTICAL [adj PLEONASTICALLY]\n",
  "PLEONASTICAL": "relating to pleonasm, also PLEONASTIC [adj PLEONASTICALLY]\n",
  "PLEONASTICALLY": "PLEONASTICAL, relating to pleonasm, also PLEONASTIC [adv]\n",
  "PLEONASTS": "PLEONAST, someone who is prone to redundancy [n]\n",
  "PLEONECTIC": "greedy; covetous [adj]\n",
  "PLEONEXIA": "excessive or insatiable covetousness [n -S]\n",
  "PLEONEXIAS": "PLEONEXIA, excessive or insatiable covetousness [n]\n",
  "PLEONIC": "relating to the pleon, the abdomen of crustaceans, also PLEONAL [adj]\n",
  "PLEONS": "PLEON, (Greek) the abdomen of a crustacean, bearing the swimming legs [n]\n",
  "PLEOPOD": "an appendage of crustaceans [n -S]\n",
  "PLEOPODS": "PLEOPOD, an appendage of crustaceans [n]\n",
  "PLERION": "a supernova remnant emitting radiation from both centre and shell [n -S]\n",
  "PLERIONS": "PLERION, a supernova remnant emitting radiation from both centre and shell [n]\n",
  "PLEROCERCOID": "the infective larva of tapeworms [n -S]\n",
  "PLEROCERCOIDS": "PLEROCERCOID, the infective larva of tapeworms [n]\n",
  "PLEROMA": "(Greek) fullness, abundance; in Gnosticism, divine being [n -S]\n",
  "PLEROMAS": "PLEROMA, (Greek) fullness, abundance; in Gnosticism, divine being [n]\n",
  "PLEROMATIC": "of or like a pleroma, fullness, abundance; in Gnosticism, divine being [adj]\n",
  "PLEROME": "(Greek) part of a plant responsible for growth [n -S]\n",
  "PLEROMES": "PLEROME, (Greek) part of a plant responsible for growth [n]\n",
  "PLEROPHORIA": "full conviction, also PLEROPHORY [n -S]\n",
  "PLEROPHORIAS": "PLEROPHORIA, full conviction, also PLEROPHORY [n]\n",
  "PLEROPHORIES": "PLEROPHORY, full conviction, also PLEROPHORIA [n]\n",
  "PLEROPHORY": "full conviction, also PLEROPHORIA [n PLEROPHORIES]\n",
  "PLESH": "(Spenser) a pool; a plash [n -ES]\n",
  "PLESHES": "PLESH, (Spenser) a pool; a plash [n]\n",
  "PLESIOSAUR": "any of a group of extinct marine reptiles of Mesozoic times [n -S]\n",
  "PLESIOSAURIAN": "a member of the reptile order Plesiosauria, extinct marine reptiles of Mesozoic times [n -S]\n",
  "PLESIOSAURIANS": "PLESIOSAURIAN, a member of the reptile order Plesiosauria, extinct marine reptiles of Mesozoic times [n]\n",
  "PLESIOSAURS": "PLESIOSAUR, any of a group of extinct marine reptiles of Mesozoic times [n]\n",
  "PLESSIMETER": "a small plate to receive the tap in examination by percussion, also PLEXIMETER [n -S]\n",
  "PLESSIMETERS": "PLESSIMETER, a small plate to receive the tap in examination by percussion, also PLEXIMETER [n]\n",
  "PLESSIMETRIC": "relating to a plessimeter [adj]\n",
  "PLESSIMETRIES": "PLESSIMETRY, the use of a plessimeter, a small plate to receive the tap in examination by percussion [n]\n",
  "PLESSIMETRY": "the use of a plessimeter, a small plate to receive the tap in examination by percussion [n PLESSIMETRIES]\n",
  "PLESSOR": "(Greek) a small, hammer-like medical instrument, also PLEXOR [n -S]\n",
  "PLESSORS": "PLESSOR, (Greek) a small, hammer-like medical instrument, also PLEXOR [n]\n",
  "PLETHORA": "(Greek) an excess, a superfluity [n -S]\n",
  "PLETHORAS": "PLETHORA, (Greek) an excess, a superfluity [n]\n",
  "PLETHORIC": "having a full habit of body; characterized by plethora or excess of blood, also PLETHORICAL [adj PLETHORICALLY]\n",
  "PLETHORICAL": "having a full habit of body; characterized by plethora or excess of blood, also PLETHORIC [adj PLETHORICALLY]\n",
  "PLETHORICALLY": "PLETHORICAL, having a full habit of body; characterized by plethora or excess of blood, also PLETHORIC [adv]\n",
  "PLETHYSMOGRAM": "a tracing made by a plethysmograph [n -S]\n",
  "PLETHYSMOGRAMS": "PLETHYSMOGRAM, a tracing made by a plethysmograph [n]\n",
  "PLETHYSMOGRAPH": "an instrument for measuring change in body part size due to blood flow [n -S]\n",
  "PLETHYSMOGRAPHS": "PLETHYSMOGRAPH, an instrument for measuring change in body part size due to blood flow [n]\n",
  "PLETHYSMOGRAPHY": "measurement by use of a plethysmograph, an instrument for measuring change in body part size due to blood flow [n]\n",
  "PLEUCH": "(Scots) to plough, also PLEUGH [v -ED, -ING, -S]\n",
  "PLEUCHED": "PLEUCH, (Scots) to plough, also PLEUGH [v]\n",
  "PLEUCHING": "PLEUCH, (Scots) to plough, also PLEUGH [v]\n",
  "PLEUCHS": "PLEUCH, (Scots) to plough, also PLEUGH [v]\n",
  "PLEUGH": "(Scots) to plough, also PLEUCH [v -ED, -ING, -S]\n",
  "PLEUGHED": "PLEUGH, (Scots) to plough, also PLEUCH [v]\n",
  "PLEUGHING": "PLEUGH, (Scots) to plough, also PLEUCH [v]\n",
  "PLEUGHS": "PLEUGH, (Scots) to plough, also PLEUCH [v]\n",
  "PLEURA": "(Greek) a membrane that covers the lungs [n PLEURAS or PLEURAE]\n",
  "PLEURAE": "PLEURA, (Greek) a membrane that covers the lungs [n]\n",
  "PLEURAL": "of or pertaining to the pleura or pleurae, or to the sides of the thorax [adj]\n",
  "PLEURAPOPHYSES": "PLEURAPOPHYSIS, a lateral process of a vertebra, with the morphological character of a rib [n]\n",
  "PLEURAPOPHYSIS": "a lateral process of a vertebra, with the morphological character of a rib [n PLEURAPOPHYSES]\n",
  "PLEURAS": "PLEURA, (Greek) a membrane that covers the lungs [n]\n",
  "PLEURISIES": "PLEURISY, inflammation of the pleura [n]\n",
  "PLEURISY": "inflammation of the pleura [n PLEURISIES]\n",
  "PLEURITIC": "suffering from pleurisy, also PLEURITICAL [adj] / someone with pleurisy [n -S]\n",
  "PLEURITICAL": "affected with pleurisy, also PLEURITIC [adj]\n",
  "PLEURITICS": "PLEURITIC, someone with pleurisy [n]\n",
  "PLEURITIS": "inflammation of the pleura, also PLEURISY [n -ES]\n",
  "PLEURITISES": "PLEURITIS, inflammation of the pleura, also PLEURISY [n]\n",
  "PLEUROCARPOUS": "of mosses, having the archegonia on short lateral branches [adj]\n",
  "PLEUROCENTESES": "PLEUROCENTESIS, the surgical puncture of the pleural cavity using a hollow needle, in order to withdraw fluid, drain blood, etc. [n]\n",
  "PLEUROCENTESIS": "the surgical puncture of the pleural cavity using a hollow needle, in order to withdraw fluid, drain blood, etc. [n PLEUROCENTESES]\n",
  "PLEURODONT": "with teeth attached to the inside of the jawbone, rather than rooted in it [adj] / a pleurodont animal, such as a reptile [n -S]\n",
  "PLEURODONTS": "PLEURODONT, a pleurodont animal, such as a reptile [n]\n",
  "PLEURODYNIA": "pain in the muscles of the chest or side [n -S]\n",
  "PLEURODYNIAS": "PLEURODYNIA, pain in the muscles of the chest or side [n]\n",
  "PLEURON": "(Greek) a part of a thoracic segment of an insect [n PLEURA]\n",
  "PLEURONIA": "the combined disorder of pleurisy and pneumonia [n -S]\n",
  "PLEURONIAS": "PLEURONIA, the combined disorder of pleurisy and pneumonia [n]\n",
  "PLEUROPNEUMONIA": "pneumonia aggravated by pleurisy [n]\n",
  "PLEUROTOMIES": "PLEUROTOMY, incision into the pleura [n]\n",
  "PLEUROTOMY": "incision into the pleura [n PLEUROTOMIES]\n",
  "PLEUSTON": "organisms living in the thin surface layer of fresh water [n -S]\n",
  "PLEUSTONIC": "relating to pleuston [adj]\n",
  "PLEUSTONS": "PLEUSTON, organisms living in the thin surface layer of fresh water [n]\n",
  "PLEW": "a beaver skin, as a tradable item of value, also PLUE, PLU [n -S]\n",
  "PLEWS": "PLEW, a beaver skin, as a tradable item of value, also PLUE, PLU [n]\n",
  "PLEX": "to make a plexus [v -ED, -ING, -ES]\n",
  "PLEXAL": "pertaining to a plexus, a network [adj]\n",
  "PLEXED": "PLEX, to make a plexus [v]\n",
  "PLEXES": "PLEX, to make a plexus [v]\n",
  "PLEXIFORM": "in the form of a network [adj]\n",
  "PLEXIGLASS": "acrylic plastic sheets [n -ES]\n",
  "PLEXIGLASSES": "PLEXIGLASS, acrylic plastic sheets [n]\n",
  "PLEXIMETER": "a small plate to receive the tap in examination by percussion, also PLESSIMETER [n -S]\n",
  "PLEXIMETERS": "PLEXIMETER, a small plate to receive the tap in examination by percussion, also PLESSIMETER [n]\n",
  "PLEXIMETRIC": "relating to a pleximeter [adj]\n",
  "PLEXIMETRIES": "PLEXIMETRY, the use of a pleximeter, a small, hard, elastic plate, as of ivory, bone, or rubber, placed in contact with body to receive the blow, in examination by mediate percussion [n]\n",
  "PLEXIMETRY": "the use of a pleximeter, a small, hard, elastic plate, as of ivory, bone, or rubber, placed in contact with body to receive the blow, in examination by mediate percussion [n PLEXIMETRIES]\n",
  "PLEXING": "PLEX, to make a plexus [v]\n",
  "PLEXOR": "(Greek) a small, rubber-headed hammer that physicians use to test reflexes, also PLESSOR [n -S]\n",
  "PLEXORS": "PLEXOR, (Greek) a small, rubber-headed hammer that physicians use to test reflexes, also PLESSOR [n]\n",
  "PLEXURE": "an interweaving [n -S]\n",
  "PLEXURES": "PLEXURE, an interweaving [n]\n",
  "PLEXUS": "(Latin) an interlacing of parts [n -ES]\n",
  "PLEXUSES": "PLEXUS, (Latin) an interlacing of parts [n]\n",
  "PLIABILITIES": "PLIABILITY, the state of being pliable [n]\n",
  "PLIABILITY": "the state of being pliable [n PLIABILITIES]\n",
  "PLIABLE": "easily bent [adj PLIABLY]\n",
  "PLIABLENESS": "the quality of being pliable [n -ES]\n",
  "PLIABLENESSES": "PLIABLENESS, the quality of being pliable [n]\n",
  "PLIABLY": "PLIABLE, easily bent [adv]\n",
  "PLIANCIES": "PLIANCY, the quality of being pliant [n]\n",
  "PLIANCY": "the quality of being pliant [n PLIANCIES]\n",
  "PLIANT": "easily bent [adj PLIANTLY]\n",
  "PLIANTLY": "PLIANT, easily bent [adv]\n",
  "PLIANTNESS": "the state of being pliant [n -ES]\n",
  "PLIANTNESSES": "PLIANTNESS, the state of being pliant [n]\n",
  "PLICA": "(Latin) a fold; also, a disease of the hair, in which it becomes twisted and matted together [n PLICAE or PLICAS]\n",
  "PLICAE": "PLICA, (Latin) a fold; also, a disease of the hair, in which it becomes twisted and matted together [n]\n",
  "PLICAL": "relating to a plica [adj]\n",
  "PLICAS": "PLICA, (Latin) a fold; also, a disease of the hair, in which it becomes twisted and matted together [n]\n",
  "PLICATE": "folded like a fan [adj PLICATELY] / to pleat, fold like a fan [v PLICATED, PLICATING, PLICATES]\n",
  "PLICATED": "PLICATE, to pleat, fold like a fan [v]\n",
  "PLICATELY": "PLICATE, folded like a fan [adv]\n",
  "PLICATENESS": "the state of being plicate [n -ES]\n",
  "PLICATENESSES": "PLICATENESS, the state of being plicate [n]\n",
  "PLICATES": "PLICATE, to pleat, fold like a fan [v]\n",
  "PLICATING": "PLICATE, to pleat, fold like a fan [v]\n",
  "PLICATION": "the act of folding, also PLICATURE [n -S]\n",
  "PLICATIONS": "PLICATION, the act of folding, also PLICATURE [n]\n",
  "PLICATURE": "the act of folding, also PLICATION [n -S]\n",
  "PLICATURES": "PLICATURE, the act of folding, also PLICATION [n]\n",
  "PLIE": "(French) a movement in ballet [n -S]\n",
  "PLIED": "PLY, to bend or fold [v]\n",
  "PLIER": "one who plies, also PLYER [n -S]\n",
  "PLIERS": "PLIER, one who plies, also PLYER [n]\n",
  "PLIES": "PLIE, (French) a movement in ballet [n]\n",
  "PLIGHT": "to make a solemn pledge [v PLIGHTED or (obsolete) YPLIGHT, PLIGHTING, PLIGHTS]\n",
  "PLIGHTED": "PLIGHT, to make a solemn pledge [v]\n",
  "PLIGHTER": "one who, or that which, plights [n -S]\n",
  "PLIGHTERS": "PLIGHTER, one who, or that which, plights [n]\n",
  "PLIGHTFUL": "grievous [adj]\n",
  "PLIGHTING": "PLIGHT, to make a solemn pledge [v]\n",
  "PLIGHTS": "PLIGHT, to make a solemn pledge [v]\n",
  "PLIM": "to swell, as grain or wood with water [v PLIMMED, PLIMMING, PLIMS]\n",
  "PLIMMED": "PLIM, to swell, as grain or wood with water [v]\n",
  "PLIMMING": "PLIM, to swell, as grain or wood with water [v]\n",
  "PLIMS": "PLIM, to swell, as grain or wood with water [v]\n",
  "PLIMSOL": "a rubber-soled cloth shoe, also PLIMSOLL, PLIMSOLE [n -S]\n",
  "PLIMSOLE": "a rubber-soled cloth shoe, also PLIMSOLL, PLIMSOL [n -S]\n",
  "PLIMSOLES": "PLIMSOLE, a rubber-soled cloth shoe, also PLIMSOLL, PLIMSOL [n]\n",
  "PLIMSOLL": "a rubber-soled cloth shoe, also PLIMSOL, PLIMSOLE [n -S]\n",
  "PLIMSOLLS": "PLIMSOLL, a rubber-soled cloth shoe, also PLIMSOL, PLIMSOLE [n]\n",
  "PLIMSOLS": "PLIMSOL, a rubber-soled cloth shoe, also PLIMSOLL, PLIMSOLE [n]\n",
  "PLING": "to beg [v -ED, -ING, -S]\n",
  "PLINGED": "PLING, to beg [v]\n",
  "PLINGING": "PLING, to beg [v]\n",
  "PLINGS": "PLING, to beg [v]\n",
  "PLINK": "to shoot at a tin can or the like [v -ED, -ING, -S]\n",
  "PLINKED": "PLINK, to shoot at a tin can or the like [v]\n",
  "PLINKER": "one who plinks, shoots informally at a variety of targets [n -S]\n",
  "PLINKERS": "PLINKER, one who plinks, shoots informally at a variety of targets [n]\n",
  "PLINKIER": "PLINKY, of a high pitched sound from a stringed instrument when plucked [adj]\n",
  "PLINKIEST": "PLINKY, of a high pitched sound from a stringed instrument when plucked [adj]\n",
  "PLINKING": "shooting at a tin can or the like [n -S]\n",
  "PLINKINGS": "PLINKING, shooting at a tin can or the like [n]\n",
  "PLINKS": "PLINK, to shoot at a tin can or the like [v]\n",
  "PLINKY": "of a high pitched sound from a stringed instrument when plucked [adj PLINKIER, PLINKIEST]\n",
  "PLINTH": "the rectangular base of a column or pedestal [n -S]\n",
  "PLINTHS": "PLINTH, the rectangular base of a column or pedestal [n]\n",
  "PLIOCENE": "relating to the epoch where mammals appeared [adj]\n",
  "PLIOFILM": "a transparent sheet of chlorinated rubber used in packaging [n -S]\n",
  "PLIOFILMS": "PLIOFILM, a transparent sheet of chlorinated rubber used in packaging [n]\n",
  "PLIOSAUR": "a type of fossil marine reptile [n -S]\n",
  "PLIOSAURS": "PLIOSAUR, a type of fossil marine reptile [n]\n",
  "PLIOTRON": "a type of vacuum tube [n -S]\n",
  "PLIOTRONS": "PLIOTRON, a type of vacuum tube [n]\n",
  "PLISKIE": "(Scots) tricky, mischievous, also PLISKY [adj PLISKIER, PLISKIEST] / a practical joke; a trick [n -S]\n",
  "PLISKIER": "PLISKIE, (Scots) tricky, mischievous, also PLISKY [adj]\n",
  "PLISKIES": "PLISKIE, a practical joke; a trick [n]\n",
  "PLISKIEST": "PLISKIE, (Scots) tricky, mischievous, also PLISKY [adj]\n",
  "PLISKY": "(Scots) a practical joke, also PLISKIE [n PLISKIES]\n",
  "PLISSE": "(French) a puckered texture of cloth [n -S]\n",
  "PLISSES": "PLISSE, (French) a puckered texture of cloth [n]\n",
  "PLOAT": "(Scots) to dip in very hot water, to scald [v -ED, -ING, -S]\n",
  "PLOATED": "PLOAT, (Scots) to dip in very hot water, to scald [v]\n",
  "PLOATING": "PLOAT, (Scots) to dip in very hot water, to scald [v]\n",
  "PLOATS": "PLOAT, (Scots) to dip in very hot water, to scald [v]\n",
  "PLOD": "to walk heavily [v PLODDED, PLODDING, PLODS]\n",
  "PLODDED": "PLOD, to walk heavily [v]\n",
  "PLODDER": "one who plods; a slow, dull person [n -S]\n",
  "PLODDERS": "PLODDER, one who plods; a slow, dull person [n]\n",
  "PLODDING": "slow in thought or movement [adj PLODDINGLY] / the act of plodding [n -S]\n",
  "PLODDINGLY": "PLODDING, slow in thought or movement [adv]\n",
  "PLODDINGNESS": "the state of being plodding [n -ES]\n",
  "PLODDINGNESSES": "PLODDINGNESS, the state of being plodding [n]\n",
  "PLODDINGS": "PLODDING, the act of plodding [n]\n",
  "PLODGE": "(dialect) to wade in water [v PLODGED, PLODGING, PLODGES]\n",
  "PLODGED": "PLODGE, (dialect) to wade in water [v]\n",
  "PLODGES": "PLODGE, (dialect) to wade in water [v]\n",
  "PLODGING": "PLODGE, (dialect) to wade in water [v]\n",
  "PLODS": "PLOD, to walk heavily [v]\n",
  "PLOGGING": "a recreational activity, originating in Sweden, that combines jogging with picking up litter [n -S]\n",
  "PLOGGINGS": "PLOGGING, a recreational activity, originating in Sweden, that combines jogging with picking up litter [n]\n",
  "PLOIDIES": "PLOIDY, the number of chromosomes in a cell [n]\n",
  "PLOIDY": "the number of chromosomes in a cell [n PLOIDIES]\n",
  "PLONG": "(Spenser) to plunge, also PLONGE [v PLONGD or PLONGED, PLONGING, PLONGS]\n",
  "PLONGD": "(Spenser) plunged [v]\n",
  "PLONGE": "(Spenser) to plunge, also PLONG [v PLONGED, PLONGING, PLONGES]\n",
  "PLONGED": "PLONGE, (Spenser) to plunge, also PLONG [v]\n",
  "PLONGES": "PLONGE, (Spenser) to plunge, also PLONG [v]\n",
  "PLONGING": "PLONGE, (Spenser) to plunge, also PLONG [v]\n",
  "PLONGS": "PLONG, (Spenser) to plunge, also PLONGE [v]\n",
  "PLONK": "to fall or drop heavily, also PLUNK, PLOP [v -ED, -ING, -S]\n",
  "PLONKED": "PLONK, to fall or drop heavily, also PLUNK, PLOP [v]\n",
  "PLONKER": "a large marble, also PLUNKER [n -S]\n",
  "PLONKERS": "PLONKER, a large marble, also PLUNKER [n]\n",
  "PLONKIER": "PLONKY, pompously self-important about mundane matters [adj]\n",
  "PLONKIEST": "PLONKY, pompously self-important about mundane matters [adj]\n",
  "PLONKING": "the practice of making self-important remarks about mundane matters [n -S]\n",
  "PLONKINGS": "PLONKING, the practice of making self-important remarks about mundane matters [n]\n",
  "PLONKO": "(Australian slang) an alcoholic esp. one who drinks wine [n -S]\n",
  "PLONKOS": "PLONKO, (Australian slang) an alcoholic esp. one who drinks wine [n]\n",
  "PLONKS": "PLONK, to fall or drop heavily, also PLUNK, PLOP [v]\n",
  "PLONKY": "pompously self-important about mundane matters [adj PLONKIER, PLONKIEST]\n",
  "PLOOK": "(Scots) a pimple, also PLOUK [n -S]\n",
  "PLOOKIE": "(Scots) pimply, also PLOOKY, PLOUKY, PLOUKIE [adj PLOOKIER, PLOOKIEST]\n",
  "PLOOKIER": "PLOOKY, pimply, also PLOOKIE, PLOUKY, PLOUKIE [adj]\n",
  "PLOOKIEST": "PLOOKY, pimply, also PLOOKIE, PLOUKY, PLOUKIE [adj]\n",
  "PLOOKS": "PLOOK, (Scots) a pimple, also PLOUK [n]\n",
  "PLOOKY": "pimply, also PLOOKIE, PLOUKY, PLOUKIE [adj PLOOKIER, PLOOKIEST]\n",
  "PLOP": "to fall or drop heavily [v PLOPPED, PLOPPING, PLOPS]\n",
  "PLOPPED": "PLOP, to fall or drop heavily [v]\n",
  "PLOPPING": "PLOP, to fall or drop heavily [v]\n",
  "PLOPS": "PLOP, to fall or drop heavily [v]\n",
  "PLOSION": "a release of breath after articulating certain consonants [n -S]\n",
  "PLOSIONS": "PLOSION, a release of breath after articulating certain consonants [n]\n",
  "PLOSIVE": "an explosive (sound), as p [n -S]\n",
  "PLOSIVES": "PLOSIVE, an explosive (sound), as p [n]\n",
  "PLOT": "to plan secretly [v PLOTTED, PLOTTING, PLOTS]\n",
  "PLOTFUL": "conspiratorial [adj]\n",
  "PLOTLESS": "without a plot [adj]\n",
  "PLOTLESSNESS": "the state of being plotless [n -ES]\n",
  "PLOTLESSNESSES": "PLOTLESSNESS, the state of being plotless [n]\n",
  "PLOTLINE": "the main story of a literary work [n -S]\n",
  "PLOTLINES": "PLOTLINE, the main story of a literary work [n]\n",
  "PLOTS": "PLOT, to plan secretly [v]\n",
  "PLOTTAGE": "the size or value of a specified piece of land, regarded in terms of the area accumulated from its constituent plots [n -S]\n",
  "PLOTTAGES": "PLOTTAGE, the size or value of a specified piece of land, regarded in terms of the area accumulated from its constituent plots [n]\n",
  "PLOTTED": "PLOT, to plan secretly [v]\n",
  "PLOTTER": "(Scots) to dabble in liquid, also PLOUTER, PLOWTER [v -ED, -ING, -S]\n",
  "PLOTTERED": "PLOTTER, (Scots) to dabble in liquid, also PLOUTER, PLOWTER [v]\n",
  "PLOTTERING": "PLOTTER, (Scots) to dabble in liquid, also PLOUTER, PLOWTER [v]\n",
  "PLOTTERS": "PLOTTER, (Scots) to dabble in liquid, also PLOUTER, PLOWTER [v]\n",
  "PLOTTIE": "a spiced hot drink, such as mulled wine, also PLOTTY [n -S]\n",
  "PLOTTIER": "PLOTTY, full of intrigue, as a novel [adj]\n",
  "PLOTTIES": "PLOTTIE, a spiced hot drink, such as mulled wine, also PLOTTY [n]\n",
  "PLOTTIEST": "PLOTTY, full of intrigue, as a novel [adj]\n",
  "PLOTTING": "conspiratorial [adj PLOTTINGLY] / the act of plotting [n -S]\n",
  "PLOTTINGLY": "PLOTTING, conspiratorial [adv]\n",
  "PLOTTINGS": "PLOTTING, the act of plotting [n]\n",
  "PLOTTY": "full of intrigue, as a novel [adj PLOTTIER, PLOTTIEST] / a spiced hot drink, such as mulled wine, also PLOTTIE [n PLOTTIES]\n",
  "PLOTZ": "(Yiddish) to explode, esp. with intense emotion [v PLOTZED, PLOTZING, PLOTZES]\n",
  "PLOTZED": "PLOTZ, (Yiddish) to explode, esp. with intense emotion [v]\n",
  "PLOTZES": "PLOTZ, (Yiddish) to explode, esp. with intense emotion [v]\n",
  "PLOTZING": "PLOTZ, (Yiddish) to explode, esp. with intense emotion [v]\n",
  "PLOUGH": "to turn soil with a farm implement, also PLOW [v -ED, -ING, -S]\n",
  "PLOUGHABLE": "capable of being plowed; arable, also PLOWABLE [adj]\n",
  "PLOUGHBACK": "the reinvestment of profits, also PLOWBACK [n -S]\n",
  "PLOUGHBACKS": "PLOUGHBACK, the reinvestment of profits, also PLOWBACK [n]\n",
  "PLOUGHBOY": "a boy who drives or guides horses in ploughing, also PLOWBOY [n -S]\n",
  "PLOUGHBOYS": "PLOUGHBOY, a boy who drives or guides horses in ploughing, also PLOWBOY [n]\n",
  "PLOUGHED": "PLOUGH, to turn soil with a farm implement, also PLOW [v]\n",
  "PLOUGHER": "one who ploughs, also PLOWER [n -S]\n",
  "PLOUGHERS": "PLOUGHER, one who ploughs, also PLOWER [n]\n",
  "PLOUGHGATE": "(Scots) plowland [n -S]\n",
  "PLOUGHGATES": "PLOUGHGATE, (Scots) plowland [n]\n",
  "PLOUGHHEAD": "the draught iron of a plough, also PLOWHEAD [n -S]\n",
  "PLOUGHHEADS": "PLOUGHHEAD, the draught iron of a plough, also PLOWHEAD [n]\n",
  "PLOUGHING": "the act of ploughing [n -S]\n",
  "PLOUGHINGS": "PLOUGHING, the act of ploughing [n]\n",
  "PLOUGHLAND": "land under the plough, also PLOWLAND [n -S]\n",
  "PLOUGHLANDS": "PLOUGHLAND, land under the plough, also PLOWLAND [n]\n",
  "PLOUGHMAN": "a man who drives or guides horses in ploughing, also PLOWMAN [n PLOUGHMEN]\n",
  "PLOUGHMANSHIP": "the craft of a ploughman, also PLOWMANSHIP [n -S]\n",
  "PLOUGHMANSHIPS": "PLOUGHMANSHIP, the craft of a ploughman, also PLOWMANSHIP [n]\n",
  "PLOUGHMEN": "PLOUGHMAN, a man who drives or guides horses in ploughing, also PLOWMAN [n]\n",
  "PLOUGHS": "PLOUGH, to turn soil with a farm implement, also PLOW [v]\n",
  "PLOUGHSHARE": "the cutting blade of a plough, also PLOWSHARE [n -S]\n",
  "PLOUGHSHARES": "PLOUGHSHARE, the cutting blade of a plough, also PLOWSHARE [n]\n",
  "PLOUGHSTAFF": "one of the handles of a plough, also PLOWSTAFF [n -S]\n",
  "PLOUGHSTAFFS": "PLOUGHSTAFF, one of the handles of a plough, also PLOWSTAFF [n]\n",
  "PLOUGHTAIL": "the end of a plough where the handles are, also PLOWTAIL [n -S]\n",
  "PLOUGHTAILS": "PLOUGHTAIL, the end of a plough where the handles are, also PLOWTAIL [n]\n",
  "PLOUGHWISE": "as in ploughing, also PLOWWISE [adv]\n",
  "PLOUGHWRIGHT": "one who makes ploughs, also PLOWWRIGHT [n -S]\n",
  "PLOUGHWRIGHTS": "PLOUGHWRIGHT, one who makes ploughs, also PLOWWRIGHT [n]\n",
  "PLOUK": "(Scots) a pimple, also PLOOK [n -S]\n",
  "PLOUKIE": "(Scots) pimply, also PLOOKIE, PLOOKY, PLOUKY [adj PLOUKIER, PLOUKIEST]\n",
  "PLOUKIER": "PLOUKIE, (Scots) pimply, also PLOOKIE, PLOOKY, PLOUKY [adj]\n",
  "PLOUKIEST": "PLOUKIE, (Scots) pimply, also PLOOKIE, PLOOKY, PLOUKY [adj]\n",
  "PLOUKS": "PLOUK, (Scots) a pimple, also PLOOK [n]\n",
  "PLOUKY": "pimply, also PLOOKIE, PLOOKY, PLOUKIE [adj PLOUKIER, PLOUKIEST]\n",
  "PLOUTER": "(Scots) to dabble in liquid, also PLOTTER, PLOWTER [v -ED, -ING, -S]\n",
  "PLOUTERED": "PLOUTER, (Scots) to dabble in liquid, also PLOTTER, PLOWTER [v]\n",
  "PLOUTERING": "PLOUTER, (Scots) to dabble in liquid, also PLOTTER, PLOWTER [v]\n",
  "PLOUTERS": "PLOUTER, (Scots) to dabble in liquid, also PLOTTER, PLOWTER [v]\n",
  "PLOVER": "a general name for birds of the family Charadriidae to which the lapwing and dotterel belong [n -S]\n",
  "PLOVERIER": "PLOVERY, abounding in plovers [adj]\n",
  "PLOVERIEST": "PLOVERY, abounding in plovers [adj]\n",
  "PLOVERS": "PLOVER, a general name for birds of the family Charadriidae to which the lapwing and dotterel belong [n]\n",
  "PLOVERY": "abounding in plovers [adj PLOVERIER, PLOVERIEST]\n",
  "PLOW": "to turn soil with a farm implement, also PLOUGH [v -ED, -ING, -S]\n",
  "PLOWABLE": "able to be plowed [adj]\n",
  "PLOWBACK": "a reinvestment of profits in a business, also PLOUGHBACK [n -S]\n",
  "PLOWBACKS": "PLOWBACK, a reinvestment of profits in a business, also PLOUGHBACK [n]\n",
  "PLOWBOY": "a boy who drives or guides horses in ploughing, also PLOUGHBOY [n -S]\n",
  "PLOWBOYS": "PLOWBOY, a boy who drives or guides horses in ploughing, also PLOUGHBOY [n]\n",
  "PLOWED": "PLOW, to turn soil with a farm implement, also PLOUGH [v]\n",
  "PLOWER": "one who ploughs, also PLOUGHER [n -S]\n",
  "PLOWERS": "PLOWER, one who ploughs, also PLOUGHER [n]\n",
  "PLOWHEAD": "the clevis of a plough, also PLOUGHHEAD [n -S]\n",
  "PLOWHEADS": "PLOWHEAD, the clevis of a plough, also PLOUGHHEAD [n]\n",
  "PLOWING": "the act of ploughing [n -S]\n",
  "PLOWINGS": "PLOWING, the act of ploughing [n]\n",
  "PLOWLAND": "land under the plough, also PLOUGHLAND [n -S]\n",
  "PLOWLANDS": "PLOWLAND, land under the plough, also PLOUGHLAND [n]\n",
  "PLOWMAN": "a man who drives or guides horses in ploughing, also PLOUGHMAN [n PLOWMEN]\n",
  "PLOWMANSHIP": "the craft of the plowman, also PLOUGHMANSHIP [n -S]\n",
  "PLOWMANSHIPS": "PLOWMANSHIP, the craft of the plowman, also PLOUGHMANSHIP [n]\n",
  "PLOWMEN": "PLOWMAN, a man who drives or guides horses in ploughing, also PLOUGHMAN [n]\n",
  "PLOWS": "PLOW, to turn soil with a farm implement, also PLOUGH [v]\n",
  "PLOWSHARE": "the cutting blade of a plow, also PLOUGHSHARE [n -S]\n",
  "PLOWSHARES": "PLOWSHARE, the cutting blade of a plow, also PLOUGHSHARE [n]\n",
  "PLOWSTAFF": "one of the handles of a plow, also PLOUGHSTAFF [n -S]\n",
  "PLOWSTAFFS": "PLOWSTAFF, one of the handles of a plow, also PLOUGHSTAFF [n]\n",
  "PLOWTAIL": "the end of a plough where the handles are, also PLOUGHTAIL [n -S]\n",
  "PLOWTAILS": "PLOWTAIL, the end of a plough where the handles are, also PLOUGHTAIL [n]\n",
  "PLOWTER": "(Scots) to dabble in liquid, also PLOTTER, PLOUTER [v -ED, -ING, -S]\n",
  "PLOWTERED": "PLOWTER, (Scots) to dabble in liquid, also PLOTTER, PLOUTER [v]\n",
  "PLOWTERING": "PLOWTER, (Scots) to dabble in liquid, also PLOTTER, PLOUTER [v]\n",
  "PLOWTERS": "PLOWTER, (Scots) to dabble in liquid, also PLOTTER, PLOUTER [v]\n",
  "PLOWWISE": "back and forth in alternate rows, in the manner of a plough, also PLOUGHWISE [adv]\n",
  "PLOWWRIGHT": "one who makes ploughs, also PLOUGHWRIGHT [n -S]\n",
  "PLOWWRIGHTS": "PLOWWRIGHT, one who makes ploughs, also PLOUGHWRIGHT [n]\n",
  "PLOY": "to move from a line into column [v -ED, -ING, -S]\n",
  "PLOYE": "a buckwheat pancake [n -S]\n",
  "PLOYED": "PLOY, to move from a line into column [v]\n",
  "PLOYES": "PLOYE, a buckwheat pancake [n]\n",
  "PLOYING": "PLOY, to move from a line into column [v]\n",
  "PLOYS": "PLOY, to move from a line into column [v]\n",
  "PLU": "(Canadian) a beaver pelt for trading, also PLUE, PLEW [n -S]\n",
  "PLUCK": "to pull out or off [v -ED, -ING, -S]\n",
  "PLUCKED": "PLUCK, to pull out or off [v]\n",
  "PLUCKER": "one who plucks [n -S]\n",
  "PLUCKERS": "PLUCKER, one who plucks [n]\n",
  "PLUCKIER": "PLUCKY, brave and spirited [adj]\n",
  "PLUCKIEST": "PLUCKY, brave and spirited [adj]\n",
  "PLUCKILY": "PLUCKY, brave and spirited [adv]\n",
  "PLUCKINESS": "the state of being plucky [n -ES]\n",
  "PLUCKINESSES": "PLUCKINESS, the state of being plucky [n]\n",
  "PLUCKING": "PLUCK, to pull out or off [v]\n",
  "PLUCKS": "PLUCK, to pull out or off [v]\n",
  "PLUCKY": "brave and spirited [adj PLUCKIER, PLUCKIEST, PLUCKILY]\n",
  "PLUE": "(Canadian) a beaver pelt for trading, also PLEW, PLU [n -S]\n",
  "PLUES": "PLUE, (Canadian) a beaver pelt for trading, also PLEW, PLU [n]\n",
  "PLUFF": "to throw out, as smoke, dust, etc., in puffs [v -ED, -ING, -S]\n",
  "PLUFFED": "PLUFF, to throw out, as smoke, dust, etc., in puffs [v]\n",
  "PLUFFIER": "PLUFFY, puffed up, puffy [adj]\n",
  "PLUFFIEST": "PLUFFY, puffed up, puffy [adj]\n",
  "PLUFFING": "PLUFF, to throw out, as smoke, dust, etc., in puffs [v]\n",
  "PLUFFS": "PLUFF, to throw out, as smoke, dust, etc., in puffs [v]\n",
  "PLUFFY": "puffed up, puffy [adj PLUFFIER, PLUFFIEST]\n",
  "PLUG": "to fill a hole with a material [v PLUGGED, PLUGGING, PLUGS]\n",
  "PLUGBOARD": "a device with a large number of electrical sockets [n -S]\n",
  "PLUGBOARDS": "PLUGBOARD, a device with a large number of electrical sockets [n]\n",
  "PLUGGED": "PLUG, to fill a hole with a material [v]\n",
  "PLUGGER": "something for plugging e.g. a dentist's instrument [n -S]\n",
  "PLUGGERS": "PLUGGER, something for plugging e.g. a dentist's instrument [n]\n",
  "PLUGGING": "stuff which forms a plug [n -S]\n",
  "PLUGGINGS": "PLUGGING, stuff which forms a plug [n]\n",
  "PLUGHOLE": "a drain-hole in a sink, bath etc. which may be stopped with a plug [n -S]\n",
  "PLUGHOLES": "PLUGHOLE, a drain-hole in a sink, bath etc. which may be stopped with a plug [n]\n",
  "PLUGLESS": "without a plug [adj]\n",
  "PLUGOLA": "a free incidental advertising on radio or television [n -S]\n",
  "PLUGOLAS": "PLUGOLA, a free incidental advertising on radio or television [n]\n",
  "PLUGS": "PLUG, to fill a hole with a material [v]\n",
  "PLUGUGLIES": "PLUGUGLY, a very ugly person [n]\n",
  "PLUGUGLY": "a very ugly person [n PLUGUGLIES]\n",
  "PLUM": "a fleshy fruit [n -S] / plum coloured; choice [adj PLUMMER, PLUMMEST]\n",
  "PLUMAGE": "the feathers of a bird [n -S]\n",
  "PLUMAGED": "having plumage [adj]\n",
  "PLUMAGES": "PLUMAGE, the feathers of a bird [n]\n",
  "PLUMASSIER": "(French) a worker in feathers; a feather-seller [n -S]\n",
  "PLUMASSIERS": "PLUMASSIER, (French) a worker in feathers; a feather-seller [n]\n",
  "PLUMATE": "having feathers or plumes, also PLUMOSE, PLUMOUS [adj]\n",
  "PLUMB": "to determine the depth of [v -ED, -ING, -S]\n",
  "PLUMBABLE": "that can be plumbed [adj]\n",
  "PLUMBAGINACEOUS": "belonging to the Plumbaginaceae, leadworts [adj]\n",
  "PLUMBAGINOUS": "of or like plumbago, graphite [adj]\n",
  "PLUMBAGO": "(Latin) graphite [n -S]\n",
  "PLUMBAGOS": "PLUMBAGO, (Latin) graphite [n]\n",
  "PLUMBATE": "a salt of plumbic acid [n -S]\n",
  "PLUMBATES": "PLUMBATE, a salt of plumbic acid [n]\n",
  "PLUMBED": "PLUMB, to determine the depth of [v]\n",
  "PLUMBEOUS": "leaden; lead-coloured [adj]\n",
  "PLUMBER": "one who installs or repairs plumbing [n -S]\n",
  "PLUMBERIES": "PLUMBERY, the work of a plumber [n]\n",
  "PLUMBERS": "PLUMBER, one who installs or repairs plumbing [n]\n",
  "PLUMBERY": "the work of a plumber [n PLUMBERIES]\n",
  "PLUMBIC": "containing lead [adj]\n",
  "PLUMBIFEROUS": "bearing or yielding lead [adj]\n",
  "PLUMBING": "the pipe system of a building [n -S]\n",
  "PLUMBINGS": "PLUMBING, the pipe system of a building [n]\n",
  "PLUMBISM": "lead poisoning [n -S]\n",
  "PLUMBISMS": "PLUMBISM, lead poisoning [n]\n",
  "PLUMBISOLVENCY": "the ability to dissolve lead, also PLUMBOSOLVENCY [n]\n",
  "PLUMBISOLVENT": "able to dissolve lead, also PLUMBOSOLVENT [adj]\n",
  "PLUMBITE": "a salt of plumbic acid [n -S]\n",
  "PLUMBITES": "PLUMBITE, a salt of plumbic acid [n]\n",
  "PLUMBLESS": "incapable of being sounded [adj]\n",
  "PLUMBNESS": "the state of being plumb [n -ES]\n",
  "PLUMBNESSES": "PLUMBNESS, the state of being plumb [n]\n",
  "PLUMBOSOLVENCY": "the ability to dissolve lead, also PLUMBISOLVENCY [n]\n",
  "PLUMBOSOLVENT": "able to dissolve lead, also PLUMBISOLVENT [adj]\n",
  "PLUMBOUS": "containing lead [adj]\n",
  "PLUMBS": "PLUMB, to determine the depth of [v]\n",
  "PLUMBUM": "(obsolete) lead [n -S]\n",
  "PLUMBUMS": "PLUMBUM, (obsolete) lead [n]\n",
  "PLUMCAKE": "a cake with raisins in it [n -S]\n",
  "PLUMCAKES": "PLUMCAKE, a cake with raisins in it [n]\n",
  "PLUMCOT": "a hybrid of a plum and an apricot, also PLUOT [n -S]\n",
  "PLUMCOTS": "PLUMCOT, a hybrid of a plum and an apricot, also PLUOT [n]\n",
  "PLUMDAMAS": "(Scots) a damson [n -ES]\n",
  "PLUMDAMASES": "PLUMDAMAS, (Scots) a damson [n]\n",
  "PLUME": "to cover with feathers [v PLUMED, PLUMING, PLUMES]\n",
  "PLUMED": "PLUME, to cover with feathers [v]\n",
  "PLUMELESS": "without plumes [adj]\n",
  "PLUMELET": "a small feather [n -S]\n",
  "PLUMELETS": "PLUMELET, a small feather [n]\n",
  "PLUMELIKE": "like a plume [adj]\n",
  "PLUMERIA": "a flowering shrub, aka frangipani [n -S]\n",
  "PLUMERIAS": "PLUMERIA, a flowering shrub, aka frangipani [n]\n",
  "PLUMERIES": "PLUMERY, plumes collectively [n]\n",
  "PLUMERY": "plumes collectively [n PLUMERIES]\n",
  "PLUMES": "PLUME, to cover with feathers [v]\n",
  "PLUMIER": "PLUMY, covered with feathers [adj]\n",
  "PLUMIEST": "PLUMY, covered with feathers [adj]\n",
  "PLUMIGEROUS": "plumaged [adj]\n",
  "PLUMING": "PLUME, to cover with feathers [v]\n",
  "PLUMIPED": "a bird with feathered feet [n -S]\n",
  "PLUMIPEDS": "PLUMIPED, a bird with feathered feet [n]\n",
  "PLUMIST": "a feather-dresser [n -S]\n",
  "PLUMISTS": "PLUMIST, a feather-dresser [n]\n",
  "PLUMLIKE": "like a plum [adj]\n",
  "PLUMMER": "PLUM, plum coloured; choice [adj]\n",
  "PLUMMEST": "PLUM, plum coloured; choice [adj]\n",
  "PLUMMET": "to drop straight down [v -ED, -ING, -S]\n",
  "PLUMMETED": "PLUMMET, to drop straight down [v]\n",
  "PLUMMETING": "PLUMMET, to drop straight down [v]\n",
  "PLUMMETS": "PLUMMET, to drop straight down [v]\n",
  "PLUMMIER": "PLUMMY, full of plums [adj]\n",
  "PLUMMIEST": "PLUMMY, full of plums [adj]\n",
  "PLUMMY": "full of plums [adj PLUMMIER, PLUMMIEST]\n",
  "PLUMOSE": "having feathers or plumes, also PLUMATE, PLUMOUS [adj]\n",
  "PLUMOSELY": "PLUMOSE, having feathers or plumes, also PLUMATE, PLUMOUS [adv]\n",
  "PLUMOSITIES": "PLUMOSITY, the state of being plumose [n]\n",
  "PLUMOSITY": "the state of being plumose [n PLUMOSITIES]\n",
  "PLUMOUS": "having feathers or plumes, also PLUMATE, PLUMOSE [adj]\n",
  "PLUMP": "to make well rounded and full in form [v -ED, -ING, -S] / somewhat fat [adj PLUMPER, PLUMPEST, PLUMPLY]\n",
  "PLUMPED": "PLUMP, to make well rounded and full in form [v]\n",
  "PLUMPEN": "to plump, to make well rounded and full in form [v -ED, -ING, -S]\n",
  "PLUMPENED": "PLUMPEN, to plump, to make well rounded and full in form [v]\n",
  "PLUMPENING": "PLUMPEN, to plump, to make well rounded and full in form [v]\n",
  "PLUMPENS": "PLUMPEN, to plump, to make well rounded and full in form [v]\n",
  "PLUMPER": "a pad kept in the mouth to round the cheeks, used by actors [n -S]\n",
  "PLUMPERS": "PLUMPER, a pad kept in the mouth to round the cheeks, used by actors [n]\n",
  "PLUMPEST": "PLUMP, somewhat fat [adj]\n",
  "PLUMPIE": "(Shakespeare) somewhat fat, also PLUMPY [adj PLUMPIER, PLUMPIEST]\n",
  "PLUMPIER": "PLUMPY, (Shakespeare) somewhat plump, also PLUMPIE [adj]\n",
  "PLUMPIEST": "PLUMPY, (Shakespeare) somewhat plump, also PLUMPIE [adj]\n",
  "PLUMPING": "PLUMP, to make well rounded and full in form [v]\n",
  "PLUMPISH": "somewhat plump [adj]\n",
  "PLUMPLY": "PLUMP, somewhat fat [adv]\n",
  "PLUMPNESS": "the state of being plump [n -ES]\n",
  "PLUMPNESSES": "PLUMPNESS, the state of being plump [n]\n",
  "PLUMPS": "PLUMP, to make well rounded and full in form [v]\n",
  "PLUMPY": "(Shakespeare) somewhat plump, also PLUMPIE [adj PLUMPIER, PLUMPIEST]\n",
  "PLUMS": "PLUM, a fleshy fruit [n]\n",
  "PLUMULA": "(Latin) the embryo shoot in a seed, also PLUMULE [n PLUMULAE]\n",
  "PLUMULACEOUS": "of or like plumulae, little feathers [adj]\n",
  "PLUMULAE": "PLUMULA, (Latin) the embryo shoot in a seed, also PLUMULE [n]\n",
  "PLUMULAR": "relating to a plumule, a little feather or plume [adj]\n",
  "PLUMULARIAN": "a member of the Plumularia, a kind of Hydrozoa [n -S]\n",
  "PLUMULARIANS": "PLUMULARIAN, a member of the Plumularia, a kind of Hydrozoa [n]\n",
  "PLUMULATE": "downy [adj]\n",
  "PLUMULE": "the embryo shoot in a seed, also PLUMULA [n -S]\n",
  "PLUMULES": "PLUMULE, the embryo shoot in a seed, also PLUMULA [n]\n",
  "PLUMULOSE": "having hairs branching out laterally, like the parts of a feather [adj]\n",
  "PLUMY": "covered with feathers [adj PLUMIER, PLUMIEST]\n",
  "PLUNDER": "to rob by force [v -ED, -ING, -S]\n",
  "PLUNDERABLE": "that can be plundered [adj]\n",
  "PLUNDERAGE": "the embezzlement of goods on shipboard [n -S]\n",
  "PLUNDERAGES": "PLUNDERAGE, the embezzlement of goods on shipboard [n]\n",
  "PLUNDERED": "PLUNDER, to rob by force [v]\n",
  "PLUNDERER": "one who plunders [n -S]\n",
  "PLUNDERERS": "PLUNDERER, one who plunders [n]\n",
  "PLUNDERING": "PLUNDER, to rob by force [v]\n",
  "PLUNDEROUS": "of or like plunder [adj]\n",
  "PLUNDERS": "PLUNDER, to rob by force [v]\n",
  "PLUNGE": "to thrust into the midst of [v PLUNGED, PLUNGING, PLUNGES]\n",
  "PLUNGED": "PLUNGE, to thrust into the midst of [v]\n",
  "PLUNGER": "an instrument or part of a mechanism which works or is worked with a plunging or thrusting movement [n -S]\n",
  "PLUNGERS": "PLUNGER, an instrument or part of a mechanism which works or is worked with a plunging or thrusting movement [n]\n",
  "PLUNGES": "PLUNGE, to thrust into the midst of [v]\n",
  "PLUNGING": "the act of plunging [n -S]\n",
  "PLUNGINGS": "PLUNGING, the act of plunging [n]\n",
  "PLUNK": "to twang; to pluck the strings of a harp [v -ED, -ING, -S]\n",
  "PLUNKED": "PLUNK, to twang; to pluck the strings of a harp [v]\n",
  "PLUNKER": "a large marble, also PLONKER [n -S]\n",
  "PLUNKERS": "PLUNKER, a large marble, also PLONKER [n]\n",
  "PLUNKIER": "PLUNKY, marked by a quick, hollow metallic sound [adj]\n",
  "PLUNKIEST": "PLUNKY, marked by a quick, hollow metallic sound [adj]\n",
  "PLUNKING": "PLUNK, to twang; to pluck the strings of a harp [v]\n",
  "PLUNKS": "PLUNK, to twang; to pluck the strings of a harp [v]\n",
  "PLUNKY": "marked by a quick, hollow metallic sound [adj PLUNKIER, PLUNKIEST]\n",
  "PLUOT": "a hybrid fruit of plum and apricot, also PLUMCOT [n -S]\n",
  "PLUOTS": "PLUOT, a hybrid fruit of plum and apricot, also PLUMCOT [n]\n",
  "PLUPERFECT": "a tense denoting completion of action before a certain point in past time [n -S]\n",
  "PLUPERFECTS": "PLUPERFECT, a tense denoting completion of action before a certain point in past time [n]\n",
  "PLURAL": "more than one [adj PLURALLY] / a word that expresses more than one [n -S]\n",
  "PLURALISATION": "the act of pluralising, also PLURALIZATION [n -S]\n",
  "PLURALISATIONS": "PLURALISATION, the act of pluralising, also PLURALIZATION [n]\n",
  "PLURALISE": "to make plural [v PLURALISED, PLURALISING, PLURALISES]\n",
  "PLURALISED": "PLURALISE, to make plural [v]\n",
  "PLURALISER": "one who pluralises, also PLURALIZER [n -S]\n",
  "PLURALISERS": "PLURALISER, one who pluralises, also PLURALIZER [n]\n",
  "PLURALISES": "PLURALISE, to make plural [v]\n",
  "PLURALISING": "PLURALISE, to make plural [v]\n",
  "PLURALISM": "a theory or system of thought recognizing more than one ultimate principle [n -S]\n",
  "PLURALISMS": "PLURALISM, a theory or system of thought recognizing more than one ultimate principle [n]\n",
  "PLURALIST": "an adherent of pluralism, a theory or system of thought recognizing more than one ultimate principle [n -S]\n",
  "PLURALISTIC": "relating to pluralism [adj PLURALISTICALLY]\n",
  "PLURALISTICALLY": "PLURALISTIC, relating to pluralism [adv]\n",
  "PLURALISTS": "PLURALIST, an adherent of pluralism, a theory or system of thought recognizing more than one ultimate principle [n]\n",
  "PLURALITIES": "PLURALITY, the state of being plural [n]\n",
  "PLURALITY": "the state of being plural [n PLURALITIES]\n",
  "PLURALIZATION": "the act of pluralizing, also PLURALISATION [n -S]\n",
  "PLURALIZATIONS": "PLURALIZATION, the act of pluralizing, also PLURALISATION [n]\n",
  "PLURALIZE": "to make plural, also PLURALISE [v PLURALIZED, PLURALIZING, PLURALIZES]\n",
  "PLURALIZED": "PLURALIZE, to make plural, also PLURALISE [v]\n",
  "PLURALIZER": "one who pluralizes, also PLURALISER [n -S]\n",
  "PLURALIZERS": "PLURALIZER, one who pluralizes, also PLURALISER [n]\n",
  "PLURALIZES": "PLURALIZE, to make plural, also PLURALISE [v]\n",
  "PLURALIZING": "PLURALIZE, to make plural, also PLURALISE [v]\n",
  "PLURALLY": "PLURAL, more than one [adv]\n",
  "PLURALS": "PLURAL, a word that expresses more than one [n]\n",
  "PLURILITERAL": "of more than three letters [adj]\n",
  "PLURILOCULAR": "multilocular [adj]\n",
  "PLURIPARA": "(Latin) a mother of two or more children, also MULTIPARA [n PLURIPARAS or PLURIPARAE]\n",
  "PLURIPARAE": "PLURIPARA, (Latin) a mother of two or more children, also MULTIPARA [n]\n",
  "PLURIPARAS": "PLURIPARA, (Latin) a mother of two or more children, also MULTIPARA [n]\n",
  "PLURIPOTENT": "not fixed as to development potentialities e.g. 'pluripotent stem cells' [adj]\n",
  "PLURIPRESENCE": "presence in multiple places at one time [n -S]\n",
  "PLURIPRESENCES": "PLURIPRESENCE, presence in multiple places at one time [n]\n",
  "PLURISERIAL": "in several rows, also PLURISERIATE [adj]\n",
  "PLURISERIATE": "in several rows, also PLURISERIAL [adj]\n",
  "PLURISIE": "(Shakespeare) superabundance [n -S]\n",
  "PLURISIES": "PLURISIE, (Shakespeare) superabundance [n]\n",
  "PLURRY": "(colloquial) bloody [adj]\n",
  "PLUS": "to increase in value [v PLUSSED or PLUSED, PLUSSING or PLUSING, PLUSSES or PLUSES]\n",
  "PLUSAGE": "an extra amount, also PLUSSAGE [n -S]\n",
  "PLUSAGES": "PLUSAGE, an extra amount, also PLUSSAGE [n]\n",
  "PLUSED": "PLUS, to increase in value [v]\n",
  "PLUSES": "PLUS, to increase in value [v]\n",
  "PLUSH": "luxurious [adj PLUSHER, PLUSHEST, PLUSHLY] / a fabric with a long pile [n -ES]\n",
  "PLUSHED": "showily luxurious [adj]\n",
  "PLUSHER": "PLUSH, luxurious [adj]\n",
  "PLUSHES": "PLUSH, a fabric with a long pile [n]\n",
  "PLUSHEST": "PLUSH, luxurious [adj]\n",
  "PLUSHIER": "PLUSHY, luxurious [adj]\n",
  "PLUSHIEST": "PLUSHY, luxurious [adj]\n",
  "PLUSHILY": "PLUSHY, luxurious [adv]\n",
  "PLUSHINESS": "the state of being plushy [n -ES]\n",
  "PLUSHINESSES": "PLUSHINESS, the state of being plushy [n]\n",
  "PLUSHLY": "PLUSH, luxurious [adv]\n",
  "PLUSHNESS": "the state of being plush [n -ES]\n",
  "PLUSHNESSES": "PLUSHNESS, the state of being plush [n]\n",
  "PLUSHY": "luxurious [adj PLUSHIER, PLUSHIEST, PLUSHILY]\n",
  "PLUSING": "PLUS, to increase in value [v]\n",
  "PLUSSAGE": "an extra amount, also PLUSAGE [n -S]\n",
  "PLUSSAGES": "PLUSSAGE, an extra amount, also PLUSAGE [n]\n",
  "PLUSSED": "PLUS, to increase in value [v]\n",
  "PLUSSES": "PLUS, to increase in value [v]\n",
  "PLUSSING": "PLUS, to increase in value [v]\n",
  "PLUTEAL": "of or pertaining to a pluteus, the free-swimming larva of sea urchins and ophiurans [adj]\n",
  "PLUTEI": "PLUTEUS, (Latin) a type of sea-urchin [n]\n",
  "PLUTEUS": "(Latin) a type of sea-urchin [n PLUTEUSES or PLUTEI]\n",
  "PLUTEUSES": "PLUTEUS, (Latin) a type of sea-urchin [n]\n",
  "PLUTO": "to reduce in importance [v PLUTOED, PLUTOING, PLUTOS or PLUTOES]\n",
  "PLUTOCRACIES": "PLUTOCRACY, rulership by the wealthy [n]\n",
  "PLUTOCRACY": "rulership by the wealthy [n PLUTOCRACIES]\n",
  "PLUTOCRAT": "a member of the wealthy ruling class [n -S]\n",
  "PLUTOCRATIC": "relating to the plutocracy, also PLUTOCRATICAL [adj PLUTOCRATICALLY]\n",
  "PLUTOCRATICAL": "relating to the plutocracy, also PLUTOCRATIC [adj PLUTOCRATICALLY]\n",
  "PLUTOCRATICALLY": "PLUTOCRATICAL, relating to the plutocracy, also PLUTOCRATIC [adv]\n",
  "PLUTOCRATS": "PLUTOCRAT, a member of the wealthy ruling class [n]\n",
  "PLUTOED": "PLUTO, to reduce in importance [v]\n",
  "PLUTOES": "PLUTO, to reduce in importance [v]\n",
  "PLUTOID": "any dwarf planet beyond Neptune [n -S]\n",
  "PLUTOIDS": "PLUTOID, any dwarf planet beyond Neptune [n]\n",
  "PLUTOING": "PLUTO, to reduce in importance [v]\n",
  "PLUTOLATRIES": "PLUTOLATRY, excessive devotion to wealth [n]\n",
  "PLUTOLATRY": "excessive devotion to wealth [n PLUTOLATRIES]\n",
  "PLUTOLOGIES": "PLUTOLOGY, political economy; the study of wealth [n]\n",
  "PLUTOLOGIST": "a student of plutology, political economy [n -S]\n",
  "PLUTOLOGISTS": "PLUTOLOGIST, a student of plutology, political economy [n]\n",
  "PLUTOLOGY": "political economy; the study of wealth [n PLUTOLOGIES]\n",
  "PLUTON": "(German) a mass of rock solidified under earth's surface [n -S]\n",
  "PLUTONIAN": "of, relating to, or characteristic of Pluto or the lower world, infernal [adj]\n",
  "PLUTONIC": "pertaining to or involving the formation of rocks at great depths in the earth's crust [adj]\n",
  "PLUTONISM": "the theory that the earth's crust was formed by volcanoes [n -S]\n",
  "PLUTONISMS": "PLUTONISM, the theory that the earth's crust was formed by volcanoes [n]\n",
  "PLUTONIUM": "a naturally radioactive, silvery, metallic transuranic element [n -S]\n",
  "PLUTONIUMS": "PLUTONIUM, a naturally radioactive, silvery, metallic transuranic element [n]\n",
  "PLUTONOMIES": "PLUTONOMY, economics [n]\n",
  "PLUTONOMIST": "a student of plutonomy, political economy [n -S]\n",
  "PLUTONOMISTS": "PLUTONOMIST, a student of plutonomy, political economy [n]\n",
  "PLUTONOMY": "economics [n PLUTONOMIES]\n",
  "PLUTONS": "PLUTON, (German) a mass of rock solidified under earth's surface [n]\n",
  "PLUTOS": "PLUTO, to reduce in importance [v]\n",
  "PLUVIAL": "rainy, also PLUVIAN, PLUVIOSE, PLUVIOUS [adj] / a floor-length open-fronted ecclesiastical garment [n -S]\n",
  "PLUVIALS": "PLUVIAL, a floor-length open-fronted ecclesiastical garment [n]\n",
  "PLUVIAN": "rainy, also PLUVIAL, PLUVIOSE, PLUVIOUS [adj] / a crocodile bird [n -S]\n",
  "PLUVIANS": "PLUVIAN, a crocodile bird [n]\n",
  "PLUVIOMETER": "a device for recording rainfall [n -S]\n",
  "PLUVIOMETERS": "PLUVIOMETER, a device for recording rainfall [n]\n",
  "PLUVIOMETRIC": "relating to pluviometry, the measurement of rainfall, also PLUVIOMETRICAL [adj]\n",
  "PLUVIOMETRICAL": "relating to pluviometry, the measurement of rainfall, also PLUVIOMETRIC [adj]\n",
  "PLUVIOMETRIES": "PLUVIOMETRY, the measurement of rain [n]\n",
  "PLUVIOMETRY": "the measurement of rain [n PLUVIOMETRIES]\n",
  "PLUVIOSE": "pertaining to rain, also PLUVIOUS [adj]\n",
  "PLUVIOUS": "rainy, also PLUVIAL, PLUVIAN, PLUVIOSE [adj]\n",
  "PLUVIUS": "as in pluvius insurance, an insurance cover taken out e.g. by the organizer of a fete against loss of takings due to rain [adj]\n",
  "PLY": "to bend or fold [v PLIED, PLYING, PLIES]\n",
  "PLYER": "one who plies, also PLIER [n -S]\n",
  "PLYERS": "PLYER, one who plies, also PLIER [n]\n",
  "PLYING": "PLY, to bend or fold [v]\n",
  "PLYINGLY": "PLYING, PLY, to bend or fold [adv]\n",
  "PLYOMETRIC": "relating to plyometrics [adj]\n",
  "PLYOMETRICS": "exercise involving repeated rapid stretching and contracting of muscles (as by jumping and rebounding) to increase muscle power [n]\n",
  "PLYWOOD": "a building material [n -S]\n",
  "PLYWOODS": "PLYWOOD, a building material [n]\n",
  "PNEUMA": "(Greek) soul, spirit [n -S]\n",
  "PNEUMAS": "PNEUMA, (Greek) soul, spirit [n]\n",
  "PNEUMATHODE": "a band or pore or aerating tissue, esp. along the stipes of ferns [n -S]\n",
  "PNEUMATHODES": "PNEUMATHODE, a band or pore or aerating tissue, esp. along the stipes of ferns [n]\n",
  "PNEUMATIC": "relating to air or gases; containing or inflated with air, also PNEUMATICAL [adj PNEUMATICALLY]\n",
  "PNEUMATICAL": "relating to air or gases; containing or inflated with air, also PNEUMATIC [adj PNEUMATICALLY]\n",
  "PNEUMATICALLY": "PNEUMATICAL, relating to air or gases; containing or inflated with air, also PNEUMATIC [adv]\n",
  "PNEUMATICITIES": "PNEUMATICITY, the state of being pneumatic [n]\n",
  "PNEUMATICITY": "the state of being pneumatic [n PNEUMATICITIES]\n",
  "PNEUMATICS": "the study of the mechanics of gases [n]\n",
  "PNEUMATOLOGICAL": "related to pneumatology [adj]\n",
  "PNEUMATOLOGIES": "PNEUMATOLOGY, the theory of the existence of spirits [n]\n",
  "PNEUMATOLOGIST": "a specialist in pneumatology [n -S]\n",
  "PNEUMATOLOGISTS": "PNEUMATOLOGIST, a specialist in pneumatology [n]\n",
  "PNEUMATOLOGY": "the theory of the existence of spirits [n PNEUMATOLOGIES]\n",
  "PNEUMATOLYSES": "PNEUMATOLYSIS, the destructive action of the hot vapours of magma on igneous rock [n]\n",
  "PNEUMATOLYSIS": "the destructive action of the hot vapours of magma on igneous rock [n PNEUMATOLYSES]\n",
  "PNEUMATOLYTIC": "relating to pneumatolysis, the destructive action of the hot vapours of magma on igneous rock [adj]\n",
  "PNEUMATOMETER": "an instrument for measuring quantity of air breathed [n -S]\n",
  "PNEUMATOMETERS": "PNEUMATOMETER, an instrument for measuring quantity of air breathed [n]\n",
  "PNEUMATOMETRIES": "PNEUMATOMETRY, the measurement of the pressure exerted by air being inhaled or exhaled during a single breath [n]\n",
  "PNEUMATOMETRY": "the measurement of the pressure exerted by air being inhaled or exhaled during a single breath [n PNEUMATOMETRIES]\n",
  "PNEUMATOPHORE": "an upward-growing respiratory root in swamp plants [n -S]\n",
  "PNEUMATOPHORES": "PNEUMATOPHORE, an upward-growing respiratory root in swamp plants [n]\n",
  "PNEUMECTOMIES": "PNEUMECTOMY, surgical removal of the lung [n]\n",
  "PNEUMECTOMY": "surgical removal of the lung [n PNEUMECTOMIES]\n",
  "PNEUMOBACILLI": "PNEUMOBACILLUS, a rod-shaped bacterium that occurs in the respiratory tract and which causes pneumonia [n]\n",
  "PNEUMOBACILLUS": "a rod-shaped bacterium that occurs in the respiratory tract and which causes pneumonia [n PNEUMOBACILLI]\n",
  "PNEUMOCOCCAL": "of or like a pneumococcus, a bacterium that causes an acute pneumonia involving one or more lobes of the lung [adj]\n",
  "PNEUMOCOCCI": "PNEUMOCOCCUS, a bacterium that causes an acute pneumonia involving one or more lobes of the lung [n]\n",
  "PNEUMOCOCCUS": "a bacterium that causes an acute pneumonia involving one or more lobes of the lung [n PNEUMOCOCCI]\n",
  "PNEUMOCONIOSES": "PNEUMOCONIOSIS, a disease of the lungs caused by the habitual inhalation of irritants (as mineral or metallic particles) [n]\n",
  "PNEUMOCONIOSIS": "a disease of the lungs caused by the habitual inhalation of irritants (as mineral or metallic particles) [n PNEUMOCONIOSES]\n",
  "PNEUMOCONIOTIC": "a person suffering from pneumoconiosis [n -S]\n",
  "PNEUMOCONIOTICS": "PNEUMOCONIOTIC, a person suffering from pneumoconiosis [n]\n",
  "PNEUMOCYSTIS": "any protozoan of the genus Pneumocystis, esp. P. carinii, which is a cause of pneumonia [n PNEUMOCYSTISES]\n",
  "PNEUMOCYSTISES": "PNEUMOCYSTIS, any protozoan of the genus Pneumocystis, esp. P. carinii, which is a cause of pneumonia [n]\n",
  "PNEUMODYNAMICS": "the science of the mechanical properties of gases [n]\n",
  "PNEUMOGASTRIC": "relating to the lungs and stomach [adj] / the vagus [n -S]\n",
  "PNEUMOGASTRICS": "PNEUMOGASTRIC, the vagus [n]\n",
  "PNEUMOGRAM": "an X-ray photograph made by a pneumograph [n -S]\n",
  "PNEUMOGRAMS": "PNEUMOGRAM, an X-ray photograph made by a pneumograph [n]\n",
  "PNEUMOGRAPH": "an instrument for measuring and recording respiration [n -S]\n",
  "PNEUMOGRAPHS": "PNEUMOGRAPH, an instrument for measuring and recording respiration [n]\n",
  "PNEUMOKONIOSES": "PNEUMOKONIOSIS, a disease of the lungs caused by the habitual inhalation of irritants (as mineral or metallic particles) [n]\n",
  "PNEUMOKONIOSIS": "a disease of the lungs caused by the habitual inhalation of irritants (as mineral or metallic particles) [n PNEUMOKONIOSES]\n",
  "PNEUMONECTOMIES": "PNEUMONECTOMY, the surgical removal of a lung [n]\n",
  "PNEUMONECTOMY": "the surgical removal of a lung [n PNEUMONECTOMIES]\n",
  "PNEUMONIA": "a disease of the lungs [n -S]\n",
  "PNEUMONIAS": "PNEUMONIA, a disease of the lungs [n]\n",
  "PNEUMONIC": "relating to the lungs [adj] / a medicine for lung diseases [n -S]\n",
  "PNEUMONICS": "PNEUMONIC, a medicine for lung diseases [n]\n",
  "PNEUMONITIDES": "PNEUMONITIS, inflammation of the lungs [n]\n",
  "PNEUMONITIS": "inflammation of the lungs [n PNEUMONITIDES or PNEUMONITISES]\n",
  "PNEUMONITISES": "PNEUMONITIS, inflammation of the lungs [n]\n",
  "PNEUMONOLOGIES": "PNEUMONOLOGY, the study of the respiratory system [n]\n",
  "PNEUMONOLOGIST": "one who studies pneumonology [n -S]\n",
  "PNEUMONOLOGISTS": "PNEUMONOLOGIST, one who studies pneumonology [n]\n",
  "PNEUMONOLOGY": "the study of the respiratory system [n PNEUMONOLOGIES]\n",
  "PNEUMOTHORACES": "PNEUMOTHORAX, accumulation of air or gas in the pleural cavity [n]\n",
  "PNEUMOTHORAX": "accumulation of air or gas in the pleural cavity [n PNEUMOTHORACES or PNEUMOTHORAXES]\n",
  "PNEUMOTHORAXES": "PNEUMOTHORAX, accumulation of air or gas in the pleural cavity [n]\n",
  "PO": "(short for) chamberpot [n -S]\n",
  "POA": "a meadow-grass plant [n -S]\n",
  "POACEOUS": "pertaining to plants of the grass family [adj]\n",
  "POACH": "to trespass to hunt game [v -ED, -ING, -ES]\n",
  "POACHABLE": "that can be poached [adj]\n",
  "POACHED": "POACH, to trespass to hunt game [v]\n",
  "POACHER": "one who poaches [n -S]\n",
  "POACHERS": "POACHER, one who poaches [n]\n",
  "POACHES": "POACH, to trespass to hunt game [v]\n",
  "POACHIER": "POACHY, spongy and sodden [adj]\n",
  "POACHIEST": "POACHY, spongy and sodden [adj]\n",
  "POACHINESS": "the state of being poachy [n -ES]\n",
  "POACHINESSES": "POACHINESS, the state of being poachy [n]\n",
  "POACHING": "encroachment on someone's territory [n -S]\n",
  "POACHINGS": "POACHING, encroachment on someone's territory [n]\n",
  "POACHY": "spongy and sodden [adj POACHIER, POACHIEST]\n",
  "POAKA": "(Maori) a New Zealand bird of the stilt family [n -S]\n",
  "POAKAS": "POAKA, (Maori) a New Zealand bird of the stilt family [n]\n",
  "POAKE": "(Shakespeare) a poke, a bag [n -S]\n",
  "POAKES": "POAKE, (Shakespeare) a poke, a bag [n]\n",
  "POAS": "POA, a meadow-grass plant [n]\n",
  "POBLANO": "a kind of long, wide, dark-green moderately hot chili used esp. in Mexican cooking [n -S]\n",
  "POBLANOS": "POBLANO, a kind of long, wide, dark-green moderately hot chili used esp. in Mexican cooking [n]\n",
  "POBOY": "a New Orleans sandwich [n -S]\n",
  "POBOYS": "POBOY, a New Orleans sandwich [n]\n",
  "POCHARD": "a kind of European duck with a red head, also POCKARD [n -S]\n",
  "POCHARDS": "POCHARD, a kind of European duck with a red head, also POCKARD [n]\n",
  "POCHAY": "to transport by post-chaise [v -ED, -ING, -S]\n",
  "POCHAYED": "POCHAY, to transport by post-chaise [v]\n",
  "POCHAYING": "POCHAY, to transport by post-chaise [v]\n",
  "POCHAYS": "POCHAY, to transport by post-chaise [v]\n",
  "POCHETTE": "(French) a pocket notecase or wallet [n -S]\n",
  "POCHETTES": "POCHETTE, (French) a pocket notecase or wallet [n]\n",
  "POCHOIR": "(French) a manual colour stencilling onto a printed illustration [n -S]\n",
  "POCHOIRS": "POCHOIR, (French) a manual colour stencilling onto a printed illustration [n]\n",
  "POCK": "to pit the skin [v -ED, -ING, -S]\n",
  "POCKARD": "a kind of European duck with a red head, also POCHARD [n -S]\n",
  "POCKARDS": "POCKARD, a kind of European duck with a red head, also POCHARD [n]\n",
  "POCKED": "POCK, to pit the skin [v]\n",
  "POCKET": "to place in a pouch sewed into a garment [v -ED, -ING, -S]\n",
  "POCKETABLE": "that can be pocketed [adj]\n",
  "POCKETBIKE": "a type of small bicycle [n -S]\n",
  "POCKETBIKES": "POCKETBIKE, a type of small bicycle [n]\n",
  "POCKETBOOK": "a wallet for papers or money carried in the pocket; a small book for the pocket [n -S]\n",
  "POCKETBOOKS": "POCKETBOOK, a wallet for papers or money carried in the pocket; a small book for the pocket [n]\n",
  "POCKETED": "POCKET, to place in a pouch sewed into a garment [v]\n",
  "POCKETER": "one who pockets [n -S]\n",
  "POCKETERS": "POCKETER, one who pockets [n]\n",
  "POCKETFUL": "the contents of a pocket [n POCKETSFUL or POCKETFULS]\n",
  "POCKETFULS": "POCKETFUL, the contents of a pocket [n]\n",
  "POCKETING": "POCKET, to place in a pouch sewed into a garment [v]\n",
  "POCKETKNIFE": "a knife for carrying in the pocket [n POCKETKNIVES]\n",
  "POCKETKNIVES": "POCKETKNIFE, a knife for carrying in the pocket [n]\n",
  "POCKETLESS": "without pockets [adj]\n",
  "POCKETPHONE": "a mobile phone [n -S]\n",
  "POCKETPHONES": "POCKETPHONE, a mobile phone [n]\n",
  "POCKETS": "POCKET, to place in a pouch sewed into a garment [v]\n",
  "POCKETSFUL": "POCKETFUL, the contents of a pocket [n]\n",
  "POCKIER": "POCKY, covered with pock marks [adj]\n",
  "POCKIES": "(Scots) woollen mittens [n]\n",
  "POCKIEST": "POCKY, covered with pock marks [adj]\n",
  "POCKILY": "POCKY, covered with pock marks [adv]\n",
  "POCKING": "POCK, to pit the skin [v]\n",
  "POCKMANKIES": "POCKMANKY, (Scots) a corrupt form of portmanteau, also POCKMANTIE [n]\n",
  "POCKMANKY": "(Scots) a corrupt form of portmanteau, also POCKMANTIE [n POCKMANKIES]\n",
  "POCKMANTIE": "(Scots) a corrupt form of portmanteau, also POCKMANKY [n -S]\n",
  "POCKMANTIES": "POCKMANTIE, (Scots) a corrupt form of portmanteau, also POCKMANKY [n]\n",
  "POCKMARK": "to mark with scars caused by an eruptive disease [v -ED, -ING, -S]\n",
  "POCKMARKED": "POCKMARK, to mark with scars caused by an eruptive disease [v]\n",
  "POCKMARKING": "POCKMARK, to mark with scars caused by an eruptive disease [v]\n",
  "POCKMARKS": "POCKMARK, to mark with scars caused by an eruptive disease [v]\n",
  "POCKPIT": "the scar left by a pock mark [n -S]\n",
  "POCKPITS": "POCKPIT, the scar left by a pock mark [n]\n",
  "POCKPITTED": "pitted by pock marks [adj]\n",
  "POCKS": "POCK, to pit the skin [v]\n",
  "POCKY": "covered with pock marks [adj POCKIER, POCKIEST, POCKILY]\n",
  "POCO": "(Italian) as a musical direction, a little [adv]\n",
  "POCOCURANTE": "(Italian) different, nonchalant [adj] / one who is indifferent [n -S]\n",
  "POCOCURANTEISM": "indifference, also POCOCURANTISM [n -S]\n",
  "POCOCURANTEISMS": "POCOCURANTEISM, indifference, also POCOCURANTISM [n]\n",
  "POCOCURANTES": "POCOCURANTE, one who is indifferent [n]\n",
  "POCOCURANTISM": "indifference, also POCOCURANTEISM [n -S]\n",
  "POCOCURANTISMS": "POCOCURANTISM, indifference, also POCOCURANTEISM [n]\n",
  "POCOCURANTIST": "one who is habitually uninterested [n -S]\n",
  "POCOCURANTISTS": "POCOCURANTIST, one who is habitually uninterested [n]\n",
  "POCOSEN": "(Native American) an upland swamp of the coastal plain of the southeastern US, also POCOSIN, POCOSON [n -S]\n",
  "POCOSENS": "POCOSEN, (Native American) an upland swamp of the coastal plain of the southeastern US, also POCOSIN, POCOSON [n]\n",
  "POCOSIN": "(Native American) an upland swamp of the coastal plain of the southeastern US, also POCOSEN, POCOSON [n -S]\n",
  "POCOSINS": "POCOSIN, (Native American) an upland swamp of the coastal plain of the southeastern US, also POCOSEN, POCOSON [n]\n",
  "POCOSON": "(Native American) an upland swamp of the coastal plain of the southeastern US, also POCOSEN, POCOSIN [n -S]\n",
  "POCOSONS": "POCOSON, (Native American) an upland swamp of the coastal plain of the southeastern US, also POCOSEN, POCOSIN [n]\n",
  "POCULIFORM": "cup-shaped [adj]\n",
  "POD": "to produce seed coverings [v PODDED, PODDING, PODS]\n",
  "PODAGRA": "(Greek) gout in the foot [n -S]\n",
  "PODAGRAL": "relating to podagra, gout, also PODAGRIC, PODAGRICAL, PODAGROUS [adj]\n",
  "PODAGRAS": "PODAGRA, (Greek) gout in the foot [n]\n",
  "PODAGRIC": "relating to podagra, gout, also PODAGRAL, PODAGRICAL, PODAGROUS [adj]\n",
  "PODAGRICAL": "relating to podagra, gout, also PODAGRAL, PODAGRIC, PODAGROUS [adj]\n",
  "PODAGROUS": "relating to podagra, gout, also PODAGRAL, PODAGRIC, PODAGRICAL [adj]\n",
  "PODAL": "of the feet, also PODALIC [adj]\n",
  "PODALIC": "of the feet, also PODAL [adj]\n",
  "PODARGUS": "a bird of the frogmouth genus [n -ES]\n",
  "PODARGUSES": "PODARGUS, a bird of the frogmouth genus [n]\n",
  "PODCAST": "to make a radio broadcast available as an audio file [v -ED, -ING, -S]\n",
  "PODCASTED": "PODCAST, to make a radio broadcast available as an audio file [v]\n",
  "PODCASTER": "one who creates podcasts [n -S]\n",
  "PODCASTERS": "PODCASTER, one who creates podcasts [n]\n",
  "PODCASTING": "a radio broadcast made available as an audio file [n -S]\n",
  "PODCASTINGS": "PODCASTING, a radio broadcast made available as an audio file [n]\n",
  "PODCASTS": "PODCAST, to make a radio broadcast available as an audio file [v]\n",
  "PODDED": "POD, to produce seed coverings [v]\n",
  "PODDIE": "an iPod user [n -S]\n",
  "PODDIER": "PODDY, corpulent [adj]\n",
  "PODDIES": "PODDY, a young calf [n]\n",
  "PODDIEST": "PODDY, corpulent [adj]\n",
  "PODDING": "POD, to produce seed coverings [v]\n",
  "PODDLE": "(dialect) to amble at leisure [v PODDLED, PODDLING, PODDLES]\n",
  "PODDLED": "PODDLE, (dialect) to amble at leisure [v]\n",
  "PODDLES": "PODDLE, (dialect) to amble at leisure [v]\n",
  "PODDLING": "PODDLE, (dialect) to amble at leisure [v]\n",
  "PODDY": "a young calf [n PODDIES] / corpulent [adj PODDIER, PODDIEST]\n",
  "PODESTA": "(Italian) one of the chief magistrates of the Italian republics in the Middle Ages [n -S]\n",
  "PODESTAS": "PODESTA, (Italian) one of the chief magistrates of the Italian republics in the Middle Ages [n]\n",
  "PODEX": "(Latin) the rump [n -ES]\n",
  "PODEXES": "PODEX, (Latin) the rump [n]\n",
  "PODGE": "a short, thickset person, also PUDGE [n -S]\n",
  "PODGES": "PODGE, a short, thickset person, also PUDGE [n]\n",
  "PODGIER": "PODGY, short and fat, also PUDGY, PUDSEY, PUDSY [adj]\n",
  "PODGIEST": "PODGY, short and fat, also PUDGY, PUDSEY, PUDSY [adj]\n",
  "PODGILY": "PODGY, short and fat, also PUDGY, PUDSEY, PUDSY [adv]\n",
  "PODGINESS": "the state of being podgy [n -ES]\n",
  "PODGINESSES": "PODGINESS, the state of being podgy [n]\n",
  "PODGY": "short and fat, also PUDGY, PUDSEY, PUDSY [adj PODGIER, PODGIEST, PODGILY]\n",
  "PODIA": "PODIUM, (Latin) a low wall, serving as a foundation, a substructure, or a terrace wall [n]\n",
  "PODIAL": "pertaining to the podium [adj]\n",
  "PODIATRIC": "relating to care of the feet [adj]\n",
  "PODIATRIES": "PODIATRY, the study and treatment of the human foot [n]\n",
  "PODIATRIST": "one who practises podiatry [n -S]\n",
  "PODIATRISTS": "PODIATRIST, one who practises podiatry [n]\n",
  "PODIATRY": "the study and treatment of the human foot [n PODIATRIES]\n",
  "PODITE": "a walking leg of a crustacean [n -S]\n",
  "PODITES": "PODITE, a walking leg of a crustacean [n]\n",
  "PODITIC": "relating to a podite, a walking leg of a crustacean [adj]\n",
  "PODIUM": "(Latin) a low wall, serving as a foundation, a substructure, or a terrace wall [n PODIA or PODIUMS] / to win a place on the victors' podium by finishing in the leading places in a sporting competition [v -ED, -ING, -S]\n",
  "PODIUMED": "PODIUM, to win a place on the victors' podium by finishing in the leading places in a sporting competition [v]\n",
  "PODIUMING": "PODIUM, to win a place on the victors' podium by finishing in the leading places in a sporting competition [v]\n",
  "PODIUMS": "PODIUM, (Latin) a low wall, serving as a foundation, a substructure, or a terrace wall [n]\n",
  "PODLEY": "(Scots) a young coalfish [n -S]\n",
  "PODLEYS": "PODLEY, (Scots) a young coalfish [n]\n",
  "PODLIKE": "resembling a seed covering [adj]\n",
  "PODOCARP": "a stem, or footstalk, supporting the fruit [n -S]\n",
  "PODOCARPS": "PODOCARP, a stem, or footstalk, supporting the fruit [n]\n",
  "PODOCONIOSES": "PODOCONIOSIS, endemic elephantiasis of the lower legs [n]\n",
  "PODOCONIOSIS": "endemic elephantiasis of the lower legs [n PODOCONIOSES]\n",
  "PODOLOGIES": "PODOLOGY, the study of the feet [n]\n",
  "PODOLOGIST": "one who practises podology, the study of the feet [n -S]\n",
  "PODOLOGISTS": "PODOLOGIST, one who practises podology, the study of the feet [n]\n",
  "PODOLOGY": "the study of the feet [n PODOLOGIES]\n",
  "PODOMERE": "a limb segment of an arthropod, also PODITE [n -S]\n",
  "PODOMERES": "PODOMERE, a limb segment of an arthropod, also PODITE [n]\n",
  "PODOPHTHALMOUS": "having eyes on stalks, like some crabs [adj]\n",
  "PODOPHYLIN": "a cathartic resin obtained from the rhizomes of the Podophyllum genus, also PODOPHYLLIN [n -S]\n",
  "PODOPHYLINS": "PODOPHYLIN, a cathartic resin obtained from the rhizomes of the Podophyllum genus, also PODOPHYLLIN [n]\n",
  "PODOPHYLLI": "PODOPHYLLUM, the dried rootlet and rhizome of the mayapple, used as a caustic [n]\n",
  "PODOPHYLLIN": "a cathartic resin obtained from the rhizomes of the Podophyllum genus, also PODOPHYLIN [n -S]\n",
  "PODOPHYLLINS": "PODOPHYLLIN, a cathartic resin obtained from the rhizomes of the Podophyllum genus, also PODOPHYLIN [n]\n",
  "PODOPHYLLUM": "the dried rootlet and rhizome of the mayapple, used as a caustic [n PODOPHYLLI or PODOPHYLLUMS]\n",
  "PODOPHYLLUMS": "PODOPHYLLUM, the dried rootlet and rhizome of the mayapple, used as a caustic [n]\n",
  "PODOSPHERE": "the collective podcasting social network or community [n -S]\n",
  "PODOSPHERES": "PODOSPHERE, the collective podcasting social network or community [n]\n",
  "PODS": "POD, to produce seed coverings [v]\n",
  "PODSOL": "(Russian) a leached soil formed in cool, humid climates, also PODZOL [n -S]\n",
  "PODSOLIC": "relating to podsol, a leached soil formed in cool, humid climates, also PODZOLIC [adj]\n",
  "PODSOLISATION": "the process of turning into a podsol, also PODSOLIZATION, PODZOLISATION, PODZOLIZATION [n -S]\n",
  "PODSOLISATIONS": "PODSOLISATION, the process of turning into a podsol, also PODSOLIZATION, PODZOLISATION, PODZOLIZATION [n]\n",
  "PODSOLISE": "to turn into podsol, also PODSOLIZE [v PODSOLISED, PODSOLISING, PODSOLISES]\n",
  "PODSOLISED": "PODSOLISE, to turn into podsol, also PODSOLIZE [v]\n",
  "PODSOLISES": "PODSOLISE, to turn into podsol, also PODSOLIZE [v]\n",
  "PODSOLISING": "PODSOLISE, to turn into podsol, also PODSOLIZE [v]\n",
  "PODSOLIZATION": "the process of turning into a podsol, also PODSOLISATION, PODZOLISATION, PODZOLIZATION [n -S]\n",
  "PODSOLIZATIONS": "PODSOLIZATION, the process of turning into a podsol, also PODSOLISATION, PODZOLISATION, PODZOLIZATION [n]\n",
  "PODSOLIZE": "to turn into podsol, also PODSOLISE [v PODSOLIZED, PODSOLIZING, PODSOLIZES]\n",
  "PODSOLIZED": "PODSOLIZE, to turn into podsol, also PODSOLISE [v]\n",
  "PODSOLIZES": "PODSOLIZE, to turn into podsol, also PODSOLISE [v]\n",
  "PODSOLIZING": "PODSOLIZE, to turn into podsol, also PODSOLISE [v]\n",
  "PODSOLS": "PODSOL, (Russian) a leached soil formed in cool, humid climates, also PODZOL [n]\n",
  "PODUNK": "a small unimportant town [n -S]\n",
  "PODUNKS": "PODUNK, a small unimportant town [n]\n",
  "PODZOL": "(Russian) an infertile soil, also PODSOL [n -S]\n",
  "PODZOLIC": "relating to podzol [adj]\n",
  "PODZOLISATION": "the process of turning into a podzol, also PODSOLISATION, PODSOLIZATION, PODZOLIZATION [n -S]\n",
  "PODZOLISATIONS": "PODZOLISATION, the process of turning into a podzol, also PODSOLISATION, PODSOLIZATION, PODZOLIZATION [n]\n",
  "PODZOLISE": "to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLIZE [v PODZOLISED, PODZOLISING, PODZOLISES]\n",
  "PODZOLISED": "PODZOLISE, to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLIZE [v]\n",
  "PODZOLISES": "PODZOLISE, to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLIZE [v]\n",
  "PODZOLISING": "PODZOLISE, to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLIZE [v]\n",
  "PODZOLIZATION": "the process of turning into a podsol, also PODSOLISATION, PODSOLIZATION, PODZOLISATION [n -S]\n",
  "PODZOLIZATIONS": "PODZOLIZATION, the process of turning into a podsol, also PODSOLISATION, PODSOLIZATION, PODZOLISATION [n]\n",
  "PODZOLIZE": "to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLISE [v PODZOLIZED, PODZOLIZING, PODZOLIZES]\n",
  "PODZOLIZED": "PODZOLIZE, to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLISE [v]\n",
  "PODZOLIZES": "PODZOLIZE, to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLISE [v]\n",
  "PODZOLIZING": "PODZOLIZE, to make into a podzol, a leached soil formed in cool, humid climates, also PODZOLISE [v]\n",
  "PODZOLS": "PODZOL, (Russian) an infertile soil, also PODSOL [n]\n",
  "POECHORE": "a semiarid region [n -S]\n",
  "POECHORES": "POECHORE, a semiarid region [n]\n",
  "POEM": "a composition in verse [n -S]\n",
  "POEMATIC": "in the style of a poem [adj]\n",
  "POEMS": "POEM, a composition in verse [n]\n",
  "POENOLOGIES": "POENOLOGY, the study of crime and punishment, also PENOLOGY [n]\n",
  "POENOLOGY": "the study of crime and punishment, also PENOLOGY [n POENOLOGIES]\n",
  "POEP": "(South African) to break wind [v -ED, -ING, -S]\n",
  "POEPED": "POEP, (South African) to break wind [v]\n",
  "POEPING": "POEP, (South African) to break wind [v]\n",
  "POEPOL": "(vulgar South African) the anus [n -S]\n",
  "POEPOLS": "POEPOL, (vulgar South African) the anus [n]\n",
  "POEPS": "POEP, (South African) to break wind [v]\n",
  "POESIED": "POESY, to utter poetry [v]\n",
  "POESIES": "POESY, to utter poetry [v]\n",
  "POESY": "to utter poetry [v POESIED, POESYING, POESIES]\n",
  "POESYING": "POESY, to utter poetry [v]\n",
  "POET": "one who writes poems [n -S]\n",
  "POETASTER": "an inferior poet [n -S]\n",
  "POETASTERIES": "POETASTERY, the writing of inferior verse, also POETASTRY [n]\n",
  "POETASTERING": "acting as a poetaster, an inferior poet [n -S]\n",
  "POETASTERINGS": "POETASTERING, acting as a poetaster, an inferior poet [n]\n",
  "POETASTERS": "POETASTER, an inferior poet [n]\n",
  "POETASTERY": "the writing of inferior verse, also POETASTRY [n POETASTERIES]\n",
  "POETASTRIES": "POETASTRY, the writing of inferior verse, also POETASTERY [n]\n",
  "POETASTRY": "the writing of inferior verse, also POETASTERY [n POETASTRIES]\n",
  "POETESS": "a female poet, also POETRESSE [n -ES]\n",
  "POETESSES": "POETESS, a female poet, also POETRESSE [n]\n",
  "POETIC": "pertaining to poetry [adj POETICALLY]\n",
  "POETICAL": "related to poetry [adj POETICALLY] / a writer of poetry [n -S]\n",
  "POETICALLY": "POETICAL, related to poetry [adv]\n",
  "POETICALNESS": "the state of being poetical [n -ES]\n",
  "POETICALNESSES": "POETICALNESS, the state of being poetical [n]\n",
  "POETICALS": "POETICAL, a writer of poetry [n]\n",
  "POETICISE": "to write, speak, or treat, poetically, also POETICIZE [v POETICISED, POETICISING, POETICISES]\n",
  "POETICISED": "POETICISE, to write, speak, or treat, poetically, also POETICIZE [v]\n",
  "POETICISES": "POETICISE, to write, speak, or treat, poetically, also POETICIZE [v]\n",
  "POETICISING": "POETICISE, to write, speak, or treat, poetically, also POETICIZE [v]\n",
  "POETICISM": "a word or phrase that is typically, usually tritely, poetic [n -S]\n",
  "POETICISMS": "POETICISM, a word or phrase that is typically, usually tritely, poetic [n]\n",
  "POETICIZE": "to write, speak, or treat, poetically, also POETICISE [v POETICIZED, POETICIZING, POETICIZES]\n",
  "POETICIZED": "POETICIZE, to write, speak, or treat, poetically, also POETICISE [v]\n",
  "POETICIZES": "POETICIZE, to write, speak, or treat, poetically, also POETICISE [v]\n",
  "POETICIZING": "POETICISE, to write, speak, or treat, poetically, also POETICIZE [v]\n",
  "POETICS": "poetic theory or practise [n]\n",
  "POETICULE": "a poetaster [n -S]\n",
  "POETICULES": "POETICULE, a poetaster [n]\n",
  "POETISE": "to write poetry, also POETIZE [v POETISED, POETISING, POETISES]\n",
  "POETISED": "POETISE, to write poetry, also POETIZE [v]\n",
  "POETISER": "one who poetises, also POETIZER [n -S]\n",
  "POETISERS": "POETISER, one who poetises, also POETIZER [n]\n",
  "POETISES": "POETISE, to write poetry, also POETIZE [v]\n",
  "POETISING": "POETISE, to write poetry, also POETIZE [v]\n",
  "POETIZE": "to write poetry, also POETISE [v POETIZED, POETIZING, POETIZES]\n",
  "POETIZED": "POETIZE, to write poetry, also POETISE [v]\n",
  "POETIZER": "one who poetises, also POETISER [n -S]\n",
  "POETIZERS": "POETIZER, one who poetises, also POETISER [n]\n",
  "POETIZES": "POETIZE, to write poetry, also POETISE [v]\n",
  "POETIZING": "POETIZE, to write poetry, also POETISE [v]\n",
  "POETLESS": "lacking a poet [adj]\n",
  "POETLIKE": "like a poet [adj]\n",
  "POETRESSE": "(Spenser) a poetess, also POETESS [n -S]\n",
  "POETRESSES": "POETRESSE, (Spenser) a poetess, also POETESS [n]\n",
  "POETRIES": "POETRY, a literary work in metrical form [n]\n",
  "POETRY": "a literary work in metrical form [n POETRIES]\n",
  "POETS": "POET, one who writes poems [n]\n",
  "POETSHIP": "the state or personality of a poet [n -S]\n",
  "POETSHIPS": "POETSHIP, the state or personality of a poet [n]\n",
  "POFFLE": "(Scots) a pendicle, an appendage [n -S]\n",
  "POFFLES": "POFFLE, (Scots) a pendicle, an appendage [n]\n",
  "POGEY": "(Canadian) in Canada, any form of government relief, also POGY [n -S]\n",
  "POGEYS": "POGEY, (Canadian) in Canada, any form of government relief, also POGY [n]\n",
  "POGGE": "the armed bullhead, a bony-plated fish [n -S]\n",
  "POGGES": "POGGE, the armed bullhead, a bony-plated fish [n]\n",
  "POGIES": "POGY, (Canadian) in Canada, any form of government relief, also POGEY [n]\n",
  "POGO": "(tradename) to jump up and down on the spot to music [v POGOED, POGOING, POGOS or POGOES]\n",
  "POGOED": "POGO, (tradename) to jump up and down on the spot to music [v]\n",
  "POGOER": "someone who pogos [n -S]\n",
  "POGOERS": "POGOER, someone who pogos [n]\n",
  "POGOES": "POGO, (tradename) to jump up and down on the spot to music [v]\n",
  "POGOING": "POGO, (tradename) to jump up and down on the spot to music [v]\n",
  "POGONIA": "a small orchid [n -S]\n",
  "POGONIAS": "POGONIA, a small orchid [n]\n",
  "POGONIP": "(Native American) a dense winter fog containing frozen particles that is formed in deep mountain valleys of the western US [n -S]\n",
  "POGONIPS": "POGONIP, (Native American) a dense winter fog containing frozen particles that is formed in deep mountain valleys of the western US [n]\n",
  "POGONOPHORAN": "any of a phylum Pogonophora of marine wormlike animals [n -S]\n",
  "POGONOPHORANS": "POGONOPHORAN, any of a phylum Pogonophora of marine wormlike animals [n]\n",
  "POGONOTOMIES": "POGONOTOMY, shaving [n]\n",
  "POGONOTOMY": "shaving [n POGONOTOMIES]\n",
  "POGOS": "POGO, (tradename) to jump up and down on the spot to music [v]\n",
  "POGROM": "(Russian) to massacre systematically [v -ED, -ING, -S]\n",
  "POGROMED": "POGROM, (Russian) to massacre systematically [v]\n",
  "POGROMING": "POGROM, (Russian) to massacre systematically [v]\n",
  "POGROMIST": "one who engages in pogroms [n -S]\n",
  "POGROMISTS": "POGROMIST, one who engages in pogroms [n]\n",
  "POGROMS": "POGROM, (Russian) to massacre systematically [v]\n",
  "POGY": "(Canadian) in Canada, any form of government relief, also POGEY [n POGIES]\n",
  "POH": "to reject contemptuously [v -ED, -ING, -S]\n",
  "POHED": "POH, to reject contemptuously [v]\n",
  "POHING": "POH, to reject contemptuously [v]\n",
  "POHIRI": "(Maori) a ceremony of welcome, esp. to a marae, also POWHIRI [n -S]\n",
  "POHIRIS": "POHIRI, (Maori) a ceremony of welcome, esp. to a marae, also POWHIRI [n]\n",
  "POHS": "POH, to reject contemptuously [v]\n",
  "POHUTUKAWA": "(Maori) a New Zealand evergreen which bears clusters of red flowers in December and January; thus called the Christmas tree [n -S]\n",
  "POHUTUKAWAS": "POHUTUKAWA, (Maori) a New Zealand evergreen which bears clusters of red flowers in December and January; thus called the Christmas tree [n]\n",
  "POI": "a Hawaiian food [n -S]\n",
  "POIGNADO": "(obsolete) a small dagger, also PONIARD, POINADO [n -ES]\n",
  "POIGNADOES": "POIGNADO, (obsolete) a small dagger, also PONIARD, POINADO [n]\n",
  "POIGNANCE": "the state of being poignant, also POIGNANCY [n -S]\n",
  "POIGNANCES": "POIGNANCE, the state of being poignant, also POIGNANCY [n]\n",
  "POIGNANCIES": "POIGNANCY, the state of being poignant, also POIGNANCE [n]\n",
  "POIGNANCY": "the state of being poignant, also POIGNANCE [n POIGNANCIES]\n",
  "POIGNANT": "emotionally distressing, also POYNANT [adj POIGNANTLY]\n",
  "POIGNANTLY": "POIGNANT, emotionally distressing, also POYNANT [adv]\n",
  "POIKILITIC": "mottled; having small crystals of one mineral irregularly scattered in larger crystals of another [adj]\n",
  "POIKILOCYTE": "an irregular red blood corpuscle [n -S]\n",
  "POIKILOCYTES": "POIKILOCYTE, an irregular red blood corpuscle [n]\n",
  "POIKILOTHERM": "an organism that takes on the temperature of its surroundings [n -S]\n",
  "POIKILOTHERMAL": "having a variable blood temperature, cold blooded, also POIKILOTHERMIC [adj]\n",
  "POIKILOTHERMIC": "having a variable blood temperature, cold blooded, also POIKILOTHERMAL [adj]\n",
  "POIKILOTHERMIES": "POIKILOTHERMY, the state of being cold-blooded, also POIKILOTHERMISM [n]\n",
  "POIKILOTHERMISM": "the state of being cold-blooded, also POIKILOTHERMY [n]\n",
  "POIKILOTHERMS": "POIKILOTHERM, an organism that takes on the temperature of its surroundings [n]\n",
  "POIKILOTHERMY": "the state of being cold-blooded, also POIKILOTHERMISM [n POIKILOTHERMIES]\n",
  "POILU": "(French slang) an infantry soldier in World War One [n -S]\n",
  "POILUS": "POILU, (French slang) an infantry soldier in World War One [n]\n",
  "POINADO": "(obsolete) a small dagger, also PONIARD, POIGNADO [n -ES]\n",
  "POINADOES": "POINADO, (obsolete) a small dagger, also PONIARD, POIGNADO [n]\n",
  "POINCIANA": "a tree of the tropical genus Poinciana, having racemes of showy orange-red flowers with long crimson filaments [n -S]\n",
  "POINCIANAS": "POINCIANA, a tree of the tropical genus Poinciana, having racemes of showy orange-red flowers with long crimson filaments [n]\n",
  "POIND": "(Scots) to distrain, impound [v -ED, -ING, -S]\n",
  "POINDED": "POIND, (Scots) to distrain, impound [v]\n",
  "POINDER": "(Scots) one who poinds, impounds [n -S]\n",
  "POINDERS": "POINDER, (Scots) one who poinds, impounds [n]\n",
  "POINDING": "impoundment [n -S]\n",
  "POINDINGS": "POINDING, impoundment [n]\n",
  "POINDS": "POIND, (Scots) to distrain, impound [v]\n",
  "POINSETTIA": "a Mexican shrub with very large and conspicuous vermilion bracts below the yellowish flowers [n -S]\n",
  "POINSETTIAS": "POINSETTIA, a Mexican shrub with very large and conspicuous vermilion bracts below the yellowish flowers [n]\n",
  "POINT": "to indicate direction with the finger [v -ED, -ING, -S]\n",
  "POINTABLE": "that can be pointed [adj]\n",
  "POINTE": "(French) the extreme tip of the toe; the position of standing on it in ballet [n -S]\n",
  "POINTED": "POINT, to indicate direction with the finger [v]\n",
  "POINTEDLY": "POINTED, POINT, to indicate direction with the finger [adv]\n",
  "POINTEDNESS": "the state of being pointed [n -ES]\n",
  "POINTEDNESSES": "POINTEDNESS, the state of being pointed [n]\n",
  "POINTEL": "a sharp instrument [n -S]\n",
  "POINTELLE": "(French) an openwork design, as in knitted fabric [n -S]\n",
  "POINTELLES": "POINTELLE, (French) an openwork design, as in knitted fabric [n]\n",
  "POINTELS": "POINTEL, a sharp instrument [n]\n",
  "POINTER": "a breed of dog used on shooting expeditions, that points to the bird with nose, body and tail in a straight line [n -S]\n",
  "POINTERS": "POINTER, a breed of dog used on shooting expeditions, that points to the bird with nose, body and tail in a straight line [n]\n",
  "POINTES": "POINTE, (French) the extreme tip of the toe; the position of standing on it in ballet [n]\n",
  "POINTIER": "POINTY, coming to a sharp, tapering end [adj]\n",
  "POINTIEST": "POINTY, coming to a sharp, tapering end [adj]\n",
  "POINTILLE": "a fine point or subtle distinction [n -S]\n",
  "POINTILLES": "POINTILLE, a fine point or subtle distinction [n]\n",
  "POINTILLISM": "a painting technique using separate dots of pure colour rather than blends, also POINTILLISME [n -S]\n",
  "POINTILLISME": "a painting technique using separate dots of pure colour rather than blends, also POINTILLISM [n -S]\n",
  "POINTILLISMES": "POINTILLISME, a painting technique using separate dots of pure colour rather than blends, also POINTILLISM [n]\n",
  "POINTILLISMS": "POINTILLISM, a painting technique using separate dots of pure colour rather than blends, also POINTILLISME [n]\n",
  "POINTILLIST": "one who practises pointillism, also POINTILLISTE [n -S]\n",
  "POINTILLISTE": "one who practises pointillisme, also POINTILLIST [n -S]\n",
  "POINTILLISTES": "POINTILLISTE, one who practises pointillisme, also POINTILLIST [n]\n",
  "POINTILLISTIC": "composed of many discrete details or parts [adj]\n",
  "POINTILLISTS": "POINTILLIST, one who practises pointillism, also POINTILLISTE [n]\n",
  "POINTING": "the mortar between joints [n -S]\n",
  "POINTINGS": "POINTING, the mortar between joints [n]\n",
  "POINTLESS": "with no point, futile [adj POINTLESSLY]\n",
  "POINTLESSLY": "POINTLESS, with no point, futile [adv]\n",
  "POINTLESSNESS": "POINTLESS, with no point, futile [n]\n",
  "POINTLESSNESSES": "POINTLESSNESS, POINTLESS, with no point, futile [n]\n",
  "POINTLIKE": "like a point [adj]\n",
  "POINTMAN": "the soldier at the head of a patrol [n POINTMEN]\n",
  "POINTMEN": "POINTMAN, the soldier at the head of a patrol [n]\n",
  "POINTS": "POINT, to indicate direction with the finger [v]\n",
  "POINTSMAN": "a man who has charge of railroad points or switches [n POINTSMEN]\n",
  "POINTSMEN": "POINTSMAN, a man who has charge of railroad points or switches [n]\n",
  "POINTY": "coming to a sharp, tapering end [adj POINTIER, POINTIEST]\n",
  "POIS": "POI, a Hawaiian food [n]\n",
  "POISE": "to hold in a state of equilibrium [v POISED, POISING, POISES]\n",
  "POISED": "POISE, to hold in a state of equilibrium [v]\n",
  "POISER": "the balancer of dipterous insects [n -S]\n",
  "POISERS": "POISER, the balancer of dipterous insects [n]\n",
  "POISES": "POISE, to hold in a state of equilibrium [v]\n",
  "POISHA": "(Bengali) a Bangladeshi monetary unit [n -S]\n",
  "POISHAS": "POISHA, (Bengali) a Bangladeshi monetary unit [n]\n",
  "POISING": "POISE, to hold in a state of equilibrium [v]\n",
  "POISON": "to administer a killing substance to [v -ED, -ING, -S]\n",
  "POISONABLE": "capable of poisoning; poisonous [adj]\n",
  "POISONED": "POISON, to administer a killing substance to [v]\n",
  "POISONER": "one who poisons [n -S]\n",
  "POISONERS": "POISONER, one who poisons [n]\n",
  "POISONING": "the act of administering a killing substance to [n -S]\n",
  "POISONINGS": "POISONING, the act of administering a killing substance to [n]\n",
  "POISONOUS": "having the quality or effect of poison [adj POISONOUSLY]\n",
  "POISONOUSLY": "POISONOUS, having the quality or effect of poison [adv]\n",
  "POISONOUSNESS": "POISONOUS, having the quality or effect of poison [n]\n",
  "POISONOUSNESSES": "POISONOUSNESS, POISONOUS, having the quality or effect of poison [n]\n",
  "POISONS": "POISON, to administer a killing substance to [v]\n",
  "POISONWOOD": "a poisonous tree of the cashew family native to Florida [n -S]\n",
  "POISONWOODS": "POISONWOOD, a poisonous tree of the cashew family native to Florida [n]\n",
  "POISSON": "(French) a fish [n -S]\n",
  "POISSONS": "POISSON, (French) a fish [n]\n",
  "POITIN": "(Irish) Irish whiskey distilled unlawfully, also POTEEN, POTHEEN, POTTEEN [n -S]\n",
  "POITINS": "POITIN, (Irish) Irish whiskey distilled unlawfully, also POTEEN, POTHEEN, POTTEEN [n]\n",
  "POITREL": "a piece of armour for the breast of a horse, also PEYTRAL, PEYTREL [n -S]\n",
  "POITRELS": "POITREL, a piece of armour for the breast of a horse, also PEYTRAL, PEYTREL [n]\n",
  "POITRINE": "(French) a woman's bosom [n -S]\n",
  "POITRINES": "POITRINE, (French) a woman's bosom [n]\n",
  "POKABLE": "able to be poked [adj]\n",
  "POKAL": "(German) a tall drinking cup [n -S]\n",
  "POKALS": "POKAL, (German) a tall drinking cup [n]\n",
  "POKE": "to prod [v POKED, POKING, POKES]\n",
  "POKEBERRIES": "POKEBERRY, an American plant, a species of Phytolacca [n]\n",
  "POKEBERRY": "an American plant, a species of Phytolacca [n POKEBERRIES]\n",
  "POKED": "POKE, to prod [v]\n",
  "POKEFUL": "as much as a poke (bag) will hold [n -S]\n",
  "POKEFULS": "POKEFUL, as much as a poke (bag) will hold [n]\n",
  "POKELOGAN": "(Canadian) a bogan, a quiet tributary or backwater [n -S]\n",
  "POKELOGANS": "POKELOGAN, (Canadian) a bogan, a quiet tributary or backwater [n]\n",
  "POKER": "one that pokes [n -S]\n",
  "POKERISH": "(US colloquial) mysterious and frightening; ghostly, uncanny [adj POKERISHLY]\n",
  "POKERISHLY": "POKERISH, (US colloquial) mysterious and frightening; ghostly, uncanny [adv]\n",
  "POKEROOT": "an aromatic perennial herb of the United States, also POKEWEED [n -S]\n",
  "POKEROOTS": "POKEROOT, an aromatic perennial herb of the United States, also POKEWEED [n]\n",
  "POKERS": "POKER, one that pokes [n]\n",
  "POKERWORK": "the art of producing designs on wood by burning it with a hot metal rod [n -S]\n",
  "POKERWORKS": "POKERWORK, the art of producing designs on wood by burning it with a hot metal rod [n]\n",
  "POKES": "POKE, to prod [v]\n",
  "POKEWEED": "an aromatic perennial herb of the United States, also POKEROOT [n -S]\n",
  "POKEWEEDS": "POKEWEED, an aromatic perennial herb of the United States, also POKEROOT [n]\n",
  "POKEY": "confined, also POKY [adj POKIER, POKIEST, POKILY] / jail [n -S]\n",
  "POKEYS": "POKEY, jail [n]\n",
  "POKIE": "a poker machine [n -S]\n",
  "POKIER": "POKY, cramped, also POKEY [adj]\n",
  "POKIES": "POKY, jail [n]\n",
  "POKIEST": "POKY, cramped, also POKEY [adj]\n",
  "POKILY": "POKY, cramped, also POKEY [adv]\n",
  "POKINESS": "the state of being poky [n -ES]\n",
  "POKINESSES": "POKINESS, the state of being poky [n]\n",
  "POKING": "POKE, to prod [v]\n",
  "POKY": "cramped, also POKEY [adj POKIER, POKIEST, POKILY] / jail [n POKIES]\n",
  "POL": "a politician [n -S]\n",
  "POLACCA": "(Italian) a vessel with two or three masts, used in the Mediterranean, also POLACRE [n -S]\n",
  "POLACCAS": "POLACCA, (Italian) a vessel with two or three masts, used in the Mediterranean, also POLACRE [n]\n",
  "POLACK": "a person of Polish birth or descent [n -S]\n",
  "POLACKS": "POLACK, a person of Polish birth or descent [n]\n",
  "POLACRE": "(Italian) a vessel with two or three masts, used in the Mediterranean, also POLACCA [n -S]\n",
  "POLACRES": "POLACRE, (Italian) a vessel with two or three masts, used in the Mediterranean, also POLACCA [n]\n",
  "POLAR": "a straight line related to a point [n -S]\n",
  "POLARIMETER": "an instrument for measuring polarised light [n -S]\n",
  "POLARIMETERS": "POLARIMETER, an instrument for measuring polarised light [n]\n",
  "POLARIMETRIC": "relating to measurement by polarimeter, an instrument for measuring polarised light [adj]\n",
  "POLARIMETRIES": "POLARIMETRY, measurement by polarimeter [n]\n",
  "POLARIMETRY": "measurement by polarimeter [n POLARIMETRIES]\n",
  "POLARISABILITY": "the ability to be polarised [n]\n",
  "POLARISABLE": "that can be polarised, also POLARIZABLE [adj]\n",
  "POLARISATION": "the act of affecting radiation and esp. light so that the vibrations of the wave assume a definite form, also POLARIZATION [n -S]\n",
  "POLARISATIONS": "POLARISATION, the act of affecting radiation and esp. light so that the vibrations of the wave assume a definite form, also POLARIZATION [n]\n",
  "POLARISCOPE": "an instrument for detecting polarized light [n -S]\n",
  "POLARISCOPES": "POLARISCOPE, an instrument for detecting polarized light [n]\n",
  "POLARISCOPIC": "relating to use of the polariscope, an instrument for detecting polarized light [adj]\n",
  "POLARISE": "to give polarity to, also POLARIZE [v POLARISED, POLARISING, POLARISES]\n",
  "POLARISED": "POLARISE, to give polarity to, also POLARIZE [v]\n",
  "POLARISER": "a device for polarising light, also POLARIZER [n -S]\n",
  "POLARISERS": "POLARISER, a device for polarising light, also POLARIZER [n]\n",
  "POLARISES": "POLARISE, to give polarity to, also POLARIZE [v]\n",
  "POLARISING": "POLARISE, to give polarity to, also POLARIZE [v]\n",
  "POLARITIES": "POLARITY, the possession of two opposite qualities [n]\n",
  "POLARITY": "the possession of two opposite qualities [n POLARITIES]\n",
  "POLARIZABILITY": "the state of being polarizable [n]\n",
  "POLARIZABLE": "that can be polarized, also POLARISABLE [adj]\n",
  "POLARIZATION": "the act of affecting radiation and esp. light so that the vibrations of the wave assume a definite form, also POLARISATION [n -S]\n",
  "POLARIZATIONS": "POLARIZATION, the act of affecting radiation and esp. light so that the vibrations of the wave assume a definite form, also POLARISATION [n]\n",
  "POLARIZE": "to give polarity to, also POLARISE [v POLARIZED, POLARIZING, POLARIZES]\n",
  "POLARIZED": "POLARIZE, to give polarity to, also POLARISE [v]\n",
  "POLARIZER": "a device for polarising light, also POLARISER [n -S]\n",
  "POLARIZERS": "POLARIZER, a device for polarising light, also POLARISER [n]\n",
  "POLARIZES": "POLARIZE, to give polarity to, also POLARISE [v]\n",
  "POLARIZING": "POLARIZE, to give polarity to, also POLARISE [v]\n",
  "POLAROGRAM": "a picture taken by polarography [n -S]\n",
  "POLAROGRAMS": "POLAROGRAM, a picture taken by polarography [n]\n",
  "POLAROGRAPH": "an apparatus for automatic chemical analysis in which a sample solution is electrolysed at successively higher voltages and the resulting current plotted against voltage [n -S]\n",
  "POLAROGRAPHIC": "relating to polarography [adj]\n",
  "POLAROGRAPHIES": "POLAROGRAPHY, a technique for determining the concentration and nature of the ions in a solution by an electrolytic process [n]\n",
  "POLAROGRAPHS": "POLAROGRAPH, an apparatus for automatic chemical analysis in which a sample solution is electrolysed at successively higher voltages and the resulting current plotted against voltage [n]\n",
  "POLAROGRAPHY": "a technique for determining the concentration and nature of the ions in a solution by an electrolytic process [n POLAROGRAPHIES]\n",
  "POLARON": "a free electron trapped by polarization charges on the surrounding molecules [n -S]\n",
  "POLARONS": "POLARON, a free electron trapped by polarization charges on the surrounding molecules [n]\n",
  "POLARS": "POLAR, a straight line related to a point [n]\n",
  "POLDER": "(Dutch) to reclaim low-lying land [v -ED, -ING, -S]\n",
  "POLDERED": "POLDER, (Dutch) to reclaim low-lying land [v]\n",
  "POLDERING": "POLDER, (Dutch) to reclaim low-lying land [v]\n",
  "POLDERS": "POLDER, (Dutch) to reclaim low-lying land [v]\n",
  "POLE": "to propel with a long stick [v POLED, POLING, POLES]\n",
  "POLEAX": "to strike with an axlike weapon, also POLEAXE [v -ED, -ING, -ES]\n",
  "POLEAXE": "to strike with an axlike weapon, also POLEAX [v POLEAXED, POLEAXING, POLEAXES]\n",
  "POLEAXED": "POLEAX, to strike with an axlike weapon, also POLEAXE [v]\n",
  "POLEAXES": "POLEAX, to strike with an axlike weapon, also POLEAXE [v]\n",
  "POLEAXING": "POLEAX, to strike with an axlike weapon, also POLEAXE [v]\n",
  "POLECAT": "a dark-brown carnivorous mammal of the weasel family [n -S]\n",
  "POLECATS": "POLECAT, a dark-brown carnivorous mammal of the weasel family [n]\n",
  "POLED": "POLE, to propel with a long stick [v]\n",
  "POLEIS": "POLIS, (Greek) an ancient Greek city state [n]\n",
  "POLELESS": "without a pole [adj]\n",
  "POLEMARCH": "a title of several officials in ancient Greek states, originally a military commander [n -S]\n",
  "POLEMARCHS": "POLEMARCH, a title of several officials in ancient Greek states, originally a military commander [n]\n",
  "POLEMIC": "relating to debate [adj POLEMICALLY] / a controversial discussion or attack [n -S]\n",
  "POLEMICAL": "related to polemics, debate, also POLEMIC [adj POLEMICALLY]\n",
  "POLEMICALLY": "POLEMICAL, related to polemics, debate, also POLEMIC [adv]\n",
  "POLEMICISE": "to argue or write polemically, carry on a controversy, also POLEMICIZE, POLEMISE, POLEMIZE [v POLEMICISED, POLEMICISING, POLEMICISES]\n",
  "POLEMICISED": "POLEMICISE, to argue or write polemically, carry on a controversy, also POLEMICIZE, POLEMISE, POLEMIZE [v]\n",
  "POLEMICISES": "POLEMICISE, to argue or write polemically, carry on a controversy, also POLEMICIZE, POLEMISE, POLEMIZE [v]\n",
  "POLEMICISING": "POLEMICISE, to argue or write polemically, carry on a controversy, also POLEMICIZE, POLEMISE, POLEMIZE [v]\n",
  "POLEMICIST": "one who engages in polemics, also POLEMIST [n -S]\n",
  "POLEMICISTS": "POLEMICIST, one who engages in polemics, also POLEMIST [n]\n",
  "POLEMICIZE": "to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMISE, POLEMIZE [v POLEMICIZED, POLEMICIZING, POLEMICIZES]\n",
  "POLEMICIZED": "POLEMICIZE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMISE, POLEMIZE [v]\n",
  "POLEMICIZES": "POLEMICIZE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMISE, POLEMIZE [v]\n",
  "POLEMICIZING": "POLEMICIZE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMISE, POLEMIZE [v]\n",
  "POLEMICS": "POLEMIC, a controversial discussion or attack [n]\n",
  "POLEMISE": "to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMIZE [v POLEMISED, POLEMISING, POLEMISES]\n",
  "POLEMISED": "POLEMISE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMIZE [v]\n",
  "POLEMISES": "POLEMISE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMIZE [v]\n",
  "POLEMISING": "POLEMISE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMIZE [v]\n",
  "POLEMIST": "one who engages in polemics [n -S]\n",
  "POLEMISTS": "POLEMIST, one who engages in polemics [n]\n",
  "POLEMIZE": "to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMISE [v POLEMIZED, POLEMIZING, POLEMIZES]\n",
  "POLEMIZED": "POLEMIZE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMISE [v]\n",
  "POLEMIZES": "POLEMIZE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMISE [v]\n",
  "POLEMIZING": "POLEMIZE, to argue or write polemically, carry on a controversy, also POLEMICISE, POLEMICIZE, POLEMISE [v]\n",
  "POLEMONIACEOUS": "belonging to the Polemoniaceae, the phlox family [adj]\n",
  "POLEMONIUM": "a genus of gamopetalous perennial herbs, including the Jacob's ladder and the Greek valerian [n -S]\n",
  "POLEMONIUMS": "POLEMONIUM, a genus of gamopetalous perennial herbs, including the Jacob's ladder and the Greek valerian [n]\n",
  "POLENTA": "(Italian) a thick mush of cornmeal [n -S]\n",
  "POLENTAS": "POLENTA, (Italian) a thick mush of cornmeal [n]\n",
  "POLER": "(Australian) one of a pair of bullocks harnessed to a pole; a shirker [n -S]\n",
  "POLERS": "POLER, (Australian) one of a pair of bullocks harnessed to a pole; a shirker [n]\n",
  "POLES": "POLE, to propel with a long stick [v]\n",
  "POLESTAR": "a guiding principle [n -S]\n",
  "POLESTARS": "POLESTAR, a guiding principle [n]\n",
  "POLEWARD": "in the direction of either the North or South pole [adv]\n",
  "POLEY": "(Australian slang) a hornless cow [n -S]\n",
  "POLEYN": "a piece of armour for the knee [n -S]\n",
  "POLEYNS": "POLEYN, a piece of armour for the knee [n]\n",
  "POLEYS": "POLEY, (Australian slang) a hornless cow [n]\n",
  "POLIANITE": "manganese dioxide, occurring in tetragonal crystals nearly as hard as quartz [n -S]\n",
  "POLIANITES": "POLIANITE, manganese dioxide, occurring in tetragonal crystals nearly as hard as quartz [n]\n",
  "POLICE": "to make orderly [v POLICED, POLICING, POLICES]\n",
  "POLICED": "POLICE, to make orderly [v]\n",
  "POLICEMAN": "a man who is a member of a police force [n POLICEMEN]\n",
  "POLICEMEN": "POLICEMAN, a man who is a member of a police force [n]\n",
  "POLICER": "a computer device controlling use [n -S]\n",
  "POLICERS": "POLICER, a computer device controlling use [n]\n",
  "POLICES": "POLICE, to make orderly [v]\n",
  "POLICEWOMAN": "a woman who is a member of a police force [n POLICEWOMEN]\n",
  "POLICEWOMEN": "POLICEWOMAN, a woman who is a member of a police force [n]\n",
  "POLICIER": "a film featuring police investigating crimes [n -S]\n",
  "POLICIERS": "POLICIER, a film featuring police investigating crimes [n]\n",
  "POLICIES": "POLICY, an action or a procedure considered with reference to prudence or expediency, also POLLICIE, POLLICY [n]\n",
  "POLICING": "the act of policing [n -S]\n",
  "POLICINGS": "POLICING, the act of policing [n]\n",
  "POLICY": "an action or a procedure considered with reference to prudence or expediency, also POLLICIE, POLLICY [n POLICIES]\n",
  "POLICYHOLDER": "the owner of an insurance policy [n -S]\n",
  "POLICYHOLDERS": "POLICYHOLDER, the owner of an insurance policy [n]\n",
  "POLICYMAKER": "one who makes policy [n -S]\n",
  "POLICYMAKERS": "POLICYMAKER, one who makes policy [n]\n",
  "POLIES": "POLY, (short for) a polytechnic [n]\n",
  "POLING": "poles collectively [n -S]\n",
  "POLINGS": "POLING, poles collectively [n]\n",
  "POLIO": "an infectious virus disease [n -S]\n",
  "POLIOMYELITIDES": "POLIOMYELITIS, a virus disease of the spinal cord, often causing paralysis; infantile paralysis [n]\n",
  "POLIOMYELITIS": "a virus disease of the spinal cord, often causing paralysis; infantile paralysis [n POLIOMYELITISES or POLIOMYELITIDES]\n",
  "POLIOMYELITISES": "POLIOMYELITIS, a virus disease of the spinal cord, often causing paralysis; infantile paralysis [n]\n",
  "POLIORCETIC": "relating to poliorcetics, siegecraft [adj]\n",
  "POLIORCETICS": "the science of siegecraft [n]\n",
  "POLIOS": "POLIO, an infectious virus disease [n]\n",
  "POLIOVIRUS": "a virus causing polio [n -ES]\n",
  "POLIOVIRUSES": "POLIOVIRUS, a virus causing polio [n]\n",
  "POLIS": "(Greek) an ancient Greek city state [n POLEIS] / (colloquial) the police [n POLISES]\n",
  "POLISES": "POLIS, (Greek) an ancient Greek city state [n]\n",
  "POLISH": "to make lustrous by rubbing [v -ED, -ING, -ES]\n",
  "POLISHABLE": "capable of being polished [adj]\n",
  "POLISHED": "POLISH, to make lustrous by rubbing [v]\n",
  "POLISHER": "one who polishes [n -S]\n",
  "POLISHERS": "POLISHER, one who polishes [n]\n",
  "POLISHES": "POLISH, to make lustrous by rubbing [v]\n",
  "POLISHING": "the act of polishing [n -S]\n",
  "POLISHINGS": "POLISHING, the act of polishing [n]\n",
  "POLISHMENT": "the act of polishing, or the state of being polished [n -S]\n",
  "POLISHMENTS": "POLISHMENT, the act of polishing, or the state of being polished [n]\n",
  "POLITBURO": "(Russian) the policy-making committee in communist states [n -S]\n",
  "POLITBUROS": "POLITBURO, (Russian) the policy-making committee in communist states [n]\n",
  "POLITE": "showing consideration for others [adj POLITER, POLITEST, POLITELY]\n",
  "POLITELY": "POLITE, showing consideration for others [adv]\n",
  "POLITENESS": "the state of being polite [n -ES]\n",
  "POLITENESSES": "POLITENESS, the state of being polite [n]\n",
  "POLITER": "POLITE, showing consideration for others [adj]\n",
  "POLITESSE": "(French) courteous formality, politeness [n -S]\n",
  "POLITESSES": "POLITESSE, (French) courteous formality, politeness [n]\n",
  "POLITEST": "POLITE, showing consideration for others [adj]\n",
  "POLITIC": "shrewd [adj POLITICLY] / to engage in politics [v POLITICKED, POLITICKING, POLITICS]\n",
  "POLITICAL": "related to politics [adj POLITICALLY]\n",
  "POLITICALISE": "to make political, also POLITICALIZE [v POLITICALISED, POLITICALISING, POLITICALISES]\n",
  "POLITICALISED": "POLITICALISE, to make political, also POLITICALIZE [v]\n",
  "POLITICALISES": "POLITICALISE, to make political, also POLITICALIZE [v]\n",
  "POLITICALISING": "POLITICALISE, to make political, also POLITICALIZE [v]\n",
  "POLITICALIZE": "to make political, also POLITICALISE [v POLITICALIZED, POLITICALIZING, POLITICALIZES]\n",
  "POLITICALIZED": "POLITICALIZE, to make political, also POLITICALISE [v]\n",
  "POLITICALIZES": "POLITICALIZE, to make political, also POLITICALISE [v]\n",
  "POLITICALIZING": "POLITICALIZE, to make political, also POLITICALISE [v]\n",
  "POLITICALLY": "POLITICAL, related to politics [adv]\n",
  "POLITICASTER": "(Milton) a petty politician; a pretender in politics [n -S]\n",
  "POLITICASTERS": "POLITICASTER, (Milton) a petty politician; a pretender in politics [n]\n",
  "POLITICIAN": "a person experienced in the art or science of government [n -S]\n",
  "POLITICIANS": "POLITICIAN, a person experienced in the art or science of government [n]\n",
  "POLITICISATION": "the act of politicising, also POLITICIZATION [n -S]\n",
  "POLITICISATIONS": "POLITICISATION, the act of politicising, also POLITICIZATION [n]\n",
  "POLITICISE": "to give a political tone or character to, also POLITICIZE [v POLITICISED, POLITICISING, POLITICISES]\n",
  "POLITICISED": "POLITICISE, to give a political tone or character to, also POLITICIZE [v]\n",
  "POLITICISES": "POLITICISE, to give a political tone or character to, also POLITICIZE [v]\n",
  "POLITICISING": "POLITICISE, to give a political tone or character to, also POLITICIZE [v]\n",
  "POLITICIZATION": "the act of politicizing, also POLITICISATION [n -S]\n",
  "POLITICIZATIONS": "POLITICIZATION, the act of politicizing, also POLITICISATION [n]\n",
  "POLITICIZE": "to give a political tone or character to, also POLITICISE [v POLITICIZED, POLITICIZING, POLITICIZES]\n",
  "POLITICIZED": "POLITICIZE, to give a political tone or character to, also POLITICISE [v]\n",
  "POLITICIZES": "POLITICIZE, to give a political tone or character to, also POLITICISE [v]\n",
  "POLITICIZING": "POLITICIZE, to give a political tone or character to, also POLITICISE [v]\n",
  "POLITICK": "to engage in politics [v -ED, -ING, -S]\n",
  "POLITICKED": "POLITICK, to engage in politics [v]\n",
  "POLITICKER": "one who engages in politics [n -S]\n",
  "POLITICKERS": "POLITICKER, one who engages in politics [n]\n",
  "POLITICKING": "engaging in politics [n -S]\n",
  "POLITICKINGS": "POLITICKING, engaging in politics [n]\n",
  "POLITICKS": "POLITICK, to engage in politics [v]\n",
  "POLITICLY": "POLITIC, shrewd [adv]\n",
  "POLITICO": "a politician; a person holding strong political views or acting from political motivation [n -ES or -S]\n",
  "POLITICOES": "POLITICO, a politician; a person holding strong political views or acting from political motivation [n]\n",
  "POLITICOS": "POLITICO, a politician; a person holding strong political views or acting from political motivation [n]\n",
  "POLITICS": "the science of government [n]\n",
  "POLITIES": "POLITY, political organisation [n]\n",
  "POLITIQUE": "(French) in French history, a member of a moderate party between Huguenots and Catholics [n -S]\n",
  "POLITIQUES": "POLITIQUE, (French) in French history, a member of a moderate party between Huguenots and Catholics [n]\n",
  "POLITY": "political organisation [n POLITIES]\n",
  "POLJE": "(Serbo-Croat) a large elliptical depression in karst regions, sometimes containing a marsh or lake [n -S]\n",
  "POLJES": "POLJE, (Serbo-Croat) a large elliptical depression in karst regions, sometimes containing a marsh or lake [n]\n",
  "POLK": "to dance a polka [v -ED, -ING, -S]\n",
  "POLKA": "(Czech) a Bohemian dance or the tune for it [n -S] / to dance this, also POLK [v -ED, -ING, -S]\n",
  "POLKAED": "POLKA, to dance this, also POLK [v]\n",
  "POLKAING": "POLKA, to dance this, also POLK [v]\n",
  "POLKAS": "POLKA, to dance this, also POLK [v]\n",
  "POLKED": "POLK, to dance a polka [v]\n",
  "POLKING": "POLK, to dance a polka [v]\n",
  "POLKS": "POLK, to dance a polka [v]\n",
  "POLL": "to assess public opinion votes [v -ED, -ING, -S]\n",
  "POLLACK": "a marine food fish, also POLLOCK [n -S]\n",
  "POLLACKS": "POLLACK, a marine food fish, also POLLOCK [n]\n",
  "POLLAN": "(Irish) a whitefish, plentiful in Irish loughs, also POWAN [n -S]\n",
  "POLLANS": "POLLAN, (Irish) a whitefish, plentiful in Irish loughs, also POWAN [n]\n",
  "POLLARD": "to cut the top branches of a tree back to the trunk [v -ED, -ING, -S]\n",
  "POLLARDED": "POLLARD, to cut the top branches of a tree back to the trunk [v]\n",
  "POLLARDING": "POLLARD, to cut the top branches of a tree back to the trunk [v]\n",
  "POLLARDS": "POLLARD, to cut the top branches of a tree back to the trunk [v]\n",
  "POLLAXE": "an axe on a pole, also POLEAX, POLEAXE [n -S] / to strike with a pollaxe [v POLLAXED, POLLAXING, POLLAXES]\n",
  "POLLAXED": "POLLAXE, to strike with a pollaxe [v]\n",
  "POLLAXES": "POLLAXE, to strike with a pollaxe [v]\n",
  "POLLAXING": "POLLAXE, to strike with a pollaxe [v]\n",
  "POLLED": "POLL, to assess public opinion votes [v]\n",
  "POLLEE": "one who is polled [n -S]\n",
  "POLLEES": "POLLEE, one who is polled [n]\n",
  "POLLEN": "the microspore of seed plants [n -S] / to cover or fertilise with pollen [v -ED, -ING, -S]\n",
  "POLLENATE": "to fertilise with pollen, also POLLINATE [v POLLENATED, POLLENATING, POLLENATES]\n",
  "POLLENATED": "POLLENATE, to fertilise with pollen, also POLLINATE [v]\n",
  "POLLENATES": "POLLENATE, to fertilise with pollen, also POLLINATE [v]\n",
  "POLLENATING": "POLLENATE, to fertilise with pollen, also POLLINATE [v]\n",
  "POLLENED": "POLLEN, to cover or fertilise with pollen [v]\n",
  "POLLENIFEROUS": "bearing pollen [adj]\n",
  "POLLENING": "POLLEN, to cover or fertilise with pollen [v]\n",
  "POLLENISER": "an agent that pollinises, also POLLENIZER [n -S]\n",
  "POLLENISERS": "POLLENISER, an agent that pollinises, also POLLENIZER [n]\n",
  "POLLENIZER": "an agent that pollenizes, also POLLENISER [n -S]\n",
  "POLLENIZERS": "POLLENIZER, an agent that pollenizes, also POLLENISER [n]\n",
  "POLLENOSES": "POLLENOSIS, allergic reaction to pollen; hay-fever, also POLLINOSIS [n]\n",
  "POLLENOSIS": "allergic reaction to pollen; hay-fever, also POLLINOSIS [n POLLENOSES]\n",
  "POLLENS": "POLLEN, to cover or fertilise with pollen [v]\n",
  "POLLENT": "(Latin) strong, powerful [adj]\n",
  "POLLER": "one that polls, also POLLIST, POLLSTER [n -S]\n",
  "POLLERS": "POLLER, one that polls, also POLLIST, POLLSTER [n]\n",
  "POLLEX": "(Latin) the thumb, as in phrase 'pollice verso', with thumb turned down, indicating condemnation, especially to death [n POLLICES]\n",
  "POLLICAL": "relating to a pollex [adj]\n",
  "POLLICES": "POLLEX, (Latin) the thumb, as in phrase 'pollice verso', with thumb turned down, indicating condemnation, especially to death [n]\n",
  "POLLICIE": "(Spenser) policy, also POLLICY [n -S]\n",
  "POLLICIES": "POLLICY, (Spenser) policy, also POLLICIE [n]\n",
  "POLLICITATION": "a promise or an offer made but not yet accepted [n -S]\n",
  "POLLICITATIONS": "POLLICITATION, a promise or an offer made but not yet accepted [n]\n",
  "POLLICY": "(Spenser) policy, also POLLICIE [n POLLICIES]\n",
  "POLLIES": "POLLY, a type of mineral water [n]\n",
  "POLLINATE": "to fertilise with pollen, also POLLENATE [v POLLINATED, POLLINATING, POLLINATES]\n",
  "POLLINATED": "POLLINATE, to fertilise with pollen, also POLLENATE [v]\n",
  "POLLINATES": "POLLINATE, to fertilise with pollen, also POLLENATE [v]\n",
  "POLLINATING": "POLLINATE, to fertilise with pollen, also POLLENATE [v]\n",
  "POLLINATION": "the process of transferring the pollen from its place of production to the place where the egg cell is produced [n -S]\n",
  "POLLINATIONS": "POLLINATION, the process of transferring the pollen from its place of production to the place where the egg cell is produced [n]\n",
  "POLLINATOR": "an agent that pollinates [n -S]\n",
  "POLLINATORS": "POLLINATOR, an agent that pollinates [n]\n",
  "POLLING": "the act of polling [n -S]\n",
  "POLLINGS": "POLLING, the act of polling [n]\n",
  "POLLINIA": "POLLINIUM, a coherent mass of pollen, as in the milkweed and most orchids [n]\n",
  "POLLINIC": "pertaining to pollen [adj]\n",
  "POLLINIFEROUS": "producing pollen; adapted for carrying pollen [adj]\n",
  "POLLINISE": "to pollinate, also POLLINIZE [v POLLINISED, POLLINISING, POLLINISES]\n",
  "POLLINISED": "POLLINISE, to pollinate, also POLLINIZE [v]\n",
  "POLLINISER": "an agent that pollinises, also POLLINIZER [n -S]\n",
  "POLLINISERS": "POLLINISER, an agent that pollinises, also POLLINIZER [n]\n",
  "POLLINISES": "POLLINISE, to pollinate, also POLLINIZE [v]\n",
  "POLLINISING": "POLLINISE, to pollinate, also POLLINIZE [v]\n",
  "POLLINIUM": "a coherent mass of pollen, as in the milkweed and most orchids [n POLLINIA]\n",
  "POLLINIZE": "to pollinate, also POLLINISE [v POLLINIZED, POLLINIZING, POLLINIZES]\n",
  "POLLINIZED": "POLLINIZE, to pollinate, also POLLINISE [v]\n",
  "POLLINIZER": "an agent that pollinizes, also POLLINISER [n -S]\n",
  "POLLINIZERS": "POLLINIZER, an agent that pollinizes, also POLLINISER [n]\n",
  "POLLINIZES": "POLLINIZE, to pollinate, also POLLINISE [v]\n",
  "POLLINIZING": "POLLINIZE, to pollinate, also POLLINISE [v]\n",
  "POLLINOSES": "POLLINOSIS, an allergic reaction to pollen; hay-fever, also POLLENOSIS [n]\n",
  "POLLINOSIS": "an allergic reaction to pollen; hay-fever, also POLLENOSIS [n POLLINOSES]\n",
  "POLLIST": "one that polls, also POLLER, POLLSTER [n -S]\n",
  "POLLISTS": "POLLIST, one that polls, also POLLER, POLLSTER [n]\n",
  "POLLIWIG": "a tadpole, also POLLIWOG, POLLYWIG, POLLYWOG, PORWIGGLE [n -S]\n",
  "POLLIWIGS": "POLLIWIG, a tadpole, also POLLIWOG, POLLYWIG, POLLYWOG, PORWIGGLE [n]\n",
  "POLLIWOG": "a tadpole, also POLLIWIG, POLLYWIG, POLLYWOG, PORWIGGLE [n -S]\n",
  "POLLIWOGS": "POLLIWOG, a tadpole, also POLLIWIG, POLLYWIG, POLLYWOG, PORWIGGLE [n]\n",
  "POLLMAN": "a graduate with a pass degree [n POLLMEN]\n",
  "POLLMEN": "POLLMAN, a graduate with a pass degree [n]\n",
  "POLLOCK": "a marine gadoid fish, aka coalfish or sillock, also POLLACK [n -S]\n",
  "POLLOCKS": "POLLOCK, a marine gadoid fish, aka coalfish or sillock, also POLLACK [n]\n",
  "POLLS": "POLL, to assess public opinion votes [v]\n",
  "POLLSTER": "one that polls, also POLLER, POLLIST [n -S]\n",
  "POLLSTERS": "POLLSTER, one that polls, also POLLER, POLLIST [n]\n",
  "POLLTAKER": "a person conducting a poll [n -S]\n",
  "POLLTAKERS": "POLLTAKER, a person conducting a poll [n]\n",
  "POLLUCITE": "a colourless rare mineral, hydrated caesium aluminium silicate [n -S]\n",
  "POLLUCITES": "POLLUCITE, a colourless rare mineral, hydrated caesium aluminium silicate [n]\n",
  "POLLUSION": "(Shakespeare) blunder for allusion [n -S]\n",
  "POLLUSIONS": "POLLUSION, (Shakespeare) blunder for allusion [n]\n",
  "POLLUTANT": "causing pollution [adj] / a substance causing pollution [n -S]\n",
  "POLLUTANTS": "POLLUTANT, a substance causing pollution [n]\n",
  "POLLUTE": "to make unclean or impure [v POLLUTED, POLLUTING, POLLUTES]\n",
  "POLLUTED": "POLLUTE, to make unclean or impure [v]\n",
  "POLLUTEDLY": "POLLUTED, POLLUTE, to make unclean or impure [adv]\n",
  "POLLUTEDNESS": "the state of being polluted [n -ES]\n",
  "POLLUTEDNESSES": "POLLUTEDNESS, the state of being polluted [n]\n",
  "POLLUTER": "one who pollutes [n -S]\n",
  "POLLUTERS": "POLLUTER, one who pollutes [n]\n",
  "POLLUTES": "POLLUTE, to make unclean or impure [v]\n",
  "POLLUTING": "POLLUTE, to make unclean or impure [v]\n",
  "POLLUTION": "making dirty, defilement [n -S]\n",
  "POLLUTIONS": "POLLUTION, making dirty, defilement [n]\n",
  "POLLUTIVE": "relating to pollution [adj]\n",
  "POLLY": "a type of mineral water [n POLLIES]\n",
  "POLLYANNA": "one who is naively optimistic [n -S]\n",
  "POLLYANNAISH": "tediously optimistic, also POLLYANNISH [adj]\n",
  "POLLYANNAISM": "a pollyannaish observation [n -S]\n",
  "POLLYANNAISMS": "POLLYANNAISM, a pollyannaish observation [n]\n",
  "POLLYANNAS": "POLLYANNA, one who is naively optimistic [n]\n",
  "POLLYANNISH": "tediously optimistic, also POLLYANNAISH [adj]\n",
  "POLLYWIG": "a tadpole, also POLLIWIG, POLLIWOG, POLLYWOG, PORWIGGLE [n -S]\n",
  "POLLYWIGS": "POLLYWIG, a tadpole, also POLLIWIG, POLLIWOG, POLLYWOG, PORWIGGLE [n]\n",
  "POLLYWOG": "a tadpole, also POLLIWIG, POLLIWOG, POLLYWIG, PORWIGGLE [n -S]\n",
  "POLLYWOGS": "POLLYWOG, a tadpole, also POLLIWIG, POLLIWOG, POLLYWIG, PORWIGGLE [n]\n",
  "POLO": "a game played on horseback [n -S]\n",
  "POLOIDAL": "of a magnetic field, generated by an electric current flowing in a ring [adj]\n",
  "POLOIST": "a polo player [n -S]\n",
  "POLOISTS": "POLOIST, a polo player [n]\n",
  "POLONAISE": "(French) a stately Polish dance of moderate tempo [n -S]\n",
  "POLONAISES": "POLONAISE, (French) a stately Polish dance of moderate tempo [n]\n",
  "POLONIE": "(Scots) a child's polonaise, a stately Polish dance of moderate tempo [n -S]\n",
  "POLONIES": "POLONY, a kind of sausage made of meat partly cooked [n]\n",
  "POLONISE": "to make Polish, also POLONIZE [v POLONISED, POLONISING, POLONISES]\n",
  "POLONISED": "POLONISE, to make Polish, also POLONIZE [v]\n",
  "POLONISES": "POLONISE, to make Polish, also POLONIZE [v]\n",
  "POLONISING": "POLONISE, to make Polish, also POLONIZE [v]\n",
  "POLONISM": "a Polish idiom [n -S]\n",
  "POLONISMS": "POLONISM, a Polish idiom [n]\n",
  "POLONIUM": "a rare highly radioactive metallic chemical element, present in some uranium ores [n -S]\n",
  "POLONIUMS": "POLONIUM, a rare highly radioactive metallic chemical element, present in some uranium ores [n]\n",
  "POLONIZE": "to make Polish, also POLONISE [v POLONIZED, POLONIZING, POLONIZES]\n",
  "POLONIZED": "POLONIZE, to make Polish, also POLONISE [v]\n",
  "POLONIZES": "POLONIZE, to make Polish, also POLONISE [v]\n",
  "POLONIZING": "POLONIZE, to make Polish, also POLONISE [v]\n",
  "POLONY": "a kind of sausage made of meat partly cooked [n POLONIES]\n",
  "POLOS": "POLO, a game played on horseback [n]\n",
  "POLS": "POL, a politician [n]\n",
  "POLT": "to strike, thump [v -ED, -ING, -S]\n",
  "POLTED": "POLT, to strike, thump [v]\n",
  "POLTERGEIST": "(German) a spirit believed to manifest itself by making noises and moving physical objects [n -S]\n",
  "POLTERGEISTS": "POLTERGEIST, (German) a spirit believed to manifest itself by making noises and moving physical objects [n]\n",
  "POLTFEET": "POLTFOOT, a clubfoot [n]\n",
  "POLTFOOT": "a clubfoot [n POLTFEET]\n",
  "POLTING": "POLT, to strike, thump [v]\n",
  "POLTROON": "a despicable coward, also POULTROONE [n -S]\n",
  "POLTROONERIES": "POLTROONERY, mean pusillanimity, cowardice [n]\n",
  "POLTROONERY": "mean pusillanimity, cowardice [n POLTROONERIES]\n",
  "POLTROONS": "POLTROON, a despicable coward, also POULTROONE [n]\n",
  "POLTS": "POLT, to strike, thump [v]\n",
  "POLVERINE": "(obsolete) barilla ash, used in glassmaking, also PULVERINE [n -S]\n",
  "POLVERINES": "POLVERINE, (obsolete) barilla ash, used in glassmaking, also PULVERINE [n]\n",
  "POLY": "(short for) a polytechnic [n POLIES or POLYS]\n",
  "POLYACID": "a compound made up of two or more hydroxyl groups [n -S]\n",
  "POLYACIDS": "POLYACID, a compound made up of two or more hydroxyl groups [n]\n",
  "POLYACRYLAMIDE": "a polyamide of acrylic acid [n -S]\n",
  "POLYACRYLAMIDES": "POLYACRYLAMIDE, a polyamide of acrylic acid [n]\n",
  "POLYACT": "of a marine animal, having many rays or tentacles, also POLYACTINAL, POLYACTINE [adj]\n",
  "POLYACTINAL": "of a marine animal, having many rays or tentacles, also POLYACT, POLYACTINE [adj]\n",
  "POLYACTINE": "the spicule of a polyactinal sponge, also POLYACT [n -S]\n",
  "POLYACTINES": "POLYACTINE, the spicule of a polyactinal sponge, also POLYACT [n]\n",
  "POLYADELPHOUS": "of stamens, united in several bundles; having the stamens so united [adj]\n",
  "POLYADIC": "of a mathematical function, taking several arguments, cf. monadic [adj]\n",
  "POLYALCOHOL": "an alcohol that contains more than one hydroxyl group [n -S]\n",
  "POLYALCOHOLS": "POLYALCOHOL, an alcohol that contains more than one hydroxyl group [n]\n",
  "POLYAMIDE": "a compound characterized by more than one amide group [n -S]\n",
  "POLYAMIDES": "POLYAMIDE, a compound characterized by more than one amide group [n]\n",
  "POLYAMINE": "a compound characterized by more than one amino group [n -S]\n",
  "POLYAMINES": "POLYAMINE, a compound characterized by more than one amino group [n]\n",
  "POLYAMORIES": "POLYAMORY, the practice of having more than one sexual and emotional relationship at a time, with the full consent of all partners [n]\n",
  "POLYAMOROUS": "related to polyamory, the state or practice of having more than one open romantic relationship at a time [adj]\n",
  "POLYAMORY": "the practice of having more than one sexual and emotional relationship at a time, with the full consent of all partners [n POLYAMORIES]\n",
  "POLYANDRIES": "POLYANDRY, marriage to several men at the same time [n]\n",
  "POLYANDROUS": "relating to polyandry [adj]\n",
  "POLYANDRY": "marriage to several men at the same time [n POLYANDRIES]\n",
  "POLYANTHA": "any of large number of dwarf hybrid roses [n -S]\n",
  "POLYANTHAS": "POLYANTHA, any of large number of dwarf hybrid roses [n]\n",
  "POLYANTHI": "POLYANTHUS, the oxlip, so called because the peduncle bears a many-flowered umbel [n]\n",
  "POLYANTHUS": "the oxlip, so called because the peduncle bears a many-flowered umbel [n POLYANTHI or POLYANTHUSES]\n",
  "POLYANTHUSES": "POLYANTHUS, the oxlip, so called because the peduncle bears a many-flowered umbel [n]\n",
  "POLYARCH": "having many xylem strands [adj]\n",
  "POLYARCHIES": "POLYARCHY, government by many people [n]\n",
  "POLYARCHY": "government by many people [n POLYARCHIES]\n",
  "POLYARTHRITIDES": "POLYARTHRITIS, arthritis affecting several joints [n]\n",
  "POLYARTHRITIS": "arthritis affecting several joints [n POLYARTHRITISES or POLYARTHRITIDES]\n",
  "POLYARTHRITISES": "POLYARTHRITIS, arthritis affecting several joints [n]\n",
  "POLYATOMIC": "having many atoms, multivalent [adj]\n",
  "POLYAXIAL": "a shape having many axes or several axis cylinders [n -S]\n",
  "POLYAXIALS": "POLYAXIAL, a shape having many axes or several axis cylinders [n]\n",
  "POLYAXON": "a nerve cell with multiple branches [n -S]\n",
  "POLYAXONIC": "having many axes or several axis cylinders [adj]\n",
  "POLYAXONS": "POLYAXON, a nerve cell with multiple branches [n]\n",
  "POLYBAG": "to put into a polythene bag [v POLYBAGGED, POLYBAGGING, POLYBAGS]\n",
  "POLYBAGGED": "POLYBAG, to put into a polythene bag [v]\n",
  "POLYBAGGING": "POLYBAG, to put into a polythene bag [v]\n",
  "POLYBAGS": "POLYBAG, to put into a polythene bag [v]\n",
  "POLYBASIC": "of an acid, having more than one replaceable hydrogen atom per molecule [adj]\n",
  "POLYBASITE": "a grey to black mineral consisting of a sulphide of silver, antimony, and copper in the form of platelike monoclinic crystals [n -S]\n",
  "POLYBASITES": "POLYBASITE, a grey to black mineral consisting of a sulphide of silver, antimony, and copper in the form of platelike monoclinic crystals [n]\n",
  "POLYBRID": "a type of hybrid plant [n -S]\n",
  "POLYBRIDS": "POLYBRID, a type of hybrid plant [n]\n",
  "POLYBUTADIENE": "a synthetic rubber that has a high resistance to wear and is used esp. in the manufacture of tires [n -S]\n",
  "POLYBUTADIENES": "POLYBUTADIENE, a synthetic rubber that has a high resistance to wear and is used esp. in the manufacture of tires [n]\n",
  "POLYCARBONATE": "any of a range of strong thermoplastics [n -S]\n",
  "POLYCARBONATES": "POLYCARBONATE, any of a range of strong thermoplastics [n]\n",
  "POLYCARBOXYLATE": "a salt or ester of a polycarboxylic acid, used in certain detergents [n]\n",
  "POLYCARBOXYLIC": "of or like a polycarboxylate [adj]\n",
  "POLYCARPELLARY": "of a plant gynoecium, having or consisting of many carpels [adj]\n",
  "POLYCARPIC": "fruiting many times, or year after year, also POLYCARPOUS [adj]\n",
  "POLYCARPIES": "POLYCARPY, the condition of being able to produce fruit and flowers several times in successive years or seasons [n]\n",
  "POLYCARPOUS": "fruiting many times, or year after year, also POLYCARPIC [adj]\n",
  "POLYCARPY": "the condition of being able to produce fruit and flowers several times in successive years or seasons [n POLYCARPIES]\n",
  "POLYCENTRIC": "a type of chromosome [n -S]\n",
  "POLYCENTRICS": "POLYCENTRIC, a type of chromosome [n]\n",
  "POLYCENTRISM": "the existence of many centers of Communist ideological thought [n -S]\n",
  "POLYCENTRISMS": "POLYCENTRISM, the existence of many centers of Communist ideological thought [n]\n",
  "POLYCHAETE": "a type of aquatic worm (including lugworms and ragworms), also POLYCHETE [n -S]\n",
  "POLYCHAETES": "POLYCHAETE, a type of aquatic worm (including lugworms and ragworms), also POLYCHETE [n]\n",
  "POLYCHAETOUS": "of or like a polychaete, a type of aquatic worm, also POLYCHETOUS [adj]\n",
  "POLYCHASIA": "POLYCHASIUM, a cymose inflorescence in which three or more branches arise from each node [n]\n",
  "POLYCHASIUM": "a cymose inflorescence in which three or more branches arise from each node [n POLYCHASIA]\n",
  "POLYCHETE": "a type of aquatic worm (including lugworms and ragworms), also POLYCHAETE [n -S]\n",
  "POLYCHETES": "POLYCHETE, a type of aquatic worm (including lugworms and ragworms), also POLYCHAETE [n]\n",
  "POLYCHETOUS": "of, relating to, or belonging to the class Polychaeta, also POLYCHAETOUS [adj]\n",
  "POLYCHLORINATED": "as in polychlorinated biphenyl [adj]\n",
  "POLYCHLOROPRENE": "neoprene [n]\n",
  "POLYCHOTOMIES": "POLYCHOTOMY, division into many parts, e.g. on a cladogram [n]\n",
  "POLYCHOTOMOUS": "dividing or marked by division into many parts, branches, or classes [adj]\n",
  "POLYCHOTOMY": "division into many parts, e.g. on a cladogram [n POLYCHOTOMIES]\n",
  "POLYCHREST": "a thing or medicine useful in many ways [n -S]\n",
  "POLYCHRESTS": "POLYCHREST, a thing or medicine useful in many ways [n]\n",
  "POLYCHROIC": "displaying different colours when seen from different directions, also PLEOCHROIC [adj]\n",
  "POLYCHROISM": "the state of being polychroic [n -S]\n",
  "POLYCHROISMS": "POLYCHROISM, the state of being polychroic [n]\n",
  "POLYCHROMATIC": "showing a variety or a change of colors [adj]\n",
  "POLYCHROMATISM": "being multicoloured [n -S]\n",
  "POLYCHROMATISMS": "POLYCHROMATISM, being multicoloured [n]\n",
  "POLYCHROME": "many-coloured, also POLYCHROMIC, POLYCHROMOUS [adj] / to colour in many colours [v POLYCHROMED, POLYCHROMING, POLYCHROMES]\n",
  "POLYCHROMED": "POLYCHROME, to colour in many colours [v]\n",
  "POLYCHROMES": "POLYCHROME, to colour in many colours [v]\n",
  "POLYCHROMIC": "many-coloured, also POLYCHROME, POLYCHROMOUS [adj]\n",
  "POLYCHROMIES": "POLYCHROMY, the art or practice of combining different colors, esp. brilliant ones, in an artistic way [n]\n",
  "POLYCHROMING": "POLYCHROME, to colour in many colours [v]\n",
  "POLYCHROMOUS": "many-coloured, also POLYCHROME, POLYCHROMIC [adj]\n",
  "POLYCHROMY": "the art or practice of combining different colors, esp. brilliant ones, in an artistic way [n POLYCHROMIES]\n",
  "POLYCISTRONIC": "containing the genetic information of a number of cistrons [adj]\n",
  "POLYCLINIC": "a clinic in which diseases of many sorts are treated; esp. an institution in which clinical instruction is given in all kinds of disease [n -S]\n",
  "POLYCLINICS": "POLYCLINIC, a clinic in which diseases of many sorts are treated; esp. an institution in which clinical instruction is given in all kinds of disease [n]\n",
  "POLYCLONAL": "a type of antibody [n -S]\n",
  "POLYCLONALS": "POLYCLONAL, a type of antibody [n]\n",
  "POLYCONIC": "pertaining to, or based upon, many cones [adj]\n",
  "POLYCOT": "(short for) a polycotyledon, a plant with more than two cotyledons [n -S]\n",
  "POLYCOTS": "POLYCOT, (short for) a polycotyledon, a plant with more than two cotyledons [n]\n",
  "POLYCOTTON": "a synthetic fabric [n -S]\n",
  "POLYCOTTONS": "POLYCOTTON, a synthetic fabric [n]\n",
  "POLYCOTYLEDON": "any of various plants, esp. gymnosperms, that have or appear to have more than two cotyledons [n -S]\n",
  "POLYCOTYLEDONS": "POLYCOTYLEDON, any of various plants, esp. gymnosperms, that have or appear to have more than two cotyledons [n]\n",
  "POLYCROTIC": "of or pertaining to polycrotism, the state of having several beats to each heartbeat [adj]\n",
  "POLYCROTISM": "the state of having several beats to each heartbeat [n -S]\n",
  "POLYCROTISMS": "POLYCROTISM, the state of having several beats to each heartbeat [n]\n",
  "POLYCRYSTAL": "an object composed of several or many variously orientated crystals [n -S]\n",
  "POLYCRYSTALLINE": "consisting of crystals variously oriented [adj]\n",
  "POLYCRYSTALS": "POLYCRYSTAL, an object composed of several or many variously orientated crystals [n]\n",
  "POLYCULTURE": "the simultaneous production of several different crops and types of livestock in one region [n -S]\n",
  "POLYCULTURES": "POLYCULTURE, the simultaneous production of several different crops and types of livestock in one region [n]\n",
  "POLYCYCLIC": "having many circles, rings, whorls [adj] / something have many cycles or rings [n -S]\n",
  "POLYCYCLICS": "POLYCYCLIC, something have many cycles or rings [n]\n",
  "POLYCYSTIC": "having or involving more than one cyst [adj]\n",
  "POLYCYTHAEMIA": "a condition marked by an abnormal increase in the number of circulating red blood cells, also POLYCYTHEMIA [n -S]\n",
  "POLYCYTHAEMIAS": "POLYCYTHAEMIA, a condition marked by an abnormal increase in the number of circulating red blood cells, also POLYCYTHEMIA [n]\n",
  "POLYCYTHEMIA": "a condition marked by an abnormal increase in the number of circulating red blood cells, also POLYCYTHAEMIA [n -S]\n",
  "POLYCYTHEMIAS": "POLYCYTHEMIA, a condition marked by an abnormal increase in the number of circulating red blood cells, also POLYCYTHAEMIA [n]\n",
  "POLYCYTHEMIC": "relating to polycythemia [adj]\n",
  "POLYDACTYL": "having too many fingers or toes [adj] / someone having too many fingers or toes [n -S]\n",
  "POLYDACTYLIES": "POLYDACTYLY, the state of being polydactyl, having too many fingers or toes [n]\n",
  "POLYDACTYLISM": "the state of being polydactyl, having more than the normal number of fingers [n -S]\n",
  "POLYDACTYLISMS": "POLYDACTYLISM, the state of being polydactyl, having more than the normal number of fingers [n]\n",
  "POLYDACTYLOUS": "having too many fingers or toes [adj]\n",
  "POLYDACTYLS": "POLYDACTYL, someone having too many fingers or toes [n]\n",
  "POLYDACTYLY": "the state of being polydactyl, having too many fingers or toes [n POLYDACTYLIES]\n",
  "POLYDAEMONISM": "the belief in and worship of numerous supernatural powers, also POLYDEMONISM [n -S]\n",
  "POLYDAEMONISMS": "POLYDAEMONISM, the belief in and worship of numerous supernatural powers, also POLYDEMONISM [n]\n",
  "POLYDEMIC": "growing in or inhabiting more than two regions [adj]\n",
  "POLYDEMONISM": "the belief in and worship of numerous supernatural powers, also POLYDAEMONISM [n -S]\n",
  "POLYDEMONISMS": "POLYDEMONISM, the belief in and worship of numerous supernatural powers, also POLYDAEMONISM [n]\n",
  "POLYDIPSIA": "abnormal thirst [n -S]\n",
  "POLYDIPSIAS": "POLYDIPSIA, abnormal thirst [n]\n",
  "POLYDIPSIC": "relating to polydipsia, excessive thirst [adj]\n",
  "POLYDISPERSE": "characterized by particles of varied sizes in the dispersed phase of a disperse system [adj]\n",
  "POLYDISPERSITY": "the state of being polydisperse, characterized by particles of varied sizes in the dispersed phase of a disperse system [n]\n",
  "POLYDRUG": "pertaining to using several drugs together [adj]\n",
  "POLYELECTROLYTE": "a jellylike plastic compounded of two polymers, one charged positively and one negatively [n]\n",
  "POLYEMBRYONATE": "forming more than one embryo from one ovule or from one fertilized ovum [adj]\n",
  "POLYEMBRYONIC": "relating to polyembryony [adj]\n",
  "POLYEMBRYONIES": "POLYEMBRYONY, the condition of having several embryos [n]\n",
  "POLYEMBRYONY": "the condition of having several embryos [n POLYEMBRYONIES]\n",
  "POLYENE": "a hydrocarbon with many carbon-carbon double bonds [n -S]\n",
  "POLYENES": "POLYENE, a hydrocarbon with many carbon-carbon double bonds [n]\n",
  "POLYENIC": "relating to a polyene, a chemical compound [adj]\n",
  "POLYESTER": "any of a range of polymerized esters [n -S]\n",
  "POLYESTERS": "POLYESTER, any of a range of polymerized esters [n]\n",
  "POLYESTROUS": "having more than one period of estrus in a year [adj]\n",
  "POLYETHENE": "the systematic name for polythene [n -S]\n",
  "POLYETHENES": "POLYETHENE, the systematic name for polythene [n]\n",
  "POLYETHYLENE": "a generic name for certain thermoplastics, polymers of ethylene, also POLYTHENE [n -S]\n",
  "POLYETHYLENES": "POLYETHYLENE, a generic name for certain thermoplastics, polymers of ethylene, also POLYTHENE [n]\n",
  "POLYGALA": "any plant of the milkwort genus Polygala [n -S]\n",
  "POLYGALACEOUS": "belonging to the family Polygalaceae, milkworts [adj]\n",
  "POLYGALAS": "POLYGALA, any plant of the milkwort genus Polygala [n]\n",
  "POLYGAM": "(Greek) a plant with male, female and hermaphrodite flowers together [n -S]\n",
  "POLYGAMIC": "of or like a polygam, a flower having male, female and hermaphrodite flowers [adj]\n",
  "POLYGAMIES": "POLYGAMY, the condition of having more than one spouse at the same time [n]\n",
  "POLYGAMISE": "to practise polygamy, also POLYGAMIZE [v POLYGAMISED, POLYGAMISING, POLYGAMISES]\n",
  "POLYGAMISED": "POLYGAMISE, to practise polygamy, also POLYGAMIZE [v]\n",
  "POLYGAMISES": "POLYGAMISE, to practise polygamy, also POLYGAMIZE [v]\n",
  "POLYGAMISING": "POLYGAMISE, to practise polygamy, also POLYGAMIZE [v]\n",
  "POLYGAMIST": "one who practises polygamy [n -S]\n",
  "POLYGAMISTS": "POLYGAMIST, one who practises polygamy [n]\n",
  "POLYGAMIZE": "to practise polygamy, also POLYGAMISE [v POLYGAMIZED, POLYGAMIZING, POLYGAMIZES]\n",
  "POLYGAMIZED": "POLYGAMIZE, to practise polygamy, also POLYGAMISE [v]\n",
  "POLYGAMIZES": "POLYGAMIZE, to practise polygamy, also POLYGAMISE [v]\n",
  "POLYGAMIZING": "POLYGAMIZE, to practise polygamy, also POLYGAMISE [v]\n",
  "POLYGAMOUS": "of or pertaining to polygamy [adj POLYGAMOUSLY]\n",
  "POLYGAMOUSLY": "POLYGAMOUS, of or pertaining to polygamy [adv]\n",
  "POLYGAMS": "POLYGAM, (Greek) a plant with male, female and hermaphrodite flowers together [n]\n",
  "POLYGAMY": "the condition of having more than one spouse at the same time [n POLYGAMIES]\n",
  "POLYGENE": "a set of cooperating genes, each producing a small effect [n -S]\n",
  "POLYGENES": "POLYGENE, a set of cooperating genes, each producing a small effect [n]\n",
  "POLYGENESES": "POLYGENESIS, the theory that humans derived from many separate origins [n]\n",
  "POLYGENESIS": "the theory that humans derived from many separate origins [n POLYGENESES]\n",
  "POLYGENETIC": "of polygenesis; springing from several sources [adj POLYGENETICALLY]\n",
  "POLYGENETICALLY": "POLYGENETIC, of polygenesis; springing from several sources [adv]\n",
  "POLYGENIC": "of or relating to polygeny [adj]\n",
  "POLYGENIES": "POLYGENY, generation from multiple origins [n]\n",
  "POLYGENISM": "the doctrine that animals of the same species have sprung from more than one original pair [n -S]\n",
  "POLYGENISMS": "POLYGENISM, the doctrine that animals of the same species have sprung from more than one original pair [n]\n",
  "POLYGENIST": "one who maintains that animals of the same species have sprung from more than one original pair [n -S]\n",
  "POLYGENISTS": "POLYGENIST, one who maintains that animals of the same species have sprung from more than one original pair [n]\n",
  "POLYGENOUS": "of multiple origin or composition [adj]\n",
  "POLYGENY": "generation from multiple origins [n POLYGENIES]\n",
  "POLYGLOT": "one who speaks many languages, also POLYGLOTT [n -S]\n",
  "POLYGLOTISM": "the use of many languages [n -S]\n",
  "POLYGLOTISMS": "POLYGLOTISM, the use of many languages [n]\n",
  "POLYGLOTS": "POLYGLOT, one who speaks many languages, also POLYGLOTT [n]\n",
  "POLYGLOTT": "one who speaks many languages, also POLYGLOT [n -S]\n",
  "POLYGLOTTAL": "like a polyglot, also POLYGLOTTIC, POLYGLOTTOUS [adj]\n",
  "POLYGLOTTIC": "like a polyglot, also POLYGLOTTAL, POLYGLOTTOUS [adj]\n",
  "POLYGLOTTISM": "the state of being polyglot [n -S]\n",
  "POLYGLOTTISMS": "POLYGLOTTISM, the state of being polyglot [n]\n",
  "POLYGLOTTOUS": "like a polyglot, also POLYGLOTTAL, POLYGLOTTIC [adj]\n",
  "POLYGLOTTS": "POLYGLOTT, one who speaks many languages, also POLYGLOT [n]\n",
  "POLYGON": "(Greek) a plane figure bounded by straight lines, esp. more than four [n -S]\n",
  "POLYGONACEOUS": "belonging to the family Polygonaceae, knotgrasses [adj]\n",
  "POLYGONAL": "like a polygon [adj POLYGONALLY]\n",
  "POLYGONALLY": "POLYGONAL, like a polygon [adv]\n",
  "POLYGONATUM": "the Solomon's seal genus Polygonatum, of the lily family [n -S]\n",
  "POLYGONATUMS": "POLYGONATUM, the Solomon's seal genus Polygonatum, of the lily family [n]\n",
  "POLYGONIES": "POLYGONY, (Spenser) the plant bistort [n]\n",
  "POLYGONS": "POLYGON, (Greek) a plane figure bounded by straight lines, esp. more than four [n]\n",
  "POLYGONUM": "any plant of the knotgrass family Polygonaceae [n -S]\n",
  "POLYGONUMS": "POLYGONUM, any plant of the knotgrass family Polygonaceae [n]\n",
  "POLYGONY": "(Spenser) the plant bistort [n POLYGONIES]\n",
  "POLYGRAPH": "an instrument for multiplying copies of a writing [n -S] / to copy by polygraph [v -ED, -ING, -S]\n",
  "POLYGRAPHED": "POLYGRAPH, to copy by polygraph [v]\n",
  "POLYGRAPHER": "one who operates a polygraph [n -S]\n",
  "POLYGRAPHERS": "POLYGRAPHER, one who operates a polygraph [n]\n",
  "POLYGRAPHIC": "relating to a polygraph [adj POLYGRAPHICALLY]\n",
  "POLYGRAPHICALLY": "POLYGRAPHIC, relating to a polygraph [adv]\n",
  "POLYGRAPHIES": "POLYGRAPHY, the use of a polygraph; the interpretation of data from a polygraph [n]\n",
  "POLYGRAPHING": "POLYGRAPH, to copy by polygraph [v]\n",
  "POLYGRAPHIST": "one who operates a polygraph [n -S]\n",
  "POLYGRAPHISTS": "POLYGRAPHIST, one who operates a polygraph [n]\n",
  "POLYGRAPHS": "POLYGRAPH, an instrument for multiplying copies of a writing [n]\n",
  "POLYGRAPHY": "the use of a polygraph; the interpretation of data from a polygraph [n POLYGRAPHIES]\n",
  "POLYGYNE": "having more than one egg-laying queen in an insect colony [adj]\n",
  "POLYGYNIAN": "having many styles; belonging to the order Polygynia, also POLYGYNOUS [adj]\n",
  "POLYGYNIES": "POLYGYNY, the condition of having more than one wife at the same time [n]\n",
  "POLYGYNIST": "one who practises polygyny, marriage to several women [n -S]\n",
  "POLYGYNISTS": "POLYGYNIST, one who practises polygyny, marriage to several women [n]\n",
  "POLYGYNOUS": "having many styles; belonging to the order Polygynia, also POLYGYNIAN [adj]\n",
  "POLYGYNY": "the condition of having more than one wife at the same time [n POLYGYNIES]\n",
  "POLYHALITE": "a triclinic hydrated sulphate of calcium, potassium, and magnesium, usually occurring as red or yellowish fibrous masses [n -S]\n",
  "POLYHALITES": "POLYHALITE, a triclinic hydrated sulphate of calcium, potassium, and magnesium, usually occurring as red or yellowish fibrous masses [n]\n",
  "POLYHEDRA": "POLYHEDRON, a body or solid contained by many sides or planes [n]\n",
  "POLYHEDRAL": "having many faces or planes, also POLYHEDRIC [adj]\n",
  "POLYHEDRIC": "having many faces or planes, also POLYHEDRAL [adj]\n",
  "POLYHEDRON": "a body or solid contained by many sides or planes [n POLYHEDRA or POLYHEDRONS]\n",
  "POLYHEDRONS": "POLYHEDRON, a body or solid contained by many sides or planes [n]\n",
  "POLYHEDROSES": "POLYHEDROSIS, an often fatal disease of certain insect larvae or decapod crustaceans, caused by viruses containing DNA [n]\n",
  "POLYHEDROSIS": "an often fatal disease of certain insect larvae or decapod crustaceans, caused by viruses containing DNA [n POLYHEDROSES]\n",
  "POLYHISTOR": "a person of great and wide learning, also POLYHISTORIAN [n -S]\n",
  "POLYHISTORIAN": "a person of great and varied learning, also POLYHISTOR [n -S]\n",
  "POLYHISTORIANS": "POLYHISTORIAN, a person of great and varied learning, also POLYHISTOR [n]\n",
  "POLYHISTORIC": "relating to polyhistory, great and varied learning [adj]\n",
  "POLYHISTORIES": "POLYHISTORY, great and varied learning [n]\n",
  "POLYHISTORS": "POLYHISTOR, a person of great and wide learning, also POLYHISTORIAN [n]\n",
  "POLYHISTORY": "great and varied learning [n POLYHISTORIES]\n",
  "POLYHYBRID": "a plant hybridised from many sources [n -S]\n",
  "POLYHYBRIDS": "POLYHYBRID, a plant hybridised from many sources [n]\n",
  "POLYHYDRIC": "having several hydroxyl groups [adj]\n",
  "POLYHYDROXY": "containing more than one hydroxyl group in the molecule [adj]\n",
  "POLYIMIDE": "a polymer containing imide groups, used in heat-resistant materials [n -S]\n",
  "POLYIMIDES": "POLYIMIDE, a polymer containing imide groups, used in heat-resistant materials [n]\n",
  "POLYISOPRENE": "a rubberlike polymer of isoprene [n -S]\n",
  "POLYISOPRENES": "POLYISOPRENE, a rubberlike polymer of isoprene [n]\n",
  "POLYLEMMA": "an argument forcing a choice between contradictory statements [n -S]\n",
  "POLYLEMMAS": "POLYLEMMA, an argument forcing a choice between contradictory statements [n]\n",
  "POLYLINGUAL": "involving many languages [adj]\n",
  "POLYLYSINE": "a protein whose polypeptide chain consists entirely of lysine residues [n -S]\n",
  "POLYLYSINES": "POLYLYSINE, a protein whose polypeptide chain consists entirely of lysine residues [n]\n",
  "POLYMASTIA": "the presence of supernumerary breasts or nipples, also POLYMASTISM, POLYMASTY [n -S]\n",
  "POLYMASTIAS": "POLYMASTIA, the presence of supernumerary breasts or nipples, also POLYMASTISM, POLYMASTY [n]\n",
  "POLYMASTIC": "a person having more than the normal number of breasts [n -S]\n",
  "POLYMASTICS": "POLYMASTIC, a person having more than the normal number of breasts [n]\n",
  "POLYMASTIES": "POLYMASTY, the presence of supernumerary breasts or nipples, also POLYMASTIA, POLYMASTISM [n]\n",
  "POLYMASTISM": "the presence of supernumerary breasts or nipples, also POLYMASTIA, POLYMASTY [n -S]\n",
  "POLYMASTISMS": "POLYMASTISM, the presence of supernumerary breasts or nipples, also POLYMASTIA, POLYMASTY [n]\n",
  "POLYMASTY": "the presence of supernumerary breasts or nipples, also POLYMASTIA, POLYMASTISM [n POLYMASTIES]\n",
  "POLYMATH": "a person of great and varied learning [n -S]\n",
  "POLYMATHIC": "pertaining to polymathy; acquainted with many branches of learning [adj]\n",
  "POLYMATHIES": "POLYMATHY, the knowledge of many arts and sciences [n]\n",
  "POLYMATHS": "POLYMATH, a person of great and varied learning [n]\n",
  "POLYMATHY": "the knowledge of many arts and sciences [n POLYMATHIES]\n",
  "POLYMER": "a complex chemical compound [n -S]\n",
  "POLYMERASE": "an enzyme present in cell nuclei which promotes the polymerization of DNA [n -S]\n",
  "POLYMERASES": "POLYMERASE, an enzyme present in cell nuclei which promotes the polymerization of DNA [n]\n",
  "POLYMERIC": "of, in a relation of, or manifesting polymerism [adj]\n",
  "POLYMERIDE": "a polymer [n -S]\n",
  "POLYMERIDES": "POLYMERIDE, a polymer [n]\n",
  "POLYMERIES": "POLYMERY, in botany, the condition of having many parts [n]\n",
  "POLYMERISATION": "a chemical reaction in which two or more molecules combine to form larger molecules that contain repeating structural units, also POLYMERIZATION [n -S]\n",
  "POLYMERISATIONS": "POLYMERISATION, a chemical reaction in which two or more molecules combine to form larger molecules that contain repeating structural units, also POLYMERIZATION [n]\n",
  "POLYMERISE": "to make into a polymer, also POLYMERIZE [v POLYMERISED, POLYMERISING, POLYMERISES]\n",
  "POLYMERISED": "POLYMERISE, to make into a polymer, also POLYMERIZE [v]\n",
  "POLYMERISES": "POLYMERISE, to make into a polymer, also POLYMERIZE [v]\n",
  "POLYMERISING": "POLYMERISE, to make into a polymer, also POLYMERIZE [v]\n",
  "POLYMERISM": "the state, quality, or relation of two or more polymeric substances [n -S]\n",
  "POLYMERISMS": "POLYMERISM, the state, quality, or relation of two or more polymeric substances [n]\n",
  "POLYMERIZATION": "a chemical reaction in which two or more molecules combine to form larger molecules that contain repeating structural units, also POLYMERISATION [n -S]\n",
  "POLYMERIZATIONS": "POLYMERIZATION, a chemical reaction in which two or more molecules combine to form larger molecules that contain repeating structural units, also POLYMERISATION [n]\n",
  "POLYMERIZE": "to make into a polymer, also POLYMERISE [v POLYMERIZED, POLYMERIZING, POLYMERIZES]\n",
  "POLYMERIZED": "POLYMERIZE, to make into a polymer, also POLYMERISE [v]\n",
  "POLYMERIZES": "POLYMERIZE, to make into a polymer, also POLYMERISE [v]\n",
  "POLYMERIZING": "POLYMERIZE, to make into a polymer, also POLYMERISE [v]\n",
  "POLYMEROUS": "consisting of many parts or segments [adj]\n",
  "POLYMERS": "POLYMER, a complex chemical compound [n]\n",
  "POLYMERY": "in botany, the condition of having many parts [n POLYMERIES]\n",
  "POLYMORPH": "a substance capable of crystallizing in several distinct forms called allomorphs [n -S]\n",
  "POLYMORPHIC": "occurring in several forms [adj POLYMORPHICALLY]\n",
  "POLYMORPHICALLY": "POLYMORPHIC, occurring in several forms [adv]\n",
  "POLYMORPHISM": "the circumstance in which two minerals with different crystalline structures have identical chemical compositions, e.g. diamond and graphite [n -S]\n",
  "POLYMORPHISMS": "POLYMORPHISM, the circumstance in which two minerals with different crystalline structures have identical chemical compositions, e.g. diamond and graphite [n]\n",
  "POLYMORPHOUS": "occurring in several forms [adj POLYMORPHOUSLY]\n",
  "POLYMORPHOUSLY": "POLYMORPHOUS, occurring in several forms [adv]\n",
  "POLYMORPHS": "POLYMORPH, a substance capable of crystallizing in several distinct forms called allomorphs [n]\n",
  "POLYMYOSITIS": "inflammation of several muscles at the same time [n -ES]\n",
  "POLYMYOSITISES": "POLYMYOSITIS, inflammation of several muscles at the same time [n]\n",
  "POLYMYXIN": "one of a group of mainly toxic antibiotics [n -S]\n",
  "POLYMYXINS": "POLYMYXIN, one of a group of mainly toxic antibiotics [n]\n",
  "POLYNEURITIDES": "POLYNEURITIS, neuritis of many nerves simultaneously [n]\n",
  "POLYNEURITIS": "neuritis of many nerves simultaneously [n POLYNEURITIDES or POLYNEURITISES]\n",
  "POLYNEURITISES": "POLYNEURITIS, neuritis of many nerves simultaneously [n]\n",
  "POLYNIA": "(Russian) open water surrounded by sea ice, also POLYNYA [n -S]\n",
  "POLYNIAS": "POLYNIA, (Russian) open water surrounded by sea ice, also POLYNYA [n]\n",
  "POLYNOMIAL": "an expression composed of two or more terms, connected by the signs plus or minus [n -S]\n",
  "POLYNOMIALISM": "the state of being polynomial [n -S]\n",
  "POLYNOMIALISMS": "POLYNOMIALISM, the state of being polynomial [n]\n",
  "POLYNOMIALS": "POLYNOMIAL, an expression composed of two or more terms, connected by the signs plus or minus [n]\n",
  "POLYNUCLEAR": "chemically polycyclic esp. with respect to the benzene ring [adj]\n",
  "POLYNUCLEATE": "having many nuclei [adj]\n",
  "POLYNUCLEOTIDE": "a polymeric chain of nucleotides [n -S]\n",
  "POLYNUCLEOTIDES": "POLYNUCLEOTIDE, a polymeric chain of nucleotides [n]\n",
  "POLYNYA": "(Russian) open water surrounded by sea ice, also POLYNIA [n POLYNYAS or POLYNYI]\n",
  "POLYNYAS": "POLYNYA, (Russian) open water surrounded by sea ice, also POLYNIA [n]\n",
  "POLYNYI": "POLYNYA, (Russian) open water surrounded by sea ice, also POLYNIA [n]\n",
  "POLYOL": "an alcohol containing three or more hydroxyl groups [n -S]\n",
  "POLYOLEFIN": "a polymer of an alkene (as polyethylene) [n -S]\n",
  "POLYOLEFINS": "POLYOLEFIN, a polymer of an alkene (as polyethylene) [n]\n",
  "POLYOLS": "POLYOL, an alcohol containing three or more hydroxyl groups [n]\n",
  "POLYOMA": "a small DNA virus that causes tumours in mice [n -S]\n",
  "POLYOMAS": "POLYOMA, a small DNA virus that causes tumours in mice [n]\n",
  "POLYOMINO": "a flat, many-sided shape made of up of identical squares placed side by side [n -ES or -S]\n",
  "POLYOMINOES": "POLYOMINO, a flat, many-sided shape made of up of identical squares placed side by side [n]\n",
  "POLYOMINOS": "POLYOMINO, a flat, many-sided shape made of up of identical squares placed side by side [n]\n",
  "POLYONYM": "a name consisting of several words [n -S]\n",
  "POLYONYMIC": "of a name, consisting of more than two words [adj]\n",
  "POLYONYMIES": "POLYONYMY, a multiplicity of names for the same thing [n]\n",
  "POLYONYMOUS": "(Greek) of e.g. gods, having or known by various names [adj]\n",
  "POLYONYMS": "POLYONYM, a name consisting of several words [n]\n",
  "POLYONYMY": "a multiplicity of names for the same thing [n POLYONYMIES]\n",
  "POLYP": "an octopus or cuttlefish, later extended to various other marine animals, also POLYPE, POULP, POULPE [n -S]\n",
  "POLYPARIA": "POLYPARIUM, the framework and base of a polyp colony, esp. coral, also POLYPARY [n]\n",
  "POLYPARIES": "POLYPARY, the common supporting structure of a polyp colony [n]\n",
  "POLYPARIUM": "the framework and base of a polyp colony, esp. coral, also POLYPARY [n POLYPARIA]\n",
  "POLYPARY": "the common supporting structure of a polyp colony [n POLYPARIES]\n",
  "POLYPE": "(obsolete) an octopus or cuttlefish, later extended to various other marine animals, also POLYP, POULP, POULPE [n -S]\n",
  "POLYPED": "something having many legs, also POLYPOD [n -S]\n",
  "POLYPEDS": "POLYPED, something having many legs, also POLYPOD [n]\n",
  "POLYPEPTIDE": "a compound containing between 10 and 100 peptides [n -S]\n",
  "POLYPEPTIDES": "POLYPEPTIDE, a compound containing between 10 and 100 peptides [n]\n",
  "POLYPEPTIDIC": "of or like a polypeptide [adj]\n",
  "POLYPES": "POLYPE, (obsolete) an octopus or cuttlefish, later extended to various other marine animals, also POLYP, POULP, POULPE [n]\n",
  "POLYPETALOUS": "separate petals [adj]\n",
  "POLYPHAGIA": "the eating of excessive amounts, or many different kinds, of food [n -S]\n",
  "POLYPHAGIAS": "POLYPHAGIA, the eating of excessive amounts, or many different kinds, of food [n]\n",
  "POLYPHAGIES": "POLYPHAGY, the practice or faculty of subsisting on many kinds of food [n]\n",
  "POLYPHAGOUS": "eating many types of food [adj]\n",
  "POLYPHAGY": "the practice or faculty of subsisting on many kinds of food [n POLYPHAGIES]\n",
  "POLYPHARMACIES": "POLYPHARMACY, treatment with many medicines for same disease [n]\n",
  "POLYPHARMACY": "treatment with many medicines for same disease [n POLYPHARMACIES]\n",
  "POLYPHASE": "having several alternating electric currents of equal frequency with uniformly spaced phase differences [adj]\n",
  "POLYPHASIC": "going through several periods of activity followed by rest in twenty-four hours [adj]\n",
  "POLYPHENOL": "a polyhydroxy phenol [n -S]\n",
  "POLYPHENOLIC": "of or like polyphenol [adj]\n",
  "POLYPHENOLS": "POLYPHENOL, a polyhydroxy phenol [n]\n",
  "POLYPHLOESBOEAN": "loud-roaring, also POLYPHLOISBIC [adj]\n",
  "POLYPHLOISBIC": "loud-roaring, also POLYPHLOESBOEAN [adj]\n",
  "POLYPHON": "a character or vocal sign representing more than one sound, as read, which is pronounced red, also POLYPHONE [n -S]\n",
  "POLYPHONE": "a character or vocal sign representing more than one sound, as read, which is pronounced red, also POLYPHON [n -S]\n",
  "POLYPHONES": "POLYPHONE, a character or vocal sign representing more than one sound, as read, which is pronounced red, also POLYPHON [n]\n",
  "POLYPHONIC": "having a multiplicity of sounds, also POLYPHONOUS [adj POLYPHONICALLY]\n",
  "POLYPHONICALLY": "POLYPHONIC, having a multiplicity of sounds, also POLYPHONOUS [adv]\n",
  "POLYPHONIES": "POLYPHONY, composition in separate, but simultaneous and harmonizing, parts [n]\n",
  "POLYPHONIST": "a contrapuntist, one who writes counterpoint [n -S]\n",
  "POLYPHONISTS": "POLYPHONIST, a contrapuntist, one who writes counterpoint [n]\n",
  "POLYPHONOUS": "relating to polyphony, also POLYPHONIC [adj POLYPHONOUSLY]\n",
  "POLYPHONOUSLY": "POLYPHONOUS, relating to polyphony, also POLYPHONIC [adv]\n",
  "POLYPHONS": "POLYPHON, a character or vocal sign representing more than one sound, as read, which is pronounced red, also POLYPHONE [n]\n",
  "POLYPHONY": "composition in separate, but simultaneous and harmonizing, parts [n POLYPHONIES]\n",
  "POLYPHOSPHORIC": "as in polyphosphoric acid, any oxyacid of pentavalent phosphorus [adj]\n",
  "POLYPHYLETIC": "descending from more than one original type [adj]\n",
  "POLYPHYLLOUS": "having the perianth leaves free [adj]\n",
  "POLYPHYODONT": "having more than two successive dentitions [adj]\n",
  "POLYPI": "POLYPUS, (Latin) a growth protruding from the mucous lining to an organ [n]\n",
  "POLYPIDE": "a polyp of a colonial animal, also POLYPITE [n -S]\n",
  "POLYPIDES": "POLYPIDE, a polyp of a colonial animal, also POLYPITE [n]\n",
  "POLYPIDOM": "a coral, or corallum; also, one of the coral-like structure made by bryozoans and hydroids [n -S]\n",
  "POLYPIDOMS": "POLYPIDOM, a coral, or corallum; also, one of the coral-like structure made by bryozoans and hydroids [n]\n",
  "POLYPILL": "a proposed pill which has drugs to control cholesterol, blood pressure and clotting [n -S]\n",
  "POLYPILLS": "POLYPILL, a proposed pill which has drugs to control cholesterol, blood pressure and clotting [n]\n",
  "POLYPINE": "of or like a (colonial) polyp [adj]\n",
  "POLYPITE": "a polyp of a colonial animal, also POLYPIDE [n -S]\n",
  "POLYPITES": "POLYPITE, a polyp of a colonial animal, also POLYPIDE [n]\n",
  "POLYPLOID": "having more than two sets (diploid) of the basic chromosome number (haploid) [n -S]\n",
  "POLYPLOIDAL": "having more than two sets (diploid) of the basic chromosome number (haploid), also POLYPLOIDIC [adj]\n",
  "POLYPLOIDIC": "having more than two sets (diploid) of the basic chromosome number (haploid), also POLYPLOIDAL [adj]\n",
  "POLYPLOIDIES": "POLYPLOIDY, the condition of being polyploid [n]\n",
  "POLYPLOIDS": "POLYPLOID, having more than two sets (diploid) of the basic chromosome number (haploid) [n]\n",
  "POLYPLOIDY": "the condition of being polyploid [n POLYPLOIDIES]\n",
  "POLYPNEA": "rapid breathing [n -S]\n",
  "POLYPNEAS": "POLYPNEA, rapid breathing [n]\n",
  "POLYPNEIC": "relating to polypnea, very rapid breathing [adj]\n",
  "POLYPOD": "(Greek) something having many legs, also POLYPED [n -S]\n",
  "POLYPODIES": "POLYPODY, a fern with creeping rootstocks [n]\n",
  "POLYPODOUS": "having many legs or similar appendages [adj]\n",
  "POLYPODS": "POLYPOD, (Greek) something having many legs, also POLYPED [n]\n",
  "POLYPODY": "a fern with creeping rootstocks [n POLYPODIES]\n",
  "POLYPOID": "like a (medical) polyp [adj]\n",
  "POLYPORE": "a fungus with pores [n -S]\n",
  "POLYPORES": "POLYPORE, a fungus with pores [n]\n",
  "POLYPOSES": "POLYPOSIS, the presence or development of polyps [n]\n",
  "POLYPOSIS": "the presence or development of polyps [n POLYPOSES]\n",
  "POLYPOUS": "of the nature of a polyp [adj]\n",
  "POLYPROPENE": "any of various thermoplastic plastics or fibers that are polymers of propylene, also POLYPROPYLENE [n -S]\n",
  "POLYPROPENES": "POLYPROPENE, any of various thermoplastic plastics or fibers that are polymers of propylene, also POLYPROPYLENE [n]\n",
  "POLYPROPYLENE": "any of various thermoplastic plastics or fibers that are polymers of propylene, also POLYPROPENE [n -S]\n",
  "POLYPROPYLENES": "POLYPROPYLENE, any of various thermoplastic plastics or fibers that are polymers of propylene, also POLYPROPENE [n]\n",
  "POLYPROTODONT": "any member of the Polyprotodontia, the suborder of marsupials, including opossums, dasyures, etc., with many small incisors [n -S]\n",
  "POLYPROTODONTS": "POLYPROTODONT, any member of the Polyprotodontia, the suborder of marsupials, including opossums, dasyures, etc., with many small incisors [n]\n",
  "POLYPS": "POLYP, an octopus or cuttlefish, later extended to various other marine animals, also POLYPE, POULP, POULPE [n]\n",
  "POLYPTYCH": "a decorated altarpiece or panel with 3 or more hinged sections that can be folded together [n -S]\n",
  "POLYPTYCHS": "POLYPTYCH, a decorated altarpiece or panel with 3 or more hinged sections that can be folded together [n]\n",
  "POLYPUS": "(Latin) a growth protruding from the mucous lining to an organ [n POLYPUSES or POLYPI]\n",
  "POLYPUSES": "POLYPUS, (Latin) a growth protruding from the mucous lining to an organ [n]\n",
  "POLYRHYTHM": "the simultaneous combination of different rhythms in a piece of music [n -S]\n",
  "POLYRHYTHMIC": "relating to polyrhythm [adj]\n",
  "POLYRHYTHMS": "POLYRHYTHM, the simultaneous combination of different rhythms in a piece of music [n]\n",
  "POLYRIBOSOMAL": "of or like a polyribosome [adj]\n",
  "POLYRIBOSOME": "a cluster of ribosomes linked together by a molecule of messenger RNA and forming the site of protein synthesis [n -S]\n",
  "POLYRIBOSOMES": "POLYRIBOSOME, a cluster of ribosomes linked together by a molecule of messenger RNA and forming the site of protein synthesis [n]\n",
  "POLYS": "POLY, (short for) a polytechnic [n]\n",
  "POLYSACCHARIDE": "a glycan, a carbohydrate whose molecules consist of a number of monosaccharide residues bonded together [n -S]\n",
  "POLYSACCHARIDES": "POLYSACCHARIDE, a glycan, a carbohydrate whose molecules consist of a number of monosaccharide residues bonded together [n]\n",
  "POLYSACCHAROSE": "any one of a class of carbohydrates whose molecules contain linked monosaccharide units, including starch, inulin, and cellulose [n -S]\n",
  "POLYSACCHAROSES": "POLYSACCHAROSE, any one of a class of carbohydrates whose molecules contain linked monosaccharide units, including starch, inulin, and cellulose [n]\n",
  "POLYSEMANT": "a word with many meanings [n -S]\n",
  "POLYSEMANTS": "POLYSEMANT, a word with many meanings [n]\n",
  "POLYSEME": "a word with more than one meaning [n -S]\n",
  "POLYSEMES": "POLYSEME, a word with more than one meaning [n]\n",
  "POLYSEMIC": "relating to a polyseme, a word with many meanings [adj]\n",
  "POLYSEMIES": "POLYSEMY, in linguistics, the state of having more than one meaning [n]\n",
  "POLYSEMOUS": "having multiple meanings [adj]\n",
  "POLYSEMY": "in linguistics, the state of having more than one meaning [n POLYSEMIES]\n",
  "POLYSEPALOUS": "having separate sepals [adj]\n",
  "POLYSILOXANE": "any of a number of polymers which are the basis of silicone chemistry [n -S]\n",
  "POLYSILOXANES": "POLYSILOXANE, any of a number of polymers which are the basis of silicone chemistry [n]\n",
  "POLYSOME": "a cluster of protein particles [n -S]\n",
  "POLYSOMES": "POLYSOME, a cluster of protein particles [n]\n",
  "POLYSOMIC": "a basically diploid chromosome complement, in which some but not all the chromosomes are represented more than twice [n -S]\n",
  "POLYSOMICS": "POLYSOMIC, a basically diploid chromosome complement, in which some but not all the chromosomes are represented more than twice [n]\n",
  "POLYSOMIES": "POLYSOMY, a condition in which one or more extra chromosomes are present in the cells of the body [n]\n",
  "POLYSOMY": "a condition in which one or more extra chromosomes are present in the cells of the body [n POLYSOMIES]\n",
  "POLYSORBATE": "an emulsifier [n -S]\n",
  "POLYSORBATES": "POLYSORBATE, an emulsifier [n]\n",
  "POLYSTICHOUS": "arranged in many rows [adj]\n",
  "POLYSTYLAR": "having many columns, also POLYSTYLE [adj]\n",
  "POLYSTYLE": "having many columns, also POLYSTYLAR [adj] / a building characterized by many columns [n -S]\n",
  "POLYSTYLES": "POLYSTYLE, a building characterized by many columns [n]\n",
  "POLYSTYRENE": "a polymer of styrene [n -S]\n",
  "POLYSTYRENES": "POLYSTYRENE, a polymer of styrene [n]\n",
  "POLYSULFIDE": "a sulfide containing two or more atoms of sulfur in the molecule, also POLYSULPHIDE [n -S]\n",
  "POLYSULFIDES": "POLYSULFIDE, a sulfide containing two or more atoms of sulfur in the molecule, also POLYSULPHIDE [n]\n",
  "POLYSULPHIDE": "a sulfide containing two or more atoms of sulfur in the molecule, also POLYSULFIDE [n -S]\n",
  "POLYSULPHIDES": "POLYSULPHIDE, a sulfide containing two or more atoms of sulfur in the molecule, also POLYSULFIDE [n]\n",
  "POLYSYLLABIC": "having more than one and usually more than three syllables, also POLYSYLLABICAL [adj]\n",
  "POLYSYLLABICAL": "having more than one and usually more than three syllables, also POLYSYLLABIC [adj]\n",
  "POLYSYLLABICISM": "the state of being polysyllabic, also POLYSYLLABISM [n]\n",
  "POLYSYLLABISM": "the state of being polysyllabic, also POLYSYLLABICISM [n -S]\n",
  "POLYSYLLABISMS": "POLYSYLLABISM, the state of being polysyllabic, also POLYSYLLABICISM [n]\n",
  "POLYSYLLABLE": "a polysyllabic word [n -S]\n",
  "POLYSYLLABLES": "POLYSYLLABLE, a polysyllabic word [n]\n",
  "POLYSYLLOGISM": "a series of syllogisms where each is basis for next [n -S]\n",
  "POLYSYLLOGISMS": "POLYSYLLOGISM, a series of syllogisms where each is basis for next [n]\n",
  "POLYSYNAPTIC": "involving two or more synapses in the central nervous system [adj]\n",
  "POLYSYNDETON": "the rhetorical device of repeating a conjunction for emphasis, as in 'it was red and yellow and pink and orange and blue!' [n -S]\n",
  "POLYSYNDETONS": "POLYSYNDETON, the rhetorical device of repeating a conjunction for emphasis, as in 'it was red and yellow and pink and orange and blue!' [n]\n",
  "POLYSYNTHESES": "POLYSYNTHESIS, the state of being polysynthetic [n]\n",
  "POLYSYNTHESIS": "the state of being polysynthetic [n POLYSYNTHESES]\n",
  "POLYSYNTHESISM": "the state of being polysynthetic [n -S]\n",
  "POLYSYNTHESISMS": "POLYSYNTHESISM, the state of being polysynthetic [n]\n",
  "POLYSYNTHETIC": "made up of many separate elements, also POLYSYNTHETICAL [adj]\n",
  "POLYSYNTHETICAL": "made up of many separate elements, also POLYSYNTHETIC [adj]\n",
  "POLYSYNTHETISM": "the state of being polysynthetic [n -S]\n",
  "POLYSYNTHETISMS": "POLYSYNTHETISM, the state of being polysynthetic [n]\n",
  "POLYTECHNIC": "a school teaching many arts and technical subjects [n -S]\n",
  "POLYTECHNICAL": "of or like a polytechnic [adj]\n",
  "POLYTECHNICS": "POLYTECHNIC, a school teaching many arts and technical subjects [n]\n",
  "POLYTENE": "having chromosomes of a certain type [adj]\n",
  "POLYTENIES": "POLYTENY, in abnormally large chromosomes, the state of being composed of many reduplicated strands [n]\n",
  "POLYTENY": "in abnormally large chromosomes, the state of being composed of many reduplicated strands [n POLYTENIES]\n",
  "POLYTHALAMOUS": "having many chambers [adj]\n",
  "POLYTHEISM": "belief in multiple deities [n -S]\n",
  "POLYTHEISMS": "POLYTHEISM, belief in multiple deities [n]\n",
  "POLYTHEIST": "an adherent of polytheism [n -S]\n",
  "POLYTHEISTIC": "relating to polytheism, also POLYTHEISTICAL [adj]\n",
  "POLYTHEISTICAL": "relating to polytheism, also POLYTHEISTIC [adj]\n",
  "POLYTHEISTS": "POLYTHEIST, an adherent of polytheism [n]\n",
  "POLYTHENE": "a generic name for certain thermoplastics, polymers of ethylene, also POLYETHYLENE [n -S]\n",
  "POLYTHENES": "POLYTHENE, a generic name for certain thermoplastics, polymers of ethylene, also POLYETHYLENE [n]\n",
  "POLYTOCOUS": "producing many or several at a birth [adj]\n",
  "POLYTONAL": "of music, having many keys [adj POLYTONALLY]\n",
  "POLYTONALISM": "the state of being polytonal, having many keys [n -S]\n",
  "POLYTONALISMS": "POLYTONALISM, the state of being polytonal, having many keys [n]\n",
  "POLYTONALIST": "one who writes polytonal music [n -S]\n",
  "POLYTONALISTS": "POLYTONALIST, one who writes polytonal music [n]\n",
  "POLYTONALITIES": "POLYTONALITY, two or more tonalities in a composition [n]\n",
  "POLYTONALITY": "two or more tonalities in a composition [n POLYTONALITIES]\n",
  "POLYTONALLY": "POLYTONAL, of music, having many keys [adv]\n",
  "POLYTROPHIC": "esp. of bacteria, obtaining food from several different organic sources [adj]\n",
  "POLYTUNNEL": "plastic sheeting stretched over rows of plants as protection from the weather [n -S]\n",
  "POLYTUNNELS": "POLYTUNNEL, plastic sheeting stretched over rows of plants as protection from the weather [n]\n",
  "POLYTYPE": "to produce by use of a cast, or facsimile copy, of an engraved block, matter in type, etc. [v POLYTYPED, POLYTYPING, POLYTYPES]\n",
  "POLYTYPED": "POLYTYPE, to produce by use of a cast, or facsimile copy, of an engraved block, matter in type, etc. [v]\n",
  "POLYTYPES": "POLYTYPE, to produce by use of a cast, or facsimile copy, of an engraved block, matter in type, etc. [v]\n",
  "POLYTYPIC": "of a taxon containing two or more taxa of lower ranks, also POLYTYPICAL [adj]\n",
  "POLYTYPICAL": "of a taxon containing two or more taxa of lower ranks, also POLYTYPIC [adj]\n",
  "POLYTYPING": "POLYTYPE, to produce by use of a cast, or facsimile copy, of an engraved block, matter in type, etc. [v]\n",
  "POLYUNSATURATE": "a fat that is polyunsaturated [n -S]\n",
  "POLYUNSATURATED": "having many double or triple bonds in a molecule [adj]\n",
  "POLYUNSATURATES": "POLYUNSATURATE, a fat that is polyunsaturated [n]\n",
  "POLYURETHAN": "any of various polymers used esp. in flexible and rigid foams, elastomers, and resins, also POLYURETHANE [n -S]\n",
  "POLYURETHANE": "any of various polymers used esp. in flexible and rigid foams, elastomers, and resins, also POLYURETHAN [n -S]\n",
  "POLYURETHANES": "POLYURETHANE, any of various polymers used esp. in flexible and rigid foams, elastomers, and resins, also POLYURETHAN [n]\n",
  "POLYURETHANS": "POLYURETHAN, any of various polymers used esp. in flexible and rigid foams, elastomers, and resins, also POLYURETHANE [n]\n",
  "POLYURIA": "excessive urination [n -S]\n",
  "POLYURIAS": "POLYURIA, excessive urination [n]\n",
  "POLYURIC": "relating to polyuria, the excessive secretion of urine [adj]\n",
  "POLYVALENCE": "the state of being polyvalent [n -S]\n",
  "POLYVALENCES": "POLYVALENCE, the state of being polyvalent [n]\n",
  "POLYVALENCIES": "POLYVALENCY, the state of being polyvalent [n]\n",
  "POLYVALENCY": "the state of being polyvalent [n POLYVALENCIES]\n",
  "POLYVALENT": "having multiple valency, also MULTIVALENT [adj]\n",
  "POLYVINYL": "a vinyl polymer [n -S]\n",
  "POLYVINYLIDENE": "any polymer derived from halogen monomers [n -S]\n",
  "POLYVINYLIDENES": "POLYVINYLIDENE, any polymer derived from halogen monomers [n]\n",
  "POLYVINYLS": "POLYVINYL, a vinyl polymer [n]\n",
  "POLYWATER": "a supposed form of water, said to be a polymer, with properties different from ordinary water [n -S]\n",
  "POLYWATERS": "POLYWATER, a supposed form of water, said to be a polymer, with properties different from ordinary water [n]\n",
  "POLYZOA": "POLYZOON, one of the individual zooids forming the compound organism of a polyzoan [n]\n",
  "POLYZOAN": "a bryozoan, a moss or liverwort [n -S]\n",
  "POLYZOANS": "POLYZOAN, a bryozoan, a moss or liverwort [n]\n",
  "POLYZOARIA": "POLYZOARIUM, a bryozoan colony or supporting structure [n]\n",
  "POLYZOARIAL": "relating to a polyzoarium, a bryozoan colony or supporting structure [adj]\n",
  "POLYZOARIES": "POLYZOARY, the compound organism of a polyzoan [n]\n",
  "POLYZOARIUM": "a bryozoan colony or supporting structure [n POLYZOARIA]\n",
  "POLYZOARY": "the compound organism of a polyzoan [n POLYZOARIES]\n",
  "POLYZOIC": "composed of many zooids [adj]\n",
  "POLYZONAL": "consisting of many zones or rings [adj]\n",
  "POLYZOOID": "like or of the nature of a polyzoon [adj]\n",
  "POLYZOON": "one of the individual zooids forming the compound organism of a polyzoan [n POLYZOA]\n",
  "POM": "(colloquial) a Pomeranian dog [n -S]\n",
  "POMACE": "the pulpy residue of crushed fruits [n -S]\n",
  "POMACEOUS": "of or relating to apples [adj]\n",
  "POMACES": "POMACE, the pulpy residue of crushed fruits [n]\n",
  "POMADE": "to apply a perfumed hair dressing to [v POMADED, POMADING, POMADES]\n",
  "POMADED": "POMADE, to apply a perfumed hair dressing to [v]\n",
  "POMADES": "POMADE, to apply a perfumed hair dressing to [v]\n",
  "POMADING": "POMADE, to apply a perfumed hair dressing to [v]\n",
  "POMANDER": "(French) a mixture of aromatic substances [n -S]\n",
  "POMANDERS": "POMANDER, (French) a mixture of aromatic substances [n]\n",
  "POMATO": "a tomato grafted on a potato [n -ES]\n",
  "POMATOES": "POMATO, a tomato grafted on a potato [n]\n",
  "POMATUM": "to apply a kind of ointment to the hair, also POMADE [v -ED, -ING, -S]\n",
  "POMATUMED": "POMATUM, to apply a kind of ointment to the hair, also POMADE [v]\n",
  "POMATUMING": "POMATUM, to apply a kind of ointment to the hair, also POMADE [v]\n",
  "POMATUMS": "POMATUM, to apply a kind of ointment to the hair, also POMADE [v]\n",
  "POMBE": "(Swahili) an African alcoholic drink [n -S]\n",
  "POMBES": "POMBE, (Swahili) an African alcoholic drink [n]\n",
  "POME": "any fruit of the apple family e.g. apple, quince [n -S]\n",
  "POMEGRANATE": "an Oriental fruit with a thick leathery rind and numerous seeds with pulpy edible seed coats [n -S]\n",
  "POMEGRANATES": "POMEGRANATE, an Oriental fruit with a thick leathery rind and numerous seeds with pulpy edible seed coats [n]\n",
  "POMELIKE": "like a pome [adj]\n",
  "POMELO": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n -S]\n",
  "POMELOS": "POMELO, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n]\n",
  "POMEROY": "an old variety of apple, also POMROY [n -S]\n",
  "POMEROYS": "POMEROY, an old variety of apple, also POMROY [n]\n",
  "POMES": "POME, any fruit of the apple family e.g. apple, quince [n]\n",
  "POMFRET": "(Portuguese) a sea fish found along the Indian coasts [n -S]\n",
  "POMFRETS": "POMFRET, (Portuguese) a sea fish found along the Indian coasts [n]\n",
  "POMICULTURE": "the growing of fruit [n -S]\n",
  "POMICULTURES": "POMICULTURE, the growing of fruit [n]\n",
  "POMIFEROUS": "bearing apples [adj]\n",
  "POMMEE": "of a heraldic cross, having arms with knoblike ends [adj]\n",
  "POMMEL": "to strike with the fists, also PUMMEL [v POMMELLED or POMMELED, POMMELLING or POMMELING, POMMELS]\n",
  "POMMELE": "having a heraldic pommel, also POMMETTY [adj]\n",
  "POMMELED": "POMMEL, to strike with the fists, also PUMMEL [v]\n",
  "POMMELING": "POMMEL, to strike with the fists, also PUMMEL [v]\n",
  "POMMELLED": "POMMEL, to strike with the fists, also PUMMEL [v]\n",
  "POMMELLING": "POMMEL, to strike with the fists, also PUMMEL [v]\n",
  "POMMELS": "POMMEL, to strike with the fists, also PUMMEL [v]\n",
  "POMMETTY": "in heraldry, having a pommel, also POMMELE [adj]\n",
  "POMMIE": "(Australian) an Englishman, also POMMY [n -S]\n",
  "POMMIES": "POMMY, (Australian) an Englishman, also POMMIE [n]\n",
  "POMMY": "(Australian) an Englishman, also POMMIE [n POMMIES]\n",
  "POMO": "(colloquial) postmodernism [n -S]\n",
  "POMOERIUM": "(Latin) an open space around a town within the walls [n -S]\n",
  "POMOERIUMS": "POMOERIUM, (Latin) an open space around a town within the walls [n]\n",
  "POMOLOGICAL": "relating to pomology [adj POMOLOGICALLY]\n",
  "POMOLOGICALLY": "POMOLOGICAL, relating to pomology [adv]\n",
  "POMOLOGIES": "POMOLOGY, the study of fruits [n]\n",
  "POMOLOGIST": "one versed in pomology; one who cultivates fruit trees [n -S]\n",
  "POMOLOGISTS": "POMOLOGIST, one versed in pomology; one who cultivates fruit trees [n]\n",
  "POMOLOGY": "the study of fruits [n POMOLOGIES]\n",
  "POMOS": "POMO, (colloquial) postmodernism [n]\n",
  "POMOSEXUAL": "someone who rejects sex altogether [n -S]\n",
  "POMOSEXUALS": "POMOSEXUAL, someone who rejects sex altogether [n]\n",
  "POMP": "stately or splendid display [n -S]\n",
  "POMPADOUR": "a hairstyle where the hair at the front is brushed up into a mound or a roll, above the forehead [n -S]\n",
  "POMPADOURED": "of hair, in the pompadour style [adj]\n",
  "POMPADOURS": "POMPADOUR, a hairstyle where the hair at the front is brushed up into a mound or a roll, above the forehead [n]\n",
  "POMPANO": "(Spanish) any one of several species of marine fish [n -S]\n",
  "POMPANOS": "POMPANO, (Spanish) any one of several species of marine fish [n]\n",
  "POMPELMOOSE": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n -S]\n",
  "POMPELMOOSES": "POMPELMOOSE, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n]\n",
  "POMPELMOUS": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUSE, POMPELO, PUMELO, PUMMELO [n -ES]\n",
  "POMPELMOUSE": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELO, PUMELO, PUMMELO [n -S]\n",
  "POMPELMOUSES": "POMPELMOUSE, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELO, PUMELO, PUMMELO [n]\n",
  "POMPELO": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, PUMELO, PUMMELO [n -S]\n",
  "POMPELOS": "POMPELO, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, PUMELO, PUMMELO [n]\n",
  "POMPEY": "(Dickens) to pamper [v -ED, -ING, -S]\n",
  "POMPEYED": "POMPEY, (Dickens) to pamper [v]\n",
  "POMPEYING": "POMPEY, (Dickens) to pamper [v]\n",
  "POMPEYS": "POMPEY, (Dickens) to pamper [v]\n",
  "POMPHOLYGOUS": "of or like a pompholyx, a vesicular eruption or eczema chiefly on the palms and soles [adj]\n",
  "POMPHOLYX": "(Greek) a vesicular eruption or eczema chiefly on the palms and soles [n -ES]\n",
  "POMPHOLYXES": "POMPHOLYX, (Greek) a vesicular eruption or eczema chiefly on the palms and soles [n]\n",
  "POMPIER": "(French) a conventional or imitative artist [n -S]\n",
  "POMPIERS": "POMPIER, (French) a conventional or imitative artist [n]\n",
  "POMPILID": "a spider-hunting wasp [n -S]\n",
  "POMPILIDS": "POMPILID, a spider-hunting wasp [n]\n",
  "POMPION": "(obsolete) a pumpkin, also PUMPION, PUNKIN [n -S]\n",
  "POMPIONS": "POMPION, (obsolete) a pumpkin, also PUMPION, PUNKIN [n]\n",
  "POMPOM": "(French) any trifling ornament for a woman's dress or bonnet, also POMPON, POMPOON [n -S]\n",
  "POMPOMS": "POMPOM, (French) any trifling ornament for a woman's dress or bonnet, also POMPON, POMPOON [n]\n",
  "POMPON": "(French) any trifling ornament for a woman's dress or bonnet, also POMPOM, POMPOON [n -S]\n",
  "POMPONS": "POMPON, (French) any trifling ornament for a woman's dress or bonnet, also POMPOM, POMPOON [n]\n",
  "POMPOON": "(obsolete) any trifling ornament for a woman's dress or bonnet, also POMPOM, POMPON [n -S]\n",
  "POMPOONS": "POMPOON, (obsolete) any trifling ornament for a woman's dress or bonnet, also POMPOM, POMPON [n]\n",
  "POMPOSITIES": "POMPOSITY, the state of being pompous [n]\n",
  "POMPOSITY": "the state of being pompous [n POMPOSITIES]\n",
  "POMPOSO": "(of a piece of music) to be played in a ceremonial or grand manner [adj]\n",
  "POMPOUS": "infused with exaggerated self-importance [adj POMPOUSLY]\n",
  "POMPOUSLY": "POMPOUS, infused with exaggerated self-importance [adv]\n",
  "POMPOUSNESS": "the state of being pompous [n -ES]\n",
  "POMPOUSNESSES": "POMPOUSNESS, the state of being pompous [n]\n",
  "POMPS": "POMP, stately or splendid display [n]\n",
  "POMROY": "an old variety of apple, also POMEROY [n -S]\n",
  "POMROYS": "POMROY, an old variety of apple, also POMEROY [n]\n",
  "POMS": "POM, (colloquial) a Pomeranian dog [n]\n",
  "POMWATER": "(Shakespeare) a sweet juicy apple [n -S]\n",
  "POMWATERS": "POMWATER, (Shakespeare) a sweet juicy apple [n]\n",
  "PONCE": "a man who lives on the immoral earnings of a prostitute [n -S] / to live on immoral earnings [v PONCED, PONCING, PONCES]\n",
  "PONCEAU": "(French) a poppy-coloured red dye [n PONCEAUX] / a small bridge [n PONCEAUS]\n",
  "PONCEAUS": "PONCEAU, (French) a poppy-coloured red dye [n]\n",
  "PONCEAUX": "PONCEAU, (French) a poppy-coloured red dye [n]\n",
  "PONCED": "PONCE, to live on immoral earnings [v]\n",
  "PONCES": "PONCE, to live on immoral earnings [v]\n",
  "PONCEY": "effeminate, also PONCY [adj PONCIER, PONCIEST]\n",
  "PONCHO": "(Spanish) a type of cloak [n -S]\n",
  "PONCHOED": "wearing a poncho [adj]\n",
  "PONCHOS": "PONCHO, (Spanish) a type of cloak [n]\n",
  "PONCIER": "PONCY, effeminate, also PONCEY [adj]\n",
  "PONCIEST": "PONCY, effeminate, also PONCEY [adj]\n",
  "PONCING": "PONCE, to live on immoral earnings [v]\n",
  "PONCY": "effeminate, also PONCEY [adj PONCIER, PONCIEST]\n",
  "POND": "to collect water in a small depression [v -ED, -ING, -S]\n",
  "PONDAGE": "the capacity of a pond [n -S]\n",
  "PONDAGES": "PONDAGE, the capacity of a pond [n]\n",
  "PONDED": "POND, to collect water in a small depression [v]\n",
  "PONDER": "to consider deeply [v -ED, -ING, -S]\n",
  "PONDERABILITIES": "PONDERABILITY, the quality of being ponderable [n]\n",
  "PONDERABILITY": "the quality of being ponderable [n PONDERABILITIES]\n",
  "PONDERABLE": "capable of being weighed [adj PONDERABLY] / something worth pondering [n -S]\n",
  "PONDERABLES": "PONDERABLE, something worth pondering [n]\n",
  "PONDERABLY": "PONDERABLE, capable of being weighed [adv]\n",
  "PONDERAL": "pertaining to weight [adj]\n",
  "PONDERANCE": "weight, gravity, also PONDERANCY [n -S]\n",
  "PONDERANCES": "PONDERANCE, weight, gravity, also PONDERANCY [n]\n",
  "PONDERANCIES": "PONDERANCY, weight, gravity, also PONDERANCE [n]\n",
  "PONDERANCY": "weight, gravity, also PONDERANCE [n PONDERANCIES]\n",
  "PONDERATE": "to consider; to ponder [v PONDERATED, PONDERATING, PONDERATES]\n",
  "PONDERATED": "PONDERATE, to consider; to ponder [v]\n",
  "PONDERATES": "PONDERATE, to consider; to ponder [v]\n",
  "PONDERATING": "PONDERATE, to consider; to ponder [v]\n",
  "PONDERATION": "weighing or weighing up [n -S]\n",
  "PONDERATIONS": "PONDERATION, weighing or weighing up [n]\n",
  "PONDERED": "PONDER, to consider deeply [v]\n",
  "PONDERER": "one who ponders [n -S]\n",
  "PONDERERS": "PONDERER, one who ponders [n]\n",
  "PONDERING": "PONDER, to consider deeply [v]\n",
  "PONDERINGLY": "PONDERING, PONDER, to consider deeply [adv]\n",
  "PONDERMENT": "the act of pondering [n -S]\n",
  "PONDERMENTS": "PONDERMENT, the act of pondering [n]\n",
  "PONDEROSA": "(Spanish) a kind of pine found in the US [n -S]\n",
  "PONDEROSAS": "PONDEROSA, (Spanish) a kind of pine found in the US [n]\n",
  "PONDEROSITIES": "PONDEROSITY, the state of being ponderous [n]\n",
  "PONDEROSITY": "the state of being ponderous [n PONDEROSITIES]\n",
  "PONDEROUS": "heavy and slow [adj PONDEROUSLY]\n",
  "PONDEROUSLY": "PONDEROUS, heavy and slow [adv]\n",
  "PONDEROUSNESS": "the state of being ponderous [n -ES]\n",
  "PONDEROUSNESSES": "PONDEROUSNESS, the state of being ponderous [n]\n",
  "PONDERS": "PONDER, to consider deeply [v]\n",
  "PONDING": "POND, to collect water in a small depression [v]\n",
  "PONDOK": "(Hottentot) in South Africa, a small hut, a shack, also PONDOKKIE [n -S]\n",
  "PONDOKKIE": "(Hottentot) in South Africa, a small hut, a shack, also PONDOK [n -S]\n",
  "PONDOKKIES": "PONDOKKIE, (Hottentot) in South Africa, a small hut, a shack, also PONDOK [n]\n",
  "PONDOKS": "PONDOK, (Hottentot) in South Africa, a small hut, a shack, also PONDOKKIE [n]\n",
  "PONDS": "POND, to collect water in a small depression [v]\n",
  "PONDWEED": "an aquatic plant [n -S]\n",
  "PONDWEEDS": "PONDWEED, an aquatic plant [n]\n",
  "PONE": "a kind of corn bread [n -S]\n",
  "PONENT": "(Milton) the west, where the sun goes down [n -S]\n",
  "PONENTS": "PONENT, (Milton) the west, where the sun goes down [n]\n",
  "PONEROLOGIES": "PONEROLOGY, the theological doctrine of wickedness or evil [n]\n",
  "PONEROLOGY": "the theological doctrine of wickedness or evil [n PONEROLOGIES]\n",
  "PONES": "PONE, a kind of corn bread [n]\n",
  "PONEY": "a small horse, also PONY, POWNEY, POWNIE, POWNY [n -S]\n",
  "PONEYS": "PONEY, a small horse, also PONY, POWNEY, POWNIE, POWNY [n]\n",
  "PONG": "to stink, also PONK [v -ED, -ING, -S]\n",
  "PONGA": "(Maori) a tall tree-fern of New Zealand, with soft thick leaves, also PUNGA [n -S]\n",
  "PONGAL": "a dish of cooked rice in Tamil-speaking India [n -S]\n",
  "PONGALS": "PONGAL, a dish of cooked rice in Tamil-speaking India [n]\n",
  "PONGAS": "PONGA, (Maori) a tall tree-fern of New Zealand, with soft thick leaves, also PUNGA [n]\n",
  "PONGED": "PONG, to stink, also PONK [v]\n",
  "PONGEE": "(Chinese) a thin, soft silk from China [n -S]\n",
  "PONGEES": "PONGEE, (Chinese) a thin, soft silk from China [n]\n",
  "PONGID": "any large ape esp. the chimpanzee and the orangutan [n -S]\n",
  "PONGIDS": "PONGID, any large ape esp. the chimpanzee and the orangutan [n]\n",
  "PONGIER": "PONGY, (colloquial) smelly [adj]\n",
  "PONGIEST": "PONGY, (colloquial) smelly [adj]\n",
  "PONGING": "PONG, to stink, also PONK [v]\n",
  "PONGO": "any large ape; esp. the chimpanzee and the orang-outang [n -ES or -S]\n",
  "PONGOES": "PONGO, any large ape; esp. the chimpanzee and the orang-outang [n]\n",
  "PONGOS": "PONGO, any large ape; esp. the chimpanzee and the orang-outang [n]\n",
  "PONGS": "PONG, to stink, also PONK [v]\n",
  "PONGY": "(colloquial) smelly [adj PONGIER, PONGIEST]\n",
  "PONIARD": "a small dagger, also POIGNADO, POINADO [n -S] / to stab with a small dagger [v -ED, -ING, -S]\n",
  "PONIARDED": "PONIARD, to stab with a small dagger [v]\n",
  "PONIARDING": "PONIARD, to stab with a small dagger [v]\n",
  "PONIARDS": "PONIARD, to stab with a small dagger [v]\n",
  "PONIED": "PONY, old slang for to pay or settle up [v]\n",
  "PONIES": "PONY, old slang for to pay or settle up [v]\n",
  "PONK": "to smell bad, also PONG [v -ED, -ING, -S]\n",
  "PONKED": "PONK, to smell bad, also PONG [v]\n",
  "PONKING": "PONK, to smell bad, also PONG [v]\n",
  "PONKS": "PONK, to smell bad, also PONG [v]\n",
  "PONS": "(Latin) a bridge of nerve fibres in the brain [n PONTES]\n",
  "PONT": "in South Africa, a small ferryboat guided across a narrow stretch of water by a rope or cable [n -S]\n",
  "PONTAGE": "a toll paid on bridges [n -S]\n",
  "PONTAGES": "PONTAGE, a toll paid on bridges [n]\n",
  "PONTAL": "relating to the pons of the brain, also PONTIC [adj]\n",
  "PONTES": "PONS, (Latin) a bridge of nerve fibres in the brain [n]\n",
  "PONTIANAC": "(Malay) a naturally occurring rubberlike substance, aka jelutong, also PONTIANAK [n -S]\n",
  "PONTIANACS": "PONTIANAC, (Malay) a naturally occurring rubberlike substance, aka jelutong, also PONTIANAK [n]\n",
  "PONTIANAK": "(Malay) a naturally occurring rubberlike substance, aka jelutong, also PONTIANAC [n -S]\n",
  "PONTIANAKS": "PONTIANAK, (Malay) a naturally occurring rubberlike substance, aka jelutong, also PONTIANAC [n]\n",
  "PONTIC": "relating to the pons of the brain, also PONTAL [adj]\n",
  "PONTICELLO": "(Italian) the bridge of a stringed instrument [n -S]\n",
  "PONTICELLOS": "PONTICELLO, (Italian) the bridge of a stringed instrument [n]\n",
  "PONTIE": "an iron rod used in holding and manipulating glassware during manufacture, also PONTIL, PONTILE, PONTY, PUNTEE, PUNTY [n -S]\n",
  "PONTIES": "PONTY, an iron rod used in holding and manipulating glassware during manufacture, also PONTIE, PONTIL, PONTILE, PUNTEE, PUNTY [n]\n",
  "PONTIFEX": "(Latin) a chief priest, also PONTIFF [n PONTIFICES]\n",
  "PONTIFF": "(Latin) a chief priest, also PONTIFEX [n -S]\n",
  "PONTIFFS": "PONTIFF, (Latin) a chief priest, also PONTIFEX [n]\n",
  "PONTIFIC": "relating to, or consisting of, pontiffs or priests [adj PONTIFICALLY]\n",
  "PONTIFICAL": "of or like a pontiff [adj] / an office-book for bishops [n -S]\n",
  "PONTIFICALITIES": "PONTIFICALITY, the state of being pontifical [n]\n",
  "PONTIFICALITY": "the state of being pontifical [n PONTIFICALITIES]\n",
  "PONTIFICALLY": "PONTIFICAL, of or like a pontiff [adv]\n",
  "PONTIFICALS": "PONTIFICAL, an office-book for bishops [n]\n",
  "PONTIFICATE": "to speak in a pompous and dogmatic manner [v PONTIFICATED, PONTIFICATING, PONTIFICATES]\n",
  "PONTIFICATED": "PONTIFICATE, to speak in a pompous and dogmatic manner [v]\n",
  "PONTIFICATES": "PONTIFICATE, to speak in a pompous and dogmatic manner [v]\n",
  "PONTIFICATING": "PONTIFICATE, to speak in a pompous and dogmatic manner [v]\n",
  "PONTIFICATION": "the act of pontificating, speaking in a pompous and dogmatic manner [n -S]\n",
  "PONTIFICATIONS": "PONTIFICATION, the act of pontificating, speaking in a pompous and dogmatic manner [n]\n",
  "PONTIFICATOR": "one who pontificates, speaks in a pompous and dogmatic manner [n -S]\n",
  "PONTIFICATORS": "PONTIFICATOR, one who pontificates, speaks in a pompous and dogmatic manner [n]\n",
  "PONTIFICE": "(Milton) bridgework; a bridge [n -S]\n",
  "PONTIFICES": "PONTIFEX, (Latin) a chief priest, also PONTIFF [n]\n",
  "PONTIFIED": "PONTIFY, to play the pontiff [v]\n",
  "PONTIFIES": "PONTIFY, to play the pontiff [v]\n",
  "PONTIFY": "to play the pontiff [v PONTIFIED, PONTIFYING, PONTIFIES]\n",
  "PONTIFYING": "PONTIFY, to play the pontiff [v]\n",
  "PONTIL": "an iron rod used in holding and manipulating glassware during manufacture, also PONTIE, PONTILE, PONTY, PUNTEE, PUNTY [n -S]\n",
  "PONTILE": "an iron rod used in holding and manipulating glassware during manufacture, also PONTIE, PONTIL, PONTY, PUNTEE, PUNTY [n -S]\n",
  "PONTILES": "PONTILE, an iron rod used in holding and manipulating glassware during manufacture, also PONTIE, PONTIL, PONTY, PUNTEE, PUNTY [n]\n",
  "PONTILS": "PONTIL, an iron rod used in holding and manipulating glassware during manufacture, also PONTIE, PONTILE, PONTY, PUNTEE, PUNTY [n]\n",
  "PONTINE": "pertaining to bridges [adj]\n",
  "PONTLEVIS": "(French) a drawbridge [n -ES]\n",
  "PONTLEVISES": "PONTLEVIS, (French) a drawbridge [n]\n",
  "PONTON": "a float, a bridge of boats, also PONTOON [n -S]\n",
  "PONTONEER": "a builder of pontoon bridges, also PONTONIER, PONTONNIER, PONTOONER [n -S]\n",
  "PONTONEERS": "PONTONEER, a builder of pontoon bridges, also PONTONIER, PONTONNIER, PONTOONER [n]\n",
  "PONTONIER": "a builder of pontoon bridges, also PONTONEER, PONTONNIER, PONTOONER [n -S]\n",
  "PONTONIERS": "PONTONIER, a builder of pontoon bridges, also PONTONEER, PONTONNIER, PONTOONER [n]\n",
  "PONTONNIER": "a builder of pontoon bridges, also PONTONEER, PONTONIER, PONTOONER [n -S]\n",
  "PONTONNIERS": "PONTONNIER, a builder of pontoon bridges, also PONTONEER, PONTONIER, PONTOONER [n]\n",
  "PONTONS": "PONTON, a float, a bridge of boats, also PONTOON [n]\n",
  "PONTOON": "a flat-bottomed boat or barge, also PONTON [n -S] / to cross with a pontoon [v -ED, -ING, -S]\n",
  "PONTOONED": "PONTOON, to cross with a pontoon [v]\n",
  "PONTOONER": "a builder of pontoon bridges, also PONTONEER, PONTONIER, PONTONNIER [n -S]\n",
  "PONTOONERS": "PONTOONER, a builder of pontoon bridges, also PONTONEER, PONTONIER, PONTONNIER [n]\n",
  "PONTOONING": "PONTOON, to cross with a pontoon [v]\n",
  "PONTOONS": "PONTOON, to cross with a pontoon [v]\n",
  "PONTS": "PONT, in South Africa, a small ferryboat guided across a narrow stretch of water by a rope or cable [n]\n",
  "PONTY": "an iron rod used in holding and manipulating glassware during manufacture, also PONTIE, PONTIL, PONTILE, PUNTEE, PUNTY [n PONTIES]\n",
  "PONY": "a small horse, also PONEY, POWNEY, POWNIE, POWNY [n PONIES] / old slang for to pay or settle up [v PONIED, PONYING, PONIES]\n",
  "PONYING": "PONY, old slang for to pay or settle up [v]\n",
  "PONYSKIN": "the skin of a foal used as a fur [n -S]\n",
  "PONYSKINS": "PONYSKIN, the skin of a foal used as a fur [n]\n",
  "PONYTAIL": "a hairstyle in which the hair is drawn back, tied, and made to hang down like a pony's tail [n -S]\n",
  "PONYTAILED": "having a ponytail [adj]\n",
  "PONYTAILS": "PONYTAIL, a hairstyle in which the hair is drawn back, tied, and made to hang down like a pony's tail [n]\n",
  "PONZU": "(Japanese) a type of sauce made from orange juice, sake, sugar, soy sauce and red pepper [n -S]\n",
  "PONZUS": "PONZU, (Japanese) a type of sauce made from orange juice, sake, sugar, soy sauce and red pepper [n]\n",
  "POO": "(vulgar slang) to defecate [v -ED, -ING, -S]\n",
  "POOBAH": "an influential person [n -S]\n",
  "POOBAHS": "POOBAH, an influential person [n]\n",
  "POOCH": "to bulge [v -ED, -ING, -ES]\n",
  "POOCHED": "POOCH, to bulge [v]\n",
  "POOCHES": "POOCH, to bulge [v]\n",
  "POOCHING": "POOCH, to bulge [v]\n",
  "POOD": "(Russian) a Russian unit of weight [n -S]\n",
  "POODLE": "a heavy-coated dog [n -S]\n",
  "POODLES": "POODLE, a heavy-coated dog [n]\n",
  "POODS": "POOD, (Russian) a Russian unit of weight [n]\n",
  "POOED": "POO, (vulgar slang) to defecate [v]\n",
  "POOF": "(offensive) an effeminate person, a homosexual, also POOFTAH, POOFTER, POOVE, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n -S]\n",
  "POOFIER": "POOFY, (offensive) effeminate, also POOVY, POUFFY [adj]\n",
  "POOFIEST": "POOFY, (offensive) effeminate, also POOVY, POUFFY [adj]\n",
  "POOFS": "POOF, (offensive) an effeminate person, a homosexual, also POOFTAH, POOFTER, POOVE, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n]\n",
  "POOFTAH": "(offensive Australian slang) an effeminate person, a homosexual, also POOF, POOFTER, POOVE, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n -S]\n",
  "POOFTAHS": "POOFTAH, (offensive Australian slang) an effeminate person, a homosexual, also POOF, POOFTER, POOVE, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n]\n",
  "POOFTER": "(offensive Australian slang) an effeminate person, a homosexual, also POOF, POOFTAH, POOVE, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n -S]\n",
  "POOFTERS": "POOFTER, (offensive Australian slang) an effeminate person, a homosexual, also POOF, POOFTAH, POOVE, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n]\n",
  "POOFY": "(offensive) effeminate, also POOVY, POUFFY [adj POOFIER, POOFIEST]\n",
  "POOGYE": "(Hindi) an Indian nose-flute [n -S]\n",
  "POOGYES": "POOGYE, (Hindi) an Indian nose-flute [n]\n",
  "POOH": "to express contempt for [v -ED, -ING, -S]\n",
  "POOHED": "POOH, to express contempt for [v]\n",
  "POOHING": "POOH, to express contempt for [v]\n",
  "POOHS": "POOH, to express contempt for [v]\n",
  "POOING": "POO, (vulgar slang) to defecate [v]\n",
  "POOJA": "(Sanskrit) a Hindu worship practice, also PUJA, POOJAH, PUJAH [n -S]\n",
  "POOJAH": "(Sanskrit) a Hindu worship practice, also PUJA, POOJA, PUJAH [n -S]\n",
  "POOJAHS": "POOJAH, (Sanskrit) a Hindu worship practice, also PUJA, POOJA, PUJAH [n]\n",
  "POOJAS": "POOJA, (Sanskrit) a Hindu worship practice, also PUJA, POOJAH, PUJAH [n]\n",
  "POOK": "(Scots) to pluck, pinch, also POUK [v POOKIT, POOKING, POOKS]\n",
  "POOKA": "(Irish) in Irish folklore, a malevolent goblin [n -S]\n",
  "POOKAS": "POOKA, (Irish) in Irish folklore, a malevolent goblin [n]\n",
  "POOKING": "POOK, (Scots) to pluck, pinch, also POUK [v]\n",
  "POOKIT": "POOK, (Scots) to pluck, pinch, also POUK [v]\n",
  "POOKS": "POOK, (Scots) to pluck, pinch, also POUK [v]\n",
  "POOL": "to contribute to a common fund [v -ED, -ING, -S]\n",
  "POOLED": "POOL, to contribute to a common fund [v]\n",
  "POOLER": "a person taking part in pool [n -S]\n",
  "POOLERS": "POOLER, a person taking part in pool [n]\n",
  "POOLHALL": "an establishment for the playing of billiards, also POOLROOM [n -S]\n",
  "POOLHALLS": "POOLHALL, an establishment for the playing of billiards, also POOLROOM [n]\n",
  "POOLING": "POOL, to contribute to a common fund [v]\n",
  "POOLROOM": "an establishment for the playing of billiards, also POOLHALL [n -S]\n",
  "POOLROOMS": "POOLROOM, an establishment for the playing of billiards, also POOLHALL [n]\n",
  "POOLS": "POOL, to contribute to a common fund [v]\n",
  "POOLSIDE": "the area at the side of a swimming pool [n -S]\n",
  "POOLSIDES": "POOLSIDE, the area at the side of a swimming pool [n]\n",
  "POON": "(Malay) an East Indian tree [n -S]\n",
  "POONAC": "(Tamil) a kind of oil cake prepared from the coconut, and fed to cattle [n -S]\n",
  "POONACS": "POONAC, (Tamil) a kind of oil cake prepared from the coconut, and fed to cattle [n]\n",
  "POONCE": "(offensive Australian slang) an effeminate man [n -S] / to behave effeminately [v POONCED, POONCING, POONCES]\n",
  "POONCED": "POONCE, to behave effeminately [v]\n",
  "POONCES": "POONCE, to behave effeminately [v]\n",
  "POONCING": "POONCE, to behave effeminately [v]\n",
  "POONS": "POON, (Malay) an East Indian tree [n]\n",
  "POONTANG": "sexual intercourse [n -S]\n",
  "POONTANGS": "POONTANG, sexual intercourse [n]\n",
  "POOP": "to tire out [v -ED, -ING, -S]\n",
  "POOPED": "POOP, to tire out [v]\n",
  "POOPER": "as in party pooper, someone who spoils the fun [n -S]\n",
  "POOPERS": "POOPER, as in party pooper, someone who spoils the fun [n]\n",
  "POOPIER": "POOPY, stupid or ineffectual [adj]\n",
  "POOPIEST": "POOPY, stupid or ineffectual [adj]\n",
  "POOPING": "POOP, to tire out [v]\n",
  "POOPS": "POOP, to tire out [v]\n",
  "POOPY": "stupid or ineffectual [adj POOPIER, POOPIEST]\n",
  "POOR": "lacking the means of support [adj POORER, POOREST, POORLY]\n",
  "POORBOX": "a box, esp. one in a church, used for the collection of alms or money for the poor [n -ES]\n",
  "POORBOXES": "POORBOX, a box, esp. one in a church, used for the collection of alms or money for the poor [n]\n",
  "POORER": "POOR, lacking the means of support [adj]\n",
  "POOREST": "POOR, lacking the means of support [adj]\n",
  "POORHOUSE": "(historical) a place of residence for people too poor to support themselves [n -S]\n",
  "POORHOUSES": "POORHOUSE, (historical) a place of residence for people too poor to support themselves [n]\n",
  "POORI": "(Hindi) in India, a small cake of unleavened bread fried in vegetable oil, also PURI [n -S]\n",
  "POORIS": "POORI, (Hindi) in India, a small cake of unleavened bread fried in vegetable oil, also PURI [n]\n",
  "POORISH": "somewhat poor [adj]\n",
  "POORLIER": "POORLY, unwell [adj]\n",
  "POORLIEST": "POORLY, unwell [adj]\n",
  "POORLY": "unwell [adj POORLIER, POORLIEST]\n",
  "POORMOUTH": "to complain about being poor [v -ED, -ING, -S]\n",
  "POORMOUTHED": "POORMOUTH, to complain about being poor [v]\n",
  "POORMOUTHING": "POORMOUTH, to complain about being poor [v]\n",
  "POORMOUTHS": "POORMOUTH, to complain about being poor [v]\n",
  "POORNESS": "the state of being poor [n -ES]\n",
  "POORNESSES": "POORNESS, the state of being poor [n]\n",
  "POORT": "(South African) a mountain pass [n -S]\n",
  "POORTITH": "(Scots) poverty, also PUIRTITH [n -S]\n",
  "POORTITHS": "POORTITH, (Scots) poverty, also PUIRTITH [n]\n",
  "POORTS": "POORT, (South African) a mountain pass [n]\n",
  "POORWILL": "an American nightjar, also WHIPPOORWILL [n -S]\n",
  "POORWILLS": "POORWILL, an American nightjar, also WHIPPOORWILL [n]\n",
  "POOS": "POO, (vulgar slang) to defecate [v]\n",
  "POOT": "(Scots) to shoot at young partridges or grouse [v -ED, -ING, -S]\n",
  "POOTED": "POOT, (Scots) to shoot at young partridges or grouse [v]\n",
  "POOTER": "to hurry away [v -ED, -ING, -S]\n",
  "POOTERED": "POOTER, to hurry away [v]\n",
  "POOTERING": "POOTER, to hurry away [v]\n",
  "POOTERS": "POOTER, to hurry away [v]\n",
  "POOTING": "POOT, (Scots) to shoot at young partridges or grouse [v]\n",
  "POOTLE": "to travel in no particular hurry [v POOTLED, POOTLING, POOTLES]\n",
  "POOTLED": "POOTLE, to travel in no particular hurry [v]\n",
  "POOTLES": "POOTLE, to travel in no particular hurry [v]\n",
  "POOTLING": "POOTLE, to travel in no particular hurry [v]\n",
  "POOTS": "POOT, (Scots) to shoot at young partridges or grouse [v]\n",
  "POOVE": "(offensive) an effeminate person, a homosexual, also POOF, POOFTAH, POOFTER, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n -S]\n",
  "POOVERIES": "POOVERY, (offensive) the state of being a poof [n]\n",
  "POOVERY": "(offensive) the state of being a poof [n POOVERIES]\n",
  "POOVES": "POOVE, (offensive) an effeminate person, a homosexual, also POOF, POOFTAH, POOFTER, POUF, POUFF, POUFFE, POUFTAH, POUFTER [n]\n",
  "POOVIER": "POOVY, (offensive) effeminate, also POOFY, POUFFY [adj]\n",
  "POOVIEST": "POOVY, (offensive) effeminate, also POOFY, POUFFY [adj]\n",
  "POOVY": "(offensive) effeminate, also POOFY, POUFFY [adj POOVIER, POOVIEST]\n",
  "POP": "to make a sharp, small, explosive sound [v POPPED, POPPING, POPS]\n",
  "POPADUM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPPADOM, POPPADUM, PUPPODUM [n -S]\n",
  "POPADUMS": "POPADUM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPPADOM, POPPADUM, PUPPODUM [n]\n",
  "POPCORN": "maize or Indian corn, the kernels of which swell up and burst open with a small explosive sound when heated [n -S]\n",
  "POPCORNS": "POPCORN, maize or Indian corn, the kernels of which swell up and burst open with a small explosive sound when heated [n]\n",
  "POPE": "a small freshwater fish, aka ruffe [n -S]\n",
  "POPEDOM": "the office of a pope [n -S]\n",
  "POPEDOMS": "POPEDOM, the office of a pope [n]\n",
  "POPEHOOD": "the condition of being pope [n -S]\n",
  "POPEHOODS": "POPEHOOD, the condition of being pope [n]\n",
  "POPELESS": "without a pope [adj]\n",
  "POPELIKE": "like a pope [adj]\n",
  "POPELING": "a petty or deputy pope [n -S]\n",
  "POPELINGS": "POPELING, a petty or deputy pope [n]\n",
  "POPERA": "operatic music presented to gain popular appeal [n -S]\n",
  "POPERAS": "POPERA, operatic music presented to gain popular appeal [n]\n",
  "POPERIES": "POPERY, a hostile term for Roman Catholicism [n]\n",
  "POPERIN": "(obsolete) a variety of pear, also POPPERING, POPRIN [n -S]\n",
  "POPERINS": "POPERIN, (obsolete) a variety of pear, also POPPERING, POPRIN [n]\n",
  "POPERY": "a hostile term for Roman Catholicism [n POPERIES]\n",
  "POPES": "POPE, a small freshwater fish, aka ruffe [n]\n",
  "POPESEYE": "denoting a cut of steak [adj]\n",
  "POPESHIP": "the condition of being pope [n -S]\n",
  "POPESHIPS": "POPESHIP, the condition of being pope [n]\n",
  "POPETTE": "a young female fan of pop music [n -S]\n",
  "POPETTES": "POPETTE, a young female fan of pop music [n]\n",
  "POPEYED": "having bulging eyes [adj]\n",
  "POPGUN": "a tube for shooting pellets by compressed air; a contemptible gun [n -S]\n",
  "POPGUNS": "POPGUN, a tube for shooting pellets by compressed air; a contemptible gun [n]\n",
  "POPINAC": "a thorny shrub or small tree of tropical or subtropical America, with clusters of fragrant yellow flowers, aka huisache, also POPINACK [n -S]\n",
  "POPINACK": "a thorny shrub or small tree of tropical or subtropical America, with clusters of fragrant yellow flowers, aka huisache, also POPINAC [n -S]\n",
  "POPINACKS": "POPINACK, a thorny shrub or small tree of tropical or subtropical America, with clusters of fragrant yellow flowers, aka huisache, also POPINAC [n]\n",
  "POPINACS": "POPINAC, a thorny shrub or small tree of tropical or subtropical America, with clusters of fragrant yellow flowers, aka huisache, also POPINACK [n]\n",
  "POPINJAY": "a figure of a bird suspended from a pole and used as a target by archers and crossbowmen; a strutting supercilious conceited person [n -S]\n",
  "POPINJAYS": "POPINJAY, a figure of a bird suspended from a pole and used as a target by archers and crossbowmen; a strutting supercilious conceited person [n]\n",
  "POPISH": "pertaining to the Roman Catholic Church [adj POPISHLY]\n",
  "POPISHLY": "POPISH, pertaining to the Roman Catholic Church [adv]\n",
  "POPJOY": "to amuse oneself [v -ED, -ING, -S]\n",
  "POPJOYED": "POPJOY, to amuse oneself [v]\n",
  "POPJOYING": "POPJOY, to amuse oneself [v]\n",
  "POPJOYS": "POPJOY, to amuse oneself [v]\n",
  "POPLAR": "a genus of rapidly growing trees of the willow family [n -S]\n",
  "POPLARS": "POPLAR, a genus of rapidly growing trees of the willow family [n]\n",
  "POPLIN": "a corded fabric with a silk warp and worsted weft [n -S]\n",
  "POPLINETTE": "an imitation poplin [n -S]\n",
  "POPLINETTES": "POPLINETTE, an imitation poplin [n]\n",
  "POPLINS": "POPLIN, a corded fabric with a silk warp and worsted weft [n]\n",
  "POPLITEAL": "of or relating to the back of the knee, also POPLITIC [adj]\n",
  "POPLITEI": "POPLITEUS, a muscle at the back of the knee [n]\n",
  "POPLITEUS": "a muscle at the back of the knee [n POPLITEI]\n",
  "POPLITIC": "pertaining to the part of the leg behind the knee [adj]\n",
  "POPMOBILITIES": "POPMOBILITY, a form of exercise that combines aerobics in a continuous dance routine, performed to pop music [n]\n",
  "POPMOBILITY": "a form of exercise that combines aerobics in a continuous dance routine, performed to pop music [n POPMOBILITIES]\n",
  "POPOUT": "a type of out in baseball [n -S]\n",
  "POPOUTS": "POPOUT, a type of out in baseball [n]\n",
  "POPOVER": "a very light egg muffin [n -S]\n",
  "POPOVERS": "POPOVER, a very light egg muffin [n]\n",
  "POPPA": "(colloquial) papa [n -S]\n",
  "POPPADOM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADUM, PUPPODUM [n -S]\n",
  "POPPADOMS": "POPPADOM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADUM, PUPPODUM [n]\n",
  "POPPADUM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, PUPPODUM [n -S]\n",
  "POPPADUMS": "POPPADUM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, PUPPODUM [n]\n",
  "POPPAS": "POPPA, (colloquial) papa [n]\n",
  "POPPED": "POP, to make a sharp, small, explosive sound [v]\n",
  "POPPER": "one that pops [n -S]\n",
  "POPPERING": "a variety of pear, also POPERIN, POPRIN [n -S]\n",
  "POPPERINGS": "POPPERING, a variety of pear, also POPERIN, POPRIN [n]\n",
  "POPPERS": "POPPER, one that pops [n]\n",
  "POPPET": "a darling; a small or dainty person [n -S]\n",
  "POPPETS": "POPPET, a darling; a small or dainty person [n]\n",
  "POPPIED": "covered with poppies [adj]\n",
  "POPPIER": "POPPY, like pop music [adj]\n",
  "POPPIES": "POPPY, a brightly coloured flower [n]\n",
  "POPPIEST": "POPPY, like pop music [adj]\n",
  "POPPING": "POP, to make a sharp, small, explosive sound [v]\n",
  "POPPISH": "like pop music [adj]\n",
  "POPPIT": "one of a number of linked beads [n -S]\n",
  "POPPITS": "POPPIT, one of a number of linked beads [n]\n",
  "POPPLE": "to move in a bubbling or rippling manner [v POPPLED, POPPLING, POPPLES]\n",
  "POPPLED": "POPPLE, to move in a bubbling or rippling manner [v]\n",
  "POPPLES": "POPPLE, to move in a bubbling or rippling manner [v]\n",
  "POPPLIER": "POPPLY, like a rippling sound [adj]\n",
  "POPPLIEST": "POPPLY, like a rippling sound [adj]\n",
  "POPPLING": "POPPLE, to move in a bubbling or rippling manner [v]\n",
  "POPPLY": "like a rippling sound [adj POPPLIER, POPPLIEST]\n",
  "POPPY": "a brightly coloured flower [n POPPIES] / like pop music [adj POPPIER, POPPIEST]\n",
  "POPPYCOCK": "(Dutch) nonsense [n -S]\n",
  "POPPYCOCKS": "POPPYCOCK, (Dutch) nonsense [n]\n",
  "POPPYHEAD": "a raised ornament on top of the upright end of seats in churches [n -S]\n",
  "POPPYHEADS": "POPPYHEAD, a raised ornament on top of the upright end of seats in churches [n]\n",
  "POPPYSEED": "containing or made from the seed of the poppy [adj]\n",
  "POPRIN": "(Shakespeare) designating a variety of pear, also POPERIN, POPPERING [adj]\n",
  "POPS": "POP, to make a sharp, small, explosive sound [v]\n",
  "POPSICLE": "flavored and colored water frozen on a stick [n -S]\n",
  "POPSICLES": "POPSICLE, flavored and colored water frozen on a stick [n]\n",
  "POPSIE": "a term of endearment, also POPSY [n -S]\n",
  "POPSIES": "POPSIE, a term of endearment, also POPSY [n]\n",
  "POPSOCK": "a woman's nylon stocking reaching up to the knee [n -S]\n",
  "POPSOCKS": "POPSOCK, a woman's nylon stocking reaching up to the knee [n]\n",
  "POPSTER": "a pop musician [n -S]\n",
  "POPSTERS": "POPSTER, a pop musician [n]\n",
  "POPSTREL": "a young, attractive female pop star [n -S]\n",
  "POPSTRELS": "POPSTREL, a young, attractive female pop star [n]\n",
  "POPSY": "a girlfriend, also POPSIE [n POPSIES]\n",
  "POPTASTIC": "denoting or relating to a very good piece of pop music [adj]\n",
  "POPULACE": "the common people [n -S]\n",
  "POPULACES": "POPULACE, the common people [n]\n",
  "POPULAR": "well-liked [adj POPULARLY] / something popular [n -S]\n",
  "POPULARISATION": "the act of popularising, also POPULARIZATION [n -S]\n",
  "POPULARISATIONS": "POPULARISATION, the act of popularising, also POPULARIZATION [n]\n",
  "POPULARISE": "to cater to popular taste, also POPULARIZE [v POPULARISED, POPULARISING, POPULARISES]\n",
  "POPULARISED": "POPULARISE, to cater to popular taste, also POPULARIZE [v]\n",
  "POPULARISER": "one who popularises, also POPULARIZER [n -S]\n",
  "POPULARISERS": "POPULARISER, one who popularises, also POPULARIZER [n]\n",
  "POPULARISES": "POPULARISE, to cater to popular taste, also POPULARIZE [v]\n",
  "POPULARISING": "POPULARISE, to cater to popular taste, also POPULARIZE [v]\n",
  "POPULARIST": "designed for the general public; nonspecialist; nonintellectual [adj]\n",
  "POPULARITIES": "POPULARITY, the state of being popular [n]\n",
  "POPULARITY": "the state of being popular [n POPULARITIES]\n",
  "POPULARIZATION": "the act of popularizing, also POPULARISATION [n -S]\n",
  "POPULARIZATIONS": "POPULARIZATION, the act of popularizing, also POPULARISATION [n]\n",
  "POPULARIZE": "to cater to popular taste, also POPULARISE [v POPULARIZED, POPULARIZING, POPULARIZES]\n",
  "POPULARIZED": "POPULARIZE, to cater to popular taste, also POPULARISE [v]\n",
  "POPULARIZER": "one who popularizes, also POPULARISER [n -S]\n",
  "POPULARIZERS": "POPULARIZER, one who popularizes, also POPULARISER [n]\n",
  "POPULARIZES": "POPULARIZE, to cater to popular taste, also POPULARISE [v]\n",
  "POPULARIZING": "POPULARIZE, to cater to popular taste, also POPULARISE [v]\n",
  "POPULARLY": "POPULAR, well-liked [adv]\n",
  "POPULARS": "POPULAR, something popular [n]\n",
  "POPULATE": "to inhabit [v POPULATED, POPULATING, POPULATES]\n",
  "POPULATED": "POPULATE, to inhabit [v]\n",
  "POPULATES": "POPULATE, to inhabit [v]\n",
  "POPULATING": "POPULATE, to inhabit [v]\n",
  "POPULATION": "the whole number of people or inhabitants in a country or region [n -S]\n",
  "POPULATIONAL": "relating to population [adj]\n",
  "POPULATIONS": "POPULATION, the whole number of people or inhabitants in a country or region [n]\n",
  "POPULISM": "the political principles and practices of populists [n -S]\n",
  "POPULISMS": "POPULISM, the political principles and practices of populists [n]\n",
  "POPULIST": "someone who believes in the right and ability of the common people to play a major part in governing themselves [n -S]\n",
  "POPULISTIC": "relating to populism [adj]\n",
  "POPULISTS": "POPULIST, someone who believes in the right and ability of the common people to play a major part in governing themselves [n]\n",
  "POPULOUS": "containing many inhabitants [adj POPULOUSLY]\n",
  "POPULOUSLY": "POPULOUS, containing many inhabitants [adv]\n",
  "POPULOUSNESS": "the state of being populous [n -ES]\n",
  "POPULOUSNESSES": "POPULOUSNESS, the state of being populous [n]\n",
  "PORAE": "(Maori) a large edible sea-fish of New Zealand waters [n -S]\n",
  "PORAES": "PORAE, (Maori) a large edible sea-fish of New Zealand waters [n]\n",
  "PORAL": "pertaining to pores [adj]\n",
  "PORANGI": "(Maori) crazy [adj]\n",
  "PORBEAGLE": "a species of shark, having a pointed nose and a crescent-shaped tail [n -S]\n",
  "PORBEAGLES": "PORBEAGLE, a species of shark, having a pointed nose and a crescent-shaped tail [n]\n",
  "PORCELAIN": "a fine earthenware, white, thin, transparent or semitransparent, first made in China [n -S]\n",
  "PORCELAINEOUS": "like porcelain, also PORCELAINOUS, PORCELANEOUS, PORCELLANEOUS, PORCELLANOUS [adj]\n",
  "PORCELAINISE": "to bake into porcelain, also PORCELAINIZE, PORCELLANISE, PORCELLANIZE [v PORCELAINISED, PORCELAINISING, PORCELAINISES]\n",
  "PORCELAINISED": "PORCELAINISE, to bake into porcelain, also PORCELAINIZE, PORCELLANISE, PORCELLANIZE [v]\n",
  "PORCELAINISES": "PORCELAINISE, to bake into porcelain, also PORCELAINIZE, PORCELLANISE, PORCELLANIZE [v]\n",
  "PORCELAINISING": "PORCELAINISE, to bake into porcelain, also PORCELAINIZE, PORCELLANISE, PORCELLANIZE [v]\n",
  "PORCELAINIZE": "to bake into porcelain, also PORCELAINISE, PORCELLANISE, PORCELLANIZE [v PORCELAINIZED, PORCELAINIZING, PORCELAINIZES]\n",
  "PORCELAINIZED": "PORCELAINIZE, to bake into porcelain, also PORCELAINISE, PORCELLANISE, PORCELLANIZE [v]\n",
  "PORCELAINIZES": "PORCELAINIZE, to bake into porcelain, also PORCELAINISE, PORCELLANISE, PORCELLANIZE [v]\n",
  "PORCELAINIZING": "PORCELAINIZE, to bake into porcelain, also PORCELAINISE, PORCELLANISE, PORCELLANIZE [v]\n",
  "PORCELAINLIKE": "like porcelain [adj]\n",
  "PORCELAINOUS": "like porcelain, also PORCELAINEOUS, PORCELANEOUS, PORCELLANEOUS, PORCELLANOUS [adj]\n",
  "PORCELAINS": "PORCELAIN, a fine earthenware, white, thin, transparent or semitransparent, first made in China [n]\n",
  "PORCELANEOUS": "like porcelain, also PORCELAINEOUS, PORCELAINOUS, PORCELLANEOUS, PORCELLANOUS [adj]\n",
  "PORCELLANEOUS": "like porcelain, also PORCELAINEOUS, PORCELAINOUS, PORCELANEOUS, PORCELLANOUS [adj]\n",
  "PORCELLANISE": "to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANIZE [v PORCELLANISED, PORCELLANISING, PORCELLANISES]\n",
  "PORCELLANISED": "PORCELLANISE, to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANIZE [v]\n",
  "PORCELLANISES": "PORCELLANISE, to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANIZE [v]\n",
  "PORCELLANISING": "PORCELLANISE, to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANIZE [v]\n",
  "PORCELLANITE": "a jasper-like shale highly indurated by contact metamorphism [n -S]\n",
  "PORCELLANITES": "PORCELLANITE, a jasper-like shale highly indurated by contact metamorphism [n]\n",
  "PORCELLANIZE": "to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANISE [v PORCELLANIZED, PORCELLANIZING, PORCELLANIZES]\n",
  "PORCELLANIZED": "PORCELLANIZE, to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANISE [v]\n",
  "PORCELLANIZES": "PORCELLANIZE, to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANISE [v]\n",
  "PORCELLANIZING": "PORCELLANIZE, to bake into porcelain, also PORCELAINISE, PORCELAINIZE, PORCELLANISE [v]\n",
  "PORCELLANOUS": "like porcelain, also PORCELAINEOUS, PORCELAINOUS, PORCELANEOUS, PORCELLANEOUS [adj]\n",
  "PORCH": "a low structure projecting from the doorway of a house and forming a covered entrance [n -ES]\n",
  "PORCHED": "having a porch [adj]\n",
  "PORCHES": "PORCH, a low structure projecting from the doorway of a house and forming a covered entrance [n]\n",
  "PORCHETTA": "(Italian) seasoned boneless roast pork cut from a whole roast pig [n -S]\n",
  "PORCHETTAS": "PORCHETTA, (Italian) seasoned boneless roast pork cut from a whole roast pig [n]\n",
  "PORCHLESS": "lacking a porch [adj]\n",
  "PORCINE": "of or pertaining to pigs [adj]\n",
  "PORCINI": "an edible mushroom [n -S]\n",
  "PORCINIS": "PORCINI, an edible mushroom [n]\n",
  "PORCINO": "(Italian) an edible mushroom [n PORCINI]\n",
  "PORCUPINE": "a large spiny rodent of various kinds, also PORPENTINE [n -S]\n",
  "PORCUPINES": "PORCUPINE, a large spiny rodent of various kinds, also PORPENTINE [n]\n",
  "PORCUPINIER": "PORCUPINY, like a porcupine, a large spiny rodent of various kinds [adj]\n",
  "PORCUPINIEST": "PORCUPINY, like a porcupine, a large spiny rodent of various kinds [adj]\n",
  "PORCUPINISH": "like a porcupine [adj]\n",
  "PORCUPINY": "like a porcupine, a large spiny rodent of various kinds [adj PORCUPINIER, PORCUPINIEST]\n",
  "PORE": "to examine closely [v PORED, PORING, PORES]\n",
  "PORED": "PORE, to examine closely [v]\n",
  "PORER": "one who pores [n -S]\n",
  "PORERS": "PORER, one who pores [n]\n",
  "PORES": "PORE, to examine closely [v]\n",
  "PORGE": "in Jewish ritual, to cleanse a slaughtered animal by removing the forbidden parts [v PORGED, PORGING, PORGES]\n",
  "PORGED": "PORGE, in Jewish ritual, to cleanse a slaughtered animal by removing the forbidden parts [v]\n",
  "PORGES": "PORGE, in Jewish ritual, to cleanse a slaughtered animal by removing the forbidden parts [v]\n",
  "PORGIE": "a species of saltwater fish, a sea-bream, also PORGY [n -S]\n",
  "PORGIES": "PORGY, a species of saltwater fish, aka sea-bream, also PORGIE [n]\n",
  "PORGING": "PORGE, in Jewish ritual, to cleanse a slaughtered animal by removing the forbidden parts [v]\n",
  "PORGY": "a species of saltwater fish, aka sea-bream, also PORGIE [n PORGIES]\n",
  "PORIER": "PORY, having pores [adj]\n",
  "PORIEST": "PORY, having pores [adj]\n",
  "PORIFER": "(Latin) a member of the Porifera, the sponges [n -S]\n",
  "PORIFERAL": "relating to the Porifera, sponges, also PORIFERAN [adj]\n",
  "PORIFERAN": "relating to the Porifera, sponges, also PORIFERAL [adj] / a member of the sponge family [n -S]\n",
  "PORIFERANS": "PORIFERAN, a member of the sponge family [n]\n",
  "PORIFEROUS": "having pores [adj]\n",
  "PORIFERS": "PORIFER, (Latin) a member of the Porifera, the sponges [n]\n",
  "PORIN": "any of a class of proteins through which molecules can diffuse [n -S]\n",
  "PORINA": "(New Zealand) the larva of a moth that damages grassland [n -S]\n",
  "PORINAS": "PORINA, (New Zealand) the larva of a moth that damages grassland [n]\n",
  "PORINESS": "a state of having pores [n -ES]\n",
  "PORINESSES": "PORINESS, a state of having pores [n]\n",
  "PORING": "PORE, to examine closely [v]\n",
  "PORINS": "PORIN, any of a class of proteins through which molecules can diffuse [n]\n",
  "PORISM": "(Greek) the geometric proposition that it is possible, in certain conditions, for a problem to have any number of solutions [n -S]\n",
  "PORISMATIC": "relating to a porism, the geometric proposition that it is possible, in certain conditions, for a problem to have any number of solutions, also PORISMATICAL, PORISTIC, PORISTICAL [adj]\n",
  "PORISMATICAL": "relating to a porism, the geometric proposition that it is possible, in certain conditions, for a problem to have any number of solutions, also PORISMATIC, PORISTIC, PORISTICAL [adj]\n",
  "PORISMS": "PORISM, (Greek) the geometric proposition that it is possible, in certain conditions, for a problem to have any number of solutions [n]\n",
  "PORISTIC": "relating to a porism, the geometric proposition that it is possible, in certain conditions, for a problem to have any number of solutions, also PORISMATIC, PORISMATICAL, PORISTICAL [adj]\n",
  "PORISTICAL": "relating to a porism, the geometric proposition that it is possible, in certain conditions, for a problem to have any number of solutions, also PORISMATIC, PORISMATICAL, PORISTIC [adj]\n",
  "PORK": "the flesh of swine used as food [n -S] / to eat ravenously [v -ED, -ING, -S]\n",
  "PORKED": "PORK, to eat ravenously [v]\n",
  "PORKER": "a pig, esp. a young hog, fattened for pork [n -S]\n",
  "PORKERS": "PORKER, a pig, esp. a young hog, fattened for pork [n]\n",
  "PORKIER": "PORKY, plump like a pig [adj]\n",
  "PORKIES": "PORKY, a lie [n]\n",
  "PORKIEST": "PORKY, plump like a pig [adj]\n",
  "PORKINESS": "the state of being porky [n -ES]\n",
  "PORKINESSES": "PORKINESS, the state of being porky [n]\n",
  "PORKING": "PORK, to eat ravenously [v]\n",
  "PORKLING": "a young pig [n -S]\n",
  "PORKLINGS": "PORKLING, a young pig [n]\n",
  "PORKPIE": "a type of man's hat [n -S]\n",
  "PORKPIES": "PORKPIE, a type of man's hat [n]\n",
  "PORKS": "PORK, to eat ravenously [v]\n",
  "PORKWOOD": "the coarse-grained brownish yellow wood of a small tree of Florida and the West Indies [n -S]\n",
  "PORKWOODS": "PORKWOOD, the coarse-grained brownish yellow wood of a small tree of Florida and the West Indies [n]\n",
  "PORKY": "plump like a pig [adj PORKIER, PORKIEST] / a lie [n PORKIES]\n",
  "PORLOCK": "to hinder by an irksome intrusion or interruption [v -ED, -ING, -S]\n",
  "PORLOCKED": "PORLOCK, to hinder by an irksome intrusion or interruption [v]\n",
  "PORLOCKING": "PORLOCK, to hinder by an irksome intrusion or interruption [v]\n",
  "PORLOCKS": "PORLOCK, to hinder by an irksome intrusion or interruption [v]\n",
  "PORN": "pornography, also PORNO [n -S]\n",
  "PORNIER": "PORNY, (colloquial) pornographic [adj]\n",
  "PORNIEST": "PORNY, (colloquial) pornographic [adj]\n",
  "PORNIFICATION": "the introduction of pornographic elements into a film etc. [n -S]\n",
  "PORNIFICATIONS": "PORNIFICATION, the introduction of pornographic elements into a film etc. [n]\n",
  "PORNO": "pornography, also PORN [n -S]\n",
  "PORNOCRACIES": "PORNOCRACY, government by harlots [n]\n",
  "PORNOCRACY": "government by harlots [n PORNOCRACIES]\n",
  "PORNOGRAPHER": "one who produces pornography [n -S]\n",
  "PORNOGRAPHERS": "PORNOGRAPHER, one who produces pornography [n]\n",
  "PORNOGRAPHIC": "relating to pornography [adj]\n",
  "PORNOGRAPHIES": "PORNOGRAPHY, the depiction of erotic behavior (as in pictures or writing) intended to cause sexual excitement [n]\n",
  "PORNOGRAPHY": "the depiction of erotic behavior (as in pictures or writing) intended to cause sexual excitement [n PORNOGRAPHIES]\n",
  "PORNOMAG": "a pornographic magazine [n -S]\n",
  "PORNOMAGS": "PORNOMAG, a pornographic magazine [n]\n",
  "PORNOS": "PORNO, pornography, also PORN [n]\n",
  "PORNOTOPIA": "a perfect setting for the antics of pornography [n -S]\n",
  "PORNOTOPIAN": "relating to a pornotopia, a perfect setting for the antics of pornography [adj]\n",
  "PORNOTOPIAS": "PORNOTOPIA, a perfect setting for the antics of pornography [n]\n",
  "PORNS": "PORN, pornography, also PORNO [n]\n",
  "PORNY": "(colloquial) pornographic [adj PORNIER, PORNIEST]\n",
  "POROGAMIC": "relating to porogamy, the fertilization of seed plants by the entry of a pollen-tube through the micropyle [adj]\n",
  "POROGAMIES": "POROGAMY, the entry of the pollen-tube through the micropyle [n]\n",
  "POROGAMY": "the entry of the pollen-tube through the micropyle [n POROGAMIES]\n",
  "POROMERIC": "permeable to water vapour [adj] / a poromeric substance [n -S]\n",
  "POROMERICS": "POROMERIC, a poromeric substance [n]\n",
  "POROSCOPE": "an instrument for investigating porosity [n -S]\n",
  "POROSCOPES": "POROSCOPE, an instrument for investigating porosity [n]\n",
  "POROSCOPIC": "relating to a poroscope, an instrument for investigating porosity [adj]\n",
  "POROSCOPIES": "POROSCOPY, the use of a poroscope, an instrument for investigating porosity [n]\n",
  "POROSCOPY": "the use of a poroscope, an instrument for investigating porosity [n POROSCOPIES]\n",
  "POROSE": "having minute openings, also POROUS [adj]\n",
  "POROSES": "POROSIS, (Greek) formation of callus [n]\n",
  "POROSIS": "(Greek) formation of callus [n POROSES]\n",
  "POROSITIES": "POROSITY, the state of being porous [n]\n",
  "POROSITY": "the state of being porous [n POROSITIES]\n",
  "POROUS": "having minute openings, also POROSE [adj POROUSLY]\n",
  "POROUSLY": "POROUS, having minute openings, also POROSE [adv]\n",
  "POROUSNESS": "the quality of being porous [n -ES]\n",
  "POROUSNESSES": "POROUSNESS, the quality of being porous [n]\n",
  "PORPENTINE": "(Shakespeare) a porcupine, also PORCUPINE [n -S]\n",
  "PORPENTINES": "PORPENTINE, (Shakespeare) a porcupine, also PORCUPINE [n]\n",
  "PORPESS": "a porpoise, also PORPESSE [n -ES]\n",
  "PORPESSE": "a porpoise, also PORPESS [n -S]\n",
  "PORPESSES": "PORPESS, a porpoise, also PORPESSE [n]\n",
  "PORPHYRIA": "any of various disorders of metabolism resulting in the excretion of an excessive quantity of porphyrins in the urine [n -S]\n",
  "PORPHYRIAS": "PORPHYRIA, any of various disorders of metabolism resulting in the excretion of an excessive quantity of porphyrins in the urine [n]\n",
  "PORPHYRIC": "relating to porphyria [adj]\n",
  "PORPHYRIES": "PORPHYRY, (Greek) a very hard, variegated rock of a purple and white colour, used in sculpture [n]\n",
  "PORPHYRIN": "any of a large group of red or purple crystalline pigments present in plant and animal tissues [n -S]\n",
  "PORPHYRINS": "PORPHYRIN, any of a large group of red or purple crystalline pigments present in plant and animal tissues [n]\n",
  "PORPHYRIO": "any bird of the purple-coot genus Porphyrio [n -S]\n",
  "PORPHYRIOS": "PORPHYRIO, any bird of the purple-coot genus Porphyrio [n]\n",
  "PORPHYRITE": "a rock with a porphyritic structure; as, augite porphyrite [n -S]\n",
  "PORPHYRITES": "PORPHYRITE, a rock with a porphyritic structure; as, augite porphyrite [n]\n",
  "PORPHYRITIC": "designating an igneous rock in which large crystals (phenocrysts) are set in a matrix of relatively finer-grained crystals or of glass [adj]\n",
  "PORPHYROGENITE": "a Byzantine emperor's son, born in the purple [n -S]\n",
  "PORPHYROGENITES": "PORPHYROGENITE, a Byzantine emperor's son, born in the purple [n]\n",
  "PORPHYROID": "a metamorphic rock having a texture characterized by large crystals set in a finer groundmass [n -S]\n",
  "PORPHYROIDS": "PORPHYROID, a metamorphic rock having a texture characterized by large crystals set in a finer groundmass [n]\n",
  "PORPHYROPSIN": "a purple pigment in the retinal rods of freshwater fishes that resembles rhodopsin [n -S]\n",
  "PORPHYROPSINS": "PORPHYROPSIN, a purple pigment in the retinal rods of freshwater fishes that resembles rhodopsin [n]\n",
  "PORPHYROUS": "purple [adj]\n",
  "PORPHYRY": "(Greek) a very hard, variegated rock of a purple and white colour, used in sculpture [n PORPHYRIES]\n",
  "PORPOISE": "a short-snouted genus of the dolphin family, also PORPESS, PORPESSE [n -S] / to move like a porpoise; specifically (of an aircraft, esp. a seaplane) to touch the water or ground and rise again [v PORPOISED, PORPOISING, PORPOISES]\n",
  "PORPOISED": "PORPOISE, to move like a porpoise; specifically (of an aircraft, esp. a seaplane) to touch the water or ground and rise again [v]\n",
  "PORPOISES": "PORPOISE, to move like a porpoise; specifically (of an aircraft, esp. a seaplane) to touch the water or ground and rise again [v]\n",
  "PORPOISING": "PORPOISE, to move like a porpoise; specifically (of an aircraft, esp. a seaplane) to touch the water or ground and rise again [v]\n",
  "PORPORATE": "(Browning) clad in purple [adj]\n",
  "PORRACEOUS": "leek-green [adj]\n",
  "PORRECT": "to stretch forth [v -ED, -ING, -S]\n",
  "PORRECTED": "PORRECT, to stretch forth [v]\n",
  "PORRECTING": "PORRECT, to stretch forth [v]\n",
  "PORRECTION": "the act of stretching forth [n -S]\n",
  "PORRECTIONS": "PORRECTION, the act of stretching forth [n]\n",
  "PORRECTS": "PORRECT, to stretch forth [v]\n",
  "PORRENGER": "a small dish for soup or porridge, also PORRINGER, POTTINGER [n -S]\n",
  "PORRENGERS": "PORRENGER, a small dish for soup or porridge, also PORRINGER, POTTINGER [n]\n",
  "PORRIDGE": "a soft meal of oatmeal, also PARRIDGE, PARRITCH [n -S]\n",
  "PORRIDGES": "PORRIDGE, a soft meal of oatmeal, also PARRIDGE, PARRITCH [n]\n",
  "PORRIDGIER": "PORRIDGY, resembling porridge [adj]\n",
  "PORRIDGIEST": "PORRIDGY, resembling porridge [adj]\n",
  "PORRIDGY": "resembling porridge [adj PORRIDGIER, PORRIDGIEST]\n",
  "PORRIGINOUS": "suffering from porrigo, a scalp disease that causes baldness [adj]\n",
  "PORRIGO": "(Latin) a kind of scalp disease [n -S]\n",
  "PORRIGOS": "PORRIGO, (Latin) a kind of scalp disease [n]\n",
  "PORRINGER": "a small dish for soup or porridge, also PORRENGER, POTTINGER [n -S]\n",
  "PORRINGERS": "PORRINGER, a small dish for soup or porridge, also PORRENGER, POTTINGER [n]\n",
  "PORT": "to carry, convey [v -ED, -ING, -S]\n",
  "PORTA": "(Latin) a gatelike anatomical structure, esp. the transverse fissure of the liver [n -S]\n",
  "PORTABELLA": "a variety of button mushroom, also PORTABELLO, PORTOBELLO [n -S]\n",
  "PORTABELLAS": "PORTABELLA, a variety of button mushroom, also PORTABELLO, PORTOBELLO [n]\n",
  "PORTABELLO": "a variety of button mushroom, also PORTABELLA, PORTOBELLO [n -S]\n",
  "PORTABELLOS": "PORTABELLO, a variety of button mushroom, also PORTABELLA, PORTOBELLO [n]\n",
  "PORTABILITIES": "PORTABILITY, the state of being portable [n]\n",
  "PORTABILITY": "the state of being portable [n PORTABILITIES]\n",
  "PORTABLE": "able to be carried [adj PORTABLY] / something e.g. a computer which is portable [n -S]\n",
  "PORTABLES": "PORTABLE, something e.g. a computer which is portable [n]\n",
  "PORTABLY": "so as to be capable of being carried [adv]\n",
  "PORTAGE": "to transport from one navigable waterway to another [v PORTAGED, PORTAGING, PORTAGES]\n",
  "PORTAGED": "PORTAGE, to transport from one navigable waterway to another [v]\n",
  "PORTAGES": "PORTAGE, to transport from one navigable waterway to another [v]\n",
  "PORTAGING": "PORTAGE, to transport from one navigable waterway to another [v]\n",
  "PORTAGUE": "a former Portuguese gold coin, also PORTIGUE [n -S]\n",
  "PORTAGUES": "PORTAGUE, a former Portuguese gold coin, also PORTIGUE [n]\n",
  "PORTAL": "a door, gate or entrance [n -S]\n",
  "PORTALED": "having a portal [adj]\n",
  "PORTALS": "PORTAL, a door, gate or entrance [n]\n",
  "PORTAMENTI": "PORTAMENTO, (Italian) in singing, or in the use of the bow, a gradual carrying or lifting of the voice or sound very smoothly from one note to another [n]\n",
  "PORTAMENTO": "(Italian) in singing, or in the use of the bow, a gradual carrying or lifting of the voice or sound very smoothly from one note to another [n PORTAMENTI]\n",
  "PORTANCE": "(Spenser) carriage, bearing [n -S]\n",
  "PORTANCES": "PORTANCE, (Spenser) carriage, bearing [n]\n",
  "PORTAPACK": "a small portable combined videotape and camera, also PORTAPAK [n -S]\n",
  "PORTAPACKS": "PORTAPACK, a small portable combined videotape and camera, also PORTAPAK [n]\n",
  "PORTAPAK": "a small portable combined videotape and camera, also PORTAPACK [n -S]\n",
  "PORTAPAKS": "PORTAPAK, a small portable combined videotape and camera, also PORTAPACK [n]\n",
  "PORTAS": "(historical) a portable breviary, also PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n -ES]\n",
  "PORTASES": "PORTAS, (historical) a portable breviary, also PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n]\n",
  "PORTATE": "in heraldry, in a carrying position [adj]\n",
  "PORTATILE": "portable [adj]\n",
  "PORTATIVE": "a portable organ [n -S]\n",
  "PORTATIVES": "PORTATIVE, a portable organ [n]\n",
  "PORTCULLIS": "a grating of iron or of timbers pointed with iron, hung over the gateway of a fortress, to be let down to prevent the entrance of an enemy [n -ES] / to obstruct as with a portcullis [v -ED, -ING, -ES]\n",
  "PORTCULLISED": "PORTCULLIS, to obstruct as with a portcullis [v]\n",
  "PORTCULLISES": "PORTCULLIS, a grating of iron or of timbers pointed with iron, hung over the gateway of a fortress, to be let down to prevent the entrance of an enemy [n]\n",
  "PORTCULLISING": "PORTCULLIS, to obstruct as with a portcullis [v]\n",
  "PORTED": "PORT, to carry, convey [v]\n",
  "PORTEND": "to serve as an omen of [v -ED, -ING, -S]\n",
  "PORTENDED": "PORTEND, to serve as an omen of [v]\n",
  "PORTENDING": "PORTEND, to serve as an omen of [v]\n",
  "PORTENDS": "PORTEND, to serve as an omen of [v]\n",
  "PORTENT": "an omen [n -S]\n",
  "PORTENTOUS": "of, relating to, or constituting a portent [adj PORTENTOUSLY]\n",
  "PORTENTOUSLY": "PORTENTOUS, of, relating to, or constituting a portent [adv]\n",
  "PORTENTOUSNESS": "PORTENTOUS, of, relating to, or constituting a portent [n]\n",
  "PORTENTS": "PORTENT, an omen [n]\n",
  "PORTEOUS": "(historical) a portable breviary, also PORTAS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n -ES]\n",
  "PORTEOUSES": "PORTEOUS, (historical) a portable breviary, also PORTAS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n]\n",
  "PORTER": "to carry luggage [v -ED, -ING, -S]\n",
  "PORTERAGE": "the work of a porter [n -S]\n",
  "PORTERAGES": "PORTERAGE, the work of a porter [n]\n",
  "PORTERED": "PORTER, to carry luggage [v]\n",
  "PORTERESS": "a female porter, also PORTRESS [n -ES]\n",
  "PORTERESSES": "PORTERESS, a female porter, also PORTRESS [n]\n",
  "PORTERHOUSE": "a house where malt liquor (as porter) is sold [n -S]\n",
  "PORTERHOUSES": "PORTERHOUSE, a house where malt liquor (as porter) is sold [n]\n",
  "PORTERING": "PORTER, to carry luggage [v]\n",
  "PORTERLY": "like a porter [adv]\n",
  "PORTERS": "PORTER, to carry luggage [v]\n",
  "PORTESS": "(historical) a portable breviary, also PORTAS, PORTEOUS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n -ES]\n",
  "PORTESSE": "(historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n -S]\n",
  "PORTESSES": "PORTESS, (historical) a portable breviary, also PORTAS, PORTEOUS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE, PORTOUS [n]\n",
  "PORTFIRE": "a slow fuse, allowing the explosive to be carried for a while [n -S]\n",
  "PORTFIRES": "PORTFIRE, a slow fuse, allowing the explosive to be carried for a while [n]\n",
  "PORTFOLIO": "a case or pair of boards for holding loose papers [n -S]\n",
  "PORTFOLIOS": "PORTFOLIO, a case or pair of boards for holding loose papers [n]\n",
  "PORTHOLE": "a small window in a ship's side [n -S]\n",
  "PORTHOLES": "PORTHOLE, a small window in a ship's side [n]\n",
  "PORTHORS": "(historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHOS, PORTHOUSE, PORTOUS [n -ES]\n",
  "PORTHORSES": "PORTHORS, (historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHOS, PORTHOUSE, PORTOUS [n]\n",
  "PORTHOS": "(historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOUSE, PORTOUS [n -ES]\n",
  "PORTHOSES": "PORTHOS, (historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOUSE, PORTOUS [n]\n",
  "PORTHOUSE": "(historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTOUS [n -S]\n",
  "PORTHOUSES": "PORTHOUSE, (historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTOUS [n]\n",
  "PORTICO": "(Italian) a formal entrance to a classical temple, church, or other building [n PORTICOS or PORTICOES]\n",
  "PORTICOED": "having a portico [adj]\n",
  "PORTICOES": "PORTICO, (Italian) a formal entrance to a classical temple, church, or other building [n]\n",
  "PORTICOS": "PORTICO, (Italian) a formal entrance to a classical temple, church, or other building [n]\n",
  "PORTIER": "PORTY, of the taste of port [adj]\n",
  "PORTIERE": "(French) a curtain hanging across a doorway [n -S]\n",
  "PORTIERED": "having a portiere [adj]\n",
  "PORTIERES": "PORTIERE, (French) a curtain hanging across a doorway [n]\n",
  "PORTIEST": "PORTY, of the taste of port [adj]\n",
  "PORTIGUE": "a former Portuguese gold coin, also PORTAGUE [n -S]\n",
  "PORTIGUES": "PORTIGUE, a former Portuguese gold coin, also PORTAGUE [n]\n",
  "PORTING": "PORT, to carry, convey [v]\n",
  "PORTION": "to divide into shares for distribution [v -ED, -ING, -S]\n",
  "PORTIONED": "PORTION, to divide into shares for distribution [v]\n",
  "PORTIONER": "the proprietor of a small piece of land forming a portion of a larger piece which has been broken up usually among joint heirs [n -S]\n",
  "PORTIONERS": "PORTIONER, the proprietor of a small piece of land forming a portion of a larger piece which has been broken up usually among joint heirs [n]\n",
  "PORTIONING": "PORTION, to divide into shares for distribution [v]\n",
  "PORTIONIST": "a postmaster of Merton College; one of two or more incumbents sharing a benefice [n -S]\n",
  "PORTIONISTS": "PORTIONIST, a postmaster of Merton College; one of two or more incumbents sharing a benefice [n]\n",
  "PORTIONLESS": "without a portion [adj]\n",
  "PORTIONS": "PORTION, to divide into shares for distribution [v]\n",
  "PORTLAND": "a kind of cement, having the color of the Portland stone [n -S]\n",
  "PORTLANDS": "PORTLAND, a kind of cement, having the color of the Portland stone [n]\n",
  "PORTLAST": "(obsolete) the gunwale of a ship, also PORTOISE [n -S]\n",
  "PORTLASTS": "PORTLAST, (obsolete) the gunwale of a ship, also PORTOISE [n]\n",
  "PORTLESS": "having no place for ships to load or unload [adj]\n",
  "PORTLIER": "PORTLY, corpulent, stout [adj]\n",
  "PORTLIEST": "PORTLY, corpulent, stout [adj]\n",
  "PORTLINESS": "the state of being portly [n -ES]\n",
  "PORTLINESSES": "PORTLINESS, the state of being portly [n]\n",
  "PORTLY": "corpulent, stout [adj PORTLIER, PORTLIEST]\n",
  "PORTMAN": "an inhabitant or burgess of a port, esp. of one of the Cinque Ports [n PORTMEN]\n",
  "PORTMANTEAU": "(French) a case opening in two parts, used for carrying clothes while traveling, also PORTMANTLE, PORTMANTUA [n PORTMANTEAUS or PORTMANTEAUX]\n",
  "PORTMANTEAUS": "PORTMANTEAU, (French) a case opening in two parts, used for carrying clothes while traveling, also PORTMANTLE, PORTMANTUA [n]\n",
  "PORTMANTEAUX": "PORTMANTEAU, (French) a case opening in two parts, used for carrying clothes while traveling, also PORTMANTLE, PORTMANTUA [n]\n",
  "PORTMANTLE": "(obsolete) a portmanteau, also PORTMANTEAU, PORTMANTUA [n -S]\n",
  "PORTMANTLES": "PORTMANTLE, (obsolete) a portmanteau, also PORTMANTEAU, PORTMANTUA [n]\n",
  "PORTMANTUA": "(obsolete) a portmanteau, also PORTMANTEAU, PORTMANTLE [n -S]\n",
  "PORTMANTUAS": "PORTMANTUA, (obsolete) a portmanteau, also PORTMANTEAU, PORTMANTLE [n]\n",
  "PORTMEN": "PORTMAN, an inhabitant or burgess of a port, esp. of one of the Cinque Ports [n]\n",
  "PORTOBELLO": "a variety of button mushroom, also PORTABELLA, PORTABELLO [n -S]\n",
  "PORTOBELLOS": "PORTOBELLO, a variety of button mushroom, also PORTABELLA, PORTABELLO [n]\n",
  "PORTOISE": "the gunwale of a ship, also PORTLAST [n -S]\n",
  "PORTOISES": "PORTOISE, the gunwale of a ship, also PORTLAST [n]\n",
  "PORTOLAN": "(Italian) in the Middle Ages, a navigation manual, also PORTOLANO, PORTULAN [n -S]\n",
  "PORTOLANI": "PORTOLANO, (Italian) in the Middle Ages, a navigation manual, also PORTOLAN, PORTULAN [n]\n",
  "PORTOLANO": "(Italian) in the Middle Ages, a navigation manual, also PORTOLAN, PORTULAN [n PORTOLANI or PORTOLANOS]\n",
  "PORTOLANOS": "PORTOLANO, (Italian) in the Middle Ages, a navigation manual, also PORTOLAN, PORTULAN [n]\n",
  "PORTOLANS": "PORTOLAN, (Italian) in the Middle Ages, a navigation manual, also PORTOLANO, PORTULAN [n]\n",
  "PORTOUS": "(historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE [n -ES]\n",
  "PORTOUSES": "PORTOUS, (historical) a portable breviary, also PORTAS, PORTEOUS, PORTESS, PORTESSE, PORTHORS, PORTHOS, PORTHOUSE [n]\n",
  "PORTRAIT": "a painting, photograph or other likeness of a real person, also POURTRAICT [n -S] / to make a portrait of [v -ED, -ING, -S]\n",
  "PORTRAITED": "PORTRAIT, to make a portrait of [v]\n",
  "PORTRAITING": "PORTRAIT, to make a portrait of [v]\n",
  "PORTRAITIST": "a maker of portraits [n -S]\n",
  "PORTRAITISTS": "PORTRAITIST, a maker of portraits [n]\n",
  "PORTRAITS": "PORTRAIT, to make a portrait of [v]\n",
  "PORTRAITURE": "the making of portraits [n -S]\n",
  "PORTRAITURES": "PORTRAITURE, the making of portraits [n]\n",
  "PORTRAY": "to paint or draw the likeness of, also POURTRAY [v -ED, -ING, -S]\n",
  "PORTRAYABLE": "that can be portrayed [adj]\n",
  "PORTRAYAL": "the act of portraying [n -S]\n",
  "PORTRAYALS": "PORTRAYAL, the act of portraying [n]\n",
  "PORTRAYED": "PORTRAY, to paint or draw the likeness of, also POURTRAY [v]\n",
  "PORTRAYER": "one who portrays [n -S]\n",
  "PORTRAYERS": "PORTRAYER, one who portrays [n]\n",
  "PORTRAYING": "PORTRAY, to paint or draw the likeness of, also POURTRAY [v]\n",
  "PORTRAYS": "PORTRAY, to paint or draw the likeness of, also POURTRAY [v]\n",
  "PORTREEVE": "a mayor or principal magistrate [n -S]\n",
  "PORTREEVES": "PORTREEVE, a mayor or principal magistrate [n]\n",
  "PORTRESS": "a female porter, also PORTERESS [n -ES]\n",
  "PORTRESSES": "PORTRESS, a female porter, also PORTERESS [n]\n",
  "PORTS": "PORT, to carry, convey [v]\n",
  "PORTSIDE": "on the port side [adj]\n",
  "PORTULACA": "any plant of the purslane family [n -S]\n",
  "PORTULACACEOUS": "belonging to the leek family [adj]\n",
  "PORTULACAS": "PORTULACA, any plant of the purslane family [n]\n",
  "PORTULAN": "(Italian) in the Middle Ages, a navigation manual, also PORTOLAN, PORTOLANO [n -S]\n",
  "PORTULANS": "PORTULAN, (Italian) in the Middle Ages, a navigation manual, also PORTOLAN, PORTOLANO [n]\n",
  "PORTY": "of the taste of port [adj PORTIER, PORTIEST]\n",
  "PORWIGGLE": "a tadpole, also POLLIWIG, POLLIWOG, POLLYWIG, POLLYWOG [n -S]\n",
  "PORWIGGLES": "PORWIGGLE, a tadpole, also POLLIWIG, POLLIWOG, POLLYWIG, POLLYWOG [n]\n",
  "PORY": "having pores [adj PORIER, PORIEST]\n",
  "POS": "(colloquial) positive, also POZ, POZZ [adj]\n",
  "POSABLE": "able to be posed, also POSEABLE [adj]\n",
  "POSADA": "(Spanish) in Mexico, each of a series of visits traditionally paid to different friends during the days before Christmas, representing Mary and Joseph's search for lodging in Bethlehem [n -S]\n",
  "POSADAS": "POSADA, (Spanish) in Mexico, each of a series of visits traditionally paid to different friends during the days before Christmas, representing Mary and Joseph's search for lodging in Bethlehem [n]\n",
  "POSAUNE": "(German) the trombone [n -S]\n",
  "POSAUNES": "POSAUNE, (German) the trombone [n]\n",
  "POSE": "to assume a fixed position [v POSED, POSING, POSES]\n",
  "POSEABLE": "able to be posed, also POSABLE [adj]\n",
  "POSED": "POSE, to assume a fixed position [v]\n",
  "POSER": "one that poses [n -S]\n",
  "POSERISH": "affected, insincere [adj]\n",
  "POSERS": "POSER, one that poses [n]\n",
  "POSES": "POSE, to assume a fixed position [v]\n",
  "POSEUR": "(French) an affected or insincere person [n -S]\n",
  "POSEURS": "POSEUR, (French) an affected or insincere person [n]\n",
  "POSEUSE": "(French) a female poseur [n -S]\n",
  "POSEUSES": "POSEUSE, (French) a female poseur [n]\n",
  "POSEY": "adopting poses for effects, also POSY [adj POSIER, POSIEST]\n",
  "POSH": "smart, stylish [adj POSHER, POSHEST, POSHLY] / to polish up [v -ED, -ING, -ES]\n",
  "POSHED": "POSH, to polish up [v]\n",
  "POSHER": "POSH, smart, stylish [adj]\n",
  "POSHES": "POSH, to polish up [v]\n",
  "POSHEST": "POSH, smart, stylish [adj]\n",
  "POSHING": "POSH, to polish up [v]\n",
  "POSHLY": "POSH, smart, stylish [adv]\n",
  "POSHNESS": "the quality of being posh [n -ES]\n",
  "POSHNESSES": "POSHNESS, the quality of being posh [n]\n",
  "POSHO": "(Swahili) corn meal [n -S]\n",
  "POSHOS": "POSHO, (Swahili) corn meal [n]\n",
  "POSHTEEN": "(Persian) an Afghan sheepskin coat, also POSTEEN, POSTIN [n -S]\n",
  "POSHTEENS": "POSHTEEN, (Persian) an Afghan sheepskin coat, also POSTEEN, POSTIN [n]\n",
  "POSIDRIVE": "(trade) having a patent screw-head that allows greater torque, also POZIDRIVE [adj]\n",
  "POSIER": "POSY, given to posing, also POSEY [adj]\n",
  "POSIES": "POSY, a small bunch of flowers [n]\n",
  "POSIEST": "POSY, given to posing, also POSEY [adj]\n",
  "POSIGRADE": "having or producing positive thrust [adj]\n",
  "POSING": "assuming a pose, pretentious [adj POSINGLY] / the act of posing [n -S]\n",
  "POSINGLY": "POSING, assuming a pose, pretentious [adv]\n",
  "POSINGS": "POSING, the act of posing [n]\n",
  "POSIT": "to place [v -ED, -ING, -S]\n",
  "POSITED": "POSIT, to place [v]\n",
  "POSITIF": "(French) a feature on older organs, manually controlling soft stops [n -S]\n",
  "POSITIFS": "POSITIF, (French) a feature on older organs, manually controlling soft stops [n]\n",
  "POSITING": "POSIT, to place [v]\n",
  "POSITION": "to put in a particular location [v -ED, -ING, -S]\n",
  "POSITIONAL": "of, relating to, or fixed by position [adj POSITIONALLY]\n",
  "POSITIONALLY": "POSITIONAL, of, relating to, or fixed by position [adv]\n",
  "POSITIONED": "POSITION, to put in a particular location [v]\n",
  "POSITIONING": "the act of putting in a particular location [n -S]\n",
  "POSITIONINGS": "POSITIONING, the act of putting in a particular location [n]\n",
  "POSITIONS": "POSITION, to put in a particular location [v]\n",
  "POSITIVE": "assertive, affirmative [adj POSITIVER, POSITIVEST, POSITIVELY] / something greater than zero [n -S]\n",
  "POSITIVELY": "POSITIVE, assertive, affirmative [adv]\n",
  "POSITIVENESS": "the state of being positive [n -ES]\n",
  "POSITIVENESSES": "POSITIVENESS, the state of being positive [n]\n",
  "POSITIVER": "POSITIVE, assertive, affirmative [adj]\n",
  "POSITIVES": "POSITIVE, something greater than zero [n]\n",
  "POSITIVEST": "POSITIVE, assertive, affirmative [adj]\n",
  "POSITIVISM": "the doctrine that that which is not observable is not knowable [n -S]\n",
  "POSITIVISMS": "POSITIVISM, the doctrine that that which is not observable is not knowable [n]\n",
  "POSITIVIST": "a believer in positivism [n -S]\n",
  "POSITIVISTIC": "relating to positivism, the doctrine that that which is not observable is not knowable [adj]\n",
  "POSITIVISTS": "POSITIVIST, a believer in positivism [n]\n",
  "POSITIVITIES": "POSITIVITY, positiveness [n]\n",
  "POSITIVITY": "positiveness [n POSITIVITIES]\n",
  "POSITON": "an electron but with a positive charge, also POSITRON [n -S]\n",
  "POSITONS": "POSITON, an electron but with a positive charge, also POSITRON [n]\n",
  "POSITRON": "an electron but with a positive charge, also POSITON [n -S]\n",
  "POSITRONIUM": "a positron and and an electron bound together in a short-lived unit, similar to a hydrogen atom [n -S]\n",
  "POSITRONIUMS": "POSITRONIUM, a positron and and an electron bound together in a short-lived unit, similar to a hydrogen atom [n]\n",
  "POSITRONS": "POSITRON, an electron but with a positive charge, also POSITON [n]\n",
  "POSITS": "POSIT, to place [v]\n",
  "POSNET": "a small cooking pot [n -S]\n",
  "POSNETS": "POSNET, a small cooking pot [n]\n",
  "POSOLE": "a thick soup made of pork, corn, garlic, and chili, also POZOLE [n -S]\n",
  "POSOLES": "POSOLE, a thick soup made of pork, corn, garlic, and chili, also POZOLE [n]\n",
  "POSOLOGIC": "relating to posology, the branch of medicine that deals with dosages, also POSOLOGICAL [adj]\n",
  "POSOLOGICAL": "related to posology, the branch of medicine that deals with dosages, also POSOLOGIC [adj]\n",
  "POSOLOGIES": "POSOLOGY, a branch of medicine that deals with drug dosages [n]\n",
  "POSOLOGY": "a branch of medicine that deals with drug dosages [n POSOLOGIES]\n",
  "POSS": "to wash clothes with a stick by agitating [v -ED, -ING, -ES]\n",
  "POSSE": "(Latin) a body of men summoned to aid a peace officer [n -S]\n",
  "POSSED": "POSS, to wash clothes with a stick by agitating [v]\n",
  "POSSER": "(archaic) a wooden stick for use in possing clothes [n -S]\n",
  "POSSERS": "POSSER, (archaic) a wooden stick for use in possing clothes [n]\n",
  "POSSES": "POSS, to wash clothes with a stick by agitating [v]\n",
  "POSSESS": "to have as an owner [v -ED, -ING, -ES]\n",
  "POSSESSABLE": "that can be possessed [adj]\n",
  "POSSESSED": "POSSESS, to have as an owner [v]\n",
  "POSSESSEDLY": "POSSESSED, POSSESS, to have as an owner [adv]\n",
  "POSSESSEDNESS": "the state of being possessed [n -ES]\n",
  "POSSESSEDNESSES": "POSSESSEDNESS, the state of being possessed [n]\n",
  "POSSESSES": "POSSESS, to have as an owner [v]\n",
  "POSSESSING": "POSSESS, to have as an owner [v]\n",
  "POSSESSION": "the act of having or taking into control [n -S]\n",
  "POSSESSIONAL": "relating to possession, also POSSESSIONARY [adj]\n",
  "POSSESSIONARY": "relating to possession, also POSSESSIONAL [adj]\n",
  "POSSESSIONATE": "holding or allowed to hold possessions, as opposed to mendicant [adj] / a possessionate monk [n -S]\n",
  "POSSESSIONATES": "POSSESSIONATE, a possessionate monk [n]\n",
  "POSSESSIONED": "having possessions [adj]\n",
  "POSSESSIONLESS": "without possessions [adj]\n",
  "POSSESSIONS": "POSSESSION, the act of having or taking into control [n]\n",
  "POSSESSIVE": "related to possession [adj POSSESSIVELY] / a possessive word or word group [n -S]\n",
  "POSSESSIVELY": "POSSESSIVE, related to possession [adv]\n",
  "POSSESSIVENESS": "POSSESSIVE, related to possession [n]\n",
  "POSSESSIVES": "POSSESSIVE, a possessive word or word group [n]\n",
  "POSSESSOR": "one who possesses [n -S]\n",
  "POSSESSORS": "POSSESSOR, one who possesses [n]\n",
  "POSSESSORSHIP": "the office of possessor [n -S]\n",
  "POSSESSORSHIPS": "POSSESSORSHIP, the office of possessor [n]\n",
  "POSSESSORY": "of or pertaining to possession [adj]\n",
  "POSSET": "a drink of milk curdled with e.g. wine [n -S] / to curdle [v -ED, -ING, -S]\n",
  "POSSETED": "POSSET, to curdle [v]\n",
  "POSSETING": "POSSET, to curdle [v]\n",
  "POSSETS": "POSSET, to curdle [v]\n",
  "POSSIBILISM": "the policy of confining efforts to what is immediately possible or practicable [n -S]\n",
  "POSSIBILISMS": "POSSIBILISM, the policy of confining efforts to what is immediately possible or practicable [n]\n",
  "POSSIBILIST": "an adherent of possibilism [n -S]\n",
  "POSSIBILISTS": "POSSIBILIST, an adherent of possibilism [n]\n",
  "POSSIBILITIES": "POSSIBILITY, the condition or fact of being possible [n]\n",
  "POSSIBILITY": "the condition or fact of being possible [n POSSIBILITIES]\n",
  "POSSIBLE": "that can be done [adj POSSIBLER, POSSIBLEST, POSSIBLY] / something that is possible [n -S]\n",
  "POSSIBLER": "POSSIBLE, that can be done [adj]\n",
  "POSSIBLES": "POSSIBLE, something that is possible [n]\n",
  "POSSIBLEST": "POSSIBLE, that can be done [adj]\n",
  "POSSIBLY": "capable of happening or proving true [adj]\n",
  "POSSIE": "(Australian slang) a position, also POZZY [n -S]\n",
  "POSSIES": "POSSIE, (Australian slang) a position, also POZZY [n]\n",
  "POSSING": "POSS, to wash clothes with a stick by agitating [v]\n",
  "POSSUM": "to feign ignorance (i.e. to play possum) [v -ED, -ING, -S]\n",
  "POSSUMED": "POSSUM, to feign ignorance (i.e. to play possum) [v]\n",
  "POSSUMING": "POSSUM, to feign ignorance (i.e. to play possum) [v]\n",
  "POSSUMS": "POSSUM, to feign ignorance (i.e. to play possum) [v]\n",
  "POST": "to display in a public place [v -ED, -ING, -S]\n",
  "POSTABORTION": "taking place after an abortion [adj]\n",
  "POSTACCIDENT": "taking place after an accident [adj]\n",
  "POSTADOLESCENT": "someone just out of adolescence e.g. in their early twenties [n -S]\n",
  "POSTADOLESCENTS": "POSTADOLESCENT, someone just out of adolescence e.g. in their early twenties [n]\n",
  "POSTAGE": "the charge for mailing an item [n -S]\n",
  "POSTAGES": "POSTAGE, the charge for mailing an item [n]\n",
  "POSTAL": "relating to post [adj POSTALLY] / a postcard issued by the Post Office with a printed stamp [n -S]\n",
  "POSTALLY": "POSTAL, relating to post [adv]\n",
  "POSTALS": "POSTAL, a postcard issued by the Post Office with a printed stamp [n]\n",
  "POSTAMPUTATION": "taking place after an amputation [adj]\n",
  "POSTANAL": "situated behind the anus [adj]\n",
  "POSTAPOCALYPTIC": "taking place after an apocalypse [adj]\n",
  "POSTARREST": "taking place after an arrest [adj]\n",
  "POSTATOMIC": "taking place after the atomic era [adj]\n",
  "POSTATTACK": "following an attack [adj]\n",
  "POSTAXIAL": "situated behind any transverse axis in the body of an animal [adj]\n",
  "POSTBAG": "a bag for holding mail [n -S]\n",
  "POSTBAGS": "POSTBAG, a bag for holding mail [n]\n",
  "POSTBASE": "a morpheme used as a suffix after a base word [n -S]\n",
  "POSTBASES": "POSTBASE, a morpheme used as a suffix after a base word [n]\n",
  "POSTBELLUM": "(Latin) after a war [adj]\n",
  "POSTBIBLICAL": "belonging to the period after the Bible [adj]\n",
  "POSTBOURGEOIS": "belonging to a period of society after the bourgeoisie [adj]\n",
  "POSTBOX": "a mailbox [n -ES]\n",
  "POSTBOXES": "POSTBOX, a mailbox [n]\n",
  "POSTBOY": "a boy who carries mail [n -S]\n",
  "POSTBOYS": "POSTBOY, a boy who carries mail [n]\n",
  "POSTBURN": "following a burn [adj]\n",
  "POSTBUS": "a small bus for mail and passengers [n POSTBUSES or POSTBUSSES]\n",
  "POSTBUSES": "POSTBUS, a small bus for mail and passengers [n]\n",
  "POSTBUSSES": "POSTBUS, a small bus for mail and passengers [n]\n",
  "POSTCAPITALIST": "taking place after capitalism [adj]\n",
  "POSTCARD": "a card for writing messages on [n -S] / to send a postcard [v -ED, -ING, -S]\n",
  "POSTCARDED": "POSTCARD, to send a postcard [v]\n",
  "POSTCARDING": "POSTCARD, to send a postcard [v]\n",
  "POSTCARDLIKE": "resembling a postcard [adj]\n",
  "POSTCARDS": "POSTCARD, to send a postcard [v]\n",
  "POSTCAVA": "(Latin) a vein in higher vertebrates [n POSTCAVAS or POSTCAVAE]\n",
  "POSTCAVAE": "POSTCAVA, (Latin) a vein in higher vertebrates [n]\n",
  "POSTCAVAL": "relating to the postcava, the inferior vena cava [adj]\n",
  "POSTCAVAS": "POSTCAVA, (Latin) a vein in higher vertebrates [n]\n",
  "POSTCLASSIC": "of or relating to a period (as in art, literature, or civilization) following a classical one, also POSTCLASSICAL [adj]\n",
  "POSTCLASSICAL": "of or relating to a period (as in art, literature, or civilization) following a classical one, also POSTCLASSIC [adj]\n",
  "POSTCODE": "a code, often a combination of letters and numbers, specific to a particular section of housing [n -S] / to give a postcode to [v POSTCODED, POSTCODING, POSTCODES]\n",
  "POSTCODED": "POSTCODE, to give a postcode to [v]\n",
  "POSTCODES": "POSTCODE, to give a postcode to [v]\n",
  "POSTCODING": "POSTCODE, to give a postcode to [v]\n",
  "POSTCOITAL": "after sexual intercourse [adj]\n",
  "POSTCOLLEGE": "taking place after college [adj]\n",
  "POSTCOLLEGIATE": "taking place after college [adj]\n",
  "POSTCOLONIAL": "taking place after the end of colonial rule [adj]\n",
  "POSTCONCEPTION": "taking place after conception [adj]\n",
  "POSTCONCERT": "taking place after a concert [adj]\n",
  "POSTCONQUEST": "taking place after conquest [adj]\n",
  "POSTCONSONANTAL": "following a consonant [adj]\n",
  "POSTCONVENTION": "taking place after a convention [adj]\n",
  "POSTCOPULATORY": "taking place after copulation [adj]\n",
  "POSTCORONARY": "taking place after a coronary [adj]\n",
  "POSTCOUP": "following a coup [adj]\n",
  "POSTCRANIAL": "of or relating to the part of the body caudal to the head [adj POSTCRANIALLY]\n",
  "POSTCRANIALLY": "POSTCRANIAL, of or relating to the part of the body caudal to the head [adv]\n",
  "POSTCRASH": "after a crash [adj]\n",
  "POSTCRISIS": "taking place after a crisis [adj]\n",
  "POSTDATE": "to date after the real time [v POSTDATED, POSTDATING, POSTDATES]\n",
  "POSTDATED": "POSTDATE, to date after the real time [v]\n",
  "POSTDATES": "POSTDATE, to date after the real time [v]\n",
  "POSTDATING": "POSTDATE, to date after the real time [v]\n",
  "POSTDEADLINE": "following a deadline [adj]\n",
  "POSTDEBATE": "after a debate [adj]\n",
  "POSTDEBUTANTE": "following the stage of being a debutante [adj]\n",
  "POSTDELIVERY": "following a delivery [adj]\n",
  "POSTDEPRESSION": "after a depression [adj]\n",
  "POSTDEVALUATION": "taking place after devaluation [adj]\n",
  "POSTDILUVIAL": "after the Flood [adj]\n",
  "POSTDILUVIAN": "pertaining to the period after the Biblical flood or any great flood [adj] / someone or something occurring in such a period [n -S]\n",
  "POSTDILUVIANS": "POSTDILUVIAN, someone or something occurring in such a period [n]\n",
  "POSTDIVE": "following a dive [adj]\n",
  "POSTDIVESTITURE": "taking place after divestiture [adj]\n",
  "POSTDIVORCE": "following a divorce [adj]\n",
  "POSTDOC": "one engaged in postdoctoral study [n -S]\n",
  "POSTDOCS": "POSTDOC, one engaged in postdoctoral study [n]\n",
  "POSTDOCTORAL": "a degree beyond the doctoral level [n -S]\n",
  "POSTDOCTORALS": "POSTDOCTORAL, a degree beyond the doctoral level [n]\n",
  "POSTDOCTORATE": "a degree after a doctorate [n -S]\n",
  "POSTDOCTORATES": "POSTDOCTORATE, a degree after a doctorate [n]\n",
  "POSTDRUG": "following the taking of a drug [adj]\n",
  "POSTED": "POST, to display in a public place [v]\n",
  "POSTEDITING": "the act of editing after a piece of writing has been produced or printed by a machine [n -S]\n",
  "POSTEDITINGS": "POSTEDITING, the act of editing after a piece of writing has been produced or printed by a machine [n]\n",
  "POSTEEN": "(Persian) an Afghan sheepskin coat, also POSHTEEN, POSTIN [n -S]\n",
  "POSTEENS": "POSTEEN, (Persian) an Afghan sheepskin coat, also POSHTEEN, POSTIN [n]\n",
  "POSTELECTION": "following an election [adj]\n",
  "POSTEMBRYONAL": "subsequent to the embryonic stage of life or growth, also POSTEMBRYONIC [adj]\n",
  "POSTEMBRYONIC": "subsequent to the embryonic stage of life or growth, also POSTEMBRYONAL [adj]\n",
  "POSTEMERGENCE": "used or occurring in the stage between the emergence of a seedling and the maturity of a crop plant [adj]\n",
  "POSTEMERGENCY": "following an emergency [adj]\n",
  "POSTEPILEPTIC": "taking place after an epileptic fit [adj]\n",
  "POSTER": "to stick bills on [v -ED, -ING, -S]\n",
  "POSTERED": "POSTER, to stick bills on [v]\n",
  "POSTERING": "POSTER, to stick bills on [v]\n",
  "POSTERIOR": "coming after [adj POSTERIORLY] / the buttocks [n -S]\n",
  "POSTERIORITIES": "POSTERIORITY, the state of being later or subsequent [n]\n",
  "POSTERIORITY": "the state of being later or subsequent [n POSTERIORITIES]\n",
  "POSTERIORLY": "POSTERIOR, coming after [adv]\n",
  "POSTERIORS": "POSTERIOR, the buttocks [n]\n",
  "POSTERISATION": "a video effect in which the picture is produced in a limited number of flat tones and colours, also POSTERIZATION [n -S]\n",
  "POSTERISATIONS": "POSTERISATION, a video effect in which the picture is produced in a limited number of flat tones and colours, also POSTERIZATION [n]\n",
  "POSTERISE": "(US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERIZE [v POSTERISED, POSTERISING, POSTERISES]\n",
  "POSTERISED": "POSTERISE, (US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERIZE [v]\n",
  "POSTERISES": "POSTERISE, (US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERIZE [v]\n",
  "POSTERISING": "POSTERISE, (US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERIZE [v]\n",
  "POSTERITIES": "POSTERITY, those coming after; succeeding generations [n]\n",
  "POSTERITY": "those coming after; succeeding generations [n POSTERITIES]\n",
  "POSTERIZATION": "a video effect in which the picture is produced in a limited number of flat tones and colours, also POSTERISATION [n -S]\n",
  "POSTERIZATIONS": "POSTERIZATION, a video effect in which the picture is produced in a limited number of flat tones and colours, also POSTERISATION [n]\n",
  "POSTERIZE": "(US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERISE [v POSTERIZED, POSTERIZING, POSTERIZES]\n",
  "POSTERIZED": "POSTERIZE, (US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERISE [v]\n",
  "POSTERIZES": "POSTERIZE, (US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERISE [v]\n",
  "POSTERIZING": "POSTERIZE, (US and Canadian slang) to humiliate (a sporting opponent) by performing a dramatic feat against them, also POSTERISE [v]\n",
  "POSTERN": "a rear door or gate [n -S]\n",
  "POSTERNS": "POSTERN, a rear door or gate [n]\n",
  "POSTEROLATERAL": "posterior and lateral in position or direction [adj]\n",
  "POSTERS": "POSTER, to stick bills on [v]\n",
  "POSTERUPTIVE": "taking place after an eruption [adj]\n",
  "POSTEXERCISE": "taking place after exercise [adj]\n",
  "POSTEXILIAN": "existing or occurring after exile, esp. after the Babylonian captivity of the Jews, also POSTEXILIC [adj]\n",
  "POSTEXILIC": "existing or occurring after exile, esp. after the Babylonian captivity of the Jews, also POSTEXILIAN [adj]\n",
  "POSTEXPERIENCE": "taking place after an experience [adj]\n",
  "POSTEXPOSURE": "taking place after exposure [adj]\n",
  "POSTFACE": "a brief note placed at the end of a publication [n -S]\n",
  "POSTFACES": "POSTFACE, a brief note placed at the end of a publication [n]\n",
  "POSTFACT": "of or relating to a culture in which appeals to the emotions tend to prevail over facts and logical arguments [adj]\n",
  "POSTFAULT": "taking place after a fault [adj]\n",
  "POSTFEMINISM": "a movement that regards the main principles of feminism as either achieved or misguided and seeks a new programme [n -S]\n",
  "POSTFEMINISMS": "POSTFEMINISM, a movement that regards the main principles of feminism as either achieved or misguided and seeks a new programme [n]\n",
  "POSTFEMINIST": "a supporter of postfeminism [n -S]\n",
  "POSTFEMINISTS": "POSTFEMINIST, a supporter of postfeminism [n]\n",
  "POSTFIRE": "following a fire [adj]\n",
  "POSTFIX": "to affix at the end of something [v -ED, -ING, -ES]\n",
  "POSTFIXAL": "added or appended to the end of something [adj]\n",
  "POSTFIXED": "POSTFIX, to affix at the end of something [v]\n",
  "POSTFIXES": "POSTFIX, to affix at the end of something [v]\n",
  "POSTFIXING": "POSTFIX, to affix at the end of something [v]\n",
  "POSTFLIGHT": "after a flight [adj]\n",
  "POSTFORM": "to shape subsequently [v -ED, -ING, -S]\n",
  "POSTFORMED": "POSTFORM, to shape subsequently [v]\n",
  "POSTFORMING": "POSTFORM, to shape subsequently [v]\n",
  "POSTFORMS": "POSTFORM, to shape subsequently [v]\n",
  "POSTFRACTURE": "taking place after a fracture [adj]\n",
  "POSTFREEZE": "after a freeze [adj]\n",
  "POSTGAME": "following a game [adj]\n",
  "POSTGANGLIONIC": "distal to a ganglion [adj]\n",
  "POSTGLACIAL": "following a period of glaciation [adj]\n",
  "POSTGRAD": "a student continuing formal education after graduation [n -S]\n",
  "POSTGRADS": "POSTGRAD, a student continuing formal education after graduation [n]\n",
  "POSTGRADUATE": "a student continuing formal education after graduation from high school or college [n -S]\n",
  "POSTGRADUATES": "POSTGRADUATE, a student continuing formal education after graduation from high school or college [n]\n",
  "POSTGRADUATION": "the period of time following graduation [n -S]\n",
  "POSTGRADUATIONS": "POSTGRADUATION, the period of time following graduation [n]\n",
  "POSTHARVEST": "following a harvest [adj]\n",
  "POSTHASTE": "great haste [n -S]\n",
  "POSTHASTES": "POSTHASTE, great haste [n]\n",
  "POSTHEAT": "to heat a material (usually metal) after welding or treating to relieve stresses [v -ED, -ING, -S]\n",
  "POSTHEATED": "POSTHEAT, to heat a material (usually metal) after welding or treating to relieve stresses [v]\n",
  "POSTHEATING": "POSTHEAT, to heat a material (usually metal) after welding or treating to relieve stresses [v]\n",
  "POSTHEATS": "POSTHEAT, to heat a material (usually metal) after welding or treating to relieve stresses [v]\n",
  "POSTHEMORRHAGIC": "taking place after a hemorrhage [adj]\n",
  "POSTHOLDER": "one who holds a post [n -S]\n",
  "POSTHOLDERS": "POSTHOLDER, one who holds a post [n]\n",
  "POSTHOLE": "a hole dug to hold a fence post [n -S]\n",
  "POSTHOLES": "POSTHOLE, a hole dug to hold a fence post [n]\n",
  "POSTHOLIDAY": "taking place after a holiday [adj]\n",
  "POSTHOLOCAUST": "following the Holocaust [adj]\n",
  "POSTHORSE": "a horse used to deliver mail [n -S]\n",
  "POSTHORSES": "POSTHORSE, a horse used to deliver mail [n]\n",
  "POSTHOSPITAL": "taking place after a stay in hospital [adj]\n",
  "POSTHOUSE": "an inn, originally where horses were kept for posting [n -S]\n",
  "POSTHOUSES": "POSTHOUSE, an inn, originally where horses were kept for posting [n]\n",
  "POSTHUMOUS": "taking place after death [adj POSTHUMOUSLY]\n",
  "POSTHUMOUSLY": "POSTHUMOUS, taking place after death [adv]\n",
  "POSTHUMOUSNESS": "the state of being posthumous [n]\n",
  "POSTHYPNOTIC": "taking place after hypnosis [adj]\n",
  "POSTICAL": "of the position of plant parts, behind another part, also POSTICOUS [adj]\n",
  "POSTICHE": "(French) a wig, false hair; an ornament added, esp. inappropriately, to finished thing, also POSTIQUE [n -S]\n",
  "POSTICHES": "POSTICHE, (French) a wig, false hair; an ornament added, esp. inappropriately, to finished thing, also POSTIQUE [n]\n",
  "POSTICOUS": "of the position of plant parts, behind another part, also POSTICAL [adj]\n",
  "POSTIE": "(Australian slang) a postman [n -S]\n",
  "POSTIES": "POSTIE, (Australian slang) a postman [n]\n",
  "POSTIL": "to gloss [v POSTILLED or POSTILED, POSTILLING or POSTILING, POSTILS]\n",
  "POSTILED": "POSTIL, to gloss [v]\n",
  "POSTILING": "POSTIL, to gloss [v]\n",
  "POSTILION": "(historical) a person who rides the near horse of those drawing a coach etc. and acts as guide to the whole team, also POSTILLION [n -S]\n",
  "POSTILIONS": "POSTILION, (historical) a person who rides the near horse of those drawing a coach etc. and acts as guide to the whole team, also POSTILLION [n]\n",
  "POSTILLATE": "to explain by marginal notes [v POSTILLATED, POSTILLATING, POSTILLATES]\n",
  "POSTILLATED": "POSTILLATE, to explain by marginal notes [v]\n",
  "POSTILLATES": "POSTILLATE, to explain by marginal notes [v]\n",
  "POSTILLATING": "POSTILLATE, to explain by marginal notes [v]\n",
  "POSTILLATION": "the act of postillating, glossing a text [n -S]\n",
  "POSTILLATIONS": "POSTILLATION, the act of postillating, glossing a text [n]\n",
  "POSTILLATOR": "one who postillates, explains by marginal notes [n -S]\n",
  "POSTILLATORS": "POSTILLATOR, one who postillates, explains by marginal notes [n]\n",
  "POSTILLED": "POSTIL, to gloss [v]\n",
  "POSTILLER": "one who postils, provides glosses [n -S]\n",
  "POSTILLERS": "POSTILLER, one who postils, provides glosses [n]\n",
  "POSTILLING": "POSTIL, to gloss [v]\n",
  "POSTILLION": "(historical) a person who rides near horse of those drawing coach etc. and acts as guide to the whole team, also POSTILION [n -S]\n",
  "POSTILLIONS": "POSTILLION, (historical) a person who rides near horse of those drawing coach etc. and acts as guide to the whole team, also POSTILION [n]\n",
  "POSTILS": "POSTIL, to gloss [v]\n",
  "POSTIMPACT": "after an impact [adj]\n",
  "POSTIMPERIAL": "taking place after imperial rule [adj]\n",
  "POSTIN": "(Persian) an Afghan sheepskin coat, also POSTEEN, POSHTEEN [n -S]\n",
  "POSTINAUGURAL": "taking place after inauguration [adj]\n",
  "POSTINDUSTRIAL": "taking place after an industrial phase [adj]\n",
  "POSTINFECTION": "taking place after an infection [adj]\n",
  "POSTING": "the act of transferring to a ledger [n -S]\n",
  "POSTINGS": "POSTING, the act of transferring to a ledger [n]\n",
  "POSTINJECTION": "taking place after an injection [adj]\n",
  "POSTINOCULATION": "taking place after inoculation [adj]\n",
  "POSTINS": "POSTIN, (Persian) an Afghan sheepskin coat, also POSTEEN, POSHTEEN [n]\n",
  "POSTIQUE": "(French) an imitation, also POSTICHE [n -S]\n",
  "POSTIQUES": "POSTIQUE, (French) an imitation, also POSTICHE [n]\n",
  "POSTIRRADIATION": "taking place after irradiation [adj]\n",
  "POSTISCHEMIC": "following ischemia, an inadequate flow of blood to part of the body [adj]\n",
  "POSTISOLATION": "following a period of isolation [adj]\n",
  "POSTLANDING": "that takes place after landing [adj]\n",
  "POSTLAPSARIAN": "of, relating to, or characteristic of the time or state after the fall of humankind described in the Bible [adj]\n",
  "POSTLAUNCH": "following a launch [adj]\n",
  "POSTLIBERATION": "taking place after liberation [adj]\n",
  "POSTLIKE": "like a post [adj]\n",
  "POSTLIMINARY": "subsequent [adj]\n",
  "POSTLIMINIA": "POSTLIMINIUM, the right by which persons and property seized in war are restored to their former status on recovery, also POSTLIMINY [n]\n",
  "POSTLIMINIARY": "relating to postliminy, the right by which persons and property seized in war are restored to former status on recovery [adj]\n",
  "POSTLIMINIES": "POSTLIMINY, the right by which persons and property seized in war are restored to former status on recovery, also POSTLIMINIUM [n]\n",
  "POSTLIMINIOUS": "being by way of a supplement or appendix, also POSTLIMINOUS [adj]\n",
  "POSTLIMINIUM": "the right by which persons and property seized in war are restored to their former status on recovery, also POSTLIMINY [n POSTLIMINIA]\n",
  "POSTLIMINOUS": "being by way of a supplement or appendix, also POSTLIMINIOUS [adj]\n",
  "POSTLIMINY": "the right by which persons and property seized in war are restored to former status on recovery, also POSTLIMINIUM [n POSTLIMINIES]\n",
  "POSTLITERATE": "relating to or occurring after the introduction of the electronic media [adj]\n",
  "POSTLUDE": "a closing piece of music; esp. an organ voluntary at the end of a church service [n -S]\n",
  "POSTLUDES": "POSTLUDE, a closing piece of music; esp. an organ voluntary at the end of a church service [n]\n",
  "POSTMAN": "a mailman [n POSTMEN]\n",
  "POSTMARITAL": "taking place after marriage [adj]\n",
  "POSTMARK": "to stamp mail with an official mark [v -ED, -ING, -S]\n",
  "POSTMARKED": "POSTMARK, to stamp mail with an official mark [v]\n",
  "POSTMARKING": "POSTMARK, to stamp mail with an official mark [v]\n",
  "POSTMARKS": "POSTMARK, to stamp mail with an official mark [v]\n",
  "POSTMASTECTOMY": "taking place after a mastectomy [adj]\n",
  "POSTMASTER": "one who has charge of a station for the accommodation of travelers; one who supplies post horses [n -S]\n",
  "POSTMASTERS": "POSTMASTER, one who has charge of a station for the accommodation of travelers; one who supplies post horses [n]\n",
  "POSTMASTERSHIP": "the office of postmaster [n -S]\n",
  "POSTMASTERSHIPS": "POSTMASTERSHIP, the office of postmaster [n]\n",
  "POSTMATING": "that takes place after mating [adj]\n",
  "POSTMEDIEVAL": "taking place after the mediaeval period [adj]\n",
  "POSTMEN": "POSTMAN, a mailman [n]\n",
  "POSTMENOPAUSAL": "taking place after the menopause [adj]\n",
  "POSTMENSTRUAL": "following menstruation [adj]\n",
  "POSTMERIDIAN": "taking place after noon [adj]\n",
  "POSTMIDNIGHT": "taking place after midnight [adj]\n",
  "POSTMILLENARIAN": "a believer in postmillennialism [n]\n",
  "POSTMILLENNIAL": "coming after or relating to the period after the millennium [adj]\n",
  "POSTMISTRESS": "a woman who is a postmaster [n -ES]\n",
  "POSTMISTRESSES": "POSTMISTRESS, a woman who is a postmaster [n]\n",
  "POSTMODERN": "one belonging to an era after a modern one [n -S]\n",
  "POSTMODERNISM": "a movement succeeding modernism [n -S]\n",
  "POSTMODERNISMS": "POSTMODERNISM, a movement succeeding modernism [n]\n",
  "POSTMODERNIST": "a follower of postmodernism [n -S]\n",
  "POSTMODERNISTS": "POSTMODERNIST, a follower of postmodernism [n]\n",
  "POSTMODERNS": "POSTMODERN, one belonging to an era after a modern one [n]\n",
  "POSTMODIFIED": "POSTMODIFY, to modify the sense of (a word or phrase) by being placed after it [v]\n",
  "POSTMODIFIES": "POSTMODIFY, to modify the sense of (a word or phrase) by being placed after it [v]\n",
  "POSTMODIFY": "to modify the sense of (a word or phrase) by being placed after it [v POSTMODIFIED, POSTMODIFYING, POSTMODIFIES]\n",
  "POSTMODIFYING": "POSTMODIFY, to modify the sense of (a word or phrase) by being placed after it [v]\n",
  "POSTMORTEM": "a postmortem examination, an autopsy [n -S]\n",
  "POSTMORTEMS": "POSTMORTEM, a postmortem examination, an autopsy [n]\n",
  "POSTNASAL": "situated or occurring at the back of or behind the nose or nasal cavity [adj]\n",
  "POSTNATAL": "following childbirth [adj POSTNATALLY]\n",
  "POSTNATALLY": "POSTNATAL, following childbirth [adv]\n",
  "POSTNATI": "(Latin) those born after a specified event [n]\n",
  "POSTNEONATAL": "following a new birth [adj]\n",
  "POSTNUPTIAL": "made or occurring after marriage or mating [adj]\n",
  "POSTOCULAR": "a scale situated behind the eye of some lizards [n -S]\n",
  "POSTOCULARS": "POSTOCULAR, a scale situated behind the eye of some lizards [n]\n",
  "POSTOP": "a patient after undergoing a surgical operation [n -S]\n",
  "POSTOPERATIVE": "following a surgical operation [adj POSTOPERATIVELY]\n",
  "POSTOPERATIVELY": "POSTOPERATIVE, following a surgical operation [adv]\n",
  "POSTOPS": "POSTOP, a patient after undergoing a surgical operation [n]\n",
  "POSTORAL": "situated behind the mouth [adj]\n",
  "POSTORBITAL": "situated behind the eye [adj]\n",
  "POSTORGASMIC": "taking place after orgasm [adj]\n",
  "POSTPAID": "with the postage prepaid [adv]\n",
  "POSTPARTUM": "(Latin) relating to the period after childbirth [adj]\n",
  "POSTPERSON": "a postman or postwoman [n -S]\n",
  "POSTPERSONS": "POSTPERSON, a postman or postwoman [n]\n",
  "POSTPOLLINATION": "taking place after pollination [adj]\n",
  "POSTPONABLE": "that can be postponed [adj]\n",
  "POSTPONE": "to put off to a future time [v POSTPONED, POSTPONING, POSTPONES]\n",
  "POSTPONED": "POSTPONE, to put off to a future time [v]\n",
  "POSTPONEMENT": "the act of postponing [n -S]\n",
  "POSTPONEMENTS": "POSTPONEMENT, the act of postponing [n]\n",
  "POSTPONENCE": "the act of postponing [n -S]\n",
  "POSTPONENCES": "POSTPONENCE, the act of postponing [n]\n",
  "POSTPONER": "one who postpones [n -S]\n",
  "POSTPONERS": "POSTPONER, one who postpones [n]\n",
  "POSTPONES": "POSTPONE, to put off to a future time [v]\n",
  "POSTPONING": "POSTPONE, to put off to a future time [v]\n",
  "POSTPOSE": "to place after in a syntax of a sentence [v POSTPOSED, POSTPOSING, POSTPOSES]\n",
  "POSTPOSED": "POSTPOSE, to place after in a syntax of a sentence [v]\n",
  "POSTPOSES": "POSTPOSE, to place after in a syntax of a sentence [v]\n",
  "POSTPOSING": "POSTPOSE, to place after in a syntax of a sentence [v]\n",
  "POSTPOSITION": "the placing of a grammatical element after a word to which it is primarily related in a sentence [n -S]\n",
  "POSTPOSITIONAL": "relating to postposition [adj]\n",
  "POSTPOSITIONS": "POSTPOSITION, the placing of a grammatical element after a word to which it is primarily related in a sentence [n]\n",
  "POSTPOSITIVE": "of an adjective, placed after the word it modifies e.g. attorney general, Scrabble player manque [adj POSTPOSITIVELY] / a postpositive adjective [n -S]\n",
  "POSTPOSITIVELY": "POSTPOSITIVE, of an adjective, placed after the word it modifies e.g. attorney general, Scrabble player manque [adv]\n",
  "POSTPOSITIVES": "POSTPOSITIVE, a postpositive adjective [n]\n",
  "POSTPRANDIAL": "taking place after dinner [adj]\n",
  "POSTPRIMARY": "taking place after primary (election) [adj]\n",
  "POSTPRISON": "after release from prison [adj]\n",
  "POSTPRODUCTION": "the period following filming or taping in which a motion picture or television show is readied for public presentation [n -S]\n",
  "POSTPRODUCTIONS": "POSTPRODUCTION, the period following filming or taping in which a motion picture or television show is readied for public presentation [n]\n",
  "POSTPUBERTIES": "POSTPUBERTY, the period after puberty [n]\n",
  "POSTPUBERTY": "the period after puberty [n POSTPUBERTIES]\n",
  "POSTPUBESCENT": "someone of an age after pubescence. [n -S]\n",
  "POSTPUBESCENTS": "POSTPUBESCENT, someone of an age after pubescence. [n]\n",
  "POSTPUNK": "a follower or musician of the musical and cultural trend after punk [n -S]\n",
  "POSTPUNKS": "POSTPUNK, a follower or musician of the musical and cultural trend after punk [n]\n",
  "POSTRACE": "following a race [adj]\n",
  "POSTRECESSION": "following a recession [adj]\n",
  "POSTRETIREMENT": "following retirement [adj]\n",
  "POSTRIDER": "one who rides over a post road to carry the mails [n -S]\n",
  "POSTRIDERS": "POSTRIDER, one who rides over a post road to carry the mails [n]\n",
  "POSTRIOT": "following a riot [adj]\n",
  "POSTROMANTIC": "a follower of the cultural and artistic movement after Romanticism [n -S]\n",
  "POSTROMANTICS": "POSTROMANTIC, a follower of the cultural and artistic movement after Romanticism [n]\n",
  "POSTS": "POST, to display in a public place [v]\n",
  "POSTSCENIUM": "the part of the stage behind the scenery [n -S]\n",
  "POSTSCENIUMS": "POSTSCENIUM, the part of the stage behind the scenery [n]\n",
  "POSTSCRIPT": "a note or series of notes appended to a completed letter, article, or book [n -S]\n",
  "POSTSCRIPTS": "POSTSCRIPT, a note or series of notes appended to a completed letter, article, or book [n]\n",
  "POSTSEASON": "the time after the end of the season [n -S]\n",
  "POSTSEASONS": "POSTSEASON, the time after the end of the season [n]\n",
  "POSTSECONDARY": "taking place after secondary education [adj]\n",
  "POSTSHOW": "following a show [adj]\n",
  "POSTSTIMULATION": "taking place after stimulation [adj]\n",
  "POSTSTIMULATORY": "following stimulation [adj]\n",
  "POSTSTIMULUS": "following on a stimulus [adj]\n",
  "POSTSTRIKE": "after a strike [adj]\n",
  "POSTSURGICAL": "taking place after surgery [adj]\n",
  "POSTSYNAPTIC": "occurring after synapsis [adj]\n",
  "POSTSYNC": "(short for) postsynchronize, to add a soundtrack to a film after recording [v -ED, -ING, -S]\n",
  "POSTSYNCED": "POSTSYNC, (short for) postsynchronize, to add a soundtrack to a film after recording [v]\n",
  "POSTSYNCHRONISE": "to add sound, such as dubbing, to a film or video after shooting is completed, also POSTSYNCHRONIZE [v]\n",
  "POSTSYNCHRONIZE": "to add sound, such as dubbing, to a film or video after shooting is completed, also POSTSYNCHRONISE [v]\n",
  "POSTSYNCING": "POSTSYNC, (short for) postsynchronize, to add a soundtrack to a film after recording [v]\n",
  "POSTSYNCS": "POSTSYNC, (short for) postsynchronize, to add a soundtrack to a film after recording [v]\n",
  "POSTTAX": "occurring after taxation [adj]\n",
  "POSTTEEN": "occurring after one's teenage years [adj] / a young adult [n -S]\n",
  "POSTTEENS": "POSTTEEN, a young adult [n]\n",
  "POSTTENSION": "to apply tension to (reinforcing steel) after concrete has set [v -ED, -ING, -S]\n",
  "POSTTENSIONED": "POSTTENSION, to apply tension to (reinforcing steel) after concrete has set [v]\n",
  "POSTTENSIONING": "POSTTENSION, to apply tension to (reinforcing steel) after concrete has set [v]\n",
  "POSTTENSIONS": "POSTTENSION, to apply tension to (reinforcing steel) after concrete has set [v]\n",
  "POSTTEST": "a test given after an instructional programme [n -S]\n",
  "POSTTESTS": "POSTTEST, a test given after an instructional programme [n]\n",
  "POSTTRANSFUSION": "caused by transfused blood [adj]\n",
  "POSTTRAUMATIC": "taking place after trauma [adj]\n",
  "POSTTREATMENT": "any treatment given after an injury, incident, etc. [n -S]\n",
  "POSTTREATMENTS": "POSTTREATMENT, any treatment given after an injury, incident, etc. [n]\n",
  "POSTTRIAL": "taking place after a trial [adj]\n",
  "POSTTRUTH": "of or relating to a culture in which appeals to the emotions tend to prevail over facts and logical arguments [adj]\n",
  "POSTULANCIES": "POSTULANCY, the state or period of being a postulant [n]\n",
  "POSTULANCY": "the state or period of being a postulant [n POSTULANCIES]\n",
  "POSTULANT": "a candidate for a religious order [n -S]\n",
  "POSTULANTS": "POSTULANT, a candidate for a religious order [n]\n",
  "POSTULANTSHIP": "the office of postulant [n -S]\n",
  "POSTULANTSHIPS": "POSTULANTSHIP, the office of postulant [n]\n",
  "POSTULATA": "POSTULATUM, (Latin) a postulate [n]\n",
  "POSTULATE": "to assume or claim as true, existent, or necessary [v POSTULATED, POSTULATING, POSTULATES]\n",
  "POSTULATED": "POSTULATE, to assume or claim as true, existent, or necessary [v]\n",
  "POSTULATES": "POSTULATE, to assume or claim as true, existent, or necessary [v]\n",
  "POSTULATING": "POSTULATE, to assume or claim as true, existent, or necessary [v]\n",
  "POSTULATION": "the act of postulating [n -S]\n",
  "POSTULATIONAL": "of or like a postulate [adj POSTULATIONALLY]\n",
  "POSTULATIONALLY": "POSTULATIONAL, of or like a postulate [adv]\n",
  "POSTULATIONS": "POSTULATION, the act of postulating [n]\n",
  "POSTULATOR": "an official who presents case for canonization or beatification [n -S]\n",
  "POSTULATORS": "POSTULATOR, an official who presents case for canonization or beatification [n]\n",
  "POSTULATORY": "assuming or assumed as a postulate [adj]\n",
  "POSTULATUM": "(Latin) a postulate [n POSTULATA]\n",
  "POSTURAL": "pertaining to the position of the body [adj]\n",
  "POSTURE": "to assume a particular position [v POSTURED, POSTURING, POSTURES]\n",
  "POSTURED": "POSTURE, to assume a particular position [v]\n",
  "POSTURER": "one who postures, also POSTURIST [n -S]\n",
  "POSTURERS": "POSTURER, one who postures, also POSTURIST [n]\n",
  "POSTURES": "POSTURE, to assume a particular position [v]\n",
  "POSTURING": "the act of striking a pose [n -S]\n",
  "POSTURINGS": "POSTURING, the act of striking a pose [n]\n",
  "POSTURISE": "to posture, also POSTURIZE [v POSTURISED, POSTURISING, POSTURISES]\n",
  "POSTURISED": "POSTURISE, to posture, also POSTURIZE [v]\n",
  "POSTURISES": "POSTURISE, to posture, also POSTURIZE [v]\n",
  "POSTURISING": "POSTURISE, to posture, also POSTURIZE [v]\n",
  "POSTURIST": "one who postures, also POSTURER [n -S]\n",
  "POSTURISTS": "POSTURIST, one who postures, also POSTURER [n]\n",
  "POSTURIZE": "to posture, also POSTURISE [v POSTURIZED, POSTURIZING, POSTURIZES]\n",
  "POSTURIZED": "POSTURIZE, to posture, also POSTURISE [v]\n",
  "POSTURIZES": "POSTURIZE, to posture, also POSTURISE [v]\n",
  "POSTURIZING": "POSTURIZE, to posture, also POSTURISE [v]\n",
  "POSTVACCINAL": "taking place after vaccination [adj]\n",
  "POSTVACCINATION": "taking place after vaccination [adj]\n",
  "POSTVAGOTOMY": "following a vagotomy [adj]\n",
  "POSTVASECTOMY": "following a vasectomy [adj]\n",
  "POSTVIRAL": "as in postviral syndrome, a debilitating condition occurring as a sequel to viral illness [adj]\n",
  "POSTVOCALIC": "after a vowel [adj]\n",
  "POSTWAR": "occurring after the war [adj]\n",
  "POSTWEANING": "that takes place after weaning [adj]\n",
  "POSTWOMAN": "a female postman [n POSTWOMEN]\n",
  "POSTWOMEN": "POSTWOMAN, a female postman [n]\n",
  "POSTWORKSHOP": "taking place after a workshop [adj]\n",
  "POSY": "given to posing, also POSEY [adj POSIER, POSIEST] / a small bunch of flowers [n POSIES]\n",
  "POT": "to put into a round, deep container [v POTTED, POTTING, POTS]\n",
  "POTABILITIES": "POTABILITY, the state of being potable [n]\n",
  "POTABILITY": "the state of being potable [n POTABILITIES]\n",
  "POTABLE": "a liquid suitable for drinking [n -S]\n",
  "POTABLENESS": "the state of being potable [n -ES]\n",
  "POTABLENESSES": "POTABLENESS, the state of being potable [n]\n",
  "POTABLES": "POTABLE, a liquid suitable for drinking [n]\n",
  "POTAE": "(Maori) a hat [n -S]\n",
  "POTAES": "POTAE, (Maori) a hat [n]\n",
  "POTAGE": "(French) a thick soup or stew of vegetables and sometimes, meat, also POTTAGE [n -S]\n",
  "POTAGER": "(French) a decorative vegetable garden [n -S]\n",
  "POTAGERS": "POTAGER, (French) a decorative vegetable garden [n]\n",
  "POTAGES": "POTAGE, (French) a thick soup or stew of vegetables and sometimes, meat, also POTTAGE [n]\n",
  "POTALE": "refuse from a grain distillery [n -S]\n",
  "POTALES": "POTALE, refuse from a grain distillery [n]\n",
  "POTAMIC": "(Greek) of or relating to rivers [adj]\n",
  "POTAMOGETON": "a plant of the pondweed genus of water plants, with floating and submerged leaves [n -S]\n",
  "POTAMOGETONS": "POTAMOGETON, a plant of the pondweed genus of water plants, with floating and submerged leaves [n]\n",
  "POTAMOLOGICAL": "related to potamology [adj]\n",
  "POTAMOLOGIES": "POTAMOLOGY, the study of rivers [n]\n",
  "POTAMOLOGIST": "one who studies rivers [n -S]\n",
  "POTAMOLOGISTS": "POTAMOLOGIST, one who studies rivers [n]\n",
  "POTAMOLOGY": "the study of rivers [n POTAMOLOGIES]\n",
  "POTASH": "a powerful alkali, potassium carbonate, also POTASS [n -ES] / to treat with potash [v -ED, -ING, -ES]\n",
  "POTASHED": "POTASH, to treat with potash [v]\n",
  "POTASHES": "POTASH, to treat with potash [v]\n",
  "POTASHING": "POTASH, to treat with potash [v]\n",
  "POTASS": "a powerful alkali, also POTASH [n -ES]\n",
  "POTASSA": "a powerful alkali [n -S]\n",
  "POTASSAS": "POTASSA, a powerful alkali [n]\n",
  "POTASSES": "POTASS, a powerful alkali, also POTASH [n]\n",
  "POTASSIC": "relating to potassium [adj]\n",
  "POTASSIUM": "a silvery alkaline metallic element [n -S]\n",
  "POTASSIUMS": "POTASSIUM, a silvery alkaline metallic element [n]\n",
  "POTATION": "the act of drinking [n -S]\n",
  "POTATIONS": "POTATION, the act of drinking [n]\n",
  "POTATO": "the edible tuber of a cultivated plant [n -ES]\n",
  "POTATOBUG": "the Colorado beetle [n -S]\n",
  "POTATOBUGS": "POTATOBUG, the Colorado beetle [n]\n",
  "POTATOES": "POTATO, the edible tuber of a cultivated plant [n]\n",
  "POTATORY": "pertaining to (excessive) drinking [adj]\n",
  "POTBELLIED": "having a potbelly [adj]\n",
  "POTBELLIES": "POTBELLY, a protruding abdomen [n]\n",
  "POTBELLY": "a protruding abdomen [n POTBELLIES]\n",
  "POTBOIL": "to produce an artistic work of poor quality [v -ED, -ING, -S]\n",
  "POTBOILED": "POTBOIL, to produce an artistic work of poor quality [v]\n",
  "POTBOILER": "a work in art or literature produced merely with regard to saleability [n -S]\n",
  "POTBOILERS": "POTBOILER, a work in art or literature produced merely with regard to saleability [n]\n",
  "POTBOILING": "the act of producing an artistic work of poor quality [n -S]\n",
  "POTBOILINGS": "POTBOILING, the act of producing an artistic work of poor quality [n]\n",
  "POTBOILS": "POTBOIL, to produce an artistic work of poor quality [v]\n",
  "POTBOUND": "of a plant, having roots which have grown to fill the pot [adj]\n",
  "POTBOY": "one who collects up empty glasses in a tavern [n -S]\n",
  "POTBOYS": "POTBOY, one who collects up empty glasses in a tavern [n]\n",
  "POTCH": "(Yiddish) to push violently, thrust, also POTCHE [v -ED, -ING, -ES]\n",
  "POTCHE": "(Yiddish) to push violently, thrust, also POTCH [v POTCHED, POTCHING, POTCHES]\n",
  "POTCHED": "POTCH, (Yiddish) to push violently, thrust, also POTCHE [v]\n",
  "POTCHER": "a machine that breaks and bleaches pulp [n -S]\n",
  "POTCHERS": "POTCHER, a machine that breaks and bleaches pulp [n]\n",
  "POTCHES": "POTCHE, (Yiddish) to push violently, thrust, also POTCH [v]\n",
  "POTCHING": "POTCHE, (Yiddish) to push violently, thrust, also POTCH [v]\n",
  "POTE": "to poke, thrust [v POTED, POTING, POTES]\n",
  "POTED": "POTE, to poke, thrust [v]\n",
  "POTEEN": "(Irish) Irish whiskey distilled unlawfully, also POTHEEN, POTTEEN, POITIN [n -S]\n",
  "POTEENS": "POTEEN, (Irish) Irish whiskey distilled unlawfully, also POTHEEN, POTTEEN, POITIN [n]\n",
  "POTENCE": "the quality of being potent, also POTENCY [n -S]\n",
  "POTENCES": "POTENCE, the quality of being potent, also POTENCY [n]\n",
  "POTENCIES": "POTENCY, the quality of being potent, also POTENCE [n]\n",
  "POTENCY": "the quality of being potent, also POTENCE [n POTENCIES]\n",
  "POTENT": "powerful [adj POTENTLY] / (obsolete) a crutch with a crosspiece fitting under the arm [n -S]\n",
  "POTENTATE": "a powerful ruler; a monarch [n -S]\n",
  "POTENTATES": "POTENTATE, a powerful ruler; a monarch [n]\n",
  "POTENTIAL": "latent, possible or likely [adj POTENTIALLY] / powers or resources not yet developed or made use of [n -S]\n",
  "POTENTIALITIES": "POTENTIALITY, the ability to develop or come into existence [n]\n",
  "POTENTIALITY": "the ability to develop or come into existence [n POTENTIALITIES]\n",
  "POTENTIALLY": "POTENTIAL, latent, possible or likely [adv]\n",
  "POTENTIALS": "POTENTIAL, powers or resources not yet developed or made use of [n]\n",
  "POTENTIARIES": "POTENTIARY, a person invested with power and influence [n]\n",
  "POTENTIARY": "a person invested with power and influence [n POTENTIARIES]\n",
  "POTENTIATE": "to use drugs in combination to increase their power [v POTENTIATED, POTENTIATING, POTENTIATES]\n",
  "POTENTIATED": "POTENTIATE, to use drugs in combination to increase their power [v]\n",
  "POTENTIATES": "POTENTIATE, to use drugs in combination to increase their power [v]\n",
  "POTENTIATING": "POTENTIATE, to use drugs in combination to increase their power [v]\n",
  "POTENTIATION": "the act of potentiating [n -S]\n",
  "POTENTIATIONS": "POTENTIATION, the act of potentiating [n]\n",
  "POTENTIATOR": "one who potentiates [n -S]\n",
  "POTENTIATORS": "POTENTIATOR, one who potentiates [n]\n",
  "POTENTILLA": "any of various chiefly yellow-flowered plants of the genus Potentilla [n -S]\n",
  "POTENTILLAS": "POTENTILLA, any of various chiefly yellow-flowered plants of the genus Potentilla [n]\n",
  "POTENTIOMETER": "an instrument for measuring electromotive forces [n -S]\n",
  "POTENTIOMETERS": "POTENTIOMETER, an instrument for measuring electromotive forces [n]\n",
  "POTENTIOMETRIC": "relating to measurement by potentiometer, an instrument for measuring electromotive forces [adj]\n",
  "POTENTIOMETRIES": "POTENTIOMETRY, the measurement of the potential difference of electromotive force [n]\n",
  "POTENTIOMETRY": "the measurement of the potential difference of electromotive force [n POTENTIOMETRIES]\n",
  "POTENTISE": "to render the latent power of (anything) available, also POTENTIZE [v POTENTISED, POTENTISING, POTENTISES]\n",
  "POTENTISED": "POTENTISE, to render the latent power of (anything) available, also POTENTIZE [v]\n",
  "POTENTISES": "POTENTISE, to render the latent power of (anything) available, also POTENTIZE [v]\n",
  "POTENTISING": "POTENTISE, to render the latent power of (anything) available, also POTENTIZE [v]\n",
  "POTENTIZE": "to render the latent power of (anything) available, also POTENTISE [v POTENTIZED, POTENTIZING, POTENTIZES]\n",
  "POTENTIZED": "POTENTIZE, to render the latent power of (anything) available, also POTENTISE [v]\n",
  "POTENTIZES": "POTENTIZE, to render the latent power of (anything) available, also POTENTISE [v]\n",
  "POTENTIZING": "POTENTIZE, to render the latent power of (anything) available, also POTENTISE [v]\n",
  "POTENTLY": "POTENT, powerful [adv]\n",
  "POTENTNESS": "the state of being potent [n -ES]\n",
  "POTENTNESSES": "POTENTNESS, the state of being potent [n]\n",
  "POTENTS": "POTENT, (obsolete) a crutch with a crosspiece fitting under the arm [n]\n",
  "POTES": "POTE, to poke, thrust [v]\n",
  "POTFUL": "as much as a pot can hold [n -S]\n",
  "POTFULS": "POTFUL, as much as a pot can hold [n]\n",
  "POTGUN": "a pot-shaped cannon; a mortar [n -S]\n",
  "POTGUNS": "POTGUN, a pot-shaped cannon; a mortar [n]\n",
  "POTHEAD": "one who smokes marijuana [n -S]\n",
  "POTHEADS": "POTHEAD, one who smokes marijuana [n]\n",
  "POTHECARIES": "POTHECARY, an apothecary, also APOTHECARY, POTICARY, POTTINGAR [n]\n",
  "POTHECARY": "an apothecary, also APOTHECARY, POTICARY, POTTINGAR [n POTHECARIES]\n",
  "POTHEEN": "(Irish) illicitly distilled Irish whisky, also POITIN, POTEEN, POTTEEN [n -S]\n",
  "POTHEENS": "POTHEEN, (Irish) illicitly distilled Irish whisky, also POITIN, POTEEN, POTTEEN [n]\n",
  "POTHER": "to make a commotion [v -ED, -ING, -S]\n",
  "POTHERB": "any herb used as a seasoning [n -S]\n",
  "POTHERBS": "POTHERB, any herb used as a seasoning [n]\n",
  "POTHERED": "POTHER, to make a commotion [v]\n",
  "POTHERIER": "POTHERY, confused, in turmoil [adj]\n",
  "POTHERIEST": "POTHERY, confused, in turmoil [adj]\n",
  "POTHERING": "POTHER, to make a commotion [v]\n",
  "POTHERS": "POTHER, to make a commotion [v]\n",
  "POTHERY": "confused, in turmoil [adj POTHERIER, POTHERIEST]\n",
  "POTHOLDER": "a piece of material used to protect the hands while lifting a pot from the oven [n -S]\n",
  "POTHOLDERS": "POTHOLDER, a piece of material used to protect the hands while lifting a pot from the oven [n]\n",
  "POTHOLE": "a hole or basin cut into bedrock of a stream by the abrasive action of pebbles and sand [n -S] / to explore (limestone potholes) [v POTHOLED, POTHOLING, POTHOLES]\n",
  "POTHOLED": "POTHOLE, to explore (limestone potholes) [v]\n",
  "POTHOLER": "someone who explores limestone potholes [n -S]\n",
  "POTHOLERS": "POTHOLER, someone who explores limestone potholes [n]\n",
  "POTHOLES": "POTHOLE, to explore (limestone potholes) [v]\n",
  "POTHOLING": "the sport of exploring potholes [n -S]\n",
  "POTHOLINGS": "POTHOLING, the sport of exploring potholes [n]\n",
  "POTHOOK": "a hook on which to hang a pot [n -S]\n",
  "POTHOOKS": "POTHOOK, a hook on which to hang a pot [n]\n",
  "POTHOS": "a climbing plant [n -ES]\n",
  "POTHOSES": "POTHOS, a climbing plant [n]\n",
  "POTHOUSE": "an alehouse [n -S]\n",
  "POTHOUSES": "POTHOUSE, an alehouse [n]\n",
  "POTHUNTER": "someone who hunts for the pot; someone who competes merely to get trophies [n -S]\n",
  "POTHUNTERS": "POTHUNTER, someone who hunts for the pot; someone who competes merely to get trophies [n]\n",
  "POTHUNTING": "going round to athletic meetings to win trophies [n -S]\n",
  "POTHUNTINGS": "POTHUNTING, going round to athletic meetings to win trophies [n]\n",
  "POTICARIES": "POTICARY, an apothecary, a druggist [n]\n",
  "POTICARY": "an apothecary, a druggist [n POTICARIES]\n",
  "POTICHE": "(French) a round or polygonal jar, tapering at the neck, with a removable cover [n -S]\n",
  "POTICHES": "POTICHE, (French) a round or polygonal jar, tapering at the neck, with a removable cover [n]\n",
  "POTICHOMANIA": "a craze for imitating Oriental porcelain [n -S]\n",
  "POTICHOMANIAS": "POTICHOMANIA, a craze for imitating Oriental porcelain [n]\n",
  "POTIN": "(French) an old alloy of copper, zinc, lead and tin [n -S]\n",
  "POTING": "POTE, to poke, thrust [v]\n",
  "POTINS": "POTIN, (French) an old alloy of copper, zinc, lead and tin [n]\n",
  "POTION": "a magical elixir or medicinal drink [n -S]\n",
  "POTIONS": "POTION, a magical elixir or medicinal drink [n]\n",
  "POTJIE": "(South African) a three-legged iron pot used for cooking over a wood fire [n -S]\n",
  "POTJIES": "POTJIE, (South African) a three-legged iron pot used for cooking over a wood fire [n]\n",
  "POTLACH": "(Native American) a social event or celebration which features reciprocal gift-giving, also POTLACHE, POTLATCH [n -ES]\n",
  "POTLACHE": "(Native American) a social event or celebration which features reciprocal gift-giving, also POTLACH, POTLATCH [n -S]\n",
  "POTLACHES": "POTLACH, (Native American) a social event or celebration which features reciprocal gift-giving, also POTLACHE, POTLATCH [n]\n",
  "POTLATCH": "(Native American) a social event or celebration which features reciprocal gift-giving, also POTLACH, POTLACHE [n -ES] / to exchange gifts [v -ED, -ING, -ES]\n",
  "POTLATCHED": "POTLATCH, to exchange gifts [v]\n",
  "POTLATCHES": "POTLATCH, to exchange gifts [v]\n",
  "POTLATCHING": "POTLATCH, to exchange gifts [v]\n",
  "POTLIKE": "resembling a pot [adj]\n",
  "POTLINE": "a row of electrolytic cells [n -S]\n",
  "POTLINES": "POTLINE, a row of electrolytic cells [n]\n",
  "POTLUCK": "whatever may chance to be in the pot, or may be provided for a meal [n -S]\n",
  "POTLUCKS": "POTLUCK, whatever may chance to be in the pot, or may be provided for a meal [n]\n",
  "POTMAN": "a man who serves customers in a tavern [n POTMEN]\n",
  "POTMEN": "POTMAN, a man who serves customers in a tavern [n]\n",
  "POTOMETER": "an instrument measuring the rate at which plants absorb water [n -S]\n",
  "POTOMETERS": "POTOMETER, an instrument measuring the rate at which plants absorb water [n]\n",
  "POTOO": "a kind of bird, a large South American goatsucker [n -S]\n",
  "POTOOS": "POTOO, a kind of bird, a large South American goatsucker [n]\n",
  "POTOROO": "(Native Australian) a kind of small kangaroo, aka kangaroo rat [n -S]\n",
  "POTOROOS": "POTOROO, (Native Australian) a kind of small kangaroo, aka kangaroo rat [n]\n",
  "POTPIE": "a meat pie which is boiled instead of being baked [n -S]\n",
  "POTPIES": "POTPIE, a meat pie which is boiled instead of being baked [n]\n",
  "POTPOURRI": "(French) a mixture of dried petals [n -S]\n",
  "POTPOURRIS": "POTPOURRI, (French) a mixture of dried petals [n]\n",
  "POTS": "POT, to put into a round, deep container [v]\n",
  "POTSHARD": "a fragment of broken pottery, also POTSHERD, POTSHARE [n -S]\n",
  "POTSHARDS": "POTSHARD, a fragment of broken pottery, also POTSHERD, POTSHARE [n]\n",
  "POTSHARE": "a fragment of broken pottery, also POTSHERD, POTSHARD [n -S]\n",
  "POTSHARES": "POTSHARE, a fragment of broken pottery, also POTSHERD, POTSHARD [n]\n",
  "POTSHERD": "a fragment of broken pottery, also POTSHARD, POTSHARE [n -S]\n",
  "POTSHERDS": "POTSHERD, a fragment of broken pottery, also POTSHARD, POTSHARE [n]\n",
  "POTSHOP": "a small public house [n -S]\n",
  "POTSHOPS": "POTSHOP, a small public house [n]\n",
  "POTSHOT": "to shoot randomly at [v POTSHOT, POTSHOTTING, POTSHOTS]\n",
  "POTSHOTS": "POTSHOT, to shoot randomly at [v]\n",
  "POTSHOTTING": "the act of taking a potshot [n -S]\n",
  "POTSHOTTINGS": "POTSHOTTING, the act of taking a potshot [n]\n",
  "POTSIE": "a children's game, also POTSY [n -S]\n",
  "POTSIES": "POTSY, a children's game, also POTSIE [n]\n",
  "POTSTONE": "a variety of steatite sometimes manufactured into culinary vessels [n -S]\n",
  "POTSTONES": "POTSTONE, a variety of steatite sometimes manufactured into culinary vessels [n]\n",
  "POTSY": "a children's game, also POTSIE [n POTSIES]\n",
  "POTT": "a size of paper [n -S]\n",
  "POTTABLE": "capable of being potted [adj]\n",
  "POTTAGE": "a thick soup or stew of vegetables and sometimes, meat, also POTAGE [n -S]\n",
  "POTTAGES": "POTTAGE, a thick soup or stew of vegetables and sometimes, meat, also POTAGE [n]\n",
  "POTTED": "POT, to put into a round, deep container [v]\n",
  "POTTEEN": "(Irish) illicitly distilled Irish whisky, also POITIN, POTEEN, POTHEEN [n -S]\n",
  "POTTEENS": "POTTEEN, (Irish) illicitly distilled Irish whisky, also POITIN, POTEEN, POTHEEN [n]\n",
  "POTTER": "to occupy oneself in a leisurely or ineffective manner, also PUTTER [v -ED, -ING, -S]\n",
  "POTTERED": "POTTER, to occupy oneself in a leisurely or ineffective manner, also PUTTER [v]\n",
  "POTTERER": "one who potters [n -S]\n",
  "POTTERERS": "POTTERER, one who potters [n]\n",
  "POTTERIES": "POTTERY, articles moulded from clay and hardened by heat [n]\n",
  "POTTERING": "busying oneself with trifling tasks [adj POTTERINGLY] / the act of pottering [n -S]\n",
  "POTTERINGLY": "POTTERING, busying oneself with trifling tasks [adv]\n",
  "POTTERINGS": "POTTERING, the act of pottering [n]\n",
  "POTTERS": "POTTER, to occupy oneself in a leisurely or ineffective manner, also PUTTER [v]\n",
  "POTTERY": "articles moulded from clay and hardened by heat [n POTTERIES]\n",
  "POTTIER": "POTTY, crazy [adj]\n",
  "POTTIES": "POTTY, a chamberpot, esp. a small easily portable one for use by a young child [n]\n",
  "POTTIEST": "POTTY, crazy [adj]\n",
  "POTTINESS": "daftness [n -ES]\n",
  "POTTINESSES": "POTTINESS, daftness [n]\n",
  "POTTING": "POT, to put into a round, deep container [v]\n",
  "POTTINGAR": "(Scots) an apothecary, also POTHECARY, POTICARY [n -S]\n",
  "POTTINGARS": "POTTINGAR, (Scots) an apothecary, also POTHECARY, POTICARY [n]\n",
  "POTTINGER": "a small dish for soup or porridge, also PORRENGER, PORRINGER [n -S]\n",
  "POTTINGERS": "POTTINGER, a small dish for soup or porridge, also PORRENGER, PORRINGER [n]\n",
  "POTTLE": "a small conical fruit basket [n -S]\n",
  "POTTLES": "POTTLE, a small conical fruit basket [n]\n",
  "POTTO": "a nocturnal mammal of the lemur family, found in West Africa [n -S]\n",
  "POTTOS": "POTTO, a nocturnal mammal of the lemur family, found in West Africa [n]\n",
  "POTTS": "POTT, a size of paper [n]\n",
  "POTTY": "crazy [adj POTTIER, POTTIEST] / a chamberpot, esp. a small easily portable one for use by a young child [n POTTIES]\n",
  "POTTYMOUTH": "one given to habitual use of bad language [n -S]\n",
  "POTTYMOUTHS": "POTTYMOUTH, one given to habitual use of bad language [n]\n",
  "POTWALLER": "a man entitled to the franchise before 1832 by virtue of possessing his own fireplace [n -S]\n",
  "POTWALLERS": "POTWALLER, a man entitled to the franchise before 1832 by virtue of possessing his own fireplace [n]\n",
  "POTZER": "(German) an inept chess player, also PATZER [n -S]\n",
  "POTZERS": "POTZER, (German) an inept chess player, also PATZER [n]\n",
  "POUCH": "a pocket, purse [n -ES] / to put in a pocket-like receptacle [v -ED, -ING, -ES]\n",
  "POUCHED": "POUCH, to put in a pocket-like receptacle [v]\n",
  "POUCHES": "POUCH, to put in a pocket-like receptacle [v]\n",
  "POUCHFUL": "as much as a pouch can hold [n -S]\n",
  "POUCHFULS": "POUCHFUL, as much as a pouch can hold [n]\n",
  "POUCHIER": "POUCHY, resembling a pouch [adj]\n",
  "POUCHIEST": "POUCHY, resembling a pouch [adj]\n",
  "POUCHING": "POUCH, to put in a pocket-like receptacle [v]\n",
  "POUCHLIKE": "like a pouch [adj]\n",
  "POUCHY": "resembling a pouch [adj POUCHIER, POUCHIEST]\n",
  "POUDER": "(obsolete) powder, also POUDRE, POULDER, POULDRE, POUTHER [n -S]\n",
  "POUDERS": "POUDER, (obsolete) powder, also POUDRE, POULDER, POULDRE, POUTHER [n]\n",
  "POUDRE": "(obsolete) powder, also POUDER, POULDER, POULDRE, POUTHER [n -S]\n",
  "POUDRES": "POUDRE, (obsolete) powder, also POUDER, POULDER, POULDRE, POUTHER [n]\n",
  "POUF": "to give a puffed shape to the hair, also POUFF, POUFFE [v -ED, -ING, -S]\n",
  "POUFED": "POUF, to give a puffed shape to the hair, also POUFF, POUFFE [v]\n",
  "POUFF": "to give a puffed shape to the hair, also POUF, POUFFE [v -ED, -ING, -S]\n",
  "POUFFE": "to give a puffed shape to the hair, also POUF, POUFF [v POUFFED, POUFFING, POUFFES]\n",
  "POUFFED": "POUFFE, to give a puffed shape to the hair, also POUF, POUFF [v]\n",
  "POUFFES": "POUFFE, to give a puffed shape to the hair, also POUF, POUFF [v]\n",
  "POUFFIER": "POUFFY, like a pouf, a loose roll of hair [adj]\n",
  "POUFFIEST": "POUFFY, like a pouf, a loose roll of hair [adj]\n",
  "POUFFING": "POUFFE, to give a puffed shape to the hair, also POUF, POUFF [v]\n",
  "POUFFS": "POUFF, to give a puffed shape to the hair, also POUF, POUFFE [v]\n",
  "POUFFY": "like a pouf, a loose roll of hair [adj POUFFIER, POUFFIEST]\n",
  "POUFING": "POUF, to give a puffed shape to the hair, also POUFF, POUFFE [v]\n",
  "POUFS": "POUF, to give a puffed shape to the hair, also POUFF, POUFFE [v]\n",
  "POUFTAH": "(offensive) a male homosexual, also POOF, POOVE, POOFTER, POUFTER [n -S]\n",
  "POUFTAHS": "POUFTAH, (offensive) a male homosexual, also POOF, POOVE, POOFTER, POUFTER [n]\n",
  "POUFTER": "(offensive) a male homosexual, also POOF, POOVE, POOFTER, POOFTAH, POUFTAH [n -S]\n",
  "POUFTERS": "POUFTER, (offensive) a male homosexual, also POOF, POOVE, POOFTER, POOFTAH, POUFTAH [n]\n",
  "POUK": "(Scots) to pluck, pinch, also POOK [v POUKIT, POUKING, POUKS]\n",
  "POUKE": "a mischievous sprite, also PUCK [n -S]\n",
  "POUKES": "POUKE, a mischievous sprite, also PUCK [n]\n",
  "POUKING": "POUK, (Scots) to pluck, pinch, also POOK [v]\n",
  "POUKIT": "POUK, (Scots) to pluck, pinch, also POOK [v]\n",
  "POUKS": "POUK, (Scots) to pluck, pinch, also POOK [v]\n",
  "POULAINE": "a pointy toed shoe as worn by jesters [n -S]\n",
  "POULAINES": "POULAINE, a pointy toed shoe as worn by jesters [n]\n",
  "POULARD": "(French) a spayed hen, also POULARDE [n -S]\n",
  "POULARDE": "(French) a spayed hen, also POULARD [n -S]\n",
  "POULARDES": "POULARDE, (French) a spayed hen, also POULARD [n]\n",
  "POULARDS": "POULARD, (French) a spayed hen, also POULARDE [n]\n",
  "POULDER": "(obsolete) powder, also POUDER, POUDRE, POULDRE, POUTHER [n -S]\n",
  "POULDERS": "POULDER, (obsolete) powder, also POUDER, POUDRE, POULDRE, POUTHER [n]\n",
  "POULDRE": "(obsolete) powder, also POUDER, POUDRE, POULDER, POUTHER [n -S]\n",
  "POULDRES": "POULDRE, (obsolete) powder, also POUDER, POUDRE, POULDER, POUTHER [n]\n",
  "POULDRON": "a shoulder-plate of a suit of armour, also PAULDRON, PULDRON [n -S]\n",
  "POULDRONS": "POULDRON, a shoulder-plate of a suit of armour, also PAULDRON, PULDRON [n]\n",
  "POULE": "(French) a hen, esp. a chicken for boiling [n -S]\n",
  "POULES": "POULE, (French) a hen, esp. a chicken for boiling [n]\n",
  "POULP": "the octopus, also POLYP, POLYPE, POULPE [n -S]\n",
  "POULPE": "(French) the octopus, also POLYP, POLYPE, POULP [n -S]\n",
  "POULPES": "POULPE, (French) the octopus, also POLYP, POLYPE, POULP [n]\n",
  "POULPS": "POULP, the octopus, also POLYP, POLYPE, POULPE [n]\n",
  "POULT": "a young domestic fowl [n -S]\n",
  "POULTER": "(archaic) a dealer in dead fowls and game, also POULTERER [n -S]\n",
  "POULTERER": "a dealer in dead fowls and game, also POULTER [n -S]\n",
  "POULTERERS": "POULTERER, a dealer in dead fowls and game, also POULTER [n]\n",
  "POULTERS": "POULTER, (archaic) a dealer in dead fowls and game, also POULTERER [n]\n",
  "POULTICE": "to apply a hot, healing substance [v POULTICED, POULTICING, POULTICES]\n",
  "POULTICED": "POULTICE, to apply a hot, healing substance [v]\n",
  "POULTICES": "POULTICE, to apply a hot, healing substance [v]\n",
  "POULTICING": "POULTICE, to apply a hot, healing substance [v]\n",
  "POULTRIES": "POULTRY, farmyard fowls collectively [n]\n",
  "POULTROONE": "(Shakespeare) a poltroon, also POLTROON [n -S]\n",
  "POULTROONES": "POULTROONE, (Shakespeare) a poltroon, also POLTROON [n]\n",
  "POULTRY": "farmyard fowls collectively [n POULTRIES]\n",
  "POULTRYMAN": "one who keeps poultry [n POULTRYMEN]\n",
  "POULTRYMEN": "POULTRYMAN, one who keeps poultry [n]\n",
  "POULTS": "POULT, a young domestic fowl [n]\n",
  "POUNCE": "to swoop upon suddenly [v POUNCED, POUNCING, POUNCES]\n",
  "POUNCED": "POUNCE, to swoop upon suddenly [v]\n",
  "POUNCER": "one that pounces [n -S]\n",
  "POUNCERS": "POUNCER, one that pounces [n]\n",
  "POUNCES": "POUNCE, to swoop upon suddenly [v]\n",
  "POUNCET": "(Shakespeare) a box with a perforated lid, for sprinkling pounce, or for holding perfumes [n -S]\n",
  "POUNCETS": "POUNCET, (Shakespeare) a box with a perforated lid, for sprinkling pounce, or for holding perfumes [n]\n",
  "POUNCHING": "(Spenser) punching [v]\n",
  "POUNCING": "POUNCE, to swoop upon suddenly [v]\n",
  "POUND": "to strike heavily and repeatedly [v -ED, -ING, -S]\n",
  "POUNDAGE": "a charge for keeping stray cattle [n -S]\n",
  "POUNDAGES": "POUNDAGE, a charge for keeping stray cattle [n]\n",
  "POUNDAL": "a unit of force, the force imparting to one pound mass an acceleration of one foot per second [n -S]\n",
  "POUNDALS": "POUNDAL, a unit of force, the force imparting to one pound mass an acceleration of one foot per second [n]\n",
  "POUNDCAKE": "a sweet rich cake containing a pound of each chief ingredient [n -S]\n",
  "POUNDCAKES": "POUNDCAKE, a sweet rich cake containing a pound of each chief ingredient [n]\n",
  "POUNDED": "POUND, to strike heavily and repeatedly [v]\n",
  "POUNDER": "a specimen weighing a pound [n -S]\n",
  "POUNDERS": "POUNDER, a specimen weighing a pound [n]\n",
  "POUNDING": "the act of striking heavily and repeatedly [n -S]\n",
  "POUNDINGS": "POUNDING, the act of striking heavily and repeatedly [n]\n",
  "POUNDS": "POUND, to strike heavily and repeatedly [v]\n",
  "POUPE": "(obsolete) to befool, to cozen, also POOP [v POUPED or POUPT, POUPING, POUPES]\n",
  "POUPED": "POUPE, (obsolete) to befool, to cozen, also POOP [v]\n",
  "POUPES": "POUPE, (obsolete) to befool, to cozen, also POOP [v]\n",
  "POUPING": "POUPE, (obsolete) to befool, to cozen, also POOP [v]\n",
  "POUPT": "POUPE, (obsolete) to befool, to cozen, also POOP [v]\n",
  "POUR": "to cause to flow [v -ED, -ING, -S]\n",
  "POURABLE": "able to be poured [adj]\n",
  "POURBOIRE": "(French) a tip, gratuity [n -S]\n",
  "POURBOIRES": "POURBOIRE, (French) a tip, gratuity [n]\n",
  "POURED": "POUR, to cause to flow [v]\n",
  "POURER": "one who pours [n -S]\n",
  "POURERS": "POURER, one who pours [n]\n",
  "POURIE": "(Scots) a container with a spout, a cream-jug [n -S]\n",
  "POURIES": "POURIE, (Scots) a container with a spout, a cream-jug [n]\n",
  "POURING": "of rain, very heavy [adj POURINGLY] / the act of pouring [n -S]\n",
  "POURINGLY": "POURING, of rain, very heavy [adv]\n",
  "POURINGS": "POURING, the act of pouring [n]\n",
  "POURPARLER": "(French) a discussion prior to negotiation [n -S]\n",
  "POURPARLERS": "POURPARLER, (French) a discussion prior to negotiation [n]\n",
  "POURPOINT": "(French) a mediaeval quilted doublet [n -S]\n",
  "POURPOINTS": "POURPOINT, (French) a mediaeval quilted doublet [n]\n",
  "POURS": "POUR, to cause to flow [v]\n",
  "POURSEW": "(Spenser) to pursue, also PURSUE, PERSUE, POURSUE, PURSEW [v -ED, -ING, -S]\n",
  "POURSEWED": "POURSEW, (Spenser) to pursue, also PURSUE, PERSUE, POURSUE, PURSEW [v]\n",
  "POURSEWING": "POURSEW, (Spenser) to pursue, also PURSUE, PERSUE, POURSUE, PURSEW [v]\n",
  "POURSEWS": "POURSEW, (Spenser) to pursue, also PURSUE, PERSUE, POURSUE, PURSEW [v]\n",
  "POURSUE": "(Spenser) to pursue, also PERSUE, POURSEW, PURSEW [v POURSUED, POURSUING, POURSUES]\n",
  "POURSUED": "POURSUE, (Spenser) to pursue, also PERSUE, POURSEW, PURSEW [v]\n",
  "POURSUES": "POURSUE, (Spenser) to pursue, also PERSUE, POURSEW, PURSEW [v]\n",
  "POURSUING": "POURSUE, (Spenser) to pursue, also PERSUE, POURSEW, PURSEW [v]\n",
  "POURSUIT": "(Spenser) pursuit [n -S]\n",
  "POURSUITS": "POURSUIT, (Spenser) pursuit [n]\n",
  "POURTRAHED": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "POURTRAICT": "(obsolete) a portrait [n -S]\n",
  "POURTRAICTS": "POURTRAICT, (obsolete) a portrait [n]\n",
  "POURTRAY": "(Spenser) to portray, also PORTRAY [v POURTRAYED or POURTRAYD or POURTRAHED, POURTRAYING, POURTRAYS]\n",
  "POURTRAYD": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "POURTRAYED": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "POURTRAYING": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "POURTRAYS": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "POUSADA": "(Portuguese) a traditional hotel in Portugal or Portuguese speaking countries [n -S]\n",
  "POUSADAS": "POUSADA, (Portuguese) a traditional hotel in Portugal or Portuguese speaking countries [n]\n",
  "POUSOWDIE": "(Scots) any mixture of heterogeneous kinds of food, also POWSOWDY [n -S]\n",
  "POUSOWDIES": "POUSOWDIE, (Scots) any mixture of heterogeneous kinds of food, also POWSOWDY [n]\n",
  "POUSSE": "(Spenser) pease [n -S]\n",
  "POUSSES": "POUSSE, (Spenser) pease [n]\n",
  "POUSSETTE": "(French) a movement, or part of a figure, in the contradance [n -S] / to make such a movement [v POUSSETTED, POUSSETTING, POUSSETTES]\n",
  "POUSSETTED": "POUSSETTE, to make such a movement [v]\n",
  "POUSSETTES": "POUSSETTE, (French) a movement, or part of a figure, in the contradance [n]\n",
  "POUSSETTING": "POUSSETTE, to make such a movement [v]\n",
  "POUSSIE": "a familiar name for a cat, also PUSSY [n -S]\n",
  "POUSSIES": "POUSSIE, a familiar name for a cat, also PUSSY [n]\n",
  "POUSSIN": "(French) a chicken raised for eating at around six weeks old [n -S]\n",
  "POUSSINS": "POUSSIN, (French) a chicken raised for eating at around six weeks old [n]\n",
  "POUT": "to protrude the lips in ill humour [v -ED, -ING, -S]\n",
  "POUTASSOU": "a gadoid fish, aka blue whiting [n -S]\n",
  "POUTASSOUS": "POUTASSOU, a gadoid fish, aka blue whiting [n]\n",
  "POUTED": "POUT, to protrude the lips in ill humour [v]\n",
  "POUTER": "a variety of pigeon that can puff out its crop [n -S]\n",
  "POUTERS": "POUTER, a variety of pigeon that can puff out its crop [n]\n",
  "POUTFUL": "pouty, sulky [adj]\n",
  "POUTHER": "(Scots) powder, also POUDER, POUDRE, POULDER, POULDRE [n -S] / to powder [v -ED, -ING, -S]\n",
  "POUTHERED": "POUTHER, to powder [v]\n",
  "POUTHERING": "POUTHER, to powder [v]\n",
  "POUTHERS": "POUTHER, to powder [v]\n",
  "POUTIER": "POUTY, tending to pout [adj]\n",
  "POUTIEST": "POUTY, tending to pout [adj]\n",
  "POUTINE": "(Canadian) a dish of chipped potatoes topped with curd cheese and a tomato-based sauce [n -S]\n",
  "POUTINES": "POUTINE, (Canadian) a dish of chipped potatoes topped with curd cheese and a tomato-based sauce [n]\n",
  "POUTING": "a fish of the cod family, aka whiting pout [n -S]\n",
  "POUTINGLY": "POUTING [adv]\n",
  "POUTINGS": "POUTING, a fish of the cod family, aka whiting pout [n]\n",
  "POUTS": "POUT, to protrude the lips in ill humour [v]\n",
  "POUTY": "tending to pout [adj POUTIER, POUTIEST]\n",
  "POVERTIES": "POVERTY, the state of being poor [n]\n",
  "POVERTY": "the state of being poor [n POVERTIES]\n",
  "POW": "(Scots) the head [n -S]\n",
  "POWAN": "(Scots) a species of whitefish [n -S]\n",
  "POWANS": "POWAN, (Scots) a species of whitefish [n]\n",
  "POWDER": "matter in a finely divided state [n -S] / to reduce to fine dustlike particles [v -ED, -ING, -S]\n",
  "POWDERED": "POWDER, to reduce to fine dustlike particles [v]\n",
  "POWDERER": "one who powders [n -S]\n",
  "POWDERERS": "POWDERER, one who powders [n]\n",
  "POWDERIER": "POWDERY, like powder [adj]\n",
  "POWDERIEST": "POWDERY, like powder [adj]\n",
  "POWDERING": "the act of applying powder [n -S]\n",
  "POWDERINGS": "POWDERING, the act of applying powder [n]\n",
  "POWDERLESS": "without powder [adj]\n",
  "POWDERLIKE": "like powder [adj]\n",
  "POWDERMAN": "a person in charge of explosives, especially in a demolition crew [n POWDERMEN]\n",
  "POWDERMEN": "POWDERMAN, a person in charge of explosives, especially in a demolition crew [n]\n",
  "POWDERS": "POWDER, to reduce to fine dustlike particles [v]\n",
  "POWDERY": "like powder [adj POWDERIER, POWDERIEST]\n",
  "POWELLISE": "to season and preserve timbers by soaking them in a saccharine solution, also POWELLIZE [v POWELLISED, POWELLISING, POWELLISES]\n",
  "POWELLISED": "POWELLISE, to season and preserve timbers by soaking them in a saccharine solution, also POWELLIZE [v]\n",
  "POWELLISES": "POWELLISE, to season and preserve timbers by soaking them in a saccharine solution, also POWELLIZE [v]\n",
  "POWELLISING": "POWELLISE, to season and preserve timbers by soaking them in a saccharine solution, also POWELLIZE [v]\n",
  "POWELLITE": "calcium molybdate [n -S]\n",
  "POWELLITES": "POWELLITE, calcium molybdate [n]\n",
  "POWELLIZE": "to season and preserve timbers by soaking them in a saccharine solution, also POWELLISE [v POWELLIZED, POWELLIZING, POWELLIZES]\n",
  "POWELLIZED": "POWELLIZE, to season and preserve timbers by soaking them in a saccharine solution, also POWELLISE [v]\n",
  "POWELLIZES": "POWELLIZE, to season and preserve timbers by soaking them in a saccharine solution, also POWELLISE [v]\n",
  "POWELLIZING": "POWELLIZE, to season and preserve timbers by soaking them in a saccharine solution, also POWELLISE [v]\n",
  "POWER": "to equip with mechanical force [v -ED, -ING, -S]\n",
  "POWERBAND": "the range of operating speeds under which an engine or motor is able to operate efficiently [n -S]\n",
  "POWERBANDS": "POWERBAND, the range of operating speeds under which an engine or motor is able to operate efficiently [n]\n",
  "POWERBOAT": "a boat propelled by an inboard or outboard motor [n -S]\n",
  "POWERBOATING": "the sport of driving a powerboat [n -S]\n",
  "POWERBOATINGS": "POWERBOATING, the sport of driving a powerboat [n]\n",
  "POWERBOATS": "POWERBOAT, a boat propelled by an inboard or outboard motor [n]\n",
  "POWERED": "POWER, to equip with mechanical force [v]\n",
  "POWERFUL": "full of power [adj POWERFULLY]\n",
  "POWERFULLY": "POWERFUL, full of power [adv]\n",
  "POWERFULNESS": "the state of being powerful [n -ES]\n",
  "POWERFULNESSES": "POWERFULNESS, the state of being powerful [n]\n",
  "POWERHOUSE": "one having great drive, energy, or ability [n -S]\n",
  "POWERHOUSES": "POWERHOUSE, one having great drive, energy, or ability [n]\n",
  "POWERING": "POWER, to equip with mechanical force [v]\n",
  "POWERLESS": "without power [adj POWERLESSLY]\n",
  "POWERLESSLY": "POWERLESS, without power [adv]\n",
  "POWERLESSNESS": "POWERLESS, without power [n]\n",
  "POWERLESSNESSES": "POWERLESSNESS, POWERLESS, without power [n]\n",
  "POWERLIFTER": "one who practises power lifting [n -S]\n",
  "POWERLIFTERS": "POWERLIFTER, one who practises power lifting [n]\n",
  "POWERLIFTING": "the sport of weightlifting [n -S]\n",
  "POWERLIFTINGS": "POWERLIFTING, the sport of weightlifting [n]\n",
  "POWERPLAY": "strong, attacking play designed to put pressure on the defence, with players and action concentrated in one small area [n -S]\n",
  "POWERPLAYS": "POWERPLAY, strong, attacking play designed to put pressure on the defence, with players and action concentrated in one small area [n]\n",
  "POWERS": "POWER, to equip with mechanical force [v]\n",
  "POWERTRAIN": "the drive-transmitting sequence in a motor vehicle [n -S]\n",
  "POWERTRAINS": "POWERTRAIN, the drive-transmitting sequence in a motor vehicle [n]\n",
  "POWFAGGED": "(dialect) exhausted [adj]\n",
  "POWHIRI": "(Maori) a Maori ceremony of welcome to a marae, also POHIRI [n -S]\n",
  "POWHIRIS": "POWHIRI, (Maori) a Maori ceremony of welcome to a marae, also POHIRI [n]\n",
  "POWIN": "(Scots) a peacock, also POWN [n -S]\n",
  "POWINS": "POWIN, (Scots) a peacock, also POWN [n]\n",
  "POWN": "(Scots) a peacock, also POWIN [n -S]\n",
  "POWND": "(Spenser) to pound, beat with the fists [v -ED, -ING, -S]\n",
  "POWNDED": "POWND, (Spenser) to pound, beat with the fists [v]\n",
  "POWNDING": "POWND, (Spenser) to pound, beat with the fists [v]\n",
  "POWNDS": "POWND, (Spenser) to pound, beat with the fists [v]\n",
  "POWNEY": "(dialect) a pony, also POWNIE, POWNY [n -S]\n",
  "POWNEYS": "POWNEY, (dialect) a pony, also POWNIE, POWNY [n]\n",
  "POWNIE": "(dialect) a pony, also POWNEY, POWNY [n -S]\n",
  "POWNIES": "POWNY, (dialect) a pony, also POWNEY, POWNIE [n]\n",
  "POWNS": "POWN, (Scots) a peacock, also POWIN [n]\n",
  "POWNY": "(dialect) a pony, also POWNEY, POWNIE [n POWNIES]\n",
  "POWRE": "(Spenser) to pour [v POWRED, POWRING, POWRES]\n",
  "POWRED": "POWRE, (Spenser) to pour [v]\n",
  "POWRES": "POWRE, (Spenser) to pour [v]\n",
  "POWRING": "POWRE, (Spenser) to pour [v]\n",
  "POWS": "POW, (Scots) the head [n]\n",
  "POWSOWDIES": "POWSOWDY, (Scots) any mixture of heterogeneous kinds of food, also POUSOWDIE [n]\n",
  "POWSOWDY": "(Scots) any mixture of heterogeneous kinds of food, also POUSOWDIE [n POWSOWDIES]\n",
  "POWTER": "(Scots) to poke, rummage [v -ED, -ING, -S]\n",
  "POWTERED": "POWTER, (Scots) to poke, rummage [v]\n",
  "POWTERING": "POWTER, (Scots) to poke, rummage [v]\n",
  "POWTERS": "POWTER, (Scots) to poke, rummage [v]\n",
  "POWWAW": "(Shakespeare) an interjection, pooh [interj]\n",
  "POWWOW": "(Native American) a conference between American Indians [n -S] / to hold such a conference, also PAWAW [v -ED, -ING, -S]\n",
  "POWWOWED": "POWWOW, to hold such a conference, also PAWAW [v]\n",
  "POWWOWING": "POWWOW, to hold such a conference, also PAWAW [v]\n",
  "POWWOWS": "POWWOW, to hold such a conference, also PAWAW [v]\n",
  "POX": "to infect with syphilis [v -ED, -ING, -ES]\n",
  "POXED": "POX, to infect with syphilis [v]\n",
  "POXES": "POX, to infect with syphilis [v]\n",
  "POXIER": "POXY, afflicted by pox [adj]\n",
  "POXIEST": "POXY, afflicted by pox [adj]\n",
  "POXING": "POX, to infect with syphilis [v]\n",
  "POXVIRUS": "any one of a group of DNA-containing animal viruses [n -ES]\n",
  "POXVIRUSES": "POXVIRUS, any one of a group of DNA-containing animal viruses [n]\n",
  "POXY": "afflicted by pox [adj POXIER, POXIEST]\n",
  "POYNANT": "(Spenser) poignant [adj]\n",
  "POYNT": "(obsolete) to point [v -ED, -ING, -S]\n",
  "POYNTED": "POYNT, (obsolete) to point [v]\n",
  "POYNTING": "POYNT, (obsolete) to point [v]\n",
  "POYNTS": "POYNT, (obsolete) to point [v]\n",
  "POYOU": "an armadillo [n -S]\n",
  "POYOUS": "POYOU, an armadillo [n]\n",
  "POYSE": "(obsolete) to poise, also PEASE, PEAZE, PEYSE [v POYSED, POYSING, POYSES]\n",
  "POYSED": "POYSE, (obsolete) to poise, also PEASE, PEAZE, PEYSE [v]\n",
  "POYSES": "POYSE, (obsolete) to poise, also PEASE, PEAZE, PEYSE [v]\n",
  "POYSING": "POYSE, (obsolete) to poise, also PEASE, PEAZE, PEYSE [v]\n",
  "POYSON": "(obsolete) to poison [v -ED, -ING, -S]\n",
  "POYSONED": "POYSON, (obsolete) to poison [v]\n",
  "POYSONING": "POYSON, (obsolete) to poison [v]\n",
  "POYSONS": "POYSON, (obsolete) to poison [v]\n",
  "POZ": "(colloquial) positive, also POS, POZZ [adj]\n",
  "POZIDRIVE": "(tradename) having a patent screw-head that allows greater torque, also POSIDRIVE [adj]\n",
  "POZOLE": "a thick soup made of pork, corn, garlic, and chili, also POSOLE [n -S]\n",
  "POZOLES": "POZOLE, a thick soup made of pork, corn, garlic, and chili, also POSOLE [n]\n",
  "POZZ": "(colloquial) positive, also POS, POZ [adj]\n",
  "POZZIES": "POZZY, (Australian slang) a position, also POSSIE [n]\n",
  "POZZOLAN": "(Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLANA, POZZUOLANA, PUZZOLANA [n -S]\n",
  "POZZOLANA": "(Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLAN, POZZUOLANA, PUZZOLANA [n -S]\n",
  "POZZOLANAS": "POZZOLANA, (Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLAN, POZZUOLANA, PUZZOLANA [n]\n",
  "POZZOLANIC": "of or like pozzolana, volcanic ashes from Pozzuoli, in Italy [adj]\n",
  "POZZOLANS": "POZZOLAN, (Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLANA, POZZUOLANA, PUZZOLANA [n]\n",
  "POZZUOLANA": "(Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLAN, POZZOLANA, PUZZOLANA [n -S]\n",
  "POZZUOLANAS": "POZZUOLANA, (Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLAN, POZZOLANA, PUZZOLANA [n]\n",
  "POZZY": "(Australian slang) a position, also POSSIE [n POZZIES]\n",
  "PRAAM": "(Dutch) a flat-bottomed boat, used in Holland and the Baltic, also PRAM [n -S]\n",
  "PRAAMS": "PRAAM, (Dutch) a flat-bottomed boat, used in Holland and the Baltic, also PRAM [n]\n",
  "PRABBLE": "(Shakespeare) a clamorous contest, a brawl, also BRABBLE, PRIBBLE [n -S]\n",
  "PRABBLES": "PRABBLE, (Shakespeare) a clamorous contest, a brawl, also BRABBLE, PRIBBLE [n]\n",
  "PRACHARAK": "(Hindi) in India, a person appointed to propagate a cause through personal contacts, meetings etc. [n -S]\n",
  "PRACHARAKS": "PRACHARAK, (Hindi) in India, a person appointed to propagate a cause through personal contacts, meetings etc. [n]\n",
  "PRACTIC": "(archaic) to put (a theory, idea, etc.) into practice, also PRACTICK [v PRACTICKED, PRACTICKING, PRACTICS]\n",
  "PRACTICABILITY": "the state of being practicable [n]\n",
  "PRACTICABLE": "that can be effected [adj PRACTICABLY]\n",
  "PRACTICABLENESS": "PRACTICABLE, that can be effected [n]\n",
  "PRACTICABLY": "PRACTICABLE, that can be effected [adv]\n",
  "PRACTICAL": "relating to actual practice [adj PRACTICALLY] / a practical examination [n -S]\n",
  "PRACTICALISM": "devotion to what is practical [n -S]\n",
  "PRACTICALISMS": "PRACTICALISM, devotion to what is practical [n]\n",
  "PRACTICALIST": "one who is devoted to what is practical [n -S]\n",
  "PRACTICALISTS": "PRACTICALIST, one who is devoted to what is practical [n]\n",
  "PRACTICALITIES": "PRACTICALITY, the state of being practical [n]\n",
  "PRACTICALITY": "the state of being practical [n PRACTICALITIES]\n",
  "PRACTICALLY": "PRACTICAL, relating to actual practice [adv]\n",
  "PRACTICALNESS": "the state of being practical [n -ES]\n",
  "PRACTICALNESSES": "PRACTICALNESS, the state of being practical [n]\n",
  "PRACTICALS": "PRACTICAL, a practical examination [n]\n",
  "PRACTICE": "to train or drill in order to acquire skill, also PRACTISE [v PRACTICED, PRACTICING, PRACTICES]\n",
  "PRACTICED": "PRACTICE, to train or drill in order to acquire skill, also PRACTISE [v]\n",
  "PRACTICER": "one who practices, also PRACTISER [n -S]\n",
  "PRACTICERS": "PRACTICER, one who practices, also PRACTISER [n]\n",
  "PRACTICES": "PRACTICE, to train or drill in order to acquire skill, also PRACTISE [v]\n",
  "PRACTICIAN": "a practiser or practitioner [n -S]\n",
  "PRACTICIANS": "PRACTICIAN, a practiser or practitioner [n]\n",
  "PRACTICING": "PRACTICE, to train or drill in order to acquire skill, also PRACTISE [v]\n",
  "PRACTICK": "(archaic) practice, also PRACTIC, PRACTIQUE [n -S]\n",
  "PRACTICKED": "PRACTIC, (archaic) to put (a theory, idea, etc.) into practice, also PRACTICK [v]\n",
  "PRACTICKING": "PRACTIC, (archaic) to put (a theory, idea, etc.) into practice, also PRACTICK [v]\n",
  "PRACTICKS": "PRACTICK, (archaic) practice, also PRACTIC, PRACTIQUE [n]\n",
  "PRACTICS": "PRACTIC, (archaic) to put (a theory, idea, etc.) into practice, also PRACTICK [v]\n",
  "PRACTICUM": "(Latin) a course of practical work undertaken to implement academic studies [n -S]\n",
  "PRACTICUMS": "PRACTICUM, (Latin) a course of practical work undertaken to implement academic studies [n]\n",
  "PRACTIQUE": "(archaic) practice, also PRACTIC, PRACTICK [n -S]\n",
  "PRACTIQUES": "PRACTIQUE, (archaic) practice, also PRACTIC, PRACTICK [n]\n",
  "PRACTISANT": "(obsolete) a fellow conspirator [n -S]\n",
  "PRACTISANTS": "PRACTISANT, (obsolete) a fellow conspirator [n]\n",
  "PRACTISE": "to train or drill in order to acquire skill, also PRACTICE [v PRACTISED, PRACTISING, PRACTISES]\n",
  "PRACTISED": "PRACTISE, to train or drill in order to acquire skill, also PRACTICE [v]\n",
  "PRACTISER": "one who practises, also PRACTICER [n -S]\n",
  "PRACTISERS": "PRACTISER, one who practises, also PRACTICER [n]\n",
  "PRACTISES": "PRACTISE, to train or drill in order to acquire skill, also PRACTICE [v]\n",
  "PRACTISING": "PRACTISE, to train or drill in order to acquire skill, also PRACTICE [v]\n",
  "PRACTITIONER": "one who practices [n -S]\n",
  "PRACTITIONERS": "PRACTITIONER, one who practices [n]\n",
  "PRACTIVE": "(obsolete) practical; concerned with practice [adj]\n",
  "PRACTOLOL": "a drug formerly used to treat cardiac arrhythmia [n -S]\n",
  "PRACTOLOLS": "PRACTOLOL, a drug formerly used to treat cardiac arrhythmia [n]\n",
  "PRAD": "(slang) a horse [n -S]\n",
  "PRADHAN": "(Hindi) (in India) a chief or leader [n -S]\n",
  "PRADHANS": "PRADHAN, (Hindi) (in India) a chief or leader [n]\n",
  "PRADS": "PRAD, (slang) a horse [n]\n",
  "PRAEAMBLE": "(Milton) a preamble, also PREAMBLE [n -S]\n",
  "PRAEAMBLES": "PRAEAMBLE, (Milton) a preamble, also PREAMBLE [n]\n",
  "PRAECIPE": "(Latin) a writ commanding something to be done, or requiring a reason for neglecting it, also PRECIPE [n -S]\n",
  "PRAECIPES": "PRAECIPE, (Latin) a writ commanding something to be done, or requiring a reason for neglecting it, also PRECIPE [n]\n",
  "PRAECOCES": "(Latin) a division of birds including those whose young are able to run about when first hatched [n]\n",
  "PRAECOCIAL": "of or relating to birds whose young are hatched with a covering of down and can leave the nest at once to seek food, also PRECOCIAL [adj]\n",
  "PRAECORDIAL": "in front of the heart, also PRECORDIAL [adj]\n",
  "PRAEDIAL": "a rural slave, also PREDIAL [n -S]\n",
  "PRAEDIALITIES": "PRAEDIALITY, the state of being praedial [n]\n",
  "PRAEDIALITY": "the state of being praedial [n PRAEDIALITIES]\n",
  "PRAEDIALS": "PRAEDIAL, a rural slave, also PREDIAL [n]\n",
  "PRAEFECT": "an ancient Roman official, also PREFECT [n -S]\n",
  "PRAEFECTORIAL": "of or like a praefect [adj]\n",
  "PRAEFECTS": "PRAEFECT, an ancient Roman official, also PREFECT [n]\n",
  "PRAELECT": "to lecture, also PRELECT [v -ED, -ING, -S]\n",
  "PRAELECTED": "PRAELECT, to lecture, also PRELECT [v]\n",
  "PRAELECTING": "PRAELECT, to lecture, also PRELECT [v]\n",
  "PRAELECTS": "PRAELECT, to lecture, also PRELECT [v]\n",
  "PRAELUDIA": "PRAELUDIUM, (Latin) a prelude [n]\n",
  "PRAELUDIUM": "(Latin) a prelude [n PRAELUDIA]\n",
  "PRAEMUNIRE": "the offense of introducing foreign authority into England, the penalties for which were originally intended to depress the civil power of the pope in the kingdom [n -S]\n",
  "PRAEMUNIRES": "PRAEMUNIRE, the offense of introducing foreign authority into England, the penalties for which were originally intended to depress the civil power of the pope in the kingdom [n]\n",
  "PRAENOMEN": "(Latin) the first name of an ancient Roman, also PRENOMEN [n PRAENOMENS or PRAENOMINA]\n",
  "PRAENOMENS": "PRAENOMEN, (Latin) the first name of an ancient Roman, also PRENOMEN [n]\n",
  "PRAENOMINA": "PRAENOMEN, (Latin) the first name of an ancient Roman, also PRENOMEN [n]\n",
  "PRAENOMINAL": "of or relating to a praenomen [adj PRAENOMINALLY]\n",
  "PRAENOMINALLY": "PRAENOMINAL, of or relating to a praenomen [adv]\n",
  "PRAEPOSTOR": "(Latin) the name used for a prefect in some English public schools, also PREPOSITOR, PREPOSTOR [n -S]\n",
  "PRAEPOSTORS": "PRAEPOSTOR, (Latin) the name used for a prefect in some English public schools, also PREPOSITOR, PREPOSTOR [n]\n",
  "PRAESES": "(Scots) a chairman or president, also PRESES [n PRAESES]\n",
  "PRAESIDIA": "PRAESIDIUM, (Latin) a standing committee in the former Soviet Union [n]\n",
  "PRAESIDIUM": "(Latin) a standing committee in the former Soviet Union [n PRAESIDIA or PRAESIDIUMS]\n",
  "PRAESIDIUMS": "PRAESIDIUM, (Latin) a standing committee in the former Soviet Union [n]\n",
  "PRAETOR": "(Latin) an ancient Roman magistrate, also PRETOR [n -S]\n",
  "PRAETORIAL": "relating to a praetor, a magistrate of ancient Rome, also PRETORIAL [adj]\n",
  "PRAETORIAN": "a former praetor or man of equivalent rank, also PRETORIAN [n -S]\n",
  "PRAETORIANS": "PRAETORIAN, a former praetor or man of equivalent rank, also PRETORIAN [n]\n",
  "PRAETORIUM": "the court or palace of the governor of a Roman province [n -S]\n",
  "PRAETORIUMS": "PRAETORIUM, the court or palace of the governor of a Roman province [n]\n",
  "PRAETORS": "PRAETOR, (Latin) an ancient Roman magistrate, also PRETOR [n]\n",
  "PRAETORSHIP": "the office of praetor, a magistrate of ancient Rome, also PRETORSHIP [n -S]\n",
  "PRAETORSHIPS": "PRAETORSHIP, the office of praetor, a magistrate of ancient Rome, also PRETORSHIP [n]\n",
  "PRAGMATIC": "dealing with facts and actual occurrences; practical, also PRAGMATICAL [adj PRAGMATICALLY]\n",
  "PRAGMATICAL": "dealing with facts and actual occurrences; practical, also PRAGMATIC [adj PRAGMATICALLY]\n",
  "PRAGMATICALITY": "the state of being pragmatical [n]\n",
  "PRAGMATICALLY": "PRAGMATICAL, dealing with facts and actual occurrences; practical, also PRAGMATIC [adv]\n",
  "PRAGMATICALNESS": "the state of being pragmatical [n]\n",
  "PRAGMATICISM": "the philosophic doctrine of C. S. Peirce [n -S]\n",
  "PRAGMATICISMS": "PRAGMATICISM, the philosophic doctrine of C. S. Peirce [n]\n",
  "PRAGMATICIST": "an adherent of pragmaticism [n -S]\n",
  "PRAGMATICISTS": "PRAGMATICIST, an adherent of pragmaticism [n]\n",
  "PRAGMATICS": "the study of inherent practical usage, and social and behavioural aspects, of language [n]\n",
  "PRAGMATISATION": "the process of pragmatising, also PRAGMATIZATION [n -S]\n",
  "PRAGMATISATIONS": "PRAGMATISATION, the process of pragmatising, also PRAGMATIZATION [n]\n",
  "PRAGMATISE": "to interpret; to represent as real, also PRAGMATIZE [v PRAGMATISED, PRAGMATISING, PRAGMATISES]\n",
  "PRAGMATISED": "PRAGMATISE, to interpret; to represent as real, also PRAGMATIZE [v]\n",
  "PRAGMATISER": "one who pragmatises, also PRAGMATIZER [n -S]\n",
  "PRAGMATISERS": "PRAGMATISER, one who pragmatises, also PRAGMATIZER [n]\n",
  "PRAGMATISES": "PRAGMATISE, to interpret; to represent as real, also PRAGMATIZE [v]\n",
  "PRAGMATISING": "PRAGMATISE, to interpret; to represent as real, also PRAGMATIZE [v]\n",
  "PRAGMATISM": "a doctrine emphasizing practical value of philosophy [n -S]\n",
  "PRAGMATISMS": "PRAGMATISM, a doctrine emphasizing practical value of philosophy [n]\n",
  "PRAGMATIST": "one who is pragmatic [n -S]\n",
  "PRAGMATISTIC": "relating to pragmatism [adj]\n",
  "PRAGMATISTS": "PRAGMATIST, one who is pragmatic [n]\n",
  "PRAGMATIZATION": "the process of pragmatizing, also PRAGMATISATION [n -S]\n",
  "PRAGMATIZATIONS": "PRAGMATIZATION, the process of pragmatizing, also PRAGMATISATION [n]\n",
  "PRAGMATIZE": "to interpret; to represent as real, also PRAGMATISE [v PRAGMATIZED, PRAGMATIZING, PRAGMATIZES]\n",
  "PRAGMATIZED": "PRAGMATIZE, to interpret; to represent as real, also PRAGMATISE [v]\n",
  "PRAGMATIZER": "one who pragmatizes, also PRAGMATISER [n -S]\n",
  "PRAGMATIZERS": "PRAGMATIZER, one who pragmatizes, also PRAGMATISER [n]\n",
  "PRAGMATIZES": "PRAGMATIZE, to interpret; to represent as real, also PRAGMATISE [v]\n",
  "PRAGMATIZING": "PRAGMATISE, to interpret; to represent as real, also PRAGMATIZE [v]\n",
  "PRAHU": "(Malay) a swift Malaysian sailing vessel, also PRAU, PRAO, PROA [n -S]\n",
  "PRAHUS": "PRAHU, (Malay) a swift Malaysian sailing vessel, also PRAU, PRAO, PROA [n]\n",
  "PRAIRIE": "a grass-covered treeless plain [n -S]\n",
  "PRAIRIED": "having prairie land [adj]\n",
  "PRAIRIES": "PRAIRIE, a grass-covered treeless plain [n]\n",
  "PRAISE": "to express admiration or approval of [v PRAISED, PRAISING, PRAISES]\n",
  "PRAISEACH": "(Irish) a kind of oatmeal porridge [n -S]\n",
  "PRAISEACHS": "PRAISEACH, (Irish) a kind of oatmeal porridge [n]\n",
  "PRAISED": "PRAISE, to express admiration or approval of [v]\n",
  "PRAISEFUL": "praiseworthy [adj]\n",
  "PRAISELESS": "without praise or approbation [adj]\n",
  "PRAISER": "one who praises [n -S]\n",
  "PRAISERS": "PRAISER, one who praises [n]\n",
  "PRAISES": "PRAISE, to express admiration or approval of [v]\n",
  "PRAISEWORTHIER": "PRAISEWORTHY, worthy of praise [adj]\n",
  "PRAISEWORTHIEST": "PRAISEWORTHY, worthy of praise [adj]\n",
  "PRAISEWORTHILY": "PRAISEWORTHY, worthy of praise [adv]\n",
  "PRAISEWORTHY": "worthy of praise [adj PRAISEWORTHIER, PRAISEWORTHIEST; PRAISEWORTHILY]\n",
  "PRAISING": "laudatory [adj PRAISINGLY] / the act of praising [n -S]\n",
  "PRAISINGLY": "PRAISING, laudatory [adv]\n",
  "PRAISINGS": "PRAISING, the act of praising [n]\n",
  "PRAJNA": "(Sanskrit) wisdom or understanding considered as the goal of Buddhist contemplation [n -S]\n",
  "PRAJNAS": "PRAJNA, (Sanskrit) wisdom or understanding considered as the goal of Buddhist contemplation [n]\n",
  "PRALINE": "(French) an almond coated with brown sugar, also PRAWLIN [n -S]\n",
  "PRALINES": "PRALINE, (French) an almond coated with brown sugar, also PRAWLIN [n]\n",
  "PRALLTRILLER": "a musical ornament comprising a mordent plus an added upper note [n -S]\n",
  "PRALLTRILLERS": "PRALLTRILLER, a musical ornament comprising a mordent plus an added upper note [n]\n",
  "PRAM": "(Dutch) a flat-bottomed boat, used in Holland and the Baltic, also PRAAM [n -S]\n",
  "PRAMS": "PRAM, (Dutch) a flat-bottomed boat, used in Holland and the Baltic, also PRAAM [n]\n",
  "PRANA": "(Sanskrit) in yoga, vital energy present in air and sunlight [n -S]\n",
  "PRANAS": "PRANA, (Sanskrit) in yoga, vital energy present in air and sunlight [n]\n",
  "PRANAYAMA": "(Sanskrit) the discipline of yogic breathing [n -S]\n",
  "PRANAYAMAS": "PRANAYAMA, (Sanskrit) the discipline of yogic breathing [n]\n",
  "PRANCE": "to spring forward on the hind legs, also PRAUNCE [v PRANCED, PRANCING, PRANCES]\n",
  "PRANCED": "PRANCE, to spring forward on the hind legs, also PRAUNCE [v]\n",
  "PRANCER": "a horse that prances [n -S]\n",
  "PRANCERS": "PRANCER, a horse that prances [n]\n",
  "PRANCES": "PRANCE, to spring forward on the hind legs, also PRAUNCE [v]\n",
  "PRANCING": "moving like a horse [adj PRANCINGLY] / the act of prancing [n -S]\n",
  "PRANCINGLY": "PRANCING, moving like a horse [adv]\n",
  "PRANCINGS": "PRANCING, the act of prancing [n]\n",
  "PRANCK": "(obsolete) to fold, pleat, also PRANCKE [v -ED, -ING, -S]\n",
  "PRANCKE": "(obsolete) to fold, pleat, also PRANCK [v PRANCKED, PRANCKING, PRANCKES]\n",
  "PRANCKED": "PRANCKE, (obsolete) to fold, pleat, also PRANCK [v]\n",
  "PRANCKES": "PRANCKE, (obsolete) to fold, pleat, also PRANCK [v]\n",
  "PRANCKING": "PRANCKE, (obsolete) to fold, pleat, also PRANCK [v]\n",
  "PRANCKS": "PRANCK, (obsolete) to fold, pleat, also PRANCKE [v]\n",
  "PRANDIAL": "of or relating to a meal [adj PRANDIALLY]\n",
  "PRANDIALLY": "PRANDIAL, of or relating to a meal [adv]\n",
  "PRANG": "to cause to crash [v -ED, -ING, -S]\n",
  "PRANGED": "PRANG, to cause to crash [v]\n",
  "PRANGING": "PRANG, to cause to crash [v]\n",
  "PRANGS": "PRANG, to cause to crash [v]\n",
  "PRANK": "to dress gaudily [v -ED, -ING, -S]\n",
  "PRANKED": "PRANK, to dress gaudily [v]\n",
  "PRANKFUL": "full of pranks [adj]\n",
  "PRANKIER": "PRANKY, of the nature of a prank [adj]\n",
  "PRANKIEST": "PRANKY, of the nature of a prank [adj]\n",
  "PRANKING": "colourful adornment [n -S]\n",
  "PRANKINGLY": "PRANKING [adv]\n",
  "PRANKINGS": "PRANKING, colourful adornment [n]\n",
  "PRANKISH": "mischievous [adj PRANKISHLY]\n",
  "PRANKISHLY": "PRANKISH, mischievous [adv]\n",
  "PRANKISHNESS": "the state of being prankish [n -ES]\n",
  "PRANKISHNESSES": "PRANKISHNESS, the state of being prankish [n]\n",
  "PRANKLE": "to prance lightly [v PRANKLED, PRANKLING, PRANKLES]\n",
  "PRANKLED": "PRANKLE, to prance lightly [v]\n",
  "PRANKLES": "PRANKLE, to prance lightly [v]\n",
  "PRANKLING": "PRANKLE, to prance lightly [v]\n",
  "PRANKS": "PRANK, to dress gaudily [v]\n",
  "PRANKSOME": "full of pranks [adj]\n",
  "PRANKSTER": "one who plays pranks [n -S]\n",
  "PRANKSTERS": "PRANKSTER, one who plays pranks [n]\n",
  "PRANKY": "of the nature of a prank [adj PRANKIER, PRANKIEST]\n",
  "PRAO": "(Malay) a swift Malaysian sailing vessel, also PRAU, PRAHU, PROA [n -S]\n",
  "PRAOS": "PRAO, (Malay) a swift Malaysian sailing vessel, also PRAU, PRAHU, PROA [n]\n",
  "PRASE": "a leek-green quartz [n -S]\n",
  "PRASEODYMIUM": "a chemical element, a metal with green salts, isolated from the once-supposed element didymium [n -S]\n",
  "PRASEODYMIUMS": "PRASEODYMIUM, a chemical element, a metal with green salts, isolated from the once-supposed element didymium [n]\n",
  "PRASES": "PRASE, a leek-green quartz [n]\n",
  "PRAT": "(colloquial) an idiot [n -S]\n",
  "PRATE": "to talk foolishly or sententiously [v PRATED, PRATING, PRATES]\n",
  "PRATED": "PRATE, to talk foolishly or sententiously [v]\n",
  "PRATER": "one who prates [n -S]\n",
  "PRATERS": "PRATER, one who prates [n]\n",
  "PRATES": "PRATE, to talk foolishly or sententiously [v]\n",
  "PRATFALL": "to fall on the buttocks, to make a big blunder [v PRATFELL, PRATFALLEN, PRATFALLING, PRATFALLS]\n",
  "PRATFALLEN": "PRATFALL, to fall on the buttocks, to make a big blunder [v]\n",
  "PRATFALLING": "PRATFALL, to fall on the buttocks, to make a big blunder [v]\n",
  "PRATFALLS": "PRATFALL, to fall on the buttocks, to make a big blunder [v]\n",
  "PRATFELL": "PRATFALL, to fall on the buttocks, to make a big blunder [v]\n",
  "PRATIE": "(Irish colloquial) a potato, also PRATY [n -S]\n",
  "PRATIES": "PRATIE, (Irish colloquial) a potato, also PRATY [n]\n",
  "PRATINCOLE": "a bird related to the plovers, with swallow-like wings and tail [n -S]\n",
  "PRATINCOLES": "PRATINCOLE, a bird related to the plovers, with swallow-like wings and tail [n]\n",
  "PRATING": "foolish talk [n -S]\n",
  "PRATINGLY": "PRATING [adv]\n",
  "PRATINGS": "PRATING, foolish talk [n]\n",
  "PRATIQUE": "(French) permission granted to a ship to use a port after quarantine or on showing a clean bill of health [n -S]\n",
  "PRATIQUES": "PRATIQUE, (French) permission granted to a ship to use a port after quarantine or on showing a clean bill of health [n]\n",
  "PRATS": "PRAT, (colloquial) an idiot [n]\n",
  "PRATT": "(Shakespeare) to beat on the buttocks [v -ED, -ING, -S]\n",
  "PRATTED": "PRATT, (Shakespeare) to beat on the buttocks [v]\n",
  "PRATTING": "PRATT, (Shakespeare) to beat on the buttocks [v]\n",
  "PRATTLE": "to talk at length about nothing in particular [v PRATTLED, PRATTLING, PRATTLES]\n",
  "PRATTLEBOX": "a prattler, a chatterbox [n -ES]\n",
  "PRATTLEBOXES": "PRATTLEBOX, a prattler, a chatterbox [n]\n",
  "PRATTLED": "PRATTLE, to talk at length about nothing in particular [v]\n",
  "PRATTLEMENT": "prattle [n -S]\n",
  "PRATTLEMENTS": "PRATTLEMENT, prattle [n]\n",
  "PRATTLER": "one who prattles [n -S]\n",
  "PRATTLERS": "PRATTLER, one who prattles [n]\n",
  "PRATTLES": "PRATTLE, to talk at length about nothing in particular [v]\n",
  "PRATTLING": "PRATTLE, to talk at length about nothing in particular [v]\n",
  "PRATTLINGLY": "PRATTLING, PRATTLE, to talk at length about nothing in particular [adv]\n",
  "PRATTS": "PRATT, (Shakespeare) to beat on the buttocks [v]\n",
  "PRATY": "(Irish colloquial) a potato, also PRATIE [n PRATIES]\n",
  "PRAU": "(Malay) a swift Malaysian sailing vessel, also PRAHU, PRAO, PROA [n -S]\n",
  "PRAUNCE": "(Spenser) to prance [v PRAUNCED, PRAUNCING, PRAUNCES]\n",
  "PRAUNCED": "PRAUNCE, (Spenser) to prance [v]\n",
  "PRAUNCES": "PRAUNCE, (Spenser) to prance [v]\n",
  "PRAUNCING": "PRAUNCE, (Spenser) to prance [v]\n",
  "PRAUS": "PRAU, (Malay) a swift Malaysian sailing vessel, also PRAHU, PRAO, PROA [n]\n",
  "PRAVITIES": "PRAVITY, wickedness [n]\n",
  "PRAVITY": "wickedness [n PRAVITIES]\n",
  "PRAWLE": "(Shakespeare) a Welsh version of brawl [n -S]\n",
  "PRAWLES": "PRAWLE, (Shakespeare) a Welsh version of brawl [n]\n",
  "PRAWLIN": "an almond coated with brown sugar, also PRALINE [n -S]\n",
  "PRAWLINS": "PRAWLIN, an almond coated with brown sugar, also PRALINE [n]\n",
  "PRAWN": "to fish for edible shellfish [v -ED, -ING, -S]\n",
  "PRAWNED": "PRAWN, to fish for edible shellfish [v]\n",
  "PRAWNER": "one who fishes for prawns [n -S]\n",
  "PRAWNERS": "PRAWNER, one who fishes for prawns [n]\n",
  "PRAWNING": "PRAWN, to fish for edible shellfish [v]\n",
  "PRAWNS": "PRAWN, to fish for edible shellfish [v]\n",
  "PRAXEOLOGICAL": "relating to praxeology [adj]\n",
  "PRAXEOLOGIES": "PRAXEOLOGY, the study of human action and conduct [n]\n",
  "PRAXEOLOGY": "the study of human action and conduct [n PRAXEOLOGIES]\n",
  "PRAXES": "PRAXIS, (Greek) practical use of a branch of learning [n]\n",
  "PRAXINOSCOPE": "an instrument with mirrors in which a series of moving drawings appear as a continuously moving picture; an early form of cinematograph [n -S]\n",
  "PRAXINOSCOPES": "PRAXINOSCOPE, an instrument with mirrors in which a series of moving drawings appear as a continuously moving picture; an early form of cinematograph [n]\n",
  "PRAXIS": "(Greek) practical use of a branch of learning [n PRAXISES or PRAXES]\n",
  "PRAXISES": "PRAXIS, (Greek) practical use of a branch of learning [n]\n",
  "PRAY": "to intercede or ask earnestly [v -ED, -ING, -S]\n",
  "PRAYED": "PRAY, to intercede or ask earnestly [v]\n",
  "PRAYER": "a devout petition to a deity [n -S]\n",
  "PRAYERFUL": "given to prayer [adj PRAYERFULLY]\n",
  "PRAYERFULLY": "PRAYERFUL, given to prayer [adv]\n",
  "PRAYERFULNESS": "PRAYERFUL, given to prayer [n]\n",
  "PRAYERFULNESSES": "PRAYERFULNESS, PRAYERFUL, given to prayer [n]\n",
  "PRAYERLESS": "not using prayer; habitually neglecting prayer to God [adj PRAYERLESSLY]\n",
  "PRAYERLESSLY": "PRAYERLESS, not using prayer; habitually neglecting prayer to God [adv]\n",
  "PRAYERLESSNESS": "the state of being prayerless [n]\n",
  "PRAYERS": "PRAYER, a devout petition to a deity [n]\n",
  "PRAYING": "in prayer [adj PRAYINGLY] / the act of praying [n -S]\n",
  "PRAYINGLY": "PRAYING, in prayer [adv]\n",
  "PRAYINGS": "PRAYING, the act of praying [n]\n",
  "PRAYS": "PRAY, to intercede or ask earnestly [v]\n",
  "PRE": "before [prep]\n",
  "PREABSORB": "to absorb beforehand [v -ED, -ING, -S]\n",
  "PREABSORBED": "PREABSORB, to absorb beforehand [v]\n",
  "PREABSORBING": "PREABSORB, to absorb beforehand [v]\n",
  "PREABSORBS": "PREABSORB, to absorb beforehand [v]\n",
  "PREACCUSE": "to accuse in advance [v PREACCUSED, PREACCUSING, PREACCUSES]\n",
  "PREACCUSED": "PREACCUSE, to accuse in advance [v]\n",
  "PREACCUSES": "PREACCUSE, to accuse in advance [v]\n",
  "PREACCUSING": "PREACCUSE, to accuse in advance [v]\n",
  "PREACE": "(Spenser) to press, also PREASE, PREASSE [v PREACED, PREACING, PREACES]\n",
  "PREACED": "PREACE, (Spenser) to press, also PREASE, PREASSE [v]\n",
  "PREACES": "PREACE, (Spenser) to press, also PREASE, PREASSE [v]\n",
  "PREACH": "to deliver a sermon [v -ED, -ING, -ES]\n",
  "PREACHABLE": "that can be preached [adj]\n",
  "PREACHED": "PREACH, to deliver a sermon [v]\n",
  "PREACHER": "one that preaches [n -S]\n",
  "PREACHERS": "PREACHER, one that preaches [n]\n",
  "PREACHERSHIP": "the office of preacher [n -S]\n",
  "PREACHERSHIPS": "PREACHERSHIP, the office of preacher [n]\n",
  "PREACHES": "PREACH, to deliver a sermon [v]\n",
  "PREACHIER": "PREACHY, tending to preach [adj]\n",
  "PREACHIEST": "PREACHY, tending to preach [adj]\n",
  "PREACHIFIED": "PREACHIFY, to discourse in the manner of a preacher [v]\n",
  "PREACHIFIES": "PREACHIFY, to discourse in the manner of a preacher [v]\n",
  "PREACHIFY": "to discourse in the manner of a preacher [v PREACHIFIED, PREACHIFYING, PREACHIFIES]\n",
  "PREACHIFYING": "the act of preachifying [n -S]\n",
  "PREACHIFYINGS": "PREACHIFYING, the act of preachifying [n]\n",
  "PREACHILY": "PREACHY, tending to preach [adv]\n",
  "PREACHINESS": "the quality of being preachy [n -ES]\n",
  "PREACHINESSES": "PREACHINESS, the quality of being preachy [n]\n",
  "PREACHING": "advocating urgently [adj PREACHINGLY] / the act of preaching [n -S]\n",
  "PREACHINGLY": "PREACHING, advocating urgently [adv]\n",
  "PREACHINGS": "PREACHING, the act of preaching [n]\n",
  "PREACHMENT": "a religious harangue; a sermon [n -S]\n",
  "PREACHMENTS": "PREACHMENT, a religious harangue; a sermon [n]\n",
  "PREACHY": "tending to preach [adj PREACHIER, PREACHIEST, PREACHILY]\n",
  "PREACING": "PREACE, (Spenser) to press, also PREASE, PREASSE [v]\n",
  "PREACQUAINT": "to acquaint beforehand [v -ED, -ING, -S]\n",
  "PREACQUAINTANCE": "acquaintance made in advance [n]\n",
  "PREACQUAINTED": "PREACQUAINT, to acquaint beforehand [v]\n",
  "PREACQUAINTING": "PREACQUAINT, to acquaint beforehand [v]\n",
  "PREACQUAINTS": "PREACQUAINT, to acquaint beforehand [v]\n",
  "PREACQUISITION": "taking place before acquisition [adj]\n",
  "PREACT": "to act beforehand [v -ED, -ING, -S]\n",
  "PREACTED": "PREACT, to act beforehand [v]\n",
  "PREACTING": "PREACT, to act beforehand [v]\n",
  "PREACTS": "PREACT, to act beforehand [v]\n",
  "PREADAMIC": "relating to the belief that there were people on the earth before Adam [adj]\n",
  "PREADAMITE": "a person who believes that there were people on earth before Adam [n -S]\n",
  "PREADAMITES": "PREADAMITE, a person who believes that there were people on earth before Adam [n]\n",
  "PREADAPT": "to adapt beforehand [v -ED, -ING, -S]\n",
  "PREADAPTATION": "a character of an organism or taxonomic group that takes on a function when none previously existed or that differs from its existing function which has been derived by evolution [n -S]\n",
  "PREADAPTATIONS": "PREADAPTATION, a character of an organism or taxonomic group that takes on a function when none previously existed or that differs from its existing function which has been derived by evolution [n]\n",
  "PREADAPTED": "PREADAPT, to adapt beforehand [v]\n",
  "PREADAPTING": "PREADAPT, to adapt beforehand [v]\n",
  "PREADAPTIVE": "of, relating to, or characterized by preadaptation [adj]\n",
  "PREADAPTS": "PREADAPT, to adapt beforehand [v]\n",
  "PREADJUST": "to adjust in advance [v -ED, -ING, -S]\n",
  "PREADJUSTED": "PREADJUST, to adjust in advance [v]\n",
  "PREADJUSTING": "PREADJUST, to adjust in advance [v]\n",
  "PREADJUSTS": "PREADJUST, to adjust in advance [v]\n",
  "PREADMISSION": "the act of preadmitting [n -S]\n",
  "PREADMISSIONS": "PREADMISSION, the act of preadmitting [n]\n",
  "PREADMIT": "to admit beforehand [v PREADMITTED, PREADMITTING, PREADMITS]\n",
  "PREADMITS": "PREADMIT, to admit beforehand [v]\n",
  "PREADMITTED": "PREADMIT, to admit beforehand [v]\n",
  "PREADMITTING": "PREADMIT, to admit beforehand [v]\n",
  "PREADMONISH": "to admonish in advance [v -ED, -ING, -ES]\n",
  "PREADMONISHED": "PREADMONISH, to admonish in advance [v]\n",
  "PREADMONISHES": "PREADMONISH, to admonish in advance [v]\n",
  "PREADMONISHING": "PREADMONISH, to admonish in advance [v]\n",
  "PREADMONITION": "the act of preadmonishing, forewarning [n -S]\n",
  "PREADMONITIONS": "PREADMONITION, the act of preadmonishing, forewarning [n]\n",
  "PREADOLESCENCE": "the period of human development just preceding adolescence [n -S]\n",
  "PREADOLESCENCES": "PREADOLESCENCE, the period of human development just preceding adolescence [n]\n",
  "PREADOLESCENT": "a child before the age of thirteen [n -S]\n",
  "PREADOLESCENTS": "PREADOLESCENT, a child before the age of thirteen [n]\n",
  "PREADOPT": "to adopt beforehand [v -ED, -ING, -S]\n",
  "PREADOPTED": "PREADOPT, to adopt beforehand [v]\n",
  "PREADOPTING": "PREADOPT, to adopt beforehand [v]\n",
  "PREADOPTS": "PREADOPT, to adopt beforehand [v]\n",
  "PREADULT": "preceding adulthood [adj] / a person of preadult age [n -S]\n",
  "PREADULTS": "PREADULT, a person of preadult age [n]\n",
  "PREAGED": "previously aged [adj]\n",
  "PREAGRICULTURAL": "belonging to the period before the development of agriculture [adj]\n",
  "PREALLOT": "to allot beforehand [v PREALLOTTED, PREALLOTTING, PREALLOTS]\n",
  "PREALLOTS": "PREALLOT, to allot beforehand [v]\n",
  "PREALLOTTED": "PREALLOT, to allot beforehand [v]\n",
  "PREALLOTTING": "PREALLOT, to allot beforehand [v]\n",
  "PREALTER": "to alter beforehand [v -ED, -ING, -S]\n",
  "PREALTERED": "PREALTER, to alter beforehand [v]\n",
  "PREALTERING": "PREALTER, to alter beforehand [v]\n",
  "PREALTERS": "PREALTER, to alter beforehand [v]\n",
  "PREAMBLE": "to give an explanatory introduction [v PREAMBLED, PREAMBLING, PREAMBLES]\n",
  "PREAMBLED": "PREAMBLE, to give an explanatory introduction [v]\n",
  "PREAMBLES": "PREAMBLE, to give an explanatory introduction [v]\n",
  "PREAMBLING": "PREAMBLE, to give an explanatory introduction [v]\n",
  "PREAMBULARY": "of or like a preamble, also PREAMBULATORY [adj]\n",
  "PREAMBULATE": "to make a preamble [v PREAMBULATED, PREAMBULATING, PREAMBULATES]\n",
  "PREAMBULATED": "PREAMBULATE, to make a preamble [v]\n",
  "PREAMBULATES": "PREAMBULATE, to make a preamble [v]\n",
  "PREAMBULATING": "PREAMBULATE, to make a preamble [v]\n",
  "PREAMBULATORY": "of or like a preamble, also PREAMBULARY [adj]\n",
  "PREAMP": "(short for) preamplifier [n -S]\n",
  "PREAMPLIFIER": "an amplifier designed to amplify extremely weak electrical signals before they are fed to additional amplifier circuits [n -S]\n",
  "PREAMPLIFIERS": "PREAMPLIFIER, an amplifier designed to amplify extremely weak electrical signals before they are fed to additional amplifier circuits [n]\n",
  "PREAMPS": "PREAMP, (short for) preamplifier [n]\n",
  "PREANAESTHETIC": "a drug administered prior to an anaesthetic, also PREANESTHETIC [n -S]\n",
  "PREANAESTHETICS": "PREANAESTHETIC, a drug administered prior to an anaesthetic, also PREANESTHETIC [n]\n",
  "PREANAL": "situated in front of the anus [adj]\n",
  "PREANESTHETIC": "taking place before an anesthetic, also PREANAESTHETIC [adj]\n",
  "PREANNOUNCE": "to announce beforehand [v PREANNOUNCED, PREANNOUNCING, PREANNOUNCES]\n",
  "PREANNOUNCED": "PREANNOUNCE, to announce beforehand [v]\n",
  "PREANNOUNCES": "PREANNOUNCE, to announce beforehand [v]\n",
  "PREANNOUNCING": "PREANNOUNCE, to announce beforehand [v]\n",
  "PREAPPLIED": "PREAPPLY, to apply beforehand [v]\n",
  "PREAPPLIES": "PREAPPLY, to apply beforehand [v]\n",
  "PREAPPLY": "to apply beforehand [v PREAPPLIED, PREAPPLYING, PREAPPLIES]\n",
  "PREAPPLYING": "PREAPPLY, to apply beforehand [v]\n",
  "PREAPPOINT": "to appoint previously, or beforehand [v -ED, -ING, -S]\n",
  "PREAPPOINTED": "PREAPPOINT, to appoint previously, or beforehand [v]\n",
  "PREAPPOINTING": "PREAPPOINT, to appoint previously, or beforehand [v]\n",
  "PREAPPOINTS": "PREAPPOINT, to appoint previously, or beforehand [v]\n",
  "PREAPPROVE": "to approve in advance [v PREAPPROVED, PREAPPROVING, PREAPPROVES]\n",
  "PREAPPROVED": "PREAPPROVE, to approve in advance [v]\n",
  "PREAPPROVES": "PREAPPROVE, to approve in advance [v]\n",
  "PREAPPROVING": "PREAPPROVE, to approve in advance [v]\n",
  "PREARM": "to arm beforehand [v -ED, -ING, -S]\n",
  "PREARMED": "PREARM, to arm beforehand [v]\n",
  "PREARMING": "PREARM, to arm beforehand [v]\n",
  "PREARMS": "PREARM, to arm beforehand [v]\n",
  "PREARRANGE": "to arrange in advance [v PREARRANGED, PREARRANGING, PREARRANGES]\n",
  "PREARRANGED": "PREARRANGE, to arrange in advance [v]\n",
  "PREARRANGEMENT": "a preliminary arrangement [n -S]\n",
  "PREARRANGEMENTS": "PREARRANGEMENT, a preliminary arrangement [n]\n",
  "PREARRANGES": "PREARRANGE, to arrange in advance [v]\n",
  "PREARRANGING": "PREARRANGE, to arrange in advance [v]\n",
  "PREASE": "(Spenser) to press, also PREACE, PREASSE [v PREASED, PREASING, PREASES]\n",
  "PREASED": "PREASE, (Spenser) to press, also PREACE, PREASSE [v]\n",
  "PREASES": "PREASE, (Spenser) to press, also PREACE, PREASSE [v]\n",
  "PREASING": "PREASE, (Spenser) to press, also PREACE, PREASSE [v]\n",
  "PREASSE": "(Spenser) to press, also PREASE, PREACE [v PREASSED, PREASSING, PREASSES]\n",
  "PREASSED": "PREASSE, (Spenser) to press, also PREASE, PREACE [v]\n",
  "PREASSEMBLED": "assembled in advance [adj]\n",
  "PREASSES": "PREASSE, (Spenser) to press, also PREASE, PREACE [v]\n",
  "PREASSIGN": "to assign in advance [v -ED, -ING, -S]\n",
  "PREASSIGNED": "PREASSIGN, to assign in advance [v]\n",
  "PREASSIGNING": "PREASSIGN, to assign in advance [v]\n",
  "PREASSIGNS": "PREASSIGN, to assign in advance [v]\n",
  "PREASSING": "PREASSE, (Spenser) to press, also PREASE, PREACE [v]\n",
  "PREASSURANCE": "advance assurance [n -S]\n",
  "PREASSURANCES": "PREASSURANCE, advance assurance [n]\n",
  "PREASSURE": "to assure in advance [v PREASSURED, PREASSURING, PREASSURES]\n",
  "PREASSURED": "PREASSURE, to assure in advance [v]\n",
  "PREASSURES": "PREASSURE, to assure in advance [v]\n",
  "PREASSURING": "PREASSURE, to assure in advance [v]\n",
  "PREATOMIC": "before the harnessing of atomic energy [adj]\n",
  "PREATTUNE": "to attune in advance [v PREATTUNED, PREATTUNING, PREATTUNES]\n",
  "PREATTUNED": "PREATTUNE, to attune in advance [v]\n",
  "PREATTUNES": "PREATTUNE, to attune in advance [v]\n",
  "PREATTUNING": "PREATTUNE, to attune in advance [v]\n",
  "PREAUDIENCE": "the right to be heard before another; precedence at the bar among lawyers [n -S]\n",
  "PREAUDIENCES": "PREAUDIENCE, the right to be heard before another; precedence at the bar among lawyers [n]\n",
  "PREAUDIT": "an audit made prior to a final settlement [n -S]\n",
  "PREAUDITS": "PREAUDIT, an audit made prior to a final settlement [n]\n",
  "PREAVER": "to aver beforehand [v PREAVERRED, PREAVERRING, PREAVERS]\n",
  "PREAVERRED": "PREAVER, to aver beforehand [v]\n",
  "PREAVERRING": "PREAVER, to aver beforehand [v]\n",
  "PREAVERS": "PREAVER, to aver beforehand [v]\n",
  "PREAXIAL": "situated in front of any transverse axis in the body of an animal [adj PREAXIALLY]\n",
  "PREAXIALLY": "PREAXIAL, situated in front of any transverse axis in the body of an animal [adv]\n",
  "PREBADE": "PREBID, to bid beforehand [v]\n",
  "PREBAKE": "to bake beforehand [v PREBAKED, PREBAKING, PREBAKES]\n",
  "PREBAKED": "PREBAKE, to bake beforehand [v]\n",
  "PREBAKES": "PREBAKE, to bake beforehand [v]\n",
  "PREBAKING": "PREBAKE, to bake beforehand [v]\n",
  "PREBASAL": "situated in front of a base [adj]\n",
  "PREBATTLE": "before battle [adj]\n",
  "PREBEND": "a clergyman's stipend [n -S]\n",
  "PREBENDAL": "relating to prebends, stipends issued by a church [adj]\n",
  "PREBENDARIES": "PREBENDARY, a clergyman attached to a collegiate or cathedral church who enjoys a prebend in consideration of his officiating at stated times in the church [n]\n",
  "PREBENDARY": "a clergyman attached to a collegiate or cathedral church who enjoys a prebend in consideration of his officiating at stated times in the church [n PREBENDARIES]\n",
  "PREBENDS": "PREBEND, a clergyman's stipend [n]\n",
  "PREBIBLICAL": "belonging to the period before bible records [adj]\n",
  "PREBID": "to bid beforehand [v PREBADE, PREBIDDEN, PREBIDDING, PREBIDS]\n",
  "PREBIDDEN": "PREBID, to bid beforehand [v]\n",
  "PREBIDDING": "the act of bidding in advance [n -S]\n",
  "PREBIDDINGS": "PREBIDDING, the act of bidding in advance [n]\n",
  "PREBIDS": "PREBID, to bid beforehand [v]\n",
  "PREBILL": "to bill beforehand [v -ED, -ING, -S]\n",
  "PREBILLED": "PREBILL, to bill beforehand [v]\n",
  "PREBILLING": "PREBILL, to bill beforehand [v]\n",
  "PREBILLS": "PREBILL, to bill beforehand [v]\n",
  "PREBIND": "to bind in durable materials for library use [v PREBOUND, PREBINDING, PREBINDS]\n",
  "PREBINDING": "PREBIND, to bind in durable materials for library use [v]\n",
  "PREBINDS": "PREBIND, to bind in durable materials for library use [v]\n",
  "PREBIOLOGIC": "before life, also PREBIOLOGICAL [adj]\n",
  "PREBIOLOGICAL": "before life, also PREBIOLOGIC [adj]\n",
  "PREBIOTIC": "a natural substances in some foods that encourage the growth of healthy bacteria in the gut [n -S]\n",
  "PREBIOTICS": "PREBIOTIC, a natural substances in some foods that encourage the growth of healthy bacteria in the gut [n]\n",
  "PREBIRTH": "the period preceding a child's birth [n -S]\n",
  "PREBIRTHS": "PREBIRTH, the period preceding a child's birth [n]\n",
  "PREBLESS": "to bless beforehand [v -ED, -ING, -ES]\n",
  "PREBLESSED": "PREBLESS, to bless beforehand [v]\n",
  "PREBLESSES": "PREBLESS, to bless beforehand [v]\n",
  "PREBLESSING": "PREBLESS, to bless beforehand [v]\n",
  "PREBOARD": "to board before the regular time [v -ED, -ING, -S]\n",
  "PREBOARDED": "PREBOARD, to board before the regular time [v]\n",
  "PREBOARDING": "PREBOARD, to board before the regular time [v]\n",
  "PREBOARDS": "PREBOARD, to board before the regular time [v]\n",
  "PREBOIL": "to boil beforehand [v -ED, -ING, -S]\n",
  "PREBOILED": "PREBOIL, to boil beforehand [v]\n",
  "PREBOILING": "PREBOIL, to boil beforehand [v]\n",
  "PREBOILS": "PREBOIL, to boil beforehand [v]\n",
  "PREBOOK": "to book beforehand [v -ED, -ING, -S]\n",
  "PREBOOKED": "PREBOOK, to book beforehand [v]\n",
  "PREBOOKING": "PREBOOK, to book beforehand [v]\n",
  "PREBOOKS": "PREBOOK, to book beforehand [v]\n",
  "PREBOOM": "preceding a sudden expansion of business [adj]\n",
  "PREBORN": "being carried in the womb, unborn [adj]\n",
  "PREBOUGHT": "PREBUY, to buy in advance [v]\n",
  "PREBOUND": "PREBIND, to bind in durable materials for library use [v]\n",
  "PREBREAKFAST": "taking place before breakfast [adj]\n",
  "PREBUDGET": "a preliminary budget [n -S]\n",
  "PREBUDGETS": "PREBUDGET, a preliminary budget [n]\n",
  "PREBUILD": "to build beforehand [v PREBUILT, PREBUILDING, PREBUILDS]\n",
  "PREBUILDING": "PREBUILD, to build beforehand [v]\n",
  "PREBUILDS": "PREBUILD, to build beforehand [v]\n",
  "PREBUILT": "PREBUILD, to build beforehand [v]\n",
  "PREBUTTAL": "a prepared response to an anticipated criticism [n -S]\n",
  "PREBUTTALS": "PREBUTTAL, a prepared response to an anticipated criticism [n]\n",
  "PREBUY": "to buy in advance [v PREBOUGHT, PREBUYING, PREBUYS]\n",
  "PREBUYING": "PREBUY, to buy in advance [v]\n",
  "PREBUYS": "PREBUY, to buy in advance [v]\n",
  "PRECALCULI": "PRECALCULUS, a mathematical prerequisite for the study of calculus [n]\n",
  "PRECALCULUS": "a mathematical prerequisite for the study of calculus [n PRECALCULI or PRECALCULUSES]\n",
  "PRECALCULUSES": "PRECALCULUS, a mathematical prerequisite for the study of calculus [n]\n",
  "PRECANCEL": "to cancel in advance [v PRECANCELLED or PRECANCELED, PRECANCELLING or PRECANCELING, PRECANCELS]\n",
  "PRECANCELED": "PRECANCEL, to cancel in advance [v]\n",
  "PRECANCELING": "PRECANCEL, to cancel in advance [v]\n",
  "PRECANCELLATION": "preceding a cancellation [adj]\n",
  "PRECANCELLED": "PRECANCEL, to cancel in advance [v]\n",
  "PRECANCELLING": "PRECANCEL, to cancel in advance [v]\n",
  "PRECANCELS": "PRECANCEL, to cancel in advance [v]\n",
  "PRECANCER": "preceding cancer [adj] / a condition that may develop into cancer [n -S]\n",
  "PRECANCEROUS": "tending to become cancerous [adj]\n",
  "PRECANCERS": "PRECANCER, a condition that may develop into cancer [n]\n",
  "PRECAPITALIST": "belonging to the period before capitalism [adj]\n",
  "PRECARIAT": "the class of people in society who lack a reliable long-term source of income, such as permanent employment [n -S]\n",
  "PRECARIATS": "PRECARIAT, the class of people in society who lack a reliable long-term source of income, such as permanent employment [n]\n",
  "PRECARIOUS": "insecure, uncertain [adj PRECARIOUSLY]\n",
  "PRECARIOUSLY": "PRECARIOUS, insecure, uncertain [adv]\n",
  "PRECARIOUSNESS": "the state of being precarious [n]\n",
  "PRECAST": "to cast before placing in position [v PRECAST, PRECASTING, PRECASTS]\n",
  "PRECASTING": "PRECAST, to cast before placing in position [v]\n",
  "PRECASTS": "PRECAST, to cast before placing in position [v]\n",
  "PRECATIVE": "supplicating; expressing entreaty [adj]\n",
  "PRECATORY": "expressing a wish [adj]\n",
  "PRECAUDAL": "in front of the caudal fin [adj]\n",
  "PRECAUTION": "care taken in advance [n -S] / to forewarn [v -ED, -ING, -S]\n",
  "PRECAUTIONAL": "of the nature of a precaution, also PRECAUTIONARY, PRECAUTIOUS [adj]\n",
  "PRECAUTIONARY": "of the nature of precaution, also PRECAUTIONAL, PRECAUTIOUS [adj]\n",
  "PRECAUTIONED": "PRECAUTION, to forewarn [v]\n",
  "PRECAUTIONING": "PRECAUTION, to forewarn [v]\n",
  "PRECAUTIONS": "PRECAUTION, to forewarn [v]\n",
  "PRECAUTIOUS": "of the nature of precaution, also PRECAUTIONAL, PRECAUTIONARY [adj]\n",
  "PRECAVA": "(Latin) the superior vena cava, also PRECAVAL [n PRECAVAE]\n",
  "PRECAVAE": "PRECAVA, (Latin) the superior vena cava, also PRECAVAL [n]\n",
  "PRECAVAL": "the superior vena cava, also PRECAVA [n -S]\n",
  "PRECAVALS": "PRECAVAL, the superior vena cava, also PRECAVA [n]\n",
  "PRECEDE": "to go before [v PRECEDED, PRECEDING, PRECEDES]\n",
  "PRECEDED": "PRECEDE, to go before [v]\n",
  "PRECEDENCE": "the fact of preceding in time, also PRECEDENCY [n -S]\n",
  "PRECEDENCES": "PRECEDENCE, the fact of preceding in time, also PRECEDENCY [n]\n",
  "PRECEDENCIES": "PRECEDENCY, the fact of preceding in time, also PRECEDENCE [n]\n",
  "PRECEDENCY": "the fact of preceding in time, also PRECEDENCE [n PRECEDENCIES]\n",
  "PRECEDENT": "preceding [adj PRECEDENTLY] / something that goes before [n -S]\n",
  "PRECEDENTED": "having a precedent, warranted by example [adj]\n",
  "PRECEDENTIAL": "of the nature of a precedent [adj PRECEDENTIALLY]\n",
  "PRECEDENTIALLY": "PRECEDENTIAL, of the nature of a precedent [adv]\n",
  "PRECEDENTLY": "PRECEDENT, preceding [adv]\n",
  "PRECEDENTS": "PRECEDENT, something that goes before [n]\n",
  "PRECEDES": "PRECEDE, to go before [v]\n",
  "PRECEDING": "PRECEDE, to go before [v]\n",
  "PRECEESE": "(Scots) precise [adj]\n",
  "PRECENSOR": "to censor a publication or film before its release [v -ED, -ING, -S]\n",
  "PRECENSORED": "PRECENSOR, to censor a publication or film before its release [v]\n",
  "PRECENSORING": "PRECENSOR, to censor a publication or film before its release [v]\n",
  "PRECENSORS": "PRECENSOR, to censor a publication or film before its release [v]\n",
  "PRECENT": "to lead a church choir in singing [v -ED, -ING, -S]\n",
  "PRECENTED": "PRECENT, to lead a church choir in singing [v]\n",
  "PRECENTING": "PRECENT, to lead a church choir in singing [v]\n",
  "PRECENTOR": "a leader of the singing of a church choir [n -S]\n",
  "PRECENTORIAL": "of or like a precentor [adj]\n",
  "PRECENTORS": "PRECENTOR, a leader of the singing of a church choir [n]\n",
  "PRECENTORSHIP": "the office of precentor [n -S]\n",
  "PRECENTORSHIPS": "PRECENTORSHIP, the office of precentor [n]\n",
  "PRECENTRESS": "a female precentor [n -ES]\n",
  "PRECENTRESSES": "PRECENTRESS, a female precentor [n]\n",
  "PRECENTRICES": "PRECENTRIX, a female precentor [n]\n",
  "PRECENTRIX": "a female precentor [n PRECENTRICES or PRECENTRIXES]\n",
  "PRECENTRIXES": "PRECENTRIX, a female precentor [n]\n",
  "PRECENTS": "PRECENT, to lead a church choir in singing [v]\n",
  "PRECEPIT": "(Shakespeare) a precipice [n -S]\n",
  "PRECEPITS": "PRECEPIT, (Shakespeare) a precipice [n]\n",
  "PRECEPT": "a rule of conduct [n -S]\n",
  "PRECEPTIAL": "(Shakespeare) consisting of precepts, also PRECEPTIVE [adj]\n",
  "PRECEPTIVE": "concerning rules of conduct, laws or precepts, also PRECEPTIAL [adj PRECEPTIVELY]\n",
  "PRECEPTIVELY": "PRECEPTIVE, concerning rules of conduct, laws or precepts, also PRECEPTIAL [adv]\n",
  "PRECEPTOR": "a teacher [n -S]\n",
  "PRECEPTORAL": "like a preceptor [adj]\n",
  "PRECEPTORATE": "the office of preceptor [n -S]\n",
  "PRECEPTORATES": "PRECEPTORATE, the office of preceptor [n]\n",
  "PRECEPTORIAL": "a college course that emphasizes independent reading, discussion in small groups, and individual conferences with the teacher [n -S]\n",
  "PRECEPTORIALS": "PRECEPTORIAL, a college course that emphasizes independent reading, discussion in small groups, and individual conferences with the teacher [n]\n",
  "PRECEPTORIES": "PRECEPTORY, a community of Knights Templars (occasionally extended to a commandery of the Hospitallers) [n]\n",
  "PRECEPTORS": "PRECEPTOR, a teacher [n]\n",
  "PRECEPTORSHIP": "the office of preceptor [n -S]\n",
  "PRECEPTORSHIPS": "PRECEPTORSHIP, the office of preceptor [n]\n",
  "PRECEPTORY": "a community of Knights Templars (occasionally extended to a commandery of the Hospitallers) [n PRECEPTORIES]\n",
  "PRECEPTRESS": "a female preceptor [n -ES]\n",
  "PRECEPTRESSES": "PRECEPTRESS, a female preceptor [n]\n",
  "PRECEPTS": "PRECEPT, a rule of conduct [n]\n",
  "PRECES": "prayers, esp. in preces and responses [n]\n",
  "PRECESS": "of a spinning globe, top etc., to wobble [v -ED, -ING, -ES]\n",
  "PRECESSED": "PRECESS, of a spinning globe, top etc., to wobble [v]\n",
  "PRECESSES": "PRECESS, of a spinning globe, top etc., to wobble [v]\n",
  "PRECESSING": "PRECESS, of a spinning globe, top etc., to wobble [v]\n",
  "PRECESSION": "the act of going before, or forward [n -S]\n",
  "PRECESSIONAL": "relating to precession [adj PRECESSIONALLY]\n",
  "PRECESSIONALLY": "PRECESSIONAL, relating to precession [adv]\n",
  "PRECESSIONS": "PRECESSION, the act of going before, or forward [n]\n",
  "PRECHARGE": "to charge in advance [v PRECHARGED, PRECHARGING, PRECHARGES]\n",
  "PRECHARGED": "PRECHARGE, to charge in advance [v]\n",
  "PRECHARGES": "PRECHARGE, to charge in advance [v]\n",
  "PRECHARGING": "PRECHARGE, to charge in advance [v]\n",
  "PRECHECK": "to check beforehand [v -ED, -ING, -S]\n",
  "PRECHECKED": "PRECHECK, to check beforehand [v]\n",
  "PRECHECKING": "PRECHECK, to check beforehand [v]\n",
  "PRECHECKS": "PRECHECK, to check beforehand [v]\n",
  "PRECHILL": "to chill beforehand [v -ED, -ING, -S]\n",
  "PRECHILLED": "PRECHILL, to chill beforehand [v]\n",
  "PRECHILLING": "PRECHILL, to chill beforehand [v]\n",
  "PRECHILLS": "PRECHILL, to chill beforehand [v]\n",
  "PRECHOOSE": "to choose beforehand [v PRECHOSE, PRECHOSEN, PRECHOOSING, PRECHOOSES]\n",
  "PRECHOOSES": "PRECHOOSE, to choose beforehand [v]\n",
  "PRECHOOSING": "PRECHOOSE, to choose beforehand [v]\n",
  "PRECHOSE": "PRECHOOSE, to choose beforehand [v]\n",
  "PRECHOSEN": "PRECHOOSE, to choose beforehand [v]\n",
  "PRECHRISTIAN": "belonging to the time before Christianity [adj]\n",
  "PRECIEUSE": "(French) a woman affecting a fastidious overrefinement [n -S]\n",
  "PRECIEUSES": "PRECIEUSE, (French) a woman affecting a fastidious overrefinement [n]\n",
  "PRECIEUX": "(French) excessively refined [adj]\n",
  "PRECINCT": "a space, esp. an enclosed one, around a building (e.g. a cathedral, college, etc.) [n -S]\n",
  "PRECINCTS": "PRECINCT, a space, esp. an enclosed one, around a building (e.g. a cathedral, college, etc.) [n]\n",
  "PRECIOSITIES": "PRECIOSITY, preciousness [n]\n",
  "PRECIOSITY": "preciousness [n PRECIOSITIES]\n",
  "PRECIOUS": "valuable [adj PRECIOUSLY] / a sweetheart [n -ES]\n",
  "PRECIOUSES": "PRECIOUS, a sweetheart [n]\n",
  "PRECIOUSLY": "PRECIOUS, valuable [adv]\n",
  "PRECIOUSNESS": "the state of being precious [n -ES]\n",
  "PRECIOUSNESSES": "PRECIOUSNESS, the state of being precious [n]\n",
  "PRECIP": "(short for) precipitation [n -S]\n",
  "PRECIPE": "(Latin) a writ commanding something to be done, or requiring a reason for neglecting it, also PRAECIPE [n -S]\n",
  "PRECIPES": "PRECIPE, (Latin) a writ commanding something to be done, or requiring a reason for neglecting it, also PRAECIPE [n]\n",
  "PRECIPICE": "a high vertical or nearly vertical cliff or rock face [n -S]\n",
  "PRECIPICED": "having precipices [adj]\n",
  "PRECIPICES": "PRECIPICE, a high vertical or nearly vertical cliff or rock face [n]\n",
  "PRECIPITABILITY": "the quality of being precipitable [n]\n",
  "PRECIPITABLE": "capable of being precipitated [adj]\n",
  "PRECIPITANCE": "the quality of being precipitate, also PRECIPITANCY [n -S]\n",
  "PRECIPITANCES": "PRECIPITANCE, the quality of being precipitate, also PRECIPITANCY [n]\n",
  "PRECIPITANCIES": "PRECIPITANCY, the quality of being precipitate, also PRECIPITANCE [n]\n",
  "PRECIPITANCY": "the quality of being precipitate, also PRECIPITANCE [n PRECIPITANCIES]\n",
  "PRECIPITANT": "serving to precipitate [adj PRECIPITANTLY] / a precipitating agent [n -S]\n",
  "PRECIPITANTLY": "PRECIPITANT, serving to precipitate [adv]\n",
  "PRECIPITANTNESS": "the state of being precipitant [n]\n",
  "PRECIPITANTS": "PRECIPITANT, a precipitating agent [n]\n",
  "PRECIPITATE": "sudden [adj PRECIPITATELY] / to throw violently [v PRECIPITATED, PRECIPITATING, PRECIPITATES]\n",
  "PRECIPITATED": "PRECIPITATE, to throw violently [v]\n",
  "PRECIPITATELY": "PRECIPITATE, sudden [adv]\n",
  "PRECIPITATENESS": "PRECIPITATE, sudden [n]\n",
  "PRECIPITATES": "PRECIPITATE, to throw violently [v]\n",
  "PRECIPITATING": "PRECIPITATE, to throw violently [v]\n",
  "PRECIPITATION": "any form of water that falls from the atmosphere to the surface of the earth (e.g. rain, snow, sleet, and hail) [n -S]\n",
  "PRECIPITATIONS": "PRECIPITATION, any form of water that falls from the atmosphere to the surface of the earth (e.g. rain, snow, sleet, and hail) [n]\n",
  "PRECIPITATIVE": "serving to precipitate [adj]\n",
  "PRECIPITATOR": "one who precipitates [n -S]\n",
  "PRECIPITATORS": "PRECIPITATOR, one who precipitates [n]\n",
  "PRECIPITIN": "antibody that reacts with an antigen to cause a precipitate [n -S]\n",
  "PRECIPITINOGEN": "an antigen that induces specific precipitin [n -S]\n",
  "PRECIPITINOGENS": "PRECIPITINOGEN, an antigen that induces specific precipitin [n]\n",
  "PRECIPITINS": "PRECIPITIN, antibody that reacts with an antigen to cause a precipitate [n]\n",
  "PRECIPITOUS": "steep, sudden [adj PRECIPITOUSLY]\n",
  "PRECIPITOUSLY": "PRECIPITOUS, steep, sudden [adv]\n",
  "PRECIPITOUSNESS": "the state of being precipitous [n]\n",
  "PRECIPS": "PRECIP, (short for) precipitation [n]\n",
  "PRECIS": "(French) to make a concise summary of [v -ED, -ING, -ES]\n",
  "PRECISE": "sharply and clearly defined or stated [adj PRECISER, PRECISEST, PRECISELY]\n",
  "PRECISED": "PRECIS, (French) to make a concise summary of [v]\n",
  "PRECISELY": "PRECISE, sharply and clearly defined or stated [adv]\n",
  "PRECISENESS": "the state of being precise [n -ES]\n",
  "PRECISENESSES": "PRECISENESS, the state of being precise [n]\n",
  "PRECISER": "PRECISE, sharply and clearly defined or stated [adj]\n",
  "PRECISES": "PRECIS, (French) to make a concise summary of [v]\n",
  "PRECISEST": "PRECISE, sharply and clearly defined or stated [adj]\n",
  "PRECISIAN": "a person excessively devoted to minute observance of rules, also PRECISIANIST [n -S]\n",
  "PRECISIANISM": "over-preciseness, formalism, also PRECISIONISM [n -S]\n",
  "PRECISIANISMS": "PRECISIANISM, over-preciseness, formalism, also PRECISIONISM [n]\n",
  "PRECISIANIST": "a person excessively devoted to minute observance of rules, also PRECISIAN [n -S]\n",
  "PRECISIANISTS": "PRECISIANIST, a person excessively devoted to minute observance of rules, also PRECISIAN [n]\n",
  "PRECISIANS": "PRECISIAN, a person excessively devoted to minute observance of rules, also PRECISIANIST [n]\n",
  "PRECISING": "PRECIS, (French) to make a concise summary of [v]\n",
  "PRECISION": "the state of being precise [n -S]\n",
  "PRECISIONISM": "over-preciseness, formalism, also PRECISIANISM [n -S]\n",
  "PRECISIONISMS": "PRECISIONISM, over-preciseness, formalism, also PRECISIANISM [n]\n",
  "PRECISIONIST": "someone who insists on precision [n -S]\n",
  "PRECISIONISTS": "PRECISIONIST, someone who insists on precision [n]\n",
  "PRECISIONS": "PRECISION, the state of being precise [n]\n",
  "PRECISIVE": "dividing off, separating or abstracting mentally [adj]\n",
  "PRECITED": "previously cited [adj]\n",
  "PRECLASSICAL": "before the classical period [adj]\n",
  "PRECLEAN": "to clean beforehand [v -ED, -ING, -S]\n",
  "PRECLEANED": "PRECLEAN, to clean beforehand [v]\n",
  "PRECLEANING": "PRECLEAN, to clean beforehand [v]\n",
  "PRECLEANS": "PRECLEAN, to clean beforehand [v]\n",
  "PRECLEAR": "to clear beforehand [v -ED, -ING, -S]\n",
  "PRECLEARANCE": "a preliminary clearance [n -S]\n",
  "PRECLEARANCES": "PRECLEARANCE, a preliminary clearance [n]\n",
  "PRECLEARED": "PRECLEAR, to clear beforehand [v]\n",
  "PRECLEARING": "PRECLEAR, to clear beforehand [v]\n",
  "PRECLEARS": "PRECLEAR, to clear beforehand [v]\n",
  "PRECLINICAL": "relating to the period preceding clinical manifestations [adj PRECLINICALLY]\n",
  "PRECLINICALLY": "PRECLINICAL, relating to the period preceding clinical manifestations [adv]\n",
  "PRECLUDABLE": "that can be precluded [adj]\n",
  "PRECLUDE": "to rule out or eliminate [v PRECLUDED, PRECLUDING, PRECLUDES]\n",
  "PRECLUDED": "PRECLUDE, to rule out or eliminate [v]\n",
  "PRECLUDES": "PRECLUDE, to rule out or eliminate [v]\n",
  "PRECLUDING": "PRECLUDE, to rule out or eliminate [v]\n",
  "PRECLUSION": "the act of precluding [n -S]\n",
  "PRECLUSIONS": "PRECLUSION, the act of precluding [n]\n",
  "PRECLUSIVE": "tending to preclude [adj PRECLUSIVELY]\n",
  "PRECLUSIVELY": "PRECLUSIVE, tending to preclude [adv]\n",
  "PRECOCIAL": "of or relating to birds whose young are hatched with a covering of down and can leave the nest at once to seek food [adj] / a bird having such young, also PRAECOCIAL [n -S]\n",
  "PRECOCIALS": "PRECOCIAL, a bird having such young, also PRAECOCIAL [n]\n",
  "PRECOCIOUS": "exceptionally early in development or occurrence [adj PRECOCIOUSLY]\n",
  "PRECOCIOUSLY": "PRECOCIOUS, exceptionally early in development or occurrence [adv]\n",
  "PRECOCIOUSNESS": "PRECOCIOUS, exceptionally early in development or occurrence [n]\n",
  "PRECOCITIES": "PRECOCITY, the state of being precocious [n]\n",
  "PRECOCITY": "the state of being precocious [n PRECOCITIES]\n",
  "PRECODE": "to code beforehand [v PRECODED, PRECODING, PRECODES]\n",
  "PRECODED": "PRECODE, to code beforehand [v]\n",
  "PRECODES": "PRECODE, to code beforehand [v]\n",
  "PRECODING": "PRECODE, to code beforehand [v]\n",
  "PRECOGNISANT": "having foreknowledge, also PRECOGNIZANT [adj]\n",
  "PRECOGNISE": "to know beforehand, also PRECOGNIZE [v PRECOGNISED, PRECOGNISING, PRECOGNISES]\n",
  "PRECOGNISED": "PRECOGNISE, to know beforehand, also PRECOGNIZE [v]\n",
  "PRECOGNISES": "PRECOGNISE, to know beforehand, also PRECOGNIZE [v]\n",
  "PRECOGNISING": "PRECOGNISE, to know beforehand, also PRECOGNIZE [v]\n",
  "PRECOGNITION": "clairvoyance relating to an event or state not yet experienced [n -S]\n",
  "PRECOGNITIONS": "PRECOGNITION, clairvoyance relating to an event or state not yet experienced [n]\n",
  "PRECOGNITIVE": "relating to precognition [adj]\n",
  "PRECOGNIZANT": "having foreknowledge, also PRECOGNISANT [adj]\n",
  "PRECOGNIZE": "to know beforehand, also PRECOGNISE [v PRECOGNIZED, PRECOGNIZING, PRECOGNIZES]\n",
  "PRECOGNIZED": "PRECOGNIZE, to know beforehand, also PRECOGNISE [v]\n",
  "PRECOGNIZES": "PRECOGNIZE, to know beforehand, also PRECOGNISE [v]\n",
  "PRECOGNIZING": "PRECOGNIZE, to know beforehand, also PRECOGNISE [v]\n",
  "PRECOGNOSCE": "to take a precognition of [v PRECOGNOSCED, PRECOGNOSCING, PRECOGNOSCES]\n",
  "PRECOGNOSCED": "PRECOGNOSCE, to take a precognition of [v]\n",
  "PRECOGNOSCES": "PRECOGNOSCE, to take a precognition of [v]\n",
  "PRECOGNOSCING": "PRECOGNOSCE, to take a precognition of [v]\n",
  "PRECOITAL": "taking place before coition [adj]\n",
  "PRECOLLEGE": "taking place before attendance at college [adj]\n",
  "PRECOLLEGIATE": "preceding collegiate education [adj]\n",
  "PRECOLONIAL": "taking place before colonialism [adj]\n",
  "PRECOMBUSTION": "a preliminary combustion [n -S]\n",
  "PRECOMBUSTIONS": "PRECOMBUSTION, a preliminary combustion [n]\n",
  "PRECOMMITMENT": "a preliminary commitment [n -S]\n",
  "PRECOMMITMENTS": "PRECOMMITMENT, a preliminary commitment [n]\n",
  "PRECOMPETITIVE": "denoting a period of industrial or commercial development during which competitors work together [adj]\n",
  "PRECOMPOSE": "to compose beforehand [v PRECOMPOSED, PRECOMPOSING, PRECOMPOSES]\n",
  "PRECOMPOSED": "PRECOMPOSE, to compose beforehand [v]\n",
  "PRECOMPOSES": "PRECOMPOSE, to compose beforehand [v]\n",
  "PRECOMPOSING": "PRECOMPOSE, to compose beforehand [v]\n",
  "PRECOMPUTE": "to compute in advance [v PRECOMPUTED, PRECOMPUTING, PRECOMPUTES]\n",
  "PRECOMPUTED": "PRECOMPUTE, to compute in advance [v]\n",
  "PRECOMPUTER": "belonging to the era before computers [adj]\n",
  "PRECOMPUTES": "PRECOMPUTE, to compute in advance [v]\n",
  "PRECOMPUTING": "PRECOMPUTE, to compute in advance [v]\n",
  "PRECONCEIT": "(obsolete) to preconceive; to form a preconceit or preconception [v -ED, -ING, -S]\n",
  "PRECONCEITED": "PRECONCEIT, (obsolete) to preconceive; to form a preconceit or preconception [v]\n",
  "PRECONCEITING": "PRECONCEIT, (obsolete) to preconceive; to form a preconceit or preconception [v]\n",
  "PRECONCEITS": "PRECONCEIT, (obsolete) to preconceive; to form a preconceit or preconception [v]\n",
  "PRECONCEIVE": "to form (as an opinion) prior to actual knowledge or experience [v PRECONCEIVED, PRECONCEIVING, PRECONCEIVES]\n",
  "PRECONCEIVED": "PRECONCEIVE, to form (as an opinion) prior to actual knowledge or experience [v]\n",
  "PRECONCEIVES": "PRECONCEIVE, to form (as an opinion) prior to actual knowledge or experience [v]\n",
  "PRECONCEIVING": "PRECONCEIVE, to form (as an opinion) prior to actual knowledge or experience [v]\n",
  "PRECONCEPTION": "a preconceived idea [n -S]\n",
  "PRECONCEPTIONS": "PRECONCEPTION, a preconceived idea [n]\n",
  "PRECONCERT": "to settle beforehand [v -ED, -ING, -S]\n",
  "PRECONCERTED": "PRECONCERT, to settle beforehand [v]\n",
  "PRECONCERTEDLY": "PRECONCERTED [adv]\n",
  "PRECONCERTING": "PRECONCERT, to settle beforehand [v]\n",
  "PRECONCERTS": "PRECONCERT, to settle beforehand [v]\n",
  "PRECONCILIAR": "preceding a council [adj]\n",
  "PRECONDEMN": "to condemn beforehand [v -ED, -ING, -S]\n",
  "PRECONDEMNED": "PRECONDEMN, to condemn beforehand [v]\n",
  "PRECONDEMNING": "PRECONDEMN, to condemn beforehand [v]\n",
  "PRECONDEMNS": "PRECONDEMN, to condemn beforehand [v]\n",
  "PRECONDITION": "to put in a proper or desired condition or frame of mind esp. in preparation [v -ED, -ING, -S]\n",
  "PRECONDITIONED": "PRECONDITION, to put in a proper or desired condition or frame of mind esp. in preparation [v]\n",
  "PRECONDITIONING": "PRECONDITION, to put in a proper or desired condition or frame of mind esp. in preparation [v]\n",
  "PRECONDITIONS": "PRECONDITION, to put in a proper or desired condition or frame of mind esp. in preparation [v]\n",
  "PRECONISATION": "the process of preconising, also PRECONIZATION [n -S]\n",
  "PRECONISATIONS": "PRECONISATION, the process of preconising, also PRECONIZATION [n]\n",
  "PRECONISE": "to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONIZE [v PRECONISED, PRECONISING, PRECONISES]\n",
  "PRECONISED": "PRECONISE, to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONIZE [v]\n",
  "PRECONISES": "PRECONISE, to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONIZE [v]\n",
  "PRECONISING": "PRECONISE, to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONIZE [v]\n",
  "PRECONIZATION": "the process of preconizing, also PRECONISATION [n -S]\n",
  "PRECONIZATIONS": "PRECONIZATION, the process of preconizing, also PRECONISATION [n]\n",
  "PRECONIZE": "to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONISE [v PRECONIZED, PRECONIZING, PRECONIZES]\n",
  "PRECONIZED": "PRECONIZE, to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONISE [v]\n",
  "PRECONIZES": "PRECONIZE, to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONISE [v]\n",
  "PRECONIZING": "PRECONIZE, to proclaim; to summon publicly; (of the Pope) to proclaim and ratify the election of as bishop, also PRECONISE [v]\n",
  "PRECONQUEST": "taking place before the Norman conquest [adj]\n",
  "PRECONSCIOUS": "of memories, ideas, etc. currently absent from, but which can be readily recalled to, the conscious mind [adj PRECONSCIOUSLY] / the preconscious part of the psyche esp. in psychoanalysis [n -ES]\n",
  "PRECONSCIOUSES": "PRECONSCIOUS, the preconscious part of the psyche esp. in psychoanalysis [n]\n",
  "PRECONSCIOUSLY": "PRECONSCIOUS, of memories, ideas, etc. currently absent from, but which can be readily recalled to, the conscious mind [adv]\n",
  "PRECONSONANTAL": "preceding a consonant [adj]\n",
  "PRECONSTRUCT": "to construct in advance [v -ED, -ING, -S]\n",
  "PRECONSTRUCTED": "PRECONSTRUCT, to construct in advance [v]\n",
  "PRECONSTRUCTING": "PRECONSTRUCT, to construct in advance [v]\n",
  "PRECONSTRUCTION": "construction in advance [n]\n",
  "PRECONSTRUCTS": "PRECONSTRUCT, to construct in advance [v]\n",
  "PRECONSUME": "to consume in advance [v PRECONSUMED, PRECONSUMING, PRECONSUMES]\n",
  "PRECONSUMED": "PRECONSUME, to consume in advance [v]\n",
  "PRECONSUMES": "PRECONSUME, to consume in advance [v]\n",
  "PRECONSUMING": "PRECONSUME, to consume in advance [v]\n",
  "PRECONTACT": "prior contact [n -S]\n",
  "PRECONTACTS": "PRECONTACT, prior contact [n]\n",
  "PRECONTRACT": "to contract in advance [v -ED, -ING, -S]\n",
  "PRECONTRACTED": "PRECONTRACT, to contract in advance [v]\n",
  "PRECONTRACTING": "PRECONTRACT, to contract in advance [v]\n",
  "PRECONTRACTS": "PRECONTRACT, to contract in advance [v]\n",
  "PRECONVENTION": "preceding a convention [adj]\n",
  "PRECONVICTION": "a preliminary conviction [n -S]\n",
  "PRECONVICTIONS": "PRECONVICTION, a preliminary conviction [n]\n",
  "PRECOOK": "to cook beforehand [v -ED, -ING, -S]\n",
  "PRECOOKED": "PRECOOK, to cook beforehand [v]\n",
  "PRECOOKER": "a device for preparing food before cooking [n -S]\n",
  "PRECOOKERS": "PRECOOKER, a device for preparing food before cooking [n]\n",
  "PRECOOKING": "PRECOOK, to cook beforehand [v]\n",
  "PRECOOKS": "PRECOOK, to cook beforehand [v]\n",
  "PRECOOL": "to cool beforehand [v -ED, -ING, -S]\n",
  "PRECOOLED": "PRECOOL, to cool beforehand [v]\n",
  "PRECOOLING": "PRECOOL, to cool beforehand [v]\n",
  "PRECOOLS": "PRECOOL, to cool beforehand [v]\n",
  "PRECOPULATORY": "preceding copulation [adj]\n",
  "PRECORDIAL": "in front of the heart, also PRAECORDIAL [adj]\n",
  "PRECOUP": "preceding a coup [adj]\n",
  "PRECRASH": "preceding a crash [adj]\n",
  "PRECREASE": "to crease in advance [v PRECREASED, PRECREASING, PRECREASES]\n",
  "PRECREASED": "PRECREASE, to crease in advance [v]\n",
  "PRECREASES": "PRECREASE, to crease in advance [v]\n",
  "PRECREASING": "PRECREASE, to crease in advance [v]\n",
  "PRECRISIS": "before a crisis [adj]\n",
  "PRECRITICAL": "prior to the development of critical capacity [adj]\n",
  "PRECURE": "to cure beforehand [v PRECURED, PRECURING, PRECURES]\n",
  "PRECURED": "PRECURE, to cure beforehand [v]\n",
  "PRECURES": "PRECURE, to cure beforehand [v]\n",
  "PRECURING": "PRECURE, to cure beforehand [v]\n",
  "PRECURRER": "(Shakespeare) a precursor, also PRECURSOR [n -S]\n",
  "PRECURRERS": "PRECURRER, (Shakespeare) a precursor, also PRECURSOR [n]\n",
  "PRECURSE": "to foreshadow or be a precursor of, to herald [v PRECURSED, PRECURSING, PRECURSES]\n",
  "PRECURSED": "PRECURSE, to foreshadow or be a precursor of, to herald [v]\n",
  "PRECURSES": "PRECURSE, to foreshadow or be a precursor of, to herald [v]\n",
  "PRECURSING": "PRECURSE, to foreshadow or be a precursor of, to herald [v]\n",
  "PRECURSIVE": "preceding; introductory; precursory [adj]\n",
  "PRECURSOR": "something that goes before, also PRECURRER [n -S]\n",
  "PRECURSORS": "PRECURSOR, something that goes before, also PRECURRER [n]\n",
  "PRECURSORY": "preceding as a precursor or harbinger [adj]\n",
  "PRECUT": "to cut beforehand [v PRECUT, PRECUTTING, PRECUTS]\n",
  "PRECUTS": "PRECUT, to cut beforehand [v]\n",
  "PRECUTTING": "PRECUT, to cut beforehand [v]\n",
  "PRECYCLE": "(of a consumer) to avoid waste by preferring to buy products with minimal packaging [v PRECYCLED, PRECYCLING, PRECYCLES]\n",
  "PRECYCLED": "PRECYCLE, (of a consumer) to avoid waste by preferring to buy products with minimal packaging [v]\n",
  "PRECYCLES": "PRECYCLE, (of a consumer) to avoid waste by preferring to buy products with minimal packaging [v]\n",
  "PRECYCLING": "PRECYCLE, (of a consumer) to avoid waste by preferring to buy products with minimal packaging [v]\n",
  "PREDACEOUS": "living by prey; predatory, also PREDACIOUS [adj]\n",
  "PREDACEOUSNESS": "PREDACEOUS, living by prey; predatory, also PREDACIOUS [n]\n",
  "PREDACIOUS": "living by prey; predatory, also PREDACEOUS [adj]\n",
  "PREDACIOUSNESS": "PREDACIOUS, living by prey; predatory, also PREDACEOUS [n]\n",
  "PREDACITIES": "PREDACITY, being predacious, living by prey [n]\n",
  "PREDACITY": "being predacious, living by prey [n PREDACITIES]\n",
  "PREDATE": "to date before the true date [v PREDATED, PREDATING, PREDATES]\n",
  "PREDATED": "PREDATE, to date before the true date [v]\n",
  "PREDATES": "PREDATE, to date before the true date [v]\n",
  "PREDATING": "PREDATE, to date before the true date [v]\n",
  "PREDATION": "the killing and consuming of other animals for survival, the activity of preying [n -S]\n",
  "PREDATIONS": "PREDATION, the killing and consuming of other animals for survival, the activity of preying [n]\n",
  "PREDATISM": "the state of preying on other animals [n -S]\n",
  "PREDATISMS": "PREDATISM, the state of preying on other animals [n]\n",
  "PREDATIVE": "relating to predation [adj]\n",
  "PREDATOR": "an animal that preys on another [n -S]\n",
  "PREDATORILY": "PREDATORY, preying on other animals [adv]\n",
  "PREDATORINESS": "the state of being predatory [n -ES]\n",
  "PREDATORINESSES": "PREDATORINESS, the state of being predatory [n]\n",
  "PREDATORS": "PREDATOR, an animal that preys on another [n]\n",
  "PREDATORY": "preying on other animals [adj PREDATORILY]\n",
  "PREDAWN": "the time just before dawn [n -S]\n",
  "PREDAWNS": "PREDAWN, the time just before dawn [n]\n",
  "PREDEATH": "the period preceding a person's death [n -S]\n",
  "PREDEATHS": "PREDEATH, the period preceding a person's death [n]\n",
  "PREDEBATE": "before a debate [adj]\n",
  "PREDECEASE": "to die sooner than [v PREDECEASED, PREDECEASING, PREDECEASES]\n",
  "PREDECEASED": "PREDECEASE, to die sooner than [v]\n",
  "PREDECEASES": "PREDECEASE, to die sooner than [v]\n",
  "PREDECEASING": "PREDECEASE, to die sooner than [v]\n",
  "PREDECESSOR": "one that precedes [n -S]\n",
  "PREDECESSORS": "PREDECESSOR, one that precedes [n]\n",
  "PREDEDUCT": "to deduct beforehand [v -ED, -ING, -S]\n",
  "PREDEDUCTED": "PREDEDUCT, to deduct beforehand [v]\n",
  "PREDEDUCTING": "PREDEDUCT, to deduct beforehand [v]\n",
  "PREDEDUCTS": "PREDEDUCT, to deduct beforehand [v]\n",
  "PREDEFINE": "to define in advance [v PREDEFINED, PREDEFINING, PREDEFINES]\n",
  "PREDEFINED": "PREDEFINE, to define in advance [v]\n",
  "PREDEFINES": "PREDEFINE, to define in advance [v]\n",
  "PREDEFINING": "PREDEFINE, to define in advance [v]\n",
  "PREDEFINITION": "the act of predefining [n -S]\n",
  "PREDEFINITIONS": "PREDEFINITION, the act of predefining [n]\n",
  "PREDELIVERIES": "PREDELIVERY, the act of delivering in advance of need, use or expectation of the thing delivered [n]\n",
  "PREDELIVERY": "the act of delivering in advance of need, use or expectation of the thing delivered [n PREDELIVERIES]\n",
  "PREDELLA": "(Italian) a board behind an altar [n PREDELLAS or PREDELLE]\n",
  "PREDELLAS": "PREDELLA, (Italian) a board behind an altar [n]\n",
  "PREDELLE": "PREDELLA, (Italian) a board behind an altar [n]\n",
  "PREDENTARY": "designating a bone situated in front of the dentary bone in some non-mammalian vertebrates (esp. ornithischian dinosaurs) [adj]\n",
  "PREDENTATE": "having teeth in the forepart of the jaw only [adj]\n",
  "PREDEPARTURE": "preceding a departure [adj]\n",
  "PREDEPOSIT": "to deposit in advance [v -ED, -ING, -S]\n",
  "PREDEPOSITED": "PREDEPOSIT, to deposit in advance [v]\n",
  "PREDEPOSITING": "PREDEPOSIT, to deposit in advance [v]\n",
  "PREDEPOSITS": "PREDEPOSIT, to deposit in advance [v]\n",
  "PREDESIGN": "to design in advance [v -ED, -ING, -S]\n",
  "PREDESIGNATE": "to specify beforehand [v PREDESIGNATED, PREDESIGNATING, PREDESIGNATES]\n",
  "PREDESIGNATED": "PREDESIGNATE, to specify beforehand [v]\n",
  "PREDESIGNATES": "PREDESIGNATE, to specify beforehand [v]\n",
  "PREDESIGNATING": "PREDESIGNATE, to specify beforehand [v]\n",
  "PREDESIGNATION": "the act of predesignating [n -S]\n",
  "PREDESIGNATIONS": "PREDESIGNATION, the act of predesignating [n]\n",
  "PREDESIGNATORY": "specifying beforehand [adj]\n",
  "PREDESIGNED": "PREDESIGN, to design in advance [v]\n",
  "PREDESIGNING": "PREDESIGN, to design in advance [v]\n",
  "PREDESIGNS": "PREDESIGN, to design in advance [v]\n",
  "PREDESTINABLE": "capable of being predestined [adj]\n",
  "PREDESTINARIAN": "one who believes in predestination [n -S]\n",
  "PREDESTINARIANS": "PREDESTINARIAN, one who believes in predestination [n]\n",
  "PREDESTINATE": "to determine beforehand [v PREDESTINATED, PREDESTINATING, PREDESTINATES]\n",
  "PREDESTINATED": "PREDESTINATE, to determine beforehand [v]\n",
  "PREDESTINATES": "PREDESTINATE, to determine beforehand [v]\n",
  "PREDESTINATING": "PREDESTINATE, to determine beforehand [v]\n",
  "PREDESTINATION": "the act of predestinating [n -S]\n",
  "PREDESTINATIONS": "PREDESTINATION, the act of predestinating [n]\n",
  "PREDESTINATIVE": "tending to predestine [adj]\n",
  "PREDESTINATOR": "one that predestinates [n -S]\n",
  "PREDESTINATORS": "PREDESTINATOR, one that predestinates [n]\n",
  "PREDESTINE": "to decree beforehand [v PREDESTINED, PREDESTINING, PREDESTINES]\n",
  "PREDESTINED": "PREDESTINE, to decree beforehand [v]\n",
  "PREDESTINES": "PREDESTINE, to decree beforehand [v]\n",
  "PREDESTINIES": "PREDESTINY, predestination [n]\n",
  "PREDESTINING": "PREDESTINE, to decree beforehand [v]\n",
  "PREDESTINY": "predestination [n PREDESTINIES]\n",
  "PREDETERMINABLE": "able to be predetermined [adj]\n",
  "PREDETERMINATE": "determined in advance [adj]\n",
  "PREDETERMINE": "to foreordain, predestine [v PREDETERMINED, PREDETERMINING, PREDETERMINES]\n",
  "PREDETERMINED": "PREDETERMINE, to foreordain, predestine [v]\n",
  "PREDETERMINER": "a limiting noun modifier (as both or all) characterized by occurrence before the determiner in a noun phrase [n -S]\n",
  "PREDETERMINERS": "PREDETERMINER, a limiting noun modifier (as both or all) characterized by occurrence before the determiner in a noun phrase [n]\n",
  "PREDETERMINES": "PREDETERMINE, to foreordain, predestine [v]\n",
  "PREDETERMINING": "PREDETERMINE, to foreordain, predestine [v]\n",
  "PREDETERMINISM": "determinism [n -S]\n",
  "PREDETERMINISMS": "PREDETERMINISM, determinism [n]\n",
  "PREDEVALUATION": "preceding a devaluation [adj]\n",
  "PREDEVELOP": "to develop in advance [v -ED, -ING, -S]\n",
  "PREDEVELOPED": "PREDEVELOP, to develop in advance [v]\n",
  "PREDEVELOPING": "PREDEVELOP, to develop in advance [v]\n",
  "PREDEVELOPMENT": "a preliminary development [n -S]\n",
  "PREDEVELOPMENTS": "PREDEVELOPMENT, a preliminary development [n]\n",
  "PREDEVELOPS": "PREDEVELOP, to develop in advance [v]\n",
  "PREDEVOTE": "to devote or dedicate beforehand [v PREDEVOTED, PREDEVOTING, PREDEVOTES]\n",
  "PREDEVOTED": "PREDEVOTE, to devote or dedicate beforehand [v]\n",
  "PREDEVOTES": "PREDEVOTE, to devote or dedicate beforehand [v]\n",
  "PREDEVOTING": "PREDEVOTE, to devote or dedicate beforehand [v]\n",
  "PREDIABETES": "an asymptomatic abnormal state that precedes the development of clinically evident diabetes [n -ES]\n",
  "PREDIABETESES": "PREDIABETES, an asymptomatic abnormal state that precedes the development of clinically evident diabetes [n]\n",
  "PREDIABETIC": "one suffering from prediabetes [n -S]\n",
  "PREDIABETICS": "PREDIABETIC, one suffering from prediabetes [n]\n",
  "PREDIAL": "a rural slave, also PRAEDIAL [n -S]\n",
  "PREDIALITIES": "PREDIALITY, the quality of being predial [n]\n",
  "PREDIALITY": "the quality of being predial [n PREDIALITIES]\n",
  "PREDIALS": "PREDIAL, a rural slave, also PRAEDIAL [n]\n",
  "PREDICABILITIES": "PREDICABILITY, the quality of being predicable [n]\n",
  "PREDICABILITY": "the quality of being predicable [n PREDICABILITIES]\n",
  "PREDICABLE": "capable of being predicated or affirmed of something [adj] / anything that can be predicated of another [n -S]\n",
  "PREDICABLENESS": "PREDICABLE, capable of being predicated or affirmed of something [n]\n",
  "PREDICABLES": "PREDICABLE, anything that can be predicated of another [n]\n",
  "PREDICAMENT": "the character, status, or classification assigned by a predication [n -S]\n",
  "PREDICAMENTAL": "of or like a predicament [adj]\n",
  "PREDICAMENTS": "PREDICAMENT, the character, status, or classification assigned by a predication [n]\n",
  "PREDICANT": "a preacher; specifically a member of a predicant religious order, also PREDIKANT [n -S]\n",
  "PREDICANTS": "PREDICANT, a preacher; specifically a member of a predicant religious order, also PREDIKANT [n]\n",
  "PREDICATE": "that which is affirmed of the subject of a proposition [n -S] / to affirm or assert [v PREDICATED, PREDICATING, PREDICATES]\n",
  "PREDICATED": "PREDICATE, to affirm or assert [v]\n",
  "PREDICATES": "PREDICATE, to affirm or assert [v]\n",
  "PREDICATING": "PREDICATE, to affirm or assert [v]\n",
  "PREDICATION": "an act or instance of predicating [n -S]\n",
  "PREDICATIONS": "PREDICATION, an act or instance of predicating [n]\n",
  "PREDICATIVE": "indicating the predicate [adj PREDICATIVELY]\n",
  "PREDICATIVELY": "PREDICATIVE, indicating the predicate [adv]\n",
  "PREDICATOR": "in systemic grammar, the part of a sentence or clause containing the verbal group [n -S]\n",
  "PREDICATORS": "PREDICATOR, in systemic grammar, the part of a sentence or clause containing the verbal group [n]\n",
  "PREDICATORY": "pertaining to preaching or a preacher [adj]\n",
  "PREDICT": "to tell of or about in advance [v -ED, -ING, -S]\n",
  "PREDICTABILITY": "the state of being predictable [n]\n",
  "PREDICTABLE": "that can be predicted [adj PREDICTABLY]\n",
  "PREDICTABLENESS": "the state of being predictable [n]\n",
  "PREDICTABLY": "PREDICTABLE, that can be predicted [adv]\n",
  "PREDICTED": "PREDICT, to tell of or about in advance [v]\n",
  "PREDICTER": "one who predicts, also PREDICTOR [n -S]\n",
  "PREDICTERS": "PREDICTER, one who predicts, also PREDICTOR [n]\n",
  "PREDICTING": "PREDICT, to tell of or about in advance [v]\n",
  "PREDICTION": "an act of predicting [n -S]\n",
  "PREDICTIONS": "PREDICTION, an act of predicting [n]\n",
  "PREDICTIVE": "relating to prediction [adj PREDICTIVELY]\n",
  "PREDICTIVELY": "PREDICTIVE, relating to prediction [adv]\n",
  "PREDICTOR": "one who predicts, also PREDICTER [n -S]\n",
  "PREDICTORS": "PREDICTOR, one who predicts, also PREDICTER [n]\n",
  "PREDICTS": "PREDICT, to tell of or about in advance [v]\n",
  "PREDIED": "PREDY, (obsolete) to make ready a ship for engagement [v]\n",
  "PREDIES": "PREDY, (obsolete) to make ready a ship for engagement [v]\n",
  "PREDIGEST": "to digest in advance [v -ED, -ING, -S]\n",
  "PREDIGESTED": "PREDIGEST, to digest in advance [v]\n",
  "PREDIGESTING": "PREDIGEST, to digest in advance [v]\n",
  "PREDIGESTION": "artificial or natural partial digestion of food [n -S]\n",
  "PREDIGESTIONS": "PREDIGESTION, artificial or natural partial digestion of food [n]\n",
  "PREDIGESTS": "PREDIGEST, to digest in advance [v]\n",
  "PREDIKANT": "(Dutch) a Dutch reformed preacher, esp. in South Africa, also PREDICANT [n -S]\n",
  "PREDIKANTS": "PREDIKANT, (Dutch) a Dutch reformed preacher, esp. in South Africa, also PREDICANT [n]\n",
  "PREDILECT": "chosen in preference, also PREDILECTED [adj]\n",
  "PREDILECTED": "chosen in preference, also PREDILECT [adj]\n",
  "PREDILECTION": "an established preference for something [n -S]\n",
  "PREDILECTIONS": "PREDILECTION, an established preference for something [n]\n",
  "PREDINNER": "taking place before dinner [adj] / a meal taken before dinner [n -S]\n",
  "PREDINNERS": "PREDINNER, a meal taken before dinner [n]\n",
  "PREDISCHARGE": "preceding a discharge [adj]\n",
  "PREDISCOVERIES": "PREDISCOVERY, a preliminary discovery [n]\n",
  "PREDISCOVERY": "a preliminary discovery [n PREDISCOVERIES]\n",
  "PREDISPOSAL": "disposal in advance [n -S]\n",
  "PREDISPOSALS": "PREDISPOSAL, disposal in advance [n]\n",
  "PREDISPOSE": "to dispose in advance [v PREDISPOSED, PREDISPOSING, PREDISPOSES]\n",
  "PREDISPOSED": "PREDISPOSE, to dispose in advance [v]\n",
  "PREDISPOSES": "PREDISPOSE, to dispose in advance [v]\n",
  "PREDISPOSING": "PREDISPOSE, to dispose in advance [v]\n",
  "PREDISPOSITION": "an inclination [n -S]\n",
  "PREDISPOSITIONS": "PREDISPOSITION, an inclination [n]\n",
  "PREDIVE": "preceding a dive [adj]\n",
  "PREDNISOLONE": "a drug similar to cortisone, used as an anti-inflammatory, also PREDNISONE [n -S]\n",
  "PREDNISOLONES": "PREDNISOLONE, a drug similar to cortisone, used as an anti-inflammatory, also PREDNISONE [n]\n",
  "PREDNISONE": "a drug similar to cortisone, used as an anti-inflammatory, also PREDNISOLONE [n -S]\n",
  "PREDNISONES": "PREDNISONE, a drug similar to cortisone, used as an anti-inflammatory, also PREDNISOLONE [n]\n",
  "PREDOCTORAL": "of, relating to, or engaged in academic study leading to the doctoral degree [adj]\n",
  "PREDOMINANCE": "the state of being predominant, also PREDOMINANCY [n -S]\n",
  "PREDOMINANCES": "PREDOMINANCE, the state of being predominant, also PREDOMINANCY [n]\n",
  "PREDOMINANCIES": "PREDOMINANCY, the state of being predominant, also PREDOMINANCE [n]\n",
  "PREDOMINANCY": "the state of being predominant, also PREDOMINANCE [n PREDOMINANCIES]\n",
  "PREDOMINANT": "having superior strength, influence, or authority [adj PREDOMINANTLY]\n",
  "PREDOMINANTLY": "PREDOMINANT, having superior strength, influence, or authority [adv]\n",
  "PREDOMINATE": "dominating in quantity [adj PREDOMINATELY] / to hold advantage in numbers or quantity [v PREDOMINATED, PREDOMINATING, PREDOMINATES]\n",
  "PREDOMINATED": "PREDOMINATE, to hold advantage in numbers or quantity [v]\n",
  "PREDOMINATELY": "PREDOMINATE, dominating in quantity [adv]\n",
  "PREDOMINATES": "PREDOMINATE, to hold advantage in numbers or quantity [v]\n",
  "PREDOMINATING": "PREDOMINATE, to hold advantage in numbers or quantity [v]\n",
  "PREDOMINATION": "the act of predominating [n -S]\n",
  "PREDOMINATIONS": "PREDOMINATION, the act of predominating [n]\n",
  "PREDOMINATOR": "one who predominates [n -S]\n",
  "PREDOMINATORS": "PREDOMINATOR, one who predominates [n]\n",
  "PREDOOM": "to sentence in advance [v -ED, -ING, -S]\n",
  "PREDOOMED": "PREDOOM, to sentence in advance [v]\n",
  "PREDOOMING": "PREDOOM, to sentence in advance [v]\n",
  "PREDOOMS": "PREDOOM, to sentence in advance [v]\n",
  "PREDRAFT": "a preliminary draft prior to a main or official draft [n -S]\n",
  "PREDRAFTS": "PREDRAFT, a preliminary draft prior to a main or official draft [n]\n",
  "PREDRIED": "PREDRY, to dry beforehand [v]\n",
  "PREDRIES": "PREDRY, to dry beforehand [v]\n",
  "PREDRILL": "to drill beforehand [v -ED, -ING, -S]\n",
  "PREDRILLED": "PREDRILL, to drill beforehand [v]\n",
  "PREDRILLING": "PREDRILL, to drill beforehand [v]\n",
  "PREDRILLS": "PREDRILL, to drill beforehand [v]\n",
  "PREDRY": "to dry beforehand [v PREDRIED, PREDRYING, PREDRIES]\n",
  "PREDRYING": "PREDRY, to dry beforehand [v]\n",
  "PREDUSK": "the time just before dusk [n -S]\n",
  "PREDUSKS": "PREDUSK, the time just before dusk [n]\n",
  "PREDY": "(obsolete) to make ready a ship for engagement [v PREDIED, PREDYING, PREDIES]\n",
  "PREDYING": "PREDY, (obsolete) to make ready a ship for engagement [v]\n",
  "PREDYNASTIC": "belonging to the period before a dynasty [adj]\n",
  "PREE": "(Scots) to make a trial of, esp. by tasting or kissing [v PREED, PREEING, PREES]\n",
  "PREECLAMPSIA": "a toxic condition occurring in late pregnancy [n -S]\n",
  "PREECLAMPSIAS": "PREECLAMPSIA, a toxic condition occurring in late pregnancy [n]\n",
  "PREECLAMPTIC": "relating to preeclampsia [adj]\n",
  "PREED": "PREE, (Scots) to make a trial of, esp. by tasting or kissing [v]\n",
  "PREEDIT": "to edit beforehand [v -ED, -ING, -S]\n",
  "PREEDITED": "PREEDIT, to edit beforehand [v]\n",
  "PREEDITING": "PREEDIT, to edit beforehand [v]\n",
  "PREEDITS": "PREEDIT, to edit beforehand [v]\n",
  "PREEING": "PREE, (Scots) to make a trial of, esp. by tasting or kissing [v]\n",
  "PREELECT": "to elect beforehand [v -ED, -ING, -S]\n",
  "PREELECTED": "PREELECT, to elect beforehand [v]\n",
  "PREELECTING": "PREELECT, to elect beforehand [v]\n",
  "PREELECTION": "taking place before an election [adj]\n",
  "PREELECTRIC": "dating from before electricity [adj]\n",
  "PREELECTS": "PREELECT, to elect beforehand [v]\n",
  "PREEMBARGO": "before an embargo [adj]\n",
  "PREEMERGENCE": "used or occurring before the emergence of seedlings above the ground [adj]\n",
  "PREEMERGENT": "used or occurring before the emergence of seedlings above the ground [adj]\n",
  "PREEMIE": "a premature baby, also PREMIE, PREMY [n -S]\n",
  "PREEMIES": "PREEMIE, a premature baby, also PREMIE, PREMY [n]\n",
  "PREEMINENCE": "the state of being preeminent, also PREHEMINENCE [n -S]\n",
  "PREEMINENCES": "PREEMINENCE, the state of being preeminent, also PREHEMINENCE [n]\n",
  "PREEMINENT": "having paramount rank, dignity, or importance [adj PREEMINENTLY]\n",
  "PREEMINENTLY": "PREEMINENT, having paramount rank, dignity, or importance [adv]\n",
  "PREEMPLOYMENT": "preceding employment [adj]\n",
  "PREEMPT": "to acquire by prior right [v -ED, -ING, -S]\n",
  "PREEMPTED": "PREEMPT, to acquire by prior right [v]\n",
  "PREEMPTING": "PREEMPT, to acquire by prior right [v]\n",
  "PREEMPTION": "the act or right of purchasing before others [n -S]\n",
  "PREEMPTIONS": "PREEMPTION, the act or right of purchasing before others [n]\n",
  "PREEMPTIVE": "of or pertaining to preemption [adj PREEMPTIVELY]\n",
  "PREEMPTIVELY": "PREEMPTIVE, of or pertaining to preemption [adv]\n",
  "PREEMPTOR": "one who preempts [n -S]\n",
  "PREEMPTORS": "PREEMPTOR, one who preempts [n]\n",
  "PREEMPTS": "PREEMPT, to acquire by prior right [v]\n",
  "PREEN": "to clean and arrange the feathers with the beak [v -ED, -ING, -S]\n",
  "PREENACT": "to enact beforehand [v -ED, -ING, -S]\n",
  "PREENACTED": "PREENACT, to enact beforehand [v]\n",
  "PREENACTING": "PREENACT, to enact beforehand [v]\n",
  "PREENACTS": "PREENACT, to enact beforehand [v]\n",
  "PREENED": "PREEN, to clean and arrange the feathers with the beak [v]\n",
  "PREENER": "one who preens [n -S]\n",
  "PREENERS": "PREENER, one who preens [n]\n",
  "PREENING": "PREEN, to clean and arrange the feathers with the beak [v]\n",
  "PREENROLLMENT": "preceding enrollment [adj]\n",
  "PREENS": "PREEN, to clean and arrange the feathers with the beak [v]\n",
  "PREERECT": "to erect beforehand [v -ED, -ING, -S]\n",
  "PREERECTED": "PREERECT, to erect beforehand [v]\n",
  "PREERECTING": "PREERECT, to erect beforehand [v]\n",
  "PREERECTS": "PREERECT, to erect beforehand [v]\n",
  "PREES": "PREE, (Scots) to make a trial of, esp. by tasting or kissing [v]\n",
  "PREESTABLISH": "to establish in advance [v -ED, -ING, -ES]\n",
  "PREESTABLISHED": "PREESTABLISH, to establish in advance [v]\n",
  "PREESTABLISHES": "PREESTABLISH, to establish in advance [v]\n",
  "PREESTABLISHING": "PREESTABLISH, to establish in advance [v]\n",
  "PREETHICAL": "relating to a state before the development of ethics [adj]\n",
  "PREEVE": "to prove, also PREVE, PRIEVE [v PREEVED, PREEVING, PREEVES]\n",
  "PREEVED": "PREEVE, to prove, also PREVE, PRIEVE [v]\n",
  "PREEVES": "PREEVE, to prove, also PREVE, PRIEVE [v]\n",
  "PREEVING": "PREEVE, to prove, also PREVE, PRIEVE [v]\n",
  "PREEXCITE": "to stimulate in preparation [v PREEXCITED, PREEXCITING, PREEXCITES]\n",
  "PREEXCITED": "PREEXCITE, to stimulate in preparation [v]\n",
  "PREEXCITES": "PREEXCITE, to stimulate in preparation [v]\n",
  "PREEXCITING": "PREEXCITE, to stimulate in preparation [v]\n",
  "PREEXEMPT": "to exempt beforehand [v -ED, -ING, -S]\n",
  "PREEXEMPTED": "PREEXEMPT, to exempt beforehand [v]\n",
  "PREEXEMPTING": "PREEXEMPT, to exempt beforehand [v]\n",
  "PREEXEMPTS": "PREEXEMPT, to exempt beforehand [v]\n",
  "PREEXILIC": "before the exile, used of Old Testament writings prior to the Jewish exile [adj]\n",
  "PREEXIST": "to exist before [v -ED, -ING, -S]\n",
  "PREEXISTED": "PREEXIST, to exist before [v]\n",
  "PREEXISTENCE": "existence in a former state or previous to something else [n -S]\n",
  "PREEXISTENCES": "PREEXISTENCE, existence in a former state or previous to something else [n]\n",
  "PREEXISTENT": "existing beforehand [adj]\n",
  "PREEXISTING": "PREEXIST, to exist before [v]\n",
  "PREEXISTS": "PREEXIST, to exist before [v]\n",
  "PREEXPERIMENT": "preceding an experiment [adj]\n",
  "PREEXPOSE": "to expose in advance [v PREEXPOSED, PREEXPOSING, PREEXPOSES]\n",
  "PREEXPOSED": "PREEXPOSE, to expose in advance [v]\n",
  "PREEXPOSES": "PREEXPOSE, to expose in advance [v]\n",
  "PREEXPOSING": "PREEXPOSE, to expose in advance [v]\n",
  "PREFAB": "(short for) prefabricate, to make standardized parts of beforehand, for assembling later [v PREFABBED, PREFABBING, PREFABS]\n",
  "PREFABBED": "PREFAB, (short for) prefabricate, to make standardized parts of beforehand, for assembling later [v]\n",
  "PREFABBING": "PREFAB, (short for) prefabricate, to make standardized parts of beforehand, for assembling later [v]\n",
  "PREFABRICATE": "to make standardized parts of beforehand, for assembling later [v PREFABRICATED, PREFABRICATING, PREFABRICATES]\n",
  "PREFABRICATED": "PREFABRICATE, to make standardized parts of beforehand, for assembling later [v]\n",
  "PREFABRICATES": "PREFABRICATE, to make standardized parts of beforehand, for assembling later [v]\n",
  "PREFABRICATING": "PREFABRICATE, to make standardized parts of beforehand, for assembling later [v]\n",
  "PREFABRICATION": "the act of prefabricating [n -S]\n",
  "PREFABRICATIONS": "PREFABRICATION, the act of prefabricating [n]\n",
  "PREFABRICATOR": "one who prefabricates [n -S]\n",
  "PREFABRICATORS": "PREFABRICATOR, one who prefabricates [n]\n",
  "PREFABS": "PREFAB, (short for) prefabricate, to make standardized parts of beforehand, for assembling later [v]\n",
  "PREFACE": "to introduce [v PREFACED, PREFACING, PREFACES]\n",
  "PREFACED": "PREFACE, to introduce [v]\n",
  "PREFACER": "one that prefaces [n -S]\n",
  "PREFACERS": "PREFACER, one that prefaces [n]\n",
  "PREFACES": "PREFACE, to introduce [v]\n",
  "PREFACIAL": "relating to a preface [adj]\n",
  "PREFACING": "PREFACE, to introduce [v]\n",
  "PREFADE": "to fade beforehand [v PREFADED, PREFADING, PREFADES]\n",
  "PREFADED": "PREFADE, to fade beforehand [v]\n",
  "PREFADES": "PREFADE, to fade beforehand [v]\n",
  "PREFADING": "PREFADE, to fade beforehand [v]\n",
  "PREFARD": "(Spenser) preferred [v]\n",
  "PREFASCIST": "belonging to the period before fascism [adj]\n",
  "PREFATORIAL": "serving as preface or opening remarks [adj PREFATORIALLY]\n",
  "PREFATORIALLY": "PREFATORIAL, serving as preface or opening remarks [adv]\n",
  "PREFATORILY": "PREFATORY, acting as a preface [adv]\n",
  "PREFATORY": "acting as a preface [adj PREFATORILY]\n",
  "PREFECT": "an ancient Roman official, also PRAEFECT [n -S]\n",
  "PREFECTORIAL": "relating to office of prefect [adj]\n",
  "PREFECTS": "PREFECT, an ancient Roman official, also PRAEFECT [n]\n",
  "PREFECTSHIP": "the office of prefect [n -S]\n",
  "PREFECTSHIPS": "PREFECTSHIP, the office of prefect [n]\n",
  "PREFECTURAL": "relating to a prefecture [adj]\n",
  "PREFECTURE": "the office, position, or jurisdiction of a prefect; also, his official residence [n -S]\n",
  "PREFECTURES": "PREFECTURE, the office, position, or jurisdiction of a prefect; also, his official residence [n]\n",
  "PREFER": "to like better [v PREFERRED, PREFERRING, PREFERS]\n",
  "PREFERABILITIES": "PREFERABILITY, the state of being preferable [n]\n",
  "PREFERABILITY": "the state of being preferable [n PREFERABILITIES]\n",
  "PREFERABLE": "to be preferred, also PREFERRABLE [adj PREFERABLY]\n",
  "PREFERABLENESS": "the state of being preferable [n]\n",
  "PREFERABLY": "PREFERABLE, to be preferred, also PREFERRABLE [adv]\n",
  "PREFERENCE": "the act of preferring [n -S]\n",
  "PREFERENCES": "PREFERENCE, the act of preferring [n]\n",
  "PREFERENTIAL": "showing preference [adj PREFERENTIALLY]\n",
  "PREFERENTIALISM": "favouring a preferential tariff [n]\n",
  "PREFERENTIALIST": "a supporter of preferentialism [n]\n",
  "PREFERENTIALITY": "the state of being preferential [n]\n",
  "PREFERENTIALLY": "PREFERENTIAL, showing preference [adv]\n",
  "PREFERMENT": "promotion [n -S]\n",
  "PREFERMENTS": "PREFERMENT, promotion [n]\n",
  "PREFERRABLE": "(obsolete) preferable [adj]\n",
  "PREFERRED": "PREFER, to like better [v]\n",
  "PREFERRER": "one who prefers [n -S]\n",
  "PREFERRERS": "PREFERRER, one who prefers [n]\n",
  "PREFERRING": "PREFER, to like better [v]\n",
  "PREFERS": "PREFER, to like better [v]\n",
  "PREFEUDAL": "before feudalism [adj]\n",
  "PREFIGHT": "preceding a fight [adj]\n",
  "PREFIGURATE": "to prefigure [v PREFIGURATED, PREFIGURATING, PREFIGURATES]\n",
  "PREFIGURATED": "PREFIGURATE, to prefigure [v]\n",
  "PREFIGURATES": "PREFIGURATE, to prefigure [v]\n",
  "PREFIGURATING": "PREFIGURATE, to prefigure [v]\n",
  "PREFIGURATION": "the act of prefiguring [n -S]\n",
  "PREFIGURATIONS": "PREFIGURATION, the act of prefiguring [n]\n",
  "PREFIGURATIVE": "relating to prefiguration [adj PREFIGURATIVELY]\n",
  "PREFIGURATIVELY": "PREFIGURATIVE, relating to prefiguration [adv]\n",
  "PREFIGURE": "to imagine beforehand; to foreshadow [v PREFIGURED, PREFIGURING, PREFIGURES]\n",
  "PREFIGURED": "PREFIGURE, to imagine beforehand; to foreshadow [v]\n",
  "PREFIGUREMENT": "the act of prefiguring [n -S]\n",
  "PREFIGUREMENTS": "PREFIGUREMENT, the act of prefiguring [n]\n",
  "PREFIGURES": "PREFIGURE, to imagine beforehand; to foreshadow [v]\n",
  "PREFIGURING": "PREFIGURE, to imagine beforehand; to foreshadow [v]\n",
  "PREFILE": "to file beforehand [v PREFILED, PREFILING, PREFILES]\n",
  "PREFILED": "PREFILE, to file beforehand [v]\n",
  "PREFILES": "PREFILE, to file beforehand [v]\n",
  "PREFILING": "PREFILE, to file beforehand [v]\n",
  "PREFILLED": "filled in advance [adj]\n",
  "PREFINANCE": "to finance in advance [v PREFINANCED, PREFINANCING, PREFINANCES]\n",
  "PREFINANCED": "financed in advance [adj]\n",
  "PREFINANCES": "PREFINANCE, to finance in advance [v]\n",
  "PREFINANCING": "financing arragned in advance [n -S]\n",
  "PREFINANCINGS": "PREFINANCING, financing arragned in advance [n]\n",
  "PREFIRE": "to fire beforehand [v PREFIRED, PREFIRING, PREFIRES]\n",
  "PREFIRED": "PREFIRE, to fire beforehand [v]\n",
  "PREFIRES": "PREFIRE, to fire beforehand [v]\n",
  "PREFIRING": "PREFIRE, to fire beforehand [v]\n",
  "PREFIX": "to add to the beginning of a root word [v -ED, -ING, -ES]\n",
  "PREFIXAL": "pertaining to a prefix [adj PREFIXALLY]\n",
  "PREFIXALLY": "PREFIXAL, pertaining to a prefix [adv]\n",
  "PREFIXED": "PREFIX, to add to the beginning of a root word [v]\n",
  "PREFIXES": "PREFIX, to add to the beginning of a root word [v]\n",
  "PREFIXING": "PREFIX, to add to the beginning of a root word [v]\n",
  "PREFIXION": "the act of prefixing [n -S]\n",
  "PREFIXIONS": "PREFIXION, the act of prefixing [n]\n",
  "PREFIXTURE": "the act of prefixing [n -S]\n",
  "PREFIXTURES": "PREFIXTURE, the act of prefixing [n]\n",
  "PREFLAME": "preceding a flame [adj]\n",
  "PREFLIGHT": "to inspect an aircraft before flight [v -ED, -ING, -S]\n",
  "PREFLIGHTED": "PREFLIGHT, to inspect an aircraft before flight [v]\n",
  "PREFLIGHTING": "PREFLIGHT, to inspect an aircraft before flight [v]\n",
  "PREFLIGHTS": "PREFLIGHT, to inspect an aircraft before flight [v]\n",
  "PREFLORATION": "the manner in which the petals and sepals are folded in the flower-bud [n -S]\n",
  "PREFLORATIONS": "PREFLORATION, the manner in which the petals and sepals are folded in the flower-bud [n]\n",
  "PREFOCUS": "to focus beforehand [v PREFOCUSSED or PREFOCUSED, PREFOCUSSING or PREFOCUSING, PREFOCUSSES or PREFOCUSES]\n",
  "PREFOCUSED": "PREFOCUS, to focus beforehand [v]\n",
  "PREFOCUSES": "PREFOCUS, to focus beforehand [v]\n",
  "PREFOCUSING": "PREFOCUS, to focus beforehand [v]\n",
  "PREFOCUSSED": "PREFOCUS, to focus beforehand [v]\n",
  "PREFOCUSSES": "PREFOCUS, to focus beforehand [v]\n",
  "PREFOCUSSING": "PREFOCUS, to focus beforehand [v]\n",
  "PREFOLIATION": "the manner in which the leaf is folded within the leaf bud, vernation [n -S]\n",
  "PREFOLIATIONS": "PREFOLIATION, the manner in which the leaf is folded within the leaf bud, vernation [n]\n",
  "PREFORM": "to form beforehand [v -ED, -ING, -S]\n",
  "PREFORMAT": "to format in advance [v PREFORMATTED, PREFORMATTING, PREFORMATS]\n",
  "PREFORMATION": "previous formation [n -S]\n",
  "PREFORMATIONISM": "the now exploded theory that the plant or animal (and therefore all its descendants) is already preformed in the germ [n]\n",
  "PREFORMATIONIST": "relating to preformation [adj]\n",
  "PREFORMATIONS": "PREFORMATION, previous formation [n]\n",
  "PREFORMATIVE": "a prefixture in Semitic languages [n -S]\n",
  "PREFORMATIVES": "PREFORMATIVE, a prefixture in Semitic languages [n]\n",
  "PREFORMATS": "PREFORMAT, to format in advance [v]\n",
  "PREFORMATTED": "PREFORMAT, to format in advance [v]\n",
  "PREFORMATTING": "PREFORMAT, to format in advance [v]\n",
  "PREFORMED": "PREFORM, to form beforehand [v]\n",
  "PREFORMING": "PREFORM, to form beforehand [v]\n",
  "PREFORMS": "PREFORM, to form beforehand [v]\n",
  "PREFORMULATE": "to formulate in advance [v PREFORMULATED, PREFORMULATING, PREFORMULATES]\n",
  "PREFORMULATED": "PREFORMULATE, to formulate in advance [v]\n",
  "PREFORMULATES": "PREFORMULATE, to formulate in advance [v]\n",
  "PREFORMULATING": "PREFORMULATE, to formulate in advance [v]\n",
  "PREFRANK": "to frank beforehand [v -ED, -ING, -S]\n",
  "PREFRANKED": "PREFRANK, to frank beforehand [v]\n",
  "PREFRANKING": "PREFRANK, to frank beforehand [v]\n",
  "PREFRANKS": "PREFRANK, to frank beforehand [v]\n",
  "PREFREEZE": "to freeze beforehand [v PREFROZE, PREFROZEN, PREFREEZING, PREFREEZES]\n",
  "PREFREEZES": "PREFREEZE, to freeze beforehand [v]\n",
  "PREFREEZING": "PREFREEZE, to freeze beforehand [v]\n",
  "PREFRESHMAN": "one at the stage before becoming a freshman [n PREFRESHMEN]\n",
  "PREFRESHMEN": "PREFRESHMAN, one at the stage before becoming a freshman [n]\n",
  "PREFRONTAL": "in front of, or in the forepart of, the frontal bone, lobe, scale, etc. [adj] / a frontal bone [n -S]\n",
  "PREFRONTALS": "PREFRONTAL, a frontal bone [n]\n",
  "PREFROZE": "PREFREEZE, to freeze beforehand [v]\n",
  "PREFROZEN": "PREFREEZE, to freeze beforehand [v]\n",
  "PREFULGENT": "extremely bright [adj]\n",
  "PREFUND": "to fund beforehand [v -ED, -ING, -S]\n",
  "PREFUNDED": "PREFUND, to fund beforehand [v]\n",
  "PREFUNDING": "PREFUND, to fund beforehand [v]\n",
  "PREFUNDS": "PREFUND, to fund beforehand [v]\n",
  "PREGAME": "to drink alcohol before a game before a game [v PREGAMES, PREGAMING, PREGAMED]\n",
  "PREGAMED": "PREGAME, to drink alcohol before a game before a game [v]\n",
  "PREGAMES": "PREGAME, to drink alcohol before a game before a game [v]\n",
  "PREGAMING": "PREGAME, to drink alcohol before a game before a game [v]\n",
  "PREGANGLIONIC": "proximal to a ganglion [adj]\n",
  "PREGENITAL": "situated in front of the genitals [adj]\n",
  "PREGGERS": "(slang) pregnant, also PREGGO, PREGGY [adj]\n",
  "PREGGIER": "PREGGY, (colloq.) pregnant, also PREGGERS, PREGGO [adj]\n",
  "PREGGIEST": "PREGGY, (colloq.) pregnant, also PREGGERS, PREGGO [adj]\n",
  "PREGGO": "(slang) pregnant, also PREGGERS, PREGGY [adj]\n",
  "PREGGY": "(colloq.) pregnant, also PREGGERS, PREGGO [adj PREGGIER, PREGGIEST]\n",
  "PREGLACIAL": "formed or occurring before a glacial period, esp. before the Pleistocene epoch [adj]\n",
  "PREGNABILITIES": "PREGNABILITY, the state of being pregnable [n]\n",
  "PREGNABILITY": "the state of being pregnable [n PREGNABILITIES]\n",
  "PREGNABLE": "capable of being taken by assault or force [adj]\n",
  "PREGNANCE": "(obsolete) pregnancy, also PREGNANCY [n -S]\n",
  "PREGNANCES": "PREGNANCE, (obsolete) pregnancy, also PREGNANCY [n]\n",
  "PREGNANCIES": "PREGNANCY, the state of being pregnant, also PREGNANCE [n]\n",
  "PREGNANCY": "the state of being pregnant, also PREGNANCE [n PREGNANCIES]\n",
  "PREGNANT": "carrying a developing fetus in the uterus [adj PREGNANTLY]\n",
  "PREGNANTLY": "PREGNANT, carrying a developing fetus in the uterus [adv]\n",
  "PREGNENOLONE": "a steroid ketone formed by the oxidation of steroids and yielding progesterone on dehydrogenation [n -S]\n",
  "PREGNENOLONES": "PREGNENOLONE, a steroid ketone formed by the oxidation of steroids and yielding progesterone on dehydrogenation [n]\n",
  "PREGROWTH": "the period before something begins to grow [n -S]\n",
  "PREGROWTHS": "PREGROWTH, the period before something begins to grow [n]\n",
  "PREGUIDE": "to guide beforehand [v PREGUIDED, PREGUIDING, PREGUIDES]\n",
  "PREGUIDED": "PREGUIDE, to guide beforehand [v]\n",
  "PREGUIDES": "PREGUIDE, to guide beforehand [v]\n",
  "PREGUIDING": "PREGUIDE, to guide beforehand [v]\n",
  "PREGUSTATION": "a foretaste [n -S]\n",
  "PREGUSTATIONS": "PREGUSTATION, a foretaste [n]\n",
  "PREHAB": "any programme of training designed to prevent sports injury [n -S]\n",
  "PREHABS": "PREHAB, any programme of training designed to prevent sports injury [n]\n",
  "PREHALLUCES": "PREHALLUX, an extra first toe, or rudiment of a toe, on the preaxial side of the hallux [n]\n",
  "PREHALLUX": "an extra first toe, or rudiment of a toe, on the preaxial side of the hallux [n PREHALLUCES]\n",
  "PREHANDLE": "to handle beforehand [v PREHANDLED, PREHANDLING, PREHANDLES]\n",
  "PREHANDLED": "PREHANDLE, to handle beforehand [v]\n",
  "PREHANDLES": "PREHANDLE, to handle beforehand [v]\n",
  "PREHANDLING": "PREHANDLE, to handle beforehand [v]\n",
  "PREHARDEN": "to harden in advance [v -ED, -ING, -S]\n",
  "PREHARDENED": "PREHARDEN, to harden in advance [v]\n",
  "PREHARDENING": "PREHARDEN, to harden in advance [v]\n",
  "PREHARDENS": "PREHARDEN, to harden in advance [v]\n",
  "PREHARVEST": "the period before harvest [n -S]\n",
  "PREHARVESTS": "PREHARVEST, the period before harvest [n]\n",
  "PREHEADACHE": "occurring before a headache [adj]\n",
  "PREHEAT": "to heat beforehand [v -ED, -ING, -S]\n",
  "PREHEATED": "PREHEAT, to heat beforehand [v]\n",
  "PREHEATER": "something or someone that preheats [n -S]\n",
  "PREHEATERS": "PREHEATER, something or someone that preheats [n]\n",
  "PREHEATING": "PREHEAT, to heat beforehand [v]\n",
  "PREHEATS": "PREHEAT, to heat beforehand [v]\n",
  "PREHEMINENCE": "(obsolete) preeminence [n -S]\n",
  "PREHEMINENCES": "PREHEMINENCE, (obsolete) preeminence [n]\n",
  "PREHEND": "to lay hold of; to seize [v -ED, -ING, -S]\n",
  "PREHENDED": "PREHEND, to lay hold of; to seize [v]\n",
  "PREHENDING": "PREHEND, to lay hold of; to seize [v]\n",
  "PREHENDS": "PREHEND, to lay hold of; to seize [v]\n",
  "PREHENSIBLE": "capable of being grasped or apprehended [adj]\n",
  "PREHENSILE": "adapted to seize or grasp, esp. by wrapping round; as, the prehensile tail of a monkey, also PREHENSIVE, PREHENSORIAL, PREHENSORY [adj]\n",
  "PREHENSILITIES": "PREHENSILITY, the state of being prehensile [n]\n",
  "PREHENSILITY": "the state of being prehensile [n PREHENSILITIES]\n",
  "PREHENSION": "the act of taking hold, as with the hand or other member [n -S]\n",
  "PREHENSIONS": "PREHENSION, the act of taking hold, as with the hand or other member [n]\n",
  "PREHENSIVE": "prehensile, related to grasping, also PREHENSILE, PREHENSORIAL, PREHENSORY [adj]\n",
  "PREHENSOR": "something that grasps or seizes [n -S]\n",
  "PREHENSORIAL": "prehensile, related to grasping, also PREHENSILE, PREHENSIVE, PREHENSORY [adj]\n",
  "PREHENSORS": "PREHENSOR, something that grasps or seizes [n]\n",
  "PREHENSORY": "adapted to seize or grasp; prehensile, also PREHENSILE, PREHENSIVE, PREHENSORIAL [adj]\n",
  "PREHIRING": "before hiring [adj]\n",
  "PREHISTORIAN": "an archaeologist who specializes in prehistory [n -S]\n",
  "PREHISTORIANS": "PREHISTORIAN, an archaeologist who specializes in prehistory [n]\n",
  "PREHISTORIC": "relating to the time before historical records, also PREHISTORICAL [adj PREHISTORICALLY]\n",
  "PREHISTORICAL": "relating to the time before historical records, also PREHISTORIC [adj PREHISTORICALLY]\n",
  "PREHISTORICALLY": "PREHISTORICAL, relating to the time before historical records, also PREHISTORIC [adv]\n",
  "PREHISTORIES": "PREHISTORY, the time before historical records [n]\n",
  "PREHISTORY": "the time before historical records [n PREHISTORIES]\n",
  "PREHNITE": "an orthorhombic basic silicate of aluminium and calcium, usually occurring in pale green vitreous masses [n -S]\n",
  "PREHNITES": "PREHNITE, an orthorhombic basic silicate of aluminium and calcium, usually occurring in pale green vitreous masses [n]\n",
  "PREHOLIDAY": "taking place before a holiday [adj]\n",
  "PREHOMINID": "preceding the evolution of hominids [adj] / an ancestor of hominids [n -S]\n",
  "PREHOMINIDS": "PREHOMINID, an ancestor of hominids [n]\n",
  "PREHUMAN": "a prototype of man [n -S]\n",
  "PREHUMANS": "PREHUMAN, a prototype of man [n]\n",
  "PREIF": "(obsolete) proof, also PREIFE, PRIEF, PRIEFE [n -S]\n",
  "PREIFE": "(obsolete) proof, also PREIF, PRIEF, PRIEFE [n -S]\n",
  "PREIFES": "PREIFE, (obsolete) proof, also PREIF, PRIEF, PRIEFE [n]\n",
  "PREIFS": "PREIF, (obsolete) proof, also PREIFE, PRIEF, PRIEFE [n]\n",
  "PREIGNITION": "ignition in an internal combustion engine while the inlet valve is open or before compression is completed [n -S]\n",
  "PREIGNITIONS": "PREIGNITION, ignition in an internal combustion engine while the inlet valve is open or before compression is completed [n]\n",
  "PREIMPLANTATION": "of, involving, or being an embryo before uterine implantation [adj]\n",
  "PREIMPOSE": "to impose in advance [v PREIMPOSED, PREIMPOSING, PREIMPOSES]\n",
  "PREIMPOSED": "PREIMPOSE, to impose in advance [v]\n",
  "PREIMPOSES": "PREIMPOSE, to impose in advance [v]\n",
  "PREIMPOSING": "PREIMPOSE, to impose in advance [v]\n",
  "PREINAUGURAL": "preceding an inauguration [adj]\n",
  "PREINDUCTION": "preceding an induction [adj]\n",
  "PREINDUSTRIAL": "preceding an industrial phase [adj]\n",
  "PREINFORM": "to inform in advance [v -ED, -ING, -S]\n",
  "PREINFORMED": "PREINFORM, to inform in advance [v]\n",
  "PREINFORMING": "PREINFORM, to inform in advance [v]\n",
  "PREINFORMS": "PREINFORM, to inform in advance [v]\n",
  "PREINSERT": "to insert beforehand [v -ED, -ING, -S]\n",
  "PREINSERTED": "PREINSERT, to insert beforehand [v]\n",
  "PREINSERTING": "PREINSERT, to insert beforehand [v]\n",
  "PREINSERTS": "PREINSERT, to insert beforehand [v]\n",
  "PREINTERVIEW": "to interview in advance [v -ED, -ING, -S]\n",
  "PREINTERVIEWED": "PREINTERVIEW, to interview in advance [v]\n",
  "PREINTERVIEWING": "PREINTERVIEW, to interview in advance [v]\n",
  "PREINTERVIEWS": "PREINTERVIEW, to interview in advance [v]\n",
  "PREINVASION": "preceding an invasion [adj]\n",
  "PREINVITE": "to invite beforehand [v PREINVITED, PREINVITING, PREINVITES]\n",
  "PREINVITED": "PREINVITE, to invite beforehand [v]\n",
  "PREINVITES": "PREINVITE, to invite beforehand [v]\n",
  "PREINVITING": "PREINVITE, to invite beforehand [v]\n",
  "PREJINK": "(Scots) prim; finical, also PERJINK, PERJINKETY [adj]\n",
  "PREJUDGE": "to judge beforehand [v PREJUDGED, PREJUDGING, PREJUDGES]\n",
  "PREJUDGED": "PREJUDGE, to judge beforehand [v]\n",
  "PREJUDGEMENT": "the act of prejudging, also PREJUDGMENT [n -S]\n",
  "PREJUDGEMENTS": "PREJUDGEMENT, the act of prejudging, also PREJUDGMENT [n]\n",
  "PREJUDGER": "one who prejudges [n -S]\n",
  "PREJUDGERS": "PREJUDGER, one who prejudges [n]\n",
  "PREJUDGES": "PREJUDGE, to judge beforehand [v]\n",
  "PREJUDGING": "PREJUDGE, to judge beforehand [v]\n",
  "PREJUDGMENT": "the act of prejudging, also PREJUDGEMENT [n -S]\n",
  "PREJUDGMENTS": "PREJUDGMENT, the act of prejudging, also PREJUDGEMENT [n]\n",
  "PREJUDICANT": "prejudging [adj]\n",
  "PREJUDICATE": "(obsolete) to spoil, prejudice [v PREJUDICATED, PREJUDICATING, PREJUDICATES]\n",
  "PREJUDICATED": "PREJUDICATE, (obsolete) to spoil, prejudice [v]\n",
  "PREJUDICATES": "PREJUDICATE, (obsolete) to spoil, prejudice [v]\n",
  "PREJUDICATING": "PREJUDICATE, (obsolete) to spoil, prejudice [v]\n",
  "PREJUDICATION": "the act of prejudging [n -S]\n",
  "PREJUDICATIONS": "PREJUDICATION, the act of prejudging [n]\n",
  "PREJUDICATIVE": "prejudging [adj]\n",
  "PREJUDICE": "a judgement or opinion formed prematurely [n -S] / to prepossess or bias in favour or against something [v PREJUDICED, PREJUDICING, PREJUDICES]\n",
  "PREJUDICED": "PREJUDICE, to prepossess or bias in favour or against something [v]\n",
  "PREJUDICES": "PREJUDICE, to prepossess or bias in favour or against something [v]\n",
  "PREJUDICIAL": "tending to injure or impair [adj PREJUDICIALLY]\n",
  "PREJUDICIALLY": "PREJUDICIAL, tending to injure or impair [adv]\n",
  "PREJUDICIALNESS": "PREJUDICIAL, tending to injure or impair [n]\n",
  "PREJUDICING": "PREJUDICE, to prepossess or bias in favour or against something [v]\n",
  "PREJUDIZE": "(Spenser) prognostication [n -S]\n",
  "PREJUDIZES": "PREJUDIZE, (Spenser) prognostication [n]\n",
  "PREKINDERGARTEN": "a nursery school [n]\n",
  "PRELACIES": "PRELACY, the office of a prelate, also PRELATY [n]\n",
  "PRELACY": "the office of a prelate, also PRELATY [n PRELACIES]\n",
  "PRELAPSARIAN": "relating to any innocent or carefree period in the past [adj]\n",
  "PRELATE": "a high ranking clergyman [n -S]\n",
  "PRELATES": "PRELATE, a high ranking clergyman [n]\n",
  "PRELATESHIP": "the office of prelate [n -S]\n",
  "PRELATESHIPS": "PRELATESHIP, the office of prelate [n]\n",
  "PRELATESS": "a female prelate [n -ES]\n",
  "PRELATESSES": "PRELATESS, a female prelate [n]\n",
  "PRELATIAL": "relating to a prelate, a bishop or abbot of superior rank, also PRELATIC, PRELATICAL [adj]\n",
  "PRELATIC": "relating to a prelate, a bishop or abbot of superior rank, also PRELATIAL, PRELATICAL [adj PRELATICALLY]\n",
  "PRELATICAL": "relating to a prelate, a bishop or abbot of superior rank, also PRELATIAL, PRELATIC [adj PRELATICALLY]\n",
  "PRELATICALLY": "PRELATICAL, relating to a prelate, a bishop or abbot of superior rank, also PRELATIAL, PRELATIC [adv]\n",
  "PRELATIES": "PRELATY, the office of a prelate, also PRELACY [n]\n",
  "PRELATION": "preferment; promotion; eminence [n -S]\n",
  "PRELATIONS": "PRELATION, preferment; promotion; eminence [n]\n",
  "PRELATISE": "to bring under the influence of the prelacy, also PRELATIZE [v PRELATISED, PRELATISING, PRELATISES]\n",
  "PRELATISED": "PRELATISE, to bring under the influence of the prelacy, also PRELATIZE [v]\n",
  "PRELATISES": "PRELATISE, to bring under the influence of the prelacy, also PRELATIZE [v]\n",
  "PRELATISH": "(Milton) like a prelate [adj]\n",
  "PRELATISING": "PRELATISE, to bring under the influence of the prelacy, also PRELATIZE [v]\n",
  "PRELATISM": "domination by prelates [n -S]\n",
  "PRELATISMS": "PRELATISM, domination by prelates [n]\n",
  "PRELATIST": "a supporter or adherent of prelacy or episcopacy [n -S]\n",
  "PRELATISTS": "PRELATIST, a supporter or adherent of prelacy or episcopacy [n]\n",
  "PRELATIZE": "to bring under the influence of the prelacy, also PRELATISE [v PRELATIZED, PRELATIZING, PRELATIZES]\n",
  "PRELATIZED": "PRELATIZE, to bring under the influence of the prelacy, also PRELATISE [v]\n",
  "PRELATIZES": "PRELATIZE, to bring under the influence of the prelacy, also PRELATISE [v]\n",
  "PRELATIZING": "PRELATIZE, to bring under the influence of the prelacy, also PRELATISE [v]\n",
  "PRELATURE": "the office of prelate, a bishop or abbot of superior rank [n -S]\n",
  "PRELATURES": "PRELATURE, the office of prelate, a bishop or abbot of superior rank [n]\n",
  "PRELATY": "the office of a prelate, also PRELACY [n PRELATIES]\n",
  "PRELAUNCH": "preceding a launch [adj] / to launch in advance [v -ED, -ING, -ES]\n",
  "PRELAUNCHED": "PRELAUNCH, to launch in advance [v]\n",
  "PRELAUNCHES": "PRELAUNCH, to launch in advance [v]\n",
  "PRELAUNCHING": "PRELAUNCH, to launch in advance [v]\n",
  "PRELAW": "before taking up the study of law [adj]\n",
  "PRELECT": "to lecture, also PRAELECT [v -ED, -ING, -S]\n",
  "PRELECTED": "PRELECT, to lecture, also PRAELECT [v]\n",
  "PRELECTING": "PRELECT, to lecture, also PRAELECT [v]\n",
  "PRELECTION": "a lecture or discourse read in public or to a select company [n -S]\n",
  "PRELECTIONS": "PRELECTION, a lecture or discourse read in public or to a select company [n]\n",
  "PRELECTOR": "a reader of lectures or discourses [n -S]\n",
  "PRELECTORS": "PRELECTOR, a reader of lectures or discourses [n]\n",
  "PRELECTS": "PRELECT, to lecture, also PRAELECT [v]\n",
  "PRELEGAL": "occurring before the commencement of studies in law [adj]\n",
  "PRELEXICAL": "denoting a stage in the formation of a sentence at which words and phrases have not yet replaced all of the underlying grammatical and semantic material of that sentence in the speaker's mind [adj]\n",
  "PRELIBATION": "a foretaste; an offering of first fruits [n -S]\n",
  "PRELIBATIONS": "PRELIBATION, a foretaste; an offering of first fruits [n]\n",
  "PRELIFE": "a life conceived of as lived before one's earthly life [n PRELIVES]\n",
  "PRELIM": "a preliminary or entrance examination [n -S]\n",
  "PRELIMINARIES": "PRELIMINARY, something that precedes or is introductory or preparatory [n]\n",
  "PRELIMINARILY": "PRELIMINARY, preceding [adv]\n",
  "PRELIMINARY": "preceding [adj PRELIMINARILY] / something that precedes or is introductory or preparatory [n PRELIMINARIES]\n",
  "PRELIMIT": "to limit beforehand [v -ED, -ING, -S]\n",
  "PRELIMITED": "PRELIMIT, to limit beforehand [v]\n",
  "PRELIMITING": "PRELIMIT, to limit beforehand [v]\n",
  "PRELIMITS": "PRELIMIT, to limit beforehand [v]\n",
  "PRELIMS": "PRELIM, a preliminary or entrance examination [n]\n",
  "PRELINGUAL": "before the use of language [adj PRELINGUALLY]\n",
  "PRELINGUALLY": "PRELINGUAL, before the use of language [adv]\n",
  "PRELITERACIES": "PRELITERACY, the state of being preliterate, not having developed a written language [n]\n",
  "PRELITERACY": "the state of being preliterate, not having developed a written language [n PRELITERACIES]\n",
  "PRELITERARY": "before the written word [adj]\n",
  "PRELITERATE": "not yet employing writing as a cultural medium [adj] / one not yet employing writing as a cultural medium [n -S]\n",
  "PRELITERATES": "PRELITERATE, one not yet employing writing as a cultural medium [n]\n",
  "PRELIVES": "PRELIFE, a life conceived of as lived before one's earthly life [n]\n",
  "PRELOAD": "to load beforehand [v -ED, -ING, -S]\n",
  "PRELOADED": "PRELOAD, to load beforehand [v]\n",
  "PRELOADING": "PRELOAD, to load beforehand [v]\n",
  "PRELOADS": "PRELOAD, to load beforehand [v]\n",
  "PRELOCATE": "to locate in advance [v PRELOCATED, PRELOCATING, PRELOCATES]\n",
  "PRELOCATED": "PRELOCATE, to locate in advance [v]\n",
  "PRELOCATES": "PRELOCATE, to locate in advance [v]\n",
  "PRELOCATING": "PRELOCATE, to locate in advance [v]\n",
  "PRELOGICAL": "before the development of logic [adj]\n",
  "PRELOVED": "a euphemism for used, previously owned by somebody else [adj]\n",
  "PRELUDE": "something that goes before; an introductory passage [n -S] / to play a musical introduction [v PRELUDED, PRELUDING, PRELUDES]\n",
  "PRELUDED": "PRELUDE, to play a musical introduction [v]\n",
  "PRELUDER": "a person who plays or performs a prelude [n -S]\n",
  "PRELUDERS": "PRELUDER, a person who plays or performs a prelude [n]\n",
  "PRELUDES": "PRELUDE, to play a musical introduction [v]\n",
  "PRELUDI": "PRELUDIO, (Italian) a prelude [n]\n",
  "PRELUDIAL": "of or pertaining to a prelude, also PRELUDIOUS [adj]\n",
  "PRELUDING": "PRELUDE, to play a musical introduction [v]\n",
  "PRELUDIO": "(Italian) a prelude [n PRELUDI or PRELUDIOS]\n",
  "PRELUDIOS": "PRELUDIO, (Italian) a prelude [n]\n",
  "PRELUDIOUS": "of or pertaining to a prelude, also PRELUDIAL [adj]\n",
  "PRELUNCH": "before lunch [adj]\n",
  "PRELUNCHEON": "a light meal before lunch [n -S]\n",
  "PRELUNCHEONS": "PRELUNCHEON, a light meal before lunch [n]\n",
  "PRELUSION": "a prelude, an introduction [n -S]\n",
  "PRELUSIONS": "PRELUSION, a prelude, an introduction [n]\n",
  "PRELUSIVE": "introductory, also PRELUSORY [adj PRELUSIVELY]\n",
  "PRELUSIVELY": "PRELUSIVE, introductory, also PRELUSORY [adv]\n",
  "PRELUSORILY": "PRELUSORY, introductory, also PRELUSIVE [adv]\n",
  "PRELUSORY": "introductory, also PRELUSIVE [adj PRELUSORILY]\n",
  "PREM": "a premature baby, also PREEMIE, PREMIE, PREMY [n -S]\n",
  "PREMADE": "PREMAKE, to make in advance [v]\n",
  "PREMAKE": "to make in advance [v PREMADE, PREMAKING, PREMAKES]\n",
  "PREMAKES": "PREMAKE, to make in advance [v]\n",
  "PREMAKING": "PREMAKE, to make in advance [v]\n",
  "PREMALIGNANT": "precancerous [adj]\n",
  "PREMAN": "a hypothetical ancestor of man [n PREMEN]\n",
  "PREMANDIBULAR": "in front of the lower jaw [adj] / a bone so placed in fishes, etc. [n -S]\n",
  "PREMANDIBULARS": "PREMANDIBULAR, a bone so placed in fishes, etc. [n]\n",
  "PREMANUFACTURE": "to manufacture in advance [v PREMANUFACTURED, PREMANUFACTURES]\n",
  "PREMANUFACTURED": "PREMANUFACTURE, to manufacture in advance [v]\n",
  "PREMANUFACTURES": "PREMANUFACTURE, to manufacture in advance [v]\n",
  "PREMARITAL": "taking place before marriage [adj PREMARITALLY]\n",
  "PREMARITALLY": "PREMARITAL, taking place before marriage [adv]\n",
  "PREMARKET": "before the development of a market [n -S] / to market in advance [v -ED, -ING, -S]\n",
  "PREMARKETED": "PREMARKET, to market in advance [v]\n",
  "PREMARKETING": "PREMARKET, to market in advance [v]\n",
  "PREMARKETS": "PREMARKET, to market in advance [v]\n",
  "PREMARRIAGE": "relating to the time before a marriage [adj]\n",
  "PREMATURE": "ahead of due time [adj PREMATURELY] / a premature baby, also PREEMIE, PREM, PREMIE, PREMY [n -S]\n",
  "PREMATURELY": "PREMATURE, ahead of due time [adv]\n",
  "PREMATURENESS": "the state of being premature [n -ES]\n",
  "PREMATURENESSES": "PREMATURENESS, the state of being premature [n]\n",
  "PREMATURES": "PREMATURE, a premature baby, also PREEMIE, PREM, PREMIE, PREMY [n]\n",
  "PREMATURITIES": "PREMATURITY, the state of being premature [n]\n",
  "PREMATURITY": "the state of being premature [n PREMATURITIES]\n",
  "PREMAXILLA": "(Latin) a bone in front of the maxilla, also PREMAXILLARY [n PREMAXILLAE or PREMAXILLAS]\n",
  "PREMAXILLAE": "PREMAXILLA, (Latin) a bone in front of the maxilla, also PREMAXILLARY [n]\n",
  "PREMAXILLARIES": "PREMAXILLARY, the premaxilla, a bone in front of the maxilla, also PREMAXILLA [n]\n",
  "PREMAXILLARY": "the premaxilla, a bone in front of the maxilla, also PREMAXILLA [n PREMAXILLARIES]\n",
  "PREMAXILLAS": "PREMAXILLA, (Latin) a bone in front of the maxilla, also PREMAXILLARY [n]\n",
  "PREMEAL": "before a meal [adj]\n",
  "PREMEASURE": "to measure in advance [v PREMEASURED, PREMEASURING, PREMEASURES]\n",
  "PREMEASURED": "PREMEASURE, to measure in advance [v]\n",
  "PREMEASURES": "PREMEASURE, to measure in advance [v]\n",
  "PREMEASURING": "PREMEASURE, to measure in advance [v]\n",
  "PREMED": "a student preparing for the study of medicine, also PREMEDIC [n -S]\n",
  "PREMEDIC": "a student preparing for the study of medicine, also PREMED [n -S]\n",
  "PREMEDICAL": "of or relating to a course of study undertaken in preparation for professional medical training [adj PREMEDICALLY]\n",
  "PREMEDICALLY": "PREMEDICAL, of or relating to a course of study undertaken in preparation for professional medical training [adv]\n",
  "PREMEDICATE": "to administer premedication to [v PREMEDICATED, PREMEDICATING, PREMEDICATES]\n",
  "PREMEDICATED": "PREMEDICATE, to administer premedication to [v]\n",
  "PREMEDICATES": "PREMEDICATE, to administer premedication to [v]\n",
  "PREMEDICATING": "PREMEDICATE, to administer premedication to [v]\n",
  "PREMEDICATION": "drugs given to sedate and prepare a patient, esp. for the administration of a general anaesthetic prior to surgery, etc. [n -S]\n",
  "PREMEDICATIONS": "PREMEDICATION, drugs given to sedate and prepare a patient, esp. for the administration of a general anaesthetic prior to surgery, etc. [n]\n",
  "PREMEDICS": "PREMEDIC, a student preparing for the study of medicine, also PREMED [n]\n",
  "PREMEDIEVAL": "taking place before the mediaeval period [adj]\n",
  "PREMEDITATE": "to think about and revolve in the mind beforehand [v PREMEDITATED, PREMEDITATING, PREMEDITATES]\n",
  "PREMEDITATED": "PREMEDITATE, to think about and revolve in the mind beforehand [v]\n",
  "PREMEDITATEDLY": "PREMEDITATED, PREMEDITATE, to think about and revolve in the mind beforehand [adv]\n",
  "PREMEDITATES": "PREMEDITATE, to think about and revolve in the mind beforehand [v]\n",
  "PREMEDITATING": "PREMEDITATE, to think about and revolve in the mind beforehand [v]\n",
  "PREMEDITATION": "an act or instance of premeditating [n -S]\n",
  "PREMEDITATIONS": "PREMEDITATION, an act or instance of premeditating [n]\n",
  "PREMEDITATIVE": "given to or characterized by premeditation [adj]\n",
  "PREMEDITATOR": "one who premeditates [n -S]\n",
  "PREMEDITATORS": "PREMEDITATOR, one who premeditates [n]\n",
  "PREMEDS": "PREMED, a student preparing for the study of medicine, also PREMEDIC [n]\n",
  "PREMEET": "taking place before a meet [adj]\n",
  "PREMEIOTIC": "taking place before meiosis [adj]\n",
  "PREMEN": "PREMAN, a hypothetical ancestor of man [n]\n",
  "PREMENOPAUSAL": "preceding the menopause [adj]\n",
  "PREMENSTRUAL": "taking place before menstruation [adj PREMENSTRUALLY]\n",
  "PREMENSTRUALLY": "PREMENSTRUAL, taking place before menstruation [adv]\n",
  "PREMERGER": "before a merger [adj]\n",
  "PREMIA": "PREMIUM, (Latin) a sum regularly payable for insurance [n]\n",
  "PREMIE": "(US slang) a premature baby, also PREEMIE, PREM, PREMY [n -S]\n",
  "PREMIER": "a chief in rank or office [n -S]\n",
  "PREMIERE": "(French) to present publicly for the first time [v PREMIERED, PREMIERING, PREMIERES]\n",
  "PREMIERED": "PREMIERE, (French) to present publicly for the first time [v]\n",
  "PREMIERES": "PREMIERE, (French) to present publicly for the first time [v]\n",
  "PREMIERING": "PREMIERE, (French) to present publicly for the first time [v]\n",
  "PREMIERS": "PREMIER, a chief in rank or office [n]\n",
  "PREMIERSHIP": "the office of premier [n -S]\n",
  "PREMIERSHIPS": "PREMIERSHIP, the office of premier [n]\n",
  "PREMIES": "PREMY, (US slang) a premature baby, also PREEMIE, PREM, PREMIE [n]\n",
  "PREMIGRATION": "preceding migration [adj]\n",
  "PREMILLENARIAN": "a believer in the premillennial coming of Christ [n -S]\n",
  "PREMILLENARIANS": "PREMILLENARIAN, a believer in the premillennial coming of Christ [n]\n",
  "PREMILLENNIAL": "coming before a millennium [adj PREMILLENNIALLY] / one born before a millennium [n -S]\n",
  "PREMILLENNIALLY": "PREMILLENNIAL, coming before a millennium [adv]\n",
  "PREMILLENNIALS": "PREMILLENNIAL, one born before a millennium [n]\n",
  "PREMISE": "to state in advance [v PREMISED, PREMISING, PREMISES]\n",
  "PREMISED": "PREMISE, to state in advance [v]\n",
  "PREMISES": "PREMISE, to state in advance [v]\n",
  "PREMISING": "PREMISE, to state in advance [v]\n",
  "PREMISS": "to state or assume [v -ED, -ING, -ES]\n",
  "PREMISSED": "PREMISS, to state or assume [v]\n",
  "PREMISSES": "PREMISS, to state or assume [v]\n",
  "PREMISSING": "PREMISS, to state or assume [v]\n",
  "PREMIUM": "(Latin) a sum regularly payable for insurance [n PREMIUMS or PREMIA]\n",
  "PREMIUMS": "PREMIUM, (Latin) a sum regularly payable for insurance [n]\n",
  "PREMIX": "to mix before use [v PREMIXT or PREMIXED, PREMIXING, PREMIXES]\n",
  "PREMIXED": "PREMIX, to mix before use [v]\n",
  "PREMIXES": "PREMIX, to mix before use [v]\n",
  "PREMIXING": "PREMIX, to mix before use [v]\n",
  "PREMIXT": "PREMIX, to mix before use [v]\n",
  "PREMODERN": "occurring before the modern era [adj]\n",
  "PREMODIFICATION": "preceding a modification [adj]\n",
  "PREMODIFIED": "PREMODIFY, to modify beforehand [v]\n",
  "PREMODIFIES": "PREMODIFY, to modify beforehand [v]\n",
  "PREMODIFY": "to modify beforehand [v PREMODIFIED, PREMODIFYING, PREMODIFIES]\n",
  "PREMODIFYING": "PREMODIFY, to modify beforehand [v]\n",
  "PREMOISTEN": "to moisten beforehand [v -ED, -ING, -S]\n",
  "PREMOISTENED": "PREMOISTEN, to moisten beforehand [v]\n",
  "PREMOISTENING": "PREMOISTEN, to moisten beforehand [v]\n",
  "PREMOISTENS": "PREMOISTEN, to moisten beforehand [v]\n",
  "PREMOLAR": "situated in front of the molar teeth [adj] / a premolar tooth [n -S]\n",
  "PREMOLARS": "PREMOLAR, a premolar tooth [n]\n",
  "PREMOLD": "to mold beforehand, also PREMOULD [v -ED, -ING, -S]\n",
  "PREMOLDED": "PREMOLD, to mold beforehand, also PREMOULD [v]\n",
  "PREMOLDING": "PREMOLD, to mold beforehand, also PREMOULD [v]\n",
  "PREMOLDS": "PREMOLD, to mold beforehand, also PREMOULD [v]\n",
  "PREMOLT": "preceding a molt, also PREMOULT [adj]\n",
  "PREMONISH": "to warn beforehand [v -ED, -ING, -ES]\n",
  "PREMONISHED": "PREMONISH, to warn beforehand [v]\n",
  "PREMONISHES": "PREMONISH, to warn beforehand [v]\n",
  "PREMONISHING": "PREMONISH, to warn beforehand [v]\n",
  "PREMONISHMENT": "the act of premonishing [n -S]\n",
  "PREMONISHMENTS": "PREMONISHMENT, the act of premonishing [n]\n",
  "PREMONITION": "previous notice or warning [n -S]\n",
  "PREMONITIONS": "PREMONITION, previous notice or warning [n]\n",
  "PREMONITIVE": "conveying a warning, also PREMONITORY [adj]\n",
  "PREMONITOR": "one who, or that which, gives premonition [n -S]\n",
  "PREMONITORILY": "PREMONITORY, conveying a warning, also PREMONITIVE [adv]\n",
  "PREMONITORS": "PREMONITOR, one who, or that which, gives premonition [n]\n",
  "PREMONITORY": "conveying a warning, also PREMONITIVE [adj PREMONITORILY]\n",
  "PREMORAL": "preceding the development of a moral code [adj]\n",
  "PREMORSE": "ending abruptly, as if bitten off [adj]\n",
  "PREMOSAIC": "relating to the time before Moses [adj]\n",
  "PREMOTION": "a motion or impulse given beforehand; esp. divine action as determining will [n -S]\n",
  "PREMOTIONS": "PREMOTION, a motion or impulse given beforehand; esp. divine action as determining will [n]\n",
  "PREMOTOR": "pertaining to a part of the frontal lobe of the brain [adj]\n",
  "PREMOULD": "to mould in advance, also PREMOLD [v -ED, -ING, -S]\n",
  "PREMOULDED": "PREMOULD, to mould in advance, also PREMOLD [v]\n",
  "PREMOULDING": "PREMOULD, to mould in advance, also PREMOLD [v]\n",
  "PREMOULDS": "PREMOULD, to mould in advance, also PREMOLD [v]\n",
  "PREMOULT": "preceding moult, also PREMOLT [adj]\n",
  "PREMOVE": "to incite or prompt to action [v PREMOVED, PREMOVING, PREMOVES]\n",
  "PREMOVED": "PREMOVE, to incite or prompt to action [v]\n",
  "PREMOVEMENT": "the act of premoving [n -S]\n",
  "PREMOVEMENTS": "PREMOVEMENT, the act of premoving [n]\n",
  "PREMOVES": "PREMOVE, to incite or prompt to action [v]\n",
  "PREMOVING": "PREMOVE, to incite or prompt to action [v]\n",
  "PREMS": "PREM, a premature baby, also PREEMIE, PREMIE, PREMY [n]\n",
  "PREMUNE": "resistant to a disease [adj]\n",
  "PREMUNITION": "the provision of relative immunity to a severe infection as a result of inducing a low-grade version [n -S]\n",
  "PREMUNITIONS": "PREMUNITION, the provision of relative immunity to a severe infection as a result of inducing a low-grade version [n]\n",
  "PREMY": "(US slang) a premature baby, also PREEMIE, PREM, PREMIE [n PREMIES]\n",
  "PREMYCOTIC": "taking place before mycosis, disease due to the growth of a fungus [adj]\n",
  "PRENAME": "a forename [n -S]\n",
  "PRENAMES": "PRENAME, a forename [n]\n",
  "PRENASAL": "situated in front of the nose, or in front of the nasal chambers [adj] / a prenasal bone [n -S]\n",
  "PRENASALS": "PRENASAL, a prenasal bone [n]\n",
  "PRENATAL": "prior to birth [adj PRENATALLY] / a prenatal examination [n -S]\n",
  "PRENATALLY": "PRENATAL, prior to birth [adv]\n",
  "PRENATALS": "PRENATAL, a prenatal examination [n]\n",
  "PRENEED": "arranged or made available in advance of eventual requirements, as in preneed funereal arrangements [adj]\n",
  "PRENEGOTIATE": "to negotiate in advance [v PRENEGOTIATED, PRENEGOTIATING, PRENEGOTIATES]\n",
  "PRENEGOTIATED": "PRENEGOTIATE, to negotiate in advance [v]\n",
  "PRENEGOTIATES": "PRENEGOTIATE, to negotiate in advance [v]\n",
  "PRENEGOTIATING": "PRENEGOTIATE, to negotiate in advance [v]\n",
  "PRENEGOTIATION": "negotiation in advance [n -S]\n",
  "PRENEGOTIATIONS": "PRENEGOTIATION, negotiation in advance [n]\n",
  "PRENOMEN": "(Latin) the first name of an ancient Roman, also PRAENOMEN [n PRENOMENS or PRENOMINA]\n",
  "PRENOMENS": "PRENOMEN, (Latin) the first name of an ancient Roman, also PRAENOMEN [n]\n",
  "PRENOMINA": "PRENOMEN, (Latin) the first name of an ancient Roman, also PRAENOMEN [n]\n",
  "PRENOMINAL": "placed before a noun, esp. (of an adjective or sense of an adjective) used only before a noun [adj PRENOMINALLY]\n",
  "PRENOMINALLY": "PRENOMINAL, placed before a noun, esp. (of an adjective or sense of an adjective) used only before a noun [adv]\n",
  "PRENOMINATE": "forenamed [adj] / to name or state beforehand [v PRENOMINATED, PRENOMINATING, PRENOMINATES]\n",
  "PRENOMINATED": "PRENOMINATE, to name or state beforehand [v]\n",
  "PRENOMINATES": "PRENOMINATE, to name or state beforehand [v]\n",
  "PRENOMINATING": "PRENOMINATE, to name or state beforehand [v]\n",
  "PRENOMINATION": "the act of prenominating, naming in advance [n -S]\n",
  "PRENOMINATIONS": "PRENOMINATION, the act of prenominating, naming in advance [n]\n",
  "PRENOON": "before noon [adj]\n",
  "PRENOTIFICATION": "preceding a notification [n]\n",
  "PRENOTIFIED": "PRENOTIFY, to notify beforehand [v]\n",
  "PRENOTIFIES": "PRENOTIFY, to notify beforehand [v]\n",
  "PRENOTIFY": "to notify beforehand [v PRENOTIFIED, PRENOTIFYING, PRENOTIFIES]\n",
  "PRENOTIFYING": "PRENOTIFY, to notify beforehand [v]\n",
  "PRENOTION": "a notion which precedes something else in time [n -S]\n",
  "PRENOTIONS": "PRENOTION, a notion which precedes something else in time [n]\n",
  "PRENT": "(Scots) to print [v -ED, -ING, -S]\n",
  "PRENTED": "PRENT, (Scots) to print [v]\n",
  "PRENTICE": "to place with an employer for instruction in a trade [v PRENTICED, PRENTICING, PRENTICES]\n",
  "PRENTICED": "PRENTICE, to place with an employer for instruction in a trade [v]\n",
  "PRENTICES": "PRENTICE, to place with an employer for instruction in a trade [v]\n",
  "PRENTICESHIP": "the office of prentice [n -S]\n",
  "PRENTICESHIPS": "PRENTICESHIP, the office of prentice [n]\n",
  "PRENTICING": "PRENTICE, to place with an employer for instruction in a trade [v]\n",
  "PRENTING": "PRENT, (Scots) to print [v]\n",
  "PRENTS": "PRENT, (Scots) to print [v]\n",
  "PRENUBILE": "before the state of being nubile [adj]\n",
  "PRENUMBER": "to number in advance [v -ED, -ING, -S]\n",
  "PRENUMBERED": "PRENUMBER, to number in advance [v]\n",
  "PRENUMBERING": "PRENUMBER, to number in advance [v]\n",
  "PRENUMBERS": "PRENUMBER, to number in advance [v]\n",
  "PRENUP": "a prenuptial agreement [n -S]\n",
  "PRENUPS": "PRENUP, a prenuptial agreement [n]\n",
  "PRENUPTIAL": "an arrangement made or occurring before marriage [n -S]\n",
  "PRENUPTIALS": "PRENUPTIAL, an arrangement made or occurring before marriage [n]\n",
  "PRENZIE": "(Shakespeare) a word of unknown meaning, possibly a misprint for princely [adj]\n",
  "PREOBTAIN": "to obtain in advance [v -ED, -ING, -S]\n",
  "PREOBTAINED": "PREOBTAIN, to obtain in advance [v]\n",
  "PREOBTAINING": "PREOBTAIN, to obtain in advance [v]\n",
  "PREOBTAINS": "PREOBTAIN, to obtain in advance [v]\n",
  "PREOCCUPANCIES": "PREOCCUPANCY, an act or the right of taking possession before another [n]\n",
  "PREOCCUPANCY": "an act or the right of taking possession before another [n PREOCCUPANCIES]\n",
  "PREOCCUPANT": "a prior occupant [n -S]\n",
  "PREOCCUPANTS": "PREOCCUPANT, a prior occupant [n]\n",
  "PREOCCUPATE": "(obsolete) to preoccupy [v PREOCCUPATED, PREOCCUPATING, PREOCCUPATES]\n",
  "PREOCCUPATED": "PREOCCUPATE, (obsolete) to preoccupy [v]\n",
  "PREOCCUPATES": "PREOCCUPATE, (obsolete) to preoccupy [v]\n",
  "PREOCCUPATING": "PREOCCUPATE, (obsolete) to preoccupy [v]\n",
  "PREOCCUPATION": "an act of preoccupying [n -S]\n",
  "PREOCCUPATIONS": "PREOCCUPATION, an act of preoccupying [n]\n",
  "PREOCCUPIED": "PREOCCUPY, to engross or fill the mind of [v]\n",
  "PREOCCUPIES": "PREOCCUPY, to engross or fill the mind of [v]\n",
  "PREOCCUPY": "to engross or fill the mind of [v PREOCCUPIED, PREOCCUPYING, PREOCCUPIES]\n",
  "PREOCCUPYING": "PREOCCUPY, to engross or fill the mind of [v]\n",
  "PREOCULAR": "a scale in front of the eye of a reptile or fish [n -S]\n",
  "PREOCULARS": "PREOCULAR, a scale in front of the eye of a reptile or fish [n]\n",
  "PREON": "a hypothetical particle, a possible constituent of a quark [n -S]\n",
  "PREONS": "PREON, a hypothetical particle, a possible constituent of a quark [n]\n",
  "PREOP": "a patient prepared for surgery [n -S]\n",
  "PREOPENING": "taking place before an opening [adj]\n",
  "PREOPERATIONAL": "preceding an operation [adj]\n",
  "PREOPERATIVE": "occurring before a surgical operation [adj PREOPERATIVELY]\n",
  "PREOPERATIVELY": "PREOPERATIVE, occurring before a surgical operation [adv]\n",
  "PREOPS": "PREOP, a patient prepared for surgery [n]\n",
  "PREOPTION": "the right of first choice [n -S]\n",
  "PREOPTIONS": "PREOPTION, the right of first choice [n]\n",
  "PREORAL": "towards the front of the mouth [adj]\n",
  "PREORDAIN": "to ordain in advance [v -ED, -ING, -S]\n",
  "PREORDAINED": "PREORDAIN, to ordain in advance [v]\n",
  "PREORDAINING": "PREORDAIN, to ordain in advance [v]\n",
  "PREORDAINMENT": "a preliminary ordainment [n -S]\n",
  "PREORDAINMENTS": "PREORDAINMENT, a preliminary ordainment [n]\n",
  "PREORDAINS": "PREORDAIN, to ordain in advance [v]\n",
  "PREORDER": "to order beforehand [v -ED, -ING, -S]\n",
  "PREORDERED": "PREORDER, to order beforehand [v]\n",
  "PREORDERING": "PREORDER, to order beforehand [v]\n",
  "PREORDERS": "PREORDER, to order beforehand [v]\n",
  "PREORDINANCE": "a rule previously established; that which is ordained beforehand [n -S]\n",
  "PREORDINANCES": "PREORDINANCE, a rule previously established; that which is ordained beforehand [n]\n",
  "PREORDINATION": "the act of preordaining [n -S]\n",
  "PREORDINATIONS": "PREORDINATION, the act of preordaining [n]\n",
  "PREOVULATORY": "occurring or existing in or typical of the period immediately preceding ovulation [adj]\n",
  "PREOWNED": "previously owned by somebody else [adj]\n",
  "PREP": "(short for) to prepare [v PREPPED, PREPPING, PREPS]\n",
  "PREPACK": "to package before retail distribution [v -ED, -ING, -S]\n",
  "PREPACKAGE": "to package in advance [v PREPACKAGED, PREPACKAGING, PREPACKAGES]\n",
  "PREPACKAGED": "PREPACKAGE, to package in advance [v]\n",
  "PREPACKAGES": "PREPACKAGE, to package in advance [v]\n",
  "PREPACKAGING": "PREPACKAGE, to package in advance [v]\n",
  "PREPACKED": "PREPACK, to package before retail distribution [v]\n",
  "PREPACKING": "PREPACK, to package before retail distribution [v]\n",
  "PREPACKS": "PREPACK, to package before retail distribution [v]\n",
  "PREPAID": "PREPAY, to pay in advance [v]\n",
  "PREPARATION": "the act of preparing [n -S]\n",
  "PREPARATIONS": "PREPARATION, the act of preparing [n]\n",
  "PREPARATIVE": "serving to prepare [adj PREPARATIVELY] / something that prepares the way for or serves as a preliminary to something else [n -S]\n",
  "PREPARATIVELY": "PREPARATIVE, serving to prepare [adv]\n",
  "PREPARATIVES": "PREPARATIVE, something that prepares the way for or serves as a preliminary to something else [n]\n",
  "PREPARATOR": "one who prepares beforehand, as subjects for dissection, specimens for preservation in collections, etc. [n -S]\n",
  "PREPARATORILY": "PREPARATORY, by way of preparation [adv]\n",
  "PREPARATORS": "PREPARATOR, one who prepares beforehand, as subjects for dissection, specimens for preservation in collections, etc. [n]\n",
  "PREPARATORY": "by way of preparation [adj PREPARATORILY]\n",
  "PREPARE": "to get ready [v PREPARED, PREPARING, PREPARES]\n",
  "PREPARED": "PREPARE, to get ready [v]\n",
  "PREPAREDLY": "PREPARED, PREPARE, to get ready [adv]\n",
  "PREPAREDNESS": "the state of being prepared [n -ES]\n",
  "PREPAREDNESSES": "PREPAREDNESS, the state of being prepared [n]\n",
  "PREPARER": "one who prepares [n -S]\n",
  "PREPARERS": "PREPARER, one who prepares [n]\n",
  "PREPARES": "PREPARE, to get ready [v]\n",
  "PREPARING": "PREPARE, to get ready [v]\n",
  "PREPASTE": "to paste beforehand [v PREPASTED, PREPASTING, PREPASTES]\n",
  "PREPASTED": "PREPASTE, to paste beforehand [v]\n",
  "PREPASTES": "PREPASTE, to paste beforehand [v]\n",
  "PREPASTING": "PREPASTE, to paste beforehand [v]\n",
  "PREPATELLAR": "as in prepatellar bursitis, housemaid's knee [adj]\n",
  "PREPAVE": "to pave beforehand [v PREPAVED, PREPAVING, PREPAVES]\n",
  "PREPAVED": "PREPAVE, to pave beforehand [v]\n",
  "PREPAVES": "PREPAVE, to pave beforehand [v]\n",
  "PREPAVING": "PREPAVE, to pave beforehand [v]\n",
  "PREPAY": "to pay in advance [v PREPAID, PREPAYING, PREPAYS]\n",
  "PREPAYABLE": "that can be prepaid [adj]\n",
  "PREPAYING": "PREPAY, to pay in advance [v]\n",
  "PREPAYMENT": "payment in advance [n -S]\n",
  "PREPAYMENTS": "PREPAYMENT, payment in advance [n]\n",
  "PREPAYS": "PREPAY, to pay in advance [v]\n",
  "PREPENSE": "premeditated; intentional, as in the legal term malice prepense [adj PREPENSELY] / (Spenser) to consider [v PREPENSED, PREPENSING, PREPENSES]\n",
  "PREPENSED": "PREPENSE, (Spenser) to consider [v]\n",
  "PREPENSELY": "PREPENSE, premeditated; intentional, as in the legal term malice prepense [adv]\n",
  "PREPENSES": "PREPENSE, (Spenser) to consider [v]\n",
  "PREPENSING": "PREPENSE, (Spenser) to consider [v]\n",
  "PREPENSIVE": "premeditated [adj]\n",
  "PREPERFORMANCE": "preceding a performance [adj]\n",
  "PREPILL": "preceding the development of a contraceptive pill [adj]\n",
  "PREPLACE": "to place beforehand [v PREPLACED, PREPLACING, PREPLACES]\n",
  "PREPLACED": "PREPLACE, to place beforehand [v]\n",
  "PREPLACES": "PREPLACE, to place beforehand [v]\n",
  "PREPLACING": "PREPLACE, to place beforehand [v]\n",
  "PREPLAN": "to plan in advance [v PREPLANNED, PREPLANNING, PREPLANS]\n",
  "PREPLANNED": "PREPLAN, to plan in advance [v]\n",
  "PREPLANNING": "PREPLAN, to plan in advance [v]\n",
  "PREPLANS": "PREPLAN, to plan in advance [v]\n",
  "PREPLANT": "occurring before planting [adj]\n",
  "PREPLANTING": "taking place before planting [adj]\n",
  "PREPOLLENCE": "predominance, also PREPOLLENCY [n -S]\n",
  "PREPOLLENCES": "PREPOLLENCE, predominance, also PREPOLLENCY [n]\n",
  "PREPOLLENCIES": "PREPOLLENCY, predominance, also PREPOLLENCE [n]\n",
  "PREPOLLENCY": "predominance, also PREPOLLENCE [n PREPOLLENCIES]\n",
  "PREPOLLENT": "having superior influence or power [adj]\n",
  "PREPOLLEX": "(Latin) in some animals, a rudimentary innermost finger [n PREPOLLICES]\n",
  "PREPOLLICES": "PREPOLLEX, (Latin) in some animals, a rudimentary innermost finger [n]\n",
  "PREPONDERANCE": "a superiority in weight, power, importance, or strength, also PREPONDERANCY [n -S]\n",
  "PREPONDERANCES": "PREPONDERANCE, a superiority in weight, power, importance, or strength, also PREPONDERANCY [n]\n",
  "PREPONDERANCIES": "PREPONDERANCY, a superiority in weight, power, importance, or strength, also PREPONDERANCE [n]\n",
  "PREPONDERANCY": "a superiority in weight, power, importance, or strength, also PREPONDERANCE [n PREPONDERANCIES]\n",
  "PREPONDERANT": "having superior weight, force, or influence [adj PREPONDERANTLY]\n",
  "PREPONDERANTLY": "PREPONDERANT, having superior weight, force, or influence [adv]\n",
  "PREPONDERATE": "surpassing [adj PREPONDERATELY] / to surpass others in numbers, intensity, force, or prowess [v PREPONDERATED, PREPONDERATING, PREPONDERATES]\n",
  "PREPONDERATED": "PREPONDERATE, to surpass others in numbers, intensity, force, or prowess [v]\n",
  "PREPONDERATELY": "PREPONDERATE, surpassing [adv]\n",
  "PREPONDERATES": "PREPONDERATE, to surpass others in numbers, intensity, force, or prowess [v]\n",
  "PREPONDERATING": "PREPONDERATE, to surpass others in numbers, intensity, force, or prowess [v]\n",
  "PREPONDERATION": "the act of preponderating [n -S]\n",
  "PREPONDERATIONS": "PREPONDERATION, the act of preponderating [n]\n",
  "PREPONE": "to bring forward [v PREPONED, PREPONING, PREPONES]\n",
  "PREPONED": "PREPONE, to bring forward [v]\n",
  "PREPONES": "PREPONE, to bring forward [v]\n",
  "PREPONING": "PREPONE, to bring forward [v]\n",
  "PREPORTION": "to portion in advance [v -ED, -ING, -S]\n",
  "PREPORTIONED": "PREPORTION, to portion in advance [v]\n",
  "PREPORTIONING": "PREPORTION, to portion in advance [v]\n",
  "PREPORTIONS": "PREPORTION, to portion in advance [v]\n",
  "PREPOSE": "to place a word before another [v PREPOSED, PREPOSING, PREPOSES]\n",
  "PREPOSED": "PREPOSE, to place a word before another [v]\n",
  "PREPOSES": "PREPOSE, to place a word before another [v]\n",
  "PREPOSING": "PREPOSE, to place a word before another [v]\n",
  "PREPOSITION": "a function word that typically combines with a noun phrase to form a phrase which usually expresses a modification or predication [n -S]\n",
  "PREPOSITIONAL": "relating to a preposition [adj PREPOSITIONALLY]\n",
  "PREPOSITIONALLY": "PREPOSITIONAL, relating to a preposition [adv]\n",
  "PREPOSITIONS": "PREPOSITION, a function word that typically combines with a noun phrase to form a phrase which usually expresses a modification or predication [n]\n",
  "PREPOSITIVE": "placed before [adj PREPOSITIVELY] / something placed before [n -S]\n",
  "PREPOSITIVELY": "PREPOSITIVE, placed before [adv]\n",
  "PREPOSITIVES": "PREPOSITIVE, something placed before [n]\n",
  "PREPOSITOR": "(Latin) the name used for a prefect in some English public schools, also PRAEPOSTOR, PREPOSTOR [n -S]\n",
  "PREPOSITORS": "PREPOSITOR, (Latin) the name used for a prefect in some English public schools, also PRAEPOSTOR, PREPOSTOR [n]\n",
  "PREPOSSESS": "to bias or prejudice favourably; to impress [v -ED, -ING, -ES]\n",
  "PREPOSSESSED": "PREPOSSESS, to bias or prejudice favourably; to impress [v]\n",
  "PREPOSSESSES": "PREPOSSESS, to bias or prejudice favourably; to impress [v]\n",
  "PREPOSSESSING": "creating a favorable impression; attractive [adj PREPOSSESSINGLY]\n",
  "PREPOSSESSINGLY": "PREPOSSESSING, creating a favorable impression; attractive [adv]\n",
  "PREPOSSESSION": "a fixed conception likely to preclude objective judgment of anything seeming to be counter to it [n -S]\n",
  "PREPOSSESSIONS": "PREPOSSESSION, a fixed conception likely to preclude objective judgment of anything seeming to be counter to it [n]\n",
  "PREPOSTEROUS": "contrary to nature, reason, or common sense [adj PREPOSTEROUSLY]\n",
  "PREPOSTEROUSLY": "PREPOSTEROUS, contrary to nature, reason, or common sense [adv]\n",
  "PREPOSTOR": "(Latin) the name used for a prefect in some English public schools, also PRAEPOSTOR, PREPOSITOR [n -S]\n",
  "PREPOSTORS": "PREPOSTOR, (Latin) the name used for a prefect in some English public schools, also PRAEPOSTOR, PREPOSITOR [n]\n",
  "PREPOTENCE": "the state of being prepotent, also PREPOTENCY [n -S]\n",
  "PREPOTENCES": "PREPOTENCE, the state of being prepotent, also PREPOTENCY [n]\n",
  "PREPOTENCIES": "PREPOTENCY, the state of being prepotent, also PREPOTENCE [n]\n",
  "PREPOTENCY": "the state of being prepotent, also PREPOTENCE [n PREPOTENCIES]\n",
  "PREPOTENT": "potent in a very high degree [adj PREPOTENTLY]\n",
  "PREPOTENTLY": "PREPOTENT, potent in a very high degree [adv]\n",
  "PREPPED": "PREP, (short for) to prepare [v]\n",
  "PREPPIE": "one who attends a preparatory school [n -S]\n",
  "PREPPIER": "PREPPY, denoting the style and behaviour of preparatory school students [adj]\n",
  "PREPPIES": "PREPPIE, one who attends a preparatory school [n]\n",
  "PREPPIEST": "PREPPY, denoting the style and behaviour of preparatory school students [adj]\n",
  "PREPPILY": "PREPPY, denoting the style and behaviour of preparatory school students [adv]\n",
  "PREPPINESS": "being like a preppie, e.g. neatly groomed [n -ES]\n",
  "PREPPINESSES": "PREPPINESS, being like a preppie, e.g. neatly groomed [n]\n",
  "PREPPING": "PREP, (short for) to prepare [v]\n",
  "PREPPY": "denoting the style and behaviour of preparatory school students [adj PREPPIER, PREPPIEST, PREPPILY]\n",
  "PREPRANDIAL": "taking place before dinner [adj]\n",
  "PREPREG": "reinforcing material already impregnated with a synthetic resin [n -S]\n",
  "PREPREGS": "PREPREG, reinforcing material already impregnated with a synthetic resin [n]\n",
  "PREPREPARED": "prepared in advance [adj]\n",
  "PREPRESIDENTIAL": "preceding a presidential election [adj]\n",
  "PREPRESS": "the preparation of an edited book, magazine etc. for printing [n -ES]\n",
  "PREPRESSES": "PREPRESS, the preparation of an edited book, magazine etc. for printing [n]\n",
  "PREPRICE": "to price beforehand [v PREPRICED, PREPRICING, PREPRICES]\n",
  "PREPRICED": "PREPRICE, to price beforehand [v]\n",
  "PREPRICES": "PREPRICE, to price beforehand [v]\n",
  "PREPRICING": "PREPRICE, to price beforehand [v]\n",
  "PREPRIMARIES": "PREPRIMARY, an election occurring before the primary elections [n]\n",
  "PREPRIMARY": "an election occurring before the primary elections [n PREPRIMARIES]\n",
  "PREPRINT": "to print in advance [v -ED, -ING, -S]\n",
  "PREPRINTED": "PREPRINT, to print in advance [v]\n",
  "PREPRINTING": "PREPRINT, to print in advance [v]\n",
  "PREPRINTS": "PREPRINT, to print in advance [v]\n",
  "PREPROCESS": "to process beforehand [v -ED, -ING, -ES]\n",
  "PREPROCESSED": "PREPROCESS, to process beforehand [v]\n",
  "PREPROCESSES": "PREPROCESS, to process beforehand [v]\n",
  "PREPROCESSING": "PREPROCESS, to process beforehand [v]\n",
  "PREPROCESSOR": "something that preprocesses [n -S]\n",
  "PREPROCESSORS": "PREPROCESSOR, something that preprocesses [n]\n",
  "PREPRODUCTION": "a preliminary production [n -S]\n",
  "PREPRODUCTIONS": "PREPRODUCTION, a preliminary production [n]\n",
  "PREPROFESSIONAL": "of or relating to the period preceding specific study for or practice of a profession [adj]\n",
  "PREPROGRAM": "to program beforehand [v PREPROGRAMED or PREPROGRAMMED, PREPROGRAMING or PREPROGRAMMING, PREPROGRAMS]\n",
  "PREPROGRAMED": "PREPROGRAM, to program beforehand [v]\n",
  "PREPROGRAMING": "PREPROGRAM, to program beforehand [v]\n",
  "PREPROGRAMMED": "PREPROGRAM, to program beforehand [v]\n",
  "PREPROGRAMMING": "the act of programming beforehand [n -S]\n",
  "PREPROGRAMMINGS": "PREPROGRAMMING, the act of programming beforehand [n]\n",
  "PREPROGRAMS": "PREPROGRAM, to program beforehand [v]\n",
  "PREPS": "PREP, (short for) to prepare [v]\n",
  "PREPSYCHEDELIC": "preceding a psychedelic experience [adj]\n",
  "PREPUBERAL": "occurring in prepuberty, also PREPUBERTAL [adj]\n",
  "PREPUBERTAL": "occurring in prepuberty, also PREPUBERAL [adj]\n",
  "PREPUBERTIES": "PREPUBERTY, the time before puberty [n]\n",
  "PREPUBERTY": "the time before puberty [n PREPUBERTIES]\n",
  "PREPUBES": "PREPUBIS, a bone situated in front of the pubic bone [n]\n",
  "PREPUBESCENCE": "prepuberty [n -S]\n",
  "PREPUBESCENCES": "PREPUBESCENCE, prepuberty [n]\n",
  "PREPUBESCENT": "one who is prepubertal [n -S]\n",
  "PREPUBESCENTS": "PREPUBESCENT, one who is prepubertal [n]\n",
  "PREPUBIS": "a bone situated in front of the pubic bone [n PREPUBES]\n",
  "PREPUBLICATION": "an advance publication [n -S]\n",
  "PREPUBLICATIONS": "PREPUBLICATION, an advance publication [n]\n",
  "PREPUCE": "a fold of skin covering the penis [n -S]\n",
  "PREPUCES": "PREPUCE, a fold of skin covering the penis [n]\n",
  "PREPUEBLO": "belonging to the period before the Pueblo Indians [adj]\n",
  "PREPUNCH": "to punch in advance [v -ED, -ING, -ES]\n",
  "PREPUNCHED": "PREPUNCH, to punch in advance [v]\n",
  "PREPUNCHES": "PREPUNCH, to punch in advance [v]\n",
  "PREPUNCHING": "PREPUNCH, to punch in advance [v]\n",
  "PREPUNCTUAL": "more than punctual; coming before time [adj]\n",
  "PREPUPA": "a stage preceding the pupa [n PREPUPAS or PREPUPAE]\n",
  "PREPUPAE": "PREPUPA, a stage preceding the pupa [n]\n",
  "PREPUPAL": "preceding the pupal stage [adj]\n",
  "PREPUPAS": "PREPUPA, a stage preceding the pupa [n]\n",
  "PREPURCHASE": "to purchase in advance [v PREPURCHASED, PREPURCHASING, PREPURCHASES]\n",
  "PREPURCHASED": "PREPURCHASE, to purchase in advance [v]\n",
  "PREPURCHASES": "PREPURCHASE, to purchase in advance [v]\n",
  "PREPURCHASING": "PREPURCHASE, to purchase in advance [v]\n",
  "PREPUTIAL": "of or relating to the prepuce [adj]\n",
  "PREQUALIFIED": "PREQUALIFY, to qualify beforehand, as for a shortlist [v]\n",
  "PREQUALIFIES": "PREQUALIFY, to qualify beforehand, as for a shortlist [v]\n",
  "PREQUALIFY": "to qualify beforehand, as for a shortlist [v PREQUALIFIED, PREQUALIFYING, PREQUALIFIES]\n",
  "PREQUALIFYING": "PREQUALIFY, to qualify beforehand, as for a shortlist [v]\n",
  "PREQUEL": "a book, film, etc., portraying events which precede those of an existing work [n -S]\n",
  "PREQUELS": "PREQUEL, a book, film, etc., portraying events which precede those of an existing work [n]\n",
  "PRERACE": "before a race [adj]\n",
  "PRERADIO": "before the invention of radio [adj]\n",
  "PREREADING": "referring to the time before a child learns to reads [adj]\n",
  "PRERECESSION": "taking place before a recession [adj]\n",
  "PRERECORD": "to record in advance [v -ED, -ING, -S]\n",
  "PRERECORDED": "PRERECORD, to record in advance [v]\n",
  "PRERECORDING": "PRERECORD, to record in advance [v]\n",
  "PRERECORDS": "PRERECORD, to record in advance [v]\n",
  "PRERECTAL": "in front of the rectum [adj]\n",
  "PREREFORM": "before reform [adj]\n",
  "PREREGISTER": "to register in advance [v -ED, -ING, -S]\n",
  "PREREGISTERED": "PREREGISTER, to register in advance [v]\n",
  "PREREGISTERING": "PREREGISTER, to register in advance [v]\n",
  "PREREGISTERS": "PREREGISTER, to register in advance [v]\n",
  "PREREGISTRATION": "a special registration (as for returning students) prior to an official registration period [n]\n",
  "PREREHEARSAL": "a preliminary rehearsal [n -S]\n",
  "PREREHEARSALS": "PREREHEARSAL, a preliminary rehearsal [n]\n",
  "PRERELEASE": "to release in advance [v PRERELEASED, PRERELEASING, PRERELEASES]\n",
  "PRERELEASED": "PRERELEASE, to release in advance [v]\n",
  "PRERELEASES": "PRERELEASE, to release in advance [v]\n",
  "PRERELEASING": "PRERELEASE, to release in advance [v]\n",
  "PRERENAL": "situated in front of the kidneys [adj]\n",
  "PREREQUIRE": "to require beforehand [v PREREQUIRED, PREREQUIRING, PREREQUIRES]\n",
  "PREREQUIRED": "PREREQUIRE, to require beforehand [v]\n",
  "PREREQUIRES": "PREREQUIRE, to require beforehand [v]\n",
  "PREREQUIRING": "PREREQUIRE, to require beforehand [v]\n",
  "PREREQUISITE": "something needed in advance [n -S]\n",
  "PREREQUISITES": "PREREQUISITE, something needed in advance [n]\n",
  "PRERETIREMENT": "preceding a retirement [adj]\n",
  "PRERETURN": "preceding a return [adj]\n",
  "PREREVIEW": "to review in advance [v -ED, -ING, -S]\n",
  "PREREVIEWED": "PREREVIEW, to review in advance [v]\n",
  "PREREVIEWING": "PREREVIEW, to review in advance [v]\n",
  "PREREVIEWS": "PREREVIEW, to review in advance [v]\n",
  "PREREVISIONIST": "preceding revisionism [adj]\n",
  "PREREVOLUTION": "preceding a revolution [adj]\n",
  "PRERINSE": "to rinse beforehand [v PRERINSED, PRERINSING, PRERINSES]\n",
  "PRERINSED": "PRERINSE, to rinse beforehand [v]\n",
  "PRERINSES": "PRERINSE, to rinse beforehand [v]\n",
  "PRERINSING": "PRERINSE, to rinse beforehand [v]\n",
  "PRERIOT": "preceding a riot [adj]\n",
  "PREROCK": "preceding the development of rock music [adj]\n",
  "PREROGATIVE": "an exclusive or special right, power, or privilege [n -S] / arising out of or held by prerogative [adj PREROGATIVELY]\n",
  "PREROGATIVED": "(Shakespeare) possessed of a prerogative [adj]\n",
  "PREROGATIVELY": "PREROGATIVE, arising out of or held by prerogative [adv]\n",
  "PREROGATIVES": "PREROGATIVE, an exclusive or special right, power, or privilege [n]\n",
  "PREROMANTIC": "a poet, composer, etc. from the period before Romanticism [n -S]\n",
  "PREROMANTICS": "PREROMANTIC, a poet, composer, etc. from the period before Romanticism [n]\n",
  "PRERUPT": "broken off; steep; abrupt [adj]\n",
  "PRESA": "(Italian) a musical symbol used in a canon etc. to mark the entry of a voice or instrument [n PRESE]\n",
  "PRESAGE": "to foretell [v PRESAGED, PRESAGING, PRESAGES]\n",
  "PRESAGED": "PRESAGE, to foretell [v]\n",
  "PRESAGEFUL": "full of presages; ominous [adj PRESAGEFULLY]\n",
  "PRESAGEFULLY": "PRESAGEFUL, full of presages; ominous [adv]\n",
  "PRESAGEMENT": "(obsolete) a presage [n -S]\n",
  "PRESAGEMENTS": "PRESAGEMENT, (obsolete) a presage [n]\n",
  "PRESAGER": "one who, or that which, presages [n -S]\n",
  "PRESAGERS": "PRESAGER, one who, or that which, presages [n]\n",
  "PRESAGES": "PRESAGE, to foretell [v]\n",
  "PRESAGING": "PRESAGE, to foretell [v]\n",
  "PRESALE": "a sale of a product before it is generally available [n -S]\n",
  "PRESALES": "PRESALE, a sale of a product before it is generally available [n]\n",
  "PRESANCTIFIED": "PRESANCTIFY, to sanctify in advance [v]\n",
  "PRESANCTIFIES": "PRESANCTIFY, to sanctify in advance [v]\n",
  "PRESANCTIFY": "to sanctify in advance [v PRESANCTIFIED, PRESANCTIFYING, PRESANCTIFIES]\n",
  "PRESANCTIFYING": "PRESANCTIFY, to sanctify in advance [v]\n",
  "PRESBYACOUSES": "PRESBYACOUSIS, progressive loss of hearing with advancing old age, also PRESBYACUSIS, PRESBYCOUSIS, PRESBYCUSIS [n]\n",
  "PRESBYACOUSIS": "progressive loss of hearing with advancing old age, also PRESBYACUSIS, PRESBYCOUSIS, PRESBYCUSIS [n PRESBYACOUSES]\n",
  "PRESBYACUSES": "PRESBYACUSIS, progressive loss of hearing with advancing old age, also PRESBYACOUSIS, PRESBYCOUSIS, PRESBYCUSIS [n]\n",
  "PRESBYACUSIS": "progressive loss of hearing with advancing old age, also PRESBYACOUSIS, PRESBYCOUSIS, PRESBYCUSIS [n PRESBYACUSES]\n",
  "PRESBYCOUSES": "PRESBYCOUSIS, progressive loss of hearing with advancing old age, also PRESBYACOUSIS, PRESBYACUSIS, PRESBYCUSIS [n]\n",
  "PRESBYCOUSIS": "progressive loss of hearing with advancing old age, also PRESBYACOUSIS, PRESBYACUSIS, PRESBYCUSIS [n PRESBYCOUSES]\n",
  "PRESBYCUSES": "PRESBYCUSIS, progressive loss of hearing with advancing old age, also PRESBYACOUSIS, PRESBYACUSIS, PRESBYCOUSIS [n]\n",
  "PRESBYCUSIS": "progressive loss of hearing with advancing old age, also PRESBYACOUSIS, PRESBYACUSIS, PRESBYCOUSIS [n PRESBYCUSES]\n",
  "PRESBYOPE": "one who has presbyopia; a farsighted person [n -S]\n",
  "PRESBYOPES": "PRESBYOPE, one who has presbyopia; a farsighted person [n]\n",
  "PRESBYOPIA": "long-sightedness in old age, also PRESBYOPY [n -S]\n",
  "PRESBYOPIAS": "PRESBYOPIA, long-sightedness in old age, also PRESBYOPY [n]\n",
  "PRESBYOPIC": "affected by presbyopia [adj] / someone with presbyopia [n -S]\n",
  "PRESBYOPICS": "PRESBYOPIC, someone with presbyopia [n]\n",
  "PRESBYOPIES": "PRESBYOPY, long-sightedness in old age, also PRESBYOPIA [n]\n",
  "PRESBYOPY": "long-sightedness in old age, also PRESBYOPIA [n PRESBYOPIES]\n",
  "PRESBYTE": "an elder in the early Christian church, also PRESBYTER [n -S]\n",
  "PRESBYTER": "an elder in the early Christian church, also PRESBYTE [n -S]\n",
  "PRESBYTERAL": "of or like a presbyter [adj]\n",
  "PRESBYTERATE": "the office of presbyter [n -S]\n",
  "PRESBYTERATES": "PRESBYTERATE, the office of presbyter [n]\n",
  "PRESBYTERIAL": "relating to a presbytery [adj PRESBYTERIALLY] / an organization of Presbyterian women associated with a presbytery [n -S]\n",
  "PRESBYTERIALLY": "PRESBYTERIAL, relating to a presbytery [adv]\n",
  "PRESBYTERIALS": "PRESBYTERIAL, an organization of Presbyterian women associated with a presbytery [n]\n",
  "PRESBYTERIAN": "a member of a Presbyterian church [n -S]\n",
  "PRESBYTERIANISE": "to make presbyterian, also PRESBYTERIANIZE [v]\n",
  "PRESBYTERIANISM": "the form of church government by presbyters [n]\n",
  "PRESBYTERIANIZE": "to make presbyterian, also PRESBYTERIANISE [v]\n",
  "PRESBYTERIANS": "PRESBYTERIAN, a member of a Presbyterian church [n]\n",
  "PRESBYTERIES": "PRESBYTERY, part of church reserved for officiating clergy [n]\n",
  "PRESBYTERS": "PRESBYTER, an elder in the early Christian church, also PRESBYTE [n]\n",
  "PRESBYTERSHIP": "the office of presbyter, an elder in the early Christian church [n -S]\n",
  "PRESBYTERSHIPS": "PRESBYTERSHIP, the office of presbyter, an elder in the early Christian church [n]\n",
  "PRESBYTERY": "part of church reserved for officiating clergy [n PRESBYTERIES]\n",
  "PRESBYTES": "PRESBYTE, an elder in the early Christian church, also PRESBYTER [n]\n",
  "PRESBYTIC": "relating to an old man [adj]\n",
  "PRESBYTISM": "presbyopia [n -S]\n",
  "PRESBYTISMS": "PRESBYTISM, presbyopia [n]\n",
  "PRESCHEDULE": "to schedule in advance [v PRESCHEDULED, PRESCHEDULING, PRESCHEDULES]\n",
  "PRESCHEDULED": "PRESCHEDULE, to schedule in advance [v]\n",
  "PRESCHEDULES": "PRESCHEDULE, to schedule in advance [v]\n",
  "PRESCHEDULING": "PRESCHEDULE, to schedule in advance [v]\n",
  "PRESCHOOL": "a kindergarten or nursery school for children of preschool age [n -S]\n",
  "PRESCHOOLER": "a child not yet old enough for school [n -S]\n",
  "PRESCHOOLERS": "PRESCHOOLER, a child not yet old enough for school [n]\n",
  "PRESCHOOLS": "PRESCHOOL, a kindergarten or nursery school for children of preschool age [n]\n",
  "PRESCIENCE": "knowledge of events before they take place [n -S]\n",
  "PRESCIENCES": "PRESCIENCE, knowledge of events before they take place [n]\n",
  "PRESCIENT": "having foresight or knowledge of what will happen, also PRESCIOUS [adj PRESCIENTLY]\n",
  "PRESCIENTIFIC": "belonging to the period before science [adj]\n",
  "PRESCIENTLY": "PRESCIENT, having foresight or knowledge of what will happen, also PRESCIOUS [adv]\n",
  "PRESCIND": "to consider separately [v -ED, -ING, -S]\n",
  "PRESCINDED": "PRESCIND, to consider separately [v]\n",
  "PRESCINDENT": "serving to prescind [adj]\n",
  "PRESCINDING": "PRESCIND, to consider separately [v]\n",
  "PRESCINDS": "PRESCIND, to consider separately [v]\n",
  "PRESCIOUS": "prescient, also PRESCIENT [adj]\n",
  "PRESCISSION": "the act of prescinding [n -S]\n",
  "PRESCISSIONS": "PRESCISSION, the act of prescinding [n]\n",
  "PRESCORE": "to record the sound before filming [v PRESCORED, PRESCORING, PRESCORES]\n",
  "PRESCORED": "PRESCORE, to record the sound before filming [v]\n",
  "PRESCORES": "PRESCORE, to record the sound before filming [v]\n",
  "PRESCORING": "PRESCORE, to record the sound before filming [v]\n",
  "PRESCREEN": "to screen in advance [v -ED, -ING, -S]\n",
  "PRESCREENED": "PRESCREEN, to screen in advance [v]\n",
  "PRESCREENING": "PRESCREEN, to screen in advance [v]\n",
  "PRESCREENS": "PRESCREEN, to screen in advance [v]\n",
  "PRESCRIBE": "to lay down a rule or direction [v PRESCRIBED, PRESCRIBING, PRESCRIBES]\n",
  "PRESCRIBED": "PRESCRIBE, to lay down a rule or direction [v]\n",
  "PRESCRIBER": "one who prescribes [n -S]\n",
  "PRESCRIBERS": "PRESCRIBER, one who prescribes [n]\n",
  "PRESCRIBES": "PRESCRIBE, to lay down a rule or direction [v]\n",
  "PRESCRIBING": "the act of prescribing [n -S]\n",
  "PRESCRIBINGS": "PRESCRIBING, the act of prescribing [n]\n",
  "PRESCRIPT": "(archaic) a thing that is prescribed or laid down; an ordinance [n -S]\n",
  "PRESCRIPTIBLE": "that can be prescribed [adj]\n",
  "PRESCRIPTION": "the act of prescribing [n -S]\n",
  "PRESCRIPTIONS": "PRESCRIPTION, the act of prescribing [n]\n",
  "PRESCRIPTIVE": "serving to prescribe; (law) acquired through uninterrupted possession [adj PRESCRIPTIVELY]\n",
  "PRESCRIPTIVELY": "PRESCRIPTIVE, serving to prescribe; (law) acquired through uninterrupted possession [adv]\n",
  "PRESCRIPTIVISM": "the belief that moral edicts are merely orders with no truth value [n -S]\n",
  "PRESCRIPTIVISMS": "PRESCRIPTIVISM, the belief that moral edicts are merely orders with no truth value [n]\n",
  "PRESCRIPTIVIST": "an adherent of prescriptivism, the belief that moral edicts are merely orders with no truth value [n -S]\n",
  "PRESCRIPTIVISTS": "PRESCRIPTIVIST, an adherent of prescriptivism, the belief that moral edicts are merely orders with no truth value [n]\n",
  "PRESCRIPTS": "PRESCRIPT, (archaic) a thing that is prescribed or laid down; an ordinance [n]\n",
  "PRESCUTA": "PRESCUTUM, (Latin) in insects, a plate in front of the scutum [n]\n",
  "PRESCUTUM": "(Latin) in insects, a plate in front of the scutum [n PRESCUTA]\n",
  "PRESE": "PRESA, (Italian) a musical symbol used in a canon etc. to mark the entry of a voice or instrument [n]\n",
  "PRESEASON": "before the advent of the season [adj] / the time before the advent of the season [n -S]\n",
  "PRESEASONS": "PRESEASON, the time before the advent of the season [n]\n",
  "PRESELECT": "to select in advance [v -ED, -ING, -S]\n",
  "PRESELECTED": "PRESELECT, to select in advance [v]\n",
  "PRESELECTING": "PRESELECT, to select in advance [v]\n",
  "PRESELECTION": "the act of preselecting [n -S]\n",
  "PRESELECTIONS": "PRESELECTION, the act of preselecting [n]\n",
  "PRESELECTOR": "a component of a radio receiver, improving reception [n -S]\n",
  "PRESELECTORS": "PRESELECTOR, a component of a radio receiver, improving reception [n]\n",
  "PRESELECTS": "PRESELECT, to select in advance [v]\n",
  "PRESELL": "to promote a product not yet available to the public [v PRESOLD, PRESELLING, PRESELLS]\n",
  "PRESELLING": "PRESELL, to promote a product not yet available to the public [v]\n",
  "PRESELLS": "PRESELL, to promote a product not yet available to the public [v]\n",
  "PRESENCE": "close proximity [n -S]\n",
  "PRESENCES": "PRESENCE, close proximity [n]\n",
  "PRESENILE": "occurring before the onset of old age [adj]\n",
  "PRESENSION": "previous perception [n -S]\n",
  "PRESENSIONS": "PRESENSION, previous perception [n]\n",
  "PRESENT": "soon [adj PRESENTLY] / to bring into the presence of someone [v -ED, -ING, -S]\n",
  "PRESENTABILITY": "the state of being presentable [n]\n",
  "PRESENTABLE": "worthy of presentation [adj PRESENTABLY]\n",
  "PRESENTABLENESS": "PRESENTABLE, worthy of presentation [n]\n",
  "PRESENTABLY": "PRESENTABLE, worthy of presentation [adv]\n",
  "PRESENTATION": "the act of presenting [n -S]\n",
  "PRESENTATIONAL": "relating to presentation [adj]\n",
  "PRESENTATIONISM": "the doctrine of immediate cognition of objects [n]\n",
  "PRESENTATIONIST": "an adherent of presentationism [n]\n",
  "PRESENTATIONS": "PRESENTATION, the act of presenting [n]\n",
  "PRESENTATIVE": "known, knowing, or capable of being known directly rather than through cogitation [adj]\n",
  "PRESENTED": "PRESENT, to bring into the presence of someone [v]\n",
  "PRESENTEE": "one presented to a benefice [n -S]\n",
  "PRESENTEEISM": "ostentatious attendance at work [n -S]\n",
  "PRESENTEEISMS": "PRESENTEEISM, ostentatious attendance at work [n]\n",
  "PRESENTEES": "PRESENTEE, one presented to a benefice [n]\n",
  "PRESENTENCE": "to sentence in advance [v PRESENTENCED, PRESENTENCING, PRESENTENCES]\n",
  "PRESENTENCED": "PRESENTENCE, to sentence in advance [v]\n",
  "PRESENTENCES": "PRESENTENCE, to sentence in advance [v]\n",
  "PRESENTENCING": "PRESENTENCE, to sentence in advance [v]\n",
  "PRESENTER": "one who presents [n -S]\n",
  "PRESENTERS": "PRESENTER, one who presents [n]\n",
  "PRESENTIAL": "relating to or having actual presence [adj PRESENTIALLY]\n",
  "PRESENTIALITIES": "PRESENTIALITY, the state of being presential, relating to or having actual presence [n]\n",
  "PRESENTIALITY": "the state of being presential, relating to or having actual presence [n PRESENTIALITIES]\n",
  "PRESENTIALLY": "PRESENTIAL, relating to or having actual presence [adv]\n",
  "PRESENTIENT": "prescient; having a premonition [adj]\n",
  "PRESENTIMENT": "a feeling that something will or is about to happen [n -S]\n",
  "PRESENTIMENTAL": "relating to presentiment [adj]\n",
  "PRESENTIMENTS": "PRESENTIMENT, a feeling that something will or is about to happen [n]\n",
  "PRESENTING": "PRESENT, to bring into the presence of someone [v]\n",
  "PRESENTISM": "the practice of evaluating past events and people by present-day values [n -S]\n",
  "PRESENTISMS": "PRESENTISM, the practice of evaluating past events and people by present-day values [n]\n",
  "PRESENTIST": "one with a bias towards present-day points of view [n -S]\n",
  "PRESENTISTS": "PRESENTIST, one with a bias towards present-day points of view [n]\n",
  "PRESENTIVE": "a word that presents an object to the mind [n -S]\n",
  "PRESENTIVENESS": "the state of being presentive [n]\n",
  "PRESENTIVES": "PRESENTIVE, a word that presents an object to the mind [n]\n",
  "PRESENTLY": "shortly, soon [adv]\n",
  "PRESENTMENT": "a jury's statement to a court of matters within its knowledge [n -S]\n",
  "PRESENTMENTS": "PRESENTMENT, a jury's statement to a court of matters within its knowledge [n]\n",
  "PRESENTNESS": "the state of being present [n -ES]\n",
  "PRESENTNESSES": "PRESENTNESS, the state of being present [n]\n",
  "PRESENTS": "PRESENT, to bring into the presence of someone [v]\n",
  "PRESERVABILITY": "the state of being preservable [n]\n",
  "PRESERVABLE": "that can be preserved [adj PRESERVABLY]\n",
  "PRESERVABLY": "PRESERVABLE, that can be preserved [adv]\n",
  "PRESERVATION": "the act of preserving [n -S]\n",
  "PRESERVATIONIST": "one who advocates preservation (as of a biological species or a historical landmark) [n]\n",
  "PRESERVATIONS": "PRESERVATION, the act of preserving [n]\n",
  "PRESERVATIVE": "serving to preserve [adj] / something that preserves or has the power of preserving [n -S]\n",
  "PRESERVATIVES": "PRESERVATIVE, something that preserves or has the power of preserving [n]\n",
  "PRESERVATORIES": "PRESERVATORY, something serving to preserve [n]\n",
  "PRESERVATORY": "serving to preserve [adj] / something serving to preserve [n PRESERVATORIES]\n",
  "PRESERVE": "to keep safe from harm [v PRESERVED, PRESERVING, PRESERVES]\n",
  "PRESERVED": "PRESERVE, to keep safe from harm [v]\n",
  "PRESERVER": "one who preserves [n -S]\n",
  "PRESERVERS": "PRESERVER, one who preserves [n]\n",
  "PRESERVES": "PRESERVE, to keep safe from harm [v]\n",
  "PRESERVICE": "before service [adj]\n",
  "PRESERVING": "PRESERVE, to keep safe from harm [v]\n",
  "PRESES": "(Scots) a president or chairman, also PRAESES [n PRESES]\n",
  "PRESET": "to set beforehand [v PRESET, PRESETTING, PRESETS]\n",
  "PRESETS": "PRESET, to set beforehand [v]\n",
  "PRESETTING": "PRESET, to set beforehand [v]\n",
  "PRESETTLE": "to settle in advance [v PRESETTLED, PRESETTLING, PRESETTLES]\n",
  "PRESETTLED": "PRESETTLE, to settle in advance [v]\n",
  "PRESETTLEMENT": "preceding a settlement [adj]\n",
  "PRESETTLES": "PRESETTLE, to settle in advance [v]\n",
  "PRESETTLING": "PRESETTLE, to settle in advance [v]\n",
  "PRESHAPE": "to shape beforehand [v PRESHAPED, PRESHAPING, PRESHAPES]\n",
  "PRESHAPED": "PRESHAPE, to shape beforehand [v]\n",
  "PRESHAPES": "PRESHAPE, to shape beforehand [v]\n",
  "PRESHAPING": "PRESHAPE, to shape beforehand [v]\n",
  "PRESHIP": "to ship beforehand [v PRESHIPPED, PRESHIPPING, PRESHIPS]\n",
  "PRESHIPPED": "PRESHIP, to ship beforehand [v]\n",
  "PRESHIPPING": "PRESHIP, to ship beforehand [v]\n",
  "PRESHIPS": "PRESHIP, to ship beforehand [v]\n",
  "PRESHOW": "to show beforehand [v PRESHOWED, PRESHOWN, PRESHOWING, PRESHOWS]\n",
  "PRESHOWED": "PRESHOW, to show beforehand [v]\n",
  "PRESHOWING": "PRESHOW, to show beforehand [v]\n",
  "PRESHOWN": "PRESHOW, to show beforehand [v]\n",
  "PRESHOWS": "PRESHOW, to show beforehand [v]\n",
  "PRESHRANK": "PRESHRINK, to shrink in advance [v]\n",
  "PRESHRINK": "to shrink in advance [v PRESHRANK, PRESHRUNK, PRESHRUNKEN, PRESHRINKING, PRESHRINKS]\n",
  "PRESHRINKING": "PRESHRINK, to shrink in advance [v]\n",
  "PRESHRINKS": "PRESHRINK, to shrink in advance [v]\n",
  "PRESHRUNK": "PRESHRINK, to shrink in advance [v]\n",
  "PRESHRUNKEN": "PRESHRINK, to shrink in advance [v]\n",
  "PRESIDE": "to occupy the position of authority [v PRESIDED, PRESIDING, PRESIDES]\n",
  "PRESIDED": "PRESIDE, to occupy the position of authority [v]\n",
  "PRESIDENCIES": "PRESIDENCY, the office of president [n]\n",
  "PRESIDENCY": "the office of president [n PRESIDENCIES]\n",
  "PRESIDENT": "the head of a state, board, council etc. [n -S]\n",
  "PRESIDENTESS": "a female president [n -ES]\n",
  "PRESIDENTESSES": "PRESIDENTESS, a female president [n]\n",
  "PRESIDENTIAL": "relating to a president [adj PRESIDENTIALLY]\n",
  "PRESIDENTIALLY": "PRESIDENTIAL, relating to a president [adv]\n",
  "PRESIDENTS": "PRESIDENT, the head of a state, board, council etc. [n]\n",
  "PRESIDENTSHIP": "the office of president [n -S]\n",
  "PRESIDENTSHIPS": "PRESIDENTSHIP, the office of president [n]\n",
  "PRESIDER": "one who presides [n -S]\n",
  "PRESIDERS": "PRESIDER, one who presides [n]\n",
  "PRESIDES": "PRESIDE, to occupy the position of authority [v]\n",
  "PRESIDIA": "PRESIDIUM, (Latin) a standing committee in the former Soviet Union, also PRAESIDIUM [n]\n",
  "PRESIDIAL": "of or pertaining to a garrison, also PRESIDIARY [adj]\n",
  "PRESIDIARY": "of or pertaining to a garrison, also PRESIDIAL [adj]\n",
  "PRESIDING": "PRESIDE, to occupy the position of authority [v]\n",
  "PRESIDIO": "(Spanish) a Spanish fort [n -S]\n",
  "PRESIDIOS": "PRESIDIO, (Spanish) a Spanish fort [n]\n",
  "PRESIDIUM": "(Latin) a standing committee in the former Soviet Union, also PRAESIDIUM [n PRESIDIA or PRESIDIUMS]\n",
  "PRESIDIUMS": "PRESIDIUM, (Latin) a standing committee in the former Soviet Union, also PRAESIDIUM [n]\n",
  "PRESIFT": "to sift beforehand [v -ED, -ING, -S]\n",
  "PRESIFTED": "PRESIFT, to sift beforehand [v]\n",
  "PRESIFTING": "PRESIFT, to sift beforehand [v]\n",
  "PRESIFTS": "PRESIFT, to sift beforehand [v]\n",
  "PRESIGNAL": "to signal in advance [v PRESIGNALED or PRESIGNALLED, PRESIGNALING or PRESIGNALLING, PRESIGNALS]\n",
  "PRESIGNALED": "PRESIGNAL, to signal in advance [v]\n",
  "PRESIGNALING": "PRESIGNAL, to signal in advance [v]\n",
  "PRESIGNALLED": "PRESIGNAL, to signal in advance [v]\n",
  "PRESIGNALLING": "PRESIGNAL, to signal in advance [v]\n",
  "PRESIGNALS": "PRESIGNAL, to signal in advance [v]\n",
  "PRESIGNIFIED": "PRESIGNIFY, to intimate or signify beforehand [v]\n",
  "PRESIGNIFIES": "PRESIGNIFY, to intimate or signify beforehand [v]\n",
  "PRESIGNIFY": "to intimate or signify beforehand [v PRESIGNIFIED, PRESIGNIFYING, PRESIGNIFIES]\n",
  "PRESIGNIFYING": "PRESIGNIFY, to intimate or signify beforehand [v]\n",
  "PRESLAUGHTER": "preceding a slaughter [adj]\n",
  "PRESLEEP": "before sleep [adj]\n",
  "PRESLICE": "to slice beforehand [v PRESLICED, PRESLICING, PRESLICES]\n",
  "PRESLICED": "PRESLICE, to slice beforehand [v]\n",
  "PRESLICES": "PRESLICE, to slice beforehand [v]\n",
  "PRESLICING": "PRESLICE, to slice beforehand [v]\n",
  "PRESOAK": "to soak beforehand [v -ED, -ING, -S]\n",
  "PRESOAKED": "PRESOAK, to soak beforehand [v]\n",
  "PRESOAKING": "PRESOAK, to soak beforehand [v]\n",
  "PRESOAKS": "PRESOAK, to soak beforehand [v]\n",
  "PRESOLD": "PRESELL, to promote a product not yet available to the public [v]\n",
  "PRESOLVE": "to solve beforehand [v PRESOLVED, PRESOLVING, PRESOLVES]\n",
  "PRESOLVED": "PRESOLVE, to solve beforehand [v]\n",
  "PRESOLVES": "PRESOLVE, to solve beforehand [v]\n",
  "PRESOLVING": "PRESOLVE, to solve beforehand [v]\n",
  "PRESONG": "before a song [adj]\n",
  "PRESORT": "to sort beforehand [v -ED, -ING, -S]\n",
  "PRESORTED": "PRESORT, to sort beforehand [v]\n",
  "PRESORTING": "PRESORT, to sort beforehand [v]\n",
  "PRESORTS": "PRESORT, to sort beforehand [v]\n",
  "PRESPECIFIED": "PRESPECIFY, to specify in advance [v]\n",
  "PRESPECIFIES": "PRESPECIFY, to specify in advance [v]\n",
  "PRESPECIFY": "to specify in advance [v PRESPECIFIED, PRESPECIFYING, PRESPECIFIES]\n",
  "PRESPECIFYING": "PRESPECIFY, to specify in advance [v]\n",
  "PRESPLIT": "before a split [adj]\n",
  "PRESS": "to compress or squeeze [v -ED, -ING, -ES]\n",
  "PRESSBACK": "relating to wooden chairs of the Victorian period, having a pattern pressed into the crest rail and/or splat by means of a steam press [adj]\n",
  "PRESSBOARD": "an ironing board esp. a small one for sleeves [n -S]\n",
  "PRESSBOARDS": "PRESSBOARD, an ironing board esp. a small one for sleeves [n]\n",
  "PRESSED": "PRESS, to compress or squeeze [v]\n",
  "PRESSER": "one who presses [n -S]\n",
  "PRESSERS": "PRESSER, one who presses [n]\n",
  "PRESSES": "PRESS, to compress or squeeze [v]\n",
  "PRESSFAT": "a vat for collecting wine or oil from the press [n -S]\n",
  "PRESSFATS": "PRESSFAT, a vat for collecting wine or oil from the press [n]\n",
  "PRESSFUL": "the contents of a press e.g. of oil or wine [n -S]\n",
  "PRESSFULS": "PRESSFUL, the contents of a press e.g. of oil or wine [n]\n",
  "PRESSGANG": "a squad of sailors forcing others into the navy [n -S]\n",
  "PRESSGANGS": "PRESSGANG, a squad of sailors forcing others into the navy [n]\n",
  "PRESSIE": "(colloquial) a present, also PRESSY, PREZZIE [n -S]\n",
  "PRESSIES": "PRESSIE, (colloquial) a present, also PRESSY, PREZZIE [n]\n",
  "PRESSING": "an article made from the same mould [n -S]\n",
  "PRESSINGLY": "PRESSING [adv]\n",
  "PRESSINGNESS": "the state of being pressing [n -ES]\n",
  "PRESSINGNESSES": "PRESSINGNESS, the state of being pressing [n]\n",
  "PRESSINGS": "PRESSING, an article made from the same mould [n]\n",
  "PRESSION": "pressure [n -S]\n",
  "PRESSIONS": "PRESSION, pressure [n]\n",
  "PRESSMAN": "a printing press operator [n PRESSMEN]\n",
  "PRESSMARK": "a mark on a book to show its location in a library [n -S]\n",
  "PRESSMARKS": "PRESSMARK, a mark on a book to show its location in a library [n]\n",
  "PRESSMEN": "PRESSMAN, a printing press operator [n]\n",
  "PRESSOR": "a substance that raises blood pressure [n -S]\n",
  "PRESSORS": "PRESSOR, a substance that raises blood pressure [n]\n",
  "PRESSROOM": "a room for reporters [n -S]\n",
  "PRESSROOMS": "PRESSROOM, a room for reporters [n]\n",
  "PRESSRUN": "a continuous operation of a printing press [n -S]\n",
  "PRESSRUNS": "PRESSRUN, a continuous operation of a printing press [n]\n",
  "PRESSURE": "to apply force to [v PRESSURED, PRESSURING, PRESSURES]\n",
  "PRESSURED": "PRESSURE, to apply force to [v]\n",
  "PRESSURELESS": "without pressure [adj]\n",
  "PRESSURES": "PRESSURE, to apply force to [v]\n",
  "PRESSURING": "PRESSURE, to apply force to [v]\n",
  "PRESSURISATION": "the act of pressurising, also PRESSURIZATION [n -S]\n",
  "PRESSURISATIONS": "PRESSURISATION, the act of pressurising, also PRESSURIZATION [n]\n",
  "PRESSURISE": "to place under pressure, also PRESSURIZE [v PRESSURISED, PRESSURISING, PRESSURISES]\n",
  "PRESSURISED": "PRESSURISE, to place under pressure, also PRESSURIZE [v]\n",
  "PRESSURISER": "an apparatus for pressurising, also PRESSURIZER [n -S]\n",
  "PRESSURISERS": "PRESSURISER, an apparatus for pressurising, also PRESSURIZER [n]\n",
  "PRESSURISES": "PRESSURISE, to place under pressure, also PRESSURIZE [v]\n",
  "PRESSURISING": "PRESSURISE, to place under pressure, also PRESSURIZE [v]\n",
  "PRESSURIZATION": "the act of pressurizing, also PRESSURISATION [n -S]\n",
  "PRESSURIZATIONS": "PRESSURIZATION, the act of pressurizing, also PRESSURISATION [n]\n",
  "PRESSURIZE": "to place under pressure, also PRESSURISE [v PRESSURIZED, PRESSURIZING, PRESSURIZES]\n",
  "PRESSURIZED": "PRESSURIZE, to place under pressure, also PRESSURISE [v]\n",
  "PRESSURIZER": "an apparatus for pressurizing, also PRESSURISER [n -S]\n",
  "PRESSURIZERS": "PRESSURIZER, an apparatus for pressurizing, also PRESSURISER [n]\n",
  "PRESSURIZES": "PRESSURIZE, to place under pressure, also PRESSURISE [v]\n",
  "PRESSURIZING": "PRESSURIZE, to place under pressure, also PRESSURISE [v]\n",
  "PRESSWOMAN": "a female reporter [n PRESSWOMEN]\n",
  "PRESSWOMEN": "PRESSWOMAN, a female reporter [n]\n",
  "PRESSWORK": "the operation of a printing press; printed matter [n -S]\n",
  "PRESSWORKS": "PRESSWORK, the operation of a printing press; printed matter [n]\n",
  "PRESSY": "(colloquial) a present, also PRESSIE, PREZZIE [n PRESSIES]\n",
  "PREST": "(obsolete) to lend [v -ED, -ING, -S]\n",
  "PRESTAMP": "to stamp beforehand [v -ED, -ING, -S]\n",
  "PRESTAMPED": "PRESTAMP, to stamp beforehand [v]\n",
  "PRESTAMPING": "PRESTAMP, to stamp beforehand [v]\n",
  "PRESTAMPS": "PRESTAMP, to stamp beforehand [v]\n",
  "PRESTATION": "a payment of money; a toll or duty [n -S]\n",
  "PRESTATIONS": "PRESTATION, a payment of money; a toll or duty [n]\n",
  "PRESTED": "PREST, (obsolete) to lend [v]\n",
  "PRESTER": "a priest [n -S]\n",
  "PRESTERILISE": "to sterilise in advance, also PRESTERILIZE [v PRESTERILISED, PRESTERILISING, PRESTERILISES]\n",
  "PRESTERILISED": "PRESTERILISE, to sterilise in advance, also PRESTERILIZE [v]\n",
  "PRESTERILISES": "PRESTERILISE, to sterilise in advance, also PRESTERILIZE [v]\n",
  "PRESTERILISING": "PRESTERILISE, to sterilise in advance, also PRESTERILIZE [v]\n",
  "PRESTERILIZE": "to sterilize in advance, also PRESTERILISE [v PRESTERILIZED, PRESTERILIZING, PRESTERILIZES]\n",
  "PRESTERILIZED": "PRESTERILIZE, to sterilize in advance, also PRESTERILISE [v]\n",
  "PRESTERILIZES": "PRESTERILIZE, to sterilize in advance, also PRESTERILISE [v]\n",
  "PRESTERILIZING": "PRESTERILIZE, to sterilize in advance, also PRESTERILISE [v]\n",
  "PRESTERNA": "PRESTERNUM, the anterior segment of the sternum [n]\n",
  "PRESTERNUM": "the anterior segment of the sternum [n PRESTERNA or PRESTERNUMS]\n",
  "PRESTERNUMS": "PRESTERNUM, the anterior segment of the sternum [n]\n",
  "PRESTERS": "PRESTER, a priest [n]\n",
  "PRESTIDIGITATOR": "a conjurer, also PRESTIGIATOR [n]\n",
  "PRESTIGE": "charm, magic or glamour in the eyes of other people [n -S]\n",
  "PRESTIGEFUL": "full of prestige [adj]\n",
  "PRESTIGES": "PRESTIGE, charm, magic or glamour in the eyes of other people [n]\n",
  "PRESTIGIATOR": "a conjurer, also PRESTIDIGITATOR [n -S]\n",
  "PRESTIGIATORS": "PRESTIGIATOR, a conjurer, also PRESTIDIGITATOR [n]\n",
  "PRESTIGIOUS": "having prestige [adj PRESTIGIOUSLY]\n",
  "PRESTIGIOUSLY": "PRESTIGIOUS, having prestige [adv]\n",
  "PRESTIGIOUSNESS": "the state of being prestigious [n]\n",
  "PRESTING": "PREST, (obsolete) to lend [v]\n",
  "PRESTISSIMO": "(Italian) as quickly as possible [adj] / a musical passage to be played as quickly as possible [n -S]\n",
  "PRESTISSIMOS": "PRESTISSIMO, a musical passage to be played as quickly as possible [n]\n",
  "PRESTO": "(Italian) a musical passage played in rapid tempo [n -S]\n",
  "PRESTORAGE": "occurring before storage [adj]\n",
  "PRESTORE": "to store beforehand [v PRESTORED, PRESTORING, PRESTORES]\n",
  "PRESTORED": "PRESTORE, to store beforehand [v]\n",
  "PRESTORES": "PRESTORE, to store beforehand [v]\n",
  "PRESTORING": "PRESTORE, to store beforehand [v]\n",
  "PRESTOS": "PRESTO, (Italian) a musical passage played in rapid tempo [n]\n",
  "PRESTRESS": "to stress in advance [v -ED, -ING, -ES]\n",
  "PRESTRESSED": "PRESTRESS, to stress in advance [v]\n",
  "PRESTRESSES": "PRESTRESS, to stress in advance [v]\n",
  "PRESTRESSING": "PRESTRESS, to stress in advance [v]\n",
  "PRESTRICTION": "(obsolete) blindness; blindfolding [n -S]\n",
  "PRESTRICTIONS": "PRESTRICTION, (obsolete) blindness; blindfolding [n]\n",
  "PRESTRIKE": "preceding a strike [adj]\n",
  "PRESTRUCTURE": "to structure in advance [v PRESTRUCTURED, PRESTRUCTURING, PRESTRUCTURES]\n",
  "PRESTRUCTURED": "PRESTRUCTURE, to structure in advance [v]\n",
  "PRESTRUCTURES": "PRESTRUCTURE, to structure in advance [v]\n",
  "PRESTRUCTURING": "PRESTRUCTURE, to structure in advance [v]\n",
  "PRESTS": "PREST, (obsolete) to lend [v]\n",
  "PRESUMABLE": "to be presumed [adj PRESUMABLY]\n",
  "PRESUMABLY": "PRESUMABLE, to be presumed [adv]\n",
  "PRESUME": "to take for granted [v PRESUMED, PRESUMING, PRESUMES]\n",
  "PRESUMED": "PRESUME, to take for granted [v]\n",
  "PRESUMEDLY": "PRESUMED, PRESUME, to take for granted [adv]\n",
  "PRESUMER": "one who presumes [n -S]\n",
  "PRESUMERS": "PRESUMER, one who presumes [n]\n",
  "PRESUMES": "PRESUME, to take for granted [v]\n",
  "PRESUMING": "PRESUME, to take for granted [v]\n",
  "PRESUMINGLY": "PRESUMING, PRESUME, to take for granted [adv]\n",
  "PRESUMMIT": "preceding a (political) summit [adj] / a meeting held prior to a summit [n -S]\n",
  "PRESUMMITS": "PRESUMMIT, a meeting held prior to a summit [n]\n",
  "PRESUMPTION": "the act of presuming [n -S]\n",
  "PRESUMPTIONS": "PRESUMPTION, the act of presuming [n]\n",
  "PRESUMPTIVE": "based on probability or presumption [adj PRESUMPTIVELY]\n",
  "PRESUMPTIVELY": "PRESUMPTIVE, based on probability or presumption [adv]\n",
  "PRESUMPTIVENESS": "the state of being presumptive [n]\n",
  "PRESUMPTUOUS": "overstepping due bounds (as of propriety or courtesy) [adj PRESUMPTUOUSLY]\n",
  "PRESUMPTUOUSLY": "PRESUMPTUOUS, overstepping due bounds (as of propriety or courtesy) [adv]\n",
  "PRESUPPOSE": "to suppose beforehand [v PRESUPPOSED, PRESUPPOSING, PRESUPPOSES]\n",
  "PRESUPPOSED": "PRESUPPOSE, to suppose beforehand [v]\n",
  "PRESUPPOSES": "PRESUPPOSE, to suppose beforehand [v]\n",
  "PRESUPPOSING": "PRESUPPOSE, to suppose beforehand [v]\n",
  "PRESUPPOSITION": "a preliminary supposition [n -S]\n",
  "PRESUPPOSITIONS": "PRESUPPOSITION, a preliminary supposition [n]\n",
  "PRESURGERY": "before surgery [adj]\n",
  "PRESURMISE": "(Shakespeare) a surmise previously formed [n -S]\n",
  "PRESURMISES": "PRESURMISE, (Shakespeare) a surmise previously formed [n]\n",
  "PRESURVEY": "to survey in advance [v -ED, -ING, -S]\n",
  "PRESURVEYED": "PRESURVEY, to survey in advance [v]\n",
  "PRESURVEYING": "PRESURVEY, to survey in advance [v]\n",
  "PRESURVEYS": "PRESURVEY, to survey in advance [v]\n",
  "PRESWEETEN": "to sweeten in advance [v -ED, -ING, -S]\n",
  "PRESWEETENED": "PRESWEETEN, to sweeten in advance [v]\n",
  "PRESWEETENING": "PRESWEETEN, to sweeten in advance [v]\n",
  "PRESWEETENS": "PRESWEETEN, to sweeten in advance [v]\n",
  "PRESYMPTOMATIC": "preceding a symptom [adj]\n",
  "PRESYNAPTIC": "relating to a neuron by which a nerve impulse is conveyed to a synapse [adj PRESYNAPTICALLY]\n",
  "PRESYNAPTICALLY": "PRESYNAPTIC, relating to a neuron by which a nerve impulse is conveyed to a synapse [adv]\n",
  "PRETAPE": "to tape beforehand [v PRETAPED, PRETAPING, PRETAPES]\n",
  "PRETAPED": "PRETAPE, to tape beforehand [v]\n",
  "PRETAPES": "PRETAPE, to tape beforehand [v]\n",
  "PRETAPING": "PRETAPE, to tape beforehand [v]\n",
  "PRETASTE": "to taste beforehand [v PRETASTED, PRETASTING, PRETASTES]\n",
  "PRETASTED": "PRETASTE, to taste beforehand [v]\n",
  "PRETASTES": "PRETASTE, to taste beforehand [v]\n",
  "PRETASTING": "PRETASTE, to taste beforehand [v]\n",
  "PRETAX": "existing before provision for taxes [adj]\n",
  "PRETEEN": "a child under the age of thirteen [n -S]\n",
  "PRETEENS": "PRETEEN, a child under the age of thirteen [n]\n",
  "PRETELEVISION": "before television [adj]\n",
  "PRETELL": "to tell beforehand [v PRETOLD, PRETELLING, PRETELLS]\n",
  "PRETELLING": "PRETELL, to tell beforehand [v]\n",
  "PRETELLS": "PRETELL, to tell beforehand [v]\n",
  "PRETENCE": "the act of pretending, also PRETENSE [n -S]\n",
  "PRETENCELESS": "without pretence [adj]\n",
  "PRETENCES": "PRETENCE, the act of pretending, also PRETENSE [n]\n",
  "PRETEND": "to make believe [v -ED, -ING, -S]\n",
  "PRETENDANT": "a pretender; a claimant, also PRETENDENT [n -S]\n",
  "PRETENDANTS": "PRETENDANT, a pretender; a claimant, also PRETENDENT [n]\n",
  "PRETENDED": "PRETEND, to make believe [v]\n",
  "PRETENDEDLY": "PRETENDED, PRETEND, to make believe [adv]\n",
  "PRETENDENT": "a pretender; a claimant, also PRETENDANT [n -S]\n",
  "PRETENDENTS": "PRETENDENT, a pretender; a claimant, also PRETENDANT [n]\n",
  "PRETENDER": "one who lays claim to something [n -S]\n",
  "PRETENDERS": "PRETENDER, one who lays claim to something [n]\n",
  "PRETENDERSHIP": "the office of pretender [n -S]\n",
  "PRETENDERSHIPS": "PRETENDERSHIP, the office of pretender [n]\n",
  "PRETENDING": "PRETEND, to make believe [v]\n",
  "PRETENDINGLY": "PRETENDING, PRETEND, to make believe [adv]\n",
  "PRETENDS": "PRETEND, to make believe [v]\n",
  "PRETENSE": "the act of pretending, also PRETENCE [n -S]\n",
  "PRETENSELESS": "without pretense [adj]\n",
  "PRETENSES": "PRETENSE, the act of pretending, also PRETENCE [n]\n",
  "PRETENSION": "foolish vanity or pretence [n -S] / to tension in advance [v -ED, -ING, -S]\n",
  "PRETENSIONED": "PRETENSION, to tension in advance [v]\n",
  "PRETENSIONING": "PRETENSION, to tension in advance [v]\n",
  "PRETENSIONLESS": "without pretension [adj]\n",
  "PRETENSIONS": "PRETENSION, to tension in advance [v]\n",
  "PRETENSIVE": "pretentious [adj]\n",
  "PRETENTIOUS": "making usually unjustified or excessive claims (as of value or standing) [adj PRETENTIOUSLY]\n",
  "PRETENTIOUSLY": "PRETENTIOUS, making usually unjustified or excessive claims (as of value or standing) [adv]\n",
  "PRETENTIOUSNESS": "PRETENTIOUS, making usually unjustified or excessive claims (as of value or standing) [n]\n",
  "PRETERHUMAN": "more than human [adj]\n",
  "PRETERIST": "a person who holds that the prophecies of the Apocalypse have been already fulfilled [n -S]\n",
  "PRETERISTS": "PRETERIST, a person who holds that the prophecies of the Apocalypse have been already fulfilled [n]\n",
  "PRETERIT": "the grammatical tense signifying past time or a completed action, also PRETERITE [n -S]\n",
  "PRETERITE": "the grammatical tense signifying past time or a completed action, also PRETERIT [n -S]\n",
  "PRETERITENESS": "the state of being preterite [n -ES]\n",
  "PRETERITENESSES": "PRETERITENESS, the state of being preterite [n]\n",
  "PRETERITES": "PRETERITE, the grammatical tense signifying past time or a completed action, also PRETERIT [n]\n",
  "PRETERITION": "the omission by a testator of some one of his entitled heirs, thus invalidating the will [n -S]\n",
  "PRETERITIONS": "PRETERITION, the omission by a testator of some one of his entitled heirs, thus invalidating the will [n]\n",
  "PRETERITIVE": "used only in the preterite [adj]\n",
  "PRETERITS": "PRETERIT, the grammatical tense signifying past time or a completed action, also PRETERITE [n]\n",
  "PRETERM": "born prematurely [adj] / a prematurely born baby [n -S]\n",
  "PRETERMINAL": "occurring or being in the period prior to death [adj]\n",
  "PRETERMINATION": "a preliminary termination [n -S]\n",
  "PRETERMINATIONS": "PRETERMINATION, a preliminary termination [n]\n",
  "PRETERMISSION": "the act or an instance of pretermitting [n -S]\n",
  "PRETERMISSIONS": "PRETERMISSION, the act or an instance of pretermitting [n]\n",
  "PRETERMIT": "to omit, neglect to mention [v PRETERMITTED, PRETERMITTING, PRETERMITS]\n",
  "PRETERMITS": "PRETERMIT, to omit, neglect to mention [v]\n",
  "PRETERMITTED": "PRETERMIT, to omit, neglect to mention [v]\n",
  "PRETERMITTER": "one who pretermits [n -S]\n",
  "PRETERMITTERS": "PRETERMITTER, one who pretermits [n]\n",
  "PRETERMITTING": "PRETERMIT, to omit, neglect to mention [v]\n",
  "PRETERMS": "PRETERM, a prematurely born baby [n]\n",
  "PRETERNATURAL": "existing outside of nature [adj PRETERNATURALLY]\n",
  "PRETERNATURALLY": "PRETERNATURAL, existing outside of nature [adv]\n",
  "PRETERPERFECT": "the perfect tense [n -S]\n",
  "PRETERPERFECTS": "PRETERPERFECT, the perfect tense [n]\n",
  "PRETEST": "to give a preliminary test to [v -ED, -ING, -S]\n",
  "PRETESTED": "PRETEST, to give a preliminary test to [v]\n",
  "PRETESTING": "PRETEST, to give a preliminary test to [v]\n",
  "PRETESTS": "PRETEST, to give a preliminary test to [v]\n",
  "PRETEXT": "an ostensible motive or reason, put forward as an excuse or to conceal the true one [n -S] / to allege as an excuse [v -ED, -ING, -S]\n",
  "PRETEXTED": "PRETEXT, to allege as an excuse [v]\n",
  "PRETEXTING": "the act of alleging as an excuse [n -S]\n",
  "PRETEXTINGS": "PRETEXTING, the act of alleging as an excuse [n]\n",
  "PRETEXTS": "PRETEXT, to allege as an excuse [v]\n",
  "PRETHEATER": "occurring before the theatre, also PRETHEATRE [adj]\n",
  "PRETHEATRE": "occurring before a visit to the theatre, also PRETHEATER [adj]\n",
  "PRETOLD": "PRETELL, to tell beforehand [v]\n",
  "PRETONIC": "denoting the syllable before the one bearing the primary stress in a word [adj]\n",
  "PRETOR": "(Latin) an ancient Roman magistrate, also PRAETOR [n -S]\n",
  "PRETORIAL": "relating to a pretor, a magistrate of ancient Rome, also PRAETORIAL [adj]\n",
  "PRETORIAN": "a former praetor or man of equivalent rank, also PRAETORIAN [n -S]\n",
  "PRETORIANS": "PRETORIAN, a former praetor or man of equivalent rank, also PRAETORIAN [n]\n",
  "PRETORS": "PRETOR, (Latin) an ancient Roman magistrate, also PRAETOR [n]\n",
  "PRETORSHIP": "the office of pretor, a magistrate of ancient Rome, also PRAETORSHIP [n -S]\n",
  "PRETORSHIPS": "PRETORSHIP, the office of pretor, a magistrate of ancient Rome, also PRAETORSHIP [n]\n",
  "PRETOURNAMENT": "taking place before a tournament [adj]\n",
  "PRETRAIN": "to train beforehand [v -ED, -ING, -S]\n",
  "PRETRAINED": "PRETRAIN, to train beforehand [v]\n",
  "PRETRAINING": "PRETRAIN, to train beforehand [v]\n",
  "PRETRAINS": "PRETRAIN, to train beforehand [v]\n",
  "PRETRAVEL": "before travel [adj]\n",
  "PRETREAT": "to treat beforehand [v -ED, -ING, -S]\n",
  "PRETREATED": "PRETREAT, to treat beforehand [v]\n",
  "PRETREATING": "PRETREAT, to treat beforehand [v]\n",
  "PRETREATMENT": "treatment in advance [n -S]\n",
  "PRETREATMENTS": "PRETREATMENT, treatment in advance [n]\n",
  "PRETREATS": "PRETREAT, to treat beforehand [v]\n",
  "PRETRIAL": "a proceeding that precedes a trial [n -S]\n",
  "PRETRIALS": "PRETRIAL, a proceeding that precedes a trial [n]\n",
  "PRETRIM": "to trim beforehand [v PRETRIMMED, PRETRIMMING, PRETRIMS]\n",
  "PRETRIMMED": "PRETRIM, to trim beforehand [v]\n",
  "PRETRIMMING": "PRETRIM, to trim beforehand [v]\n",
  "PRETRIMS": "PRETRIM, to trim beforehand [v]\n",
  "PRETTIED": "PRETTY, to make attractive [v]\n",
  "PRETTIER": "PRETTY, pleasing to the eye [adj]\n",
  "PRETTIES": "PRETTY, to make attractive [v]\n",
  "PRETTIEST": "PRETTY, pleasing to the eye [adj]\n",
  "PRETTIFICATION": "the act of prettifying [n -S]\n",
  "PRETTIFICATIONS": "PRETTIFICATION, the act of prettifying [n]\n",
  "PRETTIFIED": "PRETTIFY, to make attractive [v]\n",
  "PRETTIFIER": "one who prettifies [n -S]\n",
  "PRETTIFIERS": "PRETTIFIER, one who prettifies [n]\n",
  "PRETTIFIES": "PRETTIFY, to make attractive [v]\n",
  "PRETTIFY": "to make attractive [v PRETTIFIED, PRETTIFYING, PRETTIFIES]\n",
  "PRETTIFYING": "PRETTIFY, to make attractive [v]\n",
  "PRETTILY": "PRETTY, pleasing to the eye [adv]\n",
  "PRETTINESS": "the state of being pretty [n -ES]\n",
  "PRETTINESSES": "PRETTINESS, the state of being pretty [n]\n",
  "PRETTY": "pleasing to the eye [adj PRETTIER, PRETTIEST, PRETTILY] / to make attractive [v PRETTIED, PRETTYING, PRETTIES]\n",
  "PRETTYING": "PRETTY, to make attractive [v]\n",
  "PRETTYISH": "somewhat pretty [adj]\n",
  "PRETTYISM": "affectation of a pretty style, manner, etc. [n -S]\n",
  "PRETTYISMS": "PRETTYISM, affectation of a pretty style, manner, etc. [n]\n",
  "PRETYPE": "to type beforehand [v PRETYPED, PRETYPING, PRETYPES]\n",
  "PRETYPED": "PRETYPE, to type beforehand [v]\n",
  "PRETYPES": "PRETYPE, to type beforehand [v]\n",
  "PRETYPING": "PRETYPE, to type beforehand [v]\n",
  "PRETZEL": "(German) to twist, bend or contort [v PRETZELLED, PRETZELLING, PRETZELS]\n",
  "PRETZELLED": "PRETZEL, (German) to twist, bend or contort [v]\n",
  "PRETZELLING": "PRETZEL, (German) to twist, bend or contort [v]\n",
  "PRETZELS": "PRETZEL, (German) to twist, bend or contort [v]\n",
  "PREUNIFICATION": "preceding a unification [adj]\n",
  "PREUNION": "a union beforehand [n -S]\n",
  "PREUNIONS": "PREUNION, a union beforehand [n]\n",
  "PREUNITE": "to unite beforehand [v PREUNITED, PREUNITING, PREUNITES]\n",
  "PREUNITED": "PREUNITE, to unite beforehand [v]\n",
  "PREUNITES": "PREUNITE, to unite beforehand [v]\n",
  "PREUNITING": "PREUNITE, to unite beforehand [v]\n",
  "PREUNIVERSITY": "taking place before university [adj]\n",
  "PREVAIL": "to triumph [v -ED, -ING, -S]\n",
  "PREVAILED": "PREVAIL, to triumph [v]\n",
  "PREVAILER": "one who prevails [n -S]\n",
  "PREVAILERS": "PREVAILER, one who prevails [n]\n",
  "PREVAILING": "PREVAIL, to triumph [v]\n",
  "PREVAILINGLY": "PREVAILING, PREVAIL, to triumph [adv]\n",
  "PREVAILMENT": "(Shakespeare) the power of overcoming [n -S]\n",
  "PREVAILMENTS": "PREVAILMENT, (Shakespeare) the power of overcoming [n]\n",
  "PREVAILS": "PREVAIL, to triumph [v]\n",
  "PREVALENCE": "the state of being prevalent, also PREVALENCY [n -S]\n",
  "PREVALENCES": "PREVALENCE, the state of being prevalent, also PREVALENCY [n]\n",
  "PREVALENCIES": "PREVALENCY, the state of being prevalent, also PREVALENCE [n]\n",
  "PREVALENCY": "the state of being prevalent, also PREVALENCE [n PREVALENCIES]\n",
  "PREVALENT": "prevailing, widespread [adj PREVALENTLY] / something prevalent [n -S]\n",
  "PREVALENTLY": "PREVALENT, prevailing, widespread [adv]\n",
  "PREVALENTNESS": "PREVALENT, prevailing, widespread [n]\n",
  "PREVALENTNESSES": "PREVALENTNESS, PREVALENT, prevailing, widespread [n]\n",
  "PREVALENTS": "PREVALENT, something prevalent [n]\n",
  "PREVALUE": "to value beforehand [v PREVALUED, PREVALUING, PREVALUES]\n",
  "PREVALUED": "PREVALUE, to value beforehand [v]\n",
  "PREVALUES": "PREVALUE, to value beforehand [v]\n",
  "PREVALUING": "PREVALUE, to value beforehand [v]\n",
  "PREVARICATE": "to avoid telling the truth by being ambiguous, evading, or misleading [v PREVARICATED, PREVARICATING, PREVARICATES]\n",
  "PREVARICATED": "PREVARICATE, to avoid telling the truth by being ambiguous, evading, or misleading [v]\n",
  "PREVARICATES": "PREVARICATE, to avoid telling the truth by being ambiguous, evading, or misleading [v]\n",
  "PREVARICATING": "PREVARICATE, to avoid telling the truth by being ambiguous, evading, or misleading [v]\n",
  "PREVARICATION": "the act of prevaricating [n -S]\n",
  "PREVARICATIONS": "PREVARICATION, the act of prevaricating [n]\n",
  "PREVARICATOR": "one who prevaricates [n -S]\n",
  "PREVARICATORS": "PREVARICATOR, one who prevaricates [n]\n",
  "PREVE": "to prove, also PREEVE, PRIEVE [v PREVED, PREVING, PREVES]\n",
  "PREVED": "PREVE, to prove, also PREEVE, PRIEVE [v]\n",
  "PREVENANCIES": "PREVENANCY, courteous anticipation of others' wishes [n]\n",
  "PREVENANCY": "courteous anticipation of others' wishes [n PREVENANCIES]\n",
  "PREVENE": "to precede, anticipate [v PREVENED, PREVENING, PREVENES]\n",
  "PREVENED": "PREVENE, to precede, anticipate [v]\n",
  "PREVENES": "PREVENE, to precede, anticipate [v]\n",
  "PREVENIENCE": "the state of prevening [n -S]\n",
  "PREVENIENCES": "PREVENIENCE, the state of prevening [n]\n",
  "PREVENIENT": "antecedent, anticipatory [adj PREVENIENTLY]\n",
  "PREVENIENTLY": "PREVENIENT, antecedent, anticipatory [adv]\n",
  "PREVENING": "PREVENE, to precede, anticipate [v]\n",
  "PREVENT": "to keep from happening [v -ED, -ING, -S]\n",
  "PREVENTABILITY": "the state of being preventable [n]\n",
  "PREVENTABLE": "that can be prevented, also PREVENTIBLE [adj PREVENTABLY]\n",
  "PREVENTABLY": "PREVENTABLE, that can be prevented, also PREVENTIBLE [adv]\n",
  "PREVENTATIVE": "acting to prevent, also PREVENTIVE [adj] / something intended to prevent [n -S]\n",
  "PREVENTATIVES": "PREVENTATIVE, something intended to prevent [n]\n",
  "PREVENTED": "PREVENT, to keep from happening [v]\n",
  "PREVENTER": "one who prevents [n -S]\n",
  "PREVENTERS": "PREVENTER, one who prevents [n]\n",
  "PREVENTIBILITY": "the state of being preventible [n]\n",
  "PREVENTIBLE": "that can be prevented, also PREVENTABLE [adj PREVENTIBLY]\n",
  "PREVENTIBLY": "PREVENTIBLE, that can be prevented, also PREVENTABLE [adv]\n",
  "PREVENTING": "PREVENT, to keep from happening [v]\n",
  "PREVENTION": "the act of preventing [n -S]\n",
  "PREVENTIONS": "PREVENTION, the act of preventing [n]\n",
  "PREVENTIVE": "serving to prevent, also PREVENTATIVE [adj PREVENTIVELY] / something that prevents [n -S]\n",
  "PREVENTIVELY": "PREVENTIVE, serving to prevent, also PREVENTATIVE [adv]\n",
  "PREVENTIVENESS": "PREVENTIVE, serving to prevent, also PREVENTATIVE [n]\n",
  "PREVENTIVES": "PREVENTIVE, something that prevents [n]\n",
  "PREVENTS": "PREVENT, to keep from happening [v]\n",
  "PREVERB": "a particle or prefix which precedes a verb [n -S]\n",
  "PREVERBAL": "relating to the period of babyhood before the development of speech [adj]\n",
  "PREVERBS": "PREVERB, a particle or prefix which precedes a verb [n]\n",
  "PREVES": "PREVE, to prove, also PREEVE, PRIEVE [v]\n",
  "PREVIABLE": "before the stage when a foetus has developed sufficiently to survive outside the womb [adj]\n",
  "PREVIEW": "to view or exhibit in advance, also PREVUE [v -ED, -ING, -S]\n",
  "PREVIEWED": "PREVIEW, to view or exhibit in advance, also PREVUE [v]\n",
  "PREVIEWER": "one who previews [n -S]\n",
  "PREVIEWERS": "PREVIEWER, one who previews [n]\n",
  "PREVIEWING": "PREVIEW, to view or exhibit in advance, also PREVUE [v]\n",
  "PREVIEWS": "PREVIEW, to view or exhibit in advance, also PREVUE [v]\n",
  "PREVING": "PREVE, to prove, also PREEVE, PRIEVE [v]\n",
  "PREVIOUS": "coming or occurring before in time or order [adj PREVIOUSLY]\n",
  "PREVIOUSLY": "PREVIOUS, coming or occurring before in time or order [adv]\n",
  "PREVIOUSNESS": "the state of being previous [n -ES]\n",
  "PREVIOUSNESSES": "PREVIOUSNESS, the state of being previous [n]\n",
  "PREVISE": "to foresee [v PREVISED, PREVISING, PREVISES]\n",
  "PREVISED": "PREVISE, to foresee [v]\n",
  "PREVISES": "PREVISE, to foresee [v]\n",
  "PREVISING": "PREVISE, to foresee [v]\n",
  "PREVISION": "foresight [n -S] / to foresee [v -ED, -ING, -S]\n",
  "PREVISIONAL": "showing prevision, foresight [adj]\n",
  "PREVISIONARY": "relating to prevision, foresight [adj]\n",
  "PREVISIONED": "PREVISION, to foresee [v]\n",
  "PREVISIONING": "PREVISION, to foresee [v]\n",
  "PREVISIONS": "PREVISION, to foresee [v]\n",
  "PREVISIT": "to visit beforehand [v -ED, -ING, -S]\n",
  "PREVISITED": "PREVISIT, to visit beforehand [v]\n",
  "PREVISITING": "PREVISIT, to visit beforehand [v]\n",
  "PREVISITS": "PREVISIT, to visit beforehand [v]\n",
  "PREVISOR": "one that previses, forewarns [n -S]\n",
  "PREVISORS": "PREVISOR, one that previses, forewarns [n]\n",
  "PREVOCALIC": "before a vowel [adj PREVOCALICALLY]\n",
  "PREVOCALICALLY": "PREVOCALIC, before a vowel [adv]\n",
  "PREVOCATIONAL": "given or required before admission to a vocational school [adj]\n",
  "PREVUE": "(US) to preview, also PREVIEW [v PREVUED, PREVUING, PREVUES]\n",
  "PREVUED": "PREVUE, (US) to preview, also PREVIEW [v]\n",
  "PREVUES": "PREVUE, (US) to preview, also PREVIEW [v]\n",
  "PREVUING": "PREVUE, (US) to preview, also PREVIEW [v]\n",
  "PREWAR": "occurring before the war [adj]\n",
  "PREWARM": "to warm beforehand [v -ED, -ING, -S]\n",
  "PREWARMED": "PREWARM, to warm beforehand [v]\n",
  "PREWARMING": "PREWARM, to warm beforehand [v]\n",
  "PREWARMS": "PREWARM, to warm beforehand [v]\n",
  "PREWARN": "to warn in advance [v -ED, -ING, -S]\n",
  "PREWARNED": "PREWARN, to warn in advance [v]\n",
  "PREWARNING": "PREWARN, to warn in advance [v]\n",
  "PREWARNS": "PREWARN, to warn in advance [v]\n",
  "PREWASH": "to wash beforehand [v -ED, -ING, -ES]\n",
  "PREWASHED": "PREWASH, to wash beforehand [v]\n",
  "PREWASHES": "PREWASH, to wash beforehand [v]\n",
  "PREWASHING": "PREWASH, to wash beforehand [v]\n",
  "PREWEANED": "of e.g. calves, not yet weaned [adj]\n",
  "PREWEANING": "taking place before weaning [adj]\n",
  "PREWEIGH": "to weigh beforehand [v -ED, -ING, -S]\n",
  "PREWEIGHED": "PREWEIGH, to weigh beforehand [v]\n",
  "PREWEIGHING": "PREWEIGH, to weigh beforehand [v]\n",
  "PREWEIGHS": "PREWEIGH, to weigh beforehand [v]\n",
  "PREWIRE": "to wire beforehand [v PREWIRED, PREWIRING, PREWIRES]\n",
  "PREWIRED": "PREWIRE, to wire beforehand [v]\n",
  "PREWIRES": "PREWIRE, to wire beforehand [v]\n",
  "PREWIRING": "PREWIRE, to wire beforehand [v]\n",
  "PREWORK": "to work beforehand [v -ED, -ING, -S]\n",
  "PREWORKED": "PREWORK, to work beforehand [v]\n",
  "PREWORKING": "PREWORK, to work beforehand [v]\n",
  "PREWORKS": "PREWORK, to work beforehand [v]\n",
  "PREWORN": "of clothing, worn beforehand [adj]\n",
  "PREWRAP": "to wrap beforehand [v PREWRAPPED, PREWRAPPING, PREWRAPS]\n",
  "PREWRAPPED": "PREWRAP, to wrap beforehand [v]\n",
  "PREWRAPPING": "PREWRAP, to wrap beforehand [v]\n",
  "PREWRAPS": "PREWRAP, to wrap beforehand [v]\n",
  "PREWRITE": "to write beforehand [v PREWROTE, PREWRITTEN, PREWRITING, PREWRITES]\n",
  "PREWRITES": "PREWRITE, to write beforehand [v]\n",
  "PREWRITING": "a preliminary writing [n -S]\n",
  "PREWRITINGS": "PREWRITING, a preliminary writing [n]\n",
  "PREWRITTEN": "PREWRITE, to write beforehand [v]\n",
  "PREWROTE": "PREWRITE, to write beforehand [v]\n",
  "PREWYN": "(Shakespeare) a prune, also PRUINE [n -S]\n",
  "PREWYNS": "PREWYN, (Shakespeare) a prune, also PRUINE [n]\n",
  "PREX": "(US slang) the president of a college, also PREXIE, PREXY [n -ES]\n",
  "PREXES": "PREX, (US slang) the president of a college, also PREXIE, PREXY [n]\n",
  "PREXIE": "(colloquial) a president, also PREX, PREXY [n PREXIES]\n",
  "PREXIES": "PREXY, (US slang) the president of a college, also PREX, PREXIE [n]\n",
  "PREXY": "(US slang) the president of a college, also PREX, PREXIE [n PREXIES]\n",
  "PREY": "to exploit or terrorize victims [v -ED, -ING, -S]\n",
  "PREYED": "PREY, to exploit or terrorize victims [v]\n",
  "PREYER": "one who, or that which, preys [n -S]\n",
  "PREYERS": "PREYER, one who, or that which, preys [n]\n",
  "PREYFUL": "(Shakespeare) bent upon prey [adj]\n",
  "PREYING": "PREY, to exploit or terrorize victims [v]\n",
  "PREYS": "PREY, to exploit or terrorize victims [v]\n",
  "PREZ": "(short for) president [n -ES]\n",
  "PREZES": "PREZ, (short for) president [n]\n",
  "PREZZIE": "(colloquial) a present, also PRESSIE, PRESSY [n -S]\n",
  "PREZZIES": "PREZZIE, (colloquial) a present, also PRESSIE, PRESSY [n]\n",
  "PRIAL": "a pair-royal, a throw of three dice all the same, also PAIRIAL, PARIAL [n -S]\n",
  "PRIALS": "PRIAL, a pair-royal, a throw of three dice all the same, also PAIRIAL, PARIAL [n]\n",
  "PRIAPEAN": "phallic, also PRIAPIC [adj]\n",
  "PRIAPI": "PRIAPUS, (Greek) a representation of the phallus [n]\n",
  "PRIAPIC": "phallic, also PRIAPEAN [adj]\n",
  "PRIAPISM": "a persistent erection of the penis [n -S]\n",
  "PRIAPISMS": "PRIAPISM, a persistent erection of the penis [n]\n",
  "PRIAPUS": "(Greek) a representation of the phallus [n PRIAPUSES or PRIAPI]\n",
  "PRIAPUSES": "PRIAPUS, (Greek) a representation of the phallus [n]\n",
  "PRIBBLE": "a clamorous contest, a brawl, also BRABBLE, PRABBLE [n -S]\n",
  "PRIBBLES": "PRIBBLE, a clamorous contest, a brawl, also BRABBLE, PRABBLE [n]\n",
  "PRICE": "to set a value on [v PRICED, PRICING, PRICES]\n",
  "PRICEABLE": "that can be priced [adj]\n",
  "PRICED": "PRICE, to set a value on [v]\n",
  "PRICELESS": "beyond price [adj PRICELESSLY]\n",
  "PRICELESSLY": "PRICELESS, beyond price [adv]\n",
  "PRICELESSNESS": "PRICELESS, beyond price [n]\n",
  "PRICELESSNESSES": "PRICELESSNESS, PRICELESS, beyond price [n]\n",
  "PRICER": "one who sets a price [n -S]\n",
  "PRICERS": "PRICER, one who sets a price [n]\n",
  "PRICES": "PRICE, to set a value on [v]\n",
  "PRICEY": "expensive, also PRICY [adj PRICIER, PRICIEST, PRICILY]\n",
  "PRICIER": "PRICY, expensive, also PRICEY [adj]\n",
  "PRICIEST": "PRICY, expensive, also PRICEY [adj]\n",
  "PRICILY": "PRICY, expensive, also PRICEY [adv]\n",
  "PRICINESS": "the state of being pricy [n -ES]\n",
  "PRICINESSES": "PRICINESS, the state of being pricy [n]\n",
  "PRICING": "an act of pricing [n -S]\n",
  "PRICINGS": "PRICING, an act of pricing [n]\n",
  "PRICK": "to puncture slightly, also PRICKLE [v -ED, -ING, -S]\n",
  "PRICKED": "PRICK, to puncture slightly, also PRICKLE [v]\n",
  "PRICKER": "a light horseman employed as a skirmisher or scout [n -S]\n",
  "PRICKERS": "PRICKER, a light horseman employed as a skirmisher or scout [n]\n",
  "PRICKET": "a spike for holding a candle upright [n -S]\n",
  "PRICKETS": "PRICKET, a spike for holding a candle upright [n]\n",
  "PRICKIER": "PRICKY, having many sharp points, also PRICKLY [adj]\n",
  "PRICKIEST": "PRICKY, having many sharp points, also PRICKLY [adj]\n",
  "PRICKING": "a prickly feeling [n -S]\n",
  "PRICKINGS": "PRICKING, a prickly feeling [n]\n",
  "PRICKLE": "to puncture slightly, also PRICK [v PRICKLED, PRICKLING, PRICKLES]\n",
  "PRICKLED": "PRICKLE, to puncture slightly, also PRICK [v]\n",
  "PRICKLES": "PRICKLE, to puncture slightly, also PRICK [v]\n",
  "PRICKLIER": "PRICKLY, having many sharp points, also PRICKY [adj]\n",
  "PRICKLIEST": "PRICKLY, having many sharp points, also PRICKY [adj]\n",
  "PRICKLINESS": "the state of being prickly [n -ES]\n",
  "PRICKLINESSES": "PRICKLINESS, the state of being prickly [n]\n",
  "PRICKLING": "the act of prickling [n -S]\n",
  "PRICKLINGS": "PRICKLING, the act of prickling [n]\n",
  "PRICKLY": "having many sharp points, also PRICKY [adj PRICKLIER, PRICKLIEST]\n",
  "PRICKS": "PRICK, to puncture slightly, also PRICKLE [v]\n",
  "PRICKWOOD": "the spindle tree [n -S]\n",
  "PRICKWOODS": "PRICKWOOD, the spindle tree [n]\n",
  "PRICKY": "having many sharp points, also PRICKLY [adj PRICKIER, PRICKIEST]\n",
  "PRICY": "expensive, also PRICEY [adj PRICIER, PRICIEST, PRICILY]\n",
  "PRIDE": "to feel self-esteem [v PRIDED, PRIDING, PRIDES]\n",
  "PRIDED": "PRIDE, to feel self-esteem [v]\n",
  "PRIDEFUL": "full of pride [adj PRIDEFULLY]\n",
  "PRIDEFULLY": "PRIDEFUL, full of pride [adv]\n",
  "PRIDEFULNESS": "the state of being prideful [n -ES]\n",
  "PRIDEFULNESSES": "PRIDEFULNESS, the state of being prideful [n]\n",
  "PRIDELESS": "without pride [adj]\n",
  "PRIDES": "PRIDE, to feel self-esteem [v]\n",
  "PRIDIAN": "of or pertaining to the previous day [adj]\n",
  "PRIDING": "PRIDE, to feel self-esteem [v]\n",
  "PRIED": "PRY, to inquire impertinently into private matters [v]\n",
  "PRIEDIEU": "(French) a low desk with a book-space above and a foot-piece for kneeling in prayer [n PRIEDIEUS or PRIEDIEUX]\n",
  "PRIEDIEUS": "PRIEDIEU, (French) a low desk with a book-space above and a foot-piece for kneeling in prayer [n]\n",
  "PRIEDIEUX": "PRIEDIEU, (French) a low desk with a book-space above and a foot-piece for kneeling in prayer [n]\n",
  "PRIEF": "(Scots) proof, also PREIF, PREIFE, PRIEFE [n -S]\n",
  "PRIEFE": "(Scots) proof, also PREIF, PREIFE, PRIEF [n -S]\n",
  "PRIEFES": "PRIEFE, (Scots) proof, also PREIF, PREIFE, PRIEF [n]\n",
  "PRIEFS": "PRIEF, (Scots) proof, also PREIF, PREIFE, PRIEFE [n]\n",
  "PRIER": "one who pries, also PRYER [n -S]\n",
  "PRIERS": "PRIER, one who pries, also PRYER [n]\n",
  "PRIES": "PRY, to inquire impertinently into private matters [v]\n",
  "PRIEST": "to ordain as one authorized to perform religious rites [v -ED, -ING, -S]\n",
  "PRIESTCRAFT": "priestly policy directed to worldly ends [n -S]\n",
  "PRIESTCRAFTS": "PRIESTCRAFT, priestly policy directed to worldly ends [n]\n",
  "PRIESTED": "PRIEST, to ordain as one authorized to perform religious rites [v]\n",
  "PRIESTESS": "a female priest [n -ES]\n",
  "PRIESTESSES": "PRIESTESS, a female priest [n]\n",
  "PRIESTHOOD": "the office, dignity, or character of a priest [n -S]\n",
  "PRIESTHOODS": "PRIESTHOOD, the office, dignity, or character of a priest [n]\n",
  "PRIESTING": "PRIEST, to ordain as one authorized to perform religious rites [v]\n",
  "PRIESTLIER": "PRIESTLY, characteristic of a priest [adj]\n",
  "PRIESTLIEST": "PRIESTLY, characteristic of a priest [adj]\n",
  "PRIESTLIKE": "like a priest [adj]\n",
  "PRIESTLINESS": "the state of being priestly [n -ES]\n",
  "PRIESTLINESSES": "PRIESTLINESS, the state of being priestly [n]\n",
  "PRIESTLING": "a priest of low rank [n -S]\n",
  "PRIESTLINGS": "PRIESTLING, a priest of low rank [n]\n",
  "PRIESTLY": "characteristic of a priest [adj PRIESTLIER, PRIESTLIEST]\n",
  "PRIESTS": "PRIEST, to ordain as one authorized to perform religious rites [v]\n",
  "PRIESTSHIP": "the office of priest [n -S]\n",
  "PRIESTSHIPS": "PRIESTSHIP, the office of priest [n]\n",
  "PRIEVE": "to prove, also PREEVE, PREVE [v PRIEVED, PRIEVING, PRIEVES]\n",
  "PRIEVED": "PRIEVE, to prove, also PREEVE, PREVE [v]\n",
  "PRIEVES": "PRIEVE, to prove, also PREEVE, PREVE [v]\n",
  "PRIEVING": "PRIEVE, to prove, also PREEVE, PREVE [v]\n",
  "PRIG": "to filch [v PRIGGED, PRIGGING, PRIGS]\n",
  "PRIGGED": "PRIG, to filch [v]\n",
  "PRIGGER": "one who prigs, a thief [n -S]\n",
  "PRIGGERIES": "PRIGGERY, prim adherence to convention, also PRIGGISM [n]\n",
  "PRIGGERS": "PRIGGER, one who prigs, a thief [n]\n",
  "PRIGGERY": "prim adherence to convention, also PRIGGISM [n PRIGGERIES]\n",
  "PRIGGING": "thievery [n -S]\n",
  "PRIGGINGS": "PRIGGING, thievery [n]\n",
  "PRIGGISH": "marked by priggism [adj PRIGGISHLY]\n",
  "PRIGGISHLY": "PRIGGISH, marked by priggism [adv]\n",
  "PRIGGISHNESS": "the state of being priggish [n -ES]\n",
  "PRIGGISHNESSES": "PRIGGISHNESS, the state of being priggish [n]\n",
  "PRIGGISM": "prim adherence to convention, also PRIGGERY [n -S]\n",
  "PRIGGISMS": "PRIGGISM, prim adherence to convention, also PRIGGERY [n]\n",
  "PRIGS": "PRIG, to filch [v]\n",
  "PRILL": "to turn into pellet form e.g. by melting and letting the falling drops solidify [v -ED, -ING, -S]\n",
  "PRILLED": "PRILL, to turn into pellet form e.g. by melting and letting the falling drops solidify [v]\n",
  "PRILLING": "PRILL, to turn into pellet form e.g. by melting and letting the falling drops solidify [v]\n",
  "PRILLS": "PRILL, to turn into pellet form e.g. by melting and letting the falling drops solidify [v]\n",
  "PRIM": "rigidly proper [adj PRIMMER, PRIMMEST, PRIMLY] / to give a prim expression to [v PRIMMED, PRIMMING, PRIMS]\n",
  "PRIMA": "(Italian) the first or principal (female) part in a duo [n -S]\n",
  "PRIMACIES": "PRIMACY, the state of being first [n]\n",
  "PRIMACY": "the state of being first [n PRIMACIES]\n",
  "PRIMAEVAL": "belonging to the earth's beginnings, also PRIMEVAL [adj PRIMAEVALLY]\n",
  "PRIMAEVALLY": "PRIMAEVAL, belonging to the earth's beginnings, also PRIMEVAL [adv]\n",
  "PRIMAGE": "an amount paid as an addition to freight charges [n -S]\n",
  "PRIMAGES": "PRIMAGE, an amount paid as an addition to freight charges [n]\n",
  "PRIMAL": "being at the beginning or foundation [adj PRIMALLY]\n",
  "PRIMALITIES": "PRIMALITY, the state of being primal [n]\n",
  "PRIMALITY": "the state of being primal [n PRIMALITIES]\n",
  "PRIMALLY": "PRIMAL, being at the beginning or foundation [adv]\n",
  "PRIMAQUINE": "an antimalarial drug [n -S]\n",
  "PRIMAQUINES": "PRIMAQUINE, an antimalarial drug [n]\n",
  "PRIMARIES": "PRIMARY, a preliminary election [n]\n",
  "PRIMARILY": "PRIMARY, taking first place [adv]\n",
  "PRIMARINESS": "the state of being primary [n -ES]\n",
  "PRIMARINESSES": "PRIMARINESS, the state of being primary [n]\n",
  "PRIMARY": "taking first place [adj PRIMARILY] / a preliminary election [n PRIMARIES]\n",
  "PRIMAS": "PRIMA, (Italian) the first or principal (female) part in a duo [n]\n",
  "PRIMATAL": "any of an advanced order of mammals, also PRIMATE [n -S]\n",
  "PRIMATALS": "PRIMATAL, any of an advanced order of mammals, also PRIMATE [n]\n",
  "PRIMATE": "any of an advanced order of mammals, also PRIMATAL [n -S]\n",
  "PRIMATES": "PRIMATE, any of an advanced order of mammals, also PRIMATAL [n]\n",
  "PRIMATESHIP": "the office of primate [n -S]\n",
  "PRIMATESHIPS": "PRIMATESHIP, the office of primate [n]\n",
  "PRIMATIAL": "of or pertaining to ecclesiastical primacy, also PRIMATIC, PRIMATICAL [adj] / a primate [n -S]\n",
  "PRIMATIALS": "PRIMATIAL, a primate [n]\n",
  "PRIMATIC": "of or pertaining to ecclesiastical primacy, also PRIMATIAL, PRIMATICAL [adj]\n",
  "PRIMATICAL": "of or pertaining to ecclesiastical primacy, also PRIMATIAL, PRIMATIC [adj]\n",
  "PRIMATOLOGICAL": "relating to primatology, the study of primates [adj]\n",
  "PRIMATOLOGIES": "PRIMATOLOGY, the study of primates [n]\n",
  "PRIMATOLOGIST": "one who studies primates [n -S]\n",
  "PRIMATOLOGISTS": "PRIMATOLOGIST, one who studies primates [n]\n",
  "PRIMATOLOGY": "the study of primates [n PRIMATOLOGIES]\n",
  "PRIMAVERA": "(Italian) a kind of mahogany tree [n -S]\n",
  "PRIMAVERAS": "PRIMAVERA, (Italian) a kind of mahogany tree [n]\n",
  "PRIME": "in best condition [adj PRIMELY] / to make ready [v PRIMED, PRIMING, PRIMES]\n",
  "PRIMED": "PRIME, to make ready [v]\n",
  "PRIMELY": "PRIME, in best condition [adv]\n",
  "PRIMENESS": "the state of being first [n -ES]\n",
  "PRIMENESSES": "PRIMENESS, the state of being first [n]\n",
  "PRIMER": "a book that covers the basics of a subject, also PRIMMER [n -S]\n",
  "PRIMERO": "(Spanish) an old card game [n -S]\n",
  "PRIMEROS": "PRIMERO, (Spanish) an old card game [n]\n",
  "PRIMERS": "PRIMER, a book that covers the basics of a subject, also PRIMMER [n]\n",
  "PRIMES": "PRIME, to make ready [v]\n",
  "PRIMETIME": "occurring during or designed for prime time [adj]\n",
  "PRIMEUR": "(French) a new or early thing; specifically in plural, fruit or vegetables grown to be available very early in the season [n -S]\n",
  "PRIMEURS": "PRIMEUR, (French) a new or early thing; specifically in plural, fruit or vegetables grown to be available very early in the season [n]\n",
  "PRIMEVAL": "belonging to the earth's beginnings, also PRIMAEVAL [adj PRIMEVALLY]\n",
  "PRIMEVALLY": "PRIMEVAL, belonging to the earth's beginnings, also PRIMAEVAL [adv]\n",
  "PRIMI": "PRIMO, (Italian) the first or principal (male) part in a duo [n]\n",
  "PRIMIGENIAL": "first or earliest formed or produced [adj]\n",
  "PRIMIGRAVIDA": "(Lat.) a woman pregnant for the first time [n PRIMIGRAVIDAS or PRIMIGRAVIDAE]\n",
  "PRIMIGRAVIDAE": "PRIMIGRAVIDA, (Lat.) a woman pregnant for the first time [n]\n",
  "PRIMIGRAVIDAS": "PRIMIGRAVIDA, (Lat.) a woman pregnant for the first time [n]\n",
  "PRIMINE": "the outer covering of an ovule [n -S]\n",
  "PRIMINES": "PRIMINE, the outer covering of an ovule [n]\n",
  "PRIMING": "the act of one who primes [n -S]\n",
  "PRIMINGS": "PRIMING, the act of one who primes [n]\n",
  "PRIMIPARA": "(Latin) a woman who bears a child for the first time [n PRIMIPARAE or PRIMIPARAS]\n",
  "PRIMIPARAE": "PRIMIPARA, (Latin) a woman who bears a child for the first time [n]\n",
  "PRIMIPARAS": "PRIMIPARA, (Latin) a woman who bears a child for the first time [n]\n",
  "PRIMIPARITIES": "PRIMIPARITY, the bearing of one's first child [n]\n",
  "PRIMIPARITY": "the bearing of one's first child [n PRIMIPARITIES]\n",
  "PRIMIPAROUS": "having borne only one child [adj]\n",
  "PRIMITIAE": "(Latin) the first year's revenue of a benefice, also PRIMITIAS [n]\n",
  "PRIMITIAL": "of or relating to primitiae, the first year's revenue of a benefice [adj]\n",
  "PRIMITIAS": "(Spenser) the first year's revenue of a benefice, also PRIMITIAE [n]\n",
  "PRIMITIVE": "belonging to earliest times or the earlier stages of development [adj PRIMITIVELY] / an uncivilised person [n -S]\n",
  "PRIMITIVELY": "PRIMITIVE, belonging to earliest times or the earlier stages of development [adv]\n",
  "PRIMITIVENESS": "the state of being primitive [n -ES]\n",
  "PRIMITIVENESSES": "PRIMITIVENESS, the state of being primitive [n]\n",
  "PRIMITIVES": "PRIMITIVE, an uncivilised person [n]\n",
  "PRIMITIVISM": "the doctrine that a simple and natural life is morally best [n -S]\n",
  "PRIMITIVISMS": "PRIMITIVISM, the doctrine that a simple and natural life is morally best [n]\n",
  "PRIMITIVIST": "one who practises primitivism, the doctrine that a simple and natural life is morally best [n -S]\n",
  "PRIMITIVISTIC": "relating to primitivism [adj]\n",
  "PRIMITIVISTS": "PRIMITIVIST, one who practises primitivism, the doctrine that a simple and natural life is morally best [n]\n",
  "PRIMITIVITIES": "PRIMITIVITY, the state of being primitive [n]\n",
  "PRIMITIVITY": "the state of being primitive [n PRIMITIVITIES]\n",
  "PRIMLY": "PRIM, rigidly proper [adv]\n",
  "PRIMMED": "PRIM, to give a prim expression to [v]\n",
  "PRIMMER": "a book that covers the basics of a subject, also PRIMER [n -S]\n",
  "PRIMMERS": "PRIMMER, a book that covers the basics of a subject, also PRIMER [n]\n",
  "PRIMMEST": "PRIM, rigidly proper [adj]\n",
  "PRIMMING": "PRIM, to give a prim expression to [v]\n",
  "PRIMNESS": "the state of being prim [n -ES]\n",
  "PRIMNESSES": "PRIMNESS, the state of being prim [n]\n",
  "PRIMO": "(Italian) the first or principal (male) part in a duo [n PRIMI or PRIMOS]\n",
  "PRIMOGENIAL": "first to be formed; original [adj]\n",
  "PRIMOGENIT": "(obsolete) a firstborn [n -S]\n",
  "PRIMOGENITAL": "firstborn, also PRIMOGENITARY [adj]\n",
  "PRIMOGENITARY": "firstborn, also PRIMOGENITAL [adj]\n",
  "PRIMOGENITIVE": "(Shakespeare) primogeniture, also PRIMOGENITURE [n -S]\n",
  "PRIMOGENITIVES": "PRIMOGENITIVE, (Shakespeare) primogeniture, also PRIMOGENITURE [n]\n",
  "PRIMOGENITOR": "the earliest ancestor; an ancestor or a forefather [n PRIMOGENITORS]\n",
  "PRIMOGENITORS": "PRIMOGENITOR, the earliest ancestor; an ancestor or a forefather [n]\n",
  "PRIMOGENITRICES": "PRIMOGENITRIX, a female ancestor [n]\n",
  "PRIMOGENITRIX": "a female ancestor [n PRIMOGENITRICES or PRIMOGENITRIXES]\n",
  "PRIMOGENITRIXES": "PRIMOGENITRIX, a female ancestor [n]\n",
  "PRIMOGENITS": "PRIMOGENIT, (obsolete) a firstborn [n]\n",
  "PRIMOGENITURE": "an exclusive right of inheritance belonging to the eldest son, also PRIMOGENITIVE [n -S]\n",
  "PRIMOGENITURES": "PRIMOGENITURE, an exclusive right of inheritance belonging to the eldest son, also PRIMOGENITIVE [n]\n",
  "PRIMORDIA": "PRIMORDIUM, (Latin) the first discernible rudiment [n]\n",
  "PRIMORDIAL": "original, rudimentary [adj PRIMORDIALLY] / something primordial [n -S]\n",
  "PRIMORDIALISM": "belief in first principles or elements [n -S]\n",
  "PRIMORDIALISMS": "PRIMORDIALISM, belief in first principles or elements [n]\n",
  "PRIMORDIALITIES": "PRIMORDIALITY, the state of being primordial [n]\n",
  "PRIMORDIALITY": "the state of being primordial [n PRIMORDIALITIES]\n",
  "PRIMORDIALLY": "PRIMORDIAL, original, rudimentary [adv]\n",
  "PRIMORDIALS": "PRIMORDIAL, something primordial [n]\n",
  "PRIMORDIUM": "(Latin) the first discernible rudiment [n PRIMORDIA]\n",
  "PRIMOS": "PRIMO, (Italian) the first or principal (male) part in a duo [n]\n",
  "PRIMP": "to dress or adorn carefully [v -ED, -ING, -S]\n",
  "PRIMPED": "PRIMP, to dress or adorn carefully [v]\n",
  "PRIMPING": "PRIMP, to dress or adorn carefully [v]\n",
  "PRIMPS": "PRIMP, to dress or adorn carefully [v]\n",
  "PRIMROSE": "a yellow flower [n -S] / to gather primroses [v PRIMROSED, PRIMROSING, PRIMROSES]\n",
  "PRIMROSED": "PRIMROSE, to gather primroses [v]\n",
  "PRIMROSES": "PRIMROSE, to gather primroses [v]\n",
  "PRIMROSIER": "PRIMROSY, full of primroses [adj]\n",
  "PRIMROSIEST": "PRIMROSY, full of primroses [adj]\n",
  "PRIMROSING": "PRIMROSE, to gather primroses [v]\n",
  "PRIMROSY": "full of primroses [adj PRIMROSIER, PRIMROSIEST]\n",
  "PRIMS": "PRIM, to give a prim expression to [v]\n",
  "PRIMSIE": "(Scots) prim, demure [adj PRIMSIER, PRIMSIEST]\n",
  "PRIMSIER": "PRIMSIE, (Scots) prim, demure [adj]\n",
  "PRIMSIEST": "PRIMSIE, (Scots) prim, demure [adj]\n",
  "PRIMULA": "any of numerous usually low perennial plants constituting the genus Primula [n -S]\n",
  "PRIMULACEOUS": "belonging to the Primula family [adj]\n",
  "PRIMULAS": "PRIMULA, any of numerous usually low perennial plants constituting the genus Primula [n]\n",
  "PRIMULINE": "a yellow coal-tar dye [n -S]\n",
  "PRIMULINES": "PRIMULINE, a yellow coal-tar dye [n]\n",
  "PRIMUS": "(Latin) the head bishop of Scotland [n -ES]\n",
  "PRIMUSES": "PRIMUS, (Latin) the head bishop of Scotland [n]\n",
  "PRIMY": "(Shakespeare) in one's prime, blooming [adj]\n",
  "PRINCE": "to play the prince [v PRINCED, PRINCING, PRINCES]\n",
  "PRINCED": "PRINCE, to play the prince [v]\n",
  "PRINCEDOM": "the realm or authority of a prince [n -S]\n",
  "PRINCEDOMS": "PRINCEDOM, the realm or authority of a prince [n]\n",
  "PRINCEHOOD": "princeliness [n -S]\n",
  "PRINCEHOODS": "PRINCEHOOD, princeliness [n]\n",
  "PRINCEKIN": "a petty prince, also PRINCELET, PRINCELING [n -S]\n",
  "PRINCEKINS": "PRINCEKIN, a petty prince, also PRINCELET, PRINCELING [n]\n",
  "PRINCELET": "a petty prince, also PRINCEKIN, PRINCELING [n -S]\n",
  "PRINCELETS": "PRINCELET, a petty prince, also PRINCEKIN, PRINCELING [n]\n",
  "PRINCELIER": "PRINCELY, befitting a prince [adj]\n",
  "PRINCELIEST": "PRINCELY, befitting a prince [adj]\n",
  "PRINCELIKE": "princely [adj]\n",
  "PRINCELINESS": "the state of being princely [n -ES]\n",
  "PRINCELINESSES": "PRINCELINESS, the state of being princely [n]\n",
  "PRINCELING": "a petty prince; a young prince, also PRINCEKIN, PRINCELET [n -S]\n",
  "PRINCELINGS": "PRINCELING, a petty prince; a young prince, also PRINCEKIN, PRINCELET [n]\n",
  "PRINCELY": "befitting a prince [adj PRINCELIER, PRINCELIEST]\n",
  "PRINCES": "PRINCE, to play the prince [v]\n",
  "PRINCESHIP": "the office of prince [n -S]\n",
  "PRINCESHIPS": "PRINCESHIP, the office of prince [n]\n",
  "PRINCESS": "a non-reigning female member of a royal family [n -ES]\n",
  "PRINCESSE": "a lady's long, close-fitting dress made with waist and skirt in one [n -S]\n",
  "PRINCESSES": "PRINCESS, a non-reigning female member of a royal family [n]\n",
  "PRINCESSLIER": "PRINCESSLY, like a princess [adj]\n",
  "PRINCESSLIEST": "PRINCESSLY, like a princess [adj]\n",
  "PRINCESSLY": "like a princess [adj PRINCESSLIER, PRINCESSLIEST]\n",
  "PRINCIFIED": "imitative of a prince [adj]\n",
  "PRINCING": "PRINCE, to play the prince [v]\n",
  "PRINCIPAL": "chief [adj PRINCIPALLY] / the head of a college or university [n -S]\n",
  "PRINCIPALITIES": "PRINCIPALITY, the state, office, or authority of a prince [n]\n",
  "PRINCIPALITY": "the state, office, or authority of a prince [n PRINCIPALITIES]\n",
  "PRINCIPALLY": "PRINCIPAL, chief [adv]\n",
  "PRINCIPALNESS": "the state of being principal [n -ES]\n",
  "PRINCIPALNESSES": "PRINCIPALNESS, the state of being principal [n]\n",
  "PRINCIPALS": "PRINCIPAL, the head of a college or university [n]\n",
  "PRINCIPALSHIP": "the office of principal [n -S]\n",
  "PRINCIPALSHIPS": "PRINCIPALSHIP, the office of principal [n]\n",
  "PRINCIPATE": "principality; supreme rule [n -S]\n",
  "PRINCIPATES": "PRINCIPATE, principality; supreme rule [n]\n",
  "PRINCIPE": "(Italian) a prince [n PRINCIPI]\n",
  "PRINCIPI": "PRINCIPE, (Italian) a prince [n]\n",
  "PRINCIPIA": "PRINCIPIUM, (Latin) a first principle; element; as Newton's Principia [n]\n",
  "PRINCIPIAL": "elementary [adj]\n",
  "PRINCIPIUM": "(Latin) a first principle; element; as Newton's Principia [n PRINCIPIA]\n",
  "PRINCIPLE": "a guiding rule [n -S] / to ground (a person) in the principles or elements of a subject [v PRINCIPLED, PRINCIPLING, PRINCIPLES]\n",
  "PRINCIPLED": "PRINCIPLE, to ground (a person) in the principles or elements of a subject [v]\n",
  "PRINCIPLES": "PRINCIPLE, to ground (a person) in the principles or elements of a subject [v]\n",
  "PRINCIPLING": "PRINCIPLE, to ground (a person) in the principles or elements of a subject [v]\n",
  "PRINCOCK": "(Shakespeare) an arrogant effeminate fellow; a coxcomb, also PRINCOX [n -S]\n",
  "PRINCOCKS": "PRINCOCK, (Shakespeare) an arrogant effeminate fellow; a coxcomb, also PRINCOX [n]\n",
  "PRINCOX": "a conceited dandy, also COXCOMB, PRINCOCK [n -ES]\n",
  "PRINCOXES": "PRINCOX, a conceited dandy, also COXCOMB, PRINCOCK [n]\n",
  "PRINK": "to dress or adorn in a showy manner [v -ED, -ING, -S]\n",
  "PRINKED": "PRINK, to dress or adorn in a showy manner [v]\n",
  "PRINKER": "one who prinks [n -S]\n",
  "PRINKERS": "PRINKER, one who prinks [n]\n",
  "PRINKING": "PRINK, to dress or adorn in a showy manner [v]\n",
  "PRINKS": "PRINK, to dress or adorn in a showy manner [v]\n",
  "PRINT": "to produce by pressed type on a surface [v -ED, -ING, -S]\n",
  "PRINTABILITIES": "PRINTABILITY, the state of being printable [n]\n",
  "PRINTABILITY": "the state of being printable [n PRINTABILITIES]\n",
  "PRINTABLE": "that can be printed [adj]\n",
  "PRINTABLENESS": "PRINTABLE, that can be printed [n]\n",
  "PRINTABLENESSES": "PRINTABLENESS, PRINTABLE, that can be printed [n]\n",
  "PRINTED": "PRINT, to produce by pressed type on a surface [v]\n",
  "PRINTER": "one that prints [n -S]\n",
  "PRINTERIES": "PRINTERY, a place where printing is done [n]\n",
  "PRINTERS": "PRINTER, one that prints [n]\n",
  "PRINTERY": "a place where printing is done [n PRINTERIES]\n",
  "PRINTHEAD": "the part of a printer that does the work of printing [n -S]\n",
  "PRINTHEADS": "PRINTHEAD, the part of a printer that does the work of printing [n]\n",
  "PRINTING": "the art of the printer [n -S]\n",
  "PRINTINGS": "PRINTING, the art of the printer [n]\n",
  "PRINTLESS": "making no imprint [adj]\n",
  "PRINTMAKER": "an artist who makes prints [n -S]\n",
  "PRINTMAKERS": "PRINTMAKER, an artist who makes prints [n]\n",
  "PRINTMAKING": "the act of making prints [n -S]\n",
  "PRINTMAKINGS": "PRINTMAKING, the act of making prints [n]\n",
  "PRINTOUT": "the printed output of a computer [n -S]\n",
  "PRINTOUTS": "PRINTOUT, the printed output of a computer [n]\n",
  "PRINTS": "PRINT, to produce by pressed type on a surface [v]\n",
  "PRINTWHEEL": "another name for daisywheel, a kind of printer [n -S]\n",
  "PRINTWHEELS": "PRINTWHEEL, another name for daisywheel, a kind of printer [n]\n",
  "PRINTWORKS": "a place where printing is carried out [n]\n",
  "PRION": "any petrel of a genus feeding on the plankton of the southern oceans [n -S]\n",
  "PRIONS": "PRION, any petrel of a genus feeding on the plankton of the southern oceans [n]\n",
  "PRIOR": "previous [adj PRIORLY] / one in charge of a priory, ranking second to abbot [n -S]\n",
  "PRIORATE": "the state or office of a prior, also PRIORSHIP [n -S]\n",
  "PRIORATES": "PRIORATE, the state or office of a prior, also PRIORSHIP [n]\n",
  "PRIORESS": "a female superior of a house of any of various orders of nuns [n -ES]\n",
  "PRIORESSES": "PRIORESS, a female superior of a house of any of various orders of nuns [n]\n",
  "PRIORIES": "PRIORY, a religious house [n]\n",
  "PRIORITIES": "PRIORITY, precedence established by importance [n]\n",
  "PRIORITISATION": "the act of prioritising, also PRIORITIZATION [n -S]\n",
  "PRIORITISATIONS": "PRIORITISATION, the act of prioritising, also PRIORITIZATION [n]\n",
  "PRIORITISE": "to assign a priority to, also PRIORITIZE [v PRIORITISED, PRIORITISING, PRIORITISES]\n",
  "PRIORITISED": "PRIORITISE, to assign a priority to, also PRIORITIZE [v]\n",
  "PRIORITISES": "PRIORITISE, to assign a priority to, also PRIORITIZE [v]\n",
  "PRIORITISING": "PRIORITISE, to assign a priority to, also PRIORITIZE [v]\n",
  "PRIORITIZATION": "the act of prioritizing, also PRIORITISATION [n -S]\n",
  "PRIORITIZATIONS": "PRIORITIZATION, the act of prioritizing, also PRIORITISATION [n]\n",
  "PRIORITIZE": "to assign a priority to, also PRIORITISE [v PRIORITIZED, PRIORITIZING, PRIORITIZES]\n",
  "PRIORITIZED": "PRIORITIZE, to assign a priority to, also PRIORITISE [v]\n",
  "PRIORITIZES": "PRIORITIZE, to assign a priority to, also PRIORITISE [v]\n",
  "PRIORITIZING": "PRIORITIZE, to assign a priority to, also PRIORITISE [v]\n",
  "PRIORITY": "precedence established by importance [n PRIORITIES]\n",
  "PRIORLY": "PRIOR, previous [adv]\n",
  "PRIORS": "PRIOR, one in charge of a priory, ranking second to abbot [n]\n",
  "PRIORSHIP": "the state or office of prior, also PRIORATE [n -S]\n",
  "PRIORSHIPS": "PRIORSHIP, the state or office of prior, also PRIORATE [n]\n",
  "PRIORY": "a religious house [n PRIORIES]\n",
  "PRISAGE": "the former right of English kings to wine [n -S]\n",
  "PRISAGES": "PRISAGE, the former right of English kings to wine [n]\n",
  "PRISE": "to raise or force with a lever [v PRISED, PRISING, PRISES]\n",
  "PRISED": "PRISE, to raise or force with a lever [v]\n",
  "PRISER": "a contestant for a prize, also PRIZER [n -S]\n",
  "PRISERE": "the succession of vegetation that occurs in a previously unoccupied area as it passes from barren earth or water to a climax community [n -S]\n",
  "PRISERES": "PRISERE, the succession of vegetation that occurs in a previously unoccupied area as it passes from barren earth or water to a climax community [n]\n",
  "PRISERS": "PRISER, a contestant for a prize, also PRIZER [n]\n",
  "PRISES": "PRISE, to raise or force with a lever [v]\n",
  "PRISING": "PRISE, to raise or force with a lever [v]\n",
  "PRISM": "(Greek) a solid figure of which the two ends are similar, equal, and parallel rectilineal figures, and the sides parallelograms [n -S]\n",
  "PRISMATIC": "of, resembling or produced by prisms, also PRISMATICAL [adj PRISMATICALLY]\n",
  "PRISMATICAL": "of, resembling or produced by prisms, also PRISMATIC [adj PRISMATICALLY]\n",
  "PRISMATICALLY": "PRISMATICAL, of, resembling or produced by prisms, also PRISMATIC [adv]\n",
  "PRISMATOID": "a body that approaches to the form of a prism [n -S]\n",
  "PRISMATOIDAL": "having the form of a prismatoid [adj]\n",
  "PRISMATOIDS": "PRISMATOID, a body that approaches to the form of a prism [n]\n",
  "PRISMOID": "a body that approaches to the form of a prism [n -S]\n",
  "PRISMOIDAL": "having the form of a prismoid [adj]\n",
  "PRISMOIDS": "PRISMOID, a body that approaches to the form of a prism [n]\n",
  "PRISMS": "PRISM, (Greek) a solid figure of which the two ends are similar, equal, and parallel rectilineal figures, and the sides parallelograms [n]\n",
  "PRISMY": "having colours as from a prism [adj]\n",
  "PRISON": "a place for holding people convicted or awaiting trial [n -S] / to imprison [v -ED, -ING, -S]\n",
  "PRISONED": "PRISON, to imprison [v]\n",
  "PRISONER": "one that is imprisoned [n -S]\n",
  "PRISONERS": "PRISONER, one that is imprisoned [n]\n",
  "PRISONING": "PRISON, to imprison [v]\n",
  "PRISONMENT": "(Shakespeare) imprisonment [n -S]\n",
  "PRISONMENTS": "PRISONMENT, (Shakespeare) imprisonment [n]\n",
  "PRISONOUS": "(Dickens) of or like a prison [adj]\n",
  "PRISONS": "PRISON, to imprison [v]\n",
  "PRISS": "to act in a prissy manner [v -ED, -ING, -ES]\n",
  "PRISSED": "PRISS, to act in a prissy manner [v]\n",
  "PRISSES": "PRISS, to act in a prissy manner [v]\n",
  "PRISSIER": "PRISSY, affectedly proper [adj]\n",
  "PRISSIES": "PRISSY, one who is affectedly proper [n]\n",
  "PRISSIEST": "PRISSY, affectedly proper [adj]\n",
  "PRISSILY": "PRISSY, affectedly proper [adv]\n",
  "PRISSINESS": "the state of being prissy [n -ES]\n",
  "PRISSINESSES": "PRISSINESS, the state of being prissy [n]\n",
  "PRISSING": "PRISS, to act in a prissy manner [v]\n",
  "PRISSY": "affectedly proper [adj PRISSIER, PRISSIEST, PRISSILY] / one who is affectedly proper [n PRISSIES]\n",
  "PRISTANE": "a saturated hydrocarbon oil found in the livers of some marine creatures [n -S]\n",
  "PRISTANES": "PRISTANE, a saturated hydrocarbon oil found in the livers of some marine creatures [n]\n",
  "PRISTINE": "original, pure, unspoilt [adj PRISTINELY]\n",
  "PRISTINELY": "PRISTINE, original, pure, unspoilt [adv]\n",
  "PRITHEE": "(archaic) an expression of wish or request, also PRYTHEE [interj]\n",
  "PRIVACIES": "PRIVACY, the state of being private [n]\n",
  "PRIVACY": "the state of being private [n PRIVACIES]\n",
  "PRIVADO": "(obsolete) a private friend; a confidant [n PRIVADOES or PRIVADOS]\n",
  "PRIVADOES": "PRIVADO, (obsolete) a private friend; a confidant [n]\n",
  "PRIVADOS": "PRIVADO, (obsolete) a private friend; a confidant [n]\n",
  "PRIVATDOCENT": "(German) in German universities, a recognized teacher who is not a member of the salaried staff, also PRIVATDOZENT [n -S]\n",
  "PRIVATDOCENTS": "PRIVATDOCENT, (German) in German universities, a recognized teacher who is not a member of the salaried staff, also PRIVATDOZENT [n]\n",
  "PRIVATDOZENT": "(German) in German universities, a recognized teacher who is not a member of the salaried staff, also PRIVATDOCENT [n -S]\n",
  "PRIVATDOZENTS": "PRIVATDOZENT, (German) in German universities, a recognized teacher who is not a member of the salaried staff, also PRIVATDOCENT [n]\n",
  "PRIVATE": "secluded from the sight, presence or intrusion of others [adj PRIVATER, PRIVATEST, PRIVATELY] / a soldier of lower rank [n -S]\n",
  "PRIVATEER": "a licensed pirate [n -S] / to operate as a pirate [v -ED, -ING, -S]\n",
  "PRIVATEERED": "PRIVATEER, to operate as a pirate [v]\n",
  "PRIVATEERING": "operating as a pirate under licence [n -S]\n",
  "PRIVATEERINGS": "PRIVATEERING, operating as a pirate under licence [n]\n",
  "PRIVATEERS": "PRIVATEER, to operate as a pirate [v]\n",
  "PRIVATEERSMAN": "a crew member on a privateer [n PRIVATEERSMEN]\n",
  "PRIVATEERSMEN": "PRIVATEERSMAN, a crew member on a privateer [n]\n",
  "PRIVATELY": "PRIVATE, secluded from the sight, presence or intrusion of others [adv]\n",
  "PRIVATENESS": "the state of being private [n -ES]\n",
  "PRIVATENESSES": "PRIVATENESS, the state of being private [n]\n",
  "PRIVATER": "PRIVATE, secluded from the sight, presence or intrusion of others [adj]\n",
  "PRIVATES": "PRIVATE, a soldier of lower rank [n]\n",
  "PRIVATEST": "PRIVATE, secluded from the sight, presence or intrusion of others [adj]\n",
  "PRIVATION": "the act of depriving, or taking away [n -S]\n",
  "PRIVATIONS": "PRIVATION, the act of depriving, or taking away [n]\n",
  "PRIVATISATION": "the act of privatising, also PRIVATIZATION [n -S]\n",
  "PRIVATISATIONS": "PRIVATISATION, the act of privatising, also PRIVATIZATION [n]\n",
  "PRIVATISE": "to transfer from ownership by the state into private ownership; to denationalize, also PRIVATIZE [v PRIVATISED, PRIVATISING, PRIVATISES]\n",
  "PRIVATISED": "PRIVATISE, to transfer from ownership by the state into private ownership; to denationalize, also PRIVATIZE [v]\n",
  "PRIVATISER": "one who transfers to private ownership, denationalises, also PRIVATIZER [n -S]\n",
  "PRIVATISERS": "PRIVATISER, one who transfers to private ownership, denationalises, also PRIVATIZER [n]\n",
  "PRIVATISES": "PRIVATISE, to transfer from ownership by the state into private ownership; to denationalize, also PRIVATIZE [v]\n",
  "PRIVATISING": "PRIVATISE, to transfer from ownership by the state into private ownership; to denationalize, also PRIVATIZE [v]\n",
  "PRIVATISM": "a tendency to be concerned with ideas, matters, etc. only as affecting one as an individual [n -S]\n",
  "PRIVATISMS": "PRIVATISM, a tendency to be concerned with ideas, matters, etc. only as affecting one as an individual [n]\n",
  "PRIVATIST": "one who believes in privatism [n -S]\n",
  "PRIVATISTS": "PRIVATIST, one who believes in privatism [n]\n",
  "PRIVATIVE": "indicating absence, deprivation or negation [adj PRIVATIVELY] / a privative attribute, quality, proposition, or particle [n -S]\n",
  "PRIVATIVELY": "PRIVATIVE, indicating absence, deprivation or negation [adv]\n",
  "PRIVATIVES": "PRIVATIVE, a privative attribute, quality, proposition, or particle [n]\n",
  "PRIVATIZATION": "the act of privatizing, also PRIVATISATION [n -S]\n",
  "PRIVATIZATIONS": "PRIVATIZATION, the act of privatizing, also PRIVATISATION [n]\n",
  "PRIVATIZE": "to transfer from ownership by the state into private ownership; to denationalize, also PRIVATISE [v PRIVATIZED, PRIVATIZING, PRIVATIZES]\n",
  "PRIVATIZED": "PRIVATIZE, to transfer from ownership by the state into private ownership; to denationalize, also PRIVATISE [v]\n",
  "PRIVATIZER": "one who transfers to private ownership, denationalises, also PRIVATISER [n -S]\n",
  "PRIVATIZERS": "PRIVATIZER, one who transfers to private ownership, denationalises, also PRIVATISER [n]\n",
  "PRIVATIZES": "PRIVATIZE, to transfer from ownership by the state into private ownership; to denationalize, also PRIVATISE [v]\n",
  "PRIVATIZING": "PRIVATIZE, to transfer from ownership by the state into private ownership; to denationalize, also PRIVATISE [v]\n",
  "PRIVET": "a half-evergreen European shrub of the olive family [n -S]\n",
  "PRIVETS": "PRIVET, a half-evergreen European shrub of the olive family [n]\n",
  "PRIVIER": "PRIVY, private [adj]\n",
  "PRIVIES": "PRIVY, an outhouse [n]\n",
  "PRIVIEST": "PRIVY, private [adj]\n",
  "PRIVILEGE": "an advantage, right or favour granted to or enjoyed by an individual or group [n -S] / to grant a privilege to [v PRIVILEGED, PRIVILEGING, PRIVILEGES]\n",
  "PRIVILEGED": "PRIVILEGE, to grant a privilege to [v]\n",
  "PRIVILEGES": "PRIVILEGE, to grant a privilege to [v]\n",
  "PRIVILEGING": "PRIVILEGE, to grant a privilege to [v]\n",
  "PRIVILY": "PRIVY, private [adv]\n",
  "PRIVITIES": "PRIVITY, private knowledge [n]\n",
  "PRIVITY": "private knowledge [n PRIVITIES]\n",
  "PRIVY": "private [adj PRIVIER, PRIVIEST, PRIVILY] / an outhouse [n PRIVIES]\n",
  "PRIZABLE": "valuable [adj]\n",
  "PRIZE": "to value highly [v PRIZED, PRIZING, PRIZES]\n",
  "PRIZED": "PRIZE, to value highly [v]\n",
  "PRIZEFIGHT": "a professional boxing match [n -S]\n",
  "PRIZEFIGHTER": "one who takes part in a prizefight [n -S]\n",
  "PRIZEFIGHTERS": "PRIZEFIGHTER, one who takes part in a prizefight [n]\n",
  "PRIZEFIGHTING": "professional boxing [n -S]\n",
  "PRIZEFIGHTINGS": "PRIZEFIGHTING, professional boxing [n]\n",
  "PRIZEFIGHTS": "PRIZEFIGHT, a professional boxing match [n]\n",
  "PRIZEMAN": "a winner of a prize [n PRIZEMEN]\n",
  "PRIZEMEN": "PRIZEMAN, a winner of a prize [n]\n",
  "PRIZER": "a contestant for a prize, also PRISER [n -S]\n",
  "PRIZERS": "PRIZER, a contestant for a prize, also PRISER [n]\n",
  "PRIZES": "PRIZE, to value highly [v]\n",
  "PRIZEWINNER": "a winner of a prize [n -S]\n",
  "PRIZEWINNERS": "PRIZEWINNER, a winner of a prize [n]\n",
  "PRIZEWINNING": "having won or of a quality to win a prize [adj]\n",
  "PRIZEWOMAN": "a woman winning a prize [n PRIZEWOMEN]\n",
  "PRIZEWOMEN": "PRIZEWOMAN, a woman winning a prize [n]\n",
  "PRIZING": "PRIZE, to value highly [v]\n",
  "PRO": "(short for) a professional, or prostitute [n -S]\n",
  "PROA": "(Malay) a swift Malaysian sailing vessel, also PRAU, PRAHU, PRAO [n -S]\n",
  "PROABORTION": "favoring the legalization of abortion [adj]\n",
  "PROACTION": "action that initiates change as opposed to reaction to events [n -S]\n",
  "PROACTIONS": "PROACTION, action that initiates change as opposed to reaction to events [n]\n",
  "PROACTIVE": "tending to make changes in anticipation of change [adj]\n",
  "PROAIRESES": "PROAIRESIS, the act of choosing [n]\n",
  "PROAIRESIS": "the act of choosing [n PROAIRESES]\n",
  "PROAS": "PROA, (Malay) a swift Malaysian sailing vessel, also PRAU, PRAHU, PRAO [n]\n",
  "PROB": "(colloquial) a problem [n -S]\n",
  "PROBABILIORISM": "the belief that when in doubt one must choose the most likely answer [n -S]\n",
  "PROBABILIORISMS": "PROBABILIORISM, the belief that when in doubt one must choose the most likely answer [n]\n",
  "PROBABILIORIST": "a believer in probabiliorism [n -S]\n",
  "PROBABILIORISTS": "PROBABILIORIST, a believer in probabiliorism [n]\n",
  "PROBABILISM": "the belief that knowledge is always probable but never absolute [n -S]\n",
  "PROBABILISMS": "PROBABILISM, the belief that knowledge is always probable but never absolute [n]\n",
  "PROBABILIST": "an advocate of probabilism, the belief that knowledge is always probable but never absolute [n -S]\n",
  "PROBABILISTIC": "of or relating to probabilism [adj]\n",
  "PROBABILISTS": "PROBABILIST, an advocate of probabilism, the belief that knowledge is always probable but never absolute [n]\n",
  "PROBABILITIES": "PROBABILITY, the state of being probable [n]\n",
  "PROBABILITY": "the state of being probable [n PROBABILITIES]\n",
  "PROBABLE": "likely to occur or prove true [adj PROBABLY] / something probable [n -S]\n",
  "PROBABLES": "PROBABLE, something probable [n]\n",
  "PROBABLY": "PROBABLE, likely to occur or prove true [adv]\n",
  "PROBALL": "(Shakespeare) supposedly means plausible [adj]\n",
  "PROBAND": "a person with some distinctive characteristic who serves as the starting point for a study of genetic transmission [n -S]\n",
  "PROBANDS": "PROBAND, a person with some distinctive characteristic who serves as the starting point for a study of genetic transmission [n]\n",
  "PROBANG": "a long flexible rod with a sponge on the end used to remove foreign bodies from the larynx or the esophagus [n -S]\n",
  "PROBANGS": "PROBANG, a long flexible rod with a sponge on the end used to remove foreign bodies from the larynx or the esophagus [n]\n",
  "PROBATE": "to establish the validity of a will [v PROBATED, PROBATING, PROBATES]\n",
  "PROBATED": "PROBATE, to establish the validity of a will [v]\n",
  "PROBATES": "PROBATE, to establish the validity of a will [v]\n",
  "PROBATING": "PROBATE, to establish the validity of a will [v]\n",
  "PROBATION": "the act of proving; also, that which proves anything; proof [n -S]\n",
  "PROBATIONAL": "relating to, serving purpose of, probation or trial [adj PROBATIONALLY]\n",
  "PROBATIONALLY": "PROBATIONAL, relating to, serving purpose of, probation or trial [adv]\n",
  "PROBATIONARIES": "PROBATIONARY, one who is on probation [n]\n",
  "PROBATIONARY": "one who is on probation [n PROBATIONARIES]\n",
  "PROBATIONER": "a person (as a newly admitted student nurse) whose fitness is being tested during a trial period [n -S]\n",
  "PROBATIONERS": "PROBATIONER, a person (as a newly admitted student nurse) whose fitness is being tested during a trial period [n]\n",
  "PROBATIONERSHIP": "the state of being a probationer [n]\n",
  "PROBATIONS": "PROBATION, the act of proving; also, that which proves anything; proof [n]\n",
  "PROBATIVE": "testing, affording proof, also PROBATORY [adj PROBATIVELY]\n",
  "PROBATIVELY": "PROBATIVE, testing, affording proof, also PROBATORY [adv]\n",
  "PROBATORY": "testing, affording proof, also PROBATIVE [adj]\n",
  "PROBE": "to examine thoroughly [v PROBED, PROBING, PROBES]\n",
  "PROBEABLE": "that can be probed [adj]\n",
  "PROBED": "PROBE, to examine thoroughly [v]\n",
  "PROBENECID": "a drug that acts on renal tubular function [n -S]\n",
  "PROBENECIDS": "PROBENECID, a drug that acts on renal tubular function [n]\n",
  "PROBER": "one who probes [n -S]\n",
  "PROBERS": "PROBER, one who probes [n]\n",
  "PROBES": "PROBE, to examine thoroughly [v]\n",
  "PROBING": "the act of performing a probe [n -S]\n",
  "PROBINGLY": "PROBING [adv]\n",
  "PROBINGS": "PROBING, the act of performing a probe [n]\n",
  "PROBIOTIC": "a harmless bacterium that helps to protect the body from harmful bacteria [n -S]\n",
  "PROBIOTICS": "PROBIOTIC, a harmless bacterium that helps to protect the body from harmful bacteria [n]\n",
  "PROBIT": "a unit of statistical probability [n -S]\n",
  "PROBITIES": "PROBITY, complete and confirmed integrity [n]\n",
  "PROBITS": "PROBIT, a unit of statistical probability [n]\n",
  "PROBITY": "complete and confirmed integrity [n PROBITIES]\n",
  "PROBLEM": "a difficult question or situation [n -S]\n",
  "PROBLEMATIC": "causing problems [adj PROBLEMATICALLY] / something that is problematic, also PROBLEMATICAL [n -S]\n",
  "PROBLEMATICAL": "causing problems, also PROBLEMATIC [adj PROBLEMATICALLY]\n",
  "PROBLEMATICALLY": "PROBLEMATICAL, causing problems, also PROBLEMATIC [adv]\n",
  "PROBLEMATICS": "PROBLEMATIC, something that is problematic, also PROBLEMATICAL [n]\n",
  "PROBLEMIST": "one who sets problems [n -S]\n",
  "PROBLEMISTS": "PROBLEMIST, one who sets problems [n]\n",
  "PROBLEMS": "PROBLEM, a difficult question or situation [n]\n",
  "PROBOSCIDEAN": "any of an order of large mammals comprising the elephants and extinct related forms, also PROBOSCIDIAN [n -S]\n",
  "PROBOSCIDEANS": "PROBOSCIDEAN, any of an order of large mammals comprising the elephants and extinct related forms, also PROBOSCIDIAN [n]\n",
  "PROBOSCIDES": "PROBOSCIS, an elongated organ, usually associated with the mouth [n]\n",
  "PROBOSCIDIAN": "any of an order of large mammals comprising the elephants and extinct related forms, also PROBOSCIDEAN [n -S]\n",
  "PROBOSCIDIANS": "PROBOSCIDIAN, any of an order of large mammals comprising the elephants and extinct related forms, also PROBOSCIDEAN [n]\n",
  "PROBOSCIS": "an elongated organ, usually associated with the mouth [n PROBOSCIDES or PROBOSCISES]\n",
  "PROBOSCISES": "PROBOSCIS, an elongated organ, usually associated with the mouth [n]\n",
  "PROBOULEUTIC": "for preliminary deliberation [adj]\n",
  "PROBS": "PROB, (colloquial) a problem [n]\n",
  "PROBUSINESS": "in favour of business [adj]\n",
  "PROCACIOUS": "bold; impertinent [adj]\n",
  "PROCACITIES": "PROCACITY, forwardness, insolence, pertness [n]\n",
  "PROCACITY": "forwardness, insolence, pertness [n PROCACITIES]\n",
  "PROCAINE": "a compound used as a local anesthetic [n -S]\n",
  "PROCAINES": "PROCAINE, a compound used as a local anesthetic [n]\n",
  "PROCAMBIA": "PROCAMBIUM, the young tissue of a fibrovascular bundle before its component cells have begun to be differentiated [n]\n",
  "PROCAMBIAL": "relating to procambium, the young tissue of a fibrovascular bundle before its component cells have begun to be differentiated [adj]\n",
  "PROCAMBIUM": "the young tissue of a fibrovascular bundle before its component cells have begun to be differentiated [n PROCAMBIA or PROCAMBIUMS]\n",
  "PROCAMBIUMS": "PROCAMBIUM, the young tissue of a fibrovascular bundle before its component cells have begun to be differentiated [n]\n",
  "PROCAPITALIST": "supporting capitalism [adj]\n",
  "PROCARBAZINE": "an antineoplastic drug used esp. in the palliative treatment of Hodgkin's disease [n -S]\n",
  "PROCARBAZINES": "PROCARBAZINE, an antineoplastic drug used esp. in the palliative treatment of Hodgkin's disease [n]\n",
  "PROCARP": "a female sexual organ in certain algae [n -S]\n",
  "PROCARPS": "PROCARP, a female sexual organ in certain algae [n]\n",
  "PROCARYON": "the nucleus of a blue-green alga, bacterium etc., also PROKARYON [n -S]\n",
  "PROCARYONS": "PROCARYON, the nucleus of a blue-green alga, bacterium etc., also PROKARYON [n]\n",
  "PROCARYOTE": "a bacterium or blue-green algae whose nucleus lacks a limiting membrane, also PROKARYOT, PROKARYOTE [n -S]\n",
  "PROCARYOTES": "PROCARYOTE, a bacterium or blue-green algae whose nucleus lacks a limiting membrane, also PROKARYOT, PROKARYOTE [n]\n",
  "PROCARYOTIC": "like a procaryote [adj]\n",
  "PROCATHEDRAL": "a parish church serving as a cathedral [n -S]\n",
  "PROCATHEDRALS": "PROCATHEDRAL, a parish church serving as a cathedral [n]\n",
  "PROCEDURAL": "relating to procedure [adj PROCEDURALLY] / a realist crime novel with a specific focus [n -S]\n",
  "PROCEDURALLY": "PROCEDURAL, relating to procedure [adv]\n",
  "PROCEDURALS": "PROCEDURAL, a realist crime novel with a specific focus [n]\n",
  "PROCEDURE": "a way of doing something [n -S]\n",
  "PROCEDURES": "PROCEDURE, a way of doing something [n]\n",
  "PROCEED": "to go onward [v -ED, -ING, -S]\n",
  "PROCEEDED": "PROCEED, to go onward [v]\n",
  "PROCEEDER": "one who proceeds [n -S]\n",
  "PROCEEDERS": "PROCEEDER, one who proceeds [n]\n",
  "PROCEEDING": "the act of proceeding [n -S]\n",
  "PROCEEDINGS": "PROCEEDING, the act of proceeding [n]\n",
  "PROCEEDS": "PROCEED, to go onward [v]\n",
  "PROCELEUSMATIC": "inciting; encouraging; exhorting [adj] / a metrical foot of four short syllables [n -S]\n",
  "PROCELEUSMATICS": "PROCELEUSMATIC, a metrical foot of four short syllables [n]\n",
  "PROCELLARIAN": "a bird species from the genus Procellaria, petrels [n -S]\n",
  "PROCELLARIANS": "PROCELLARIAN, a bird species from the genus Procellaria, petrels [n]\n",
  "PROCEPHALIC": "pertaining to the front of the head [adj]\n",
  "PROCERCOID": "the solid first parasitic larva of some tapeworms [n -S]\n",
  "PROCERCOIDS": "PROCERCOID, the solid first parasitic larva of some tapeworms [n]\n",
  "PROCEREBRA": "PROCEREBRUM, the forebrain, the prosencephalon [n]\n",
  "PROCEREBRAL": "relating to the procerebrum, the forebrain, the proencephalon [adj]\n",
  "PROCEREBRUM": "the forebrain, the prosencephalon [n PROCEREBRA or PROCEREBRUMS]\n",
  "PROCEREBRUMS": "PROCEREBRUM, the forebrain, the prosencephalon [n]\n",
  "PROCERITIES": "PROCERITY, tallness, loftiness [n]\n",
  "PROCERITY": "tallness, loftiness [n PROCERITIES]\n",
  "PROCESS": "to treat or prepare by a special method [v -ED, -ING, -ES]\n",
  "PROCESSABILITY": "the state of being processable, also PROCESSIBILITY [n]\n",
  "PROCESSABLE": "that can be processed, also PROCESSIBLE [adj]\n",
  "PROCESSED": "PROCESS, to treat or prepare by a special method [v]\n",
  "PROCESSER": "something that processes, also PROCESSOR [n -S]\n",
  "PROCESSERS": "PROCESSER, something that processes, also PROCESSOR [n]\n",
  "PROCESSES": "PROCESS, to treat or prepare by a special method [v]\n",
  "PROCESSIBILITY": "the state of being processible, also PROCESSABILITY [n]\n",
  "PROCESSIBLE": "that can be processed, also PROCESSABLE [adj]\n",
  "PROCESSING": "the act of processing [n -S]\n",
  "PROCESSINGS": "PROCESSING, the act of processing [n]\n",
  "PROCESSION": "to go in procession [v -ED, -ING, -S]\n",
  "PROCESSIONAL": "of or like a procession [adj PROCESSIONALLY] / a book containing material for a procession [n -S]\n",
  "PROCESSIONALIST": "one who takes part in a processional [n]\n",
  "PROCESSIONALLY": "PROCESSIONAL, of or like a procession [adv]\n",
  "PROCESSIONALS": "PROCESSIONAL, a book containing material for a procession [n]\n",
  "PROCESSIONARIES": "PROCESSIONARY, a kind of moth [n]\n",
  "PROCESSIONARY": "a kind of moth [n PROCESSIONARIES]\n",
  "PROCESSIONED": "PROCESSION, to go in procession [v]\n",
  "PROCESSIONER": "(US) a county officer who determines boundaries [n -S]\n",
  "PROCESSIONERS": "PROCESSIONER, (US) a county officer who determines boundaries [n]\n",
  "PROCESSIONING": "the act of going in procession [n -S]\n",
  "PROCESSIONINGS": "PROCESSIONING, the act of going in procession [n]\n",
  "PROCESSIONS": "PROCESSION, to go in procession [v]\n",
  "PROCESSOR": "something that processes, also PROCESSER [n -S]\n",
  "PROCESSORS": "PROCESSOR, something that processes, also PROCESSER [n]\n",
  "PROCESSUAL": "governed by or related to an established process [adj]\n",
  "PROCHAIN": "(French) nearest in time, relation or degree, also PROCHEIN [adj]\n",
  "PROCHEIN": "(French) nearest in time, relation or degree, also PROCHAIN [adj]\n",
  "PROCHOICE": "in favour of women's right to abortion [adj]\n",
  "PROCHRONISM": "assigning a date to an event earlier than actual [n -S]\n",
  "PROCHRONISMS": "PROCHRONISM, assigning a date to an event earlier than actual [n]\n",
  "PROCHURCH": "favourable to church [adj]\n",
  "PROCIDENCE": "prolapse [n -S]\n",
  "PROCIDENCES": "PROCIDENCE, prolapse [n]\n",
  "PROCIDENT": "relating to procidence, prolapse [adj]\n",
  "PROCINCT": "(Milton) preparedness [n -S]\n",
  "PROCINCTS": "PROCINCT, (Milton) preparedness [n]\n",
  "PROCLAIM": "to make known [v -ED, -ING, -S]\n",
  "PROCLAIMANT": "one who proclaims [n -S]\n",
  "PROCLAIMANTS": "PROCLAIMANT, one who proclaims [n]\n",
  "PROCLAIMED": "PROCLAIM, to make known [v]\n",
  "PROCLAIMER": "one who proclaims [n -S]\n",
  "PROCLAIMERS": "PROCLAIMER, one who proclaims [n]\n",
  "PROCLAIMING": "PROCLAIM, to make known [v]\n",
  "PROCLAIMS": "PROCLAIM, to make known [v]\n",
  "PROCLAMATION": "the action of proclaiming [n -S]\n",
  "PROCLAMATIONS": "PROCLAMATION, the action of proclaiming [n]\n",
  "PROCLAMATORY": "of the nature of a proclamation [adj]\n",
  "PROCLISES": "PROCLISIS, the pronunciation of a word as a proclitic [n]\n",
  "PROCLISIS": "the pronunciation of a word as a proclitic [n PROCLISES]\n",
  "PROCLITIC": "of a word, transferring its stress to the following word [adj] / a proclitic word [n -S]\n",
  "PROCLITICS": "PROCLITIC, a proclitic word [n]\n",
  "PROCLIVE": "(archaic) having a tendency by nature; prone [adj]\n",
  "PROCLIVITIES": "PROCLIVITY, an inclination or predisposition toward something [n]\n",
  "PROCLIVITY": "an inclination or predisposition toward something [n PROCLIVITIES]\n",
  "PROCOELOUS": "cupped in front [adj]\n",
  "PROCONSUL": "an officer who discharged the duties of a consul without being himself consul; a governor of, or a military commander in, a province [n -S]\n",
  "PROCONSULAR": "relating to a proconsul [adj]\n",
  "PROCONSULATE": "the office of proconsul [n -S]\n",
  "PROCONSULATES": "PROCONSULATE, the office of proconsul [n]\n",
  "PROCONSULS": "PROCONSUL, an officer who discharged the duties of a consul without being himself consul; a governor of, or a military commander in, a province [n]\n",
  "PROCONSULSHIP": "the office of proconsul [n -S]\n",
  "PROCONSULSHIPS": "PROCONSULSHIP, the office of proconsul [n]\n",
  "PROCRASTINATE": "to put off intentionally and habitually [v PROCRASTINATED, PROCRASTINATING, PROCRASTINATES]\n",
  "PROCRASTINATED": "PROCRASTINATE, to put off intentionally and habitually [v]\n",
  "PROCRASTINATES": "PROCRASTINATE, to put off intentionally and habitually [v]\n",
  "PROCRASTINATING": "PROCRASTINATE, to put off intentionally and habitually [v]\n",
  "PROCRASTINATION": "the act of procrastinating [n]\n",
  "PROCRASTINATIVE": "tending to procrastinate, also PROCRASTINATORY [adj]\n",
  "PROCRASTINATOR": "one who procrastinates [n -S]\n",
  "PROCRASTINATORS": "PROCRASTINATOR, one who procrastinates [n]\n",
  "PROCRASTINATORY": "tending to procrastinate, also PROCRASTINATIVE [adj]\n",
  "PROCREANT": "generating; producing [adj] / a person who or thing which procreates [n -S]\n",
  "PROCREANTS": "PROCREANT, a person who or thing which procreates [n]\n",
  "PROCREATE": "to engender, beget offspring [v PROCREATED, PROCREATING, PROCREATES]\n",
  "PROCREATED": "PROCREATE, to engender, beget offspring [v]\n",
  "PROCREATES": "PROCREATE, to engender, beget offspring [v]\n",
  "PROCREATING": "PROCREATE, to engender, beget offspring [v]\n",
  "PROCREATION": "the act of procreating [n -S]\n",
  "PROCREATIONAL": "relating to procreation, also PROCREATIVE [adj]\n",
  "PROCREATIONS": "PROCREATION, the act of procreating [n]\n",
  "PROCREATIVE": "relating to procreation, also PROCREATIONAL [adj]\n",
  "PROCREATIVENESS": "the state of being procreative [n]\n",
  "PROCREATOR": "one who procreates [n -S]\n",
  "PROCREATORS": "PROCREATOR, one who procreates [n]\n",
  "PROCRUSTEAN": "marked by arbitrary often ruthless disregard of individual differences or special circumstances [adj]\n",
  "PROCRYPSES": "PROCRYPSIS, protective coloration [n]\n",
  "PROCRYPSIS": "protective coloration [n PROCRYPSES]\n",
  "PROCRYPTIC": "pertaining to or having protective coloration [adj PROCRYPTICALLY]\n",
  "PROCRYPTICALLY": "PROCRYPTIC, pertaining to or having protective coloration [adv]\n",
  "PROCTAL": "pertaining to the anus or rectum [adj]\n",
  "PROCTALGIA": "neuralgic pain in the rectum [n -S]\n",
  "PROCTALGIAS": "PROCTALGIA, neuralgic pain in the rectum [n]\n",
  "PROCTITIDES": "PROCTITIS, inflammation of the rectum, aka rectitis [n]\n",
  "PROCTITIS": "inflammation of the rectum, aka rectitis [n PROCTITISES or PROCTITIDES]\n",
  "PROCTITISES": "PROCTITIS, inflammation of the rectum, aka rectitis [n]\n",
  "PROCTODAEA": "PROCTODAEUM, the posterior portion of the alimentary canal, also PROCTODEUM [n]\n",
  "PROCTODAEAL": "relating to the proctodaeum, the posterior portion of the alimentary canal, esp. in insects and embryos, also PROCTODEAL [adj]\n",
  "PROCTODAEUM": "the posterior portion of the alimentary canal, also PROCTODEUM [n PROCTODAEA or PROCTODAEUMS]\n",
  "PROCTODAEUMS": "PROCTODAEUM, the posterior portion of the alimentary canal, also PROCTODEUM [n]\n",
  "PROCTODEA": "PROCTODEUM, the posterior portion of the alimentary canal, also PROCTODAEUM [n]\n",
  "PROCTODEAL": "relating to the proctodeum, also PROCTODAEAL [adj]\n",
  "PROCTODEUM": "the posterior portion of the alimentary canal, also PROCTODAEUM [n PROCTODEA or PROCTODEUMS]\n",
  "PROCTODEUMS": "PROCTODEUM, the posterior portion of the alimentary canal, also PROCTODAEUM [n]\n",
  "PROCTOLOGIC": "relating to proctology, the study of the rectum, also PROCTOLOGICAL [adj]\n",
  "PROCTOLOGICAL": "relating to proctology, the study of the rectum, also PROCTOLOGIC [adj]\n",
  "PROCTOLOGIES": "PROCTOLOGY, the study of the rectum [n]\n",
  "PROCTOLOGIST": "a specialist in proctology [n -S]\n",
  "PROCTOLOGISTS": "PROCTOLOGIST, a specialist in proctology [n]\n",
  "PROCTOLOGY": "the study of the rectum [n PROCTOLOGIES]\n",
  "PROCTOR": "a disciplinary officer at a college or university [n -S] / to officiate as a proctor [v -ED, -ING, -S]\n",
  "PROCTORAGE": "management by a proctor [n -S]\n",
  "PROCTORAGES": "PROCTORAGE, management by a proctor [n]\n",
  "PROCTORED": "PROCTOR, to officiate as a proctor [v]\n",
  "PROCTORIAL": "of or pertaining to a proctor, esp. an academic proctor [adj PROCTORIALLY]\n",
  "PROCTORIALLY": "PROCTORIAL, of or pertaining to a proctor, esp. an academic proctor [adv]\n",
  "PROCTORING": "PROCTOR, to officiate as a proctor [v]\n",
  "PROCTORISE": "to exercise the power of a proctor against, also PROCTORIZE [v PROCTORISED, PROCTORISING, PROCTORISES]\n",
  "PROCTORISED": "PROCTORISE, to exercise the power of a proctor against, also PROCTORIZE [v]\n",
  "PROCTORISES": "PROCTORISE, to exercise the power of a proctor against, also PROCTORIZE [v]\n",
  "PROCTORISING": "PROCTORISE, to exercise the power of a proctor against, also PROCTORIZE [v]\n",
  "PROCTORIZE": "to exercise the power of a proctor against, also PROCTORISE [v PROCTORIZED, PROCTORIZING, PROCTORIZES]\n",
  "PROCTORIZED": "PROCTORIZE, to exercise the power of a proctor against, also PROCTORISE [v]\n",
  "PROCTORIZES": "PROCTORIZE, to exercise the power of a proctor against, also PROCTORISE [v]\n",
  "PROCTORIZING": "PROCTORIZE, to exercise the power of a proctor against, also PROCTORISE [v]\n",
  "PROCTORS": "PROCTOR, to officiate as a proctor [v]\n",
  "PROCTORSHIP": "the office of proctor [n -S]\n",
  "PROCTORSHIPS": "PROCTORSHIP, the office of proctor [n]\n",
  "PROCTOSCOPE": "an instrument for examining the rectum [n -S]\n",
  "PROCTOSCOPES": "PROCTOSCOPE, an instrument for examining the rectum [n]\n",
  "PROCTOSCOPIC": "relating to proctoscopy [adj]\n",
  "PROCTOSCOPIES": "PROCTOSCOPY, examination by use of a proctoscope, an instrument for examining the rectum [n]\n",
  "PROCTOSCOPY": "examination by use of a proctoscope, an instrument for examining the rectum [n PROCTOSCOPIES]\n",
  "PROCUMBENT": "lying face down, prone [adj]\n",
  "PROCURABLE": "capable of being procured [adj]\n",
  "PROCURACIES": "PROCURACY, the office of a procurator [n]\n",
  "PROCURACY": "the office of a procurator [n PROCURACIES]\n",
  "PROCURAL": "the act of procuring [n -S]\n",
  "PROCURALS": "PROCURAL, the act of procuring [n]\n",
  "PROCURANCE": "the act of procuring [n -S]\n",
  "PROCURANCES": "PROCURANCE, the act of procuring [n]\n",
  "PROCURATION": "the management of another's affairs; the instrument giving authority for this [n -S]\n",
  "PROCURATIONS": "PROCURATION, the management of another's affairs; the instrument giving authority for this [n]\n",
  "PROCURATOR": "a person who is employed to manage the affairs of another or is authorized to act on behalf of another in any business, also PROCUREUR [n -S]\n",
  "PROCURATORIAL": "of or like a procurator [adj]\n",
  "PROCURATORIES": "PROCURATORY, authorization to act for another [n]\n",
  "PROCURATORS": "PROCURATOR, a person who is employed to manage the affairs of another or is authorized to act on behalf of another in any business, also PROCUREUR [n]\n",
  "PROCURATORSHIP": "the office of procurator [n -S]\n",
  "PROCURATORSHIPS": "PROCURATORSHIP, the office of procurator [n]\n",
  "PROCURATORY": "authorization to act for another [n PROCURATORIES]\n",
  "PROCURE": "to obtain by effort [v PROCURED, PROCURING, PROCURES]\n",
  "PROCURED": "PROCURE, to obtain by effort [v]\n",
  "PROCUREMENT": "the act of procuring [n -S]\n",
  "PROCUREMENTS": "PROCUREMENT, the act of procuring [n]\n",
  "PROCURER": "someone who procures; a pander [n -S]\n",
  "PROCURERS": "PROCURER, someone who procures; a pander [n]\n",
  "PROCURES": "PROCURE, to obtain by effort [v]\n",
  "PROCURESS": "a female procurer, or pander [n -ES]\n",
  "PROCURESSES": "PROCURESS, a female procurer, or pander [n]\n",
  "PROCUREUR": "(French) a procurator, also PROCURATOR [n -S]\n",
  "PROCUREURS": "PROCUREUR, (French) a procurator, also PROCURATOR [n]\n",
  "PROCURING": "the act of obtaining [n -S]\n",
  "PROCURINGS": "PROCURING, the act of obtaining [n]\n",
  "PROCYONID": "a member of the Procyonidae: racoons, coatis etc. [n -S]\n",
  "PROCYONIDS": "PROCYONID, a member of the Procyonidae: racoons, coatis etc. [n]\n",
  "PROD": "to jab [v PRODDED, PRODDING, PRODS]\n",
  "PRODDED": "PROD, to jab [v]\n",
  "PRODDER": "one who prods [n -S]\n",
  "PRODDERS": "PRODDER, one who prods [n]\n",
  "PRODDING": "the act of poking [n -S]\n",
  "PRODDINGS": "PRODDING, the act of poking [n]\n",
  "PRODIGAL": "lavish [adj PRODIGALLY] / a wastrel, a spendthrift [n -S]\n",
  "PRODIGALISE": "to spend lavishly, to waste, also PRODIGALIZE [v PRODIGALISED, PRODIGALISING, PRODIGALISES]\n",
  "PRODIGALISED": "PRODIGALISE, to spend lavishly, to waste, also PRODIGALIZE [v]\n",
  "PRODIGALISES": "PRODIGALISE, to spend lavishly, to waste, also PRODIGALIZE [v]\n",
  "PRODIGALISING": "PRODIGALISE, to spend lavishly, to waste, also PRODIGALIZE [v]\n",
  "PRODIGALITIES": "PRODIGALITY, the state of being prodigal [n]\n",
  "PRODIGALITY": "the state of being prodigal [n PRODIGALITIES]\n",
  "PRODIGALIZE": "to spend lavishly, to waste, also PRODIGALISE [v PRODIGALIZED, PRODIGALIZING, PRODIGALIZES]\n",
  "PRODIGALIZED": "PRODIGALIZE, to spend lavishly, to waste, also PRODIGALISE [v]\n",
  "PRODIGALIZES": "PRODIGALIZE, to spend lavishly, to waste, also PRODIGALISE [v]\n",
  "PRODIGALIZING": "PRODIGALIZE, to spend lavishly, to waste, also PRODIGALISE [v]\n",
  "PRODIGALLY": "PRODIGAL, lavish [adv]\n",
  "PRODIGALS": "PRODIGAL, a wastrel, a spendthrift [n]\n",
  "PRODIGIES": "PRODIGY, a child with exceptional talent and ability [n]\n",
  "PRODIGIOSITIES": "PRODIGIOSITY, being prodigious [n]\n",
  "PRODIGIOSITY": "being prodigious [n PRODIGIOSITIES]\n",
  "PRODIGIOUS": "resembling or befitting a prodigy [adj PRODIGIOUSLY]\n",
  "PRODIGIOUSLY": "PRODIGIOUS, resembling or befitting a prodigy [adv]\n",
  "PRODIGIOUSNESS": "the state of being prodigious [n]\n",
  "PRODIGY": "a child with exceptional talent and ability [n PRODIGIES]\n",
  "PRODITOR": "(Latin) a traitor [n -S]\n",
  "PRODITORIOUS": "traitorous; prone to give away secrets [adj]\n",
  "PRODITORS": "PRODITOR, (Latin) a traitor [n]\n",
  "PRODITORY": "treacherous [adj]\n",
  "PRODNOSE": "an inquisitive person [n -S] / to pry, make uninvited inquiries [v PRODNOSED, PRODNOSING, PRODNOSES]\n",
  "PRODNOSED": "PRODNOSE, to pry, make uninvited inquiries [v]\n",
  "PRODNOSES": "PRODNOSE, to pry, make uninvited inquiries [v]\n",
  "PRODNOSING": "PRODNOSE, to pry, make uninvited inquiries [v]\n",
  "PRODROMA": "(Greek) any symptom that signals the impending onset of a disease, also PRODROME, PRODROMUS [n PRODROMATA]\n",
  "PRODROMAL": "of or pertaining to prodromes; as, the prodromal stage of a disease, also PRODROMIC [adj]\n",
  "PRODROMATA": "PRODROME, a prefatory work; an initial symptom of a disease, also PRODROMA, PRODROMUS [n]\n",
  "PRODROME": "a prefatory work; an initial symptom of a disease, also PRODROMA, PRODROMUS [n PRODROMES or PRODROMATA]\n",
  "PRODROMES": "PRODROME, a prefatory work; an initial symptom of a disease, also PRODROMA, PRODROMUS [n]\n",
  "PRODROMI": "PRODROMUS, a prefatory work; an initial symptom of a disease, also PRODROMA, PRODROME [n]\n",
  "PRODROMIC": "of or pertaining to prodromes; as, the prodromal stage of a disease, also PRODROMAL [adj]\n",
  "PRODROMUS": "a prefatory work; an initial symptom of a disease, also PRODROMA, PRODROME [n PRODROMI]\n",
  "PRODRUG": "an inactive chemical substance that becomes an active drug in the body [n -S]\n",
  "PRODRUGS": "PRODRUG, an inactive chemical substance that becomes an active drug in the body [n]\n",
  "PRODS": "PROD, to jab [v]\n",
  "PRODUCE": "to bring into existence [v PRODUCED, PRODUCING, PRODUCES]\n",
  "PRODUCED": "PRODUCE, to bring into existence [v]\n",
  "PRODUCEMENT": "(Milton) product [n -S]\n",
  "PRODUCEMENTS": "PRODUCEMENT, (Milton) product [n]\n",
  "PRODUCER": "one that produces [n -S]\n",
  "PRODUCERS": "PRODUCER, one that produces [n]\n",
  "PRODUCES": "PRODUCE, to bring into existence [v]\n",
  "PRODUCIBILITIES": "PRODUCIBILITY, the capacity to be produced [n]\n",
  "PRODUCIBILITY": "the capacity to be produced [n PRODUCIBILITIES]\n",
  "PRODUCIBLE": "capable of being produced [adj]\n",
  "PRODUCING": "PRODUCE, to bring into existence [v]\n",
  "PRODUCT": "something produced by labour or effort [n -S]\n",
  "PRODUCTIBILITY": "the state of being producible [n]\n",
  "PRODUCTILE": "capable of being extended or prolonged [adj]\n",
  "PRODUCTION": "something produced [n -S]\n",
  "PRODUCTIONAL": "relating to production [adj]\n",
  "PRODUCTIONS": "PRODUCTION, something produced [n]\n",
  "PRODUCTIVE": "having the power of producing, esp. in abundance [adj PRODUCTIVELY]\n",
  "PRODUCTIVELY": "PRODUCTIVE, having the power of producing, esp. in abundance [adv]\n",
  "PRODUCTIVENESS": "PRODUCTIVE, having the power of producing, esp. in abundance [n]\n",
  "PRODUCTIVITIES": "PRODUCTIVITY, the state of being productive [n]\n",
  "PRODUCTIVITY": "the state of being productive [n PRODUCTIVITIES]\n",
  "PRODUCTS": "PRODUCT, something produced by labour or effort [n]\n",
  "PROEM": "an introduction, a prelude, also PROOEMION, PROOEMIUM [n -S]\n",
  "PROEMBRYO": "a group of cells formed in the dividing zygote, from which part the embryo arises [n -S]\n",
  "PROEMBRYOS": "PROEMBRYO, a group of cells formed in the dividing zygote, from which part the embryo arises [n]\n",
  "PROEMIAL": "relating to a proem [adj]\n",
  "PROEMS": "PROEM, an introduction, a prelude, also PROOEMION, PROOEMIUM [n]\n",
  "PROENZYME": "an enzyme in an inactive form which can be activated, often by another enzyme [n -S]\n",
  "PROENZYMES": "PROENZYME, an enzyme in an inactive form which can be activated, often by another enzyme [n]\n",
  "PROESTRUS": "in mammals, the coming on of heat in the oestrus cycle [n -ES]\n",
  "PROESTRUSES": "PROESTRUS, in mammals, the coming on of heat in the oestrus cycle [n]\n",
  "PROETTE": "a female golfing professional [n -S]\n",
  "PROETTES": "PROETTE, a female golfing professional [n]\n",
  "PROF": "(short for) professor [n -S]\n",
  "PROFACE": "(Shakespeare) may it profit you, a phrase of welcome [interj]\n",
  "PROFAMILY": "supportive of the family [adj]\n",
  "PROFANATION": "the act or an instance of profaning [n -S]\n",
  "PROFANATIONS": "PROFANATION, the act or an instance of profaning [n]\n",
  "PROFANATORY": "tending to profane [adj]\n",
  "PROFANE": "not sacred [adj PROFANELY] / to treat with irreverence or insult [v PROFANED, PROFANING, PROFANES]\n",
  "PROFANED": "PROFANE, to treat with irreverence or insult [v]\n",
  "PROFANELY": "PROFANE, not sacred [adv]\n",
  "PROFANENESS": "the state of being profane [n -ES]\n",
  "PROFANENESSES": "PROFANENESS, the state of being profane [n]\n",
  "PROFANER": "one who profanes [n -S]\n",
  "PROFANERS": "PROFANER, one who profanes [n]\n",
  "PROFANES": "PROFANE, to treat with irreverence or insult [v]\n",
  "PROFANING": "PROFANE, to treat with irreverence or insult [v]\n",
  "PROFANITIES": "PROFANITY, the state of being profane; a swearword [n]\n",
  "PROFANITY": "the state of being profane; a swearword [n PROFANITIES]\n",
  "PROFASCIST": "supporting fascism [adj]\n",
  "PROFECTITIOUS": "derived from a parent or ancestor [adj]\n",
  "PROFEMINIST": "in favour of feminism [adj]\n",
  "PROFESS": "to affirm openly [v -ED, -ING, -ES]\n",
  "PROFESSED": "PROFESS, to affirm openly [v]\n",
  "PROFESSEDLY": "PROFESSED, PROFESS, to affirm openly [adv]\n",
  "PROFESSES": "PROFESS, to affirm openly [v]\n",
  "PROFESSING": "PROFESS, to affirm openly [v]\n",
  "PROFESSION": "a calling [n -S]\n",
  "PROFESSIONAL": "of, belonging to or relating to a profession [adj PROFESSIONALLY] / one that is professional [n -S]\n",
  "PROFESSIONALISE": "to give a professional character to, also PROFESSIONALIZE [v]\n",
  "PROFESSIONALISM": "the conduct, aims, or qualities that characterize or mark a profession or a professional person [n]\n",
  "PROFESSIONALIST": "characterised by professionalism [adj]\n",
  "PROFESSIONALIZE": "to give a professional character to, also PROFESSIONALISE [v]\n",
  "PROFESSIONALLY": "PROFESSIONAL, of, belonging to or relating to a profession [adv]\n",
  "PROFESSIONALS": "PROFESSIONAL, one that is professional [n]\n",
  "PROFESSIONS": "PROFESSION, a calling [n]\n",
  "PROFESSOR": "a university or college teacher of the highest grade [n -S]\n",
  "PROFESSORATE": "the office of a professor [n -S]\n",
  "PROFESSORATES": "PROFESSORATE, the office of a professor [n]\n",
  "PROFESSORESS": "a female professor [n -ES]\n",
  "PROFESSORESSES": "PROFESSORESS, a female professor [n]\n",
  "PROFESSORIAL": "of or like a professor [adj PROFESSORIALLY]\n",
  "PROFESSORIALLY": "PROFESSORIAL, of or like a professor [adv]\n",
  "PROFESSORIAT": "the body of college and university teachers at an institution or in society, also PROFESSORIATE [n -S]\n",
  "PROFESSORIATE": "the body of college and university teachers at an institution or in society, also PROFESSORIAT [n -S]\n",
  "PROFESSORIATES": "PROFESSORIATE, the body of college and university teachers at an institution or in society, also PROFESSORIAT [n]\n",
  "PROFESSORIATS": "PROFESSORIAT, the body of college and university teachers at an institution or in society, also PROFESSORIATE [n]\n",
  "PROFESSORS": "PROFESSOR, a university or college teacher of the highest grade [n]\n",
  "PROFESSORSHIP": "the office of professor [n -S]\n",
  "PROFESSORSHIPS": "PROFESSORSHIP, the office of professor [n]\n",
  "PROFFER": "to present for acceptance [v -ED, -ING, -S]\n",
  "PROFFERED": "PROFFER, to present for acceptance [v]\n",
  "PROFFERER": "one who proffers [n -S]\n",
  "PROFFERERS": "PROFFERER, one who proffers [n]\n",
  "PROFFERING": "PROFFER, to present for acceptance [v]\n",
  "PROFFERS": "PROFFER, to present for acceptance [v]\n",
  "PROFICIENCE": "the state of being proficient, also PROFICIENCY [n -S]\n",
  "PROFICIENCES": "PROFICIENCE, the state of being proficient, also PROFICIENCY [n]\n",
  "PROFICIENCIES": "PROFICIENCY, the state of being proficient, also PROFICIENCE [n]\n",
  "PROFICIENCY": "the state of being proficient, also PROFICIENCE [n PROFICIENCIES]\n",
  "PROFICIENT": "well advanced in an art, occupation, or branch of knowledge [adj PROFICIENTLY] / one who is proficient [n -S]\n",
  "PROFICIENTLY": "PROFICIENT, well advanced in an art, occupation, or branch of knowledge [adv]\n",
  "PROFICIENTS": "PROFICIENT, one who is proficient [n]\n",
  "PROFILE": "to draw an outline of [v PROFILED, PROFILING, PROFILES]\n",
  "PROFILED": "PROFILE, to draw an outline of [v]\n",
  "PROFILER": "one who profiles, also PROFILIST [n -S]\n",
  "PROFILERS": "PROFILER, one who profiles, also PROFILIST [n]\n",
  "PROFILES": "PROFILE, to draw an outline of [v]\n",
  "PROFILING": "the process of compiling a profile of a person's physical (e.g. DNA) or psychological characteristics [n -S]\n",
  "PROFILINGS": "PROFILING, the process of compiling a profile of a person's physical (e.g. DNA) or psychological characteristics [n]\n",
  "PROFILIST": "one who draws profiles, also PROFILER [n -S]\n",
  "PROFILISTS": "PROFILIST, one who draws profiles, also PROFILER [n]\n",
  "PROFIT": "to gain an advantage or benefit [v -ED, -ING, -S]\n",
  "PROFITABILITIES": "PROFITABILITY, the state of being profitable [n]\n",
  "PROFITABILITY": "the state of being profitable [n PROFITABILITIES]\n",
  "PROFITABLE": "yielding profit [adj PROFITABLY]\n",
  "PROFITABLENESS": "PROFITABLE, yielding profit [n]\n",
  "PROFITABLY": "PROFITABLE, yielding profit [adv]\n",
  "PROFITED": "PROFIT, to gain an advantage or benefit [v]\n",
  "PROFITEER": "a person who takes advantage of an emergency to make exorbitant profits [n -S] / to act as a profiteer [v -ED, -ING, -S]\n",
  "PROFITEERED": "PROFITEER, to act as a profiteer [v]\n",
  "PROFITEERING": "acting as a profiteer [n -S]\n",
  "PROFITEERINGS": "PROFITEERING, acting as a profiteer [n]\n",
  "PROFITEERS": "PROFITEER, to act as a profiteer [v]\n",
  "PROFITER": "one who profits [n -S]\n",
  "PROFITEROLE": "(French) a small puff of choux pastry, usually filled with cream and covered with a chocolate sauce [n -S]\n",
  "PROFITEROLES": "PROFITEROLE, (French) a small puff of choux pastry, usually filled with cream and covered with a chocolate sauce [n]\n",
  "PROFITERS": "PROFITER, one who profits [n]\n",
  "PROFITING": "the act of profiting [n -S]\n",
  "PROFITINGS": "PROFITING, the act of profiting [n]\n",
  "PROFITLESS": "without profit [adj PROFITLESSLY]\n",
  "PROFITLESSLY": "PROFITLESS, without profit [adv]\n",
  "PROFITS": "PROFIT, to gain an advantage or benefit [v]\n",
  "PROFITWISE": "by way of profit [adv]\n",
  "PROFLIGACIES": "PROFLIGACY, the state of being profligate [n]\n",
  "PROFLIGACY": "the state of being profligate [n PROFLIGACIES]\n",
  "PROFLIGATE": "debauched; rashly extravagant [adj PROFLIGATELY] / one who is profligate [n -S]\n",
  "PROFLIGATELY": "PROFLIGATE, debauched; rashly extravagant [adv]\n",
  "PROFLIGATES": "PROFLIGATE, one who is profligate [n]\n",
  "PROFLUENCE": "(Milton) the quality of being profluent [n -S]\n",
  "PROFLUENCES": "PROFLUENCE, (Milton) the quality of being profluent [n]\n",
  "PROFLUENT": "(Milton) flowing out or onwards [adj]\n",
  "PROFORMA": "an invoice made out to show the price of goods, the goods being paid for before dispatch [n -S]\n",
  "PROFORMAS": "PROFORMA, an invoice made out to show the price of goods, the goods being paid for before dispatch [n]\n",
  "PROFOUND": "very deep [adj PROFOUNDER, PROFOUNDEST, PROFOUNDLY] / something that is very deep [n -S]\n",
  "PROFOUNDER": "PROFOUND, very deep [adj]\n",
  "PROFOUNDEST": "PROFOUND, very deep [adj]\n",
  "PROFOUNDLY": "PROFOUND, very deep [adv]\n",
  "PROFOUNDNESS": "the state of being profound [n -ES]\n",
  "PROFOUNDNESSES": "PROFOUNDNESS, the state of being profound [n]\n",
  "PROFOUNDS": "PROFOUND, something that is very deep [n]\n",
  "PROFS": "PROF, (short for) professor [n]\n",
  "PROFULGENT": "shining out; radiant [adj]\n",
  "PROFUNDITIES": "PROFUNDITY, intellectual depth [n]\n",
  "PROFUNDITY": "intellectual depth [n PROFUNDITIES]\n",
  "PROFUSE": "pouring forth generously, also PROFUSIVE [adj PROFUSELY]\n",
  "PROFUSELY": "PROFUSE, pouring forth generously, also PROFUSIVE [adv]\n",
  "PROFUSENESS": "the state of being profuse [n -ES]\n",
  "PROFUSENESSES": "PROFUSENESS, the state of being profuse [n]\n",
  "PROFUSER": "a prodigal or spendthrift [n -S]\n",
  "PROFUSERS": "PROFUSER, a prodigal or spendthrift [n]\n",
  "PROFUSION": "the state of being profuse [n -S]\n",
  "PROFUSIONS": "PROFUSION, the state of being profuse [n]\n",
  "PROFUSIVE": "profuse, also PROFUSE [adj]\n",
  "PROG": "to forage for food [v PROGGED, PROGGING, PROGS]\n",
  "PROGENIES": "PROGENY, a descendant [n]\n",
  "PROGENITIVE": "capable of bearing offspring [adj]\n",
  "PROGENITIVENESS": "the state of being progenitive [n]\n",
  "PROGENITOR": "an ancestor in the direct line [n -S]\n",
  "PROGENITORIAL": "of or like a progenitor [adj]\n",
  "PROGENITORS": "PROGENITOR, an ancestor in the direct line [n]\n",
  "PROGENITORSHIP": "the state of being a progenitor [n -S]\n",
  "PROGENITORSHIPS": "PROGENITORSHIP, the state of being a progenitor [n]\n",
  "PROGENITRESS": "a female parent or ancestor, also PROGENITRIX [n -ES]\n",
  "PROGENITRESSES": "PROGENITRESS, a female parent or ancestor, also PROGENITRIX [n]\n",
  "PROGENITRICES": "PROGENITRIX, a female parent or ancestor, also PROGENITRESS [n]\n",
  "PROGENITRIX": "a female parent or ancestor, also PROGENITRESS [n PROGENITRICES or PROGENITRIXES]\n",
  "PROGENITRIXES": "PROGENITRIX, a female parent or ancestor, also PROGENITRESS [n]\n",
  "PROGENITURE": "an act or instance of begetting [n -S]\n",
  "PROGENITURES": "PROGENITURE, an act or instance of begetting [n]\n",
  "PROGENY": "a descendant [n PROGENIES]\n",
  "PROGERIA": "a syndrome of children characterized by physical symptoms suggestive of premature senility [n -S]\n",
  "PROGERIAS": "PROGERIA, a syndrome of children characterized by physical symptoms suggestive of premature senility [n]\n",
  "PROGESTATIONAL": "preceding pregnancy or gestation [adj]\n",
  "PROGESTERONE": "a female sex hormone that prepares the uterus for the fertilized ovum and maintains pregnancy [n -S]\n",
  "PROGESTERONES": "PROGESTERONE, a female sex hormone that prepares the uterus for the fertilized ovum and maintains pregnancy [n]\n",
  "PROGESTIN": "a hormone concerned with changes before pregnancy [n -S]\n",
  "PROGESTINS": "PROGESTIN, a hormone concerned with changes before pregnancy [n]\n",
  "PROGESTOGEN": "any of a range of hormones of the progesterone type [n -S]\n",
  "PROGESTOGENIC": "relating to progestogen [adj]\n",
  "PROGESTOGENS": "PROGESTOGEN, any of a range of hormones of the progesterone type [n]\n",
  "PROGGED": "PROG, to forage for food [v]\n",
  "PROGGER": "one who progs, wanders about and begs [n -S]\n",
  "PROGGERS": "PROGGER, one who progs, wanders about and begs [n]\n",
  "PROGGING": "PROG, to forage for food [v]\n",
  "PROGGINS": "(slang) a college proctor [n -ES]\n",
  "PROGGINSES": "PROGGINS, (slang) a college proctor [n]\n",
  "PROGLOTTIC": "relating to the proglottis [adj]\n",
  "PROGLOTTID": "a segment of a tapeworm, also PROGLOTTIS [n -S]\n",
  "PROGLOTTIDEAN": "of or like a proglottis, a segment of a tapeworm [adj]\n",
  "PROGLOTTIDES": "PROGLOTTID, a segment of a tapeworm, also PROGLOTTIS [n]\n",
  "PROGLOTTIDS": "PROGLOTTID, a segment of a tapeworm, also PROGLOTTIS [n]\n",
  "PROGLOTTIS": "a segment of a tapeworm, also PROGLOTTID [n PROGLOTTIDES]\n",
  "PROGNATHIC": "having a jaw that projects forward, also PROGNATHOUS [adj]\n",
  "PROGNATHISM": "the state of having projecting jaws [n -S]\n",
  "PROGNATHISMS": "PROGNATHISM, the state of having projecting jaws [n]\n",
  "PROGNATHOUS": "having a jaw that projects forward, also PROGNATHIC [adj]\n",
  "PROGNOSE": "to forecast the probable course of a disease [v PROGNOSED, PROGNOSING, PROGNOSES]\n",
  "PROGNOSED": "PROGNOSE, to forecast the probable course of a disease [v]\n",
  "PROGNOSES": "PROGNOSE, to forecast the probable course of a disease [v]\n",
  "PROGNOSING": "PROGNOSE, to forecast the probable course of a disease [v]\n",
  "PROGNOSIS": "a forecasting or forecast, esp. of the course of a disease [n PROGNOSES]\n",
  "PROGNOSTIC": "indicating what is to happen by signs or symptoms [adj] / a symptom on which prognosis can be based [n -S]\n",
  "PROGNOSTICATE": "to foretell from signs or symptoms [v PROGNOSTICATED, PROGNOSTICATING, PROGNOSTICATES]\n",
  "PROGNOSTICATED": "PROGNOSTICATE, to foretell from signs or symptoms [v]\n",
  "PROGNOSTICATES": "PROGNOSTICATE, to foretell from signs or symptoms [v]\n",
  "PROGNOSTICATING": "PROGNOSTICATE, to foretell from signs or symptoms [v]\n",
  "PROGNOSTICATION": "an indication in advance [n]\n",
  "PROGNOSTICATIVE": "of the nature of prognostication [adj]\n",
  "PROGNOSTICATOR": "one who prognosticates [n -S]\n",
  "PROGNOSTICATORS": "PROGNOSTICATOR, one who prognosticates [n]\n",
  "PROGNOSTICS": "PROGNOSTIC, a symptom on which prognosis can be based [n]\n",
  "PROGRADATION": "the act of prograding, advancing seaward [n -S]\n",
  "PROGRADATIONS": "PROGRADATION, the act of prograding, advancing seaward [n]\n",
  "PROGRADE": "to accumulate sediment and hence advance seaward [v PROGRADED, PROGRADING, PROGRADES]\n",
  "PROGRADED": "PROGRADE, to accumulate sediment and hence advance seaward [v]\n",
  "PROGRADES": "PROGRADE, to accumulate sediment and hence advance seaward [v]\n",
  "PROGRADING": "PROGRADE, to accumulate sediment and hence advance seaward [v]\n",
  "PROGRAM": "to arrange in a plan of proceedings [v PROGRAMED or PROGRAMMED, PROGRAMING or PROGRAMMING, PROGRAMS]\n",
  "PROGRAMABLE": "that can be programmed, also PROGRAMMABLE [adj]\n",
  "PROGRAMED": "PROGRAM, to arrange in a plan of proceedings [v]\n",
  "PROGRAMER": "(US) one who writes programs, also PROGRAMMER [n -S]\n",
  "PROGRAMERS": "PROGRAMER, (US) one who writes programs, also PROGRAMMER [n]\n",
  "PROGRAMING": "the act of writing a program [n -S]\n",
  "PROGRAMINGS": "PROGRAMING, the act of writing a program [n]\n",
  "PROGRAMMABILITY": "the state of being programmable [n]\n",
  "PROGRAMMABLE": "that can be programmed, also PROGRAMABLE [adj] / a device that can be programmed [n -S]\n",
  "PROGRAMMABLES": "PROGRAMMABLE, a device that can be programmed [n]\n",
  "PROGRAMMATIC": "relating to program music [adj]\n",
  "PROGRAMME": "to prepare a program for (a computer, etc.) [v PROGRAMMED, PROGRAMMING, PROGRAMMES]\n",
  "PROGRAMMED": "PROGRAM, to arrange in a plan of proceedings [v]\n",
  "PROGRAMMER": "one who writes programs, also PROGRAMER [n -S]\n",
  "PROGRAMMERS": "PROGRAMMER, one who writes programs, also PROGRAMER [n]\n",
  "PROGRAMMES": "PROGRAMME, to prepare a program for (a computer, etc.) [v]\n",
  "PROGRAMMING": "the act of making a program [n -S]\n",
  "PROGRAMMINGS": "PROGRAMMING, the act of making a program [n]\n",
  "PROGRAMS": "PROGRAM, to arrange in a plan of proceedings [v]\n",
  "PROGRESS": "to move forward [v -ED, -ING, -ES]\n",
  "PROGRESSED": "PROGRESS, to move forward [v]\n",
  "PROGRESSES": "PROGRESS, to move forward [v]\n",
  "PROGRESSING": "PROGRESS, to move forward [v]\n",
  "PROGRESSION": "motion onward [n -S]\n",
  "PROGRESSIONAL": "relating to progression [adj PROGRESSIONALLY]\n",
  "PROGRESSIONALLY": "PROGRESSIONAL, relating to progression [adv]\n",
  "PROGRESSIONARY": "showing progression [adj]\n",
  "PROGRESSIONISM": "sympathy with or advocacy of progress; belief that social or other evolution is towards higher or better things [n -S]\n",
  "PROGRESSIONISMS": "PROGRESSIONISM, sympathy with or advocacy of progress; belief that social or other evolution is towards higher or better things [n]\n",
  "PROGRESSIONIST": "a supporter of progressionism [n -S]\n",
  "PROGRESSIONISTS": "PROGRESSIONIST, a supporter of progressionism [n]\n",
  "PROGRESSIONS": "PROGRESSION, motion onward [n]\n",
  "PROGRESSISM": "sympathy with or advocacy of progress, also PROGRESSIVISM [n -S]\n",
  "PROGRESSISMS": "PROGRESSISM, sympathy with or advocacy of progress, also PROGRESSIVISM [n]\n",
  "PROGRESSIST": "one who believes in progressism [n -S]\n",
  "PROGRESSISTS": "PROGRESSIST, one who believes in progressism [n]\n",
  "PROGRESSIVE": "showing progress [adj PROGRESSIVELY] / one who favours progress or reform [n -S]\n",
  "PROGRESSIVELY": "PROGRESSIVE, showing progress [adv]\n",
  "PROGRESSIVENESS": "PROGRESSIVE, showing progress [n]\n",
  "PROGRESSIVES": "PROGRESSIVE, one who favours progress or reform [n]\n",
  "PROGRESSIVISM": "sympathy with or advocacy of progress, also PROGRESSISM [n -S]\n",
  "PROGRESSIVISMS": "PROGRESSIVISM, sympathy with or advocacy of progress, also PROGRESSISM [n]\n",
  "PROGRESSIVIST": "an upholder of progressivism [n -S]\n",
  "PROGRESSIVISTIC": "relating to progressivism [adj]\n",
  "PROGRESSIVISTS": "PROGRESSIVIST, an upholder of progressivism [n]\n",
  "PROGRESSIVITIES": "PROGRESSIVITY, the state of being a progressive tax [n]\n",
  "PROGRESSIVITY": "the state of being a progressive tax [n PROGRESSIVITIES]\n",
  "PROGS": "PROG, to forage for food [v]\n",
  "PROGUN": "in favour of guns [adj]\n",
  "PROGYMNASIA": "PROGYMNASIUM, in Germany, a gymnasium for pupils up to age 16 only, at which university entrance qualifications are not obtainable [n]\n",
  "PROGYMNASIUM": "in Germany, a gymnasium for pupils up to age 16 only, at which university entrance qualifications are not obtainable [n PROGYMNASIA or PROGYMNASIUMS]\n",
  "PROGYMNASIUMS": "PROGYMNASIUM, in Germany, a gymnasium for pupils up to age 16 only, at which university entrance qualifications are not obtainable [n]\n",
  "PROHIBIT": "to forbid with authority [v -ED, -ING, -S]\n",
  "PROHIBITED": "PROHIBIT, to forbid with authority [v]\n",
  "PROHIBITER": "one who prohibits, also PROHIBITOR [n -S]\n",
  "PROHIBITERS": "PROHIBITER, one who prohibits, also PROHIBITOR [n]\n",
  "PROHIBITING": "PROHIBIT, to forbid with authority [v]\n",
  "PROHIBITION": "the act of prohibiting [n -S]\n",
  "PROHIBITIONARY": "serving to prohibit [adj]\n",
  "PROHIBITIONISM": "support for prohibition [n -S]\n",
  "PROHIBITIONISMS": "PROHIBITIONISM, support for prohibition [n]\n",
  "PROHIBITIONIST": "one who favors prohibition [n -S]\n",
  "PROHIBITIONISTS": "PROHIBITIONIST, one who favors prohibition [n]\n",
  "PROHIBITIONS": "PROHIBITION, the act of prohibiting [n]\n",
  "PROHIBITIVE": "tending to prohibit or restrain [adj PROHIBITIVELY]\n",
  "PROHIBITIVELY": "PROHIBITIVE, tending to prohibit or restrain [adv]\n",
  "PROHIBITIVENESS": "the state of being prohibitive [n]\n",
  "PROHIBITOR": "one who prohibits, also PROHIBITER [n -S]\n",
  "PROHIBITORS": "PROHIBITOR, one who prohibits, also PROHIBITER [n]\n",
  "PROHIBITORY": "serving to prohibit [adj]\n",
  "PROHIBITS": "PROHIBIT, to forbid with authority [v]\n",
  "PROIGN": "(obsolete) to preen, prune, also PROIN, PROINE, PROYN, PROYNE [v -ED, -ING, -S]\n",
  "PROIGNED": "PROIGN, (obsolete) to preen, prune, also PROIN, PROINE, PROYN, PROYNE [v]\n",
  "PROIGNING": "PROIGN, (obsolete) to preen, prune, also PROIN, PROINE, PROYN, PROYNE [v]\n",
  "PROIGNS": "PROIGN, (obsolete) to preen, prune, also PROIN, PROINE, PROYN, PROYNE [v]\n",
  "PROIN": "(obsolete) to preen, prune, also PROIGN, PROINE, PROYN, PROYNE [v -ED, -ING, -S]\n",
  "PROINE": "(obsolete) to preen, prune, also PROIGN, PROIN, PROYN, PROYNE [v PROINED, PROINING, PROINES]\n",
  "PROINED": "PROINE, (obsolete) to preen, prune, also PROIGN, PROIN, PROYN, PROYNE [v]\n",
  "PROINES": "PROINE, (obsolete) to preen, prune, also PROIGN, PROIN, PROYN, PROYNE [v]\n",
  "PROINING": "PROINE, (obsolete) to preen, prune, also PROIGN, PROIN, PROYN, PROYNE [v]\n",
  "PROINS": "PROIN, (obsolete) to preen, prune, also PROIGN, PROINE, PROYN, PROYNE [v]\n",
  "PROINSULIN": "a single-chain polypeptidic precursor of insulin [n -S]\n",
  "PROINSULINS": "PROINSULIN, a single-chain polypeptidic precursor of insulin [n]\n",
  "PROJECT": "to extend outward [v -ED, -ING, -S]\n",
  "PROJECTABLE": "that can be projected [adj]\n",
  "PROJECTED": "PROJECT, to extend outward [v]\n",
  "PROJECTILE": "a body projected by external force and continuing in motion by its own inertia [n -S]\n",
  "PROJECTILES": "PROJECTILE, a body projected by external force and continuing in motion by its own inertia [n]\n",
  "PROJECTING": "the act of extending outwards [n -S]\n",
  "PROJECTINGS": "PROJECTING, the act of extending outwards [n]\n",
  "PROJECTION": "something which is projected [n -S]\n",
  "PROJECTIONAL": "relating to projection [adj]\n",
  "PROJECTIONIST": "one that makes projections [n -S]\n",
  "PROJECTIONISTS": "PROJECTIONIST, one that makes projections [n]\n",
  "PROJECTIONS": "PROJECTION, something which is projected [n]\n",
  "PROJECTISATION": "the direction of aid to developing countries towards a specific project, without regard to wider issues or needs, also PROJECTIZATION [n -S]\n",
  "PROJECTISATIONS": "PROJECTISATION, the direction of aid to developing countries towards a specific project, without regard to wider issues or needs, also PROJECTIZATION [n]\n",
  "PROJECTIVE": "projecting; of projection [adj PROJECTIVELY]\n",
  "PROJECTIVELY": "PROJECTIVE, projecting; of projection [adv]\n",
  "PROJECTIVITIES": "PROJECTIVITY, the state of being projective [n]\n",
  "PROJECTIVITY": "the state of being projective [n PROJECTIVITIES]\n",
  "PROJECTIZATION": "the direction of aid to developing countries towards a specific project, without regard to wider issues or needs, also PROJECTISATION [n -S]\n",
  "PROJECTIZATIONS": "PROJECTIZATION, the direction of aid to developing countries towards a specific project, without regard to wider issues or needs, also PROJECTISATION [n]\n",
  "PROJECTMENT": "a design or plan [n -S]\n",
  "PROJECTMENTS": "PROJECTMENT, a design or plan [n]\n",
  "PROJECTOR": "an apparatus for projecting, esp. an image or a beam of light [n -S]\n",
  "PROJECTORS": "PROJECTOR, an apparatus for projecting, esp. an image or a beam of light [n]\n",
  "PROJECTS": "PROJECT, to extend outward [v]\n",
  "PROJECTURE": "a jutting out beyond a surface [n -S]\n",
  "PROJECTURES": "PROJECTURE, a jutting out beyond a surface [n]\n",
  "PROJET": "(French) a draft of a proposed measure; a project [n -S]\n",
  "PROJETS": "PROJET, (French) a draft of a proposed measure; a project [n]\n",
  "PROKARYON": "the nucleus of a blue-green alga, bacterium etc., also PROCARYON [n -S]\n",
  "PROKARYONS": "PROKARYON, the nucleus of a blue-green alga, bacterium etc., also PROCARYON [n]\n",
  "PROKARYOT": "a bacterium or blue-green algae whose nucleus lacks a limiting membrane, also PROCARYOTE, PROKARYOTE [n -S]\n",
  "PROKARYOTE": "a bacterium or blue-green algae whose nucleus lacks a limiting membrane, also PROCARYOTE, PROKARYOT [n -S]\n",
  "PROKARYOTES": "PROKARYOTE, a bacterium or blue-green algae whose nucleus lacks a limiting membrane, also PROCARYOTE, PROKARYOT [n]\n",
  "PROKARYOTIC": "of or like a prokaryote [adj]\n",
  "PROKARYOTS": "PROKARYOT, a bacterium or blue-green algae whose nucleus lacks a limiting membrane, also PROCARYOTE, PROKARYOTE [n]\n",
  "PROKE": "(dialect) to poke [v PROKED, PROKING, PROKES]\n",
  "PROKED": "PROKE, (dialect) to poke [v]\n",
  "PROKER": "a poker [n -S]\n",
  "PROKERS": "PROKER, a poker [n]\n",
  "PROKES": "PROKE, (dialect) to poke [v]\n",
  "PROKING": "PROKE, (dialect) to poke [v]\n",
  "PROLABOR": "favouring organized labor, also PROLABOUR [adj]\n",
  "PROLABOUR": "favouring an organized labour movement, also PROLABOR [adj]\n",
  "PROLACTIN": "a hormone produced by the pituitary gland [n -S]\n",
  "PROLACTINS": "PROLACTIN, a hormone produced by the pituitary gland [n]\n",
  "PROLAMIN": "one of a group of proteins found in wheat and rye, also PROLAMINE [n -S]\n",
  "PROLAMINE": "one of a group of proteins found in wheat and rye, also PROLAMIN [n -S]\n",
  "PROLAMINES": "PROLAMINE, one of a group of proteins found in wheat and rye, also PROLAMIN [n]\n",
  "PROLAMINS": "PROLAMIN, one of a group of proteins found in wheat and rye, also PROLAMINE [n]\n",
  "PROLAN": "a gonadotropic hormone used to test for cyesis (pregnancy) [n -S]\n",
  "PROLANS": "PROLAN, a gonadotropic hormone used to test for cyesis (pregnancy) [n]\n",
  "PROLAPSE": "to slip or fall out of place [v PROLAPSED, PROLAPSING, PROLAPSES]\n",
  "PROLAPSED": "PROLAPSE, to slip or fall out of place [v]\n",
  "PROLAPSES": "PROLAPSE, to slip or fall out of place [v]\n",
  "PROLAPSING": "PROLAPSE, to slip or fall out of place [v]\n",
  "PROLAPSUS": "(Latin) a prolapse [n -ES]\n",
  "PROLAPSUSES": "PROLAPSUS, (Latin) a prolapse [n]\n",
  "PROLATE": "having flattened sides due to lengthwise elongation [adj PROLATELY] / to lengthen out in utterance [v PROLATED, PROLATING, PROLATES]\n",
  "PROLATED": "PROLATE, to lengthen out in utterance [v]\n",
  "PROLATELY": "PROLATE, having flattened sides due to lengthwise elongation [adv]\n",
  "PROLATENESS": "the state of being prolate [n -ES]\n",
  "PROLATENESSES": "PROLATENESS, the state of being prolate [n]\n",
  "PROLATES": "PROLATE, to lengthen out in utterance [v]\n",
  "PROLATING": "PROLATE, to lengthen out in utterance [v]\n",
  "PROLATION": "an utterance; the time-ratio of a semibreve to a minim [n -S]\n",
  "PROLATIONS": "PROLATION, an utterance; the time-ratio of a semibreve to a minim [n]\n",
  "PROLATIVE": "esp. of an infinitive, serving to continue or complete a predication [adj]\n",
  "PROLE": "to prowl, also PROLL, PROUL [v PROLED, PROLING, PROLES]\n",
  "PROLED": "PROLE, to prowl, also PROLL, PROUL [v]\n",
  "PROLEG": "an abdominal leg of certain insect larvae [n -S]\n",
  "PROLEGOMENA": "PROLEGOMENON, prefatory remarks; specifically, a formal essay or critical discussion serving to introduce and interpret an extended work [n]\n",
  "PROLEGOMENAL": "of the nature of a prolegomenon, introduction, also PROLEGOMENARY, PROLEGOMENOUS [adj]\n",
  "PROLEGOMENARY": "of the nature of a prolegomenon, introductory, also PROLEGOMENAL, PROLEGOMENOUS [adj]\n",
  "PROLEGOMENON": "prefatory remarks; specifically, a formal essay or critical discussion serving to introduce and interpret an extended work [n PROLEGOMENA]\n",
  "PROLEGOMENOUS": "of the nature of a prolegomenon, introduction, also PROLEGOMENAL, PROLEGOMENARY [adj]\n",
  "PROLEGS": "PROLEG, an abdominal leg of certain insect larvae [n]\n",
  "PROLEPSES": "PROLEPSIS, (Greek) a rhetorical device of weakening objections by anticipating them [n]\n",
  "PROLEPSIS": "(Greek) a rhetorical device of weakening objections by anticipating them [n PROLEPSES]\n",
  "PROLEPTIC": "relating to prolepsis, also PROLEPTICAL [adj PROLEPTICALLY]\n",
  "PROLEPTICAL": "relating to prolepsis, also PROLEPTIC [adj PROLEPTICALLY]\n",
  "PROLEPTICALLY": "PROLEPTICAL, relating to prolepsis, also PROLEPTIC [adv]\n",
  "PROLER": "(obsolete) a prowler, also PROLLER, PROULER [n -S]\n",
  "PROLERS": "PROLER, (obsolete) a prowler, also PROLLER, PROULER [n]\n",
  "PROLES": "PROLE, to prowl, also PROLL, PROUL [v]\n",
  "PROLETARIAN": "a member of the proletariat, also PROLETARY [n -S]\n",
  "PROLETARIANISE": "to make proletarian, also PROLETARIANIZE [v PROLETARIANISED, PROLETARIANISES]\n",
  "PROLETARIANISED": "PROLETARIANISE, to make proletarian, also PROLETARIANIZE [v]\n",
  "PROLETARIANISES": "PROLETARIANISE, to make proletarian, also PROLETARIANIZE [v]\n",
  "PROLETARIANISM": "belief in the proletariat [n -S]\n",
  "PROLETARIANISMS": "PROLETARIANISM, belief in the proletariat [n]\n",
  "PROLETARIANIZE": "to reduce to a proletarian status or level, also PROLETARIANISE [v PROLETARIANIZED, PROLETARIANIZES]\n",
  "PROLETARIANIZED": "PROLETARIANIZE, to reduce to a proletarian status or level, also PROLETARIANISE [v]\n",
  "PROLETARIANIZES": "PROLETARIANIZE, to reduce to a proletarian status or level, also PROLETARIANISE [v]\n",
  "PROLETARIANNESS": "the state of being proletarian [n]\n",
  "PROLETARIANS": "PROLETARIAN, a member of the proletariat, also PROLETARY [n]\n",
  "PROLETARIAT": "the laboring class, also PROLETARIATE [n -S]\n",
  "PROLETARIATE": "the poorest labouring class; the wage-earning class, esp. those without capital, also PROLETARIAT [n -S]\n",
  "PROLETARIATES": "PROLETARIATE, the poorest labouring class; the wage-earning class, esp. those without capital, also PROLETARIAT [n]\n",
  "PROLETARIATS": "PROLETARIAT, the laboring class, also PROLETARIATE [n]\n",
  "PROLETARIES": "PROLETARY, a proletarian, also PROLETARIAN [n]\n",
  "PROLETARY": "a proletarian, also PROLETARIAN [n PROLETARIES]\n",
  "PROLICIDAL": "relating to prolicide, the killing of offspring [adj]\n",
  "PROLICIDE": "killing of offspring; killing of the human race [n -S]\n",
  "PROLICIDES": "PROLICIDE, killing of offspring; killing of the human race [n]\n",
  "PROLIFERATE": "to grow or increase in number rapidly [v PROLIFERATED, PROLIFERATING, PROLIFERATES]\n",
  "PROLIFERATED": "PROLIFERATE, to grow or increase in number rapidly [v]\n",
  "PROLIFERATES": "PROLIFERATE, to grow or increase in number rapidly [v]\n",
  "PROLIFERATING": "PROLIFERATE, to grow or increase in number rapidly [v]\n",
  "PROLIFERATION": "a rapid increase in number [n -S]\n",
  "PROLIFERATIONS": "PROLIFERATION, a rapid increase in number [n]\n",
  "PROLIFERATIVE": "tending to proliferate [adj]\n",
  "PROLIFEROUS": "producing buds and/or new plants vegetatively [adj PROLIFEROUSLY]\n",
  "PROLIFEROUSLY": "PROLIFEROUS, producing buds and/or new plants vegetatively [adv]\n",
  "PROLIFIC": "producing abundantly [adj PROLIFICALLY]\n",
  "PROLIFICACIES": "PROLIFICACY, the state of being prolific, also PROLIFICITY [n]\n",
  "PROLIFICACY": "the state of being prolific, also PROLIFICITY [n PROLIFICACIES]\n",
  "PROLIFICAL": "producing young or fruit abundantly [adj PROLIFICALLY]\n",
  "PROLIFICALLY": "PROLIFICAL, producing young or fruit abundantly [adv]\n",
  "PROLIFICATION": "the production of young; development of a shoot by continued growth of a flower [n -S]\n",
  "PROLIFICATIONS": "PROLIFICATION, the production of young; development of a shoot by continued growth of a flower [n]\n",
  "PROLIFICITIES": "PROLIFICITY, the state of being prolific, also PROLIFICACY [n]\n",
  "PROLIFICITY": "the state of being prolific, also PROLIFICACY [n PROLIFICITIES]\n",
  "PROLIFICNESS": "the state of being prolific [n -ES]\n",
  "PROLIFICNESSES": "PROLIFICNESS, the state of being prolific [n]\n",
  "PROLINE": "an amino acid commonly occurring in proteins [n -S]\n",
  "PROLINES": "PROLINE, an amino acid commonly occurring in proteins [n]\n",
  "PROLING": "PROLE, to prowl, also PROLL, PROUL [v]\n",
  "PROLIX": "tediously long and wordy [adj PROLIXLY]\n",
  "PROLIXIOUS": "(Shakespeare) dilatory; tedious; superfluous [adj]\n",
  "PROLIXITIES": "PROLIXITY, the state of being long-winded in speech or writing [n]\n",
  "PROLIXITY": "the state of being long-winded in speech or writing [n PROLIXITIES]\n",
  "PROLIXLY": "PROLIX, tediously long and wordy [adv]\n",
  "PROLIXNESS": "the state of being prolix [n -ES]\n",
  "PROLIXNESSES": "PROLIXNESS, the state of being prolix [n]\n",
  "PROLL": "(obsolete) to prowl, also PROLE, PROUL [v -ED, -ING, -S]\n",
  "PROLLED": "PROLL, (obsolete) to prowl, also PROLE, PROUL [v]\n",
  "PROLLER": "(obsolete) a prowler, also PROLER, PROULER [n -S]\n",
  "PROLLERS": "PROLLER, (obsolete) a prowler, also PROLER, PROULER [n]\n",
  "PROLLING": "PROLL, (obsolete) to prowl, also PROLE, PROUL [v]\n",
  "PROLLS": "PROLL, (obsolete) to prowl, also PROLE, PROUL [v]\n",
  "PROLLY": "(colloquial) probably [adv]\n",
  "PROLOCUTION": "an introductory speech or saying [n -S]\n",
  "PROLOCUTIONS": "PROLOCUTION, an introductory speech or saying [n]\n",
  "PROLOCUTOR": "a presiding officer; a chairman, esp. of the lower house of Convocation [n -S]\n",
  "PROLOCUTORS": "PROLOCUTOR, a presiding officer; a chairman, esp. of the lower house of Convocation [n]\n",
  "PROLOCUTORSHIP": "the office of a prolocutor, a spokesman [n -S]\n",
  "PROLOCUTORSHIPS": "PROLOCUTORSHIP, the office of a prolocutor, a spokesman [n]\n",
  "PROLOCUTRICES": "PROLOCUTRIX, a spokesman, a chairwoman, esp. of the lower house of Convocation [n]\n",
  "PROLOCUTRIX": "a spokesman, a chairwoman, esp. of the lower house of Convocation [n PROLOCUTRICES]\n",
  "PROLOCUTRIXES": "PROLOCUTRIX, a spokesman, a chairwoman, esp. of the lower house of Convocation [n]\n",
  "PROLOG": "to preface, also PROLOGUE [v -ED, -ING, -S]\n",
  "PROLOGED": "PROLOG, to preface, also PROLOGUE [v]\n",
  "PROLOGING": "PROLOG, to preface, also PROLOGUE [v]\n",
  "PROLOGISE": "to speak a prolog, also PROLOGIZE, PROLOGUISE, PROLOGUIZE [v PROLOGISED, PROLOGISING, PROLOGISES]\n",
  "PROLOGISED": "PROLOGISE, to speak a prolog, also PROLOGIZE, PROLOGUISE, PROLOGUIZE [v]\n",
  "PROLOGISES": "PROLOGISE, to speak a prolog, also PROLOGIZE, PROLOGUISE, PROLOGUIZE [v]\n",
  "PROLOGISING": "PROLOGISE, to speak a prolog, also PROLOGIZE, PROLOGUISE, PROLOGUIZE [v]\n",
  "PROLOGIST": "a writer of prologues [n -S]\n",
  "PROLOGISTS": "PROLOGIST, a writer of prologues [n]\n",
  "PROLOGIZE": "to speak a prolog, also PROLOGISE, PROLOGUISE, PROLOGUIZE [v PROLOGIZED, PROLOGIZING, PROLOGIZES]\n",
  "PROLOGIZED": "PROLOGIZE, to speak a prolog, also PROLOGISE, PROLOGUISE, PROLOGUIZE [v]\n",
  "PROLOGIZES": "PROLOGIZE, to speak a prolog, also PROLOGISE, PROLOGUISE, PROLOGUIZE [v]\n",
  "PROLOGIZING": "PROLOGIZE, to speak a prolog, also PROLOGISE, PROLOGUISE, PROLOGUIZE [v]\n",
  "PROLOGS": "PROLOG, to preface, also PROLOGUE [v]\n",
  "PROLOGUE": "to preface, also PROLOG [v PROLOGUED, PROLOGUING, PROLOGUES]\n",
  "PROLOGUED": "PROLOGUE, to preface, also PROLOG [v]\n",
  "PROLOGUES": "PROLOGUE, to preface, also PROLOG [v]\n",
  "PROLOGUING": "PROLOGUE, to preface, also PROLOG [v]\n",
  "PROLOGUISE": "to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUIZE [v PROLOGUISED, PROLOGUISING, PROLOGUISES]\n",
  "PROLOGUISED": "PROLOGUISE, to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUIZE [v]\n",
  "PROLOGUISES": "PROLOGUISE, to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUIZE [v]\n",
  "PROLOGUISING": "PROLOGUISE, to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUIZE [v]\n",
  "PROLOGUIZE": "to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUISE [v PROLOGUIZED, PROLOGUIZING, PROLOGUIZES]\n",
  "PROLOGUIZED": "PROLOGUIZE, to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUISE [v]\n",
  "PROLOGUIZES": "PROLOGUIZE, to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUISE [v]\n",
  "PROLOGUIZING": "PROLOGUIZE, to speak a prologue, also PROLOGISE, PROLOGIZE, PROLOGUISE [v]\n",
  "PROLONG": "to lengthen in duration [v -ED, -ING, -S]\n",
  "PROLONGABLE": "that can be prolonged [adj]\n",
  "PROLONGATE": "to prolong [v PROLONGATED, PROLONGATING, PROLONGATES]\n",
  "PROLONGATED": "PROLONGATE, to prolong [v]\n",
  "PROLONGATES": "PROLONGATE, to prolong [v]\n",
  "PROLONGATING": "PROLONGATE, to prolong [v]\n",
  "PROLONGATION": "the act of prolonging [n -S]\n",
  "PROLONGATIONS": "PROLONGATION, the act of prolonging [n]\n",
  "PROLONGE": "(French) a rope used for pulling a gun carriage [n -S]\n",
  "PROLONGED": "PROLONG, to lengthen in duration [v]\n",
  "PROLONGER": "one who, or that which, causes an extension in time or space [n -S]\n",
  "PROLONGERS": "PROLONGER, one who, or that which, causes an extension in time or space [n]\n",
  "PROLONGES": "PROLONGE, (French) a rope used for pulling a gun carriage [n]\n",
  "PROLONGING": "PROLONG, to lengthen in duration [v]\n",
  "PROLONGMENT": "the act of prolonging [n -S]\n",
  "PROLONGMENTS": "PROLONGMENT, the act of prolonging [n]\n",
  "PROLONGS": "PROLONG, to lengthen in duration [v]\n",
  "PROLUSION": "preliminary performance, activity or display [n -S]\n",
  "PROLUSIONS": "PROLUSION, preliminary performance, activity or display [n]\n",
  "PROLUSORY": "relating to prolusion, preliminary [adj]\n",
  "PROM": "a school or college dance [n -S]\n",
  "PROMACHOS": "(Greek) a champion or defender; a tutelary god [n -ES]\n",
  "PROMACHOSES": "PROMACHOS, (Greek) a champion or defender; a tutelary god [n]\n",
  "PROMENADE": "(French) a walk for pleasure, display, or exercise [n -S] / to take a promenade [v PROMENADED, PROMENADING, PROMENADES]\n",
  "PROMENADED": "PROMENADE, to take a promenade [v]\n",
  "PROMENADER": "one who promenades [n -S]\n",
  "PROMENADERS": "PROMENADER, one who promenades [n]\n",
  "PROMENADES": "PROMENADE, to take a promenade [v]\n",
  "PROMENADING": "PROMENADE, to take a promenade [v]\n",
  "PROMETAL": "a kind of cast-iron highly resistant to heat [n -S]\n",
  "PROMETALS": "PROMETAL, a kind of cast-iron highly resistant to heat [n]\n",
  "PROMETHAZINE": "a bitter-tasting phenothiazine derivative, related to chlorpromazine, used as an antihistamine, anti-emetic, and sedative [n -S]\n",
  "PROMETHAZINES": "PROMETHAZINE, a bitter-tasting phenothiazine derivative, related to chlorpromazine, used as an antihistamine, anti-emetic, and sedative [n]\n",
  "PROMETHEUM": "the former name of promethium, a radioactive element, also PROMETHIUM [n -S]\n",
  "PROMETHEUMS": "PROMETHEUM, the former name of promethium, a radioactive element, also PROMETHIUM [n]\n",
  "PROMETHIUM": "a radioactive rare-earth element, also PROMETHEUM [n -S]\n",
  "PROMETHIUMS": "PROMETHIUM, a radioactive rare-earth element, also PROMETHEUM [n]\n",
  "PROMETRIC": "in favour of the metric system [adj]\n",
  "PROMILITARY": "in favour of the military [adj]\n",
  "PROMINE": "a substance that promotes growth [n -S]\n",
  "PROMINENCE": "something prominent, also PROMINENCY [n -S]\n",
  "PROMINENCES": "PROMINENCE, something prominent, also PROMINENCY [n]\n",
  "PROMINENCIES": "PROMINENCY, the state of being prominent, also PROMINENCE [n]\n",
  "PROMINENCY": "the state of being prominent, also PROMINENCE [n PROMINENCIES]\n",
  "PROMINENT": "standing out, projecting [adj PROMINENTLY] / a stout drab-coloured moth with tufts on the forewings which stick up while at rest, the caterpillars of which typically have fleshy growths on the back [n -S]\n",
  "PROMINENTLY": "PROMINENT, standing out, projecting [adv]\n",
  "PROMINENTNESS": "the state of being prominent [n -ES]\n",
  "PROMINENTNESSES": "PROMINENTNESS, the state of being prominent [n]\n",
  "PROMINENTS": "PROMINENT, a stout drab-coloured moth with tufts on the forewings which stick up while at rest, the caterpillars of which typically have fleshy growths on the back [n]\n",
  "PROMINES": "PROMINE, a substance that promotes growth [n]\n",
  "PROMISCUITIES": "PROMISCUITY, miscellaneous mingling or selection of persons or things [n]\n",
  "PROMISCUITY": "miscellaneous mingling or selection of persons or things [n PROMISCUITIES]\n",
  "PROMISCUOUS": "composed of all sorts of persons or things [adj PROMISCUOUSLY]\n",
  "PROMISCUOUSLY": "PROMISCUOUS, composed of all sorts of persons or things [adv]\n",
  "PROMISCUOUSNESS": "the state of being promiscuous [n]\n",
  "PROMISE": "to make a declaration of assurance [v PROMISED, PROMISING, PROMISES]\n",
  "PROMISED": "PROMISE, to make a declaration of assurance [v]\n",
  "PROMISEE": "one who is promised something [n -S]\n",
  "PROMISEES": "PROMISEE, one who is promised something [n]\n",
  "PROMISEFUL": "full of promise [adj]\n",
  "PROMISELESS": "without a promise [adj]\n",
  "PROMISER": "one who promises, also PROMISOR, PROMISSOR [n -S]\n",
  "PROMISERS": "PROMISER, one who promises, also PROMISOR, PROMISSOR [n]\n",
  "PROMISES": "PROMISE, to make a declaration of assurance [v]\n",
  "PROMISING": "PROMISE, to make a declaration of assurance [v]\n",
  "PROMISINGLY": "PROMISING, PROMISE, to make a declaration of assurance [adv]\n",
  "PROMISOR": "one who promises, also PROMISER, PROMISSOR [n -S]\n",
  "PROMISORS": "PROMISOR, one who promises, also PROMISER, PROMISSOR [n]\n",
  "PROMISSIVE": "making a promise [adj]\n",
  "PROMISSOR": "one who makes a (legal) promise, also PROMISER, PROMISOR [n -S]\n",
  "PROMISSORILY": "PROMISSORY, containing a promise or binding declaration of something to be done or forborne [adv]\n",
  "PROMISSORS": "PROMISSOR, one who makes a (legal) promise, also PROMISER, PROMISOR [n]\n",
  "PROMISSORY": "containing a promise or binding declaration of something to be done or forborne [adj PROMISSORILY]\n",
  "PROMMER": "an attender of promenade concerts [n -S]\n",
  "PROMMERS": "PROMMER, an attender of promenade concerts [n]\n",
  "PROMO": "(short for) a promotional presentation [n -S] / to give a promo [v -ED, -ING, -S]\n",
  "PROMODERN": "in favour of the modern [adj]\n",
  "PROMOED": "PROMO, to give a promo [v]\n",
  "PROMOING": "PROMO, to give a promo [v]\n",
  "PROMONARCHIST": "in favour of monarchy [adj]\n",
  "PROMONTORIES": "PROMONTORY, a high point of land or rock projecting into a body of water [n]\n",
  "PROMONTORY": "a high point of land or rock projecting into a body of water [n PROMONTORIES]\n",
  "PROMOS": "PROMO, to give a promo [v]\n",
  "PROMOTABILITIES": "PROMOTABILITY, the state of being promotable [n]\n",
  "PROMOTABILITY": "the state of being promotable [n PROMOTABILITIES]\n",
  "PROMOTABLE": "that can be promoted [adj]\n",
  "PROMOTE": "to help forward [v PROMOTED, PROMOTING, PROMOTES]\n",
  "PROMOTED": "PROMOTE, to help forward [v]\n",
  "PROMOTER": "one who promotes [n -S]\n",
  "PROMOTERS": "PROMOTER, one who promotes [n]\n",
  "PROMOTES": "PROMOTE, to help forward [v]\n",
  "PROMOTING": "PROMOTE, to help forward [v]\n",
  "PROMOTION": "the act of promoting [n -S]\n",
  "PROMOTIONAL": "serving to promote [adj]\n",
  "PROMOTIONS": "PROMOTION, the act of promoting [n]\n",
  "PROMOTIVE": "tending to advance, promote, or encourage [adj]\n",
  "PROMOTIVENESS": "the state of being promotive [n -ES]\n",
  "PROMOTIVENESSES": "PROMOTIVENESS, the state of being promotive [n]\n",
  "PROMOTOR": "a person who presents candidates for graduation [n -S]\n",
  "PROMOTORS": "PROMOTOR, a person who presents candidates for graduation [n]\n",
  "PROMPT": "done without delay [adj PROMPTER, PROMPTEST, PROMPTLY] / to move to action [v -ED, -ING, -S]\n",
  "PROMPTBOOK": "a copy of a play for a prompter [n -S]\n",
  "PROMPTBOOKS": "PROMPTBOOK, a copy of a play for a prompter [n]\n",
  "PROMPTED": "PROMPT, to move to action [v]\n",
  "PROMPTER": "one that prompts [n -S]\n",
  "PROMPTERS": "PROMPTER, one that prompts [n]\n",
  "PROMPTEST": "PROMPT, done without delay [adj]\n",
  "PROMPTING": "the act of supplying a prompt [n -S]\n",
  "PROMPTINGS": "PROMPTING, the act of supplying a prompt [n]\n",
  "PROMPTITUDE": "the quality or habit of being prompt [n -S]\n",
  "PROMPTITUDES": "PROMPTITUDE, the quality or habit of being prompt [n]\n",
  "PROMPTLY": "PROMPT, done without delay [adv]\n",
  "PROMPTNESS": "the state of being prompt [n -ES]\n",
  "PROMPTNESSES": "PROMPTNESS, the state of being prompt [n]\n",
  "PROMPTS": "PROMPT, to move to action [v]\n",
  "PROMPTUARIES": "PROMPTUARY, a repository; a reference book of facts [n]\n",
  "PROMPTUARY": "a repository; a reference book of facts [n PROMPTUARIES]\n",
  "PROMPTURE": "(Shakespeare) a suggestion [n -S]\n",
  "PROMPTURES": "PROMPTURE, (Shakespeare) a suggestion [n]\n",
  "PROMS": "PROM, a school or college dance [n]\n",
  "PROMULGATE": "to make known, disseminate, also PROMULGE [v PROMULGATED, PROMULGATING, PROMULGATES]\n",
  "PROMULGATED": "PROMULGATE, to make known, disseminate, also PROMULGE [v]\n",
  "PROMULGATES": "PROMULGATE, to make known, disseminate, also PROMULGE [v]\n",
  "PROMULGATING": "PROMULGATE, to make known, disseminate, also PROMULGE [v]\n",
  "PROMULGATION": "the act of promulgating [n -S]\n",
  "PROMULGATIONS": "PROMULGATION, the act of promulgating [n]\n",
  "PROMULGATOR": "one who promulgates [n -S]\n",
  "PROMULGATORS": "PROMULGATOR, one who promulgates [n]\n",
  "PROMULGE": "(archaic) to proclaim or announce publicly, also PROMULGATE [v PROMULGED, PROMULGING, PROMULGES]\n",
  "PROMULGED": "PROMULGE, (archaic) to proclaim or announce publicly, also PROMULGATE [v]\n",
  "PROMULGES": "PROMULGE, (archaic) to proclaim or announce publicly, also PROMULGATE [v]\n",
  "PROMULGING": "PROMULGE, (archaic) to proclaim or announce publicly, also PROMULGATE [v]\n",
  "PROMUSCES": "PROMUSCIS, a proboscis, esp. an insect's [n]\n",
  "PROMUSCIDATE": "like or having a promuscis [adj]\n",
  "PROMUSCIDES": "PROMUSCIS, a proboscis, esp. an insect's [n]\n",
  "PROMUSCIS": "a proboscis, esp. an insect's [n PROMUSCES or PROMUSCIDES]\n",
  "PROMYCELIA": "PROMYCELIUM, a short germ-tube put out by some fungal spores [n]\n",
  "PROMYCELIAL": "like a promycelium, a short germ-tube put out by some fungal spores [adj]\n",
  "PROMYCELIUM": "a short germ-tube put out by some fungal spores [n PROMYCELIA]\n",
  "PRONAOI": "PRONAOS, (Greek) a vestibule in front of a temple [n]\n",
  "PRONAOS": "(Greek) a vestibule in front of a temple [n PRONAOI]\n",
  "PRONATE": "to turn the palm downward or backward [v PRONATED, PRONATING, PRONATES]\n",
  "PRONATED": "PRONATE, to turn the palm downward or backward [v]\n",
  "PRONATES": "PRONATE, to turn the palm downward or backward [v]\n",
  "PRONATING": "PRONATE, to turn the palm downward or backward [v]\n",
  "PRONATION": "turning the hand and forearm so that palm faces downward [n -S]\n",
  "PRONATIONS": "PRONATION, turning the hand and forearm so that palm faces downward [n]\n",
  "PRONATOR": "a forearm or forelimb muscle [n -S]\n",
  "PRONATORES": "PRONATOR, a forearm or forelimb muscle [n]\n",
  "PRONATORS": "PRONATOR, a forearm or forelimb muscle [n]\n",
  "PRONE": "lying face down [adj PRONER, PRONEST, PRONELY] / (obsolete) a place in a church where intimations are given out [n -S]\n",
  "PRONELY": "PRONE, lying face down [adv]\n",
  "PRONENESS": "the state of being prone [n -ES]\n",
  "PRONENESSES": "PRONENESS, the state of being prone [n]\n",
  "PRONEPHRA": "PRONEPHROS, a primitive kidney that disappears early in embryonic development [n]\n",
  "PRONEPHRIC": "of or pertaining to the pronephros [adj]\n",
  "PRONEPHROI": "PRONEPHROS, a primitive kidney that disappears early in embryonic development [n]\n",
  "PRONEPHROS": "a primitive kidney that disappears early in embryonic development [n PRONEPHROSES, PRONEPHRA or PRONEPHROI]\n",
  "PRONEPHROSES": "PRONEPHROS, a primitive kidney that disappears early in embryonic development [n]\n",
  "PRONER": "PRONE, lying face down [adj]\n",
  "PRONES": "PRONE, (obsolete) a place in a church where intimations are given out [n]\n",
  "PRONEST": "PRONE, lying face down [adj]\n",
  "PRONEUR": "(French) a flatterer [n -S]\n",
  "PRONEURS": "PRONEUR, (French) a flatterer [n]\n",
  "PRONG": "to pierce with a pointed object [v -ED, -ING, -S]\n",
  "PRONGBUCK": "the springbuck [n -S]\n",
  "PRONGBUCKS": "PRONGBUCK, the springbuck [n]\n",
  "PRONGED": "PRONG, to pierce with a pointed object [v]\n",
  "PRONGHORN": "a North American ruminant, the sole member of the family Antilocapridae, resembling an antelope but having deciduous hooked horns in the male [n -S]\n",
  "PRONGHORNS": "PRONGHORN, a North American ruminant, the sole member of the family Antilocapridae, resembling an antelope but having deciduous hooked horns in the male [n]\n",
  "PRONGING": "PRONG, to pierce with a pointed object [v]\n",
  "PRONGS": "PRONG, to pierce with a pointed object [v]\n",
  "PRONK": "(South African) of a springbok, to leap in the air [v -ED, -ING, -S]\n",
  "PRONKED": "PRONK, (South African) of a springbok, to leap in the air [v]\n",
  "PRONKING": "a springbok's leaping in the air [n -S]\n",
  "PRONKINGS": "PRONKING, a springbok's leaping in the air [n]\n",
  "PRONKS": "PRONK, (South African) of a springbok, to leap in the air [v]\n",
  "PRONOMINAL": "of or like a pronoun [adj PRONOMINALLY]\n",
  "PRONOMINALISE": "to make into or treat as a pronoun, also PRONOMINALIZE [v PRONOMINALISED, PRONOMINALISING, PRONOMINALISES]\n",
  "PRONOMINALISED": "PRONOMINALISE, to make into or treat as a pronoun, also PRONOMINALIZE [v]\n",
  "PRONOMINALISES": "PRONOMINALISE, to make into or treat as a pronoun, also PRONOMINALIZE [v]\n",
  "PRONOMINALISING": "PRONOMINALISE, to make into or treat as a pronoun, also PRONOMINALIZE [v]\n",
  "PRONOMINALIZE": "to make into or treat as a pronoun, also PRONOMINALISE [v PRONOMINALIZED, PRONOMINALIZING, PRONOMINALIZES]\n",
  "PRONOMINALIZED": "PRONOMINALIZE, to make into or treat as a pronoun, also PRONOMINALISE [v]\n",
  "PRONOMINALIZES": "PRONOMINALIZE, to make into or treat as a pronoun, also PRONOMINALISE [v]\n",
  "PRONOMINALIZING": "PRONOMINALIZE, to make into or treat as a pronoun, also PRONOMINALISE [v]\n",
  "PRONOMINALLY": "PRONOMINAL, of or like a pronoun [adv]\n",
  "PRONOTA": "PRONOTUM, a hard outer plate of an insect [n]\n",
  "PRONOTAL": "pertaining to the pronotum [adj]\n",
  "PRONOTUM": "a hard outer plate of an insect [n PRONOTA]\n",
  "PRONOUN": "a word that may be used in place of a noun [n -S]\n",
  "PRONOUNCE": "to articulate one's words [v PRONOUNCED, PRONOUNCING, PRONOUNCES]\n",
  "PRONOUNCEABLE": "capable of being pronounced [adj]\n",
  "PRONOUNCED": "strongly marked; unequivocal [adj PRONOUNCEDLY]\n",
  "PRONOUNCEDLY": "PRONOUNCED, strongly marked; unequivocal [adv]\n",
  "PRONOUNCEMENT": "a statement [n -S]\n",
  "PRONOUNCEMENTS": "PRONOUNCEMENT, a statement [n]\n",
  "PRONOUNCER": "one who pronounces [n -S]\n",
  "PRONOUNCERS": "PRONOUNCER, one who pronounces [n]\n",
  "PRONOUNCES": "PRONOUNCE, to articulate one's words [v]\n",
  "PRONOUNCING": "the act of pronunciation [n -S]\n",
  "PRONOUNCINGS": "PRONOUNCING, the act of pronunciation [n]\n",
  "PRONOUNS": "PRONOUN, a word that may be used in place of a noun [n]\n",
  "PRONTO": "(Italian) promptly, quickly [adv]\n",
  "PRONUCLEAR": "relating to a pronucleus [adj]\n",
  "PRONUCLEARIST": "one in favour of nuclear energy [n -S]\n",
  "PRONUCLEARISTS": "PRONUCLEARIST, one in favour of nuclear energy [n]\n",
  "PRONUCLEI": "PRONUCLEUS, the nucleus of a germ-cell after meiosis and before fertilization [n]\n",
  "PRONUCLEUS": "the nucleus of a germ-cell after meiosis and before fertilization [n PRONUCLEI or PRONUCLEUSES]\n",
  "PRONUCLEUSES": "PRONUCLEUS, the nucleus of a germ-cell after meiosis and before fertilization [n]\n",
  "PRONUNCIAMENTO": "an official or authoritarian declaration; a proclamation or an edict [n -S]\n",
  "PRONUNCIAMENTOS": "PRONUNCIAMENTO, an official or authoritarian declaration; a proclamation or an edict [n]\n",
  "PRONUNCIATION": "the act or manner of pronouncing something [n -S]\n",
  "PRONUNCIATIONAL": "relating to pronunciation [adj]\n",
  "PRONUNCIATIONS": "PRONUNCIATION, the act or manner of pronouncing something [n]\n",
  "PRONUNCIO": "a papal ambassador of lower status than a nuncio [n -S]\n",
  "PRONUNCIOS": "PRONUNCIO, a papal ambassador of lower status than a nuncio [n]\n",
  "PROO": "(Scots) a call to a cow to come near, also PRUH [interj]\n",
  "PROOEMION": "a preface, also PROEM, PROOEMIUM [n -S]\n",
  "PROOEMIONS": "PROOEMION, a preface, also PROEM, PROOEMIUM [n]\n",
  "PROOEMIUM": "a preface, also PROEM, PROOEMION [n -S]\n",
  "PROOEMIUMS": "PROOEMIUM, a preface, also PROEM, PROOEMION [n]\n",
  "PROOF": "to examine for errors [v -ED, -ING, -S]\n",
  "PROOFED": "PROOF, to examine for errors [v]\n",
  "PROOFER": "one who proofs [n -S]\n",
  "PROOFERS": "PROOFER, one who proofs [n]\n",
  "PROOFING": "material used to make things waterproof [n -S]\n",
  "PROOFINGS": "PROOFING, material used to make things waterproof [n]\n",
  "PROOFLESS": "wanting sufficient evidence to induce belief; not proved [adj]\n",
  "PROOFREAD": "to read checking for mistakes [v PROOFREAD, PROOFREADING, PROOFREADS]\n",
  "PROOFREADER": "a person who proofreads [n -S]\n",
  "PROOFREADERS": "PROOFREADER, a person who proofreads [n]\n",
  "PROOFREADING": "the process of reading to check for mistakes [n -S]\n",
  "PROOFREADINGS": "PROOFREADING, the process of reading to check for mistakes [n]\n",
  "PROOFREADS": "PROOFREAD, to read checking for mistakes [v]\n",
  "PROOFROOM": "a room where proofs are set up [n -S]\n",
  "PROOFROOMS": "PROOFROOM, a room where proofs are set up [n]\n",
  "PROOFS": "PROOF, to examine for errors [v]\n",
  "PROOTIC": "a bone in front of the ear [n -S]\n",
  "PROOTICS": "PROOTIC, a bone in front of the ear [n]\n",
  "PROP": "to hold up [v PROPPED, PROPPING, PROPS]\n",
  "PROPAEDEUTIC": "a preliminary study [n -S]\n",
  "PROPAEDEUTICAL": "of or like a propaedeutic, a preliminary study [adj]\n",
  "PROPAEDEUTICS": "PROPAEDEUTIC, a preliminary study [n]\n",
  "PROPAGABILITIES": "PROPAGABILITY, the quality of being propagable [n]\n",
  "PROPAGABILITY": "the quality of being propagable [n PROPAGABILITIES]\n",
  "PROPAGABLE": "capable of being propagated [adj]\n",
  "PROPAGABLENESS": "PROPAGABLE, capable of being propagated [n]\n",
  "PROPAGANDA": "a congregation of the Roman curia having jurisdiction over missionary territories and related institutions [n -S]\n",
  "PROPAGANDAS": "PROPAGANDA, a congregation of the Roman curia having jurisdiction over missionary territories and related institutions [n]\n",
  "PROPAGANDISE": "to subject to propaganda, also PROPAGANDIZE [v PROPAGANDISED, PROPAGANDISING, PROPAGANDISES]\n",
  "PROPAGANDISED": "PROPAGANDISE, to subject to propaganda, also PROPAGANDIZE [v]\n",
  "PROPAGANDISER": "one who propagandises, also PROPAGANDIZER [n -S]\n",
  "PROPAGANDISERS": "PROPAGANDISER, one who propagandises, also PROPAGANDIZER [n]\n",
  "PROPAGANDISES": "PROPAGANDISE, to subject to propaganda, also PROPAGANDIZE [v]\n",
  "PROPAGANDISING": "PROPAGANDISE, to subject to propaganda, also PROPAGANDIZE [v]\n",
  "PROPAGANDISM": "the practice of propagating tenets or principles [n -S]\n",
  "PROPAGANDISMS": "PROPAGANDISM, the practice of propagating tenets or principles [n]\n",
  "PROPAGANDIST": "one who engages in propaganda [n -S]\n",
  "PROPAGANDISTIC": "related to propaganda [adj]\n",
  "PROPAGANDISTS": "PROPAGANDIST, one who engages in propaganda [n]\n",
  "PROPAGANDIZE": "to subject to propaganda, also PROPAGANDISE [v PROPAGANDIZED, PROPAGANDIZING, PROPAGANDIZES]\n",
  "PROPAGANDIZED": "PROPAGANDIZE, to subject to propaganda, also PROPAGANDISE [v]\n",
  "PROPAGANDIZER": "one who propagandizes, also PROPAGANDISER [n -S]\n",
  "PROPAGANDIZERS": "PROPAGANDIZER, one who propagandizes, also PROPAGANDISER [n]\n",
  "PROPAGANDIZES": "PROPAGANDIZE, to subject to propaganda, also PROPAGANDISE [v]\n",
  "PROPAGANDIZING": "PROPAGANDIZE, to subject to propaganda, also PROPAGANDISE [v]\n",
  "PROPAGATE": "to increase by natural process; to multiply [v PROPAGATED, PROPAGATING, PROPAGATES]\n",
  "PROPAGATED": "PROPAGATE, to increase by natural process; to multiply [v]\n",
  "PROPAGATES": "PROPAGATE, to increase by natural process; to multiply [v]\n",
  "PROPAGATING": "PROPAGATE, to increase by natural process; to multiply [v]\n",
  "PROPAGATION": "the act of propagating [n -S]\n",
  "PROPAGATIONAL": "relating to propagation [adj]\n",
  "PROPAGATIONS": "PROPAGATION, the act of propagating [n]\n",
  "PROPAGATIVE": "serving to propagate [adj]\n",
  "PROPAGATOR": "one who propagates [n -S]\n",
  "PROPAGATORS": "PROPAGATOR, one who propagates [n]\n",
  "PROPAGE": "to propagate [v PROPAGED, PROPAGING, PROPAGES]\n",
  "PROPAGED": "PROPAGE, to propagate [v]\n",
  "PROPAGES": "PROPAGE, to propagate [v]\n",
  "PROPAGING": "PROPAGE, to propagate [v]\n",
  "PROPAGULA": "PROPAGULUM, a body with the capacity to give rise to a new plant e.g. seed, spore, bulbil, fragment etc., also PROPAGULE [n]\n",
  "PROPAGULE": "a body with the capacity to give rise to a new plant e.g. seed, spore, bulbil, fragment etc., also PROPAGULUM [n -S]\n",
  "PROPAGULES": "PROPAGULE, a body with the capacity to give rise to a new plant e.g. seed, spore, bulbil, fragment etc., also PROPAGULUM [n]\n",
  "PROPAGULUM": "a body with the capacity to give rise to a new plant e.g. seed, spore, bulbil, fragment etc., also PROPAGULE [n PROPAGULA]\n",
  "PROPALE": "(Scots) to disclose [v PROPALED, PROPALING, PROPALES]\n",
  "PROPALED": "PROPALE, (Scots) to disclose [v]\n",
  "PROPALES": "PROPALE, (Scots) to disclose [v]\n",
  "PROPALING": "PROPALE, (Scots) to disclose [v]\n",
  "PROPANE": "a flammable gas [n -S]\n",
  "PROPANEDIOIC": "as in propanedioic acid, a white crystalline acid, aka malonic acid [adj]\n",
  "PROPANES": "PROPANE, a flammable gas [n]\n",
  "PROPANOIC": "as in propanoic acid, a colourless carboxylic acid, also PROPIONIC [adj]\n",
  "PROPANOL": "propyl alcohol [n -S]\n",
  "PROPANOLS": "PROPANOL, propyl alcohol [n]\n",
  "PROPANONE": "a systematic name of acetone [n -S]\n",
  "PROPANONES": "PROPANONE, a systematic name of acetone [n]\n",
  "PROPAROXYTONE": "in ancient Greek, a word having the acute accent on the third last syllable [n -S]\n",
  "PROPAROXYTONES": "PROPAROXYTONE, in ancient Greek, a word having the acute accent on the third last syllable [n]\n",
  "PROPEL": "to drive forward [v PROPELLED, PROPELLING, PROPELS]\n",
  "PROPELLANT": "something that propels, also PROPELLENT [n -S]\n",
  "PROPELLANTS": "PROPELLANT, something that propels, also PROPELLENT [n]\n",
  "PROPELLED": "PROPEL, to drive forward [v]\n",
  "PROPELLENT": "something that propels, also PROPELLANT [n -S]\n",
  "PROPELLENTS": "PROPELLENT, something that propels, also PROPELLANT [n]\n",
  "PROPELLER": "someone who, or something which, propels, also PROPELLOR [n -S]\n",
  "PROPELLERS": "PROPELLER, someone who, or something which, propels, also PROPELLOR [n]\n",
  "PROPELLING": "the act of causing a move forward or onward [n -S]\n",
  "PROPELLINGS": "PROPELLING, the act of causing a move forward or onward [n]\n",
  "PROPELLOR": "someone who, or something which, propels, also PROPELLER [n -S]\n",
  "PROPELLORS": "PROPELLOR, someone who, or something which, propels, also PROPELLER [n]\n",
  "PROPELMENT": "propulsion; a propelling motion [n -S]\n",
  "PROPELMENTS": "PROPELMENT, propulsion; a propelling motion [n]\n",
  "PROPELS": "PROPEL, to drive forward [v]\n",
  "PROPENAL": "another name for acrolein [n -S]\n",
  "PROPENALS": "PROPENAL, another name for acrolein [n]\n",
  "PROPEND": "(Shakespeare) to have a tendency toward [v -ED, -ING, -S]\n",
  "PROPENDED": "PROPEND, (Shakespeare) to have a tendency toward [v]\n",
  "PROPENDENT": "(obsolete) inclining forward or toward [adj]\n",
  "PROPENDING": "PROPEND, (Shakespeare) to have a tendency toward [v]\n",
  "PROPENDS": "PROPEND, (Shakespeare) to have a tendency toward [v]\n",
  "PROPENE": "a flammable gas [n -S]\n",
  "PROPENES": "PROPENE, a flammable gas [n]\n",
  "PROPENOIC": "as in propenoic acid, a colourless carboxylic acid [adj]\n",
  "PROPENOL": "a flammable gas [n -S]\n",
  "PROPENOLS": "PROPENOL, a flammable gas [n]\n",
  "PROPENSE": "(obsolete) inclined [adj PROPENSELY]\n",
  "PROPENSELY": "PROPENSE, (obsolete) inclined [adv]\n",
  "PROPENSENESS": "the state of being propense [n -ES]\n",
  "PROPENSENESSES": "PROPENSENESS, the state of being propense [n]\n",
  "PROPENSION": "(Shakespeare) inclination, propensity [n -S]\n",
  "PROPENSIONS": "PROPENSION, (Shakespeare) inclination, propensity [n]\n",
  "PROPENSITIES": "PROPENSITY, an often intense natural inclination or preference [n]\n",
  "PROPENSITY": "an often intense natural inclination or preference [n PROPENSITIES]\n",
  "PROPENSIVE": "(obsolete) inclined [adj]\n",
  "PROPENYL": "a hydrocarbon radical related to propene [n -S]\n",
  "PROPENYLS": "PROPENYL, a hydrocarbon radical related to propene [n]\n",
  "PROPER": "fitting [adj PROPERER, PROPEREST, PROPERLY] / a service, psalm set apart for a particular day or occasion [n -S]\n",
  "PROPERDIN": "a natural protein in blood that helps provide immunity to infectious disease [n -S]\n",
  "PROPERDINS": "PROPERDIN, a natural protein in blood that helps provide immunity to infectious disease [n]\n",
  "PROPERER": "PROPER, fitting [adj]\n",
  "PROPEREST": "PROPER, fitting [adj]\n",
  "PROPERISPOMENA": "PROPERISPOMENON, a word with the circumflex accent on the penultimate syllable [n]\n",
  "PROPERISPOMENON": "a word with the circumflex accent on the penultimate syllable [n PROPERISPOMENA]\n",
  "PROPERLY": "PROPER, fitting [adv]\n",
  "PROPERNESS": "the state of being proper [n -ES]\n",
  "PROPERNESSES": "PROPERNESS, the state of being proper [n]\n",
  "PROPERS": "PROPER, a service, psalm set apart for a particular day or occasion [n]\n",
  "PROPERTIED": "PROPERTY, to make one's own property, appropriate, take or hold possession of [v]\n",
  "PROPERTIES": "PROPERTY, to make one's own property, appropriate, take or hold possession of [v]\n",
  "PROPERTY": "something owned [n PROPERTIES] / to make one's own property, appropriate, take or hold possession of [v PROPERTIED, PROPERTYING, PROPERTIES]\n",
  "PROPERTYING": "PROPERTY, to make one's own property, appropriate, take or hold possession of [v]\n",
  "PROPERTYLESS": "without property [adj]\n",
  "PROPHAGE": "a virus that exists in a bacterial cell and undergoes division with its host without destroying it [n -S]\n",
  "PROPHAGES": "PROPHAGE, a virus that exists in a bacterial cell and undergoes division with its host without destroying it [n]\n",
  "PROPHASE": "the first stage in cell division [n -S]\n",
  "PROPHASES": "PROPHASE, the first stage in cell division [n]\n",
  "PROPHASIC": "relating to prophase, the first stage in cell division [adj]\n",
  "PROPHECIES": "PROPHECY, a prediction [n]\n",
  "PROPHECY": "a prediction [n PROPHECIES]\n",
  "PROPHESIABLE": "that can prophesied [adj]\n",
  "PROPHESIED": "PROPHESY, to predict [v]\n",
  "PROPHESIER": "one who prophesies [n -S]\n",
  "PROPHESIERS": "PROPHESIER, one who prophesies [n]\n",
  "PROPHESIES": "PROPHESY, to predict [v]\n",
  "PROPHESY": "to predict [v PROPHESIED, PROPHESYING, PROPHESIES]\n",
  "PROPHESYING": "the act of prophesying [n -S]\n",
  "PROPHESYINGS": "PROPHESYING, the act of prophesying [n]\n",
  "PROPHET": "one who predicts [n -S]\n",
  "PROPHETESS": "a woman who is a prophet [n -ES]\n",
  "PROPHETESSES": "PROPHETESS, a woman who is a prophet [n]\n",
  "PROPHETHOOD": "the state of being a prophet [n -S]\n",
  "PROPHETHOODS": "PROPHETHOOD, the state of being a prophet [n]\n",
  "PROPHETIC": "related to prophesy, also PROPHETICAL [adj PROPHETICALLY]\n",
  "PROPHETICAL": "related to prophesy, also PROPHETIC [adj PROPHETICALLY]\n",
  "PROPHETICALLY": "PROPHETICAL, related to prophesy, also PROPHETIC [adv]\n",
  "PROPHETICISM": "being prophetic [n -S]\n",
  "PROPHETICISMS": "PROPHETICISM, being prophetic [n]\n",
  "PROPHETISM": "the actions of a prophet or prophets [n -S]\n",
  "PROPHETISMS": "PROPHETISM, the actions of a prophet or prophets [n]\n",
  "PROPHETS": "PROPHET, one who predicts [n]\n",
  "PROPHETSHIP": "the office of prophet [n -S]\n",
  "PROPHETSHIPS": "PROPHETSHIP, the office of prophet [n]\n",
  "PROPHYLACTIC": "guarding against disease [adj] / something (a drug or device) that protects from disease [n -S]\n",
  "PROPHYLACTICS": "PROPHYLACTIC, something (a drug or device) that protects from disease [n]\n",
  "PROPHYLAXES": "PROPHYLAXIS, preventive treatment against diseases, etc. [n]\n",
  "PROPHYLAXIS": "preventive treatment against diseases, etc. [n PROPHYLAXES]\n",
  "PROPHYLL": "a small leaf on the axis of a flower [n -S]\n",
  "PROPHYLLS": "PROPHYLL, a small leaf on the axis of a flower [n]\n",
  "PROPINE": "(archaic) to pledge in drinking; to present or offer [v PROPINED, PROPINING, PROPINES]\n",
  "PROPINED": "PROPINE, (archaic) to pledge in drinking; to present or offer [v]\n",
  "PROPINES": "PROPINE, (archaic) to pledge in drinking; to present or offer [v]\n",
  "PROPINING": "PROPINE, (archaic) to pledge in drinking; to present or offer [v]\n",
  "PROPINQUITIES": "PROPINQUITY, nearness in space, time or relationship [n]\n",
  "PROPINQUITY": "nearness in space, time or relationship [n PROPINQUITIES]\n",
  "PROPIONATE": "a salt of propionic acid [n -S]\n",
  "PROPIONATES": "PROPIONATE, a salt of propionic acid [n]\n",
  "PROPIONIC": "as in propionic acid, a former name of propanoic acid, also PROPANOIC [adj]\n",
  "PROPITIABLE": "that can be propitiated [adj]\n",
  "PROPITIATE": "to render favourable, to appease [v PROPITIATED, PROPITIATING, PROPITIATES]\n",
  "PROPITIATED": "PROPITIATE, to render favourable, to appease [v]\n",
  "PROPITIATES": "PROPITIATE, to render favourable, to appease [v]\n",
  "PROPITIATING": "PROPITIATE, to render favourable, to appease [v]\n",
  "PROPITIATION": "the act of propitiating [n -S]\n",
  "PROPITIATIONS": "PROPITIATION, the act of propitiating [n]\n",
  "PROPITIATIOUS": "serving to propitiate, also PROPITIATIVE, PROPITIATORY [adj]\n",
  "PROPITIATIVE": "serving to propitiate, also PROPITIATIOUS, PROPITIATORY [adj]\n",
  "PROPITIATOR": "one who propitiates [n -S]\n",
  "PROPITIATORIES": "PROPITIATORY, the mercy seat [n]\n",
  "PROPITIATORILY": "PROPITIATORY, serving to propitiate, also PROPITIATIOUS, PROPITIATIVE [adv]\n",
  "PROPITIATORS": "PROPITIATOR, one who propitiates [n]\n",
  "PROPITIATORY": "serving to propitiate, also PROPITIATIOUS, PROPITIATIVE [adj PROPITIATORILY] / the mercy seat [n PROPITIATORIES]\n",
  "PROPITIOUS": "favorably disposed, benevolent; auspicious [adj PROPITIOUSLY]\n",
  "PROPITIOUSLY": "PROPITIOUS, favorably disposed, benevolent; auspicious [adv]\n",
  "PROPITIOUSNESS": "the state of being propitious [n]\n",
  "PROPJET": "a jet aeroplane having a turbine-driven propeller [n -S]\n",
  "PROPJETS": "PROPJET, a jet aeroplane having a turbine-driven propeller [n]\n",
  "PROPLASTID": "a precursor of a cell plastid [n -S]\n",
  "PROPLASTIDS": "PROPLASTID, a precursor of a cell plastid [n]\n",
  "PROPMAN": "a man in charge of stage properties [n PROPMEN]\n",
  "PROPMEN": "PROPMAN, a man in charge of stage properties [n]\n",
  "PROPODEON": "in some Hymenoptera, the first abdominal segment, also PROPODEUM [n -S]\n",
  "PROPODEONS": "PROPODEON, in some Hymenoptera, the first abdominal segment, also PROPODEUM [n]\n",
  "PROPODEUM": "in some Hymenoptera, the first abdominal segment, also PROPODEON [n -S]\n",
  "PROPODEUMS": "PROPODEUM, in some Hymenoptera, the first abdominal segment, also PROPODEON [n]\n",
  "PROPOLIS": "(Greek) a resinous substance used as a cement by bees [n -ES]\n",
  "PROPOLISES": "PROPOLIS, (Greek) a resinous substance used as a cement by bees [n]\n",
  "PROPONE": "to propose, bring forward [v PROPONED, PROPONING, PROPONES]\n",
  "PROPONED": "PROPONE, to propose, bring forward [v]\n",
  "PROPONENT": "bringing forward, proposing [adj] / one who is making proposals [n -S]\n",
  "PROPONENTS": "PROPONENT, one who is making proposals [n]\n",
  "PROPONES": "PROPONE, to propose, bring forward [v]\n",
  "PROPONING": "PROPONE, to propose, bring forward [v]\n",
  "PROPORTION": "to adjust (a part or thing) in size relative to other parts or things [v -ED, -ING, -S]\n",
  "PROPORTIONABLE": "proportional, proportionate [adj PROPORTIONABLY]\n",
  "PROPORTIONABLY": "PROPORTIONABLE, proportional, proportionate [adv]\n",
  "PROPORTIONAL": "relating to proportion [adj PROPORTIONALLY] / a number or quantity in a proportion [n -S]\n",
  "PROPORTIONALITY": "the state of being proportional [n]\n",
  "PROPORTIONALLY": "PROPORTIONAL, relating to proportion [adv]\n",
  "PROPORTIONALS": "PROPORTIONAL, a number or quantity in a proportion [n]\n",
  "PROPORTIONATE": "in proportion [adj PROPORTIONATELY] / to make proportionate [v PROPORTIONATED, PROPORTIONATING, PROPORTIONATES]\n",
  "PROPORTIONATED": "PROPORTIONATE, to make proportionate [v]\n",
  "PROPORTIONATELY": "PROPORTIONATE, in proportion [adv]\n",
  "PROPORTIONATES": "PROPORTIONATE, to make proportionate [v]\n",
  "PROPORTIONATING": "PROPORTIONATE, to make proportionate [v]\n",
  "PROPORTIONED": "PROPORTION, to adjust (a part or thing) in size relative to other parts or things [v]\n",
  "PROPORTIONING": "an adjustment of proportions [n -S]\n",
  "PROPORTIONINGS": "PROPORTIONING, an adjustment of proportions [n]\n",
  "PROPORTIONLESS": "without proportion [adj]\n",
  "PROPORTIONMENT": "the act of proportioning [n -S]\n",
  "PROPORTIONMENTS": "PROPORTIONMENT, the act of proportioning [n]\n",
  "PROPORTIONS": "PROPORTION, to adjust (a part or thing) in size relative to other parts or things [v]\n",
  "PROPOSABLE": "that can be proposed [adj]\n",
  "PROPOSAL": "something that is proposed [n -S]\n",
  "PROPOSALS": "PROPOSAL, something that is proposed [n]\n",
  "PROPOSE": "to put forward for consideration or acceptance [v PROPOSED, PROPOSING, PROPOSES]\n",
  "PROPOSED": "PROPOSE, to put forward for consideration or acceptance [v]\n",
  "PROPOSER": "one that proposes [n -S]\n",
  "PROPOSERS": "PROPOSER, one that proposes [n]\n",
  "PROPOSES": "PROPOSE, to put forward for consideration or acceptance [v]\n",
  "PROPOSING": "PROPOSE, to put forward for consideration or acceptance [v]\n",
  "PROPOSITA": "a woman from whom a line of descent is traced [n PROPOSITAE]\n",
  "PROPOSITAE": "PROPOSITA, a woman from whom a line of descent is traced [n]\n",
  "PROPOSITI": "PROPOSITUS, (Latin) an individual to whom the family relationships of others are reckoned; specifically (a) (medicine) the first member of a family to be investigated by a researcher; (b) (law) a testator when making a will [n]\n",
  "PROPOSITION": "to make a proposal to [v -ED, -ING, -S]\n",
  "PROPOSITIONAL": "of the nature of a proposition [adj PROPOSITIONALLY]\n",
  "PROPOSITIONALLY": "PROPOSITIONAL, of the nature of a proposition [adv]\n",
  "PROPOSITIONED": "PROPOSITION, to make a proposal to [v]\n",
  "PROPOSITIONING": "PROPOSITION, to make a proposal to [v]\n",
  "PROPOSITIONS": "PROPOSITION, to make a proposal to [v]\n",
  "PROPOSITUS": "(Latin) an individual to whom the family relationships of others are reckoned; specifically (a) (medicine) the first member of a family to be investigated by a researcher; (b) (law) a testator when making a will [n PROPOSITI]\n",
  "PROPOUND": "to propose [v -ED, -ING, -S]\n",
  "PROPOUNDED": "PROPOUND, to propose [v]\n",
  "PROPOUNDER": "one who propounds [n -S]\n",
  "PROPOUNDERS": "PROPOUNDER, one who propounds [n]\n",
  "PROPOUNDING": "PROPOUND, to propose [v]\n",
  "PROPOUNDS": "PROPOUND, to propose [v]\n",
  "PROPOXYPHENE": "a narcotic analgesic structurally related to methadone but less addicting [n -S]\n",
  "PROPOXYPHENES": "PROPOXYPHENE, a narcotic analgesic structurally related to methadone but less addicting [n]\n",
  "PROPPANT": "a material, e.g. sand, used to keep open fissures in an oil-bearing sediment [n -S]\n",
  "PROPPANTS": "PROPPANT, a material, e.g. sand, used to keep open fissures in an oil-bearing sediment [n]\n",
  "PROPPED": "PROP, to hold up [v]\n",
  "PROPPING": "PROP, to hold up [v]\n",
  "PROPRAETOR": "a magistrate of ancient Rome who, after acting as praetor, was appointed to the governor of a province, also PROPRETOR [n -S]\n",
  "PROPRAETORIAL": "of or like a propraetor, also PROPRAETORIAN [adj]\n",
  "PROPRAETORIAN": "of or like a propraetor, also PROPRAETORIAL [adj]\n",
  "PROPRAETORS": "PROPRAETOR, a magistrate of ancient Rome who, after acting as praetor, was appointed to the governor of a province, also PROPRETOR [n]\n",
  "PROPRANOLOL": "a beta-blocker drug used mainly in the treatment of cardiac arrhythmia [n -S]\n",
  "PROPRANOLOLS": "PROPRANOLOL, a beta-blocker drug used mainly in the treatment of cardiac arrhythmia [n]\n",
  "PROPRETOR": "a magistrate of ancient Rome who, after acting as praetor, was appointed to the governor of a province, also PROPRAETOR [n -S]\n",
  "PROPRETORS": "PROPRETOR, a magistrate of ancient Rome who, after acting as praetor, was appointed to the governor of a province, also PROPRAETOR [n]\n",
  "PROPRIA": "PROPRIUM, an attribute belonging inseparably to every member of a species [n]\n",
  "PROPRIETARIES": "PROPRIETARY, an owner [n]\n",
  "PROPRIETARILY": "PROPRIETARY, of the nature of property [adv]\n",
  "PROPRIETARY": "of the nature of property [adj PROPRIETARILY] / an owner [n PROPRIETARIES]\n",
  "PROPRIETIES": "PROPRIETY, properness, correct behaviour [n]\n",
  "PROPRIETOR": "an owner [n -S]\n",
  "PROPRIETORIAL": "relating to ownership [adj PROPRIETORIALLY]\n",
  "PROPRIETORIALLY": "PROPRIETORIAL, relating to ownership [adv]\n",
  "PROPRIETORS": "PROPRIETOR, an owner [n]\n",
  "PROPRIETORSHIP": "the office of proprietor [n -S]\n",
  "PROPRIETORSHIPS": "PROPRIETORSHIP, the office of proprietor [n]\n",
  "PROPRIETRESS": "a woman who is a proprietor, also PROPRIETRIX [n -ES]\n",
  "PROPRIETRESSES": "PROPRIETRESS, a woman who is a proprietor, also PROPRIETRIX [n]\n",
  "PROPRIETRICES": "PROPRIETRIX, a female proprietor, also PROPRIETRESS [n]\n",
  "PROPRIETRIX": "a female proprietor, also PROPRIETRESS [n PROPRIETRICES or PROPRIETRIXES]\n",
  "PROPRIETRIXES": "PROPRIETRIX, a female proprietor, also PROPRIETRESS [n]\n",
  "PROPRIETY": "properness, correct behaviour [n PROPRIETIES]\n",
  "PROPRIOCEPTION": "the sense of muscular position [n -S]\n",
  "PROPRIOCEPTIONS": "PROPRIOCEPTION, the sense of muscular position [n]\n",
  "PROPRIOCEPTIVE": "relating to proprioception [adj]\n",
  "PROPRIOCEPTOR": "a sense organ receptive to stimuli from within the body [n -S]\n",
  "PROPRIOCEPTORS": "PROPRIOCEPTOR, a sense organ receptive to stimuli from within the body [n]\n",
  "PROPRIUM": "an attribute belonging inseparably to every member of a species [n PROPRIA]\n",
  "PROPROCTOR": "an assistant proctor [n -S]\n",
  "PROPROCTORS": "PROPROCTOR, an assistant proctor [n]\n",
  "PROPS": "PROP, to hold up [v]\n",
  "PROPTOSES": "PROPTOSIS, the forward displacement of an organ, particularly the eyeball [n]\n",
  "PROPTOSIS": "the forward displacement of an organ, particularly the eyeball [n PROPTOSES]\n",
  "PROPUGNATION": "(Shakespeare) defence [n -S]\n",
  "PROPUGNATIONS": "PROPUGNATION, (Shakespeare) defence [n]\n",
  "PROPULSION": "the act of propelling [n -S]\n",
  "PROPULSIONS": "PROPULSION, the act of propelling [n]\n",
  "PROPULSIVE": "tending or having power to propel [adj]\n",
  "PROPULSOR": "something which propels [n -S]\n",
  "PROPULSORS": "PROPULSOR, something which propels [n]\n",
  "PROPULSORY": "propulsive [adj]\n",
  "PROPYL": "a univalent radical regarded as the essential residue of propane and related compounds [n -S]\n",
  "PROPYLA": "PROPYLON, an entrance to a temple [n]\n",
  "PROPYLAEA": "PROPYLAEUM, any court or vestibule before a building or leading into any inclosure [n]\n",
  "PROPYLAEUM": "any court or vestibule before a building or leading into any inclosure [n PROPYLAEA]\n",
  "PROPYLAMINE": "an amine of propyl [n -S]\n",
  "PROPYLAMINES": "PROPYLAMINE, an amine of propyl [n]\n",
  "PROPYLENE": "a colorless gaseous hydrocarbon of the ethylene series, having a garlic odor, also PROPENE [n -S]\n",
  "PROPYLENES": "PROPYLENE, a colorless gaseous hydrocarbon of the ethylene series, having a garlic odor, also PROPENE [n]\n",
  "PROPYLIC": "pertaining to, derived from, or containing, propyl [adj]\n",
  "PROPYLITE": "an andesite altered by solfataric action [n -S]\n",
  "PROPYLITES": "PROPYLITE, an andesite altered by solfataric action [n]\n",
  "PROPYLITISATION": "the process of propylitising, also PROPYLITIZATION [n]\n",
  "PROPYLITISE": "to become or turn into propylite, also PROPYLITIZE [v PROPYLITISED, PROPYLITISING, PROPYLITISES]\n",
  "PROPYLITISED": "PROPYLITISE, to become or turn into propylite, also PROPYLITIZE [v]\n",
  "PROPYLITISES": "PROPYLITISE, to become or turn into propylite, also PROPYLITIZE [v]\n",
  "PROPYLITISING": "PROPYLITISE, to become or turn into propylite, also PROPYLITIZE [v]\n",
  "PROPYLITIZATION": "the process of propylitizing, also PROPYLITISATION [n]\n",
  "PROPYLITIZE": "to become or turn into propylite, also PROPYLITISE [v PROPYLITIZED, PROPYLITIZING, PROPYLITIZES]\n",
  "PROPYLITIZED": "PROPYLITIZE, to become or turn into propylite, also PROPYLITISE [v]\n",
  "PROPYLITIZES": "PROPYLITIZE, to become or turn into propylite, also PROPYLITISE [v]\n",
  "PROPYLITIZING": "PROPYLITIZE, to become or turn into propylite, also PROPYLITISE [v]\n",
  "PROPYLON": "an entrance to a temple [n PROPYLONS or PROPYLA]\n",
  "PROPYLONS": "PROPYLON, an entrance to a temple [n]\n",
  "PROPYLS": "PROPYL, a univalent radical regarded as the essential residue of propane and related compounds [n]\n",
  "PROPYNE": "a gaseous methyl acetylene [n -S]\n",
  "PROPYNES": "PROPYNE, a gaseous methyl acetylene [n]\n",
  "PRORATABLE": "capable of being prorated, or divided proportionately [adj]\n",
  "PRORATE": "to divide proportionately [v PRORATED, PRORATING, PRORATES]\n",
  "PRORATED": "PRORATE, to divide proportionately [v]\n",
  "PRORATES": "PRORATE, to divide proportionately [v]\n",
  "PRORATING": "PRORATE, to divide proportionately [v]\n",
  "PRORATION": "the act of prorating, sharing out [n -S]\n",
  "PRORATIONS": "PRORATION, the act of prorating, sharing out [n]\n",
  "PRORE": "a prow; a ship [n -S]\n",
  "PRORECTOR": "an officer who presides over the academic senate of a German university [n -S]\n",
  "PRORECTORS": "PRORECTOR, an officer who presides over the academic senate of a German university [n]\n",
  "PROREFORM": "in favour of reform [adj]\n",
  "PRORES": "PRORE, a prow; a ship [n]\n",
  "PROROGATE": "to end a session (of Parliament); to postpone (a meeting), also PROROGUE [v PROROGATED, PROROGATING, PROROGATES]\n",
  "PROROGATED": "PROROGATE, to end a session (of Parliament); to postpone (a meeting), also PROROGUE [v]\n",
  "PROROGATES": "PROROGATE, to end a session (of Parliament); to postpone (a meeting), also PROROGUE [v]\n",
  "PROROGATING": "PROROGATE, to end a session (of Parliament); to postpone (a meeting), also PROROGUE [v]\n",
  "PROROGATION": "the act of prorogating, postponing a meeting [n -S]\n",
  "PROROGATIONS": "PROROGATION, the act of prorogating, postponing a meeting [n]\n",
  "PROROGUE": "to end a session (of Parliament); to postpone (a meeting), also PROROGATE [v PROROGUED, PROROGUING, PROROGUES]\n",
  "PROROGUED": "PROROGUE, to end a session (of Parliament); to postpone (a meeting), also PROROGATE [v]\n",
  "PROROGUES": "PROROGUE, to end a session (of Parliament); to postpone (a meeting), also PROROGATE [v]\n",
  "PROROGUING": "PROROGUE, to end a session (of Parliament); to postpone (a meeting), also PROROGATE [v]\n",
  "PROS": "PRO, (short for) a professional, or prostitute [n]\n",
  "PROSAIC": "pertaining to prose, also PROSY [adj]\n",
  "PROSAICAL": "relating to prose; dull, banal, also PROSAIC [adj PROSAICALLY]\n",
  "PROSAICALLY": "PROSAICAL, relating to prose; dull, banal, also PROSAIC [adv]\n",
  "PROSAICALNESS": "PROSAICAL, relating to prose; dull, banal, also PROSAIC [n]\n",
  "PROSAICALNESSES": "PROSAICALNESS, PROSAICAL, relating to prose; dull, banal, also PROSAIC [n]\n",
  "PROSAICISM": "the quality of being prosaic [n -S]\n",
  "PROSAICISMS": "PROSAICISM, the quality of being prosaic [n]\n",
  "PROSAICNESS": "the state of being prosaic [n -ES]\n",
  "PROSAICNESSES": "PROSAICNESS, the state of being prosaic [n]\n",
  "PROSAISM": "a prosaic style [n -S]\n",
  "PROSAISMS": "PROSAISM, a prosaic style [n]\n",
  "PROSAIST": "a writer of prose, also PROSER [n -S]\n",
  "PROSAISTS": "PROSAIST, a writer of prose, also PROSER [n]\n",
  "PROSATEUR": "(French) one who writes prose for a living [n -S]\n",
  "PROSATEURS": "PROSATEUR, (French) one who writes prose for a living [n]\n",
  "PROSAUROPOD": "a reptile-like dinosaur of the division Prosauropoda which lived in the Triassic period [n -S]\n",
  "PROSAUROPODS": "PROSAUROPOD, a reptile-like dinosaur of the division Prosauropoda which lived in the Triassic period [n]\n",
  "PROSCENIA": "PROSCENIUM, the part of the stage in front of the curtain [n]\n",
  "PROSCENIUM": "the part of the stage in front of the curtain [n PROSCENIUMS or PROSCENIA]\n",
  "PROSCENIUMS": "PROSCENIUM, the part of the stage in front of the curtain [n]\n",
  "PROSCIUTTI": "PROSCIUTTO, (Italian) aged, dry-cured Italian ham, ready to eat and usually sliced thin [n]\n",
  "PROSCIUTTO": "(Italian) aged, dry-cured Italian ham, ready to eat and usually sliced thin [n PROSCIUTTOS or PROSCIUTTI]\n",
  "PROSCIUTTOS": "PROSCIUTTO, (Italian) aged, dry-cured Italian ham, ready to eat and usually sliced thin [n]\n",
  "PROSCRIBE": "to forbid, esp. by law [v PROSCRIBED, PROSCRIBING, PROSCRIBES]\n",
  "PROSCRIBED": "PROSCRIBE, to forbid, esp. by law [v]\n",
  "PROSCRIBER": "one who proscribes [n -S]\n",
  "PROSCRIBERS": "PROSCRIBER, one who proscribes [n]\n",
  "PROSCRIBES": "PROSCRIBE, to forbid, esp. by law [v]\n",
  "PROSCRIBING": "PROSCRIBE, to forbid, esp. by law [v]\n",
  "PROSCRIPT": "a person who is proscribed [n -S]\n",
  "PROSCRIPTION": "the act of proscribing [n -S]\n",
  "PROSCRIPTIONS": "PROSCRIPTION, the act of proscribing [n]\n",
  "PROSCRIPTIVE": "relating to proscription [adj PROSCRIPTIVELY]\n",
  "PROSCRIPTIVELY": "PROSCRIPTIVE, relating to proscription [adv]\n",
  "PROSCRIPTS": "PROSCRIPT, a person who is proscribed [n]\n",
  "PROSE": "to write without metrical structure [v PROSED, PROSING, PROSES]\n",
  "PROSECCO": "(Italian) an Italian sparkling white wine [n -S]\n",
  "PROSECCOS": "PROSECCO, (Italian) an Italian sparkling white wine [n]\n",
  "PROSECT": "to dissect [v -ED, -ING, -S]\n",
  "PROSECTED": "PROSECT, to dissect [v]\n",
  "PROSECTING": "PROSECT, to dissect [v]\n",
  "PROSECTOR": "one who dissects bodies in anatomical lectures [n -S]\n",
  "PROSECTORIAL": "of or like a prosector, one who dissects bodies in anatomical lectures [adj]\n",
  "PROSECTORS": "PROSECTOR, one who dissects bodies in anatomical lectures [n]\n",
  "PROSECTORSHIP": "the state of being a prosector [n -S]\n",
  "PROSECTORSHIPS": "PROSECTORSHIP, the state of being a prosector [n]\n",
  "PROSECTS": "PROSECT, to dissect [v]\n",
  "PROSECUTABLE": "capable of being prosecuted [adj]\n",
  "PROSECUTE": "to pursue by law [v PROSECUTED, PROSECUTING, PROSECUTES]\n",
  "PROSECUTED": "PROSECUTE, to pursue by law [v]\n",
  "PROSECUTES": "PROSECUTE, to pursue by law [v]\n",
  "PROSECUTING": "PROSECUTE, to pursue by law [v]\n",
  "PROSECUTION": "the act of prosecuting [n -S]\n",
  "PROSECUTIONS": "PROSECUTION, the act of prosecuting [n]\n",
  "PROSECUTOR": "a person who institutes an official prosecution before a court [n -S]\n",
  "PROSECUTORIAL": "of, relating to, or being a prosecutor or prosecution [adj]\n",
  "PROSECUTORS": "PROSECUTOR, a person who institutes an official prosecution before a court [n]\n",
  "PROSECUTRICES": "PROSECUTRIX, a female prosecutor [n]\n",
  "PROSECUTRIX": "a female prosecutor [n PROSECUTRICES or PROSECUTRIXES]\n",
  "PROSECUTRIXES": "PROSECUTRIX, a female prosecutor [n]\n",
  "PROSED": "PROSE, to write without metrical structure [v]\n",
  "PROSELIKE": "like prose [adj]\n",
  "PROSELYTE": "a convert, esp. to Jewish faith [n -S] / to become a proselyte [v PROSELYTED, PROSELYTING, PROSELYTES]\n",
  "PROSELYTED": "PROSELYTE, to become a proselyte [v]\n",
  "PROSELYTES": "PROSELYTE, to become a proselyte [v]\n",
  "PROSELYTIC": "of or like a proselyte [adj]\n",
  "PROSELYTING": "PROSELYTE, to become a proselyte [v]\n",
  "PROSELYTISATION": "the act of proselytising, also PROSELYTIZATION [n]\n",
  "PROSELYTISE": "to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTIZE [v PROSELYTISED, PROSELYTISING, PROSELYTISES]\n",
  "PROSELYTISED": "PROSELYTISE, to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTIZE [v]\n",
  "PROSELYTISER": "one who proselytises, also PROSELYTIZER [n -S]\n",
  "PROSELYTISERS": "PROSELYTISER, one who proselytises, also PROSELYTIZER [n]\n",
  "PROSELYTISES": "PROSELYTISE, to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTIZE [v]\n",
  "PROSELYTISING": "PROSELYTISE, to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTIZE [v]\n",
  "PROSELYTISM": "conversion [n -S]\n",
  "PROSELYTISMS": "PROSELYTISM, conversion [n]\n",
  "PROSELYTIZATION": "the act of proselytizing, also PROSELYTISATION [n]\n",
  "PROSELYTIZE": "to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTISE [v PROSELYTIZED, PROSELYTIZING, PROSELYTIZES]\n",
  "PROSELYTIZED": "PROSELYTIZE, to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTISE [v]\n",
  "PROSELYTIZER": "one who proselytizes, also PROSELYTISER [n -S]\n",
  "PROSELYTIZERS": "PROSELYTIZER, one who proselytizes, also PROSELYTISER [n]\n",
  "PROSELYTIZES": "PROSELYTIZE, to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTISE [v]\n",
  "PROSELYTIZING": "PROSELYTIZE, to recruit or convert esp. to a new faith, institution, or cause, also PROSELYTISE [v]\n",
  "PROSEMAN": "a writer of prose [n PROSEMEN]\n",
  "PROSEMEN": "PROSEMAN, a writer of prose [n]\n",
  "PROSEMINAR": "a course of study like a graduate seminar but often open to advanced students [n -S]\n",
  "PROSEMINARS": "PROSEMINAR, a course of study like a graduate seminar but often open to advanced students [n]\n",
  "PROSENCEPHALA": "PROSENCEPHALON, the forebrain [n]\n",
  "PROSENCEPHALIC": "relating to the prosencephalon, the forebrain [adj]\n",
  "PROSENCEPHALON": "the forebrain [n PROSENCEPHALA]\n",
  "PROSENCHYMA": "supporting plant tissue containing little protoplasm [n PROSENCHYMAS or PROSENCHYMATA]\n",
  "PROSENCHYMAS": "PROSENCHYMA, supporting plant tissue containing little protoplasm [n]\n",
  "PROSENCHYMATA": "PROSENCHYMA, supporting plant tissue containing little protoplasm [n]\n",
  "PROSENCHYMATOUS": "relating to prosenchyma, supporting plant tissue containing little protoplasm [adj]\n",
  "PROSER": "a writer of prose, also PROSAIST [n -S]\n",
  "PROSERS": "PROSER, a writer of prose, also PROSAIST [n]\n",
  "PROSES": "PROSE, to write without metrical structure [v]\n",
  "PROSEUCHA": "(Greek) a place of prayer, an oratory, also PROSEUCHE [n PROSEUCHAE]\n",
  "PROSEUCHAE": "PROSEUCHA, (Greek) a place of prayer, an oratory, also PROSEUCHE [n]\n",
  "PROSEUCHE": "(Greek) a place of prayer, an oratory, also PROSEUCHA [n PROSEUCHAE]\n",
  "PROSIER": "PROSY, prosaic, tedious [adj]\n",
  "PROSIEST": "PROSY, prosaic, tedious [adj]\n",
  "PROSIFIED": "PROSIFY, to write prose [v]\n",
  "PROSIFIES": "PROSIFY, to write prose [v]\n",
  "PROSIFY": "to write prose [v PROSIFIED, PROSIFYING, PROSIFIES]\n",
  "PROSIFYING": "PROSIFY, to write prose [v]\n",
  "PROSILIENCIES": "PROSILIENCY, the state of being prosilient, outstanding [n]\n",
  "PROSILIENCY": "the state of being prosilient, outstanding [n PROSILIENCIES]\n",
  "PROSILIENT": "outstanding [adj]\n",
  "PROSILY": "PROSY, prosaic, tedious [adv]\n",
  "PROSIMIAN": "a primate of the suborder Prosimii, that includes the lemur, loris and tarsier [n -S]\n",
  "PROSIMIANS": "PROSIMIAN, a primate of the suborder Prosimii, that includes the lemur, loris and tarsier [n]\n",
  "PROSINESS": "the state of being prosy [n -ES]\n",
  "PROSINESSES": "PROSINESS, the state of being prosy [n]\n",
  "PROSING": "writing in a prosy way [n -S]\n",
  "PROSINGS": "PROSING, writing in a prosy way [n]\n",
  "PROSIT": "(Latin) a toast to good health, also PROST [interj]\n",
  "PROSLAMBANOMENE": "plural of proslambanomenos, (which has sixteen letters), an additional note at the bottom of the scale\n",
  "PROSLAVERY": "in favour of slavery [adj]\n",
  "PROSO": "(Russian) a variety of millet [n -S]\n",
  "PROSOBRANCH": "any of a subclass of gastropod molluscs [n -S]\n",
  "PROSOBRANCHS": "PROSOBRANCH, any of a subclass of gastropod molluscs [n]\n",
  "PROSOCIAL": "in the interests of society as a whole [adj]\n",
  "PROSODIAL": "prosodical [adj]\n",
  "PROSODIAN": "one skilled in prosody, also PROSODIST [n -S]\n",
  "PROSODIANS": "PROSODIAN, one skilled in prosody, also PROSODIST [n]\n",
  "PROSODIC": "of or pertaining to prosody, also PROSODICAL [adj PROSODICALLY]\n",
  "PROSODICAL": "of or pertaining to prosody, also PROSODIC [adj PROSODICALLY]\n",
  "PROSODICALLY": "PROSODICAL, of or pertaining to prosody, also PROSODIC [adv]\n",
  "PROSODIES": "PROSODY, the study of poetical forms [n]\n",
  "PROSODIST": "one skilled in prosody, also PROSODIAN [n -S]\n",
  "PROSODISTS": "PROSODIST, one skilled in prosody, also PROSODIAN [n]\n",
  "PROSODY": "the study of poetical forms [n PROSODIES]\n",
  "PROSOMA": "the front region of the body of an invertebrate [n PROSOMAS or PROSOMATA]\n",
  "PROSOMAL": "relating to a prosoma [adj]\n",
  "PROSOMAS": "PROSOMA, the front region of the body of an invertebrate [n]\n",
  "PROSOMATA": "PROSOMA, the front region of the body of an invertebrate [n]\n",
  "PROSOPAGNOSIA": "inability to recognize familiar faces [n -S]\n",
  "PROSOPAGNOSIAS": "PROSOPAGNOSIA, inability to recognize familiar faces [n]\n",
  "PROSOPOGRAPHER": "a writer of prosopographies, biographical sketches [n -S]\n",
  "PROSOPOGRAPHERS": "PROSOPOGRAPHER, a writer of prosopographies, biographical sketches [n]\n",
  "PROSOPOGRAPHIES": "PROSOPOGRAPHY, a biographical sketch; a description of person [n]\n",
  "PROSOPOGRAPHY": "a biographical sketch; a description of person [n PROSOPOGRAPHIES]\n",
  "PROSOPON": "the embodiment of any one of the Trinity [n -S]\n",
  "PROSOPONS": "PROSOPON, the embodiment of any one of the Trinity [n]\n",
  "PROSOPOPEIA": "a figure of speech in which an imaginary or absent person is represented as speaking or acting, also PROSOPOPOEIA [n -S]\n",
  "PROSOPOPEIAL": "relating to prosopopeia, personification [adj]\n",
  "PROSOPOPEIAS": "PROSOPOPEIA, a figure of speech in which an imaginary or absent person is represented as speaking or acting, also PROSOPOPOEIA [n]\n",
  "PROSOPOPOEIA": "a figure of speech in which an imaginary or absent person is represented as speaking or acting, also PROSOPOPEIA [n -S]\n",
  "PROSOPOPOEIAL": "relating to prosopopeia, personification [adj]\n",
  "PROSOPOPOEIAS": "PROSOPOPOEIA, a figure of speech in which an imaginary or absent person is represented as speaking or acting, also PROSOPOPEIA [n]\n",
  "PROSOS": "PROSO, (Russian) a variety of millet [n]\n",
  "PROSPECT": "to search for mineral deposits [v -ED, -ING, -S]\n",
  "PROSPECTED": "PROSPECT, to search for mineral deposits [v]\n",
  "PROSPECTING": "exploring for mineral deposits [n -S]\n",
  "PROSPECTINGS": "PROSPECTING, exploring for mineral deposits [n]\n",
  "PROSPECTION": "looking to the future, foresight [n -S]\n",
  "PROSPECTIONS": "PROSPECTION, looking to the future, foresight [n]\n",
  "PROSPECTIVE": "relating to or effective in the future [adj PROSPECTIVELY] / a prospect [n -S]\n",
  "PROSPECTIVELY": "PROSPECTIVE, relating to or effective in the future [adv]\n",
  "PROSPECTIVENESS": "the state of being prospective [n]\n",
  "PROSPECTIVES": "PROSPECTIVE, a prospect [n]\n",
  "PROSPECTLESS": "without a prospect [adj]\n",
  "PROSPECTOR": "one who prospects [n -S]\n",
  "PROSPECTORS": "PROSPECTOR, one who prospects [n]\n",
  "PROSPECTS": "PROSPECT, to search for mineral deposits [v]\n",
  "PROSPECTUS": "the outline of any plan submitted for public approval, particularly of a literary work or of a joint-stock concern [n -ES]\n",
  "PROSPECTUSES": "PROSPECTUS, the outline of any plan submitted for public approval, particularly of a literary work or of a joint-stock concern [n]\n",
  "PROSPER": "to be successful [v -ED, -ING, -S]\n",
  "PROSPERED": "PROSPER, to be successful [v]\n",
  "PROSPERING": "PROSPER, to be successful [v]\n",
  "PROSPERITIES": "PROSPERITY, the condition of being successful or thriving [n]\n",
  "PROSPERITY": "the condition of being successful or thriving [n PROSPERITIES]\n",
  "PROSPEROUS": "thriving, affluent [adj PROSPEROUSLY]\n",
  "PROSPEROUSLY": "PROSPEROUS, thriving, affluent [adv]\n",
  "PROSPEROUSNESS": "PROSPEROUS, thriving, affluent [n]\n",
  "PROSPERS": "PROSPER, to be successful [v]\n",
  "PROSS": "(colloq.) a prostitute, also PROSSIE, PROSTIE, PROZZIE [n -ES]\n",
  "PROSSES": "PROSS, (colloq.) a prostitute, also PROSSIE, PROSTIE, PROZZIE [n]\n",
  "PROSSIE": "(colloq.) a prostitute, also PROSS, PROSTIE, PROZZIE [n -S]\n",
  "PROSSIES": "PROSSIE, (colloq.) a prostitute, also PROSS, PROSTIE, PROZZIE [n]\n",
  "PROST": "(Latin) a toast to good health, also PROSIT [interj]\n",
  "PROSTACYCLIN": "a prostaglandin which dilates blood vessels and inhibits blood clotting [n -S]\n",
  "PROSTACYCLINS": "PROSTACYCLIN, a prostaglandin which dilates blood vessels and inhibits blood clotting [n]\n",
  "PROSTAGLANDIN": "any of a group of chemical substances secreted by various parts of the body into the bloodstream and found to have a wide range of effects on the body processes, e.g. on muscle contraction [n -S]\n",
  "PROSTAGLANDINS": "PROSTAGLANDIN, any of a group of chemical substances secreted by various parts of the body into the bloodstream and found to have a wide range of effects on the body processes, e.g. on muscle contraction [n]\n",
  "PROSTANTHERA": "an Australian bush, with strongly scented leaves and red or white flowers [n -S]\n",
  "PROSTANTHERAS": "PROSTANTHERA, an Australian bush, with strongly scented leaves and red or white flowers [n]\n",
  "PROSTATE": "a gland in males at the neck of the bladder, which releases a liquid that forms part of semen [n -S]\n",
  "PROSTATECTOMIES": "PROSTATECTOMY, the surgical removal of the prostate gland [n]\n",
  "PROSTATECTOMY": "the surgical removal of the prostate gland [n PROSTATECTOMIES]\n",
  "PROSTATES": "PROSTATE, a gland in males at the neck of the bladder, which releases a liquid that forms part of semen [n]\n",
  "PROSTATIC": "of or pertaining to the prostate gland [adj]\n",
  "PROSTATISM": "an illness or disorder associated with enlargement of the prostate [n -S]\n",
  "PROSTATISMS": "PROSTATISM, an illness or disorder associated with enlargement of the prostate [n]\n",
  "PROSTATITIS": "inflammation of the prostate gland [n -ES]\n",
  "PROSTATITISES": "PROSTATITIS, inflammation of the prostate gland [n]\n",
  "PROSTERNA": "PROSTERNUM, the sternum of the prothorax of insects [n]\n",
  "PROSTERNUM": "the sternum of the prothorax of insects [n PROSTERNA or PROSTERNUMS]\n",
  "PROSTERNUMS": "PROSTERNUM, the sternum of the prothorax of insects [n]\n",
  "PROSTHESES": "PROSTHESIS, the addition to the human body of some artificial part, to replace one that is wanting, as a log or an eye [n]\n",
  "PROSTHESIS": "the addition to the human body of some artificial part, to replace one that is wanting, as a log or an eye [n PROSTHESES]\n",
  "PROSTHETIC": "relating to prosthesis [adj PROSTHETICALLY] / an artificial part of the body [n -S]\n",
  "PROSTHETICALLY": "PROSTHETIC, relating to prosthesis [adv]\n",
  "PROSTHETICS": "PROSTHETIC, an artificial part of the body [n]\n",
  "PROSTHETIST": "one who makes prosthetics [n -S]\n",
  "PROSTHETISTS": "PROSTHETIST, one who makes prosthetics [n]\n",
  "PROSTHODONTIA": "the provision of false teeth, also PROSTHODONTICS [n -S]\n",
  "PROSTHODONTIAS": "PROSTHODONTIA, the provision of false teeth, also PROSTHODONTICS [n]\n",
  "PROSTHODONTICS": "the provision of false teeth, also PROSTHODONTIA [n]\n",
  "PROSTHODONTIST": "a specialist in prosthodontics [n -S]\n",
  "PROSTHODONTISTS": "PROSTHODONTIST, a specialist in prosthodontics [n]\n",
  "PROSTIE": "(colloq.) a prostitute, also PROSS, PROSSIE, PROZZIE [n -S]\n",
  "PROSTIES": "PROSTIE, (colloq.) a prostitute, also PROSS, PROSSIE, PROZZIE [n]\n",
  "PROSTITUTE": "a person (usually a woman) who accepts money in return for sexual intercourse [n -S] / to offer indiscriminately for sexual intercourse esp. for money [v PROSTITUTED, PROSTITUTING, PROSTITUTES]\n",
  "PROSTITUTED": "PROSTITUTE, to offer indiscriminately for sexual intercourse esp. for money [v]\n",
  "PROSTITUTES": "PROSTITUTE, to offer indiscriminately for sexual intercourse esp. for money [v]\n",
  "PROSTITUTING": "PROSTITUTE, to offer indiscriminately for sexual intercourse esp. for money [v]\n",
  "PROSTITUTION": "the act or practice of engaging in promiscuous sexual relations esp. for money [n -S]\n",
  "PROSTITUTIONS": "PROSTITUTION, the act or practice of engaging in promiscuous sexual relations esp. for money [n]\n",
  "PROSTITUTOR": "one who prostitutes [n -S]\n",
  "PROSTITUTORS": "PROSTITUTOR, one who prostitutes [n]\n",
  "PROSTOMIA": "PROSTOMIUM, that portion of the head of an annelid situated in front of the mouth [n]\n",
  "PROSTOMIAL": "relating to the prostomium, that portion of the head of an annelid situated in front of the mouth [adj]\n",
  "PROSTOMIUM": "that portion of the head of an annelid situated in front of the mouth [n PROSTOMIA]\n",
  "PROSTRATE": "prone; lying or bent with one's face on the ground [adj] / to throw forward on the ground [v PROSTRATED, PROSTRATING, PROSTRATES]\n",
  "PROSTRATED": "PROSTRATE, to throw forward on the ground [v]\n",
  "PROSTRATES": "PROSTRATE, to throw forward on the ground [v]\n",
  "PROSTRATING": "PROSTRATE, to throw forward on the ground [v]\n",
  "PROSTRATION": "the act of assuming a prostrate position [n -S]\n",
  "PROSTRATIONS": "PROSTRATION, the act of assuming a prostrate position [n]\n",
  "PROSTYLE": "in Greek architecture, a building having a row of columns across the front only [n -S]\n",
  "PROSTYLES": "PROSTYLE, in Greek architecture, a building having a row of columns across the front only [n]\n",
  "PROSUMER": "a consumer who uses professional standard equipment [n -S]\n",
  "PROSUMERS": "PROSUMER, a consumer who uses professional standard equipment [n]\n",
  "PROSY": "prosaic, tedious [adj PROSIER, PROSIEST, PROSILY]\n",
  "PROSYLLOGISM": "a syllogism whose conclusion forms the premise of another [n -S]\n",
  "PROSYLLOGISMS": "PROSYLLOGISM, a syllogism whose conclusion forms the premise of another [n]\n",
  "PROTACTINIUM": "a radioactive metallic chemical element, a member of the actinide series which occurs as a decay product in uranium ores [n -S]\n",
  "PROTACTINIUMS": "PROTACTINIUM, a radioactive metallic chemical element, a member of the actinide series which occurs as a decay product in uranium ores [n]\n",
  "PROTAGONISM": "the state of being a protagonist [n -S]\n",
  "PROTAGONISMS": "PROTAGONISM, the state of being a protagonist [n]\n",
  "PROTAGONIST": "the principal character in a literary work [n -S]\n",
  "PROTAGONISTS": "PROTAGONIST, the principal character in a literary work [n]\n",
  "PROTAMIN": "any of a class of simple basic proteins which occur combined with nucleic acids (esp. in fish sperm), also PROTAMINE [n -S]\n",
  "PROTAMINE": "any of a class of simple basic proteins which occur combined with nucleic acids (esp. in fish sperm), also PROTAMIN [n -S]\n",
  "PROTAMINES": "PROTAMINE, any of a class of simple basic proteins which occur combined with nucleic acids (esp. in fish sperm), also PROTAMIN [n]\n",
  "PROTAMINS": "PROTAMIN, any of a class of simple basic proteins which occur combined with nucleic acids (esp. in fish sperm), also PROTAMINE [n]\n",
  "PROTANDRIES": "PROTANDRY, the development of male organs before female to avoid self-fertilization [n]\n",
  "PROTANDROUS": "showing protandry, the development of male organs before female to avoid self-fertilization [adj]\n",
  "PROTANDRY": "the development of male organs before female to avoid self-fertilization [n PROTANDRIES]\n",
  "PROTANOMALIES": "PROTANOMALY, a form of colour blindness in which there is a decreased response to red [n]\n",
  "PROTANOMALOUS": "afflicted with protanomaly, a form of colour blindness in which there is a decreased response to red [adj]\n",
  "PROTANOMALY": "a form of colour blindness in which there is a decreased response to red [n PROTANOMALIES]\n",
  "PROTANOPE": "a sufferer from protanopia, colour-blindness with respect to red [n -S]\n",
  "PROTANOPES": "PROTANOPE, a sufferer from protanopia, colour-blindness with respect to red [n]\n",
  "PROTANOPIA": "colour-blindness with respect to red [n -S]\n",
  "PROTANOPIAS": "PROTANOPIA, colour-blindness with respect to red [n]\n",
  "PROTANOPIC": "colour-blind to red [adj]\n",
  "PROTASES": "PROTASIS, the introductory part of a classical drama [n]\n",
  "PROTASIS": "the introductory part of a classical drama [n PROTASES]\n",
  "PROTATIC": "of or pertaining to the protasis of an ancient play; introductory [adj]\n",
  "PROTEA": "a plant of a large South African genus [n -S]\n",
  "PROTEACEOUS": "belonging to the protea family [adj]\n",
  "PROTEAN": "having a varied nature or ability to assume different forms [adj] / a theatrical performer who takes several parts in the same piece [n -S]\n",
  "PROTEANS": "PROTEAN, a theatrical performer who takes several parts in the same piece [n]\n",
  "PROTEAS": "PROTEA, a plant of a large South African genus [n]\n",
  "PROTEASE": "any enzyme that splits up proteins, also PROTEINASE [n -S]\n",
  "PROTEASES": "PROTEASE, any enzyme that splits up proteins, also PROTEINASE [n]\n",
  "PROTECT": "to shield from harm, attack or injury [v -ED, -ING, -S]\n",
  "PROTECTANT": "a protecting agent [n -S]\n",
  "PROTECTANTS": "PROTECTANT, a protecting agent [n]\n",
  "PROTECTED": "PROTECT, to shield from harm, attack or injury [v]\n",
  "PROTECTER": "one who protects, also PROTECTOR [n -S]\n",
  "PROTECTERS": "PROTECTER, one who protects, also PROTECTOR [n]\n",
  "PROTECTING": "PROTECT, to shield from harm, attack or injury [v]\n",
  "PROTECTINGLY": "PROTECTING, PROTECT, to shield from harm, attack or injury [adv]\n",
  "PROTECTION": "the act of protecting [n -S]\n",
  "PROTECTIONISM": "a supporter of protectionism [n -S]\n",
  "PROTECTIONISMS": "PROTECTIONISM, a supporter of protectionism [n]\n",
  "PROTECTIONIST": "an advocate of government economic protection for domestic producers through restrictions on foreign competitors [n -S]\n",
  "PROTECTIONISTS": "PROTECTIONIST, an advocate of government economic protection for domestic producers through restrictions on foreign competitors [n]\n",
  "PROTECTIONS": "PROTECTION, the act of protecting [n]\n",
  "PROTECTIVE": "serving to protect [adj PROTECTIVELY] / something that offers protection [n -S]\n",
  "PROTECTIVELY": "PROTECTIVE, serving to protect [adv]\n",
  "PROTECTIVENESS": "the state of being protective [n]\n",
  "PROTECTIVES": "PROTECTIVE, something that offers protection [n]\n",
  "PROTECTOR": "one who protects, also PROTECTER [n -S]\n",
  "PROTECTORAL": "of or relating to a protector or protectorate [adj]\n",
  "PROTECTORATE": "an area governed by a protector [n -S]\n",
  "PROTECTORATES": "PROTECTORATE, an area governed by a protector [n]\n",
  "PROTECTORIAL": "of or like a protectorate [adj]\n",
  "PROTECTORIES": "PROTECTORY, an institution for destitute or delinquent children [n]\n",
  "PROTECTORLESS": "without a protector [adj]\n",
  "PROTECTORS": "PROTECTOR, one who protects, also PROTECTER [n]\n",
  "PROTECTORSHIP": "the office of protector [n -S]\n",
  "PROTECTORSHIPS": "PROTECTORSHIP, the office of protector [n]\n",
  "PROTECTORY": "an institution for destitute or delinquent children [n PROTECTORIES]\n",
  "PROTECTRESS": "a female protector, also PROTECTRIX [n -ES]\n",
  "PROTECTRESSES": "PROTECTRESS, a female protector, also PROTECTRIX [n]\n",
  "PROTECTRICES": "PROTECTRIX, a female protector, also PROTECTRESS [n]\n",
  "PROTECTRIX": "a female protector, also PROTECTRESS [n PROTECTRICES or PROTECTRIXES]\n",
  "PROTECTRIXES": "PROTECTRIX, a female protector, also PROTECTRESS [n]\n",
  "PROTECTS": "PROTECT, to shield from harm, attack or injury [v]\n",
  "PROTEGE": "(French) one whose career is promoted by an influential person [n -S]\n",
  "PROTEGEE": "(French) one (female) who is looked after or sponsored by another [n -S]\n",
  "PROTEGEES": "PROTEGEE, (French) one (female) who is looked after or sponsored by another [n]\n",
  "PROTEGES": "PROTEGE, (French) one whose career is promoted by an influential person [n]\n",
  "PROTEI": "PROTEUS, (Greek) any of the rodlike bacteria found in decaying matter [n]\n",
  "PROTEID": "a nitrogenous organic compound, also PROTEIN, PROTEIDE [n -S]\n",
  "PROTEIDE": "a nitrogenous organic compound, also PROTEIN, PROTEID [n -S]\n",
  "PROTEIDES": "PROTEIDE, a nitrogenous organic compound, also PROTEIN, PROTEID [n]\n",
  "PROTEIDS": "PROTEID, a nitrogenous organic compound, also PROTEIN, PROTEIDE [n]\n",
  "PROTEIFORM": "changeable in form [adj]\n",
  "PROTEIN": "a nitrogenous organic compound, also PROTEID, PROTEIDE [n -S]\n",
  "PROTEINACEOUS": "of or related to protein, also PROTEINOUS [adj]\n",
  "PROTEINASE": "any enzyme that splits up proteins, also PROTEASE [n -S]\n",
  "PROTEINASES": "PROTEINASE, any enzyme that splits up proteins, also PROTEASE [n]\n",
  "PROTEINIC": "relating to protein [adj]\n",
  "PROTEINOUS": "of or related to protein, also PROTEINACEOUS [adj]\n",
  "PROTEINS": "PROTEIN, a nitrogenous organic compound, also PROTEID, PROTEIDE [n]\n",
  "PROTEINURIA": "the presence of abnormally high levels of protein in the urine, esp. as a symptom of kidney damage [n -S]\n",
  "PROTEINURIAS": "PROTEINURIA, the presence of abnormally high levels of protein in the urine, esp. as a symptom of kidney damage [n]\n",
  "PROTEND": "(archaic) to stretch forth, hold out [v -ED, -ING, -S]\n",
  "PROTENDED": "PROTEND, (archaic) to stretch forth, hold out [v]\n",
  "PROTENDING": "PROTEND, (archaic) to stretch forth, hold out [v]\n",
  "PROTENDS": "PROTEND, (archaic) to stretch forth, hold out [v]\n",
  "PROTENSE": "(Spenser) an extension in time, a duration [n -S]\n",
  "PROTENSES": "PROTENSE, (Spenser) an extension in time, a duration [n]\n",
  "PROTENSION": "duration [n -S]\n",
  "PROTENSIONS": "PROTENSION, duration [n]\n",
  "PROTENSITIES": "PROTENSITY, (archaic) duration, extension in time [n]\n",
  "PROTENSITY": "(archaic) duration, extension in time [n PROTENSITIES]\n",
  "PROTENSIVE": "extensive in time or length [adj PROTENSIVELY]\n",
  "PROTENSIVELY": "PROTENSIVE, extensive in time or length [adv]\n",
  "PROTEOCLASTIC": "proteolytic, relating to the splitting of proteins by enzymes [adj]\n",
  "PROTEOGLYCAN": "any of a class of glycoproteins of high molecular weight that are found esp. in the extracellular matrix of connective tissue [n -S]\n",
  "PROTEOGLYCANS": "PROTEOGLYCAN, any of a class of glycoproteins of high molecular weight that are found esp. in the extracellular matrix of connective tissue [n]\n",
  "PROTEOLYSE": "to split proteins by proteolysis [v PROTEOLYSED, PROTEOLYSING, PROTEOLYSES]\n",
  "PROTEOLYSED": "PROTEOLYSE, to split proteins by proteolysis [v]\n",
  "PROTEOLYSES": "PROTEOLYSE, to split proteins by proteolysis [v]\n",
  "PROTEOLYSING": "PROTEOLYSE, to split proteins by proteolysis [v]\n",
  "PROTEOLYSIS": "the disintegration of protein [n PROTEOLYSES]\n",
  "PROTEOLYTIC": "relating to proteolysis, the disintegration of protein [adj PROTEOLYTICALLY]\n",
  "PROTEOLYTICALLY": "PROTEOLYTIC, relating to proteolysis, the disintegration of protein [adv]\n",
  "PROTEOME": "the complement of proteins expressed by a genome [n -S]\n",
  "PROTEOMES": "PROTEOME, the complement of proteins expressed by a genome [n]\n",
  "PROTEOMIC": "relating to a proteome, the full complement of proteins that occurs with a cell or tissue [adj]\n",
  "PROTEOMICS": "the study of proteomes, especially their role in physiology and the action of drugs [n]\n",
  "PROTEOSE": "a substance derived from protein in digestion [n -S]\n",
  "PROTEOSES": "PROTEOSE, a substance derived from protein in digestion [n]\n",
  "PROTERANDRIES": "PROTERANDRY, in a hermaphrodite organism, the maturation and loss of the male elements before the female elements develop [n]\n",
  "PROTERANDROUS": "exhibiting proterandry [adj]\n",
  "PROTERANDRY": "in a hermaphrodite organism, the maturation and loss of the male elements before the female elements develop [n PROTERANDRIES]\n",
  "PROTEROGYNIES": "PROTEROGYNY, the development of female organs before male to avoid self-fertilization [n]\n",
  "PROTEROGYNOUS": "exhibiting proterogyny [adj]\n",
  "PROTEROGYNY": "the development of female organs before male to avoid self-fertilization [n PROTEROGYNIES]\n",
  "PROTERVITIES": "PROTERVITY, peevishness [n]\n",
  "PROTERVITY": "peevishness [n PROTERVITIES]\n",
  "PROTEST": "to express strong objection [v -ED, -ING, -S]\n",
  "PROTESTANT": "one who protests [n -S]\n",
  "PROTESTANTS": "PROTESTANT, one who protests [n]\n",
  "PROTESTATION": "an avowal or solemn declaration [n -S]\n",
  "PROTESTATIONS": "PROTESTATION, an avowal or solemn declaration [n]\n",
  "PROTESTED": "PROTEST, to express strong objection [v]\n",
  "PROTESTER": "one who protests, also PROTESTOR [n -S]\n",
  "PROTESTERS": "PROTESTER, one who protests, also PROTESTOR [n]\n",
  "PROTESTING": "PROTEST, to express strong objection [v]\n",
  "PROTESTINGLY": "PROTESTING, PROTEST, to express strong objection [adv]\n",
  "PROTESTOR": "one who protests, also PROTESTER [n -S]\n",
  "PROTESTORS": "PROTESTOR, one who protests, also PROTESTER [n]\n",
  "PROTESTS": "PROTEST, to express strong objection [v]\n",
  "PROTEUS": "(Greek) any of the rodlike bacteria found in decaying matter [n PROTEUSES or PROTEI]\n",
  "PROTEUSES": "PROTEUS, (Greek) any of the rodlike bacteria found in decaying matter [n]\n",
  "PROTHALAMIA": "PROTHALAMIUM, (Spenser) a song in honour of a marriage, also PROTHALAMION [n]\n",
  "PROTHALAMION": "(Spenser) a song in honour of a marriage, also PROTHALAMIUM [n PROTHALAMIA]\n",
  "PROTHALAMIUM": "(Spenser) a song in honour of a marriage, also PROTHALAMION [n PROTHALAMIA]\n",
  "PROTHALLI": "PROTHALLUS, the free-living gametophyte of a fern or other vascular cryptogam, also PROTHALLIUM [n]\n",
  "PROTHALLIA": "PROTHALLIUM, the free-living gametophyte of a fern or other vascular cryptogam, also PROTHALLUS [n]\n",
  "PROTHALLIAL": "of or like the prothallium, the growth following a germinating spore, for the purpose of sexual reproduction, producing the antheridia and archegonia [adj]\n",
  "PROTHALLIC": "relating to a prothallus, the growth following a germinating spore, for the purpose of sexual reproduction [adj]\n",
  "PROTHALLIUM": "the free-living gametophyte of a fern or other vascular cryptogam, also PROTHALLUS [n PROTHALLIA]\n",
  "PROTHALLOID": "relating to the prothallus, the gametophyte or sexual generation in ferns and related plants [adj]\n",
  "PROTHALLUS": "the free-living gametophyte of a fern or other vascular cryptogam, also PROTHALLIUM [n PROTHALLI or PROTHALLUSES]\n",
  "PROTHALLUSES": "PROTHALLUS, the free-living gametophyte of a fern or other vascular cryptogam, also PROTHALLIUM [n]\n",
  "PROTHESES": "PROTHESIS, the development of an extra initial sound at the beginning of a word [n]\n",
  "PROTHESIS": "the development of an extra initial sound at the beginning of a word [n PROTHESES]\n",
  "PROTHETIC": "of or pertaining to prothesis, the development of an extra initial sound at the beginning of a word [adj PROTHETICALLY]\n",
  "PROTHETICALLY": "PROTHETIC, of or pertaining to prothesis, the development of an extra initial sound at the beginning of a word [adv]\n",
  "PROTHONOTARIAL": "of or like a prothonotary [adj]\n",
  "PROTHONOTARIAT": "the college constituted by the twelve apostolical prothonotaries (bishops and senior members of the curia) in Rome, also PROTONOTARIAT [n -S]\n",
  "PROTHONOTARIATS": "PROTHONOTARIAT, the college constituted by the twelve apostolical prothonotaries (bishops and senior members of the curia) in Rome, also PROTONOTARIAT [n]\n",
  "PROTHONOTARIES": "PROTHONOTARY, a court clerk; a chief clerk of any of various courts of law, also PROTONOTARY [n]\n",
  "PROTHONOTARY": "a court clerk; a chief clerk of any of various courts of law, also PROTONOTARY [n PROTHONOTARIES]\n",
  "PROTHORACES": "PROTHORAX, the first or anterior segment of the thorax in insects [n]\n",
  "PROTHORACIC": "of or relating to the prothorax [adj]\n",
  "PROTHORAX": "the first or anterior segment of the thorax in insects [n PROTHORAXES or PROTHORACES]\n",
  "PROTHORAXES": "PROTHORAX, the first or anterior segment of the thorax in insects [n]\n",
  "PROTHROMBIN": "a protein-like substance present in blood plasma [n -S]\n",
  "PROTHROMBINS": "PROTHROMBIN, a protein-like substance present in blood plasma [n]\n",
  "PROTHYL": "(Greek) a hypothetical source of the chemical elements, also PROTYLE, PROTYL [n -S]\n",
  "PROTHYLS": "PROTHYL, (Greek) a hypothetical source of the chemical elements, also PROTYLE, PROTYL [n]\n",
  "PROTIST": "one of the Protista, protozoans, algae, bacteria, and other forms not readily classified as plant or animal, also PROTISTAN [n -S]\n",
  "PROTISTAN": "one of the Protista, protozoans, algae, bacteria, and other forms not readily classified as plant or animal, also PROTIST [n -S]\n",
  "PROTISTANS": "PROTISTAN, one of the Protista, protozoans, algae, bacteria, and other forms not readily classified as plant or animal, also PROTIST [n]\n",
  "PROTISTIC": "of or like a protist [adj]\n",
  "PROTISTOLOGIES": "PROTISTOLOGY, the study of protists [n]\n",
  "PROTISTOLOGIST": "a specialist in protistology [n -S]\n",
  "PROTISTOLOGISTS": "PROTISTOLOGIST, a specialist in protistology [n]\n",
  "PROTISTOLOGY": "the study of protists [n PROTISTOLOGIES]\n",
  "PROTISTS": "PROTIST, one of the Protista, protozoans, algae, bacteria, and other forms not readily classified as plant or animal, also PROTISTAN [n]\n",
  "PROTIUM": "ordinary hydrogen of atomic weight 1, as distinct from deuterium and tritium [n -S]\n",
  "PROTIUMS": "PROTIUM, ordinary hydrogen of atomic weight 1, as distinct from deuterium and tritium [n]\n",
  "PROTO": "(tradename) as in proto team, a team of people trained to deal with underground rescues, etc. [adj]\n",
  "PROTOACTINIUM": "a radioactive element that yields actinium on disintegration [n -S]\n",
  "PROTOACTINIUMS": "PROTOACTINIUM, a radioactive element that yields actinium on disintegration [n]\n",
  "PROTOAVIS": "a member of the genus Protoavis of the Triassic periods, with dinosaur-like tail and hind legs, but some anatomical features characteristic of modern birds [n PROTOAVISES]\n",
  "PROTOAVISES": "PROTOAVIS, a member of the genus Protoavis of the Triassic periods, with dinosaur-like tail and hind legs, but some anatomical features characteristic of modern birds [n]\n",
  "PROTOCHORDATE": "a member of the Protochordata [n -S]\n",
  "PROTOCHORDATES": "PROTOCHORDATE, a member of the Protochordata [n]\n",
  "PROTOCOCCAL": "relating to the Protoccus genus of unicellular algae [adj]\n",
  "PROTOCOL": "the original copy of any writing, as of a deed, treaty, dispatch, or other instrument [n -S] / to draw up a protocol [v PROTOCOLED or PROTOCOLLED, PROTOCOLING or PROTOCOLLING, PROTOCOLS]\n",
  "PROTOCOLED": "PROTOCOL, to draw up a protocol [v]\n",
  "PROTOCOLIC": "of or like protocol [adj]\n",
  "PROTOCOLING": "PROTOCOL, to draw up a protocol [v]\n",
  "PROTOCOLISE": "to make a protocol of, also PROTOCOLIZE [v PROTOCOLISED, PROTOCOLISING, PROTOCOLISES]\n",
  "PROTOCOLISED": "PROTOCOLISE, to make a protocol of, also PROTOCOLIZE [v]\n",
  "PROTOCOLISES": "PROTOCOLISE, to make a protocol of, also PROTOCOLIZE [v]\n",
  "PROTOCOLISING": "PROTOCOLISE, to make a protocol of, also PROTOCOLIZE [v]\n",
  "PROTOCOLIST": "a registrar or clerk [n -S]\n",
  "PROTOCOLISTS": "PROTOCOLIST, a registrar or clerk [n]\n",
  "PROTOCOLIZE": "to make a protocol of, also PROTOCOLISE [v PROTOCOLIZED, PROTOCOLIZING, PROTOCOLIZES]\n",
  "PROTOCOLIZED": "PROTOCOLIZE, to make a protocol of, also PROTOCOLISE [v]\n",
  "PROTOCOLIZES": "PROTOCOLIZE, to make a protocol of, also PROTOCOLISE [v]\n",
  "PROTOCOLIZING": "PROTOCOLIZE, to make a protocol of, also PROTOCOLISE [v]\n",
  "PROTOCOLLED": "PROTOCOL, to draw up a protocol [v]\n",
  "PROTOCOLLING": "PROTOCOL, to draw up a protocol [v]\n",
  "PROTOCOLS": "PROTOCOL, to draw up a protocol [v]\n",
  "PROTOCTIST": "any unicellular or simple multicellular organism belonging to the kingdom Protoctista, which includes protozoans, algae, and slime moulds [n -S]\n",
  "PROTOCTISTS": "PROTOCTIST, any unicellular or simple multicellular organism belonging to the kingdom Protoctista, which includes protozoans, algae, and slime moulds [n]\n",
  "PROTODERM": "the dermatogen, the nascent epidermis, or external cuticle of plants in a forming condition [n -S]\n",
  "PROTODERMS": "PROTODERM, the dermatogen, the nascent epidermis, or external cuticle of plants in a forming condition [n]\n",
  "PROTOGALAXIES": "PROTOGALAXY, a galaxy in its initial state of formation [n]\n",
  "PROTOGALAXY": "a galaxy in its initial state of formation [n PROTOGALAXIES]\n",
  "PROTOGENIC": "of a compound, able to donate a hydrogen ion (proton) in a chemical reaction [adj]\n",
  "PROTOGINE": "a kind of granite or gneiss containing a silvery talcose mineral [n -S]\n",
  "PROTOGINES": "PROTOGINE, a kind of granite or gneiss containing a silvery talcose mineral [n]\n",
  "PROTOGYNIES": "PROTOGYNY, the development of female organs before male to avoid self-fertilization [n]\n",
  "PROTOGYNOUS": "exhibiting protogyny [adj]\n",
  "PROTOGYNY": "the development of female organs before male to avoid self-fertilization [n PROTOGYNIES]\n",
  "PROTOHISTORIAN": "one who studies protohistory [n -S]\n",
  "PROTOHISTORIANS": "PROTOHISTORIAN, one who studies protohistory [n]\n",
  "PROTOHISTORIC": "relating to protohistory [adj]\n",
  "PROTOHISTORIES": "PROTOHISTORY, the study of human beings in the times that immediately antedate recorded history [n]\n",
  "PROTOHISTORY": "the study of human beings in the times that immediately antedate recorded history [n PROTOHISTORIES]\n",
  "PROTOHUMAN": "a prehistoric primate, a supposed ancestor of modern man [n -S]\n",
  "PROTOHUMANS": "PROTOHUMAN, a prehistoric primate, a supposed ancestor of modern man [n]\n",
  "PROTOLANGUAGE": "an assumed or recorded ancestral language [n -S]\n",
  "PROTOLANGUAGES": "PROTOLANGUAGE, an assumed or recorded ancestral language [n]\n",
  "PROTOLITHIC": "pertaining to earliest Stone Age [adj]\n",
  "PROTOMARTYR": "the first martyr in any cause, esp. St Stephen [n -S]\n",
  "PROTOMARTYRS": "PROTOMARTYR, the first martyr in any cause, esp. St Stephen [n]\n",
  "PROTOMORPHIC": "primordial; primitive [adj]\n",
  "PROTON": "a subatomic particle [n -S]\n",
  "PROTONATE": "to acquire an additional proton [v PROTONATED, PROTONATING, PROTONATES]\n",
  "PROTONATED": "PROTONATE, to acquire an additional proton [v]\n",
  "PROTONATES": "PROTONATE, to acquire an additional proton [v]\n",
  "PROTONATING": "PROTONATE, to acquire an additional proton [v]\n",
  "PROTONATION": "the acquisition of an additional proton [n -S]\n",
  "PROTONATIONS": "PROTONATION, the acquisition of an additional proton [n]\n",
  "PROTONEMA": "a branched filament produced by germination of a moss spore, giving rise to moss plants from buds [n PROTONEMATA]\n",
  "PROTONEMAL": "of or like a protonema, the primary growth from the spore of a moss, also PROTONEMATAL [adj]\n",
  "PROTONEMATA": "PROTONEMA, a branched filament produced by germination of a moss spore, giving rise to moss plants from buds [n]\n",
  "PROTONEMATAL": "of or like a protonema, the primary growth from the spore of a moss, also PROTONEMAL [adj]\n",
  "PROTONIC": "relating to a proton [adj]\n",
  "PROTONOTARIAL": "of or like a protonotary, a principle law clerk in certain courts of law [adj]\n",
  "PROTONOTARIAT": "the college constituted by the twelve apostolical prothonotaries (bishops and senior members of the curia) in Rome, also PROTHONOTARIAT [n -S]\n",
  "PROTONOTARIATS": "PROTONOTARIAT, the college constituted by the twelve apostolical prothonotaries (bishops and senior members of the curia) in Rome, also PROTHONOTARIAT [n]\n",
  "PROTONOTARIES": "PROTONOTARY, a court clerk; a chief clerk of any of various courts of law, also PROTHONOTARY [n]\n",
  "PROTONOTARY": "a court clerk; a chief clerk of any of various courts of law, also PROTHONOTARY [n PROTONOTARIES]\n",
  "PROTONS": "PROTON, a subatomic particle [n]\n",
  "PROTOPATHIC": "pertaining to reception by nerves, etc. of only coarse stimuli such as heat, pain, etc.; pertaining to such nerves [adj]\n",
  "PROTOPATHIES": "PROTOPATHY, first or direct experience [n]\n",
  "PROTOPATHY": "first or direct experience [n PROTOPATHIES]\n",
  "PROTOPHILIC": "having or involving an affinity for hydrogen ions (protons) [adj]\n",
  "PROTOPHLOEM": "the first-formed phloem that develops from procambium, usually associated with a region of rapid growth [n -S]\n",
  "PROTOPHLOEMS": "PROTOPHLOEM, the first-formed phloem that develops from procambium, usually associated with a region of rapid growth [n]\n",
  "PROTOPHYTE": "any unicellular plant, or plant forming only a plasmodium, having reproduction only by fission, gemmation, or cell division [n -S]\n",
  "PROTOPHYTES": "PROTOPHYTE, any unicellular plant, or plant forming only a plasmodium, having reproduction only by fission, gemmation, or cell division [n]\n",
  "PROTOPHYTIC": "relating to a protophyte [adj]\n",
  "PROTOPLANET": "a planet in its initial state of formation [n -S]\n",
  "PROTOPLANETARY": "of or like a protoplanet [adj]\n",
  "PROTOPLANETS": "PROTOPLANET, a planet in its initial state of formation [n]\n",
  "PROTOPLASM": "the complex translucent colourless colloidal material comprising the living part of a cell [n -S]\n",
  "PROTOPLASMAL": "of or like protoplasm, also PROTOPLASMATIC, PROTOPLASMIC, PROTOPLASTIC [adj]\n",
  "PROTOPLASMATIC": "of or like protoplasm, also PROTOPLASMAL, PROTOPLASMIC, PROTOPLASTIC [adj]\n",
  "PROTOPLASMIC": "of or like protoplasm, also PROTOPLASMAL, PROTOPLASMATIC, PROTOPLASTIC [adj]\n",
  "PROTOPLASMS": "PROTOPLASM, the complex translucent colourless colloidal material comprising the living part of a cell [n]\n",
  "PROTOPLAST": "living material within a cell divided into discrete structures; the protein of which cells are composed [n -S]\n",
  "PROTOPLASTIC": "of or like protoplasm, also PROTOPLASMAL, PROTOPLASMATIC, PROTOPLASMIC [adj]\n",
  "PROTOPLASTS": "PROTOPLAST, living material within a cell divided into discrete structures; the protein of which cells are composed [n]\n",
  "PROTOPOD": "a part of a crustacean appendage [n -S]\n",
  "PROTOPODS": "PROTOPOD, a part of a crustacean appendage [n]\n",
  "PROTOPORPHYRIN": "metal-free porphyrin derived from blood hemin [n -S]\n",
  "PROTOPORPHYRINS": "PROTOPORPHYRIN, metal-free porphyrin derived from blood hemin [n]\n",
  "PROTORE": "an earlier unenriched form of a mineral ore [n -S]\n",
  "PROTORES": "PROTORE, an earlier unenriched form of a mineral ore [n]\n",
  "PROTOSPATAIRE": "the captain of the guards at Byzantium, also PROTOSPATHAIRE, PROTOSPATHARIUS [n -S]\n",
  "PROTOSPATAIRES": "PROTOSPATAIRE, the captain of the guards at Byzantium, also PROTOSPATHAIRE, PROTOSPATHARIUS [n]\n",
  "PROTOSPATHAIRE": "(historical) the captain of the guards at Byzantium, also PROTOSPATAIRE, PROTOSPATHARIUS [n -S]\n",
  "PROTOSPATHAIRES": "PROTOSPATHAIRE, (historical) the captain of the guards at Byzantium, also PROTOSPATAIRE, PROTOSPATHARIUS [n]\n",
  "PROTOSPATHARIUS": "(historical) the captain of the guards at Byzantium, also PROTOSPATAIRE, PROTOSPATHAIRE [n]\n",
  "PROTOSTAR": "a condensing mass of gas in the early formation of a star [n -S]\n",
  "PROTOSTARS": "PROTOSTAR, a condensing mass of gas in the early formation of a star [n]\n",
  "PROTOSTELE": "a stele in which the vascular tissue forms a solid core, with centrally placed xylem surrounded by phloem [n -S]\n",
  "PROTOSTELES": "PROTOSTELE, a stele in which the vascular tissue forms a solid core, with centrally placed xylem surrounded by phloem [n]\n",
  "PROTOSTELIC": "of or like a protostele [adj]\n",
  "PROTOSTOME": "a major group of bilateral metazoan animals, that includes mollusks and annelids [n -S]\n",
  "PROTOSTOMES": "PROTOSTOME, a major group of bilateral metazoan animals, that includes mollusks and annelids [n]\n",
  "PROTOTHERIAN": "pertaining to a member of Prototheria, which comprises the order Monotremata and related fossil forms [adj] / a member of the Prototheria [n -S]\n",
  "PROTOTHERIANS": "PROTOTHERIAN, a member of the Prototheria [n]\n",
  "PROTOTROPH": "a bacterium feeding only on inorganic matter [n -S]\n",
  "PROTOTROPHIC": "of bacteria, feeding directly on uncombined elements [adj]\n",
  "PROTOTROPHIES": "PROTOTROPHY, the state of being prototrophic [n]\n",
  "PROTOTROPHS": "PROTOTROPH, a bacterium feeding only on inorganic matter [n]\n",
  "PROTOTROPHY": "the state of being prototrophic [n PROTOTROPHIES]\n",
  "PROTOTYPAL": "relating to a prototype, also PROTOTYPIC, PROTOTYPICAL [adj]\n",
  "PROTOTYPE": "the first or original type or model from which anything is copied [n -S] / to make a prototype [v PROTOTYPED, PROTOTYPING, PROTOTYPES]\n",
  "PROTOTYPED": "PROTOTYPE, to make a prototype [v]\n",
  "PROTOTYPES": "PROTOTYPE, to make a prototype [v]\n",
  "PROTOTYPIC": "relating to a prototype, also PROTOTYPAL, PROTOTYPICAL [adj]\n",
  "PROTOTYPICAL": "relating to a prototype, also PROTOTYPAL, PROTOTYPIC [adj PROTOTYPICALLY]\n",
  "PROTOTYPICALLY": "PROTOTYPICAL, relating to a prototype, also PROTOTYPAL, PROTOTYPIC [adv]\n",
  "PROTOTYPING": "PROTOTYPE, to make a prototype [v]\n",
  "PROTOXID": "that one of a series of oxides having the lowest proportion of oxygen, also PROTOXIDE [n -S]\n",
  "PROTOXIDE": "that one of a series of oxides having the lowest proportion of oxygen, also PROTOXID [n -S]\n",
  "PROTOXIDES": "PROTOXIDE, that one of a series of oxides having the lowest proportion of oxygen, also PROTOXID [n]\n",
  "PROTOXIDS": "PROTOXID, that one of a series of oxides having the lowest proportion of oxygen, also PROTOXIDE [n]\n",
  "PROTOXYLEM": "the first part of the xylem to be formed [n -S]\n",
  "PROTOXYLEMS": "PROTOXYLEM, the first part of the xylem to be formed [n]\n",
  "PROTOZOA": "PROTOZOON, any member of the Protozoa, also PROTOZOAN [n]\n",
  "PROTOZOAL": "of or pertaining to the Protozoa [adj]\n",
  "PROTOZOAN": "any member of the Protozoa, also PROTOZOON [n -S]\n",
  "PROTOZOANS": "PROTOZOAN, any member of the Protozoa, also PROTOZOON [n]\n",
  "PROTOZOIC": "of or pertaining to the protozoa [adj]\n",
  "PROTOZOOLOGICAL": "related to protozoology [adj]\n",
  "PROTOZOOLOGIES": "PROTOZOOLOGY, the study of protozoans [n]\n",
  "PROTOZOOLOGIST": "one who studies protozoology [n -S]\n",
  "PROTOZOOLOGISTS": "PROTOZOOLOGIST, one who studies protozoology [n]\n",
  "PROTOZOOLOGY": "the study of protozoans [n PROTOZOOLOGIES]\n",
  "PROTOZOON": "any member of the Protozoa, also PROTOZOAN [n PROTOZOA or PROTOZOONS]\n",
  "PROTOZOONS": "PROTOZOON, any member of the Protozoa, also PROTOZOAN [n]\n",
  "PROTRACT": "to prolong [v -ED, -ING, -S]\n",
  "PROTRACTED": "PROTRACT, to prolong [v]\n",
  "PROTRACTEDLY": "PROTRACTED, PROTRACT, to prolong [adv]\n",
  "PROTRACTEDNESS": "the state of being protracted [n]\n",
  "PROTRACTIBLE": "able to be thrust out, also PROTRACTILE [adj]\n",
  "PROTRACTILE": "able to be thrust out, also PROTRACTIBLE [adj]\n",
  "PROTRACTING": "PROTRACT, to prolong [v]\n",
  "PROTRACTION": "the act of protracting [n -S]\n",
  "PROTRACTIONS": "PROTRACTION, the act of protracting [n]\n",
  "PROTRACTIVE": "serving to protract [adj]\n",
  "PROTRACTOR": "one who, or that which, protracts [n -S]\n",
  "PROTRACTORS": "PROTRACTOR, one who, or that which, protracts [n]\n",
  "PROTRACTS": "PROTRACT, to prolong [v]\n",
  "PROTRADE": "in favour of trade [adj]\n",
  "PROTREPTIC": "exhorting or encouraging, also PROTREPTICAL [adj] / an exhortation [n -S]\n",
  "PROTREPTICAL": "exhorting or encouraging, also PROTREPTIC [adj]\n",
  "PROTREPTICS": "PROTREPTIC, an exhortation [n]\n",
  "PROTRUDABLE": "that can be protruded, also PROTRUSIBLE, PROTRUSILE [adj]\n",
  "PROTRUDE": "to stick out [v PROTRUDED, PROTRUDING, PROTRUDES]\n",
  "PROTRUDED": "PROTRUDE, to stick out [v]\n",
  "PROTRUDENT": "protruding [adj]\n",
  "PROTRUDES": "PROTRUDE, to stick out [v]\n",
  "PROTRUDING": "PROTRUDE, to stick out [v]\n",
  "PROTRUSIBLE": "that can be protruded, also PROTRUDABLE, PROTRUSILE [adj]\n",
  "PROTRUSILE": "that can be protruded, also PROTRUDABLE, PROTRUSIBLE [adj]\n",
  "PROTRUSION": "the act of protruding [n -S]\n",
  "PROTRUSIONS": "PROTRUSION, the act of protruding [n]\n",
  "PROTRUSIVE": "thrusting or impelling forward; as, protrusive motion [adj PROTRUSIVELY]\n",
  "PROTRUSIVELY": "PROTRUSIVE, thrusting or impelling forward; as, protrusive motion [adv]\n",
  "PROTRUSIVENESS": "PROTRUSIVE, thrusting or impelling forward; as, protrusive motion [n]\n",
  "PROTUBERANCE": "a swelling or bump on the surface, also PROTUBERANCY [n -S]\n",
  "PROTUBERANCES": "PROTUBERANCE, a swelling or bump on the surface, also PROTUBERANCY [n]\n",
  "PROTUBERANCIES": "PROTUBERANCY, a swelling or bump on the surface, also PROTUBERANCE [n]\n",
  "PROTUBERANCY": "a swelling or bump on the surface, also PROTUBERANCE [n PROTUBERANCIES]\n",
  "PROTUBERANT": "thrusting out from a surrounding or adjacent surface often as a rounded mass [adj PROTUBERANTLY]\n",
  "PROTUBERANTLY": "PROTUBERANT, thrusting out from a surrounding or adjacent surface often as a rounded mass [adv]\n",
  "PROTUBERATE": "to bulge out [v PROTUBERATED, PROTUBERATING, PROTUBERATES]\n",
  "PROTUBERATED": "PROTUBERATE, to bulge out [v]\n",
  "PROTUBERATES": "PROTUBERATE, to bulge out [v]\n",
  "PROTUBERATING": "PROTUBERATE, to bulge out [v]\n",
  "PROTUBERATION": "a swelling out, a bulge [n -S]\n",
  "PROTUBERATIONS": "PROTUBERATION, a swelling out, a bulge [n]\n",
  "PROTURAN": "any of an order of white wingless insects [n -S]\n",
  "PROTURANS": "PROTURAN, any of an order of white wingless insects [n]\n",
  "PROTYL": "(Greek) a hypothetical source of the chemical elements, also PROTYLE, PROTHYL [n -S]\n",
  "PROTYLE": "(Greek) a hypothetical source of the chemical elements, also PROTHYL, PROTYL [n -S]\n",
  "PROTYLES": "PROTYLE, (Greek) a hypothetical source of the chemical elements, also PROTHYL, PROTYL [n]\n",
  "PROTYLS": "PROTYL, (Greek) a hypothetical source of the chemical elements, also PROTYLE, PROTHYL [n]\n",
  "PROUD": "having or displaying pride [adj PROUDER, PROUDEST, PROUDLY]\n",
  "PROUDER": "PROUD, having or displaying pride [adj]\n",
  "PROUDEST": "PROUD, having or displaying pride [adj]\n",
  "PROUDFUL": "(dialect) full of pride [adj]\n",
  "PROUDHEARTED": "proud in spirit [adj]\n",
  "PROUDISH": "somewhat proud [adj]\n",
  "PROUDLY": "PROUD, having or displaying pride [adv]\n",
  "PROUDNESS": "the quality of being proud [n -ES]\n",
  "PROUDNESSES": "PROUDNESS, the quality of being proud [n]\n",
  "PROUL": "to prowl, also PROLE, PROLL [v -ED, -ING, -S]\n",
  "PROULED": "PROUL, to prowl, also PROLE, PROLL [v]\n",
  "PROULER": "(obsolete) a prowler, also PROLER, PROLLER [n -S]\n",
  "PROULERS": "PROULER, (obsolete) a prowler, also PROLER, PROLLER [n]\n",
  "PROULING": "PROUL, to prowl, also PROLE, PROLL [v]\n",
  "PROULS": "PROUL, to prowl, also PROLE, PROLL [v]\n",
  "PROUNION": "favouring labour unions [adj]\n",
  "PROUSTITE": "a red silver ore, sulphide of arsenic and silver, aka ruby silver ore [n -S]\n",
  "PROUSTITES": "PROUSTITE, a red silver ore, sulphide of arsenic and silver, aka ruby silver ore [n]\n",
  "PROVABILITIES": "PROVABILITY, the state of being provable, also PROVEABILITY [n]\n",
  "PROVABILITY": "the state of being provable, also PROVEABILITY [n PROVABILITIES]\n",
  "PROVABLE": "that can be proved, also PROVEABLE [adj PROVABLY]\n",
  "PROVABLENESS": "the state of being provable [n -ES]\n",
  "PROVABLENESSES": "PROVABLENESS, the state of being provable [n]\n",
  "PROVABLY": "PROVABLE, that can be proved, also PROVEABLE [adv]\n",
  "PROVAND": "an allowance of food, also PROVEND, PROVENDER, PROVIANT [n -S]\n",
  "PROVANDS": "PROVAND, an allowance of food, also PROVEND, PROVENDER, PROVIANT [n]\n",
  "PROVANT": "(obsolete) to supply with provisions [v -ED, -ING, -S]\n",
  "PROVANTED": "PROVANT, (obsolete) to supply with provisions [v]\n",
  "PROVANTING": "PROVANT, (obsolete) to supply with provisions [v]\n",
  "PROVANTS": "PROVANT, (obsolete) to supply with provisions [v]\n",
  "PROVASCULAR": "of, relating to, or being procambium [adj]\n",
  "PROVE": "to establish as certain or true [v PROVED, PROVEN, PROVING, PROVES]\n",
  "PROVEABILITIES": "PROVEABILITY, the capacity for being proved, also PROVABILITY [n]\n",
  "PROVEABILITY": "the capacity for being proved, also PROVABILITY [n PROVEABILITIES]\n",
  "PROVEABLE": "that can be proved, also PROVABLE [adj PROVEABLY]\n",
  "PROVEABLY": "PROVEABLE, that can be proved, also PROVABLE [adv]\n",
  "PROVECTION": "the carrying forward of a sound at the end of a word to the beginning of the next (as 'a newt' from original from 'an ewt') [n -S]\n",
  "PROVECTIONS": "PROVECTION, the carrying forward of a sound at the end of a word to the beginning of the next (as 'a newt' from original from 'an ewt') [n]\n",
  "PROVED": "PROVE, to establish as certain or true [v]\n",
  "PROVEDITOR": "a purveyor, also PROVEDITORE, PROVEDOR, PROVEDORE, PROVIDOR, PROVISOR [n -S]\n",
  "PROVEDITORE": "a purveyor, also PROVEDITOR, PROVEDOR, PROVEDORE, PROVIDOR, PROVISOR [n -S]\n",
  "PROVEDITORES": "PROVEDITORE, a purveyor, also PROVEDITOR, PROVEDOR, PROVEDORE, PROVIDOR, PROVISOR [n]\n",
  "PROVEDITORS": "PROVEDITOR, a purveyor, also PROVEDITORE, PROVEDOR, PROVEDORE, PROVIDOR, PROVISOR [n]\n",
  "PROVEDOR": "a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDORE, PROVIDOR, PROVISOR [n -S]\n",
  "PROVEDORE": "a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDOR, PROVIDOR, PROVISOR [n -S]\n",
  "PROVEDORES": "PROVEDORE, a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDOR, PROVIDOR, PROVISOR [n]\n",
  "PROVEDORS": "PROVEDOR, a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDORE, PROVIDOR, PROVISOR [n]\n",
  "PROVEN": "PROVE, to establish as certain or true [v]\n",
  "PROVENANCE": "an origin, source, also PROVENIENCE [n -S]\n",
  "PROVENANCES": "PROVENANCE, an origin, source, also PROVENIENCE [n]\n",
  "PROVEND": "an allowance of food, also PROVAND, PROVENDER, PROVIANT [n -S]\n",
  "PROVENDER": "dry food for domestic animals, as hay, straw, corn, oats, also PROVAND, PROVEND, PROVIANT [n -S] / to supply with provender [v -ED, -ING, -S]\n",
  "PROVENDERED": "PROVENDER, to supply with provender [v]\n",
  "PROVENDERING": "PROVENDER, to supply with provender [v]\n",
  "PROVENDERS": "PROVENDER, to supply with provender [v]\n",
  "PROVENDS": "PROVEND, an allowance of food, also PROVAND, PROVENDER, PROVIANT [n]\n",
  "PROVENIENCE": "an origin, source, also PROVENANCE [n -S]\n",
  "PROVENIENCES": "PROVENIENCE, an origin, source, also PROVENANCE [n]\n",
  "PROVENLY": "without doubt [adv]\n",
  "PROVENTRICULAR": "relating to the proventriculus, the first part of a bird's stomach [adj]\n",
  "PROVENTRICULI": "PROVENTRICULUS, the first part of a bird's stomach, aka gizzard [n]\n",
  "PROVENTRICULUS": "the first part of a bird's stomach, aka gizzard [n PROVENTRICULI]\n",
  "PROVER": "one who proves [n -S]\n",
  "PROVERB": "a short familiar saying expressing a supposed truth or moral lesson [n -S] / to speak of proverbially [v -ED, -ING, -S]\n",
  "PROVERBED": "PROVERB, to speak of proverbially [v]\n",
  "PROVERBIAL": "of or like a proverb [adj PROVERBIALLY]\n",
  "PROVERBIALISE": "to make proverbial, also PROVERBIALIZE [v PROVERBIALISED, PROVERBIALISING, PROVERBIALISES]\n",
  "PROVERBIALISED": "PROVERBIALISE, to make proverbial, also PROVERBIALIZE [v]\n",
  "PROVERBIALISES": "PROVERBIALISE, to make proverbial, also PROVERBIALIZE [v]\n",
  "PROVERBIALISING": "PROVERBIALISE, to make proverbial, also PROVERBIALIZE [v]\n",
  "PROVERBIALISM": "a saying in the form of, or like, a proverb [n -S]\n",
  "PROVERBIALISMS": "PROVERBIALISM, a saying in the form of, or like, a proverb [n]\n",
  "PROVERBIALIST": "one who speaks a proverbialism [n -S]\n",
  "PROVERBIALISTS": "PROVERBIALIST, one who speaks a proverbialism [n]\n",
  "PROVERBIALIZE": "to make proverbial, also PROVERBIALISE [v PROVERBIALIZED, PROVERBIALIZING, PROVERBIALIZES]\n",
  "PROVERBIALIZED": "PROVERBIALIZE, to make proverbial, also PROVERBIALISE [v]\n",
  "PROVERBIALIZES": "PROVERBIALIZE, to make proverbial, also PROVERBIALISE [v]\n",
  "PROVERBIALIZING": "PROVERBIALIZE, to make proverbial, also PROVERBIALISE [v]\n",
  "PROVERBIALLY": "PROVERBIAL, of or like a proverb [adv]\n",
  "PROVERBING": "PROVERB, to speak of proverbially [v]\n",
  "PROVERBS": "PROVERB, to speak of proverbially [v]\n",
  "PROVERS": "PROVER, one who proves [n]\n",
  "PROVES": "PROVE, to establish as certain or true [v]\n",
  "PROVIANT": "an allowance of food, also PROVAND, PROVEND, PROVENDER [n -S]\n",
  "PROVIANTS": "PROVIANT, an allowance of food, also PROVAND, PROVEND, PROVENDER [n]\n",
  "PROVIDABLE": "that can be provided [adj]\n",
  "PROVIDE": "to supply [v PROVIDED, PROVIDING, PROVIDES]\n",
  "PROVIDED": "PROVIDE, to supply [v]\n",
  "PROVIDENCE": "divine guidance or care [n -S]\n",
  "PROVIDENCES": "PROVIDENCE, divine guidance or care [n]\n",
  "PROVIDENT": "seeing beforehand, and providing for the future [adj PROVIDENTLY]\n",
  "PROVIDENTIAL": "of, relating to, or determined by Providence [adj PROVIDENTIALLY]\n",
  "PROVIDENTIALLY": "PROVIDENTIAL, of, relating to, or determined by Providence [adv]\n",
  "PROVIDENTLY": "PROVIDENT, seeing beforehand, and providing for the future [adv]\n",
  "PROVIDER": "one that provides [n -S]\n",
  "PROVIDERS": "PROVIDER, one that provides [n]\n",
  "PROVIDES": "PROVIDE, to supply [v]\n",
  "PROVIDING": "PROVIDE, to supply [v]\n",
  "PROVIDOR": "a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDOR, PROVEDORE, PROVISOR [n -S]\n",
  "PROVIDORS": "PROVIDOR, a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDOR, PROVEDORE, PROVISOR [n]\n",
  "PROVINCE": "an administrative division of a country [n -S]\n",
  "PROVINCES": "PROVINCE, an administrative division of a country [n]\n",
  "PROVINCEWIDE": "extending throughout a province [adj]\n",
  "PROVINCIAL": "relating to the provinces [adj PROVINCIALLY] / one who lives in the provinces [n -S]\n",
  "PROVINCIALISE": "to make provincial, also PROVINCIALIZE [v PROVINCIALISED, PROVINCIALISING, PROVINCIALISES]\n",
  "PROVINCIALISED": "PROVINCIALISE, to make provincial, also PROVINCIALIZE [v]\n",
  "PROVINCIALISES": "PROVINCIALISE, to make provincial, also PROVINCIALIZE [v]\n",
  "PROVINCIALISING": "PROVINCIALISE, to make provincial, also PROVINCIALIZE [v]\n",
  "PROVINCIALISM": "a dialectal or local word, phrase, or idiom [n -S]\n",
  "PROVINCIALISMS": "PROVINCIALISM, a dialectal or local word, phrase, or idiom [n]\n",
  "PROVINCIALIST": "a native or inhabitant of a province [n -S]\n",
  "PROVINCIALISTS": "PROVINCIALIST, a native or inhabitant of a province [n]\n",
  "PROVINCIALITIES": "PROVINCIALITY, the state of being provincial [n]\n",
  "PROVINCIALITY": "the state of being provincial [n PROVINCIALITIES]\n",
  "PROVINCIALIZE": "to make provincial, also PROVINCIALISE [v PROVINCIALIZED, PROVINCIALIZES]\n",
  "PROVINCIALIZED": "PROVINCIALIZE, to make provincial, also PROVINCIALISE [v]\n",
  "PROVINCIALIZES": "PROVINCIALIZE, to make provincial, also PROVINCIALISE [v]\n",
  "PROVINCIALIZING": "PROVINCIALIZE, to make provincial, also PROVINCIALISE [v]\n",
  "PROVINCIALLY": "PROVINCIAL, relating to the provinces [adv]\n",
  "PROVINCIALS": "PROVINCIAL, one who lives in the provinces [n]\n",
  "PROVINE": "to propagate by layering [v PROVINED, PROVINING, PROVINES]\n",
  "PROVINED": "PROVINE, to propagate by layering [v]\n",
  "PROVINES": "PROVINE, to propagate by layering [v]\n",
  "PROVING": "the act of proving [n -S]\n",
  "PROVINGS": "PROVING, the act of proving [n]\n",
  "PROVINING": "PROVINE, to propagate by layering [v]\n",
  "PROVIRAL": "relating to a provirus, the form of a virus when it is integrated into the DNA of the host cell [adj]\n",
  "PROVIRUS": "the form of a virus when it is integrated into the DNA of the host cell [n -ES]\n",
  "PROVIRUSES": "PROVIRUS, the form of a virus when it is integrated into the DNA of the host cell [n]\n",
  "PROVISION": "the act of providing [n -S] / to provide [v -ED, -ING, -S]\n",
  "PROVISIONAL": "temporary [adj PROVISIONALLY] / a postage stamp for use until a regular issue appears [n -S]\n",
  "PROVISIONALLY": "PROVISIONAL, temporary [adv]\n",
  "PROVISIONALS": "PROVISIONAL, a postage stamp for use until a regular issue appears [n]\n",
  "PROVISIONARIES": "PROVISIONARY, something provisional [n]\n",
  "PROVISIONARY": "provisional [adj] / something provisional [n PROVISIONARIES]\n",
  "PROVISIONED": "PROVISION, to provide [v]\n",
  "PROVISIONER": "a furnisher of provisions [n -S]\n",
  "PROVISIONERS": "PROVISIONER, a furnisher of provisions [n]\n",
  "PROVISIONING": "PROVISION, to provide [v]\n",
  "PROVISIONS": "PROVISION, the act of providing [n]\n",
  "PROVISO": "(Latin) a clause in a document containing a condition [n -S or -ES]\n",
  "PROVISOES": "PROVISO, (Latin) a clause in a document containing a condition [n]\n",
  "PROVISOR": "(historical) one who provides; a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDOR, PROVEDORE, PROVIDOR [n -S]\n",
  "PROVISORILY": "PROVISORY, of the nature of a proviso; containing a proviso or condition [adv]\n",
  "PROVISORS": "PROVISOR, (historical) one who provides; a purveyor, also PROVEDITOR, PROVEDITORE, PROVEDOR, PROVEDORE, PROVIDOR [n]\n",
  "PROVISORY": "of the nature of a proviso; containing a proviso or condition [adj PROVISORILY]\n",
  "PROVISOS": "PROVISO, (Latin) a clause in a document containing a condition [n]\n",
  "PROVITAMIN": "a pre-vitamin [n -S]\n",
  "PROVITAMINS": "PROVITAMIN, a pre-vitamin [n]\n",
  "PROVOCABLE": "that can be provoked, also PROVOKABLE [adj]\n",
  "PROVOCANT": "one who provokes [n -S]\n",
  "PROVOCANTS": "PROVOCANT, one who provokes [n]\n",
  "PROVOCATEUR": "(French) one who provokes others to commit a crime [n -S]\n",
  "PROVOCATEURS": "PROVOCATEUR, (French) one who provokes others to commit a crime [n]\n",
  "PROVOCATION": "the act of provoking [n -S]\n",
  "PROVOCATIONS": "PROVOCATION, the act of provoking [n]\n",
  "PROVOCATIVE": "serving to provoke [adj PROVOCATIVELY] / something that provokes [n -S]\n",
  "PROVOCATIVELY": "PROVOCATIVE, serving to provoke [adv]\n",
  "PROVOCATIVENESS": "the state of being provocative [n]\n",
  "PROVOCATIVES": "PROVOCATIVE, something that provokes [n]\n",
  "PROVOCATOR": "one who provokes [n -S]\n",
  "PROVOCATORS": "PROVOCATOR, one who provokes [n]\n",
  "PROVOCATORY": "provocative [adj]\n",
  "PROVOKABLE": "that can be provoked, also PROVOCABLE [adj]\n",
  "PROVOKE": "to arouse to anger or sexual desire [v PROVOKED, PROVOKING, PROVOKES]\n",
  "PROVOKED": "PROVOKE, to arouse to anger or sexual desire [v]\n",
  "PROVOKEMENT": "(Spenser) provocation [n -S]\n",
  "PROVOKEMENTS": "PROVOKEMENT, (Spenser) provocation [n]\n",
  "PROVOKER": "something or someone that provokes [n -S]\n",
  "PROVOKERS": "PROVOKER, something or someone that provokes [n]\n",
  "PROVOKES": "PROVOKE, to arouse to anger or sexual desire [v]\n",
  "PROVOKING": "PROVOKE, to arouse to anger or sexual desire [v]\n",
  "PROVOKINGLY": "PROVOKING, PROVOKE, to arouse to anger or sexual desire [adv]\n",
  "PROVOLONE": "(Italian) a firm pliant smoked cheese of Italian origin [n -S]\n",
  "PROVOLONES": "PROVOLONE, (Italian) a firm pliant smoked cheese of Italian origin [n]\n",
  "PROVOST": "a high-ranking university official [n -S]\n",
  "PROVOSTRIES": "PROVOSTRY, the office of provost, the head of certain universities and colleges [n]\n",
  "PROVOSTRY": "the office of provost, the head of certain universities and colleges [n PROVOSTRIES]\n",
  "PROVOSTS": "PROVOST, a high-ranking university official [n]\n",
  "PROVOSTSHIP": "the office of provost [n -S]\n",
  "PROVOSTSHIPS": "PROVOSTSHIP, the office of provost [n]\n",
  "PROW": "the front part of a ship [n -S] / (archaic) full of prowess [adj PROWER, PROWEST]\n",
  "PROWAR": "favouring war [adj]\n",
  "PROWER": "PROW, (archaic) full of prowess [adj]\n",
  "PROWESS": "exceptional ability [n -ES]\n",
  "PROWESSED": "having prowess [adj]\n",
  "PROWESSES": "PROWESS, exceptional ability [n]\n",
  "PROWEST": "PROW, (archaic) full of prowess [adj]\n",
  "PROWL": "to move about stealthily [v -ED, -ING, -S]\n",
  "PROWLED": "PROWL, to move about stealthily [v]\n",
  "PROWLER": "one that prowls, also PROLER, PROLLER, PROULER [n -S]\n",
  "PROWLERS": "PROWLER, one that prowls, also PROLER, PROLLER, PROULER [n]\n",
  "PROWLING": "stealthy [adj PROWLINGLY] / the act of prowling [n -S]\n",
  "PROWLINGLY": "PROWLING, stealthy [adv]\n",
  "PROWLINGS": "PROWLING, the act of prowling [n]\n",
  "PROWLS": "PROWL, to move about stealthily [v]\n",
  "PROWS": "PROW, the front part of a ship [n]\n",
  "PROXEMIC": "pertaining to a branch of environmental study [adj]\n",
  "PROXEMICS": "the study of the human use of physical space in nonverbal communication, esp. the distances that people maintain between themselves and others while interacting [n]\n",
  "PROXIES": "PROXY, a person authorised to act for another [n]\n",
  "PROXIMAL": "located near the point of origin [adj PROXIMALLY]\n",
  "PROXIMALLY": "PROXIMAL, located near the point of origin [adv]\n",
  "PROXIMATE": "nearest or next [adj PROXIMATELY]\n",
  "PROXIMATELY": "PROXIMATE, nearest or next [adv]\n",
  "PROXIMATENESS": "the state of being proximate [n -ES]\n",
  "PROXIMATENESSES": "PROXIMATENESS, the state of being proximate [n]\n",
  "PROXIMATION": "immediate nearness in time, place, relationship, etc., also PROXIMITY [n -S]\n",
  "PROXIMATIONS": "PROXIMATION, immediate nearness in time, place, relationship, etc., also PROXIMITY [n]\n",
  "PROXIMITIES": "PROXIMITY, immediate nearness in time, place, relationship, etc., also PROXIMATION [n]\n",
  "PROXIMITY": "immediate nearness in time, place, relationship, etc., also PROXIMATION [n PROXIMITIES]\n",
  "PROXIMO": "(Latin) of or occurring in the following month [adj]\n",
  "PROXY": "a person authorised to act for another [n PROXIES]\n",
  "PROYN": "to prune, also PROIGN, PROIN, PROINE, PROYNE [v -ED, -ING, -S]\n",
  "PROYNE": "to prune, also PROIGN, PROIN, PROINE, PROYN [v PROYNED, PROYNING, PROYNES]\n",
  "PROYNED": "PROYN, to prune, also PROIGN, PROIN, PROINE, PROYNE [v]\n",
  "PROYNES": "PROYNE, to prune, also PROIGN, PROIN, PROINE, PROYN [v]\n",
  "PROYNING": "PROYN, to prune, also PROIGN, PROIN, PROINE, PROYNE [v]\n",
  "PROYNS": "PROYN, to prune, also PROIGN, PROIN, PROINE, PROYNE [v]\n",
  "PROZYMITE": "a person who uses leavened bread in the Eucharist (as opposed to an azymite) [n -S]\n",
  "PROZYMITES": "PROZYMITE, a person who uses leavened bread in the Eucharist (as opposed to an azymite) [n]\n",
  "PROZZIE": "a prostitute, also PROSS, PROSSIE, PROSTIE [n -S]\n",
  "PROZZIES": "PROZZIE, a prostitute, also PROSS, PROSSIE, PROSTIE [n]\n",
  "PRUDE": "a prudish person [n -S]\n",
  "PRUDENCE": "the quality of being prudent [n -S]\n",
  "PRUDENCES": "PRUDENCE, the quality of being prudent [n]\n",
  "PRUDENT": "cautious, wise and discreet in conduct [adj]\n",
  "PRUDENTIAL": "of or relating to prudence, exercising good judgment [adj PRUDENTIALLY] / a prudent maxim [n -S]\n",
  "PRUDENTIALISM": "a system based on prudence alone [n -S]\n",
  "PRUDENTIALISMS": "PRUDENTIALISM, a system based on prudence alone [n]\n",
  "PRUDENTIALIST": "one who believes in prudentialism [n -S]\n",
  "PRUDENTIALISTS": "PRUDENTIALIST, one who believes in prudentialism [n]\n",
  "PRUDENTIALITIES": "PRUDENTIALITY, the state of being prudential [n]\n",
  "PRUDENTIALITY": "the state of being prudential [n PRUDENTIALITIES]\n",
  "PRUDENTIALLY": "PRUDENTIAL, of or relating to prudence, exercising good judgment [adv]\n",
  "PRUDENTIALS": "PRUDENTIAL, a prudent maxim [n]\n",
  "PRUDENTLY": "PRUDENT, cautious, wise and discreet in conduct [adv]\n",
  "PRUDERIES": "PRUDERY, a person with affected modesty [n]\n",
  "PRUDERY": "a person with affected modesty [n PRUDERIES]\n",
  "PRUDES": "PRUDE, a prudish person [n]\n",
  "PRUDISH": "marked by prudery [adj PRUDISHLY]\n",
  "PRUDISHLY": "PRUDISH, marked by prudery [adv]\n",
  "PRUDISHNESS": "the state of being prudish [n -ES]\n",
  "PRUDISHNESSES": "PRUDISHNESS, the state of being prudish [n]\n",
  "PRUH": "(Scots) a call to a cow to come near, also PROO [interj]\n",
  "PRUINA": "(Latin) a powdery bloom upon the surface of plants [n -S]\n",
  "PRUINAS": "PRUINA, (Latin) a powdery bloom upon the surface of plants [n]\n",
  "PRUINE": "(Shakespeare) a prune, also PREWYN [n -S]\n",
  "PRUINES": "PRUINE, (Shakespeare) a prune, also PREWYN [n]\n",
  "PRUINOSE": "having a powdery covering [adj]\n",
  "PRUNABLE": "able to be pruned [adj]\n",
  "PRUNE": "to trim and shape by cutting back [v PRUNED, PRUNING, PRUNES]\n",
  "PRUNED": "PRUNE, to trim and shape by cutting back [v]\n",
  "PRUNELLA": "a strong silk or woollen material, formerly used for academic and clerical gowns and women's shoes, also PRUNELLE [n -S]\n",
  "PRUNELLAS": "PRUNELLA, a strong silk or woollen material, formerly used for academic and clerical gowns and women's shoes, also PRUNELLE [n]\n",
  "PRUNELLE": "(French) a strong silk or woollen material, formerly used for academic and clerical gowns and women's shoes, also PRUNELLA [n -S]\n",
  "PRUNELLES": "PRUNELLE, (French) a strong silk or woollen material, formerly used for academic and clerical gowns and women's shoes, also PRUNELLA [n]\n",
  "PRUNELLO": "(Italian) a fine kind of prune, esp. one made from a greengage [n -S]\n",
  "PRUNELLOS": "PRUNELLO, (Italian) a fine kind of prune, esp. one made from a greengage [n]\n",
  "PRUNER": "one that prunes [n -S]\n",
  "PRUNERS": "PRUNER, one that prunes [n]\n",
  "PRUNES": "PRUNE, to trim and shape by cutting back [v]\n",
  "PRUNEY": "resembling a prune [adj PRUNIER, PRUNIEST]\n",
  "PRUNIER": "PRUNEY, resembling a prune [adj]\n",
  "PRUNIEST": "PRUNEY, resembling a prune [adj]\n",
  "PRUNING": "the act of pruning [n -S]\n",
  "PRUNINGS": "PRUNING, the act of pruning [n]\n",
  "PRUNT": "a moulded glass ornament attached to a larger glass object [n -S]\n",
  "PRUNTED": "ornamented with a prunt [adj]\n",
  "PRUNTS": "PRUNT, a moulded glass ornament attached to a larger glass object [n]\n",
  "PRUNUS": "(Latin) a genus of tree including plum [n -ES]\n",
  "PRUNUSES": "PRUNUS, (Latin) a genus of tree including plum [n]\n",
  "PRURIENCE": "the state of being prurient, also PRURIENCY [n -S]\n",
  "PRURIENCES": "PRURIENCE, the state of being prurient, also PRURIENCY [n]\n",
  "PRURIENCIES": "PRURIENCY, the state of being prurient, also PRURIENCE [n]\n",
  "PRURIENCY": "the state of being prurient, also PRURIENCE [n PRURIENCIES]\n",
  "PRURIENT": "having lustful thoughts or desires [adj PRURIENTLY]\n",
  "PRURIENTLY": "PRURIENT, having lustful thoughts or desires [adv]\n",
  "PRURIGINOUS": "relating to prurigo [adj]\n",
  "PRURIGO": "(Latin) a chronic skin condition characterized by itching and the presence of small pale pimples [n -S]\n",
  "PRURIGOS": "PRURIGO, (Latin) a chronic skin condition characterized by itching and the presence of small pale pimples [n]\n",
  "PRURITIC": "of or like pruritus, itching of the skin [adj]\n",
  "PRURITUS": "(Latin) intense itching [n -ES]\n",
  "PRURITUSES": "PRURITUS, (Latin) intense itching [n]\n",
  "PRUSIK": "(German) to climb using mountaineering slings [v -ED, -ING, -S]\n",
  "PRUSIKED": "PRUSIK, (German) to climb using mountaineering slings [v]\n",
  "PRUSIKING": "PRUSIK, (German) to climb using mountaineering slings [v]\n",
  "PRUSIKS": "PRUSIK, (German) to climb using mountaineering slings [v]\n",
  "PRUSSIAN": "as in prussian blue, ferric ferrocyanide, a colour pigment, discovered in Berlin [adj]\n",
  "PRUSSIANISATION": "the act of prussianising, also PRUSSIANIZATION [n]\n",
  "PRUSSIANISE": "to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANIZE [v PRUSSIANISED, PRUSSIANISING, PRUSSIANISES]\n",
  "PRUSSIANISED": "PRUSSIANISE, to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANIZE [v]\n",
  "PRUSSIANISES": "PRUSSIANISE, to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANIZE [v]\n",
  "PRUSSIANISING": "PRUSSIANISE, to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANIZE [v]\n",
  "PRUSSIANIZATION": "the act of prussianizing, also PRUSSIANISATION [n]\n",
  "PRUSSIANIZE": "to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANISE [v PRUSSIANIZED, PRUSSIANIZING, PRUSSIANIZES]\n",
  "PRUSSIANIZED": "PRUSSIANIZE, to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANISE [v]\n",
  "PRUSSIANIZES": "PRUSSIANIZE, to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANISE [v]\n",
  "PRUSSIANIZING": "PRUSSIANIZE, to make Prussian in character or principle, as in authoritarian control or rigid discipline, also PRUSSIANISE [v]\n",
  "PRUSSIATE": "a salt of prussic acid; a cyanide [n -S]\n",
  "PRUSSIATES": "PRUSSIATE, a salt of prussic acid; a cyanide [n]\n",
  "PRUSSIC": "pertaining to a type of acid [adj]\n",
  "PRUTA": "(Hebrew) a monetary unit of Israel, also PRUTAH [n PRUTOT]\n",
  "PRUTAH": "(Hebrew) a monetary unit of Israel, also PRUTA [n PRUTOTH]\n",
  "PRUTOT": "PRUTA, (Hebrew) a monetary unit of Israel, also PRUTAH [n]\n",
  "PRUTOTH": "PRUTAH, (Hebrew) a monetary unit of Israel, also PRUTA [n]\n",
  "PRY": "to inquire impertinently into private matters [v PRIED, PRYING, PRIES]\n",
  "PRYER": "one who pries, also PRIER [n -S]\n",
  "PRYERS": "PRYER, one who pries, also PRIER [n]\n",
  "PRYING": "inquisitive [adj PRYINGLY] / the act of prying [n -S]\n",
  "PRYINGLY": "PRYING, inquisitive [adv]\n",
  "PRYINGS": "PRYING, the act of prying [n]\n",
  "PRYS": "(obsolete) to price [v PRYSED, PRYSING, PRYSES]\n",
  "PRYSE": "(Spenser) to pay for [v PRYSED, PRYSING, PRYSES]\n",
  "PRYSED": "PRYSE, (Spenser) to pay for [v]\n",
  "PRYSES": "PRYSE, (Spenser) to pay for [v]\n",
  "PRYSING": "PRYSE, (Spenser) to pay for [v]\n",
  "PRYTANEA": "PRYTANEUM, (Greek) an ancient Greek town hall [n]\n",
  "PRYTANEUM": "(Greek) an ancient Greek town hall [n PRYTANEA]\n",
  "PRYTHEE": "used to express a request, also PRITHEE [interj]\n",
  "PSALIGRAPHIES": "PSALIGRAPHY, the art of paper-cutting to make pictures [n]\n",
  "PSALIGRAPHY": "the art of paper-cutting to make pictures [n PSALIGRAPHIES]\n",
  "PSALM": "a hymn or religious song [n -S] / to sing psalms [v -ED, -ING, -S]\n",
  "PSALMBOOK": "a book of psalms [n -S]\n",
  "PSALMBOOKS": "PSALMBOOK, a book of psalms [n]\n",
  "PSALMED": "PSALM, to sing psalms [v]\n",
  "PSALMIC": "pertaining to a psalm [adj]\n",
  "PSALMING": "PSALM, to sing psalms [v]\n",
  "PSALMIST": "a writer of psalms [n -S]\n",
  "PSALMISTS": "PSALMIST, a writer of psalms [n]\n",
  "PSALMODIC": "relating to a psalmody, also PSALMODICAL [adj]\n",
  "PSALMODICAL": "relating to a psalmody, also PSALMODIC [adj]\n",
  "PSALMODIES": "PSALMODY, the use of psalms in worship [n]\n",
  "PSALMODISE": "to practise psalmody, also PSALMODIZE [v PSALMODISED, PSALMODISING, PSALMODISES]\n",
  "PSALMODISED": "PSALMODISE, to practise psalmody, also PSALMODIZE [v]\n",
  "PSALMODISES": "PSALMODISE, to practise psalmody, also PSALMODIZE [v]\n",
  "PSALMODISING": "PSALMODISE, to practise psalmody, also PSALMODIZE [v]\n",
  "PSALMODIST": "a singer of psalms [n -S]\n",
  "PSALMODISTS": "PSALMODIST, a singer of psalms [n]\n",
  "PSALMODIZE": "to practice psalmody, also PSALMODISE [v PSALMODIZED, PSALMODIZING, PSALMODIZES]\n",
  "PSALMODIZED": "PSALMODIZE, to practice psalmody, also PSALMODISE [v]\n",
  "PSALMODIZES": "PSALMODIZE, to practice psalmody, also PSALMODISE [v]\n",
  "PSALMODIZING": "PSALMODIZE, to practice psalmody, also PSALMODISE [v]\n",
  "PSALMODY": "the use of psalms in worship [n PSALMODIES]\n",
  "PSALMS": "PSALM, to sing psalms [v]\n",
  "PSALTER": "a book of psalms [n -S]\n",
  "PSALTERIA": "PSALTERIUM, (Latin) the third stomach of ruminants [n]\n",
  "PSALTERIAN": "relating to a psalter, the Book of Psalms, a musical setting for this, or selection from it [adj]\n",
  "PSALTERIES": "PSALTERY, an ancient stringed musical instrument, also PSALTRY [n]\n",
  "PSALTERIUM": "(Latin) the third stomach of ruminants [n PSALTERIA]\n",
  "PSALTERS": "PSALTER, a book of psalms [n]\n",
  "PSALTERY": "an ancient stringed musical instrument, also PSALTRY [n PSALTERIES]\n",
  "PSALTRESS": "a woman who plays the psaltery [n -ES]\n",
  "PSALTRESSES": "PSALTRESS, a woman who plays the psaltery [n]\n",
  "PSALTRIES": "PSALTRY, an ancient stringed musical instrument, also PSALTERY [n]\n",
  "PSALTRY": "an ancient stringed musical instrument, also PSALTERY [n PSALTRIES]\n",
  "PSAMMITE": "a fine-grained rock [n -S]\n",
  "PSAMMITES": "PSAMMITE, a fine-grained rock [n]\n",
  "PSAMMITIC": "of or like psammite, any rock composed of sand-grains [adj]\n",
  "PSAMMON": "(Greek) a group of microorganisms living in waterlogged sands [n -S]\n",
  "PSAMMONS": "PSAMMON, (Greek) a group of microorganisms living in waterlogged sands [n]\n",
  "PSAMMOPHIL": "a sand-loving plant, also PSAMMOPHILE [n -S]\n",
  "PSAMMOPHILE": "a sand-loving plant, also PSAMMOPHIL [n -S]\n",
  "PSAMMOPHILES": "PSAMMOPHILE, a sand-loving plant, also PSAMMOPHIL [n]\n",
  "PSAMMOPHILOUS": "sand-loving [adj]\n",
  "PSAMMOPHILS": "PSAMMOPHIL, a sand-loving plant, also PSAMMOPHILE [n]\n",
  "PSAMMOPHYTE": "a plant adapted to growing in sand [n -S]\n",
  "PSAMMOPHYTES": "PSAMMOPHYTE, a plant adapted to growing in sand [n]\n",
  "PSAMMOPHYTIC": "like a psammophyte, a plant adapted to growing in sand [adj]\n",
  "PSCHENT": "(Greek) a crown worn by ancient Egyptian kings [n -S]\n",
  "PSCHENTS": "PSCHENT, (Greek) a crown worn by ancient Egyptian kings [n]\n",
  "PSELLISM": "a defect in articulation or pronunciation, also PSELLISMUS [n -S]\n",
  "PSELLISMS": "PSELLISM, a defect in articulation or pronunciation, also PSELLISMUS [n]\n",
  "PSELLISMUS": "a defect in articulation or pronunciation, also PSELLISM [n -ES]\n",
  "PSELLISMUSES": "PSELLISMUS, a defect in articulation or pronunciation, also PSELLISM [n]\n",
  "PSEPHISM": "(historical) a decree of the Athenian assembly (from their voting with pebbles) [n -S]\n",
  "PSEPHISMS": "PSEPHISM, (historical) a decree of the Athenian assembly (from their voting with pebbles) [n]\n",
  "PSEPHITE": "a rock composed of small pebbles [n -S]\n",
  "PSEPHITES": "PSEPHITE, a rock composed of small pebbles [n]\n",
  "PSEPHITIC": "of or relating to pebbles [adj]\n",
  "PSEPHOANALYSES": "PSEPHOANALYSIS, the sociological and statistical study of election results and trends [n]\n",
  "PSEPHOANALYSIS": "the sociological and statistical study of election results and trends [n PSEPHOANALYSES]\n",
  "PSEPHOLOGICAL": "related to psephology [adj PSEPHOLOGICALLY]\n",
  "PSEPHOLOGICALLY": "PSEPHOLOGICAL, related to psephology [adv]\n",
  "PSEPHOLOGIES": "PSEPHOLOGY, the study of political elections [n]\n",
  "PSEPHOLOGIST": "one who studies election results and trends [n -S]\n",
  "PSEPHOLOGISTS": "PSEPHOLOGIST, one who studies election results and trends [n]\n",
  "PSEPHOLOGY": "the study of political elections [n PSEPHOLOGIES]\n",
  "PSEUD": "a person pretending to be intellectual, also PSEUDO [n -S]\n",
  "PSEUDAESTHESIA": "imaginary feeling or sensation [n -S]\n",
  "PSEUDAESTHESIAS": "PSEUDAESTHESIA, imaginary feeling or sensation [n]\n",
  "PSEUDARTHROSES": "PSEUDARTHROSIS, a joint formed by fibrous tissue bridging the gap between the two fragments of bone of an old fracture that have not united, also PSEUDOARTHROSIS [n]\n",
  "PSEUDARTHROSIS": "a joint formed by fibrous tissue bridging the gap between the two fragments of bone of an old fracture that have not united, also PSEUDOARTHROSIS [n PSEUDARTHROSES]\n",
  "PSEUDAXES": "PSEUDAXIS, a sympodium, an axis made up of the basal portions of several branches [n]\n",
  "PSEUDAXIS": "a sympodium, an axis made up of the basal portions of several branches [n PSEUDAXES]\n",
  "PSEUDEPIGRAPH": "a book ascribed to Old Testament characters, but not judged genuine by scholars [n -S]\n",
  "PSEUDEPIGRAPHA": "spurious writings, esp. writings falsely attributed to biblical characters or times (plural of 16-letter pseudepigraphon [n]\n",
  "PSEUDEPIGRAPHIC": "relating to pseudepigrapha, spurious writings [adj]\n",
  "PSEUDEPIGRAPHON": "a book ascribed to Old Testament characters, but not judged genuine by scholars [n PSEUDEPIGRAPHA]\n",
  "PSEUDEPIGRAPHS": "PSEUDEPIGRAPH, a book ascribed to Old Testament characters, but not judged genuine by scholars [n]\n",
  "PSEUDEPIGRAPHY": "the ascription of false names of authors to works [n]\n",
  "PSEUDERIES": "PSEUDERY, falseness [n]\n",
  "PSEUDERY": "falseness [n PSEUDERIES]\n",
  "PSEUDIMAGINES": "PSEUDIMAGO, a stage in the development of certain insects, such as the May flies, intermediate between the pupa and imago [n]\n",
  "PSEUDIMAGO": "a stage in the development of certain insects, such as the May flies, intermediate between the pupa and imago [n PSEUDIMAGOS or PSEUDIMAGINES or PSEUDIMAGOES]\n",
  "PSEUDIMAGOES": "PSEUDIMAGO, a stage in the development of certain insects, such as the May flies, intermediate between the pupa and imago [n]\n",
  "PSEUDIMAGOS": "PSEUDIMAGO, a stage in the development of certain insects, such as the May flies, intermediate between the pupa and imago [n]\n",
  "PSEUDISH": "somewhat pseud [adj]\n",
  "PSEUDO": "a person pretending to be intellectual, also PSEUD [n -S]\n",
  "PSEUDOACID": "a compound which is not an acid but which is isomeric with and transformable into an acid [n -S]\n",
  "PSEUDOACIDS": "PSEUDOACID, a compound which is not an acid but which is isomeric with and transformable into an acid [n]\n",
  "PSEUDOALLELE": "a false allele [n -S]\n",
  "PSEUDOALLELES": "PSEUDOALLELE, a false allele [n]\n",
  "PSEUDOARTHROSES": "PSEUDOARTHROSIS, a joint formed by fibrous tissue bridging the gap between the two fragments of bone of an old fracture that have not united, also PSEUDARTHROSIS [n]\n",
  "PSEUDOARTHROSIS": "a joint formed by fibrous tissue bridging the gap between the two fragments of bone of an old fracture that have not united, also PSEUDARTHROSIS [n PSEUDOARTHROSES]\n",
  "PSEUDOBULB": "a swollen stem internode in some orchids [n -S]\n",
  "PSEUDOBULBS": "PSEUDOBULB, a swollen stem internode in some orchids [n]\n",
  "PSEUDOCARP": "that portion of an anthocarpous fruit which is not derived from the ovary, as the soft part of a strawberry or of a fig [n -S]\n",
  "PSEUDOCARPOUS": "of or like a pseudocarp [adj]\n",
  "PSEUDOCARPS": "PSEUDOCARP, that portion of an anthocarpous fruit which is not derived from the ovary, as the soft part of a strawberry or of a fig [n]\n",
  "PSEUDOCIDE": "faking one's own death [n -S]\n",
  "PSEUDOCIDES": "PSEUDOCIDE, faking one's own death [n]\n",
  "PSEUDOCLASSIC": "pretending to be or erroneously regarded as classic [adj] / an imitation classic [n -S]\n",
  "PSEUDOCLASSICS": "PSEUDOCLASSIC, an imitation classic [n]\n",
  "PSEUDOCODE": "instructions written in a symbolic language which must be translated into machine code before they can be executed [n -S]\n",
  "PSEUDOCODES": "PSEUDOCODE, instructions written in a symbolic language which must be translated into machine code before they can be executed [n]\n",
  "PSEUDOCOEL": "a body cavity not formed by gastrulation and lacking a mesodermal lining [n -S]\n",
  "PSEUDOCOELOMATE": "an invertebrate (as a nematode or rotifer) having a body cavity that is a pseudocoel [n]\n",
  "PSEUDOCOELS": "PSEUDOCOEL, a body cavity not formed by gastrulation and lacking a mesodermal lining [n]\n",
  "PSEUDOCYESES": "PSEUDOCYESIS, false pregnancy [n]\n",
  "PSEUDOCYESIS": "false pregnancy [n PSEUDOCYESES]\n",
  "PSEUDOEPHEDRINE": "a naturally occurring isomer of ephedrine, used in the form of its hydrochloride as a bronchodilator [n]\n",
  "PSEUDOGRAPH": "spurious writing; forgery [n -S]\n",
  "PSEUDOGRAPHIES": "PSEUDOGRAPHY, unsatisfactory spelling [n]\n",
  "PSEUDOGRAPHS": "PSEUDOGRAPH, spurious writing; forgery [n]\n",
  "PSEUDOGRAPHY": "unsatisfactory spelling [n PSEUDOGRAPHIES]\n",
  "PSEUDOLOGIA": "lying in speech or writing [n -S]\n",
  "PSEUDOLOGIAS": "PSEUDOLOGIA, lying in speech or writing [n]\n",
  "PSEUDOLOGIES": "PSEUDOLOGY, the art or science of lying [n]\n",
  "PSEUDOLOGUE": "a pathological liar [n -S]\n",
  "PSEUDOLOGUES": "PSEUDOLOGUE, a pathological liar [n]\n",
  "PSEUDOLOGY": "the art or science of lying [n PSEUDOLOGIES]\n",
  "PSEUDOMARTYR": "a false martyr [n -S]\n",
  "PSEUDOMARTYRS": "PSEUDOMARTYR, a false martyr [n]\n",
  "PSEUDOMEMBRANE": "a false membrane [n -S]\n",
  "PSEUDOMEMBRANES": "PSEUDOMEMBRANE, a false membrane [n]\n",
  "PSEUDOMONAD": "a virgate plant and animal pathogen [n -S]\n",
  "PSEUDOMONADES": "PSEUDOMONAD, a virgate plant and animal pathogen [n]\n",
  "PSEUDOMONADS": "PSEUDOMONAD, a virgate plant and animal pathogen [n]\n",
  "PSEUDOMONAS": "any of a genus of rodlike bacteria, many of which cause disease in plants or animals [n PSEUDOMONADES]\n",
  "PSEUDOMORPH": "a false or abnormal physical form [n -S]\n",
  "PSEUDOMORPHIC": "of or like a pseudomorph, also PSEUDOMORPHOUS [adj]\n",
  "PSEUDOMORPHISM": "the state of being pseudomorphic [n -S]\n",
  "PSEUDOMORPHISMS": "PSEUDOMORPHISM, the state of being pseudomorphic [n]\n",
  "PSEUDOMORPHOUS": "of or like a pseudomorph, also PSEUDOMORPHIC [adj]\n",
  "PSEUDOMORPHS": "PSEUDOMORPH, a false or abnormal physical form [n]\n",
  "PSEUDOMUTUALITY": "a relationship between two persons in which conflict of views or opinions is solved by simply ignoring it [n]\n",
  "PSEUDONYM": "a fictitious name assumed for the time, as by an author [n -S]\n",
  "PSEUDONYMITIES": "PSEUDONYMITY, the state of being pseudonymous [n]\n",
  "PSEUDONYMITY": "the state of being pseudonymous [n PSEUDONYMITIES]\n",
  "PSEUDONYMOUS": "using a pseudonym [adj PSEUDONYMOUSLY]\n",
  "PSEUDONYMOUSLY": "PSEUDONYMOUS, using a pseudonym [adv]\n",
  "PSEUDONYMS": "PSEUDONYM, a fictitious name assumed for the time, as by an author [n]\n",
  "PSEUDOPOD": "a process protruding from the cell of a protozoan, etc., used for movement or feeding [n -S]\n",
  "PSEUDOPODAL": "of or like a pseudopod, also PSEUDOPODIAL [adj]\n",
  "PSEUDOPODIA": "PSEUDOPODIUM, a process protruding from the cell of a protozoan, etc., used for movement or feeding [n]\n",
  "PSEUDOPODIAL": "of or like a pseudopod, also PSEUDOPODAL [adj]\n",
  "PSEUDOPODIUM": "a process protruding from the cell of a protozoan, etc., used for movement or feeding [n PSEUDOPODIA]\n",
  "PSEUDOPODS": "PSEUDOPOD, a process protruding from the cell of a protozoan, etc., used for movement or feeding [n]\n",
  "PSEUDOPREGNANCY": "false pregnancy [n]\n",
  "PSEUDOPREGNANT": "relating to pseudopregnancy [adj]\n",
  "PSEUDORANDOM": "being or involving entities (as numbers) that are selected by a definite computational process but that satisfy one or more standard tests for statistical randomness [adj]\n",
  "PSEUDOS": "PSEUDO, a person pretending to be intellectual, also PSEUD [n]\n",
  "PSEUDOSCALAR": "a variable quantity that has magnitude but not direction and is an odd function of the coordinates [n -S]\n",
  "PSEUDOSCALARS": "PSEUDOSCALAR, a variable quantity that has magnitude but not direction and is an odd function of the coordinates [n]\n",
  "PSEUDOSCIENCE": "a system of theories, assumptions, and methods erroneously regarded as scientific [n -S]\n",
  "PSEUDOSCIENCES": "PSEUDOSCIENCE, a system of theories, assumptions, and methods erroneously regarded as scientific [n]\n",
  "PSEUDOSCIENTIST": "one who practises pseudoscience [n]\n",
  "PSEUDOSCOPE": "an instrument producing images in reversed relief [n -S]\n",
  "PSEUDOSCOPES": "PSEUDOSCOPE, an instrument producing images in reversed relief [n]\n",
  "PSEUDOSCORPION": "any of various small arachnids of the order Pseudoscorpiones, resembling a scorpion but tailless, and found in soil, leaf litter, bark, etc. [n -S]\n",
  "PSEUDOSCORPIONS": "PSEUDOSCORPION, any of various small arachnids of the order Pseudoscorpiones, resembling a scorpion but tailless, and found in soil, leaf litter, bark, etc. [n]\n",
  "PSEUDOSOLUTION": "a false solution [n -S]\n",
  "PSEUDOSOLUTIONS": "PSEUDOSOLUTION, a false solution [n]\n",
  "PSEUDOSYMMETRY": "a deceptively close approach by a crystal to a higher degree of symmetry [n]\n",
  "PSEUDOVECTOR": "a variable quantity, such as angular momentum, that has magnitude and orientation with respect to an axis [n -S]\n",
  "PSEUDOVECTORS": "PSEUDOVECTOR, a variable quantity, such as angular momentum, that has magnitude and orientation with respect to an axis [n]\n",
  "PSEUDS": "PSEUD, a person pretending to be intellectual, also PSEUDO [n]\n",
  "PSHAW": "to utter an expression of contempt or disapproval [v -ED, -ING, -S]\n",
  "PSHAWED": "PSHAW, to utter an expression of contempt or disapproval [v]\n",
  "PSHAWING": "PSHAW, to utter an expression of contempt or disapproval [v]\n",
  "PSHAWS": "PSHAW, to utter an expression of contempt or disapproval [v]\n",
  "PSI": "a Greek letter [n -S]\n",
  "PSILANTHROPIC": "relating to psilanthropism, the denial of Christ's divinity [adj]\n",
  "PSILANTHROPIES": "PSILANTHROPY, the belief that Christ was not divine but divinely inspired [n]\n",
  "PSILANTHROPISM": "the denial of Christ's divinity [n -S]\n",
  "PSILANTHROPISMS": "PSILANTHROPISM, the denial of Christ's divinity [n]\n",
  "PSILANTHROPIST": "one who denies Christ's divinity [n -S]\n",
  "PSILANTHROPISTS": "PSILANTHROPIST, one who denies Christ's divinity [n]\n",
  "PSILANTHROPY": "the belief that Christ was not divine but divinely inspired [n PSILANTHROPIES]\n",
  "PSILOCIN": "a hallucinogenic drug found in a Mexican mushroom [n -S]\n",
  "PSILOCINS": "PSILOCIN, a hallucinogenic drug found in a Mexican mushroom [n]\n",
  "PSILOCYBIN": "a hallucinogenic drug, obtained from the Mexican mushroom Psilocybe mexicana and other mushrooms [n -S]\n",
  "PSILOCYBINS": "PSILOCYBIN, a hallucinogenic drug, obtained from the Mexican mushroom Psilocybe mexicana and other mushrooms [n]\n",
  "PSILOMELANE": "an oxide of manganese, usually with barium, etc., occurring in smooth black botryoidal masses [n -S]\n",
  "PSILOMELANES": "PSILOMELANE, an oxide of manganese, usually with barium, etc., occurring in smooth black botryoidal masses [n]\n",
  "PSILOPHYTE": "any of an order of extinct plants [n -S]\n",
  "PSILOPHYTES": "PSILOPHYTE, any of an order of extinct plants [n]\n",
  "PSILOPHYTIC": "of or like a psilophyte, a kind of extinct plant [adj]\n",
  "PSILOSES": "PSILOSIS, (Greek) loss of hair [n]\n",
  "PSILOSIS": "(Greek) loss of hair [n PSILOSES]\n",
  "PSILOTIC": "relating to psilosis, loss of hair [adj]\n",
  "PSION": "a particle formed by collision of a positron and an electron [n -S]\n",
  "PSIONIC": "relating to a psion, a hypothetical PSI particle [adj]\n",
  "PSIONICS": "psychic abilities as a motif in science fiction [n]\n",
  "PSIONS": "PSION, a particle formed by collision of a positron and an electron [n]\n",
  "PSIS": "PSI, a Greek letter [n]\n",
  "PSITTACINE": "a member of the parrot family [n -S]\n",
  "PSITTACINES": "PSITTACINE, a member of the parrot family [n]\n",
  "PSITTACOSES": "PSITTACOSIS, contagious parrot disease, causing fever and pneumonia in humans [n]\n",
  "PSITTACOSIS": "contagious parrot disease, causing fever and pneumonia in humans [n PSITTACOSES]\n",
  "PSITTACOTIC": "relating to psittacosis [adj]\n",
  "PSOAE": "PSOAS, (Greek) a muscle of the pelvic region [n]\n",
  "PSOAI": "PSOAS, (Greek) a muscle of the pelvic region [n]\n",
  "PSOAS": "(Greek) a muscle of the pelvic region [n PSOASES or PSOAE or PSOAI]\n",
  "PSOASES": "PSOAS, (Greek) a muscle of the pelvic region [n]\n",
  "PSOATIC": "relating to the psoas, the loin muscle [adj]\n",
  "PSOCID": "any member of the family Psocidae, tiny winged or wingless insects that include booklice, bark-lice etc. [n -S]\n",
  "PSOCIDS": "PSOCID, any member of the family Psocidae, tiny winged or wingless insects that include booklice, bark-lice etc. [n]\n",
  "PSORA": "(obsolete) a cutaneous disease; esp. the itch [n -S]\n",
  "PSORALEA": "a plant of the bean family [n -S]\n",
  "PSORALEAS": "PSORALEA, a plant of the bean family [n]\n",
  "PSORALEN": "a drug used to treat psoriasis [n -S]\n",
  "PSORALENS": "PSORALEN, a drug used to treat psoriasis [n]\n",
  "PSORAS": "PSORA, (obsolete) a cutaneous disease; esp. the itch [n]\n",
  "PSORIASES": "PSORIASIS, the state of being affected with psora, a cutaneous disease [n]\n",
  "PSORIASIS": "the state of being affected with psora, a cutaneous disease [n PSORIASES]\n",
  "PSORIATIC": "suffering from psoriasis [adj] / a person suffering from psoriasis [n -S]\n",
  "PSORIATICS": "PSORIATIC, a person suffering from psoriasis [n]\n",
  "PSORIC": "of or pertaining to psora, a cutaneous disease [adj]\n",
  "PSST": "an interjection used to attract attention, also PST [interj]\n",
  "PST": "an interjection used to attract attention, also PSST [interj]\n",
  "PSYCH": "to stimulate to a proper frame of mind [v -ED, -ING, -S]\n",
  "PSYCHAGOGUE": "a conductor of souls to the underworld [n -S]\n",
  "PSYCHAGOGUES": "PSYCHAGOGUE, a conductor of souls to the underworld [n]\n",
  "PSYCHASTHENIA": "an incapacity to resolve doubts/uncertainties or to resist obsessions/compulsions that one knows are irrational [n -S]\n",
  "PSYCHASTHENIAS": "PSYCHASTHENIA, an incapacity to resolve doubts/uncertainties or to resist obsessions/compulsions that one knows are irrational [n]\n",
  "PSYCHASTHENIC": "relating to psychasthenia [adj] / one suffering from psychasthenia [n -S]\n",
  "PSYCHASTHENICS": "PSYCHASTHENIC, one suffering from psychasthenia [n]\n",
  "PSYCHE": "the mental structure of a person [n -S]\n",
  "PSYCHED": "PSYCH, to stimulate to a proper frame of mind [v]\n",
  "PSYCHEDELIA": "the production of, or the culture associated with, psychedelic experiences, also PSYCHODELIA [n -S]\n",
  "PSYCHEDELIAS": "PSYCHEDELIA, the production of, or the culture associated with, psychedelic experiences, also PSYCHODELIA [n]\n",
  "PSYCHEDELIC": "relating to a state of heightened perception, also PSYCHODELIC [adj PSYCHEDELICALLY] / a psychedelic drug, such as LSD [n -S]\n",
  "PSYCHEDELICALLY": "PSYCHEDELIC, relating to a state of heightened perception, also PSYCHODELIC [adv]\n",
  "PSYCHEDELICS": "PSYCHEDELIC, a psychedelic drug, such as LSD [n]\n",
  "PSYCHES": "PSYCHE, the mental structure of a person [n]\n",
  "PSYCHIATER": "(archaic) a psychiatrist, also PSYCHIATRIST [n -S]\n",
  "PSYCHIATERS": "PSYCHIATER, (archaic) a psychiatrist, also PSYCHIATRIST [n]\n",
  "PSYCHIATRIC": "relating to psychiatry, also PSYCHIATRICAL [adj PSYCHIATRICALLY]\n",
  "PSYCHIATRICAL": "relating to psychiatry, also PSYCHIATRIC [adj PSYCHIATRICALLY]\n",
  "PSYCHIATRICALLY": "PSYCHIATRICAL, relating to psychiatry, also PSYCHIATRIC [adv]\n",
  "PSYCHIATRIES": "PSYCHIATRY, a branch of medicine that deals with mental, emotional, or behavioral disorders [n]\n",
  "PSYCHIATRIST": "one who practises psychiatry, also PSYCHIATER [n -S]\n",
  "PSYCHIATRISTS": "PSYCHIATRIST, one who practises psychiatry, also PSYCHIATER [n]\n",
  "PSYCHIATRY": "a branch of medicine that deals with mental, emotional, or behavioral disorders [n PSYCHIATRIES]\n",
  "PSYCHIC": "relating to the psyche, also PSYCHICAL [adj PSYCHICALLY] / one sensitive to extrasensory phenomena [n -S]\n",
  "PSYCHICAL": "relating to the psyche, also PSYCHIC [adj PSYCHICALLY]\n",
  "PSYCHICALLY": "PSYCHICAL, relating to the psyche, also PSYCHIC [adv]\n",
  "PSYCHICISM": "psychical research [n -S]\n",
  "PSYCHICISMS": "PSYCHICISM, psychical research [n]\n",
  "PSYCHICIST": "a psychical researcher [n -S]\n",
  "PSYCHICISTS": "PSYCHICIST, a psychical researcher [n]\n",
  "PSYCHICS": "PSYCHIC, one sensitive to extrasensory phenomena [n]\n",
  "PSYCHING": "PSYCH, to stimulate to a proper frame of mind [v]\n",
  "PSYCHISM": "the doctrine of a universal soul [n -S]\n",
  "PSYCHISMS": "PSYCHISM, the doctrine of a universal soul [n]\n",
  "PSYCHIST": "someone interested in psychical research [n -S]\n",
  "PSYCHISTS": "PSYCHIST, someone interested in psychical research [n]\n",
  "PSYCHO": "a mentally unstable person [n -S]\n",
  "PSYCHOACOUSTIC": "relating to psychoacoustics [adj]\n",
  "PSYCHOACOUSTICS": "a branch of science dealing with the perception of sound, the sensations produced by sounds, and the problems of communication [n]\n",
  "PSYCHOACTIVE": "affecting the mind or behavior [adj]\n",
  "PSYCHOANALYSE": "to subject to psychoanalysis, also PSYCHOANALYZE [v PSYCHOANALYSED, PSYCHOANALYSING, PSYCHOANALYSES]\n",
  "PSYCHOANALYSED": "PSYCHOANALYSE, to subject to psychoanalysis, also PSYCHOANALYZE [v]\n",
  "PSYCHOANALYSER": "one who psychoanalyses, also PSYCHOANALYZER [n -S]\n",
  "PSYCHOANALYSERS": "PSYCHOANALYSER, one who psychoanalyses, also PSYCHOANALYZER [n]\n",
  "PSYCHOANALYSES": "PSYCHOANALYSE, to subject to psychoanalysis, also PSYCHOANALYZE [v]\n",
  "PSYCHOANALYSING": "PSYCHOANALYSE, to subject to psychoanalysis, also PSYCHOANALYZE [v]\n",
  "PSYCHOANALYSIS": "the treatment of neurotic persons by the analysis of their neuroses and revelation of their origins [n PSYCHOANALYSES]\n",
  "PSYCHOANALYST": "a practitioner of psychoanalysis [n -S]\n",
  "PSYCHOANALYSTS": "PSYCHOANALYST, a practitioner of psychoanalysis [n]\n",
  "PSYCHOANALYTIC": "of, relating to, or employing psychoanalysis or its principles and techniques [adj]\n",
  "PSYCHOANALYZE": "to subject to psychoanalysis, also PSYCHOANALYSE [v PSYCHOANALYZED, PSYCHOANALYZING, PSYCHOANALYZES]\n",
  "PSYCHOANALYZED": "PSYCHOANALYZE, to subject to psychoanalysis, also PSYCHOANALYSE [v]\n",
  "PSYCHOANALYZER": "one who psychoanalyzes, also PSYCHOANALYSER [n -S]\n",
  "PSYCHOANALYZERS": "PSYCHOANALYZER, one who psychoanalyzes, also PSYCHOANALYSER [n]\n",
  "PSYCHOANALYZES": "PSYCHOANALYZE, to subject to psychoanalysis, also PSYCHOANALYSE [v]\n",
  "PSYCHOANALYZING": "PSYCHOANALYZE, to subject to psychoanalysis, also PSYCHOANALYSE [v]\n",
  "PSYCHOBABBLE": "to use language laden with jargon from psychotherapy or psychiatry used without much concern for accuracy [v PSYCHOBABBLED, PSYCHOBABBLING, PSYCHOBABBLES]\n",
  "PSYCHOBABBLED": "PSYCHOBABBLE, to use language laden with jargon from psychotherapy or psychiatry used without much concern for accuracy [v]\n",
  "PSYCHOBABBLER": "one who indulges in psychobabble [n -S]\n",
  "PSYCHOBABBLERS": "PSYCHOBABBLER, one who indulges in psychobabble [n]\n",
  "PSYCHOBABBLES": "PSYCHOBABBLE, to use language laden with jargon from psychotherapy or psychiatry used without much concern for accuracy [v]\n",
  "PSYCHOBABBLING": "PSYCHOBABBLE, to use language laden with jargon from psychotherapy or psychiatry used without much concern for accuracy [v]\n",
  "PSYCHOBILLIES": "PSYCHOBILLY, a genre of popular music, blending rockabilly with punk rock [n]\n",
  "PSYCHOBILLY": "a genre of popular music, blending rockabilly with punk rock [n PSYCHOBILLIES]\n",
  "PSYCHOBIOGRAPHY": "a biography written from a psychodynamic or psychoanalytic point of view [n]\n",
  "PSYCHOBIOLOGIC": "relating to psychobiology [adj]\n",
  "PSYCHOBIOLOGIES": "PSYCHOBIOLOGY, the study of the biology of the mind [n]\n",
  "PSYCHOBIOLOGIST": "one who studies psychobiology [n]\n",
  "PSYCHOBIOLOGY": "the study of the biology of the mind [n PSYCHOBIOLOGIES]\n",
  "PSYCHOCHEMICAL": "a psychoactive chemical [n -S]\n",
  "PSYCHOCHEMICALS": "PSYCHOCHEMICAL, a psychoactive chemical [n]\n",
  "PSYCHOCHEMISTRY": "the treatment of mental illness by drugs [n]\n",
  "PSYCHODELIA": "the production of, or the culture associated with, psychedelic experiences, also PSYCHEDELIA [n -S]\n",
  "PSYCHODELIAS": "PSYCHODELIA, the production of, or the culture associated with, psychedelic experiences, also PSYCHEDELIA [n]\n",
  "PSYCHODELIC": "relating to a state of heightened perception, also PSYCHEDELIC [adj PSYCHODELICALLY]\n",
  "PSYCHODELICALLY": "PSYCHODELIC, relating to a state of heightened perception, also PSYCHEDELIC [adv]\n",
  "PSYCHODRAMA": "therapeutic drama [n -S]\n",
  "PSYCHODRAMAS": "PSYCHODRAMA, therapeutic drama [n]\n",
  "PSYCHODRAMATIC": "relating to psychodrama [adj]\n",
  "PSYCHODYNAMIC": "concerning psychological motives and causation [adj]\n",
  "PSYCHODYNAMICS": "the psychology of mental or emotional forces or processes developing especially in early childhood and their effects on behaviour and mental states [n]\n",
  "PSYCHOGALVANIC": "as in psychogalvanic response, a change in the electrical properties of the skin in response to stress or anxiety [adj]\n",
  "PSYCHOGAS": "a gas which makes a person's performance deteriorate very seriously without his being aware of it [n -ES]\n",
  "PSYCHOGASES": "PSYCHOGAS, a gas which makes a person's performance deteriorate very seriously without his being aware of it [n]\n",
  "PSYCHOGENESES": "PSYCHOGENESIS, the origin and development of the mind [n]\n",
  "PSYCHOGENESIS": "the origin and development of the mind [n PSYCHOGENESES]\n",
  "PSYCHOGENETIC": "relating to psychogenesis, the origin and development of the mind, also PSYCHOGENETICAL [adj]\n",
  "PSYCHOGENETICAL": "relating to psychogenesis, the origin and development of the mind, also PSYCHOGENETIC [adj]\n",
  "PSYCHOGENETICS": "the study of internal or mental states [n]\n",
  "PSYCHOGENIC": "derived from the mind [adj PSYCHOGENICALLY]\n",
  "PSYCHOGENICALLY": "PSYCHOGENIC, derived from the mind [adv]\n",
  "PSYCHOGERIATRIC": "relating to the study of the psychological problems of old age [adj]\n",
  "PSYCHOGNOSES": "PSYCHOGNOSIS, the use of hypnosis to study mental phenomena; the study of personality by observation of outward bodily sign [n]\n",
  "PSYCHOGNOSIS": "the use of hypnosis to study mental phenomena; the study of personality by observation of outward bodily sign [n PSYCHOGNOSES]\n",
  "PSYCHOGNOSTIC": "relating to psychognosis [adj]\n",
  "PSYCHOGONIES": "PSYCHOGONY, development of the mind or soul [n]\n",
  "PSYCHOGONY": "development of the mind or soul [n PSYCHOGONIES]\n",
  "PSYCHOGRAM": "writing supposedly produced under influence of spirits [n -S]\n",
  "PSYCHOGRAMS": "PSYCHOGRAM, writing supposedly produced under influence of spirits [n]\n",
  "PSYCHOGRAPH": "a photographic image attributed to a supernatural or spiritualistic cause [n -S]\n",
  "PSYCHOGRAPHIC": "relating to psychographics, also PSYCHOGRAPHICAL [adj]\n",
  "PSYCHOGRAPHICAL": "relating to psychographics, also PSYCHOGRAPHIC [adj]\n",
  "PSYCHOGRAPHICS": "the quantitive study of personalities and attitudes, used as a tool in marketing [n]\n",
  "PSYCHOGRAPHIES": "PSYCHOGRAPHY, the production of images attributed to supernatural causes [n]\n",
  "PSYCHOGRAPHS": "PSYCHOGRAPH, a photographic image attributed to a supernatural or spiritualistic cause [n]\n",
  "PSYCHOGRAPHY": "the production of images attributed to supernatural causes [n PSYCHOGRAPHIES]\n",
  "PSYCHOHISTORIAN": "a student of psychohistory [n]\n",
  "PSYCHOHISTORIES": "PSYCHOHISTORY, historical analysis or interpretation using psychological and psychoanalytic methods [n]\n",
  "PSYCHOHISTORY": "historical analysis or interpretation using psychological and psychoanalytic methods [n PSYCHOHISTORIES]\n",
  "PSYCHOID": "the hypothetical regulative principle controlling the behaviour of an organism [n -S]\n",
  "PSYCHOIDS": "PSYCHOID, the hypothetical regulative principle controlling the behaviour of an organism [n]\n",
  "PSYCHOKINESES": "PSYCHOKINESIS, the movement of physical objects by the mind without use of physical means [n]\n",
  "PSYCHOKINESIS": "the movement of physical objects by the mind without use of physical means [n PSYCHOKINESES]\n",
  "PSYCHOKINETIC": "relating to psychokinesis [adj]\n",
  "PSYCHOLINGUIST": "a student of psycholinguistics [n -S]\n",
  "PSYCHOLINGUISTS": "PSYCHOLINGUIST, a student of psycholinguistics [n]\n",
  "PSYCHOLOGIC": "of or relating to psychology, also PSYCHOLOGICAL [adj PSYCHOLOGICALLY]\n",
  "PSYCHOLOGICAL": "of or relating to psychology, also PSYCHOLOGIC [adj PSYCHOLOGICALLY]\n",
  "PSYCHOLOGICALLY": "PSYCHOLOGICAL, of or relating to psychology, also PSYCHOLOGIC [adv]\n",
  "PSYCHOLOGIES": "PSYCHOLOGY, the science of mind and behavior [n]\n",
  "PSYCHOLOGISE": "to speculate in psychological terms or on psychological motivations, also PSYCHOLOGIZE [v PSYCHOLOGISED, PSYCHOLOGISING, PSYCHOLOGISES]\n",
  "PSYCHOLOGISED": "PSYCHOLOGISE, to speculate in psychological terms or on psychological motivations, also PSYCHOLOGIZE [v]\n",
  "PSYCHOLOGISES": "PSYCHOLOGISE, to speculate in psychological terms or on psychological motivations, also PSYCHOLOGIZE [v]\n",
  "PSYCHOLOGISING": "PSYCHOLOGISE, to speculate in psychological terms or on psychological motivations, also PSYCHOLOGIZE [v]\n",
  "PSYCHOLOGISM": "a theory that applies psychological conceptions to the interpretation of historical events or logical thought [n -S]\n",
  "PSYCHOLOGISMS": "PSYCHOLOGISM, a theory that applies psychological conceptions to the interpretation of historical events or logical thought [n]\n",
  "PSYCHOLOGIST": "one who practises psychology [n -S]\n",
  "PSYCHOLOGISTIC": "relating to psychologism, a theory that applies psychological conceptions to the interpretation of historical events or logical thought [adj]\n",
  "PSYCHOLOGISTS": "PSYCHOLOGIST, one who practises psychology [n]\n",
  "PSYCHOLOGIZE": "to speculate in psychological terms or on psychological motivations, also PSYCHOLOGISE [v PSYCHOLOGIZED, PSYCHOLOGIZING, PSYCHOLOGIZES]\n",
  "PSYCHOLOGIZED": "PSYCHOLOGIZE, to speculate in psychological terms or on psychological motivations, also PSYCHOLOGISE [v]\n",
  "PSYCHOLOGIZES": "PSYCHOLOGIZE, to speculate in psychological terms or on psychological motivations, also PSYCHOLOGISE [v]\n",
  "PSYCHOLOGIZING": "PSYCHOLOGIZE, to speculate in psychological terms or on psychological motivations, also PSYCHOLOGISE [v]\n",
  "PSYCHOLOGY": "the science of mind and behavior [n PSYCHOLOGIES]\n",
  "PSYCHOMACHIA": "conflict of the soul [n -S]\n",
  "PSYCHOMACHIAS": "PSYCHOMACHIA, conflict of the soul [n]\n",
  "PSYCHOMACHIES": "PSYCHOMACHY, conflict of the soul [n]\n",
  "PSYCHOMACHY": "conflict of the soul [n PSYCHOMACHIES]\n",
  "PSYCHOMETER": "an instrument measuring the duration and intensity of mental states [n -S]\n",
  "PSYCHOMETERS": "PSYCHOMETER, an instrument measuring the duration and intensity of mental states [n]\n",
  "PSYCHOMETRIC": "relating to psychometry, also PSYCHOMETRICAL, PSYCHROMETRIC, PSYCHROMETRICAL [adj]\n",
  "PSYCHOMETRICAL": "relating to psychometry, also PSYCHOMETRIC, PSYCHROMETRIC, PSYCHROMETRICAL [adj]\n",
  "PSYCHOMETRICIAN": "a person (as a clinical psychologist) who is skilled in the administration and interpretation of objective psychological tests [n]\n",
  "PSYCHOMETRICS": "the design and use of psychological tests, including statistical techniques [n]\n",
  "PSYCHOMETRIES": "PSYCHOMETRY, the measurement of mental aptitudes and intelligence [n]\n",
  "PSYCHOMETRIST": "one who practises psychometry [n -S]\n",
  "PSYCHOMETRISTS": "PSYCHOMETRIST, one who practises psychometry [n]\n",
  "PSYCHOMETRY": "the measurement of mental aptitudes and intelligence [n PSYCHOMETRIES]\n",
  "PSYCHOMOTOR": "pertaining to physical action as immediate result of mental act [adj]\n",
  "PSYCHONEUROSES": "PSYCHONEUROSIS, neurosis [n]\n",
  "PSYCHONEUROSIS": "neurosis [n PSYCHONEUROSES]\n",
  "PSYCHONEUROTIC": "relating to psychoneurosis [adj] / one suffering from a psychoneurosis [n -S]\n",
  "PSYCHONEUROTICS": "PSYCHONEUROTIC, one suffering from a psychoneurosis [n]\n",
  "PSYCHONOMIC": "relating to psychonomics [adj]\n",
  "PSYCHONOMICS": "the study of the individual mind in relation to its environment [n]\n",
  "PSYCHOPATH": "a mentally ill or unstable person [n -S]\n",
  "PSYCHOPATHIC": "relating to psychopathy [adj] / a psychopath [n -S]\n",
  "PSYCHOPATHICS": "PSYCHOPATHIC, a psychopath [n]\n",
  "PSYCHOPATHIES": "PSYCHOPATHY, the state of being a psychopath [n]\n",
  "PSYCHOPATHIST": "a student of psychopathology [n -S]\n",
  "PSYCHOPATHISTS": "PSYCHOPATHIST, a student of psychopathology [n]\n",
  "PSYCHOPATHOLOGY": "the study of mental illness [n]\n",
  "PSYCHOPATHS": "PSYCHOPATH, a mentally ill or unstable person [n]\n",
  "PSYCHOPATHY": "the state of being a psychopath [n PSYCHOPATHIES]\n",
  "PSYCHOPHILIES": "PSYCHOPHILY, pollination by butterflies [n]\n",
  "PSYCHOPHILY": "pollination by butterflies [n PSYCHOPHILIES]\n",
  "PSYCHOPHYSICAL": "of or relating to psychophysics [adj]\n",
  "PSYCHOPHYSICIST": "a student of psychophysics [n]\n",
  "PSYCHOPHYSICS": "the study of the link between mental and physical processes [n]\n",
  "PSYCHOPOMP": "a guide of souls, one who escorts the soul of a newly-deceased to the afterlife [n -S]\n",
  "PSYCHOPOMPS": "PSYCHOPOMP, a guide of souls, one who escorts the soul of a newly-deceased to the afterlife [n]\n",
  "PSYCHOS": "PSYCHO, a mentally unstable person [n]\n",
  "PSYCHOSES": "PSYCHOSIS, a serious mental disorder characterized by e.g. illusions, delusions, hallucinations, mental confusion and a lack of insight on the part of the patient into his or her condition [n]\n",
  "PSYCHOSEXUAL": "of or relating to the mental, emotional, and behavioral aspects of sexual development [adj PSYCHOSEXUALLY]\n",
  "PSYCHOSEXUALITY": "the psychic factors of sex [n]\n",
  "PSYCHOSEXUALLY": "PSYCHOSEXUAL, of or relating to the mental, emotional, and behavioral aspects of sexual development [adv]\n",
  "PSYCHOSIS": "a serious mental disorder characterized by e.g. illusions, delusions, hallucinations, mental confusion and a lack of insight on the part of the patient into his or her condition [n PSYCHOSES]\n",
  "PSYCHOSOCIAL": "involving both psychological and social aspects [adj PSYCHOSOCIALLY]\n",
  "PSYCHOSOCIALLY": "PSYCHOSOCIAL, involving both psychological and social aspects [adv]\n",
  "PSYCHOSOCIOLOGY": "the study of how psychological and sociological factors combine [n]\n",
  "PSYCHOSOMATIC": "of, relating to, concerned with, or involving both mind and body [adj]\n",
  "PSYCHOSOMATICS": "the study of psychosomatic conditions [n]\n",
  "PSYCHOSOMIMETIC": "of drugs such as LSD and mescaline, capable of inducing psychotic symptoms, also PSYCHOTOMIMETIC [adj]\n",
  "PSYCHOSURGEON": "a practitioner of psychosurgery [n -S]\n",
  "PSYCHOSURGEONS": "PSYCHOSURGEON, a practitioner of psychosurgery [n]\n",
  "PSYCHOSURGERIES": "PSYCHOSURGERY, cerebral surgery employed in treating psychic symptoms [n]\n",
  "PSYCHOSURGERY": "cerebral surgery employed in treating psychic symptoms [n PSYCHOSURGERIES]\n",
  "PSYCHOSURGICAL": "relating to psychosurgery [adj]\n",
  "PSYCHOSYNTHESES": "PSYCHOSYNTHESIS, a form of psychotherapy combining psychoanalytic techniques with meditation and exercise [n]\n",
  "PSYCHOSYNTHESIS": "a form of psychotherapy combining psychoanalytic techniques with meditation and exercise [n PSYCHOSYNTHESES]\n",
  "PSYCHOTECHNICS": "the practical applications of psychology [n]\n",
  "PSYCHOTHERAPIES": "PSYCHOTHERAPY, treatment of mental disorders [n]\n",
  "PSYCHOTHERAPIST": "a practitioner of psychotherapy [n]\n",
  "PSYCHOTHERAPY": "treatment of mental disorders [n PSYCHOTHERAPIES]\n",
  "PSYCHOTIC": "suffering from a psychosis [adj PSYCHOTICALLY] / one suffering from a psychosis [n -S]\n",
  "PSYCHOTICALLY": "PSYCHOTIC, suffering from a psychosis [adv]\n",
  "PSYCHOTICISM": "the state of being psychotic [n -S]\n",
  "PSYCHOTICISMS": "PSYCHOTICISM, the state of being psychotic [n]\n",
  "PSYCHOTICS": "PSYCHOTIC, one suffering from a psychosis [n]\n",
  "PSYCHOTOMIMETIC": "of drugs such as LSD and mescaline, capable of inducing psychotic symptoms, also PSYCHOSOMIMETIC [adj]\n",
  "PSYCHOTOXIC": "damaging to the mind, esp. of such addictive drugs [adj]\n",
  "PSYCHOTROPIC": "acting on the mind [adj] / a drug acting on the mind [n -S]\n",
  "PSYCHOTROPICS": "PSYCHOTROPIC, a drug acting on the mind [n]\n",
  "PSYCHROMETER": "an instrument for measuring the dryness of the atmosphere [n -S]\n",
  "PSYCHROMETERS": "PSYCHROMETER, an instrument for measuring the dryness of the atmosphere [n]\n",
  "PSYCHROMETRIC": "relating to measurement by psychrometer, also PSYCHOMETRIC, PSYCHOMETRICAL, PSYCHROMETRICAL [adj]\n",
  "PSYCHROMETRICAL": "relating to measurement by psychrometer, also PSYCHOMETRIC, PSYCHOMETRICAL, PSYCHROMETRIC [adj]\n",
  "PSYCHROMETRIES": "PSYCHROMETRY, measurement by psychrometer [n]\n",
  "PSYCHROMETRY": "measurement by psychrometer [n PSYCHROMETRIES]\n",
  "PSYCHROPHILIC": "thriving at temperatures below 15 degrees Centigrade [adj]\n",
  "PSYCHS": "PSYCH, to stimulate to a proper frame of mind [v]\n",
  "PSYLLA": "(Greek) any of various plant lice, also PSYLLID [n -S]\n",
  "PSYLLAS": "PSYLLA, (Greek) any of various plant lice, also PSYLLID [n]\n",
  "PSYLLID": "any of various plant lice, also PSYLLA [n -S]\n",
  "PSYLLIDS": "PSYLLID, any of various plant lice, also PSYLLA [n]\n",
  "PSYLLIUM": "(Greek) the seed of the fleawort [n -S]\n",
  "PSYLLIUMS": "PSYLLIUM, (Greek) the seed of the fleawort [n]\n",
  "PSYOP": "(short for) psychological operation (in warfare) [n -S]\n",
  "PSYOPS": "PSYOP, (short for) psychological operation (in warfare) [n]\n",
  "PSYWAR": "(short for) psychological warfare [n -S]\n",
  "PSYWARS": "PSYWAR, (short for) psychological warfare [n]\n",
  "PTARMIC": "(Greek) a substance that causes sneezing [n -S]\n",
  "PTARMICS": "PTARMIC, (Greek) a substance that causes sneezing [n]\n",
  "PTARMIGAN": "(Gaelic) a game-bird of the grouse family [n -S]\n",
  "PTARMIGANS": "PTARMIGAN, (Gaelic) a game-bird of the grouse family [n]\n",
  "PTERANODON": "a toothless flying reptile of the Cretaceous period with a hornlike crest [n -S]\n",
  "PTERANODONS": "PTERANODON, a toothless flying reptile of the Cretaceous period with a hornlike crest [n]\n",
  "PTERIA": "PTERION, (Greek) a place where several skull bones meet [n]\n",
  "PTERIDINE": "any member of a genus of ferns that includes bracken [n -S]\n",
  "PTERIDINES": "PTERIDINE, any member of a genus of ferns that includes bracken [n]\n",
  "PTERIDOLOGICAL": "relating to pteridology, the study of ferns [adj]\n",
  "PTERIDOLOGIES": "PTERIDOLOGY, the study of ferns [n]\n",
  "PTERIDOLOGIST": "one who studies pteridology [n -S]\n",
  "PTERIDOLOGISTS": "PTERIDOLOGIST, one who studies pteridology [n]\n",
  "PTERIDOLOGY": "the study of ferns [n PTERIDOLOGIES]\n",
  "PTERIDOMANIA": "a passion for ferns [n -S]\n",
  "PTERIDOMANIAS": "PTERIDOMANIA, a passion for ferns [n]\n",
  "PTERIDOPHILIST": "a fern-lover [n -S]\n",
  "PTERIDOPHILISTS": "PTERIDOPHILIST, a fern-lover [n]\n",
  "PTERIDOPHYTE": "the general name for the ferns and their allies [n -S]\n",
  "PTERIDOPHYTES": "PTERIDOPHYTE, the general name for the ferns and their allies [n]\n",
  "PTERIDOPHYTIC": "of or like a pteridophyte, a fern, also PTERIDOPHYTOUS [adj]\n",
  "PTERIDOPHYTOUS": "of or like a pteridophyte, a fern, also PTERIDOPHYTIC [adj]\n",
  "PTERIDOSPERM": "an extinct group of seed plants which bore fernlike leaves [n -S]\n",
  "PTERIDOSPERMS": "PTERIDOSPERM, an extinct group of seed plants which bore fernlike leaves [n]\n",
  "PTERIN": "(Greek) any of a group of substances occurring in butterfly wings [n -S]\n",
  "PTERINS": "PTERIN, (Greek) any of a group of substances occurring in butterfly wings [n]\n",
  "PTERION": "(Greek) a place where several skull bones meet [n PTERIA]\n",
  "PTERODACTYL": "any of various pterosaurs of the Late Jurassic and Cretaceous having a rudimentary tail and a beak with reduced dentition, also PTERODACTYLE [n -S]\n",
  "PTERODACTYLE": "any of various pterosaurs of the Late Jurassic and Cretaceous having a rudimentary tail and a beak with reduced dentition, also PTERODACTYL [n -S]\n",
  "PTERODACTYLES": "PTERODACTYLE, any of various pterosaurs of the Late Jurassic and Cretaceous having a rudimentary tail and a beak with reduced dentition, also PTERODACTYL [n]\n",
  "PTERODACTYLS": "PTERODACTYL, any of various pterosaurs of the Late Jurassic and Cretaceous having a rudimentary tail and a beak with reduced dentition, also PTERODACTYLE [n]\n",
  "PTEROIC": "as in pteroic acid, the original folic acid found in spinach [adj]\n",
  "PTEROPOD": "a small swimming mollusc, often shell-less [n -S]\n",
  "PTEROPODS": "PTEROPOD, a small swimming mollusc, often shell-less [n]\n",
  "PTEROSAUR": "a pterodactyl, also PTEROSAURIAN [n -S]\n",
  "PTEROSAURIAN": "a pterodactyl, also PTEROSAUR [n -S]\n",
  "PTEROSAURIANS": "PTEROSAURIAN, a pterodactyl, also PTEROSAUR [n]\n",
  "PTEROSAURS": "PTEROSAUR, a pterodactyl, also PTEROSAURIAN [n]\n",
  "PTERYGIA": "PTERYGIUM, a growth over the cornea [n]\n",
  "PTERYGIAL": "of or relating to a wing or fin [adj] / a bone in a fin [n -S]\n",
  "PTERYGIALS": "PTERYGIAL, a bone in a fin [n]\n",
  "PTERYGIUM": "a growth over the cornea [n PTERYGIUMS or PTERYGIA]\n",
  "PTERYGIUMS": "PTERYGIUM, a growth over the cornea [n]\n",
  "PTERYGOID": "winglike [adj] / a paired bone of the upper jaw [n -S]\n",
  "PTERYGOIDS": "PTERYGOID, a paired bone of the upper jaw [n]\n",
  "PTERYLA": "(Greek) the feathered area on the skin of a bird [n PTERYLAE]\n",
  "PTERYLAE": "PTERYLA, (Greek) the feathered area on the skin of a bird [n]\n",
  "PTERYLOGRAPHIC": "relating to pterylography [adj]\n",
  "PTERYLOGRAPHIES": "PTERYLOGRAPHY, a description of pterylae [n]\n",
  "PTERYLOGRAPHY": "a description of pterylae [n PTERYLOGRAPHIES]\n",
  "PTERYLOSES": "PTERYLOSIS, the arrangement of feathers in definite areas [n]\n",
  "PTERYLOSIS": "the arrangement of feathers in definite areas [n PTERYLOSES]\n",
  "PTILOSES": "PTILOSIS, (Greek) plumage or mode of feathering [n]\n",
  "PTILOSIS": "(Greek) plumage or mode of feathering [n PTILOSES]\n",
  "PTISAN": "(Greek) a wholesome or medicinal drink or infusion, originally specifically made with barley; now (esp.), a herbal tea, also TISANE [n -S]\n",
  "PTISANS": "PTISAN, (Greek) a wholesome or medicinal drink or infusion, originally specifically made with barley; now (esp.), a herbal tea, also TISANE [n]\n",
  "PTOCHOCRACIES": "PTOCHOCRACY, government by the poor [n]\n",
  "PTOCHOCRACY": "government by the poor [n PTOCHOCRACIES]\n",
  "PTOMAIN": "a compound produced by the decomposition of protein, also PTOMAINE [n -S]\n",
  "PTOMAINE": "a compound produced by the decomposition of protein, also PTOMAIN [n -S]\n",
  "PTOMAINES": "PTOMAINE, a compound produced by the decomposition of protein, also PTOMAIN [n]\n",
  "PTOMAINIC": "of or like ptomaine, a poisonous alkaloid found in decaying matter [adj]\n",
  "PTOMAINS": "PTOMAIN, a compound produced by the decomposition of protein, also PTOMAINE [n]\n",
  "PTOOEY": "an imitation of the sound of someone spitting, also PTUI [interj]\n",
  "PTOSES": "PTOSIS, (Greek) a drooping of the upper eyelid [n]\n",
  "PTOSIS": "(Greek) a drooping of the upper eyelid [n PTOSES]\n",
  "PTOTIC": "relating to ptosis, a drooping of the upper eyelid [adj]\n",
  "PTUI": "an imitation of the sound of someone spitting, also PTOOEY [interj]\n",
  "PTYALAGOGIC": "acting as a ptyalagogue [adj]\n",
  "PTYALAGOGUE": "a substance promoting salivation [n -S]\n",
  "PTYALAGOGUES": "PTYALAGOGUE, a substance promoting salivation [n]\n",
  "PTYALIN": "(Greek) a ferment in saliva that turns starch into sugar [n -S]\n",
  "PTYALINS": "PTYALIN, (Greek) a ferment in saliva that turns starch into sugar [n]\n",
  "PTYALISE": "to induce ptyalism in, also PTYALIZE [v PTYALISED, PTYALISING, PTYALISES]\n",
  "PTYALISED": "PTYALISE, to induce ptyalism in, also PTYALIZE [v]\n",
  "PTYALISES": "PTYALISE, to induce ptyalism in, also PTYALIZE [v]\n",
  "PTYALISING": "PTYALISE, to induce ptyalism in, also PTYALIZE [v]\n",
  "PTYALISM": "an excessive flow of saliva [n -S]\n",
  "PTYALISMS": "PTYALISM, an excessive flow of saliva [n]\n",
  "PTYALIZE": "to induce ptyalism in, also PTYALISE [v PTYALIZED, PTYALIZING, PTYALIZES]\n",
  "PTYALIZED": "PTYALIZE, to induce ptyalism in, also PTYALISE [v]\n",
  "PTYALIZES": "PTYALIZE, to induce ptyalism in, also PTYALISE [v]\n",
  "PTYALIZING": "PTYALIZE, to induce ptyalism in, also PTYALISE [v]\n",
  "PTYXES": "PTYXIS, (Greek) a type of leaf folding in a bud [n]\n",
  "PTYXIS": "(Greek) a type of leaf folding in a bud [n PTYXISES or PTYXES]\n",
  "PTYXISES": "PTYXIS, (Greek) a type of leaf folding in a bud [n]\n",
  "PUB": "to go to a public bar [v PUBBED, PUBBING, PUBS]\n",
  "PUBBED": "PUB, to go to a public bar [v]\n",
  "PUBBING": "the practice of frequenting pubs [n -S]\n",
  "PUBBINGS": "PUBBING, the practice of frequenting pubs [n]\n",
  "PUBCO": "a company that operates a chain of pubs [n -S]\n",
  "PUBCOS": "PUBCO, a company that operates a chain of pubs [n]\n",
  "PUBCRAWLER": "one who engages in pub-crawls [n -S]\n",
  "PUBCRAWLERS": "PUBCRAWLER, one who engages in pub-crawls [n]\n",
  "PUBE": "a pubic hair [n -S]\n",
  "PUBERAL": "of or pertaining to puberty, also PUBERTAL [adj]\n",
  "PUBERTAL": "of or pertaining to puberty, also PUBERAL [adj]\n",
  "PUBERTIES": "PUBERTY, the beginning of sexual maturity [n]\n",
  "PUBERTY": "the beginning of sexual maturity [n PUBERTIES]\n",
  "PUBERULENT": "feebly or minutely pubescent; covered with minute down, also PUBERULOUS [adj]\n",
  "PUBERULOUS": "feebly or minutely pubescent; covered with minute down, also PUBERULENT [adj]\n",
  "PUBES": "the lower part of the hypogastric region; the hair which grows there at puberty [n PUBES]\n",
  "PUBESCENCE": "the state of being pubescent [n -S]\n",
  "PUBESCENCES": "PUBESCENCE, the state of being pubescent [n]\n",
  "PUBESCENT": "arrived at puberty [adj]\n",
  "PUBIC": "pertaining to the pubis [adj]\n",
  "PUBIS": "a bone of the pelvis [n -ES]\n",
  "PUBISES": "PUBIS, a bone of the pelvis [n]\n",
  "PUBLIC": "open to general view [adj PUBLICLY or PUBLICALLY] / the community or the people as a whole [n -S]\n",
  "PUBLICALLY": "PUBLIC, open to general view [adv]\n",
  "PUBLICAN": "one who owns or manages a hotel [n -S]\n",
  "PUBLICANS": "PUBLICAN, one who owns or manages a hotel [n]\n",
  "PUBLICATION": "the act of publishing [n -S]\n",
  "PUBLICATIONS": "PUBLICATION, the act of publishing [n]\n",
  "PUBLICISE": "to make public, also PUBLICIZE [v PUBLICISED, PUBLICISING, PUBLICISES]\n",
  "PUBLICISED": "PUBLICISE, to make public, also PUBLICIZE [v]\n",
  "PUBLICISES": "PUBLICISE, to make public, also PUBLICIZE [v]\n",
  "PUBLICISING": "PUBLICISE, to make public, also PUBLICIZE [v]\n",
  "PUBLICIST": "someone who publicizes something [n -S]\n",
  "PUBLICISTS": "PUBLICIST, someone who publicizes something [n]\n",
  "PUBLICITIES": "PUBLICITY, the process of making something known to the general public [n]\n",
  "PUBLICITY": "the process of making something known to the general public [n PUBLICITIES]\n",
  "PUBLICIZE": "to make public, also PUBLICISE [v PUBLICIZED, PUBLICIZING, PUBLICIZES]\n",
  "PUBLICIZED": "PUBLICIZE, to make public, also PUBLICISE [v]\n",
  "PUBLICIZES": "PUBLICIZE, to make public, also PUBLICISE [v]\n",
  "PUBLICIZING": "PUBLICIZE, to make public, also PUBLICISE [v]\n",
  "PUBLICLY": "PUBLIC, open to general view [adv]\n",
  "PUBLICNESS": "the state of being public [n -ES]\n",
  "PUBLICNESSES": "PUBLICNESS, the state of being public [n]\n",
  "PUBLICS": "PUBLIC, the community or the people as a whole [n]\n",
  "PUBLISH": "to print and issue to the public [v -ED, -ING, -ES]\n",
  "PUBLISHABLE": "that can be published [adj]\n",
  "PUBLISHED": "PUBLISH, to print and issue to the public [v]\n",
  "PUBLISHER": "one who publishes [n -S]\n",
  "PUBLISHERS": "PUBLISHER, one who publishes [n]\n",
  "PUBLISHES": "PUBLISH, to print and issue to the public [v]\n",
  "PUBLISHING": "the business of printing and issuing to the public [n -S]\n",
  "PUBLISHINGS": "PUBLISHING, the business of printing and issuing to the public [n]\n",
  "PUBLISHMENT": "publication [n -S]\n",
  "PUBLISHMENTS": "PUBLISHMENT, publication [n]\n",
  "PUBS": "PUB [n]\n",
  "PUCAN": "(Irish) a traditional Connemara open sailing boat [n -S]\n",
  "PUCANS": "PUCAN, (Irish) a traditional Connemara open sailing boat [n]\n",
  "PUCCINIACEOUS": "belonging to the genus Puccinia, a genus of rust-fungi [adj]\n",
  "PUCCOON": "(Native American) a plant with a red root and red sap, and bearing a pretty, white flower in early spring, aka bloodroot, redroot [n -S]\n",
  "PUCCOONS": "PUCCOON, (Native American) a plant with a red root and red sap, and bearing a pretty, white flower in early spring, aka bloodroot, redroot [n]\n",
  "PUCE": "dark red [adj PUCER, PUCEST] / a dark red colour [n -S]\n",
  "PUCELAGE": "virginity [n -S]\n",
  "PUCELAGES": "PUCELAGE, virginity [n]\n",
  "PUCELLE": "(obsolete) a slut; a maid or virgin, also PUSSEL, PUZEL, PUZZEL [n -S]\n",
  "PUCELLES": "PUCELLE, (obsolete) a slut; a maid or virgin, also PUSSEL, PUZEL, PUZZEL [n]\n",
  "PUCER": "PUCE, dark red [adj]\n",
  "PUCES": "PUCE, a dark red colour [n]\n",
  "PUCEST": "PUCE, dark red [adj]\n",
  "PUCK": "a thick rubber disc used in ice hockey [n -S] / to hit a puck [v -ED, -ING, -S]\n",
  "PUCKA": "(Hindi) genuine; first-class, also PAKKA, PUKKA, PUKKAH [adj]\n",
  "PUCKED": "PUCK, to hit a puck [v]\n",
  "PUCKER": "to gather into small wrinkles or folds [v -ED, -ING, -S]\n",
  "PUCKERED": "PUCKER, to gather into small wrinkles or folds [v]\n",
  "PUCKERER": "one who, or that which, puckers [n -S]\n",
  "PUCKERERS": "PUCKERER, one who, or that which, puckers [n]\n",
  "PUCKERIER": "PUCKERY, astringent; tending to wrinkle [adj]\n",
  "PUCKERIES": "PUCKERY, puckishness [n]\n",
  "PUCKERIEST": "PUCKERY, astringent; tending to wrinkle [adj]\n",
  "PUCKERING": "PUCKER, to gather into small wrinkles or folds [v]\n",
  "PUCKEROOD": "(New Zealand slang) ruined, exhausted, also PUCKEROOED [adj]\n",
  "PUCKEROOED": "(slang) exhausted, also PUCKEROOD [adj]\n",
  "PUCKERS": "PUCKER, to gather into small wrinkles or folds [v]\n",
  "PUCKERY": "astringent; tending to wrinkle [adj PUCKERIER, PUCKERIEST] / puckishness [n PUCKERIES]\n",
  "PUCKFIST": "a puffball fungus [n -S]\n",
  "PUCKFISTS": "PUCKFIST, a puffball fungus [n]\n",
  "PUCKING": "PUCK, to hit a puck [v]\n",
  "PUCKISH": "like a puck, impish [adj PUCKISHLY]\n",
  "PUCKISHLY": "PUCKISH, like a puck, impish [adv]\n",
  "PUCKISHNESS": "the state of being puckish [n -ES]\n",
  "PUCKISHNESSES": "PUCKISHNESS, the state of being puckish [n]\n",
  "PUCKLE": "(Scots) a small quantity; a grain of corn [n -S]\n",
  "PUCKLES": "PUCKLE, (Scots) a small quantity; a grain of corn [n]\n",
  "PUCKOUT": "in ice hockey, a free hit from the goal area made by the goalkeeper [n -S]\n",
  "PUCKOUTS": "PUCKOUT, in ice hockey, a free hit from the goal area made by the goalkeeper [n]\n",
  "PUCKS": "PUCK, a thick rubber disc used in ice hockey [n]\n",
  "PUCKSTER": "a hockey player [n -S]\n",
  "PUCKSTERS": "PUCKSTER, a hockey player [n]\n",
  "PUD": "(colloquial) pudding [n -S]\n",
  "PUDDEN": "a dull person [n -S]\n",
  "PUDDENING": "a pad of rope used as a fender on a boat [n -S]\n",
  "PUDDENINGS": "PUDDENING, a pad of rope used as a fender on a boat [n]\n",
  "PUDDENS": "PUDDEN, a dull person [n]\n",
  "PUDDER": "to make a tumult or bustle, also POTHER [v -ED, -ING, -S]\n",
  "PUDDERED": "PUDDER, to make a tumult or bustle, also POTHER [v]\n",
  "PUDDERING": "PUDDER, to make a tumult or bustle, also POTHER [v]\n",
  "PUDDERS": "PUDDER, to make a tumult or bustle, also POTHER [v]\n",
  "PUDDIER": "PUDDY, short and pudgy [adj]\n",
  "PUDDIES": "PUDDY, (colloquial) a paw, fist [n]\n",
  "PUDDIEST": "PUDDY, short and pudgy [adj]\n",
  "PUDDING": "a thick, soft dessert, also PUDDEN [n -S]\n",
  "PUDDINGIER": "PUDDINGY, like a pudding, soft and stodgy [adj]\n",
  "PUDDINGIEST": "PUDDINGY, like a pudding, soft and stodgy [adj]\n",
  "PUDDINGS": "PUDDING, a thick, soft dessert, also PUDDEN [n]\n",
  "PUDDINGY": "like a pudding, soft and stodgy [adj PUDDINGIER, PUDDINGIEST]\n",
  "PUDDLE": "to make a small pool of water [v PUDDLED, PUDDLING, PUDDLES]\n",
  "PUDDLED": "PUDDLE, to make a small pool of water [v]\n",
  "PUDDLER": "one who converts pig-iron to wrought-iron [n -S]\n",
  "PUDDLERS": "PUDDLER, one who converts pig-iron to wrought-iron [n]\n",
  "PUDDLES": "PUDDLE, to make a small pool of water [v]\n",
  "PUDDLIER": "PUDDLY, full of puddles [adj]\n",
  "PUDDLIEST": "PUDDLY, full of puddles [adj]\n",
  "PUDDLING": "the process of converting pig iron to wrought iron [n -S]\n",
  "PUDDLINGS": "PUDDLING, the process of converting pig iron to wrought iron [n]\n",
  "PUDDLY": "full of puddles [adj PUDDLIER, PUDDLIEST]\n",
  "PUDDOCK": "a toad or frog, also PADDOCK [n -S]\n",
  "PUDDOCKS": "PUDDOCK, a toad or frog, also PADDOCK [n]\n",
  "PUDDY": "(colloquial) a paw, fist [n PUDDIES] / short and pudgy [adj PUDDIER, PUDDIEST]\n",
  "PUDENCIES": "PUDENCY, (Shakespeare) modesty, shamefacedness [n]\n",
  "PUDENCY": "(Shakespeare) modesty, shamefacedness [n PUDENCIES]\n",
  "PUDENDA": "PUDENDUM, (Latin) the external genital organs of a woman [n]\n",
  "PUDENDAL": "pertaining to the pudendum [adj]\n",
  "PUDENDOUS": "(obsolete) shameful [adj]\n",
  "PUDENDUM": "(Latin) the external genital organs of a woman [n PUDENDA]\n",
  "PUDENT": "modest [adj]\n",
  "PUDEUR": "(French) a sense of shame or embarrassment [n -S]\n",
  "PUDEURS": "PUDEUR, (French) a sense of shame or embarrassment [n]\n",
  "PUDGE": "a short, thickset person, also PODGE [n -S]\n",
  "PUDGES": "PUDGE, a short, thickset person, also PODGE [n]\n",
  "PUDGIER": "PUDGY, short and fat, also PODGY, PUDSEY, PUDSY [adj]\n",
  "PUDGIEST": "PUDGY, short and fat, also PODGY, PUDSEY, PUDSY [adj]\n",
  "PUDGILY": "PUDGY, short and fat, also PODGY, PUDSEY, PUDSY [adv]\n",
  "PUDGINESS": "the state of being pudgy [n -ES]\n",
  "PUDGINESSES": "PUDGINESS, the state of being pudgy [n]\n",
  "PUDGY": "short and fat, also PODGY, PUDSEY, PUDSY [adj PUDGIER, PUDGIEST, PUDGILY]\n",
  "PUDIBUND": "shamefaced; prudish [adj]\n",
  "PUDIBUNDITIES": "PUDIBUNDITY, the state of being pudibund [n]\n",
  "PUDIBUNDITY": "the state of being pudibund [n PUDIBUNDITIES]\n",
  "PUDIC": "pertaining to the pudendum [adj]\n",
  "PUDICITIES": "PUDICITY, modesty; chastity [n]\n",
  "PUDICITY": "modesty; chastity [n PUDICITIES]\n",
  "PUDOR": "(obsolete) a sense of shame [n -S]\n",
  "PUDORS": "PUDOR, (obsolete) a sense of shame [n]\n",
  "PUDS": "PUD, (colloquial) pudding [n]\n",
  "PUDSEY": "short and fat, also PUDGY, PODGY, PUDSY [adj]\n",
  "PUDSIER": "PUDSY, podgy, also PUDSEY [adj]\n",
  "PUDSIES": "PUDSY, a plump person [n]\n",
  "PUDSIEST": "PUDSY, podgy, also PUDSEY [adj]\n",
  "PUDSY": "podgy, also PUDSEY [adj PUDSIER, PUDSIEST] / a plump person [n PUDSIES]\n",
  "PUDU": "a very small deer, native of the Chilian Andes [n -S]\n",
  "PUDUS": "PUDU, a very small deer, native of the Chilian Andes [n]\n",
  "PUEBLO": "(Spanish) a communal dwelling of certain Indian tribes [n -S]\n",
  "PUEBLOS": "PUEBLO, (Spanish) a communal dwelling of certain Indian tribes [n]\n",
  "PUER": "to tan leather with dog faeces [v -ED, -ING, -S]\n",
  "PUERED": "PUER, to tan leather with dog faeces [v]\n",
  "PUERILE": "juvenile; childish [adj PUERILELY]\n",
  "PUERILELY": "PUERILE, juvenile; childish [adv]\n",
  "PUERILISM": "childishness [n -S]\n",
  "PUERILISMS": "PUERILISM, childishness [n]\n",
  "PUERILITIES": "PUERILITY, the state of being puerile [n]\n",
  "PUERILITY": "the state of being puerile [n PUERILITIES]\n",
  "PUERING": "PUER, to tan leather with dog faeces [v]\n",
  "PUERPERA": "(Latin) a woman who has recently given birth [n PUERPERAE]\n",
  "PUERPERAE": "PUERPERA, (Latin) a woman who has recently given birth [n]\n",
  "PUERPERAL": "of or relating to childbirth [adj PUERPERALLY]\n",
  "PUERPERALLY": "PUERPERAL, of or relating to childbirth [adv]\n",
  "PUERPERIA": "PUERPERIUM, (Latin) the condition immediately following childbirth [n]\n",
  "PUERPERIUM": "(Latin) the condition immediately following childbirth [n PUERPERIA]\n",
  "PUERS": "PUER, to tan leather with dog faeces [v]\n",
  "PUFF": "to blow in short gusts [v -ED, -ING, -S]\n",
  "PUFFA": "as in puffa jacket, a warm quilted and padded jacket [adj]\n",
  "PUFFBACK": "a small African bird [n -S]\n",
  "PUFFBACKS": "PUFFBACK, a small African bird [n]\n",
  "PUFFBALL": "any of various globular fungi [n -S]\n",
  "PUFFBALLS": "PUFFBALL, any of various globular fungi [n]\n",
  "PUFFBIRD": "any bird of a Central American family relating to the barbets [n -S]\n",
  "PUFFBIRDS": "PUFFBIRD, any bird of a Central American family relating to the barbets [n]\n",
  "PUFFED": "PUFF, to blow in short gusts [v]\n",
  "PUFFER": "a steam-engine; a kind of fish [n -S]\n",
  "PUFFERFISH": "a kind of fish, capable of inflating its body [n -ES]\n",
  "PUFFERFISHES": "PUFFERFISH, a kind of fish, capable of inflating its body [n]\n",
  "PUFFERIES": "PUFFERY, excessive public praise [n]\n",
  "PUFFERS": "PUFFER, a steam-engine; a kind of fish [n]\n",
  "PUFFERY": "excessive public praise [n PUFFERIES]\n",
  "PUFFIER": "PUFFY, swollen [adj]\n",
  "PUFFIEST": "PUFFY, swollen [adj]\n",
  "PUFFILY": "PUFFY, swollen [adv]\n",
  "PUFFIN": "a seabird of the auk family [n -S]\n",
  "PUFFINESS": "the state of being puffy [n -ES]\n",
  "PUFFINESSES": "PUFFINESS, the state of being puffy [n]\n",
  "PUFFING": "the action of puffing [n -S]\n",
  "PUFFINGLY": "PUFFING [adv]\n",
  "PUFFINGS": "PUFFING, the action of puffing [n]\n",
  "PUFFINS": "PUFFIN, a seabird of the auk family [n]\n",
  "PUFFS": "PUFF, to blow in short gusts [v]\n",
  "PUFFTALOONAS": "(Australian) a type of fried cake, eaten hot with jam, honey or sugar, also PUFTALOON, PUFTALOONIES [n]\n",
  "PUFFY": "swollen [adj PUFFIER, PUFFIEST, PUFFILY]\n",
  "PUFTALOON": "(Australian) a type of fried cake, eaten hot with jam, honey or sugar, also PUFFTALOONAS, PUFTALOONIES [n -S or -AS]\n",
  "PUFTALOONAS": "PUFTALOON, (Australian) a type of fried cake, eaten hot with jam, honey or sugar, also PUFFTALOONAS, PUFTALOONIES [n]\n",
  "PUFTALOONIES": "(Australian) a type of fried cake, eaten hot with jam, honey or sugar, also PUFFTALOONAS, PUFTALOON [n]\n",
  "PUFTALOONS": "PUFTALOON, (Australian) a type of fried cake, eaten hot with jam, honey or sugar, also PUFFTALOONAS, PUFTALOONIES [n]\n",
  "PUG": "to fill in with clay or mortar [v PUGGED, PUGGING, PUGS]\n",
  "PUGAREE": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGGAREE, PUGGERY, PUGGREE, PUGGRY, PUGREE [n -S]\n",
  "PUGAREES": "PUGAREE, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGGAREE, PUGGERY, PUGGREE, PUGGRY, PUGREE [n]\n",
  "PUGGAREE": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGERY, PUGGREE, PUGGRY, PUGREE [n -S]\n",
  "PUGGAREES": "PUGGAREE, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGERY, PUGGREE, PUGGRY, PUGREE [n]\n",
  "PUGGED": "PUG, to fill in with clay or mortar [v]\n",
  "PUGGERIES": "PUGGERY, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGREE, PUGGRY, PUGREE [n]\n",
  "PUGGERY": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGREE, PUGGRY, PUGREE [n PUGGERIES]\n",
  "PUGGIE": "(Scots) a monkey, also PUGGY [n -S]\n",
  "PUGGIER": "PUGGY, like a monkey or pug-dog, also PUGGIE [adj]\n",
  "PUGGIES": "PUGGIE, (Scots) a monkey, also PUGGY [n]\n",
  "PUGGIEST": "PUGGY, like a monkey or pug-dog, also PUGGIE [adj]\n",
  "PUGGINESS": "the state of being puggy, like a monkey [n -ES]\n",
  "PUGGINESSES": "PUGGINESS, the state of being puggy, like a monkey [n]\n",
  "PUGGING": "the working of clay for making bricks [n PUGGINGS]\n",
  "PUGGINGS": "PUGGING, the working of clay for making bricks [n]\n",
  "PUGGISH": "like a monkey or pug-dog; snub-nosed [adj]\n",
  "PUGGLE": "to cause to become exhausted [v PUGGLED, PUGGLING, PUGGLES]\n",
  "PUGGLED": "PUGGLE, to cause to become exhausted [v]\n",
  "PUGGLES": "PUGGLE, to cause to become exhausted [v]\n",
  "PUGGLING": "PUGGLE, to cause to become exhausted [v]\n",
  "PUGGREE": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGERY, PUGGRY, PUGREE [n -S]\n",
  "PUGGREES": "PUGGREE, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGERY, PUGGRY, PUGREE [n]\n",
  "PUGGRIES": "PUGGRY, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGERY, PUGGREE, PUGREE [n]\n",
  "PUGGRY": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGERY, PUGGREE, PUGREE [n PUGGRIES]\n",
  "PUGGY": "like a monkey or pug-dog, also PUGGIE [adj PUGGIER, PUGGIEST] / (Scots) a monkey [n PUGGIES]\n",
  "PUGH": "(obsolete) an expression of contempt, also PUH [interj]\n",
  "PUGIL": "(obsolete) a boxer [n -S]\n",
  "PUGILISM": "the art of fighting with the fists [n -S]\n",
  "PUGILISMS": "PUGILISM, the art of fighting with the fists [n]\n",
  "PUGILIST": "one who fights with his fists [n -S]\n",
  "PUGILISTIC": "related to pugilism, also PUGILISTICAL [adj PUGILISTICALLY]\n",
  "PUGILISTICAL": "related to pugilism, also PUGILISTIC [adj PUGILISTICALLY]\n",
  "PUGILISTICALLY": "PUGILISTICAL, related to pugilism, also PUGILISTIC [adv]\n",
  "PUGILISTS": "PUGILIST, one who fights with his fists [n]\n",
  "PUGILS": "PUGIL, (obsolete) a boxer [n]\n",
  "PUGMARK": "the track of a big cat e.g. a tiger [n -S]\n",
  "PUGMARKS": "PUGMARK, the track of a big cat e.g. a tiger [n]\n",
  "PUGNACIOUS": "having a quarrelsome or combative nature [adj PUGNACIOUSLY]\n",
  "PUGNACIOUSLY": "PUGNACIOUS, having a quarrelsome or combative nature [adv]\n",
  "PUGNACIOUSNESS": "PUGNACIOUS, having a quarrelsome or combative nature [n]\n",
  "PUGNACITIES": "PUGNACITY, the state of being pugnacious [n]\n",
  "PUGNACITY": "the state of being pugnacious [n PUGNACITIES]\n",
  "PUGREE": "(Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGERY, PUGGREE, PUGGRY [n -S]\n",
  "PUGREES": "PUGREE, (Hindi) a turban, a light scarf worn round a hat to keep out the sun, also PAGRI, PUGAREE, PUGGAREE, PUGGERY, PUGGREE, PUGGRY [n]\n",
  "PUGS": "PUG, to fill in with clay or mortar [v]\n",
  "PUH": "(Shakespeare) an interjection expressing disgust, also PUGH [interj]\n",
  "PUHA": "(Maori) sow thistle [n -S]\n",
  "PUHAS": "PUHA, (Maori) sow thistle [n]\n",
  "PUIR": "(Scots) poor [adj PUIRER, PUIREST]\n",
  "PUIRER": "PUIR, (Scots) poor [adj]\n",
  "PUIREST": "PUIR, (Scots) poor [adj]\n",
  "PUIRTITH": "(Scots) poverty, also POORTITH [n -S]\n",
  "PUIRTITHS": "PUIRTITH, (Scots) poverty, also POORTITH [n]\n",
  "PUISNE": "puny; surviving as a term applied to certain junior judges, also PUISNY [adj] / a puisne judge [n -S]\n",
  "PUISNES": "PUISNE, a puisne judge [n]\n",
  "PUISNY": "(Shakespeare) puny, also PUISNE [adj]\n",
  "PUISSANCE": "(archaic) power, also PUISSAUNCE [n -S]\n",
  "PUISSANCES": "PUISSANCE, (archaic) power, also PUISSAUNCE [n]\n",
  "PUISSANT": "(archaic) powerful, also PUISSAUNT [adj PUISSANTLY]\n",
  "PUISSANTLY": "PUISSANT, (archaic) powerful, also PUISSAUNT [adv]\n",
  "PUISSAUNCE": "power, potency, also PUISSANCE [n -S]\n",
  "PUISSAUNCES": "PUISSAUNCE, power, potency, also PUISSANCE [n]\n",
  "PUISSAUNT": "(archaic) powerful, also PUISSANT [adj]\n",
  "PUJA": "(Sanskrit) a Hindu worship practice, also POOJA, POOJAH, PUJAH [n -S]\n",
  "PUJAH": "(Sanskrit) a Hindu act of worship or prayer, also POOJA, POOJAH, PUJA [n -S]\n",
  "PUJAHS": "PUJAH, (Sanskrit) a Hindu act of worship or prayer, also POOJA, POOJAH, PUJA [n]\n",
  "PUJARI": "(Hindu) a priest [n -S]\n",
  "PUJARIS": "PUJARI, (Hindu) a priest [n]\n",
  "PUJAS": "PUJA, (Sanskrit) a Hindu worship practice, also POOJA, POOJAH, PUJAH [n]\n",
  "PUKA": "(Maori) a large evergreen tree, aka broadleaf or papauma, also KAPUKA [n -S]\n",
  "PUKAS": "PUKA, (Maori) a large evergreen tree, aka broadleaf or papauma, also KAPUKA [n]\n",
  "PUKATEA": "(Maori) an aromatic New Zealand tree, valued for its high-quality timber [n -S]\n",
  "PUKATEAS": "PUKATEA, (Maori) an aromatic New Zealand tree, valued for its high-quality timber [n]\n",
  "PUKE": "to vomit [v PUKED, PUKING, PUKES]\n",
  "PUKED": "PUKE, to vomit [v]\n",
  "PUKEKO": "(Maori) a New Zealand wading bird with bright plumage [n -S]\n",
  "PUKEKOS": "PUKEKO, (Maori) a New Zealand wading bird with bright plumage [n]\n",
  "PUKER": "(archaic) an emetic [n -S]\n",
  "PUKERS": "PUKER, (archaic) an emetic [n]\n",
  "PUKES": "PUKE, to vomit [v]\n",
  "PUKEY": "reminiscent of or resembling vomit, also PUKY [adj PUKIER, PUKIEST]\n",
  "PUKIER": "PUKY, reminiscent of or resembling vomit, also PUKEY [adj]\n",
  "PUKIEST": "PUKY, reminiscent of or resembling vomit, also PUKEY [adj]\n",
  "PUKING": "PUKE, to vomit [v]\n",
  "PUKKA": "(Hindi) genuine; first-class, also PAKKA, PUCKA, PUKKAH [adj]\n",
  "PUKKAH": "genuine, also PAKKA, PUCKA, PUKKA [adj]\n",
  "PUKU": "(Zulu) an antelope of central southern Africa, related to the waterbuck [n -S]\n",
  "PUKUS": "PUKU, (Zulu) an antelope of central southern Africa, related to the waterbuck [n]\n",
  "PUKY": "reminiscent of or resembling vomit, also PUKEY [adj PUKIER, PUKIEST]\n",
  "PUL": "a coin of Afghanistan [n PULS or PULI]\n",
  "PULA": "(Setswana) a monetary unit of Botswana, 100 thebe [n -S]\n",
  "PULAO": "(Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILAW, PILOW, PILLAU [n -S]\n",
  "PULAOS": "PULAO, (Persian) a dish made from seasoned rice and meat, also PILAO, PILAU, PILAFF, PILAF, PILAW, PILOW, PILLAU [n]\n",
  "PULAS": "PULA, (Setswana) a monetary unit of Botswana, 100 thebe [n]\n",
  "PULCHRITUDE": "beauty [n -S]\n",
  "PULCHRITUDES": "PULCHRITUDE, beauty [n]\n",
  "PULCHRITUDINOUS": "beautiful, comely [adj]\n",
  "PULDRON": "(obsolete) a shoulder-plate of a suit of armour, also PAULDRON, POULDRON [n -S]\n",
  "PULDRONS": "PULDRON, (obsolete) a shoulder-plate of a suit of armour, also PAULDRON, POULDRON [n]\n",
  "PULE": "to pipe; to whimper or whine [v PULED, PULING, PULES]\n",
  "PULED": "PULE, to pipe; to whimper or whine [v]\n",
  "PULER": "one who pules [n -S]\n",
  "PULERS": "PULER, one who pules [n]\n",
  "PULES": "PULE, to pipe; to whimper or whine [v]\n",
  "PULI": "(Hungarian) a longhaired sheepdog [n PULIS or PULIK]\n",
  "PULICENE": "pertaining to, or abounding in, fleas [adj]\n",
  "PULICIDE": "an agent used for destroying fleas [n -S]\n",
  "PULICIDES": "PULICIDE, an agent used for destroying fleas [n]\n",
  "PULIER": "PULY, given to puling, whiny [adj]\n",
  "PULIEST": "PULY, given to puling, whiny [adj]\n",
  "PULIK": "PULI, (Hungarian) a longhaired sheepdog [n]\n",
  "PULING": "whimpering [adj PULINGLY] / a plaintive cry [n -S]\n",
  "PULINGLY": "PULING, whimpering [adv]\n",
  "PULINGS": "PULING, a plaintive cry [n]\n",
  "PULIS": "PULI, (Hungarian) a longhaired sheepdog [n]\n",
  "PULK": "(Finnish) a Laplander's boat-shaped sledge, also PULKA, PULKHA [n -S]\n",
  "PULKA": "(Finnish) a Laplander's boat-shaped sledge, also PULK, PULKHA [n -S]\n",
  "PULKAS": "PULKA, (Finnish) a Laplander's boat-shaped sledge, also PULK, PULKHA [n]\n",
  "PULKHA": "(Finnish) a Laplander's boat-shaped sledge, also PULKA, PULK [n -S]\n",
  "PULKHAS": "PULKHA, (Finnish) a Laplander's boat-shaped sledge, also PULKA, PULK [n]\n",
  "PULKS": "PULK, (Finnish) a Laplander's boat-shaped sledge, also PULKA, PULKHA [n]\n",
  "PULL": "to draw or drag [v -ED, -ING, -S]\n",
  "PULLBACK": "a restraint or drawback [n -S]\n",
  "PULLBACKS": "PULLBACK, a restraint or drawback [n]\n",
  "PULLED": "PULL, to draw or drag [v]\n",
  "PULLER": "one that pulls [n -S]\n",
  "PULLERS": "PULLER, one that pulls [n]\n",
  "PULLET": "a young hen [n -S]\n",
  "PULLETS": "PULLET, a young hen [n]\n",
  "PULLEY": "to hoist with a pulley [v -ED, -ING, -S]\n",
  "PULLEYED": "PULLEY, to hoist with a pulley [v]\n",
  "PULLEYING": "PULLEY, to hoist with a pulley [v]\n",
  "PULLEYS": "PULLEY, to hoist with a pulley [v]\n",
  "PULLI": "PULLUS, a chick or young bird [n]\n",
  "PULLIES": "PULLY, (colloquial) a pullover [n]\n",
  "PULLING": "PULL, to draw or drag [v]\n",
  "PULLMAN": "a railroad sleeping car [n -S]\n",
  "PULLMANS": "PULLMAN, a railroad sleeping car [n]\n",
  "PULLORUM": "as in pullorum disease, a bacterial infection in chickens [adj]\n",
  "PULLOUT": "a withdrawal [n -S]\n",
  "PULLOUTS": "PULLOUT, a withdrawal [n]\n",
  "PULLOVER": "a garment that is put by drawing over the head [n -S]\n",
  "PULLOVERS": "PULLOVER, a garment that is put by drawing over the head [n]\n",
  "PULLS": "PULL, to draw or drag [v]\n",
  "PULLULATE": "to swarm, to teem; to breed freely [v PULLULATED, PULLULATING, PULLULATES]\n",
  "PULLULATED": "PULLULATE, to swarm, to teem; to breed freely [v]\n",
  "PULLULATES": "PULLULATE, to swarm, to teem; to breed freely [v]\n",
  "PULLULATING": "PULLULATE, to swarm, to teem; to breed freely [v]\n",
  "PULLULATION": "the act of pullulating [n -S]\n",
  "PULLULATIONS": "PULLULATION, the act of pullulating [n]\n",
  "PULLUP": "the act of raising oneself while hanging by the hands [n -S]\n",
  "PULLUPS": "PULLUP, the act of raising oneself while hanging by the hands [n]\n",
  "PULLUS": "a chick or young bird [n PULLI]\n",
  "PULLY": "(colloquial) a pullover [n PULLIES]\n",
  "PULMO": "(Latin) a lung [n PULMONES]\n",
  "PULMOBRANCH": "a lung-book [n -S]\n",
  "PULMOBRANCHIATE": "relating to a pulmobranch, a lung-book [adj]\n",
  "PULMOBRANCHS": "PULMOBRANCH, a lung-book [n]\n",
  "PULMONARY": "of or pertaining to the lungs, also PULMONIC [adj]\n",
  "PULMONATE": "a member of the Pulmonata, an air-breathing order or subclass of Gastropoda [n -S]\n",
  "PULMONATES": "PULMONATE, a member of the Pulmonata, an air-breathing order or subclass of Gastropoda [n]\n",
  "PULMONES": "PULMO, (Latin) a lung [n]\n",
  "PULMONIC": "of or relating to the lungs, also PULMONARY [adj] / a medicine for the lungs [n -S]\n",
  "PULMONICS": "PULMONIC, a medicine for the lungs [n]\n",
  "PULMONOLOGIES": "PULMONOLOGY, the branch of medicine concerned with the study of the lungs [n]\n",
  "PULMONOLOGIST": "a consultant in pulmonology, the study of the lungs [n -S]\n",
  "PULMONOLOGISTS": "PULMONOLOGIST, a consultant in pulmonology, the study of the lungs [n]\n",
  "PULMONOLOGY": "the branch of medicine concerned with the study of the lungs [n PULMONOLOGIES]\n",
  "PULMOTOR": "a respiratory device [n -S]\n",
  "PULMOTORS": "PULMOTOR, a respiratory device [n]\n",
  "PULP": "to reduce to a soft, moist mass of matter [v -ED, -ING, -S]\n",
  "PULPAL": "pertaining to pulp [adj PULPALLY]\n",
  "PULPALLY": "PULPAL, pertaining to pulp [adv]\n",
  "PULPBOARD": "a coarse cardboard made from pulp [n -S]\n",
  "PULPBOARDS": "PULPBOARD, a coarse cardboard made from pulp [n]\n",
  "PULPED": "PULP, to reduce to a soft, moist mass of matter [v]\n",
  "PULPER": "a machine for pulping [n -S]\n",
  "PULPERS": "PULPER, a machine for pulping [n]\n",
  "PULPIER": "PULPY, resembling pulp [adj]\n",
  "PULPIEST": "PULPY, resembling pulp [adj]\n",
  "PULPIFIED": "PULPIFY, to reduce to pulp [v]\n",
  "PULPIFIES": "PULPIFY, to reduce to pulp [v]\n",
  "PULPIFY": "to reduce to pulp [v PULPIFIED, PULPIFYING, PULPIFIES]\n",
  "PULPIFYING": "PULPIFY, to reduce to pulp [v]\n",
  "PULPILY": "PULPY, resembling pulp [adv]\n",
  "PULPINESS": "the state of being pulpy [n -ES]\n",
  "PULPINESSES": "PULPINESS, the state of being pulpy [n]\n",
  "PULPING": "the act of reducing to pulp [n -S]\n",
  "PULPINGS": "PULPING, the act of reducing to pulp [n]\n",
  "PULPIT": "a raised structure for preaching from [n -S]\n",
  "PULPITAL": "relating to a pulpit [adj]\n",
  "PULPITED": "provided with a pulpit [adj]\n",
  "PULPITEER": "someone who speaks from a pulpit, a preacher, also PULPITER [n -S] / to preach from a pulpit [v -ED, -ING, -S]\n",
  "PULPITEERED": "PULPITEER, to preach from a pulpit [v]\n",
  "PULPITEERING": "PULPITEER, to preach from a pulpit [v]\n",
  "PULPITEERS": "PULPITEER, someone who speaks from a pulpit, a preacher, also PULPITER [n]\n",
  "PULPITER": "someone who speaks from a pulpit, a preacher, also PULPITEER [n -S]\n",
  "PULPITERS": "PULPITER, someone who speaks from a pulpit, a preacher, also PULPITEER [n]\n",
  "PULPITRIES": "PULPITRY, sermonizing [n]\n",
  "PULPITRY": "sermonizing [n PULPITRIES]\n",
  "PULPITS": "PULPIT, a raised structure for preaching from [n]\n",
  "PULPITUM": "(Latin) a gigantic stone screen separating a cathedral choir from the nave [n -S]\n",
  "PULPITUMS": "PULPITUM, (Latin) a gigantic stone screen separating a cathedral choir from the nave [n]\n",
  "PULPLESS": "having no pulp [adj]\n",
  "PULPMILL": "a machine for pulping wood [n -S]\n",
  "PULPMILLS": "PULPMILL, a machine for pulping wood [n]\n",
  "PULPOUS": "containing pulp; pulpy [adj]\n",
  "PULPS": "PULP, to reduce to a soft, moist mass of matter [v]\n",
  "PULPSTONE": "a grindstone for pulping wood [n -S]\n",
  "PULPSTONES": "PULPSTONE, a grindstone for pulping wood [n]\n",
  "PULPWOOD": "soft wood used in making paper [n -S]\n",
  "PULPWOODS": "PULPWOOD, soft wood used in making paper [n]\n",
  "PULPY": "resembling pulp [adj PULPIER, PULPIEST, PULPILY]\n",
  "PULQUE": "(Nahuatl) a fermented Mexican beverage made from agave [n -S]\n",
  "PULQUES": "PULQUE, (Nahuatl) a fermented Mexican beverage made from agave [n]\n",
  "PULS": "PUL, a coin of Afghanistan [n]\n",
  "PULSANT": "pulsating [adj]\n",
  "PULSAR": "a celestial source of radio waves [n -S]\n",
  "PULSARS": "PULSAR, a celestial source of radio waves [n]\n",
  "PULSATANCE": "the angular frequency of a periodic motion [n -S]\n",
  "PULSATANCES": "PULSATANCE, the angular frequency of a periodic motion [n]\n",
  "PULSATE": "to expand and contract rhythmically, also PULSE [v PULSATED, PULSATING, PULSATES]\n",
  "PULSATED": "PULSATE, to expand and contract rhythmically, also PULSE [v]\n",
  "PULSATES": "PULSATE, to expand and contract rhythmically, also PULSE [v]\n",
  "PULSATILE": "of musical instruments, played by percussion, also PULSATIVE [adj]\n",
  "PULSATILITIES": "PULSATILITY, the state of being pulsatile [n]\n",
  "PULSATILITY": "the state of being pulsatile [n PULSATILITIES]\n",
  "PULSATILLA": "another name for pasqueflower [n -S]\n",
  "PULSATILLAS": "PULSATILLA, another name for pasqueflower [n]\n",
  "PULSATING": "PULSATE, to expand and contract rhythmically, also PULSE [v]\n",
  "PULSATION": "a beating or throbbing [n -S]\n",
  "PULSATIONS": "PULSATION, a beating or throbbing [n]\n",
  "PULSATIVE": "of musical instruments, played by percussion, also PULSATILE [adj PULSATIVELY]\n",
  "PULSATIVELY": "PULSATIVE, of musical instruments, played by percussion, also PULSATILE [adv]\n",
  "PULSATOR": "something that pulsates [n -S]\n",
  "PULSATORS": "PULSATOR, something that pulsates [n]\n",
  "PULSATORY": "capable of pulsating; throbbing [adj]\n",
  "PULSE": "to expand and contract rhythmically, also PULSATE [v PULSED, PULSING, PULSES]\n",
  "PULSEBEAT": "the pulse [n -S]\n",
  "PULSEBEATS": "PULSEBEAT, the pulse [n]\n",
  "PULSED": "PULSE, to expand and contract rhythmically, also PULSATE [v]\n",
  "PULSEJET": "in jet propulsion, an intermittent jet, also PULSOJET [n -S]\n",
  "PULSEJETS": "PULSEJET, in jet propulsion, an intermittent jet, also PULSOJET [n]\n",
  "PULSELESS": "without a pulse [adj]\n",
  "PULSELESSNESS": "the state of being pulseless [n -ES]\n",
  "PULSELESSNESSES": "PULSELESSNESS, the state of being pulseless [n]\n",
  "PULSER": "a device that causes pulsations [n -S]\n",
  "PULSERS": "PULSER, a device that causes pulsations [n]\n",
  "PULSES": "PULSE, to expand and contract rhythmically, also PULSATE [v]\n",
  "PULSIDGE": "(Shakespeare) the throb of a pulse [n -S]\n",
  "PULSIDGES": "PULSIDGE, (Shakespeare) the throb of a pulse [n]\n",
  "PULSIFIC": "producing a single pulse [adj]\n",
  "PULSIMETER": "an instrument for measuring the pulse [n -S]\n",
  "PULSIMETERS": "PULSIMETER, an instrument for measuring the pulse [n]\n",
  "PULSING": "PULSE, to expand and contract rhythmically, also PULSATE [v]\n",
  "PULSION": "the act of driving forward; propulsion [n -S]\n",
  "PULSIONS": "PULSION, the act of driving forward; propulsion [n]\n",
  "PULSOJET": "in jet propulsion, an intermittent jet, also PULSEJET [n -S]\n",
  "PULSOJETS": "PULSOJET, in jet propulsion, an intermittent jet, also PULSEJET [n]\n",
  "PULSOMETER": "a pump that draws in water by condensation of steam in two chambers alternately [n -S]\n",
  "PULSOMETERS": "PULSOMETER, a pump that draws in water by condensation of steam in two chambers alternately [n]\n",
  "PULTACEOUS": "macerated and softened [adj]\n",
  "PULTAN": "(Hindi) an Indian regiment, also PULTUN, PULTON, PULTOON [n -S]\n",
  "PULTANS": "PULTAN, (Hindi) an Indian regiment, also PULTUN, PULTON, PULTOON [n]\n",
  "PULTON": "(Hindi) an Indian regiment, also PULTUN, PULTAN, PULTOON [n -S]\n",
  "PULTONS": "PULTON, (Hindi) an Indian regiment, also PULTUN, PULTAN, PULTOON [n]\n",
  "PULTOON": "(Hindi) an Indian regiment, also PULTUN, PULTAN, PULTON [n -S]\n",
  "PULTOONS": "PULTOON, (Hindi) an Indian regiment, also PULTUN, PULTAN, PULTON [n]\n",
  "PULTRUDE": "to carry out pultrusion, a process for producing reinforced plastic products [v PULTRUDED, PULTRUDING, PULTRUDES]\n",
  "PULTRUDED": "PULTRUDE, to carry out pultrusion, a process for producing reinforced plastic products [v]\n",
  "PULTRUDES": "PULTRUDE, to carry out pultrusion, a process for producing reinforced plastic products [v]\n",
  "PULTRUDING": "PULTRUDE, to carry out pultrusion, a process for producing reinforced plastic products [v]\n",
  "PULTRUSION": "a process for producing reinforced plastic products [n -S]\n",
  "PULTRUSIONS": "PULTRUSION, a process for producing reinforced plastic products [n]\n",
  "PULTUN": "(Hindi) an Indian regiment, also PULTAN, PULTON, PULTOON [n -S]\n",
  "PULTUNS": "PULTUN, (Hindi) an Indian regiment, also PULTAN, PULTON, PULTOON [n]\n",
  "PULTURE": "a right to food for man, horse and dog in a forest, also PUTURE [n -S]\n",
  "PULTURES": "PULTURE, a right to food for man, horse and dog in a forest, also PUTURE [n]\n",
  "PULU": "(Hawaiian) a silky fibre obtained from the Hawaiian tree-fern [n -S]\n",
  "PULUS": "PULU, (Hawaiian) a silky fibre obtained from the Hawaiian tree-fern [n]\n",
  "PULVER": "to reduce to powder [v -ED, -ING, -S]\n",
  "PULVERABLE": "that can be reduced to powder [adj]\n",
  "PULVERATION": "pulverization [n -S]\n",
  "PULVERATIONS": "PULVERATION, pulverization [n]\n",
  "PULVERED": "PULVER, to reduce to powder [v]\n",
  "PULVERINE": "barilla ash, used in glassmaking, also POLVERINE [n -S]\n",
  "PULVERINES": "PULVERINE, barilla ash, used in glassmaking, also POLVERINE [n]\n",
  "PULVERING": "PULVER, to reduce to powder [v]\n",
  "PULVERISABLE": "that can be pulverised, also PULVERIZABLE [adj]\n",
  "PULVERISATION": "the process of pulverising, also PULVERIZATION [n -S]\n",
  "PULVERISATIONS": "PULVERISATION, the process of pulverising, also PULVERIZATION [n]\n",
  "PULVERISE": "to reduce to powder, also PULVERIZE [v PULVERISED, PULVERISING, PULVERISES]\n",
  "PULVERISED": "PULVERISE, to reduce to powder, also PULVERIZE [v]\n",
  "PULVERISER": "one who pulverises, also PULVERIZER [n -S]\n",
  "PULVERISERS": "PULVERISER, one who pulverises, also PULVERIZER [n]\n",
  "PULVERISES": "PULVERISE, to reduce to powder, also PULVERIZE [v]\n",
  "PULVERISING": "PULVERISE, to reduce to powder, also PULVERIZE [v]\n",
  "PULVERIZABLE": "capable of being pulverized, also PULVERISABLE [adj]\n",
  "PULVERIZATION": "the act of pulverizing, also PULVERISATION [n -S]\n",
  "PULVERIZATIONS": "PULVERIZATION, the act of pulverizing, also PULVERISATION [n]\n",
  "PULVERIZE": "to reduce to powder [v PULVERIZED, PULVERIZING, PULVERIZES]\n",
  "PULVERIZED": "PULVERIZE, to reduce to powder [v]\n",
  "PULVERIZER": "one who pulverizes, also PULVERISER [n -S]\n",
  "PULVERIZERS": "PULVERIZER, one who pulverizes, also PULVERISER [n]\n",
  "PULVERIZES": "PULVERIZE, to reduce to powder [v]\n",
  "PULVERIZING": "PULVERIZE, to reduce to powder [v]\n",
  "PULVEROUS": "dusty or powder [adj]\n",
  "PULVERS": "PULVER, to reduce to powder [v]\n",
  "PULVERULENCE": "the state of being pulverulent, powdery [n -S]\n",
  "PULVERULENCES": "PULVERULENCE, the state of being pulverulent, powdery [n]\n",
  "PULVERULENT": "dusty-looking; readily crumbling; powdery [adj]\n",
  "PULVIL": "perfumed powder, also PULVILIO, PULVILLIO, PULVILLE [n -S] / to scent with pulvil [v PULVILLED, PULVILLING, PULVILS]\n",
  "PULVILIO": "(historical) perfumed powder; snuff, also PULVIL, PULVILLE, PULVILLIO [n -S]\n",
  "PULVILIOS": "PULVILIO, (historical) perfumed powder; snuff, also PULVIL, PULVILLE, PULVILLIO [n]\n",
  "PULVILISED": "in the form of pulvil, a perfumed powder, also PULVILIZED [adj]\n",
  "PULVILIZED": "in the form of pulvil, a perfumed powder, also PULVILISED [adj]\n",
  "PULVILLAR": "cushion-like [adj]\n",
  "PULVILLE": "(historical) perfumed powder; snuff, also PULVIL, PULVILIO, PULVILLIO [n -S]\n",
  "PULVILLED": "PULVIL, to scent with pulvil [v]\n",
  "PULVILLES": "PULVILLE, (historical) perfumed powder; snuff, also PULVIL, PULVILIO, PULVILLIO [n]\n",
  "PULVILLI": "PULVILLUS, (Latin) a little cushion or pad [n]\n",
  "PULVILLIFORM": "shaped like a cushion [adj]\n",
  "PULVILLING": "PULVIL, to scent with pulvil [v]\n",
  "PULVILLIO": "(historical) perfumed powder; snuff, also PULVIL, PULVILIO, PULVILLE [n -S]\n",
  "PULVILLIOS": "PULVILLIO, (historical) perfumed powder; snuff, also PULVIL, PULVILIO, PULVILLE [n]\n",
  "PULVILLUS": "(Latin) a little cushion or pad [n PULVILLI]\n",
  "PULVILS": "PULVIL, perfumed powder, also PULVILIO, PULVILLIO, PULVILLE [n]\n",
  "PULVINAR": "a knob on the brain by the optic nerve [n -S]\n",
  "PULVINARS": "PULVINAR, a knob on the brain by the optic nerve [n]\n",
  "PULVINATE": "cushion-like; bulging; pillowy, also PULVINATED [adj]\n",
  "PULVINATED": "cushion-like; bulging; pillowy, also PULVINATE [adj]\n",
  "PULVINI": "PULVINUS, (Latin) a swelling at the base of a stalk or leaf [n]\n",
  "PULVINULE": "the pulvinus of a leaflet [n -S]\n",
  "PULVINULES": "PULVINULE, the pulvinus of a leaflet [n]\n",
  "PULVINUS": "(Latin) a swelling at the base of a stalk or leaf [n PULVINI]\n",
  "PULWAR": "(Hindi) a light keelless boat used on the Ganges [n -S]\n",
  "PULWARS": "PULWAR, (Hindi) a light keelless boat used on the Ganges [n]\n",
  "PULY": "given to puling, whiny [adj PULIER, PULIEST]\n",
  "PUMA": "(Quechua) a large reddish-brown American cat, aka mountain lion [n -S]\n",
  "PUMAS": "PUMA, (Quechua) a large reddish-brown American cat, aka mountain lion [n]\n",
  "PUMELO": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMMELO [n -S]\n",
  "PUMELOS": "PUMELO, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMMELO [n]\n",
  "PUMICATE": "to make smooth with pumice [v PUMICATED, PUMICATING, PUMICATES]\n",
  "PUMICATED": "PUMICATE, to make smooth with pumice [v]\n",
  "PUMICATES": "PUMICATE, to make smooth with pumice [v]\n",
  "PUMICATING": "PUMICATE, to make smooth with pumice [v]\n",
  "PUMICE": "to polish with a porous volcanic rock [v PUMICED, PUMICING, PUMICES]\n",
  "PUMICED": "PUMICE, to polish with a porous volcanic rock [v]\n",
  "PUMICEOUS": "of or pertaining to pumice [adj]\n",
  "PUMICER": "one that pumices [n -S]\n",
  "PUMICERS": "PUMICER, one that pumices [n]\n",
  "PUMICES": "PUMICE, to polish with a porous volcanic rock [v]\n",
  "PUMICING": "PUMICE, to polish with a porous volcanic rock [v]\n",
  "PUMICITE": "a porous volcanic rock [n -S]\n",
  "PUMICITES": "PUMICITE, a porous volcanic rock [n]\n",
  "PUMIE": "(Spenser) a pebble, also PUMY [n -S]\n",
  "PUMIES": "PUMY, (Spenser) a pebble, also PUMIE [n]\n",
  "PUMMEL": "to strike with the fists, also POMMEL [v PUMMELLED or PUMMELED, PUMMELLING or PUMMELING, PUMMELS]\n",
  "PUMMELED": "PUMMEL, to strike with the fists, also POMMEL [v]\n",
  "PUMMELING": "PUMMEL, to strike with the fists, also POMMEL [v]\n",
  "PUMMELLED": "PUMMEL, to strike with the fists, also POMMEL [v]\n",
  "PUMMELLING": "a beating with the fists [n -S]\n",
  "PUMMELLINGS": "PUMMELLING, a beating with the fists [n]\n",
  "PUMMELO": "(Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO [n -S]\n",
  "PUMMELOS": "PUMMELO, (Dutch) the shaddock or grapefruit, also PAMPELMOOSE, PAMPELMOUSE, POMELO, POMPELMOOSE, POMPELMOUS, POMPELMOUSE, POMPELO, PUMELO [n]\n",
  "PUMMELS": "PUMMEL, to strike with the fists, also POMMEL [v]\n",
  "PUMP": "to propel liquid by a motor [v -ED, -ING, -S]\n",
  "PUMPABLE": "capable of being pumped [adj]\n",
  "PUMPED": "PUMP, to propel liquid by a motor [v]\n",
  "PUMPER": "one who pumps [n -S]\n",
  "PUMPERNICKEL": "(German) a kind of coarse dark rye bread [n -S]\n",
  "PUMPERNICKELS": "PUMPERNICKEL, (German) a kind of coarse dark rye bread [n]\n",
  "PUMPERS": "PUMPER, one who pumps [n]\n",
  "PUMPHOOD": "the head of a pump [n -S]\n",
  "PUMPHOODS": "PUMPHOOD, the head of a pump [n]\n",
  "PUMPHOUSE": "a building in which are housed pumps that supply e.g. an irrigation system [n -S]\n",
  "PUMPHOUSES": "PUMPHOUSE, a building in which are housed pumps that supply e.g. an irrigation system [n]\n",
  "PUMPING": "as in optical pumping, a laser technique [n -S]\n",
  "PUMPINGS": "PUMPING, as in optical pumping, a laser technique [n]\n",
  "PUMPION": "(obsolete) a pumpkin, also POMPION, PUNKIN [n -S]\n",
  "PUMPIONS": "PUMPION, (obsolete) a pumpkin, also POMPION, PUNKIN [n]\n",
  "PUMPJACK": "a pumping apparatus at an oil well [n -S]\n",
  "PUMPJACKS": "PUMPJACK, a pumping apparatus at an oil well [n]\n",
  "PUMPKIN": "a plant of the gourd family, or its fruit, also POMPION, PUMPION, PUNKIN [n -S]\n",
  "PUMPKING": "a person involved in a web-based project who has temporary but exclusive authority to make changes to the master source code [n -S]\n",
  "PUMPKINGS": "PUMPKING, a person involved in a web-based project who has temporary but exclusive authority to make changes to the master source code [n]\n",
  "PUMPKINS": "PUMPKIN, a plant of the gourd family, or its fruit, also POMPION, PUMPION, PUNKIN [n]\n",
  "PUMPKINSEED": "the seed of the pumpkin [n -S]\n",
  "PUMPKINSEEDS": "PUMPKINSEED, the seed of the pumpkin [n]\n",
  "PUMPLESS": "without a pump [adj]\n",
  "PUMPLIKE": "like a pump [adj]\n",
  "PUMPS": "PUMP, to propel liquid by a motor [v]\n",
  "PUMY": "(Spenser) a pebble, also PUMIE [n PUMIES]\n",
  "PUN": "to make a play on words [v PUNNED, PUNNING, PUNS]\n",
  "PUNA": "(Quechua) a high bleak plateau in the Peruvian Andes; a cold wind of the Andes that blows there [n -S]\n",
  "PUNAANI": "(slang) the female genitalia; women collectively, regarded as sexual objects, also PUNANI, PUNAANY, PUNANY [n]\n",
  "PUNAANY": "(slang) the female genitalia; women collectively, regarded as sexual objects, also PUNANI, PUNAANI, PUNANY [n]\n",
  "PUNALUA": "(Hawaiian) the marriage of brothers of one family to sisters of another [n -S]\n",
  "PUNALUAN": "pertaining to punalua, primitive group marriage of a number of brothers to a number of sisters [adj]\n",
  "PUNALUAS": "PUNALUA, (Hawaiian) the marriage of brothers of one family to sisters of another [n]\n",
  "PUNANI": "(slang) the female genitalia; women collectively, regarded as sexual objects, also PUNAANY, PUNAANI, PUNANY [n]\n",
  "PUNANY": "(slang) the female genitalia; women collectively, regarded as sexual objects, also PUNAANY, PUNAANI, PUNANI [n]\n",
  "PUNAS": "PUNA, (Quechua) a high bleak plateau in the Peruvian Andes; a cold wind of the Andes that blows there [n]\n",
  "PUNCE": "(dialect) to prod or poke [v PUNCED, PUNCING, PUNCES]\n",
  "PUNCED": "PUNCE, (dialect) to prod or poke [v]\n",
  "PUNCES": "PUNCE, (dialect) to prod or poke [v]\n",
  "PUNCH": "to perforate with a type of tool [v -ED, -ING, -ES]\n",
  "PUNCHBAG": "a punching bag, used in boxing training [n -S]\n",
  "PUNCHBAGS": "PUNCHBAG, a punching bag, used in boxing training [n]\n",
  "PUNCHBALL": "a suspended ball used for boxing practice [n -S]\n",
  "PUNCHBALLS": "PUNCHBALL, a suspended ball used for boxing practice [n]\n",
  "PUNCHBOARD": "a practice board used in the martial arts [n -S]\n",
  "PUNCHBOARDS": "PUNCHBOARD, a practice board used in the martial arts [n]\n",
  "PUNCHBOWL": "a bowl for holding punch [n -S]\n",
  "PUNCHBOWLS": "PUNCHBOWL, a bowl for holding punch [n]\n",
  "PUNCHED": "PUNCH, to perforate with a type of tool [v]\n",
  "PUNCHEON": "a cask; a liquid measure of from 70 to 120 gallons, also PANCHEON, PANCHION [n -S]\n",
  "PUNCHEONS": "PUNCHEON, a cask; a liquid measure of from 70 to 120 gallons, also PANCHEON, PANCHION [n]\n",
  "PUNCHER": "one who punches; an instrument for punching [n -S]\n",
  "PUNCHERS": "PUNCHER, one who punches; an instrument for punching [n]\n",
  "PUNCHES": "PUNCH, to perforate with a type of tool [v]\n",
  "PUNCHIER": "PUNCHY, forceful, having impact [adj]\n",
  "PUNCHIEST": "PUNCHY, forceful, having impact [adj]\n",
  "PUNCHILY": "PUNCHY, forceful, having impact [adv]\n",
  "PUNCHINELLO": "(Italian) a fat short humpbacked clown [n -S]\n",
  "PUNCHINELLOES": "PUNCHINELLO, (Italian) a fat short humpbacked clown [n]\n",
  "PUNCHINELLOS": "PUNCHINELLO, (Italian) a fat short humpbacked clown [n]\n",
  "PUNCHINESS": "the quality of being punchy [n -ES]\n",
  "PUNCHINESSES": "PUNCHINESS, the quality of being punchy [n]\n",
  "PUNCHING": "PUNCH, to perforate with a type of tool [v]\n",
  "PUNCHLESS": "without a punch [adj]\n",
  "PUNCHLINE": "the last line or conclusion of a joke, in which the point lies [n -S]\n",
  "PUNCHLINES": "PUNCHLINE, the last line or conclusion of a joke, in which the point lies [n]\n",
  "PUNCHOUT": "a fist fight [n -S]\n",
  "PUNCHOUTS": "PUNCHOUT, a fist fight [n]\n",
  "PUNCHY": "forceful, having impact [adj PUNCHIER, PUNCHIEST, PUNCHILY]\n",
  "PUNCING": "PUNCE, (dialect) to prod or poke [v]\n",
  "PUNCTA": "PUNCTUM, (Latin) a point or dot; a minute aperture [n]\n",
  "PUNCTATE": "marked with points or dots, also PUNCTATED [adj]\n",
  "PUNCTATED": "dotted, pitted, also PUNCTATE [adj]\n",
  "PUNCTATION": "dotting, pitting [n -S]\n",
  "PUNCTATIONS": "PUNCTATION, dotting, pitting [n]\n",
  "PUNCTATOR": "someone who marks something with dots, esp. applied to the Massoretes, who invented the Hebrew vowel points [n -S]\n",
  "PUNCTATORS": "PUNCTATOR, someone who marks something with dots, esp. applied to the Massoretes, who invented the Hebrew vowel points [n]\n",
  "PUNCTILIO": "(Italian) a minute detail of conduct; careful observance of forms [n -S]\n",
  "PUNCTILIOS": "PUNCTILIO, (Italian) a minute detail of conduct; careful observance of forms [n]\n",
  "PUNCTILIOUS": "extremely attentive to minute details of action or behavior [adj PUNCTILIOUSLY]\n",
  "PUNCTILIOUSLY": "PUNCTILIOUS, extremely attentive to minute details of action or behavior [adv]\n",
  "PUNCTILIOUSNESS": "PUNCTILIOUS, extremely attentive to minute details of action or behavior [n]\n",
  "PUNCTO": "(obsolete) a nice point of form or ceremony, also PUNTO [n -S]\n",
  "PUNCTOS": "PUNCTO, (obsolete) a nice point of form or ceremony, also PUNTO [n]\n",
  "PUNCTUAL": "being on time [adj PUNCTUALLY]\n",
  "PUNCTUALIST": "(obsolete) an authority on or observer of punctilios [n -S]\n",
  "PUNCTUALISTS": "PUNCTUALIST, (obsolete) an authority on or observer of punctilios [n]\n",
  "PUNCTUALITIES": "PUNCTUALITY, the state of being punctual [n]\n",
  "PUNCTUALITY": "the state of being punctual [n PUNCTUALITIES]\n",
  "PUNCTUALLY": "PUNCTUAL, being on time [adv]\n",
  "PUNCTUATE": "to mark with points; to mark a piece of writing with commas, full stops etc. [v PUNCTUATED, PUNCTUATING, PUNCTUATES]\n",
  "PUNCTUATED": "PUNCTUATE, to mark with points; to mark a piece of writing with commas, full stops etc. [v]\n",
  "PUNCTUATES": "PUNCTUATE, to mark with points; to mark a piece of writing with commas, full stops etc. [v]\n",
  "PUNCTUATING": "PUNCTUATE, to mark with points; to mark a piece of writing with commas, full stops etc. [v]\n",
  "PUNCTUATION": "the act of punctuating [n -S]\n",
  "PUNCTUATIONIST": "a believer in punctuated equilibrium [n -S]\n",
  "PUNCTUATIONISTS": "PUNCTUATIONIST, a believer in punctuated equilibrium [n]\n",
  "PUNCTUATIONS": "PUNCTUATION, the act of punctuating [n]\n",
  "PUNCTUATIVE": "relating to punctuation [adj]\n",
  "PUNCTUATOR": "one who punctuates, as in writing [n -S]\n",
  "PUNCTUATORS": "PUNCTUATOR, one who punctuates, as in writing [n]\n",
  "PUNCTULATE": "to mark with small dots [v PUNCTULATED, PUNCTULATING, PUNCTULATES]\n",
  "PUNCTULATED": "PUNCTULATE, to mark with small dots [v]\n",
  "PUNCTULATES": "PUNCTULATE, to mark with small dots [v]\n",
  "PUNCTULATING": "PUNCTULATE, to mark with small dots [v]\n",
  "PUNCTULATION": "the state of having small spots [n -S]\n",
  "PUNCTULATIONS": "PUNCTULATION, the state of having small spots [n]\n",
  "PUNCTULE": "a minute dot [n -S]\n",
  "PUNCTULES": "PUNCTULE, a minute dot [n]\n",
  "PUNCTUM": "(Latin) a point or dot; a minute aperture [n PUNCTA or PUNCTUMS]\n",
  "PUNCTUMS": "PUNCTUM, (Latin) a point or dot; a minute aperture [n]\n",
  "PUNCTURABLE": "that can be punctured [adj]\n",
  "PUNCTURATION": "being marked with punctures [n -S]\n",
  "PUNCTURATIONS": "PUNCTURATION, being marked with punctures [n]\n",
  "PUNCTURE": "to pierce with a pointed object [v PUNCTURED, PUNCTURING, PUNCTURES]\n",
  "PUNCTURED": "PUNCTURE, to pierce with a pointed object [v]\n",
  "PUNCTURER": "one who punctures [n -S]\n",
  "PUNCTURERS": "PUNCTURER, one who punctures [n]\n",
  "PUNCTURES": "PUNCTURE, to pierce with a pointed object [v]\n",
  "PUNCTURING": "PUNCTURE, to pierce with a pointed object [v]\n",
  "PUNDIGRION": "(obsolete) a play on words, a pun [n -S]\n",
  "PUNDIGRIONS": "PUNDIGRION, (obsolete) a play on words, a pun [n]\n",
  "PUNDIT": "(Sanskrit) a learned person, an expert; originally a Hindu learned in Sanskrit, also PANDIT [n -S]\n",
  "PUNDITIC": "like a pundit [adj]\n",
  "PUNDITRIES": "PUNDITRY, the learning of pundits [n]\n",
  "PUNDITRY": "the learning of pundits [n PUNDITRIES]\n",
  "PUNDITS": "PUNDIT, (Sanskrit) a learned person, an expert; originally a Hindu learned in Sanskrit, also PANDIT [n]\n",
  "PUNDONOR": "(Spanish) a point of honor [n -ES]\n",
  "PUNDONORES": "PUNDONOR, (Spanish) a point of honor [n]\n",
  "PUNG": "(Native American) a box-shaped sleigh [n -S]\n",
  "PUNGA": "(Maori) a tall tree-fern of New Zealand, with soft thick leaves, also PONGA [n -S]\n",
  "PUNGAS": "PUNGA, (Maori) a tall tree-fern of New Zealand, with soft thick leaves, also PONGA [n]\n",
  "PUNGENCE": "the state of being pungent, also PUNGENCY [n -S]\n",
  "PUNGENCES": "PUNGENCE, the state of being pungent, also PUNGENCY [n]\n",
  "PUNGENCIES": "PUNGENCY, the state of being pungent, also PUNGENCE [n]\n",
  "PUNGENCY": "the state of being pungent, also PUNGENCE [n PUNGENCIES]\n",
  "PUNGENT": "sharply affecting the organs of taste or smell [adj PUNGENTLY]\n",
  "PUNGENTLY": "PUNGENT, sharply affecting the organs of taste or smell [adv]\n",
  "PUNGLE": "(US) to contribute [v PUNGLED, PUNGLING, PUNGLES]\n",
  "PUNGLED": "PUNGLE, (US) to contribute [v]\n",
  "PUNGLES": "PUNGLE, (US) to contribute [v]\n",
  "PUNGLING": "PUNGLE, (US) to contribute [v]\n",
  "PUNGS": "PUNG, (Native American) a box-shaped sleigh [n]\n",
  "PUNICACEOUS": "relating to Punicaceae, the pomegranate family [adj]\n",
  "PUNIER": "PUNY, of inferior size, strength or significance [adj]\n",
  "PUNIEST": "PUNY, of inferior size, strength or significance [adj]\n",
  "PUNILY": "PUNY, of inferior size, strength or significance [adv]\n",
  "PUNINESS": "the state of being puny [n -ES]\n",
  "PUNINESSES": "PUNINESS, the state of being puny [n]\n",
  "PUNISH": "to impose a penalty for wrongdoing [v -ED, -ING, -ES]\n",
  "PUNISHABILITIES": "PUNISHABILITY, the state of being punishable [n]\n",
  "PUNISHABILITY": "the state of being punishable [n PUNISHABILITIES]\n",
  "PUNISHABLE": "worthy of punishment [adj]\n",
  "PUNISHED": "PUNISH, to impose a penalty for wrongdoing [v]\n",
  "PUNISHER": "one that punishes [n -S]\n",
  "PUNISHERS": "PUNISHER, one that punishes [n]\n",
  "PUNISHES": "PUNISH, to impose a penalty for wrongdoing [v]\n",
  "PUNISHING": "PUNISH, to impose a penalty for wrongdoing [v]\n",
  "PUNISHINGLY": "PUNISHING, PUNISH, to impose a penalty for wrongdoing [adv]\n",
  "PUNISHMENT": "the act of punishing [n -S]\n",
  "PUNISHMENTS": "PUNISHMENT, the act of punishing [n]\n",
  "PUNITION": "punishment [n -S]\n",
  "PUNITIONS": "PUNITION, punishment [n]\n",
  "PUNITIVE": "relating to punishment, also PUNITORY [adj PUNITIVELY]\n",
  "PUNITIVELY": "PUNITIVE, relating to punishment, also PUNITORY [adv]\n",
  "PUNITIVENESS": "the state of being punitive [n -ES]\n",
  "PUNITIVENESSES": "PUNITIVENESS, the state of being punitive [n]\n",
  "PUNITORY": "relating to punishment, also PUNITIVE [adj]\n",
  "PUNJI": "a sharpened bamboo stick [n PUNJIS] / to fortify with punji stakes [v -ED, -ING, -ES]\n",
  "PUNJIED": "PUNJI, to fortify with punji stakes [v]\n",
  "PUNJIES": "PUNJI, to fortify with punji stakes [v]\n",
  "PUNJIING": "PUNJI, to fortify with punji stakes [v]\n",
  "PUNJIS": "PUNJI, a sharpened bamboo stick [n]\n",
  "PUNK": "of inferior quality [adj PUNKER, PUNKEST] / dry, decayed wood used as tinder [n -S]\n",
  "PUNKA": "(Hindi) a large palm-leaf fan suspended from the ceiling used esp in India, also PUNKAH [n -S]\n",
  "PUNKAH": "(Hindi) a large palm-leaf fan suspended from the ceiling used esp in India, also PUNKA [n -S]\n",
  "PUNKAHS": "PUNKAH, (Hindi) a large palm-leaf fan suspended from the ceiling used esp in India, also PUNKA [n]\n",
  "PUNKAS": "PUNKA, (Hindi) a large palm-leaf fan suspended from the ceiling used esp in India, also PUNKAH [n]\n",
  "PUNKER": "a punk rock musician [n -S]\n",
  "PUNKERS": "PUNKER, a punk rock musician [n]\n",
  "PUNKEST": "PUNK, of inferior quality [adj]\n",
  "PUNKETTE": "a female follower of punk music [n -S]\n",
  "PUNKETTES": "PUNKETTE, a female follower of punk music [n]\n",
  "PUNKEY": "a biting gnat, also PUNKIE [n -S]\n",
  "PUNKEYS": "PUNKEY, a biting gnat, also PUNKIE [n]\n",
  "PUNKIE": "a biting gnat, also PUNKEY [n -S]\n",
  "PUNKIER": "PUNKY, like a punk [adj]\n",
  "PUNKIES": "PUNKIE, a biting gnat, also PUNKEY [n]\n",
  "PUNKIEST": "PUNKY, like a punk [adj]\n",
  "PUNKIN": "a pumpkin, also POMPION, PUMPION [n -S]\n",
  "PUNKINESS": "being a punk [n -ES]\n",
  "PUNKINESSES": "PUNKINESS, being a punk [n]\n",
  "PUNKINS": "PUNKIN, a pumpkin, also POMPION, PUMPION [n]\n",
  "PUNKISH": "pertaining to a style inspired by punk rock [adj]\n",
  "PUNKS": "PUNK, dry, decayed wood used as tinder [n]\n",
  "PUNKY": "like a punk [adj PUNKIER, PUNKIEST]\n",
  "PUNNED": "PUN, to make a play on words [v]\n",
  "PUNNER": "one who makes puns, also PUNSTER [n -S]\n",
  "PUNNERS": "PUNNER, one who makes puns, also PUNSTER [n]\n",
  "PUNNET": "a small shallow fruit basket [n -S]\n",
  "PUNNETS": "PUNNET, a small shallow fruit basket [n]\n",
  "PUNNIER": "PUNNY, involving a pun [adj]\n",
  "PUNNIEST": "PUNNY, involving a pun [adj]\n",
  "PUNNING": "playing on words [adj PUNNINGLY] / the act of punning [n -S]\n",
  "PUNNINGLY": "PUNNING, playing on words [adv]\n",
  "PUNNINGS": "PUNNING, the act of punning [n]\n",
  "PUNNY": "involving a pun [adj PUNNIER, PUNNIEST]\n",
  "PUNS": "PUN, to make a play on words [v]\n",
  "PUNSTER": "one who makes puns, also PUNNER [n -S]\n",
  "PUNSTERS": "PUNSTER, one who makes puns, also PUNNER [n]\n",
  "PUNT": "to propel through water with a pole [v -ED, -ING, -S]\n",
  "PUNTED": "PUNT, to propel through water with a pole [v]\n",
  "PUNTEE": "an iron supporting rod used in glassmaking, also PUNTY, PONTIE, PONTIL, PONTILE, PONTY [n -S]\n",
  "PUNTEES": "PUNTEE, an iron supporting rod used in glassmaking, also PUNTY, PONTIE, PONTIL, PONTILE, PONTY [n]\n",
  "PUNTER": "one that punts [n -S]\n",
  "PUNTERS": "PUNTER, one that punts [n]\n",
  "PUNTIES": "PUNTY, an iron supporting rod used in glassmaking, also PONTIE, PONTIL, PONTILE, PONTY, PUNTEE [n]\n",
  "PUNTING": "PUNT, to propel through water with a pole [v]\n",
  "PUNTO": "(Italian) a hit or thrust in fencing [n -S]\n",
  "PUNTOS": "PUNTO, (Italian) a hit or thrust in fencing [n]\n",
  "PUNTS": "PUNT, to propel through water with a pole [v]\n",
  "PUNTSMAN": "someone who uses a punt [n PUNTSMEN]\n",
  "PUNTSMEN": "PUNTSMAN, someone who uses a punt [n]\n",
  "PUNTY": "an iron supporting rod used in glassmaking, also PONTIE, PONTIL, PONTILE, PONTY, PUNTEE [n PUNTIES]\n",
  "PUNY": "of inferior size, strength or significance [adj PUNIER, PUNIEST, PUNILY]\n",
  "PUP": "to give birth to puppies [v PUPPED, PUPPING, PUPS]\n",
  "PUPA": "(Latin) an insect in the stage between larva and imago [n PUPAS or PUPAE]\n",
  "PUPAE": "PUPA, (Latin) an insect in the stage between larva and imago [n]\n",
  "PUPAL": "pertaining to a pupa [adj]\n",
  "PUPARIA": "PUPARIUM, (Latin) a pupal shell [n]\n",
  "PUPARIAL": "relating to a puparium, the last larval skin of the pupa [adj]\n",
  "PUPARIUM": "(Latin) a pupal shell [n PUPARIA]\n",
  "PUPAS": "PUPA, (Latin) an insect in the stage between larva and imago [n]\n",
  "PUPATE": "to pass through the pupal stage [v PUPATED, PUPATING, PUPATES]\n",
  "PUPATED": "PUPATE, to pass through the pupal stage [v]\n",
  "PUPATES": "PUPATE, to pass through the pupal stage [v]\n",
  "PUPATING": "PUPATE, to pass through the pupal stage [v]\n",
  "PUPATION": "the act of becoming a pupa [n -S]\n",
  "PUPATIONS": "PUPATION, the act of becoming a pupa [n]\n",
  "PUPFISH": "a small, freshwater fish, native to the warmer waters of the western US [n -ES]\n",
  "PUPFISHES": "PUPFISH, a small, freshwater fish, native to the warmer waters of the western US [n]\n",
  "PUPIGEROUS": "bearing a puparium [adj]\n",
  "PUPIL": "a student under the close supervision of a teacher [n -S]\n",
  "PUPILABILITIES": "PUPILABILITY, an intentionally unintelligible word in Sterne's Tristram Shandy [n]\n",
  "PUPILABILITY": "an intentionally unintelligible word in Sterne's Tristram Shandy [n PUPILABILITIES]\n",
  "PUPILAGE": "the state of being a pupil [n -S]\n",
  "PUPILAGES": "PUPILAGE, the state of being a pupil [n]\n",
  "PUPILAR": "relating to a pupil or ward, also PUPILARY, PUPILLAR, PUPILLARY [adj]\n",
  "PUPILARITIES": "PUPILARITY, the state of being a pupil or legal ward, also PUPILLARITY [n]\n",
  "PUPILARITY": "the state of being a pupil or legal ward, also PUPILLARITY [n PUPILARITIES]\n",
  "PUPILARY": "relating to a pupil or ward, also PUPILAR, PUPILLAR, PUPILLARY [adj]\n",
  "PUPILLAGE": "the state of being a pupil or under age, also PUPILAGE [n -S]\n",
  "PUPILLAGES": "PUPILLAGE, the state of being a pupil or under age, also PUPILAGE [n]\n",
  "PUPILLAR": "relating to a pupil or ward, also PUPILAR, PUPILARY, PUPILLARY [adj]\n",
  "PUPILLARITIES": "PUPILLARITY, the state of being a pupil or legal ward, also PUPILARITY [n]\n",
  "PUPILLARITY": "the state of being a pupil or legal ward, also PUPILARITY [n PUPILLARITIES]\n",
  "PUPILLARY": "relating to a pupil or ward, also PUPILAR, PUPILARY, PUPILLAR [adj]\n",
  "PUPILLATE": "to cry in the manner of a peacock [v PUPILLATED, PUPILLATING, PUPILLATES]\n",
  "PUPILLATED": "PUPILLATE, to cry in the manner of a peacock [v]\n",
  "PUPILLATES": "PUPILLATE, to cry in the manner of a peacock [v]\n",
  "PUPILLATING": "PUPILLATE, to cry in the manner of a peacock [v]\n",
  "PUPILS": "PUPIL, a student under the close supervision of a teacher [n]\n",
  "PUPILSHIP": "the state of being a pupil [n -S]\n",
  "PUPILSHIPS": "PUPILSHIP, the state of being a pupil [n]\n",
  "PUPIPAROUS": "bearing, or containing, a pupa [adj]\n",
  "PUPPED": "PUP, to give birth to puppies [v]\n",
  "PUPPET": "a doll manipulated by the hand or strings [n -S]\n",
  "PUPPETEER": "one who operates a puppet [n -S] / to operate a puppet [v -ED, -ING, -S]\n",
  "PUPPETEERED": "PUPPETEER, to operate a puppet [v]\n",
  "PUPPETEERING": "PUPPETEER, to operate a puppet [v]\n",
  "PUPPETEERS": "PUPPETEER, one who operates a puppet [n]\n",
  "PUPPETLIKE": "like a puppet [adj]\n",
  "PUPPETRIES": "PUPPETRY, the art of making or manipulating puppets [n]\n",
  "PUPPETRY": "the art of making or manipulating puppets [n PUPPETRIES]\n",
  "PUPPETS": "PUPPET, a doll manipulated by the hand or strings [n]\n",
  "PUPPIED": "PUPPY, to give birth to a pup [v]\n",
  "PUPPIES": "PUPPY, to give birth to a pup [v]\n",
  "PUPPING": "PUP, to give birth to puppies [v]\n",
  "PUPPODUM": "(Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM [n -S]\n",
  "PUPPODUMS": "PUPPODUM, (Tamil) a thin circle of dough fried in oil until crisp, also PAPADAM, PAPADOM, PAPADUM, PAPPADAM, PAPPADOM, PAPPADUM, POPADUM, POPPADOM, POPPADUM [n]\n",
  "PUPPY": "to give birth to a pup [v PUPPIED, PUPPYING, PUPPIES]\n",
  "PUPPYDOM": "the world of puppies [n -S]\n",
  "PUPPYDOMS": "PUPPYDOM, the world of puppies [n]\n",
  "PUPPYHOOD": "the time or state of being a puppy [n -S]\n",
  "PUPPYHOODS": "PUPPYHOOD, the time or state of being a puppy [n]\n",
  "PUPPYING": "PUPPY, to give birth to a pup [v]\n",
  "PUPPYISH": "pertaining to a puppy [adj]\n",
  "PUPPYISM": "conceit in men [n -S]\n",
  "PUPPYISMS": "PUPPYISM, conceit in men [n]\n",
  "PUPPYLIKE": "like a puppy [adj]\n",
  "PUPS": "PUP, to give birth to puppies [v]\n",
  "PUPU": "(Hawaiian) a dish of Asian foods served as an appetize [n -S]\n",
  "PUPUNHA": "(Portuguese) the peach-palm [n -S]\n",
  "PUPUNHAS": "PUPUNHA, (Portuguese) the peach-palm [n]\n",
  "PUPUS": "PUPU, (Hawaiian) a dish of Asian foods served as an appetize [n]\n",
  "PUR": "to utter a low, vibrant sound, also PURR [v PURRED, PURRING, PURS]\n",
  "PURANA": "(Sanskrit) any one of a class of sacred books of Hindu mythology, cosmology, etc. written in Sanskrit [n -S]\n",
  "PURANAS": "PURANA, (Sanskrit) any one of a class of sacred books of Hindu mythology, cosmology, etc. written in Sanskrit [n]\n",
  "PURANIC": "(Sanskrit) pertaining to the Puranas, the Hindu sacred books [adj]\n",
  "PURBLIND": "partially blind [adj PURBLINDLY]\n",
  "PURBLINDLY": "PURBLIND, partially blind [adv]\n",
  "PURBLINDNESS": "the state of being purblind [n -ES]\n",
  "PURBLINDNESSES": "PURBLINDNESS, the state of being purblind [n]\n",
  "PURCHASABILITY": "the quality of being purchasable [n]\n",
  "PURCHASABLE": "that can be purchased [adj]\n",
  "PURCHASE": "to buy [v PURCHASED, PURCHASING, PURCHASES]\n",
  "PURCHASED": "PURCHASE, to buy [v]\n",
  "PURCHASER": "one who purchases [n -S]\n",
  "PURCHASERS": "PURCHASER, one who purchases [n]\n",
  "PURCHASES": "PURCHASE, to buy [v]\n",
  "PURCHASING": "the act of buying [n -S]\n",
  "PURCHASINGS": "PURCHASING, the act of buying [n]\n",
  "PURDA": "(Urdu) seclusion of women from public observation among Muslims and some Hindus, also PARDAH, PURDAH [n -S]\n",
  "PURDAH": "(Urdu) seclusion of women from public observation among Muslims and some Hindus, also PARDAH, PURDA [n -S]\n",
  "PURDAHED": "of a woman, secluded, in purdah [adj]\n",
  "PURDAHS": "PURDAH, (Urdu) seclusion of women from public observation among Muslims and some Hindus, also PARDAH, PURDA [n]\n",
  "PURDAS": "PURDA, (Urdu) seclusion of women from public observation among Muslims and some Hindus, also PARDAH, PURDAH [n]\n",
  "PURDONIUM": "a kind of coal-scuttle introduced by a Mr Purdon [n -S]\n",
  "PURDONIUMS": "PURDONIUM, a kind of coal-scuttle introduced by a Mr Purdon [n]\n",
  "PURE": "free from stain [adj PURER, PUREST, PURELY] / to cleanse or refine; to treat with pure (dog faeces) [v PURED, PURING, PURES]\n",
  "PUREBLOOD": "a horse etc. of unmixed race [n -S]\n",
  "PUREBLOODS": "PUREBLOOD, a horse etc. of unmixed race [n]\n",
  "PUREBRED": "an animal of unmixed stock [n -S]\n",
  "PUREBREDS": "PUREBRED, an animal of unmixed stock [n]\n",
  "PURED": "PUR, to utter a low, vibrant sound, also PURR [v]\n",
  "PUREE": "to reduce to a thick pulp by cooking and sieving [v PUREED, PUREEING, PUREES]\n",
  "PUREED": "PUREE, to reduce to a thick pulp by cooking and sieving [v]\n",
  "PUREEING": "PUREE, to reduce to a thick pulp by cooking and sieving [v]\n",
  "PUREES": "PUREE, to reduce to a thick pulp by cooking and sieving [v]\n",
  "PURELY": "PURE, free from stain [adv]\n",
  "PURENESS": "the quality of being pure [n -ES]\n",
  "PURENESSES": "PURENESS, the quality of being pure [n]\n",
  "PURER": "PURE, free from stain [adj]\n",
  "PURES": "PURE, to cleanse or refine; to treat with pure (dog faeces) [v]\n",
  "PUREST": "PURE, free from stain [adj]\n",
  "PURFLE": "to decorate the border of [v PURFLED, PURFLING, PURFLES]\n",
  "PURFLED": "PURFLE, to decorate the border of [v]\n",
  "PURFLER": "something or someone that purfles [n -S]\n",
  "PURFLERS": "PURFLER, something or someone that purfles [n]\n",
  "PURFLES": "PURFLE, to decorate the border of [v]\n",
  "PURFLING": "ornamentation on the edges of a violin [n -S]\n",
  "PURFLINGS": "PURFLING, ornamentation on the edges of a violin [n]\n",
  "PURFLY": "short of breath [adj]\n",
  "PURGATION": "the act of purging [n -S]\n",
  "PURGATIONS": "PURGATION, the act of purging [n]\n",
  "PURGATIVE": "serving to purge [adj PURGATIVELY] / a medicine that empties the intestines [n -S]\n",
  "PURGATIVELY": "PURGATIVE, serving to purge [adv]\n",
  "PURGATIVES": "PURGATIVE, a medicine that empties the intestines [n]\n",
  "PURGATORIAL": "relating to purgatory, also PURGATORIAN [adj PURGATORIALLY]\n",
  "PURGATORIALLY": "PURGATORIAL, relating to purgatory, also PURGATORIAN [adv]\n",
  "PURGATORIAN": "a person who believes in Purgatory [n -S]\n",
  "PURGATORIANS": "PURGATORIAN, a person who believes in Purgatory [n]\n",
  "PURGATORIES": "PURGATORY, a place or state in which souls are after death purified from venial sins [n]\n",
  "PURGATORY": "a place or state in which souls are after death purified from venial sins [n PURGATORIES]\n",
  "PURGE": "to purify [v PURGED, PURGING, PURGES]\n",
  "PURGEABLE": "that can be purged [adj]\n",
  "PURGED": "PURGE, to purify [v]\n",
  "PURGER": "one who purges [n -S]\n",
  "PURGERS": "PURGER, one who purges [n]\n",
  "PURGES": "PURGE, to purify [v]\n",
  "PURGING": "the act of purifying [n -S]\n",
  "PURGINGS": "PURGING, the act of purifying [n]\n",
  "PURI": "(Hindi) in India, a small cake of unleavened bread fried in vegetable oil, also POORI [n -S]\n",
  "PURIFICATION": "the act or an instance of purifying or of being purified [n -S]\n",
  "PURIFICATIONS": "PURIFICATION, the act or an instance of purifying or of being purified [n]\n",
  "PURIFICATIVE": "serving to purify, also PURIFICATORY [adj]\n",
  "PURIFICATOR": "a cloth used to wipe the Eucharist chalice [n -S]\n",
  "PURIFICATORS": "PURIFICATOR, a cloth used to wipe the Eucharist chalice [n]\n",
  "PURIFICATORY": "serving to purify, also PURIFICATIVE [adj]\n",
  "PURIFIED": "PURIFY, to cleanse from impurities [v]\n",
  "PURIFIER": "one that purifies [n -S]\n",
  "PURIFIERS": "PURIFIER, one that purifies [n]\n",
  "PURIFIES": "PURIFY, to cleanse from impurities [v]\n",
  "PURIFY": "to cleanse from impurities [v PURIFIED, PURIFYING, PURIFIES]\n",
  "PURIFYING": "PURIFY, to cleanse from impurities [v]\n",
  "PURIN": "a white crystalline substance which with oxygen forms uric acid, also PURINE [n -S]\n",
  "PURINE": "a white crystalline substance which with oxygen forms uric acid, also PURIN [n -S]\n",
  "PURINES": "PURINE, a white crystalline substance which with oxygen forms uric acid, also PURIN [n]\n",
  "PURING": "PURE, to cleanse or refine; to treat with pure (dog faeces) [v]\n",
  "PURINS": "PURIN, a white crystalline substance which with oxygen forms uric acid, also PURINE [n]\n",
  "PURIRI": "(Maori) a timber tree of New Zealand, with red berries and glossy green leaves [n -S]\n",
  "PURIRIS": "PURIRI, (Maori) a timber tree of New Zealand, with red berries and glossy green leaves [n]\n",
  "PURIS": "PURI, (Hindi) in India, a small cake of unleavened bread fried in vegetable oil, also POORI [n]\n",
  "PURISM": "strict adherence to traditional correctness [n -S]\n",
  "PURISMS": "PURISM, strict adherence to traditional correctness [n]\n",
  "PURIST": "one who practises purism [n -S]\n",
  "PURISTIC": "of or pertaining to purists or purism, also PURISTICAL [adj PURISTICALLY]\n",
  "PURISTICAL": "of or pertaining to purists or purism, also PURISTIC [adj PURISTICALLY]\n",
  "PURISTICALLY": "PURISTICAL, of or pertaining to purists or purism, also PURISTIC [adv]\n",
  "PURISTS": "PURIST, one who practises purism [n]\n",
  "PURITAN": "a person who is strictly moral in conduct [n -S]\n",
  "PURITANIC": "of or like a puritan, also PURITANICAL [adj PURITANICALLY]\n",
  "PURITANICAL": "of or like a puritan, also PURITANIC [adj PURITANICALLY]\n",
  "PURITANICALLY": "PURITANICAL, of or like a puritan, also PURITANIC [adv]\n",
  "PURITANICALNESS": "PURITANICAL, of or like a puritan, also PURITANIC [n]\n",
  "PURITANISE": "to make a Puritan of, also PURITANIZE [v PURITANISED, PURITANISING, PURITANISES]\n",
  "PURITANISED": "PURITANISE, to make a Puritan of, also PURITANIZE [v]\n",
  "PURITANISES": "PURITANISE, to make a Puritan of, also PURITANIZE [v]\n",
  "PURITANISING": "PURITANISE, to make a Puritan of, also PURITANIZE [v]\n",
  "PURITANISM": "the beliefs and practices characteristic of the Puritans [n -S]\n",
  "PURITANISMS": "PURITANISM, the beliefs and practices characteristic of the Puritans [n]\n",
  "PURITANIZE": "to make a Puritan of, also PURITANISE [v PURITANIZED, PURITANIZING, PURITANIZES]\n",
  "PURITANIZED": "PURITANIZE, to make a Puritan of, also PURITANISE [v]\n",
  "PURITANIZES": "PURITANIZE, to make a Puritan of, also PURITANISE [v]\n",
  "PURITANIZING": "PURITANIZE, to make a Puritan of, also PURITANISE [v]\n",
  "PURITANS": "PURITAN, a person who is strictly moral in conduct [n]\n",
  "PURITIES": "PURITY, the quality of being pure [n]\n",
  "PURITY": "the quality of being pure [n PURITIES]\n",
  "PURL": "to knit with a type of stitch [v -ED, -ING, -S]\n",
  "PURLED": "PURL, to knit with a type of stitch [v]\n",
  "PURLER": "a heavy fall [n -S]\n",
  "PURLERS": "PURLER, a heavy fall [n]\n",
  "PURLICUE": "to summarise in conclusion, also PIRLICUE [v PURLICUED, PURLICUING, PURLICUES]\n",
  "PURLICUED": "PURLICUE, to summarise in conclusion, also PIRLICUE [v]\n",
  "PURLICUES": "PURLICUE, to summarise in conclusion, also PIRLICUE [v]\n",
  "PURLICUING": "PURLICUE, to summarise in conclusion, also PIRLICUE [v]\n",
  "PURLIEU": "(French) a neighbourhood; a suburb [n PURLIEUS or PURLIEUX]\n",
  "PURLIEUS": "PURLIEU, (French) a neighbourhood; a suburb [n]\n",
  "PURLIEUX": "PURLIEU, (French) a neighbourhood; a suburb [n]\n",
  "PURLIN": "a horizontal supporting timber, also PURLINE [n -S]\n",
  "PURLINE": "a horizontal supporting timber, also PURLIN [n -S]\n",
  "PURLINES": "PURLINE, a horizontal supporting timber, also PURLIN [n]\n",
  "PURLING": "the swirling of a stream [n -S]\n",
  "PURLINGS": "PURLING, the swirling of a stream [n]\n",
  "PURLINS": "PURLIN, a horizontal supporting timber, also PURLINE [n]\n",
  "PURLOIN": "to steal; to filch [v -ED, -ING, -S]\n",
  "PURLOINED": "PURLOIN, to steal; to filch [v]\n",
  "PURLOINER": "one who purloins [n -S]\n",
  "PURLOINERS": "PURLOINER, one who purloins [n]\n",
  "PURLOINING": "PURLOIN, to steal; to filch [v]\n",
  "PURLOINS": "PURLOIN, to steal; to filch [v]\n",
  "PURLS": "PURL, to knit with a type of stitch [v]\n",
  "PUROMYCIN": "a type of antibiotic [n -S]\n",
  "PUROMYCINS": "PUROMYCIN, a type of antibiotic [n]\n",
  "PURPIE": "(Scots) purslane, or perhaps brooklime, also PURPY [n -S]\n",
  "PURPIES": "PURPY, (Scots) purslane, or perhaps brooklime, also PURPIE [n]\n",
  "PURPLE": "of a colour which is a mixture between blue and red [adj PURPLER, PURPLEST] / to make the colour purple [v PURPLED, PURPLING, PURPLES]\n",
  "PURPLED": "PURPLE, to make the colour purple [v]\n",
  "PURPLEHEART": "a kind of wood, purple-coloured [n -S]\n",
  "PURPLEHEARTS": "PURPLEHEART, a kind of wood, purple-coloured [n]\n",
  "PURPLENESS": "the state of being purple [n -ES]\n",
  "PURPLENESSES": "PURPLENESS, the state of being purple [n]\n",
  "PURPLER": "PURPLE, of a colour which is a mixture between blue and red [adj]\n",
  "PURPLES": "PURPLE, to make the colour purple [v]\n",
  "PURPLEST": "PURPLE, of a colour which is a mixture between blue and red [adj]\n",
  "PURPLIER": "PURPLY, purplish [adj]\n",
  "PURPLIEST": "PURPLY, purplish [adj]\n",
  "PURPLING": "PURPLE, to make the colour purple [v]\n",
  "PURPLISH": "somewhat purple [adj]\n",
  "PURPLY": "purplish [adj PURPLIER, PURPLIEST]\n",
  "PURPORT": "to profess or proclaim [v -ED, -ING, -S]\n",
  "PURPORTED": "PURPORT, to profess or proclaim [v]\n",
  "PURPORTEDLY": "PURPORTED, PURPORT, to profess or proclaim [adv]\n",
  "PURPORTING": "PURPORT, to profess or proclaim [v]\n",
  "PURPORTLESS": "without purport [adj]\n",
  "PURPORTS": "PURPORT, to profess or proclaim [v]\n",
  "PURPOSE": "to intend to accomplish [v PURPOSED, PURPOSING, PURPOSES]\n",
  "PURPOSED": "PURPOSE, to intend to accomplish [v]\n",
  "PURPOSEFUL": "showing purpose [adj PURPOSEFULLY]\n",
  "PURPOSEFULLY": "PURPOSEFUL, showing purpose [adv]\n",
  "PURPOSEFULNESS": "PURPOSEFUL, showing purpose [n]\n",
  "PURPOSELESS": "having no purpose [adj PURPOSELESSLY]\n",
  "PURPOSELESSLY": "PURPOSELESS, having no purpose [adv]\n",
  "PURPOSELESSNESS": "PURPOSELESS, having no purpose [n]\n",
  "PURPOSELY": "deliberately [adv]\n",
  "PURPOSES": "PURPOSE, to intend to accomplish [v]\n",
  "PURPOSING": "PURPOSE, to intend to accomplish [v]\n",
  "PURPOSIVE": "directed towards an end [adj PURPOSIVELY]\n",
  "PURPOSIVELY": "PURPOSIVE, directed towards an end [adv]\n",
  "PURPOSIVENESS": "PURPOSIVE, directed towards an end [n]\n",
  "PURPOSIVENESSES": "PURPOSIVENESS, PURPOSIVE, directed towards an end [n]\n",
  "PURPRESTURE": "encroachment on public property [n -S]\n",
  "PURPRESTURES": "PURPRESTURE, encroachment on public property [n]\n",
  "PURPURA": "(Latin) a disease characterised by purple spots on the skin [n -S]\n",
  "PURPURAS": "PURPURA, (Latin) a disease characterised by purple spots on the skin [n]\n",
  "PURPURE": "the heraldic colour purple [n -S]\n",
  "PURPUREAL": "purple, also PURPLE, PURPURE [adj]\n",
  "PURPURES": "PURPURE, the heraldic colour purple [n]\n",
  "PURPURIC": "of or pertaining to purpura, a skin disease [adj]\n",
  "PURPURIN": "a reddish dye [n -S]\n",
  "PURPURINS": "PURPURIN, a reddish dye [n]\n",
  "PURPY": "(Scots) purslane, or perhaps brooklime, also PURPIE [n PURPIES]\n",
  "PURR": "to utter a low, vibrant sound, also PUR [v -ED, -ING, -S]\n",
  "PURRED": "PURR, to utter a low, vibrant sound, also PUR [v]\n",
  "PURRING": "making a sound like a cat [adj PURRINGLY] / the act of purring [n -S]\n",
  "PURRINGLY": "PURRING, making a sound like a cat [adv]\n",
  "PURRINGS": "PURRING, the act of purring [n]\n",
  "PURRS": "PURR, to utter a low, vibrant sound, also PUR [v]\n",
  "PURS": "PUR, to utter a low, vibrant sound, also PURR [v]\n",
  "PURSE": "to pucker, esp. the lips [v PURSED, PURSING, PURSES]\n",
  "PURSED": "PURSE, to pucker, esp. the lips [v]\n",
  "PURSEFUL": "enough to fill a purse [n -S]\n",
  "PURSEFULS": "PURSEFUL, enough to fill a purse [n]\n",
  "PURSELIKE": "like a purse [adj]\n",
  "PURSER": "an officer in charge of a ship's accounts [n -S]\n",
  "PURSERS": "PURSER, an officer in charge of a ship's accounts [n]\n",
  "PURSERSHIP": "the office of purser [n -S]\n",
  "PURSERSHIPS": "PURSERSHIP, the office of purser [n]\n",
  "PURSES": "PURSE, to pucker, esp. the lips [v]\n",
  "PURSEW": "(Spenser) to pursue, also PERSUE, POURSEW, POURSUE [v -ED, -ING, -S]\n",
  "PURSEWED": "PURSEW, (Spenser) to pursue, also PERSUE, POURSEW, POURSUE [v]\n",
  "PURSEWING": "PURSEW, (Spenser) to pursue, also PERSUE, POURSEW, POURSUE [v]\n",
  "PURSEWS": "PURSEW, (Spenser) to pursue, also PERSUE, POURSEW, POURSUE [v]\n",
  "PURSIER": "PURSY, short of breath [adj]\n",
  "PURSIEST": "PURSY, short of breath [adj]\n",
  "PURSILY": "PURSY, short of breath [adv]\n",
  "PURSINESS": "the state of being pursy [n -ES]\n",
  "PURSINESSES": "PURSINESS, the state of being pursy [n]\n",
  "PURSING": "PURSE, to pucker, esp. the lips [v]\n",
  "PURSLAIN": "a pot herb and salad herb, also PERSELINE, PURSLANE [n -S]\n",
  "PURSLAINS": "PURSLAIN, a pot herb and salad herb, also PERSELINE, PURSLANE [n]\n",
  "PURSLANE": "a pot herb and salad herb, also PERSELINE, PURSLAIN [n -S]\n",
  "PURSLANES": "PURSLANE, a pot herb and salad herb, also PERSELINE, PURSLAIN [n]\n",
  "PURSUABLE": "capable of being pursued [adj]\n",
  "PURSUAL": "the act of pursuit [n -S]\n",
  "PURSUALS": "PURSUAL, the act of pursuit [n]\n",
  "PURSUANCE": "the act of pursuing or prosecuting [n -S]\n",
  "PURSUANCES": "PURSUANCE, the act of pursuing or prosecuting [n]\n",
  "PURSUANT": "acting in consequence or in prosecution (of anything) [adj]\n",
  "PURSUANTLY": "PURSUANT, acting in consequence or in prosecution (of anything) [adv]\n",
  "PURSUE": "to follow, in order to overtake or capture, also PERSUE, POURSEW, POURSUE, PURSEW [v PURSUED, PURSUING, PURSUES]\n",
  "PURSUED": "PURSUE, to follow, in order to overtake or capture, also PERSUE, POURSEW, POURSUE, PURSEW [v]\n",
  "PURSUER": "one that pursues [n -S]\n",
  "PURSUERS": "PURSUER, one that pursues [n]\n",
  "PURSUES": "PURSUE, to follow, in order to overtake or capture, also PERSUE, POURSEW, POURSUE, PURSEW [v]\n",
  "PURSUING": "following [adj PURSUINGLY] / the act of pursuing [n -S]\n",
  "PURSUINGLY": "PURSUING, following [adv]\n",
  "PURSUINGS": "PURSUING, the act of pursuing [n]\n",
  "PURSUIT": "the act of pursuing, also POURSUIT [n -S]\n",
  "PURSUITS": "PURSUIT, the act of pursuing, also POURSUIT [n]\n",
  "PURSUIVANT": "an officer ranking below a herald [n -S]\n",
  "PURSUIVANTS": "PURSUIVANT, an officer ranking below a herald [n]\n",
  "PURSY": "short of breath [adj PURSIER, PURSIEST, PURSILY]\n",
  "PURTENANCE": "(obsolete) something which pertains or belongs; the guts, esp. of an animal [n -S]\n",
  "PURTENANCES": "PURTENANCE, (obsolete) something which pertains or belongs; the guts, esp. of an animal [n]\n",
  "PURTIER": "PURTY, (US dialect) pretty [adj]\n",
  "PURTIEST": "PURTY, (US dialect) pretty [adj]\n",
  "PURTRAID": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "PURTRAYD": "POURTRAY, (Spenser) to portray, also PORTRAY [v]\n",
  "PURTY": "(US dialect) pretty [adj PURTIER, PURTIEST]\n",
  "PURULENCE": "the state of being purulent, also PURULENCY [n -S]\n",
  "PURULENCES": "PURULENCE, the state of being purulent, also PURULENCY [n]\n",
  "PURULENCIES": "PURULENCY, the state of being purulent, also PURULENCE [n]\n",
  "PURULENCY": "the state of being purulent, also PURULENCE [n PURULENCIES]\n",
  "PURULENT": "secreting pus [adj PURULENTLY]\n",
  "PURULENTLY": "PURULENT, secreting pus [adv]\n",
  "PURVEY": "to supply [v -ED, -ING, -S]\n",
  "PURVEYANCE": "the act of purveying [n -S]\n",
  "PURVEYANCES": "PURVEYANCE, the act of purveying [n]\n",
  "PURVEYED": "PURVEY, to supply [v]\n",
  "PURVEYING": "PURVEY, to supply [v]\n",
  "PURVEYOR": "one that purveys, supplies provisions [n -S]\n",
  "PURVEYORS": "PURVEYOR, one that purveys, supplies provisions [n]\n",
  "PURVEYS": "PURVEY, to supply [v]\n",
  "PURVIEW": "a field of activity or view [n -S]\n",
  "PURVIEWS": "PURVIEW, a field of activity or view [n]\n",
  "PUS": "a viscous fluid formed in infected tissue [n -ES]\n",
  "PUSCHKINIA": "(Russian) a genus of spring-flowering bulbous plants native to western Asia [n -S]\n",
  "PUSCHKINIAS": "PUSCHKINIA, (Russian) a genus of spring-flowering bulbous plants native to western Asia [n]\n",
  "PUSES": "PUS, a viscous fluid formed in infected tissue [n]\n",
  "PUSH": "to thrust or press against [v -ED, -ING, -ES]\n",
  "PUSHBACK": "a negative or unfavourable response [n -S]\n",
  "PUSHBACKS": "PUSHBACK, a negative or unfavourable response [n]\n",
  "PUSHBALL": "a game in which an enormous ball is pushed [n -S]\n",
  "PUSHBALLS": "PUSHBALL, a game in which an enormous ball is pushed [n]\n",
  "PUSHBIKE": "a bicycle driven by pedals [n -S]\n",
  "PUSHBIKES": "PUSHBIKE, a bicycle driven by pedals [n]\n",
  "PUSHCART": "a light cart pushed by hand [n -S]\n",
  "PUSHCARTS": "PUSHCART, a light cart pushed by hand [n]\n",
  "PUSHCHAIR": "a chair on wheels for transporting a small child [n -S]\n",
  "PUSHCHAIRS": "PUSHCHAIR, a chair on wheels for transporting a small child [n]\n",
  "PUSHDOWN": "a store of computer data [n -S]\n",
  "PUSHDOWNS": "PUSHDOWN, a store of computer data [n]\n",
  "PUSHED": "PUSH, to thrust or press against [v]\n",
  "PUSHER": "one that pushes [n -S]\n",
  "PUSHERS": "PUSHER, one that pushes [n]\n",
  "PUSHES": "PUSH, to thrust or press against [v]\n",
  "PUSHFUL": "energetically or aggressively enterprising [adj PUSHFULLY]\n",
  "PUSHFULLY": "PUSHFUL, energetically or aggressively enterprising [adv]\n",
  "PUSHFULNESS": "the state of being pushful [n -ES]\n",
  "PUSHFULNESSES": "PUSHFULNESS, the state of being pushful [n]\n",
  "PUSHIER": "PUSHY, offensively aggressive [adj]\n",
  "PUSHIEST": "PUSHY, offensively aggressive [adj]\n",
  "PUSHILY": "PUSHY, offensively aggressive [adv]\n",
  "PUSHINESS": "the state of being pushy [n -ES]\n",
  "PUSHINESSES": "PUSHINESS, the state of being pushy [n]\n",
  "PUSHING": "PUSH, to thrust or press against [v]\n",
  "PUSHINGLY": "PUSHING, PUSH, to thrust or press against [adv]\n",
  "PUSHINGNESS": "the state of being pushing [n -ES]\n",
  "PUSHINGNESSES": "PUSHINGNESS, the state of being pushing [n]\n",
  "PUSHOVER": "an easily defeated person or team [n -S]\n",
  "PUSHOVERS": "PUSHOVER, an easily defeated person or team [n]\n",
  "PUSHPIN": "a large-headed pin [n -S]\n",
  "PUSHPINS": "PUSHPIN, a large-headed pin [n]\n",
  "PUSHPIT": "a safety railing at the stern of a yacht [n -S]\n",
  "PUSHPITS": "PUSHPIT, a safety railing at the stern of a yacht [n]\n",
  "PUSHROD": "a rod for operating the valves in an engine [n -S]\n",
  "PUSHRODS": "PUSHROD, a rod for operating the valves in an engine [n]\n",
  "PUSHUP": "a type of gymnastic exercise [n -S]\n",
  "PUSHUPS": "PUSHUP, a type of gymnastic exercise [n]\n",
  "PUSHY": "offensively aggressive [adj PUSHIER, PUSHIEST, PUSHILY]\n",
  "PUSILLANIMITIES": "PUSILLANIMITY, cowardliness [n]\n",
  "PUSILLANIMITY": "cowardliness [n PUSILLANIMITIES]\n",
  "PUSILLANIMOUS": "lacking courage, timid [adj PUSILLANIMOUSLY]\n",
  "PUSILLANIMOUSLY": "PUSILLANIMOUS, lacking courage, timid [adv]\n",
  "PUSLE": "to puzzle [v PUSLED, PUSLING, PUSLES]\n",
  "PUSLED": "PUSLE, to puzzle [v]\n",
  "PUSLES": "PUSLE, to puzzle [v]\n",
  "PUSLEY": "purslane, also PUSSLEY, PUSSLY [n -S]\n",
  "PUSLEYS": "PUSLEY, purslane, also PUSSLEY, PUSSLY [n]\n",
  "PUSLIKE": "like pus [adj]\n",
  "PUSLING": "PUSLE, to puzzle [v]\n",
  "PUSS": "a familiar name for a cat [n -ES]\n",
  "PUSSEL": "(Shakespeare) a slut, also PUCELLE, PUZEL, PUZZEL [n -S]\n",
  "PUSSELS": "PUSSEL, (Shakespeare) a slut, also PUCELLE, PUZEL, PUZZEL [n]\n",
  "PUSSER": "in naval slang, a supply officer [n -S]\n",
  "PUSSERS": "PUSSER, in naval slang, a supply officer [n]\n",
  "PUSSES": "PUSS, a familiar name for a cat [n]\n",
  "PUSSIER": "PUSSY, full of pus [adj]\n",
  "PUSSIES": "PUSSY, a cat, also POUSSIE [n]\n",
  "PUSSIEST": "PUSSY, full of pus [adj]\n",
  "PUSSLEY": "purslane, also PUSLEY, PUSSLY [n -S]\n",
  "PUSSLEYS": "PUSSLEY, purslane, also PUSLEY, PUSSLY [n]\n",
  "PUSSLIES": "PUSSLY, purslane, a herb used in salads, also PUSLEY, PUSSLEY [n]\n",
  "PUSSLIKE": "like a puss [adj]\n",
  "PUSSLY": "purslane, a herb used in salads, also PUSLEY, PUSSLEY [n PUSSLIES]\n",
  "PUSSY": "a cat, also POUSSIE [n PUSSIES] / full of pus [adj PUSSIER, PUSSIEST]\n",
  "PUSSYCAT": "a very amenable person [n -S]\n",
  "PUSSYCATS": "PUSSYCAT, a very amenable person [n]\n",
  "PUSSYFOOT": "a prohibitionist [n -S] / to tread softly or lightly to avoid being noticed; to act cautiously or noncommittally [v -ED, -ING, -S]\n",
  "PUSSYFOOTED": "PUSSYFOOT, to tread softly or lightly to avoid being noticed; to act cautiously or noncommittally [v]\n",
  "PUSSYFOOTER": "one who pussyfoots [n -S]\n",
  "PUSSYFOOTERS": "PUSSYFOOTER, one who pussyfoots [n]\n",
  "PUSSYFOOTING": "the act of approaching a topic with great caution [n -S]\n",
  "PUSSYFOOTINGS": "PUSSYFOOTING, the act of approaching a topic with great caution [n]\n",
  "PUSSYFOOTS": "PUSSYFOOT, to tread softly or lightly to avoid being noticed; to act cautiously or noncommittally [v]\n",
  "PUSSYTOES": "a genus of composite herbs [n PUSSYTOES]\n",
  "PUSTULANT": "producing pustules [adj] / an agent that causes pustules [n -S]\n",
  "PUSTULANTS": "PUSTULANT, an agent that causes pustules [n]\n",
  "PUSTULAR": "of or pertaining to pustules, also PUSTULOUS [adj]\n",
  "PUSTULATE": "to form into pustules, or blisters [v PUSTULATED, PUSTULATING, PUSTULATES]\n",
  "PUSTULATED": "PUSTULATE, to form into pustules, or blisters [v]\n",
  "PUSTULATES": "PUSTULATE, to form into pustules, or blisters [v]\n",
  "PUSTULATING": "PUSTULATE, to form into pustules, or blisters [v]\n",
  "PUSTULATION": "the state of having pustules [n -S]\n",
  "PUSTULATIONS": "PUSTULATION, the state of having pustules [n]\n",
  "PUSTULE": "a pimple containing pus [n -S]\n",
  "PUSTULED": "having a pustule [adj]\n",
  "PUSTULES": "PUSTULE, a pimple containing pus [n]\n",
  "PUSTULOUS": "of or pertaining to pustules, also PUSTULAR [adj]\n",
  "PUT": "to place in position [v PUTTED or PUT, PUTTING, PUTS]\n",
  "PUTAMEN": "(Latin) a fruit stone; a membrane lining an eggshell [n PUTAMINA or PUTAMENS]\n",
  "PUTAMENS": "PUTAMEN, (Latin) a fruit stone; a membrane lining an eggshell [n]\n",
  "PUTAMINA": "PUTAMEN, (Latin) a fruit stone; a membrane lining an eggshell [n]\n",
  "PUTANGITANGI": "(Maori) a New Zealand bird, aka paradise duck [n -S]\n",
  "PUTANGITANGIS": "PUTANGITANGI, (Maori) a New Zealand bird, aka paradise duck [n]\n",
  "PUTATIVE": "supposed or reputed [adj PUTATIVELY]\n",
  "PUTATIVELY": "PUTATIVE, supposed or reputed [adv]\n",
  "PUTCHEON": "a wire trap for catching salmon, also PUTCHER [n -S]\n",
  "PUTCHEONS": "PUTCHEON, a wire trap for catching salmon, also PUTCHER [n]\n",
  "PUTCHER": "a wire trap for catching salmon, also PUTCHEON [n -S]\n",
  "PUTCHERS": "PUTCHER, a wire trap for catching salmon, also PUTCHEON [n]\n",
  "PUTCHOCK": "(Hindi) an aromatic root resembling ginger, also PACHAK, PUTCHUK [n -S]\n",
  "PUTCHOCKS": "PUTCHOCK, (Hindi) an aromatic root resembling ginger, also PACHAK, PUTCHUK [n]\n",
  "PUTCHUK": "(Hindi) an aromatic root resembling ginger, also PUTCHOCK, PACHAK [n -S]\n",
  "PUTCHUKS": "PUTCHUK, (Hindi) an aromatic root resembling ginger, also PUTCHOCK, PACHAK [n]\n",
  "PUTDOWN": "a disparaging or snubbing remark [n -S]\n",
  "PUTDOWNS": "PUTDOWN, a disparaging or snubbing remark [n]\n",
  "PUTEAL": "a wall around the top of a well [n -S]\n",
  "PUTEALS": "PUTEAL, a wall around the top of a well [n]\n",
  "PUTELI": "(Hindi) a flat-bottomed boat used on the Ganges [n -S]\n",
  "PUTELIS": "PUTELI, (Hindi) a flat-bottomed boat used on the Ganges [n]\n",
  "PUTID": "decayed; fetid [adj]\n",
  "PUTLOCK": "a crosspiece in a scaffolding, also PUTLOG [n -S]\n",
  "PUTLOCKS": "PUTLOCK, a crosspiece in a scaffolding, also PUTLOG [n]\n",
  "PUTLOG": "a crosspiece in a scaffolding, also PUTLOCK [n -S]\n",
  "PUTLOGS": "PUTLOG, a crosspiece in a scaffolding, also PUTLOCK [n]\n",
  "PUTOFF": "an excuse or evasion [n -S]\n",
  "PUTOFFS": "PUTOFF, an excuse or evasion [n]\n",
  "PUTOIS": "(French) a brush for painting pottery [n PUTOIS]\n",
  "PUTON": "a hoax or deception [n -S]\n",
  "PUTONGHUA": "the official spoken language of China [n -S]\n",
  "PUTONGHUAS": "PUTONGHUA, the official spoken language of China [n]\n",
  "PUTONS": "PUTON, a hoax or deception [n]\n",
  "PUTOUT": "an act of causing an out in baseball [n -S]\n",
  "PUTOUTS": "PUTOUT, an act of causing an out in baseball [n]\n",
  "PUTREFACIENT": "causing putrefaction [adj]\n",
  "PUTREFACTION": "rotting [n -S]\n",
  "PUTREFACTIONS": "PUTREFACTION, rotting [n]\n",
  "PUTREFACTIVE": "relating to putrefaction [adj]\n",
  "PUTREFIABLE": "capable of putrefying [adj]\n",
  "PUTREFIED": "PUTREFY, to make or become putrid [v]\n",
  "PUTREFIER": "an agent that causes putrefaction [n -S]\n",
  "PUTREFIERS": "PUTREFIER, an agent that causes putrefaction [n]\n",
  "PUTREFIES": "PUTREFY, to make or become putrid [v]\n",
  "PUTREFY": "to make or become putrid [v PUTREFIED, PUTREFYING, PUTREFIES]\n",
  "PUTREFYING": "PUTREFY, to make or become putrid [v]\n",
  "PUTRESCENCE": "the state of being putrescent [n -S]\n",
  "PUTRESCENCES": "PUTRESCENCE, the state of being putrescent [n]\n",
  "PUTRESCENT": "becoming putrid or rotten [adj]\n",
  "PUTRESCIBILITY": "the state of being putrescible [n]\n",
  "PUTRESCIBLE": "something capable of putrescence [n -S]\n",
  "PUTRESCIBLES": "PUTRESCIBLE, something capable of putrescence [n]\n",
  "PUTRESCINE": "a substance formed during the putrefaction of flesh [n -S]\n",
  "PUTRESCINES": "PUTRESCINE, a substance formed during the putrefaction of flesh [n]\n",
  "PUTRID": "rotten [adj PUTRIDER, PUTRIDEST, PUTRIDLY]\n",
  "PUTRIDER": "PUTRID, rotten [adj]\n",
  "PUTRIDEST": "PUTRID, rotten [adj]\n",
  "PUTRIDITIES": "PUTRIDITY, the state of being putrid, also PUTRIDNESS [n]\n",
  "PUTRIDITY": "the state of being putrid, also PUTRIDNESS [n PUTRIDITIES]\n",
  "PUTRIDLY": "PUTRID, rotten [adv]\n",
  "PUTRIDNESS": "the state of being putrid, also PUTRIDITY [n -ES]\n",
  "PUTRIDNESSES": "PUTRIDNESS, the state of being putrid, also PUTRIDITY [n]\n",
  "PUTRIFICATION": "the act or state of putrefying [n -S]\n",
  "PUTRIFICATIONS": "PUTRIFICATION, the act or state of putrefying [n]\n",
  "PUTS": "PUT, to place in position [v]\n",
  "PUTSCH": "(German) a secretly plotted and suddenly executed attempt to overthrow a government [n -ES]\n",
  "PUTSCHES": "PUTSCH, (German) a secretly plotted and suddenly executed attempt to overthrow a government [n]\n",
  "PUTSCHIST": "one who engages in a putsch [n -S]\n",
  "PUTSCHISTS": "PUTSCHIST, one who engages in a putsch [n]\n",
  "PUTT": "to hit with a light stroke in golf [v -ED, -ING, -S]\n",
  "PUTTED": "PUT, to place in position [v]\n",
  "PUTTEE": "(Hindi) a long strip of cloth wound round the lower leg, esp as part of army uniform, also PUTTIE [n -S]\n",
  "PUTTEES": "PUTTEE, (Hindi) a long strip of cloth wound round the lower leg, esp as part of army uniform, also PUTTIE [n]\n",
  "PUTTEN": "PIT, to mark with depressions [v]\n",
  "PUTTER": "to occupy oneself in a leisurely or ineffective manner, also POTTER [v -ED, -ING, -S]\n",
  "PUTTERED": "PUTTER, to occupy oneself in a leisurely or ineffective manner, also POTTER [v]\n",
  "PUTTERER": "one who putters [n -S]\n",
  "PUTTERERS": "PUTTERER, one who putters [n]\n",
  "PUTTERING": "PUTTER, to occupy oneself in a leisurely or ineffective manner, also POTTER [v]\n",
  "PUTTERS": "PUTTER, to occupy oneself in a leisurely or ineffective manner, also POTTER [v]\n",
  "PUTTI": "PUTTO, (Italian) an artistic representation of a cherub [n]\n",
  "PUTTIE": "(Hindi) a long strip of cloth wound round the lower leg, esp as part of army uniform, also PUTTEE [n -S]\n",
  "PUTTIED": "PUTTY, to fill with a type of cement [v]\n",
  "PUTTIER": "one who putties; a glazier [n -S]\n",
  "PUTTIERS": "PUTTIER, one who putties; a glazier [n]\n",
  "PUTTIES": "PUTTY, to fill with a type of cement [v]\n",
  "PUTTING": "a sport where heavy weights are hurled [n -S]\n",
  "PUTTINGS": "PUTTING, a sport where heavy weights are hurled [n]\n",
  "PUTTO": "(Italian) an artistic representation of a cherub [n PUTTI]\n",
  "PUTTOCK": "a kite or buzzard [n -S]\n",
  "PUTTOCKS": "PUTTOCK, a kite or buzzard [n]\n",
  "PUTTS": "PUTT, to hit with a light stroke in golf [v]\n",
  "PUTTY": "to fill with a type of cement [v PUTTIED, PUTTYING, PUTTIES]\n",
  "PUTTYING": "PUTTY, to fill with a type of cement [v]\n",
  "PUTTYLESS": "without putty [adj]\n",
  "PUTTYLIKE": "like putty [adj]\n",
  "PUTTYROOT": "an American orchidaceous plant which flowers in early summer [n -S]\n",
  "PUTTYROOTS": "PUTTYROOT, an American orchidaceous plant which flowers in early summer [n]\n",
  "PUTURE": "(historical) a foresters' claim of subsistence within the bounds of a forest, also PULTURE [n -S]\n",
  "PUTURES": "PUTURE, (historical) a foresters' claim of subsistence within the bounds of a forest, also PULTURE [n]\n",
  "PUTZ": "to waste time [v -ED, -ING, -ES]\n",
  "PUTZED": "PUTZ, to waste time [v]\n",
  "PUTZES": "PUTZ, to waste time [v]\n",
  "PUTZING": "PUTZ, to waste time [v]\n",
  "PUY": "a small volcanic cone [n -S]\n",
  "PUYS": "PUY, a small volcanic cone [n]\n",
  "PUZEL": "(obsolete) a maid, a slut, also PUCELLE, PUSSEL, PUZZEL [n -S]\n",
  "PUZELS": "PUZEL, (obsolete) a maid, a slut, also PUCELLE, PUSSEL, PUZZEL [n]\n",
  "PUZZEL": "(obsolete) a maid, a slut, also PUCELLE, PUSSEL, PUZEL [n -S]\n",
  "PUZZELS": "PUZZEL, (obsolete) a maid, a slut, also PUCELLE, PUSSEL, PUZEL [n]\n",
  "PUZZLE": "to cause uncertainty and indecision in [v PUZZLED, PUZZLING, PUZZLES]\n",
  "PUZZLED": "PUZZLE, to cause uncertainty and indecision in [v]\n",
  "PUZZLEDLY": "PUZZLED, PUZZLE, to cause uncertainty and indecision in [adv]\n",
  "PUZZLEDOM": "the domain of puzzles; puzzles, collectively [n -S]\n",
  "PUZZLEDOMS": "PUZZLEDOM, the domain of puzzles; puzzles, collectively [n]\n",
  "PUZZLEHEADED": "having or based on confused attitudes or ideas [adj]\n",
  "PUZZLEMENT": "the state of being puzzled [n -S]\n",
  "PUZZLEMENTS": "PUZZLEMENT, the state of being puzzled [n]\n",
  "PUZZLER": "something that puzzles [n -S]\n",
  "PUZZLERS": "PUZZLER, something that puzzles [n]\n",
  "PUZZLES": "PUZZLE, to cause uncertainty and indecision in [v]\n",
  "PUZZLING": "PUZZLE, to cause uncertainty and indecision in [v]\n",
  "PUZZLINGLY": "PUZZLING, PUZZLE, to cause uncertainty and indecision in [adv]\n",
  "PUZZOLANA": "(Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLAN, POZZOLANA, POZZUOLANA [n -S]\n",
  "PUZZOLANAS": "PUZZOLANA, (Italian) volcanic ashes from Pozzuoli, in Italy, used in the manufacture of a kind of mortar which hardens under water, also POZZOLAN, POZZOLANA, POZZUOLANA [n]\n",
  "PWN": "(slang) to dominate or humiliate an opponent esp. in online gaming [v -ED, -ING, -S]\n",
  "PWNED": "PWN, (slang) to dominate or humiliate an opponent esp. in online gaming [v]\n",
  "PWNING": "PWN, (slang) to dominate or humiliate an opponent esp. in online gaming [v]\n",
  "PWNS": "PWN, (slang) to dominate or humiliate an opponent esp. in online gaming [v]\n",
  "PYA": "a copper coin of Burma [n -S]\n",
  "PYAEMIA": "(Greek) the presence of pus in the blood, also PYEMIA [n -S]\n",
  "PYAEMIAS": "PYAEMIA, (Greek) the presence of pus in the blood, also PYEMIA [n]\n",
  "PYAEMIC": "of or pertaining to pyaemia, a form of blood poisoning, also PYEMIC [adj]\n",
  "PYAS": "PYA, a copper coin of Burma [n]\n",
  "PYAT": "(Scots) a magpie, also PYET, PIET, PYOT [n -S]\n",
  "PYATS": "PYAT, (Scots) a magpie, also PYET, PIET, PYOT [n]\n",
  "PYCNIC": "characterized by shortness of stature, broadness of girth, and powerful muscularity, also PYKNIC [adj]\n",
  "PYCNIDIA": "PYCNIDIUM, a spore-bearing organ in some fungi [n]\n",
  "PYCNIDIAL": "relating to a pycnidium, a roundish fructification formed by many species of fungi [adj]\n",
  "PYCNIDIOSPORE": "a conidium produced in a pycnidium, also PYCNOSPORE [n -S]\n",
  "PYCNIDIOSPORES": "PYCNIDIOSPORE, a conidium produced in a pycnidium, also PYCNOSPORE [n]\n",
  "PYCNIDIUM": "a spore-bearing organ in some fungi [n PYCNIDIA]\n",
  "PYCNITE": "a variety of topaz [n -S]\n",
  "PYCNITES": "PYCNITE, a variety of topaz [n]\n",
  "PYCNOCONIDIA": "PYCNOCONIDIUM, an asexual fungal spore produced in a pycnidium [n]\n",
  "PYCNOCONIDIUM": "an asexual fungal spore produced in a pycnidium [n PYCNOCONIDIA]\n",
  "PYCNODYSOSTOSES": "PYCNODYSOSTOSIS, a rare inherited bone disease characterized by short stature and thickening and fragility of the bones [n]\n",
  "PYCNODYSOSTOSIS": "a rare inherited bone disease characterized by short stature and thickening and fragility of the bones [n PYCNODYSOSTOSES]\n",
  "PYCNOGONID": "one of the Pycnogonida, sea-spiders [n -S]\n",
  "PYCNOGONIDS": "PYCNOGONID, one of the Pycnogonida, sea-spiders [n]\n",
  "PYCNOGONOID": "a sea-spider, also PYCNOGONID [n -S]\n",
  "PYCNOGONOIDS": "PYCNOGONOID, a sea-spider, also PYCNOGONID [n]\n",
  "PYCNOMETER": "an instrument for measuring specific gravity or density, also PYKNOMETER [n -S]\n",
  "PYCNOMETERS": "PYCNOMETER, an instrument for measuring specific gravity or density, also PYKNOMETER [n]\n",
  "PYCNOMETRIC": "relating to a pycnometer, an instrument for measuring specific gravity or density [adj]\n",
  "PYCNON": "(Greek) a term in ancient Greek music; in mediaeval music, a semitone [n -S]\n",
  "PYCNONS": "PYCNON, (Greek) a term in ancient Greek music; in mediaeval music, a semitone [n]\n",
  "PYCNOSES": "PYCNOSIS, a shrinking and thickening of a cell nucleus, also PYKNOSIS [n]\n",
  "PYCNOSIS": "a shrinking and thickening of a cell nucleus, also PYKNOSIS [n PYCNOSES]\n",
  "PYCNOSOME": "a body type characterized by stockiness [n -S]\n",
  "PYCNOSOMES": "PYCNOSOME, a body type characterized by stockiness [n]\n",
  "PYCNOSPORE": "a conidium produced in a pycnidium, also PYCNIDIOSPORE [n -S]\n",
  "PYCNOSPORES": "PYCNOSPORE, a conidium produced in a pycnidium, also PYCNIDIOSPORE [n]\n",
  "PYCNOSTYLE": "with close-set columns, one and a half diameters apart [adj] / an ancient Greek temple with columns in this style [n -S]\n",
  "PYCNOSTYLES": "PYCNOSTYLE, an ancient Greek temple with columns in this style [n]\n",
  "PYCNOTIC": "exhibiting pyknosis, also PYKNOTIC [adj]\n",
  "PYE": "to mix printing type indiscrimately, also PI, PIE [v PIED, PYEING, PYES]\n",
  "PYEBALD": "a horse with patchy colours, also PIEBALD [n -S]\n",
  "PYEBALDS": "PYEBALD, a horse with patchy colours, also PIEBALD [n]\n",
  "PYEING": "PYE, to mix printing type indiscrimately, also PI, PIE [v]\n",
  "PYELITIC": "relating to pyelitis, inflammation of the pelvis of the kidney [adj]\n",
  "PYELITIS": "inflammation of the pelvis or kidney [n -ES]\n",
  "PYELITISES": "PYELITIS, inflammation of the pelvis or kidney [n]\n",
  "PYELOGRAM": "an X-ray picture of the renal pelvis [n -S]\n",
  "PYELOGRAMS": "PYELOGRAM, an X-ray picture of the renal pelvis [n]\n",
  "PYELOGRAPHIC": "relating to pyelography, the use of pyelograms, X-ray pictures of the renal pelvis [adj]\n",
  "PYELOGRAPHIES": "PYELOGRAPHY, the use of pyelograms, X-ray pictures of the renal pelvis [n]\n",
  "PYELOGRAPHY": "the use of pyelograms, X-ray pictures of the renal pelvis [n PYELOGRAPHIES]\n",
  "PYELONEPHRITIC": "relating to pyelonephritis, inflammation of both the kidney and its pelvis [adj]\n",
  "PYELONEPHRITIS": "inflammation of both the kidney and its pelvis [n]\n",
  "PYEMIA": "(Greek) the presence of pus in the blood, also PYAEMIA [n -S]\n",
  "PYEMIAS": "PYEMIA, (Greek) the presence of pus in the blood, also PYAEMIA [n]\n",
  "PYEMIC": "relating to pyemia, blood poisoning, also PYAEMIC [adj]\n",
  "PYENGADU": "(Burmese) the ironwood tree, also PYINKADO [n -S]\n",
  "PYENGADUS": "PYENGADU, (Burmese) the ironwood tree, also PYINKADO [n]\n",
  "PYES": "PYE, to mix printing type indiscrimately, also PI, PIE [v]\n",
  "PYET": "(Scots) a magpie, also PIET, PYAT, PYOT [n -S]\n",
  "PYETS": "PYET, (Scots) a magpie, also PIET, PYAT, PYOT [n]\n",
  "PYGAL": "the posterior median plate of a chelonian carapace [n -S]\n",
  "PYGALS": "PYGAL, the posterior median plate of a chelonian carapace [n]\n",
  "PYGARG": "(Greek) chiefly in biblical translations, a kind of antelope, perhaps an addax [n -S]\n",
  "PYGARGS": "PYGARG, (Greek) chiefly in biblical translations, a kind of antelope, perhaps an addax [n]\n",
  "PYGARGUS": "(obsolete) any of several birds of prey with a white tail, esp. the white-tailed sea eagle [n -ES]\n",
  "PYGARGUSES": "PYGARGUS, (obsolete) any of several birds of prey with a white tail, esp. the white-tailed sea eagle [n]\n",
  "PYGIDIA": "PYGIDIUM, in trilobites, the posterior division of the body, formed by fusion of the telson with one or more posterior pleurae [n]\n",
  "PYGIDIAL": "of or like a pygidium, the posterior division of the body in trilobites [adj]\n",
  "PYGIDIUM": "in trilobites, the posterior division of the body, formed by fusion of the telson with one or more posterior pleurae [n PYGIDIA]\n",
  "PYGMAEAN": "pygmy-like, also PIGMAEAN, PIGMEAN, PYGMEAN [adj]\n",
  "PYGMEAN": "pygmy-like, also PIGMAEAN, PIGMEAN, PYGMAEAN [adj]\n",
  "PYGMIES": "PYGMY, a small person, also PIGMY [n]\n",
  "PYGMOID": "a pygmy, also PIGMOID [n -S]\n",
  "PYGMOIDS": "PYGMOID, a pygmy, also PIGMOID [n]\n",
  "PYGMY": "a small person, also PIGMY [n PYGMIES]\n",
  "PYGMYISH": "like a pygmy [adj]\n",
  "PYGMYISM": "a stunted or dwarfish condition [n -S]\n",
  "PYGMYISMS": "PYGMYISM, a stunted or dwarfish condition [n]\n",
  "PYGOSTYLE": "the bone of a bird's tail [n -S]\n",
  "PYGOSTYLES": "PYGOSTYLE, the bone of a bird's tail [n]\n",
  "PYIC": "pertaining to or discharging pus [adj]\n",
  "PYIN": "a protein compound contained in pus [n -S]\n",
  "PYINKADO": "(Burmese) the ironwood tree, also PYENGADU [n -S]\n",
  "PYINKADOS": "PYINKADO, (Burmese) the ironwood tree, also PYENGADU [n]\n",
  "PYINS": "PYIN, a protein compound contained in pus [n]\n",
  "PYJAMA": "a garment for sleeping or lounging, also PAJAMA [n -S]\n",
  "PYJAMAED": "wearing pyjamas [adj]\n",
  "PYJAMAS": "PYJAMA, a garment for sleeping or lounging, also PAJAMA [n]\n",
  "PYKNIC": "characterized by shortness of stature, broadness of girth, and powerful muscularity [adj] / a person of pyknic build, also PYCNIC [n -S]\n",
  "PYKNICS": "PYKNIC, a person of pyknic build, also PYCNIC [n]\n",
  "PYKNODYSOSTOSES": "PYKNODYSOSTOSIS, a rare inherited bone disease characterized by short stature and thickening and fragility of the bones [n]\n",
  "PYKNODYSOSTOSIS": "a rare inherited bone disease characterized by short stature and thickening and fragility of the bones [n PYKNODYSOSTOSES]\n",
  "PYKNOMETER": "an instrument for measuring specific gravity or density, also PYCNOMETER [n -S]\n",
  "PYKNOMETERS": "PYKNOMETER, an instrument for measuring specific gravity or density, also PYCNOMETER [n]\n",
  "PYKNOSES": "PYKNOSIS, a shrinking and thickening of a cell nucleus, also PYCNOSIS [n]\n",
  "PYKNOSIS": "a shrinking and thickening of a cell nucleus, also PYCNOSIS [n PYKNOSES]\n",
  "PYKNOSOME": "the short or stocky type of human figure [n -S]\n",
  "PYKNOSOMES": "PYKNOSOME, the short or stocky type of human figure [n]\n",
  "PYKNOTIC": "exhibiting pyknosis, also PYCNOTIC [adj]\n",
  "PYLON": "a structure for supporting power-cables [n -S]\n",
  "PYLONS": "PYLON, a structure for supporting power-cables [n]\n",
  "PYLORECTOMIES": "PYLORECTOMY, the surgical removal of all or part of the pylorus [n]\n",
  "PYLORECTOMY": "the surgical removal of all or part of the pylorus [n PYLORECTOMIES]\n",
  "PYLORI": "PYLORUS, (Latin) the opening between the stomach and the duodenum [n]\n",
  "PYLORIC": "pertaining to the pylorus [adj]\n",
  "PYLORUS": "(Latin) the opening between the stomach and the duodenum [n PYLORUSES or PYLORI]\n",
  "PYLORUSES": "PYLORUS, (Latin) the opening between the stomach and the duodenum [n]\n",
  "PYNE": "to yearn intensely, also PINE [v PYNED, PYNING, PYNES]\n",
  "PYNED": "PYNE, to yearn intensely, also PINE [v]\n",
  "PYNES": "PYNE, to yearn intensely, also PINE [v]\n",
  "PYNING": "PYNE, to yearn intensely, also PINE [v]\n",
  "PYODERMA": "a pus-causing skin disease [n -S]\n",
  "PYODERMAS": "PYODERMA, a pus-causing skin disease [n]\n",
  "PYODERMIC": "of or like pyoderma, any skin disease resulting in pustules and/or pus [adj]\n",
  "PYOGENESES": "PYOGENESIS, the formation of pus [n]\n",
  "PYOGENESIS": "the formation of pus [n PYOGENESES]\n",
  "PYOGENIC": "producing pus [adj]\n",
  "PYOID": "purulent [adj]\n",
  "PYONER": "(Shakespeare) a military pioneer, also PIONER [n -S]\n",
  "PYONERS": "PYONER, (Shakespeare) a military pioneer, also PIONER [n]\n",
  "PYONINGS": "(Spenser) pioning, pioneer-work [n]\n",
  "PYORRHEA": "pus in the sockets of the teeth [n -S]\n",
  "PYORRHEAL": "relating to pyorrhea, suppuration in the sockets of the teeth, also PYORRHEIC, PYORRHOEAL, PYORRHOEIC [adj]\n",
  "PYORRHEAS": "PYORRHEA, pus in the sockets of the teeth [n]\n",
  "PYORRHEIC": "relating to pyorrhea, suppuration in the sockets of the teeth, also PYORRHEAL, PYORRHOEAL, PYORRHOEIC [adj]\n",
  "PYORRHOEA": "suppuration in the sockets of the teeth, also PYORRHEA [n -S]\n",
  "PYORRHOEAL": "relating to pyorrhoea, suppuration in the sockets of the teeth, also PYORRHEAL, PYORRHEIC, PYORRHOEIC [adj]\n",
  "PYORRHOEAS": "PYORRHOEA, suppuration in the sockets of the teeth, also PYORRHEA [n]\n",
  "PYORRHOEIC": "relating to pyorrhoea, suppuration in the sockets of the teeth, also PYORRHEAL, PYORRHEIC, PYORRHOEAL [adj]\n",
  "PYOSES": "PYOSIS, the formation of pus [n]\n",
  "PYOSIS": "the formation of pus [n PYOSES]\n",
  "PYOT": "(Scots) a magpie, also PIET, PYAT, PYET [n -S]\n",
  "PYOTS": "PYOT, (Scots) a magpie, also PIET, PYAT, PYET [n]\n",
  "PYRACANTH": "the evergreen thorn, a shrub native of Europe, also PYRACANTHA [n -S]\n",
  "PYRACANTHA": "the evergreen thorn, a shrub native of Europe, also PYRACANTH [n -S]\n",
  "PYRACANTHAS": "PYRACANTHA, the evergreen thorn, a shrub native of Europe, also PYRACANTH [n]\n",
  "PYRACANTHS": "PYRACANTH, the evergreen thorn, a shrub native of Europe, also PYRACANTHA [n]\n",
  "PYRAL": "of or pertaining to a pyre [adj]\n",
  "PYRALID": "(Greek) a long-legged moth, also PYRALIS [n -S]\n",
  "PYRALIDID": "a kind of moth, also PYRALID, PYRALIS [n -S]\n",
  "PYRALIDIDS": "PYRALIDID, a kind of moth, also PYRALID, PYRALIS [n]\n",
  "PYRALIDS": "PYRALID, (Greek) a long-legged moth, also PYRALIS [n]\n",
  "PYRALIS": "(Greek) a kind of moth, also PYRALID, PYRALIDID [n -ES]\n",
  "PYRALISES": "PYRALIS, (Greek) a kind of moth, also PYRALID, PYRALIDID [n]\n",
  "PYRAMID": "a solid figure with triangular sides meeting in a point [n PYRAMIDS or PYRAMIDES] / to increase by adding gradually [v -ED, -ING, -S]\n",
  "PYRAMIDAL": "shaped like a pyramid [adj PYRAMIDALLY]\n",
  "PYRAMIDALLY": "PYRAMIDAL, shaped like a pyramid [adv]\n",
  "PYRAMIDED": "PYRAMID, to increase by adding gradually [v]\n",
  "PYRAMIDES": "PYRAMID, a solid figure with triangular sides meeting in a point [n]\n",
  "PYRAMIDIA": "PYRAMIDION, the small pyramidal apex of an obelisk [n]\n",
  "PYRAMIDIC": "of or like a pyramid, also PYRAMIDICAL [adj PYRAMIDICALLY]\n",
  "PYRAMIDICAL": "of or like a pyramid, also PYRAMIDIC [adj PYRAMIDICALLY]\n",
  "PYRAMIDICALLY": "PYRAMIDICAL, of or like a pyramid, also PYRAMIDIC [adv]\n",
  "PYRAMIDING": "PYRAMID, to increase by adding gradually [v]\n",
  "PYRAMIDION": "the small pyramidal apex of an obelisk [n PYRAMIDIONS or PYRAMIDIA]\n",
  "PYRAMIDIONS": "PYRAMIDION, the small pyramidal apex of an obelisk [n]\n",
  "PYRAMIDIST": "someone who studies the Egyptian pyramids [n -S]\n",
  "PYRAMIDISTS": "PYRAMIDIST, someone who studies the Egyptian pyramids [n]\n",
  "PYRAMIDOLOGIES": "PYRAMIDOLOGY, the study of the Egyptian pyramids [n]\n",
  "PYRAMIDOLOGIST": "a specialist in pyramidology [n -S]\n",
  "PYRAMIDOLOGISTS": "PYRAMIDOLOGIST, a specialist in pyramidology [n]\n",
  "PYRAMIDOLOGY": "the study of the Egyptian pyramids [n PYRAMIDOLOGIES]\n",
  "PYRAMIDON": "an organ-stop with pipes like inverted pyramids [n -S]\n",
  "PYRAMIDONS": "PYRAMIDON, an organ-stop with pipes like inverted pyramids [n]\n",
  "PYRAMIDS": "PYRAMID, to increase by adding gradually [v]\n",
  "PYRAMIS": "(Shakespeare) a pyramid [n PYRAMISES or PYRAMIDES]\n",
  "PYRAMISES": "PYRAMIS, (Shakespeare) a pyramid [n]\n",
  "PYRAN": "a type of unsaturated heterocyclic compound [n -S]\n",
  "PYRANOID": "of or like the chemical compound pyran [adj]\n",
  "PYRANOMETER": "another name for a solarimeter [n -S]\n",
  "PYRANOMETERS": "PYRANOMETER, another name for a solarimeter [n]\n",
  "PYRANOSE": "a sugar present in pyran [n -S]\n",
  "PYRANOSES": "PYRANOSE, a sugar present in pyran [n]\n",
  "PYRANOSIDE": "a glycoside containing the pyran ring [n -S]\n",
  "PYRANOSIDES": "PYRANOSIDE, a glycoside containing the pyran ring [n]\n",
  "PYRANS": "PYRAN, a type of unsaturated heterocyclic compound [n]\n",
  "PYRARGYRITE": "a deep-red to black silver ore [n -S]\n",
  "PYRARGYRITES": "PYRARGYRITE, a deep-red to black silver ore [n]\n",
  "PYRAZOLE": "a chemical related to pyrrole [n -S]\n",
  "PYRAZOLES": "PYRAZOLE, a chemical related to pyrrole [n]\n",
  "PYRE": "a pile of combustible material [n -S]\n",
  "PYRENE": "the hard covering of the kernel of certain fruits [n -S]\n",
  "PYRENEITE": "a black garnet [n -S]\n",
  "PYRENEITES": "PYRENEITE, a black garnet [n]\n",
  "PYRENES": "PYRENE, the hard covering of the kernel of certain fruits [n]\n",
  "PYRENOCARP": "a perithecium, a small fruiting body containing ascospores [n -S]\n",
  "PYRENOCARPS": "PYRENOCARP, a perithecium, a small fruiting body containing ascospores [n]\n",
  "PYRENOID": "a protein body of certain lower organisms [n -S]\n",
  "PYRENOIDS": "PYRENOID, a protein body of certain lower organisms [n]\n",
  "PYRENOMYCETOUS": "belonging to the Pyrenomycetes, a group of Ascomycetes whose characteristic fructification is the perithecium [adj]\n",
  "PYRES": "PYRE, a pile of combustible material [n]\n",
  "PYRETHRIN": "either of two insecticidal oily esters prepared from pyrethrum flowers [n -S]\n",
  "PYRETHRINS": "PYRETHRIN, either of two insecticidal oily esters prepared from pyrethrum flowers [n]\n",
  "PYRETHROID": "any of various synthetic compounds related to the pyrethrins, and sharing their insecticidal properties [n -S]\n",
  "PYRETHROIDS": "PYRETHROID, any of various synthetic compounds related to the pyrethrins, and sharing their insecticidal properties [n]\n",
  "PYRETHRUM": "a name still applied to various garden flowers, esp. varieties of Chrysanthemum [n -S]\n",
  "PYRETHRUMS": "PYRETHRUM, a name still applied to various garden flowers, esp. varieties of Chrysanthemum [n]\n",
  "PYRETIC": "pertaining to fever [adj]\n",
  "PYRETOLOGIES": "PYRETOLOGY, medical study of fevers [n]\n",
  "PYRETOLOGY": "medical study of fevers [n PYRETOLOGIES]\n",
  "PYRETOTHERAPIES": "PYRETOTHERAPY, medical treatment by causing fever [n]\n",
  "PYRETOTHERAPY": "medical treatment by causing fever [n PYRETOTHERAPIES]\n",
  "PYREX": "(tradename) a heat-resistant glassware [n -ES]\n",
  "PYREXES": "PYREX, (tradename) a heat-resistant glassware [n]\n",
  "PYREXIA": "(Greek) a fever [n -S]\n",
  "PYREXIAL": "showing symptoms of pyrexia, feverish [adj]\n",
  "PYREXIAS": "PYREXIA, (Greek) a fever [n]\n",
  "PYREXIC": "of or like pyrexia, fever [adj]\n",
  "PYRGEOMETER": "an instrument for measuring the loss of heat by radiation from the earth's surface [n -S]\n",
  "PYRGEOMETERS": "PYRGEOMETER, an instrument for measuring the loss of heat by radiation from the earth's surface [n]\n",
  "PYRHELIOMETER": "an instrument for measuring the heating effect of the sun [n -S]\n",
  "PYRHELIOMETERS": "PYRHELIOMETER, an instrument for measuring the heating effect of the sun [n]\n",
  "PYRHELIOMETRIC": "relating to measurement by pyrheliometer, an instrument for measuring the heating effect of the sun [adj]\n",
  "PYRIC": "pertaining to burning [adj]\n",
  "PYRIDIC": "related to, or formed from, pyridine, a nitrogenous base used as antiseptic, etc. [adj]\n",
  "PYRIDINE": "a nitrogenous base used as antiseptic, etc. [n -S]\n",
  "PYRIDINES": "PYRIDINE, a nitrogenous base used as antiseptic, etc. [n]\n",
  "PYRIDOXAL": "a crystalline aldehyde of the vitamin B6 group [n -S]\n",
  "PYRIDOXALS": "PYRIDOXAL, a crystalline aldehyde of the vitamin B6 group [n]\n",
  "PYRIDOXAMINE": "a crystalline amine of the vitamin B6 group [n -S]\n",
  "PYRIDOXAMINES": "PYRIDOXAMINE, a crystalline amine of the vitamin B6 group [n]\n",
  "PYRIDOXIN": "a pyridine derivative, a member of the vitamin B complex, also PYRIDOXINE [n -S]\n",
  "PYRIDOXINE": "a pyridine derivative, a member of the vitamin B complex, also PYRIDOXIN [n -S]\n",
  "PYRIDOXINES": "PYRIDOXINE, a pyridine derivative, a member of the vitamin B complex, also PYRIDOXIN [n]\n",
  "PYRIDOXINS": "PYRIDOXIN, a pyridine derivative, a member of the vitamin B complex, also PYRIDOXINE [n]\n",
  "PYRIFORM": "pear-shaped, also PIRIFORM [adj]\n",
  "PYRIMETHAMINE": "a drug used in the treatment of malaria and toxoplasmosis [n -S]\n",
  "PYRIMETHAMINES": "PYRIMETHAMINE, a drug used in the treatment of malaria and toxoplasmosis [n]\n",
  "PYRIMIDINE": "a compound found in DNA [n -S]\n",
  "PYRIMIDINES": "PYRIMIDINE, a compound found in DNA [n]\n",
  "PYRITE": "(Greek) a brassy yellow mineral, iron disulphide, also PYRITES [n -S]\n",
  "PYRITES": "(Greek) a brassy yellow mineral, iron disulphide, also PYRITE [n]\n",
  "PYRITHIAMINE": "an antivitamin causing thiamine (vitamin B1) deficiency [n -S]\n",
  "PYRITHIAMINES": "PYRITHIAMINE, an antivitamin causing thiamine (vitamin B1) deficiency [n]\n",
  "PYRITIC": "consisting of, or resembling, pyrites, also PYRITICAL, PYRITOUS [adj]\n",
  "PYRITICAL": "consisting of, or resembling, pyrites, also PYRITIC, PYRITOUS [adj]\n",
  "PYRITIFEROUS": "bearing pyrite [adj]\n",
  "PYRITISE": "to convert into pyrites, also PYRITIZE [v PYRITISED, PYRITISING, PYRITISES]\n",
  "PYRITISED": "PYRITISE, to convert into pyrites, also PYRITIZE [v]\n",
  "PYRITISES": "PYRITISE, to convert into pyrites, also PYRITIZE [v]\n",
  "PYRITISING": "PYRITISE, to convert into pyrites, also PYRITIZE [v]\n",
  "PYRITIZE": "to convert into pyrites, also PYRITISE [v PYRITIZED, PYRITIZING, PYRITIZES]\n",
  "PYRITIZED": "PYRITIZE, to convert into pyrites, also PYRITISE [v]\n",
  "PYRITIZES": "PYRITIZE, to convert into pyrites, also PYRITISE [v]\n",
  "PYRITIZING": "PYRITIZE, to convert into pyrites, also PYRITISE [v]\n",
  "PYRITOHEDRA": "PYRITOHEDRON, a pentagonal dodecahedron [n]\n",
  "PYRITOHEDRAL": "of or like a pyritohedron, a pentagonal dodecahedron [adj]\n",
  "PYRITOHEDRON": "a pentagonal dodecahedron [n PYRITOHEDRA or PYRITOHEDRONS]\n",
  "PYRITOHEDRONS": "PYRITOHEDRON, a pentagonal dodecahedron [n]\n",
  "PYRITOUS": "consisting of, or resembling, pyrites, also PYRITIC, PYRITICAL [adj]\n",
  "PYRO": "(short for) pyrogallol, a chemical used in photography [n -S]\n",
  "PYROBALLOGIES": "PYROBALLOGY, the study of artillery [n]\n",
  "PYROBALLOGY": "the study of artillery [n PYROBALLOGIES]\n",
  "PYROBORIC": "as in pyroboric acid [adj]\n",
  "PYROCATECHIN": "another name for catechol, also PYROCATECHOL [n -S]\n",
  "PYROCATECHINS": "PYROCATECHIN, another name for catechol, also PYROCATECHOL [n]\n",
  "PYROCATECHOL": "another name for catechol, also PYROCATECHIN [n -S]\n",
  "PYROCATECHOLS": "PYROCATECHOL, another name for catechol, also PYROCATECHIN [n]\n",
  "PYROCERAM": "(tradename) a strong heat-resistant glass [n -S]\n",
  "PYROCERAMS": "PYROCERAM, (tradename) a strong heat-resistant glass [n]\n",
  "PYROCHEMICAL": "relating to chemical changes at high temperatures [adj PYROCHEMICALLY]\n",
  "PYROCHEMICALLY": "PYROCHEMICAL, relating to chemical changes at high temperatures [adv]\n",
  "PYROCLAST": "ash and other debris ejected by a volcano [n -S]\n",
  "PYROCLASTIC": "of rocks, formed of fragments thrown out by volcanic action [adj] / a rock formed in this way [n -S]\n",
  "PYROCLASTICS": "PYROCLASTIC, a rock formed in this way [n]\n",
  "PYROCLASTS": "PYROCLAST, ash and other debris ejected by a volcano [n]\n",
  "PYROELECTRIC": "of, concerned with, or exhibiting pyroelectricity [adj] / a pyroelectric substance [n -S]\n",
  "PYROELECTRICITY": "electric charge produced in some crystals by temperature changes [n]\n",
  "PYROELECTRICS": "PYROELECTRIC, a pyroelectric substance [n]\n",
  "PYROGALLATE": "any salt or ester of pyrogallol [n -S]\n",
  "PYROGALLATES": "PYROGALLATE, any salt or ester of pyrogallol [n]\n",
  "PYROGALLIC": "relating to pyrogallol [adj]\n",
  "PYROGALLOL": "pyrogallic acid [n -S]\n",
  "PYROGALLOLS": "PYROGALLOL, pyrogallic acid [n]\n",
  "PYROGEN": "a substance that produces fever [n -S]\n",
  "PYROGENETIC": "produced by, or producing, heat or fever, also PYROGENIC, PYROGENOUS [adj]\n",
  "PYROGENIC": "produced by, or producing, heat or fever, also PYROGENETIC, PYROGENOUS [adj]\n",
  "PYROGENICITIES": "PYROGENICITY, the state of being pyrogenic [n]\n",
  "PYROGENICITY": "the state of being pyrogenic [n PYROGENICITIES]\n",
  "PYROGENOUS": "produced by, or producing, heat or fever, also PYROGENETIC, PYROGENIC [adj]\n",
  "PYROGENS": "PYROGEN, a substance that produces fever [n]\n",
  "PYROGIES": "PYROGY, (Russian) a small dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIEROGI, PIROGI, PYROHY [n]\n",
  "PYROGNOSTIC": "relating to the testing of minerals by flame [adj]\n",
  "PYROGNOSTICS": "the characteristics of a mineral, such as fusibility, that are revealed by the application of heat [n]\n",
  "PYROGRAPHER": "one who practises pyrography [n -S]\n",
  "PYROGRAPHERS": "PYROGRAPHER, one who practises pyrography [n]\n",
  "PYROGRAPHIC": "relating to pyrography [adj]\n",
  "PYROGRAPHIES": "PYROGRAPHY, the tracing of designs by burning [n]\n",
  "PYROGRAPHY": "the tracing of designs by burning [n PYROGRAPHIES]\n",
  "PYROGRAVURE": "design traced by pyrography [n -S]\n",
  "PYROGRAVURES": "PYROGRAVURE, design traced by pyrography [n]\n",
  "PYROGY": "(Russian) a small dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIEROGI, PIROGI, PYROHY [n PYROGIES]\n",
  "PYROHIES": "PYROHY, (Russian) a small dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIEROGI, PIROGI, PYROGY [n]\n",
  "PYROHY": "(Russian) a small dumpling with a filling, also PEROGI, PEROGIE, PEROGY, PIEROGI, PIROGI, PYROGY [n PYROHIES]\n",
  "PYROKINESES": "PYROKINESIS, the ability to start fires using mind alone [n]\n",
  "PYROKINESIS": "the ability to start fires using mind alone [n PYROKINESES]\n",
  "PYROLA": "(Latin) any plant of the wintergreen genus [n -S]\n",
  "PYROLAS": "PYROLA, (Latin) any plant of the wintergreen genus [n]\n",
  "PYROLATER": "a fire-worshipper [n -S]\n",
  "PYROLATERS": "PYROLATER, a fire-worshipper [n]\n",
  "PYROLATRIES": "PYROLATRY, fire-worship [n]\n",
  "PYROLATRY": "fire-worship [n PYROLATRIES]\n",
  "PYROLIGNEOUS": "produced by the action of heat on wood, also PYROLIGNIC, PYROXYLIC [adj]\n",
  "PYROLIGNIC": "produced by the action of heat on wood, also PYROLIGNEOUS, PYROXYLIC [adj]\n",
  "PYROLISE": "to decompose by heating, also PYROLIZE, PYROLYSE, PYROLYZE [v PYROLISED, PYROLISING, PYROLISES]\n",
  "PYROLISED": "PYROLISE, to decompose by heating, also PYROLIZE, PYROLYSE, PYROLYZE [v]\n",
  "PYROLISES": "PYROLISE, to decompose by heating, also PYROLIZE, PYROLYSE, PYROLYZE [v]\n",
  "PYROLISING": "PYROLISE, to decompose by heating, also PYROLIZE, PYROLYSE, PYROLYZE [v]\n",
  "PYROLIZE": "to decompose by heating, also PYROLISE, PYROLYSE, PYROLYZE [v PYROLIZED, PYROLIZING, PYROLIZES]\n",
  "PYROLIZED": "PYROLIZE, to decompose by heating, also PYROLISE, PYROLYSE, PYROLYZE [v]\n",
  "PYROLIZES": "PYROLIZE, to decompose by heating, also PYROLISE, PYROLYSE, PYROLYZE [v]\n",
  "PYROLIZING": "PYROLIZE, to decompose by heating, also PYROLISE, PYROLYSE, PYROLYZE [v]\n",
  "PYROLOGIES": "PYROLOGY, the scientific examination of materials by heat [n]\n",
  "PYROLOGY": "the scientific examination of materials by heat [n PYROLOGIES]\n",
  "PYROLUSITE": "native manganese dioxide, a black or dark-grey tetragonal mineral with a metallic lustre [n -S]\n",
  "PYROLUSITES": "PYROLUSITE, native manganese dioxide, a black or dark-grey tetragonal mineral with a metallic lustre [n]\n",
  "PYROLYSABLE": "that can be pyrolysed, also PYROLYZABLE [adj]\n",
  "PYROLYSATE": "a product of pyrolysis, also PYROLYZATE [n -S]\n",
  "PYROLYSATES": "PYROLYSATE, a product of pyrolysis, also PYROLYZATE [n]\n",
  "PYROLYSE": "to decompose by heating, also PYROLIZE, PYROLISE, PYROLYZE [v PYROLYSED, PYROLYSING, PYROLYSES]\n",
  "PYROLYSED": "PYROLYSE, to decompose by heating, also PYROLIZE, PYROLISE, PYROLYZE [v]\n",
  "PYROLYSER": "a device for pyrolysing [n -S]\n",
  "PYROLYSERS": "PYROLYSER, a device for pyrolysing [n]\n",
  "PYROLYSES": "PYROLYSE, to decompose by heating, also PYROLIZE, PYROLISE, PYROLYZE [v]\n",
  "PYROLYSING": "PYROLYSE, to decompose by heating, also PYROLIZE, PYROLISE, PYROLYZE [v]\n",
  "PYROLYSIS": "decomposition due to heat [n PYROLYSES]\n",
  "PYROLYTIC": "relating to pyrolysis, decomposition due to heat [adj PYROLYTICALLY]\n",
  "PYROLYTICALLY": "PYROLYTIC, relating to pyrolysis, decomposition due to heat [adv]\n",
  "PYROLYZABLE": "that can be pyrolysed, also PYROLYSABLE [adj]\n",
  "PYROLYZATE": "a product of pyrolysis, also PYROLYSATE [n -S]\n",
  "PYROLYZATES": "PYROLYZATE, a product of pyrolysis, also PYROLYSATE [n]\n",
  "PYROLYZE": "to decompose by heating, also PYROLISE, PYROLIZE, PYROLYSE [v PYROLYZED, PYROLYZING, PYROLYZES]\n",
  "PYROLYZED": "PYROLYZE, to decompose by heating, also PYROLISE, PYROLIZE, PYROLYSE [v]\n",
  "PYROLYZER": "an agent that pyrolyzes [n -S]\n",
  "PYROLYZERS": "PYROLYZER, an agent that pyrolyzes [n]\n",
  "PYROLYZES": "PYROLYZE, to decompose by heating, also PYROLISE, PYROLIZE, PYROLYSE [v]\n",
  "PYROLYZING": "PYROLYZE, to decompose by heating, also PYROLISE, PYROLIZE, PYROLYSE [v]\n",
  "PYROMAGNETIC": "of or concerned with the relationship between heat and magnetism [adj]\n",
  "PYROMANCER": "one who engages in pyromancy, divination by the use of fire [n -S]\n",
  "PYROMANCERS": "PYROMANCER, one who engages in pyromancy, divination by the use of fire [n]\n",
  "PYROMANCIES": "PYROMANCY, divination by the use of fire [n]\n",
  "PYROMANCY": "divination by the use of fire [n PYROMANCIES]\n",
  "PYROMANIA": "an obsessive urge to set fire to things [n -S]\n",
  "PYROMANIAC": "a sufferer from pyromania, an obsessive urge to set fire to things [n -S]\n",
  "PYROMANIACAL": "relating to pyromania [adj]\n",
  "PYROMANIACS": "PYROMANIAC, a sufferer from pyromania, an obsessive urge to set fire to things [n]\n",
  "PYROMANIAS": "PYROMANIA, an obsessive urge to set fire to things [n]\n",
  "PYROMANTIC": "of or pertaining to pyromancy [adj]\n",
  "PYROMERIDE": "a nodular rhyolite [n -S]\n",
  "PYROMERIDES": "PYROMERIDE, a nodular rhyolite [n]\n",
  "PYROMETALLURGY": "chemical metallurgy depending on heat action (as roasting and smelting) [adj]\n",
  "PYROMETER": "an instrument for measuring very high temperatures [n -S]\n",
  "PYROMETERS": "PYROMETER, an instrument for measuring very high temperatures [n]\n",
  "PYROMETRIC": "relating to pyrometry, the art of measuring degrees of heat, or the expansion of bodies by heat, also PYROMETRICAL [adj PYROMETRICALLY]\n",
  "PYROMETRICAL": "relating to pyrometry, the art of measuring degrees of heat, or the expansion of bodies by heat, also PYROMETRIC [adj PYROMETRICALLY]\n",
  "PYROMETRICALLY": "PYROMETRICAL, relating to pyrometry, the art of measuring degrees of heat, or the expansion of bodies by heat, also PYROMETRIC [adv]\n",
  "PYROMETRIES": "PYROMETRY, the art of measuring degrees of heat, or the expansion of bodies by heat [n]\n",
  "PYROMETRY": "the art of measuring degrees of heat, or the expansion of bodies by heat [n PYROMETRIES]\n",
  "PYROMORPHITE": "a green, brown, or yellow lead ore [n -S]\n",
  "PYROMORPHITES": "PYROMORPHITE, a green, brown, or yellow lead ore [n]\n",
  "PYRONE": "a type of carbon compound [n -S]\n",
  "PYRONES": "PYRONE, a type of carbon compound [n]\n",
  "PYRONIN": "either of two synthetic red xanthene dyes, also PYRONINE [n -S]\n",
  "PYRONINE": "(tradename) any of several xanthene dyes, also PYRONIN [n -S]\n",
  "PYRONINES": "PYRONINE, (tradename) any of several xanthene dyes, also PYRONIN [n]\n",
  "PYRONINOPHILIC": "having an affinity for pyronine, any of several xanthene dyes [adj]\n",
  "PYRONINS": "PYRONIN, either of two synthetic red xanthene dyes, also PYRONINE [n]\n",
  "PYROPE": "(Greek) a fiery red gemstone, a variety of garnet, also PYROPUS [n -S]\n",
  "PYROPES": "PYROPE, (Greek) a fiery red gemstone, a variety of garnet, also PYROPUS [n]\n",
  "PYROPHOBIA": "fear of fire [n -S]\n",
  "PYROPHOBIAS": "PYROPHOBIA, fear of fire [n]\n",
  "PYROPHOBIC": "one having an irrational fear of fires [n -S]\n",
  "PYROPHOBICS": "PYROPHOBIC, one having an irrational fear of fires [n]\n",
  "PYROPHONE": "an organ producing interference-tones by pairs of flames in tubes [n -S]\n",
  "PYROPHONES": "PYROPHONE, an organ producing interference-tones by pairs of flames in tubes [n]\n",
  "PYROPHORIC": "spontaneously igniting in air, also PYROPHOROUS [adj]\n",
  "PYROPHOROUS": "spontaneously igniting in air, also PYROPHORIC [adj]\n",
  "PYROPHORUS": "any substance capable of igniting spontaneously on exposure to air [n -ES]\n",
  "PYROPHORUSES": "PYROPHORUS, any substance capable of igniting spontaneously on exposure to air [n]\n",
  "PYROPHOSPHATE": "a salt or ester of pyrophosphoric acid [n -S]\n",
  "PYROPHOSPHATES": "PYROPHOSPHATE, a salt or ester of pyrophosphoric acid [n]\n",
  "PYROPHOSPHORIC": "as in pyrophosphoric acid, a type of acid [adj]\n",
  "PYROPHOTOGRAPH": "a burnt-in photograph, e.g. on glass or porcelain [n -S]\n",
  "PYROPHOTOGRAPHS": "PYROPHOTOGRAPH, a burnt-in photograph, e.g. on glass or porcelain [n]\n",
  "PYROPHOTOGRAPHY": "the production of pyrophotographs [n]\n",
  "PYROPHOTOMETER": "a type of pyrometer in which the temperature of an incandescent body is determined by photometric measurement of the light it emits [n -S]\n",
  "PYROPHOTOMETERS": "PYROPHOTOMETER, a type of pyrometer in which the temperature of an incandescent body is determined by photometric measurement of the light it emits [n]\n",
  "PYROPHOTOMETRY": "the measurement of the temperature of an incandescent body by photometric measurement of the light it emits [n]\n",
  "PYROPHYLLITE": "a silvery-white to pale-green aluminum silicate [n -S]\n",
  "PYROPHYLLITES": "PYROPHYLLITE, a silvery-white to pale-green aluminum silicate [n]\n",
  "PYROPUS": "a fiery red gemstone, a variety of garnet, also PYROPE [n -ES]\n",
  "PYROPUSES": "PYROPUS, a fiery red gemstone, a variety of garnet, also PYROPE [n]\n",
  "PYROS": "PYRO, (short for) pyrogallol, a chemical used in photography [n]\n",
  "PYROSCOPE": "an instrument for measuring intensity of radiant heat [n -S]\n",
  "PYROSCOPES": "PYROSCOPE, an instrument for measuring intensity of radiant heat [n]\n",
  "PYROSES": "PYROSIS, (Greek) heartburn [n]\n",
  "PYROSIS": "(Greek) heartburn [n PYROSISES or PYROSES]\n",
  "PYROSISES": "PYROSIS, (Greek) heartburn [n]\n",
  "PYROSOME": "a type of thermostat [n -S]\n",
  "PYROSOMES": "PYROSOME, a type of thermostat [n]\n",
  "PYROSTAT": "an automatic fire-alarm and extinguisher; a thermostat [n -S]\n",
  "PYROSTATIC": "relating to a pyrostat, a thermostat used at high temperatures [adj]\n",
  "PYROSTATS": "PYROSTAT, an automatic fire-alarm and extinguisher; a thermostat [n]\n",
  "PYROSULFITE": "as in sodium pyrosulfite, an inorganic compound used as a preservative, antioxidant and disinfectant [n -S]\n",
  "PYROSULFITES": "PYROSULFITE, as in sodium pyrosulfite, an inorganic compound used as a preservative, antioxidant and disinfectant [n]\n",
  "PYROSULPHATE": "a salt of sulphur [n -S]\n",
  "PYROSULPHATES": "PYROSULPHATE, a salt of sulphur [n]\n",
  "PYROSULPHURIC": "as in pyrosulphuric acid, a type of acid [adj]\n",
  "PYROTARTARIC": "as in pyrotartaric acid [adj]\n",
  "PYROTARTRATE": "a salt of tartaric acid [n -S]\n",
  "PYROTARTRATES": "PYROTARTRATE, a salt of tartaric acid [n]\n",
  "PYROTECHNIC": "relating to pyrotechnics, the art of making fireworks, also PYROTECHNICAL [adj PYROTECHNICALLY]\n",
  "PYROTECHNICAL": "relating to pyrotechnics, the art of making fireworks, also PYROTECHNIC [adj PYROTECHNICALLY]\n",
  "PYROTECHNICALLY": "PYROTECHNICAL, relating to pyrotechnics, the art of making fireworks, also PYROTECHNIC [adv]\n",
  "PYROTECHNICIAN": "one who makes fireworks [n -S]\n",
  "PYROTECHNICIANS": "PYROTECHNICIAN, one who makes fireworks [n]\n",
  "PYROTECHNICS": "the art of making fireworks [n]\n",
  "PYROTECHNIES": "PYROTECHNY, the use and application of fire in science and the arts [n]\n",
  "PYROTECHNIST": "a firework maker [n -S]\n",
  "PYROTECHNISTS": "PYROTECHNIST, a firework maker [n]\n",
  "PYROTECHNY": "the use and application of fire in science and the arts [n PYROTECHNIES]\n",
  "PYROVANADIC": "pertaining to, or designating, an acid of vanadium [adj]\n",
  "PYROXENE": "any of a group of minerals common in igneous rocks [n -S]\n",
  "PYROXENES": "PYROXENE, any of a group of minerals common in igneous rocks [n]\n",
  "PYROXENIC": "containing pyroxene [adj]\n",
  "PYROXENITE": "a rock consisting essentially of pyroxene [n -S]\n",
  "PYROXENITES": "PYROXENITE, a rock consisting essentially of pyroxene [n]\n",
  "PYROXENITIC": "of or like pyroxene [adj]\n",
  "PYROXENOID": "a mineral like pyroxene, a common mineral occurring in monoclinic crystals [n -S]\n",
  "PYROXENOIDS": "PYROXENOID, a mineral like pyroxene, a common mineral occurring in monoclinic crystals [n]\n",
  "PYROXYLE": "a nitrocellulose [n -S]\n",
  "PYROXYLES": "PYROXYLE, a nitrocellulose [n]\n",
  "PYROXYLIC": "produced by the action of heat on wood, also PYROLIGNEOUS, PYROLIGNIC [adj]\n",
  "PYROXYLIN": "any of the nitrocelluloses, also PYROXYLE, PYROXYLINE [n -S]\n",
  "PYROXYLINE": "any of the nitrocelluloses, also PYROXYLE, PYROXYLIN [n -S]\n",
  "PYROXYLINES": "PYROXYLINE, any of the nitrocelluloses, also PYROXYLE, PYROXYLIN [n]\n",
  "PYROXYLINS": "PYROXYLIN, any of the nitrocelluloses, also PYROXYLE, PYROXYLINE [n]\n",
  "PYRRHIC": "(Greek) an ancient Greek war dance [n -S]\n",
  "PYRRHICIST": "(historical) one who danced the pyrrhic [n -S]\n",
  "PYRRHICISTS": "PYRRHICIST, (historical) one who danced the pyrrhic [n]\n",
  "PYRRHICS": "PYRRHIC, (Greek) an ancient Greek war dance [n]\n",
  "PYRRHOTINE": "magnetic pyrites, an iron sulphide, often containing nickel, also PYRRHOTITE [n -S]\n",
  "PYRRHOTINES": "PYRRHOTINE, magnetic pyrites, an iron sulphide, often containing nickel, also PYRRHOTITE [n]\n",
  "PYRRHOTITE": "magnetic pyrites, an iron sulphide, often containing nickel, also PYRRHOTINE [n -S]\n",
  "PYRRHOTITES": "PYRRHOTITE, magnetic pyrites, an iron sulphide, often containing nickel, also PYRRHOTINE [n]\n",
  "PYRRHOUS": "reddish; ruddy [adj]\n",
  "PYRRHULOXIA": "a grey-and-pink crested bunting of Central and SW North America, with a short parrot-like bill [n -S]\n",
  "PYRRHULOXIAS": "PYRRHULOXIA, a grey-and-pink crested bunting of Central and SW North America, with a short parrot-like bill [n]\n",
  "PYRROL": "a colourless toxic liquid found in many naturally occurring compounds, e.g. chlorophyll, also PYRROLE [n -S]\n",
  "PYRROLE": "a colourless toxic liquid found in many naturally occurring compounds, e.g. chlorophyll, also PYRROL [n -S]\n",
  "PYRROLES": "PYRROLE, a colourless toxic liquid found in many naturally occurring compounds, e.g. chlorophyll, also PYRROL [n]\n",
  "PYRROLIC": "of or like pyrrole, a colourless toxic liquid found in many naturally occurring compounds [adj]\n",
  "PYRROLIDINE": "a colourless strongly alkaline heterocyclic base both occurring naturally and produced from pyrrole [n -S]\n",
  "PYRROLIDINES": "PYRROLIDINE, a colourless strongly alkaline heterocyclic base both occurring naturally and produced from pyrrole [n]\n",
  "PYRROLS": "PYRROL, a colourless toxic liquid found in many naturally occurring compounds, e.g. chlorophyll, also PYRROLE [n]\n",
  "PYRUVATE": "a salt or ester of pyruvic acid [n -S]\n",
  "PYRUVATES": "PYRUVATE, a salt or ester of pyruvic acid [n]\n",
  "PYRUVIC": "as in pyruvic acid [adj]\n",
  "PYSANKA": "(Russian) a hand-painted Ukrainian Easter Egg [n PYSANKY]\n",
  "PYSANKY": "PYSANKA, (Russian) a hand-painted Ukrainian Easter Egg [n]\n",
  "PYTHIUM": "a fungus of the genus Pythium [n -S]\n",
  "PYTHIUMS": "PYTHIUM, a fungus of the genus Pythium [n]\n",
  "PYTHOGENIC": "produced by filth; causing dirt or decay [adj]\n",
  "PYTHON": "a large snake [n -S]\n",
  "PYTHONESS": "a witch (with capital, the priestess who gave oracular answers at Delphi in Greece) [n -ES]\n",
  "PYTHONESSES": "PYTHONESS, a witch (with capital, the priestess who gave oracular answers at Delphi in Greece) [n]\n",
  "PYTHONIC": "like an oracle or a python [adj]\n",
  "PYTHONOMORPH": "a large marine reptile of the Cretaceous period, with long, scaly body and paddle-shaped limbs [n -S]\n",
  "PYTHONOMORPHS": "PYTHONOMORPH, a large marine reptile of the Cretaceous period, with long, scaly body and paddle-shaped limbs [n]\n",
  "PYTHONS": "PYTHON, a large snake [n]\n",
  "PYURIA": "the presence of pus in the urine [n -S]\n",
  "PYURIAS": "PYURIA, the presence of pus in the urine [n]\n",
  "PYX": "to test newly minted coins [v -ED, -ING, -ES]\n",
  "PYXED": "PYX, to test newly minted coins [v]\n",
  "PYXES": "PYX, to test newly minted coins [v]\n",
  "PYXIDES": "PYXIS, (Latin) a little box for jewels [n]\n",
  "PYXIDIA": "PYXIDIUM, a capsule that opens by a transverse circular split [n]\n",
  "PYXIDIUM": "a capsule that opens by a transverse circular split [n PYXIDIA]\n",
  "PYXIE": "a creeping evergreen shrub having small white or pinkish flowers, native to pine barrens of the eastern United States [n -S]\n",
  "PYXIES": "PYXIE, a creeping evergreen shrub having small white or pinkish flowers, native to pine barrens of the eastern United States [n]\n",
  "PYXING": "PYX, to test newly minted coins [v]\n",
  "PYXIS": "(Latin) a little box for jewels [n PYXIDES]\n",
  "PZAZZ": "panache, flamboyance, also BAZAZZ, BEZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZZ [n -ES]\n",
  "PZAZZES": "PZAZZ, panache, flamboyance, also BAZAZZ, BEZAZZ, BIZAZZ, PAZAZZ, PAZZAZZ, PIZAZZ, PIZZAZZ [n]\n",
  "QABALA": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALAH [n -S]\n",
  "QABALAH": "(Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALA [n -S]\n",
  "QABALAHS": "QABALAH, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALA [n]\n",
  "QABALAS": "QABALA, (Hebrew) a Jewish doctrine based on hidden meanings in sacred texts, also CABALA, CABBALA, CABBALAH, KABALA, KABBALA, KABBALAH, QABALAH [n]\n",
  "QABALISM": "a sect based on qabala, also KABALISM, KABBALISM, CABALISM, CABBALISM [n -S]\n",
  "QABALISMS": "QABALISM, a sect based on qabala, also KABALISM, KABBALISM, CABALISM, CABBALISM [n]\n",
  "QABALIST": "(Hebrew) one who practises cabalism, also CABALIST, CABBALIST, KABALIST, KABBALIST [n -S]\n",
  "QABALISTIC": "relating to the qabala, a mystical tradition of Jewish rabbis [adj]\n",
  "QABALISTS": "QABALIST, (Hebrew) one who practises cabalism, also CABALIST, CABBALIST, KABALIST, KABBALIST [n]\n",
  "QADI": "(Arabic) a civil judge in a Muslim country, also CADI, CAID, KADI, KAID, QAID [n -S]\n",
  "QADIS": "QADI, (Arabic) a civil judge in a Muslim country, also CADI, CAID, KADI, KAID, QAID [n]\n",
  "QAID": "(Arabic) a civil judge in a Muslim country, also CADI, CAID, KADI, KAID, QADI [n -S]\n",
  "QAIDS": "QAID, (Arabic) a civil judge in a Muslim country, also CADI, CAID, KADI, KAID, QADI [n]\n",
  "QAIMAQAM": "(Turkish) a Turkish governor, also CAIMAC, CAIMACAM, KAIMAKAM [n -S]\n",
  "QAIMAQAMS": "QAIMAQAM, (Turkish) a Turkish governor, also CAIMAC, CAIMACAM, KAIMAKAM [n]\n",
  "QAJAQ": "(Inuit) a kayak, also KAIAK, KAYAK, KYAK [n -S]\n",
  "QAJAQS": "QAJAQ, (Inuit) a kayak, also KAIAK, KAYAK, KYAK [n]\n",
  "QALAMDAN": "(Persian) a Persian writing-case, also KALAMDAN [n -S]\n",
  "QALAMDANS": "QALAMDAN, (Persian) a Persian writing-case, also KALAMDAN [n]\n",
  "QAMUTIK": "(Inuit) a sled with wooden runners, also COMATIK, KAMOTIK, KAMOTIQ, KOMATIK [n -S]\n",
  "QAMUTIKS": "QAMUTIK, (Inuit) a sled with wooden runners, also COMATIK, KAMOTIK, KAMOTIQ, KOMATIK [n]\n",
  "QANAT": "(Arabic) an underground water tunnel [n -S]\n",
  "QANATS": "QANAT, (Arabic) an underground water tunnel [n]\n",
  "QAPIK": "(Azerbaijani) a monetary unit of Azerbaijan, one hundredth of a manat, also GOPIK [n -S]\n",
  "QAPIKS": "QAPIK, (Azerbaijani) a monetary unit of Azerbaijan, one hundredth of a manat, also GOPIK [n]\n",
  "QASIDA": "(Arabic) an Arabic poem of praise or mourning [n -S]\n",
  "QASIDAS": "QASIDA, (Arabic) an Arabic poem of praise or mourning [n]\n",
  "QAT": "(Arabic) a shrub of East Africa, Arabia, etc., or its leaves, chewed or taken as tea for their stimulant effect, also KAT, KHAT [n -S]\n",
  "QATS": "QAT, (Arabic) a shrub of East Africa, Arabia, etc., or its leaves, chewed or taken as tea for their stimulant effect, also KAT, KHAT [n]\n",
  "QAWWAL": "(Arabic) a singer of qawwali, devotional Sufi music [n -S]\n",
  "QAWWALI": "(Arabic) a form of devotional Sufi music [n -S]\n",
  "QAWWALIS": "QAWWALI, (Arabic) a form of devotional Sufi music [n]\n",
  "QAWWALS": "QAWWAL, (Arabic) a singer of qawwali, devotional Sufi music [n]\n",
  "QI": "(Chinese) a life force, also KI [n -S]\n",
  "QIBLA": "(Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KEBLAH, KIBLA, KIBLAH [n -S]\n",
  "QIBLAS": "QIBLA, (Arabic) the direction of the place to which Muslims must turn for prayer, now the Kaaba at Mecca, also KEBLAH, KIBLA, KIBLAH [n]\n",
  "QIGONG": "(Chinese) a system of Chinese meditative exercises [n -S]\n",
  "QIGONGS": "QIGONG, (Chinese) a system of Chinese meditative exercises [n]\n",
  "QIN": "(Chinese) a kind of Chinese zither with silken strings, also GUQIN [n -S]\n",
  "QINDAR": "(Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINTAR, QUINTAR [n QINDARS or QINDARKA]\n",
  "QINDARKA": "QINDAR, (Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINTAR, QUINTAR [n]\n",
  "QINDARS": "QINDAR, (Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINTAR, QUINTAR [n]\n",
  "QINGHAOSU": "(Chinese) a crystalline compound obtained from artemisia [n -S]\n",
  "QINGHAOSUS": "QINGHAOSU, (Chinese) a crystalline compound obtained from artemisia [n]\n",
  "QINS": "QIN, (Chinese) a kind of Chinese zither with silken strings, also GUQIN [n]\n",
  "QINTAR": "(Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINDAR, QUINTAR [n QINTARKA or QINTARS]\n",
  "QINTARKA": "QINTAR, (Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINDAR, QUINTAR [n]\n",
  "QINTARS": "QINTAR, (Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINDAR, QUINTAR [n]\n",
  "QIS": "QI, (Chinese) a life force, also KI [n]\n",
  "QIVIUT": "(Inuit) the fine, soft, light-brown under layer of hair on the musk ox [n -S]\n",
  "QIVIUTS": "QIVIUT, (Inuit) the fine, soft, light-brown under layer of hair on the musk ox [n]\n",
  "QOPH": "(Hebrew) a Hebrew letter, also KOPH [n -S]\n",
  "QOPHS": "QOPH, (Hebrew) a Hebrew letter, also KOPH [n]\n",
  "QORMA": "(Hindi) a mild curry, also KORMA [n -S]\n",
  "QORMAS": "QORMA, (Hindi) a mild curry, also KORMA [n]\n",
  "QUA": "(Latin) the capacity of [adv]\n",
  "QUAALUDE": "(tradename) a type of sedative, aka methaqualone [n -S]\n",
  "QUAALUDES": "QUAALUDE, (tradename) a type of sedative, aka methaqualone [n]\n",
  "QUACK": "to make the sound of a duck [v -ED, -ING, -S]\n",
  "QUACKED": "QUACK, to make the sound of a duck [v]\n",
  "QUACKER": "one who quacks [n -S]\n",
  "QUACKERIES": "QUACKERY, the practise of a charlatan, also QUACKISM [n]\n",
  "QUACKERS": "QUACKER, one who quacks [n]\n",
  "QUACKERY": "the practise of a charlatan, also QUACKISM [n QUACKERIES]\n",
  "QUACKIER": "QUACKY, resembling the cry of a duck [adj]\n",
  "QUACKIEST": "QUACKY, resembling the cry of a duck [adj]\n",
  "QUACKING": "QUACK, to make the sound of a duck [v]\n",
  "QUACKISH": "fraudulent [adj]\n",
  "QUACKISM": "the practise of a charlatan, also QUACKERY [n -S]\n",
  "QUACKISMS": "QUACKISM, the practise of a charlatan, also QUACKERY [n]\n",
  "QUACKLE": "to choke; to suffocate [v QUACKLED, QUACKLING, QUACKLES]\n",
  "QUACKLED": "QUACKLE, to choke; to suffocate [v]\n",
  "QUACKLES": "QUACKLE, to choke; to suffocate [v]\n",
  "QUACKLING": "QUACKLE, to choke; to suffocate [v]\n",
  "QUACKS": "QUACK, to make the sound of a duck [v]\n",
  "QUACKSALVER": "(archaic) a quack [n -S]\n",
  "QUACKSALVERS": "QUACKSALVER, (archaic) a quack [n]\n",
  "QUACKSALVING": "(obsolete) like a quacksalver, a charlatan [adj]\n",
  "QUACKY": "resembling the cry of a duck [adj QUACKIER, QUACKIEST]\n",
  "QUAD": "to space by means of quadrats [v QUADDED, QUADDING, QUADS]\n",
  "QUADCOPTER": "a pilotless four-rotor helicopter [n -S]\n",
  "QUADCOPTERS": "QUADCOPTER, a pilotless four-rotor helicopter [n]\n",
  "QUADDED": "QUAD, to space by means of quadrats [v]\n",
  "QUADDING": "the practice of birdwatching in a specific area [n -S]\n",
  "QUADDINGS": "QUADDING, the practice of birdwatching in a specific area [n]\n",
  "QUADPLAY": "the supply to a customer by one provider of television, internet and both fixed-line and mobile telephony, also FOURPLAY [n -S]\n",
  "QUADPLAYS": "QUADPLAY, the supply to a customer by one provider of television, internet and both fixed-line and mobile telephony, also FOURPLAY [n]\n",
  "QUADPLEX": "a building having four units, also FOURPLEX [n -ES]\n",
  "QUADPLEXES": "QUADPLEX, a building having four units, also FOURPLEX [n]\n",
  "QUADRAGENARIAN": "a person who is forty years old, or between forty and fifty [n -S]\n",
  "QUADRAGENARIANS": "QUADRAGENARIAN, a person who is forty years old, or between forty and fifty [n]\n",
  "QUADRAGESIMAL": "consisting of 40; specifically, in regard to a 40-day fast occurring during Lent [adj]\n",
  "QUADRANGLE": "a plane figure with four angles (and therefore four sides) [n -S]\n",
  "QUADRANGLES": "QUADRANGLE, a plane figure with four angles (and therefore four sides) [n]\n",
  "QUADRANGULAR": "like a quadrangle [adj QUADRANGULARLY]\n",
  "QUADRANGULARLY": "QUADRANGULAR, like a quadrangle [adv]\n",
  "QUADRANS": "(Latin) a Roman coin, a fourth part of an as [n QUADRANTES]\n",
  "QUADRANT": "a quarter section of a circle [n -S]\n",
  "QUADRANTAL": "of or pertaining to a quadrant [adj]\n",
  "QUADRANTES": "QUADRANS, (Latin) a Roman coin, a fourth part of an as [n]\n",
  "QUADRANTS": "QUADRANT, a quarter section of a circle [n]\n",
  "QUADRAPHONIC": "of, relating to, or using four channels for the transmission, recording, or reproduction of sound, also QUADRIPHONIC, QUADROPHONIC [adj]\n",
  "QUADRAPHONICS": "a system of sound transmission using a minimum of four speakers, also QUADRAPHONY, QUADRIPHONICS, QUADROPHONICS, QUADROPHONY [n]\n",
  "QUADRAPHONIES": "QUADRAPHONY, a system of sound transmission using four speakers, also QUADRAPHONICS, QUADRIPHONICS, QUADROPHONICS, QUADROPHONY [n]\n",
  "QUADRAPHONY": "a system of sound transmission using four speakers, also QUADRAPHONICS, QUADRIPHONICS, QUADROPHONICS, QUADROPHONY [n QUADRAPHONIES]\n",
  "QUADRAPLEGIA": "paralysis of both arms and both legs, also QUADRIPLEGIA, TETRAPLEGIA [n -S]\n",
  "QUADRAPLEGIAS": "QUADRAPLEGIA, paralysis of both arms and both legs, also QUADRIPLEGIA, TETRAPLEGIA [n]\n",
  "QUADRAPLEGIC": "one suffering from quadriplegia, paralysis of both arms and both legs, also QUADRIPLEGIC [n -S]\n",
  "QUADRAPLEGICS": "QUADRAPLEGIC, one suffering from quadriplegia, paralysis of both arms and both legs, also QUADRIPLEGIC [n]\n",
  "QUADRASONIC": "relating to a system of sound recording and reproduction that uses four independent loudspeakers to give directional sources of sound [adj]\n",
  "QUADRASONICS": "a system of sound recording and reproduction that uses four independent loudspeakers to give directional sources of sound [n]\n",
  "QUADRAT": "a piece of type metal used for spacing [n -S]\n",
  "QUADRATE": "to conform or agree [v QUADRATED, QUADRATING, QUADRATES]\n",
  "QUADRATED": "QUADRATE, to conform or agree [v]\n",
  "QUADRATES": "QUADRATE, to conform or agree [v]\n",
  "QUADRATI": "QUADRATUS, the name of several quadrangular muscles [n]\n",
  "QUADRATIC": "involving the square but no higher power, also QUADRATICAL [adj QUADRATICALLY] / a quadratic equation [n -S]\n",
  "QUADRATICAL": "involving the square but no higher power, as a quadratic equation, also QUADRATIC [adj QUADRATICALLY]\n",
  "QUADRATICALLY": "QUADRATICAL, involving the square but no higher power, as a quadratic equation, also QUADRATIC [adv]\n",
  "QUADRATICS": "QUADRATIC, a quadratic equation [n]\n",
  "QUADRATING": "QUADRATE, to conform or agree [v]\n",
  "QUADRATRICES": "QUADRATRIX, a curve by which a circle may be squared [n]\n",
  "QUADRATRIX": "a curve by which a circle may be squared [n QUADRATRICES or QUADRATRIXES]\n",
  "QUADRATRIXES": "QUADRATRIX, a curve by which a circle may be squared [n]\n",
  "QUADRATS": "QUADRAT, a piece of type metal used for spacing [n]\n",
  "QUADRATURA": "(Italian) a wall or ceiling painted with arches and columns in strong perspective [n QUADRATURE]\n",
  "QUADRATURE": "the finding of a square having the same area as some given curvilinear figure [n -S]\n",
  "QUADRATURES": "QUADRATURE, the finding of a square having the same area as some given curvilinear figure [n]\n",
  "QUADRATUS": "the name of several quadrangular muscles [n QUADRATI or QUADRATUSES]\n",
  "QUADRATUSES": "QUADRATUS, the name of several quadrangular muscles [n]\n",
  "QUADRELLA": "(Australian) a group of four horse races at a meeting for which the punter has to select the four winners [n -S]\n",
  "QUADRELLAS": "QUADRELLA, (Australian) a group of four horse races at a meeting for which the punter has to select the four winners [n]\n",
  "QUADRENNIA": "QUADRENNIUM, (Latin) a period of four years, also QUADRIENNIUM [n]\n",
  "QUADRENNIAL": "lasting four years; occurring once every four years [adj QUADRENNIALLY] / an event taking place every four years [n -S]\n",
  "QUADRENNIALLY": "QUADRENNIAL, lasting four years; occurring once every four years [adv]\n",
  "QUADRENNIALS": "QUADRENNIAL, an event taking place every four years [n]\n",
  "QUADRENNIUM": "(Latin) a period of four years, also QUADRIENNIUM [n QUADRENNIA or QUADRENNIUMS]\n",
  "QUADRENNIUMS": "QUADRENNIUM, (Latin) a period of four years, also QUADRIENNIUM [n]\n",
  "QUADRIC": "of or pertaining to the second degree [adj] / a quadric curve [n -S]\n",
  "QUADRICEP": "the great extensor muscle of the knee, divided above into four parts which unite in a single tendon at the knee [n -S]\n",
  "QUADRICEPS": "the great extensor muscle of the knee, divided above into four parts which unite in a single tendon at the knee [n -ES]\n",
  "QUADRICEPSES": "QUADRICEPS, the great extensor muscle of the knee, divided above into four parts which unite in a single tendon at the knee [n]\n",
  "QUADRICIPITAL": "relating to the quadriceps, the great extensor muscle of the knee [adj]\n",
  "QUADRICONE": "a quadric cone, or cone having a conic as base [n -S]\n",
  "QUADRICONES": "QUADRICONE, a quadric cone, or cone having a conic as base [n]\n",
  "QUADRICS": "QUADRIC, a quadric curve [n]\n",
  "QUADRIENNIA": "QUADRIENNIUM, (Latin) a period of four years, also QUADRENNIUM [n]\n",
  "QUADRIENNIAL": "taking place every four years [adj]\n",
  "QUADRIENNIUM": "(Latin) a period of four years, also QUADRENNIUM [n QUADRIENNIA or QUADRIENNIUMS]\n",
  "QUADRIENNIUMS": "QUADRIENNIUM, (Latin) a period of four years, also QUADRENNIUM [n]\n",
  "QUADRIFARIOUS": "arranged in four close-set rows along the stem [adj]\n",
  "QUADRIFID": "four-part (as with a leaf) [adj]\n",
  "QUADRIFOLIATE": "having four leaves [adj]\n",
  "QUADRIFORM": "having four forms or aspects [adj]\n",
  "QUADRIGA": "(Latin) a four-horse chariot [n QUADRIGAS or QUADRIGAE]\n",
  "QUADRIGAE": "QUADRIGA, (Latin) a four-horse chariot [n]\n",
  "QUADRIGAS": "QUADRIGA, (Latin) a four-horse chariot [n]\n",
  "QUADRIGEMINAL": "having four similar parts, also QUADRIGEMINATE, QUADRIGEMINOUS [adj]\n",
  "QUADRIGEMINATE": "having four similar parts, also QUADRIGEMINAL, QUADRIGEMINOUS [adj]\n",
  "QUADRIGEMINOUS": "having four similar parts, also QUADRIGEMINAL, QUADRIGEMINATE [adj]\n",
  "QUADRILATERAL": "a polygon of four sides [n -S]\n",
  "QUADRILATERALS": "QUADRILATERAL, a polygon of four sides [n]\n",
  "QUADRILINGUAL": "speaking four languages [adj]\n",
  "QUADRILITERAL": "consisting of four letters [adj] / a word of four letters [n -S]\n",
  "QUADRILITERALS": "QUADRILITERAL, a word of four letters [n]\n",
  "QUADRILLE": "(French) a square dance for four couples [n -S] / to dance the quadrille [v QUADRILLED, QUADRILLING, QUADRILLES]\n",
  "QUADRILLED": "QUADRILLE, to dance the quadrille [v]\n",
  "QUADRILLER": "one who dances the quadrille [n -S]\n",
  "QUADRILLERS": "QUADRILLER, one who dances the quadrille [n]\n",
  "QUADRILLES": "QUADRILLE, (French) a square dance for four couples [n]\n",
  "QUADRILLING": "QUADRILLE, to dance the quadrille [v]\n",
  "QUADRILLION": "a thousand raised to the fifth power [n -S]\n",
  "QUADRILLIONS": "QUADRILLION, a thousand raised to the fifth power [n]\n",
  "QUADRILLIONTH": "the ordinal of quadrillion [adj] / one of a quadrillion equal parts [n -S]\n",
  "QUADRILLIONTHS": "QUADRILLIONTH, one of a quadrillion equal parts [n]\n",
  "QUADRILOCULAR": "having four compartments [adj]\n",
  "QUADRINGENARIES": "QUADRINGENARY, a four-hundredth anniversary or its celebration [n]\n",
  "QUADRINGENARY": "a four-hundredth anniversary or its celebration [n QUADRINGENARIES]\n",
  "QUADRINOMIAL": "an expression of four terms [n -S]\n",
  "QUADRINOMIALS": "QUADRINOMIAL, an expression of four terms [n]\n",
  "QUADRIPARTITE": "pertaining to or for four parts or parties [adj]\n",
  "QUADRIPARTITION": "division into four parts [n]\n",
  "QUADRIPHONIC": "of, relating to, or using four channels for the transmission, recording, or reproduction of sound, also QUADRAPHONIC, QUADROPHONIC [adj]\n",
  "QUADRIPHONICS": "a system of sound transmission using a minimum of four speakers, also QUADRAPHONICS, QUADRAPHONY, QUADROPHONICS, QUADROPHONY [n]\n",
  "QUADRIPLEGIA": "paralysis of both arms and both legs, also TETRAPLEGIA [n -S]\n",
  "QUADRIPLEGIAS": "QUADRIPLEGIA, paralysis of both arms and both legs, also TETRAPLEGIA [n]\n",
  "QUADRIPLEGIC": "relating to quadriplegia, paralysis of both arms and both legs [adj] / one suffering from quadriplegia, also QUADRAPLEGIC [n -S]\n",
  "QUADRIPLEGICS": "QUADRIPLEGIC, one suffering from quadriplegia, also QUADRAPLEGIC [n]\n",
  "QUADRIPOLE": "a network with two input and two output terminals [n -S]\n",
  "QUADRIPOLES": "QUADRIPOLE, a network with two input and two output terminals [n]\n",
  "QUADRIREME": "an ancient ship with four banks of oars [n -S]\n",
  "QUADRIREMES": "QUADRIREME, an ancient ship with four banks of oars [n]\n",
  "QUADRISECT": "to divide into four equal parts [v -ED, -ING, -S]\n",
  "QUADRISECTED": "QUADRISECT, to divide into four equal parts [v]\n",
  "QUADRISECTING": "QUADRISECT, to divide into four equal parts [v]\n",
  "QUADRISECTION": "division into four equal parts [n -S]\n",
  "QUADRISECTIONS": "QUADRISECTION, division into four equal parts [n]\n",
  "QUADRISECTS": "QUADRISECT, to divide into four equal parts [v]\n",
  "QUADRISYLLABIC": "a word or poetic meter with four syllables [n -S]\n",
  "QUADRISYLLABICS": "QUADRISYLLABIC, a word or poetic meter with four syllables [n]\n",
  "QUADRISYLLABLE": "a tetrasyllable [n -S]\n",
  "QUADRISYLLABLES": "QUADRISYLLABLE, a tetrasyllable [n]\n",
  "QUADRIVALENCE": "the state of being quadrivalent, also QUADRIVALENCY [n -S]\n",
  "QUADRIVALENCES": "QUADRIVALENCE, the state of being quadrivalent, also QUADRIVALENCY [n]\n",
  "QUADRIVALENCIES": "QUADRIVALENCY, the state of being quadrivalent, also QUADRIVALENCE [n]\n",
  "QUADRIVALENCY": "the state of being quadrivalent, also QUADRIVALENCE [n QUADRIVALENCIES]\n",
  "QUADRIVALENT": "a quadrivalent chromosomal group [n -S]\n",
  "QUADRIVALENTS": "QUADRIVALENT, a quadrivalent chromosomal group [n]\n",
  "QUADRIVIA": "QUADRIVIUM, (Latin) a higher division of seven liberal arts studied in the Middle Ages, comprising arithmetic, music, astronomy, geometry [n]\n",
  "QUADRIVIAL": "leading in four directions; concerning a four-way junction [adj]\n",
  "QUADRIVIUM": "(Latin) a higher division of seven liberal arts studied in the Middle Ages, comprising arithmetic, music, astronomy, geometry [n QUADRIVIUMS or QUADRIVIA]\n",
  "QUADRIVIUMS": "QUADRIVIUM, (Latin) a higher division of seven liberal arts studied in the Middle Ages, comprising arithmetic, music, astronomy, geometry [n]\n",
  "QUADROON": "an old term for a person of one-quarter black ancestry, also QUARTEROON [n -S]\n",
  "QUADROONS": "QUADROON, an old term for a person of one-quarter black ancestry, also QUARTEROON [n]\n",
  "QUADROPHONIC": "of, relating to, or using four channels for the transmission, recording, or reproduction of sound, also QUADRAPHONIC, QUADRIPHONIC [adj]\n",
  "QUADROPHONICS": "a system of sound transmission using a minimum of four speakers, also QUADRAPHONICS, QUADRAPHONY, QUADRIPHONICS, QUADROPHONY [n]\n",
  "QUADROPHONIES": "QUADROPHONY, a system of sound transmission using four speakers, also QUADRAPHONICS, QUADRAPHONY, QUADRIPHONICS, QUADROPHONICS [n]\n",
  "QUADROPHONY": "a system of sound transmission using four speakers, also QUADRAPHONICS, QUADRAPHONY, QUADRIPHONICS, QUADROPHONICS [n QUADROPHONIES]\n",
  "QUADRUMAN": "a former name for primates other than man, also QUADRUMANE [n -S]\n",
  "QUADRUMANE": "a former name for primates other than man, also QUADRUMAN [n -S]\n",
  "QUADRUMANES": "QUADRUMANE, a former name for primates other than man, also QUADRUMAN [n]\n",
  "QUADRUMANOUS": "of apes, etc., with all four feet adapted for use as hands [adj]\n",
  "QUADRUMANS": "QUADRUMAN, a former name for primates other than man, also QUADRUMANE [n]\n",
  "QUADRUMVIR": "a member of a quadrumvirate [n -S]\n",
  "QUADRUMVIRATE": "a group of four men acting together in some capacity [n -S]\n",
  "QUADRUMVIRATES": "QUADRUMVIRATE, a group of four men acting together in some capacity [n]\n",
  "QUADRUMVIRS": "QUADRUMVIR, a member of a quadrumvirate [n]\n",
  "QUADRUPED": "a four-footed animal [n -S]\n",
  "QUADRUPEDAL": "having four feet [adj]\n",
  "QUADRUPEDS": "QUADRUPED, a four-footed animal [n]\n",
  "QUADRUPLE": "to increase fourfold [v QUADRUPLED, QUADRUPLING, QUADRUPLES]\n",
  "QUADRUPLED": "QUADRUPLE, to increase fourfold [v]\n",
  "QUADRUPLES": "QUADRUPLE, to increase fourfold [v]\n",
  "QUADRUPLET": "a combination of four of a kind [n -S]\n",
  "QUADRUPLETS": "QUADRUPLET, a combination of four of a kind [n]\n",
  "QUADRUPLEX": "fourfold [adj] / to make quadruplex [v -ED, -ING, -ES]\n",
  "QUADRUPLEXED": "QUADRUPLEX, to make quadruplex [v]\n",
  "QUADRUPLEXES": "QUADRUPLEX, to make quadruplex [v]\n",
  "QUADRUPLEXING": "QUADRUPLEX, to make quadruplex [v]\n",
  "QUADRUPLICATE": "to make quadruple or fourfold [v QUADRUPLICATED, QUADRUPLICATING, QUADRUPLICATES]\n",
  "QUADRUPLICATED": "QUADRUPLICATE, to make quadruple or fourfold [v]\n",
  "QUADRUPLICATES": "QUADRUPLICATE, to make quadruple or fourfold [v]\n",
  "QUADRUPLICATING": "QUADRUPLICATE, to make quadruple or fourfold [v]\n",
  "QUADRUPLICATION": "the act of quadruplicating [n]\n",
  "QUADRUPLICITIES": "QUADRUPLICITY, the state of being quadruple [n]\n",
  "QUADRUPLICITY": "the state of being quadruple [n QUADRUPLICITIES]\n",
  "QUADRUPLIES": "QUADRUPLY, (Scots) a reply to a triply [n]\n",
  "QUADRUPLING": "QUADRUPLE, to increase fourfold [v]\n",
  "QUADRUPLY": "(Scots) a reply to a triply [n QUADRUPLIES]\n",
  "QUADRUPOLE": "a system composed of two dipoles of equal but oppositely directed moment [n -S]\n",
  "QUADRUPOLES": "QUADRUPOLE, a system composed of two dipoles of equal but oppositely directed moment [n]\n",
  "QUADS": "QUAD, to space by means of quadrats [v]\n",
  "QUAERE": "(Latin) to inquire or question [v QUAERED, QUAEREING, QUAERES]\n",
  "QUAERED": "QUAERE, (Latin) to inquire or question [v]\n",
  "QUAEREING": "QUAERE, (Latin) to inquire or question [v]\n",
  "QUAERES": "QUAERE, (Latin) to inquire or question [v]\n",
  "QUAERITUR": "(Latin) the question is asked [v]\n",
  "QUAESITUM": "(Latin) something sought for; the true value [n -S]\n",
  "QUAESITUMS": "QUAESITUM, (Latin) something sought for; the true value [n]\n",
  "QUAESTIONARIES": "QUAESTIONARY, (Scott) a religious pardoner, also QUESTIONARY [n]\n",
  "QUAESTIONARY": "(Scott) a religious pardoner, also QUESTIONARY [n QUAESTIONARIES]\n",
  "QUAESTOR": "(Latin) an ancient Roman public treasurer or assistant military commander, also QUESTOR [n -S]\n",
  "QUAESTORIAL": "relating to the office of quaestor, also QUESTORIAL [adj]\n",
  "QUAESTORS": "QUAESTOR, (Latin) an ancient Roman public treasurer or assistant military commander, also QUESTOR [n]\n",
  "QUAESTORSHIP": "the office of quaestor, also QUESTORSHIP [n -S]\n",
  "QUAESTORSHIPS": "QUAESTORSHIP, the office of quaestor, also QUESTORSHIP [n]\n",
  "QUAESTUARIES": "QUAESTUARY, (Latin) an ancient Roman public treasurer or assistant military commander, also QUAESTOR, QUESTOR [n]\n",
  "QUAESTUARY": "(Latin) an ancient Roman public treasurer or assistant military commander, also QUAESTOR, QUESTOR [n QUAESTUARIES]\n",
  "QUAFF": "to drink deeply [v -ED, -ING, -S]\n",
  "QUAFFABLE": "that can be quaffed [adj]\n",
  "QUAFFED": "QUAFF, to drink deeply [v]\n",
  "QUAFFER": "one who quaffs, or drinks largely [n -S]\n",
  "QUAFFERS": "QUAFFER, one who quaffs, or drinks largely [n]\n",
  "QUAFFING": "QUAFF, to drink deeply [v]\n",
  "QUAFFS": "QUAFF, to drink deeply [v]\n",
  "QUAG": "a quagmire [n -S]\n",
  "QUAGGA": "(Hottentot) an extinct South African wild ass [n -S]\n",
  "QUAGGAS": "QUAGGA, (Hottentot) an extinct South African wild ass [n]\n",
  "QUAGGIER": "QUAGGY, boggy, like a quagmire [adj]\n",
  "QUAGGIEST": "QUAGGY, boggy, like a quagmire [adj]\n",
  "QUAGGINESS": "the state of being quaggy [n -ES]\n",
  "QUAGGINESSES": "QUAGGINESS, the state of being quaggy [n]\n",
  "QUAGGY": "boggy, like a quagmire [adj QUAGGIER, QUAGGIEST]\n",
  "QUAGMIRE": "to entangle as in boggy ground [v QUAGMIRED, QUAGMIRING, QUAGMIRES]\n",
  "QUAGMIRED": "QUAGMIRE, to entangle as in boggy ground [v]\n",
  "QUAGMIRES": "QUAGMIRE, to entangle as in boggy ground [v]\n",
  "QUAGMIRIER": "QUAGMIRY, like a quagmire, boggy [adj]\n",
  "QUAGMIRIEST": "QUAGMIRY, like a quagmire, boggy [adj]\n",
  "QUAGMIRING": "QUAGMIRE, to entangle as in boggy ground [v]\n",
  "QUAGMIRY": "like a quagmire, boggy [adj QUAGMIRIER, QUAGMIRIEST]\n",
  "QUAGS": "QUAG, a quagmire [n]\n",
  "QUAHAUG": "(Native American) a kind of clam, also COHOG, QUAHOG, QUOHOG [n -S]\n",
  "QUAHAUGS": "QUAHAUG, (Native American) a kind of clam, also COHOG, QUAHOG, QUOHOG [n]\n",
  "QUAHOG": "(Native American) a kind of clam, also COHOG, QUAHAUG, QUOHOG [n -S]\n",
  "QUAHOGS": "QUAHOG, (Native American) a kind of clam, also COHOG, QUAHAUG, QUOHOG [n]\n",
  "QUAI": "(French) a quay [n -S]\n",
  "QUAICH": "(Gaelic) a drinking-cup, also QUAIGH [n QUAICHS or QUAICHES]\n",
  "QUAICHES": "QUAICH, (Gaelic) a drinking-cup, also QUAIGH [n]\n",
  "QUAICHS": "QUAICH, (Gaelic) a drinking-cup, also QUAIGH [n]\n",
  "QUAIGH": "(Gaelic) a drinking-cup, also QUAICH [n -S]\n",
  "QUAIGHS": "QUAIGH, (Gaelic) a drinking-cup, also QUAICH [n]\n",
  "QUAIL": "to give way in fear [v -ED, -ING, -S]\n",
  "QUAILED": "QUAIL, to give way in fear [v]\n",
  "QUAILING": "the act of quailing [n -S]\n",
  "QUAILINGS": "QUAILING, the act of quailing [n]\n",
  "QUAILS": "QUAIL, to give way in fear [v]\n",
  "QUAINT": "pleasantly odd, also QUEINT [adj QUAINTER, QUAINTEST, QUAINTLY]\n",
  "QUAINTER": "QUAINT, pleasantly odd, also QUEINT [adj]\n",
  "QUAINTEST": "QUAINT, pleasantly odd, also QUEINT [adj]\n",
  "QUAINTLY": "QUAINT, pleasantly odd, also QUEINT [adv]\n",
  "QUAINTNESS": "the state of being quaint [n -ES]\n",
  "QUAINTNESSES": "QUAINTNESS, the state of being quaint [n]\n",
  "QUAIR": "(obsolete) a quire; a book [n -S]\n",
  "QUAIRS": "QUAIR, (obsolete) a quire; a book [n]\n",
  "QUAIS": "QUAI, (French) a quay [n]\n",
  "QUAKE": "to shake [v QUAKED or (Spenser) QUOOKE, QUAKING, QUAKES]\n",
  "QUAKED": "QUAKE, to shake [v]\n",
  "QUAKER": "one who quakes [n -S]\n",
  "QUAKERS": "QUAKER, one who quakes [n]\n",
  "QUAKES": "QUAKE, to shake [v]\n",
  "QUAKIER": "QUAKY, quaking, shaky [adj]\n",
  "QUAKIEST": "QUAKY, quaking, shaky [adj]\n",
  "QUAKILY": "QUAKY, quaking, shaky [adv]\n",
  "QUAKINESS": "the state of being quaky [n -ES]\n",
  "QUAKINESSES": "QUAKINESS, the state of being quaky [n]\n",
  "QUAKING": "shaking [adj QUAKINGLY] / the act of quaking [n -S]\n",
  "QUAKINGLY": "QUAKING, shaking [adv]\n",
  "QUAKINGS": "QUAKING, the act of quaking [n]\n",
  "QUAKY": "quaking, shaky [adj QUAKIER, QUAKIEST, QUAKILY]\n",
  "QUALE": "(Latin) a property or quality of something [n QUALIA]\n",
  "QUALIA": "QUALE, (Latin) a property or quality of something [n]\n",
  "QUALIFIABLE": "that can be qualified [adj]\n",
  "QUALIFICATION": "a restriction in meaning or application [n -S]\n",
  "QUALIFICATIONS": "QUALIFICATION, a restriction in meaning or application [n]\n",
  "QUALIFICATIVE": "serving to qualify [adj] / something serving to qualify [n -S]\n",
  "QUALIFICATIVES": "QUALIFICATIVE, something serving to qualify [n]\n",
  "QUALIFICATOR": "one who prepares ecclesiastical cases for trial [n -S]\n",
  "QUALIFICATORS": "QUALIFICATOR, one who prepares ecclesiastical cases for trial [n]\n",
  "QUALIFICATORY": "of the nature of a qualification [adj]\n",
  "QUALIFIED": "QUALIFY, to be eligible after having the necessary requirements [v]\n",
  "QUALIFIEDLY": "QUALIFIED, QUALIFY, to be eligible after having the necessary requirements [adv]\n",
  "QUALIFIER": "one who qualifies [n -S]\n",
  "QUALIFIERS": "QUALIFIER, one who qualifies [n]\n",
  "QUALIFIES": "QUALIFY, to be eligible after having the necessary requirements [v]\n",
  "QUALIFY": "to be eligible after having the necessary requirements [v QUALIFIED, QUALIFYING, QUALIFIES]\n",
  "QUALIFYING": "the act of qualifying [n -S]\n",
  "QUALIFYINGS": "QUALIFYING, the act of qualifying [n]\n",
  "QUALITATIVE": "of, relating to, or involving quality or kind [adj QUALITATIVELY]\n",
  "QUALITATIVELY": "QUALITATIVE, of, relating to, or involving quality or kind [adv]\n",
  "QUALITIED": "endowed with a quality or qualities [adj]\n",
  "QUALITIES": "QUALITY, persons of the upper class collectively [n]\n",
  "QUALITY": "persons of the upper class collectively [n QUALITIES]\n",
  "QUALM": "a feeling of doubt [n -S]\n",
  "QUALMIER": "QUALMY, having misgivings [adj]\n",
  "QUALMIEST": "QUALMY, having misgivings [adj]\n",
  "QUALMING": "the state of having a qualm [n -S]\n",
  "QUALMINGS": "QUALMING, the state of having a qualm [n]\n",
  "QUALMISH": "sick at the stomach; affected with nausea [adj QUALMISHLY]\n",
  "QUALMISHLY": "QUALMISH, sick at the stomach; affected with nausea [adv]\n",
  "QUALMISHNESS": "the state of being qualmish, sick at the stomach [n -ES]\n",
  "QUALMISHNESSES": "QUALMISHNESS, the state of being qualmish, sick at the stomach [n]\n",
  "QUALMLESS": "having no qualms [adj]\n",
  "QUALMS": "QUALM, a feeling of doubt [n]\n",
  "QUALMY": "having misgivings [adj QUALMIER, QUALMIEST]\n",
  "QUAMASH": "(Native American) a blue-flowered liliaceous plant of northwestern America, also CAMAS, CAMASH, CAMASS [n -ES]\n",
  "QUAMASHES": "QUAMASH, (Native American) a blue-flowered liliaceous plant of northwestern America, also CAMAS, CAMASH, CAMASS [n]\n",
  "QUANDANG": "(Native Australian) an Australian tree, also QUANDONG, QUANTONG [n -S]\n",
  "QUANDANGS": "QUANDANG, (Native Australian) an Australian tree, also QUANDONG, QUANTONG [n]\n",
  "QUANDARIES": "QUANDARY, a state of perplexity [n]\n",
  "QUANDARY": "a state of perplexity [n QUANDARIES]\n",
  "QUANDONG": "(Native Australian) a small Australian tree of the sandalwood family, also QUANDANG, QUANTONG [n -S]\n",
  "QUANDONGS": "QUANDONG, (Native Australian) a small Australian tree of the sandalwood family, also QUANDANG, QUANTONG [n]\n",
  "QUANGO": "a quasi-autonomous nongovernmental organization [n -S]\n",
  "QUANGOCRACIES": "QUANGOCRACY, government by quango [n]\n",
  "QUANGOCRACY": "government by quango [n QUANGOCRACIES]\n",
  "QUANGOS": "QUANGO, a quasi-autonomous nongovernmental organization [n]\n",
  "QUANNET": "a flat file used like a plane [n -S]\n",
  "QUANNETS": "QUANNET, a flat file used like a plane [n]\n",
  "QUANT": "to propel with a pole [v -ED, -ING, -S]\n",
  "QUANTA": "QUANTUM, (Latin) a minimum quantity [n]\n",
  "QUANTAL": "of or pertaining to a quantum [adj QUANTALLY]\n",
  "QUANTALLY": "QUANTAL, of or pertaining to a quantum [adv]\n",
  "QUANTED": "QUANT, to propel with a pole [v]\n",
  "QUANTIC": "a kind of mathematical function [n -S]\n",
  "QUANTICAL": "of or like a quantic, a homogeneous algebraic function of two or more variables [adj]\n",
  "QUANTICS": "QUANTIC, a kind of mathematical function [n]\n",
  "QUANTIFIABLE": "capable of being quantified [adj]\n",
  "QUANTIFICATION": "the operation of quantifying [n -S]\n",
  "QUANTIFICATIONS": "QUANTIFICATION, the operation of quantifying [n]\n",
  "QUANTIFIED": "QUANTIFY, to determine the quantity of [v]\n",
  "QUANTIFIER": "one that quantifies [n -S]\n",
  "QUANTIFIERS": "QUANTIFIER, one that quantifies [n]\n",
  "QUANTIFIES": "QUANTIFY, to determine the quantity of [v]\n",
  "QUANTIFY": "to determine the quantity of [v QUANTIFIED, QUANTIFYING, QUANTIFIES]\n",
  "QUANTIFYING": "QUANTIFY, to determine the quantity of [v]\n",
  "QUANTILE": "any of the values of a random variable that divides a frequency distribution [n -S]\n",
  "QUANTILES": "QUANTILE, any of the values of a random variable that divides a frequency distribution [n]\n",
  "QUANTING": "QUANT, to propel with a pole [v]\n",
  "QUANTISATION": "the act of quantising, also QUANTIZATION [n -S]\n",
  "QUANTISATIONS": "QUANTISATION, the act of quantising, also QUANTIZATION [n]\n",
  "QUANTISE": "to express in terms of quanta, also QUANTIZE [v QUANTISED, QUANTISING, QUANTISES]\n",
  "QUANTISED": "QUANTISE, to express in terms of quanta, also QUANTIZE [v]\n",
  "QUANTISER": "one who quantises, expresses in terms of quanta, also QUANTIZER [n -S]\n",
  "QUANTISERS": "QUANTISER, one who quantises, expresses in terms of quanta, also QUANTIZER [n]\n",
  "QUANTISES": "QUANTISE, to express in terms of quanta, also QUANTIZE [v]\n",
  "QUANTISING": "QUANTISE, to express in terms of quanta, also QUANTIZE [v]\n",
  "QUANTITATE": "to make quantitative [v QUANTITATED, QUANTITATING, QUANTITATES]\n",
  "QUANTITATED": "QUANTITATE, to make quantitative [v]\n",
  "QUANTITATES": "QUANTITATE, to make quantitative [v]\n",
  "QUANTITATING": "QUANTITATE, to make quantitative [v]\n",
  "QUANTITATION": "the act of quantitating [n -S]\n",
  "QUANTITATIONS": "QUANTITATION, the act of quantitating [n]\n",
  "QUANTITATIVE": "estimable according to quantity, also QUANTITIVE [adj QUANTITATIVELY]\n",
  "QUANTITATIVELY": "QUANTITATIVE, estimable according to quantity, also QUANTITIVE [adv]\n",
  "QUANTITIES": "QUANTITY, a certain number [n]\n",
  "QUANTITIVE": "estimable according to quantity, also QUANTITATIVE [adj QUANTITIVELY]\n",
  "QUANTITIVELY": "QUANTITIVE, estimable according to quantity, also QUANTITATIVE [adv]\n",
  "QUANTITY": "a certain number [n QUANTITIES]\n",
  "QUANTIVALENCE": "valency [n -S]\n",
  "QUANTIVALENCES": "QUANTIVALENCE, valency [n]\n",
  "QUANTIVALENT": "relating to quantivalence, valency [adj]\n",
  "QUANTIZATION": "the act of quantizing, also QUANTISATION [n -S]\n",
  "QUANTIZATIONS": "QUANTIZATION, the act of quantizing, also QUANTISATION [n]\n",
  "QUANTIZE": "to express in terms of quanta, also QUANTISE [v QUANTIZED, QUANTIZING, QUANTIZES]\n",
  "QUANTIZED": "QUANTIZE, to express in terms of quanta, also QUANTISE [v]\n",
  "QUANTIZER": "one who quantizes, expresses in terms of quanta, also QUANTISER [n -S]\n",
  "QUANTIZERS": "QUANTIZER, one who quantizes, expresses in terms of quanta, also QUANTISER [n]\n",
  "QUANTIZES": "QUANTIZE, to express in terms of quanta, also QUANTISE [v]\n",
  "QUANTIZING": "QUANTIZE, to express in terms of quanta, also QUANTISE [v]\n",
  "QUANTOMETER": "(tradename) an instrument for measuring proportions of elements in metallic samples [n -S]\n",
  "QUANTOMETERS": "QUANTOMETER, (tradename) an instrument for measuring proportions of elements in metallic samples [n]\n",
  "QUANTONG": "(Native Australian) a small Australian tree of the sandalwood family, also QUANDANG, QUANDONG [n -S]\n",
  "QUANTONGS": "QUANTONG, (Native Australian) a small Australian tree of the sandalwood family, also QUANDANG, QUANDONG [n]\n",
  "QUANTS": "QUANT, to propel with a pole [v]\n",
  "QUANTUM": "(Latin) a minimum quantity [n QUANTA or QUANTUMS]\n",
  "QUANTUMS": "QUANTUM, (Latin) a minimum quantity [n]\n",
  "QUAQUAVERSAL": "sloping downward from the center in all directions [adj QUAQUAVERSALLY]\n",
  "QUAQUAVERSALLY": "QUAQUAVERSAL, sloping downward from the center in all directions [adv]\n",
  "QUARANTINE": "a time of compulsory isolation or detention to prevent spread of contagion or infection [n -S] / to detain in or exclude by quarantine [v QUARANTINED, QUARANTINING, QUARANTINES]\n",
  "QUARANTINED": "QUARANTINE, to detain in or exclude by quarantine [v]\n",
  "QUARANTINES": "QUARANTINE, to detain in or exclude by quarantine [v]\n",
  "QUARANTINING": "QUARANTINE, to detain in or exclude by quarantine [v]\n",
  "QUARE": "(dialect) queer [adj QUARER, QUAREST]\n",
  "QUARENDEN": "a kind of early red apple, also QUARENDER, QUARRENDER, QUARRINGTON [n -S]\n",
  "QUARENDENS": "QUARENDEN, a kind of early red apple, also QUARENDER, QUARRENDER, QUARRINGTON [n]\n",
  "QUARENDER": "a kind of early red apple, also QUARENDEN, QUARRENDER, QUARRINGTON [n -S]\n",
  "QUARENDERS": "QUARENDER, a kind of early red apple, also QUARENDEN, QUARRENDER, QUARRINGTON [n]\n",
  "QUARER": "QUARE, (dialect) queer [adj]\n",
  "QUAREST": "QUARE, (dialect) queer [adj]\n",
  "QUARK": "a fundamental subatomic particle [n -S]\n",
  "QUARKS": "QUARK, a fundamental subatomic particle [n]\n",
  "QUARREL": "to become involved in an unfriendly dispute [v QUARRELED or QUARRELLED, QUARRELING or QUARRELLING, QUARRELS]\n",
  "QUARRELED": "QUARREL, to become involved in an unfriendly dispute [v]\n",
  "QUARRELER": "one who quarrels, also QUARRELLER [n -S]\n",
  "QUARRELERS": "QUARRELER, one who quarrels, also QUARRELLER [n]\n",
  "QUARRELING": "te act of having a quarrel [n -S]\n",
  "QUARRELINGS": "QUARRELING, te act of having a quarrel [n]\n",
  "QUARRELLED": "QUARREL, to become involved in an unfriendly dispute [v]\n",
  "QUARRELLER": "one who quarrels, also QUARRELER [n -S]\n",
  "QUARRELLERS": "QUARRELLER, one who quarrels, also QUARRELER [n]\n",
  "QUARRELLING": "the act of quarrelling [n -S]\n",
  "QUARRELLINGS": "QUARRELLING, the act of quarrelling [n]\n",
  "QUARRELLOUS": "(Shakespeare) giving to quarrelling [adj]\n",
  "QUARRELS": "QUARREL, to become involved in an unfriendly dispute [v]\n",
  "QUARRELSOME": "apt or disposed to quarrel in an often petty manner [adj QUARRELSOMELY]\n",
  "QUARRELSOMELY": "QUARRELSOME, apt or disposed to quarrel in an often petty manner [adv]\n",
  "QUARRELSOMENESS": "QUARRELSOME, apt or disposed to quarrel in an often petty manner [n]\n",
  "QUARRENDER": "a kind of early red apple, also QUARENDEN, QUARENDER, QUARRINGTON [n -S]\n",
  "QUARRENDERS": "QUARRENDER, a kind of early red apple, also QUARENDEN, QUARENDER, QUARRINGTON [n]\n",
  "QUARRIABLE": "that can be quarried [adj]\n",
  "QUARRIAN": "(Native Australian) a kind of cockatiel, also QUARRION [n -S]\n",
  "QUARRIANS": "QUARRIAN, (Native Australian) a kind of cockatiel, also QUARRION [n]\n",
  "QUARRIED": "QUARRY, to dig for stone [v]\n",
  "QUARRIER": "one who quarries [n -S]\n",
  "QUARRIERS": "QUARRIER, one who quarries [n]\n",
  "QUARRIES": "QUARRY, to dig for stone [v]\n",
  "QUARRINGTON": "a kind of early red apple, also QUARENDEN, QUARENDER, QUARRENDER [n -S]\n",
  "QUARRINGTONS": "QUARRINGTON, a kind of early red apple, also QUARENDEN, QUARENDER, QUARRENDER [n]\n",
  "QUARRION": "(Native Australian) a kind of cockatiel, also QUARRIAN [n -S]\n",
  "QUARRIONS": "QUARRION, (Native Australian) a kind of cockatiel, also QUARRIAN [n]\n",
  "QUARRY": "to dig for stone [v QUARRIED, QUARRYING, QUARRIES]\n",
  "QUARRYING": "the act of quarrying [n -S]\n",
  "QUARRYINGS": "QUARRYING, the act of quarrying [n]\n",
  "QUARRYMAN": "a quarry worker [n QUARRYMEN]\n",
  "QUARRYMASTER": "one in charge of a quarry [n -S]\n",
  "QUARRYMASTERS": "QUARRYMASTER, one in charge of a quarry [n]\n",
  "QUARRYMEN": "QUARRYMAN, a quarry worker [n]\n",
  "QUART": "the fourth part of a gallon, or two pints [n -S]\n",
  "QUARTAN": "(Latin) a malarial fever recurring every third day [n -S]\n",
  "QUARTANS": "QUARTAN, (Latin) a malarial fever recurring every third day [n]\n",
  "QUARTATION": "mixing one part gold with three parts silver prior to purifying it [n -S]\n",
  "QUARTATIONS": "QUARTATION, mixing one part gold with three parts silver prior to purifying it [n]\n",
  "QUARTE": "the fourth of eight parrying or attacking positions in fencing [n -S]\n",
  "QUARTER": "to divide into four parts [v -ED, -ING, -S]\n",
  "QUARTERAGE": "a quarterly allowance [n -S]\n",
  "QUARTERAGES": "QUARTERAGE, a quarterly allowance [n]\n",
  "QUARTERBACK": "in American football, the player between the linemen and the halfbacks, who directs the teams's attacking play [n -S] / to direct the offensive play of (as a football team) [v -ED, -ING, -S]\n",
  "QUARTERBACKED": "QUARTERBACK, to direct the offensive play of (as a football team) [v]\n",
  "QUARTERBACKING": "wisdom after the event, esp. by spectators [n -S]\n",
  "QUARTERBACKINGS": "QUARTERBACKING, wisdom after the event, esp. by spectators [n]\n",
  "QUARTERBACKS": "QUARTERBACK, to direct the offensive play of (as a football team) [v]\n",
  "QUARTERDECK": "part of ship's deck set aside by captain for ceremonial functions [n -S]\n",
  "QUARTERDECKER": "a stickler for naval etiquette [n -S]\n",
  "QUARTERDECKERS": "QUARTERDECKER, a stickler for naval etiquette [n]\n",
  "QUARTERDECKS": "QUARTERDECK, part of ship's deck set aside by captain for ceremonial functions [n]\n",
  "QUARTERED": "QUARTER, to divide into four parts [v]\n",
  "QUARTERER": "one who quarters [n -S]\n",
  "QUARTERERS": "QUARTERER, one who quarters [n]\n",
  "QUARTERFINAL": "the round before the semifinal in a knockout competition [n -S]\n",
  "QUARTERFINALIST": "one who reaches a quarterfinal [n]\n",
  "QUARTERFINALS": "QUARTERFINAL, the round before the semifinal in a knockout competition [n]\n",
  "QUARTERING": "sailing nearly before the wind [n -S]\n",
  "QUARTERINGS": "QUARTERING, sailing nearly before the wind [n]\n",
  "QUARTERLIES": "QUARTERLY, a periodical appearing quarterly [n]\n",
  "QUARTERLIFE": "designating the period of life immediately following the major changes of adolescence, usually early twenties to early thirties [adj]\n",
  "QUARTERLIGHT": "a small triangular ventilation window in a car [n -S]\n",
  "QUARTERLIGHTS": "QUARTERLIGHT, a small triangular ventilation window in a car [n]\n",
  "QUARTERLY": "a periodical appearing quarterly [n QUARTERLIES]\n",
  "QUARTERMASTER": "one in charge of stores [n -S]\n",
  "QUARTERMASTERS": "QUARTERMASTER, one in charge of stores [n]\n",
  "QUARTERMISTRESS": "a female quartermaster [n]\n",
  "QUARTERN": "a fourth part [n -S]\n",
  "QUARTERNS": "QUARTERN, a fourth part [n]\n",
  "QUARTEROON": "an old term for a person of one-quarter black ancestry, also QUADROON [n -S]\n",
  "QUARTEROONS": "QUARTEROON, an old term for a person of one-quarter black ancestry, also QUADROON [n]\n",
  "QUARTERS": "QUARTER, to divide into four parts [v]\n",
  "QUARTERSAW": "to saw (timber) into quarters along two diameters of a log at right angles to each other [v QUARTERSAWED, QUARTERSAWN, QUARTERSAWING, QUARTERSAWS]\n",
  "QUARTERSAWED": "QUARTERSAW, to saw (timber) into quarters along two diameters of a log at right angles to each other [v]\n",
  "QUARTERSAWING": "QUARTERSAW, to saw (timber) into quarters along two diameters of a log at right angles to each other [v]\n",
  "QUARTERSAWN": "QUARTERSAW, to saw (timber) into quarters along two diameters of a log at right angles to each other [v]\n",
  "QUARTERSAWS": "QUARTERSAW, to saw (timber) into quarters along two diameters of a log at right angles to each other [v]\n",
  "QUARTERSTAFF": "a long wooden pole with an iron tip, an old weapon of defence [n QUARTERSTAFFS or QUARTERSTAVES]\n",
  "QUARTERSTAFFS": "QUARTERSTAFF, a long wooden pole with an iron tip, an old weapon of defence [n]\n",
  "QUARTERSTAVES": "QUARTERSTAFF, a long wooden pole with an iron tip, an old weapon of defence [n]\n",
  "QUARTES": "QUARTE, the fourth of eight parrying or attacking positions in fencing [n]\n",
  "QUARTET": "a set of four; a composition for four voices or instruments, also QUARTETT, QUARTETTE, QUARTETTO [n -S]\n",
  "QUARTETS": "QUARTET, a set of four; a composition for four voices or instruments, also QUARTETT, QUARTETTE, QUARTETTO [n]\n",
  "QUARTETT": "a composition for four voices or instruments, also QUARTET, QUARTETTE, QUARTETTO [n -S]\n",
  "QUARTETTE": "a set of four; a composition for four voices or instruments, also QUARTET, QUARTETT, QUARTETTO [n -S]\n",
  "QUARTETTES": "QUARTETTE, a set of four; a composition for four voices or instruments, also QUARTET, QUARTETT, QUARTETTO [n]\n",
  "QUARTETTI": "QUARTETTO, (Italian) a quartet, a composition for four voices, also QUARTET, QUARTETT, QUARTETTE [n]\n",
  "QUARTETTO": "(Italian) a quartet, a composition for four voices, also QUARTET, QUARTETT, QUARTETTE [n QUARTETTI]\n",
  "QUARTETTS": "QUARTETT, a composition for four voices or instruments, also QUARTET, QUARTETTE, QUARTETTO [n]\n",
  "QUARTIC": "a function, curve or surface of the fourth degree [n -S]\n",
  "QUARTICS": "QUARTIC, a function, curve or surface of the fourth degree [n]\n",
  "QUARTIER": "(French) a specified district in a French town or city [n -S]\n",
  "QUARTIERS": "QUARTIER, (French) a specified district in a French town or city [n]\n",
  "QUARTILE": "an aspect of the planets when their longitudes differ by 90 [n -S]\n",
  "QUARTILES": "QUARTILE, an aspect of the planets when their longitudes differ by 90 [n]\n",
  "QUARTO": "a book size made by folding sheet into four leaves [n -S]\n",
  "QUARTODECIMAN": "an early Christian who celebrated Easter on Passover even if not a Sunday [n -S]\n",
  "QUARTODECIMANS": "QUARTODECIMAN, an early Christian who celebrated Easter on Passover even if not a Sunday [n]\n",
  "QUARTOS": "QUARTO, a book size made by folding sheet into four leaves [n]\n",
  "QUARTS": "QUART, the fourth part of a gallon, or two pints [n]\n",
  "QUARTZ": "the commonest rock-forming mineral, composed of silica [n -ES]\n",
  "QUARTZES": "QUARTZ, the commonest rock-forming mineral, composed of silica [n]\n",
  "QUARTZIER": "QUARTZY, like quartz [adj]\n",
  "QUARTZIEST": "QUARTZY, like quartz [adj]\n",
  "QUARTZIFEROUS": "bearing quartz [adj]\n",
  "QUARTZITE": "a metamorphosed sandstone [n -S]\n",
  "QUARTZITES": "QUARTZITE, a metamorphosed sandstone [n]\n",
  "QUARTZITIC": "of or like quartzite [adj]\n",
  "QUARTZOSE": "of or containing quartz, also QUARTZOUS [adj]\n",
  "QUARTZOUS": "of or containing quartz, also QUARTZOSE [adj]\n",
  "QUARTZY": "like quartz [adj QUARTZIER, QUARTZIEST]\n",
  "QUASAR": "a starlike object which emits radio waves [n -S]\n",
  "QUASARS": "QUASAR, a starlike object which emits radio waves [n]\n",
  "QUASH": "to set aside or annul [v -ED, -ING, -ES]\n",
  "QUASHED": "QUASH, to set aside or annul [v]\n",
  "QUASHEE": "(offensive) a black person, esp. in the West Indies, also QUASHIE [n -S]\n",
  "QUASHEES": "QUASHEE, (offensive) a black person, esp. in the West Indies, also QUASHIE [n]\n",
  "QUASHER": "one who quashes [n -S]\n",
  "QUASHERS": "QUASHER, one who quashes [n]\n",
  "QUASHES": "QUASH, to set aside or annul [v]\n",
  "QUASHIE": "(offensive) a black person, esp. in the West Indies, also QUASHEE [n -S]\n",
  "QUASHIES": "QUASHIE, (offensive) a black person, esp. in the West Indies, also QUASHEE [n]\n",
  "QUASHING": "QUASH, to set aside or annul [v]\n",
  "QUASI": "(Latin) as if; seemingly; in a manner [adv]\n",
  "QUASICRYSTAL": "a body of solid material that resembles a crystal in being composed of repeating structural units but that incorporates two or more unit cells into a quasiperiodic structure [n -S]\n",
  "QUASICRYSTALS": "QUASICRYSTAL, a body of solid material that resembles a crystal in being composed of repeating structural units but that incorporates two or more unit cells into a quasiperiodic structure [n]\n",
  "QUASIPARTICLE": "a composite entity (as a vibration in a solid) that is analogous in its behavior to a single particle [n -S]\n",
  "QUASIPARTICLES": "QUASIPARTICLE, a composite entity (as a vibration in a solid) that is analogous in its behavior to a single particle [n]\n",
  "QUASIPERIODIC": "almost but not quite periodic [adj]\n",
  "QUASS": "(Russian) a kind of Russian beer, also KVAS, KVASS [n -ES]\n",
  "QUASSES": "QUASS, (Russian) a kind of Russian beer, also KVAS, KVASS [n]\n",
  "QUASSIA": "the bitter wood of several tropical American trees, used in medicine and sometimes as a substitute for hops in making beer [n -S]\n",
  "QUASSIAS": "QUASSIA, the bitter wood of several tropical American trees, used in medicine and sometimes as a substitute for hops in making beer [n]\n",
  "QUASSIN": "the bitter principle of quassia, extracted as a white crystalline substance [n -S]\n",
  "QUASSINS": "QUASSIN, the bitter principle of quassia, extracted as a white crystalline substance [n]\n",
  "QUAT": "to beat down or squash [v QUATTED, QUATTING, QUATS]\n",
  "QUATCH": "(dialect) to stir, move, also QUETCH, QUICH, QUINCHE, QUITCH [v -ED, -ING, -ES]\n",
  "QUATCHED": "QUATCH, (dialect) to stir, move, also QUETCH, QUICH, QUINCHE, QUITCH [v]\n",
  "QUATCHES": "QUATCH, (dialect) to stir, move, also QUETCH, QUICH, QUINCHE, QUITCH [v]\n",
  "QUATCHING": "QUATCH, (dialect) to stir, move, also QUETCH, QUICH, QUINCHE, QUITCH [v]\n",
  "QUATE": "fortune, destiny [n -S]\n",
  "QUATERCENTENARY": "a four-hundredth anniversary [n]\n",
  "QUATERNARIES": "QUATERNARY, a set of four [n]\n",
  "QUATERNARY": "a set of four [n QUATERNARIES]\n",
  "QUATERNATE": "in sets of four [adj]\n",
  "QUATERNION": "a set or group of four; the operation of changing one vector into another, or the quotient of two vectors [n -S]\n",
  "QUATERNIONIST": "a person who studies quaternions [n -S]\n",
  "QUATERNIONISTS": "QUATERNIONIST, a person who studies quaternions [n]\n",
  "QUATERNIONS": "QUATERNION, a set or group of four; the operation of changing one vector into another, or the quotient of two vectors [n]\n",
  "QUATERNITIES": "QUATERNITY, fourness; any group of four things [n]\n",
  "QUATERNITY": "fourness; any group of four things [n QUATERNITIES]\n",
  "QUATES": "QUATE, fortune, destiny [n]\n",
  "QUATORZAIN": "a poem of fourteen lines; a sonnet [n -S]\n",
  "QUATORZAINS": "QUATORZAIN, a poem of fourteen lines; a sonnet [n]\n",
  "QUATORZE": "(French) the four aces, kings, queens, knaves or tens in pique, counting fourteen [n -S]\n",
  "QUATORZES": "QUATORZE, (French) the four aces, kings, queens, knaves or tens in pique, counting fourteen [n]\n",
  "QUATRAIN": "a stanza of four lines rhyming alternately [n -S]\n",
  "QUATRAINS": "QUATRAIN, a stanza of four lines rhyming alternately [n]\n",
  "QUATRE": "(French) a card, die, or domino, having four spots, or pips [n -S]\n",
  "QUATREFEUILLE": "a four-petalled flower or leaf of four leaflets; an openwork design or ornament divided by cusps into four lobes, also QUATREFOIL [n -S]\n",
  "QUATREFEUILLES": "QUATREFEUILLE, a four-petalled flower or leaf of four leaflets; an openwork design or ornament divided by cusps into four lobes, also QUATREFOIL [n]\n",
  "QUATREFOIL": "a four-petalled flower or leaf of four leaflets; an openwork design or ornament divided by cusps into four lobes, also QUATREFEUILLE [n -S]\n",
  "QUATREFOILS": "QUATREFOIL, a four-petalled flower or leaf of four leaflets; an openwork design or ornament divided by cusps into four lobes, also QUATREFEUILLE [n]\n",
  "QUATRES": "QUATRE, (French) a card, die, or domino, having four spots, or pips [n]\n",
  "QUATS": "QUAT, to beat down or squash [v]\n",
  "QUATTED": "QUAT, to beat down or squash [v]\n",
  "QUATTING": "QUAT, to beat down or squash [v]\n",
  "QUATTROCENTISM": "the spirit of the fifteenth century in reference to Italian art and literature [n -S]\n",
  "QUATTROCENTISMS": "QUATTROCENTISM, the spirit of the fifteenth century in reference to Italian art and literature [n]\n",
  "QUATTROCENTIST": "an artist who flourished in the fifteenth century in reference to Italian art and literature [n -S]\n",
  "QUATTROCENTISTS": "QUATTROCENTIST, an artist who flourished in the fifteenth century in reference to Italian art and literature [n]\n",
  "QUATTROCENTO": "(Italian) the fifteenth century in Italy; the Italian style of art, architecture, etc. of this period [n -S]\n",
  "QUATTROCENTOS": "QUATTROCENTO, (Italian) the fifteenth century in Italy; the Italian style of art, architecture, etc. of this period [n]\n",
  "QUAVER": "to tremble, quiver [v -ED, -ING, -S]\n",
  "QUAVERED": "QUAVER, to tremble, quiver [v]\n",
  "QUAVERER": "one who quavers [n -S]\n",
  "QUAVERERS": "QUAVERER, one who quavers [n]\n",
  "QUAVERIER": "QUAVERY, shaky, quavering [adj]\n",
  "QUAVERIEST": "QUAVERY, shaky, quavering [adj]\n",
  "QUAVERING": "shaky [adj QUAVERINGLY] / the act of quavering [n -S]\n",
  "QUAVERINGLY": "QUAVERING, shaky [adv]\n",
  "QUAVERINGS": "QUAVERING, the act of quavering [n]\n",
  "QUAVERS": "QUAVER, to tremble, quiver [v]\n",
  "QUAVERY": "shaky, quavering [adj QUAVERIER, QUAVERIEST]\n",
  "QUAY": "a wharf for the loading or unloading of vessels [n -S]\n",
  "QUAYAGE": "dues levied on goods landed or shipped at a quay, or on ships using a quay [n -S]\n",
  "QUAYAGES": "QUAYAGE, dues levied on goods landed or shipped at a quay, or on ships using a quay [n]\n",
  "QUAYD": "(Spenser) daunted [adj]\n",
  "QUAYLIKE": "like a quay [adj]\n",
  "QUAYS": "QUAY, a wharf for the loading or unloading of vessels [n]\n",
  "QUAYSIDE": "the side of a quay, a wharf for the loading or unloading of vessels [n -S]\n",
  "QUAYSIDES": "QUAYSIDE, the side of a quay, a wharf for the loading or unloading of vessels [n]\n",
  "QUAZZIER": "QUAZZY, (English dialect) queasy, also QUEAZY [adj]\n",
  "QUAZZIEST": "QUAZZY, (English dialect) queasy, also QUEAZY [adj]\n",
  "QUAZZY": "(English dialect) queasy, also QUEAZY [adj QUAZZIER, QUAZZIEST]\n",
  "QUBIT": "in computing, a quantum bit [n -S]\n",
  "QUBITS": "QUBIT, in computing, a quantum bit [n]\n",
  "QUBYTE": "a sequence of eight quantum bits [n -S]\n",
  "QUBYTES": "QUBYTE, a sequence of eight quantum bits [n]\n",
  "QUEACH": "(obsolete) a thicket, a dense growth of bushes [n -ES]\n",
  "QUEACHES": "QUEACH, (obsolete) a thicket, a dense growth of bushes [n]\n",
  "QUEACHIER": "QUEACHY, forming a thicket; boggy, also QUEECHY [adj]\n",
  "QUEACHIEST": "QUEACHY, forming a thicket; boggy, also QUEECHY [adj]\n",
  "QUEACHY": "forming a thicket; boggy, also QUEECHY [adj QUEACHIER, QUEACHIEST]\n",
  "QUEAN": "(Scots) a young woman, also QUEYN, QUEYNIE, QUINE, QUINIE [n -S]\n",
  "QUEANS": "QUEAN, (Scots) a young woman, also QUEYN, QUEYNIE, QUINE, QUINIE [n]\n",
  "QUEASIER": "QUEASY, feeling sick, also QUAZZY, QUEAZY [adj]\n",
  "QUEASIEST": "QUEASY, feeling sick, also QUAZZY, QUEAZY [adj]\n",
  "QUEASILY": "QUEASY, feeling sick, also QUAZZY, QUEAZY [adv]\n",
  "QUEASINESS": "the state of being queasy [n -ES]\n",
  "QUEASINESSES": "QUEASINESS, the state of being queasy [n]\n",
  "QUEASY": "feeling sick, also QUAZZY, QUEAZY [adj QUEASIER, QUEASIEST, QUEASILY]\n",
  "QUEAZIER": "QUEAZY, feeling sick, also QUAZZY, QUEASY [adj]\n",
  "QUEAZIEST": "QUEAZY, feeling sick, also QUAZZY, QUEASY [adj]\n",
  "QUEAZY": "feeling sick, also QUAZZY, QUEASY [adj QUEAZIER, QUEAZIEST]\n",
  "QUEBEC": "(in international radio communication) a code word for the letter q [n -S]\n",
  "QUEBECS": "QUEBEC, (in international radio communication) a code word for the letter q [n]\n",
  "QUEBRACHO": "(Spanish) any of several tropical American trees and their timber or bark [n -S]\n",
  "QUEBRACHOS": "QUEBRACHO, (Spanish) any of several tropical American trees and their timber or bark [n]\n",
  "QUEECHIER": "QUEECHY, forming a thicket; boggy, also QUEACHY [adj]\n",
  "QUEECHIEST": "QUEECHY, forming a thicket; boggy, also QUEACHY [adj]\n",
  "QUEECHY": "forming a thicket; boggy, also QUEACHY [adj QUEECHIER, QUEECHIEST]\n",
  "QUEEN": "a female monarch [n -S] / to make a queen of [v -ED, -ING, -S]\n",
  "QUEENCAKE": "a small light cake containing currants [n -S]\n",
  "QUEENCAKES": "QUEENCAKE, a small light cake containing currants [n]\n",
  "QUEENCRAFT": "craft or skill in policy on the part of a queen [n -S]\n",
  "QUEENCRAFTS": "QUEENCRAFT, craft or skill in policy on the part of a queen [n]\n",
  "QUEENCUP": "a flowering plant, aka clintonia [n -S]\n",
  "QUEENCUPS": "QUEENCUP, a flowering plant, aka clintonia [n]\n",
  "QUEENDOM": "a Queen's domain [n -S]\n",
  "QUEENDOMS": "QUEENDOM, a Queen's domain [n]\n",
  "QUEENED": "QUEEN, to make a queen of [v]\n",
  "QUEENFISH": "a Californian blue-and-silver fish, aka DRUMFISH [n -ES]\n",
  "QUEENFISHES": "QUEENFISH, a Californian blue-and-silver fish, aka DRUMFISH [n]\n",
  "QUEENHOOD": "the state, personality, or character of a queen [n -S]\n",
  "QUEENHOODS": "QUEENHOOD, the state, personality, or character of a queen [n]\n",
  "QUEENIE": "a Solway scallop [n -S]\n",
  "QUEENIER": "QUEENY, camp or effeminate [adj]\n",
  "QUEENIES": "QUEENIE, a Solway scallop [n]\n",
  "QUEENIEST": "QUEENY, camp or effeminate [adj]\n",
  "QUEENING": "a variety of apple [n -S]\n",
  "QUEENINGS": "QUEENING, a variety of apple [n]\n",
  "QUEENITE": "a queen's partisan [n -S]\n",
  "QUEENITES": "QUEENITE, a queen's partisan [n]\n",
  "QUEENLESS": "having no queen [adj]\n",
  "QUEENLET": "a petty queen [n -S]\n",
  "QUEENLETS": "QUEENLET, a petty queen [n]\n",
  "QUEENLIER": "QUEENLY, like a queen [adj]\n",
  "QUEENLIEST": "QUEENLY, like a queen [adj]\n",
  "QUEENLIKE": "like a queen [adj]\n",
  "QUEENLINESS": "the state of being queenly [n -ES]\n",
  "QUEENLINESSES": "QUEENLINESS, the state of being queenly [n]\n",
  "QUEENLY": "like a queen [adj QUEENLIER, QUEENLIEST]\n",
  "QUEENS": "QUEEN, to make a queen of [v]\n",
  "QUEENSHIP": "the state, rank, or dignity of a queen [n -S]\n",
  "QUEENSHIPS": "QUEENSHIP, the state, rank, or dignity of a queen [n]\n",
  "QUEENSIDE": "in chess, the side of the board where the queen stands at the beginning of play [n -S]\n",
  "QUEENSIDES": "QUEENSIDE, in chess, the side of the board where the queen stands at the beginning of play [n]\n",
  "QUEENY": "camp or effeminate [adj QUEENIER, QUEENIEST]\n",
  "QUEER": "strange [adj QUEERER, QUEEREST, QUEERLY] / to spoil, to put someone in a difficult position [v -ED, -ING, -S]\n",
  "QUEERCORE": "a type of gay-oriented punk music [n -S]\n",
  "QUEERCORES": "QUEERCORE, a type of gay-oriented punk music [n]\n",
  "QUEERDOM": "a group of homosexuals [n -S]\n",
  "QUEERDOMS": "QUEERDOM, a group of homosexuals [n]\n",
  "QUEERED": "QUEER, to spoil, to put someone in a difficult position [v]\n",
  "QUEERER": "QUEER, strange [adj]\n",
  "QUEEREST": "QUEER, strange [adj]\n",
  "QUEERING": "QUEER, to spoil, to put someone in a difficult position [v]\n",
  "QUEERISH": "slightly queer [adj]\n",
  "QUEERITIES": "QUEERITY, oddity [n]\n",
  "QUEERITY": "oddity [n QUEERITIES]\n",
  "QUEERLY": "QUEER, strange [adv]\n",
  "QUEERNESS": "the state of being queer [n -ES]\n",
  "QUEERNESSES": "QUEERNESS, the state of being queer [n]\n",
  "QUEERS": "QUEER, to spoil, to put someone in a difficult position [v]\n",
  "QUEEST": "the ringdove or wood-pigeon, also QUIST, QUOIST [n -S]\n",
  "QUEESTS": "QUEEST, the ringdove or wood-pigeon, also QUIST, QUOIST [n]\n",
  "QUEINT": "(Spenser) quaint [adj]\n",
  "QUELCH": "to squash wetly, also SQUELCH [v -ED, -ING, -ES]\n",
  "QUELCHED": "QUELCH, to squash wetly, also SQUELCH [v]\n",
  "QUELCHES": "QUELCH, to squash wetly, also SQUELCH [v]\n",
  "QUELCHING": "QUELCH, to squash wetly, also SQUELCH [v]\n",
  "QUELEA": "a kind of African weaverbird [n -S]\n",
  "QUELEAS": "QUELEA, a kind of African weaverbird [n]\n",
  "QUELL": "to suppress [v -ED, -ING, -S]\n",
  "QUELLABLE": "that can be quelled [adj]\n",
  "QUELLED": "QUELL, to suppress [v]\n",
  "QUELLER": "a killer; as, Jack the Giant Queller [n -S]\n",
  "QUELLERS": "QUELLER, a killer; as, Jack the Giant Queller [n]\n",
  "QUELLING": "QUELL, to suppress [v]\n",
  "QUELLS": "QUELL, to suppress [v]\n",
  "QUELQUECHOSE": "(French) something [n -S]\n",
  "QUELQUECHOSES": "QUELQUECHOSE, (French) something [n]\n",
  "QUEME": "(Spenser) to please, suit, fit [v QUEMED, QUEMING, QUEMES]\n",
  "QUEMED": "QUEME, (Spenser) to please, suit, fit [v]\n",
  "QUEMES": "QUEME, (Spenser) to please, suit, fit [v]\n",
  "QUEMING": "QUEME, (Spenser) to please, suit, fit [v]\n",
  "QUENA": "(Spanish) a type of bamboo flute from the Andes [n -S]\n",
  "QUENAS": "QUENA, (Spanish) a type of bamboo flute from the Andes [n]\n",
  "QUENCH": "to put out or extinguish [v -ED, -ING, -ES]\n",
  "QUENCHABLE": "capable of being quenched [adj]\n",
  "QUENCHED": "QUENCH, to put out or extinguish [v]\n",
  "QUENCHER": "one who, or that which, quenches [n -S]\n",
  "QUENCHERS": "QUENCHER, one who, or that which, quenches [n]\n",
  "QUENCHES": "QUENCH, to put out or extinguish [v]\n",
  "QUENCHING": "the act of quenching [n -S]\n",
  "QUENCHINGS": "QUENCHING, the act of quenching [n]\n",
  "QUENCHLESS": "incapable of being quenched [adj QUENCHLESSLY]\n",
  "QUENCHLESSLY": "QUENCHLESS, incapable of being quenched [adv]\n",
  "QUENELLE": "(French) a poached meat dumpling [n -S]\n",
  "QUENELLES": "QUENELLE, (French) a poached meat dumpling [n]\n",
  "QUEP": "(obsolete) an interjection expression remonstrance [interj]\n",
  "QUERCETIC": "of or like quercetin, a yellow crystalline compound obtained from the inner bark of the quercitron oak [adj]\n",
  "QUERCETIN": "a yellow crystalline compound obtained from the inner bark of the quercitron oak, also QUERCITIN [n -S]\n",
  "QUERCETINS": "QUERCETIN, a yellow crystalline compound obtained from the inner bark of the quercitron oak, also QUERCITIN [n]\n",
  "QUERCETUM": "(Latin) a plantation of oak trees [n -S]\n",
  "QUERCETUMS": "QUERCETUM, (Latin) a plantation of oak trees [n]\n",
  "QUERCINE": "pertaining to oak trees [adj]\n",
  "QUERCITIN": "a yellow crystalline compound obtained from the inner bark of the quercitron oak, also QUERCETIN [n -S]\n",
  "QUERCITINS": "QUERCITIN, a yellow crystalline compound obtained from the inner bark of the quercitron oak, also QUERCETIN [n]\n",
  "QUERCITRON": "a North American oak, the dyer's oak; its inner bark, a source of quercetin and flavin [n -S]\n",
  "QUERCITRONS": "QUERCITRON, a North American oak, the dyer's oak; its inner bark, a source of quercetin and flavin [n]\n",
  "QUERIDA": "(Spanish) a Mexican term of endearment, sweetheart [n -S]\n",
  "QUERIDAS": "QUERIDA, (Spanish) a Mexican term of endearment, sweetheart [n]\n",
  "QUERIED": "QUERY, to question [v]\n",
  "QUERIER": "one who questions, also QUERIST [n -S]\n",
  "QUERIERS": "QUERIER, one who questions, also QUERIST [n]\n",
  "QUERIES": "QUERY, to question [v]\n",
  "QUERIMONIES": "QUERIMONY, a complaint [n]\n",
  "QUERIMONIOUS": "complaining, querulous [adj QUERIMONIOUSLY]\n",
  "QUERIMONIOUSLY": "QUERIMONIOUS, complaining, querulous [adv]\n",
  "QUERIMONY": "a complaint [n QUERIMONIES]\n",
  "QUERIST": "one who questions, also QUERIER [n -S]\n",
  "QUERISTS": "QUERIST, one who questions, also QUERIER [n]\n",
  "QUERN": "a hand operated stone mill for grinding corn [n -S]\n",
  "QUERNS": "QUERN, a hand operated stone mill for grinding corn [n]\n",
  "QUERNSTONE": "a quern, a stone mill for grinding corn [n -S]\n",
  "QUERNSTONES": "QUERNSTONE, a quern, a stone mill for grinding corn [n]\n",
  "QUERSPRUNG": "(German) in skiing, a jump-turn at right angles [n -S]\n",
  "QUERSPRUNGS": "QUERSPRUNG, (German) in skiing, a jump-turn at right angles [n]\n",
  "QUERULOUS": "complaining; peevish [adj QUERULOUSLY]\n",
  "QUERULOUSLY": "QUERULOUS, complaining; peevish [adv]\n",
  "QUERULOUSNESS": "the state of being querulous [n -ES]\n",
  "QUERULOUSNESSES": "QUERULOUSNESS, the state of being querulous [n]\n",
  "QUERY": "to question [v QUERIED, QUERYING, QUERIES]\n",
  "QUERYING": "questioning [n -S]\n",
  "QUERYINGLY": "QUERYING [adv]\n",
  "QUERYINGS": "QUERYING, questioning [n]\n",
  "QUESADILLA": "(Spanish) a tortilla filled with cheese, chillis etc. folded and fried [n -S]\n",
  "QUESADILLAS": "QUESADILLA, (Spanish) a tortilla filled with cheese, chillis etc. folded and fried [n]\n",
  "QUEST": "to make a search [v -ED, -ING, -S]\n",
  "QUESTANT": "(Shakespeare) one who undertakes a quest, also QUESTER [n -S]\n",
  "QUESTANTS": "QUESTANT, (Shakespeare) one who undertakes a quest, also QUESTER [n]\n",
  "QUESTED": "QUEST, to make a search [v]\n",
  "QUESTER": "a person who seeks, also QUESTANT [n -S]\n",
  "QUESTERS": "QUESTER, a person who seeks, also QUESTANT [n]\n",
  "QUESTING": "searching [adj QUESTINGLY] / the act of questing [n -S]\n",
  "QUESTINGLY": "QUESTING, searching [adv]\n",
  "QUESTINGS": "QUESTING, the act of questing [n]\n",
  "QUESTION": "to ask [v -ED, -ING, -S]\n",
  "QUESTIONABILITY": "the quality of being questionable [n]\n",
  "QUESTIONABLE": "open to question [adj QUESTIONABLY]\n",
  "QUESTIONABLY": "QUESTIONABLE, open to question [adv]\n",
  "QUESTIONARIES": "QUESTIONARY, an asker of questions, also QUAESTIONARY [n]\n",
  "QUESTIONARY": "an asker of questions, also QUAESTIONARY [n QUESTIONARIES]\n",
  "QUESTIONED": "QUESTION, to ask [v]\n",
  "QUESTIONEE": "one who is questioned [n -S]\n",
  "QUESTIONEES": "QUESTIONEE, one who is questioned [n]\n",
  "QUESTIONER": "one who asks questions [n -S]\n",
  "QUESTIONERS": "QUESTIONER, one who asks questions [n]\n",
  "QUESTIONING": "the act of questioning [n -S]\n",
  "QUESTIONINGLY": "QUESTIONING [adv]\n",
  "QUESTIONINGS": "QUESTIONING, the act of questioning [n]\n",
  "QUESTIONIST": "a questioner, a doubter [n -S]\n",
  "QUESTIONISTS": "QUESTIONIST, a questioner, a doubter [n]\n",
  "QUESTIONLESS": "unquestioning; beyond question or doubt [adj QUESTIONLESSLY]\n",
  "QUESTIONLESSLY": "QUESTIONLESS, unquestioning; beyond question or doubt [adv]\n",
  "QUESTIONNAIRE": "a set of questions for obtaining statistically useful or personal information from individuals [n -S]\n",
  "QUESTIONNAIRES": "QUESTIONNAIRE, a set of questions for obtaining statistically useful or personal information from individuals [n]\n",
  "QUESTIONS": "QUESTION, to ask [v]\n",
  "QUESTOR": "(Latin) an ancient Roman public treasurer or assistant military commander, also QUAESTOR [n -S]\n",
  "QUESTORIAL": "relating to a questor, also QUAESTORIAL [adj]\n",
  "QUESTORS": "QUESTOR, (Latin) an ancient Roman public treasurer or assistant military commander, also QUAESTOR [n]\n",
  "QUESTORSHIP": "the office of questor, also QUAESTORSHIP [n -S]\n",
  "QUESTORSHIPS": "QUESTORSHIP, the office of questor, also QUAESTORSHIP [n]\n",
  "QUESTRIST": "(Shakespeare) a seeker; a pursuer [n -S]\n",
  "QUESTRISTS": "QUESTRIST, (Shakespeare) a seeker; a pursuer [n]\n",
  "QUESTS": "QUEST, to make a search [v]\n",
  "QUETCH": "(dialect) to stir, move, also QUATCH, QUICH, QUINCHE, QUITCH [v -ED, -ING, -ES]\n",
  "QUETCHED": "QUETCH, (dialect) to stir, move, also QUATCH, QUICH, QUINCHE, QUITCH [v]\n",
  "QUETCHES": "QUETCH, (dialect) to stir, move, also QUATCH, QUICH, QUINCHE, QUITCH [v]\n",
  "QUETCHING": "QUETCH, (dialect) to stir, move, also QUATCH, QUICH, QUINCHE, QUITCH [v]\n",
  "QUETHE": "(obsolete) to quote [v QUOTH, QUETHING, QUETHES]\n",
  "QUETHES": "QUETHE, (obsolete) to quote [v]\n",
  "QUETHING": "QUETHE, (obsolete) to quote [v]\n",
  "QUETSCH": "(German) a spirit distilled from the fermented juice of plums [n -ES]\n",
  "QUETSCHES": "QUETSCH, (German) a spirit distilled from the fermented juice of plums [n]\n",
  "QUETZAL": "(Nahuatl) a tropical bird, also QUEZAL [n -ES or -S]\n",
  "QUETZALES": "QUETZAL, (Nahuatl) a tropical bird, also QUEZAL [n]\n",
  "QUETZALS": "QUETZAL, (Nahuatl) a tropical bird, also QUEZAL [n]\n",
  "QUEUE": "to line up for service [v QUEUED, QUEUEING, QUEUES]\n",
  "QUEUED": "QUEUE, to line up for service [v]\n",
  "QUEUEING": "the act of lining up, also QUEUING [n -S]\n",
  "QUEUEINGS": "QUEUEING, the act of lining up, also QUEUING [n]\n",
  "QUEUER": "one who lines up [n -S]\n",
  "QUEUERS": "QUEUER, one who lines up [n]\n",
  "QUEUES": "QUEUE, to line up for service [v]\n",
  "QUEUING": "the act of lining up, also QUEUEING [n -S]\n",
  "QUEUINGS": "QUEUING, the act of lining up, also QUEUEING [n]\n",
  "QUEY": "(Scots) a heifer [n -S]\n",
  "QUEYN": "(Scots) a young woman, also QUEAN, QUEYNIE, QUINE, QUINIE [n -S]\n",
  "QUEYNIE": "(Scots) diminutive of queyn, a girl, also QUEAN, QUEYN, QUINE, QUINIE [n -S]\n",
  "QUEYNIES": "QUEYNIE, (Scots) diminutive of queyn, a girl, also QUEAN, QUEYN, QUINE, QUINIE [n]\n",
  "QUEYNS": "QUEYN, (Scots) a young woman, also QUEAN, QUEYNIE, QUINE, QUINIE [n]\n",
  "QUEYS": "QUEY, (Scots) a heifer [n]\n",
  "QUEZAL": "(Nahuatl) a tropical bird, also QUETZAL [n -ES or -S]\n",
  "QUEZALES": "QUEZAL, (Nahuatl) a tropical bird, also QUETZAL [n]\n",
  "QUEZALS": "QUETZAL, (Nahuatl) a tropical bird, also QUEZAL [n]\n",
  "QUIBBLE": "to argue over petty matters [v QUIBBLED, QUIBBLING, QUIBBLES]\n",
  "QUIBBLED": "QUIBBLE, to argue over petty matters [v]\n",
  "QUIBBLER": "one who quibbles [n -S]\n",
  "QUIBBLERS": "QUIBBLER, one who quibbles [n]\n",
  "QUIBBLES": "QUIBBLE, to argue over petty matters [v]\n",
  "QUIBBLING": "arguing over trivialities [adj QUIBBLINGLY] / the act of quibbling [n -S]\n",
  "QUIBBLINGLY": "QUIBBLING, arguing over trivialities [adv]\n",
  "QUIBBLINGS": "QUIBBLING, the act of quibbling [n]\n",
  "QUIBLIN": "(obsolete) a quibble, also QUILLET [n -S]\n",
  "QUIBLINS": "QUIBLIN, (obsolete) a quibble, also QUILLET [n]\n",
  "QUICH": "(Spenser) to stir, move, also QUATCH, QUETCH, QUINCHE, QUITCH [v -ED, -ING, -ES]\n",
  "QUICHE": "(French) a flan of plain pastry filled with a cooked egg mixture [n -S]\n",
  "QUICHED": "QUICH, (Spenser) to stir, move, also QUATCH, QUETCH, QUINCHE, QUITCH [v]\n",
  "QUICHES": "QUICH, (Spenser) to stir, move, also QUATCH, QUETCH, QUINCHE, QUITCH [v]\n",
  "QUICHING": "QUICH, (Spenser) to stir, move, also QUATCH, QUETCH, QUINCHE, QUITCH [v]\n",
  "QUICK": "acting or capable of acting with speed [adj QUICKER, QUICKEST, QUICKLY] / a sensitive area of flesh [n -S]\n",
  "QUICKBEAM": "the hawthorn [n -S]\n",
  "QUICKBEAMS": "QUICKBEAM, the hawthorn [n]\n",
  "QUICKEN": "to speed up [v -ED, -ING, -S]\n",
  "QUICKENED": "QUICKEN, to speed up [v]\n",
  "QUICKENER": "one who quickens [n -S]\n",
  "QUICKENERS": "QUICKENER, one who quickens [n]\n",
  "QUICKENING": "the act of quickening [n -S]\n",
  "QUICKENINGS": "QUICKENING, the act of quickening [n]\n",
  "QUICKENS": "QUICKEN, to speed up [v]\n",
  "QUICKER": "QUICK, acting or capable of acting with speed [adj]\n",
  "QUICKEST": "QUICK, acting or capable of acting with speed [adj]\n",
  "QUICKFIRE": "rapid, as question and answer [adj]\n",
  "QUICKIE": "(colloquial) a hurried act of sexual intercourse, also QUICKY [n -S]\n",
  "QUICKIES": "QUICKIE, (colloquial) a hurried act of sexual intercourse, also QUICKY [n]\n",
  "QUICKLIME": "unslaked lime, calcium oxide [n -S]\n",
  "QUICKLIMES": "QUICKLIME, unslaked lime, calcium oxide [n]\n",
  "QUICKLY": "QUICK, acting or capable of acting with speed [adv]\n",
  "QUICKNESS": "the state of being quick [n -ES]\n",
  "QUICKNESSES": "QUICKNESS, the state of being quick [n]\n",
  "QUICKS": "QUICK, a sensitive area of flesh [n]\n",
  "QUICKSAND": "a loose watery sand which swallows up anyone who walks on it [n -S]\n",
  "QUICKSANDS": "QUICKSAND, a loose watery sand which swallows up anyone who walks on it [n]\n",
  "QUICKSET": "a living plant suitable for hedges [n -S]\n",
  "QUICKSETS": "QUICKSET, a living plant suitable for hedges [n]\n",
  "QUICKSILVER": "an old name for mercury [n -S] / to coat with quicksilver [v -ED, -ING, -S]\n",
  "QUICKSILVERED": "QUICKSILVER, to coat with quicksilver [v]\n",
  "QUICKSILVERIER": "QUICKSILVERY, like quicksilver [adj]\n",
  "QUICKSILVERIEST": "QUICKSILVERY, like quicksilver [adj]\n",
  "QUICKSILVERING": "the mercury on the back of a mirror [n -S]\n",
  "QUICKSILVERINGS": "QUICKSILVERING, the mercury on the back of a mirror [n]\n",
  "QUICKSILVERISH": "somewhat like quicksilver [adj]\n",
  "QUICKSILVERS": "QUICKSILVER, an old name for mercury [n]\n",
  "QUICKSILVERY": "like quicksilver [adj QUICKSILVERIER, QUICKSILVERIEST]\n",
  "QUICKSTEP": "a fast marchlike dance [n -S] / to do the quickstep [v QUICKSTEPPED, QUICKSTEPPING, QUICKSTEPS]\n",
  "QUICKSTEPPED": "QUICKSTEP, to do the quickstep [v]\n",
  "QUICKSTEPPING": "QUICKSTEP, to do the quickstep [v]\n",
  "QUICKSTEPS": "QUICKSTEP, a fast marchlike dance [n]\n",
  "QUICKTHORN": "hawthorn [n -S]\n",
  "QUICKTHORNS": "QUICKTHORN, hawthorn [n]\n",
  "QUICKY": "(colloquial) a hurried act of sexual intercourse, also QUICKIE [n QUICKIES]\n",
  "QUID": "a cut or wad or something chewable [n -S]\n",
  "QUIDAM": "(Latin) a certain person; somebody [n -S]\n",
  "QUIDAMS": "QUIDAM, (Latin) a certain person; somebody [n]\n",
  "QUIDDANIED": "QUIDDANY, to make into quince jelly [v]\n",
  "QUIDDANIES": "QUIDDANY, a jelly or thick syrup made from sweetened quince juice [n]\n",
  "QUIDDANY": "a jelly or thick syrup made from sweetened quince juice [n QUIDDANIES] / to make into quince jelly [v QUIDDANIED, QUIDDANYING, QUIDDANIES]\n",
  "QUIDDANYING": "QUIDDANY, to make into quince jelly [v]\n",
  "QUIDDIT": "(archaic) the inherent nature or essence of anything; any trifling nicety; a quibble, also QUIDDITY [n -S]\n",
  "QUIDDITATIVE": "of the nature of a quiddity, trifling [adj]\n",
  "QUIDDITCH": "an imaginary game played on broomsticks [n -ES]\n",
  "QUIDDITCHES": "QUIDDITCH, an imaginary game played on broomsticks [n]\n",
  "QUIDDITIES": "QUIDDITY, the inherent nature of something, also QUIDDIT [n]\n",
  "QUIDDITS": "QUIDDIT, (archaic) the inherent nature or essence of anything; any trifling nicety; a quibble, also QUIDDITY [n]\n",
  "QUIDDITY": "the inherent nature of something, also QUIDDIT [n QUIDDITIES]\n",
  "QUIDDLE": "(dialect) to trifle [v QUIDDLED, QUIDDLING, QUIDDLES]\n",
  "QUIDDLED": "QUIDDLE, (dialect) to trifle [v]\n",
  "QUIDDLER": "someone who quiddles [n -S]\n",
  "QUIDDLERS": "QUIDDLER, someone who quiddles [n]\n",
  "QUIDDLES": "QUIDDLE, (dialect) to trifle [v]\n",
  "QUIDDLING": "QUIDDLE, (dialect) to trifle [v]\n",
  "QUIDNUNC": "(Latin) one who seeks to know all the latest news or gossip, a busybody [n -S]\n",
  "QUIDNUNCS": "QUIDNUNC, (Latin) one who seeks to know all the latest news or gossip, a busybody [n]\n",
  "QUIDS": "QUID, a cut or wad or something chewable [n]\n",
  "QUIESCE": "to quieten down [v QUIESCED, QUIESCING, QUIESCES]\n",
  "QUIESCED": "QUIESCE, to quieten down [v]\n",
  "QUIESCENCE": "the state of being quiescent, also QUIESCENCY [n -S]\n",
  "QUIESCENCES": "QUIESCENCE, the state of being quiescent, also QUIESCENCY [n]\n",
  "QUIESCENCIES": "QUIESCENCY, the state of being quiescent, also QUIESCENCE [n]\n",
  "QUIESCENCY": "the state of being quiescent, also QUIESCENCE [n QUIESCENCIES]\n",
  "QUIESCENT": "resting, dormant [adj QUIESCENTLY]\n",
  "QUIESCENTLY": "QUIESCENT, resting, dormant [adv]\n",
  "QUIESCES": "QUIESCE, to quieten down [v]\n",
  "QUIESCING": "QUIESCE, to quieten down [v]\n",
  "QUIET": "making little or no noise [adj QUIETER, QUIETEST, QUIETLY] / to cause to be quiet [v -ED, -ING, -S]\n",
  "QUIETED": "QUIET, to cause to be quiet [v]\n",
  "QUIETEN": "to make quiet [v -ED, -ING, -S]\n",
  "QUIETENED": "QUIETEN, to make quiet [v]\n",
  "QUIETENER": "one who quietens [n -S]\n",
  "QUIETENERS": "QUIETENER, one who quietens [n]\n",
  "QUIETENING": "the act of quietening [n -S]\n",
  "QUIETENINGS": "QUIETENING, the act of quietening [n]\n",
  "QUIETENS": "QUIETEN, to make quiet [v]\n",
  "QUIETER": "one who quiets [n -S]\n",
  "QUIETERS": "QUIETER, one who quiets [n]\n",
  "QUIETEST": "QUIET, making little or no noise [adj]\n",
  "QUIETING": "the act of making quiet [n -S]\n",
  "QUIETINGS": "QUIETING, the act of making quiet [n]\n",
  "QUIETISM": "a doctrine of passive religious contemplation [n -S]\n",
  "QUIETISMS": "QUIETISM, a doctrine of passive religious contemplation [n]\n",
  "QUIETIST": "one who believes in quietism [n -S]\n",
  "QUIETISTIC": "of or pertaining to the Quietists, or to Quietism [adj]\n",
  "QUIETISTS": "QUIETIST, one who believes in quietism [n]\n",
  "QUIETIVE": "a sedative [n -S]\n",
  "QUIETIVES": "QUIETIVE, a sedative [n]\n",
  "QUIETLY": "QUIET, making little or no noise [adv]\n",
  "QUIETNESS": "the state of being quiet [n -ES]\n",
  "QUIETNESSES": "QUIETNESS, the state of being quiet [n]\n",
  "QUIETS": "QUIET, to cause to be quiet [v]\n",
  "QUIETSOME": "(Spenser) undisturbed [adj]\n",
  "QUIETUDE": "tranquillity [n -S]\n",
  "QUIETUDES": "QUIETUDE, tranquillity [n]\n",
  "QUIETUS": "(Latin) a final settlement [n -ES]\n",
  "QUIETUSES": "QUIETUS, (Latin) a final settlement [n]\n",
  "QUIFF": "a tuft of hair brushed away from the forehead [n -S]\n",
  "QUIFFED": "having a quiff [adj]\n",
  "QUIFFS": "QUIFF, a tuft of hair brushed away from the forehead [n]\n",
  "QUIGHT": "(Spenser) to quit, depart from, also QUYTE [v -ED, -ING, -S]\n",
  "QUIGHTED": "QUIGHT, (Spenser) to quit, depart from, also QUYTE [v]\n",
  "QUIGHTING": "QUIGHT, (Spenser) to quit, depart from, also QUYTE [v]\n",
  "QUIGHTS": "QUIGHT, (Spenser) to quit, depart from, also QUYTE [v]\n",
  "QUILL": "to press small ridges in [v -ED, -ING, -S]\n",
  "QUILLAI": "the soapbark tree, a rosaceous tree native to Chile, also CULLAY, QUILLAIA, QUILLAJA [n -S]\n",
  "QUILLAIA": "an evergreen tree, also QUILLAI, QUILLAJA [n -S]\n",
  "QUILLAIAS": "QUILLAIA, an evergreen tree, also QUILLAI, QUILLAJA [n]\n",
  "QUILLAIS": "QUILLAI, the soapbark tree, a rosaceous tree native to Chile, also CULLAY, QUILLAIA, QUILLAJA [n]\n",
  "QUILLAJA": "the soapbark tree, a rosaceous tree native to Chile, also CULLAY, QUILLAI, QUILLAIA [n -S]\n",
  "QUILLAJAS": "QUILLAJA, the soapbark tree, a rosaceous tree native to Chile, also CULLAY, QUILLAI, QUILLAIA [n]\n",
  "QUILLBACK": "an American freshwater fish [n -S]\n",
  "QUILLBACKS": "QUILLBACK, an American freshwater fish [n]\n",
  "QUILLED": "QUILL, to press small ridges in [v]\n",
  "QUILLET": "(archaic) a quibble, also QUIBLIN [n -S]\n",
  "QUILLETS": "QUILLET, (archaic) a quibble, also QUIBLIN [n]\n",
  "QUILLING": "a strip or ribbon gathered into flutings [n -S]\n",
  "QUILLINGS": "QUILLING, a strip or ribbon gathered into flutings [n]\n",
  "QUILLMAN": "a clerk [n QUILLMEN]\n",
  "QUILLMEN": "QUILLMAN, a clerk [n]\n",
  "QUILLON": "(French) the arm of the cross-guard of a sword handle [n -S]\n",
  "QUILLONS": "QUILLON, (French) the arm of the cross-guard of a sword handle [n]\n",
  "QUILLOW": "a quilt made into a pillow [n -S]\n",
  "QUILLOWS": "QUILLOW, a quilt made into a pillow [n]\n",
  "QUILLS": "QUILL, to press small ridges in [v]\n",
  "QUILLWORK": "ornamental work in porcupine quills [n -S]\n",
  "QUILLWORKS": "QUILLWORK, ornamental work in porcupine quills [n]\n",
  "QUILLWORT": "an aquatic plant with hollow stems [n -S]\n",
  "QUILLWORTS": "QUILLWORT, an aquatic plant with hollow stems [n]\n",
  "QUILT": "to stitch together with padding in between [v -ED, -ING, -S]\n",
  "QUILTED": "QUILT, to stitch together with padding in between [v]\n",
  "QUILTER": "one who makes quilts [n -S]\n",
  "QUILTERS": "QUILTER, one who makes quilts [n]\n",
  "QUILTING": "the act of making quilts [n -S]\n",
  "QUILTINGS": "QUILTING, the act of making quilts [n]\n",
  "QUILTS": "QUILT, to stitch together with padding in between [v]\n",
  "QUIM": "(vulgar slang) the female genitalia [n -S]\n",
  "QUIMS": "QUIM, (vulgar slang) the female genitalia [n]\n",
  "QUIN": "(short for) a quintuplet [n -S]\n",
  "QUINA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, KINAKINA, QUINAQUINA, QUINQUINA [n -S]\n",
  "QUINACRINE": "another name for mepacrine, a bitter yellow powder, formerly used against malaria [n -S]\n",
  "QUINACRINES": "QUINACRINE, another name for mepacrine, a bitter yellow powder, formerly used against malaria [n]\n",
  "QUINALBARBITONE": "an anaesthetic and sedative drug derived from barbiturate, aka secobarbital [n]\n",
  "QUINAQUINA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, KINAKINA, QUINA, QUINQUINA [n -S]\n",
  "QUINAQUINAS": "QUINAQUINA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, KINAKINA, QUINA, QUINQUINA [n]\n",
  "QUINARIES": "QUINARY, a set of five [n]\n",
  "QUINARY": "a set of five [n QUINARIES]\n",
  "QUINAS": "QUINA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, KINAKINA, QUINAQUINA, QUINQUINA [n]\n",
  "QUINATE": "arranged in groups of five [adj]\n",
  "QUINCE": "a fragrant, acid fruit [n -S]\n",
  "QUINCENTENARIES": "QUINCENTENARY, a five-hundredth anniversary, also QUINGENTENARY [n]\n",
  "QUINCENTENARY": "pertaining to a five-hundredth anniversary [adj] / a five-hundredth anniversary, also QUINGENTENARY [n QUINCENTENARIES]\n",
  "QUINCENTENNIAL": "a five hundred year anniversary [n -S]\n",
  "QUINCENTENNIALS": "QUINCENTENNIAL, a five hundred year anniversary [n]\n",
  "QUINCES": "QUINCE, a fragrant, acid fruit [n]\n",
  "QUINCHE": "(Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUITCH [v QUINCHED, QUINCHING, QUINCHES]\n",
  "QUINCHED": "QUINCHE, (Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUITCH [v]\n",
  "QUINCHES": "QUINCHE, (Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUITCH [v]\n",
  "QUINCHING": "QUINCHE, (Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUITCH [v]\n",
  "QUINCUNCIAL": "of or like a quincunx, also QUINCUNXIAL [adj QUINCUNCIALLY]\n",
  "QUINCUNCIALLY": "QUINCUNCIAL, of or like a quincunx, also QUINCUNXIAL [adv]\n",
  "QUINCUNX": "(Latin) an arrangement of five things [n -ES]\n",
  "QUINCUNXES": "QUINCUNX, (Latin) an arrangement of five things [n]\n",
  "QUINCUNXIAL": "of or like a quincunx, also QUINCUNCIAL [adj]\n",
  "QUINDECAGON": "a geometric figure having fifteen sides and fifteen angles [n -S]\n",
  "QUINDECAGONS": "QUINDECAGON, a geometric figure having fifteen sides and fifteen angles [n]\n",
  "QUINDECAPLET": "a group of fifteen [n -S]\n",
  "QUINDECAPLETS": "QUINDECAPLET, a group of fifteen [n]\n",
  "QUINDECENNIAL": "a fifteenth anniversary [n -S]\n",
  "QUINDECENNIALS": "QUINDECENNIAL, a fifteenth anniversary [n]\n",
  "QUINDECILLION": "ten to the power of 48, or in Britain ten to the power of 90 [n -S]\n",
  "QUINDECILLIONS": "QUINDECILLION, ten to the power of 48, or in Britain ten to the power of 90 [n]\n",
  "QUINE": "(Scots) a young woman, also QUEAN, QUEYN, QUEYNIE, QUINIE [n -S]\n",
  "QUINELA": "(Spanish) a bet whereby the bettor must pick first two winners of a race but not necessarily in order, also QUINELLA, QUINIELA [n -S]\n",
  "QUINELAS": "QUINELA, (Spanish) a bet whereby the bettor must pick first two winners of a race but not necessarily in order, also QUINELLA, QUINIELA [n]\n",
  "QUINELLA": "(Spanish) a bet whereby the bettor must pick first two winners of a race but not necessarily in order, also QUINELA, QUINIELA [n -S]\n",
  "QUINELLAS": "QUINELLA, (Spanish) a bet whereby the bettor must pick first two winners of a race but not necessarily in order, also QUINELA, QUINIELA [n]\n",
  "QUINES": "QUINE, (Scots) a young woman, also QUEAN, QUEYN, QUEYNIE, QUINIE [n]\n",
  "QUINGENTENARIES": "QUINGENTENARY, a five-hundredth anniversary, also QUINCENTENARY [n]\n",
  "QUINGENTENARY": "pertaining to a five-hundredth anniversary [adj] / a five-hundredth anniversary, also QUINCENTENARY [n QUINGENTENARIES]\n",
  "QUINIC": "as in quinic acid, an acid derived from cinchona bark [adj]\n",
  "QUINIDINE": "a cinchona alkaloid, which is an optically active isomer of quinine and is used to treat cardiac arrhythmia [n -S]\n",
  "QUINIDINES": "QUINIDINE, a cinchona alkaloid, which is an optically active isomer of quinine and is used to treat cardiac arrhythmia [n]\n",
  "QUINIE": "(Scots) a young woman, also QUEAN, QUEYN, QUEYNIE, QUINE [n -S]\n",
  "QUINIELA": "(Spanish) a bet whereby the bettor must pick first two winners of a race but not necessarily in order, also QUINELA, QUINELLA [n -S]\n",
  "QUINIELAS": "QUINIELA, (Spanish) a bet whereby the bettor must pick first two winners of a race but not necessarily in order, also QUINELA, QUINELLA [n]\n",
  "QUINIES": "QUINIE, (Scots) a young woman, also QUEAN, QUEYN, QUEYNIE, QUINE [n]\n",
  "QUININ": "a colourless, bitter alkaloid obtained from cinchona bark, used as an antipyretic or analgesic, also QUININA, QUININE [n -S]\n",
  "QUININA": "a colourless, bitter alkaloid obtained from cinchona bark, used as an antipyretic or analgesic, also QUININ, QUININE [n -S]\n",
  "QUININAS": "QUININA, a colourless, bitter alkaloid obtained from cinchona bark, used as an antipyretic or analgesic, also QUININ, QUININE [n]\n",
  "QUININE": "a colourless, bitter alkaloid obtained from cinchona bark, used as an antipyretic or analgesic, also QUININ, QUININA [n -S]\n",
  "QUININES": "QUININE, a colourless, bitter alkaloid obtained from cinchona bark, used as an antipyretic or analgesic, also QUININ, QUININA [n]\n",
  "QUININS": "QUININ, a colourless, bitter alkaloid obtained from cinchona bark, used as an antipyretic or analgesic, also QUININA, QUININE [n]\n",
  "QUINNAT": "(Native American) a fish, the king-salmon [n -S]\n",
  "QUINNATS": "QUINNAT, (Native American) a fish, the king-salmon [n]\n",
  "QUINO": "a game of chance, also KENO, KEENO, KINO [n -S]\n",
  "QUINOA": "(Quechua) a South American goosefoot, with seeds used as rice [n -S]\n",
  "QUINOAS": "QUINOA, (Quechua) a South American goosefoot, with seeds used as rice [n]\n",
  "QUINOID": "a quinonoid substance [n -S]\n",
  "QUINOIDAL": "of or like quinoid, a quinonoid substance [adj]\n",
  "QUINOIDS": "QUINOID, a quinonoid substance [n]\n",
  "QUINOL": "a reducing agent obtained from quinone [n -S]\n",
  "QUINOLIN": "a pungent, colourless, oily liquid, first obtained from quinine and used e.g. as a food preservative, also QUINOLINE [n -S]\n",
  "QUINOLINE": "a pungent, colourless, oily liquid, first obtained from quinine and used e.g. as a food preservative, also QUINOLIN [n -S]\n",
  "QUINOLINES": "QUINOLINE, a pungent, colourless, oily liquid, first obtained from quinine and used e.g. as a food preservative, also QUINOLIN [n]\n",
  "QUINOLINS": "QUINOLIN, a pungent, colourless, oily liquid, first obtained from quinine and used e.g. as a food preservative, also QUINOLINE [n]\n",
  "QUINOLONE": "any of a group of antibiotics used esp. against infections of the urinary or respiratory tracts [n -S]\n",
  "QUINOLONES": "QUINOLONE, any of a group of antibiotics used esp. against infections of the urinary or respiratory tracts [n]\n",
  "QUINOLS": "QUINOL, a reducing agent obtained from quinone [n]\n",
  "QUINONE": "a crystalline derivative of aniline, also CHINONE, KINONE [n -S]\n",
  "QUINONES": "QUINONE, a crystalline derivative of aniline, also CHINONE, KINONE [n]\n",
  "QUINONOID": "like a quinone [adj]\n",
  "QUINOS": "QUINO, a game of chance, also KENO, KEENO, KINO [n]\n",
  "QUINQUAGENARIAN": "aged between fifty and sixty [adj] / a person in the fiftieth to sixtieth year of life [n]\n",
  "QUINQUAGESIMAL": "consisting of fifty days [adj]\n",
  "QUINQUECOSTATE": "five-ribbed [adj]\n",
  "QUINQUEFARIOUS": "arranged in five rows [adj]\n",
  "QUINQUEFOLIATE": "having five leaves [adj]\n",
  "QUINQUENNIA": "QUINQUENNIUM, a period of five years, also QUINQUENNIAD [n]\n",
  "QUINQUENNIAD": "a period of five years, also QUINQUENNIUM [n -S]\n",
  "QUINQUENNIADS": "QUINQUENNIAD, a period of five years, also QUINQUENNIUM [n]\n",
  "QUINQUENNIAL": "lasting five years; occurring every fifth year [adj QUINQUENNIALLY] / an anniversary recurring every five years [n -S]\n",
  "QUINQUENNIALLY": "QUINQUENNIAL, lasting five years; occurring every fifth year [adv]\n",
  "QUINQUENNIALS": "QUINQUENNIAL, an anniversary recurring every five years [n]\n",
  "QUINQUENNIUM": "a period of five years, also QUINQUENNIAD [n QUINQUENNIA or QUINQUENNIUMS]\n",
  "QUINQUENNIUMS": "QUINQUENNIUM, a period of five years, also QUINQUENNIAD [n]\n",
  "QUINQUEPARTITE": "divided into or composed of five parts [adj]\n",
  "QUINQUEREME": "an ancient ship with five banks of oars [n -S]\n",
  "QUINQUEREMES": "QUINQUEREME, an ancient ship with five banks of oars [n]\n",
  "QUINQUEVALENCE": "pentavalency, also QUINQUEVALENCY, QUINQUIVALENCE, QUINQUIVALENCY [n -S]\n",
  "QUINQUEVALENCES": "QUINQUEVALENCE, pentavalency, also QUINQUEVALENCY, QUINQUIVALENCE, QUINQUIVALENCY [n]\n",
  "QUINQUEVALENCY": "pentavalency, also QUINQUEVALENCE, QUINQUIVALENCE, QUINQUIVALENCY [n]\n",
  "QUINQUEVALENT": "having a valency of five, also QUINQUIVALENT [adj]\n",
  "QUINQUINA": "(Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, KINAKINA, QUINA, QUINAQUINA [n -S]\n",
  "QUINQUINAS": "QUINQUINA, (Quechua) a tree yielding cinchona bark, from which quinine is made, also CHINACHINA, CINCHONA, KINA, KINAKINA, QUINA, QUINAQUINA [n]\n",
  "QUINQUIVALENCE": "the state of being quinquivalent, having a valency of five, also QUINQUEVALENCE, QUINQUEVALENCY, QUINQUIVALENCY [n -S]\n",
  "QUINQUIVALENCES": "QUINQUIVALENCE, the state of being quinquivalent, having a valency of five, also QUINQUEVALENCE, QUINQUEVALENCY, QUINQUIVALENCY [n]\n",
  "QUINQUIVALENCY": "the state of being quinquivalent, having a valency of five, also QUINQUEVALENCE, QUINQUEVALENCY, QUINQUIVALENCE [n]\n",
  "QUINQUIVALENT": "having a valency of five, also QUINQUEVALENT [adj]\n",
  "QUINS": "QUIN, (short for) a quintuplet [n]\n",
  "QUINSIED": "suffering from quinsy, severe inflammation of tonsils and throat [adj]\n",
  "QUINSIES": "QUINSY, severe inflammation of tonsils and throat [n]\n",
  "QUINSY": "severe inflammation of tonsils and throat [n QUINSIES]\n",
  "QUINT": "a five-stringed tenor viol [n -S]\n",
  "QUINTA": "(Spanish) a country house in Spain or Portugal [n -S]\n",
  "QUINTAIN": "(historical) a post for the practice of tilting with a turning crosspiece [n -S]\n",
  "QUINTAINS": "QUINTAIN, (historical) a post for the practice of tilting with a turning crosspiece [n]\n",
  "QUINTAL": "(French) an old unit of weight equal to 100 kilograms [n -S]\n",
  "QUINTALS": "QUINTAL, (French) an old unit of weight equal to 100 kilograms [n]\n",
  "QUINTAN": "a malarial fever recurring every fifth day [n -S]\n",
  "QUINTANS": "QUINTAN, a malarial fever recurring every fifth day [n]\n",
  "QUINTAR": "(Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINDAR, QINTAR [n -S]\n",
  "QUINTARS": "QUINTAR, (Albanian) a monetary unit of Albania, equal to one-hundredth of a lek, also QINDAR, QINTAR [n]\n",
  "QUINTAS": "QUINTA, (Spanish) a country house in Spain or Portugal [n]\n",
  "QUINTE": "an attacking fencing position [n -S]\n",
  "QUINTES": "QUINTE, an attacking fencing position [n]\n",
  "QUINTESSENCE": "the pure, concentrated essence; the most perfect embodiment of something [n -S]\n",
  "QUINTESSENCES": "QUINTESSENCE, the pure, concentrated essence; the most perfect embodiment of something [n]\n",
  "QUINTESSENTIAL": "something that is a typical part or pure example [n -S]\n",
  "QUINTESSENTIALS": "QUINTESSENTIAL, something that is a typical part or pure example [n]\n",
  "QUINTET": "a group of five, also QUINTETT [n -S]\n",
  "QUINTETS": "QUINTET, a group of five, also QUINTETT [n]\n",
  "QUINTETT": "a composition for five voices or instruments, also QUINTET, QUINTETTE [n -S]\n",
  "QUINTETTE": "a composition for five voices or instruments, also QUINTET, QUINTETT [n -S]\n",
  "QUINTETTES": "QUINTETTE, a composition for five voices or instruments, also QUINTET, QUINTETT [n]\n",
  "QUINTETTI": "QUINTETTO, (Italian) a quintet [n]\n",
  "QUINTETTO": "(Italian) a quintet [n QUINTETTI]\n",
  "QUINTETTS": "QUINTETT, a composition for five voices or instruments, also QUINTET, QUINTETTE [n]\n",
  "QUINTIC": "an equation of the fifth degree [n -S]\n",
  "QUINTICS": "QUINTIC, an equation of the fifth degree [n]\n",
  "QUINTILE": "a frequency distribution [n -S]\n",
  "QUINTILES": "QUINTILE, a frequency distribution [n]\n",
  "QUINTILLION": "a thousand raised to the sixth power [n -S]\n",
  "QUINTILLIONS": "QUINTILLION, a thousand raised to the sixth power [n]\n",
  "QUINTILLIONTH": "the ordinal of quintillion [adj] / a quintillionth part [n -S]\n",
  "QUINTILLIONTHS": "QUINTILLIONTH, a quintillionth part [n]\n",
  "QUINTIN": "a kind of fine linen [n -S]\n",
  "QUINTINS": "QUINTIN, a kind of fine linen [n]\n",
  "QUINTROON": "an old term for someone who is of 1/16 black descent [n -S]\n",
  "QUINTROONS": "QUINTROON, an old term for someone who is of 1/16 black descent [n]\n",
  "QUINTS": "QUINT, a five-stringed tenor viol [n]\n",
  "QUINTUPLE": "fivefold [adj QUINTUPLY] / to make fivefold [v QUINTUPLED, QUINTUPLING, QUINTUPLES]\n",
  "QUINTUPLED": "QUINTUPLE, to make fivefold [v]\n",
  "QUINTUPLES": "QUINTUPLE, to make fivefold [v]\n",
  "QUINTUPLET": "one of five children born in one birth [n -S]\n",
  "QUINTUPLETS": "QUINTUPLET, one of five children born in one birth [n]\n",
  "QUINTUPLICATE": "to make quintuple or fivefold [v QUINTUPLICATED, QUINTUPLICATING, QUINTUPLICATES]\n",
  "QUINTUPLICATED": "QUINTUPLICATE, to make quintuple or fivefold [v]\n",
  "QUINTUPLICATES": "QUINTUPLICATE, to make quintuple or fivefold [v]\n",
  "QUINTUPLICATING": "QUINTUPLICATE, to make quintuple or fivefold [v]\n",
  "QUINTUPLICATION": "multiplication fivefold [n]\n",
  "QUINTUPLIES": "QUINTUPLY, in Scots law, a reply made to a defendant's quadruply [n]\n",
  "QUINTUPLING": "QUINTUPLE, to make fivefold [v]\n",
  "QUINTUPLY": "in Scots law, a reply made to a defendant's quadruply [n QUINTUPLIES]\n",
  "QUINZE": "(French) a card game [n -S]\n",
  "QUINZES": "QUINZE, (French) a card game [n]\n",
  "QUINZHEE": "(Inuit) a shelter made by hollowing out a pile of snow, also QUINZIE [n -S]\n",
  "QUINZHEES": "QUINZHEE, (Inuit) a shelter made by hollowing out a pile of snow, also QUINZIE [n]\n",
  "QUINZIE": "(Inuit) a shelter made by hollowing out a pile of snow, also QUINZHEE [n -S]\n",
  "QUINZIES": "QUINZIE, (Inuit) a shelter made by hollowing out a pile of snow, also QUINZHEE [n]\n",
  "QUIP": "to make witty remarks [v QUIPPED, QUIPPING, QUIPS]\n",
  "QUIPO": "(Quechua) a device of knotted cords, used by Incas of Peru to calculate or order information, also QUIPPU, QUIPU [n -S]\n",
  "QUIPOS": "QUIPO, (Quechua) a device of knotted cords, used by Incas of Peru to calculate or order information, also QUIPPU, QUIPU [n]\n",
  "QUIPPED": "QUIP, to make witty remarks [v]\n",
  "QUIPPER": "a person given to making clever remarks, also QUIPSTER [n -S]\n",
  "QUIPPERS": "QUIPPER, a person given to making clever remarks, also QUIPSTER [n]\n",
  "QUIPPIER": "QUIPPY, full of quips [adj]\n",
  "QUIPPIEST": "QUIPPY, full of quips [adj]\n",
  "QUIPPING": "QUIP, to make witty remarks [v]\n",
  "QUIPPISH": "given to making quips [adj]\n",
  "QUIPPU": "(Quechua) a device of knotted cords, used by Incas of Peru to calculate or order information, also QUIPO, QUIPU [n -S]\n",
  "QUIPPUS": "QUIPPU, (Quechua) a device of knotted cords, used by Incas of Peru to calculate or order information, also QUIPO, QUIPU [n]\n",
  "QUIPPY": "full of quips [adj QUIPPIER, QUIPPIEST]\n",
  "QUIPS": "QUIP, to make witty remarks [v]\n",
  "QUIPSTER": "a person given to making clever remarks, also QUIPPER [n -S]\n",
  "QUIPSTERS": "QUIPSTER, a person given to making clever remarks, also QUIPPER [n]\n",
  "QUIPU": "(Quechua) a device of knotted cords, used by Incas of Peru to calculate or order information, also QUIPO, QUIPPU [n -S]\n",
  "QUIPUS": "QUIPU, (Quechua) a device of knotted cords, used by Incas of Peru to calculate or order information, also QUIPO, QUIPPU [n]\n",
  "QUIRE": "to sing in concert [v QUIRED, QUIRING, QUIRES]\n",
  "QUIRED": "QUIRE, to sing in concert [v]\n",
  "QUIRES": "QUIRE, to sing in concert [v]\n",
  "QUIRING": "QUIRE, to sing in concert [v]\n",
  "QUIRISTER": "a member of a choir, also CHORALIST, CHORIST, CHORISTER [n -S]\n",
  "QUIRISTERS": "QUIRISTER, a member of a choir, also CHORALIST, CHORIST, CHORISTER [n]\n",
  "QUIRK": "to move jerkily [v -ED, -ING, -S]\n",
  "QUIRKED": "QUIRK, to move jerkily [v]\n",
  "QUIRKIER": "QUIRKY, twisted [adj]\n",
  "QUIRKIEST": "QUIRKY, twisted [adj]\n",
  "QUIRKILY": "QUIRKY, twisted [adv]\n",
  "QUIRKINESS": "the state of being quirky [n -ES]\n",
  "QUIRKINESSES": "QUIRKINESS, the state of being quirky [n]\n",
  "QUIRKING": "QUIRK, to move jerkily [v]\n",
  "QUIRKISH": "in a twisted way [adj]\n",
  "QUIRKS": "QUIRK, to move jerkily [v]\n",
  "QUIRKY": "twisted [adj QUIRKIER, QUIRKIEST, QUIRKILY]\n",
  "QUIRT": "to strike with a horse whip [v -ED, -ING, -S]\n",
  "QUIRTED": "QUIRT, to strike with a horse whip [v]\n",
  "QUIRTING": "QUIRT, to strike with a horse whip [v]\n",
  "QUIRTS": "QUIRT, to strike with a horse whip [v]\n",
  "QUISLING": "(Norwegian) a puppet leader supported by a foreign power [n -S]\n",
  "QUISLINGISM": "being a quisling [n -S]\n",
  "QUISLINGISMS": "QUISLINGISM, being a quisling [n]\n",
  "QUISLINGS": "QUISLING, (Norwegian) a puppet leader supported by a foreign power [n]\n",
  "QUIST": "a pigeon, also CUSHAT, QUEEST, QUOIST [n -S]\n",
  "QUISTS": "QUIST, a pigeon, also CUSHAT, QUEEST, QUOIST [n]\n",
  "QUIT": "to end one's engagement in or occupation with, also QUIGHT, QUITE, QUYTE [v QUIT or QUITTED, QUITTING, QUITS]\n",
  "QUITCH": "(Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUINCHE [v -ED, -ING, -ES]\n",
  "QUITCHED": "QUITCH, (Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUINCHE [v]\n",
  "QUITCHES": "QUITCH, (Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUINCHE [v]\n",
  "QUITCHING": "QUITCH, (Spenser) to stir, move, also QUATCH, QUETCH, QUICH, QUINCHE [v]\n",
  "QUITCLAIM": "to draw up a quitclaim, a deed relinquishing a claim, such as a mining title [v -ED, -ING, -S]\n",
  "QUITCLAIMED": "QUITCLAIM, to draw up a quitclaim, a deed relinquishing a claim, such as a mining title [v]\n",
  "QUITCLAIMING": "QUITCLAIM, to draw up a quitclaim, a deed relinquishing a claim, such as a mining title [v]\n",
  "QUITCLAIMS": "QUITCLAIM, to draw up a quitclaim, a deed relinquishing a claim, such as a mining title [v]\n",
  "QUITE": "to depart from or stop, also QUIT [v QUITED, QUITING, QUITES]\n",
  "QUITED": "QUITE, to depart from or stop, also QUIT [v]\n",
  "QUITES": "QUITE, to depart from or stop, also QUIT [v]\n",
  "QUITING": "QUITE, to depart from or stop, also QUIT [v]\n",
  "QUITRENT": "a small nominal rent paid to commute feudal service [n -S]\n",
  "QUITRENTS": "QUITRENT, a small nominal rent paid to commute feudal service [n]\n",
  "QUITS": "QUIT, to end one's engagement in or occupation with, also QUIGHT, QUITE, QUYTE [v]\n",
  "QUITTAL": "(Shakespeare) requital [n -S]\n",
  "QUITTALS": "QUITTAL, (Shakespeare) requital [n]\n",
  "QUITTANCE": "a release from debt [n -S] / to repay [v QUITTANCED, QUITTANCING, QUITTANCES]\n",
  "QUITTANCED": "QUITTANCE, to repay [v]\n",
  "QUITTANCES": "QUITTANCE, to repay [v]\n",
  "QUITTANCING": "QUITTANCE, to repay [v]\n",
  "QUITTED": "QUIT, to end one's engagement in or occupation with, also QUIGHT, QUITE, QUYTE [v]\n",
  "QUITTER": "one who quits, gives up [n -S]\n",
  "QUITTERS": "QUITTER, one who quits, gives up [n]\n",
  "QUITTING": "QUIT, to end one's engagement in or occupation with, also QUIGHT, QUITE, QUYTE [v]\n",
  "QUITTOR": "a fistulous sore on a horse's hoof [n -S]\n",
  "QUITTORS": "QUITTOR, a fistulous sore on a horse's hoof [n]\n",
  "QUIVER": "to shake slightly [v -ED, -ING, -S]\n",
  "QUIVERED": "QUIVER, to shake slightly [v]\n",
  "QUIVERER": "one who quivers [n -S]\n",
  "QUIVERERS": "QUIVERER, one who quivers [n]\n",
  "QUIVERFUL": "the contents of a quiver [n QUIVERFULS or QUIVERSFUL]\n",
  "QUIVERFULS": "QUIVERFUL, the contents of a quiver [n]\n",
  "QUIVERIER": "QUIVERY, quivering [adj]\n",
  "QUIVERIEST": "QUIVERY, quivering [adj]\n",
  "QUIVERING": "shaking with a slight but rapid motion [adj QUIVERINGLY] / the act of quivering [n -S]\n",
  "QUIVERINGLY": "QUIVERING, shaking with a slight but rapid motion [adv]\n",
  "QUIVERINGS": "QUIVERING, the act of quivering [n]\n",
  "QUIVERISH": "shaky, quivering [adj]\n",
  "QUIVERS": "QUIVER, to shake slightly [v]\n",
  "QUIVERSFUL": "QUIVERFUL, the contents of a quiver [n]\n",
  "QUIVERY": "quivering [adj QUIVERIER, QUIVERIEST]\n",
  "QUIXOTE": "a quixotic person [n -S]\n",
  "QUIXOTES": "QUIXOTE, a quixotic person [n]\n",
  "QUIXOTIC": "extravagantly and romantically chivalrous; idealistic, also QUIXOTICAL [adj QUIXOTICALLY]\n",
  "QUIXOTICAL": "extravagantly and romantically chivalrous; idealistic, also QUIXOTIC [adj QUIXOTICALLY]\n",
  "QUIXOTICALLY": "QUIXOTICAL, extravagantly and romantically chivalrous; idealistic, also QUIXOTIC [adv]\n",
  "QUIXOTISM": "quixotic principles, character, or practice; a quixotic action, statement, or idea, also QUIXOTRY [n -S]\n",
  "QUIXOTISMS": "QUIXOTISM, quixotic principles, character, or practice; a quixotic action, statement, or idea, also QUIXOTRY [n]\n",
  "QUIXOTRIES": "QUIXOTRY, quixotic principles, character, or practice; a quixotic action, statement, or idea, also QUIXOTISM [n]\n",
  "QUIXOTRY": "quixotic principles, character, or practice; a quixotic action, statement, or idea, also QUIXOTISM [n QUIXOTRIES]\n",
  "QUIZ": "to interrogate [v QUIZZED, QUIZZING, QUIZZES]\n",
  "QUIZMASTER": "one who puts the questions to contestants in a quiz show [n -S]\n",
  "QUIZMASTERS": "QUIZMASTER, one who puts the questions to contestants in a quiz show [n]\n",
  "QUIZZED": "QUIZ, to interrogate [v]\n",
  "QUIZZER": "one who quizzes [n -S]\n",
  "QUIZZERIES": "QUIZZERY, the act of interrogation [n]\n",
  "QUIZZERS": "QUIZZER, one who quizzes [n]\n",
  "QUIZZERY": "the act of interrogation [n QUIZZERIES]\n",
  "QUIZZES": "QUIZ, to interrogate [v]\n",
  "QUIZZICAL": "mocking, questioning [adj QUIZZICALLY]\n",
  "QUIZZICALITIES": "QUIZZICALITY, the state of being quizzical [n]\n",
  "QUIZZICALITY": "the state of being quizzical [n QUIZZICALITIES]\n",
  "QUIZZICALLY": "QUIZZICAL, mocking, questioning [adv]\n",
  "QUIZZIFICATION": "quizzing [n -S]\n",
  "QUIZZIFICATIONS": "QUIZZIFICATION, quizzing [n]\n",
  "QUIZZIFIED": "QUIZZIFY, (obsolete) to cause to look odd [v]\n",
  "QUIZZIFIES": "QUIZZIFY, (obsolete) to cause to look odd [v]\n",
  "QUIZZIFY": "(obsolete) to cause to look odd [v QUIZZIFIED, QUIZZIFYING, QUIZZIFIES]\n",
  "QUIZZIFYING": "QUIZZIFY, (obsolete) to cause to look odd [v]\n",
  "QUIZZINESS": "oddness [n -ES]\n",
  "QUIZZINESSES": "QUIZZINESS, oddness [n]\n",
  "QUIZZING": "questioning [n -S]\n",
  "QUIZZINGS": "QUIZZING, questioning [n]\n",
  "QULLIQ": "(Inuit) a type of oil lamp used by the Inuit, also KUDLIK [n -S]\n",
  "QULLIQS": "QULLIQ, (Inuit) a type of oil lamp used by the Inuit, also KUDLIK [n]\n",
  "QUOAD": "(Latin) as far as [adv]\n",
  "QUOD": "to imprison [v QUODDED, QUODDING, QUODS]\n",
  "QUODDED": "QUOD, to imprison [v]\n",
  "QUODDING": "QUOD, to imprison [v]\n",
  "QUODLIBET": "(Latin) a philosophical or theological point proposed for disputation; a whimsical combination of familiar melodies or texts [n -S]\n",
  "QUODLIBETARIAN": "a self-satisfied, disputatious person [n -S]\n",
  "QUODLIBETARIANS": "QUODLIBETARIAN, a self-satisfied, disputatious person [n]\n",
  "QUODLIBETIC": "of or like a quodlibet, also QUODLIBETICAL [adj QUODLIBETICALLY]\n",
  "QUODLIBETICAL": "of or like a quodlibet, also QUODLIBETIC [adj QUODLIBETICALLY]\n",
  "QUODLIBETICALLY": "QUODLIBETICAL, of or like a quodlibet, also QUODLIBETIC [adv]\n",
  "QUODLIBETS": "QUODLIBET, (Latin) a philosophical or theological point proposed for disputation; a whimsical combination of familiar melodies or texts [n]\n",
  "QUODLIN": "a variety of elongated apple, also CODLIN, CODLING [n -S]\n",
  "QUODLINS": "QUODLIN, a variety of elongated apple, also CODLIN, CODLING [n]\n",
  "QUODS": "QUOD, to imprison [v]\n",
  "QUOHOG": "(Native American) a kind of clam, also COHOG, QUAHAUG, QUAHOG [n -S]\n",
  "QUOHOGS": "QUOHOG, (Native American) a kind of clam, also COHOG, QUAHAUG, QUAHOG [n]\n",
  "QUOIF": "to put the hair into a kind of close-fitting cap, also COIF [v -ED, -ING, -S]\n",
  "QUOIFED": "QUOIF, to put the hair into a kind of close-fitting cap, also COIF [v]\n",
  "QUOIFING": "QUOIF, to put the hair into a kind of close-fitting cap, also COIF [v]\n",
  "QUOIFS": "QUOIF, to put the hair into a kind of close-fitting cap, also COIF [v]\n",
  "QUOIN": "a wedge; a cornerstone [n -S] / to secure or raise by wedging [v -ED, -ING, -S]\n",
  "QUOINED": "QUOIN, to secure or raise by wedging [v]\n",
  "QUOINING": "the act of wedging [n -S]\n",
  "QUOININGS": "QUOINING, the act of wedging [n]\n",
  "QUOINS": "QUOIN, to secure or raise by wedging [v]\n",
  "QUOIST": "the ringdove or wood-pigeon, also QUEEST, QUIST [n -S]\n",
  "QUOISTS": "QUOIST, the ringdove or wood-pigeon, also QUEEST, QUIST [n]\n",
  "QUOIT": "a heavy flat ring thrown over a pin in a game like horseshoes [n -S] / to play at quoits [v -ED, -ING, -S]\n",
  "QUOITED": "QUOIT, to play at quoits [v]\n",
  "QUOITER": "one who plays quoits [n -S]\n",
  "QUOITERS": "QUOITER, one who plays quoits [n]\n",
  "QUOITING": "QUOIT, to play at quoits [v]\n",
  "QUOITS": "QUOIT, to play at quoits [v]\n",
  "QUOKKA": "(Native Australian) a small marsupial found in West Australia [n -S]\n",
  "QUOKKAS": "QUOKKA, (Native Australian) a small marsupial found in West Australia [n]\n",
  "QUOLL": "(Native Australian) an Australian marsupial, about the size of a cat [n -S]\n",
  "QUOLLS": "QUOLL, (Native Australian) an Australian marsupial, about the size of a cat [n]\n",
  "QUOMODO": "(Latin) a means or manner [n -S]\n",
  "QUOMODOS": "QUOMODO, (Latin) a means or manner [n]\n",
  "QUONDAM": "(Latin) former, erstwhile [adj]\n",
  "QUONK": "to make an accidental disturbing noise too close to a microphone [v -ED, -ING, -S]\n",
  "QUONKED": "QUONK, to make an accidental disturbing noise too close to a microphone [v]\n",
  "QUONKING": "QUONK, to make an accidental disturbing noise too close to a microphone [v]\n",
  "QUONKS": "QUONK, to make an accidental disturbing noise too close to a microphone [v]\n",
  "QUOOKE": "QUAKE, to shake [v]\n",
  "QUOP": "(dialect) to throb [v QUOPPED, QUOPPING, QUOPS]\n",
  "QUOPPED": "QUOP, (dialect) to throb [v]\n",
  "QUOPPING": "QUOP, (dialect) to throb [v]\n",
  "QUOPS": "QUOP, (dialect) to throb [v]\n",
  "QUORATE": "having a quorum [adj]\n",
  "QUORUM": "(Latin) a minimum number of persons necessary for some business [n -S]\n",
  "QUORUMS": "QUORUM, (Latin) a minimum number of persons necessary for some business [n]\n",
  "QUOTA": "(Latin) a proportional share, a part assigned [n -S]\n",
  "QUOTABILITIES": "QUOTABILITY, the ability to be quoted [n]\n",
  "QUOTABILITY": "the ability to be quoted [n QUOTABILITIES]\n",
  "QUOTABLE": "capable of being quoted [adj QUOTABLY]\n",
  "QUOTABLENESS": "the state of being quotable [n -ES]\n",
  "QUOTABLENESSES": "QUOTABLENESS, the state of being quotable [n]\n",
  "QUOTABLY": "QUOTABLE, capable of being quoted [adv]\n",
  "QUOTAS": "QUOTA, (Latin) a proportional share, a part assigned [n]\n",
  "QUOTATION": "something quoted [n -S]\n",
  "QUOTATIONS": "QUOTATION, something quoted [n]\n",
  "QUOTATIOUS": "tending to quote [adj]\n",
  "QUOTATIVE": "a function word used in informal contexts to introduce a quotation [n -S]\n",
  "QUOTATIVES": "QUOTATIVE, a function word used in informal contexts to introduce a quotation [n]\n",
  "QUOTE": "to repeat the words of, also COATE [v QUOTED, QUOTING, QUOTES]\n",
  "QUOTED": "QUOTE, to repeat the words of, also COATE [v]\n",
  "QUOTER": "one who quotes [n -S]\n",
  "QUOTERS": "QUOTER, one who quotes [n]\n",
  "QUOTES": "QUOTE, to repeat the words of, also COATE [v]\n",
  "QUOTEWORTHIER": "QUOTEWORTHY, worth being quoted [adj]\n",
  "QUOTEWORTHIEST": "QUOTEWORTHY, worth being quoted [adj]\n",
  "QUOTEWORTHY": "worth being quoted [adj QUOTEWORTHIER, QUOTEWORTHIEST]\n",
  "QUOTH": "1st and 3rd person singular past of the otherwise obsolete verb QUETHE, said (followed by its subject) [v]\n",
  "QUOTHA": "(archaic) an expression of surprise or contempt [interj]\n",
  "QUOTIDIAN": "commonplace; occurring every day [adj] / a quotidian fever or ague [n -S]\n",
  "QUOTIDIANS": "QUOTIDIAN, a quotidian fever or ague [n]\n",
  "QUOTIENT": "the result obtained by dividing one quantity by another [n -S]\n",
  "QUOTIENTS": "QUOTIENT, the result obtained by dividing one quantity by another [n]\n",
  "QUOTING": "QUOTE, to repeat the words of, also COATE [v]\n",
  "QUOTITION": "a division regarded as a repeated subtraction [n -S]\n",
  "QUOTITIONS": "QUOTITION, a division regarded as a repeated subtraction [n]\n",
  "QUOTUM": "(Latin) a share, also QUOTA [n -S]\n",
  "QUOTUMS": "QUOTUM, (Latin) a share, also QUOTA [n]\n",
  "QURSH": "(Arabic) a monetary unit of Saudi Arabia, also GIRSH, GURSH, KURUSH, QURUSH [n -ES]\n",
  "QURSHES": "QURSH, (Arabic) a monetary unit of Saudi Arabia, also GIRSH, GURSH, KURUSH, QURUSH [n]\n",
  "QURUSH": "(Arabic) a monetary unit of Saudi Arabia, also GIRSH, GURSH, KURUSH, QURSH [n -ES]\n",
  "QURUSHES": "QURUSH, (Arabic) a monetary unit of Saudi Arabia, also GIRSH, GURSH, KURUSH, QURSH [n]\n",
  "QUYTE": "(obsolete) to quit, also QUIGHT, QUITE [v QUYTED, QUYTING, QUYTES]\n",
  "QUYTED": "QUYTE, (obsolete) to quit, also QUIGHT, QUITE [v]\n",
  "QUYTES": "QUYTE, (obsolete) to quit, also QUIGHT, QUITE [v]\n",
  "QUYTING": "QUYTE, (obsolete) to quit, also QUIGHT, QUITE [v]\n",
  "QWERTIES": "QWERTY, the usual keyboard layout [n]\n",
  "QWERTY": "the usual keyboard layout [n QWERTIES or QWERTYS]\n",
  "QWERTYS": "QWERTY, the usual keyboard layout [n]\n",
  "RABANNA": "(Malagasy) a kind of raffia fabric [n -S]\n",
  "RABANNAS": "RABANNA, (Malagasy) a kind of raffia fabric [n]\n",
  "RABASKA": "(Native American) a large canoe [n -S]\n",
  "RABASKAS": "RABASKA, (Native American) a large canoe [n]\n",
  "RABAT": "(French) to rotate into coincidence with another plane, also RABATTE [v RABATTED, RABATTING, RABATS]\n",
  "RABATINE": "(Scott) a low collar [n -S]\n",
  "RABATINES": "RABATINE, (Scott) a low collar [n]\n",
  "RABATMENT": "rotation into coincidence with another plane [n -S]\n",
  "RABATMENTS": "RABATMENT, rotation into coincidence with another plane [n]\n",
  "RABATO": "(Shakespeare) a stiff collar or support for a ruff, also REBATO [n RABATOS or RABATOES]\n",
  "RABATOES": "RABATO, (Shakespeare) a stiff collar or support for a ruff, also REBATO [n]\n",
  "RABATOS": "RABATO, (Shakespeare) a stiff collar or support for a ruff, also REBATO [n]\n",
  "RABATS": "RABAT, (French) to rotate into coincidence with another plane, also RABATTE [v]\n",
  "RABATTE": "(French) to rotate into coincidence with another plane, also RABAT [v RABATTED, RABATTING, RABATTES]\n",
  "RABATTED": "RABATTE, (French) to rotate into coincidence with another plane, also RABAT [v]\n",
  "RABATTEMENT": "the act of rabatting [n -S]\n",
  "RABATTEMENTS": "RABATTEMENT, the act of rabatting [n]\n",
  "RABATTES": "RABATTE, (French) to rotate into coincidence with another plane, also RABAT [v]\n",
  "RABATTING": "rotation in coincidence with another plane [n -S]\n",
  "RABATTINGS": "RABATTING, rotation in coincidence with another plane [n]\n",
  "RABBET": "a groove cut to receive an edge [n -S] / to join by a rabbet [v -ED, -ING, -S]\n",
  "RABBETED": "RABBET, to join by a rabbet [v]\n",
  "RABBETING": "RABBET, to join by a rabbet [v]\n",
  "RABBETS": "RABBET, to join by a rabbet [v]\n",
  "RABBI": "(Hebrew) a Jewish expounder or doctor of the law, also RABBIN [n RABBIS or RABBIES]\n",
  "RABBIES": "RABBI, (Hebrew) a Jewish expounder or doctor of the law, also RABBIN [n]\n",
  "RABBIN": "(Hebrew) a Jewish expounder or doctor of the law, also RABBI [n -S]\n",
  "RABBINATE": "the office of a rabbi [n -S]\n",
  "RABBINATES": "RABBINATE, the office of a rabbi [n]\n",
  "RABBINIC": "(Hebrew) of or pertaining to the rabbins, also RABBINICAL [adj RABBINICALLY]\n",
  "RABBINICAL": "of or pertaining to the rabbins, also RABBINIC [adj RABBINICALLY]\n",
  "RABBINICALLY": "RABBINICAL, of or pertaining to the rabbins, also RABBINIC [adv]\n",
  "RABBINICS": "the study of rabbinic literature of the post-Talmudic period [n]\n",
  "RABBINISM": "a rabbinic expression or phraseology; a peculiarity of the language of the rabbins [n -S]\n",
  "RABBINISMS": "RABBINISM, a rabbinic expression or phraseology; a peculiarity of the language of the rabbins [n]\n",
  "RABBINIST": "a person who adheres to the Talmud and traditions of the rabbis, also RABBINITE [n -S]\n",
  "RABBINISTIC": "relating to rabbis [adj]\n",
  "RABBINISTS": "RABBINIST, a person who adheres to the Talmud and traditions of the rabbis, also RABBINITE [n]\n",
  "RABBINITE": "a person who adheres to the Talmud and traditions of the rabbis, also RABBINIST [n -S]\n",
  "RABBINITES": "RABBINITE, a person who adheres to the Talmud and traditions of the rabbis, also RABBINIST [n]\n",
  "RABBINS": "RABBIN, (Hebrew) a Jewish expounder or doctor of the law, also RABBI [n]\n",
  "RABBIS": "RABBI, (Hebrew) a Jewish expounder or doctor of the law, also RABBIN [n]\n",
  "RABBIT": "a small burrowing animal related to the hare [n -S] / to hunt rabbits [v -ED, -ING, -S]\n",
  "RABBITBRUSH": "any of several low branching composite shrubs found in the US, aka chamisa [n -ES]\n",
  "RABBITBRUSHES": "RABBITBRUSH, any of several low branching composite shrubs found in the US, aka chamisa [n]\n",
  "RABBITED": "RABBIT, to hunt rabbits [v]\n",
  "RABBITER": "one who hunts rabbits [n -S]\n",
  "RABBITERS": "RABBITER, one who hunts rabbits [n]\n",
  "RABBITFISH": "a type of herring, or other fish thought to resemble a rabbit [n -ES]\n",
  "RABBITFISHES": "RABBITFISH, a type of herring, or other fish thought to resemble a rabbit [n]\n",
  "RABBITIER": "RABBITY, like a rabbit [adj]\n",
  "RABBITIEST": "RABBITY, like a rabbit [adj]\n",
  "RABBITING": "the act of hunting rodent-like mammals [n -S]\n",
  "RABBITINGS": "RABBITING, the act of hunting rodent-like mammals [n]\n",
  "RABBITO": "(Australian slang) an itinerant seller of rabbits for eating, also RABBITOH [n -S]\n",
  "RABBITOH": "(Australian slang) an itinerant seller of rabbits for eating, also RABBITO [n -S]\n",
  "RABBITOHS": "RABBITOH, (Australian slang) an itinerant seller of rabbits for eating, also RABBITO [n]\n",
  "RABBITOS": "RABBITO, (Australian slang) an itinerant seller of rabbits for eating, also RABBITOH [n]\n",
  "RABBITRIES": "RABBITRY, a place where rabbits are kept [n]\n",
  "RABBITRY": "a place where rabbits are kept [n RABBITRIES]\n",
  "RABBITS": "RABBIT, to hunt rabbits [v]\n",
  "RABBITY": "like a rabbit [adj RABBITIER, RABBITIEST]\n",
  "RABBLE": "a device for stirring molten iron in a furnace [n -S] / to stir with a rabble [v RABBLED, RABBLING, RABBLES]\n",
  "RABBLED": "RABBLE, to stir with a rabble [v]\n",
  "RABBLEMENT": "a tumultuous crowd of low people, a rabble [n -S]\n",
  "RABBLEMENTS": "RABBLEMENT, a tumultuous crowd of low people, a rabble [n]\n",
  "RABBLER": "a scraping tool for smoothing metal [n -S]\n",
  "RABBLERS": "RABBLER, a scraping tool for smoothing metal [n]\n",
  "RABBLES": "RABBLE, to stir with a rabble [v]\n",
  "RABBLING": "(Scots) the mobbing and ousting of the Episcopal 'curates' at the Revolution [n -S]\n",
  "RABBLINGS": "RABBLING, (Scots) the mobbing and ousting of the Episcopal 'curates' at the Revolution [n]\n",
  "RABBONI": "(Hebrew) my great master, a title of respect [n -S]\n",
  "RABBONIS": "RABBONI, (Hebrew) my great master, a title of respect [n]\n",
  "RABI": "(Urdu) the spring grain harvest in India and Pakistan [n -S]\n",
  "RABIC": "pertaining to rabies [adj]\n",
  "RABID": "afflicted with rabies [adj RABIDER, RABIDEST, RABIDLY]\n",
  "RABIDER": "RABID, afflicted with rabies [adj]\n",
  "RABIDEST": "RABID, afflicted with rabies [adj]\n",
  "RABIDITIES": "RABIDITY, the state of being rabid [n]\n",
  "RABIDITY": "the state of being rabid [n RABIDITIES]\n",
  "RABIDLY": "RABID, afflicted with rabies [adv]\n",
  "RABIDNESS": "the state of being rabid [n -ES]\n",
  "RABIDNESSES": "RABIDNESS, the state of being rabid [n]\n",
  "RABIES": "(Latin) an infectious virus disease [n RABIES]\n",
  "RABIETIC": "suffering from rabies, an infectious viral disease [adj]\n",
  "RABIS": "RABI, (Urdu) the spring grain harvest in India and Pakistan [n]\n",
  "RABONA": "an unconventional method of kicking the ball in which a player plants one leg and brings the kicking foot round behind it [n -S]\n",
  "RABONAS": "RABONA, an unconventional method of kicking the ball in which a player plants one leg and brings the kicking foot round behind it [n]\n",
  "RACA": "(Aramaic) empty, worthless (used as term of derision in Matthew 5.22) [adj]\n",
  "RACAHOUT": "(Arabic) acorn meal, used by the Arabs as a substitute for chocolate, and also as a beverage for invalids, also RACCAHOUT [n -S]\n",
  "RACAHOUTS": "RACAHOUT, (Arabic) acorn meal, used by the Arabs as a substitute for chocolate, and also as a beverage for invalids, also RACCAHOUT [n]\n",
  "RACCAHOUT": "(Arabic) acorn meal, used by the Arabs as a substitute for chocolate, and also as a beverage for invalids, also RACAHOUT [n -S]\n",
  "RACCAHOUTS": "RACCAHOUT, (Arabic) acorn meal, used by the Arabs as a substitute for chocolate, and also as a beverage for invalids, also RACAHOUT [n]\n",
  "RACCOON": "a small American animal related to the bears, also RACOON [n -S]\n",
  "RACCOONS": "RACCOON, a small American animal related to the bears, also RACOON [n]\n",
  "RACE": "to compete in a contest of speed [v RACED or RAST, RACING, RACES]\n",
  "RACEABLE": "(of a racecourse) fit to be used for racing [adj]\n",
  "RACECARD": "a programme for a race meeting [n -S]\n",
  "RACECARDS": "RACECARD, a programme for a race meeting [n]\n",
  "RACECOURSE": "a course for racing [n -S]\n",
  "RACECOURSES": "RACECOURSE, a course for racing [n]\n",
  "RACED": "RACE, to compete in a contest of speed [v]\n",
  "RACEGOER": "an attender of race meetings [n -S]\n",
  "RACEGOERS": "RACEGOER, an attender of race meetings [n]\n",
  "RACEGOING": "attendance at race meetings [n -S]\n",
  "RACEGOINGS": "RACEGOING, attendance at race meetings [n]\n",
  "RACEHORSE": "a horse bred to race [n -S]\n",
  "RACEHORSES": "RACEHORSE, a horse bred to race [n]\n",
  "RACEMATE": "a salt of racemic acid [n -S]\n",
  "RACEMATES": "RACEMATE, a salt of racemic acid [n]\n",
  "RACEMATION": "a cluster or bunch of anything esp. grapes [n -S]\n",
  "RACEMATIONS": "RACEMATION, a cluster or bunch of anything esp. grapes [n]\n",
  "RACEME": "an indefinite arrangement of flowers on a main stalk [n -S]\n",
  "RACEMED": "arranged in a raceme, or in racemes [adj]\n",
  "RACEMES": "RACEME, an indefinite arrangement of flowers on a main stalk [n]\n",
  "RACEMIC": "applied to an acid obtained from a certain kind of grape, an optically inactive form of tartaric acid [adj]\n",
  "RACEMISATION": "a change into a racemic form, also RACEMIZATION [n -S]\n",
  "RACEMISATIONS": "RACEMISATION, a change into a racemic form, also RACEMIZATION [n]\n",
  "RACEMISE": "to change into racemic form, also RACEMIZE [v RACEMISED, RACEMISING, RACEMISES]\n",
  "RACEMISED": "RACEMISE, to change into racemic form, also RACEMIZE [v]\n",
  "RACEMISES": "RACEMISE, to change into racemic form, also RACEMIZE [v]\n",
  "RACEMISING": "RACEMISE, to change into racemic form, also RACEMIZE [v]\n",
  "RACEMISM": "the quality of being racemic [n -S]\n",
  "RACEMISMS": "RACEMISM, the quality of being racemic [n]\n",
  "RACEMIZATION": "a change into a racemic form, also RACEMISATION [n -S]\n",
  "RACEMIZATIONS": "RACEMIZATION, a change into a racemic form, also RACEMISATION [n]\n",
  "RACEMIZE": "to change into racemic form, also RACEMISE [v RACEMIZED, RACEMIZING, RACEMIZES]\n",
  "RACEMIZED": "RACEMIZE, to change into racemic form, also RACEMISE [v]\n",
  "RACEMIZES": "RACEMIZE, to change into racemic form, also RACEMISE [v]\n",
  "RACEMIZING": "RACEMIZE, to change into racemic form, also RACEMISE [v]\n",
  "RACEMOID": "shaped like a raceme, a kind of inflorescence with flowers borne on footstalks up a central stem [adj]\n",
  "RACEMOSE": "having the form of a raceme, also RACEMOUS [adj RACEMOSELY]\n",
  "RACEMOSELY": "RACEMOSE, having the form of a raceme, also RACEMOUS [adv]\n",
  "RACEMOUS": "having the form of a raceme, also RACEMOSE [adj RACEMOUSLY]\n",
  "RACEMOUSLY": "RACEMOUS, having the form of a raceme, also RACEMOSE [adv]\n",
  "RACEPATH": "a course for races [n -S]\n",
  "RACEPATHS": "RACEPATH, a course for races [n]\n",
  "RACER": "one that races [n -S]\n",
  "RACERS": "RACER, one that races [n]\n",
  "RACES": "RACE, to compete in a contest of speed [v]\n",
  "RACETRACK": "a track on which races take place [n -S]\n",
  "RACETRACKER": "one who attends a racetrack [n -S]\n",
  "RACETRACKERS": "RACETRACKER, one who attends a racetrack [n]\n",
  "RACETRACKS": "RACETRACK, a track on which races take place [n]\n",
  "RACEWALK": "to walk for speed while maintaining foot contact with the ground and keeping the supporting leg straight [v -ED, -ING, -S]\n",
  "RACEWALKED": "RACEWALK, to walk for speed while maintaining foot contact with the ground and keeping the supporting leg straight [v]\n",
  "RACEWALKER": "one who engages in racewalking [n -S]\n",
  "RACEWALKERS": "RACEWALKER, one who engages in racewalking [n]\n",
  "RACEWALKING": "the competitive sport of racing at a fast walk [n -S]\n",
  "RACEWALKINGS": "RACEWALKING, the competitive sport of racing at a fast walk [n]\n",
  "RACEWALKS": "RACEWALK, to walk for speed while maintaining foot contact with the ground and keeping the supporting leg straight [v]\n",
  "RACEWAY": "a course for running races over [n -S]\n",
  "RACEWAYS": "RACEWAY, a course for running races over [n]\n",
  "RACH": "(archaic) a dog that hunts by scent, also RACHE [n -ES]\n",
  "RACHE": "(archaic) a dog that hunts by scent, also RACH [n -S]\n",
  "RACHES": "RACHE, (archaic) a dog that hunts by scent, also RACH [n]\n",
  "RACHET": "a mechanism which allows motion in one direction only [n -S] / to move by a rachet mechanism, also RATCHET [v -ED, -ING, -S]\n",
  "RACHETED": "RACHET, to move by a rachet mechanism, also RATCHET [v]\n",
  "RACHETING": "RACHET, to move by a rachet mechanism, also RATCHET [v]\n",
  "RACHETS": "RACHET, a mechanism which allows motion in one direction only [n]\n",
  "RACHIAL": "relating to a rachis, the spine or axis of a feather [adj]\n",
  "RACHIDES": "RACHIS, (Greek) the spinal column, also RHACHIS [n]\n",
  "RACHIDIAL": "of or like a rachis, the spine or axis of a feather, also RACHIDIAN, RHACHIDIAL [adj]\n",
  "RACHIDIAN": "of or like a rachis, the spine or axis of a feather, also RACHIDIAL, RHACHIDIAL [adj]\n",
  "RACHILLA": "(Greek) the central stalk or axis of a grass spikelet, also RHACHILLA [n RACHILLAS or RACHILLAE]\n",
  "RACHILLAE": "RACHILLA, (Greek) the central stalk or axis of a grass spikelet, also RHACHILLA [n]\n",
  "RACHILLAS": "RACHILLA, (Greek) the central stalk or axis of a grass spikelet, also RHACHILLA [n]\n",
  "RACHIOTOMIES": "RACHIOTOMY, another name for laminectomy [n]\n",
  "RACHIOTOMY": "another name for laminectomy [n RACHIOTOMIES]\n",
  "RACHIS": "(Greek) the spinal column, also RHACHIS [n RACHISES or RACHIDES]\n",
  "RACHISCHISES": "RACHISCHISIS, a severe form of spina bifida [n]\n",
  "RACHISCHISIS": "a severe form of spina bifida [n RACHISCHISES]\n",
  "RACHISES": "RACHIS, (Greek) the spinal column, also RHACHIS [n]\n",
  "RACHITIC": "pertaining to or having rachitis, inflammation of spine [adj]\n",
  "RACHITIDES": "RACHITIS, inflammation of the spine, also RHACHITIS [n]\n",
  "RACHITIS": "inflammation of the spine, also RHACHITIS [n RACHITIDES or RACHITISES]\n",
  "RACHITISES": "RACHITIS, inflammation of the spine, also RHACHITIS [n]\n",
  "RACIAL": "pertaining to an ethnic group [adj RACIALLY]\n",
  "RACIALISE": "to make racial, also RACIALIZE [v RACIALISED, RACIALISING, RACIALISES]\n",
  "RACIALISED": "RACIALISE, to make racial, also RACIALIZE [v]\n",
  "RACIALISES": "RACIALISE, to make racial, also RACIALIZE [v]\n",
  "RACIALISING": "RACIALISE, to make racial, also RACIALIZE [v]\n",
  "RACIALISM": "a doctrine of racial superiority, also RACISM [n -S]\n",
  "RACIALISMS": "RACIALISM, a doctrine of racial superiority, also RACISM [n]\n",
  "RACIALIST": "one with racist views [n -S]\n",
  "RACIALISTIC": "relating to racialism [adj]\n",
  "RACIALISTS": "RACIALIST, one with racist views [n]\n",
  "RACIALIZE": "to make racial, also RACIALISE [v RACIALIZED, RACIALIZING, RACIALIZES]\n",
  "RACIALIZED": "RACIALIZE, to make racial, also RACIALISE [v]\n",
  "RACIALIZES": "RACIALIZE, to make racial, also RACIALISE [v]\n",
  "RACIALIZING": "RACIALIZE, to make racial, also RACIALISE [v]\n",
  "RACIALLY": "RACIAL, pertaining to an ethnic group [adv]\n",
  "RACIATION": "the formation locally of new biological groups smaller than species [n -S]\n",
  "RACIATIONS": "RACIATION, the formation locally of new biological groups smaller than species [n]\n",
  "RACIER": "RACY, pungent [adj]\n",
  "RACIEST": "RACY, pungent [adj]\n",
  "RACILY": "RACY, pungent [adv]\n",
  "RACINESS": "the quality of being racy [n -ES]\n",
  "RACINESSES": "RACINESS, the quality of being racy [n]\n",
  "RACING": "the sport of engaging in contests of speed [n -S]\n",
  "RACINGS": "RACING, the sport of engaging in contests of speed [n]\n",
  "RACINO": "a racetrack that offers additional facilities for gambling [n -S]\n",
  "RACINOS": "RACINO, a racetrack that offers additional facilities for gambling [n]\n",
  "RACISM": "a doctrine of racial superiority, also RACIALISM [n -S]\n",
  "RACISMS": "RACISM, a doctrine of racial superiority, also RACIALISM [n]\n",
  "RACIST": "an advocate of racism [n -S]\n",
  "RACISTS": "RACIST, an advocate of racism [n]\n",
  "RACK": "to place in a type of frame [v -ED, -ING, -S]\n",
  "RACKABONES": "a very lean animal, esp. a horse [n RACKABONES]\n",
  "RACKED": "RACK, to place in a type of frame [v]\n",
  "RACKER": "a horse that walks with a racking gait, i.e. with both legs on one side moving nearly together [n -S]\n",
  "RACKERS": "RACKER, a horse that walks with a racking gait, i.e. with both legs on one side moving nearly together [n]\n",
  "RACKET": "to make a loud noise [v -ED, -ING, -S]\n",
  "RACKETED": "RACKET, to make a loud noise [v]\n",
  "RACKETEER": "a criminal who runs a protection racket, also RACKETER [n -S] / to run a protection racket [v -ED, -ING, -S]\n",
  "RACKETEERED": "RACKETEER, to run a protection racket [v]\n",
  "RACKETEERING": "running a protection racket [n -S]\n",
  "RACKETEERINGS": "RACKETEERING, running a protection racket [n]\n",
  "RACKETEERS": "RACKETEER, a criminal who runs a protection racket, also RACKETER [n]\n",
  "RACKETER": "one who makes, or engages in, a racket, also RACKETEER [n -S]\n",
  "RACKETERS": "RACKETER, one who makes, or engages in, a racket, also RACKETEER [n]\n",
  "RACKETIER": "RACKETY, noisy [adj]\n",
  "RACKETIEST": "RACKETY, noisy [adj]\n",
  "RACKETING": "RACKET, to make a loud noise [v]\n",
  "RACKETRIES": "RACKETRY, illegal interference [n]\n",
  "RACKETRY": "illegal interference [n RACKETRIES]\n",
  "RACKETS": "RACKET, to make a loud noise [v]\n",
  "RACKETT": "(German) an old wind instrument of the double bassoon kind, having ventages but not keys [n -S]\n",
  "RACKETTS": "RACKETT, (German) an old wind instrument of the double bassoon kind, having ventages but not keys [n]\n",
  "RACKETY": "noisy [adj RACKETIER, RACKETIEST]\n",
  "RACKFUL": "as much as a rack can hold [n -S]\n",
  "RACKFULS": "RACKFUL, as much as a rack can hold [n]\n",
  "RACKING": "tormenting, exhausting [adj RACKINGLY] / the act of racking [n -S]\n",
  "RACKINGLY": "RACKING, tormenting, exhausting [adv]\n",
  "RACKINGS": "RACKING, the act of racking [n]\n",
  "RACKLE": "a chain [n -S]\n",
  "RACKLES": "RACKLE, a chain [n]\n",
  "RACKS": "RACK, to place in a type of frame [v]\n",
  "RACKWORK": "any mechanism having a rack, as a rack and pinion [n -S]\n",
  "RACKWORKS": "RACKWORK, any mechanism having a rack, as a rack and pinion [n]\n",
  "RACLETTE": "(French) a dish made from melted cheese and potatoes [n -S]\n",
  "RACLETTES": "RACLETTE, (French) a dish made from melted cheese and potatoes [n]\n",
  "RACLOIR": "(French) a scraper [n -S]\n",
  "RACLOIRS": "RACLOIR, (French) a scraper [n]\n",
  "RACON": "a type of radar transmitter [n -S]\n",
  "RACONS": "RACON, a type of radar transmitter [n]\n",
  "RACONTEUR": "(French) a teller of anecdotes [n -S]\n",
  "RACONTEURING": "telling tales [n -S]\n",
  "RACONTEURINGS": "RACONTEURING, telling tales [n]\n",
  "RACONTEURS": "RACONTEUR, (French) a teller of anecdotes [n]\n",
  "RACONTEUSE": "(French) a female raconteur [n -S]\n",
  "RACONTEUSES": "RACONTEUSE, (French) a female raconteur [n]\n",
  "RACOON": "a small American animal related to the bears, also RACCOON [n -S]\n",
  "RACOONS": "RACOON, a small American animal related to the bears, also RACCOON [n]\n",
  "RACQUET": "a bat with strings used for hitting balls [n -S] / to strike with a racquet [v -ED, -ING, -S]\n",
  "RACQUETBALL": "a game similar to handball that is played on a 4-walled court with a short-handled racket and a larger ball [n -S]\n",
  "RACQUETBALLS": "RACQUETBALL, a game similar to handball that is played on a 4-walled court with a short-handled racket and a larger ball [n]\n",
  "RACQUETED": "RACQUET, to strike with a racquet [v]\n",
  "RACQUETING": "RACQUET, to strike with a racquet [v]\n",
  "RACQUETS": "RACQUET, to strike with a racquet [v]\n",
  "RACTOPAMINE": "a synthetic food additive used in some countries to promote rapid muscle growth in animals [n -S]\n",
  "RACTOPAMINES": "RACTOPAMINE, a synthetic food additive used in some countries to promote rapid muscle growth in animals [n]\n",
  "RACY": "pungent [adj RACIER, RACIEST, RACILY]\n",
  "RAD": "afraid [adj RADDER, RADDEST] / to fear [v RADDED, RADDING, RADS]\n",
  "RADAR": "an electronic locating device [n -S]\n",
  "RADARS": "RADAR, an electronic locating device [n]\n",
  "RADARSCOPE": "an instrument for detecting radar signals [n -S]\n",
  "RADARSCOPES": "RADARSCOPE, an instrument for detecting radar signals [n]\n",
  "RADDED": "RAD, to fear [v]\n",
  "RADDER": "RAD, afraid [adj]\n",
  "RADDEST": "RAD, afraid [adj]\n",
  "RADDING": "RAD, to fear [v]\n",
  "RADDLE": "to redden with red ochre, also REDDLE [v RADDLED, RADDLING, RADDLES]\n",
  "RADDLED": "RADDLE, to redden with red ochre, also REDDLE [v]\n",
  "RADDLEMAN": "one who marks e.g. sheep with raddle, also REDDLEMAN, RUDDLEMAN [n RADDLEMEN]\n",
  "RADDLEMEN": "RADDLEMAN, one who marks e.g. sheep with raddle, also REDDLEMAN, RUDDLEMAN [n]\n",
  "RADDLES": "RADDLE, to redden with red ochre, also REDDLE [v]\n",
  "RADDLING": "RADDLE, to redden with red ochre, also REDDLE [v]\n",
  "RADDOCKE": "(Shakespeare) a robin, also RUDDOCK [n -S]\n",
  "RADDOCKES": "RADDOCKE, (Shakespeare) a robin, also RUDDOCK [n]\n",
  "RADE": "RIDE, to be conveyed by an animal or machine [v]\n",
  "RADGE": "(Scots) angry, obstreperous; lustful [adj RADGER, RADGEST] / a bad temper, a rage [n -S]\n",
  "RADGER": "RADGE, (Scots) angry, obstreperous; lustful [adj]\n",
  "RADGES": "RADGE, a bad temper, a rage [n]\n",
  "RADGEST": "RADGE, (Scots) angry, obstreperous; lustful [adj]\n",
  "RADIABLE": "capable of radiating [adj]\n",
  "RADIAL": "having rays or spokes diverging from the centre [adj RADIALLY] / a radial artery [n -S]\n",
  "RADIALE": "(Latin) a wrist-bone of the carpus [n RADIALIA]\n",
  "RADIALIA": "RADIALE, (Latin) a wrist-bone of the carpus [n]\n",
  "RADIALISATION": "the process of radialising, also RADIALIZATION [n -S]\n",
  "RADIALISATIONS": "RADIALISATION, the process of radialising, also RADIALIZATION [n]\n",
  "RADIALISE": "to arrange radially, also RADIALIZE [v RADIALISED, RADIALISING, RADIALISES]\n",
  "RADIALISED": "RADIALISE, to arrange radially, also RADIALIZE [v]\n",
  "RADIALISES": "RADIALISE, to arrange radially, also RADIALIZE [v]\n",
  "RADIALISING": "RADIALISE, to arrange radially, also RADIALIZE [v]\n",
  "RADIALITIES": "RADIALITY, radial symmetry [n]\n",
  "RADIALITY": "radial symmetry [n RADIALITIES]\n",
  "RADIALIZATION": "the process of radializing, also RADIALISATION [n -S]\n",
  "RADIALIZATIONS": "RADIALIZATION, the process of radializing, also RADIALISATION [n]\n",
  "RADIALIZE": "to arrange radially, also RADIALISE [v RADIALIZED, RADIALIZING, RADIALIZES]\n",
  "RADIALIZED": "RADIALIZE, to arrange radially, also RADIALISE [v]\n",
  "RADIALIZES": "RADIALIZE, to arrange radially, also RADIALISE [v]\n",
  "RADIALIZING": "RADIALIZE, to arrange radially, also RADIALISE [v]\n",
  "RADIALLY": "RADIAL, having rays or spokes diverging from the centre [adv]\n",
  "RADIALS": "RADIAL, a radial artery [n]\n",
  "RADIAN": "a unit of angular measure [n -S]\n",
  "RADIANCE": "the quality of being radiant, also RADIANCY [n -S]\n",
  "RADIANCES": "RADIANCE, the quality of being radiant, also RADIANCY [n]\n",
  "RADIANCIES": "RADIANCY, the quality of being radiant, also RADIANCE [n]\n",
  "RADIANCY": "the quality of being radiant, also RADIANCE [n RADIANCIES]\n",
  "RADIANS": "RADIAN, a unit of angular measure [n]\n",
  "RADIANT": "shining [adj RADIANTLY] / a straight line from a point about which it is conceived to revolve [n -S]\n",
  "RADIANTLY": "RADIANT, shining [adv]\n",
  "RADIANTS": "RADIANT, a straight line from a point about which it is conceived to revolve [n]\n",
  "RADIATA": "an originally Californian variety of pine tree, now grown esp. in New Zealand for timber [n -S]\n",
  "RADIATAS": "RADIATA, an originally Californian variety of pine tree, now grown esp. in New Zealand for timber [n]\n",
  "RADIATE": "arranged like rays [adj RADIATELY] / to emit rays [v RADIATED, RADIATING, RADIATES]\n",
  "RADIATED": "RADIATE, to emit rays [v]\n",
  "RADIATELY": "RADIATE, arranged like rays [adv]\n",
  "RADIATES": "RADIATE, to emit rays [v]\n",
  "RADIATING": "RADIATE, to emit rays [v]\n",
  "RADIATION": "heat transport without the intervention of matter, as in the transport of heat from the Sun to the Earth [n -S]\n",
  "RADIATIONAL": "relating to radiation [adj]\n",
  "RADIATIONLESS": "without radiation, heat transport without the intervention of matter, as in the transport of heat from the Sun to the Earth [adj]\n",
  "RADIATIONS": "RADIATION, heat transport without the intervention of matter, as in the transport of heat from the Sun to the Earth [n]\n",
  "RADIATIVE": "capable of radiating; acting by radiation [adj]\n",
  "RADIATOR": "a heating device [n -S]\n",
  "RADIATORS": "RADIATOR, a heating device [n]\n",
  "RADIATORY": "relating to radiation [adj]\n",
  "RADICAL": "fundamental [adj RADICALLY] / a group of atoms behaving like a single atom and passing unchanged from one compound to another [n -S]\n",
  "RADICALISATION": "the act of radicalising, also RADICALIZATION [n -S]\n",
  "RADICALISATIONS": "RADICALISATION, the act of radicalising, also RADICALIZATION [n]\n",
  "RADICALISE": "to make or become radical, also RADICALIZE [v RADICALISED, RADICALISING, RADICALISES]\n",
  "RADICALISED": "RADICALISE, to make or become radical, also RADICALIZE [v]\n",
  "RADICALISES": "RADICALISE, to make or become radical, also RADICALIZE [v]\n",
  "RADICALISING": "RADICALISE, to make or become radical, also RADICALIZE [v]\n",
  "RADICALISM": "the state of being radical [n -S]\n",
  "RADICALISMS": "RADICALISM, the state of being radical [n]\n",
  "RADICALISTIC": "related to radicalism, the state of being radical [adj]\n",
  "RADICALITIES": "RADICALITY, the state of being radical [n]\n",
  "RADICALITY": "the state of being radical [n RADICALITIES]\n",
  "RADICALIZATION": "the act of radicalizing, also RADICALISATION [n -S]\n",
  "RADICALIZATIONS": "RADICALIZATION, the act of radicalizing, also RADICALISATION [n]\n",
  "RADICALIZE": "to make or become radical, also RADICALISE [v RADICALIZED, RADICALIZING, RADICALIZES]\n",
  "RADICALIZED": "RADICALIZE, to make or become radical, also RADICALISE [v]\n",
  "RADICALIZES": "RADICALIZE, to make or become radical, also RADICALISE [v]\n",
  "RADICALIZING": "RADICALIZE, to make or become radical, also RADICALISE [v]\n",
  "RADICALLY": "RADICAL, fundamental [adv]\n",
  "RADICALNESS": "the state of being radical [n -ES]\n",
  "RADICALNESSES": "RADICALNESS, the state of being radical [n]\n",
  "RADICALS": "RADICAL, a group of atoms behaving like a single atom and passing unchanged from one compound to another [n]\n",
  "RADICAND": "a quantity in mathematics [n -S]\n",
  "RADICANDS": "RADICAND, a quantity in mathematics [n]\n",
  "RADICANT": "rooting from the stem [adj]\n",
  "RADICATE": "to cause to take root [v RADICATED, RADICATING, RADICATES]\n",
  "RADICATED": "RADICATE, to cause to take root [v]\n",
  "RADICATES": "RADICATE, to cause to take root [v]\n",
  "RADICATING": "RADICATE, to cause to take root [v]\n",
  "RADICATION": "the process of taking root [n -S]\n",
  "RADICATIONS": "RADICATION, the process of taking root [n]\n",
  "RADICCHIO": "(Italian) a purple-leaved variety of chicory from Italy [n -S]\n",
  "RADICCHIOS": "RADICCHIO, (Italian) a purple-leaved variety of chicory from Italy [n]\n",
  "RADICEL": "a rootlike organ or part, also RADICLE, RADICULE [n -S]\n",
  "RADICELLOSE": "like a radicel, a rootlike organ or part [adj]\n",
  "RADICELS": "RADICEL, a rootlike organ or part, also RADICLE, RADICULE [n]\n",
  "RADICES": "RADIX, (Latin) a root; a root-number or numerical base; a root word or stem [n]\n",
  "RADICICOLOUS": "inhabiting or parasitic on roots [adj]\n",
  "RADICIFORM": "like a root [adj]\n",
  "RADICIVOROUS": "eating roots [adj]\n",
  "RADICLE": "a rootlike organ or part, also RADICEL, RADICULE [n -S]\n",
  "RADICLES": "RADICLE, a rootlike organ or part, also RADICEL, RADICULE [n]\n",
  "RADICULAR": "of or pertaining to roots [adj]\n",
  "RADICULE": "a rootlike organ or part, also RADICEL, RADICLE [n -S]\n",
  "RADICULES": "RADICULE, a rootlike organ or part, also RADICEL, RADICLE [n]\n",
  "RADICULOSE": "producing numerous radicles, or rootlets [adj]\n",
  "RADIESTHESIA": "sensitivity to radiation from any source [n -S]\n",
  "RADIESTHESIAS": "RADIESTHESIA, sensitivity to radiation from any source [n]\n",
  "RADIESTHESIST": "one who practises radiesthesia, a dowser [n -S]\n",
  "RADIESTHESISTS": "RADIESTHESIST, one who practises radiesthesia, a dowser [n]\n",
  "RADIESTHETIC": "relating to radiesthesia, sensitivity to radiation from any source [adj]\n",
  "RADII": "RADIUS, (Latin) the shorter and thicker of the two arm bones [n]\n",
  "RADIO": "signalling through space, without connecting wires, by means of electromagnetic waves [n -S] / to transmit by radio [v -ED, -ING, -ES]\n",
  "RADIOACTIVATE": "to activate by radio [v RADIOACTIVATED, RADIOACTIVATING, RADIOACTIVATES]\n",
  "RADIOACTIVATED": "RADIOACTIVATE, to activate by radio [v]\n",
  "RADIOACTIVATES": "RADIOACTIVATE, to activate by radio [v]\n",
  "RADIOACTIVATING": "RADIOACTIVATE, to activate by radio [v]\n",
  "RADIOACTIVATION": "the act of making radioactive [n]\n",
  "RADIOACTIVE": "of, caused by, or exhibiting radioactivity [adj RADIOACTIVELY]\n",
  "RADIOACTIVELY": "RADIOACTIVE, of, caused by, or exhibiting radioactivity [adv]\n",
  "RADIOACTIVITIES": "RADIOACTIVITY, the spontaneous decay of the nucleus of an element [n]\n",
  "RADIOACTIVITY": "the spontaneous decay of the nucleus of an element [n RADIOACTIVITIES]\n",
  "RADIOAUTOGRAPH": "an autoradiographic record, also AUTORADIOGRAPH [n -S]\n",
  "RADIOAUTOGRAPHS": "RADIOAUTOGRAPH, an autoradiographic record, also AUTORADIOGRAPH [n]\n",
  "RADIOAUTOGRAPHY": "the use of radioautographs [n]\n",
  "RADIOBIOLOGIC": "relating to radiobiology, also RADIOBIOLOGICAL [adj]\n",
  "RADIOBIOLOGICAL": "relating to radiobiology, also RADIOBIOLOGIC [adj]\n",
  "RADIOBIOLOGIES": "RADIOBIOLOGY, a branch of biology dealing with the effects of radiation or radioactive materials on biological systems [n]\n",
  "RADIOBIOLOGIST": "one who studies radiobiology [n -S]\n",
  "RADIOBIOLOGISTS": "RADIOBIOLOGIST, one who studies radiobiology [n]\n",
  "RADIOBIOLOGY": "a branch of biology dealing with the effects of radiation or radioactive materials on biological systems [n RADIOBIOLOGIES]\n",
  "RADIOCARBON": "a radioactive isotope of carbon, specifically, carbon-14 [n -S]\n",
  "RADIOCARBONS": "RADIOCARBON, a radioactive isotope of carbon, specifically, carbon-14 [n]\n",
  "RADIOCHEMICAL": "relating to radiochemistry [adj RADIOCHEMICALLY]\n",
  "RADIOCHEMICALLY": "RADIOCHEMICAL, relating to radiochemistry [adv]\n",
  "RADIOCHEMIST": "one who practises radiochemistry [n -S]\n",
  "RADIOCHEMISTRY": "a branch of chemistry dealing with radioactive substances and phenomena including tracer studies [n]\n",
  "RADIOCHEMISTS": "RADIOCHEMIST, one who practises radiochemistry [n]\n",
  "RADIOECOLOGIES": "RADIOECOLOGY, the study of the effects of radiation and radioactive substances on ecological communities [n]\n",
  "RADIOECOLOGY": "the study of the effects of radiation and radioactive substances on ecological communities [n RADIOECOLOGIES]\n",
  "RADIOED": "RADIO, to transmit by radio [v]\n",
  "RADIOELEMENT": "a radioactive element [n -S]\n",
  "RADIOELEMENTS": "RADIOELEMENT, a radioactive element [n]\n",
  "RADIOES": "RADIO, to transmit by radio [v]\n",
  "RADIOGENIC": "produced by radioactive decay [adj]\n",
  "RADIOGOLD": "the radioisotope gold-198 [n -S]\n",
  "RADIOGOLDS": "RADIOGOLD, the radioisotope gold-198 [n]\n",
  "RADIOGONIOMETER": "an instrument for finding direction through radio signals [n]\n",
  "RADIOGONIOMETRY": "the science of detecting the direction of radio waves [n]\n",
  "RADIOGRAM": "an X-ray photograph [n -S]\n",
  "RADIOGRAMS": "RADIOGRAM, an X-ray photograph [n]\n",
  "RADIOGRAPH": "a picture produced by the Rontgen rays upon a sensitive surface, photographic or fluorescent, esp. a picture of opaque objects traversed by the rays [n -S] / to produce a radiograph of [v RADIOGRAPHED, RADIOGRAPHING, RADIOGRAPHS]\n",
  "RADIOGRAPHED": "RADIOGRAPH, to produce a radiograph of [v]\n",
  "RADIOGRAPHER": "one who practises radiography [n -S]\n",
  "RADIOGRAPHERS": "RADIOGRAPHER, one who practises radiography [n]\n",
  "RADIOGRAPHIC": "relating to radiography [adj]\n",
  "RADIOGRAPHIES": "RADIOGRAPHY, photography of the interior of a body or specimen by radiations other than light, such as X-rays, etc. [n]\n",
  "RADIOGRAPHING": "RADIOGRAPH, to produce a radiograph of [v]\n",
  "RADIOGRAPHS": "RADIOGRAPH, a picture produced by the Rontgen rays upon a sensitive surface, photographic or fluorescent, esp. a picture of opaque objects traversed by the rays [n]\n",
  "RADIOGRAPHY": "photography of the interior of a body or specimen by radiations other than light, such as X-rays, etc. [n RADIOGRAPHIES]\n",
  "RADIOING": "RADIO, to transmit by radio [v]\n",
  "RADIOIODINE": "a radioisotope of iodine with medical uses [n -S]\n",
  "RADIOIODINES": "RADIOIODINE, a radioisotope of iodine with medical uses [n]\n",
  "RADIOISOTOPE": "a radioactive isotope [n -S]\n",
  "RADIOISOTOPES": "RADIOISOTOPE, a radioactive isotope [n]\n",
  "RADIOISOTOPIC": "of or like a radioisotope, a radioactive isotope [adj]\n",
  "RADIOLABEL": "a label on a radioactive substance [n -S] / to label as radioactive [v RADIOLABELED or RADIOLABELLED, RADIOLABELING or RADIOLABELLING, RADIOLABELS]\n",
  "RADIOLABELED": "RADIOLABEL, to label as radioactive [v]\n",
  "RADIOLABELING": "RADIOLABEL, to label as radioactive [v]\n",
  "RADIOLABELLED": "RADIOLABEL, to label as radioactive [v]\n",
  "RADIOLABELLING": "RADIOLABEL, to label as radioactive [v]\n",
  "RADIOLABELS": "RADIOLABEL, a label on a radioactive substance [n]\n",
  "RADIOLARIAN": "any member of an order of marine Protozoa, or unicellular animals, with fine radial tentacles for feeding and movement [n -S]\n",
  "RADIOLARIANS": "RADIOLARIAN, any member of an order of marine Protozoa, or unicellular animals, with fine radial tentacles for feeding and movement [n]\n",
  "RADIOLOCATION": "position-finding by radio signals; radar [n -S]\n",
  "RADIOLOCATIONAL": "relating to radiolocation, position-finding by radio signals [adj]\n",
  "RADIOLOCATIONS": "RADIOLOCATION, position-finding by radio signals; radar [n]\n",
  "RADIOLOGIC": "of or relating to radiology, also RADIOLOGICAL [adj RADIOLOGICALLY]\n",
  "RADIOLOGICAL": "of or relating to radiology, also RADIOLOGIC [adj RADIOLOGICALLY]\n",
  "RADIOLOGICALLY": "RADIOLOGICAL, of or relating to radiology, also RADIOLOGIC [adv]\n",
  "RADIOLOGIES": "RADIOLOGY, the study of X-rays and their medical applications [n]\n",
  "RADIOLOGIST": "a physician specializing in medical radiology [n -S]\n",
  "RADIOLOGISTS": "RADIOLOGIST, a physician specializing in medical radiology [n]\n",
  "RADIOLOGY": "the study of X-rays and their medical applications [n RADIOLOGIES]\n",
  "RADIOLUCENCIES": "RADIOLUCENCY, the state of being radiolucent [n]\n",
  "RADIOLUCENCY": "the state of being radiolucent [n RADIOLUCENCIES]\n",
  "RADIOLUCENT": "penetrable by X-rays [adj]\n",
  "RADIOLYSES": "RADIOLYSIS, chemical decomposition induced by ionizing radiation [n]\n",
  "RADIOLYSIS": "chemical decomposition induced by ionizing radiation [n RADIOLYSES]\n",
  "RADIOLYTIC": "relating to radiolysis [adj]\n",
  "RADIOMAN": "a radio operator or technician [n RADIOMEN]\n",
  "RADIOMEN": "RADIOMAN, a radio operator or technician [n]\n",
  "RADIOMETER": "an instrument measuring radiation energy [n -S]\n",
  "RADIOMETERS": "RADIOMETER, an instrument measuring radiation energy [n]\n",
  "RADIOMETRIC": "relating to radiometry, the measurement of radiant energy [adj RADIOMETRICALLY]\n",
  "RADIOMETRICALLY": "RADIOMETRIC, relating to radiometry, the measurement of radiant energy [adv]\n",
  "RADIOMETRIES": "RADIOMETRY, the measurement of radiant energy [n]\n",
  "RADIOMETRY": "the measurement of radiant energy [n RADIOMETRIES]\n",
  "RADIOMICROMETER": "an instrument for detecting and measuring small amounts of radiation, usually by a sensitive thermocouple [n]\n",
  "RADIOMIMETIC": "producing effects similar to those of radiation [adj]\n",
  "RADIONICS": "diagnosis and treatment at a distance on radiesthetic principles, using hair, nail clippings etc. [n]\n",
  "RADIONUCLIDE": "a radioactive nuclide [n -S]\n",
  "RADIONUCLIDES": "RADIONUCLIDE, a radioactive nuclide [n]\n",
  "RADIOPACITIES": "RADIOPACITY, the state of being radio-opaque i.e. not allowing radio waves through [n]\n",
  "RADIOPACITY": "the state of being radio-opaque i.e. not allowing radio waves through [n RADIOPACITIES]\n",
  "RADIOPAGER": "a radio receiver which functions as a pager [n -S]\n",
  "RADIOPAGERS": "RADIOPAGER, a radio receiver which functions as a pager [n]\n",
  "RADIOPAGING": "the use of a radiopager, a radio receiver which functions as a pager [n -S]\n",
  "RADIOPAGINGS": "RADIOPAGING, the use of a radiopager, a radio receiver which functions as a pager [n]\n",
  "RADIOPAQUE": "not allowing passage of X-rays [adj]\n",
  "RADIOPHONE": "an instrument for producing sound by radiant energy [n -S]\n",
  "RADIOPHONES": "RADIOPHONE, an instrument for producing sound by radiant energy [n]\n",
  "RADIOPHONIC": "of music, produced electronically; producing electronic music [adj RADIOPHONICALLY]\n",
  "RADIOPHONICALLY": "RADIOPHONIC, of music, produced electronically; producing electronic music [adv]\n",
  "RADIOPHONICS": "the business of producing electronic music [n]\n",
  "RADIOPHONIES": "RADIOPHONY, the art or practice of using the radiophone [n]\n",
  "RADIOPHONIST": "one who uses a radiophone [n -S]\n",
  "RADIOPHONISTS": "RADIOPHONIST, one who uses a radiophone [n]\n",
  "RADIOPHONY": "the art or practice of using the radiophone [n RADIOPHONIES]\n",
  "RADIOPHOSPHORUS": "a radioactive isotope of phosphorus [n]\n",
  "RADIOPHOTO": "a picture transmitted by radio [n -S]\n",
  "RADIOPHOTOS": "RADIOPHOTO, a picture transmitted by radio [n]\n",
  "RADIOPROTECTION": "protection against the injurious effects of radiation [n]\n",
  "RADIOPROTECTIVE": "serving to protect or aiding in protecting against the injurious effect of radiations [adj]\n",
  "RADIORESISTANT": "able to withstand considerable radiation doses without injury [adj]\n",
  "RADIOS": "RADIO, signalling through space, without connecting wires, by means of electromagnetic waves [n]\n",
  "RADIOSCOPE": "an instrument for viewing objects using X-rays [n -S]\n",
  "RADIOSCOPES": "RADIOSCOPE, an instrument for viewing objects using X-rays [n]\n",
  "RADIOSCOPIC": "related to radioscopy, the examination of opaque bodies by X-rays [adj RADIOSCOPICALLY]\n",
  "RADIOSCOPICALLY": "RADIOSCOPIC, related to radioscopy, the examination of opaque bodies by X-rays [adv]\n",
  "RADIOSCOPIES": "RADIOSCOPY, examination of opaque bodies by X-rays [n]\n",
  "RADIOSCOPY": "examination of opaque bodies by X-rays [n RADIOSCOPIES]\n",
  "RADIOSENSITISE": "to make e.g. cancer cells more radiosensitive, also RADIOSENSITIZE [v RADIOSENSITISED, RADIOSENSITISES]\n",
  "RADIOSENSITISED": "RADIOSENSITISE, to make e.g. cancer cells more radiosensitive, also RADIOSENSITIZE [v]\n",
  "RADIOSENSITISES": "RADIOSENSITISE, to make e.g. cancer cells more radiosensitive, also RADIOSENSITIZE [v]\n",
  "RADIOSENSITIVE": "sensitive to the effects of radiant energy [adj]\n",
  "RADIOSENSITIZE": "to make e.g. cancer cells more radiosensitive, also RADIOSENSITISE [v RADIOSENSITIZED, RADIOSENSITIZES]\n",
  "RADIOSENSITIZED": "RADIOSENSITIZE, to make e.g. cancer cells more radiosensitive, also RADIOSENSITISE [v]\n",
  "RADIOSENSITIZES": "RADIOSENSITIZE, to make e.g. cancer cells more radiosensitive, also RADIOSENSITISE [v]\n",
  "RADIOSONDE": "a radio transmitter, borne into and from upper atmosphere by balloon and parachute, sending out information on atmospheric conditions [n -S]\n",
  "RADIOSONDES": "RADIOSONDE, a radio transmitter, borne into and from upper atmosphere by balloon and parachute, sending out information on atmospheric conditions [n]\n",
  "RADIOSTRONTIUM": "a radioactive isotope of strontium, esp. strontium-90 [n -S]\n",
  "RADIOSTRONTIUMS": "RADIOSTRONTIUM, a radioactive isotope of strontium, esp. strontium-90 [n]\n",
  "RADIOTELEGRAM": "a telegram sent by radio [n -S]\n",
  "RADIOTELEGRAMS": "RADIOTELEGRAM, a telegram sent by radio [n]\n",
  "RADIOTELEGRAPH": "wireless telegraphy [n -S]\n",
  "RADIOTELEGRAPHS": "RADIOTELEGRAPH, wireless telegraphy [n]\n",
  "RADIOTELEGRAPHY": "signalling by radiotelegraph, wireless telegraphy [n]\n",
  "RADIOTELEMETER": "an instrument for measuring an electrical or other quantity and signalling the measurement to a distant point [n -S]\n",
  "RADIOTELEMETERS": "RADIOTELEMETER, an instrument for measuring an electrical or other quantity and signalling the measurement to a distant point [n]\n",
  "RADIOTELEMETRIC": "relating to radiotelemetry [adj]\n",
  "RADIOTELEMETRY": "signalling by radiotelemeter, an instrument for measuring an electrical or other quantity and signalling the measurement to a distant point [n]\n",
  "RADIOTELEPHONE": "to telephone (someone) by wireless telephony [v RADIOTELEPHONED, RADIOTELEPHONES]\n",
  "RADIOTELEPHONED": "RADIOTELEPHONE, to telephone (someone) by wireless telephony [v]\n",
  "RADIOTELEPHONES": "RADIOTELEPHONE, to telephone (someone) by wireless telephony [v]\n",
  "RADIOTELEPHONIC": "relating to the radiotelephone [adj]\n",
  "RADIOTELEPHONY": "communication by radiotelephone [n]\n",
  "RADIOTELETYPE": "a teleprinter that receives and transmits by radio [n -S]\n",
  "RADIOTELETYPES": "RADIOTELETYPE, a teleprinter that receives and transmits by radio [n]\n",
  "RADIOTHERAPIES": "RADIOTHERAPY, treatment by radiation [n]\n",
  "RADIOTHERAPIST": "one who practises radiotherapy [n -S]\n",
  "RADIOTHERAPISTS": "RADIOTHERAPIST, one who practises radiotherapy [n]\n",
  "RADIOTHERAPY": "treatment by radiation [n RADIOTHERAPIES]\n",
  "RADIOTHERMIES": "RADIOTHERMY, the treatment of disease by means of heat generated by electromagnetic radiation [n]\n",
  "RADIOTHERMY": "the treatment of disease by means of heat generated by electromagnetic radiation [n RADIOTHERMIES]\n",
  "RADIOTHON": "a marathon talk-in on radio [n -S]\n",
  "RADIOTHONS": "RADIOTHON, a marathon talk-in on radio [n]\n",
  "RADIOTHORIUM": "a radioactive isotope of thorium with the mass number 228 [n -S]\n",
  "RADIOTHORIUMS": "RADIOTHORIUM, a radioactive isotope of thorium with the mass number 228 [n]\n",
  "RADIOTOXIC": "relating to the toxic effects of radioactivity or radioactive waste [adj]\n",
  "RADIOTRACER": "a radioactive tracer [n -S]\n",
  "RADIOTRACERS": "RADIOTRACER, a radioactive tracer [n]\n",
  "RADISH": "a pungent root vegetable [n -ES]\n",
  "RADISHES": "RADISH, a pungent root vegetable [n]\n",
  "RADIUM": "a radioactive element [n -S]\n",
  "RADIUMS": "RADIUM, a radioactive element [n]\n",
  "RADIUS": "(Latin) the shorter and thicker of the two arm bones [n RADII or RADIUSES] / to give a rounded form to [v -ED, -ING, -ES]\n",
  "RADIUSED": "RADIUS, to give a rounded form to [v]\n",
  "RADIUSES": "RADIUS, (Latin) the shorter and thicker of the two arm bones [n]\n",
  "RADIUSING": "RADIUS, to give a rounded form to [v]\n",
  "RADIX": "(Latin) a root; a root-number or numerical base; a root word or stem [n RADICES or RADIXES]\n",
  "RADIXES": "RADIX, (Latin) a root; a root-number or numerical base; a root word or stem [n]\n",
  "RADOME": "a domelike device used to shelter a radar antenna [n -S]\n",
  "RADOMES": "RADOME, a domelike device used to shelter a radar antenna [n]\n",
  "RADON": "a radioactive element, an inert gas [n -S]\n",
  "RADONS": "RADON, a radioactive element, an inert gas [n]\n",
  "RADS": "RAD, to fear [v]\n",
  "RADULA": "(Latin) a tonguelike organ of molluscs [n RADULAS or RADULAE]\n",
  "RADULAE": "RADULA, (Latin) a tonguelike organ of molluscs [n]\n",
  "RADULAR": "like a radula, raspy [adj]\n",
  "RADULAS": "RADULA, (Latin) a tonguelike organ of molluscs [n]\n",
  "RADULATE": "having a radula, a mollusc's tongue, that is studded with tiny teeth [adj]\n",
  "RADULIFORM": "like a rasp or file [adj]\n",
  "RADWASTE": "radioactive waste [n -S]\n",
  "RADWASTES": "RADWASTE, radioactive waste [n]\n",
  "RAFALE": "(French) a burst of artillery in quick rounds [n -S]\n",
  "RAFALES": "RAFALE, (French) a burst of artillery in quick rounds [n]\n",
  "RAFF": "(archaic) rubbish, refuse [n -S]\n",
  "RAFFIA": "(Malagasy) a kind of palm tree, also RAPHIA [n -S]\n",
  "RAFFIAS": "RAFFIA, (Malagasy) a kind of palm tree, also RAPHIA [n]\n",
  "RAFFINATE": "the refined fraction which results after removal of impurities by solvent extraction, specifically in oil refining [n -S]\n",
  "RAFFINATES": "RAFFINATE, the refined fraction which results after removal of impurities by solvent extraction, specifically in oil refining [n]\n",
  "RAFFINOSE": "a colorless crystalline slightly sweet substance obtained from the molasses of the sugar beet [n -S]\n",
  "RAFFINOSES": "RAFFINOSE, a colorless crystalline slightly sweet substance obtained from the molasses of the sugar beet [n]\n",
  "RAFFISH": "marked by or suggestive of flashy vulgarity or crudeness [adj RAFFISHLY]\n",
  "RAFFISHLY": "RAFFISH, marked by or suggestive of flashy vulgarity or crudeness [adv]\n",
  "RAFFISHNESS": "the state of being raffish [n -ES]\n",
  "RAFFISHNESSES": "RAFFISHNESS, the state of being raffish [n]\n",
  "RAFFLE": "to dispose of by tickets of chance [v RAFFLED, RAFFLING, RAFFLES]\n",
  "RAFFLED": "RAFFLE, to dispose of by tickets of chance [v]\n",
  "RAFFLER": "one who raffles [n -S]\n",
  "RAFFLERS": "RAFFLER, one who raffles [n]\n",
  "RAFFLES": "RAFFLE, to dispose of by tickets of chance [v]\n",
  "RAFFLESIA": "any of various stemless leafless parasitic plants, native to Java and Sumatra [n -S]\n",
  "RAFFLESIAS": "RAFFLESIA, any of various stemless leafless parasitic plants, native to Java and Sumatra [n]\n",
  "RAFFLING": "RAFFLE, to dispose of by tickets of chance [v]\n",
  "RAFFS": "RAFF, (archaic) rubbish, refuse [n]\n",
  "RAFT": "to ride on water on a floating mass [v -ED, -ING, -S]\n",
  "RAFTED": "RAFT, to ride on water on a floating mass [v]\n",
  "RAFTER": "to supply with supporting beams [v -ED, -ING, -S]\n",
  "RAFTERED": "RAFTER, to supply with supporting beams [v]\n",
  "RAFTERING": "rafters collectively [n -S]\n",
  "RAFTERINGS": "RAFTERING, rafters collectively [n]\n",
  "RAFTERS": "RAFTER, to supply with supporting beams [v]\n",
  "RAFTING": "an activity of travelling by raft [n -S]\n",
  "RAFTINGS": "RAFTING, an activity of travelling by raft [n]\n",
  "RAFTMAN": "one who manages a raft, also RAFTSMAN [n RAFTMEN]\n",
  "RAFTMEN": "RAFTMAN, one who manages a raft, also RAFTSMAN [n]\n",
  "RAFTS": "RAFT, to ride on water on a floating mass [v]\n",
  "RAFTSMAN": "one who manages a raft, also RAFTMAN [n RAFTSMEN]\n",
  "RAFTSMEN": "RAFTSMAN, one who manages a raft, also RAFTMAN [n]\n",
  "RAG": "to tease or ridicule [v RAGGED, RAGGING, RAGS]\n",
  "RAGA": "(Sanskrit) an Indian musical form [n -S]\n",
  "RAGAMUFFIN": "someone, esp. a child, in ragged, dirty clothes [n -S]\n",
  "RAGAMUFFINS": "RAGAMUFFIN, someone, esp. a child, in ragged, dirty clothes [n]\n",
  "RAGAS": "RAGA, (Sanskrit) an Indian musical form [n]\n",
  "RAGBAG": "a bag for storing rags [n -S]\n",
  "RAGBAGS": "RAGBAG, a bag for storing rags [n]\n",
  "RAGBOLT": "a bolt with barbs to prevent withdrawal [n -S]\n",
  "RAGBOLTS": "RAGBOLT, a bolt with barbs to prevent withdrawal [n]\n",
  "RAGDE": "(Shakespeare) ragged [adj]\n",
  "RAGDOLL": "a kind of domestic cat [n -S]\n",
  "RAGDOLLS": "RAGDOLL, a kind of domestic cat [n]\n",
  "RAGE": "to react with violent anger [v RAGED, RAGING, RAGES]\n",
  "RAGED": "RAGE, to react with violent anger [v]\n",
  "RAGEE": "(Hindi) a kind of millet, also RAGGEE, RAGGY, RAGI [n -S]\n",
  "RAGEES": "RAGEE, (Hindi) a kind of millet, also RAGGEE, RAGGY, RAGI [n]\n",
  "RAGEFUL": "full of rage [adj]\n",
  "RAGER": "one who rages [n -S]\n",
  "RAGERS": "RAGER, one who rages [n]\n",
  "RAGES": "RAGE, to react with violent anger [v]\n",
  "RAGG": "a rough hard stone, also RAGSTONE [n -S]\n",
  "RAGGA": "a type of rap music combining reggae and hip-hop, also RAGGAMUFFIN [n -S]\n",
  "RAGGAMUFFIN": "a type of rap music combining reggae and hip-hop, also RAGGA [n -S]\n",
  "RAGGAMUFFINS": "RAGGAMUFFIN, a type of rap music combining reggae and hip-hop, also RAGGA [n]\n",
  "RAGGAS": "RAGGA, a type of rap music combining reggae and hip-hop, also RAGGAMUFFIN [n]\n",
  "RAGGED": "tattered [adj RAGGEDER, RAGGEDEST, RAGGEDLY]\n",
  "RAGGEDER": "RAGGED, tattered [adj]\n",
  "RAGGEDEST": "RAGGED, tattered [adj]\n",
  "RAGGEDIER": "RAGGEDY, somewhat ragged [adj]\n",
  "RAGGEDIEST": "RAGGEDY, somewhat ragged [adj]\n",
  "RAGGEDLY": "RAGGED, tattered [adv]\n",
  "RAGGEDNESS": "the state of being ragged [n -ES]\n",
  "RAGGEDNESSES": "RAGGEDNESS, the state of being ragged [n]\n",
  "RAGGEDY": "somewhat ragged [adj RAGGEDIER, RAGGEDIEST]\n",
  "RAGGEE": "(Hindi) a kind of millet, also RAGEE, RAGGY, RAGI [n -S]\n",
  "RAGGEES": "RAGGEE, (Hindi) a kind of millet, also RAGEE, RAGGY, RAGI [n]\n",
  "RAGGERIES": "RAGGERY, rags collectively [n]\n",
  "RAGGERY": "rags collectively [n RAGGERIES]\n",
  "RAGGIER": "RAGGY, tattered [adj]\n",
  "RAGGIES": "RAGGY, a kind of millet, also RAGI, RAGEE, RAGGEE [n]\n",
  "RAGGIEST": "RAGGY, tattered [adj]\n",
  "RAGGING": "the act of ragging (teasing) [n -S]\n",
  "RAGGINGS": "RAGGING, the act of ragging (teasing) [n]\n",
  "RAGGLE": "to cut a groove in masonry [v RAGGLED, RAGGLING, RAGGLES]\n",
  "RAGGLED": "RAGGLE, to cut a groove in masonry [v]\n",
  "RAGGLES": "RAGGLE, to cut a groove in masonry [v]\n",
  "RAGGLING": "RAGGLE, to cut a groove in masonry [v]\n",
  "RAGGS": "RAGG, a rough hard stone, also RAGSTONE [n]\n",
  "RAGGY": "tattered [adj RAGGIER, RAGGIEST] / a kind of millet, also RAGI, RAGEE, RAGGEE [n RAGGIES]\n",
  "RAGHEAD": "(offensive) an Arab [n -S]\n",
  "RAGHEADS": "RAGHEAD, (offensive) an Arab [n]\n",
  "RAGI": "(Hindi) a kind of millet, also RAGEE, RAGGEE, RAGGY [n -S]\n",
  "RAGING": "furious [adj RAGINGLY] / the act of being very angry [n -S]\n",
  "RAGINGLY": "RAGING, furious [adv]\n",
  "RAGINGS": "RAGING, the act of being very angry [n]\n",
  "RAGINI": "(Sanskrit) a modified raga [n -S]\n",
  "RAGINIS": "RAGINI, (Sanskrit) a modified raga [n]\n",
  "RAGIS": "RAGI, (Hindi) a kind of millet, also RAGEE, RAGGEE, RAGGY [n]\n",
  "RAGLAN": "a loose overcoat with large sleeves [n -S]\n",
  "RAGLANS": "RAGLAN, a loose overcoat with large sleeves [n]\n",
  "RAGMAN": "a man who collects, or deals in, rags, also RAGMENT [n RAGMEN] / (obsolete) a document with pendent seals [n -S]\n",
  "RAGMANS": "RAGMAN, a man who collects, or deals in, rags, also RAGMENT [n]\n",
  "RAGMATICAL": "riotous, disorderly [adj]\n",
  "RAGMEN": "RAGMAN, a man who collects, or deals in, rags, also RAGMENT [n]\n",
  "RAGMENT": "(obsolete) a catalogue; a document with pendent seals, also RAGMAN [n -S]\n",
  "RAGMENTS": "RAGMENT, (obsolete) a catalogue; a document with pendent seals, also RAGMAN [n]\n",
  "RAGOUT": "(French) to make into a highly seasoned stew [v -ED, -ING, -S]\n",
  "RAGOUTED": "RAGOUT, (French) to make into a highly seasoned stew [v]\n",
  "RAGOUTING": "RAGOUT, (French) to make into a highly seasoned stew [v]\n",
  "RAGOUTS": "RAGOUT, (French) to make into a highly seasoned stew [v]\n",
  "RAGPICKER": "one who gets a living by picking up rags and refuse things in the streets [n -S]\n",
  "RAGPICKERS": "RAGPICKER, one who gets a living by picking up rags and refuse things in the streets [n]\n",
  "RAGS": "RAG, to tease or ridicule [v]\n",
  "RAGSTONE": "any of various different kinds of stone of a hard coarse texture, which break up in flat pieces several inches thick, also RAGG [n -S]\n",
  "RAGSTONES": "RAGSTONE, any of various different kinds of stone of a hard coarse texture, which break up in flat pieces several inches thick, also RAGG [n]\n",
  "RAGTAG": "the rabble [n -S]\n",
  "RAGTAGS": "RAGTAG, the rabble [n]\n",
  "RAGTAIL": "ragged, shabby [adj]\n",
  "RAGTIME": "a style of American dance music [n -S]\n",
  "RAGTIMER": "one who plays ragtime music [n -S]\n",
  "RAGTIMERS": "RAGTIMER, one who plays ragtime music [n]\n",
  "RAGTIMES": "RAGTIME, a style of American dance music [n]\n",
  "RAGTOP": "a folding canvas top on a sports car [n -S]\n",
  "RAGTOPS": "RAGTOP, a folding canvas top on a sports car [n]\n",
  "RAGU": "(Italian) in Italian cookery, a meat and tomato sauce [n -S]\n",
  "RAGULED": "of a line, with oblique projections like stubs, also RAGULY [adj]\n",
  "RAGULY": "with projections like stubs of branches, also RAGULED [adj]\n",
  "RAGUS": "RAGU, (Italian) in Italian cookery, a meat and tomato sauce [n]\n",
  "RAGWEED": "any of various greyish North American plants of the genus Ambrosia, of the composite family [n -S]\n",
  "RAGWEEDS": "RAGWEED, any of various greyish North American plants of the genus Ambrosia, of the composite family [n]\n",
  "RAGWHEEL": "a toothed wheel [n -S]\n",
  "RAGWHEELS": "RAGWHEEL, a toothed wheel [n]\n",
  "RAGWORK": "undressed masonry in slabs, also RAGSTONE [n -S]\n",
  "RAGWORKS": "RAGWORK, undressed masonry in slabs, also RAGSTONE [n]\n",
  "RAGWORM": "any polychaete worm of the family Nereidae, found in sand or under stones and often used as bait [n -S]\n",
  "RAGWORMS": "RAGWORM, any polychaete worm of the family Nereidae, found in sand or under stones and often used as bait [n]\n",
  "RAGWORT": "a common coarse yellow-headed composite weed of pastures [n -S]\n",
  "RAGWORTS": "RAGWORT, a common coarse yellow-headed composite weed of pastures [n]\n",
  "RAH": "to cheer on a team or player [v -ED, -ING, -S]\n",
  "RAHED": "RAH, to cheer on a team or player [v]\n",
  "RAHING": "RAH, to cheer on a team or player [v]\n",
  "RAHS": "RAH, to cheer on a team or player [v]\n",
  "RAHUI": "(Maori) a Maori prohibition [n -S]\n",
  "RAHUIS": "RAHUI, (Maori) a Maori prohibition [n]\n",
  "RAI": "a modern North African form of popular music [n -S]\n",
  "RAIA": "(Arabic) a non-Muslim subject of Turkey, also RAYA, RAYAH [n -S]\n",
  "RAIAS": "RAIA, (Arabic) a non-Muslim subject of Turkey, also RAYA, RAYAH [n]\n",
  "RAID": "to make a sudden assault on [v -ED, -ING, -S]\n",
  "RAIDED": "RAID, to make a sudden assault on [v]\n",
  "RAIDER": "one that raids [n -S]\n",
  "RAIDERS": "RAIDER, one that raids [n]\n",
  "RAIDING": "the act of raiding [n -S]\n",
  "RAIDINGS": "RAIDING, the act of raiding [n]\n",
  "RAIDS": "RAID, to make a sudden assault on [v]\n",
  "RAIK": "(Scots) to go; to range [v -ED, -ING, -S]\n",
  "RAIKED": "RAIK, (Scots) to go; to range [v]\n",
  "RAIKING": "RAIK, (Scots) to go; to range [v]\n",
  "RAIKS": "RAIK, (Scots) to go; to range [v]\n",
  "RAIL": "to scold in abusive or insolent language, also RAYLE [v -ED, -ING, -S]\n",
  "RAILAGE": "transportation by railway; the cost of this [n -S]\n",
  "RAILAGES": "RAILAGE, transportation by railway; the cost of this [n]\n",
  "RAILBED": "the bed of a railway track [n -S]\n",
  "RAILBEDS": "RAILBED, the bed of a railway track [n]\n",
  "RAILBIRD": "a racing enthusiast [n -S]\n",
  "RAILBIRDS": "RAILBIRD, a racing enthusiast [n]\n",
  "RAILBUS": "a passenger bus on rails [n RAILBUSES or RAILBUSSES]\n",
  "RAILBUSES": "RAILBUS, a passenger bus on rails [n]\n",
  "RAILBUSSES": "RAILBUS, a passenger bus on rails [n]\n",
  "RAILCAR": "a railway car [n -S]\n",
  "RAILCARD": "a special travel card [n -S]\n",
  "RAILCARDS": "RAILCARD, a special travel card [n]\n",
  "RAILCARS": "RAILCAR, a railway car [n]\n",
  "RAILE": "(Spenser) to flow, gush [v RAILED, RAILING, RAILES]\n",
  "RAILED": "RAILE, (Spenser) to flow, gush [v]\n",
  "RAILER": "one who rails [n -S]\n",
  "RAILERS": "RAILER, one who rails [n]\n",
  "RAILES": "RAILE, (Spenser) to flow, gush [v]\n",
  "RAILHEAD": "the end of a railway line [n -S]\n",
  "RAILHEADS": "RAILHEAD, the end of a railway line [n]\n",
  "RAILING": "jeering [adj RAILINGLY] / a fencelike barrier [n -S]\n",
  "RAILINGLY": "RAILING, jeering [adv]\n",
  "RAILINGS": "RAILING, a fencelike barrier [n]\n",
  "RAILLERIES": "RAILLERY, good-natured teasing [n]\n",
  "RAILLERY": "good-natured teasing [n RAILLERIES]\n",
  "RAILLESS": "without rails [adj]\n",
  "RAILLIES": "RAILLY, a jacket [n]\n",
  "RAILLY": "a jacket [n RAILLIES]\n",
  "RAILMAN": "a railway employee [n RAILMEN]\n",
  "RAILMEN": "RAILMAN, a railway employee [n]\n",
  "RAILROAD": "to put through a process forcefully and rapidly [v -ED, -ING, -S]\n",
  "RAILROADED": "RAILROAD, to put through a process forcefully and rapidly [v]\n",
  "RAILROADER": "a railway worker or official [n -S]\n",
  "RAILROADERS": "RAILROADER, a railway worker or official [n]\n",
  "RAILROADING": "putting through a process forcefully and rapidly [n -S]\n",
  "RAILROADINGS": "RAILROADING, putting through a process forcefully and rapidly [n]\n",
  "RAILROADS": "RAILROAD, to put through a process forcefully and rapidly [v]\n",
  "RAILS": "RAIL, to scold in abusive or insolent language, also RAYLE [v]\n",
  "RAILWAY": "a railroad [n -S]\n",
  "RAILWAYMAN": "one who works on the railway [n RAILWAYMEN]\n",
  "RAILWAYMEN": "RAILWAYMAN, one who works on the railway [n]\n",
  "RAILWAYS": "RAILWAY, a railroad [n]\n",
  "RAILWOMAN": "a female railway worker [n RAILWOMEN]\n",
  "RAILWOMEN": "RAILWOMAN, a female railway worker [n]\n",
  "RAILWORKER": "one who works on a railway [n -S]\n",
  "RAILWORKERS": "RAILWORKER, one who works on a railway [n]\n",
  "RAIMENT": "(archaic) clothing [n -S]\n",
  "RAIMENTS": "RAIMENT, (archaic) clothing [n]\n",
  "RAIN": "to fall in drops of water [v -ED, -ING, -S]\n",
  "RAINBAND": "a dark band in the earth's atmosphere, caused by the presence of water vapour in the earth's atmosphere [n -S]\n",
  "RAINBANDS": "RAINBAND, a dark band in the earth's atmosphere, caused by the presence of water vapour in the earth's atmosphere [n]\n",
  "RAINBIRD": "a bird, such as the green woodpecker, supposed to foretell rain [n -S]\n",
  "RAINBIRDS": "RAINBIRD, a bird, such as the green woodpecker, supposed to foretell rain [n]\n",
  "RAINBOW": "an arc of spectral colours formed in the sky [n -S]\n",
  "RAINBOWED": "having a rainbow [adj]\n",
  "RAINBOWIER": "RAINBOWY, full of rainbows [adj]\n",
  "RAINBOWIEST": "RAINBOWY, full of rainbows [adj]\n",
  "RAINBOWLIKE": "like a rainbow [adj]\n",
  "RAINBOWS": "RAINBOW, an arc of spectral colours formed in the sky [n]\n",
  "RAINBOWY": "full of rainbows [adj RAINBOWIER, RAINBOWIEST]\n",
  "RAINCHECK": "a ticket for future use given to spectators when rain stops a game [n -S]\n",
  "RAINCHECKS": "RAINCHECK, a ticket for future use given to spectators when rain stops a game [n]\n",
  "RAINCOAT": "a coat worn to keep off the rain [n -S]\n",
  "RAINCOATS": "RAINCOAT, a coat worn to keep off the rain [n]\n",
  "RAINDATE": "an alternate date in the event of rain [n -S]\n",
  "RAINDATES": "RAINDATE, an alternate date in the event of rain [n]\n",
  "RAINDROP": "a drop of rain [n -S]\n",
  "RAINDROPS": "RAINDROP, a drop of rain [n]\n",
  "RAINE": "(Spenser) to reign, also RAYNE [v RAINED, RAINING, RAINES]\n",
  "RAINED": "RAIN, to fall in drops of water [v]\n",
  "RAINES": "RAINE, (Spenser) to reign, also RAYNE [v]\n",
  "RAINFALL": "a fall of rain [n -S]\n",
  "RAINFALLS": "RAINFALL, a fall of rain [n]\n",
  "RAINFOREST": "a complex community dominated by trees, with high rainfall, many epiphytes and lianes [n -S]\n",
  "RAINFORESTS": "RAINFOREST, a complex community dominated by trees, with high rainfall, many epiphytes and lianes [n]\n",
  "RAINIER": "RAINY, marked by rain [adj]\n",
  "RAINIEST": "RAINY, marked by rain [adj]\n",
  "RAINILY": "RAINY, marked by rain [adv]\n",
  "RAININESS": "the state of being rainy [n -ES]\n",
  "RAININESSES": "RAININESS, the state of being rainy [n]\n",
  "RAINING": "RAIN, to fall in drops of water [v]\n",
  "RAINLESS": "without rain [adj]\n",
  "RAINMAKER": "a person in tribal societies who professes to bring rain; a person with a strong ability to bring in new business or produce results, esp. through the use of influence, connections, etc. [n -S]\n",
  "RAINMAKERS": "RAINMAKER, a person in tribal societies who professes to bring rain; a person with a strong ability to bring in new business or produce results, esp. through the use of influence, connections, etc. [n]\n",
  "RAINMAKING": "a ceremony designed to bring rain [n -S]\n",
  "RAINMAKINGS": "RAINMAKING, a ceremony designed to bring rain [n]\n",
  "RAINOUT": "atomic fallout occurring in precipitation [n -S]\n",
  "RAINOUTS": "RAINOUT, atomic fallout occurring in precipitation [n]\n",
  "RAINPROOF": "to make proof against rain [v -ED, -ING, -S]\n",
  "RAINPROOFED": "RAINPROOF, to make proof against rain [v]\n",
  "RAINPROOFING": "RAINPROOF, to make proof against rain [v]\n",
  "RAINPROOFS": "RAINPROOF, to make proof against rain [v]\n",
  "RAINS": "RAIN, to fall in drops of water [v]\n",
  "RAINSPOUT": "a gutter, a downspout [n -S]\n",
  "RAINSPOUTS": "RAINSPOUT, a gutter, a downspout [n]\n",
  "RAINSQUALL": "a squall of rain [n -S]\n",
  "RAINSQUALLS": "RAINSQUALL, a squall of rain [n]\n",
  "RAINSTICK": "a musical instrument consisting of a tube filled with sand or pebbles, which is inverted to produce a sound [n -S]\n",
  "RAINSTICKS": "RAINSTICK, a musical instrument consisting of a tube filled with sand or pebbles, which is inverted to produce a sound [n]\n",
  "RAINSTORM": "a storm of rain [n -S]\n",
  "RAINSTORMS": "RAINSTORM, a storm of rain [n]\n",
  "RAINSUIT": "a waterproof jacket and pants [n -S]\n",
  "RAINSUITS": "RAINSUIT, a waterproof jacket and pants [n]\n",
  "RAINSWEPT": "(of a place) open to or characterized by frequent heavy rain [adj]\n",
  "RAINTIGHT": "rainproof [adj]\n",
  "RAINWASH": "to wash material downhill by rain [v -ED, -ING, -ES]\n",
  "RAINWASHED": "RAINWASH, to wash material downhill by rain [v]\n",
  "RAINWASHES": "RAINWASH, to wash material downhill by rain [v]\n",
  "RAINWASHING": "RAINWASH, to wash material downhill by rain [v]\n",
  "RAINWATER": "water from rainfall [n -S]\n",
  "RAINWATERS": "RAINWATER, water from rainfall [n]\n",
  "RAINWEAR": "waterproof clothing [n -S]\n",
  "RAINWEARS": "RAINWEAR, waterproof clothing [n]\n",
  "RAINY": "marked by rain [adj RAINIER, RAINIEST, RAINILY]\n",
  "RAIRD": "(Scots) an uproar, also REIRD [n -S]\n",
  "RAIRDS": "RAIRD, (Scots) an uproar, also REIRD [n]\n",
  "RAIS": "RAI, a modern North African form of popular music [n]\n",
  "RAISABLE": "capable of being raised, also RAISEABLE [adj]\n",
  "RAISE": "to move to a higher position [v RAISED, RAISING, RAISES]\n",
  "RAISEABLE": "capable of being raised, also RAISABLE [adj]\n",
  "RAISED": "RAISE, to move to a higher position [v]\n",
  "RAISER": "one who raises [n -S]\n",
  "RAISERS": "RAISER, one who raises [n]\n",
  "RAISES": "RAISE, to move to a higher position [v]\n",
  "RAISIN": "(French) a dried grape [n -S]\n",
  "RAISING": "an elevation [n -S]\n",
  "RAISINGS": "RAISING, an elevation [n]\n",
  "RAISINIER": "RAISINY, full of raisins [adj]\n",
  "RAISINIEST": "RAISINY, full of raisins [adj]\n",
  "RAISINS": "RAISIN, (French) a dried grape [n]\n",
  "RAISINY": "full of raisins [adj RAISINIER, RAISINIEST]\n",
  "RAISONNE": "(French) arranged systematically, or according to classes or subjects; as, a catalogue raisonne [adj]\n",
  "RAISONNEUR": "(French) a person in a play or book embodying the author's viewpoint [n -S]\n",
  "RAISONNEURS": "RAISONNEUR, (French) a person in a play or book embodying the author's viewpoint [n]\n",
  "RAIT": "to soak flax, also RET [v -ED, -ING, -S]\n",
  "RAITA": "(Hindi) an Indian dish of chopped vegetables in yogurt [n -S]\n",
  "RAITAS": "RAITA, (Hindi) an Indian dish of chopped vegetables in yogurt [n]\n",
  "RAITED": "RAIT, to soak flax, also RET [v]\n",
  "RAITING": "RAIT, to soak flax, also RET [v]\n",
  "RAITS": "RAIT, to soak flax, also RET [v]\n",
  "RAIYAT": "(Hindi) an Indian peasant, also RYOT [n -S]\n",
  "RAIYATS": "RAIYAT, (Hindi) an Indian peasant, also RYOT [n]\n",
  "RAIYATWARI": "(Hindi) a system of peasantry in India, also RYOTWARI [n -S]\n",
  "RAIYATWARIS": "RAIYATWARI, (Hindi) a system of peasantry in India, also RYOTWARI [n]\n",
  "RAJ": "in India, sovereignty [n -ES]\n",
  "RAJA": "(Hindi) an Indian ruler, also RAJAH [n -S]\n",
  "RAJAH": "(Hindi) an Indian ruler, also RAJA [n -S]\n",
  "RAJAHS": "RAJAH, (Hindi) an Indian ruler, also RAJA [n]\n",
  "RAJAHSHIP": "the office or dignity of a rajah, also RAJASHIP [n -S]\n",
  "RAJAHSHIPS": "RAJAHSHIP, the office or dignity of a rajah, also RAJASHIP [n]\n",
  "RAJAS": "RAJA, (Hindi) an Indian ruler, also RAJAH [n]\n",
  "RAJASHIP": "the office of a raja, also RAJAHSHIP [n -S]\n",
  "RAJASHIPS": "RAJASHIP, the office of a raja, also RAJAHSHIP [n]\n",
  "RAJES": "RAJ, in India, sovereignty [n]\n",
  "RAJPRAMUKH": "(Hindi) the head of a state or states union in the Democratic Republic of India [n -S]\n",
  "RAJPRAMUKHS": "RAJPRAMUKH, (Hindi) the head of a state or states union in the Democratic Republic of India [n]\n",
  "RAKE": "to gather with a toothed bar on a handle [v RAKED, RAKING, RAKES]\n",
  "RAKED": "RAKE, to gather with a toothed bar on a handle [v]\n",
  "RAKEE": "(Turkish) a strong spirit distilled in Turkey, Yugoslavia, etc., from grain, usually flavoured with aniseed or other aromatics, also RAKI [n -S]\n",
  "RAKEES": "RAKEE, (Turkish) a strong spirit distilled in Turkey, Yugoslavia, etc., from grain, usually flavoured with aniseed or other aromatics, also RAKI [n]\n",
  "RAKEHELL": "a man lacking in moral restraint [n -S]\n",
  "RAKEHELLIER": "RAKEHELLY, like a rakehell, dissolute [adj]\n",
  "RAKEHELLIEST": "RAKEHELLY, like a rakehell, dissolute [adj]\n",
  "RAKEHELLS": "RAKEHELL, a man lacking in moral restraint [n]\n",
  "RAKEHELLY": "like a rakehell, dissolute [adj RAKEHELLIER, RAKEHELLIEST]\n",
  "RAKELIKE": "like a rake [adj]\n",
  "RAKEOFF": "a share of the profits [n -S]\n",
  "RAKEOFFS": "RAKEOFF, a share of the profits [n]\n",
  "RAKER": "in games, a long, fast, low-flying shot [n -S]\n",
  "RAKERIES": "RAKERY, dissoluteness [n]\n",
  "RAKERS": "RAKER, in games, a long, fast, low-flying shot [n]\n",
  "RAKERY": "dissoluteness [n RAKERIES]\n",
  "RAKES": "RAKE, to gather with a toothed bar on a handle [v]\n",
  "RAKESHAME": "a vile, dissolute wretch [n -S]\n",
  "RAKESHAMES": "RAKESHAME, a vile, dissolute wretch [n]\n",
  "RAKI": "(Turkish) a Turkish liqueur, also RAKEE [n -S]\n",
  "RAKIA": "a kind of fruit brandy produced by distillation of fermented fruit, popular throughout the Balkans, also RAKIJA [n -S]\n",
  "RAKIAS": "RAKIA, a kind of fruit brandy produced by distillation of fermented fruit, popular throughout the Balkans, also RAKIJA [n]\n",
  "RAKIJA": "a kind of fruit brandy produced by distillation of fermented fruit, popular throughout the Balkans, also RAKIA [n -S]\n",
  "RAKIJAS": "RAKIJA, a kind of fruit brandy produced by distillation of fermented fruit, popular throughout the Balkans, also RAKIA [n]\n",
  "RAKING": "the act of raking [n -S]\n",
  "RAKINGS": "RAKING, the act of raking [n]\n",
  "RAKIS": "RAKI, (Turkish) a Turkish liqueur, also RAKEE [n]\n",
  "RAKISH": "dapper [adj RAKISHLY]\n",
  "RAKISHLY": "RAKISH, dapper [adv]\n",
  "RAKISHNESS": "the quality of being rakish [n -ES]\n",
  "RAKISHNESSES": "RAKISHNESS, the quality of being rakish [n]\n",
  "RAKSHAS": "(Sanskrit) in Hindu mythology, an evil spirit, also RAKSHASA [n -ES]\n",
  "RAKSHASA": "(Sanskrit) in Hindu mythology, an evil spirit, also RAKSHAS [n -S]\n",
  "RAKSHASAS": "RAKSHASA, (Sanskrit) in Hindu mythology, an evil spirit, also RAKSHAS [n]\n",
  "RAKSHASES": "RAKSHAS, (Sanskrit) in Hindu mythology, an evil spirit, also RAKSHASA [n]\n",
  "RAKU": "(Japanese) a kind of earthenware made in Japan [n -S]\n",
  "RAKUS": "RAKU, (Japanese) a kind of earthenware made in Japan [n]\n",
  "RALE": "(French) a rattling sound from a diseased lung [n -S]\n",
  "RALES": "RALE, (French) a rattling sound from a diseased lung [n]\n",
  "RALLENTANDI": "RALLENTANDO, (Italian) a musical direction to perform a passage with a gradual decrease in time and force [n]\n",
  "RALLENTANDO": "(Italian) a musical direction to perform a passage with a gradual decrease in time and force [n RALLENTANDOS or RALLENTANDI]\n",
  "RALLENTANDOS": "RALLENTANDO, (Italian) a musical direction to perform a passage with a gradual decrease in time and force [n]\n",
  "RALLIED": "RALLY, to call together for a common purpose, also RALLYE, REALLIE [v]\n",
  "RALLIER": "one who rallies [n -S]\n",
  "RALLIERS": "RALLIER, one who rallies [n]\n",
  "RALLIES": "RALLY, to call together for a common purpose, also RALLYE, REALLIE [v]\n",
  "RALLIFORM": "of the rail family of birds [adj]\n",
  "RALLINE": "pertaining to the rail family of birds [adj]\n",
  "RALLY": "to call together for a common purpose, also RALLYE, REALLIE [v RALLIED, RALLYING, RALLIES]\n",
  "RALLYCROSS": "a form of motor sport in which cars race over a one-mile circuit of rough grass with some hard-surfaced sections [n -ES]\n",
  "RALLYCROSSES": "RALLYCROSS, a form of motor sport in which cars race over a one-mile circuit of rough grass with some hard-surfaced sections [n]\n",
  "RALLYE": "(US) a (car) rally [n -S]\n",
  "RALLYES": "RALLYE, (US) a (car) rally [n]\n",
  "RALLYING": "the sport of driving in car rallies [n -S]\n",
  "RALLYINGLY": "RALLYING [adv]\n",
  "RALLYINGS": "RALLYING, the sport of driving in car rallies [n]\n",
  "RALLYIST": "one who takes part in car rallies [n -S]\n",
  "RALLYISTS": "RALLYIST, one who takes part in car rallies [n]\n",
  "RALPH": "(US slang) to vomit [v -ED, -ING, -S]\n",
  "RALPHED": "RALPH, (US slang) to vomit [v]\n",
  "RALPHING": "RALPH, (US slang) to vomit [v]\n",
  "RALPHS": "RALPH, (US slang) to vomit [v]\n",
  "RAM": "to thrust roughly with force [v RAMMED, RAMMING, RAMS]\n",
  "RAMADA": "(Spanish) an outdoor eating area with roof but open sides [n -S]\n",
  "RAMADAS": "RAMADA, (Spanish) an outdoor eating area with roof but open sides [n]\n",
  "RAMAKIN": "a small casserole dish in which cheese souffle, eggs etc. are served, also RAMEKIN, RAMEQUIN [n -S]\n",
  "RAMAKINS": "RAMAKIN, a small casserole dish in which cheese souffle, eggs etc. are served, also RAMEKIN, RAMEQUIN [n]\n",
  "RAMAL": "of or pertaining to a ramus or branch, also RAMEAL, RAMEOUS [adj]\n",
  "RAMAPITHECINE": "an early Pliocene genus of primates [n -S]\n",
  "RAMAPITHECINES": "RAMAPITHECINE, an early Pliocene genus of primates [n]\n",
  "RAMATE": "branched, as the stem or root of a plant, also RAMOSE, RAMOUS [adj]\n",
  "RAMBLA": "(Spanish) a dry ravine; a broad avenue esp. in Barcelona [n -S]\n",
  "RAMBLAS": "RAMBLA, (Spanish) a dry ravine; a broad avenue esp. in Barcelona [n]\n",
  "RAMBLE": "to wander [v RAMBLED, RAMBLING, RAMBLES]\n",
  "RAMBLED": "RAMBLE, to wander [v]\n",
  "RAMBLER": "one that rambles [n -S]\n",
  "RAMBLERS": "RAMBLER, one that rambles [n]\n",
  "RAMBLES": "RAMBLE, to wander [v]\n",
  "RAMBLING": "discursive [adj RAMBLINGLY] / the act of rambling [n -S]\n",
  "RAMBLINGLY": "RAMBLING, discursive [adv]\n",
  "RAMBLINGS": "RAMBLING, the act of rambling [n]\n",
  "RAMBOUILLET": "a kind of sheep [n -S]\n",
  "RAMBOUILLETS": "RAMBOUILLET, a kind of sheep [n]\n",
  "RAMBUNCTIOUS": "marked by uncontrollable exuberance, unruly, also RUMBUNCTIOUS [adj RAMBUNCTIOUSLY]\n",
  "RAMBUNCTIOUSLY": "RAMBUNCTIOUS, marked by uncontrollable exuberance, unruly, also RUMBUNCTIOUS [adv]\n",
  "RAMBUTAN": "(Malay) a tree of the same family as the lychee; its edible fruit [n -S]\n",
  "RAMBUTANS": "RAMBUTAN, (Malay) a tree of the same family as the lychee; its edible fruit [n]\n",
  "RAMCAT": "a male cat [n -S]\n",
  "RAMCATS": "RAMCAT, a male cat [n]\n",
  "RAMEAL": "of or pertaining to a ramus or branch, also RAMAL, RAMEOUS [adj]\n",
  "RAMEE": "(Malay) Rhea or China grass, a plant of the nettle family, also RAMI, RAMIE [n -S]\n",
  "RAMEES": "RAMEE, (Malay) Rhea or China grass, a plant of the nettle family, also RAMI, RAMIE [n]\n",
  "RAMEKIN": "a small casserole dish in which cheese souffle, eggs etc. are served, also RAMAKIN, RAMEQUIN [n -S]\n",
  "RAMEKINS": "RAMEKIN, a small casserole dish in which cheese souffle, eggs etc. are served, also RAMAKIN, RAMEQUIN [n]\n",
  "RAMEN": "(Japanese) a dish of clear broth with noodles [n -S]\n",
  "RAMENS": "RAMEN, (Japanese) a dish of clear broth with noodles [n]\n",
  "RAMENTA": "RAMENTUM, (Latin) a scale formed on the surface of fern leaves [n]\n",
  "RAMENTACEOUS": "of or like ramentum [adj]\n",
  "RAMENTUM": "(Latin) a scale formed on the surface of fern leaves [n RAMENTA]\n",
  "RAMEOUS": "of or pertaining to a ramus or branch, also RAMAL, RAMEAL [adj]\n",
  "RAMEQUIN": "a small casserole dish in which cheese souffle, eggs etc. are served, also RAMAKIN, RAMEKIN [n -S]\n",
  "RAMEQUINS": "RAMEQUIN, a small casserole dish in which cheese souffle, eggs etc. are served, also RAMAKIN, RAMEKIN [n]\n",
  "RAMET": "an independent member of a clone [n -S]\n",
  "RAMETS": "RAMET, an independent member of a clone [n]\n",
  "RAMGUNSHOCH": "(Scots) rough [adj]\n",
  "RAMI": "(Malay) Rhea or China grass, a plant of the nettle family, also RAMEE, RAMIE [n -S]\n",
  "RAMIE": "(Malay) Rhea or China grass, a plant of the nettle family, also RAMEE, RAMI [n -S]\n",
  "RAMIES": "RAMIE, (Malay) Rhea or China grass, a plant of the nettle family, also RAMEE, RAMI [n]\n",
  "RAMIFICATION": "branching [n -S]\n",
  "RAMIFICATIONS": "RAMIFICATION, branching [n]\n",
  "RAMIFIED": "RAMIFY, to divide into branches [v]\n",
  "RAMIFIES": "RAMIFY, to divide into branches [v]\n",
  "RAMIFORM": "shaped like a branch [adj]\n",
  "RAMIFY": "to divide into branches [v RAMIFIED, RAMIFYING, RAMIFIES]\n",
  "RAMIFYING": "RAMIFY, to divide into branches [v]\n",
  "RAMILIE": "a wig with a long plait at the back, fashionable in the 18th century, also RAMILLIE [n -S]\n",
  "RAMILIES": "RAMILIE, a wig with a long plait at the back, fashionable in the 18th century, also RAMILLIE [n]\n",
  "RAMILLIE": "a wig with a long plait at the back, fashionable in the 18th century, also RAMILIE [n -S]\n",
  "RAMILLIES": "RAMILLIE, a wig with a long plait at the back, fashionable in the 18th century, also RAMILIE [n]\n",
  "RAMIN": "(Malay) a Malaysian hardwood tree; its timber [n -S]\n",
  "RAMINS": "RAMIN, (Malay) a Malaysian hardwood tree; its timber [n]\n",
  "RAMIS": "RAMI, (Malay) Rhea or China grass, a plant of the nettle family, also RAMEE, RAMIE [n]\n",
  "RAMJET": "a type of engine [n -S]\n",
  "RAMJETS": "RAMJET, a type of engine [n]\n",
  "RAMMED": "RAM, to thrust roughly with force [v]\n",
  "RAMMEL": "(dialect) discarded matter, waste [n -S]\n",
  "RAMMELS": "RAMMEL, (dialect) discarded matter, waste [n]\n",
  "RAMMER": "a tool for ramming e.g. pavements [n -S]\n",
  "RAMMERS": "RAMMER, a tool for ramming e.g. pavements [n]\n",
  "RAMMIER": "RAMMY, resembling a male sheep [adj]\n",
  "RAMMIES": "RAMMY, a row [n]\n",
  "RAMMIEST": "RAMMY, resembling a male sheep [adj]\n",
  "RAMMING": "RAM, to thrust roughly with force [v]\n",
  "RAMMISH": "resembling a male sheep, also RAMMY [adj]\n",
  "RAMMISHLY": "RAMMISH, resembling a male sheep, also RAMMY [adv]\n",
  "RAMMISHNESS": "the state of being rammish [n -ES]\n",
  "RAMMISHNESSES": "RAMMISHNESS, the state of being rammish [n]\n",
  "RAMMLE": "(English dialect) things saved in case they might prove useful [n -S]\n",
  "RAMMLES": "RAMMLE, (English dialect) things saved in case they might prove useful [n]\n",
  "RAMMY": "resembling a male sheep [adj RAMMIER, RAMMIEST] / a row [n RAMMIES]\n",
  "RAMONA": "(Spanish) any of various plants of the sage family having aromatic greyish-green leaves, aka sagebrush [n -S]\n",
  "RAMONAS": "RAMONA, (Spanish) any of various plants of the sage family having aromatic greyish-green leaves, aka sagebrush [n]\n",
  "RAMOSE": "branched, as the stem or root of a plant, also RAMATE, RAMOUS [adj]\n",
  "RAMOSELY": "RAMOSE, branched, as the stem or root of a plant, also RAMATE, RAMOUS [adv]\n",
  "RAMOSITIES": "RAMOSITY, the state of being ramose, branched [n]\n",
  "RAMOSITY": "the state of being ramose, branched [n RAMOSITIES]\n",
  "RAMOUS": "having many branches, also RAMATE, RAMOSE [adj RAMOUSLY]\n",
  "RAMOUSLY": "RAMOUS, having many branches, also RAMATE, RAMOSE [adv]\n",
  "RAMP": "to swindle, esp. by the practice of causing large, false increases in the price of shares etc. by dishonest means [v -ED, -ING, -S]\n",
  "RAMPACIOUS": "(Dickens) turbulent, unruly, also RAMPAGEOUS [adj]\n",
  "RAMPAGE": "to rush around wildly, also RAMPAUGE [v RAMPAGED, RAMPAGING, RAMPAGES]\n",
  "RAMPAGED": "RAMPAGE, to rush around wildly, also RAMPAUGE [v]\n",
  "RAMPAGEOUS": "turbulent; unruly, also RAMPACIOUS [adj RAMPAGEOUSLY]\n",
  "RAMPAGEOUSLY": "RAMPAGEOUS, turbulent; unruly, also RAMPACIOUS [adv]\n",
  "RAMPAGEOUSNESS": "the state of being rampageous [n]\n",
  "RAMPAGER": "one who rampages [n -S]\n",
  "RAMPAGERS": "RAMPAGER, one who rampages [n]\n",
  "RAMPAGES": "RAMPAGE, to rush around wildly, also RAMPAUGE [v]\n",
  "RAMPAGING": "the act of rampaging [n -S]\n",
  "RAMPAGINGS": "RAMPAGING, the act of rampaging [n]\n",
  "RAMPALLIAN": "(Shakespeare) a mean wretch [n -S]\n",
  "RAMPALLIANS": "RAMPALLIAN, (Shakespeare) a mean wretch [n]\n",
  "RAMPANCIES": "RAMPANCY, the state of being rampant [n]\n",
  "RAMPANCY": "the state of being rampant [n RAMPANCIES]\n",
  "RAMPANT": "unrestrained [adj RAMPANTLY]\n",
  "RAMPANTLY": "RAMPANT, unrestrained [adv]\n",
  "RAMPART": "to furnish with a fortifying embankment [v -ED, -ING, -S]\n",
  "RAMPARTED": "RAMPART, to furnish with a fortifying embankment [v]\n",
  "RAMPARTING": "RAMPART, to furnish with a fortifying embankment [v]\n",
  "RAMPARTS": "RAMPART, to furnish with a fortifying embankment [v]\n",
  "RAMPAUGE": "(Scots) to rampage [v RAMPAUGED, RAMPAUGING, RAMPAUGES]\n",
  "RAMPAUGED": "RAMPAUGE, (Scots) to rampage [v]\n",
  "RAMPAUGES": "RAMPAUGE, (Scots) to rampage [v]\n",
  "RAMPAUGING": "RAMPAUGE, (Scots) to rampage [v]\n",
  "RAMPED": "RAMP, to swindle, esp. by the practice of causing large, false increases in the price of shares etc. by dishonest means [v]\n",
  "RAMPER": "one who makes a disturbance to cover the activities of others [n -S]\n",
  "RAMPERS": "RAMPER, one who makes a disturbance to cover the activities of others [n]\n",
  "RAMPICK": "a dead tree or tree decayed at top, also RAMPIKE, RAMPOLE, RANPIKE [n -S]\n",
  "RAMPICKED": "of a tree, like a rampick, decayed at the top [adj]\n",
  "RAMPICKS": "RAMPICK, a dead tree or tree decayed at top, also RAMPIKE, RAMPOLE, RANPIKE [n]\n",
  "RAMPIKE": "a dead tree or tree decayed at top, also RAMPICK, RAMPOLE, RANPIKE [n -S]\n",
  "RAMPIKES": "RAMPIKE, a dead tree or tree decayed at top, also RAMPICK, RAMPOLE, RANPIKE [n]\n",
  "RAMPING": "the practice of causing large, false increases in the price of shares etc. by dishonest means [n -S]\n",
  "RAMPINGS": "RAMPING, the practice of causing large, false increases in the price of shares etc. by dishonest means [n]\n",
  "RAMPION": "a European plant [n -S]\n",
  "RAMPIONS": "RAMPION, a European plant [n]\n",
  "RAMPIRE": "a flat-topped defensive mound [n -S]\n",
  "RAMPIRED": "having a rampire [adj]\n",
  "RAMPIRES": "RAMPIRE, a flat-topped defensive mound [n]\n",
  "RAMPOLE": "a dead tree or tree decayed at top, also RAMPICK, RAMPIKE, RANPIKE [n -S]\n",
  "RAMPOLES": "RAMPOLE, a dead tree or tree decayed at top, also RAMPICK, RAMPIKE, RANPIKE [n]\n",
  "RAMPS": "RAMP, to swindle, esp. by the practice of causing large, false increases in the price of shares etc. by dishonest means [v]\n",
  "RAMPSMAN": "a person who exploits bookmakers [n RAMPSMEN]\n",
  "RAMPSMEN": "RAMPSMAN, a person who exploits bookmakers [n]\n",
  "RAMROD": "to push or drive with great force [v RAMRODDED, RAMRODDING, RAMRODS]\n",
  "RAMRODDED": "RAMROD, to push or drive with great force [v]\n",
  "RAMRODDING": "RAMROD, to push or drive with great force [v]\n",
  "RAMRODS": "RAMROD, to push or drive with great force [v]\n",
  "RAMS": "RAM, to thrust roughly with force [v]\n",
  "RAMSHACKLE": "appearing ready to collapse [adj]\n",
  "RAMSHORN": "a snail used as an aquarium scavenger [n -S]\n",
  "RAMSHORNS": "RAMSHORN, a snail used as an aquarium scavenger [n]\n",
  "RAMSON": "a kind of wild garlic [n -S]\n",
  "RAMSONS": "RAMSON, a kind of wild garlic [n]\n",
  "RAMSTAM": "(Scots) headlong [adv]\n",
  "RAMTIL": "(Bengali) a plant of the Indian subcontinent, cultivated for the oil pressed from the seeds, also RAMTILLA [n -S]\n",
  "RAMTILLA": "(Bengali) a plant of the Indian subcontinent, cultivated for the oil pressed from the seeds, also RAMTIL [n -S]\n",
  "RAMTILLAS": "RAMTILLA, (Bengali) a plant of the Indian subcontinent, cultivated for the oil pressed from the seeds, also RAMTIL [n]\n",
  "RAMTILS": "RAMTIL, (Bengali) a plant of the Indian subcontinent, cultivated for the oil pressed from the seeds, also RAMTILLA [n]\n",
  "RAMULAR": "of a branch [adj]\n",
  "RAMULI": "RAMULUS, (Latin) a little branch [n]\n",
  "RAMULOSE": "having many small branches, also RAMULOUS [adj]\n",
  "RAMULOUS": "having many small branches, also RAMULOSE [adj]\n",
  "RAMULUS": "(Latin) a little branch [n RAMULI]\n",
  "RAMUS": "(Latin) a branchlike part of a structure [n RAMI]\n",
  "RAN": "RUN, to move by rapid steps [v]\n",
  "RANA": "(Hindi) a Rajput prince [n -S]\n",
  "RANARIAN": "pertaining to frogs [adj]\n",
  "RANARIUM": "(Latin) a place for rearing frogs [n -S]\n",
  "RANARIUMS": "RANARIUM, (Latin) a place for rearing frogs [n]\n",
  "RANAS": "RANA, (Hindi) a Rajput prince [n]\n",
  "RANCE": "to prop [v RANCED, RANCING, RANCES]\n",
  "RANCED": "RANCE, to prop [v]\n",
  "RANCEL": "to search for stolen goods, also RANSEL, RANZEL [v RANCELLED, RANCELLING, RANCELS]\n",
  "RANCELLED": "RANCEL, to search for stolen goods, also RANSEL, RANZEL [v]\n",
  "RANCELLING": "RANCEL, to search for stolen goods, also RANSEL, RANZEL [v]\n",
  "RANCELS": "RANCEL, to search for stolen goods, also RANSEL, RANZEL [v]\n",
  "RANCES": "RANCE, to prop [v]\n",
  "RANCH": "to work at an establishment for raising livestock [v -ED, -ING, -ES]\n",
  "RANCHED": "RANCH, to work at an establishment for raising livestock [v]\n",
  "RANCHER": "one that owns or works on a ranch [n -S]\n",
  "RANCHERA": "(Spanish) a type of Mexican country music [n -S]\n",
  "RANCHERAS": "RANCHERA, (Spanish) a type of Mexican country music [n]\n",
  "RANCHERIA": "(Spanish) in Spanish America and the western US, a collection of Indian huts; a place or house where a number of rancheros live [n -S]\n",
  "RANCHERIAS": "RANCHERIA, (Spanish) in Spanish America and the western US, a collection of Indian huts; a place or house where a number of rancheros live [n]\n",
  "RANCHERIE": "a Canadian Indian village or settlement, esp. on a reserve [n -S]\n",
  "RANCHERIES": "RANCHERIE, a Canadian Indian village or settlement, esp. on a reserve [n]\n",
  "RANCHERO": "(Spanish) in Mexico and the southwestern US, a rancher [n -S]\n",
  "RANCHEROS": "RANCHERO, (Spanish) in Mexico and the southwestern US, a rancher [n]\n",
  "RANCHERS": "RANCHER, one that owns or works on a ranch [n]\n",
  "RANCHES": "RANCH, to work at an establishment for raising livestock [v]\n",
  "RANCHETTE": "a small-scale ranch, typically of only a few acres [n -S]\n",
  "RANCHETTES": "RANCHETTE, a small-scale ranch, typically of only a few acres [n]\n",
  "RANCHING": "the act of ranching [n -S]\n",
  "RANCHINGS": "RANCHING, the act of ranching [n]\n",
  "RANCHLAND": "the land occupied by a ranch [n -S]\n",
  "RANCHLANDS": "RANCHLAND, the land occupied by a ranch [n]\n",
  "RANCHLESS": "without a ranch [adj]\n",
  "RANCHLIKE": "like a ranch [adj]\n",
  "RANCHMAN": "one who works on or owns a ranch [n RANCHMEN]\n",
  "RANCHMEN": "RANCHMAN, one who works on or owns a ranch [n]\n",
  "RANCHO": "(Spanish) a rude hut, or group of huts, esp. for travellers [n -S]\n",
  "RANCHOS": "RANCHO, (Spanish) a rude hut, or group of huts, esp. for travellers [n]\n",
  "RANCID": "rank in taste or smell [adj RANCIDER, RANCIDEST, RANCIDLY]\n",
  "RANCIDER": "RANCID, rank in taste or smell [adj]\n",
  "RANCIDEST": "RANCID, rank in taste or smell [adj]\n",
  "RANCIDITIES": "RANCIDITY, the state of being rancid [n]\n",
  "RANCIDITY": "the state of being rancid [n RANCIDITIES]\n",
  "RANCIDLY": "RANCID, rank in taste or smell [adv]\n",
  "RANCIDNESS": "the state of being rancid [n -ES]\n",
  "RANCIDNESSES": "RANCIDNESS, the state of being rancid [n]\n",
  "RANCING": "RANCE, to prop [v]\n",
  "RANCOR": "bitter and vindictive enmity, also RANCOUR [n -S]\n",
  "RANCORED": "having feelings of rancor, also RANCOURED [adj]\n",
  "RANCOROUS": "full of rancour [adj RANCOROUSLY]\n",
  "RANCOROUSLY": "RANCOROUS, full of rancour [adv]\n",
  "RANCOROUSNESS": "the state of being rancorous [n -ES]\n",
  "RANCOROUSNESSES": "RANCOROUSNESS, the state of being rancorous [n]\n",
  "RANCORS": "RANCOR, bitter and vindictive enmity, also RANCOUR [n]\n",
  "RANCOUR": "bitter and vindictive enmity, also RANCOR [n -S]\n",
  "RANCOURED": "having feelings of rancor, also RANCORED [adj]\n",
  "RANCOURS": "RANCOUR, bitter and vindictive enmity, also RANCOR [n]\n",
  "RAND": "to rant [v -ED, -ING, -S]\n",
  "RANDAN": "a boat rowed by three people, the second with two oars [n -S]\n",
  "RANDANS": "RANDAN, a boat rowed by three people, the second with two oars [n]\n",
  "RANDED": "RAND, to rant [v]\n",
  "RANDEM": "a tandem with three horses [n -S]\n",
  "RANDEMS": "RANDEM, a tandem with three horses [n]\n",
  "RANDIE": "a violent beggar, esp. a woman, also RANDY [n -S]\n",
  "RANDIER": "RANDY, full of sexual desire [adj]\n",
  "RANDIES": "RANDIE, a violent beggar, esp. a woman, also RANDY [n]\n",
  "RANDIEST": "RANDY, full of sexual desire [adj]\n",
  "RANDILY": "RANDY, full of sexual desire [adv]\n",
  "RANDINESS": "the state of being randy [n -ES]\n",
  "RANDINESSES": "RANDINESS, the state of being randy [n]\n",
  "RANDING": "RAND, to rant [v]\n",
  "RANDLORD": "(South African) a 19th century mining magnate [n -S]\n",
  "RANDLORDS": "RANDLORD, (South African) a 19th century mining magnate [n]\n",
  "RANDOM": "haphazard [adj RANDOMLY] / a haphazard course, also RANDON [n -S]\n",
  "RANDOMISATION": "the process of randomising, also RANDOMIZATION [n -S]\n",
  "RANDOMISATIONS": "RANDOMISATION, the process of randomising, also RANDOMIZATION [n]\n",
  "RANDOMISE": "to make random, also RANDOMIZE [v RANDOMISED, RANDOMISING, RANDOMISES]\n",
  "RANDOMISED": "RANDOMISE, to make random, also RANDOMIZE [v]\n",
  "RANDOMISER": "a device or routine for randomising, also RANDOMIZER [n -S]\n",
  "RANDOMISERS": "RANDOMISER, a device or routine for randomising, also RANDOMIZER [n]\n",
  "RANDOMISES": "RANDOMISE, to make random, also RANDOMIZE [v]\n",
  "RANDOMISING": "RANDOMISE, to make random, also RANDOMIZE [v]\n",
  "RANDOMIZATION": "the act of randomizing, also RANDOMISATION [n -S]\n",
  "RANDOMIZATIONS": "RANDOMIZATION, the act of randomizing, also RANDOMISATION [n]\n",
  "RANDOMIZE": "to make random, also RANDOMISE [v RANDOMIZED, RANDOMIZING, RANDOMIZES]\n",
  "RANDOMIZED": "RANDOMIZE, to make random, also RANDOMISE [v]\n",
  "RANDOMIZER": "a device or routine for randomising, also RANDOMISER [n -S]\n",
  "RANDOMIZERS": "RANDOMIZER, a device or routine for randomising, also RANDOMISER [n]\n",
  "RANDOMIZES": "RANDOMIZE, to make random, also RANDOMISE [v]\n",
  "RANDOMIZING": "RANDOMIZE, to make random, also RANDOMISE [v]\n",
  "RANDOMLY": "RANDOM, haphazard [adv]\n",
  "RANDOMNESS": "the state of being random [n -ES]\n",
  "RANDOMNESSES": "RANDOMNESS, the state of being random [n]\n",
  "RANDOMS": "RANDOM, a haphazard course, also RANDON [n]\n",
  "RANDOMWISE": "in a random fashion [adv]\n",
  "RANDON": "(Spenser) random chance, also RANDOM [n -S]\n",
  "RANDONS": "RANDON, (Spenser) random chance, also RANDOM [n]\n",
  "RANDS": "RAND, to rant [v]\n",
  "RANDY": "full of sexual desire [adj RANDIER, RANDIEST, RANDILY] / a violent beggar; a coarse virago, also RANDIE [n RANDIES]\n",
  "RANEE": "(Hindi) the wife of a rajah, also RANI [n -S]\n",
  "RANEES": "RANEE, (Hindi) the wife of a rajah, also RANI [n]\n",
  "RANG": "a row of long lots along a road [n -S]\n",
  "RANGA": "(Australian) an offensive term for a person with red hair [n -S]\n",
  "RANGAS": "RANGA, (Australian) an offensive term for a person with red hair [n]\n",
  "RANGATIRA": "(Maori) a leader or chief [n -S]\n",
  "RANGATIRAS": "RANGATIRA, (Maori) a leader or chief [n]\n",
  "RANGATIRATANGA": "(Maori) the condition of being a Maori chief [n -S]\n",
  "RANGATIRATANGAS": "RANGATIRATANGA, (Maori) the condition of being a Maori chief [n]\n",
  "RANGE": "to place in a particular order, also RAUNGE [v RANGED, RANGING, RANGES]\n",
  "RANGED": "RANGE, to place in a particular order, also RAUNGE [v]\n",
  "RANGEFINDER": "an instrument for finding the distance of an object [n -S]\n",
  "RANGEFINDERS": "RANGEFINDER, an instrument for finding the distance of an object [n]\n",
  "RANGEFINDING": "the act of using a rangefinder [n -S]\n",
  "RANGEFINDINGS": "RANGEFINDING, the act of using a rangefinder [n]\n",
  "RANGELAND": "land suitable for grazing, but too dry for growing crops [n -S]\n",
  "RANGELANDS": "RANGELAND, land suitable for grazing, but too dry for growing crops [n]\n",
  "RANGER": "an officer supervising the care of a forest [n -S]\n",
  "RANGERS": "RANGER, an officer supervising the care of a forest [n]\n",
  "RANGERSHIP": "the office of the keeper of a forest or park [n -S]\n",
  "RANGERSHIPS": "RANGERSHIP, the office of the keeper of a forest or park [n]\n",
  "RANGES": "RANGE, to place in a particular order, also RAUNGE [v]\n",
  "RANGI": "(Maori) sky [n -S]\n",
  "RANGIER": "RANGY, tall and slender [adj]\n",
  "RANGIEST": "RANGY, tall and slender [adj]\n",
  "RANGILY": "RANGY, tall and slender [adv]\n",
  "RANGINESS": "the state of being rangy [n -ES]\n",
  "RANGINESSES": "RANGINESS, the state of being rangy [n]\n",
  "RANGING": "the act of ranging [n -S]\n",
  "RANGINGS": "RANGING, the act of ranging [n]\n",
  "RANGIORA": "(Maori) an evergreen New Zealand shrub with large ovate leaves and small greenish-white flowers [n -S]\n",
  "RANGIORAS": "RANGIORA, (Maori) an evergreen New Zealand shrub with large ovate leaves and small greenish-white flowers [n]\n",
  "RANGIS": "RANGI, (Maori) sky [n]\n",
  "RANGOLI": "(Hindi) a traditional Hindu form of decoration on floors and doorsteps, forming patterns of coloured sand and rice flour [n -S]\n",
  "RANGOLIS": "RANGOLI, (Hindi) a traditional Hindu form of decoration on floors and doorsteps, forming patterns of coloured sand and rice flour [n]\n",
  "RANGS": "RANG, a row of long lots along a road [n]\n",
  "RANGY": "tall and slender [adj RANGIER, RANGIEST, RANGILY]\n",
  "RANI": "(Hindi) the wife of a rajah, also RANEE [n -S]\n",
  "RANID": "any of a large family of frogs [n -S]\n",
  "RANIDS": "RANID, any of a large family of frogs [n]\n",
  "RANIFORM": "froglike [adj]\n",
  "RANINE": "pertaining to or like frogs [adj]\n",
  "RANIS": "RANI, (Hindi) the wife of a rajah, also RANEE [n]\n",
  "RANIVOROUS": "eating frogs [adj]\n",
  "RANK": "disagreeable in odour or taste [adj RANKER, RANKEST, RANKLY] / to assign to a particular place or grade [v -ED, -ING, -S]\n",
  "RANKE": "(Shakespeare) a jogtrot [n -S]\n",
  "RANKED": "RANK, to assign to a particular place or grade [v]\n",
  "RANKER": "an enlisted soldier [n -S]\n",
  "RANKERS": "RANKER, an enlisted soldier [n]\n",
  "RANKES": "RANKE, (Shakespeare) a jogtrot [n]\n",
  "RANKEST": "RANK, disagreeable in odour or taste [adj]\n",
  "RANKING": "a listing of ranked individuals [n -S]\n",
  "RANKINGS": "RANKING, a listing of ranked individuals [n]\n",
  "RANKISH": "somewhat rank [adj]\n",
  "RANKISM": "discrimination on the basis of rank [n -S]\n",
  "RANKISMS": "RANKISM, discrimination on the basis of rank [n]\n",
  "RANKIST": "a person who discriminates against people on the grounds of rank [n -S]\n",
  "RANKISTS": "RANKIST, a person who discriminates against people on the grounds of rank [n]\n",
  "RANKLE": "to cause irritation or resentment in [v RANKLED, RANKLING, RANKLES]\n",
  "RANKLED": "RANKLE, to cause irritation or resentment in [v]\n",
  "RANKLES": "RANKLE, to cause irritation or resentment in [v]\n",
  "RANKLESS": "without a rank [adj]\n",
  "RANKLING": "RANKLE, to cause irritation or resentment in [v]\n",
  "RANKLY": "RANK, disagreeable in odour or taste [adv]\n",
  "RANKNESS": "the state of being rank [n -ES]\n",
  "RANKNESSES": "RANKNESS, the state of being rank [n]\n",
  "RANKS": "RANK, to assign to a particular place or grade [v]\n",
  "RANKSHIFT": "to shift or be shifted from one linguistic rank to another [v -ED, -ING, -S]\n",
  "RANKSHIFTED": "RANKSHIFT, to shift or be shifted from one linguistic rank to another [v]\n",
  "RANKSHIFTING": "RANKSHIFT, to shift or be shifted from one linguistic rank to another [v]\n",
  "RANKSHIFTS": "RANKSHIFT, to shift or be shifted from one linguistic rank to another [v]\n",
  "RANPIKE": "a dead tree or tree decayed at top, also RAMPICK, RAMPIKE, RAMPOLE [n -S]\n",
  "RANPIKES": "RANPIKE, a dead tree or tree decayed at top, also RAMPICK, RAMPIKE, RAMPOLE [n]\n",
  "RANSACK": "to search thoroughly [v -ED, -ING, -S]\n",
  "RANSACKED": "RANSACK, to search thoroughly [v]\n",
  "RANSACKER": "one who ransacks [n -S]\n",
  "RANSACKERS": "RANSACKER, one who ransacks [n]\n",
  "RANSACKING": "the act of searching thoroughly [n -S]\n",
  "RANSACKINGS": "RANSACKING, the act of searching thoroughly [n]\n",
  "RANSACKS": "RANSACK, to search thoroughly [v]\n",
  "RANSEL": "a search for stolen goods, also RANCEL, RANZEL [n -S]\n",
  "RANSELS": "RANSEL, a search for stolen goods, also RANCEL, RANZEL [n]\n",
  "RANSHACKLE": "(Scott) to search, ransack, also RANSHAKLE [v RANSHACKLED, RANSHACKLING, RANSHACKLES]\n",
  "RANSHACKLED": "RANSHACKLE, (Scott) to search, ransack, also RANSHAKLE [v]\n",
  "RANSHACKLES": "RANSHACKLE, (Scott) to search, ransack, also RANSHAKLE [v]\n",
  "RANSHACKLING": "RANSHACKLE, (Scott) to search, ransack, also RANSHAKLE [v]\n",
  "RANSHAKLE": "(Scott) to search, ransack, also RANSHACKLE [v RANSHAKLED, RANSHAKLING, RANSHAKLES]\n",
  "RANSHAKLED": "RANSHAKLE, (Scott) to search, ransack, also RANSHACKLE [v]\n",
  "RANSHAKLES": "RANSHAKLE, (Scott) to search, ransack, also RANSHACKLE [v]\n",
  "RANSHAKLING": "RANSHAKLE, (Scott) to search, ransack, also RANSHACKLE [v]\n",
  "RANSOM": "to pay a price for redemption from captivity [v -ED, -ING, -S]\n",
  "RANSOMABLE": "such as can be ransomed [adj]\n",
  "RANSOMED": "RANSOM, to pay a price for redemption from captivity [v]\n",
  "RANSOMER": "one who ransoms [n -S]\n",
  "RANSOMERS": "RANSOMER, one who ransoms [n]\n",
  "RANSOMING": "RANSOM, to pay a price for redemption from captivity [v]\n",
  "RANSOMLESS": "incapable of being ransomed [adj]\n",
  "RANSOMS": "RANSOM, to pay a price for redemption from captivity [v]\n",
  "RANSOMWARE": "illegal computer software that disables a computer or blocks access to data until a payment is received [n -S]\n",
  "RANSOMWARES": "RANSOMWARE, illegal computer software that disables a computer or blocks access to data until a payment is received [n]\n",
  "RANT": "to declaim bombastically [v -ED, -ING, -S]\n",
  "RANTED": "RANT, to declaim bombastically [v]\n",
  "RANTER": "one who rants [n -S]\n",
  "RANTERISM": "the practice or tenets of the Ranters [n -S]\n",
  "RANTERISMS": "RANTERISM, the practice or tenets of the Ranters [n]\n",
  "RANTERS": "RANTER, one who rants [n]\n",
  "RANTING": "hectoring [adj RANTINGLY] / the act of ranting [n -S]\n",
  "RANTINGLY": "RANTING, hectoring [adv]\n",
  "RANTINGS": "RANTING, the act of ranting [n]\n",
  "RANTIPOLE": "(archaic) a wild, reckless person [n -S] / to act in a wild way [v RANTIPOLED, RANTIPOLING, RANTIPOLES]\n",
  "RANTIPOLED": "RANTIPOLE, to act in a wild way [v]\n",
  "RANTIPOLES": "RANTIPOLE, to act in a wild way [v]\n",
  "RANTIPOLING": "RANTIPOLE, to act in a wild way [v]\n",
  "RANTS": "RANT, to declaim bombastically [v]\n",
  "RANULA": "(Latin) a cyst formed under the tongue [n -S]\n",
  "RANULAR": "relating to a ranula, a cyst on the lower surface of the tongue [adj]\n",
  "RANULAS": "RANULA, (Latin) a cyst formed under the tongue [n]\n",
  "RANUNCULACEOUS": "pertaining to or like buttercups; belonging to buttercup family of plants [adj]\n",
  "RANUNCULI": "RANUNCULUS, a genus of herbs, mostly with yellow flowers, including crowfoot and buttercups [n]\n",
  "RANUNCULUS": "a genus of herbs, mostly with yellow flowers, including crowfoot and buttercups [n RANUNCULI or RANUNCULUSES]\n",
  "RANUNCULUSES": "RANUNCULUS, a genus of herbs, mostly with yellow flowers, including crowfoot and buttercups [n]\n",
  "RANZEL": "a search for stolen goods, also RANCEL, RANSEL [n -S]\n",
  "RANZELMAN": "an official who searches for stolen goods [n RANZELMEN]\n",
  "RANZELMEN": "RANZELMAN, an official who searches for stolen goods [n]\n",
  "RANZELS": "RANZEL, a search for stolen goods, also RANCEL, RANSEL [n]\n",
  "RAOULIA": "a New Zealand plant [n -S]\n",
  "RAOULIAS": "RAOULIA, a New Zealand plant [n]\n",
  "RAP": "to strike sharply [v RAPPED, RAPPING, RAPS]\n",
  "RAPACIOUS": "greedy, predacious [adj RAPACIOUSLY]\n",
  "RAPACIOUSLY": "RAPACIOUS, greedy, predacious [adv]\n",
  "RAPACIOUSNESS": "the state of being rapacious [n -ES]\n",
  "RAPACIOUSNESSES": "RAPACIOUSNESS, the state of being rapacious [n]\n",
  "RAPACITIES": "RAPACITY, the quality of being rapacious [n]\n",
  "RAPACITY": "the quality of being rapacious [n RAPACITIES]\n",
  "RAPE": "to take by force; to violate [v RAPED, RAPING, RAPES]\n",
  "RAPED": "RAPE, to take by force; to violate [v]\n",
  "RAPER": "one who rapes [n -S]\n",
  "RAPERS": "RAPER, one who rapes [n]\n",
  "RAPES": "RAPE, to take by force; to violate [v]\n",
  "RAPESEED": "the seed of rape, from which an oil is expressed [n -S]\n",
  "RAPESEEDS": "RAPESEED, the seed of rape, from which an oil is expressed [n]\n",
  "RAPHAE": "RAPHE, (Greek) a seamlike ridge between two halves or an organ or part, also RHAPHE [n]\n",
  "RAPHANIA": "(Greek) a form of ergotism, attributed by Linnaeus to wild radish [n -S]\n",
  "RAPHANIAS": "RAPHANIA, (Greek) a form of ergotism, attributed by Linnaeus to wild radish [n]\n",
  "RAPHE": "(Greek) a seamlike ridge between two halves or an organ or part, also RHAPHE [n RAPHES or RAPHAE]\n",
  "RAPHES": "RAPHE, (Greek) a seamlike ridge between two halves or an organ or part, also RHAPHE [n]\n",
  "RAPHIA": "(Malagasy) a genus of palm trees, also RAFFIA [n -S]\n",
  "RAPHIAS": "RAPHIA, (Malagasy) a genus of palm trees, also RAFFIA [n]\n",
  "RAPHIDE": "a needle-shaped crystal occurring in plant cells, also RAPHIS [n -S]\n",
  "RAPHIDES": "RAPHIS, (Greek) a needlelike crystal, usually of calcium oxalate, occurring in plant cells, also RAPHIDE, RHAPHIDE, RHAPHIS [n]\n",
  "RAPHIS": "(Greek) a needlelike crystal, usually of calcium oxalate, occurring in plant cells, also RAPHIDE, RHAPHIDE, RHAPHIS [n RAPHIDES]\n",
  "RAPID": "quick [adj RAPIDER, RAPIDEST, RAPIDLY] / a swift-flowing part of a river [n -S]\n",
  "RAPIDER": "RAPID, quick [adj]\n",
  "RAPIDEST": "RAPID, quick [adj]\n",
  "RAPIDITIES": "RAPIDITY, the state of being rapid [n]\n",
  "RAPIDITY": "the state of being rapid [n RAPIDITIES]\n",
  "RAPIDLY": "RAPID, quick [adv]\n",
  "RAPIDNESS": "rapidity [n -ES]\n",
  "RAPIDNESSES": "RAPIDNESS, rapidity [n]\n",
  "RAPIDS": "RAPID, a swift-flowing part of a river [n]\n",
  "RAPIER": "a long, slender sword, designed esp. for thrusting [n -S]\n",
  "RAPIERED": "having a rapier [adj]\n",
  "RAPIERLIKE": "like a rapier [adj]\n",
  "RAPIERS": "RAPIER, a long, slender sword, designed esp. for thrusting [n]\n",
  "RAPINE": "the taking of property by force [n -S]\n",
  "RAPINES": "RAPINE, the taking of property by force [n]\n",
  "RAPING": "RAPE, to take by force; to violate [v]\n",
  "RAPINI": "(Italian) immature turnip plants, also RAPPINI [n -S]\n",
  "RAPINIS": "RAPINI, (Italian) immature turnip plants, also RAPPINI [n]\n",
  "RAPIST": "one who commits rape [n -S]\n",
  "RAPISTS": "RAPIST, one who commits rape [n]\n",
  "RAPLOCH": "(Scots) a homespun material [n -S]\n",
  "RAPLOCHS": "RAPLOCH, (Scots) a homespun material [n]\n",
  "RAPPAREE": "(Irish) a wild Irish plunderer, esp. one of the 17th century [n -S]\n",
  "RAPPAREES": "RAPPAREE, (Irish) a wild Irish plunderer, esp. one of the 17th century [n]\n",
  "RAPPE": "(Canadian) a dish of grated potatoes and pork or chicken [n -S]\n",
  "RAPPED": "RAP, to strike sharply [v]\n",
  "RAPPEE": "(French) a pungent kind of snuff made from the darker and ranker kinds of tobacco leaves [n -S]\n",
  "RAPPEES": "RAPPEE, (French) a pungent kind of snuff made from the darker and ranker kinds of tobacco leaves [n]\n",
  "RAPPEL": "(French) to descend from a steep height by means of a rope [v RAPPELED or RAPPELLED, RAPPELING or RAPPELLING, RAPPELS]\n",
  "RAPPELED": "RAPPEL, (French) to descend from a steep height by means of a rope [v]\n",
  "RAPPELING": "RAPPEL, (French) to descend from a steep height by means of a rope [v]\n",
  "RAPPELLED": "RAPPEL, (French) to descend from a steep height by means of a rope [v]\n",
  "RAPPELLING": "descending by rope [n -S]\n",
  "RAPPELLINGS": "RAPPELLING, descending by rope [n]\n",
  "RAPPELS": "RAPPEL, (French) to descend from a steep height by means of a rope [v]\n",
  "RAPPEN": "(German) a monetary unit of Switzerland [n RAPPEN]\n",
  "RAPPER": "a doorknocker [n -S]\n",
  "RAPPERS": "RAPPER, a doorknocker [n]\n",
  "RAPPES": "RAPPE, (Canadian) a dish of grated potatoes and pork or chicken [n]\n",
  "RAPPING": "the process of loosening a pattern in a foundry mould [n -S]\n",
  "RAPPINGS": "RAPPING, the process of loosening a pattern in a foundry mould [n]\n",
  "RAPPINI": "(Italian) immature turnip plants, also RAPINI [n]\n",
  "RAPPORT": "(French) a relationship, esp. harmonious [n -S]\n",
  "RAPPORTAGE": "(French) the description of real events in writing [n -S]\n",
  "RAPPORTAGES": "RAPPORTAGE, (French) the description of real events in writing [n]\n",
  "RAPPORTEUR": "(French) a person who gives reports (as at a meeting of a learned society) [n -S]\n",
  "RAPPORTEURS": "RAPPORTEUR, (French) a person who gives reports (as at a meeting of a learned society) [n]\n",
  "RAPPORTS": "RAPPORT, (French) a relationship, esp. harmonious [n]\n",
  "RAPPROCHEMENT": "(French) a resumption of or improvement in relations between countries or persons [n -S]\n",
  "RAPPROCHEMENTS": "RAPPROCHEMENT, (French) a resumption of or improvement in relations between countries or persons [n]\n",
  "RAPS": "RAP, to strike sharply [v]\n",
  "RAPSCALLION": "a low, mean wretch, also RASCALLION [n -S]\n",
  "RAPSCALLIONS": "RAPSCALLION, a low, mean wretch, also RASCALLION [n]\n",
  "RAPT": "deeply engrossed [adj RAPTLY]\n",
  "RAPTATORIAL": "predatory, also RAPTORIAL [adj]\n",
  "RAPTLY": "RAPT, deeply engrossed [adv]\n",
  "RAPTNESS": "the state of being rapt [n -ES]\n",
  "RAPTNESSES": "RAPTNESS, the state of being rapt [n]\n",
  "RAPTOR": "a bird or prey [n -S]\n",
  "RAPTORIAL": "predatory, also RAPTATORIAL [adj]\n",
  "RAPTORS": "RAPTOR, a bird or prey [n]\n",
  "RAPTURE": "to fill with great joy [v RAPTURED, RAPTURING, RAPTURES]\n",
  "RAPTURED": "RAPTURE, to fill with great joy [v]\n",
  "RAPTURELESS": "without rapture [adj]\n",
  "RAPTURES": "RAPTURE, to fill with great joy [v]\n",
  "RAPTURING": "RAPTURE, to fill with great joy [v]\n",
  "RAPTURISE": "to put, or be put, in a state of rapture, also RAPTURIZE [v RAPTURISED, RAPTURISING, RAPTURISES]\n",
  "RAPTURISED": "RAPTURISE, to put, or be put, in a state of rapture, also RAPTURIZE [v]\n",
  "RAPTURISES": "RAPTURISE, to put, or be put, in a state of rapture, also RAPTURIZE [v]\n",
  "RAPTURISING": "RAPTURISE, to put, or be put, in a state of rapture, also RAPTURIZE [v]\n",
  "RAPTURIST": "an enthusiast [n -S]\n",
  "RAPTURISTS": "RAPTURIST, an enthusiast [n]\n",
  "RAPTURIZE": "to put, or be put, in a state of rapture, also RAPTURISE [v RAPTURIZED, RAPTURIZING, RAPTURIZES]\n",
  "RAPTURIZED": "RAPTURIZE, to put, or be put, in a state of rapture, also RAPTURISE [v]\n",
  "RAPTURIZES": "RAPTURIZE, to put, or be put, in a state of rapture, also RAPTURISE [v]\n",
  "RAPTURIZING": "RAPTURIZE, to put, or be put, in a state of rapture, also RAPTURISE [v]\n",
  "RAPTUROUS": "in a state of rapture [adj RAPTUROUSLY]\n",
  "RAPTUROUSLY": "RAPTUROUS, in a state of rapture [adv]\n",
  "RAPTUROUSNESS": "the state of being rapturous [n -ES]\n",
  "RAPTUROUSNESSES": "RAPTUROUSNESS, the state of being rapturous [n]\n",
  "RARE": "not common [adj RARER, RAREST, RARELY] / to be enthusiastic, as in 'raring to go' [v RARED, RARING, RARES]\n",
  "RAREBIT": "a dish of melted and seasoned or simply toasted cheese on toast [n -S]\n",
  "RAREBITS": "RAREBIT, a dish of melted and seasoned or simply toasted cheese on toast [n]\n",
  "RARED": "RARE, to be enthusiastic, as in 'raring to go' [v]\n",
  "RAREE": "as in raree show, a street show or carnival [adj]\n",
  "RAREFACTION": "the act of rarefying [n -S]\n",
  "RAREFACTIONAL": "relating to rarefaction [adj]\n",
  "RAREFACTIONS": "RAREFACTION, the act of rarefying [n]\n",
  "RAREFACTIVE": "causing rarefaction [adj]\n",
  "RAREFIABLE": "capable of being rarefied [adj]\n",
  "RAREFICATION": "the act of rarefying [n -S]\n",
  "RAREFICATIONAL": "relating to rarefaction [adj]\n",
  "RAREFICATIONS": "RAREFICATION, the act of rarefying [n]\n",
  "RAREFIED": "RAREFY, to make less dense, also RARIFY [v]\n",
  "RAREFIER": "something or someone that rarefies [n -S]\n",
  "RAREFIERS": "RAREFIER, something or someone that rarefies [n]\n",
  "RAREFIES": "RAREFY, to make less dense, also RARIFY [v]\n",
  "RAREFY": "to make less dense, also RARIFY [v RAREFIED, RAREFYING, RAREFIES]\n",
  "RAREFYING": "RAREFY, to make less dense, also RARIFY [v]\n",
  "RARELY": "RARE, not common [adv]\n",
  "RARENESS": "the quality of being rare, also RARITY [n -ES]\n",
  "RARENESSES": "RARENESS, the quality of being rare, also RARITY [n]\n",
  "RARER": "RARE, not common [adj]\n",
  "RARERIPE": "a fruit that ripens early, also RATHERIPE, RATHRIPE [n -S]\n",
  "RARERIPES": "RARERIPE, a fruit that ripens early, also RATHERIPE, RATHRIPE [n]\n",
  "RARES": "RARE, to be enthusiastic, as in 'raring to go' [v]\n",
  "RAREST": "RARE, not common [adj]\n",
  "RARIFIED": "RARIFY, to make less dense, also RAREFY [v]\n",
  "RARIFIES": "RARIFY, to make less dense, also RAREFY [v]\n",
  "RARIFY": "to make less dense, also RAREFY [v RARIFIED, RARIFYING, RARIFIES]\n",
  "RARIFYING": "RARIFY, to make less dense, also RAREFY [v]\n",
  "RARING": "RARE, to be enthusiastic, as in 'raring to go' [v]\n",
  "RARITIES": "RARITY, the quality of being rare, also RARENESS [n]\n",
  "RARITY": "the quality of being rare, also RARENESS [n RARITIES]\n",
  "RARK": "(New Zealand) to reprimand [v -ED, -ING, -S]\n",
  "RARKED": "RARK, (New Zealand) to reprimand [v]\n",
  "RARKING": "RARK, (New Zealand) to reprimand [v]\n",
  "RARKS": "RARK, (New Zealand) to reprimand [v]\n",
  "RAS": "an Ethiopian prince [n -ES]\n",
  "RASBORA": "a brightly coloured tropical fish [n -S]\n",
  "RASBORAS": "RASBORA, a brightly coloured tropical fish [n]\n",
  "RASCAILLE": "(archaic) an archaic form of rascal, in the sense of rabble [n -S]\n",
  "RASCAILLES": "RASCAILLE, (archaic) an archaic form of rascal, in the sense of rabble [n]\n",
  "RASCAL": "a rogue or scamp [n -S]\n",
  "RASCALDOM": "the state of being a rascal [n -S]\n",
  "RASCALDOMS": "RASCALDOM, the state of being a rascal [n]\n",
  "RASCALISM": "rascally conduct, also RASCALITY [n -S]\n",
  "RASCALISMS": "RASCALISM, rascally conduct, also RASCALITY [n]\n",
  "RASCALITIES": "RASCALITY, rascally conduct, also RASCALISM [n]\n",
  "RASCALITY": "rascally conduct, also RASCALISM [n RASCALITIES]\n",
  "RASCALLIER": "RASCALLY, like a rascal [adj]\n",
  "RASCALLIEST": "RASCALLY, like a rascal [adj]\n",
  "RASCALLION": "a low, mean wretch, also RAPSCALLION [n -S]\n",
  "RASCALLIONS": "RASCALLION, a low, mean wretch, also RAPSCALLION [n]\n",
  "RASCALLY": "like a rascal [adj RASCALLIER, RASCALLIEST]\n",
  "RASCALS": "RASCAL, a rogue or scamp [n]\n",
  "RASCASSE": "(French) a kind of fish found in the Mediterranean, aka scorpion fish [n -S]\n",
  "RASCASSES": "RASCASSE, (French) a kind of fish found in the Mediterranean, aka scorpion fish [n]\n",
  "RASCHEL": "(German) a type of light loosely knitted cloth [n -S]\n",
  "RASCHELS": "RASCHEL, (German) a type of light loosely knitted cloth [n]\n",
  "RASE": "to demolish, also RAZE [v RASED, RASING, RASES]\n",
  "RASED": "RASE, to demolish, also RAZE [v]\n",
  "RASER": "one that rases, also RAZER [n -S]\n",
  "RASERS": "RASER, one that rases, also RAZER [n]\n",
  "RASES": "RASE, to demolish, also RAZE [v]\n",
  "RASH": "acting without forethought [adj RASHER, RASHEST, RASHLY] / to dash, rush [v -ED, -ING, -ES]\n",
  "RASHED": "RASH, to dash, rush [v]\n",
  "RASHER": "a thin slice of meat [n -S]\n",
  "RASHERS": "RASHER, a thin slice of meat [n]\n",
  "RASHES": "RASH, to dash, rush [v]\n",
  "RASHEST": "RASH, acting without forethought [adj]\n",
  "RASHIE": "(Australian slang) a shirt worn by surfers as protection against the sun, heat rash etc. [n -S]\n",
  "RASHIES": "RASHIE, (Australian slang) a shirt worn by surfers as protection against the sun, heat rash etc. [n]\n",
  "RASHING": "RASH, to dash, rush [v]\n",
  "RASHLIKE": "like a rash [adj]\n",
  "RASHLY": "RASH, acting without forethought [adv]\n",
  "RASHNESS": "the state of being rash [n -ES]\n",
  "RASHNESSES": "RASHNESS, the state of being rash [n]\n",
  "RASING": "RASE, to demolish, also RAZE [v]\n",
  "RASMALAI": "(Hindi) an Indian dessert made of cheese, milk and almonds [n -S]\n",
  "RASMALAIS": "RASMALAI, (Hindi) an Indian dessert made of cheese, milk and almonds [n]\n",
  "RASORIAL": "habitually scratching the ground for food [adj]\n",
  "RASP": "to scrape with something rough [v -ED, -ING, -S]\n",
  "RASPATORIES": "RASPATORY, a surgeon's rasp [n]\n",
  "RASPATORY": "a surgeon's rasp [n RASPATORIES]\n",
  "RASPBERRIES": "RASPBERRY, the fruit of Rubus idaeus [n]\n",
  "RASPBERRY": "the fruit of Rubus idaeus [n RASPBERRIES]\n",
  "RASPED": "RASP, to scrape with something rough [v]\n",
  "RASPER": "a tool used for rasping [n -S]\n",
  "RASPERS": "RASPER, a tool used for rasping [n]\n",
  "RASPIER": "RASPY, rough [adj]\n",
  "RASPIEST": "RASPY, rough [adj]\n",
  "RASPINESS": "the state of being raspy, rough [n -ES]\n",
  "RASPINESSES": "RASPINESS, the state of being raspy, rough [n]\n",
  "RASPING": "abrasive [adj RASPINGLY] / the act of rasping [n -S]\n",
  "RASPINGLY": "RASPING, abrasive [adv]\n",
  "RASPINGS": "RASPING, the act of rasping [n]\n",
  "RASPISH": "irritable [adj]\n",
  "RASPS": "RASP, to scrape with something rough [v]\n",
  "RASPY": "rough [adj RASPIER, RASPIEST]\n",
  "RASSE": "(Javanese) a carnivore allied to the civet but smaller, native of China and the East Indies [n -S]\n",
  "RASSES": "RASSE, (Javanese) a carnivore allied to the civet but smaller, native of China and the East Indies [n]\n",
  "RASSLE": "(colloquial) to wrestle, also WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v RASSLED, RASSLING, RASSLES]\n",
  "RASSLED": "RASSLE, (colloquial) to wrestle, also WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "RASSLER": "a wrestler [n -S]\n",
  "RASSLERS": "RASSLER, a wrestler [n]\n",
  "RASSLES": "RASSLE, (colloquial) to wrestle, also WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "RASSLING": "RASSLE, (colloquial) to wrestle, also WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "RAST": "RACE, to compete in a contest of speed [v]\n",
  "RASTA": "(short for) rastafarian, relating to a member of a West Indian cult [adj]\n",
  "RASTAFARI": "a member of a West Indian cult which rejects western ideas and regards the Emperor Haile Selassie as divine [n -S]\n",
  "RASTAFARIAN": "a member of rastafari, a West Indian cult which rejects western ideas and regards the Emperor Haile Selassie as divine [n -S]\n",
  "RASTAFARIANS": "RASTAFARIAN, a member of rastafari, a West Indian cult which rejects western ideas and regards the Emperor Haile Selassie as divine [n]\n",
  "RASTAFARIS": "RASTAFARI, a member of a West Indian cult which rejects western ideas and regards the Emperor Haile Selassie as divine [n]\n",
  "RASTER": "the area reproducing images on the picture tube of a television set [n -S] / to create a raster image [v -ED, -ING, -S]\n",
  "RASTERED": "RASTER, to create a raster image [v]\n",
  "RASTERING": "RASTER, to create a raster image [v]\n",
  "RASTERISE": "to convert an image into raster form, also RASTERIZE [v RASTERISED, RASTERISING, RASTERISES]\n",
  "RASTERISED": "RASTERISE, to convert an image into raster form, also RASTERIZE [v]\n",
  "RASTERISES": "RASTERISE, to convert an image into raster form, also RASTERIZE [v]\n",
  "RASTERISING": "RASTERISE, to convert an image into raster form, also RASTERIZE [v]\n",
  "RASTERIZE": "to convert an image into raster form, also RASTERISE [v RASTERIZED, RASTERIZING, RASTERIZES]\n",
  "RASTERIZED": "RASTERIZE, to convert an image into raster form, also RASTERISE [v]\n",
  "RASTERIZES": "RASTERIZE, to convert an image into raster form, also RASTERISE [v]\n",
  "RASTERIZING": "RASTERIZE, to convert an image into raster form, also RASTERISE [v]\n",
  "RASTERS": "RASTER, the area reproducing images on the picture tube of a television set [n]\n",
  "RASTRUM": "(Latin) a music-pen [n -S]\n",
  "RASTRUMS": "RASTRUM, (Latin) a music-pen [n]\n",
  "RASURE": "the act of scraping, also RAZURE [n -S]\n",
  "RASURES": "RASURE, the act of scraping, also RAZURE [n]\n",
  "RAT": "to hunt long-tailed rodents [v RATTED, RATTING, RATS]\n",
  "RATA": "(Maori) a myrtaceous New Zealand tree with hard red wood and bearing crimson flowers [n -S]\n",
  "RATABILITIES": "RATABILITY, the ability to be rated, also RATEABILITY [n]\n",
  "RATABILITY": "the ability to be rated, also RATEABILITY [n RATABILITIES]\n",
  "RATABLE": "capable of being rated [adj RATABLY] / property which may be rated, also RATEABLE [n -S]\n",
  "RATABLENESS": "the quality of being ratable, also RATEABLENESS [n -ES]\n",
  "RATABLENESSES": "RATABLENESS, the quality of being ratable, also RATEABLENESS [n]\n",
  "RATABLES": "RATABLE, property which may be rated, also RATEABLE [n]\n",
  "RATABLY": "RATABLE, capable of being rated [adv]\n",
  "RATAFEE": "an almond-flavoured liqueur, also RATAFIA [n -S]\n",
  "RATAFEES": "RATAFEE, an almond-flavoured liqueur, also RATAFIA [n]\n",
  "RATAFIA": "an almond-flavoured liqueur, also RATAFEE [n -S]\n",
  "RATAFIAS": "RATAFIA, an almond-flavoured liqueur, also RATAFEE [n]\n",
  "RATAL": "an amount on which rates are assessed [n -S]\n",
  "RATALS": "RATAL, an amount on which rates are assessed [n]\n",
  "RATAN": "(Malay) a climbing plant with long thin stems, also ROTAN, RATTAN [n -S]\n",
  "RATANIES": "RATANY, (Quechua) a South American shrub with astringent roots, also RHATANY [n]\n",
  "RATANS": "RATAN, (Malay) a climbing plant with long thin stems, also ROTAN, RATTAN [n]\n",
  "RATANY": "(Quechua) a South American shrub with astringent roots, also RHATANY [n RATANIES]\n",
  "RATAPLAN": "to make a rapidly repeating sound, as on a drum [v RATAPLANNED, RATAPLANNING, RATAPLANS]\n",
  "RATAPLANNED": "RATAPLAN, to make a rapidly repeating sound, as on a drum [v]\n",
  "RATAPLANNING": "RATAPLAN, to make a rapidly repeating sound, as on a drum [v]\n",
  "RATAPLANS": "RATAPLAN, to make a rapidly repeating sound, as on a drum [v]\n",
  "RATAS": "RATA, (Maori) a myrtaceous New Zealand tree with hard red wood and bearing crimson flowers [n]\n",
  "RATATAT": "a quick, sharp rapping sound [n -S]\n",
  "RATATATS": "RATATAT, a quick, sharp rapping sound [n]\n",
  "RATATOUILLE": "(French) a vegetable dish of aubergines, courgettes, tomatoes, onions, and peppers fried and stewed in oil [n -S]\n",
  "RATATOUILLES": "RATATOUILLE, (French) a vegetable dish of aubergines, courgettes, tomatoes, onions, and peppers fried and stewed in oil [n]\n",
  "RATBAG": "an eccentric person [n -S]\n",
  "RATBAGGERIES": "RATBAGGERY, nonsense, eccentricity [n]\n",
  "RATBAGGERY": "nonsense, eccentricity [n RATBAGGERIES]\n",
  "RATBAGS": "RATBAG, an eccentric person [n]\n",
  "RATBITE": "as in ratbite fever, a bacterial disease spread by rat bites [adj]\n",
  "RATCH": "to wander, prowl [v -ED, -ING, -ES]\n",
  "RATCHED": "RATCH, to wander, prowl [v]\n",
  "RATCHES": "RATCH, to wander, prowl [v]\n",
  "RATCHET": "a mechanism which allows motion in one direction only [n -S] / to move by a ratchet mechanism, also RACHET [v -ED, -ING, -S]\n",
  "RATCHETED": "RATCHET, to move by a ratchet mechanism, also RACHET [v]\n",
  "RATCHETING": "RATCHET, to move by a ratchet mechanism, also RACHET [v]\n",
  "RATCHETS": "RATCHET, to move by a ratchet mechanism, also RACHET [v]\n",
  "RATCHING": "RATCH, to wander, prowl [v]\n",
  "RATE": "to estimate the value of [v RATED, RATING, RATES]\n",
  "RATEABILITIES": "RATEABILITY, the ability to be rated, also RATABILITY [n]\n",
  "RATEABILITY": "the ability to be rated, also RATABILITY [n RATEABILITIES]\n",
  "RATEABLE": "capable of being rated, also RATABLE [adj]\n",
  "RATEABLENESS": "the state of being rateable [n -ES]\n",
  "RATEABLENESSES": "RATEABLENESS, the state of being rateable [n]\n",
  "RATEABLES": "property that is liable to rates, also RATABLES [n]\n",
  "RATEABLY": "RATEABLE, capable of being rated, also RATABLE [adv]\n",
  "RATED": "RATE, to estimate the value of [v]\n",
  "RATEEN": "a rough dress fabric, also RATINE, RATTEEN [n -S]\n",
  "RATEENS": "RATEEN, a rough dress fabric, also RATINE, RATTEEN [n]\n",
  "RATEL": "(South African) an African badger, aka honey-badger [n -S]\n",
  "RATELS": "RATEL, (South African) an African badger, aka honey-badger [n]\n",
  "RATEMETER": "an instrument for measuring the counting rate of electronic counters [n -S]\n",
  "RATEMETERS": "RATEMETER, an instrument for measuring the counting rate of electronic counters [n]\n",
  "RATEPAYER": "one who pays rates or taxes [n -S]\n",
  "RATEPAYERS": "RATEPAYER, one who pays rates or taxes [n]\n",
  "RATER": "one that rates [n -S]\n",
  "RATERS": "RATER, one that rates [n]\n",
  "RATES": "RATE, to estimate the value of [v]\n",
  "RATFINK": "a contemptible person [n -S]\n",
  "RATFINKS": "RATFINK, a contemptible person [n]\n",
  "RATFISH": "a marine fish [n -ES]\n",
  "RATFISHES": "RATFISH, a marine fish [n]\n",
  "RATH": "an ancient hill fort [n -S] / quick, ready, also RATHE [adj RATHER, RATHEST]\n",
  "RATHA": "(Hindi) a four-wheeled carriage drawn by horses or bullocks [n -S]\n",
  "RATHAS": "RATHA, (Hindi) a four-wheeled carriage drawn by horses or bullocks [n]\n",
  "RATHE": "(archaic) quick, early, also RATH [adj RATHER, RATHEST]\n",
  "RATHER": "preferably, also RUTHER [adv RATHEREST]\n",
  "RATHEREST": "RATHER, preferably, also RUTHER [adv]\n",
  "RATHERIPE": "a fruit that ripens early, also RARERIPE, RATHRIPE [n -S]\n",
  "RATHERIPES": "RATHERIPE, a fruit that ripens early, also RARERIPE, RATHRIPE [n]\n",
  "RATHERISH": "(colloquial) rather [adj]\n",
  "RATHEST": "RATHE, (archaic) quick, early, also RATH [adj]\n",
  "RATHOLE": "a hole made by a rat [n -S]\n",
  "RATHOLES": "RATHOLE, a hole made by a rat [n]\n",
  "RATHOUSE": "(Australian slang) a mental asylum [n -S]\n",
  "RATHOUSES": "RATHOUSE, (Australian slang) a mental asylum [n]\n",
  "RATHRIPE": "a fruit that ripens early, also RARERIPE, RATHERIPE [n -S]\n",
  "RATHRIPES": "RATHRIPE, a fruit that ripens early, also RARERIPE, RATHERIPE [n]\n",
  "RATHS": "RATH, an ancient hill fort [n]\n",
  "RATHSKELLER": "(German) a usually basement tavern or restaurant [n -S]\n",
  "RATHSKELLERS": "RATHSKELLER, (German) a usually basement tavern or restaurant [n]\n",
  "RATICIDE": "a substance for killing rats [n -S]\n",
  "RATICIDES": "RATICIDE, a substance for killing rats [n]\n",
  "RATIFIABLE": "that can be ratified [adj]\n",
  "RATIFICATION": "the act of ratifying [n -S]\n",
  "RATIFICATIONS": "RATIFICATION, the act of ratifying [n]\n",
  "RATIFIED": "RATIFY, to approve and sanction formally [v]\n",
  "RATIFIER": "one who ratifies [n -S]\n",
  "RATIFIERS": "RATIFIER, one who ratifies [n]\n",
  "RATIFIES": "RATIFY, to approve and sanction formally [v]\n",
  "RATIFY": "to approve and sanction formally [v RATIFIED, RATIFYING, RATIFIES]\n",
  "RATIFYING": "RATIFY, to approve and sanction formally [v]\n",
  "RATINE": "(French) a rough dress fabric, also RATEEN, RATTEEN [n -S]\n",
  "RATINES": "RATINE, (French) a rough dress fabric, also RATEEN, RATTEEN [n]\n",
  "RATING": "an estimate or evaluation [n -S]\n",
  "RATINGS": "RATING, an estimate or evaluation [n]\n",
  "RATIO": "(Latin) a proportional relationship [n -S]\n",
  "RATIOCINATE": "to reason or argue logically [v RATIOCINATED, RATIOCINATING, RATIOCINATES]\n",
  "RATIOCINATED": "RATIOCINATE, to reason or argue logically [v]\n",
  "RATIOCINATES": "RATIOCINATE, to reason or argue logically [v]\n",
  "RATIOCINATING": "RATIOCINATE, to reason or argue logically [v]\n",
  "RATIOCINATION": "the process of exact thinking, reasoning [n -S]\n",
  "RATIOCINATIONS": "RATIOCINATION, the process of exact thinking, reasoning [n]\n",
  "RATIOCINATIVE": "relating to ratiocination, the process of exact thinking [adj]\n",
  "RATIOCINATOR": "one who ratiocinates, reasons or argues logically [n -S]\n",
  "RATIOCINATORS": "RATIOCINATOR, one who ratiocinates, reasons or argues logically [n]\n",
  "RATIOCINATORY": "relating to ratiocination, the process of exact thinking [adj]\n",
  "RATION": "to distribute in fixed amounts [v -ED, -ING, -S]\n",
  "RATIONAL": "conforming to reason [adj RATIONALLY] / a number that can be expressed as a quotient of integers [n -S]\n",
  "RATIONALE": "a reasoned exposition of principles [n -S]\n",
  "RATIONALES": "RATIONALE, a reasoned exposition of principles [n]\n",
  "RATIONALISABLE": "capable of being rationalised, also RATIONALIZABLE [adj]\n",
  "RATIONALISATION": "the act of rationalising, also RATIONALIZATION [n]\n",
  "RATIONALISE": "to make rational, also RATIONALIZE [v RATIONALISED, RATIONALISING, RATIONALISES]\n",
  "RATIONALISED": "RATIONALISE, to make rational, also RATIONALIZE [v]\n",
  "RATIONALISER": "one who rationalises, also RATIONALIZER [n -S]\n",
  "RATIONALISERS": "RATIONALISER, one who rationalises, also RATIONALIZER [n]\n",
  "RATIONALISES": "RATIONALISE, to make rational, also RATIONALIZE [v]\n",
  "RATIONALISING": "RATIONALISE, to make rational, also RATIONALIZE [v]\n",
  "RATIONALISM": "reliance on reason as the basis for establishment of religious truth [n -S]\n",
  "RATIONALISMS": "RATIONALISM, reliance on reason as the basis for establishment of religious truth [n]\n",
  "RATIONALIST": "an adherent of rationalism [n -S]\n",
  "RATIONALISTIC": "relating to rationalism [adj]\n",
  "RATIONALISTS": "RATIONALIST, an adherent of rationalism [n]\n",
  "RATIONALITIES": "RATIONALITY, the state of being rational [n]\n",
  "RATIONALITY": "the state of being rational [n RATIONALITIES]\n",
  "RATIONALIZABLE": "capable of being rationalized, also RATIONALISABLE [adj]\n",
  "RATIONALIZATION": "the act of rationalizing, also RATIONALISATION [n]\n",
  "RATIONALIZE": "to bring into accord with reason, also RATIONALISE [v RATIONALIZED, RATIONALIZING, RATIONALIZES]\n",
  "RATIONALIZED": "RATIONALIZE, to bring into accord with reason, also RATIONALISE [v]\n",
  "RATIONALIZER": "one who rationalizes, also RATIONALISER [n -S]\n",
  "RATIONALIZERS": "RATIONALIZER, one who rationalizes, also RATIONALISER [n]\n",
  "RATIONALIZES": "RATIONALIZE, to bring into accord with reason, also RATIONALISE [v]\n",
  "RATIONALIZING": "RATIONALIZE, to bring into accord with reason, also RATIONALISE [v]\n",
  "RATIONALLY": "RATIONAL, conforming to reason [adv]\n",
  "RATIONALNESS": "the state of being rational [n -ES]\n",
  "RATIONALNESSES": "RATIONALNESS, the state of being rational [n]\n",
  "RATIONALS": "RATIONAL, a number that can be expressed as a quotient of integers [n]\n",
  "RATIONED": "RATION, to distribute in fixed amounts [v]\n",
  "RATIONING": "distribution in fixed portions [n -S]\n",
  "RATIONINGS": "RATIONING, distribution in fixed portions [n]\n",
  "RATIONS": "RATION, to distribute in fixed amounts [v]\n",
  "RATIOS": "RATIO, (Latin) a proportional relationship [n]\n",
  "RATITE": "a bird having a flat breastbone, such as ostrich, emu [n -S]\n",
  "RATITES": "RATITE, a bird having a flat breastbone, such as ostrich, emu [n]\n",
  "RATLIKE": "like a rat [adj]\n",
  "RATLIN": "any of the small lines forming the steps of the rigging of ships, also RATLINE, RATLING, RATTLIN, RATTLINE, RATTLING [n -S]\n",
  "RATLINE": "any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLING, RATTLIN, RATTLINE, RATTLING [n -S]\n",
  "RATLINES": "RATLINE, any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLING, RATTLIN, RATTLINE, RATTLING [n]\n",
  "RATLING": "any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATTLIN, RATTLINE, RATTLING [n -S]\n",
  "RATLINGS": "RATLING, any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATTLIN, RATTLINE, RATTLING [n]\n",
  "RATLINS": "RATLIN, any of the small lines forming the steps of the rigging of ships, also RATLINE, RATLING, RATTLIN, RATTLINE, RATTLING [n]\n",
  "RATO": "a rocket-assisted aeroplane takeoff [n -S]\n",
  "RATOO": "a local chief in Fiji, also RATU [n -S]\n",
  "RATOON": "to sprout from a root planted the previous year, also RATTOON [v -ED, -ING, -S]\n",
  "RATOONED": "RATOON, to sprout from a root planted the previous year, also RATTOON [v]\n",
  "RATOONER": "a plant that ratoons [n -S]\n",
  "RATOONERS": "RATOONER, a plant that ratoons [n]\n",
  "RATOONING": "RATOON, to sprout from a root planted the previous year, also RATTOON [v]\n",
  "RATOONS": "RATOON, to sprout from a root planted the previous year, also RATTOON [v]\n",
  "RATOOS": "RATOO, a local chief in Fiji, also RATU [n]\n",
  "RATOS": "RATO, a rocket-assisted aeroplane takeoff [n]\n",
  "RATPACK": "a show-business clique [n -S]\n",
  "RATPACKS": "RATPACK, a show-business clique [n]\n",
  "RATPROOF": "impervious to rats [adj]\n",
  "RATS": "RAT, to hunt long-tailed rodents [v]\n",
  "RATSBANE": "rat poison; white arsenic [n -S]\n",
  "RATSBANES": "RATSBANE, rat poison; white arsenic [n]\n",
  "RATTAIL": "any of various deepwater marine long-tailed fishes [n -S]\n",
  "RATTAILED": "having tails like rats [adj]\n",
  "RATTAILS": "RATTAIL, any of various deepwater marine long-tailed fishes [n]\n",
  "RATTAN": "(Malay) a climbing plant with long thin stems, also ROTAN, RATAN [n -S]\n",
  "RATTANS": "RATTAN, (Malay) a climbing plant with long thin stems, also ROTAN, RATAN [n]\n",
  "RATTED": "RAT, to hunt long-tailed rodents [v]\n",
  "RATTEEN": "a rough dress fabric, also RATEEN, RATINE [n -S]\n",
  "RATTEENS": "RATTEEN, a rough dress fabric, also RATEEN, RATINE [n]\n",
  "RATTEN": "to compel obedience to a trade union by damaging or depriving of machinery, tools, etc. [v -ED, -ING, -S]\n",
  "RATTENED": "RATTEN, to compel obedience to a trade union by damaging or depriving of machinery, tools, etc. [v]\n",
  "RATTENER": "one who rattens, compels obedience to a trade union by damaging or depriving of machinery, tools, etc. [n -S]\n",
  "RATTENERS": "RATTENER, one who rattens, compels obedience to a trade union by damaging or depriving of machinery, tools, etc. [n]\n",
  "RATTENING": "the act of compelling obedience to a trade union by damaging or depriving of machinery, tools, etc. [n -S]\n",
  "RATTENINGS": "RATTENING, the act of compelling obedience to a trade union by damaging or depriving of machinery, tools, etc. [n]\n",
  "RATTENS": "RATTEN, to compel obedience to a trade union by damaging or depriving of machinery, tools, etc. [v]\n",
  "RATTER": "an animal used for catching rats [n -S]\n",
  "RATTERIES": "RATTERY, a place where rats are abundant [n]\n",
  "RATTERS": "RATTER, an animal used for catching rats [n]\n",
  "RATTERY": "a place where rats are abundant [n RATTERIES]\n",
  "RATTIER": "RATTY, infested with rats [adj]\n",
  "RATTIEST": "RATTY, infested with rats [adj]\n",
  "RATTILY": "RATTY, infested with rats [adv]\n",
  "RATTINESS": "the state of being ratty [n -ES]\n",
  "RATTINESSES": "RATTINESS, the state of being ratty [n]\n",
  "RATTING": "rat-hunting [n -S]\n",
  "RATTINGS": "RATTING, rat-hunting [n]\n",
  "RATTISH": "like a rat [adj]\n",
  "RATTLE": "to make a quick succession of short, sharp sounds [v RATTLED, RATTLING, RATTLES]\n",
  "RATTLEBAG": "a rattle or rattling apparatus; a person who causes a commotion [n -S]\n",
  "RATTLEBAGS": "RATTLEBAG, a rattle or rattling apparatus; a person who causes a commotion [n]\n",
  "RATTLEBOX": "any of various tropical and subtropical plants with inflated seedpods within which the seeds rattle [n -ES]\n",
  "RATTLEBOXES": "RATTLEBOX, any of various tropical and subtropical plants with inflated seedpods within which the seeds rattle [n]\n",
  "RATTLEBRAIN": "a shallow, voluble, volatile person [n -S]\n",
  "RATTLEBRAINED": "like a rattlebrain, a shallow, voluble, volatile person [adj]\n",
  "RATTLEBRAINS": "RATTLEBRAIN, a shallow, voluble, volatile person [n]\n",
  "RATTLED": "RATTLE, to make a quick succession of short, sharp sounds [v]\n",
  "RATTLEPODS": "a genus of plants and shrubs with pods in which the seeds rattle, aka crotalaria [n]\n",
  "RATTLER": "a rattlesnake [n -S]\n",
  "RATTLERS": "RATTLER, a rattlesnake [n]\n",
  "RATTLES": "RATTLE, to make a quick succession of short, sharp sounds [v]\n",
  "RATTLESNAKE": "any of several American pit vipers that have horny interlocking joints at the end of the tail which make a sharp rattling sound when shaken [n -S]\n",
  "RATTLESNAKES": "RATTLESNAKE, any of several American pit vipers that have horny interlocking joints at the end of the tail which make a sharp rattling sound when shaken [n]\n",
  "RATTLETRAP": "any machine or vehicle that does not run smoothly [n -S]\n",
  "RATTLETRAPS": "RATTLETRAP, any machine or vehicle that does not run smoothly [n]\n",
  "RATTLIER": "RATTLY, inclined to rattle [adj]\n",
  "RATTLIEST": "RATTLY, inclined to rattle [adj]\n",
  "RATTLIN": "any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATLING, RATTLINE, RATTLING [n -S]\n",
  "RATTLINE": "any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATLING, RATTLIN, RATTLING [n -S]\n",
  "RATTLINES": "RATTLINE, any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATLING, RATTLIN, RATTLING [n]\n",
  "RATTLING": "any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATLING, RATTLIN, RATTLINE [n -S]\n",
  "RATTLINGLY": "RATTLING [adv]\n",
  "RATTLINGS": "RATTLING, any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATLING, RATTLIN, RATTLINE [n]\n",
  "RATTLINS": "RATTLIN, any of the small lines forming the steps of the rigging of ships, also RATLIN, RATLINE, RATLING, RATTLINE, RATTLING [n]\n",
  "RATTLY": "inclined to rattle [adj RATTLIER, RATTLIEST]\n",
  "RATTON": "(dialect) a rat, also ROTTAN, ROTTEN [n -S]\n",
  "RATTONS": "RATTON, (dialect) a rat, also ROTTAN, ROTTEN [n]\n",
  "RATTOON": "to sprout from a root planted the previous year, also RATOON [v -ED, -ING, -S]\n",
  "RATTOONED": "RATTOON, to sprout from a root planted the previous year, also RATOON [v]\n",
  "RATTOONING": "RATTOON, to sprout from a root planted the previous year, also RATOON [v]\n",
  "RATTOONS": "RATTOON, to sprout from a root planted the previous year, also RATOON [v]\n",
  "RATTRAP": "a trap for catching rats [n -S]\n",
  "RATTRAPS": "RATTRAP, a trap for catching rats [n]\n",
  "RATTY": "infested with rats [adj RATTIER, RATTIEST, RATTILY]\n",
  "RATU": "a local chief in Fiji, also RATOO [n -S]\n",
  "RATUS": "RATU, a local chief in Fiji, also RATOO [n]\n",
  "RAUCID": "loud and unruly, also RAUCOUS [adj]\n",
  "RAUCITIES": "RAUCITY, harshness of sound; rough utterance [n]\n",
  "RAUCITY": "harshness of sound; rough utterance [n RAUCITIES]\n",
  "RAUCLE": "(Scots) rough, vigorous [adj RAUCLER, RAUCLEST]\n",
  "RAUCLER": "RAUCLE, (Scots) rough, vigorous [adj]\n",
  "RAUCLEST": "RAUCLE, (Scots) rough, vigorous [adj]\n",
  "RAUCOUS": "loud and unruly [adj RAUCOUSLY]\n",
  "RAUCOUSLY": "RAUCOUS, loud and unruly [adv]\n",
  "RAUCOUSNESS": "the state of being raucous [n -ES]\n",
  "RAUCOUSNESSES": "RAUCOUSNESS, the state of being raucous [n]\n",
  "RAUGHT": "REACH, to stretch out or put forth [v]\n",
  "RAUN": "(Scott) fish-roe, also RAWN [n -S]\n",
  "RAUNCH": "(Spenser) to race [v -ED, -ING, -ES]\n",
  "RAUNCHED": "RAUNCH, (Spenser) to race [v]\n",
  "RAUNCHES": "RAUNCH, (Spenser) to race [v]\n",
  "RAUNCHIER": "RAUNCHY, coarsely or openly sexual [adj]\n",
  "RAUNCHIEST": "RAUNCHY, coarsely or openly sexual [adj]\n",
  "RAUNCHILY": "RAUNCHY, coarsely or openly sexual [adv]\n",
  "RAUNCHINESS": "the state of being raunchy [n -ES]\n",
  "RAUNCHINESSES": "RAUNCHINESS, the state of being raunchy [n]\n",
  "RAUNCHING": "RAUNCH, (Spenser) to race [v]\n",
  "RAUNCHY": "coarsely or openly sexual [adj RAUNCHIER, RAUNCHIEST, RAUNCHILY]\n",
  "RAUNGE": "(obsolete) to range [v RAUNGED, RAUNGING, RAUNGES]\n",
  "RAUNGED": "RAUNGE, (obsolete) to range [v]\n",
  "RAUNGES": "RAUNGE, (obsolete) to range [v]\n",
  "RAUNGING": "RAUNGE, (obsolete) to range [v]\n",
  "RAUNS": "RAUN, (Scott) fish-roe, also RAWN [n]\n",
  "RAUPATU": "(Maori) confiscation of land [n -S]\n",
  "RAUPATUS": "RAUPATU, (Maori) confiscation of land [n]\n",
  "RAUPO": "(Maori) the New Zealand bulrush [n -S]\n",
  "RAUPOS": "RAUPO, (Maori) the New Zealand bulrush [n]\n",
  "RAURIKI": "(Maori) sow-thistle [n -S]\n",
  "RAURIKIS": "RAURIKI, (Maori) sow-thistle [n]\n",
  "RAUWOLFIA": "a tropical tree or shrub used as source of various drugs, esp. the sedative reserpine [n -S]\n",
  "RAUWOLFIAS": "RAUWOLFIA, a tropical tree or shrub used as source of various drugs, esp. the sedative reserpine [n]\n",
  "RAV": "(Hebrew) a rabbi, esp. one in authority; a teacher or mentor [n -S]\n",
  "RAVAGE": "to destroy [v RAVAGED, RAVAGING, RAVAGES]\n",
  "RAVAGED": "RAVAGE, to destroy [v]\n",
  "RAVAGEMENT": "laying waste [n -S]\n",
  "RAVAGEMENTS": "RAVAGEMENT, laying waste [n]\n",
  "RAVAGER": "one who ravages [n -S]\n",
  "RAVAGERS": "RAVAGER, one who ravages [n]\n",
  "RAVAGES": "RAVAGE, to destroy [v]\n",
  "RAVAGING": "RAVAGE, to destroy [v]\n",
  "RAVE": "to utter wildly or incoherently [v RAVED, RAVING, RAVES]\n",
  "RAVED": "RAVE, to utter wildly or incoherently [v]\n",
  "RAVEL": "to entangle [v RAVELED or RAVELLED, RAVELING or RAVELLING, RAVELS]\n",
  "RAVELED": "RAVEL, to entangle [v]\n",
  "RAVELER": "one who ravels, also RAVELLER [n -S]\n",
  "RAVELERS": "RAVELER, one who ravels, also RAVELLER [n]\n",
  "RAVELIN": "a type of fortification [n -S]\n",
  "RAVELING": "a ravelled out thread, also RAVELLING [n -S]\n",
  "RAVELINGS": "RAVELING, a ravelled out thread, also RAVELLING [n]\n",
  "RAVELINS": "RAVELIN, a type of fortification [n]\n",
  "RAVELLED": "RAVEL, to entangle [v]\n",
  "RAVELLER": "one who ravels, also RAVELER [n -S]\n",
  "RAVELLERS": "RAVELLER, one who ravels, also RAVELER [n]\n",
  "RAVELLIER": "RAVELLY, tangled [adj]\n",
  "RAVELLIEST": "RAVELLY, tangled [adj]\n",
  "RAVELLING": "a ravelled out thread, also RAVELING [n -S]\n",
  "RAVELLINGS": "RAVELLING, a ravelled out thread, also RAVELING [n]\n",
  "RAVELLY": "tangled [adj RAVELLIER, RAVELLIEST]\n",
  "RAVELMENT": "confusion, complexity, tangle [n -S]\n",
  "RAVELMENTS": "RAVELMENT, confusion, complexity, tangle [n]\n",
  "RAVELS": "RAVEL, to entangle [v]\n",
  "RAVEN": "of a black colour [adj RAVENER, RAVENEST] / to prey upon [v -ED, -ING, -S]\n",
  "RAVENED": "RAVEN, to prey upon [v]\n",
  "RAVENER": "one who, or that which, ravens or plunders [n -S]\n",
  "RAVENERS": "RAVENER, one who, or that which, ravens or plunders [n]\n",
  "RAVENEST": "RAVEN, of a black colour [adj]\n",
  "RAVENING": "preying upon [adj RAVENINGLY] / the act of ravening [n -S]\n",
  "RAVENINGLY": "RAVENING, preying upon [adv]\n",
  "RAVENINGS": "RAVENING, the act of ravening [n]\n",
  "RAVENLIKE": "like a raven [adj]\n",
  "RAVENOUS": "extremely hungry [adj RAVENOUSLY]\n",
  "RAVENOUSLY": "RAVENOUS, extremely hungry [adv]\n",
  "RAVENOUSNESS": "the state of being ravenous [n -ES]\n",
  "RAVENOUSNESSES": "RAVENOUSNESS, the state of being ravenous [n]\n",
  "RAVENS": "RAVEN, to prey upon [v]\n",
  "RAVER": "one that raves [n -S]\n",
  "RAVERS": "RAVER, one that raves [n]\n",
  "RAVES": "RAVE, to utter wildly or incoherently [v]\n",
  "RAVEY": "characteristic of a rave [adj RAVIER, RAVIEST]\n",
  "RAVIER": "RAVEY, characteristic of a rave [adj]\n",
  "RAVIEST": "RAVEY, characteristic of a rave [adj]\n",
  "RAVIGOTE": "(French) a spicy vinegar sauce, also RAVIGOTTE [n -S]\n",
  "RAVIGOTES": "RAVIGOTE, (French) a spicy vinegar sauce, also RAVIGOTTE [n]\n",
  "RAVIGOTTE": "(French) vinegar sauce, minced onion, capers, and herbs, also RAVIGOTE [n -S]\n",
  "RAVIGOTTES": "RAVIGOTTE, (French) vinegar sauce, minced onion, capers, and herbs, also RAVIGOTE [n]\n",
  "RAVIN": "to devour greedily, also RAVEN [v -ED, -ING, -S]\n",
  "RAVINE": "a narrow, steep-sided valley [n -S]\n",
  "RAVINED": "RAVIN, to devour greedily, also RAVEN [v]\n",
  "RAVINES": "RAVINE, a narrow, steep-sided valley [n]\n",
  "RAVING": "mad [adj RAVINGLY] / wild talk [n -S]\n",
  "RAVINGLY": "RAVING, mad [adv]\n",
  "RAVINGS": "RAVING, wild talk [n]\n",
  "RAVINING": "RAVIN, to devour greedily, also RAVEN [v]\n",
  "RAVINS": "RAVIN, to devour greedily, also RAVEN [v]\n",
  "RAVIOLI": "(Italian) pasta in the form of small square cases filled with minced meat, vegetables, etc. [n -S]\n",
  "RAVIOLIS": "RAVIOLI, (Italian) pasta in the form of small square cases filled with minced meat, vegetables, etc. [n]\n",
  "RAVISH": "to seize and carry off by force [v RAVISHED, (obsolete) YRAVISHED, RAVISHING, RAVISHES]\n",
  "RAVISHED": "RAVISH, to seize and carry off by force [v]\n",
  "RAVISHER": "one who ravishes [n -S]\n",
  "RAVISHERS": "RAVISHER, one who ravishes [n]\n",
  "RAVISHES": "RAVISH, to seize and carry off by force [v]\n",
  "RAVISHING": "RAVISH, to seize and carry off by force [v]\n",
  "RAVISHINGLY": "RAVISHING, RAVISH, to seize and carry off by force [adv]\n",
  "RAVISHMENT": "the act of ravishing [n -S]\n",
  "RAVISHMENTS": "RAVISHMENT, the act of ravishing [n]\n",
  "RAVS": "RAV, (Hebrew) a rabbi, esp. one in authority; a teacher or mentor [n]\n",
  "RAW": "uncooked [adj RAWER, RAWEST, RAWLY] / a sore or irritated spot [n -S]\n",
  "RAWARU": "(Maori) the blue cod [n -S]\n",
  "RAWARUS": "RAWARU, (Maori) the blue cod [n]\n",
  "RAWBONE": "(Spenser) having little flesh, also RAWBONED [adj]\n",
  "RAWBONED": "having little flesh [adj]\n",
  "RAWER": "RAW, uncooked [adj]\n",
  "RAWEST": "RAW, uncooked [adj]\n",
  "RAWHEAD": "a spectre mentioned to frighten children; as in 'rawhead and bloodybones' [n -S]\n",
  "RAWHEADS": "RAWHEAD, a spectre mentioned to frighten children; as in 'rawhead and bloodybones' [n]\n",
  "RAWHIDE": "to beat with a type of whip [v RAWHIDED, RAWHIDING, RAWHIDES]\n",
  "RAWHIDED": "RAWHIDE, to beat with a type of whip [v]\n",
  "RAWHIDES": "RAWHIDE, to beat with a type of whip [v]\n",
  "RAWHIDING": "RAWHIDE, to beat with a type of whip [v]\n",
  "RAWIN": "a wind measurement made by tracking a balloon with radar [n -S]\n",
  "RAWING": "a second mowing of grass in the same season, an aftermath, also ROWEN [n -S]\n",
  "RAWINGS": "RAWING, a second mowing of grass in the same season, an aftermath, also ROWEN [n]\n",
  "RAWINS": "RAWIN, a wind measurement made by tracking a balloon with radar [n]\n",
  "RAWINSONDE": "an apparatus for taking upper-air wind velocity and direction [n -S]\n",
  "RAWINSONDES": "RAWINSONDE, an apparatus for taking upper-air wind velocity and direction [n]\n",
  "RAWISH": "somewhat raw [adj]\n",
  "RAWLY": "RAW, uncooked [adv]\n",
  "RAWMAISH": "(Irish) foolish exaggerated talk [n -ES]\n",
  "RAWMAISHES": "RAWMAISH, (Irish) foolish exaggerated talk [n]\n",
  "RAWN": "(Scots) fish-roe, also RAUN [n -S]\n",
  "RAWNESS": "the state of being raw [n -ES]\n",
  "RAWNESSES": "RAWNESS, the state of being raw [n]\n",
  "RAWNS": "RAWN, (Scots) fish-roe, also RAUN [n]\n",
  "RAWS": "RAW, a sore or irritated spot [n]\n",
  "RAX": "to stretch out [v -ED, -ING, -ES]\n",
  "RAXED": "RAX, to stretch out [v]\n",
  "RAXES": "RAX, to stretch out [v]\n",
  "RAXING": "RAX, to stretch out [v]\n",
  "RAY": "to emit a narrow beam of light [v -ED, -ING, -S]\n",
  "RAYA": "(Arabic) a non-Muslim subject of Turkey, also RAIA, RAYAH [n -S]\n",
  "RAYAH": "(Arabic) a non-Muslim inhabitant of Turkey, also RAIA, RAYA [n -S]\n",
  "RAYAHS": "RAYAH, (Arabic) a non-Muslim inhabitant of Turkey, also RAIA, RAYA [n]\n",
  "RAYAS": "RAYA, (Arabic) a non-Muslim subject of Turkey, also RAIA, RAYAH [n]\n",
  "RAYED": "RAY, to emit a narrow beam of light [v]\n",
  "RAYGRASS": "a pasture and fodder type of grass, also RYEFLOUR, RYEGRASS [n -ES]\n",
  "RAYGRASSES": "RAYGRASS, a pasture and fodder type of grass, also RYEFLOUR, RYEGRASS [n]\n",
  "RAYING": "RAY, to emit a narrow beam of light [v]\n",
  "RAYLE": "(Spenser) to rail [v RAYLED, RAYLING, RAYLES]\n",
  "RAYLED": "RAYLE, (Spenser) to rail [v]\n",
  "RAYLES": "RAYLE, (Spenser) to rail [v]\n",
  "RAYLESS": "without rays [adj RAYLESSLY]\n",
  "RAYLESSLY": "RAYLESS, without rays [adv]\n",
  "RAYLESSNESS": "the state of being rayless [n -ES]\n",
  "RAYLESSNESSES": "RAYLESSNESS, the state of being rayless [n]\n",
  "RAYLET": "a small ray [n -S]\n",
  "RAYLETS": "RAYLET, a small ray [n]\n",
  "RAYLIKE": "resembling a narrow beam of light [adj]\n",
  "RAYLING": "RAYLE, (Spenser) to rail [v]\n",
  "RAYNE": "(Spenser) a reign, also RAINE [n -S]\n",
  "RAYNES": "RAYNE, (Spenser) a reign, also RAINE [n]\n",
  "RAYON": "a synthetic fibre [n -S]\n",
  "RAYONS": "RAYON, a synthetic fibre [n]\n",
  "RAYS": "RAY, to emit a narrow beam of light [v]\n",
  "RAZE": "to demolish, also RASE [v RAZED, RAZING, RAZES]\n",
  "RAZED": "RAZE, to demolish, also RASE [v]\n",
  "RAZEE": "to cut down by removing the upper deck, as a ship [v RAZEED, RAZEEING, RAZEES]\n",
  "RAZEED": "RAZEE, to cut down by removing the upper deck, as a ship [v]\n",
  "RAZEEING": "RAZEE, to cut down by removing the upper deck, as a ship [v]\n",
  "RAZEES": "RAZEE, to cut down by removing the upper deck, as a ship [v]\n",
  "RAZER": "one who razes, also RASER [n -S]\n",
  "RAZERS": "RAZER, one who razes, also RASER [n]\n",
  "RAZES": "RAZE, to demolish, also RASE [v]\n",
  "RAZING": "RAZE, to demolish, also RASE [v]\n",
  "RAZMATAZ": "a to-do, a hullabaloo, also RAZZAMATAZZ, RAZZMATAZZ [n -ES]\n",
  "RAZMATAZES": "RAZMATAZ, a to-do, a hullabaloo, also RAZZAMATAZZ, RAZZMATAZZ [n]\n",
  "RAZOO": "(Australian slang) an imaginary coin, as in not worth a brass razoo [n -S]\n",
  "RAZOOS": "RAZOO, (Australian slang) an imaginary coin, as in not worth a brass razoo [n]\n",
  "RAZOR": "to shave with a sharp instrument [v -ED, -ING, -S]\n",
  "RAZORABLE": "(Shakespeare) fit to be shaved [adj]\n",
  "RAZORBACK": "the rorqual [n -S]\n",
  "RAZORBACKS": "RAZORBACK, the rorqual [n]\n",
  "RAZORBILL": "a species of auk, with a compressed bill [n -S]\n",
  "RAZORBILLS": "RAZORBILL, a species of auk, with a compressed bill [n]\n",
  "RAZORCLAM": "a lamellibranch mollusc with a shell like an old-fashioned razor handle, also RAZORFISH [n -S]\n",
  "RAZORCLAMS": "RAZORCLAM, a lamellibranch mollusc with a shell like an old-fashioned razor handle, also RAZORFISH [n]\n",
  "RAZORED": "RAZOR, to shave with a sharp instrument [v]\n",
  "RAZORFISH": "a lamellibranch mollusc with a shell like an old-fashioned razor handle, also RAZORCLAM [n -ES]\n",
  "RAZORFISHES": "RAZORFISH, a lamellibranch mollusc with a shell like an old-fashioned razor handle, also RAZORCLAM [n]\n",
  "RAZORING": "RAZOR, to shave with a sharp instrument [v]\n",
  "RAZORS": "RAZOR, to shave with a sharp instrument [v]\n",
  "RAZURE": "the act of scraping, also RASURE [n -S]\n",
  "RAZURES": "RAZURE, the act of scraping, also RASURE [n]\n",
  "RAZZ": "to deride [v -ED, -ING, -ES]\n",
  "RAZZAMATAZZ": "a to-do, hullabaloo, also RAZMATAZ, RAZZMATAZZ [n -ES]\n",
  "RAZZAMATAZZES": "RAZZAMATAZZ, a to-do, hullabaloo, also RAZMATAZ, RAZZMATAZZ [n]\n",
  "RAZZBERRIES": "RAZZBERRY, (US) a raspberry [n]\n",
  "RAZZBERRY": "(US) a raspberry [n RAZZBERRIES]\n",
  "RAZZED": "RAZZ, to deride [v]\n",
  "RAZZES": "RAZZ, to deride [v]\n",
  "RAZZIA": "(Arabic) a plundering and destructive incursion [n -S]\n",
  "RAZZIAS": "RAZZIA, (Arabic) a plundering and destructive incursion [n]\n",
  "RAZZING": "the act of blowing a raspberry [n -S]\n",
  "RAZZINGS": "RAZZING, the act of blowing a raspberry [n]\n",
  "RAZZLE": "a rowdy drinking spree [n -S]\n",
  "RAZZLES": "RAZZLE, a rowdy drinking spree [n]\n",
  "RAZZMATAZZ": "a to-do, a hullabaloo, also RAZMATAZ, RAZZAMATAZZ [n -ES]\n",
  "RAZZMATAZZES": "RAZZMATAZZ, a to-do, a hullabaloo, also RAZMATAZ, RAZZAMATAZZ [n]\n",
  "RE": "in tonic sol-fa, the second note of the scale [n -S]\n",
  "REABSORB": "to absorb again [v -ED, -ING, -S]\n",
  "REABSORBED": "REABSORB, to absorb again [v]\n",
  "REABSORBING": "REABSORB, to absorb again [v]\n",
  "REABSORBS": "REABSORB, to absorb again [v]\n",
  "REABSORPTION": "the act of reabsorbing [n -S]\n",
  "REABSORPTIONS": "REABSORPTION, the act of reabsorbing [n]\n",
  "REACCEDE": "to accede again [v REACCEDED, REACCEDING, REACCEDES]\n",
  "REACCEDED": "REACCEDE, to accede again [v]\n",
  "REACCEDES": "REACCEDE, to accede again [v]\n",
  "REACCEDING": "REACCEDE, to accede again [v]\n",
  "REACCELERATE": "to accelerate again [v REACCELERATED, REACCELERATING, REACCELERATES]\n",
  "REACCELERATED": "REACCELERATE, to accelerate again [v]\n",
  "REACCELERATES": "REACCELERATE, to accelerate again [v]\n",
  "REACCELERATING": "REACCELERATE, to accelerate again [v]\n",
  "REACCENT": "to accent again [v -ED, -ING, -S]\n",
  "REACCENTED": "REACCENT, to accent again [v]\n",
  "REACCENTING": "REACCENT, to accent again [v]\n",
  "REACCENTS": "REACCENT, to accent again [v]\n",
  "REACCEPT": "to accept again [v -ED, -ING, -S]\n",
  "REACCEPTED": "REACCEPT, to accept again [v]\n",
  "REACCEPTING": "REACCEPT, to accept again [v]\n",
  "REACCEPTS": "REACCEPT, to accept again [v]\n",
  "REACCESSION": "a new accession [n -S]\n",
  "REACCESSIONS": "REACCESSION, a new accession [n]\n",
  "REACCLAIM": "to acclaim again [v -ED, -ING, -S]\n",
  "REACCLAIMED": "REACCLAIM, to acclaim again [v]\n",
  "REACCLAIMING": "REACCLAIM, to acclaim again [v]\n",
  "REACCLAIMS": "REACCLAIM, to acclaim again [v]\n",
  "REACCLIMATISE": "to acclimatise again, also REACCLIMATIZE [v REACCLIMATISED, REACCLIMATISING, REACCLIMATISES]\n",
  "REACCLIMATISED": "REACCLIMATISE, to acclimatise again, also REACCLIMATIZE [v]\n",
  "REACCLIMATISES": "REACCLIMATISE, to acclimatise again, also REACCLIMATIZE [v]\n",
  "REACCLIMATISING": "REACCLIMATISE, to acclimatise again, also REACCLIMATIZE [v]\n",
  "REACCLIMATIZE": "to acclimatize again, also REACCLIMATISE [v REACCLIMATIZED, REACCLIMATIZING, REACCLIMATIZES]\n",
  "REACCLIMATIZED": "REACCLIMATIZE, to acclimatize again, also REACCLIMATISE [v]\n",
  "REACCLIMATIZES": "REACCLIMATIZE, to acclimatize again, also REACCLIMATISE [v]\n",
  "REACCLIMATIZING": "REACCLIMATIZE, to acclimatize again, also REACCLIMATISE [v]\n",
  "REACCREDIT": "to accredit again [v -ED, -ING, -S]\n",
  "REACCREDITATION": "the act of reaccrediting [n]\n",
  "REACCREDITED": "REACCREDIT, to accredit again [v]\n",
  "REACCREDITING": "REACCREDIT, to accredit again [v]\n",
  "REACCREDITS": "REACCREDIT, to accredit again [v]\n",
  "REACCUSE": "to accuse again [v REACCUSED, REACCUSING, REACCUSES]\n",
  "REACCUSED": "REACCUSE, to accuse again [v]\n",
  "REACCUSES": "REACCUSE, to accuse again [v]\n",
  "REACCUSING": "REACCUSE, to accuse again [v]\n",
  "REACCUSTOM": "to get used to again [v -ED, -ING, -S]\n",
  "REACCUSTOMED": "REACCUSTOM, to get used to again [v]\n",
  "REACCUSTOMING": "REACCUSTOM, to get used to again [v]\n",
  "REACCUSTOMS": "REACCUSTOM, to get used to again [v]\n",
  "REACH": "to stretch out or put forth [v REACHED or (obsolete) RAUGHT or ROUGHT, REACHING, REACHES]\n",
  "REACHABLE": "being within reach [adj]\n",
  "REACHED": "REACH, to stretch out or put forth [v]\n",
  "REACHER": "one who reaches [n -S]\n",
  "REACHERS": "REACHER, one who reaches [n]\n",
  "REACHES": "REACH, to stretch out or put forth [v]\n",
  "REACHING": "REACH, to stretch out or put forth [v]\n",
  "REACHLESS": "being beyond reach; lofty [adj]\n",
  "REACQUAINT": "to acquaint again [v -ED, -ING, -S]\n",
  "REACQUAINTANCE": "a new acquaintance [n -S]\n",
  "REACQUAINTANCES": "REACQUAINTANCE, a new acquaintance [n]\n",
  "REACQUAINTED": "REACQUAINT, to acquaint again [v]\n",
  "REACQUAINTING": "REACQUAINT, to acquaint again [v]\n",
  "REACQUAINTS": "REACQUAINT, to acquaint again [v]\n",
  "REACQUIRE": "to acquire again [v REACQUIRED, REACQUIRING, REACQUIRES]\n",
  "REACQUIRED": "REACQUIRE, to acquire again [v]\n",
  "REACQUIRES": "REACQUIRE, to acquire again [v]\n",
  "REACQUIRING": "REACQUIRE, to acquire again [v]\n",
  "REACQUISITION": "the act of reacquiring [n -S]\n",
  "REACQUISITIONS": "REACQUISITION, the act of reacquiring [n]\n",
  "REACT": "to respond to a stimulus [v -ED, -ING, -S]\n",
  "REACTANCE": "the component of impedance due to inductance or capacitance [n -S]\n",
  "REACTANCES": "REACTANCE, the component of impedance due to inductance or capacitance [n]\n",
  "REACTANT": "a substance taking part in a reaction [n -S]\n",
  "REACTANTS": "REACTANT, a substance taking part in a reaction [n]\n",
  "REACTED": "REACT, to respond to a stimulus [v]\n",
  "REACTING": "REACT, to respond to a stimulus [v]\n",
  "REACTION": "the act of reacting [n -S]\n",
  "REACTIONAL": "relating to reaction [adj]\n",
  "REACTIONARIES": "REACTIONARY, a person who tends to oppose political change or who attempts to revert to past political conditions [n]\n",
  "REACTIONARISM": "the state of being reactionary, also REACTIONARYISM [n -S]\n",
  "REACTIONARISMS": "REACTIONARISM, the state of being reactionary, also REACTIONARYISM [n]\n",
  "REACTIONARIST": "a reactionary [n -S]\n",
  "REACTIONARISTS": "REACTIONARIST, a reactionary [n]\n",
  "REACTIONARY": "resisting change [adj] / a person who tends to oppose political change or who attempts to revert to past political conditions [n REACTIONARIES]\n",
  "REACTIONARYISM": "the state of being reactionary, also REACTIONARISM [n -S]\n",
  "REACTIONARYISMS": "REACTIONARYISM, the state of being reactionary, also REACTIONARISM [n]\n",
  "REACTIONISM": "the state of being a reactionist [n -S]\n",
  "REACTIONISMS": "REACTIONISM, the state of being a reactionist [n]\n",
  "REACTIONIST": "a reactionary [n -S]\n",
  "REACTIONISTS": "REACTIONIST, a reactionary [n]\n",
  "REACTIONS": "REACTION, the act of reacting [n]\n",
  "REACTIVATE": "to activate again [v REACTIVATED, REACTIVATING, REACTIVATES]\n",
  "REACTIVATED": "REACTIVATE, to activate again [v]\n",
  "REACTIVATES": "REACTIVATE, to activate again [v]\n",
  "REACTIVATING": "REACTIVATE, to activate again [v]\n",
  "REACTIVATION": "the act of reactivating [n -S]\n",
  "REACTIVATIONS": "REACTIVATION, the act of reactivating [n]\n",
  "REACTIVE": "tending to react [adj REACTIVELY]\n",
  "REACTIVELY": "REACTIVE, tending to react [adv]\n",
  "REACTIVENESS": "the state of being reactive [n -ES]\n",
  "REACTIVENESSES": "REACTIVENESS, the state of being reactive [n]\n",
  "REACTIVITIES": "REACTIVITY, the state of being reactive [n]\n",
  "REACTIVITY": "the state of being reactive [n REACTIVITIES]\n",
  "REACTOR": "one that reacts [n -S]\n",
  "REACTORS": "REACTOR, one that reacts [n]\n",
  "REACTS": "REACT, to respond to a stimulus [v]\n",
  "REACTUATE": "to actuate again [v REACTUATED, REACTUATING, REACTUATES]\n",
  "REACTUATED": "REACTUATE, to actuate again [v]\n",
  "REACTUATES": "REACTUATE, to actuate again [v]\n",
  "REACTUATING": "REACTUATE, to actuate again [v]\n",
  "READ": "to look at and understand written matter [v READ, READING, READS]\n",
  "READABILITIES": "READABILITY, the ability to be read [n]\n",
  "READABILITY": "the ability to be read [n READABILITIES]\n",
  "READABLE": "able to be read [adj READABLY]\n",
  "READABLENESS": "the state of being readable [n -ES]\n",
  "READABLENESSES": "READABLENESS, the state of being readable [n]\n",
  "READABLY": "READABLE, able to be read [adv]\n",
  "READAPT": "to adapt again [v -ED, -ING, -S]\n",
  "READAPTATION": "the act of readapting [n -S]\n",
  "READAPTATIONS": "READAPTATION, the act of readapting [n]\n",
  "READAPTED": "READAPT, to adapt again [v]\n",
  "READAPTING": "READAPT, to adapt again [v]\n",
  "READAPTS": "READAPT, to adapt again [v]\n",
  "READD": "to add again [v -ED, -ING, -S]\n",
  "READDED": "READD, to add again [v]\n",
  "READDICT": "to become addicted again [v -ED, -ING, -S]\n",
  "READDICTED": "READDICT, to become addicted again [v]\n",
  "READDICTING": "READDICT, to become addicted again [v]\n",
  "READDICTS": "READDICT, to become addicted again [v]\n",
  "READDING": "READD, to add again [v]\n",
  "READDRESS": "to address again, esp. reflexively [v -ED, -ING, -ES]\n",
  "READDRESSED": "READDRESS, to address again, esp. reflexively [v]\n",
  "READDRESSES": "READDRESS, to address again, esp. reflexively [v]\n",
  "READDRESSING": "READDRESS, to address again, esp. reflexively [v]\n",
  "READDS": "READD, to add again [v]\n",
  "READER": "one that reads [n -S]\n",
  "READERLIER": "READERLY, typical of a reader [adj]\n",
  "READERLIEST": "READERLY, typical of a reader [adj]\n",
  "READERLY": "typical of a reader [adj READERLIER, READERLIEST]\n",
  "READERS": "READER, one that reads [n]\n",
  "READERSHIP": "the office or position of a reader [n -S]\n",
  "READERSHIPS": "READERSHIP, the office or position of a reader [n]\n",
  "READIED": "READY, to make ready [v]\n",
  "READIER": "READY, prepared [adj]\n",
  "READIES": "READY, to make ready [v]\n",
  "READIEST": "READY, prepared [adj]\n",
  "READILY": "READY, prepared [adv]\n",
  "READINESS": "the state of being ready [n -ES]\n",
  "READINESSES": "READINESS, the state of being ready [n]\n",
  "READING": "material that is read [n -S]\n",
  "READINGS": "READING, material that is read [n]\n",
  "READJUST": "to adjust again [v -ED, -ING, -S]\n",
  "READJUSTABLE": "that can be readjusted [adj]\n",
  "READJUSTED": "READJUST, to adjust again [v]\n",
  "READJUSTER": "one who readjusts [n -S]\n",
  "READJUSTERS": "READJUSTER, one who readjusts [n]\n",
  "READJUSTING": "READJUST, to adjust again [v]\n",
  "READJUSTMENT": "the act of readjusting [n -S]\n",
  "READJUSTMENTS": "READJUSTMENT, the act of readjusting [n]\n",
  "READJUSTS": "READJUST, to adjust again [v]\n",
  "README": "a text file supplied with computer software that contains information about the software, such as advice on installation and bugs [n -S]\n",
  "READMES": "README, a text file supplied with computer software that contains information about the software, such as advice on installation and bugs [n]\n",
  "READMISSION": "the act of readmitting [n -S]\n",
  "READMISSIONS": "READMISSION, the act of readmitting [n]\n",
  "READMIT": "to admit again [v READMITTED, READMITTING, READMITS]\n",
  "READMITS": "READMIT, to admit again [v]\n",
  "READMITTANCE": "the act of readmitting [n -S]\n",
  "READMITTANCES": "READMITTANCE, the act of readmitting [n]\n",
  "READMITTED": "READMIT, to admit again [v]\n",
  "READMITTING": "READMIT, to admit again [v]\n",
  "READOPT": "to adopt again [v -ED, -ING, -S]\n",
  "READOPTED": "READOPT, to adopt again [v]\n",
  "READOPTING": "READOPT, to adopt again [v]\n",
  "READOPTION": "the act of adopting again [n -S]\n",
  "READOPTIONS": "READOPTION, the act of adopting again [n]\n",
  "READOPTS": "READOPT, to adopt again [v]\n",
  "READORN": "to adorn again [v -ED, -ING, -S]\n",
  "READORNED": "READORN, to adorn again [v]\n",
  "READORNING": "READORN, to adorn again [v]\n",
  "READORNS": "READORN, to adorn again [v]\n",
  "READOUT": "a presentation of computer data [n -S]\n",
  "READOUTS": "READOUT, a presentation of computer data [n]\n",
  "READS": "READ, to look at and understand written matter [v]\n",
  "READVANCE": "to advance again [v READVANCED, READVANCING, READVANCES]\n",
  "READVANCED": "READVANCE, to advance again [v]\n",
  "READVANCES": "READVANCE, to advance again [v]\n",
  "READVANCING": "READVANCE, to advance again [v]\n",
  "READVERTISE": "to advertise again, also READVERTIZE [v READVERTISED, READVERTISING, READVERTISES]\n",
  "READVERTISED": "READVERTISE, to advertise again, also READVERTIZE [v]\n",
  "READVERTISEMENT": "the act of readvertising, also READVERTIZEMENT [n]\n",
  "READVERTISES": "READVERTISE, to advertise again, also READVERTIZE [v]\n",
  "READVERTISING": "READVERTISE, to advertise again, also READVERTIZE [v]\n",
  "READVERTIZE": "to advertize again, also READVERTISE [v READVERTIZED, READVERTIZING, READVERTIZES]\n",
  "READVERTIZED": "READVERTIZE, to advertize again, also READVERTISE [v]\n",
  "READVERTIZEMENT": "the act of advertizing again [n]\n",
  "READVERTIZES": "READVERTIZE, to advertize again, also READVERTISE [v]\n",
  "READVERTIZING": "READVERTIZE, to advertize again, also READVERTISE [v]\n",
  "READVISE": "to advise again [v READVISED, READVISING, READVISES]\n",
  "READVISED": "READVISE, to advise again [v]\n",
  "READVISES": "READVISE, to advise again [v]\n",
  "READVISING": "READVISE, to advise again [v]\n",
  "READY": "prepared [adj READIER, READIEST, READILY] / to make ready [v READIED, READYING, READIES]\n",
  "READYING": "READY, to make ready [v]\n",
  "READYMADE": "made before sale, not made to order [adj] / a readymade item of clothing [n -S]\n",
  "READYMADES": "READYMADE, a readymade item of clothing [n]\n",
  "REAEDIFIED": "REAEDIFY, (Spenser) to rebuild, also REAEDIFYE, REEDIFY [v]\n",
  "REAEDIFIES": "REAEDIFY, (Spenser) to rebuild, also REAEDIFYE, REEDIFY [v]\n",
  "REAEDIFY": "(Spenser) to rebuild, also REAEDIFYE, REEDIFY [v REAEDIFIED, REAEDIFYING, REAEDIFIES]\n",
  "REAEDIFYE": "(Spenser) to rebuild, also REAEDIFY, REEDIFY [v REAEDIFYED, REAEDIFYING, REAEDIFYES]\n",
  "REAEDIFYED": "REAEDIFYE, (Spenser) to rebuild, also REAEDIFY, REEDIFY [v]\n",
  "REAEDIFYES": "REAEDIFYE, (Spenser) to rebuild, also REAEDIFY, REEDIFY [v]\n",
  "REAEDIFYING": "REAEDIFY, (Spenser) to rebuild, also REAEDIFYE, REEDIFY [v]\n",
  "REAFFIRM": "to affirm again [v -ED, -ING, -S]\n",
  "REAFFIRMATION": "the act of reaffirming [n -S]\n",
  "REAFFIRMATIONS": "REAFFIRMATION, the act of reaffirming [n]\n",
  "REAFFIRMED": "REAFFIRM, to affirm again [v]\n",
  "REAFFIRMING": "REAFFIRM, to affirm again [v]\n",
  "REAFFIRMS": "REAFFIRM, to affirm again [v]\n",
  "REAFFIX": "to affix again [v -ED, -ING, -ES]\n",
  "REAFFIXED": "REAFFIX, to affix again [v]\n",
  "REAFFIXES": "REAFFIX, to affix again [v]\n",
  "REAFFIXING": "REAFFIX, to affix again [v]\n",
  "REAFFOREST": "to plant with forest again [v -ED, -ING, -S]\n",
  "REAFFORESTATION": "the act of reafforesting [n]\n",
  "REAFFORESTED": "REAFFOREST, to plant with forest again [v]\n",
  "REAFFORESTING": "REAFFOREST, to plant with forest again [v]\n",
  "REAFFORESTS": "REAFFOREST, to plant with forest again [v]\n",
  "REAGENCIES": "REAGENCY, a substance with a characteristic reaction, also REAGENT [n]\n",
  "REAGENCY": "a substance with a characteristic reaction, also REAGENT [n REAGENCIES]\n",
  "REAGENT": "a substance with a characteristic reaction, also REAGENCY [n -S]\n",
  "REAGENTS": "REAGENT, a substance with a characteristic reaction, also REAGENCY [n]\n",
  "REAGGREGATE": "to aggregate again [v REAGGREGATED, REAGGREGATING, REAGGREGATES]\n",
  "REAGGREGATED": "REAGGREGATE, to aggregate again [v]\n",
  "REAGGREGATES": "REAGGREGATE, to aggregate again [v]\n",
  "REAGGREGATING": "REAGGREGATE, to aggregate again [v]\n",
  "REAGGREGATION": "the act of reaggregating [n -S]\n",
  "REAGGREGATIONS": "REAGGREGATION, the act of reaggregating [n]\n",
  "REAGIN": "a type of antibody [n -S]\n",
  "REAGINIC": "relating to a reagin, a type of antibody [adj]\n",
  "REAGINS": "REAGIN, a type of antibody [n]\n",
  "REAIS": "REAL, a monetary unit in Brazil [n]\n",
  "REAK": "(obsolete) to reckon, care for, heed, also RECK, REKE [v -ED, -ING, -S]\n",
  "REAKED": "REAK, (obsolete) to reckon, care for, heed, also RECK, REKE [v]\n",
  "REAKING": "REAK, (obsolete) to reckon, care for, heed, also RECK, REKE [v]\n",
  "REAKS": "REAK, (obsolete) to reckon, care for, heed, also RECK, REKE [v]\n",
  "REAL": "genuine [adj REALER, REALEST, REALLY] / a monetary unit in Brazil [n REALS, REALES, REIS or REAIS]\n",
  "REALER": "REAL, genuine [adj]\n",
  "REALES": "REAL, a monetary unit in Brazil [n]\n",
  "REALEST": "REAL, genuine [adj]\n",
  "REALGAR": "(Arabic) a bright-red monoclinic mineral, also RESALGAR [n -S]\n",
  "REALGARS": "REALGAR, (Arabic) a bright-red monoclinic mineral, also RESALGAR [n]\n",
  "REALIA": "(Latin) objects used by a teacher to illustrate everyday living [n]\n",
  "REALIGN": "to align again [v -ED, -ING, -S]\n",
  "REALIGNED": "REALIGN, to align again [v]\n",
  "REALIGNING": "REALIGN, to align again [v]\n",
  "REALIGNMENT": "the act of realigning [n -S]\n",
  "REALIGNMENTS": "REALIGNMENT, the act of realigning [n]\n",
  "REALIGNS": "REALIGN, to align again [v]\n",
  "REALISABILITIES": "REALISABILITY, the quality of being realisable, also REALIZABILITY [n]\n",
  "REALISABILITY": "the quality of being realisable, also REALIZABILITY [n REALISABILITIES]\n",
  "REALISABLE": "that can be realised, also REALIZABLE [adj REALISABLY]\n",
  "REALISABLY": "REALISABLE, that can be realised, also REALIZABLE [adv]\n",
  "REALISATION": "the act of realising, also REALIZATION [n -S]\n",
  "REALISATIONS": "REALISATION, the act of realising, also REALIZATION [n]\n",
  "REALISE": "to accomplish, also REALIZE [v REALISED, REALISING, REALISES]\n",
  "REALISED": "REALISE, to accomplish, also REALIZE [v]\n",
  "REALISER": "one who realises, also REALIZER [n -S]\n",
  "REALISERS": "REALISER, one who realises, also REALIZER [n]\n",
  "REALISES": "REALISE, to accomplish, also REALIZE [v]\n",
  "REALISING": "REALISE, to accomplish, also REALIZE [v]\n",
  "REALISM": "the doctrine that objects of cognition are real [n -S]\n",
  "REALISMS": "REALISM, the doctrine that objects of cognition are real [n]\n",
  "REALIST": "one who is concerned with fact or reality [n -S]\n",
  "REALISTIC": "resembling reality, lifelike [adj REALISTICALLY]\n",
  "REALISTICALLY": "REALISTIC, resembling reality, lifelike [adv]\n",
  "REALISTS": "REALIST, one who is concerned with fact or reality [n]\n",
  "REALITIES": "REALITY, something that is real [n]\n",
  "REALITY": "something that is real [n REALITIES]\n",
  "REALIZABILITIES": "REALIZABILITY, the quality of being realizable, also REALISABILITY [n]\n",
  "REALIZABILITY": "the quality of being realizable, also REALISABILITY [n REALIZABILITIES]\n",
  "REALIZABLE": "that can be realized, also REALISABLE [adj REALIZABLY]\n",
  "REALIZABLY": "REALIZABLE, that can be realized, also REALISABLE [adv]\n",
  "REALIZATION": "the act of realizing, also REALISATION [n -S]\n",
  "REALIZATIONS": "REALIZATION, the act of realizing, also REALISATION [n]\n",
  "REALIZE": "to accomplish, also REALISE [v REALIZED, REALIZING, REALIZES]\n",
  "REALIZED": "REALIZE, to accomplish, also REALISE [v]\n",
  "REALIZER": "one who realizes, also REALISER [n -S]\n",
  "REALIZERS": "REALIZER, one who realizes, also REALISER [n]\n",
  "REALIZES": "REALIZE, to accomplish, also REALISE [v]\n",
  "REALIZING": "REALIZE, to accomplish, also REALISE [v]\n",
  "REALLIE": "(Spenser) to rally, form again, also RALLY, RALLYE [v REALLIED, REALLYING, REALLIES]\n",
  "REALLIED": "REALLY, to ally again [v]\n",
  "REALLIES": "REALLY, to ally again [v]\n",
  "REALLOCATE": "to allocate again [v REALLOCATED, REALLOCATING, REALLOCATES]\n",
  "REALLOCATED": "REALLOCATE, to allocate again [v]\n",
  "REALLOCATES": "REALLOCATE, to allocate again [v]\n",
  "REALLOCATING": "REALLOCATE, to allocate again [v]\n",
  "REALLOCATION": "the act of reallocating [n -S]\n",
  "REALLOCATIONS": "REALLOCATION, the act of reallocating [n]\n",
  "REALLOT": "to allot again [v REALLOTTED, REALLOTTING, REALLOTS]\n",
  "REALLOTMENT": "the act of allotting again [n -S]\n",
  "REALLOTMENTS": "REALLOTMENT, the act of allotting again [n]\n",
  "REALLOTS": "REALLOT, to allot again [v]\n",
  "REALLOTTED": "REALLOT, to allot again [v]\n",
  "REALLOTTING": "REALLOT, to allot again [v]\n",
  "REALLY": "to ally again [v REALLIED, REALLYING, REALLIES]\n",
  "REALLYING": "REALLY, to ally again [v]\n",
  "REALM": "a kingdom, also REAME [n -S]\n",
  "REALMLESS": "destitute of a realm [adj]\n",
  "REALMS": "REALM, a kingdom, also REAME [n]\n",
  "REALNESS": "the state of being real [n -ES]\n",
  "REALNESSES": "REALNESS, the state of being real [n]\n",
  "REALO": "(German) a member of the less radical section of the German Green party [n -S]\n",
  "REALOS": "REALO, (German) a member of the less radical section of the German Green party [n]\n",
  "REALPOLITIK": "(German) politics guided by practical considerations, instead of principles or ethics [n -S]\n",
  "REALPOLITIKER": "(German) one who practises realpolitik, politics based on practical, rather than moral or ideological, considerations [n -S]\n",
  "REALPOLITIKERS": "REALPOLITIKER, (German) one who practises realpolitik, politics based on practical, rather than moral or ideological, considerations [n]\n",
  "REALPOLITIKS": "REALPOLITIK, (German) politics guided by practical considerations, instead of principles or ethics [n]\n",
  "REALS": "REAL, a monetary unit in Brazil [n]\n",
  "REALTER": "to alter again [v -ED, -ING, -S]\n",
  "REALTERED": "REALTER, to alter again [v]\n",
  "REALTERING": "REALTER, to alter again [v]\n",
  "REALTERS": "REALTER, to alter again [v]\n",
  "REALTIE": "(Milton) sincerity, honesty [n -S]\n",
  "REALTIES": "REALTIE, (Milton) sincerity, honesty [n]\n",
  "REALTIME": "relating to a computer system [adj]\n",
  "REALTONE": "a ringtone that closely resembles an original sound record [n -S]\n",
  "REALTONES": "REALTONE, a ringtone that closely resembles an original sound record [n]\n",
  "REALTOR": "(US) an estate agent [n -S]\n",
  "REALTORS": "REALTOR, (US) an estate agent [n]\n",
  "REALTY": "property in buildings and land [n REALTIES]\n",
  "REAM": "to enlarge the bore of with a reamer [v -ED, -ING, -S]\n",
  "REAME": "(Spenser) a realm [n -S]\n",
  "REAMED": "REAM, to enlarge the bore of with a reamer [v]\n",
  "REAMEND": "to amend again [v -ED, -ING, -S]\n",
  "REAMENDED": "REAMEND, to amend again [v]\n",
  "REAMENDING": "REAMEND, to amend again [v]\n",
  "REAMENDMENT": "the act of amending again [n -S]\n",
  "REAMENDMENTS": "REAMENDMENT, the act of amending again [n]\n",
  "REAMENDS": "REAMEND, to amend again [v]\n",
  "REAMER": "a tool used to enlarge holes, also RIMMER [n -S]\n",
  "REAMERS": "REAMER, a tool used to enlarge holes, also RIMMER [n]\n",
  "REAMES": "REAME, (Spenser) a realm [n]\n",
  "REAMIER": "REAMY, creamy, frothy [adj]\n",
  "REAMIEST": "REAMY, creamy, frothy [adj]\n",
  "REAMING": "REAM, to enlarge the bore of with a reamer [v]\n",
  "REAMS": "REAM, to enlarge the bore of with a reamer [v]\n",
  "REAMY": "creamy, frothy [adj REAMIER, REAMIEST]\n",
  "REAN": "a drainage channel, also REEN, RHINE, RHYNE [n -S]\n",
  "REANALYSE": "to analyse again, also REANALYZE [v REANALYSED, REANALYSING, REANALYSES]\n",
  "REANALYSED": "REANALYSE, to analyse again, also REANALYZE [v]\n",
  "REANALYSES": "REANALYSIS, the act of analysing again [n]\n",
  "REANALYSING": "REANALYSE, to analyse again, also REANALYZE [v]\n",
  "REANALYSIS": "the act of analysing again [n REANALYSES]\n",
  "REANALYZE": "to analyze again, also REANALYSE [v REANALYZED, REANALYZING, REANALYZES]\n",
  "REANALYZED": "REANALYZE, to analyze again, also REANALYSE [v]\n",
  "REANALYZES": "REANALYZE, to analyze again, also REANALYSE [v]\n",
  "REANALYZING": "REANALYZE, to analyze again, also REANALYSE [v]\n",
  "REANIMATE": "to bring back to life [v REANIMATED, REANIMATING, REANIMATES]\n",
  "REANIMATED": "REANIMATE, to bring back to life [v]\n",
  "REANIMATES": "REANIMATE, to bring back to life [v]\n",
  "REANIMATING": "REANIMATE, to bring back to life [v]\n",
  "REANIMATION": "the act of reanimating [n -S]\n",
  "REANIMATIONS": "REANIMATION, the act of reanimating [n]\n",
  "REANNEX": "to annex again [v -ED, -ING, -ES]\n",
  "REANNEXATION": "the act of reannexing [n -S]\n",
  "REANNEXATIONS": "REANNEXATION, the act of reannexing [n]\n",
  "REANNEXED": "REANNEX, to annex again [v]\n",
  "REANNEXES": "REANNEX, to annex again [v]\n",
  "REANNEXING": "REANNEX, to annex again [v]\n",
  "REANOINT": "to anoint again [v -ED, -ING, -S]\n",
  "REANOINTED": "REANOINT, to anoint again [v]\n",
  "REANOINTING": "REANOINT, to anoint again [v]\n",
  "REANOINTS": "REANOINT, to anoint again [v]\n",
  "REANS": "REAN, a drainage channel, also REEN, RHINE, RHYNE [n]\n",
  "REANSWER": "(Shakespeare) to be equivalent to [v -ED, -ING, -S]\n",
  "REANSWERED": "REANSWER, (Shakespeare) to be equivalent to [v]\n",
  "REANSWERING": "REANSWER, (Shakespeare) to be equivalent to [v]\n",
  "REANSWERS": "REANSWER, (Shakespeare) to be equivalent to [v]\n",
  "REAP": "to cut for harvest [v -ED, -ING, -S]\n",
  "REAPABLE": "able to be reaped [adj]\n",
  "REAPED": "REAP, to cut for harvest [v]\n",
  "REAPER": "one that reaps [n -S]\n",
  "REAPERS": "REAPER, one that reaps [n]\n",
  "REAPHOOK": "an implement used in reaping [n -S]\n",
  "REAPHOOKS": "REAPHOOK, an implement used in reaping [n]\n",
  "REAPING": "the cutting of e.g. corn [n -S]\n",
  "REAPINGS": "REAPING, the cutting of e.g. corn [n]\n",
  "REAPPAREL": "to clothe again [v REAPPARELED or REAPPARELLED, REAPPARELING or REAPPARELLING, REAPPARELS]\n",
  "REAPPARELED": "REAPPAREL, to clothe again [v]\n",
  "REAPPARELING": "REAPPAREL, to clothe again [v]\n",
  "REAPPARELLED": "REAPPAREL, to clothe again [v]\n",
  "REAPPARELLING": "REAPPAREL, to clothe again [v]\n",
  "REAPPARELS": "REAPPAREL, to clothe again [v]\n",
  "REAPPEAR": "to appear again [v -ED, -ING, -S]\n",
  "REAPPEARANCE": "the act of reappearing [n -S]\n",
  "REAPPEARANCES": "REAPPEARANCE, the act of reappearing [n]\n",
  "REAPPEARED": "REAPPEAR, to appear again [v]\n",
  "REAPPEARING": "REAPPEAR, to appear again [v]\n",
  "REAPPEARS": "REAPPEAR, to appear again [v]\n",
  "REAPPLICATION": "the act of reapplying [n -S]\n",
  "REAPPLICATIONS": "REAPPLICATION, the act of reapplying [n]\n",
  "REAPPLIED": "REAPPLY, to apply again [v]\n",
  "REAPPLIES": "REAPPLY, to apply again [v]\n",
  "REAPPLY": "to apply again [v REAPPLIED, REAPPLYING, REAPPLIES]\n",
  "REAPPLYING": "REAPPLY, to apply again [v]\n",
  "REAPPOINT": "to appoint again [v -ED, -ING, -S]\n",
  "REAPPOINTED": "REAPPOINT, to appoint again [v]\n",
  "REAPPOINTING": "REAPPOINT, to appoint again [v]\n",
  "REAPPOINTMENT": "the act of reappointing [n -S]\n",
  "REAPPOINTMENTS": "REAPPOINTMENT, the act of reappointing [n]\n",
  "REAPPOINTS": "REAPPOINT, to appoint again [v]\n",
  "REAPPORTION": "to apportion (as a house of representatives) anew [v -ED, -ING, -S]\n",
  "REAPPORTIONED": "REAPPORTION, to apportion (as a house of representatives) anew [v]\n",
  "REAPPORTIONING": "REAPPORTION, to apportion (as a house of representatives) anew [v]\n",
  "REAPPORTIONMENT": "the act of reapportioning [n]\n",
  "REAPPORTIONS": "REAPPORTION, to apportion (as a house of representatives) anew [v]\n",
  "REAPPRAISAL": "the act of reappraising [n -S]\n",
  "REAPPRAISALS": "REAPPRAISAL, the act of reappraising [n]\n",
  "REAPPRAISE": "to appraise again [v REAPPRAISED, REAPPRAISING, REAPPRAISES]\n",
  "REAPPRAISED": "REAPPRAISE, to appraise again [v]\n",
  "REAPPRAISEMENT": "the act of reappraising [n -S]\n",
  "REAPPRAISEMENTS": "REAPPRAISEMENT, the act of reappraising [n]\n",
  "REAPPRAISER": "one who reappraises [n -S]\n",
  "REAPPRAISERS": "REAPPRAISER, one who reappraises [n]\n",
  "REAPPRAISES": "REAPPRAISE, to appraise again [v]\n",
  "REAPPRAISING": "REAPPRAISE, to appraise again [v]\n",
  "REAPPROPRIATE": "to appropriate again [v REAPPROPRIATED, REAPPROPRIATING, REAPPROPRIATES]\n",
  "REAPPROPRIATED": "REAPPROPRIATE, to appropriate again [v]\n",
  "REAPPROPRIATES": "REAPPROPRIATE, to appropriate again [v]\n",
  "REAPPROPRIATING": "REAPPROPRIATE, to appropriate again [v]\n",
  "REAPPROVE": "to approve again [v REAPPROVED, REAPPROVING, REAPPROVES]\n",
  "REAPPROVED": "REAPPROVE, to approve again [v]\n",
  "REAPPROVES": "REAPPROVE, to approve again [v]\n",
  "REAPPROVING": "REAPPROVE, to approve again [v]\n",
  "REAPS": "REAP, to cut for harvest [v]\n",
  "REAR": "to lift upright [v -ED, -ING, -S]\n",
  "REARED": "REAR, to lift upright [v]\n",
  "REARER": "a horse that rears [n -S]\n",
  "REARERS": "REARER, a horse that rears [n]\n",
  "REARGUARD": "the rear of an army; a body of troops protecting it [n -S]\n",
  "REARGUARDS": "REARGUARD, the rear of an army; a body of troops protecting it [n]\n",
  "REARGUE": "to argue again [v REARGUED, REARGUING, REARGUES]\n",
  "REARGUED": "REARGUE, to argue again [v]\n",
  "REARGUES": "REARGUE, to argue again [v]\n",
  "REARGUING": "REARGUE, to argue again [v]\n",
  "REARGUMENT": "an arguing over again, as of a motion made in court [n -S]\n",
  "REARGUMENTS": "REARGUMENT, an arguing over again, as of a motion made in court [n]\n",
  "REARHORSE": "a praying mantis [n -S]\n",
  "REARHORSES": "REARHORSE, a praying mantis [n]\n",
  "REARING": "the act of bringing up [n -S]\n",
  "REARINGS": "REARING, the act of bringing up [n]\n",
  "REARISE": "to arise again [v REAROSE, REARISEN, REARISING, REARISES]\n",
  "REARISEN": "REARISE, to arise again [v]\n",
  "REARISES": "REARISE, to arise again [v]\n",
  "REARISING": "REARISE, to arise again [v]\n",
  "REARLY": "(archaic) early [adv]\n",
  "REARM": "to arm again [v -ED, -ING, -S]\n",
  "REARMAMENT": "the act of arming again [n -S]\n",
  "REARMAMENTS": "REARMAMENT, the act of arming again [n]\n",
  "REARMED": "REARM, to arm again [v]\n",
  "REARMICE": "REARMOUSE, a bat, also REREMOUSE [n]\n",
  "REARMING": "REARM, to arm again [v]\n",
  "REARMOST": "situated last [adj]\n",
  "REARMOUSE": "a bat, also REREMOUSE [n REARMICE]\n",
  "REARMS": "REARM, to arm again [v]\n",
  "REAROSE": "REARISE, to arise again [v]\n",
  "REAROUSAL": "the act of rearousing [n -S]\n",
  "REAROUSALS": "REAROUSAL, the act of rearousing [n]\n",
  "REAROUSE": "to arouse again [v REAROUSED, REAROUSING, REAROUSES]\n",
  "REAROUSED": "REAROUSE, to arouse again [v]\n",
  "REAROUSES": "REAROUSE, to arouse again [v]\n",
  "REAROUSING": "REAROUSE, to arouse again [v]\n",
  "REARRANGE": "to arrange in a different way [v REARRANGED, REARRANGING, REARRANGES]\n",
  "REARRANGED": "REARRANGE, to arrange in a different way [v]\n",
  "REARRANGEMENT": "the act of rearranging [n -S]\n",
  "REARRANGEMENTS": "REARRANGEMENT, the act of rearranging [n]\n",
  "REARRANGER": "one who rearranges [n -S]\n",
  "REARRANGERS": "REARRANGER, one who rearranges [n]\n",
  "REARRANGES": "REARRANGE, to arrange in a different way [v]\n",
  "REARRANGING": "REARRANGE, to arrange in a different way [v]\n",
  "REARREST": "to arrest again [v -ED, -ING, -S]\n",
  "REARRESTED": "REARREST, to arrest again [v]\n",
  "REARRESTING": "REARREST, to arrest again [v]\n",
  "REARRESTS": "REARREST, to arrest again [v]\n",
  "REARS": "REAR, to lift upright [v]\n",
  "REARTICULATE": "to articulate again [v REARTICULATED, REARTICULATING, REARTICULATES]\n",
  "REARTICULATED": "REARTICULATE, to articulate again [v]\n",
  "REARTICULATES": "REARTICULATE, to articulate again [v]\n",
  "REARTICULATING": "REARTICULATE, to articulate again [v]\n",
  "REARWARD": "the rearmost division of an army, also REREWARD [n -S]\n",
  "REARWARDS": "REARWARD, the rearmost division of an army, also REREWARD [n]\n",
  "REASCEND": "to ascend again [v -ED, -ING, -S]\n",
  "REASCENDED": "REASCEND, to ascend again [v]\n",
  "REASCENDING": "REASCEND, to ascend again [v]\n",
  "REASCENDS": "REASCEND, to ascend again [v]\n",
  "REASCENSION": "the act of ascending again esp. to heaven [n -S]\n",
  "REASCENSIONS": "REASCENSION, the act of ascending again esp. to heaven [n]\n",
  "REASCENT": "a second ascent [n -S]\n",
  "REASCENTS": "REASCENT, a second ascent [n]\n",
  "REASON": "to deduct inferences from premises [v -ED, -ING, -S]\n",
  "REASONABILITIES": "REASONABILITY, the state of being reasonable [n]\n",
  "REASONABILITY": "the state of being reasonable [n REASONABILITIES]\n",
  "REASONABLE": "related to reason [adj REASONABLY]\n",
  "REASONABLENESS": "the state of being reasonable [n]\n",
  "REASONABLY": "REASONABLE, related to reason [adv]\n",
  "REASONED": "REASON, to deduct inferences from premises [v]\n",
  "REASONEDLY": "REASONED, REASON, to deduct inferences from premises [adv]\n",
  "REASONER": "one who reasons [n -S]\n",
  "REASONERS": "REASONER, one who reasons [n]\n",
  "REASONING": "the derivation of inferences or conclusions from known or presumed facts [n -S]\n",
  "REASONINGS": "REASONING, the derivation of inferences or conclusions from known or presumed facts [n]\n",
  "REASONLESS": "destitute of reason [adj REASONLESSLY]\n",
  "REASONLESSLY": "REASONLESS, destitute of reason [adv]\n",
  "REASONS": "REASON, to deduct inferences from premises [v]\n",
  "REASSAIL": "to assail again [v -ED, -ING, -S]\n",
  "REASSAILED": "REASSAIL, to assail again [v]\n",
  "REASSAILING": "REASSAIL, to assail again [v]\n",
  "REASSAILS": "REASSAIL, to assail again [v]\n",
  "REASSEMBLAGE": "a reassembly [n -S]\n",
  "REASSEMBLAGES": "REASSEMBLAGE, a reassembly [n]\n",
  "REASSEMBLE": "to assemble again [v REASSEMBLED, REASSEMBLING, REASSEMBLES]\n",
  "REASSEMBLED": "REASSEMBLE, to assemble again [v]\n",
  "REASSEMBLES": "REASSEMBLE, to assemble again [v]\n",
  "REASSEMBLIES": "REASSEMBLY, the act of reassembling [n]\n",
  "REASSEMBLING": "REASSEMBLE, to assemble again [v]\n",
  "REASSEMBLY": "the act of reassembling [n REASSEMBLIES]\n",
  "REASSERT": "to assert again [v -ED, -ING, -S]\n",
  "REASSERTED": "REASSERT, to assert again [v]\n",
  "REASSERTING": "REASSERT, to assert again [v]\n",
  "REASSERTION": "the act of asserting again [n -S]\n",
  "REASSERTIONS": "REASSERTION, the act of asserting again [n]\n",
  "REASSERTS": "REASSERT, to assert again [v]\n",
  "REASSESS": "to assess again [v -ED, -ING, -ES]\n",
  "REASSESSED": "REASSESS, to assess again [v]\n",
  "REASSESSES": "REASSESS, to assess again [v]\n",
  "REASSESSING": "REASSESS, to assess again [v]\n",
  "REASSESSMENT": "the act of reassessing [n -S]\n",
  "REASSESSMENTS": "REASSESSMENT, the act of reassessing [n]\n",
  "REASSIGN": "to assign again [v -ED, -ING, -S]\n",
  "REASSIGNED": "REASSIGN, to assign again [v]\n",
  "REASSIGNING": "REASSIGN, to assign again [v]\n",
  "REASSIGNMENT": "the act of reassigning [n -S]\n",
  "REASSIGNMENTS": "REASSIGNMENT, the act of reassigning [n]\n",
  "REASSIGNS": "REASSIGN, to assign again [v]\n",
  "REASSORT": "to assort again [v -ED, -ING, -S]\n",
  "REASSORTED": "REASSORT, to assort again [v]\n",
  "REASSORTING": "REASSORT, to assort again [v]\n",
  "REASSORTMENT": "the act of reassorting [n -S]\n",
  "REASSORTMENTS": "REASSORTMENT, the act of reassorting [n]\n",
  "REASSORTS": "REASSORT, to assort again [v]\n",
  "REASSUME": "to assume again [v REASSUMED, REASSUMING, REASSUMES]\n",
  "REASSUMED": "REASSUME, to assume again [v]\n",
  "REASSUMES": "REASSUME, to assume again [v]\n",
  "REASSUMING": "REASSUME, to assume again [v]\n",
  "REASSUMPTION": "the act of reassuming [n -S]\n",
  "REASSUMPTIONS": "REASSUMPTION, the act of reassuming [n]\n",
  "REASSURANCE": "the action of reassuring [n -S]\n",
  "REASSURANCES": "REASSURANCE, the action of reassuring [n]\n",
  "REASSURE": "to assure again [v REASSURED, REASSURING, REASSURES]\n",
  "REASSURED": "REASSURE, to assure again [v]\n",
  "REASSURER": "one who reassures [n -S]\n",
  "REASSURERS": "REASSURER, one who reassures [n]\n",
  "REASSURES": "REASSURE, to assure again [v]\n",
  "REASSURING": "REASSURE, to assure again [v]\n",
  "REASSURINGLY": "REASSURING, REASSURE, to assure again [adv]\n",
  "REAST": "esp of horses, to be noisily uncooperative, also REEST [v -ED, -ING, -S]\n",
  "REASTED": "REAST, esp of horses, to be noisily uncooperative, also REEST [v]\n",
  "REASTIER": "REASTY, rancid [adj]\n",
  "REASTIEST": "REASTY, rancid [adj]\n",
  "REASTINESS": "the state of being reasty, rancid [n -ES]\n",
  "REASTINESSES": "REASTINESS, the state of being reasty, rancid [n]\n",
  "REASTING": "REAST, esp of horses, to be noisily uncooperative, also REEST [v]\n",
  "REASTS": "REAST, esp of horses, to be noisily uncooperative, also REEST [v]\n",
  "REASTY": "rancid [adj REASTIER, REASTIEST]\n",
  "REATA": "(Spanish) a lariat, also RIATA [n -S]\n",
  "REATAS": "REATA, (Spanish) a lariat, also RIATA [n]\n",
  "REATE": "any of several kinds of water-crowfoot [n -S]\n",
  "REATES": "REATE, any of several kinds of water-crowfoot [n]\n",
  "REATTACH": "to attach again [v -ED, -ING, -ES]\n",
  "REATTACHED": "REATTACH, to attach again [v]\n",
  "REATTACHES": "REATTACH, to attach again [v]\n",
  "REATTACHING": "REATTACH, to attach again [v]\n",
  "REATTACHMENT": "the act of reattaching [n -S]\n",
  "REATTACHMENTS": "REATTACHMENT, the act of reattaching [n]\n",
  "REATTACK": "to attack again [v -ED, -ING, -S]\n",
  "REATTACKED": "REATTACK, to attack again [v]\n",
  "REATTACKING": "REATTACK, to attack again [v]\n",
  "REATTACKS": "REATTACK, to attack again [v]\n",
  "REATTAIN": "to attain again [v -ED, -ING, -S]\n",
  "REATTAINED": "REATTAIN, to attain again [v]\n",
  "REATTAINING": "REATTAIN, to attain again [v]\n",
  "REATTAINS": "REATTAIN, to attain again [v]\n",
  "REATTEMPT": "to attempt again [v -ED, -ING, -S]\n",
  "REATTEMPTED": "REATTEMPT, to attempt again [v]\n",
  "REATTEMPTING": "REATTEMPT, to attempt again [v]\n",
  "REATTEMPTS": "REATTEMPT, to attempt again [v]\n",
  "REATTRIBUTE": "to attribute again [v REATTRIBUTED, REATTRIBUTING, REATTRIBUTES]\n",
  "REATTRIBUTED": "REATTRIBUTE, to attribute again [v]\n",
  "REATTRIBUTES": "REATTRIBUTE, to attribute again [v]\n",
  "REATTRIBUTING": "REATTRIBUTE, to attribute again [v]\n",
  "REATTRIBUTION": "the act of reattributing [n -S]\n",
  "REATTRIBUTIONS": "REATTRIBUTION, the act of reattributing [n]\n",
  "REAUTHORISATION": "the process of reauthorising, also REAUTHORIZATION [n]\n",
  "REAUTHORISE": "to authorise again, also REAUTHORIZE [v REAUTHORISED, REAUTHORISING, REAUTHORISES]\n",
  "REAUTHORISED": "REAUTHORISE, to authorise again, also REAUTHORIZE [v]\n",
  "REAUTHORISES": "REAUTHORISE, to authorise again, also REAUTHORIZE [v]\n",
  "REAUTHORISING": "REAUTHORISE, to authorise again, also REAUTHORIZE [v]\n",
  "REAUTHORIZATION": "the process of reauthorizing, also REAUTHORISATION [n]\n",
  "REAUTHORIZE": "to authorize again, also REAUTHORISE [v REAUTHORIZED, REAUTHORIZING, REAUTHORIZES]\n",
  "REAUTHORIZED": "REAUTHORIZE, to authorize again, also REAUTHORISE [v]\n",
  "REAUTHORIZES": "REAUTHORIZE, to authorize again, also REAUTHORISE [v]\n",
  "REAUTHORIZING": "REAUTHORIZE, to authorize again, also REAUTHORISE [v]\n",
  "REAVAIL": "to avail again [v -ED, -ING, -S]\n",
  "REAVAILED": "REAVAIL, to avail again [v]\n",
  "REAVAILING": "REAVAIL, to avail again [v]\n",
  "REAVAILS": "REAVAIL, to avail again [v]\n",
  "REAVE": "(archaic) to rob, plunder, also REIVE, RIEVE [v REAVED, REFT, REAVING, REAVES]\n",
  "REAVED": "REAVE, (archaic) to rob, plunder, also REIVE, RIEVE [v]\n",
  "REAVER": "one that reaves, also RIEVER [n -S]\n",
  "REAVERS": "REAVER, one that reaves, also RIEVER [n]\n",
  "REAVES": "REAVE, (archaic) to rob, plunder, also REIVE, RIEVE [v]\n",
  "REAVING": "REAVE, (archaic) to rob, plunder, also REIVE, RIEVE [v]\n",
  "REAVOW": "to vow again [v -ED, -ING, -S]\n",
  "REAVOWED": "REAVOW, to vow again [v]\n",
  "REAVOWING": "REAVOW, to vow again [v]\n",
  "REAVOWS": "REAVOW, to vow again [v]\n",
  "REAWAKE": "to awake again [v REAWOKE or REAWAKED, REAWOKEN, REAWAKING, REAWAKES]\n",
  "REAWAKED": "REAWAKE, to awake again [v]\n",
  "REAWAKEN": "to wake again [v -ED, -ING, -S]\n",
  "REAWAKENED": "REAWAKEN, to wake again [v]\n",
  "REAWAKENING": "the act of reawakening [n -S]\n",
  "REAWAKENINGS": "REAWAKENING, the act of reawakening [n]\n",
  "REAWAKENS": "REAWAKEN, to wake again [v]\n",
  "REAWAKES": "REAWAKE, to awake again [v]\n",
  "REAWAKING": "REAWAKE, to awake again [v]\n",
  "REAWOKE": "REAWAKE, to awake again [v]\n",
  "REAWOKEN": "REAWAKE, to awake again [v]\n",
  "REB": "a Confederate soldier [n -S]\n",
  "REBACK": "to replace the back of [v -ED, -ING, -S]\n",
  "REBACKED": "REBACK, to replace the back of [v]\n",
  "REBACKING": "REBACK, to replace the back of [v]\n",
  "REBACKS": "REBACK, to replace the back of [v]\n",
  "REBADGE": "to market a product under a new brand name [v REBADGED, REBADGING, REBADGES]\n",
  "REBADGED": "REBADGE, to market a product under a new brand name [v]\n",
  "REBADGES": "REBADGE, to market a product under a new brand name [v]\n",
  "REBADGING": "REBADGE, to market a product under a new brand name [v]\n",
  "REBAIT": "to bait again [v -ED, -ING, -S]\n",
  "REBAITED": "REBAIT, to bait again [v]\n",
  "REBAITING": "REBAIT, to bait again [v]\n",
  "REBAITS": "REBAIT, to bait again [v]\n",
  "REBALANCE": "to balance again [v REBALANCED, REBALANCING, REBALANCES]\n",
  "REBALANCED": "REBALANCE, to balance again [v]\n",
  "REBALANCES": "REBALANCE, to balance again [v]\n",
  "REBALANCING": "REBALANCE, to balance again [v]\n",
  "REBAPTISE": "to baptize again or a second time, also REBAPTIZE [v REBAPTISED, REBAPTISING, REBAPTISES]\n",
  "REBAPTISED": "REBAPTISE, to baptize again or a second time, also REBAPTIZE [v]\n",
  "REBAPTISES": "REBAPTISE, to baptize again or a second time, also REBAPTIZE [v]\n",
  "REBAPTISING": "REBAPTISE, to baptize again or a second time, also REBAPTIZE [v]\n",
  "REBAPTISM": "a second baptism [n -S]\n",
  "REBAPTISMS": "REBAPTISM, a second baptism [n]\n",
  "REBAPTIZE": "to baptize again or a second time, also REBAPTISE [v REBAPTIZED, REBAPTIZING, REBAPTIZES]\n",
  "REBAPTIZED": "REBAPTIZE, to baptize again or a second time, also REBAPTISE [v]\n",
  "REBAPTIZES": "REBAPTIZE, to baptize again or a second time, also REBAPTISE [v]\n",
  "REBAPTIZING": "REBAPTIZE, to baptize again or a second time, also REBAPTISE [v]\n",
  "REBAR": "a steel rod for use in reinforced concrete [n -S]\n",
  "REBARBATIVE": "irritating; repellent [adj REBARBATIVELY]\n",
  "REBARBATIVELY": "REBARBATIVE, irritating; repellent [adv]\n",
  "REBARS": "REBAR, a steel rod for use in reinforced concrete [n]\n",
  "REBASE": "to set a new foundation for something [v REBASED, REBASING, REBASES]\n",
  "REBASED": "REBASE, to set a new foundation for something [v]\n",
  "REBASES": "REBASE, to set a new foundation for something [v]\n",
  "REBASING": "REBASE, to set a new foundation for something [v]\n",
  "REBATABLE": "that can be rebated, also REBATEABLE [adj]\n",
  "REBATE": "to give a discount for payment [v REBATED, REBATING, REBATES]\n",
  "REBATEABLE": "that can be rebated, also REBATABLE [adj]\n",
  "REBATED": "REBATE, to give a discount for payment [v]\n",
  "REBATEMENT": "abatement; reduction; discount [n -S]\n",
  "REBATEMENTS": "REBATEMENT, abatement; reduction; discount [n]\n",
  "REBATER": "one who rebates [n -S]\n",
  "REBATERS": "REBATER, one who rebates [n]\n",
  "REBATES": "REBATE, to give a discount for payment [v]\n",
  "REBATING": "REBATE, to give a discount for payment [v]\n",
  "REBATO": "(Shakespeare) a wide, lace-edged collar, also RABATO [n -ES or -S]\n",
  "REBATOES": "REBATO, (Shakespeare) a wide, lace-edged collar, also RABATO [n]\n",
  "REBATOS": "REBATO, (Shakespeare) a wide, lace-edged collar, also RABATO [n]\n",
  "REBBE": "(Yiddish) a rabbi or spiritual leader of a Hasidic Jewish group [n -S]\n",
  "REBBES": "REBBE, (Yiddish) a rabbi or spiritual leader of a Hasidic Jewish group [n]\n",
  "REBBETZIN": "(Yiddish) the wife of a rabbi [n -S]\n",
  "REBBETZINS": "REBBETZIN, (Yiddish) the wife of a rabbi [n]\n",
  "REBEC": "a medieval musical instrument like a mandolin or viol, also REBECK [n -S]\n",
  "REBECK": "a medieval musical instrument like a mandolin or viol, also REBEC [n -S]\n",
  "REBECKS": "REBECK, a medieval musical instrument like a mandolin or viol, also REBEC [n]\n",
  "REBECS": "REBEC, a medieval musical instrument like a mandolin or viol, also REBECK [n]\n",
  "REBEGAN": "REBEGIN, to begin again [v]\n",
  "REBEGIN": "to begin again [v REBEGAN, REBEGUN, REBEGINNING, REBEGINS]\n",
  "REBEGINNING": "REBEGIN, to begin again [v]\n",
  "REBEGINS": "REBEGIN, to begin again [v]\n",
  "REBEGUN": "REBEGIN, to begin again [v]\n",
  "REBEL": "to oppose authority [v REBELLED, REBELLING, REBELS]\n",
  "REBELDOM": "an area controlled by rebels [n -S]\n",
  "REBELDOMS": "REBELDOM, an area controlled by rebels [n]\n",
  "REBELLED": "REBEL, to oppose authority [v]\n",
  "REBELLER": "one who rebels [n -S]\n",
  "REBELLERS": "REBELLER, one who rebels [n]\n",
  "REBELLING": "REBEL, to oppose authority [v]\n",
  "REBELLION": "the act of rebelling [n -S]\n",
  "REBELLIONS": "REBELLION, the act of rebelling [n]\n",
  "REBELLIOUS": "given to or engaged in rebellion [adj REBELLIOUSLY]\n",
  "REBELLIOUSLY": "REBELLIOUS, given to or engaged in rebellion [adv]\n",
  "REBELLIOUSNESS": "the state of being rebellious [n]\n",
  "REBELLOW": "(Spenser) to bellow in return [v -ED, -ING, -S]\n",
  "REBELLOWED": "REBELLOW, (Spenser) to bellow in return [v]\n",
  "REBELLOWING": "REBELLOW, (Spenser) to bellow in return [v]\n",
  "REBELLOWS": "REBELLOW, (Spenser) to bellow in return [v]\n",
  "REBELS": "REBEL, to oppose authority [v]\n",
  "REBID": "to bid again [v REBID, REBIDDEN, REBIDDING, REBIDS]\n",
  "REBIDDEN": "REBID, to bid again [v]\n",
  "REBIDDING": "REBID, to bid again [v]\n",
  "REBIDS": "REBID, to bid again [v]\n",
  "REBILL": "to bill again [v -ED, -ING, -S]\n",
  "REBILLED": "REBILL, to bill again [v]\n",
  "REBILLING": "REBILL, to bill again [v]\n",
  "REBILLS": "REBILL, to bill again [v]\n",
  "REBIND": "to bind again [v REBOUND, REBINDING, REBINDS]\n",
  "REBINDING": "REBIND, to bind again [v]\n",
  "REBINDS": "REBIND, to bind again [v]\n",
  "REBIRTH": "a second birth [n -S]\n",
  "REBIRTHER": "one who claims to have experienced spiritual rebirth [n -S]\n",
  "REBIRTHERS": "REBIRTHER, one who claims to have experienced spiritual rebirth [n]\n",
  "REBIRTHING": "the act of being born again [n -S]\n",
  "REBIRTHINGS": "REBIRTHING, the act of being born again [n]\n",
  "REBIRTHS": "REBIRTH, a second birth [n]\n",
  "REBIT": "REBITE, in engraving, to freshen a plate by a new application of acid [v]\n",
  "REBITE": "in engraving, to freshen a plate by a new application of acid [v REBIT, REBITTEN, REBITING, REBITES]\n",
  "REBITES": "REBITE, in engraving, to freshen a plate by a new application of acid [v]\n",
  "REBITING": "REBITE, in engraving, to freshen a plate by a new application of acid [v]\n",
  "REBITTEN": "REBITE, in engraving, to freshen a plate by a new application of acid [v]\n",
  "REBLEND": "to blend again [v REBLENT or REBLENDED, REBLENDING, REBLENDS]\n",
  "REBLENDED": "REBLEND, to blend again [v]\n",
  "REBLENDING": "REBLEND, to blend again [v]\n",
  "REBLENDS": "REBLEND, to blend again [v]\n",
  "REBLENT": "REBLEND, to blend again [v]\n",
  "REBLOCHON": "a delicately-flavoured soft cheese, made chiefly in the Savoie region of France [n -S]\n",
  "REBLOCHONS": "REBLOCHON, a delicately-flavoured soft cheese, made chiefly in the Savoie region of France [n]\n",
  "REBLOOM": "to bloom again [v -ED, -ING, -S]\n",
  "REBLOOMED": "REBLOOM, to bloom again [v]\n",
  "REBLOOMER": "a flower that blooms again, especially in the same growing season [n -S]\n",
  "REBLOOMERS": "REBLOOMER, a flower that blooms again, especially in the same growing season [n]\n",
  "REBLOOMING": "REBLOOM, to bloom again [v]\n",
  "REBLOOMS": "REBLOOM, to bloom again [v]\n",
  "REBLOSSOM": "to blossom again [v -ED, -ING, -S]\n",
  "REBLOSSOMED": "REBLOSSOM, to blossom again [v]\n",
  "REBLOSSOMING": "REBLOSSOM, to blossom again [v]\n",
  "REBLOSSOMS": "REBLOSSOM, to blossom again [v]\n",
  "REBOANT": "resounding loudly [adj]\n",
  "REBOARD": "to board again [v -ED, -ING, -S]\n",
  "REBOARDED": "REBOARD, to board again [v]\n",
  "REBOARDING": "REBOARD, to board again [v]\n",
  "REBOARDS": "REBOARD, to board again [v]\n",
  "REBOATION": "being reboant, reverberation [n -S]\n",
  "REBOATIONS": "REBOATION, being reboant, reverberation [n]\n",
  "REBODIED": "REBODY, to renew the body of [v]\n",
  "REBODIES": "REBODY, to renew the body of [v]\n",
  "REBODY": "to renew the body of [v REBODIED, REBODYING, REBODIES]\n",
  "REBODYING": "REBODY, to renew the body of [v]\n",
  "REBOIL": "to boil again [v -ED, -ING, -S]\n",
  "REBOILED": "REBOIL, to boil again [v]\n",
  "REBOILING": "REBOIL, to boil again [v]\n",
  "REBOILS": "REBOIL, to boil again [v]\n",
  "REBOOK": "to book again [v -ED, -ING, -S]\n",
  "REBOOKED": "REBOOK, to book again [v]\n",
  "REBOOKING": "REBOOK, to book again [v]\n",
  "REBOOKS": "REBOOK, to book again [v]\n",
  "REBOOT": "to renew the boots of [v -ED, -ING, -S]\n",
  "REBOOTED": "REBOOT, to renew the boots of [v]\n",
  "REBOOTING": "REBOOT, to renew the boots of [v]\n",
  "REBOOTS": "REBOOT, to renew the boots of [v]\n",
  "REBOP": "a type of music [n -S]\n",
  "REBOPS": "REBOP, a type of music [n]\n",
  "REBORE": "to bore out again [v REBORED, REBORING, REBORES]\n",
  "REBORED": "REBORE, to bore out again [v]\n",
  "REBORES": "REBORE, to bore out again [v]\n",
  "REBORING": "REBORE, to bore out again [v]\n",
  "REBORN": "born again [adj]\n",
  "REBORROW": "to borrow again [v -ED, -ING, -S]\n",
  "REBORROWED": "REBORROW, to borrow again [v]\n",
  "REBORROWING": "REBORROW, to borrow again [v]\n",
  "REBORROWS": "REBORROW, to borrow again [v]\n",
  "REBOTTLE": "to bottle again [v REBOTTLED, REBOTTLING, REBOTTLES]\n",
  "REBOTTLED": "REBOTTLE, to bottle again [v]\n",
  "REBOTTLES": "REBOTTLE, to bottle again [v]\n",
  "REBOTTLING": "REBOTTLE, to bottle again [v]\n",
  "REBOUGHT": "REBUY, to buy again [v]\n",
  "REBOUND": "to spring back [v -ED, -ING, -S]\n",
  "REBOUNDED": "REBOUND, to spring back [v]\n",
  "REBOUNDER": "a basketball player who is good at catching the ball as it rebounds from the backboard [n -S]\n",
  "REBOUNDERS": "REBOUNDER, a basketball player who is good at catching the ball as it rebounds from the backboard [n]\n",
  "REBOUNDING": "the act of springing back [n -S]\n",
  "REBOUNDINGS": "REBOUNDING, the act of springing back [n]\n",
  "REBOUNDS": "REBOUND, to spring back [v]\n",
  "REBOZO": "(Spanish) a long scarf worn chiefly by Mexican women [n -S]\n",
  "REBOZOS": "REBOZO, (Spanish) a long scarf worn chiefly by Mexican women [n]\n",
  "REBRACE": "to brace again [v REBRACED, REBRACING, REBRACES]\n",
  "REBRACED": "REBRACE, to brace again [v]\n",
  "REBRACES": "REBRACE, to brace again [v]\n",
  "REBRACING": "REBRACE, to brace again [v]\n",
  "REBRANCH": "to form secondary branches [v -ED, -ING, -ES]\n",
  "REBRANCHED": "REBRANCH, to form secondary branches [v]\n",
  "REBRANCHES": "REBRANCH, to form secondary branches [v]\n",
  "REBRANCHING": "REBRANCH, to form secondary branches [v]\n",
  "REBRAND": "to change a product's brand name or image [v -ED, -ING, -S]\n",
  "REBRANDED": "REBRAND, to change a product's brand name or image [v]\n",
  "REBRANDING": "the act of assigning a new brand [n -S]\n",
  "REBRANDINGS": "REBRANDING, the act of assigning a new brand [n]\n",
  "REBRANDS": "REBRAND, to change a product's brand name or image [v]\n",
  "REBRED": "REBREED, to breed again [v]\n",
  "REBREED": "to breed again [v REBRED, REBREEDING, REBREEDS]\n",
  "REBREEDING": "REBREED, to breed again [v]\n",
  "REBREEDS": "REBREED, to breed again [v]\n",
  "REBROADCAST": "to broadcast again (a radio or television program being simultaneously received from another source) [v -ED, -ING, -S]\n",
  "REBROADCASTED": "REBROADCAST, to broadcast again (a radio or television program being simultaneously received from another source) [v]\n",
  "REBROADCASTING": "REBROADCAST, to broadcast again (a radio or television program being simultaneously received from another source) [v]\n",
  "REBROADCASTS": "REBROADCAST, to broadcast again (a radio or television program being simultaneously received from another source) [v]\n",
  "REBS": "REB, a Confederate soldier [n]\n",
  "REBUFF": "to reject or refuse curtly [v -ED, -ING, -S]\n",
  "REBUFFED": "REBUFF, to reject or refuse curtly [v]\n",
  "REBUFFING": "REBUFF, to reject or refuse curtly [v]\n",
  "REBUFFS": "REBUFF, to reject or refuse curtly [v]\n",
  "REBUILD": "to build again [v REBUILDED, REBUILT, REBUILDING, REBUILDS]\n",
  "REBUILDED": "REBUILD, to build again [v]\n",
  "REBUILDING": "the act of building again [n -S]\n",
  "REBUILDINGS": "REBUILDING, the act of building again [n]\n",
  "REBUILDS": "REBUILD, to build again [v]\n",
  "REBUILT": "REBUILD, to build again [v]\n",
  "REBUKABLE": "worthy of rebuke [adj]\n",
  "REBUKE": "to reprove sternly [v REBUKED, REBUKING, REBUKES]\n",
  "REBUKED": "REBUKE, to reprove sternly [v]\n",
  "REBUKEFUL": "containing rebuke; of the nature of rebuke [adj REBUKEFULLY]\n",
  "REBUKEFULLY": "REBUKEFUL, containing rebuke; of the nature of rebuke [adv]\n",
  "REBUKER": "one who rebukes [n -S]\n",
  "REBUKERS": "REBUKER, one who rebukes [n]\n",
  "REBUKES": "REBUKE, to reprove sternly [v]\n",
  "REBUKING": "REBUKE, to reprove sternly [v]\n",
  "REBUKINGLY": "REBUKING, REBUKE, to reprove sternly [adv]\n",
  "REBURIAL": "a second burial [n -S]\n",
  "REBURIALS": "REBURIAL, a second burial [n]\n",
  "REBURIED": "REBURY, to bury again [v]\n",
  "REBURIES": "REBURY, to bury again [v]\n",
  "REBURY": "to bury again [v REBURIED, REBURYING, REBURIES]\n",
  "REBURYING": "REBURY, to bury again [v]\n",
  "REBUS": "(Latin) a representation of syllables or words by means of pictures or symbols; also, a riddle made up of such pictures or symbols [n -ES]\n",
  "REBUSES": "REBUS, (Latin) a representation of syllables or words by means of pictures or symbols; also, a riddle made up of such pictures or symbols [n]\n",
  "REBUT": "to prove to be false or erroneous [v REBUTTED, REBUTTING, REBUTS]\n",
  "REBUTMENT": "the act of rebutting [n -S]\n",
  "REBUTMENTS": "REBUTMENT, the act of rebutting [n]\n",
  "REBUTS": "REBUT, to prove to be false or erroneous [v]\n",
  "REBUTTABLE": "capable of being rebutted [adj]\n",
  "REBUTTAL": "an argument or proof that rebuts [n -S]\n",
  "REBUTTALS": "REBUTTAL, an argument or proof that rebuts [n]\n",
  "REBUTTED": "REBUT, to prove to be false or erroneous [v]\n",
  "REBUTTER": "one who rebuts [n -S]\n",
  "REBUTTERS": "REBUTTER, one who rebuts [n]\n",
  "REBUTTING": "REBUT, to prove to be false or erroneous [v]\n",
  "REBUTTON": "to button again [v -ED, -ING, -S]\n",
  "REBUTTONED": "REBUTTON, to button again [v]\n",
  "REBUTTONING": "REBUTTON, to button again [v]\n",
  "REBUTTONS": "REBUTTON, to button again [v]\n",
  "REBUY": "to buy again [v REBOUGHT, REBUYING, REBUYS]\n",
  "REBUYING": "REBUY, to buy again [v]\n",
  "REBUYS": "REBUY, to buy again [v]\n",
  "REC": "a recreation ground [n -S]\n",
  "RECAL": "to call back, also RECALL [v RECALLED, RECALLING, RECALS]\n",
  "RECALCITRANCE": "the state of being recalcitrant, also RECALCITRANCY [n -S]\n",
  "RECALCITRANCES": "RECALCITRANCE, the state of being recalcitrant, also RECALCITRANCY [n]\n",
  "RECALCITRANCIES": "RECALCITRANCY, the state of being recalcitrant, also RECALCITRANCE [n]\n",
  "RECALCITRANCY": "the state of being recalcitrant, also RECALCITRANCE [n RECALCITRANCIES]\n",
  "RECALCITRANT": "obstinately defiant of authority or restraint [adj] / a recalcitrant person [n -S]\n",
  "RECALCITRANTS": "RECALCITRANT, a recalcitrant person [n]\n",
  "RECALCITRATE": "to show strong objection to [v RECALCITRATED, RECALCITRATING, RECALCITRATES]\n",
  "RECALCITRATED": "RECALCITRATE, to show strong objection to [v]\n",
  "RECALCITRATES": "RECALCITRATE, to show strong objection to [v]\n",
  "RECALCITRATING": "RECALCITRATE, to show strong objection to [v]\n",
  "RECALCITRATION": "refractoriness [n -S]\n",
  "RECALCITRATIONS": "RECALCITRATION, refractoriness [n]\n",
  "RECALCULATE": "to calculate again [v RECALCULATED, RECALCULATING, RECALCULATES]\n",
  "RECALCULATED": "RECALCULATE, to calculate again [v]\n",
  "RECALCULATES": "RECALCULATE, to calculate again [v]\n",
  "RECALCULATING": "RECALCULATE, to calculate again [v]\n",
  "RECALCULATION": "the act of recalculating [n -S]\n",
  "RECALCULATIONS": "RECALCULATION, the act of recalculating [n]\n",
  "RECALESCE": "to liberate heat suddenly when cooling through certain temperature [v RECALESCED, RECALESCING, RECALESCES]\n",
  "RECALESCED": "RECALESCE, to liberate heat suddenly when cooling through certain temperature [v]\n",
  "RECALESCENCE": "the renewed glowing of iron at a certain stage of cooling from white heat [n -S]\n",
  "RECALESCENCES": "RECALESCENCE, the renewed glowing of iron at a certain stage of cooling from white heat [n]\n",
  "RECALESCENT": "liberating heat suddenly when cooling through certain temperature [adj]\n",
  "RECALESCES": "RECALESCE, to liberate heat suddenly when cooling through certain temperature [v]\n",
  "RECALESCING": "RECALESCE, to liberate heat suddenly when cooling through certain temperature [v]\n",
  "RECALIBRATE": "to calibrate again [v RECALIBRATED, RECALIBRATING, RECALIBRATES]\n",
  "RECALIBRATED": "RECALIBRATE, to calibrate again [v]\n",
  "RECALIBRATES": "RECALIBRATE, to calibrate again [v]\n",
  "RECALIBRATING": "RECALIBRATE, to calibrate again [v]\n",
  "RECALIBRATION": "the act of recalibrating [n -S]\n",
  "RECALIBRATIONS": "RECALIBRATION, the act of recalibrating [n]\n",
  "RECALL": "to call back, also RECAL [v -ED, -ING, -S]\n",
  "RECALLABILITIES": "RECALLABILITY, the state of being recallable [n]\n",
  "RECALLABILITY": "the state of being recallable [n RECALLABILITIES]\n",
  "RECALLABLE": "capable of being recalled [adj]\n",
  "RECALLED": "RECALL, to call back, also RECAL [v]\n",
  "RECALLER": "one who recalls [n -S]\n",
  "RECALLERS": "RECALLER, one who recalls [n]\n",
  "RECALLING": "RECALL, to call back, also RECAL [v]\n",
  "RECALLMENT": "the act of calling back, also RECALMENT [n -S]\n",
  "RECALLMENTS": "RECALLMENT, the act of calling back, also RECALMENT [n]\n",
  "RECALLS": "RECALL, to call back, also RECAL [v]\n",
  "RECALMENT": "the act of calling back, also RECALLMENT [n -S]\n",
  "RECALMENTS": "RECALMENT, the act of calling back, also RECALLMENT [n]\n",
  "RECALS": "RECAL, to call back, also RECALL [v]\n",
  "RECAMIER": "(French) a backless couch [n -S]\n",
  "RECAMIERS": "RECAMIER, (French) a backless couch [n]\n",
  "RECANALISATION": "the process of restoring flow to or reuniting an interrupted channel of a bodily tube (as a blood vessel or vas deferens), also RECANALIZATION [n -S]\n",
  "RECANALISATIONS": "RECANALISATION, the process of restoring flow to or reuniting an interrupted channel of a bodily tube (as a blood vessel or vas deferens), also RECANALIZATION [n]\n",
  "RECANALISE": "to canalize again, also RECANALIZE [v RECANALISED, RECANALISING, RECANALISES]\n",
  "RECANALISED": "RECANALISE, to canalize again, also RECANALIZE [v]\n",
  "RECANALISES": "RECANALISE, to canalize again, also RECANALIZE [v]\n",
  "RECANALISING": "RECANALISE, to canalize again, also RECANALIZE [v]\n",
  "RECANALIZATION": "the process of restoring flow to or reuniting an interrupted channel of a bodily tube (as a blood vessel or vas deferens), also RECANALISATION [n -S]\n",
  "RECANALIZATIONS": "RECANALIZATION, the process of restoring flow to or reuniting an interrupted channel of a bodily tube (as a blood vessel or vas deferens), also RECANALISATION [n]\n",
  "RECANALIZE": "to canalize again, also RECANALISE [v RECANALIZED, RECANALIZING, RECANALIZES]\n",
  "RECANALIZED": "RECANALIZE, to canalize again, also RECANALISE [v]\n",
  "RECANALIZES": "RECANALIZE, to canalize again, also RECANALISE [v]\n",
  "RECANALIZING": "RECANALIZE, to canalize again, also RECANALISE [v]\n",
  "RECANE": "to replace the cane of [v RECANED, RECANING, RECANES]\n",
  "RECANED": "RECANE, to replace the cane of [v]\n",
  "RECANES": "RECANE, to replace the cane of [v]\n",
  "RECANING": "RECANE, to replace the cane of [v]\n",
  "RECANT": "to make a formal retraction [v -ED, -ING, -S]\n",
  "RECANTATION": "the act of recanting [n -S]\n",
  "RECANTATIONS": "RECANTATION, the act of recanting [n]\n",
  "RECANTED": "RECANT, to make a formal retraction [v]\n",
  "RECANTER": "one who recants [n -S]\n",
  "RECANTERS": "RECANTER, one who recants [n]\n",
  "RECANTING": "RECANT, to make a formal retraction [v]\n",
  "RECANTS": "RECANT, to make a formal retraction [v]\n",
  "RECAP": "(short for) recapitulate, to review by a brief summary [v RECAPPED, RECAPPING, RECAPS]\n",
  "RECAPITALISE": "to supply with new capital, also RECAPITALIZE [v RECAPITALISED, RECAPITALISING, RECAPITALISES]\n",
  "RECAPITALISED": "RECAPITALISE, to supply with new capital, also RECAPITALIZE [v]\n",
  "RECAPITALISES": "RECAPITALISE, to supply with new capital, also RECAPITALIZE [v]\n",
  "RECAPITALISING": "RECAPITALISE, to supply with new capital, also RECAPITALIZE [v]\n",
  "RECAPITALIZE": "to change the capital structure of, also RECAPITALISE [v RECAPITALIZED, RECAPITALIZING, RECAPITALIZES]\n",
  "RECAPITALIZED": "RECAPITALIZE, to change the capital structure of, also RECAPITALISE [v]\n",
  "RECAPITALIZES": "RECAPITALIZE, to change the capital structure of, also RECAPITALISE [v]\n",
  "RECAPITALIZING": "RECAPITALIZE, to change the capital structure of, also RECAPITALISE [v]\n",
  "RECAPITULATE": "to restate briefly, also RECAP [v RECAPITULATED, RECAPITULATING, RECAPITULATES]\n",
  "RECAPITULATED": "RECAPITULATE, to restate briefly, also RECAP [v]\n",
  "RECAPITULATES": "RECAPITULATE, to restate briefly, also RECAP [v]\n",
  "RECAPITULATING": "RECAPITULATE, to restate briefly, also RECAP [v]\n",
  "RECAPITULATION": "a concise summary [n -S]\n",
  "RECAPITULATIONS": "RECAPITULATION, a concise summary [n]\n",
  "RECAPITULATIVE": "serving to recapitulate [adj]\n",
  "RECAPITULATORY": "of the nature of a recapitulation [adj]\n",
  "RECAPPABLE": "that can be recapped [adj]\n",
  "RECAPPED": "RECAP, (short for) recapitulate, to review by a brief summary [v]\n",
  "RECAPPING": "RECAP, (short for) recapitulate, to review by a brief summary [v]\n",
  "RECAPS": "RECAP, (short for) recapitulate, to review by a brief summary [v]\n",
  "RECAPTION": "taking back by peaceable means goods, children, etc. from someone who has no right to detain them [n -S]\n",
  "RECAPTIONS": "RECAPTION, taking back by peaceable means goods, children, etc. from someone who has no right to detain them [n]\n",
  "RECAPTOR": "one who recaptures [n -S]\n",
  "RECAPTORS": "RECAPTOR, one who recaptures [n]\n",
  "RECAPTURE": "to capture again [v RECAPTURED, RECAPTURING, RECAPTURES]\n",
  "RECAPTURED": "RECAPTURE, to capture again [v]\n",
  "RECAPTURER": "one who recaptures [n -S]\n",
  "RECAPTURERS": "RECAPTURER, one who recaptures [n]\n",
  "RECAPTURES": "RECAPTURE, to capture again [v]\n",
  "RECAPTURING": "RECAPTURE, to capture again [v]\n",
  "RECARPET": "to replace the carpet [v -ED, -ING, -S]\n",
  "RECARPETED": "RECARPET, to replace the carpet [v]\n",
  "RECARPETING": "RECARPET, to replace the carpet [v]\n",
  "RECARPETS": "RECARPET, to replace the carpet [v]\n",
  "RECARRIED": "RECARRY, to carry again [v]\n",
  "RECARRIES": "RECARRY, to carry again [v]\n",
  "RECARRY": "to carry again [v RECARRIED, RECARRYING, RECARRIES]\n",
  "RECARRYING": "RECARRY, to carry again [v]\n",
  "RECAST": "to cast again [v RECAST, RECASTING, RECASTS]\n",
  "RECASTING": "RECAST, to cast again [v]\n",
  "RECASTS": "RECAST, to cast again [v]\n",
  "RECATALOG": "to catalog again, also RECATALOGUE [v -ED, -ING, -S]\n",
  "RECATALOGED": "RECATALOG, to catalog again, also RECATALOGUE [v]\n",
  "RECATALOGING": "RECATALOG, to catalog again, also RECATALOGUE [v]\n",
  "RECATALOGS": "RECATALOG, to catalog again, also RECATALOGUE [v]\n",
  "RECATALOGUE": "to catalogue again, also RECATALOG [v RECATALOGUED, RECATALOGUING, RECATALOGUES]\n",
  "RECATALOGUED": "RECATALOGUE, to catalogue again, also RECATALOG [v]\n",
  "RECATALOGUES": "RECATALOGUE, to catalogue again, also RECATALOG [v]\n",
  "RECATALOGUING": "RECATALOGUE, to catalogue again, also RECATALOG [v]\n",
  "RECATCH": "to catch again [v RECAUGHT, RECATCHING, RECATCHES]\n",
  "RECATCHES": "RECATCH, to catch again [v]\n",
  "RECATCHING": "RECATCH, to catch again [v]\n",
  "RECAUGHT": "RECATCH, to catch again [v]\n",
  "RECAUTION": "to caution again [v -ED, -ING, -S]\n",
  "RECAUTIONED": "RECAUTION, to caution again [v]\n",
  "RECAUTIONING": "RECAUTION, to caution again [v]\n",
  "RECAUTIONS": "RECAUTION, to caution again [v]\n",
  "RECCE": "to make a preliminary survey, also RECCY [v RECCED or RECCEED, RECCEING, RECCES]\n",
  "RECCED": "RECCE, to make a preliminary survey, also RECCY [v]\n",
  "RECCEED": "RECCE, to make a preliminary survey, also RECCY [v]\n",
  "RECCEING": "RECCE, to make a preliminary survey, also RECCY [v]\n",
  "RECCES": "RECCE, to make a preliminary survey, also RECCY [v]\n",
  "RECCIED": "RECCY, (colloquial) to reconnoitre, also RECCE, RECCO [v]\n",
  "RECCIES": "RECCY, (colloquial) to reconnoitre, also RECCE, RECCO [v]\n",
  "RECCO": "(colloquial) a reconnoitre, also RECCE, RECCY [n -S]\n",
  "RECCOS": "RECCO, (colloquial) a reconnoitre, also RECCE, RECCY [n]\n",
  "RECCY": "(colloquial) to reconnoitre, also RECCE, RECCO [v RECCIED, RECCYING, RECCIES]\n",
  "RECCYING": "RECCY, (colloquial) to reconnoitre, also RECCE, RECCO [v]\n",
  "RECEDE": "to move back [v RECEDED, RECEDING, RECEDES]\n",
  "RECEDED": "RECEDE, to move back [v]\n",
  "RECEDES": "RECEDE, to move back [v]\n",
  "RECEDING": "RECEDE, to move back [v]\n",
  "RECEIPT": "to mark as having been paid [v -ED, -ING, -S]\n",
  "RECEIPTED": "RECEIPT, to mark as having been paid [v]\n",
  "RECEIPTING": "RECEIPT, to mark as having been paid [v]\n",
  "RECEIPTOR": "a person who receipts [n -S]\n",
  "RECEIPTORS": "RECEIPTOR, a person who receipts [n]\n",
  "RECEIPTS": "RECEIPT, to mark as having been paid [v]\n",
  "RECEIVABILITIES": "RECEIVABILITY, the quality of being receivable [n]\n",
  "RECEIVABILITY": "the quality of being receivable [n RECEIVABILITIES]\n",
  "RECEIVABLE": "capable of being received [adj] / something that can be received [n -S]\n",
  "RECEIVABLENESS": "RECEIVABLE, capable of being received [n]\n",
  "RECEIVABLES": "RECEIVABLE, something that can be received [n]\n",
  "RECEIVAL": "the act of receiving [n -S]\n",
  "RECEIVALS": "RECEIVAL, the act of receiving [n]\n",
  "RECEIVE": "to come into possession of [v RECEIVED, RECEIVING, RECEIVES]\n",
  "RECEIVED": "RECEIVE, to come into possession of [v]\n",
  "RECEIVER": "one that receives [n -S]\n",
  "RECEIVERS": "RECEIVER, one that receives [n]\n",
  "RECEIVERSHIP": "the office or function of a receiver [n -S]\n",
  "RECEIVERSHIPS": "RECEIVERSHIP, the office or function of a receiver [n]\n",
  "RECEIVES": "RECEIVE, to come into possession of [v]\n",
  "RECEIVING": "the act of receiving [n -S]\n",
  "RECEIVINGS": "RECEIVING, the act of receiving [n]\n",
  "RECEMENT": "to redo cement work [v -ED, -ING, -S]\n",
  "RECEMENTED": "RECEMENT, to redo cement work [v]\n",
  "RECEMENTING": "RECEMENT, to redo cement work [v]\n",
  "RECEMENTS": "RECEMENT, to redo cement work [v]\n",
  "RECENCIES": "RECENCY, the state of being recent [n]\n",
  "RECENCY": "the state of being recent [n RECENCIES]\n",
  "RECENSE": "to revise critically [v RECENSED, RECENSING, RECENSES]\n",
  "RECENSED": "RECENSE, to revise critically [v]\n",
  "RECENSES": "RECENSE, to revise critically [v]\n",
  "RECENSING": "RECENSE, to revise critically [v]\n",
  "RECENSION": "the act of reviewing or revising [n -S]\n",
  "RECENSIONS": "RECENSION, the act of reviewing or revising [n]\n",
  "RECENSOR": "to censor again [v -ED, -ING, -S]\n",
  "RECENSORED": "RECENSOR, to censor again [v]\n",
  "RECENSORING": "RECENSOR, to censor again [v]\n",
  "RECENSORS": "RECENSOR, to censor again [v]\n",
  "RECENT": "happening not long ago [adj RECENTER, RECENTEST, RECENTLY]\n",
  "RECENTER": "RECENT, happening not long ago [adj]\n",
  "RECENTEST": "RECENT, happening not long ago [adj]\n",
  "RECENTLY": "RECENT, happening not long ago [adv]\n",
  "RECENTNESS": "the state of being recent [n -ES]\n",
  "RECENTNESSES": "RECENTNESS, the state of being recent [n]\n",
  "RECENTRE": "to centre again [v RECENTRED, RECENTRING, RECENTRES]\n",
  "RECENTRED": "RECENTRE, to centre again [v]\n",
  "RECENTRES": "RECENTRE, to centre again [v]\n",
  "RECENTRIFUGE": "to put through a centrifuge again [v RECENTRIFUGED, RECENTRIFUGING, RECENTRIFUGES]\n",
  "RECENTRIFUGED": "RECENTRIFUGE, to put through a centrifuge again [v]\n",
  "RECENTRIFUGES": "RECENTRIFUGE, to put through a centrifuge again [v]\n",
  "RECENTRIFUGING": "RECENTRIFUGE, to put through a centrifuge again [v]\n",
  "RECENTRING": "RECENTRE, to centre again [v]\n",
  "RECEPT": "an idea or image formed by repeated similar perceptions [n -S]\n",
  "RECEPTACLE": "that in which anything is or may be received [n -S]\n",
  "RECEPTACLES": "RECEPTACLE, that in which anything is or may be received [n]\n",
  "RECEPTACULA": "RECEPTACULUM, (Latin) a receptacle [n]\n",
  "RECEPTACULAR": "of or like a receptacle [adj]\n",
  "RECEPTACULUM": "(Latin) a receptacle [n RECEPTACULA]\n",
  "RECEPTIBILITIES": "RECEPTIBILITY, the state of being receptible [n]\n",
  "RECEPTIBILITY": "the state of being receptible [n RECEPTIBILITIES]\n",
  "RECEPTIBLE": "such as may be received [adj]\n",
  "RECEPTION": "the act of receiving or of being received [n -S]\n",
  "RECEPTIONIST": "a person employed to greet telephone callers, visitors, patients, or clients [n -S]\n",
  "RECEPTIONISTS": "RECEPTIONIST, a person employed to greet telephone callers, visitors, patients, or clients [n]\n",
  "RECEPTIONS": "RECEPTION, the act of receiving or of being received [n]\n",
  "RECEPTIVE": "ready to receive [adj RECEPTIVELY]\n",
  "RECEPTIVELY": "RECEPTIVE, ready to receive [adv]\n",
  "RECEPTIVENESS": "the state of being receptive [n -ES]\n",
  "RECEPTIVENESSES": "RECEPTIVENESS, the state of being receptive [n]\n",
  "RECEPTIVITIES": "RECEPTIVITY, the state of being receptive [n]\n",
  "RECEPTIVITY": "the state of being receptive [n RECEPTIVITIES]\n",
  "RECEPTOR": "a nerve ending specialized to receive stimuli [n -S]\n",
  "RECEPTORS": "RECEPTOR, a nerve ending specialized to receive stimuli [n]\n",
  "RECEPTS": "RECEPT, an idea or image formed by repeated similar perceptions [n]\n",
  "RECERTIFICATION": "the act of recertifying [n]\n",
  "RECERTIFIED": "RECERTIFY, to certify again [v]\n",
  "RECERTIFIES": "RECERTIFY, to certify again [v]\n",
  "RECERTIFY": "to certify again [v RECERTIFIED, RECERTIFYING, RECERTIFIES]\n",
  "RECERTIFYING": "RECERTIFY, to certify again [v]\n",
  "RECESS": "to place in a hollow [v -ED, -ING, -ES]\n",
  "RECESSED": "RECESS, to place in a hollow [v]\n",
  "RECESSES": "RECESS, to place in a hollow [v]\n",
  "RECESSING": "RECESS, to place in a hollow [v]\n",
  "RECESSION": "a temporary decline in a country's trade [n -S]\n",
  "RECESSIONAL": "a hymn or musical piece at the conclusion of a service or program [n -S]\n",
  "RECESSIONALS": "RECESSIONAL, a hymn or musical piece at the conclusion of a service or program [n]\n",
  "RECESSIONARY": "relating to recession [adj]\n",
  "RECESSIONISTA": "a person whose clothes, whether cheap, secondhand, or suitably subdued, are considered appropriate to an economic downturn [n -S]\n",
  "RECESSIONISTAS": "RECESSIONISTA, a person whose clothes, whether cheap, secondhand, or suitably subdued, are considered appropriate to an economic downturn [n]\n",
  "RECESSIONS": "RECESSION, a temporary decline in a country's trade [n]\n",
  "RECESSIVE": "tending to receive [adj RECESSIVELY] / a recessive gene [n -S]\n",
  "RECESSIVELY": "RECESSIVE, tending to receive [adv]\n",
  "RECESSIVENESS": "the state of being recessive [n -ES]\n",
  "RECESSIVENESSES": "RECESSIVENESS, the state of being recessive [n]\n",
  "RECESSIVES": "RECESSIVE, a recessive gene [n]\n",
  "RECHALLENGE": "to challenge again [v RECHALLENGED, RECHALLENGING, RECHALLENGES]\n",
  "RECHALLENGED": "RECHALLENGE, to challenge again [v]\n",
  "RECHALLENGES": "RECHALLENGE, to challenge again [v]\n",
  "RECHALLENGING": "RECHALLENGE, to challenge again [v]\n",
  "RECHANGE": "to change again [v RECHANGED, RECHANGING, RECHANGES]\n",
  "RECHANGED": "RECHANGE, to change again [v]\n",
  "RECHANGES": "RECHANGE, to change again [v]\n",
  "RECHANGING": "RECHANGE, to change again [v]\n",
  "RECHANNEL": "to channel again [v RECHANNELED or RECHANNELLED, RECHANNELING or RECHANNELLING, RECHANNELS]\n",
  "RECHANNELED": "RECHANNEL, to channel again [v]\n",
  "RECHANNELING": "RECHANNEL, to channel again [v]\n",
  "RECHANNELLED": "RECHANNEL, to channel again [v]\n",
  "RECHANNELLING": "RECHANNEL, to channel again [v]\n",
  "RECHANNELS": "RECHANNEL, to channel again [v]\n",
  "RECHARGE": "to charge again [v RECHARGED, RECHARGING, RECHARGES]\n",
  "RECHARGEABLE": "capable of being recharged [adj]\n",
  "RECHARGED": "RECHARGE, to charge again [v]\n",
  "RECHARGER": "a device for recharging e.g. a battery [n -S]\n",
  "RECHARGERS": "RECHARGER, a device for recharging e.g. a battery [n]\n",
  "RECHARGES": "RECHARGE, to charge again [v]\n",
  "RECHARGING": "RECHARGE, to charge again [v]\n",
  "RECHART": "to chart again [v -ED, -ING, -S]\n",
  "RECHARTED": "RECHART, to chart again [v]\n",
  "RECHARTER": "to charter again [v -ED, -ING, -S]\n",
  "RECHARTERED": "RECHARTER, to charter again [v]\n",
  "RECHARTERING": "RECHARTER, to charter again [v]\n",
  "RECHARTERS": "RECHARTER, to charter again [v]\n",
  "RECHARTING": "RECHART, to chart again [v]\n",
  "RECHARTS": "RECHART, to chart again [v]\n",
  "RECHATE": "(Shakespeare) a strain given on the horn to call back the hounds when they have lost track of the game, also RECHEAT [n -S]\n",
  "RECHATES": "RECHATE, (Shakespeare) a strain given on the horn to call back the hounds when they have lost track of the game, also RECHEAT [n]\n",
  "RECHAUFFE": "(French) a reheated dish; a fresh concoction of old material [n -S]\n",
  "RECHAUFFES": "RECHAUFFE, (French) a reheated dish; a fresh concoction of old material [n]\n",
  "RECHEAT": "to sound a hunting call, to call back the hounds when they have lost track of the game [v -ED, -ING, -S]\n",
  "RECHEATED": "RECHEAT, to sound a hunting call, to call back the hounds when they have lost track of the game [v]\n",
  "RECHEATING": "RECHEAT, to sound a hunting call, to call back the hounds when they have lost track of the game [v]\n",
  "RECHEATS": "RECHEAT, to sound a hunting call, to call back the hounds when they have lost track of the game [v]\n",
  "RECHECK": "to check again [v -ED, -ING, -S]\n",
  "RECHECKED": "RECHECK, to check again [v]\n",
  "RECHECKING": "RECHECK, to check again [v]\n",
  "RECHECKS": "RECHECK, to check again [v]\n",
  "RECHERCHE": "(French) exquisite, choice; excessively refined, affected [adj]\n",
  "RECHEW": "to chew again [v -ED, -ING, -S]\n",
  "RECHEWED": "RECHEW, to chew again [v]\n",
  "RECHEWING": "RECHEW, to chew again [v]\n",
  "RECHEWS": "RECHEW, to chew again [v]\n",
  "RECHIE": "(Shakespeare) smoky, grimy, also REECHIE, REECHY, REEKIE, REEKY [adj]\n",
  "RECHIP": "to change the electronic identity of (a stolen mobile phone) [v RECHIPPED, RECHIPPING, RECHIPS]\n",
  "RECHIPPED": "RECHIP, to change the electronic identity of (a stolen mobile phone) [v]\n",
  "RECHIPPING": "the act of rechipping [n -S]\n",
  "RECHIPPINGS": "RECHIPPING, the act of rechipping [n]\n",
  "RECHIPS": "RECHIP, to change the electronic identity of (a stolen mobile phone) [v]\n",
  "RECHLESSE": "(Spenser) reckless, also RECKLESS, RETCHLESS [adj]\n",
  "RECHOOSE": "to choose again [v RECHOSE, RECHOSEN, RECHOOSING, RECHOOSES]\n",
  "RECHOOSES": "RECHOOSE, to choose again [v]\n",
  "RECHOOSING": "RECHOOSE, to choose again [v]\n",
  "RECHOREOGRAPH": "to choreograph again [v -ED, -S]\n",
  "RECHOREOGRAPHED": "RECHOREOGRAPH, to choreograph again [v]\n",
  "RECHOREOGRAPHS": "RECHOREOGRAPH, to choreograph again [v]\n",
  "RECHOSE": "RECHOOSE, to choose again [v]\n",
  "RECHOSEN": "RECHOOSE, to choose again [v]\n",
  "RECHRISTEN": "to christen again [v -ED, -ING, -S]\n",
  "RECHRISTENED": "RECHRISTEN, to christen again [v]\n",
  "RECHRISTENING": "RECHRISTEN, to christen again [v]\n",
  "RECHRISTENS": "RECHRISTEN, to christen again [v]\n",
  "RECHROMATOGRAPH": "to do by chromatograph again [v]\n",
  "RECIDIVISM": "a tendency to relapse into a previous condition or mode of behavior, esp. a relapse into criminal behavior [n -S]\n",
  "RECIDIVISMS": "RECIDIVISM, a tendency to relapse into a previous condition or mode of behavior, esp. a relapse into criminal behavior [n]\n",
  "RECIDIVIST": "a habitual criminal (one who relapses) [n -S]\n",
  "RECIDIVISTIC": "relating to recidivism [adj]\n",
  "RECIDIVISTS": "RECIDIVIST, a habitual criminal (one who relapses) [n]\n",
  "RECIDIVOUS": "given to recidivism [adj]\n",
  "RECIPE": "a set of instructions for making something [n -S]\n",
  "RECIPES": "RECIPE, a set of instructions for making something [n]\n",
  "RECIPIENCE": "the state of being recipient, also RECIPIENCY [n -S]\n",
  "RECIPIENCES": "RECIPIENCE, the state of being recipient, also RECIPIENCY [n]\n",
  "RECIPIENCIES": "RECIPIENCY, the state of being recipient, also RECIPIENCE [n]\n",
  "RECIPIENCY": "the state of being recipient, also RECIPIENCE [n RECIPIENCIES]\n",
  "RECIPIENT": "one who receives [n -S]\n",
  "RECIPIENTS": "RECIPIENT, one who receives [n]\n",
  "RECIPROCAL": "acting in return [adj RECIPROCALLY] / something in a reciprocal relationship to another [n -S]\n",
  "RECIPROCALITIES": "RECIPROCALITY, the state of being reciprocal [n]\n",
  "RECIPROCALITY": "the state of being reciprocal [n RECIPROCALITIES]\n",
  "RECIPROCALLY": "RECIPROCAL, acting in return [adv]\n",
  "RECIPROCALS": "RECIPROCAL, something in a reciprocal relationship to another [n]\n",
  "RECIPROCANT": "in maths, a differential invariant [n -S]\n",
  "RECIPROCANTS": "RECIPROCANT, in maths, a differential invariant [n]\n",
  "RECIPROCATE": "to give and take mutually [v RECIPROCATED, RECIPROCATING, RECIPROCATES]\n",
  "RECIPROCATED": "RECIPROCATE, to give and take mutually [v]\n",
  "RECIPROCATES": "RECIPROCATE, to give and take mutually [v]\n",
  "RECIPROCATING": "RECIPROCATE, to give and take mutually [v]\n",
  "RECIPROCATION": "a mutual exchange [n -S]\n",
  "RECIPROCATIONS": "RECIPROCATION, a mutual exchange [n]\n",
  "RECIPROCATIVE": "relating to reciprocation [adj]\n",
  "RECIPROCATOR": "one who reciprocates [n -S]\n",
  "RECIPROCATORS": "RECIPROCATOR, one who reciprocates [n]\n",
  "RECIPROCATORY": "of the nature of reciprocation [adj]\n",
  "RECIPROCITIES": "RECIPROCITY, the state of being reciprocal [n]\n",
  "RECIPROCITY": "the state of being reciprocal [n RECIPROCITIES]\n",
  "RECIRCLE": "to circle again [v RECIRCLED, RECIRCLING, RECIRCLES]\n",
  "RECIRCLED": "RECIRCLE, to circle again [v]\n",
  "RECIRCLES": "RECIRCLE, to circle again [v]\n",
  "RECIRCLING": "RECIRCLE, to circle again [v]\n",
  "RECIRCULATE": "to circulate again [v RECIRCULATED, RECIRCULATING, RECIRCULATES]\n",
  "RECIRCULATED": "RECIRCULATE, to circulate again [v]\n",
  "RECIRCULATES": "RECIRCULATE, to circulate again [v]\n",
  "RECIRCULATING": "RECIRCULATE, to circulate again [v]\n",
  "RECIRCULATION": "the act of recirculating [n -S]\n",
  "RECIRCULATIONS": "RECIRCULATION, the act of recirculating [n]\n",
  "RECISION": "a cancellation [n -S]\n",
  "RECISIONS": "RECISION, a cancellation [n]\n",
  "RECIT": "(French) the narrative of a book as opposed to the dialogue [n -S]\n",
  "RECITABLE": "that can be recited [adj]\n",
  "RECITAL": "a detailed account [n -S]\n",
  "RECITALIST": "one who gives recitals [n -S]\n",
  "RECITALISTS": "RECITALIST, one who gives recitals [n]\n",
  "RECITALS": "RECITAL, a detailed account [n]\n",
  "RECITATION": "the act of enumerating [n -S]\n",
  "RECITATIONIST": "a declaimer [n -S]\n",
  "RECITATIONISTS": "RECITATIONIST, a declaimer [n]\n",
  "RECITATIONS": "RECITATION, the act of enumerating [n]\n",
  "RECITATIVE": "a style of musical declamation, between singing and ordinary speech, used esp. in the dialogue and narrative parts of an opera or oratorio, also RECITATIVO [n -S]\n",
  "RECITATIVES": "RECITATIVE, a style of musical declamation, between singing and ordinary speech, used esp. in the dialogue and narrative parts of an opera or oratorio, also RECITATIVO [n]\n",
  "RECITATIVI": "RECITATIVO, (Italian) a style of musical declamation, between singing and ordinary speech, used esp. in the dialogue and narrative parts of an opera or oratorio, also RECITATIVE [n]\n",
  "RECITATIVO": "(Italian) a style of musical declamation, between singing and ordinary speech, used esp. in the dialogue and narrative parts of an opera or oratorio, also RECITATIVE [n RECITATIVI or RECITATIVOS]\n",
  "RECITATIVOS": "RECITATIVO, (Italian) a style of musical declamation, between singing and ordinary speech, used esp. in the dialogue and narrative parts of an opera or oratorio, also RECITATIVE [n]\n",
  "RECITE": "to say from memory [v RECITED, RECITING, RECITES]\n",
  "RECITED": "RECITE, to say from memory [v]\n",
  "RECITER": "one who recites [n -S]\n",
  "RECITERS": "RECITER, one who recites [n]\n",
  "RECITES": "RECITE, to say from memory [v]\n",
  "RECITING": "RECITE, to say from memory [v]\n",
  "RECITS": "RECIT, (French) the narrative of a book as opposed to the dialogue [n]\n",
  "RECK": "to be concerned about, also REAK, REKE [v ROUGHT or RECKED, RECKING, RECKS]\n",
  "RECKAN": "a chain, hook or bar for hanging a pot over a fire [n -S]\n",
  "RECKANS": "RECKAN, a chain, hook or bar for hanging a pot over a fire [n]\n",
  "RECKED": "RECK, to be concerned about, also REAK, REKE [v]\n",
  "RECKING": "RECK, to be concerned about, also REAK, REKE [v]\n",
  "RECKLESS": "foolishly heedless of danger [adj RECKLESSLY]\n",
  "RECKLESSLY": "RECKLESS, foolishly heedless of danger [adv]\n",
  "RECKLESSNESS": "the state of being reckless [n -ES]\n",
  "RECKLESSNESSES": "RECKLESSNESS, the state of being reckless [n]\n",
  "RECKLING": "(Old Norse) the runt of a litter [n -S]\n",
  "RECKLINGS": "RECKLING, (Old Norse) the runt of a litter [n]\n",
  "RECKON": "to count or compute [v -ED, -ING, -S]\n",
  "RECKONED": "RECKON, to count or compute [v]\n",
  "RECKONER": "one that reckons [n -S]\n",
  "RECKONERS": "RECKONER, one that reckons [n]\n",
  "RECKONING": "the act of reckoning [n -S]\n",
  "RECKONINGS": "RECKONING, the act of reckoning [n]\n",
  "RECKONS": "RECKON, to count or compute [v]\n",
  "RECKS": "RECK, to be concerned about, also REAK, REKE [v]\n",
  "RECLAD": "to clad again [v RECLADDED, RECLADDING, RECLADS]\n",
  "RECLADDED": "RECLAD, to clad again [v]\n",
  "RECLADDING": "RECLAD, to clad again [v]\n",
  "RECLADS": "RECLAD, to clad again [v]\n",
  "RECLAIM": "to make suitable for cultivation or habitation [v -ED, -ING, -S]\n",
  "RECLAIMABLE": "that can be reclaimed [adj RECLAIMABLY]\n",
  "RECLAIMABLY": "RECLAIMABLE, that can be reclaimed [adv]\n",
  "RECLAIMANT": "one who reclaims [n -S]\n",
  "RECLAIMANTS": "RECLAIMANT, one who reclaims [n]\n",
  "RECLAIMED": "RECLAIM, to make suitable for cultivation or habitation [v]\n",
  "RECLAIMER": "one who reclaims [n -S]\n",
  "RECLAIMERS": "RECLAIMER, one who reclaims [n]\n",
  "RECLAIMING": "RECLAIM, to make suitable for cultivation or habitation [v]\n",
  "RECLAIMS": "RECLAIM, to make suitable for cultivation or habitation [v]\n",
  "RECLAMATION": "the act of reclaiming [n -S]\n",
  "RECLAMATIONS": "RECLAMATION, the act of reclaiming [n]\n",
  "RECLAME": "(French) publicity [n -S]\n",
  "RECLAMES": "RECLAME, (French) publicity [n]\n",
  "RECLASP": "to clasp again [v -ED, -ING, -S]\n",
  "RECLASPED": "RECLASP, to clasp again [v]\n",
  "RECLASPING": "RECLASP, to clasp again [v]\n",
  "RECLASPS": "RECLASP, to clasp again [v]\n",
  "RECLASSIFIED": "RECLASSIFY, to classify again [v]\n",
  "RECLASSIFIES": "RECLASSIFY, to classify again [v]\n",
  "RECLASSIFY": "to classify again [v RECLASSIFIED, RECLASSIFYING, RECLASSIFIES]\n",
  "RECLASSIFYING": "RECLASSIFY, to classify again [v]\n",
  "RECLEAN": "to clean again [v -ED, -ING, -S]\n",
  "RECLEANED": "RECLEAN, to clean again [v]\n",
  "RECLEANING": "RECLEAN, to clean again [v]\n",
  "RECLEANS": "RECLEAN, to clean again [v]\n",
  "RECLIMB": "to climb again [v -ED, -ING, -S]\n",
  "RECLIMBED": "RECLIMB, to climb again [v]\n",
  "RECLIMBING": "RECLIMB, to climb again [v]\n",
  "RECLIMBS": "RECLIMB, to climb again [v]\n",
  "RECLINABLE": "of a chair, that can be leaned back [adj]\n",
  "RECLINATE": "bent down or back [adj]\n",
  "RECLINATION": "the act of reclining [n -S]\n",
  "RECLINATIONS": "RECLINATION, the act of reclining [n]\n",
  "RECLINE": "to lean or lie back [v RECLINED, RECLINING, RECLINES]\n",
  "RECLINED": "RECLINE, to lean or lie back [v]\n",
  "RECLINER": "a kind of couch [n -S]\n",
  "RECLINERS": "RECLINER, a kind of couch [n]\n",
  "RECLINES": "RECLINE, to lean or lie back [v]\n",
  "RECLINING": "RECLINE, to lean or lie back [v]\n",
  "RECLOSABLE": "capable of being closed again [adj]\n",
  "RECLOSE": "to close again [v RECLOSED, RECLOSING, RECLOSES]\n",
  "RECLOSED": "RECLOSE, to close again [v]\n",
  "RECLOSES": "RECLOSE, to close again [v]\n",
  "RECLOSING": "RECLOSE, to close again [v]\n",
  "RECLOTHE": "to dress again [v RECLOTHED or RECLAD, RECLOTHING, RECLOTHES]\n",
  "RECLOTHED": "RECLOTHE, to dress again [v]\n",
  "RECLOTHES": "RECLOTHE, to dress again [v]\n",
  "RECLOTHING": "RECLOTHE, to dress again [v]\n",
  "RECLUSE": "one who lives in solitude and seclusion [n -S]\n",
  "RECLUSELY": "like a recluse [adj]\n",
  "RECLUSENESS": "the state of being recluse [n -ES]\n",
  "RECLUSENESSES": "RECLUSENESS, the state of being recluse [n]\n",
  "RECLUSES": "RECLUSE, one who lives in solitude and seclusion [n]\n",
  "RECLUSION": "religious seclusion [n -S]\n",
  "RECLUSIONS": "RECLUSION, religious seclusion [n]\n",
  "RECLUSIVE": "solitary by nature [adj RECLUSIVELY]\n",
  "RECLUSIVELY": "RECLUSIVE, solitary by nature [adv]\n",
  "RECLUSIVENESS": "RECLUSIVE, solitary by nature [n]\n",
  "RECLUSIVENESSES": "RECLUSIVENESS, RECLUSIVE, solitary by nature [n]\n",
  "RECLUSORIES": "RECLUSORY, the habitation of a recluse; a hermitage [n]\n",
  "RECLUSORY": "the habitation of a recluse; a hermitage [n RECLUSORIES]\n",
  "RECOAL": "to refill with coal [v -ED, -ING, -S]\n",
  "RECOALED": "RECOAL, to refill with coal [v]\n",
  "RECOALING": "RECOAL, to refill with coal [v]\n",
  "RECOALS": "RECOAL, to refill with coal [v]\n",
  "RECOAT": "to coat again [v -ED, -ING, -S]\n",
  "RECOATED": "RECOAT, to coat again [v]\n",
  "RECOATING": "RECOAT, to coat again [v]\n",
  "RECOATS": "RECOAT, to coat again [v]\n",
  "RECOCK": "to cock again [v -ED, -ING, -S]\n",
  "RECOCKED": "RECOCK, to cock again [v]\n",
  "RECOCKING": "RECOCK, to cock again [v]\n",
  "RECOCKS": "RECOCK, to cock again [v]\n",
  "RECODE": "to code again [v RECODED, RECODING, RECODES]\n",
  "RECODED": "RECODE, to code again [v]\n",
  "RECODES": "RECODE, to code again [v]\n",
  "RECODIFICATION": "the act of recodifying [n -S]\n",
  "RECODIFICATIONS": "RECODIFICATION, the act of recodifying [n]\n",
  "RECODIFIED": "RECODIFY, to insert a new code [v]\n",
  "RECODIFIES": "RECODIFY, to insert a new code [v]\n",
  "RECODIFY": "to insert a new code [v RECODIFIED, RECODIFYING, RECODIFIES]\n",
  "RECODIFYING": "RECODIFY, to insert a new code [v]\n",
  "RECODING": "RECODE, to code again [v]\n",
  "RECOGNISABILITY": "the quality of being recognisable [n]\n",
  "RECOGNISABLE": "that can be recognised, also RECOGNIZABLE [adj RECOGNISABLY]\n",
  "RECOGNISABLY": "RECOGNISABLE, that can be recognised, also RECOGNIZABLE [adv]\n",
  "RECOGNISANCE": "a legal obligation entered into before a magistrate to do, or not to do, some particular act, also RECOGNIZANCE [n -S]\n",
  "RECOGNISANCES": "RECOGNISANCE, a legal obligation entered into before a magistrate to do, or not to do, some particular act, also RECOGNIZANCE [n]\n",
  "RECOGNISANT": "related to recognisance, also RECOGNIZANT [adj]\n",
  "RECOGNISE": "to identify as known or experienced before, also RECOGNIZE [v RECOGNISED, RECOGNISING, RECOGNISES]\n",
  "RECOGNISED": "RECOGNISE, to identify as known or experienced before, also RECOGNIZE [v]\n",
  "RECOGNISEE": "one who is recognised, also RECOGNIZEE [n -S]\n",
  "RECOGNISEES": "RECOGNISEE, one who is recognised, also RECOGNIZEE [n]\n",
  "RECOGNISER": "one who recognises, also RECOGNISOR, RECOGNIZER, RECOGNIZOR [n -S]\n",
  "RECOGNISERS": "RECOGNISER, one who recognises, also RECOGNISOR, RECOGNIZER, RECOGNIZOR [n]\n",
  "RECOGNISES": "RECOGNISE, to identify as known or experienced before, also RECOGNIZE [v]\n",
  "RECOGNISING": "RECOGNISE, to identify as known or experienced before, also RECOGNIZE [v]\n",
  "RECOGNISOR": "one who recognises, also RECOGNISER, RECOGNIZER, RECOGNIZOR [n -S]\n",
  "RECOGNISORS": "RECOGNISOR, one who recognises, also RECOGNISER, RECOGNIZER, RECOGNIZOR [n]\n",
  "RECOGNITION": "the act of recognising [n -S]\n",
  "RECOGNITIONS": "RECOGNITION, the act of recognising [n]\n",
  "RECOGNITIVE": "relating to recognition [adj]\n",
  "RECOGNITORY": "relating to recognition [adj]\n",
  "RECOGNIZABILITY": "the state of being recognizable [n]\n",
  "RECOGNIZABLE": "that can be recognized, also RECOGNISABLE [adj RECOGNIZABLY]\n",
  "RECOGNIZABLY": "RECOGNIZABLE, that can be recognized, also RECOGNISABLE [adv]\n",
  "RECOGNIZANCE": "a legal obligation entered into before a magistrate to do, or not to do, some particular act, also RECOGNISANCE [n -S]\n",
  "RECOGNIZANCES": "RECOGNIZANCE, a legal obligation entered into before a magistrate to do, or not to do, some particular act, also RECOGNISANCE [n]\n",
  "RECOGNIZANT": "related to recognizance, also RECOGNISANT [adj]\n",
  "RECOGNIZE": "to identify as known or experienced before, also RECOGNISE [v RECOGNIZED, RECOGNIZING, RECOGNIZES]\n",
  "RECOGNIZED": "RECOGNIZE, to identify as known or experienced before, also RECOGNISE [v]\n",
  "RECOGNIZEE": "one who is recognised, also RECOGNISEE [n -S]\n",
  "RECOGNIZEES": "RECOGNIZEE, one who is recognised, also RECOGNISEE [n]\n",
  "RECOGNIZER": "one who recognizes, also RECOGNISER, RECOGNISOR, RECOGNIZOR [n -S]\n",
  "RECOGNIZERS": "RECOGNIZER, one who recognizes, also RECOGNISER, RECOGNISOR, RECOGNIZOR [n]\n",
  "RECOGNIZES": "RECOGNIZE, to identify as known or experienced before, also RECOGNISE [v]\n",
  "RECOGNIZING": "RECOGNIZE, to identify as known or experienced before, also RECOGNISE [v]\n",
  "RECOGNIZOR": "one who recognises, also RECOGNISER, RECOGNISOR, RECOGNIZER [n -S]\n",
  "RECOGNIZORS": "RECOGNIZOR, one who recognises, also RECOGNISER, RECOGNISOR, RECOGNIZER [n]\n",
  "RECOIL": "to draw back in fear or disgust [v -ED, -ING, -S]\n",
  "RECOILED": "RECOIL, to draw back in fear or disgust [v]\n",
  "RECOILER": "one who, or that which, recoils [n -S]\n",
  "RECOILERS": "RECOILER, one who, or that which, recoils [n]\n",
  "RECOILING": "RECOIL, to draw back in fear or disgust [v]\n",
  "RECOILLESS": "without recoil (of a gun) [adj]\n",
  "RECOILS": "RECOIL, to draw back in fear or disgust [v]\n",
  "RECOIN": "to coin again [v -ED, -ING, -S]\n",
  "RECOINAGE": "the act of coining anew [n -S]\n",
  "RECOINAGES": "RECOINAGE, the act of coining anew [n]\n",
  "RECOINED": "RECOIN, to coin again [v]\n",
  "RECOINING": "RECOIN, to coin again [v]\n",
  "RECOINS": "RECOIN, to coin again [v]\n",
  "RECOLLECT": "to remember [v -ED, -ING, -S]\n",
  "RECOLLECTED": "RECOLLECT, to remember [v]\n",
  "RECOLLECTEDLY": "RECOLLECTED, RECOLLECT, to remember [adv]\n",
  "RECOLLECTEDNESS": "the state of being recollected [n]\n",
  "RECOLLECTING": "RECOLLECT, to remember [v]\n",
  "RECOLLECTION": "something remembered [n -S]\n",
  "RECOLLECTIONS": "RECOLLECTION, something remembered [n]\n",
  "RECOLLECTIVE": "of the nature of recollection [adj RECOLLECTIVELY]\n",
  "RECOLLECTIVELY": "RECOLLECTIVE, of the nature of recollection [adv]\n",
  "RECOLLECTS": "RECOLLECT, to remember [v]\n",
  "RECOLLET": "(French) a member of an order of Franciscan friars who cultivate detachment from the world [n -S]\n",
  "RECOLLETS": "RECOLLET, (French) a member of an order of Franciscan friars who cultivate detachment from the world [n]\n",
  "RECOLONISATION": "the act of recolonising, also RECOLONIZATION [n -S]\n",
  "RECOLONISATIONS": "RECOLONISATION, the act of recolonising, also RECOLONIZATION [n]\n",
  "RECOLONISE": "to colonise again, also RECOLONIZE [v RECOLONISED, RECOLONISING, RECOLONISES]\n",
  "RECOLONISED": "RECOLONISE, to colonise again, also RECOLONIZE [v]\n",
  "RECOLONISES": "RECOLONISE, to colonise again, also RECOLONIZE [v]\n",
  "RECOLONISING": "RECOLONISE, to colonise again, also RECOLONIZE [v]\n",
  "RECOLONIZATION": "the act of recolonizing, also RECOLONISATION [n -S]\n",
  "RECOLONIZATIONS": "RECOLONIZATION, the act of recolonizing, also RECOLONISATION [n]\n",
  "RECOLONIZE": "to colonize again, also RECOLONISE [v RECOLONIZED, RECOLONIZING, RECOLONIZES]\n",
  "RECOLONIZED": "RECOLONIZE, to colonize again, also RECOLONISE [v]\n",
  "RECOLONIZES": "RECOLONIZE, to colonize again, also RECOLONISE [v]\n",
  "RECOLONIZING": "RECOLONIZE, to colonize again, also RECOLONISE [v]\n",
  "RECOLOR": "to color again, also RECOLOUR [v -ED, -ING, -S]\n",
  "RECOLORED": "RECOLOR, to color again, also RECOLOUR [v]\n",
  "RECOLORING": "RECOLOR, to color again, also RECOLOUR [v]\n",
  "RECOLORS": "RECOLOR, to color again, also RECOLOUR [v]\n",
  "RECOLOUR": "to colour again, also RECOLOR [v -ED, -ING, -S]\n",
  "RECOLOURED": "RECOLOUR, to colour again, also RECOLOR [v]\n",
  "RECOLOURING": "RECOLOUR, to colour again, also RECOLOR [v]\n",
  "RECOLOURS": "RECOLOUR, to colour again, also RECOLOR [v]\n",
  "RECOMB": "to comb again [v -ED, -ING, -S]\n",
  "RECOMBED": "RECOMB, to comb again [v]\n",
  "RECOMBINANT": "a gene that recombines [n -S]\n",
  "RECOMBINANTS": "RECOMBINANT, a gene that recombines [n]\n",
  "RECOMBINATION": "the formation by the processes of crossing over and independent assortment of new combinations of genes in progeny that did not occur in the parents [n -S]\n",
  "RECOMBINATIONAL": "relating to recombination [adj]\n",
  "RECOMBINATIONS": "RECOMBINATION, the formation by the processes of crossing over and independent assortment of new combinations of genes in progeny that did not occur in the parents [n]\n",
  "RECOMBINE": "to combine again [v RECOMBINED, RECOMBINING, RECOMBINES]\n",
  "RECOMBINED": "RECOMBINE, to combine again [v]\n",
  "RECOMBINES": "RECOMBINE, to combine again [v]\n",
  "RECOMBING": "RECOMB, to comb again [v]\n",
  "RECOMBINING": "RECOMBINE, to combine again [v]\n",
  "RECOMBS": "RECOMB, to comb again [v]\n",
  "RECOMFORT": "(archaic) to comfort, console [v -ED, -ING, -S]\n",
  "RECOMFORTED": "RECOMFORT, (archaic) to comfort, console [v]\n",
  "RECOMFORTING": "RECOMFORT, (archaic) to comfort, console [v]\n",
  "RECOMFORTLESS": "(Spenser) comfortless [adj]\n",
  "RECOMFORTS": "RECOMFORT, (archaic) to comfort, console [v]\n",
  "RECOMFORTURE": "(Shakespeare) consolation [n -S]\n",
  "RECOMFORTURES": "RECOMFORTURE, (Shakespeare) consolation [n]\n",
  "RECOMMENCE": "to commence again [v RECOMMENCED, RECOMMENCING, RECOMMENCES]\n",
  "RECOMMENCED": "RECOMMENCE, to commence again [v]\n",
  "RECOMMENCEMENT": "a new beginning [n -S]\n",
  "RECOMMENCEMENTS": "RECOMMENCEMENT, a new beginning [n]\n",
  "RECOMMENCES": "RECOMMENCE, to commence again [v]\n",
  "RECOMMENCING": "RECOMMENCE, to commence again [v]\n",
  "RECOMMEND": "to commend or introduce as suitable for acceptance [v -ED, -ING, -S]\n",
  "RECOMMENDABLE": "worthy of recommendation [adj RECOMMENDABLY]\n",
  "RECOMMENDABLY": "RECOMMENDABLE, worthy of recommendation [adv]\n",
  "RECOMMENDATION": "the act of recommending [n -S]\n",
  "RECOMMENDATIONS": "RECOMMENDATION, the act of recommending [n]\n",
  "RECOMMENDATORY": "serving to recommend [adj]\n",
  "RECOMMENDED": "RECOMMEND, to commend or introduce as suitable for acceptance [v]\n",
  "RECOMMENDER": "one who recommends [n -S]\n",
  "RECOMMENDERS": "RECOMMENDER, one who recommends [n]\n",
  "RECOMMENDING": "RECOMMEND, to commend or introduce as suitable for acceptance [v]\n",
  "RECOMMENDS": "RECOMMEND, to commend or introduce as suitable for acceptance [v]\n",
  "RECOMMISSION": "to commission again [v -ED, -ING, -S]\n",
  "RECOMMISSIONED": "RECOMMISSION, to commission again [v]\n",
  "RECOMMISSIONING": "RECOMMISSION, to commission again [v]\n",
  "RECOMMISSIONS": "RECOMMISSION, to commission again [v]\n",
  "RECOMMIT": "to commit again [v RECOMMITTED, RECOMMITTING, RECOMMITS]\n",
  "RECOMMITMENT": "the act of recommitting [n -S]\n",
  "RECOMMITMENTS": "RECOMMITMENT, the act of recommitting [n]\n",
  "RECOMMITS": "RECOMMIT, to commit again [v]\n",
  "RECOMMITTAL": "the act of recommitting [n -S]\n",
  "RECOMMITTALS": "RECOMMITTAL, the act of recommitting [n]\n",
  "RECOMMITTED": "RECOMMIT, to commit again [v]\n",
  "RECOMMITTING": "RECOMMIT, to commit again [v]\n",
  "RECOMPACT": "to compact or join anew [v -ED, -ING, -S]\n",
  "RECOMPACTED": "RECOMPACT, to compact or join anew [v]\n",
  "RECOMPACTING": "RECOMPACT, to compact or join anew [v]\n",
  "RECOMPACTS": "RECOMPACT, to compact or join anew [v]\n",
  "RECOMPENCE": "(obsolete) a reward, a compensation, also RECOMPENSE [n -S]\n",
  "RECOMPENCES": "RECOMPENCE, (obsolete) a reward, a compensation, also RECOMPENSE [n]\n",
  "RECOMPENSABLE": "that can be recompensed [adj]\n",
  "RECOMPENSE": "to give something to by way of compensation (as for a service rendered or damage incurred), also RECOMPENCE [v RECOMPENSED, RECOMPENSING, RECOMPENSES]\n",
  "RECOMPENSED": "RECOMPENSE, to give something to by way of compensation (as for a service rendered or damage incurred), also RECOMPENCE [v]\n",
  "RECOMPENSER": "one who recompenses [n -S]\n",
  "RECOMPENSERS": "RECOMPENSER, one who recompenses [n]\n",
  "RECOMPENSES": "RECOMPENSE, to give something to by way of compensation (as for a service rendered or damage incurred), also RECOMPENCE [v]\n",
  "RECOMPENSING": "RECOMPENSE, to give something to by way of compensation (as for a service rendered or damage incurred), also RECOMPENCE [v]\n",
  "RECOMPILATION": "the act of recompiling [n -S]\n",
  "RECOMPILATIONS": "RECOMPILATION, the act of recompiling [n]\n",
  "RECOMPILE": "to compile again [v RECOMPILED, RECOMPILING, RECOMPILES]\n",
  "RECOMPILED": "RECOMPILE, to compile again [v]\n",
  "RECOMPILES": "RECOMPILE, to compile again [v]\n",
  "RECOMPILING": "RECOMPILE, to compile again [v]\n",
  "RECOMPOSE": "to compose again [v RECOMPOSED, RECOMPOSING, RECOMPOSES]\n",
  "RECOMPOSED": "RECOMPOSE, to compose again [v]\n",
  "RECOMPOSES": "RECOMPOSE, to compose again [v]\n",
  "RECOMPOSING": "RECOMPOSE, to compose again [v]\n",
  "RECOMPOSITION": "the act of recomposing [n -S]\n",
  "RECOMPOSITIONS": "RECOMPOSITION, the act of recomposing [n]\n",
  "RECOMPRESS": "to compress again [v -ED, -ING, -ES]\n",
  "RECOMPRESSED": "RECOMPRESS, to compress again [v]\n",
  "RECOMPRESSES": "RECOMPRESS, to compress again [v]\n",
  "RECOMPRESSING": "RECOMPRESS, to compress again [v]\n",
  "RECOMPRESSION": "a repeated compression [n -S]\n",
  "RECOMPRESSIONS": "RECOMPRESSION, a repeated compression [n]\n",
  "RECOMPUTATION": "the act of recomputing [n -S]\n",
  "RECOMPUTATIONS": "RECOMPUTATION, the act of recomputing [n]\n",
  "RECOMPUTE": "to compute again [v RECOMPUTED, RECOMPUTING, RECOMPUTES]\n",
  "RECOMPUTED": "RECOMPUTE, to compute again [v]\n",
  "RECOMPUTES": "RECOMPUTE, to compute again [v]\n",
  "RECOMPUTING": "RECOMPUTE, to compute again [v]\n",
  "RECON": "to conduct a preliminary survey [v RECONNED, RECONNING, RECONS]\n",
  "RECONCEIVE": "to conceive again [v RECONCEIVED, RECONCEIVING, RECONCEIVES]\n",
  "RECONCEIVED": "RECONCEIVE, to conceive again [v]\n",
  "RECONCEIVES": "RECONCEIVE, to conceive again [v]\n",
  "RECONCEIVING": "RECONCEIVE, to conceive again [v]\n",
  "RECONCENTRATE": "to concentrate again [v RECONCENTRATED, RECONCENTRATING, RECONCENTRATES]\n",
  "RECONCENTRATED": "RECONCENTRATE, to concentrate again [v]\n",
  "RECONCENTRATES": "RECONCENTRATE, to concentrate again [v]\n",
  "RECONCENTRATING": "RECONCENTRATE, to concentrate again [v]\n",
  "RECONCENTRATION": "the act of reconcentrating [n]\n",
  "RECONCEPTION": "the act of reconceiving [n -S]\n",
  "RECONCEPTIONS": "RECONCEPTION, the act of reconceiving [n]\n",
  "RECONCEPTUALISE": "to form a new concept of, also RECONCEPTUALIZE [v]\n",
  "RECONCEPTUALIZE": "to form a new concept of, also RECONCEPTUALISE [v]\n",
  "RECONCILABILITY": "the state of being reconcilable [n]\n",
  "RECONCILABLE": "capable of being reconciled [adj RECONCILABLY]\n",
  "RECONCILABLY": "RECONCILABLE, capable of being reconciled [adv]\n",
  "RECONCILE": "to restore or bring back to friendship or union [v RECONCILED, RECONCILING, RECONCILES]\n",
  "RECONCILED": "RECONCILE, to restore or bring back to friendship or union [v]\n",
  "RECONCILEMENT": "the act of reconciling [n -S]\n",
  "RECONCILEMENTS": "RECONCILEMENT, the act of reconciling [n]\n",
  "RECONCILER": "one who reconciles [n -S]\n",
  "RECONCILERS": "RECONCILER, one who reconciles [n]\n",
  "RECONCILES": "RECONCILE, to restore or bring back to friendship or union [v]\n",
  "RECONCILIATION": "the action of reconciling [n -S]\n",
  "RECONCILIATIONS": "RECONCILIATION, the action of reconciling [n]\n",
  "RECONCILIATORY": "relating to reconciliation [adj]\n",
  "RECONCILING": "RECONCILE, to restore or bring back to friendship or union [v]\n",
  "RECONDENSATION": "the act of recondensing [n -S]\n",
  "RECONDENSATIONS": "RECONDENSATION, the act of recondensing [n]\n",
  "RECONDENSE": "to condense again [v RECONDENSED, RECONDENSING, RECONDENSES]\n",
  "RECONDENSED": "RECONDENSE, to condense again [v]\n",
  "RECONDENSES": "RECONDENSE, to condense again [v]\n",
  "RECONDENSING": "RECONDENSE, to condense again [v]\n",
  "RECONDITE": "concealed; deep; having to do with something obscure [adj RECONDITELY]\n",
  "RECONDITELY": "RECONDITE, concealed; deep; having to do with something obscure [adv]\n",
  "RECONDITENESS": "the state of being recondite [n -ES]\n",
  "RECONDITENESSES": "RECONDITENESS, the state of being recondite [n]\n",
  "RECONDITION": "to restore to good condition [v -ED, -ING, -S]\n",
  "RECONDITIONED": "RECONDITION, to restore to good condition [v]\n",
  "RECONDITIONING": "RECONDITION, to restore to good condition [v]\n",
  "RECONDITIONS": "RECONDITION, to restore to good condition [v]\n",
  "RECONDUCT": "to conduct again [v -ED, -ING, -S]\n",
  "RECONDUCTED": "RECONDUCT, to conduct again [v]\n",
  "RECONDUCTING": "RECONDUCT, to conduct again [v]\n",
  "RECONDUCTS": "RECONDUCT, to conduct again [v]\n",
  "RECONFER": "to confer again [v RECONFERRED, RECONFERRING, RECONFERS]\n",
  "RECONFERRED": "RECONFER, to confer again [v]\n",
  "RECONFERRING": "RECONFER, to confer again [v]\n",
  "RECONFERS": "RECONFER, to confer again [v]\n",
  "RECONFIGURATION": "the act of reconfiguring [n]\n",
  "RECONFIGURE": "to configure again [v RECONFIGURED, RECONFIGURING, RECONFIGURES]\n",
  "RECONFIGURED": "RECONFIGURE, to configure again [v]\n",
  "RECONFIGURES": "RECONFIGURE, to configure again [v]\n",
  "RECONFIGURING": "RECONFIGURE, to configure again [v]\n",
  "RECONFINE": "to confine again [v RECONFINED, RECONFINING, RECONFINES]\n",
  "RECONFINED": "RECONFINE, to confine again [v]\n",
  "RECONFINES": "RECONFINE, to confine again [v]\n",
  "RECONFINING": "RECONFINE, to confine again [v]\n",
  "RECONFIRM": "to confirm anew [v -ED, -ING, -S]\n",
  "RECONFIRMATION": "the act of reconfirming [n -S]\n",
  "RECONFIRMATIONS": "RECONFIRMATION, the act of reconfirming [n]\n",
  "RECONFIRMED": "RECONFIRM, to confirm anew [v]\n",
  "RECONFIRMING": "RECONFIRM, to confirm anew [v]\n",
  "RECONFIRMS": "RECONFIRM, to confirm anew [v]\n",
  "RECONNAISSANCE": "a preliminary survey to gain information, also RECONNOISSANCE [n -S]\n",
  "RECONNAISSANCES": "RECONNAISSANCE, a preliminary survey to gain information, also RECONNOISSANCE [n]\n",
  "RECONNECT": "to connect again [v -ED, -ING, -S]\n",
  "RECONNECTED": "RECONNECT, to connect again [v]\n",
  "RECONNECTING": "RECONNECT, to connect again [v]\n",
  "RECONNECTION": "the act of reconnecting [n -S]\n",
  "RECONNECTIONS": "RECONNECTION, the act of reconnecting [n]\n",
  "RECONNECTS": "RECONNECT, to connect again [v]\n",
  "RECONNED": "RECON, to conduct a preliminary survey [v]\n",
  "RECONNING": "RECON, to conduct a preliminary survey [v]\n",
  "RECONNOISSANCE": "a preliminary survey to gain information, also RECONNAISSANCE [n -S]\n",
  "RECONNOISSANCES": "RECONNOISSANCE, a preliminary survey to gain information, also RECONNAISSANCE [n]\n",
  "RECONNOITER": "(US) to make a reconnaissance of, also RECONNOITRE [v -ED, -ING, -S]\n",
  "RECONNOITERED": "RECONNOITER, (US) to make a reconnaissance of, also RECONNOITRE [v]\n",
  "RECONNOITERER": "one who reconnoiters [n -S]\n",
  "RECONNOITERERS": "RECONNOITERER, one who reconnoiters [n]\n",
  "RECONNOITERING": "RECONNOITER, (US) to make a reconnaissance of, also RECONNOITRE [v]\n",
  "RECONNOITERS": "RECONNOITER, (US) to make a reconnaissance of, also RECONNOITRE [v]\n",
  "RECONNOITRE": "to make a reconnaissance of, also RECONNOITER [v RECONNOITRED, RECONNOITRING, RECONNOITRES]\n",
  "RECONNOITRED": "RECONNOITRE, to make a reconnaissance of, also RECONNOITER [v]\n",
  "RECONNOITRER": "one who reconnoiters [n -S]\n",
  "RECONNOITRERS": "RECONNOITRER, one who reconnoiters [n]\n",
  "RECONNOITRES": "RECONNOITRE, to make a reconnaissance of, also RECONNOITER [v]\n",
  "RECONNOITRING": "the act of conducting a reconnoitre [n -S]\n",
  "RECONNOITRINGS": "RECONNOITRING, the act of conducting a reconnoitre [n]\n",
  "RECONQUER": "to conquer again [v -ED, -ING, -S]\n",
  "RECONQUERED": "RECONQUER, to conquer again [v]\n",
  "RECONQUERING": "RECONQUER, to conquer again [v]\n",
  "RECONQUERS": "RECONQUER, to conquer again [v]\n",
  "RECONQUEST": "the act of conquering again [n -S]\n",
  "RECONQUESTS": "RECONQUEST, the act of conquering again [n]\n",
  "RECONS": "RECON, to conduct a preliminary survey [v]\n",
  "RECONSECRATE": "to consecrate again [v RECONSECRATED, RECONSECRATING, RECONSECRATES]\n",
  "RECONSECRATED": "RECONSECRATE, to consecrate again [v]\n",
  "RECONSECRATES": "RECONSECRATE, to consecrate again [v]\n",
  "RECONSECRATING": "RECONSECRATE, to consecrate again [v]\n",
  "RECONSECRATION": "the act of reconsecrating [n -S]\n",
  "RECONSECRATIONS": "RECONSECRATION, the act of reconsecrating [n]\n",
  "RECONSIDER": "to consider again esp. with a view to changing or reversing [v -ED, -ING, -S]\n",
  "RECONSIDERATION": "the act of reconsidering [n]\n",
  "RECONSIDERED": "RECONSIDER, to consider again esp. with a view to changing or reversing [v]\n",
  "RECONSIDERING": "RECONSIDER, to consider again esp. with a view to changing or reversing [v]\n",
  "RECONSIDERS": "RECONSIDER, to consider again esp. with a view to changing or reversing [v]\n",
  "RECONSIGN": "to consign again [v -ED, -ING, -S]\n",
  "RECONSIGNED": "RECONSIGN, to consign again [v]\n",
  "RECONSIGNING": "RECONSIGN, to consign again [v]\n",
  "RECONSIGNS": "RECONSIGN, to consign again [v]\n",
  "RECONSOLE": "to console again [v RECONSOLED, RECONSOLING, RECONSOLES]\n",
  "RECONSOLED": "RECONSOLE, to console again [v]\n",
  "RECONSOLES": "RECONSOLE, to console again [v]\n",
  "RECONSOLIDATE": "to consolidate again [v RECONSOLIDATED, RECONSOLIDATING, RECONSOLIDATES]\n",
  "RECONSOLIDATED": "RECONSOLIDATE, to consolidate again [v]\n",
  "RECONSOLIDATES": "RECONSOLIDATE, to consolidate again [v]\n",
  "RECONSOLIDATING": "RECONSOLIDATE, to consolidate again [v]\n",
  "RECONSOLIDATION": "the act of reconsolidating [n]\n",
  "RECONSOLING": "RECONSOLE, to console again [v]\n",
  "RECONSTITUENT": "something reconstituted [n -S]\n",
  "RECONSTITUENTS": "RECONSTITUENT, something reconstituted [n]\n",
  "RECONSTITUTABLE": "that can be reconstituted [adj]\n",
  "RECONSTITUTE": "to constitute again [v RECONSTITUTED, RECONSTITUTING, RECONSTITUTES]\n",
  "RECONSTITUTED": "RECONSTITUTE, to constitute again [v]\n",
  "RECONSTITUTES": "RECONSTITUTE, to constitute again [v]\n",
  "RECONSTITUTING": "RECONSTITUTE, to constitute again [v]\n",
  "RECONSTITUTION": "the act of reconstituting [n -S]\n",
  "RECONSTITUTIONS": "RECONSTITUTION, the act of reconstituting [n]\n",
  "RECONSTRUCT": "to construct again [v -ED, -ING, -S]\n",
  "RECONSTRUCTED": "RECONSTRUCT, to construct again [v]\n",
  "RECONSTRUCTIBLE": "capable of being reconstructed [adj]\n",
  "RECONSTRUCTING": "RECONSTRUCT, to construct again [v]\n",
  "RECONSTRUCTION": "the action of reconstructing [n -S]\n",
  "RECONSTRUCTIONS": "RECONSTRUCTION, the action of reconstructing [n]\n",
  "RECONSTRUCTIVE": "relating to reconstruction [adj]\n",
  "RECONSTRUCTOR": "one who reconstructs [n -S]\n",
  "RECONSTRUCTORS": "RECONSTRUCTOR, one who reconstructs [n]\n",
  "RECONSTRUCTS": "RECONSTRUCT, to construct again [v]\n",
  "RECONSULT": "to consult again [v -ED, -ING, -S]\n",
  "RECONSULTED": "RECONSULT, to consult again [v]\n",
  "RECONSULTING": "RECONSULT, to consult again [v]\n",
  "RECONSULTS": "RECONSULT, to consult again [v]\n",
  "RECONTACT": "to contact again [v -ED, -ING, -S]\n",
  "RECONTACTED": "RECONTACT, to contact again [v]\n",
  "RECONTACTING": "RECONTACT, to contact again [v]\n",
  "RECONTACTS": "RECONTACT, to contact again [v]\n",
  "RECONTAMINATE": "to contaminate again [v RECONTAMINATED, RECONTAMINATING, RECONTAMINATES]\n",
  "RECONTAMINATED": "RECONTAMINATE, to contaminate again [v]\n",
  "RECONTAMINATES": "RECONTAMINATE, to contaminate again [v]\n",
  "RECONTAMINATING": "RECONTAMINATE, to contaminate again [v]\n",
  "RECONTAMINATION": "the act of recontaminating [n]\n",
  "RECONTEXTUALISE": "to contextualise again, also RECONTEXTUALIZE [v]\n",
  "RECONTEXTUALIZE": "to place (as a literary or artistic work) in a different context, also RECONTEXTUALISE [v]\n",
  "RECONTINUE": "to continue anew [v RECONTINUED, RECONTINUING, RECONTINUES]\n",
  "RECONTINUED": "RECONTINUE, to continue anew [v]\n",
  "RECONTINUES": "RECONTINUE, to continue anew [v]\n",
  "RECONTINUING": "RECONTINUE, to continue anew [v]\n",
  "RECONTOUR": "to contour again [v -ED, -ING, -S]\n",
  "RECONTOURED": "RECONTOUR, to contour again [v]\n",
  "RECONTOURING": "RECONTOUR, to contour again [v]\n",
  "RECONTOURS": "RECONTOUR, to contour again [v]\n",
  "RECONVALESCE": "to convalesce again [v RECONVALESCED, RECONVALESCING, RECONVALESCES]\n",
  "RECONVALESCED": "RECONVALESCE, to convalesce again [v]\n",
  "RECONVALESCENCE": "(archaic) recovery from illness [n]\n",
  "RECONVALESCENT": "in a state of convalescing again [adj]\n",
  "RECONVALESCES": "RECONVALESCE, to convalesce again [v]\n",
  "RECONVALESCING": "RECONVALESCE, to convalesce again [v]\n",
  "RECONVENE": "to convene again [v RECONVENED, RECONVENING, RECONVENES]\n",
  "RECONVENED": "RECONVENE, to convene again [v]\n",
  "RECONVENES": "RECONVENE, to convene again [v]\n",
  "RECONVENING": "RECONVENE, to convene again [v]\n",
  "RECONVERSION": "the act of reconverting [n -S]\n",
  "RECONVERSIONS": "RECONVERSION, the act of reconverting [n]\n",
  "RECONVERT": "to convert again [v -ED, -ING, -S]\n",
  "RECONVERTED": "RECONVERT, to convert again [v]\n",
  "RECONVERTING": "RECONVERT, to convert again [v]\n",
  "RECONVERTS": "RECONVERT, to convert again [v]\n",
  "RECONVEY": "to convey back to a previous position [v -ED, -ING, -S]\n",
  "RECONVEYANCE": "the act of reconveying [n -S]\n",
  "RECONVEYANCES": "RECONVEYANCE, the act of reconveying [n]\n",
  "RECONVEYED": "RECONVEY, to convey back to a previous position [v]\n",
  "RECONVEYING": "RECONVEY, to convey back to a previous position [v]\n",
  "RECONVEYS": "RECONVEY, to convey back to a previous position [v]\n",
  "RECONVICT": "to convict again [v -ED, -ING, -S]\n",
  "RECONVICTED": "RECONVICT, to convict again [v]\n",
  "RECONVICTING": "RECONVICT, to convict again [v]\n",
  "RECONVICTION": "a fresh conviction [n -S]\n",
  "RECONVICTIONS": "RECONVICTION, a fresh conviction [n]\n",
  "RECONVICTS": "RECONVICT, to convict again [v]\n",
  "RECONVINCE": "to convince again [v RECONVINCED, RECONVINCING, RECONVINCES]\n",
  "RECONVINCED": "RECONVINCE, to convince again [v]\n",
  "RECONVINCES": "RECONVINCE, to convince again [v]\n",
  "RECONVINCING": "RECONVINCE, to convince again [v]\n",
  "RECOOK": "to cook again [v -ED, -ING, -S]\n",
  "RECOOKED": "RECOOK, to cook again [v]\n",
  "RECOOKING": "RECOOK, to cook again [v]\n",
  "RECOOKS": "RECOOK, to cook again [v]\n",
  "RECOPIED": "RECOPY, to copy again [v]\n",
  "RECOPIES": "RECOPY, to copy again [v]\n",
  "RECOPY": "to copy again [v RECOPIED, RECOPYING, RECOPIES]\n",
  "RECOPYING": "RECOPY, to copy again [v]\n",
  "RECORD": "to register in writing [v -ED, -ING, -S]\n",
  "RECORDABLE": "that can be recorded [adj]\n",
  "RECORDATION": "remembrance, recording [n -S]\n",
  "RECORDATIONS": "RECORDATION, remembrance, recording [n]\n",
  "RECORDED": "RECORD, to register in writing [v]\n",
  "RECORDER": "one that records [n -S]\n",
  "RECORDERS": "RECORDER, one that records [n]\n",
  "RECORDERSHIP": "the office of recorder [n -S]\n",
  "RECORDERSHIPS": "RECORDERSHIP, the office of recorder [n]\n",
  "RECORDING": "a record of sound or images made for later reproduction [n -S]\n",
  "RECORDINGS": "RECORDING, a record of sound or images made for later reproduction [n]\n",
  "RECORDIST": "a person who records esp. for a cinema film [n -S]\n",
  "RECORDISTS": "RECORDIST, a person who records esp. for a cinema film [n]\n",
  "RECORDS": "RECORD, to register in writing [v]\n",
  "RECORK": "to cork again [v -ED, -ING, -S]\n",
  "RECORKED": "RECORK, to cork again [v]\n",
  "RECORKING": "RECORK, to cork again [v]\n",
  "RECORKS": "RECORK, to cork again [v]\n",
  "RECOUNT": "to relate in detail [v -ED, -ING, -S]\n",
  "RECOUNTAL": "the act of recounting [n -S]\n",
  "RECOUNTALS": "RECOUNTAL, the act of recounting [n]\n",
  "RECOUNTED": "RECOUNT, to relate in detail [v]\n",
  "RECOUNTER": "one who recounts [n -S]\n",
  "RECOUNTERS": "RECOUNTER, one who recounts [n]\n",
  "RECOUNTING": "RECOUNT, to relate in detail [v]\n",
  "RECOUNTMENT": "(Shakespeare) relation in detail [n -S]\n",
  "RECOUNTMENTS": "RECOUNTMENT, (Shakespeare) relation in detail [n]\n",
  "RECOUNTS": "RECOUNT, to relate in detail [v]\n",
  "RECOUP": "to get back the equivalent of [v -ED, -ING, -S]\n",
  "RECOUPABLE": "that can be recouped [adj]\n",
  "RECOUPE": "the act of keeping back or withholding something which is legally due to someone [n -S]\n",
  "RECOUPED": "RECOUP, to get back the equivalent of [v]\n",
  "RECOUPES": "RECOUPE, the act of keeping back or withholding something which is legally due to someone [n]\n",
  "RECOUPING": "RECOUP, to get back the equivalent of [v]\n",
  "RECOUPLE": "to couple again [v RECOUPLED, RECOUPLING, RECOUPLES]\n",
  "RECOUPLED": "RECOUPLE, to couple again [v]\n",
  "RECOUPLES": "RECOUPLE, to couple again [v]\n",
  "RECOUPLING": "RECOUPLE, to couple again [v]\n",
  "RECOUPMENT": "the act of recouping [n -S]\n",
  "RECOUPMENTS": "RECOUPMENT, the act of recouping [n]\n",
  "RECOUPS": "RECOUP, to get back the equivalent of [v]\n",
  "RECOURE": "(Spenser) to recover, also RECOWER [v RECOURED, RECOURING, RECOURES]\n",
  "RECOURED": "RECOURE, (Spenser) to recover, also RECOWER [v]\n",
  "RECOURES": "RECOURE, (Spenser) to recover, also RECOWER [v]\n",
  "RECOURING": "RECOURE, (Spenser) to recover, also RECOWER [v]\n",
  "RECOURSE": "to return, go back, revert [v RECOURSED, RECOURSING, RECOURSES]\n",
  "RECOURSED": "RECOURSE, to return, go back, revert [v]\n",
  "RECOURSES": "RECOURSE, to return, go back, revert [v]\n",
  "RECOURSING": "RECOURSE, to return, go back, revert [v]\n",
  "RECOVER": "to obtain again after losing, also RECOURE, RECOWER [v -ED, -ING, -S]\n",
  "RECOVERABILITY": "the state of being recoverable [n]\n",
  "RECOVERABLE": "that can be recovered [adj]\n",
  "RECOVERABLENESS": "the state of being recoverable [n]\n",
  "RECOVERED": "RECOVER, to obtain again after losing, also RECOURE, RECOWER [v]\n",
  "RECOVEREE": "the person against whom a judgment is obtained in common recovery [n -S]\n",
  "RECOVEREES": "RECOVEREE, the person against whom a judgment is obtained in common recovery [n]\n",
  "RECOVERER": "one who recovers [n -S]\n",
  "RECOVERERS": "RECOVERER, one who recovers [n]\n",
  "RECOVERIES": "RECOVERY, an economic upturn [n]\n",
  "RECOVERING": "RECOVER, to obtain again after losing, also RECOURE, RECOWER [v]\n",
  "RECOVEROR": "the demandant in a common recovery after judgment [n -S]\n",
  "RECOVERORS": "RECOVEROR, the demandant in a common recovery after judgment [n]\n",
  "RECOVERS": "RECOVER, to obtain again after losing, also RECOURE, RECOWER [v]\n",
  "RECOVERY": "an economic upturn [n RECOVERIES]\n",
  "RECOWER": "(Spenser) to recover, also RECOURE [v -ED, -ING, -S]\n",
  "RECOWERED": "RECOWER, (Spenser) to recover, also RECOURE [v]\n",
  "RECOWERING": "RECOWER, (Spenser) to recover, also RECOURE [v]\n",
  "RECOWERS": "RECOWER, (Spenser) to recover, also RECOURE [v]\n",
  "RECOYLE": "(Spenser) to recoil, force back, also RECUILE, RECULE, REQUOYLE [v RECOYLED, RECOYLING, RECOYLES]\n",
  "RECOYLED": "RECOYLE, (Spenser) to recoil, force back, also RECUILE, RECULE, REQUOYLE [v]\n",
  "RECOYLES": "RECOYLE, (Spenser) to recoil, force back, also RECUILE, RECULE, REQUOYLE [v]\n",
  "RECOYLING": "RECOYLE, (Spenser) to recoil, force back, also RECUILE, RECULE, REQUOYLE [v]\n",
  "RECRATE": "to crate again [v RECRATED, RECRATING, RECRATES]\n",
  "RECRATED": "RECRATE, to crate again [v]\n",
  "RECRATES": "RECRATE, to crate again [v]\n",
  "RECRATING": "RECRATE, to crate again [v]\n",
  "RECREANCE": "mean-spiritedness; apostasy; treachery, also RECREANCY [n -S]\n",
  "RECREANCES": "RECREANCE, mean-spiritedness; apostasy; treachery, also RECREANCY [n]\n",
  "RECREANCIES": "RECREANCY, the state of being a recreant, also RECREANCE [n]\n",
  "RECREANCY": "the state of being a recreant, also RECREANCE [n RECREANCIES]\n",
  "RECREANT": "(archaic) cowardly, apostate [adj RECREANTLY] / a coward; an apostate [n -S]\n",
  "RECREANTLY": "RECREANT, (archaic) cowardly, apostate [adv]\n",
  "RECREANTS": "RECREANT, a coward; an apostate [n]\n",
  "RECREATE": "to reinvigorate [v RECREATED, RECREATING, RECREATES]\n",
  "RECREATED": "RECREATE, to reinvigorate [v]\n",
  "RECREATES": "RECREATE, to reinvigorate [v]\n",
  "RECREATING": "RECREATE, to reinvigorate [v]\n",
  "RECREATION": "refreshment of strength and spirits after work [n -S]\n",
  "RECREATIONAL": "of, relating to, or characteristic of recreation [adj RECREATIONALLY]\n",
  "RECREATIONALLY": "RECREATIONAL, of, relating to, or characteristic of recreation [adv]\n",
  "RECREATIONIST": "a person who seeks recreation esp. in the outdoors [n -S]\n",
  "RECREATIONISTS": "RECREATIONIST, a person who seeks recreation esp. in the outdoors [n]\n",
  "RECREATIONS": "RECREATION, refreshment of strength and spirits after work [n]\n",
  "RECREATIVE": "tending to recreate or refresh [adj RECREATIVELY]\n",
  "RECREATIVELY": "RECREATIVE, tending to recreate or refresh [adv]\n",
  "RECREATOR": "one who recreates [n -S]\n",
  "RECREATORS": "RECREATOR, one who recreates [n]\n",
  "RECREMENT": "a waste product of an organism [n -S]\n",
  "RECREMENTAL": "relating to recrement, a secretion of the body absorbed again by the body [adj]\n",
  "RECREMENTITIAL": "of or like recrement, waste, dross, also RECREMENTITIOUS [adj]\n",
  "RECREMENTITIOUS": "of or like recrement, waste, dross, also RECREMENTITIAL [adj]\n",
  "RECREMENTS": "RECREMENT, a waste product of an organism [n]\n",
  "RECRIMINATE": "to charge one's accuser [v RECRIMINATED, RECRIMINATING, RECRIMINATES]\n",
  "RECRIMINATED": "RECRIMINATE, to charge one's accuser [v]\n",
  "RECRIMINATES": "RECRIMINATE, to charge one's accuser [v]\n",
  "RECRIMINATING": "RECRIMINATE, to charge one's accuser [v]\n",
  "RECRIMINATION": "a retaliatory accusation [n -S]\n",
  "RECRIMINATIONS": "RECRIMINATION, a retaliatory accusation [n]\n",
  "RECRIMINATIVE": "relating to recrimination [adj]\n",
  "RECRIMINATOR": "one who recriminates [n -S]\n",
  "RECRIMINATORS": "RECRIMINATOR, one who recriminates [n]\n",
  "RECRIMINATORY": "relating to recrimination [adj]\n",
  "RECROSS": "to cross again [v -ED, -ING, -ES]\n",
  "RECROSSED": "RECROSS, to cross again [v]\n",
  "RECROSSES": "RECROSS, to cross again [v]\n",
  "RECROSSING": "RECROSS, to cross again [v]\n",
  "RECROWN": "to crown again [v -ED, -ING, -S]\n",
  "RECROWNED": "RECROWN, to crown again [v]\n",
  "RECROWNING": "RECROWN, to crown again [v]\n",
  "RECROWNS": "RECROWN, to crown again [v]\n",
  "RECRUDESCE": "of a disease, sore, or hostile feeling, to break out again [v RECRUDESCED, RECRUDESCING, RECRUDESCES]\n",
  "RECRUDESCED": "RECRUDESCE, of a disease, sore, or hostile feeling, to break out again [v]\n",
  "RECRUDESCENCE": "a new outbreak after a dormant period, also RECRUDESCENCY [n -S]\n",
  "RECRUDESCENCES": "RECRUDESCENCE, a new outbreak after a dormant period, also RECRUDESCENCY [n]\n",
  "RECRUDESCENCIES": "RECRUDESCENCY, a new outbreak after a dormant period, also RECRUDESCENCE [n]\n",
  "RECRUDESCENCY": "a new outbreak after a dormant period, also RECRUDESCENCE [n RECRUDESCENCIES]\n",
  "RECRUDESCENT": "breaking out again [adj]\n",
  "RECRUDESCES": "RECRUDESCE, of a disease, sore, or hostile feeling, to break out again [v]\n",
  "RECRUDESCING": "RECRUDESCE, of a disease, sore, or hostile feeling, to break out again [v]\n",
  "RECRUIT": "to enlist for military service [v -ED, -ING, -S]\n",
  "RECRUITABLE": "that can be recruited [adj]\n",
  "RECRUITAL": "the act of recruiting [n -S]\n",
  "RECRUITALS": "RECRUITAL, the act of recruiting [n]\n",
  "RECRUITED": "RECRUIT, to enlist for military service [v]\n",
  "RECRUITER": "one who recruits [n -S]\n",
  "RECRUITERS": "RECRUITER, one who recruits [n]\n",
  "RECRUITING": "the act of looking for recruits [n -S]\n",
  "RECRUITINGS": "RECRUITING, the act of looking for recruits [n]\n",
  "RECRUITMENT": "the act of recruiting [n -S]\n",
  "RECRUITMENTS": "RECRUITMENT, the act of recruiting [n]\n",
  "RECRUITS": "RECRUIT, to enlist for military service [v]\n",
  "RECRYSTALLISE": "to crystallise again, also RECRYSTALLIZE [v RECRYSTALLISED, RECRYSTALLISES]\n",
  "RECRYSTALLISED": "RECRYSTALLISE, to crystallise again, also RECRYSTALLIZE [v]\n",
  "RECRYSTALLISES": "RECRYSTALLISE, to crystallise again, also RECRYSTALLIZE [v]\n",
  "RECRYSTALLISING": "RECRYSTALLISE, to crystallise again, also RECRYSTALLIZE [v]\n",
  "RECRYSTALLIZE": "to crystallize again, also RECRYSTALLISE [v RECRYSTALLIZED, RECRYSTALLIZING, RECRYSTALLIZES]\n",
  "RECRYSTALLIZED": "RECRYSTALLIZE, to crystallize again, also RECRYSTALLISE [v]\n",
  "RECRYSTALLIZES": "RECRYSTALLIZE, to crystallize again, also RECRYSTALLISE [v]\n",
  "RECRYSTALLIZING": "RECRYSTALLIZE, to crystallize again, also RECRYSTALLISE [v]\n",
  "RECS": "REC, a recreation ground [n]\n",
  "RECTA": "RECTUM, (Latin) the terminal portion of the large intestine [n]\n",
  "RECTAL": "pertaining to the rectum [adj]\n",
  "RECTALLY": "by way of the rectum [adv]\n",
  "RECTANGLE": "a four-sided plane figure with all its angles right angles, esp. one with unequal adjacent sides [n -S]\n",
  "RECTANGLED": "rectangular [adj]\n",
  "RECTANGLES": "RECTANGLE, a four-sided plane figure with all its angles right angles, esp. one with unequal adjacent sides [n]\n",
  "RECTANGULAR": "shaped like a rectangle [adj RECTANGULARLY]\n",
  "RECTANGULARITY": "the state of being rectangular [n]\n",
  "RECTANGULARLY": "RECTANGULAR, shaped like a rectangle [adv]\n",
  "RECTI": "RECTUS, (Latin) any one of several straight muscles in the body [n]\n",
  "RECTIFIABILITY": "the state of being rectifiable [n]\n",
  "RECTIFIABLE": "having finite length [adj]\n",
  "RECTIFICATION": "the act of rectifying [n -S]\n",
  "RECTIFICATIONS": "RECTIFICATION, the act of rectifying [n]\n",
  "RECTIFIED": "RECTIFY, to correct, put right [v]\n",
  "RECTIFIER": "a person who rectifies (esp. alcohol) [n -S]\n",
  "RECTIFIERS": "RECTIFIER, a person who rectifies (esp. alcohol) [n]\n",
  "RECTIFIES": "RECTIFY, to correct, put right [v]\n",
  "RECTIFY": "to correct, put right [v RECTIFIED, RECTIFYING, RECTIFIES]\n",
  "RECTIFYING": "RECTIFY, to correct, put right [v]\n",
  "RECTILINEAL": "moving in or forming a straight line, also RECTILINEAR [adj RECTILINEALLY]\n",
  "RECTILINEALLY": "RECTILINEAL, moving in or forming a straight line, also RECTILINEAR [adv]\n",
  "RECTILINEAR": "moving in or forming a straight line, also RECTILINEAL [adj RECTILINEARLY]\n",
  "RECTILINEARITY": "the state of being rectilinear [n]\n",
  "RECTILINEARLY": "RECTILINEAR, moving in or forming a straight line, also RECTILINEAL [adv]\n",
  "RECTION": "syntactical government, i.e. the influence of one word over another in determining the case of a noun, the mood of a verb, etc. [n -S]\n",
  "RECTIONS": "RECTION, syntactical government, i.e. the influence of one word over another in determining the case of a noun, the mood of a verb, etc. [n]\n",
  "RECTIPETALIES": "RECTIPETALY, the tendency to grow in a straight line, also RECTIPETALITY [n]\n",
  "RECTIPETALITIES": "RECTIPETALITY, the tendency to grow in a straight line, also RECTIPETALY [n]\n",
  "RECTIPETALITY": "the tendency to grow in a straight line, also RECTIPETALY [n RECTIPETALITIES]\n",
  "RECTIPETALY": "the tendency to grow in a straight line, also RECTIPETALITY [n RECTIPETALIES]\n",
  "RECTIROSTRAL": "having straight beak [adj]\n",
  "RECTISERIAL": "in vertical ranks [adj]\n",
  "RECTITIC": "of the rectum [adj]\n",
  "RECTITIS": "inflammation of the rectum [n -ES]\n",
  "RECTITISES": "RECTITIS, inflammation of the rectum [n]\n",
  "RECTITUDE": "rightness, integrity [n -S]\n",
  "RECTITUDES": "RECTITUDE, rightness, integrity [n]\n",
  "RECTITUDINOUS": "characterized by straightness or moral integrity; piously self-righteous [adj]\n",
  "RECTO": "(Latin) a right-hand page of a book [n -S]\n",
  "RECTOCELE": "the herniation of the rectum into the vagina [n -S]\n",
  "RECTOCELES": "RECTOCELE, the herniation of the rectum into the vagina [n]\n",
  "RECTOR": "in the Church of England, a clergyman of a parish where the tithes were formerly paid to the incumbent [n -S]\n",
  "RECTORAL": "pertaining to a rector or governor [adj]\n",
  "RECTORATE": "the office of rector, also RECTORSHIP [n -S]\n",
  "RECTORATES": "RECTORATE, the office of rector, also RECTORSHIP [n]\n",
  "RECTORESS": "a female rector, a rector's wife, also RECTRESS [n -ES]\n",
  "RECTORESSES": "RECTORESS, a female rector, a rector's wife, also RECTRESS [n]\n",
  "RECTORIAL": "pertaining to a rector or a rectory [adj] / at a Scottish university, a rectorial election [n -S]\n",
  "RECTORIALS": "RECTORIAL, at a Scottish university, a rectorial election [n]\n",
  "RECTORIES": "RECTORY, a rector's dwelling [n]\n",
  "RECTORS": "RECTOR, in the Church of England, a clergyman of a parish where the tithes were formerly paid to the incumbent [n]\n",
  "RECTORSHIP": "the office of rector, also RECTORATE [n -S]\n",
  "RECTORSHIPS": "RECTORSHIP, the office of rector, also RECTORATE [n]\n",
  "RECTORY": "a rector's dwelling [n RECTORIES]\n",
  "RECTOS": "RECTO, (Latin) a right-hand page of a book [n]\n",
  "RECTRESS": "a female rector, a rector's wife, also RECTORESS [n -ES]\n",
  "RECTRESSES": "RECTRESS, a female rector, a rector's wife, also RECTORESS [n]\n",
  "RECTRICES": "RECTRIX, (Latin) a feather of a bird's tail [n]\n",
  "RECTRICIAL": "relating to rectrices [adj]\n",
  "RECTRIX": "(Latin) a feather of a bird's tail [n RECTRICES]\n",
  "RECTUM": "(Latin) the terminal portion of the large intestine [n RECTUMS or RECTA]\n",
  "RECTUMS": "RECTUM, (Latin) the terminal portion of the large intestine [n]\n",
  "RECTUS": "(Latin) any one of several straight muscles in the body [n RECTI]\n",
  "RECUILE": "(Spenser) to recoil, also RECOYLE, RECULE, REQUOYLE [v RECUILED, RECUILING, RECUILES]\n",
  "RECUILED": "RECUILE, (Spenser) to recoil, also RECOYLE, RECULE, REQUOYLE [v]\n",
  "RECUILES": "RECUILE, (Spenser) to recoil, also RECOYLE, RECULE, REQUOYLE [v]\n",
  "RECUILING": "RECUILE, (Spenser) to recoil, also RECOYLE, RECULE, REQUOYLE [v]\n",
  "RECULE": "(Spenser) to recoil, also RECOYLE, RECUILE, REQUOYLE [v RECULED, RECULING, RECULES]\n",
  "RECULED": "RECULE, (Spenser) to recoil, also RECOYLE, RECUILE, REQUOYLE [v]\n",
  "RECULES": "RECULE, (Spenser) to recoil, also RECOYLE, RECUILE, REQUOYLE [v]\n",
  "RECULING": "RECULE, (Spenser) to recoil, also RECOYLE, RECUILE, REQUOYLE [v]\n",
  "RECULTIVATE": "to cultivate again [v RECULTIVATED, RECULTIVATING, RECULTIVATES]\n",
  "RECULTIVATED": "RECULTIVATE, to cultivate again [v]\n",
  "RECULTIVATES": "RECULTIVATE, to cultivate again [v]\n",
  "RECULTIVATING": "RECULTIVATE, to cultivate again [v]\n",
  "RECUMBENCE": "the state of being recumbent, also RECUMBENCY [n -S]\n",
  "RECUMBENCES": "RECUMBENCE, the state of being recumbent, also RECUMBENCY [n]\n",
  "RECUMBENCIES": "RECUMBENCY, the state of being recumbent, also RECUMBENCE [n]\n",
  "RECUMBENCY": "the state of being recumbent, also RECUMBENCE [n RECUMBENCIES]\n",
  "RECUMBENT": "reclining; lying comfortably [adj RECUMBENTLY]\n",
  "RECUMBENTLY": "RECUMBENT, reclining; lying comfortably [adv]\n",
  "RECUPERABLE": "that can be recuperated [adj]\n",
  "RECUPERATE": "to get back, recover [v RECUPERATED, RECUPERATING, RECUPERATES]\n",
  "RECUPERATED": "RECUPERATE, to get back, recover [v]\n",
  "RECUPERATES": "RECUPERATE, to get back, recover [v]\n",
  "RECUPERATING": "RECUPERATE, to get back, recover [v]\n",
  "RECUPERATION": "the act of recuperating [n -S]\n",
  "RECUPERATIONS": "RECUPERATION, the act of recuperating [n]\n",
  "RECUPERATIVE": "of or relating to recuperation [adj]\n",
  "RECUPERATOR": "an arrangement by which something lost is regained, such as the heat of waste gases in a furnace [n -S]\n",
  "RECUPERATORS": "RECUPERATOR, an arrangement by which something lost is regained, such as the heat of waste gases in a furnace [n]\n",
  "RECUPERATORY": "assisting in recuperation [adj]\n",
  "RECUR": "to come around at intervals [v RECURRED, RECURRING, RECURS]\n",
  "RECURE": "to cure again [v RECURED, RECURING, RECURES]\n",
  "RECURED": "RECURE, to cure again [v]\n",
  "RECURELESS": "(obsolete) incurable [adj]\n",
  "RECURES": "RECURE, to cure again [v]\n",
  "RECURING": "RECURE, to cure again [v]\n",
  "RECURRED": "RECUR, to come around at intervals [v]\n",
  "RECURRENCE": "the act of recurring, also RECURRENCY [n -S]\n",
  "RECURRENCES": "RECURRENCE, the act of recurring, also RECURRENCY [n]\n",
  "RECURRENCIES": "RECURRENCY, the act of recurring, also RECURRENCE [n]\n",
  "RECURRENCY": "the act of recurring, also RECURRENCE [n RECURRENCIES]\n",
  "RECURRENT": "happening again and again [adj RECURRENTLY]\n",
  "RECURRENTLY": "RECURRENT, happening again and again [adv]\n",
  "RECURRING": "RECUR, to come around at intervals [v]\n",
  "RECURRINGLY": "RECURRING, RECUR, to come around at intervals [adv]\n",
  "RECURS": "RECUR, to come around at intervals [v]\n",
  "RECURSION": "the application or use of a recursive procedure or definition [n -S]\n",
  "RECURSIONS": "RECURSION, the application or use of a recursive procedure or definition [n]\n",
  "RECURSIVE": "involving or designating a repeated procedure such that the required result at each step except the last is given in terms of the result(s) of the next step [adj RECURSIVELY]\n",
  "RECURSIVELY": "RECURSIVE, involving or designating a repeated procedure such that the required result at each step except the last is given in terms of the result(s) of the next step [adv]\n",
  "RECURSIVENESS": "the state of being recursive [n -ES]\n",
  "RECURSIVENESSES": "RECURSIVENESS, the state of being recursive [n]\n",
  "RECURVATE": "bent back [adj]\n",
  "RECURVE": "to bend back [v RECURVED, RECURVING, RECURVES]\n",
  "RECURVED": "RECURVE, to bend back [v]\n",
  "RECURVES": "RECURVE, to bend back [v]\n",
  "RECURVING": "RECURVE, to bend back [v]\n",
  "RECURVIROSTRAL": "with up-bent bill [adj]\n",
  "RECUSAL": "a disqualification of oneself as a judge [n -S]\n",
  "RECUSALS": "RECUSAL, a disqualification of oneself as a judge [n]\n",
  "RECUSANCE": "the state of being recusant, one who refuses to attend Catholic church services, also RECUSANCY [n -S]\n",
  "RECUSANCES": "RECUSANCE, the state of being recusant, one who refuses to attend Catholic church services, also RECUSANCY [n]\n",
  "RECUSANCIES": "RECUSANCY, the state of being recusant, one who refuses to attend Catholic church services, also RECUSANCE [n]\n",
  "RECUSANCY": "the state of being recusant, one who refuses to attend Catholic church services, also RECUSANCE [n RECUSANCIES]\n",
  "RECUSANT": "one who refuses to accept established authority [n -S]\n",
  "RECUSANTS": "RECUSANT, one who refuses to accept established authority [n]\n",
  "RECUSATION": "refusal [n -S]\n",
  "RECUSATIONS": "RECUSATION, refusal [n]\n",
  "RECUSE": "to disqualify or challenge as judge in a particular case [v RECUSED, RECUSING, RECUSES]\n",
  "RECUSED": "RECUSE, to disqualify or challenge as judge in a particular case [v]\n",
  "RECUSES": "RECUSE, to disqualify or challenge as judge in a particular case [v]\n",
  "RECUSING": "RECUSE, to disqualify or challenge as judge in a particular case [v]\n",
  "RECUT": "to cut again [v RECUT, RECUTTING, RECUTS]\n",
  "RECUTS": "RECUT, to cut again [v]\n",
  "RECUTTING": "RECUT, to cut again [v]\n",
  "RECYCLABLE": "that can be recycled [adj] / something that can be recycled, also RECYCLEABLE [n -S]\n",
  "RECYCLABLES": "RECYCLABLE, something that can be recycled, also RECYCLEABLE [n]\n",
  "RECYCLATE": "material that has been recycled [n -S]\n",
  "RECYCLATES": "RECYCLATE, material that has been recycled [n]\n",
  "RECYCLE": "to process waste materials [v RECYCLED, RECYCLING, RECYCLES]\n",
  "RECYCLEABLE": "something that can be recycled, also RECYCLABLE [n -S]\n",
  "RECYCLEABLES": "RECYCLEABLE, something that can be recycled, also RECYCLABLE [n]\n",
  "RECYCLED": "RECYCLE, to process waste materials [v]\n",
  "RECYCLER": "one who recycles, also RECYCLIST [n -S]\n",
  "RECYCLERS": "RECYCLER, one who recycles, also RECYCLIST [n]\n",
  "RECYCLES": "RECYCLE, to process waste materials [v]\n",
  "RECYCLING": "the act of reclaiming used material [n -S]\n",
  "RECYCLINGS": "RECYCLING, the act of reclaiming used material [n]\n",
  "RECYCLIST": "one who recycles, also RECYCLER [n -S]\n",
  "RECYCLISTS": "RECYCLIST, one who recycles, also RECYCLER [n]\n",
  "RED": "the colour of blood [adj REDDER, REDDEST, REDLY] / to put in order, also REDD [v REDDED, REDDING, REDS]\n",
  "REDACT": "to prepare for publication [v -ED, -ING, -S]\n",
  "REDACTED": "REDACT, to prepare for publication [v]\n",
  "REDACTING": "REDACT, to prepare for publication [v]\n",
  "REDACTION": "an act or instance of putting something in writing or adapting it for publication [n -S]\n",
  "REDACTIONAL": "relating to redaction [adj]\n",
  "REDACTIONS": "REDACTION, an act or instance of putting something in writing or adapting it for publication [n]\n",
  "REDACTOR": "an editor [n -S]\n",
  "REDACTORIAL": "relating to redaction [adj]\n",
  "REDACTORS": "REDACTOR, an editor [n]\n",
  "REDACTS": "REDACT, to prepare for publication [v]\n",
  "REDAMAGE": "to damage again [v REDAMAGED, REDAMAGING, REDAMAGES]\n",
  "REDAMAGED": "REDAMAGE, to damage again [v]\n",
  "REDAMAGES": "REDAMAGE, to damage again [v]\n",
  "REDAMAGING": "REDAMAGE, to damage again [v]\n",
  "REDAN": "(French) a field fortification with two parapets meeting at an angle [n -S]\n",
  "REDANS": "REDAN, (French) a field fortification with two parapets meeting at an angle [n]\n",
  "REDARGUE": "(Scots) to refute [v REDARGUED, REDARGUING, REDARGUES]\n",
  "REDARGUED": "REDARGUE, (Scots) to refute [v]\n",
  "REDARGUES": "REDARGUE, (Scots) to refute [v]\n",
  "REDARGUING": "REDARGUE, (Scots) to refute [v]\n",
  "REDATE": "to change the date [v REDATED, REDATING, REDATES]\n",
  "REDATED": "REDATE, to change the date [v]\n",
  "REDATES": "REDATE, to change the date [v]\n",
  "REDATING": "REDATE, to change the date [v]\n",
  "REDBACK": "a venomous spider found in Australia, the male of which has a red stripe on its back [n -S]\n",
  "REDBACKS": "REDBACK, a venomous spider found in Australia, the male of which has a red stripe on its back [n]\n",
  "REDBAIT": "to denounce as Communist [v -ED, -ING, -S]\n",
  "REDBAITED": "REDBAIT, to denounce as Communist [v]\n",
  "REDBAITER": "one who redbaits [n -S]\n",
  "REDBAITERS": "REDBAITER, one who redbaits [n]\n",
  "REDBAITING": "REDBAIT, to denounce as Communist [v]\n",
  "REDBAITS": "REDBAIT, to denounce as Communist [v]\n",
  "REDBAY": "a small tree [n -S]\n",
  "REDBAYS": "REDBAY, a small tree [n]\n",
  "REDBELLIES": "REDBELLY, the char or other red-bellied fish [n]\n",
  "REDBELLY": "the char or other red-bellied fish [n REDBELLIES]\n",
  "REDBIRD": "a large seed-eating finch [n -S]\n",
  "REDBIRDS": "REDBIRD, a large seed-eating finch [n]\n",
  "REDBONE": "a kind of hunting dog [n -S]\n",
  "REDBONES": "REDBONE, a kind of hunting dog [n]\n",
  "REDBREAST": "the robin [n -S]\n",
  "REDBREASTS": "REDBREAST, the robin [n]\n",
  "REDBRICK": "a British university founded in the 19th or early 20th century [n -S]\n",
  "REDBRICKS": "REDBRICK, a British university founded in the 19th or early 20th century [n]\n",
  "REDBUD": "a small ornamental leguminous tree of the US [n -S]\n",
  "REDBUDS": "REDBUD, a small ornamental leguminous tree of the US [n]\n",
  "REDBUG": "a chigger, a bloodsucking larval mite [n -S]\n",
  "REDBUGS": "REDBUG, a chigger, a bloodsucking larval mite [n]\n",
  "REDCAP": "a military police officer [n -S]\n",
  "REDCAPS": "REDCAP, a military police officer [n]\n",
  "REDCOAT": "a British soldier during the American Revolution [n -S]\n",
  "REDCOATS": "REDCOAT, a British soldier during the American Revolution [n]\n",
  "REDCURRANT": "the small red berry of a shrub of the gooseberry genus [n -S]\n",
  "REDCURRANTS": "REDCURRANT, the small red berry of a shrub of the gooseberry genus [n]\n",
  "REDD": "(Scots) to put in order, also RED [v -ED, -ING, -S]\n",
  "REDDED": "REDD, (Scots) to put in order, also RED [v]\n",
  "REDDEN": "to make or become red [v -ED, -ING, -S]\n",
  "REDDENDA": "REDDENDUM, (Latin) a clause in a lease [n]\n",
  "REDDENDO": "(Scots) in Scots law, service to be rendered or money to be paid by a vassal [n -S]\n",
  "REDDENDOS": "REDDENDO, (Scots) in Scots law, service to be rendered or money to be paid by a vassal [n]\n",
  "REDDENDUM": "(Latin) a clause in a lease [n REDDENDA]\n",
  "REDDENED": "REDDEN, to make or become red [v]\n",
  "REDDENING": "REDDEN, to make or become red [v]\n",
  "REDDENS": "REDDEN, to make or become red [v]\n",
  "REDDER": "one who redds, tidies up [n -S]\n",
  "REDDERS": "REDDER, one who redds, tidies up [n]\n",
  "REDDEST": "RED, the colour of blood [adj]\n",
  "REDDIER": "REDDY, somewhat red [adj]\n",
  "REDDIEST": "REDDY, somewhat red [adj]\n",
  "REDDING": "the act of redding, putting in order [n -S]\n",
  "REDDINGS": "REDDING, the act of redding, putting in order [n]\n",
  "REDDISH": "somewhat red [adj REDDISHLY]\n",
  "REDDISHLY": "REDDISH, somewhat red [adv]\n",
  "REDDISHNESS": "the state of being reddish [n -ES]\n",
  "REDDISHNESSES": "REDDISHNESS, the state of being reddish [n]\n",
  "REDDLE": "to colour with a red dye, also RUDDLE [v REDDLED, REDDLING, REDDLES]\n",
  "REDDLED": "REDDLE, to colour with a red dye, also RUDDLE [v]\n",
  "REDDLEMAN": "one who marks e.g. sheep with reddle, also RADDLEMAN, RUDDLEMAN [n REDDLEMEN]\n",
  "REDDLEMEN": "REDDLEMAN, one who marks e.g. sheep with reddle, also RADDLEMAN, RUDDLEMAN [n]\n",
  "REDDLES": "REDDLE, to colour with a red dye, also RUDDLE [v]\n",
  "REDDLING": "REDDLE, to colour with a red dye, also RUDDLE [v]\n",
  "REDDS": "REDD, (Scots) to put in order, also RED [v]\n",
  "REDDY": "somewhat red [adj REDDIER, REDDIEST]\n",
  "REDE": "(archaic) to advise or counsel, also REEDE [v REDED, REDING, REDES]\n",
  "REDEAL": "to deal again [v REDEALT, REDEALING, REDEALS]\n",
  "REDEALING": "REDEAL, to deal again [v]\n",
  "REDEALS": "REDEAL, to deal again [v]\n",
  "REDEALT": "REDEAL, to deal again [v]\n",
  "REDEAR": "the common sunfish [n -S]\n",
  "REDEARS": "REDEAR, the common sunfish [n]\n",
  "REDECIDE": "to decide again [v REDECIDED, REDECIDING, REDECIDES]\n",
  "REDECIDED": "REDECIDE, to decide again [v]\n",
  "REDECIDES": "REDECIDE, to decide again [v]\n",
  "REDECIDING": "REDECIDE, to decide again [v]\n",
  "REDECORATE": "to decorate again [v REDECORATED, REDECORATING, REDECORATES]\n",
  "REDECORATED": "REDECORATE, to decorate again [v]\n",
  "REDECORATES": "REDECORATE, to decorate again [v]\n",
  "REDECORATING": "REDECORATE, to decorate again [v]\n",
  "REDECORATION": "the act of redecorating [n -S]\n",
  "REDECORATIONS": "REDECORATION, the act of redecorating [n]\n",
  "REDECORATOR": "one who redecorates [n -S]\n",
  "REDECORATORS": "REDECORATOR, one who redecorates [n]\n",
  "REDECRAFT": "(archaic) logic [n -S]\n",
  "REDECRAFTS": "REDECRAFT, (archaic) logic [n]\n",
  "REDED": "REDE, (archaic) to advise or counsel, also REEDE [v]\n",
  "REDEDICATE": "to dedicate again [v REDEDICATED, REDEDICATING, REDEDICATES]\n",
  "REDEDICATED": "REDEDICATE, to dedicate again [v]\n",
  "REDEDICATES": "REDEDICATE, to dedicate again [v]\n",
  "REDEDICATING": "REDEDICATE, to dedicate again [v]\n",
  "REDEDICATION": "the act of rededicating [n -S]\n",
  "REDEDICATIONS": "REDEDICATION, the act of rededicating [n]\n",
  "REDEEM": "to buy back [v -ED, -ING, -S]\n",
  "REDEEMABILITIES": "REDEEMABILITY, the quality of being redeemable [n]\n",
  "REDEEMABILITY": "the quality of being redeemable [n REDEEMABILITIES]\n",
  "REDEEMABLE": "that can be redeemed [adj REDEEMABLY]\n",
  "REDEEMABLENESS": "the state of being redeemable [n]\n",
  "REDEEMABLY": "REDEEMABLE, that can be redeemed [adv]\n",
  "REDEEMED": "REDEEM, to buy back [v]\n",
  "REDEEMER": "one that redeems [n -S]\n",
  "REDEEMERS": "REDEEMER, one that redeems [n]\n",
  "REDEEMING": "REDEEM, to buy back [v]\n",
  "REDEEMLESS": "not to be redeemed [adj]\n",
  "REDEEMS": "REDEEM, to buy back [v]\n",
  "REDEFEAT": "to defeat again [v -ED, -ING, -S]\n",
  "REDEFEATED": "REDEFEAT, to defeat again [v]\n",
  "REDEFEATING": "REDEFEAT, to defeat again [v]\n",
  "REDEFEATS": "REDEFEAT, to defeat again [v]\n",
  "REDEFECT": "to defect again [v -ED, -ING, -S]\n",
  "REDEFECTED": "REDEFECT, to defect again [v]\n",
  "REDEFECTING": "REDEFECT, to defect again [v]\n",
  "REDEFECTS": "REDEFECT, to defect again [v]\n",
  "REDEFIED": "REDEFY, to defy again [v]\n",
  "REDEFIES": "REDEFY, to defy again [v]\n",
  "REDEFINE": "to define again [v REDEFINED, REDEFINING, REDEFINES]\n",
  "REDEFINED": "REDEFINE, to define again [v]\n",
  "REDEFINES": "REDEFINE, to define again [v]\n",
  "REDEFINING": "REDEFINE, to define again [v]\n",
  "REDEFINITION": "the act of redefining [n -S]\n",
  "REDEFINITIONS": "REDEFINITION, the act of redefining [n]\n",
  "REDEFY": "to defy again [v REDEFIED, REDEFYING, REDEFIES]\n",
  "REDEFYING": "REDEFY, to defy again [v]\n",
  "REDELESS": "(archaic) without rede or counsel [adj]\n",
  "REDELIVER": "to deliver or give back; to return [v -ED, -ING, -S]\n",
  "REDELIVERANCE": "the act of redelivering [n -S]\n",
  "REDELIVERANCES": "REDELIVERANCE, the act of redelivering [n]\n",
  "REDELIVERED": "REDELIVER, to deliver or give back; to return [v]\n",
  "REDELIVERER": "one who redelivers [n -S]\n",
  "REDELIVERERS": "REDELIVERER, one who redelivers [n]\n",
  "REDELIVERIES": "REDELIVERY, the act of delivering again [n]\n",
  "REDELIVERING": "REDELIVER, to deliver or give back; to return [v]\n",
  "REDELIVERS": "REDELIVER, to deliver or give back; to return [v]\n",
  "REDELIVERY": "the act of delivering again [n REDELIVERIES]\n",
  "REDEMAND": "to demand again [v -ED, -ING, -S]\n",
  "REDEMANDED": "REDEMAND, to demand again [v]\n",
  "REDEMANDING": "REDEMAND, to demand again [v]\n",
  "REDEMANDS": "REDEMAND, to demand again [v]\n",
  "REDEMPTIBLE": "that can be redeemed [adj]\n",
  "REDEMPTION": "the act of redeeming [n -S]\n",
  "REDEMPTIONAL": "of the nature of redemption [adj]\n",
  "REDEMPTIONER": "an immigrant to America in the 18th and 19th centuries who obtained passage by becoming an indentured servant [n -S]\n",
  "REDEMPTIONERS": "REDEMPTIONER, an immigrant to America in the 18th and 19th centuries who obtained passage by becoming an indentured servant [n]\n",
  "REDEMPTIONS": "REDEMPTION, the act of redeeming [n]\n",
  "REDEMPTIVE": "serving to redeem [adj REDEMPTIVELY]\n",
  "REDEMPTIVELY": "REDEMPTIVE, serving to redeem [adv]\n",
  "REDEMPTORY": "paid for ransom; serving to redeem [adj]\n",
  "REDENIED": "REDENY, to deny again [v]\n",
  "REDENIES": "REDENY, to deny again [v]\n",
  "REDENY": "to deny again [v REDENIED, REDENYING, REDENIES]\n",
  "REDENYING": "REDENY, to deny again [v]\n",
  "REDEPLOY": "to deploy again [v -ED, -ING, -S]\n",
  "REDEPLOYED": "REDEPLOY, to deploy again [v]\n",
  "REDEPLOYING": "REDEPLOY, to deploy again [v]\n",
  "REDEPLOYMENT": "the act of redeploying [n -S]\n",
  "REDEPLOYMENTS": "REDEPLOYMENT, the act of redeploying [n]\n",
  "REDEPLOYS": "REDEPLOY, to deploy again [v]\n",
  "REDEPOSIT": "to deposit again [v -ED, -ING, -S]\n",
  "REDEPOSITED": "REDEPOSIT, to deposit again [v]\n",
  "REDEPOSITING": "REDEPOSIT, to deposit again [v]\n",
  "REDEPOSITS": "REDEPOSIT, to deposit again [v]\n",
  "REDES": "REDE, (archaic) to advise or counsel, also REEDE [v]\n",
  "REDESCEND": "to descend again [v -ED, -ING, -S]\n",
  "REDESCENDED": "REDESCEND, to descend again [v]\n",
  "REDESCENDING": "REDESCEND, to descend again [v]\n",
  "REDESCENDS": "REDESCEND, to descend again [v]\n",
  "REDESCRIBE": "to describe again [v REDESCRIBED, REDESCRIBING, REDESCRIBES]\n",
  "REDESCRIBED": "REDESCRIBE, to describe again [v]\n",
  "REDESCRIBES": "REDESCRIBE, to describe again [v]\n",
  "REDESCRIBING": "REDESCRIBE, to describe again [v]\n",
  "REDESCRIPTION": "a new and more complete description esp. of a biological taxon [n -S]\n",
  "REDESCRIPTIONS": "REDESCRIPTION, a new and more complete description esp. of a biological taxon [n]\n",
  "REDESIGN": "to design again [v -ED, -ING, -S]\n",
  "REDESIGNED": "REDESIGN, to design again [v]\n",
  "REDESIGNING": "REDESIGN, to design again [v]\n",
  "REDESIGNS": "REDESIGN, to design again [v]\n",
  "REDETERMINATION": "the act of redetermining [n]\n",
  "REDETERMINE": "to determine again [v REDETERMINED, REDETERMINING, REDETERMINES]\n",
  "REDETERMINED": "REDETERMINE, to determine again [v]\n",
  "REDETERMINES": "REDETERMINE, to determine again [v]\n",
  "REDETERMINING": "REDETERMINE, to determine again [v]\n",
  "REDEVELOP": "to develop again [v -ED, -ING, -S]\n",
  "REDEVELOPED": "REDEVELOP, to develop again [v]\n",
  "REDEVELOPER": "one who redevelops [n -S]\n",
  "REDEVELOPERS": "REDEVELOPER, one who redevelops [n]\n",
  "REDEVELOPING": "REDEVELOP, to develop again [v]\n",
  "REDEVELOPMENT": "the act of redeveloping [n -S]\n",
  "REDEVELOPMENTS": "REDEVELOPMENT, the act of redeveloping [n]\n",
  "REDEVELOPS": "REDEVELOP, to develop again [v]\n",
  "REDEYE": "a railroad danger signal [n -S]\n",
  "REDEYES": "REDEYE, a railroad danger signal [n]\n",
  "REDFIN": "a small North American dace; the male, in the breeding season, has bright red fins [n -S]\n",
  "REDFINS": "REDFIN, a small North American dace; the male, in the breeding season, has bright red fins [n]\n",
  "REDFISH": "the blueback salmon of the north Pacific, aka nerka [n -ES]\n",
  "REDFISHES": "REDFISH, the blueback salmon of the north Pacific, aka nerka [n]\n",
  "REDFOOT": "a fatal disease of newborn lambs [n -S]\n",
  "REDFOOTS": "REDFOOT, a fatal disease of newborn lambs [n]\n",
  "REDHANDED": "caught in the act [adj]\n",
  "REDHEAD": "any of several birds with reddish head, esp. the pochard [n -S]\n",
  "REDHEADED": "having red hair [adj]\n",
  "REDHEADS": "REDHEAD, any of several birds with reddish head, esp. the pochard [n]\n",
  "REDHORSE": "a freshwater fish [n -S]\n",
  "REDHORSES": "REDHORSE, a freshwater fish [n]\n",
  "REDIA": "(Latin) the larva or certain flatworms [n REDIAS or REDIAE]\n",
  "REDIAE": "REDIA, (Latin) the larva or certain flatworms [n]\n",
  "REDIAL": "to dial again [v REDIALED or REDIALLED, REDIALING or REDIALLING, REDIALS]\n",
  "REDIALED": "REDIAL, to dial again [v]\n",
  "REDIALING": "REDIAL, to dial again [v]\n",
  "REDIALLED": "REDIAL, to dial again [v]\n",
  "REDIALLING": "REDIAL, to dial again [v]\n",
  "REDIALS": "REDIAL, to dial again [v]\n",
  "REDIAS": "REDIA, (Latin) the larva or certain flatworms [n]\n",
  "REDICTATE": "to dictate again [v REDICTATED, REDICTATING, REDICTATES]\n",
  "REDICTATED": "REDICTATE, to dictate again [v]\n",
  "REDICTATES": "REDICTATE, to dictate again [v]\n",
  "REDICTATING": "REDICTATE, to dictate again [v]\n",
  "REDID": "REDO, to do again [v]\n",
  "REDIGEST": "to digest again [v -ED, -ING, -S]\n",
  "REDIGESTED": "REDIGEST, to digest again [v]\n",
  "REDIGESTING": "REDIGEST, to digest again [v]\n",
  "REDIGESTION": "the act of redigesting [n -S]\n",
  "REDIGESTIONS": "REDIGESTION, the act of redigesting [n]\n",
  "REDIGESTS": "REDIGEST, to digest again [v]\n",
  "REDIGRESS": "to digress again [v -ED, -ING, -ES]\n",
  "REDIGRESSED": "REDIGRESS, to digress again [v]\n",
  "REDIGRESSES": "REDIGRESS, to digress again [v]\n",
  "REDIGRESSING": "REDIGRESS, to digress again [v]\n",
  "REDING": "REDE, (archaic) to advise or counsel, also REEDE [v]\n",
  "REDINGOTE": "(French) a long plain double-breasted outside coat for women [n -S]\n",
  "REDINGOTES": "REDINGOTE, (French) a long plain double-breasted outside coat for women [n]\n",
  "REDINTEGRATE": "to make whole again; to restore [v REDINTEGRATED, REDINTEGRATING, REDINTEGRATES]\n",
  "REDINTEGRATED": "REDINTEGRATE, to make whole again; to restore [v]\n",
  "REDINTEGRATES": "REDINTEGRATE, to make whole again; to restore [v]\n",
  "REDINTEGRATING": "REDINTEGRATE, to make whole again; to restore [v]\n",
  "REDINTEGRATION": "revival of the whole of a previous mental state when a phase of it recurs [n -S]\n",
  "REDINTEGRATIONS": "REDINTEGRATION, revival of the whole of a previous mental state when a phase of it recurs [n]\n",
  "REDINTEGRATIVE": "relating to redintegration [adj]\n",
  "REDIP": "to dip again [v REDIPPED, REDIPT, REDIPPING, REDIPS]\n",
  "REDIPPED": "REDIP, to dip again [v]\n",
  "REDIPPING": "REDIP, to dip again [v]\n",
  "REDIPS": "REDIP, to dip again [v]\n",
  "REDIPT": "REDIP, to dip again [v]\n",
  "REDIRECT": "to change the direction of [v -ED, -ING, -S]\n",
  "REDIRECTED": "REDIRECT, to change the direction of [v]\n",
  "REDIRECTING": "REDIRECT, to change the direction of [v]\n",
  "REDIRECTION": "the act of redirecting [n -S]\n",
  "REDIRECTIONS": "REDIRECTION, the act of redirecting [n]\n",
  "REDIRECTS": "REDIRECT, to change the direction of [v]\n",
  "REDISBURSE": "(Spenser) to refund [v REDISBURSED, REDISBURSING, REDISBURSES]\n",
  "REDISBURSED": "REDISBURSE, (Spenser) to refund [v]\n",
  "REDISBURSES": "REDISBURSE, (Spenser) to refund [v]\n",
  "REDISBURSING": "REDISBURSE, (Spenser) to refund [v]\n",
  "REDISCOUNT": "to discount again [v -ED, -ING, -S]\n",
  "REDISCOUNTABLE": "capable of being rediscounted [adj]\n",
  "REDISCOUNTED": "REDISCOUNT, to discount again [v]\n",
  "REDISCOUNTING": "REDISCOUNT, to discount again [v]\n",
  "REDISCOUNTS": "REDISCOUNT, to discount again [v]\n",
  "REDISCOVER": "to discover again [v -ED, -ING, -S]\n",
  "REDISCOVERED": "REDISCOVER, to discover again [v]\n",
  "REDISCOVERER": "one who rediscovers [n -S]\n",
  "REDISCOVERERS": "REDISCOVERER, one who rediscovers [n]\n",
  "REDISCOVERIES": "REDISCOVERY, the act of rediscovering [n]\n",
  "REDISCOVERING": "REDISCOVER, to discover again [v]\n",
  "REDISCOVERS": "REDISCOVER, to discover again [v]\n",
  "REDISCOVERY": "the act of rediscovering [n REDISCOVERIES]\n",
  "REDISCUSS": "to discuss again [v -ED, -ING, -ES]\n",
  "REDISCUSSED": "REDISCUSS, to discuss again [v]\n",
  "REDISCUSSES": "REDISCUSS, to discuss again [v]\n",
  "REDISCUSSING": "REDISCUSS, to discuss again [v]\n",
  "REDISPLAY": "to display again [v -ED, -ING, -S]\n",
  "REDISPLAYED": "REDISPLAY, to display again [v]\n",
  "REDISPLAYING": "REDISPLAY, to display again [v]\n",
  "REDISPLAYS": "REDISPLAY, to display again [v]\n",
  "REDISPOSE": "to dispose anew or again [v REDISPOSED, REDISPOSING, REDISPOSES]\n",
  "REDISPOSED": "REDISPOSE, to dispose anew or again [v]\n",
  "REDISPOSES": "REDISPOSE, to dispose anew or again [v]\n",
  "REDISPOSING": "REDISPOSE, to dispose anew or again [v]\n",
  "REDISPOSITION": "a new disposition [n -S]\n",
  "REDISPOSITIONS": "REDISPOSITION, a new disposition [n]\n",
  "REDISSOLUTION": "the act of dissolving again [n -S]\n",
  "REDISSOLUTIONS": "REDISSOLUTION, the act of dissolving again [n]\n",
  "REDISSOLVE": "to dissolve again [v REDISSOLVED, REDISSOLVING, REDISSOLVES]\n",
  "REDISSOLVED": "REDISSOLVE, to dissolve again [v]\n",
  "REDISSOLVES": "REDISSOLVE, to dissolve again [v]\n",
  "REDISSOLVING": "REDISSOLVE, to dissolve again [v]\n",
  "REDISTIL": "to distil again, also REDISTILL [v REDISTILLED, REDISTILLING, REDISTILS]\n",
  "REDISTILL": "to distill again, also REDISTIL [v -ED, -ING, -S]\n",
  "REDISTILLATION": "the act of redistilling [n -S]\n",
  "REDISTILLATIONS": "REDISTILLATION, the act of redistilling [n]\n",
  "REDISTILLED": "REDISTIL, to distil again, also REDISTILL [v]\n",
  "REDISTILLING": "REDISTIL, to distil again, also REDISTILL [v]\n",
  "REDISTILLS": "REDISTILL, to distill again, also REDISTIL [v]\n",
  "REDISTILS": "REDISTIL, to distil again, also REDISTILL [v]\n",
  "REDISTRIBUTE": "to alter the distribution of [v REDISTRIBUTED, REDISTRIBUTING, REDISTRIBUTES]\n",
  "REDISTRIBUTED": "REDISTRIBUTE, to alter the distribution of [v]\n",
  "REDISTRIBUTES": "REDISTRIBUTE, to alter the distribution of [v]\n",
  "REDISTRIBUTING": "REDISTRIBUTE, to alter the distribution of [v]\n",
  "REDISTRIBUTION": "the act of redistributing [n -S]\n",
  "REDISTRIBUTIONS": "REDISTRIBUTION, the act of redistributing [n]\n",
  "REDISTRIBUTIVE": "relating to redistribution [adj]\n",
  "REDISTRICT": "to divide into new districts [v -ED, -ING, -S]\n",
  "REDISTRICTED": "REDISTRICT, to divide into new districts [v]\n",
  "REDISTRICTING": "the act of dividing into new districts [n -S]\n",
  "REDISTRICTINGS": "REDISTRICTING, the act of dividing into new districts [n]\n",
  "REDISTRICTS": "REDISTRICT, to divide into new districts [v]\n",
  "REDIVIDE": "to divide again [v REDIVIDED, REDIVIDING, REDIVIDES]\n",
  "REDIVIDED": "REDIVIDE, to divide again [v]\n",
  "REDIVIDES": "REDIVIDE, to divide again [v]\n",
  "REDIVIDING": "REDIVIDE, to divide again [v]\n",
  "REDIVISION": "the act of dividing again [n -S]\n",
  "REDIVISIONS": "REDIVISION, the act of dividing again [n]\n",
  "REDIVIVUS": "(Latin) living again; revived [adj]\n",
  "REDIVORCE": "to divorce again [v REDIVORCED, REDIVORCING, REDIVORCES]\n",
  "REDIVORCED": "REDIVORCE, to divorce again [v]\n",
  "REDIVORCES": "REDIVORCE, to divorce again [v]\n",
  "REDIVORCING": "REDIVORCE, to divorce again [v]\n",
  "REDLEG": "a term for a poor white person, esp. a descendant of original white settlers [n -S]\n",
  "REDLEGS": "REDLEG, a term for a poor white person, esp. a descendant of original white settlers [n]\n",
  "REDLINE": "to withhold loans or insurance from certain neighborhoods [v REDLINED, REDLINING, REDLINES]\n",
  "REDLINED": "REDLINE, to withhold loans or insurance from certain neighborhoods [v]\n",
  "REDLINER": "one that redlines, withholds loans or insurance from certain neighbourhoods [n -S]\n",
  "REDLINERS": "REDLINER, one that redlines, withholds loans or insurance from certain neighbourhoods [n]\n",
  "REDLINES": "REDLINE, to withhold loans or insurance from certain neighborhoods [v]\n",
  "REDLINING": "refusing to serve particular geographical areas because of race or income [n -S]\n",
  "REDLININGS": "REDLINING, refusing to serve particular geographical areas because of race or income [n]\n",
  "REDLY": "RED, the colour of blood [adv]\n",
  "REDNECK": "a poor white farm labourer in the southwestern states of the US [n -S]\n",
  "REDNECKED": "like a redneck, ignorant, intolerant, narrow-minded [adj]\n",
  "REDNECKS": "REDNECK, a poor white farm labourer in the southwestern states of the US [n]\n",
  "REDNESS": "the state of being red [n -ES]\n",
  "REDNESSES": "REDNESS, the state of being red [n]\n",
  "REDO": "a repeated action [n -S] / to do again [v REDID, REDONE, REDOING, REDOES]\n",
  "REDOCK": "to dock again [v -ED, -ING, -S]\n",
  "REDOCKED": "REDOCK, to dock again [v]\n",
  "REDOCKING": "REDOCK, to dock again [v]\n",
  "REDOCKS": "REDOCK, to dock again [v]\n",
  "REDOES": "REDO, to do again [v]\n",
  "REDOING": "REDO, to do again [v]\n",
  "REDOLENCE": "fragrance, the state of being redolent, also REDOLENCY [n -S]\n",
  "REDOLENCES": "REDOLENCE, fragrance, the state of being redolent, also REDOLENCY [n]\n",
  "REDOLENCIES": "REDOLENCY, fragrance, the state of being redolent, also REDOLENCE [n]\n",
  "REDOLENCY": "fragrance, the state of being redolent, also REDOLENCE [n REDOLENCIES]\n",
  "REDOLENT": "fragrant; smelling of; suggestive of [adj REDOLENTLY]\n",
  "REDOLENTLY": "REDOLENT, fragrant; smelling of; suggestive of [adv]\n",
  "REDON": "to don again [v REDONNED, REDONNING, REDONS]\n",
  "REDONE": "REDO, to do again [v]\n",
  "REDONNED": "REDON, to don again [v]\n",
  "REDONNING": "REDON, to don again [v]\n",
  "REDONS": "REDON, to don again [v]\n",
  "REDOS": "REDO, to do again [v]\n",
  "REDOUBLE": "to double [v REDOUBLED, REDOUBLING, REDOUBLES]\n",
  "REDOUBLED": "REDOUBLE, to double [v]\n",
  "REDOUBLEMENT": "the act of redoubling [n -S]\n",
  "REDOUBLEMENTS": "REDOUBLEMENT, the act of redoubling [n]\n",
  "REDOUBLER": "one who redoubles [n -S]\n",
  "REDOUBLERS": "REDOUBLER, one who redoubles [n]\n",
  "REDOUBLES": "REDOUBLE, to double [v]\n",
  "REDOUBLING": "REDOUBLE, to double [v]\n",
  "REDOUBT": "(archaic) to fear [v -ED, -ING, -S]\n",
  "REDOUBTABLE": "causing fear or alarm, formidable [adj REDOUBTABLY]\n",
  "REDOUBTABLENESS": "REDOUBTABLE, causing fear or alarm, formidable [n]\n",
  "REDOUBTABLY": "REDOUBTABLE, causing fear or alarm, formidable [adv]\n",
  "REDOUBTED": "REDOUBT, (archaic) to fear [v]\n",
  "REDOUBTING": "REDOUBT, (archaic) to fear [v]\n",
  "REDOUBTS": "REDOUBT, (archaic) to fear [v]\n",
  "REDOUND": "to have an effect or consequence [v -ED, -ING, -S]\n",
  "REDOUNDED": "REDOUND, to have an effect or consequence [v]\n",
  "REDOUNDING": "the act of redounding [n -S]\n",
  "REDOUNDINGS": "REDOUNDING, the act of redounding [n]\n",
  "REDOUNDS": "REDOUND, to have an effect or consequence [v]\n",
  "REDOUT": "reddening of the visual field caused by blood being forced to the head in conditions of low gravity [n -S]\n",
  "REDOUTS": "REDOUT, reddening of the visual field caused by blood being forced to the head in conditions of low gravity [n]\n",
  "REDOWA": "(Czech) a lively Bohemian dance [n -S]\n",
  "REDOWAS": "REDOWA, (Czech) a lively Bohemian dance [n]\n",
  "REDOX": "a type of chemical reaction, in which one reagent is reduced while another is oxidised [n -ES]\n",
  "REDOXES": "REDOX, a type of chemical reaction, in which one reagent is reduced while another is oxidised [n]\n",
  "REDPOLL": "a kind of finch [n -S]\n",
  "REDPOLLS": "REDPOLL, a kind of finch [n]\n",
  "REDRAFT": "to make a revised copy of [v -ED, -ING, -S]\n",
  "REDRAFTED": "REDRAFT, to make a revised copy of [v]\n",
  "REDRAFTING": "REDRAFT, to make a revised copy of [v]\n",
  "REDRAFTS": "REDRAFT, to make a revised copy of [v]\n",
  "REDRAW": "to draw again [v REDREW, REDRAWN, REDRAWING, REDRAWS]\n",
  "REDRAWER": "one that redraws [n -S]\n",
  "REDRAWERS": "REDRAWER, one that redraws [n]\n",
  "REDRAWING": "REDRAW, to draw again [v]\n",
  "REDRAWN": "REDRAW, to draw again [v]\n",
  "REDRAWS": "REDRAW, to draw again [v]\n",
  "REDREAM": "to dream again [v REDREAMED, REDREAMT, REDREAMING, REDREAMS]\n",
  "REDREAMED": "REDREAM, to dream again [v]\n",
  "REDREAMING": "REDREAM, to dream again [v]\n",
  "REDREAMS": "REDREAM, to dream again [v]\n",
  "REDREAMT": "REDREAM, to dream again [v]\n",
  "REDRESS": "to set right [v -ED, -ING, -ES]\n",
  "REDRESSABLE": "that can be redressed, also REDRESSIBLE [adj]\n",
  "REDRESSAL": "an act or instance of redressing [n -S]\n",
  "REDRESSALS": "REDRESSAL, an act or instance of redressing [n]\n",
  "REDRESSED": "REDRESS, to set right [v]\n",
  "REDRESSER": "one who redresses, also REDRESSOR [n -S]\n",
  "REDRESSERS": "REDRESSER, one who redresses, also REDRESSOR [n]\n",
  "REDRESSES": "REDRESS, to set right [v]\n",
  "REDRESSIBLE": "that can be redressed, also REDRESSABLE [adj]\n",
  "REDRESSING": "REDRESS, to set right [v]\n",
  "REDRESSIVE": "tending to redress [adj]\n",
  "REDRESSOR": "one who redresses, also REDRESSER [n -S]\n",
  "REDRESSORS": "REDRESSOR, one who redresses, also REDRESSER [n]\n",
  "REDREW": "REDRAW, to draw again [v]\n",
  "REDRIED": "REDRY, to dry again [v]\n",
  "REDRIES": "REDRY, to dry again [v]\n",
  "REDRILL": "to drill again [v -ED, -ING, -S]\n",
  "REDRILLED": "REDRILL, to drill again [v]\n",
  "REDRILLING": "REDRILL, to drill again [v]\n",
  "REDRILLS": "REDRILL, to drill again [v]\n",
  "REDRIVE": "to drive again [v REDROVE, REDRIVEN, REDRIVING, REDRIVES]\n",
  "REDRIVEN": "REDRIVE, to drive again [v]\n",
  "REDRIVES": "REDRIVE, to drive again [v]\n",
  "REDRIVING": "REDRIVE, to drive again [v]\n",
  "REDROOT": "a plant with a red root and red sap, and bearing a pretty, white flower in early spring, aka puccoon, bloodroot [n -S]\n",
  "REDROOTS": "REDROOT, a plant with a red root and red sap, and bearing a pretty, white flower in early spring, aka puccoon, bloodroot [n]\n",
  "REDROVE": "REDRIVE, to drive again [v]\n",
  "REDRUTHITE": "copper-glance, a mineral found at Redruth in Cornwall [n -S]\n",
  "REDRUTHITES": "REDRUTHITE, copper-glance, a mineral found at Redruth in Cornwall [n]\n",
  "REDRY": "to dry again [v REDRIED, REDRYING, REDRIES]\n",
  "REDRYING": "REDRY, to dry again [v]\n",
  "REDS": "RED, to put in order, also REDD [v]\n",
  "REDSEAR": "brittle at red-heat, also REDSHARE, REDSHIRE, REDSHORT [adj]\n",
  "REDSHANK": "a kind of wading bird with reddish legs [n -S]\n",
  "REDSHANKS": "REDSHANK, a kind of wading bird with reddish legs [n]\n",
  "REDSHARE": "brittle at red-heat, also REDSEAR, REDSHIRE, REDSHORT [adj]\n",
  "REDSHIFT": "the displacement of the light a receding object emits toward the red end of the spectrum [n -S]\n",
  "REDSHIFTED": "of e.g. a star, having its light shifted towards the red [adj]\n",
  "REDSHIFTS": "REDSHIFT, the displacement of the light a receding object emits toward the red end of the spectrum [n]\n",
  "REDSHIRE": "brittle at red-heat, also REDSEAR, REDSHARE, REDSHORT [adj]\n",
  "REDSHIRT": "to keep a college athlete out of varsity play to extend his eligibility [v -ED, -ING, -S]\n",
  "REDSHIRTED": "REDSHIRT, to keep a college athlete out of varsity play to extend his eligibility [v]\n",
  "REDSHIRTING": "REDSHIRT, to keep a college athlete out of varsity play to extend his eligibility [v]\n",
  "REDSHIRTS": "REDSHIRT, to keep a college athlete out of varsity play to extend his eligibility [v]\n",
  "REDSHORT": "brittle at red-heat, also REDSEAR, REDSHARE, REDSHIRE [adj]\n",
  "REDSKIN": "(offensive) a Native American [n -S]\n",
  "REDSKINS": "REDSKIN, (offensive) a Native American [n]\n",
  "REDSTART": "a bird of the thrush family, characterised by a red tail [n -S]\n",
  "REDSTARTS": "REDSTART, a bird of the thrush family, characterised by a red tail [n]\n",
  "REDSTREAK": "a favorite English cider apple, having the skin streaked with red and yellow [n -S]\n",
  "REDSTREAKS": "REDSTREAK, a favorite English cider apple, having the skin streaked with red and yellow [n]\n",
  "REDTAIL": "a kind of hawk [n -S]\n",
  "REDTAILS": "REDTAIL, a kind of hawk [n]\n",
  "REDTOP": "a kind of grass highly valued in the US for pasturage and hay for cattle [n -S]\n",
  "REDTOPS": "REDTOP, a kind of grass highly valued in the US for pasturage and hay for cattle [n]\n",
  "REDUB": "to dub again [v REDUBBED, REDUBBING, REDUBS]\n",
  "REDUBBED": "REDUB, to dub again [v]\n",
  "REDUBBING": "REDUB, to dub again [v]\n",
  "REDUBS": "REDUB, to dub again [v]\n",
  "REDUCE": "to diminish [v REDUCED, REDUCING, REDUCES]\n",
  "REDUCED": "REDUCE, to diminish [v]\n",
  "REDUCER": "a joint piece that connects pipes of varying diameters [n -S]\n",
  "REDUCERS": "REDUCER, a joint piece that connects pipes of varying diameters [n]\n",
  "REDUCES": "REDUCE, to diminish [v]\n",
  "REDUCIBILITIES": "REDUCIBILITY, the state of being reducible [n]\n",
  "REDUCIBILITY": "the state of being reducible [n REDUCIBILITIES]\n",
  "REDUCIBLE": "capable of being reduced [adj REDUCIBLY]\n",
  "REDUCIBLENESS": "the state of being reducible [n -ES]\n",
  "REDUCIBLENESSES": "REDUCIBLENESS, the state of being reducible [n]\n",
  "REDUCIBLY": "REDUCIBLE, capable of being reduced [adv]\n",
  "REDUCING": "REDUCE, to diminish [v]\n",
  "REDUCTANT": "a reducing agent [n -S]\n",
  "REDUCTANTS": "REDUCTANT, a reducing agent [n]\n",
  "REDUCTASE": "an enzyme which brings about the reduction of organic compounds [n -S]\n",
  "REDUCTASES": "REDUCTASE, an enzyme which brings about the reduction of organic compounds [n]\n",
  "REDUCTION": "the act of reducing [n -S]\n",
  "REDUCTIONAL": "relating to reduction [adj]\n",
  "REDUCTIONISM": "the belief that complex phenomena are reducible to simple ones [n -S]\n",
  "REDUCTIONISMS": "REDUCTIONISM, the belief that complex phenomena are reducible to simple ones [n]\n",
  "REDUCTIONIST": "a believer in reductionism [n -S]\n",
  "REDUCTIONISTIC": "relating to reductionism [adj]\n",
  "REDUCTIONISTS": "REDUCTIONIST, a believer in reductionism [n]\n",
  "REDUCTIONS": "REDUCTION, the act of reducing [n]\n",
  "REDUCTIVE": "tending to reduce [adj REDUCTIVELY] / a reducing agent [n -S]\n",
  "REDUCTIVELY": "REDUCTIVE, tending to reduce [adv]\n",
  "REDUCTIVENESS": "the state of being reductive [n -ES]\n",
  "REDUCTIVENESSES": "REDUCTIVENESS, the state of being reductive [n]\n",
  "REDUCTIVES": "REDUCTIVE, a reducing agent [n]\n",
  "REDUCTOR": "an apparatus for the reduction of metallic ions in solution [n -S]\n",
  "REDUCTORS": "REDUCTOR, an apparatus for the reduction of metallic ions in solution [n]\n",
  "REDUIT": "(French) a keep or stronghold into which a garrison may retire if the outworks are taken [n -S]\n",
  "REDUITS": "REDUIT, (French) a keep or stronghold into which a garrison may retire if the outworks are taken [n]\n",
  "REDUNDANCE": "the state of being redundant, also REDUNDANCY [n -S]\n",
  "REDUNDANCES": "REDUNDANCE, the state of being redundant, also REDUNDANCY [n]\n",
  "REDUNDANCIES": "REDUNDANCY, the state of being redundant, also REDUNDANCE [n]\n",
  "REDUNDANCY": "the state of being redundant, also REDUNDANCE [n REDUNDANCIES]\n",
  "REDUNDANT": "no longer needed [adj REDUNDANTLY]\n",
  "REDUNDANTLY": "REDUNDANT, no longer needed [adv]\n",
  "REDUPLICATE": "to make or perform again [v REDUPLICATED, REDUPLICATING, REDUPLICATES]\n",
  "REDUPLICATED": "REDUPLICATE, to make or perform again [v]\n",
  "REDUPLICATES": "REDUPLICATE, to make or perform again [v]\n",
  "REDUPLICATING": "REDUPLICATE, to make or perform again [v]\n",
  "REDUPLICATION": "an act or instance of doubling or reiterating [n -S]\n",
  "REDUPLICATIONS": "REDUPLICATION, an act or instance of doubling or reiterating [n]\n",
  "REDUPLICATIVE": "relating to reduplication [adj REDUPLICATIVELY]\n",
  "REDUPLICATIVELY": "REDUPLICATIVE, relating to reduplication [adv]\n",
  "REDUVIID": "a member of a family of predaceous bugs [n -S]\n",
  "REDUVIIDS": "REDUVIID, a member of a family of predaceous bugs [n]\n",
  "REDUX": "(Latin) brought back, revived, restored [adj]\n",
  "REDWARE": "an edible seaweed [n -S]\n",
  "REDWARES": "REDWARE, an edible seaweed [n]\n",
  "REDWATER": "a cattle disease [n -S]\n",
  "REDWATERS": "REDWATER, a cattle disease [n]\n",
  "REDWING": "a bird of the thrush family, with a red underwing [n -S]\n",
  "REDWINGS": "REDWING, a bird of the thrush family, with a red underwing [n]\n",
  "REDWOOD": "a species of sequoia with reddish wood much used commercially [n -S]\n",
  "REDWOODS": "REDWOOD, a species of sequoia with reddish wood much used commercially [n]\n",
  "REDYE": "to dye again [v REDYED, REDYEING, REDYES]\n",
  "REDYED": "REDYE, to dye again [v]\n",
  "REDYEING": "REDYE, to dye again [v]\n",
  "REDYES": "REDYE, to dye again [v]\n",
  "REE": "(Scots) a walled enclosure for sheep [n -S]\n",
  "REEARN": "to earn again [v -ED, -ING, -S]\n",
  "REEARNED": "REEARN, to earn again [v]\n",
  "REEARNING": "REEARN, to earn again [v]\n",
  "REEARNS": "REEARN, to earn again [v]\n",
  "REEBOK": "(South African) a kind of antelope, also RHEBOK [n -S]\n",
  "REEBOKS": "REEBOK, (South African) a kind of antelope, also RHEBOK [n]\n",
  "REECH": "to emit smoke, also REEK [v -ED, -ING, -ES]\n",
  "REECHED": "REECH, to emit smoke, also REEK [v]\n",
  "REECHES": "REECH, to emit smoke, also REEK [v]\n",
  "REECHIE": "(Shakespeare) smoky, grimy, also RECHIE, REECHY, REEKIE, REEKY [adj REECHIER, REECHIEST]\n",
  "REECHIER": "REECHIE, (Shakespeare) smoky, grimy, also RECHIE, REECHY, REEKIE, REEKY [adj]\n",
  "REECHIEST": "REECHIE, (Shakespeare) smoky, grimy, also RECHIE, REECHY, REEKIE, REEKY [adj]\n",
  "REECHING": "REECH, to emit smoke, also REEK [v]\n",
  "REECHO": "to echo back, reverberate [v -ED, -ING, -ES]\n",
  "REECHOED": "REECHO, to echo back, reverberate [v]\n",
  "REECHOES": "REECHO, to echo back, reverberate [v]\n",
  "REECHOING": "REECHO, to echo back, reverberate [v]\n",
  "REECHY": "smoky, dirty, also RECHIE, REECHIE, REEKIE, REEKY [adj REECHIER, REECHIEST]\n",
  "REED": "a tall stiff hard-culmed marsh or water grass of various kinds [n -S] / to fasten or thatch with reed [v -ED, -ING, -S]\n",
  "REEDBED": "a bed of reeds [n -S]\n",
  "REEDBEDS": "REEDBED, a bed of reeds [n]\n",
  "REEDBIRD": "a kind of bird, aka bobolink [n -S]\n",
  "REEDBIRDS": "REEDBIRD, a kind of bird, aka bobolink [n]\n",
  "REEDBUCK": "a kind of African antelope, also REITBOK [n -S]\n",
  "REEDBUCKS": "REEDBUCK, a kind of African antelope, also REITBOK [n]\n",
  "REEDE": "(Spenser) counsel, also REDE [n -S]\n",
  "REEDED": "REED, to fasten or thatch with reed [v]\n",
  "REEDEN": "made of reeds [adj]\n",
  "REEDER": "a thatcher [n -S]\n",
  "REEDERS": "REEDER, a thatcher [n]\n",
  "REEDES": "REEDE, (Spenser) counsel, also REDE [n]\n",
  "REEDIER": "REEDY, abounding in reeds [adj]\n",
  "REEDIEST": "REEDY, abounding in reeds [adj]\n",
  "REEDIFIED": "REEDIFY, to rebuild (a house, wall, city, etc.), also REAEDIFY, REAEDIFYE [v]\n",
  "REEDIFIES": "REEDIFY, to rebuild (a house, wall, city, etc.), also REAEDIFY, REAEDIFYE [v]\n",
  "REEDIFY": "to rebuild (a house, wall, city, etc.), also REAEDIFY, REAEDIFYE [v REEDIFIED, REEDIFYING, REEDIFIES]\n",
  "REEDIFYING": "REEDIFY, to rebuild (a house, wall, city, etc.), also REAEDIFY, REAEDIFYE [v]\n",
  "REEDILY": "REEDY, abounding in reeds [adv]\n",
  "REEDINESS": "the quality of being reedy [n -ES]\n",
  "REEDINESSES": "REEDINESS, the quality of being reedy [n]\n",
  "REEDING": "parallel grooves cut into the edge of a coin at right angles to the faces [n -S]\n",
  "REEDINGS": "REEDING, parallel grooves cut into the edge of a coin at right angles to the faces [n]\n",
  "REEDIT": "to edit again [v -ED, -ING, -S]\n",
  "REEDITED": "REEDIT, to edit again [v]\n",
  "REEDITING": "REEDIT, to edit again [v]\n",
  "REEDITION": "the act of editing again [n -S]\n",
  "REEDITIONS": "REEDITION, the act of editing again [n]\n",
  "REEDITS": "REEDIT, to edit again [v]\n",
  "REEDLIKE": "like reeds [adj]\n",
  "REEDLING": "a marsh bird [n -S]\n",
  "REEDLINGS": "REEDLING, a marsh bird [n]\n",
  "REEDMAN": "one who plays a reed instrument [n REEDMEN]\n",
  "REEDMEN": "REEDMAN, one who plays a reed instrument [n]\n",
  "REEDS": "REED, to fasten or thatch with reed [v]\n",
  "REEDSTOP": "an organ stop that is made up of or that controls a rank of reed pipes [n -S]\n",
  "REEDSTOPS": "REEDSTOP, an organ stop that is made up of or that controls a rank of reed pipes [n]\n",
  "REEDUCATE": "to educate again [v REEDUCATED, REEDUCATING, REEDUCATES]\n",
  "REEDUCATED": "REEDUCATE, to educate again [v]\n",
  "REEDUCATES": "REEDUCATE, to educate again [v]\n",
  "REEDUCATING": "REEDUCATE, to educate again [v]\n",
  "REEDUCATION": "the act of reeducating [n -S]\n",
  "REEDUCATIONS": "REEDUCATION, the act of reeducating [n]\n",
  "REEDUCATIVE": "serving to reeducate [adj]\n",
  "REEDY": "abounding in reeds [adj REEDIER, REEDIEST, REEDILY]\n",
  "REEF": "to reduce the area of a sail [v -ED, -ING, -S]\n",
  "REEFABLE": "able to be reefed [adj]\n",
  "REEFED": "REEF, to reduce the area of a sail [v]\n",
  "REEFER": "a midshipman [n -S]\n",
  "REEFERS": "REEFER, a midshipman [n]\n",
  "REEFIER": "REEFY, abounding in ridges of rock [adj]\n",
  "REEFIEST": "REEFY, abounding in ridges of rock [adj]\n",
  "REEFING": "the act of reefing, reducing the area of a sail by rolling or folding part of it [n -S]\n",
  "REEFINGS": "REEFING, the act of reefing, reducing the area of a sail by rolling or folding part of it [n]\n",
  "REEFPOINT": "any of several short pieces of rope attached to a sail to secure it [n -S]\n",
  "REEFPOINTS": "REEFPOINT, any of several short pieces of rope attached to a sail to secure it [n]\n",
  "REEFS": "REEF, to reduce the area of a sail [v]\n",
  "REEFY": "abounding in ridges of rock [adj REEFIER, REEFIEST]\n",
  "REEJECT": "to eject again [v -ED, -ING, -S]\n",
  "REEJECTED": "REEJECT, to eject again [v]\n",
  "REEJECTING": "REEJECT, to eject again [v]\n",
  "REEJECTS": "REEJECT, to eject again [v]\n",
  "REEK": "to give off smoke, fumes or smell, also REECH [v -ED, -ING, -S]\n",
  "REEKED": "REEK, to give off smoke, fumes or smell, also REECH [v]\n",
  "REEKER": "one that reeks [n -S]\n",
  "REEKERS": "REEKER, one that reeks [n]\n",
  "REEKIE": "(Scots) smoky, reeking, also RECHIE, REECHIE, REECHY, REEKY [adj REEKIER, REEKIEST]\n",
  "REEKIER": "REEKY, (Scots) smoky, reeking, also RECHIE, REECHIE, REECHY, REEKIE [adj]\n",
  "REEKIEST": "REEKY, (Scots) smoky, reeking, also RECHIE, REECHIE, REECHY, REEKIE [adj]\n",
  "REEKING": "REEK, to give off smoke, fumes or smell, also REECH [v]\n",
  "REEKINGLY": "REEKING, REEK, to give off smoke, fumes or smell, also REECH [adv]\n",
  "REEKS": "REEK, to give off smoke, fumes or smell, also REECH [v]\n",
  "REEKY": "(Scots) smoky, reeking, also RECHIE, REECHIE, REECHY, REEKIE [adj REEKIER, REEKIEST]\n",
  "REEL": "to wind on a type of rotary device [v -ED, -ING, -S]\n",
  "REELABLE": "able to be reeled [adj]\n",
  "REELECT": "to elect again [v -ED, -ING, -S]\n",
  "REELECTED": "REELECT, to elect again [v]\n",
  "REELECTING": "REELECT, to elect again [v]\n",
  "REELECTION": "the act of electing again [n -S]\n",
  "REELECTIONS": "REELECTION, the act of electing again [n]\n",
  "REELECTS": "REELECT, to elect again [v]\n",
  "REELED": "REEL, to wind on a type of rotary device [v]\n",
  "REELER": "an instrument for reeling; esp. a machine which winds paper, yarn, etc., on to reels [n -S]\n",
  "REELERS": "REELER, an instrument for reeling; esp. a machine which winds paper, yarn, etc., on to reels [n]\n",
  "REELEVATE": "to elevate again [v REELEVATED, REELEVATING, REELEVATES]\n",
  "REELEVATED": "REELEVATE, to elevate again [v]\n",
  "REELEVATES": "REELEVATE, to elevate again [v]\n",
  "REELEVATING": "REELEVATE, to elevate again [v]\n",
  "REELIGIBILITIES": "REELIGIBILITY, the state of being reeligible [n]\n",
  "REELIGIBILITY": "the state of being reeligible [n REELIGIBILITIES]\n",
  "REELIGIBLE": "eligible again, as, reeligible to the same office [adj]\n",
  "REELING": "staggering [adj REELINGLY] / the act of reeling [n -S]\n",
  "REELINGLY": "REELING, staggering [adv]\n",
  "REELINGS": "REELING, the act of reeling [n]\n",
  "REELMAN": "the member of a lifesaving surf team who operates the reel [n REELMEN]\n",
  "REELMEN": "REELMAN, the member of a lifesaving surf team who operates the reel [n]\n",
  "REELS": "REEL, to wind on a type of rotary device [v]\n",
  "REEMBARK": "to embark again [v -ED, -ING, -S]\n",
  "REEMBARKED": "REEMBARK, to embark again [v]\n",
  "REEMBARKING": "REEMBARK, to embark again [v]\n",
  "REEMBARKS": "REEMBARK, to embark again [v]\n",
  "REEMBODIED": "REEMBODY, to embody again [v]\n",
  "REEMBODIES": "REEMBODY, to embody again [v]\n",
  "REEMBODY": "to embody again [v REEMBODIED, REEMBODYING, REEMBODIES]\n",
  "REEMBODYING": "REEMBODY, to embody again [v]\n",
  "REEMBRACE": "to embrace again [v REEMBRACED, REEMBRACING, REEMBRACES]\n",
  "REEMBRACED": "REEMBRACE, to embrace again [v]\n",
  "REEMBRACES": "REEMBRACE, to embrace again [v]\n",
  "REEMBRACING": "REEMBRACE, to embrace again [v]\n",
  "REEMBROIDER": "to outline a design, as on lace, with embroidery stitching [v -ED, -ING, -S]\n",
  "REEMBROIDERED": "REEMBROIDER, to outline a design, as on lace, with embroidery stitching [v]\n",
  "REEMBROIDERING": "REEMBROIDER, to outline a design, as on lace, with embroidery stitching [v]\n",
  "REEMBROIDERS": "REEMBROIDER, to outline a design, as on lace, with embroidery stitching [v]\n",
  "REEMERGE": "to emerge again [v REEMERGED, REEMERGING, REEMERGES]\n",
  "REEMERGED": "REEMERGE, to emerge again [v]\n",
  "REEMERGENCE": "the act of reemerging [n -S]\n",
  "REEMERGENCES": "REEMERGENCE, the act of reemerging [n]\n",
  "REEMERGES": "REEMERGE, to emerge again [v]\n",
  "REEMERGING": "REEMERGE, to emerge again [v]\n",
  "REEMISSION": "the act of emitting again [n -S]\n",
  "REEMISSIONS": "REEMISSION, the act of emitting again [n]\n",
  "REEMIT": "to emit again [v REEMITTED, REEMITTING, REEMITS]\n",
  "REEMITS": "REEMIT, to emit again [v]\n",
  "REEMITTED": "REEMIT, to emit again [v]\n",
  "REEMITTING": "REEMIT, to emit again [v]\n",
  "REEMPHASES": "REEMPHASIS, emphasis again [n]\n",
  "REEMPHASIS": "emphasis again [n REEMPHASES]\n",
  "REEMPHASISE": "to emphasise again, also REEMPHASIZE [v REEMPHASISED, REEMPHASISING, REEMPHASISES]\n",
  "REEMPHASISED": "REEMPHASISE, to emphasise again, also REEMPHASIZE [v]\n",
  "REEMPHASISES": "REEMPHASISE, to emphasise again, also REEMPHASIZE [v]\n",
  "REEMPHASISING": "REEMPHASISE, to emphasise again, also REEMPHASIZE [v]\n",
  "REEMPHASIZE": "to emphasise again, also REEMPHASISE [v REEMPHASIZED, REEMPHASIZING, REEMPHASIZES]\n",
  "REEMPHASIZED": "REEMPHASIZE, to emphasise again, also REEMPHASISE [v]\n",
  "REEMPHASIZES": "REEMPHASIZE, to emphasise again, also REEMPHASISE [v]\n",
  "REEMPHASIZING": "REEMPHASIZE, to emphasise again, also REEMPHASISE [v]\n",
  "REEMPLOY": "to employ again [v -ED, -ING, -S]\n",
  "REEMPLOYED": "REEMPLOY, to employ again [v]\n",
  "REEMPLOYING": "REEMPLOY, to employ again [v]\n",
  "REEMPLOYMENT": "the act of reemploying [n -S]\n",
  "REEMPLOYMENTS": "REEMPLOYMENT, the act of reemploying [n]\n",
  "REEMPLOYS": "REEMPLOY, to employ again [v]\n",
  "REEN": "a drainage channel, also REAN, RHINE, RHYNE [n -S]\n",
  "REENACT": "to enact again [v -ED, -ING, -S]\n",
  "REENACTED": "REENACT, to enact again [v]\n",
  "REENACTING": "REENACT, to enact again [v]\n",
  "REENACTMENT": "the act of reenacting [n -S]\n",
  "REENACTMENTS": "REENACTMENT, the act of reenacting [n]\n",
  "REENACTOR": "one who reenacts [n -S]\n",
  "REENACTORS": "REENACTOR, one who reenacts [n]\n",
  "REENACTS": "REENACT, to enact again [v]\n",
  "REENCOUNTER": "to encounter again [v -ED, -ING, -S]\n",
  "REENCOUNTERED": "REENCOUNTER, to encounter again [v]\n",
  "REENCOUNTERING": "REENCOUNTER, to encounter again [v]\n",
  "REENCOUNTERS": "REENCOUNTER, to encounter again [v]\n",
  "REENDOW": "to endow again [v -ED, -ING, -S]\n",
  "REENDOWED": "REENDOW, to endow again [v]\n",
  "REENDOWING": "REENDOW, to endow again [v]\n",
  "REENDOWS": "REENDOW, to endow again [v]\n",
  "REENERGISE": "to give new energy to, also REENERGIZE [v REENERGISED, REENERGISING, REENERGISES]\n",
  "REENERGISED": "REENERGISE, to give new energy to, also REENERGIZE [v]\n",
  "REENERGISES": "REENERGISE, to give new energy to, also REENERGIZE [v]\n",
  "REENERGISING": "REENERGISE, to give new energy to, also REENERGIZE [v]\n",
  "REENERGIZE": "to give new energy to, also REENERGISE [v REENERGIZED, REENERGIZING, REENERGIZES]\n",
  "REENERGIZED": "REENERGIZE, to give new energy to, also REENERGISE [v]\n",
  "REENERGIZES": "REENERGIZE, to give new energy to, also REENERGISE [v]\n",
  "REENERGIZING": "REENERGIZE, to give new energy to, also REENERGISE [v]\n",
  "REENFORCE": "to strengthen with new force, assistance, material, or support, also REINFORCE, RENFORCE [v REENFORCED, REENFORCING, REENFORCES]\n",
  "REENFORCED": "REENFORCE, to strengthen with new force, assistance, material, or support, also REINFORCE, RENFORCE [v]\n",
  "REENFORCES": "REENFORCE, to strengthen with new force, assistance, material, or support, also REINFORCE, RENFORCE [v]\n",
  "REENFORCING": "REENFORCE, to strengthen with new force, assistance, material, or support, also REINFORCE, RENFORCE [v]\n",
  "REENGAGE": "to engage again [v REENGAGED, REENGAGING, REENGAGES]\n",
  "REENGAGED": "REENGAGE, to engage again [v]\n",
  "REENGAGEMENT": "the act of reengaging [n -S]\n",
  "REENGAGEMENTS": "REENGAGEMENT, the act of reengaging [n]\n",
  "REENGAGES": "REENGAGE, to engage again [v]\n",
  "REENGAGING": "REENGAGE, to engage again [v]\n",
  "REENGINEER": "to engineer again [v -ED, -ING, -S]\n",
  "REENGINEERED": "REENGINEER, to engineer again [v]\n",
  "REENGINEERING": "REENGINEER, to engineer again [v]\n",
  "REENGINEERS": "REENGINEER, to engineer again [v]\n",
  "REENGRAVE": "to engrave anew [v REENGRAVED, REENGRAVING, REENGRAVES]\n",
  "REENGRAVED": "REENGRAVE, to engrave anew [v]\n",
  "REENGRAVES": "REENGRAVE, to engrave anew [v]\n",
  "REENGRAVING": "REENGRAVE, to engrave anew [v]\n",
  "REENJOY": "to enjoy again [v -ED, -ING, -S]\n",
  "REENJOYED": "REENJOY, to enjoy again [v]\n",
  "REENJOYING": "REENJOY, to enjoy again [v]\n",
  "REENJOYS": "REENJOY, to enjoy again [v]\n",
  "REENLARGE": "to enlarge again [v REENLARGED, REENLARGING, REENLARGES]\n",
  "REENLARGED": "REENLARGE, to enlarge again [v]\n",
  "REENLARGES": "REENLARGE, to enlarge again [v]\n",
  "REENLARGING": "REENLARGE, to enlarge again [v]\n",
  "REENLIST": "to enlist again [v -ED, -ING, -S]\n",
  "REENLISTED": "REENLIST, to enlist again [v]\n",
  "REENLISTING": "REENLIST, to enlist again [v]\n",
  "REENLISTMENT": "the act of reenlisting [n -S]\n",
  "REENLISTMENTS": "REENLISTMENT, the act of reenlisting [n]\n",
  "REENLISTS": "REENLIST, to enlist again [v]\n",
  "REENROLL": "to enroll again [v -ED, -ING, -S]\n",
  "REENROLLED": "REENROLL, to enroll again [v]\n",
  "REENROLLING": "REENROLL, to enroll again [v]\n",
  "REENROLLS": "REENROLL, to enroll again [v]\n",
  "REENS": "REEN, a drainage channel, also REAN, RHINE, RHYNE [n]\n",
  "REENSLAVE": "to enslave again [v REENSLAVED, REENSLAVING, REENSLAVES]\n",
  "REENSLAVED": "REENSLAVE, to enslave again [v]\n",
  "REENSLAVES": "REENSLAVE, to enslave again [v]\n",
  "REENSLAVING": "REENSLAVE, to enslave again [v]\n",
  "REENTER": "to enter again [v -ED, -ING, -S]\n",
  "REENTERED": "REENTER, to enter again [v]\n",
  "REENTERING": "REENTER, to enter again [v]\n",
  "REENTERS": "REENTER, to enter again [v]\n",
  "REENTHRONE": "to enthrone again [v REENTHRONED, REENTHRONING, REENTHRONES]\n",
  "REENTHRONED": "REENTHRONE, to enthrone again [v]\n",
  "REENTHRONES": "REENTHRONE, to enthrone again [v]\n",
  "REENTHRONING": "REENTHRONE, to enthrone again [v]\n",
  "REENTRANCE": "reentry [n -S]\n",
  "REENTRANCES": "REENTRANCE, reentry [n]\n",
  "REENTRANT": "something that reenters or turns in on itself [n -S]\n",
  "REENTRANTS": "REENTRANT, something that reenters or turns in on itself [n]\n",
  "REENTRIES": "REENTRY, a second entry [n]\n",
  "REENTRY": "a second entry [n REENTRIES]\n",
  "REEQUIP": "to equip again [v REEQUIPPED, REEQUIPPING, REEQUIPS]\n",
  "REEQUIPMENT": "the act of reequipping [n -S]\n",
  "REEQUIPMENTS": "REEQUIPMENT, the act of reequipping [n]\n",
  "REEQUIPPED": "REEQUIP, to equip again [v]\n",
  "REEQUIPPING": "REEQUIP, to equip again [v]\n",
  "REEQUIPS": "REEQUIP, to equip again [v]\n",
  "REERECT": "to erect again [v -ED, -ING, -S]\n",
  "REERECTED": "REERECT, to erect again [v]\n",
  "REERECTING": "REERECT, to erect again [v]\n",
  "REERECTS": "REERECT, to erect again [v]\n",
  "REES": "REE, (Scots) a walled enclosure for sheep [n]\n",
  "REESCALATE": "to escalate again [v REESCALATED, REESCALATING, REESCALATES]\n",
  "REESCALATED": "REESCALATE, to escalate again [v]\n",
  "REESCALATES": "REESCALATE, to escalate again [v]\n",
  "REESCALATING": "REESCALATE, to escalate again [v]\n",
  "REESCALATION": "the act of reescalating [n -S]\n",
  "REESCALATIONS": "REESCALATION, the act of reescalating [n]\n",
  "REEST": "esp of horses, to be noisily uncooperative, also REAST [v -ED, -ING, -S]\n",
  "REESTABLISH": "to establish again [v -ED, -ING, -ES]\n",
  "REESTABLISHED": "REESTABLISH, to establish again [v]\n",
  "REESTABLISHES": "REESTABLISH, to establish again [v]\n",
  "REESTABLISHING": "REESTABLISH, to establish again [v]\n",
  "REESTABLISHMENT": "the act of reestablishing [n]\n",
  "REESTED": "REEST, esp of horses, to be noisily uncooperative, also REAST [v]\n",
  "REESTIER": "REESTY, of a horse, liable to balk [adj]\n",
  "REESTIEST": "REESTY, of a horse, liable to balk [adj]\n",
  "REESTIMATE": "to estimate again [v REESTIMATED, REESTIMATING, REESTIMATES]\n",
  "REESTIMATED": "REESTIMATE, to estimate again [v]\n",
  "REESTIMATES": "REESTIMATE, to estimate again [v]\n",
  "REESTIMATING": "REESTIMATE, to estimate again [v]\n",
  "REESTING": "REEST, esp of horses, to be noisily uncooperative, also REAST [v]\n",
  "REESTS": "REEST, esp of horses, to be noisily uncooperative, also REAST [v]\n",
  "REESTY": "of a horse, liable to balk [adj REESTIER, REESTIEST]\n",
  "REEVALUATE": "to evaluate again [v REEVALUATED, REEVALUATING, REEVALUATES]\n",
  "REEVALUATED": "REEVALUATE, to evaluate again [v]\n",
  "REEVALUATES": "REEVALUATE, to evaluate again [v]\n",
  "REEVALUATING": "REEVALUATE, to evaluate again [v]\n",
  "REEVALUATION": "the act of reevaluating [n -S]\n",
  "REEVALUATIONS": "REEVALUATION, the act of reevaluating [n]\n",
  "REEVE": "to fasten by passing through or around something [v REEVED or ROVE, ROVEN, REEVING, REEVES]\n",
  "REEVED": "REEVE, to fasten by passing through or around something [v]\n",
  "REEVES": "REEVE, to fasten by passing through or around something [v]\n",
  "REEVESHIP": "the office of reeve [n -S]\n",
  "REEVESHIPS": "REEVESHIP, the office of reeve [n]\n",
  "REEVING": "REEVE, to fasten by passing through or around something [v]\n",
  "REEVOKE": "to evoke again [v REEVOKED, REEVOKING, REEVOKES]\n",
  "REEVOKED": "REEVOKE, to evoke again [v]\n",
  "REEVOKES": "REEVOKE, to evoke again [v]\n",
  "REEVOKING": "REEVOKE, to evoke again [v]\n",
  "REEXAMINATION": "the act of reexamining [n -S]\n",
  "REEXAMINATIONS": "REEXAMINATION, the act of reexamining [n]\n",
  "REEXAMINE": "to examine again [v REEXAMINED, REEXAMINING, REEXAMINES]\n",
  "REEXAMINED": "REEXAMINE, to examine again [v]\n",
  "REEXAMINES": "REEXAMINE, to examine again [v]\n",
  "REEXAMINING": "REEXAMINE, to examine again [v]\n",
  "REEXECUTE": "to execute again [v REEXECUTED, REEXECUTING, REEXECUTES]\n",
  "REEXECUTED": "REEXECUTE, to execute again [v]\n",
  "REEXECUTES": "REEXECUTE, to execute again [v]\n",
  "REEXECUTING": "REEXECUTE, to execute again [v]\n",
  "REEXHIBIT": "to exhibit again [v -ED, -ING, -S]\n",
  "REEXHIBITED": "REEXHIBIT, to exhibit again [v]\n",
  "REEXHIBITING": "REEXHIBIT, to exhibit again [v]\n",
  "REEXHIBITS": "REEXHIBIT, to exhibit again [v]\n",
  "REEXPEL": "to expel again [v REEXPELLED, REEXPELLING, REEXPELS]\n",
  "REEXPELLED": "REEXPEL, to expel again [v]\n",
  "REEXPELLING": "REEXPEL, to expel again [v]\n",
  "REEXPELS": "REEXPEL, to expel again [v]\n",
  "REEXPERIENCE": "to experience again [v REEXPERIENCED, REEXPERIENCING, REEXPERIENCES]\n",
  "REEXPERIENCED": "REEXPERIENCE, to experience again [v]\n",
  "REEXPERIENCES": "REEXPERIENCE, to experience again [v]\n",
  "REEXPERIENCING": "REEXPERIENCE, to experience again [v]\n",
  "REEXPLAIN": "to explain again [v -ED, -ING, -S]\n",
  "REEXPLAINED": "REEXPLAIN, to explain again [v]\n",
  "REEXPLAINING": "REEXPLAIN, to explain again [v]\n",
  "REEXPLAINS": "REEXPLAIN, to explain again [v]\n",
  "REEXPLORE": "to explore again [v REEXPLORED, REEXPLORING, REEXPLORES]\n",
  "REEXPLORED": "REEXPLORE, to explore again [v]\n",
  "REEXPLORES": "REEXPLORE, to explore again [v]\n",
  "REEXPLORING": "REEXPLORE, to explore again [v]\n",
  "REEXPORT": "to export again [v -ED, -ING, -S]\n",
  "REEXPORTATION": "the act of reexporting [n -S]\n",
  "REEXPORTATIONS": "REEXPORTATION, the act of reexporting [n]\n",
  "REEXPORTED": "REEXPORT, to export again [v]\n",
  "REEXPORTING": "REEXPORT, to export again [v]\n",
  "REEXPORTS": "REEXPORT, to export again [v]\n",
  "REEXPOSE": "to expose again [v REEXPOSED, REEXPOSING, REEXPOSES]\n",
  "REEXPOSED": "REEXPOSE, to expose again [v]\n",
  "REEXPOSES": "REEXPOSE, to expose again [v]\n",
  "REEXPOSING": "REEXPOSE, to expose again [v]\n",
  "REEXPOSURE": "a new exposure [n -S]\n",
  "REEXPOSURES": "REEXPOSURE, a new exposure [n]\n",
  "REEXPRESS": "to express again [v -ED, -ING, -ES]\n",
  "REEXPRESSED": "REEXPRESS, to express again [v]\n",
  "REEXPRESSES": "REEXPRESS, to express again [v]\n",
  "REEXPRESSING": "REEXPRESS, to express again [v]\n",
  "REF": "to referee [v REFFED, REFFING, REFS]\n",
  "REFACE": "to repair the outer surface of [v REFACED, REFACING, REFACES]\n",
  "REFACED": "REFACE, to repair the outer surface of [v]\n",
  "REFACES": "REFACE, to repair the outer surface of [v]\n",
  "REFACING": "REFACE, to repair the outer surface of [v]\n",
  "REFALL": "to fall again [v REFELL, REFALLEN, REFALLING, REFALLS]\n",
  "REFALLEN": "REFALL, to fall again [v]\n",
  "REFALLING": "REFALL, to fall again [v]\n",
  "REFALLS": "REFALL, to fall again [v]\n",
  "REFASHION": "to fashion again [v -ED, -ING, -S]\n",
  "REFASHIONED": "REFASHION, to fashion again [v]\n",
  "REFASHIONING": "REFASHION, to fashion again [v]\n",
  "REFASHIONMENT": "the act of refashioning [n -S]\n",
  "REFASHIONMENTS": "REFASHIONMENT, the act of refashioning [n]\n",
  "REFASHIONS": "REFASHION, to fashion again [v]\n",
  "REFASTEN": "to fasten again [v -ED, -ING, -S]\n",
  "REFASTENED": "REFASTEN, to fasten again [v]\n",
  "REFASTENING": "REFASTEN, to fasten again [v]\n",
  "REFASTENS": "REFASTEN, to fasten again [v]\n",
  "REFECT": "to refresh with food and drink [v -ED, -ING, -S]\n",
  "REFECTED": "REFECT, to refresh with food and drink [v]\n",
  "REFECTING": "REFECT, to refresh with food and drink [v]\n",
  "REFECTION": "refreshment; a meal [n -S]\n",
  "REFECTIONER": "the officer in charge of the refectory and its arrangements, also REFECTORIAN [n -S]\n",
  "REFECTIONERS": "REFECTIONER, the officer in charge of the refectory and its arrangements, also REFECTORIAN [n]\n",
  "REFECTIONS": "REFECTION, refreshment; a meal [n]\n",
  "REFECTIVE": "relating to refection [adj]\n",
  "REFECTORIAN": "the officer in charge of the refectory and its arrangements, also REFECTIONER [n -S]\n",
  "REFECTORIANS": "REFECTORIAN, the officer in charge of the refectory and its arrangements, also REFECTIONER [n]\n",
  "REFECTORIES": "REFECTORY, the dining-hall of a monastery or other institution [n]\n",
  "REFECTORY": "the dining-hall of a monastery or other institution [n REFECTORIES]\n",
  "REFECTS": "REFECT, to refresh with food and drink [v]\n",
  "REFED": "REFEED, to feed again [v]\n",
  "REFEED": "to feed again [v REFED, REFEEDING, REFEEDS]\n",
  "REFEEDING": "the act of feeding again [n -S]\n",
  "REFEEDINGS": "REFEEDING, the act of feeding again [n]\n",
  "REFEEDS": "REFEED, to feed again [v]\n",
  "REFEEL": "to feel again [v REFELT, REFEELING, REFEELS]\n",
  "REFEELING": "REFEEL, to feel again [v]\n",
  "REFEELS": "REFEEL, to feel again [v]\n",
  "REFEL": "(obsolete) to refute; to disprove [v REFELLED, REFELLING, REFELS]\n",
  "REFELL": "REFALL, to fall again [v]\n",
  "REFELLED": "REFEL, (obsolete) to refute; to disprove [v]\n",
  "REFELLING": "REFEL, (obsolete) to refute; to disprove [v]\n",
  "REFELS": "REFEL, (obsolete) to refute; to disprove [v]\n",
  "REFELT": "REFEEL, to feel again [v]\n",
  "REFENCE": "to fence again [v REFENCED, REFENCING, REFENCES]\n",
  "REFENCED": "REFENCE, to fence again [v]\n",
  "REFENCES": "REFENCE, to fence again [v]\n",
  "REFENCING": "REFENCE, to fence again [v]\n",
  "REFER": "to direct to a source for help or information [v REFERRED, REFERRING, REFERS]\n",
  "REFERABLE": "capable of being referred, also REFERRABLE, REFERRIBLE [adj]\n",
  "REFEREE": "to supervise the play in certain sports [v REFEREED, REFEREEING, REFEREES]\n",
  "REFEREED": "REFEREE, to supervise the play in certain sports [v]\n",
  "REFEREEING": "acting as a referee [n -S]\n",
  "REFEREEINGS": "REFEREEING, acting as a referee [n]\n",
  "REFEREES": "REFEREE, to supervise the play in certain sports [v]\n",
  "REFERENCE": "to refer to [v REFERENCED, REFERENCING, REFERENCES]\n",
  "REFERENCED": "REFERENCE, to refer to [v]\n",
  "REFERENCER": "one who references [n -S]\n",
  "REFERENCERS": "REFERENCER, one who references [n]\n",
  "REFERENCES": "REFERENCE, to refer to [v]\n",
  "REFERENCING": "the act of referring to [n -S]\n",
  "REFERENCINGS": "REFERENCING, the act of referring to [n]\n",
  "REFERENDA": "REFERENDUM, (Latin) the process or principle of referring an important political question to the nation as a whole [n]\n",
  "REFERENDARIES": "REFERENDARY, a referee; formerly a court official who was the medium of communication with the Pope, emperor etc. [n]\n",
  "REFERENDARY": "a referee; formerly a court official who was the medium of communication with the Pope, emperor etc. [n REFERENDARIES]\n",
  "REFERENDUM": "(Latin) the process or principle of referring an important political question to the nation as a whole [n REFERENDA or REFERENDUMS]\n",
  "REFERENDUMS": "REFERENDUM, (Latin) the process or principle of referring an important political question to the nation as a whole [n]\n",
  "REFERENT": "something referred to [n -S]\n",
  "REFERENTIAL": "of, containing, or constituting a reference [adj REFERENTIALLY]\n",
  "REFERENTIALITY": "the state of being referential [n]\n",
  "REFERENTIALLY": "REFERENTIAL, of, containing, or constituting a reference [adv]\n",
  "REFERENTS": "REFERENT, something referred to [n]\n",
  "REFERRABLE": "capable of being referred, also REFERABLE, REFERRIBLE [adj]\n",
  "REFERRAL": "an instance of being referred to another [n -S]\n",
  "REFERRALS": "REFERRAL, an instance of being referred to another [n]\n",
  "REFERRED": "REFER, to direct to a source for help or information [v]\n",
  "REFERRER": "one that refers [n -S]\n",
  "REFERRERS": "REFERRER, one that refers [n]\n",
  "REFERRIBLE": "capable of being referred, also REFERABLE, REFERRABLE [adj]\n",
  "REFERRING": "REFER, to direct to a source for help or information [v]\n",
  "REFERS": "REFER, to direct to a source for help or information [v]\n",
  "REFFED": "REF, to referee [v]\n",
  "REFFING": "the job of a referee [n -S]\n",
  "REFFINGS": "REFFING, the job of a referee [n]\n",
  "REFFO": "(Australian slang) a refugee [n -S]\n",
  "REFFOS": "REFFO, (Australian slang) a refugee [n]\n",
  "REFI": "(short for) refinancing [n -S]\n",
  "REFIGHT": "to fight again [v REFOUGHT, REFIGHTING, REFIGHTS]\n",
  "REFIGHTING": "REFIGHT, to fight again [v]\n",
  "REFIGHTS": "REFIGHT, to fight again [v]\n",
  "REFIGURE": "to figure again [v REFIGURED, REFIGURING, REFIGURES]\n",
  "REFIGURED": "REFIGURE, to figure again [v]\n",
  "REFIGURES": "REFIGURE, to figure again [v]\n",
  "REFIGURING": "REFIGURE, to figure again [v]\n",
  "REFILE": "to file again [v REFILED, REFILING, REFILES]\n",
  "REFILED": "REFILE, to file again [v]\n",
  "REFILES": "REFILE, to file again [v]\n",
  "REFILING": "REFILE, to file again [v]\n",
  "REFILL": "to fill again [v -ED, -ING, -S]\n",
  "REFILLABLE": "that can be refilled [adj]\n",
  "REFILLED": "REFILL, to fill again [v]\n",
  "REFILLING": "REFILL, to fill again [v]\n",
  "REFILLS": "REFILL, to fill again [v]\n",
  "REFILM": "to film again [v -ED, -ING, -S]\n",
  "REFILMED": "REFILM, to film again [v]\n",
  "REFILMING": "REFILM, to film again [v]\n",
  "REFILMS": "REFILM, to film again [v]\n",
  "REFILTER": "to filter again [v -ED, -ING, -S]\n",
  "REFILTERED": "REFILTER, to filter again [v]\n",
  "REFILTERING": "REFILTER, to filter again [v]\n",
  "REFILTERS": "REFILTER, to filter again [v]\n",
  "REFINABLE": "that can be refined [adj]\n",
  "REFINANCE": "to finance again [v REFINANCED, REFINANCING, REFINANCES]\n",
  "REFINANCED": "REFINANCE, to finance again [v]\n",
  "REFINANCES": "REFINANCE, to finance again [v]\n",
  "REFINANCING": "the act of financing again [n -S]\n",
  "REFINANCINGS": "REFINANCING, the act of financing again [n]\n",
  "REFIND": "to find again [v REFOUND, REFINDING, REFINDS]\n",
  "REFINDING": "REFIND, to find again [v]\n",
  "REFINDS": "REFIND, to find again [v]\n",
  "REFINE": "to free from impurities [v REFINED, REFINING, REFINES]\n",
  "REFINED": "REFINE, to free from impurities [v]\n",
  "REFINEDLY": "REFINED, REFINE, to free from impurities [adv]\n",
  "REFINEDNESS": "the state of being refined [n -ES]\n",
  "REFINEDNESSES": "REFINEDNESS, the state of being refined [n]\n",
  "REFINEMENT": "the act of refining [n -S]\n",
  "REFINEMENTS": "REFINEMENT, the act of refining [n]\n",
  "REFINER": "one who, or that which, refines [n -S]\n",
  "REFINERIES": "REFINERY, a place where crude material is refined [n]\n",
  "REFINERS": "REFINER, one who, or that which, refines [n]\n",
  "REFINERY": "a place where crude material is refined [n REFINERIES]\n",
  "REFINES": "REFINE, to free from impurities [v]\n",
  "REFINING": "the act of refining [n -S]\n",
  "REFININGS": "REFINING, the act of refining [n]\n",
  "REFINISH": "to give a new surface to [v -ED, -ING, -ES]\n",
  "REFINISHED": "REFINISH, to give a new surface to [v]\n",
  "REFINISHER": "one who finishes again [n -S]\n",
  "REFINISHERS": "REFINISHER, one who finishes again [n]\n",
  "REFINISHES": "REFINISH, to give a new surface to [v]\n",
  "REFINISHING": "REFINISH, to give a new surface to [v]\n",
  "REFIRE": "to fire again [v REFIRED, REFIRING, REFIRES]\n",
  "REFIRED": "REFIRE, to fire again [v]\n",
  "REFIRES": "REFIRE, to fire again [v]\n",
  "REFIRING": "REFIRE, to fire again [v]\n",
  "REFIS": "REFI, (short for) refinancing [n]\n",
  "REFIT": "to fit out afresh and repair [v REFITTED, REFITTING, REFITS]\n",
  "REFITMENT": "the act of refitting, or the state of being refitted [n -S]\n",
  "REFITMENTS": "REFITMENT, the act of refitting, or the state of being refitted [n]\n",
  "REFITS": "REFIT, to fit out afresh and repair [v]\n",
  "REFITTED": "REFIT, to fit out afresh and repair [v]\n",
  "REFITTING": "the act of refitting [n -S]\n",
  "REFITTINGS": "REFITTING, the act of refitting [n]\n",
  "REFIX": "to fix again [v -ED, -ING, -ES]\n",
  "REFIXED": "REFIX, to fix again [v]\n",
  "REFIXES": "REFIX, to fix again [v]\n",
  "REFIXING": "REFIX, to fix again [v]\n",
  "REFLAG": "to change the flag [v REFLAGGED, REFLAGGING, REFLAGS]\n",
  "REFLAGGED": "REFLAG, to change the flag [v]\n",
  "REFLAGGING": "REFLAG, to change the flag [v]\n",
  "REFLAGS": "REFLAG, to change the flag [v]\n",
  "REFLATE": "to inflate again [v REFLATED, REFLATING, REFLATES]\n",
  "REFLATED": "REFLATE, to inflate again [v]\n",
  "REFLATES": "REFLATE, to inflate again [v]\n",
  "REFLATING": "REFLATE, to inflate again [v]\n",
  "REFLATION": "an increase in amount of economic activity and spending [n -S]\n",
  "REFLATIONARY": "relating to reflation [adj]\n",
  "REFLATIONS": "REFLATION, an increase in amount of economic activity and spending [n]\n",
  "REFLECT": "to be mirrored [v -ED, -ING, -S]\n",
  "REFLECTANCE": "the ratio of reflected radiation to incident radiation [n -S]\n",
  "REFLECTANCES": "REFLECTANCE, the ratio of reflected radiation to incident radiation [n]\n",
  "REFLECTED": "REFLECT, to be mirrored [v]\n",
  "REFLECTER": "(Swift) a person who casts reflections [n -S]\n",
  "REFLECTERS": "REFLECTER, (Swift) a person who casts reflections [n]\n",
  "REFLECTING": "REFLECT, to be mirrored [v]\n",
  "REFLECTINGLY": "REFLECTING, REFLECT, to be mirrored [adv]\n",
  "REFLECTION": "an image given back by a reflecting surface [n -S]\n",
  "REFLECTIONAL": "relating to reflection, also REFLEXIONAL [adj]\n",
  "REFLECTIONLESS": "without reflection, an image given back by a reflecting surface [adj]\n",
  "REFLECTIONS": "REFLECTION, an image given back by a reflecting surface [n]\n",
  "REFLECTIVE": "capable of reflecting light, images, or sound waves [adj REFLECTIVELY]\n",
  "REFLECTIVELY": "REFLECTIVE, capable of reflecting light, images, or sound waves [adv]\n",
  "REFLECTIVENESS": "REFLECTIVE, capable of reflecting light, images, or sound waves [n]\n",
  "REFLECTIVITIES": "REFLECTIVITY, the state of being reflective [n]\n",
  "REFLECTIVITY": "the state of being reflective [n REFLECTIVITIES]\n",
  "REFLECTOGRAM": "an image produced by reflectography [n -S]\n",
  "REFLECTOGRAMS": "REFLECTOGRAM, an image produced by reflectography [n]\n",
  "REFLECTOGRAPH": "an image produced by reflectography [n -S]\n",
  "REFLECTOGRAPHS": "REFLECTOGRAPH, an image produced by reflectography [n]\n",
  "REFLECTOGRAPHY": "a technique used to detect underdrawing, etc. in a painting, in which infrared light is bounced off the lowest, gessoed layer and the resulting image viewed on a TV monitor [n]\n",
  "REFLECTOMETER": "instrument for measuring reflectance of radiant energy [n -S]\n",
  "REFLECTOMETERS": "REFLECTOMETER, instrument for measuring reflectance of radiant energy [n]\n",
  "REFLECTOMETRIES": "REFLECTOMETRY, measurement by reflectometer [n]\n",
  "REFLECTOMETRY": "measurement by reflectometer [n REFLECTOMETRIES]\n",
  "REFLECTOR": "something or someone that reflects [n -S]\n",
  "REFLECTORISE": "to make reflecting, also REFLECTORIZE [v REFLECTORISED, REFLECTORISING, REFLECTORISES]\n",
  "REFLECTORISED": "REFLECTORISE, to make reflecting, also REFLECTORIZE [v]\n",
  "REFLECTORISES": "REFLECTORISE, to make reflecting, also REFLECTORIZE [v]\n",
  "REFLECTORISING": "REFLECTORISE, to make reflecting, also REFLECTORIZE [v]\n",
  "REFLECTORIZE": "to make reflecting, also REFLECTORISE [v REFLECTORIZED, REFLECTORIZING, REFLECTORIZES]\n",
  "REFLECTORIZED": "REFLECTORIZE, to make reflecting, also REFLECTORISE [v]\n",
  "REFLECTORIZES": "REFLECTORIZE, to make reflecting, also REFLECTORISE [v]\n",
  "REFLECTORIZING": "REFLECTORIZE, to make reflecting, also REFLECTORISE [v]\n",
  "REFLECTORS": "REFLECTOR, something or someone that reflects [n]\n",
  "REFLECTS": "REFLECT, to be mirrored [v]\n",
  "REFLET": "(French) an iridescent or metallic lustre [n -S]\n",
  "REFLETS": "REFLET, (French) an iridescent or metallic lustre [n]\n",
  "REFLEW": "REFLY, to fly again [v]\n",
  "REFLEX": "bent backwards [adj REFLEXLY] / to bend back [v -ED, -ING, -ES]\n",
  "REFLEXED": "REFLEX, to bend back [v]\n",
  "REFLEXES": "REFLEX, to bend back [v]\n",
  "REFLEXIBILITIES": "REFLEXIBILITY, the state of being reflexible, capable of being reflected [n]\n",
  "REFLEXIBILITY": "the state of being reflexible, capable of being reflected [n REFLEXIBILITIES]\n",
  "REFLEXIBLE": "capable of being reflected, or thrown back [adj]\n",
  "REFLEXING": "REFLEX, to bend back [v]\n",
  "REFLEXION": "the act of reflexing, bending back [n -S]\n",
  "REFLEXIONAL": "relating to reflexion, also REFLECTIONAL [adj]\n",
  "REFLEXIONS": "REFLEXION, the act of reflexing, bending back [n]\n",
  "REFLEXIVE": "indicating that the action turns back upon the subject; relating to a reflex [adj REFLEXIVELY] / a reflexive pronoun or verb [n -S]\n",
  "REFLEXIVELY": "REFLEXIVE, indicating that the action turns back upon the subject; relating to a reflex [adv]\n",
  "REFLEXIVENESS": "REFLEXIVE, indicating that the action turns back upon the subject; relating to a reflex [n]\n",
  "REFLEXIVENESSES": "REFLEXIVENESS, REFLEXIVE, indicating that the action turns back upon the subject; relating to a reflex [n]\n",
  "REFLEXIVES": "REFLEXIVE, a reflexive pronoun or verb [n]\n",
  "REFLEXIVITIES": "REFLEXIVITY, the state of being reflexive [n]\n",
  "REFLEXIVITY": "the state of being reflexive [n REFLEXIVITIES]\n",
  "REFLEXLY": "REFLEX, bent backwards [adv]\n",
  "REFLEXOLOGICAL": "related to reflexology [adj]\n",
  "REFLEXOLOGIES": "REFLEXOLOGY, a form of therapy for treating particular bodily ailments and general stress [n]\n",
  "REFLEXOLOGIST": "a specialist in reflexology [n -S]\n",
  "REFLEXOLOGISTS": "REFLEXOLOGIST, a specialist in reflexology [n]\n",
  "REFLEXOLOGY": "a form of therapy for treating particular bodily ailments and general stress [n REFLEXOLOGIES]\n",
  "REFLIES": "REFLY, to fly again [v]\n",
  "REFLOAT": "to float again [v -ED, -ING, -S]\n",
  "REFLOATED": "REFLOAT, to float again [v]\n",
  "REFLOATING": "REFLOAT, to float again [v]\n",
  "REFLOATS": "REFLOAT, to float again [v]\n",
  "REFLOOD": "to flood again [v -ED, -ING, -S]\n",
  "REFLOODED": "REFLOOD, to flood again [v]\n",
  "REFLOODING": "REFLOOD, to flood again [v]\n",
  "REFLOODS": "REFLOOD, to flood again [v]\n",
  "REFLOW": "to flow again [v -ED, -ING, -S]\n",
  "REFLOWED": "REFLOW, to flow again [v]\n",
  "REFLOWER": "to flower again [v -ED, -ING, -S]\n",
  "REFLOWERED": "REFLOWER, to flower again [v]\n",
  "REFLOWERING": "the act of reflowering [n -S]\n",
  "REFLOWERINGS": "REFLOWERING, the act of reflowering [n]\n",
  "REFLOWERS": "REFLOWER, to flower again [v]\n",
  "REFLOWING": "the act of reflowing [n -S]\n",
  "REFLOWINGS": "REFLOWING, the act of reflowing [n]\n",
  "REFLOWN": "REFLY, to fly again [v]\n",
  "REFLOWS": "REFLOW, to flow again [v]\n",
  "REFLUENCE": "a flowing back, ebb, also REFLUX [n -S]\n",
  "REFLUENCES": "REFLUENCE, a flowing back, ebb, also REFLUX [n]\n",
  "REFLUENT": "flowing back [adj]\n",
  "REFLUX": "to cause to flow back [v -ED, -ING, -ES]\n",
  "REFLUXED": "REFLUX, to cause to flow back [v]\n",
  "REFLUXES": "REFLUX, to cause to flow back [v]\n",
  "REFLUXING": "REFLUX, to cause to flow back [v]\n",
  "REFLY": "to fly again [v REFLEW, REFLOWN, REFLYING, REFLIES]\n",
  "REFLYING": "REFLY, to fly again [v]\n",
  "REFOCILLATE": "(obsolete) to refresh; to cherish [v REFOCILLATED, REFOCILLATING, REFOCILLATES]\n",
  "REFOCILLATED": "REFOCILLATE, (obsolete) to refresh; to cherish [v]\n",
  "REFOCILLATES": "REFOCILLATE, (obsolete) to refresh; to cherish [v]\n",
  "REFOCILLATING": "REFOCILLATE, (obsolete) to refresh; to cherish [v]\n",
  "REFOCILLATION": "the act of refocillating, refreshing [n -S]\n",
  "REFOCILLATIONS": "REFOCILLATION, the act of refocillating, refreshing [n]\n",
  "REFOCUS": "to focus again [v REFOCUSSED or REFOCUSED, REFOCUSSING or REFOCUSING, REFOCUSSES or REFOCUSES]\n",
  "REFOCUSED": "REFOCUS, to focus again [v]\n",
  "REFOCUSES": "REFOCUS, to focus again [v]\n",
  "REFOCUSING": "REFOCUS, to focus again [v]\n",
  "REFOCUSSED": "REFOCUS, to focus again [v]\n",
  "REFOCUSSES": "REFOCUS, to focus again [v]\n",
  "REFOCUSSING": "REFOCUS, to focus again [v]\n",
  "REFOLD": "to fold again [v -ED, -ING, -S]\n",
  "REFOLDED": "REFOLD, to fold again [v]\n",
  "REFOLDING": "REFOLD, to fold again [v]\n",
  "REFOLDS": "REFOLD, to fold again [v]\n",
  "REFOOT": "to replace the foot of [v -ED, -ING, -S]\n",
  "REFOOTED": "REFOOT, to replace the foot of [v]\n",
  "REFOOTING": "REFOOT, to replace the foot of [v]\n",
  "REFOOTS": "REFOOT, to replace the foot of [v]\n",
  "REFOREST": "to replant with trees [v -ED, -ING, -S]\n",
  "REFORESTATION": "the action of renewing forest cover, as by natural seeding or by the artificial planting of seeds or young trees [n -S]\n",
  "REFORESTATIONS": "REFORESTATION, the action of renewing forest cover, as by natural seeding or by the artificial planting of seeds or young trees [n]\n",
  "REFORESTED": "REFOREST, to replant with trees [v]\n",
  "REFORESTING": "REFOREST, to replant with trees [v]\n",
  "REFORESTS": "REFOREST, to replant with trees [v]\n",
  "REFORGE": "to forge again [v REFORGED, REFORGING, REFORGES]\n",
  "REFORGED": "REFORGE, to forge again [v]\n",
  "REFORGES": "REFORGE, to forge again [v]\n",
  "REFORGING": "REFORGE, to forge again [v]\n",
  "REFORM": "to change to a better state [v -ED, -ING, -S]\n",
  "REFORMABILITIES": "REFORMABILITY, the state of being reformable [n]\n",
  "REFORMABILITY": "the state of being reformable [n REFORMABILITIES]\n",
  "REFORMABLE": "capable of being reformed [adj]\n",
  "REFORMADE": "(Spanish) a monk of a reformed order, also REFORMADO [n -S]\n",
  "REFORMADES": "REFORMADE, (Spanish) a monk of a reformed order, also REFORMADO [n]\n",
  "REFORMADO": "(Spanish) a monk of a reformed order, also REFORMADE [n -ES or -S]\n",
  "REFORMADOES": "REFORMADO, (Spanish) a monk of a reformed order, also REFORMADE [n]\n",
  "REFORMADOS": "REFORMADO, (Spanish) a monk of a reformed order, also REFORMADE [n]\n",
  "REFORMAT": "to change the format [v REFORMATTED, REFORMATTING, REFORMATS]\n",
  "REFORMATE": "a product of hydrocarbon reforming [n -S]\n",
  "REFORMATES": "REFORMATE, a product of hydrocarbon reforming [n]\n",
  "REFORMATION": "the act of reforming [n -S]\n",
  "REFORMATIONAL": "relating to reformation [adj]\n",
  "REFORMATIONIST": "a supporter of reformation [n -S]\n",
  "REFORMATIONISTS": "REFORMATIONIST, a supporter of reformation [n]\n",
  "REFORMATIONS": "REFORMATION, the act of reforming [n]\n",
  "REFORMATIVE": "intended or tending to reform [adj]\n",
  "REFORMATORIES": "REFORMATORY, a penal institution to which esp. young or first offenders are committed for training and reformation [n]\n",
  "REFORMATORY": "a penal institution to which esp. young or first offenders are committed for training and reformation [n REFORMATORIES]\n",
  "REFORMATS": "REFORMAT, to change the format [v]\n",
  "REFORMATTED": "REFORMAT, to change the format [v]\n",
  "REFORMATTING": "REFORMAT, to change the format [v]\n",
  "REFORMED": "REFORM, to change to a better state [v]\n",
  "REFORMER": "one that reforms [n -S]\n",
  "REFORMERS": "REFORMER, one that reforms [n]\n",
  "REFORMING": "the act of reforming [n -S]\n",
  "REFORMINGS": "REFORMING, the act of reforming [n]\n",
  "REFORMISM": "any doctrine or movement advocating gradual social and political change within a democratic framework rather than revolutionary change [n -S]\n",
  "REFORMISMS": "REFORMISM, any doctrine or movement advocating gradual social and political change within a democratic framework rather than revolutionary change [n]\n",
  "REFORMIST": "a reformer [n -S]\n",
  "REFORMISTS": "REFORMIST, a reformer [n]\n",
  "REFORMS": "REFORM, to change to a better state [v]\n",
  "REFORMULATE": "to formulate again [v REFORMULATED, REFORMULATING, REFORMULATES]\n",
  "REFORMULATED": "REFORMULATE, to formulate again [v]\n",
  "REFORMULATES": "REFORMULATE, to formulate again [v]\n",
  "REFORMULATING": "REFORMULATE, to formulate again [v]\n",
  "REFORMULATION": "the act of reformulating [n -S]\n",
  "REFORMULATIONS": "REFORMULATION, the act of reformulating [n]\n",
  "REFORTIFICATION": "the act of refortifying [n]\n",
  "REFORTIFIED": "REFORTIFY, to fortify anew [v]\n",
  "REFORTIFIES": "REFORTIFY, to fortify anew [v]\n",
  "REFORTIFY": "to fortify anew [v REFORTIFIED, REFORTIFYING, REFORTIFIES]\n",
  "REFORTIFYING": "REFORTIFY, to fortify anew [v]\n",
  "REFOUGHT": "REFIGHT, to fight again [v]\n",
  "REFOULEMENT": "the act of forcing a refugee to return to a place from which he or she is seeking asylum [n -S]\n",
  "REFOULEMENTS": "REFOULEMENT, the act of forcing a refugee to return to a place from which he or she is seeking asylum [n]\n",
  "REFOUND": "to found again [v -ED, -ING, -S]\n",
  "REFOUNDATION": "the act of refounding [n -S]\n",
  "REFOUNDATIONS": "REFOUNDATION, the act of refounding [n]\n",
  "REFOUNDED": "REFOUND, to found again [v]\n",
  "REFOUNDER": "one who refounds [n -S]\n",
  "REFOUNDERS": "REFOUNDER, one who refounds [n]\n",
  "REFOUNDING": "REFOUND, to found again [v]\n",
  "REFOUNDS": "REFOUND, to found again [v]\n",
  "REFRACT": "to deflect in a particular manner, as a ray of light [v -ED, -ING, -S]\n",
  "REFRACTABLE": "that can be refracted [adj]\n",
  "REFRACTARIES": "REFRACTARY, a substance that is able to resist high temperatures, etc., used in lining furnaces, etc. [n]\n",
  "REFRACTARY": "(obsolete) refractory [adj] / a substance that is able to resist high temperatures, etc., used in lining furnaces, etc. [n REFRACTARIES]\n",
  "REFRACTED": "REFRACT, to deflect in a particular manner, as a ray of light [v]\n",
  "REFRACTILE": "refractive, capable of being refracted [adj]\n",
  "REFRACTING": "REFRACT, to deflect in a particular manner, as a ray of light [v]\n",
  "REFRACTION": "the bending of waves or rays of energy [n -S]\n",
  "REFRACTIONS": "REFRACTION, the bending of waves or rays of energy [n]\n",
  "REFRACTIVE": "serving to refract [adj REFRACTIVELY]\n",
  "REFRACTIVELY": "REFRACTIVE, serving to refract [adv]\n",
  "REFRACTIVENESS": "the state of being refractive [n]\n",
  "REFRACTIVITIES": "REFRACTIVITY, the state of being refractive [n]\n",
  "REFRACTIVITY": "the state of being refractive [n REFRACTIVITIES]\n",
  "REFRACTOMETER": "an instrument for measuring the refraction of light [n -S]\n",
  "REFRACTOMETERS": "REFRACTOMETER, an instrument for measuring the refraction of light [n]\n",
  "REFRACTOMETRIC": "relating to measurement by refractometer [adj]\n",
  "REFRACTOMETRIES": "REFRACTOMETRY, measurement by refractometer [n]\n",
  "REFRACTOMETRY": "measurement by refractometer [n REFRACTOMETRIES]\n",
  "REFRACTOR": "a refracting telescope [n -S]\n",
  "REFRACTORIES": "REFRACTORY, a stubborn person [n]\n",
  "REFRACTORILY": "REFRACTORY, unruly, stubborn [adv]\n",
  "REFRACTORINESS": "the state of being refractory [n]\n",
  "REFRACTORS": "REFRACTOR, a refracting telescope [n]\n",
  "REFRACTORY": "unruly, stubborn [adj REFRACTORILY] / a stubborn person [n REFRACTORIES]\n",
  "REFRACTS": "REFRACT, to deflect in a particular manner, as a ray of light [v]\n",
  "REFRACTURE": "to fracture again [v REFRACTURED, REFRACTURING, REFRACTURES]\n",
  "REFRACTURED": "REFRACTURE, to fracture again [v]\n",
  "REFRACTURES": "REFRACTURE, to fracture again [v]\n",
  "REFRACTURING": "REFRACTURE, to fracture again [v]\n",
  "REFRAIN": "to keep oneself from action [v -ED, -ING, -S]\n",
  "REFRAINED": "REFRAIN, to keep oneself from action [v]\n",
  "REFRAINER": "one who refrains [n -S]\n",
  "REFRAINERS": "REFRAINER, one who refrains [n]\n",
  "REFRAINING": "REFRAIN, to keep oneself from action [v]\n",
  "REFRAINMENT": "the act of refraining [n -S]\n",
  "REFRAINMENTS": "REFRAINMENT, the act of refraining [n]\n",
  "REFRAINS": "REFRAIN, to keep oneself from action [v]\n",
  "REFRAME": "to put in a new frame [v REFRAMED, REFRAMING, REFRAMES]\n",
  "REFRAMED": "REFRAME, to put in a new frame [v]\n",
  "REFRAMES": "REFRAME, to put in a new frame [v]\n",
  "REFRAMING": "REFRAME, to put in a new frame [v]\n",
  "REFRANGIBILITY": "the state of being refrangible [n]\n",
  "REFRANGIBLE": "that may be refracted [adj]\n",
  "REFRANGIBLENESS": "REFRANGIBLE, that may be refracted [n]\n",
  "REFREEZE": "to freeze again [v REFROZE, REFROZEN, REFREEZING, REFREEZES]\n",
  "REFREEZES": "REFREEZE, to freeze again [v]\n",
  "REFREEZING": "REFREEZE, to freeze again [v]\n",
  "REFRESH": "to restore the wellbeing and vigour of [v -ED, -ING, -ES]\n",
  "REFRESHED": "REFRESH, to restore the wellbeing and vigour of [v]\n",
  "REFRESHEN": "to refresh [v -ED, -ING, -S]\n",
  "REFRESHENED": "REFRESHEN, to refresh [v]\n",
  "REFRESHENER": "something that refreshens [n -S]\n",
  "REFRESHENERS": "REFRESHENER, something that refreshens [n]\n",
  "REFRESHENING": "REFRESHEN, to refresh [v]\n",
  "REFRESHENS": "REFRESHEN, to refresh [v]\n",
  "REFRESHER": "something that refreshes [n -S]\n",
  "REFRESHERS": "REFRESHER, something that refreshes [n]\n",
  "REFRESHES": "REFRESH, to restore the wellbeing and vigour of [v]\n",
  "REFRESHFUL": "(archaic) full of power to refresh [adj REFRESHFULLY]\n",
  "REFRESHFULLY": "REFRESHFUL, (archaic) full of power to refresh [adv]\n",
  "REFRESHING": "REFRESH, to restore the wellbeing and vigour of [v]\n",
  "REFRESHINGLY": "REFRESHING, REFRESH, to restore the wellbeing and vigour of [adv]\n",
  "REFRESHMENT": "the act of refreshing [n -S]\n",
  "REFRESHMENTS": "REFRESHMENT, the act of refreshing [n]\n",
  "REFRIED": "REFRY, to fry again [v]\n",
  "REFRIES": "REFRY, to fry again [v]\n",
  "REFRIGERANT": "a refrigerant agent or agency [n -S]\n",
  "REFRIGERANTS": "REFRIGERANT, a refrigerant agent or agency [n]\n",
  "REFRIGERATE": "to make or keep cold [v REFRIGERATED, REFRIGERATING, REFRIGERATES]\n",
  "REFRIGERATED": "REFRIGERATE, to make or keep cold [v]\n",
  "REFRIGERATES": "REFRIGERATE, to make or keep cold [v]\n",
  "REFRIGERATING": "REFRIGERATE, to make or keep cold [v]\n",
  "REFRIGERATION": "the act of refrigerating [n -S]\n",
  "REFRIGERATIONS": "REFRIGERATION, the act of refrigerating [n]\n",
  "REFRIGERATIVE": "serving to refrigerate [adj]\n",
  "REFRIGERATOR": "something that refrigerates [n -S]\n",
  "REFRIGERATORIES": "REFRIGERATORY, a refrigerator; a chamber in which ice is formed [n]\n",
  "REFRIGERATORS": "REFRIGERATOR, something that refrigerates [n]\n",
  "REFRIGERATORY": "cooling; refrigerative [adj] / a refrigerator; a chamber in which ice is formed [n REFRIGERATORIES]\n",
  "REFRINGE": "(obsolete) to refract [v REFRINGED, REFRINGING, REFRINGES]\n",
  "REFRINGED": "REFRINGE, (obsolete) to refract [v]\n",
  "REFRINGENCE": "refractivity, also REFRINGENCY [n -S]\n",
  "REFRINGENCES": "REFRINGENCE, refractivity, also REFRINGENCY [n]\n",
  "REFRINGENCIES": "REFRINGENCY, refractivity, also REFRINGENCE [n]\n",
  "REFRINGENCY": "refractivity, also REFRINGENCE [n REFRINGENCIES]\n",
  "REFRINGENT": "pertaining to, or possessing, refringency [adj]\n",
  "REFRINGES": "REFRINGE, (obsolete) to refract [v]\n",
  "REFRINGING": "REFRINGE, (obsolete) to refract [v]\n",
  "REFRONT": "to put on a new front [v -ED, -ING, -S]\n",
  "REFRONTED": "REFRONT, to put on a new front [v]\n",
  "REFRONTING": "REFRONT, to put on a new front [v]\n",
  "REFRONTS": "REFRONT, to put on a new front [v]\n",
  "REFROZE": "REFREEZE, to freeze again [v]\n",
  "REFROZEN": "REFREEZE, to freeze again [v]\n",
  "REFRY": "to fry again [v REFRIED, REFRYING, REFRIES]\n",
  "REFRYING": "REFRY, to fry again [v]\n",
  "REFS": "REF, to referee [v]\n",
  "REFT": "REAVE, (archaic) to rob, plunder, also REIVE, RIEVE [v]\n",
  "REFUEL": "to fill with fuel [v REFUELED or REFUELLED, REFUELING or REFUELLING, REFUELS]\n",
  "REFUELABLE": "capable of being refuelled, also REFUELLABLE [adj]\n",
  "REFUELED": "REFUEL, to fill with fuel [v]\n",
  "REFUELING": "the act of adding new fuel also REFUELLING [n -S]\n",
  "REFUELINGS": "REFUELING, the act of adding new fuel also REFUELLING [n]\n",
  "REFUELLABLE": "capable of being refuelled, also REFUELABLE [adj]\n",
  "REFUELLED": "REFUEL, to fill with fuel [v]\n",
  "REFUELLING": "the act of adding new fuel, also REFUELING [n -S]\n",
  "REFUELLINGS": "REFUELLING, the act of adding new fuel, also REFUELING [n]\n",
  "REFUELS": "REFUEL, to fill with fuel [v]\n",
  "REFUGE": "to give or take shelter [v REFUGED, REFUGING, REFUGES]\n",
  "REFUGED": "REFUGE, to give or take shelter [v]\n",
  "REFUGEE": "one who flees for safety [n -S]\n",
  "REFUGEEISM": "the state of being a refugee [n -S]\n",
  "REFUGEEISMS": "REFUGEEISM, the state of being a refugee [n]\n",
  "REFUGEES": "REFUGEE, one who flees for safety [n]\n",
  "REFUGES": "REFUGE, to give or take shelter [v]\n",
  "REFUGIA": "REFUGIUM, (Latin) a stable area during a period of continental climatic change [n]\n",
  "REFUGING": "REFUGE, to give or take shelter [v]\n",
  "REFUGIUM": "(Latin) a stable area during a period of continental climatic change [n REFUGIA]\n",
  "REFULGENCE": "the quality of being refulgent, also REFULGENCY [n -S]\n",
  "REFULGENCES": "REFULGENCE, the quality of being refulgent, also REFULGENCY [n]\n",
  "REFULGENCIES": "REFULGENCY, the quality of being refulgent, also REFULGENCE [n]\n",
  "REFULGENCY": "the quality of being refulgent, also REFULGENCE [n REFULGENCIES]\n",
  "REFULGENT": "radiant, brilliant, shining [adj REFULGENTLY]\n",
  "REFULGENTLY": "REFULGENT, radiant, brilliant, shining [adv]\n",
  "REFUND": "to give back [v -ED, -ING, -S]\n",
  "REFUNDABILITIES": "REFUNDABILITY, the state of being refundable [n]\n",
  "REFUNDABILITY": "the state of being refundable [n REFUNDABILITIES]\n",
  "REFUNDABLE": "that can be refunded [adj]\n",
  "REFUNDED": "REFUND, to give back [v]\n",
  "REFUNDER": "one who refunds, restores [n -S]\n",
  "REFUNDERS": "REFUNDER, one who refunds, restores [n]\n",
  "REFUNDING": "the act of giving back what has been paid [n -S]\n",
  "REFUNDINGS": "REFUNDING, the act of giving back what has been paid [n]\n",
  "REFUNDMENT": "the act of refunding; also, that which is refunded [n -S]\n",
  "REFUNDMENTS": "REFUNDMENT, the act of refunding; also, that which is refunded [n]\n",
  "REFUNDS": "REFUND, to give back [v]\n",
  "REFURB": "(colloquial) to refurbish [v -ED, -ING, -S]\n",
  "REFURBED": "REFURB, (colloquial) to refurbish [v]\n",
  "REFURBING": "REFURB, (colloquial) to refurbish [v]\n",
  "REFURBISH": "to furbish anew [v -ED, -ING, -ES]\n",
  "REFURBISHED": "REFURBISH, to furbish anew [v]\n",
  "REFURBISHER": "one who refurbishes [n -S]\n",
  "REFURBISHERS": "REFURBISHER, one who refurbishes [n]\n",
  "REFURBISHES": "REFURBISH, to furbish anew [v]\n",
  "REFURBISHING": "the act of refurbishing [n -S]\n",
  "REFURBISHINGS": "REFURBISHING, the act of refurbishing [n]\n",
  "REFURBISHMENT": "the act of refurbishing [n -S]\n",
  "REFURBISHMENTS": "REFURBISHMENT, the act of refurbishing [n]\n",
  "REFURBS": "REFURB, (colloquial) to refurbish [v]\n",
  "REFURNISH": "to furnish again [v -ED, -ING, -ES]\n",
  "REFURNISHED": "REFURNISH, to furnish again [v]\n",
  "REFURNISHES": "REFURNISH, to furnish again [v]\n",
  "REFURNISHING": "REFURNISH, to furnish again [v]\n",
  "REFUSABLE": "capable of being refused; admitting of refusal [adj]\n",
  "REFUSAL": "the act of refusing [n -S]\n",
  "REFUSALS": "REFUSAL, the act of refusing [n]\n",
  "REFUSE": "to decline to take or accept [v REFUSED, REFUSING, REFUSES]\n",
  "REFUSED": "REFUSE, to decline to take or accept [v]\n",
  "REFUSENIK": "(Russian) a Soviet Jew wishing to emigrate; a dissident, also REFUSNIK [n -S]\n",
  "REFUSENIKS": "REFUSENIK, (Russian) a Soviet Jew wishing to emigrate; a dissident, also REFUSNIK [n]\n",
  "REFUSER": "one that refuses [n -S]\n",
  "REFUSERS": "REFUSER, one that refuses [n]\n",
  "REFUSES": "REFUSE, to decline to take or accept [v]\n",
  "REFUSING": "REFUSE, to decline to take or accept [v]\n",
  "REFUSION": "the act of fusing again [n -S]\n",
  "REFUSIONS": "REFUSION, the act of fusing again [n]\n",
  "REFUSNIK": "(Russian) a Soviet Jew wishing to emigrate, also REFUSENIK [n -S]\n",
  "REFUSNIKS": "REFUSNIK, (Russian) a Soviet Jew wishing to emigrate, also REFUSENIK [n]\n",
  "REFUTABILITIES": "REFUTABILITY, the quality of being refutable [n]\n",
  "REFUTABILITY": "the quality of being refutable [n REFUTABILITIES]\n",
  "REFUTABLE": "that can be refuted [adj REFUTABLY]\n",
  "REFUTABLY": "REFUTABLE, that can be refuted [adv]\n",
  "REFUTAL": "an act of refuting [n -S]\n",
  "REFUTALS": "REFUTAL, an act of refuting [n]\n",
  "REFUTATION": "the act of refuting [n -S]\n",
  "REFUTATIONS": "REFUTATION, the act of refuting [n]\n",
  "REFUTE": "to prove to be false or erroneous [v REFUTED, REFUTING, REFUTES]\n",
  "REFUTED": "REFUTE, to prove to be false or erroneous [v]\n",
  "REFUTER": "one who refutes [n -S]\n",
  "REFUTERS": "REFUTER, one who refutes [n]\n",
  "REFUTES": "REFUTE, to prove to be false or erroneous [v]\n",
  "REFUTING": "REFUTE, to prove to be false or erroneous [v]\n",
  "REG": "(short for) a regulation [n -S]\n",
  "REGAIN": "to take possession once more [v -ED, -ING, -S]\n",
  "REGAINABLE": "that can be regained [adj]\n",
  "REGAINED": "REGAIN, to take possession once more [v]\n",
  "REGAINER": "one who regains [n -S]\n",
  "REGAINERS": "REGAINER, one who regains [n]\n",
  "REGAINING": "REGAIN, to take possession once more [v]\n",
  "REGAINMENT": "the act of regaining [n -S]\n",
  "REGAINMENTS": "REGAINMENT, the act of regaining [n]\n",
  "REGAINS": "REGAIN, to take possession once more [v]\n",
  "REGAL": "royal [adj REGALLY] / a small portable organ [n -S]\n",
  "REGALE": "to delight [v REGALED, REGALING, REGALES]\n",
  "REGALED": "REGALE, to delight [v]\n",
  "REGALEMENT": "the act of regaling [n -S]\n",
  "REGALEMENTS": "REGALEMENT, the act of regaling [n]\n",
  "REGALER": "one who regales [n -S]\n",
  "REGALERS": "REGALER, one who regales [n]\n",
  "REGALES": "REGALE, to delight [v]\n",
  "REGALIA": "(Latin) ceremonial robes [n -S]\n",
  "REGALIAN": "(archaic) regal [adj]\n",
  "REGALIAS": "REGALIA, (Latin) ceremonial robes [n]\n",
  "REGALING": "REGALE, to delight [v]\n",
  "REGALISM": "the doctrine of the monarch's supremacy in church affairs [n -S]\n",
  "REGALISMS": "REGALISM, the doctrine of the monarch's supremacy in church affairs [n]\n",
  "REGALIST": "one who believes in royal supremacy, esp. in church matters [n -S]\n",
  "REGALISTS": "REGALIST, one who believes in royal supremacy, esp. in church matters [n]\n",
  "REGALITIES": "REGALITY, regal authority [n]\n",
  "REGALITY": "regal authority [n REGALITIES]\n",
  "REGALLY": "REGAL, royal [adv]\n",
  "REGALNESS": "the quality of being regal, also REGALITY [n -ES]\n",
  "REGALNESSES": "REGALNESS, the quality of being regal, also REGALITY [n]\n",
  "REGALS": "REGAL, a small portable organ [n]\n",
  "REGAR": "(Hindi) the rich black cotton soil of the Indian subcontinent, also REGUR [n -S]\n",
  "REGARD": "to look upon, to esteem highly [v -ED, -ING, -S]\n",
  "REGARDABLE": "worthy of regard or notice [adj]\n",
  "REGARDANT": "in heraldry, in profile and looking to rear [adj]\n",
  "REGARDED": "REGARD, to look upon, to esteem highly [v]\n",
  "REGARDER": "one who regards [n -S]\n",
  "REGARDERS": "REGARDER, one who regards [n]\n",
  "REGARDFUL": "heedful; observant [adj REGARDFULLY]\n",
  "REGARDFULLY": "REGARDFUL, heedful; observant [adv]\n",
  "REGARDFULNESS": "REGARDFUL, heedful; observant [n]\n",
  "REGARDFULNESSES": "REGARDFULNESS, REGARDFUL, heedful; observant [n]\n",
  "REGARDING": "REGARD, to look upon, to esteem highly [v]\n",
  "REGARDLESS": "having no regard; heedless [adj REGARDLESSLY]\n",
  "REGARDLESSLY": "REGARDLESS, having no regard; heedless [adv]\n",
  "REGARDLESSNESS": "REGARDLESS, having no regard; heedless [n]\n",
  "REGARDS": "REGARD, to look upon, to esteem highly [v]\n",
  "REGARS": "REGAR, (Hindi) the rich black cotton soil of the Indian subcontinent, also REGUR [n]\n",
  "REGATHER": "to assemble once more [v -ED, -ING, -S]\n",
  "REGATHERED": "REGATHER, to assemble once more [v]\n",
  "REGATHERING": "REGATHER, to assemble once more [v]\n",
  "REGATHERS": "REGATHER, to assemble once more [v]\n",
  "REGATTA": "(Italian) a rowing or sailing competition [n -S]\n",
  "REGATTAS": "REGATTA, (Italian) a rowing or sailing competition [n]\n",
  "REGAUGE": "to adjust the gauges of [v REGAUGED, REGAUGING, REGAUGES]\n",
  "REGAUGED": "REGAUGE, to adjust the gauges of [v]\n",
  "REGAUGES": "REGAUGE, to adjust the gauges of [v]\n",
  "REGAUGING": "REGAUGE, to adjust the gauges of [v]\n",
  "REGAVE": "REGIVE, to give again [v]\n",
  "REGEAR": "to equip again [v -ED, -ING, -S]\n",
  "REGEARED": "REGEAR, to equip again [v]\n",
  "REGEARING": "REGEAR, to equip again [v]\n",
  "REGEARS": "REGEAR, to equip again [v]\n",
  "REGELATE": "to refreeze ice by reducing the pressure [v REGELATED, REGELATING, REGELATES]\n",
  "REGELATED": "REGELATE, to refreeze ice by reducing the pressure [v]\n",
  "REGELATES": "REGELATE, to refreeze ice by reducing the pressure [v]\n",
  "REGELATING": "REGELATE, to refreeze ice by reducing the pressure [v]\n",
  "REGELATION": "freezing again, esp. of water from ice melted by pressure when pressure is relieved [n -S]\n",
  "REGELATIONS": "REGELATION, freezing again, esp. of water from ice melted by pressure when pressure is relieved [n]\n",
  "REGENCE": "(obsolete) government [n -S]\n",
  "REGENCES": "REGENCE, (obsolete) government [n]\n",
  "REGENCIES": "REGENCY, the office of a regent [n]\n",
  "REGENCY": "the office of a regent [n REGENCIES]\n",
  "REGENERABLE": "able to be regenerated [adj]\n",
  "REGENERACIES": "REGENERACY, the state of being regenerated [n]\n",
  "REGENERACY": "the state of being regenerated [n REGENERACIES]\n",
  "REGENERATE": "renewed [adj REGENERATELY] / to generate anew [v REGENERATED, REGENERATING, REGENERATES]\n",
  "REGENERATED": "REGENERATE, to generate anew [v]\n",
  "REGENERATELY": "REGENERATE, renewed [adv]\n",
  "REGENERATENESS": "the state of being regenerate [n]\n",
  "REGENERATES": "REGENERATE, to generate anew [v]\n",
  "REGENERATING": "REGENERATE, to generate anew [v]\n",
  "REGENERATION": "an act or the process of regenerating [n -S]\n",
  "REGENERATIONS": "REGENERATION, an act or the process of regenerating [n]\n",
  "REGENERATIVE": "serving to regenerate [adj REGENERATIVELY]\n",
  "REGENERATIVELY": "REGENERATIVE, serving to regenerate [adv]\n",
  "REGENERATOR": "one that regenerates [n -S]\n",
  "REGENERATORS": "REGENERATOR, one that regenerates [n]\n",
  "REGENERATORY": "serving to regenerate [adj]\n",
  "REGENT": "one who rules in place of a sovereign [n -S]\n",
  "REGENTAL": "relating to a regent, a person invested with royal authority by or on behalf of another [adj]\n",
  "REGENTS": "REGENT, one who rules in place of a sovereign [n]\n",
  "REGENTSHIP": "the office of a regent [n -S]\n",
  "REGENTSHIPS": "REGENTSHIP, the office of a regent [n]\n",
  "REGES": "REX, a king [n]\n",
  "REGEST": "(Milton) to register, record [v -ED, -ING, -S]\n",
  "REGESTED": "REGEST, (Milton) to register, record [v]\n",
  "REGESTING": "REGEST, (Milton) to register, record [v]\n",
  "REGESTS": "REGEST, (Milton) to register, record [v]\n",
  "REGGAE": "a form of popular Jamaican music [n -S]\n",
  "REGGAES": "REGGAE, a form of popular Jamaican music [n]\n",
  "REGGAETON": "a form of music blending West Indian music influences of reggae and dancehall with those of Latin America [n -S]\n",
  "REGGAETONS": "REGGAETON, a form of music blending West Indian music influences of reggae and dancehall with those of Latin America [n]\n",
  "REGGO": "(Australian slang) a (motor vehicle) registration, also REGO [n -S]\n",
  "REGGOS": "REGGO, (Australian slang) a (motor vehicle) registration, also REGO [n]\n",
  "REGICIDAL": "pertaining to regicide, or to one committing it [adj]\n",
  "REGICIDE": "the killing of a king [n -S]\n",
  "REGICIDES": "REGICIDE, the killing of a king [n]\n",
  "REGIE": "(French) a system of Government monopoly, esp. in tobacco [n -S]\n",
  "REGIES": "REGIE, (French) a system of Government monopoly, esp. in tobacco [n]\n",
  "REGIFT": "to take a gift that has been received and give it to somebody else, sometimes in the guise of a new gift [v -ED, -ING, -S]\n",
  "REGIFTED": "REGIFT, to take a gift that has been received and give it to somebody else, sometimes in the guise of a new gift [v]\n",
  "REGIFTER": "one who regifts [n -S]\n",
  "REGIFTERS": "REGIFTER, one who regifts [n]\n",
  "REGIFTING": "REGIFT, to take a gift that has been received and give it to somebody else, sometimes in the guise of a new gift [v]\n",
  "REGIFTS": "REGIFT, to take a gift that has been received and give it to somebody else, sometimes in the guise of a new gift [v]\n",
  "REGILD": "to gild once more [v REGILDED, REGILT, REGILDING, REGILDS]\n",
  "REGILDED": "REGILD, to gild once more [v]\n",
  "REGILDING": "REGILD, to gild once more [v]\n",
  "REGILDS": "REGILD, to gild once more [v]\n",
  "REGILT": "REGILD, to gild once more [v]\n",
  "REGIME": "a system of government [n -S]\n",
  "REGIMEN": "(Latin) a systematic plan [n -S]\n",
  "REGIMENS": "REGIMEN, (Latin) a systematic plan [n]\n",
  "REGIMENT": "a large permanent unit within an army [n -S] / to form into military units [v -ED, -ING, -S]\n",
  "REGIMENTAL": "of or relating to a regiment [adj REGIMENTALLY] / the uniform of a regiment [n -S]\n",
  "REGIMENTALLY": "REGIMENTAL, of or relating to a regiment [adv]\n",
  "REGIMENTALS": "military dress [n]\n",
  "REGIMENTATION": "the act of regimenting [n -S]\n",
  "REGIMENTATIONS": "REGIMENTATION, the act of regimenting [n]\n",
  "REGIMENTED": "REGIMENT, to form into military units [v]\n",
  "REGIMENTING": "REGIMENT, to form into military units [v]\n",
  "REGIMENTS": "REGIMENT, to form into military units [v]\n",
  "REGIMES": "REGIME, a system of government [n]\n",
  "REGIMINAL": "of or relating to regimen; as, regiminal rules [adj]\n",
  "REGINA": "(Latin) a queen [n REGINAS or REGINAE]\n",
  "REGINAE": "REGINA, (Latin) a queen [n]\n",
  "REGINAL": "pertaining to a queen [adj]\n",
  "REGINAS": "REGINA, (Latin) a queen [n]\n",
  "REGION": "an area or district; a tract of country [n -S]\n",
  "REGIONAL": "relating to a region, also REGIONARY [adj REGIONALLY] / something that serves as a region [n -S]\n",
  "REGIONALISATION": "the act of regionalising, also REGIONALIZATION [n]\n",
  "REGIONALISE": "to divide into regions or administrative districts, also REGIONALIZE [v REGIONALISED, REGIONALISING, REGIONALISES]\n",
  "REGIONALISED": "REGIONALISE, to divide into regions or administrative districts, also REGIONALIZE [v]\n",
  "REGIONALISES": "REGIONALISE, to divide into regions or administrative districts, also REGIONALIZE [v]\n",
  "REGIONALISING": "REGIONALISE, to divide into regions or administrative districts, also REGIONALIZE [v]\n",
  "REGIONALISM": "consciousness of and loyalty to a distinct region with a homogeneous population [n -S]\n",
  "REGIONALISMS": "REGIONALISM, consciousness of and loyalty to a distinct region with a homogeneous population [n]\n",
  "REGIONALIST": "a supporter of regionalism [n -S]\n",
  "REGIONALISTIC": "relating to regionalism [adj]\n",
  "REGIONALISTS": "REGIONALIST, a supporter of regionalism [n]\n",
  "REGIONALIZATION": "the act of regionalizing, also REGIONALISATION [n]\n",
  "REGIONALIZE": "to divide into regions or administrative districts, also REGIONALISE [v REGIONALIZED, REGIONALIZING, REGIONALIZES]\n",
  "REGIONALIZED": "REGIONALIZE, to divide into regions or administrative districts, also REGIONALISE [v]\n",
  "REGIONALIZES": "REGIONALIZE, to divide into regions or administrative districts, also REGIONALISE [v]\n",
  "REGIONALIZING": "REGIONALIZE, to divide into regions or administrative districts, also REGIONALISE [v]\n",
  "REGIONALLY": "REGIONAL, relating to a region, also REGIONARY [adv]\n",
  "REGIONALS": "REGIONAL, something that serves as a region [n]\n",
  "REGIONARY": "relating to a region, also REGIONAL [adj]\n",
  "REGIONS": "REGION, an area or district; a tract of country [n]\n",
  "REGISSEUR": "(French) a ballet director [n -S]\n",
  "REGISSEURS": "REGISSEUR, (French) a ballet director [n]\n",
  "REGISTER": "to record officially [v -ED, -ING, -S]\n",
  "REGISTERABLE": "capable of being registered, also REGISTRABLE [adj]\n",
  "REGISTERED": "REGISTER, to record officially [v]\n",
  "REGISTERER": "one who registers [n -S]\n",
  "REGISTERERS": "REGISTERER, one who registers [n]\n",
  "REGISTERING": "REGISTER, to record officially [v]\n",
  "REGISTERS": "REGISTER, to record officially [v]\n",
  "REGISTRABLE": "capable of being registered, also REGISTERABLE [adj]\n",
  "REGISTRANT": "a person who registers, or has registered (a trademark, etc.) [n -S]\n",
  "REGISTRANTS": "REGISTRANT, a person who registers, or has registered (a trademark, etc.) [n]\n",
  "REGISTRAR": "a middle-ranking hospital doctor undergoing training as a specialist or consultant [n -S]\n",
  "REGISTRARIES": "REGISTRARY, a registrar [n]\n",
  "REGISTRARS": "REGISTRAR, a middle-ranking hospital doctor undergoing training as a specialist or consultant [n]\n",
  "REGISTRARSHIP": "the office of registrar [n -S]\n",
  "REGISTRARSHIPS": "REGISTRARSHIP, the office of registrar [n]\n",
  "REGISTRARY": "a registrar [n REGISTRARIES]\n",
  "REGISTRATION": "the act of registering [n -S]\n",
  "REGISTRATIONAL": "relating to registration [adj]\n",
  "REGISTRATIONS": "REGISTRATION, the act of registering [n]\n",
  "REGISTRIES": "REGISTRY, the act of registering [n]\n",
  "REGISTRY": "the act of registering [n REGISTRIES]\n",
  "REGIUS": "(Latin) royal, as in regius professor, one holding a professorship founded by royalty [adj]\n",
  "REGIVE": "to give again [v REGAVE, REGIVEN, REGIVING, REGIVES]\n",
  "REGIVEN": "REGIVE, to give again [v]\n",
  "REGIVES": "REGIVE, to give again [v]\n",
  "REGIVING": "REGIVE, to give again [v]\n",
  "REGLAZE": "to glaze again [v REGLAZED, REGLAZING, REGLAZES]\n",
  "REGLAZED": "REGLAZE, to glaze again [v]\n",
  "REGLAZES": "REGLAZE, to glaze again [v]\n",
  "REGLAZING": "REGLAZE, to glaze again [v]\n",
  "REGLET": "a flat, narrow moulding [n -S]\n",
  "REGLETS": "REGLET, a flat, narrow moulding [n]\n",
  "REGLORIFIED": "REGLORIFY, to glorify again [v]\n",
  "REGLORIFIES": "REGLORIFY, to glorify again [v]\n",
  "REGLORIFY": "to glorify again [v REGLORIFIED, REGLORIFYING, REGLORIFIES]\n",
  "REGLORIFYING": "REGLORIFY, to glorify again [v]\n",
  "REGLOSS": "to glass again [v -ED, -ING, -ES]\n",
  "REGLOSSED": "REGLOSS, to glass again [v]\n",
  "REGLOSSES": "REGLOSS, to glass again [v]\n",
  "REGLOSSING": "REGLOSS, to glass again [v]\n",
  "REGLOW": "to glow again [v -ED, -ING, -S]\n",
  "REGLOWED": "REGLOW, to glow again [v]\n",
  "REGLOWING": "REGLOW, to glow again [v]\n",
  "REGLOWS": "REGLOW, to glow again [v]\n",
  "REGLUE": "to glue again [v REGLUED, REGLUING, REGLUES]\n",
  "REGLUED": "REGLUE, to glue again [v]\n",
  "REGLUES": "REGLUE, to glue again [v]\n",
  "REGLUING": "REGLUE, to glue again [v]\n",
  "REGMA": "(Greek) a dry fruit formed of three or more cells which break open when ripe [n REGMATA]\n",
  "REGMAKER": "(South African) a drink taken to relieve the effects of a hangover [n -S]\n",
  "REGMAKERS": "REGMAKER, (South African) a drink taken to relieve the effects of a hangover [n]\n",
  "REGMATA": "REGMA, (Greek) a dry fruit formed of three or more cells which break open when ripe [n]\n",
  "REGNA": "REGNUM, (Latin) reign, dominion [n]\n",
  "REGNAL": "pertaining to a king or his reign [adj]\n",
  "REGNANCIES": "REGNANCY, the condition of being regnant [n]\n",
  "REGNANCY": "the condition of being regnant [n REGNANCIES]\n",
  "REGNANT": "reigning, used postpositively, as in queen regnant: a queen reigning in her own right, as opposed to a queen consort [adj]\n",
  "REGNUM": "(Latin) reign, dominion [n REGNA]\n",
  "REGO": "(Australian slang) a (motor vehicle) registration, also REGGO [n -S]\n",
  "REGOLITH": "a layer of loose rock overlaying solid rock [n -S]\n",
  "REGOLITHS": "REGOLITH, a layer of loose rock overlaying solid rock [n]\n",
  "REGORGE": "to disgorge; to regurgitate [v REGORGED, REGORGING, REGORGES]\n",
  "REGORGED": "REGORGE, to disgorge; to regurgitate [v]\n",
  "REGORGES": "REGORGE, to disgorge; to regurgitate [v]\n",
  "REGORGING": "REGORGE, to disgorge; to regurgitate [v]\n",
  "REGOS": "REGO, (Australian slang) a (motor vehicle) registration, also REGGO [n]\n",
  "REGOSOL": "a type of soil [n -S]\n",
  "REGOSOLS": "REGOSOL, a type of soil [n]\n",
  "REGRADE": "to grade again [v REGRADED, REGRADING, REGRADES]\n",
  "REGRADED": "REGRADE, to grade again [v]\n",
  "REGRADES": "REGRADE, to grade again [v]\n",
  "REGRADING": "REGRADE, to grade again [v]\n",
  "REGRAFT": "to graft again [v -ED, -ING, -S]\n",
  "REGRAFTED": "REGRAFT, to graft again [v]\n",
  "REGRAFTING": "REGRAFT, to graft again [v]\n",
  "REGRAFTS": "REGRAFT, to graft again [v]\n",
  "REGRANT": "to grant again [v -ED, -ING, -S]\n",
  "REGRANTED": "REGRANT, to grant again [v]\n",
  "REGRANTING": "REGRANT, to grant again [v]\n",
  "REGRANTS": "REGRANT, to grant again [v]\n",
  "REGRATE": "to buy up in order to sell for a higher price in the same area [v REGRATED, REGRATING, REGRATES]\n",
  "REGRATED": "REGRATE, to buy up in order to sell for a higher price in the same area [v]\n",
  "REGRATER": "one who buys and sells in the same market, also REGRATOR [n -S]\n",
  "REGRATERS": "REGRATER, one who buys and sells in the same market, also REGRATOR [n]\n",
  "REGRATES": "REGRATE, to buy up in order to sell for a higher price in the same area [v]\n",
  "REGRATING": "buying and selling again in or near the same market [n -S]\n",
  "REGRATINGS": "REGRATING, buying and selling again in or near the same market [n]\n",
  "REGRATOR": "one who buys and sells in the same market, also REGRATER [n -S]\n",
  "REGRATORS": "REGRATOR, one who buys and sells in the same market, also REGRATER [n]\n",
  "REGREDE": "to retrograde [v REGREDED, REGREDING, REGREDES]\n",
  "REGREDED": "REGREDE, to retrograde [v]\n",
  "REGREDES": "REGREDE, to retrograde [v]\n",
  "REGREDIENCE": "the act of regreding [n -S]\n",
  "REGREDIENCES": "REGREDIENCE, the act of regreding [n]\n",
  "REGREDING": "REGREDE, to retrograde [v]\n",
  "REGREEN": "to green again [v -ED, -ING, -S]\n",
  "REGREENED": "REGREEN, to green again [v]\n",
  "REGREENING": "REGREEN, to green again [v]\n",
  "REGREENS": "REGREEN, to green again [v]\n",
  "REGREET": "to greet in return [v -ED, -ING, -S]\n",
  "REGREETED": "REGREET, to greet in return [v]\n",
  "REGREETING": "REGREET, to greet in return [v]\n",
  "REGREETS": "REGREET, to greet in return [v]\n",
  "REGRESS": "to go back [v -ED, -ING, -ES]\n",
  "REGRESSED": "REGRESS, to go back [v]\n",
  "REGRESSES": "REGRESS, to go back [v]\n",
  "REGRESSING": "REGRESS, to go back [v]\n",
  "REGRESSION": "progressive decline of a manifestation of disease [n -S]\n",
  "REGRESSIONS": "REGRESSION, progressive decline of a manifestation of disease [n]\n",
  "REGRESSIVE": "tending to regress [adj REGRESSIVELY]\n",
  "REGRESSIVELY": "REGRESSIVE, tending to regress [adv]\n",
  "REGRESSIVENESS": "REGRESSIVE, tending to regress [n]\n",
  "REGRESSIVITIES": "REGRESSIVITY, the state of being regressive [n]\n",
  "REGRESSIVITY": "the state of being regressive [n REGRESSIVITIES]\n",
  "REGRESSOR": "one who regresses [n -S]\n",
  "REGRESSORS": "REGRESSOR, one who regresses [n]\n",
  "REGRET": "to look back upon with sorrow or remorse [v REGRETTED, REGRETTING, REGRETS]\n",
  "REGRETFUL": "full of regret [adj REGRETFULLY]\n",
  "REGRETFULLY": "REGRETFUL, full of regret [adv]\n",
  "REGRETFULNESS": "REGRETFUL, full of regret [n]\n",
  "REGRETFULNESSES": "REGRETFULNESS, REGRETFUL, full of regret [n]\n",
  "REGRETS": "REGRET, to look back upon with sorrow or remorse [v]\n",
  "REGRETTABLE": "to be regretted [adj REGRETTABLY]\n",
  "REGRETTABLY": "REGRETTABLE, to be regretted [adv]\n",
  "REGRETTED": "REGRET, to look back upon with sorrow or remorse [v]\n",
  "REGRETTER": "one who regrets [n -S]\n",
  "REGRETTERS": "REGRETTER, one who regrets [n]\n",
  "REGRETTING": "REGRET, to look back upon with sorrow or remorse [v]\n",
  "REGREW": "REGROW, to grow again [v]\n",
  "REGRIND": "to grind again [v REGROUND, REGRINDING, REGRINDS]\n",
  "REGRINDING": "REGRIND, to grind again [v]\n",
  "REGRINDS": "REGRIND, to grind again [v]\n",
  "REGROOM": "to groom again [v -ED, -ING, -S]\n",
  "REGROOMED": "REGROOM, to groom again [v]\n",
  "REGROOMING": "REGROOM, to groom again [v]\n",
  "REGROOMS": "REGROOM, to groom again [v]\n",
  "REGROOVE": "to groove again [v REGROOVED, REGROOVING, REGROOVES]\n",
  "REGROOVED": "REGROOVE, to groove again [v]\n",
  "REGROOVES": "REGROOVE, to groove again [v]\n",
  "REGROOVING": "REGROOVE, to groove again [v]\n",
  "REGROUND": "REGRIND, to grind again [v]\n",
  "REGROUP": "to group together once more [v -ED, -ING, -S]\n",
  "REGROUPED": "REGROUP, to group together once more [v]\n",
  "REGROUPING": "the act of forming a new group [n -S]\n",
  "REGROUPINGS": "REGROUPING, the act of forming a new group [n]\n",
  "REGROUPS": "REGROUP, to group together once more [v]\n",
  "REGROW": "to grow again [v REGREW, REGROWN, REGROWING, REGROWS]\n",
  "REGROWING": "REGROW, to grow again [v]\n",
  "REGROWN": "REGROW, to grow again [v]\n",
  "REGROWS": "REGROW, to grow again [v]\n",
  "REGROWTH": "a new or second growth [n -S]\n",
  "REGROWTHS": "REGROWTH, a new or second growth [n]\n",
  "REGS": "REG, (short for) a regulation [n]\n",
  "REGUERDON": "(Shakespeare) to reward [v -ED, -ING, -S]\n",
  "REGUERDONED": "REGUERDON, (Shakespeare) to reward [v]\n",
  "REGUERDONING": "REGUERDON, (Shakespeare) to reward [v]\n",
  "REGUERDONS": "REGUERDON, (Shakespeare) to reward [v]\n",
  "REGULA": "(Latin) the rule of a religious order [n REGULAE]\n",
  "REGULABLE": "that can be regulated [adj]\n",
  "REGULAE": "REGULA, (Latin) the rule of a religious order [n]\n",
  "REGULAR": "occurring at set intervals [adj REGULARLY] / a habitual customer [n -S]\n",
  "REGULARISATION": "the act of regularising, also REGULARIZATION [n -S]\n",
  "REGULARISATIONS": "REGULARISATION, the act of regularising, also REGULARIZATION [n]\n",
  "REGULARISE": "to make regular, also REGULARIZE [v REGULARISED, REGULARISING, REGULARISES]\n",
  "REGULARISED": "REGULARISE, to make regular, also REGULARIZE [v]\n",
  "REGULARISES": "REGULARISE, to make regular, also REGULARIZE [v]\n",
  "REGULARISING": "REGULARISE, to make regular, also REGULARIZE [v]\n",
  "REGULARITIES": "REGULARITY, the state of being regular [n]\n",
  "REGULARITY": "the state of being regular [n REGULARITIES]\n",
  "REGULARIZATION": "the act of regularizing, also REGULARISATION [n -S]\n",
  "REGULARIZATIONS": "REGULARIZATION, the act of regularizing, also REGULARISATION [n]\n",
  "REGULARIZE": "to make regular, also REGULARISE [v REGULARIZED, REGULARIZING, REGULARIZES]\n",
  "REGULARIZED": "REGULARIZE, to make regular, also REGULARISE [v]\n",
  "REGULARIZES": "REGULARIZE, to make regular, also REGULARISE [v]\n",
  "REGULARIZING": "REGULARIZE, to make regular, also REGULARISE [v]\n",
  "REGULARLY": "REGULAR, occurring at set intervals [adv]\n",
  "REGULARS": "REGULAR, a habitual customer [n]\n",
  "REGULATE": "to control according to rule [v REGULATED, REGULATING, REGULATES]\n",
  "REGULATED": "REGULATE, to control according to rule [v]\n",
  "REGULATES": "REGULATE, to control according to rule [v]\n",
  "REGULATING": "REGULATE, to control according to rule [v]\n",
  "REGULATION": "the act of regulating [n -S]\n",
  "REGULATIONS": "REGULATION, the act of regulating [n]\n",
  "REGULATIVE": "tending to regulate [adj REGULATIVELY]\n",
  "REGULATIVELY": "REGULATIVE, tending to regulate [adv]\n",
  "REGULATOR": "one who regulates [n -S]\n",
  "REGULATORS": "REGULATOR, one who regulates [n]\n",
  "REGULATORY": "relating to the act of regulation [adj]\n",
  "REGULI": "REGULUS, (Latin) a mass that forms beneath the slag in a furnace [n]\n",
  "REGULINE": "of or pertaining to the regulus genus of birds, goldcrests [adj]\n",
  "REGULISE": "to reduce to regulus, also REGULIZE [v REGULISED, REGULISING, REGULISES]\n",
  "REGULISED": "REGULISE, to reduce to regulus, also REGULIZE [v]\n",
  "REGULISES": "REGULISE, to reduce to regulus, also REGULIZE [v]\n",
  "REGULISING": "REGULISE, to reduce to regulus, also REGULIZE [v]\n",
  "REGULIZE": "to reduce to regulus, also REGULISE [v REGULIZED, REGULIZING, REGULIZES]\n",
  "REGULIZED": "REGULIZE, to reduce to regulus, also REGULISE [v]\n",
  "REGULIZES": "REGULIZE, to reduce to regulus, also REGULISE [v]\n",
  "REGULIZING": "REGULIZE, to reduce to regulus, also REGULISE [v]\n",
  "REGULO": "the scale of temperature in a gas oven [n -S]\n",
  "REGULOS": "REGULO, the scale of temperature in a gas oven [n]\n",
  "REGULUS": "(Latin) a mass that forms beneath the slag in a furnace [n REGULUSES or REGULI]\n",
  "REGULUSES": "REGULUS, (Latin) a mass that forms beneath the slag in a furnace [n]\n",
  "REGUR": "(Hindi) the rich black cotton soil of the Indian subcontinent, also REGAR [n -S]\n",
  "REGURGITANT": "a drug causing regurgitation [n -S]\n",
  "REGURGITANTS": "REGURGITANT, a drug causing regurgitation [n]\n",
  "REGURGITATE": "to bring back into the mouth after swallowing [v REGURGITATED, REGURGITATING, REGURGITATES]\n",
  "REGURGITATED": "REGURGITATE, to bring back into the mouth after swallowing [v]\n",
  "REGURGITATES": "REGURGITATE, to bring back into the mouth after swallowing [v]\n",
  "REGURGITATING": "REGURGITATE, to bring back into the mouth after swallowing [v]\n",
  "REGURGITATION": "an act of regurgitating [n -S]\n",
  "REGURGITATIONS": "REGURGITATION, an act of regurgitating [n]\n",
  "REGURS": "REGUR, (Hindi) the rich black cotton soil of the Indian subcontinent, also REGAR [n]\n",
  "REH": "an accumulation of salts on soil [n -S]\n",
  "REHAB": "to restore to a good condition [v REHABBED, REHABBING, REHABS]\n",
  "REHABBED": "REHAB, to restore to a good condition [v]\n",
  "REHABBER": "one who rehabs, rehabilitates [n -S]\n",
  "REHABBERS": "REHABBER, one who rehabs, rehabilitates [n]\n",
  "REHABBING": "REHAB, to restore to a good condition [v]\n",
  "REHABILITANT": "a disabled person undergoing rehabilitation [n -S]\n",
  "REHABILITANTS": "REHABILITANT, a disabled person undergoing rehabilitation [n]\n",
  "REHABILITATE": "to restore to a former capacity [v REHABILITATED, REHABILITATING, REHABILITATES]\n",
  "REHABILITATED": "REHABILITATE, to restore to a former capacity [v]\n",
  "REHABILITATES": "REHABILITATE, to restore to a former capacity [v]\n",
  "REHABILITATING": "REHABILITATE, to restore to a former capacity [v]\n",
  "REHABILITATION": "the act of rehabilitating [n -S]\n",
  "REHABILITATIONS": "REHABILITATION, the act of rehabilitating [n]\n",
  "REHABILITATIVE": "serving to rehabilitate [adj]\n",
  "REHABILITATOR": "one who rehabilitates [n -S]\n",
  "REHABILITATORS": "REHABILITATOR, one who rehabilitates [n]\n",
  "REHABS": "REHAB, to restore to a good condition [v]\n",
  "REHAMMER": "to hammer again [v -ED, -ING, -S]\n",
  "REHAMMERED": "REHAMMER, to hammer again [v]\n",
  "REHAMMERING": "REHAMMER, to hammer again [v]\n",
  "REHAMMERS": "REHAMMER, to hammer again [v]\n",
  "REHANDLE": "to handle again [v REHANDLED, REHANDLING, REHANDLES]\n",
  "REHANDLED": "REHANDLE, to handle again [v]\n",
  "REHANDLES": "REHANDLE, to handle again [v]\n",
  "REHANDLING": "the act of rehandling [n -S]\n",
  "REHANDLINGS": "REHANDLING, the act of rehandling [n]\n",
  "REHANG": "to hang again [v REHANGED, REHUNG, REHANGING, REHANGS]\n",
  "REHANGED": "REHANG, to hang again [v]\n",
  "REHANGING": "REHANG, to hang again [v]\n",
  "REHANGS": "REHANG, to hang again [v]\n",
  "REHARDEN": "to harden again [v -ED, -ING, -S]\n",
  "REHARDENED": "REHARDEN, to harden again [v]\n",
  "REHARDENING": "REHARDEN, to harden again [v]\n",
  "REHARDENS": "REHARDEN, to harden again [v]\n",
  "REHASH": "to go over old ideas again [v -ED, -ING, -ES]\n",
  "REHASHED": "REHASH, to go over old ideas again [v]\n",
  "REHASHES": "REHASH, to go over old ideas again [v]\n",
  "REHASHING": "REHASH, to go over old ideas again [v]\n",
  "REHEAR": "to hear again [v REHEARD, REHEARING, REHEARS]\n",
  "REHEARD": "REHEAR, to hear again [v]\n",
  "REHEARING": "the act of rehearing [n -S]\n",
  "REHEARINGS": "REHEARING, the act of rehearing [n]\n",
  "REHEARS": "REHEAR, to hear again [v]\n",
  "REHEARSAL": "an act of rehearsing [n -S]\n",
  "REHEARSALS": "REHEARSAL, an act of rehearsing [n]\n",
  "REHEARSE": "to practice in preparation for a public appearance [v REHEARSED, REHEARSING, REHEARSES]\n",
  "REHEARSED": "REHEARSE, to practice in preparation for a public appearance [v]\n",
  "REHEARSER": "one who rehearses [n -S]\n",
  "REHEARSERS": "REHEARSER, one who rehearses [n]\n",
  "REHEARSES": "REHEARSE, to practice in preparation for a public appearance [v]\n",
  "REHEARSING": "the act of rehearsing [n -S]\n",
  "REHEARSINGS": "REHEARSING, the act of rehearsing [n]\n",
  "REHEAT": "to heat again [v -ED, -ING, -S]\n",
  "REHEATED": "REHEAT, to heat again [v]\n",
  "REHEATER": "an apparatus for reheating [n -S]\n",
  "REHEATERS": "REHEATER, an apparatus for reheating [n]\n",
  "REHEATING": "the act of heating again [n -S]\n",
  "REHEATINGS": "REHEATING, the act of heating again [n]\n",
  "REHEATS": "REHEAT, to heat again [v]\n",
  "REHEEL": "to replace the heels of [v -ED, -ING, -S]\n",
  "REHEELED": "REHEEL, to replace the heels of [v]\n",
  "REHEELING": "REHEEL, to replace the heels of [v]\n",
  "REHEELS": "REHEEL, to replace the heels of [v]\n",
  "REHEM": "to take up the hem once more [v REHEMMED, REHEMMING, REHEMS]\n",
  "REHEMMED": "REHEM, to take up the hem once more [v]\n",
  "REHEMMING": "REHEM, to take up the hem once more [v]\n",
  "REHEMS": "REHEM, to take up the hem once more [v]\n",
  "REHINGE": "to hinge again [v REHINGED, REHINGING, REHINGES]\n",
  "REHINGED": "REHINGE, to hinge again [v]\n",
  "REHINGES": "REHINGE, to hinge again [v]\n",
  "REHINGING": "REHINGE, to hinge again [v]\n",
  "REHIRE": "to hire again [v REHIRED, REHIRING, REHIRES]\n",
  "REHIRED": "REHIRE, to hire again [v]\n",
  "REHIRES": "REHIRE, to hire again [v]\n",
  "REHIRING": "REHIRE, to hire again [v]\n",
  "REHOBOAM": "(Hebrew) a large wine bottle containing 1.05 gallons [n -S]\n",
  "REHOBOAMS": "REHOBOAM, (Hebrew) a large wine bottle containing 1.05 gallons [n]\n",
  "REHOME": "to home again [v REHOMED, REHOMING, REHOMES]\n",
  "REHOMED": "REHOME, to home again [v]\n",
  "REHOMES": "REHOME, to home again [v]\n",
  "REHOMING": "the act of homing again [n -S]\n",
  "REHOMINGS": "REHOMING, the act of homing again [n]\n",
  "REHOSPITALISE": "to hospitalise again, also REHOSPITALIZE [v REHOSPITALISED, REHOSPITALISING, REHOSPITALISES]\n",
  "REHOSPITALISED": "REHOSPITALISE, to hospitalise again, also REHOSPITALIZE [v]\n",
  "REHOSPITALISES": "REHOSPITALISE, to hospitalise again, also REHOSPITALIZE [v]\n",
  "REHOSPITALISING": "REHOSPITALISE, to hospitalise again, also REHOSPITALIZE [v]\n",
  "REHOSPITALIZE": "to hospitalize again, also REHOSPITALISE [v REHOSPITALIZED, REHOSPITALIZING, REHOSPITALIZES]\n",
  "REHOSPITALIZED": "REHOSPITALIZE, to hospitalize again, also REHOSPITALISE [v]\n",
  "REHOSPITALIZES": "REHOSPITALIZE, to hospitalize again, also REHOSPITALISE [v]\n",
  "REHOSPITALIZING": "REHOSPITALIZE, to hospitalize again, also REHOSPITALISE [v]\n",
  "REHOUSE": "to establish in a new housing unit [v REHOUSED, REHOUSING, REHOUSES]\n",
  "REHOUSED": "REHOUSE, to establish in a new housing unit [v]\n",
  "REHOUSES": "REHOUSE, to establish in a new housing unit [v]\n",
  "REHOUSING": "the act of putting in a new house [n -S]\n",
  "REHOUSINGS": "REHOUSING, the act of putting in a new house [n]\n",
  "REHS": "REH, an accumulation of salts on soil [n]\n",
  "REHUMANISE": "to make human again, also REHUMANIZE [v REHUMANISED, REHUMANISING, REHUMANISES]\n",
  "REHUMANISED": "REHUMANISE, to make human again, also REHUMANIZE [v]\n",
  "REHUMANISES": "REHUMANISE, to make human again, also REHUMANIZE [v]\n",
  "REHUMANISING": "REHUMANISE, to make human again, also REHUMANIZE [v]\n",
  "REHUMANIZE": "to make human again, also REHUMANISE [v REHUMANIZED, REHUMANIZING, REHUMANIZES]\n",
  "REHUMANIZED": "REHUMANIZE, to make human again, also REHUMANISE [v]\n",
  "REHUMANIZES": "REHUMANIZE, to make human again, also REHUMANISE [v]\n",
  "REHUMANIZING": "REHUMANIZE, to make human again, also REHUMANISE [v]\n",
  "REHUNG": "REHANG, to hang again [v]\n",
  "REHYDRATABLE": "capable of being rehydrated [adj]\n",
  "REHYDRATE": "to add water to (a dehydrated substance) [v REHYDRATED, REHYDRATING, REHYDRATES]\n",
  "REHYDRATED": "REHYDRATE, to add water to (a dehydrated substance) [v]\n",
  "REHYDRATES": "REHYDRATE, to add water to (a dehydrated substance) [v]\n",
  "REHYDRATING": "REHYDRATE, to add water to (a dehydrated substance) [v]\n",
  "REHYDRATION": "the act of rehydrating [n -S]\n",
  "REHYDRATIONS": "REHYDRATION, the act of rehydrating [n]\n",
  "REHYPNOTISE": "to hypnotise again, also REHYPNOTIZE [v REHYPNOTISED, REHYPNOTISING, REHYPNOTISES]\n",
  "REHYPNOTISED": "REHYPNOTISE, to hypnotise again, also REHYPNOTIZE [v]\n",
  "REHYPNOTISES": "REHYPNOTISE, to hypnotise again, also REHYPNOTIZE [v]\n",
  "REHYPNOTISING": "REHYPNOTISE, to hypnotise again, also REHYPNOTIZE [v]\n",
  "REHYPNOTIZE": "to hypnotize again, also REHYPNOTISE [v REHYPNOTIZED, REHYPNOTIZING, REHYPNOTIZES]\n",
  "REHYPNOTIZED": "REHYPNOTIZE, to hypnotize again, also REHYPNOTISE [v]\n",
  "REHYPNOTIZES": "REHYPNOTIZE, to hypnotize again, also REHYPNOTISE [v]\n",
  "REHYPNOTIZING": "REHYPNOTIZE, to hypnotize again, also REHYPNOTISE [v]\n",
  "REI": "a former Portuguese coin [n -S]\n",
  "REICHSMARK": "(German) a German unit of currency [n -S]\n",
  "REICHSMARKS": "REICHSMARK, (German) a German unit of currency [n]\n",
  "REIDENTIFIED": "REIDENTIFY, to identify again [v]\n",
  "REIDENTIFIES": "REIDENTIFY, to identify again [v]\n",
  "REIDENTIFY": "to identify again [v REIDENTIFIED, REIDENTIFYING, REIDENTIFIES]\n",
  "REIDENTIFYING": "REIDENTIFY, to identify again [v]\n",
  "REIF": "(Scots) property etc. taken by force or robbery [n -S]\n",
  "REIFICATION": "the process or result of reifying [n -S]\n",
  "REIFICATIONS": "REIFICATION, the process or result of reifying [n]\n",
  "REIFICATORY": "effecting reification [adj]\n",
  "REIFIED": "REIFY, to regard as real or concrete [v]\n",
  "REIFIER": "one that reifies [n -S]\n",
  "REIFIERS": "REIFIER, one that reifies [n]\n",
  "REIFIES": "REIFY, to regard as real or concrete [v]\n",
  "REIFS": "REIF, (Scots) property etc. taken by force or robbery [n]\n",
  "REIFY": "to regard as real or concrete [v REIFIED, REIFYING, REIFIES]\n",
  "REIFYING": "REIFY, to regard as real or concrete [v]\n",
  "REIGN": "to exercise sovereign power [v -ED, -ING, -S]\n",
  "REIGNED": "REIGN, to exercise sovereign power [v]\n",
  "REIGNING": "REIGN, to exercise sovereign power [v]\n",
  "REIGNITE": "to light again [v REIGNITED, REIGNITING, REIGNITES]\n",
  "REIGNITED": "REIGNITE, to light again [v]\n",
  "REIGNITES": "REIGNITE, to light again [v]\n",
  "REIGNITING": "REIGNITE, to light again [v]\n",
  "REIGNITION": "the act of igniting again [n -S]\n",
  "REIGNITIONS": "REIGNITION, the act of igniting again [n]\n",
  "REIGNS": "REIGN, to exercise sovereign power [v]\n",
  "REIK": "(obsolete) a prank [n -S]\n",
  "REIKI": "(Japanese) a form of massage therapy [n -S]\n",
  "REIKIS": "REIKI, (Japanese) a form of massage therapy [n]\n",
  "REIKS": "REIK, (obsolete) a prank [n]\n",
  "REILLUME": "to light again [v REILLUMED, REILLUMING, REILLUMES]\n",
  "REILLUMED": "REILLUME, to light again [v]\n",
  "REILLUMES": "REILLUME, to light again [v]\n",
  "REILLUMINE": "to illumine again [v REILLUMINED, REILLUMINING, REILLUMINES]\n",
  "REILLUMINED": "REILLUMINE, to illumine again [v]\n",
  "REILLUMINES": "REILLUMINE, to illumine again [v]\n",
  "REILLUMING": "REILLUME, to light again [v]\n",
  "REILLUMINING": "REILLUMINE, to illumine again [v]\n",
  "REIMAGE": "to fix the image of [v REIMAGED, REIMAGING, REIMAGES]\n",
  "REIMAGED": "REIMAGE, to fix the image of [v]\n",
  "REIMAGES": "REIMAGE, to fix the image of [v]\n",
  "REIMAGINE": "to imagine again [v REIMAGINED, REIMAGINING, REIMAGINES]\n",
  "REIMAGINED": "REIMAGINE, to imagine again [v]\n",
  "REIMAGINES": "REIMAGINE, to imagine again [v]\n",
  "REIMAGING": "REIMAGE, to fix the image of [v]\n",
  "REIMAGINING": "REIMAGINE, to imagine again [v]\n",
  "REIMBURSABLE": "capable of being reimbursed [adj]\n",
  "REIMBURSE": "to repay [v REIMBURSED, REIMBURSING, REIMBURSES]\n",
  "REIMBURSED": "REIMBURSE, to repay [v]\n",
  "REIMBURSEMENT": "the act of reimbursing [n -S]\n",
  "REIMBURSEMENTS": "REIMBURSEMENT, the act of reimbursing [n]\n",
  "REIMBURSER": "one who reimburses [n -S]\n",
  "REIMBURSERS": "REIMBURSER, one who reimburses [n]\n",
  "REIMBURSES": "REIMBURSE, to repay [v]\n",
  "REIMBURSING": "REIMBURSE, to repay [v]\n",
  "REIMMERSE": "to immerse again [v REIMMERSED, REIMMERSING, REIMMERSES]\n",
  "REIMMERSED": "REIMMERSE, to immerse again [v]\n",
  "REIMMERSES": "REIMMERSE, to immerse again [v]\n",
  "REIMMERSING": "REIMMERSE, to immerse again [v]\n",
  "REIMPLANT": "to implant again [v -ED, -ING, -S]\n",
  "REIMPLANTATION": "the act of reimplanting [n -S]\n",
  "REIMPLANTATIONS": "REIMPLANTATION, the act of reimplanting [n]\n",
  "REIMPLANTED": "REIMPLANT, to implant again [v]\n",
  "REIMPLANTING": "REIMPLANT, to implant again [v]\n",
  "REIMPLANTS": "REIMPLANT, to implant again [v]\n",
  "REIMPORT": "to import again [v -ED, -ING, -S]\n",
  "REIMPORTATION": "the act of reimporting [n -S]\n",
  "REIMPORTATIONS": "REIMPORTATION, the act of reimporting [n]\n",
  "REIMPORTED": "REIMPORT, to import again [v]\n",
  "REIMPORTER": "one who reimports [n -S]\n",
  "REIMPORTERS": "REIMPORTER, one who reimports [n]\n",
  "REIMPORTING": "REIMPORT, to import again [v]\n",
  "REIMPORTS": "REIMPORT, to import again [v]\n",
  "REIMPOSE": "to impose again [v REIMPOSED, REIMPOSING, REIMPOSES]\n",
  "REIMPOSED": "REIMPOSE, to impose again [v]\n",
  "REIMPOSES": "REIMPOSE, to impose again [v]\n",
  "REIMPOSING": "REIMPOSE, to impose again [v]\n",
  "REIMPOSITION": "the act of reimposing [n -S]\n",
  "REIMPOSITIONS": "REIMPOSITION, the act of reimposing [n]\n",
  "REIMPRESSION": "a second or later impression of an edition of a book, etc. [n -S]\n",
  "REIMPRESSIONS": "REIMPRESSION, a second or later impression of an edition of a book, etc. [n]\n",
  "REIN": "to restrain [v -ED, -ING, -S]\n",
  "REINCARNATE": "to incarnate again [v REINCARNATED, REINCARNATING, REINCARNATES]\n",
  "REINCARNATED": "REINCARNATE, to incarnate again [v]\n",
  "REINCARNATES": "REINCARNATE, to incarnate again [v]\n",
  "REINCARNATING": "REINCARNATE, to incarnate again [v]\n",
  "REINCARNATION": "the action of reincarnating [n -S]\n",
  "REINCARNATIONS": "REINCARNATION, the action of reincarnating [n]\n",
  "REINCITE": "to incite again [v REINCITED, REINCITING, REINCITES]\n",
  "REINCITED": "REINCITE, to incite again [v]\n",
  "REINCITES": "REINCITE, to incite again [v]\n",
  "REINCITING": "REINCITE, to incite again [v]\n",
  "REINCORPORATE": "to incorporate again [v REINCORPORATED, REINCORPORATING, REINCORPORATES]\n",
  "REINCORPORATED": "REINCORPORATE, to incorporate again [v]\n",
  "REINCORPORATES": "REINCORPORATE, to incorporate again [v]\n",
  "REINCORPORATING": "REINCORPORATE, to incorporate again [v]\n",
  "REINCORPORATION": "the act of reincorporating [n]\n",
  "REINCREASE": "to increase again [v REINCREASED, REINCREASING, REINCREASES]\n",
  "REINCREASED": "REINCREASE, to increase again [v]\n",
  "REINCREASES": "REINCREASE, to increase again [v]\n",
  "REINCREASING": "REINCREASE, to increase again [v]\n",
  "REINCUR": "to incur again [v REINCURRED, REINCURRING, REINCURS]\n",
  "REINCURRED": "REINCUR, to incur again [v]\n",
  "REINCURRING": "REINCUR, to incur again [v]\n",
  "REINCURS": "REINCUR, to incur again [v]\n",
  "REINDEER": "a large deer [n -S]\n",
  "REINDEERS": "REINDEER, a large deer [n]\n",
  "REINDEX": "to index again [v -ED, -ING, -ES]\n",
  "REINDEXED": "REINDEX, to index again [v]\n",
  "REINDEXES": "REINDEX, to index again [v]\n",
  "REINDEXING": "REINDEX, to index again [v]\n",
  "REINDICT": "to indict again [v -ED, -ING, -S]\n",
  "REINDICTED": "REINDICT, to indict again [v]\n",
  "REINDICTING": "REINDICT, to indict again [v]\n",
  "REINDICTMENT": "the act of reindicting [n -S]\n",
  "REINDICTMENTS": "REINDICTMENT, the act of reindicting [n]\n",
  "REINDICTS": "REINDICT, to indict again [v]\n",
  "REINDUCE": "to induce again [v REINDUCED, REINDUCING, REINDUCES]\n",
  "REINDUCED": "REINDUCE, to induce again [v]\n",
  "REINDUCES": "REINDUCE, to induce again [v]\n",
  "REINDUCING": "REINDUCE, to induce again [v]\n",
  "REINDUCT": "to induct again [v -ED, -ING, -S]\n",
  "REINDUCTED": "REINDUCT, to induct again [v]\n",
  "REINDUCTING": "REINDUCT, to induct again [v]\n",
  "REINDUCTS": "REINDUCT, to induct again [v]\n",
  "REINDUSTRIALISE": "to industrialise again, also REINDUSTRIALIZE [v]\n",
  "REINDUSTRIALIZE": "to industrialise again, also REINDUSTRIALISE [v]\n",
  "REINED": "REIN, to restrain [v]\n",
  "REINETTE": "(French) a name given to many different kinds of apples, mostly of French origin, also RENNET, RUNNET [n -S]\n",
  "REINETTES": "REINETTE, (French) a name given to many different kinds of apples, mostly of French origin, also RENNET, RUNNET [n]\n",
  "REINFECT": "to infect again [v -ED, -ING, -S]\n",
  "REINFECTED": "REINFECT, to infect again [v]\n",
  "REINFECTING": "REINFECT, to infect again [v]\n",
  "REINFECTION": "infection following recovery from or superimposed on infection of the same type [n -S]\n",
  "REINFECTIONS": "REINFECTION, infection following recovery from or superimposed on infection of the same type [n]\n",
  "REINFECTS": "REINFECT, to infect again [v]\n",
  "REINFESTATION": "a recurrence of an infestation [n -S]\n",
  "REINFESTATIONS": "REINFESTATION, a recurrence of an infestation [n]\n",
  "REINFLAME": "to inflame again [v REINFLAMED, REINFLAMING, REINFLAMES]\n",
  "REINFLAMED": "REINFLAME, to inflame again [v]\n",
  "REINFLAMES": "REINFLAME, to inflame again [v]\n",
  "REINFLAMING": "REINFLAME, to inflame again [v]\n",
  "REINFLATE": "to inflate again [v REINFLATED, REINFLATING, REINFLATES]\n",
  "REINFLATED": "REINFLATE, to inflate again [v]\n",
  "REINFLATES": "REINFLATE, to inflate again [v]\n",
  "REINFLATING": "REINFLATE, to inflate again [v]\n",
  "REINFLATION": "the act of reinflating [n -S]\n",
  "REINFLATIONS": "REINFLATION, the act of reinflating [n]\n",
  "REINFORCE": "to strengthen with new force, assistance, material, or support, also REENFORCE, RENFORCE [v REINFORCED, REINFORCING, REINFORCES]\n",
  "REINFORCEABLE": "capable of being reinforced [adj]\n",
  "REINFORCED": "REINFORCE, to strengthen with new force, assistance, material, or support, also REENFORCE, RENFORCE [v]\n",
  "REINFORCEMENT": "the action of reinforcing [n -S]\n",
  "REINFORCEMENTS": "REINFORCEMENT, the action of reinforcing [n]\n",
  "REINFORCER": "something that reinforces [n -S]\n",
  "REINFORCERS": "REINFORCER, something that reinforces [n]\n",
  "REINFORCES": "REINFORCE, to strengthen with new force, assistance, material, or support, also REENFORCE, RENFORCE [v]\n",
  "REINFORCING": "REINFORCE, to strengthen with new force, assistance, material, or support, also REENFORCE, RENFORCE [v]\n",
  "REINFORM": "to inform again [v -ED, -ING, -S]\n",
  "REINFORMED": "REINFORM, to inform again [v]\n",
  "REINFORMING": "REINFORM, to inform again [v]\n",
  "REINFORMS": "REINFORM, to inform again [v]\n",
  "REINFUND": "to flow again [v -ED, -ING, -S]\n",
  "REINFUNDED": "REINFUND, to flow again [v]\n",
  "REINFUNDING": "REINFUND, to flow again [v]\n",
  "REINFUNDS": "REINFUND, to flow again [v]\n",
  "REINFUSE": "to infuse again [v REINFUSED, REINFUSING, REINFUSES]\n",
  "REINFUSED": "REINFUSE, to infuse again [v]\n",
  "REINFUSES": "REINFUSE, to infuse again [v]\n",
  "REINFUSING": "REINFUSE, to infuse again [v]\n",
  "REINHABIT": "to inhabit again [v -ED, -ING, -S]\n",
  "REINHABITED": "REINHABIT, to inhabit again [v]\n",
  "REINHABITING": "REINHABIT, to inhabit again [v]\n",
  "REINHABITS": "REINHABIT, to inhabit again [v]\n",
  "REINING": "REIN, to restrain [v]\n",
  "REINITIATE": "to initiate again [v REINITIATED, REINITIATING, REINITIATES]\n",
  "REINITIATED": "REINITIATE, to initiate again [v]\n",
  "REINITIATES": "REINITIATE, to initiate again [v]\n",
  "REINITIATING": "REINITIATE, to initiate again [v]\n",
  "REINJECT": "to inject again [v -ED, -ING, -S]\n",
  "REINJECTED": "REINJECT, to inject again [v]\n",
  "REINJECTING": "REINJECT, to inject again [v]\n",
  "REINJECTION": "the act of reinjecting [n -S]\n",
  "REINJECTIONS": "REINJECTION, the act of reinjecting [n]\n",
  "REINJECTS": "REINJECT, to inject again [v]\n",
  "REINJURE": "to injure again [v REINJURED, REINJURING, REINJURES]\n",
  "REINJURED": "REINJURE, to injure again [v]\n",
  "REINJURES": "REINJURE, to injure again [v]\n",
  "REINJURIES": "REINJURY, a second injury [n]\n",
  "REINJURING": "REINJURE, to injure again [v]\n",
  "REINJURY": "a second injury [n REINJURIES]\n",
  "REINK": "to ink again [v -ED, -ING, -S]\n",
  "REINKED": "REINK, to ink again [v]\n",
  "REINKING": "REINK, to ink again [v]\n",
  "REINKS": "REINK, to ink again [v]\n",
  "REINLESS": "unrestrained [adj]\n",
  "REINNERVATE": "to innervate again [v REINNERVATED, REINNERVATING, REINNERVATES]\n",
  "REINNERVATED": "REINNERVATE, to innervate again [v]\n",
  "REINNERVATES": "REINNERVATE, to innervate again [v]\n",
  "REINNERVATING": "REINNERVATE, to innervate again [v]\n",
  "REINNERVATION": "the act of reinnervating [n -S]\n",
  "REINNERVATIONS": "REINNERVATION, the act of reinnervating [n]\n",
  "REINOCULATE": "to inoculate again [v REINOCULATED, REINOCULATING, REINOCULATES]\n",
  "REINOCULATED": "REINOCULATE, to inoculate again [v]\n",
  "REINOCULATES": "REINOCULATE, to inoculate again [v]\n",
  "REINOCULATING": "REINOCULATE, to inoculate again [v]\n",
  "REINOCULATION": "the act of reinoculating [n -S]\n",
  "REINOCULATIONS": "REINOCULATION, the act of reinoculating [n]\n",
  "REINS": "REIN, to restrain [v]\n",
  "REINSERT": "to insert again [v -ED, -ING, -S]\n",
  "REINSERTED": "REINSERT, to insert again [v]\n",
  "REINSERTING": "REINSERT, to insert again [v]\n",
  "REINSERTION": "the act of reinserting [n -S]\n",
  "REINSERTIONS": "REINSERTION, the act of reinserting [n]\n",
  "REINSERTS": "REINSERT, to insert again [v]\n",
  "REINSMAN": "a skilled rider of horses [n REINSMEN]\n",
  "REINSMEN": "REINSMAN, a skilled rider of horses [n]\n",
  "REINSPECT": "to inspect again [v -ED, -ING, -S]\n",
  "REINSPECTED": "REINSPECT, to inspect again [v]\n",
  "REINSPECTING": "REINSPECT, to inspect again [v]\n",
  "REINSPECTION": "a repeated inspection [n -S]\n",
  "REINSPECTIONS": "REINSPECTION, a repeated inspection [n]\n",
  "REINSPECTS": "REINSPECT, to inspect again [v]\n",
  "REINSPIRE": "to inspire anew [v REINSPIRED, REINSPIRING, REINSPIRES]\n",
  "REINSPIRED": "REINSPIRE, to inspire anew [v]\n",
  "REINSPIRES": "REINSPIRE, to inspire anew [v]\n",
  "REINSPIRING": "REINSPIRE, to inspire anew [v]\n",
  "REINSPIRIT": "to give fresh spirit to [v -ED, -ING, -S]\n",
  "REINSPIRITED": "REINSPIRIT, to give fresh spirit to [v]\n",
  "REINSPIRITING": "REINSPIRIT, to give fresh spirit to [v]\n",
  "REINSPIRITS": "REINSPIRIT, to give fresh spirit to [v]\n",
  "REINSTAL": "to instal again, also REINSTALL [v REINSTALLED, REINSTALLING, REINSTALS]\n",
  "REINSTALL": "to install again, also REINSTAL [v -ED, -ING, -S]\n",
  "REINSTALLATION": "the act of reinstalling [n -S]\n",
  "REINSTALLATIONS": "REINSTALLATION, the act of reinstalling [n]\n",
  "REINSTALLED": "REINSTALL, to install again, also REINSTAL [v]\n",
  "REINSTALLING": "REINSTALL, to install again, also REINSTAL [v]\n",
  "REINSTALLS": "REINSTALL, to install again, also REINSTAL [v]\n",
  "REINSTALMENT": "the act of reinstalling [n -S]\n",
  "REINSTALMENTS": "REINSTALMENT, the act of reinstalling [n]\n",
  "REINSTALS": "REINSTAL, to instal again, also REINSTALL [v]\n",
  "REINSTATE": "to instate again [v REINSTATED, REINSTATING, REINSTATES]\n",
  "REINSTATED": "REINSTATE, to instate again [v]\n",
  "REINSTATEMENT": "the act of reinstating, also REINSTATION [n -S]\n",
  "REINSTATEMENTS": "REINSTATEMENT, the act of reinstating, also REINSTATION [n]\n",
  "REINSTATES": "REINSTATE, to instate again [v]\n",
  "REINSTATING": "REINSTATE, to instate again [v]\n",
  "REINSTATION": "the act of reinstating, also REINSTATEMENT [n -S]\n",
  "REINSTATIONS": "REINSTATION, the act of reinstating, also REINSTATEMENT [n]\n",
  "REINSTATOR": "one who reinstates [n -S]\n",
  "REINSTATORS": "REINSTATOR, one who reinstates [n]\n",
  "REINSTITUTE": "to institute again [v REINSTITUTED, REINSTITUTING, REINSTITUTES]\n",
  "REINSTITUTED": "REINSTITUTE, to institute again [v]\n",
  "REINSTITUTES": "REINSTITUTE, to institute again [v]\n",
  "REINSTITUTING": "REINSTITUTE, to institute again [v]\n",
  "REINSTITUTION": "the act of reinstituting [n -S]\n",
  "REINSTITUTIONS": "REINSTITUTION, the act of reinstituting [n]\n",
  "REINSURANCE": "insurance by another insurer of all or a part of a risk previously assumed by an insurance company [n -S]\n",
  "REINSURANCES": "REINSURANCE, insurance by another insurer of all or a part of a risk previously assumed by an insurance company [n]\n",
  "REINSURE": "to insure again [v REINSURED, REINSURING, REINSURES]\n",
  "REINSURED": "REINSURE, to insure again [v]\n",
  "REINSURER": "one who gives reinsurance [n -S]\n",
  "REINSURERS": "REINSURER, one who gives reinsurance [n]\n",
  "REINSURES": "REINSURE, to insure again [v]\n",
  "REINSURING": "REINSURE, to insure again [v]\n",
  "REINTEGRATE": "to integrate again into an entity [v REINTEGRATED, REINTEGRATING, REINTEGRATES]\n",
  "REINTEGRATED": "REINTEGRATE, to integrate again into an entity [v]\n",
  "REINTEGRATES": "REINTEGRATE, to integrate again into an entity [v]\n",
  "REINTEGRATING": "REINTEGRATE, to integrate again into an entity [v]\n",
  "REINTEGRATION": "the act of reintegrating [n -S]\n",
  "REINTEGRATIONS": "REINTEGRATION, the act of reintegrating [n]\n",
  "REINTEGRATIVE": "serving to reintegrate [adj]\n",
  "REINTER": "to inter again [v REINTERRED, REINTERRING, REINTERS]\n",
  "REINTERMENT": "reburial [n -S]\n",
  "REINTERMENTS": "REINTERMENT, reburial [n]\n",
  "REINTERPRET": "to interpret again [v -ED, -ING, -S]\n",
  "REINTERPRETED": "REINTERPRET, to interpret again [v]\n",
  "REINTERPRETING": "REINTERPRET, to interpret again [v]\n",
  "REINTERPRETS": "REINTERPRET, to interpret again [v]\n",
  "REINTERRED": "REINTER, to inter again [v]\n",
  "REINTERRING": "REINTER, to inter again [v]\n",
  "REINTERROGATE": "to interrogate again [v REINTERROGATED, REINTERROGATING, REINTERROGATES]\n",
  "REINTERROGATED": "REINTERROGATE, to interrogate again [v]\n",
  "REINTERROGATES": "REINTERROGATE, to interrogate again [v]\n",
  "REINTERROGATING": "REINTERROGATE, to interrogate again [v]\n",
  "REINTERROGATION": "a new interrogation [n]\n",
  "REINTERS": "REINTER, to inter again [v]\n",
  "REINTERVIEW": "to interview again [v -ED, -ING, -S]\n",
  "REINTERVIEWED": "REINTERVIEW, to interview again [v]\n",
  "REINTERVIEWING": "REINTERVIEW, to interview again [v]\n",
  "REINTERVIEWS": "REINTERVIEW, to interview again [v]\n",
  "REINTRODUCE": "to introduce again [v REINTRODUCED, REINTRODUCING, REINTRODUCES]\n",
  "REINTRODUCED": "REINTRODUCE, to introduce again [v]\n",
  "REINTRODUCES": "REINTRODUCE, to introduce again [v]\n",
  "REINTRODUCING": "REINTRODUCE, to introduce again [v]\n",
  "REINTRODUCTION": "the act of reintroducing [n -S]\n",
  "REINTRODUCTIONS": "REINTRODUCTION, the act of reintroducing [n]\n",
  "REINVADE": "to invade again [v REINVADED, REINVADING, REINVADES]\n",
  "REINVADED": "REINVADE, to invade again [v]\n",
  "REINVADES": "REINVADE, to invade again [v]\n",
  "REINVADING": "REINVADE, to invade again [v]\n",
  "REINVASION": "the act of invading again [n -S]\n",
  "REINVASIONS": "REINVASION, the act of invading again [n]\n",
  "REINVENT": "to invent again [v -ED, -ING, -S]\n",
  "REINVENTED": "REINVENT, to invent again [v]\n",
  "REINVENTING": "REINVENT, to invent again [v]\n",
  "REINVENTION": "the act of reinventing [n -S]\n",
  "REINVENTIONS": "REINVENTION, the act of reinventing [n]\n",
  "REINVENTS": "REINVENT, to invent again [v]\n",
  "REINVEST": "to invest again [v -ED, -ING, -S]\n",
  "REINVESTED": "REINVEST, to invest again [v]\n",
  "REINVESTIGATE": "to investigate again [v REINVESTIGATED, REINVESTIGATING, REINVESTIGATES]\n",
  "REINVESTIGATED": "REINVESTIGATE, to investigate again [v]\n",
  "REINVESTIGATES": "REINVESTIGATE, to investigate again [v]\n",
  "REINVESTIGATING": "REINVESTIGATE, to investigate again [v]\n",
  "REINVESTIGATION": "the act of reinvestigating [n]\n",
  "REINVESTING": "REINVEST, to invest again [v]\n",
  "REINVESTMENT": "the action of reinvesting [n -S]\n",
  "REINVESTMENTS": "REINVESTMENT, the action of reinvesting [n]\n",
  "REINVESTS": "REINVEST, to invest again [v]\n",
  "REINVIGORATE": "to invigorate again [v REINVIGORATED, REINVIGORATING, REINVIGORATES]\n",
  "REINVIGORATED": "REINVIGORATE, to invigorate again [v]\n",
  "REINVIGORATES": "REINVIGORATE, to invigorate again [v]\n",
  "REINVIGORATING": "REINVIGORATE, to invigorate again [v]\n",
  "REINVIGORATION": "the act of reinvigorating [n -S]\n",
  "REINVIGORATIONS": "REINVIGORATION, the act of reinvigorating [n]\n",
  "REINVIGORATOR": "somehting that reinvigorates [n -S]\n",
  "REINVIGORATORS": "REINVIGORATOR, somehting that reinvigorates [n]\n",
  "REINVITE": "to invite again [v REINVITED, REINVITING, REINVITES]\n",
  "REINVITED": "REINVITE, to invite again [v]\n",
  "REINVITES": "REINVITE, to invite again [v]\n",
  "REINVITING": "REINVITE, to invite again [v]\n",
  "REINVOKE": "to invoke again [v REINVOKED, REINVOKING, REINVOKES]\n",
  "REINVOKED": "REINVOKE, to invoke again [v]\n",
  "REINVOKES": "REINVOKE, to invoke again [v]\n",
  "REINVOKING": "REINVOKE, to invoke again [v]\n",
  "REINVOLVE": "to involve anew [v REINVOLVED, REINVOLVING, REINVOLVES]\n",
  "REINVOLVED": "REINVOLVE, to involve anew [v]\n",
  "REINVOLVES": "REINVOLVE, to involve anew [v]\n",
  "REINVOLVING": "REINVOLVE, to involve anew [v]\n",
  "REIOYNDURE": "(Shakespeare) a rejoindure, a joining again, also REJOINDURE [n -S]\n",
  "REIOYNDURES": "REIOYNDURE, (Shakespeare) a rejoindure, a joining again, also REJOINDURE [n]\n",
  "REIRD": "(Scots) an uproar, also RAIRD [n -S]\n",
  "REIRDS": "REIRD, (Scots) an uproar, also RAIRD [n]\n",
  "REIS": "twigs or small branches [n -ES]\n",
  "REISES": "REIS, twigs or small branches [n]\n",
  "REISHI": "(Japanese) a mushroom having a shiny cap [n -S]\n",
  "REISHIS": "REISHI, (Japanese) a mushroom having a shiny cap [n]\n",
  "REISSUABLE": "capable of being reissued [adj]\n",
  "REISSUE": "to issue again [v REISSUED, REISSUING, REISSUES]\n",
  "REISSUED": "REISSUE, to issue again [v]\n",
  "REISSUER": "one who reissues [n -S]\n",
  "REISSUERS": "REISSUER, one who reissues [n]\n",
  "REISSUES": "REISSUE, to issue again [v]\n",
  "REISSUING": "REISSUE, to issue again [v]\n",
  "REIST": "to become rancid [v -ED, -ING, -S]\n",
  "REISTAFEL": "(Dutch) an Indonesian rice dish, also RIJSTAFEL, RIJSTTAFEL [n -S]\n",
  "REISTAFELS": "REISTAFEL, (Dutch) an Indonesian rice dish, also RIJSTAFEL, RIJSTTAFEL [n]\n",
  "REISTED": "REIST, to become rancid [v]\n",
  "REISTING": "REIST, to become rancid [v]\n",
  "REISTS": "REIST, to become rancid [v]\n",
  "REITBOK": "(South African) a kind of antelope, also REEDBUCK [n -S]\n",
  "REITBOKS": "REITBOK, (South African) a kind of antelope, also REEDBUCK [n]\n",
  "REITER": "to reiterate [v -ED, -ING, -S]\n",
  "REITERANCE": "the act of reiterating [n -S]\n",
  "REITERANCES": "REITERANCE, the act of reiterating [n]\n",
  "REITERANT": "reiterating [adj]\n",
  "REITERATE": "to repeat [v REITERATED, REITERATING, REITERATES]\n",
  "REITERATED": "REITERATE, to repeat [v]\n",
  "REITERATEDLY": "REITERATED, REITERATE, to repeat [adv]\n",
  "REITERATES": "REITERATE, to repeat [v]\n",
  "REITERATING": "REITERATE, to repeat [v]\n",
  "REITERATION": "the act of reiterating [n -S]\n",
  "REITERATIONS": "REITERATION, the act of reiterating [n]\n",
  "REITERATIVE": "repeating [adj REITERATIVELY] / a word formed by reduplication, the second element usually differing from the first e.g. helter-skelter [n -S]\n",
  "REITERATIVELY": "REITERATIVE, repeating [adv]\n",
  "REITERATIVES": "REITERATIVE, a word formed by reduplication, the second element usually differing from the first e.g. helter-skelter [n]\n",
  "REITERED": "REITER, to reiterate [v]\n",
  "REITERING": "REITER, to reiterate [v]\n",
  "REITERS": "REITER, to reiterate [v]\n",
  "REIVE": "(archaic) to plunder, rob, also REAVE, RIEVE [v REIVED, REIVING, REIVES]\n",
  "REIVED": "REIVE, (archaic) to plunder, rob, also REAVE, RIEVE [v]\n",
  "REIVER": "a raider, plunderer, also REAVER, RIEVER [n -S]\n",
  "REIVERS": "REIVER, a raider, plunderer, also REAVER, RIEVER [n]\n",
  "REIVES": "REIVE, (archaic) to plunder, rob, also REAVE, RIEVE [v]\n",
  "REIVING": "plundering [n -S]\n",
  "REIVINGS": "REIVING, plundering [n]\n",
  "REJACKET": "to clothe in a jacket once more [v -ED, -ING, -S]\n",
  "REJACKETED": "REJACKET, to clothe in a jacket once more [v]\n",
  "REJACKETING": "REJACKET, to clothe in a jacket once more [v]\n",
  "REJACKETS": "REJACKET, to clothe in a jacket once more [v]\n",
  "REJECT": "to refuse to accept [v -ED, -ING, -S]\n",
  "REJECTABLE": "capable of being rejected, also REJECTIBLE [adj]\n",
  "REJECTAMENTA": "refuse; excrement [n]\n",
  "REJECTED": "REJECT, to refuse to accept [v]\n",
  "REJECTEE": "one who is rejected [n -S]\n",
  "REJECTEES": "REJECTEE, one who is rejected [n]\n",
  "REJECTER": "one who rejects, also REJECTOR [n -S]\n",
  "REJECTERS": "REJECTER, one who rejects, also REJECTOR [n]\n",
  "REJECTIBLE": "capable of being rejected, also REJECTABLE [adj]\n",
  "REJECTING": "REJECT, to refuse to accept [v]\n",
  "REJECTINGLY": "REJECTING, REJECT, to refuse to accept [adv]\n",
  "REJECTION": "the act of rejecting [n -S]\n",
  "REJECTIONIST": "one who rejects e.g. an offer or peace plan [n -S]\n",
  "REJECTIONISTS": "REJECTIONIST, one who rejects e.g. an offer or peace plan [n]\n",
  "REJECTIONS": "REJECTION, the act of rejecting [n]\n",
  "REJECTIVE": "rejecting, or tending to reject [adj]\n",
  "REJECTOR": "one who rejects, also REJECTER [n -S]\n",
  "REJECTORS": "REJECTOR, one who rejects, also REJECTER [n]\n",
  "REJECTS": "REJECT, to refuse to accept [v]\n",
  "REJIG": "to fix something up in a different fashion, also REJIGGER [v REJIGGED, REJIGGING, REJIGS]\n",
  "REJIGGED": "REJIG, to fix something up in a different fashion, also REJIGGER [v]\n",
  "REJIGGER": "to fix something up in a different fashion, also REJIG [v -ED, -ING, -S]\n",
  "REJIGGERED": "REJIGGER, to fix something up in a different fashion, also REJIG [v]\n",
  "REJIGGERING": "REJIGGER, to fix something up in a different fashion, also REJIG [v]\n",
  "REJIGGERS": "REJIGGER, to fix something up in a different fashion, also REJIG [v]\n",
  "REJIGGING": "REJIG, to fix something up in a different fashion, also REJIGGER [v]\n",
  "REJIGS": "REJIG, to fix something up in a different fashion, also REJIGGER [v]\n",
  "REJOICE": "to feel joyful [v REJOICED, REJOICING, REJOICES]\n",
  "REJOICED": "REJOICE, to feel joyful [v]\n",
  "REJOICEFUL": "joyous, full of rejoicing [adj]\n",
  "REJOICEMENT": "the act of rejoicing [n -S]\n",
  "REJOICEMENTS": "REJOICEMENT, the act of rejoicing [n]\n",
  "REJOICER": "one who rejoices [n -S]\n",
  "REJOICERS": "REJOICER, one who rejoices [n]\n",
  "REJOICES": "REJOICE, to feel joyful [v]\n",
  "REJOICING": "joyful [adj REJOICINGLY] / the act of rejoicing [n -S]\n",
  "REJOICINGLY": "REJOICING, joyful [adv]\n",
  "REJOICINGS": "REJOICING, the act of rejoicing [n]\n",
  "REJOIN": "to join again [v -ED, -ING, -S]\n",
  "REJOINDER": "a sharp and clever answer; in law, the defendant's answer to the plaintiff's reply/replication [n -S]\n",
  "REJOINDERS": "REJOINDER, a sharp and clever answer; in law, the defendant's answer to the plaintiff's reply/replication [n]\n",
  "REJOINDURE": "the act of joining again, also REIOYNDURE [n -S]\n",
  "REJOINDURES": "REJOINDURE, the act of joining again, also REIOYNDURE [n]\n",
  "REJOINED": "REJOIN, to join again [v]\n",
  "REJOINING": "REJOIN, to join again [v]\n",
  "REJOINS": "REJOIN, to join again [v]\n",
  "REJON": "(Spanish) a lance with a wooden handle, used in bullfighting [n -ES]\n",
  "REJONEADOR": "(Spanish) a mounted bullfighter who uses rejones, a lance with a wooden handle [n REJONEADORES]\n",
  "REJONEADORA": "(Spanish) a female rejoneador, a mounted bullfighter who uses rejones, a lance with a wooden handle [n -S]\n",
  "REJONEADORAS": "REJONEADORA, (Spanish) a female rejoneador, a mounted bullfighter who uses rejones, a lance with a wooden handle [n]\n",
  "REJONEADORES": "REJONEADOR, (Spanish) a mounted bullfighter who uses rejones, a lance with a wooden handle [n]\n",
  "REJONEO": "(Spanish) the art of bullfighting on horseback using rejones [n -S]\n",
  "REJONEOS": "REJONEO, (Spanish) the art of bullfighting on horseback using rejones [n]\n",
  "REJONES": "REJON, (Spanish) a lance with a wooden handle, used in bullfighting [n]\n",
  "REJOURN": "(Shakespeare) to postpone, defer [v -ED, -ING, -S]\n",
  "REJOURNED": "REJOURN, (Shakespeare) to postpone, defer [v]\n",
  "REJOURNING": "REJOURN, (Shakespeare) to postpone, defer [v]\n",
  "REJOURNS": "REJOURN, (Shakespeare) to postpone, defer [v]\n",
  "REJUDGE": "to judge again [v REJUDGED, REJUDGING, REJUDGES]\n",
  "REJUDGED": "REJUDGE, to judge again [v]\n",
  "REJUDGES": "REJUDGE, to judge again [v]\n",
  "REJUDGING": "REJUDGE, to judge again [v]\n",
  "REJUGGLE": "to juggle again [v REJUGGLED, REJUGGLING, REJUGGLES]\n",
  "REJUGGLED": "REJUGGLE, to juggle again [v]\n",
  "REJUGGLES": "REJUGGLE, to juggle again [v]\n",
  "REJUGGLING": "REJUGGLE, to juggle again [v]\n",
  "REJUSTIFIED": "REJUSTIFY, to justify again [v]\n",
  "REJUSTIFIES": "REJUSTIFY, to justify again [v]\n",
  "REJUSTIFY": "to justify again [v REJUSTIFIED, REJUSTIFYING, REJUSTIFIES]\n",
  "REJUSTIFYING": "REJUSTIFY, to justify again [v]\n",
  "REJUVENATE": "to make young again [v REJUVENATED, REJUVENATING, REJUVENATES]\n",
  "REJUVENATED": "REJUVENATE, to make young again [v]\n",
  "REJUVENATES": "REJUVENATE, to make young again [v]\n",
  "REJUVENATING": "REJUVENATE, to make young again [v]\n",
  "REJUVENATION": "the act of making young again [n -S]\n",
  "REJUVENATIONS": "REJUVENATION, the act of making young again [n]\n",
  "REJUVENATOR": "something that rejuvenates [n -S]\n",
  "REJUVENATORS": "REJUVENATOR, something that rejuvenates [n]\n",
  "REJUVENESCE": "to make young again [v REJUVENESCED, REJUVENESCING, REJUVENESCES]\n",
  "REJUVENESCED": "REJUVENESCE, to make young again [v]\n",
  "REJUVENESCENCE": "a renewal of youthfulness or vigor [n -S]\n",
  "REJUVENESCENCES": "REJUVENESCENCE, a renewal of youthfulness or vigor [n]\n",
  "REJUVENESCENT": "effecting rejuvenescence [adj]\n",
  "REJUVENESCES": "REJUVENESCE, to make young again [v]\n",
  "REJUVENESCING": "REJUVENESCE, to make young again [v]\n",
  "REJUVENISE": "to rejuvenate, also REJUVENIZE [v REJUVENISED, REJUVENISING, REJUVENISES]\n",
  "REJUVENISED": "REJUVENISE, to rejuvenate, also REJUVENIZE [v]\n",
  "REJUVENISES": "REJUVENISE, to rejuvenate, also REJUVENIZE [v]\n",
  "REJUVENISING": "REJUVENISE, to rejuvenate, also REJUVENIZE [v]\n",
  "REJUVENIZE": "to rejuvenate, also REJUVENISE [v REJUVENIZED, REJUVENIZING, REJUVENIZES]\n",
  "REJUVENIZED": "REJUVENIZE, to rejuvenate, also REJUVENISE [v]\n",
  "REJUVENIZES": "REJUVENIZE, to rejuvenate, also REJUVENISE [v]\n",
  "REJUVENIZING": "REJUVENIZE, to rejuvenate, also REJUVENISE [v]\n",
  "REKE": "(Spenser) to reckon, care for, heed, also REAK, RECK [v REKED, REKING, REKES]\n",
  "REKED": "REKE, (Spenser) to reckon, care for, heed, also REAK, RECK [v]\n",
  "REKES": "REKE, (Spenser) to reckon, care for, heed, also REAK, RECK [v]\n",
  "REKEY": "to reenter information [v -ED, -ING, -S]\n",
  "REKEYBOARD": "to enter again on a keyboard [v -ED, -ING, -S]\n",
  "REKEYBOARDED": "REKEYBOARD, to enter again on a keyboard [v]\n",
  "REKEYBOARDING": "REKEYBOARD, to enter again on a keyboard [v]\n",
  "REKEYBOARDS": "REKEYBOARD, to enter again on a keyboard [v]\n",
  "REKEYED": "REKEY, to reenter information [v]\n",
  "REKEYING": "REKEY, to reenter information [v]\n",
  "REKEYS": "REKEY, to reenter information [v]\n",
  "REKINDLE": "to arouse once more [v REKINDLED, REKINDLING, REKINDLES]\n",
  "REKINDLED": "REKINDLE, to arouse once more [v]\n",
  "REKINDLES": "REKINDLE, to arouse once more [v]\n",
  "REKINDLING": "the act of kindling again [n -S]\n",
  "REKINDLINGS": "REKINDLING, the act of kindling again [n]\n",
  "REKING": "REKE, (Spenser) to reckon, care for, heed, also REAK, RECK [v]\n",
  "REKNIT": "to knit again [v REKNITTED, REKNITTING, REKNITS]\n",
  "REKNITS": "REKNIT, to knit again [v]\n",
  "REKNITTED": "REKNIT, to knit again [v]\n",
  "REKNITTING": "the act of knitting again [n -S]\n",
  "REKNITTINGS": "REKNITTING, the act of knitting again [n]\n",
  "REKNOT": "to knot again [v REKNOTTED, REKNOTTING, REKNOTS]\n",
  "REKNOTS": "REKNOT, to knot again [v]\n",
  "REKNOTTED": "REKNOT, to knot again [v]\n",
  "REKNOTTING": "the act of knotting again [n -S]\n",
  "REKNOTTINGS": "REKNOTTING, the act of knotting again [n]\n",
  "RELABEL": "to label again [v RELABELED or RELABELLED, RELABELING or RELABELLING, RELABELS]\n",
  "RELABELED": "RELABEL, to label again [v]\n",
  "RELABELING": "RELABEL, to label again [v]\n",
  "RELABELLED": "RELABEL, to label again [v]\n",
  "RELABELLING": "RELABEL, to label again [v]\n",
  "RELABELS": "RELABEL, to label again [v]\n",
  "RELACE": "to do up again [v RELACED, RELACING, RELACES]\n",
  "RELACED": "RELACE, to do up again [v]\n",
  "RELACES": "RELACE, to do up again [v]\n",
  "RELACHE": "(French) a period of rest; a break from something [n -S]\n",
  "RELACHES": "RELACHE, (French) a period of rest; a break from something [n]\n",
  "RELACING": "RELACE, to do up again [v]\n",
  "RELACQUER": "to lacquer again [v -ED, -ING, -S]\n",
  "RELACQUERED": "RELACQUER, to lacquer again [v]\n",
  "RELACQUERING": "RELACQUER, to lacquer again [v]\n",
  "RELACQUERS": "RELACQUER, to lacquer again [v]\n",
  "RELAID": "RELAY, to put down new flooring [v]\n",
  "RELAND": "to land again [v -ED, -ING, -S]\n",
  "RELANDED": "RELAND, to land again [v]\n",
  "RELANDING": "RELAND, to land again [v]\n",
  "RELANDS": "RELAND, to land again [v]\n",
  "RELANDSCAPE": "to landscape again [v RELANDSCAPED, RELANDSCAPING, RELANDSCAPES]\n",
  "RELANDSCAPED": "RELANDSCAPE, to landscape again [v]\n",
  "RELANDSCAPES": "RELANDSCAPE, to landscape again [v]\n",
  "RELANDSCAPING": "RELANDSCAPE, to landscape again [v]\n",
  "RELAPSE": "to slip back into a former state [v RELAPSED, RELAPSING, RELAPSES]\n",
  "RELAPSED": "RELAPSE, to slip back into a former state [v]\n",
  "RELAPSER": "one who relapses [n -S]\n",
  "RELAPSERS": "RELAPSER, one who relapses [n]\n",
  "RELAPSES": "RELAPSE, to slip back into a former state [v]\n",
  "RELAPSING": "RELAPSE, to slip back into a former state [v]\n",
  "RELATA": "RELATUM, a term in a proposition that is related to the referent of the proposition [n]\n",
  "RELATABLE": "that can be related [adj]\n",
  "RELATE": "to give an account of [v RELATED, RELATING, RELATES]\n",
  "RELATED": "RELATE, to give an account of [v]\n",
  "RELATEDLY": "RELATED, RELATE, to give an account of [adv]\n",
  "RELATEDNESS": "the state of being related [n -ES]\n",
  "RELATEDNESSES": "RELATEDNESS, the state of being related [n]\n",
  "RELATER": "one who relates, also RELATOR [n -S]\n",
  "RELATERS": "RELATER, one who relates, also RELATOR [n]\n",
  "RELATES": "RELATE, to give an account of [v]\n",
  "RELATING": "RELATE, to give an account of [v]\n",
  "RELATION": "an association between people or things [n -S]\n",
  "RELATIONAL": "of or relating to kinship [adj RELATIONALLY]\n",
  "RELATIONALLY": "RELATIONAL, of or relating to kinship [adv]\n",
  "RELATIONISM": "the doctrine that relations have an objective existence; the doctrine of relativity of knowledge [n -S]\n",
  "RELATIONISMS": "RELATIONISM, the doctrine that relations have an objective existence; the doctrine of relativity of knowledge [n]\n",
  "RELATIONIST": "a believer in relationism [n -S]\n",
  "RELATIONISTS": "RELATIONIST, a believer in relationism [n]\n",
  "RELATIONLESS": "without relations [adj]\n",
  "RELATIONS": "RELATION, an association between people or things [n]\n",
  "RELATIONSHIP": "a state or mode of being related [n -S]\n",
  "RELATIONSHIPS": "RELATIONSHIP, a state or mode of being related [n]\n",
  "RELATIVAL": "concerning relation, esp. grammatical relation [adj]\n",
  "RELATIVE": "in relation to [adj RELATIVELY] / one who is connected with another by blood or marriage [n -S]\n",
  "RELATIVELY": "RELATIVE, in relation to [adv]\n",
  "RELATIVENESS": "the state of being relative [n -ES]\n",
  "RELATIVENESSES": "RELATIVENESS, the state of being relative [n]\n",
  "RELATIVES": "RELATIVE, one who is connected with another by blood or marriage [n]\n",
  "RELATIVISATION": "the process of relativising, also RELATIVIZATION [n -S]\n",
  "RELATIVISATIONS": "RELATIVISATION, the process of relativising, also RELATIVIZATION [n]\n",
  "RELATIVISE": "to make relative, also RELATIVIZE [v RELATIVISED, RELATIVISING, RELATIVISES]\n",
  "RELATIVISED": "RELATIVISE, to make relative, also RELATIVIZE [v]\n",
  "RELATIVISES": "RELATIVISE, to make relative, also RELATIVIZE [v]\n",
  "RELATIVISING": "RELATIVISE, to make relative, also RELATIVIZE [v]\n",
  "RELATIVISM": "a theory that knowledge is relative to the limited nature of the mind and the conditions of knowing [n -S]\n",
  "RELATIVISMS": "RELATIVISM, a theory that knowledge is relative to the limited nature of the mind and the conditions of knowing [n]\n",
  "RELATIVIST": "a believer in relativism [n -S]\n",
  "RELATIVISTIC": "of, relating to, or characterized by relativity or relativism [adj]\n",
  "RELATIVISTS": "RELATIVIST, a believer in relativism [n]\n",
  "RELATIVITIES": "RELATIVITY, the state of being relative [n]\n",
  "RELATIVITIST": "a person who studies or accepts relativity [n -S]\n",
  "RELATIVITISTS": "RELATIVITIST, a person who studies or accepts relativity [n]\n",
  "RELATIVITY": "the state of being relative [n RELATIVITIES]\n",
  "RELATIVIZATION": "the process of relativizing, also RELATIVISATION [n -S]\n",
  "RELATIVIZATIONS": "RELATIVIZATION, the process of relativizing, also RELATIVISATION [n]\n",
  "RELATIVIZE": "to treat or describe as relative, also RELATIVISE [v RELATIVIZED, RELATIVIZING, RELATIVIZES]\n",
  "RELATIVIZED": "RELATIVIZE, to treat or describe as relative, also RELATIVISE [v]\n",
  "RELATIVIZES": "RELATIVIZE, to treat or describe as relative, also RELATIVISE [v]\n",
  "RELATIVIZING": "RELATIVIZE, to treat or describe as relative, also RELATIVISE [v]\n",
  "RELATOR": "one who relates, also RELATER [n -S]\n",
  "RELATORS": "RELATOR, one who relates, also RELATER [n]\n",
  "RELATUM": "a term in a proposition that is related to the referent of the proposition [n RELATA]\n",
  "RELAUNCH": "to launch again [v -ED, -ING, -ES]\n",
  "RELAUNCHED": "RELAUNCH, to launch again [v]\n",
  "RELAUNCHES": "RELAUNCH, to launch again [v]\n",
  "RELAUNCHING": "RELAUNCH, to launch again [v]\n",
  "RELAUNDER": "to launder again [v -ED, -ING, -S]\n",
  "RELAUNDERED": "RELAUNDER, to launder again [v]\n",
  "RELAUNDERING": "RELAUNDER, to launder again [v]\n",
  "RELAUNDERS": "RELAUNDER, to launder again [v]\n",
  "RELAX": "to make less tense or rigid [v -ED, -ING, -ES]\n",
  "RELAXABLE": "that can be relaxed [adj]\n",
  "RELAXANT": "a drug that relieves muscular tension [n -S]\n",
  "RELAXANTS": "RELAXANT, a drug that relieves muscular tension [n]\n",
  "RELAXATION": "the act of relaxing or state of being relaxed [n -S]\n",
  "RELAXATIONS": "RELAXATION, the act of relaxing or state of being relaxed [n]\n",
  "RELAXATIVE": "a medication or activity that promotes relaxation [n -S]\n",
  "RELAXATIVES": "RELAXATIVE, a medication or activity that promotes relaxation [n]\n",
  "RELAXED": "RELAX, to make less tense or rigid [v]\n",
  "RELAXEDLY": "RELAXED, RELAX, to make less tense or rigid [adv]\n",
  "RELAXEDNESS": "the state of being relaxed [n -ES]\n",
  "RELAXEDNESSES": "RELAXEDNESS, the state of being relaxed [n]\n",
  "RELAXER": "one that relaxes [n -S]\n",
  "RELAXERS": "RELAXER, one that relaxes [n]\n",
  "RELAXES": "RELAX, to make less tense or rigid [v]\n",
  "RELAXIN": "a hormone which has a relaxing effect on the pelvic muscles [n -S]\n",
  "RELAXING": "RELAX, to make less tense or rigid [v]\n",
  "RELAXINS": "RELAXIN, a hormone which has a relaxing effect on the pelvic muscles [n]\n",
  "RELAY": "to put down new flooring [v RELAID, RELAYING, RELAYS] / to send along by using fresh sets to replace tired ones [v RELAYED, RELAYING, RELAYS]\n",
  "RELAYED": "RELAY, to put down new flooring [v]\n",
  "RELAYING": "RELAY, to put down new flooring [v]\n",
  "RELAYS": "RELAY, to put down new flooring [v]\n",
  "RELEARN": "to learn again [v RELEARNED, RELEARNT, RELEARNING, RELEARNS]\n",
  "RELEARNED": "RELEARN, to learn again [v]\n",
  "RELEARNING": "RELEARN, to learn again [v]\n",
  "RELEARNS": "RELEARN, to learn again [v]\n",
  "RELEARNT": "RELEARN, to learn again [v]\n",
  "RELEASABLE": "that may be released [adj]\n",
  "RELEASE": "to set free [v RELEASED, RELEASING, RELEASES]\n",
  "RELEASED": "RELEASE, to set free [v]\n",
  "RELEASEE": "a person to whom an estate is released [n -S]\n",
  "RELEASEES": "RELEASEE, a person to whom an estate is released [n]\n",
  "RELEASEMENT": "release [n -S]\n",
  "RELEASEMENTS": "RELEASEMENT, release [n]\n",
  "RELEASER": "one who releases, also RELEASOR [n -S]\n",
  "RELEASERS": "RELEASER, one who releases, also RELEASOR [n]\n",
  "RELEASES": "RELEASE, to set free [v]\n",
  "RELEASING": "RELEASE, to set free [v]\n",
  "RELEASOR": "one who releases, also RELEASER [n -S]\n",
  "RELEASORS": "RELEASOR, one who releases, also RELEASER [n]\n",
  "RELEGABLE": "that can be relegated, also RELEGATABLE [adj]\n",
  "RELEGATABLE": "that can be relegated, also RELEGABLE [adj]\n",
  "RELEGATE": "to remove, usually to an inferior position [v RELEGATED, RELEGATING, RELEGATES]\n",
  "RELEGATED": "RELEGATE, to remove, usually to an inferior position [v]\n",
  "RELEGATES": "RELEGATE, to remove, usually to an inferior position [v]\n",
  "RELEGATING": "RELEGATE, to remove, usually to an inferior position [v]\n",
  "RELEGATION": "the act of relegating [n -S]\n",
  "RELEGATIONS": "RELEGATION, the act of relegating [n]\n",
  "RELEND": "to lend again [v RELENT, RELENDING, RELENDS]\n",
  "RELENDING": "RELEND, to lend again [v]\n",
  "RELENDS": "RELEND, to lend again [v]\n",
  "RELENT": "to soften and become less severe [v -ED, -ING, -S]\n",
  "RELENTED": "RELENT, to soften and become less severe [v]\n",
  "RELENTING": "the act of relenting [n -S]\n",
  "RELENTINGS": "RELENTING, the act of relenting [n]\n",
  "RELENTLESS": "unrelenting [adj RELENTLESSLY]\n",
  "RELENTLESSLY": "RELENTLESS, unrelenting [adv]\n",
  "RELENTLESSNESS": "RELENTLESS, unrelenting [n]\n",
  "RELENTMENT": "the act of relenting [n -S]\n",
  "RELENTMENTS": "RELENTMENT, the act of relenting [n]\n",
  "RELENTS": "RELENT, to soften and become less severe [v]\n",
  "RELET": "to let again [v RELET, RELETTING, RELETS]\n",
  "RELETS": "RELET, to let again [v]\n",
  "RELETTER": "to write again [v -ED, -ING, -S]\n",
  "RELETTERED": "RELETTER, to write again [v]\n",
  "RELETTERING": "RELETTER, to write again [v]\n",
  "RELETTERS": "RELETTER, to write again [v]\n",
  "RELETTING": "RELET, to let again [v]\n",
  "RELEVANCE": "the state of being relevant, also RELEVANCY [n -S]\n",
  "RELEVANCES": "RELEVANCE, the state of being relevant, also RELEVANCY [n]\n",
  "RELEVANCIES": "RELEVANCY, (US) relevance, also RELEVANCE [n]\n",
  "RELEVANCY": "(US) relevance, also RELEVANCE [n RELEVANCIES]\n",
  "RELEVANT": "pertaining to the matter at hand [adj RELEVANTLY]\n",
  "RELEVANTLY": "RELEVANT, pertaining to the matter at hand [adv]\n",
  "RELEVE": "(French) a raising on to the toe in ballet [n -S]\n",
  "RELEVES": "RELEVE, (French) a raising on to the toe in ballet [n]\n",
  "RELIABILITIES": "RELIABILITY, the state of being reliable [n]\n",
  "RELIABILITY": "the state of being reliable [n RELIABILITIES]\n",
  "RELIABLE": "dependable [adj RELIABLY] / something, e.g. a car, that is reliable [n -S]\n",
  "RELIABLENESS": "the state of being reliable [n -ES]\n",
  "RELIABLENESSES": "RELIABLENESS, the state of being reliable [n]\n",
  "RELIABLES": "RELIABLE, something, e.g. a car, that is reliable [n]\n",
  "RELIABLY": "RELIABLE, dependable [adv]\n",
  "RELIANCE": "confident or trustful dependence [n -S]\n",
  "RELIANCES": "RELIANCE, confident or trustful dependence [n]\n",
  "RELIANT": "showing reliance [adj RELIANTLY]\n",
  "RELIANTLY": "RELIANT, showing reliance [adv]\n",
  "RELIC": "a surviving memorial of something past, also RELIQUE [n -S]\n",
  "RELICENSE": "to license again [v RELICENSED, RELICENSING, RELICENSES]\n",
  "RELICENSED": "RELICENSE, to license again [v]\n",
  "RELICENSES": "RELICENSE, to license again [v]\n",
  "RELICENSING": "RELICENSE, to license again [v]\n",
  "RELICENSURE": "a renewal of a licensure [n -S]\n",
  "RELICENSURES": "RELICENSURE, a renewal of a licensure [n]\n",
  "RELICS": "RELIC, a surviving memorial of something past, also RELIQUE [n]\n",
  "RELICT": "an organism surviving in a changed environment [n -S]\n",
  "RELICTION": "the recession of the sea leaving bare land [n -S]\n",
  "RELICTIONS": "RELICTION, the recession of the sea leaving bare land [n]\n",
  "RELICTS": "RELICT, an organism surviving in a changed environment [n]\n",
  "RELIDE": "RELIE, (obsolete) to assemble, collect together [v]\n",
  "RELIE": "(obsolete) to assemble, collect together [v RELIED or (Spenser) RELIDE, RELYING, RELIES]\n",
  "RELIED": "RELY, to depend on confidently [v]\n",
  "RELIEF": "aid in the form of money or necessities [n -S]\n",
  "RELIEFLESS": "destitute of relief [adj]\n",
  "RELIEFS": "RELIEF, aid in the form of money or necessities [n]\n",
  "RELIER": "(Shakespeare) one who relies [n -S]\n",
  "RELIERS": "RELIER, (Shakespeare) one who relies [n]\n",
  "RELIES": "RELY, to depend on confidently [v]\n",
  "RELIEVABLE": "capable of being relieved [adj]\n",
  "RELIEVE": "to free from discomfort [v RELIEVED, RELIEVING, RELIEVES]\n",
  "RELIEVED": "RELIEVE, to free from discomfort [v]\n",
  "RELIEVEDLY": "RELIEVED, RELIEVE, to free from discomfort [adv]\n",
  "RELIEVER": "one who relieves [n -S]\n",
  "RELIEVERS": "RELIEVER, one who relieves [n]\n",
  "RELIEVES": "RELIEVE, to free from discomfort [v]\n",
  "RELIEVING": "RELIEVE, to free from discomfort [v]\n",
  "RELIEVO": "(Italian) the projection of figures or forms from a flat background, also RILIEVO [n -S]\n",
  "RELIEVOS": "RELIEVO, (Italian) the projection of figures or forms from a flat background, also RILIEVO [n]\n",
  "RELIGHT": "to light again [v RELIGHTED, RELIT, RELIGHTING, RELIGHTS]\n",
  "RELIGHTED": "RELIGHT, to light again [v]\n",
  "RELIGHTING": "RELIGHT, to light again [v]\n",
  "RELIGHTS": "RELIGHT, to light again [v]\n",
  "RELIGIEUSE": "(French) a (female) person bound by monastic vows; a nun [n -S]\n",
  "RELIGIEUSES": "RELIGIEUSE, (French) a (female) person bound by monastic vows; a nun [n]\n",
  "RELIGIEUX": "(French) a (male) person bound by monastic vows; a monk [n RELIGIEUX]\n",
  "RELIGION": "belief in a higher power [n -S]\n",
  "RELIGIONARIES": "RELIGIONARY, a member of a religious order; a Protestant [n]\n",
  "RELIGIONARY": "a member of a religious order; a Protestant [n RELIGIONARIES]\n",
  "RELIGIONER": "a religionist [n -S]\n",
  "RELIGIONERS": "RELIGIONER, a religionist [n]\n",
  "RELIGIONISE": "to imbue with religion, also RELIGIONIZE [v RELIGIONISED, RELIGIONISING, RELIGIONISES]\n",
  "RELIGIONISED": "RELIGIONISE, to imbue with religion, also RELIGIONIZE [v]\n",
  "RELIGIONISES": "RELIGIONISE, to imbue with religion, also RELIGIONIZE [v]\n",
  "RELIGIONISING": "RELIGIONISE, to imbue with religion, also RELIGIONIZE [v]\n",
  "RELIGIONISM": "religiosity, bigotry [n -S]\n",
  "RELIGIONISMS": "RELIGIONISM, religiosity, bigotry [n]\n",
  "RELIGIONIST": "a person adhering to a religion [n -S]\n",
  "RELIGIONISTS": "RELIGIONIST, a person adhering to a religion [n]\n",
  "RELIGIONIZE": "to imbue with religion, also RELIGIONISE [v RELIGIONIZED, RELIGIONIZING, RELIGIONIZES]\n",
  "RELIGIONIZED": "RELIGIONIZE, to imbue with religion, also RELIGIONISE [v]\n",
  "RELIGIONIZES": "RELIGIONIZE, to imbue with religion, also RELIGIONISE [v]\n",
  "RELIGIONIZING": "RELIGIONIZE, to imbue with religion, also RELIGIONISE [v]\n",
  "RELIGIONLESS": "without religion [adj]\n",
  "RELIGIONS": "RELIGION, belief in a higher power [n]\n",
  "RELIGIOSE": "morbidly or sentimentally religious [adj RELIGIOSELY]\n",
  "RELIGIOSELY": "RELIGIOSE, morbidly or sentimentally religious [adv]\n",
  "RELIGIOSITIES": "RELIGIOSITY, the state of being religiose [n]\n",
  "RELIGIOSITY": "the state of being religiose [n RELIGIOSITIES]\n",
  "RELIGIOSO": "(Italian) a musical piece meant to be played devotionally [n -S]\n",
  "RELIGIOSOS": "RELIGIOSO, (Italian) a musical piece meant to be played devotionally [n]\n",
  "RELIGIOUS": "concerned with religion [adj RELIGIOUSLY] / a person bound by monastic vows [n -ES]\n",
  "RELIGIOUSES": "RELIGIOUS, a person bound by monastic vows [n]\n",
  "RELIGIOUSLY": "RELIGIOUS, concerned with religion [adv]\n",
  "RELIGIOUSNESS": "the state of being religious [n -ES]\n",
  "RELIGIOUSNESSES": "RELIGIOUSNESS, the state of being religious [n]\n",
  "RELINE": "to line again [v RELINED, RELINING, RELINES]\n",
  "RELINED": "RELINE, to line again [v]\n",
  "RELINES": "RELINE, to line again [v]\n",
  "RELINING": "RELINE, to line again [v]\n",
  "RELINK": "to link again [v -ED, -ING, -S]\n",
  "RELINKED": "RELINK, to link again [v]\n",
  "RELINKING": "RELINK, to link again [v]\n",
  "RELINKS": "RELINK, to link again [v]\n",
  "RELINQUISH": "to withdraw or retreat from [v -ED, -ING, -ES]\n",
  "RELINQUISHED": "RELINQUISH, to withdraw or retreat from [v]\n",
  "RELINQUISHER": "one who relinquishes [n -S]\n",
  "RELINQUISHERS": "RELINQUISHER, one who relinquishes [n]\n",
  "RELINQUISHES": "RELINQUISH, to withdraw or retreat from [v]\n",
  "RELINQUISHING": "RELINQUISH, to withdraw or retreat from [v]\n",
  "RELINQUISHMENT": "the act of relinquishing [n -S]\n",
  "RELINQUISHMENTS": "RELINQUISHMENT, the act of relinquishing [n]\n",
  "RELIQUAIRE": "(French) a receptacle for relics, also RELIQUARY [n -S]\n",
  "RELIQUAIRES": "RELIQUAIRE, (French) a receptacle for relics, also RELIQUARY [n]\n",
  "RELIQUARIES": "RELIQUARY, a small box or shrine used to hold relics, also RELIQUAIRE [n]\n",
  "RELIQUARY": "a small box or shrine used to hold relics, also RELIQUAIRE [n RELIQUARIES]\n",
  "RELIQUE": "(archaic) a relic, a surviving memorial of something past [n -S]\n",
  "RELIQUEFIED": "RELIQUEFY, to liquefy again, also RELIQUIFY [v]\n",
  "RELIQUEFIES": "RELIQUEFY, to liquefy again, also RELIQUIFY [v]\n",
  "RELIQUEFY": "to liquefy again, also RELIQUIFY [v RELIQUEFIED, RELIQUEFYING, RELIQUEFIES]\n",
  "RELIQUEFYING": "RELIQUEFY, to liquefy again, also RELIQUIFY [v]\n",
  "RELIQUES": "RELIQUE, (archaic) a relic, a surviving memorial of something past [n]\n",
  "RELIQUIAE": "(Latin) remains, esp. fossil [n]\n",
  "RELIQUIFIED": "RELIQUIFY, to liquify again, also RELIQUEFY [v]\n",
  "RELIQUIFIES": "RELIQUIFY, to liquify again, also RELIQUEFY [v]\n",
  "RELIQUIFY": "to liquify again, also RELIQUEFY [v RELIQUIFIED, RELIQUIFYING, RELIQUIFIES]\n",
  "RELIQUIFYING": "RELIQUIFY, to liquify again, also RELIQUEFY [v]\n",
  "RELISH": "to enjoy [v RELISHED, RELISHING, RELISHES]\n",
  "RELISHABLE": "capable of being relished [adj]\n",
  "RELISHED": "RELISH, to enjoy [v]\n",
  "RELISHES": "RELISH, to enjoy [v]\n",
  "RELISHING": "RELISH, to enjoy [v]\n",
  "RELIST": "to list again [v -ED, -ING, -S]\n",
  "RELISTED": "RELIST, to list again [v]\n",
  "RELISTEN": "to listen again [v -ED, -ING, -S]\n",
  "RELISTENED": "RELISTEN, to listen again [v]\n",
  "RELISTENING": "RELISTEN, to listen again [v]\n",
  "RELISTENS": "RELISTEN, to listen again [v]\n",
  "RELISTING": "RELIST, to list again [v]\n",
  "RELISTS": "RELIST, to list again [v]\n",
  "RELIT": "RELIGHT, to light again [v]\n",
  "RELIVABLE": "that can be relived [adj]\n",
  "RELIVE": "to experience again [v RELIVED, RELIVING, RELIVES]\n",
  "RELIVED": "RELIVE, to experience again [v]\n",
  "RELIVER": "(Shakespeare) to deliver back [v -ED, -ING, -S]\n",
  "RELIVERED": "RELIVER, (Shakespeare) to deliver back [v]\n",
  "RELIVERING": "RELIVER, (Shakespeare) to deliver back [v]\n",
  "RELIVERS": "RELIVER, (Shakespeare) to deliver back [v]\n",
  "RELIVES": "RELIVE, to experience again [v]\n",
  "RELIVING": "RELIVE, to experience again [v]\n",
  "RELLENO": "(Spanish) a Mexican dish of stuffed vegetables [n -S]\n",
  "RELLENOS": "RELLENO, (Spanish) a Mexican dish of stuffed vegetables [n]\n",
  "RELLIE": "(Australian slang) a relative, also RELLO [n -S]\n",
  "RELLIES": "RELLIE, (Australian slang) a relative, also RELLO [n]\n",
  "RELLISH": "(Shakespeare) to warble [v -ED, -ING, -ES]\n",
  "RELLISHED": "RELLISH, (Shakespeare) to warble [v]\n",
  "RELLISHES": "RELLISH, (Shakespeare) to warble [v]\n",
  "RELLISHING": "RELLISH, (Shakespeare) to warble [v]\n",
  "RELLO": "(Australian slang) a relative, also RELLIE [n -S]\n",
  "RELLOS": "RELLO, (Australian slang) a relative, also RELLIE [n]\n",
  "RELOAD": "to load again [v -ED, -ING, -S]\n",
  "RELOADED": "RELOAD, to load again [v]\n",
  "RELOADER": "a device for reloading e.g. a gun [n -S]\n",
  "RELOADERS": "RELOADER, a device for reloading e.g. a gun [n]\n",
  "RELOADING": "RELOAD, to load again [v]\n",
  "RELOADS": "RELOAD, to load again [v]\n",
  "RELOAN": "to loan again [v -ED, -ING, -S]\n",
  "RELOANED": "RELOAN, to loan again [v]\n",
  "RELOANING": "RELOAN, to loan again [v]\n",
  "RELOANS": "RELOAN, to loan again [v]\n",
  "RELOCATABLE": "that can be relocated [adj]\n",
  "RELOCATE": "to establish in a new place [v RELOCATED, RELOCATING, RELOCATES]\n",
  "RELOCATED": "RELOCATE, to establish in a new place [v]\n",
  "RELOCATEE": "one who is relocated [n -S]\n",
  "RELOCATEES": "RELOCATEE, one who is relocated [n]\n",
  "RELOCATES": "RELOCATE, to establish in a new place [v]\n",
  "RELOCATING": "RELOCATE, to establish in a new place [v]\n",
  "RELOCATION": "the act of relocating [n -S]\n",
  "RELOCATIONS": "RELOCATION, the act of relocating [n]\n",
  "RELOCATOR": "one who relocates [n -S]\n",
  "RELOCATORS": "RELOCATOR, one who relocates [n]\n",
  "RELOCK": "to lock again [v -ED, -ING, -S]\n",
  "RELOCKED": "RELOCK, to lock again [v]\n",
  "RELOCKING": "RELOCK, to lock again [v]\n",
  "RELOCKS": "RELOCK, to lock again [v]\n",
  "RELOOK": "to look again [v -ED, -ING, -S]\n",
  "RELOOKED": "RELOOK, to look again [v]\n",
  "RELOOKING": "RELOOK, to look again [v]\n",
  "RELOOKS": "RELOOK, to look again [v]\n",
  "RELUBRICATE": "to lubricate again [v RELUBRICATED, RELUBRICATING, RELUBRICATES]\n",
  "RELUBRICATED": "RELUBRICATE, to lubricate again [v]\n",
  "RELUBRICATES": "RELUBRICATE, to lubricate again [v]\n",
  "RELUBRICATING": "RELUBRICATE, to lubricate again [v]\n",
  "RELUBRICATION": "the act of relubricating [n -S]\n",
  "RELUBRICATIONS": "RELUBRICATION, the act of relubricating [n]\n",
  "RELUCENT": "reflecting light [adj]\n",
  "RELUCT": "(archaic) to be unwilling, also RELUCTATE [v -ED, -ING, -S]\n",
  "RELUCTANCE": "the state of being reluctant, also RELUCTANCY [n -S]\n",
  "RELUCTANCES": "RELUCTANCE, the state of being reluctant, also RELUCTANCY [n]\n",
  "RELUCTANCIES": "RELUCTANCY, the state of being reluctant, also RELUCTANCE [n]\n",
  "RELUCTANCY": "the state of being reluctant, also RELUCTANCE [n RELUCTANCIES]\n",
  "RELUCTANT": "unwilling [adj RELUCTANTLY]\n",
  "RELUCTANTLY": "RELUCTANT, unwilling [adv]\n",
  "RELUCTATE": "to be reluctant, also RELUCT [v RELUCTATED, RELUCTATING, RELUCTATES]\n",
  "RELUCTATED": "RELUCTATE, to be reluctant, also RELUCT [v]\n",
  "RELUCTATES": "RELUCTATE, to be reluctant, also RELUCT [v]\n",
  "RELUCTATING": "RELUCTATE, to be reluctant, also RELUCT [v]\n",
  "RELUCTATION": "(archaic) repugnance [n -S]\n",
  "RELUCTATIONS": "RELUCTATION, (archaic) repugnance [n]\n",
  "RELUCTED": "RELUCT, (archaic) to be unwilling, also RELUCTATE [v]\n",
  "RELUCTING": "RELUCT, (archaic) to be unwilling, also RELUCTATE [v]\n",
  "RELUCTIVITIES": "RELUCTIVITY, a specific or relative reluctance of a magnetic material [n]\n",
  "RELUCTIVITY": "a specific or relative reluctance of a magnetic material [n RELUCTIVITIES]\n",
  "RELUCTS": "RELUCT, (archaic) to be unwilling, also RELUCTATE [v]\n",
  "RELUME": "to light again, also RELUMINE [v RELUMED, RELUMING, RELUMES]\n",
  "RELUMED": "RELUME, to light again, also RELUMINE [v]\n",
  "RELUMES": "RELUME, to light again, also RELUMINE [v]\n",
  "RELUMINE": "to light again, also RELUME [v RELUMINED, RELUMINING, RELUMINES]\n",
  "RELUMINED": "RELUMINE, to light again, also RELUME [v]\n",
  "RELUMINES": "RELUMINE, to light again, also RELUME [v]\n",
  "RELUMING": "RELUME, to light again, also RELUMINE [v]\n",
  "RELUMINING": "RELUMINE, to light again, also RELUME [v]\n",
  "RELY": "to depend on confidently [v RELIED, RELYING, RELIES]\n",
  "RELYING": "RELY, to depend on confidently [v]\n",
  "REM": "a unit of radiation dosage [n -S]\n",
  "REMADE": "a thing e.g. a golf ball made again from reused materials [n -S]\n",
  "REMADES": "REMADE, a thing e.g. a golf ball made again from reused materials [n]\n",
  "REMAIL": "to post again [v -ED, -ING, -S]\n",
  "REMAILED": "REMAIL, to post again [v]\n",
  "REMAILER": "an internet service that forwards emails anonymously [n -S]\n",
  "REMAILERS": "REMAILER, an internet service that forwards emails anonymously [n]\n",
  "REMAILING": "the act of mailing again [n -S]\n",
  "REMAILINGS": "REMAILING, the act of mailing again [n]\n",
  "REMAILS": "REMAIL, to post again [v]\n",
  "REMAIN": "to continue in the same state [v -ED, -ING, -S]\n",
  "REMAINDER": "what is left over [n -S] / to sell as a remainder [v -ED, -ING, -S]\n",
  "REMAINDERED": "REMAINDER, to sell as a remainder [v]\n",
  "REMAINDERING": "REMAINDER, to sell as a remainder [v]\n",
  "REMAINDERMAN": "the person entitled to receive a particular estate on its determination [n REMAINDERMEN]\n",
  "REMAINDERMEN": "REMAINDERMAN, the person entitled to receive a particular estate on its determination [n]\n",
  "REMAINDERS": "REMAINDER, to sell as a remainder [v]\n",
  "REMAINED": "REMAIN, to continue in the same state [v]\n",
  "REMAINER": "one who remains [n -S]\n",
  "REMAINERS": "REMAINER, one who remains [n]\n",
  "REMAINING": "REMAIN, to continue in the same state [v]\n",
  "REMAINS": "REMAIN, to continue in the same state [v]\n",
  "REMAKE": "to make over again [v REMADE, REMAKING, REMAKES]\n",
  "REMAKER": "one who remakes [n -S]\n",
  "REMAKERS": "REMAKER, one who remakes [n]\n",
  "REMAKES": "REMAKE, to make over again [v]\n",
  "REMAKING": "REMAKE, to make over again [v]\n",
  "REMAN": "to supply a fresh group of men [v REMANNED, REMANNING, REMANS]\n",
  "REMAND": "to send back [v -ED, -ING, -S]\n",
  "REMANDED": "REMAND, to send back [v]\n",
  "REMANDING": "REMAND, to send back [v]\n",
  "REMANDMENT": "the act of remanding [n -S]\n",
  "REMANDMENTS": "REMANDMENT, the act of remanding [n]\n",
  "REMANDS": "REMAND, to send back [v]\n",
  "REMANENCE": "the property of staying magnetic, also REMANENCY [n -S]\n",
  "REMANENCES": "REMANENCE, the property of staying magnetic, also REMANENCY [n]\n",
  "REMANENCIES": "REMANENCY, the property of staying magnetic, also REMANENCE [n]\n",
  "REMANENCY": "the property of staying magnetic, also REMANENCE [n REMANENCIES]\n",
  "REMANENT": "a piece left over, also REMANET [n -S]\n",
  "REMANENTS": "REMANENT, a piece left over, also REMANET [n]\n",
  "REMANET": "(Latin) a postponed case or parliamentary bill [n -S]\n",
  "REMANETS": "REMANET, (Latin) a postponed case or parliamentary bill [n]\n",
  "REMANIE": "(French) a fossil or other relic of an older rock preserved in a later deposit [n -S]\n",
  "REMANIES": "REMANIE, (French) a fossil or other relic of an older rock preserved in a later deposit [n]\n",
  "REMANNED": "REMAN, to supply a fresh group of men [v]\n",
  "REMANNING": "REMAN, to supply a fresh group of men [v]\n",
  "REMANS": "REMAN, to supply a fresh group of men [v]\n",
  "REMANUFACTURE": "to manufacture into a new product [v REMANUFACTURED, REMANUFACTURING, REMANUFACTURES]\n",
  "REMANUFACTURED": "REMANUFACTURE, to manufacture into a new product [v]\n",
  "REMANUFACTURER": "one who remanufactures [n -S]\n",
  "REMANUFACTURERS": "REMANUFACTURER, one who remanufactures [n]\n",
  "REMANUFACTURES": "REMANUFACTURE, to manufacture into a new product [v]\n",
  "REMANUFACTURING": "REMANUFACTURE, to manufacture into a new product [v]\n",
  "REMAP": "to map again [v REMAPPED, REMAPPING, REMAPS]\n",
  "REMAPPED": "REMAP, to map again [v]\n",
  "REMAPPING": "REMAP, to map again [v]\n",
  "REMAPS": "REMAP, to map again [v]\n",
  "REMARK": "to say briefly or casually [v -ED, -ING, -S]\n",
  "REMARKABILITIES": "REMARKABILITY, the quality of being remarkable [n]\n",
  "REMARKABILITY": "the quality of being remarkable [n REMARKABILITIES]\n",
  "REMARKABLE": "worthy of note [adj REMARKABLY] / something worthy of remark [n -S]\n",
  "REMARKABLENESS": "the state of being remarkable [n]\n",
  "REMARKABLES": "REMARKABLE, something worthy of remark [n]\n",
  "REMARKABLY": "REMARKABLE, worthy of note [adv]\n",
  "REMARKED": "REMARK, to say briefly or casually [v]\n",
  "REMARKER": "one who remarks [n -S]\n",
  "REMARKERS": "REMARKER, one who remarks [n]\n",
  "REMARKET": "to market again [v -ED, -ING, -S]\n",
  "REMARKETED": "REMARKET, to market again [v]\n",
  "REMARKETING": "REMARKET, to market again [v]\n",
  "REMARKETS": "REMARKET, to market again [v]\n",
  "REMARKING": "REMARK, to say briefly or casually [v]\n",
  "REMARKS": "REMARK, to say briefly or casually [v]\n",
  "REMARQUE": "(French) a mark made in the margin of an engraving indicating a stage of development prior to completion [n -S]\n",
  "REMARQUED": "bearing a remarque, a mark made in the margin of an engraving indicating a stage of development prior to completion [adj]\n",
  "REMARQUES": "REMARQUE, (French) a mark made in the margin of an engraving indicating a stage of development prior to completion [n]\n",
  "REMARRIAGE": "the act of marrying again [n -S]\n",
  "REMARRIAGES": "REMARRIAGE, the act of marrying again [n]\n",
  "REMARRIED": "REMARRY, to marry again [v]\n",
  "REMARRIES": "REMARRY, to marry again [v]\n",
  "REMARRY": "to marry again [v REMARRIED, REMARRYING, REMARRIES]\n",
  "REMARRYING": "REMARRY, to marry again [v]\n",
  "REMASTER": "to master again [v -ED, -ING, -S]\n",
  "REMASTERED": "REMASTER, to master again [v]\n",
  "REMASTERING": "REMASTER, to master again [v]\n",
  "REMASTERS": "REMASTER, to master again [v]\n",
  "REMATCH": "to match again [v -ED, -ING, -ES]\n",
  "REMATCHED": "REMATCH, to match again [v]\n",
  "REMATCHES": "REMATCH, to match again [v]\n",
  "REMATCHING": "REMATCH, to match again [v]\n",
  "REMATE": "to mate again [v REMATED, REMATING, REMATES]\n",
  "REMATED": "REMATE, to mate again [v]\n",
  "REMATERIALISE": "to materialise again, also REMATERIALIZE [v REMATERIALISED, REMATERIALISING, REMATERIALISES]\n",
  "REMATERIALISED": "REMATERIALISE, to materialise again, also REMATERIALIZE [v]\n",
  "REMATERIALISES": "REMATERIALISE, to materialise again, also REMATERIALIZE [v]\n",
  "REMATERIALISING": "REMATERIALISE, to materialise again, also REMATERIALIZE [v]\n",
  "REMATERIALIZE": "to materialize again, also REMATERIALISE [v REMATERIALIZED, REMATERIALIZING, REMATERIALIZES]\n",
  "REMATERIALIZED": "REMATERIALIZE, to materialize again, also REMATERIALISE [v]\n",
  "REMATERIALIZES": "REMATERIALIZE, to materialize again, also REMATERIALISE [v]\n",
  "REMATERIALIZING": "REMATERIALIZE, to materialize again, also REMATERIALISE [v]\n",
  "REMATES": "REMATE, to mate again [v]\n",
  "REMATING": "REMATE, to mate again [v]\n",
  "REMBLAI": "(French) earth or materials made into a bank after having been excavated [n -S]\n",
  "REMBLAIS": "REMBLAI, (French) earth or materials made into a bank after having been excavated [n]\n",
  "REMBLE": "to remove [v REMBLED, REMBLING, REMBLES]\n",
  "REMBLED": "REMBLE, to remove [v]\n",
  "REMBLES": "REMBLE, to remove [v]\n",
  "REMBLING": "REMBLE, to remove [v]\n",
  "REMEAD": "(Scots) to remedy, also REMEDE, REMEID [v -ED, -ING, -S]\n",
  "REMEADED": "REMEAD, (Scots) to remedy, also REMEDE, REMEID [v]\n",
  "REMEADING": "REMEAD, (Scots) to remedy, also REMEDE, REMEID [v]\n",
  "REMEADS": "REMEAD, (Scots) to remedy, also REMEDE, REMEID [v]\n",
  "REMEASURE": "to measure again; to retrace [v REMEASURED, REMEASURING, REMEASURES]\n",
  "REMEASURED": "REMEASURE, to measure again; to retrace [v]\n",
  "REMEASUREMENT": "the act of remeasuring [n -S]\n",
  "REMEASUREMENTS": "REMEASUREMENT, the act of remeasuring [n]\n",
  "REMEASURES": "REMEASURE, to measure again; to retrace [v]\n",
  "REMEASURING": "REMEASURE, to measure again; to retrace [v]\n",
  "REMEDE": "(Scots) to remedy, also REMEAD, REMEID [v REMEDED, REMEDING, REMEDES]\n",
  "REMEDED": "REMEDE, (Scots) to remedy, also REMEAD, REMEID [v]\n",
  "REMEDES": "REMEDE, (Scots) to remedy, also REMEAD, REMEID [v]\n",
  "REMEDIABILITIES": "REMEDIABILITY, the state of being remediable [n]\n",
  "REMEDIABILITY": "the state of being remediable [n REMEDIABILITIES]\n",
  "REMEDIABLE": "that can be remedied [adj REMEDIABLY]\n",
  "REMEDIABLY": "REMEDIABLE, that can be remedied [adv]\n",
  "REMEDIAL": "affording a remedy, also REMEDIAT, REMEDIATE [adj REMEDIALLY]\n",
  "REMEDIALLY": "REMEDIAL, affording a remedy, also REMEDIAT, REMEDIATE [adv]\n",
  "REMEDIAT": "(Shakespeare) remedial [adj]\n",
  "REMEDIATE": "(Shakespeare) to remedy [v REMEDIATED, REMEDIATING, REMEDIATES]\n",
  "REMEDIATED": "REMEDIATE, (Shakespeare) to remedy [v]\n",
  "REMEDIATES": "REMEDIATE, (Shakespeare) to remedy [v]\n",
  "REMEDIATING": "REMEDIATE, (Shakespeare) to remedy [v]\n",
  "REMEDIATION": "the act of remedying [n -S]\n",
  "REMEDIATIONS": "REMEDIATION, the act of remedying [n]\n",
  "REMEDIED": "REMEDY, to relieve or cure [v]\n",
  "REMEDIES": "REMEDY, to relieve or cure [v]\n",
  "REMEDILESS": "not admitting of a remedy [adj REMEDILESSLY]\n",
  "REMEDILESSLY": "REMEDILESS, not admitting of a remedy [adv]\n",
  "REMEDILESSNESS": "the state of being remediless [n]\n",
  "REMEDING": "REMEDE, (Scots) to remedy, also REMEAD, REMEID [v]\n",
  "REMEDY": "to relieve or cure [v REMEDIED, REMEDYING, REMEDIES]\n",
  "REMEDYING": "REMEDY, to relieve or cure [v]\n",
  "REMEET": "to meet again [v REMET, REMEETING, REMEETS]\n",
  "REMEETING": "REMEET, to meet again [v]\n",
  "REMEETS": "REMEET, to meet again [v]\n",
  "REMEID": "(Scots) to remedy, also REMEAD, REMEDE [v -ED, -ING, -S]\n",
  "REMEIDED": "REMEID, (Scots) to remedy, also REMEAD, REMEDE [v]\n",
  "REMEIDING": "REMEID, (Scots) to remedy, also REMEAD, REMEDE [v]\n",
  "REMEIDS": "REMEID, (Scots) to remedy, also REMEAD, REMEDE [v]\n",
  "REMELT": "to melt again [v -ED, -ING, -S]\n",
  "REMELTED": "REMELT, to melt again [v]\n",
  "REMELTING": "REMELT, to melt again [v]\n",
  "REMELTS": "REMELT, to melt again [v]\n",
  "REMEMBER": "to bring to mind again [v -ED, -ING, -S]\n",
  "REMEMBERABILITY": "the state of being rememberable [n]\n",
  "REMEMBERABLE": "capable of being remembered [adj REMEMBERABLY]\n",
  "REMEMBERABLY": "REMEMBERABLE, capable of being remembered [adv]\n",
  "REMEMBERED": "REMEMBER, to bring to mind again [v]\n",
  "REMEMBERER": "one who remembers [n -S]\n",
  "REMEMBERERS": "REMEMBERER, one who remembers [n]\n",
  "REMEMBERING": "REMEMBER, to bring to mind again [v]\n",
  "REMEMBERS": "REMEMBER, to bring to mind again [v]\n",
  "REMEMBRANCE": "the state of bearing in mind [n -S]\n",
  "REMEMBRANCER": "an officer of exchequer [n -S]\n",
  "REMEMBRANCERS": "REMEMBRANCER, an officer of exchequer [n]\n",
  "REMEMBRANCES": "REMEMBRANCE, the state of bearing in mind [n]\n",
  "REMEN": "an ancient Egyptian measure of length [n -S]\n",
  "REMEND": "to mend again [v -ED, -ING, -S]\n",
  "REMENDED": "REMEND, to mend again [v]\n",
  "REMENDING": "REMEND, to mend again [v]\n",
  "REMENDS": "REMEND, to mend again [v]\n",
  "REMENS": "REMEN, an ancient Egyptian measure of length [n]\n",
  "REMERCIED": "REMERCY, (obsolete) to thank [v]\n",
  "REMERCIES": "REMERCY, (obsolete) to thank [v]\n",
  "REMERCY": "(obsolete) to thank [v REMERCIED, REMERCYING, REMERCIES]\n",
  "REMERCYING": "REMERCY, (obsolete) to thank [v]\n",
  "REMERGE": "to merge again [v REMERGED, REMERGING, REMERGES]\n",
  "REMERGED": "REMERGE, to merge again [v]\n",
  "REMERGES": "REMERGE, to merge again [v]\n",
  "REMERGING": "REMERGE, to merge again [v]\n",
  "REMET": "REMEET, to meet again [v]\n",
  "REMEX": "(Latin) one of the large feathers of a bird's wing [n REMIGES]\n",
  "REMIGATE": "to row [v REMIGATED, REMIGATING, REMIGATES]\n",
  "REMIGATED": "REMIGATE, to row [v]\n",
  "REMIGATES": "REMIGATE, to row [v]\n",
  "REMIGATING": "REMIGATE, to row [v]\n",
  "REMIGATION": "the act of rowing [n -S]\n",
  "REMIGATIONS": "REMIGATION, the act of rowing [n]\n",
  "REMIGES": "REMEX, (Latin) one of the large feathers of a bird's wing [n]\n",
  "REMIGIAL": "relating to the remiges, the large feathers of a bird's wing [adj]\n",
  "REMIGRATE": "to migrate again or back [v REMIGRATED, REMIGRATING, REMIGRATES]\n",
  "REMIGRATED": "REMIGRATE, to migrate again or back [v]\n",
  "REMIGRATES": "REMIGRATE, to migrate again or back [v]\n",
  "REMIGRATING": "REMIGRATE, to migrate again or back [v]\n",
  "REMIGRATION": "return from migration [n -S]\n",
  "REMIGRATIONS": "REMIGRATION, return from migration [n]\n",
  "REMILITARISE": "to militarise again, also REMILITARIZE [v REMILITARISED, REMILITARISING, REMILITARISES]\n",
  "REMILITARISED": "REMILITARISE, to militarise again, also REMILITARIZE [v]\n",
  "REMILITARISES": "REMILITARISE, to militarise again, also REMILITARIZE [v]\n",
  "REMILITARISING": "REMILITARISE, to militarise again, also REMILITARIZE [v]\n",
  "REMILITARIZE": "to militarize again, also REMILITARISE [v REMILITARIZED, REMILITARIZING, REMILITARIZES]\n",
  "REMILITARIZED": "REMILITARIZE, to militarize again, also REMILITARISE [v]\n",
  "REMILITARIZES": "REMILITARIZE, to militarize again, also REMILITARISE [v]\n",
  "REMILITARIZING": "REMILITARIZE, to militarize again, also REMILITARISE [v]\n",
  "REMIND": "to cause to remember [v -ED, -ING, -S]\n",
  "REMINDED": "REMIND, to cause to remember [v]\n",
  "REMINDER": "something that serves to remind [n -S]\n",
  "REMINDERS": "REMINDER, something that serves to remind [n]\n",
  "REMINDFUL": "tending to remind [adj]\n",
  "REMINDING": "REMIND, to cause to remember [v]\n",
  "REMINDS": "REMIND, to cause to remember [v]\n",
  "REMINERALISE": "to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALIZE [v REMINERALISED, REMINERALISING, REMINERALISES]\n",
  "REMINERALISED": "REMINERALISE, to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALIZE [v]\n",
  "REMINERALISES": "REMINERALISE, to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALIZE [v]\n",
  "REMINERALISING": "REMINERALISE, to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALIZE [v]\n",
  "REMINERALIZE": "to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALISE [v REMINERALIZED, REMINERALIZING, REMINERALIZES]\n",
  "REMINERALIZED": "REMINERALIZE, to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALISE [v]\n",
  "REMINERALIZES": "REMINERALIZE, to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALISE [v]\n",
  "REMINERALIZING": "REMINERALIZE, to replace the depleted mineral content of (bones, teeth, etc.), also REMINERALISE [v]\n",
  "REMINISCE": "to engage in remembering [v REMINISCED, REMINISCING, REMINISCES]\n",
  "REMINISCED": "REMINISCE, to engage in remembering [v]\n",
  "REMINISCENCE": "recollection; an account of something remembered [n -S]\n",
  "REMINISCENCES": "REMINISCENCE, recollection; an account of something remembered [n]\n",
  "REMINISCENT": "of the character of or relating to reminiscence [adj REMINISCENTLY] / something that serves to recall [n -S]\n",
  "REMINISCENTIAL": "of the nature of reminiscence [adj]\n",
  "REMINISCENTLY": "REMINISCENT, of the character of or relating to reminiscence [adv]\n",
  "REMINISCENTS": "REMINISCENT, something that serves to recall [n]\n",
  "REMINISCER": "one who reminisces [n -S]\n",
  "REMINISCERS": "REMINISCER, one who reminisces [n]\n",
  "REMINISCES": "REMINISCE, to engage in remembering [v]\n",
  "REMINISCING": "REMINISCE, to engage in remembering [v]\n",
  "REMINT": "to melt down and make into new coins [v -ED, -ING, -S]\n",
  "REMINTED": "REMINT, to melt down and make into new coins [v]\n",
  "REMINTING": "REMINT, to melt down and make into new coins [v]\n",
  "REMINTS": "REMINT, to melt down and make into new coins [v]\n",
  "REMISE": "to give up a claim to [v REMISED, REMISING, REMISES]\n",
  "REMISED": "REMISE, to give up a claim to [v]\n",
  "REMISES": "REMISE, to give up a claim to [v]\n",
  "REMISING": "REMISE, to give up a claim to [v]\n",
  "REMISS": "careless [adj REMISSLY]\n",
  "REMISSIBILITIES": "REMISSIBILITY, the state of being remissible, capable of being remitted or forgiven [n]\n",
  "REMISSIBILITY": "the state of being remissible, capable of being remitted or forgiven [n REMISSIBILITIES]\n",
  "REMISSIBLE": "capable of being remitted or forgiven [adj REMISSIBLY]\n",
  "REMISSIBLENESS": "REMISSIBLE, capable of being remitted or forgiven [n]\n",
  "REMISSIBLY": "REMISSIBLE, capable of being remitted or forgiven [adv]\n",
  "REMISSION": "the act of remitting; abatement [n -S]\n",
  "REMISSIONS": "REMISSION, the act of remitting; abatement [n]\n",
  "REMISSIVE": "remitting; forgiving [adj REMISSIVELY]\n",
  "REMISSIVELY": "REMISSIVE, remitting; forgiving [adv]\n",
  "REMISSLY": "REMISS, careless [adv]\n",
  "REMISSNESS": "the state of being remiss [n -ES]\n",
  "REMISSNESSES": "REMISSNESS, the state of being remiss [n]\n",
  "REMISSORY": "serving or tending to remit, or to secure remission [adj]\n",
  "REMIT": "to send payment [v REMITTED, REMITTING, REMITS]\n",
  "REMITMENT": "the act of remitting, also REMITTAL [n -S]\n",
  "REMITMENTS": "REMITMENT, the act of remitting, also REMITTAL [n]\n",
  "REMITS": "REMIT, to send payment [v]\n",
  "REMITTABLE": "that can be remitted [adj]\n",
  "REMITTAL": "the act of remitting, also REMITMENT [n -S]\n",
  "REMITTALS": "REMITTAL, the act of remitting, also REMITMENT [n]\n",
  "REMITTANCE": "a sum of money remitted [n -S]\n",
  "REMITTANCES": "REMITTANCE, a sum of money remitted [n]\n",
  "REMITTED": "REMIT, to send payment [v]\n",
  "REMITTEE": "a person to whom a remittance is sent [n -S]\n",
  "REMITTEES": "REMITTEE, a person to whom a remittance is sent [n]\n",
  "REMITTENCE": "a period of diminished severity in a fever, also REMITTENCY [n -S]\n",
  "REMITTENCES": "REMITTENCE, a period of diminished severity in a fever, also REMITTENCY [n]\n",
  "REMITTENCIES": "REMITTENCY, a period of diminished severity in a fever, also REMITTENCE [n]\n",
  "REMITTENCY": "a period of diminished severity in a fever, also REMITTENCE [n REMITTENCIES]\n",
  "REMITTENT": "remitting; having remissions [adj REMITTENTLY]\n",
  "REMITTENTLY": "REMITTENT, remitting; having remissions [adv]\n",
  "REMITTER": "one who remits, also REMITTOR [n -S]\n",
  "REMITTERS": "REMITTER, one who remits, also REMITTOR [n]\n",
  "REMITTING": "REMIT, to send payment [v]\n",
  "REMITTOR": "one who remits, also REMITTER [n -S]\n",
  "REMITTORS": "REMITTOR, one who remits, also REMITTER [n]\n",
  "REMIX": "to mix again [v REMIXED, REMIXT, REMIXING, REMIXES]\n",
  "REMIXED": "REMIX, to mix again [v]\n",
  "REMIXER": "one that remixes (a recording) [n -S]\n",
  "REMIXERS": "REMIXER, one that remixes (a recording) [n]\n",
  "REMIXES": "REMIX, to mix again [v]\n",
  "REMIXING": "REMIX, to mix again [v]\n",
  "REMIXT": "REMIX, to mix again [v]\n",
  "REMIXTURE": "the act of remixing [n -S]\n",
  "REMIXTURES": "REMIXTURE, the act of remixing [n]\n",
  "REMNANT": "something remaining, also REMANENT [n -S]\n",
  "REMNANTAL": "existing as a remnant [adj]\n",
  "REMNANTS": "REMNANT, something remaining, also REMANENT [n]\n",
  "REMOBILISATION": "the act of remobilising, also REMOBILIZATION [n -S]\n",
  "REMOBILISATIONS": "REMOBILISATION, the act of remobilising, also REMOBILIZATION [n]\n",
  "REMOBILISE": "to mobilise again, also REMOBILIZE [v REMOBILISED, REMOBILISING, REMOBILISES]\n",
  "REMOBILISED": "REMOBILISE, to mobilise again, also REMOBILIZE [v]\n",
  "REMOBILISES": "REMOBILISE, to mobilise again, also REMOBILIZE [v]\n",
  "REMOBILISING": "REMOBILISE, to mobilise again, also REMOBILIZE [v]\n",
  "REMOBILIZATION": "the act of remobilizing, also REMOBILISATION [n -S]\n",
  "REMOBILIZATIONS": "REMOBILIZATION, the act of remobilizing, also REMOBILISATION [n]\n",
  "REMOBILIZE": "to mobilise again, also REMOBILISE [v REMOBILIZED, REMOBILIZING, REMOBILIZES]\n",
  "REMOBILIZED": "REMOBILIZE, to mobilise again, also REMOBILISE [v]\n",
  "REMOBILIZES": "REMOBILIZE, to mobilise again, also REMOBILISE [v]\n",
  "REMOBILIZING": "REMOBILIZE, to mobilise again, also REMOBILISE [v]\n",
  "REMODEL": "to make over [v REMODELED or REMODELLED, REMODELING or REMODELLING, REMODELS]\n",
  "REMODELED": "REMODEL, to make over [v]\n",
  "REMODELER": "one who remodels [n -S]\n",
  "REMODELERS": "REMODELER, one who remodels [n]\n",
  "REMODELING": "the act of modelling again [n -S]\n",
  "REMODELINGS": "REMODELING, the act of modelling again [n]\n",
  "REMODELLED": "REMODEL, to make over [v]\n",
  "REMODELLER": "one who remodels [n -S]\n",
  "REMODELLERS": "REMODELLER, one who remodels [n]\n",
  "REMODELLING": "the act of modelling again [n -S]\n",
  "REMODELLINGS": "REMODELLING, the act of modelling again [n]\n",
  "REMODELS": "REMODEL, to make over [v]\n",
  "REMODIFIED": "REMODIFY, to modify again [v]\n",
  "REMODIFIES": "REMODIFY, to modify again [v]\n",
  "REMODIFY": "to modify again [v REMODIFIED, REMODIFYING, REMODIFIES]\n",
  "REMODIFYING": "REMODIFY, to modify again [v]\n",
  "REMOISTEN": "to moisten again [v -ED, -ING, -S]\n",
  "REMOISTENED": "REMOISTEN, to moisten again [v]\n",
  "REMOISTENING": "REMOISTEN, to moisten again [v]\n",
  "REMOISTENS": "REMOISTEN, to moisten again [v]\n",
  "REMOLADE": "(French) a piquant sauce, also REMOULADE [n -S]\n",
  "REMOLADES": "REMOLADE, (French) a piquant sauce, also REMOULADE [n]\n",
  "REMOLD": "to retread a tyre, also REMOULD [v -ED, -ING, -S]\n",
  "REMOLDED": "REMOLD, to retread a tyre, also REMOULD [v]\n",
  "REMOLDING": "REMOLD, to retread a tyre, also REMOULD [v]\n",
  "REMOLDS": "REMOLD, to retread a tyre, also REMOULD [v]\n",
  "REMONETISATION": "the act of remonetising, also REMONETIZATION [n -S]\n",
  "REMONETISATIONS": "REMONETISATION, the act of remonetising, also REMONETIZATION [n]\n",
  "REMONETISE": "to reestablish as legal tender, also REMONETIZE [v REMONETISED, REMONETISING, REMONETISES]\n",
  "REMONETISED": "REMONETISE, to reestablish as legal tender, also REMONETIZE [v]\n",
  "REMONETISES": "REMONETISE, to reestablish as legal tender, also REMONETIZE [v]\n",
  "REMONETISING": "REMONETISE, to reestablish as legal tender, also REMONETIZE [v]\n",
  "REMONETIZATION": "the act of remonetizing, also REMONETISATION [n -S]\n",
  "REMONETIZATIONS": "REMONETIZATION, the act of remonetizing, also REMONETISATION [n]\n",
  "REMONETIZE": "to reestablish as legal tender, also REMONETISE [v REMONETIZED, REMONETIZING, REMONETIZES]\n",
  "REMONETIZED": "REMONETIZE, to reestablish as legal tender, also REMONETISE [v]\n",
  "REMONETIZES": "REMONETIZE, to reestablish as legal tender, also REMONETISE [v]\n",
  "REMONETIZING": "REMONETIZE, to reestablish as legal tender, also REMONETISE [v]\n",
  "REMONSTRANCE": "an earnest presentation of reasons for opposition or grievance [n -S]\n",
  "REMONSTRANCES": "REMONSTRANCE, an earnest presentation of reasons for opposition or grievance [n]\n",
  "REMONSTRANT": "remonstrating [adj REMONSTRANTLY] / one who remonstrates [n -S]\n",
  "REMONSTRANTLY": "REMONSTRANT, remonstrating [adv]\n",
  "REMONSTRANTS": "REMONSTRANT, one who remonstrates [n]\n",
  "REMONSTRATE": "to protest, to expostulate [v REMONSTRATED, REMONSTRATING, REMONSTRATES]\n",
  "REMONSTRATED": "REMONSTRATE, to protest, to expostulate [v]\n",
  "REMONSTRATES": "REMONSTRATE, to protest, to expostulate [v]\n",
  "REMONSTRATING": "REMONSTRATE, to protest, to expostulate [v]\n",
  "REMONSTRATINGLY": "REMONSTRATING, REMONSTRATE, to protest, to expostulate [adv]\n",
  "REMONSTRATION": "the act of remonstrating [n -S]\n",
  "REMONSTRATIONS": "REMONSTRATION, the act of remonstrating [n]\n",
  "REMONSTRATIVE": "expressing remonstration [adj REMONSTRATIVELY]\n",
  "REMONSTRATIVELY": "REMONSTRATIVE, expressing remonstration [adv]\n",
  "REMONSTRATOR": "one who remonstrates [n -S]\n",
  "REMONSTRATORS": "REMONSTRATOR, one who remonstrates [n]\n",
  "REMONSTRATORY": "of the nature of a remonstrance [adj]\n",
  "REMONTANT": "(French) flowering more than once per season [adj] / a remontant flower [n -S]\n",
  "REMONTANTS": "REMONTANT, a remontant flower [n]\n",
  "REMONTOIR": "any of various devices used in watches, clocks etc. to compensate for errors, also REMONTOIRE [n -S]\n",
  "REMONTOIRE": "any of various devices used in watches, clocks etc. to compensate for errors, also REMONTOIR [n -S]\n",
  "REMONTOIRES": "REMONTOIRE, any of various devices used in watches, clocks etc. to compensate for errors, also REMONTOIR [n]\n",
  "REMONTOIRS": "REMONTOIR, any of various devices used in watches, clocks etc. to compensate for errors, also REMONTOIRE [n]\n",
  "REMORA": "(Latin) the sucking-fish, formerly believed to stop ships by attaching its sucker [n -S]\n",
  "REMORALISATION": "the process of remoralising, also REMORALIZATION [n -S]\n",
  "REMORALISATIONS": "REMORALISATION, the process of remoralising, also REMORALIZATION [n]\n",
  "REMORALISE": "to restore morality to, also REMORALIZE [v REMORALISED, REMORALISING, REMORALISES]\n",
  "REMORALISED": "REMORALISE, to restore morality to, also REMORALIZE [v]\n",
  "REMORALISES": "REMORALISE, to restore morality to, also REMORALIZE [v]\n",
  "REMORALISING": "REMORALISE, to restore morality to, also REMORALIZE [v]\n",
  "REMORALIZATION": "the process of remoralizing, also REMORALISATION [n -S]\n",
  "REMORALIZATIONS": "REMORALIZATION, the process of remoralizing, also REMORALISATION [n]\n",
  "REMORALIZE": "to restore morality to, also REMORALISE [v REMORALIZED, REMORALIZING, REMORALIZES]\n",
  "REMORALIZED": "REMORALIZE, to restore morality to, also REMORALISE [v]\n",
  "REMORALIZES": "REMORALIZE, to restore morality to, also REMORALISE [v]\n",
  "REMORALIZING": "REMORALIZE, to restore morality to, also REMORALISE [v]\n",
  "REMORAS": "REMORA, (Latin) the sucking-fish, formerly believed to stop ships by attaching its sucker [n]\n",
  "REMORID": "of or like a remora, the sucking-fish, previously believed to delay ships by attaching itself to the keel [adj]\n",
  "REMORSE": "deep anguish caused by a sense of guilt [n -S]\n",
  "REMORSEFUL": "motivated or marked by remorse [adj REMORSEFULLY]\n",
  "REMORSEFULLY": "REMORSEFUL, motivated or marked by remorse [adv]\n",
  "REMORSEFULNESS": "REMORSEFUL, motivated or marked by remorse [n]\n",
  "REMORSELESS": "having no remorse [adj REMORSELESSLY]\n",
  "REMORSELESSLY": "REMORSELESS, having no remorse [adv]\n",
  "REMORSELESSNESS": "the state of being remorseless [n]\n",
  "REMORSES": "REMORSE, deep anguish caused by a sense of guilt [n]\n",
  "REMORTGAGE": "to mortgage again [v REMORTGAGED, REMORTGAGING, REMORTGAGES]\n",
  "REMORTGAGED": "REMORTGAGE, to mortgage again [v]\n",
  "REMORTGAGES": "REMORTGAGE, to mortgage again [v]\n",
  "REMORTGAGING": "REMORTGAGE, to mortgage again [v]\n",
  "REMOTE": "far off [adj REMOTER, REMOTEST, REMOTELY] / a remote control [n -S]\n",
  "REMOTELY": "REMOTE, far off [adv]\n",
  "REMOTENESS": "the state of being remote [n -ES]\n",
  "REMOTENESSES": "REMOTENESS, the state of being remote [n]\n",
  "REMOTER": "REMOTE, far off [adj]\n",
  "REMOTES": "REMOTE, a remote control [n]\n",
  "REMOTEST": "REMOTE, far off [adj]\n",
  "REMOTION": "the act of removing [n -S]\n",
  "REMOTIONS": "REMOTION, the act of removing [n]\n",
  "REMOTIVATE": "to motivate again [v REMOTIVATED, REMOTIVATING, REMOTIVATES]\n",
  "REMOTIVATED": "REMOTIVATE, to motivate again [v]\n",
  "REMOTIVATES": "REMOTIVATE, to motivate again [v]\n",
  "REMOTIVATING": "REMOTIVATE, to motivate again [v]\n",
  "REMOTIVATION": "the act of remotivating [n -S]\n",
  "REMOTIVATIONS": "REMOTIVATION, the act of remotivating [n]\n",
  "REMOUD": "(Spenser) removed [v]\n",
  "REMOULADE": "(French) a piquant sauce, also REMOLADE [n -S]\n",
  "REMOULADES": "REMOULADE, (French) a piquant sauce, also REMOLADE [n]\n",
  "REMOULD": "to retread a tyre, also REMOLD [v -ED, -ING, -S]\n",
  "REMOULDED": "REMOULD, to retread a tyre, also REMOLD [v]\n",
  "REMOULDING": "REMOULD, to retread a tyre, also REMOLD [v]\n",
  "REMOULDS": "REMOULD, to retread a tyre, also REMOLD [v]\n",
  "REMOUNT": "to climb on a horse once more [v -ED, -ING, -S]\n",
  "REMOUNTED": "REMOUNT, to climb on a horse once more [v]\n",
  "REMOUNTING": "the act of mounting again [n -S]\n",
  "REMOUNTINGS": "REMOUNTING, the act of mounting again [n]\n",
  "REMOUNTS": "REMOUNT, to climb on a horse once more [v]\n",
  "REMOVABILITIES": "REMOVABILITY, the state of being removable [n]\n",
  "REMOVABILITY": "the state of being removable [n REMOVABILITIES]\n",
  "REMOVABLE": "capable of being removed, also REMOVEABLE [adj REMOVABLY]\n",
  "REMOVABLENESS": "REMOVABLE, capable of being removed, also REMOVEABLE [n]\n",
  "REMOVABLENESSES": "REMOVABLENESS, REMOVABLE, capable of being removed, also REMOVEABLE [n]\n",
  "REMOVABLY": "REMOVABLE, capable of being removed, also REMOVEABLE [adv]\n",
  "REMOVAL": "the act of removing [n -S]\n",
  "REMOVALIST": "(Australian) a person or company that transports household effects to a new home [n -S]\n",
  "REMOVALISTS": "REMOVALIST, (Australian) a person or company that transports household effects to a new home [n]\n",
  "REMOVALS": "REMOVAL, the act of removing [n]\n",
  "REMOVE": "to transfer to another place [v REMOVED, REMOVING, REMOVES]\n",
  "REMOVEABLE": "capable of being removed, also REMOVABLE [adj]\n",
  "REMOVED": "REMOVE, to transfer to another place [v]\n",
  "REMOVEDLY": "REMOVED, REMOVE, to transfer to another place [adv]\n",
  "REMOVEDNESS": "the state of being removed [n -ES]\n",
  "REMOVEDNESSES": "REMOVEDNESS, the state of being removed [n]\n",
  "REMOVER": "one who removes [n -S]\n",
  "REMOVERS": "REMOVER, one who removes [n]\n",
  "REMOVES": "REMOVE, to transfer to another place [v]\n",
  "REMOVING": "REMOVE, to transfer to another place [v]\n",
  "REMS": "REM, a unit of radiation dosage [n]\n",
  "REMUAGE": "(French) the process of turning or shaking wine bottles so that the sediment collects at the cork end for removal [n -S]\n",
  "REMUAGES": "REMUAGE, (French) the process of turning or shaking wine bottles so that the sediment collects at the cork end for removal [n]\n",
  "REMUDA": "(Spanish) a herd of horses from which ranch hands select their mounts [n -S]\n",
  "REMUDAS": "REMUDA, (Spanish) a herd of horses from which ranch hands select their mounts [n]\n",
  "REMUEUR": "(French) the person who carries out remuage, the process of turning or shaking wine bottles so that the sediment collects at the cork end for removal [n -S]\n",
  "REMUEURS": "REMUEUR, (French) the person who carries out remuage, the process of turning or shaking wine bottles so that the sediment collects at the cork end for removal [n]\n",
  "REMUNERABILITY": "the quality of being remunerable [n]\n",
  "REMUNERABLE": "that can be remunerated [adj]\n",
  "REMUNERATE": "to pay an equivalent for [v REMUNERATED, REMUNERATING, REMUNERATES]\n",
  "REMUNERATED": "REMUNERATE, to pay an equivalent for [v]\n",
  "REMUNERATES": "REMUNERATE, to pay an equivalent for [v]\n",
  "REMUNERATING": "REMUNERATE, to pay an equivalent for [v]\n",
  "REMUNERATION": "something that remunerates [n -S]\n",
  "REMUNERATIONS": "REMUNERATION, something that remunerates [n]\n",
  "REMUNERATIVE": "serving to remunerate [adj REMUNERATIVELY]\n",
  "REMUNERATIVELY": "REMUNERATIVE, serving to remunerate [adv]\n",
  "REMUNERATOR": "one who remunerates [n -S]\n",
  "REMUNERATORS": "REMUNERATOR, one who remunerates [n]\n",
  "REMUNERATORY": "relating to remuneration [adj]\n",
  "REMURMUR": "to murmur again; to utter back, or reply, in murmurs [v -ED, -ING, -S]\n",
  "REMURMURED": "REMURMUR, to murmur again; to utter back, or reply, in murmurs [v]\n",
  "REMURMURING": "REMURMUR, to murmur again; to utter back, or reply, in murmurs [v]\n",
  "REMURMURS": "REMURMUR, to murmur again; to utter back, or reply, in murmurs [v]\n",
  "REMYTHOLOGISE": "to mythologise again, also REMYTHOLOGIZE [v REMYTHOLOGISED, REMYTHOLOGISES]\n",
  "REMYTHOLOGISED": "REMYTHOLOGISE, to mythologise again, also REMYTHOLOGIZE [v]\n",
  "REMYTHOLOGISES": "REMYTHOLOGISE, to mythologise again, also REMYTHOLOGIZE [v]\n",
  "REMYTHOLOGISING": "REMYTHOLOGISE, to mythologise again, also REMYTHOLOGIZE [v]\n",
  "REMYTHOLOGIZE": "to mythologize again, also REMYTHOLOGISE [v REMYTHOLOGIZED, REMYTHOLOGIZING, REMYTHOLOGIZES]\n",
  "REMYTHOLOGIZED": "REMYTHOLOGIZE, to mythologize again, also REMYTHOLOGISE [v]\n",
  "REMYTHOLOGIZES": "REMYTHOLOGIZE, to mythologize again, also REMYTHOLOGISE [v]\n",
  "REMYTHOLOGIZING": "REMYTHOLOGIZE, to mythologize again, also REMYTHOLOGISE [v]\n",
  "REN": "(obsolete) to run, also RENNE, RIN, RONNE [v RENNED, RENNING, RENS]\n",
  "RENAGUE": "to refuse, deny, also RENEAGUE, RENEGE, RENEGUE, RENIG [v RENAGUED, RENAGUING, RENAGUES]\n",
  "RENAGUED": "RENAGUE, to refuse, deny, also RENEAGUE, RENEGE, RENEGUE, RENIG [v]\n",
  "RENAGUES": "RENAGUE, to refuse, deny, also RENEAGUE, RENEGE, RENEGUE, RENIG [v]\n",
  "RENAGUING": "RENAGUE, to refuse, deny, also RENEAGUE, RENEGE, RENEGUE, RENIG [v]\n",
  "RENAIL": "to nail again [v -ED, -ING, -S]\n",
  "RENAILED": "RENAIL, to nail again [v]\n",
  "RENAILING": "RENAIL, to nail again [v]\n",
  "RENAILS": "RENAIL, to nail again [v]\n",
  "RENAISSANCE": "rebirth, also RENASCENCE [n -S]\n",
  "RENAISSANCES": "RENAISSANCE, rebirth, also RENASCENCE [n]\n",
  "RENAL": "pertaining to the kidneys [adj]\n",
  "RENAME": "to issue with a new name [v RENAMED, RENAMING, RENAMES]\n",
  "RENAMED": "RENAME, to issue with a new name [v]\n",
  "RENAMES": "RENAME, to issue with a new name [v]\n",
  "RENAMING": "RENAME, to issue with a new name [v]\n",
  "RENASCENCE": "rebirth, also RENAISSANCE [n -S]\n",
  "RENASCENCES": "RENASCENCE, rebirth, also RENAISSANCE [n]\n",
  "RENASCENT": "coming into renewed life or vitality [adj]\n",
  "RENATIONALISE": "to nationalise again, also RENATIONALIZE [v RENATIONALISED, RENATIONALISING, RENATIONALISES]\n",
  "RENATIONALISED": "RENATIONALISE, to nationalise again, also RENATIONALIZE [v]\n",
  "RENATIONALISES": "RENATIONALISE, to nationalise again, also RENATIONALIZE [v]\n",
  "RENATIONALISING": "RENATIONALISE, to nationalise again, also RENATIONALIZE [v]\n",
  "RENATIONALIZE": "to nationalize again, also RENATIONALISE [v RENATIONALIZED, RENATIONALIZING, RENATIONALIZES]\n",
  "RENATIONALIZED": "RENATIONALIZE, to nationalize again, also RENATIONALISE [v]\n",
  "RENATIONALIZES": "RENATIONALIZE, to nationalize again, also RENATIONALISE [v]\n",
  "RENATIONALIZING": "RENATIONALIZE, to nationalize again, also RENATIONALISE [v]\n",
  "RENATURATION": "the act of renaturing [n -S]\n",
  "RENATURATIONS": "RENATURATION, the act of renaturing [n]\n",
  "RENATURE": "to restore natural qualities [v RENATURED, RENATURING, RENATURES]\n",
  "RENATURED": "RENATURE, to restore natural qualities [v]\n",
  "RENATURES": "RENATURE, to restore natural qualities [v]\n",
  "RENATURING": "RENATURE, to restore natural qualities [v]\n",
  "RENAY": "(obsolete) to renounce, abjure, also RENEY, RENY [v -ED, -ING, -S]\n",
  "RENAYED": "RENAY, (obsolete) to renounce, abjure, also RENEY, RENY [v]\n",
  "RENAYING": "RENAY, (obsolete) to renounce, abjure, also RENEY, RENY [v]\n",
  "RENAYS": "RENAY, (obsolete) to renounce, abjure, also RENEY, RENY [v]\n",
  "RENCONTRE": "(French) to encounter or meet, esp. under negative circumstances [v RENCONTRED, RENCONTRING, RENCONTRES]\n",
  "RENCONTRED": "RENCONTRE, (French) to encounter or meet, esp. under negative circumstances [v]\n",
  "RENCONTRES": "RENCONTRE, (French) to encounter or meet, esp. under negative circumstances [v]\n",
  "RENCONTRING": "RENCONTRE, (French) to encounter or meet, esp. under negative circumstances [v]\n",
  "RENCOUNTER": "to meet, encounter [v -ED, -ING, -S]\n",
  "RENCOUNTERED": "RENCOUNTER, to meet, encounter [v]\n",
  "RENCOUNTERING": "RENCOUNTER, to meet, encounter [v]\n",
  "RENCOUNTERS": "RENCOUNTER, to meet, encounter [v]\n",
  "REND": "to tear apart forcibly [v RENDED or RENT or (obsolete) YRENT, RENDING, RENDS]\n",
  "RENDANG": "an Indonesian dish of meat cooked slowly in a spicy paste [n -S]\n",
  "RENDANGS": "RENDANG, an Indonesian dish of meat cooked slowly in a spicy paste [n]\n",
  "RENDED": "REND, to tear apart forcibly [v]\n",
  "RENDER": "to plaster with a first coat [v -ED, -ING, -S]\n",
  "RENDERABLE": "capable of being rendered [adj]\n",
  "RENDERED": "RENDER, to plaster with a first coat [v]\n",
  "RENDERER": "one that renders [n -S]\n",
  "RENDERERS": "RENDERER, one that renders [n]\n",
  "RENDERING": "a first coat of plaster etc. [n -S]\n",
  "RENDERINGS": "RENDERING, a first coat of plaster etc. [n]\n",
  "RENDERS": "RENDER, to plaster with a first coat [v]\n",
  "RENDEZVOUS": "(French) an arranged meeting [n] / to arrange a meeting [v -ED, -ING, -ES]\n",
  "RENDEZVOUSED": "RENDEZVOUS, to arrange a meeting [v]\n",
  "RENDEZVOUSES": "RENDEZVOUS, (French) an arranged meeting [n]\n",
  "RENDEZVOUSING": "RENDEZVOUS, to arrange a meeting [v]\n",
  "RENDIBLE": "capable of being rent [adj]\n",
  "RENDING": "REND, to tear apart forcibly [v]\n",
  "RENDITION": "to surrender (fugitives from justice) at the claim of a foreign government [v -ED, -ING, -S]\n",
  "RENDITIONED": "RENDITION, to surrender (fugitives from justice) at the claim of a foreign government [v]\n",
  "RENDITIONING": "RENDITION, to surrender (fugitives from justice) at the claim of a foreign government [v]\n",
  "RENDITIONS": "RENDITION, to surrender (fugitives from justice) at the claim of a foreign government [v]\n",
  "RENDS": "REND, to tear apart forcibly [v]\n",
  "RENDZINA": "(Russian) a fertile soil-type derived from calcium-rich bedrock [n -S]\n",
  "RENDZINAS": "RENDZINA, (Russian) a fertile soil-type derived from calcium-rich bedrock [n]\n",
  "RENEAGUE": "to go back on a promise etc., also RENAGUE, RENEGE, RENEGUE, RENIG [v RENEAGUED, RENEAGUING, RENEAGUES]\n",
  "RENEAGUED": "RENEAGUE, to go back on a promise etc., also RENAGUE, RENEGE, RENEGUE, RENIG [v]\n",
  "RENEAGUES": "RENEAGUE, to go back on a promise etc., also RENAGUE, RENEGE, RENEGUE, RENIG [v]\n",
  "RENEAGUING": "RENEAGUE, to go back on a promise etc., also RENAGUE, RENEGE, RENEGUE, RENIG [v]\n",
  "RENEGADE": "a person who abandons a party or belief, also RENEGADO, RENEGATE, RUNAGATE [n -S] / to turn renegade [v RENEGADED, RENEGADING, RENEGADES]\n",
  "RENEGADED": "RENEGADE, to turn renegade [v]\n",
  "RENEGADES": "RENEGADE, to turn renegade [v]\n",
  "RENEGADING": "RENEGADE, to turn renegade [v]\n",
  "RENEGADO": "(archaic) a renegade [n -ES or -S]\n",
  "RENEGADOES": "RENEGADO, (archaic) a renegade [n]\n",
  "RENEGADOS": "RENEGADO, (archaic) a renegade [n]\n",
  "RENEGATE": "a person who abandons a party or belief, also RENEGADE, RENEGADO, RUNAGATE [n -S]\n",
  "RENEGATES": "RENEGATE, a person who abandons a party or belief, also RENEGADE, RENEGADO, RUNAGATE [n]\n",
  "RENEGATION": "a denial [n -S]\n",
  "RENEGATIONS": "RENEGATION, a denial [n]\n",
  "RENEGE": "to refuse, deny, also RENAGUE, RENEAGUE, RENEGUE, RENIG [v RENEGED, RENEGING, RENEGES]\n",
  "RENEGED": "RENEGE, to refuse, deny, also RENAGUE, RENEAGUE, RENEGUE, RENIG [v]\n",
  "RENEGER": "one who reneges [n -S]\n",
  "RENEGERS": "RENEGER, one who reneges [n]\n",
  "RENEGES": "RENEGE, to refuse, deny, also RENAGUE, RENEAGUE, RENEGUE, RENIG [v]\n",
  "RENEGING": "RENEGE, to refuse, deny, also RENAGUE, RENEAGUE, RENEGUE, RENIG [v]\n",
  "RENEGOTIABLE": "subject to renegotiation [adj]\n",
  "RENEGOTIATE": "to negotiate again (as to adjust interest rates or repayments or to get more money) [v RENEGOTIATED, RENEGOTIATING, RENEGOTIATES]\n",
  "RENEGOTIATED": "RENEGOTIATE, to negotiate again (as to adjust interest rates or repayments or to get more money) [v]\n",
  "RENEGOTIATES": "RENEGOTIATE, to negotiate again (as to adjust interest rates or repayments or to get more money) [v]\n",
  "RENEGOTIATING": "RENEGOTIATE, to negotiate again (as to adjust interest rates or repayments or to get more money) [v]\n",
  "RENEGOTIATION": "the act of renegotiating [n -S]\n",
  "RENEGOTIATIONS": "RENEGOTIATION, the act of renegotiating [n]\n",
  "RENEGUE": "to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENIG [v RENEGUED, RENEGUING, RENEGUES]\n",
  "RENEGUED": "RENEGUE, to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENIG [v]\n",
  "RENEGUER": "one who renegues [n -S]\n",
  "RENEGUERS": "RENEGUER, one who renegues [n]\n",
  "RENEGUES": "RENEGUE, to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENIG [v]\n",
  "RENEGUING": "RENEGUE, to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENIG [v]\n",
  "RENEST": "to nest again [v -ED, -ING, -S]\n",
  "RENESTED": "RENEST, to nest again [v]\n",
  "RENESTING": "RENEST, to nest again [v]\n",
  "RENESTS": "RENEST, to nest again [v]\n",
  "RENEW": "to make new again [v -ED, -ING, -S]\n",
  "RENEWABILITIES": "RENEWABILITY, the state of being renewable [n]\n",
  "RENEWABILITY": "the state of being renewable [n RENEWABILITIES]\n",
  "RENEWABLE": "capable of being renewed [adj RENEWABLY] / a renewable resource [n -S]\n",
  "RENEWABLES": "RENEWABLE, a renewable resource [n]\n",
  "RENEWABLY": "RENEWABLE, capable of being renewed [adv]\n",
  "RENEWAL": "the act of renewing [n -S]\n",
  "RENEWALS": "RENEWAL, the act of renewing [n]\n",
  "RENEWED": "RENEW, to make new again [v]\n",
  "RENEWEDLY": "RENEWED, RENEW, to make new again [adv]\n",
  "RENEWEDNESS": "the state of being renewed [n -ES]\n",
  "RENEWEDNESSES": "RENEWEDNESS, the state of being renewed [n]\n",
  "RENEWER": "one who renews [n -S]\n",
  "RENEWERS": "RENEWER, one who renews [n]\n",
  "RENEWING": "the act of renewing [n -S]\n",
  "RENEWINGS": "RENEWING, the act of renewing [n]\n",
  "RENEWS": "RENEW, to make new again [v]\n",
  "RENEY": "(obsolete) to renounce, abjure, also RENAY, RENY [v -ED, -ING, -S]\n",
  "RENEYED": "RENEY, (obsolete) to renounce, abjure, also RENAY, RENY [v]\n",
  "RENEYING": "RENEY, (obsolete) to renounce, abjure, also RENAY, RENY [v]\n",
  "RENEYS": "RENEY, (obsolete) to renounce, abjure, also RENAY, RENY [v]\n",
  "RENFIERST": "(Spenser) made fierce [adj]\n",
  "RENFORCE": "to reinforce [v RENFORCED or (Spenser) RENFORST, RENFORCING, RENFORCES]\n",
  "RENFORCED": "RENFORCE, to reinforce [v]\n",
  "RENFORCES": "RENFORCE, to reinforce [v]\n",
  "RENFORCING": "RENFORCE, to reinforce [v]\n",
  "RENFORST": "RENFORCE, to reinforce [v]\n",
  "RENGA": "(Japanese) a kind of linked verse [n -S]\n",
  "RENGAS": "RENGA, (Japanese) a kind of linked verse [n]\n",
  "RENIED": "RENY, (obsolete) to renounce, abjure, also RENAY, RENEY [v]\n",
  "RENIES": "RENY, (obsolete) to renounce, abjure, also RENAY, RENEY [v]\n",
  "RENIFORM": "kidney-shaped [adj]\n",
  "RENIG": "(Irish) to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENEGUE [v RENIGGED, RENIGGING, RENIGS]\n",
  "RENIGGED": "RENIG, (Irish) to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENEGUE [v]\n",
  "RENIGGING": "RENIG, (Irish) to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENEGUE [v]\n",
  "RENIGS": "RENIG, (Irish) to refuse, deny, also RENAGUE, RENEAGUE, RENEGE, RENEGUE [v]\n",
  "RENIN": "a protein enzyme secreted by the kidneys [n -S]\n",
  "RENINS": "RENIN, a protein enzyme secreted by the kidneys [n]\n",
  "RENITENCE": "the state of being renitent, resistent, also RENITENCY [n -S]\n",
  "RENITENCES": "RENITENCE, the state of being renitent, resistent, also RENITENCY [n]\n",
  "RENITENCIES": "RENITENCY, the state of being renitent, resistent, also RENITENCE [n]\n",
  "RENITENCY": "the state of being renitent, resistent, also RENITENCE [n RENITENCIES]\n",
  "RENITENT": "resisting physical pressure [adj]\n",
  "RENK": "(dialect) unpleasant, horrible [adj RENKER, RENKEST]\n",
  "RENKER": "RENK, (dialect) unpleasant, horrible [adj]\n",
  "RENKEST": "RENK, (dialect) unpleasant, horrible [adj]\n",
  "RENMINBI": "(Chinese) the currency of the People's Republic of China since 1948 [n -S]\n",
  "RENMINBIS": "RENMINBI, (Chinese) the currency of the People's Republic of China since 1948 [n]\n",
  "RENNASE": "an enzyme found in gastric juice, which causes coagulation of milk, also RENNIN [n -S]\n",
  "RENNASES": "RENNASE, an enzyme found in gastric juice, which causes coagulation of milk, also RENNIN [n]\n",
  "RENNE": "(Spenser) to run [v RENNED, RENNING, RENNES]\n",
  "RENNED": "REN, (obsolete) to run, also RENNE, RIN, RONNE [v]\n",
  "RENNES": "RENNE, (Spenser) to run [v]\n",
  "RENNET": "a name given to many different kinds of apples, mostly of French origin, also REINETTE, RUNNET [n -S]\n",
  "RENNETS": "RENNET, a name given to many different kinds of apples, mostly of French origin, also REINETTE, RUNNET [n]\n",
  "RENNIN": "an enzyme found in gastric juice, which causes coagulation of milk, also RENNASE [n -S]\n",
  "RENNING": "the act of running [n -S]\n",
  "RENNINGS": "RENNING, the act of running [n]\n",
  "RENNINS": "RENNIN, an enzyme found in gastric juice, which causes coagulation of milk, also RENNASE [n]\n",
  "RENO": "(short for) a renovated house [n -S]\n",
  "RENOGRAM": "a photographic depiction of the course of renal excretion [n -S]\n",
  "RENOGRAMS": "RENOGRAM, a photographic depiction of the course of renal excretion [n]\n",
  "RENOGRAPHIC": "relating to a renogram [adj]\n",
  "RENOGRAPHIES": "RENOGRAPHY, a treatise on or description of the kidneys [n]\n",
  "RENOGRAPHY": "a treatise on or description of the kidneys [n RENOGRAPHIES]\n",
  "RENOMINATE": "to nominate again esp. for a succeeding term [v RENOMINATED, RENOMINATING, RENOMINATES]\n",
  "RENOMINATED": "RENOMINATE, to nominate again esp. for a succeeding term [v]\n",
  "RENOMINATES": "RENOMINATE, to nominate again esp. for a succeeding term [v]\n",
  "RENOMINATING": "RENOMINATE, to nominate again esp. for a succeeding term [v]\n",
  "RENOMINATION": "the act of nominating again, e.g. for a second term [n -S]\n",
  "RENOMINATIONS": "RENOMINATION, the act of nominating again, e.g. for a second term [n]\n",
  "RENORMALISATION": "the process of renormalising, also RENORMALIZATION [n]\n",
  "RENORMALISE": "to subject to or calculate using renormalisation, also RENORMALIZE [v RENORMALISED, RENORMALISING, RENORMALISES]\n",
  "RENORMALISED": "RENORMALISE, to subject to or calculate using renormalisation, also RENORMALIZE [v]\n",
  "RENORMALISES": "RENORMALISE, to subject to or calculate using renormalisation, also RENORMALIZE [v]\n",
  "RENORMALISING": "RENORMALISE, to subject to or calculate using renormalisation, also RENORMALIZE [v]\n",
  "RENORMALIZATION": "the process of renormalizing, also RENORMALISATION [n]\n",
  "RENORMALIZE": "to subject to or calculate using renormalization, also RENORMALISE [v RENORMALIZED, RENORMALIZING, RENORMALIZES]\n",
  "RENORMALIZED": "RENORMALIZE, to subject to or calculate using renormalization, also RENORMALISE [v]\n",
  "RENORMALIZES": "RENORMALIZE, to subject to or calculate using renormalization, also RENORMALISE [v]\n",
  "RENORMALIZING": "RENORMALIZE, to subject to or calculate using renormalization, also RENORMALISE [v]\n",
  "RENOS": "RENO, (short for) a renovated house [n]\n",
  "RENOSTERVELD": "(South African) an area of high altitude in South Africa, having fertile ground [n -S]\n",
  "RENOSTERVELDS": "RENOSTERVELD, (South African) an area of high altitude in South Africa, having fertile ground [n]\n",
  "RENOTIFIED": "RENOTIFY, to notify again [v]\n",
  "RENOTIFIES": "RENOTIFY, to notify again [v]\n",
  "RENOTIFY": "to notify again [v RENOTIFIED, RENOTIFYING, RENOTIFIES]\n",
  "RENOTIFYING": "RENOTIFY, to notify again [v]\n",
  "RENOUNCE": "to disown, give up [v RENOUNCED, RENOUNCING, RENOUNCES]\n",
  "RENOUNCEABLE": "able to be renounced [adj]\n",
  "RENOUNCED": "RENOUNCE, to disown, give up [v]\n",
  "RENOUNCEMENT": "the act of renouncing [n -S]\n",
  "RENOUNCEMENTS": "RENOUNCEMENT, the act of renouncing [n]\n",
  "RENOUNCER": "one who renounces [n -S]\n",
  "RENOUNCERS": "RENOUNCER, one who renounces [n]\n",
  "RENOUNCES": "RENOUNCE, to disown, give up [v]\n",
  "RENOUNCING": "RENOUNCE, to disown, give up [v]\n",
  "RENOVASCULAR": "of, relating to, or involving the blood vessels of the kidneys [adj]\n",
  "RENOVATE": "to make like new [v RENOVATED, RENOVATING, RENOVATES]\n",
  "RENOVATED": "RENOVATE, to make like new [v]\n",
  "RENOVATES": "RENOVATE, to make like new [v]\n",
  "RENOVATING": "RENOVATE, to make like new [v]\n",
  "RENOVATION": "the act of renovating [n -S]\n",
  "RENOVATIONS": "RENOVATION, the act of renovating [n]\n",
  "RENOVATIVE": "serving to renovate [adj]\n",
  "RENOVATOR": "one who, or that which, renovates [n -S]\n",
  "RENOVATORS": "RENOVATOR, one who, or that which, renovates [n]\n",
  "RENOWN": "to make famous [v -ED, -ING, -S]\n",
  "RENOWNED": "RENOWN, to make famous [v]\n",
  "RENOWNER": "one who gives another renown [n -S]\n",
  "RENOWNERS": "RENOWNER, one who gives another renown [n]\n",
  "RENOWNING": "RENOWN, to make famous [v]\n",
  "RENOWNS": "RENOWN, to make famous [v]\n",
  "RENS": "REN, (obsolete) to run, also RENNE, RIN, RONNE [v]\n",
  "RENSSELAERITE": "a kind of firm-textured talc, used for carving ornaments [n -S]\n",
  "RENSSELAERITES": "RENSSELAERITE, a kind of firm-textured talc, used for carving ornaments [n]\n",
  "RENT": "to hire [v -ED, -ING, -S]\n",
  "RENTABILITIES": "RENTABILITY, the ability to be rented [n]\n",
  "RENTABILITY": "the ability to be rented [n RENTABILITIES]\n",
  "RENTABLE": "able to be rented [adj]\n",
  "RENTAL": "the amount paid as rent [n -S]\n",
  "RENTALLER": "(Scots) a kindly tenant [n -S]\n",
  "RENTALLERS": "RENTALLER, (Scots) a kindly tenant [n]\n",
  "RENTALS": "RENTAL, the amount paid as rent [n]\n",
  "RENTE": "(French) French or other government securities or income from them [n -S]\n",
  "RENTED": "RENT, to hire [v]\n",
  "RENTER": "one who rents [n -S]\n",
  "RENTERS": "RENTER, one who rents [n]\n",
  "RENTES": "RENTE, (French) French or other government securities or income from them [n]\n",
  "RENTIER": "(French) a person who has, or who lives on, an income from rents or investments [n -S]\n",
  "RENTIERS": "RENTIER, (French) a person who has, or who lives on, an income from rents or investments [n]\n",
  "RENTING": "the act of renting [n -S]\n",
  "RENTINGS": "RENTING, the act of renting [n]\n",
  "RENTS": "RENT, to hire [v]\n",
  "RENUMBER": "to number again [v -ED, -ING, -S]\n",
  "RENUMBERED": "RENUMBER, to number again [v]\n",
  "RENUMBERING": "RENUMBER, to number again [v]\n",
  "RENUMBERS": "RENUMBER, to number again [v]\n",
  "RENUNCIATE": "a religious devotee who gives up earthly pleasures to live as an ascetic [n -S]\n",
  "RENUNCIATES": "RENUNCIATE, a religious devotee who gives up earthly pleasures to live as an ascetic [n]\n",
  "RENUNCIATION": "the act or practice of renouncing [n -S]\n",
  "RENUNCIATIONS": "RENUNCIATION, the act or practice of renouncing [n]\n",
  "RENUNCIATIVE": "relating to renunciation [adj]\n",
  "RENUNCIATORY": "relating to renunciation [adj]\n",
  "RENVERSE": "(archaic) to reverse, to upset [v RENVERSED or (Spenser) RENVERST, RENVERSING, RENVERSES]\n",
  "RENVERSED": "RENVERSE, (archaic) to reverse, to upset [v]\n",
  "RENVERSEMENT": "(French) an aeroplane manoeuvre consisting of a half-loop effected simultaneously with a half-turn [n -S]\n",
  "RENVERSEMENTS": "RENVERSEMENT, (French) an aeroplane manoeuvre consisting of a half-loop effected simultaneously with a half-turn [n]\n",
  "RENVERSES": "RENVERSE, (archaic) to reverse, to upset [v]\n",
  "RENVERSING": "RENVERSE, (archaic) to reverse, to upset [v]\n",
  "RENVERST": "RENVERSE, (archaic) to reverse, to upset [v]\n",
  "RENVOI": "(French) a sending back by a government of an alien to his or her own country, also RENVOY [n -S]\n",
  "RENVOIS": "RENVOI, (French) a sending back by a government of an alien to his or her own country, also RENVOY [n]\n",
  "RENVOY": "the sending back by a government of an alien to his or her own country, also RENVOI [n -S]\n",
  "RENVOYS": "RENVOY, the sending back by a government of an alien to his or her own country, also RENVOI [n]\n",
  "RENY": "(obsolete) to renounce, abjure, also RENAY, RENEY [v RENIED, RENYING, RENIES]\n",
  "RENYING": "RENY, (obsolete) to renounce, abjure, also RENAY, RENEY [v]\n",
  "REO": "(Maori) language [n -S]\n",
  "REOBJECT": "to object again [v -ED, -ING, -S]\n",
  "REOBJECTED": "REOBJECT, to object again [v]\n",
  "REOBJECTING": "REOBJECT, to object again [v]\n",
  "REOBJECTS": "REOBJECT, to object again [v]\n",
  "REOBSERVE": "to observe again [v REOBSERVED, REOBSERVING, REOBSERVES]\n",
  "REOBSERVED": "REOBSERVE, to observe again [v]\n",
  "REOBSERVES": "REOBSERVE, to observe again [v]\n",
  "REOBSERVING": "REOBSERVE, to observe again [v]\n",
  "REOBTAIN": "to obtain again [v -ED, -ING, -S]\n",
  "REOBTAINED": "REOBTAIN, to obtain again [v]\n",
  "REOBTAINING": "REOBTAIN, to obtain again [v]\n",
  "REOBTAINS": "REOBTAIN, to obtain again [v]\n",
  "REOCCUPATION": "the act of reoccupying [n -S]\n",
  "REOCCUPATIONS": "REOCCUPATION, the act of reoccupying [n]\n",
  "REOCCUPIED": "REOCCUPY, to occupy again [v]\n",
  "REOCCUPIES": "REOCCUPY, to occupy again [v]\n",
  "REOCCUPY": "to occupy again [v REOCCUPIED, REOCCUPYING, REOCCUPIES]\n",
  "REOCCUPYING": "REOCCUPY, to occupy again [v]\n",
  "REOCCUR": "to occur again [v REOCCURRED, REOCCURRING, REOCCURS]\n",
  "REOCCURRED": "REOCCUR, to occur again [v]\n",
  "REOCCURRENCE": "a repeated occurrence [n -S]\n",
  "REOCCURRENCES": "REOCCURRENCE, a repeated occurrence [n]\n",
  "REOCCURRING": "REOCCUR, to occur again [v]\n",
  "REOCCURS": "REOCCUR, to occur again [v]\n",
  "REOFFEND": "to offend again [v -ED, -ING, -S]\n",
  "REOFFENDED": "REOFFEND, to offend again [v]\n",
  "REOFFENDER": "one who reoffends [n -S]\n",
  "REOFFENDERS": "REOFFENDER, one who reoffends [n]\n",
  "REOFFENDING": "REOFFEND, to offend again [v]\n",
  "REOFFENDS": "REOFFEND, to offend again [v]\n",
  "REOFFER": "to offer for public sale [v -ED, -ING, -S]\n",
  "REOFFERED": "REOFFER, to offer for public sale [v]\n",
  "REOFFERING": "REOFFER, to offer for public sale [v]\n",
  "REOFFERS": "REOFFER, to offer for public sale [v]\n",
  "REOIL": "to oil again [v -ED, -ING, -S]\n",
  "REOILED": "REOIL, to oil again [v]\n",
  "REOILING": "REOIL, to oil again [v]\n",
  "REOILS": "REOIL, to oil again [v]\n",
  "REOPEN": "to open again [v -ED, -ING, -S]\n",
  "REOPENED": "REOPEN, to open again [v]\n",
  "REOPENER": "a clause in a contract for reconsideration [n -S]\n",
  "REOPENERS": "REOPENER, a clause in a contract for reconsideration [n]\n",
  "REOPENING": "the act of opening again [n -S]\n",
  "REOPENINGS": "REOPENING, the act of opening again [n]\n",
  "REOPENS": "REOPEN, to open again [v]\n",
  "REOPERATE": "to operate again [v REOPERATED, REOPERATING, REOPERATES]\n",
  "REOPERATED": "REOPERATE, to operate again [v]\n",
  "REOPERATES": "REOPERATE, to operate again [v]\n",
  "REOPERATING": "REOPERATE, to operate again [v]\n",
  "REOPERATION": "operation again [n -S]\n",
  "REOPERATIONS": "REOPERATION, operation again [n]\n",
  "REOPPOSE": "to oppose again [v REOPPOSED, REOPPOSING, REOPPOSES]\n",
  "REOPPOSED": "REOPPOSE, to oppose again [v]\n",
  "REOPPOSES": "REOPPOSE, to oppose again [v]\n",
  "REOPPOSING": "REOPPOSE, to oppose again [v]\n",
  "REORCHESTRATE": "to orchestrate again [v REORCHESTRATED, REORCHESTRATING, REORCHESTRATES]\n",
  "REORCHESTRATED": "REORCHESTRATE, to orchestrate again [v]\n",
  "REORCHESTRATES": "REORCHESTRATE, to orchestrate again [v]\n",
  "REORCHESTRATING": "REORCHESTRATE, to orchestrate again [v]\n",
  "REORCHESTRATION": "the act of reorchestrating [n]\n",
  "REORDAIN": "to ordain again [v -ED, -ING, -S]\n",
  "REORDAINED": "REORDAIN, to ordain again [v]\n",
  "REORDAINING": "REORDAIN, to ordain again [v]\n",
  "REORDAINS": "REORDAIN, to ordain again [v]\n",
  "REORDER": "to put in a further order [v -ED, -ING, -S]\n",
  "REORDERED": "REORDER, to put in a further order [v]\n",
  "REORDERING": "REORDER, to put in a further order [v]\n",
  "REORDERS": "REORDER, to put in a further order [v]\n",
  "REORDINATION": "the act of reordinating [n -S]\n",
  "REORDINATIONS": "REORDINATION, the act of reordinating [n]\n",
  "REORG": "to reorganize [v -ED, -ING, -S]\n",
  "REORGANISATION": "the process of reorganising, also REORGANIZATION [n -S]\n",
  "REORGANISATIONS": "REORGANISATION, the process of reorganising, also REORGANIZATION [n]\n",
  "REORGANISE": "to organize again, also REORGANIZE [v REORGANISED, REORGANISING, REORGANISES]\n",
  "REORGANISED": "REORGANISE, to organize again, also REORGANIZE [v]\n",
  "REORGANISER": "one who reorganises, also REORGANIZER [n -S]\n",
  "REORGANISERS": "REORGANISER, one who reorganises, also REORGANIZER [n]\n",
  "REORGANISES": "REORGANISE, to organize again, also REORGANIZE [v]\n",
  "REORGANISING": "REORGANISE, to organize again, also REORGANIZE [v]\n",
  "REORGANIZATION": "the act of reorganizing, also REORGANISATION [n -S]\n",
  "REORGANIZATIONS": "REORGANIZATION, the act of reorganizing, also REORGANISATION [n]\n",
  "REORGANIZE": "to organize again, also REORGANISE [v REORGANIZED, REORGANIZING, REORGANIZES]\n",
  "REORGANIZED": "REORGANIZE, to organize again, also REORGANISE [v]\n",
  "REORGANIZER": "one who reorganizes, also REORGANISER [n -S]\n",
  "REORGANIZERS": "REORGANIZER, one who reorganizes, also REORGANISER [n]\n",
  "REORGANIZES": "REORGANIZE, to organize again, also REORGANISE [v]\n",
  "REORGANIZING": "REORGANIZE, to organize again, also REORGANISE [v]\n",
  "REORGED": "REORG, to reorganize [v]\n",
  "REORGING": "REORG, to reorganize [v]\n",
  "REORGS": "REORG, to reorganize [v]\n",
  "REORIENT": "to acquaint oneself again [v -ED, -ING, -S]\n",
  "REORIENTATE": "to orientate again [v REORIENTATED, REORIENTATING, REORIENTATES]\n",
  "REORIENTATED": "REORIENTATE, to orientate again [v]\n",
  "REORIENTATES": "REORIENTATE, to orientate again [v]\n",
  "REORIENTATING": "REORIENTATE, to orientate again [v]\n",
  "REORIENTATION": "the act of reorienting [n -S]\n",
  "REORIENTATIONS": "REORIENTATION, the act of reorienting [n]\n",
  "REORIENTED": "REORIENT, to acquaint oneself again [v]\n",
  "REORIENTING": "REORIENT, to acquaint oneself again [v]\n",
  "REORIENTS": "REORIENT, to acquaint oneself again [v]\n",
  "REOS": "REO, (Maori) language [n]\n",
  "REOUTFIT": "to outfit again [v REOUTFITTED, REOUTFITTING, REOUTFITS]\n",
  "REOUTFITS": "REOUTFIT, to outfit again [v]\n",
  "REOUTFITTED": "REOUTFIT, to outfit again [v]\n",
  "REOUTFITTING": "REOUTFIT, to outfit again [v]\n",
  "REOVIRUS": "a type of virus [n -ES]\n",
  "REOVIRUSES": "REOVIRUS, a type of virus [n]\n",
  "REOXIDATION": "the process of reoxidizing [n -S]\n",
  "REOXIDATIONS": "REOXIDATION, the process of reoxidizing [n]\n",
  "REOXIDISE": "to oxidise again, also REOXIDIZE [v REOXIDISED, REOXIDISING, REOXIDISES]\n",
  "REOXIDISED": "REOXIDISE, to oxidise again, also REOXIDIZE [v]\n",
  "REOXIDISES": "REOXIDISE, to oxidise again, also REOXIDIZE [v]\n",
  "REOXIDISING": "REOXIDISE, to oxidise again, also REOXIDIZE [v]\n",
  "REOXIDIZE": "to oxidize again, also REOXIDISE [v REOXIDIZED, REOXIDIZING, REOXIDIZES]\n",
  "REOXIDIZED": "REOXIDIZE, to oxidize again, also REOXIDISE [v]\n",
  "REOXIDIZES": "REOXIDIZE, to oxidize again, also REOXIDISE [v]\n",
  "REOXIDIZING": "REOXIDIZE, to oxidize again, also REOXIDISE [v]\n",
  "REOXYGENATE": "to oxygenate again [v REOXYGENATED, REOXYGENATING, REOXYGENATES]\n",
  "REOXYGENATED": "REOXYGENATE, to oxygenate again [v]\n",
  "REOXYGENATES": "REOXYGENATE, to oxygenate again [v]\n",
  "REOXYGENATING": "REOXYGENATE, to oxygenate again [v]\n",
  "REP": "to act as a commercial representative [v REPPED, REPPING, REPS]\n",
  "REPACIFIED": "REPACIFY, to pacify again [v]\n",
  "REPACIFIES": "REPACIFY, to pacify again [v]\n",
  "REPACIFY": "to pacify again [v REPACIFIED, REPACIFYING, REPACIFIES]\n",
  "REPACIFYING": "REPACIFY, to pacify again [v]\n",
  "REPACK": "to pack again [v -ED, -ING, -S]\n",
  "REPACKAGE": "to package again [v REPACKAGED, REPACKAGING, REPACKAGES]\n",
  "REPACKAGED": "REPACKAGE, to package again [v]\n",
  "REPACKAGER": "one who repackages [n -S]\n",
  "REPACKAGERS": "REPACKAGER, one who repackages [n]\n",
  "REPACKAGES": "REPACKAGE, to package again [v]\n",
  "REPACKAGING": "REPACKAGE, to package again [v]\n",
  "REPACKED": "REPACK, to pack again [v]\n",
  "REPACKING": "REPACK, to pack again [v]\n",
  "REPACKS": "REPACK, to pack again [v]\n",
  "REPAGINATE": "to paginate again [v REPAGINATED, REPAGINATING, REPAGINATES]\n",
  "REPAGINATED": "REPAGINATE, to paginate again [v]\n",
  "REPAGINATES": "REPAGINATE, to paginate again [v]\n",
  "REPAGINATING": "REPAGINATE, to paginate again [v]\n",
  "REPAGINATION": "the act of repaginating [n -S]\n",
  "REPAGINATIONS": "REPAGINATION, the act of repaginating [n]\n",
  "REPAID": "REPAY, to pay back [v]\n",
  "REPAINT": "to paint again [v -ED, -ING, -S]\n",
  "REPAINTED": "REPAINT, to paint again [v]\n",
  "REPAINTING": "the act of repainting [n -S]\n",
  "REPAINTINGS": "REPAINTING, the act of repainting [n]\n",
  "REPAINTS": "REPAINT, to paint again [v]\n",
  "REPAIR": "to restore to good condition [v -ED, -ING, -S]\n",
  "REPAIRABILITIES": "REPAIRABILITY, the state of being repairable [n]\n",
  "REPAIRABILITY": "the state of being repairable [n REPAIRABILITIES]\n",
  "REPAIRABLE": "that can be repaired [adj]\n",
  "REPAIRED": "REPAIR, to restore to good condition [v]\n",
  "REPAIRER": "one who repairs [n -S]\n",
  "REPAIRERS": "REPAIRER, one who repairs [n]\n",
  "REPAIRING": "REPAIR, to restore to good condition [v]\n",
  "REPAIRMAN": "one whose job is to repair things [n REPAIRMEN]\n",
  "REPAIRMEN": "REPAIRMAN, one whose job is to repair things [n]\n",
  "REPAIRS": "REPAIR, to restore to good condition [v]\n",
  "REPAND": "having a wavy margin [adj REPANDLY]\n",
  "REPANDLY": "REPAND, having a wavy margin [adv]\n",
  "REPANEL": "to panel again [v REPANELED or REPANELLED, REPANELING or REPANELLING, REPANELS]\n",
  "REPANELED": "REPANEL, to panel again [v]\n",
  "REPANELING": "REPANEL, to panel again [v]\n",
  "REPANELLED": "REPANEL, to panel again [v]\n",
  "REPANELLING": "REPANEL, to panel again [v]\n",
  "REPANELS": "REPANEL, to panel again [v]\n",
  "REPAPER": "to apply new paper [v -ED, -ING, -S]\n",
  "REPAPERED": "REPAPER, to apply new paper [v]\n",
  "REPAPERING": "REPAPER, to apply new paper [v]\n",
  "REPAPERS": "REPAPER, to apply new paper [v]\n",
  "REPARABILITIES": "REPARABILITY, the quality of being reparable [n]\n",
  "REPARABILITY": "the quality of being reparable [n REPARABILITIES]\n",
  "REPARABLE": "that can be repaired [adj REPARABLY]\n",
  "REPARABLY": "REPARABLE, that can be repaired [adv]\n",
  "REPARATION": "a repairing or keeping in repair [n -S]\n",
  "REPARATIONS": "REPARATION, a repairing or keeping in repair [n]\n",
  "REPARATIVE": "repairing, or tending to repair [adj]\n",
  "REPARATORY": "related to reparation [adj]\n",
  "REPARK": "to park again [v -ED, -ING, -S]\n",
  "REPARKED": "REPARK, to park again [v]\n",
  "REPARKING": "REPARK, to park again [v]\n",
  "REPARKS": "REPARK, to park again [v]\n",
  "REPARTEE": "to make a quick witty reply [v REPARTEED, REPARTEEING, REPARTEES]\n",
  "REPARTEED": "REPARTEE, to make a quick witty reply [v]\n",
  "REPARTEEING": "REPARTEE, to make a quick witty reply [v]\n",
  "REPARTEES": "REPARTEE, to make a quick witty reply [v]\n",
  "REPARTITION": "to partition again [v -ED, -ING, -S]\n",
  "REPARTITIONED": "REPARTITION, to partition again [v]\n",
  "REPARTITIONING": "REPARTITION, to partition again [v]\n",
  "REPARTITIONS": "REPARTITION, to partition again [v]\n",
  "REPASS": "to pass again [v -ED, -ING, -ES]\n",
  "REPASSAGE": "the act of repassing; passage back [n -S]\n",
  "REPASSAGES": "REPASSAGE, the act of repassing; passage back [n]\n",
  "REPASSED": "REPASS, to pass again [v]\n",
  "REPASSES": "REPASS, to pass again [v]\n",
  "REPASSING": "REPASS, to pass again [v]\n",
  "REPAST": "to partake of a meal [v -ED, -ING, -S]\n",
  "REPASTED": "REPAST, to partake of a meal [v]\n",
  "REPASTING": "REPAST, to partake of a meal [v]\n",
  "REPASTS": "REPAST, to partake of a meal [v]\n",
  "REPASTURE": "(Shakespeare) food [n -S]\n",
  "REPASTURES": "REPASTURE, (Shakespeare) food [n]\n",
  "REPATCH": "to patch again [v -ED, -ING, -ES]\n",
  "REPATCHED": "REPATCH, to patch again [v]\n",
  "REPATCHES": "REPATCH, to patch again [v]\n",
  "REPATCHING": "REPATCH, to patch again [v]\n",
  "REPATRIATE": "to restore to one's own country [v REPATRIATED, REPATRIATING, REPATRIATES]\n",
  "REPATRIATED": "REPATRIATE, to restore to one's own country [v]\n",
  "REPATRIATES": "REPATRIATE, to restore to one's own country [v]\n",
  "REPATRIATING": "REPATRIATE, to restore to one's own country [v]\n",
  "REPATRIATION": "the act of repatriating [n -S]\n",
  "REPATRIATIONS": "REPATRIATION, the act of repatriating [n]\n",
  "REPATRIATOR": "one who repatriates [n -S]\n",
  "REPATRIATORS": "REPATRIATOR, one who repatriates [n]\n",
  "REPATTERN": "to pattern again [v -ED, -ING, -S]\n",
  "REPATTERNED": "REPATTERN, to pattern again [v]\n",
  "REPATTERNING": "REPATTERN, to pattern again [v]\n",
  "REPATTERNS": "REPATTERN, to pattern again [v]\n",
  "REPAVE": "to pave again [v REPAVED, REPAVING, REPAVES]\n",
  "REPAVED": "REPAVE, to pave again [v]\n",
  "REPAVES": "REPAVE, to pave again [v]\n",
  "REPAVING": "REPAVE, to pave again [v]\n",
  "REPAY": "to pay back [v REPAID, REPAYING, REPAYS]\n",
  "REPAYABLE": "capable of being repaid [adj]\n",
  "REPAYING": "REPAY, to pay back [v]\n",
  "REPAYMENT": "the act of paying back [n -S]\n",
  "REPAYMENTS": "REPAYMENT, the act of paying back [n]\n",
  "REPAYS": "REPAY, to pay back [v]\n",
  "REPEAL": "to revoke [v -ED, -ING, -S]\n",
  "REPEALABLE": "capable of being repealed [adj]\n",
  "REPEALED": "REPEAL, to revoke [v]\n",
  "REPEALER": "one who repeals [n -S]\n",
  "REPEALERS": "REPEALER, one who repeals [n]\n",
  "REPEALING": "REPEAL, to revoke [v]\n",
  "REPEALS": "REPEAL, to revoke [v]\n",
  "REPEAT": "to say or do again [v -ED, -ING, -S]\n",
  "REPEATABILITIES": "REPEATABILITY, the state of being repeatable [n]\n",
  "REPEATABILITY": "the state of being repeatable [n REPEATABILITIES]\n",
  "REPEATABLE": "that can be repeated [adj]\n",
  "REPEATED": "REPEAT, to say or do again [v]\n",
  "REPEATEDLY": "REPEATED, REPEAT, to say or do again [adv]\n",
  "REPEATER": "one who repeats [n -S]\n",
  "REPEATERS": "REPEATER, one who repeats [n]\n",
  "REPEATING": "the act of repeating [n -S]\n",
  "REPEATINGS": "REPEATING, the act of repeating [n]\n",
  "REPEATS": "REPEAT, to say or do again [v]\n",
  "REPECHAGE": "(French) a supplementary heat or competition giving eliminated competitors the chance of competing again to reach the final [n -S]\n",
  "REPECHAGES": "REPECHAGE, (French) a supplementary heat or competition giving eliminated competitors the chance of competing again to reach the final [n]\n",
  "REPEG": "to peg again [v REPEGGED, REPEGGING, REPEGS]\n",
  "REPEGGED": "REPEG, to peg again [v]\n",
  "REPEGGING": "REPEG, to peg again [v]\n",
  "REPEGS": "REPEG, to peg again [v]\n",
  "REPEL": "to drive back [v REPELLED, REPELLING, REPELS]\n",
  "REPELLANCE": "the act of repelling, also REPELLANCY [n -S]\n",
  "REPELLANCES": "REPELLANCE, the act of repelling, also REPELLANCY [n]\n",
  "REPELLANCIES": "REPELLANCY, the act of repelling, also REPELLANCE [n]\n",
  "REPELLANCY": "the act of repelling, also REPELLANCE [n REPELLANCIES]\n",
  "REPELLANT": "serving to repel, also REPELLENT [adj REPELLANTLY] / something that repels [n -S]\n",
  "REPELLANTLY": "REPELLANT, serving to repel, also REPELLENT [adv]\n",
  "REPELLANTS": "REPELLANT, something that repels [n]\n",
  "REPELLED": "REPEL, to drive back [v]\n",
  "REPELLENCE": "the principle of repulsion, also REPELLENCY [n -S]\n",
  "REPELLENCES": "REPELLENCE, the principle of repulsion, also REPELLENCY [n]\n",
  "REPELLENCIES": "REPELLENCY, the principle of repulsion, also REPELLENCE [n]\n",
  "REPELLENCY": "the principle of repulsion, also REPELLENCE [n REPELLENCIES]\n",
  "REPELLENT": "serving to repel, also REPELLANT [adj REPELLENTLY] / something that repels [n -S]\n",
  "REPELLENTLY": "REPELLENT, serving to repel, also REPELLANT [adv]\n",
  "REPELLENTS": "REPELLENT, something that repels [n]\n",
  "REPELLER": "one who, or that which, repels [n -S]\n",
  "REPELLERS": "REPELLER, one who, or that which, repels [n]\n",
  "REPELLING": "REPEL, to drive back [v]\n",
  "REPELLINGLY": "REPELLING, REPEL, to drive back [adv]\n",
  "REPELS": "REPEL, to drive back [v]\n",
  "REPENT": "to regret and be sorry for a past action [v -ED, -ING, -S]\n",
  "REPENTANCE": "the act of repenting [n -S]\n",
  "REPENTANCES": "REPENTANCE, the act of repenting [n]\n",
  "REPENTANT": "penitent [adj REPENTANTLY] / a penitent [n -S]\n",
  "REPENTANTLY": "REPENTANT, penitent [adv]\n",
  "REPENTANTS": "REPENTANT, a penitent [n]\n",
  "REPENTED": "REPENT, to regret and be sorry for a past action [v]\n",
  "REPENTER": "one who repents [n -S]\n",
  "REPENTERS": "REPENTER, one who repents [n]\n",
  "REPENTING": "REPENT, to regret and be sorry for a past action [v]\n",
  "REPENTINGLY": "REPENTING, REPENT, to regret and be sorry for a past action [adv]\n",
  "REPENTS": "REPENT, to regret and be sorry for a past action [v]\n",
  "REPEOPLE": "to supply with people again [v REPEOPLED, REPEOPLING, REPEOPLES]\n",
  "REPEOPLED": "REPEOPLE, to supply with people again [v]\n",
  "REPEOPLES": "REPEOPLE, to supply with people again [v]\n",
  "REPEOPLING": "REPEOPLE, to supply with people again [v]\n",
  "REPERCUSS": "to reverberate, have consequences [v -ED, -ING, -ES]\n",
  "REPERCUSSED": "REPERCUSS, to reverberate, have consequences [v]\n",
  "REPERCUSSES": "REPERCUSS, to reverberate, have consequences [v]\n",
  "REPERCUSSING": "REPERCUSS, to reverberate, have consequences [v]\n",
  "REPERCUSSION": "a reflection, reverberation [n -S]\n",
  "REPERCUSSIONS": "REPERCUSSION, a reflection, reverberation [n]\n",
  "REPERCUSSIVE": "having repercussions; reverberating or reverberated [adj]\n",
  "REPEREPE": "(Maori) the elephant fish, a large fish of the Pacific with a trunk-like snout [n -S]\n",
  "REPEREPES": "REPEREPE, (Maori) the elephant fish, a large fish of the Pacific with a trunk-like snout [n]\n",
  "REPERK": "to brew again [v -ED, -ING, -S]\n",
  "REPERKED": "REPERK, to brew again [v]\n",
  "REPERKING": "REPERK, to brew again [v]\n",
  "REPERKS": "REPERK, to brew again [v]\n",
  "REPERTOIRE": "(French) a stock of dramatic parts, tunes, songs, etc. which a performer or company knows or is prepared to perform [n -S]\n",
  "REPERTOIRES": "REPERTOIRE, (French) a stock of dramatic parts, tunes, songs, etc. which a performer or company knows or is prepared to perform [n]\n",
  "REPERTORIAL": "relating to repertory [adj]\n",
  "REPERTORIES": "REPERTORY, the performance of plays, operas, ballets, etc. by a company at regular short intervals [n]\n",
  "REPERTORY": "the performance of plays, operas, ballets, etc. by a company at regular short intervals [n REPERTORIES]\n",
  "REPERUSAL": "a second or repeated perusal [n -S]\n",
  "REPERUSALS": "REPERUSAL, a second or repeated perusal [n]\n",
  "REPERUSE": "to peruse again [v REPERUSED, REPERUSING, REPERUSES]\n",
  "REPERUSED": "REPERUSE, to peruse again [v]\n",
  "REPERUSES": "REPERUSE, to peruse again [v]\n",
  "REPERUSING": "REPERUSE, to peruse again [v]\n",
  "REPETEND": "a phrase or sound that is repeated [n -S]\n",
  "REPETENDS": "REPETEND, a phrase or sound that is repeated [n]\n",
  "REPETITEUR": "(French) a coach, tutor; one who rehearses opera singers [n -S]\n",
  "REPETITEURS": "REPETITEUR, (French) a coach, tutor; one who rehearses opera singers [n]\n",
  "REPETITEUSE": "a female repetiteur, one who rehearses opera singers [n -S]\n",
  "REPETITEUSES": "REPETITEUSE, a female repetiteur, one who rehearses opera singers [n]\n",
  "REPETITION": "the act of repeating [n -S]\n",
  "REPETITIONAL": "relating to repetition [adj]\n",
  "REPETITIONARY": "of the nature of, or characterized by, repetition [adj]\n",
  "REPETITIONS": "REPETITION, the act of repeating [n]\n",
  "REPETITIOUS": "characterized or marked by repetition [adj REPETITIOUSLY]\n",
  "REPETITIOUSLY": "REPETITIOUS, characterized or marked by repetition [adv]\n",
  "REPETITIOUSNESS": "REPETITIOUS, characterized or marked by repetition [n]\n",
  "REPETITIVE": "showing repetition [adj REPETITIVELY]\n",
  "REPETITIVELY": "REPETITIVE, showing repetition [adv]\n",
  "REPETITIVENESS": "REPETITIVE, showing repetition [n]\n",
  "REPHOTOGRAPH": "to photograph again [v -ED, -ING, -S]\n",
  "REPHOTOGRAPHED": "REPHOTOGRAPH, to photograph again [v]\n",
  "REPHOTOGRAPHING": "REPHOTOGRAPH, to photograph again [v]\n",
  "REPHOTOGRAPHS": "REPHOTOGRAPH, to photograph again [v]\n",
  "REPHRASE": "to say or repeat in a different way [v REPHRASED, REPHRASING, REPHRASES]\n",
  "REPHRASED": "REPHRASE, to say or repeat in a different way [v]\n",
  "REPHRASES": "REPHRASE, to say or repeat in a different way [v]\n",
  "REPHRASING": "the act of phrasing again [n -S]\n",
  "REPHRASINGS": "REPHRASING, the act of phrasing again [n]\n",
  "REPIGMENT": "to pigment again [v -ED, -ING, -S]\n",
  "REPIGMENTED": "REPIGMENT, to pigment again [v]\n",
  "REPIGMENTING": "REPIGMENT, to pigment again [v]\n",
  "REPIGMENTS": "REPIGMENT, to pigment again [v]\n",
  "REPIN": "to pin again [v REPINNED, REPINNING, REPINS]\n",
  "REPINE": "to express discontent [v REPINED, REPINING, REPINES]\n",
  "REPINED": "REPINE, to express discontent [v]\n",
  "REPINEMENT": "the act of repining [n -S]\n",
  "REPINEMENTS": "REPINEMENT, the act of repining [n]\n",
  "REPINER": "one who repines [n -S]\n",
  "REPINERS": "REPINER, one who repines [n]\n",
  "REPINES": "REPINE, to express discontent [v]\n",
  "REPINING": "the act of repining [n -S]\n",
  "REPININGLY": "REPINING [adv]\n",
  "REPININGS": "REPINING, the act of repining [n]\n",
  "REPINNED": "REPIN, to pin again [v]\n",
  "REPINNING": "REPIN, to pin again [v]\n",
  "REPINS": "REPIN, to pin again [v]\n",
  "REPIQUE": "(French) to score in a game of piquet [v REPIQUED, REPIQUING, REPIQUES]\n",
  "REPIQUED": "REPIQUE, (French) to score in a game of piquet [v]\n",
  "REPIQUES": "REPIQUE, (French) to score in a game of piquet [v]\n",
  "REPIQUING": "REPIQUE, (French) to score in a game of piquet [v]\n",
  "REPLA": "REPLUM, (Latin) a partition in fruit [n]\n",
  "REPLACE": "to put back or supply a substitute [v REPLACED, REPLACING, REPLACES]\n",
  "REPLACEABILITY": "the quality of being replaceable [n]\n",
  "REPLACEABLE": "that can be replaced [adj]\n",
  "REPLACED": "REPLACE, to put back or supply a substitute [v]\n",
  "REPLACEMENT": "the act of replacing [n -S]\n",
  "REPLACEMENTS": "REPLACEMENT, the act of replacing [n]\n",
  "REPLACER": "one who replaces [n -S]\n",
  "REPLACERS": "REPLACER, one who replaces [n]\n",
  "REPLACES": "REPLACE, to put back or supply a substitute [v]\n",
  "REPLACING": "REPLACE, to put back or supply a substitute [v]\n",
  "REPLAN": "to plan again [v REPLANNED, REPLANNING, REPLANS]\n",
  "REPLANNED": "REPLAN, to plan again [v]\n",
  "REPLANNING": "REPLAN, to plan again [v]\n",
  "REPLANS": "REPLAN, to plan again [v]\n",
  "REPLANT": "to plant again [v -ED, -ING, -S]\n",
  "REPLANTATION": "reattachment or reinsertion of a bodily part (as a limb or tooth) after separation from the body [n -S]\n",
  "REPLANTATIONS": "REPLANTATION, reattachment or reinsertion of a bodily part (as a limb or tooth) after separation from the body [n]\n",
  "REPLANTED": "REPLANT, to plant again [v]\n",
  "REPLANTING": "REPLANT, to plant again [v]\n",
  "REPLANTS": "REPLANT, to plant again [v]\n",
  "REPLASTER": "to plaster again [v -ED, -ING, -S]\n",
  "REPLASTERED": "REPLASTER, to plaster again [v]\n",
  "REPLASTERING": "REPLASTER, to plaster again [v]\n",
  "REPLASTERS": "REPLASTER, to plaster again [v]\n",
  "REPLATE": "to plate again [v REPLATED, REPLATING, REPLATES]\n",
  "REPLATED": "REPLATE, to plate again [v]\n",
  "REPLATES": "REPLATE, to plate again [v]\n",
  "REPLATING": "REPLATE, to plate again [v]\n",
  "REPLAY": "to play again [v -ED, -ING, -S]\n",
  "REPLAYED": "REPLAY, to play again [v]\n",
  "REPLAYING": "REPLAY, to play again [v]\n",
  "REPLAYS": "REPLAY, to play again [v]\n",
  "REPLEAD": "to plead again [v REPLEADED, REPLED, REPLEADING, REPLEADS]\n",
  "REPLEADED": "REPLEAD, to plead again [v]\n",
  "REPLEADER": "a second pleading, or course of pleadings; also, the right of pleading again [n -S]\n",
  "REPLEADERS": "REPLEADER, a second pleading, or course of pleadings; also, the right of pleading again [n]\n",
  "REPLEADING": "REPLEAD, to plead again [v]\n",
  "REPLEADS": "REPLEAD, to plead again [v]\n",
  "REPLED": "REPLEAD, to plead again [v]\n",
  "REPLEDGE": "to pledge again [v REPLEDGED, REPLEDGING, REPLEDGES]\n",
  "REPLEDGED": "REPLEDGE, to pledge again [v]\n",
  "REPLEDGES": "REPLEDGE, to pledge again [v]\n",
  "REPLEDGING": "REPLEDGE, to pledge again [v]\n",
  "REPLENISH": "to fill again, also PLENISH [v -ED, -ING, -ES]\n",
  "REPLENISHABLE": "capable of being replenished [adj]\n",
  "REPLENISHED": "REPLENISH, to fill again, also PLENISH [v]\n",
  "REPLENISHER": "one who replenishes [n -S]\n",
  "REPLENISHERS": "REPLENISHER, one who replenishes [n]\n",
  "REPLENISHES": "REPLENISH, to fill again, also PLENISH [v]\n",
  "REPLENISHING": "REPLENISH, to fill again, also PLENISH [v]\n",
  "REPLENISHMENT": "the act of replenishing [n -S]\n",
  "REPLENISHMENTS": "REPLENISHMENT, the act of replenishing [n]\n",
  "REPLETE": "full [adj REPLETELY] / to fill completely [v REPLETED, REPLETING, REPLETES]\n",
  "REPLETED": "REPLETE, to fill completely [v]\n",
  "REPLETELY": "REPLETE, full [adv]\n",
  "REPLETENESS": "the state of being replete [n -ES]\n",
  "REPLETENESSES": "REPLETENESS, the state of being replete [n]\n",
  "REPLETES": "REPLETE, to fill completely [v]\n",
  "REPLETING": "REPLETE, to fill completely [v]\n",
  "REPLETION": "the state of being replete [n -S]\n",
  "REPLETIONS": "REPLETION, the state of being replete [n]\n",
  "REPLEVIABLE": "subject to replevin, also REPLEVISABLE [adj]\n",
  "REPLEVIED": "REPLEVY, to regain possession by legal action, also REPLEVIN [v]\n",
  "REPLEVIES": "REPLEVY, to regain possession by legal action, also REPLEVIN [v]\n",
  "REPLEVIN": "to regain possession by legal action, also REPLEVY [v -ED, -ING, -S]\n",
  "REPLEVINED": "REPLEVIN, to regain possession by legal action, also REPLEVY [v]\n",
  "REPLEVINING": "REPLEVIN, to regain possession by legal action, also REPLEVY [v]\n",
  "REPLEVINS": "REPLEVIN, to regain possession by legal action, also REPLEVY [v]\n",
  "REPLEVISABLE": "subject to replevin, also REPLEVIABLE [adj]\n",
  "REPLEVY": "to regain possession by legal action, also REPLEVIN [v REPLEVIED, REPLEVYING, REPLEVIES]\n",
  "REPLEVYING": "REPLEVY, to regain possession by legal action, also REPLEVIN [v]\n",
  "REPLICA": "a copy or reproduction [n -S]\n",
  "REPLICABILITIES": "REPLICABILITY, the state of being replicable [n]\n",
  "REPLICABILITY": "the state of being replicable [n REPLICABILITIES]\n",
  "REPLICABLE": "capable of replication [adj]\n",
  "REPLICANT": "(in science fiction) an artificially created or cloned biological creature, esp. in human form [n -S]\n",
  "REPLICANTS": "REPLICANT, (in science fiction) an artificially created or cloned biological creature, esp. in human form [n]\n",
  "REPLICAS": "REPLICA, a copy or reproduction [n]\n",
  "REPLICASE": "a polymerase involved in synthesis of RNA [n -S]\n",
  "REPLICASES": "REPLICASE, a polymerase involved in synthesis of RNA [n]\n",
  "REPLICATE": "to make a replica of [v REPLICATED, REPLICATING, REPLICATES]\n",
  "REPLICATED": "REPLICATE, to make a replica of [v]\n",
  "REPLICATES": "REPLICATE, to make a replica of [v]\n",
  "REPLICATING": "REPLICATE, to make a replica of [v]\n",
  "REPLICATION": "copying, reproduction [n -S]\n",
  "REPLICATIONS": "REPLICATION, copying, reproduction [n]\n",
  "REPLICATIVE": "of, relating to, involved in, or characterized by replication [adj]\n",
  "REPLICATOR": "something or someone that replicates [n -S]\n",
  "REPLICATORS": "REPLICATOR, something or someone that replicates [n]\n",
  "REPLICON": "a part of a DNA molecule replicated from a single origin [n -S]\n",
  "REPLICONS": "REPLICON, a part of a DNA molecule replicated from a single origin [n]\n",
  "REPLIED": "REPLY, to answer [v]\n",
  "REPLIER": "one who replies [n -S]\n",
  "REPLIERS": "REPLIER, one who replies [n]\n",
  "REPLIES": "REPLY, to answer [v]\n",
  "REPLOT": "to plot again [v REPLOTTED, REPLOTTING, REPLOTS]\n",
  "REPLOTS": "REPLOT, to plot again [v]\n",
  "REPLOTTED": "REPLOT, to plot again [v]\n",
  "REPLOTTING": "REPLOT, to plot again [v]\n",
  "REPLOUGH": "to plough again, also REPLOW [v -ED, -ING, -S]\n",
  "REPLOUGHED": "REPLOUGH, to plough again, also REPLOW [v]\n",
  "REPLOUGHING": "REPLOUGH, to plough again, also REPLOW [v]\n",
  "REPLOUGHS": "REPLOUGH, to plough again, also REPLOW [v]\n",
  "REPLOW": "to plow again, also REPLOUGH [v -ED, -ING, -S]\n",
  "REPLOWED": "REPLOW, to plow again, also REPLOUGH [v]\n",
  "REPLOWING": "REPLOW, to plow again, also REPLOUGH [v]\n",
  "REPLOWS": "REPLOW, to plow again, also REPLOUGH [v]\n",
  "REPLUM": "(Latin) a partition in fruit [n REPLA]\n",
  "REPLUMB": "to plumb again [v -ED, -ING, -S]\n",
  "REPLUMBED": "REPLUMB, to plumb again [v]\n",
  "REPLUMBING": "REPLUMB, to plumb again [v]\n",
  "REPLUMBS": "REPLUMB, to plumb again [v]\n",
  "REPLUNGE": "to plunge again [v REPLUNGED, REPLUNGING, REPLUNGES]\n",
  "REPLUNGED": "REPLUNGE, to plunge again [v]\n",
  "REPLUNGES": "REPLUNGE, to plunge again [v]\n",
  "REPLUNGING": "REPLUNGE, to plunge again [v]\n",
  "REPLY": "to answer [v REPLIED, REPLYING, REPLIES]\n",
  "REPLYING": "REPLY, to answer [v]\n",
  "REPO": "(short for) repossession [n -S]\n",
  "REPOINT": "to repair mortar [v -ED, -ING, -S]\n",
  "REPOINTED": "REPOINT, to repair mortar [v]\n",
  "REPOINTING": "the application of new mortar to brickwork [n -S]\n",
  "REPOINTINGS": "REPOINTING, the application of new mortar to brickwork [n]\n",
  "REPOINTS": "REPOINT, to repair mortar [v]\n",
  "REPOLARISATION": "restoration of the difference in charge between the inside and outside of the cell membrane following depolarisation, also REPOLARIZATION [n -S]\n",
  "REPOLARISATIONS": "REPOLARISATION, restoration of the difference in charge between the inside and outside of the cell membrane following depolarisation, also REPOLARIZATION [n]\n",
  "REPOLARISE": "to polarise again, also REPOLARIZE [v REPOLARISED, REPOLARISING, REPOLARISES]\n",
  "REPOLARISED": "REPOLARISE, to polarise again, also REPOLARIZE [v]\n",
  "REPOLARISES": "REPOLARISE, to polarise again, also REPOLARIZE [v]\n",
  "REPOLARISING": "REPOLARISE, to polarise again, also REPOLARIZE [v]\n",
  "REPOLARIZATION": "restoration of the difference in charge between the inside and outside of the cell membrane following depolarization, also REPOLARISATION [n -S]\n",
  "REPOLARIZATIONS": "REPOLARIZATION, restoration of the difference in charge between the inside and outside of the cell membrane following depolarization, also REPOLARISATION [n]\n",
  "REPOLARIZE": "to polarize again, also REPOLARISE [v REPOLARIZED, REPOLARIZING, REPOLARIZES]\n",
  "REPOLARIZED": "REPOLARIZE, to polarize again, also REPOLARISE [v]\n",
  "REPOLARIZES": "REPOLARIZE, to polarize again, also REPOLARISE [v]\n",
  "REPOLARIZING": "REPOLARIZE, to polarize again, also REPOLARISE [v]\n",
  "REPOLISH": "to polish again [v -ED, -ING, -ES]\n",
  "REPOLISHED": "REPOLISH, to polish again [v]\n",
  "REPOLISHES": "REPOLISH, to polish again [v]\n",
  "REPOLISHING": "REPOLISH, to polish again [v]\n",
  "REPOLL": "to poll again [v -ED, -ING, -S]\n",
  "REPOLLED": "REPOLL, to poll again [v]\n",
  "REPOLLING": "REPOLL, to poll again [v]\n",
  "REPOLLS": "REPOLL, to poll again [v]\n",
  "REPOMAN": "one who repossesses unpaid-for goods [n REPOMEN]\n",
  "REPOMEN": "REPOMAN, one who repossesses unpaid-for goods [n]\n",
  "REPONE": "to restore to office [v REPONED, REPONING, REPONES]\n",
  "REPONED": "REPONE, to restore to office [v]\n",
  "REPONES": "REPONE, to restore to office [v]\n",
  "REPONING": "REPONE, to restore to office [v]\n",
  "REPOPULARISE": "to popularise again, also REPOPULARIZE [v REPOPULARISED, REPOPULARISING, REPOPULARISES]\n",
  "REPOPULARISED": "REPOPULARISE, to popularise again, also REPOPULARIZE [v]\n",
  "REPOPULARISES": "REPOPULARISE, to popularise again, also REPOPULARIZE [v]\n",
  "REPOPULARISING": "REPOPULARISE, to popularise again, also REPOPULARIZE [v]\n",
  "REPOPULARIZE": "to popularize again, also REPOPULARISE [v REPOPULARIZED, REPOPULARIZING, REPOPULARIZES]\n",
  "REPOPULARIZED": "REPOPULARIZE, to popularize again, also REPOPULARISE [v]\n",
  "REPOPULARIZES": "REPOPULARIZE, to popularize again, also REPOPULARISE [v]\n",
  "REPOPULARIZING": "REPOPULARIZE, to popularize again, also REPOPULARISE [v]\n",
  "REPOPULATE": "to populate again [v REPOPULATED, REPOPULATING, REPOPULATES]\n",
  "REPOPULATED": "REPOPULATE, to populate again [v]\n",
  "REPOPULATES": "REPOPULATE, to populate again [v]\n",
  "REPOPULATING": "REPOPULATE, to populate again [v]\n",
  "REPOPULATION": "the act of repopulating [n -S]\n",
  "REPOPULATIONS": "REPOPULATION, the act of repopulating [n]\n",
  "REPORT": "to give an account of [v -ED, -ING, -S]\n",
  "REPORTABLE": "worth reporting [adj]\n",
  "REPORTAGE": "reporting [n -S]\n",
  "REPORTAGES": "REPORTAGE, reporting [n]\n",
  "REPORTED": "REPORT, to give an account of [v]\n",
  "REPORTEDLY": "REPORTED, REPORT, to give an account of [adv]\n",
  "REPORTER": "one that reports [n -S]\n",
  "REPORTERS": "REPORTER, one that reports [n]\n",
  "REPORTING": "giving an account of [adj REPORTINGLY] / the act of reporting [n -S]\n",
  "REPORTINGLY": "REPORTING, giving an account of [adv]\n",
  "REPORTINGS": "REPORTING, the act of reporting [n]\n",
  "REPORTORIAL": "relating to the work of a reporter [adj REPORTORIALLY]\n",
  "REPORTORIALLY": "REPORTORIAL, relating to the work of a reporter [adv]\n",
  "REPORTS": "REPORT, to give an account of [v]\n",
  "REPOS": "REPO, (short for) repossession [n]\n",
  "REPOSAL": "the act or state of reposing; as, the reposal of trust, also REPOSALL [n -S]\n",
  "REPOSALL": "(Shakespeare) reposal [n -S]\n",
  "REPOSALLS": "REPOSALL, (Shakespeare) reposal [n]\n",
  "REPOSALS": "REPOSAL, the act or state of reposing; as, the reposal of trust, also REPOSALL [n]\n",
  "REPOSE": "to lie at rest [v REPOSED, REPOSING, REPOSES]\n",
  "REPOSED": "REPOSE, to lie at rest [v]\n",
  "REPOSEDLY": "REPOSED, REPOSE, to lie at rest [adv]\n",
  "REPOSEDNESS": "the state of being reposed [n -ES]\n",
  "REPOSEDNESSES": "REPOSEDNESS, the state of being reposed [n]\n",
  "REPOSEFUL": "restful [adj REPOSEFULLY]\n",
  "REPOSEFULLY": "REPOSEFUL, restful [adv]\n",
  "REPOSEFULNESS": "the state of being reposeful [n -ES]\n",
  "REPOSEFULNESSES": "REPOSEFULNESS, the state of being reposeful [n]\n",
  "REPOSER": "one who reposes [n -S]\n",
  "REPOSERS": "REPOSER, one who reposes [n]\n",
  "REPOSES": "REPOSE, to lie at rest [v]\n",
  "REPOSING": "REPOSE, to lie at rest [v]\n",
  "REPOSIT": "to put away [v -ED, -ING, -S]\n",
  "REPOSITED": "REPOSIT, to put away [v]\n",
  "REPOSITING": "REPOSIT, to put away [v]\n",
  "REPOSITION": "to change the position of [v -ED, -ING, -S]\n",
  "REPOSITIONED": "REPOSITION, to change the position of [v]\n",
  "REPOSITIONING": "REPOSITION, to change the position of [v]\n",
  "REPOSITIONS": "REPOSITION, to change the position of [v]\n",
  "REPOSITOR": "an instrument employed for replacing a displaced organ or part [n -S]\n",
  "REPOSITORIES": "REPOSITORY, a side altar in a Catholic church [n]\n",
  "REPOSITORS": "REPOSITOR, an instrument employed for replacing a displaced organ or part [n]\n",
  "REPOSITORY": "a side altar in a Catholic church [n REPOSITORIES]\n",
  "REPOSITS": "REPOSIT, to put away [v]\n",
  "REPOSSESS": "to possess again [v -ED, -ING, -ES]\n",
  "REPOSSESSED": "REPOSSESS, to possess again [v]\n",
  "REPOSSESSES": "REPOSSESS, to possess again [v]\n",
  "REPOSSESSING": "REPOSSESS, to possess again [v]\n",
  "REPOSSESSION": "the act of repossessing [n -S]\n",
  "REPOSSESSIONS": "REPOSSESSION, the act of repossessing [n]\n",
  "REPOSSESSOR": "one who repossesses [n -S]\n",
  "REPOSSESSORS": "REPOSSESSOR, one who repossesses [n]\n",
  "REPOST": "to post again [v -ED, -ING, -S]\n",
  "REPOSTED": "REPOST, to post again [v]\n",
  "REPOSTING": "REPOST, to post again [v]\n",
  "REPOSTS": "REPOST, to post again [v]\n",
  "REPOSURE": "(Shakespeare) repose [n -S]\n",
  "REPOSURES": "REPOSURE, (Shakespeare) repose [n]\n",
  "REPOT": "to put in a new pot [v REPOTTED, REPOTTING, REPOTS]\n",
  "REPOTS": "REPOT, to put in a new pot [v]\n",
  "REPOTTED": "REPOT, to put in a new pot [v]\n",
  "REPOTTING": "the act of repotting [n -S]\n",
  "REPOTTINGS": "REPOTTING, the act of repotting [n]\n",
  "REPOUR": "to pour again [v -ED, -ING, -S]\n",
  "REPOURED": "REPOUR, to pour again [v]\n",
  "REPOURING": "REPOUR, to pour again [v]\n",
  "REPOURS": "REPOUR, to pour again [v]\n",
  "REPOUSSAGE": "the art of doing repousse work [n -S]\n",
  "REPOUSSAGES": "REPOUSSAGE, the art of doing repousse work [n]\n",
  "REPOUSSE": "(French) a raised design hammered in metal [n -S]\n",
  "REPOUSSES": "REPOUSSE, (French) a raised design hammered in metal [n]\n",
  "REPOUSSOIR": "(French) a figure or object in the foreground of a painted etc. composition intended to draw the viewer's eye in [n -S]\n",
  "REPOUSSOIRS": "REPOUSSOIR, (French) a figure or object in the foreground of a painted etc. composition intended to draw the viewer's eye in [n]\n",
  "REPOWER": "to power again [v -ED, -ING, -S]\n",
  "REPOWERED": "REPOWER, to power again [v]\n",
  "REPOWERING": "REPOWER, to power again [v]\n",
  "REPOWERS": "REPOWER, to power again [v]\n",
  "REPP": "a kind of corded cloth, also REP [n -S]\n",
  "REPPED": "REP, to act as a commercial representative [v]\n",
  "REPPING": "working as a commercial rep [n -S]\n",
  "REPPINGS": "REPPING, working as a commercial rep [n]\n",
  "REPPS": "REPP, a kind of corded cloth, also REP [n]\n",
  "REPREEVE": "(Shakespeare) to delay the execution of, also REPRIVE, REPRYVE [v REPREEVED, REPREEVING, REPREEVES]\n",
  "REPREEVED": "REPREEVE, (Shakespeare) to delay the execution of, also REPRIVE, REPRYVE [v]\n",
  "REPREEVES": "REPREEVE, (Shakespeare) to delay the execution of, also REPRIVE, REPRYVE [v]\n",
  "REPREEVING": "REPREEVE, (Shakespeare) to delay the execution of, also REPRIVE, REPRYVE [v]\n",
  "REPREHEND": "to rebuke [v -ED, -ING, -S]\n",
  "REPREHENDABLE": "that can be reprehended [adj]\n",
  "REPREHENDED": "REPREHEND, to rebuke [v]\n",
  "REPREHENDER": "one who reprehends [n -S]\n",
  "REPREHENDERS": "REPREHENDER, one who reprehends [n]\n",
  "REPREHENDING": "REPREHEND, to rebuke [v]\n",
  "REPREHENDS": "REPREHEND, to rebuke [v]\n",
  "REPREHENSIBLE": "worthy of or deserving reprehension [adj REPREHENSIBLY]\n",
  "REPREHENSIBLY": "REPREHENSIBLE, worthy of or deserving reprehension [adv]\n",
  "REPREHENSION": "the act of reprehending [n -S]\n",
  "REPREHENSIONS": "REPREHENSION, the act of reprehending [n]\n",
  "REPREHENSIVE": "serving to reprehend [adj REPREHENSIVELY]\n",
  "REPREHENSIVELY": "REPREHENSIVE, serving to reprehend [adv]\n",
  "REPREHENSORY": "finding fault with [adj]\n",
  "REPRESENT": "to exhibit the image of; to use, or serve, as a symbol for [v -ED, -ING, -S]\n",
  "REPRESENTABLE": "capable of being represented [adj]\n",
  "REPRESENTAMEN": "the product of representation [n -S]\n",
  "REPRESENTAMENS": "REPRESENTAMEN, the product of representation [n]\n",
  "REPRESENTANT": "a representative [n -S]\n",
  "REPRESENTANTS": "REPRESENTANT, a representative [n]\n",
  "REPRESENTATION": "an artistic likeness or image [n -S]\n",
  "REPRESENTATIONS": "REPRESENTATION, an artistic likeness or image [n]\n",
  "REPRESENTATIVE": "one that represents a constituency as a member of a legislative body [n -S]\n",
  "REPRESENTATIVES": "REPRESENTATIVE, one that represents a constituency as a member of a legislative body [n]\n",
  "REPRESENTED": "REPRESENT, to exhibit the image of; to use, or serve, as a symbol for [v]\n",
  "REPRESENTEE": "a person to whom a representation has been made [n -S]\n",
  "REPRESENTEES": "REPRESENTEE, a person to whom a representation has been made [n]\n",
  "REPRESENTER": "one who represents [n -S]\n",
  "REPRESENTERS": "REPRESENTER, one who represents [n]\n",
  "REPRESENTING": "REPRESENT, to exhibit the image of; to use, or serve, as a symbol for [v]\n",
  "REPRESENTMENT": "the act of representing [n -S]\n",
  "REPRESENTMENTS": "REPRESENTMENT, the act of representing [n]\n",
  "REPRESENTOR": "a person who makes a representation in the course of contractual negotiations [n -S]\n",
  "REPRESENTORS": "REPRESENTOR, a person who makes a representation in the course of contractual negotiations [n]\n",
  "REPRESENTS": "REPRESENT, to exhibit the image of; to use, or serve, as a symbol for [v]\n",
  "REPRESS": "to keep under control [v -ED, -ING, -ES]\n",
  "REPRESSED": "REPRESS, to keep under control [v]\n",
  "REPRESSER": "one who represses, also REPRESSOR [n -S]\n",
  "REPRESSERS": "REPRESSER, one who represses, also REPRESSOR [n]\n",
  "REPRESSES": "REPRESS, to keep under control [v]\n",
  "REPRESSIBILITY": "the state of being repressible [n]\n",
  "REPRESSIBLE": "that can be repressed [adj REPRESSIBLY]\n",
  "REPRESSIBLY": "REPRESSIBLE, that can be repressed [adv]\n",
  "REPRESSING": "REPRESS, to keep under control [v]\n",
  "REPRESSION": "the act of repressing [n -S]\n",
  "REPRESSIONIST": "an advocate of repression [n -S]\n",
  "REPRESSIONISTS": "REPRESSIONIST, an advocate of repression [n]\n",
  "REPRESSIONS": "REPRESSION, the act of repressing [n]\n",
  "REPRESSIVE": "serving to repress [adj REPRESSIVELY]\n",
  "REPRESSIVELY": "REPRESSIVE, serving to repress [adv]\n",
  "REPRESSIVENESS": "the state of being repressive [n]\n",
  "REPRESSOR": "one who represses, also REPRESSER [n -S]\n",
  "REPRESSORS": "REPRESSOR, one who represses, also REPRESSER [n]\n",
  "REPRESSURISE": "to pressurise again, also REPRESSURIZE [v REPRESSURISED, REPRESSURISING, REPRESSURISES]\n",
  "REPRESSURISED": "REPRESSURISE, to pressurise again, also REPRESSURIZE [v]\n",
  "REPRESSURISES": "REPRESSURISE, to pressurise again, also REPRESSURIZE [v]\n",
  "REPRESSURISING": "REPRESSURISE, to pressurise again, also REPRESSURIZE [v]\n",
  "REPRESSURIZE": "to pressurize again, also REPRESSURISE [v REPRESSURIZED, REPRESSURIZING, REPRESSURIZES]\n",
  "REPRESSURIZED": "REPRESSURIZE, to pressurize again, also REPRESSURISE [v]\n",
  "REPRESSURIZES": "REPRESSURIZE, to pressurize again, also REPRESSURISE [v]\n",
  "REPRESSURIZING": "REPRESSURIZE, to pressurize again, also REPRESSURISE [v]\n",
  "REPRICE": "to price again [v REPRICED, REPRICING, REPRICES]\n",
  "REPRICED": "REPRICE, to price again [v]\n",
  "REPRICES": "REPRICE, to price again [v]\n",
  "REPRICING": "REPRICE, to price again [v]\n",
  "REPRIEFE": "(Spenser) reproach, insult [n -S]\n",
  "REPRIEFES": "REPRIEFE, (Spenser) reproach, insult [n]\n",
  "REPRIEVABLE": "that can be reprieved [adj]\n",
  "REPRIEVAL": "a reprieve [n -S]\n",
  "REPRIEVALS": "REPRIEVAL, a reprieve [n]\n",
  "REPRIEVE": "to give a respite to [v REPRIEVED, REPRIEVING, REPRIEVES]\n",
  "REPRIEVED": "REPRIEVE, to give a respite to [v]\n",
  "REPRIEVER": "one who reprieves [n -S]\n",
  "REPRIEVERS": "REPRIEVER, one who reprieves [n]\n",
  "REPRIEVES": "REPRIEVE, to give a respite to [v]\n",
  "REPRIEVING": "REPRIEVE, to give a respite to [v]\n",
  "REPRIMAND": "to scold, censure [v -ED, -ING, -S]\n",
  "REPRIMANDED": "REPRIMAND, to scold, censure [v]\n",
  "REPRIMANDING": "REPRIMAND, to scold, censure [v]\n",
  "REPRIMANDS": "REPRIMAND, to scold, censure [v]\n",
  "REPRIME": "to prime again [v REPRIMED, REPRIMING, REPRIMES]\n",
  "REPRIMED": "REPRIME, to prime again [v]\n",
  "REPRIMES": "REPRIME, to prime again [v]\n",
  "REPRIMING": "REPRIME, to prime again [v]\n",
  "REPRINT": "to print again [v -ED, -ING, -S]\n",
  "REPRINTED": "REPRINT, to print again [v]\n",
  "REPRINTER": "one who reprints [n -S]\n",
  "REPRINTERS": "REPRINTER, one who reprints [n]\n",
  "REPRINTING": "REPRINT, to print again [v]\n",
  "REPRINTS": "REPRINT, to print again [v]\n",
  "REPRISAL": "the act of retaliation [n -S]\n",
  "REPRISALS": "REPRISAL, the act of retaliation [n]\n",
  "REPRISE": "to take back by force, also REPRIZE [v REPRISED, REPRISING, REPRISES]\n",
  "REPRISED": "REPRISE, to take back by force, also REPRIZE [v]\n",
  "REPRISES": "REPRISE, to take back by force, also REPRIZE [v]\n",
  "REPRISING": "REPRISE, to take back by force, also REPRIZE [v]\n",
  "REPRISTINATE": "to revive, restore [v REPRISTINATED, REPRISTINATING, REPRISTINATES]\n",
  "REPRISTINATED": "REPRISTINATE, to revive, restore [v]\n",
  "REPRISTINATES": "REPRISTINATE, to revive, restore [v]\n",
  "REPRISTINATING": "REPRISTINATE, to revive, restore [v]\n",
  "REPRISTINATION": "the act of making pristine again [n -S]\n",
  "REPRISTINATIONS": "REPRISTINATION, the act of making pristine again [n]\n",
  "REPRIVATISATION": "the act of reprivatising, also REPRIVATIZATION [n]\n",
  "REPRIVATISE": "to privatize again, also REPRIVATIZE [v REPRIVATISED, REPRIVATISING, REPRIVATISES]\n",
  "REPRIVATISED": "REPRIVATISE, to privatize again, also REPRIVATIZE [v]\n",
  "REPRIVATISES": "REPRIVATISE, to privatize again, also REPRIVATIZE [v]\n",
  "REPRIVATISING": "REPRIVATISE, to privatize again, also REPRIVATIZE [v]\n",
  "REPRIVATIZATION": "the act of reprivatizing, also REPRIVATISATION [n]\n",
  "REPRIVATIZE": "to privatize again, also REPRIVATISE [v REPRIVATIZED, REPRIVATIZING, REPRIVATIZES]\n",
  "REPRIVATIZED": "REPRIVATIZE, to privatize again, also REPRIVATISE [v]\n",
  "REPRIVATIZES": "REPRIVATIZE, to privatize again, also REPRIVATISE [v]\n",
  "REPRIVATIZING": "REPRIVATIZE, to privatize again, also REPRIVATISE [v]\n",
  "REPRIVE": "(Spenser) to reprieve, also REPREEVE, REPRYVE [v REPRIVED, REPRIVING, REPRIVES]\n",
  "REPRIVED": "REPRIVE, (Spenser) to reprieve, also REPREEVE, REPRYVE [v]\n",
  "REPRIVES": "REPRIVE, (Spenser) to reprieve, also REPREEVE, REPRYVE [v]\n",
  "REPRIVING": "REPRIVE, (Spenser) to reprieve, also REPREEVE, REPRYVE [v]\n",
  "REPRIZE": "(Spenser) to reprise [v REPRIZED, REPRIZING, REPRIZES]\n",
  "REPRIZED": "REPRIZE, (Spenser) to reprise [v]\n",
  "REPRIZES": "REPRIZE, (Spenser) to reprise [v]\n",
  "REPRIZING": "REPRIZE, (Spenser) to reprise [v]\n",
  "REPRO": "(short for) reproduction, a piece of reproduction furniture [n -S]\n",
  "REPROACH": "to find fault with [v -ED, -ING, -ES]\n",
  "REPROACHABLE": "worthy of reproach [adj REPROACHABLY]\n",
  "REPROACHABLY": "REPROACHABLE, worthy of reproach [adv]\n",
  "REPROACHED": "REPROACH, to find fault with [v]\n",
  "REPROACHER": "one who reproaches [n -S]\n",
  "REPROACHERS": "REPROACHER, one who reproaches [n]\n",
  "REPROACHES": "REPROACH, to find fault with [v]\n",
  "REPROACHFUL": "reproving [adj REPROACHFULLY]\n",
  "REPROACHFULLY": "REPROACHFUL, reproving [adv]\n",
  "REPROACHFULNESS": "REPROACHFUL, reproving [n]\n",
  "REPROACHING": "REPROACH, to find fault with [v]\n",
  "REPROACHINGLY": "REPROACHING, REPROACH, to find fault with [adv]\n",
  "REPROACHLESS": "without reproach [adj]\n",
  "REPROBACIES": "REPROBACY, the state of being a reprobate [n]\n",
  "REPROBACY": "the state of being a reprobate [n REPROBACIES]\n",
  "REPROBANCE": "(Shakespeare) reprobation [n -S]\n",
  "REPROBANCES": "REPROBANCE, (Shakespeare) reprobation [n]\n",
  "REPROBATE": "a reprehensible or immoral person [n -S] / to disapprove of [v REPROBATED, REPROBATING, REPROBATES]\n",
  "REPROBATED": "REPROBATE, to disapprove of [v]\n",
  "REPROBATER": "one who reprobates [n -S]\n",
  "REPROBATERS": "REPROBATER, one who reprobates [n]\n",
  "REPROBATES": "REPROBATE, to disapprove of [v]\n",
  "REPROBATING": "REPROBATE, to disapprove of [v]\n",
  "REPROBATION": "the act of reprobating [n -S]\n",
  "REPROBATIONARY": "expressing reprobation [adj]\n",
  "REPROBATIONS": "REPROBATION, the act of reprobating [n]\n",
  "REPROBATIVE": "condemnatory, also REPROBATORY [adj REPROBATIVELY]\n",
  "REPROBATIVELY": "REPROBATIVE, condemnatory, also REPROBATORY [adv]\n",
  "REPROBATOR": "(Scots) in Scots law, an action to prove a witness perjured or biased [n -S]\n",
  "REPROBATORS": "REPROBATOR, (Scots) in Scots law, an action to prove a witness perjured or biased [n]\n",
  "REPROBATORY": "condemnatory, also REPROBATIVE [adj]\n",
  "REPROBE": "to probe again [v REPROBED, REPROBING, REPROBES]\n",
  "REPROBED": "REPROBE, to probe again [v]\n",
  "REPROBES": "REPROBE, to probe again [v]\n",
  "REPROBING": "REPROBE, to probe again [v]\n",
  "REPROCESS": "to process again [v -ED, -ING, -ES]\n",
  "REPROCESSED": "REPROCESS, to process again [v]\n",
  "REPROCESSES": "REPROCESS, to process again [v]\n",
  "REPROCESSING": "as in fuel reprocessing, the processing of nuclear rods after use to remove fission products [n -S]\n",
  "REPROCESSINGS": "REPROCESSING, as in fuel reprocessing, the processing of nuclear rods after use to remove fission products [n]\n",
  "REPRODUCE": "to produce a copy of [v REPRODUCED, REPRODUCING, REPRODUCES]\n",
  "REPRODUCED": "REPRODUCE, to produce a copy of [v]\n",
  "REPRODUCER": "one who reproduces [n -S]\n",
  "REPRODUCERS": "REPRODUCER, one who reproduces [n]\n",
  "REPRODUCES": "REPRODUCE, to produce a copy of [v]\n",
  "REPRODUCIBILITY": "the state of being reproducible [n]\n",
  "REPRODUCIBLE": "that can be reproduced [adj REPRODUCIBLY] / something that can be reproduced [n -S]\n",
  "REPRODUCIBLES": "REPRODUCIBLE, something that can be reproduced [n]\n",
  "REPRODUCIBLY": "REPRODUCIBLE, that can be reproduced [adv]\n",
  "REPRODUCING": "REPRODUCE, to produce a copy of [v]\n",
  "REPRODUCTION": "the manufacture of offspring as part of an organism's life cycle [n -S]\n",
  "REPRODUCTIONS": "REPRODUCTION, the manufacture of offspring as part of an organism's life cycle [n]\n",
  "REPRODUCTIVE": "capable of reproducing [adj REPRODUCTIVELY] / an actual or potential parent [n -S]\n",
  "REPRODUCTIVELY": "REPRODUCTIVE, capable of reproducing [adv]\n",
  "REPRODUCTIVES": "REPRODUCTIVE, an actual or potential parent [n]\n",
  "REPRODUCTIVITY": "the state of being reproductive [n]\n",
  "REPROGRAM": "to program again [v REPROGRAMED or REPROGRAMMED, REPROGRAMING or REPROGRAMMING, REPROGRAMS]\n",
  "REPROGRAMED": "REPROGRAM, to program again [v]\n",
  "REPROGRAMING": "REPROGRAM, to program again [v]\n",
  "REPROGRAMMABLE": "capable of being reprogrammed [adj]\n",
  "REPROGRAMME": "to programme again, also REPROGRAM [v REPROGRAMMED, REPROGRAMMING, REPROGRAMMES]\n",
  "REPROGRAMMED": "REPROGRAM, to program again [v]\n",
  "REPROGRAMMES": "REPROGRAMME, to programme again, also REPROGRAM [v]\n",
  "REPROGRAMMING": "REPROGRAM, to program again [v]\n",
  "REPROGRAMS": "REPROGRAM, to program again [v]\n",
  "REPROGRAPHER": "one who practises reprography [n -S]\n",
  "REPROGRAPHERS": "REPROGRAPHER, one who practises reprography [n]\n",
  "REPROGRAPHIC": "relating to reprography, the reproduction of graphic or typeset material [adj]\n",
  "REPROGRAPHICS": "the reproduction of graphic or typeset material, e.g. by photocopying [n]\n",
  "REPROGRAPHIES": "REPROGRAPHY, the reproduction of graphic or typeset material [n]\n",
  "REPROGRAPHY": "the reproduction of graphic or typeset material [n REPROGRAPHIES]\n",
  "REPROOF": "to make waterproof again [v -ED, -ING, -S]\n",
  "REPROOFED": "REPROOF, to make waterproof again [v]\n",
  "REPROOFING": "REPROOF, to make waterproof again [v]\n",
  "REPROOFS": "REPROOF, to make waterproof again [v]\n",
  "REPROS": "REPRO, (short for) reproduction, a piece of reproduction furniture [n]\n",
  "REPROVABLE": "that can be reproved [adj]\n",
  "REPROVAL": "censure, reproof [n -S]\n",
  "REPROVALS": "REPROVAL, censure, reproof [n]\n",
  "REPROVE": "to rebuke sternly [v REPROVED, REPROVING, REPROVES]\n",
  "REPROVED": "REPROVE, to rebuke sternly [v]\n",
  "REPROVER": "one who, or that which, reproves [n -S]\n",
  "REPROVERS": "REPROVER, one who, or that which, reproves [n]\n",
  "REPROVES": "REPROVE, to rebuke sternly [v]\n",
  "REPROVING": "REPROVE, to rebuke sternly [v]\n",
  "REPROVINGLY": "REPROVING, REPROVE, to rebuke sternly [adv]\n",
  "REPROVISION": "to provision again [v -ED, -ING, -S]\n",
  "REPROVISIONED": "REPROVISION, to provision again [v]\n",
  "REPROVISIONING": "REPROVISION, to provision again [v]\n",
  "REPROVISIONS": "REPROVISION, to provision again [v]\n",
  "REPRYVE": "(Spenser) to reprieve, also REPREEVE, REPRIVE [v REPRYVED, REPRYVING, REPRYVES]\n",
  "REPRYVED": "REPRYVE, (Spenser) to reprieve, also REPREEVE, REPRIVE [v]\n",
  "REPRYVES": "REPRYVE, (Spenser) to reprieve, also REPREEVE, REPRIVE [v]\n",
  "REPRYVING": "REPRYVE, (Spenser) to reprieve, also REPREEVE, REPRIVE [v]\n",
  "REPS": "REP, to act as a commercial representative [v]\n",
  "REPTANT": "creeping or crawling [adj]\n",
  "REPTATION": "the act of squirming along a smooth-walled narrow passage [n -S]\n",
  "REPTATIONS": "REPTATION, the act of squirming along a smooth-walled narrow passage [n]\n",
  "REPTILE": "any of a class of cold-blooded, breathing vertebrates [n -S]\n",
  "REPTILES": "REPTILE, any of a class of cold-blooded, breathing vertebrates [n]\n",
  "REPTILIA": "REPTILIUM, a building for displaying reptiles [n]\n",
  "REPTILIAN": "related to reptiles [adj REPTILIANLY] / a reptile [n -S]\n",
  "REPTILIANLY": "REPTILIAN, related to reptiles [adv]\n",
  "REPTILIANS": "REPTILIAN, a reptile [n]\n",
  "REPTILIFEROUS": "of rock, bearing fossil reptiles [adj]\n",
  "REPTILIFORM": "having the form of a reptile [adj]\n",
  "REPTILIOUS": "like a reptile [adj]\n",
  "REPTILIUM": "a building for displaying reptiles [n REPTILIA]\n",
  "REPTILOID": "reptile-like [adj] / any animal of the Reptilia [n -S]\n",
  "REPTILOIDS": "REPTILOID, any animal of the Reptilia [n]\n",
  "REPUBLIC": "a constitutional form of government [n -S]\n",
  "REPUBLICAN": "one that favors or supports a republican form of government [n -S]\n",
  "REPUBLICANISE": "to make republican, also REPUBLICANIZE [v REPUBLICANISED, REPUBLICANISING, REPUBLICANISES]\n",
  "REPUBLICANISED": "REPUBLICANISE, to make republican, also REPUBLICANIZE [v]\n",
  "REPUBLICANISES": "REPUBLICANISE, to make republican, also REPUBLICANIZE [v]\n",
  "REPUBLICANISING": "REPUBLICANISE, to make republican, also REPUBLICANIZE [v]\n",
  "REPUBLICANISM": "adherence to or sympathy for a republican form of government [n -S]\n",
  "REPUBLICANISMS": "REPUBLICANISM, adherence to or sympathy for a republican form of government [n]\n",
  "REPUBLICANIZE": "to make republican, also REPUBLICANISE [v REPUBLICANIZED, REPUBLICANIZING, REPUBLICANIZES]\n",
  "REPUBLICANIZED": "REPUBLICANIZE, to make republican, also REPUBLICANISE [v]\n",
  "REPUBLICANIZES": "REPUBLICANIZE, to make republican, also REPUBLICANISE [v]\n",
  "REPUBLICANIZING": "REPUBLICANIZE, to make republican, also REPUBLICANISE [v]\n",
  "REPUBLICANS": "REPUBLICAN, one that favors or supports a republican form of government [n]\n",
  "REPUBLICATION": "the act or action of republishing [n -S]\n",
  "REPUBLICATIONS": "REPUBLICATION, the act or action of republishing [n]\n",
  "REPUBLICS": "REPUBLIC, a constitutional form of government [n]\n",
  "REPUBLISH": "to publish again [v -ED, -ING, -ES]\n",
  "REPUBLISHED": "REPUBLISH, to publish again [v]\n",
  "REPUBLISHER": "one who republishes [n -S]\n",
  "REPUBLISHERS": "REPUBLISHER, one who republishes [n]\n",
  "REPUBLISHES": "REPUBLISH, to publish again [v]\n",
  "REPUBLISHING": "REPUBLISH, to publish again [v]\n",
  "REPUDIABLE": "admitting of repudiation [adj]\n",
  "REPUDIATE": "to cast off, disown [v REPUDIATED, REPUDIATING, REPUDIATES]\n",
  "REPUDIATED": "REPUDIATE, to cast off, disown [v]\n",
  "REPUDIATES": "REPUDIATE, to cast off, disown [v]\n",
  "REPUDIATING": "REPUDIATE, to cast off, disown [v]\n",
  "REPUDIATION": "the act of repudiating [n -S]\n",
  "REPUDIATIONIST": "a person who favours repudiation of public debt [n -S]\n",
  "REPUDIATIONISTS": "REPUDIATIONIST, a person who favours repudiation of public debt [n]\n",
  "REPUDIATIONS": "REPUDIATION, the act of repudiating [n]\n",
  "REPUDIATIVE": "serving to repudiate [adj]\n",
  "REPUDIATOR": "one who repudiates [n -S]\n",
  "REPUDIATORS": "REPUDIATOR, one who repudiates [n]\n",
  "REPUGN": "to fight against; to oppose [v -ED, -ING, -S]\n",
  "REPUGNANCE": "strong dislike, antipathy, also REPUGNANCY [n -S]\n",
  "REPUGNANCES": "REPUGNANCE, strong dislike, antipathy, also REPUGNANCY [n]\n",
  "REPUGNANCIES": "REPUGNANCY, strong dislike, antipathy, also REPUGNANCE [n]\n",
  "REPUGNANCY": "strong dislike, antipathy, also REPUGNANCE [n REPUGNANCIES]\n",
  "REPUGNANT": "distasteful, odious [adj REPUGNANTLY]\n",
  "REPUGNANTLY": "REPUGNANT, distasteful, odious [adv]\n",
  "REPUGNED": "REPUGN, to fight against; to oppose [v]\n",
  "REPUGNING": "REPUGN, to fight against; to oppose [v]\n",
  "REPUGNS": "REPUGN, to fight against; to oppose [v]\n",
  "REPULP": "to pulp again [v -ED, -ING, -S]\n",
  "REPULPED": "REPULP, to pulp again [v]\n",
  "REPULPING": "REPULP, to pulp again [v]\n",
  "REPULPS": "REPULP, to pulp again [v]\n",
  "REPULSE": "to drive back [v REPULSED, REPULSING, REPULSES]\n",
  "REPULSED": "REPULSE, to drive back [v]\n",
  "REPULSER": "one who repulses [n -S]\n",
  "REPULSERS": "REPULSER, one who repulses [n]\n",
  "REPULSES": "REPULSE, to drive back [v]\n",
  "REPULSING": "REPULSE, to drive back [v]\n",
  "REPULSION": "the act of repulsing, or the state of being repulsed [n -S]\n",
  "REPULSIONS": "REPULSION, the act of repulsing, or the state of being repulsed [n]\n",
  "REPULSIVE": "that repels [adj REPULSIVELY]\n",
  "REPULSIVELY": "REPULSIVE, that repels [adv]\n",
  "REPULSIVENESS": "the state of being repulsive [n -ES]\n",
  "REPULSIVENESSES": "REPULSIVENESS, the state of being repulsive [n]\n",
  "REPUMP": "to pump again [v -ED, -ING, -S]\n",
  "REPUMPED": "REPUMP, to pump again [v]\n",
  "REPUMPING": "REPUMP, to pump again [v]\n",
  "REPUMPS": "REPUMP, to pump again [v]\n",
  "REPUNCTUATION": "the act of punctuating again [n -S]\n",
  "REPUNCTUATIONS": "REPUNCTUATION, the act of punctuating again [n]\n",
  "REPUNIT": "a number of two or more identical integers [n -S]\n",
  "REPUNITS": "REPUNIT, a number of two or more identical integers [n]\n",
  "REPURCHASE": "to buy back or again [v REPURCHASED, REPURCHASING, REPURCHASES]\n",
  "REPURCHASED": "REPURCHASE, to buy back or again [v]\n",
  "REPURCHASES": "REPURCHASE, to buy back or again [v]\n",
  "REPURCHASING": "REPURCHASE, to buy back or again [v]\n",
  "REPURE": "to purify again, also REPURIFY [v REPURED, REPURING, REPURES]\n",
  "REPURED": "REPURE, to purify again, also REPURIFY [v]\n",
  "REPURES": "REPURE, to purify again, also REPURIFY [v]\n",
  "REPURIFIED": "REPURIFY, to purify again [v]\n",
  "REPURIFIES": "REPURIFY, to purify again [v]\n",
  "REPURIFY": "to purify again [v REPURIFIED, REPURIFYING, REPURIFIES]\n",
  "REPURIFYING": "REPURIFY, to purify again [v]\n",
  "REPURING": "REPURE, to purify again, also REPURIFY [v]\n",
  "REPURPOSE": "to purpose anew [v REPURPOSED, REPURPOSING, REPURPOSES]\n",
  "REPURPOSED": "REPURPOSE, to purpose anew [v]\n",
  "REPURPOSES": "REPURPOSE, to purpose anew [v]\n",
  "REPURPOSING": "REPURPOSE, to purpose anew [v]\n",
  "REPURSUE": "to pursue again [v REPURSUED, REPURSUING, REPURSUES]\n",
  "REPURSUED": "REPURSUE, to pursue again [v]\n",
  "REPURSUES": "REPURSUE, to pursue again [v]\n",
  "REPURSUING": "REPURSUE, to pursue again [v]\n",
  "REPUTABILITIES": "REPUTABILITY, the state of being reputable [n]\n",
  "REPUTABILITY": "the state of being reputable [n REPUTABILITIES]\n",
  "REPUTABLE": "of good repute [adj REPUTABLY]\n",
  "REPUTABLY": "REPUTABLE, of good repute [adv]\n",
  "REPUTATION": "overall quality or character as seen or judged by people in general [n -S]\n",
  "REPUTATIONAL": "relating to reputation [adj]\n",
  "REPUTATIONLESS": "without a reputation [adj]\n",
  "REPUTATIONS": "REPUTATION, overall quality or character as seen or judged by people in general [n]\n",
  "REPUTATIVE": "reputed, putative [adj REPUTATIVELY]\n",
  "REPUTATIVELY": "REPUTATIVE, reputed, putative [adv]\n",
  "REPUTE": "to consider to be as specified [v REPUTED, REPUTING, REPUTES]\n",
  "REPUTED": "REPUTE, to consider to be as specified [v]\n",
  "REPUTEDLY": "REPUTED, REPUTE, to consider to be as specified [adv]\n",
  "REPUTELESS": "(Shakespeare) without good repute [adj]\n",
  "REPUTES": "REPUTE, to consider to be as specified [v]\n",
  "REPUTING": "(Shakespeare) pluming oneself [n -S]\n",
  "REPUTINGS": "REPUTING, (Shakespeare) pluming oneself [n]\n",
  "REQUALIFIED": "REQUALIFY, to qualify again [v]\n",
  "REQUALIFIES": "REQUALIFY, to qualify again [v]\n",
  "REQUALIFY": "to qualify again [v REQUALIFIED, REQUALIFYING, REQUALIFIES]\n",
  "REQUALIFYING": "REQUALIFY, to qualify again [v]\n",
  "REQUERE": "(Spenser) to require [v REQUERED, REQUERING, REQUERES]\n",
  "REQUERED": "REQUERE, (Spenser) to require [v]\n",
  "REQUERES": "REQUERE, (Spenser) to require [v]\n",
  "REQUERING": "REQUERE, (Spenser) to require [v]\n",
  "REQUEST": "to ask for [v -ED, -ING, -S]\n",
  "REQUESTED": "REQUEST, to ask for [v]\n",
  "REQUESTER": "one who requests, also REQUESTOR [n -S]\n",
  "REQUESTERS": "REQUESTER, one who requests, also REQUESTOR [n]\n",
  "REQUESTING": "REQUEST, to ask for [v]\n",
  "REQUESTOR": "one who requests, also REQUESTER [n -S]\n",
  "REQUESTORS": "REQUESTOR, one who requests, also REQUESTER [n]\n",
  "REQUESTS": "REQUEST, to ask for [v]\n",
  "REQUICKEN": "(Shakespeare) to give new life to [v -ED, -ING, -S]\n",
  "REQUICKENED": "REQUICKEN, (Shakespeare) to give new life to [v]\n",
  "REQUICKENING": "REQUICKEN, (Shakespeare) to give new life to [v]\n",
  "REQUICKENS": "REQUICKEN, (Shakespeare) to give new life to [v]\n",
  "REQUIEM": "(Latin) a musical composition for the dead [n -S]\n",
  "REQUIEMS": "REQUIEM, (Latin) a musical composition for the dead [n]\n",
  "REQUIESCAT": "a prayer for the dead [n -S]\n",
  "REQUIESCATS": "REQUIESCAT, a prayer for the dead [n]\n",
  "REQUIGHT": "(Spenser) to requite, also REQUIT, REQUITE [v -ED, -ING, -S]\n",
  "REQUIGHTED": "REQUIGHT, (Spenser) to requite, also REQUIT, REQUITE [v]\n",
  "REQUIGHTING": "REQUIGHT, (Spenser) to requite, also REQUIT, REQUITE [v]\n",
  "REQUIGHTS": "REQUIGHT, (Spenser) to requite, also REQUIT, REQUITE [v]\n",
  "REQUIN": "(French) the man-eater, or white shark, so called on account of its causing requiems to be sung [n -S]\n",
  "REQUINS": "REQUIN, (French) the man-eater, or white shark, so called on account of its causing requiems to be sung [n]\n",
  "REQUINTO": "a small guitar [n -S]\n",
  "REQUINTOS": "REQUINTO, a small guitar [n]\n",
  "REQUIRABLE": "capable of being required [adj]\n",
  "REQUIRE": "to have need of [v REQUIRED, REQUIRING, REQUIRES]\n",
  "REQUIRED": "REQUIRE, to have need of [v]\n",
  "REQUIREMENT": "something required [n -S]\n",
  "REQUIREMENTS": "REQUIREMENT, something required [n]\n",
  "REQUIRER": "one who requires [n -S]\n",
  "REQUIRERS": "REQUIRER, one who requires [n]\n",
  "REQUIRES": "REQUIRE, to have need of [v]\n",
  "REQUIRING": "the act of requiring [n -S]\n",
  "REQUIRINGS": "REQUIRING, the act of requiring [n]\n",
  "REQUISITE": "required [adj REQUISITELY] / something necessary [n -S]\n",
  "REQUISITELY": "REQUISITE, required [adv]\n",
  "REQUISITENESS": "the state of being requisite [n -ES]\n",
  "REQUISITENESSES": "REQUISITENESS, the state of being requisite [n]\n",
  "REQUISITES": "REQUISITE, something necessary [n]\n",
  "REQUISITION": "a demand for supplies [n -S] / to make a demand for supplies [v -ED, -ING, -S]\n",
  "REQUISITIONARY": "of the nature of a requisition [adj]\n",
  "REQUISITIONED": "REQUISITION, to make a demand for supplies [v]\n",
  "REQUISITIONING": "REQUISITION, to make a demand for supplies [v]\n",
  "REQUISITIONIST": "a person who makes a requisition [n -S]\n",
  "REQUISITIONISTS": "REQUISITIONIST, a person who makes a requisition [n]\n",
  "REQUISITIONS": "REQUISITION, to make a demand for supplies [v]\n",
  "REQUISITOR": "one who makes requisition; esp. one authorized by a requisition to investigate facts [n -S]\n",
  "REQUISITORIES": "REQUISITORY, in law, a demand made by a prosecutor that a sentence be passed on an accused, giving the reasons [n]\n",
  "REQUISITORS": "REQUISITOR, one who makes requisition; esp. one authorized by a requisition to investigate facts [n]\n",
  "REQUISITORY": "in law, a demand made by a prosecutor that a sentence be passed on an accused, giving the reasons [n REQUISITORIES]\n",
  "REQUIT": "(Shakespeare) to repay, also REQUIGHT [v REQUITTED, REQUITTING, REQUITS]\n",
  "REQUITABLE": "that may be requited [adj]\n",
  "REQUITAL": "payment in return [n -S]\n",
  "REQUITALS": "REQUITAL, payment in return [n]\n",
  "REQUITE": "to repay [v REQUITED, REQUITING, REQUITES]\n",
  "REQUITED": "REQUITE, to repay [v]\n",
  "REQUITEFUL": "relating to the act of requiting [adj]\n",
  "REQUITELESS": "without requital, free [adj]\n",
  "REQUITEMENT": "the act of requiting [n -S]\n",
  "REQUITEMENTS": "REQUITEMENT, the act of requiting [n]\n",
  "REQUITER": "one who requites [n -S]\n",
  "REQUITERS": "REQUITER, one who requites [n]\n",
  "REQUITES": "REQUITE, to repay [v]\n",
  "REQUITING": "REQUITE, to repay [v]\n",
  "REQUITS": "REQUIT, (Shakespeare) to repay, also REQUIGHT [v]\n",
  "REQUITTED": "REQUIT, (Shakespeare) to repay, also REQUIGHT [v]\n",
  "REQUITTING": "REQUIT, (Shakespeare) to repay, also REQUIGHT [v]\n",
  "REQUOTE": "to quote again [v REQUOTED, REQUOTING, REQUOTES]\n",
  "REQUOTED": "REQUOTE, to quote again [v]\n",
  "REQUOTES": "REQUOTE, to quote again [v]\n",
  "REQUOTING": "REQUOTE, to quote again [v]\n",
  "REQUOYLE": "(Shakespeare) to recoil [v REQUOYLED, REQUOYLING, REQUOYLES]\n",
  "REQUOYLED": "REQUOYLE, (Shakespeare) to recoil [v]\n",
  "REQUOYLES": "REQUOYLE, (Shakespeare) to recoil [v]\n",
  "REQUOYLING": "REQUOYLE, (Shakespeare) to recoil [v]\n",
  "RERACK": "to rack again [v -ED, -ING, -S]\n",
  "RERACKED": "RERACK, to rack again [v]\n",
  "RERACKING": "RERACK, to rack again [v]\n",
  "RERACKS": "RERACK, to rack again [v]\n",
  "RERADIATE": "to radiate again [v RERADIATED, RERADIATING, RERADIATES]\n",
  "RERADIATED": "RERADIATE, to radiate again [v]\n",
  "RERADIATES": "RERADIATE, to radiate again [v]\n",
  "RERADIATING": "RERADIATE, to radiate again [v]\n",
  "RERADIATION": "the act of reradiating [n -S]\n",
  "RERADIATIONS": "RERADIATION, the act of reradiating [n]\n",
  "RERAIL": "to replace on the rails [v -ED, -ING, -S]\n",
  "RERAILED": "RERAIL, to replace on the rails [v]\n",
  "RERAILING": "the act of replacing on the rails [n -S]\n",
  "RERAILINGS": "RERAILING, the act of replacing on the rails [n]\n",
  "RERAILS": "RERAIL, to replace on the rails [v]\n",
  "RERAISE": "to raise again [v RERAISED, RERAISING, RERAISES]\n",
  "RERAISED": "RERAISE, to raise again [v]\n",
  "RERAISES": "RERAISE, to raise again [v]\n",
  "RERAISING": "RERAISE, to raise again [v]\n",
  "RERAN": "RERUN, to show a repetition of a recorded performance [v]\n",
  "REREAD": "to read again [v REREAD, REREADING, REREADS]\n",
  "REREADING": "the act of rereading [n -S]\n",
  "REREADINGS": "REREADING, the act of rereading [n]\n",
  "REREADS": "REREAD, to read again [v]\n",
  "REREBRACE": "armour for the arm from shoulder to elbow [n -S]\n",
  "REREBRACES": "REREBRACE, armour for the arm from shoulder to elbow [n]\n",
  "RERECORD": "to record again [v -ED, -ING, -S]\n",
  "RERECORDED": "RERECORD, to record again [v]\n",
  "RERECORDING": "RERECORD, to record again [v]\n",
  "RERECORDS": "RERECORD, to record again [v]\n",
  "REREDORTER": "(historical) a lavatory built behind a monastic dormitory [n -S]\n",
  "REREDORTERS": "REREDORTER, (historical) a lavatory built behind a monastic dormitory [n]\n",
  "REREDOS": "a screen or panelling behind an altar or seat, also REREDOSSE [n REREDOSES or REREDOSSES]\n",
  "REREDOSES": "REREDOS, a screen or panelling behind an altar or seat, also REREDOSSE [n]\n",
  "REREDOSSE": "a screen or panelling behind an altar or seat, also REREDOS [n -S]\n",
  "REREDOSSES": "REREDOS, a screen or panelling behind an altar or seat, also REREDOSSE [n]\n",
  "REREGISTER": "to register again [v -ED, -ING, -S]\n",
  "REREGISTERED": "REREGISTER, to register again [v]\n",
  "REREGISTERING": "REREGISTER, to register again [v]\n",
  "REREGISTERS": "REREGISTER, to register again [v]\n",
  "REREGISTRATION": "the act of reregistering [n -S]\n",
  "REREGISTRATIONS": "REREGISTRATION, the act of reregistering [n]\n",
  "REREGULATE": "to regulate again [v REREGULATED, REREGULATING, REREGULATES]\n",
  "REREGULATED": "REREGULATE, to regulate again [v]\n",
  "REREGULATES": "REREGULATE, to regulate again [v]\n",
  "REREGULATING": "REREGULATE, to regulate again [v]\n",
  "REREGULATION": "the act of regulating again [n -S]\n",
  "REREGULATIONS": "REREGULATION, the act of regulating again [n]\n",
  "RERELEASE": "to release again [v RERELEASED, RERELEASING, RERELEASES]\n",
  "RERELEASED": "RERELEASE, to release again [v]\n",
  "RERELEASES": "RERELEASE, to release again [v]\n",
  "RERELEASING": "RERELEASE, to release again [v]\n",
  "REREMAI": "(Maori) the basking shark [n -S]\n",
  "REREMAIS": "REREMAI, (Maori) the basking shark [n]\n",
  "REREMICE": "REREMOUSE, a bat, also REARMOUSE [n]\n",
  "REREMIND": "to remind again [v -ED, -ING, -S]\n",
  "REREMINDED": "REREMIND, to remind again [v]\n",
  "REREMINDING": "REREMIND, to remind again [v]\n",
  "REREMINDS": "REREMIND, to remind again [v]\n",
  "REREMOUSE": "a bat, also REARMOUSE [n REREMICE]\n",
  "RERENT": "to rent again [v -ED, -ING, -S]\n",
  "RERENTED": "RERENT, to rent again [v]\n",
  "RERENTING": "RERENT, to rent again [v]\n",
  "RERENTS": "RERENT, to rent again [v]\n",
  "REREPEAT": "to repeat again [v -ED, -ING, -S]\n",
  "REREPEATED": "REREPEAT, to repeat again [v]\n",
  "REREPEATING": "REREPEAT, to repeat again [v]\n",
  "REREPEATS": "REREPEAT, to repeat again [v]\n",
  "REREVIEW": "to review again [v -ED, -ING, -S]\n",
  "REREVIEWED": "REREVIEW, to review again [v]\n",
  "REREVIEWING": "REREVIEW, to review again [v]\n",
  "REREVIEWS": "REREVIEW, to review again [v]\n",
  "REREVISE": "to revise again [v REREVISED, REREVISING, REREVISES]\n",
  "REREVISED": "REREVISE, to revise again [v]\n",
  "REREVISES": "REREVISE, to revise again [v]\n",
  "REREVISING": "REREVISE, to revise again [v]\n",
  "REREWARD": "the rearmost division of an army, also REARWARD [n -S]\n",
  "REREWARDS": "REREWARD, the rearmost division of an army, also REARWARD [n]\n",
  "RERIG": "to rig again [v RERIGGED, RERIGGING, RERIGS]\n",
  "RERIGGED": "RERIG, to rig again [v]\n",
  "RERIGGING": "RERIG, to rig again [v]\n",
  "RERIGS": "RERIG, to rig again [v]\n",
  "RERISE": "to rise again [v REROSE, RERISEN, RERISING, RERISES]\n",
  "RERISEN": "RERISE, to rise again [v]\n",
  "RERISES": "RERISE, to rise again [v]\n",
  "RERISING": "RERISE, to rise again [v]\n",
  "REROLL": "to roll again [v -ED, -ING, -S]\n",
  "REROLLED": "REROLL, to roll again [v]\n",
  "REROLLER": "one who rerolls [n -S]\n",
  "REROLLERS": "REROLLER, one who rerolls [n]\n",
  "REROLLING": "REROLL, to roll again [v]\n",
  "REROLLS": "REROLL, to roll again [v]\n",
  "REROOF": "to renew the roof [v -ED, -ING, -S]\n",
  "REROOFED": "REROOF, to renew the roof [v]\n",
  "REROOFING": "REROOF, to renew the roof [v]\n",
  "REROOFS": "REROOF, to renew the roof [v]\n",
  "REROSE": "RERISE, to rise again [v]\n",
  "REROUTE": "to choose a different route [v REROUTED, REROUTING or REROUTEING, REROUTES]\n",
  "REROUTED": "REROUTE, to choose a different route [v]\n",
  "REROUTEING": "REROUTE, to choose a different route [v]\n",
  "REROUTES": "REROUTE, to choose a different route [v]\n",
  "REROUTING": "REROUTE, to choose a different route [v]\n",
  "RERUN": "to show a repetition of a recorded performance [v RERAN, RERUN, RERUNNING, RERUNS]\n",
  "RERUNNING": "RERUN, to show a repetition of a recorded performance [v]\n",
  "RERUNS": "RERUN, to show a repetition of a recorded performance [v]\n",
  "RES": "(short for) (a Native American) reservation, also REZ [n -ES]\n",
  "RESADDLE": "to saddle again [v RESADDLED, RESADDLING, RESADDLES]\n",
  "RESADDLED": "RESADDLE, to saddle again [v]\n",
  "RESADDLES": "RESADDLE, to saddle again [v]\n",
  "RESADDLING": "RESADDLE, to saddle again [v]\n",
  "RESAID": "RESAY, to say again [v]\n",
  "RESAIL": "to sail again [v -ED, -ING, -S]\n",
  "RESAILED": "RESAIL, to sail again [v]\n",
  "RESAILING": "RESAIL, to sail again [v]\n",
  "RESAILS": "RESAIL, to sail again [v]\n",
  "RESALABLE": "that can be resold [adj]\n",
  "RESALE": "the act of selling again [n -S]\n",
  "RESALEABLE": "that can be resold [adj]\n",
  "RESALES": "RESALE, the act of selling again [n]\n",
  "RESALGAR": "(obsolete) a bright-red monoclinic mineral, also REALGAR [n -S]\n",
  "RESALGARS": "RESALGAR, (obsolete) a bright-red monoclinic mineral, also REALGAR [n]\n",
  "RESALUTE": "to salute again [v RESALUTED, RESALUTING, RESALUTES]\n",
  "RESALUTED": "RESALUTE, to salute again [v]\n",
  "RESALUTES": "RESALUTE, to salute again [v]\n",
  "RESALUTING": "RESALUTE, to salute again [v]\n",
  "RESAMPLE": "to sample again [v RESAMPLED, RESAMPLING, RESAMPLES]\n",
  "RESAMPLED": "RESAMPLE, to sample again [v]\n",
  "RESAMPLES": "RESAMPLE, to sample again [v]\n",
  "RESAMPLING": "RESAMPLE, to sample again [v]\n",
  "RESAT": "RESIT, to sit again after failing [v]\n",
  "RESAW": "to saw again [v RESAWED, RESAWN, RESAWING, RESAWS]\n",
  "RESAWED": "RESAW, to saw again [v]\n",
  "RESAWING": "RESAW, to saw again [v]\n",
  "RESAWN": "RESAW, to saw again [v]\n",
  "RESAWS": "RESAW, to saw again [v]\n",
  "RESAY": "to say again [v RESAID, RESAYING, RESAYS]\n",
  "RESAYING": "RESAY, to say again [v]\n",
  "RESAYS": "RESAY, to say again [v]\n",
  "RESCALE": "to plan to a new scale [v RESCALED, RESCALING, RESCALES]\n",
  "RESCALED": "RESCALE, to plan to a new scale [v]\n",
  "RESCALES": "RESCALE, to plan to a new scale [v]\n",
  "RESCALING": "RESCALE, to plan to a new scale [v]\n",
  "RESCHEDULE": "to schedule again according to a different timetable [v RESCHEDULED, RESCHEDULING, RESCHEDULES]\n",
  "RESCHEDULED": "RESCHEDULE, to schedule again according to a different timetable [v]\n",
  "RESCHEDULES": "RESCHEDULE, to schedule again according to a different timetable [v]\n",
  "RESCHEDULING": "the act of scheduling again [n -S]\n",
  "RESCHEDULINGS": "RESCHEDULING, the act of scheduling again [n]\n",
  "RESCHOOL": "to school again [v -ED, -ING, -S]\n",
  "RESCHOOLED": "RESCHOOL, to school again [v]\n",
  "RESCHOOLING": "RESCHOOL, to school again [v]\n",
  "RESCHOOLS": "RESCHOOL, to school again [v]\n",
  "RESCIND": "to annul, remove [v -ED, -ING, -S]\n",
  "RESCINDABLE": "that can be rescinded [adj]\n",
  "RESCINDED": "RESCIND, to annul, remove [v]\n",
  "RESCINDER": "one who rescinds [n -S]\n",
  "RESCINDERS": "RESCINDER, one who rescinds [n]\n",
  "RESCINDING": "RESCIND, to annul, remove [v]\n",
  "RESCINDMENT": "the act of rescinding [n -S]\n",
  "RESCINDMENTS": "RESCINDMENT, the act of rescinding [n]\n",
  "RESCINDS": "RESCIND, to annul, remove [v]\n",
  "RESCISSIBLE": "able to be rescinded [adj]\n",
  "RESCISSION": "the act of rescinding [n -S]\n",
  "RESCISSIONS": "RESCISSION, the act of rescinding [n]\n",
  "RESCISSORY": "tending to rescind [adj]\n",
  "RESCORE": "to score again [v RESCORED, RESCORING, RESCORES]\n",
  "RESCORED": "RESCORE, to score again [v]\n",
  "RESCORES": "RESCORE, to score again [v]\n",
  "RESCORING": "RESCORE, to score again [v]\n",
  "RESCREEN": "to screen again [v -ED, -ING, -S]\n",
  "RESCREENED": "RESCREEN, to screen again [v]\n",
  "RESCREENING": "RESCREEN, to screen again [v]\n",
  "RESCREENS": "RESCREEN, to screen again [v]\n",
  "RESCRIPT": "to issue a papal edict or decree [v -ED, -ING, -S]\n",
  "RESCRIPTED": "RESCRIPT, to issue a papal edict or decree [v]\n",
  "RESCRIPTING": "RESCRIPT, to issue a papal edict or decree [v]\n",
  "RESCRIPTION": "a reply or answering of a letter [n -S]\n",
  "RESCRIPTIONS": "RESCRIPTION, a reply or answering of a letter [n]\n",
  "RESCRIPTS": "RESCRIPT, to issue a papal edict or decree [v]\n",
  "RESCUABLE": "that may be rescued [adj]\n",
  "RESCUE": "to free from danger [v RESCUED, RESCUING, RESCUES]\n",
  "RESCUED": "RESCUE, to free from danger [v]\n",
  "RESCUEE": "one that is rescued [n -S]\n",
  "RESCUEES": "RESCUEE, one that is rescued [n]\n",
  "RESCUER": "one who rescues [n -S]\n",
  "RESCUERS": "RESCUER, one who rescues [n]\n",
  "RESCUES": "RESCUE, to free from danger [v]\n",
  "RESCUING": "RESCUE, to free from danger [v]\n",
  "RESCULPT": "to sculpt again [v -ED, -ING, -S]\n",
  "RESCULPTED": "RESCULPT, to sculpt again [v]\n",
  "RESCULPTING": "RESCULPT, to sculpt again [v]\n",
  "RESCULPTS": "RESCULPT, to sculpt again [v]\n",
  "RESEAL": "to seal again [v -ED, -ING, -S]\n",
  "RESEALABLE": "that can be resealed [adj]\n",
  "RESEALED": "RESEAL, to seal again [v]\n",
  "RESEALING": "RESEAL, to seal again [v]\n",
  "RESEALS": "RESEAL, to seal again [v]\n",
  "RESEARCH": "to investigate thoroughly [v -ED, -ING, -ES]\n",
  "RESEARCHABLE": "capable of being researched [adj]\n",
  "RESEARCHED": "RESEARCH, to investigate thoroughly [v]\n",
  "RESEARCHER": "one who does research [n -S]\n",
  "RESEARCHERS": "RESEARCHER, one who does research [n]\n",
  "RESEARCHES": "RESEARCH, to investigate thoroughly [v]\n",
  "RESEARCHFUL": "full of research [adj]\n",
  "RESEARCHING": "RESEARCH, to investigate thoroughly [v]\n",
  "RESEARCHIST": "one engaged in research [n -S]\n",
  "RESEARCHISTS": "RESEARCHIST, one engaged in research [n]\n",
  "RESEASON": "to season again [v -ED, -ING, -S]\n",
  "RESEASONED": "RESEASON, to season again [v]\n",
  "RESEASONING": "RESEASON, to season again [v]\n",
  "RESEASONS": "RESEASON, to season again [v]\n",
  "RESEAT": "to seat again [v -ED, -ING, -S]\n",
  "RESEATED": "RESEAT, to seat again [v]\n",
  "RESEATING": "RESEAT, to seat again [v]\n",
  "RESEATS": "RESEAT, to seat again [v]\n",
  "RESEAU": "(French) a filter screen for making colour films [n RESEAUS or RESEAUX]\n",
  "RESEAUS": "RESEAU, (French) a filter screen for making colour films [n]\n",
  "RESEAUX": "RESEAU, (French) a filter screen for making colour films [n]\n",
  "RESECT": "to cut away part of [v -ED, -ING, -S]\n",
  "RESECTABILITIES": "RESECTABILITY, the state of being resectable [n]\n",
  "RESECTABILITY": "the state of being resectable [n RESECTABILITIES]\n",
  "RESECTABLE": "that can be resected [adj]\n",
  "RESECTED": "RESECT, to cut away part of [v]\n",
  "RESECTING": "RESECT, to cut away part of [v]\n",
  "RESECTION": "the operation of cutting away, esp. of bone [n -S]\n",
  "RESECTIONAL": "relating to resection, the operation of cutting away, esp. bone [adj]\n",
  "RESECTIONS": "RESECTION, the operation of cutting away, esp. of bone [n]\n",
  "RESECTS": "RESECT, to cut away part of [v]\n",
  "RESECURE": "to secure again [v RESECURED, RESECURING, RESECURES]\n",
  "RESECURED": "RESECURE, to secure again [v]\n",
  "RESECURES": "RESECURE, to secure again [v]\n",
  "RESECURING": "RESECURE, to secure again [v]\n",
  "RESEDA": "(French) a pale green colour [n -S]\n",
  "RESEDAS": "RESEDA, (French) a pale green colour [n]\n",
  "RESEE": "to see again [v RESAW or RESEED, RESEEN, RESEEING, RESEES]\n",
  "RESEED": "to seed again [v -ED, -ING, -S]\n",
  "RESEEDED": "RESEED, to seed again [v]\n",
  "RESEEDING": "RESEED, to seed again [v]\n",
  "RESEEDS": "RESEED, to seed again [v]\n",
  "RESEEING": "RESEE, to see again [v]\n",
  "RESEEK": "to seek again [v RESOUGHT, RESEEKING, RESEEKS]\n",
  "RESEEKING": "RESEEK, to seek again [v]\n",
  "RESEEKS": "RESEEK, to seek again [v]\n",
  "RESEEN": "RESEE, to see again [v]\n",
  "RESEES": "RESEE, to see again [v]\n",
  "RESEGREGATE": "to segregate again [v RESEGREGATED, RESEGREGATING, RESEGREGATES]\n",
  "RESEGREGATED": "RESEGREGATE, to segregate again [v]\n",
  "RESEGREGATES": "RESEGREGATE, to segregate again [v]\n",
  "RESEGREGATING": "RESEGREGATE, to segregate again [v]\n",
  "RESEGREGATION": "the act of resegregating [n -S]\n",
  "RESEGREGATIONS": "RESEGREGATION, the act of resegregating [n]\n",
  "RESEIZE": "(Spenser) to reinstate [v RESEIZED, RESEIZING, RESEIZES]\n",
  "RESEIZED": "RESEIZE, (Spenser) to reinstate [v]\n",
  "RESEIZES": "RESEIZE, (Spenser) to reinstate [v]\n",
  "RESEIZING": "RESEIZE, (Spenser) to reinstate [v]\n",
  "RESEIZURE": "the act of reseizing [n -S]\n",
  "RESEIZURES": "RESEIZURE, the act of reseizing [n]\n",
  "RESELECT": "to choose again [v -ED, -ING, -S]\n",
  "RESELECTED": "RESELECT, to choose again [v]\n",
  "RESELECTING": "RESELECT, to choose again [v]\n",
  "RESELECTION": "the act of selecting again [n -S]\n",
  "RESELECTIONS": "RESELECTION, the act of selecting again [n]\n",
  "RESELECTS": "RESELECT, to choose again [v]\n",
  "RESELL": "to sell again [v RESOLD, RESELLING, RESELLS]\n",
  "RESELLER": "one who resells [n -S]\n",
  "RESELLERS": "RESELLER, one who resells [n]\n",
  "RESELLING": "RESELL, to sell again [v]\n",
  "RESELLS": "RESELL, to sell again [v]\n",
  "RESEMBLANCE": "the state of resembling [n -S]\n",
  "RESEMBLANCES": "RESEMBLANCE, the state of resembling [n]\n",
  "RESEMBLANT": "having or exhibiting resemblance [adj]\n",
  "RESEMBLE": "to be alike [v RESEMBLED, RESEMBLING, RESEMBLES]\n",
  "RESEMBLED": "RESEMBLE, to be alike [v]\n",
  "RESEMBLER": "one who resembles [n -S]\n",
  "RESEMBLERS": "RESEMBLER, one who resembles [n]\n",
  "RESEMBLES": "RESEMBLE, to be alike [v]\n",
  "RESEMBLING": "RESEMBLE, to be alike [v]\n",
  "RESEND": "to send again [v RESENT, RESENDING, RESENDS]\n",
  "RESENDING": "RESEND, to send again [v]\n",
  "RESENDS": "RESEND, to send again [v]\n",
  "RESENSITISE": "to sensitise again, also RESENSITIZE [v RESENSITISED, RESENSITISING, RESENSITISES]\n",
  "RESENSITISED": "RESENSITISE, to sensitise again, also RESENSITIZE [v]\n",
  "RESENSITISES": "RESENSITISE, to sensitise again, also RESENSITIZE [v]\n",
  "RESENSITISING": "RESENSITISE, to sensitise again, also RESENSITIZE [v]\n",
  "RESENSITIZE": "to sensitize again [v RESENSITIZED, RESENSITIZING, RESENSITIZES]\n",
  "RESENSITIZED": "RESENSITIZE, to sensitize again [v]\n",
  "RESENSITIZES": "RESENSITIZE, to sensitize again [v]\n",
  "RESENSITIZING": "RESENSITIZE, to sensitize again [v]\n",
  "RESENT": "to feel affront or ill-will [v -ED, -ING, -S]\n",
  "RESENTED": "RESENT, to feel affront or ill-will [v]\n",
  "RESENTENCE": "to sentence again [v RESENTENCED, RESENTENCING, RESENTENCES]\n",
  "RESENTENCED": "RESENTENCE, to sentence again [v]\n",
  "RESENTENCES": "RESENTENCE, to sentence again [v]\n",
  "RESENTENCING": "RESENTENCE, to sentence again [v]\n",
  "RESENTER": "one who resents [n -S]\n",
  "RESENTERS": "RESENTER, one who resents [n]\n",
  "RESENTFUL": "full of resentment, also RESENTIVE [adj RESENTFULLY]\n",
  "RESENTFULLY": "RESENTFUL, full of resentment, also RESENTIVE [adv]\n",
  "RESENTFULNESS": "the state of being resentful [n -ES]\n",
  "RESENTFULNESSES": "RESENTFULNESS, the state of being resentful [n]\n",
  "RESENTING": "RESENT, to feel affront or ill-will [v]\n",
  "RESENTINGLY": "RESENTING, RESENT, to feel affront or ill-will [adv]\n",
  "RESENTIVE": "feeling resentment, also RESENTFUL [adj]\n",
  "RESENTMENT": "a feeling of indignant displeasure or persistent ill will at something regarded as a wrong, insult, or injury [n -S]\n",
  "RESENTMENTS": "RESENTMENT, a feeling of indignant displeasure or persistent ill will at something regarded as a wrong, insult, or injury [n]\n",
  "RESENTS": "RESENT, to feel affront or ill-will [v]\n",
  "RESERPINE": "a sedative drug [n -S]\n",
  "RESERPINES": "RESERPINE, a sedative drug [n]\n",
  "RESERVABLE": "that can be reserved [adj]\n",
  "RESERVATION": "somehting reserved, a booking [n -S]\n",
  "RESERVATIONIST": "one who makes a reservation [n -S]\n",
  "RESERVATIONISTS": "RESERVATIONIST, one who makes a reservation [n]\n",
  "RESERVATIONS": "RESERVATION, somehting reserved, a booking [n]\n",
  "RESERVATORIES": "RESERVATORY, a receptacle; a reservoir [n]\n",
  "RESERVATORY": "a receptacle; a reservoir [n RESERVATORIES]\n",
  "RESERVE": "to hold in abeyance [v RESERVED, RESERVING, RESERVES]\n",
  "RESERVED": "RESERVE, to hold in abeyance [v]\n",
  "RESERVEDLY": "RESERVED, RESERVE, to hold in abeyance [adv]\n",
  "RESERVEDNESS": "the state of being reserved [n -ES]\n",
  "RESERVEDNESSES": "RESERVEDNESS, the state of being reserved [n]\n",
  "RESERVER": "one who reserves [n -S]\n",
  "RESERVERS": "RESERVER, one who reserves [n]\n",
  "RESERVES": "RESERVE, to hold in abeyance [v]\n",
  "RESERVICE": "to service again [v RESERVICED, RESERVICING, RESERVICES]\n",
  "RESERVICED": "RESERVICE, to service again [v]\n",
  "RESERVICES": "RESERVICE, to service again [v]\n",
  "RESERVICING": "RESERVICE, to service again [v]\n",
  "RESERVING": "RESERVE, to hold in abeyance [v]\n",
  "RESERVIST": "a member of a reserve force [n -S]\n",
  "RESERVISTS": "RESERVIST, a member of a reserve force [n]\n",
  "RESERVOIR": "a storage place [n -S] / to keep as in a reservoir, store [v -ED, -ING, -S]\n",
  "RESERVOIRED": "RESERVOIR, to keep as in a reservoir, store [v]\n",
  "RESERVOIRING": "RESERVOIR, to keep as in a reservoir, store [v]\n",
  "RESERVOIRS": "RESERVOIR, to keep as in a reservoir, store [v]\n",
  "RESES": "RES, (short for) (a Native American) reservation, also REZ [n]\n",
  "RESET": "to set again [v RESET or RESETTED, RESETTING, RESETS]\n",
  "RESETS": "RESET, to set again [v]\n",
  "RESETTABLE": "that can be reset [adj]\n",
  "RESETTED": "RESET, to set again [v]\n",
  "RESETTER": "one who resets [n -S]\n",
  "RESETTERS": "RESETTER, one who resets [n]\n",
  "RESETTING": "RESET, to set again [v]\n",
  "RESETTLE": "to move to another place of residence [v RESETTLED, RESETTLING, RESETTLES]\n",
  "RESETTLED": "RESETTLE, to move to another place of residence [v]\n",
  "RESETTLEMENT": "the act of resettling [n -S]\n",
  "RESETTLEMENTS": "RESETTLEMENT, the act of resettling [n]\n",
  "RESETTLES": "RESETTLE, to move to another place of residence [v]\n",
  "RESETTLING": "RESETTLE, to move to another place of residence [v]\n",
  "RESEW": "to sew again [v RESEWED, RESEWN, RESEWING, RESEWS]\n",
  "RESEWED": "RESEW, to sew again [v]\n",
  "RESEWING": "RESEW, to sew again [v]\n",
  "RESEWN": "RESEW, to sew again [v]\n",
  "RESEWS": "RESEW, to sew again [v]\n",
  "RESH": "(Hebrew) a Hebrew letter [n -ES]\n",
  "RESHAPE": "to shape again [v RESHAPED, RESHAPING, RESHAPES]\n",
  "RESHAPED": "RESHAPE, to shape again [v]\n",
  "RESHAPER": "one that reshapes something [n -S]\n",
  "RESHAPERS": "RESHAPER, one that reshapes something [n]\n",
  "RESHAPES": "RESHAPE, to shape again [v]\n",
  "RESHAPING": "the act of shaping again [n -S]\n",
  "RESHAPINGS": "RESHAPING, the act of shaping again [n]\n",
  "RESHARPEN": "to sharpen again [v -ED, -ING, -S]\n",
  "RESHARPENED": "RESHARPEN, to sharpen again [v]\n",
  "RESHARPENING": "RESHARPEN, to sharpen again [v]\n",
  "RESHARPENS": "RESHARPEN, to sharpen again [v]\n",
  "RESHAVE": "to shave again [v RESHAVED, RESHAVEN, RESHAVING, RESHAVES]\n",
  "RESHAVED": "RESHAVE, to shave again [v]\n",
  "RESHAVEN": "RESHAVE, to shave again [v]\n",
  "RESHAVES": "RESHAVE, to shave again [v]\n",
  "RESHAVING": "RESHAVE, to shave again [v]\n",
  "RESHES": "RESH, (Hebrew) a Hebrew letter [n]\n",
  "RESHINE": "to shine again [v RESHINED, RESHONE, RESHINING, RESHINES]\n",
  "RESHINED": "RESHINE, to shine again [v]\n",
  "RESHINES": "RESHINE, to shine again [v]\n",
  "RESHINGLE": "to shingle again [v RESHINGLED, RESHINGLING, RESHINGLES]\n",
  "RESHINGLED": "RESHINGLE, to shingle again [v]\n",
  "RESHINGLES": "RESHINGLE, to shingle again [v]\n",
  "RESHINGLING": "RESHINGLE, to shingle again [v]\n",
  "RESHINING": "RESHINE, to shine again [v]\n",
  "RESHIP": "to ship again [v RESHIPPED, RESHIPPING, RESHIPS]\n",
  "RESHIPMENT": "the act of reshipping [n -S]\n",
  "RESHIPMENTS": "RESHIPMENT, the act of reshipping [n]\n",
  "RESHIPPED": "RESHIP, to ship again [v]\n",
  "RESHIPPER": "one who reships [n -S]\n",
  "RESHIPPERS": "RESHIPPER, one who reships [n]\n",
  "RESHIPPING": "RESHIP, to ship again [v]\n",
  "RESHIPS": "RESHIP, to ship again [v]\n",
  "RESHOD": "RESHOE, to shoe again [v]\n",
  "RESHOE": "to shoe again [v RESHOD or RESHOED, RESHOEING, RESHOES]\n",
  "RESHOED": "RESHOE, to shoe again [v]\n",
  "RESHOEING": "RESHOE, to shoe again [v]\n",
  "RESHOES": "RESHOE, to shoe again [v]\n",
  "RESHONE": "RESHINE, to shine again [v]\n",
  "RESHOOT": "to film a scene again [v RESHOT, RESHOOTING, RESHOOTS]\n",
  "RESHOOTING": "RESHOOT, to film a scene again [v]\n",
  "RESHOOTS": "RESHOOT, to film a scene again [v]\n",
  "RESHOT": "RESHOOT, to film a scene again [v]\n",
  "RESHOW": "to show again [v RESHOWED, RESHOWN, RESHOWING, RESHOWS]\n",
  "RESHOWED": "RESHOW, to show again [v]\n",
  "RESHOWER": "to shower again [v -ED, -ING, -S]\n",
  "RESHOWERED": "RESHOWER, to shower again [v]\n",
  "RESHOWERING": "RESHOWER, to shower again [v]\n",
  "RESHOWERS": "RESHOWER, to shower again [v]\n",
  "RESHOWING": "the act of showing again [n -S]\n",
  "RESHOWINGS": "RESHOWING, the act of showing again [n]\n",
  "RESHOWN": "RESHOW, to show again [v]\n",
  "RESHOWS": "RESHOW, to show again [v]\n",
  "RESHUFFLE": "to shuffle again [v RESHUFFLED, RESHUFFLING, RESHUFFLES]\n",
  "RESHUFFLED": "RESHUFFLE, to shuffle again [v]\n",
  "RESHUFFLES": "RESHUFFLE, to shuffle again [v]\n",
  "RESHUFFLING": "RESHUFFLE, to shuffle again [v]\n",
  "RESIANCE": "(archaic) a residence, abode [n -S]\n",
  "RESIANCES": "RESIANCE, (archaic) a residence, abode [n]\n",
  "RESIANT": "(archaic) a resident [n -S]\n",
  "RESIANTS": "RESIANT, (archaic) a resident [n]\n",
  "RESID": "a type of fuel oil [n -S]\n",
  "RESIDE": "to live in a certain place [v RESIDED, RESIDING, RESIDES]\n",
  "RESIDED": "RESIDE, to live in a certain place [v]\n",
  "RESIDENCE": "a place where one lives, also RESIANCE, RESIDENCY [n -S]\n",
  "RESIDENCES": "RESIDENCE, a place where one lives, also RESIANCE, RESIDENCY [n]\n",
  "RESIDENCIES": "RESIDENCY, the official abode of a resident or governor of a protected state, also RESIANCE, RESIDENCE [n]\n",
  "RESIDENCY": "the official abode of a resident or governor of a protected state, also RESIANCE, RESIDENCE [n RESIDENCIES]\n",
  "RESIDENT": "one who resides [n -S]\n",
  "RESIDENTER": "(Scots) an inhabitant [n -S]\n",
  "RESIDENTERS": "RESIDENTER, (Scots) an inhabitant [n]\n",
  "RESIDENTIAL": "used as a residence or by residents [adj RESIDENTIALLY]\n",
  "RESIDENTIALLY": "RESIDENTIAL, used as a residence or by residents [adv]\n",
  "RESIDENTIARIES": "RESIDENTIARY, an inhabitant; a person bound to reside, such as a canon [n]\n",
  "RESIDENTIARY": "an inhabitant; a person bound to reside, such as a canon [n RESIDENTIARIES]\n",
  "RESIDENTS": "RESIDENT, one who resides [n]\n",
  "RESIDENTSHIP": "the state of being a resident [n -S]\n",
  "RESIDENTSHIPS": "RESIDENTSHIP, the state of being a resident [n]\n",
  "RESIDER": "one who resides [n -S]\n",
  "RESIDERS": "RESIDER, one who resides [n]\n",
  "RESIDES": "RESIDE, to live in a certain place [v]\n",
  "RESIDING": "RESIDE, to live in a certain place [v]\n",
  "RESIDS": "RESID, a type of fuel oil [n]\n",
  "RESIDUA": "RESIDUUM, (Latin) a residue [n]\n",
  "RESIDUAL": "remaining, also RESIDUOUS [adj RESIDUALLY] / that which remains as a residue [n -S]\n",
  "RESIDUALLY": "RESIDUAL, remaining, also RESIDUOUS [adv]\n",
  "RESIDUALS": "RESIDUAL, that which remains as a residue [n]\n",
  "RESIDUARY": "of the nature of a residue, esp. of an estate [adj]\n",
  "RESIDUE": "something remaining after the removal of a part [n -S]\n",
  "RESIDUES": "RESIDUE, something remaining after the removal of a part [n]\n",
  "RESIDUOUS": "remaining, also RESIDUAL [adj]\n",
  "RESIDUUM": "(Latin) a residue [n RESIDUA or RESIDUUMS]\n",
  "RESIDUUMS": "RESIDUUM, (Latin) a residue [n]\n",
  "RESIFT": "to sift again [v -ED, -ING, -S]\n",
  "RESIFTED": "RESIFT, to sift again [v]\n",
  "RESIFTING": "RESIFT, to sift again [v]\n",
  "RESIFTS": "RESIFT, to sift again [v]\n",
  "RESIGHT": "to sight again [v -ED, -ING, -S]\n",
  "RESIGHTED": "RESIGHT, to sight again [v]\n",
  "RESIGHTING": "RESIGHT, to sight again [v]\n",
  "RESIGHTS": "RESIGHT, to sight again [v]\n",
  "RESIGN": "to give up an office or position [v -ED, -ING, -S]\n",
  "RESIGNATION": "an act or instance of resigning something [n -S]\n",
  "RESIGNATIONS": "RESIGNATION, an act or instance of resigning something [n]\n",
  "RESIGNED": "RESIGN, to give up an office or position [v]\n",
  "RESIGNEDLY": "RESIGNED, RESIGN, to give up an office or position [adv]\n",
  "RESIGNEDNESS": "the state of being resigned [n -ES]\n",
  "RESIGNEDNESSES": "RESIGNEDNESS, the state of being resigned [n]\n",
  "RESIGNER": "one who resigns [n -S]\n",
  "RESIGNERS": "RESIGNER, one who resigns [n]\n",
  "RESIGNING": "RESIGN, to give up an office or position [v]\n",
  "RESIGNMENT": "the act of resigning [n -S]\n",
  "RESIGNMENTS": "RESIGNMENT, the act of resigning [n]\n",
  "RESIGNS": "RESIGN, to give up an office or position [v]\n",
  "RESILE": "to spring back [v RESILED, RESILING, RESILES]\n",
  "RESILED": "RESILE, to spring back [v]\n",
  "RESILEMENT": "the act of resiling [n -S]\n",
  "RESILEMENTS": "RESILEMENT, the act of resiling [n]\n",
  "RESILES": "RESILE, to spring back [v]\n",
  "RESILIENCE": "the quality of being resilient, also RESILIENCY [n -S]\n",
  "RESILIENCES": "RESILIENCE, the quality of being resilient, also RESILIENCY [n]\n",
  "RESILIENCIES": "RESILIENCY, the quality of being resilient, also RESILIENCE [n]\n",
  "RESILIENCY": "the quality of being resilient, also RESILIENCE [n RESILIENCIES]\n",
  "RESILIENT": "springing back [adj RESILIENTLY]\n",
  "RESILIENTLY": "RESILIENT, springing back [adv]\n",
  "RESILIN": "an elastic substance in the cuticles of many insects [n -S]\n",
  "RESILING": "RESILE, to spring back [v]\n",
  "RESILINS": "RESILIN, an elastic substance in the cuticles of many insects [n]\n",
  "RESILVER": "to cover with silver [v -ED, -ING, -S]\n",
  "RESILVERED": "RESILVER, to cover with silver [v]\n",
  "RESILVERING": "RESILVER, to cover with silver [v]\n",
  "RESILVERS": "RESILVER, to cover with silver [v]\n",
  "RESIN": "any of a number of substances or products obtained from the sap of certain plants and trees [n -S] / to impregnate with resin [v -ED, -ING, -S]\n",
  "RESINATA": "(Latin) a Greek white wine [n -S]\n",
  "RESINATAS": "RESINATA, (Latin) a Greek white wine [n]\n",
  "RESINATE": "to treat with a viscous substance, also RESIN [v RESINATED, RESINATING, RESINATES]\n",
  "RESINATED": "RESINATE, to treat with a viscous substance, also RESIN [v]\n",
  "RESINATES": "RESINATE, to treat with a viscous substance, also RESIN [v]\n",
  "RESINATING": "RESINATE, to treat with a viscous substance, also RESIN [v]\n",
  "RESINED": "RESIN, to impregnate with resin [v]\n",
  "RESINER": "a resin gatherer [n -S]\n",
  "RESINERS": "RESINER, a resin gatherer [n]\n",
  "RESINIER": "RESINY, full of resin [adj]\n",
  "RESINIEST": "RESINY, full of resin [adj]\n",
  "RESINIFEROUS": "bearing resin [adj]\n",
  "RESINIFICATION": "the process of resinifying [n -S]\n",
  "RESINIFICATIONS": "RESINIFICATION, the process of resinifying [n]\n",
  "RESINIFIED": "RESINIFY, to convert into resin [v]\n",
  "RESINIFIES": "RESINIFY, to convert into resin [v]\n",
  "RESINIFY": "to convert into resin [v RESINIFIED, RESINIFYING, RESINIFIES]\n",
  "RESINIFYING": "RESINIFY, to convert into resin [v]\n",
  "RESINING": "RESIN, to impregnate with resin [v]\n",
  "RESINISE": "to treat with resin, also RESINIZE [v RESINISED, RESINISING, RESINISES]\n",
  "RESINISED": "RESINISE, to treat with resin, also RESINIZE [v]\n",
  "RESINISES": "RESINISE, to treat with resin, also RESINIZE [v]\n",
  "RESINISING": "RESINISE, to treat with resin, also RESINIZE [v]\n",
  "RESINIZE": "to treat with resin, also RESINISE [v RESINIZED, RESINIZING, RESINIZES]\n",
  "RESINIZED": "RESINIZE, to treat with resin, also RESINISE [v]\n",
  "RESINIZES": "RESINIZE, to treat with resin, also RESINISE [v]\n",
  "RESINIZING": "RESINIZE, to treat with resin, also RESINISE [v]\n",
  "RESINLIKE": "like resin [adj]\n",
  "RESINOID": "a resinous substance [n -S]\n",
  "RESINOIDS": "RESINOID, a resinous substance [n]\n",
  "RESINOSES": "RESINOSIS, an abnormal flow of resin [n]\n",
  "RESINOSIS": "an abnormal flow of resin [n RESINOSES]\n",
  "RESINOUS": "resembling resin [adj RESINOUSLY]\n",
  "RESINOUSLY": "RESINOUS, resembling resin [adv]\n",
  "RESINOUSNESS": "the state of being resinous [n -ES]\n",
  "RESINOUSNESSES": "RESINOUSNESS, the state of being resinous [n]\n",
  "RESINS": "RESIN, to impregnate with resin [v]\n",
  "RESINY": "full of resin [adj RESINIER, RESINIEST]\n",
  "RESIPISCENCE": "recognition of error; change to better frame of mind, also RESIPISCENCY [n -S]\n",
  "RESIPISCENCES": "RESIPISCENCE, recognition of error; change to better frame of mind, also RESIPISCENCY [n]\n",
  "RESIPISCENCIES": "RESIPISCENCY, recognition of error, change to a better frame of mind, also RESIPISCENCE [n]\n",
  "RESIPISCENCY": "recognition of error, change to a better frame of mind, also RESIPISCENCE [n RESIPISCENCIES]\n",
  "RESIPISCENT": "having returned to a saner mind [adj]\n",
  "RESIST": "to strive against, oppose [v -ED, -ING, -S]\n",
  "RESISTANCE": "the act or power of resisting [n -S]\n",
  "RESISTANCES": "RESISTANCE, the act or power of resisting [n]\n",
  "RESISTANT": "making resistance [adj] / a person who or thing which resists; specifically a member of a resistance movement, also RESISTENT [n -S]\n",
  "RESISTANTS": "RESISTANT, a person who or thing which resists; specifically a member of a resistance movement, also RESISTENT [n]\n",
  "RESISTED": "RESIST, to strive against, oppose [v]\n",
  "RESISTENT": "making resistance [adj] / a person who or thing which resists; specifically a member of a resistance movement, also RESISTANT [n -S]\n",
  "RESISTENTS": "RESISTENT, a person who or thing which resists; specifically a member of a resistance movement, also RESISTANT [n]\n",
  "RESISTER": "one who resists [n -S]\n",
  "RESISTERS": "RESISTER, one who resists [n]\n",
  "RESISTIBILITIES": "RESISTIBILITY, the state of being resistible [n]\n",
  "RESISTIBILITY": "the state of being resistible [n RESISTIBILITIES]\n",
  "RESISTIBLE": "that can be resisted [adj RESISTIBLY]\n",
  "RESISTIBLY": "RESISTIBLE, that can be resisted [adv]\n",
  "RESISTING": "RESIST, to strive against, oppose [v]\n",
  "RESISTINGLY": "RESISTING, RESIST, to strive against, oppose [adv]\n",
  "RESISTIVE": "serving to resist [adj RESISTIVELY]\n",
  "RESISTIVELY": "RESISTIVE, serving to resist [adv]\n",
  "RESISTIVENESS": "RESISTIVE, serving to resist [n]\n",
  "RESISTIVENESSES": "RESISTIVENESS, RESISTIVE, serving to resist [n]\n",
  "RESISTIVITIES": "RESISTIVITY, the longitudinal electrical resistance of a uniform rod of unit length and unit cross-sectional area [n]\n",
  "RESISTIVITY": "the longitudinal electrical resistance of a uniform rod of unit length and unit cross-sectional area [n RESISTIVITIES]\n",
  "RESISTLESS": "(archaic) irresistible [adj RESISTLESSLY]\n",
  "RESISTLESSLY": "RESISTLESS, (archaic) irresistible [adv]\n",
  "RESISTLESSNESS": "RESISTLESS, (archaic) irresistible [n]\n",
  "RESISTOR": "a device in an electric circuit [n -S]\n",
  "RESISTORS": "RESISTOR, a device in an electric circuit [n]\n",
  "RESISTS": "RESIST, to strive against, oppose [v]\n",
  "RESIT": "to sit again after failing [v RESAT, RESITTING, RESITS]\n",
  "RESITE": "to move to a different locality [v RESITED, RESITING, RESITES]\n",
  "RESITED": "RESITE, to move to a different locality [v]\n",
  "RESITES": "RESITE, to move to a different locality [v]\n",
  "RESITING": "RESITE, to move to a different locality [v]\n",
  "RESITS": "RESIT, to sit again after failing [v]\n",
  "RESITTING": "the act of resitting [n -S]\n",
  "RESITTINGS": "RESITTING, the act of resitting [n]\n",
  "RESITUATE": "to situate again [v RESITUATED, RESITUATING, RESITUATES]\n",
  "RESITUATED": "RESITUATE, to situate again [v]\n",
  "RESITUATES": "RESITUATE, to situate again [v]\n",
  "RESITUATING": "RESITUATE, to situate again [v]\n",
  "RESIZABLE": "capable of being resized [adj]\n",
  "RESIZE": "to size again [v RESIZED, RESIZING, RESIZES]\n",
  "RESIZED": "RESIZE, to size again [v]\n",
  "RESIZES": "RESIZE, to size again [v]\n",
  "RESIZING": "RESIZE, to size again [v]\n",
  "RESKETCH": "to sketch again [v -ED, -ING, -ES]\n",
  "RESKETCHED": "RESKETCH, to sketch again [v]\n",
  "RESKETCHES": "RESKETCH, to sketch again [v]\n",
  "RESKETCHING": "RESKETCH, to sketch again [v]\n",
  "RESKEW": "(Spenser) to rescue, also RESKUE [v -ED, -ING, -S]\n",
  "RESKEWED": "RESKEW, (Spenser) to rescue, also RESKUE [v]\n",
  "RESKEWING": "RESKEW, (Spenser) to rescue, also RESKUE [v]\n",
  "RESKEWS": "RESKEW, (Spenser) to rescue, also RESKUE [v]\n",
  "RESKILL": "to retrain employees for new work [v -ED, -ING, -S]\n",
  "RESKILLED": "RESKILL, to retrain employees for new work [v]\n",
  "RESKILLING": "the retraining of employees [n -S]\n",
  "RESKILLINGS": "RESKILLING, the retraining of employees [n]\n",
  "RESKILLS": "RESKILL, to retrain employees for new work [v]\n",
  "RESKIN": "to replace the outermost layer of an aircraft or motor vehicle [v RESKINNED, RESKINNING, RESKINS]\n",
  "RESKINNED": "RESKIN, to replace the outermost layer of an aircraft or motor vehicle [v]\n",
  "RESKINNING": "RESKIN, to replace the outermost layer of an aircraft or motor vehicle [v]\n",
  "RESKINS": "RESKIN, to replace the outermost layer of an aircraft or motor vehicle [v]\n",
  "RESKUE": "(Spenser) to rescue, also RESKEW [v RESKUED, RESKUING, RESKUES]\n",
  "RESKUED": "RESKUE, (Spenser) to rescue, also RESKEW [v]\n",
  "RESKUES": "RESKUE, (Spenser) to rescue, also RESKEW [v]\n",
  "RESKUING": "RESKUE, (Spenser) to rescue, also RESKEW [v]\n",
  "RESLATE": "to put down new slate [v RESLATED, RESLATING, RESLATES]\n",
  "RESLATED": "RESLATE, to put down new slate [v]\n",
  "RESLATES": "RESLATE, to put down new slate [v]\n",
  "RESLATING": "RESLATE, to put down new slate [v]\n",
  "RESMELT": "to smelt again [v -ED, -ING, -S]\n",
  "RESMELTED": "RESMELT, to smelt again [v]\n",
  "RESMELTING": "RESMELT, to smelt again [v]\n",
  "RESMELTS": "RESMELT, to smelt again [v]\n",
  "RESMOOTH": "to smooth again [v -ED, -ING, -S]\n",
  "RESMOOTHED": "RESMOOTH, to smooth again [v]\n",
  "RESMOOTHING": "RESMOOTH, to smooth again [v]\n",
  "RESMOOTHS": "RESMOOTH, to smooth again [v]\n",
  "RESNATRON": "a high-power, high-frequency tetrode [n -S]\n",
  "RESNATRONS": "RESNATRON, a high-power, high-frequency tetrode [n]\n",
  "RESOAK": "to soak again [v -ED, -ING, -S]\n",
  "RESOAKED": "RESOAK, to soak again [v]\n",
  "RESOAKING": "RESOAK, to soak again [v]\n",
  "RESOAKS": "RESOAK, to soak again [v]\n",
  "RESOCIALISATION": "the act of resocialising, also RESOCIALIZATION [n]\n",
  "RESOCIALISE": "to socialise again, also RESOCIALIZE [v RESOCIALISED, RESOCIALISING, RESOCIALISES]\n",
  "RESOCIALISED": "RESOCIALISE, to socialise again, also RESOCIALIZE [v]\n",
  "RESOCIALISES": "RESOCIALISE, to socialise again, also RESOCIALIZE [v]\n",
  "RESOCIALISING": "RESOCIALISE, to socialise again, also RESOCIALIZE [v]\n",
  "RESOCIALIZATION": "the act of resocializing, also RESOCIALISATION [n]\n",
  "RESOCIALIZE": "to socialize again, also RESOCIALISE [v RESOCIALIZED, RESOCIALIZING, RESOCIALIZES]\n",
  "RESOCIALIZED": "RESOCIALIZE, to socialize again, also RESOCIALISE [v]\n",
  "RESOCIALIZES": "RESOCIALIZE, to socialize again, also RESOCIALISE [v]\n",
  "RESOCIALIZING": "RESOCIALIZE, to socialize again, also RESOCIALISE [v]\n",
  "RESOD": "to put down new turf [v RESODDED, RESODDING, RESODS]\n",
  "RESODDED": "RESOD, to put down new turf [v]\n",
  "RESODDING": "RESOD, to put down new turf [v]\n",
  "RESODS": "RESOD, to put down new turf [v]\n",
  "RESOFTEN": "to soften again [v -ED, -ING, -S]\n",
  "RESOFTENED": "RESOFTEN, to soften again [v]\n",
  "RESOFTENING": "RESOFTEN, to soften again [v]\n",
  "RESOFTENS": "RESOFTEN, to soften again [v]\n",
  "RESOJET": "a pulsejet [n -S]\n",
  "RESOJETS": "RESOJET, a pulsejet [n]\n",
  "RESOLD": "RESELL, to sell again [v]\n",
  "RESOLDER": "to solder again [v -ED, -ING, -S]\n",
  "RESOLDERED": "RESOLDER, to solder again [v]\n",
  "RESOLDERING": "RESOLDER, to solder again [v]\n",
  "RESOLDERS": "RESOLDER, to solder again [v]\n",
  "RESOLE": "to put on new soles [v RESOLED, RESOLING, RESOLES]\n",
  "RESOLED": "RESOLE, to put on new soles [v]\n",
  "RESOLES": "RESOLE, to put on new soles [v]\n",
  "RESOLIDIFIED": "RESOLIDIFY, to solidify again [v]\n",
  "RESOLIDIFIES": "RESOLIDIFY, to solidify again [v]\n",
  "RESOLIDIFY": "to solidify again [v RESOLIDIFIED, RESOLIDIFYING, RESOLIDIFIES]\n",
  "RESOLIDIFYING": "RESOLIDIFY, to solidify again [v]\n",
  "RESOLING": "RESOLE, to put on new soles [v]\n",
  "RESOLUBILITIES": "RESOLUBILITY, the state of being resoluble [n]\n",
  "RESOLUBILITY": "the state of being resoluble [n RESOLUBILITIES]\n",
  "RESOLUBLE": "able to be dissolved again [adj]\n",
  "RESOLUBLENESS": "the state of being resoluble [n -ES]\n",
  "RESOLUBLENESSES": "RESOLUBLENESS, the state of being resoluble [n]\n",
  "RESOLUTE": "determined [adj RESOLUTER, RESOLUTEST, RESOLUTELY] / (Shakespeare) a determined person [n -S]\n",
  "RESOLUTELY": "RESOLUTE, determined [adv]\n",
  "RESOLUTENESS": "the state of being resolute [n -ES]\n",
  "RESOLUTENESSES": "RESOLUTENESS, the state of being resolute [n]\n",
  "RESOLUTER": "RESOLUTE, determined [adj]\n",
  "RESOLUTES": "RESOLUTE, (Shakespeare) a determined person [n]\n",
  "RESOLUTEST": "RESOLUTE, determined [adj]\n",
  "RESOLUTION": "the act of resolving [n -S]\n",
  "RESOLUTIONER": "one who joins in or accepts a resolution [n -S]\n",
  "RESOLUTIONERS": "RESOLUTIONER, one who joins in or accepts a resolution [n]\n",
  "RESOLUTIONIST": "one who makes a resolution [n -S]\n",
  "RESOLUTIONISTS": "RESOLUTIONIST, one who makes a resolution [n]\n",
  "RESOLUTIONS": "RESOLUTION, the act of resolving [n]\n",
  "RESOLUTIVE": "serving to dissolve or relax [adj]\n",
  "RESOLVABILITIES": "RESOLVABILITY, the quality of being resolvable [n]\n",
  "RESOLVABILITY": "the quality of being resolvable [n RESOLVABILITIES]\n",
  "RESOLVABLE": "that can be resolved [adj]\n",
  "RESOLVABLENESS": "the state of being resolvable [n]\n",
  "RESOLVE": "to make a firm decision about [v RESOLVED, RESOLVING, RESOLVES]\n",
  "RESOLVED": "RESOLVE, to make a firm decision about [v]\n",
  "RESOLVEDLY": "RESOLVED, RESOLVE, to make a firm decision about [adv]\n",
  "RESOLVEDNESS": "the state of being resolved [n -ES]\n",
  "RESOLVEDNESSES": "RESOLVEDNESS, the state of being resolved [n]\n",
  "RESOLVENT": "a means of removing a difficulty, settling a problem [n -S]\n",
  "RESOLVENTS": "RESOLVENT, a means of removing a difficulty, settling a problem [n]\n",
  "RESOLVER": "one that resolves [n -S]\n",
  "RESOLVERS": "RESOLVER, one that resolves [n]\n",
  "RESOLVES": "RESOLVE, to make a firm decision about [v]\n",
  "RESOLVING": "RESOLVE, to make a firm decision about [v]\n",
  "RESONANCE": "resounding, sonority [n -S]\n",
  "RESONANCES": "RESONANCE, resounding, sonority [n]\n",
  "RESONANT": "resounding, ringing [adj RESONANTLY] / a liquid or nasal consonant [n -S]\n",
  "RESONANTLY": "RESONANT, resounding, ringing [adv]\n",
  "RESONANTS": "RESONANT, a liquid or nasal consonant [n]\n",
  "RESONATE": "to resound [v RESONATED, RESONATING, RESONATES]\n",
  "RESONATED": "RESONATE, to resound [v]\n",
  "RESONATES": "RESONATE, to resound [v]\n",
  "RESONATING": "RESONATE, to resound [v]\n",
  "RESONATION": "the act of resonating [n -S]\n",
  "RESONATIONS": "RESONATION, the act of resonating [n]\n",
  "RESONATOR": "a resonating body or device for increasing sound [n -S]\n",
  "RESONATORS": "RESONATOR, a resonating body or device for increasing sound [n]\n",
  "RESORB": "to absorb again [v -ED, -ING, -S]\n",
  "RESORBED": "RESORB, to absorb again [v]\n",
  "RESORBENCE": "reabsorption [n -S]\n",
  "RESORBENCES": "RESORBENCE, reabsorption [n]\n",
  "RESORBENT": "absorbing again [adj]\n",
  "RESORBING": "RESORB, to absorb again [v]\n",
  "RESORBS": "RESORB, to absorb again [v]\n",
  "RESORCIN": "a colourless phenol used in dyeing, photography and medicine, also RESORCINOL [n -S]\n",
  "RESORCINAL": "of or like resorcinol [adj]\n",
  "RESORCINOL": "a colourless phenol used in dyeing, photography and medicine, also RESORCIN [n -S]\n",
  "RESORCINOLS": "RESORCINOL, a colourless phenol used in dyeing, photography and medicine, also RESORCIN [n]\n",
  "RESORCINS": "RESORCIN, a colourless phenol used in dyeing, photography and medicine, also RESORCINOL [n]\n",
  "RESORPTION": "the act of resorbing, esp. of a mineral by rock magma [n -S]\n",
  "RESORPTIONS": "RESORPTION, the act of resorbing, esp. of a mineral by rock magma [n]\n",
  "RESORPTIVE": "relating to resorption [adj]\n",
  "RESORT": "to sort again or differently [v -ED, -ING, -S]\n",
  "RESORTED": "RESORT, to sort again or differently [v]\n",
  "RESORTER": "one who resorts [n -S]\n",
  "RESORTERS": "RESORTER, one who resorts [n]\n",
  "RESORTING": "RESORT, to sort again or differently [v]\n",
  "RESORTS": "RESORT, to sort again or differently [v]\n",
  "RESOUGHT": "RESEEK, to seek again [v]\n",
  "RESOUND": "to make an echoing sound [v -ED, -ING, -S]\n",
  "RESOUNDED": "RESOUND, to make an echoing sound [v]\n",
  "RESOUNDING": "RESOUND, to make an echoing sound [v]\n",
  "RESOUNDINGLY": "RESOUNDING [adv]\n",
  "RESOUNDS": "RESOUND, to make an echoing sound [v]\n",
  "RESOURCE": "to provide for [v RESOURCED, RESOURCING, RESOURCES]\n",
  "RESOURCED": "RESOURCE, to provide for [v]\n",
  "RESOURCEFUL": "able to meet situations [adj RESOURCEFULLY]\n",
  "RESOURCEFULLY": "RESOURCEFUL, able to meet situations [adv]\n",
  "RESOURCEFULNESS": "the state of being resourceful [n]\n",
  "RESOURCELESS": "without resources [adj]\n",
  "RESOURCES": "RESOURCE, to provide for [v]\n",
  "RESOURCING": "the act of providing a resource [n -S]\n",
  "RESOURCINGS": "RESOURCING, the act of providing a resource [n]\n",
  "RESOW": "to sow again [v RESOWED, RESOWN, RESOWING, RESOWS]\n",
  "RESOWED": "RESOW, to sow again [v]\n",
  "RESOWING": "RESOW, to sow again [v]\n",
  "RESOWN": "RESOW, to sow again [v]\n",
  "RESOWS": "RESOW, to sow again [v]\n",
  "RESPACE": "to provide new spacing [v RESPACED, RESPACING, RESPACES]\n",
  "RESPACED": "RESPACE, to provide new spacing [v]\n",
  "RESPACES": "RESPACE, to provide new spacing [v]\n",
  "RESPACING": "RESPACE, to provide new spacing [v]\n",
  "RESPADE": "to turn over soil again [v RESPADED, RESPADING, RESPADES]\n",
  "RESPADED": "RESPADE, to turn over soil again [v]\n",
  "RESPADES": "RESPADE, to turn over soil again [v]\n",
  "RESPADING": "RESPADE, to turn over soil again [v]\n",
  "RESPEAK": "(Shakespeare) to speak again [v RESPOKE, RESPOKEN, RESPEAKING, RESPEAKS]\n",
  "RESPEAKING": "RESPEAK, (Shakespeare) to speak again [v]\n",
  "RESPEAKS": "RESPEAK, (Shakespeare) to speak again [v]\n",
  "RESPECIFIED": "RESPECIFY, to specify again [v]\n",
  "RESPECIFIES": "RESPECIFY, to specify again [v]\n",
  "RESPECIFY": "to specify again [v RESPECIFIED, RESPECIFYING, RESPECIFIES]\n",
  "RESPECIFYING": "RESPECIFY, to specify again [v]\n",
  "RESPECT": "to have high regard for [v -ED, -ING, -S]\n",
  "RESPECTABILISE": "to make respectable, also RESPECTABILIZE [v RESPECTABILISED, RESPECTABILISES]\n",
  "RESPECTABILISED": "RESPECTABILISE, to make respectable, also RESPECTABILIZE [v]\n",
  "RESPECTABILISES": "RESPECTABILISE, to make respectable, also RESPECTABILIZE [v]\n",
  "RESPECTABILITY": "the state of being respectable [n]\n",
  "RESPECTABILIZE": "to make respectable, also RESPECTABILISE [v RESPECTABILIZED, RESPECTABILIZES]\n",
  "RESPECTABILIZED": "RESPECTABILIZE, to make respectable, also RESPECTABILISE [v]\n",
  "RESPECTABILIZES": "RESPECTABILIZE, to make respectable, also RESPECTABILISE [v]\n",
  "RESPECTABLE": "worthy of respect [adj RESPECTABLY] / one who is respectable [n -S]\n",
  "RESPECTABLENESS": "the state of being respectable [n]\n",
  "RESPECTABLES": "RESPECTABLE, one who is respectable [n]\n",
  "RESPECTABLY": "RESPECTABLE, worthy of respect [adv]\n",
  "RESPECTANT": "facing each other [adj]\n",
  "RESPECTED": "RESPECT, to have high regard for [v]\n",
  "RESPECTER": "one who respects [n -S]\n",
  "RESPECTERS": "RESPECTER, one who respects [n]\n",
  "RESPECTFUL": "marked by or showing respect [adj RESPECTFULLY]\n",
  "RESPECTFULLY": "RESPECTFUL, marked by or showing respect [adv]\n",
  "RESPECTFULNESS": "the state of being respectful [n]\n",
  "RESPECTING": "RESPECT, to have high regard for [v]\n",
  "RESPECTIVE": "particular, separate [adj RESPECTIVELY]\n",
  "RESPECTIVELY": "RESPECTIVE, particular, separate [adv]\n",
  "RESPECTIVENESS": "RESPECTIVE, particular, separate [n]\n",
  "RESPECTLESS": "without respect [adj]\n",
  "RESPECTS": "RESPECT, to have high regard for [v]\n",
  "RESPELL": "to spell again [v RESPELLED, RESPELT, RESPELLING, RESPELLS]\n",
  "RESPELLED": "RESPELL, to spell again [v]\n",
  "RESPELLING": "the act of respelling [n -S]\n",
  "RESPELLINGS": "RESPELLING, the act of respelling [n]\n",
  "RESPELLS": "RESPELL, to spell again [v]\n",
  "RESPELT": "RESPELL, to spell again [v]\n",
  "RESPIRABILITIES": "RESPIRABILITY, the quality of being respirable [n]\n",
  "RESPIRABILITY": "the quality of being respirable [n RESPIRABILITIES]\n",
  "RESPIRABLE": "fit for breathing [adj]\n",
  "RESPIRATION": "breathing; the taking in of oxygen and giving out of carbon dioxide [n -S]\n",
  "RESPIRATIONAL": "related to respiration [adj]\n",
  "RESPIRATIONS": "RESPIRATION, breathing; the taking in of oxygen and giving out of carbon dioxide [n]\n",
  "RESPIRATOR": "an appliance which provides artificial respiration [n -S]\n",
  "RESPIRATORS": "RESPIRATOR, an appliance which provides artificial respiration [n]\n",
  "RESPIRATORY": "related to respiration [adj]\n",
  "RESPIRE": "to breathe [v RESPIRED, RESPIRING, RESPIRES]\n",
  "RESPIRED": "RESPIRE, to breathe [v]\n",
  "RESPIRES": "RESPIRE, to breathe [v]\n",
  "RESPIRING": "RESPIRE, to breathe [v]\n",
  "RESPIRITUALISE": "to spiritualize again, also RESPIRITUALIZE [v RESPIRITUALISED, RESPIRITUALISES]\n",
  "RESPIRITUALISED": "RESPIRITUALISE, to spiritualize again, also RESPIRITUALIZE [v]\n",
  "RESPIRITUALISES": "RESPIRITUALISE, to spiritualize again, also RESPIRITUALIZE [v]\n",
  "RESPIRITUALIZE": "to spiritualize again, also RESPIRITUALISE [v RESPIRITUALIZED, RESPIRITUALIZES]\n",
  "RESPIRITUALIZED": "RESPIRITUALIZE, to spiritualize again, also RESPIRITUALISE [v]\n",
  "RESPIRITUALIZES": "RESPIRITUALIZE, to spiritualize again, also RESPIRITUALISE [v]\n",
  "RESPIROLOGIES": "RESPIROLOGY, the branch of medicine concerned with breathing [n]\n",
  "RESPIROLOGIST": "a student of respirology [n -S]\n",
  "RESPIROLOGISTS": "RESPIROLOGIST, a student of respirology [n]\n",
  "RESPIROLOGY": "the branch of medicine concerned with breathing [n RESPIROLOGIES]\n",
  "RESPIROMETER": "an instrument for measuring and studying respiration [n -S]\n",
  "RESPIROMETERS": "RESPIROMETER, an instrument for measuring and studying respiration [n]\n",
  "RESPIROMETRIC": "relating to measurement by respirometer [adj]\n",
  "RESPIROMETRIES": "RESPIROMETRY, measurement by respirometer [n]\n",
  "RESPIROMETRY": "measurement by respirometer [n RESPIROMETRIES]\n",
  "RESPITE": "to relieve temporarily [v RESPITED, RESPITING, RESPITES]\n",
  "RESPITED": "RESPITE, to relieve temporarily [v]\n",
  "RESPITELESS": "without a respite [adj]\n",
  "RESPITES": "RESPITE, to relieve temporarily [v]\n",
  "RESPITING": "RESPITE, to relieve temporarily [v]\n",
  "RESPLEND": "to shine brilliantly [v -ED, -ING, -S]\n",
  "RESPLENDED": "RESPLEND, to shine brilliantly [v]\n",
  "RESPLENDENCE": "the state of being resplendent, also RESPLENDENCY [n -S]\n",
  "RESPLENDENCES": "RESPLENDENCE, the state of being resplendent, also RESPLENDENCY [n]\n",
  "RESPLENDENCIES": "RESPLENDENCY, the state of being resplendent, also RESPLENDENCE [n]\n",
  "RESPLENDENCY": "the state of being resplendent, also RESPLENDENCE [n RESPLENDENCIES]\n",
  "RESPLENDENT": "shining brilliantly [adj RESPLENDENTLY]\n",
  "RESPLENDENTLY": "RESPLENDENT, shining brilliantly [adv]\n",
  "RESPLENDING": "RESPLEND, to shine brilliantly [v]\n",
  "RESPLENDS": "RESPLEND, to shine brilliantly [v]\n",
  "RESPLICE": "to splice again [v RESPLICED, RESPLICING, RESPLICES]\n",
  "RESPLICED": "RESPLICE, to splice again [v]\n",
  "RESPLICES": "RESPLICE, to splice again [v]\n",
  "RESPLICING": "RESPLICE, to splice again [v]\n",
  "RESPLIT": "to split again [v RESPLIT, RESPLITTING, RESPLITS]\n",
  "RESPLITS": "RESPLIT, to split again [v]\n",
  "RESPLITTING": "RESPLIT, to split again [v]\n",
  "RESPOKE": "RESPEAK, (Shakespeare) to speak again [v]\n",
  "RESPOKEN": "RESPEAK, (Shakespeare) to speak again [v]\n",
  "RESPOND": "to say or act in return [v -ED, -ING, -S]\n",
  "RESPONDED": "RESPOND, to say or act in return [v]\n",
  "RESPONDENCE": "correspondence, agreement, also RESPONDENCY [n -S]\n",
  "RESPONDENCES": "RESPONDENCE, correspondence, agreement, also RESPONDENCY [n]\n",
  "RESPONDENCIES": "RESPONDENCY, correspondence, agreement, also RESPONDENCE [n]\n",
  "RESPONDENCY": "correspondence, agreement, also RESPONDENCE [n RESPONDENCIES]\n",
  "RESPONDENT": "one who maintains a thesis in reply [n -S]\n",
  "RESPONDENTIA": "a loan on a ship's cargo payable on safe arrival [n -S]\n",
  "RESPONDENTIAS": "RESPONDENTIA, a loan on a ship's cargo payable on safe arrival [n]\n",
  "RESPONDENTS": "RESPONDENT, one who maintains a thesis in reply [n]\n",
  "RESPONDER": "one who responds, also RESPONSER, RESPONSOR [n -S]\n",
  "RESPONDERS": "RESPONDER, one who responds, also RESPONSER, RESPONSOR [n]\n",
  "RESPONDING": "RESPOND, to say or act in return [v]\n",
  "RESPONDS": "RESPOND, to say or act in return [v]\n",
  "RESPONSA": "RESPONSUM, (Latin) in rabbinical literature, a written response to a question of doctrine [n]\n",
  "RESPONSE": "a reply or reaction [n -S]\n",
  "RESPONSELESS": "without a response [adj]\n",
  "RESPONSER": "one who responds, also RESPONDER, RESPONSOR [n -S]\n",
  "RESPONSERS": "RESPONSER, one who responds, also RESPONDER, RESPONSOR [n]\n",
  "RESPONSES": "RESPONSE, a reply or reaction [n]\n",
  "RESPONSIBILITY": "moral, legal, or mental accountability [n]\n",
  "RESPONSIBLE": "liable to be called to account as being in charge or control; answerable, also SPONSIBLE [adj RESPONSIBLY]\n",
  "RESPONSIBLENESS": "the state of being responsible [n]\n",
  "RESPONSIBLY": "RESPONSIBLE, liable to be called to account as being in charge or control; answerable, also SPONSIBLE [adv]\n",
  "RESPONSIONS": "the first examination for BA degree at Oxford University [n]\n",
  "RESPONSIVE": "giving response [adj RESPONSIVELY]\n",
  "RESPONSIVELY": "RESPONSIVE, giving response [adv]\n",
  "RESPONSIVENESS": "the state of being responsive [n]\n",
  "RESPONSOR": "one who responds, also RESPONDER, RESPONSER [n -S]\n",
  "RESPONSORIAL": "an office-book containing the responsories [n -S]\n",
  "RESPONSORIALS": "RESPONSORIAL, an office-book containing the responsories [n]\n",
  "RESPONSORIES": "RESPONSORY, a set of responses sung or said after liturgical reading [n]\n",
  "RESPONSORS": "RESPONSOR, one who responds, also RESPONDER, RESPONSER [n]\n",
  "RESPONSORY": "a set of responses sung or said after liturgical reading [n RESPONSORIES]\n",
  "RESPONSUM": "(Latin) in rabbinical literature, a written response to a question of doctrine [n RESPONSA or RESPONSUMS]\n",
  "RESPONSUMS": "RESPONSUM, (Latin) in rabbinical literature, a written response to a question of doctrine [n]\n",
  "RESPOOL": "to spool again [v -ED, -ING, -S]\n",
  "RESPOOLED": "RESPOOL, to spool again [v]\n",
  "RESPOOLING": "RESPOOL, to spool again [v]\n",
  "RESPOOLS": "RESPOOL, to spool again [v]\n",
  "RESPOT": "to spot again [v RESPOTTED, RESPOTTING, RESPOTS]\n",
  "RESPOTS": "RESPOT, to spot again [v]\n",
  "RESPOTTED": "RESPOT, to spot again [v]\n",
  "RESPOTTING": "RESPOT, to spot again [v]\n",
  "RESPRANG": "RESPRING, to replace the springs of [v]\n",
  "RESPRAY": "to spray again [v -ED, -ING, -S]\n",
  "RESPRAYED": "RESPRAY, to spray again [v]\n",
  "RESPRAYING": "RESPRAY, to spray again [v]\n",
  "RESPRAYS": "RESPRAY, to spray again [v]\n",
  "RESPREAD": "to spread again [v RESPREAD, RESPREADING, RESPREADS]\n",
  "RESPREADING": "RESPREAD, to spread again [v]\n",
  "RESPREADS": "RESPREAD, to spread again [v]\n",
  "RESPRING": "to replace the springs of [v RESPRANG, RESPRUNG, RESPRINGING, RESPRINGS]\n",
  "RESPRINGING": "RESPRING, to replace the springs of [v]\n",
  "RESPRINGS": "RESPRING, to replace the springs of [v]\n",
  "RESPROUT": "to sprout again [v -ED, -ING, -S]\n",
  "RESPROUTED": "RESPROUT, to sprout again [v]\n",
  "RESPROUTING": "RESPROUT, to sprout again [v]\n",
  "RESPROUTS": "RESPROUT, to sprout again [v]\n",
  "RESPRUNG": "RESPRING, to replace the springs of [v]\n",
  "RESSALDAR": "(Urdu) an Indian troop commander, also RISALDAR [n -S]\n",
  "RESSALDARS": "RESSALDAR, (Urdu) an Indian troop commander, also RISALDAR [n]\n",
  "RESSENTIMENT": "a feeling of resentment and hostility accompanied by the lack of means to express or act upon it [n -S]\n",
  "RESSENTIMENTS": "RESSENTIMENT, a feeling of resentment and hostility accompanied by the lack of means to express or act upon it [n]\n",
  "REST": "to stop work or activity for repose [v -ED, -ING, -S]\n",
  "RESTABILISE": "to stabilise again, also RESTABILIZE [v RESTABILISED, RESTABILISING, RESTABILISES]\n",
  "RESTABILISED": "RESTABILISE, to stabilise again, also RESTABILIZE [v]\n",
  "RESTABILISES": "RESTABILISE, to stabilise again, also RESTABILIZE [v]\n",
  "RESTABILISING": "RESTABILISE, to stabilise again, also RESTABILIZE [v]\n",
  "RESTABILIZE": "to stabilize again, also RESTABILISE [v RESTABILIZED, RESTABILIZING, RESTABILIZES]\n",
  "RESTABILIZED": "RESTABILIZE, to stabilize again, also RESTABILISE [v]\n",
  "RESTABILIZES": "RESTABILIZE, to stabilize again, also RESTABILISE [v]\n",
  "RESTABILIZING": "RESTABILIZE, to stabilize again, also RESTABILISE [v]\n",
  "RESTABLE": "to put in stables again [v RESTABLED, RESTABLING, RESTABLES]\n",
  "RESTABLED": "RESTABLE, to put in stables again [v]\n",
  "RESTABLES": "RESTABLE, to put in stables again [v]\n",
  "RESTABLING": "RESTABLE, to put in stables again [v]\n",
  "RESTACK": "to stack again [v -ED, -ING, -S]\n",
  "RESTACKED": "RESTACK, to stack again [v]\n",
  "RESTACKING": "RESTACK, to stack again [v]\n",
  "RESTACKS": "RESTACK, to stack again [v]\n",
  "RESTAFF": "to staff again [v -ED, -ING, -S]\n",
  "RESTAFFED": "RESTAFF, to staff again [v]\n",
  "RESTAFFING": "RESTAFF, to staff again [v]\n",
  "RESTAFFS": "RESTAFF, to staff again [v]\n",
  "RESTAGE": "to put on the same play again [v RESTAGED, RESTAGING, RESTAGES]\n",
  "RESTAGED": "RESTAGE, to put on the same play again [v]\n",
  "RESTAGES": "RESTAGE, to put on the same play again [v]\n",
  "RESTAGING": "RESTAGE, to put on the same play again [v]\n",
  "RESTAMP": "to stamp again [v -ED, -ING, -S]\n",
  "RESTAMPED": "RESTAMP, to stamp again [v]\n",
  "RESTAMPING": "RESTAMP, to stamp again [v]\n",
  "RESTAMPS": "RESTAMP, to stamp again [v]\n",
  "RESTART": "to start again [v -ED, -ING, -S]\n",
  "RESTARTABLE": "capable of being restarted [adj]\n",
  "RESTARTED": "RESTART, to start again [v]\n",
  "RESTARTER": "something or someone that restarts [n -S]\n",
  "RESTARTERS": "RESTARTER, something or someone that restarts [n]\n",
  "RESTARTING": "RESTART, to start again [v]\n",
  "RESTARTS": "RESTART, to start again [v]\n",
  "RESTATE": "to state again [v RESTATED, RESTATING, RESTATES]\n",
  "RESTATED": "RESTATE, to state again [v]\n",
  "RESTATEMENT": "something that is restated [n -S]\n",
  "RESTATEMENTS": "RESTATEMENT, something that is restated [n]\n",
  "RESTATES": "RESTATE, to state again [v]\n",
  "RESTATING": "RESTATE, to state again [v]\n",
  "RESTATION": "to station again [v -ED, -ING, -S]\n",
  "RESTATIONED": "RESTATION, to station again [v]\n",
  "RESTATIONING": "RESTATION, to station again [v]\n",
  "RESTATIONS": "RESTATION, to station again [v]\n",
  "RESTAURANT": "a business establishment where meals or refreshments may be purchased [n -S]\n",
  "RESTAURANTEUR": "(French) one who frequents restaurants [n -S]\n",
  "RESTAURANTEURS": "RESTAURANTEUR, (French) one who frequents restaurants [n]\n",
  "RESTAURANTS": "RESTAURANT, a business establishment where meals or refreshments may be purchased [n]\n",
  "RESTAURATEUR": "(French) the operator or proprietor of a restaurant [n -S]\n",
  "RESTAURATEURS": "RESTAURATEUR, (French) the operator or proprietor of a restaurant [n]\n",
  "RESTAURATION": "the business, skill or art of a restaurateur [n -S]\n",
  "RESTAURATIONS": "RESTAURATION, the business, skill or art of a restaurateur [n]\n",
  "RESTED": "REST, to stop work or activity for repose [v]\n",
  "RESTEM": "(Shakespeare) to force against the current [v RESTEMMED, RESTEMMING, RESTEMS]\n",
  "RESTEMMED": "RESTEM, (Shakespeare) to force against the current [v]\n",
  "RESTEMMING": "RESTEM, (Shakespeare) to force against the current [v]\n",
  "RESTEMS": "RESTEM, (Shakespeare) to force against the current [v]\n",
  "RESTER": "one who rests [n -S]\n",
  "RESTERS": "RESTER, one who rests [n]\n",
  "RESTFUL": "relaxing [adj RESTFULLER, RESTFULLEST, RESTFULLY]\n",
  "RESTFULLER": "RESTFUL, relaxing [adj]\n",
  "RESTFULLEST": "RESTFUL, relaxing [adj]\n",
  "RESTFULLY": "RESTFUL, relaxing [adv]\n",
  "RESTFULNESS": "the state of being restful [n -ES]\n",
  "RESTFULNESSES": "RESTFULNESS, the state of being restful [n]\n",
  "RESTHARROW": "a wild flower [n -S]\n",
  "RESTHARROWS": "RESTHARROW, a wild flower [n]\n",
  "RESTIER": "RESTY, (obsolete) restive [adj]\n",
  "RESTIEST": "RESTY, (obsolete) restive [adj]\n",
  "RESTIFF": "(obsolete) restive [adj]\n",
  "RESTIFORM": "cordlike [adj]\n",
  "RESTIMULATE": "to stimulate again [v RESTIMULATED, RESTIMULATING, RESTIMULATES]\n",
  "RESTIMULATED": "RESTIMULATE, to stimulate again [v]\n",
  "RESTIMULATES": "RESTIMULATE, to stimulate again [v]\n",
  "RESTIMULATING": "RESTIMULATE, to stimulate again [v]\n",
  "RESTIMULATION": "the act of restimulating [n -S]\n",
  "RESTIMULATIONS": "RESTIMULATION, the act of restimulating [n]\n",
  "RESTING": "the act of resting [n -S]\n",
  "RESTINGS": "RESTING, the act of resting [n]\n",
  "RESTITCH": "to stitch again [v -ED, -ING, -ES]\n",
  "RESTITCHED": "RESTITCH, to stitch again [v]\n",
  "RESTITCHES": "RESTITCH, to stitch again [v]\n",
  "RESTITCHING": "RESTITCH, to stitch again [v]\n",
  "RESTITUTE": "(archaic) to restore to a former state [v RESTITUTED, RESTITUTING, RESTITUTES]\n",
  "RESTITUTED": "RESTITUTE, (archaic) to restore to a former state [v]\n",
  "RESTITUTES": "RESTITUTE, (archaic) to restore to a former state [v]\n",
  "RESTITUTING": "RESTITUTE, (archaic) to restore to a former state [v]\n",
  "RESTITUTION": "a restoration of something to its rightful owner [n -S]\n",
  "RESTITUTIONISM": "the belief that after a purgation all sinners and angels will be restored to the favour of God, aka restorationism [n -S]\n",
  "RESTITUTIONISMS": "RESTITUTIONISM, the belief that after a purgation all sinners and angels will be restored to the favour of God, aka restorationism [n]\n",
  "RESTITUTIONIST": "a believer in restitutionism [n -S]\n",
  "RESTITUTIONISTS": "RESTITUTIONIST, a believer in restitutionism [n]\n",
  "RESTITUTIONS": "RESTITUTION, a restoration of something to its rightful owner [n]\n",
  "RESTITUTIVE": "relating to restitution [adj]\n",
  "RESTITUTOR": "one who makes restitution [n -S]\n",
  "RESTITUTORS": "RESTITUTOR, one who makes restitution [n]\n",
  "RESTITUTORY": "serving to restitute [adj]\n",
  "RESTIVE": "uneasy, as if ready to break from control [adj]\n",
  "RESTIVELY": "RESTIVE, uneasy, as if ready to break from control [adv]\n",
  "RESTIVENESS": "the state of being restive [n -ES]\n",
  "RESTIVENESSES": "RESTIVENESS, the state of being restive [n]\n",
  "RESTLESS": "unable to remain at rest [adj RESTLESSLY]\n",
  "RESTLESSLY": "RESTLESS, unable to remain at rest [adv]\n",
  "RESTLESSNESS": "the state of being restless [n -ES]\n",
  "RESTLESSNESSES": "RESTLESSNESS, the state of being restless [n]\n",
  "RESTO": "(Australian slang) a restored antique, vintage car etc. [n -S]\n",
  "RESTOCK": "to stock again [v -ED, -ING, -S]\n",
  "RESTOCKED": "RESTOCK, to stock again [v]\n",
  "RESTOCKING": "RESTOCK, to stock again [v]\n",
  "RESTOCKS": "RESTOCK, to stock again [v]\n",
  "RESTOKE": "to stoke again [v RESTOKED, RESTOKING, RESTOKES]\n",
  "RESTOKED": "RESTOKE, to stoke again [v]\n",
  "RESTOKES": "RESTOKE, to stoke again [v]\n",
  "RESTOKING": "RESTOKE, to stoke again [v]\n",
  "RESTORABLE": "fit for restoring or reclaiming [adj]\n",
  "RESTORABLENESS": "the state of being restorable [n]\n",
  "RESTORAL": "restoration [n -S]\n",
  "RESTORALS": "RESTORAL, restoration [n]\n",
  "RESTORATION": "a bringing back to a former position or condition, also RESTORAL [n -S]\n",
  "RESTORATIONISM": "the belief that after a purgation all sinners and angels will be restored to the favour of God, aka restitutionism [n -S]\n",
  "RESTORATIONISMS": "RESTORATIONISM, the belief that after a purgation all sinners and angels will be restored to the favour of God, aka restitutionism [n]\n",
  "RESTORATIONIST": "a believer in restorationism [n -S]\n",
  "RESTORATIONISTS": "RESTORATIONIST, a believer in restorationism [n]\n",
  "RESTORATIONS": "RESTORATION, a bringing back to a former position or condition, also RESTORAL [n]\n",
  "RESTORATIVE": "serving to restore to consciousness, vigor, or health [adj RESTORATIVELY] / a restorative medicine [n -S]\n",
  "RESTORATIVELY": "RESTORATIVE, serving to restore to consciousness, vigor, or health [adv]\n",
  "RESTORATIVES": "RESTORATIVE, a restorative medicine [n]\n",
  "RESTORE": "to bring back to the original condition [v RESTORED, RESTORING, RESTORES]\n",
  "RESTORED": "RESTORE, to bring back to the original condition [v]\n",
  "RESTORER": "one that restores [n -S]\n",
  "RESTORERS": "RESTORER, one that restores [n]\n",
  "RESTORES": "RESTORE, to bring back to the original condition [v]\n",
  "RESTORING": "RESTORE, to bring back to the original condition [v]\n",
  "RESTOS": "RESTO, (Australian slang) a restored antique, vintage car etc. [n]\n",
  "RESTRAIN": "to hold back [v -ED, -ING, -S]\n",
  "RESTRAINABLE": "capable of being restrained [adj]\n",
  "RESTRAINED": "RESTRAIN, to hold back [v]\n",
  "RESTRAINEDLY": "RESTRAINED, RESTRAIN, to hold back [adv]\n",
  "RESTRAINEDNESS": "the state of being restrained [n]\n",
  "RESTRAINER": "one who restrains [n -S]\n",
  "RESTRAINERS": "RESTRAINER, one who restrains [n]\n",
  "RESTRAINING": "the act of restraining [n -S]\n",
  "RESTRAININGS": "RESTRAINING, the act of restraining [n]\n",
  "RESTRAINS": "RESTRAIN, to hold back [v]\n",
  "RESTRAINT": "the act of restraining [n -S]\n",
  "RESTRAINTS": "RESTRAINT, the act of restraining [n]\n",
  "RESTRENGTHEN": "to strengthen again [v -ED, -ING, -S]\n",
  "RESTRENGTHENED": "RESTRENGTHEN, to strengthen again [v]\n",
  "RESTRENGTHENING": "RESTRENGTHEN, to strengthen again [v]\n",
  "RESTRENGTHENS": "RESTRENGTHEN, to strengthen again [v]\n",
  "RESTRESS": "to stress again [v -ED, -ING, -ES]\n",
  "RESTRESSED": "RESTRESS, to stress again [v]\n",
  "RESTRESSES": "RESTRESS, to stress again [v]\n",
  "RESTRESSING": "RESTRESS, to stress again [v]\n",
  "RESTRETCH": "to stretch again [v -ED, -ING, -ES]\n",
  "RESTRETCHED": "RESTRETCH, to stretch again [v]\n",
  "RESTRETCHES": "RESTRETCH, to stretch again [v]\n",
  "RESTRETCHING": "RESTRETCH, to stretch again [v]\n",
  "RESTRICKEN": "RESTRIKE, to strike again [v]\n",
  "RESTRICT": "to keep within boundaries [v -ED, -ING, -S]\n",
  "RESTRICTED": "RESTRICT, to keep within boundaries [v]\n",
  "RESTRICTEDLY": "RESTRICTED, RESTRICT, to keep within boundaries [adv]\n",
  "RESTRICTEDNESS": "the state of being restricted [n]\n",
  "RESTRICTING": "RESTRICT, to keep within boundaries [v]\n",
  "RESTRICTION": "a regulation that restricts or restrains [n -S]\n",
  "RESTRICTIONISM": "a policy or philosophy favoring restriction, as of trade or immigration [n -S]\n",
  "RESTRICTIONISMS": "RESTRICTIONISM, a policy or philosophy favoring restriction, as of trade or immigration [n]\n",
  "RESTRICTIONIST": "a supporter of restrictionism [n -S]\n",
  "RESTRICTIONISTS": "RESTRICTIONIST, a supporter of restrictionism [n]\n",
  "RESTRICTIONS": "RESTRICTION, a regulation that restricts or restrains [n]\n",
  "RESTRICTIVE": "of or relating to restriction [adj RESTRICTIVELY] / something that restricts [n -S]\n",
  "RESTRICTIVELY": "RESTRICTIVE, of or relating to restriction [adv]\n",
  "RESTRICTIVENESS": "RESTRICTIVE, of or relating to restriction [n]\n",
  "RESTRICTIVES": "RESTRICTIVE, something that restricts [n]\n",
  "RESTRICTS": "RESTRICT, to keep within boundaries [v]\n",
  "RESTRIKE": "to strike again [v RESTRUCK, RESTRICKEN, RESTRIKING, RESTRIKES]\n",
  "RESTRIKES": "RESTRIKE, to strike again [v]\n",
  "RESTRIKING": "RESTRIKE, to strike again [v]\n",
  "RESTRING": "to string again [v RESTRUNG or RESTRINGED, RESTRINGING, RESTRINGS]\n",
  "RESTRINGE": "to restrict [v RESTRINGED, RESTRINGEING, RESTRINGES]\n",
  "RESTRINGED": "RESTRING, to string again [v]\n",
  "RESTRINGEING": "RESTRINGE, to restrict [v]\n",
  "RESTRINGENT": "an astringent [n -S]\n",
  "RESTRINGENTS": "RESTRINGENT, an astringent [n]\n",
  "RESTRINGES": "RESTRINGE, to restrict [v]\n",
  "RESTRINGING": "RESTRING, to string again [v]\n",
  "RESTRINGS": "RESTRING, to string again [v]\n",
  "RESTRIVE": "to strive again [v RESTROVE, RESTRIVEN, RESTRIVING, RESTRIVES]\n",
  "RESTRIVEN": "RESTRIVE, to strive again [v]\n",
  "RESTRIVES": "RESTRIVE, to strive again [v]\n",
  "RESTRIVING": "RESTRIVE, to strive again [v]\n",
  "RESTROOM": "a room furnished with toilets and washbasins [n -S]\n",
  "RESTROOMS": "RESTROOM, a room furnished with toilets and washbasins [n]\n",
  "RESTROVE": "RESTRIVE, to strive again [v]\n",
  "RESTRUCK": "RESTRIKE, to strike again [v]\n",
  "RESTRUCTURE": "to change the makeup, organization, or pattern of [v RESTRUCTURED, RESTRUCTURING, RESTRUCTURES]\n",
  "RESTRUCTURED": "RESTRUCTURE, to change the makeup, organization, or pattern of [v]\n",
  "RESTRUCTURES": "RESTRUCTURE, to change the makeup, organization, or pattern of [v]\n",
  "RESTRUCTURING": "the act of changing the structure of something [n -S]\n",
  "RESTRUCTURINGS": "RESTRUCTURING, the act of changing the structure of something [n]\n",
  "RESTRUNG": "RESTRING, to string again [v]\n",
  "RESTS": "REST, to stop work or activity for repose [v]\n",
  "RESTUDIED": "RESTUDY, to study again [v]\n",
  "RESTUDIES": "RESTUDY, to study again [v]\n",
  "RESTUDY": "to study again [v RESTUDIED, RESTUDYING, RESTUDIES]\n",
  "RESTUDYING": "RESTUDY, to study again [v]\n",
  "RESTUFF": "to stuff again [v -ED, -ING, -S]\n",
  "RESTUFFED": "RESTUFF, to stuff again [v]\n",
  "RESTUFFING": "RESTUFF, to stuff again [v]\n",
  "RESTUFFS": "RESTUFF, to stuff again [v]\n",
  "RESTUMP": "(Australian) to provide (a building) with new stumps [v -ED, -ING, -S]\n",
  "RESTUMPED": "RESTUMP, (Australian) to provide (a building) with new stumps [v]\n",
  "RESTUMPING": "RESTUMP, (Australian) to provide (a building) with new stumps [v]\n",
  "RESTUMPS": "RESTUMP, (Australian) to provide (a building) with new stumps [v]\n",
  "RESTY": "(obsolete) restive [adj RESTIER, RESTIEST]\n",
  "RESTYLE": "to make into a new style [v RESTYLED, RESTYLING, RESTYLES]\n",
  "RESTYLED": "RESTYLE, to make into a new style [v]\n",
  "RESTYLES": "RESTYLE, to make into a new style [v]\n",
  "RESTYLING": "RESTYLE, to make into a new style [v]\n",
  "RESUBJECT": "to subject again [v -ED, -ING, -S]\n",
  "RESUBJECTED": "RESUBJECT, to subject again [v]\n",
  "RESUBJECTING": "RESUBJECT, to subject again [v]\n",
  "RESUBJECTS": "RESUBJECT, to subject again [v]\n",
  "RESUBMISSION": "the act of resubmitting [n -S]\n",
  "RESUBMISSIONS": "RESUBMISSION, the act of resubmitting [n]\n",
  "RESUBMIT": "to submit again [v RESUBMITTED, RESUBMITTING, RESUBMITS]\n",
  "RESUBMITS": "RESUBMIT, to submit again [v]\n",
  "RESUBMITTED": "RESUBMIT, to submit again [v]\n",
  "RESUBMITTING": "RESUBMIT, to submit again [v]\n",
  "RESULT": "to follow as a consequence [v -ED, -ING, -S]\n",
  "RESULTANT": "resulting [adj RESULTANTLY] / the product or outcome of something [n -S]\n",
  "RESULTANTLY": "RESULTANT, resulting [adv]\n",
  "RESULTANTS": "RESULTANT, the product or outcome of something [n]\n",
  "RESULTATIVE": "(in grammar) a phrase which describes the state of a noun by completing the verb phrase [n -S]\n",
  "RESULTATIVES": "RESULTATIVE, (in grammar) a phrase which describes the state of a noun by completing the verb phrase [n]\n",
  "RESULTED": "RESULT, to follow as a consequence [v]\n",
  "RESULTFUL": "having results or effects [adj]\n",
  "RESULTING": "RESULT, to follow as a consequence [v]\n",
  "RESULTLESS": "being without result [adj]\n",
  "RESULTLESSNESS": "the state of being resultless [n]\n",
  "RESULTS": "RESULT, to follow as a consequence [v]\n",
  "RESUMABLE": "capable of, or admitting of, being resumed [adj]\n",
  "RESUME": "to begin again [v RESUMED, RESUMING, RESUMES]\n",
  "RESUMED": "RESUME, to begin again [v]\n",
  "RESUMER": "one who resumes [n -S]\n",
  "RESUMERS": "RESUMER, one who resumes [n]\n",
  "RESUMES": "RESUME, to begin again [v]\n",
  "RESUMING": "RESUME, to begin again [v]\n",
  "RESUMMON": "to summon again [v -ED, -ING, -S]\n",
  "RESUMMONED": "RESUMMON, to summon again [v]\n",
  "RESUMMONING": "RESUMMON, to summon again [v]\n",
  "RESUMMONS": "RESUMMON, to summon again [v]\n",
  "RESUMPTION": "an act or instance of resuming [n -S]\n",
  "RESUMPTIONS": "RESUMPTION, an act or instance of resuming [n]\n",
  "RESUMPTIVE": "taking back; resuming [adj RESUMPTIVELY]\n",
  "RESUMPTIVELY": "RESUMPTIVE, taking back; resuming [adv]\n",
  "RESUPINATE": "turned through 180 degrees; reversed [adj]\n",
  "RESUPINATION": "the state of being supine [n -S]\n",
  "RESUPINATIONS": "RESUPINATION, the state of being supine [n]\n",
  "RESUPINE": "lying on the back [adj]\n",
  "RESUPPLIED": "RESUPPLY, to supply again [v]\n",
  "RESUPPLIES": "RESUPPLY, to supply again [v]\n",
  "RESUPPLY": "to supply again [v RESUPPLIED, RESUPPLYING, RESUPPLIES]\n",
  "RESUPPLYING": "RESUPPLY, to supply again [v]\n",
  "RESURFACE": "to surface again [v RESURFACED, RESURFACING, RESURFACES]\n",
  "RESURFACED": "RESURFACE, to surface again [v]\n",
  "RESURFACER": "one who resurfaces [n -S]\n",
  "RESURFACERS": "RESURFACER, one who resurfaces [n]\n",
  "RESURFACES": "RESURFACE, to surface again [v]\n",
  "RESURFACING": "RESURFACE, to surface again [v]\n",
  "RESURGE": "to rise again [v RESURGED, RESURGING, RESURGES]\n",
  "RESURGED": "RESURGE, to rise again [v]\n",
  "RESURGENCE": "a rising again into life, activity, or prominence [n -S]\n",
  "RESURGENCES": "RESURGENCE, a rising again into life, activity, or prominence [n]\n",
  "RESURGENT": "rising again, as from the dead [adj]\n",
  "RESURGES": "RESURGE, to rise again [v]\n",
  "RESURGING": "RESURGE, to rise again [v]\n",
  "RESURRECT": "to bring back to life [v -ED, -ING, -S]\n",
  "RESURRECTED": "RESURRECT, to bring back to life [v]\n",
  "RESURRECTING": "RESURRECT, to bring back to life [v]\n",
  "RESURRECTION": "a rising from the dead [n -S]\n",
  "RESURRECTIONAL": "relating to resurrection, also RESURRECTIONARY [adj]\n",
  "RESURRECTIONARY": "relating to resurrection, also RESURRECTIONAL [adj]\n",
  "RESURRECTIONISE": "to bring about resurrection, also RESURRECTIONIZE [v]\n",
  "RESURRECTIONISM": "belief in the Resurrection [n]\n",
  "RESURRECTIONIST": "(historical) a person who steals bodies from the grave for dissection [n]\n",
  "RESURRECTIONIZE": "to bring about resurrection, also RESURRECTIONISE [v]\n",
  "RESURRECTIONS": "RESURRECTION, a rising from the dead [n]\n",
  "RESURRECTIVE": "relating to resurrection [adj]\n",
  "RESURRECTOR": "one who resurrects [n -S]\n",
  "RESURRECTORS": "RESURRECTOR, one who resurrects [n]\n",
  "RESURRECTS": "RESURRECT, to bring back to life [v]\n",
  "RESURVEY": "to survey again [v -ED, -ING, -S]\n",
  "RESURVEYED": "RESURVEY, to survey again [v]\n",
  "RESURVEYING": "RESURVEY, to survey again [v]\n",
  "RESURVEYS": "RESURVEY, to survey again [v]\n",
  "RESUS": "(short for) resuscitation room [n RESUSES or RESUSSES]\n",
  "RESUSCITABLE": "capable of being resuscitated [adj]\n",
  "RESUSCITANT": "having a resuscitating effect [adj] / a resuscitant drug [n -S]\n",
  "RESUSCITANTS": "RESUSCITANT, a resuscitant drug [n]\n",
  "RESUSCITATE": "to revive from apparent death or from unconsciousness [v RESUSCITATED, RESUSCITATING, RESUSCITATES]\n",
  "RESUSCITATED": "RESUSCITATE, to revive from apparent death or from unconsciousness [v]\n",
  "RESUSCITATES": "RESUSCITATE, to revive from apparent death or from unconsciousness [v]\n",
  "RESUSCITATING": "RESUSCITATE, to revive from apparent death or from unconsciousness [v]\n",
  "RESUSCITATION": "restoration to life [n -S]\n",
  "RESUSCITATIONS": "RESUSCITATION, restoration to life [n]\n",
  "RESUSCITATIVE": "having the power of restoration to life [adj]\n",
  "RESUSCITATOR": "one that resuscitates [n -S]\n",
  "RESUSCITATORS": "RESUSCITATOR, one that resuscitates [n]\n",
  "RESUSES": "RESUS, (short for) resuscitation room [n]\n",
  "RESUSPEND": "to suspend again [v -ED, -ING, -S]\n",
  "RESUSPENDED": "RESUSPEND, to suspend again [v]\n",
  "RESUSPENDING": "RESUSPEND, to suspend again [v]\n",
  "RESUSPENDS": "RESUSPEND, to suspend again [v]\n",
  "RESUSSES": "RESUS, (short for) resuscitation room [n]\n",
  "RESVERATROL": "a fungicidal phenol with antioxidant properties found in grape skins [n -S]\n",
  "RESVERATROLS": "RESVERATROL, a fungicidal phenol with antioxidant properties found in grape skins [n]\n",
  "RESWALLOW": "to swallow again [v -ED, -ING, -S]\n",
  "RESWALLOWED": "RESWALLOW, to swallow again [v]\n",
  "RESWALLOWING": "RESWALLOW, to swallow again [v]\n",
  "RESWALLOWS": "RESWALLOW, to swallow again [v]\n",
  "RESYNCHRONISE": "to synchronise again, also RESYNCHRONIZE [v RESYNCHRONISED, RESYNCHRONISING, RESYNCHRONISES]\n",
  "RESYNCHRONISED": "RESYNCHRONISE, to synchronise again, also RESYNCHRONIZE [v]\n",
  "RESYNCHRONISES": "RESYNCHRONISE, to synchronise again, also RESYNCHRONIZE [v]\n",
  "RESYNCHRONISING": "RESYNCHRONISE, to synchronise again, also RESYNCHRONIZE [v]\n",
  "RESYNCHRONIZE": "to synchronise again, also RESYNCHRONISE [v RESYNCHRONIZED, RESYNCHRONIZING, RESYNCHRONIZES]\n",
  "RESYNCHRONIZED": "RESYNCHRONIZE, to synchronise again, also RESYNCHRONISE [v]\n",
  "RESYNCHRONIZES": "RESYNCHRONIZE, to synchronise again, also RESYNCHRONISE [v]\n",
  "RESYNCHRONIZING": "RESYNCHRONIZE, to synchronise again, also RESYNCHRONISE [v]\n",
  "RESYNTHESES": "RESYNTHESIS, a new synthesis [n]\n",
  "RESYNTHESIS": "a new synthesis [n RESYNTHESES]\n",
  "RESYNTHESISE": "to synthesise again, also RESYNTHESIZE [v RESYNTHESISED, RESYNTHESISING, RESYNTHESISES]\n",
  "RESYNTHESISED": "RESYNTHESISE, to synthesise again, also RESYNTHESIZE [v]\n",
  "RESYNTHESISES": "RESYNTHESISE, to synthesise again, also RESYNTHESIZE [v]\n",
  "RESYNTHESISING": "RESYNTHESISE, to synthesise again, also RESYNTHESIZE [v]\n",
  "RESYNTHESIZE": "to synthesize again, also RESYNTHESISE [v RESYNTHESIZED, RESYNTHESIZING, RESYNTHESIZES]\n",
  "RESYNTHESIZED": "RESYNTHESIZE, to synthesize again, also RESYNTHESISE [v]\n",
  "RESYNTHESIZES": "RESYNTHESIZE, to synthesize again, also RESYNTHESISE [v]\n",
  "RESYNTHESIZING": "RESYNTHESIZE, to synthesize again, also RESYNTHESISE [v]\n",
  "RESYSTEMATISE": "to systematise again, also RESYSTEMATIZE [v RESYSTEMATISED, RESYSTEMATISING, RESYSTEMATISES]\n",
  "RESYSTEMATISED": "RESYSTEMATISE, to systematise again, also RESYSTEMATIZE [v]\n",
  "RESYSTEMATISES": "RESYSTEMATISE, to systematise again, also RESYSTEMATIZE [v]\n",
  "RESYSTEMATISING": "RESYSTEMATISE, to systematise again, also RESYSTEMATIZE [v]\n",
  "RESYSTEMATIZE": "to systematise again, also RESYSTEMATISE [v RESYSTEMATIZED, RESYSTEMATIZING, RESYSTEMATIZES]\n",
  "RESYSTEMATIZED": "RESYSTEMATIZE, to systematise again, also RESYSTEMATISE [v]\n",
  "RESYSTEMATIZES": "RESYSTEMATIZE, to systematise again, also RESYSTEMATISE [v]\n",
  "RESYSTEMATIZING": "RESYSTEMATIZE, to systematise again, also RESYSTEMATISE [v]\n",
  "RET": "to expose to moisture [v RETTED, RETTING, RETS]\n",
  "RETABLE": "(French) a shelf or ornamental setting for panels behind an altar, also RETABLO [n -S]\n",
  "RETABLES": "RETABLE, (French) a shelf or ornamental setting for panels behind an altar, also RETABLO [n]\n",
  "RETABLO": "a shelf or ornamental setting for panels behind an altar, also RETABLE [n -S]\n",
  "RETABLOS": "RETABLO, a shelf or ornamental setting for panels behind an altar, also RETABLE [n]\n",
  "RETACK": "to tack again [v -ED, -ING, -S]\n",
  "RETACKED": "RETACK, to tack again [v]\n",
  "RETACKING": "RETACK, to tack again [v]\n",
  "RETACKLE": "to tackle again [v RETACKLED, RETACKLING, RETACKLES]\n",
  "RETACKLED": "RETACKLE, to tackle again [v]\n",
  "RETACKLES": "RETACKLE, to tackle again [v]\n",
  "RETACKLING": "RETACKLE, to tackle again [v]\n",
  "RETACKS": "RETACK, to tack again [v]\n",
  "RETAG": "to tag again [v RETAGGED, RETAGGING, RETAGS]\n",
  "RETAGGED": "RETAG, to tag again [v]\n",
  "RETAGGING": "RETAG, to tag again [v]\n",
  "RETAGS": "RETAG, to tag again [v]\n",
  "RETAIL": "to sell direct to the consumer [v -ED, -ING, -S]\n",
  "RETAILED": "RETAIL, to sell direct to the consumer [v]\n",
  "RETAILER": "one who sells direct to the consumer [n -S]\n",
  "RETAILERS": "RETAILER, one who sells direct to the consumer [n]\n",
  "RETAILING": "the act of retailing [n -S]\n",
  "RETAILINGS": "RETAILING, the act of retailing [n]\n",
  "RETAILMENT": "the act of retailing [n -S]\n",
  "RETAILMENTS": "RETAILMENT, the act of retailing [n]\n",
  "RETAILOR": "to tailor again [v -ED, -ING, -S]\n",
  "RETAILORED": "RETAILOR, to tailor again [v]\n",
  "RETAILORING": "RETAILOR, to tailor again [v]\n",
  "RETAILORS": "RETAILOR, to tailor again [v]\n",
  "RETAILS": "RETAIL, to sell direct to the consumer [v]\n",
  "RETAIN": "to keep possession of [v -ED, -ING, -S]\n",
  "RETAINABLE": "capable of being retained [adj]\n",
  "RETAINED": "RETAIN, to keep possession of [v]\n",
  "RETAINER": "one that retains [n -S]\n",
  "RETAINERS": "RETAINER, one that retains [n]\n",
  "RETAINERSHIP": "the office of retainer [n -S]\n",
  "RETAINERSHIPS": "RETAINERSHIP, the office of retainer [n]\n",
  "RETAINING": "RETAIN, to keep possession of [v]\n",
  "RETAINMENT": "the act of retaining [n -S]\n",
  "RETAINMENTS": "RETAINMENT, the act of retaining [n]\n",
  "RETAINS": "RETAIN, to keep possession of [v]\n",
  "RETAKE": "to take back [v RETOOK, RETAKEN, RETAKING, RETAKES]\n",
  "RETAKEN": "RETAKE, to take back [v]\n",
  "RETAKER": "one who takes again what has been taken [n -S]\n",
  "RETAKERS": "RETAKER, one who takes again what has been taken [n]\n",
  "RETAKES": "RETAKE, to take back [v]\n",
  "RETAKING": "the act or taking again [n -S]\n",
  "RETAKINGS": "RETAKING, the act or taking again [n]\n",
  "RETALIATE": "to repay in kind [v RETALIATED, RETALIATING, RETALIATES]\n",
  "RETALIATED": "RETALIATE, to repay in kind [v]\n",
  "RETALIATES": "RETALIATE, to repay in kind [v]\n",
  "RETALIATING": "RETALIATE, to repay in kind [v]\n",
  "RETALIATION": "the act of retaliating [n -S]\n",
  "RETALIATIONIST": "one who believes in retaliation [n -S]\n",
  "RETALIATIONISTS": "RETALIATIONIST, one who believes in retaliation [n]\n",
  "RETALIATIONS": "RETALIATION, the act of retaliating [n]\n",
  "RETALIATIVE": "relating to retaliation [adj]\n",
  "RETALIATOR": "one who retaliates [n -S]\n",
  "RETALIATORS": "RETALIATOR, one who retaliates [n]\n",
  "RETALIATORY": "having the nature of retaliation [adj]\n",
  "RETALLIED": "RETALLY, to tally again [v]\n",
  "RETALLIES": "RETALLY, to tally again [v]\n",
  "RETALLY": "to tally again [v RETALLIED, RETALLYING, RETALLIES]\n",
  "RETALLYING": "RETALLY, to tally again [v]\n",
  "RETAMA": "(Spanish) a name for various desert plants, e.g. Spanish broom, also RETEM [n -S]\n",
  "RETAMAS": "RETAMA, (Spanish) a name for various desert plants, e.g. Spanish broom, also RETEM [n]\n",
  "RETAPE": "to tape again [v RETAPED, RETAPING, RETAPES]\n",
  "RETAPED": "RETAPE, to tape again [v]\n",
  "RETAPES": "RETAPE, to tape again [v]\n",
  "RETAPING": "RETAPE, to tape again [v]\n",
  "RETARD": "to hold back [v -ED, -ING, -S]\n",
  "RETARDANT": "something that retards e.g. the spread of fire [n -S]\n",
  "RETARDANTS": "RETARDANT, something that retards e.g. the spread of fire [n]\n",
  "RETARDATE": "a person who is mentally retarded [n -S]\n",
  "RETARDATES": "RETARDATE, a person who is mentally retarded [n]\n",
  "RETARDATION": "an act or instance of retarding [n -S]\n",
  "RETARDATIONS": "RETARDATION, an act or instance of retarding [n]\n",
  "RETARDATIVE": "serving to retard [adj]\n",
  "RETARDATORY": "tending to retard [adj]\n",
  "RETARDED": "RETARD, to hold back [v]\n",
  "RETARDER": "one who retards [n -S]\n",
  "RETARDERS": "RETARDER, one who retards [n]\n",
  "RETARDING": "RETARD, to hold back [v]\n",
  "RETARDMENT": "the act of retarding [n -S]\n",
  "RETARDMENTS": "RETARDMENT, the act of retarding [n]\n",
  "RETARDS": "RETARD, to hold back [v]\n",
  "RETARGET": "to target again [v -ED, -ING, -S]\n",
  "RETARGETED": "RETARGET, to target again [v]\n",
  "RETARGETING": "RETARGET, to target again [v]\n",
  "RETARGETS": "RETARGET, to target again [v]\n",
  "RETASTE": "to taste again [v RETASTED, RETASTING, RETASTES]\n",
  "RETASTED": "RETASTE, to taste again [v]\n",
  "RETASTES": "RETASTE, to taste again [v]\n",
  "RETASTING": "RETASTE, to taste again [v]\n",
  "RETAUGHT": "RETEACH, to teach again [v]\n",
  "RETAX": "to tax again [v -ED, -ING, -ES]\n",
  "RETAXED": "RETAX, to tax again [v]\n",
  "RETAXES": "RETAX, to tax again [v]\n",
  "RETAXING": "RETAX, to tax again [v]\n",
  "RETCH": "to make an effort to vomit [v -ED, -ING, -ES]\n",
  "RETCHED": "RETCH, to make an effort to vomit [v]\n",
  "RETCHES": "RETCH, to make an effort to vomit [v]\n",
  "RETCHING": "the act of making an effort to vomit [n -S]\n",
  "RETCHINGS": "RETCHING, the act of making an effort to vomit [n]\n",
  "RETCHLESS": "(obsolete) reckless, also RECHLESSE, RECKLESS [adj]\n",
  "RETE": "an anatomical mesh or network [n RETIA]\n",
  "RETEACH": "to teach again [v RETAUGHT, RETEACHING, RETEACHES]\n",
  "RETEACHES": "RETEACH, to teach again [v]\n",
  "RETEACHING": "RETEACH, to teach again [v]\n",
  "RETEAM": "to team up with again [v -ED, -ING, -S]\n",
  "RETEAMED": "RETEAM, to team up with again [v]\n",
  "RETEAMING": "RETEAM, to team up with again [v]\n",
  "RETEAMS": "RETEAM, to team up with again [v]\n",
  "RETEAR": "to tear again [v RETORE, RETORN, RETEARING, RETEARS]\n",
  "RETEARING": "RETEAR, to tear again [v]\n",
  "RETEARS": "RETEAR, to tear again [v]\n",
  "RETELL": "to tell again [v RETOLD, RETELLING, RETELLS]\n",
  "RETELLER": "one who retells stories [n -S]\n",
  "RETELLERS": "RETELLER, one who retells stories [n]\n",
  "RETELLING": "the act of retelling [n -S]\n",
  "RETELLINGS": "RETELLING, the act of retelling [n]\n",
  "RETELLS": "RETELL, to tell again [v]\n",
  "RETEM": "(Spanish) a name for various desert plants, e.g. Spanish broom, also RETAMA [n -S]\n",
  "RETEMPER": "to modify again [v -ED, -ING, -S]\n",
  "RETEMPERED": "RETEMPER, to modify again [v]\n",
  "RETEMPERING": "RETEMPER, to modify again [v]\n",
  "RETEMPERS": "RETEMPER, to modify again [v]\n",
  "RETEMS": "RETEM, (Spanish) a name for various desert plants, e.g. Spanish broom, also RETAMA [n]\n",
  "RETENE": "a hydrocarbon obtained from tar [n -S]\n",
  "RETENES": "RETENE, a hydrocarbon obtained from tar [n]\n",
  "RETENTION": "the act of retaining [n -S]\n",
  "RETENTIONIST": "a person who advocates the retaining of a policy, etc., esp. that of capital punishment [n -S]\n",
  "RETENTIONISTS": "RETENTIONIST, a person who advocates the retaining of a policy, etc., esp. that of capital punishment [n]\n",
  "RETENTIONS": "RETENTION, the act of retaining [n]\n",
  "RETENTIVE": "tending to retain [adj RETENTIVELY] / as in anal retentive, an emotionally constipated person [n -S]\n",
  "RETENTIVELY": "RETENTIVE, tending to retain [adv]\n",
  "RETENTIVENESS": "the state of being retentive [n -ES]\n",
  "RETENTIVENESSES": "RETENTIVENESS, the state of being retentive [n]\n",
  "RETENTIVES": "RETENTIVE, as in anal retentive, an emotionally constipated person [n]\n",
  "RETENTIVITIES": "RETENTIVITY, the power of retaining [n]\n",
  "RETENTIVITY": "the power of retaining [n RETENTIVITIES]\n",
  "RETEST": "to test again [v -ED, -ING, -S]\n",
  "RETESTED": "RETEST, to test again [v]\n",
  "RETESTIFIED": "RETESTIFY, to testify again [v]\n",
  "RETESTIFIES": "RETESTIFY, to testify again [v]\n",
  "RETESTIFY": "to testify again [v RETESTIFIED, RETESTIFYING, RETESTIFIES]\n",
  "RETESTIFYING": "RETESTIFY, to testify again [v]\n",
  "RETESTING": "RETEST, to test again [v]\n",
  "RETESTS": "RETEST, to test again [v]\n",
  "RETEXTURE": "to treat (material, a garment, etc.) so as to restore firmness to its texture [v RETEXTURED, RETEXTURING, RETEXTURES]\n",
  "RETEXTURED": "RETEXTURE, to treat (material, a garment, etc.) so as to restore firmness to its texture [v]\n",
  "RETEXTURES": "RETEXTURE, to treat (material, a garment, etc.) so as to restore firmness to its texture [v]\n",
  "RETEXTURING": "RETEXTURE, to treat (material, a garment, etc.) so as to restore firmness to its texture [v]\n",
  "RETHINK": "to think again [v RETHOUGHT, RETHINKING, RETHINKS]\n",
  "RETHINKER": "one who rethinks [n -S]\n",
  "RETHINKERS": "RETHINKER, one who rethinks [n]\n",
  "RETHINKING": "the act of thinking again [n -S]\n",
  "RETHINKINGS": "RETHINKING, the act of thinking again [n]\n",
  "RETHINKS": "RETHINK, to think again [v]\n",
  "RETHOUGHT": "RETHINK, to think again [v]\n",
  "RETHREAD": "to thread again [v -ED, -ING, -S]\n",
  "RETHREADED": "RETHREAD, to thread again [v]\n",
  "RETHREADING": "RETHREAD, to thread again [v]\n",
  "RETHREADS": "RETHREAD, to thread again [v]\n",
  "RETIA": "RETE, an anatomical mesh or network [n]\n",
  "RETIAL": "pertaining to a rete, a network [adj]\n",
  "RETIARII": "RETIARIUS, (Latin) a gladiator armed with a net [n]\n",
  "RETIARIUS": "(Latin) a gladiator armed with a net [n RETIARII]\n",
  "RETIARY": "fighting with a net, using a net, esp. in the manner of a retiarius [adj]\n",
  "RETICELLA": "an early form of needlepoint lace produced in Italy [n -S]\n",
  "RETICELLAS": "RETICELLA, an early form of needlepoint lace produced in Italy [n]\n",
  "RETICENCE": "the quality of being reticent, also RETICENCY [n -S]\n",
  "RETICENCES": "RETICENCE, the quality of being reticent, also RETICENCY [n]\n",
  "RETICENCIES": "RETICENCY, the quality of being reticent, also RETICENCE [n]\n",
  "RETICENCY": "the quality of being reticent, also RETICENCE [n RETICENCIES]\n",
  "RETICENT": "tending to be silent [adj RETICENTLY]\n",
  "RETICENTLY": "RETICENT, tending to be silent [adv]\n",
  "RETICLE": "a network of lines in the eyepiece of an optical instrument [n -S]\n",
  "RETICLES": "RETICLE, a network of lines in the eyepiece of an optical instrument [n]\n",
  "RETICULA": "RETICULUM, (Latin) a network [n]\n",
  "RETICULAR": "netted, netlike [adj RETICULARLY]\n",
  "RETICULARLY": "RETICULAR, netted, netlike [adv]\n",
  "RETICULARY": "relating to a reticulum, a network [adj]\n",
  "RETICULATE": "like a network [adj RETICULATELY] / to interconnect in network fashion [v RETICULATED, RETICULATING, RETICULATES]\n",
  "RETICULATED": "RETICULATE, to interconnect in network fashion [v]\n",
  "RETICULATELY": "RETICULATE, like a network [adv]\n",
  "RETICULATES": "RETICULATE, to interconnect in network fashion [v]\n",
  "RETICULATING": "RETICULATE, to interconnect in network fashion [v]\n",
  "RETICULATION": "a network or netlike structure [n -S]\n",
  "RETICULATIONS": "RETICULATION, a network or netlike structure [n]\n",
  "RETICULE": "a woman's workbag, or a little bag to be carried in the hand, originally of network [n -S]\n",
  "RETICULES": "RETICULE, a woman's workbag, or a little bag to be carried in the hand, originally of network [n]\n",
  "RETICULOCYTE": "an immature red blood cell that exhibits a reticulated appearance when stained [n -S]\n",
  "RETICULOCYTES": "RETICULOCYTE, an immature red blood cell that exhibits a reticulated appearance when stained [n]\n",
  "RETICULUM": "(Latin) a network [n RETICULUMS or RETICULA]\n",
  "RETICULUMS": "RETICULUM, (Latin) a network [n]\n",
  "RETIE": "to tie again [v RETIED, RETIEING or RETYING, RETIES]\n",
  "RETIED": "RETIE, to tie again [v]\n",
  "RETIEING": "RETIE, to tie again [v]\n",
  "RETIES": "RETIE, to tie again [v]\n",
  "RETIFORM": "arranged like a net [adj]\n",
  "RETIGHTEN": "to tighten again [v -ED, -ING, -S]\n",
  "RETIGHTENED": "RETIGHTEN, to tighten again [v]\n",
  "RETIGHTENING": "RETIGHTEN, to tighten again [v]\n",
  "RETIGHTENS": "RETIGHTEN, to tighten again [v]\n",
  "RETILE": "to tile again [v RETILED, RETILING, RETILES]\n",
  "RETILED": "RETILE, to tile again [v]\n",
  "RETILES": "RETILE, to tile again [v]\n",
  "RETILING": "RETILE, to tile again [v]\n",
  "RETIME": "to time again [v RETIMED, RETIMING, RETIMES]\n",
  "RETIMED": "RETIME, to time again [v]\n",
  "RETIMES": "RETIME, to time again [v]\n",
  "RETIMING": "RETIME, to time again [v]\n",
  "RETINA": "(Latin) a membrane of the eye [n RETINAS or RETINAE]\n",
  "RETINACULA": "RETINACULUM, a band-like structure that holds an organ in place [n]\n",
  "RETINACULAR": "pertaining to the retinaculum, a band-like structure that holds an organ in place [adj]\n",
  "RETINACULUM": "a band-like structure that holds an organ in place [n RETINACULA]\n",
  "RETINAE": "RETINA, (Latin) a membrane of the eye [n]\n",
  "RETINAL": "a pigment in the retina, also RETINENE [n -S]\n",
  "RETINALITE": "a translucent variety of serpentine, of a honey yellow or greenish yellow color, having a waxy resinlike luster [n -S]\n",
  "RETINALITES": "RETINALITE, a translucent variety of serpentine, of a honey yellow or greenish yellow color, having a waxy resinlike luster [n]\n",
  "RETINALS": "RETINAL, a pigment in the retina, also RETINENE [n]\n",
  "RETINAS": "RETINA, (Latin) a membrane of the eye [n]\n",
  "RETINE": "a substance in cells that retards growth and cell division [n -S]\n",
  "RETINENE": "a pigment in the retina, also RETINAL [n -S]\n",
  "RETINENES": "RETINENE, a pigment in the retina, also RETINAL [n]\n",
  "RETINES": "RETINE, a substance in cells that retards growth and cell division [n]\n",
  "RETINISPORA": "a cypress or related conifer in a perpetuated juvenile form, also RETINOSPORA [n -S]\n",
  "RETINISPORAS": "RETINISPORA, a cypress or related conifer in a perpetuated juvenile form, also RETINOSPORA [n]\n",
  "RETINITE": "an inflammable mineral resin, usually of a yellowish brown color, found in roundish masses, sometimes with coal [n -S]\n",
  "RETINITES": "RETINITE, an inflammable mineral resin, usually of a yellowish brown color, found in roundish masses, sometimes with coal [n]\n",
  "RETINITIDES": "RETINITIS, inflammation of the retina [n]\n",
  "RETINITIS": "inflammation of the retina [n RETINITIDES or RETINITISES]\n",
  "RETINITISES": "RETINITIS, inflammation of the retina [n]\n",
  "RETINOBLASTOMA": "a tumour of the retina [n -S]\n",
  "RETINOBLASTOMAS": "RETINOBLASTOMA, a tumour of the retina [n]\n",
  "RETINOIC": "as in retinoic acid, a derivative of vitamin A that is important in morphogenesis and embryo development [adj]\n",
  "RETINOID": "a compound analogous to vitamin A [n -S]\n",
  "RETINOIDS": "RETINOID, a compound analogous to vitamin A [n]\n",
  "RETINOL": "a liquid hydrocarbon [n -S]\n",
  "RETINOLS": "RETINOL, a liquid hydrocarbon [n]\n",
  "RETINOPATHIES": "RETINOPATHY, any of various noninflammatory disorders of the retina including some that cause blindness [n]\n",
  "RETINOPATHY": "any of various noninflammatory disorders of the retina including some that cause blindness [n RETINOPATHIES]\n",
  "RETINOSCOPE": "an instrument for measuring and viewing the retina [n -S]\n",
  "RETINOSCOPES": "RETINOSCOPE, an instrument for measuring and viewing the retina [n]\n",
  "RETINOSCOPIC": "relating to retinoscopy, observation of the retina of the eye esp. to determine the state of refraction [adj]\n",
  "RETINOSCOPIES": "RETINOSCOPY, observation of the retina of the eye esp. to determine the state of refraction [n]\n",
  "RETINOSCOPIST": "one who uses a retinoscope, an instrument for measuring and viewing the retina [n -S]\n",
  "RETINOSCOPISTS": "RETINOSCOPIST, one who uses a retinoscope, an instrument for measuring and viewing the retina [n]\n",
  "RETINOSCOPY": "observation of the retina of the eye esp. to determine the state of refraction [n RETINOSCOPIES]\n",
  "RETINOSPORA": "a cypress or related conifer in a perpetuated juvenile form, also RETINISPORA [n -S]\n",
  "RETINOSPORAS": "RETINOSPORA, a cypress or related conifer in a perpetuated juvenile form, also RETINISPORA [n]\n",
  "RETINOTECTAL": "of, relating to, or being the nerve fibers connecting the retina and the tectum of the midbrain [adj]\n",
  "RETINT": "to tint again [v -ED, -ING, -S]\n",
  "RETINTED": "RETINT, to tint again [v]\n",
  "RETINTING": "RETINT, to tint again [v]\n",
  "RETINTS": "RETINT, to tint again [v]\n",
  "RETINUE": "a group of attendants [n -S]\n",
  "RETINUED": "having a retinue [adj]\n",
  "RETINUES": "RETINUE, a group of attendants [n]\n",
  "RETINULA": "(Latin) a neural receptor of an arthropod's eye [n -S]\n",
  "RETINULAE": "RETINULA, (Latin) a neural receptor of an arthropod's eye [n]\n",
  "RETINULAR": "relating to the retinula, a pigmented cell in some arthropod compound eyes, from which the rhabdom arises [adj]\n",
  "RETINULAS": "RETINULA, (Latin) a neural receptor of an arthropod's eye [n]\n",
  "RETIRACIES": "RETIRACY, seclusion [n]\n",
  "RETIRACY": "seclusion [n RETIRACIES]\n",
  "RETIRAL": "the giving up of office [n -S]\n",
  "RETIRALS": "RETIRAL, the giving up of office [n]\n",
  "RETIRANT": "one who has retired from his vocation, also RETIREE [n -S]\n",
  "RETIRANTS": "RETIRANT, one who has retired from his vocation, also RETIREE [n]\n",
  "RETIRE": "to withdraw or retreat [v RETIRED, RETIRING, RETIRES]\n",
  "RETIRED": "RETIRE, to withdraw or retreat [v]\n",
  "RETIREDLY": "RETIRED, RETIRE, to withdraw or retreat [adv]\n",
  "RETIREDNESS": "the state of being retired [n -ES]\n",
  "RETIREDNESSES": "RETIREDNESS, the state of being retired [n]\n",
  "RETIREE": "one who has retired from his vocation, also RETIRANT [n -S]\n",
  "RETIREES": "RETIREE, one who has retired from his vocation, also RETIRANT [n]\n",
  "RETIREMENT": "an act of retiring [n -S]\n",
  "RETIREMENTS": "RETIREMENT, an act of retiring [n]\n",
  "RETIRER": "one who retires [n -S]\n",
  "RETIRERS": "RETIRER, one who retires [n]\n",
  "RETIRES": "RETIRE, to withdraw or retreat [v]\n",
  "RETIRING": "RETIRE, to withdraw or retreat [v]\n",
  "RETIRINGLY": "RETIRING, RETIRE, to withdraw or retreat [adv]\n",
  "RETIRINGNESS": "the state of being retiring [n -ES]\n",
  "RETIRINGNESSES": "RETIRINGNESS, the state of being retiring [n]\n",
  "RETITLE": "to give a new title to [v RETITLED, RETITLING, RETITLES]\n",
  "RETITLED": "RETITLE, to give a new title to [v]\n",
  "RETITLES": "RETITLE, to give a new title to [v]\n",
  "RETITLING": "RETITLE, to give a new title to [v]\n",
  "RETOLD": "RETELL, to tell again [v]\n",
  "RETOOK": "RETAKE, to take back [v]\n",
  "RETOOL": "to reequip with tools [v -ED, -ING, -S]\n",
  "RETOOLED": "RETOOL, to reequip with tools [v]\n",
  "RETOOLING": "RETOOL, to reequip with tools [v]\n",
  "RETOOLS": "RETOOL, to reequip with tools [v]\n",
  "RETORE": "RETEAR, to tear again [v]\n",
  "RETORN": "RETEAR, to tear again [v]\n",
  "RETORSION": "the act of retorting or throwing back, also RETORTION [n -S]\n",
  "RETORSIONS": "RETORSION, the act of retorting or throwing back, also RETORTION [n]\n",
  "RETORT": "to answer back [v -ED, -ING, -S]\n",
  "RETORTED": "RETORT, to answer back [v]\n",
  "RETORTER": "one who retorts [n -S]\n",
  "RETORTERS": "RETORTER, one who retorts [n]\n",
  "RETORTING": "RETORT, to answer back [v]\n",
  "RETORTION": "the act of retorting or throwing back, also RETORSION [n -S]\n",
  "RETORTIONS": "RETORTION, the act of retorting or throwing back, also RETORSION [n]\n",
  "RETORTIVE": "of the nature of a retort or sharp reply [adj]\n",
  "RETORTS": "RETORT, to answer back [v]\n",
  "RETOTAL": "to total again [v RETOTALED or RETOTALLED, RETOTALING or RETOTALLING, RETOTALS]\n",
  "RETOTALED": "RETOTAL, to total again [v]\n",
  "RETOTALING": "RETOTAL, to total again [v]\n",
  "RETOTALLED": "RETOTAL, to total again [v]\n",
  "RETOTALLING": "RETOTAL, to total again [v]\n",
  "RETOTALS": "RETOTAL, to total again [v]\n",
  "RETOUCH": "to add new details to [v -ED, -ING, -ES]\n",
  "RETOUCHABLE": "that can be retouched [adj]\n",
  "RETOUCHED": "RETOUCH, to add new details to [v]\n",
  "RETOUCHER": "one who retouches [n -S]\n",
  "RETOUCHERS": "RETOUCHER, one who retouches [n]\n",
  "RETOUCHES": "RETOUCH, to add new details to [v]\n",
  "RETOUCHING": "the act of adding new details or touches to [n -S]\n",
  "RETOUCHINGS": "RETOUCHING, the act of adding new details or touches to [n]\n",
  "RETOUR": "to confirm as heir [v -ED, -ING, -S]\n",
  "RETOURED": "RETOUR, to confirm as heir [v]\n",
  "RETOURING": "RETOUR, to confirm as heir [v]\n",
  "RETOURS": "RETOUR, to confirm as heir [v]\n",
  "RETOX": "to embark on a binge of drink, drugs, or unhealthy food after a period of abstinence [v -ED, -ING, -ES]\n",
  "RETOXED": "RETOX, to embark on a binge of drink, drugs, or unhealthy food after a period of abstinence [v]\n",
  "RETOXES": "RETOX, to embark on a binge of drink, drugs, or unhealthy food after a period of abstinence [v]\n",
  "RETOXING": "RETOX, to embark on a binge of drink, drugs, or unhealthy food after a period of abstinence [v]\n",
  "RETRACE": "to go back over [v RETRACED, RETRACING, RETRACES]\n",
  "RETRACEABLE": "that can be retraced [adj]\n",
  "RETRACED": "RETRACE, to go back over [v]\n",
  "RETRACEMENT": "the act of retracing [n -S]\n",
  "RETRACEMENTS": "RETRACEMENT, the act of retracing [n]\n",
  "RETRACER": "one who retraces [n -S]\n",
  "RETRACERS": "RETRACER, one who retraces [n]\n",
  "RETRACES": "RETRACE, to go back over [v]\n",
  "RETRACING": "RETRACE, to go back over [v]\n",
  "RETRACK": "to retrace one's steps [v -ED, -ING, -S]\n",
  "RETRACKED": "RETRACK, to retrace one's steps [v]\n",
  "RETRACKING": "RETRACK, to retrace one's steps [v]\n",
  "RETRACKS": "RETRACK, to retrace one's steps [v]\n",
  "RETRACT": "to take back [v -ED, -ING, -S]\n",
  "RETRACTABILITY": "the quality of being retractable [n]\n",
  "RETRACTABLE": "that can be retracted, also RETRACTIBLE [adj]\n",
  "RETRACTATION": "revoking, recantation [n -S]\n",
  "RETRACTATIONS": "RETRACTATION, revoking, recantation [n]\n",
  "RETRACTED": "RETRACT, to take back [v]\n",
  "RETRACTIBILITY": "the state of being retractible [n]\n",
  "RETRACTIBLE": "that can be retracted, also RETRACTABLE [adj]\n",
  "RETRACTILE": "capable of retraction, like the claws of a cat [adj]\n",
  "RETRACTILITIES": "RETRACTILITY, the state of being retractile [n]\n",
  "RETRACTILITY": "the state of being retractile [n RETRACTILITIES]\n",
  "RETRACTING": "RETRACT, to take back [v]\n",
  "RETRACTION": "an act of recanting [n -S]\n",
  "RETRACTIONS": "RETRACTION, an act of recanting [n]\n",
  "RETRACTIVE": "serving to retract [adj RETRACTIVELY]\n",
  "RETRACTIVELY": "RETRACTIVE, serving to retract [adv]\n",
  "RETRACTOR": "something that retracts [n -S]\n",
  "RETRACTORS": "RETRACTOR, something that retracts [n]\n",
  "RETRACTS": "RETRACT, to take back [v]\n",
  "RETRAICT": "(obsolete) retreat, also RETRAIT, RETRAITE, RETRATE [n -S]\n",
  "RETRAICTS": "RETRAICT, (obsolete) retreat, also RETRAIT, RETRAITE, RETRATE [n]\n",
  "RETRAIN": "to train again [v -ED, -ING, -S]\n",
  "RETRAINABLE": "that can be restrained [adj]\n",
  "RETRAINED": "RETRAIN, to train again [v]\n",
  "RETRAINEE": "one who is retrained [n -S]\n",
  "RETRAINEES": "RETRAINEE, one who is retrained [n]\n",
  "RETRAINING": "the act of training again [n -S]\n",
  "RETRAININGS": "RETRAINING, the act of training again [n]\n",
  "RETRAINS": "RETRAIN, to train again [v]\n",
  "RETRAIT": "(obsolete) retreat, also RETRAICT, RETRAITE, RETRATE [n -S]\n",
  "RETRAITE": "(obsolete) retreat, also RETRAICT, RETRAIT, RETRATE [n -S]\n",
  "RETRAITES": "RETRAITE, (obsolete) retreat, also RETRAICT, RETRAIT, RETRATE [n]\n",
  "RETRAITS": "RETRAIT, (obsolete) retreat, also RETRAICT, RETRAITE, RETRATE [n]\n",
  "RETRAITT": "(Spenser) a portrait [n -S]\n",
  "RETRAITTS": "RETRAITT, (Spenser) a portrait [n]\n",
  "RETRAL": "situated toward the back [adj RETRALLY]\n",
  "RETRALLY": "RETRAL, situated toward the back [adv]\n",
  "RETRANSFER": "to transfer again [v RETRANSFERRED, RETRANSFERRING, RETRANSFERS]\n",
  "RETRANSFERRED": "RETRANSFER, to transfer again [v]\n",
  "RETRANSFERRING": "RETRANSFER, to transfer again [v]\n",
  "RETRANSFERS": "RETRANSFER, to transfer again [v]\n",
  "RETRANSFORM": "to transform again [v -ED, -ING, -S]\n",
  "RETRANSFORMED": "RETRANSFORM, to transform again [v]\n",
  "RETRANSFORMING": "RETRANSFORM, to transform again [v]\n",
  "RETRANSFORMS": "RETRANSFORM, to transform again [v]\n",
  "RETRANSFUSE": "to transfuse again [v RETRANSFUSED, RETRANSFUSING, RETRANSFUSES]\n",
  "RETRANSFUSED": "RETRANSFUSE, to transfuse again [v]\n",
  "RETRANSFUSES": "RETRANSFUSE, to transfuse again [v]\n",
  "RETRANSFUSING": "RETRANSFUSE, to transfuse again [v]\n",
  "RETRANSLATE": "to translate (a translation) into another language [v RETRANSLATED, RETRANSLATING, RETRANSLATES]\n",
  "RETRANSLATED": "RETRANSLATE, to translate (a translation) into another language [v]\n",
  "RETRANSLATES": "RETRANSLATE, to translate (a translation) into another language [v]\n",
  "RETRANSLATING": "RETRANSLATE, to translate (a translation) into another language [v]\n",
  "RETRANSLATION": "the act of retranslating [n -S]\n",
  "RETRANSLATIONS": "RETRANSLATION, the act of retranslating [n]\n",
  "RETRANSMISSION": "the act of retransmitting [n -S]\n",
  "RETRANSMISSIONS": "RETRANSMISSION, the act of retransmitting [n]\n",
  "RETRANSMIT": "to transmit again [v RETRANSMITTED, RETRANSMITTING, RETRANSMITS]\n",
  "RETRANSMITS": "RETRANSMIT, to transmit again [v]\n",
  "RETRANSMITTED": "RETRANSMIT, to transmit again [v]\n",
  "RETRANSMITTING": "RETRANSMIT, to transmit again [v]\n",
  "RETRATE": "(Spenser) to retreat, also RETRAICT, RETRAIT, RETRAITE [v RETRATED, RETRATING, RETRATES]\n",
  "RETRATED": "RETRATE, (Spenser) to retreat, also RETRAICT, RETRAIT, RETRAITE [v]\n",
  "RETRATES": "RETRATE, (Spenser) to retreat, also RETRAICT, RETRAIT, RETRAITE [v]\n",
  "RETRATING": "RETRATE, (Spenser) to retreat, also RETRAICT, RETRAIT, RETRAITE [v]\n",
  "RETREAD": "to tread again [v RETROD, RETRODDEN, RETREADING, RETREADS] / to furnish with new tread [v RETREADED, RETREADING, RETREADS]\n",
  "RETREADED": "RETREAD, to tread again [v]\n",
  "RETREADING": "RETREAD, to tread again [v]\n",
  "RETREADS": "RETREAD, to tread again [v]\n",
  "RETREAT": "to go back [v -ED, -ING, -S]\n",
  "RETREATANT": "a person taking part in a religious retreat [n -S]\n",
  "RETREATANTS": "RETREATANT, a person taking part in a religious retreat [n]\n",
  "RETREATED": "RETREAT, to go back [v]\n",
  "RETREATER": "one who retreats [n -S]\n",
  "RETREATERS": "RETREATER, one who retreats [n]\n",
  "RETREATING": "RETREAT, to go back [v]\n",
  "RETREATS": "RETREAT, to go back [v]\n",
  "RETREE": "in papermaking, damaged or defective sheets of paper [n -S]\n",
  "RETREES": "RETREE, in papermaking, damaged or defective sheets of paper [n]\n",
  "RETRENCH": "to cut down expenses [v -ED, -ING, -ES]\n",
  "RETRENCHABLE": "able to be retrenched [adj]\n",
  "RETRENCHED": "RETRENCH, to cut down expenses [v]\n",
  "RETRENCHES": "RETRENCH, to cut down expenses [v]\n",
  "RETRENCHING": "RETRENCH, to cut down expenses [v]\n",
  "RETRENCHMENT": "cutting down on; reduction in amount of [n -S]\n",
  "RETRENCHMENTS": "RETRENCHMENT, cutting down on; reduction in amount of [n]\n",
  "RETRIAL": "a second trial [n -S]\n",
  "RETRIALS": "RETRIAL, a second trial [n]\n",
  "RETRIBUTE": "to give in return [v RETRIBUTED, RETRIBUTING, RETRIBUTES]\n",
  "RETRIBUTED": "RETRIBUTE, to give in return [v]\n",
  "RETRIBUTES": "RETRIBUTE, to give in return [v]\n",
  "RETRIBUTING": "RETRIBUTE, to give in return [v]\n",
  "RETRIBUTION": "retaliation, punishment [n -S]\n",
  "RETRIBUTIONS": "RETRIBUTION, retaliation, punishment [n]\n",
  "RETRIBUTIVE": "relating to retribution [adj RETRIBUTIVELY]\n",
  "RETRIBUTIVELY": "RETRIBUTIVE, relating to retribution [adv]\n",
  "RETRIBUTOR": "one engaging in retribution [n -S]\n",
  "RETRIBUTORS": "RETRIBUTOR, one engaging in retribution [n]\n",
  "RETRIBUTORY": "relating to retribution [adj]\n",
  "RETRIED": "RETRY, to try again [v]\n",
  "RETRIES": "RETRY, to try again [v]\n",
  "RETRIEVABILITY": "the state of being retrievable [n]\n",
  "RETRIEVABLE": "that can be retrieved [adj RETRIEVABLY]\n",
  "RETRIEVABLENESS": "RETRIEVABLE, that can be retrieved [n]\n",
  "RETRIEVABLY": "RETRIEVABLE, that can be retrieved [adv]\n",
  "RETRIEVAL": "the act of retrieving [n -S]\n",
  "RETRIEVALS": "RETRIEVAL, the act of retrieving [n]\n",
  "RETRIEVE": "to get back [v RETRIEVED, RETRIEVING, RETRIEVES]\n",
  "RETRIEVED": "RETRIEVE, to get back [v]\n",
  "RETRIEVEMENT": "the act of retrieving [n -S]\n",
  "RETRIEVEMENTS": "RETRIEVEMENT, the act of retrieving [n]\n",
  "RETRIEVER": "one of a breed of large gun dogs that can be trained to retrieve game [n -S]\n",
  "RETRIEVERS": "RETRIEVER, one of a breed of large gun dogs that can be trained to retrieve game [n]\n",
  "RETRIEVES": "RETRIEVE, to get back [v]\n",
  "RETRIEVING": "the act of retrieving [n -S]\n",
  "RETRIEVINGS": "RETRIEVING, the act of retrieving [n]\n",
  "RETRIM": "to trim again [v RETRIMMED, RETRIMMING, RETRIMS]\n",
  "RETRIMMED": "RETRIM, to trim again [v]\n",
  "RETRIMMING": "RETRIM, to trim again [v]\n",
  "RETRIMS": "RETRIM, to trim again [v]\n",
  "RETRO": "a kind of rocket [n -S]\n",
  "RETROACT": "to act in return [v -ED, -ING, -S]\n",
  "RETROACTED": "RETROACT, to act in return [v]\n",
  "RETROACTING": "RETROACT, to act in return [v]\n",
  "RETROACTION": "acting backward [n -S]\n",
  "RETROACTIONS": "RETROACTION, acting backward [n]\n",
  "RETROACTIVE": "taking effect as from a previous date [adj RETROACTIVELY]\n",
  "RETROACTIVELY": "RETROACTIVE, taking effect as from a previous date [adv]\n",
  "RETROACTIVENESS": "the state of being retroactive [n]\n",
  "RETROACTIVITIES": "RETROACTIVITY, the state of being retroactive [n]\n",
  "RETROACTIVITY": "the state of being retroactive [n RETROACTIVITIES]\n",
  "RETROACTS": "RETROACT, to act in return [v]\n",
  "RETROBULBAR": "behind the eyeball [adj]\n",
  "RETROCEDE": "to cede back (a territory) [v RETROCEDED, RETROCEDING, RETROCEDES]\n",
  "RETROCEDED": "RETROCEDE, to cede back (a territory) [v]\n",
  "RETROCEDENCE": "the act of retroceding [n -S]\n",
  "RETROCEDENCES": "RETROCEDENCE, the act of retroceding [n]\n",
  "RETROCEDENT": "moving backward [adj]\n",
  "RETROCEDES": "RETROCEDE, to cede back (a territory) [v]\n",
  "RETROCEDING": "RETROCEDE, to cede back (a territory) [v]\n",
  "RETROCESSION": "a ceding back, as of territory [n -S]\n",
  "RETROCESSIONS": "RETROCESSION, a ceding back, as of territory [n]\n",
  "RETROCESSIVE": "going backwards [adj]\n",
  "RETROCHOIR": "the part of a cathedral or large church behind the high altar [n -S]\n",
  "RETROCHOIRS": "RETROCHOIR, the part of a cathedral or large church behind the high altar [n]\n",
  "RETROCOGNITION": "extrasensory knowledge of past events [n -S]\n",
  "RETROCOGNITIONS": "RETROCOGNITION, extrasensory knowledge of past events [n]\n",
  "RETROD": "RETREAD, to tread again [v]\n",
  "RETRODDEN": "RETREAD, to tread again [v]\n",
  "RETRODICT": "to utilize present information or ideas to infer or explain (a past event or state of affairs) [v -ED, -ING, -S]\n",
  "RETRODICTED": "RETRODICT, to utilize present information or ideas to infer or explain (a past event or state of affairs) [v]\n",
  "RETRODICTING": "RETRODICT, to utilize present information or ideas to infer or explain (a past event or state of affairs) [v]\n",
  "RETRODICTION": "the utilization of present information or ideas to infer or explain (a past event or state of affairs) [n -S]\n",
  "RETRODICTIONS": "RETRODICTION, the utilization of present information or ideas to infer or explain (a past event or state of affairs) [n]\n",
  "RETRODICTIVE": "relating to retrodiction [adj]\n",
  "RETRODICTS": "RETRODICT, to utilize present information or ideas to infer or explain (a past event or state of affairs) [v]\n",
  "RETROENGINE": "a small rocket on a spacecraft which is fired to alter its course or slow it down [n -S]\n",
  "RETROENGINES": "RETROENGINE, a small rocket on a spacecraft which is fired to alter its course or slow it down [n]\n",
  "RETROFIRE": "to cause a retrorocket to become ignited [v RETROFIRED, RETROFIRING, RETROFIRES]\n",
  "RETROFIRED": "RETROFIRE, to cause a retrorocket to become ignited [v]\n",
  "RETROFIRES": "RETROFIRE, to cause a retrorocket to become ignited [v]\n",
  "RETROFIRING": "RETROFIRE, to cause a retrorocket to become ignited [v]\n",
  "RETROFIT": "to furnish with new parts not originally available [v RETROFITTED, RETROFITTING, RETROFITS]\n",
  "RETROFITS": "RETROFIT, to furnish with new parts not originally available [v]\n",
  "RETROFITTED": "RETROFIT, to furnish with new parts not originally available [v]\n",
  "RETROFITTING": "the act of retrofitting [n -S]\n",
  "RETROFITTINGS": "RETROFITTING, the act of retrofitting [n]\n",
  "RETROFLECTED": "bent or turned back, also RETROFLEXED [adj]\n",
  "RETROFLECTION": "the state of being bent back, also RETROFLEXION [n -S]\n",
  "RETROFLECTIONS": "RETROFLECTION, the state of being bent back, also RETROFLEXION [n]\n",
  "RETROFLEX": "to bend back [v -ED, -ING, -ES]\n",
  "RETROFLEXED": "RETROFLEX, to bend back [v]\n",
  "RETROFLEXES": "RETROFLEX, to bend back [v]\n",
  "RETROFLEXING": "RETROFLEX, to bend back [v]\n",
  "RETROFLEXION": "the state of being bent back, also RETROFLECTION [n -S]\n",
  "RETROFLEXIONS": "RETROFLEXION, the state of being bent back, also RETROFLECTION [n]\n",
  "RETROGRADATION": "the act of retrograding [n -S]\n",
  "RETROGRADATIONS": "RETROGRADATION, the act of retrograding [n]\n",
  "RETROGRADE": "going backwards [adj RETROGRADELY] / to cause to go back [v RETROGRADED, RETROGRADING, RETROGRADES]\n",
  "RETROGRADED": "RETROGRADE, to cause to go back [v]\n",
  "RETROGRADELY": "RETROGRADE, going backwards [adv]\n",
  "RETROGRADES": "RETROGRADE, to cause to go back [v]\n",
  "RETROGRADING": "RETROGRADE, to cause to go back [v]\n",
  "RETROGRESS": "to show backward movement, degenerate [v -ED, -ING, -ES]\n",
  "RETROGRESSED": "RETROGRESS, to show backward movement, degenerate [v]\n",
  "RETROGRESSES": "RETROGRESS, to show backward movement, degenerate [v]\n",
  "RETROGRESSING": "RETROGRESS, to show backward movement, degenerate [v]\n",
  "RETROGRESSION": "the act of retrogressing [n -S]\n",
  "RETROGRESSIONAL": "of or like retrogression [adj]\n",
  "RETROGRESSIONS": "RETROGRESSION, the act of retrogressing [n]\n",
  "RETROGRESSIVE": "characterized by retrogression [adj RETROGRESSIVELY]\n",
  "RETROGRESSIVELY": "RETROGRESSIVE, characterized by retrogression [adv]\n",
  "RETROJECT": "to throw backwards [v -ED, -ING, -S]\n",
  "RETROJECTED": "RETROJECT, to throw backwards [v]\n",
  "RETROJECTING": "RETROJECT, to throw backwards [v]\n",
  "RETROJECTION": "throwing backwards [n -S]\n",
  "RETROJECTIONS": "RETROJECTION, throwing backwards [n]\n",
  "RETROJECTS": "RETROJECT, to throw backwards [v]\n",
  "RETROLENTAL": "behind the or a lens, esp. that of the eye [adj]\n",
  "RETROMINGENCIES": "RETROMINGENCY, urinating backwards [n]\n",
  "RETROMINGENCY": "urinating backwards [n RETROMINGENCIES]\n",
  "RETROMINGENT": "passing urine in a backward direction, as camels do [adj] / a retromingent animal [n -S]\n",
  "RETROMINGENTS": "RETROMINGENT, a retromingent animal [n]\n",
  "RETRONYM": "a term coined to distinguish the original referent from a later development [n -S]\n",
  "RETRONYMS": "RETRONYM, a term coined to distinguish the original referent from a later development [n]\n",
  "RETROPACK": "a system of auxiliary rockets on a spacecraft [n -S]\n",
  "RETROPACKS": "RETROPACK, a system of auxiliary rockets on a spacecraft [n]\n",
  "RETROPERITONEAL": "situated behind the peritoneum [adj]\n",
  "RETROPHILIA": "love of things of the past [n -S]\n",
  "RETROPHILIAC": "one who engages in retrophilia, love of things past [n -S]\n",
  "RETROPHILIACS": "RETROPHILIAC, one who engages in retrophilia, love of things past [n]\n",
  "RETROPHILIAS": "RETROPHILIA, love of things of the past [n]\n",
  "RETROPULSION": "pushing backwards [n -S]\n",
  "RETROPULSIONS": "RETROPULSION, pushing backwards [n]\n",
  "RETROPULSIVE": "showing retropulsion [adj]\n",
  "RETROREFLECTION": "the action or use of a retroreflector [n]\n",
  "RETROREFLECTIVE": "relating to retroreflection [adj]\n",
  "RETROREFLECTOR": "a device that reflects radiation so that the paths of the reflected rays are parallel to those of the incident rays [n -S]\n",
  "RETROREFLECTORS": "RETROREFLECTOR, a device that reflects radiation so that the paths of the reflected rays are parallel to those of the incident rays [n]\n",
  "RETROROCKET": "a rocket whose function is to slow down, fired in a direction opposite to that in which a body, e.g. a spacecraft or an artificial satellite, is travelling [n -S]\n",
  "RETROROCKETS": "RETROROCKET, a rocket whose function is to slow down, fired in a direction opposite to that in which a body, e.g. a spacecraft or an artificial satellite, is travelling [n]\n",
  "RETRORSE": "turned back or downward [adj RETRORSELY]\n",
  "RETRORSELY": "RETRORSE, turned back or downward [adv]\n",
  "RETROS": "RETRO, a kind of rocket [n]\n",
  "RETROSEXUAL": "a man with traditional sexual attitudes [n -S]\n",
  "RETROSEXUALS": "RETROSEXUAL, a man with traditional sexual attitudes [n]\n",
  "RETROSPECT": "to engage in retrospection [v -ED, -ING, -S]\n",
  "RETROSPECTED": "RETROSPECT, to engage in retrospection [v]\n",
  "RETROSPECTING": "RETROSPECT, to engage in retrospection [v]\n",
  "RETROSPECTION": "the act or an instance of surveying the past [n -S]\n",
  "RETROSPECTIONS": "RETROSPECTION, the act or an instance of surveying the past [n]\n",
  "RETROSPECTIVE": "looking back [adj RETROSPECTIVELY] / a generally comprehensive exhibition, compilation, or performance of the work of an artist over a span of years [n -S]\n",
  "RETROSPECTIVELY": "RETROSPECTIVE, looking back [adv]\n",
  "RETROSPECTIVES": "RETROSPECTIVE, a generally comprehensive exhibition, compilation, or performance of the work of an artist over a span of years [n]\n",
  "RETROSPECTS": "RETROSPECT, to engage in retrospection [v]\n",
  "RETROUSSAGE": "(French) in etching, the action of drawing a fine cloth across an inked plate to draw out some ink and smear it irregularly across the plate [n -S]\n",
  "RETROUSSAGES": "RETROUSSAGE, (French) in etching, the action of drawing a fine cloth across an inked plate to draw out some ink and smear it irregularly across the plate [n]\n",
  "RETROUSSE": "(French) of the nose, turned up [adj]\n",
  "RETROVERSE": "turned backwards [adj]\n",
  "RETROVERSION": "the bending backward of the uterus and cervix [n -S]\n",
  "RETROVERSIONS": "RETROVERSION, the bending backward of the uterus and cervix [n]\n",
  "RETROVERT": "to turn back [v -ED, -ING, -S]\n",
  "RETROVERTED": "RETROVERT, to turn back [v]\n",
  "RETROVERTING": "RETROVERT, to turn back [v]\n",
  "RETROVERTS": "RETROVERT, to turn back [v]\n",
  "RETROVIRAL": "relating to a retrovirus [adj]\n",
  "RETROVIRUS": "any of a group of viruses whose genetic material is encoded in the form of RNA rather than DNA [n -ES]\n",
  "RETROVIRUSES": "RETROVIRUS, any of a group of viruses whose genetic material is encoded in the form of RNA rather than DNA [n]\n",
  "RETRY": "to try again [v RETRIED, RETRYING, RETRIES]\n",
  "RETRYING": "RETRY, to try again [v]\n",
  "RETS": "RET, to expose to moisture [v]\n",
  "RETSINA": "(Modern Greek) a resin-flavoured Greek wine [n -S]\n",
  "RETSINAS": "RETSINA, (Modern Greek) a resin-flavoured Greek wine [n]\n",
  "RETTED": "RET, to expose to moisture [v]\n",
  "RETTERIES": "RETTERY, a place where flax is retted [n]\n",
  "RETTERY": "a place where flax is retted [n RETTERIES]\n",
  "RETTING": "RET, to expose to moisture [v]\n",
  "RETUND": "to blunt the edge of a weapon [v -ED, -ING, -S]\n",
  "RETUNDED": "RETUND, to blunt the edge of a weapon [v]\n",
  "RETUNDING": "RETUND, to blunt the edge of a weapon [v]\n",
  "RETUNDS": "RETUND, to blunt the edge of a weapon [v]\n",
  "RETUNE": "to tune again [v RETUNED, RETUNING, RETUNES]\n",
  "RETUNED": "RETUNE, to tune again [v]\n",
  "RETUNES": "RETUNE, to tune again [v]\n",
  "RETUNING": "RETUNE, to tune again [v]\n",
  "RETURF": "to lay new turf [v -ED, -ING, -S]\n",
  "RETURFED": "RETURF, to lay new turf [v]\n",
  "RETURFING": "RETURF, to lay new turf [v]\n",
  "RETURFS": "RETURF, to lay new turf [v]\n",
  "RETURN": "to go back [v -ED, -ING, -S]\n",
  "RETURNABILITIES": "RETURNABILITY, the quality of being returnable [n]\n",
  "RETURNABILITY": "the quality of being returnable [n RETURNABILITIES]\n",
  "RETURNABLE": "that can be returned [adj] / something designed to be returned (as for recycling) [n -S]\n",
  "RETURNABLES": "RETURNABLE, something designed to be returned (as for recycling) [n]\n",
  "RETURNED": "RETURN, to go back [v]\n",
  "RETURNEE": "one who has returned [n -S]\n",
  "RETURNEES": "RETURNEE, one who has returned [n]\n",
  "RETURNER": "one who returns [n -S]\n",
  "RETURNERS": "RETURNER, one who returns [n]\n",
  "RETURNIK": "someone going home after their country's political change [n -S]\n",
  "RETURNIKS": "RETURNIK, someone going home after their country's political change [n]\n",
  "RETURNING": "RETURN, to go back [v]\n",
  "RETURNLESS": "admitting no return [adj]\n",
  "RETURNS": "RETURN, to go back [v]\n",
  "RETUSE": "describing leaves with a rounded apex and a shallow notch [adj]\n",
  "RETWEET": "to tweet again [v -ED, -ING, -S]\n",
  "RETWEETED": "RETWEET, to tweet again [v]\n",
  "RETWEETING": "RETWEET, to tweet again [v]\n",
  "RETWEETS": "RETWEET, to tweet again [v]\n",
  "RETWIST": "to twist again [v -ED, -ING, -S]\n",
  "RETWISTED": "RETWIST, to twist again [v]\n",
  "RETWISTING": "RETWIST, to twist again [v]\n",
  "RETWISTS": "RETWIST, to twist again [v]\n",
  "RETYING": "RETIE, to tie again [v]\n",
  "RETYPE": "to type again [v RETYPED, RETYPING, RETYPES]\n",
  "RETYPED": "RETYPE, to type again [v]\n",
  "RETYPES": "RETYPE, to type again [v]\n",
  "RETYPING": "RETYPE, to type again [v]\n",
  "REUNIFICATION": "the act of reunifying [n -S]\n",
  "REUNIFICATIONS": "REUNIFICATION, the act of reunifying [n]\n",
  "REUNIFIED": "REUNIFY, to unify again [v]\n",
  "REUNIFIES": "REUNIFY, to unify again [v]\n",
  "REUNIFY": "to unify again [v REUNIFIED, REUNIFYING, REUNIFIES]\n",
  "REUNIFYING": "REUNIFY, to unify again [v]\n",
  "REUNION": "a uniting of people after separation [n -S]\n",
  "REUNIONISM": "a policy of reunification [n -S]\n",
  "REUNIONISMS": "REUNIONISM, a policy of reunification [n]\n",
  "REUNIONIST": "a person in favour of reuniting the Anglican and Roman Catholic churches [n -S]\n",
  "REUNIONISTIC": "relating to reunionism, a policy of reunification [adj]\n",
  "REUNIONISTS": "REUNIONIST, a person in favour of reuniting the Anglican and Roman Catholic churches [n]\n",
  "REUNIONS": "REUNION, a uniting of people after separation [n]\n",
  "REUNITABLE": "that can be reunited [adj]\n",
  "REUNITE": "to come together again [v REUNITED, REUNITING, REUNITES]\n",
  "REUNITED": "REUNITE, to come together again [v]\n",
  "REUNITER": "one who reunites [n -S]\n",
  "REUNITERS": "REUNITER, one who reunites [n]\n",
  "REUNITES": "REUNITE, to come together again [v]\n",
  "REUNITING": "REUNITE, to come together again [v]\n",
  "REUPHOLSTER": "to upholster again [v -ED, -ING, -S]\n",
  "REUPHOLSTERED": "REUPHOLSTER, to upholster again [v]\n",
  "REUPHOLSTERING": "REUPHOLSTER, to upholster again [v]\n",
  "REUPHOLSTERS": "REUPHOLSTER, to upholster again [v]\n",
  "REUPTAKE": "to take up again [v REUPTOOK, REUPTAKING, REUPTAKEN, REUPTAKES]\n",
  "REUPTAKEN": "REUPTAKE, to take up again [v]\n",
  "REUPTAKES": "REUPTAKE, to take up again [v]\n",
  "REUPTAKING": "REUPTAKE, to take up again [v]\n",
  "REUPTOOK": "REUPTAKE, to take up again [v]\n",
  "REURGE": "to press strongly [v REURGED, REURGING, REURGES]\n",
  "REURGED": "REURGE, to press strongly [v]\n",
  "REURGES": "REURGE, to press strongly [v]\n",
  "REURGING": "REURGE, to press strongly [v]\n",
  "REUSABILITIES": "REUSABILITY, the capacity to be reused [n]\n",
  "REUSABILITY": "the capacity to be reused [n REUSABILITIES]\n",
  "REUSABLE": "capable of being used again [adj] / something that can be used again [n -S]\n",
  "REUSABLES": "REUSABLE, something that can be used again [n]\n",
  "REUSE": "to use again [v REUSED, REUSING, REUSES]\n",
  "REUSED": "REUSE, to use again [v]\n",
  "REUSES": "REUSE, to use again [v]\n",
  "REUSING": "REUSE, to use again [v]\n",
  "REUTILISATION": "the process of reutilising, also REUTILIZATION [n -S]\n",
  "REUTILISATIONS": "REUTILISATION, the process of reutilising, also REUTILIZATION [n]\n",
  "REUTILISE": "to utilise again, also REUTILIZE [v REUTILISED, REUTILISING, REUTILISES]\n",
  "REUTILISED": "REUTILISE, to utilise again, also REUTILIZE [v]\n",
  "REUTILISES": "REUTILISE, to utilise again, also REUTILIZE [v]\n",
  "REUTILISING": "REUTILISE, to utilise again, also REUTILIZE [v]\n",
  "REUTILIZATION": "the process of reutilizing, also REUTILISATION [n -S]\n",
  "REUTILIZATIONS": "REUTILIZATION, the process of reutilizing, also REUTILISATION [n]\n",
  "REUTILIZE": "to utilize again, also REUTILISE [v REUTILIZED, REUTILIZING, REUTILIZES]\n",
  "REUTILIZED": "REUTILIZE, to utilize again, also REUTILISE [v]\n",
  "REUTILIZES": "REUTILIZE, to utilize again, also REUTILISE [v]\n",
  "REUTILIZING": "REUTILIZE, to utilize again, also REUTILISE [v]\n",
  "REUTTER": "to utter again [v -ED, -ING, -S]\n",
  "REUTTERED": "REUTTER, to utter again [v]\n",
  "REUTTERING": "REUTTER, to utter again [v]\n",
  "REUTTERS": "REUTTER, to utter again [v]\n",
  "REV": "to increase the speed of [v REVVED, REVVING, REVS]\n",
  "REVACCINATE": "to vaccinate again [v REVACCINATED, REVACCINATING, REVACCINATES]\n",
  "REVACCINATED": "REVACCINATE, to vaccinate again [v]\n",
  "REVACCINATES": "REVACCINATE, to vaccinate again [v]\n",
  "REVACCINATING": "REVACCINATE, to vaccinate again [v]\n",
  "REVACCINATION": "the act of revaccinating [n -S]\n",
  "REVACCINATIONS": "REVACCINATION, the act of revaccinating [n]\n",
  "REVALENTA": "lentil-meal, also ERVALENTA [n -S]\n",
  "REVALENTAS": "REVALENTA, lentil-meal, also ERVALENTA [n]\n",
  "REVALIDATE": "to validate again [v REVALIDATED, REVALIDATING, REVALIDATES]\n",
  "REVALIDATED": "REVALIDATE, to validate again [v]\n",
  "REVALIDATES": "REVALIDATE, to validate again [v]\n",
  "REVALIDATING": "REVALIDATE, to validate again [v]\n",
  "REVALIDATION": "the action or an instance of revalidating [n -S]\n",
  "REVALIDATIONS": "REVALIDATION, the action or an instance of revalidating [n]\n",
  "REVALORISATION": "the act of revalorising, also REVALORIZATION [n -S]\n",
  "REVALORISATIONS": "REVALORISATION, the act of revalorising, also REVALORIZATION [n]\n",
  "REVALORISE": "to give a new value to; to restore value of currency, also REVALORIZE [v REVALORISED, REVALORISING, REVALORISES]\n",
  "REVALORISED": "REVALORISE, to give a new value to; to restore value of currency, also REVALORIZE [v]\n",
  "REVALORISES": "REVALORISE, to give a new value to; to restore value of currency, also REVALORIZE [v]\n",
  "REVALORISING": "REVALORISE, to give a new value to; to restore value of currency, also REVALORIZE [v]\n",
  "REVALORIZATION": "the act of revalorizing, also REVALORISATION [n -S]\n",
  "REVALORIZATIONS": "REVALORIZATION, the act of revalorizing, also REVALORISATION [n]\n",
  "REVALORIZE": "to give a new value to; to restore value of currency, also REVALORISE [v REVALORIZED, REVALORIZING, REVALORIZES]\n",
  "REVALORIZED": "REVALORIZE, to give a new value to; to restore value of currency, also REVALORISE [v]\n",
  "REVALORIZES": "REVALORIZE, to give a new value to; to restore value of currency, also REVALORISE [v]\n",
  "REVALORIZING": "REVALORIZE, to give a new value to; to restore value of currency, also REVALORISE [v]\n",
  "REVALUATE": "to evaluate again [v REVALUATED, REVALUATING, REVALUATES]\n",
  "REVALUATED": "REVALUATE, to evaluate again [v]\n",
  "REVALUATES": "REVALUATE, to evaluate again [v]\n",
  "REVALUATING": "REVALUATE, to evaluate again [v]\n",
  "REVALUATION": "the act of revaluing [n -S]\n",
  "REVALUATIONS": "REVALUATION, the act of revaluing [n]\n",
  "REVALUE": "to value again [v REVALUED, REVALUING, REVALUES]\n",
  "REVALUED": "REVALUE, to value again [v]\n",
  "REVALUES": "REVALUE, to value again [v]\n",
  "REVALUING": "REVALUE, to value again [v]\n",
  "REVAMP": "to make over [v -ED, -ING, -S]\n",
  "REVAMPED": "REVAMP, to make over [v]\n",
  "REVAMPER": "one who revamps [n -S]\n",
  "REVAMPERS": "REVAMPER, one who revamps [n]\n",
  "REVAMPING": "renovation [n -S]\n",
  "REVAMPINGS": "REVAMPING, renovation [n]\n",
  "REVAMPS": "REVAMP, to make over [v]\n",
  "REVANCHE": "(French) a political policy designed to gain lost territory [n -S]\n",
  "REVANCHES": "REVANCHE, (French) a political policy designed to gain lost territory [n]\n",
  "REVANCHISM": "policy of aggressively seeking recovery of lost territory [n -S]\n",
  "REVANCHISMS": "REVANCHISM, policy of aggressively seeking recovery of lost territory [n]\n",
  "REVANCHIST": "one adhering to policy of aggressively seeking recovery of lost territory [n -S]\n",
  "REVANCHISTS": "REVANCHIST, one adhering to policy of aggressively seeking recovery of lost territory [n]\n",
  "REVARNISH": "to varnish again [v -ED, -ING, -ES]\n",
  "REVARNISHED": "REVARNISH, to varnish again [v]\n",
  "REVARNISHES": "REVARNISH, to varnish again [v]\n",
  "REVARNISHING": "REVARNISH, to varnish again [v]\n",
  "REVEAL": "to make known [v -ED, -ING, -S]\n",
  "REVEALABILITIES": "REVEALABILITY, the quality of being revealable [n]\n",
  "REVEALABILITY": "the quality of being revealable [n REVEALABILITIES]\n",
  "REVEALABLE": "capable of being revealed [adj]\n",
  "REVEALED": "REVEAL, to make known [v]\n",
  "REVEALER": "one who reveals [n -S]\n",
  "REVEALERS": "REVEALER, one who reveals [n]\n",
  "REVEALING": "making visible [adj REVEALINGLY] / the act of revealing [n -S]\n",
  "REVEALINGLY": "REVEALING, making visible [adv]\n",
  "REVEALINGNESS": "the state of being revealing [n -ES]\n",
  "REVEALINGNESSES": "REVEALINGNESS, the state of being revealing [n]\n",
  "REVEALINGS": "REVEALING, the act of revealing [n]\n",
  "REVEALMENT": "the act of revealing [n -S]\n",
  "REVEALMENTS": "REVEALMENT, the act of revealing [n]\n",
  "REVEALS": "REVEAL, to make known [v]\n",
  "REVEGETATE": "to vegetate anew [v REVEGETATED, REVEGETATING, REVEGETATES]\n",
  "REVEGETATED": "REVEGETATE, to vegetate anew [v]\n",
  "REVEGETATES": "REVEGETATE, to vegetate anew [v]\n",
  "REVEGETATING": "REVEGETATE, to vegetate anew [v]\n",
  "REVEGETATION": "the act of revegetating [n -S]\n",
  "REVEGETATIONS": "REVEGETATION, the act of revegetating [n]\n",
  "REVEHENT": "carrying back [adj]\n",
  "REVEILLE": "(French) a morning bugle call [n -S]\n",
  "REVEILLES": "REVEILLE, (French) a morning bugle call [n]\n",
  "REVEL": "to engage in noisy merrymaking [v REVELLED or REVELED, REVELLING or REVELING, REVELS]\n",
  "REVELATION": "an act of revealing [n -S]\n",
  "REVELATIONAL": "of or like revelation [adj]\n",
  "REVELATIONIST": "a believer in divine revelation [n -S]\n",
  "REVELATIONISTS": "REVELATIONIST, a believer in divine revelation [n]\n",
  "REVELATIONS": "REVELATION, an act of revealing [n]\n",
  "REVELATIVE": "relating to revelation, also REVELATORY [adj]\n",
  "REVELATOR": "one who makes a revelation [n -S]\n",
  "REVELATORS": "REVELATOR, one who makes a revelation [n]\n",
  "REVELATORY": "relating to revelation, also REVELATIVE [adj]\n",
  "REVELED": "REVEL, to engage in noisy merrymaking [v]\n",
  "REVELER": "one who revels, also REVELLER [n -S]\n",
  "REVELERS": "REVELER, one who revels, also REVELLER [n]\n",
  "REVELING": "REVEL, to engage in noisy merrymaking [v]\n",
  "REVELLED": "REVEL, to engage in noisy merrymaking [v]\n",
  "REVELLER": "one who revels, also REVELER [n -S]\n",
  "REVELLERS": "REVELLER, one who revels, also REVELER [n]\n",
  "REVELLING": "the act of revelling [n -S]\n",
  "REVELLINGS": "REVELLING, the act of revelling [n]\n",
  "REVELMENT": "the act of revelling [n -S]\n",
  "REVELMENTS": "REVELMENT, the act of revelling [n]\n",
  "REVELRIES": "REVELRY, noisy merrymaking [n]\n",
  "REVELROUS": "given to revelry [adj]\n",
  "REVELRY": "noisy merrymaking [n REVELRIES]\n",
  "REVELS": "REVEL, to engage in noisy merrymaking [v]\n",
  "REVENANT": "(French) one that returns after death or a long absence [n -S]\n",
  "REVENANTS": "REVENANT, (French) one that returns after death or a long absence [n]\n",
  "REVENDICATE": "to make formal claim to; to try to retrieve lost goods [v REVENDICATED, REVENDICATING, REVENDICATES]\n",
  "REVENDICATED": "REVENDICATE, to make formal claim to; to try to retrieve lost goods [v]\n",
  "REVENDICATES": "REVENDICATE, to make formal claim to; to try to retrieve lost goods [v]\n",
  "REVENDICATING": "REVENDICATE, to make formal claim to; to try to retrieve lost goods [v]\n",
  "REVENDICATION": "(French) the action of claiming back or recovering something by a formal claim [n -S]\n",
  "REVENDICATIONS": "REVENDICATION, (French) the action of claiming back or recovering something by a formal claim [n]\n",
  "REVENGE": "to take retribution for wrongs done [v REVENGED, REVENGING, REVENGES]\n",
  "REVENGED": "REVENGE, to take retribution for wrongs done [v]\n",
  "REVENGEFUL": "full of or prone to revenge [adj REVENGEFULLY]\n",
  "REVENGEFULLY": "REVENGEFUL, full of or prone to revenge [adv]\n",
  "REVENGEFULNESS": "the state of being revengeful [n]\n",
  "REVENGELESS": "without revenge [adj]\n",
  "REVENGEMENT": "(Shakespeare) revenge, also VENGEMENT [n -S]\n",
  "REVENGEMENTS": "REVENGEMENT, (Shakespeare) revenge, also VENGEMENT [n]\n",
  "REVENGER": "one who takes revenge [n -S]\n",
  "REVENGERS": "REVENGER, one who takes revenge [n]\n",
  "REVENGES": "REVENGE, to take retribution for wrongs done [v]\n",
  "REVENGING": "vengeful [adj REVENGINGLY] / the act of revenging [n -S]\n",
  "REVENGINGLY": "REVENGING, vengeful [adv]\n",
  "REVENGINGS": "REVENGING, the act of revenging [n]\n",
  "REVENGIVE": "(Shakespeare) revengeful [adj]\n",
  "REVENUAL": "relating to revenue [adj]\n",
  "REVENUE": "the income of a government [n -S]\n",
  "REVENUED": "possessed of revenue [adj]\n",
  "REVENUER": "a revenue officer [n -S]\n",
  "REVENUERS": "REVENUER, a revenue officer [n]\n",
  "REVENUES": "REVENUE, the income of a government [n]\n",
  "REVERABLE": "worthy of reverence [adj]\n",
  "REVERB": "(Shakespeare) to echo, reverberate [v -ED, -ING, -S]\n",
  "REVERBATORIES": "REVERBATORY, a furnace in which the flames are made to pass over the substance being heated; a reverberatory furnace or kiln [n]\n",
  "REVERBATORY": "a furnace in which the flames are made to pass over the substance being heated; a reverberatory furnace or kiln [n REVERBATORIES]\n",
  "REVERBED": "REVERB, (Shakespeare) to echo, reverberate [v]\n",
  "REVERBERANT": "tending to reverberate [adj REVERBERANTLY]\n",
  "REVERBERANTLY": "REVERBERANT, tending to reverberate [adv]\n",
  "REVERBERATE": "to continue in or as if in a series of echoes, to resound, also REVERB [v REVERBERATED, REVERBERATING, REVERBERATES]\n",
  "REVERBERATED": "REVERBERATE, to continue in or as if in a series of echoes, to resound, also REVERB [v]\n",
  "REVERBERATES": "REVERBERATE, to continue in or as if in a series of echoes, to resound, also REVERB [v]\n",
  "REVERBERATING": "REVERBERATE, to continue in or as if in a series of echoes, to resound, also REVERB [v]\n",
  "REVERBERATION": "an act of reverberating [n -S]\n",
  "REVERBERATIONS": "REVERBERATION, an act of reverberating [n]\n",
  "REVERBERATIVE": "constituting reverberation [adj]\n",
  "REVERBERATOR": "something that reverberates [n -S]\n",
  "REVERBERATORIES": "REVERBERATORY, a kind of furnace [n]\n",
  "REVERBERATORS": "REVERBERATOR, something that reverberates [n]\n",
  "REVERBERATORY": "a kind of furnace [n REVERBERATORIES]\n",
  "REVERBING": "REVERB, (Shakespeare) to echo, reverberate [v]\n",
  "REVERBS": "REVERB, (Shakespeare) to echo, reverberate [v]\n",
  "REVERE": "to regard with great respect [v REVERED, REVERING, REVERES]\n",
  "REVERED": "REVERE, to regard with great respect [v]\n",
  "REVERENCE": "veneration [n -S] / to venerate, also REVERE [v REVERENCED, REVERENCING, REVERENCES]\n",
  "REVERENCED": "REVERENCE, to venerate, also REVERE [v]\n",
  "REVERENCER": "one who reverences [n -S]\n",
  "REVERENCERS": "REVERENCER, one who reverences [n]\n",
  "REVERENCES": "REVERENCE, to venerate, also REVERE [v]\n",
  "REVERENCING": "REVERENCE, to venerate, also REVERE [v]\n",
  "REVEREND": "a clergyman [n -S]\n",
  "REVERENDS": "REVEREND, a clergyman [n]\n",
  "REVERENT": "deeply respectful [adj REVERENTLY]\n",
  "REVERENTIAL": "expressing or having a quality of reverence [adj REVERENTIALLY]\n",
  "REVERENTIALLY": "REVERENTIAL, expressing or having a quality of reverence [adv]\n",
  "REVERENTLY": "REVERENT, deeply respectful [adv]\n",
  "REVERENTNESS": "the state of being reverent [n -ES]\n",
  "REVERENTNESSES": "REVERENTNESS, the state of being reverent [n]\n",
  "REVERER": "one who reveres [n -S]\n",
  "REVERERS": "REVERER, one who reveres [n]\n",
  "REVERES": "REVERE, to regard with great respect [v]\n",
  "REVERIE": "(French) a daydream, also REVERY [n -S]\n",
  "REVERIES": "REVERY, a daydream, also REVERIE [n]\n",
  "REVERIFIED": "REVERIFY, to verify again [v]\n",
  "REVERIFIES": "REVERIFY, to verify again [v]\n",
  "REVERIFY": "to verify again [v REVERIFIED, REVERIFYING, REVERIFIES]\n",
  "REVERIFYING": "REVERIFY, to verify again [v]\n",
  "REVERING": "REVERE, to regard with great respect [v]\n",
  "REVERIST": "a person who has reveries [n -S]\n",
  "REVERISTS": "REVERIST, a person who has reveries [n]\n",
  "REVERS": "(French) a part of a garment that folds back [n REVERS]\n",
  "REVERSAL": "the act of reversing [n -S]\n",
  "REVERSALS": "REVERSAL, the act of reversing [n]\n",
  "REVERSE": "in the opposite direction [adj REVERSELY] / to turn or move in the opposite direction [v REVERSED, REVERSING, REVERSES]\n",
  "REVERSED": "REVERSE, to turn or move in the opposite direction [v]\n",
  "REVERSEDLY": "REVERSED, REVERSE, to turn or move in the opposite direction [adv]\n",
  "REVERSELESS": "unalterable [adj]\n",
  "REVERSELY": "REVERSE, in the opposite direction [adv]\n",
  "REVERSER": "one who reverses [n -S]\n",
  "REVERSERS": "REVERSER, one who reverses [n]\n",
  "REVERSES": "REVERSE, to turn or move in the opposite direction [v]\n",
  "REVERSI": "REVERSO, (Italian) a backhanded sword-stroke [n]\n",
  "REVERSIBILITIES": "REVERSIBILITY, the state of being reversible [n]\n",
  "REVERSIBILITY": "the state of being reversible [n REVERSIBILITIES]\n",
  "REVERSIBLE": "capable of being reversed [adj REVERSIBLY] / a reversible garment [n -S]\n",
  "REVERSIBLES": "REVERSIBLE, a reversible garment [n]\n",
  "REVERSIBLY": "REVERSIBLE, capable of being reversed [adv]\n",
  "REVERSING": "the act of moving in reverse [n -S]\n",
  "REVERSINGS": "REVERSING, the act of moving in reverse [n]\n",
  "REVERSION": "the act of reverting [n -S]\n",
  "REVERSIONAL": "relating to a reversion esp. legal [adj REVERSIONALLY]\n",
  "REVERSIONALLY": "REVERSIONAL, relating to a reversion esp. legal [adv]\n",
  "REVERSIONARIES": "REVERSIONARY, a person who has had a (legal) reversion [n]\n",
  "REVERSIONARY": "a person who has had a (legal) reversion [n REVERSIONARIES]\n",
  "REVERSIONER": "a person entitled to receive an estate after the reversion (grant) runs out [n -S]\n",
  "REVERSIONERS": "REVERSIONER, a person entitled to receive an estate after the reversion (grant) runs out [n]\n",
  "REVERSIONS": "REVERSION, the act of reverting [n]\n",
  "REVERSIS": "an old card game in which the taker of fewest tricks wins [n -ES]\n",
  "REVERSISES": "REVERSIS, an old card game in which the taker of fewest tricks wins [n]\n",
  "REVERSO": "(Italian) a backhanded sword-stroke [n REVERSI or REVERSOS]\n",
  "REVERSOS": "REVERSO, (Italian) a backhanded sword-stroke [n]\n",
  "REVERT": "to return to a former state [v -ED, -ING, -S]\n",
  "REVERTANT": "(French) a mutant gene that regains a former capability [n -S]\n",
  "REVERTANTS": "REVERTANT, (French) a mutant gene that regains a former capability [n]\n",
  "REVERTED": "REVERT, to return to a former state [v]\n",
  "REVERTER": "one who, or that which, reverts [n -S]\n",
  "REVERTERS": "REVERTER, one who, or that which, reverts [n]\n",
  "REVERTIBLE": "capable of being reverted; as, a revertible estate [adj]\n",
  "REVERTING": "REVERT, to return to a former state [v]\n",
  "REVERTIVE": "reverting, or tending to revert [adj]\n",
  "REVERTS": "REVERT, to return to a former state [v]\n",
  "REVERY": "a daydream, also REVERIE [n REVERIES]\n",
  "REVEST": "to vest again [v -ED, -ING, -S]\n",
  "REVESTED": "REVEST, to vest again [v]\n",
  "REVESTIARIES": "REVESTIARY, a vestry, also REVESTRY [n]\n",
  "REVESTIARY": "a vestry, also REVESTRY [n REVESTIARIES]\n",
  "REVESTING": "REVEST, to vest again [v]\n",
  "REVESTRIES": "REVESTRY, a room in which vestments are kept, also VESTRY [n]\n",
  "REVESTRY": "a room in which vestments are kept, also VESTRY [n REVESTRIES]\n",
  "REVESTS": "REVEST, to vest again [v]\n",
  "REVET": "to face with masonry [v REVETTED, REVETTING, REVETS]\n",
  "REVETMENT": "a masonry etc. facing of an embankment or trench [n -S]\n",
  "REVETMENTS": "REVETMENT, a masonry etc. facing of an embankment or trench [n]\n",
  "REVETS": "REVET, to face with masonry [v]\n",
  "REVETTED": "REVET, to face with masonry [v]\n",
  "REVETTING": "REVET, to face with masonry [v]\n",
  "REVEUR": "(French) a daydreamer [n -S]\n",
  "REVEURS": "REVEUR, (French) a daydreamer [n]\n",
  "REVEUSE": "(French) a (female) daydreamer [n -S]\n",
  "REVEUSES": "REVEUSE, (French) a (female) daydreamer [n]\n",
  "REVIBRATE": "to vibrate again [v REVIBRATED, REVIBRATING, REVIBRATES]\n",
  "REVIBRATED": "REVIBRATE, to vibrate again [v]\n",
  "REVIBRATES": "REVIBRATE, to vibrate again [v]\n",
  "REVIBRATING": "REVIBRATE, to vibrate again [v]\n",
  "REVICTUAL": "to victual again [v REVICTUALED or REVICTUALLED, REVICTUALING or REVICTUALLING, REVICTUALS]\n",
  "REVICTUALED": "REVICTUAL, to victual again [v]\n",
  "REVICTUALING": "REVICTUAL, to victual again [v]\n",
  "REVICTUALLED": "REVICTUAL, to victual again [v]\n",
  "REVICTUALLING": "REVICTUAL, to victual again [v]\n",
  "REVICTUALS": "REVICTUAL, to victual again [v]\n",
  "REVIE": "to stake higher [v REVIED, REVYING, REVIES]\n",
  "REVIED": "REVIE, to stake higher [v]\n",
  "REVIES": "REVIE, to stake higher [v]\n",
  "REVIEW": "to view again [v -ED, -ING, -S]\n",
  "REVIEWABLE": "that can be reviewed [adj]\n",
  "REVIEWAL": "the act of reviewing something [n -S]\n",
  "REVIEWALS": "REVIEWAL, the act of reviewing something [n]\n",
  "REVIEWED": "REVIEW, to view again [v]\n",
  "REVIEWER": "one who reviews [n -S]\n",
  "REVIEWERS": "REVIEWER, one who reviews [n]\n",
  "REVIEWING": "REVIEW, to view again [v]\n",
  "REVIEWS": "REVIEW, to view again [v]\n",
  "REVILE": "to assail with bitter abuse [v REVILED, REVILING, REVILES]\n",
  "REVILED": "REVILE, to assail with bitter abuse [v]\n",
  "REVILEMENT": "the act of reviling [n -S]\n",
  "REVILEMENTS": "REVILEMENT, the act of reviling [n]\n",
  "REVILER": "one who reviles [n -S]\n",
  "REVILERS": "REVILER, one who reviles [n]\n",
  "REVILES": "REVILE, to assail with bitter abuse [v]\n",
  "REVILING": "abusive [adj REVILINGLY] / the act of reviling [n -S]\n",
  "REVILINGLY": "REVILING, abusive [adv]\n",
  "REVILINGS": "REVILING, the act of reviling [n]\n",
  "REVINDICATE": "to vindicate again [v REVINDICATED, REVINDICATING, REVINDICATES]\n",
  "REVINDICATED": "REVINDICATE, to vindicate again [v]\n",
  "REVINDICATES": "REVINDICATE, to vindicate again [v]\n",
  "REVINDICATING": "REVINDICATE, to vindicate again [v]\n",
  "REVINDICATION": "the act of revindicating [n -S]\n",
  "REVINDICATIONS": "REVINDICATION, the act of revindicating [n]\n",
  "REVIOLATE": "to violate again [v REVIOLATED, REVIOLATING, REVIOLATES]\n",
  "REVIOLATED": "REVIOLATE, to violate again [v]\n",
  "REVIOLATES": "REVIOLATE, to violate again [v]\n",
  "REVIOLATING": "REVIOLATE, to violate again [v]\n",
  "REVISABLE": "that may be revised [adj]\n",
  "REVISAL": "a revised version, also REVISION [n -S]\n",
  "REVISALS": "REVISAL, a revised version, also REVISION [n]\n",
  "REVISE": "to make a new or improved version of [v REVISED, REVISING, REVISES]\n",
  "REVISED": "REVISE, to make a new or improved version of [v]\n",
  "REVISER": "one who revises, also REVISOR [n -S]\n",
  "REVISERS": "REVISER, one who revises, also REVISOR [n]\n",
  "REVISES": "REVISE, to make a new or improved version of [v]\n",
  "REVISING": "REVISE, to make a new or improved version of [v]\n",
  "REVISION": "a revised version, also REVISAL [n -S]\n",
  "REVISIONAL": "relating to revision, also REVISIONARY [adj]\n",
  "REVISIONARY": "relating to revision, also REVISIONAL [adj]\n",
  "REVISIONISM": "a movement in revolutionary Marxian socialism favoring an evolutionary rather than a revolutionary spirit [n -S]\n",
  "REVISIONISMS": "REVISIONISM, a movement in revolutionary Marxian socialism favoring an evolutionary rather than a revolutionary spirit [n]\n",
  "REVISIONIST": "a supporter of revisionism [n -S]\n",
  "REVISIONISTS": "REVISIONIST, a supporter of revisionism [n]\n",
  "REVISIONS": "REVISION, a revised version, also REVISAL [n]\n",
  "REVISIT": "to visit again [v -ED, -ING, -S]\n",
  "REVISITANT": "one who visits again [n -S]\n",
  "REVISITANTS": "REVISITANT, one who visits again [n]\n",
  "REVISITATION": "the act of revisiting [n -S]\n",
  "REVISITATIONS": "REVISITATION, the act of revisiting [n]\n",
  "REVISITED": "REVISIT, to visit again [v]\n",
  "REVISITING": "REVISIT, to visit again [v]\n",
  "REVISITS": "REVISIT, to visit again [v]\n",
  "REVISOR": "one who revises, also REVISER [n -S]\n",
  "REVISORS": "REVISOR, one who revises, also REVISER [n]\n",
  "REVISORY": "having the power or purpose to revise [adj]\n",
  "REVISUALISATION": "the act of visualising again, also REVISUALIZATION [n]\n",
  "REVISUALIZATION": "the act of visualizing again, also REVISUALISATION [n]\n",
  "REVITALISATION": "the process of revitalising, also REVITALIZATION [n -S]\n",
  "REVITALISATIONS": "REVITALISATION, the process of revitalising, also REVITALIZATION [n]\n",
  "REVITALISE": "to give new life or vigor to, also REVITALIZE [v REVITALISED, REVITALISING, REVITALISES]\n",
  "REVITALISED": "REVITALISE, to give new life or vigor to, also REVITALIZE [v]\n",
  "REVITALISES": "REVITALISE, to give new life or vigor to, also REVITALIZE [v]\n",
  "REVITALISING": "REVITALISE, to give new life or vigor to, also REVITALIZE [v]\n",
  "REVITALIZATION": "the process of revitalizing, also REVITALISATION [n -S]\n",
  "REVITALIZATIONS": "REVITALIZATION, the process of revitalizing, also REVITALISATION [n]\n",
  "REVITALIZE": "to give new life or vigor to, also REVITALISE [v REVITALIZED, REVITALIZING, REVITALIZES]\n",
  "REVITALIZED": "REVITALIZE, to give new life or vigor to, also REVITALISE [v]\n",
  "REVITALIZES": "REVITALIZE, to give new life or vigor to, also REVITALISE [v]\n",
  "REVITALIZING": "REVITALIZE, to give new life or vigor to, also REVITALISE [v]\n",
  "REVIVABILITIES": "REVIVABILITY, the quality of being revivable [n]\n",
  "REVIVABILITY": "the quality of being revivable [n REVIVABILITIES]\n",
  "REVIVABLE": "that can be revived [adj REVIVABLY]\n",
  "REVIVABLY": "REVIVABLE, that can be revived [adv]\n",
  "REVIVAL": "renewed interest or attention to something [n -S]\n",
  "REVIVALISM": "the spirit or methods characteristic of religious revivals [n -S]\n",
  "REVIVALISMS": "REVIVALISM, the spirit or methods characteristic of religious revivals [n]\n",
  "REVIVALIST": "one who conducts religious revivals [n -S]\n",
  "REVIVALISTIC": "relating to revivalism, the spirit or methods characteristic of religious revivals [adj]\n",
  "REVIVALISTS": "REVIVALIST, one who conducts religious revivals [n]\n",
  "REVIVALS": "REVIVAL, renewed interest or attention to something [n]\n",
  "REVIVE": "to bring back to life or consciousness [v REVIVED, REVIVING, REVIVES]\n",
  "REVIVED": "REVIVE, to bring back to life or consciousness [v]\n",
  "REVIVEMENT": "the act of reviving [n -S]\n",
  "REVIVEMENTS": "REVIVEMENT, the act of reviving [n]\n",
  "REVIVER": "something that revives [n -S]\n",
  "REVIVERS": "REVIVER, something that revives [n]\n",
  "REVIVES": "REVIVE, to bring back to life or consciousness [v]\n",
  "REVIVESCENCE": "the act of reviving, also REVIVESCENCY, REVIVISCENCE, REVIVISCENCY [n -S]\n",
  "REVIVESCENCES": "REVIVESCENCE, the act of reviving, also REVIVESCENCY, REVIVISCENCE, REVIVISCENCY [n]\n",
  "REVIVESCENCIES": "REVIVESCENCY, the act of reviving, also REVIVESCENCE, REVIVISCENCE, REVIVISCENCY [n]\n",
  "REVIVESCENCY": "the act of reviving, also REVIVESCENCE, REVIVISCENCE, REVIVISCENCY [n REVIVESCENCIES]\n",
  "REVIVESCENT": "reviving, also REVIVISCENT [adj]\n",
  "REVIVIFICATION": "the act of revivifying [n -S]\n",
  "REVIVIFICATIONS": "REVIVIFICATION, the act of revivifying [n]\n",
  "REVIVIFIED": "REVIVIFY, to reactivate [v]\n",
  "REVIVIFIES": "REVIVIFY, to reactivate [v]\n",
  "REVIVIFY": "to reactivate [v REVIVIFIED, REVIVIFYING, REVIVIFIES]\n",
  "REVIVIFYING": "REVIVIFY, to reactivate [v]\n",
  "REVIVING": "restorative [adj REVIVINGLY] / the act of reviving [n -S]\n",
  "REVIVINGLY": "REVIVING, restorative [adv]\n",
  "REVIVINGS": "REVIVING, the act of reviving [n]\n",
  "REVIVISCENCE": "the act of reviving, also REVIVESCENCE, REVIVESCENCY, REVIVISCENCY [n -S]\n",
  "REVIVISCENCES": "REVIVISCENCE, the act of reviving, also REVIVESCENCE, REVIVESCENCY, REVIVISCENCY [n]\n",
  "REVIVISCENCIES": "REVIVISCENCY, the act of reviving, also REVIVESCENCE, REVIVESCENCY, REVIVISCENCE [n]\n",
  "REVIVISCENCY": "the act of reviving, also REVIVESCENCE, REVIVESCENCY, REVIVISCENCE [n REVIVISCENCIES]\n",
  "REVIVISCENT": "reviving, also REVIVESCENT [adj]\n",
  "REVIVOR": "the revival of a law suit [n -S]\n",
  "REVIVORS": "REVIVOR, the revival of a law suit [n]\n",
  "REVOCABILITIES": "REVOCABILITY, the quality of being revocable, also REVOKABILITY [n]\n",
  "REVOCABILITY": "the quality of being revocable, also REVOKABILITY [n REVOCABILITIES]\n",
  "REVOCABLE": "that can be revoked, also REVOKABLE [adj REVOCABLY]\n",
  "REVOCABLENESS": "the quality of being revocable [n -ES]\n",
  "REVOCABLENESSES": "REVOCABLENESS, the quality of being revocable [n]\n",
  "REVOCABLY": "REVOCABLE, that can be revoked, also REVOKABLE [adv]\n",
  "REVOCATION": "the act of revoking, calling back [n -S]\n",
  "REVOCATIONS": "REVOCATION, the act of revoking, calling back [n]\n",
  "REVOCATORY": "of or pertaining to revocation [adj]\n",
  "REVOICE": "to refurnish with a voice; to refit, as an organ pipe, so as to restore its tone [v REVOICED, REVOICING, REVOICES]\n",
  "REVOICED": "REVOICE, to refurnish with a voice; to refit, as an organ pipe, so as to restore its tone [v]\n",
  "REVOICES": "REVOICE, to refurnish with a voice; to refit, as an organ pipe, so as to restore its tone [v]\n",
  "REVOICING": "REVOICE, to refurnish with a voice; to refit, as an organ pipe, so as to restore its tone [v]\n",
  "REVOKABILITIES": "REVOKABILITY, the quality of being revokable, also REVOCABILITY [n]\n",
  "REVOKABILITY": "the quality of being revokable, also REVOCABILITY [n REVOKABILITIES]\n",
  "REVOKABLE": "that can be revoked, also REVOCABLE [adj REVOKABLY]\n",
  "REVOKABLY": "REVOKABLE, that can be revoked, also REVOCABLE [adv]\n",
  "REVOKE": "to annul by taking back [v REVOKED, REVOKING, REVOKES]\n",
  "REVOKED": "REVOKE, to annul by taking back [v]\n",
  "REVOKEMENT": "(Shakespeare) the act of revoking [n -S]\n",
  "REVOKEMENTS": "REVOKEMENT, (Shakespeare) the act of revoking [n]\n",
  "REVOKER": "one who revokes [n -S]\n",
  "REVOKERS": "REVOKER, one who revokes [n]\n",
  "REVOKES": "REVOKE, to annul by taking back [v]\n",
  "REVOKING": "REVOKE, to annul by taking back [v]\n",
  "REVOLT": "to rise up against authority [v -ED, -ING, -S]\n",
  "REVOLTED": "REVOLT, to rise up against authority [v]\n",
  "REVOLTER": "one who revolts [n -S]\n",
  "REVOLTERS": "REVOLTER, one who revolts [n]\n",
  "REVOLTING": "REVOLT, to rise up against authority [v]\n",
  "REVOLTINGLY": "REVOLTING, REVOLT, to rise up against authority [adv]\n",
  "REVOLTS": "REVOLT, to rise up against authority [v]\n",
  "REVOLUTE": "rolled backward or downward [adj]\n",
  "REVOLUTION": "the action by a celestial body of going round in an orbit or elliptical course [n -S]\n",
  "REVOLUTIONAL": "of or like revolution [adj]\n",
  "REVOLUTIONARIES": "REVOLUTIONARY, one engaged in a revolution [n]\n",
  "REVOLUTIONARILY": "REVOLUTIONARY, of or like a revolution [adv]\n",
  "REVOLUTIONARY": "of or like a revolution [adj REVOLUTIONARILY] / one engaged in a revolution [n REVOLUTIONARIES]\n",
  "REVOLUTIONER": "(historical) a supporter of a revolution, esp. that of 1688 [n -S]\n",
  "REVOLUTIONERS": "REVOLUTIONER, (historical) a supporter of a revolution, esp. that of 1688 [n]\n",
  "REVOLUTIONISE": "to effect a revolution in, also REVOLUTIONIZE [v REVOLUTIONISED, REVOLUTIONISING, REVOLUTIONISES]\n",
  "REVOLUTIONISED": "REVOLUTIONISE, to effect a revolution in, also REVOLUTIONIZE [v]\n",
  "REVOLUTIONISER": "one who revolutionises, also REVOLUTIONIZER [n -S]\n",
  "REVOLUTIONISERS": "REVOLUTIONISER, one who revolutionises, also REVOLUTIONIZER [n]\n",
  "REVOLUTIONISES": "REVOLUTIONISE, to effect a revolution in, also REVOLUTIONIZE [v]\n",
  "REVOLUTIONISING": "REVOLUTIONISE, to effect a revolution in, also REVOLUTIONIZE [v]\n",
  "REVOLUTIONISM": "belief in revolution [n -S]\n",
  "REVOLUTIONISMS": "REVOLUTIONISM, belief in revolution [n]\n",
  "REVOLUTIONIST": "a revolutionary [n -S]\n",
  "REVOLUTIONISTS": "REVOLUTIONIST, a revolutionary [n]\n",
  "REVOLUTIONIZE": "to effect a revolution in, also REVOLUTIONISE [v REVOLUTIONIZED, REVOLUTIONIZING, REVOLUTIONIZES]\n",
  "REVOLUTIONIZED": "REVOLUTIONIZE, to effect a revolution in, also REVOLUTIONISE [v]\n",
  "REVOLUTIONIZER": "one who effects a revolution, also REVOLUTIONISER [n -S]\n",
  "REVOLUTIONIZERS": "REVOLUTIONIZER, one who effects a revolution, also REVOLUTIONISER [n]\n",
  "REVOLUTIONIZES": "REVOLUTIONIZE, to effect a revolution in, also REVOLUTIONISE [v]\n",
  "REVOLUTIONIZING": "REVOLUTIONIZE, to effect a revolution in, also REVOLUTIONISE [v]\n",
  "REVOLUTIONS": "REVOLUTION, the action by a celestial body of going round in an orbit or elliptical course [n]\n",
  "REVOLVABLE": "that may be revolved [adj REVOLVABLY]\n",
  "REVOLVABLY": "REVOLVABLE, that may be revolved [adv]\n",
  "REVOLVE": "to turn on an axis [v REVOLVED, REVOLVING, REVOLVES]\n",
  "REVOLVED": "REVOLVE, to turn on an axis [v]\n",
  "REVOLVENCIES": "REVOLVENCY, the act or state of revolving [n]\n",
  "REVOLVENCY": "the act or state of revolving [n REVOLVENCIES]\n",
  "REVOLVER": "a pistol with a rotating magazine [n -S]\n",
  "REVOLVERS": "REVOLVER, a pistol with a rotating magazine [n]\n",
  "REVOLVES": "REVOLVE, to turn on an axis [v]\n",
  "REVOLVING": "turning about an axis [adj REVOLVINGLY] / the act of revolving [n -S]\n",
  "REVOLVINGLY": "REVOLVING, turning about an axis [adv]\n",
  "REVOLVINGS": "REVOLVING, the act of revolving [n]\n",
  "REVOTE": "to vote again [v REVOTED, REVOTING, REVOTES]\n",
  "REVOTED": "REVOTE, to vote again [v]\n",
  "REVOTES": "REVOTE, to vote again [v]\n",
  "REVOTING": "REVOTE, to vote again [v]\n",
  "REVS": "REV, to increase the speed of [v]\n",
  "REVUE": "(French) a type of musical show [n -S]\n",
  "REVUES": "REVUE, (French) a type of musical show [n]\n",
  "REVUIST": "a writer of revues [n -S]\n",
  "REVUISTS": "REVUIST, a writer of revues [n]\n",
  "REVULSED": "affected with revulsion [adj]\n",
  "REVULSION": "a feeling of strong dislike or disgust [n -S]\n",
  "REVULSIONARY": "of or like revolution [adj]\n",
  "REVULSIONS": "REVULSION, a feeling of strong dislike or disgust [n]\n",
  "REVULSIVE": "causing, or tending to, revulsion [adj REVULSIVELY] / a counterirritant [n -S]\n",
  "REVULSIVELY": "REVULSIVE, causing, or tending to, revulsion [adv]\n",
  "REVULSIVES": "REVULSIVE, a counterirritant [n]\n",
  "REVVED": "REV, to increase the speed of [v]\n",
  "REVVING": "REV, to increase the speed of [v]\n",
  "REVYING": "REVIE, to stake higher [v]\n",
  "REW": "(Spenser) a row [n -S]\n",
  "REWAKE": "to wake again [v REWOKE or REWAKED, REWOKEN, REWAKING, REWAKES]\n",
  "REWAKED": "REWAKE, to wake again [v]\n",
  "REWAKEN": "to waken again, also REAWAKE, REWAKE [v -ED, -ING, -S]\n",
  "REWAKENED": "REWAKEN, to waken again, also REAWAKE, REWAKE [v]\n",
  "REWAKENING": "REWAKEN, to waken again, also REAWAKE, REWAKE [v]\n",
  "REWAKENS": "REWAKEN, to waken again, also REAWAKE, REWAKE [v]\n",
  "REWAKES": "REWAKE, to wake again [v]\n",
  "REWAKING": "REWAKE, to wake again [v]\n",
  "REWAN": "REWIN, to win again [v]\n",
  "REWARD": "to give in return for some service or act [v -ED, -ING, -S]\n",
  "REWARDABLE": "that can be rewarded [adj]\n",
  "REWARDABLENESS": "the state of being rewardable [n]\n",
  "REWARDED": "REWARD, to give in return for some service or act [v]\n",
  "REWARDER": "one that rewards [n -S]\n",
  "REWARDERS": "REWARDER, one that rewards [n]\n",
  "REWARDFUL": "yielding reward [adj]\n",
  "REWARDING": "REWARD, to give in return for some service or act [v]\n",
  "REWARDINGLY": "REWARDING, REWARD, to give in return for some service or act [adv]\n",
  "REWARDLESS": "having, or affording, no reward [adj]\n",
  "REWARDS": "REWARD, to give in return for some service or act [v]\n",
  "REWAREWA": "(Maori) a New Zealand tree whose wood is used in furniture making [n -S]\n",
  "REWAREWAS": "REWAREWA, (Maori) a New Zealand tree whose wood is used in furniture making [n]\n",
  "REWARM": "to warm again [v -ED, -ING, -S]\n",
  "REWARMED": "REWARM, to warm again [v]\n",
  "REWARMING": "REWARM, to warm again [v]\n",
  "REWARMS": "REWARM, to warm again [v]\n",
  "REWASH": "to wash again [v -ED, -ING, -ES]\n",
  "REWASHED": "REWASH, to wash again [v]\n",
  "REWASHES": "REWASH, to wash again [v]\n",
  "REWASHING": "REWASH, to wash again [v]\n",
  "REWATER": "to water again [v -ED, -ING, -S]\n",
  "REWATERED": "REWATER, to water again [v]\n",
  "REWATERING": "REWATER, to water again [v]\n",
  "REWATERS": "REWATER, to water again [v]\n",
  "REWAX": "to wax again [v -ED, -ING, -ES]\n",
  "REWAXED": "REWAX, to wax again [v]\n",
  "REWAXES": "REWAX, to wax again [v]\n",
  "REWAXING": "REWAX, to wax again [v]\n",
  "REWEAR": "to wear again [v REWORE, REWORN, REWEARING, REWEARS]\n",
  "REWEARING": "REWEAR, to wear again [v]\n",
  "REWEARS": "REWEAR, to wear again [v]\n",
  "REWEAVE": "to weave again [v REWOVE or REWEAVED, REWOVEN, REWEAVING, REWEAVES]\n",
  "REWEAVED": "REWEAVE, to weave again [v]\n",
  "REWEAVES": "REWEAVE, to weave again [v]\n",
  "REWEAVING": "REWEAVE, to weave again [v]\n",
  "REWED": "to wed again [v REWEDDED, REWEDDING, REWEDS]\n",
  "REWEDDED": "REWED, to wed again [v]\n",
  "REWEDDING": "REWED, to wed again [v]\n",
  "REWEDS": "REWED, to wed again [v]\n",
  "REWEIGH": "to weigh again [v -ED, -ING, -S]\n",
  "REWEIGHED": "REWEIGH, to weigh again [v]\n",
  "REWEIGHING": "REWEIGH, to weigh again [v]\n",
  "REWEIGHS": "REWEIGH, to weigh again [v]\n",
  "REWELD": "to weld again [v -ED, -ING, -S]\n",
  "REWELDED": "REWELD, to weld again [v]\n",
  "REWELDING": "REWELD, to weld again [v]\n",
  "REWELDS": "REWELD, to weld again [v]\n",
  "REWET": "to wet again [v REWETTED, REWETTING, REWETS]\n",
  "REWETS": "REWET, to wet again [v]\n",
  "REWETTED": "REWET, to wet again [v]\n",
  "REWETTING": "REWET, to wet again [v]\n",
  "REWIDEN": "to widen again [v -ED, -ING, -S]\n",
  "REWIDENED": "REWIDEN, to widen again [v]\n",
  "REWIDENING": "REWIDEN, to widen again [v]\n",
  "REWIDENS": "REWIDEN, to widen again [v]\n",
  "REWILD": "to release (an animal) from captivity into the wild to return (land) to a natural, undeveloped state [v -ED, -ING, -S]\n",
  "REWILDED": "REWILD, to release (an animal) from captivity into the wild to return (land) to a natural, undeveloped state [v]\n",
  "REWILDING": "the practice of returning areas of land to a wild state, including the reintroduction of animal species that are no longer naturally found there [n -S]\n",
  "REWILDINGS": "REWILDING, the practice of returning areas of land to a wild state, including the reintroduction of animal species that are no longer naturally found there [n]\n",
  "REWILDS": "REWILD, to release (an animal) from captivity into the wild to return (land) to a natural, undeveloped state [v]\n",
  "REWIN": "to win again [v REWON or (obsolete) REWAN, REWINNING, REWINS]\n",
  "REWIND": "to wind again [v REWINDED, REWOUND, REWINDING, REWINDS]\n",
  "REWINDED": "REWIND, to wind again [v]\n",
  "REWINDER": "one who rewinds [n -S]\n",
  "REWINDERS": "REWINDER, one who rewinds [n]\n",
  "REWINDING": "the act of winding again [n -S]\n",
  "REWINDINGS": "REWINDING, the act of winding again [n]\n",
  "REWINDS": "REWIND, to wind again [v]\n",
  "REWINNING": "REWIN, to win again [v]\n",
  "REWINS": "REWIN, to win again [v]\n",
  "REWIRABLE": "that can be rewired [adj]\n",
  "REWIRE": "to install new wiring [v REWIRED, REWIRING, REWIRES]\n",
  "REWIRED": "REWIRE, to install new wiring [v]\n",
  "REWIRES": "REWIRE, to install new wiring [v]\n",
  "REWIRING": "the act of fitting with new wires [n -S]\n",
  "REWIRINGS": "REWIRING, the act of fitting with new wires [n]\n",
  "REWOKE": "REWAKE, to wake again [v]\n",
  "REWOKEN": "REWAKE, to wake again [v]\n",
  "REWON": "REWIN, to win again [v]\n",
  "REWORD": "to state again in different wording [v -ED, -ING, -S]\n",
  "REWORDED": "REWORD, to state again in different wording [v]\n",
  "REWORDING": "the act of stating again in different wording [n -S]\n",
  "REWORDINGS": "REWORDING, the act of stating again in different wording [n]\n",
  "REWORDS": "REWORD, to state again in different wording [v]\n",
  "REWORE": "REWEAR, to wear again [v]\n",
  "REWORK": "to work again [v REWROUGHT or REWORKED, REWORKING, REWORKS]\n",
  "REWORKED": "REWORK, to work again [v]\n",
  "REWORKING": "the act of working again [n -S]\n",
  "REWORKINGS": "REWORKING, the act of working again [n]\n",
  "REWORKS": "REWORK, to work again [v]\n",
  "REWORN": "REWEAR, to wear again [v]\n",
  "REWOUND": "REWIND, to wind again [v]\n",
  "REWOVE": "REWEAVE, to weave again [v]\n",
  "REWOVEN": "REWEAVE, to weave again [v]\n",
  "REWRAP": "to wrap again [v REWRAPPED, REWRAPT, REWRAPPING, REWRAPS]\n",
  "REWRAPPED": "REWRAP, to wrap again [v]\n",
  "REWRAPPING": "REWRAP, to wrap again [v]\n",
  "REWRAPS": "REWRAP, to wrap again [v]\n",
  "REWRAPT": "REWRAP, to wrap again [v]\n",
  "REWRITABLE": "(of a CD, flash drive, etc.) able to record information over the top of existing information, also REWRITEABLE [adj]\n",
  "REWRITE": "to write again [v REWROTE, REWRITTEN, REWRITING, REWRITES]\n",
  "REWRITEABLE": "(of a CD, flash drive, etc.) able to record information over the top of existing information, also REWRITABLE [adj]\n",
  "REWRITER": "a device for rewriting [n -S]\n",
  "REWRITERS": "REWRITER, a device for rewriting [n]\n",
  "REWRITES": "REWRITE, to write again [v]\n",
  "REWRITING": "REWRITE, to write again [v]\n",
  "REWRITTEN": "REWRITE, to write again [v]\n",
  "REWROTE": "REWRITE, to write again [v]\n",
  "REWROUGHT": "REWORK, to work again [v]\n",
  "REWS": "REW, (Spenser) a row [n]\n",
  "REWTH": "(Spenser) ruth, pity [n -S]\n",
  "REWTHS": "REWTH, (Spenser) ruth, pity [n]\n",
  "REX": "a king [n REGES] / an animal with a single wavy layer of hair [n REXES]\n",
  "REXES": "REX, a king [n]\n",
  "REXINE": "(tradename) a kind of artificial leather [n -S]\n",
  "REXINES": "REXINE, (tradename) a kind of artificial leather [n]\n",
  "REYNARD": "an appellation applied after the manner of a proper name to the fox [n -S]\n",
  "REYNARDS": "REYNARD, an appellation applied after the manner of a proper name to the fox [n]\n",
  "REZ": "(short for) a (Native American) reservation, also RES [n REZES or REZZES]\n",
  "REZERO": "to reset (a gauge) back to zero [v -ED, -ING, -S or -ES]\n",
  "REZEROED": "REZERO, to reset (a gauge) back to zero [v]\n",
  "REZEROES": "REZERO, to reset (a gauge) back to zero [v]\n",
  "REZEROING": "REZERO, to reset (a gauge) back to zero [v]\n",
  "REZEROS": "REZERO, to reset (a gauge) back to zero [v]\n",
  "REZES": "REZ, (short for) a (Native American) reservation, also RES [n]\n",
  "REZONE": "to zone again [v REZONED, REZONING, REZONES]\n",
  "REZONED": "REZONE, to zone again [v]\n",
  "REZONES": "REZONE, to zone again [v]\n",
  "REZONING": "the act of altering the boundaries of [n -S]\n",
  "REZONINGS": "REZONING, the act of altering the boundaries of [n]\n",
  "REZZES": "REZ, (short for) a (Native American) reservation, also RES [n]\n",
  "RHABDOCOELE": "a turbellarian worm with an unbranched intestine [n -S]\n",
  "RHABDOCOELES": "RHABDOCOELE, a turbellarian worm with an unbranched intestine [n]\n",
  "RHABDOID": "a rodlike body [n -S]\n",
  "RHABDOIDS": "RHABDOID, a rodlike body [n]\n",
  "RHABDOLITH": "a calcareous rod in some Protozoa [n -S]\n",
  "RHABDOLITHS": "RHABDOLITH, a calcareous rod in some Protozoa [n]\n",
  "RHABDOM": "(Greek) a rodlike structure in the retinula, also RHABDOME [n -S]\n",
  "RHABDOMAL": "of or like a rhabdom, a fourfold rod in the compound eye of an arthropod [adj]\n",
  "RHABDOMANCER": "one who practises rhabdomancy [n -S]\n",
  "RHABDOMANCERS": "RHABDOMANCER, one who practises rhabdomancy [n]\n",
  "RHABDOMANCIES": "RHABDOMANCY, divination by wands or rods [n]\n",
  "RHABDOMANCY": "divination by wands or rods [n RHABDOMANCIES]\n",
  "RHABDOMANTIST": "one who practices divination by means of a rod to locate underground water; a dowser [n -S]\n",
  "RHABDOMANTISTS": "RHABDOMANTIST, one who practices divination by means of a rod to locate underground water; a dowser [n]\n",
  "RHABDOME": "(Greek) a rodlike structure in the retinula, also RHABDOM [n -S]\n",
  "RHABDOMERE": "one of the several parts composing a rhabdom [n -S]\n",
  "RHABDOMERES": "RHABDOMERE, one of the several parts composing a rhabdom [n]\n",
  "RHABDOMES": "RHABDOME, (Greek) a rodlike structure in the retinula, also RHABDOM [n]\n",
  "RHABDOMS": "RHABDOM, (Greek) a rodlike structure in the retinula, also RHABDOME [n]\n",
  "RHABDOMYOMA": "a tumour of striated muscle [n RHABDOMYOMAS or RHABDOMYOMATA]\n",
  "RHABDOMYOMAS": "RHABDOMYOMA, a tumour of striated muscle [n]\n",
  "RHABDOMYOMATA": "RHABDOMYOMA, a tumour of striated muscle [n]\n",
  "RHABDOSPHERE": "an aggregation of rhabdoliths in oceanic ooze [n -S]\n",
  "RHABDOSPHERES": "RHABDOSPHERE, an aggregation of rhabdoliths in oceanic ooze [n]\n",
  "RHABDOVIRUS": "a class of virus that includes rabies [n -ES]\n",
  "RHABDOVIRUSES": "RHABDOVIRUS, a class of virus that includes rabies [n]\n",
  "RHABDUS": "(Greek) a rodlike sponge spicule [n -ES]\n",
  "RHABDUSES": "RHABDUS, (Greek) a rodlike sponge spicule [n]\n",
  "RHACHIAL": "pertaining to the spinal column [adj]\n",
  "RHACHIDES": "RHACHIS, (Greek) the spinal column, also RACHIS [n]\n",
  "RHACHIDIAL": "of or like a rhachis, the spine or axis of a feather, also RACHIDIAL, RACHIDIAN [adj]\n",
  "RHACHILLA": "(Greek) the axis of a grass spikelet, also RACHILLA [n -S]\n",
  "RHACHILLAS": "RHACHILLA, (Greek) the axis of a grass spikelet, also RACHILLA [n]\n",
  "RHACHIS": "(Greek) the spinal column, also RACHIS [n RHACHISES or RHACHIDES]\n",
  "RHACHISES": "RHACHIS, (Greek) the spinal column, also RACHIS [n]\n",
  "RHACHITIS": "inflammation of the spine; rickets, also RACHITIS [n RHACHITISES]\n",
  "RHACHITISES": "RHACHITIS, inflammation of the spine; rickets, also RACHITIS [n]\n",
  "RHADAMANTHINE": "strictly and inflexibly honest and just [adj]\n",
  "RHAGADES": "(Greek) cracks in the skin [n]\n",
  "RHAGADIFORM": "in the form of cracks or fissures in the skin [adj]\n",
  "RHAMNACEOUS": "relating to the buckthorn family [adj]\n",
  "RHAMNOSE": "a sugar found in plants [n -S]\n",
  "RHAMNOSES": "RHAMNOSE, a sugar found in plants [n]\n",
  "RHAMNUS": "(Greek) a thorny tree or shrub [n -ES]\n",
  "RHAMNUSES": "RHAMNUS, (Greek) a thorny tree or shrub [n]\n",
  "RHAMPHOID": "hook-beak-shaped, like e.g. a toucan [adj]\n",
  "RHAMPHOTHECA": "the horny or leathery outer layer of a bird's bill [n RHAMPHOTHECAE]\n",
  "RHAMPHOTHECAE": "RHAMPHOTHECA, the horny or leathery outer layer of a bird's bill [n]\n",
  "RHANJA": "(Hinglish) a male lover [n -S]\n",
  "RHANJAS": "RHANJA, (Hinglish) a male lover [n]\n",
  "RHAPHAE": "RHAPHE, (Greek) a seamlike ridge between two halves or an organ or part, also RAPHE [n]\n",
  "RHAPHE": "(Greek) a seamlike ridge between two halves or an organ or part, also RAPHE [n RHAPHES or RHAPHAE]\n",
  "RHAPHES": "RHAPHE, (Greek) a seamlike ridge between two halves or an organ or part, also RAPHE [n]\n",
  "RHAPHIDE": "a needlelike crystal, also RHAPHIS [n RHAPHIDES]\n",
  "RHAPHIDES": "RHAPHIS, (Greek) a needlelike crystal, usually of calcium oxalate, occurring in plant cells, also RAPHIDE, RAPHIS, RHAPHIDE [n]\n",
  "RHAPHIS": "(Greek) a needlelike crystal, usually of calcium oxalate, occurring in plant cells, also RAPHIDE, RAPHIS, RHAPHIDE [n RHAPHIDES]\n",
  "RHAPONTIC": "the common rhubarb [n -S]\n",
  "RHAPONTICS": "RHAPONTIC, the common rhubarb [n]\n",
  "RHAPSODE": "anciently, one who recited or composed a rhapsody; esp. one whose profession was to recite the verses of Homer and other epic poets, also RHAPSODIST [n -S]\n",
  "RHAPSODES": "RHAPSODE, anciently, one who recited or composed a rhapsody; esp. one whose profession was to recite the verses of Homer and other epic poets, also RHAPSODIST [n]\n",
  "RHAPSODIC": "of or like a rhapsody, a free instrumental composition in one extended movement, also RHAPSODICAL [adj RHAPSODICALLY]\n",
  "RHAPSODICAL": "of or like a rhapsody, a free instrumental composition in one extended movement, also RHAPSODIC [adj RHAPSODICALLY]\n",
  "RHAPSODICALLY": "RHAPSODICAL, of or like a rhapsody, a free instrumental composition in one extended movement, also RHAPSODIC [adv]\n",
  "RHAPSODIES": "RHAPSODY, an irregular, emotional piece of music [n]\n",
  "RHAPSODISE": "to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODIZE [v RHAPSODISED, RHAPSODISING, RHAPSODISES]\n",
  "RHAPSODISED": "RHAPSODISE, to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODIZE [v]\n",
  "RHAPSODISES": "RHAPSODISE, to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODIZE [v]\n",
  "RHAPSODISING": "RHAPSODISE, to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODIZE [v]\n",
  "RHAPSODIST": "anciently, one who recited or composed a rhapsody; esp. one whose profession was to recite the verses of Homer and other epic poets, also RHAPSODE [n -S]\n",
  "RHAPSODISTIC": "of the nature of a rhapsody [adj]\n",
  "RHAPSODISTS": "RHAPSODIST, anciently, one who recited or composed a rhapsody; esp. one whose profession was to recite the verses of Homer and other epic poets, also RHAPSODE [n]\n",
  "RHAPSODIZE": "to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODISE [v RHAPSODIZED, RHAPSODIZING, RHAPSODIZES]\n",
  "RHAPSODIZED": "RHAPSODIZE, to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODISE [v]\n",
  "RHAPSODIZES": "RHAPSODIZE, to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODISE [v]\n",
  "RHAPSODIZING": "RHAPSODIZE, to utter as a rhapsody, or in the manner of a rhapsody, also RHAPSODISE [v]\n",
  "RHAPSODY": "an irregular, emotional piece of music [n RHAPSODIES]\n",
  "RHATANIES": "RHATANY, (Quechua) a South American shrub, also RATANY [n]\n",
  "RHATANY": "(Quechua) a South American shrub, also RATANY [n RHATANIES]\n",
  "RHEA": "a flightless bird [n -S]\n",
  "RHEAS": "RHEA, a flightless bird [n]\n",
  "RHEBOK": "(South African) a kind of antelope, also REEBOK [n -S]\n",
  "RHEBOKS": "RHEBOK, (South African) a kind of antelope, also REEBOK [n]\n",
  "RHEMATIC": "pertaining to a verb [adj]\n",
  "RHEME": "the constituent of a sentence that adds the most new information [n -S]\n",
  "RHEMES": "RHEME, the constituent of a sentence that adds the most new information [n]\n",
  "RHENIUM": "a metallic element [n -S]\n",
  "RHENIUMS": "RHENIUM, a metallic element [n]\n",
  "RHEOBASE": "the smallest amount of electricity required to stimulate a nerve [n -S]\n",
  "RHEOBASES": "RHEOBASE, the smallest amount of electricity required to stimulate a nerve [n]\n",
  "RHEOBASIC": "relating to a rheobase, the smallest amount of electricity required to stimulate a nerve [adj]\n",
  "RHEOCHORD": "a wire rheostat, a metallic wire used for regulating the resistance of a circuit, also RHEOCORD [n -S]\n",
  "RHEOCHORDS": "RHEOCHORD, a wire rheostat, a metallic wire used for regulating the resistance of a circuit, also RHEOCORD [n]\n",
  "RHEOCORD": "a wire rheostat, a metallic wire used for regulating the resistance of a circuit, also RHEOCHORD [n -S]\n",
  "RHEOCORDS": "RHEOCORD, a wire rheostat, a metallic wire used for regulating the resistance of a circuit, also RHEOCHORD [n]\n",
  "RHEOLOGIC": "relating to rheology, the science of the deformation or flow of matter, also RHEOLOGICAL [adj]\n",
  "RHEOLOGICAL": "relating to rheology, the science of the deformation or flow of matter, also RHEOLOGIC [adj RHEOLOGICALLY]\n",
  "RHEOLOGICALLY": "RHEOLOGICAL, relating to rheology, the science of the deformation or flow of matter, also RHEOLOGIC [adv]\n",
  "RHEOLOGIES": "RHEOLOGY, the study of matter in the fluid state [n]\n",
  "RHEOLOGIST": "one who studies rheology [n -S]\n",
  "RHEOLOGISTS": "RHEOLOGIST, one who studies rheology [n]\n",
  "RHEOLOGY": "the study of matter in the fluid state [n RHEOLOGIES]\n",
  "RHEOMETER": "an instrument that measures current [n -S]\n",
  "RHEOMETERS": "RHEOMETER, an instrument that measures current [n]\n",
  "RHEOMETRIC": "relating to measurement by a rheometer, also RHEOMETRICAL [adj]\n",
  "RHEOMETRICAL": "relating to measurement by a rheometer, also RHEOMETRIC [adj]\n",
  "RHEOMETRIES": "RHEOMETRY, measurement with a rheometer, an instrument that measures current [n]\n",
  "RHEOMETRY": "measurement with a rheometer, an instrument that measures current [n RHEOMETRIES]\n",
  "RHEOMORPHIC": "relating to rheomorphism, the liquefaction of rock [adj]\n",
  "RHEOMORPHISM": "the liquefaction of rock, which results in its flowing and intruding into surrounding rocks [n -S]\n",
  "RHEOMORPHISMS": "RHEOMORPHISM, the liquefaction of rock, which results in its flowing and intruding into surrounding rocks [n]\n",
  "RHEOPHIL": "living in flowing water, also RHEOPHILE [adj]\n",
  "RHEOPHILE": "living in flowing water, also RHEOPHIL [adj] / a creature that lives in flowing water, also RHEOPHIL [n -S]\n",
  "RHEOPHILES": "RHEOPHILE, a creature that lives in flowing water, also RHEOPHIL [n]\n",
  "RHEORECEPTOR": "a receptor in fish and some amphibians that responds to water currents [n -S]\n",
  "RHEORECEPTORS": "RHEORECEPTOR, a receptor in fish and some amphibians that responds to water currents [n]\n",
  "RHEOSCOPE": "an instrument for detecting the existence of an electric current [n -S]\n",
  "RHEOSCOPES": "RHEOSCOPE, an instrument for detecting the existence of an electric current [n]\n",
  "RHEOSTAT": "a resistor used to control electric current [n -S]\n",
  "RHEOSTATIC": "relating to a rheostat [adj]\n",
  "RHEOSTATS": "RHEOSTAT, a resistor used to control electric current [n]\n",
  "RHEOTACTIC": "relating to rheotaxis, the movement of an organism in response to a current of water [adj]\n",
  "RHEOTAXES": "RHEOTAXIS, the movement of an organism in response to a current of water [n]\n",
  "RHEOTAXIS": "the movement of an organism in response to a current of water [n RHEOTAXES]\n",
  "RHEOTOME": "an instrument which periodically or otherwise interrupts an electric current [n -S]\n",
  "RHEOTOMES": "RHEOTOME, an instrument which periodically or otherwise interrupts an electric current [n]\n",
  "RHEOTROPE": "an instrument for reversing the direction of an electric current [n -S]\n",
  "RHEOTROPES": "RHEOTROPE, an instrument for reversing the direction of an electric current [n]\n",
  "RHEOTROPIC": "relating to a rheotrope, an instrument for reversing the direction of an electric current [adj]\n",
  "RHEOTROPISM": "the direction of growth by water [n -S]\n",
  "RHEOTROPISMS": "RHEOTROPISM, the direction of growth by water [n]\n",
  "RHESUS": "a kind of monkey [n -ES]\n",
  "RHESUSES": "RHESUS, a kind of monkey [n]\n",
  "RHETOR": "(Latin) a teacher of rhetoric [n -S]\n",
  "RHETORIC": "the study of effective speech and writing [n -S]\n",
  "RHETORICAL": "of, relating to, or concerned with rhetoric [adj RHETORICALLY]\n",
  "RHETORICALLY": "RHETORICAL, of, relating to, or concerned with rhetoric [adv]\n",
  "RHETORICIAN": "a master or teacher of rhetoric [n -S]\n",
  "RHETORICIANS": "RHETORICIAN, a master or teacher of rhetoric [n]\n",
  "RHETORICS": "RHETORIC, the study of effective speech and writing [n]\n",
  "RHETORISE": "(obsolete) to use rhetorical language [v RHETORISED, RHETORISING, RHETORISES]\n",
  "RHETORISED": "RHETORISE, (obsolete) to use rhetorical language [v]\n",
  "RHETORISES": "RHETORISE, (obsolete) to use rhetorical language [v]\n",
  "RHETORISING": "RHETORISE, (obsolete) to use rhetorical language [v]\n",
  "RHETORIZE": "(obsolete) to use rhetorical language, also RHETORISE [v RHETORIZED, RHETORIZING, RHETORIZES]\n",
  "RHETORIZED": "RHETORIZE, (obsolete) to use rhetorical language, also RHETORISE [v]\n",
  "RHETORIZES": "RHETORIZE, (obsolete) to use rhetorical language, also RHETORISE [v]\n",
  "RHETORIZING": "RHETORIZE, (obsolete) to use rhetorical language, also RHETORISE [v]\n",
  "RHETORS": "RHETOR, (Latin) a teacher of rhetoric [n]\n",
  "RHEUM": "a watery discharge from the nose or eyes, also RUME [n -S]\n",
  "RHEUMATEESE": "(dialect) rheumatism, also RHEUMATISE, RHEUMATIZ, RHEUMATIZE [n -S]\n",
  "RHEUMATEESES": "RHEUMATEESE, (dialect) rheumatism, also RHEUMATISE, RHEUMATIZ, RHEUMATIZE [n]\n",
  "RHEUMATIC": "related to rheumatism [adj RHEUMATICALLY] / one who suffers from rheumatism [n -S]\n",
  "RHEUMATICAL": "relating to rheumatism, also RHEUMATIC [adj RHEUMATICALLY]\n",
  "RHEUMATICALLY": "RHEUMATICAL, relating to rheumatism, also RHEUMATIC [adv]\n",
  "RHEUMATICKY": "suffering from rheumatism [adj]\n",
  "RHEUMATICS": "RHEUMATIC, one who suffers from rheumatism [n]\n",
  "RHEUMATISE": "(dialect) rheumatism, also RHEUMATEESE, RHEUMATIZ, RHEUMATIZE [n -S]\n",
  "RHEUMATISES": "RHEUMATISE, (dialect) rheumatism, also RHEUMATEESE, RHEUMATIZ, RHEUMATIZE [n]\n",
  "RHEUMATISM": "a condition characterised by pain and stiffness in muscles and joints, also RHEUMATEESE, RHEUMATISE, RHEUMATIZ, RHEUMATIZE [n -S]\n",
  "RHEUMATISMAL": "relating to rheumatism [adj]\n",
  "RHEUMATISMS": "RHEUMATISM, a condition characterised by pain and stiffness in muscles and joints, also RHEUMATEESE, RHEUMATISE, RHEUMATIZ, RHEUMATIZE [n]\n",
  "RHEUMATIZ": "(dialect) rheumatism, also RHEUMATEESE, RHEUMATISE, RHEUMATIZE [n -ES]\n",
  "RHEUMATIZE": "(dialect) rheumatism, also RHEUMATEESE, RHEUMATISE, RHEUMATIZ [n -S]\n",
  "RHEUMATIZES": "RHEUMATIZE, (dialect) rheumatism, also RHEUMATEESE, RHEUMATISE, RHEUMATIZ [n]\n",
  "RHEUMATOID": "characteristic of or affected with rheumatoid arthritis [adj RHEUMATOIDALLY]\n",
  "RHEUMATOIDALLY": "RHEUMATOID, characteristic of or affected with rheumatoid arthritis [adv]\n",
  "RHEUMATOLOGICAL": "related to rheumatology [adj]\n",
  "RHEUMATOLOGIES": "RHEUMATOLOGY, the study of rheumatism [n]\n",
  "RHEUMATOLOGIST": "one who studies rheumatology [n -S]\n",
  "RHEUMATOLOGISTS": "RHEUMATOLOGIST, one who studies rheumatology [n]\n",
  "RHEUMATOLOGY": "the study of rheumatism [n RHEUMATOLOGIES]\n",
  "RHEUMED": "troubled by rheumatism [adj]\n",
  "RHEUMIC": "pertaining to, or characterized by, rheum, watery discharge from eyes and nose [adj]\n",
  "RHEUMIER": "RHEUMY, like rheum [adj]\n",
  "RHEUMIEST": "RHEUMY, like rheum [adj]\n",
  "RHEUMS": "RHEUM, a watery discharge from the nose or eyes, also RUME [n]\n",
  "RHEUMY": "like rheum [adj RHEUMIER, RHEUMIEST]\n",
  "RHEXES": "RHEXIS, (Greek) rupture of a blood vessel [n]\n",
  "RHEXIS": "(Greek) rupture of a blood vessel [n RHEXISES or RHEXES]\n",
  "RHEXISES": "RHEXIS, (Greek) rupture of a blood vessel [n]\n",
  "RHIES": "RHY, (Spenser) rye [n]\n",
  "RHIGOLENE": "a volatile liquid obtained from petroleum and used as a local anaesthetic [n -S]\n",
  "RHIGOLENES": "RHIGOLENE, a volatile liquid obtained from petroleum and used as a local anaesthetic [n]\n",
  "RHIME": "(obsolete) a rhyme [n -S]\n",
  "RHIMES": "RHIME, (obsolete) a rhyme [n]\n",
  "RHINAL": "pertaining to the nose [adj]\n",
  "RHINE": "a drainage channel, also REAN, REEN, RHYNE [n -S]\n",
  "RHINENCEPHALA": "RHINENCEPHALON, the olfactory lobe of the brain [n]\n",
  "RHINENCEPHALIC": "relating to the rhinencephalon, the olfactory lobe of the brain [adj]\n",
  "RHINENCEPHALON": "the olfactory lobe of the brain [n RHINENCEPHALA or RHINENCEPHALONS]\n",
  "RHINENCEPHALONS": "RHINENCEPHALON, the olfactory lobe of the brain [n]\n",
  "RHINES": "RHINE, a drainage channel, also REAN, REEN, RHYNE [n]\n",
  "RHINESTONE": "an imitation diamond made of paste [n -S]\n",
  "RHINESTONED": "adorned with rhinestones [adj]\n",
  "RHINESTONES": "RHINESTONE, an imitation diamond made of paste [n]\n",
  "RHINITIC": "suffering from rhinitis [adj]\n",
  "RHINITIDES": "RHINITIS, inflammation of the mucous membranes of the nose [n]\n",
  "RHINITIS": "inflammation of the mucous membranes of the nose [n RHINITISES or RHINITIDES]\n",
  "RHINITISES": "RHINITIS, inflammation of the mucous membranes of the nose [n]\n",
  "RHINO": "(short for) a rhinoceros [n -S]\n",
  "RHINOCERI": "RHINOCEROS, a large heavy ungulate mammal of the perissodactyl family Rhinocerotidae, also RHINOCEROT, RHINOCEROTE [n]\n",
  "RHINOCERICAL": "(archaic slang) rich [adj]\n",
  "RHINOCEROI": "RHINOCEROS, a large heavy ungulate mammal of the perissodactyl family Rhinocerotidae, also RHINOCEROT, RHINOCEROTE [n]\n",
  "RHINOCEROS": "a large heavy ungulate mammal of the perissodactyl family Rhinocerotidae, also RHINOCEROT, RHINOCEROTE [n RHINOCEROSES or RHINOCERI or RHINOCEROI]\n",
  "RHINOCEROSES": "RHINOCEROS, a large heavy ungulate mammal of the perissodactyl family Rhinocerotidae, also RHINOCEROT, RHINOCEROTE [n]\n",
  "RHINOCEROT": "(obsolete) a rhinoceros, also RHINOCEROS, RHINOCEROTE [n RHINOCEROTES]\n",
  "RHINOCEROTE": "(obsolete) a rhinoceros, also RHINOCEROS, RHINOCEROT [n -S]\n",
  "RHINOCEROTES": "RHINOCEROTE, (obsolete) a rhinoceros, also RHINOCEROS, RHINOCEROT [n]\n",
  "RHINOCEROTIC": "like a rhinoceros [adj]\n",
  "RHINOLALIA": "nasal speech [n -S]\n",
  "RHINOLALIAS": "RHINOLALIA, nasal speech [n]\n",
  "RHINOLITH": "a concretion formed within the cavities of the nose [n -S]\n",
  "RHINOLITHS": "RHINOLITH, a concretion formed within the cavities of the nose [n]\n",
  "RHINOLOGICAL": "related to rhinology [adj]\n",
  "RHINOLOGIES": "RHINOLOGY, the study of the nose [n]\n",
  "RHINOLOGIST": "a student of rhinology, the study of the nose [n -S]\n",
  "RHINOLOGISTS": "RHINOLOGIST, a student of rhinology, the study of the nose [n]\n",
  "RHINOLOGY": "the study of the nose [n RHINOLOGIES]\n",
  "RHINOPHONIA": "a nasal tone to the voice which is caused by a defect in the nasal passages [n -S]\n",
  "RHINOPHONIAS": "RHINOPHONIA, a nasal tone to the voice which is caused by a defect in the nasal passages [n]\n",
  "RHINOPHYMA": "acne of the nose [n -S]\n",
  "RHINOPHYMAS": "RHINOPHYMA, acne of the nose [n]\n",
  "RHINOPLASTIC": "relating to rhinoplasty, plastic surgery of the nose [adj]\n",
  "RHINOPLASTIES": "RHINOPLASTY, plastic surgery of the nose [n]\n",
  "RHINOPLASTY": "plastic surgery of the nose [n RHINOPLASTIES]\n",
  "RHINORRHAGIA": "nosebleeding [n -S]\n",
  "RHINORRHAGIAS": "RHINORRHAGIA, nosebleeding [n]\n",
  "RHINORRHOEA": "continuous nasal catarrh [n -S]\n",
  "RHINORRHOEAL": "relating to rhinorrhoea, continuous nasal catarrh [adj]\n",
  "RHINORRHOEAS": "RHINORRHOEA, continuous nasal catarrh [n]\n",
  "RHINOS": "RHINO, (short for) a rhinoceros [n]\n",
  "RHINOSCLEROMA": "a disease with hard swelling in the nose etc. [n RHINOSCLEROMAS or RHINOSCLEROMATA]\n",
  "RHINOSCLEROMAS": "RHINOSCLEROMA, a disease with hard swelling in the nose etc. [n]\n",
  "RHINOSCLEROMATA": "RHINOSCLEROMA, a disease with hard swelling in the nose etc. [n]\n",
  "RHINOSCOPE": "an instrument for examining the nose [n -S]\n",
  "RHINOSCOPES": "RHINOSCOPE, an instrument for examining the nose [n]\n",
  "RHINOSCOPIC": "relating to a rhinoscope [adj]\n",
  "RHINOSCOPIES": "RHINOSCOPY, the examination of the nose [n]\n",
  "RHINOSCOPY": "the examination of the nose [n RHINOSCOPIES]\n",
  "RHINOTHECA": "the sheath of the upper mandible of a bird [n RHINOTHECAE]\n",
  "RHINOTHECAE": "RHINOTHECA, the sheath of the upper mandible of a bird [n]\n",
  "RHINOVIRUS": "a virus belonging to a subgroup thought to be responsible for the common cold [n -ES]\n",
  "RHINOVIRUSES": "RHINOVIRUS, a virus belonging to a subgroup thought to be responsible for the common cold [n]\n",
  "RHIPIDATE": "fan-shaped [adj]\n",
  "RHIPIDION": "(Greek) in the Greek Orthodox church, the eucharistical fan or flabellum [n -S]\n",
  "RHIPIDIONS": "RHIPIDION, (Greek) in the Greek Orthodox church, the eucharistical fan or flabellum [n]\n",
  "RHIPIDIUM": "a fan-shaped cymose inflorescence [n -S]\n",
  "RHIPIDIUMS": "RHIPIDIUM, a fan-shaped cymose inflorescence [n]\n",
  "RHIZANTHOUS": "with flowers emerging from root [adj]\n",
  "RHIZIC": "of the root of an equation [adj]\n",
  "RHIZINE": "a lichen rhizoid [n -S]\n",
  "RHIZINES": "RHIZINE, a lichen rhizoid [n]\n",
  "RHIZOBIA": "RHIZOBIUM, a bacterium important in nitrogen fixation in leguminous plants [n]\n",
  "RHIZOBIAL": "relating to a rhizobium, a bacterium important in nitrogen fixation in leguminous plants [adj]\n",
  "RHIZOBIUM": "a bacterium important in nitrogen fixation in leguminous plants [n RHIZOBIA]\n",
  "RHIZOCARP": "a water-fern or heterosporous fern [n -S]\n",
  "RHIZOCARPIC": "of or like a rhizocarp, also RHIZOCARPOUS [adj]\n",
  "RHIZOCARPOUS": "of or like a rhizocarp, also RHIZOCARPIC [adj]\n",
  "RHIZOCARPS": "RHIZOCARP, a water-fern or heterosporous fern [n]\n",
  "RHIZOCAUL": "the rootlike stalk of a hydrozoan colony [n -S]\n",
  "RHIZOCAULS": "RHIZOCAUL, the rootlike stalk of a hydrozoan colony [n]\n",
  "RHIZOCEPHALAN": "any member of the Rhizocephala, an order of cirripedes parasitic on crabs [n -S]\n",
  "RHIZOCEPHALANS": "RHIZOCEPHALAN, any member of the Rhizocephala, an order of cirripedes parasitic on crabs [n]\n",
  "RHIZOCEPHALOUS": "of or like a rhizocephalan, a cirripede parasitic on crabs [adj]\n",
  "RHIZOCTONIA": "any of a genus of imperfect fungi that includes major plant pathogens [n -S]\n",
  "RHIZOCTONIAS": "RHIZOCTONIA, any of a genus of imperfect fungi that includes major plant pathogens [n]\n",
  "RHIZOGENETIC": "producing or growing roots, also RHIZOGENIC, RHIZOGENOUS [adj]\n",
  "RHIZOGENIC": "producing or growing roots, also RHIZOGENETIC, RHIZOGENOUS [adj]\n",
  "RHIZOGENOUS": "producing or growing roots, also RHIZOGENETIC, RHIZOGENIC [adj]\n",
  "RHIZOID": "a short hairlike organ in the lower plants, serving as a root [n -S]\n",
  "RHIZOIDAL": "relating to a rhizoid, a short hairlike organ in the lower plants, serving as a root [adj]\n",
  "RHIZOIDS": "RHIZOID, a short hairlike organ in the lower plants, serving as a root [n]\n",
  "RHIZOMA": "(Greek) a rootlike, underground stem, also RHIZOME [n RHIZOMATA]\n",
  "RHIZOMATA": "RHIZOMA, (Greek) a rootlike, underground stem, also RHIZOME [n]\n",
  "RHIZOMATOUS": "having the form of a rhizome [adj]\n",
  "RHIZOME": "(Greek) a rootlike, underground stem, also RHIZOMA [n -S]\n",
  "RHIZOMES": "RHIZOME, (Greek) a rootlike, underground stem, also RHIZOMA [n]\n",
  "RHIZOMIC": "relating to a rhizome, a horizontal underground stem [adj]\n",
  "RHIZOMORPH": "a rootlike mass of fungal hyphae [n -S]\n",
  "RHIZOMORPHOUS": "having the form of a root [adj]\n",
  "RHIZOMORPHS": "RHIZOMORPH, a rootlike mass of fungal hyphae [n]\n",
  "RHIZOPHAGOUS": "feeding on roots [adj]\n",
  "RHIZOPHILOUS": "growing on roots [adj]\n",
  "RHIZOPHORE": "a specialised leafless stem which bears roots, as in Selaginella [n -S]\n",
  "RHIZOPHORES": "RHIZOPHORE, a specialised leafless stem which bears roots, as in Selaginella [n]\n",
  "RHIZOPI": "RHIZOPUS, (Greek) any of a genus of mould fungi [n]\n",
  "RHIZOPLANE": "the surface of a root together with the soil adhering to it [n -S]\n",
  "RHIZOPLANES": "RHIZOPLANE, the surface of a root together with the soil adhering to it [n]\n",
  "RHIZOPOD": "any of a class of protozoans [n -S]\n",
  "RHIZOPODAN": "one of the Rhizopoda, amoebae and rotarians moving and taking in food with pseudopods, also RHIZOPOD [n -S]\n",
  "RHIZOPODANS": "RHIZOPODAN, one of the Rhizopoda, amoebae and rotarians moving and taking in food with pseudopods, also RHIZOPOD [n]\n",
  "RHIZOPODOUS": "relating to a rhizopod [adj]\n",
  "RHIZOPODS": "RHIZOPOD, any of a class of protozoans [n]\n",
  "RHIZOPUS": "(Greek) any of a genus of mould fungi [n RHIZOPUSES or RHIZOPI]\n",
  "RHIZOPUSES": "RHIZOPUS, (Greek) any of a genus of mould fungi [n]\n",
  "RHIZOSPHERE": "a region of increased biological activity in the neighborhood of a root [n -S]\n",
  "RHIZOSPHERES": "RHIZOSPHERE, a region of increased biological activity in the neighborhood of a root [n]\n",
  "RHIZOTOMIES": "RHIZOTOMY, the surgical severance of the spinal nerve roots to alleviate pain [n]\n",
  "RHIZOTOMY": "the surgical severance of the spinal nerve roots to alleviate pain [n RHIZOTOMIES]\n",
  "RHO": "a letter of the Greek alphabet [n -S]\n",
  "RHODAMIN": "a synthetic dyestuff, usually red, also RHODAMINE [n -S]\n",
  "RHODAMINE": "a synthetic dyestuff, usually red, also RHODAMIN [n -S]\n",
  "RHODAMINES": "RHODAMINE, a synthetic dyestuff, usually red, also RHODAMIN [n]\n",
  "RHODAMINS": "RHODAMIN, a synthetic dyestuff, usually red, also RHODAMINE [n]\n",
  "RHODANATE": "in dyeing, a thiocyanate [n -S]\n",
  "RHODANATES": "RHODANATE, in dyeing, a thiocyanate [n]\n",
  "RHODANIC": "pertaining to thiocyanic acid [adj]\n",
  "RHODANISE": "to electroplate with rhodium, also RHODANIZE [v RHODANISED, RHODANISING, RHODANISES]\n",
  "RHODANISED": "RHODANISE, to electroplate with rhodium, also RHODANIZE [v]\n",
  "RHODANISES": "RHODANISE, to electroplate with rhodium, also RHODANIZE [v]\n",
  "RHODANISING": "RHODANISE, to electroplate with rhodium, also RHODANIZE [v]\n",
  "RHODANIZE": "to electroplate with rhodium, also RHODANISE [v RHODANIZED, RHODANIZING, RHODANIZES]\n",
  "RHODANIZED": "RHODANIZE, to electroplate with rhodium, also RHODANISE [v]\n",
  "RHODANIZES": "RHODANIZE, to electroplate with rhodium, also RHODANISE [v]\n",
  "RHODANIZING": "RHODANIZE, to electroplate with rhodium, also RHODANISE [v]\n",
  "RHODIC": "of or pertaining to rhodium [adj]\n",
  "RHODIE": "(colloquial) a rhododendron, also RHODY [n -S]\n",
  "RHODIES": "RHODY, (colloquial) a rhododendron, also RHODIE [n]\n",
  "RHODINAL": "an aldehyde found in citronella, used in soaps and perfumes [n -S]\n",
  "RHODINALS": "RHODINAL, an aldehyde found in citronella, used in soaps and perfumes [n]\n",
  "RHODIUM": "a very hard silvery-white metallic chemical element, belonging to the platinum group [n -S]\n",
  "RHODIUMS": "RHODIUM, a very hard silvery-white metallic chemical element, belonging to the platinum group [n]\n",
  "RHODOCHROSITE": "manganese ore [n -S]\n",
  "RHODOCHROSITES": "RHODOCHROSITE, manganese ore [n]\n",
  "RHODODAPHNE": "(Spenser) oleander [n -S]\n",
  "RHODODAPHNES": "RHODODAPHNE, (Spenser) oleander [n]\n",
  "RHODODENDRA": "RHODODENDRON, any of a genus of widely cultivated shrubs and trees of the heath family [n]\n",
  "RHODODENDRON": "any of a genus of widely cultivated shrubs and trees of the heath family [n RHODODENDRA or RHODODENDRONS]\n",
  "RHODODENDRONS": "RHODODENDRON, any of a genus of widely cultivated shrubs and trees of the heath family [n]\n",
  "RHODOLITE": "a rose-red or pink garnet gem [n -S]\n",
  "RHODOLITES": "RHODOLITE, a rose-red or pink garnet gem [n]\n",
  "RHODOMONTADE": "(French) a bragging speech; vain boasting or bluster [n -S] / to boast, rant, also RODOMONTADE [v RHODOMONTADED, RHODOMONTADING, RHODOMONTADES]\n",
  "RHODOMONTADED": "RHODOMONTADE, to boast, rant, also RODOMONTADE [v]\n",
  "RHODOMONTADES": "RHODOMONTADE, to boast, rant, also RODOMONTADE [v]\n",
  "RHODOMONTADING": "RHODOMONTADE, to boast, rant, also RODOMONTADE [v]\n",
  "RHODONITE": "a rose-red anorthic pyroxene, manganese silicate [n -S]\n",
  "RHODONITES": "RHODONITE, a rose-red anorthic pyroxene, manganese silicate [n]\n",
  "RHODOPHANE": "the red pigment contained in the inner segments of the cones of the retina in animals [n -S]\n",
  "RHODOPHANES": "RHODOPHANE, the red pigment contained in the inner segments of the cones of the retina in animals [n]\n",
  "RHODOPSIN": "visual purple, a pigment in the eye [n -S]\n",
  "RHODOPSINS": "RHODOPSIN, visual purple, a pigment in the eye [n]\n",
  "RHODORA": "a North American azalea, bearing rose-purple flowers before the leaves [n -S]\n",
  "RHODORAS": "RHODORA, a North American azalea, bearing rose-purple flowers before the leaves [n]\n",
  "RHODOUS": "of rhodium in lower valency [adj]\n",
  "RHODY": "(colloquial) a rhododendron, also RHODIE [n RHODIES]\n",
  "RHOEADINE": "an alkaloid found in poppies [n -S]\n",
  "RHOEADINES": "RHOEADINE, an alkaloid found in poppies [n]\n",
  "RHOICISSUS": "a genus of climbing plants, including the grape ivy [n -ES]\n",
  "RHOICISSUSES": "RHOICISSUS, a genus of climbing plants, including the grape ivy [n]\n",
  "RHOMB": "a type of geometric figure, also RHOMBUS [n -S]\n",
  "RHOMBENCEPHALA": "RHOMBENCEPHALON, the hindbrain [n]\n",
  "RHOMBENCEPHALON": "the hindbrain [n RHOMBENCEPHALA]\n",
  "RHOMBENPORPHYR": "an intermediate, moderately fine-grained igneous rock with feldspar phenocrysts rhombic in section, also RHOMBENPORPHYRY, RHOMBPORPHYRY [n -S]\n",
  "RHOMBENPORPHYRS": "RHOMBENPORPHYR, an intermediate, moderately fine-grained igneous rock with feldspar phenocrysts rhombic in section, also RHOMBENPORPHYRY, RHOMBPORPHYRY [n]\n",
  "RHOMBENPORPHYRY": "an intermediate, moderately fine-grained igneous rock with feldspar inclusions, also RHOMBENPORPHYR, RHOMBPORPHYRY [n]\n",
  "RHOMBI": "RHOMBUS, (Greek) a type of geometric figure, also RHOMB [n]\n",
  "RHOMBIC": "of or like a rhombus, an equilateral parallelogram, also RHOMBICAL [adj]\n",
  "RHOMBICAL": "of or like a rhombus, an equilateral parallelogram, also RHOMBIC [adj]\n",
  "RHOMBOHEDRA": "RHOMBOHEDRON, a parallelepiped whose faces are rhombuses [n]\n",
  "RHOMBOHEDRAL": "shaped like a rhombohedron [adj]\n",
  "RHOMBOHEDRON": "a parallelepiped whose faces are rhombuses [n RHOMBOHEDRA or RHOMBOHEDRONS]\n",
  "RHOMBOHEDRONS": "RHOMBOHEDRON, a parallelepiped whose faces are rhombuses [n]\n",
  "RHOMBOI": "RHOMBOS, (Greek) a bullroarer, a kind of rattle [n]\n",
  "RHOMBOID": "a parallelogram with unequal sides, also RHOMBOIDES, RHOMBOIDEUS [n -S]\n",
  "RHOMBOIDAL": "having, or approaching, the shape of a rhomboid [adj]\n",
  "RHOMBOIDEI": "RHOMBOIDEUS, a rhomboid, also RHOMBOIDES [n]\n",
  "RHOMBOIDES": "a rhomboid, also RHOMBOIDEUS [n RHOMBOIDES]\n",
  "RHOMBOIDEUS": "a rhomboid, also RHOMBOIDES [n RHOMBOIDEI]\n",
  "RHOMBOIDS": "RHOMBOID, a parallelogram with unequal sides, also RHOMBOIDES, RHOMBOIDEUS [n]\n",
  "RHOMBOS": "(Greek) a bullroarer, a kind of rattle [n RHOMBOI]\n",
  "RHOMBPORPHYRIES": "RHOMBPORPHYRY, an intermediate, moderately fine-grained igneous rock with feldspar inclusions, also RHOMBENPORPHYR, RHOMBENPORPHYRY [n]\n",
  "RHOMBPORPHYRY": "an intermediate, moderately fine-grained igneous rock with feldspar inclusions, also RHOMBENPORPHYR, RHOMBENPORPHYRY [n RHOMBPORPHYRIES]\n",
  "RHOMBS": "RHOMB, a type of geometric figure, also RHOMBUS [n]\n",
  "RHOMBUS": "(Greek) a type of geometric figure, also RHOMB [n RHOMBUSES or RHOMBI]\n",
  "RHOMBUSES": "RHOMBUS, (Greek) a type of geometric figure, also RHOMB [n]\n",
  "RHONCHAL": "of or relating to snoring, also RHONCHIAL [adj]\n",
  "RHONCHI": "RHONCHUS, (Greek) a whistling or snoring sound heard when the air channels are partially obstructed, also RHONCUS [n]\n",
  "RHONCHIAL": "of or relating to snoring, also RHONCHAL [adj]\n",
  "RHONCHUS": "(Greek) a whistling or snoring sound heard when the air channels are partially obstructed, also RHONCUS [n RHONCHI]\n",
  "RHONCUS": "a rattling or whistling respiratory sound resembling snoring, caused by secretions in the trachea or bronchi, also RHONCHUS [n -ES]\n",
  "RHONCUSES": "RHONCUS, a rattling or whistling respiratory sound resembling snoring, caused by secretions in the trachea or bronchi, also RHONCHUS [n]\n",
  "RHONE": "(Scots) a roof-gutter, also ROAN, ROANPIPE, RONE, RONEPIPE [n -S]\n",
  "RHONES": "RHONE, (Scots) a roof-gutter, also ROAN, ROANPIPE, RONE, RONEPIPE [n]\n",
  "RHOPALIC": "each word being increased by a syllable [adj]\n",
  "RHOPALISM": "a sentence or poem in which each word is one syllable longer than its predecessor [n -S]\n",
  "RHOPALISMS": "RHOPALISM, a sentence or poem in which each word is one syllable longer than its predecessor [n]\n",
  "RHOPALOCERAL": "relating to the Rhopalocera, a suborder of insects with clubbed antennae, also RHOPALOCEROUS [adj]\n",
  "RHOPALOCEROUS": "relating to the Rhopalocera, a suborder of insects with clubbed antennae, also RHOPALOCERAL [adj]\n",
  "RHOS": "RHO, a letter of the Greek alphabet [n]\n",
  "RHOTACISE": "to change to an r- sound, esp. from z, also RHOTACIZE [v RHOTACISED, RHOTACISING, RHOTACISES]\n",
  "RHOTACISED": "RHOTACISE, to change to an r- sound, esp. from z, also RHOTACIZE [v]\n",
  "RHOTACISES": "RHOTACISE, to change to an r- sound, esp. from z, also RHOTACIZE [v]\n",
  "RHOTACISING": "RHOTACISE, to change to an r- sound, esp. from z, also RHOTACIZE [v]\n",
  "RHOTACISM": "the excessive use or faulty pronunciation of the letter R [n -S]\n",
  "RHOTACISMS": "RHOTACISM, the excessive use or faulty pronunciation of the letter R [n]\n",
  "RHOTACIST": "one whose speech shows rhotacism [n -S]\n",
  "RHOTACISTIC": "relating to rhotacism, the excessive use or faulty pronunciation of the letter R [adj]\n",
  "RHOTACISTS": "RHOTACIST, one whose speech shows rhotacism [n]\n",
  "RHOTACIZE": "to change to an r- sound, esp. from z, also RHOTACISE [v RHOTACIZED, RHOTACIZING, RHOTACIZES]\n",
  "RHOTACIZED": "RHOTACIZE, to change to an r- sound, esp. from z, also RHOTACISE [v]\n",
  "RHOTACIZES": "RHOTACIZE, to change to an r- sound, esp. from z, also RHOTACISE [v]\n",
  "RHOTACIZING": "RHOTACIZE, to change to an r- sound, esp. from z, also RHOTACISE [v]\n",
  "RHOTIC": "(Greek) r- pronouncing, as defining a dialect [adj]\n",
  "RHOTICITIES": "RHOTICITY, the quality of being rhotic, r- pronouncing, as defining a dialect [n]\n",
  "RHOTICITY": "the quality of being rhotic, r- pronouncing, as defining a dialect [n RHOTICITIES]\n",
  "RHUBARB": "any species of the genus Rheum; the leafstalks cooked and used as if fruit [n -S] / to simulate conversation e.g. on stage [v -ED, -ING, -S]\n",
  "RHUBARBED": "RHUBARB, to simulate conversation e.g. on stage [v]\n",
  "RHUBARBIER": "RHUBARBY, like rhubarb [adj]\n",
  "RHUBARBIEST": "RHUBARBY, like rhubarb [adj]\n",
  "RHUBARBING": "in the theatre, the use or practice of muttering rhubarb or a similar sound [n -S]\n",
  "RHUBARBINGS": "RHUBARBING, in the theatre, the use or practice of muttering rhubarb or a similar sound [n]\n",
  "RHUBARBS": "RHUBARB, to simulate conversation e.g. on stage [v]\n",
  "RHUBARBY": "like rhubarb [adj RHUBARBIER, RHUBARBIEST]\n",
  "RHUMB": "in marine navigation, a line of constant direction [n -S]\n",
  "RHUMBA": "(Spanish) to dance a lively Spanish dance, also RUMBA [v -ED, -ING, -S]\n",
  "RHUMBAED": "RHUMBA, (Spanish) to dance a lively Spanish dance, also RUMBA [v]\n",
  "RHUMBAING": "RHUMBA, (Spanish) to dance a lively Spanish dance, also RUMBA [v]\n",
  "RHUMBAS": "RHUMBA, (Spanish) to dance a lively Spanish dance, also RUMBA [v]\n",
  "RHUMBATRON": "a cavity resonator [n -S]\n",
  "RHUMBATRONS": "RHUMBATRON, a cavity resonator [n]\n",
  "RHUMBS": "RHUMB, in marine navigation, a line of constant direction [n]\n",
  "RHUS": "(Greek) a plant of the sumach genus [n -ES]\n",
  "RHUSES": "RHUS, (Greek) a plant of the sumach genus [n]\n",
  "RHY": "(Spenser) rye [n RHIES]\n",
  "RHYME": "to compose verse with corresponding terminal sounds, also RIME [v RHYMED, RHYMING, RHYMES]\n",
  "RHYMED": "RHYME, to compose verse with corresponding terminal sounds, also RIME [v]\n",
  "RHYMELESS": "destitute of rhyme [adj]\n",
  "RHYMER": "one who composes rhymes, also RIMER [n -S]\n",
  "RHYMERS": "RHYMER, one who composes rhymes, also RIMER [n]\n",
  "RHYMES": "RHYME, to compose verse with corresponding terminal sounds, also RIME [v]\n",
  "RHYMESTER": "a poetaster, a would-be poet, also RIMESTER [n -S]\n",
  "RHYMESTERS": "RHYMESTER, a poetaster, a would-be poet, also RIMESTER [n]\n",
  "RHYMING": "RHYME, to compose verse with corresponding terminal sounds, also RIME [v]\n",
  "RHYMIST": "a versifier [n -S]\n",
  "RHYMISTS": "RHYMIST, a versifier [n]\n",
  "RHYNCHOCOEL": "the cavity in which the proboscis of a nemertine lies [n -S]\n",
  "RHYNCHOCOELS": "RHYNCHOCOEL, the cavity in which the proboscis of a nemertine lies [n]\n",
  "RHYNCHODONT": "having a toothed beak [adj]\n",
  "RHYNCHOPHORE": "a member of the Rhyncophora, weevils [n -S]\n",
  "RHYNCHOPHORES": "RHYNCHOPHORE, a member of the Rhyncophora, weevils [n]\n",
  "RHYNCHOPHOROUS": "of or belonging to the Rhynchophora; snouted [adj]\n",
  "RHYNE": "a drainage channel, also REAN, REEN, RHINE [n -S]\n",
  "RHYNES": "RHYNE, a drainage channel, also REAN, REEN, RHINE [n]\n",
  "RHYOLITE": "a highly felsic igneous volcanic rock, typically light in color [n -S]\n",
  "RHYOLITES": "RHYOLITE, a highly felsic igneous volcanic rock, typically light in color [n]\n",
  "RHYOLITIC": "relating to rhyolite, a highly felsic igneous volcanic rock [adj]\n",
  "RHYPAROGRAPHER": "one who does genre or still-life pictures of sordid subjects [n -S]\n",
  "RHYPAROGRAPHERS": "RHYPAROGRAPHER, one who does genre or still-life pictures of sordid subjects [n]\n",
  "RHYPAROGRAPHIC": "relating to rhyparography, genre or still-life pictures of sordid subjects [adj]\n",
  "RHYPAROGRAPHIES": "RHYPAROGRAPHY, genre or still-life pictures of sordid subjects [n]\n",
  "RHYPAROGRAPHY": "genre or still-life pictures of sordid subjects [n RHYPAROGRAPHIES]\n",
  "RHYTA": "RHYTON, (Greek) a drinking cup with a hole in the point to drink by [n]\n",
  "RHYTHM": "a pattern of recurrence, also RHYTHMUS [n -S]\n",
  "RHYTHMAL": "relating to rhythm [adj]\n",
  "RHYTHMED": "having a rhythm [adj]\n",
  "RHYTHMI": "RHYTHMUS, (Latin) a pattern of recurrence, also RHYTHM [n]\n",
  "RHYTHMIC": "related to rhythm, also RHYTHMICAL [adj RHYTHMICALLY]\n",
  "RHYTHMICAL": "according to rhythm, also RHYTHMIC [adj RHYTHMICALLY]\n",
  "RHYTHMICALLY": "RHYTHMICAL, according to rhythm, also RHYTHMIC [adv]\n",
  "RHYTHMICITIES": "RHYTHMICITY, the state of being rhythmic or of responding rhythmically [n]\n",
  "RHYTHMICITY": "the state of being rhythmic or of responding rhythmically [n RHYTHMICITIES]\n",
  "RHYTHMICS": "the science or theory of rhythm [n]\n",
  "RHYTHMISATION": "the process of rhythmising, also RHYTHMIZATION [n -S]\n",
  "RHYTHMISATIONS": "RHYTHMISATION, the process of rhythmising, also RHYTHMIZATION [n]\n",
  "RHYTHMISE": "to subject to rhythm, also RHYTHMIZE [v RHYTHMISED, RHYTHMISING, RHYTHMISES]\n",
  "RHYTHMISED": "RHYTHMISE, to subject to rhythm, also RHYTHMIZE [v]\n",
  "RHYTHMISES": "RHYTHMISE, to subject to rhythm, also RHYTHMIZE [v]\n",
  "RHYTHMISING": "RHYTHMISE, to subject to rhythm, also RHYTHMIZE [v]\n",
  "RHYTHMIST": "a person skilled in rhythm [n -S]\n",
  "RHYTHMISTS": "RHYTHMIST, a person skilled in rhythm [n]\n",
  "RHYTHMIZATION": "the process of rhythmizing, also RHYTHMISATION [n -S]\n",
  "RHYTHMIZATIONS": "RHYTHMIZATION, the process of rhythmizing, also RHYTHMISATION [n]\n",
  "RHYTHMIZE": "to subject to rhythm, also RHYTHMISE [v RHYTHMIZED, RHYTHMIZING, RHYTHMIZES]\n",
  "RHYTHMIZED": "RHYTHMIZE, to subject to rhythm, also RHYTHMISE [v]\n",
  "RHYTHMIZES": "RHYTHMIZE, to subject to rhythm, also RHYTHMISE [v]\n",
  "RHYTHMIZING": "RHYTHMIZE, to subject to rhythm, also RHYTHMISE [v]\n",
  "RHYTHMLESS": "being without rhythm [adj]\n",
  "RHYTHMOMETER": "an instrument for measuring the speed of rhythms [n -S]\n",
  "RHYTHMOMETERS": "RHYTHMOMETER, an instrument for measuring the speed of rhythms [n]\n",
  "RHYTHMOPOEIA": "the art of composing rhythmically [n -S]\n",
  "RHYTHMOPOEIAS": "RHYTHMOPOEIA, the art of composing rhythmically [n]\n",
  "RHYTHMS": "RHYTHM, a pattern of recurrence, also RHYTHMUS [n]\n",
  "RHYTHMUS": "(Latin) a pattern of recurrence, also RHYTHM [n RHYTHMUSES or RHYTHMI]\n",
  "RHYTHMUSES": "RHYTHMUS, (Latin) a pattern of recurrence, also RHYTHM [n]\n",
  "RHYTIDECTOMIES": "RHYTIDECTOMY, the surgical removal of wrinkles [n]\n",
  "RHYTIDECTOMY": "the surgical removal of wrinkles [n RHYTIDECTOMIES]\n",
  "RHYTIDOME": "the bark external to the last formed periderm [n -S]\n",
  "RHYTIDOMES": "RHYTIDOME, the bark external to the last formed periderm [n]\n",
  "RHYTINA": "(Greek) an aquatic mammal of the now extinct Rhytinia genus of Sirenia (aka Steller's sea-cow) [n -S]\n",
  "RHYTINAS": "RHYTINA, (Greek) an aquatic mammal of the now extinct Rhytinia genus of Sirenia (aka Steller's sea-cow) [n]\n",
  "RHYTON": "(Greek) a drinking cup with a hole in the point to drink by [n RHYTA or RHYTONS]\n",
  "RHYTONS": "RHYTON, (Greek) a drinking cup with a hole in the point to drink by [n]\n",
  "RIA": "a long, narrow inlet [n -S]\n",
  "RIAD": "(Arabic) a traditional Moroccan house or palace with an interior garden [n -S]\n",
  "RIADS": "RIAD, (Arabic) a traditional Moroccan house or palace with an interior garden [n]\n",
  "RIAL": "a monetary unit of Iran [n -S]\n",
  "RIALS": "RIAL, a monetary unit of Iran [n]\n",
  "RIALTO": "a theatrical district; a marketplace [n -S]\n",
  "RIALTOS": "RIALTO, a theatrical district; a marketplace [n]\n",
  "RIANCIES": "RIANCY, merriment [n]\n",
  "RIANCY": "merriment [n RIANCIES]\n",
  "RIANT": "mirthful, gay [adj RIANTLY]\n",
  "RIANTLY": "RIANT, mirthful, gay [adv]\n",
  "RIAS": "RIA, a long, narrow inlet [n]\n",
  "RIATA": "(Spanish) a lariat, also REATA [n -S]\n",
  "RIATAS": "RIATA, (Spanish) a lariat, also REATA [n]\n",
  "RIB": "to poke fun at [v RIBBED, RIBBING, RIBS]\n",
  "RIBA": "(Arabic) interest or usury, as forbidden by the Koran [n -S]\n",
  "RIBALD": "earthily sexy [adj RIBALDER, RIBALDEST, RIBALDLY] / (obsolete) a menial of the lowest grade; a loose, low character, also RIBAUD [n -S]\n",
  "RIBALDER": "RIBALD, earthily sexy [adj]\n",
  "RIBALDEST": "RIBALD, earthily sexy [adj]\n",
  "RIBALDLY": "RIBALD, earthily sexy [adv]\n",
  "RIBALDRIES": "RIBALDRY, crude language [n]\n",
  "RIBALDRY": "crude language [n RIBALDRIES]\n",
  "RIBALDS": "RIBALD, (obsolete) a menial of the lowest grade; a loose, low character, also RIBAUD [n]\n",
  "RIBAND": "a ribbon, also RIBBAND [n -S]\n",
  "RIBANDS": "RIBAND, a ribbon, also RIBBAND [n]\n",
  "RIBAS": "RIBA, (Arabic) interest or usury, as forbidden by the Koran [n]\n",
  "RIBATTUTA": "(Italian) the slow beginning of a trill [n -S]\n",
  "RIBATTUTAS": "RIBATTUTA, (Italian) the slow beginning of a trill [n]\n",
  "RIBAUD": "(Spenser) a menial of the lowest grade; a loose, low character, also RIBALD [n -S]\n",
  "RIBAUDRED": "(Shakespeare) an obscure word, perhaps ribaud-rid, ridden by a ribald [adj]\n",
  "RIBAUDRIES": "RIBAUDRY, (Spenser) ribaldry, also RYBAUDRYE [n]\n",
  "RIBAUDRY": "(Spenser) ribaldry, also RYBAUDRYE [n RIBAUDRIES]\n",
  "RIBAUDS": "RIBAUD, (Spenser) a menial of the lowest grade; a loose, low character, also RIBALD [n]\n",
  "RIBAVIRIN": "a synthetic guanosine analogue, which interferes with the synthesis of viral nucleic acids and is used to treat viral infections [n -S]\n",
  "RIBAVIRINS": "RIBAVIRIN, a synthetic guanosine analogue, which interferes with the synthesis of viral nucleic acids and is used to treat viral infections [n]\n",
  "RIBBAND": "a ribbon, also RIBAND [n -S]\n",
  "RIBBANDS": "RIBBAND, a ribbon, also RIBAND [n]\n",
  "RIBBED": "RIB, to poke fun at [v]\n",
  "RIBBER": "one that ribs [n -S]\n",
  "RIBBERS": "RIBBER, one that ribs [n]\n",
  "RIBBIE": "in baseball, a run batted in [n -S]\n",
  "RIBBIER": "RIBBY, marked by ribs [adj]\n",
  "RIBBIES": "RIBBIE, in baseball, a run batted in [n]\n",
  "RIBBIEST": "RIBBY, marked by ribs [adj]\n",
  "RIBBING": "an arrangement of ribs [n -S]\n",
  "RIBBINGS": "RIBBING, an arrangement of ribs [n]\n",
  "RIBBIT": "the sound made by a frog [n -S]\n",
  "RIBBITS": "RIBBIT, the sound made by a frog [n]\n",
  "RIBBON": "to decorate with narrow strips of fabric [v -ED, -ING, -S]\n",
  "RIBBONED": "RIBBON, to decorate with narrow strips of fabric [v]\n",
  "RIBBONFISH": "a long slender fish, the oarfish [n -ES]\n",
  "RIBBONFISHES": "RIBBONFISH, a long slender fish, the oarfish [n]\n",
  "RIBBONIER": "RIBBONY, adorned with ribbons [adj]\n",
  "RIBBONIEST": "RIBBONY, adorned with ribbons [adj]\n",
  "RIBBONING": "RIBBON, to decorate with narrow strips of fabric [v]\n",
  "RIBBONLIKE": "like a ribbon [adj]\n",
  "RIBBONRIES": "RIBBONRY, ribbons collectively [n]\n",
  "RIBBONRY": "ribbons collectively [n RIBBONRIES]\n",
  "RIBBONS": "RIBBON, to decorate with narrow strips of fabric [v]\n",
  "RIBBONWOOD": "a small evergreen malvaceous tree of New Zealand, aka houhere [n -S]\n",
  "RIBBONWOODS": "RIBBONWOOD, a small evergreen malvaceous tree of New Zealand, aka houhere [n]\n",
  "RIBBONY": "adorned with ribbons [adj RIBBONIER, RIBBONIEST]\n",
  "RIBBY": "marked by ribs [adj RIBBIER, RIBBIEST]\n",
  "RIBCAGE": "an enclosure for the ribs [n -S]\n",
  "RIBCAGES": "RIBCAGE, an enclosure for the ribs [n]\n",
  "RIBES": "a genus of shrubs including gooseberries and currants of many kinds [n RIBES]\n",
  "RIBEYE": "a choice cut of beefsteak, cut from the rib [n -S]\n",
  "RIBEYES": "RIBEYE, a choice cut of beefsteak, cut from the rib [n]\n",
  "RIBGRASS": "a weedy plant, also RIBWORT [n -ES]\n",
  "RIBGRASSES": "RIBGRASS, a weedy plant, also RIBWORT [n]\n",
  "RIBIBE": "(obsolete) a small three-stringed viol, a rebec, also RIBIBLE [n -S]\n",
  "RIBIBES": "RIBIBE, (obsolete) a small three-stringed viol, a rebec, also RIBIBLE [n]\n",
  "RIBIBLE": "a small three-stringed viol, a rebec, also RIBIBE [n -S]\n",
  "RIBIBLES": "RIBIBLE, a small three-stringed viol, a rebec, also RIBIBE [n]\n",
  "RIBIER": "a large, black grape [n -S]\n",
  "RIBIERS": "RIBIER, a large, black grape [n]\n",
  "RIBLESS": "without ribs [adj]\n",
  "RIBLET": "the rib end in a breast of lamb or veal [n -S]\n",
  "RIBLETS": "RIBLET, the rib end in a breast of lamb or veal [n]\n",
  "RIBLIKE": "like a rib [adj]\n",
  "RIBOFLAVIN": "a member of vitamin B complex, in yellowish-brown crystals, promoting growth in children, also RIBOFLAVINE [n -S]\n",
  "RIBOFLAVINE": "a member of the vitamin B complex, in yellowish-brown crystals, promoting growth in children, also RIBOFLAVIN [n -S]\n",
  "RIBOFLAVINES": "RIBOFLAVINE, a member of the vitamin B complex, in yellowish-brown crystals, promoting growth in children, also RIBOFLAVIN [n]\n",
  "RIBOFLAVINS": "RIBOFLAVIN, a member of vitamin B complex, in yellowish-brown crystals, promoting growth in children, also RIBOFLAVINE [n]\n",
  "RIBONUCLEASE": "an enzyme that catalyzes the hydrolysis of RNA [n -S]\n",
  "RIBONUCLEASES": "RIBONUCLEASE, an enzyme that catalyzes the hydrolysis of RNA [n]\n",
  "RIBONUCLEIC": "an acid derived from ribose [adj]\n",
  "RIBONUCLEOSIDE": "a nucleoside containing ribose [n -S]\n",
  "RIBONUCLEOSIDES": "RIBONUCLEOSIDE, a nucleoside containing ribose [n]\n",
  "RIBONUCLEOTIDE": "a nucleotide containing ribose [n -S]\n",
  "RIBONUCLEOTIDES": "RIBONUCLEOTIDE, a nucleotide containing ribose [n]\n",
  "RIBOSE": "a pentose sugar [n -S]\n",
  "RIBOSES": "RIBOSE, a pentose sugar [n]\n",
  "RIBOSOMAL": "relating to a ribosome [adj]\n",
  "RIBOSOME": "a particle composed of protein and RNA [n -S]\n",
  "RIBOSOMES": "RIBOSOME, a particle composed of protein and RNA [n]\n",
  "RIBOZYMAL": "of or like a ribozyme, an RNA-derived molecule displaying enzyme-like activity [adj]\n",
  "RIBOZYME": "a RNA derived molecular [n -S]\n",
  "RIBOZYMES": "RIBOZYME, a RNA derived molecular [n]\n",
  "RIBS": "RIB, to poke fun at [v]\n",
  "RIBSTON": "a variety of winter apple brought from Normandy to Ribston Hall in Yorkshire, also RIBSTONE [n -S]\n",
  "RIBSTONE": "an apple, also RIBSTON [n -S]\n",
  "RIBSTONES": "RIBSTONE, an apple, also RIBSTON [n]\n",
  "RIBSTONS": "RIBSTON, a variety of winter apple brought from Normandy to Ribston Hall in Yorkshire, also RIBSTONE [n]\n",
  "RIBULOSE": "a type of sugar [n -S]\n",
  "RIBULOSES": "RIBULOSE, a type of sugar [n]\n",
  "RIBWORK": "a rib vaulting [n -S]\n",
  "RIBWORKS": "RIBWORK, a rib vaulting [n]\n",
  "RIBWORT": "a plantain with lanceolate prominently veined leaves, common in grassland, also RIBGRASS [n -S]\n",
  "RIBWORTS": "RIBWORT, a plantain with lanceolate prominently veined leaves, common in grassland, also RIBGRASS [n]\n",
  "RICE": "to form soft foods by pressing through a ricer [v RICED, RICING, RICES]\n",
  "RICEBIRD": "the Java sparrow [n -S]\n",
  "RICEBIRDS": "RICEBIRD, the Java sparrow [n]\n",
  "RICED": "RICE, to form soft foods by pressing through a ricer [v]\n",
  "RICEFIELD": "a field used for growing rice [n -S]\n",
  "RICEFIELDS": "RICEFIELD, a field used for growing rice [n]\n",
  "RICEGRASS": "any of several barnyard grasses, esp. shama millet [n -ES]\n",
  "RICEGRASSES": "RICEGRASS, any of several barnyard grasses, esp. shama millet [n]\n",
  "RICER": "a cooking utensil for forcing potatoes etc. through perforations to give a granulated effect like rice [n -S]\n",
  "RICERCAR": "any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCARE, RICERCATA [n -S]\n",
  "RICERCARE": "any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCAR, RICERCATA [n RICERCARI or RICERCARES]\n",
  "RICERCARES": "RICERCARE, any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCAR, RICERCATA [n]\n",
  "RICERCARI": "RICERCARE, any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCAR, RICERCATA [n]\n",
  "RICERCARS": "RICERCAR, any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCARE, RICERCATA [n]\n",
  "RICERCATA": "any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCAR, RICERCARE [n -S]\n",
  "RICERCATAS": "RICERCATA, any of various contrapuntal instrumental forms esp. of the 16th and 17th centuries, also RICERCAR, RICERCARE [n]\n",
  "RICERS": "RICER, a cooking utensil for forcing potatoes etc. through perforations to give a granulated effect like rice [n]\n",
  "RICES": "RICE, to form soft foods by pressing through a ricer [v]\n",
  "RICEY": "containing rice, also RICY [adj RICIER, RICIEST]\n",
  "RICH": "wealthy [adj RICHER, RICHEST, RICHLY] / to grow rich [v -ED, -ING, -ES]\n",
  "RICHED": "RICH, to grow rich [v]\n",
  "RICHEN": "to make or become rich, also ENRICH [v -ED, -ING, -S]\n",
  "RICHENED": "RICHEN, to make or become rich, also ENRICH [v]\n",
  "RICHENING": "RICHEN, to make or become rich, also ENRICH [v]\n",
  "RICHENS": "RICHEN, to make or become rich, also ENRICH [v]\n",
  "RICHER": "RICH, wealthy [adj]\n",
  "RICHES": "RICH, to grow rich [v]\n",
  "RICHESSE": "(obsolete) riches [n -S]\n",
  "RICHESSES": "RICHESSE, (obsolete) riches [n]\n",
  "RICHEST": "RICH, wealthy [adj]\n",
  "RICHING": "RICH, to grow rich [v]\n",
  "RICHLY": "RICH, wealthy [adv]\n",
  "RICHNESS": "the state of being rich [n -ES]\n",
  "RICHNESSES": "RICHNESS, the state of being rich [n]\n",
  "RICHT": "(Scots) right [adj RICHTER, RICHTEST] / to right [v -ED, -ING, -S]\n",
  "RICHTED": "RICHT, to right [v]\n",
  "RICHTER": "RICHT, (Scots) right [adj]\n",
  "RICHTEST": "RICHT, (Scots) right [adj]\n",
  "RICHTING": "RICHT, to right [v]\n",
  "RICHTS": "RICHT, to right [v]\n",
  "RICHWEED": "a herb of the nettle family, having a smooth, juicy, pellucid stem [n -S]\n",
  "RICHWEEDS": "RICHWEED, a herb of the nettle family, having a smooth, juicy, pellucid stem [n]\n",
  "RICIER": "RICY, containing rice, also RICEY [adj]\n",
  "RICIEST": "RICY, containing rice, also RICEY [adj]\n",
  "RICIN": "a substance extracted from castor bean, used as a biochemical reagent [n -S]\n",
  "RICING": "RICE, to form soft foods by pressing through a ricer [v]\n",
  "RICINOLEIC": "relating to castor oil, as in ricinoleic, an oily acid obtained from castor oil [adj]\n",
  "RICINS": "RICIN, a substance extracted from castor bean, used as a biochemical reagent [n]\n",
  "RICINUS": "(Latin) a genus of plants of the Spurge family, containing one species, the castor-oil plant [n -ES]\n",
  "RICINUSES": "RICINUS, (Latin) a genus of plants of the Spurge family, containing one species, the castor-oil plant [n]\n",
  "RICK": "to pile hay in stacks [v -ED, -ING, -S]\n",
  "RICKBURNER": "(archaic) an arsonist who sets fire to haystacks [n -S]\n",
  "RICKBURNERS": "RICKBURNER, (archaic) an arsonist who sets fire to haystacks [n]\n",
  "RICKED": "RICK, to pile hay in stacks [v]\n",
  "RICKER": "a young tree trunk [n -S]\n",
  "RICKERS": "RICKER, a young tree trunk [n]\n",
  "RICKET": "a mistake or blunder [n -S]\n",
  "RICKETIER": "RICKETY, shaky, ramshackle, also RICKETTY [adj]\n",
  "RICKETIEST": "RICKETY, shaky, ramshackle, also RICKETTY [adj]\n",
  "RICKETILY": "RICKETY, shaky, ramshackle, also RICKETTY [adv]\n",
  "RICKETINESS": "the state of being rickety [n -ES]\n",
  "RICKETINESSES": "RICKETINESS, the state of being rickety [n]\n",
  "RICKETS": "a disease resulting from a vitamin D deficiency [n RICKETS]\n",
  "RICKETTIER": "RICKETTY, shaky, ramshackle, also RICKETY [adj]\n",
  "RICKETTIEST": "RICKETTY, shaky, ramshackle, also RICKETY [adj]\n",
  "RICKETTSIA": "a genus of bacteria that cause typhus and Rocky Mountain spotted fever [n RICKETTSIAS or RICKETTSIAE]\n",
  "RICKETTSIAE": "RICKETTSIA, a genus of bacteria that cause typhus and Rocky Mountain spotted fever [n]\n",
  "RICKETTSIAL": "relating to rickettsia [adj]\n",
  "RICKETTSIAS": "RICKETTSIA, a genus of bacteria that cause typhus and Rocky Mountain spotted fever [n]\n",
  "RICKETTY": "shaky, ramshackle, also RICKETY [adj RICKETTIER, RICKETTIEST]\n",
  "RICKETY": "shaky, ramshackle, also RICKETTY [adj RICKETIER, RICKETIEST]\n",
  "RICKEY": "an alcoholic beverage [n -S]\n",
  "RICKEYS": "RICKEY, an alcoholic beverage [n]\n",
  "RICKING": "RICK, to pile hay in stacks [v]\n",
  "RICKLE": "(Scots) a loose heap; a rickety structure [n -S]\n",
  "RICKLES": "RICKLE, (Scots) a loose heap; a rickety structure [n]\n",
  "RICKLIER": "RICKLY, (Scots) loose, rickety [adj]\n",
  "RICKLIEST": "RICKLY, (Scots) loose, rickety [adj]\n",
  "RICKLY": "(Scots) loose, rickety [adj RICKLIER, RICKLIEST]\n",
  "RICKRACK": "a braid used in trimming, also RICRAC [n -S]\n",
  "RICKRACKS": "RICKRACK, a braid used in trimming, also RICRAC [n]\n",
  "RICKS": "RICK, to pile hay in stacks [v]\n",
  "RICKSHA": "(Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHAW, RIKISHA, RIKSHAW [n -S]\n",
  "RICKSHAS": "RICKSHA, (Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHAW, RIKISHA, RIKSHAW [n]\n",
  "RICKSHAW": "(Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RIKISHA, RIKSHAW [n -S]\n",
  "RICKSHAWS": "RICKSHAW, (Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RIKISHA, RIKSHAW [n]\n",
  "RICKSTAND": "a flooring or framework on which a rick is made [n -S]\n",
  "RICKSTANDS": "RICKSTAND, a flooring or framework on which a rick is made [n]\n",
  "RICKSTICK": "a toothed stick for combing thatch on a stack [n -S]\n",
  "RICKSTICKS": "RICKSTICK, a toothed stick for combing thatch on a stack [n]\n",
  "RICKYARD": "a yard for storing ricks [n -S]\n",
  "RICKYARDS": "RICKYARD, a yard for storing ricks [n]\n",
  "RICOCHET": "(French) to rebound from a surface [v RICOCHETED or RICOCHETTED, RICOCHETING or RICOCHETTING, RICOCHETS]\n",
  "RICOCHETED": "RICOCHET, (French) to rebound from a surface [v]\n",
  "RICOCHETING": "RICOCHET, (French) to rebound from a surface [v]\n",
  "RICOCHETS": "RICOCHET, (French) to rebound from a surface [v]\n",
  "RICOCHETTED": "RICOCHET, (French) to rebound from a surface [v]\n",
  "RICOCHETTING": "RICOCHET, (French) to rebound from a surface [v]\n",
  "RICOTTA": "(Italian) a type of Italian cheese [n -S]\n",
  "RICOTTAS": "RICOTTA, (Italian) a type of Italian cheese [n]\n",
  "RICRAC": "a braid used in trimming, also RICKRACK [n -S]\n",
  "RICRACS": "RICRAC, a braid used in trimming, also RICKRACK [n]\n",
  "RICTAL": "relating to the rictus, the expanse or gape of the mouth, or of the beak or jaws of a bird, fish, etc. [adj]\n",
  "RICTUS": "(Latin) the expanse of the open mouth [n -ES]\n",
  "RICTUSES": "RICTUS, (Latin) the expanse of the open mouth [n]\n",
  "RICY": "containing rice, also RICEY [adj RICIER, RICIEST]\n",
  "RID": "to free or clear [v RIDDED, RIDDING, RIDS]\n",
  "RIDABILITIES": "RIDABILITY, the state of being ridable [n]\n",
  "RIDABILITY": "the state of being ridable [n RIDABILITIES]\n",
  "RIDABLE": "capable of being ridden, also RIDEABLE [adj]\n",
  "RIDDANCE": "the action or an act of getting rid of something or someone [n -S]\n",
  "RIDDANCES": "RIDDANCE, the action or an act of getting rid of something or someone [n]\n",
  "RIDDED": "RID, to free or clear [v]\n",
  "RIDDEN": "RIDE, to be conveyed by an animal or machine [v]\n",
  "RIDDER": "one who rids [n -S]\n",
  "RIDDERS": "RIDDER, one who rids [n]\n",
  "RIDDING": "RID, to free or clear [v]\n",
  "RIDDLE": "to pierce with many holes [v RIDDLED, RIDDLING, RIDDLES]\n",
  "RIDDLED": "RIDDLE, to pierce with many holes [v]\n",
  "RIDDLER": "one who poses riddles [n -S]\n",
  "RIDDLERS": "RIDDLER, one who poses riddles [n]\n",
  "RIDDLES": "RIDDLE, to pierce with many holes [v]\n",
  "RIDDLING": "enigmatic, obscure [adj RIDDLINGLY] / the act of riddling [n -S]\n",
  "RIDDLINGLY": "RIDDLING, enigmatic, obscure [adv]\n",
  "RIDDLINGS": "RIDDLING, the act of riddling [n]\n",
  "RIDE": "to be conveyed by an animal or machine [v RODE or (obsolete) RADE, RIDDEN, RIDING, RIDES]\n",
  "RIDEABLE": "capable of being ridden, also RIDABLE [adj]\n",
  "RIDENT": "laughing [adj]\n",
  "RIDER": "one who rides [n -S]\n",
  "RIDERED": "depicting a rider [adj]\n",
  "RIDERLESS": "without a rider [adj]\n",
  "RIDERS": "RIDER, one who rides [n]\n",
  "RIDERSHIP": "being a rider [n -S]\n",
  "RIDERSHIPS": "RIDERSHIP, being a rider [n]\n",
  "RIDES": "RIDE, to be conveyed by an animal or machine [v]\n",
  "RIDESHARING": "the practice of sharing a car with other commuters as a means of lessening traffic congestion or pollution [n -S]\n",
  "RIDESHARINGS": "RIDESHARING, the practice of sharing a car with other commuters as a means of lessening traffic congestion or pollution [n]\n",
  "RIDGE": "to form into long, narrow elevations [v RIDGED, RIDGING, RIDGES]\n",
  "RIDGEBACK": "a large hunting-dog [n -S]\n",
  "RIDGEBACKS": "RIDGEBACK, a large hunting-dog [n]\n",
  "RIDGED": "RIDGE, to form into long, narrow elevations [v]\n",
  "RIDGEL": "a male animal with only one testicle, also RIDGELING, RIDGIL, RIDGLING, RIGGALD, RIGLIN, RIGLING [n -S]\n",
  "RIDGELIKE": "like a ridge [adj]\n",
  "RIDGELINE": "a line marking or following a ridge [n -S]\n",
  "RIDGELINES": "RIDGELINE, a line marking or following a ridge [n]\n",
  "RIDGELING": "a male animal with only one testicle, also RIDGEL, RIDGIL, RIDGLING, RIGGALD, RIGLIN, RIGLING [n -S]\n",
  "RIDGELINGS": "RIDGELING, a male animal with only one testicle, also RIDGEL, RIDGIL, RIDGLING, RIGGALD, RIGLIN, RIGLING [n]\n",
  "RIDGELS": "RIDGEL, a male animal with only one testicle, also RIDGELING, RIDGIL, RIDGLING, RIGGALD, RIGLIN, RIGLING [n]\n",
  "RIDGEPOLE": "the timber forming the ridge of a roof, into which the rafters are secured, also RIDGETREE [n -S]\n",
  "RIDGEPOLES": "RIDGEPOLE, the timber forming the ridge of a roof, into which the rafters are secured, also RIDGETREE [n]\n",
  "RIDGER": "a type of plough which forms ridges on either side of the furrow [n -S]\n",
  "RIDGERS": "RIDGER, a type of plough which forms ridges on either side of the furrow [n]\n",
  "RIDGES": "RIDGE, to form into long, narrow elevations [v]\n",
  "RIDGETOP": "the crest of a ridge [n -S]\n",
  "RIDGETOPS": "RIDGETOP, the crest of a ridge [n]\n",
  "RIDGETREE": "the timber forming the ridge of a roof, into which the rafters are secured, also RIDGEPOLE [n -S]\n",
  "RIDGETREES": "RIDGETREE, the timber forming the ridge of a roof, into which the rafters are secured, also RIDGEPOLE [n]\n",
  "RIDGEWAY": "a track following a ridge [n -S]\n",
  "RIDGEWAYS": "RIDGEWAY, a track following a ridge [n]\n",
  "RIDGIER": "RIDGY, having ridges [adj]\n",
  "RIDGIEST": "RIDGY, having ridges [adj]\n",
  "RIDGIL": "a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGLING, RIGGALD, RIGLIN, RIGLING [n -S]\n",
  "RIDGILS": "RIDGIL, a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGLING, RIGGALD, RIGLIN, RIGLING [n]\n",
  "RIDGING": "the forming of ridges [n -S]\n",
  "RIDGINGS": "RIDGING, the forming of ridges [n]\n",
  "RIDGLING": "a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIGGALD, RIGLIN, RIGLING [n -S]\n",
  "RIDGLINGS": "RIDGLING, a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIGGALD, RIGLIN, RIGLING [n]\n",
  "RIDGY": "having ridges [adj RIDGIER, RIDGIEST]\n",
  "RIDIC": "(slang) ridiculous [adj]\n",
  "RIDICULE": "to make fun of [v RIDICULED, RIDICULING, RIDICULES]\n",
  "RIDICULED": "RIDICULE, to make fun of [v]\n",
  "RIDICULER": "one who ridicules [n -S]\n",
  "RIDICULERS": "RIDICULER, one who ridicules [n]\n",
  "RIDICULES": "RIDICULE, to make fun of [v]\n",
  "RIDICULING": "RIDICULE, to make fun of [v]\n",
  "RIDICULOUS": "arousing or deserving ridicule [adj RIDICULOUSLY]\n",
  "RIDICULOUSLY": "RIDICULOUS, arousing or deserving ridicule [adv]\n",
  "RIDICULOUSNESS": "the state of being ridiculous [n]\n",
  "RIDING": "a division of a county [n -S]\n",
  "RIDINGS": "RIDING, a division of a county [n]\n",
  "RIDLEY": "a sea turtle [n -S]\n",
  "RIDLEYS": "RIDLEY, a sea turtle [n]\n",
  "RIDOTTO": "(Italian) a public musical entertainment in 18th century England [n -S]\n",
  "RIDOTTOS": "RIDOTTO, (Italian) a public musical entertainment in 18th century England [n]\n",
  "RIDS": "RID, to free or clear [v]\n",
  "RIEBECKITE": "a monoclinic amphibole, a silicate of sodium and iron [n -S]\n",
  "RIEBECKITES": "RIEBECKITE, a monoclinic amphibole, a silicate of sodium and iron [n]\n",
  "RIEL": "a monetary unit of Cambodia [n -S]\n",
  "RIELS": "RIEL, a monetary unit of Cambodia [n]\n",
  "RIEM": "(South African) a rawhide thong [n -S]\n",
  "RIEMPIE": "(South African) a long riem about the width of a shoelace, used as string [n -S]\n",
  "RIEMPIES": "RIEMPIE, (South African) a long riem about the width of a shoelace, used as string [n]\n",
  "RIEMS": "RIEM, (South African) a rawhide thong [n]\n",
  "RIESLING": "(German) a type of grape grown esp. in Germany; a dry white table wine produced from this [n -S]\n",
  "RIESLINGS": "RIESLING, (German) a type of grape grown esp. in Germany; a dry white table wine produced from this [n]\n",
  "RIEVE": "to rob, plunder, also REAVE, REIVE [v RIEVED or REFT, RIEVING, RIEVES]\n",
  "RIEVED": "RIEVE, to rob, plunder, also REAVE, REIVE [v]\n",
  "RIEVER": "a raider, plunderer, also REAVER, REIVER [n -S]\n",
  "RIEVERS": "RIEVER, a raider, plunderer, also REAVER, REIVER [n]\n",
  "RIEVES": "RIEVE, to rob, plunder, also REAVE, REIVE [v]\n",
  "RIEVING": "RIEVE, to rob, plunder, also REAVE, REIVE [v]\n",
  "RIF": "to dismiss from employment [v RIFFED, RIFFING, RIFS]\n",
  "RIFACIMENTI": "RIFACIMENTO, (Italian) a recasting of a literary or musical work [n]\n",
  "RIFACIMENTO": "(Italian) a recasting of a literary or musical work [n RIFACIMENTI or RIFACIMENTOS]\n",
  "RIFACIMENTOS": "RIFACIMENTO, (Italian) a recasting of a literary or musical work [n]\n",
  "RIFAMPICIN": "an antibiotic drug used in treating tuberculosis, leprosy and meningitis [n -S]\n",
  "RIFAMPICINS": "RIFAMPICIN, an antibiotic drug used in treating tuberculosis, leprosy and meningitis [n]\n",
  "RIFAMPIN": "an antibiotic [n -S]\n",
  "RIFAMPINS": "RIFAMPIN, an antibiotic [n]\n",
  "RIFAMYCIN": "an antibiotic [n -S]\n",
  "RIFAMYCINS": "RIFAMYCIN, an antibiotic [n]\n",
  "RIFE": "abundant, prevalent, also RYFE [adj RIFER, RIFEST, RIFELY]\n",
  "RIFELY": "RIFE, abundant, prevalent, also RYFE [adv]\n",
  "RIFENESS": "the state of being rife [n -ES]\n",
  "RIFENESSES": "RIFENESS, the state of being rife [n]\n",
  "RIFER": "RIFE, abundant, prevalent, also RYFE [adj]\n",
  "RIFEST": "RIFE, abundant, prevalent, also RYFE [adj]\n",
  "RIFF": "in jazz, a short rhythmic phrase repeated constantly [n -S] / to play such a phrase [v -ED, -ING, -S]\n",
  "RIFFAGE": "in jazz, the act of playing a short series of chords [n -S]\n",
  "RIFFAGES": "RIFFAGE, in jazz, the act of playing a short series of chords [n]\n",
  "RIFFED": "RIFF, to play such a phrase [v]\n",
  "RIFFING": "RIFF, to play such a phrase [v]\n",
  "RIFFLE": "to ruffle, to shuffle e.g. cards [v RIFFLED, RIFFLING, RIFFLES]\n",
  "RIFFLED": "RIFFLE, to ruffle, to shuffle e.g. cards [v]\n",
  "RIFFLER": "a small file with curved ends used in woodworking [n -S]\n",
  "RIFFLERS": "RIFFLER, a small file with curved ends used in woodworking [n]\n",
  "RIFFLES": "RIFFLE, to ruffle, to shuffle e.g. cards [v]\n",
  "RIFFLING": "RIFFLE, to ruffle, to shuffle e.g. cards [v]\n",
  "RIFFOLA": "(colloquial) the use of an abundance of dominant riffs [n -S]\n",
  "RIFFOLAS": "RIFFOLA, (colloquial) the use of an abundance of dominant riffs [n]\n",
  "RIFFRAFF": "the disreputable element of society [n -S]\n",
  "RIFFRAFFS": "RIFFRAFF, the disreputable element of society [n]\n",
  "RIFFS": "RIFF, to play such a phrase [v]\n",
  "RIFLE": "to search through and rob [v RIFLED, RIFLING, RIFLES]\n",
  "RIFLEBIRD": "each of three birds of paradise of the genus Ptiloris, having velvety black plumage with bright coloured patches, and a long bill [n -S]\n",
  "RIFLEBIRDS": "RIFLEBIRD, each of three birds of paradise of the genus Ptiloris, having velvety black plumage with bright coloured patches, and a long bill [n]\n",
  "RIFLED": "RIFLE, to search through and rob [v]\n",
  "RIFLEMAN": "a soldier armed with a type of firearm [n RIFLEMEN]\n",
  "RIFLEMEN": "RIFLEMAN, a soldier armed with a type of firearm [n]\n",
  "RIFLER": "a hawk that grasps only feathers in striking at the quarry [n -S]\n",
  "RIFLERIES": "RIFLERY, the practice of shooting at targets with a rifle [n]\n",
  "RIFLERS": "RIFLER, a hawk that grasps only feathers in striking at the quarry [n]\n",
  "RIFLERY": "the practice of shooting at targets with a rifle [n RIFLERIES]\n",
  "RIFLES": "RIFLE, to search through and rob [v]\n",
  "RIFLING": "the system of grooves in a gun barrel [n -S]\n",
  "RIFLINGS": "RIFLING, the system of grooves in a gun barrel [n]\n",
  "RIFLIP": "the genetic difference between two individuals [n -S]\n",
  "RIFLIPS": "RIFLIP, the genetic difference between two individuals [n]\n",
  "RIFS": "RIF, to dismiss from employment [v]\n",
  "RIFT": "to form a fissure [v -ED, -ING, -S]\n",
  "RIFTE": "RIVE, to tear apart [v]\n",
  "RIFTED": "RIFT, to form a fissure [v]\n",
  "RIFTIER": "RIFTY, having fissures [adj]\n",
  "RIFTIEST": "RIFTY, having fissures [adj]\n",
  "RIFTING": "RIFT, to form a fissure [v]\n",
  "RIFTLESS": "without rifts [adj]\n",
  "RIFTS": "RIFT, to form a fissure [v]\n",
  "RIFTY": "having fissures [adj RIFTIER, RIFTIEST]\n",
  "RIG": "to equip or fit with sails [v RIGGED, RIGGING, RIGS]\n",
  "RIGADOON": "a lively Baroque period dance, also RIGAUDON [n -S]\n",
  "RIGADOONS": "RIGADOON, a lively Baroque period dance, also RIGAUDON [n]\n",
  "RIGAMAROLE": "a succession of incoherent statements, also RIGMAROLE [n -S]\n",
  "RIGAMAROLES": "RIGAMAROLE, a succession of incoherent statements, also RIGMAROLE [n]\n",
  "RIGATONI": "(Italian) pasta in the form of large fluted tubes [n -S]\n",
  "RIGATONIS": "RIGATONI, (Italian) pasta in the form of large fluted tubes [n]\n",
  "RIGAUDON": "(French) a lively Baroque period dance, also RIGADOON [n -S]\n",
  "RIGAUDONS": "RIGAUDON, (French) a lively Baroque period dance, also RIGADOON [n]\n",
  "RIGG": "the dogfish [n -S]\n",
  "RIGGALD": "a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIDGLING, RIGLIN, RIGLING [n -S]\n",
  "RIGGALDS": "RIGGALD, a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIDGLING, RIGLIN, RIGLING [n]\n",
  "RIGGED": "RIG, to equip or fit with sails [v]\n",
  "RIGGER": "one who rigs e.g. ships [n -S]\n",
  "RIGGERS": "RIGGER, one who rigs e.g. ships [n]\n",
  "RIGGING": "the system of lines, chains, and tackle used aboard a ship [n -S]\n",
  "RIGGINGS": "RIGGING, the system of lines, chains, and tackle used aboard a ship [n]\n",
  "RIGGISH": "(Shakespeare) wanton [adj]\n",
  "RIGGS": "RIGG, the dogfish [n]\n",
  "RIGHT": "being in accordance with what is good, proper, or just [adj RIGHTER, RIGHTEST, RIGHTLY] / to put in proper order or condition [v -ED, -ING, -S]\n",
  "RIGHTABLE": "that can be righted [adj RIGHTABLY]\n",
  "RIGHTABLENESS": "the state of being rightable [n -ES]\n",
  "RIGHTABLENESSES": "RIGHTABLENESS, the state of being rightable [n]\n",
  "RIGHTABLY": "RIGHTABLE, that can be righted [adv]\n",
  "RIGHTED": "RIGHT, to put in proper order or condition [v]\n",
  "RIGHTEN": "(archaic) to set right [v -ED, -ING, -S]\n",
  "RIGHTENED": "RIGHTEN, (archaic) to set right [v]\n",
  "RIGHTENING": "RIGHTEN, (archaic) to set right [v]\n",
  "RIGHTENS": "RIGHTEN, (archaic) to set right [v]\n",
  "RIGHTEOUS": "just, proper [adj RIGHTEOUSLY]\n",
  "RIGHTEOUSLY": "RIGHTEOUS, just, proper [adv]\n",
  "RIGHTEOUSNESS": "the state of being righteous [n -ES]\n",
  "RIGHTEOUSNESSES": "RIGHTEOUSNESS, the state of being righteous [n]\n",
  "RIGHTER": "one who sets things right [n -S]\n",
  "RIGHTERS": "RIGHTER, one who sets things right [n]\n",
  "RIGHTEST": "RIGHT, being in accordance with what is good, proper, or just [adj]\n",
  "RIGHTFUL": "just and proper [adj RIGHTFULLY]\n",
  "RIGHTFULLY": "RIGHTFUL, just and proper [adv]\n",
  "RIGHTFULNESS": "the state of being rightful [n -ES]\n",
  "RIGHTFULNESSES": "RIGHTFULNESS, the state of being rightful [n]\n",
  "RIGHTIER": "RIGHTY, politically conservative [adj]\n",
  "RIGHTIES": "RIGHTY, a right-handed person [n]\n",
  "RIGHTIEST": "RIGHTY, politically conservative [adj]\n",
  "RIGHTING": "the act of making things right [n -S]\n",
  "RIGHTINGS": "RIGHTING, the act of making things right [n]\n",
  "RIGHTISH": "somewhat right [adj]\n",
  "RIGHTISM": "conservative political philosophy [n -S]\n",
  "RIGHTISMS": "RIGHTISM, conservative political philosophy [n]\n",
  "RIGHTIST": "one who adheres to the political right [n -S]\n",
  "RIGHTISTS": "RIGHTIST, one who adheres to the political right [n]\n",
  "RIGHTLESS": "destitute of right [adj]\n",
  "RIGHTLY": "RIGHT, being in accordance with what is good, proper, or just [adv]\n",
  "RIGHTMOST": "on the extreme right [adj]\n",
  "RIGHTNESS": "the state of being right [n -ES]\n",
  "RIGHTNESSES": "RIGHTNESS, the state of being right [n]\n",
  "RIGHTO": "used to express cheerful consent [interj]\n",
  "RIGHTS": "RIGHT, to put in proper order or condition [v]\n",
  "RIGHTSIZE": "to adapt an organisation to an appropriate size by means of redundancies [v RIGHTSIZED, RIGHTSIZING, RIGHTSIZES]\n",
  "RIGHTSIZED": "RIGHTSIZE, to adapt an organisation to an appropriate size by means of redundancies [v]\n",
  "RIGHTSIZES": "RIGHTSIZE, to adapt an organisation to an appropriate size by means of redundancies [v]\n",
  "RIGHTSIZING": "the act of adapting an organisation to an appropriate size by means of redundancies [n -S]\n",
  "RIGHTSIZINGS": "RIGHTSIZING, the act of adapting an organisation to an appropriate size by means of redundancies [n]\n",
  "RIGHTWARD": "toward the right [adj RIGHTWARDLY]\n",
  "RIGHTWARDLY": "RIGHTWARD, toward the right [adv]\n",
  "RIGHTWARDS": "toward the right, also RIGHTWARD [adv]\n",
  "RIGHTY": "politically conservative [adj RIGHTIER, RIGHTIEST] / a right-handed person [n RIGHTIES]\n",
  "RIGID": "stiff [adj RIGIDER, RIGIDEST, RIGIDLY] / a rigid airship [n -S]\n",
  "RIGIDER": "RIGID, stiff [adj]\n",
  "RIGIDEST": "RIGID, stiff [adj]\n",
  "RIGIDIFICATION": "the act of rigidifying [n -S]\n",
  "RIGIDIFICATIONS": "RIGIDIFICATION, the act of rigidifying [n]\n",
  "RIGIDIFIED": "RIGIDIFY, to make stiff, also RIGIDISE, RIGIDIZE [v]\n",
  "RIGIDIFIES": "RIGIDIFY, to make stiff, also RIGIDISE, RIGIDIZE [v]\n",
  "RIGIDIFY": "to make stiff, also RIGIDISE, RIGIDIZE [v RIGIDIFIED, RIGIDIFYING, RIGIDIFIES]\n",
  "RIGIDIFYING": "RIGIDIFY, to make stiff, also RIGIDISE, RIGIDIZE [v]\n",
  "RIGIDISE": "to make stiff, also RIGIDIFY, RIGIDIZE [v RIGIDISED, RIGIDISING, RIGIDISES]\n",
  "RIGIDISED": "RIGIDISE, to make stiff, also RIGIDIFY, RIGIDIZE [v]\n",
  "RIGIDISES": "RIGIDISE, to make stiff, also RIGIDIFY, RIGIDIZE [v]\n",
  "RIGIDISING": "RIGIDISE, to make stiff, also RIGIDIFY, RIGIDIZE [v]\n",
  "RIGIDITIES": "RIGIDITY, the state of being rigid [n]\n",
  "RIGIDITY": "the state of being rigid [n RIGIDITIES]\n",
  "RIGIDIZE": "to make stiff, also RIGIDIFY, RIGIDISE [v RIGIDIZED, RIGIDIZING, RIGIDIZES]\n",
  "RIGIDIZED": "RIGIDIZE, to make stiff, also RIGIDIFY, RIGIDISE [v]\n",
  "RIGIDIZES": "RIGIDIZE, to make stiff, also RIGIDIFY, RIGIDISE [v]\n",
  "RIGIDIZING": "RIGIDIZE, to make stiff, also RIGIDIFY, RIGIDISE [v]\n",
  "RIGIDLY": "RIGID, stiff [adv]\n",
  "RIGIDNESS": "the state of being rigid, also RIGIDITY [n -ES]\n",
  "RIGIDNESSES": "RIGIDNESS, the state of being rigid, also RIGIDITY [n]\n",
  "RIGIDS": "RIGID, a rigid airship [n]\n",
  "RIGLIN": "a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIDGLING, RIGGALD, RIGLING [n -S]\n",
  "RIGLING": "a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIDGLING, RIGGALD, RIGLIN [n -S]\n",
  "RIGLINGS": "RIGLING, a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIDGLING, RIGGALD, RIGLIN [n]\n",
  "RIGLINS": "RIGLIN, a male animal with only one testicle, also RIDGEL, RIDGELING, RIDGIL, RIDGLING, RIGGALD, RIGLING [n]\n",
  "RIGMAROLE": "a succession of incoherent statements, also RIGAMAROLE [n -S]\n",
  "RIGMAROLES": "RIGMAROLE, a succession of incoherent statements, also RIGAMAROLE [n]\n",
  "RIGOL": "a gutter or water-channel, also RIGOLL [n -S]\n",
  "RIGOLL": "a gutter or water-channel, also RIGOL [n -S]\n",
  "RIGOLLS": "RIGOLL, a gutter or water-channel, also RIGOL [n]\n",
  "RIGOLS": "RIGOL, a gutter or water-channel, also RIGOLL [n]\n",
  "RIGOR": "a sense of chilliness with contraction of the skin [n -S]\n",
  "RIGORISM": "rigidity in principle or practice [n -S]\n",
  "RIGORISMS": "RIGORISM, rigidity in principle or practice [n]\n",
  "RIGORIST": "one who professes rigorism [n -S]\n",
  "RIGORISTIC": "relating to rigorism [adj]\n",
  "RIGORISTS": "RIGORIST, one who professes rigorism [n]\n",
  "RIGOROUS": "characterized by rigor [adj RIGOROUSLY]\n",
  "RIGOROUSLY": "RIGOROUS, characterized by rigor [adv]\n",
  "RIGOROUSNESS": "the state of being rigorous [n -ES]\n",
  "RIGOROUSNESSES": "RIGOROUSNESS, the state of being rigorous [n]\n",
  "RIGORS": "RIGOR, a sense of chilliness with contraction of the skin [n]\n",
  "RIGOUR": "severity [n -S]\n",
  "RIGOURS": "RIGOUR, severity [n]\n",
  "RIGOUT": "a person's distinctive costume [n -S]\n",
  "RIGOUTS": "RIGOUT, a person's distinctive costume [n]\n",
  "RIGS": "RIG, to equip or fit with sails [v]\n",
  "RIGSDALER": "(Dutch) a small Dutch silver coin, also RIJKSDAALER [n -S]\n",
  "RIGSDALERS": "RIGSDALER, (Dutch) a small Dutch silver coin, also RIJKSDAALER [n]\n",
  "RIGWIDDIE": "(Scots) a carthorse's backband, also RIGWOODIE [n -S]\n",
  "RIGWIDDIES": "RIGWIDDIE, (Scots) a carthorse's backband, also RIGWOODIE [n]\n",
  "RIGWOODIE": "(Scots) a carthorse's backband, also RIGWIDDIE [n -S]\n",
  "RIGWOODIES": "RIGWOODIE, (Scots) a carthorse's backband, also RIGWIDDIE [n]\n",
  "RIJKSDAALER": "(Dutch) a small Dutch silver coin, also RIGSDALER [n -S]\n",
  "RIJKSDAALERS": "RIJKSDAALER, (Dutch) a small Dutch silver coin, also RIGSDALER [n]\n",
  "RIJSTAFEL": "(Dutch) an Indonesian rice dish, also REISTAFEL, RIJSTTAFEL [n -S]\n",
  "RIJSTAFELS": "RIJSTAFEL, (Dutch) an Indonesian rice dish, also REISTAFEL, RIJSTTAFEL [n]\n",
  "RIJSTTAFEL": "(Dutch) an Indonesian rice dish, also REISTAFEL, RIJSTAFEL [n -S]\n",
  "RIJSTTAFELS": "RIJSTTAFEL, (Dutch) an Indonesian rice dish, also REISTAFEL, RIJSTAFEL [n]\n",
  "RIKISHA": "(Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKSHAW [n -S]\n",
  "RIKISHAS": "RIKISHA, (Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKSHAW [n]\n",
  "RIKISHI": "(Japanese) a sumo wrestler [n RIKISHI]\n",
  "RIKSHAW": "(Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA [n -S]\n",
  "RIKSHAWS": "RIKSHAW, (Japanese) a small, two-wheeled hooded carriage drawn by a man or men, also JINRICKSHA, JINRICKSHAW, JINRIKISHA, JINRIKSHA, RICKSHA, RICKSHAW, RIKISHA [n]\n",
  "RILE": "to anger [v RILED, RILING, RILES]\n",
  "RILED": "RILE, to anger [v]\n",
  "RILES": "RILE, to anger [v]\n",
  "RILEY": "turbid, also ROILY [adj RILIER, RILIEST]\n",
  "RILIER": "RILEY, turbid, also ROILY [adj]\n",
  "RILIEST": "RILEY, turbid, also ROILY [adj]\n",
  "RILIEVI": "RILIEVO, (Italian) the projection of figures or forms from a flat background, also RELIEVO [n]\n",
  "RILIEVO": "(Italian) the projection of figures or forms from a flat background, also RELIEVO [n RILIEVI]\n",
  "RILING": "RILE, to anger [v]\n",
  "RILL": "to flow like a small brook [v -ED, -ING, -S]\n",
  "RILLE": "a valley on the moon's surface [n -S]\n",
  "RILLED": "RILL, to flow like a small brook [v]\n",
  "RILLES": "RILLE, a valley on the moon's surface [n]\n",
  "RILLET": "a small rill [n -S]\n",
  "RILLETS": "RILLET, a small rill [n]\n",
  "RILLETTES": "(French) a French type of potted meat made by simmering shreds of lean and fat pork, then pounding them to make a paste [n]\n",
  "RILLING": "RILL, to flow like a small brook [v]\n",
  "RILLMARK": "a marking produced by water running down a bank or beach [n -S]\n",
  "RILLMARKS": "RILLMARK, a marking produced by water running down a bank or beach [n]\n",
  "RILLS": "RILL, to flow like a small brook [v]\n",
  "RIM": "to provide with an outer edge [v RIMMED, RIMMING, RIMS]\n",
  "RIMA": "(Latin) a chink [n RIMAE]\n",
  "RIMAE": "RIMA, (Latin) a chink [n]\n",
  "RIMAYE": "(French) a bergschrund, a crevasse formed where a glacier or snowfield moves away from a mountain wall [n -S]\n",
  "RIMAYES": "RIMAYE, (French) a bergschrund, a crevasse formed where a glacier or snowfield moves away from a mountain wall [n]\n",
  "RIME": "hoarfrost [n -S] / to cover with rime [v RIMED, RIMING, RIMES]\n",
  "RIMED": "RIME, to cover with rime [v]\n",
  "RIMELESS": "without rime [adj]\n",
  "RIMER": "one that rimes, also RIMESTER [n -S]\n",
  "RIMERS": "RIMER, one that rimes, also RIMESTER [n]\n",
  "RIMES": "RIME, to cover with rime [v]\n",
  "RIMESTER": "one that rimes, also RIMER [n -S]\n",
  "RIMESTERS": "RIMESTER, one that rimes, also RIMER [n]\n",
  "RIMFIRE": "a cartridge having the primer set in the rim of the shell [n -S]\n",
  "RIMFIRES": "RIMFIRE, a cartridge having the primer set in the rim of the shell [n]\n",
  "RIMIER": "RIMY, covered with rime [adj]\n",
  "RIMIEST": "RIMY, covered with rime [adj]\n",
  "RIMINESS": "the condition of being rimy [n -ES]\n",
  "RIMINESSES": "RIMINESS, the condition of being rimy [n]\n",
  "RIMING": "RIME, to cover with rime [v]\n",
  "RIMLAND": "an outlying area [n -S]\n",
  "RIMLANDS": "RIMLAND, an outlying area [n]\n",
  "RIMLESS": "without a rim [adj]\n",
  "RIMMED": "RIM, to provide with an outer edge [v]\n",
  "RIMMER": "a tool used to enlarge holes, also REAMER [n -S]\n",
  "RIMMERS": "RIMMER, a tool used to enlarge holes, also REAMER [n]\n",
  "RIMMING": "stimulation of the anus [n -S]\n",
  "RIMMINGS": "RIMMING, stimulation of the anus [n]\n",
  "RIMOSE": "marked by cracks, also RIMOUS [adj]\n",
  "RIMOSELY": "RIMOSE, marked by cracks, also RIMOUS [adv]\n",
  "RIMOSITIES": "RIMOSITY, the state of being rimose, full of cracks [n]\n",
  "RIMOSITY": "the state of being rimose, full of cracks [n RIMOSITIES]\n",
  "RIMOUS": "marked by cracks, also RIMOSE [adj]\n",
  "RIMPLE": "to wrinkle [v RIMPLED, RIMPLING, RIMPLES]\n",
  "RIMPLED": "RIMPLE, to wrinkle [v]\n",
  "RIMPLES": "RIMPLE, to wrinkle [v]\n",
  "RIMPLING": "RIMPLE, to wrinkle [v]\n",
  "RIMROCK": "an outcrop of resistant rock, esp. one forming a cliff at the edge of a plateau [n -S]\n",
  "RIMROCKS": "RIMROCK, an outcrop of resistant rock, esp. one forming a cliff at the edge of a plateau [n]\n",
  "RIMS": "RIM, to provide with an outer edge [v]\n",
  "RIMSHOT": "a sound made by a drumstick striking the rim and head of a drum [n -S]\n",
  "RIMSHOTS": "RIMSHOT, a sound made by a drumstick striking the rim and head of a drum [n]\n",
  "RIMU": "(Maori) a coniferous New Zealand tree [n -S]\n",
  "RIMUS": "RIMU, (Maori) a coniferous New Zealand tree [n]\n",
  "RIMY": "covered with rime [adj RIMIER, RIMIEST]\n",
  "RIN": "(Scots) to run [v RUN, RAN, RINNING, RINS]\n",
  "RIND": "to cover with bark, encrust [v -ED, -ING, -S]\n",
  "RINDED": "RIND, to cover with bark, encrust [v]\n",
  "RINDERPEST": "(German) an infectious disease of ruminants, esp. oxen [n -S]\n",
  "RINDERPESTS": "RINDERPEST, (German) an infectious disease of ruminants, esp. oxen [n]\n",
  "RINDIER": "RINDY, covered in rind [adj]\n",
  "RINDIEST": "RINDY, covered in rind [adj]\n",
  "RINDING": "RIND, to cover with bark, encrust [v]\n",
  "RINDLESS": "without rind [adj]\n",
  "RINDS": "RIND, to cover with bark, encrust [v]\n",
  "RINDY": "covered in rind [adj RINDIER, RINDIEST]\n",
  "RINE": "(Spenser) rind [n -S]\n",
  "RINES": "RINE, (Spenser) rind [n]\n",
  "RINFORZANDO": "(Italian) with a sudden stress or crescendo [adv]\n",
  "RING": "to give forth a clear, resonant sound [v RANG or (obsolete) RONG or RINGED, RUNG, RINGING, RINGS] / to form a circle around [v RINGED, RINGING, RINGS]\n",
  "RINGBARK": "to strip a ring of bark from a tree [v -ED, -ING, -S]\n",
  "RINGBARKED": "RINGBARK, to strip a ring of bark from a tree [v]\n",
  "RINGBARKING": "RINGBARK, to strip a ring of bark from a tree [v]\n",
  "RINGBARKS": "RINGBARK, to strip a ring of bark from a tree [v]\n",
  "RINGBIT": "a horse's bit [n -S]\n",
  "RINGBITS": "RINGBIT, a horse's bit [n]\n",
  "RINGBOLT": "an eyebolt having a ring through the eye [n -S]\n",
  "RINGBOLTS": "RINGBOLT, an eyebolt having a ring through the eye [n]\n",
  "RINGBONE": "a bony growth on a horse's foot [n -S]\n",
  "RINGBONES": "RINGBONE, a bony growth on a horse's foot [n]\n",
  "RINGDOVE": "the wood-pigeon, from the broken white ring or line on its neck [n -S]\n",
  "RINGDOVES": "RINGDOVE, the wood-pigeon, from the broken white ring or line on its neck [n]\n",
  "RINGED": "RING, to give forth a clear, resonant sound [v]\n",
  "RINGENT": "having gaping liplike parts such as the shells of certain bivalves [adj]\n",
  "RINGER": "one that rings [n -S]\n",
  "RINGERS": "RINGER, one that rings [n]\n",
  "RINGETTE": "(Canadian) a team sport played on an ice surface in which straight sticks are used to control a rubber ring [n -S]\n",
  "RINGETTES": "RINGETTE, (Canadian) a team sport played on an ice surface in which straight sticks are used to control a rubber ring [n]\n",
  "RINGGIT": "(Malay) a monetary unit in Brunei [n -S]\n",
  "RINGGITS": "RINGGIT, (Malay) a monetary unit in Brunei [n]\n",
  "RINGHALS": "(South African) an African snake that spits its venom, also RINKHALS [n -ES]\n",
  "RINGHALSES": "RINGHALS, (South African) an African snake that spits its venom, also RINKHALS [n]\n",
  "RINGING": "making a ringing sound [adj RINGINGLY] / the act of ringing [n -S]\n",
  "RINGINGLY": "RINGING, making a ringing sound [adv]\n",
  "RINGINGS": "RINGING, the act of ringing [n]\n",
  "RINGLEADER": "a leader of a ring of individuals engaged esp. in improper or unlawful activities [n -S]\n",
  "RINGLEADERS": "RINGLEADER, a leader of a ring of individuals engaged esp. in improper or unlawful activities [n]\n",
  "RINGLESS": "without a ring [adj]\n",
  "RINGLET": "a small ring [n -S]\n",
  "RINGLETED": "of hair, styled in ringlets [adj]\n",
  "RINGLETIER": "RINGLETY, resembling or suggestive of a ringlet [adj]\n",
  "RINGLETIEST": "RINGLETY, resembling or suggestive of a ringlet [adj]\n",
  "RINGLETS": "RINGLET, a small ring [n]\n",
  "RINGLETY": "resembling or suggestive of a ringlet [adj RINGLETIER, RINGLETIEST]\n",
  "RINGLIKE": "like a ring [adj]\n",
  "RINGMAN": "the ring finger [n RINGMEN]\n",
  "RINGMASTER": "one in charge of performances in a ring (as of a circus) [n -S]\n",
  "RINGMASTERS": "RINGMASTER, one in charge of performances in a ring (as of a circus) [n]\n",
  "RINGMEN": "RINGMAN, the ring finger [n]\n",
  "RINGNECK": "a bird having a ring of colour around the neck [n -S]\n",
  "RINGNECKS": "RINGNECK, a bird having a ring of colour around the neck [n]\n",
  "RINGS": "RING, to give forth a clear, resonant sound [v]\n",
  "RINGSIDE": "the area just outside the boxing ring [n -S]\n",
  "RINGSIDER": "one with a seat at the ringside [n -S]\n",
  "RINGSIDERS": "RINGSIDER, one with a seat at the ringside [n]\n",
  "RINGSIDES": "RINGSIDE, the area just outside the boxing ring [n]\n",
  "RINGSTAND": "a stand for chemical vessels, with rings clamped to a vertical rod [n -S]\n",
  "RINGSTANDS": "RINGSTAND, a stand for chemical vessels, with rings clamped to a vertical rod [n]\n",
  "RINGSTER": "a member of a ring, esp. a price-fixing ring [n -S]\n",
  "RINGSTERS": "RINGSTER, a member of a ring, esp. a price-fixing ring [n]\n",
  "RINGSTRAKED": "of an animal, insect, etc., having bands of colour round the body [adj]\n",
  "RINGTAIL": "an animal whose tail has ringlike markings [n -S]\n",
  "RINGTAILS": "RINGTAIL, an animal whose tail has ringlike markings [n]\n",
  "RINGTAW": "a game of marbles [n -S]\n",
  "RINGTAWS": "RINGTAW, a game of marbles [n]\n",
  "RINGTONE": "a tune played by a mobile phone when a call is received [n -S]\n",
  "RINGTONES": "RINGTONE, a tune played by a mobile phone when a call is received [n]\n",
  "RINGTOSS": "a game in which the object is to toss a ring so that it will catch upon an upright stick [n -ES]\n",
  "RINGTOSSES": "RINGTOSS, a game in which the object is to toss a ring so that it will catch upon an upright stick [n]\n",
  "RINGWAY": "a ring-road [n -S]\n",
  "RINGWAYS": "RINGWAY, a ring-road [n]\n",
  "RINGWISE": "in the manner of a ring [adv]\n",
  "RINGWOMB": "a complication in lamb birthing when the cervix fails to open [n -S]\n",
  "RINGWOMBS": "RINGWOMB, a complication in lamb birthing when the cervix fails to open [n]\n",
  "RINGWORK": "work executed in rings [n -S]\n",
  "RINGWORKS": "RINGWORK, work executed in rings [n]\n",
  "RINGWORM": "a contagious itching skin-disease occurring in small circular patches [n -S]\n",
  "RINGWORMS": "RINGWORM, a contagious itching skin-disease occurring in small circular patches [n]\n",
  "RINK": "to skate at an amusement venue [v -ED, -ING, -S]\n",
  "RINKED": "RINK, to skate at an amusement venue [v]\n",
  "RINKHALS": "(South African) an African snake that spits its venom, also RINGHALS [n -ES]\n",
  "RINKHALSES": "RINKHALS, (South African) an African snake that spits its venom, also RINGHALS [n]\n",
  "RINKING": "RINK, to skate at an amusement venue [v]\n",
  "RINKS": "RINK, to skate at an amusement venue [v]\n",
  "RINKSIDE": "the area at the side of a rink [n -S]\n",
  "RINKSIDES": "RINKSIDE, the area at the side of a rink [n]\n",
  "RINNING": "RIN, (Scots) to run [v]\n",
  "RINS": "RIN, (Scots) to run [v]\n",
  "RINSABILITIES": "RINSABILITY, the quality of being rinsable, also RINSIBILITY [n]\n",
  "RINSABILITY": "the quality of being rinsable, also RINSIBILITY [n RINSABILITIES]\n",
  "RINSABLE": "able to be rinsed [adj]\n",
  "RINSE": "to cleanse with clear water [v RINSED, RINSING, RINSES]\n",
  "RINSEABLE": "that can be rinsed, also RINSABLE, RINSIBLE [adj]\n",
  "RINSED": "RINSE, to cleanse with clear water [v]\n",
  "RINSER": "something or someone that rinses [n -S]\n",
  "RINSERS": "RINSER, something or someone that rinses [n]\n",
  "RINSES": "RINSE, to cleanse with clear water [v]\n",
  "RINSIBILITIES": "RINSIBILITY, the quality of being rinsible, also RINSABILITY [n]\n",
  "RINSIBILITY": "the quality of being rinsible, also RINSABILITY [n RINSIBILITIES]\n",
  "RINSIBLE": "that can be rinsed, also RINSABLE, RINSEABLE [adj]\n",
  "RINSING": "the act of rinsing [n -S]\n",
  "RINSINGS": "RINSING, the act of rinsing [n]\n",
  "RINTHEREOUT": "(Scots) a vagrant [n -S]\n",
  "RINTHEREOUTS": "RINTHEREOUT, (Scots) a vagrant [n]\n",
  "RIOJA": "(Spanish) a dry red wine [n -S]\n",
  "RIOJAS": "RIOJA, (Spanish) a dry red wine [n]\n",
  "RIOT": "to take part in a violent public disturbance [v -ED, -ING, -S]\n",
  "RIOTED": "RIOT, to take part in a violent public disturbance [v]\n",
  "RIOTER": "one that riots [n -S]\n",
  "RIOTERS": "RIOTER, one that riots [n]\n",
  "RIOTING": "the act of rioting [n -S]\n",
  "RIOTINGS": "RIOTING, the act of rioting [n]\n",
  "RIOTISE": "(obsolete) riot, extravagance, also RIOTIZE [n -S]\n",
  "RIOTISES": "RIOTISE, (obsolete) riot, extravagance, also RIOTIZE [n]\n",
  "RIOTIZE": "(obsolete) riot, extravagance, also RIOTISE [n -S]\n",
  "RIOTIZES": "RIOTIZE, (obsolete) riot, extravagance, also RIOTISE [n]\n",
  "RIOTOUS": "characterized by rioting [adj RIOTOUSLY]\n",
  "RIOTOUSLY": "RIOTOUS, characterized by rioting [adv]\n",
  "RIOTOUSNESS": "the state of being riotous [n -ES]\n",
  "RIOTOUSNESSES": "RIOTOUSNESS, the state of being riotous [n]\n",
  "RIOTRIES": "RIOTRY, the act or practice of rioting [n]\n",
  "RIOTRY": "the act or practice of rioting [n RIOTRIES]\n",
  "RIOTS": "RIOT, to take part in a violent public disturbance [v]\n",
  "RIP": "to tear apart roughly [v RIPPED or (obsolete) RIPT, RIPPING, RIPS]\n",
  "RIPARIAL": "an inhabitant of a river bank, also RIPARIAN [n -S]\n",
  "RIPARIALS": "RIPARIAL, an inhabitant of a river bank, also RIPARIAN [n]\n",
  "RIPARIAN": "of or inhabiting a riverbank, also RIPARIAL [adj] / an owner of land bordering a river [n -S]\n",
  "RIPARIANS": "RIPARIAN, an owner of land bordering a river [n]\n",
  "RIPCORD": "a cord to release a parachute [n -S]\n",
  "RIPCORDS": "RIPCORD, a cord to release a parachute [n]\n",
  "RIPE": "ready for harvest [adj RIPER, RIPEST, RIPELY] / to ripen [v RIPED, RIPING, RIPES]\n",
  "RIPECK": "a pole used for mooring a punt, also RYEPECK, RYPECK [n -S]\n",
  "RIPECKS": "RIPECK, a pole used for mooring a punt, also RYEPECK, RYPECK [n]\n",
  "RIPED": "RIPE, to ripen [v]\n",
  "RIPELY": "RIPE, ready for harvest [adv]\n",
  "RIPEN": "to become ripe [v -ED, -ING, -S]\n",
  "RIPENED": "RIPEN, to become ripe [v]\n",
  "RIPENER": "one that ripens [n -S]\n",
  "RIPENERS": "RIPENER, one that ripens [n]\n",
  "RIPENESS": "the state of being ripe [n -ES]\n",
  "RIPENESSES": "RIPENESS, the state of being ripe [n]\n",
  "RIPENING": "RIPEN, to become ripe [v]\n",
  "RIPENS": "RIPEN, to become ripe [v]\n",
  "RIPER": "one who gropes, ransacks [n -S]\n",
  "RIPERS": "RIPER, one who gropes, ransacks [n]\n",
  "RIPES": "RIPE, to ripen [v]\n",
  "RIPEST": "RIPE, ready for harvest [adj]\n",
  "RIPIDOLITE": "a translucent mineral of the chlorite group, aka clinochlore [n -S]\n",
  "RIPIDOLITES": "RIPIDOLITE, a translucent mineral of the chlorite group, aka clinochlore [n]\n",
  "RIPIENI": "RIPIENO, (Italian) a musical passage performed by all the performers [n]\n",
  "RIPIENIST": "a supplementary instrumentalist [n -S]\n",
  "RIPIENISTS": "RIPIENIST, a supplementary instrumentalist [n]\n",
  "RIPIENO": "(Italian) a musical passage performed by all the performers [n RIPIENOS or RIPIENI]\n",
  "RIPIENOS": "RIPIENO, (Italian) a musical passage performed by all the performers [n]\n",
  "RIPING": "RIPE, to ripen [v]\n",
  "RIPOFF": "a swindle, an excessively high price [n -S]\n",
  "RIPOFFS": "RIPOFF, a swindle, an excessively high price [n]\n",
  "RIPOST": "(French) to make a return thrust in fencing, also RIPOSTE [v -ED, -ING, -S]\n",
  "RIPOSTE": "(French) to make a return thrust in fencing, also RIPOST [v RIPOSTED, RIPOSTING, RIPOSTES]\n",
  "RIPOSTED": "RIPOSTE, (French) to make a return thrust in fencing, also RIPOST [v]\n",
  "RIPOSTES": "RIPOSTE, (French) to make a return thrust in fencing, also RIPOST [v]\n",
  "RIPOSTING": "RIPOSTE, (French) to make a return thrust in fencing, also RIPOST [v]\n",
  "RIPOSTS": "RIPOST, (French) to make a return thrust in fencing, also RIPOSTE [v]\n",
  "RIPP": "(Scots) a plucked handful e.g. of grass, corn [n -S]\n",
  "RIPPABLE": "able to be ripped [adj]\n",
  "RIPPED": "RIP, to tear apart roughly [v]\n",
  "RIPPER": "(obsolete) a person who carries fish inland to sell, also RIPPIER [n -S]\n",
  "RIPPERS": "RIPPER, (obsolete) a person who carries fish inland to sell, also RIPPIER [n]\n",
  "RIPPIER": "(obsolete) a person who carries fish inland to sell, also RIPPER [n -S]\n",
  "RIPPIERS": "RIPPIER, (obsolete) a person who carries fish inland to sell, also RIPPER [n]\n",
  "RIPPING": "excellent [adj RIPPINGLY] / the act of copying a track from a CD [n -S]\n",
  "RIPPINGLY": "RIPPING, excellent [adv]\n",
  "RIPPINGS": "RIPPING, the act of copying a track from a CD [n]\n",
  "RIPPLE": "to form small waves [v RIPPLED, RIPPLING, RIPPLES]\n",
  "RIPPLED": "RIPPLE, to form small waves [v]\n",
  "RIPPLER": "a toothed tool for cleaning waxed fibre [n -S]\n",
  "RIPPLERS": "RIPPLER, a toothed tool for cleaning waxed fibre [n]\n",
  "RIPPLES": "RIPPLE, to form small waves [v]\n",
  "RIPPLET": "a small ripple [n -S]\n",
  "RIPPLETS": "RIPPLET, a small ripple [n]\n",
  "RIPPLIER": "RIPPLY, marked by ripples [adj]\n",
  "RIPPLIEST": "RIPPLY, marked by ripples [adj]\n",
  "RIPPLING": "making ripples [adj RIPPLINGLY] / the act of rippling [n -S]\n",
  "RIPPLINGLY": "RIPPLING, making ripples [adv]\n",
  "RIPPLINGS": "RIPPLING, the act of rippling [n]\n",
  "RIPPLY": "marked by ripples [adj RIPPLIER, RIPPLIEST]\n",
  "RIPPS": "RIPP, (Scots) a plucked handful e.g. of grass, corn [n]\n",
  "RIPRAP": "to strengthen with a foundation of broken stones [v RIPRAPPED, RIPRAPPING, RIPRAPS]\n",
  "RIPRAPPED": "RIPRAP, to strengthen with a foundation of broken stones [v]\n",
  "RIPRAPPING": "RIPRAP, to strengthen with a foundation of broken stones [v]\n",
  "RIPRAPS": "RIPRAP, to strengthen with a foundation of broken stones [v]\n",
  "RIPS": "RIP, to tear apart roughly [v]\n",
  "RIPSAW": "a type of saw [n -S] / to cut with a ripsaw [v RIPSAWED, RIPSAWN, RIPSAWING, RIPSAWS]\n",
  "RIPSAWED": "RIPSAW, to cut with a ripsaw [v]\n",
  "RIPSAWING": "RIPSAW, to cut with a ripsaw [v]\n",
  "RIPSAWN": "RIPSAW, to cut with a ripsaw [v]\n",
  "RIPSAWS": "RIPSAW, to cut with a ripsaw [v]\n",
  "RIPSNORTER": "something extraordinary [n -S]\n",
  "RIPSNORTERS": "RIPSNORTER, something extraordinary [n]\n",
  "RIPSNORTING": "fast and furious, like a ripsnorter [adj RIPSNORTINGLY]\n",
  "RIPSNORTINGLY": "RIPSNORTING, fast and furious, like a ripsnorter [adv]\n",
  "RIPSTOP": "a fabric woven so that small tears do not spread [n -S]\n",
  "RIPSTOPS": "RIPSTOP, a fabric woven so that small tears do not spread [n]\n",
  "RIPT": "RIP, to tear apart roughly [v]\n",
  "RIPTIDE": "a tide that opposes other tides [n -S]\n",
  "RIPTIDES": "RIPTIDE, a tide that opposes other tides [n]\n",
  "RIRORIRO": "(Maori) the grey warbler [n -S]\n",
  "RIRORIROS": "RIRORIRO, (Maori) the grey warbler [n]\n",
  "RISALDAR": "(Urdu) an Indian troop commander, also RESSALDAR [n -S]\n",
  "RISALDARS": "RISALDAR, (Urdu) an Indian troop commander, also RESSALDAR [n]\n",
  "RISE": "to move upward [v ROSE or (US) RIZ, RISEN, RISING, RISES]\n",
  "RISEN": "RISE, to move upward [v]\n",
  "RISER": "a rod securing a stair-carpet [n -S]\n",
  "RISERS": "RISER, a rod securing a stair-carpet [n]\n",
  "RISES": "RISE, to move upward [v]\n",
  "RISHI": "(Sanskrit) a sage or poet [n -S]\n",
  "RISHIS": "RISHI, (Sanskrit) a sage or poet [n]\n",
  "RISIBILITIES": "RISIBILITY, the quality of being risible [n]\n",
  "RISIBILITY": "the quality of being risible [n RISIBILITIES]\n",
  "RISIBLE": "provoking laughter [adj RISIBLY]\n",
  "RISIBLES": "(US) a sense of the ridiculous; a person's sense of humour [n]\n",
  "RISIBLY": "RISIBLE, provoking laughter [adv]\n",
  "RISING": "the act of one that rises [n -S]\n",
  "RISINGS": "RISING, the act of one that rises [n]\n",
  "RISK": "to expose to loss or injury [v -ED, -ING, -S]\n",
  "RISKED": "RISK, to expose to loss or injury [v]\n",
  "RISKER": "one who risks or hazards [n -S]\n",
  "RISKERS": "RISKER, one who risks or hazards [n]\n",
  "RISKFUL": "dangerous, also RISKY [adj]\n",
  "RISKIER": "RISKY, dangerous, also RISKFUL [adj]\n",
  "RISKIEST": "RISKY, dangerous, also RISKFUL [adj]\n",
  "RISKILY": "RISKY, dangerous, also RISKFUL [adv]\n",
  "RISKINESS": "the state of being risky [n -ES]\n",
  "RISKINESSES": "RISKINESS, the state of being risky [n]\n",
  "RISKING": "RISK, to expose to loss or injury [v]\n",
  "RISKLESS": "free of risk [adj]\n",
  "RISKS": "RISK, to expose to loss or injury [v]\n",
  "RISKY": "dangerous, also RISKFUL [adj RISKIER, RISKIEST, RISKILY]\n",
  "RISOLUTO": "(Italian) with emphasis, boldly [adv]\n",
  "RISORGIMENTO": "(Italian) a time of renewal or renaissance; specifically, the 19th century movement for Italian political unity [n -S]\n",
  "RISORGIMENTOS": "RISORGIMENTO, (Italian) a time of renewal or renaissance; specifically, the 19th century movement for Italian political unity [n]\n",
  "RISORII": "RISORIUS, a facial muscle situated at the corner of the mouth [n]\n",
  "RISORIUS": "a facial muscle situated at the corner of the mouth [n RISORII]\n",
  "RISOTTO": "(Italian) rice cooked in broth with grated cheese and seasonings [n -S]\n",
  "RISOTTOS": "RISOTTO, (Italian) rice cooked in broth with grated cheese and seasonings [n]\n",
  "RISP": "(Scots) to rasp, grate [v -ED, -ING, -S]\n",
  "RISPED": "RISP, (Scots) to rasp, grate [v]\n",
  "RISPETTI": "RISPETTO, (Italian) a type of Italian folksong with 8-line stanzas [n]\n",
  "RISPETTO": "(Italian) a type of Italian folksong with 8-line stanzas [n RISPETTI]\n",
  "RISPING": "a portion grated off [n -S]\n",
  "RISPINGS": "RISPING, a portion grated off [n]\n",
  "RISPS": "RISP, (Scots) to rasp, grate [v]\n",
  "RISQUE": "(French) a hazard or danger [n -S]\n",
  "RISQUES": "RISQUE, (French) a hazard or danger [n]\n",
  "RISSOLE": "(French) a small ball filled with meat or fish [n -S]\n",
  "RISSOLES": "RISSOLE, (French) a small ball filled with meat or fish [n]\n",
  "RISTRA": "a string of dried chili peppers [n -S]\n",
  "RISTRAS": "RISTRA, a string of dried chili peppers [n]\n",
  "RISTRETTO": "(Italian) a very strong espresso coffee [n -S]\n",
  "RISTRETTOS": "RISTRETTO, (Italian) a very strong espresso coffee [n]\n",
  "RISUS": "(Latin) a laugh; a grin [n -ES]\n",
  "RISUSES": "RISUS, (Latin) a laugh; a grin [n]\n",
  "RIT": "(Scots) to scratch, score, also RITT [v RITTED, RITTING, RITS]\n",
  "RITARD": "(Italian) a musical passage with a gradual slackening of tempo, also RITARDANDO [n -S]\n",
  "RITARDANDI": "RITARDANDO, (Italian) a musical passage with a gradual slackening of tempo, also RITARD [n]\n",
  "RITARDANDO": "(Italian) a musical passage with a gradual slackening of tempo, also RITARD [n RITARDANDI or RITARDANDOS]\n",
  "RITARDANDOS": "RITARDANDO, (Italian) a musical passage with a gradual slackening of tempo, also RITARD [n]\n",
  "RITARDS": "RITARD, (Italian) a musical passage with a gradual slackening of tempo, also RITARDANDO [n]\n",
  "RITE": "a ceremonial act or procedure [n -S]\n",
  "RITELESS": "without rites [adj]\n",
  "RITENUTO": "(Italian) a musical passage with a held back tempo [n -S]\n",
  "RITENUTOS": "RITENUTO, (Italian) a musical passage with a held back tempo [n]\n",
  "RITES": "RITE, a ceremonial act or procedure [n]\n",
  "RITONAVIR": "a drug used to treat HIV [n -S]\n",
  "RITONAVIRS": "RITONAVIR, a drug used to treat HIV [n]\n",
  "RITORNEL": "a short instrumental passage in a vocal work, also RITORNELL, RITORNELLE, RITORNELLO, RITOURNELLE [n -S]\n",
  "RITORNELL": "a short instrumental passage in a vocal work, also RITORNEL, RITORNELLE, RITORNELLO, RITOURNELLE [n -S]\n",
  "RITORNELLE": "(French) a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLO, RITOURNELLE [n -S]\n",
  "RITORNELLES": "RITORNELLE, (French) a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLO, RITOURNELLE [n]\n",
  "RITORNELLI": "RITORNELLO, a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLE, RITOURNELLE [n]\n",
  "RITORNELLO": "a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLE, RITOURNELLE [n RITORNELLOS or RITORNELLI]\n",
  "RITORNELLOS": "RITORNELLO, a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLE, RITOURNELLE [n]\n",
  "RITORNELLS": "RITORNELL, a short instrumental passage in a vocal work, also RITORNEL, RITORNELLE, RITORNELLO, RITOURNELLE [n]\n",
  "RITORNELS": "RITORNEL, a short instrumental passage in a vocal work, also RITORNELL, RITORNELLE, RITORNELLO, RITOURNELLE [n]\n",
  "RITOURNELLE": "(French) a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLE, RITORNELLO [n -S]\n",
  "RITOURNELLES": "RITOURNELLE, (French) a short instrumental passage in a vocal work, also RITORNEL, RITORNELL, RITORNELLE, RITORNELLO [n]\n",
  "RITS": "RIT, (Scots) to scratch, score, also RITT [v]\n",
  "RITT": "(Scots) to score or scratch, also RIT [v -ED, -ING, -S]\n",
  "RITTED": "RIT, (Scots) to scratch, score, also RITT [v]\n",
  "RITTER": "(German) a German or Austrian knight or mounted warrior [n -S]\n",
  "RITTERS": "RITTER, (German) a German or Austrian knight or mounted warrior [n]\n",
  "RITTING": "RIT, (Scots) to scratch, score, also RITT [v]\n",
  "RITTS": "RITT, (Scots) to score or scratch, also RIT [v]\n",
  "RITUAL": "according to rite [adj RITUALLY] / a system of rites [n -S]\n",
  "RITUALISATION": "the act of ritualising, also RITUALIZATION [n -S]\n",
  "RITUALISATIONS": "RITUALISATION, the act of ritualising, also RITUALIZATION [n]\n",
  "RITUALISE": "to make into a ritual, also RITUALIZE [v RITUALISED, RITUALISING, RITUALISES]\n",
  "RITUALISED": "RITUALISE, to make into a ritual, also RITUALIZE [v]\n",
  "RITUALISES": "RITUALISE, to make into a ritual, also RITUALIZE [v]\n",
  "RITUALISING": "RITUALISE, to make into a ritual, also RITUALIZE [v]\n",
  "RITUALISM": "regular observance or practice of ritual [n -S]\n",
  "RITUALISMS": "RITUALISM, regular observance or practice of ritual [n]\n",
  "RITUALIST": "a believer in ritual [n -S]\n",
  "RITUALISTIC": "relating to ritualism [adj RITUALISTICALLY]\n",
  "RITUALISTICALLY": "RITUALISTIC, relating to ritualism [adv]\n",
  "RITUALISTS": "RITUALIST, a believer in ritual [n]\n",
  "RITUALIZATION": "the act of ritualizing, also RITUALISATION [n -S]\n",
  "RITUALIZATIONS": "RITUALIZATION, the act of ritualizing, also RITUALISATION [n]\n",
  "RITUALIZE": "to make into a ritual, also RITUALISE [v RITUALIZED, RITUALIZING, RITUALIZES]\n",
  "RITUALIZED": "RITUALIZE, to make into a ritual, also RITUALISE [v]\n",
  "RITUALIZES": "RITUALIZE, to make into a ritual, also RITUALISE [v]\n",
  "RITUALIZING": "RITUALIZE, to make into a ritual, also RITUALISE [v]\n",
  "RITUALLY": "RITUAL, according to rite [adv]\n",
  "RITUALS": "RITUAL, a system of rites [n]\n",
  "RITUXIMAB": "a drug used in the treatment of B cell non-Hodgkin's lymphoma [n -S]\n",
  "RITUXIMABS": "RITUXIMAB, a drug used in the treatment of B cell non-Hodgkin's lymphoma [n]\n",
  "RITZ": "pretentious display [n -ES]\n",
  "RITZES": "RITZ, pretentious display [n]\n",
  "RITZIER": "RITZY, pretentious [adj]\n",
  "RITZIEST": "RITZY, pretentious [adj]\n",
  "RITZILY": "RITZY, pretentious [adv]\n",
  "RITZINESS": "being ritzy [n -ES]\n",
  "RITZINESSES": "RITZINESS, being ritzy [n]\n",
  "RITZY": "pretentious [adj RITZIER, RITZIEST, RITZILY]\n",
  "RIVA": "(Old Norse) in Shetland, a cleft in rock [n -S]\n",
  "RIVAGE": "(French) a shore, bank [n -S]\n",
  "RIVAGES": "RIVAGE, (French) a shore, bank [n]\n",
  "RIVAL": "to strive to equal or surpass [v RIVALLED or RIVALED, RIVALLING or RIVALING, RIVALS]\n",
  "RIVALED": "RIVAL, to strive to equal or surpass [v]\n",
  "RIVALESS": "(archaic) a female rival [n -ES]\n",
  "RIVALESSES": "RIVALESS, (archaic) a female rival [n]\n",
  "RIVALING": "RIVAL, to strive to equal or surpass [v]\n",
  "RIVALISE": "to enter into rivalry, also RIVALIZE [v RIVALISED, RIVALISING, RIVALISES]\n",
  "RIVALISED": "RIVALISE, to enter into rivalry, also RIVALIZE [v]\n",
  "RIVALISES": "RIVALISE, to enter into rivalry, also RIVALIZE [v]\n",
  "RIVALISING": "RIVALISE, to enter into rivalry, also RIVALIZE [v]\n",
  "RIVALITIES": "RIVALITY, competition, also RIVALRY [n]\n",
  "RIVALITY": "competition, also RIVALRY [n RIVALITIES]\n",
  "RIVALIZE": "to enter into rivalry, also RIVALISE [v RIVALIZED, RIVALIZING, RIVALIZES]\n",
  "RIVALIZED": "RIVALIZE, to enter into rivalry, also RIVALISE [v]\n",
  "RIVALIZES": "RIVALIZE, to enter into rivalry, also RIVALISE [v]\n",
  "RIVALIZING": "RIVALIZE, to enter into rivalry, also RIVALISE [v]\n",
  "RIVALLED": "RIVAL, to strive to equal or surpass [v]\n",
  "RIVALLESS": "without rivals [adj]\n",
  "RIVALLING": "RIVAL, to strive to equal or surpass [v]\n",
  "RIVALRIES": "RIVALRY, competition, also RIVALITY [n]\n",
  "RIVALROUS": "relating to rivalry [adj]\n",
  "RIVALRY": "competition, also RIVALITY [n RIVALRIES]\n",
  "RIVALS": "RIVAL, to strive to equal or surpass [v]\n",
  "RIVALSHIP": "rivalry [n -S]\n",
  "RIVALSHIPS": "RIVALSHIP, rivalry [n]\n",
  "RIVAS": "RIVA, (Old Norse) in Shetland, a cleft in rock [n]\n",
  "RIVE": "to tear apart [v RIVED or RIFTE, RIFTE or RIVEN or YRIVD, RIVING, RIVES]\n",
  "RIVED": "RIVE, to tear apart [v]\n",
  "RIVEL": "to wrinkle [v RIVELLED, RIVELLING, RIVELS]\n",
  "RIVELLED": "RIVEL, to wrinkle [v]\n",
  "RIVELLING": "RIVEL, to wrinkle [v]\n",
  "RIVELS": "RIVEL, to wrinkle [v]\n",
  "RIVEN": "RIVE, to tear apart [v]\n",
  "RIVER": "a large natural stream of water [n -S]\n",
  "RIVERAIN": "(French) a riverside dweller [n -S]\n",
  "RIVERAINS": "RIVERAIN, (French) a riverside dweller [n]\n",
  "RIVERBANK": "the bank of a river [n -S]\n",
  "RIVERBANKS": "RIVERBANK, the bank of a river [n]\n",
  "RIVERBED": "the area covered by a river [n -S]\n",
  "RIVERBEDS": "RIVERBED, the area covered by a river [n]\n",
  "RIVERBOAT": "a boat used for river transport [n -S]\n",
  "RIVERBOATS": "RIVERBOAT, a boat used for river transport [n]\n",
  "RIVERCRAFT": "a craft suitable for use on a river [n -S]\n",
  "RIVERCRAFTS": "RIVERCRAFT, a craft suitable for use on a river [n]\n",
  "RIVERED": "watered by rivers [adj]\n",
  "RIVERET": "(archaic) a small river [n -S]\n",
  "RIVERETS": "RIVERET, (archaic) a small river [n]\n",
  "RIVERFRONT": "the land or area along a river [n -S]\n",
  "RIVERFRONTS": "RIVERFRONT, the land or area along a river [n]\n",
  "RIVERHEAD": "the source of a river [n -S]\n",
  "RIVERHEADS": "RIVERHEAD, the source of a river [n]\n",
  "RIVERIER": "RIVERY, like a river; full of rivers [adj]\n",
  "RIVERIEST": "RIVERY, like a river; full of rivers [adj]\n",
  "RIVERINE": "pertaining to a river, located on the banks of a river [adj]\n",
  "RIVERLESS": "without rivers [adj]\n",
  "RIVERLIKE": "like a river [adj]\n",
  "RIVERMAN": "a man who works on a river [n RIVERMEN]\n",
  "RIVERMEN": "RIVERMAN, a man who works on a river [n]\n",
  "RIVERS": "RIVER, a large natural stream of water [n]\n",
  "RIVERSCAPE": "a view of a river [n -S]\n",
  "RIVERSCAPES": "RIVERSCAPE, a view of a river [n]\n",
  "RIVERSIDE": "the area at the side of a river [n -S]\n",
  "RIVERSIDES": "RIVERSIDE, the area at the side of a river [n]\n",
  "RIVERWALK": "a walk beside a river [n -S]\n",
  "RIVERWALKS": "RIVERWALK, a walk beside a river [n]\n",
  "RIVERWARD": "towards a river, also RIVERWARDS [adv]\n",
  "RIVERWARDS": "towards a river, also RIVERWARD [adv]\n",
  "RIVERWAY": "a river as a waterway [n -S]\n",
  "RIVERWAYS": "RIVERWAY, a river as a waterway [n]\n",
  "RIVERWEED": "any plant of the genus Podostemon [n -S]\n",
  "RIVERWEEDS": "RIVERWEED, any plant of the genus Podostemon [n]\n",
  "RIVERWORTHIER": "RIVERWORTHY, able to be used on a river [adj]\n",
  "RIVERWORTHIEST": "RIVERWORTHY, able to be used on a river [adj]\n",
  "RIVERWORTHINESS": "the state of being riverworthy [n]\n",
  "RIVERWORTHY": "able to be used on a river [adj RIVERWORTHIER, RIVERWORTHIEST]\n",
  "RIVERY": "like a river; full of rivers [adj RIVERIER, RIVERIEST]\n",
  "RIVES": "RIVE, to tear apart [v]\n",
  "RIVET": "to fasten with a type of metal bolt [v RIVETTED or RIVETED, RIVETTING or RIVETING, RIVETS]\n",
  "RIVETED": "RIVET, to fasten with a type of metal bolt [v]\n",
  "RIVETER": "one who rivets [n -S]\n",
  "RIVETERS": "RIVETER, one who rivets [n]\n",
  "RIVETING": "the act of riveting [n -S]\n",
  "RIVETINGLY": "RIVETING [adv]\n",
  "RIVETINGS": "RIVETING, the act of riveting [n]\n",
  "RIVETS": "RIVET, to fasten with a type of metal bolt [v]\n",
  "RIVETTED": "RIVET, to fasten with a type of metal bolt [v]\n",
  "RIVETTING": "RIVET, to fasten with a type of metal bolt [v]\n",
  "RIVIERA": "(Italian) a warm coastal district [n -S]\n",
  "RIVIERAS": "RIVIERA, (Italian) a warm coastal district [n]\n",
  "RIVIERE": "(French) a necklace of precious stones [n -S]\n",
  "RIVIERES": "RIVIERE, (French) a necklace of precious stones [n]\n",
  "RIVING": "RIVE, to tear apart [v]\n",
  "RIVLIN": "(Scots) a shoe moulded from untanned hide [n -S]\n",
  "RIVLINS": "RIVLIN, (Scots) a shoe moulded from untanned hide [n]\n",
  "RIVO": "(Shakespeare) a drinking cry [interj]\n",
  "RIVULET": "a small stream [n -S]\n",
  "RIVULETS": "RIVULET, a small stream [n]\n",
  "RIVULOSE": "having narrow, winding lines [adj]\n",
  "RIVULUS": "a small tropical American fish [n -ES]\n",
  "RIVULUSES": "RIVULUS, a small tropical American fish [n]\n",
  "RIYAL": "a monetary unit of Saudi Arabia [n -S]\n",
  "RIYALS": "RIYAL, a monetary unit of Saudi Arabia [n]\n",
  "RIZ": "RISE, to move upward [v]\n",
  "RIZA": "(Russian) an ornamental silver plate covering a Russian icon [n -S]\n",
  "RIZARD": "(Scots) a redcurrant, also RIZZAR, RIZZART, RIZZER, RIZZOR [n -S]\n",
  "RIZARDS": "RIZARD, (Scots) a redcurrant, also RIZZAR, RIZZART, RIZZER, RIZZOR [n]\n",
  "RIZAS": "RIZA, (Russian) an ornamental silver plate covering a Russian icon [n]\n",
  "RIZZAR": "(Scots) to dry in the sun, also RIZZER, RIZZOR [v -ED, -ING, -S]\n",
  "RIZZARED": "RIZZAR, (Scots) to dry in the sun, also RIZZER, RIZZOR [v]\n",
  "RIZZARING": "RIZZAR, (Scots) to dry in the sun, also RIZZER, RIZZOR [v]\n",
  "RIZZARS": "RIZZAR, (Scots) to dry in the sun, also RIZZER, RIZZOR [v]\n",
  "RIZZART": "(Scots) a redcurrant, also RIZARD, RIZZAR, RIZZER, RIZZOR [n -S]\n",
  "RIZZARTS": "RIZZART, (Scots) a redcurrant, also RIZARD, RIZZAR, RIZZER, RIZZOR [n]\n",
  "RIZZER": "(Scots) to dry in the sun, also RIZZAR, RIZZOR [v -ED, -ING, -S]\n",
  "RIZZERED": "RIZZER, (Scots) to dry in the sun, also RIZZAR, RIZZOR [v]\n",
  "RIZZERING": "RIZZER, (Scots) to dry in the sun, also RIZZAR, RIZZOR [v]\n",
  "RIZZERS": "RIZZER, (Scots) to dry in the sun, also RIZZAR, RIZZOR [v]\n",
  "RIZZOR": "(Scots) to dry in the sun, also RIZZAR, RIZZER [v -ED, -ING, -S]\n",
  "RIZZORED": "RIZZOR, (Scots) to dry in the sun, also RIZZAR, RIZZER [v]\n",
  "RIZZORING": "RIZZOR, (Scots) to dry in the sun, also RIZZAR, RIZZER [v]\n",
  "RIZZORS": "RIZZOR, (Scots) to dry in the sun, also RIZZAR, RIZZER [v]\n",
  "ROACH": "to clip or trim (a horse's mane) short so that the hair stands on end [v -ED, -ING, -ES]\n",
  "ROACHED": "ROACH, to clip or trim (a horse's mane) short so that the hair stands on end [v]\n",
  "ROACHES": "ROACH, to clip or trim (a horse's mane) short so that the hair stands on end [v]\n",
  "ROACHING": "ROACH, to clip or trim (a horse's mane) short so that the hair stands on end [v]\n",
  "ROAD": "a way for public transport [n -S]\n",
  "ROADABILITIES": "ROADABILITY, the qualities, such as steadiness and balance, desirable in an automobile on the road [n]\n",
  "ROADABILITY": "the qualities, such as steadiness and balance, desirable in an automobile on the road [n ROADABILITIES]\n",
  "ROADBED": "the foundation for a railroad track [n -S]\n",
  "ROADBEDS": "ROADBED, the foundation for a railroad track [n]\n",
  "ROADBLOCK": "a barrier across a road [n -S] / to bar by means of a roadblock [v -ED, -ING, -S]\n",
  "ROADBLOCKED": "ROADBLOCK, to bar by means of a roadblock [v]\n",
  "ROADBLOCKING": "ROADBLOCK, to bar by means of a roadblock [v]\n",
  "ROADBLOCKS": "ROADBLOCK, to bar by means of a roadblock [v]\n",
  "ROADCRAFT": "knowledge and skill useful to road users [n -S]\n",
  "ROADCRAFTS": "ROADCRAFT, knowledge and skill useful to road users [n]\n",
  "ROADEO": "a competition for truck drivers [n -S]\n",
  "ROADEOS": "ROADEO, a competition for truck drivers [n]\n",
  "ROADHEADER": "a tunnelling machine used in mining that excavates with a combination of cutting blades and high-pressure water jets [n -S]\n",
  "ROADHEADERS": "ROADHEADER, a tunnelling machine used in mining that excavates with a combination of cutting blades and high-pressure water jets [n]\n",
  "ROADHOG": "a selfish or aggressive driver [n -S]\n",
  "ROADHOGS": "ROADHOG, a selfish or aggressive driver [n]\n",
  "ROADHOLDING": "the qualities of an automobile that tend to make it respond precisely to the driver's steering [n -S]\n",
  "ROADHOLDINGS": "ROADHOLDING, the qualities of an automobile that tend to make it respond precisely to the driver's steering [n]\n",
  "ROADHOUSE": "a roadside public house [n -S]\n",
  "ROADHOUSES": "ROADHOUSE, a roadside public house [n]\n",
  "ROADIE": "a person who works for travelling entertainers [n -S]\n",
  "ROADIES": "ROADIE, a person who works for travelling entertainers [n]\n",
  "ROADING": "a woodcock's evening flight, also RODING [n -S]\n",
  "ROADINGS": "ROADING, a woodcock's evening flight, also RODING [n]\n",
  "ROADKILL": "an animal that has been killed on the road [n -S]\n",
  "ROADKILLS": "ROADKILL, an animal that has been killed on the road [n]\n",
  "ROADLESS": "without a road [adj]\n",
  "ROADMAKING": "road building [n -S]\n",
  "ROADMAKINGS": "ROADMAKING, road building [n]\n",
  "ROADMAN": "one who works making or repairing roads, also ROADSMAN [n ROADMEN]\n",
  "ROADMEN": "ROADMAN, one who works making or repairing roads, also ROADSMAN [n]\n",
  "ROADMENDER": "one whose job is to repair roads [n -S]\n",
  "ROADMENDERS": "ROADMENDER, one whose job is to repair roads [n]\n",
  "ROADROLLER": "a motor vehicle with heavy rollers for compressing road surfaces during roadmaking [n -S]\n",
  "ROADROLLERS": "ROADROLLER, a motor vehicle with heavy rollers for compressing road surfaces during roadmaking [n]\n",
  "ROADRUNNER": "a bird of the turkey family, aka the chaparral cock [n -S]\n",
  "ROADRUNNERS": "ROADRUNNER, a bird of the turkey family, aka the chaparral cock [n]\n",
  "ROADS": "ROAD, a way for public transport [n]\n",
  "ROADSHOW": "a touring group of theatrical or musical performers [n -S]\n",
  "ROADSHOWS": "ROADSHOW, a touring group of theatrical or musical performers [n]\n",
  "ROADSIDE": "land adjoining a road or highway [n -S]\n",
  "ROADSIDES": "ROADSIDE, land adjoining a road or highway [n]\n",
  "ROADSMAN": "one who works making or repairing roads, also ROADMAN [n ROADSMEN]\n",
  "ROADSMEN": "ROADSMAN, one who works making or repairing roads, also ROADMAN [n]\n",
  "ROADSTEAD": "an anchorage off shore [n -S]\n",
  "ROADSTEADS": "ROADSTEAD, an anchorage off shore [n]\n",
  "ROADSTER": "a light, open automobile [n -S]\n",
  "ROADSTERS": "ROADSTER, a light, open automobile [n]\n",
  "ROADWAY": "a road, also RODEWAY [n -S]\n",
  "ROADWAYS": "ROADWAY, a road, also RODEWAY [n]\n",
  "ROADWORK": "outdoor running as a form of physical exercise [n -S]\n",
  "ROADWORKS": "ROADWORK, outdoor running as a form of physical exercise [n]\n",
  "ROADWORTHIER": "ROADWORTHY, able to be used on a road [adj]\n",
  "ROADWORTHIES": "ROADWORTHY, in South Africa, a certificate for a roadworthy vehicle [n]\n",
  "ROADWORTHIEST": "ROADWORTHY, able to be used on a road [adj]\n",
  "ROADWORTHINESS": "the state of being roadworthy [n]\n",
  "ROADWORTHY": "able to be used on a road [adj ROADWORTHIER, ROADWORTHIEST] / in South Africa, a certificate for a roadworthy vehicle [n ROADWORTHIES]\n",
  "ROAM": "to move about without purpose or plan [v -ED, -ING, -S]\n",
  "ROAMED": "ROAM, to move about without purpose or plan [v]\n",
  "ROAMER": "one who roams, a wanderer [n -S]\n",
  "ROAMERS": "ROAMER, one who roams, a wanderer [n]\n",
  "ROAMING": "the act of roaming [n -S]\n",
  "ROAMINGS": "ROAMING, the act of roaming [n]\n",
  "ROAMS": "ROAM, to move about without purpose or plan [v]\n",
  "ROAN": "(Scots) a roof-gutter, also RHONE, ROANPIPE, RONE, RONEPIPE [n -S]\n",
  "ROANPIPE": "(Scots) a roof-gutter, also RHONE, ROAN, RONE, RONEPIPE [n -S]\n",
  "ROANPIPES": "ROANPIPE, (Scots) a roof-gutter, also RHONE, ROAN, RONE, RONEPIPE [n]\n",
  "ROANS": "ROAN, (Scots) a roof-gutter, also RHONE, ROANPIPE, RONE, RONEPIPE [n]\n",
  "ROAR": "to utter a full, loud sound of a lion [v -ED, -ING, -S]\n",
  "ROARED": "ROAR, to utter a full, loud sound of a lion [v]\n",
  "ROARER": "one who roars [n -S]\n",
  "ROARERS": "ROARER, one who roars [n]\n",
  "ROARIE": "(Scots) noisy, garish, too bright, also ROARY, RORIE, RORY [adj ROARIER, ROARIEST]\n",
  "ROARIER": "ROARY, noisy, garish, too bright, also ROARIE, RORIE, RORY [adj]\n",
  "ROARIEST": "ROARY, noisy, garish, too bright, also ROARIE, RORIE, RORY [adj]\n",
  "ROARING": "proceeding with very great activity or success [adj ROARINGLY] / the act of roaring [n -S]\n",
  "ROARINGLY": "ROARING, proceeding with very great activity or success [adv]\n",
  "ROARINGS": "ROARING, the act of roaring [n]\n",
  "ROARMING": "(dialect) severe, as in a roarming cold [adj]\n",
  "ROARS": "ROAR, to utter a full, loud sound of a lion [v]\n",
  "ROARY": "noisy, garish, too bright, also ROARIE, RORIE, RORY [adj ROARIER, ROARIEST]\n",
  "ROAST": "to cook with dry heat [v -ED, -ING, -S]\n",
  "ROASTED": "ROAST, to cook with dry heat [v]\n",
  "ROASTER": "a pan or dish in which meat etc. may be roasted [n -S]\n",
  "ROASTERS": "ROASTER, a pan or dish in which meat etc. may be roasted [n]\n",
  "ROASTIE": "(colloquial) a roast potato [n -S]\n",
  "ROASTIES": "ROASTIE, (colloquial) a roast potato [n]\n",
  "ROASTING": "a scolding [n -S]\n",
  "ROASTINGS": "ROASTING, a scolding [n]\n",
  "ROASTS": "ROAST, to cook with dry heat [v]\n",
  "ROATE": "(Shakespeare) to learn by repetition, also ROTE [v ROATED, ROATING, ROATES]\n",
  "ROATED": "ROATE, (Shakespeare) to learn by repetition, also ROTE [v]\n",
  "ROATES": "ROATE, (Shakespeare) to learn by repetition, also ROTE [v]\n",
  "ROATING": "ROATE, (Shakespeare) to learn by repetition, also ROTE [v]\n",
  "ROB": "to steal [v ROBBED, ROBBING, ROBS]\n",
  "ROBALO": "(Spanish) a kind of marine fish [n -S]\n",
  "ROBALOS": "ROBALO, (Spanish) a kind of marine fish [n]\n",
  "ROBAND": "a piece of yarn used to fasten a sail to a spar [n -S]\n",
  "ROBANDS": "ROBAND, a piece of yarn used to fasten a sail to a spar [n]\n",
  "ROBATA": "(Japanese) a grill used for Japanese cooking [n -S]\n",
  "ROBATAS": "ROBATA, (Japanese) a grill used for Japanese cooking [n]\n",
  "ROBBED": "ROB, to steal [v]\n",
  "ROBBER": "one that robs [n -S]\n",
  "ROBBERIES": "ROBBERY, the act of one who robs [n]\n",
  "ROBBERS": "ROBBER, one that robs [n]\n",
  "ROBBERY": "the act of one who robs [n ROBBERIES]\n",
  "ROBBIN": "a kind of package in which pepper and other dry commodities are sometimes exported from the East Indies [n -S]\n",
  "ROBBING": "ROB, to steal [v]\n",
  "ROBBINS": "ROBBIN, a kind of package in which pepper and other dry commodities are sometimes exported from the East Indies [n]\n",
  "ROBE": "to dress [v ROBED, ROBING, ROBES]\n",
  "ROBED": "ROBE, to dress [v]\n",
  "ROBELIKE": "like a robe [adj]\n",
  "ROBERDSMAN": "(obsolete) a stout robber, also ROBERTSMAN [n ROBERDSMEN]\n",
  "ROBERDSMEN": "ROBERDSMAN, (obsolete) a stout robber, also ROBERTSMAN [n]\n",
  "ROBERTSMAN": "(obsolete) a stout robber, also ROBERDSMAN [n ROBERTSMEN]\n",
  "ROBERTSMEN": "ROBERTSMAN, (obsolete) a stout robber, also ROBERDSMAN [n]\n",
  "ROBES": "ROBE, to dress [v]\n",
  "ROBIN": "a songbird [n -S]\n",
  "ROBING": "the putting on of clothes [n -S]\n",
  "ROBINGS": "ROBING, the putting on of clothes [n]\n",
  "ROBINIA": "a genus of leguminous trees including the common locust of North America [n -S]\n",
  "ROBINIAS": "ROBINIA, a genus of leguminous trees including the common locust of North America [n]\n",
  "ROBINS": "ROBIN, a songbird [n]\n",
  "ROBLE": "(Spanish) a name for various species of oak [n -S]\n",
  "ROBLES": "ROBLE, (Spanish) a name for various species of oak [n]\n",
  "ROBOCALL": "a telephone call from an automated source that delivers a prerecorded message to a large number of people [n -S]\n",
  "ROBOCALLS": "ROBOCALL, a telephone call from an automated source that delivers a prerecorded message to a large number of people [n]\n",
  "ROBORANT": "an invigorating drug [n -S]\n",
  "ROBORANTS": "ROBORANT, an invigorating drug [n]\n",
  "ROBORATING": "restoring vigor or strength, also ROBORANT [adj]\n",
  "ROBOT": "a humanlike machine that performs various functions [n -S]\n",
  "ROBOTIC": "relating to a robot [adj ROBOTICALLY]\n",
  "ROBOTICALLY": "ROBOTIC, relating to a robot [adv]\n",
  "ROBOTICS": "the study of robots [n]\n",
  "ROBOTISATION": "the act of causing a job to be done by robots, also ROBOTIZATION [n -S]\n",
  "ROBOTISATIONS": "ROBOTISATION, the act of causing a job to be done by robots, also ROBOTIZATION [n]\n",
  "ROBOTISE": "to make automatic, also ROBOTIZE [v ROBOTISED, ROBOTISING, ROBOTISES]\n",
  "ROBOTISED": "ROBOTISE, to make automatic, also ROBOTIZE [v]\n",
  "ROBOTISES": "ROBOTISE, to make automatic, also ROBOTIZE [v]\n",
  "ROBOTISING": "ROBOTISE, to make automatic, also ROBOTIZE [v]\n",
  "ROBOTISM": "the state of being a robot [n -S]\n",
  "ROBOTISMS": "ROBOTISM, the state of being a robot [n]\n",
  "ROBOTIZATION": "the act of causing a job to be done by robots, also ROBOTISATION [n -S]\n",
  "ROBOTIZATIONS": "ROBOTIZATION, the act of causing a job to be done by robots, also ROBOTISATION [n]\n",
  "ROBOTIZE": "to make automatic, also ROBOTISE [v ROBOTIZED, ROBOTIZING, ROBOTIZES]\n",
  "ROBOTIZED": "ROBOTIZE, to make automatic, also ROBOTISE [v]\n",
  "ROBOTIZES": "ROBOTIZE, to make automatic, also ROBOTISE [v]\n",
  "ROBOTIZING": "ROBOTIZE, to make automatic, also ROBOTISE [v]\n",
  "ROBOTRIES": "ROBOTRY, the science of robots [n]\n",
  "ROBOTRY": "the science of robots [n ROBOTRIES]\n",
  "ROBOTS": "ROBOT, a humanlike machine that performs various functions [n]\n",
  "ROBS": "ROB, to steal [v]\n",
  "ROBURITE": "a flameless explosive [n -S]\n",
  "ROBURITES": "ROBURITE, a flameless explosive [n]\n",
  "ROBUST": "strong and healthy [adj ROBUSTER, ROBUSTEST, ROBUSTLY]\n",
  "ROBUSTA": "a kind of coffee grown in Africa [n -S]\n",
  "ROBUSTAS": "ROBUSTA, a kind of coffee grown in Africa [n]\n",
  "ROBUSTER": "ROBUST, strong and healthy [adj]\n",
  "ROBUSTEST": "ROBUST, strong and healthy [adj]\n",
  "ROBUSTIOUS": "boisterous [adj ROBUSTIOUSLY]\n",
  "ROBUSTIOUSLY": "ROBUSTIOUS, boisterous [adv]\n",
  "ROBUSTIOUSNESS": "the state of being robustious, robust [n]\n",
  "ROBUSTLY": "ROBUST, strong and healthy [adv]\n",
  "ROBUSTNESS": "the state of being robust [n -ES]\n",
  "ROBUSTNESSES": "ROBUSTNESS, the state of being robust [n]\n",
  "ROC": "an enormous bird of Arabian legend, also ROK, RUC, RUKH [n -S]\n",
  "ROCAILLE": "(French) artificial rockwork or similar ornament [n -S]\n",
  "ROCAILLES": "ROCAILLE, (French) artificial rockwork or similar ornament [n]\n",
  "ROCAMBOLE": "(French) a plant closely related to garlic [n -S]\n",
  "ROCAMBOLES": "ROCAMBOLE, (French) a plant closely related to garlic [n]\n",
  "ROCH": "the little auk, also ROTCH, ROTCHE, ROTCHIE [n -ES]\n",
  "ROCHES": "ROCH, the little auk, also ROTCH, ROTCHE, ROTCHIE [n]\n",
  "ROCHET": "a close-fitting surplice-like vestment worn by bishops and abbots, also ROCQUET, ROQUET [n -S]\n",
  "ROCHETS": "ROCHET, a close-fitting surplice-like vestment worn by bishops and abbots, also ROCQUET, ROQUET [n]\n",
  "ROCK": "to move back and forth [v -ED, -ING, -S]\n",
  "ROCKABIES": "ROCKABY, a song used to lull children to sleep, also ROCKABYE [n]\n",
  "ROCKABILLIES": "ROCKABILLY, a form of rock-and-roll music with elements of hillbilly [n]\n",
  "ROCKABILLY": "a form of rock-and-roll music with elements of hillbilly [n ROCKABILLIES]\n",
  "ROCKABLE": "able to be rocked [adj]\n",
  "ROCKABY": "a song used to lull children to sleep, also ROCKABYE [n ROCKABIES]\n",
  "ROCKABYE": "a song used to lull children to sleep, also ROCKABY [n -S]\n",
  "ROCKABYES": "ROCKABYE, a song used to lull children to sleep, also ROCKABY [n]\n",
  "ROCKAWAY": "a light four-wheeled carriage with fixed top and open sides [n -S]\n",
  "ROCKAWAYS": "ROCKAWAY, a light four-wheeled carriage with fixed top and open sides [n]\n",
  "ROCKBOUND": "hemmed in by rock, rocky [adj]\n",
  "ROCKBURST": "a sudden, violent rupture or collapse of highly stressed rock in a mine [n -S]\n",
  "ROCKBURSTS": "ROCKBURST, a sudden, violent rupture or collapse of highly stressed rock in a mine [n]\n",
  "ROCKCRESS": "another name for the plant arabis [n -ES]\n",
  "ROCKCRESSES": "ROCKCRESS, another name for the plant arabis [n]\n",
  "ROCKED": "ROCK, to move back and forth [v]\n",
  "ROCKER": "the rock dove, also ROCKIER [n -S]\n",
  "ROCKERIES": "ROCKERY, a rock garden [n]\n",
  "ROCKERS": "ROCKER, the rock dove, also ROCKIER [n]\n",
  "ROCKERY": "a rock garden [n ROCKERIES]\n",
  "ROCKET": "to be projected by the backward jet thrust of hot gases [v -ED, -ING, -S]\n",
  "ROCKETED": "ROCKET, to be projected by the backward jet thrust of hot gases [v]\n",
  "ROCKETEER": "a person who experiments or works with rockets [n -S]\n",
  "ROCKETEERS": "ROCKETEER, a person who experiments or works with rockets [n]\n",
  "ROCKETER": "a bird, esp. a pheasant, which, being flushed, rises straight in the air like a rocket [n -S]\n",
  "ROCKETERS": "ROCKETER, a bird, esp. a pheasant, which, being flushed, rises straight in the air like a rocket [n]\n",
  "ROCKETING": "ROCKET, to be projected by the backward jet thrust of hot gases [v]\n",
  "ROCKETRIES": "ROCKETRY, the science of rockets [n]\n",
  "ROCKETRY": "the science of rockets [n ROCKETRIES]\n",
  "ROCKETS": "ROCKET, to be projected by the backward jet thrust of hot gases [v]\n",
  "ROCKETSONDE": "a sonde carried up by rocket [n -S]\n",
  "ROCKETSONDES": "ROCKETSONDE, a sonde carried up by rocket [n]\n",
  "ROCKFALL": "a mass of fallen rocks [n -S]\n",
  "ROCKFALLS": "ROCKFALL, a mass of fallen rocks [n]\n",
  "ROCKFISH": "a fish living around rocks [n -ES]\n",
  "ROCKFISHES": "ROCKFISH, a fish living around rocks [n]\n",
  "ROCKHOPPER": "a crested penguin [n -S]\n",
  "ROCKHOPPERS": "ROCKHOPPER, a crested penguin [n]\n",
  "ROCKHOUND": "a person interested in rocks and minerals [n -S]\n",
  "ROCKHOUNDING": "of a rock-collector, looking for rocks [n -S]\n",
  "ROCKHOUNDINGS": "ROCKHOUNDING, of a rock-collector, looking for rocks [n]\n",
  "ROCKHOUNDS": "ROCKHOUND, a person interested in rocks and minerals [n]\n",
  "ROCKIER": "the rock dove, also ROCKER [n -S]\n",
  "ROCKIERS": "ROCKIER, the rock dove, also ROCKER [n]\n",
  "ROCKIEST": "ROCKY, shaky, or unsteady [adj]\n",
  "ROCKILY": "ROCKY, shaky, or unsteady [adv]\n",
  "ROCKINESS": "the state of being rocky [n -ES]\n",
  "ROCKINESSES": "ROCKINESS, the state of being rocky [n]\n",
  "ROCKING": "moving back and forth [adj ROCKINGLY] / the act of rocking [n -S]\n",
  "ROCKINGLY": "ROCKING, moving back and forth [adv]\n",
  "ROCKINGS": "ROCKING, the act of rocking [n]\n",
  "ROCKLAY": "(Scots) a short cloak, also ROKELAY, ROQUELAURE [n -S]\n",
  "ROCKLAYS": "ROCKLAY, (Scots) a short cloak, also ROKELAY, ROQUELAURE [n]\n",
  "ROCKLESS": "without rocks [adj]\n",
  "ROCKLIKE": "like a rock [adj]\n",
  "ROCKLING": "a small fish of the cod family with barbels on both jaws [n -S]\n",
  "ROCKLINGS": "ROCKLING, a small fish of the cod family with barbels on both jaws [n]\n",
  "ROCKOON": "a small rocket [n -S]\n",
  "ROCKOONS": "ROCKOON, a small rocket [n]\n",
  "ROCKROSE": "a shrub of the Potentilla genus [n -S]\n",
  "ROCKROSES": "ROCKROSE, a shrub of the Potentilla genus [n]\n",
  "ROCKS": "ROCK, to move back and forth [v]\n",
  "ROCKSHAFT": "a shaft that rocks [n -S]\n",
  "ROCKSHAFTS": "ROCKSHAFT, a shaft that rocks [n]\n",
  "ROCKSLIDE": "a fall of rocks down a hillside [n -S]\n",
  "ROCKSLIDES": "ROCKSLIDE, a fall of rocks down a hillside [n]\n",
  "ROCKSTEADIES": "ROCKSTEADY, a 1960s style of dance music, originally from Jamaica [n]\n",
  "ROCKSTEADY": "a 1960s style of dance music, originally from Jamaica [n ROCKSTEADIES]\n",
  "ROCKWATER": "water issuing from a rock [n -S]\n",
  "ROCKWATERS": "ROCKWATER, water issuing from a rock [n]\n",
  "ROCKWEED": "any coarse seaweed growing on sea-washed rocks [n -S]\n",
  "ROCKWEEDS": "ROCKWEED, any coarse seaweed growing on sea-washed rocks [n]\n",
  "ROCKWOOL": "a mineral wool used for insulation [n -S]\n",
  "ROCKWOOLS": "ROCKWOOL, a mineral wool used for insulation [n]\n",
  "ROCKWORK": "stonework in which the surface is left broken and rough [n -S]\n",
  "ROCKWORKS": "ROCKWORK, stonework in which the surface is left broken and rough [n]\n",
  "ROCKY": "shaky, or unsteady [adj ROCKIER, ROCKIEST, ROCKILY]\n",
  "ROCOCO": "(French) a style of architecture marked by much ornamentation esp. scrollwork [n -S]\n",
  "ROCOCOS": "ROCOCO, (French) a style of architecture marked by much ornamentation esp. scrollwork [n]\n",
  "ROCQUET": "a close-fitting surplice-like vestment worn by bishops and abbots, also ROCHET, ROQUET [n -S]\n",
  "ROCQUETS": "ROCQUET, a close-fitting surplice-like vestment worn by bishops and abbots, also ROCHET, ROQUET [n]\n",
  "ROCS": "ROC, an enormous bird of Arabian legend, also ROK, RUC, RUKH [n]\n",
  "ROD": "to clear a drain with a long slender pole [v RODDED, RODDING, RODS]\n",
  "RODDED": "ROD, to clear a drain with a long slender pole [v]\n",
  "RODDING": "the act of clearing an obstacle with a rod [n -S]\n",
  "RODDINGS": "RODDING, the act of clearing an obstacle with a rod [n]\n",
  "RODE": "to perform an evening flight [v RODED, RODING, RODES]\n",
  "RODED": "RODE, to perform an evening flight [v]\n",
  "RODENT": "a gnawing mammal [n -S]\n",
  "RODENTIAL": "relating to Rodentia, the order containing rodents [adj]\n",
  "RODENTICIDE": "the killing of rodents [n -S]\n",
  "RODENTICIDES": "RODENTICIDE, the killing of rodents [n]\n",
  "RODENTS": "RODENT, a gnawing mammal [n]\n",
  "RODEO": "to perform a public exhibition of cowboy skills [v -ED, -ING, -S]\n",
  "RODEOED": "RODEO, to perform a public exhibition of cowboy skills [v]\n",
  "RODEOING": "RODEO, to perform a public exhibition of cowboy skills [v]\n",
  "RODEOS": "RODEO, to perform a public exhibition of cowboy skills [v]\n",
  "RODES": "RODE, to perform an evening flight [v]\n",
  "RODEWAY": "(Shakespeare) a roadway [n -S]\n",
  "RODEWAYS": "RODEWAY, (Shakespeare) a roadway [n]\n",
  "RODFISHER": "one who fishes by rod [n -S]\n",
  "RODFISHERS": "RODFISHER, one who fishes by rod [n]\n",
  "RODFISHING": "fishing with a rod and line [n -S]\n",
  "RODFISHINGS": "RODFISHING, fishing with a rod and line [n]\n",
  "RODGERSIA": "a flowering perennial herb [n -S]\n",
  "RODGERSIAS": "RODGERSIA, a flowering perennial herb [n]\n",
  "RODING": "a woodcock's evening flight, also ROADING [n -S]\n",
  "RODINGS": "RODING, a woodcock's evening flight, also ROADING [n]\n",
  "RODLESS": "without a rod [adj]\n",
  "RODLIKE": "like a rod [adj]\n",
  "RODMAN": "a surveyor's assistant, also RODSMAN [n RODMEN]\n",
  "RODMEN": "RODMAN, a surveyor's assistant, also RODSMAN [n]\n",
  "RODNEY": "(Canadian) a small fishing boat [n -S]\n",
  "RODNEYS": "RODNEY, (Canadian) a small fishing boat [n]\n",
  "RODOMONTADE": "(French) a bragging speech; vain boasting or bluster [n -S] / to boast, rant, also RHODOMONTADE [v RODOMONTADED, RODOMONTADING, RODOMONTADES]\n",
  "RODOMONTADED": "RODOMONTADE, to boast, rant, also RHODOMONTADE [v]\n",
  "RODOMONTADER": "a braggart, a blusterer [n -S]\n",
  "RODOMONTADERS": "RODOMONTADER, a braggart, a blusterer [n]\n",
  "RODOMONTADES": "RODOMONTADE, (French) a bragging speech; vain boasting or bluster [n]\n",
  "RODOMONTADING": "RODOMONTADE, to boast, rant, also RHODOMONTADE [v]\n",
  "RODS": "ROD, to clear a drain with a long slender pole [v]\n",
  "RODSMAN": "a surveyor's assistant, also RODMAN [n RODSMEN]\n",
  "RODSMEN": "RODSMAN, a surveyor's assistant, also RODMAN [n]\n",
  "RODSTER": "(archaic) an angler [n -S]\n",
  "RODSTERS": "RODSTER, (archaic) an angler [n]\n",
  "ROE": "a mass of fish eggs [n -S]\n",
  "ROEBUCK": "the male of a small Eurasian deer [n -S]\n",
  "ROEBUCKS": "ROEBUCK, the male of a small Eurasian deer [n]\n",
  "ROED": "containing roe [adj]\n",
  "ROEMER": "(Dutch) a large drinking glass, also RUMMER [n -S]\n",
  "ROEMERS": "ROEMER, (Dutch) a large drinking glass, also RUMMER [n]\n",
  "ROENTGEN": "(German) a unit of radiation dosage, also RONTGEN [n -S]\n",
  "ROENTGENISATION": "the process of roentgenising, also ROENTGENIZATION, RONTGENISATION, RONTGENIZATION [n]\n",
  "ROENTGENISE": "to bombard with X-rays, also ROENTGENIZE [v ROENTGENISED, ROENTGENISING, ROENTGENISES]\n",
  "ROENTGENISED": "ROENTGENISE, to bombard with X-rays, also ROENTGENIZE [v]\n",
  "ROENTGENISES": "ROENTGENISE, to bombard with X-rays, also ROENTGENIZE [v]\n",
  "ROENTGENISING": "ROENTGENISE, to bombard with X-rays, also ROENTGENIZE [v]\n",
  "ROENTGENIUM": "a short-lived radioactive element produced artificially [n -S]\n",
  "ROENTGENIUMS": "ROENTGENIUM, a short-lived radioactive element produced artificially [n]\n",
  "ROENTGENIZATION": "the process of roentgenizing, also ROENTGENISATION, RONTGENISATION, RONTGENIZATION [n]\n",
  "ROENTGENIZE": "to bombard with X-rays, also ROENTGENISE [v ROENTGENIZED, ROENTGENIZING, ROENTGENIZES]\n",
  "ROENTGENIZED": "ROENTGENIZE, to bombard with X-rays, also ROENTGENISE [v]\n",
  "ROENTGENIZES": "ROENTGENIZE, to bombard with X-rays, also ROENTGENISE [v]\n",
  "ROENTGENIZING": "ROENTGENIZE, to bombard with X-rays, also ROENTGENISE [v]\n",
  "ROENTGENOGRAM": "a radiograph, also RONTGENOGRAM [n -S]\n",
  "ROENTGENOGRAMS": "ROENTGENOGRAM, a radiograph, also RONTGENOGRAM [n]\n",
  "ROENTGENOGRAPH": "an X-ray photograph, also RONTGENOGRAPH [n -S]\n",
  "ROENTGENOGRAPHS": "ROENTGENOGRAPH, an X-ray photograph, also RONTGENOGRAPH [n]\n",
  "ROENTGENOGRAPHY": "radiography [n]\n",
  "ROENTGENOLOGIC": "relating to roentgenology [adj]\n",
  "ROENTGENOLOGIES": "ROENTGENOLOGY, radiology, also RONTGENOLOGY [n]\n",
  "ROENTGENOLOGIST": "one who studies roentgenology, also RONTGENOLOGIST [n]\n",
  "ROENTGENOLOGY": "radiology, also RONTGENOLOGY [n ROENTGENOLOGIES]\n",
  "ROENTGENOPAQUE": "opaque to X-rays [adj]\n",
  "ROENTGENOSCOPE": "an apparatus for examining patients by use of X-rays, also RONTGENOSCOPE [n -S]\n",
  "ROENTGENOSCOPES": "ROENTGENOSCOPE, an apparatus for examining patients by use of X-rays, also RONTGENOSCOPE [n]\n",
  "ROENTGENOSCOPIC": "relating to use of the roentgenoscope [adj]\n",
  "ROENTGENOSCOPY": "examination by use of the roentgenoscope [adj]\n",
  "ROENTGENS": "ROENTGEN, (German) a unit of radiation dosage, also RONTGEN [n]\n",
  "ROES": "ROE, a mass of fish eggs [n]\n",
  "ROESTI": "a dish of grated potatoes shaped into a pancake and fried, also ROSTI [n -S]\n",
  "ROESTIS": "ROESTI, a dish of grated potatoes shaped into a pancake and fried, also ROSTI [n]\n",
  "ROESTONE": "another name for oolite, a kind of limestone comprising small egg-like grains [n -S]\n",
  "ROESTONES": "ROESTONE, another name for oolite, a kind of limestone comprising small egg-like grains [n]\n",
  "ROGALLO": "a light and flexible hang glider wing [n -S]\n",
  "ROGALLOS": "ROGALLO, a light and flexible hang glider wing [n]\n",
  "ROGATION": "an asking or supplication, esp. in an ecclesiastical sense [n -S]\n",
  "ROGATIONS": "ROGATION, an asking or supplication, esp. in an ecclesiastical sense [n]\n",
  "ROGATORY": "requesting information [adj]\n",
  "ROGER": "(slang) to have intercourse with [v -ED, -ING, -S]\n",
  "ROGERED": "ROGER, (slang) to have intercourse with [v]\n",
  "ROGERING": "the act of rogering [n -S]\n",
  "ROGERINGS": "ROGERING, the act of rogering [n]\n",
  "ROGERS": "ROGER, (slang) to have intercourse with [v]\n",
  "ROGNON": "(French) an isolated rock outcrop on a glacier [n -S]\n",
  "ROGNONS": "ROGNON, (French) an isolated rock outcrop on a glacier [n]\n",
  "ROGUE": "to cheat or defraud [v ROGUED, ROGUEING or ROGUING, ROGUES]\n",
  "ROGUED": "ROGUE, to cheat or defraud [v]\n",
  "ROGUEING": "ROGUE, to cheat or defraud [v]\n",
  "ROGUER": "a rogue [n -S]\n",
  "ROGUERIES": "ROGUERY, roguish conduct [n]\n",
  "ROGUERS": "ROGUER, a rogue [n]\n",
  "ROGUERY": "roguish conduct [n ROGUERIES]\n",
  "ROGUES": "ROGUE, to cheat or defraud [v]\n",
  "ROGUESHIP": "(archaic) the state of being a rogue [n -S]\n",
  "ROGUESHIPS": "ROGUESHIP, (archaic) the state of being a rogue [n]\n",
  "ROGUIER": "ROGUY, roguish [adj]\n",
  "ROGUIEST": "ROGUY, roguish [adj]\n",
  "ROGUING": "ROGUE, to cheat or defraud [v]\n",
  "ROGUISH": "dishonest [adj ROGUISHLY]\n",
  "ROGUISHLY": "ROGUISH, dishonest [adv]\n",
  "ROGUISHNESS": "the state of being roguish [n -ES]\n",
  "ROGUISHNESSES": "ROGUISHNESS, the state of being roguish [n]\n",
  "ROGUY": "roguish [adj ROGUIER, ROGUIEST]\n",
  "ROHE": "(Maori) the territory controlled by a Maori tribal group [n -S]\n",
  "ROHES": "ROHE, (Maori) the territory controlled by a Maori tribal group [n]\n",
  "ROID": "(short for) steroid [n -S]\n",
  "ROIDS": "ROID, (short for) steroid [n]\n",
  "ROIL": "to make muddy by stirring or to disturb sediment [v -ED, -ING, -S]\n",
  "ROILED": "ROIL, to make muddy by stirring or to disturb sediment [v]\n",
  "ROILIER": "ROILY, turbid [adj]\n",
  "ROILIEST": "ROILY, turbid [adj]\n",
  "ROILING": "ROIL, to make muddy by stirring or to disturb sediment [v]\n",
  "ROILS": "ROIL, to make muddy by stirring or to disturb sediment [v]\n",
  "ROILY": "turbid [adj ROILIER, ROILIEST]\n",
  "ROIN": "(Spenser) to growl, roar, also ROYNE [v -ED, -ING, -S]\n",
  "ROINED": "ROIN, (Spenser) to growl, roar, also ROYNE [v]\n",
  "ROINING": "ROIN, (Spenser) to growl, roar, also ROYNE [v]\n",
  "ROINISH": "(Shakespeare) mangy; scurvy, also ROYNISH [adj]\n",
  "ROINS": "ROIN, (Spenser) to growl, roar, also ROYNE [v]\n",
  "ROIST": "to revel noisily, carouse, also ROISTER, ROYST, ROYSTER [v -ED, -ING, -S]\n",
  "ROISTED": "ROIST, to revel noisily, carouse, also ROISTER, ROYST, ROYSTER [v]\n",
  "ROISTER": "to revel noisily, carouse, also ROIST, ROYST, ROYSTER [v -ED, -ING, -S]\n",
  "ROISTERED": "ROISTER, to revel noisily, carouse, also ROIST, ROYST, ROYSTER [v]\n",
  "ROISTERER": "one who roisters, carouses, also ROYSTERER [n -S]\n",
  "ROISTERERS": "ROISTERER, one who roisters, carouses, also ROYSTERER [n]\n",
  "ROISTERING": "carousing [n -S]\n",
  "ROISTERINGS": "ROISTERING, carousing [n]\n",
  "ROISTEROUS": "blustering, boisterous, also ROYSTEROUS [adj ROISTEROUSLY]\n",
  "ROISTEROUSLY": "ROISTEROUS, blustering, boisterous, also ROYSTEROUS [adv]\n",
  "ROISTERS": "ROISTER, to revel noisily, carouse, also ROIST, ROYST, ROYSTER [v]\n",
  "ROISTING": "ROIST, to revel noisily, carouse, also ROISTER, ROYST, ROYSTER [v]\n",
  "ROISTS": "ROIST, to revel noisily, carouse, also ROISTER, ROYST, ROYSTER [v]\n",
  "ROJAK": "(Malay) a salad dish served in chilli sauce [n -S]\n",
  "ROJAKS": "ROJAK, (Malay) a salad dish served in chilli sauce [n]\n",
  "ROJI": "(Japanese) a Japanese garden design [n -S]\n",
  "ROJIS": "ROJI, (Japanese) a Japanese garden design [n]\n",
  "ROK": "an enormous bird of Arabian legend, also ROC, RUC, RUKH [n -S]\n",
  "ROKE": "(dialect) to steam, smoke [v ROKED, ROKING, ROKES]\n",
  "ROKED": "ROKE, (dialect) to steam, smoke [v]\n",
  "ROKELAY": "(Scots) a short cloak, also ROCKLAY, ROQUELAURE [n -S]\n",
  "ROKELAYS": "ROKELAY, (Scots) a short cloak, also ROCKLAY, ROQUELAURE [n]\n",
  "ROKER": "any ray other than a skate, esp. the thornback ray [n -S]\n",
  "ROKERS": "ROKER, any ray other than a skate, esp. the thornback ray [n]\n",
  "ROKES": "ROKE, (dialect) to steam, smoke [v]\n",
  "ROKIER": "ROKY, (dialect) misty; foggy; cloudy [adj]\n",
  "ROKIEST": "ROKY, (dialect) misty; foggy; cloudy [adj]\n",
  "ROKING": "ROKE, (dialect) to steam, smoke [v]\n",
  "ROKKAKU": "(Japanese) a fighting kite [n ROKKAKU]\n",
  "ROKS": "ROK, an enormous bird of Arabian legend, also ROC, RUC, RUKH [n]\n",
  "ROKY": "(dialect) misty; foggy; cloudy [adj ROKIER, ROKIEST]\n",
  "ROLAG": "(Gaelic) a roll of combed sheep's wool ready for spinning [n -S]\n",
  "ROLAGS": "ROLAG, (Gaelic) a roll of combed sheep's wool ready for spinning [n]\n",
  "ROLAMITE": "two or more rollers connected by a belt but relatively loose [n -S]\n",
  "ROLAMITES": "ROLAMITE, two or more rollers connected by a belt but relatively loose [n]\n",
  "ROLE": "a part played by an actor [n -S]\n",
  "ROLES": "ROLE, a part played by an actor [n]\n",
  "ROLF": "to perform a deep massage [v -ED, -ING, -S]\n",
  "ROLFED": "ROLF, to perform a deep massage [v]\n",
  "ROLFER": "a manipulator of muscles [n -S]\n",
  "ROLFERS": "ROLFER, a manipulator of muscles [n]\n",
  "ROLFING": "a therapeutic technique [n -S]\n",
  "ROLFINGS": "ROLFING, a therapeutic technique [n]\n",
  "ROLFS": "ROLF, to perform a deep massage [v]\n",
  "ROLL": "to move along by repeatedly turning over [v -ED, -ING, -S]\n",
  "ROLLABLE": "able to be rolled [adj]\n",
  "ROLLAWAY": "something mounted on rollers [n -S]\n",
  "ROLLAWAYS": "ROLLAWAY, something mounted on rollers [n]\n",
  "ROLLBACK": "a return to lower prices or wages [n -S]\n",
  "ROLLBACKS": "ROLLBACK, a return to lower prices or wages [n]\n",
  "ROLLBAR": "a frame to protect the driver in racing cars [n -S]\n",
  "ROLLBARS": "ROLLBAR, a frame to protect the driver in racing cars [n]\n",
  "ROLLCOLLAR": "a collar of a garment turned back in a curve [n -S]\n",
  "ROLLCOLLARS": "ROLLCOLLAR, a collar of a garment turned back in a curve [n]\n",
  "ROLLED": "ROLL, to move along by repeatedly turning over [v]\n",
  "ROLLER": "a cylindrical device that rolls or rotates [n -S]\n",
  "ROLLERBALL": "a pen having a small moving nylon, plastic, or metal ball as a writing point [n -S]\n",
  "ROLLERBALLS": "ROLLERBALL, a pen having a small moving nylon, plastic, or metal ball as a writing point [n]\n",
  "ROLLERBLADE": "(tradename) a type of roller-skate with wheels set in line resembling the blade of an ice skate [n -S] / to skate on rollerblades [v ROLLERBLADED, ROLLERBLADING, ROLLERBLADES]\n",
  "ROLLERBLADED": "ROLLERBLADE, to skate on rollerblades [v]\n",
  "ROLLERBLADER": "one who skates on rollerblades [n -S]\n",
  "ROLLERBLADERS": "ROLLERBLADER, one who skates on rollerblades [n]\n",
  "ROLLERBLADES": "ROLLERBLADE, (tradename) a type of roller-skate with wheels set in line resembling the blade of an ice skate [n]\n",
  "ROLLERBLADING": "the sport of skating on rollerblades [n -S]\n",
  "ROLLERBLADINGS": "ROLLERBLADING, the sport of skating on rollerblades [n]\n",
  "ROLLERCOASTER": "to direct or cause to move with great speed, esp. in a set direction [v -ED, -S]\n",
  "ROLLERCOASTERED": "ROLLERCOASTER, to direct or cause to move with great speed, esp. in a set direction [v]\n",
  "ROLLERCOASTERS": "ROLLERCOASTER, to direct or cause to move with great speed, esp. in a set direction [v]\n",
  "ROLLERDROME": "(US) a venue for roller-skating to music [n -S]\n",
  "ROLLERDROMES": "ROLLERDROME, (US) a venue for roller-skating to music [n]\n",
  "ROLLERS": "ROLLER, a cylindrical device that rolls or rotates [n]\n",
  "ROLLICK": "to behave in a carefree, playful, boisterous way [v -ED, -ING, -S]\n",
  "ROLLICKED": "ROLLICK, to behave in a carefree, playful, boisterous way [v]\n",
  "ROLLICKIER": "ROLLICKY, playful, boisterous [adj]\n",
  "ROLLICKIEST": "ROLLICKY, playful, boisterous [adj]\n",
  "ROLLICKING": "playful, boisterous [adj] / the act of rollicking [n -S]\n",
  "ROLLICKINGS": "ROLLICKING, the act of rollicking [n]\n",
  "ROLLICKS": "ROLLICK, to behave in a carefree, playful, boisterous way [v]\n",
  "ROLLICKY": "playful, boisterous [adj ROLLICKIER, ROLLICKIEST]\n",
  "ROLLIE": "a hand-rolled cigarette [n ROLLIES]\n",
  "ROLLIES": "ROLLIE, a hand-rolled cigarette [n]\n",
  "ROLLING": "the act of rolling [n -S]\n",
  "ROLLINGS": "ROLLING, the act of rolling [n]\n",
  "ROLLMOP": "a fillet of herring rolled up in onion [n -S]\n",
  "ROLLMOPS": "ROLLMOP, a fillet of herring rolled up in onion [n]\n",
  "ROLLNECK": "of a garment, having a neck which can be rolled over [adj] / a garment with such a neck [n -S]\n",
  "ROLLNECKS": "ROLLNECK, a garment with such a neck [n]\n",
  "ROLLOCK": "a contrivance serving as a fulcrum for an oar, also ROWLOCK, RULLOCK [n -S]\n",
  "ROLLOCKING": "a telling off [n -S]\n",
  "ROLLOCKINGS": "ROLLOCKING, a telling off [n]\n",
  "ROLLOCKS": "ROLLOCK, a contrivance serving as a fulcrum for an oar, also ROWLOCK, RULLOCK [n]\n",
  "ROLLOUT": "a type of play in football [n -S]\n",
  "ROLLOUTS": "ROLLOUT, a type of play in football [n]\n",
  "ROLLOVER": "a motor vehicle accident in which the vehicle overturns [n -S]\n",
  "ROLLOVERS": "ROLLOVER, a motor vehicle accident in which the vehicle overturns [n]\n",
  "ROLLS": "ROLL, to move along by repeatedly turning over [v]\n",
  "ROLLTOP": "having a flexible, sliding cover [adj]\n",
  "ROLLUP": "something that is rolled into the shape of a tube [n -S]\n",
  "ROLLUPS": "ROLLUP, something that is rolled into the shape of a tube [n]\n",
  "ROLLWAY": "an incline for rolling logs [n -S]\n",
  "ROLLWAYS": "ROLLWAY, an incline for rolling logs [n]\n",
  "ROM": "a gypsy man [n ROMA or ROMS]\n",
  "ROMA": "ROM, a gypsy man [n]\n",
  "ROMAGE": "(Shakespeare) tumult [n -S]\n",
  "ROMAGES": "ROMAGE, (Shakespeare) tumult [n]\n",
  "ROMAIKA": "(Modern Greek) a modern Greek dance [n -S]\n",
  "ROMAIKAS": "ROMAIKA, (Modern Greek) a modern Greek dance [n]\n",
  "ROMAINE": "(French) a type of lettuce [n -S]\n",
  "ROMAINES": "ROMAINE, (French) a type of lettuce [n]\n",
  "ROMAJI": "(Japanese) a system of transliterating Japanese into the Latin alphabet [n -S]\n",
  "ROMAJIS": "ROMAJI, (Japanese) a system of transliterating Japanese into the Latin alphabet [n]\n",
  "ROMAL": "(Urdu) a handkerchief or headcloth, also RUMAL [n -S]\n",
  "ROMALS": "ROMAL, (Urdu) a handkerchief or headcloth, also RUMAL [n]\n",
  "ROMAN": "a metrical narrative of medieval France [n -S]\n",
  "ROMANCE": "to woo [v ROMANCED, ROMANCING, ROMANCES]\n",
  "ROMANCED": "ROMANCE, to woo [v]\n",
  "ROMANCER": "one who writes romances [n -S]\n",
  "ROMANCERS": "ROMANCER, one who writes romances [n]\n",
  "ROMANCES": "ROMANCE, to woo [v]\n",
  "ROMANCICAL": "(Lamb) dealing with romance [adj]\n",
  "ROMANCING": "the act of romancing [n -S]\n",
  "ROMANCINGS": "ROMANCING, the act of romancing [n]\n",
  "ROMANESCO": "(Italian) a type of cauliflower [n -S]\n",
  "ROMANESCOS": "ROMANESCO, (Italian) a type of cauliflower [n]\n",
  "ROMANICITE": "another name for the mineral psilomelane [n -S]\n",
  "ROMANICITES": "ROMANICITE, another name for the mineral psilomelane [n]\n",
  "ROMANISATION": "the act of romanising, also ROMANIZATION [n -S]\n",
  "ROMANISATIONS": "ROMANISATION, the act of romanising, also ROMANIZATION [n]\n",
  "ROMANISE": "to write in the Roman alphabet, also ROMANIZE [v ROMANISED, ROMANISING, ROMANISES]\n",
  "ROMANISED": "ROMANISE, to write in the Roman alphabet, also ROMANIZE [v]\n",
  "ROMANISES": "ROMANISE, to write in the Roman alphabet, also ROMANIZE [v]\n",
  "ROMANISING": "ROMANISE, to write in the Roman alphabet, also ROMANIZE [v]\n",
  "ROMANIZATION": "the act of romanizing, also ROMANISATION [n -S]\n",
  "ROMANIZATIONS": "ROMANIZATION, the act of romanizing, also ROMANISATION [n]\n",
  "ROMANIZE": "to write in the Roman alphabet, also ROMANISE [v ROMANIZED, ROMANIZING, ROMANIZES]\n",
  "ROMANIZED": "ROMANIZE, to write in the Roman alphabet, also ROMANISE [v]\n",
  "ROMANIZES": "ROMANIZE, to write in the Roman alphabet, also ROMANISE [v]\n",
  "ROMANIZING": "ROMANIZE, to write in the Roman alphabet, also ROMANISE [v]\n",
  "ROMANO": "(Italian) a black-rinded Italian cheese [n -S]\n",
  "ROMANOS": "ROMANO, (Italian) a black-rinded Italian cheese [n]\n",
  "ROMANS": "ROMAN, a metrical narrative of medieval France [n]\n",
  "ROMANTIC": "related to romance [adj ROMANTICALLY] / a fanciful person [n -S]\n",
  "ROMANTICAL": "romantic [adj ROMANTICALLY]\n",
  "ROMANTICALITIES": "ROMANTICALITY, the state of being romantic [n]\n",
  "ROMANTICALITY": "the state of being romantic [n ROMANTICALITIES]\n",
  "ROMANTICALLY": "ROMANTICAL, romantic [adv]\n",
  "ROMANTICISATION": "the act of romanticising, also ROMANTICIZATION [n]\n",
  "ROMANTICISE": "to make romantic, also ROMANTICIZE [v ROMANTICISED, ROMANTICISING, ROMANTICISES]\n",
  "ROMANTICISED": "ROMANTICISE, to make romantic, also ROMANTICIZE [v]\n",
  "ROMANTICISES": "ROMANTICISE, to make romantic, also ROMANTICIZE [v]\n",
  "ROMANTICISING": "ROMANTICISE, to make romantic, also ROMANTICIZE [v]\n",
  "ROMANTICISM": "romantic quality, feeling or tendency [n -S]\n",
  "ROMANTICISMS": "ROMANTICISM, romantic quality, feeling or tendency [n]\n",
  "ROMANTICIST": "an adherent of romanticism [n -S]\n",
  "ROMANTICISTS": "ROMANTICIST, an adherent of romanticism [n]\n",
  "ROMANTICIZATION": "the act of romanticizing, also ROMANTICISATION [n]\n",
  "ROMANTICIZE": "to make romantic, also ROMANTICISE [v ROMANTICIZED, ROMANTICIZING, ROMANTICIZES]\n",
  "ROMANTICIZED": "ROMANTICIZE, to make romantic, also ROMANTICISE [v]\n",
  "ROMANTICIZES": "ROMANTICIZE, to make romantic, also ROMANTICISE [v]\n",
  "ROMANTICIZING": "ROMANTICIZE, to make romantic, also ROMANTICISE [v]\n",
  "ROMANTICS": "ROMANTIC, a fanciful person [n]\n",
  "ROMANZA": "(Italian) a short instrumental piece of songlike character [n -S]\n",
  "ROMANZAS": "ROMANZA, (Italian) a short instrumental piece of songlike character [n]\n",
  "ROMAUNT": "(archaic) a romantic story in verse [n -S]\n",
  "ROMAUNTS": "ROMAUNT, (archaic) a romantic story in verse [n]\n",
  "ROMCOM": "a romantic comedy [n -S]\n",
  "ROMCOMS": "ROMCOM, a romantic comedy [n]\n",
  "ROMELDALE": "an American breed of utility sheep [n -S]\n",
  "ROMELDALES": "ROMELDALE, an American breed of utility sheep [n]\n",
  "ROMEO": "a man who is a passionate lover or seducer [n -S]\n",
  "ROMEOS": "ROMEO, a man who is a passionate lover or seducer [n]\n",
  "ROMNEYA": "a plant with large white flowers [n -S]\n",
  "ROMNEYAS": "ROMNEYA, a plant with large white flowers [n]\n",
  "ROMP": "to play boisterously [v -ED, -ING, -S]\n",
  "ROMPED": "ROMP, to play boisterously [v]\n",
  "ROMPER": "a one-piece garment covering the legs and trunk, worn esp. by young children [n -S]\n",
  "ROMPERS": "ROMPER, a one-piece garment covering the legs and trunk, worn esp. by young children [n]\n",
  "ROMPING": "ROMP, to play boisterously [v]\n",
  "ROMPINGLY": "ROMPING, ROMP, to play boisterously [adv]\n",
  "ROMPISH": "inclined to romp [adj ROMPISHLY]\n",
  "ROMPISHLY": "ROMPISH, inclined to romp [adv]\n",
  "ROMPISHNESS": "the state of being rompish [n -ES]\n",
  "ROMPISHNESSES": "ROMPISHNESS, the state of being rompish [n]\n",
  "ROMPS": "ROMP, to play boisterously [v]\n",
  "ROMS": "ROM, a gypsy man [n]\n",
  "RONCADOR": "(Spanish) a name for various fishes of the maigre family [n -S]\n",
  "RONCADORS": "RONCADOR, (Spanish) a name for various fishes of the maigre family [n]\n",
  "RONDACHE": "(French) a circular shield carried by foot soldiers [n -S]\n",
  "RONDACHES": "RONDACHE, (French) a circular shield carried by foot soldiers [n]\n",
  "RONDAVEL": "(South African) in South Africa, a round hut with a grass roof [n -S]\n",
  "RONDAVELS": "RONDAVEL, (South African) in South Africa, a round hut with a grass roof [n]\n",
  "RONDE": "(French) a script printing type [n -S]\n",
  "RONDEAU": "(French) a poem of 13 lines with two rhymes and the opening words used as a refrain in two places [n RONDEAUX]\n",
  "RONDEAUX": "RONDEAU, (French) a poem of 13 lines with two rhymes and the opening words used as a refrain in two places [n]\n",
  "RONDEL": "(French) a verse form of thirteen or fourteen lines on two rhymes, also RONDELLE [n -S]\n",
  "RONDELET": "(French) a short 5 or 7-line rondeau with one refrain per stanza [n -S]\n",
  "RONDELETS": "RONDELET, (French) a short 5 or 7-line rondeau with one refrain per stanza [n]\n",
  "RONDELLE": "(French) a verse form of thirteen or fourteen lines on two rhymes, also RONDEL [n -S]\n",
  "RONDELLES": "RONDELLE, (French) a verse form of thirteen or fourteen lines on two rhymes, also RONDEL [n]\n",
  "RONDELS": "RONDEL, (French) a verse form of thirteen or fourteen lines on two rhymes, also RONDELLE [n]\n",
  "RONDES": "RONDE, (French) a script printing type [n]\n",
  "RONDINO": "(Italian) a short rondo [n -S]\n",
  "RONDINOS": "RONDINO, (Italian) a short rondo [n]\n",
  "RONDO": "(Italian) a piece of music with a recurring leading theme, often as the final movement of a concerto, sonata, etc. [n -S]\n",
  "RONDOLETTO": "a short rondo [n -S]\n",
  "RONDOLETTOS": "RONDOLETTO, a short rondo [n]\n",
  "RONDOS": "RONDO, (Italian) a piece of music with a recurring leading theme, often as the final movement of a concerto, sonata, etc. [n]\n",
  "RONDURE": "(Shakespeare) a gracefully rounded curvature, also ROUNDURE [n -S]\n",
  "RONDURES": "RONDURE, (Shakespeare) a gracefully rounded curvature, also ROUNDURE [n]\n",
  "RONE": "(Scots) a roof-gutter, also RHONE, ROAN, ROANPIPE, RONEPIPE [n -S]\n",
  "RONEO": "(tradename) to produce copies on a Roneo, an early duplicating machine [v -ED, -ING, -S]\n",
  "RONEOED": "RONEO, (tradename) to produce copies on a Roneo, an early duplicating machine [v]\n",
  "RONEOING": "RONEO, (tradename) to produce copies on a Roneo, an early duplicating machine [v]\n",
  "RONEOS": "RONEO, (tradename) to produce copies on a Roneo, an early duplicating machine [v]\n",
  "RONEPIPE": "(Scots) a roof-gutter, also RHONE, ROAN, ROANPIPE, RONE [n -S]\n",
  "RONEPIPES": "RONEPIPE, (Scots) a roof-gutter, also RHONE, ROAN, ROANPIPE, RONE [n]\n",
  "RONES": "RONE, (Scots) a roof-gutter, also RHONE, ROAN, ROANPIPE, RONEPIPE [n]\n",
  "RONG": "RING, to give forth a clear, resonant sound [v]\n",
  "RONGGENG": "(Malay) a Malaysian dancing-girl [n -S]\n",
  "RONGGENGS": "RONGGENG, (Malay) a Malaysian dancing-girl [n]\n",
  "RONIN": "(Japanese) a lordless samurai [n -S]\n",
  "RONINS": "RONIN, (Japanese) a lordless samurai [n]\n",
  "RONION": "a mangy or scabby creature, also RONYON, RUNNION [n -S]\n",
  "RONIONS": "RONION, a mangy or scabby creature, also RONYON, RUNNION [n]\n",
  "RONNE": "(Spenser) to run [v RAN, RONNE, RONNING, RUNS]\n",
  "RONNEL": "an insecticide [n -S]\n",
  "RONNELS": "RONNEL, an insecticide [n]\n",
  "RONNIE": "(slang) Dublin slang for a moustache [n -S]\n",
  "RONNIES": "RONNIE, (slang) Dublin slang for a moustache [n]\n",
  "RONNING": "RUN, to move by rapid steps [v]\n",
  "RONT": "(Spenser) a runt, also RONTE [n -S]\n",
  "RONTE": "(Spenser) a runt, also RONT [n -S]\n",
  "RONTES": "RONTE, (Spenser) a runt, also RONT [n]\n",
  "RONTGEN": "(German) the international unit of dose of X-rays, also ROENTGEN [n -S]\n",
  "RONTGENISATION": "the process of rontgenising, also ROENTGENISATION, ROENTGENIZATION, RONTGENIZATION [n -S]\n",
  "RONTGENISATIONS": "RONTGENISATION, the process of rontgenising, also ROENTGENISATION, ROENTGENIZATION, RONTGENIZATION [n]\n",
  "RONTGENISE": "to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENIZE [v RONTGENISED, RONTGENISING, RONTGENISES]\n",
  "RONTGENISED": "RONTGENISE, to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENIZE [v]\n",
  "RONTGENISES": "RONTGENISE, to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENIZE [v]\n",
  "RONTGENISING": "RONTGENISE, to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENIZE [v]\n",
  "RONTGENIZATION": "the process of rontgenizing, also ROENTGENISATION, ROENTGENIZATION, RONTGENISATION [n -S]\n",
  "RONTGENIZATIONS": "RONTGENIZATION, the process of rontgenizing, also ROENTGENISATION, ROENTGENIZATION, RONTGENISATION [n]\n",
  "RONTGENIZE": "to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENISE [v RONTGENIZED, RONTGENIZING, RONTGENIZES]\n",
  "RONTGENIZED": "RONTGENIZE, to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENISE [v]\n",
  "RONTGENIZES": "RONTGENIZE, to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENISE [v]\n",
  "RONTGENIZING": "RONTGENIZE, to treat by rontgen rays, also ROENTGENISE, ROENTGENIZE, RONTGENISE [v]\n",
  "RONTGENOGRAM": "a photograph made with rontgen rays, also ROENTGENOGRAM [n -S]\n",
  "RONTGENOGRAMS": "RONTGENOGRAM, a photograph made with rontgen rays, also ROENTGENOGRAM [n]\n",
  "RONTGENOGRAPH": "an apparatus for taking X-ray photographs, also ROENTGENOGRAPH [n -S]\n",
  "RONTGENOGRAPHS": "RONTGENOGRAPH, an apparatus for taking X-ray photographs, also ROENTGENOGRAPH [n]\n",
  "RONTGENOGRAPHY": "photography by X-rays [n]\n",
  "RONTGENOLOGICAL": "related to rontgenology [adj]\n",
  "RONTGENOLOGIES": "RONTGENOLOGY, the science of X-rays, also ROENTGENOLOGY [n]\n",
  "RONTGENOLOGIST": "a specialist in rontgenology, also ROENTGENOLOGIST [n -S]\n",
  "RONTGENOLOGISTS": "RONTGENOLOGIST, a specialist in rontgenology, also ROENTGENOLOGIST [n]\n",
  "RONTGENOLOGY": "the science of X-rays, also ROENTGENOLOGY [n RONTGENOLOGIES]\n",
  "RONTGENOPAQUE": "opaque to X-rays [adj]\n",
  "RONTGENOSCOPE": "an apparatus for examining patients by use of X-rays, also ROENTGENOSCOPE [n -S]\n",
  "RONTGENOSCOPES": "RONTGENOSCOPE, an apparatus for examining patients by use of X-rays, also ROENTGENOSCOPE [n]\n",
  "RONTGENOSCOPIC": "relating to use of the rontgenoscope [adj]\n",
  "RONTGENOSCOPIES": "RONTGENOSCOPY, observation by means of X-rays [n]\n",
  "RONTGENOSCOPY": "observation by means of X-rays [n RONTGENOSCOPIES]\n",
  "RONTGENOTHERAPY": "treatment by X-rays [n]\n",
  "RONTGENS": "RONTGEN, (German) the international unit of dose of X-rays, also ROENTGEN [n]\n",
  "RONTS": "RONT, (Spenser) a runt, also RONTE [n]\n",
  "RONYON": "(Shakespeare) a mangy or scabby creature, also RONION, RUNNION [n -S]\n",
  "RONYONS": "RONYON, (Shakespeare) a mangy or scabby creature, also RONION, RUNNION [n]\n",
  "RONZ": "(New Zealand) acronym for the rest of New Zealand i.e. other than Auckland [n]\n",
  "RONZER": "(New Zealand) someone from the rest of New Zealand i.e. apart from Auckland [n -S]\n",
  "RONZERS": "RONZER, (New Zealand) someone from the rest of New Zealand i.e. apart from Auckland [n]\n",
  "ROO": "(short for) kangaroo [n -S]\n",
  "ROOD": "a cross or crucifix at the entrance to a church chancel [n -S]\n",
  "ROODS": "ROOD, a cross or crucifix at the entrance to a church chancel [n]\n",
  "ROOF": "to provide a building with a covering [v -ED, -ING, -S]\n",
  "ROOFED": "ROOF, to provide a building with a covering [v]\n",
  "ROOFER": "one who supplies or repairs roofs [n -S]\n",
  "ROOFERS": "ROOFER, one who supplies or repairs roofs [n]\n",
  "ROOFIE": "a tablet of a powerful sedative [n -S]\n",
  "ROOFIER": "ROOFY, having a roof [adj]\n",
  "ROOFIES": "ROOFIE, a tablet of a powerful sedative [n]\n",
  "ROOFIEST": "ROOFY, having a roof [adj]\n",
  "ROOFING": "material for a roof [n -S]\n",
  "ROOFINGS": "ROOFING, material for a roof [n]\n",
  "ROOFLESS": "without a roof [adj]\n",
  "ROOFLESSNESS": "the state of being roofless [n -ES]\n",
  "ROOFLESSNESSES": "ROOFLESSNESS, the state of being roofless [n]\n",
  "ROOFLIKE": "like a roof [adj]\n",
  "ROOFLINE": "the profile of a roof [n -S]\n",
  "ROOFLINES": "ROOFLINE, the profile of a roof [n]\n",
  "ROOFS": "ROOF, to provide a building with a covering [v]\n",
  "ROOFSCAPE": "a view of roofs [n -S]\n",
  "ROOFSCAPES": "ROOFSCAPE, a view of roofs [n]\n",
  "ROOFTOP": "the outside of a roof [n -S]\n",
  "ROOFTOPS": "ROOFTOP, the outside of a roof [n]\n",
  "ROOFTREE": "a horizontal timber in a roof [n -S]\n",
  "ROOFTREES": "ROOFTREE, a horizontal timber in a roof [n]\n",
  "ROOFY": "having a roof [adj ROOFIER, ROOFIEST]\n",
  "ROOIBOS": "(South African) tea prepared from the dried leaves of an African plant [n ROOIBOS or ROOIBOSES]\n",
  "ROOIBOSES": "ROOIBOS, (South African) tea prepared from the dried leaves of an African plant [n]\n",
  "ROOIKAT": "(South African) a South African lynx [n -S]\n",
  "ROOIKATS": "ROOIKAT, (South African) a South African lynx [n]\n",
  "ROOINEK": "(South African) an Afrikaans nickname for an English-speaking person [n -S]\n",
  "ROOINEKS": "ROOINEK, (South African) an Afrikaans nickname for an English-speaking person [n]\n",
  "ROOK": "to swindle [v -ED, -ING, -S]\n",
  "ROOKED": "ROOK, to swindle [v]\n",
  "ROOKERIES": "ROOKERY, a colony of European crows [n]\n",
  "ROOKERY": "a colony of European crows [n ROOKERIES]\n",
  "ROOKIE": "a new recruit [n -S]\n",
  "ROOKIER": "ROOKY, (Shakespeare) full of rooks [adj]\n",
  "ROOKIES": "ROOKIE, a new recruit [n]\n",
  "ROOKIEST": "ROOKY, (Shakespeare) full of rooks [adj]\n",
  "ROOKING": "ROOK, to swindle [v]\n",
  "ROOKISH": "like a rook [adj]\n",
  "ROOKS": "ROOK, to swindle [v]\n",
  "ROOKY": "(Shakespeare) full of rooks [adj ROOKIER, ROOKIEST]\n",
  "ROOM": "to occupy a room [v -ED, -ING, -S]\n",
  "ROOMED": "ROOM, to occupy a room [v]\n",
  "ROOMER": "a lodger [n -S]\n",
  "ROOMERS": "ROOMER, a lodger [n]\n",
  "ROOMETTE": "a small room [n -S]\n",
  "ROOMETTES": "ROOMETTE, a small room [n]\n",
  "ROOMFUL": "the contents of a room [n ROOMSFUL or ROOMFULS]\n",
  "ROOMFULS": "ROOMFUL, the contents of a room [n]\n",
  "ROOMIE": "(colloquial) a roommate [n -S]\n",
  "ROOMIER": "ROOMY, spacious [adj]\n",
  "ROOMIES": "ROOMIE, (colloquial) a roommate [n]\n",
  "ROOMIEST": "ROOMY, spacious [adj]\n",
  "ROOMILY": "ROOMY, spacious [adv]\n",
  "ROOMINESS": "the state of being roomy [n -ES]\n",
  "ROOMINESSES": "ROOMINESS, the state of being roomy [n]\n",
  "ROOMING": "ROOM, to occupy a room [v]\n",
  "ROOMMATE": "one who shares a room [n -S]\n",
  "ROOMMATES": "ROOMMATE, one who shares a room [n]\n",
  "ROOMS": "ROOM, to occupy a room [v]\n",
  "ROOMSFUL": "ROOMFUL, the contents of a room [n]\n",
  "ROOMSOME": "(obsolete) roomy [adj]\n",
  "ROOMY": "spacious [adj ROOMIER, ROOMIEST, ROOMILY]\n",
  "ROON": "(Scots) a strip of cloth, a selvage, also RUND [n -S]\n",
  "ROONS": "ROON, (Scots) a strip of cloth, a selvage, also RUND [n]\n",
  "ROOP": "(Scots) to make a hoarse sound [v -ED, -ING, -S]\n",
  "ROOPED": "ROOP, (Scots) to make a hoarse sound [v]\n",
  "ROOPIER": "ROOPY, (Scots) hoarse [adj]\n",
  "ROOPIEST": "ROOPY, (Scots) hoarse [adj]\n",
  "ROOPING": "ROOP, (Scots) to make a hoarse sound [v]\n",
  "ROOPIT": "(Scots) hoarse, also ROUPET, ROUPIT, ROUPY [adj]\n",
  "ROOPS": "ROOP, (Scots) to make a hoarse sound [v]\n",
  "ROOPY": "(Scots) hoarse [adj ROOPIER, ROOPIEST]\n",
  "ROORBACH": "a false story used for political advantage, also ROORBACK [n -S]\n",
  "ROORBACHS": "ROORBACH, a false story used for political advantage, also ROORBACK [n]\n",
  "ROORBACK": "a false story used for political advantage, also ROORBACH [n -S]\n",
  "ROORBACKS": "ROORBACK, a false story used for political advantage, also ROORBACH [n]\n",
  "ROOS": "ROO, (short for) kangaroo [n]\n",
  "ROOSA": "(Hindi) an Indian grass [n -S]\n",
  "ROOSAS": "ROOSA, (Hindi) an Indian grass [n]\n",
  "ROOSE": "to heap praise on [v ROOSED, ROOSING, ROOSES]\n",
  "ROOSED": "ROOSE, to heap praise on [v]\n",
  "ROOSER": "(Scots) a boaster [n -S]\n",
  "ROOSERS": "ROOSER, (Scots) a boaster [n]\n",
  "ROOSES": "ROOSE, to heap praise on [v]\n",
  "ROOSING": "ROOSE, to heap praise on [v]\n",
  "ROOST": "to prepare for sleep by perching [v -ED, -ING, -S]\n",
  "ROOSTED": "ROOST, to prepare for sleep by perching [v]\n",
  "ROOSTER": "a domestic cock [n -S]\n",
  "ROOSTERS": "ROOSTER, a domestic cock [n]\n",
  "ROOSTING": "ROOST, to prepare for sleep by perching [v]\n",
  "ROOSTS": "ROOST, to prepare for sleep by perching [v]\n",
  "ROOT": "to implant in the earth [v -ED, -ING, -S]\n",
  "ROOTAGE": "a system of roots [n -S]\n",
  "ROOTAGES": "ROOTAGE, a system of roots [n]\n",
  "ROOTBALL": "the mass of a plant's roots and surrounding soil [n -S]\n",
  "ROOTBALLS": "ROOTBALL, the mass of a plant's roots and surrounding soil [n]\n",
  "ROOTBOUND": "rooted to the ground; potbound [adj]\n",
  "ROOTCAP": "the loose mass of cells that covers the tip of some roots [n -S]\n",
  "ROOTCAPS": "ROOTCAP, the loose mass of cells that covers the tip of some roots [n]\n",
  "ROOTED": "ROOT, to implant in the earth [v]\n",
  "ROOTEDLY": "ROOTED, ROOT, to implant in the earth [adv]\n",
  "ROOTEDNESS": "the state of being rooted [n -ES]\n",
  "ROOTEDNESSES": "ROOTEDNESS, the state of being rooted [n]\n",
  "ROOTER": "a vocal supporter [n -S]\n",
  "ROOTERS": "ROOTER, a vocal supporter [n]\n",
  "ROOTHOLD": "maintenance of position by roots [n -S]\n",
  "ROOTHOLDS": "ROOTHOLD, maintenance of position by roots [n]\n",
  "ROOTIER": "ROOTY, full of roots [adj]\n",
  "ROOTIES": "ROOTY, military slang for bread [n]\n",
  "ROOTIEST": "ROOTY, full of roots [adj]\n",
  "ROOTINESS": "the state of being rooty [n -ES]\n",
  "ROOTINESSES": "ROOTINESS, the state of being rooty [n]\n",
  "ROOTING": "the act of rooting [n -S]\n",
  "ROOTINGS": "ROOTING, the act of rooting [n]\n",
  "ROOTKIT": "a set of programs used to gain unauthorized access to a computer's operating system, esp. in order to destroy or alter files, attack other computers, etc. [n -S]\n",
  "ROOTKITS": "ROOTKIT, a set of programs used to gain unauthorized access to a computer's operating system, esp. in order to destroy or alter files, attack other computers, etc. [n]\n",
  "ROOTLE": "to grub [v ROOTLED, ROOTLING, ROOTLES]\n",
  "ROOTLED": "ROOTLE, to grub [v]\n",
  "ROOTLES": "ROOTLE, to grub [v]\n",
  "ROOTLESS": "without roots [adj]\n",
  "ROOTLESSNESS": "the state of being rootless [n -ES]\n",
  "ROOTLESSNESSES": "ROOTLESSNESS, the state of being rootless [n]\n",
  "ROOTLET": "a small root [n -S]\n",
  "ROOTLETS": "ROOTLET, a small root [n]\n",
  "ROOTLIKE": "like a root [adj]\n",
  "ROOTLING": "ROOTLE, to grub [v]\n",
  "ROOTS": "ROOT, to implant in the earth [v]\n",
  "ROOTSERVER": "a computer that acts as the main server for a whole service [n -S]\n",
  "ROOTSERVERS": "ROOTSERVER, a computer that acts as the main server for a whole service [n]\n",
  "ROOTSIER": "ROOTSY, reminiscent of folk styles [adj]\n",
  "ROOTSIEST": "ROOTSY, reminiscent of folk styles [adj]\n",
  "ROOTSINESS": "the state of being rootsy [n -ES]\n",
  "ROOTSINESSES": "ROOTSINESS, the state of being rootsy [n]\n",
  "ROOTSTALK": "an underground stem producing roots and leafy shoots, aka rhizome [n -S]\n",
  "ROOTSTALKS": "ROOTSTALK, an underground stem producing roots and leafy shoots, aka rhizome [n]\n",
  "ROOTSTOCK": "a rhizome, esp. if short, thick, and more or less erect [n -S]\n",
  "ROOTSTOCKS": "ROOTSTOCK, a rhizome, esp. if short, thick, and more or less erect [n]\n",
  "ROOTSY": "reminiscent of folk styles [adj ROOTSIER, ROOTSIEST]\n",
  "ROOTWORM": "a beetle whose larvae feed on the roots of crop plants [n -S]\n",
  "ROOTWORMS": "ROOTWORM, a beetle whose larvae feed on the roots of crop plants [n]\n",
  "ROOTY": "full of roots [adj ROOTIER, ROOTIEST] / military slang for bread [n ROOTIES]\n",
  "ROPABLE": "that can be roped, also ROPEABLE [adj]\n",
  "ROPE": "to bind with thick twisted fibre [v ROPED, ROPING, ROPES]\n",
  "ROPEABLE": "that can be roped, also ROPABLE [adj]\n",
  "ROPED": "ROPE, to bind with thick twisted fibre [v]\n",
  "ROPEDANCER": "one who dances, walks, or performs acrobatic feats, on a tightrope [n -S]\n",
  "ROPEDANCERS": "ROPEDANCER, one who dances, walks, or performs acrobatic feats, on a tightrope [n]\n",
  "ROPEDANCING": "the sport of dancing with a rope [n -S]\n",
  "ROPEDANCINGS": "ROPEDANCING, the sport of dancing with a rope [n]\n",
  "ROPELIKE": "resembling a rope [adj]\n",
  "ROPER": "a rope-maker [n -S]\n",
  "ROPERIES": "ROPERY, a place where ropes are made [n]\n",
  "ROPERS": "ROPER, a rope-maker [n]\n",
  "ROPERY": "a place where ropes are made [n ROPERIES]\n",
  "ROPES": "ROPE, to bind with thick twisted fibre [v]\n",
  "ROPEWALK": "a long narrow shed or alley for twisting strands into a rope [n -S]\n",
  "ROPEWALKER": "a ropedancer [n -S]\n",
  "ROPEWALKERS": "ROPEWALKER, a ropedancer [n]\n",
  "ROPEWALKS": "ROPEWALK, a long narrow shed or alley for twisting strands into a rope [n]\n",
  "ROPEWAY": "an aerial cable used to transport freight [n -S]\n",
  "ROPEWAYS": "ROPEWAY, an aerial cable used to transport freight [n]\n",
  "ROPEWORK": "a place where ropes are made [n -S]\n",
  "ROPEWORKS": "ROPEWORK, a place where ropes are made [n]\n",
  "ROPEY": "resembling rope, also ROPY [adj ROPIER, ROPIEST]\n",
  "ROPIER": "ROPY, resembling rope, also ROPEY [adj]\n",
  "ROPIEST": "ROPY, resembling rope, also ROPEY [adj]\n",
  "ROPILY": "ROPY, resembling rope, also ROPEY [adv]\n",
  "ROPINESS": "the state of being ropy [n -ES]\n",
  "ROPINESSES": "ROPINESS, the state of being ropy [n]\n",
  "ROPING": "the act of roping [n -S]\n",
  "ROPINGS": "ROPING, the act of roping [n]\n",
  "ROPY": "resembling rope, also ROPEY [adj ROPIER, ROPIEST, ROPILY]\n",
  "ROQUE": "a form of croquet [n -S]\n",
  "ROQUEFORT": "(French) a kind of French cheese [n -S]\n",
  "ROQUEFORTS": "ROQUEFORT, (French) a kind of French cheese [n]\n",
  "ROQUELAURE": "a cloak reaching about to, or just below, the knees, worn in the 18th century, also ROCKLAY, ROKELAY [n -S]\n",
  "ROQUELAURES": "ROQUELAURE, a cloak reaching about to, or just below, the knees, worn in the 18th century, also ROCKLAY, ROKELAY [n]\n",
  "ROQUES": "ROQUE, a form of croquet [n]\n",
  "ROQUET": "in croquet, a stroke by which the player's ball strikes an opponent's [n -S] / to make such a stroke, also ROCQUET [v -ED, -ING, -S]\n",
  "ROQUETED": "ROQUET, to make such a stroke, also ROCQUET [v]\n",
  "ROQUETING": "ROQUET, to make such a stroke, also ROCQUET [v]\n",
  "ROQUETS": "ROQUET, to make such a stroke, also ROCQUET [v]\n",
  "ROQUETTE": "(French) a kind of salad plant, also ROCKET [n -S]\n",
  "ROQUETTES": "ROQUETTE, (French) a kind of salad plant, also ROCKET [n]\n",
  "RORAL": "dewy, also RORIC, RORID [adj]\n",
  "RORE": "(Shakespeare) a roar, tumult [n -S]\n",
  "RORES": "RORE, (Shakespeare) a roar, tumult [n]\n",
  "RORIC": "dewy, also RORAL, RORID [adj]\n",
  "RORID": "dewy, also RORAL, RORIC [adj]\n",
  "RORIE": "noisy, garish, too bright, also ROARIE, ROARY, RORY [adj]\n",
  "RORIER": "RORY, (Scots) noisy, garish, also ROARIE, ROARY, RORIE [adj]\n",
  "RORIEST": "RORY, (Scots) noisy, garish, also ROARIE, ROARY, RORIE [adj]\n",
  "RORQUAL": "a large whale, a finback [n -S]\n",
  "RORQUALS": "RORQUAL, a large whale, a finback [n]\n",
  "RORT": "(Australian slang) to falsify accounts [v -ED, -ING, -S]\n",
  "RORTED": "RORT, (Australian slang) to falsify accounts [v]\n",
  "RORTER": "a conman [n -S]\n",
  "RORTERS": "RORTER, a conman [n]\n",
  "RORTIER": "RORTY, (Australian slang) lively, enjoyable [adj]\n",
  "RORTIEST": "RORTY, (Australian slang) lively, enjoyable [adj]\n",
  "RORTING": "the falsification of accounts [n -S]\n",
  "RORTINGS": "RORTING, the falsification of accounts [n]\n",
  "RORTS": "RORT, (Australian slang) to falsify accounts [v]\n",
  "RORTY": "(Australian slang) lively, enjoyable [adj RORTIER, RORTIEST]\n",
  "RORY": "(Scots) noisy, garish, also ROARIE, ROARY, RORIE [adj RORIER, RORIEST]\n",
  "ROSACE": "(French) a rosette; a rose-window [n -S]\n",
  "ROSACEA": "(Latin) a skin disease [n -S]\n",
  "ROSACEAS": "ROSACEA, (Latin) a skin disease [n]\n",
  "ROSACEOUS": "of or pertaining to the Rosaceae or rose family [adj]\n",
  "ROSACES": "ROSACE, (French) a rosette; a rose-window [n]\n",
  "ROSAKER": "(obsolete) a bright-red monoclinic mineral, now called realgar [n -S]\n",
  "ROSAKERS": "ROSAKER, (obsolete) a bright-red monoclinic mineral, now called realgar [n]\n",
  "ROSALIA": "(Italian) a series of repetitions of the same musical passage, each a tone higher [n -S]\n",
  "ROSALIAS": "ROSALIA, (Italian) a series of repetitions of the same musical passage, each a tone higher [n]\n",
  "ROSANILIN": "a reddish-brown derivative of anilin used as a dye [n -S]\n",
  "ROSANILINE": "a base derived from aniline, with red salts used in dyeing [n -S]\n",
  "ROSANILINES": "ROSANILINE, a base derived from aniline, with red salts used in dyeing [n]\n",
  "ROSANILINS": "ROSANILIN, a reddish-brown derivative of anilin used as a dye [n]\n",
  "ROSARIA": "ROSARIUM, (Latin) a rose garden [n]\n",
  "ROSARIAN": "a cultivator of roses [n -S]\n",
  "ROSARIANS": "ROSARIAN, a cultivator of roses [n]\n",
  "ROSARIES": "ROSARY, a series of prayers in the Roman Catholic Church [n]\n",
  "ROSARIUM": "(Latin) a rose garden [n ROSARIUMS or ROSARIA]\n",
  "ROSARIUMS": "ROSARIUM, (Latin) a rose garden [n]\n",
  "ROSARY": "a series of prayers in the Roman Catholic Church [n ROSARIES]\n",
  "ROSBIF": "(French) an English person [n -S]\n",
  "ROSBIFS": "ROSBIF, (French) an English person [n]\n",
  "ROSCID": "dewy [adj]\n",
  "ROSCOE": "(US slang) a gun [n -S]\n",
  "ROSCOES": "ROSCOE, (US slang) a gun [n]\n",
  "ROSE": "to redden [v ROSED, ROSING, ROSES]\n",
  "ROSEAL": "resembling a rose in smell or color [adj]\n",
  "ROSEATE": "resembling a rose; overly optimistic [adj ROSEATELY]\n",
  "ROSEATELY": "ROSEATE, resembling a rose; overly optimistic [adv]\n",
  "ROSEBAY": "the oleander; any rhododendron [n -S]\n",
  "ROSEBAYS": "ROSEBAY, the oleander; any rhododendron [n]\n",
  "ROSEBED": "a part of a garden where roses grow [n -S]\n",
  "ROSEBEDS": "ROSEBED, a part of a garden where roses grow [n]\n",
  "ROSEBOWL": "a bowl for keeping roses in [n -S]\n",
  "ROSEBOWLS": "ROSEBOWL, a bowl for keeping roses in [n]\n",
  "ROSEBUD": "the bud of a rose [n -S]\n",
  "ROSEBUDS": "ROSEBUD, the bud of a rose [n]\n",
  "ROSEBUSH": "a bush that bears roses [n -ES]\n",
  "ROSEBUSHES": "ROSEBUSH, a bush that bears roses [n]\n",
  "ROSED": "ROSE, to redden [v]\n",
  "ROSEFINCH": "any of various finches found in Europe and Asia, the males more or less covered with red or pink plumage [n -ES]\n",
  "ROSEFINCHES": "ROSEFINCH, any of various finches found in Europe and Asia, the males more or less covered with red or pink plumage [n]\n",
  "ROSEFISH": "a large marine food fish, aka bergylt [n -ES]\n",
  "ROSEFISHES": "ROSEFISH, a large marine food fish, aka bergylt [n]\n",
  "ROSEHIP": "the fruit of the rose [n -S]\n",
  "ROSEHIPS": "ROSEHIP, the fruit of the rose [n]\n",
  "ROSELESS": "having no roses [adj]\n",
  "ROSELIKE": "like a rose [adj]\n",
  "ROSELLA": "an Australian parakeet [n -S]\n",
  "ROSELLAS": "ROSELLA, an Australian parakeet [n]\n",
  "ROSELLE": "an East Indian hibiscus, also ROZELLE [n -S]\n",
  "ROSELLES": "ROSELLE, an East Indian hibiscus, also ROZELLE [n]\n",
  "ROSEMALING": "(Norwegian) the art of painting (wooden objects) with flower motifs; flower motifs, esp. painted on wood [n -S]\n",
  "ROSEMALINGS": "ROSEMALING, (Norwegian) the art of painting (wooden objects) with flower motifs; flower motifs, esp. painted on wood [n]\n",
  "ROSEMARIES": "ROSEMARY, an evergreen shrub [n]\n",
  "ROSEMARY": "an evergreen shrub [n ROSEMARIES]\n",
  "ROSEOLA": "a rose-coloured skin rash [n -S]\n",
  "ROSEOLAR": "like roseola, a rash of rose-colored patches [adj]\n",
  "ROSEOLAS": "ROSEOLA, a rose-coloured skin rash [n]\n",
  "ROSERIES": "ROSERY, a place where roses are grown [n]\n",
  "ROSEROOT": "a fleshy-leaved herb, so called because the roots have the odor of roses [n -S]\n",
  "ROSEROOTS": "ROSEROOT, a fleshy-leaved herb, so called because the roots have the odor of roses [n]\n",
  "ROSERY": "a place where roses are grown [n ROSERIES]\n",
  "ROSES": "ROSE, to redden [v]\n",
  "ROSESLUG": "a larval sawfly that eats rose leaves [n -S]\n",
  "ROSESLUGS": "ROSESLUG, a larval sawfly that eats rose leaves [n]\n",
  "ROSET": "(Scots) to coat with rosin [v -ED, -ING, -S]\n",
  "ROSETED": "ROSET, (Scots) to coat with rosin [v]\n",
  "ROSETING": "ROSET, (Scots) to coat with rosin [v]\n",
  "ROSETS": "ROSET, (Scots) to coat with rosin [v]\n",
  "ROSETTE": "a knot or radiating loops of ribbon concentrically arranged [n -S] / to award a rosette to [v ROSETTED, ROSETTING, ROSETTES]\n",
  "ROSETTED": "ROSETTE, to award a rosette to [v]\n",
  "ROSETTES": "ROSETTE, to award a rosette to [v]\n",
  "ROSETTING": "the development of abnormal leaves as a symptom of disease [n -S]\n",
  "ROSETTINGS": "ROSETTING, the development of abnormal leaves as a symptom of disease [n]\n",
  "ROSETTY": "(Scots) like rosin, also ROSETY [adj]\n",
  "ROSETY": "(Scots) like rosin, also ROSETTY [adj]\n",
  "ROSEWATER": "water distilled from roses, or scented with essence of roses, used as a perfume etc. [n -S]\n",
  "ROSEWATERS": "ROSEWATER, water distilled from roses, or scented with essence of roses, used as a perfume etc. [n]\n",
  "ROSEWOOD": "a valuable cabinet wood of a dark red color [n -S]\n",
  "ROSEWOODS": "ROSEWOOD, a valuable cabinet wood of a dark red color [n]\n",
  "ROSHAMBO": "(Japanese) the game of rock-paper-scissors [n -S]\n",
  "ROSHAMBOS": "ROSHAMBO, (Japanese) the game of rock-paper-scissors [n]\n",
  "ROSHI": "(Japanese) a teacher of Zen Buddhism [n -S]\n",
  "ROSHIS": "ROSHI, (Japanese) a teacher of Zen Buddhism [n]\n",
  "ROSIED": "ROSY, to redden [v]\n",
  "ROSIER": "a rosebush, also ROSIERE [n -S]\n",
  "ROSIERE": "(Spenser) a rosebush, also ROSIER [n -S]\n",
  "ROSIERES": "ROSIERE, (Spenser) a rosebush, also ROSIER [n]\n",
  "ROSIERS": "ROSIER, a rosebush, also ROSIERE [n]\n",
  "ROSIES": "ROSY, to redden [v]\n",
  "ROSIEST": "ROSY, rose-coloured [adj]\n",
  "ROSILY": "ROSY, rose-coloured [adv]\n",
  "ROSIN": "to treat with a brittle resin, also ROSET [v -ED, -ING, -S]\n",
  "ROSINATE": "a resinate [n -S]\n",
  "ROSINATES": "ROSINATE, a resinate [n]\n",
  "ROSINED": "ROSIN, to treat with a brittle resin, also ROSET [v]\n",
  "ROSINER": "(Australian slang) a strong alcoholic drink [n -S]\n",
  "ROSINERS": "ROSINER, (Australian slang) a strong alcoholic drink [n]\n",
  "ROSINESS": "the state of being rosy [n -ES]\n",
  "ROSINESSES": "ROSINESS, the state of being rosy [n]\n",
  "ROSING": "ROSE, to redden [v]\n",
  "ROSINIER": "ROSINY, like rosin, or having its qualities [adj]\n",
  "ROSINIEST": "ROSINY, like rosin, or having its qualities [adj]\n",
  "ROSINING": "ROSIN, to treat with a brittle resin, also ROSET [v]\n",
  "ROSINOL": "a rosin oil [n -S]\n",
  "ROSINOLS": "ROSINOL, a rosin oil [n]\n",
  "ROSINOUS": "resembling rosin [adj]\n",
  "ROSINS": "ROSIN, to treat with a brittle resin, also ROSET [v]\n",
  "ROSINWEED": "the compass-plant, Silphium [n -S]\n",
  "ROSINWEEDS": "ROSINWEED, the compass-plant, Silphium [n]\n",
  "ROSINY": "like rosin, or having its qualities [adj ROSINIER, ROSINIEST]\n",
  "ROSIT": "(Scots) to coat with rosin, also ROSET, ROZET, ROZIT [v -ED, -ING, -S]\n",
  "ROSITED": "ROSIT, (Scots) to coat with rosin, also ROSET, ROZET, ROZIT [v]\n",
  "ROSITING": "ROSIT, (Scots) to coat with rosin, also ROSET, ROZET, ROZIT [v]\n",
  "ROSITS": "ROSIT, (Scots) to coat with rosin, also ROSET, ROZET, ROZIT [v]\n",
  "ROSMARINE": "(Spenser) a mythical walrus-like sea animal that feeds on dew [n -S]\n",
  "ROSMARINES": "ROSMARINE, (Spenser) a mythical walrus-like sea animal that feeds on dew [n]\n",
  "ROSOGLIO": "(Italian) a sweet cordial made with raisins, also ROSOLIO [n -S]\n",
  "ROSOGLIOS": "ROSOGLIO, (Italian) a sweet cordial made with raisins, also ROSOLIO [n]\n",
  "ROSOLIO": "(Italian) a sweet cordial made with raisins, also ROSOGLIO [n -S]\n",
  "ROSOLIOS": "ROSOLIO, (Italian) a sweet cordial made with raisins, also ROSOGLIO [n]\n",
  "ROSSER": "(slang) a policeman, also ROZZER [n -S]\n",
  "ROSSERS": "ROSSER, (slang) a policeman, also ROZZER [n]\n",
  "ROST": "(obsolete) to roast [v -ED, -ING, -S]\n",
  "ROSTED": "ROST, (obsolete) to roast [v]\n",
  "ROSTELLA": "ROSTELLUM, (Latin) the protruding forepart of the head of a tapeworm, armed with hooklets or spines [n]\n",
  "ROSTELLAR": "pertaining to a rostellum, a small beaklike process or extension of some part [adj]\n",
  "ROSTELLATE": "having a rostellum, or small beak; terminating in a beak [adj]\n",
  "ROSTELLUM": "(Latin) the protruding forepart of the head of a tapeworm, armed with hooklets or spines [n ROSTELLUMS or ROSTELLA]\n",
  "ROSTELLUMS": "ROSTELLUM, (Latin) the protruding forepart of the head of a tapeworm, armed with hooklets or spines [n]\n",
  "ROSTER": "to put on a list of duties [v -ED, -ING, -S]\n",
  "ROSTERED": "ROSTER, to put on a list of duties [v]\n",
  "ROSTERING": "the act of rostering [n -S]\n",
  "ROSTERINGS": "ROSTERING, the act of rostering [n]\n",
  "ROSTERS": "ROSTER, to put on a list of duties [v]\n",
  "ROSTI": "a cheese-topped fried Swiss dish consisting of grated potato and onion, also ROESTI [n -S]\n",
  "ROSTING": "ROST, (obsolete) to roast [v]\n",
  "ROSTIS": "ROSTI, a cheese-topped fried Swiss dish consisting of grated potato and onion, also ROESTI [n]\n",
  "ROSTRA": "ROSTRUM, (Latin) a beaklike process or part [n]\n",
  "ROSTRAL": "of or like a rostrum, a spike on prow of warship for ramming [adj]\n",
  "ROSTRALLY": "ROSTRAL, of or like a rostrum, a spike on prow of warship for ramming [adv]\n",
  "ROSTRATE": "having a rostrum [adj]\n",
  "ROSTRATED": "beak-shaped, also ROSTRATE [adj]\n",
  "ROSTROCARINATE": "beaked and keeled [adj] / a supposed flint implement with beak and keel [n -S]\n",
  "ROSTROCARINATES": "ROSTROCARINATE, a supposed flint implement with beak and keel [n]\n",
  "ROSTRUM": "(Latin) a beaklike process or part [n ROSTRUMS or ROSTRA]\n",
  "ROSTRUMS": "ROSTRUM, (Latin) a beaklike process or part [n]\n",
  "ROSTS": "ROST, (obsolete) to roast [v]\n",
  "ROSULA": "(Latin) a leaf-rosette [n -S]\n",
  "ROSULAS": "ROSULA, (Latin) a leaf-rosette [n]\n",
  "ROSULATE": "of leaves and bracts, arranged in little roselike clusters [adj]\n",
  "ROSY": "rose-coloured [adj ROSIER, ROSIEST, ROSILY] / to redden [v ROSIED, ROSYING, ROSIES]\n",
  "ROSYING": "ROSY, to redden [v]\n",
  "ROT": "to decompose [v ROTTED, ROTTING, ROTS]\n",
  "ROTA": "(Latin) a list of names [n -S]\n",
  "ROTACHUTE": "a parachute-like device where the chute is replaced by rotors [n -S]\n",
  "ROTACHUTES": "ROTACHUTE, a parachute-like device where the chute is replaced by rotors [n]\n",
  "ROTAL": "relating to wheels or to rotary motion [adj]\n",
  "ROTAMETER": "(tradename) an instrument for measuring the length of curved lines [n -S]\n",
  "ROTAMETERS": "ROTAMETER, (tradename) an instrument for measuring the length of curved lines [n]\n",
  "ROTAN": "(Malay) a climbing plant with long thin stems, also RATAN, RATTAN [n -S]\n",
  "ROTANS": "ROTAN, (Malay) a climbing plant with long thin stems, also RATAN, RATTAN [n]\n",
  "ROTAPLANE": "a rotor plane [n -S]\n",
  "ROTAPLANES": "ROTAPLANE, a rotor plane [n]\n",
  "ROTARIES": "ROTARY, a rotating part or device [n]\n",
  "ROTARY": "a rotating part or device [n ROTARIES]\n",
  "ROTAS": "ROTA, (Latin) a list of names [n]\n",
  "ROTATABLE": "that can be rotated [adj]\n",
  "ROTATE": "to turn like a wheel [v ROTATED, ROTATING, ROTATES]\n",
  "ROTATED": "ROTATE, to turn like a wheel [v]\n",
  "ROTATES": "ROTATE, to turn like a wheel [v]\n",
  "ROTATING": "ROTATE, to turn like a wheel [v]\n",
  "ROTATION": "an instance of rotating [n -S]\n",
  "ROTATIONAL": "relating to rotation, also ROTARY, ROTATIVE, ROTATORY [adj]\n",
  "ROTATIONS": "ROTATION, an instance of rotating [n]\n",
  "ROTATIVE": "turning like a wheel, also ROTARY, ROTATIONAL, ROTATORY [adj ROTATIVELY]\n",
  "ROTATIVELY": "ROTATIVE, turning like a wheel, also ROTARY, ROTATIONAL, ROTATORY [adv]\n",
  "ROTATOR": "a muscle serving to rotate a part of the body [n ROTATORS or ROTATORES]\n",
  "ROTATORES": "ROTATOR, a muscle serving to rotate a part of the body [n]\n",
  "ROTATORS": "ROTATOR, a muscle serving to rotate a part of the body [n]\n",
  "ROTATORY": "turning as on an axis, also ROTARY, ROTATIONAL, ROTATIVE [adj]\n",
  "ROTAVATE": "to till by means of a hand-operated machine, also ROTOVATE [v ROTAVATED, ROTAVATING, ROTAVATES]\n",
  "ROTAVATED": "ROTAVATE, to till by means of a hand-operated machine, also ROTOVATE [v]\n",
  "ROTAVATES": "ROTAVATE, to till by means of a hand-operated machine, also ROTOVATE [v]\n",
  "ROTAVATING": "ROTAVATE, to till by means of a hand-operated machine, also ROTOVATE [v]\n",
  "ROTAVATOR": "(tradename) a tool for breaking up the soil, also ROTOVATOR [n -S]\n",
  "ROTAVATORS": "ROTAVATOR, (tradename) a tool for breaking up the soil, also ROTOVATOR [n]\n",
  "ROTAVIRAL": "of or like a rotavirus [adj]\n",
  "ROTAVIRUS": "a wheel-shaped virus causing gastroenteritis [n -ES]\n",
  "ROTAVIRUSES": "ROTAVIRUS, a wheel-shaped virus causing gastroenteritis [n]\n",
  "ROTCH": "the little auk, also ROCH, ROTCHE, ROTCHIE [n -ES]\n",
  "ROTCHE": "the little auk, also ROCH, ROTCH, ROTCHIE [n -S]\n",
  "ROTCHES": "ROTCH, the little auk, also ROCH, ROTCHE, ROTCHIE [n]\n",
  "ROTCHIE": "the little auk, also ROCH, ROTCH, ROTCHE [n -S]\n",
  "ROTCHIES": "ROTCHIE, the little auk, also ROCH, ROTCH, ROTCHE [n]\n",
  "ROTE": "using mechanical memory, repetition or performance without regard to the meaning, also ROATE [adj ROTELY] / to fix by rote [v ROTED, ROTING, ROTES]\n",
  "ROTED": "ROTE, to fix by rote [v]\n",
  "ROTELY": "by rote [adv]\n",
  "ROTENONE": "an insecticide and fish-poison prepared from derris and other roots [n -S]\n",
  "ROTENONES": "ROTENONE, an insecticide and fish-poison prepared from derris and other roots [n]\n",
  "ROTES": "ROTE, to fix by rote [v]\n",
  "ROTGRASS": "soft grass, butterwort, pennywort or other plant reputed to cause sheep-rot [n -ES]\n",
  "ROTGRASSES": "ROTGRASS, soft grass, butterwort, pennywort or other plant reputed to cause sheep-rot [n]\n",
  "ROTGUT": "(colloquial) rough, cheap alcohol, also GUTROT [n -S]\n",
  "ROTGUTS": "ROTGUT, (colloquial) rough, cheap alcohol, also GUTROT [n]\n",
  "ROTHER": "(obsolete) an ox, cow [n -S]\n",
  "ROTHERS": "ROTHER, (obsolete) an ox, cow [n]\n",
  "ROTI": "(Hindi) a cake of unleavened bread [n -S]\n",
  "ROTIFER": "(Latin) a microscopic aquatic organism [n -S]\n",
  "ROTIFERAL": "relating to a rotifer, a microscopic, multicellular, freshwater creature with rotating cilia at one end, also ROTIFEROUS [adj]\n",
  "ROTIFERAN": "a rotifer [n -S]\n",
  "ROTIFERANS": "ROTIFERAN, a rotifer [n]\n",
  "ROTIFEROUS": "relating to a rotifer, a microscopic, multicellular, freshwater creature with rotating cilia at one end, also ROTIFERAL [adj]\n",
  "ROTIFERS": "ROTIFER, (Latin) a microscopic aquatic organism [n]\n",
  "ROTIFORM": "shaped like a wheel [adj]\n",
  "ROTING": "ROTE, to fix by rote [v]\n",
  "ROTINI": "(Italian) a kind of pasta in small spirals [n -S]\n",
  "ROTINIS": "ROTINI, (Italian) a kind of pasta in small spirals [n]\n",
  "ROTIS": "ROTI, (Hindi) a cake of unleavened bread [n]\n",
  "ROTISSERIE": "(French) to cook using an incorporating a spit [v ROTISSERIED, ROTISSERIEING, ROTISSERIES]\n",
  "ROTISSERIED": "ROTISSERIE, (French) to cook using an incorporating a spit [v]\n",
  "ROTISSERIEING": "ROTISSERIE, (French) to cook using an incorporating a spit [v]\n",
  "ROTISSERIES": "ROTISSERIE, (French) to cook using an incorporating a spit [v]\n",
  "ROTL": "(Arabic) a variable Levantine weight, also ROTOLO [n ARTAL or ROTLS]\n",
  "ROTLS": "ROTL, (Arabic) a variable Levantine weight, also ROTOLO [n]\n",
  "ROTO": "(short for) rotogravure, a type of printing process [n -S]\n",
  "ROTOGRAPH": "to make a photograph by laying negative on sensitive paper [v -ED, -ING, -S]\n",
  "ROTOGRAPHED": "ROTOGRAPH, to make a photograph by laying negative on sensitive paper [v]\n",
  "ROTOGRAPHING": "ROTOGRAPH, to make a photograph by laying negative on sensitive paper [v]\n",
  "ROTOGRAPHS": "ROTOGRAPH, to make a photograph by laying negative on sensitive paper [v]\n",
  "ROTOGRAVURE": "an intaglio printing process by which imagery is transferred from a copper cylinder to a web of paper, plastic or similar material in a rotary press [n -S]\n",
  "ROTOGRAVURES": "ROTOGRAVURE, an intaglio printing process by which imagery is transferred from a copper cylinder to a web of paper, plastic or similar material in a rotary press [n]\n",
  "ROTOLI": "ROTOLO, (Italian) an Italian form of rotl, a unit of weight, also ROTL [n]\n",
  "ROTOLO": "(Italian) an Italian form of rotl, a unit of weight, also ROTL [n ROTOLI or ROTOLOS]\n",
  "ROTOLOS": "ROTOLO, (Italian) an Italian form of rotl, a unit of weight, also ROTL [n]\n",
  "ROTON": "a quantum of vortex motion [n -S]\n",
  "ROTONS": "ROTON, a quantum of vortex motion [n]\n",
  "ROTOR": "a rotating part of a machine [n -S]\n",
  "ROTORCRAFT": "a helicopter or autogyro [n -S]\n",
  "ROTORCRAFTS": "ROTORCRAFT, a helicopter or autogyro [n]\n",
  "ROTORS": "ROTOR, a rotating part of a machine [n]\n",
  "ROTOS": "ROTO, (short for) rotogravure, a type of printing process [n]\n",
  "ROTOSCOPE": "to create the outline of an object from live-action film for manipulation in an animated film sequence [v ROTOSCOPED, ROTOSCOPING, ROTOSCOPES]\n",
  "ROTOSCOPED": "ROTOSCOPE, to create the outline of an object from live-action film for manipulation in an animated film sequence [v]\n",
  "ROTOSCOPES": "ROTOSCOPE, to create the outline of an object from live-action film for manipulation in an animated film sequence [v]\n",
  "ROTOSCOPING": "ROTOSCOPE, to create the outline of an object from live-action film for manipulation in an animated film sequence [v]\n",
  "ROTOTILL": "to till soil with a type of farming implement [v -ED, -ING, -S]\n",
  "ROTOTILLED": "ROTOTILL, to till soil with a type of farming implement [v]\n",
  "ROTOTILLER": "an implement used to rototill [n -S]\n",
  "ROTOTILLERS": "ROTOTILLER, an implement used to rototill [n]\n",
  "ROTOTILLING": "ROTOTILL, to till soil with a type of farming implement [v]\n",
  "ROTOTILLS": "ROTOTILL, to till soil with a type of farming implement [v]\n",
  "ROTOVATE": "to till by means of a hand-operated machine, also ROTAVATE [v ROTOVATED, ROTOVATING, ROTOVATES]\n",
  "ROTOVATED": "ROTOVATE, to till by means of a hand-operated machine, also ROTAVATE [v]\n",
  "ROTOVATES": "ROTOVATE, to till by means of a hand-operated machine, also ROTAVATE [v]\n",
  "ROTOVATING": "ROTOVATE, to till by means of a hand-operated machine, also ROTAVATE [v]\n",
  "ROTOVATOR": "(tradename) a tool for breaking up the soil, also ROTAVATOR [n -S]\n",
  "ROTOVATORS": "ROTOVATOR, (tradename) a tool for breaking up the soil, also ROTAVATOR [n]\n",
  "ROTPROOF": "proof against rot [adj]\n",
  "ROTS": "ROT, to decompose [v]\n",
  "ROTTAN": "(dialect) a rat, also RATTON, ROTTEN [n -S]\n",
  "ROTTANS": "ROTTAN, (dialect) a rat, also RATTON, ROTTEN [n]\n",
  "ROTTE": "a medieval stringed instrument [n -S]\n",
  "ROTTED": "ROT, to decompose [v]\n",
  "ROTTEN": "very bad, rotted, also RATTON, ROTTAN [adj ROTTENER, ROTTENEST, ROTTENLY] / a rat [n -S]\n",
  "ROTTENER": "ROTTEN, very bad, rotted, also RATTON, ROTTAN [adj]\n",
  "ROTTENEST": "ROTTEN, very bad, rotted, also RATTON, ROTTAN [adj]\n",
  "ROTTENLY": "ROTTEN, very bad, rotted, also RATTON, ROTTAN [adv]\n",
  "ROTTENNESS": "the state of being rotten [n -ES]\n",
  "ROTTENNESSES": "ROTTENNESS, the state of being rotten [n]\n",
  "ROTTENS": "ROTTEN, a rat [n]\n",
  "ROTTENSTONE": "friable, decomposed, siliceous limestone used for polishing [n -S] / to polish with rottenstone [v ROTTENSTONED, ROTTENSTONING, ROTTENSTONES]\n",
  "ROTTENSTONED": "ROTTENSTONE, to polish with rottenstone [v]\n",
  "ROTTENSTONES": "ROTTENSTONE, to polish with rottenstone [v]\n",
  "ROTTENSTONING": "ROTTENSTONE, to polish with rottenstone [v]\n",
  "ROTTER": "a scoundrel [n -S]\n",
  "ROTTERS": "ROTTER, a scoundrel [n]\n",
  "ROTTES": "ROTTE, a medieval stringed instrument [n]\n",
  "ROTTING": "ROT, to decompose [v]\n",
  "ROTTWEILER": "(German) an aggressive, ruthless person [n -S]\n",
  "ROTTWEILERS": "ROTTWEILER, (German) an aggressive, ruthless person [n]\n",
  "ROTULA": "(Latin) the kneecap or patella [n ROTULAS or ROTULAE]\n",
  "ROTULAE": "ROTULA, (Latin) the kneecap or patella [n]\n",
  "ROTULAS": "ROTULA, (Latin) the kneecap or patella [n]\n",
  "ROTUND": "rounded, plump [adj ROTUNDER, ROTUNDEST, ROTUNDLY] / to round [v -ED, -ING, -S]\n",
  "ROTUNDA": "(Italian) a rounded, domed building or hall [n -S]\n",
  "ROTUNDAS": "ROTUNDA, (Italian) a rounded, domed building or hall [n]\n",
  "ROTUNDATE": "rounded off; orbicular [adj]\n",
  "ROTUNDED": "ROTUND, to round [v]\n",
  "ROTUNDER": "ROTUND, rounded, plump [adj]\n",
  "ROTUNDEST": "ROTUND, rounded, plump [adj]\n",
  "ROTUNDING": "ROTUND, to round [v]\n",
  "ROTUNDITIES": "ROTUNDITY, the state of being rotund [n]\n",
  "ROTUNDITY": "the state of being rotund [n ROTUNDITIES]\n",
  "ROTUNDLY": "ROTUND, rounded, plump [adv]\n",
  "ROTUNDNESS": "the state of being rotund [n -ES]\n",
  "ROTUNDNESSES": "ROTUNDNESS, the state of being rotund [n]\n",
  "ROTUNDS": "ROTUND, to round [v]\n",
  "ROTURIER": "a plebeian, a commoner; literally, one who breaks ground [n -S]\n",
  "ROTURIERS": "ROTURIER, a plebeian, a commoner; literally, one who breaks ground [n]\n",
  "ROUBLE": "(Russian) a monetary unit of the Soviet Union, also RUBLE [n -S]\n",
  "ROUBLES": "ROUBLE, (Russian) a monetary unit of the Soviet Union, also RUBLE [n]\n",
  "ROUCHE": "(French) a frill of lace or other material, also RUCHE [n -S]\n",
  "ROUCHED": "trimmed with a rouche, also RUCHED [adj]\n",
  "ROUCHES": "ROUCHE, (French) a frill of lace or other material, also RUCHE [n]\n",
  "ROUCHING": "a lace trimming, also RUCHING [n -S]\n",
  "ROUCHINGS": "ROUCHING, a lace trimming, also RUCHING [n]\n",
  "ROUCOU": "(Tupi) a bright orange colouring matter, aka annatto [n -S]\n",
  "ROUCOUS": "ROUCOU, (Tupi) a bright orange colouring matter, aka annatto [n]\n",
  "ROUE": "(French) a debauched man; a lecher [n -S]\n",
  "ROUEN": "(French) a type of domestic duck [n -S]\n",
  "ROUENS": "ROUEN, (French) a type of domestic duck [n]\n",
  "ROUES": "ROUE, (French) a debauched man; a lecher [n]\n",
  "ROUGE": "(French) to colour with a red cosmetic [v ROUGED, ROUGING, ROUGES]\n",
  "ROUGED": "ROUGE, (French) to colour with a red cosmetic [v]\n",
  "ROUGES": "ROUGE, (French) to colour with a red cosmetic [v]\n",
  "ROUGH": "having an uneven surface [adj ROUGHER, ROUGHEST, ROUGHLY] / to make rough [v -ED, -ING, -S]\n",
  "ROUGHAGE": "coarse, bulky food [n -S]\n",
  "ROUGHAGES": "ROUGHAGE, coarse, bulky food [n]\n",
  "ROUGHBACK": "a rough-skinned flatfish [n -S]\n",
  "ROUGHBACKS": "ROUGHBACK, a rough-skinned flatfish [n]\n",
  "ROUGHCAST": "plaster mixed with small stones or shells, used to coat the outside walls of buildings [n -S] / to cover with roughcast [v -ED, -ING, -S]\n",
  "ROUGHCASTED": "ROUGHCAST, to cover with roughcast [v]\n",
  "ROUGHCASTER": "one who applies roughcast [n -S]\n",
  "ROUGHCASTERS": "ROUGHCASTER, one who applies roughcast [n]\n",
  "ROUGHCASTING": "ROUGHCAST, to cover with roughcast [v]\n",
  "ROUGHCASTS": "ROUGHCAST, to cover with roughcast [v]\n",
  "ROUGHDRIED": "ROUGHDRY, to dry without ironing, as washed clothes [v]\n",
  "ROUGHDRIES": "ROUGHDRY, to dry without ironing, as washed clothes [v]\n",
  "ROUGHDRY": "to dry without ironing, as washed clothes [v ROUGHDRIED, ROUGHDRYING, ROUGHDRIES]\n",
  "ROUGHDRYING": "ROUGHDRY, to dry without ironing, as washed clothes [v]\n",
  "ROUGHED": "ROUGH, to make rough [v]\n",
  "ROUGHEN": "to make rough [v -ED, -ING, -S]\n",
  "ROUGHENED": "ROUGHEN, to make rough [v]\n",
  "ROUGHENING": "ROUGHEN, to make rough [v]\n",
  "ROUGHENS": "ROUGHEN, to make rough [v]\n",
  "ROUGHER": "a person who performs preliminary operations [n -S]\n",
  "ROUGHERS": "ROUGHER, a person who performs preliminary operations [n]\n",
  "ROUGHEST": "ROUGH, having an uneven surface [adj]\n",
  "ROUGHHEW": "to shape roughly [v ROUGHHEWED, ROUGHHEWN, ROUGHHEWING, ROUGHHEWS]\n",
  "ROUGHHEWED": "ROUGHHEW, to shape roughly [v]\n",
  "ROUGHHEWING": "ROUGHHEW, to shape roughly [v]\n",
  "ROUGHHEWN": "ROUGHHEW, to shape roughly [v]\n",
  "ROUGHHEWS": "ROUGHHEW, to shape roughly [v]\n",
  "ROUGHHOUSE": "a brawl [n -S] / to brawl [v ROUGHHOUSED, ROUGHHOUSING, ROUGHHOUSES]\n",
  "ROUGHHOUSED": "ROUGHHOUSE, to brawl [v]\n",
  "ROUGHHOUSES": "ROUGHHOUSE, to brawl [v]\n",
  "ROUGHHOUSING": "brawling [n -S]\n",
  "ROUGHHOUSINGS": "ROUGHHOUSING, brawling [n]\n",
  "ROUGHIE": "a dry bough used as a torch, also ROUGHY [n -S]\n",
  "ROUGHIES": "ROUGHIE, a dry bough used as a torch, also ROUGHY [n]\n",
  "ROUGHING": "the act of making rough [n -S]\n",
  "ROUGHINGS": "ROUGHING, the act of making rough [n]\n",
  "ROUGHISH": "somewhat rough [adj]\n",
  "ROUGHLEG": "any one of several species of large hawk, having the legs feathered to the toes [n -S]\n",
  "ROUGHLEGS": "ROUGHLEG, any one of several species of large hawk, having the legs feathered to the toes [n]\n",
  "ROUGHLY": "ROUGH, having an uneven surface [adv]\n",
  "ROUGHNECK": "a member of an oil rig crew employed to deal with equipment on the rig floor [n -S] / to work as a roughneck on an oil rig [v -ED, -ING, -S]\n",
  "ROUGHNECKED": "ROUGHNECK, to work as a roughneck on an oil rig [v]\n",
  "ROUGHNECKING": "ROUGHNECK, to work as a roughneck on an oil rig [v]\n",
  "ROUGHNECKS": "ROUGHNECK, to work as a roughneck on an oil rig [v]\n",
  "ROUGHNESS": "the state of being rough [n -ES]\n",
  "ROUGHNESSES": "ROUGHNESS, the state of being rough [n]\n",
  "ROUGHOUT": "an unfinished roughly shaped artifact [n -S]\n",
  "ROUGHOUTS": "ROUGHOUT, an unfinished roughly shaped artifact [n]\n",
  "ROUGHRIDER": "a rider of untrained horses; a horse-breaker [n -S]\n",
  "ROUGHRIDERS": "ROUGHRIDER, a rider of untrained horses; a horse-breaker [n]\n",
  "ROUGHS": "ROUGH, to make rough [v]\n",
  "ROUGHSHOD": "provided with horseshoes with projecting nails to afford extra grip [adj]\n",
  "ROUGHT": "RECK, to be concerned about, also REAK, REKE [v]\n",
  "ROUGHY": "a dry bough, also ROUGHIE [n ROUGHIES]\n",
  "ROUGING": "ROUGE, (French) to colour with a red cosmetic [v]\n",
  "ROUILLE": "(French) a peppery garlic sauce [n -S]\n",
  "ROUILLES": "ROUILLE, (French) a peppery garlic sauce [n]\n",
  "ROUL": "(obsolete) a roll, also ROULE [n -S]\n",
  "ROULADE": "(French) a meat roll [n -S]\n",
  "ROULADES": "ROULADE, (French) a meat roll [n]\n",
  "ROULE": "(obsolete) a roll, also ROUL [n -S]\n",
  "ROULEAU": "(French) a roll of coins, wrapped in paper [n ROULEAUS or ROULEAUX]\n",
  "ROULEAUS": "ROULEAU, (French) a roll of coins, wrapped in paper [n]\n",
  "ROULEAUX": "ROULEAU, (French) a roll of coins, wrapped in paper [n]\n",
  "ROULES": "ROULE, (obsolete) a roll, also ROUL [n]\n",
  "ROULETTE": "(French) to make tiny slits in [v ROULETTED, ROULETTING, ROULETTES]\n",
  "ROULETTED": "ROULETTE, (French) to make tiny slits in [v]\n",
  "ROULETTES": "ROULETTE, (French) to make tiny slits in [v]\n",
  "ROULETTING": "ROULETTE, (French) to make tiny slits in [v]\n",
  "ROULS": "ROUL, (obsolete) a roll, also ROULE [n]\n",
  "ROUM": "(obsolete) a room, also ROWME [n -S]\n",
  "ROUMING": "in the phrase souming and rouming, calculating the percentage of sheep and cattle appropriate to a pasture [n -S]\n",
  "ROUMINGS": "ROUMING, in the phrase souming and rouming, calculating the percentage of sheep and cattle appropriate to a pasture [n]\n",
  "ROUMS": "ROUM, (obsolete) a room, also ROWME [n]\n",
  "ROUNCE": "part of a hand printing press [n -S]\n",
  "ROUNCES": "ROUNCE, part of a hand printing press [n]\n",
  "ROUNCEVAL": "a large variety of garden pea [n -S]\n",
  "ROUNCEVALS": "ROUNCEVAL, a large variety of garden pea [n]\n",
  "ROUNCIES": "ROUNCY, (archaic) a riding-horse, a nag [n]\n",
  "ROUNCY": "(archaic) a riding-horse, a nag [n ROUNCIES]\n",
  "ROUND": "shaped like a sphere or circle [adj ROUNDER, ROUNDEST, ROUNDLY] / to make round [v -ED, -ING, -S]\n",
  "ROUNDABOUT": "circuitous [adj ROUNDABOUTLY] / to go round and round [v -ED, -ING, -S]\n",
  "ROUNDABOUTATION": "going round and round [n]\n",
  "ROUNDABOUTED": "ROUNDABOUT, to go round and round [v]\n",
  "ROUNDABOUTEDLY": "in a roundabout way [adv]\n",
  "ROUNDABOUTILITY": "the state of being roundabout [n]\n",
  "ROUNDABOUTING": "ROUNDABOUT, to go round and round [v]\n",
  "ROUNDABOUTLY": "ROUNDABOUT, circuitous [adv]\n",
  "ROUNDABOUTNESS": "the state of being roundabout [n]\n",
  "ROUNDABOUTS": "ROUNDABOUT, to go round and round [v]\n",
  "ROUNDARCH": "having semicircular arches, also ROUNDARCHED [adj]\n",
  "ROUNDARCHED": "having semicircular arches, also ROUNDARCH [adj]\n",
  "ROUNDBALL": "a form of basketball [n -S]\n",
  "ROUNDBALLS": "ROUNDBALL, a form of basketball [n]\n",
  "ROUNDED": "ROUND, to make round [v]\n",
  "ROUNDEDLY": "ROUNDED, ROUND, to make round [adv]\n",
  "ROUNDEDNESS": "the state of being rounded [n -ES]\n",
  "ROUNDEDNESSES": "ROUNDEDNESS, the state of being rounded [n]\n",
  "ROUNDEL": "a round object, also ROUNDLE [n -S]\n",
  "ROUNDELAY": "a song with a refrain [n -S]\n",
  "ROUNDELAYS": "ROUNDELAY, a song with a refrain [n]\n",
  "ROUNDELS": "ROUNDEL, a round object, also ROUNDLE [n]\n",
  "ROUNDER": "a tool for rounding [n -S]\n",
  "ROUNDERS": "ROUNDER, a tool for rounding [n]\n",
  "ROUNDEST": "ROUND, shaped like a sphere or circle [adj]\n",
  "ROUNDHAND": "a style of penmanship in which the letters are well-rounded and free [n -S]\n",
  "ROUNDHANDS": "ROUNDHAND, a style of penmanship in which the letters are well-rounded and free [n]\n",
  "ROUNDHEADED": "having a round head [adj]\n",
  "ROUNDHEADEDNESS": "the state of being roundheaded [n]\n",
  "ROUNDHEEL": "an immoral woman [n -S]\n",
  "ROUNDHEELS": "ROUNDHEEL, an immoral woman [n]\n",
  "ROUNDHOUSE": "a constable's prison; a lockup, watch-house, or station house [n -S]\n",
  "ROUNDHOUSES": "ROUNDHOUSE, a constable's prison; a lockup, watch-house, or station house [n]\n",
  "ROUNDING": "the process of raising or lowering a number to an approximation which has fewer decimal places [n -S]\n",
  "ROUNDINGS": "ROUNDING, the process of raising or lowering a number to an approximation which has fewer decimal places [n]\n",
  "ROUNDISH": "somewhat round [adj]\n",
  "ROUNDLE": "a round object, also ROUNDEL [n -S]\n",
  "ROUNDLES": "ROUNDLE, a round object, also ROUNDEL [n]\n",
  "ROUNDLET": "a small circle [n -S]\n",
  "ROUNDLETS": "ROUNDLET, a small circle [n]\n",
  "ROUNDLY": "ROUND, shaped like a sphere or circle [adv]\n",
  "ROUNDNESS": "the state of being round [n -ES]\n",
  "ROUNDNESSES": "ROUNDNESS, the state of being round [n]\n",
  "ROUNDS": "ROUND, to make round [v]\n",
  "ROUNDSMAN": "a person who goes round esp. one sent by a shopkeeper to take orders and deliver goods [n ROUNDSMEN]\n",
  "ROUNDSMEN": "ROUNDSMAN, a person who goes round esp. one sent by a shopkeeper to take orders and deliver goods [n]\n",
  "ROUNDTABLE": "a meeting or conference at which the participants meet on equal terms [n -S]\n",
  "ROUNDTABLES": "ROUNDTABLE, a meeting or conference at which the participants meet on equal terms [n]\n",
  "ROUNDTRIP": "(US) a return trip [n -S]\n",
  "ROUNDTRIPPING": "a form of trading in which a company borrows a sum of money from one source and takes advantage of a short-term rise in interest rates to make a profit by lending it to another [n -S]\n",
  "ROUNDTRIPPINGS": "ROUNDTRIPPING, a form of trading in which a company borrows a sum of money from one source and takes advantage of a short-term rise in interest rates to make a profit by lending it to another [n]\n",
  "ROUNDTRIPS": "ROUNDTRIP, (US) a return trip [n]\n",
  "ROUNDUP": "an assembling of scattered cattle [n -S]\n",
  "ROUNDUPS": "ROUNDUP, an assembling of scattered cattle [n]\n",
  "ROUNDURE": "roundness; a round or circle, also RONDURE [n -S]\n",
  "ROUNDURES": "ROUNDURE, roundness; a round or circle, also RONDURE [n]\n",
  "ROUNDWOOD": "timber used (as for poles) without any sawing or hewing [n -S]\n",
  "ROUNDWOODS": "ROUNDWOOD, timber used (as for poles) without any sawing or hewing [n]\n",
  "ROUNDWORM": "a nematoid worm [n -S]\n",
  "ROUNDWORMS": "ROUNDWORM, a nematoid worm [n]\n",
  "ROUP": "(Scots) to auction [v -ED, -ING, -S]\n",
  "ROUPED": "ROUP, (Scots) to auction [v]\n",
  "ROUPET": "(Scots) hoarse, also ROOPIT, ROUPIT, ROUPY [adj]\n",
  "ROUPIER": "ROUPY, hoarse, also ROOPIT, ROUPET, ROUPIT [adj]\n",
  "ROUPIEST": "ROUPY, hoarse, also ROOPIT, ROUPET, ROUPIT [adj]\n",
  "ROUPILY": "ROUPY, hoarse, also ROOPIT, ROUPET, ROUPIT [adv]\n",
  "ROUPING": "ROUP, (Scots) to auction [v]\n",
  "ROUPIT": "(Scots) hoarse, also ROOPIT, ROUPET, ROUPY [adj]\n",
  "ROUPS": "ROUP, (Scots) to auction [v]\n",
  "ROUPY": "hoarse, also ROOPIT, ROUPET, ROUPIT [adj ROUPIER, ROUPIEST, ROUPILY]\n",
  "ROUSABLE": "capable of being roused [adj]\n",
  "ROUSANT": "in heraldry, rising as a bird, especially a swan [adj]\n",
  "ROUSE": "to disturb or awaken [v ROUSED, ROUSING, ROUSES]\n",
  "ROUSEABOUT": "(Australian) an odd-job man on a sheep station, also ROUSTABOUT [n -S]\n",
  "ROUSEABOUTS": "ROUSEABOUT, (Australian) an odd-job man on a sheep station, also ROUSTABOUT [n]\n",
  "ROUSED": "ROUSE, to disturb or awaken [v]\n",
  "ROUSEDNESS": "the state of being roused [n -ES]\n",
  "ROUSEDNESSES": "ROUSEDNESS, the state of being roused [n]\n",
  "ROUSEMENT": "(US) religious excitement [n -S]\n",
  "ROUSEMENTS": "ROUSEMENT, (US) religious excitement [n]\n",
  "ROUSER": "a person or thing that rouses [n -S]\n",
  "ROUSERS": "ROUSER, a person or thing that rouses [n]\n",
  "ROUSES": "ROUSE, to disturb or awaken [v]\n",
  "ROUSING": "ROUSE, to disturb or awaken [v]\n",
  "ROUSINGLY": "ROUSING, ROUSE, to disturb or awaken [adv]\n",
  "ROUSSEAU": "(French) fried pemmican [n -S]\n",
  "ROUSSEAUS": "ROUSSEAU, (French) fried pemmican [n]\n",
  "ROUSSETTE": "(French) a kind of fruit-bat; a kind of dogfish [n -S]\n",
  "ROUSSETTES": "ROUSSETTE, (French) a kind of fruit-bat; a kind of dogfish [n]\n",
  "ROUST": "to arouse and drive out [v -ED, -ING, -S]\n",
  "ROUSTABOUT": "a casual or unskilled laborer, esp. on an oil rig, also ROUSEABOUT [n -S]\n",
  "ROUSTABOUTS": "ROUSTABOUT, a casual or unskilled laborer, esp. on an oil rig, also ROUSEABOUT [n]\n",
  "ROUSTED": "ROUST, to arouse and drive out [v]\n",
  "ROUSTER": "a wharf labourer and deckhand [n -S]\n",
  "ROUSTERS": "ROUSTER, a wharf labourer and deckhand [n]\n",
  "ROUSTING": "ROUST, to arouse and drive out [v]\n",
  "ROUSTS": "ROUST, to arouse and drive out [v]\n",
  "ROUT": "to defeat utterly [v -ED, -ING, -S]\n",
  "ROUTE": "to send on a particular course [v ROUTED, ROUTEING or ROUTING, ROUTES]\n",
  "ROUTED": "ROUTE, to send on a particular course [v]\n",
  "ROUTEING": "ROUTE, to send on a particular course [v]\n",
  "ROUTEMAN": "a man who conducts business on a customary course [n ROUTEMEN]\n",
  "ROUTEMARCH": "a long training march [n -ES] / to send on a route march [v -ED, -ING, -ES]\n",
  "ROUTEMARCHED": "ROUTEMARCH, to send on a route march [v]\n",
  "ROUTEMARCHES": "ROUTEMARCH, to send on a route march [v]\n",
  "ROUTEMARCHING": "ROUTEMARCH, to send on a route march [v]\n",
  "ROUTEMEN": "ROUTEMAN, a man who conducts business on a customary course [n]\n",
  "ROUTER": "a two-handled plane with a cutter projecting below the sole used to form and plane a groove or recess [n -S]\n",
  "ROUTERS": "ROUTER, a two-handled plane with a cutter projecting below the sole used to form and plane a groove or recess [n]\n",
  "ROUTES": "ROUTE, to send on a particular course [v]\n",
  "ROUTEWAY": "an established course of travel [n -S]\n",
  "ROUTEWAYS": "ROUTEWAY, an established course of travel [n]\n",
  "ROUTH": "(Scots) abundance, also ROWTH [n -S]\n",
  "ROUTHIE": "(Scots) plentiful [adj ROUTHIER, ROUTHIEST]\n",
  "ROUTHIER": "ROUTHIE, (Scots) plentiful [adj]\n",
  "ROUTHIEST": "ROUTHIE, (Scots) plentiful [adj]\n",
  "ROUTHS": "ROUTH, (Scots) abundance, also ROWTH [n]\n",
  "ROUTINE": "regular [adj ROUTINELY] / a regular course of procedure [n -S]\n",
  "ROUTINEER": "one who adheres to a routine [n -S]\n",
  "ROUTINEERS": "ROUTINEER, one who adheres to a routine [n]\n",
  "ROUTINELY": "ROUTINE, regular [adv]\n",
  "ROUTINES": "ROUTINE, a regular course of procedure [n]\n",
  "ROUTING": "going to receptions [n -S]\n",
  "ROUTINGS": "ROUTING, going to receptions [n]\n",
  "ROUTINISATION": "the act of routinising, also ROUTINIZATION [n -S]\n",
  "ROUTINISATIONS": "ROUTINISATION, the act of routinising, also ROUTINIZATION [n]\n",
  "ROUTINISE": "to make routine, also ROUTINIZE [v ROUTINISED, ROUTINISING, ROUTINISES]\n",
  "ROUTINISED": "ROUTINISE, to make routine, also ROUTINIZE [v]\n",
  "ROUTINISES": "ROUTINISE, to make routine, also ROUTINIZE [v]\n",
  "ROUTINISING": "ROUTINISE, to make routine, also ROUTINIZE [v]\n",
  "ROUTINISM": "the practice of doing things with undiscriminating, mechanical regularity [n -S]\n",
  "ROUTINISMS": "ROUTINISM, the practice of doing things with undiscriminating, mechanical regularity [n]\n",
  "ROUTINIST": "one who habituated to a routine [n -S]\n",
  "ROUTINISTS": "ROUTINIST, one who habituated to a routine [n]\n",
  "ROUTINIZATION": "the act of routinizing, also ROUTINISATION [n -S]\n",
  "ROUTINIZATIONS": "ROUTINIZATION, the act of routinizing, also ROUTINISATION [n]\n",
  "ROUTINIZE": "to make routine, also ROUTINISE [v ROUTINIZED, ROUTINIZING, ROUTINIZES]\n",
  "ROUTINIZED": "ROUTINIZE, to make routine, also ROUTINISE [v]\n",
  "ROUTINIZES": "ROUTINIZE, to make routine, also ROUTINISE [v]\n",
  "ROUTINIZING": "ROUTINIZE, to make routine, also ROUTINISE [v]\n",
  "ROUTOUS": "(archaic) like a rout, tumultuous, disorderly [adj ROUTOUSLY]\n",
  "ROUTOUSLY": "ROUTOUS, (archaic) like a rout, tumultuous, disorderly [adv]\n",
  "ROUTS": "ROUT, to defeat utterly [v]\n",
  "ROUX": "(French) a thickening made of equal quantities of butter and flour mixed together [n ROUX]\n",
  "ROVE": "to roam [v ROVED, ROVING, ROVES]\n",
  "ROVED": "ROVE, to roam [v]\n",
  "ROVEN": "REEVE, to fasten by passing through or around something [v]\n",
  "ROVER": "one who roves [n -S]\n",
  "ROVERS": "ROVER, one who roves [n]\n",
  "ROVES": "ROVE, to roam [v]\n",
  "ROVING": "wandering [adj ROVINGLY] / the act of roving [n -S]\n",
  "ROVINGLY": "ROVING, wandering [adv]\n",
  "ROVINGS": "ROVING, the act of roving [n]\n",
  "ROW": "to propel by means of oars [v -ED, -ING, -S]\n",
  "ROWABLE": "able to be rowed [adj]\n",
  "ROWAN": "a small deciduous tree with scarlet berries [n -S]\n",
  "ROWANBERRIES": "ROWANBERRY, the berry of the rowan [n]\n",
  "ROWANBERRY": "the berry of the rowan [n ROWANBERRIES]\n",
  "ROWANS": "ROWAN, a small deciduous tree with scarlet berries [n]\n",
  "ROWBOAT": "a small boat designed to be rowed [n -S]\n",
  "ROWBOATS": "ROWBOAT, a small boat designed to be rowed [n]\n",
  "ROWDEDOW": "an uproar, also ROWDYDOW [n -S]\n",
  "ROWDEDOWS": "ROWDEDOW, an uproar, also ROWDYDOW [n]\n",
  "ROWDIER": "ROWDY, turbulent [adj]\n",
  "ROWDIES": "ROWDY, a noisy, turbulent person [n]\n",
  "ROWDIEST": "ROWDY, turbulent [adj]\n",
  "ROWDILY": "ROWDY, turbulent [adv]\n",
  "ROWDINESS": "the state of being rowdy [n -ES]\n",
  "ROWDINESSES": "ROWDINESS, the state of being rowdy [n]\n",
  "ROWDY": "turbulent [adj ROWDIER, ROWDIEST, ROWDILY] / a noisy, turbulent person [n ROWDIES]\n",
  "ROWDYDOW": "hubbub; uproar, also ROWDEDOW [n -S] / to make a hullabaloo [v -ED, -ING, -S]\n",
  "ROWDYDOWED": "ROWDYDOW, to make a hullabaloo [v]\n",
  "ROWDYDOWING": "ROWDYDOW, to make a hullabaloo [v]\n",
  "ROWDYDOWS": "ROWDYDOW, hubbub; uproar, also ROWDEDOW [n]\n",
  "ROWDYISH": "somewhat rowdy [adj]\n",
  "ROWDYISM": "disorderly behaviour [n -S]\n",
  "ROWDYISMS": "ROWDYISM, disorderly behaviour [n]\n",
  "ROWED": "ROW, to propel by means of oars [v]\n",
  "ROWEL": "to prick with a spiked wheel in order to urge forward [v ROWELLED or ROWELED, ROWELLING or ROWELING, ROWELS]\n",
  "ROWELED": "ROWEL, to prick with a spiked wheel in order to urge forward [v]\n",
  "ROWELING": "ROWEL, to prick with a spiked wheel in order to urge forward [v]\n",
  "ROWELLED": "ROWEL, to prick with a spiked wheel in order to urge forward [v]\n",
  "ROWELLING": "ROWEL, to prick with a spiked wheel in order to urge forward [v]\n",
  "ROWELS": "ROWEL, to prick with a spiked wheel in order to urge forward [v]\n",
  "ROWEN": "a second mowing of grass in the same season, also RAWING [n -S]\n",
  "ROWENS": "ROWEN, a second mowing of grass in the same season, also RAWING [n]\n",
  "ROWER": "one who rows [n -S]\n",
  "ROWERS": "ROWER, one who rows [n]\n",
  "ROWIE": "(Scots) a bread roll made with butter and fat [n -S]\n",
  "ROWIES": "ROWIE, (Scots) a bread roll made with butter and fat [n]\n",
  "ROWING": "the sport of racing in light, long and narrow rowboats [n -S]\n",
  "ROWINGS": "ROWING, the sport of racing in light, long and narrow rowboats [n]\n",
  "ROWLOCK": "a device for holding an oar in place [n -S]\n",
  "ROWLOCKS": "ROWLOCK, a device for holding an oar in place [n]\n",
  "ROWME": "(Spenser) place, space, room, also ROUM [n -S]\n",
  "ROWMES": "ROWME, (Spenser) place, space, room, also ROUM [n]\n",
  "ROWND": "(obsolete) to round [v -ED, -ING, -S]\n",
  "ROWNDED": "ROWND, (obsolete) to round [v]\n",
  "ROWNDELL": "(Spenser) a bubble [n -S]\n",
  "ROWNDELLS": "ROWNDELL, (Spenser) a bubble [n]\n",
  "ROWNDING": "ROWND, (obsolete) to round [v]\n",
  "ROWNDS": "ROWND, (obsolete) to round [v]\n",
  "ROWOVER": "a rowing event won by rowing the course unopposed [n -S]\n",
  "ROWOVERS": "ROWOVER, a rowing event won by rowing the course unopposed [n]\n",
  "ROWS": "ROW, to propel by means of oars [v]\n",
  "ROWT": "to rummage out [v -ED, -ING, -S]\n",
  "ROWTED": "ROWT, to rummage out [v]\n",
  "ROWTH": "(Scots) abundance, also ROUTH [n -S]\n",
  "ROWTHS": "ROWTH, (Scots) abundance, also ROUTH [n]\n",
  "ROWTING": "ROWT, to rummage out [v]\n",
  "ROWTS": "ROWT, to rummage out [v]\n",
  "ROYAL": "relating to a king or queen [adj ROYALLER, ROYALLEST, ROYALLY] / a size of printing paper [n -S]\n",
  "ROYALET": "a petty king [n -S]\n",
  "ROYALETS": "ROYALET, a petty king [n]\n",
  "ROYALISE": "(Shakespeare) to play the king, also ROYALIZE [v ROYALISED, ROYALISING, ROYALISES]\n",
  "ROYALISED": "ROYALISE, (Shakespeare) to play the king, also ROYALIZE [v]\n",
  "ROYALISES": "ROYALISE, (Shakespeare) to play the king, also ROYALIZE [v]\n",
  "ROYALISING": "ROYALISE, (Shakespeare) to play the king, also ROYALIZE [v]\n",
  "ROYALISM": "support of a monarch or monarchy [n -S]\n",
  "ROYALISMS": "ROYALISM, support of a monarch or monarchy [n]\n",
  "ROYALIST": "a supporter of a monarch or monarchy [n -S]\n",
  "ROYALISTIC": "characteristic of royalists [adj]\n",
  "ROYALISTS": "ROYALIST, a supporter of a monarch or monarchy [n]\n",
  "ROYALIZE": "(Shakespeare) to play the king, also ROYALISE [v ROYALIZED, ROYALIZING, ROYALIZES]\n",
  "ROYALIZED": "ROYALIZE, (Shakespeare) to play the king, also ROYALISE [v]\n",
  "ROYALIZES": "ROYALIZE, (Shakespeare) to play the king, also ROYALISE [v]\n",
  "ROYALIZING": "ROYALIZE, (Shakespeare) to play the king, also ROYALISE [v]\n",
  "ROYALLER": "ROYAL, relating to a king or queen [adj]\n",
  "ROYALLEST": "ROYAL, relating to a king or queen [adj]\n",
  "ROYALLY": "ROYAL, relating to a king or queen [adv]\n",
  "ROYALMAST": "the highest part of a mast [n -S]\n",
  "ROYALMASTS": "ROYALMAST, the highest part of a mast [n]\n",
  "ROYALS": "ROYAL, a size of printing paper [n]\n",
  "ROYALTIES": "ROYALTY, the status or power of a monarch [n]\n",
  "ROYALTY": "the status or power of a monarch [n ROYALTIES]\n",
  "ROYNE": "(Spenser) to growl, roar, also ROIN [v ROYNED, ROYNING, ROYNES]\n",
  "ROYNED": "ROYNE, (Spenser) to growl, roar, also ROIN [v]\n",
  "ROYNES": "ROYNE, (Spenser) to growl, roar, also ROIN [v]\n",
  "ROYNING": "ROYNE, (Spenser) to growl, roar, also ROIN [v]\n",
  "ROYNISH": "(Shakespeare) mangy; scurvy, also ROINISH [adj]\n",
  "ROYST": "to revel noisily, carouse, also ROIST, ROISTER, ROYSTER [v -ED, -ING, -S]\n",
  "ROYSTED": "ROYST, to revel noisily, carouse, also ROIST, ROISTER, ROYSTER [v]\n",
  "ROYSTER": "to revel noisily, carouse, also ROIST, ROISTER, ROYST [v -ED, -ING, -S]\n",
  "ROYSTERED": "ROYSTER, to revel noisily, carouse, also ROIST, ROISTER, ROYST [v]\n",
  "ROYSTERER": "one who roysters, carouses, also ROISTERER [n -S]\n",
  "ROYSTERERS": "ROYSTERER, one who roysters, carouses, also ROISTERER [n]\n",
  "ROYSTERING": "ROYSTER, to revel noisily, carouse, also ROIST, ROISTER, ROYST [v]\n",
  "ROYSTEROUS": "blustering, boisterous, also ROISTEROUS [adj]\n",
  "ROYSTERS": "ROYSTER, to revel noisily, carouse, also ROIST, ROISTER, ROYST [v]\n",
  "ROYSTING": "ROYST, to revel noisily, carouse, also ROIST, ROISTER, ROYSTER [v]\n",
  "ROYSTS": "ROYST, to revel noisily, carouse, also ROIST, ROISTER, ROYSTER [v]\n",
  "ROZELLE": "an East Indian hibiscus, also ROSELLE [n -S]\n",
  "ROZELLES": "ROZELLE, an East Indian hibiscus, also ROSELLE [n]\n",
  "ROZET": "(Scots) to rosin, also ROSET, ROSIT, ROZIT [v -ED, -ING, -S]\n",
  "ROZETED": "ROZET, (Scots) to rosin, also ROSET, ROSIT, ROZIT [v]\n",
  "ROZETING": "ROZET, (Scots) to rosin, also ROSET, ROSIT, ROZIT [v]\n",
  "ROZETS": "ROZET, (Scots) to rosin, also ROSET, ROSIT, ROZIT [v]\n",
  "ROZIT": "(Scots) to rosin, also ROSET, ROSIT, ROZET [v -ED, -ING, -S]\n",
  "ROZITED": "ROZIT, (Scots) to rosin, also ROSET, ROSIT, ROZET [v]\n",
  "ROZITING": "ROZIT, (Scots) to rosin, also ROSET, ROSIT, ROZET [v]\n",
  "ROZITS": "ROZIT, (Scots) to rosin, also ROSET, ROSIT, ROZET [v]\n",
  "ROZZER": "(slang) a policeman, also ROSSER [n -S]\n",
  "ROZZERS": "ROZZER, (slang) a policeman, also ROSSER [n]\n",
  "RUANA": "(Spanish) a woollen outer garment resembling a poncho, worn in parts of South America [n -S]\n",
  "RUANAS": "RUANA, (Spanish) a woollen outer garment resembling a poncho, worn in parts of South America [n]\n",
  "RUB": "to apply friction [v RUBBED, RUBBING, RUBS] / (Scots) to rob [v RUBBET, RUBBIT, RUBBING, RUBS]\n",
  "RUBABOO": "(Canadian) a type of soup, also RUBBABOO [n -S]\n",
  "RUBABOOS": "RUBABOO, (Canadian) a type of soup, also RUBBABOO [n]\n",
  "RUBACE": "a kind of ruby-red quartz, also RUBASSE [n -S]\n",
  "RUBACES": "RUBACE, a kind of ruby-red quartz, also RUBASSE [n]\n",
  "RUBAI": "(Arabic) a Persian verse-form, a four-line stanza [n RUBAIYAT or RUBAIS]\n",
  "RUBAIS": "RUBAI, (Arabic) a Persian verse-form, a four-line stanza [n]\n",
  "RUBAIYAT": "RUBAI, (Arabic) a Persian verse-form, a four-line stanza [n]\n",
  "RUBASSE": "a kind of ruby-red quartz, also RUBACE [n -S]\n",
  "RUBASSES": "RUBASSE, a kind of ruby-red quartz, also RUBACE [n]\n",
  "RUBATI": "RUBATO, (Italian) a musical piece with a distorted rhythm [n]\n",
  "RUBATO": "(Italian) a musical piece with a distorted rhythm [n RUBATOS or RUBATI]\n",
  "RUBATOS": "RUBATO, (Italian) a musical piece with a distorted rhythm [n]\n",
  "RUBBABOO": "(Canadian) a type of soup, also RUBABOO [n -S]\n",
  "RUBBABOOS": "RUBBABOO, (Canadian) a type of soup, also RUBABOO [n]\n",
  "RUBBED": "RUB, to apply friction [v]\n",
  "RUBBER": "to provide with an eraser [v -ED, -ING, -S]\n",
  "RUBBERED": "RUBBER, to provide with an eraser [v]\n",
  "RUBBERIER": "RUBBERY, resembling an elastic substance [adj]\n",
  "RUBBERIEST": "RUBBERY, resembling an elastic substance [adj]\n",
  "RUBBERING": "RUBBER, to provide with an eraser [v]\n",
  "RUBBERISE": "to coat with rubber, also RUBBERIZE [v RUBBERISED, RUBBERISING, RUBBERISES]\n",
  "RUBBERISED": "RUBBERISE, to coat with rubber, also RUBBERIZE [v]\n",
  "RUBBERISES": "RUBBERISE, to coat with rubber, also RUBBERIZE [v]\n",
  "RUBBERISING": "RUBBERISE, to coat with rubber, also RUBBERIZE [v]\n",
  "RUBBERIZE": "to coat with rubber, also RUBBERISE [v RUBBERIZED, RUBBERIZING, RUBBERIZES]\n",
  "RUBBERIZED": "RUBBERIZE, to coat with rubber, also RUBBERISE [v]\n",
  "RUBBERIZES": "RUBBERIZE, to coat with rubber, also RUBBERISE [v]\n",
  "RUBBERIZING": "RUBBERIZE, to coat with rubber, also RUBBERISE [v]\n",
  "RUBBERLIKE": "like rubber [adj]\n",
  "RUBBERNECK": "an over-inquisitive or gaping person [n -S] / to look curiously at something [v -ED, -ING, -S]\n",
  "RUBBERNECKED": "RUBBERNECK, to look curiously at something [v]\n",
  "RUBBERNECKER": "one who rubbernecks [n -S]\n",
  "RUBBERNECKERS": "RUBBERNECKER, one who rubbernecks [n]\n",
  "RUBBERNECKING": "RUBBERNECK, to look curiously at something [v]\n",
  "RUBBERNECKS": "RUBBERNECK, to look curiously at something [v]\n",
  "RUBBERS": "RUBBER, to provide with an eraser [v]\n",
  "RUBBERWEAR": "rubber clothing [n -S]\n",
  "RUBBERWEARS": "RUBBERWEAR, rubber clothing [n]\n",
  "RUBBERY": "resembling an elastic substance [adj RUBBERIER, RUBBERIEST]\n",
  "RUBBET": "RUB, to apply friction [v]\n",
  "RUBBIDIES": "RUBBIDY, (Australian slang) a pub (rhyming slang rubbidy dub), also RUBBITY [n]\n",
  "RUBBIDY": "(Australian slang) a pub (rhyming slang rubbidy dub), also RUBBITY [n RUBBIDIES]\n",
  "RUBBIES": "RUBBY, (Canadian slang) rubbing alcohol, esp. when mixed with cheap red wine [n]\n",
  "RUBBING": "an image produced by rubbing [n -S]\n",
  "RUBBINGS": "RUBBING, an image produced by rubbing [n]\n",
  "RUBBISH": "to criticize [v -ED, -ING, -ES]\n",
  "RUBBISHED": "RUBBISH, to criticize [v]\n",
  "RUBBISHES": "RUBBISH, to criticize [v]\n",
  "RUBBISHIER": "RUBBISHY, like rubbish, also RUBBISHLY [adj]\n",
  "RUBBISHIEST": "RUBBISHY, like rubbish, also RUBBISHLY [adj]\n",
  "RUBBISHING": "RUBBISH, to criticize [v]\n",
  "RUBBISHLIER": "RUBBISHLY, like rubbish, also RUBBISHY [adj]\n",
  "RUBBISHLIEST": "RUBBISHLY, like rubbish, also RUBBISHY [adj]\n",
  "RUBBISHLY": "like rubbish, also RUBBISHY [adj RUBBISHLIER, RUBBISHLIEST]\n",
  "RUBBISHY": "like rubbish, also RUBBISHLY [adj RUBBISHIER, RUBBISHIEST]\n",
  "RUBBIT": "RUB, to apply friction [v]\n",
  "RUBBITIES": "RUBBITY, (Australian slang) a pub (rhyming slang rubbity dub), also RUBBIDY [n]\n",
  "RUBBITY": "(Australian slang) a pub (rhyming slang rubbity dub), also RUBBIDY [n RUBBITIES]\n",
  "RUBBLE": "to reduce into pieces [v RUBBLED, RUBBLING, RUBBLES]\n",
  "RUBBLED": "RUBBLE, to reduce into pieces [v]\n",
  "RUBBLES": "RUBBLE, to reduce into pieces [v]\n",
  "RUBBLEWORK": "coarse masonry [n -S]\n",
  "RUBBLEWORKS": "RUBBLEWORK, coarse masonry [n]\n",
  "RUBBLIER": "RUBBLY, abounding in rubble [adj]\n",
  "RUBBLIEST": "RUBBLY, abounding in rubble [adj]\n",
  "RUBBLING": "RUBBLE, to reduce into pieces [v]\n",
  "RUBBLY": "abounding in rubble [adj RUBBLIER, RUBBLIEST]\n",
  "RUBBOARD": "a corrugated rectangular board used as a percussion instrument [n -S]\n",
  "RUBBOARDS": "RUBBOARD, a corrugated rectangular board used as a percussion instrument [n]\n",
  "RUBBY": "(Canadian slang) rubbing alcohol, esp. when mixed with cheap red wine [n RUBBIES]\n",
  "RUBBYDUB": "(slang) an alcoholic who will substitute any liquid inebriant should ethanol become unavailable, including rubbing alcohol [n -S]\n",
  "RUBBYDUBS": "RUBBYDUB, (slang) an alcoholic who will substitute any liquid inebriant should ethanol become unavailable, including rubbing alcohol [n]\n",
  "RUBDOWN": "a brisk rubbing down of the body [n -S]\n",
  "RUBDOWNS": "RUBDOWN, a brisk rubbing down of the body [n]\n",
  "RUBE": "(US slang) a bumpkin, an easy mark [n -S]\n",
  "RUBEFACIENT": "an agent that is a gentle irritant producing increased blood circulation and reddening of the skin where it is applied [n -S]\n",
  "RUBEFACIENTS": "RUBEFACIENT, an agent that is a gentle irritant producing increased blood circulation and reddening of the skin where it is applied [n]\n",
  "RUBEFACTION": "reddening [n -S]\n",
  "RUBEFACTIONS": "RUBEFACTION, reddening [n]\n",
  "RUBEFIED": "RUBEFY, to redden, also RUBIFY [v]\n",
  "RUBEFIES": "RUBEFY, to redden, also RUBIFY [v]\n",
  "RUBEFY": "to redden, also RUBIFY [v RUBEFIED, RUBEFYING, RUBEFIES]\n",
  "RUBEFYING": "RUBEFY, to redden, also RUBIFY [v]\n",
  "RUBEL": "a currency unit of Belarus [n RUBLI or RUBELS]\n",
  "RUBELLA": "(Latin) a virus disease, German measles [n -S]\n",
  "RUBELLAN": "a mineral, an altered biotite, mica containing iron and magnesia [n -S]\n",
  "RUBELLANS": "RUBELLAN, a mineral, an altered biotite, mica containing iron and magnesia [n]\n",
  "RUBELLAS": "RUBELLA, (Latin) a virus disease, German measles [n]\n",
  "RUBELLITE": "a variety of tourmaline varying in color from a pale rose to a deep ruby, and containing lithium [n -S]\n",
  "RUBELLITES": "RUBELLITE, a variety of tourmaline varying in color from a pale rose to a deep ruby, and containing lithium [n]\n",
  "RUBELS": "RUBEL, a currency unit of Belarus [n]\n",
  "RUBEOLA": "(Latin) a virus disease, measles [n -S]\n",
  "RUBEOLAR": "relating to rubeola, a measles virus [adj]\n",
  "RUBEOLAS": "RUBEOLA, (Latin) a virus disease, measles [n]\n",
  "RUBES": "RUBE, (US slang) a bumpkin, an easy mark [n]\n",
  "RUBESCENCE": "reddening, blushing [n -S]\n",
  "RUBESCENCES": "RUBESCENCE, reddening, blushing [n]\n",
  "RUBESCENT": "growing red; blushing [adj]\n",
  "RUBIACEOUS": "belonging to madder family of plants [adj]\n",
  "RUBICELLE": "an orange-coloured spinel [n -S]\n",
  "RUBICELLES": "RUBICELLE, an orange-coloured spinel [n]\n",
  "RUBICON": "(Latin) the winning of a game in piquet before one's opponent scores [n -S] / to win at piquet in this way [v -ED, -ING, -S]\n",
  "RUBICONED": "RUBICON, to win at piquet in this way [v]\n",
  "RUBICONING": "RUBICON, to win at piquet in this way [v]\n",
  "RUBICONS": "RUBICON, to win at piquet in this way [v]\n",
  "RUBICUND": "inclining to redness, ruddy [adj]\n",
  "RUBICUNDITIES": "RUBICUNDITY, the state of being rubicund [n]\n",
  "RUBICUNDITY": "the state of being rubicund [n RUBICUNDITIES]\n",
  "RUBIDIC": "of or pertaining to rubidium; containing rubidium [adj]\n",
  "RUBIDIUM": "a metallic element [n -S]\n",
  "RUBIDIUMS": "RUBIDIUM, a metallic element [n]\n",
  "RUBIED": "RUBY, to redden [v]\n",
  "RUBIER": "RUBY, red like a ruby [adj]\n",
  "RUBIES": "RUBY, to redden [v]\n",
  "RUBIEST": "RUBY, red like a ruby [adj]\n",
  "RUBIFIED": "RUBIFY, to redden, also RUBEFY [v]\n",
  "RUBIFIES": "RUBIFY, to redden, also RUBEFY [v]\n",
  "RUBIFY": "to redden, also RUBEFY [v RUBIFIED, RUBIFYING, RUBIFIES]\n",
  "RUBIFYING": "RUBIFY, to redden, also RUBEFY [v]\n",
  "RUBIGINOSE": "rust-coloured, also RUBIGINOUS [adj]\n",
  "RUBIGINOUS": "rust-coloured, also RUBIGINOSE [adj]\n",
  "RUBIGO": "(Latin) red iron oxide [n -S]\n",
  "RUBIGOS": "RUBIGO, (Latin) red iron oxide [n]\n",
  "RUBIN": "(Spenser) a ruby, also RUBINE [n -S]\n",
  "RUBINE": "(Spenser) a ruby, also RUBIN [n -S]\n",
  "RUBINEOUS": "ruby-red [adj]\n",
  "RUBINES": "RUBINE, (Spenser) a ruby, also RUBIN [n]\n",
  "RUBINS": "RUBIN, (Spenser) a ruby, also RUBINE [n]\n",
  "RUBIOUS": "ruby coloured [adj]\n",
  "RUBLE": "(Russian) a monetary unit of the Soviet Union, also ROUBLE [n -S]\n",
  "RUBLES": "RUBLE, (Russian) a monetary unit of the Soviet Union, also ROUBLE [n]\n",
  "RUBLI": "RUBEL, a currency unit of Belarus [n]\n",
  "RUBOFF": "a deep impression made by close contact [n -S]\n",
  "RUBOFFS": "RUBOFF, a deep impression made by close contact [n]\n",
  "RUBOUT": "an act of rubbing out [n -S]\n",
  "RUBOUTS": "RUBOUT, an act of rubbing out [n]\n",
  "RUBRIC": "a passage in a book printed in red or other distinctive type, esp. as a direction in a service book [n -S]\n",
  "RUBRICAL": "colored in, or marked with, red, placed in rubrics [adj RUBRICALLY]\n",
  "RUBRICALLY": "RUBRICAL, colored in, or marked with, red, placed in rubrics [adv]\n",
  "RUBRICATE": "to write, print, or mark in red; formerly, to enter (a name) in red letters in a calendar of saints [v RUBRICATED, RUBRICATING, RUBRICATES]\n",
  "RUBRICATED": "RUBRICATE, to write, print, or mark in red; formerly, to enter (a name) in red letters in a calendar of saints [v]\n",
  "RUBRICATES": "RUBRICATE, to write, print, or mark in red; formerly, to enter (a name) in red letters in a calendar of saints [v]\n",
  "RUBRICATING": "RUBRICATE, to write, print, or mark in red; formerly, to enter (a name) in red letters in a calendar of saints [v]\n",
  "RUBRICATION": "the act of rubricating [n -S]\n",
  "RUBRICATIONS": "RUBRICATION, the act of rubricating [n]\n",
  "RUBRICATOR": "one who rubricates [n -S]\n",
  "RUBRICATORS": "RUBRICATOR, one who rubricates [n]\n",
  "RUBRICIAN": "a student or follower of liturgical rubrics [n -S]\n",
  "RUBRICIANS": "RUBRICIAN, a student or follower of liturgical rubrics [n]\n",
  "RUBRICS": "RUBRIC, a passage in a book printed in red or other distinctive type, esp. as a direction in a service book [n]\n",
  "RUBS": "RUB, to apply friction [v]\n",
  "RUBSTONE": "a whetstone [n -S]\n",
  "RUBSTONES": "RUBSTONE, a whetstone [n]\n",
  "RUBUS": "(Latin) a genus of rosaceous plants, including the raspberry and blackberry [n RUBUS or RUBUSES]\n",
  "RUBUSES": "RUBUS, (Latin) a genus of rosaceous plants, including the raspberry and blackberry [n]\n",
  "RUBY": "a pure transparent red corundum, also RUBIN, RUBINE [n RUBIES] / red like a ruby [adj RUBIER, RUBIEST] / to redden [v RUBIED, RUBYING, RUBIES]\n",
  "RUBYING": "RUBY, to redden [v]\n",
  "RUBYLIKE": "like a ruby [adj]\n",
  "RUBYTHROAT": "any of numerous species of humming birds, in which the male has on the throat a brilliant patch of red feathers having metallic reflections [n -S]\n",
  "RUBYTHROATS": "RUBYTHROAT, any of numerous species of humming birds, in which the male has on the throat a brilliant patch of red feathers having metallic reflections [n]\n",
  "RUC": "an enormous bird of Arabian legend, also ROC, ROK, RUKH [n -S]\n",
  "RUCHE": "a frill of lace or other material, also ROUCHE [n -S] / to trim with a ruche [v RUCHED, RUCHING, RUCHES]\n",
  "RUCHED": "RUCHE, to trim with a ruche [v]\n",
  "RUCHES": "RUCHE, to trim with a ruche [v]\n",
  "RUCHING": "a ruche, or ruches collectively, also ROUCHING [n -S]\n",
  "RUCHINGS": "RUCHING, a ruche, or ruches collectively, also ROUCHING [n]\n",
  "RUCK": "to wrinkle or crease, also RUCKLE [v -ED, -ING, -S]\n",
  "RUCKED": "RUCK, to wrinkle or crease, also RUCKLE [v]\n",
  "RUCKING": "RUCK, to wrinkle or crease, also RUCKLE [v]\n",
  "RUCKLE": "to wrinkle or crease, also RUCK, RUNKLE [v RUCKLED, RUCKLING, RUCKLES]\n",
  "RUCKLED": "RUCKLE, to wrinkle or crease, also RUCK, RUNKLE [v]\n",
  "RUCKLES": "RUCKLE, to wrinkle or crease, also RUCK, RUNKLE [v]\n",
  "RUCKLING": "RUCKLE, to wrinkle or crease, also RUCK, RUNKLE [v]\n",
  "RUCKMAN": "in Australian rules football, a person who plays in the ruck [n RUCKMEN]\n",
  "RUCKMEN": "RUCKMAN, in Australian rules football, a person who plays in the ruck [n]\n",
  "RUCKS": "RUCK, to wrinkle or crease, also RUCKLE [v]\n",
  "RUCKSACK": "a knapsack [n -S]\n",
  "RUCKSACKS": "RUCKSACK, a knapsack [n]\n",
  "RUCKSEAT": "a folding seat attached to a rucksack for camping [n -S]\n",
  "RUCKSEATS": "RUCKSEAT, a folding seat attached to a rucksack for camping [n]\n",
  "RUCKUS": "a noisy disturbance [n -ES]\n",
  "RUCKUSES": "RUCKUS, a noisy disturbance [n]\n",
  "RUCOLA": "(Italian) a Mediterranean plant used in salads, also ARUGOLA, ARUGULA, RUGOLA [n -S]\n",
  "RUCOLAS": "RUCOLA, (Italian) a Mediterranean plant used in salads, also ARUGOLA, ARUGULA, RUGOLA [n]\n",
  "RUCS": "RUC, an enormous bird of Arabian legend, also ROC, ROK, RUKH [n]\n",
  "RUCTATION": "(obsolete) belching, also ERUCTATION [n -S]\n",
  "RUCTATIONS": "RUCTATION, (obsolete) belching, also ERUCTATION [n]\n",
  "RUCTION": "a noisy disturbance [n -S]\n",
  "RUCTIONS": "RUCTION, a noisy disturbance [n]\n",
  "RUCTIOUS": "quarrelsome [adj]\n",
  "RUD": "(Spenser) to redden [v RUDDED, RUDDING, RUDS]\n",
  "RUDACEOUS": "of breccia etc., composed of coarse-grained material [adj]\n",
  "RUDAS": "(Scots) a foulmouthed old woman [n -ES]\n",
  "RUDASES": "RUDAS, (Scots) a foulmouthed old woman [n]\n",
  "RUDBECKIA": "(Swedish) a composite plant of the sunflower family [n -S]\n",
  "RUDBECKIAS": "RUDBECKIA, (Swedish) a composite plant of the sunflower family [n]\n",
  "RUDD": "a freshwater fish [n -S]\n",
  "RUDDED": "RUD, (Spenser) to redden [v]\n",
  "RUDDER": "a vertical blade used to direct the course of a vessel [n -S]\n",
  "RUDDERHEAD": "the top of the rudderpost, to which the steering apparatus may be fixed [n -S]\n",
  "RUDDERHEADS": "RUDDERHEAD, the top of the rudderpost, to which the steering apparatus may be fixed [n]\n",
  "RUDDERLESS": "without a rudder [adj]\n",
  "RUDDERPOST": "the shank of a rudder, having the blade at one end and the attachments for operating it at the other [n -S]\n",
  "RUDDERPOSTS": "RUDDERPOST, the shank of a rudder, having the blade at one end and the attachments for operating it at the other [n]\n",
  "RUDDERS": "RUDDER, a vertical blade used to direct the course of a vessel [n]\n",
  "RUDDERSTOCK": "a vertical post at the forward edge of a rudder that enables the rudder to pivot [n -S]\n",
  "RUDDERSTOCKS": "RUDDERSTOCK, a vertical post at the forward edge of a rudder that enables the rudder to pivot [n]\n",
  "RUDDIED": "RUDDY, to redden [v]\n",
  "RUDDIER": "RUDDY, reddish [adj]\n",
  "RUDDIES": "RUDDY, to redden [v]\n",
  "RUDDIEST": "RUDDY, reddish [adj]\n",
  "RUDDILY": "RUDDY, reddish [adv]\n",
  "RUDDINESS": "the state of being ruddy [n -ES]\n",
  "RUDDINESSES": "RUDDINESS, the state of being ruddy [n]\n",
  "RUDDING": "RUD, (Spenser) to redden [v]\n",
  "RUDDLE": "to colour with a red dye, also REDDLE [v RUDDLED, RUDDLING, RUDDLES]\n",
  "RUDDLED": "RUDDLE, to colour with a red dye, also REDDLE [v]\n",
  "RUDDLEMAN": "one who marks e.g. sheep with reddle, also RADDLEMAN, REDDLEMAN [n RUDDLEMEN]\n",
  "RUDDLEMEN": "RUDDLEMAN, one who marks e.g. sheep with reddle, also RADDLEMAN, REDDLEMAN [n]\n",
  "RUDDLES": "RUDDLE, to colour with a red dye, also REDDLE [v]\n",
  "RUDDLING": "RUDDLE, to colour with a red dye, also REDDLE [v]\n",
  "RUDDOCK": "(dialect) a robin, also RADDOCKE [n -S]\n",
  "RUDDOCKS": "RUDDOCK, (dialect) a robin, also RADDOCKE [n]\n",
  "RUDDS": "RUDD, a freshwater fish [n]\n",
  "RUDDY": "reddish [adj RUDDIER, RUDDIEST, RUDDILY] / to redden [v RUDDIED, RUDDYING, RUDDIES]\n",
  "RUDDYING": "RUDDY, to redden [v]\n",
  "RUDE": "boorish [adj RUDER, RUDEST, RUDELY] / a rude boy, also RUDESBY, RUDIE [n RUDES]\n",
  "RUDELY": "RUDE, boorish [adv]\n",
  "RUDENESS": "the quality of being rude [n -ES]\n",
  "RUDENESSES": "RUDENESS, the quality of being rude [n]\n",
  "RUDER": "RUDE, boorish [adj]\n",
  "RUDERAL": "a plant growing in poor land [n -S]\n",
  "RUDERALS": "RUDERAL, a plant growing in poor land [n]\n",
  "RUDERIES": "RUDERY, (colloquial) rudeness [n]\n",
  "RUDERY": "(colloquial) rudeness [n RUDERIES]\n",
  "RUDES": "RUDE, a rude boy, also RUDESBY, RUDIE [n]\n",
  "RUDESBIES": "RUDESBY, (Shakespeare) an uncivil, turbulent fellow [n]\n",
  "RUDESBY": "(Shakespeare) an uncivil, turbulent fellow [n RUDESBIES]\n",
  "RUDEST": "RUDE, boorish [adj]\n",
  "RUDI": "(in Jamaica) a member of a group of lower- or working-class teenagers in the 1960s, noted for listening to ska music and for juvenile delinquency, also RUDY [n -S]\n",
  "RUDIE": "(slang) a rude boy, also RUDE, RUDESBY [n -S]\n",
  "RUDIES": "RUDIE, (slang) a rude boy, also RUDE, RUDESBY [n]\n",
  "RUDIMENT": "a basic principle or element [n -S]\n",
  "RUDIMENTAL": "rudimentary, also RUDIMENTARY [adj RUDIMENTALLY]\n",
  "RUDIMENTALLY": "RUDIMENTAL, rudimentary, also RUDIMENTARY [adv]\n",
  "RUDIMENTARILY": "RUDIMENTARY, arrested at an early stage of development, also RUDIMENTAL [adv]\n",
  "RUDIMENTARINESS": "the state of being rudimentary [n]\n",
  "RUDIMENTARY": "arrested at an early stage of development, also RUDIMENTAL [adj RUDIMENTARILY]\n",
  "RUDIMENTS": "RUDIMENT, a basic principle or element [n]\n",
  "RUDIS": "RUDI, (in Jamaica) a member of a group of lower- or working-class teenagers in the 1960s, noted for listening to ska music and for juvenile delinquency, also RUDY [n]\n",
  "RUDISH": "somewhat rude [adj]\n",
  "RUDIST": "a cone-shaped extinct mollusc, also RUDISTID [n -S]\n",
  "RUDISTID": "a cone-shaped extinct mollusc, also RUDIST [n -S]\n",
  "RUDISTIDS": "RUDISTID, a cone-shaped extinct mollusc, also RUDIST [n]\n",
  "RUDISTS": "RUDIST, a cone-shaped extinct mollusc, also RUDISTID [n]\n",
  "RUDS": "RUD, (Spenser) to redden [v]\n",
  "RUDY": "(In Jamaica) a member of a group of lower- or working-class teenagers in the 1960s, noted for listening to ska music and for juvenile delinquency, also RUDI [n RUDIES]\n",
  "RUE": "to feel sorrow or remorse for [v RUED, RUING or RUEING, RUES]\n",
  "RUED": "RUE, to feel sorrow or remorse for [v]\n",
  "RUEDA": "(Spanish) a Cuban street dance, performed in a circle, featuring many turns and changes of partner [n -S]\n",
  "RUEDAS": "RUEDA, (Spanish) a Cuban street dance, performed in a circle, featuring many turns and changes of partner [n]\n",
  "RUEFUL": "feeling sorrow or remorse [adj RUEFULLY]\n",
  "RUEFULLY": "RUEFUL, feeling sorrow or remorse [adv]\n",
  "RUEFULNESS": "the state of being rueful [n -ES]\n",
  "RUEFULNESSES": "RUEFULNESS, the state of being rueful [n]\n",
  "RUEING": "repentance [n -S]\n",
  "RUEINGS": "RUEING, repentance [n]\n",
  "RUELLE": "(French) the space between a bed and the wall [n -S]\n",
  "RUELLES": "RUELLE, (French) the space between a bed and the wall [n]\n",
  "RUELLIA": "a plant of the acanthus family [n -S]\n",
  "RUELLIAS": "RUELLIA, a plant of the acanthus family [n]\n",
  "RUER": "one who rues [n -S]\n",
  "RUERS": "RUER, one who rues [n]\n",
  "RUES": "RUE, to feel sorrow or remorse for [v]\n",
  "RUFESCENCE": "the state of being rufescent, inclined to redness [n -S]\n",
  "RUFESCENCES": "RUFESCENCE, the state of being rufescent, inclined to redness [n]\n",
  "RUFESCENT": "inclining to redness [adj]\n",
  "RUFF": "at bridge, to play a trump card when one cannot follow through [v -ED, -ING, -S]\n",
  "RUFFE": "a freshwater fish, also RUFFIN [n -S]\n",
  "RUFFED": "RUFF, at bridge, to play a trump card when one cannot follow through [v]\n",
  "RUFFES": "RUFFE, a freshwater fish, also RUFFIN [n]\n",
  "RUFFIAN": "to behave like a tough, lawless person [v -ED, -ING, -S]\n",
  "RUFFIANED": "RUFFIAN, to behave like a tough, lawless person [v]\n",
  "RUFFIANING": "RUFFIAN, to behave like a tough, lawless person [v]\n",
  "RUFFIANISH": "having the qualities of a ruffian [adj]\n",
  "RUFFIANISM": "being a ruffian [n -S]\n",
  "RUFFIANISMS": "RUFFIANISM, being a ruffian [n]\n",
  "RUFFIANLY": "like a ruffian [adj]\n",
  "RUFFIANS": "RUFFIAN, to behave like a tough, lawless person [v]\n",
  "RUFFIN": "(Spenser) a small freshwater fish of the perch family, also RUFFE [n -S]\n",
  "RUFFING": "RUFF, at bridge, to play a trump card when one cannot follow through [v]\n",
  "RUFFINS": "RUFFIN, (Spenser) a small freshwater fish of the perch family, also RUFFE [n]\n",
  "RUFFLE": "to disturb the smoothness of [v RUFFLED, RUFFLING, RUFFLES]\n",
  "RUFFLED": "RUFFLE, to disturb the smoothness of [v]\n",
  "RUFFLER": "a beggar posing as a maimed soldier or sailor [n -S]\n",
  "RUFFLERS": "RUFFLER, a beggar posing as a maimed soldier or sailor [n]\n",
  "RUFFLES": "RUFFLE, to disturb the smoothness of [v]\n",
  "RUFFLIER": "RUFFLY, not smooth [adj]\n",
  "RUFFLIEST": "RUFFLY, not smooth [adj]\n",
  "RUFFLIKE": "resembling a pleated collar [adj]\n",
  "RUFFLING": "the act of ruffling [n -S]\n",
  "RUFFLINGS": "RUFFLING, the act of ruffling [n]\n",
  "RUFFLY": "not smooth [adj RUFFLIER, RUFFLIEST]\n",
  "RUFFS": "RUFF, at bridge, to play a trump card when one cannot follow through [v]\n",
  "RUFIYAA": "a monetary unit of the Maldives [n -S]\n",
  "RUFIYAAS": "RUFIYAA, a monetary unit of the Maldives [n]\n",
  "RUFOUS": "a reddish or brownish-red colour [n -ES]\n",
  "RUFOUSES": "RUFOUS, a reddish or brownish-red colour [n]\n",
  "RUG": "(Scots) to pull roughly [v RUGGED, RUGGING, RUGS]\n",
  "RUGA": "(Latin) an anatomical fold or wrinkle [n RUGAE]\n",
  "RUGAE": "RUGA, (Latin) an anatomical fold or wrinkle [n]\n",
  "RUGAL": "wrinkled [adj]\n",
  "RUGALACH": "(Yiddish) in Jewish cooking, small crescent-shaped pastries filled with fruit, nuts etc., also RUGELACH, RUGGELACH [n]\n",
  "RUGATE": "wrinkled; covered with sunken lines, also RUGOSE, RUGOUS [adj]\n",
  "RUGBIES": "RUGBY, a form of football, also RUGGER [n]\n",
  "RUGBY": "a form of football, also RUGGER [n RUGBIES]\n",
  "RUGELACH": "(Yiddish) in Jewish cooking, a small crescent-shaped pastry filled with fruit, nuts etc., also RUGALACH, RUGGELACH [n -S]\n",
  "RUGELACHS": "RUGELACH, (Yiddish) in Jewish cooking, a small crescent-shaped pastry filled with fruit, nuts etc., also RUGALACH, RUGGELACH [n]\n",
  "RUGGED": "having an uneven surface, also RUGGY [adj RUGGEDER, RUGGEDEST, RUGGEDLY]\n",
  "RUGGEDER": "RUGGED, having an uneven surface, also RUGGY [adj]\n",
  "RUGGEDEST": "RUGGED, having an uneven surface, also RUGGY [adj]\n",
  "RUGGEDISATION": "the process of ruggedising, also RUGGEDIZATION [n -S]\n",
  "RUGGEDISATIONS": "RUGGEDISATION, the process of ruggedising, also RUGGEDIZATION [n]\n",
  "RUGGEDISE": "to make rugged, also RUGGEDIZE [v RUGGEDISED, RUGGEDISING, RUGGEDISES]\n",
  "RUGGEDISED": "RUGGEDISE, to make rugged, also RUGGEDIZE [v]\n",
  "RUGGEDISES": "RUGGEDISE, to make rugged, also RUGGEDIZE [v]\n",
  "RUGGEDISING": "RUGGEDISE, to make rugged, also RUGGEDIZE [v]\n",
  "RUGGEDIZATION": "the process of ruggedizing, also RUGGEDISATION [n -S]\n",
  "RUGGEDIZATIONS": "RUGGEDIZATION, the process of ruggedizing, also RUGGEDISATION [n]\n",
  "RUGGEDIZE": "to make rugged, also RUGGEDISE [v RUGGEDIZED, RUGGEDIZING, RUGGEDIZES]\n",
  "RUGGEDIZED": "RUGGEDIZE, to make rugged, also RUGGEDISE [v]\n",
  "RUGGEDIZES": "RUGGEDIZE, to make rugged, also RUGGEDISE [v]\n",
  "RUGGEDIZING": "RUGGEDIZE, to make rugged, also RUGGEDISE [v]\n",
  "RUGGEDLY": "RUGGED, having an uneven surface, also RUGGY [adv]\n",
  "RUGGEDNESS": "the state of being rugged [n -ES]\n",
  "RUGGEDNESSES": "RUGGEDNESS, the state of being rugged [n]\n",
  "RUGGELACH": "(Yiddish) in Jewish cooking, small crescent-shaped pastries filled with fruit, nuts etc., also RUGALACH, RUGELACH [n]\n",
  "RUGGER": "a form of football, also RUGBY [n -S]\n",
  "RUGGERS": "RUGGER, a form of football, also RUGBY [n]\n",
  "RUGGIER": "RUGGY, rough and uneven [adj]\n",
  "RUGGIEST": "RUGGY, rough and uneven [adj]\n",
  "RUGGING": "a coarse kind of woollen cloth, used for wrapping, blanketing, etc. [n -S]\n",
  "RUGGINGS": "RUGGING, a coarse kind of woollen cloth, used for wrapping, blanketing, etc. [n]\n",
  "RUGGY": "rough and uneven [adj RUGGIER, RUGGIEST]\n",
  "RUGLIKE": "like a floor covering [adj]\n",
  "RUGOLA": "(Italian) a Mediterranean plant used in salads, also ARUGOLA, ARUGULA, RUCOLA [n -S]\n",
  "RUGOLAS": "RUGOLA, (Italian) a Mediterranean plant used in salads, also ARUGOLA, ARUGULA, RUCOLA [n]\n",
  "RUGOSA": "(Latin) a garden rose [n -S]\n",
  "RUGOSAS": "RUGOSA, (Latin) a garden rose [n]\n",
  "RUGOSE": "wrinkled; covered with sunken lines, also RUGATE, RUGOUS [adj RUGOSELY]\n",
  "RUGOSELY": "RUGOSE, wrinkled; covered with sunken lines, also RUGATE, RUGOUS [adv]\n",
  "RUGOSITIES": "RUGOSITY, the state of being rugose, having wrinkles [n]\n",
  "RUGOSITY": "the state of being rugose, having wrinkles [n RUGOSITIES]\n",
  "RUGOUS": "wrinkled; covered with sunken lines, also RUGATE, RUGOSE [adj]\n",
  "RUGRAT": "(colloquial) a young child [n -S]\n",
  "RUGRATS": "RUGRAT, (colloquial) a young child [n]\n",
  "RUGS": "RUG, (Scots) to pull roughly [v]\n",
  "RUGULOSE": "having small wrinkles [adj]\n",
  "RUIN": "to destroy [v -ED, -ING, -S]\n",
  "RUINABLE": "able to be ruined [adj]\n",
  "RUINATE": "(archaic) to ruin, destroy [v RUINATED, RUINATING, RUINATES]\n",
  "RUINATED": "RUINATE, (archaic) to ruin, destroy [v]\n",
  "RUINATES": "RUINATE, (archaic) to ruin, destroy [v]\n",
  "RUINATING": "RUINATE, (archaic) to ruin, destroy [v]\n",
  "RUINATION": "the act of ruining [n -S]\n",
  "RUINATIONS": "RUINATION, the act of ruining [n]\n",
  "RUINED": "RUIN, to destroy [v]\n",
  "RUINER": "one who ruins [n -S]\n",
  "RUINERS": "RUINER, one who ruins [n]\n",
  "RUING": "repentance [n -S]\n",
  "RUINGS": "RUING, repentance [n]\n",
  "RUINING": "the act of ruining [n -S]\n",
  "RUININGS": "RUINING, the act of ruining [n]\n",
  "RUINOUS": "destructive [adj RUINOUSLY]\n",
  "RUINOUSLY": "RUINOUS, destructive [adv]\n",
  "RUINOUSNESS": "the state of being ruinous [n -ES]\n",
  "RUINOUSNESSES": "RUINOUSNESS, the state of being ruinous [n]\n",
  "RUINS": "RUIN, to destroy [v]\n",
  "RUKH": "(Persian) an enormous bird of Arabian legend, also ROC, ROK, RUC [n -S]\n",
  "RUKHS": "RUKH, (Persian) an enormous bird of Arabian legend, also ROC, ROK, RUC [n]\n",
  "RULABLE": "able to be ruled [adj]\n",
  "RULE": "to exercise control over [v RULED, RULING, RULES]\n",
  "RULED": "RULE, to exercise control over [v]\n",
  "RULELESS": "unruly, without rules, also RULESSE [adj]\n",
  "RULER": "to strike with an implement for ruling lines [v -ED, -ING, -S]\n",
  "RULERED": "RULER, to strike with an implement for ruling lines [v]\n",
  "RULERING": "RULER, to strike with an implement for ruling lines [v]\n",
  "RULERS": "RULER, to strike with an implement for ruling lines [v]\n",
  "RULERSHIP": "being a ruler [n -S]\n",
  "RULERSHIPS": "RULERSHIP, being a ruler [n]\n",
  "RULES": "RULE, to exercise control over [v]\n",
  "RULESSE": "(Spenser) unruly, without rules, also RULELESS [adj]\n",
  "RULIER": "RULY, obedient, orderly [adj]\n",
  "RULIEST": "RULY, obedient, orderly [adj]\n",
  "RULING": "an authoritative decision [n -S]\n",
  "RULINGS": "RULING, an authoritative decision [n]\n",
  "RULLION": "(Scots) a rawhide shoe [n -S]\n",
  "RULLIONS": "RULLION, (Scots) a rawhide shoe [n]\n",
  "RULLOCK": "a contrivance serving as a fulcrum for an oar, also ROLLOCK, ROWLOCK [n -S]\n",
  "RULLOCKS": "RULLOCK, a contrivance serving as a fulcrum for an oar, also ROLLOCK, ROWLOCK [n]\n",
  "RULY": "obedient, orderly [adj RULIER, RULIEST]\n",
  "RUM": "odd, droll [adj RUMMER, RUMMEST, RUMLY] / a spirit distilled from sugarcane [n -S]\n",
  "RUMAKI": "(Japanese) an appetizer, marinated chicken liver and a water chestnut grilled in a rasher of bacon [n -S]\n",
  "RUMAKIS": "RUMAKI, (Japanese) an appetizer, marinated chicken liver and a water chestnut grilled in a rasher of bacon [n]\n",
  "RUMAL": "(Urdu) a handkerchief or headcloth, also ROMAL [n -S]\n",
  "RUMALS": "RUMAL, (Urdu) a handkerchief or headcloth, also ROMAL [n]\n",
  "RUMBA": "(Spanish) to perform a kind of dance, also RHUMBA [v -ED, -ING, -S]\n",
  "RUMBAED": "RUMBA, (Spanish) to perform a kind of dance, also RHUMBA [v]\n",
  "RUMBAING": "RUMBA, (Spanish) to perform a kind of dance, also RHUMBA [v]\n",
  "RUMBAS": "RUMBA, (Spanish) to perform a kind of dance, also RHUMBA [v]\n",
  "RUMBELOW": "a meaningless word, occurring as a refrain in old sea-songs [n -S]\n",
  "RUMBELOWS": "RUMBELOW, a meaningless word, occurring as a refrain in old sea-songs [n]\n",
  "RUMBLE": "to make a deep, thunderous sound [v RUMBLED, RUMBLING, RUMBLES]\n",
  "RUMBLED": "RUMBLE, to make a deep, thunderous sound [v]\n",
  "RUMBLEDETHUMP": "a Scottish dish of butter and mashed potatoes, sometimes mixed with cabbage or turnips, also RUMBLEDETHUMPS [n -S]\n",
  "RUMBLEDETHUMPS": "a Scottish dish of butter and mashed potatoes, sometimes mixed with cabbage or turnips, also RUMBLEDETHUMP [n]\n",
  "RUMBLEGUMPTION": "(Scots) commonsense, also RUMELGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n -S]\n",
  "RUMBLEGUMPTIONS": "RUMBLEGUMPTION, (Scots) commonsense, also RUMELGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n]\n",
  "RUMBLER": "a machine for peeling potatoes [n -S]\n",
  "RUMBLERS": "RUMBLER, a machine for peeling potatoes [n]\n",
  "RUMBLES": "RUMBLE, to make a deep, thunderous sound [v]\n",
  "RUMBLIER": "RUMBLY, tending to rumble [adj]\n",
  "RUMBLIEST": "RUMBLY, tending to rumble [adj]\n",
  "RUMBLING": "a deep, thunderous sound [n -S]\n",
  "RUMBLINGLY": "RUMBLING [adv]\n",
  "RUMBLINGS": "RUMBLING, a deep, thunderous sound [n]\n",
  "RUMBLY": "tending to rumble [adj RUMBLIER, RUMBLIEST]\n",
  "RUMBO": "rum punch [n -S]\n",
  "RUMBOS": "RUMBO, rum punch [n]\n",
  "RUMBULLION": "(obsolete) an older name for rum [n -S]\n",
  "RUMBULLIONS": "RUMBULLION, (obsolete) an older name for rum [n]\n",
  "RUMBUNCTIOUS": "boisterous, unruly, also RAMBUNCTIOUS [adj]\n",
  "RUMBUSTICAL": "(archaic) boisterous, also RUMBUSTIOUS [adj]\n",
  "RUMBUSTIOUS": "boisterous, rambunctious, also RUMBUSTICAL [adj RUMBUSTIOUSLY]\n",
  "RUMBUSTIOUSLY": "RUMBUSTIOUS, boisterous, rambunctious, also RUMBUSTICAL [adv]\n",
  "RUMBUSTIOUSNESS": "the state of being rumbustious [n]\n",
  "RUMDUM": "an alcoholic [n -S]\n",
  "RUMDUMS": "RUMDUM, an alcoholic [n]\n",
  "RUME": "(Shakespeare) a watery discharge from the nose or eyes, also RHEUM [n -S]\n",
  "RUMELGUMPTION": "commonsense, also RUMBLEGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n -S]\n",
  "RUMELGUMPTIONS": "RUMELGUMPTION, commonsense, also RUMBLEGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n]\n",
  "RUMEN": "(Latin) a part of the stomach of a ruminant [n RUMENS or RUMINA]\n",
  "RUMENS": "RUMEN, (Latin) a part of the stomach of a ruminant [n]\n",
  "RUMES": "RUME, (Shakespeare) a watery discharge from the nose or eyes, also RHEUM [n]\n",
  "RUMFUSTIAN": "(archaic) a hot alcoholic drink made from rum and various spices [n -S]\n",
  "RUMFUSTIANS": "RUMFUSTIAN, (archaic) a hot alcoholic drink made from rum and various spices [n]\n",
  "RUMGUMPTION": "(Scots) common sense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n -S]\n",
  "RUMGUMPTIONS": "RUMGUMPTION, (Scots) common sense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n]\n",
  "RUMINA": "RUMEN, (Latin) a part of the stomach of a ruminant [n]\n",
  "RUMINAL": "of or like the rumen [adj]\n",
  "RUMINANT": "chewing the cud [adj RUMINANTLY] / an animal that chews the cud [n -S]\n",
  "RUMINANTLY": "RUMINANT, chewing the cud [adv]\n",
  "RUMINANTS": "RUMINANT, an animal that chews the cud [n]\n",
  "RUMINATE": "to chew again [v RUMINATED, RUMINATING, RUMINATES]\n",
  "RUMINATED": "RUMINATE, to chew again [v]\n",
  "RUMINATES": "RUMINATE, to chew again [v]\n",
  "RUMINATING": "RUMINATE, to chew again [v]\n",
  "RUMINATINGLY": "RUMINATING, RUMINATE, to chew again [adv]\n",
  "RUMINATION": "the act of ruminating [n -S]\n",
  "RUMINATIONS": "RUMINATION, the act of ruminating [n]\n",
  "RUMINATIVE": "tending to ruminate [adj RUMINATIVELY]\n",
  "RUMINATIVELY": "RUMINATIVE, tending to ruminate [adv]\n",
  "RUMINATOR": "one who ruminates [n -S]\n",
  "RUMINATORS": "RUMINATOR, one who ruminates [n]\n",
  "RUMKIN": "(obsolete) a kind of drinking vessel [n -S]\n",
  "RUMKINS": "RUMKIN, (obsolete) a kind of drinking vessel [n]\n",
  "RUMLEGUMPTION": "commonsense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n -S]\n",
  "RUMLEGUMPTIONS": "RUMLEGUMPTION, commonsense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMGUMPTION, RUMMELGUMPTION, RUMMLEGUMPTION [n]\n",
  "RUMLY": "RUM, odd, droll [adv]\n",
  "RUMMAGE": "to search thoroughly through [v RUMMAGED, RUMMAGING, RUMMAGES]\n",
  "RUMMAGED": "RUMMAGE, to search thoroughly through [v]\n",
  "RUMMAGER": "one who rummages [n -S]\n",
  "RUMMAGERS": "RUMMAGER, one who rummages [n]\n",
  "RUMMAGES": "RUMMAGE, to search thoroughly through [v]\n",
  "RUMMAGING": "RUMMAGE, to search thoroughly through [v]\n",
  "RUMMELGUMPTION": "commonsense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMLEGUMPTION [n -S]\n",
  "RUMMELGUMPTIONS": "RUMMELGUMPTION, commonsense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMLEGUMPTION [n]\n",
  "RUMMER": "(Dutch) a large drinking-glass, also ROEMER [n -S]\n",
  "RUMMERS": "RUMMER, (Dutch) a large drinking-glass, also ROEMER [n]\n",
  "RUMMEST": "RUM, odd, droll [adj]\n",
  "RUMMIER": "RUMMY, queer [adj]\n",
  "RUMMIES": "RUMMY, a card game [n]\n",
  "RUMMIEST": "RUMMY, queer [adj]\n",
  "RUMMILY": "RUMMY, queer [adv]\n",
  "RUMMINESS": "the state of being rummy [n -ES]\n",
  "RUMMINESSES": "RUMMINESS, the state of being rummy [n]\n",
  "RUMMISH": "(Scots) to roar or protest [v -ED, -ING, -ES]\n",
  "RUMMISHED": "RUMMISH, (Scots) to roar or protest [v]\n",
  "RUMMISHES": "RUMMISH, (Scots) to roar or protest [v]\n",
  "RUMMISHING": "RUMMISH, (Scots) to roar or protest [v]\n",
  "RUMMLEGUMPTION": "commonsense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION [n -S]\n",
  "RUMMLEGUMPTIONS": "RUMMLEGUMPTION, commonsense, also RUMBLEGUMPTION, RUMELGUMPTION, RUMGUMPTION, RUMLEGUMPTION, RUMMELGUMPTION [n]\n",
  "RUMMY": "queer [adj RUMMIER, RUMMIEST, RUMMILY] / a card game [n RUMMIES]\n",
  "RUMNESS": "the state of being odd, queer [n -ES]\n",
  "RUMNESSES": "RUMNESS, the state of being odd, queer [n]\n",
  "RUMOR": "to spread by hearsay, also RUMOUR [v -ED, -ING, -S]\n",
  "RUMORED": "RUMOR, to spread by hearsay, also RUMOUR [v]\n",
  "RUMORER": "a person who is given to spreading rumours, also RUMOURER [n -S]\n",
  "RUMORERS": "RUMORER, a person who is given to spreading rumours, also RUMOURER [n]\n",
  "RUMORING": "RUMOR, to spread by hearsay, also RUMOUR [v]\n",
  "RUMORMONGER": "one who spreads rumours [n -S]\n",
  "RUMORMONGERING": "the spreading of rumours [n -S]\n",
  "RUMORMONGERINGS": "RUMORMONGERING, the spreading of rumours [n]\n",
  "RUMORMONGERS": "RUMORMONGER, one who spreads rumours [n]\n",
  "RUMOROUS": "full of rumors [adj]\n",
  "RUMORS": "RUMOR, to spread by hearsay, also RUMOUR [v]\n",
  "RUMOUR": "to spread by hearsay, also RUMOR [v -ED, -ING, -S]\n",
  "RUMOURED": "RUMOUR, to spread by hearsay, also RUMOR [v]\n",
  "RUMOURER": "one who spreads rumours, also RUMORER [n -S]\n",
  "RUMOURERS": "RUMOURER, one who spreads rumours, also RUMORER [n]\n",
  "RUMOURING": "RUMOUR, to spread by hearsay, also RUMOR [v]\n",
  "RUMOURS": "RUMOUR, to spread by hearsay, also RUMOR [v]\n",
  "RUMP": "to turn one's back on [v -ED, -ING, -S]\n",
  "RUMPED": "RUMP, to turn one's back on [v]\n",
  "RUMPIER": "RUMPY, having a large rump [adj]\n",
  "RUMPIES": "RUMPY, a Manx cat; a tailless chicken [n]\n",
  "RUMPIEST": "RUMPY, having a large rump [adj]\n",
  "RUMPING": "RUMP, to turn one's back on [v]\n",
  "RUMPLE": "to wrinkle, crease [v RUMPLED, RUMPLING, RUMPLES]\n",
  "RUMPLED": "RUMPLE, to wrinkle, crease [v]\n",
  "RUMPLES": "RUMPLE, to wrinkle, crease [v]\n",
  "RUMPLESS": "without a rump [adj]\n",
  "RUMPLIER": "RUMPLY, wrinkled [adj]\n",
  "RUMPLIEST": "RUMPLY, wrinkled [adj]\n",
  "RUMPLING": "RUMPLE, to wrinkle, crease [v]\n",
  "RUMPLY": "wrinkled [adj RUMPLIER, RUMPLIEST]\n",
  "RUMPO": "(slang) sexual intercourse [n -S]\n",
  "RUMPOS": "RUMPO, (slang) sexual intercourse [n]\n",
  "RUMPOT": "an alcoholic [n -S]\n",
  "RUMPOTS": "RUMPOT, an alcoholic [n]\n",
  "RUMPS": "RUMP, to turn one's back on [v]\n",
  "RUMPUS": "a noisy disturbance [n -ES]\n",
  "RUMPUSES": "RUMPUS, a noisy disturbance [n]\n",
  "RUMPY": "having a large rump [adj RUMPIER, RUMPIEST] / a Manx cat; a tailless chicken [n RUMPIES]\n",
  "RUMRUNNER": "a person involved in smuggling alcohol into the US during Prohibition [n -S]\n",
  "RUMRUNNERS": "RUMRUNNER, a person involved in smuggling alcohol into the US during Prohibition [n]\n",
  "RUMS": "RUM, a spirit distilled from sugarcane [n]\n",
  "RUN": "to move by rapid steps [v RAN, RUN, RUNNING, RUNS]\n",
  "RUNABOUT": "a small light boat, car or aeroplane, also RUNAROUND [n -S]\n",
  "RUNABOUTS": "RUNABOUT, a small light boat, car or aeroplane, also RUNAROUND [n]\n",
  "RUNAGATE": "a fugitive, a runaway, a vagabond, also RENEGADE, RENEGADO, RENEGATE [n -S]\n",
  "RUNAGATES": "RUNAGATE, a fugitive, a runaway, a vagabond, also RENEGADE, RENEGADO, RENEGATE [n]\n",
  "RUNANGA": "(Maori) an assembly or council [n -S]\n",
  "RUNANGAS": "RUNANGA, (Maori) an assembly or council [n]\n",
  "RUNAROUND": "a small light boat, car or aeroplane, also RUNABOUT [n -S]\n",
  "RUNAROUNDS": "RUNAROUND, a small light boat, car or aeroplane, also RUNABOUT [n]\n",
  "RUNAWAY": "one that runs away [n -S]\n",
  "RUNAWAYS": "RUNAWAY, one that runs away [n]\n",
  "RUNBACK": "the area behind the base line at either end of a tennis court [n -S]\n",
  "RUNBACKS": "RUNBACK, the area behind the base line at either end of a tennis court [n]\n",
  "RUNCH": "a wild radish [n -ES]\n",
  "RUNCHES": "RUNCH, a wild radish [n]\n",
  "RUNCIBLE": "a nonsense word applied by Edward Lear to a spoon with fork tines [adj]\n",
  "RUNCINATE": "pinnately cut with the lobes pointing downwards, as the leaf of the dandelion [adj]\n",
  "RUND": "(Scots) a strip of cloth, a selvage, also ROON [n -S]\n",
  "RUNDALE": "(Scots) a system of holding land in single detached pieces, also RUNRIG [n -S]\n",
  "RUNDALES": "RUNDALE, (Scots) a system of holding land in single detached pieces, also RUNRIG [n]\n",
  "RUNDLE": "a round, a rung of a ladder [n -S]\n",
  "RUNDLED": "having a rung [adj]\n",
  "RUNDLES": "RUNDLE, a round, a rung of a ladder [n]\n",
  "RUNDLET": "(archaic) an old liquid measure equal to about 15 gallons [n -S]\n",
  "RUNDLETS": "RUNDLET, (archaic) an old liquid measure equal to about 15 gallons [n]\n",
  "RUNDOWN": "a summary, a statement bringing together all the main items [n -S]\n",
  "RUNDOWNS": "RUNDOWN, a summary, a statement bringing together all the main items [n]\n",
  "RUNDS": "RUND, (Scots) a strip of cloth, a selvage, also ROON [n]\n",
  "RUNE": "a letter of an ancient alphabet [n -S]\n",
  "RUNECRAFT": "skill with runes [n -S]\n",
  "RUNECRAFTS": "RUNECRAFT, skill with runes [n]\n",
  "RUNED": "bearing runes [adj]\n",
  "RUNELIKE": "like a rune [adj]\n",
  "RUNES": "RUNE, a letter of an ancient alphabet [n]\n",
  "RUNFLAT": "a tyre able to run after being punctured [n -S]\n",
  "RUNFLATS": "RUNFLAT, a tyre able to run after being punctured [n]\n",
  "RUNG": "a crosspiece forming a step of a ladder [n -S]\n",
  "RUNGED": "having rungs [adj]\n",
  "RUNGLESS": "without rungs [adj]\n",
  "RUNGS": "RUNG, a crosspiece forming a step of a ladder [n]\n",
  "RUNIC": "pertaining to a rune [adj]\n",
  "RUNKLE": "to wrinkle, crease, also RUCK, RUCKLE [v RUNKLED, RUNKLING, RUNKLES]\n",
  "RUNKLED": "RUNKLE, to wrinkle, crease, also RUCK, RUCKLE [v]\n",
  "RUNKLES": "RUNKLE, to wrinkle, crease, also RUCK, RUCKLE [v]\n",
  "RUNKLING": "RUNKLE, to wrinkle, crease, also RUCK, RUCKLE [v]\n",
  "RUNLESS": "scoring no runs in baseball [adj]\n",
  "RUNLET": "a little brook, also RUNNEL [n -S]\n",
  "RUNLETS": "RUNLET, a little brook, also RUNNEL [n]\n",
  "RUNNABLE": "fit for hunting [adj]\n",
  "RUNNEL": "a little brook, also RUNLET [n -S]\n",
  "RUNNELS": "RUNNEL, a little brook, also RUNLET [n]\n",
  "RUNNER": "one who runs [n -S]\n",
  "RUNNERS": "RUNNER, one who runs [n]\n",
  "RUNNET": "(dialect) rennet [n -S]\n",
  "RUNNETS": "RUNNET, (dialect) rennet [n]\n",
  "RUNNIER": "RUNNY, inclined to run or liquefy [adj]\n",
  "RUNNIEST": "RUNNY, inclined to run or liquefy [adj]\n",
  "RUNNINESS": "the state of being runny [n -ES]\n",
  "RUNNINESSES": "RUNNINESS, the state of being runny [n]\n",
  "RUNNING": "flowing [adj RUNNINGLY] / a race [n -S]\n",
  "RUNNINGLY": "RUNNING, flowing [adv]\n",
  "RUNNINGS": "RUNNING, a race [n]\n",
  "RUNNION": "(Shakespeare) a mangy or scabby creature, also RONION, RONYON [n -S]\n",
  "RUNNIONS": "RUNNION, (Shakespeare) a mangy or scabby creature, also RONION, RONYON [n]\n",
  "RUNNY": "inclined to run or liquefy [adj RUNNIER, RUNNIEST]\n",
  "RUNOFF": "a rainfall that is not absorbed by the soil [n -S]\n",
  "RUNOFFS": "RUNOFF, a rainfall that is not absorbed by the soil [n]\n",
  "RUNOUT": "a dismissal at cricket due to being run out [n -S]\n",
  "RUNOUTS": "RUNOUT, a dismissal at cricket due to being run out [n]\n",
  "RUNOVER": "matter for publication that exceeds the allotted space [n -S]\n",
  "RUNOVERS": "RUNOVER, matter for publication that exceeds the allotted space [n]\n",
  "RUNPROOF": "(of stockings or tights) designed to be especially resistant to being ripped [adj]\n",
  "RUNRIG": "(Scots) a system of holding land in single detached pieces, also RUNDALE [n -S]\n",
  "RUNRIGS": "RUNRIG, (Scots) a system of holding land in single detached pieces, also RUNDALE [n]\n",
  "RUNROUND": "evasive action [n -S]\n",
  "RUNROUNDS": "RUNROUND, evasive action [n]\n",
  "RUNS": "RUN, to move by rapid steps [v]\n",
  "RUNT": "the smallest of a litter, also RONT, RONTE [n -S]\n",
  "RUNTED": "stunted [adj]\n",
  "RUNTIER": "RUNTY, like a runt [adj]\n",
  "RUNTIEST": "RUNTY, like a runt [adj]\n",
  "RUNTINESS": "the state of being runty [n -ES]\n",
  "RUNTINESSES": "RUNTINESS, the state of being runty [n]\n",
  "RUNTISH": "somewhat runty [adj RUNTISHLY]\n",
  "RUNTISHLY": "RUNTISH, somewhat runty [adv]\n",
  "RUNTS": "RUNT, the smallest of a litter, also RONT, RONTE [n]\n",
  "RUNTY": "like a runt [adj RUNTIER, RUNTIEST]\n",
  "RUNWAY": "a landing and takeoff strip for aircraft [n -S]\n",
  "RUNWAYS": "RUNWAY, a landing and takeoff strip for aircraft [n]\n",
  "RUPEE": "(Hindi) a monetary unit of India [n -S]\n",
  "RUPEES": "RUPEE, (Hindi) a monetary unit of India [n]\n",
  "RUPESTRIAN": "composed of rock; inscribed on rock [adj]\n",
  "RUPIA": "(Greek) a skin ulcer covered with dead tissue [n -S]\n",
  "RUPIAH": "(Hindi) a monetary unit of Indonesia [n -S]\n",
  "RUPIAHS": "RUPIAH, (Hindi) a monetary unit of Indonesia [n]\n",
  "RUPIAS": "RUPIA, (Greek) a skin ulcer covered with dead tissue [n]\n",
  "RUPICOLINE": "living among or growing on rocks, also RUPICOLOUS [adj]\n",
  "RUPICOLOUS": "living among or growing on rocks, also RUPICOLINE [adj]\n",
  "RUPTURABLE": "that can be ruptured [adj]\n",
  "RUPTURE": "to burst [v RUPTURED, RUPTURING, RUPTURES]\n",
  "RUPTURED": "RUPTURE, to burst [v]\n",
  "RUPTURES": "RUPTURE, to burst [v]\n",
  "RUPTUREWORT": "a caryophyllaceous plant once thought to cure hernia [n -S]\n",
  "RUPTUREWORTS": "RUPTUREWORT, a caryophyllaceous plant once thought to cure hernia [n]\n",
  "RUPTURING": "RUPTURE, to burst [v]\n",
  "RURAL": "belonging to the countryside [adj RURALLY] / a country-dweller [n -S]\n",
  "RURALISATION": "making rural, also RURALIZATION [n -S]\n",
  "RURALISATIONS": "RURALISATION, making rural, also RURALIZATION [n]\n",
  "RURALISE": "to make rural, also RURALIZE [v RURALISED, RURALISING, RURALISES]\n",
  "RURALISED": "RURALISE, to make rural, also RURALIZE [v]\n",
  "RURALISES": "RURALISE, to make rural, also RURALIZE [v]\n",
  "RURALISING": "RURALISE, to make rural, also RURALIZE [v]\n",
  "RURALISM": "the state of being rural [n -S]\n",
  "RURALISMS": "RURALISM, the state of being rural [n]\n",
  "RURALIST": "one who lives in the country, also RURALITE [n -S]\n",
  "RURALISTS": "RURALIST, one who lives in the country, also RURALITE [n]\n",
  "RURALITE": "one who lives in the country, also RURALIST [n -S]\n",
  "RURALITES": "RURALITE, one who lives in the country, also RURALIST [n]\n",
  "RURALITIES": "RURALITY, the state of being rural [n]\n",
  "RURALITY": "the state of being rural [n RURALITIES]\n",
  "RURALIZATION": "making rural, also RURALISATION [n -S]\n",
  "RURALIZATIONS": "RURALIZATION, making rural, also RURALISATION [n]\n",
  "RURALIZE": "to make rural, also RURALISE [v RURALIZED, RURALIZING, RURALIZES]\n",
  "RURALIZED": "RURALIZE, to make rural, also RURALISE [v]\n",
  "RURALIZES": "RURALIZE, to make rural, also RURALISE [v]\n",
  "RURALIZING": "RURALIZE, to make rural, also RURALISE [v]\n",
  "RURALLY": "RURAL, belonging to the countryside [adv]\n",
  "RURALNESS": "the state of being rural [n -ES]\n",
  "RURALNESSES": "RURALNESS, the state of being rural [n]\n",
  "RURALS": "RURAL, a country-dweller [n]\n",
  "RURBAN": "partially rural, partially urban [adj]\n",
  "RURIDECANAL": "concerning a rural dean and his jurisdiction [adj]\n",
  "RURP": "a small hooklike piton used in mountaineering [n -S]\n",
  "RURPS": "RURP, a small hooklike piton used in mountaineering [n]\n",
  "RURU": "(Maori) a New Zealand owl, aka boobook [n -S]\n",
  "RURUS": "RURU, (Maori) a New Zealand owl, aka boobook [n]\n",
  "RUSA": "(Hindi) an East Indian deer [n -S]\n",
  "RUSALKA": "(Russian) a water-nymph [n -S]\n",
  "RUSALKAS": "RUSALKA, (Russian) a water-nymph [n]\n",
  "RUSAS": "RUSA, (Hindi) an East Indian deer [n]\n",
  "RUSCUS": "(Latin) any plant of the genus Ruscus, that includes butcher's broom [n -ES]\n",
  "RUSCUSES": "RUSCUS, (Latin) any plant of the genus Ruscus, that includes butcher's broom [n]\n",
  "RUSE": "a deception [n -S]\n",
  "RUSES": "RUSE, a deception [n]\n",
  "RUSH": "to move swiftly [v -ED, -ING, -ES]\n",
  "RUSHED": "RUSH, to move swiftly [v]\n",
  "RUSHEE": "a college student seeking admission to a fraternity or sorority [n -S]\n",
  "RUSHEES": "RUSHEE, a college student seeking admission to a fraternity or sorority [n]\n",
  "RUSHEN": "made of rushes [adj]\n",
  "RUSHER": "in American football, a player who rushes; esp. a forward [n -S]\n",
  "RUSHERS": "RUSHER, in American football, a player who rushes; esp. a forward [n]\n",
  "RUSHES": "RUSH, to move swiftly [v]\n",
  "RUSHIER": "RUSHY, abounding in rushes [adj]\n",
  "RUSHIEST": "RUSHY, abounding in rushes [adj]\n",
  "RUSHINESS": "the state of abounding with rushes [n -ES]\n",
  "RUSHINESSES": "RUSHINESS, the state of abounding with rushes [n]\n",
  "RUSHING": "yardage gained in football by running plays [n -S]\n",
  "RUSHINGS": "RUSHING, yardage gained in football by running plays [n]\n",
  "RUSHLIGHT": "a type of candle dipped in grease [n -S]\n",
  "RUSHLIGHTS": "RUSHLIGHT, a type of candle dipped in grease [n]\n",
  "RUSHLIKE": "like a grasslike marsh plant [adj]\n",
  "RUSHY": "abounding in rushes [adj RUSHIER, RUSHIEST]\n",
  "RUSINE": "pertaining to a deer of the genus Rusa, which includes the sambur deer of India [adj]\n",
  "RUSK": "a light, soft-textured sweetened biscuit [n -S]\n",
  "RUSKS": "RUSK, a light, soft-textured sweetened biscuit [n]\n",
  "RUSMA": "(Turkish) a depilatory made of orpiment and quicklime, used by the Turks [n -S]\n",
  "RUSMAS": "RUSMA, (Turkish) a depilatory made of orpiment and quicklime, used by the Turks [n]\n",
  "RUSSE": "(French) as in charlotte russe, a cold dessert made from whipped cream, custard etc., surrounded by sponge fingers [adj]\n",
  "RUSSEL": "a ribbed cotton and woollen material [n -S]\n",
  "RUSSELS": "RUSSEL, a ribbed cotton and woollen material [n]\n",
  "RUSSET": "to become reddish brown in colour [v -ED, -ING, -S]\n",
  "RUSSETED": "RUSSET, to become reddish brown in colour [v]\n",
  "RUSSETIER": "RUSSETY, of a russet color [adj]\n",
  "RUSSETIEST": "RUSSETY, of a russet color [adj]\n",
  "RUSSETING": "a russet apple, also RUSSETTING [n -S]\n",
  "RUSSETINGS": "RUSSETING, a russet apple, also RUSSETTING [n]\n",
  "RUSSETS": "RUSSET, to become reddish brown in colour [v]\n",
  "RUSSETTING": "a russet apple, also RUSSETING [n -S]\n",
  "RUSSETTINGS": "RUSSETTING, a russet apple, also RUSSETING [n]\n",
  "RUSSETY": "of a russet color [adj RUSSETIER, RUSSETIEST]\n",
  "RUSSIA": "a fine brownish-red leather impregnated with birch tar oil, used esp. in bookbinding [n -S]\n",
  "RUSSIAS": "RUSSIA, a fine brownish-red leather impregnated with birch tar oil, used esp. in bookbinding [n]\n",
  "RUSSIFIED": "RUSSIFY, to make Russian [v]\n",
  "RUSSIFIES": "RUSSIFY, to make Russian [v]\n",
  "RUSSIFY": "to make Russian [v RUSSIFIED, RUSSIFYING, RUSSIFIES]\n",
  "RUSSIFYING": "RUSSIFY, to make Russian [v]\n",
  "RUSSULA": "any fungus of the genus Russula [n RUSSULAE or RUSSULAS]\n",
  "RUSSULAE": "RUSSULA, any fungus of the genus Russula [n]\n",
  "RUSSULAS": "RUSSULA, any fungus of the genus Russula [n]\n",
  "RUST": "to form a coat as on iron [v -ED, -ING, -S]\n",
  "RUSTABLE": "able to rust [adj]\n",
  "RUSTBUCKET": "a badly rusted car [n -S]\n",
  "RUSTBUCKETS": "RUSTBUCKET, a badly rusted car [n]\n",
  "RUSTED": "RUST, to form a coat as on iron [v]\n",
  "RUSTIC": "of or like the country, also RUSTICAL, RUSTICIAL [adj RUSTICLY or RUSTICALLY] / one who lives in the country [n -S]\n",
  "RUSTICAL": "rustic, also RUSTIC, RUSTICIAL [adj RUSTICALLY] / a rustic [n -S]\n",
  "RUSTICALLY": "RUSTICAL, rustic, also RUSTIC, RUSTICIAL [adv]\n",
  "RUSTICALS": "RUSTICAL, a rustic [n]\n",
  "RUSTICANA": "objects such as agricultural implements, garden furniture etc. made in the rustic style [n]\n",
  "RUSTICATE": "to send into the country; to banish to rural areas [v RUSTICATED, RUSTICATING, RUSTICATES]\n",
  "RUSTICATED": "RUSTICATE, to send into the country; to banish to rural areas [v]\n",
  "RUSTICATES": "RUSTICATE, to send into the country; to banish to rural areas [v]\n",
  "RUSTICATING": "the act of rusticating [n -S]\n",
  "RUSTICATINGS": "RUSTICATING, the act of rusticating [n]\n",
  "RUSTICATION": "the action of banishing, or the state of being banished, into the country [n -S]\n",
  "RUSTICATIONS": "RUSTICATION, the action of banishing, or the state of being banished, into the country [n]\n",
  "RUSTICATOR": "one who rusticates [n -S]\n",
  "RUSTICATORS": "RUSTICATOR, one who rusticates [n]\n",
  "RUSTICIAL": "(Scott) rustic, also RUSTIC, RUSTICAL [adj]\n",
  "RUSTICISE": "to make rustic, also RUSTICIZE [v RUSTICISED, RUSTICISING, RUSTICISES]\n",
  "RUSTICISED": "RUSTICISE, to make rustic, also RUSTICIZE [v]\n",
  "RUSTICISES": "RUSTICISE, to make rustic, also RUSTICIZE [v]\n",
  "RUSTICISING": "RUSTICISE, to make rustic, also RUSTICIZE [v]\n",
  "RUSTICISM": "a rustic saying or custom [n -S]\n",
  "RUSTICISMS": "RUSTICISM, a rustic saying or custom [n]\n",
  "RUSTICITIES": "RUSTICITY, a rustic manner; simplicity; rudeness [n]\n",
  "RUSTICITY": "a rustic manner; simplicity; rudeness [n RUSTICITIES]\n",
  "RUSTICIZE": "to make rustic, also RUSTICISE [v RUSTICIZED, RUSTICIZING, RUSTICIZES]\n",
  "RUSTICIZED": "RUSTICIZE, to make rustic, also RUSTICISE [v]\n",
  "RUSTICIZES": "RUSTICIZE, to make rustic, also RUSTICISE [v]\n",
  "RUSTICIZING": "RUSTICIZE, to make rustic, also RUSTICISE [v]\n",
  "RUSTICLY": "RUSTIC, of or like the country, also RUSTICAL, RUSTICIAL [adv]\n",
  "RUSTICS": "RUSTIC, one who lives in the country [n]\n",
  "RUSTICWORK": "rusticated masonry; summerhouses, etc. of rough branches [n -S]\n",
  "RUSTICWORKS": "RUSTICWORK, rusticated masonry; summerhouses, etc. of rough branches [n]\n",
  "RUSTIER": "RUSTY, covered with rust [adj]\n",
  "RUSTIEST": "RUSTY, covered with rust [adj]\n",
  "RUSTILY": "RUSTY, covered with rust [adv]\n",
  "RUSTINESS": "the state of being rusty [n -ES]\n",
  "RUSTINESSES": "RUSTINESS, the state of being rusty [n]\n",
  "RUSTING": "the act of rusting [n -S]\n",
  "RUSTINGS": "RUSTING, the act of rusting [n]\n",
  "RUSTLE": "to steal cattle [v RUSTLED, RUSTLING, RUSTLES]\n",
  "RUSTLED": "RUSTLE, to steal cattle [v]\n",
  "RUSTLER": "one who steals cattle [n -S]\n",
  "RUSTLERS": "RUSTLER, one who steals cattle [n]\n",
  "RUSTLES": "RUSTLE, to steal cattle [v]\n",
  "RUSTLESS": "free from rust [adj]\n",
  "RUSTLING": "making a rustling sound [adj RUSTLINGLY] / the act of rustling [n -S]\n",
  "RUSTLINGLY": "RUSTLING, making a rustling sound [adv]\n",
  "RUSTLINGS": "RUSTLING, the act of rustling [n]\n",
  "RUSTPROOF": "to make resistant to rust, such as by applying a coating [v -ED, -ING, -S]\n",
  "RUSTPROOFED": "RUSTPROOF, to make resistant to rust, such as by applying a coating [v]\n",
  "RUSTPROOFING": "the act of making resistant to rust, such as by applying a coating [n -S]\n",
  "RUSTPROOFINGS": "RUSTPROOFING, the act of making resistant to rust, such as by applying a coating [n]\n",
  "RUSTPROOFS": "RUSTPROOF, to make resistant to rust, such as by applying a coating [v]\n",
  "RUSTRE": "a lozenge pierced with a circular opening [n -S]\n",
  "RUSTRED": "pierced with a rustre, a lozenge pierced with a circular opening [adj]\n",
  "RUSTRES": "RUSTRE, a lozenge pierced with a circular opening [n]\n",
  "RUSTS": "RUST, to form a coat as on iron [v]\n",
  "RUSTY": "covered with rust [adj RUSTIER, RUSTIEST, RUSTILY]\n",
  "RUT": "to make grooves in [v RUTTED, RUTTING, RUTS]\n",
  "RUTABAGA": "(Swedish) a root vegetable like a swede [n -S]\n",
  "RUTABAGAS": "RUTABAGA, (Swedish) a root vegetable like a swede [n]\n",
  "RUTACEOUS": "of or pertaining to the rue family [adj]\n",
  "RUTH": "(archaic) compassion, pity, also REWTH [n -S]\n",
  "RUTHENIC": "pertaining to a rare, metallic element [adj]\n",
  "RUTHENIOUS": "pertaining to, or containing, ruthenium [adj]\n",
  "RUTHENIUM": "a metallic element of the platinum group [n -S]\n",
  "RUTHENIUMS": "RUTHENIUM, a metallic element of the platinum group [n]\n",
  "RUTHER": "(dialect) rather [adv]\n",
  "RUTHERFORD": "a unit of radioactive decay equal to 1 million disintegrations per second [n -S]\n",
  "RUTHERFORDIUM": "an artificially produced radioactive transuranic element [n -S]\n",
  "RUTHERFORDIUMS": "RUTHERFORDIUM, an artificially produced radioactive transuranic element [n]\n",
  "RUTHERFORDS": "RUTHERFORD, a unit of radioactive decay equal to 1 million disintegrations per second [n]\n",
  "RUTHFUL": "full of compassion [adj RUTHFULLY]\n",
  "RUTHFULLY": "RUTHFUL, full of compassion [adv]\n",
  "RUTHFULNESS": "the state of being ruthful [n -ES]\n",
  "RUTHFULNESSES": "RUTHFULNESS, the state of being ruthful [n]\n",
  "RUTHLESS": "having no compassion [adj RUTHLESSLY]\n",
  "RUTHLESSLY": "RUTHLESS, having no compassion [adv]\n",
  "RUTHLESSNESS": "the state of being ruthless [n -ES]\n",
  "RUTHLESSNESSES": "RUTHLESSNESS, the state of being ruthless [n]\n",
  "RUTHS": "RUTH, (archaic) compassion, pity, also REWTH [n]\n",
  "RUTILANT": "having a reddish glow [adj]\n",
  "RUTILATED": "of quartz, containing needles of rutile [adj]\n",
  "RUTILE": "a reddish-brown mineral of the tetragonal system, titanium oxide [n -S]\n",
  "RUTILES": "RUTILE, a reddish-brown mineral of the tetragonal system, titanium oxide [n]\n",
  "RUTIN": "a drug used against the fragility of small blood vessels [n -S]\n",
  "RUTINS": "RUTIN, a drug used against the fragility of small blood vessels [n]\n",
  "RUTS": "RUT, to make grooves in [v]\n",
  "RUTTED": "RUT, to make grooves in [v]\n",
  "RUTTER": "(obsolete) a horseman or trooper [n -S]\n",
  "RUTTERS": "RUTTER, (obsolete) a horseman or trooper [n]\n",
  "RUTTIER": "RUTTY, marked by ruts [adj]\n",
  "RUTTIEST": "RUTTY, marked by ruts [adj]\n",
  "RUTTILY": "RUTTY, marked by ruts [adv]\n",
  "RUTTINESS": "the state of being rutty [n -ES]\n",
  "RUTTINESSES": "RUTTINESS, the state of being rutty [n]\n",
  "RUTTING": "the act of sexual congress, esp. of animals [n -S]\n",
  "RUTTINGS": "RUTTING, the act of sexual congress, esp. of animals [n]\n",
  "RUTTISH": "(Shakespeare) lustful [adj RUTTISHLY]\n",
  "RUTTISHLY": "RUTTISH, (Shakespeare) lustful [adv]\n",
  "RUTTISHNESS": "the state of being ruttish [n -ES]\n",
  "RUTTISHNESSES": "RUTTISHNESS, the state of being ruttish [n]\n",
  "RUTTY": "marked by ruts [adj RUTTIER, RUTTIEST, RUTTILY]\n",
  "RYA": "a Scandinavian handwoven rug [n -S]\n",
  "RYAL": "an old English gold coin worth about ten shillings, also RIAL [n -S]\n",
  "RYALS": "RYAL, an old English gold coin worth about ten shillings, also RIAL [n]\n",
  "RYAS": "RYA, a Scandinavian handwoven rug [n]\n",
  "RYBAT": "(Scots) a dressed stone at the side of a door, window etc. [n -S]\n",
  "RYBATS": "RYBAT, (Scots) a dressed stone at the side of a door, window etc. [n]\n",
  "RYBAUDRYE": "(Spenser) ribaldry, also RIBALDRY, RIBAUDRY [n -S]\n",
  "RYBAUDRYES": "RYBAUDRYE, (Spenser) ribaldry, also RIBALDRY, RIBAUDRY [n]\n",
  "RYE": "a cereal grass, also RHY [n -S]\n",
  "RYEBREAD": "bread made from rye [n -S]\n",
  "RYEBREADS": "RYEBREAD, bread made from rye [n]\n",
  "RYEFLOUR": "a pasture and fodder type of grass, also RAYGRASS, RYEGRASS [n -S]\n",
  "RYEFLOURS": "RYEFLOUR, a pasture and fodder type of grass, also RAYGRASS, RYEGRASS [n]\n",
  "RYEGRASS": "a pasture and fodder type of grass, also RAYGRASS, RYEFLOUR [n -ES]\n",
  "RYEGRASSES": "RYEGRASS, a pasture and fodder type of grass, also RAYGRASS, RYEFLOUR [n]\n",
  "RYEPECK": "a pole used for mooring a punt, also RIPECK, RYPECK [n -S]\n",
  "RYEPECKS": "RYEPECK, a pole used for mooring a punt, also RIPECK, RYPECK [n]\n",
  "RYES": "RYE, a cereal grass, also RHY [n]\n",
  "RYFE": "(Spenser) rife [adj]\n",
  "RYKE": "(Scots) to reach [v RYKED, RYKING, RYKES]\n",
  "RYKED": "RYKE, (Scots) to reach [v]\n",
  "RYKES": "RYKE, (Scots) to reach [v]\n",
  "RYKING": "RYKE, (Scots) to reach [v]\n",
  "RYMME": "(obsolete) to provide with a rim [v RYMMED, RYMMING, RYMMES]\n",
  "RYMMED": "RYMME, (obsolete) to provide with a rim [v]\n",
  "RYMMES": "RYMME, (obsolete) to provide with a rim [v]\n",
  "RYMMING": "RYMME, (obsolete) to provide with a rim [v]\n",
  "RYND": "a fitting to support a millstone [n -S]\n",
  "RYNDS": "RYND, a fitting to support a millstone [n]\n",
  "RYOKAN": "(Japanese) a traditional Japanese inn [n -S]\n",
  "RYOKANS": "RYOKAN, (Japanese) a traditional Japanese inn [n]\n",
  "RYOT": "(Hindi) an Indian peasant, also RAIYAT [n -S]\n",
  "RYOTS": "RYOT, (Hindi) an Indian peasant, also RAIYAT [n]\n",
  "RYOTWARI": "(Hindi) a system of peasantry in India, also RAIYATWARI [n -S]\n",
  "RYOTWARIS": "RYOTWARI, (Hindi) a system of peasantry in India, also RAIYATWARI [n]\n",
  "RYPE": "(Danish) a ptarmigan [n RYPER]\n",
  "RYPECK": "a pole used for mooring a punt, also RIPECK, RYEPECK [n -S]\n",
  "RYPECKS": "RYPECK, a pole used for mooring a punt, also RIPECK, RYEPECK [n]\n",
  "RYPER": "RYPE, (Danish) a ptarmigan [n]\n",
  "RYU": "(Japanese) a school of Japanese martial arts [n -S]\n",
  "RYUS": "RYU, (Japanese) a school of Japanese martial arts [n]\n",
  "SAAG": "(Hindi) in Indian cookery, spinach [n -S]\n",
  "SAAGS": "SAAG, (Hindi) in Indian cookery, spinach [n]\n",
  "SAB": "(Scots) to sob [v SABBED, SABBING, SABS]\n",
  "SABADILLA": "(Spanish) a liliaceous plant, yielding the alkaloid veratrine, also CEBADILLA, CEVADILLA [n -S]\n",
  "SABADILLAS": "SABADILLA, (Spanish) a liliaceous plant, yielding the alkaloid veratrine, also CEBADILLA, CEVADILLA [n]\n",
  "SABAL": "a variety of palm tree [n -S]\n",
  "SABALS": "SABAL, a variety of palm tree [n]\n",
  "SABATON": "(historical) a foot-covering as part of suit of armour [n -S]\n",
  "SABATONS": "SABATON, (historical) a foot-covering as part of suit of armour [n]\n",
  "SABAYON": "(French) a sauce of whipped egg yolks, sugar and wine [n -S]\n",
  "SABAYONS": "SABAYON, (French) a sauce of whipped egg yolks, sugar and wine [n]\n",
  "SABBAT": "an assembly of demons and witches, also SABBATH [n -S]\n",
  "SABBATARIAN": "of or like a Sabbatarian, one who keeps the sabbath strictly [adj]\n",
  "SABBATH": "(Hebrew) an assembly of demons and witches, also SABBAT [n -S]\n",
  "SABBATHS": "SABBATH, (Hebrew) an assembly of demons and witches, also SABBAT [n]\n",
  "SABBATIC": "a period of leave from one's work, also SABBATICAL [n -S]\n",
  "SABBATICAL": "relating to the Sabbath [adj] / a period of leave from one's work, also SABBATIC [n -S]\n",
  "SABBATICALS": "SABBATICAL, a period of leave from one's work, also SABBATIC [n]\n",
  "SABBATICS": "SABBATIC, a period of leave from one's work, also SABBATICAL [n]\n",
  "SABBATINE": "relating to Saturday [adj]\n",
  "SABBATISE": "to observe as a Sabbath, also SABBATIZE [v SABBATISED, SABBATISING, SABBATISES]\n",
  "SABBATISED": "SABBATISE, to observe as a Sabbath, also SABBATIZE [v]\n",
  "SABBATISES": "SABBATISE, to observe as a Sabbath, also SABBATIZE [v]\n",
  "SABBATISING": "SABBATISE, to observe as a Sabbath, also SABBATIZE [v]\n",
  "SABBATISM": "intermission of labor, as upon the Sabbath [n -S]\n",
  "SABBATISMS": "SABBATISM, intermission of labor, as upon the Sabbath [n]\n",
  "SABBATIZE": "to observe as a Sabbath, also SABBATISE [v SABBATIZED, SABBATIZING, SABBATIZES]\n",
  "SABBATIZED": "SABBATIZE, to observe as a Sabbath, also SABBATISE [v]\n",
  "SABBATIZES": "SABBATIZE, to observe as a Sabbath, also SABBATISE [v]\n",
  "SABBATIZING": "SABBATIZE, to observe as a Sabbath, also SABBATISE [v]\n",
  "SABBATS": "SABBAT, an assembly of demons and witches, also SABBATH [n]\n",
  "SABBED": "SAB, (Scots) to sob [v]\n",
  "SABBING": "the performance of organized acts of sabotage [n -S]\n",
  "SABBINGS": "SABBING, the performance of organized acts of sabotage [n]\n",
  "SABE": "to know, to understand, also SAVEY, SAVVEY, SAVVY [v SABED, SABEING, SABES]\n",
  "SABED": "SABE, to know, to understand, also SAVEY, SAVVEY, SAVVY [v]\n",
  "SABEING": "SABE, to know, to understand, also SAVEY, SAVVEY, SAVVY [v]\n",
  "SABELLA": "(Latin) any of a genus of tubicolous annelids having a circle of plumose gills around the head [n -S]\n",
  "SABELLAS": "SABELLA, (Latin) any of a genus of tubicolous annelids having a circle of plumose gills around the head [n]\n",
  "SABER": "to strike with a type of sword, also SABRE [v -ED, -ING, -S]\n",
  "SABERED": "SABER, to strike with a type of sword, also SABRE [v]\n",
  "SABERING": "SABER, to strike with a type of sword, also SABRE [v]\n",
  "SABERLIKE": "like a saber, also SABRELIKE [adj]\n",
  "SABERMETRICIAN": "a student of sabermetrics, the statistical analysis of baseball data [n -S]\n",
  "SABERMETRICIANS": "SABERMETRICIAN, a student of sabermetrics, the statistical analysis of baseball data [n]\n",
  "SABERMETRICS": "the statistical analysis of baseball data [n]\n",
  "SABERS": "SABER, to strike with a type of sword, also SABRE [v]\n",
  "SABES": "SABE, to know, to understand, also SAVEY, SAVVEY, SAVVY [v]\n",
  "SABHA": "(Arabic) a set of beads used by Muslims during prayer, also SUBHA [n -S]\n",
  "SABHAS": "SABHA, (Arabic) a set of beads used by Muslims during prayer, also SUBHA [n]\n",
  "SABICU": "a Caribbean tree, aka horse-head mahogany [n -S]\n",
  "SABICUS": "SABICU, a Caribbean tree, aka horse-head mahogany [n]\n",
  "SABIN": "(obsolete) a unit of acoustic absorption [n -S]\n",
  "SABINE": "an evergreen shrub, also SAVIN, SAVINE [n -S]\n",
  "SABINES": "SABINE, an evergreen shrub, also SAVIN, SAVINE [n]\n",
  "SABINS": "SABIN, (obsolete) a unit of acoustic absorption [n]\n",
  "SABIR": "(French) a French-based pidgin language [n -S]\n",
  "SABIRS": "SABIR, (French) a French-based pidgin language [n]\n",
  "SABKHA": "(Arabic) a broad, salt-encrusted coastal plain above the level of normal tides, also SABKHAH, SABKHAT [n -S]\n",
  "SABKHAH": "(Arabic) a broad, salt-encrusted coastal plain above the level of normal tides, also SABKHA, SABKHAT [n -S]\n",
  "SABKHAHS": "SABKHAH, (Arabic) a broad, salt-encrusted coastal plain above the level of normal tides, also SABKHA, SABKHAT [n]\n",
  "SABKHAS": "SABKHA, (Arabic) a broad, salt-encrusted coastal plain above the level of normal tides, also SABKHAH, SABKHAT [n]\n",
  "SABKHAT": "(Arabic) a broad, salt-encrusted coastal plain above the level of normal tides, also SABKHA, SABKHAH [n -S]\n",
  "SABKHATS": "SABKHAT, (Arabic) a broad, salt-encrusted coastal plain above the level of normal tides, also SABKHA, SABKHAH [n]\n",
  "SABLE": "black, dark [adj SABLER, SABLEST] / to darken [v SABLED, SABLING, SABLES]\n",
  "SABLED": "SABLE, to darken [v]\n",
  "SABLEFISH": "a large spiny-finned gray to blackish fish of the Pacific coast [n -ES]\n",
  "SABLEFISHES": "SABLEFISH, a large spiny-finned gray to blackish fish of the Pacific coast [n]\n",
  "SABLER": "SABLE, black, dark [adj]\n",
  "SABLES": "SABLE, to darken [v]\n",
  "SABLEST": "SABLE, black, dark [adj]\n",
  "SABLING": "SABLE, to darken [v]\n",
  "SABOT": "(French) a wooden shoe; a clog [n -S]\n",
  "SABOTAGE": "to destroy maliciously [v SABOTAGED, SABOTAGING, SABOTAGES]\n",
  "SABOTAGED": "SABOTAGE, to destroy maliciously [v]\n",
  "SABOTAGES": "SABOTAGE, to destroy maliciously [v]\n",
  "SABOTAGING": "SABOTAGE, to destroy maliciously [v]\n",
  "SABOTED": "wearing sabots [adj]\n",
  "SABOTEUR": "(French) one who performs acts of sabotage [n -S]\n",
  "SABOTEURS": "SABOTEUR, (French) one who performs acts of sabotage [n]\n",
  "SABOTIER": "(French) a wearer of wooden shoes [n -S]\n",
  "SABOTIERS": "SABOTIER, (French) a wearer of wooden shoes [n]\n",
  "SABOTS": "SABOT, (French) a wooden shoe; a clog [n]\n",
  "SABRA": "(Hebrew) a prickly-pear fruit; also, a native Israeli [n -S]\n",
  "SABRAS": "SABRA, (Hebrew) a prickly-pear fruit; also, a native Israeli [n]\n",
  "SABRE": "to strike with a type of sword, also SABER [v SABRED, SABRING, SABRES]\n",
  "SABRED": "SABRE, to strike with a type of sword, also SABER [v]\n",
  "SABRELIKE": "like a sabre, also SABERLIKE [adj]\n",
  "SABRES": "SABRE, to strike with a type of sword, also SABER [v]\n",
  "SABRETACHE": "(French) a satchel suspended from a cavalry officer's belt [n -S]\n",
  "SABRETACHES": "SABRETACHE, (French) a satchel suspended from a cavalry officer's belt [n]\n",
  "SABREUR": "(French) a person, esp. a cavalry officer, who fights with a sabre [n -S]\n",
  "SABREURS": "SABREUR, (French) a person, esp. a cavalry officer, who fights with a sabre [n]\n",
  "SABREWING": "a hummingbird of a group with bent outer primaries in the male [n -S]\n",
  "SABREWINGS": "SABREWING, a hummingbird of a group with bent outer primaries in the male [n]\n",
  "SABRING": "SABRE, to strike with a type of sword, also SABER [v]\n",
  "SABS": "SAB, (Scots) to sob [v]\n",
  "SABULINE": "sandy [adj]\n",
  "SABULOSE": "sandy; growing in sandy places, also SABULOUS [adj]\n",
  "SABULOSITIES": "SABULOSITY, grittiness, sandiness [n]\n",
  "SABULOSITY": "grittiness, sandiness [n SABULOSITIES]\n",
  "SABULOUS": "sandy; growing in sandy places, also SABULOSE [adj]\n",
  "SABURRA": "(Latin) a granular deposit [n -S]\n",
  "SABURRAL": "relating to saburra, granular matter deposited in the body [adj]\n",
  "SABURRAS": "SABURRA, (Latin) a granular deposit [n]\n",
  "SABURRATION": "the application of hot sand as medical treatment [n -S]\n",
  "SABURRATIONS": "SABURRATION, the application of hot sand as medical treatment [n]\n",
  "SAC": "in biology, a baglike structure [n -S]\n",
  "SACAHUISTA": "(Nahuatl) a bear grass that may cause poisoning in livestock, also SACAHUISTE [n -S]\n",
  "SACAHUISTAS": "SACAHUISTA, (Nahuatl) a bear grass that may cause poisoning in livestock, also SACAHUISTE [n]\n",
  "SACAHUISTE": "(Nahuatl) a bear grass that may cause poisoning in livestock, also SACAHUISTA [n -S]\n",
  "SACAHUISTES": "SACAHUISTE, (Nahuatl) a bear grass that may cause poisoning in livestock, also SACAHUISTA [n]\n",
  "SACATON": "(Spanish) a type of coarse perennial grass growing in alkaline regions of the southern US, also ZACATON [n -S]\n",
  "SACATONS": "SACATON, (Spanish) a type of coarse perennial grass growing in alkaline regions of the southern US, also ZACATON [n]\n",
  "SACBUT": "a medieval trombone, also SACKBUT, SAGBUT [n -S]\n",
  "SACBUTS": "SACBUT, a medieval trombone, also SACKBUT, SAGBUT [n]\n",
  "SACCADE": "(French) a brief rapid movement of the eye from one position of rest to another, whether voluntary or involuntary [n -S]\n",
  "SACCADES": "SACCADE, (French) a brief rapid movement of the eye from one position of rest to another, whether voluntary or involuntary [n]\n",
  "SACCADIC": "jerky; twitching [adj SACCADICALLY]\n",
  "SACCADICALLY": "SACCADIC, jerky; twitching [adv]\n",
  "SACCATE": "having the form of a sack or pouch [adj]\n",
  "SACCHARASE": "an enzyme that inverts cane sugar, aka invertase [n -S]\n",
  "SACCHARASES": "SACCHARASE, an enzyme that inverts cane sugar, aka invertase [n]\n",
  "SACCHARATE": "a salt of saccharic acid [n -S]\n",
  "SACCHARATED": "converted to a salt of saccharic acid [adj]\n",
  "SACCHARATES": "SACCHARATE, a salt of saccharic acid [n]\n",
  "SACCHARIC": "of or obtained from saccharin [adj]\n",
  "SACCHARIDE": "a carbohydrate, a compound of sugar [n -S]\n",
  "SACCHARIDES": "SACCHARIDE, a carbohydrate, a compound of sugar [n]\n",
  "SACCHARIFEROUS": "bearing sugar [adj]\n",
  "SACCHARIFIED": "SACCHARIFY, to convert into, or to impregnate with, sugar [v]\n",
  "SACCHARIFIES": "SACCHARIFY, to convert into, or to impregnate with, sugar [v]\n",
  "SACCHARIFY": "to convert into, or to impregnate with, sugar [v SACCHARIFIED, SACCHARIFYING, SACCHARIFIES]\n",
  "SACCHARIFYING": "SACCHARIFY, to convert into, or to impregnate with, sugar [v]\n",
  "SACCHARIMETER": "an instrument for measuring the amount of sugar in a solution, also SACCHAROMETER [n -S]\n",
  "SACCHARIMETERS": "SACCHARIMETER, an instrument for measuring the amount of sugar in a solution, also SACCHAROMETER [n]\n",
  "SACCHARIMETRIES": "SACCHARIMETRY, the measurement of the concentration of sugar solutions [n]\n",
  "SACCHARIMETRY": "the measurement of the concentration of sugar solutions [n SACCHARIMETRIES]\n",
  "SACCHARIN": "an artificial sweetener, also SACCHARINE [n -S]\n",
  "SACCHARINE": "sickly sweet [adj SACCHARINELY] / an artificial sweetener, also SACCHARIN [n -S]\n",
  "SACCHARINELY": "SACCHARINE, sickly sweet [adv]\n",
  "SACCHARINES": "SACCHARINE, an artificial sweetener, also SACCHARIN [n]\n",
  "SACCHARINITIES": "SACCHARINITY, the state of being saccharine [n]\n",
  "SACCHARINITY": "the state of being saccharine [n SACCHARINITIES]\n",
  "SACCHARINS": "SACCHARIN, an artificial sweetener, also SACCHARINE [n]\n",
  "SACCHARISATION": "the process of saccharising, also SACCHARIZATION [n -S]\n",
  "SACCHARISATIONS": "SACCHARISATION, the process of saccharising, also SACCHARIZATION [n]\n",
  "SACCHARISE": "to convert into, or to impregnate with, sugar, also SACCHARIZE [v SACCHARISED, SACCHARISING, SACCHARISES]\n",
  "SACCHARISED": "SACCHARISE, to convert into, or to impregnate with, sugar, also SACCHARIZE [v]\n",
  "SACCHARISES": "SACCHARISE, to convert into, or to impregnate with, sugar, also SACCHARIZE [v]\n",
  "SACCHARISING": "SACCHARISE, to convert into, or to impregnate with, sugar, also SACCHARIZE [v]\n",
  "SACCHARIZATION": "the process of saccharizing, also SACCHARISATION [n -S]\n",
  "SACCHARIZATIONS": "SACCHARIZATION, the process of saccharizing, also SACCHARISATION [n]\n",
  "SACCHARIZE": "to convert into, or to impregnate with, sugar, also SACCHARISE [v SACCHARIZED, SACCHARIZING, SACCHARIZES]\n",
  "SACCHARIZED": "SACCHARIZE, to convert into, or to impregnate with, sugar, also SACCHARISE [v]\n",
  "SACCHARIZES": "SACCHARIZE, to convert into, or to impregnate with, sugar, also SACCHARISE [v]\n",
  "SACCHARIZING": "SACCHARIZE, to convert into, or to impregnate with, sugar, also SACCHARISE [v]\n",
  "SACCHAROID": "like loaf sugar in texture, also SACCHAROIDAL [adj] / a marble or quartzite of fine to medium grain [n -S]\n",
  "SACCHAROIDAL": "like loaf sugar in texture, usually applied to marbles and quartzites of fine to medium grain, also SACCHAROID [adj]\n",
  "SACCHAROIDS": "SACCHAROID, a marble or quartzite of fine to medium grain [n]\n",
  "SACCHAROMETER": "an instrument for measuring the amount of sugar in a solution, also SACCHARIMETER [n -S]\n",
  "SACCHAROMETERS": "SACCHAROMETER, an instrument for measuring the amount of sugar in a solution, also SACCHARIMETER [n]\n",
  "SACCHAROMETRIES": "SACCHAROMETRY, the process of determining the quantity of sugar in a solution [n]\n",
  "SACCHAROMETRY": "the process of determining the quantity of sugar in a solution [n SACCHAROMETRIES]\n",
  "SACCHAROMYCES": "any of a genus of usually unicellular yeasts [n SACCHAROMYCETES]\n",
  "SACCHAROMYCETES": "SACCHAROMYCES, any of a genus of usually unicellular yeasts [n]\n",
  "SACCHAROSE": "any carbohydrate, esp. cane sugar [n -S]\n",
  "SACCHAROSES": "SACCHAROSE, any carbohydrate, esp. cane sugar [n]\n",
  "SACCHARUM": "a genus of tall tropical grasses including the sugar cane [n -S]\n",
  "SACCHARUMS": "SACCHARUM, a genus of tall tropical grasses including the sugar cane [n]\n",
  "SACCIFORM": "shaped like a sac [adj]\n",
  "SACCOI": "SACCOS, (Greek) a Bishop's vestment like an alb, also SAKKOS [n]\n",
  "SACCOS": "(Greek) a Bishop's vestment like an alb, also SAKKOS [n SACCOSES or SACCOI]\n",
  "SACCOSES": "SACCOS, (Greek) a Bishop's vestment like an alb, also SAKKOS [n]\n",
  "SACCULAR": "saclike [adj]\n",
  "SACCULATE": "formed in a series of saclike enclosures, also SACCULATED [adj]\n",
  "SACCULATED": "formed in a series of saclike enclosures, also SACCULATE [adj]\n",
  "SACCULATION": "the state of being sacculated [n -S]\n",
  "SACCULATIONS": "SACCULATION, the state of being sacculated [n]\n",
  "SACCULE": "a small sac, also SACCULUS [n -S]\n",
  "SACCULES": "SACCULE, a small sac, also SACCULUS [n]\n",
  "SACCULI": "SACCULUS, (Latin) a small sac, also SACCULE [n]\n",
  "SACCULIFORM": "shaped like a small sac [adj]\n",
  "SACCULUS": "(Latin) a small sac, also SACCULE [n SACCULI]\n",
  "SACELLA": "SACELLUM, (Latin) an unroofed space consecrated to a divinity [n]\n",
  "SACELLUM": "(Latin) an unroofed space consecrated to a divinity [n SACELLA]\n",
  "SACERDOTAL": "of or relating to priests or a priesthood [adj SACERDOTALLY]\n",
  "SACERDOTALISE": "to render sacerdotal, also SACERDOTALIZE [v SACERDOTALISED, SACERDOTALISING, SACERDOTALISES]\n",
  "SACERDOTALISED": "SACERDOTALISE, to render sacerdotal, also SACERDOTALIZE [v]\n",
  "SACERDOTALISES": "SACERDOTALISE, to render sacerdotal, also SACERDOTALIZE [v]\n",
  "SACERDOTALISING": "SACERDOTALISE, to render sacerdotal, also SACERDOTALIZE [v]\n",
  "SACERDOTALISM": "the belief that priests are necessary mediators between God and mankind [n -S]\n",
  "SACERDOTALISMS": "SACERDOTALISM, the belief that priests are necessary mediators between God and mankind [n]\n",
  "SACERDOTALIST": "a believer in sacerdotalism [n -S]\n",
  "SACERDOTALISTS": "SACERDOTALIST, a believer in sacerdotalism [n]\n",
  "SACERDOTALIZE": "to render sacerdotal, also SACERDOTALISE [v SACERDOTALIZED, SACERDOTALIZING, SACERDOTALIZES]\n",
  "SACERDOTALIZED": "SACERDOTALIZE, to render sacerdotal, also SACERDOTALISE [v]\n",
  "SACERDOTALIZES": "SACERDOTALIZE, to render sacerdotal, also SACERDOTALISE [v]\n",
  "SACERDOTALIZING": "SACERDOTALIZE, to render sacerdotal, also SACERDOTALISE [v]\n",
  "SACERDOTALLY": "SACERDOTAL, of or relating to priests or a priesthood [adv]\n",
  "SACHEM": "(Native American) an Indian chief; a Tammany leader [n -S]\n",
  "SACHEMDOM": "the government or jurisdiction of a sachem [n -S]\n",
  "SACHEMDOMS": "SACHEMDOM, the government or jurisdiction of a sachem [n]\n",
  "SACHEMIC": "relating to a sachem, an Indian chief [adj]\n",
  "SACHEMS": "SACHEM, (Native American) an Indian chief; a Tammany leader [n]\n",
  "SACHEMSHIP": "the office or condition of a sachem [n -S]\n",
  "SACHEMSHIPS": "SACHEMSHIP, the office or condition of a sachem [n]\n",
  "SACHET": "a small plastic envelope holding liquid or cream [n -S]\n",
  "SACHETED": "possessed of a sachet [adj]\n",
  "SACHETS": "SACHET, a small plastic envelope holding liquid or cream [n]\n",
  "SACK": "to put into a large bag [v -ED, -ING, -S]\n",
  "SACKABLE": "serious enough to be sacked for [adj]\n",
  "SACKAGE": "to sack or plunder [v SACKAGED, SACKAGING, SACKAGES]\n",
  "SACKAGED": "SACKAGE, to sack or plunder [v]\n",
  "SACKAGES": "SACKAGE, to sack or plunder [v]\n",
  "SACKAGING": "SACKAGE, to sack or plunder [v]\n",
  "SACKBUT": "a medieval trombone, also SACBUT, SAGBUT [n -S]\n",
  "SACKBUTS": "SACKBUT, a medieval trombone, also SACBUT, SAGBUT [n]\n",
  "SACKCLOTH": "a coarse cloth worn by penitents [n -S]\n",
  "SACKCLOTHS": "SACKCLOTH, a coarse cloth worn by penitents [n]\n",
  "SACKED": "SACK, to put into a large bag [v]\n",
  "SACKER": "a position in baseball [n -S]\n",
  "SACKERS": "SACKER, a position in baseball [n]\n",
  "SACKFUL": "as much as a sack can hold [n SACKFULS or SACKSFUL]\n",
  "SACKFULS": "SACKFUL, as much as a sack can hold [n]\n",
  "SACKING": "material for making sacks [n -S]\n",
  "SACKINGS": "SACKING, material for making sacks [n]\n",
  "SACKLESS": "quiet; peaceable; harmless, also SACLESS, SAIKLESS [adj]\n",
  "SACKLIKE": "like a sack [adj]\n",
  "SACKLOAD": "the contents of a sack [n -S]\n",
  "SACKLOADS": "SACKLOAD, the contents of a sack [n]\n",
  "SACKS": "SACK, to put into a large bag [v]\n",
  "SACKSFUL": "SACKFUL, as much as a sack can hold [n]\n",
  "SACLESS": "quiet; peaceable; innocent [adj]\n",
  "SACLIKE": "like a sac [adj]\n",
  "SACQUE": "a woman's loose-fitting gown; a train of silk hanging from the shoulders of such a gown [n -S]\n",
  "SACQUES": "SACQUE, a woman's loose-fitting gown; a train of silk hanging from the shoulders of such a gown [n]\n",
  "SACRA": "SACRUM, (Latin) a bone of the pelvis [n]\n",
  "SACRAL": "a vertebra or nerve near the sacrum [n -S]\n",
  "SACRALGIA": "inflammation of the sacrum [n -S]\n",
  "SACRALGIAS": "SACRALGIA, inflammation of the sacrum [n]\n",
  "SACRALISATION": "the process of sacralising, also SACRALIZATION [n -S]\n",
  "SACRALISATIONS": "SACRALISATION, the process of sacralising, also SACRALIZATION [n]\n",
  "SACRALISE": "to make sacred, also SACRALIZE [v SACRALISED, SACRALISING, SACRALISES]\n",
  "SACRALISED": "SACRALISE, to make sacred, also SACRALIZE [v]\n",
  "SACRALISES": "SACRALISE, to make sacred, also SACRALIZE [v]\n",
  "SACRALISING": "SACRALISE, to make sacred, also SACRALIZE [v]\n",
  "SACRALITIES": "SACRALITY, the state of being SACRAL [n]\n",
  "SACRALITY": "the state of being SACRAL [n SACRALITIES]\n",
  "SACRALIZATION": "the process of sacralizing, also SACRALISATION [n -S]\n",
  "SACRALIZATIONS": "SACRALIZATION, the process of sacralizing, also SACRALISATION [n]\n",
  "SACRALIZE": "to make sacred, also SACRALISE [v SACRALIZED, SACRALIZING, SACRALIZES]\n",
  "SACRALIZED": "SACRALIZE, to make sacred, also SACRALISE [v]\n",
  "SACRALIZES": "SACRALIZE, to make sacred, also SACRALISE [v]\n",
  "SACRALIZING": "SACRALIZE, to make sacred, also SACRALISE [v]\n",
  "SACRALS": "SACRAL, a vertebra or nerve near the sacrum [n]\n",
  "SACRAMENT": "a sign, token, or pledge of a covenant [n -S] / to bind by an oath or sacrament [v -ED, -ING, -S]\n",
  "SACRAMENTAL": "of or like a sacrament [adj SACRAMENTALLY] / an action or object, such as the rosary, of ecclesiastical origin that serves to express or increase devotion [n -S]\n",
  "SACRAMENTALISM": "belief in or use of sacramental rites, acts, or objects [n -S]\n",
  "SACRAMENTALISMS": "SACRAMENTALISM, belief in or use of sacramental rites, acts, or objects [n]\n",
  "SACRAMENTALIST": "an exponent of sacramentalism [n -S]\n",
  "SACRAMENTALISTS": "SACRAMENTALIST, an exponent of sacramentalism [n]\n",
  "SACRAMENTALITY": "the state of being sacramental [n]\n",
  "SACRAMENTALLY": "SACRAMENTAL, of or like a sacrament [adv]\n",
  "SACRAMENTALNESS": "the state of being sacramental [n]\n",
  "SACRAMENTALS": "SACRAMENTAL, an action or object, such as the rosary, of ecclesiastical origin that serves to express or increase devotion [n]\n",
  "SACRAMENTARIAN": "holding a high or extreme view of the efficacy of the sacraments [adj] / a person with such views [n -S]\n",
  "SACRAMENTARIANS": "SACRAMENTARIAN, a person with such views [n]\n",
  "SACRAMENTARIES": "SACRAMENTARY, a book containing all the prayers and ceremonies used at the celebration of the Roman Catholic sacraments [n]\n",
  "SACRAMENTARY": "a book containing all the prayers and ceremonies used at the celebration of the Roman Catholic sacraments [n SACRAMENTARIES]\n",
  "SACRAMENTED": "SACRAMENT, to bind by an oath or sacrament [v]\n",
  "SACRAMENTING": "SACRAMENT, to bind by an oath or sacrament [v]\n",
  "SACRAMENTS": "SACRAMENT, to bind by an oath or sacrament [v]\n",
  "SACRARIA": "SACRARIUM, (Latin) the sanctuary or sacristy (room housing sacred vessels) of a church [n]\n",
  "SACRARIAL": "of or like a sacrarium, a sanctuary [adj]\n",
  "SACRARIUM": "(Latin) the sanctuary or sacristy (room housing sacred vessels) of a church [n SACRARIA or SACRARIUMS]\n",
  "SACRARIUMS": "SACRARIUM, (Latin) the sanctuary or sacristy (room housing sacred vessels) of a church [n]\n",
  "SACRED": "dedicated to or set apart for the worship of a deity [adj SACREDER, SACREDEST, SACREDLY]\n",
  "SACREDER": "SACRED, dedicated to or set apart for the worship of a deity [adj]\n",
  "SACREDEST": "SACRED, dedicated to or set apart for the worship of a deity [adj]\n",
  "SACREDLY": "SACRED, dedicated to or set apart for the worship of a deity [adv]\n",
  "SACREDNESS": "the state of being sacred [n -ES]\n",
  "SACREDNESSES": "SACREDNESS, the state of being sacred [n]\n",
  "SACRIFICE": "the slaughter of an animal, person, etc. on an altar as an offering to a god [n -S] / to offer up in sacrifice, also SACRIFY [v SACRIFICED, SACRIFICING, SACRIFICES]\n",
  "SACRIFICEABLE": "that can be sacrificed [adj]\n",
  "SACRIFICED": "SACRIFICE, to offer up in sacrifice, also SACRIFY [v]\n",
  "SACRIFICER": "one who sacrifices [n -S]\n",
  "SACRIFICERS": "SACRIFICER, one who sacrifices [n]\n",
  "SACRIFICES": "SACRIFICE, to offer up in sacrifice, also SACRIFY [v]\n",
  "SACRIFICIAL": "of or like a sacrifice [adj SACRIFICIALLY]\n",
  "SACRIFICIALLY": "SACRIFICIAL, of or like a sacrifice [adv]\n",
  "SACRIFICING": "SACRIFICE, to offer up in sacrifice, also SACRIFY [v]\n",
  "SACRIFIDE": "SACRIFY, to sacrifice [v]\n",
  "SACRIFIED": "SACRIFY, to sacrifice [v]\n",
  "SACRIFIES": "SACRIFY, to sacrifice [v]\n",
  "SACRIFY": "to sacrifice [v SACRIFIED or (Spenser) SACRIFIDE, SACRIFYING, SACRIFIES]\n",
  "SACRIFYING": "SACRIFY, to sacrifice [v]\n",
  "SACRILEGE": "profanation or disregard of anything holy [n -S]\n",
  "SACRILEGES": "SACRILEGE, profanation or disregard of anything holy [n]\n",
  "SACRILEGIOUS": "grossly irreverent toward a hallowed person, place, or thing [adj SACRILEGIOUSLY]\n",
  "SACRILEGIOUSLY": "SACRILEGIOUS, grossly irreverent toward a hallowed person, place, or thing [adv]\n",
  "SACRILEGIST": "one who commits sacrilege [n -S]\n",
  "SACRILEGISTS": "SACRILEGIST, one who commits sacrilege [n]\n",
  "SACRING": "(archaic) the act or ritual of consecration; a sacring bell is a bell rung at moment of elevation of the Host [n -S]\n",
  "SACRINGS": "SACRING, (archaic) the act or ritual of consecration; a sacring bell is a bell rung at moment of elevation of the Host [n]\n",
  "SACRIST": "a Church official in charge of vessels and the sacristy, also SACRISTAN [n -S]\n",
  "SACRISTAN": "a Church official in charge of vessels and the sacristy, also SACRIST [n -S]\n",
  "SACRISTANS": "SACRISTAN, a Church official in charge of vessels and the sacristy, also SACRIST [n]\n",
  "SACRISTIES": "SACRISTY, a room in which sacred objects are kept [n]\n",
  "SACRISTS": "SACRIST, a Church official in charge of vessels and the sacristy, also SACRISTAN [n]\n",
  "SACRISTY": "a room in which sacred objects are kept [n SACRISTIES]\n",
  "SACROCOCCYGEAL": "relating to the sacrum and the coccyx [adj]\n",
  "SACROCOSTAL": "a muscle connecting sacrum and ribs [n -S]\n",
  "SACROCOSTALS": "SACROCOSTAL, a muscle connecting sacrum and ribs [n]\n",
  "SACROILIAC": "relating to the articulation of the sacrum and ilium [adj] / the joint that articulates the sacrum and ilium [n -S]\n",
  "SACROILIACS": "SACROILIAC, the joint that articulates the sacrum and ilium [n]\n",
  "SACROILIITIS": "inflammation of the sacroiliac joint [n -ES]\n",
  "SACROILIITISES": "SACROILIITIS, inflammation of the sacroiliac joint [n]\n",
  "SACROSANCT": "sacred; inviolable [adj]\n",
  "SACROSANCTITIES": "SACROSANCTITY, the state of being sacrosanct [n]\n",
  "SACROSANCTITY": "the state of being sacrosanct [n SACROSANCTITIES]\n",
  "SACROSANCTNESS": "the state of being sacrosanct [n]\n",
  "SACRUM": "(Latin) a bone of the pelvis [n SACRUMS or SACRA]\n",
  "SACRUMS": "SACRUM, (Latin) a bone of the pelvis [n]\n",
  "SACS": "SAC, in biology, a baglike structure [n]\n",
  "SAD": "unhappy [adj SADDER, SADDEST, SADLY] / to express sadness [v SADDED, SADDING, SADS]\n",
  "SADDED": "SAD, to express sadness [v]\n",
  "SADDEN": "to make sad [v -ED, -ING, -S]\n",
  "SADDENED": "SADDEN, to make sad [v]\n",
  "SADDENING": "SADDEN, to make sad [v]\n",
  "SADDENS": "SADDEN, to make sad [v]\n",
  "SADDER": "SAD, unhappy [adj]\n",
  "SADDEST": "SAD, unhappy [adj]\n",
  "SADDHU": "(Sanskrit) an ascetic Indian holy man, also SADHU [n -S]\n",
  "SADDHUS": "SADDHU, (Sanskrit) an ascetic Indian holy man, also SADHU [n]\n",
  "SADDIE": "a dull unsociable person, also SADDO [n -S]\n",
  "SADDIES": "SADDIE, a dull unsociable person, also SADDO [n]\n",
  "SADDING": "SAD, to express sadness [v]\n",
  "SADDISH": "somewhat sad [adj]\n",
  "SADDLE": "to put a leather seat for a rider on a horse [v SADDLED, SADDLING, SADDLES]\n",
  "SADDLEBACK": "a kind of pig [n -S]\n",
  "SADDLEBACKED": "saddle-shaped [adj]\n",
  "SADDLEBACKS": "SADDLEBACK, a kind of pig [n]\n",
  "SADDLEBAG": "a bag carried at, or attached to, the saddle [n -S]\n",
  "SADDLEBAGS": "SADDLEBAG, a bag carried at, or attached to, the saddle [n]\n",
  "SADDLEBILL": "a large black-and-white stork [n -S]\n",
  "SADDLEBILLS": "SADDLEBILL, a large black-and-white stork [n]\n",
  "SADDLEBOW": "part of a saddle [n -S]\n",
  "SADDLEBOWS": "SADDLEBOW, part of a saddle [n]\n",
  "SADDLEBRED": "a breed of saddle horses developed chiefly in Kentucky [n -S]\n",
  "SADDLEBREDS": "SADDLEBRED, a breed of saddle horses developed chiefly in Kentucky [n]\n",
  "SADDLECLOTH": "a cloth placed under or over a saddle [n -S]\n",
  "SADDLECLOTHS": "SADDLECLOTH, a cloth placed under or over a saddle [n]\n",
  "SADDLED": "SADDLE, to put a leather seat for a rider on a horse [v]\n",
  "SADDLELESS": "without a saddle [adj]\n",
  "SADDLER": "one who makes, sells or repairs saddles [n -S]\n",
  "SADDLERIES": "SADDLERY, the shop of a saddler [n]\n",
  "SADDLEROOM": "a room where saddles and harness are kept [n -S]\n",
  "SADDLEROOMS": "SADDLEROOM, a room where saddles and harness are kept [n]\n",
  "SADDLERS": "SADDLER, one who makes, sells or repairs saddles [n]\n",
  "SADDLERY": "the shop of a saddler [n SADDLERIES]\n",
  "SADDLES": "SADDLE, to put a leather seat for a rider on a horse [v]\n",
  "SADDLETREE": "the frame of a saddle [n -S]\n",
  "SADDLETREES": "SADDLETREE, the frame of a saddle [n]\n",
  "SADDLING": "SADDLE, to put a leather seat for a rider on a horse [v]\n",
  "SADDO": "(slang) an unsociable person, also SADDIE [n -ES or -S]\n",
  "SADDOES": "SADDO, (slang) an unsociable person, also SADDIE [n]\n",
  "SADDOS": "SADDO, (slang) an unsociable person, also SADDIE [n]\n",
  "SADE": "(Hebrew) a Hebrew letter, also SADHE, SADI, TSADE, TSADI, TZADDI [n -S]\n",
  "SADES": "SADE, (Hebrew) a Hebrew letter, also SADHE, SADI, TSADE, TSADI, TZADDI [n]\n",
  "SADHANA": "(Hindi) one of a number of spiritual practices or disciplines which lead to perfection [n -S]\n",
  "SADHANAS": "SADHANA, (Hindi) one of a number of spiritual practices or disciplines which lead to perfection [n]\n",
  "SADHE": "(Hebrew) a Hebrew letter, also SADE, SADI, TSADE, TSADI, TZADDI [n -S]\n",
  "SADHES": "SADHE, (Hebrew) a Hebrew letter, also SADE, SADI, TSADE, TSADI, TZADDI [n]\n",
  "SADHU": "(Sanskrit) an ascetic Indian holy man, also SADDHU [n -S]\n",
  "SADHUS": "SADHU, (Sanskrit) an ascetic Indian holy man, also SADDHU [n]\n",
  "SADI": "(Hebrew) a Hebrew letter, also SADE, SADHE, TSADE, TSADI, TZADDI [n -S]\n",
  "SADIRON": "a heavy flatiron with both ends pointed and a removable handle [n -S]\n",
  "SADIRONS": "SADIRON, a heavy flatiron with both ends pointed and a removable handle [n]\n",
  "SADIS": "SADI, (Hebrew) a Hebrew letter, also SADE, SADHE, TSADE, TSADI, TZADDI [n]\n",
  "SADISM": "pleasure gained from inflicting pain on another [n -S]\n",
  "SADISMS": "SADISM, pleasure gained from inflicting pain on another [n]\n",
  "SADIST": "one who inflicts pain for pleasure [n -S]\n",
  "SADISTIC": "like a sadist [adj SADISTICALLY]\n",
  "SADISTICALLY": "SADISTIC, like a sadist [adv]\n",
  "SADISTS": "SADIST, one who inflicts pain for pleasure [n]\n",
  "SADLY": "SAD, unhappy [adv]\n",
  "SADNESS": "the state of being sad [n -ES]\n",
  "SADNESSES": "SADNESS, the state of being sad [n]\n",
  "SADO": "(Japanese) a Japanese tea ceremony, also CHADO, CHANOYO, CHANOYU [n -S]\n",
  "SADOMASOCHISM": "the derivation of pleasure from the infliction of physical or mental pain either on others or on oneself [n -S]\n",
  "SADOMASOCHISMS": "SADOMASOCHISM, the derivation of pleasure from the infliction of physical or mental pain either on others or on oneself [n]\n",
  "SADOMASOCHIST": "one who derives sexual pleasure from inflicting pain [n -S]\n",
  "SADOMASOCHISTIC": "relating to sadomasochism [adj]\n",
  "SADOMASOCHISTS": "SADOMASOCHIST, one who derives sexual pleasure from inflicting pain [n]\n",
  "SADOS": "SADO, (Japanese) a Japanese tea ceremony, also CHADO, CHANOYO, CHANOYU [n]\n",
  "SADS": "SAD, to express sadness [v]\n",
  "SADZA": "a type of porridge made from maize flour [n -S]\n",
  "SADZAS": "SADZA, a type of porridge made from maize flour [n]\n",
  "SAE": "(Scots) so [adv]\n",
  "SAECULA": "SAECULUM, (Latin) an astronomical or geological age, also SECULUM [n]\n",
  "SAECULUM": "(Latin) an astronomical or geological age, also SECULUM [n SAECULA or SAECULUMS]\n",
  "SAECULUMS": "SAECULUM, (Latin) an astronomical or geological age, also SECULUM [n]\n",
  "SAETER": "(Norwegian) an upland pasture that provides summer pasture [n -S]\n",
  "SAETERS": "SAETER, (Norwegian) an upland pasture that provides summer pasture [n]\n",
  "SAFARI": "(Swahili) a hunting expedition, also SUFFARI [n -S] / to go on a hunting expedition [v -ED, -ING, -S]\n",
  "SAFARIED": "SAFARI, to go on a hunting expedition [v]\n",
  "SAFARIING": "SAFARI, to go on a hunting expedition [v]\n",
  "SAFARIS": "SAFARI, to go on a hunting expedition [v]\n",
  "SAFARIST": "a person who goes on safari [n -S]\n",
  "SAFARISTS": "SAFARIST, a person who goes on safari [n]\n",
  "SAFE": "secure [adj SAFER, SAFEST, SAFELY] / (obsolete) to make safe [v SAFED, SAFING, SAFES]\n",
  "SAFECRACKER": "one that breaks open safes to steal [n -S]\n",
  "SAFECRACKERS": "SAFECRACKER, one that breaks open safes to steal [n]\n",
  "SAFECRACKING": "the act of breaking open a safe [n -S]\n",
  "SAFECRACKINGS": "SAFECRACKING, the act of breaking open a safe [n]\n",
  "SAFED": "SAFE, (obsolete) to make safe [v]\n",
  "SAFEGUARD": "a device, condition, or arrangement ensuring safety, also SAUFGARD, SAVEGARD [n -S] / to keep safe [v -ED, -ING, -S]\n",
  "SAFEGUARDED": "SAFEGUARD, to keep safe [v]\n",
  "SAFEGUARDING": "SAFEGUARD, to keep safe [v]\n",
  "SAFEGUARDS": "SAFEGUARD, to keep safe [v]\n",
  "SAFEKEEPING": "the act of preserving in safety [n -S]\n",
  "SAFEKEEPINGS": "SAFEKEEPING, the act of preserving in safety [n]\n",
  "SAFELIGHT": "a light used in a photographic darkroom etc., which emits light of an intensity and colour which will not damage the materials being processed [n -S]\n",
  "SAFELIGHTS": "SAFELIGHT, a light used in a photographic darkroom etc., which emits light of an intensity and colour which will not damage the materials being processed [n]\n",
  "SAFELY": "SAFE, secure [adv]\n",
  "SAFENESS": "the quality of being safe [n -ES]\n",
  "SAFENESSES": "SAFENESS, the quality of being safe [n]\n",
  "SAFER": "SAFE, secure [adj]\n",
  "SAFES": "SAFE, (obsolete) to make safe [v]\n",
  "SAFEST": "SAFE, secure [adj]\n",
  "SAFETIED": "SAFETY, to protect against failure, breakage or accident [v]\n",
  "SAFETIES": "SAFETY, to protect against failure, breakage or accident [v]\n",
  "SAFETY": "to protect against failure, breakage or accident [v SAFETIED, SAFETYING, SAFETIES]\n",
  "SAFETYING": "SAFETY, to protect against failure, breakage or accident [v]\n",
  "SAFETYMAN": "a type of defensive player in American football [n SAFETYMEN]\n",
  "SAFETYMEN": "SAFETYMAN, a type of defensive player in American football [n]\n",
  "SAFFIAN": "(Russian) a brightly-coloured goatskin or sheepskin leather [n -S]\n",
  "SAFFIANS": "SAFFIAN, (Russian) a brightly-coloured goatskin or sheepskin leather [n]\n",
  "SAFFLOWER": "a thistle-like plant yielding an orange dye [n -S]\n",
  "SAFFLOWERS": "SAFFLOWER, a thistle-like plant yielding an orange dye [n]\n",
  "SAFFRON": "a flowering plant; its dried stigmas used as a spice and a dye [n -S]\n",
  "SAFFRONED": "seasoned or dyed with saffron [adj]\n",
  "SAFFRONIER": "SAFFRONY, having a colour somewhat like saffron [adj]\n",
  "SAFFRONIEST": "SAFFRONY, having a colour somewhat like saffron [adj]\n",
  "SAFFRONS": "SAFFRON, a flowering plant; its dried stigmas used as a spice and a dye [n]\n",
  "SAFFRONY": "having a colour somewhat like saffron [adj SAFFRONIER, SAFFRONIEST]\n",
  "SAFING": "SAFE, (obsolete) to make safe [v]\n",
  "SAFRANIN": "the yellow colouring matter in saffron; a coal tar derivative which dyes yellowish red, also SAFRANINE [n -S]\n",
  "SAFRANINE": "the yellow colouring matter in saffron; a coal tar derivative which dyes yellowish red, also SAFRANIN [n -S]\n",
  "SAFRANINES": "SAFRANINE, the yellow colouring matter in saffron; a coal tar derivative which dyes yellowish red, also SAFRANIN [n]\n",
  "SAFRANINS": "SAFRANIN, the yellow colouring matter in saffron; a coal tar derivative which dyes yellowish red, also SAFRANINE [n]\n",
  "SAFROL": "a colourless oily liquid obtained from sassafras and used in perfumes, soaps etc., also SAFROLE [n -S]\n",
  "SAFROLE": "a colourless oily liquid obtained from sassafras and used in perfumes, soaps etc., also SAFROL [n -S]\n",
  "SAFROLES": "SAFROLE, a colourless oily liquid obtained from sassafras and used in perfumes, soaps etc., also SAFROL [n]\n",
  "SAFROLS": "SAFROL, a colourless oily liquid obtained from sassafras and used in perfumes, soaps etc., also SAFROLE [n]\n",
  "SAFRONAL": "a spicy-tasting chemical constituent of saffron [n -S]\n",
  "SAFRONALS": "SAFRONAL, a spicy-tasting chemical constituent of saffron [n]\n",
  "SAFT": "(Scots) soft [adj SAFTER, SAFTEST]\n",
  "SAFTER": "SAFT, (Scots) soft [adj]\n",
  "SAFTEST": "SAFT, (Scots) soft [adj]\n",
  "SAG": "to bend or give way [v SAGGED, SAGGING, SAGS]\n",
  "SAGA": "a series of novels dealing with a family history [n -S]\n",
  "SAGACIOUS": "wise [adj SAGACIOUSLY]\n",
  "SAGACIOUSLY": "SAGACIOUS, wise [adv]\n",
  "SAGACIOUSNESS": "the state of being sagacious [n -ES]\n",
  "SAGACIOUSNESSES": "SAGACIOUSNESS, the state of being sagacious [n]\n",
  "SAGACITIES": "SAGACITY, wisdom [n]\n",
  "SAGACITY": "wisdom [n SAGACITIES]\n",
  "SAGAMAN": "(Old Norse) a writer of sagas [n SAGAMEN]\n",
  "SAGAMEN": "SAGAMAN, (Old Norse) a writer of sagas [n]\n",
  "SAGAMORE": "(Native American) a North American Indian chief [n -S]\n",
  "SAGAMORES": "SAGAMORE, (Native American) a North American Indian chief [n]\n",
  "SAGANASH": "(Native American) a white man [n -ES]\n",
  "SAGANASHES": "SAGANASH, (Native American) a white man [n]\n",
  "SAGAPENUM": "a gum resin, formerly used to stimulate menstruation and as an antispasmodic [n -S]\n",
  "SAGAPENUMS": "SAGAPENUM, a gum resin, formerly used to stimulate menstruation and as an antispasmodic [n]\n",
  "SAGAS": "SAGA, a series of novels dealing with a family history [n]\n",
  "SAGATHIES": "SAGATHY, a lightweight fabric [n]\n",
  "SAGATHY": "a lightweight fabric [n SAGATHIES]\n",
  "SAGBUT": "a medieval trombone, also SACKBUT, SACBUT [n -S]\n",
  "SAGBUTS": "SAGBUT, a medieval trombone, also SACKBUT, SACBUT [n]\n",
  "SAGE": "wise [adj SAGER, SAGEST, SAGELY] / a garden labiate plant whose grey-green leaves are used as a flavouring, also SAULGE [n -S]\n",
  "SAGEBRUSH": "a low irregular shrub covering vast tracts of the dry alkaline regions of the American plains [n -ES]\n",
  "SAGEBRUSHES": "SAGEBRUSH, a low irregular shrub covering vast tracts of the dry alkaline regions of the American plains [n]\n",
  "SAGEHOOD": "the state of being wise [n -S]\n",
  "SAGEHOODS": "SAGEHOOD, the state of being wise [n]\n",
  "SAGELY": "SAGE, wise [adv]\n",
  "SAGENE": "a network [n -S]\n",
  "SAGENES": "SAGENE, a network [n]\n",
  "SAGENESS": "wisdom [n -ES]\n",
  "SAGENESSES": "SAGENESS, wisdom [n]\n",
  "SAGENITE": "a form of the mineral rutile [n -S]\n",
  "SAGENITES": "SAGENITE, a form of the mineral rutile [n]\n",
  "SAGENITIC": "pertaining to sagenite, a form of rutile [adj]\n",
  "SAGER": "SAGE, wise [adj]\n",
  "SAGES": "SAGE, a garden labiate plant whose grey-green leaves are used as a flavouring, also SAULGE [n]\n",
  "SAGEST": "SAGE, wise [adj]\n",
  "SAGGAR": "a clay box in which pottery is packed for baking, also SAGGARD, SEGGAR [n -S] / to pack in a saggar, also SAGGER [v -ED, -ING, -S]\n",
  "SAGGARD": "a clay box for baking pottery [n -S]\n",
  "SAGGARDS": "SAGGARD, a clay box for baking pottery [n]\n",
  "SAGGARED": "SAGGAR, to pack in a saggar, also SAGGER [v]\n",
  "SAGGARING": "SAGGAR, to pack in a saggar, also SAGGER [v]\n",
  "SAGGARS": "SAGGAR, to pack in a saggar, also SAGGER [v]\n",
  "SAGGED": "SAG, to bend or give way [v]\n",
  "SAGGER": "a clay box in which pottery is packed for baking, also SAGGARD, SEGGAR [n -S] / to pack in a sagger, also SAGGAR [v -ED, -ING, -S]\n",
  "SAGGERED": "SAGGER, to pack in a sagger, also SAGGAR [v]\n",
  "SAGGERING": "SAGGER, to pack in a sagger, also SAGGAR [v]\n",
  "SAGGERS": "SAGGER, to pack in a sagger, also SAGGAR [v]\n",
  "SAGGIER": "SAGGY, characterized by sagging [adj]\n",
  "SAGGIEST": "SAGGY, characterized by sagging [adj]\n",
  "SAGGING": "the act of sagging [n -S]\n",
  "SAGGINGS": "SAGGING, the act of sagging [n]\n",
  "SAGGY": "characterized by sagging [adj SAGGIER, SAGGIEST]\n",
  "SAGIER": "SAGY, flavoured with sage [adj]\n",
  "SAGIEST": "SAGY, flavoured with sage [adj]\n",
  "SAGINATE": "to fatten animals [v SAGINATED, SAGINATING, SAGINATES]\n",
  "SAGINATED": "SAGINATE, to fatten animals [v]\n",
  "SAGINATES": "SAGINATE, to fatten animals [v]\n",
  "SAGINATING": "SAGINATE, to fatten animals [v]\n",
  "SAGINATION": "the act of fattening, or state of being fattened [n -S]\n",
  "SAGINATIONS": "SAGINATION, the act of fattening, or state of being fattened [n]\n",
  "SAGITTA": "(Latin) a keystone [n -S]\n",
  "SAGITTAL": "shaped like an arrowhead, also SAGITTATE, SAGITTIFORM [adj SAGITTALLY]\n",
  "SAGITTALLY": "SAGITTAL, shaped like an arrowhead, also SAGITTATE, SAGITTIFORM [adv]\n",
  "SAGITTARIES": "SAGITTARY, a representation of a centaur or mounted archer [n]\n",
  "SAGITTARY": "a representation of a centaur or mounted archer [n SAGITTARIES]\n",
  "SAGITTAS": "SAGITTA, (Latin) a keystone [n]\n",
  "SAGITTATE": "shaped like an arrowhead, also SAGITTAL, SAGITTIFORM [adj]\n",
  "SAGITTIFORM": "shaped like an arrowhead, also SAGITTAL, SAGITTATE [adj]\n",
  "SAGO": "(Malay) a type of palm tree; a nutritive cereal derived from its pith [n -S]\n",
  "SAGOIN": "(Tupi) a South American monkey, also SAGOUIN, SAGUIN [n -S]\n",
  "SAGOINS": "SAGOIN, (Tupi) a South American monkey, also SAGOUIN, SAGUIN [n]\n",
  "SAGOS": "SAGO, (Malay) a type of palm tree; a nutritive cereal derived from its pith [n]\n",
  "SAGOUIN": "(Tupi) a South American monkey, also SAGOIN, SAGUIN [n -S]\n",
  "SAGOUINS": "SAGOUIN, (Tupi) a South American monkey, also SAGOIN, SAGUIN [n]\n",
  "SAGRADA": "(Spanish) as in cascara sagrada, dried bark of the cascara buckthorn, used as a purgative [adj]\n",
  "SAGS": "SAG, to bend or give way [v]\n",
  "SAGUARO": "(Spanish) a giant cactus, that bears white flowers and a scaly reddish edible fruit, also SAHUARO [n -S]\n",
  "SAGUAROS": "SAGUARO, (Spanish) a giant cactus, that bears white flowers and a scaly reddish edible fruit, also SAHUARO [n]\n",
  "SAGUIN": "(Tupi) a South American monkey, also SAGOIN, SAGOUIN [n -S]\n",
  "SAGUINS": "SAGUIN, (Tupi) a South American monkey, also SAGOIN, SAGOUIN [n]\n",
  "SAGUM": "(Latin) a cloak worn by Roman soldiers [n SAGA]\n",
  "SAGY": "flavoured with sage [adj SAGIER, SAGIEST]\n",
  "SAHEB": "(Hindi) a term of respect in colonial India, also SAHIB [n -S]\n",
  "SAHEBS": "SAHEB, (Hindi) a term of respect in colonial India, also SAHIB [n]\n",
  "SAHIB": "(Hindi) a term of respect in colonial India, also SAHEB [n -S]\n",
  "SAHIBA": "(Hindi) a lady sahib, also SAHIBAH [n -S]\n",
  "SAHIBAH": "(Hindi) a lady sahib, also SAHIBA [n -S]\n",
  "SAHIBAHS": "SAHIBAH, (Hindi) a lady sahib, also SAHIBA [n]\n",
  "SAHIBAS": "SAHIBA, (Hindi) a lady sahib, also SAHIBAH [n]\n",
  "SAHIBS": "SAHIB, (Hindi) a term of respect in colonial India, also SAHEB [n]\n",
  "SAHIWAL": "(Punjabi) any of a breed of humped dairy cattle [n -S]\n",
  "SAHIWALS": "SAHIWAL, (Punjabi) any of a breed of humped dairy cattle [n]\n",
  "SAHUARO": "(Spanish) a giant cactus, that bears white flowers and a scaly reddish edible fruit, also SAGUARO [n -S]\n",
  "SAHUAROS": "SAHUARO, (Spanish) a giant cactus, that bears white flowers and a scaly reddish edible fruit, also SAGUARO [n]\n",
  "SAI": "the capuchin monkey [n -S]\n",
  "SAIBLING": "(German) a European mountain trout, aka torgoch [n -S]\n",
  "SAIBLINGS": "SAIBLING, (German) a European mountain trout, aka torgoch [n]\n",
  "SAIC": "(Turkish) a Levantine vessel like a ketch, also SAICK, SAIQUE [n -S]\n",
  "SAICE": "(Arabic) a male servant in India, also SYCE, SICE [n -S]\n",
  "SAICES": "SAICE, (Arabic) a male servant in India, also SYCE, SICE [n]\n",
  "SAICK": "(Turkish) a Levantine vessel like a ketch, also SAIC, SAIQUE [n -S]\n",
  "SAICKS": "SAICK, (Turkish) a Levantine vessel like a ketch, also SAIC, SAIQUE [n]\n",
  "SAICS": "SAIC, (Turkish) a Levantine vessel like a ketch, also SAICK, SAIQUE [n]\n",
  "SAID": "(Arabic) a descendant of Mohammed's daughter Fatima, also SAIYID, SAYED, SAYID, SAYYID [n -S]\n",
  "SAIDEST": "(archaic) 2nd person past tense singular of say, also SAIDST [v]\n",
  "SAIDS": "SAID, (Arabic) a descendant of Mohammed's daughter Fatima, also SAIYID, SAYED, SAYID, SAYYID [n]\n",
  "SAIDST": "SAY, to utter in words, speak [v]\n",
  "SAIGA": "(Russian) an antelope native to the plains of Siberia and Eastern Russia [n -S]\n",
  "SAIGAS": "SAIGA, (Russian) an antelope native to the plains of Siberia and Eastern Russia [n]\n",
  "SAIKEI": "(Japanese) a miniature landscape of bonsai trees etc. [n -S]\n",
  "SAIKEIS": "SAIKEI, (Japanese) a miniature landscape of bonsai trees etc. [n]\n",
  "SAIKLESS": "(Scots) quiet; peaceable; innocent, also SACKLESS, SACLESS [adj]\n",
  "SAIL": "to be pushed in a boat by the wind [v -ED, -ING, -S]\n",
  "SAILABLE": "able to be sailed [adj]\n",
  "SAILBOARD": "a small, flat, light-hulled sailing craft [n -S] / to use a sailboard [v -ED, -ING, -S]\n",
  "SAILBOARDED": "SAILBOARD, to use a sailboard [v]\n",
  "SAILBOARDER": "one who practises sailboarding [n -S]\n",
  "SAILBOARDERS": "SAILBOARDER, one who practises sailboarding [n]\n",
  "SAILBOARDING": "the sport of using a sailboard [n -S]\n",
  "SAILBOARDINGS": "SAILBOARDING, the sport of using a sailboard [n]\n",
  "SAILBOARDS": "SAILBOARD, a small, flat, light-hulled sailing craft [n]\n",
  "SAILBOAT": "a boat with sails [n -S]\n",
  "SAILBOATER": "one who sails a sailing-boat [n -S]\n",
  "SAILBOATERS": "SAILBOATER, one who sails a sailing-boat [n]\n",
  "SAILBOATING": "the sport of using a sailboat [n -S]\n",
  "SAILBOATINGS": "SAILBOATING, the sport of using a sailboat [n]\n",
  "SAILBOATS": "SAILBOAT, a boat with sails [n]\n",
  "SAILCLOTH": "duck or canvas used in making sails [n -S]\n",
  "SAILCLOTHS": "SAILCLOTH, duck or canvas used in making sails [n]\n",
  "SAILED": "SAIL, to be pushed in a boat by the wind [v]\n",
  "SAILER": "a vessel that sails [n -S]\n",
  "SAILERS": "SAILER, a vessel that sails [n]\n",
  "SAILFISH": "a large game fish with a sail-like dorsal fin [n -ES]\n",
  "SAILFISHES": "SAILFISH, a large game fish with a sail-like dorsal fin [n]\n",
  "SAILING": "the act of one that sails [n -S]\n",
  "SAILINGS": "SAILING, the act of one that sails [n]\n",
  "SAILLESS": "without a sail [adj]\n",
  "SAILMAKER": "one who makes sails [n -S]\n",
  "SAILMAKERS": "SAILMAKER, one who makes sails [n]\n",
  "SAILMAKING": "the making of sails [n -S]\n",
  "SAILMAKINGS": "SAILMAKING, the making of sails [n]\n",
  "SAILOR": "a member of a ship's crew [n -S]\n",
  "SAILORING": "the work of a sailor [n -S]\n",
  "SAILORINGS": "SAILORING, the work of a sailor [n]\n",
  "SAILORLESS": "without sailors [adj]\n",
  "SAILORLIER": "SAILORLY, like or appropriate to a sailor [adj]\n",
  "SAILORLIEST": "SAILORLY, like or appropriate to a sailor [adj]\n",
  "SAILORLIKE": "like a sailor [adj]\n",
  "SAILORLY": "like or appropriate to a sailor [adj SAILORLIER, SAILORLIEST]\n",
  "SAILORS": "SAILOR, a member of a ship's crew [n]\n",
  "SAILPAST": "the sailing of ships past a place [n -S]\n",
  "SAILPASTS": "SAILPAST, the sailing of ships past a place [n]\n",
  "SAILPLANE": "a glider that can rise with an upward current [n -S] / to fly using a sailplane [v SAILPLANED, SAILPLANING, SAILPLANES]\n",
  "SAILPLANED": "SAILPLANE, to fly using a sailplane [v]\n",
  "SAILPLANER": "one who flies a sailplane [n -S]\n",
  "SAILPLANERS": "SAILPLANER, one who flies a sailplane [n]\n",
  "SAILPLANES": "SAILPLANE, to fly using a sailplane [v]\n",
  "SAILPLANING": "the sport of using a sailplane [n -S]\n",
  "SAILPLANINGS": "SAILPLANING, the sport of using a sailplane [n]\n",
  "SAILROOM": "a room aboard a vessel for storing sails in [n -S]\n",
  "SAILROOMS": "SAILROOM, a room aboard a vessel for storing sails in [n]\n",
  "SAILS": "SAIL, to be pushed in a boat by the wind [v]\n",
  "SAIM": "(Scots) a seam [n -S]\n",
  "SAIMIN": "(Chinese) a Hawaiian noodle soup [n -S]\n",
  "SAIMINS": "SAIMIN, (Chinese) a Hawaiian noodle soup [n]\n",
  "SAIMIRI": "(Tupi) a squirrel monkey [n -S]\n",
  "SAIMIRIS": "SAIMIRI, (Tupi) a squirrel monkey [n]\n",
  "SAIMS": "SAIM, (Scots) a seam [n]\n",
  "SAIN": "(archaic) to make the sign of the cross over [v -ED, -ING, -S]\n",
  "SAINE": "(Spenser) 3rd pers. pl. of say, also SAYNE [v]\n",
  "SAINED": "SAIN, (archaic) to make the sign of the cross over [v]\n",
  "SAINFOIN": "(French) a leguminous plant, used as fodder, also SAINTFOIN [n -S]\n",
  "SAINFOINS": "SAINFOIN, (French) a leguminous plant, used as fodder, also SAINTFOIN [n]\n",
  "SAINING": "SAIN, (archaic) to make the sign of the cross over [v]\n",
  "SAINS": "SAIN, (archaic) to make the sign of the cross over [v]\n",
  "SAINT": "to hail as a person of exceptional holiness [v -ED, -ING, -S]\n",
  "SAINTDOM": "the condition of being a saint [n -S]\n",
  "SAINTDOMS": "SAINTDOM, the condition of being a saint [n]\n",
  "SAINTED": "SAINT, to hail as a person of exceptional holiness [v]\n",
  "SAINTESS": "a female saint [n -ES]\n",
  "SAINTESSES": "SAINTESS, a female saint [n]\n",
  "SAINTFOIN": "(French) a leguminous plant, used as fodder, also SAINFOIN [n -S]\n",
  "SAINTFOINS": "SAINTFOIN, (French) a leguminous plant, used as fodder, also SAINFOIN [n]\n",
  "SAINTHOOD": "the state of being a saint [n -S]\n",
  "SAINTHOODS": "SAINTHOOD, the state of being a saint [n]\n",
  "SAINTING": "SAINT, to hail as a person of exceptional holiness [v]\n",
  "SAINTISH": "resembling a saint [adj]\n",
  "SAINTISM": "the quality of a saint [n -S]\n",
  "SAINTISMS": "SAINTISM, the quality of a saint [n]\n",
  "SAINTLESS": "without a saint [adj]\n",
  "SAINTLIER": "SAINTLY, befitting a saint [adj]\n",
  "SAINTLIEST": "SAINTLY, befitting a saint [adj]\n",
  "SAINTLIKE": "like a saint [adj]\n",
  "SAINTLILY": "SAINTLY, befitting a saint [adv]\n",
  "SAINTLINESS": "the state of being saintly [n -ES]\n",
  "SAINTLINESSES": "SAINTLINESS, the state of being saintly [n]\n",
  "SAINTLING": "a little saint [n -S]\n",
  "SAINTLINGS": "SAINTLING, a little saint [n]\n",
  "SAINTLY": "befitting a saint [adj SAINTLIER, SAINTLIEST, SAINTLILY]\n",
  "SAINTPAULIA": "a tropical African flowering plant of the genus Saintpaulia, commonly grown as a pot plant, the African violet [n -S]\n",
  "SAINTPAULIAS": "SAINTPAULIA, a tropical African flowering plant of the genus Saintpaulia, commonly grown as a pot plant, the African violet [n]\n",
  "SAINTS": "SAINT, to hail as a person of exceptional holiness [v]\n",
  "SAINTSHIP": "the character or qualities of a saint [n -S]\n",
  "SAINTSHIPS": "SAINTSHIP, the character or qualities of a saint [n]\n",
  "SAIQUE": "(Turkish) a Levantine vessel like a ketch, also SAIC, SAICK [n -S]\n",
  "SAIQUES": "SAIQUE, (Turkish) a Levantine vessel like a ketch, also SAIC, SAICK [n]\n",
  "SAIR": "(Scots) sore, very [adj SAIRER, SAIREST] / to savour, also SAR [v -ED, -ING, -S]\n",
  "SAIRED": "SAIR, to savour, also SAR [v]\n",
  "SAIRER": "SAIR, (Scots) sore, very [adj]\n",
  "SAIREST": "SAIR, (Scots) sore, very [adj]\n",
  "SAIRING": "SAIR, to savour, also SAR [v]\n",
  "SAIRS": "SAIR, to savour, also SAR [v]\n",
  "SAIS": "SAI, the capuchin monkey [n]\n",
  "SAIST": "(Spenser) 2nd person singular of say, also SAYEST, SAYST [v]\n",
  "SAITH": "the coalfish, also SAITHE [n -S]\n",
  "SAITHE": "the coalfish, also SAITH [n -S]\n",
  "SAITHES": "SAITHE, the coalfish, also SAITH [n]\n",
  "SAITHS": "SAITH, the coalfish, also SAITHE [n]\n",
  "SAIYID": "(Arabic) a descendant of Mohammed's daughter Fatima, also SAID, SAYED, SAYID, SAYYID [n -S]\n",
  "SAIYIDS": "SAIYID, (Arabic) a descendant of Mohammed's daughter Fatima, also SAID, SAYED, SAYID, SAYYID [n]\n",
  "SAJOU": "(Tupi) a capuchin or spider monkey, also SAPAJOU [n -S]\n",
  "SAJOUS": "SAJOU, (Tupi) a capuchin or spider monkey, also SAPAJOU [n]\n",
  "SAKAI": "(Malay) a Malaysian aborigine [n -S]\n",
  "SAKAIS": "SAKAI, (Malay) a Malaysian aborigine [n]\n",
  "SAKE": "benefit or advantage [n -S]\n",
  "SAKER": "a falcon native to Southern Europe and Asia, closely resembling the lanner [n -S]\n",
  "SAKERET": "the male saker [n -S]\n",
  "SAKERETS": "SAKERET, the male saker [n]\n",
  "SAKERS": "SAKER, a falcon native to Southern Europe and Asia, closely resembling the lanner [n]\n",
  "SAKES": "SAKE, benefit or advantage [n]\n",
  "SAKI": "(Japanese) a kind of rice wine [n -S]\n",
  "SAKIA": "(Arabic) an Eastern waterwheel, also SAKIEH, SAKIYEH [n -S]\n",
  "SAKIAS": "SAKIA, (Arabic) an Eastern waterwheel, also SAKIEH, SAKIYEH [n]\n",
  "SAKIEH": "(Arabic) an Eastern waterwheel, also SAKIA, SAKIYEH [n -S]\n",
  "SAKIEHS": "SAKIEH, (Arabic) an Eastern waterwheel, also SAKIA, SAKIYEH [n]\n",
  "SAKIS": "SAKI, (Japanese) a kind of rice wine [n]\n",
  "SAKIYEH": "(Arabic) an Eastern waterwheel, also SAKIA, SAKIEH [n -S]\n",
  "SAKIYEHS": "SAKIYEH, (Arabic) an Eastern waterwheel, also SAKIA, SAKIEH [n]\n",
  "SAKKOI": "SAKKOS, (Greek) an Eastern bishop's vestment, also SACCOS [n]\n",
  "SAKKOS": "(Greek) an Eastern bishop's vestment, also SACCOS [n SAKKOI or SAKKOSES]\n",
  "SAKKOSES": "SAKKOS, (Greek) an Eastern bishop's vestment, also SACCOS [n]\n",
  "SAKSAUL": "a low, thick, grotesquely contorted tree of the saltbush family found on the steppes of Asia, also SAXAUL [n -S]\n",
  "SAKSAULS": "SAKSAUL, a low, thick, grotesquely contorted tree of the saltbush family found on the steppes of Asia, also SAXAUL [n]\n",
  "SAKTI": "(Hindu) the wife of a god in Hinduism [n -S]\n",
  "SAKTIS": "SAKTI, (Hindu) the wife of a god in Hinduism [n]\n",
  "SAL": "a large North Indian tree [n -S]\n",
  "SALAAM": "(Arabic) to make a salaam, a low bow [v -ED, -ING, -S]\n",
  "SALAAMED": "SALAAM, (Arabic) to make a salaam, a low bow [v]\n",
  "SALAAMING": "SALAAM, (Arabic) to make a salaam, a low bow [v]\n",
  "SALAAMS": "SALAAM, (Arabic) to make a salaam, a low bow [v]\n",
  "SALABILITIES": "SALABILITY, the quality of being salable [n]\n",
  "SALABILITY": "the quality of being salable [n SALABILITIES]\n",
  "SALABLE": "able to be sold, also SALEABLE, SELLABLE [adj SALABLY]\n",
  "SALABLENESS": "the quality of being salable, also SALEABILITY [n -ES]\n",
  "SALABLENESSES": "SALABLENESS, the quality of being salable, also SALEABILITY [n]\n",
  "SALABLY": "SALABLE, able to be sold, also SALEABLE, SELLABLE [adv]\n",
  "SALACIOUS": "indecently erotic, lecherous [adj SALACIOUSLY]\n",
  "SALACIOUSLY": "SALACIOUS, indecently erotic, lecherous [adv]\n",
  "SALACIOUSNESS": "the state of being salacious [n -ES]\n",
  "SALACIOUSNESSES": "SALACIOUSNESS, the state of being salacious [n]\n",
  "SALACITIES": "SALACITY, lewdness [n]\n",
  "SALACITY": "lewdness [n SALACITIES]\n",
  "SALAD": "a dish of green raw vegetables, also SALLAD [n -S]\n",
  "SALADANG": "(Malay) a kind of wild ox, also SELADANG, SLADANG [n -S]\n",
  "SALADANGS": "SALADANG, (Malay) a kind of wild ox, also SELADANG, SLADANG [n]\n",
  "SALADE": "in medieval armour, a light helmet extending over the back of the neck, also SALET, SALLET [n -S]\n",
  "SALADES": "SALADE, in medieval armour, a light helmet extending over the back of the neck, also SALET, SALLET [n]\n",
  "SALADING": "ingredients for a salad [n -S]\n",
  "SALADINGS": "SALADING, ingredients for a salad [n]\n",
  "SALADS": "SALAD, a dish of green raw vegetables, also SALLAD [n]\n",
  "SALAL": "(Native American) an American shrub of the heather family, also SALLAL [n -S]\n",
  "SALALS": "SALAL, (Native American) an American shrub of the heather family, also SALLAL [n]\n",
  "SALAMANDER": "any of various urodele amphibians, formerly believed to live in fire [n -S]\n",
  "SALAMANDERS": "SALAMANDER, any of various urodele amphibians, formerly believed to live in fire [n]\n",
  "SALAMANDRIAN": "a salamander of the order Batrachia [n -S]\n",
  "SALAMANDRIANS": "SALAMANDRIAN, a salamander of the order Batrachia [n]\n",
  "SALAMANDRINE": "like a salamander, also SALAMANDRIAN [adj]\n",
  "SALAMANDROID": "like a salamander [adj] / a member of the salamander family [n -S]\n",
  "SALAMANDROIDS": "SALAMANDROID, a member of the salamander family [n]\n",
  "SALAMI": "(Italian) a seasoned sausage [n -S]\n",
  "SALAMIS": "SALAMI, (Italian) a seasoned sausage [n]\n",
  "SALAMON": "(obsolete) the mass, as in the vagrants' inviolable oath 'by the salamon' [n -S]\n",
  "SALAMONS": "SALAMON, (obsolete) the mass, as in the vagrants' inviolable oath 'by the salamon' [n]\n",
  "SALANGANE": "(Tagalog) a swiftlet that builds edible nests [n -S]\n",
  "SALANGANES": "SALANGANE, (Tagalog) a swiftlet that builds edible nests [n]\n",
  "SALARIAT": "(French) the class of salaried persons [n -S]\n",
  "SALARIATS": "SALARIAT, (French) the class of salaried persons [n]\n",
  "SALARIED": "SALARY, to pay periodically for nonmanual labour [v]\n",
  "SALARIES": "SALARY, to pay periodically for nonmanual labour [v]\n",
  "SALARY": "to pay periodically for nonmanual labour [v SALARIED, SALARYING, SALARIES]\n",
  "SALARYING": "SALARY, to pay periodically for nonmanual labour [v]\n",
  "SALARYMAN": "in Japan, an office worker [n SALARYMEN]\n",
  "SALARYMEN": "SALARYMAN, in Japan, an office worker [n]\n",
  "SALAT": "(Arabic) a set of prayers performed by Muslims five times a day while facing towards Mecca [n -S]\n",
  "SALATS": "SALAT, (Arabic) a set of prayers performed by Muslims five times a day while facing towards Mecca [n]\n",
  "SALBAND": "(German) a crust or coating of mineral [n -S]\n",
  "SALBANDS": "SALBAND, (German) a crust or coating of mineral [n]\n",
  "SALBUTAMOL": "a bronchodilator drug [n -S]\n",
  "SALBUTAMOLS": "SALBUTAMOL, a bronchodilator drug [n]\n",
  "SALCHOW": "(Swedish) an ice-skating leap with turns from inner backward edge of one skate to outer backward edge of other [n -S]\n",
  "SALCHOWS": "SALCHOW, (Swedish) an ice-skating leap with turns from inner backward edge of one skate to outer backward edge of other [n]\n",
  "SALE": "the act of selling [n -S]\n",
  "SALEABILITIES": "SALEABILITY, the quality of being saleable, also SALABLENESS [n]\n",
  "SALEABILITY": "the quality of being saleable, also SALABLENESS [n SALEABILITIES]\n",
  "SALEABLE": "able to be sold, also SALABLE, SELLABLE [adj SALEABLY]\n",
  "SALEABLENESS": "the state of being saleable [n -ES]\n",
  "SALEABLENESSES": "SALEABLENESS, the state of being saleable [n]\n",
  "SALEABLY": "SALEABLE, able to be sold, also SALABLE, SELLABLE [adv]\n",
  "SALEP": "(Turkish) dried orchid tubers; a food or drug prepared from them, also SALOOP, SALOP [n -S]\n",
  "SALEPS": "SALEP, (Turkish) dried orchid tubers; a food or drug prepared from them, also SALOOP, SALOP [n]\n",
  "SALERATUS": "potassium or sodium bicarbonate, used in raising agents such as baking powder [n -ES]\n",
  "SALERATUSES": "SALERATUS, potassium or sodium bicarbonate, used in raising agents such as baking powder [n]\n",
  "SALERING": "a cattle-selling area [n -S]\n",
  "SALERINGS": "SALERING, a cattle-selling area [n]\n",
  "SALEROOM": "a room where goods for sale, esp. at auction, are displayed, also SALESROOM [n -S]\n",
  "SALEROOMS": "SALEROOM, a room where goods for sale, esp. at auction, are displayed, also SALESROOM [n]\n",
  "SALES": "SALE, the act of selling [n]\n",
  "SALESCLERK": "a salesperson in a store [n -S]\n",
  "SALESCLERKS": "SALESCLERK, a salesperson in a store [n]\n",
  "SALESGIRL": "a woman who sells merchandise [n -S]\n",
  "SALESGIRLS": "SALESGIRL, a woman who sells merchandise [n]\n",
  "SALESLADIES": "SALESLADY, a woman who sells merchandise [n]\n",
  "SALESLADY": "a woman who sells merchandise [n SALESLADIES]\n",
  "SALESMAN": "a man who sells merchandise [n SALESMEN]\n",
  "SALESMANSHIP": "the skill or art of selling [n -S]\n",
  "SALESMANSHIPS": "SALESMANSHIP, the skill or art of selling [n]\n",
  "SALESMEN": "SALESMAN, a man who sells merchandise [n]\n",
  "SALESPEOPLE": "persons employed to sell goods or services [n]\n",
  "SALESPERSON": "a salesman or saleswoman [n -S]\n",
  "SALESPERSONS": "SALESPERSON, a salesman or saleswoman [n]\n",
  "SALESROOM": "a room where goods for sale, esp. at auction, are displayed, also SALEROOM [n -S]\n",
  "SALESROOMS": "SALESROOM, a room where goods for sale, esp. at auction, are displayed, also SALEROOM [n]\n",
  "SALESWOMAN": "a woman who sells in a given territory, in a store, or by telephone [n SALESWOMEN]\n",
  "SALESWOMEN": "SALESWOMAN, a woman who sells in a given territory, in a store, or by telephone [n]\n",
  "SALET": "in medieval armour, a light helmet extending over the back of the neck, also SALADE, SALLET [n -S]\n",
  "SALETS": "SALET, in medieval armour, a light helmet extending over the back of the neck, also SALADE, SALLET [n]\n",
  "SALEWD": "SALUE, (obsolete) to salute [v]\n",
  "SALEYARD": "an enclosure in which livestock for auction are kept [n -S]\n",
  "SALEYARDS": "SALEYARD, an enclosure in which livestock for auction are kept [n]\n",
  "SALFERN": "a medicinal herb, aka gromwell [n -S]\n",
  "SALFERNS": "SALFERN, a medicinal herb, aka gromwell [n]\n",
  "SALIAUNCE": "(Spenser) an assault, sally [n -S]\n",
  "SALIAUNCES": "SALIAUNCE, (Spenser) an assault, sally [n]\n",
  "SALIC": "of minerals, rich in silicon and aluminum [adj]\n",
  "SALICACEOUS": "pertaining to or like a willow; belonging to the willow family of plants [adj]\n",
  "SALICES": "SALIX, (Latin) any of a genus of trees or shrubs including the willow, osier, and the like, growing usually in wet grounds [n]\n",
  "SALICET": "an organ stop with a tone like that of a willow pipe, also SALICIONAL [n -S]\n",
  "SALICETA": "SALICETUM, (Latin) a willow plantation [n]\n",
  "SALICETS": "SALICET, an organ stop with a tone like that of a willow pipe, also SALICIONAL [n]\n",
  "SALICETUM": "(Latin) a willow plantation [n SALICETUMS or SALICETA]\n",
  "SALICETUMS": "SALICETUM, (Latin) a willow plantation [n]\n",
  "SALICIN": "a bitter crystalline glucoside obtained from willow-bark, etc. and used medicinally as an analgesic, etc., also SALICINE [n -S]\n",
  "SALICINE": "a bitter crystalline glucoside obtained from willow-bark, etc. and used medicinally as an analgesic, etc., also SALICIN [n -S]\n",
  "SALICINES": "SALICINE, a bitter crystalline glucoside obtained from willow-bark, etc. and used medicinally as an analgesic, etc., also SALICIN [n]\n",
  "SALICINS": "SALICIN, a bitter crystalline glucoside obtained from willow-bark, etc. and used medicinally as an analgesic, etc., also SALICINE [n]\n",
  "SALICIONAL": "an organ stop with a tone like that of a willow pipe, also SALICET [n -S]\n",
  "SALICIONALS": "SALICIONAL, an organ stop with a tone like that of a willow pipe, also SALICET [n]\n",
  "SALICORNIA": "any plant, such as glasswort, of the Salicornia genus of goosefoots, found on salt marshes [n -S]\n",
  "SALICORNIAS": "SALICORNIA, any plant, such as glasswort, of the Salicornia genus of goosefoots, found on salt marshes [n]\n",
  "SALICYLAMIDE": "an analgesic drug administered orally [n -S]\n",
  "SALICYLAMIDES": "SALICYLAMIDE, an analgesic drug administered orally [n]\n",
  "SALICYLATE": "a salt of salicylic acid [n -S] / to treat with salicylic acid [v SALICYLATED, SALICYLATING, SALICYLATES]\n",
  "SALICYLATED": "SALICYLATE, to treat with salicylic acid [v]\n",
  "SALICYLATES": "SALICYLATE, a salt of salicylic acid [n]\n",
  "SALICYLATING": "SALICYLATE, to treat with salicylic acid [v]\n",
  "SALICYLIC": "as in salicylic acid, a bitter-tasting derivative of phenol that is used in making aspirin and dyes and as a fungicide [adj]\n",
  "SALICYLISM": "poisoning due to an overdose of salicylate-containing drugs such as aspirin [n -S]\n",
  "SALICYLISMS": "SALICYLISM, poisoning due to an overdose of salicylate-containing drugs such as aspirin [n]\n",
  "SALIENCE": "a projecting feature or detail, also SALIENCY [n -S]\n",
  "SALIENCES": "SALIENCE, a projecting feature or detail, also SALIENCY [n]\n",
  "SALIENCIES": "SALIENCY, a projecting feature or detail, also SALIENCE [n]\n",
  "SALIENCY": "a projecting feature or detail, also SALIENCE [n SALIENCIES]\n",
  "SALIENT": "strikingly conspicuous; prominent [adj SALIENTLY] / an outward-pointing angle, esp. of a fortification or line of defences [n -S]\n",
  "SALIENTIAN": "belonging to the order Salientia, amphibians including frogs and toads [adj] / an amphibian belonging to the order Salientia [n -S]\n",
  "SALIENTIANS": "SALIENTIAN, an amphibian belonging to the order Salientia [n]\n",
  "SALIENTLY": "SALIENT, strikingly conspicuous; prominent [adv]\n",
  "SALIENTS": "SALIENT, an outward-pointing angle, esp. of a fortification or line of defences [n]\n",
  "SALIFEROUS": "containing salt [adj]\n",
  "SALIFIABLE": "capable of neutralizing an acid to form a salt [adj]\n",
  "SALIFICATION": "the process of salifying [n -S]\n",
  "SALIFICATIONS": "SALIFICATION, the process of salifying [n]\n",
  "SALIFIED": "SALIFY, to combine with salt [v]\n",
  "SALIFIES": "SALIFY, to combine with salt [v]\n",
  "SALIFY": "to combine with salt [v SALIFIED, SALIFYING, SALIFIES]\n",
  "SALIFYING": "SALIFY, to combine with salt [v]\n",
  "SALIGOT": "(French) the water chestnut [n -S]\n",
  "SALIGOTS": "SALIGOT, (French) the water chestnut [n]\n",
  "SALIMETER": "an instrument for measuring the amount of salt present in any given solution, also SALINOMETER, SALOMETER [n -S]\n",
  "SALIMETERS": "SALIMETER, an instrument for measuring the amount of salt present in any given solution, also SALINOMETER, SALOMETER [n]\n",
  "SALIMETRIC": "relating to the measurement of salinity [adj]\n",
  "SALIMETRIES": "SALIMETRY, the measurement of salinity, also SALINOMETRY [n]\n",
  "SALIMETRY": "the measurement of salinity, also SALINOMETRY [n SALIMETRIES]\n",
  "SALINA": "(Spanish) a salt lagoon [n -S]\n",
  "SALINAS": "SALINA, (Spanish) a salt lagoon [n]\n",
  "SALINE": "a salt solution [n -S]\n",
  "SALINES": "SALINE, a salt solution [n]\n",
  "SALINISATION": "the process of salinising, also SALINIZATION [n -S]\n",
  "SALINISATIONS": "SALINISATION, the process of salinising, also SALINIZATION [n]\n",
  "SALINISE": "to treat with salt, also SALINIZE [v SALINISED, SALINISING, SALINISES]\n",
  "SALINISED": "SALINISE, to treat with salt, also SALINIZE [v]\n",
  "SALINISES": "SALINISE, to treat with salt, also SALINIZE [v]\n",
  "SALINISING": "SALINISE, to treat with salt, also SALINIZE [v]\n",
  "SALINITIES": "SALINITY, a concentration of salt [n]\n",
  "SALINITY": "a concentration of salt [n SALINITIES]\n",
  "SALINIZATION": "the process of salinizing, also SALINISATION [n -S]\n",
  "SALINIZATIONS": "SALINIZATION, the process of salinizing, also SALINISATION [n]\n",
  "SALINIZE": "to treat with salt, also SALINISE [v SALINIZED, SALINIZING, SALINIZES]\n",
  "SALINIZED": "SALINIZE, to treat with salt, also SALINISE [v]\n",
  "SALINIZES": "SALINIZE, to treat with salt, also SALINISE [v]\n",
  "SALINIZING": "SALINIZE, to treat with salt, also SALINISE [v]\n",
  "SALINOMETER": "an instrument for measuring the amount of salt present in any given solution, also SALIMETER, SALOMETER [n -S]\n",
  "SALINOMETERS": "SALINOMETER, an instrument for measuring the amount of salt present in any given solution, also SALIMETER, SALOMETER [n]\n",
  "SALINOMETRIC": "relating to the measurement of salinity [adj]\n",
  "SALINOMETRIES": "SALINOMETRY, the measurement of salinity, also SALIMETRY [n]\n",
  "SALINOMETRY": "the measurement of salinity, also SALIMETRY [n SALINOMETRIES]\n",
  "SALIVA": "a fluid secreted by the glands of the mouth [n -S]\n",
  "SALIVAL": "relating to saliva, also SALIVARY [adj]\n",
  "SALIVARY": "relating to saliva, also SALIVAL [adj]\n",
  "SALIVAS": "SALIVA, a fluid secreted by the glands of the mouth [n]\n",
  "SALIVATE": "to secrete saliva [v SALIVATED, SALIVATING, SALIVATES]\n",
  "SALIVATED": "SALIVATE, to secrete saliva [v]\n",
  "SALIVATES": "SALIVATE, to secrete saliva [v]\n",
  "SALIVATING": "SALIVATE, to secrete saliva [v]\n",
  "SALIVATION": "the act of salivating [n -S]\n",
  "SALIVATIONS": "SALIVATION, the act of salivating [n]\n",
  "SALIVATOR": "one who salivates [n -S]\n",
  "SALIVATORS": "SALIVATOR, one who salivates [n]\n",
  "SALIX": "(Latin) any of a genus of trees or shrubs including the willow, osier, and the like, growing usually in wet grounds [n SALICES]\n",
  "SALL": "(US) shall [v]\n",
  "SALLAD": "(archaic) a salad [n -S]\n",
  "SALLADS": "SALLAD, (archaic) a salad [n]\n",
  "SALLAL": "(Native American) an American shrub of the heather family, also SALAL [n -S]\n",
  "SALLALS": "SALLAL, (Native American) an American shrub of the heather family, also SALAL [n]\n",
  "SALLE": "(French) a hall [n -S]\n",
  "SALLEE": "a species of acacia [n -S]\n",
  "SALLEES": "SALLEE, a species of acacia [n]\n",
  "SALLENDERS": "a skin disease affecting the hocks of horses [n]\n",
  "SALLES": "SALLE, (French) a hall [n]\n",
  "SALLET": "in medieval armour, a light helmet extending over the back of the neck, also SALADE, SALET [n -S]\n",
  "SALLETS": "SALLET, in medieval armour, a light helmet extending over the back of the neck, also SALADE, SALET [n]\n",
  "SALLIED": "SALLY, to rush out suddenly [v]\n",
  "SALLIER": "one who sallies [n -S]\n",
  "SALLIERS": "SALLIER, one who sallies [n]\n",
  "SALLIES": "SALLY, to rush out suddenly [v]\n",
  "SALLOW": "esp. of a person's skin, of a pale-yellowish colour [adj SALLOWER, SALLOWEST, SALLOWLY] / to make sallow [v -ED, -ING, -S]\n",
  "SALLOWED": "SALLOW, to make sallow [v]\n",
  "SALLOWER": "SALLOW, esp. of a person's skin, of a pale-yellowish colour [adj]\n",
  "SALLOWEST": "SALLOW, esp. of a person's skin, of a pale-yellowish colour [adj]\n",
  "SALLOWIER": "SALLOWY, abounding in sallows, willow trees [adj]\n",
  "SALLOWIEST": "SALLOWY, abounding in sallows, willow trees [adj]\n",
  "SALLOWING": "SALLOW, to make sallow [v]\n",
  "SALLOWISH": "somewhat sallow, also SALLOWY [adj]\n",
  "SALLOWLY": "SALLOW, esp. of a person's skin, of a pale-yellowish colour [adv]\n",
  "SALLOWNESS": "the state of being sallow [n -ES]\n",
  "SALLOWNESSES": "SALLOWNESS, the state of being sallow [n]\n",
  "SALLOWS": "SALLOW, to make sallow [v]\n",
  "SALLOWY": "abounding in sallows, willow trees [adj SALLOWIER, SALLOWIEST]\n",
  "SALLY": "to rush out suddenly [v SALLIED, SALLYING, SALLIES]\n",
  "SALLYING": "SALLY, to rush out suddenly [v]\n",
  "SALLYPORT": "a gateway or opening for making a sally from a fortified place [n -S]\n",
  "SALLYPORTS": "SALLYPORT, a gateway or opening for making a sally from a fortified place [n]\n",
  "SALMAGUNDI": "(French) a dish of chopped meat, eggs, anchovies, onions etc., also SALMAGUNDY [n -S]\n",
  "SALMAGUNDIES": "SALMAGUNDY, (French) a dish of chopped meat, eggs, anchovies, onions etc., also SALMAGUNDI [n]\n",
  "SALMAGUNDIS": "SALMAGUNDI, (French) a dish of chopped meat, eggs, anchovies, onions etc., also SALMAGUNDY [n]\n",
  "SALMAGUNDY": "(French) a dish of chopped meat, eggs, anchovies, onions etc., also SALMAGUNDI [n SALMAGUNDIES]\n",
  "SALMANASER": "a large wine bottle containing 2.10 gallons, also SALMANAZAR [n -S]\n",
  "SALMANASERS": "SALMANASER, a large wine bottle containing 2.10 gallons, also SALMANAZAR [n]\n",
  "SALMANAZAR": "a large wine bottle containing 2.10 gallons, also SALMANASER [n -S]\n",
  "SALMANAZARS": "SALMANAZAR, a large wine bottle containing 2.10 gallons, also SALMANASER [n]\n",
  "SALMI": "(French) a ragout of roast game, also SALMIS [n -S]\n",
  "SALMIS": "(French) a ragout of roast game, also SALMI [n]\n",
  "SALMON": "any soft-finned fish of the family Salmonidae [n -S]\n",
  "SALMONBERRIES": "SALMONBERRY, a salmon-coloured North American raspberry [n]\n",
  "SALMONBERRY": "a salmon-coloured North American raspberry [n SALMONBERRIES]\n",
  "SALMONELLA": "a genus of rodlike bacteria, associated with poisoning by contaminated food [n SALMONELLAE or SALMONELLAS]\n",
  "SALMONELLAE": "SALMONELLA, a genus of rodlike bacteria, associated with poisoning by contaminated food [n]\n",
  "SALMONELLAS": "SALMONELLA, a genus of rodlike bacteria, associated with poisoning by contaminated food [n]\n",
  "SALMONELLOSES": "SALMONELLOSIS, infection with or disease caused by salmonellae [n]\n",
  "SALMONELLOSIS": "infection with or disease caused by salmonellae [n SALMONELLOSES]\n",
  "SALMONET": "a young salmon, also SAMLET [n -S]\n",
  "SALMONETS": "SALMONET, a young salmon, also SAMLET [n]\n",
  "SALMONID": "a member of the salmon family, also SALMONOID [n -S]\n",
  "SALMONIDS": "SALMONID, a member of the salmon family, also SALMONOID [n]\n",
  "SALMONIER": "SALMONY, of or like a salmon [adj]\n",
  "SALMONIEST": "SALMONY, of or like a salmon [adj]\n",
  "SALMONOID": "a member of the salmon family, also SALMONID [n -S]\n",
  "SALMONOIDS": "SALMONOID, a member of the salmon family, also SALMONID [n]\n",
  "SALMONS": "SALMON, any soft-finned fish of the family Salmonidae [n]\n",
  "SALMONY": "of or like a salmon [adj SALMONIER, SALMONIEST]\n",
  "SALOL": "a white crystalline substance consisting of phenol salicylate [n -S]\n",
  "SALOLS": "SALOL, a white crystalline substance consisting of phenol salicylate [n]\n",
  "SALOMETER": "an instrument for measuring the amount of salt present in any given solution, also SALIMETER, SALINOMETER [n -S]\n",
  "SALOMETERS": "SALOMETER, an instrument for measuring the amount of salt present in any given solution, also SALIMETER, SALINOMETER [n]\n",
  "SALON": "a large room in which guests are received [n -S]\n",
  "SALONS": "SALON, a large room in which guests are received [n]\n",
  "SALOON": "a large room or hall used for meetings, exhibitions, etc., esp. in a hotel or public building [n -S]\n",
  "SALOONS": "SALOON, a large room or hall used for meetings, exhibitions, etc., esp. in a hotel or public building [n]\n",
  "SALOOP": "(Turkish) a hot drink made from an infusion of salep, later from sassafras, formerly used as a tonic, also SALEP, SALOP [n -S]\n",
  "SALOOPS": "SALOOP, (Turkish) a hot drink made from an infusion of salep, later from sassafras, formerly used as a tonic, also SALEP, SALOP [n]\n",
  "SALOP": "(Turkish) a hot drink made from an infusion of salep, later from sassafras, formerly used as a tonic, also SALEP, SALOOP [n -S]\n",
  "SALOPETTES": "quilted skiing trousers with shoulder straps [n]\n",
  "SALOPIAN": "relating to a salop, an aromatic drink prepared from sassafras bark and other ingredients [adj]\n",
  "SALOPS": "SALOP, (Turkish) a hot drink made from an infusion of salep, later from sassafras, formerly used as a tonic, also SALEP, SALOOP [n]\n",
  "SALP": "a free-swimming small marine animal, also SALPA, SALPIAN, SALPID [n -S]\n",
  "SALPA": "a free-swimming small marine animal, also SALP, SALPIAN, SALPID [n SALPAS or SALPAE]\n",
  "SALPAE": "SALPA, a free-swimming small marine animal, also SALP, SALPIAN, SALPID [n]\n",
  "SALPAS": "SALPA, a free-swimming small marine animal, also SALP, SALPIAN, SALPID [n]\n",
  "SALPIAN": "a free-swimming small marine animal, also SALPA, SALP, SALPID [n -S]\n",
  "SALPIANS": "SALPIAN, a free-swimming small marine animal, also SALPA, SALP, SALPID [n]\n",
  "SALPICON": "(French) a dish comprising game, fish, poultry, truffles etc. in sauce [n -S]\n",
  "SALPICONS": "SALPICON, (French) a dish comprising game, fish, poultry, truffles etc. in sauce [n]\n",
  "SALPID": "a free-swimming small marine animal, also SALPA, SALP, SALPIAN [n -S]\n",
  "SALPIDS": "SALPID, a free-swimming small marine animal, also SALPA, SALP, SALPIAN [n]\n",
  "SALPIFORM": "shaped like a barrel [adj]\n",
  "SALPIGLOSSES": "SALPIGLOSSIS, any plant of the genus Salpiglossis, some of which bear bright trumpet-shaped flowers [n]\n",
  "SALPIGLOSSIS": "any plant of the genus Salpiglossis, some of which bear bright trumpet-shaped flowers [n SALPIGLOSSES or SALPIGLOSSISES]\n",
  "SALPIGLOSSISES": "SALPIGLOSSIS, any plant of the genus Salpiglossis, some of which bear bright trumpet-shaped flowers [n]\n",
  "SALPINGECTOMIES": "SALPINGECTOMY, surgical removal of the salpinx [n]\n",
  "SALPINGECTOMY": "surgical removal of the salpinx [n SALPINGECTOMIES]\n",
  "SALPINGES": "SALPINX, (Greek) an anatomical tube [n]\n",
  "SALPINGIAN": "of or like the salpinx, the Eustachian tube [adj]\n",
  "SALPINGITIC": "of, or of the nature of, salpingitis [adj]\n",
  "SALPINGITIS": "inflammation of the salpinx [n -ES]\n",
  "SALPINGITISES": "SALPINGITIS, inflammation of the salpinx [n]\n",
  "SALPINX": "(Greek) an anatomical tube [n SALPINXES or SALPINGES]\n",
  "SALPINXES": "SALPINX, (Greek) an anatomical tube [n]\n",
  "SALPS": "SALP, a free-swimming small marine animal, also SALPA, SALPIAN, SALPID [n]\n",
  "SALS": "SAL, a large North Indian tree [n]\n",
  "SALSA": "(Spanish) a rhythmic Latin-American big-band dance music; a dance performed to this [n -S] / to do such a dance [v -ED, -ING, -S]\n",
  "SALSAED": "SALSA, to do such a dance [v]\n",
  "SALSAING": "SALSA, to do such a dance [v]\n",
  "SALSAS": "SALSA, to do such a dance [v]\n",
  "SALSE": "(French) a mud volcano [n -S]\n",
  "SALSES": "SALSE, (French) a mud volcano [n]\n",
  "SALSIFIES": "SALSIFY, the oyster plant, a purple-flowered European composite plant cultivated for its edible root tasting like oysters [n]\n",
  "SALSIFY": "the oyster plant, a purple-flowered European composite plant cultivated for its edible root tasting like oysters [n SALSIFIES]\n",
  "SALSILLA": "a tropical plant [n -S]\n",
  "SALSILLAS": "SALSILLA, a tropical plant [n]\n",
  "SALSOLACEOUS": "belonging to the saltwort genus Salsola of the goosefoot family [adj]\n",
  "SALSUGINOUS": "salty; brackish; growing in salty soil [adj]\n",
  "SALT": "sodium chloride, also SAUT [n -S] / tasting of salt [adj SALTER, SALTEST, SALTLY] / to put salt on [v -ED, -ING, -S]\n",
  "SALTANDO": "(Italian) a short, bouncing bow stroke resulting in a staccato sound, also SALTATO [n -S]\n",
  "SALTANDOS": "SALTANDO, (Italian) a short, bouncing bow stroke resulting in a staccato sound, also SALTATO [n]\n",
  "SALTANT": "a mutated form of an organism suddenly developed [n -S]\n",
  "SALTANTS": "SALTANT, a mutated form of an organism suddenly developed [n]\n",
  "SALTARELLI": "SALTARELLO, (Italian) a lively Italian dance [n]\n",
  "SALTARELLO": "(Italian) a lively Italian dance [n SALTARELLOS or SALTARELLI]\n",
  "SALTARELLOS": "SALTARELLO, (Italian) a lively Italian dance [n]\n",
  "SALTATE": "to undergo an abrupt mutation [v SALTATED, SALTATING, SALTATES]\n",
  "SALTATED": "SALTATE, to undergo an abrupt mutation [v]\n",
  "SALTATES": "SALTATE, to undergo an abrupt mutation [v]\n",
  "SALTATING": "SALTATE, to undergo an abrupt mutation [v]\n",
  "SALTATION": "an act of leaping or dancing; a sudden metamorphosis [n -S]\n",
  "SALTATIONISM": "punctuation in evolution [n -S]\n",
  "SALTATIONISMS": "SALTATIONISM, punctuation in evolution [n]\n",
  "SALTATIONIST": "someone who supports saltationism as a theory [n -S]\n",
  "SALTATIONISTS": "SALTATIONIST, someone who supports saltationism as a theory [n]\n",
  "SALTATIONS": "SALTATION, an act of leaping or dancing; a sudden metamorphosis [n]\n",
  "SALTATO": "(Italian) a short, bouncing bow stroke resulting in a staccato sound, also SALTANDO [n -S]\n",
  "SALTATORIAL": "pertaining to leaping or dancing; taking place by leaps and bounds [adj]\n",
  "SALTATORIOUS": "of or for saltation, also SALTATORY [adj]\n",
  "SALTATORY": "of or for saltation, also SALTATORIOUS [adj]\n",
  "SALTATOS": "SALTATO, (Italian) a short, bouncing bow stroke resulting in a staccato sound, also SALTANDO [n]\n",
  "SALTBOX": "a box for holding salt [n -ES]\n",
  "SALTBOXES": "SALTBOX, a box for holding salt [n]\n",
  "SALTBUSH": "an Australian plant of the goosefoot family [n -ES]\n",
  "SALTBUSHES": "SALTBUSH, an Australian plant of the goosefoot family [n]\n",
  "SALTCAT": "a mixture of salt, coarse meal, lime, etc. attractive to pigeons [n -S]\n",
  "SALTCATS": "SALTCAT, a mixture of salt, coarse meal, lime, etc. attractive to pigeons [n]\n",
  "SALTCELLAR": "a small vessel of glass or other material, used for holding salt on the table [n -S]\n",
  "SALTCELLARS": "SALTCELLAR, a small vessel of glass or other material, used for holding salt on the table [n]\n",
  "SALTCHUCK": "(Canadian) a body of salt water [n -S]\n",
  "SALTCHUCKER": "(Canadian) a saltwater angler [n -S]\n",
  "SALTCHUCKERS": "SALTCHUCKER, (Canadian) a saltwater angler [n]\n",
  "SALTCHUCKS": "SALTCHUCK, (Canadian) a body of salt water [n]\n",
  "SALTED": "SALT, to put salt on [v]\n",
  "SALTER": "a person who makes or deals in salt or salted foods [n -S]\n",
  "SALTERIES": "SALTERY, a factory where fish is salted for storage [n]\n",
  "SALTERN": "a saltwork [n -S]\n",
  "SALTERNS": "SALTERN, a saltwork [n]\n",
  "SALTERS": "SALTER, a person who makes or deals in salt or salted foods [n]\n",
  "SALTERY": "a factory where fish is salted for storage [n SALTERIES]\n",
  "SALTEST": "SALT, tasting of salt [adj]\n",
  "SALTFISH": "salted cod [n -ES]\n",
  "SALTFISHES": "SALTFISH, salted cod [n]\n",
  "SALTIE": "a deep-sea vessel sailing the Great Lakes [n -S]\n",
  "SALTIER": "an X-shaped cross, a St Andrew's Cross, also SALTIRE [n -S]\n",
  "SALTIERS": "SALTIER, an X-shaped cross, a St Andrew's Cross, also SALTIRE [n]\n",
  "SALTIES": "SALTIE, a deep-sea vessel sailing the Great Lakes [n]\n",
  "SALTIEST": "SALTY, tasting of salt [adj]\n",
  "SALTIGRADE": "a kind of jumping spider [n -S]\n",
  "SALTIGRADES": "SALTIGRADE, a kind of jumping spider [n]\n",
  "SALTILY": "SALTY, tasting of salt [adv]\n",
  "SALTIMBANCO": "(Italian) a mountebank, a quack [n -S]\n",
  "SALTIMBANCOS": "SALTIMBANCO, (Italian) a mountebank, a quack [n]\n",
  "SALTIMBOCCA": "(Italian) an Italian dish of rolled slices of meat and ham, with cheese and herbs [n -S]\n",
  "SALTIMBOCCAS": "SALTIMBOCCA, (Italian) an Italian dish of rolled slices of meat and ham, with cheese and herbs [n]\n",
  "SALTINE": "a salted cracker [n -S]\n",
  "SALTINES": "SALTINE, a salted cracker [n]\n",
  "SALTINESS": "the state of being salty [n -ES]\n",
  "SALTINESSES": "SALTINESS, the state of being salty [n]\n",
  "SALTING": "land regularly flooded by tides [n -S]\n",
  "SALTINGS": "SALTING, land regularly flooded by tides [n]\n",
  "SALTIRE": "an X-shaped cross, a St Andrew's cross, also SALTIER [n -S]\n",
  "SALTIRES": "SALTIRE, an X-shaped cross, a St Andrew's cross, also SALTIER [n]\n",
  "SALTIREWISE": "in the fashion of a saltire [adv]\n",
  "SALTISH": "somewhat salty [adj SALTISHLY]\n",
  "SALTISHLY": "SALTISH, somewhat salty [adv]\n",
  "SALTISHNESS": "the quality of being saltish [n -ES]\n",
  "SALTISHNESSES": "SALTISHNESS, the quality of being saltish [n]\n",
  "SALTLESS": "without salt [adj]\n",
  "SALTLIKE": "resembling salt [adj]\n",
  "SALTLY": "SALT, tasting of salt [adv]\n",
  "SALTNESS": "the state of being salty [n -ES]\n",
  "SALTNESSES": "SALTNESS, the state of being salty [n]\n",
  "SALTO": "(Italian) to perform a daring leap [v -ED, -ING, -S]\n",
  "SALTOED": "SALTO, (Italian) to perform a daring leap [v]\n",
  "SALTOING": "SALTO, (Italian) to perform a daring leap [v]\n",
  "SALTOS": "SALTO, (Italian) to perform a daring leap [v]\n",
  "SALTPAN": "a large pan for making salt by evaporation [n -S]\n",
  "SALTPANS": "SALTPAN, a large pan for making salt by evaporation [n]\n",
  "SALTPETER": "(US) potassium nitrate, the chief constituent of gunpowder, also SALTPETRE [n -S]\n",
  "SALTPETERS": "SALTPETER, (US) potassium nitrate, the chief constituent of gunpowder, also SALTPETRE [n]\n",
  "SALTPETRE": "potassium nitrate, the chief constituent of gunpowder, also SALTPETER [n -S]\n",
  "SALTPETREMAN": "(historical) someone authorized to search for saltpetre; someone who prepares saltpetre [n SALTPETREMEN]\n",
  "SALTPETREMEN": "SALTPETREMAN, (historical) someone authorized to search for saltpetre; someone who prepares saltpetre [n]\n",
  "SALTPETRES": "SALTPETRE, potassium nitrate, the chief constituent of gunpowder, also SALTPETER [n]\n",
  "SALTS": "SALT, to put salt on [v]\n",
  "SALTSHAKER": "a saltcellar [n -S]\n",
  "SALTSHAKERS": "SALTSHAKER, a saltcellar [n]\n",
  "SALTUS": "(Latin) a breach of continuity; a jump to a conclusion [n -ES]\n",
  "SALTUSES": "SALTUS, (Latin) a breach of continuity; a jump to a conclusion [n]\n",
  "SALTWATER": "water that contains salt [n -S]\n",
  "SALTWATERS": "SALTWATER, water that contains salt [n]\n",
  "SALTWORK": "a place where salt is produced, also SALTERN [n -S]\n",
  "SALTWORKS": "SALTWORK, a place where salt is produced, also SALTERN [n]\n",
  "SALTWORT": "a seaside herb [n -S]\n",
  "SALTWORTS": "SALTWORT, a seaside herb [n]\n",
  "SALTY": "tasting of salt [adj SALTIER, SALTIEST, SALTILY]\n",
  "SALUBRIOUS": "beneficial, healthful [adj SALUBRIOUSLY]\n",
  "SALUBRIOUSLY": "SALUBRIOUS, beneficial, healthful [adv]\n",
  "SALUBRIOUSNESS": "SALUBRIOUS, beneficial, healthful [n]\n",
  "SALUBRITIES": "SALUBRITY, the quality of being salubrious [n]\n",
  "SALUBRITY": "the quality of being salubrious [n SALUBRITIES]\n",
  "SALUE": "(obsolete) to salute [v SALUED or (Spenser) SALEWD, SALUING, SALUES]\n",
  "SALUED": "SALUE, (obsolete) to salute [v]\n",
  "SALUES": "SALUE, (obsolete) to salute [v]\n",
  "SALUING": "SALUE, (obsolete) to salute [v]\n",
  "SALUKI": "(Arabic) a greyhound-like Arab dog, aka gazelle hound [n -S]\n",
  "SALUKIS": "SALUKI, (Arabic) a greyhound-like Arab dog, aka gazelle hound [n]\n",
  "SALURETIC": "a drug that increases the secretion of salt in urine [n -S]\n",
  "SALURETICS": "SALURETIC, a drug that increases the secretion of salt in urine [n]\n",
  "SALUT": "an interjection expressing friendship before a drink [interj]\n",
  "SALUTARILY": "SALUTARY, producing a beneficial effect [adv]\n",
  "SALUTARINESS": "the state of being salutary [n -ES]\n",
  "SALUTARINESSES": "SALUTARINESS, the state of being salutary [n]\n",
  "SALUTARY": "producing a beneficial effect [adj SALUTARILY]\n",
  "SALUTATION": "an expression of greeting [n -S]\n",
  "SALUTATIONAL": "relating to salutation [adj]\n",
  "SALUTATIONS": "SALUTATION, an expression of greeting [n]\n",
  "SALUTATORIAN": "the second best student in a graduating class, whose job it is to give an introductory speech [n -S]\n",
  "SALUTATORIANS": "SALUTATORIAN, the second best student in a graduating class, whose job it is to give an introductory speech [n]\n",
  "SALUTATORIES": "SALUTATORY, an address of welcome, esp. in American colleges [n]\n",
  "SALUTATORILY": "SALUTATORY, relating to salutation [adv]\n",
  "SALUTATORY": "relating to salutation [adj SALUTATORILY] / an address of welcome, esp. in American colleges [n SALUTATORIES]\n",
  "SALUTE": "to greet with a sign of respect [v SALUTED, SALUTING, SALUTES]\n",
  "SALUTED": "SALUTE, to greet with a sign of respect [v]\n",
  "SALUTER": "one who salutes [n -S]\n",
  "SALUTERS": "SALUTER, one who salutes [n]\n",
  "SALUTES": "SALUTE, to greet with a sign of respect [v]\n",
  "SALUTIFEROUS": "conducive to health or wellbeing [adj]\n",
  "SALUTING": "SALUTE, to greet with a sign of respect [v]\n",
  "SALVABILITIES": "SALVABILITY, the state of being salvable [n]\n",
  "SALVABILITY": "the state of being salvable [n SALVABILITIES]\n",
  "SALVABLE": "capable of being saved [adj SALVABLY]\n",
  "SALVABLENESS": "the state of being salvable [n -ES]\n",
  "SALVABLENESSES": "SALVABLENESS, the state of being salvable [n]\n",
  "SALVABLY": "SALVABLE, capable of being saved [adv]\n",
  "SALVAGE": "to save from loss or destruction [v SALVAGED, SALVAGING, SALVAGES]\n",
  "SALVAGEABILITY": "the state of being salvageable [n]\n",
  "SALVAGEABLE": "that can be salvaged [adj]\n",
  "SALVAGED": "SALVAGE, to save from loss or destruction [v]\n",
  "SALVAGEE": "one in whose favor salvage has been effected [n -S]\n",
  "SALVAGEES": "SALVAGEE, one in whose favor salvage has been effected [n]\n",
  "SALVAGER": "one who salvages [n -S]\n",
  "SALVAGERS": "SALVAGER, one who salvages [n]\n",
  "SALVAGES": "SALVAGE, to save from loss or destruction [v]\n",
  "SALVAGING": "SALVAGE, to save from loss or destruction [v]\n",
  "SALVARSAN": "(tradename) a compound of arsenic once used as a remedy for syphilis [n -S]\n",
  "SALVARSANS": "SALVARSAN, (tradename) a compound of arsenic once used as a remedy for syphilis [n]\n",
  "SALVATION": "an act of saving; a means of preservation [n -S]\n",
  "SALVATIONAL": "relating to salvation [adj]\n",
  "SALVATIONISM": "religious teaching emphasizing the saving of the soul [n -S]\n",
  "SALVATIONISMS": "SALVATIONISM, religious teaching emphasizing the saving of the soul [n]\n",
  "SALVATIONIST": "a soldier or officer of the salvation Army [n -S]\n",
  "SALVATIONISTS": "SALVATIONIST, a soldier or officer of the salvation Army [n]\n",
  "SALVATIONS": "SALVATION, an act of saving; a means of preservation [n]\n",
  "SALVATORIES": "SALVATORY, a repository for safe storage [n]\n",
  "SALVATORY": "a repository for safe storage [n SALVATORIES]\n",
  "SALVE": "to soothe [v SALVED, SALVING, SALVES]\n",
  "SALVED": "SALVE, to soothe [v]\n",
  "SALVER": "a tray or serving platter [n -S]\n",
  "SALVERFORM": "of a corolla, having a long tube with terminal petals spread out flat [adj]\n",
  "SALVERS": "SALVER, a tray or serving platter [n]\n",
  "SALVES": "SALVE, to soothe [v]\n",
  "SALVETE": "(Latin) a greeting, used to more than one person [n -S]\n",
  "SALVETES": "SALVETE, (Latin) a greeting, used to more than one person [n]\n",
  "SALVIA": "a genus of plants including sage [n -S]\n",
  "SALVIAS": "SALVIA, a genus of plants including sage [n]\n",
  "SALVIFIC": "(obsolete) having the purpose or intention of saving, also SALVIFICAL [adj SALVIFICALLY]\n",
  "SALVIFICAL": "(obsolete) having the purpose or intention of saving, also SALVIFIC [adj SALVIFICALLY]\n",
  "SALVIFICALLY": "SALVIFICAL, (obsolete) having the purpose or intention of saving, also SALVIFIC [adv]\n",
  "SALVING": "the act of salving [n -S]\n",
  "SALVINGS": "SALVING, the act of salving [n]\n",
  "SALVINIACEOUS": "of or like the Salvinia family, water ferns [adj]\n",
  "SALVO": "to discharge firearms simultaneously [v SALVOED, SALVOING, SALVOES or SALVOS]\n",
  "SALVOED": "SALVO, to discharge firearms simultaneously [v]\n",
  "SALVOES": "SALVO, to discharge firearms simultaneously [v]\n",
  "SALVOING": "SALVO, to discharge firearms simultaneously [v]\n",
  "SALVOR": "one who assists in saving a ship or goods at sea, without being under special obligation to do so [n -S]\n",
  "SALVORS": "SALVOR, one who assists in saving a ship or goods at sea, without being under special obligation to do so [n]\n",
  "SALVOS": "SALVO, to discharge firearms simultaneously [v]\n",
  "SALWAR": "(Urdu) a long tunic worn over a pair of baggy trousers, worn by women in Pakistan [n -S]\n",
  "SALWARS": "SALWAR, (Urdu) a long tunic worn over a pair of baggy trousers, worn by women in Pakistan [n]\n",
  "SAM": "(Spenser) to gather [v SAMMED, SAMMING, SAMS]\n",
  "SAMA": "(Japanese) a title given to an exalted person [n -S]\n",
  "SAMAAN": "(Caribbean) the rain-tree, a member of the mimosa family, also SAMAN, ZAMAN, ZAMANG [n -S]\n",
  "SAMAANS": "SAMAAN, (Caribbean) the rain-tree, a member of the mimosa family, also SAMAN, ZAMAN, ZAMANG [n]\n",
  "SAMADHI": "(Sanskrit) a state of oneness with the infinite [n -S]\n",
  "SAMADHIS": "SAMADHI, (Sanskrit) a state of oneness with the infinite [n]\n",
  "SAMAN": "(Caribbean) the rain-tree, a member of the mimosa family, also SAMAAN, ZAMAN, ZAMANG [n -S]\n",
  "SAMANS": "SAMAN, (Caribbean) the rain-tree, a member of the mimosa family, also SAMAAN, ZAMAN, ZAMANG [n]\n",
  "SAMARA": "(Latin) a propeller-like winged fruit, as of ash, elm or maple [n -S]\n",
  "SAMARAS": "SAMARA, (Latin) a propeller-like winged fruit, as of ash, elm or maple [n]\n",
  "SAMARIFORM": "like a samara in shape [adj]\n",
  "SAMARITAN": "one who helps others in distress [n -S]\n",
  "SAMARITANS": "SAMARITAN, one who helps others in distress [n]\n",
  "SAMARIUM": "a metallic element [n -S]\n",
  "SAMARIUMS": "SAMARIUM, a metallic element [n]\n",
  "SAMARSKITE": "a black mineral containing uranium [n -S]\n",
  "SAMARSKITES": "SAMARSKITE, a black mineral containing uranium [n]\n",
  "SAMAS": "SAMA, (Japanese) a title given to an exalted person [n]\n",
  "SAMBA": "(Portuguese) to perform a Brazilian dance [v -ED, -ING, -S]\n",
  "SAMBAED": "SAMBA, (Portuguese) to perform a Brazilian dance [v]\n",
  "SAMBAING": "SAMBA, (Portuguese) to perform a Brazilian dance [v]\n",
  "SAMBAL": "(Malay) a food served with curry [n -S]\n",
  "SAMBALS": "SAMBAL, (Malay) a food served with curry [n]\n",
  "SAMBAR": "(Hindi) a large Asian deer, also SAMBHAR, SAMBHUR, SAMBUR [n -S]\n",
  "SAMBARS": "SAMBAR, (Hindi) a large Asian deer, also SAMBHAR, SAMBHUR, SAMBUR [n]\n",
  "SAMBAS": "SAMBA, (Portuguese) to perform a Brazilian dance [v]\n",
  "SAMBHAR": "(Hindi) a large Asian deer, also SAMBAR, SAMBHUR, SAMBUR [n -S]\n",
  "SAMBHARS": "SAMBHAR, (Hindi) a large Asian deer, also SAMBAR, SAMBHUR, SAMBUR [n]\n",
  "SAMBHUR": "(Hindi) a large Asian deer, also SAMBAR, SAMBHAR, SAMBUR [n -S]\n",
  "SAMBHURS": "SAMBHUR, (Hindi) a large Asian deer, also SAMBAR, SAMBHAR, SAMBUR [n]\n",
  "SAMBO": "(offensive) a colloquial or humorous appellation for a negro; sometimes, the offspring of a black person and a mulatto [n -ES or -S]\n",
  "SAMBOES": "SAMBO, (offensive) a colloquial or humorous appellation for a negro; sometimes, the offspring of a black person and a mulatto [n]\n",
  "SAMBOS": "SAMBO, (offensive) a colloquial or humorous appellation for a negro; sometimes, the offspring of a black person and a mulatto [n]\n",
  "SAMBUCA": "(Latin) an ancient stringed instrument, also SAMBUKE [n -S]\n",
  "SAMBUCAS": "SAMBUCA, (Latin) an ancient stringed instrument, also SAMBUKE [n]\n",
  "SAMBUKE": "(Latin) an ancient stringed instrument, also SAMBUCA [n -S]\n",
  "SAMBUKES": "SAMBUKE, (Latin) an ancient stringed instrument, also SAMBUCA [n]\n",
  "SAMBUR": "(Hindi) a large Asian deer, also SAMBAR, SAMBHAR, SAMBHUR [n -S]\n",
  "SAMBURS": "SAMBUR, (Hindi) a large Asian deer, also SAMBAR, SAMBHAR, SAMBHUR [n]\n",
  "SAME": "resembling in every relevant respect, also SAMEN [adj SAMELY] / the same thing [n -S]\n",
  "SAMECH": "(Hebrew) the 15th letter of the Hebrew alphabet, also SAMEK, SAMEKH [n -S]\n",
  "SAMECHS": "SAMECH, (Hebrew) the 15th letter of the Hebrew alphabet, also SAMEK, SAMEKH [n]\n",
  "SAMEK": "(Hebrew) the 15th letter of the Hebrew alphabet, also SAMECH, SAMEKH [n -S]\n",
  "SAMEKH": "(Hebrew) the 15th letter of the Hebrew alphabet, also SAMECH, SAMEK [n -S]\n",
  "SAMEKHS": "SAMEKH, (Hebrew) the 15th letter of the Hebrew alphabet, also SAMECH, SAMEK [n]\n",
  "SAMEKS": "SAMEK, (Hebrew) the 15th letter of the Hebrew alphabet, also SAMECH, SAMEKH [n]\n",
  "SAMEL": "of a brick or tile, imperfectly burnt [adj]\n",
  "SAMELY": "SAME, resembling in every relevant respect, also SAMEN [adj]\n",
  "SAMEN": "(Scots) same [adj]\n",
  "SAMENESS": "lack of variety [n -ES]\n",
  "SAMENESSES": "SAMENESS, lack of variety [n]\n",
  "SAMES": "SAME, the same thing [n]\n",
  "SAMEY": "(colloquial) boringly alike, monotonous [adj SAMIER, SAMIEST]\n",
  "SAMEYNESS": "the quality of being samey [n -ES]\n",
  "SAMEYNESSES": "SAMEYNESS, the quality of being samey [n]\n",
  "SAMFOO": "(Chinese) an outfit worn by Chinese women, also SAMFU [n -S]\n",
  "SAMFOOS": "SAMFOO, (Chinese) an outfit worn by Chinese women, also SAMFU [n]\n",
  "SAMFU": "(Chinese) an outfit worn by Chinese women, also SAMFOO [n -S]\n",
  "SAMFUS": "SAMFU, (Chinese) an outfit worn by Chinese women, also SAMFOO [n]\n",
  "SAMIEL": "(Turkish) a hot sand-laden wind of the Arabian and North African deserts [n -S]\n",
  "SAMIELS": "SAMIEL, (Turkish) a hot sand-laden wind of the Arabian and North African deserts [n]\n",
  "SAMIER": "SAMEY, (colloquial) boringly alike, monotonous [adj]\n",
  "SAMIEST": "SAMEY, (colloquial) boringly alike, monotonous [adj]\n",
  "SAMISEN": "(Japanese) a banjo-like 3-stringed instrument, also SHAMISEN [n -S]\n",
  "SAMISENS": "SAMISEN, (Japanese) a banjo-like 3-stringed instrument, also SHAMISEN [n]\n",
  "SAMITE": "a rich and heavy silk, sometimes interwoven with gold or silver [n -S]\n",
  "SAMITES": "SAMITE, a rich and heavy silk, sometimes interwoven with gold or silver [n]\n",
  "SAMITHI": "(Hindi) a political organization, also SAMITI [n -S]\n",
  "SAMITHIS": "SAMITHI, (Hindi) a political organization, also SAMITI [n]\n",
  "SAMITI": "(Hindi) a political organization, also SAMITHI [n -S]\n",
  "SAMITIS": "SAMITI, (Hindi) a political organization, also SAMITHI [n]\n",
  "SAMIZDAT": "(Russian) in the former Soviet Union, the clandestine circulation of underground literature [n -S]\n",
  "SAMIZDATS": "SAMIZDAT, (Russian) in the former Soviet Union, the clandestine circulation of underground literature [n]\n",
  "SAMLET": "a young salmon, also SALMONET [n -S]\n",
  "SAMLETS": "SAMLET, a young salmon, also SALMONET [n]\n",
  "SAMLOR": "(Thai) a three-wheeled taxi in Thailand [n -S]\n",
  "SAMLORS": "SAMLOR, (Thai) a three-wheeled taxi in Thailand [n]\n",
  "SAMMED": "SAM, (Spenser) to gather [v]\n",
  "SAMMIE": "(Australian slang) a sandwich [n -S]\n",
  "SAMMIES": "SAMMY, (South African) an Indian fruit and vegetable seller who goes from house to house [n]\n",
  "SAMMING": "SAM, (Spenser) to gather [v]\n",
  "SAMMY": "(South African) an Indian fruit and vegetable seller who goes from house to house [n SAMMIES]\n",
  "SAMNITIS": "(Spenser) an unknown poisonous plant [n -ES]\n",
  "SAMNITISES": "SAMNITIS, (Spenser) an unknown poisonous plant [n]\n",
  "SAMOSA": "(Hindi) a small, fried pastry turnover stuffed with spiced vegetables [n -S]\n",
  "SAMOSAS": "SAMOSA, (Hindi) a small, fried pastry turnover stuffed with spiced vegetables [n]\n",
  "SAMOVAR": "(Russian) an urn for making tea [n -S]\n",
  "SAMOVARS": "SAMOVAR, (Russian) an urn for making tea [n]\n",
  "SAMOYED": "(Russian) any of a Siberian breed of medium-sized white or cream-colored sled dogs [n -S]\n",
  "SAMOYEDS": "SAMOYED, (Russian) any of a Siberian breed of medium-sized white or cream-colored sled dogs [n]\n",
  "SAMP": "(Native American) a coarsely ground maize [n -S]\n",
  "SAMPAN": "(Chinese) a flat-bottomed Chinese skiff usually propelled by two short oars, also SANPAN [n -S]\n",
  "SAMPANS": "SAMPAN, (Chinese) a flat-bottomed Chinese skiff usually propelled by two short oars, also SANPAN [n]\n",
  "SAMPHIRE": "a fleshy coastal plant, also SAMPIRE [n -S]\n",
  "SAMPHIRES": "SAMPHIRE, a fleshy coastal plant, also SAMPIRE [n]\n",
  "SAMPI": "(Greek) a supposed name of a Greek numerical character representing 900 [n -S]\n",
  "SAMPIRE": "a fleshy coastal plant; glasswort, also SAMPHIRE [n -S]\n",
  "SAMPIRES": "SAMPIRE, a fleshy coastal plant; glasswort, also SAMPHIRE [n]\n",
  "SAMPIS": "SAMPI, (Greek) a supposed name of a Greek numerical character representing 900 [n]\n",
  "SAMPLE": "to test a specimen of [v SAMPLED, SAMPLING, SAMPLES]\n",
  "SAMPLED": "SAMPLE, to test a specimen of [v]\n",
  "SAMPLER": "one that samples [n -S]\n",
  "SAMPLERIES": "SAMPLERY, sample work [n]\n",
  "SAMPLERS": "SAMPLER, one that samples [n]\n",
  "SAMPLERY": "sample work [n SAMPLERIES]\n",
  "SAMPLES": "SAMPLE, to test a specimen of [v]\n",
  "SAMPLING": "a small part selected for analysis [n -S]\n",
  "SAMPLINGS": "SAMPLING, a small part selected for analysis [n]\n",
  "SAMPS": "SAMP, (Native American) a coarsely ground maize [n]\n",
  "SAMS": "SAM, (Spenser) to gather [v]\n",
  "SAMSARA": "(Sanskrit) the never-ending cycle of birth, death and rebirth [n -S]\n",
  "SAMSARAS": "SAMSARA, (Sanskrit) the never-ending cycle of birth, death and rebirth [n]\n",
  "SAMSARIC": "of or relating to samsara, the Buddhist cycle of death and rebirth [adj]\n",
  "SAMSHOO": "(Chinese) a spirituous liquor distilled by the Chinese from the yeasty liquor in which boiled rice has fermented under pressure, also SAMSHU [n -S]\n",
  "SAMSHOOS": "SAMSHOO, (Chinese) a spirituous liquor distilled by the Chinese from the yeasty liquor in which boiled rice has fermented under pressure, also SAMSHU [n]\n",
  "SAMSHU": "(Chinese) a spirituous liquor distilled by the Chinese from the yeasty liquor in which boiled rice has fermented under pressure, also SAMSHOO [n -S]\n",
  "SAMSHUS": "SAMSHU, (Chinese) a spirituous liquor distilled by the Chinese from the yeasty liquor in which boiled rice has fermented under pressure, also SAMSHOO [n]\n",
  "SAMSKARA": "(Sanskrit) a Hindu purification ceremony [n -S]\n",
  "SAMSKARAS": "SAMSKARA, (Sanskrit) a Hindu purification ceremony [n]\n",
  "SAMURAI": "(Japanese) a member of the military caste in feudal Japan [n -S]\n",
  "SAMURAIS": "SAMURAI, (Japanese) a member of the military caste in feudal Japan [n]\n",
  "SAN": "(short for) a sanatorium [n -S]\n",
  "SANATIVE": "having the power to cure or heal [adj]\n",
  "SANATORIA": "SANATORIUM, a hospital, esp. for tuberculosis, also SANITARIUM, SANITORIUM [n]\n",
  "SANATORIUM": "a hospital, esp. for tuberculosis, also SANITARIUM, SANITORIUM [n SANATORIUMS or SANATORIA]\n",
  "SANATORIUMS": "SANATORIUM, a hospital, esp. for tuberculosis, also SANITARIUM, SANITORIUM [n]\n",
  "SANATORY": "of healing [adj]\n",
  "SANBENITO": "(Spanish) in the Spanish Inquisition, a yellow scapular-shaped garment, with a red St Andrew's cross before and behind, worn by a confessed and penitent heretic [n -S]\n",
  "SANBENITOS": "SANBENITO, (Spanish) in the Spanish Inquisition, a yellow scapular-shaped garment, with a red St Andrew's cross before and behind, worn by a confessed and penitent heretic [n]\n",
  "SANCAI": "(Chinese) in Chinese ceramics, a three-colour glaze [n -S]\n",
  "SANCAIS": "SANCAI, (Chinese) in Chinese ceramics, a three-colour glaze [n]\n",
  "SANCHO": "(Ashanti) a West African guitar, also SANKO [n -S]\n",
  "SANCHOS": "SANCHO, (Ashanti) a West African guitar, also SANKO [n]\n",
  "SANCTA": "SANCTUM, (Latin) a sacred place [n]\n",
  "SANCTIFIABLE": "able to be sanctified [adj]\n",
  "SANCTIFICATION": "an act of sanctifying [n -S]\n",
  "SANCTIFICATIONS": "SANCTIFICATION, an act of sanctifying [n]\n",
  "SANCTIFIED": "SANCTIFY, to make holy [v]\n",
  "SANCTIFIEDLY": "SANCTIFIED, SANCTIFY, to make holy [adv]\n",
  "SANCTIFIER": "one who sanctifies, or makes holy; specifically, the Holy Spirit [n -S]\n",
  "SANCTIFIERS": "SANCTIFIER, one who sanctifies, or makes holy; specifically, the Holy Spirit [n]\n",
  "SANCTIFIES": "SANCTIFY, to make holy [v]\n",
  "SANCTIFY": "to make holy [v SANCTIFIED, SANCTIFYING, SANCTIFIES]\n",
  "SANCTIFYING": "the act of making holy [n -S]\n",
  "SANCTIFYINGLY": "SANCTIFYING [adv]\n",
  "SANCTIFYINGS": "SANCTIFYING, the act of making holy [n]\n",
  "SANCTIMONIES": "SANCTIMONY, outward, affected, or simulated holiness [n]\n",
  "SANCTIMONIOUS": "hypocritically pious or devout [adj SANCTIMONIOUSLY]\n",
  "SANCTIMONIOUSLY": "SANCTIMONIOUS, hypocritically pious or devout [adv]\n",
  "SANCTIMONY": "outward, affected, or simulated holiness [n SANCTIMONIES]\n",
  "SANCTION": "to authorize [v -ED, -ING, -S]\n",
  "SANCTIONABLE": "capable of being sanctioned [adj]\n",
  "SANCTIONED": "SANCTION, to authorize [v]\n",
  "SANCTIONEER": "a person who advocates (esp. political) sanctions [n -S]\n",
  "SANCTIONEERS": "SANCTIONEER, a person who advocates (esp. political) sanctions [n]\n",
  "SANCTIONER": "one who sanctions [n -S]\n",
  "SANCTIONERS": "SANCTIONER, one who sanctions [n]\n",
  "SANCTIONING": "SANCTION, to authorize [v]\n",
  "SANCTIONLESS": "without sanctions [adj]\n",
  "SANCTIONS": "SANCTION, to authorize [v]\n",
  "SANCTITIES": "SANCTITY, holiness [n]\n",
  "SANCTITUDE": "holiness, sanctity [n -S]\n",
  "SANCTITUDES": "SANCTITUDE, holiness, sanctity [n]\n",
  "SANCTITY": "holiness [n SANCTITIES]\n",
  "SANCTUARIES": "SANCTUARY, a place of safety [n]\n",
  "SANCTUARISE": "to afford sanctuary to, also SANCTUARIZE [v SANCTUARISED, SANCTUARISING, SANCTUARISES]\n",
  "SANCTUARISED": "SANCTUARISE, to afford sanctuary to, also SANCTUARIZE [v]\n",
  "SANCTUARISES": "SANCTUARISE, to afford sanctuary to, also SANCTUARIZE [v]\n",
  "SANCTUARISING": "SANCTUARISE, to afford sanctuary to, also SANCTUARIZE [v]\n",
  "SANCTUARIZE": "to afford sanctuary to, also SANCTUARISE [v SANCTUARIZED, SANCTUARIZING, SANCTUARIZES]\n",
  "SANCTUARIZED": "SANCTUARIZE, to afford sanctuary to, also SANCTUARISE [v]\n",
  "SANCTUARIZES": "SANCTUARIZE, to afford sanctuary to, also SANCTUARISE [v]\n",
  "SANCTUARIZING": "SANCTUARIZE, to afford sanctuary to, also SANCTUARISE [v]\n",
  "SANCTUARY": "a place of safety [n SANCTUARIES]\n",
  "SANCTUM": "(Latin) a sacred place [n SANCTUMS or SANCTA]\n",
  "SANCTUMS": "SANCTUM, (Latin) a sacred place [n]\n",
  "SAND": "to cover with a loose granular rock material [v -ED, -ING, -S]\n",
  "SANDABLE": "able to be sanded [adj]\n",
  "SANDAL": "to dress in light open shoes [v SANDALED or SANDALLED, SANDALING or SANDALLING, SANDALS]\n",
  "SANDALED": "SANDAL, to dress in light open shoes [v]\n",
  "SANDALING": "SANDAL, to dress in light open shoes [v]\n",
  "SANDALLED": "SANDAL, to dress in light open shoes [v]\n",
  "SANDALLING": "SANDAL, to dress in light open shoes [v]\n",
  "SANDALS": "SANDAL, to dress in light open shoes [v]\n",
  "SANDALWOOD": "a compact and fine-grained very fragrant East Indian wood; the parasitic tree yielding it [n -S]\n",
  "SANDALWOODS": "SANDALWOOD, a compact and fine-grained very fragrant East Indian wood; the parasitic tree yielding it [n]\n",
  "SANDARAC": "(Latin) the resin of a tropical tree, powdered to form pounce and used in making varnish, also SANDARACH [n -S]\n",
  "SANDARACH": "(Latin) the resin of a tropical tree, powdered to form pounce and used in making varnish, also SANDARAC [n -S]\n",
  "SANDARACHS": "SANDARACH, (Latin) the resin of a tropical tree, powdered to form pounce and used in making varnish, also SANDARAC [n]\n",
  "SANDARACS": "SANDARAC, (Latin) the resin of a tropical tree, powdered to form pounce and used in making varnish, also SANDARACH [n]\n",
  "SANDBAG": "to stun with a bag of sand [v SANDBAGGED, SANDBAGGING, SANDBAGS]\n",
  "SANDBAGGED": "SANDBAG, to stun with a bag of sand [v]\n",
  "SANDBAGGER": "an assaulter whose weapon is a sand bag [n -S]\n",
  "SANDBAGGERS": "SANDBAGGER, an assaulter whose weapon is a sand bag [n]\n",
  "SANDBAGGING": "SANDBAG, to stun with a bag of sand [v]\n",
  "SANDBAGS": "SANDBAG, to stun with a bag of sand [v]\n",
  "SANDBANK": "a mound of sand in a river [n -S]\n",
  "SANDBANKS": "SANDBANK, a mound of sand in a river [n]\n",
  "SANDBAR": "a ridge of sand formed in a river or the sea [n -S]\n",
  "SANDBARS": "SANDBAR, a ridge of sand formed in a river or the sea [n]\n",
  "SANDBLAST": "a sand-laden wind [n -S] / to clean with a sand-laden blast of air [v -ED, -ING, -S]\n",
  "SANDBLASTED": "SANDBLAST, to clean with a sand-laden blast of air [v]\n",
  "SANDBLASTER": "a tool for sandblasting [n -S]\n",
  "SANDBLASTERS": "SANDBLASTER, a tool for sandblasting [n]\n",
  "SANDBLASTING": "the act of cleaning with a sand-laden blast of air [n -S]\n",
  "SANDBLASTINGS": "SANDBLASTING, the act of cleaning with a sand-laden blast of air [n]\n",
  "SANDBLASTS": "SANDBLAST, a sand-laden wind [n]\n",
  "SANDBOX": "a children's play box filled with sand [n -ES]\n",
  "SANDBOXES": "SANDBOX, a children's play box filled with sand [n]\n",
  "SANDBOY": "one who is proverbially happy [n -S]\n",
  "SANDBOYS": "SANDBOY, one who is proverbially happy [n]\n",
  "SANDBUR": "an annual herb, also SANDBURR, SANDSPUR [n -S]\n",
  "SANDBURR": "an annual herb, also SANDBUR, SANDSPUR [n -S]\n",
  "SANDBURRS": "SANDBURR, an annual herb, also SANDBUR, SANDSPUR [n]\n",
  "SANDBURS": "SANDBUR, an annual herb, also SANDBURR, SANDSPUR [n]\n",
  "SANDCASTLE": "a castle made of sand [n -S]\n",
  "SANDCASTLES": "SANDCASTLE, a castle made of sand [n]\n",
  "SANDCRACK": "a deep crack or fissure in the wall of a horse's hoof, often causing lameness [n -S]\n",
  "SANDCRACKS": "SANDCRACK, a deep crack or fissure in the wall of a horse's hoof, often causing lameness [n]\n",
  "SANDDAB": "a small Pacific flatfish [n -S]\n",
  "SANDDABS": "SANDDAB, a small Pacific flatfish [n]\n",
  "SANDED": "SAND, to cover with a loose granular rock material [v]\n",
  "SANDEK": "(Hebrew) a man who holds a baby being circumcised [n -S]\n",
  "SANDEKS": "SANDEK, (Hebrew) a man who holds a baby being circumcised [n]\n",
  "SANDER": "a tool for sanding [n -S]\n",
  "SANDERLING": "a small gray and brown sandpiper [n -S]\n",
  "SANDERLINGS": "SANDERLING, a small gray and brown sandpiper [n]\n",
  "SANDERS": "sandalwood, esp. red sandalwood, also SANDERSWOOD [n -ES]\n",
  "SANDERSES": "SANDERS, sandalwood, esp. red sandalwood, also SANDERSWOOD [n]\n",
  "SANDERSWOOD": "sandalwood, esp. red sandalwood, also SANDERS [n -S]\n",
  "SANDERSWOODS": "SANDERSWOOD, sandalwood, esp. red sandalwood, also SANDERS [n]\n",
  "SANDFISH": "a small marine fish of the Pacific coast of North America, which buries itself in the sand [n -ES]\n",
  "SANDFISHES": "SANDFISH, a small marine fish of the Pacific coast of North America, which buries itself in the sand [n]\n",
  "SANDFLIES": "SANDFLY, any of various small bloodsucking flies [n]\n",
  "SANDFLY": "any of various small bloodsucking flies [n SANDFLIES]\n",
  "SANDGLASS": "an instrument for measuring time by the running of sand [n -ES]\n",
  "SANDGLASSES": "SANDGLASS, an instrument for measuring time by the running of sand [n]\n",
  "SANDGROPER": "(Australian slang) a pioneer at the time of the gold rush [n -S]\n",
  "SANDGROPERS": "SANDGROPER, (Australian slang) a pioneer at the time of the gold rush [n]\n",
  "SANDGROUSE": "any bird of genus Pterocles [n -S]\n",
  "SANDGROUSES": "SANDGROUSE, any bird of genus Pterocles [n]\n",
  "SANDHEAP": "a pile of sand [n -S]\n",
  "SANDHEAPS": "SANDHEAP, a pile of sand [n]\n",
  "SANDHI": "(Sanskrit) the modification of a sound of a word by its context, e.g. the difference in pronunciation of 'the' in 'the house' and in 'the other house' [n -S]\n",
  "SANDHILL": "a hill of sand [n -S]\n",
  "SANDHILLS": "SANDHILL, a hill of sand [n]\n",
  "SANDHIS": "SANDHI, (Sanskrit) the modification of a sound of a word by its context, e.g. the difference in pronunciation of 'the' in 'the house' and in 'the other house' [n]\n",
  "SANDHOG": "a worker who works in sand [n -S]\n",
  "SANDHOGS": "SANDHOG, a worker who works in sand [n]\n",
  "SANDIER": "SANDY, covered with sand [adj]\n",
  "SANDIEST": "SANDY, covered with sand [adj]\n",
  "SANDINESS": "the state of being sandy [n -ES]\n",
  "SANDINESSES": "SANDINESS, the state of being sandy [n]\n",
  "SANDING": "the act of wearing down with a sander [n -S]\n",
  "SANDINGS": "SANDING, the act of wearing down with a sander [n]\n",
  "SANDIVER": "scum formed on molten glass [n -S]\n",
  "SANDIVERS": "SANDIVER, scum formed on molten glass [n]\n",
  "SANDLESS": "without sand [adj]\n",
  "SANDLIKE": "like sand [adj]\n",
  "SANDLING": "a marine fish [n -S]\n",
  "SANDLINGS": "SANDLING, a marine fish [n]\n",
  "SANDLOT": "a vacant plot of sandy land in a town, esp. one used by children for playing sport and games [n -S]\n",
  "SANDLOTS": "SANDLOT, a vacant plot of sandy land in a town, esp. one used by children for playing sport and games [n]\n",
  "SANDLOTTER": "one who occupies a vacant lot [n -S]\n",
  "SANDLOTTERS": "SANDLOTTER, one who occupies a vacant lot [n]\n",
  "SANDMAN": "a mythical person who puts children to sleep [n SANDMEN]\n",
  "SANDMEN": "SANDMAN, a mythical person who puts children to sleep [n]\n",
  "SANDPAINTING": "a painting made with sand [n -S]\n",
  "SANDPAINTINGS": "SANDPAINTING, a painting made with sand [n]\n",
  "SANDPAPER": "a kind of rough paper [n -S] / to smooth or polish with sandpaper [v -ED, -ING, -S]\n",
  "SANDPAPERED": "SANDPAPER, to smooth or polish with sandpaper [v]\n",
  "SANDPAPERIER": "SANDPAPERY, rough like sandpaper [adj]\n",
  "SANDPAPERIEST": "SANDPAPERY, rough like sandpaper [adj]\n",
  "SANDPAPERING": "the act of smoothing or polishing with sandpaper [n -S]\n",
  "SANDPAPERINGS": "SANDPAPERING, the act of smoothing or polishing with sandpaper [n]\n",
  "SANDPAPERS": "SANDPAPER, to smooth or polish with sandpaper [v]\n",
  "SANDPAPERY": "rough like sandpaper [adj SANDPAPERIER, SANDPAPERIEST]\n",
  "SANDPEEP": "(US) any small sandpiper [n -S]\n",
  "SANDPEEPS": "SANDPEEP, (US) any small sandpiper [n]\n",
  "SANDPILE": "a pile of sand [n -S]\n",
  "SANDPILES": "SANDPILE, a pile of sand [n]\n",
  "SANDPIPER": "any of various smaller waders of the family Scolopacidae [n -S]\n",
  "SANDPIPERS": "SANDPIPER, any of various smaller waders of the family Scolopacidae [n]\n",
  "SANDPIT": "a pit dug in sandy soil [n -S]\n",
  "SANDPITS": "SANDPIT, a pit dug in sandy soil [n]\n",
  "SANDPUMP": "a pump for sand or mud [n -S]\n",
  "SANDPUMPS": "SANDPUMP, a pump for sand or mud [n]\n",
  "SANDS": "SAND, to cover with a loose granular rock material [v]\n",
  "SANDSHOE": "a lightweight sneaker [n -S]\n",
  "SANDSHOES": "SANDSHOE, a lightweight sneaker [n]\n",
  "SANDSOAP": "a soap for heavy cleaning [n -S]\n",
  "SANDSOAPS": "SANDSOAP, a soap for heavy cleaning [n]\n",
  "SANDSPIT": "a small point of land created by sand dunes [n -S]\n",
  "SANDSPITS": "SANDSPIT, a small point of land created by sand dunes [n]\n",
  "SANDSPOUT": "a moving pillar of sand drawn up in a whirlwind [n -S]\n",
  "SANDSPOUTS": "SANDSPOUT, a moving pillar of sand drawn up in a whirlwind [n]\n",
  "SANDSPUR": "an annual herb, also SANDBUR, SANDBURR [n -S]\n",
  "SANDSPURS": "SANDSPUR, an annual herb, also SANDBUR, SANDBURR [n]\n",
  "SANDSTONE": "a clastic sedimentary rock that is lithified sand [n -S]\n",
  "SANDSTONES": "SANDSTONE, a clastic sedimentary rock that is lithified sand [n]\n",
  "SANDSTORM": "a strong wind that whips up clouds of sand, esp. in a desert [n -S]\n",
  "SANDSTORMS": "SANDSTORM, a strong wind that whips up clouds of sand, esp. in a desert [n]\n",
  "SANDSUCKER": "a fish, the rough dab [n -S]\n",
  "SANDSUCKERS": "SANDSUCKER, a fish, the rough dab [n]\n",
  "SANDWICH": "to place between two objects [v -ED, -ING, -ES]\n",
  "SANDWICHED": "SANDWICH, to place between two objects [v]\n",
  "SANDWICHES": "SANDWICH, to place between two objects [v]\n",
  "SANDWICHING": "SANDWICH, to place between two objects [v]\n",
  "SANDWORM": "a sand-dwelling worm [n -S]\n",
  "SANDWORMS": "SANDWORM, a sand-dwelling worm [n]\n",
  "SANDWORT": "any of various small white-flowered plants of the pink family [n -S]\n",
  "SANDWORTS": "SANDWORT, any of various small white-flowered plants of the pink family [n]\n",
  "SANDY": "covered with sand [adj SANDIER, SANDIEST]\n",
  "SANDYISH": "somewhat sandy [adj]\n",
  "SANE": "mentally sound [adj SANER, SANEST, SANELY] / to make the sign of the cross on, also SAIN [v SANED, SANING, SANES]\n",
  "SANED": "SANE, to make the sign of the cross on, also SAIN [v]\n",
  "SANELY": "SANE, mentally sound [adv]\n",
  "SANENESS": "sanity [n -ES]\n",
  "SANENESSES": "SANENESS, sanity [n]\n",
  "SANER": "SANE, mentally sound [adj]\n",
  "SANES": "SANE, to make the sign of the cross on, also SAIN [v]\n",
  "SANEST": "SANE, mentally sound [adj]\n",
  "SANG": "(Chinese) a Chinese organ played by mouth [n -S]\n",
  "SANGA": "(Pushtu) a temporary fortification, also SANGAR, SUNGAR [n -S]\n",
  "SANGAR": "(Pushtu) a temporary fortification, also SANGA, SUNGAR [n -S]\n",
  "SANGAREE": "(Spanish) a summer drink consisting of lemon juice, claret, sugar, ice; any sweetened wine drink [n -S]\n",
  "SANGAREES": "SANGAREE, (Spanish) a summer drink consisting of lemon juice, claret, sugar, ice; any sweetened wine drink [n]\n",
  "SANGARS": "SANGAR, (Pushtu) a temporary fortification, also SANGA, SUNGAR [n]\n",
  "SANGAS": "SANGA, (Pushtu) a temporary fortification, also SANGAR, SUNGAR [n]\n",
  "SANGEET": "(Hindi) a kind of pre-wedding party in a Hindi or Sikh marriage [n -S]\n",
  "SANGEETS": "SANGEET, (Hindi) a kind of pre-wedding party in a Hindi or Sikh marriage [n]\n",
  "SANGER": "(Australian slang) a sandwich, also SANGO [n -S]\n",
  "SANGERS": "SANGER, (Australian slang) a sandwich, also SANGO [n]\n",
  "SANGFROID": "(French) self-possession or imperturbability esp. under strain [n -S]\n",
  "SANGFROIDS": "SANGFROID, (French) self-possession or imperturbability esp. under strain [n]\n",
  "SANGH": "(Hindi) an association promoting unity between different groups in Hinduism [n -S]\n",
  "SANGHA": "the Buddhist community; the Buddhist monastic order [n -S]\n",
  "SANGHAS": "SANGHA, the Buddhist community; the Buddhist monastic order [n]\n",
  "SANGHAT": "(Punjabi) a fellowship or assembly, esp. a local Sikh community or congregation [n -S]\n",
  "SANGHATS": "SANGHAT, (Punjabi) a fellowship or assembly, esp. a local Sikh community or congregation [n]\n",
  "SANGHS": "SANGH, (Hindi) an association promoting unity between different groups in Hinduism [n]\n",
  "SANGLIER": "(French) a wild boar [n -S]\n",
  "SANGLIERS": "SANGLIER, (French) a wild boar [n]\n",
  "SANGO": "(colloquial) a sandwich, also SANGER [n -S]\n",
  "SANGOMA": "(Zulu) a witch-doctor [n -S]\n",
  "SANGOMAS": "SANGOMA, (Zulu) a witch-doctor [n]\n",
  "SANGOS": "SANGO, (colloquial) a sandwich, also SANGER [n]\n",
  "SANGRAIL": "the legendary cup used by Christ at the Last Supper, also SANGREAL [n -S]\n",
  "SANGRAILS": "SANGRAIL, the legendary cup used by Christ at the Last Supper, also SANGREAL [n]\n",
  "SANGREAL": "the legendary cup used by Christ at the Last Supper, also SANGRAIL [n -S]\n",
  "SANGREALS": "SANGREAL, the legendary cup used by Christ at the Last Supper, also SANGRAIL [n]\n",
  "SANGRIA": "(Spanish) a Spanish wine punch [n -S]\n",
  "SANGRIAS": "SANGRIA, (Spanish) a Spanish wine punch [n]\n",
  "SANGS": "SANG, (Chinese) a Chinese organ played by mouth [n]\n",
  "SANGUIFEROUS": "bearing blood [adj]\n",
  "SANGUIFICATION": "blood-making [n -S]\n",
  "SANGUIFICATIONS": "SANGUIFICATION, blood-making [n]\n",
  "SANGUIFIED": "SANGUIFY, to make blood [v]\n",
  "SANGUIFIES": "SANGUIFY, to make blood [v]\n",
  "SANGUIFY": "to make blood [v SANGUIFIED, SANGUIFYING, SANGUIFIES]\n",
  "SANGUIFYING": "SANGUIFY, to make blood [v]\n",
  "SANGUINARIA": "the dried rhizome of the bloodroot Sanguinaria used as an emetic [n -S]\n",
  "SANGUINARIAS": "SANGUINARIA, the dried rhizome of the bloodroot Sanguinaria used as an emetic [n]\n",
  "SANGUINARILY": "SANGUINARY, bloodthirsty; murderous [adv]\n",
  "SANGUINARINESS": "the state of being sanguinary [n]\n",
  "SANGUINARY": "bloodthirsty; murderous [adj SANGUINARILY]\n",
  "SANGUINE": "bloody; optimistic [adj SANGUINELY] / to stain with blood [v SANGUINED, SANGUINING, SANGUINES]\n",
  "SANGUINED": "SANGUINE, to stain with blood [v]\n",
  "SANGUINELY": "SANGUINE, bloody; optimistic [adv]\n",
  "SANGUINENESS": "the state of being sanguine [n -ES]\n",
  "SANGUINENESSES": "SANGUINENESS, the state of being sanguine [n]\n",
  "SANGUINEOUS": "bloodred; of or relating to blood [adj]\n",
  "SANGUINEOUSNESS": "SANGUINEOUS, bloodred; of or relating to blood [n]\n",
  "SANGUINES": "SANGUINE, to stain with blood [v]\n",
  "SANGUINING": "SANGUINE, to stain with blood [v]\n",
  "SANGUINITIES": "SANGUINITY, the state of being sanguine [n]\n",
  "SANGUINITY": "the state of being sanguine [n SANGUINITIES]\n",
  "SANGUINIVOROUS": "drinking blood, also SANGUIVOROUS [adj]\n",
  "SANGUINOLENCIES": "SANGUINOLENCY, the state of being sanguinolent, containing blood [n]\n",
  "SANGUINOLENCY": "the state of being sanguinolent, containing blood [n SANGUINOLENCIES]\n",
  "SANGUINOLENT": "containing blood; bloodthirsty [adj]\n",
  "SANGUIVOROUS": "drinking blood, also SANGUINIVOROUS [adj]\n",
  "SANICLE": "a wild flower, with astringent properties [n -S]\n",
  "SANICLES": "SANICLE, a wild flower, with astringent properties [n]\n",
  "SANIDINE": "a variety of orthoclase feldspar common in certain eruptive rocks [n -S]\n",
  "SANIDINES": "SANIDINE, a variety of orthoclase feldspar common in certain eruptive rocks [n]\n",
  "SANIES": "(Latin) a watery foul discharge from wounds or sores [n SANIES]\n",
  "SANIFIED": "SANIFY, to make healthy [v]\n",
  "SANIFIES": "SANIFY, to make healthy [v]\n",
  "SANIFY": "to make healthy [v SANIFIED, SANIFYING, SANIFIES]\n",
  "SANIFYING": "SANIFY, to make healthy [v]\n",
  "SANING": "SANE, to make the sign of the cross on, also SAIN [v]\n",
  "SANIOUS": "pertaining to sanies, a watery foul discharge from wounds or sores [adj]\n",
  "SANITARIA": "SANITARIUM, (Latin) a health station or retreat, also SANATORIUM, SANITORIUM [n]\n",
  "SANITARIAN": "a person favouring sanitary measures [n -S]\n",
  "SANITARIANISM": "the policy of favouring sanitary measures [n -S]\n",
  "SANITARIANISMS": "SANITARIANISM, the policy of favouring sanitary measures [n]\n",
  "SANITARIANS": "SANITARIAN, a person favouring sanitary measures [n]\n",
  "SANITARIES": "SANITARY, a public urinal [n]\n",
  "SANITARILY": "SANITARY, related to health [adv]\n",
  "SANITARINESS": "the state of being sanitary [n -ES]\n",
  "SANITARINESSES": "SANITARINESS, the state of being sanitary [n]\n",
  "SANITARIST": "a sanitarian [n -S]\n",
  "SANITARISTS": "SANITARIST, a sanitarian [n]\n",
  "SANITARIUM": "(Latin) a health station or retreat, also SANATORIUM, SANITORIUM [n SANITARIA or SANITARIUMS]\n",
  "SANITARIUMS": "SANITARIUM, (Latin) a health station or retreat, also SANATORIUM, SANITORIUM [n]\n",
  "SANITARY": "related to health [adj SANITARILY] / a public urinal [n SANITARIES]\n",
  "SANITATE": "to clean and sterilize, also SANITISE, SANITIZE [v SANITATED, SANITATING, SANITATES]\n",
  "SANITATED": "SANITATE, to clean and sterilize, also SANITISE, SANITIZE [v]\n",
  "SANITATES": "SANITATE, to clean and sterilize, also SANITISE, SANITIZE [v]\n",
  "SANITATING": "SANITATE, to clean and sterilize, also SANITISE, SANITIZE [v]\n",
  "SANITATION": "the act of making sanitary [n -S]\n",
  "SANITATIONIST": "one concerned with sanitary measures [n -S]\n",
  "SANITATIONISTS": "SANITATIONIST, one concerned with sanitary measures [n]\n",
  "SANITATIONS": "SANITATION, the act of making sanitary [n]\n",
  "SANITIES": "SANITY, the state of being sane [n]\n",
  "SANITISATION": "the act of sanitising, also SANITIZATION [n -S]\n",
  "SANITISATIONS": "SANITISATION, the act of sanitising, also SANITIZATION [n]\n",
  "SANITISE": "to clean and sterilize, also SANITIZE, SANITATE [v SANITISED, SANITISING, SANITISES]\n",
  "SANITISED": "SANITISE, to clean and sterilize, also SANITIZE, SANITATE [v]\n",
  "SANITISER": "one who sanitises, also SANITIZER [n -S]\n",
  "SANITISERS": "SANITISER, one who sanitises, also SANITIZER [n]\n",
  "SANITISES": "SANITISE, to clean and sterilize, also SANITIZE, SANITATE [v]\n",
  "SANITISING": "SANITISE, to clean and sterilize, also SANITIZE, SANITATE [v]\n",
  "SANITIZATION": "the act of sanitizing, also SANITISATION [n -S]\n",
  "SANITIZATIONS": "SANITIZATION, the act of sanitizing, also SANITISATION [n]\n",
  "SANITIZE": "to clean and sterilize, also SANITISE, SANITATE [v SANITIZED, SANITIZING, SANITIZES]\n",
  "SANITIZED": "SANITIZE, to clean and sterilize, also SANITISE, SANITATE [v]\n",
  "SANITIZER": "one who sanitises, also SANITISER [n -S]\n",
  "SANITIZERS": "SANITIZER, one who sanitises, also SANITISER [n]\n",
  "SANITIZES": "SANITIZE, to clean and sterilize, also SANITISE, SANITATE [v]\n",
  "SANITIZING": "SANITIZE, to clean and sterilize, also SANITISE, SANITATE [v]\n",
  "SANITORIA": "SANITORIUM, a hospital, esp. for tuberculosis, also SANATORIUM, SANITARIUM [n]\n",
  "SANITORIUM": "a hospital, esp. for tuberculosis, also SANATORIUM, SANITARIUM [n SANITORIUMS or SANITORIA]\n",
  "SANITORIUMS": "SANITORIUM, a hospital, esp. for tuberculosis, also SANATORIUM, SANITARIUM [n]\n",
  "SANITY": "the state of being sane [n SANITIES]\n",
  "SANJAK": "(Turkish) a district or a subdivision of a vilayet, one of the chief administrative divisions or provinces of the Ottoman Empire [n -S]\n",
  "SANJAKS": "SANJAK, (Turkish) a district or a subdivision of a vilayet, one of the chief administrative divisions or provinces of the Ottoman Empire [n]\n",
  "SANK": "SINK, to subside to a lower level [v]\n",
  "SANKO": "a West African guitar, also SANCHO [n -S]\n",
  "SANKOS": "SANKO, a West African guitar, also SANCHO [n]\n",
  "SANNIE": "(Scots) a sandshoe [n -S]\n",
  "SANNIES": "SANNIE, (Scots) a sandshoe [n]\n",
  "SANNOP": "(Native American) a married male in North American Indian societies, also SANNUP [n -S]\n",
  "SANNOPS": "SANNOP, (Native American) a married male in North American Indian societies, also SANNUP [n]\n",
  "SANNUP": "(Native American) a married male in North American Indian societies, also SANNOP [n -S]\n",
  "SANNUPS": "SANNUP, (Native American) a married male in North American Indian societies, also SANNOP [n]\n",
  "SANNYASI": "(Hindi) a Hindu ascetic or hermit who lives by begging, also SANNYASIN, SANYASI [n -S]\n",
  "SANNYASIN": "(Hindi) a Hindu ascetic or hermit who lives by begging, also SANNYASI, SANYASI [n -S]\n",
  "SANNYASINS": "SANNYASIN, (Hindi) a Hindu ascetic or hermit who lives by begging, also SANNYASI, SANYASI [n]\n",
  "SANNYASIS": "SANNYASI, (Hindi) a Hindu ascetic or hermit who lives by begging, also SANNYASIN, SANYASI [n]\n",
  "SANPAN": "(Chinese) a flat-bottomed Chinese skiff usually propelled by two short oars, also SAMPAN [n -S]\n",
  "SANPANS": "SANPAN, (Chinese) a flat-bottomed Chinese skiff usually propelled by two short oars, also SAMPAN [n]\n",
  "SANPRO": "sanitary protection products as an advertising market [n -S]\n",
  "SANPROS": "SANPRO, sanitary protection products as an advertising market [n]\n",
  "SANS": "(French) without; deprived or destitute of [prep]\n",
  "SANSA": "(Arabic) an African musical instrument, aka mbira, also ZANZA, ZANZE [n -S]\n",
  "SANSAR": "a cold, whistling wind, also SARSAR [n -S]\n",
  "SANSARS": "SANSAR, a cold, whistling wind, also SARSAR [n]\n",
  "SANSAS": "SANSA, (Arabic) an African musical instrument, aka mbira, also ZANZA, ZANZE [n]\n",
  "SANSCULOTTE": "(French) an extreme radical republican in France at the time of the Revolution; a radical or violent extremist in politics [n -S]\n",
  "SANSCULOTTERIE": "(French) the sansculottes as a social group [n -S]\n",
  "SANSCULOTTERIES": "SANSCULOTTERIE, (French) the sansculottes as a social group [n]\n",
  "SANSCULOTTES": "SANSCULOTTE, (French) an extreme radical republican in France at the time of the Revolution; a radical or violent extremist in politics [n]\n",
  "SANSCULOTTIC": "of or like a sansculotte [adj]\n",
  "SANSCULOTTIDES": "(French) the holidays following the last month of the year on the French Republican Calendar [n]\n",
  "SANSCULOTTISH": "like a sansculotte, an extreme radical republican in France [adj]\n",
  "SANSCULOTTISM": "the politics of the sansculotte [n -S]\n",
  "SANSCULOTTISMS": "SANSCULOTTISM, the politics of the sansculotte [n]\n",
  "SANSCULOTTIST": "a violent revolutionary [n -S]\n",
  "SANSCULOTTISTS": "SANSCULOTTIST, a violent revolutionary [n]\n",
  "SANSEI": "(Japanese) a grandchild of Japanese immigrants to the United States [n -S]\n",
  "SANSEIS": "SANSEI, (Japanese) a grandchild of Japanese immigrants to the United States [n]\n",
  "SANSERIF": "a typeface without serifs [n -S]\n",
  "SANSERIFS": "SANSERIF, a typeface without serifs [n]\n",
  "SANSEVIERIA": "a kind of house plant [n -S]\n",
  "SANSEVIERIAS": "SANSEVIERIA, a kind of house plant [n]\n",
  "SANT": "(Hindi) in Sikhism, a devout person, a saint [n -S]\n",
  "SANTAL": "sandalwood [n -S]\n",
  "SANTALACEOUS": "belonging to the sandalwood genus Santalum, or sandalwood family Santalaceae [adj]\n",
  "SANTALIC": "pertaining to sandalwood [adj]\n",
  "SANTALIN": "colouring matter [n -S]\n",
  "SANTALINS": "SANTALIN, colouring matter [n]\n",
  "SANTALOL": "sandalwood oil [n -S]\n",
  "SANTALOLS": "SANTALOL, sandalwood oil [n]\n",
  "SANTALS": "SANTAL, sandalwood [n]\n",
  "SANTERA": "(Spanish) a priestess of santeria [n -S]\n",
  "SANTERAS": "SANTERA, (Spanish) a priestess of santeria [n]\n",
  "SANTERIA": "(Spanish) a Caribbean religion composed of elements from both traditional African religion and Roman Catholicism [n -S]\n",
  "SANTERIAS": "SANTERIA, (Spanish) a Caribbean religion composed of elements from both traditional African religion and Roman Catholicism [n]\n",
  "SANTERO": "(Spanish) a priest of santeria, a Caribbean religion [n -S]\n",
  "SANTEROS": "SANTERO, (Spanish) a priest of santeria, a Caribbean religion [n]\n",
  "SANTIM": "a formerly used coin of Latvia, also SANTIMI [n SANTIMS or SANTIMI or SANTIMU]\n",
  "SANTIMI": "SANTIMS, (Latvian) a former coin of Latvia, also SANTIMU [n]\n",
  "SANTIMS": "(Latvian) a former coin of Latvia, also SANTIMU [n SANTIMI]\n",
  "SANTIMU": "SANTIM, a formerly used coin of Latvia, also SANTIMI [n]\n",
  "SANTIR": "(Arabic) a Persian stringed instrument, also SANTOOR, SANTOUR, SANTUR [n -S]\n",
  "SANTIRS": "SANTIR, (Arabic) a Persian stringed instrument, also SANTOOR, SANTOUR, SANTUR [n]\n",
  "SANTO": "(Spanish) the wooden image of a saint [n -S]\n",
  "SANTOKU": "(Japanese) a kind of Japanese kitchen knife [n -S]\n",
  "SANTOKUS": "SANTOKU, (Japanese) a kind of Japanese kitchen knife [n]\n",
  "SANTOL": "a tropical tree yielding a yellow fruit [n -S]\n",
  "SANTOLINA": "a genus of fragrant Mediterranean shrubs [n -S]\n",
  "SANTOLINAS": "SANTOLINA, a genus of fragrant Mediterranean shrubs [n]\n",
  "SANTOLS": "SANTOL, a tropical tree yielding a yellow fruit [n]\n",
  "SANTON": "(Spanish) an Eastern dervish or saint [n -S]\n",
  "SANTONICA": "the dried unexpanded flower-heads of a species of wormwood [n -S]\n",
  "SANTONICAS": "SANTONICA, the dried unexpanded flower-heads of a species of wormwood [n]\n",
  "SANTONIN": "an anthelminthic extracted from santonica [n -S]\n",
  "SANTONINS": "SANTONIN, an anthelminthic extracted from santonica [n]\n",
  "SANTONS": "SANTON, (Spanish) an Eastern dervish or saint [n]\n",
  "SANTOOR": "(Arabic) an Eastern dulcimer, also SANTIR, SANTOUR, SANTUR [n -S]\n",
  "SANTOORS": "SANTOOR, (Arabic) an Eastern dulcimer, also SANTIR, SANTOUR, SANTUR [n]\n",
  "SANTOS": "SANTO, (Spanish) the wooden image of a saint [n]\n",
  "SANTOUR": "(Arabic) an Eastern dulcimer, also SANTIR, SANTOOR, SANTUR [n -S]\n",
  "SANTOURS": "SANTOUR, (Arabic) an Eastern dulcimer, also SANTIR, SANTOOR, SANTUR [n]\n",
  "SANTS": "SANT, (Hindi) in Sikhism, a devout person, a saint [n]\n",
  "SANTUR": "(Arabic) an Eastern dulcimer, also SANTIR, SANTOOR, SANTOUR [n -S]\n",
  "SANTURS": "SANTUR, (Arabic) an Eastern dulcimer, also SANTIR, SANTOOR, SANTOUR [n]\n",
  "SANYASI": "(Hindi) a Hindu ascetic or hermit who lives by begging, also SANNYASI, SANNYASIN [n -S]\n",
  "SANYASIS": "SANYASI, (Hindi) a Hindu ascetic or hermit who lives by begging, also SANNYASI, SANNYASIN [n]\n",
  "SAOLA": "(Vietnamese) a small oxlike mammal found in Vietnam and Laos [n -S]\n",
  "SAOLAS": "SAOLA, (Vietnamese) a small oxlike mammal found in Vietnam and Laos [n]\n",
  "SAOUARI": "a tree of Guiana, yielding butternuts, also SOUARI [n -S]\n",
  "SAOUARIS": "SAOUARI, a tree of Guiana, yielding butternuts, also SOUARI [n]\n",
  "SAP": "to deprive of strength [v SAPPED, SAPPING, SAPS]\n",
  "SAPAJOU": "(Tupi) a long-tailed monkey, also SAJOU [n -S]\n",
  "SAPAJOUS": "SAPAJOU, (Tupi) a long-tailed monkey, also SAJOU [n]\n",
  "SAPAN": "(Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPANWOOD, SAPPAN, SAPPANWOOD [n -S]\n",
  "SAPANS": "SAPAN, (Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPANWOOD, SAPPAN, SAPPANWOOD [n]\n",
  "SAPANWOOD": "(Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPAN, SAPPAN, SAPPANWOOD [n -S]\n",
  "SAPANWOODS": "SAPANWOOD, (Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPAN, SAPPAN, SAPPANWOOD [n]\n",
  "SAPEGO": "a dry, scaly eruption on the skin; esp. a ringworm, also SERPIGO, SUPPEAGO [n -ES]\n",
  "SAPEGOES": "SAPEGO, a dry, scaly eruption on the skin; esp. a ringworm, also SERPIGO, SUPPEAGO [n]\n",
  "SAPELE": "a tropical timber resembling mahogany [n -S]\n",
  "SAPELES": "SAPELE, a tropical timber resembling mahogany [n]\n",
  "SAPFUL": "full of sap [adj]\n",
  "SAPHEAD": "a stupid person [n -S]\n",
  "SAPHEADED": "dopy, weak-minded [adj]\n",
  "SAPHEADS": "SAPHEAD, a stupid person [n]\n",
  "SAPHENA": "(Latin) a large vein in the leg [n SAPHENAS or SAPHENAE]\n",
  "SAPHENAE": "SAPHENA, (Latin) a large vein in the leg [n]\n",
  "SAPHENAS": "SAPHENA, (Latin) a large vein in the leg [n]\n",
  "SAPHENOUS": "relating to the saphena, one of the two principal superficial veins of the leg [adj]\n",
  "SAPID": "pleasantly flavoured [adj SAPIDER, SAPIDEST]\n",
  "SAPIDER": "SAPID, pleasantly flavoured [adj]\n",
  "SAPIDEST": "SAPID, pleasantly flavoured [adj]\n",
  "SAPIDITIES": "SAPIDITY, the state of being sapid, pleasantly flavoured, also SAPIDNESS [n]\n",
  "SAPIDITY": "the state of being sapid, pleasantly flavoured, also SAPIDNESS [n SAPIDITIES]\n",
  "SAPIDLESS": "tasteless [adj]\n",
  "SAPIDNESS": "the state of being sapid, pleasantly flavoured, also SAPIDITY [n -ES]\n",
  "SAPIDNESSES": "SAPIDNESS, the state of being sapid, pleasantly flavoured, also SAPIDITY [n]\n",
  "SAPIENCE": "discernment, judgement, also SAPIENCY [n -S]\n",
  "SAPIENCES": "SAPIENCE, discernment, judgement, also SAPIENCY [n]\n",
  "SAPIENCIES": "SAPIENCY, discernment; judgement, also SAPIENCE [n]\n",
  "SAPIENCY": "discernment; judgement, also SAPIENCE [n SAPIENCIES]\n",
  "SAPIENS": "(Latin) pertaining to recent man [adj]\n",
  "SAPIENT": "wise [adj SAPIENTLY] / a wise person [n -S]\n",
  "SAPIENTIAL": "providing wisdom [adj SAPIENTIALLY]\n",
  "SAPIENTIALLY": "SAPIENTIAL, providing wisdom [adv]\n",
  "SAPIENTLY": "SAPIENT, wise [adv]\n",
  "SAPIENTS": "SAPIENT, a wise person [n]\n",
  "SAPINDACEOUS": "belonging to the Sapindus genus of plants, including soapwort [adj]\n",
  "SAPLESS": "lacking vitality [adj]\n",
  "SAPLESSNESS": "the state of being sapless [n -ES]\n",
  "SAPLESSNESSES": "SAPLESSNESS, the state of being sapless [n]\n",
  "SAPLING": "a young tree [n -S]\n",
  "SAPLINGS": "SAPLING, a young tree [n]\n",
  "SAPODILLA": "(Spanish) the edible fruit of a Mexican tree, also SAPOTA, SAPOTE, ZAPOTILLA [n -S]\n",
  "SAPODILLAS": "SAPODILLA, (Spanish) the edible fruit of a Mexican tree, also SAPOTA, SAPOTE, ZAPOTILLA [n]\n",
  "SAPOGENIN": "a compound derived from saponin, often used in synthesizing steroid hormones [n -S]\n",
  "SAPOGENINS": "SAPOGENIN, a compound derived from saponin, often used in synthesizing steroid hormones [n]\n",
  "SAPONACEOUS": "slippery, elusive; soapy [adj]\n",
  "SAPONACEOUSNESS": "the state of being saponaceous, slippery; soapy [n]\n",
  "SAPONARIA": "a genus of flowers, aka soapwort [n -S]\n",
  "SAPONARIAS": "SAPONARIA, a genus of flowers, aka soapwort [n]\n",
  "SAPONATED": "treated or combined with soap [adj]\n",
  "SAPONIFIABLE": "capable of being converted into soap [adj]\n",
  "SAPONIFICATION": "the act of saponifying [n -S]\n",
  "SAPONIFICATIONS": "SAPONIFICATION, the act of saponifying [n]\n",
  "SAPONIFIED": "SAPONIFY, to convert into soap [v]\n",
  "SAPONIFIER": "any agent used to cause saponification [n -S]\n",
  "SAPONIFIERS": "SAPONIFIER, any agent used to cause saponification [n]\n",
  "SAPONIFIES": "SAPONIFY, to convert into soap [v]\n",
  "SAPONIFY": "to convert into soap [v SAPONIFIED, SAPONIFYING, SAPONIFIES]\n",
  "SAPONIFYING": "SAPONIFY, to convert into soap [v]\n",
  "SAPONIN": "a soapy substance obtained from plants, also SAPONINE [n -S]\n",
  "SAPONINE": "a soapy substance obtained from plants, also SAPONIN [n -S]\n",
  "SAPONINES": "SAPONINE, a soapy substance obtained from plants, also SAPONIN [n]\n",
  "SAPONINS": "SAPONIN, a soapy substance obtained from plants, also SAPONINE [n]\n",
  "SAPONITE": "a hydrous silicate of magnesia and alumina occurring in soft, soapy, amorphous masses [n -S]\n",
  "SAPONITES": "SAPONITE, a hydrous silicate of magnesia and alumina occurring in soft, soapy, amorphous masses [n]\n",
  "SAPOR": "flavour, also SAPOUR [n -S]\n",
  "SAPORIFIC": "flavourful, also SAPOROUS [adj]\n",
  "SAPOROUS": "flavourful, also SAPORIFIC [adj]\n",
  "SAPORS": "SAPOR, flavour, also SAPOUR [n]\n",
  "SAPOTA": "(Spanish) the edible fruit of a Mexican tree, also SAPODILLA, SAPOTE, ZAPOTILLA [n -S]\n",
  "SAPOTACEOUS": "pertaining to or like sapota; belonging to sapota family of trees [adj]\n",
  "SAPOTAS": "SAPOTA, (Spanish) the edible fruit of a Mexican tree, also SAPODILLA, SAPOTE, ZAPOTILLA [n]\n",
  "SAPOTE": "a tropical American tree, also SAPODILLA, SAPOTA, ZAPOTILLA [n -S]\n",
  "SAPOTES": "SAPOTE, a tropical American tree, also SAPODILLA, SAPOTA, ZAPOTILLA [n]\n",
  "SAPOUR": "flavour, also SAPOR [n -S]\n",
  "SAPOURS": "SAPOUR, flavour, also SAPOR [n]\n",
  "SAPPAN": "(Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPAN, SAPANWOOD, SAPPANWOOD [n -S]\n",
  "SAPPANS": "SAPPAN, (Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPAN, SAPANWOOD, SAPPANWOOD [n]\n",
  "SAPPANWOOD": "(Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPAN, SAPANWOOD, SAPPAN [n -S]\n",
  "SAPPANWOODS": "SAPPANWOOD, (Malay) the wood of a leguminous tree, formerly used to provide a red dye, also SAPAN, SAPANWOOD, SAPPAN [n]\n",
  "SAPPED": "SAP, to deprive of strength [v]\n",
  "SAPPER": "a military engineer [n -S]\n",
  "SAPPERMENT": "(German) a German oath [interj]\n",
  "SAPPERS": "SAPPER, a military engineer [n]\n",
  "SAPPHIC": "a type of verse form said to have been invented by the Greek lyric poet Sappho [n -S]\n",
  "SAPPHICS": "SAPPHIC, a type of verse form said to have been invented by the Greek lyric poet Sappho [n]\n",
  "SAPPHIRE": "a precious variety of corundum, usually blue [n -S]\n",
  "SAPPHIRED": "coloured with sapphire blue [adj]\n",
  "SAPPHIRES": "SAPPHIRE, a precious variety of corundum, usually blue [n]\n",
  "SAPPHIRINE": "a blue mineral, aluminium-magnesium silicate [n -S]\n",
  "SAPPHIRINES": "SAPPHIRINE, a blue mineral, aluminium-magnesium silicate [n]\n",
  "SAPPHISM": "lesbianism [n -S]\n",
  "SAPPHISMS": "SAPPHISM, lesbianism [n]\n",
  "SAPPHIST": "a lesbian [n -S]\n",
  "SAPPHISTS": "SAPPHIST, a lesbian [n]\n",
  "SAPPIER": "SAPPY, full of sap [adj]\n",
  "SAPPIEST": "SAPPY, full of sap [adj]\n",
  "SAPPILY": "SAPPY, full of sap [adv]\n",
  "SAPPINESS": "the quality of being sappy [n -ES]\n",
  "SAPPINESSES": "SAPPINESS, the quality of being sappy [n]\n",
  "SAPPING": "the act of undermining [n -S]\n",
  "SAPPINGS": "SAPPING, the act of undermining [n]\n",
  "SAPPLE": "(Scots) to wash clothes by hand in soapy water [v SAPPLED, SAPPLING, SAPPLES]\n",
  "SAPPLED": "SAPPLE, (Scots) to wash clothes by hand in soapy water [v]\n",
  "SAPPLES": "SAPPLE, (Scots) to wash clothes by hand in soapy water [v]\n",
  "SAPPLING": "SAPPLE, (Scots) to wash clothes by hand in soapy water [v]\n",
  "SAPPY": "full of sap [adj SAPPIER, SAPPIEST, SAPPILY]\n",
  "SAPRAEMIA": "a kind of blood-poisoning, also SAPREMIA [n -S]\n",
  "SAPRAEMIAS": "SAPRAEMIA, a kind of blood-poisoning, also SAPREMIA [n]\n",
  "SAPRAEMIC": "relating to sapraemia, a kind of blood-poisoning, also SAPREMIC [adj]\n",
  "SAPREMIA": "a kind of blood-poisoning, also SAPRAEMIA [n -S]\n",
  "SAPREMIAS": "SAPREMIA, a kind of blood-poisoning, also SAPRAEMIA [n]\n",
  "SAPREMIC": "relating to sapremia, a kind of blood-poisoning, also SAPRAEMIC [adj]\n",
  "SAPROBE": "(Greek) an organism that lives on decaying matter [n -S]\n",
  "SAPROBES": "SAPROBE, (Greek) an organism that lives on decaying matter [n]\n",
  "SAPROBIAL": "of or like a saprobe, an organism living in foul water, also SAPROBIC [adj]\n",
  "SAPROBIC": "of or like a saprobe, an organism living in foul water, also SAPROBIAL [adj]\n",
  "SAPROBIONT": "any organism, esp. a fungus or bacterium, that lives and feeds on dead organic matter, also SAPROTROPH [n -S]\n",
  "SAPROBIONTS": "SAPROBIONT, any organism, esp. a fungus or bacterium, that lives and feeds on dead organic matter, also SAPROTROPH [n]\n",
  "SAPROBIOTIC": "feeding on dead or decaying plants or animals [adj]\n",
  "SAPROBITIES": "SAPROBITY, the state of being a saprobe [n]\n",
  "SAPROBITY": "the state of being a saprobe [n SAPROBITIES]\n",
  "SAPROGENIC": "producing decay or putrefaction [adj]\n",
  "SAPROGENICITIES": "SAPROGENICITY, the state of being saprogenic [n]\n",
  "SAPROGENICITY": "the state of being saprogenic [n SAPROGENICITIES]\n",
  "SAPROGENOUS": "growing on decaying material; causing putrefaction [adj]\n",
  "SAPROLEGNIA": "any fungus of the genus Saprolegnia, one species of which grows on diseased salmon and was formerly thought to be the cause of the disease [n -S]\n",
  "SAPROLEGNIAS": "SAPROLEGNIA, any fungus of the genus Saprolegnia, one species of which grows on diseased salmon and was formerly thought to be the cause of the disease [n]\n",
  "SAPROLITE": "a soft, partially decomposed rock that has remained in its original site [n -S]\n",
  "SAPROLITES": "SAPROLITE, a soft, partially decomposed rock that has remained in its original site [n]\n",
  "SAPROLITIC": "of or like a saprolite [adj]\n",
  "SAPROPEL": "(Greek) a slimy sediment laid down in water, largely organic in origin [n -S]\n",
  "SAPROPELIC": "living in sapropel [adj]\n",
  "SAPROPELITE": "coal formed of sapropel [n -S]\n",
  "SAPROPELITES": "SAPROPELITE, coal formed of sapropel [n]\n",
  "SAPROPELS": "SAPROPEL, (Greek) a slimy sediment laid down in water, largely organic in origin [n]\n",
  "SAPROPHAGOUS": "feeding on decaying material [adj]\n",
  "SAPROPHYTE": "a fungus or bacterium that feeds upon dead and decaying organic matter [n -S]\n",
  "SAPROPHYTES": "SAPROPHYTE, a fungus or bacterium that feeds upon dead and decaying organic matter [n]\n",
  "SAPROPHYTIC": "relating to a saprophyte [adj SAPROPHYTICALLY]\n",
  "SAPROPHYTICALLY": "SAPROPHYTIC, relating to a saprophyte [adv]\n",
  "SAPROPHYTISM": "being a saprophyte [n -S]\n",
  "SAPROPHYTISMS": "SAPROPHYTISM, being a saprophyte [n]\n",
  "SAPROTROPH": "any organism, esp. a fungus or bacterium, that lives and feeds on dead organic matter, also SAPROBIONT [n -S]\n",
  "SAPROTROPHIC": "of or like a saprotroph [adj]\n",
  "SAPROTROPHS": "SAPROTROPH, any organism, esp. a fungus or bacterium, that lives and feeds on dead organic matter, also SAPROBIONT [n]\n",
  "SAPROZOIC": "feeding on dead or decaying organic material [adj]\n",
  "SAPS": "SAP, to deprive of strength [v]\n",
  "SAPSAGO": "(German) a hard green Swiss cheese [n -S]\n",
  "SAPSAGOS": "SAPSAGO, (German) a hard green Swiss cheese [n]\n",
  "SAPSUCKER": "a kind of woodpecker that eats sap [n -S]\n",
  "SAPSUCKERS": "SAPSUCKER, a kind of woodpecker that eats sap [n]\n",
  "SAPUCAIA": "(Tupi) a South American tree, related to the Brazil nut; the oily edible seed of this [n -S]\n",
  "SAPUCAIAS": "SAPUCAIA, (Tupi) a South American tree, related to the Brazil nut; the oily edible seed of this [n]\n",
  "SAPWOOD": "the newly formed outer wood of a tree [n -S]\n",
  "SAPWOODS": "SAPWOOD, the newly formed outer wood of a tree [n]\n",
  "SAR": "(Scots) to savour, also SAIR [v -ED, -ING, -S]\n",
  "SARABAND": "(Spanish) a stately court dance of the 17th and 18th centuries, resembling the minuet, also SARABANDE [n -S]\n",
  "SARABANDE": "(Spanish) a stately court dance of the 17th and 18th centuries, resembling the minuet, also SARABAND [n -S]\n",
  "SARABANDES": "SARABANDE, (Spanish) a stately court dance of the 17th and 18th centuries, resembling the minuet, also SARABAND [n]\n",
  "SARABANDS": "SARABAND, (Spanish) a stately court dance of the 17th and 18th centuries, resembling the minuet, also SARABANDE [n]\n",
  "SARAFAN": "(Russian) the national dress of Russian peasant women [n -S]\n",
  "SARAFANS": "SARAFAN, (Russian) the national dress of Russian peasant women [n]\n",
  "SARAN": "a thermoplastic resin [n -S]\n",
  "SARANGI": "(Hindi) an Indian stringed instrument, played like a fiddle [n -S]\n",
  "SARANGIS": "SARANGI, (Hindi) an Indian stringed instrument, played like a fiddle [n]\n",
  "SARANS": "SARAN, a thermoplastic resin [n]\n",
  "SARAPE": "(Spanish) a blanket or shawl worn as an outer garment by the Spanish Americans, as in Mexico, also SERAPE, ZARAPE [n -S]\n",
  "SARAPES": "SARAPE, (Spanish) a blanket or shawl worn as an outer garment by the Spanish Americans, as in Mexico, also SERAPE, ZARAPE [n]\n",
  "SARBACANE": "(French) a blowpipe for shooting animals etc. [n -S]\n",
  "SARBACANES": "SARBACANE, (French) a blowpipe for shooting animals etc. [n]\n",
  "SARCASM": "a sharply mocking or contemptuous remark [n -S]\n",
  "SARCASMS": "SARCASM, a sharply mocking or contemptuous remark [n]\n",
  "SARCASTIC": "showing sarcasm, scornful [adj SARCASTICALLY]\n",
  "SARCASTICALLY": "SARCASTIC, showing sarcasm, scornful [adv]\n",
  "SARCENCHYMATOUS": "of or like a sarcenchyme, a soft tissue of sponges with close-packed cells and reduced gelatinous matrix [adj]\n",
  "SARCENCHYME": "a soft tissue of sponges with close-packed cells and reduced gelatinous matrix [n -S]\n",
  "SARCENCHYMES": "SARCENCHYME, a soft tissue of sponges with close-packed cells and reduced gelatinous matrix [n]\n",
  "SARCENET": "a fine silk fabric, also SARSENET, SARSNET, SARCONET [n -S]\n",
  "SARCENETS": "SARCENET, a fine silk fabric, also SARSENET, SARSNET, SARCONET [n]\n",
  "SARCINA": "a spherical bacterium [n SARCINAS or SARCINAE]\n",
  "SARCINAE": "SARCINA, a spherical bacterium [n]\n",
  "SARCINAS": "SARCINA, a spherical bacterium [n]\n",
  "SARCOCARP": "the fleshy part of a stone fruit [n -S]\n",
  "SARCOCARPS": "SARCOCARP, the fleshy part of a stone fruit [n]\n",
  "SARCOCOLLA": "(Greek) a Persian gum from Astragalus or other plants, reputed to heal wounds [n -S]\n",
  "SARCOCOLLAS": "SARCOCOLLA, (Greek) a Persian gum from Astragalus or other plants, reputed to heal wounds [n]\n",
  "SARCOCYSTIS": "a sporozoan of the genus Sarcocystis, parasitic in muscles of mammals [n -ES]\n",
  "SARCOCYSTISES": "SARCOCYSTIS, a sporozoan of the genus Sarcocystis, parasitic in muscles of mammals [n]\n",
  "SARCODE": "protoplasm, esp. of protozoans [n -S]\n",
  "SARCODES": "SARCODE, protoplasm, esp. of protozoans [n]\n",
  "SARCODIC": "of or pertaining to sarcode, protoplasm, esp. of protozoans [adj]\n",
  "SARCOID": "a fleshy tumour [n -S]\n",
  "SARCOIDOSES": "SARCOIDOSIS, a medical condition characterized by the formation of nodules, esp. in lymph nodes and lungs [n]\n",
  "SARCOIDOSIS": "a medical condition characterized by the formation of nodules, esp. in lymph nodes and lungs [n SARCOIDOSES]\n",
  "SARCOIDS": "SARCOID, a fleshy tumour [n]\n",
  "SARCOLEMMA": "the cell membrane enclosing a muscle fibre [n SARCOLEMMAS or SARCOLEMMATA]\n",
  "SARCOLEMMAL": "of or like a sarcolemma, the very thin transparent and apparently homogeneous sheath which incloses a striated muscular fiber [adj]\n",
  "SARCOLEMMAS": "SARCOLEMMA, the cell membrane enclosing a muscle fibre [n]\n",
  "SARCOLEMMATA": "SARCOLEMMA, the cell membrane enclosing a muscle fibre [n]\n",
  "SARCOLOGIES": "SARCOLOGY, the study of soft, fleshy parts of the body [n]\n",
  "SARCOLOGY": "the study of soft, fleshy parts of the body [n SARCOLOGIES]\n",
  "SARCOMA": "(Greek) a tumour of connective tissue [n SARCOMAS or SARCOMATA]\n",
  "SARCOMAS": "SARCOMA, (Greek) a tumour of connective tissue [n]\n",
  "SARCOMATA": "SARCOMA, (Greek) a tumour of connective tissue [n]\n",
  "SARCOMATOID": "like a sarcoma, a tumour of connective tissue [adj]\n",
  "SARCOMATOSES": "SARCOMATOSIS, a disease characterized by the presence and spread of sarcomas [n]\n",
  "SARCOMATOSIS": "a disease characterized by the presence and spread of sarcomas [n SARCOMATOSES]\n",
  "SARCOMATOUS": "of or like a sarcoma [adj]\n",
  "SARCOMERE": "a unit of myofibril, in muscle [n -S]\n",
  "SARCOMERES": "SARCOMERE, a unit of myofibril, in muscle [n]\n",
  "SARCONET": "a fine silk fabric, also SARSENET, SARSNET, SARCENET [n -S]\n",
  "SARCONETS": "SARCONET, a fine silk fabric, also SARSENET, SARSNET, SARCENET [n]\n",
  "SARCOPENIA": "reduction in muscle tissue as a result of ageing [n -S]\n",
  "SARCOPENIAS": "SARCOPENIA, reduction in muscle tissue as a result of ageing [n]\n",
  "SARCOPHAGAL": "flesh-eating; of or relating to sarcophagi [adj]\n",
  "SARCOPHAGI": "SARCOPHAGUS, a stone coffin [n]\n",
  "SARCOPHAGOUS": "feeding on flesh; carnivorous [adj]\n",
  "SARCOPHAGUS": "a stone coffin [n SARCOPHAGI or SARCOPHAGUSES]\n",
  "SARCOPHAGUSES": "SARCOPHAGUS, a stone coffin [n]\n",
  "SARCOPLASM": "the protoplasmic substance separating the fibrils in muscle fibres [n -S]\n",
  "SARCOPLASMIC": "relating to sarcoplasm, the protoplasmic substance separating the fibrils in muscle fibres [adj]\n",
  "SARCOPLASMS": "SARCOPLASM, the protoplasmic substance separating the fibrils in muscle fibres [n]\n",
  "SARCOPTIC": "relating to a genus of small mites [adj]\n",
  "SARCOSOMAL": "of or like a sarcosome [adj]\n",
  "SARCOSOME": "a mitochondrion of a striated muscle fire [n -S]\n",
  "SARCOSOMES": "SARCOSOME, a mitochondrion of a striated muscle fire [n]\n",
  "SARCOUS": "composed or flesh or muscle [adj]\n",
  "SARD": "a variety of quartz, also SARDIUS [n -S]\n",
  "SARDANA": "(Catalan) a Spanish folk dance [n -S]\n",
  "SARDANAS": "SARDANA, (Catalan) a Spanish folk dance [n]\n",
  "SARDAR": "(Urdu) a native chief in Hindostan; a headman, also SIRDAR [n -S]\n",
  "SARDARS": "SARDAR, (Urdu) a native chief in Hindostan; a headman, also SIRDAR [n]\n",
  "SARDEL": "a small fish related to the sardine, also SARDELLE [n -S]\n",
  "SARDELLE": "a small fish related to the sardine, also SARDEL [n -S]\n",
  "SARDELLES": "SARDELLE, a small fish related to the sardine, also SARDEL [n]\n",
  "SARDELS": "SARDEL, a small fish related to the sardine, also SARDELLE [n]\n",
  "SARDINE": "to pack tightly together [v SARDINED, SARDINING, SARDINES]\n",
  "SARDINED": "SARDINE, to pack tightly together [v]\n",
  "SARDINES": "SARDINE, to pack tightly together [v]\n",
  "SARDINING": "SARDINE, to pack tightly together [v]\n",
  "SARDIUS": "(Latin) a variety of quartz, also SARD [n -ES]\n",
  "SARDIUSES": "SARDIUS, (Latin) a variety of quartz, also SARD [n]\n",
  "SARDONIAN": "(obsolete) a person who flatters with harmful or deadly intent [n -S]\n",
  "SARDONIANS": "SARDONIAN, (obsolete) a person who flatters with harmful or deadly intent [n]\n",
  "SARDONIC": "mocking [adj SARDONICALLY]\n",
  "SARDONICAL": "bitterly or evilly humorous; grimly mocking, also SARDONIAN, SARDONIC [adj SARDONICALLY]\n",
  "SARDONICALLY": "SARDONICAL, bitterly or evilly humorous; grimly mocking, also SARDONIAN, SARDONIC [adv]\n",
  "SARDONICISM": "the state of being sardonic [n -S]\n",
  "SARDONICISMS": "SARDONICISM, the state of being sardonic [n]\n",
  "SARDONYX": "(Greek) an onyx with alternate layers of sard and other mineral [n -ES]\n",
  "SARDONYXES": "SARDONYX, (Greek) an onyx with alternate layers of sard and other mineral [n]\n",
  "SARDS": "SARD, a variety of quartz, also SARDIUS [n]\n",
  "SARED": "SAR, (Scots) to savour, also SAIR [v]\n",
  "SAREE": "(Hindi) an outer garment worn by Hindu women, also SARI [n -S]\n",
  "SAREES": "SAREE, (Hindi) an outer garment worn by Hindu women, also SARI [n]\n",
  "SARGASSA": "SARGASSUM, (Latin) a genus of algae including the gulfweed, also SARGASSO [n]\n",
  "SARGASSO": "(Portuguese) a genus of algae including the gulfweed, also SARGASSUM [n -ES or -S]\n",
  "SARGASSOES": "SARGASSO, (Portuguese) a genus of algae including the gulfweed, also SARGASSUM [n]\n",
  "SARGASSOS": "SARGASSO, (Portuguese) a genus of algae including the gulfweed, also SARGASSUM [n]\n",
  "SARGASSUM": "(Latin) a genus of algae including the gulfweed, also SARGASSO [n SARGASSA or SARGASSUMS]\n",
  "SARGASSUMS": "SARGASSUM, (Latin) a genus of algae including the gulfweed, also SARGASSO [n]\n",
  "SARGE": "(colloquial) sergeant [n -S]\n",
  "SARGES": "SARGE, (colloquial) sergeant [n]\n",
  "SARGO": "(Spanish) a fish, sea-bream, also SARGOS, SARGUS [n -S]\n",
  "SARGOS": "(Spanish) a fish, the sea-bream, also SARGO, SARGUS [n -ES]\n",
  "SARGOSES": "SARGOS, (Spanish) a fish, the sea-bream, also SARGO, SARGUS [n]\n",
  "SARGUS": "(Spanish) a fish, sea-bream, also SARGO, SARGOS [n -ES]\n",
  "SARGUSES": "SARGUS, (Spanish) a fish, sea-bream, also SARGO, SARGOS [n]\n",
  "SARI": "(Hindi) an outer garment worn by Hindu women, also SAREE [n -S]\n",
  "SARIN": "(German) a compound of phosphorus used as a lethal nerve gas [n -S]\n",
  "SARING": "SAR, (Scots) to savour, also SAIR [v]\n",
  "SARINS": "SARIN, (German) a compound of phosphorus used as a lethal nerve gas [n]\n",
  "SARIS": "SARI, (Hindi) an outer garment worn by Hindu women, also SAREE [n]\n",
  "SARK": "(Scots) a shirt, a chemise, also SERK [n -S]\n",
  "SARKIER": "SARKY, sarcastic [adj]\n",
  "SARKIEST": "SARKY, sarcastic [adj]\n",
  "SARKILY": "SARKY, sarcastic [adv]\n",
  "SARKINESS": "the quality of being sarky [n -ES]\n",
  "SARKINESSES": "SARKINESS, the quality of being sarky [n]\n",
  "SARKING": "a lining of thin boards for a roof [n -S]\n",
  "SARKINGS": "SARKING, a lining of thin boards for a roof [n]\n",
  "SARKS": "SARK, (Scots) a shirt, a chemise, also SERK [n]\n",
  "SARKY": "sarcastic [adj SARKIER, SARKIEST, SARKILY]\n",
  "SARMENT": "a long whiplike runner, leafless except at the tip, also SARMENTUM [n -S]\n",
  "SARMENTA": "SARMENTUM, (Latin) a long whiplike runner, leafless except at the tip, also SARMENT [n]\n",
  "SARMENTACEOUS": "having sarmenta or runners; creeping [adj]\n",
  "SARMENTOSE": "producing long, flexuose runners or stolons, also SARMENTOUS [adj]\n",
  "SARMENTOUS": "producing long, flexuose runners or stolons, also SARMENTOSE [adj]\n",
  "SARMENTS": "SARMENT, a long whiplike runner, leafless except at the tip, also SARMENTUM [n]\n",
  "SARMENTUM": "(Latin) a long whiplike runner, leafless except at the tip, also SARMENT [n SARMENTA]\n",
  "SARMIE": "(South African) a sandwich, also SARNEY, SARNIE [n -S]\n",
  "SARMIES": "SARMIE, (South African) a sandwich, also SARNEY, SARNIE [n]\n",
  "SARNEY": "(colloquial) a sandwich, also SARMIE, SARNIE [n -S]\n",
  "SARNEYS": "SARNEY, (colloquial) a sandwich, also SARMIE, SARNIE [n]\n",
  "SARNIE": "(colloquial) a sandwich, also SARMIE, SARNEY [n -S]\n",
  "SARNIES": "SARNIE, (colloquial) a sandwich, also SARMIE, SARNEY [n]\n",
  "SAROD": "(Hindi) an Indian instrument like a cello, also SARODE [n -S]\n",
  "SARODE": "(Hindi) an Indian instrument like a cello, also SAROD [n -S]\n",
  "SARODES": "SARODE, (Hindi) an Indian instrument like a cello, also SAROD [n]\n",
  "SARODIST": "one who plays the sarod, an Indian instrument like a cello [n -S]\n",
  "SARODISTS": "SARODIST, one who plays the sarod, an Indian instrument like a cello [n]\n",
  "SARODS": "SAROD, (Hindi) an Indian instrument like a cello, also SARODE [n]\n",
  "SARONG": "(Malay) a sort of petticoat worn by both sexes in Java and the Malay Archipelago [n -S]\n",
  "SARONGS": "SARONG, (Malay) a sort of petticoat worn by both sexes in Java and the Malay Archipelago [n]\n",
  "SARONIC": "relating to a saros, a cycle of 6585.32 days in which eclipses of the sun and moon occur in same sequence and at the same intervals as in the previous such cycle [adj]\n",
  "SAROS": "(Greek) the eclipse cycle of the sun and moon [n -ES]\n",
  "SAROSES": "SAROS, (Greek) the eclipse cycle of the sun and moon [n]\n",
  "SARPANCH": "(Hindi) the head of an Indian village [n -ES]\n",
  "SARPANCHES": "SARPANCH, (Hindi) the head of an Indian village [n]\n",
  "SARRACENIA": "a genus of American perennial herbs growing in bogs; the American pitcher plant [n -S]\n",
  "SARRACENIACEOUS": "belonging to the Sarraceniaceae, pitcher-plants [adj]\n",
  "SARRACENIAS": "SARRACENIA, a genus of American perennial herbs growing in bogs; the American pitcher plant [n]\n",
  "SARRASIN": "(French) buckwheat, also SARRAZIN [n -S]\n",
  "SARRASINS": "SARRASIN, (French) buckwheat, also SARRAZIN [n]\n",
  "SARRAZIN": "(French) buckwheat, also SARRASIN [n -S]\n",
  "SARRAZINS": "SARRAZIN, (French) buckwheat, also SARRASIN [n]\n",
  "SARRUSOPHONE": "a double-reeded musical instrument resembling the bassoon [n -S]\n",
  "SARRUSOPHONES": "SARRUSOPHONE, a double-reeded musical instrument resembling the bassoon [n]\n",
  "SARS": "SAR, (Scots) to savour, also SAIR [v]\n",
  "SARSAPARILLA": "(Spanish) any tropical American plant of the genus Smilax; a drink or medicine prepared from it [n -S]\n",
  "SARSAPARILLAS": "SARSAPARILLA, (Spanish) any tropical American plant of the genus Smilax; a drink or medicine prepared from it [n]\n",
  "SARSAR": "a cold, whistling wind, also SANSAR [n -S]\n",
  "SARSARS": "SARSAR, a cold, whistling wind, also SANSAR [n]\n",
  "SARSDEN": "a sandstone boulder of South England; such a stone used in a prehistoric monument, also SARSEN [n -S]\n",
  "SARSDENS": "SARSDEN, a sandstone boulder of South England; such a stone used in a prehistoric monument, also SARSEN [n]\n",
  "SARSEN": "a sandstone boulder of South England; such a stone used in a prehistoric monument, also SARSDEN [n -S]\n",
  "SARSENET": "a fine silk fabric, also SARSNET, SARCENET, SARCONET [n -S]\n",
  "SARSENETS": "SARSENET, a fine silk fabric, also SARSNET, SARCENET, SARCONET [n]\n",
  "SARSENS": "SARSEN, a sandstone boulder of South England; such a stone used in a prehistoric monument, also SARSDEN [n]\n",
  "SARSNET": "a thin tissue of fine silk, also SARCENET, SARCONET, SARSENET [n -S]\n",
  "SARSNETS": "SARSNET, a thin tissue of fine silk, also SARCENET, SARCONET, SARSENET [n]\n",
  "SARTOR": "(Latin) a tailor [n -S]\n",
  "SARTORIAL": "of or relating to a tailor or tailored clothes, also SARTORIAN [adj SARTORIALLY]\n",
  "SARTORIALLY": "SARTORIAL, of or relating to a tailor or tailored clothes, also SARTORIAN [adv]\n",
  "SARTORIAN": "of or relating to a tailor or tailored clothes, also SARTORIAL [adj]\n",
  "SARTORII": "SARTORIUS, (Latin) a flat thigh muscle [n]\n",
  "SARTORIUS": "(Latin) a flat thigh muscle [n SARTORIUSES or SARTORII]\n",
  "SARTORIUSES": "SARTORIUS, (Latin) a flat thigh muscle [n]\n",
  "SARTORS": "SARTOR, (Latin) a tailor [n]\n",
  "SARUS": "(Hindi) a large redheaded crane found from India to the Philippines [n -ES]\n",
  "SARUSES": "SARUS, (Hindi) a large redheaded crane found from India to the Philippines [n]\n",
  "SASANQUA": "(Japanese) a kind of camellia [n -S]\n",
  "SASANQUAS": "SASANQUA, (Japanese) a kind of camellia [n]\n",
  "SASARARA": "a scolding; a blow, also SASSARARA, SISERARY [n -S]\n",
  "SASARARAS": "SASARARA, a scolding; a blow, also SASSARARA, SISERARY [n]\n",
  "SASER": "a device for amplifying ultrasound [n -S]\n",
  "SASERS": "SASER, a device for amplifying ultrasound [n]\n",
  "SASH": "a band or scarf worn round the waist or over the shoulder [n -ES] / to dress or adorn with a sash [v -ED, -ING, -ES]\n",
  "SASHAY": "(colloquial) to walk or move in a gliding, ostentatious way [v -ED, -ING, -S]\n",
  "SASHAYED": "SASHAY, (colloquial) to walk or move in a gliding, ostentatious way [v]\n",
  "SASHAYING": "SASHAY, (colloquial) to walk or move in a gliding, ostentatious way [v]\n",
  "SASHAYS": "SASHAY, (colloquial) to walk or move in a gliding, ostentatious way [v]\n",
  "SASHED": "SASH, to dress or adorn with a sash [v]\n",
  "SASHES": "SASH, to dress or adorn with a sash [v]\n",
  "SASHIMI": "(Japanese) fish, sliced paper-thin and served raw [n -S]\n",
  "SASHIMIS": "SASHIMI, (Japanese) fish, sliced paper-thin and served raw [n]\n",
  "SASHING": "SASH, to dress or adorn with a sash [v]\n",
  "SASHLESS": "without a sash [adj]\n",
  "SASIN": "(Nepali) the common Indian antelope [n -S]\n",
  "SASINE": "(Scots) infeftment, the act of giving legal possession of feudal property [n -S]\n",
  "SASINES": "SASINE, (Scots) infeftment, the act of giving legal possession of feudal property [n]\n",
  "SASINS": "SASIN, (Nepali) the common Indian antelope [n]\n",
  "SASKATOON": "(Canadian) a shrub of western North America; the sweet purple edible berry of this shrub [n -S]\n",
  "SASKATOONS": "SASKATOON, (Canadian) a shrub of western North America; the sweet purple edible berry of this shrub [n]\n",
  "SASQUATCH": "(Canadian) a large hairy manlike creature said to inhabit certain parts of Canada [n -ES]\n",
  "SASQUATCHES": "SASQUATCH, (Canadian) a large hairy manlike creature said to inhabit certain parts of Canada [n]\n",
  "SASS": "to talk impudently to [v -ED, -ING, -ES]\n",
  "SASSABIES": "SASSABY, (Setswana) a kind of African antelope, also TSESSEBE [n]\n",
  "SASSABY": "(Setswana) a kind of African antelope, also TSESSEBE [n SASSABIES]\n",
  "SASSAFRAS": "(Spanish) an American tree of the laurel family; also, the bark of the roots, which has an aromatic smell and taste [n -ES]\n",
  "SASSAFRASES": "SASSAFRAS, (Spanish) an American tree of the laurel family; also, the bark of the roots, which has an aromatic smell and taste [n]\n",
  "SASSARARA": "a scolding; a blow, also SASARARA, SISERARY [n -S]\n",
  "SASSARARAS": "SASSARARA, a scolding; a blow, also SASARARA, SISERARY [n]\n",
  "SASSE": "(Dutch) a sluice or lock, as in a river, to make it more navigable [n -S]\n",
  "SASSED": "SASS, to talk impudently to [v]\n",
  "SASSES": "SASSE, (Dutch) a sluice or lock, as in a river, to make it more navigable [n]\n",
  "SASSIER": "SASSY, impertinent [adj]\n",
  "SASSIES": "SASSY, the bark of a West African leguminous tree, used by the natives as an ordeal poison, and also medicinally, also SASSWOOD [n]\n",
  "SASSIEST": "SASSY, impertinent [adj]\n",
  "SASSILY": "SASSY, impertinent [adv]\n",
  "SASSINESS": "the state of being sassy, impertinent [n -ES]\n",
  "SASSINESSES": "SASSINESS, the state of being sassy, impertinent [n]\n",
  "SASSING": "SASS, to talk impudently to [v]\n",
  "SASSOLIN": "a native boric acid, also SASSOLITE [n -S]\n",
  "SASSOLINS": "SASSOLIN, a native boric acid, also SASSOLITE [n]\n",
  "SASSOLITE": "a native boric acid, also SASSOLIN [n -S]\n",
  "SASSOLITES": "SASSOLITE, a native boric acid, also SASSOLIN [n]\n",
  "SASSWOOD": "the bark of a West African leguminous tree, used by the natives as an ordeal poison, also SASSYWOOD [n -S]\n",
  "SASSWOODS": "SASSWOOD, the bark of a West African leguminous tree, used by the natives as an ordeal poison, also SASSYWOOD [n]\n",
  "SASSY": "impertinent [adj SASSIER, SASSIEST, SASSILY] / the bark of a West African leguminous tree, used by the natives as an ordeal poison, and also medicinally, also SASSWOOD [n SASSIES]\n",
  "SASSYWOOD": "the bark of a West African leguminous tree, used by the natives as an ordeal poison, also SASSWOOD [n -S]\n",
  "SASSYWOODS": "SASSYWOOD, the bark of a West African leguminous tree, used by the natives as an ordeal poison, also SASSWOOD [n]\n",
  "SASTRA": "(Sanskrit) any of the sacred writings of Hinduism, also SHASTER, SHASTRA [n -S]\n",
  "SASTRAS": "SASTRA, (Sanskrit) any of the sacred writings of Hinduism, also SHASTER, SHASTRA [n]\n",
  "SASTRUGA": "(Russian) long parallel ridges of snow that form on windy plains, also ZASTRUGA [n SASTRUGI]\n",
  "SASTRUGI": "SASTRUGA, (Russian) long parallel ridges of snow that form on windy plains, also ZASTRUGA [n]\n",
  "SAT": "SIT, to rest on the buttocks [v]\n",
  "SATAI": "(Malay) a Malaysian dish of marinated meat barbecued on skewers, also SATAY [n -S]\n",
  "SATAIS": "SATAI, (Malay) a Malaysian dish of marinated meat barbecued on skewers, also SATAY [n]\n",
  "SATANG": "(Thai) a monetary unit of Thailand, 1/100th of a baht [n -S]\n",
  "SATANGS": "SATANG, (Thai) a monetary unit of Thailand, 1/100th of a baht [n]\n",
  "SATANIC": "devilish, also SATANICAL [adj SATANICALLY]\n",
  "SATANICAL": "devilish, also SATANIC [adj SATANICALLY]\n",
  "SATANICALLY": "SATANICAL, devilish, also SATANIC [adv]\n",
  "SATANICALNESS": "the state of being satanical [n -ES]\n",
  "SATANICALNESSES": "SATANICALNESS, the state of being satanical [n]\n",
  "SATANISM": "worship of the powers of evil [n -S]\n",
  "SATANISMS": "SATANISM, worship of the powers of evil [n]\n",
  "SATANIST": "one who worships the Devil [n -S]\n",
  "SATANISTS": "SATANIST, one who worships the Devil [n]\n",
  "SATANITIES": "SATANITY, devilishness [n]\n",
  "SATANITY": "devilishness [n SATANITIES]\n",
  "SATANOLOGIES": "SATANOLOGY, the study of the devil [n]\n",
  "SATANOLOGY": "the study of the devil [n SATANOLOGIES]\n",
  "SATANOPHANIES": "SATANOPHANY, an appearance of the devil [n]\n",
  "SATANOPHANY": "an appearance of the devil [n SATANOPHANIES]\n",
  "SATANOPHOBIA": "fear of the devil [n -S]\n",
  "SATANOPHOBIAS": "SATANOPHOBIA, fear of the devil [n]\n",
  "SATARA": "(Hindi) a ribbed lustred wool [n -S]\n",
  "SATARAS": "SATARA, (Hindi) a ribbed lustred wool [n]\n",
  "SATAY": "(Malay) a dish of marinated meat barbecued on skewers, also SATAI [n -S]\n",
  "SATAYS": "SATAY, (Malay) a dish of marinated meat barbecued on skewers, also SATAI [n]\n",
  "SATCHEL": "a small carrying bag [n -S]\n",
  "SATCHELED": "carrying a satchel, also SATCHELLED [adj]\n",
  "SATCHELFUL": "the contents of a satchel [n SATCHELFULS or SATCHELSFUL]\n",
  "SATCHELFULS": "SATCHELFUL, the contents of a satchel [n]\n",
  "SATCHELLED": "carrying a satchel, also SATCHELED [adj]\n",
  "SATCHELS": "SATCHEL, a small carrying bag [n]\n",
  "SATCHELSFUL": "SATCHELFUL, the contents of a satchel [n]\n",
  "SATCOM": "satellite communications [n -S]\n",
  "SATCOMS": "SATCOM, satellite communications [n]\n",
  "SATE": "to satisfy to capacity, also SATIATE [v SATED, SATING, SATES]\n",
  "SATED": "SATE, to satisfy to capacity, also SATIATE [v]\n",
  "SATEDNESS": "the state of being sated [n -ES]\n",
  "SATEDNESSES": "SATEDNESS, the state of being sated [n]\n",
  "SATEEN": "a glossy cotton or wool [n -S]\n",
  "SATEENS": "SATEEN, a glossy cotton or wool [n]\n",
  "SATELESS": "insatiable [adj]\n",
  "SATELLES": "(obsolete) a satellite [n SATELLITES]\n",
  "SATELLITE": "a body revolving around a planet, also SATELLES [n -S] / to transmit by satellite [v SATELLITED, SATELLITING, SATELLITES]\n",
  "SATELLITED": "SATELLITE, to transmit by satellite [v]\n",
  "SATELLITES": "SATELLITE, to transmit by satellite [v]\n",
  "SATELLITIC": "of or like a satellite [adj]\n",
  "SATELLITING": "SATELLITE, to transmit by satellite [v]\n",
  "SATELLITISE": "to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITIZE [v SATELLITISED, SATELLITISING, SATELLITISES]\n",
  "SATELLITISED": "SATELLITISE, to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITIZE [v]\n",
  "SATELLITISES": "SATELLITISE, to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITIZE [v]\n",
  "SATELLITISING": "SATELLITISE, to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITIZE [v]\n",
  "SATELLITIUM": "a group of three or more planets lying in one sign of the zodiac [n -S]\n",
  "SATELLITIUMS": "SATELLITIUM, a group of three or more planets lying in one sign of the zodiac [n]\n",
  "SATELLITIZE": "to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITISE [v SATELLITIZED, SATELLITIZING, SATELLITIZES]\n",
  "SATELLITIZED": "SATELLITIZE, to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITISE [v]\n",
  "SATELLITIZES": "SATELLITIZE, to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITISE [v]\n",
  "SATELLITIZING": "SATELLITIZE, to bring satellite(s) into use in (meteorology, broadcasting, etc.), also SATELLITISE [v]\n",
  "SATEM": "pertaining to a group of Indo-European languages [adj]\n",
  "SATES": "SATE, to satisfy to capacity, also SATIATE [v]\n",
  "SATI": "(Sanskrit) the act of a Hindu widow willingly being cremated on the funeral pyre of her husband, also SUTTEE [n -S]\n",
  "SATIABILITIES": "SATIABILITY, the capacity to be satiated [n]\n",
  "SATIABILITY": "the capacity to be satiated [n SATIABILITIES]\n",
  "SATIABLE": "capable of being satiated [adj SATIABLY]\n",
  "SATIABLY": "SATIABLE, capable of being satiated [adv]\n",
  "SATIATE": "to satisfy to capacity, also SATE [v SATIATED, SATIATING, SATIATES]\n",
  "SATIATED": "SATIATE, to satisfy to capacity, also SATE [v]\n",
  "SATIATES": "SATIATE, to satisfy to capacity, also SATE [v]\n",
  "SATIATING": "SATIATE, to satisfy to capacity, also SATE [v]\n",
  "SATIATION": "the state of being satiated, also SATIETY [n -S]\n",
  "SATIATIONS": "SATIATION, the state of being satiated, also SATIETY [n]\n",
  "SATIETIES": "SATIETY, the state of being satiated [n]\n",
  "SATIETY": "the state of being satiated [n SATIETIES]\n",
  "SATIN": "a closely-woven silk with a lustrous and unbroken surface showing much of the warp [n -S] / to make like satin [v -ED, -ING, -S]\n",
  "SATINED": "SATIN, to make like satin [v]\n",
  "SATINET": "a thin satin, also SATINETTA, SATINETTE [n -S]\n",
  "SATINETS": "SATINET, a thin satin, also SATINETTA, SATINETTE [n]\n",
  "SATINETTA": "a thin satin, also SATINET, SATINETTE [n -S]\n",
  "SATINETTAS": "SATINETTA, a thin satin, also SATINET, SATINETTE [n]\n",
  "SATINETTE": "a thin satin, also SATINET, SATINETTA [n -S]\n",
  "SATINETTES": "SATINETTE, a thin satin, also SATINET, SATINETTA [n]\n",
  "SATINFLOWER": "another name for the greater stitchwort [n -S]\n",
  "SATINFLOWERS": "SATINFLOWER, another name for the greater stitchwort [n]\n",
  "SATING": "SATE, to satisfy to capacity, also SATIATE [v]\n",
  "SATINIER": "SATINY, resembling satin [adj]\n",
  "SATINIEST": "SATINY, resembling satin [adj]\n",
  "SATINING": "SATIN, to make like satin [v]\n",
  "SATINPOD": "a flowering plant, aka honesty [n -S]\n",
  "SATINPODS": "SATINPOD, a flowering plant, aka honesty [n]\n",
  "SATINS": "SATIN, to make like satin [v]\n",
  "SATINWOOD": "a smooth, satiny ornamental wood from India [n -S]\n",
  "SATINWOODS": "SATINWOOD, a smooth, satiny ornamental wood from India [n]\n",
  "SATINY": "resembling satin [adj SATINIER, SATINIEST]\n",
  "SATIRE": "the use of ridicule or scorn to criticise folly or vice [n -S]\n",
  "SATIRES": "SATIRE, the use of ridicule or scorn to criticise folly or vice [n]\n",
  "SATIRIC": "of or like satire, also SATIRICAL [adj SATIRICALLY]\n",
  "SATIRICAL": "of or like satire, also SATIRIC [adj SATIRICALLY]\n",
  "SATIRICALLY": "SATIRICAL, of or like satire, also SATIRIC [adv]\n",
  "SATIRICALNESS": "the state of being satirical [n -ES]\n",
  "SATIRICALNESSES": "SATIRICALNESS, the state of being satirical [n]\n",
  "SATIRISABLE": "capable of being satirised, also SATIRIZABLE [adj]\n",
  "SATIRISATION": "the process of satirising, also SATIRIZATION [n -S]\n",
  "SATIRISATIONS": "SATIRISATION, the process of satirising, also SATIRIZATION [n]\n",
  "SATIRISE": "to subject to satire, also SATIRIZE [v SATIRISED, SATIRISING, SATIRISES]\n",
  "SATIRISED": "SATIRISE, to subject to satire, also SATIRIZE [v]\n",
  "SATIRISER": "one who satirises, also SATIRIST, SATIRIZER [n -S]\n",
  "SATIRISERS": "SATIRISER, one who satirises, also SATIRIST, SATIRIZER [n]\n",
  "SATIRISES": "SATIRISE, to subject to satire, also SATIRIZE [v]\n",
  "SATIRISING": "SATIRISE, to subject to satire, also SATIRIZE [v]\n",
  "SATIRIST": "one who satirizes, also SATIRISER, SATIRIZER [n -S]\n",
  "SATIRISTS": "SATIRIST, one who satirizes, also SATIRISER, SATIRIZER [n]\n",
  "SATIRIZABLE": "capable of being satirized, also SATIRISABLE [adj]\n",
  "SATIRIZATION": "the process of satirizing, also SATIRISATION [n -S]\n",
  "SATIRIZATIONS": "SATIRIZATION, the process of satirizing, also SATIRISATION [n]\n",
  "SATIRIZE": "to subject to satire, also SATIRISE [v SATIRIZED, SATIRIZING, SATIRIZES]\n",
  "SATIRIZED": "SATIRIZE, to subject to satire, also SATIRISE [v]\n",
  "SATIRIZER": "one who satirises, also SATIRISER, SATIRIST [n -S]\n",
  "SATIRIZERS": "SATIRIZER, one who satirises, also SATIRISER, SATIRIST [n]\n",
  "SATIRIZES": "SATIRIZE, to subject to satire, also SATIRISE [v]\n",
  "SATIRIZING": "SATIRIZE, to subject to satire, also SATIRISE [v]\n",
  "SATIS": "SATI, (Sanskrit) the act of a Hindu widow willingly being cremated on the funeral pyre of her husband, also SUTTEE [n]\n",
  "SATISFACTION": "the act of satisfying [n -S]\n",
  "SATISFACTIONS": "SATISFACTION, the act of satisfying [n]\n",
  "SATISFACTORILY": "SATISFACTORY, giving satisfaction [adv]\n",
  "SATISFACTORY": "giving satisfaction [adj SATISFACTORILY]\n",
  "SATISFIABLE": "capable of being satisfied [adj]\n",
  "SATISFICE": "to aim for or achieve that which will suffice [v SATISFICED, SATISFICING, SATISFICES]\n",
  "SATISFICED": "SATISFICE, to aim for or achieve that which will suffice [v]\n",
  "SATISFICER": "one who satisfices [n -S]\n",
  "SATISFICERS": "SATISFICER, one who satisfices [n]\n",
  "SATISFICES": "SATISFICE, to aim for or achieve that which will suffice [v]\n",
  "SATISFICING": "the act of satisfying [n -S]\n",
  "SATISFICINGS": "SATISFICING, the act of satisfying [n]\n",
  "SATISFIED": "SATISFY, to provide fully for [v]\n",
  "SATISFIER": "one who satisfies [n -S]\n",
  "SATISFIERS": "SATISFIER, one who satisfies [n]\n",
  "SATISFIES": "SATISFY, to provide fully for [v]\n",
  "SATISFY": "to provide fully for [v SATISFIED, SATISFYING, SATISFIES]\n",
  "SATISFYING": "SATISFY, to provide fully for [v]\n",
  "SATISFYINGLY": "SATISFYING, SATISFY, to provide fully for [adv]\n",
  "SATIVE": "(obsolete) cultivated [adj]\n",
  "SATNAV": "(colloquial) satellite navigation [n -S]\n",
  "SATNAVS": "SATNAV, (colloquial) satellite navigation [n]\n",
  "SATORI": "(Japanese) a state of sudden enlightenment, sought in Zen Buddhism [n -S]\n",
  "SATORIS": "SATORI, (Japanese) a state of sudden enlightenment, sought in Zen Buddhism [n]\n",
  "SATRAP": "(Greek) a governor of a province in ancient Persia [n -S]\n",
  "SATRAPAL": "of or pertaining to a satrap, or a satrapy [adj]\n",
  "SATRAPIES": "SATRAPY, the territory of a satrap [n]\n",
  "SATRAPS": "SATRAP, (Greek) a governor of a province in ancient Persia [n]\n",
  "SATRAPY": "the territory of a satrap [n SATRAPIES]\n",
  "SATSANG": "(Sanskrit) a sacred gathering in Hinduism [n -S]\n",
  "SATSANGS": "SATSANG, (Sanskrit) a sacred gathering in Hinduism [n]\n",
  "SATSUMA": "(Japanese) a small citrus fruit [n -S]\n",
  "SATSUMAS": "SATSUMA, (Japanese) a small citrus fruit [n]\n",
  "SATURABILITIES": "SATURABILITY, the ability to become saturated [n]\n",
  "SATURABILITY": "the ability to become saturated [n SATURABILITIES]\n",
  "SATURABLE": "capable of being saturated [adj]\n",
  "SATURANT": "a substance used to saturate [n -S]\n",
  "SATURANTS": "SATURANT, a substance used to saturate [n]\n",
  "SATURATE": "to fill completely with something that permeates [v SATURATED, SATURATING, SATURATES]\n",
  "SATURATED": "SATURATE, to fill completely with something that permeates [v]\n",
  "SATURATER": "one who, or that which, saturates, also SATURATOR [n -S]\n",
  "SATURATERS": "SATURATER, one who, or that which, saturates, also SATURATOR [n]\n",
  "SATURATES": "SATURATE, to fill completely with something that permeates [v]\n",
  "SATURATING": "SATURATE, to fill completely with something that permeates [v]\n",
  "SATURATION": "complete infiltration [n -S]\n",
  "SATURATIONS": "SATURATION, complete infiltration [n]\n",
  "SATURATOR": "one who, or that which, saturates, also SATURATER [n -S]\n",
  "SATURATORS": "SATURATOR, one who, or that which, saturates, also SATURATER [n]\n",
  "SATURNALIA": "a wild party or orgy [n -S]\n",
  "SATURNALIAN": "riotously merry [adj SATURNALIANLY]\n",
  "SATURNALIANLY": "SATURNALIAN, riotously merry [adv]\n",
  "SATURNALIAS": "SATURNALIA, a wild party or orgy [n]\n",
  "SATURNIC": "suffering from lead poisoning [adj]\n",
  "SATURNIID": "any of a family of large tropical moths [n -S]\n",
  "SATURNIIDS": "SATURNIID, any of a family of large tropical moths [n]\n",
  "SATURNINE": "cold and steady in mood, of a gloomy or surly disposition, having a sardonic aspect [adj SATURNINELY]\n",
  "SATURNINELY": "SATURNINE, cold and steady in mood, of a gloomy or surly disposition, having a sardonic aspect [adv]\n",
  "SATURNINITIES": "SATURNINITY, the state of being saturnine [n]\n",
  "SATURNINITY": "the state of being saturnine [n SATURNINITIES]\n",
  "SATURNISM": "(archaic) lead poisoning [n -S]\n",
  "SATURNISMS": "SATURNISM, (archaic) lead poisoning [n]\n",
  "SATURNIST": "a person of a dull, grave, gloomy temperament [n -S]\n",
  "SATURNISTS": "SATURNIST, a person of a dull, grave, gloomy temperament [n]\n",
  "SATYAGRAHA": "(Sanskrit) the policy of passive resistance inaugurated by Mohandas Gandhi in 1919 as a method of gaining political and social reforms [n -S]\n",
  "SATYAGRAHAS": "SATYAGRAHA, (Sanskrit) the policy of passive resistance inaugurated by Mohandas Gandhi in 1919 as a method of gaining political and social reforms [n]\n",
  "SATYAGRAHI": "(Sanskrit) an exponent of satyagraha, passive resistance, esp. as a form of political protest [n -S]\n",
  "SATYAGRAHIS": "SATYAGRAHI, (Sanskrit) an exponent of satyagraha, passive resistance, esp. as a form of political protest [n]\n",
  "SATYR": "a Greek god of the woodlands, with a tail and long ears, represented by the Romans as part goat [n -S]\n",
  "SATYRA": "a female satyr, also SATYRESS [n -S]\n",
  "SATYRAL": "a heraldic monster compounded of man, lion and antelope [n -S]\n",
  "SATYRALS": "SATYRAL, a heraldic monster compounded of man, lion and antelope [n]\n",
  "SATYRAS": "SATYRA, a female satyr, also SATYRESS [n]\n",
  "SATYRE": "in phrase sea satyre, a Spenserian sea monster [n -S]\n",
  "SATYRES": "SATYRE, in phrase sea satyre, a Spenserian sea monster [n]\n",
  "SATYRESQUE": "like a satyr [adj]\n",
  "SATYRESS": "a female satyr, also SATYRA [n -ES]\n",
  "SATYRESSES": "SATYRESS, a female satyr, also SATYRA [n]\n",
  "SATYRIASES": "SATYRIASIS, immoderate venereal appetite in the male [n]\n",
  "SATYRIASIS": "immoderate venereal appetite in the male [n SATYRIASES]\n",
  "SATYRIC": "of satyrs; having a chorus of satyrs, also SATYRICAL [adj]\n",
  "SATYRICAL": "of satyrs; having a chorus of satyrs, also SATYRIC [adj]\n",
  "SATYRID": "a brownish butterfly [n -S]\n",
  "SATYRIDS": "SATYRID, a brownish butterfly [n]\n",
  "SATYRISK": "a little satyr [n -S]\n",
  "SATYRISKS": "SATYRISK, a little satyr [n]\n",
  "SATYRLIKE": "like a satyr [adj]\n",
  "SATYRS": "SATYR, a Greek god of the woodlands, with a tail and long ears, represented by the Romans as part goat [n]\n",
  "SAU": "a monetary unit of Vietnam, also XU [n SAU]\n",
  "SAUBA": "(Tupi) a South American leafcutter ant [n -S]\n",
  "SAUBAS": "SAUBA, (Tupi) a South American leafcutter ant [n]\n",
  "SAUCE": "to serve with a liquid dressing [v SAUCED, SAUCING, SAUCES]\n",
  "SAUCEBOAT": "a container from which sauce is poured over food [n -S]\n",
  "SAUCEBOATS": "SAUCEBOAT, a container from which sauce is poured over food [n]\n",
  "SAUCEBOX": "a saucy, impudent person; esp. a pert child, also SAUCEPOT [n -ES]\n",
  "SAUCEBOXES": "SAUCEBOX, a saucy, impudent person; esp. a pert child, also SAUCEPOT [n]\n",
  "SAUCED": "SAUCE, to serve with a liquid dressing [v]\n",
  "SAUCELESS": "without sauce [adj]\n",
  "SAUCEPAN": "a cooking utensil [n -S]\n",
  "SAUCEPANS": "SAUCEPAN, a cooking utensil [n]\n",
  "SAUCEPOT": "a deep cooking pot with two handles [n -S]\n",
  "SAUCEPOTS": "SAUCEPOT, a deep cooking pot with two handles [n]\n",
  "SAUCER": "a small shallow dish [n -S]\n",
  "SAUCERFUL": "the contents of a saucer [n -S]\n",
  "SAUCERFULS": "SAUCERFUL, the contents of a saucer [n]\n",
  "SAUCERLESS": "without a saucer [adj]\n",
  "SAUCERLIKE": "like a saucer [adj]\n",
  "SAUCERS": "SAUCER, a small shallow dish [n]\n",
  "SAUCES": "SAUCE, to serve with a liquid dressing [v]\n",
  "SAUCH": "(Scots) a sallow, a willow tree, also SAUGH [n -S]\n",
  "SAUCHS": "SAUCH, (Scots) a sallow, a willow tree, also SAUGH [n]\n",
  "SAUCIER": "a chef who specializes in sauces [n -S]\n",
  "SAUCIERS": "SAUCIER, a chef who specializes in sauces [n]\n",
  "SAUCIEST": "SAUCY, impertinent [adj]\n",
  "SAUCILY": "SAUCY, impertinent [adv]\n",
  "SAUCINESS": "the state of being saucy [n -ES]\n",
  "SAUCINESSES": "SAUCINESS, the state of being saucy [n]\n",
  "SAUCING": "SAUCE, to serve with a liquid dressing [v]\n",
  "SAUCISSE": "(French) a long canvas tube filled with powder for use as a fuse, e.g. when firing a mine, also SAUCISSON [n -S]\n",
  "SAUCISSES": "SAUCISSE, (French) a long canvas tube filled with powder for use as a fuse, e.g. when firing a mine, also SAUCISSON [n]\n",
  "SAUCISSON": "(French) a long canvas tube filled with powder for use as a fuse, e.g. when firing a mine, also SAUCISSE [n -S]\n",
  "SAUCISSONS": "SAUCISSON, (French) a long canvas tube filled with powder for use as a fuse, e.g. when firing a mine, also SAUCISSE [n]\n",
  "SAUCY": "impertinent [adj SAUCIER, SAUCIEST, SAUCILY]\n",
  "SAUERBRATEN": "(German) a dish of German origin consisting of beef marinaded in vinegar with peppercorns, onions, and other seasonings and then cooked [n -S]\n",
  "SAUERBRATENS": "SAUERBRATEN, (German) a dish of German origin consisting of beef marinaded in vinegar with peppercorns, onions, and other seasonings and then cooked [n]\n",
  "SAUERKRAUT": "(German) cabbage cut fine and allowed to ferment in a brine made of its own juice with salt [n -S]\n",
  "SAUERKRAUTS": "SAUERKRAUT, (German) cabbage cut fine and allowed to ferment in a brine made of its own juice with salt [n]\n",
  "SAUFGARD": "(Spenser) a safeguard, also SAVEGARD [n -S]\n",
  "SAUFGARDS": "SAUFGARD, (Spenser) a safeguard, also SAVEGARD [n]\n",
  "SAUGER": "an American freshwater food fish [n -S]\n",
  "SAUGERS": "SAUGER, an American freshwater food fish [n]\n",
  "SAUGH": "(Scots) a sallow, a willow tree, also SAUCH [n -S]\n",
  "SAUGHS": "SAUGH, (Scots) a sallow, a willow tree, also SAUCH [n]\n",
  "SAUGHY": "full of saughs, willows [adj]\n",
  "SAUL": "(Scots) a soul [n -S]\n",
  "SAULGE": "(Spenser) the plant sage [n -S]\n",
  "SAULGES": "SAULGE, (Spenser) the plant sage [n]\n",
  "SAULIE": "(Scots) a hired mourner at a funeral [n -S]\n",
  "SAULIES": "SAULIE, (Scots) a hired mourner at a funeral [n]\n",
  "SAULS": "SAUL, (Scots) a soul [n]\n",
  "SAULT": "(Canadian) a waterfall or rapid in some rivers; as, the Sault Ste Marie [n -S]\n",
  "SAULTS": "SAULT, (Canadian) a waterfall or rapid in some rivers; as, the Sault Ste Marie [n]\n",
  "SAUNA": "(Finnish) a type of steam bath [n -S] / to take a sauna [v -ED, -ING, -S]\n",
  "SAUNAED": "SAUNA, to take a sauna [v]\n",
  "SAUNAING": "SAUNA, to take a sauna [v]\n",
  "SAUNAS": "SAUNA, to take a sauna [v]\n",
  "SAUNT": "(Scots) a saint [n -S] / to sanctify [v -ED, -ING, -S]\n",
  "SAUNTED": "SAUNT, to sanctify [v]\n",
  "SAUNTER": "to walk in a leisurely manner [v -ED, -ING, -S]\n",
  "SAUNTERED": "SAUNTER, to walk in a leisurely manner [v]\n",
  "SAUNTERER": "one who saunters [n -S]\n",
  "SAUNTERERS": "SAUNTERER, one who saunters [n]\n",
  "SAUNTERING": "walking in a leisurely manner [adj SAUNTERINGLY] / the act of sauntering [n -S]\n",
  "SAUNTERINGLY": "SAUNTERING, walking in a leisurely manner [adv]\n",
  "SAUNTERINGS": "SAUNTERING, the act of sauntering [n]\n",
  "SAUNTERS": "SAUNTER, to walk in a leisurely manner [v]\n",
  "SAUNTING": "SAUNT, to sanctify [v]\n",
  "SAUNTS": "SAUNT, to sanctify [v]\n",
  "SAUREL": "(French) a marine fish, the horse-mackerel or scad [n -S]\n",
  "SAURELS": "SAUREL, (French) a marine fish, the horse-mackerel or scad [n]\n",
  "SAURIAN": "any of a suborder of reptiles [n -S]\n",
  "SAURIANS": "SAURIAN, any of a suborder of reptiles [n]\n",
  "SAURIES": "SAURY, a sharp-beaked fish, like a needlefish [n]\n",
  "SAURISCHIAN": "any dinosaur of the Saurischia [n -S]\n",
  "SAURISCHIANS": "SAURISCHIAN, any dinosaur of the Saurischia [n]\n",
  "SAUROGNATHOUS": "having a lizard-like arrangement of the palate-bones (as e.g. woodpeckers) [adj]\n",
  "SAUROID": "a type of fish [n -S]\n",
  "SAUROIDS": "SAUROID, a type of fish [n]\n",
  "SAUROPOD": "any gigantic herbivorous quadrupedal dinosaur of the suborder Sauropoda [n -S]\n",
  "SAUROPODOUS": "like a sauropod [adj]\n",
  "SAUROPODS": "SAUROPOD, any gigantic herbivorous quadrupedal dinosaur of the suborder Sauropoda [n]\n",
  "SAUROPSIDAN": "a member of the Sauropsida, one of the main divisions of Vertebrata including birds and reptiles [n -S]\n",
  "SAUROPSIDANS": "SAUROPSIDAN, a member of the Sauropsida, one of the main divisions of Vertebrata including birds and reptiles [n]\n",
  "SAUROPTERYGIAN": "any carnivorous Mesozoic marine reptile of the group Sauropterygia, with paddle-like limbs [n -S]\n",
  "SAUROPTERYGIANS": "SAUROPTERYGIAN, any carnivorous Mesozoic marine reptile of the group Sauropterygia, with paddle-like limbs [n]\n",
  "SAURY": "a sharp-beaked fish, like a needlefish [n SAURIES]\n",
  "SAUSAGE": "finely chopped and seasoned meat in a casing [n -S]\n",
  "SAUSAGES": "SAUSAGE, finely chopped and seasoned meat in a casing [n]\n",
  "SAUSSURITE": "a dull opaque mass of zoisite, albite, etc., formed by the alteration of feldspar [n -S]\n",
  "SAUSSURITES": "SAUSSURITE, a dull opaque mass of zoisite, albite, etc., formed by the alteration of feldspar [n]\n",
  "SAUSSURITIC": "of or like saussurite [adj]\n",
  "SAUT": "(Scots) salt [n -S] / to put salt on [v -ED, -ING, -S]\n",
  "SAUTE": "(French) to fry in a small amount of fat [v SAUTED or SAUTEED, SAUTEING or SAUTEEING, SAUTES]\n",
  "SAUTED": "SAUTE, (French) to fry in a small amount of fat [v]\n",
  "SAUTEED": "SAUTE, (French) to fry in a small amount of fat [v]\n",
  "SAUTEEING": "SAUTE, (French) to fry in a small amount of fat [v]\n",
  "SAUTEING": "SAUTE, (French) to fry in a small amount of fat [v]\n",
  "SAUTERNE": "(French) a sweet white wine made in the district of Sauterne, France [n -S]\n",
  "SAUTERNES": "SAUTERNE, (French) a sweet white wine made in the district of Sauterne, France [n]\n",
  "SAUTES": "SAUTE, (French) to fry in a small amount of fat [v]\n",
  "SAUTING": "SAUT, to put salt on [v]\n",
  "SAUTOIR": "(French) a long necklace, or pendant on a long chain, also SAUTOIRE [n -S]\n",
  "SAUTOIRE": "(French) a long necklace, or pendant on a long chain, also SAUTOIR [n -S]\n",
  "SAUTOIRES": "SAUTOIRE, (French) a long necklace, or pendant on a long chain, also SAUTOIR [n]\n",
  "SAUTOIRS": "SAUTOIR, (French) a long necklace, or pendant on a long chain, also SAUTOIRE [n]\n",
  "SAUTS": "SAUT, to put salt on [v]\n",
  "SAV": "(short for) a saveloy, a highly seasoned sausage, also SAVELOY [n -S]\n",
  "SAVABLE": "that can be saved, also SAVEABLE [adj]\n",
  "SAVABLENESS": "the state of being savable [n -ES]\n",
  "SAVABLENESSES": "SAVABLENESS, the state of being savable [n]\n",
  "SAVAGE": "fierce, uncivilized [adj SAVAGER, SAVAGEST, SAVAGELY] / to attack or treat brutally [v SAVAGED, SAVAGING, SAVAGES]\n",
  "SAVAGED": "SAVAGE, to attack or treat brutally [v]\n",
  "SAVAGEDOM": "the state of being savage; savages collectively, also SAVAGISM [n -S]\n",
  "SAVAGEDOMS": "SAVAGEDOM, the state of being savage; savages collectively, also SAVAGISM [n]\n",
  "SAVAGELY": "SAVAGE, fierce, uncivilized [adv]\n",
  "SAVAGENESS": "the state of being savage [n -ES]\n",
  "SAVAGENESSES": "SAVAGENESS, the state of being savage [n]\n",
  "SAVAGER": "SAVAGE, fierce, uncivilized [adj]\n",
  "SAVAGERIES": "SAVAGERY, the quality of being savage, also SAVAGISM [n]\n",
  "SAVAGERY": "the quality of being savage, also SAVAGISM [n SAVAGERIES]\n",
  "SAVAGES": "SAVAGE, to attack or treat brutally [v]\n",
  "SAVAGEST": "SAVAGE, fierce, uncivilized [adj]\n",
  "SAVAGING": "SAVAGE, to attack or treat brutally [v]\n",
  "SAVAGISM": "the state of being savage, also SAVAGEDOM [n -S]\n",
  "SAVAGISMS": "SAVAGISM, the state of being savage, also SAVAGEDOM [n]\n",
  "SAVANNA": "(Spanish) a flat, treeless grassland, also SAVANNAH [n -S]\n",
  "SAVANNAH": "(Spanish) tropical grassland, also SAVANNA [n -S]\n",
  "SAVANNAHS": "SAVANNAH, (Spanish) tropical grassland, also SAVANNA [n]\n",
  "SAVANNAS": "SAVANNA, (Spanish) a flat, treeless grassland, also SAVANNAH [n]\n",
  "SAVANT": "(French) a learned person, esp. a distinguished scientist etc. [n -S]\n",
  "SAVANTE": "(French) a woman of great learning [n -S]\n",
  "SAVANTES": "SAVANTE, (French) a woman of great learning [n]\n",
  "SAVANTS": "SAVANT, (French) a learned person, esp. a distinguished scientist etc. [n]\n",
  "SAVARIN": "(French) a cake made with yeast dough, similar to the baba [n -S]\n",
  "SAVARINS": "SAVARIN, (French) a cake made with yeast dough, similar to the baba [n]\n",
  "SAVASANA": "a meditative posture in which one lies on one's back that is typically considered the final resting pose in yoga, also SHAVASANA [n -S]\n",
  "SAVASANAS": "SAVASANA, a meditative posture in which one lies on one's back that is typically considered the final resting pose in yoga, also SHAVASANA [n]\n",
  "SAVATE": "(French) a French form of kickboxing [n -S]\n",
  "SAVATES": "SAVATE, (French) a French form of kickboxing [n]\n",
  "SAVE": "to rescue from danger, injury or loss [v SAVED, SAVING, SAVES]\n",
  "SAVEABLE": "that can be saved, also SAVABLE [adj]\n",
  "SAVEABLENESS": "the state of being saveable [n -ES]\n",
  "SAVEABLENESSES": "SAVEABLENESS, the state of being saveable [n]\n",
  "SAVED": "SAVE, to rescue from danger, injury or loss [v]\n",
  "SAVEGARD": "(Spenser) to safeguard [v -ED, -ING, -S]\n",
  "SAVEGARDED": "SAVEGARD, (Spenser) to safeguard [v]\n",
  "SAVEGARDING": "SAVEGARD, (Spenser) to safeguard [v]\n",
  "SAVEGARDS": "SAVEGARD, (Spenser) to safeguard [v]\n",
  "SAVELOY": "a highly seasoned sausage, also SAV [n -S]\n",
  "SAVELOYS": "SAVELOY, a highly seasoned sausage, also SAV [n]\n",
  "SAVER": "one that saves [n -S]\n",
  "SAVERS": "SAVER, one that saves [n]\n",
  "SAVES": "SAVE, to rescue from danger, injury or loss [v]\n",
  "SAVEY": "to know, to understand, also SABE, SAVVEY, SAVVY [v -ED, -ING, -S]\n",
  "SAVEYED": "SAVEY, to know, to understand, also SABE, SAVVEY, SAVVY [v]\n",
  "SAVEYING": "SAVEY, to know, to understand, also SABE, SAVVEY, SAVVY [v]\n",
  "SAVEYS": "SAVEY, to know, to understand, also SABE, SAVVEY, SAVVY [v]\n",
  "SAVIN": "a species of juniper, also SABINE, SAVINE [n -S]\n",
  "SAVINE": "a species of juniper, also SAVIN, SABINE [n -S]\n",
  "SAVINES": "SAVINE, a species of juniper, also SAVIN, SABINE [n]\n",
  "SAVING": "money laid aside for future use [n -S]\n",
  "SAVINGLY": "SAVING [adv]\n",
  "SAVINGNESS": "frugality, parsimony [n -ES]\n",
  "SAVINGNESSES": "SAVINGNESS, frugality, parsimony [n]\n",
  "SAVINGS": "SAVING, money laid aside for future use [n]\n",
  "SAVINS": "SAVIN, a species of juniper, also SABINE, SAVINE [n]\n",
  "SAVIOR": "one who saves, also SAVIOUR [n -S]\n",
  "SAVIORS": "SAVIOR, one who saves, also SAVIOUR [n]\n",
  "SAVIOUR": "one who saves, also SAVIOR [n -S]\n",
  "SAVIOURS": "SAVIOUR, one who saves, also SAVIOR [n]\n",
  "SAVOR": "to taste or smell with pleasure, also SAVOUR [v -ED, -ING, -S]\n",
  "SAVORED": "SAVOR, to taste or smell with pleasure, also SAVOUR [v]\n",
  "SAVORER": "one that savors, also SAVOURER [n -S]\n",
  "SAVORERS": "SAVORER, one that savors, also SAVOURER [n]\n",
  "SAVORIER": "SAVORY, (US) savoury [adj]\n",
  "SAVORIES": "SAVORY, a kind of herb [n]\n",
  "SAVORIEST": "SAVORY, (US) savoury [adj]\n",
  "SAVORILY": "SAVORY, (US) savoury [adv]\n",
  "SAVORINESS": "the quality of being savory [n -ES]\n",
  "SAVORINESSES": "SAVORINESS, the quality of being savory [n]\n",
  "SAVORING": "SAVOR, to taste or smell with pleasure, also SAVOUR [v]\n",
  "SAVORLESS": "without savor, also SAVOURLESS [adj]\n",
  "SAVOROUS": "savoury, pleasant to the taste or smell [adj]\n",
  "SAVORS": "SAVOR, to taste or smell with pleasure, also SAVOUR [v]\n",
  "SAVORY": "(US) savoury [adj SAVORIER, SAVORIEST, SAVORILY] / a kind of herb [n SAVORIES]\n",
  "SAVOUR": "to taste or smell with pleasure, also SAVOR [v -ED, -ING, -S]\n",
  "SAVOURED": "SAVOUR, to taste or smell with pleasure, also SAVOR [v]\n",
  "SAVOURER": "one that savors, also SAVORER [n -S]\n",
  "SAVOURERS": "SAVOURER, one that savors, also SAVORER [n]\n",
  "SAVOURIER": "SAVOURY, pleasant to the taste or smell, also SAVORY [adj]\n",
  "SAVOURIES": "SAVOURY, a savory dish served before or after a meal [n]\n",
  "SAVOURIEST": "SAVOURY, pleasant to the taste or smell, also SAVORY [adj]\n",
  "SAVOURILY": "SAVOURY, pleasant to the taste or smell, also SAVORY [adv]\n",
  "SAVOURINESS": "the state of being savoury [n -ES]\n",
  "SAVOURINESSES": "SAVOURINESS, the state of being savoury [n]\n",
  "SAVOURING": "SAVOUR, to taste or smell with pleasure, also SAVOR [v]\n",
  "SAVOURLESS": "without savour, also SAVORLESS [adj]\n",
  "SAVOURLY": "(obsolete) with relish, feelingly [adv]\n",
  "SAVOURS": "SAVOUR, to taste or smell with pleasure, also SAVOR [v]\n",
  "SAVOURY": "pleasant to the taste or smell, also SAVORY [adj SAVOURIER, SAVOURIEST, SAVOURILY] / a savory dish served before or after a meal [n SAVOURIES]\n",
  "SAVOY": "a variety of cabbage [n -S]\n",
  "SAVOYARD": "a devotee of Gilbert and Sullivan operas [n -S]\n",
  "SAVOYARDS": "SAVOYARD, a devotee of Gilbert and Sullivan operas [n]\n",
  "SAVOYS": "SAVOY, a variety of cabbage [n]\n",
  "SAVS": "SAV, (short for) a saveloy, a highly seasoned sausage, also SAVELOY [n]\n",
  "SAVVEY": "(colloquial) to know, to understand, also SABE, SAVEY, SAVVY [v -ED, -ING, -S]\n",
  "SAVVEYED": "SAVVEY, (colloquial) to know, to understand, also SABE, SAVEY, SAVVY [v]\n",
  "SAVVEYING": "SAVVEY, (colloquial) to know, to understand, also SABE, SAVEY, SAVVY [v]\n",
  "SAVVEYS": "SAVVEY, (colloquial) to know, to understand, also SABE, SAVEY, SAVVY [v]\n",
  "SAVVIED": "SAVVY, to understand, also SABE, SAVEY, SAVVEY [v]\n",
  "SAVVIER": "SAVVY, shrewd [adj]\n",
  "SAVVIES": "SAVVY, to understand, also SABE, SAVEY, SAVVEY [v]\n",
  "SAVVIEST": "SAVVY, shrewd [adj]\n",
  "SAVVILY": "SAVVY, shrewd [adv]\n",
  "SAVVINESS": "the quality of being savvy [n -ES]\n",
  "SAVVINESSES": "SAVVINESS, the quality of being savvy [n]\n",
  "SAVVY": "shrewd [adj SAVVIER, SAVVIEST, SAVVILY] / to understand, also SABE, SAVEY, SAVVEY [v SAVVIED, SAVVYING, SAVVIES]\n",
  "SAVVYING": "SAVVY, to understand, also SABE, SAVEY, SAVVEY [v]\n",
  "SAW": "to cut with a jagged-edged tool [v SAWED, SAWN, SAWING, SAWS]\n",
  "SAWAH": "(Malay) an irrigated paddy-field [n -S]\n",
  "SAWAHS": "SAWAH, (Malay) an irrigated paddy-field [n]\n",
  "SAWBILL": "a kind of bird, aka merganser [n -S]\n",
  "SAWBILLS": "SAWBILL, a kind of bird, aka merganser [n]\n",
  "SAWBLADE": "the blade of a saw [n -S]\n",
  "SAWBLADES": "SAWBLADE, the blade of a saw [n]\n",
  "SAWBONES": "(colloquial) a surgeon [n -ES]\n",
  "SAWBONESES": "SAWBONES, (colloquial) a surgeon [n]\n",
  "SAWBUCK": "a rack used as a support for sawing, also SAWHORSE [n -S]\n",
  "SAWBUCKS": "SAWBUCK, a rack used as a support for sawing, also SAWHORSE [n]\n",
  "SAWDER": "to flatter, also SOWDER [v -ED, -ING, -S]\n",
  "SAWDERED": "SAWDER, to flatter, also SOWDER [v]\n",
  "SAWDERING": "SAWDER, to flatter, also SOWDER [v]\n",
  "SAWDERS": "SAWDER, to flatter, also SOWDER [v]\n",
  "SAWDUST": "to sprinkle with the residue produced from sawing wood [v -ED, -ING, -S]\n",
  "SAWDUSTED": "SAWDUST, to sprinkle with the residue produced from sawing wood [v]\n",
  "SAWDUSTIER": "SAWDUSTY, like or full of sawdust [adj]\n",
  "SAWDUSTIEST": "SAWDUSTY, like or full of sawdust [adj]\n",
  "SAWDUSTING": "SAWDUST, to sprinkle with the residue produced from sawing wood [v]\n",
  "SAWDUSTS": "SAWDUST, to sprinkle with the residue produced from sawing wood [v]\n",
  "SAWDUSTY": "like or full of sawdust [adj SAWDUSTIER, SAWDUSTIEST]\n",
  "SAWED": "SAW, to cut with a jagged-edged tool [v]\n",
  "SAWER": "one who saws, also SAWYER [n -S]\n",
  "SAWERS": "SAWER, one who saws, also SAWYER [n]\n",
  "SAWFISH": "any of various cartilaginous fishes having a long flattened snout with toothlike projections along each edge [n -ES]\n",
  "SAWFISHES": "SAWFISH, any of various cartilaginous fishes having a long flattened snout with toothlike projections along each edge [n]\n",
  "SAWFLIES": "SAWFLY, a hymenopterous insect of various kinds [n]\n",
  "SAWFLY": "a hymenopterous insect of various kinds [n SAWFLIES]\n",
  "SAWGRASS": "a sedge with serrated leaves, growing in coastal areas of the southeastern US [n -ES]\n",
  "SAWGRASSES": "SAWGRASS, a sedge with serrated leaves, growing in coastal areas of the southeastern US [n]\n",
  "SAWHORSE": "a rack used as a support for sawing, also SAWBUCK [n -S]\n",
  "SAWHORSES": "SAWHORSE, a rack used as a support for sawing, also SAWBUCK [n]\n",
  "SAWING": "the act of sawing [n -S]\n",
  "SAWINGS": "SAWING, the act of sawing [n]\n",
  "SAWLIKE": "like a saw [adj]\n",
  "SAWLOG": "a log large enough to saw into boards [n -S]\n",
  "SAWLOGS": "SAWLOG, a log large enough to saw into boards [n]\n",
  "SAWMILL": "a place where logs are sawed [n -S]\n",
  "SAWMILLER": "one who operates a sawmill [n -S]\n",
  "SAWMILLERS": "SAWMILLER, one who operates a sawmill [n]\n",
  "SAWMILLS": "SAWMILL, a place where logs are sawed [n]\n",
  "SAWN": "SAW, to cut with a jagged-edged tool [v]\n",
  "SAWNEY": "a foolish person [n -S]\n",
  "SAWNEYS": "SAWNEY, a foolish person [n]\n",
  "SAWPIT": "a pit in which a sawer stands [n -S]\n",
  "SAWPITS": "SAWPIT, a pit in which a sawer stands [n]\n",
  "SAWS": "SAW, to cut with a jagged-edged tool [v]\n",
  "SAWSHARK": "a kind of shark with a long flattened serrated jaw [n -S]\n",
  "SAWSHARKS": "SAWSHARK, a kind of shark with a long flattened serrated jaw [n]\n",
  "SAWTEETH": "SAWTOOTH, one of a set of teeth resembling a saw, as on certain sharks [n]\n",
  "SAWTIMBER": "timber suitable for sawing into lumber [n -S]\n",
  "SAWTIMBERS": "SAWTIMBER, timber suitable for sawing into lumber [n]\n",
  "SAWTOOTH": "one of a set of teeth resembling a saw, as on certain sharks [n SAWTEETH]\n",
  "SAWYER": "one whose occupation is to saw timber, also SAWER [n -S]\n",
  "SAWYERS": "SAWYER, one whose occupation is to saw timber, also SAWER [n]\n",
  "SAX": "a chopper for trimming slate, also ZAX, ZEX [n -ES]\n",
  "SAXATILE": "living or growing among rocks, also SAXICOLE [adj]\n",
  "SAXAUL": "a low, thick, grotesquely contorted tree of the saltbush family found on the steppes of Asia, also SAKSAUL [n -S]\n",
  "SAXAULS": "SAXAUL, a low, thick, grotesquely contorted tree of the saltbush family found on the steppes of Asia, also SAKSAUL [n]\n",
  "SAXE": "as in saxe blue, a light bluish-grey colour [adj]\n",
  "SAXES": "SAX, a chopper for trimming slate, also ZAX, ZEX [n]\n",
  "SAXHORN": "a brass wind instrument [n -S]\n",
  "SAXHORNS": "SAXHORN, a brass wind instrument [n]\n",
  "SAXICAVOUS": "boring into rocks [adj]\n",
  "SAXICOLE": "living or growing among rocks, also SAXATILE [adj]\n",
  "SAXICOLINE": "inhabiting or growing among rocks, also SAXICOLOUS [adj]\n",
  "SAXICOLOUS": "inhabiting or growing among rocks, also SAXICOLINE [adj]\n",
  "SAXIFRAGACEOUS": "belonging to the saxifrage family [adj]\n",
  "SAXIFRAGE": "a kind of rock plant [n -S]\n",
  "SAXIFRAGES": "SAXIFRAGE, a kind of rock plant [n]\n",
  "SAXIST": "a saxophone player [n -S]\n",
  "SAXISTS": "SAXIST, a saxophone player [n]\n",
  "SAXITOXIN": "a nerve poison found in molluscs feeding on dinoflagellates of the genus Gonyaulax [n -S]\n",
  "SAXITOXINS": "SAXITOXIN, a nerve poison found in molluscs feeding on dinoflagellates of the genus Gonyaulax [n]\n",
  "SAXMAN": "a saxophone player [n SAXMEN]\n",
  "SAXMEN": "SAXMAN, a saxophone player [n]\n",
  "SAXONIES": "SAXONY, a fine soft woollen fabric [n]\n",
  "SAXONITE": "an ultrabasic igneous rock consisting of olivine and enstatite [n -S]\n",
  "SAXONITES": "SAXONITE, an ultrabasic igneous rock consisting of olivine and enstatite [n]\n",
  "SAXONY": "a fine soft woollen fabric [n SAXONIES]\n",
  "SAXOPHONE": "a jazz and dance band instrument with a reed, an S-shaped (properly metal) tube, and about twenty finger-keys [n -S]\n",
  "SAXOPHONES": "SAXOPHONE, a jazz and dance band instrument with a reed, an S-shaped (properly metal) tube, and about twenty finger-keys [n]\n",
  "SAXOPHONIC": "of or like a saxophone [adj]\n",
  "SAXOPHONIST": "one who plays the saxophone [n -S]\n",
  "SAXOPHONISTS": "SAXOPHONIST, one who plays the saxophone [n]\n",
  "SAXTUBA": "a bass saxhorn [n -S]\n",
  "SAXTUBAS": "SAXTUBA, a bass saxhorn [n]\n",
  "SAY": "to utter in words, speak [v SAID or (obsolete) SED, SAYING, SAYNE, present sing 2d person SAY, (obsolete) SAIST, SAYEST, or SAYST, 2d person past SAIDST or SAIDEST, 3d person SAYS or (colloquial) SEZ or (obsolete) SAITH]\n",
  "SAYABLE": "a thing that can be said [n -S]\n",
  "SAYABLES": "SAYABLE, a thing that can be said [n]\n",
  "SAYED": "(Arabic) a Muslim claiming descent from Mohammed's grandson, also SAID, SAIYID, SAYID, SAYYID [n -S]\n",
  "SAYEDS": "SAYED, (Arabic) a Muslim claiming descent from Mohammed's grandson, also SAID, SAIYID, SAYID, SAYYID [n]\n",
  "SAYER": "one that says [n -S]\n",
  "SAYERS": "SAYER, one that says [n]\n",
  "SAYEST": "SAY, to utter in words, speak [v]\n",
  "SAYID": "(Arabic) a descendant of Mohammed's daughter Fatima, also SAID, SAIYID, SAYED, SAYYID [n -S]\n",
  "SAYIDS": "SAYID, (Arabic) a descendant of Mohammed's daughter Fatima, also SAID, SAIYID, SAYED, SAYYID [n]\n",
  "SAYING": "a maxim, proverb [n -S]\n",
  "SAYINGS": "SAYING, a maxim, proverb [n]\n",
  "SAYNE": "(Spenser) 3rd pers. pl. of say, also SAINE [v]\n",
  "SAYON": "a jacket [n -S]\n",
  "SAYONARA": "(Japanese) goodbye [n -S]\n",
  "SAYONARAS": "SAYONARA, (Japanese) goodbye [n]\n",
  "SAYONS": "SAYON, a jacket [n]\n",
  "SAYS": "SAY, to utter in words, speak [v]\n",
  "SAYST": "SAY, to utter in words, speak [v]\n",
  "SAYYID": "(Arabic) a descendant of Mohammed's daughter Fatima, also SAID, SAIYID, SAYED, SAYID [n -S]\n",
  "SAYYIDS": "SAYYID, (Arabic) a descendant of Mohammed's daughter Fatima, also SAID, SAIYID, SAYED, SAYID [n]\n",
  "SAZ": "a stringed instrument of the Middle East [n SAZES or SAZZES]\n",
  "SAZERAC": "a cocktail based on pernod and whisky [n -S]\n",
  "SAZERACS": "SAZERAC, a cocktail based on pernod and whisky [n]\n",
  "SAZES": "SAZ, a stringed instrument of the Middle East [n]\n",
  "SAZHEN": "(Russian) a unit of length formerly used in Russia, equal to 7 feet [n -S]\n",
  "SAZHENS": "SAZHEN, (Russian) a unit of length formerly used in Russia, equal to 7 feet [n]\n",
  "SAZZES": "SAZ, a stringed instrument of the Middle East [n]\n",
  "SBIRRI": "SBIRRO, (Italian) an Italian police officer [n]\n",
  "SBIRRO": "(Italian) an Italian police officer [n SBIRRI]\n",
  "SCAB": "to become covered with a crust over a healing wound [v SCABBED, SCABBING, SCABS]\n",
  "SCABBARD": "to sheathe, as a sword [v -ED, -ING, -S]\n",
  "SCABBARDED": "SCABBARD, to sheathe, as a sword [v]\n",
  "SCABBARDING": "SCABBARD, to sheathe, as a sword [v]\n",
  "SCABBARDLESS": "without a scabbard [adj]\n",
  "SCABBARDS": "SCABBARD, to sheathe, as a sword [v]\n",
  "SCABBED": "SCAB, to become covered with a crust over a healing wound [v]\n",
  "SCABBEDNESS": "the state of being scabbed [n -ES]\n",
  "SCABBEDNESSES": "SCABBEDNESS, the state of being scabbed [n]\n",
  "SCABBIER": "SCABBY, covered with scabs [adj]\n",
  "SCABBIEST": "SCABBY, covered with scabs [adj]\n",
  "SCABBILY": "SCABBY, covered with scabs [adv]\n",
  "SCABBINESS": "the state of being scabby [n -ES]\n",
  "SCABBINESSES": "SCABBINESS, the state of being scabby [n]\n",
  "SCABBING": "SCAB, to become covered with a crust over a healing wound [v]\n",
  "SCABBLE": "to shape roughly, also SCAPPLE [v SCABBLED, SCABBLING, SCABBLES]\n",
  "SCABBLED": "SCABBLE, to shape roughly, also SCAPPLE [v]\n",
  "SCABBLES": "SCABBLE, to shape roughly, also SCAPPLE [v]\n",
  "SCABBLING": "SCABBLE, to shape roughly, also SCAPPLE [v]\n",
  "SCABBY": "covered with scabs [adj SCABBIER, SCABBIEST, SCABBILY]\n",
  "SCABERULOUS": "(archaic) somewhat scabrous or rough [adj]\n",
  "SCABIES": "(Latin) a contagious skin infection caused by an itch mite [n SCABIES]\n",
  "SCABIETIC": "relating to scabies, a contagious skin infection caused by an itch mite [adj]\n",
  "SCABIOSA": "(Latin) any of various plants of the genus Scabiosa, also SCABIOUS [n -S]\n",
  "SCABIOSAS": "SCABIOSA, (Latin) any of various plants of the genus Scabiosa, also SCABIOUS [n]\n",
  "SCABIOUS": "any of various plants of the genus Scabiosa, also SCABIOSA [n -ES]\n",
  "SCABIOUSES": "SCABIOUS, any of various plants of the genus Scabiosa, also SCABIOSA [n]\n",
  "SCABLAND": "rocky land with little soil cover [n -S]\n",
  "SCABLANDS": "SCABLAND, rocky land with little soil cover [n]\n",
  "SCABLIKE": "resembling a scab [adj]\n",
  "SCABRID": "roughened with small projections, also SCABROUS [adj]\n",
  "SCABRIDITIES": "SCABRIDITY, (archaic) the state of being scabrid, scabrous [n]\n",
  "SCABRIDITY": "(archaic) the state of being scabrid, scabrous [n SCABRIDITIES]\n",
  "SCABROUS": "roughened with small projections, also SCABRID [adj SCABROUSLY]\n",
  "SCABROUSLY": "SCABROUS, roughened with small projections, also SCABRID [adv]\n",
  "SCABROUSNESS": "the state of being scabrous [n -ES]\n",
  "SCABROUSNESSES": "SCABROUSNESS, the state of being scabrous [n]\n",
  "SCABS": "SCAB, to become covered with a crust over a healing wound [v]\n",
  "SCAD": "a kind of marine fish, aka horse-mackerel or saurel [n -S]\n",
  "SCADS": "SCAD, a kind of marine fish, aka horse-mackerel or saurel [n]\n",
  "SCAFF": "(Scots) to beg or ask for (food) in a mean or rude manner [v -ED, -ING, -S]\n",
  "SCAFFED": "SCAFF, (Scots) to beg or ask for (food) in a mean or rude manner [v]\n",
  "SCAFFIE": "(Scots) a scavenger [n -S]\n",
  "SCAFFIER": "SCAFFY, (Scots) having little value, cheap [adj]\n",
  "SCAFFIES": "SCAFFIE, (Scots) a scavenger [n]\n",
  "SCAFFIEST": "SCAFFY, (Scots) having little value, cheap [adj]\n",
  "SCAFFING": "SCAFF, (Scots) to beg or ask for (food) in a mean or rude manner [v]\n",
  "SCAFFOLAGE": "(Shakespeare) scaffoldage, also SCAFFOLDAGE [n -S]\n",
  "SCAFFOLAGES": "SCAFFOLAGE, (Shakespeare) scaffoldage, also SCAFFOLDAGE [n]\n",
  "SCAFFOLD": "to provide with a temporary platform for workmen [v -ED, -ING, -S]\n",
  "SCAFFOLDAGE": "the gallery of a theatre, also SCAFFOLAGE [n -S]\n",
  "SCAFFOLDAGES": "SCAFFOLDAGE, the gallery of a theatre, also SCAFFOLAGE [n]\n",
  "SCAFFOLDED": "SCAFFOLD, to provide with a temporary platform for workmen [v]\n",
  "SCAFFOLDER": "one who erects scaffolding [n -S]\n",
  "SCAFFOLDERS": "SCAFFOLDER, one who erects scaffolding [n]\n",
  "SCAFFOLDING": "a framework of platforms for painters [n -S]\n",
  "SCAFFOLDINGS": "SCAFFOLDING, a framework of platforms for painters [n]\n",
  "SCAFFOLDS": "SCAFFOLD, to provide with a temporary platform for workmen [v]\n",
  "SCAFFS": "SCAFF, (Scots) to beg or ask for (food) in a mean or rude manner [v]\n",
  "SCAFFY": "(Scots) having little value, cheap [adj SCAFFIER, SCAFFIEST] / a light fishing boat [n SCAFFIES]\n",
  "SCAG": "to make a tear in cloth [v SCAGGED, SCAGGING, SCAGS]\n",
  "SCAGGED": "SCAG, to make a tear in cloth [v]\n",
  "SCAGGING": "SCAG, to make a tear in cloth [v]\n",
  "SCAGLIA": "(Italian) a reddish variety of limestone [n -S]\n",
  "SCAGLIAS": "SCAGLIA, (Italian) a reddish variety of limestone [n]\n",
  "SCAGLIOLA": "(Italian) a polished imitation marble consisting of ground gypsum bound with glue [n -S]\n",
  "SCAGLIOLAS": "SCAGLIOLA, (Italian) a polished imitation marble consisting of ground gypsum bound with glue [n]\n",
  "SCAGS": "SCAG, to make a tear in cloth [v]\n",
  "SCAIL": "(Scots) to scatter, disperse, also SKAIL [v -ED, -ING, -S]\n",
  "SCAILED": "SCAIL, (Scots) to scatter, disperse, also SKAIL [v]\n",
  "SCAILING": "SCAIL, (Scots) to scatter, disperse, also SKAIL [v]\n",
  "SCAILS": "SCAIL, (Scots) to scatter, disperse, also SKAIL [v]\n",
  "SCAITH": "(Old Norse) to injure, also SCATH, SCATHE, SKAITH [v -ED, -ING, -S]\n",
  "SCAITHED": "SCAITH, (Old Norse) to injure, also SCATH, SCATHE, SKAITH [v]\n",
  "SCAITHING": "SCAITH, (Old Norse) to injure, also SCATH, SCATHE, SKAITH [v]\n",
  "SCAITHLESS": "(Scots) without injury, scatheless, also SCATHELESS, SKAITHLESS [adj]\n",
  "SCAITHS": "SCAITH, (Old Norse) to injure, also SCATH, SCATHE, SKAITH [v]\n",
  "SCALA": "(Latin) a machine formerly employed for reducing dislocations of the humerus [n SCALAE]\n",
  "SCALABILITIES": "SCALABILITY, the ability to be scaled [n]\n",
  "SCALABILITY": "the ability to be scaled [n SCALABILITIES]\n",
  "SCALABLE": "that can be scaled, also SCALEABLE [adj SCALABLY]\n",
  "SCALABLENESS": "the state of being scalable [n -ES]\n",
  "SCALABLENESSES": "SCALABLENESS, the state of being scalable [n]\n",
  "SCALABLY": "SCALABLE, that can be scaled, also SCALEABLE [adv]\n",
  "SCALADE": "the scaling of walls of a fortress by ladders, also ESCALADE, ESCALADO, SCALADO [n -S]\n",
  "SCALADES": "SCALADE, the scaling of walls of a fortress by ladders, also ESCALADE, ESCALADO, SCALADO [n]\n",
  "SCALADO": "(Italian) the scaling of the walls of a fortress by ladders, also ESCALADE, ESCALADO, SCALADE [n -S]\n",
  "SCALADOS": "SCALADO, (Italian) the scaling of the walls of a fortress by ladders, also ESCALADE, ESCALADO, SCALADE [n]\n",
  "SCALAE": "SCALA, (Latin) a machine formerly employed for reducing dislocations of the humerus [n]\n",
  "SCALAGE": "a percentage deduction for shrinkage [n -S]\n",
  "SCALAGES": "SCALAGE, a percentage deduction for shrinkage [n]\n",
  "SCALAR": "a mathematical quantity possessing only magnitude [n -S]\n",
  "SCALARE": "(Latin) a kind of tropical fish [n -S]\n",
  "SCALARES": "SCALARE, (Latin) a kind of tropical fish [n]\n",
  "SCALARIFORM": "shaped like a ladder [adj SCALARIFORMLY]\n",
  "SCALARIFORMLY": "SCALARIFORM, shaped like a ladder [adv]\n",
  "SCALARS": "SCALAR, a mathematical quantity possessing only magnitude [n]\n",
  "SCALATION": "the way that scales are arranged [n -S]\n",
  "SCALATIONS": "SCALATION, the way that scales are arranged [n]\n",
  "SCALAWAG": "a good-for-nothing, a rascal; in US history, a white Southerner who acted in support of the Reconstruction after the Civil War, also SCALLAWAG, SCALLYWAG [n -S]\n",
  "SCALAWAGS": "SCALAWAG, a good-for-nothing, a rascal; in US history, a white Southerner who acted in support of the Reconstruction after the Civil War, also SCALLAWAG, SCALLYWAG [n]\n",
  "SCALD": "to burn with hot liquid or steam, also SCAUD [v -ED, -ING, -S]\n",
  "SCALDBERRIES": "SCALDBERRY, the blackberry (from a belief that it causes scaldhead) [n]\n",
  "SCALDBERRY": "the blackberry (from a belief that it causes scaldhead) [n SCALDBERRIES]\n",
  "SCALDED": "SCALD, to burn with hot liquid or steam, also SCAUD [v]\n",
  "SCALDER": "that which scalds [n -S]\n",
  "SCALDERS": "SCALDER, that which scalds [n]\n",
  "SCALDFISH": "a European flounder [n -ES]\n",
  "SCALDFISHES": "SCALDFISH, a European flounder [n]\n",
  "SCALDHEAD": "a disease scalp; a scalp disease [n -S]\n",
  "SCALDHEADS": "SCALDHEAD, a disease scalp; a scalp disease [n]\n",
  "SCALDIC": "pertaining to an ancient Scandinavian poet, also SKALDIC [adj]\n",
  "SCALDING": "the act of scalding [n -S]\n",
  "SCALDINGS": "SCALDING, the act of scalding [n]\n",
  "SCALDINI": "SCALDINO, (Italian) an Italian brazier [n]\n",
  "SCALDINO": "(Italian) an Italian brazier [n SCALDINI]\n",
  "SCALDS": "SCALD, to burn with hot liquid or steam, also SCAUD [v]\n",
  "SCALDSHIP": "the office of scald, an ancient Scandinavian bard, also SKALDSHIP [n -S]\n",
  "SCALDSHIPS": "SCALDSHIP, the office of scald, an ancient Scandinavian bard, also SKALDSHIP [n]\n",
  "SCALE": "to climb up or over [v SCALED, SCALING, SCALES]\n",
  "SCALEABLE": "that can be scaled, also SCALABLE [adj SCALEABLY]\n",
  "SCALEABLY": "SCALEABLE, that can be scaled, also SCALABLE [adv]\n",
  "SCALEBOARD": "a very thin piece of board, used for backing a picture, as a veneer, etc. [n -S]\n",
  "SCALEBOARDS": "SCALEBOARD, a very thin piece of board, used for backing a picture, as a veneer, etc. [n]\n",
  "SCALED": "SCALE, to climb up or over [v]\n",
  "SCALELESS": "destitute of scales [adj]\n",
  "SCALELIKE": "like a scale [adj]\n",
  "SCALENE": "one of the paired muscles of the neck, also SCALENUS [n -S]\n",
  "SCALENES": "SCALENE, one of the paired muscles of the neck, also SCALENUS [n]\n",
  "SCALENI": "SCALENUS, (Latin) a muscle in the neck, also SCALENE [n]\n",
  "SCALENOHEDRA": "SCALENOHEDRON, a hemihedral form bounded in the hexagonal system by twelve, in the tetragonal by eight, faces, each a scalene triangle [n]\n",
  "SCALENOHEDRON": "a hemihedral form bounded in the hexagonal system by twelve, in the tetragonal by eight, faces, each a scalene triangle [n SCALENOHEDRA or SCALENOHEDRONS]\n",
  "SCALENOHEDRONS": "SCALENOHEDRON, a hemihedral form bounded in the hexagonal system by twelve, in the tetragonal by eight, faces, each a scalene triangle [n]\n",
  "SCALENUS": "(Latin) a muscle in the neck, also SCALENE [n SCALENI]\n",
  "SCALEPAN": "a pan on a weighing scale [n -S]\n",
  "SCALEPANS": "SCALEPAN, a pan on a weighing scale [n]\n",
  "SCALER": "a person or thing that scales [n -S]\n",
  "SCALERS": "SCALER, a person or thing that scales [n]\n",
  "SCALES": "SCALE, to climb up or over [v]\n",
  "SCALETAIL": "a type of squirrel [n -S]\n",
  "SCALETAILS": "SCALETAIL, a type of squirrel [n]\n",
  "SCALEUP": "an increase based on a fixed ratio [n -S]\n",
  "SCALEUPS": "SCALEUP, an increase based on a fixed ratio [n]\n",
  "SCALEWORK": "imbricated ornament [n -S]\n",
  "SCALEWORKS": "SCALEWORK, imbricated ornament [n]\n",
  "SCALIER": "SCALY, peeling off in flakes [adj]\n",
  "SCALIEST": "SCALY, peeling off in flakes [adj]\n",
  "SCALINESS": "the state of being scaly [n -ES]\n",
  "SCALINESSES": "SCALINESS, the state of being scaly [n]\n",
  "SCALING": "climbing [n -S]\n",
  "SCALINGS": "SCALING, climbing [n]\n",
  "SCALL": "(obsolete) scabbiness, esp. of the scalp [n -S]\n",
  "SCALLAWAG": "a good-for-nothing, a rascal, also SCALAWAG, SCALLYWAG [n -S]\n",
  "SCALLAWAGS": "SCALLAWAG, a good-for-nothing, a rascal, also SCALAWAG, SCALLYWAG [n]\n",
  "SCALLED": "having scabs [adj]\n",
  "SCALLIES": "SCALLY, a scallywag or rogue [n]\n",
  "SCALLION": "an onion-like plant [n -S]\n",
  "SCALLIONS": "SCALLION, an onion-like plant [n]\n",
  "SCALLOP": "a kind of shell [n -S] / to indent like a scallop, also ESCALLOP, SCOLLOP [v -ED, -ING, -S]\n",
  "SCALLOPED": "SCALLOP, to indent like a scallop, also ESCALLOP, SCOLLOP [v]\n",
  "SCALLOPER": "one who fishes for scallops [n -S]\n",
  "SCALLOPERS": "SCALLOPER, one who fishes for scallops [n]\n",
  "SCALLOPING": "the act of scalloping [n -S]\n",
  "SCALLOPINGS": "SCALLOPING, the act of scalloping [n]\n",
  "SCALLOPINI": "(Italian) thin slices of meat coated with flour and fried [n -S]\n",
  "SCALLOPINIS": "SCALLOPINI, (Italian) thin slices of meat coated with flour and fried [n]\n",
  "SCALLOPS": "SCALLOP, to indent like a scallop, also ESCALLOP, SCOLLOP [v]\n",
  "SCALLS": "SCALL, (obsolete) scabbiness, esp. of the scalp [n]\n",
  "SCALLY": "a scallywag or rogue [n SCALLIES]\n",
  "SCALLYWAG": "a good-for-nothing, a rascal, also SCALAWAG, SCALLAWAG [n -S]\n",
  "SCALLYWAGS": "SCALLYWAG, a good-for-nothing, a rascal, also SCALAWAG, SCALLAWAG [n]\n",
  "SCALOGRAM": "an arrangement of items, as problems in a test or features of speech, such that the presence or accomplishment at one level implies the presence or ability to accomplish all lower levels [n -S]\n",
  "SCALOGRAMS": "SCALOGRAM, an arrangement of items, as problems in a test or features of speech, such that the presence or accomplishment at one level implies the presence or ability to accomplish all lower levels [n]\n",
  "SCALOPPINE": "(Italian) thin slices of meat coated with flour and fried, also SCALOPPINI [n -S]\n",
  "SCALOPPINES": "SCALOPPINE, (Italian) thin slices of meat coated with flour and fried, also SCALOPPINI [n]\n",
  "SCALOPPINI": "(Italian) thin slices of meat coated with flour and fried, also SCALOPPINE [n]\n",
  "SCALP": "to remove the covering from the top of the skull [v -ED, -ING, -S]\n",
  "SCALPED": "SCALP, to remove the covering from the top of the skull [v]\n",
  "SCALPEL": "a small surgical knife [n -S]\n",
  "SCALPELLIC": "of or like a scalpel [adj]\n",
  "SCALPELLIFORM": "shaped like a scalpel [adj]\n",
  "SCALPELS": "SCALPEL, a small surgical knife [n]\n",
  "SCALPER": "a semicircular gouging chisel, also SCAUPER, SCORPER [n -S]\n",
  "SCALPERS": "SCALPER, a semicircular gouging chisel, also SCAUPER, SCORPER [n]\n",
  "SCALPING": "the act of scalping [n -S]\n",
  "SCALPINGS": "SCALPING, the act of scalping [n]\n",
  "SCALPINS": "small drainage stones [n]\n",
  "SCALPLESS": "without a scalp [adj]\n",
  "SCALPRIFORM": "shaped like a chisel [adj]\n",
  "SCALPRUM": "(Latin) a surgeon's rasping instrument [n -S]\n",
  "SCALPRUMS": "SCALPRUM, (Latin) a surgeon's rasping instrument [n]\n",
  "SCALPS": "SCALP, to remove the covering from the top of the skull [v]\n",
  "SCALY": "peeling off in flakes [adj SCALIER, SCALIEST]\n",
  "SCAM": "to cheat or swindle [v SCAMMED, SCAMMING, SCAMS]\n",
  "SCAMBAITING": "the practice of pretending to fall for online scams in order to waste the time of the perpetrators [n -S]\n",
  "SCAMBAITINGS": "SCAMBAITING, the practice of pretending to fall for online scams in order to waste the time of the perpetrators [n]\n",
  "SCAMBLE": "to move awkwardly; to shamble [v SCAMBLED, SCAMBLING, SCAMBLES]\n",
  "SCAMBLED": "SCAMBLE, to move awkwardly; to shamble [v]\n",
  "SCAMBLER": "(Scots) one who scrounges meals [n -S]\n",
  "SCAMBLERS": "SCAMBLER, (Scots) one who scrounges meals [n]\n",
  "SCAMBLES": "SCAMBLE, to move awkwardly; to shamble [v]\n",
  "SCAMBLING": "a haphazard meal [n -S]\n",
  "SCAMBLINGLY": "strugglingly [adv]\n",
  "SCAMBLINGS": "SCAMBLING, a haphazard meal [n]\n",
  "SCAMEL": "(Shakespeare) alleged to be a Norfolk name for the bar-tailed godwit; or a misprint for staniel or stannel [n -S]\n",
  "SCAMELS": "SCAMEL, (Shakespeare) alleged to be a Norfolk name for the bar-tailed godwit; or a misprint for staniel or stannel [n]\n",
  "SCAMMED": "SCAM, to cheat or swindle [v]\n",
  "SCAMMER": "one who perpetrates scams, also SCAMSTER [n -S]\n",
  "SCAMMERS": "SCAMMER, one who perpetrates scams, also SCAMSTER [n]\n",
  "SCAMMING": "SCAM, to cheat or swindle [v]\n",
  "SCAMMONIATE": "of or like scammony, a species of bindweed or convolvulus [adj]\n",
  "SCAMMONIES": "SCAMMONY, (Greek) a climbing plant [n]\n",
  "SCAMMONY": "(Greek) a climbing plant [n SCAMMONIES]\n",
  "SCAMP": "to perform carelessly [v -ED, -ING, -S]\n",
  "SCAMPED": "SCAMP, to perform carelessly [v]\n",
  "SCAMPER": "to run playfully about [v -ED, -ING, -S]\n",
  "SCAMPERED": "SCAMPER, to run playfully about [v]\n",
  "SCAMPERER": "one who scampers [n -S]\n",
  "SCAMPERERS": "SCAMPERER, one who scampers [n]\n",
  "SCAMPERING": "running playfully about [n -S]\n",
  "SCAMPERINGS": "SCAMPERING, running playfully about [n]\n",
  "SCAMPERS": "SCAMPER, to run playfully about [v]\n",
  "SCAMPI": "(Italian) crustaceans of the genus Nephrops, often fried in breadcrumbs [n SCAMPIS or SCAMPIES]\n",
  "SCAMPIES": "SCAMPI, (Italian) crustaceans of the genus Nephrops, often fried in breadcrumbs [n]\n",
  "SCAMPING": "work done without thoroughness [n -S]\n",
  "SCAMPINGS": "SCAMPING, work done without thoroughness [n]\n",
  "SCAMPIS": "SCAMPI, (Italian) crustaceans of the genus Nephrops, often fried in breadcrumbs [n]\n",
  "SCAMPISH": "of or like a scamp [adj SCAMPISHLY]\n",
  "SCAMPISHLY": "SCAMPISH, of or like a scamp [adv]\n",
  "SCAMPISHNESS": "the state of being scampish [n -ES]\n",
  "SCAMPISHNESSES": "SCAMPISHNESS, the state of being scampish [n]\n",
  "SCAMPS": "SCAMP, to perform carelessly [v]\n",
  "SCAMS": "SCAM, to cheat or swindle [v]\n",
  "SCAMSTER": "one who perpetrates scams, also SCAMMER [n -S]\n",
  "SCAMSTERS": "SCAMSTER, one who perpetrates scams, also SCAMMER [n]\n",
  "SCAMTO": "(South African) the argot of urban South African blacks [n -S]\n",
  "SCAMTOS": "SCAMTO, (South African) the argot of urban South African blacks [n]\n",
  "SCAN": "to examine closely [v SCANNED or (archaic) SCAND, SCANNING, SCANS]\n",
  "SCAND": "SCAN, to examine closely [v]\n",
  "SCANDAL": "to defame [v SCANDALED or SCANDALLED, SCANDALING or SCANDALLING, SCANDALS]\n",
  "SCANDALED": "SCANDAL, to defame [v]\n",
  "SCANDALING": "SCANDAL, to defame [v]\n",
  "SCANDALISATION": "the process of scandalising, also SCANDALIZATION [n -S]\n",
  "SCANDALISATIONS": "SCANDALISATION, the process of scandalising, also SCANDALIZATION [n]\n",
  "SCANDALISE": "to offend the moral sense of, also SCANDALIZE [v SCANDALISED, SCANDALISING, SCANDALISES]\n",
  "SCANDALISED": "SCANDALISE, to offend the moral sense of, also SCANDALIZE [v]\n",
  "SCANDALISER": "one who scandalises, also SCANDALIZER [n -S]\n",
  "SCANDALISERS": "SCANDALISER, one who scandalises, also SCANDALIZER [n]\n",
  "SCANDALISES": "SCANDALISE, to offend the moral sense of, also SCANDALIZE [v]\n",
  "SCANDALISING": "SCANDALISE, to offend the moral sense of, also SCANDALIZE [v]\n",
  "SCANDALIZATION": "the process of scandalizing, also SCANDALISATION [n -S]\n",
  "SCANDALIZATIONS": "SCANDALIZATION, the process of scandalizing, also SCANDALISATION [n]\n",
  "SCANDALIZE": "to offend the moral sense of, also SCANDALISE [v SCANDALIZED, SCANDALIZING, SCANDALIZES]\n",
  "SCANDALIZED": "SCANDALIZE, to offend the moral sense of, also SCANDALISE [v]\n",
  "SCANDALIZER": "one who scandalizes, also SCANDALISER [n -S]\n",
  "SCANDALIZERS": "SCANDALIZER, one who scandalizes, also SCANDALISER [n]\n",
  "SCANDALIZES": "SCANDALIZE, to offend the moral sense of, also SCANDALISE [v]\n",
  "SCANDALIZING": "SCANDALIZE, to offend the moral sense of, also SCANDALISE [v]\n",
  "SCANDALLED": "SCANDAL, to defame [v]\n",
  "SCANDALLING": "SCANDAL, to defame [v]\n",
  "SCANDALMONGER": "one who spreads scandal [n -S]\n",
  "SCANDALMONGERS": "SCANDALMONGER, one who spreads scandal [n]\n",
  "SCANDALOUS": "of the nature of a scandal [adj SCANDALOUSLY]\n",
  "SCANDALOUSLY": "SCANDALOUS, of the nature of a scandal [adv]\n",
  "SCANDALOUSNESS": "the state of being scandalous [n]\n",
  "SCANDALS": "SCANDAL, to defame [v]\n",
  "SCANDENT": "climbing as a plant [adj]\n",
  "SCANDIA": "an oxide of scandium [n -S]\n",
  "SCANDIAS": "SCANDIA, an oxide of scandium [n]\n",
  "SCANDIC": "of or pertaining to the element scandium [adj]\n",
  "SCANDIUM": "a rare metallic element of the boron group [n -S]\n",
  "SCANDIUMS": "SCANDIUM, a rare metallic element of the boron group [n]\n",
  "SCANNABLE": "that can be scanned [adj]\n",
  "SCANNED": "SCAN, to examine closely [v]\n",
  "SCANNER": "a device for scanning documents [n -S]\n",
  "SCANNERS": "SCANNER, a device for scanning documents [n]\n",
  "SCANNING": "close examination [n -S]\n",
  "SCANNINGS": "SCANNING, close examination [n]\n",
  "SCANS": "SCAN, to examine closely [v]\n",
  "SCANSION": "the mode of analysing the metrical patterns of verse [n -S]\n",
  "SCANSIONS": "SCANSION, the mode of analysing the metrical patterns of verse [n]\n",
  "SCANSORIAL": "climbing; adapted for climbing [adj]\n",
  "SCANT": "scarce [adj SCANTER, SCANTEST, SCANTLY] / to cut short, to spare [v -ED, -ING, -S]\n",
  "SCANTED": "SCANT, to cut short, to spare [v]\n",
  "SCANTER": "SCANT, scarce [adj]\n",
  "SCANTEST": "SCANT, scarce [adj]\n",
  "SCANTIER": "SCANTY, poorly supplied [adj]\n",
  "SCANTIES": "brief panties for women [n]\n",
  "SCANTIEST": "SCANTY, poorly supplied [adj]\n",
  "SCANTILY": "SCANTY, poorly supplied [adv]\n",
  "SCANTINESS": "the state of being scanty [n -ES]\n",
  "SCANTINESSES": "SCANTINESS, the state of being scanty [n]\n",
  "SCANTING": "SCANT, to cut short, to spare [v]\n",
  "SCANTITIES": "SCANTITY, scantness [n]\n",
  "SCANTITY": "scantness [n SCANTITIES]\n",
  "SCANTLE": "to stint, make scant [v SCANTLED, SCANTLING, SCANTLES]\n",
  "SCANTLED": "SCANTLE, to stint, make scant [v]\n",
  "SCANTLES": "SCANTLE, to stint, make scant [v]\n",
  "SCANTLING": "a small portion [n -S]\n",
  "SCANTLINGS": "SCANTLING, a small portion [n]\n",
  "SCANTLY": "SCANT, scarce [adv]\n",
  "SCANTNESS": "the state of being scant [n -ES]\n",
  "SCANTNESSES": "SCANTNESS, the state of being scant [n]\n",
  "SCANTS": "SCANT, to cut short, to spare [v]\n",
  "SCANTY": "poorly supplied [adj SCANTIER, SCANTIEST, SCANTILY]\n",
  "SCAPA": "to run away, leave without notice, also SCARPA, SCARPER [v -ED, -ING, -S]\n",
  "SCAPAED": "SCAPA, to run away, leave without notice, also SCARPA, SCARPER [v]\n",
  "SCAPAING": "SCAPA, to run away, leave without notice, also SCARPA, SCARPER [v]\n",
  "SCAPAS": "SCAPA, to run away, leave without notice, also SCARPA, SCARPER [v]\n",
  "SCAPE": "to escape [v SCAPED, SCAPING, SCAPES]\n",
  "SCAPED": "SCAPE, to escape [v]\n",
  "SCAPEGALLOWS": "a person who deserves hanging [n -ES]\n",
  "SCAPEGALLOWSES": "SCAPEGALLOWS, a person who deserves hanging [n]\n",
  "SCAPEGOAT": "a goat upon whose head are symbolically placed the sins of the people after which he is sent into the wilderness in the biblical ceremony for Yom Kippur [n -S] / to make a scapegoat of [v -ED, -ING, -S]\n",
  "SCAPEGOATED": "SCAPEGOAT, to make a scapegoat of [v]\n",
  "SCAPEGOATING": "the act of making a scapegoat of [n -S]\n",
  "SCAPEGOATINGS": "SCAPEGOATING, the act of making a scapegoat of [n]\n",
  "SCAPEGOATISM": "the act of making scapegoats [n -S]\n",
  "SCAPEGOATISMS": "SCAPEGOATISM, the act of making scapegoats [n]\n",
  "SCAPEGOATS": "SCAPEGOAT, to make a scapegoat of [v]\n",
  "SCAPEGRACE": "an incorrigible rascal [n -S]\n",
  "SCAPEGRACES": "SCAPEGRACE, an incorrigible rascal [n]\n",
  "SCAPELESS": "not to be escaped [adj]\n",
  "SCAPEMENT": "a part of a clock or watch connecting the wheelwork with the pendulum or balance, and allowing a tooth to escape at each vibration, also ESCAPEMENT [n -S]\n",
  "SCAPEMENTS": "SCAPEMENT, a part of a clock or watch connecting the wheelwork with the pendulum or balance, and allowing a tooth to escape at each vibration, also ESCAPEMENT [n]\n",
  "SCAPES": "SCAPE, to escape [v]\n",
  "SCAPEWHEEL": "an escape wheel [n -S]\n",
  "SCAPEWHEELS": "SCAPEWHEEL, an escape wheel [n]\n",
  "SCAPHOCEPHALI": "SCAPHOCEPHALUS, an abnormally long and narrow boat-shaped skull [n]\n",
  "SCAPHOCEPHALIC": "someone having an abnormally long narrow skull [n -S]\n",
  "SCAPHOCEPHALICS": "SCAPHOCEPHALIC, someone having an abnormally long narrow skull [n]\n",
  "SCAPHOCEPHALIES": "SCAPHOCEPHALY, having an abnormally long and narrow boat-shaped skull [n]\n",
  "SCAPHOCEPHALISM": "the state of being scaphocephalic, having an abnormally long and narrow boat-shaped skull [n]\n",
  "SCAPHOCEPHALOUS": "having an abnormally long and narrow boat-shaped skull [adj]\n",
  "SCAPHOCEPHALUS": "an abnormally long and narrow boat-shaped skull [n SCAPHOCEPHALI]\n",
  "SCAPHOCEPHALY": "having an abnormally long and narrow boat-shaped skull [n SCAPHOCEPHALIES]\n",
  "SCAPHOID": "a boat-shaped bone in the wrist [n -S]\n",
  "SCAPHOIDS": "SCAPHOID, a boat-shaped bone in the wrist [n]\n",
  "SCAPHOPOD": "a member of a class of marine molluscs [n -S]\n",
  "SCAPHOPODS": "SCAPHOPOD, a member of a class of marine molluscs [n]\n",
  "SCAPI": "SCAPUS, (Latin) the shaft of a column or feather [n]\n",
  "SCAPIGEROUS": "having a scape [adj]\n",
  "SCAPING": "SCAPE, to escape [v]\n",
  "SCAPOLITE": "any of a group of rare minerals, silicates of aluminium, calcium, and sodium with some chlorine, aka wernerite [n -S]\n",
  "SCAPOLITES": "SCAPOLITE, any of a group of rare minerals, silicates of aluminium, calcium, and sodium with some chlorine, aka wernerite [n]\n",
  "SCAPOSE": "bearing a leafless stalk [adj]\n",
  "SCAPPLE": "to work stone smoothly, without smoothing to a finish, also SCABBLE [v SCAPPLED, SCAPPLING, SCAPPLES]\n",
  "SCAPPLED": "SCAPPLE, to work stone smoothly, without smoothing to a finish, also SCABBLE [v]\n",
  "SCAPPLES": "SCAPPLE, to work stone smoothly, without smoothing to a finish, also SCABBLE [v]\n",
  "SCAPPLING": "SCAPPLE, to work stone smoothly, without smoothing to a finish, also SCABBLE [v]\n",
  "SCAPULA": "(Latin) a bone in the shoulder [n SCAPULAS or SCAPULAE]\n",
  "SCAPULAE": "SCAPULA, (Latin) a bone in the shoulder [n]\n",
  "SCAPULAR": "a loose sleeveless vestment falling in front and behind, worn by certain religious orders, also SCAPULARY [n -S]\n",
  "SCAPULARIES": "SCAPULARY, a loose sleeveless vestment falling in front and behind, worn by certain religious orders, also SCAPULAR [n]\n",
  "SCAPULARS": "SCAPULAR, a loose sleeveless vestment falling in front and behind, worn by certain religious orders, also SCAPULARY [n]\n",
  "SCAPULARY": "a loose sleeveless vestment falling in front and behind, worn by certain religious orders, also SCAPULAR [n SCAPULARIES]\n",
  "SCAPULAS": "SCAPULA, (Latin) a bone in the shoulder [n]\n",
  "SCAPULATED": "with noticeable scapular feathers [adj]\n",
  "SCAPULIMANCIES": "SCAPULIMANCY, divination involving a shoulder blade which has been charred or cracked from a fire, also SCAPULOMANCY [n]\n",
  "SCAPULIMANCY": "divination involving a shoulder blade which has been charred or cracked from a fire, also SCAPULOMANCY [n SCAPULIMANCIES]\n",
  "SCAPULIMANTIC": "related to scapulimancy, divination involving a shoulder blade which has been charred or cracked from a fire [adj]\n",
  "SCAPULOMANCIES": "SCAPULOMANCY, divination involving a shoulder blade which has been charred or cracked from a fire, also SCAPULIMANCY [n]\n",
  "SCAPULOMANCY": "divination involving a shoulder blade which has been charred or cracked from a fire, also SCAPULIMANCY [n SCAPULOMANCIES]\n",
  "SCAPULOMANTIC": "related to scapulomancy, divination involving a shoulder blade which has been charred or cracked from a fire [adj]\n",
  "SCAPUS": "(Latin) the shaft of a column or feather [n SCAPI]\n",
  "SCAR": "to leave a mark of injured tissue [v SCARRED, SCARRING, SCARS]\n",
  "SCARAB": "any scarabaeid beetle, esp. Scarabaeus sacer, regarded by the ancient Egyptians as divine, also SCARABAEID, SCARABEE, SCARABOID [n -S]\n",
  "SCARABAEAN": "a lamellicorn beetle [n -S]\n",
  "SCARABAEANS": "SCARABAEAN, a lamellicorn beetle [n]\n",
  "SCARABAEI": "SCARABAEUS, a beetle of the Scarabaeus genus of lamellicorn beetles [n]\n",
  "SCARABAEID": "a beetle of the Scarabaeus genus of lamellicorn beetles, also SCARAB, SCARABEE, SCARABOID [n -S]\n",
  "SCARABAEIDS": "SCARABAEID, a beetle of the Scarabaeus genus of lamellicorn beetles, also SCARAB, SCARABEE, SCARABOID [n]\n",
  "SCARABAEIST": "a person who studies scarabaeid beetles [n -S]\n",
  "SCARABAEISTS": "SCARABAEIST, a person who studies scarabaeid beetles [n]\n",
  "SCARABAEOID": "any of various kinds of lamellicorn beetle, esp. Scarabaeus sacer (sacred scarab), regarded by the ancient Egyptians as divine [n -S]\n",
  "SCARABAEOIDS": "SCARABAEOID, any of various kinds of lamellicorn beetle, esp. Scarabaeus sacer (sacred scarab), regarded by the ancient Egyptians as divine [n]\n",
  "SCARABAEUS": "a beetle of the Scarabaeus genus of lamellicorn beetles [n SCARABAEUSES or SCARABAEI]\n",
  "SCARABAEUSES": "SCARABAEUS, a beetle of the Scarabaeus genus of lamellicorn beetles [n]\n",
  "SCARABEE": "(archaic) a scarabaeid beetle, also SCARAB, SCARABAEID, SCARABOID [n -S]\n",
  "SCARABEES": "SCARABEE, (archaic) a scarabaeid beetle, also SCARAB, SCARABAEID, SCARABOID [n]\n",
  "SCARABOID": "belonging to the family Scarabaeidae, an extensive group of lamellicorn beetles [adj] / a lamellicorn beetle, also SCARAB, SCARABAEID, SCARABEE [n -S]\n",
  "SCARABOIDS": "SCARABOID, a lamellicorn beetle, also SCARAB, SCARABAEID, SCARABEE [n]\n",
  "SCARABS": "SCARAB, any scarabaeid beetle, esp. Scarabaeus sacer, regarded by the ancient Egyptians as divine, also SCARABAEID, SCARABEE, SCARABOID [n]\n",
  "SCARAMOUCH": "a bragging cowardly buffoon, also SCARAMOUCHE [n -ES] / to behave like a rascal or cowardly fool [v -ED, -ING, -ES]\n",
  "SCARAMOUCHE": "a bragging cowardly buffoon, also SCARAMOUCH [n -S]\n",
  "SCARAMOUCHED": "SCARAMOUCH, to behave like a rascal or cowardly fool [v]\n",
  "SCARAMOUCHES": "SCARAMOUCH, to behave like a rascal or cowardly fool [v]\n",
  "SCARAMOUCHING": "SCARAMOUCH, to behave like a rascal or cowardly fool [v]\n",
  "SCARCE": "in short supply [adj SCARCER, SCARCEST, SCARCELY]\n",
  "SCARCELY": "SCARCE, in short supply [adv]\n",
  "SCARCEMENT": "an offset where a wall or bank of earth, etc. retreats, leaving a shelf or footing [n -S]\n",
  "SCARCEMENTS": "SCARCEMENT, an offset where a wall or bank of earth, etc. retreats, leaving a shelf or footing [n]\n",
  "SCARCENESS": "the state of being scarce [n -ES]\n",
  "SCARCENESSES": "SCARCENESS, the state of being scarce [n]\n",
  "SCARCER": "SCARCE, in short supply [adj]\n",
  "SCARCEST": "SCARCE, in short supply [adj]\n",
  "SCARCITIES": "SCARCITY, the quality of being scarce [n]\n",
  "SCARCITY": "the quality of being scarce [n SCARCITIES]\n",
  "SCARE": "to frighten [v SCARED, SCARING, SCARES]\n",
  "SCARECROW": "anything set up to scare birds [n -S]\n",
  "SCARECROWS": "SCARECROW, anything set up to scare birds [n]\n",
  "SCARED": "frightened [adj SCAREDER, SCAREDEST]\n",
  "SCAREDER": "SCARED, frightened [adj]\n",
  "SCAREDEST": "SCARED, frightened [adj]\n",
  "SCAREDIES": "SCAREDY, someone who is easily frightened [n]\n",
  "SCAREDY": "someone who is easily frightened [n SCAREDIES]\n",
  "SCAREHEAD": "a newspaper heading designed to raise a scare [n -S]\n",
  "SCAREHEADS": "SCAREHEAD, a newspaper heading designed to raise a scare [n]\n",
  "SCAREMONGER": "one who raises false alarms [n -S]\n",
  "SCAREMONGERING": "raising false alarms [n -S]\n",
  "SCAREMONGERINGS": "SCAREMONGERING, raising false alarms [n]\n",
  "SCAREMONGERS": "SCAREMONGER, one who raises false alarms [n]\n",
  "SCARER": "something or someone who scares [n -S]\n",
  "SCARERS": "SCARER, something or someone who scares [n]\n",
  "SCARES": "SCARE, to frighten [v]\n",
  "SCAREWARE": "a program that is presented as antivirus software but which is usually harmful to a computer when downloaded [n -S]\n",
  "SCAREWARES": "SCAREWARE, a program that is presented as antivirus software but which is usually harmful to a computer when downloaded [n]\n",
  "SCAREY": "frightening, also SCARY [adj SCARIER, SCARIEST, SCARILY]\n",
  "SCARF": "a piece of cloth worn for warmth or protection [n SCARFS or SCARVES] / to cover with a scarf [v -ED, -ING, -S]\n",
  "SCARFED": "SCARF, to cover with a scarf [v]\n",
  "SCARFER": "one that eats or drinks voraciously [n -S]\n",
  "SCARFERS": "SCARFER, one that eats or drinks voraciously [n]\n",
  "SCARFING": "in carpentry, joining with a scarf end [n -S]\n",
  "SCARFINGS": "SCARFING, in carpentry, joining with a scarf end [n]\n",
  "SCARFISH": "a kind of fish, the parrot-wrasse [n -ES]\n",
  "SCARFISHES": "SCARFISH, a kind of fish, the parrot-wrasse [n]\n",
  "SCARFPIN": "a pin for fastening a scarf [n -S]\n",
  "SCARFPINS": "SCARFPIN, a pin for fastening a scarf [n]\n",
  "SCARFS": "SCARF, to cover with a scarf [v]\n",
  "SCARFSKIN": "the epidermis or outermost layer of skin [n -S]\n",
  "SCARFSKINS": "SCARFSKIN, the epidermis or outermost layer of skin [n]\n",
  "SCARFWISE": "arranged like a scarf [adv]\n",
  "SCARIER": "SCARY, frightening, also SCAREY [adj]\n",
  "SCARIEST": "SCARY, frightening, also SCAREY [adj]\n",
  "SCARIFICATION": "the act of scarifying [n -S]\n",
  "SCARIFICATIONS": "SCARIFICATION, the act of scarifying [n]\n",
  "SCARIFICATOR": "a surgical instrument for scarifying, also SCARIFIER [n -S]\n",
  "SCARIFICATORS": "SCARIFICATOR, a surgical instrument for scarifying, also SCARIFIER [n]\n",
  "SCARIFIED": "SCARIFY, to make superficial cuts in [v]\n",
  "SCARIFIER": "an implement for scarifying, also SCARIFICATOR [n -S]\n",
  "SCARIFIERS": "SCARIFIER, an implement for scarifying, also SCARIFICATOR [n]\n",
  "SCARIFIES": "SCARIFY, to make superficial cuts in [v]\n",
  "SCARIFY": "to make superficial cuts in [v SCARIFIED, SCARIFYING, SCARIFIES]\n",
  "SCARIFYING": "SCARIFY, to make superficial cuts in [v]\n",
  "SCARIFYINGLY": "SCARIFYING, SCARIFY, to make superficial cuts in [adv]\n",
  "SCARILY": "SCARY, frightening, also SCAREY [adv]\n",
  "SCARINESS": "the quality of being scary [n -ES]\n",
  "SCARINESSES": "SCARINESS, the quality of being scary [n]\n",
  "SCARING": "SCARE, to frighten [v]\n",
  "SCARIOSE": "thin, dry and membranous, also SCARIOUS [adj]\n",
  "SCARIOUS": "thin, dry and membranous, also SCARIOSE [adj]\n",
  "SCARLATINA": "scarlet fever [n -S]\n",
  "SCARLATINAL": "of or like scarlatina [adj]\n",
  "SCARLATINAS": "SCARLATINA, scarlet fever [n]\n",
  "SCARLESS": "having no scars [adj]\n",
  "SCARLET": "a brilliant red [n -S] / to redden [v -ED, -ING, -S]\n",
  "SCARLETED": "SCARLET, to redden [v]\n",
  "SCARLETING": "SCARLET, to redden [v]\n",
  "SCARLETS": "SCARLET, to redden [v]\n",
  "SCARMOGE": "(archaic) a skirmish [n -S]\n",
  "SCARMOGES": "SCARMOGE, (archaic) a skirmish [n]\n",
  "SCARP": "to make into a steep slope [v -ED, -ING, -S]\n",
  "SCARPA": "to run away, leave without notice, also SCAPA, SCARPER [v -ED, -ING, -S]\n",
  "SCARPAED": "SCARPA, to run away, leave without notice, also SCAPA, SCARPER [v]\n",
  "SCARPAING": "SCARPA, to run away, leave without notice, also SCAPA, SCARPER [v]\n",
  "SCARPAS": "SCARPA, to run away, leave without notice, also SCAPA, SCARPER [v]\n",
  "SCARPED": "SCARP, to make into a steep slope [v]\n",
  "SCARPER": "to run away, leave without notice, also SCAPA, SCARPA [v -ED, -ING, -S]\n",
  "SCARPERED": "SCARPER, to run away, leave without notice, also SCAPA, SCARPA [v]\n",
  "SCARPERING": "SCARPER, to run away, leave without notice, also SCAPA, SCARPA [v]\n",
  "SCARPERS": "SCARPER, to run away, leave without notice, also SCAPA, SCARPA [v]\n",
  "SCARPETTI": "SCARPETTO, (Italian) a climbing shoe with a hemp sole [n]\n",
  "SCARPETTO": "(Italian) a climbing shoe with a hemp sole [n SCARPETTI]\n",
  "SCARPH": "in carpentry, to unite by means of a type of joint, also SCARF [v -ED, -ING, -S]\n",
  "SCARPHED": "SCARPH, in carpentry, to unite by means of a type of joint, also SCARF [v]\n",
  "SCARPHING": "SCARPH, in carpentry, to unite by means of a type of joint, also SCARF [v]\n",
  "SCARPHS": "SCARPH, in carpentry, to unite by means of a type of joint, also SCARF [v]\n",
  "SCARPINES": "(Italian) an instrument of torture for the feet [n]\n",
  "SCARPING": "an escarpment [n -S]\n",
  "SCARPINGS": "SCARPING, an escarpment [n]\n",
  "SCARPS": "SCARP, to make into a steep slope [v]\n",
  "SCARRE": "(Scots) to scare, also SCAUR [v SCARRED, SCARRING, SCARRES]\n",
  "SCARRED": "SCAR, to leave a mark of injured tissue [v]\n",
  "SCARRES": "SCARRE, (Scots) to scare, also SCAUR [v]\n",
  "SCARRIER": "SCARRY, marked with scars [adj]\n",
  "SCARRIEST": "SCARRY, marked with scars [adj]\n",
  "SCARRING": "blemishes from wounds on the skin [n -S]\n",
  "SCARRINGS": "SCARRING, blemishes from wounds on the skin [n]\n",
  "SCARRY": "marked with scars [adj SCARRIER, SCARRIEST]\n",
  "SCARS": "SCAR, to leave a mark of injured tissue [v]\n",
  "SCART": "to scratch, scrape, also SCRAT [v -ED, -ING, -S]\n",
  "SCARTED": "SCART, to scratch, scrape, also SCRAT [v]\n",
  "SCARTH": "(Scots) a cormorant, also SCART, SKART, SKARTH [n -S]\n",
  "SCARTHS": "SCARTH, (Scots) a cormorant, also SCART, SKART, SKARTH [n]\n",
  "SCARTING": "SCART, to scratch, scrape, also SCRAT [v]\n",
  "SCARTS": "SCART, to scratch, scrape, also SCRAT [v]\n",
  "SCARVED": "wearing a scarf [adj]\n",
  "SCARVES": "SCARF, a piece of cloth worn for warmth or protection [n]\n",
  "SCARY": "frightening, also SCAREY [adj SCARIER, SCARIEST, SCARILY]\n",
  "SCAT": "to scare away, also SCATT, SKAT [v SCATTED, SCATTING, SCATS]\n",
  "SCATBACK": "a type of player in football [n -S]\n",
  "SCATBACKS": "SCATBACK, a type of player in football [n]\n",
  "SCATCH": "a stilt [n -ES]\n",
  "SCATCHES": "SCATCH, a stilt [n]\n",
  "SCATH": "(Spenser) to injure, also SCAITH, SCATHE, SKAITH [v -ED, -ING, -S]\n",
  "SCATHE": "(Old Norse) to injure, also SCAITH, SCATH, SKAITH [v SCATHED, SCATHING, SCATHES]\n",
  "SCATHED": "SCATHE, (Old Norse) to injure, also SCAITH, SCATH, SKAITH [v]\n",
  "SCATHEFUL": "harmful [adj]\n",
  "SCATHEFULNESS": "the state of being scatheful, harmful [n -ES]\n",
  "SCATHEFULNESSES": "SCATHEFULNESS, the state of being scatheful, harmful [n]\n",
  "SCATHELESS": "without injury, also SCAITHLESS, SKAITHLESS [adj]\n",
  "SCATHES": "SCATHE, (Old Norse) to injure, also SCAITH, SCATH, SKAITH [v]\n",
  "SCATHING": "SCATHE, (Old Norse) to injure, also SCAITH, SCATH, SKAITH [v]\n",
  "SCATHINGLY": "SCATHING, SCATHE, (Old Norse) to injure, also SCAITH, SCATH, SKAITH [adv]\n",
  "SCATHS": "SCATH, (Spenser) to injure, also SCAITH, SCATHE, SKAITH [v]\n",
  "SCATOLE": "a crystalline compound found in faeces and coal tar, also SKATOL, SKATOLE [n -S]\n",
  "SCATOLES": "SCATOLE, a crystalline compound found in faeces and coal tar, also SKATOL, SKATOLE [n]\n",
  "SCATOLOGIC": "relating to scatology, also SCATOLOGICAL [adj]\n",
  "SCATOLOGICAL": "relating to scatology, also SCATOLOGIC [adj]\n",
  "SCATOLOGIES": "SCATOLOGY, the study of excrement or obscene literature [n]\n",
  "SCATOLOGIST": "a student of scatology, the study of excrement or obscene literature [n -S]\n",
  "SCATOLOGISTS": "SCATOLOGIST, a student of scatology, the study of excrement or obscene literature [n]\n",
  "SCATOLOGY": "the study of excrement or obscene literature [n SCATOLOGIES]\n",
  "SCATOPHAGIES": "SCATOPHAGY, the religious practice of eating excrement [n]\n",
  "SCATOPHAGOUS": "habitually feeding on dung, coprophagous [adj]\n",
  "SCATOPHAGY": "the religious practice of eating excrement [n SCATOPHAGIES]\n",
  "SCATS": "SCAT, to scare away, also SCATT, SKAT [v]\n",
  "SCATT": "(historical) a tribute, a tax, esp. in Orkney and Shetland, also SCAT, SKAT [n -S]\n",
  "SCATTED": "SCAT, to scare away, also SCATT, SKAT [v]\n",
  "SCATTER": "to disperse in all directions [v -ED, -ING, -S]\n",
  "SCATTERABLE": "that can be scattered [adj]\n",
  "SCATTERATION": "the act of scattering [n -S]\n",
  "SCATTERATIONS": "SCATTERATION, the act of scattering [n]\n",
  "SCATTERBRAIN": "a giddy heedless person [n -S]\n",
  "SCATTERBRAINED": "having the characteristics of a scatterbrain [adj]\n",
  "SCATTERBRAINS": "SCATTERBRAIN, a giddy heedless person [n]\n",
  "SCATTERED": "SCATTER, to disperse in all directions [v]\n",
  "SCATTEREDLY": "SCATTERED, SCATTER, to disperse in all directions [adv]\n",
  "SCATTERER": "one who scatters [n -S]\n",
  "SCATTERERS": "SCATTERER, one who scatters [n]\n",
  "SCATTERGOOD": "a spendthrift [n -S]\n",
  "SCATTERGOODS": "SCATTERGOOD, a spendthrift [n]\n",
  "SCATTERGRAM": "a scatter diagram, a graph plotting two variables, with axes at right angles to one another [n -S]\n",
  "SCATTERGRAMS": "SCATTERGRAM, a scatter diagram, a graph plotting two variables, with axes at right angles to one another [n]\n",
  "SCATTERGUN": "a shotgun [n -S]\n",
  "SCATTERGUNS": "SCATTERGUN, a shotgun [n]\n",
  "SCATTERIER": "SCATTERY, dispersed; sparse [adj]\n",
  "SCATTERIEST": "SCATTERY, dispersed; sparse [adj]\n",
  "SCATTERING": "dispersion; that which is scattered [n -S]\n",
  "SCATTERINGLY": "SCATTERING [adv]\n",
  "SCATTERINGS": "SCATTERING, dispersion; that which is scattered [n]\n",
  "SCATTERLING": "(archaic) a vagrant [n -S]\n",
  "SCATTERLINGS": "SCATTERLING, (archaic) a vagrant [n]\n",
  "SCATTERMOUCH": "(slang) old nautical slang for any Latin or Levantine person [n -ES]\n",
  "SCATTERMOUCHES": "SCATTERMOUCH, (slang) old nautical slang for any Latin or Levantine person [n]\n",
  "SCATTEROMETER": "an instrument carried in a meteorological satellite for measuring the backscatter of light from the surface of the sea [n -S]\n",
  "SCATTEROMETERS": "SCATTEROMETER, an instrument carried in a meteorological satellite for measuring the backscatter of light from the surface of the sea [n]\n",
  "SCATTERS": "SCATTER, to disperse in all directions [v]\n",
  "SCATTERSHOT": "random, indiscriminate, wide-ranging, as is shot from a gun [adj]\n",
  "SCATTERY": "dispersed; sparse [adj SCATTERIER, SCATTERIEST]\n",
  "SCATTIER": "SCATTY, empty-headed [adj]\n",
  "SCATTIEST": "SCATTY, empty-headed [adj]\n",
  "SCATTILY": "SCATTY, empty-headed [adv]\n",
  "SCATTINESS": "the state of being scatty [n -ES]\n",
  "SCATTINESSES": "SCATTINESS, the state of being scatty [n]\n",
  "SCATTING": "pebble dashing [n -S]\n",
  "SCATTINGS": "SCATTING, pebble dashing [n]\n",
  "SCATTS": "SCATT, (historical) a tribute, a tax, esp. in Orkney and Shetland, also SCAT, SKAT [n]\n",
  "SCATTY": "empty-headed [adj SCATTIER, SCATTIEST, SCATTILY]\n",
  "SCATURIENT": "flowing out; gushing [adj]\n",
  "SCAUD": "(Scots) to scald [v -ED, -ING, -S]\n",
  "SCAUDED": "SCAUD, (Scots) to scald [v]\n",
  "SCAUDING": "SCAUD, (Scots) to scald [v]\n",
  "SCAUDS": "SCAUD, (Scots) to scald [v]\n",
  "SCAUP": "to cut the scalp from [v -ED, -ING, -S]\n",
  "SCAUPED": "SCAUP, to cut the scalp from [v]\n",
  "SCAUPER": "a semicircular gouging chisel, also SCALPER, SCORPER [n -S]\n",
  "SCAUPERS": "SCAUPER, a semicircular gouging chisel, also SCALPER, SCORPER [n]\n",
  "SCAUPING": "SCAUP, to cut the scalp from [v]\n",
  "SCAUPS": "SCAUP, to cut the scalp from [v]\n",
  "SCAUR": "(Scots) to scare, also SCARRE [v -ED, -ING, -S]\n",
  "SCAURED": "SCAUR, (Scots) to scare, also SCARRE [v]\n",
  "SCAURIES": "SCAURY, (Old Norse) in the Orkneys, a young gull, also SCOURIE, SCOWRIE [n]\n",
  "SCAURING": "SCAUR, (Scots) to scare, also SCARRE [v]\n",
  "SCAURS": "SCAUR, (Scots) to scare, also SCARRE [v]\n",
  "SCAURY": "(Old Norse) in the Orkneys, a young gull, also SCOURIE, SCOWRIE [n SCAURIES]\n",
  "SCAVAGE": "to scavenge [v SCAVAGED, SCAVAGING, SCAVAGES]\n",
  "SCAVAGED": "SCAVAGE, to scavenge [v]\n",
  "SCAVAGER": "an officer who collected scavage, the toll for keeping the streets clean [n -S]\n",
  "SCAVAGERS": "SCAVAGER, an officer who collected scavage, the toll for keeping the streets clean [n]\n",
  "SCAVAGES": "SCAVAGE, to scavenge [v]\n",
  "SCAVAGING": "SCAVAGE, to scavenge [v]\n",
  "SCAVENGE": "to search through rubbish for items [v SCAVENGED, SCAVENGING, SCAVENGES]\n",
  "SCAVENGED": "SCAVENGE, to search through rubbish for items [v]\n",
  "SCAVENGER": "to act as a scavenger, scavenge [v SCAVENGERED, SCAVENGERING, SCAVENGERS]\n",
  "SCAVENGERED": "SCAVENGER, to act as a scavenger, scavenge [v]\n",
  "SCAVENGERIES": "SCAVENGERY, the act of scavenging [n]\n",
  "SCAVENGERING": "the act of scavengering [n -S]\n",
  "SCAVENGERINGS": "SCAVENGERING, the act of scavengering [n]\n",
  "SCAVENGERS": "SCAVENGER, to act as a scavenger, scavenge [v]\n",
  "SCAVENGERY": "the act of scavenging [n SCAVENGERIES]\n",
  "SCAVENGES": "SCAVENGE, to search through rubbish for items [v]\n",
  "SCAVENGING": "the act of scavenging [n -S]\n",
  "SCAVENGINGS": "SCAVENGING, the act of scavenging [n]\n",
  "SCAW": "a low cape or headland, also SKAW [n -S]\n",
  "SCAWS": "SCAW, a low cape or headland, also SKAW [n]\n",
  "SCAWTITE": "a carbonate or silicate of calcium, occurring naturally in small crystals [n -S]\n",
  "SCAWTITES": "SCAWTITE, a carbonate or silicate of calcium, occurring naturally in small crystals [n]\n",
  "SCAZON": "(Greek) a choliamb, also SCAZONTIC [n SCAZONS or SCAZONTES]\n",
  "SCAZONS": "SCAZON, (Greek) a choliamb, also SCAZONTIC [n]\n",
  "SCAZONTES": "SCAZON, (Greek) a choliamb, also SCAZONTIC [n]\n",
  "SCAZONTIC": "a choliamb, also SCAZON [n -S]\n",
  "SCAZONTICS": "SCAZONTIC, a choliamb, also SCAZON [n]\n",
  "SCEAT": "(Old English) a small silver or gold coin of Anglo-Saxon times, also SCEATT [n SCEATTAS or SCEATS]\n",
  "SCEATS": "SCEAT, (Old English) a small silver or gold coin of Anglo-Saxon times, also SCEATT [n]\n",
  "SCEATT": "(Old English) a small silver or gold coin of Anglo-Saxon times, also SCEAT [n SCEATTAS or SCEATTS]\n",
  "SCEATTAS": "SCEATT, (Old English) a small silver or gold coin of Anglo-Saxon times, also SCEAT [n]\n",
  "SCEATTS": "SCEATT, (Old English) a small silver or gold coin of Anglo-Saxon times, also SCEAT [n]\n",
  "SCEDULE": "(US) to plan, also SCHEDULE [v SCEDULED, SCEDULING, SCEDULES]\n",
  "SCEDULED": "SCEDULE, (US) to plan, also SCHEDULE [v]\n",
  "SCEDULES": "SCEDULE, (US) to plan, also SCHEDULE [v]\n",
  "SCEDULING": "SCEDULE, (US) to plan, also SCHEDULE [v]\n",
  "SCELERAT": "(French) a villain, also SCELERATE [n -S]\n",
  "SCELERATE": "(obsolete) a villain, also SCELERAT [n -S]\n",
  "SCELERATES": "SCELERATE, (obsolete) a villain, also SCELERAT [n]\n",
  "SCELERATS": "SCELERAT, (French) a villain, also SCELERATE [n]\n",
  "SCENA": "(Italian) a scene in an opera [n -S]\n",
  "SCENARIES": "SCENARY, (obsolete) scenery [n]\n",
  "SCENARIO": "(Italian) an outline of a dramatic work [n -S]\n",
  "SCENARIOS": "SCENARIO, (Italian) an outline of a dramatic work [n]\n",
  "SCENARISATION": "the process of scenarising, also SCENARIZATION [n -S]\n",
  "SCENARISATIONS": "SCENARISATION, the process of scenarising, also SCENARIZATION [n]\n",
  "SCENARISE": "to make a scenario of, also SCENARIZE [v SCENARISED, SCENARISING, SCENARISES]\n",
  "SCENARISED": "SCENARISE, to make a scenario of, also SCENARIZE [v]\n",
  "SCENARISES": "SCENARISE, to make a scenario of, also SCENARIZE [v]\n",
  "SCENARISING": "SCENARISE, to make a scenario of, also SCENARIZE [v]\n",
  "SCENARIST": "one who makes scenarios [n -S]\n",
  "SCENARISTS": "SCENARIST, one who makes scenarios [n]\n",
  "SCENARIZATION": "the process of scenarizing, also SCENARISATION [n -S]\n",
  "SCENARIZATIONS": "SCENARIZATION, the process of scenarizing, also SCENARISATION [n]\n",
  "SCENARIZE": "to make a scenario of, also SCENARISE [v SCENARIZED, SCENARIZING, SCENARIZES]\n",
  "SCENARIZED": "SCENARIZE, to make a scenario of, also SCENARISE [v]\n",
  "SCENARIZES": "SCENARIZE, to make a scenario of, also SCENARISE [v]\n",
  "SCENARIZING": "SCENARIZE, to make a scenario of, also SCENARISE [v]\n",
  "SCENARY": "(obsolete) scenery [n SCENARIES]\n",
  "SCENAS": "SCENA, (Italian) a scene in an opera [n]\n",
  "SCEND": "of a ship, to pitch into the trough of the sea, also SEND [v -ED, -ING, -S]\n",
  "SCENDED": "SCEND, of a ship, to pitch into the trough of the sea, also SEND [v]\n",
  "SCENDING": "SCEND, of a ship, to pitch into the trough of the sea, also SEND [v]\n",
  "SCENDS": "SCEND, of a ship, to pitch into the trough of the sea, also SEND [v]\n",
  "SCENE": "to set in a place of action [v SCENED, SCENING, SCENES]\n",
  "SCENED": "SCENE, to set in a place of action [v]\n",
  "SCENEMAN": "the man who manages the movable scenes in a theatre [n SCENEMEN]\n",
  "SCENEMEN": "SCENEMAN, the man who manages the movable scenes in a theatre [n]\n",
  "SCENERIES": "SCENERY, a picturesque landscape [n]\n",
  "SCENERY": "a picturesque landscape [n SCENERIES]\n",
  "SCENES": "SCENE, to set in a place of action [v]\n",
  "SCENESHIFTER": "a worker who moves the scenes in a theater [n -S]\n",
  "SCENESHIFTERS": "SCENESHIFTER, a worker who moves the scenes in a theater [n]\n",
  "SCENESTER": "a person who identifies with a particular cultural scene [n -S]\n",
  "SCENESTERS": "SCENESTER, a person who identifies with a particular cultural scene [n]\n",
  "SCENIC": "of or pertaining to scenery, also SCENICAL [adj SCENICALLY] / something scenic [n -S]\n",
  "SCENICAL": "of or pertaining to scenery, also SCENIC [adj SCENICALLY]\n",
  "SCENICALLY": "SCENICAL, of or pertaining to scenery, also SCENIC [adv]\n",
  "SCENICS": "SCENIC, something scenic [n]\n",
  "SCENING": "SCENE, to set in a place of action [v]\n",
  "SCENOGRAPHER": "one who practises scenography [n -S]\n",
  "SCENOGRAPHERS": "SCENOGRAPHER, one who practises scenography [n]\n",
  "SCENOGRAPHIC": "related to scenography, the representation of an object in perspective, also SCENOGRAPHICAL [adj]\n",
  "SCENOGRAPHICAL": "related to scenography, the representation of an object in perspective, also SCENOGRAPHIC [adj]\n",
  "SCENOGRAPHIES": "SCENOGRAPHY, the representation of an object in perspective [n]\n",
  "SCENOGRAPHY": "the representation of an object in perspective [n SCENOGRAPHIES]\n",
  "SCENT": "to fill with a perfume [v -ED, -ING, -S]\n",
  "SCENTED": "SCENT, to fill with a perfume [v]\n",
  "SCENTFUL": "having acute sense of smell [adj]\n",
  "SCENTING": "the act of a dog scenting its prey [n -S]\n",
  "SCENTINGS": "SCENTING, the act of a dog scenting its prey [n]\n",
  "SCENTLESS": "without scent [adj]\n",
  "SCENTLESSNESS": "the state of being scentless [n -ES]\n",
  "SCENTLESSNESSES": "SCENTLESSNESS, the state of being scentless [n]\n",
  "SCENTS": "SCENT, to fill with a perfume [v]\n",
  "SCEPSIS": "(Greek) philosophic doubt, also SKEPSIS [n -ES]\n",
  "SCEPSISES": "SCEPSIS, (Greek) philosophic doubt, also SKEPSIS [n]\n",
  "SCEPTER": "to invest with royal authority, also SCEPTRE [v -ED, -ING, -S]\n",
  "SCEPTERED": "SCEPTER, to invest with royal authority, also SCEPTRE [v]\n",
  "SCEPTERING": "SCEPTER, to invest with royal authority, also SCEPTRE [v]\n",
  "SCEPTERLESS": "without a sceptre, also SCEPTRELESS [adj]\n",
  "SCEPTERS": "SCEPTER, to invest with royal authority, also SCEPTRE [v]\n",
  "SCEPTIC": "disbelieving, also SKEPTIC [adj SCEPTICALLY] / a person who doubts prevailing doctrines [n -S]\n",
  "SCEPTICAL": "inclined to questioning and disbelief, also SKEPTICAL [adj SCEPTICALLY]\n",
  "SCEPTICALLY": "SCEPTICAL, inclined to questioning and disbelief, also SKEPTICAL [adv]\n",
  "SCEPTICISM": "the doctrine that no facts can be certainly known, also SKEPTICISM [n -S]\n",
  "SCEPTICISMS": "SCEPTICISM, the doctrine that no facts can be certainly known, also SKEPTICISM [n]\n",
  "SCEPTICS": "SCEPTIC, a person who doubts prevailing doctrines [n]\n",
  "SCEPTRAL": "pertaining to royal authority [adj]\n",
  "SCEPTRE": "to invest with royal authority, also SCEPTER [v SCEPTRED, SCEPTRING, SCEPTRES]\n",
  "SCEPTRED": "SCEPTRE, to invest with royal authority, also SCEPTER [v]\n",
  "SCEPTRELESS": "without a sceptre, also SCEPTERLESS [adj]\n",
  "SCEPTRES": "SCEPTRE, to invest with royal authority, also SCEPTER [v]\n",
  "SCEPTRING": "SCEPTRE, to invest with royal authority, also SCEPTER [v]\n",
  "SCEPTRY": "(Keats) sceptred [adj]\n",
  "SCERNE": "(archaic) to discern [v SCERNED, SCERNING, SCERNES]\n",
  "SCERNED": "SCERNE, (archaic) to discern [v]\n",
  "SCERNES": "SCERNE, (archaic) to discern [v]\n",
  "SCERNING": "SCERNE, (archaic) to discern [v]\n",
  "SCEUOPHYLACIA": "SCEUOPHYLACIUM, a sacristy [n]\n",
  "SCEUOPHYLACIUM": "a sacristy [n SCEUOPHYLACIA or SCEUOPHYLACIUMS]\n",
  "SCEUOPHYLACIUMS": "SCEUOPHYLACIUM, a sacristy [n]\n",
  "SCEUOPHYLAX": "a sacristan [n -ES]\n",
  "SCEUOPHYLAXES": "SCEUOPHYLAX, a sacristan [n]\n",
  "SCHADENFREUDE": "(German) enjoyment gained from others' troubles [n -S]\n",
  "SCHADENFREUDES": "SCHADENFREUDE, (German) enjoyment gained from others' troubles [n]\n",
  "SCHALSTEIN": "(German) a slaty diabase tuff [n -S]\n",
  "SCHALSTEINS": "SCHALSTEIN, (German) a slaty diabase tuff [n]\n",
  "SCHANSE": "(South African) a heap of stones used as protection against rifle-fire, also SCHANTZE, SCHANZE [n -S]\n",
  "SCHANSES": "SCHANSE, (South African) a heap of stones used as protection against rifle-fire, also SCHANTZE, SCHANZE [n]\n",
  "SCHANTZE": "(South African) a heap of stones used as protection against rifle-fire, also SCHANSE, SCHANZE [n -S]\n",
  "SCHANTZES": "SCHANTZE, (South African) a heap of stones used as protection against rifle-fire, also SCHANSE, SCHANZE [n]\n",
  "SCHANZE": "(South African) a heap of stones used as protection against rifle-fire, also SCHANSE, SCHANTZE [n -S]\n",
  "SCHANZES": "SCHANZE, (South African) a heap of stones used as protection against rifle-fire, also SCHANSE, SCHANTZE [n]\n",
  "SCHAPPE": "(German) to process waste silk [v SCHAPPED, SCHAPPEING, SCHAPPES]\n",
  "SCHAPPED": "SCHAPPE, (German) to process waste silk [v]\n",
  "SCHAPPEING": "SCHAPPE, (German) to process waste silk [v]\n",
  "SCHAPPES": "SCHAPPE, (German) to process waste silk [v]\n",
  "SCHAPSKA": "(Polish) a kind of military cap, adapted from the traditional peasant cap, worn by lancers, also CHAPKA, CZAPKA [n -S]\n",
  "SCHAPSKAS": "SCHAPSKA, (Polish) a kind of military cap, adapted from the traditional peasant cap, worn by lancers, also CHAPKA, CZAPKA [n]\n",
  "SCHATCHEN": "(Hebrew) a matchmaker, also SHADCHAN, SHADKHAN [n -S]\n",
  "SCHATCHENS": "SCHATCHEN, (Hebrew) a matchmaker, also SHADCHAN, SHADKHAN [n]\n",
  "SCHAV": "(Yiddish) a cold soup of leafy vegetables [n -S]\n",
  "SCHAVS": "SCHAV, (Yiddish) a cold soup of leafy vegetables [n]\n",
  "SCHECHITA": "(Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITAH, SHECHITA, SHECHITAH, SHEHITA, SHEHITAH [n -S]\n",
  "SCHECHITAH": "(Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SHECHITA, SHECHITAH, SHEHITA, SHEHITAH [n -S]\n",
  "SCHECHITAHS": "SCHECHITAH, (Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SHECHITA, SHECHITAH, SHEHITA, SHEHITAH [n]\n",
  "SCHECHITAS": "SCHECHITA, (Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITAH, SHECHITA, SHECHITAH, SHEHITA, SHEHITAH [n]\n",
  "SCHECKLATON": "(Spenser) a kind of gilt leather, also CHECKLATON, SHECKLATON [n -S]\n",
  "SCHECKLATONS": "SCHECKLATON, (Spenser) a kind of gilt leather, also CHECKLATON, SHECKLATON [n]\n",
  "SCHEDULAR": "of or like a schedule [adj]\n",
  "SCHEDULE": "to plan, also SCEDULE [v SCHEDULED, SCHEDULING, SCHEDULES]\n",
  "SCHEDULED": "SCHEDULE, to plan, also SCEDULE [v]\n",
  "SCHEDULER": "one who schedules [n -S]\n",
  "SCHEDULERS": "SCHEDULER, one who schedules [n]\n",
  "SCHEDULES": "SCHEDULE, to plan, also SCEDULE [v]\n",
  "SCHEDULING": "the act of assigning to a certain date or time [n -S]\n",
  "SCHEDULINGS": "SCHEDULING, the act of assigning to a certain date or time [n]\n",
  "SCHEELITE": "calcium tungstate, a mineral of a white or pale yellowish color [n -S]\n",
  "SCHEELITES": "SCHEELITE, calcium tungstate, a mineral of a white or pale yellowish color [n]\n",
  "SCHEFFLERA": "any of various evergreen tropical or subtropical shrubs of the family Araliaceae, having large compound leaves and clusters of small flowers followed by berries [n -S]\n",
  "SCHEFFLERAS": "SCHEFFLERA, any of various evergreen tropical or subtropical shrubs of the family Araliaceae, having large compound leaves and clusters of small flowers followed by berries [n]\n",
  "SCHELLIES": "SCHELLY, a freshwater white fish of the Lake District [n]\n",
  "SCHELLUM": "(Scots) a scoundrel, rascal, also SCHELM, SKELLUM, SKELM, SKELUM [n -S]\n",
  "SCHELLUMS": "SCHELLUM, (Scots) a scoundrel, rascal, also SCHELM, SKELLUM, SKELM, SKELUM [n]\n",
  "SCHELLY": "a freshwater white fish of the Lake District [n SCHELLIES]\n",
  "SCHELM": "(obsolete) a scoundrel, rascal, also SCHELLUM, SKELLUM, SKELM, SKELUM [n -S]\n",
  "SCHELMS": "SCHELM, (obsolete) a scoundrel, rascal, also SCHELLUM, SKELLUM, SKELM, SKELUM [n]\n",
  "SCHEMA": "(Greek) a schematic representation of something [n SCHEMATA or SCHEMAS]\n",
  "SCHEMAS": "SCHEMA, (Greek) a schematic representation of something [n]\n",
  "SCHEMATA": "SCHEMA, (Greek) a schematic representation of something [n]\n",
  "SCHEMATIC": "relating to a scheme, also SCHEMATICAL [adj SCHEMATICALLY] / the representation of something by a diagram, plan etc. [n -S]\n",
  "SCHEMATICAL": "involving a particular plan, also SCHEMATIC [adj SCHEMATICALLY]\n",
  "SCHEMATICALLY": "SCHEMATICAL, involving a particular plan, also SCHEMATIC [adv]\n",
  "SCHEMATICS": "SCHEMATIC, the representation of something by a diagram, plan etc. [n]\n",
  "SCHEMATISATION": "the act of schematising, also SCHEMATIZATION [n -S]\n",
  "SCHEMATISATIONS": "SCHEMATISATION, the act of schematising, also SCHEMATIZATION [n]\n",
  "SCHEMATISE": "to make a scheme of, also SCHEMATIZE [v SCHEMATISED, SCHEMATISING, SCHEMATISES]\n",
  "SCHEMATISED": "SCHEMATISE, to make a scheme of, also SCHEMATIZE [v]\n",
  "SCHEMATISES": "SCHEMATISE, to make a scheme of, also SCHEMATIZE [v]\n",
  "SCHEMATISING": "SCHEMATISE, to make a scheme of, also SCHEMATIZE [v]\n",
  "SCHEMATISM": "combination of the aspects of heavenly bodies [n -S]\n",
  "SCHEMATISMS": "SCHEMATISM, combination of the aspects of heavenly bodies [n]\n",
  "SCHEMATIST": "one given to forming schemes [n -S]\n",
  "SCHEMATISTS": "SCHEMATIST, one given to forming schemes [n]\n",
  "SCHEMATIZATION": "the act of schematizing, also SCHEMATISATION [n -S]\n",
  "SCHEMATIZATIONS": "SCHEMATIZATION, the act of schematizing, also SCHEMATISATION [n]\n",
  "SCHEMATIZE": "to make a scheme of, also SCHEMATISE [v SCHEMATIZED, SCHEMATIZING, SCHEMATIZES]\n",
  "SCHEMATIZED": "SCHEMATIZE, to make a scheme of, also SCHEMATISE [v]\n",
  "SCHEMATIZES": "SCHEMATIZE, to make a scheme of, also SCHEMATISE [v]\n",
  "SCHEMATIZING": "SCHEMATIZE, to make a scheme of, also SCHEMATISE [v]\n",
  "SCHEME": "to plan or plot [v SCHEMED, SCHEMING, SCHEMES]\n",
  "SCHEMED": "SCHEME, to plan or plot [v]\n",
  "SCHEMER": "one that schemes [n -S]\n",
  "SCHEMERS": "SCHEMER, one that schemes [n]\n",
  "SCHEMES": "SCHEME, to plan or plot [v]\n",
  "SCHEMIE": "(Scots) a derogatory word for a member of a housing scheme [n -S]\n",
  "SCHEMIES": "SCHEMIE, (Scots) a derogatory word for a member of a housing scheme [n]\n",
  "SCHEMING": "artful [adj SCHEMINGLY] / the act of scheming [n -S]\n",
  "SCHEMINGLY": "SCHEMING, artful [adv]\n",
  "SCHEMINGS": "SCHEMING, the act of scheming [n]\n",
  "SCHEMOZZLE": "(Yiddish) to make off, also SHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v SCHEMOZZLED, SCHEMOZZLING, SCHEMOZZLES]\n",
  "SCHEMOZZLED": "SCHEMOZZLE, (Yiddish) to make off, also SHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v]\n",
  "SCHEMOZZLES": "SCHEMOZZLE, (Yiddish) to make off, also SHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v]\n",
  "SCHEMOZZLING": "SCHEMOZZLE, (Yiddish) to make off, also SHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v]\n",
  "SCHERZANDI": "SCHERZANDO, a scherzando passage [n]\n",
  "SCHERZANDO": "(Italian) in a playful or sportive manner [adv] / a scherzando passage [n SCHERZANDI or SCHERZANDOS]\n",
  "SCHERZANDOS": "SCHERZANDO, a scherzando passage [n]\n",
  "SCHERZI": "SCHERZO, (Italian) a lively musical movement [n]\n",
  "SCHERZO": "(Italian) a lively musical movement [n SCHERZOS or SCHERZI]\n",
  "SCHERZOS": "SCHERZO, (Italian) a lively musical movement [n]\n",
  "SCHIAVONE": "(Italian) a basket-hilted broadsword used by the Doge's bodyguard of Slavs [n -S]\n",
  "SCHIAVONES": "SCHIAVONE, (Italian) a basket-hilted broadsword used by the Doge's bodyguard of Slavs [n]\n",
  "SCHIEDAM": "(Dutch) Holland gin made at Schiedam in the Netherlands [n -S]\n",
  "SCHIEDAMS": "SCHIEDAM, (Dutch) Holland gin made at Schiedam in the Netherlands [n]\n",
  "SCHILLER": "(German) a peculiar bronze-like lustre in certain minerals [n -S]\n",
  "SCHILLERISATION": "the process of schillerising, also SCHILLERIZATION [n]\n",
  "SCHILLERISE": "to give a bronze lustre to, also SCHILLERIZE [v SCHILLERISED, SCHILLERISING, SCHILLERISES]\n",
  "SCHILLERISED": "SCHILLERISE, to give a bronze lustre to, also SCHILLERIZE [v]\n",
  "SCHILLERISES": "SCHILLERISE, to give a bronze lustre to, also SCHILLERIZE [v]\n",
  "SCHILLERISING": "SCHILLERISE, to give a bronze lustre to, also SCHILLERIZE [v]\n",
  "SCHILLERIZATION": "the process of schillerizing, also SCHILLERISATION [n]\n",
  "SCHILLERIZE": "to give a bronze lustre to, also SCHILLERISE [v SCHILLERIZED, SCHILLERIZING, SCHILLERIZES]\n",
  "SCHILLERIZED": "SCHILLERIZE, to give a bronze lustre to, also SCHILLERISE [v]\n",
  "SCHILLERIZES": "SCHILLERIZE, to give a bronze lustre to, also SCHILLERISE [v]\n",
  "SCHILLERIZING": "SCHILLERIZE, to give a bronze lustre to, also SCHILLERISE [v]\n",
  "SCHILLERS": "SCHILLER, (German) a peculiar bronze-like lustre in certain minerals [n]\n",
  "SCHILLING": "(German) any one of several small German and Dutch coins [n -S]\n",
  "SCHILLINGS": "SCHILLING, (German) any one of several small German and Dutch coins [n]\n",
  "SCHIMMEL": "(German) a roan horse [n -S]\n",
  "SCHIMMELS": "SCHIMMEL, (German) a roan horse [n]\n",
  "SCHINDYLESES": "SCHINDYLESIS, an articulation formed by the fitting of the crest of one bone into the groove of another [n]\n",
  "SCHINDYLESIS": "an articulation formed by the fitting of the crest of one bone into the groove of another [n SCHINDYLESES]\n",
  "SCHINDYLETIC": "of or like a schindylesis, an articulation formed by the fitting of the crest of one bone into the groove of another [adj]\n",
  "SCHIPPERKE": "(Dutch) a small black Belgian canalboat dog [n -S]\n",
  "SCHIPPERKES": "SCHIPPERKE, (Dutch) a small black Belgian canalboat dog [n]\n",
  "SCHISM": "a division of unity [n -S]\n",
  "SCHISMA": "(Greek) in music, an interval equal to half the difference between twelve perfect fifths and seven octaves [n -S]\n",
  "SCHISMAS": "SCHISMA, (Greek) in music, an interval equal to half the difference between twelve perfect fifths and seven octaves [n]\n",
  "SCHISMATIC": "of or pertaining to schism, also SCHISMATICAL [adj SCHISMATICALLY] / one who causes a schism [n -S]\n",
  "SCHISMATICAL": "relating to a schism, also SCHISMATIC [adj SCHISMATICALLY] / a person who causes a schism [n -S]\n",
  "SCHISMATICALLY": "SCHISMATICAL, relating to a schism, also SCHISMATIC [adv]\n",
  "SCHISMATICALS": "SCHISMATICAL, a person who causes a schism [n]\n",
  "SCHISMATICS": "SCHISMATIC, one who causes a schism [n]\n",
  "SCHISMATISE": "to practise schism; to make a schism, also SCHISMATIZE [v SCHISMATISED, SCHISMATISING, SCHISMATISES]\n",
  "SCHISMATISED": "SCHISMATISE, to practise schism; to make a schism, also SCHISMATIZE [v]\n",
  "SCHISMATISES": "SCHISMATISE, to practise schism; to make a schism, also SCHISMATIZE [v]\n",
  "SCHISMATISING": "SCHISMATISE, to practise schism; to make a schism, also SCHISMATIZE [v]\n",
  "SCHISMATIZE": "to practise schism; to make a schism, also SCHISMATISE [v SCHISMATIZED, SCHISMATIZING, SCHISMATIZES]\n",
  "SCHISMATIZED": "SCHISMATIZE, to practise schism; to make a schism, also SCHISMATISE [v]\n",
  "SCHISMATIZES": "SCHISMATIZE, to practise schism; to make a schism, also SCHISMATISE [v]\n",
  "SCHISMATIZING": "SCHISMATIZE, to practise schism; to make a schism, also SCHISMATISE [v]\n",
  "SCHISMS": "SCHISM, a division of unity [n]\n",
  "SCHIST": "a type of metamorphic rock, also SHIST [n -S]\n",
  "SCHISTOSE": "of or pertaining to schist; having the structure of a schist, also SCHISTOUS [adj]\n",
  "SCHISTOSITIES": "SCHISTOSITY, the foliation in a schist, due largely to the parallel orientation of micas [n]\n",
  "SCHISTOSITY": "the foliation in a schist, due largely to the parallel orientation of micas [n SCHISTOSITIES]\n",
  "SCHISTOSOMAL": "of or like a schistosome, a disease-causing blood fluke [adj]\n",
  "SCHISTOSOME": "a disease-causing blood fluke [n -S]\n",
  "SCHISTOSOMES": "SCHISTOSOME, a disease-causing blood fluke [n]\n",
  "SCHISTOSOMIASES": "SCHISTOSOMIASIS, a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka bilharziasis [n]\n",
  "SCHISTOSOMIASIS": "a disease caused by infestation of the body with blood flukes of the genus Schistosoma, aka bilharziasis [n SCHISTOSOMIASES]\n",
  "SCHISTOUS": "of or pertaining to schist; having the structure of a schist, also SCHISTOSE [adj]\n",
  "SCHISTS": "SCHIST, a type of metamorphic rock, also SHIST [n]\n",
  "SCHIZAEACEOUS": "belonging to the Schizaeaceae, a tropical genus of ferns [adj]\n",
  "SCHIZANTHUS": "a Chilean flowering plant of the genus Schizanthus, frequently cultivated for its showy orchidlike blooms [n -ES]\n",
  "SCHIZANTHUSES": "SCHIZANTHUS, a Chilean flowering plant of the genus Schizanthus, frequently cultivated for its showy orchidlike blooms [n]\n",
  "SCHIZIER": "SCHIZY, affected with schizophrenia, also SCHIZZY [adj]\n",
  "SCHIZIEST": "SCHIZY, affected with schizophrenia, also SCHIZZY [adj]\n",
  "SCHIZO": "(colloquial) a schizophrenic [n -S]\n",
  "SCHIZOCARP": "a compound fruit splitting into several one-seeded ones, e.g. the winged seed pod of maple trees [n -S]\n",
  "SCHIZOCARPIC": "of or like a schizocarp, a compound fruit splitting into several one-seeded ones [adj]\n",
  "SCHIZOCARPOUS": "of or like a schizocarp, a compound fruit splitting into several one-seeded ones [adj]\n",
  "SCHIZOCARPS": "SCHIZOCARP, a compound fruit splitting into several one-seeded ones, e.g. the winged seed pod of maple trees [n]\n",
  "SCHIZOGENESES": "SCHIZOGENESIS, reproduction by division [n]\n",
  "SCHIZOGENESIS": "reproduction by division [n SCHIZOGENESES]\n",
  "SCHIZOGENETIC": "reproducing, reproduced, or formed by fission or splitting, also SCHIZOGENIC [adj]\n",
  "SCHIZOGENIC": "reproducing, reproduced, or formed by fission or splitting, also SCHIZOGENETIC [adj]\n",
  "SCHIZOGNATHOUS": "of some birds, having the bones of the palate separate [adj]\n",
  "SCHIZOGONIC": "relating to schizogony [adj]\n",
  "SCHIZOGONIES": "SCHIZOGONY, reproduction by division [n]\n",
  "SCHIZOGONOUS": "reproducing by multiple fission [adj]\n",
  "SCHIZOGONY": "reproduction by division [n SCHIZOGONIES]\n",
  "SCHIZOID": "suffering from schizophrenia [adj] / one suffering from schizophrenia [n -S]\n",
  "SCHIZOIDAL": "suffering from schizophrenia, also SCHIZOID, SCHIZOPHRENETIC, SCHIZOPHRENIC [adj]\n",
  "SCHIZOIDS": "SCHIZOID, one suffering from schizophrenia [n]\n",
  "SCHIZOMYCETE": "any microscopic organism of the class Schizomycetes [n -S]\n",
  "SCHIZOMYCETES": "SCHIZOMYCETE, any microscopic organism of the class Schizomycetes [n]\n",
  "SCHIZOMYCETIC": "of or like a schizomycete, any microscopic organism of the class Schizomycetes, also SCHIZOMYCETOUS [adj]\n",
  "SCHIZOMYCETOUS": "of or like a schizomycete, any microscopic organism of the class Schizomycetes, also SCHIZOMYCETIC [adj]\n",
  "SCHIZONT": "in protozoans, a mature trophozoite about to reproduce by schizogony [n -S]\n",
  "SCHIZONTS": "SCHIZONT, in protozoans, a mature trophozoite about to reproduce by schizogony [n]\n",
  "SCHIZOPHRENE": "one affected with schizophrenia [n -S]\n",
  "SCHIZOPHRENES": "SCHIZOPHRENE, one affected with schizophrenia [n]\n",
  "SCHIZOPHRENETIC": "suffering from schizophrenia, also SCHIZOID, SCHIZOIDAL, SCHIZOPHRENIC [adj]\n",
  "SCHIZOPHRENIA": "a mental disorder with 'splitting' of personality and separation from environment [n -S]\n",
  "SCHIZOPHRENIAS": "SCHIZOPHRENIA, a mental disorder with 'splitting' of personality and separation from environment [n]\n",
  "SCHIZOPHRENIC": "relating to schizophrenia, also SCHIZOID, SCHIZOIDAL, SCHIZOPHRENETIC [adj] / one suffering from schizophrenia [n -S]\n",
  "SCHIZOPHRENICS": "SCHIZOPHRENIC, one suffering from schizophrenia [n]\n",
  "SCHIZOPHYCEOUS": "of or belonging to the Schizophyceae, a group of bluish-green algae [adj]\n",
  "SCHIZOPHYTE": "a plant of the Schizophyta, an obsolete grouping of organisms that multiply only by fission, including bacteria and blue-green algae [n -S]\n",
  "SCHIZOPHYTES": "SCHIZOPHYTE, a plant of the Schizophyta, an obsolete grouping of organisms that multiply only by fission, including bacteria and blue-green algae [n]\n",
  "SCHIZOPHYTIC": "of or like a schizophyte, an obsolete grouping of organisms that multiply only by fission [adj]\n",
  "SCHIZOPOD": "one of the Schizopoda, shrimplike crustaceans [n -S]\n",
  "SCHIZOPODAL": "of or like a schizopod, also SCHIZOPODOUS [adj]\n",
  "SCHIZOPODOUS": "of or like a schizopod, also SCHIZOPODAL [adj]\n",
  "SCHIZOPODS": "SCHIZOPOD, one of the Schizopoda, shrimplike crustaceans [n]\n",
  "SCHIZOS": "SCHIZO, (colloquial) a schizophrenic [n]\n",
  "SCHIZOTHYMIA": "schizoid behavior that resembles schizophrenia in the tendency toward autistic thinking but remains within normal limits [n -S]\n",
  "SCHIZOTHYMIAS": "SCHIZOTHYMIA, schizoid behavior that resembles schizophrenia in the tendency toward autistic thinking but remains within normal limits [n]\n",
  "SCHIZOTHYMIC": "designating a schizoid tendency remaining within the bounds of normality [adj]\n",
  "SCHIZY": "affected with schizophrenia, also SCHIZZY [adj SCHIZIER, SCHIZIEST]\n",
  "SCHIZZIER": "SCHIZZY, affected with schizophrenia, also SCHIZY [adj]\n",
  "SCHIZZIEST": "SCHIZZY, affected with schizophrenia, also SCHIZY [adj]\n",
  "SCHIZZY": "affected with schizophrenia, also SCHIZY [adj SCHIZZIER, SCHIZZIEST]\n",
  "SCHLAGER": "(German) a duelling sword used in some German universities [n -S]\n",
  "SCHLAGERS": "SCHLAGER, (German) a duelling sword used in some German universities [n]\n",
  "SCHLEMIEL": "(Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIHL, SHLEMIEHL, SHLEMIEL [n -S]\n",
  "SCHLEMIELS": "SCHLEMIEL, (Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIHL, SHLEMIEHL, SHLEMIEL [n]\n",
  "SCHLEMIHL": "(Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIEL, SHLEMIEHL, SHLEMIEL [n -S]\n",
  "SCHLEMIHLS": "SCHLEMIHL, (Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIEL, SHLEMIEHL, SHLEMIEL [n]\n",
  "SCHLEP": "(Yiddish) to drag one's feet; travel a great distance, also SCHLEPP, SHLEP, SHLEPP [v SCHLEPPED, SCHLEPPING, SCHLEPS]\n",
  "SCHLEPP": "(Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SHLEP, SHLEPP [v -ED, -ING, -S]\n",
  "SCHLEPPED": "SCHLEP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEPP, SHLEP, SHLEPP [v]\n",
  "SCHLEPPER": "(Yiddish) an incompetent or nonentity, also SHLEPPER [n -S]\n",
  "SCHLEPPERS": "SCHLEPPER, (Yiddish) an incompetent or nonentity, also SHLEPPER [n]\n",
  "SCHLEPPIER": "SCHLEPPY, (Yiddish) incompetent, also SHLEPPY [adj]\n",
  "SCHLEPPIEST": "SCHLEPPY, (Yiddish) incompetent, also SHLEPPY [adj]\n",
  "SCHLEPPING": "SCHLEP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEPP, SHLEP, SHLEPP [v]\n",
  "SCHLEPPS": "SCHLEPP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SHLEP, SHLEPP [v]\n",
  "SCHLEPPY": "(Yiddish) incompetent, also SHLEPPY [adj SCHLEPPIER, SCHLEPPIEST]\n",
  "SCHLEPS": "SCHLEP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEPP, SHLEP, SHLEPP [v]\n",
  "SCHLICH": "(German) the finer portion of a crushed ore, as of gold, lead, or tin, separated by the water in certain wet processes [n -S]\n",
  "SCHLICHS": "SCHLICH, (German) the finer portion of a crushed ore, as of gold, lead, or tin, separated by the water in certain wet processes [n]\n",
  "SCHLIERE": "(German) one of a set of visible streaks of different density in a fluid, or streaks of different color or composition in igneous rock [n SCHLIEREN]\n",
  "SCHLIEREN": "one of a set of visible streaks of different density in a fluid, or streaks of different color or composition in igneous rock [n -S]\n",
  "SCHLIERENS": "SCHLIEREN, one of a set of visible streaks of different density in a fluid, or streaks of different color or composition in igneous rock [n]\n",
  "SCHLIERIC": "relating to schlieren, visible streaks of different density in a fluid [adj]\n",
  "SCHLIMAZEL": "(Yiddish) an unlucky person; one with perpetual bad luck, also SHLIMAZEL [n -S]\n",
  "SCHLIMAZELS": "SCHLIMAZEL, (Yiddish) an unlucky person; one with perpetual bad luck, also SHLIMAZEL [n]\n",
  "SCHLOCK": "(Yiddish) inferior merchandise, also SHLOCK [n -S]\n",
  "SCHLOCKER": "(Yiddish) something of inferior quality, also SCHLOCK, SHLOCK [n -S]\n",
  "SCHLOCKERS": "SCHLOCKER, (Yiddish) something of inferior quality, also SCHLOCK, SHLOCK [n]\n",
  "SCHLOCKEY": "(Yiddish) of poor quality, also SCHLOCKY, SHL:OCKY / something trashy, of inferior quality [n -S]\n",
  "SCHLOCKEYS": "SCHLOCKEY, something trashy, of inferior quality [n]\n",
  "SCHLOCKIER": "SCHLOCKY, (Yiddish) trashy, of inferior quality, also SCHLOCKEY, SHLOCKY [adj]\n",
  "SCHLOCKIEST": "SCHLOCKY, (Yiddish) trashy, of inferior quality, also SCHLOCKEY, SHLOCKY [adj]\n",
  "SCHLOCKS": "SCHLOCK, (Yiddish) inferior merchandise, also SHLOCK [n]\n",
  "SCHLOCKY": "(Yiddish) trashy, of inferior quality, also SCHLOCKEY, SHLOCKY [adj SCHLOCKIER, SCHLOCKIEST]\n",
  "SCHLONG": "(vulgar slang) the penis, also SHLONG [n -S]\n",
  "SCHLONGS": "SCHLONG, (vulgar slang) the penis, also SHLONG [n]\n",
  "SCHLOSS": "(German) a castle, palace, manor-house [n -ES]\n",
  "SCHLOSSES": "SCHLOSS, (German) a castle, palace, manor-house [n]\n",
  "SCHLUB": "(Yiddish) a stupid or unattractive person, also SHLUB [n -S]\n",
  "SCHLUBS": "SCHLUB, (Yiddish) a stupid or unattractive person, also SHLUB [n]\n",
  "SCHLUMBERGERA": "Christmas cactus [n -S]\n",
  "SCHLUMBERGERAS": "SCHLUMBERGERA, Christmas cactus [n]\n",
  "SCHLUMP": "(Yiddish) to flop, slump, also SHLUMP [v -ED, -ING, -S]\n",
  "SCHLUMPED": "SCHLUMP, (Yiddish) to flop, slump, also SHLUMP [v]\n",
  "SCHLUMPIER": "SCHLUMPY, unattractive, slovenly [adj]\n",
  "SCHLUMPIEST": "SCHLUMPY, unattractive, slovenly [adj]\n",
  "SCHLUMPING": "SCHLUMP, (Yiddish) to flop, slump, also SHLUMP [v]\n",
  "SCHLUMPS": "SCHLUMP, (Yiddish) to flop, slump, also SHLUMP [v]\n",
  "SCHLUMPY": "unattractive, slovenly [adj SCHLUMPIER, SCHLUMPIEST]\n",
  "SCHMALTZ": "(Yiddish) excessive sentimentality, also SCHMALZ, SHMALTZ [n -ES]\n",
  "SCHMALTZES": "SCHMALTZ, (Yiddish) excessive sentimentality, also SCHMALZ, SHMALTZ [n]\n",
  "SCHMALTZIER": "SHMALTZY, (Yiddish) sickly sentimental, also SCHMALTZY, SCHMALZY [adj]\n",
  "SCHMALTZIEST": "SHMALTZY, (Yiddish) sickly sentimental, also SCHMALTZY, SCHMALZY [adj]\n",
  "SCHMALTZY": "(Yiddish) sickly sentimental, also SCHMALZY, SHMALTZY [adj SCHMALTZIER, SCHMALTZIEST]\n",
  "SCHMALZ": "(Yiddish) excessive sentimentality, also SCHMALTZ, SHMALTZ [n -ES]\n",
  "SCHMALZES": "SCHMALZ, (Yiddish) excessive sentimentality, also SCHMALTZ, SHMALTZ [n]\n",
  "SCHMALZIER": "SCHMALZY, (Yiddish) characterized by schmaltz, also SHMALTZY [adj]\n",
  "SCHMALZIEST": "SCHMALZY, (Yiddish) characterized by schmaltz, also SHMALTZY [adj]\n",
  "SCHMALZY": "(Yiddish) characterized by schmaltz, also SHMALTZY [adj SCHMALZIER, SCHMALZIEST]\n",
  "SCHMATTE": "(Yiddish) clothing, rags, also SCHMUTTER, SHMATTE [n -S]\n",
  "SCHMATTES": "SCHMATTE, (Yiddish) clothing, rags, also SCHMUTTER, SHMATTE [n]\n",
  "SCHMEAR": "(Yiddish) to spread or smear, also SCHMEER, SHMEAR, SHMEER [v -ED, -ING, -S]\n",
  "SCHMEARED": "SCHMEAR, (Yiddish) to spread or smear, also SCHMEER, SHMEAR, SHMEER [v]\n",
  "SCHMEARING": "SCHMEAR, (Yiddish) to spread or smear, also SCHMEER, SHMEAR, SHMEER [v]\n",
  "SCHMEARS": "SCHMEAR, (Yiddish) to spread or smear, also SCHMEER, SHMEAR, SHMEER [v]\n",
  "SCHMECK": "(Yiddish) to taste good [v -ED, -ING, -S]\n",
  "SCHMECKED": "SCHMECK, (Yiddish) to taste good [v]\n",
  "SCHMECKER": "a heroin user [n -S]\n",
  "SCHMECKERS": "SCHMECKER, a heroin user [n]\n",
  "SCHMECKING": "SCHMECK, (Yiddish) to taste good [v]\n",
  "SCHMECKS": "SCHMECK, (Yiddish) to taste good [v]\n",
  "SCHMEER": "(Yiddish) to flatter or bribe, also SCHMEAR, SHMEAR, SHMEER [v -ED, -ING, -S]\n",
  "SCHMEERED": "SCHMEER, (Yiddish) to flatter or bribe, also SCHMEAR, SHMEAR, SHMEER [v]\n",
  "SCHMEERING": "SCHMEER, (Yiddish) to flatter or bribe, also SCHMEAR, SHMEAR, SHMEER [v]\n",
  "SCHMEERS": "SCHMEER, (Yiddish) to flatter or bribe, also SCHMEAR, SHMEAR, SHMEER [v]\n",
  "SCHMELZ": "(German) a kind of glass of a red or ruby color, made in Bohemia, also SCHMELZE [n -ES]\n",
  "SCHMELZE": "(German) a kind of glass of a red or ruby color, made in Bohemia, also SCHMELZ [n -S]\n",
  "SCHMELZES": "SCHMELZ, (German) a kind of glass of a red or ruby color, made in Bohemia, also SCHMELZE [n]\n",
  "SCHMICK": "(Australian slang) stylish [adj SCHMICKER, SCHMICKEST]\n",
  "SCHMICKER": "SCHMICK, (Australian slang) stylish [adj]\n",
  "SCHMICKEST": "SCHMICK, (Australian slang) stylish [adj]\n",
  "SCHMO": "(Yiddish) a stupid or boring person, also SCHMOE, SHMO, SHMOE [n -ES or -S]\n",
  "SCHMOCK": "(Yiddish) a stupid or boring person, also SHMOCK [n -S]\n",
  "SCHMOCKS": "SCHMOCK, (Yiddish) a stupid or boring person, also SHMOCK [n]\n",
  "SCHMOE": "(Yiddish) a stupid or boring person, also SCHMO, SHMO, SHMOE [n -S]\n",
  "SCHMOES": "SCHMOE, (Yiddish) a stupid or boring person, also SCHMO, SHMO, SHMOE [n]\n",
  "SCHMOOS": "(Yiddish) to chat in a friendly way, also SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE, SHMOOZE [v SCHMOOSED, SCHMOOSING, SCHMOOSES]\n",
  "SCHMOOSE": "(Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOZ, SCHMOOZE, SHMOOSE, SHMOOZE [v SCHMOOSED, SCHMOOSING, SCHMOOSES]\n",
  "SCHMOOSED": "SCHMOOS, (Yiddish) to chat in a friendly way, also SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE, SHMOOZE [v]\n",
  "SCHMOOSES": "SCHMOOS, (Yiddish) to chat in a friendly way, also SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE, SHMOOZE [v]\n",
  "SCHMOOSING": "SCHMOOS, (Yiddish) to chat in a friendly way, also SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE, SHMOOZE [v]\n",
  "SCHMOOZ": "(Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZE, SHMOOSE, SHMOOZE [v -ED, -ING, -ES]\n",
  "SCHMOOZE": "(Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SHMOOSE, SHMOOZE [v SCHMOOZED, SCHMOOZING, SCHMOOZES]\n",
  "SCHMOOZED": "SCHMOOZE, (Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SHMOOSE, SHMOOZE [v]\n",
  "SCHMOOZER": "(Yiddish) one who schmoozes, also SHMOOZER [n -S]\n",
  "SCHMOOZERS": "SCHMOOZER, (Yiddish) one who schmoozes, also SHMOOZER [n]\n",
  "SCHMOOZES": "SCHMOOZE, (Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SHMOOSE, SHMOOZE [v]\n",
  "SCHMOOZIER": "SCHMOOZY, (Yiddish) gossipy, also SHMOOZY [adj]\n",
  "SCHMOOZIEST": "SCHMOOZY, (Yiddish) gossipy, also SHMOOZY [adj]\n",
  "SCHMOOZING": "SCHMOOZE, (Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SHMOOSE, SHMOOZE [v]\n",
  "SCHMOOZY": "(Yiddish) gossipy, also SHMOOZY [adj SCHMOOZIER, SCHMOOZIEST]\n",
  "SCHMOS": "SCHMO, (Yiddish) a stupid or boring person, also SCHMOE, SHMO, SHMOE [n]\n",
  "SCHMUCK": "(Yiddish) to hit or flatten [v -ED, -ING, -S]\n",
  "SCHMUCKED": "SCHMUCK, (Yiddish) to hit or flatten [v]\n",
  "SCHMUCKIER": "SCHMUCKY, acting like a schmuck, foolish, contemptible [adj]\n",
  "SCHMUCKIEST": "SCHMUCKY, acting like a schmuck, foolish, contemptible [adj]\n",
  "SCHMUCKING": "SCHMUCK, (Yiddish) to hit or flatten [v]\n",
  "SCHMUCKS": "SCHMUCK, (Yiddish) to hit or flatten [v]\n",
  "SCHMUCKY": "acting like a schmuck, foolish, contemptible [adj SCHMUCKIER, SCHMUCKIEST]\n",
  "SCHMUTTER": "(Yiddish) clothing, rags, also SCHMATTE, SHMATTE [n -S]\n",
  "SCHMUTTERS": "SCHMUTTER, (Yiddish) clothing, rags, also SCHMATTE, SHMATTE [n]\n",
  "SCHMUTZ": "dirt, grime [n -ES]\n",
  "SCHMUTZES": "SCHMUTZ, dirt, grime [n]\n",
  "SCHNAPPER": "an Australian food-fish, also SNAPPER [n -S]\n",
  "SCHNAPPERS": "SCHNAPPER, an Australian food-fish, also SNAPPER [n]\n",
  "SCHNAPPS": "(German) a kind of brandy, also SCHNAPS, SHNAPPS, SHNAPS [n -ES]\n",
  "SCHNAPPSES": "SCHNAPPS, (German) a kind of brandy, also SCHNAPS, SHNAPPS, SHNAPS [n]\n",
  "SCHNAPS": "(German) a kind of brandy, also SCHNAPPS, SHNAPPS, SHNAPS [n -ES]\n",
  "SCHNAPSES": "SCHNAPS, (German) a kind of brandy, also SCHNAPPS, SHNAPPS, SHNAPS [n]\n",
  "SCHNAUZER": "(German) a German breed of wirehaired terrier [n -S]\n",
  "SCHNAUZERS": "SCHNAUZER, (German) a German breed of wirehaired terrier [n]\n",
  "SCHNECKE": "(German) a sweet bread roll, containing nuts and flavoured with cinnamon [n SCHNECKEN]\n",
  "SCHNECKEN": "SCHNECKE, (German) a sweet bread roll, containing nuts and flavoured with cinnamon [n]\n",
  "SCHNEID": "a series of losses [n -S]\n",
  "SCHNEIDS": "SCHNEID, a series of losses [n]\n",
  "SCHNELL": "(German) quick [adj]\n",
  "SCHNITZEL": "(German) a thin veal cutlet fried in butter [n -S]\n",
  "SCHNITZELS": "SCHNITZEL, (German) a thin veal cutlet fried in butter [n]\n",
  "SCHNOODLE": "a dog that is a cross between a schnauzer and a poodle [n -S]\n",
  "SCHNOODLES": "SCHNOODLE, a dog that is a cross between a schnauzer and a poodle [n]\n",
  "SCHNOOK": "(Yiddish) a stupid, easily deceived person, also SHNOOK [n -S]\n",
  "SCHNOOKS": "SCHNOOK, (Yiddish) a stupid, easily deceived person, also SHNOOK [n]\n",
  "SCHNORKEL": "(German) to swim underwater using a breathing-tube, also SNORKEL [v SCHNORKELED or SCHNORKELLED, SCHNORKELING or SCHNORKELLING, SCHNORKELS]\n",
  "SCHNORKELED": "SCHNORKEL, (German) to swim underwater using a breathing-tube, also SNORKEL [v]\n",
  "SCHNORKELING": "SCHNORKEL, (German) to swim underwater using a breathing-tube, also SNORKEL [v]\n",
  "SCHNORKELLED": "SCHNORKEL, (German) to swim underwater using a breathing-tube, also SNORKEL [v]\n",
  "SCHNORKELLING": "SCHNORKEL, (German) to swim underwater using a breathing-tube, also SNORKEL [v]\n",
  "SCHNORKELS": "SCHNORKEL, (German) to swim underwater using a breathing-tube, also SNORKEL [v]\n",
  "SCHNORR": "(Yiddish) to beg, esp. in such a way as to make the giver feel beholden [v -ED, -ING, -S]\n",
  "SCHNORRED": "SCHNORR, (Yiddish) to beg, esp. in such a way as to make the giver feel beholden [v]\n",
  "SCHNORRER": "(Yiddish) one who takes advantage of the generosity of others, also SHNORRER [n -S]\n",
  "SCHNORRERS": "SCHNORRER, (Yiddish) one who takes advantage of the generosity of others, also SHNORRER [n]\n",
  "SCHNORRING": "SCHNORR, (Yiddish) to beg, esp. in such a way as to make the giver feel beholden [v]\n",
  "SCHNORRS": "SCHNORR, (Yiddish) to beg, esp. in such a way as to make the giver feel beholden [v]\n",
  "SCHNOZ": "(Yiddish) the nose, also SCHNOZZ, SCHNOZZLE [n SCHNOZZES or SCHNOZES]\n",
  "SCHNOZES": "SCHNOZ, (Yiddish) the nose, also SCHNOZZ, SCHNOZZLE [n]\n",
  "SCHNOZZ": "(Yiddish) nose, also SCHNOZ, SCHNOZZLE [n -ES]\n",
  "SCHNOZZES": "SCHNOZ, (Yiddish) the nose, also SCHNOZZ, SCHNOZZLE [n]\n",
  "SCHNOZZLE": "(Yiddish) nose, also SCHNOZ, SCHNOZZ [n -S]\n",
  "SCHNOZZLES": "SCHNOZZLE, (Yiddish) nose, also SCHNOZ, SCHNOZZ [n]\n",
  "SCHOLAR": "a learned person [n -S]\n",
  "SCHOLARCH": "the head of a school [n -S]\n",
  "SCHOLARCHS": "SCHOLARCH, the head of a school [n]\n",
  "SCHOLARLIER": "SCHOLARLY, learned, like a scholar [adj]\n",
  "SCHOLARLIEST": "SCHOLARLY, learned, like a scholar [adj]\n",
  "SCHOLARLINESS": "the state of being scholarly [n -ES]\n",
  "SCHOLARLINESSES": "SCHOLARLINESS, the state of being scholarly [n]\n",
  "SCHOLARLY": "learned, like a scholar [adj SCHOLARLIER, SCHOLARLIEST]\n",
  "SCHOLARS": "SCHOLAR, a learned person [n]\n",
  "SCHOLARSHIP": "the activity of a scholar [n -S]\n",
  "SCHOLARSHIPS": "SCHOLARSHIP, the activity of a scholar [n]\n",
  "SCHOLASTIC": "relating to schools, universities etc., also SCHOLASTICAL [adj SCHOLASTICALLY] / a Scholastic philosopher [n -S]\n",
  "SCHOLASTICAL": "(archaic) scholastic [adj SCHOLASTICALLY]\n",
  "SCHOLASTICALLY": "SCHOLASTICAL, (archaic) scholastic [adv]\n",
  "SCHOLASTICATE": "a preparatory college for those intending to enter Catholic order [n -S]\n",
  "SCHOLASTICATES": "SCHOLASTICATE, a preparatory college for those intending to enter Catholic order [n]\n",
  "SCHOLASTICISM": "the aims, methods, and products of thought which constituted the main endeavour of the intellectual life of the Middle Ages [n -S]\n",
  "SCHOLASTICISMS": "SCHOLASTICISM, the aims, methods, and products of thought which constituted the main endeavour of the intellectual life of the Middle Ages [n]\n",
  "SCHOLASTICS": "SCHOLASTIC, a Scholastic philosopher [n]\n",
  "SCHOLIA": "SCHOLIUM, (Greek) an explanatory marginal note [n]\n",
  "SCHOLIAST": "a commentator; a writer of marginal notes [n -S]\n",
  "SCHOLIASTIC": "like a scholiast [adj]\n",
  "SCHOLIASTS": "SCHOLIAST, a commentator; a writer of marginal notes [n]\n",
  "SCHOLION": "(Greek) a marginal annotation; specifically, an explanatory comment on the text of a classic author by an early grammarian, also SCHOLIUM [n SCHOLIA]\n",
  "SCHOLIUM": "(Greek) an explanatory marginal note [n SCHOLIUMS or SCHOLIA]\n",
  "SCHOLIUMS": "SCHOLIUM, (Greek) an explanatory marginal note [n]\n",
  "SCHOOL": "to educate in an institution of learning [v -ED, -ING, -S]\n",
  "SCHOOLBAG": "a bag for carrying school books [n -S]\n",
  "SCHOOLBAGS": "SCHOOLBAG, a bag for carrying school books [n]\n",
  "SCHOOLBOOK": "a school textbook [n -S]\n",
  "SCHOOLBOOKS": "SCHOOLBOOK, a school textbook [n]\n",
  "SCHOOLBOY": "a boy who attends school [n -S]\n",
  "SCHOOLBOYISH": "of or like a schoolboy [adj]\n",
  "SCHOOLBOYS": "SCHOOLBOY, a boy who attends school [n]\n",
  "SCHOOLCHILD": "a child attending school [n SCHOOLCHILDREN]\n",
  "SCHOOLCHILDREN": "SCHOOLCHILD, a child attending school [n]\n",
  "SCHOOLCRAFT": "(archaic) learning [n -S]\n",
  "SCHOOLCRAFTS": "SCHOOLCRAFT, (archaic) learning [n]\n",
  "SCHOOLDAY": "a day on which school is held [n -S]\n",
  "SCHOOLDAYS": "SCHOOLDAY, a day on which school is held [n]\n",
  "SCHOOLE": "(Shakespeare) a shoal, also SHAUL [n -S]\n",
  "SCHOOLED": "SCHOOL, to educate in an institution of learning [v]\n",
  "SCHOOLER": "a student attending a school of the specified kind or being educated in the specified way [n -S]\n",
  "SCHOOLERIES": "SCHOOLERY, (archaic) something taught; precepts [n]\n",
  "SCHOOLERS": "SCHOOLER, a student attending a school of the specified kind or being educated in the specified way [n]\n",
  "SCHOOLERY": "(archaic) something taught; precepts [n SCHOOLERIES]\n",
  "SCHOOLES": "SCHOOLE, (Shakespeare) a shoal, also SHAUL [n]\n",
  "SCHOOLFELLOW": "a fellow pupil at a school [n -S]\n",
  "SCHOOLFELLOWS": "SCHOOLFELLOW, a fellow pupil at a school [n]\n",
  "SCHOOLGIRL": "a girl attending school [n -S]\n",
  "SCHOOLGIRLISH": "like a schoolgirl [adj]\n",
  "SCHOOLGIRLS": "SCHOOLGIRL, a girl attending school [n]\n",
  "SCHOOLGOING": "attendance at school [n -S]\n",
  "SCHOOLGOINGS": "SCHOOLGOING, attendance at school [n]\n",
  "SCHOOLHOUSE": "a building used as a school, esp. a rural school [n -S]\n",
  "SCHOOLHOUSES": "SCHOOLHOUSE, a building used as a school, esp. a rural school [n]\n",
  "SCHOOLIE": "(Australian slang) a schoolteacher or high-school student [n -S]\n",
  "SCHOOLIES": "SCHOOLIE, (Australian slang) a schoolteacher or high-school student [n]\n",
  "SCHOOLING": "tuition [n -S]\n",
  "SCHOOLINGS": "SCHOOLING, tuition [n]\n",
  "SCHOOLKID": "a child who attends school [n -S]\n",
  "SCHOOLKIDS": "SCHOOLKID, a child who attends school [n]\n",
  "SCHOOLMAID": "a schoolgirl [n -S]\n",
  "SCHOOLMAIDS": "SCHOOLMAID, a schoolgirl [n]\n",
  "SCHOOLMAN": "a philosopher or theologian of medieval scholasticism [n SCHOOLMEN]\n",
  "SCHOOLMARM": "a woman who is a schoolteacher, especially in a rural or small-town school [n -S]\n",
  "SCHOOLMARMISH": "like a schoolmarm, prim, severe [adj]\n",
  "SCHOOLMARMS": "SCHOOLMARM, a woman who is a schoolteacher, especially in a rural or small-town school [n]\n",
  "SCHOOLMASTER": "a male schoolteacher or head of a school [n -S] / to act as a schoolmaster to [v -ED, -ING, -S]\n",
  "SCHOOLMASTERED": "SCHOOLMASTER, to act as a schoolmaster to [v]\n",
  "SCHOOLMASTERING": "SCHOOLMASTER, to act as a schoolmaster to [v]\n",
  "SCHOOLMASTERISH": "like a schoolmaster [adj]\n",
  "SCHOOLMASTERLY": "like a schoolmaster [adj]\n",
  "SCHOOLMASTERS": "SCHOOLMASTER, a male schoolteacher or head of a school [n]\n",
  "SCHOOLMATE": "a companion at school [n -S]\n",
  "SCHOOLMATES": "SCHOOLMATE, a companion at school [n]\n",
  "SCHOOLMEN": "SCHOOLMAN, a philosopher or theologian of medieval scholasticism [n]\n",
  "SCHOOLMISTRESS": "a female schoolmaster [n]\n",
  "SCHOOLMISTRESSY": "like a schoolmistress, prim [adj]\n",
  "SCHOOLROOM": "a classroom [n -S]\n",
  "SCHOOLROOMS": "SCHOOLROOM, a classroom [n]\n",
  "SCHOOLS": "SCHOOL, to educate in an institution of learning [v]\n",
  "SCHOOLTEACHER": "one who teaches school [n -S]\n",
  "SCHOOLTEACHERS": "SCHOOLTEACHER, one who teaches school [n]\n",
  "SCHOOLTEACHING": "teaching as a profession [n -S]\n",
  "SCHOOLTEACHINGS": "SCHOOLTEACHING, teaching as a profession [n]\n",
  "SCHOOLTIDE": "schooldays [n -S]\n",
  "SCHOOLTIDES": "SCHOOLTIDE, schooldays [n]\n",
  "SCHOOLTIME": "the time at which a school opens, or during which it remains open [n -S]\n",
  "SCHOOLTIMES": "SCHOOLTIME, the time at which a school opens, or during which it remains open [n]\n",
  "SCHOOLWARD": "toward school, also SCHOOLWARDS [adv]\n",
  "SCHOOLWARDS": "toward school, also SCHOOLWARD [adv]\n",
  "SCHOOLWORK": "lessons done in class or assigned to be done at home [n -S]\n",
  "SCHOOLWORKS": "SCHOOLWORK, lessons done in class or assigned to be done at home [n]\n",
  "SCHOOLYARD": "the grounds of a school, especially as a place for children to play [n -S]\n",
  "SCHOOLYARDS": "SCHOOLYARD, the grounds of a school, especially as a place for children to play [n]\n",
  "SCHOONER": "a kind of sailing vessel [n -S]\n",
  "SCHOONERS": "SCHOONER, a kind of sailing vessel [n]\n",
  "SCHORL": "(German) a mineral, black tourmaline, also SHORL [n -S]\n",
  "SCHORLACEOUS": "like schorl [adj]\n",
  "SCHORLOMITE": "a black variety of garnet rich in titanium dioxide [n -S]\n",
  "SCHORLOMITES": "SCHORLOMITE, a black variety of garnet rich in titanium dioxide [n]\n",
  "SCHORLS": "SCHORL, (German) a mineral, black tourmaline, also SHORL [n]\n",
  "SCHOTTISCHE": "(German) an old polka-like round dance [n -S]\n",
  "SCHOTTISCHES": "SCHOTTISCHE, (German) an old polka-like round dance [n]\n",
  "SCHOUT": "(Dutch) a municipal officer [n -S]\n",
  "SCHOUTS": "SCHOUT, (Dutch) a municipal officer [n]\n",
  "SCHRECKLICH": "(German) horrible [adj]\n",
  "SCHRIK": "a sudden fright [n -S]\n",
  "SCHRIKS": "SCHRIK, a sudden fright [n]\n",
  "SCHROD": "a young cod, also SCROD [n -S]\n",
  "SCHRODS": "SCHROD, a young cod, also SCROD [n]\n",
  "SCHTICK": "(Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTIK, SHTICK, SHTIK [n -S]\n",
  "SCHTICKS": "SCHTICK, (Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTIK, SHTICK, SHTIK [n]\n",
  "SCHTIK": "(Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTICK, SHTICK, SHTIK [n -S]\n",
  "SCHTIKS": "SCHTIK, (Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTICK, SHTICK, SHTIK [n]\n",
  "SCHTOOK": "(Yiddish) trouble, bother, also SCHTUCK, SHTOOK, SHTUCK [n -S]\n",
  "SCHTOOKS": "SCHTOOK, (Yiddish) trouble, bother, also SCHTUCK, SHTOOK, SHTUCK [n]\n",
  "SCHTOOM": "(Yiddish) silent, dumb, quiet, also SCHTUM, SHTOOM, SHTUM, SHTUMM, STUMM [adj]\n",
  "SCHTUCK": "(Yiddish) trouble, bother, also SCHTOOK, SHTOOK, SHTUCK [n -S]\n",
  "SCHTUCKS": "SCHTUCK, (Yiddish) trouble, bother, also SCHTOOK, SHTOOK, SHTUCK [n]\n",
  "SCHTUM": "(Yiddish) silent, dumb, quiet, also SCHTOOM, SHTOOM, SHTUM, SHTUMM, STUMM [adj]\n",
  "SCHTUP": "(Yiddish) to have sexual intercourse with, also SHTUP [v SCHTUPPED, SCHTUPPING, SCHTUPS]\n",
  "SCHTUPPED": "SCHTUP, (Yiddish) to have sexual intercourse with, also SHTUP [v]\n",
  "SCHTUPPING": "SCHTUP, (Yiddish) to have sexual intercourse with, also SHTUP [v]\n",
  "SCHTUPS": "SCHTUP, (Yiddish) to have sexual intercourse with, also SHTUP [v]\n",
  "SCHUIT": "(Dutch) a flat-bottomed boat, used along canals and round the coast, also SCHUYT [n -S]\n",
  "SCHUITS": "SCHUIT, (Dutch) a flat-bottomed boat, used along canals and round the coast, also SCHUYT [n]\n",
  "SCHUL": "(Yiddish) a synagogue, also SHUL [n SCHULS or SCHULN]\n",
  "SCHULN": "SCHUL, (Yiddish) a synagogue, also SHUL [n]\n",
  "SCHULS": "SCHUL, (Yiddish) a synagogue, also SHUL [n]\n",
  "SCHUSS": "(German) to make a fast, straight run in skiing [v -ED, -ING, -ES]\n",
  "SCHUSSBOOMER": "a very proficient schusser [n -S]\n",
  "SCHUSSBOOMERS": "SCHUSSBOOMER, a very proficient schusser [n]\n",
  "SCHUSSED": "SCHUSS, (German) to make a fast, straight run in skiing [v]\n",
  "SCHUSSER": "(German) one who makes schusses, fast runs on a straight skiing slope [n -S]\n",
  "SCHUSSERS": "SCHUSSER, (German) one who makes schusses, fast runs on a straight skiing slope [n]\n",
  "SCHUSSES": "SCHUSS, (German) to make a fast, straight run in skiing [v]\n",
  "SCHUSSING": "SCHUSS, (German) to make a fast, straight run in skiing [v]\n",
  "SCHUYT": "(Dutch) a Dutch flat-bottomed boat, used along canals and round the coast, also SCHUIT [n -S]\n",
  "SCHUYTS": "SCHUYT, (Dutch) a Dutch flat-bottomed boat, used along canals and round the coast, also SCHUIT [n]\n",
  "SCHVARTZE": "(offensive Yiddish) a black person, also SCHWARTZE, SHVARTZE [n -S]\n",
  "SCHVARTZES": "SCHVARTZE, (offensive Yiddish) a black person, also SCHWARTZE, SHVARTZE [n]\n",
  "SCHVITZ": "(Yiddish) to sweat, also SHVITZ [v SCHVITZED, SCHVITZING, SCHVITZES]\n",
  "SCHVITZED": "SCHVITZ, (Yiddish) to sweat, also SHVITZ [v]\n",
  "SCHVITZES": "SCHVITZ, (Yiddish) to sweat, also SHVITZ [v]\n",
  "SCHVITZING": "SCHVITZ, (Yiddish) to sweat, also SHVITZ [v]\n",
  "SCHWA": "(German) a vowel sound, like \"a\" in alone or \"e\" in linen, that in English often appears unstressed, also SHWA [n -S]\n",
  "SCHWAG": "(Yiddish) cheap merchandise given away to the public at promotional events; poor quality marijuana [n -S]\n",
  "SCHWAGS": "SCHWAG, (Yiddish) cheap merchandise given away to the public at promotional events; poor quality marijuana [n]\n",
  "SCHWARMEREI": "(German) excessive or unwholesome sentiment [n -S]\n",
  "SCHWARMEREIS": "SCHWARMEREI, (German) excessive or unwholesome sentiment [n]\n",
  "SCHWARMERISCH": "(German) showing schwarmerei, excessive or unwholesome sentiment [adj]\n",
  "SCHWARTZE": "(offensive Yiddish) a black person, also SCHVARTZE, SHVARTZE [n -S]\n",
  "SCHWARTZES": "SCHWARTZE, (offensive Yiddish) a black person, also SCHVARTZE, SHVARTZE [n]\n",
  "SCHWARZLOT": "(German) a type of black enamel decoration on glass, porcelain etc. [n -S]\n",
  "SCHWARZLOTS": "SCHWARZLOT, (German) a type of black enamel decoration on glass, porcelain etc. [n]\n",
  "SCHWAS": "SCHWA, (German) a vowel sound, like \"a\" in alone or \"e\" in linen, that in English often appears unstressed, also SHWA [n]\n",
  "SCIAENID": "a member of the family Sciaenidae of tropical and temperate percoid fishes, also SCIAENOID [n -S]\n",
  "SCIAENIDS": "SCIAENID, a member of the family Sciaenidae of tropical and temperate percoid fishes, also SCIAENOID [n]\n",
  "SCIAENOID": "a member of the family Sciaenidae of tropical and temperate percoid fishes, also SCIAENID [n -S]\n",
  "SCIAENOIDS": "SCIAENOID, a member of the family Sciaenidae of tropical and temperate percoid fishes, also SCIAENID [n]\n",
  "SCIAMACHIES": "SCIAMACHY, fighting with a shadow or an imaginary opponent, also SCIOMACHY, SKIAMACHY [n]\n",
  "SCIAMACHY": "fighting with a shadow or an imaginary opponent, also SCIOMACHY, SKIAMACHY [n SCIAMACHIES]\n",
  "SCIARID": "a minute, dark-coloured, two-winged fly [n -S]\n",
  "SCIARIDS": "SCIARID, a minute, dark-coloured, two-winged fly [n]\n",
  "SCIATIC": "of or relating to the hip, also SCIATICAL [adj] / the sciatic nerve [n -S]\n",
  "SCIATICA": "neuritis of the sciatic nerve [n -S]\n",
  "SCIATICAL": "of or relating to the hip, also SCIATIC [adj]\n",
  "SCIATICAS": "SCIATICA, neuritis of the sciatic nerve [n]\n",
  "SCIATICS": "SCIATIC, the sciatic nerve [n]\n",
  "SCIENCE": "knowledge obtained by observation and experiment [n -S]\n",
  "SCIENCED": "versed [adj]\n",
  "SCIENCES": "SCIENCE, knowledge obtained by observation and experiment [n]\n",
  "SCIENT": "(archaic) knowing; skillful [adj]\n",
  "SCIENTER": "having knowledge [adv]\n",
  "SCIENTIAL": "relating to or producing knowledge or science [adj]\n",
  "SCIENTIFIC": "of, relating to, or exhibiting the methods or principles of science, also SCIENTIFICAL [adj SCIENTIFICALLY]\n",
  "SCIENTIFICAL": "of, relating to, or exhibiting the methods or principles of science, also SCIENTIFIC [adj SCIENTIFICALLY]\n",
  "SCIENTIFICALLY": "SCIENTIFICAL, of, relating to, or exhibiting the methods or principles of science, also SCIENTIFIC [adv]\n",
  "SCIENTIFICITIES": "SCIENTIFICITY, the state of being SCIENTIFIC [n]\n",
  "SCIENTIFICITY": "the state of being SCIENTIFIC [n SCIENTIFICITIES]\n",
  "SCIENTISE": "to treat in a scientific way, also SCIENTIZE [v SCIENTISED, SCIENTISING, SCIENTISES]\n",
  "SCIENTISED": "SCIENTISE, to treat in a scientific way, also SCIENTIZE [v]\n",
  "SCIENTISES": "SCIENTISE, to treat in a scientific way, also SCIENTIZE [v]\n",
  "SCIENTISING": "SCIENTISE, to treat in a scientific way, also SCIENTIZE [v]\n",
  "SCIENTISM": "the belief that the methods of science are universally applicable [n -S]\n",
  "SCIENTISMS": "SCIENTISM, the belief that the methods of science are universally applicable [n]\n",
  "SCIENTIST": "one who practises science [n -S]\n",
  "SCIENTISTIC": "like a scientist [adj]\n",
  "SCIENTISTS": "SCIENTIST, one who practises science [n]\n",
  "SCIENTIZE": "to treat in a scientific way, also SCIENTISE [v SCIENTIZED, SCIENTIZING, SCIENTIZES]\n",
  "SCIENTIZED": "SCIENTIZE, to treat in a scientific way, also SCIENTISE [v]\n",
  "SCIENTIZES": "SCIENTIZE, to treat in a scientific way, also SCIENTISE [v]\n",
  "SCIENTIZING": "SCIENTIZE, to treat in a scientific way, also SCIENTISE [v]\n",
  "SCILICET": "(Latin) to wit; namely [adv]\n",
  "SCILLA": "(Latin) any plant of the squill genus [n -S]\n",
  "SCILLAS": "SCILLA, (Latin) any plant of the squill genus [n]\n",
  "SCIMETAR": "a curved oriental sword, also CEMITARE, SCIMITAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n -S]\n",
  "SCIMETARS": "SCIMETAR, a curved oriental sword, also CEMITARE, SCIMITAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n]\n",
  "SCIMITAR": "a curved oriental sword, also CEMITARE, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n -S]\n",
  "SCIMITARS": "SCIMITAR, a curved oriental sword, also CEMITARE, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n]\n",
  "SCIMITER": "a curved oriental sword, also SCIMITAR, SCIMETAR, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n -S]\n",
  "SCIMITERS": "SCIMITER, a curved oriental sword, also SCIMITAR, SCIMETAR, SEMITAR, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n]\n",
  "SCINCOID": "belonging to the skink family [adj] / a member of the skink family [n -S]\n",
  "SCINCOIDIAN": "a member of the skink family [n -S]\n",
  "SCINCOIDIANS": "SCINCOIDIAN, a member of the skink family [n]\n",
  "SCINCOIDS": "SCINCOID, a member of the skink family [n]\n",
  "SCINDAPSUS": "any plant of the tropical Asiatic climbing genus Scindapsus, grown as greenhouse or house plants for their leathery heart-shaped variegated leaves [n -ES]\n",
  "SCINDAPSUSES": "SCINDAPSUS, any plant of the tropical Asiatic climbing genus Scindapsus, grown as greenhouse or house plants for their leathery heart-shaped variegated leaves [n]\n",
  "SCINTIGRAM": "a diagram produced by scintigraphy [n -S]\n",
  "SCINTIGRAMS": "SCINTIGRAM, a diagram produced by scintigraphy [n]\n",
  "SCINTIGRAPHIC": "relating to scintigraphy, a diagnostic technique using gamma rays [adj]\n",
  "SCINTIGRAPHIES": "SCINTIGRAPHY, a diagnostic technique using gamma rays [n]\n",
  "SCINTIGRAPHY": "a diagnostic technique using gamma rays [n SCINTIGRAPHIES]\n",
  "SCINTILLA": "(Latin) a spark; an atom [n SCINTILLAE or SCINTILLAS]\n",
  "SCINTILLAE": "SCINTILLA, (Latin) a spark; an atom [n]\n",
  "SCINTILLANT": "sparkling [adj SCINTILLANTLY]\n",
  "SCINTILLANTLY": "SCINTILLANT, sparkling [adv]\n",
  "SCINTILLAS": "SCINTILLA, (Latin) a spark; an atom [n]\n",
  "SCINTILLASCOPE": "an instrument which shows scintillations on a screen, used to produce a scintigram, also SCINTILLOSCOPE [n -S]\n",
  "SCINTILLASCOPES": "SCINTILLASCOPE, an instrument which shows scintillations on a screen, used to produce a scintigram, also SCINTILLOSCOPE [n]\n",
  "SCINTILLATE": "to sparkle [v SCINTILLATED, SCINTILLATING, SCINTILLATES]\n",
  "SCINTILLATED": "SCINTILLATE, to sparkle [v]\n",
  "SCINTILLATES": "SCINTILLATE, to sparkle [v]\n",
  "SCINTILLATING": "SCINTILLATE, to sparkle [v]\n",
  "SCINTILLATINGLY": "SCINTILLATING, SCINTILLATE, to sparkle [adv]\n",
  "SCINTILLATION": "the twinkling of stars or small bursts of light [n -S]\n",
  "SCINTILLATIONS": "SCINTILLATION, the twinkling of stars or small bursts of light [n]\n",
  "SCINTILLATOR": "an instrument for detecting radioactivity; a phosphor that produces scintillations [n -S]\n",
  "SCINTILLATORS": "SCINTILLATOR, an instrument for detecting radioactivity; a phosphor that produces scintillations [n]\n",
  "SCINTILLISCAN": "a 2-D image from a radioisotope scan, also SCINTISCAN [n -S]\n",
  "SCINTILLISCANS": "SCINTILLISCAN, a 2-D image from a radioisotope scan, also SCINTISCAN [n]\n",
  "SCINTILLOMETER": "instrument measuring scintillation of star [n -S]\n",
  "SCINTILLOMETERS": "SCINTILLOMETER, instrument measuring scintillation of star [n]\n",
  "SCINTILLON": "a luminescent body present in the cytoplasm of some dinoflagellates [n -S]\n",
  "SCINTILLONS": "SCINTILLON, a luminescent body present in the cytoplasm of some dinoflagellates [n]\n",
  "SCINTILLOSCOPE": "an instrument for measuring gamma rays emitted by a radioactive body, also SCINTILLASCOPE [n -S]\n",
  "SCINTILLOSCOPES": "SCINTILLOSCOPE, an instrument for measuring gamma rays emitted by a radioactive body, also SCINTILLASCOPE [n]\n",
  "SCINTISCAN": "a 2-D image from a radioisotope scan, also SCINTILLISCAN [n -S]\n",
  "SCINTISCANNER": "a device for producing scintiscans [n -S]\n",
  "SCINTISCANNERS": "SCINTISCANNER, a device for producing scintiscans [n]\n",
  "SCINTISCANS": "SCINTISCAN, a 2-D image from a radioisotope scan, also SCINTILLISCAN [n]\n",
  "SCIOLISM": "(Latin) superficial knowledge [n -S]\n",
  "SCIOLISMS": "SCIOLISM, (Latin) superficial knowledge [n]\n",
  "SCIOLIST": "one whose knowledge is superficial [n -S]\n",
  "SCIOLISTIC": "of or pertaining to sciolism [adj]\n",
  "SCIOLISTS": "SCIOLIST, one whose knowledge is superficial [n]\n",
  "SCIOLOUS": "knowing superficially or imperfectly [adj]\n",
  "SCIOLTO": "(Italian) in a free manner [adv]\n",
  "SCIOMACHIES": "SCIOMACHY, fighting with a shadow or an imaginary opponent, also SCIAMACHY, SKIAMACHY [n]\n",
  "SCIOMACHY": "fighting with a shadow or an imaginary opponent, also SCIAMACHY, SKIAMACHY [n SCIOMACHIES]\n",
  "SCIOMANCER": "one who practises sciomancy, divination with the help of ghosts [n -S]\n",
  "SCIOMANCERS": "SCIOMANCER, one who practises sciomancy, divination with the help of ghosts [n]\n",
  "SCIOMANCIES": "SCIOMANCY, divination with the help of ghosts [n]\n",
  "SCIOMANCY": "divination with the help of ghosts [n SCIOMANCIES]\n",
  "SCIOMANTIC": "relating to sciomancy, divination with the help of ghosts [adj]\n",
  "SCION": "a young member of a family, also CION, SEYEN, SIEN, SIENT, SYEN [n -S]\n",
  "SCIONS": "SCION, a young member of a family, also CION, SEYEN, SIEN, SIENT, SYEN [n]\n",
  "SCIOPHYTE": "any plant that grows best in the shade [n -S]\n",
  "SCIOPHYTES": "SCIOPHYTE, any plant that grows best in the shade [n]\n",
  "SCIOPHYTIC": "of or like a sciophyte, any plant that grows best in the shade [adj]\n",
  "SCIOSOPHIES": "SCIOSOPHY, a system of knowledge without basis in science [n]\n",
  "SCIOSOPHY": "a system of knowledge without basis in science [n SCIOSOPHIES]\n",
  "SCIROC": "(Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROCCO, SIROC, SIROCCO [n -S]\n",
  "SCIROCCO": "(Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROC, SIROC, SIROCCO [n -S]\n",
  "SCIROCCOS": "SCIROCCO, (Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROC, SIROC, SIROCCO [n]\n",
  "SCIROCS": "SCIROC, (Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROCCO, SIROC, SIROCCO [n]\n",
  "SCIRRHI": "SCIRRHUS, (Latin) a hard tumour [n]\n",
  "SCIRRHOID": "resembling a scirrhus, a hard swelling, also SCIRRHOUS [adj]\n",
  "SCIRRHOSITIES": "SCIRRHOSITY, the state of being scirrhous, resembling a scirrhus, a hard swelling [n]\n",
  "SCIRRHOSITY": "the state of being scirrhous, resembling a scirrhus, a hard swelling [n SCIRRHOSITIES]\n",
  "SCIRRHOUS": "resembling a scirrhus, a hard swelling, also SCIRRHOID [adj]\n",
  "SCIRRHUS": "(Latin) a hard tumour [n SCIRRHUSES or SCIRRHI]\n",
  "SCIRRHUSES": "SCIRRHUS, (Latin) a hard tumour [n]\n",
  "SCISSEL": "metal clippings, scrap metal, also SCISSIL, SIZEL [n -S]\n",
  "SCISSELS": "SCISSEL, metal clippings, scrap metal, also SCISSIL, SIZEL [n]\n",
  "SCISSIL": "metal clippings, scrap metal, also SCISSEL, SIZEL [n -S]\n",
  "SCISSILE": "capable of being cut [adj]\n",
  "SCISSILS": "SCISSIL, metal clippings, scrap metal, also SCISSEL, SIZEL [n]\n",
  "SCISSION": "a division or split in a group or union [n -S]\n",
  "SCISSIONS": "SCISSION, a division or split in a group or union [n]\n",
  "SCISSIPARITIES": "SCISSIPARITY, reproduction by fission [n]\n",
  "SCISSIPARITY": "reproduction by fission [n SCISSIPARITIES]\n",
  "SCISSOR": "to cut with a two-bladed instrument [v -ED, -ING, -S]\n",
  "SCISSORED": "SCISSOR, to cut with a two-bladed instrument [v]\n",
  "SCISSORER": "one who scissors [n -S]\n",
  "SCISSORERS": "SCISSORER, one who scissors [n]\n",
  "SCISSORING": "SCISSOR, to cut with a two-bladed instrument [v]\n",
  "SCISSORS": "SCISSOR, to cut with a two-bladed instrument [v]\n",
  "SCISSORTAIL": "an American flycatcher [n -S]\n",
  "SCISSORTAILS": "SCISSORTAIL, an American flycatcher [n]\n",
  "SCISSORWISE": "in the fashion of scissors [adv]\n",
  "SCISSURE": "a lengthwise cut [n -S]\n",
  "SCISSURES": "SCISSURE, a lengthwise cut [n]\n",
  "SCITAMINEOUS": "of the Scitamineae, an order of monocotyledons including the banana, ginger, Indian shot, and arrowroot families [adj]\n",
  "SCIURID": "a member of the squirrel family, also SCIURINE, SCIUROID [n -S]\n",
  "SCIURIDS": "SCIURID, a member of the squirrel family, also SCIURINE, SCIUROID [n]\n",
  "SCIURINE": "a member of the squirrel family, also SCIURID, SCIUROID [n -S]\n",
  "SCIURINES": "SCIURINE, a member of the squirrel family, also SCIURID, SCIUROID [n]\n",
  "SCIUROID": "of or relating to squirrels or chipmunks, also SCIURID, SCIURINE [adj]\n",
  "SCLAFF": "to strike the ground with a club before hitting the ball [v -ED, -ING, -S]\n",
  "SCLAFFED": "SCLAFF, to strike the ground with a club before hitting the ball [v]\n",
  "SCLAFFER": "one who sclaffs, slaps [n -S]\n",
  "SCLAFFERS": "SCLAFFER, one who sclaffs, slaps [n]\n",
  "SCLAFFING": "SCLAFF, to strike the ground with a club before hitting the ball [v]\n",
  "SCLAFFS": "SCLAFF, to strike the ground with a club before hitting the ball [v]\n",
  "SCLATE": "(Scots) slate [n -S] / to slate [v SCLATED, SCLATING, SCLATES]\n",
  "SCLATED": "SCLATE, to slate [v]\n",
  "SCLATES": "SCLATE, (Scots) slate [n]\n",
  "SCLATING": "SCLATE, to slate [v]\n",
  "SCLAUNDER": "(obsolete) slander [n -S]\n",
  "SCLAUNDERS": "SCLAUNDER, (obsolete) slander [n]\n",
  "SCLAVE": "(obsolete) a slave [n -S]\n",
  "SCLAVES": "SCLAVE, (obsolete) a slave [n]\n",
  "SCLERA": "(Greek) the outermost membrane of the eyeball [n SCLERAS or SCLERAE]\n",
  "SCLERAE": "SCLERA, (Greek) the outermost membrane of the eyeball [n]\n",
  "SCLERAL": "pertaining to the sclera [adj]\n",
  "SCLERAS": "SCLERA, (Greek) the outermost membrane of the eyeball [n]\n",
  "SCLERE": "a sponge spicule [n -S]\n",
  "SCLEREID": "a thick-walled plant cell, also SCLEREIDE [n -S]\n",
  "SCLEREIDE": "a thick-walled plant cell, also SCLEREID [n -S]\n",
  "SCLEREIDES": "SCLEREIDE, a thick-walled plant cell, also SCLEREID [n]\n",
  "SCLEREIDS": "SCLEREID, a thick-walled plant cell, also SCLEREIDE [n]\n",
  "SCLEREMA": "(Greek) a hardening of tissues [n -S]\n",
  "SCLEREMAS": "SCLEREMA, (Greek) a hardening of tissues [n]\n",
  "SCLERENCHYMA": "plant tissue consisting of cells with thick lignified walls [n -S]\n",
  "SCLERENCHYMAS": "SCLERENCHYMA, plant tissue consisting of cells with thick lignified walls [n]\n",
  "SCLERENCHYMATA": "SCLERENCHYMA, plant tissue consisting of cells with thick lignified walls [n]\n",
  "SCLERES": "SCLERE, a sponge spicule [n]\n",
  "SCLERIASES": "SCLERIASIS, a morbid induration of the edge of the eyelid [n]\n",
  "SCLERIASIS": "a morbid induration of the edge of the eyelid [n SCLERIASES]\n",
  "SCLERITE": "a hard skeletal plate or spicule [n -S]\n",
  "SCLERITES": "SCLERITE, a hard skeletal plate or spicule [n]\n",
  "SCLERITIC": "of or like a sclerite, a hard chitinous or calcareous process or corpuscle [adj]\n",
  "SCLERITIS": "inflammation of the sclerotic, also SCLEROTITIS [n -ES]\n",
  "SCLERITISES": "SCLERITIS, inflammation of the sclerotic, also SCLEROTITIS [n]\n",
  "SCLEROCAULIES": "SCLEROCAULY, possession of a hard, dry stem [n]\n",
  "SCLEROCAULOUS": "having a hard dry stem [adj]\n",
  "SCLEROCAULY": "possession of a hard, dry stem [n SCLEROCAULIES]\n",
  "SCLERODERM": "one of a tribe of plectognath fishes having the skin covered with hard scales, or plates, as the cowfish and the trunkfish [n -S]\n",
  "SCLERODERMA": "a disease marked by hardening of skin [n SCLERODERMAS or SCLERODERMATA]\n",
  "SCLERODERMAS": "SCLERODERMA, a disease marked by hardening of skin [n]\n",
  "SCLERODERMATA": "SCLERODERMA, a disease marked by hardening of skin [n]\n",
  "SCLERODERMATOUS": "hard-skinned; having bony armour [adj]\n",
  "SCLERODERMIA": "hardness and contraction of the body's connective tissue in which the skin becomes thickened by substitution of fibrous tissue for subcutaneous fat [n -S]\n",
  "SCLERODERMIAS": "SCLERODERMIA, hardness and contraction of the body's connective tissue in which the skin becomes thickened by substitution of fibrous tissue for subcutaneous fat [n]\n",
  "SCLERODERMIC": "hard-skinned; having bony armour [adj]\n",
  "SCLERODERMITE": "the integument of a segment in arthropods [n -S]\n",
  "SCLERODERMITES": "SCLERODERMITE, the integument of a segment in arthropods [n]\n",
  "SCLERODERMOUS": "hard-skinned; having bony armour [adj]\n",
  "SCLERODERMS": "SCLERODERM, one of a tribe of plectognath fishes having the skin covered with hard scales, or plates, as the cowfish and the trunkfish [n]\n",
  "SCLEROID": "of tissue, hard, hardened, also SCLEROTIC, SCLEROUS [adj]\n",
  "SCLEROMA": "(Greek) a hardened patch of cellular tissue [n SCLEROMAS or SCLEROMATA]\n",
  "SCLEROMALACIA": "thinning of the sclerotic coat resulting from inflammation [n -S]\n",
  "SCLEROMALACIAS": "SCLEROMALACIA, thinning of the sclerotic coat resulting from inflammation [n]\n",
  "SCLEROMAS": "SCLEROMA, (Greek) a hardened patch of cellular tissue [n]\n",
  "SCLEROMATA": "SCLEROMA, (Greek) a hardened patch of cellular tissue [n]\n",
  "SCLEROMETER": "an instrument for measuring the hardness of minerals [n -S]\n",
  "SCLEROMETERS": "SCLEROMETER, an instrument for measuring the hardness of minerals [n]\n",
  "SCLEROMETRIC": "pertaining to measurement by sclerometer, an instrument for measuring the hardness of minerals [adj]\n",
  "SCLEROPHYLL": "a hard, leathery leaf; a woody plant, esp. of hot, arid regions, with such leaves [n -S]\n",
  "SCLEROPHYLLIES": "SCLEROPHYLLY, the possession of sclerophylls, hard leathery leaves [n]\n",
  "SCLEROPHYLLOUS": "having sclerophylls, hard leathery leaves [adj]\n",
  "SCLEROPHYLLS": "SCLEROPHYLL, a hard, leathery leaf; a woody plant, esp. of hot, arid regions, with such leaves [n]\n",
  "SCLEROPHYLLY": "the possession of sclerophylls, hard leathery leaves [n SCLEROPHYLLIES]\n",
  "SCLEROPROTEIN": "a large class of proteins found in skeletal and connective tissue [n -S]\n",
  "SCLEROPROTEINS": "SCLEROPROTEIN, a large class of proteins found in skeletal and connective tissue [n]\n",
  "SCLEROSAL": "affected with sclerosis, induration [adj]\n",
  "SCLEROSE": "to harden; to affect with sclerosis [v SCLEROSED, SCLEROSING, SCLEROSES]\n",
  "SCLEROSED": "SCLEROSE, to harden; to affect with sclerosis [v]\n",
  "SCLEROSES": "SCLEROSE, to harden; to affect with sclerosis [v]\n",
  "SCLEROSING": "SCLEROSE, to harden; to affect with sclerosis [v]\n",
  "SCLEROSIS": "hardening; morbid hardening, e.g. of arteries by deposition of fatty plaques [n SCLEROSES]\n",
  "SCLEROTAL": "a sclerotic bone or plate [n -S]\n",
  "SCLEROTALS": "SCLEROTAL, a sclerotic bone or plate [n]\n",
  "SCLEROTIA": "SCLEROTIUM, a hardened body formed by certain fungi, such as by the Claviceps purpurea, which produces ergot [n]\n",
  "SCLEROTIAL": "of or like a sclerotium [adj]\n",
  "SCLEROTIC": "hard, indurated, also SCLEROID, SCLEROUS [adj] / the firm outer coat of the eyeball, which is often cartilaginous and sometimes bony [n -S]\n",
  "SCLEROTICS": "SCLEROTIC, the firm outer coat of the eyeball, which is often cartilaginous and sometimes bony [n]\n",
  "SCLEROTIN": "in insects, a protein in the cuticle that becomes hard and dark [n -S]\n",
  "SCLEROTINS": "SCLEROTIN, in insects, a protein in the cuticle that becomes hard and dark [n]\n",
  "SCLEROTIOID": "of, relating to, or resembling a sclerotium [adj]\n",
  "SCLEROTISATION": "the cross-linking of chitin protein molecules to harden an insect's shell, also SCLEROTIZATION [n -S]\n",
  "SCLEROTISATIONS": "SCLEROTISATION, the cross-linking of chitin protein molecules to harden an insect's shell, also SCLEROTIZATION [n]\n",
  "SCLEROTISE": "to harden or darken, also SCLEROTIZE [v SCLEROTISED, SCLEROTISING, SCLEROTISES]\n",
  "SCLEROTISED": "SCLEROTISE, to harden or darken, also SCLEROTIZE [v]\n",
  "SCLEROTISES": "SCLEROTISE, to harden or darken, also SCLEROTIZE [v]\n",
  "SCLEROTISING": "SCLEROTISE, to harden or darken, also SCLEROTIZE [v]\n",
  "SCLEROTITIS": "inflammation of the sclerotic, also SCLERITIS [n -ES]\n",
  "SCLEROTITISES": "SCLEROTITIS, inflammation of the sclerotic, also SCLERITIS [n]\n",
  "SCLEROTIUM": "a hardened body formed by certain fungi, such as by the Claviceps purpurea, which produces ergot [n SCLEROTIA]\n",
  "SCLEROTIZATION": "the cross-linking of chitin protein molecules to harden an insect's shell, also SCLEROTISATION [n -S]\n",
  "SCLEROTIZATIONS": "SCLEROTIZATION, the cross-linking of chitin protein molecules to harden an insect's shell, also SCLEROTISATION [n]\n",
  "SCLEROTIZE": "to harden or darken, also SCLEROTISE [v SCLEROTIZED, SCLEROTIZING, SCLEROTIZES]\n",
  "SCLEROTIZED": "SCLEROTIZE, to harden or darken, also SCLEROTISE [v]\n",
  "SCLEROTIZES": "SCLEROTIZE, to harden or darken, also SCLEROTISE [v]\n",
  "SCLEROTIZING": "SCLEROTIZE, to harden or darken, also SCLEROTISE [v]\n",
  "SCLEROTOMIES": "SCLEROTOMY, an incision into the sclera [n]\n",
  "SCLEROTOMY": "an incision into the sclera [n SCLEROTOMIES]\n",
  "SCLEROUS": "hard, indurated, also SCLEROID, SCLEROTIC [adj]\n",
  "SCLIFF": "(Scots) a small segment or piece, also SKLIFF [n -S]\n",
  "SCLIFFS": "SCLIFF, (Scots) a small segment or piece, also SKLIFF [n]\n",
  "SCLIM": "(Scots) to climb, also SKLIM [v SCLIMMED, SCLIMMING, SCLIMS]\n",
  "SCLIMMED": "SCLIM, (Scots) to climb, also SKLIM [v]\n",
  "SCLIMMING": "SCLIM, (Scots) to climb, also SKLIM [v]\n",
  "SCLIMS": "SCLIM, (Scots) to climb, also SKLIM [v]\n",
  "SCODIER": "SCODY, (NZ) unkempt, dirty, also SKODY [adj]\n",
  "SCODIEST": "SCODY, (NZ) unkempt, dirty, also SKODY [adj]\n",
  "SCODY": "(NZ) unkempt, dirty, also SKODY [adj SCODIER, SCODIEST]\n",
  "SCOFF": "to express rude doubt or derision, also SKOFF [v -ED, -ING, -S]\n",
  "SCOFFED": "SCOFF, to express rude doubt or derision, also SKOFF [v]\n",
  "SCOFFER": "one who scoffs [n -S]\n",
  "SCOFFERS": "SCOFFER, one who scoffs [n]\n",
  "SCOFFING": "scornful [adj SCOFFINGLY] / the act of scoffing [n -S]\n",
  "SCOFFINGLY": "SCOFFING, scornful [adv]\n",
  "SCOFFINGS": "SCOFFING, the act of scoffing [n]\n",
  "SCOFFLAW": "a habitual law violator [n -S]\n",
  "SCOFFLAWS": "SCOFFLAW, a habitual law violator [n]\n",
  "SCOFFS": "SCOFF, to express rude doubt or derision, also SKOFF [v]\n",
  "SCOG": "(Scots) to shelter, also SCOOG, SCOUG, SCUG, SKOG, SKUG [v SCOGGED, SCOGGING, SCOGS]\n",
  "SCOGGED": "SCOG, (Scots) to shelter, also SCOOG, SCOUG, SCUG, SKOG, SKUG [v]\n",
  "SCOGGING": "SCOG, (Scots) to shelter, also SCOOG, SCOUG, SCUG, SKOG, SKUG [v]\n",
  "SCOGS": "SCOG, (Scots) to shelter, also SCOOG, SCOUG, SCUG, SKOG, SKUG [v]\n",
  "SCOINSON": "the inner part of a door jamb or window frame, also SCONCHEON, SCONTION, SCUNCHEON [n -S]\n",
  "SCOINSONS": "SCOINSON, the inner part of a door jamb or window frame, also SCONCHEON, SCONTION, SCUNCHEON [n]\n",
  "SCOLD": "to rebuke harshly [v -ED, -ING, -S]\n",
  "SCOLDABLE": "able to be scolded [adj]\n",
  "SCOLDED": "SCOLD, to rebuke harshly [v]\n",
  "SCOLDER": "one who scolds [n -S]\n",
  "SCOLDERS": "SCOLDER, one who scolds [n]\n",
  "SCOLDING": "a harsh reproof [n -S]\n",
  "SCOLDINGLY": "SCOLDING [adv]\n",
  "SCOLDINGS": "SCOLDING, a harsh reproof [n]\n",
  "SCOLDS": "SCOLD, to rebuke harshly [v]\n",
  "SCOLECES": "SCOLEX, (Greek) the knoblike head of a tapeworm [n]\n",
  "SCOLECID": "a worm of the Scolecida, the class of tapeworms [n -S]\n",
  "SCOLECIDS": "SCOLECID, a worm of the Scolecida, the class of tapeworms [n]\n",
  "SCOLECIFORM": "tapeworm-shaped [adj]\n",
  "SCOLECITE": "a hydrous silicate of alumina and lime, occurring in delicate radiating groups of white crystals [n -S]\n",
  "SCOLECITES": "SCOLECITE, a hydrous silicate of alumina and lime, occurring in delicate radiating groups of white crystals [n]\n",
  "SCOLECOID": "like a scolex, the head of a tapeworm [adj]\n",
  "SCOLEX": "(Greek) the knoblike head of a tapeworm [n SCOLECES or SCOLICES]\n",
  "SCOLIA": "SCOLION, (Greek) a Greek drinking song, also SKOLION [n]\n",
  "SCOLICES": "SCOLEX, (Greek) the knoblike head of a tapeworm [n]\n",
  "SCOLIOMA": "(Greek) abnormal curvature of the spine [n -S]\n",
  "SCOLIOMAS": "SCOLIOMA, (Greek) abnormal curvature of the spine [n]\n",
  "SCOLION": "(Greek) a Greek drinking song, also SKOLION [n SCOLIA]\n",
  "SCOLIOSES": "SCOLIOSIS, a lateral curvature of the spine [n]\n",
  "SCOLIOSIS": "a lateral curvature of the spine [n SCOLIOSES]\n",
  "SCOLIOTIC": "affected by scoliosis, a lateral curvature of the spine [adj]\n",
  "SCOLLOP": "to indent like a shell, also SCALLOP, ESCALLOP, ESCALOP [v -ED, -ING, -S]\n",
  "SCOLLOPED": "SCOLLOP, to indent like a shell, also SCALLOP, ESCALLOP, ESCALOP [v]\n",
  "SCOLLOPING": "SCOLLOP, to indent like a shell, also SCALLOP, ESCALLOP, ESCALOP [v]\n",
  "SCOLLOPS": "SCOLLOP, to indent like a shell, also SCALLOP, ESCALLOP, ESCALOP [v]\n",
  "SCOLOPACEOUS": "snipelike [adj]\n",
  "SCOLOPENDRA": "a centipede of the genus Scolopendra of myriapods, including large tropical centipedes up to a foot in length [n -S]\n",
  "SCOLOPENDRAS": "SCOLOPENDRA, a centipede of the genus Scolopendra of myriapods, including large tropical centipedes up to a foot in length [n]\n",
  "SCOLOPENDRID": "any centipede of the family Scolopendridae [n -S]\n",
  "SCOLOPENDRIDS": "SCOLOPENDRID, any centipede of the family Scolopendridae [n]\n",
  "SCOLOPENDRIFORM": "having the form of a centipede [adj]\n",
  "SCOLOPENDRINE": "like a centipede of the family Scolopendridae [adj]\n",
  "SCOLOPENDRIUM": "any fern with undivided leaves of the genus Scolopendrium, including hart's tongue [n -S]\n",
  "SCOLOPENDRIUMS": "SCOLOPENDRIUM, any fern with undivided leaves of the genus Scolopendrium, including hart's tongue [n]\n",
  "SCOLYTID": "(Greek) any one of numerous species of small bark-boring beetles, also SCOLYTOID [n -S]\n",
  "SCOLYTIDS": "SCOLYTID, (Greek) any one of numerous species of small bark-boring beetles, also SCOLYTOID [n]\n",
  "SCOLYTOID": "a member of the Scolytidae, bark-beetles, also SCOLYTID [n -S]\n",
  "SCOLYTOIDS": "SCOLYTOID, a member of the Scolytidae, bark-beetles, also SCOLYTID [n]\n",
  "SCOMBRID": "a fish of the Scombridae, the mackerel genus, also SCOMBROID [n -S]\n",
  "SCOMBRIDS": "SCOMBRID, a fish of the Scombridae, the mackerel genus, also SCOMBROID [n]\n",
  "SCOMBROID": "any member of the mackerel family, also SCOMBRID [n -S]\n",
  "SCOMBROIDS": "SCOMBROID, any member of the mackerel family, also SCOMBRID [n]\n",
  "SCOMFISH": "(Scots) to suffocate or stifle; to smother, also SCUMFISH [v -ED, -ING, -ES]\n",
  "SCOMFISHED": "SCOMFISH, (Scots) to suffocate or stifle; to smother, also SCUMFISH [v]\n",
  "SCOMFISHES": "SCOMFISH, (Scots) to suffocate or stifle; to smother, also SCUMFISH [v]\n",
  "SCOMFISHING": "SCOMFISH, (Scots) to suffocate or stifle; to smother, also SCUMFISH [v]\n",
  "SCONCE": "to entrench, to screen [v SCONCED, SCONCING, SCONCES]\n",
  "SCONCED": "SCONCE, to entrench, to screen [v]\n",
  "SCONCES": "SCONCE, to entrench, to screen [v]\n",
  "SCONCHEON": "the inner part of a door jamb or window frame, also SCOINSON, SCONTION, SCUNCHEON [n -S]\n",
  "SCONCHEONS": "SCONCHEON, the inner part of a door jamb or window frame, also SCOINSON, SCONTION, SCUNCHEON [n]\n",
  "SCONCING": "SCONCE, to entrench, to screen [v]\n",
  "SCONE": "a flattish, usually round or quadrant-shaped plain cake of dough, baked on a griddle or in an oven [n -S]\n",
  "SCONES": "SCONE, a flattish, usually round or quadrant-shaped plain cake of dough, baked on a griddle or in an oven [n]\n",
  "SCONTION": "the inner part of a door jamb or window frame, also SCOINSON, SCONCHEON, SCUNCHEON [n -S]\n",
  "SCONTIONS": "SCONTION, the inner part of a door jamb or window frame, also SCOINSON, SCONCHEON, SCUNCHEON [n]\n",
  "SCOOBIES": "SCOOBY, a clue, as in the phrase I don't have a scooby doo, a clue [n]\n",
  "SCOOBY": "a clue, as in the phrase I don't have a scooby doo, a clue [n SCOOBIES]\n",
  "SCOOCH": "to compress one's body into a smaller space, also SCOOTCH [v -ED, -ING, -ES]\n",
  "SCOOCHED": "SCOOCH, to compress one's body into a smaller space, also SCOOTCH [v]\n",
  "SCOOCHES": "SCOOCH, to compress one's body into a smaller space, also SCOOTCH [v]\n",
  "SCOOCHING": "SCOOCH, to compress one's body into a smaller space, also SCOOTCH [v]\n",
  "SCOOG": "(Scots) to shelter, also SCOG, SCOUG, SCUG, SKOG, SKUG [v -ED, -ING, -S]\n",
  "SCOOGED": "SCOOG, (Scots) to shelter, also SCOG, SCOUG, SCUG, SKOG, SKUG [v]\n",
  "SCOOGING": "SCOOG, (Scots) to shelter, also SCOG, SCOUG, SCUG, SKOG, SKUG [v]\n",
  "SCOOGS": "SCOOG, (Scots) to shelter, also SCOG, SCOUG, SCUG, SKOG, SKUG [v]\n",
  "SCOOP": "to lift with a spoon-like utensil [v -ED, -ING, -S]\n",
  "SCOOPABLE": "that can be scooped [adj]\n",
  "SCOOPED": "SCOOP, to lift with a spoon-like utensil [v]\n",
  "SCOOPER": "a tool used esp. in engraving, for hollowing out portions of the surface worked [n -S]\n",
  "SCOOPERS": "SCOOPER, a tool used esp. in engraving, for hollowing out portions of the surface worked [n]\n",
  "SCOOPFUL": "as much as a scoop can hold [n SCOOPFULS or SCOOPSFUL]\n",
  "SCOOPFULS": "SCOOPFUL, as much as a scoop can hold [n]\n",
  "SCOOPING": "the act of scooping [n -S]\n",
  "SCOOPINGS": "SCOOPING, the act of scooping [n]\n",
  "SCOOPS": "SCOOP, to lift with a spoon-like utensil [v]\n",
  "SCOOPSFUL": "SCOOPFUL, as much as a scoop can hold [n]\n",
  "SCOOSH": "to squirt, also SKOOSH [v -ED, -ING, -ES]\n",
  "SCOOSHED": "SCOOSH, to squirt, also SKOOSH [v]\n",
  "SCOOSHES": "SCOOSH, to squirt, also SKOOSH [v]\n",
  "SCOOSHING": "SCOOSH, to squirt, also SKOOSH [v]\n",
  "SCOOT": "to go quickly [v -ED, -ING, -S]\n",
  "SCOOTCH": "to compress one's body into a smaller space, also SCOOCH [v -ED, -ING, -ES]\n",
  "SCOOTCHED": "SCOOTCH, to compress one's body into a smaller space, also SCOOCH [v]\n",
  "SCOOTCHES": "SCOOTCH, to compress one's body into a smaller space, also SCOOCH [v]\n",
  "SCOOTCHING": "SCOOTCH, to compress one's body into a smaller space, also SCOOCH [v]\n",
  "SCOOTED": "SCOOT, to go quickly [v]\n",
  "SCOOTER": "to travel by by a two-wheeled vehicle [v -ED, -ING, -S]\n",
  "SCOOTERED": "SCOOTER, to travel by by a two-wheeled vehicle [v]\n",
  "SCOOTERING": "SCOOTER, to travel by by a two-wheeled vehicle [v]\n",
  "SCOOTERIST": "one who rides a scooter [n -S]\n",
  "SCOOTERISTS": "SCOOTERIST, one who rides a scooter [n]\n",
  "SCOOTERS": "SCOOTER, to travel by by a two-wheeled vehicle [v]\n",
  "SCOOTING": "SCOOT, to go quickly [v]\n",
  "SCOOTS": "SCOOT, to go quickly [v]\n",
  "SCOP": "(Old English) an Anglo-Saxon poet and harpist [n SCOPS or SCOPAS]\n",
  "SCOPA": "(Latin) a brushlike tuft on back legs or abdomen of bees [n SCOPAE]\n",
  "SCOPAE": "SCOPA, (Latin) a brushlike tuft on back legs or abdomen of bees [n]\n",
  "SCOPAS": "SCOP, (Old English) an Anglo-Saxon poet and harpist [n]\n",
  "SCOPATE": "tufted, brushlike [adj]\n",
  "SCOPE": "to examine with a viewing instrument [v SCOPED, SCOPING, SCOPES]\n",
  "SCOPED": "SCOPE, to examine with a viewing instrument [v]\n",
  "SCOPELID": "(Greek) a member of the Scopelidae, a genus of deepwater fish, also SCOPELOID [n -S]\n",
  "SCOPELIDS": "SCOPELID, (Greek) a member of the Scopelidae, a genus of deepwater fish, also SCOPELOID [n]\n",
  "SCOPELOID": "(Greek) a member of the Scopelidae, a genus of deepwater fish, also SCOPELID [n -S]\n",
  "SCOPELOIDS": "SCOPELOID, (Greek) a member of the Scopelidae, a genus of deepwater fish, also SCOPELID [n]\n",
  "SCOPES": "SCOPE, to examine with a viewing instrument [v]\n",
  "SCOPING": "SCOPE, to examine with a viewing instrument [v]\n",
  "SCOPOLAMINE": "a sleep-inducing drug obtained from nightshade family of plants [n -S]\n",
  "SCOPOLAMINES": "SCOPOLAMINE, a sleep-inducing drug obtained from nightshade family of plants [n]\n",
  "SCOPOLINE": "a liquid extract of scopolamine, used as a sedative [n -S]\n",
  "SCOPOLINES": "SCOPOLINE, a liquid extract of scopolamine, used as a sedative [n]\n",
  "SCOPOPHILIA": "the practice of obtaining sexual pleasure from things seen, as e.g. naked bodies, also SCOPTOPHILIA [n -S]\n",
  "SCOPOPHILIAC": "one who derives sexual pleasure from things seen, as e.g. naked bodies [n -S]\n",
  "SCOPOPHILIACS": "SCOPOPHILIAC, one who derives sexual pleasure from things seen, as e.g. naked bodies [n]\n",
  "SCOPOPHILIAS": "SCOPOPHILIA, the practice of obtaining sexual pleasure from things seen, as e.g. naked bodies, also SCOPTOPHILIA [n]\n",
  "SCOPOPHILIC": "relating to scopophilia [adj]\n",
  "SCOPOPHOBIA": "fear of being looked at, also SCOPTOPHOBIA [n -S]\n",
  "SCOPOPHOBIAS": "SCOPOPHOBIA, fear of being looked at, also SCOPTOPHOBIA [n]\n",
  "SCOPS": "SCOP, (Old English) an Anglo-Saxon poet and harpist [n]\n",
  "SCOPTOPHILIA": "the practice of obtaining sexual pleasure from things seen, as e.g. naked bodies, also SCOPOPHILIA [n -S]\n",
  "SCOPTOPHILIAS": "SCOPTOPHILIA, the practice of obtaining sexual pleasure from things seen, as e.g. naked bodies, also SCOPOPHILIA [n]\n",
  "SCOPTOPHOBIA": "fear of being looked at, also SCOPOPHOBIA [n -S]\n",
  "SCOPTOPHOBIAS": "SCOPTOPHOBIA, fear of being looked at, also SCOPOPHOBIA [n]\n",
  "SCOPULA": "(Latin) a brushlike tuft of hairs on legs of some spiders [n SCOPULAE or SCOPULAS]\n",
  "SCOPULAE": "SCOPULA, (Latin) a brushlike tuft of hairs on legs of some spiders [n]\n",
  "SCOPULAS": "SCOPULA, (Latin) a brushlike tuft of hairs on legs of some spiders [n]\n",
  "SCOPULATE": "like a scopula, a little tuft of hairs [adj]\n",
  "SCORBUTIC": "pertaining to or afflicted with scurvy [adj SCORBUTICALLY]\n",
  "SCORBUTICALLY": "SCORBUTIC, pertaining to or afflicted with scurvy [adv]\n",
  "SCORCH": "to burn slightly [v -ED, -ING, -ES]\n",
  "SCORCHED": "SCORCH, to burn slightly [v]\n",
  "SCORCHER": "(colloquial) a very hot day [n -S]\n",
  "SCORCHERS": "SCORCHER, (colloquial) a very hot day [n]\n",
  "SCORCHES": "SCORCH, to burn slightly [v]\n",
  "SCORCHING": "very hot [adj SCORCHINGLY] / the act of scorching [n -S]\n",
  "SCORCHINGLY": "SCORCHING, very hot [adv]\n",
  "SCORCHINGNESS": "the state of being scorching [n -ES]\n",
  "SCORCHINGNESSES": "SCORCHINGNESS, the state of being scorching [n]\n",
  "SCORCHINGS": "SCORCHING, the act of scorching [n]\n",
  "SCORDATO": "(Italian) put out of tune [adv]\n",
  "SCORDATURA": "(Italian) a temporary departure from the normal tuning of a stringed instrument [n -S]\n",
  "SCORDATURAS": "SCORDATURA, (Italian) a temporary departure from the normal tuning of a stringed instrument [n]\n",
  "SCORE": "to achieve a success [v SCORED, SCORING, SCORES]\n",
  "SCOREBOARD": "a large board for displaying the score of a game or match [n -S]\n",
  "SCOREBOARDS": "SCOREBOARD, a large board for displaying the score of a game or match [n]\n",
  "SCORECARD": "a card or sheet for recording the score in a game, also SCORESHEET [n -S]\n",
  "SCORECARDS": "SCORECARD, a card or sheet for recording the score in a game, also SCORESHEET [n]\n",
  "SCORED": "SCORE, to achieve a success [v]\n",
  "SCOREKEEPER": "one that keeps score [n -S]\n",
  "SCOREKEEPERS": "SCOREKEEPER, one that keeps score [n]\n",
  "SCORELESS": "without a score [adj]\n",
  "SCORELINE": "the result in a game [n -S]\n",
  "SCORELINES": "SCORELINE, the result in a game [n]\n",
  "SCOREPAD": "a pad on which scored points are recorded [n -S]\n",
  "SCOREPADS": "SCOREPAD, a pad on which scored points are recorded [n]\n",
  "SCORER": "one that scores [n -S]\n",
  "SCORERS": "SCORER, one that scores [n]\n",
  "SCORES": "SCORE, to achieve a success [v]\n",
  "SCORESHEET": "a card or sheet, for recording the score in a game, also SCORECARD [n -S]\n",
  "SCORESHEETS": "SCORESHEET, a card or sheet, for recording the score in a game, also SCORECARD [n]\n",
  "SCORIA": "(Latin) the dross or slag from metal smelting [n SCORIAE]\n",
  "SCORIAC": "like slag, also SCORIACEOUS, SCORIOUS [adj]\n",
  "SCORIACEOUS": "like slag, also SCORIAC, SCORIOUS [adj]\n",
  "SCORIAE": "SCORIA, (Latin) the dross or slag from metal smelting [n]\n",
  "SCORIFICATION": "the act of scorifying [n -S]\n",
  "SCORIFICATIONS": "SCORIFICATION, the act of scorifying [n]\n",
  "SCORIFIED": "SCORIFY, to reduce to scoria [v]\n",
  "SCORIFIER": "a thing which scorifies something; specifically a fireclay vessel used in the process of refining or assaying [n -S]\n",
  "SCORIFIERS": "SCORIFIER, a thing which scorifies something; specifically a fireclay vessel used in the process of refining or assaying [n]\n",
  "SCORIFIES": "SCORIFY, to reduce to scoria [v]\n",
  "SCORIFY": "to reduce to scoria [v SCORIFIED, SCORIFYING, SCORIFIES]\n",
  "SCORIFYING": "SCORIFY, to reduce to scoria [v]\n",
  "SCORING": "orchestration [n -S]\n",
  "SCORINGS": "SCORING, orchestration [n]\n",
  "SCORIOUS": "like slag, also SCORIAC, SCORIACEOUS [adj]\n",
  "SCORN": "to treat with contempt [v -ED, -ING, -S]\n",
  "SCORNED": "SCORN, to treat with contempt [v]\n",
  "SCORNER": "one who scorns [n -S]\n",
  "SCORNERS": "SCORNER, one who scorns [n]\n",
  "SCORNFUL": "expressing contempt [adj SCORNFULLY]\n",
  "SCORNFULLY": "SCORNFUL, expressing contempt [adv]\n",
  "SCORNFULNESS": "the state of being scornful [n -ES]\n",
  "SCORNFULNESSES": "SCORNFULNESS, the state of being scornful [n]\n",
  "SCORNING": "the act of scorning [n -S]\n",
  "SCORNINGS": "SCORNING, the act of scorning [n]\n",
  "SCORNS": "SCORN, to treat with contempt [v]\n",
  "SCORODITE": "an orthorhombic hydrated arsenate of iron and aluminium [n -S]\n",
  "SCORODITES": "SCORODITE, an orthorhombic hydrated arsenate of iron and aluminium [n]\n",
  "SCORPAENID": "any fish of the family Scorpaenidae, spiny-finned marine fish with large armoured heads [n -S]\n",
  "SCORPAENIDS": "SCORPAENID, any fish of the family Scorpaenidae, spiny-finned marine fish with large armoured heads [n]\n",
  "SCORPAENOID": "any member of the scorpion fish family [n -S]\n",
  "SCORPAENOIDS": "SCORPAENOID, any member of the scorpion fish family [n]\n",
  "SCORPER": "a semicircular gouging chisel, also SCALPER, SCAUPER [n -S]\n",
  "SCORPERS": "SCORPER, a semicircular gouging chisel, also SCALPER, SCAUPER [n]\n",
  "SCORPIOID": "a scorpion; a scorpion-like animal [n -S]\n",
  "SCORPIOIDS": "SCORPIOID, a scorpion; a scorpion-like animal [n]\n",
  "SCORPION": "any arachnid of the genus Scorpio [n -S]\n",
  "SCORPIONIC": "of or like a scorpion [adj]\n",
  "SCORPIONS": "SCORPION, any arachnid of the genus Scorpio [n]\n",
  "SCORRENDO": "(Italian) in a gliding manner [adv]\n",
  "SCORSE": "(obsolete) to exchange, also SCOURSE [v SCORSED, SCORSING, SCORSES]\n",
  "SCORSED": "SCORSE, (obsolete) to exchange, also SCOURSE [v]\n",
  "SCORSER": "one who barters [n -S]\n",
  "SCORSERS": "SCORSER, one who barters [n]\n",
  "SCORSES": "SCORSE, (obsolete) to exchange, also SCOURSE [v]\n",
  "SCORSING": "SCORSE, (obsolete) to exchange, also SCOURSE [v]\n",
  "SCORZONERA": "(Italian) a plant of the genus Scorzonera, black salsify [n -S]\n",
  "SCORZONERAS": "SCORZONERA, (Italian) a plant of the genus Scorzonera, black salsify [n]\n",
  "SCOT": "(historical) money assessed or paid [n -S]\n",
  "SCOTCH": "to frustrate, put an end to [v -ED, -ING, -ES]\n",
  "SCOTCHED": "SCOTCH, to frustrate, put an end to [v]\n",
  "SCOTCHES": "SCOTCH, to frustrate, put an end to [v]\n",
  "SCOTCHING": "SCOTCH, to frustrate, put an end to [v]\n",
  "SCOTER": "a sea duck [n -S]\n",
  "SCOTERS": "SCOTER, a sea duck [n]\n",
  "SCOTIA": "(Greek) a concave molding used esp. in classical architecture [n -S]\n",
  "SCOTIAS": "SCOTIA, (Greek) a concave molding used esp. in classical architecture [n]\n",
  "SCOTODINIA": "dizziness together with headache and loss of vision [n -S]\n",
  "SCOTODINIAS": "SCOTODINIA, dizziness together with headache and loss of vision [n]\n",
  "SCOTOMA": "(Greek) dizziness with dimness of sight, also SCOTOMIA, SCOTOMY [n SCOTOMAS or SCOTOMATA]\n",
  "SCOTOMAS": "SCOTOMA, (Greek) dizziness with dimness of sight, also SCOTOMIA, SCOTOMY [n]\n",
  "SCOTOMATA": "SCOTOMA, (Greek) dizziness with dimness of sight, also SCOTOMIA, SCOTOMY [n]\n",
  "SCOTOMATOUS": "relating to scotoma [adj]\n",
  "SCOTOMETER": "an instrument for detecting defects in the visual field [n -S]\n",
  "SCOTOMETERS": "SCOTOMETER, an instrument for detecting defects in the visual field [n]\n",
  "SCOTOMIA": "(obsolete) dizziness with dimness of sight, also SCOTOMA, SCOTOMY [n -S]\n",
  "SCOTOMIAS": "SCOTOMIA, (obsolete) dizziness with dimness of sight, also SCOTOMA, SCOTOMY [n]\n",
  "SCOTOMIES": "SCOTOMY, (obsolete) dizziness with dimness of sight, also SCOTOMA, SCOTOMIA [n]\n",
  "SCOTOMY": "(obsolete) dizziness with dimness of sight, also SCOTOMA, SCOTOMIA [n SCOTOMIES]\n",
  "SCOTOPHIL": "liking darkness [adj]\n",
  "SCOTOPIA": "(Greek) vision in dim light [n -S]\n",
  "SCOTOPIAS": "SCOTOPIA, (Greek) vision in dim light [n]\n",
  "SCOTOPIC": "relating to scotopia, vision in dim light or darkness [adj]\n",
  "SCOTS": "SCOT, (historical) money assessed or paid [n]\n",
  "SCOTTIE": "a short-legged terrier [n -S]\n",
  "SCOTTIES": "SCOTTIE, a short-legged terrier [n]\n",
  "SCOUG": "(Scots) to shelter, also SCOG, SCOOG, SCUG, SKOG, SKUG [v -ED, -ING, -S]\n",
  "SCOUGED": "SCOUG, (Scots) to shelter, also SCOG, SCOOG, SCUG, SKOG, SKUG [v]\n",
  "SCOUGING": "SCOUG, (Scots) to shelter, also SCOG, SCOOG, SCUG, SKOG, SKUG [v]\n",
  "SCOUGS": "SCOUG, (Scots) to shelter, also SCOG, SCOOG, SCUG, SKOG, SKUG [v]\n",
  "SCOUNDREL": "a rascal [n -S]\n",
  "SCOUNDRELLIER": "SCOUNDRELLY, like a scoundrel [adj]\n",
  "SCOUNDRELLIEST": "SCOUNDRELLY, like a scoundrel [adj]\n",
  "SCOUNDRELLY": "like a scoundrel [adj SCOUNDRELLIER, SCOUNDRELLIEST]\n",
  "SCOUNDRELS": "SCOUNDREL, a rascal [n]\n",
  "SCOUP": "(Scots) to bound, caper, also SCOWP [v -ED, -ING, -S]\n",
  "SCOUPED": "SCOUP, (Scots) to bound, caper, also SCOWP [v]\n",
  "SCOUPING": "SCOUP, (Scots) to bound, caper, also SCOWP [v]\n",
  "SCOUPS": "SCOUP, (Scots) to bound, caper, also SCOWP [v]\n",
  "SCOUR": "to cleanse by hard rubbing [v -ED, -ING, -S]\n",
  "SCOURED": "SCOUR, to cleanse by hard rubbing [v]\n",
  "SCOURER": "(historical) a member of a roistering band that roamed the streets maltreating watchmen etc., also SCOWRER [n -S]\n",
  "SCOURERS": "SCOURER, (historical) a member of a roistering band that roamed the streets maltreating watchmen etc., also SCOWRER [n]\n",
  "SCOURGE": "to whip severely [v SCOURGED, SCOURGING, SCOURGES]\n",
  "SCOURGED": "SCOURGE, to whip severely [v]\n",
  "SCOURGER": "one who scourges [n -S]\n",
  "SCOURGERS": "SCOURGER, one who scourges [n]\n",
  "SCOURGES": "SCOURGE, to whip severely [v]\n",
  "SCOURGING": "a flogging [n -S]\n",
  "SCOURGINGS": "SCOURGING, a flogging [n]\n",
  "SCOURIE": "(Old Norse) in the Orkneys, a young gull, also SCAURY, SCOWRIE [n -S]\n",
  "SCOURIES": "SCOURIE, (Old Norse) in the Orkneys, a young gull, also SCAURY, SCOWRIE [n]\n",
  "SCOURING": "material removed by scouring [n -S]\n",
  "SCOURINGS": "SCOURING, material removed by scouring [n]\n",
  "SCOURS": "SCOUR, to cleanse by hard rubbing [v]\n",
  "SCOURSE": "to barter, exchange, also SCORSE [v SCOURSED, SCOURSING, SCOURSES]\n",
  "SCOURSED": "SCOURSE, to barter, exchange, also SCORSE [v]\n",
  "SCOURSES": "SCOURSE, to barter, exchange, also SCORSE [v]\n",
  "SCOURSING": "SCOURSE, to barter, exchange, also SCORSE [v]\n",
  "SCOUSE": "a type of meat stew [n -S]\n",
  "SCOUSER": "a native of Liverpool [n -S]\n",
  "SCOUSERS": "SCOUSER, a native of Liverpool [n]\n",
  "SCOUSES": "SCOUSE, a type of meat stew [n]\n",
  "SCOUT": "to reconnoitre [v -ED, -ING, -S]\n",
  "SCOUTCRAFT": "the knowledge and skill proper to a scout [n -S]\n",
  "SCOUTCRAFTS": "SCOUTCRAFT, the knowledge and skill proper to a scout [n]\n",
  "SCOUTED": "SCOUT, to reconnoitre [v]\n",
  "SCOUTER": "an adult working with instructors etc. in the Scout Association [n -S]\n",
  "SCOUTERS": "SCOUTER, an adult working with instructors etc. in the Scout Association [n]\n",
  "SCOUTH": "(Scots) free range, plenty, also SCOWTH [n -S]\n",
  "SCOUTHER": "(Scots) to scorch, also SCOWDER, SCOWTHER [v -ED, -ING, -S]\n",
  "SCOUTHERED": "SCOUTHER, (Scots) to scorch, also SCOWDER, SCOWTHER [v]\n",
  "SCOUTHERING": "a scorching [n -S]\n",
  "SCOUTHERINGS": "SCOUTHERING, a scorching [n]\n",
  "SCOUTHERS": "SCOUTHER, (Scots) to scorch, also SCOWDER, SCOWTHER [v]\n",
  "SCOUTHERY": "scorching, singeing [adj]\n",
  "SCOUTHS": "SCOUTH, (Scots) free range, plenty, also SCOWTH [n]\n",
  "SCOUTING": "the act of one who scouts [n -S]\n",
  "SCOUTINGS": "SCOUTING, the act of one who scouts [n]\n",
  "SCOUTMASTER": "the leader of a band of scouts [n -S]\n",
  "SCOUTMASTERS": "SCOUTMASTER, the leader of a band of scouts [n]\n",
  "SCOUTS": "SCOUT, to reconnoitre [v]\n",
  "SCOW": "to transport by flat-bottomed boat [v -ED, -ING, -S]\n",
  "SCOWDER": "(Scots) to scorch, also SCOUTHER, SCOWTHER [v -ED, -ING, -S]\n",
  "SCOWDERED": "SCOWDER, (Scots) to scorch, also SCOUTHER, SCOWTHER [v]\n",
  "SCOWDERING": "a scorching [n -S]\n",
  "SCOWDERINGS": "SCOWDERING, a scorching [n]\n",
  "SCOWDERS": "SCOWDER, (Scots) to scorch, also SCOUTHER, SCOWTHER [v]\n",
  "SCOWED": "SCOW, to transport by flat-bottomed boat [v]\n",
  "SCOWING": "SCOW, to transport by flat-bottomed boat [v]\n",
  "SCOWL": "to frown angrily [v -ED, -ING, -S]\n",
  "SCOWLED": "SCOWL, to frown angrily [v]\n",
  "SCOWLER": "one who scowls [n -S]\n",
  "SCOWLERS": "SCOWLER, one who scowls [n]\n",
  "SCOWLING": "SCOWL, to frown angrily [v]\n",
  "SCOWLINGLY": "SCOWLING, SCOWL, to frown angrily [adv]\n",
  "SCOWLS": "SCOWL, to frown angrily [v]\n",
  "SCOWP": "(Scots) to bound, caper, also SCOUP [v -ED, -ING, -S]\n",
  "SCOWPED": "SCOWP, (Scots) to bound, caper, also SCOUP [v]\n",
  "SCOWPING": "SCOWP, (Scots) to bound, caper, also SCOUP [v]\n",
  "SCOWPS": "SCOWP, (Scots) to bound, caper, also SCOUP [v]\n",
  "SCOWRER": "(obsolete) a member of a roistering band that roamed the streets maltreating watchmen etc., also SCOURER [n -S]\n",
  "SCOWRERS": "SCOWRER, (obsolete) a member of a roistering band that roamed the streets maltreating watchmen etc., also SCOURER [n]\n",
  "SCOWRIE": "(Old Norse) in the Orkneys, a young gull, also SCAURY, SCOURIE [n -S]\n",
  "SCOWRIES": "SCOWRIE, (Old Norse) in the Orkneys, a young gull, also SCAURY, SCOURIE [n]\n",
  "SCOWS": "SCOW, to transport by flat-bottomed boat [v]\n",
  "SCOWTH": "(Scots) free range, plenty, also SCOUTH [n -S]\n",
  "SCOWTHER": "(Scots) to scorch, singe, also SCOUTHER, SCOWDER [v -ED, -ING, -S]\n",
  "SCOWTHERED": "SCOWTHER, (Scots) to scorch, singe, also SCOUTHER, SCOWDER [v]\n",
  "SCOWTHERING": "SCOWTHER, (Scots) to scorch, singe, also SCOUTHER, SCOWDER [v]\n",
  "SCOWTHERS": "SCOWTHER, (Scots) to scorch, singe, also SCOUTHER, SCOWDER [v]\n",
  "SCOWTHS": "SCOWTH, (Scots) free range, plenty, also SCOUTH [n]\n",
  "SCOZZA": "(Australian slang) a rowdy person, esp. one the worse for drink [n -S]\n",
  "SCOZZAS": "SCOZZA, (Australian slang) a rowdy person, esp. one the worse for drink [n]\n",
  "SCRAB": "(dialect) to scratch, also SCRAT, SCRATCH, SCRATTLE, SCRAWM [v SCRABBED, SCRABBING, SCRABS]\n",
  "SCRABBED": "SCRAB, (dialect) to scratch, also SCRAT, SCRATCH, SCRATTLE, SCRAWM [v]\n",
  "SCRABBING": "SCRAB, (dialect) to scratch, also SCRAT, SCRATCH, SCRATTLE, SCRAWM [v]\n",
  "SCRABBLE": "to claw or grope about frantically [v SCRABBLED, SCRABBLING, SCRABBLES]\n",
  "SCRABBLED": "SCRABBLE, to claw or grope about frantically [v]\n",
  "SCRABBLER": "one who scrabbles [n -S]\n",
  "SCRABBLERS": "SCRABBLER, one who scrabbles [n]\n",
  "SCRABBLES": "SCRABBLE, to claw or grope about frantically [v]\n",
  "SCRABBLIER": "SCRABBLY, scrabbling [adj]\n",
  "SCRABBLIEST": "SCRABBLY, scrabbling [adj]\n",
  "SCRABBLING": "the act of groping about frantically [n -S]\n",
  "SCRABBLINGS": "SCRABBLING, the act of groping about frantically [n]\n",
  "SCRABBLY": "scrabbling [adj SCRABBLIER, SCRABBLIEST]\n",
  "SCRABS": "SCRAB, (dialect) to scratch, also SCRAT, SCRATCH, SCRATTLE, SCRAWM [v]\n",
  "SCRAE": "(Scott) scree, loose rock debris [n -S]\n",
  "SCRAES": "SCRAE, (Scott) scree, loose rock debris [n]\n",
  "SCRAG": "to wring the neck of [v SCRAGGED, SCRAGGING, SCRAGS]\n",
  "SCRAGGED": "SCRAG, to wring the neck of [v]\n",
  "SCRAGGEDNESS": "cragginess [n -ES]\n",
  "SCRAGGEDNESSES": "SCRAGGEDNESS, cragginess [n]\n",
  "SCRAGGIER": "SCRAGGY, skinny [adj]\n",
  "SCRAGGIEST": "SCRAGGY, skinny [adj]\n",
  "SCRAGGILY": "SCRAGGY, skinny [adv]\n",
  "SCRAGGINESS": "the state of being scraggy [n -ES]\n",
  "SCRAGGINESSES": "SCRAGGINESS, the state of being scraggy [n]\n",
  "SCRAGGING": "SCRAG, to wring the neck of [v]\n",
  "SCRAGGLIER": "SCRAGGLY, irregular or ragged in growth or form [adj]\n",
  "SCRAGGLIEST": "SCRAGGLY, irregular or ragged in growth or form [adj]\n",
  "SCRAGGLING": "scraggy, meagre [adj]\n",
  "SCRAGGLY": "irregular or ragged in growth or form [adj SCRAGGLIER, SCRAGGLIEST]\n",
  "SCRAGGY": "skinny [adj SCRAGGIER, SCRAGGIEST, SCRAGGILY]\n",
  "SCRAGS": "SCRAG, to wring the neck of [v]\n",
  "SCRAICH": "(Scots) to screech, shriek, also SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -S]\n",
  "SCRAICHED": "SCRAICH, (Scots) to screech, shriek, also SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRAICHING": "SCRAICH, (Scots) to screech, shriek, also SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRAICHS": "SCRAICH, (Scots) to screech, shriek, also SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRAIGH": "(Scots) to screech, shriek, also SCRAICH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -S]\n",
  "SCRAIGHED": "SCRAIGH, (Scots) to screech, shriek, also SCRAICH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRAIGHING": "SCRAIGH, (Scots) to screech, shriek, also SCRAICH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRAIGHS": "SCRAIGH, (Scots) to screech, shriek, also SCRAICH, SCREECH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRAM": "to leave quickly [v SCRAMMED, SCRAMMING, SCRAMS]\n",
  "SCRAMB": "(dialect) to scratch with claws or nails, also SCRAM [v -ED, -ING, -S]\n",
  "SCRAMBED": "SCRAMB, (dialect) to scratch with claws or nails, also SCRAM [v]\n",
  "SCRAMBING": "SCRAMB, (dialect) to scratch with claws or nails, also SCRAM [v]\n",
  "SCRAMBLE": "to move hurriedly, also SCAMBLE [v SCRAMBLED, SCRAMBLING, SCRAMBLES]\n",
  "SCRAMBLED": "SCRAMBLE, to move hurriedly, also SCAMBLE [v]\n",
  "SCRAMBLER": "a telephone device for scrambling a conversation [n -S]\n",
  "SCRAMBLERS": "SCRAMBLER, a telephone device for scrambling a conversation [n]\n",
  "SCRAMBLES": "SCRAMBLE, to move hurriedly, also SCAMBLE [v]\n",
  "SCRAMBLING": "moving or climbing hurriedly [n -S]\n",
  "SCRAMBLINGLY": "SCRAMBLING [adv]\n",
  "SCRAMBLINGS": "SCRAMBLING, moving or climbing hurriedly [n]\n",
  "SCRAMBS": "SCRAMB, (dialect) to scratch with claws or nails, also SCRAM [v]\n",
  "SCRAMJET": "a type of aircraft engine [n -S]\n",
  "SCRAMJETS": "SCRAMJET, a type of aircraft engine [n]\n",
  "SCRAMMED": "SCRAM, to leave quickly [v]\n",
  "SCRAMMING": "SCRAM, to leave quickly [v]\n",
  "SCRAMS": "SCRAM, to leave quickly [v]\n",
  "SCRAN": "(slang) food, provision, also SKRAN [n -S]\n",
  "SCRANCH": "to crunch [v -ED, -ING, -ES]\n",
  "SCRANCHED": "SCRANCH, to crunch [v]\n",
  "SCRANCHES": "SCRANCH, to crunch [v]\n",
  "SCRANCHING": "SCRANCH, to crunch [v]\n",
  "SCRANNEL": "(archaic) a thin person [n -S]\n",
  "SCRANNELS": "SCRANNEL, (archaic) a thin person [n]\n",
  "SCRANNIER": "SCRANNY, thin, scrawny [adj]\n",
  "SCRANNIEST": "SCRANNY, thin, scrawny [adj]\n",
  "SCRANNY": "thin, scrawny [adj SCRANNIER, SCRANNIEST]\n",
  "SCRANS": "SCRAN, (slang) food, provision, also SKRAN [n]\n",
  "SCRAP": "to discard [v SCRAPPED, SCRAPPING, SCRAPS]\n",
  "SCRAPABLE": "that can be scraped [adj]\n",
  "SCRAPBOOK": "to keep cuttings in a scrapbook, esp. as a hobby [v -ED, -ING, -S]\n",
  "SCRAPBOOKED": "SCRAPBOOK, to keep cuttings in a scrapbook, esp. as a hobby [v]\n",
  "SCRAPBOOKING": "the practice of keeping cuttings [n -S]\n",
  "SCRAPBOOKINGS": "SCRAPBOOKING, the practice of keeping cuttings [n]\n",
  "SCRAPBOOKS": "SCRAPBOOK, to keep cuttings in a scrapbook, esp. as a hobby [v]\n",
  "SCRAPE": "to rub and make a grating sound [v SCRAPED, SCRAPING, SCRAPES]\n",
  "SCRAPED": "SCRAPE, to rub and make a grating sound [v]\n",
  "SCRAPEGOOD": "(archaic) a miser, a skinflint [n -S]\n",
  "SCRAPEGOODS": "SCRAPEGOOD, (archaic) a miser, a skinflint [n]\n",
  "SCRAPEGUT": "(archaic) a fiddler [n -S]\n",
  "SCRAPEGUTS": "SCRAPEGUT, (archaic) a fiddler [n]\n",
  "SCRAPEPENNIES": "SCRAPEPENNY, (archaic) a miser, a skinflint [n]\n",
  "SCRAPEPENNY": "(archaic) a miser, a skinflint [n SCRAPEPENNIES]\n",
  "SCRAPER": "one that scrapes [n -S]\n",
  "SCRAPERBOARD": "a clay-surface board on which drawings can be made by scraping tints off as well as applying them [n -S]\n",
  "SCRAPERBOARDS": "SCRAPERBOARD, a clay-surface board on which drawings can be made by scraping tints off as well as applying them [n]\n",
  "SCRAPERS": "SCRAPER, one that scrapes [n]\n",
  "SCRAPES": "SCRAPE, to rub and make a grating sound [v]\n",
  "SCRAPHEAP": "a place where old iron or useless material is collected [n -S]\n",
  "SCRAPHEAPS": "SCRAPHEAP, a place where old iron or useless material is collected [n]\n",
  "SCRAPIE": "a disease of sheep [n -S]\n",
  "SCRAPIES": "SCRAPIE, a disease of sheep [n]\n",
  "SCRAPING": "something scraped off [n -S]\n",
  "SCRAPINGS": "SCRAPING, something scraped off [n]\n",
  "SCRAPPAGE": "allowance for scrap [n -S]\n",
  "SCRAPPAGES": "SCRAPPAGE, allowance for scrap [n]\n",
  "SCRAPPED": "SCRAP, to discard [v]\n",
  "SCRAPPER": "a fighter [n -S]\n",
  "SCRAPPERS": "SCRAPPER, a fighter [n]\n",
  "SCRAPPIER": "SCRAPPY, fragmentary [adj]\n",
  "SCRAPPIEST": "SCRAPPY, fragmentary [adj]\n",
  "SCRAPPILY": "SCRAPPY, fragmentary [adv]\n",
  "SCRAPPINESS": "the state of being scrappy [n -ES]\n",
  "SCRAPPINESSES": "SCRAPPINESS, the state of being scrappy [n]\n",
  "SCRAPPING": "the act of making scrap [n -S]\n",
  "SCRAPPINGS": "SCRAPPING, the act of making scrap [n]\n",
  "SCRAPPLE": "a mixture of ground meat and cornmeal [n -S]\n",
  "SCRAPPLES": "SCRAPPLE, a mixture of ground meat and cornmeal [n]\n",
  "SCRAPPY": "fragmentary [adj SCRAPPIER, SCRAPPIEST, SCRAPPILY]\n",
  "SCRAPS": "SCRAP, to discard [v]\n",
  "SCRAPYARD": "a place where old iron or useless material is collected [n -S]\n",
  "SCRAPYARDS": "SCRAPYARD, a place where old iron or useless material is collected [n]\n",
  "SCRAT": "to scratch, also SCART [v SCRATTED, SCRATTING, SCRATS]\n",
  "SCRATCH": "to make a thin, shallow cut on, also SCRAB, SCRAT, SCRATTLE, SCRAWM [v -ED, -ING, -ES]\n",
  "SCRATCHBACK": "a backscratcher [n -S]\n",
  "SCRATCHBACKS": "SCRATCHBACK, a backscratcher [n]\n",
  "SCRATCHBOARD": "a scraperboard [n -S]\n",
  "SCRATCHBOARDS": "SCRATCHBOARD, a scraperboard [n]\n",
  "SCRATCHBUILD": "to build (usually models) from raw materials, as opposed to constructing from kits or buying ready made [v SCRATCHBUILT, SCRATCHBUILDING, SCRATCHBUILDS]\n",
  "SCRATCHBUILDER": "one who scratchbuilds, builds models from raw materials, as opposed to constructing from kits or buying ready made [n -S]\n",
  "SCRATCHBUILDERS": "SCRATCHBUILDER, one who scratchbuilds, builds models from raw materials, as opposed to constructing from kits or buying ready made [n]\n",
  "SCRATCHBUILDING": "SCRATCHBUILD, to build (usually models) from raw materials, as opposed to constructing from kits or buying ready made [v]\n",
  "SCRATCHBUILDS": "SCRATCHBUILD, to build (usually models) from raw materials, as opposed to constructing from kits or buying ready made [v]\n",
  "SCRATCHBUILT": "SCRATCHBUILD, to build (usually models) from raw materials, as opposed to constructing from kits or buying ready made [v]\n",
  "SCRATCHCARD": "a type of lottery card covered with an opaque film which is scratched off to reveal numbers or symbols which may entitle the holder to a prize [n -S]\n",
  "SCRATCHCARDS": "SCRATCHCARD, a type of lottery card covered with an opaque film which is scratched off to reveal numbers or symbols which may entitle the holder to a prize [n]\n",
  "SCRATCHED": "SCRATCH, to make a thin, shallow cut on, also SCRAB, SCRAT, SCRATTLE, SCRAWM [v]\n",
  "SCRATCHER": "a tool for scratching [n -S]\n",
  "SCRATCHERS": "SCRATCHER, a tool for scratching [n]\n",
  "SCRATCHES": "SCRATCH, to make a thin, shallow cut on, also SCRAB, SCRAT, SCRATTLE, SCRAWM [v]\n",
  "SCRATCHIE": "(Australian slang) a scratch card [n -S]\n",
  "SCRATCHIER": "SCRATCHY, made by scratching [adj]\n",
  "SCRATCHIES": "SCRATCHIE, (Australian slang) a scratch card [n]\n",
  "SCRATCHIEST": "SCRATCHY, made by scratching [adj]\n",
  "SCRATCHILY": "SCRATCHY, made by scratching [adv]\n",
  "SCRATCHINESS": "the state of being scratchy [n -ES]\n",
  "SCRATCHINESSES": "SCRATCHINESS, the state of being scratchy [n]\n",
  "SCRATCHING": "causing a scratch [adj SCRATCHINGLY] / the act of scratching [n SCRATCHINGS]\n",
  "SCRATCHINGLY": "SCRATCHING [adv]\n",
  "SCRATCHINGS": "SCRATCHING, the act of scratching [n]\n",
  "SCRATCHLESS": "without a scratch [adj]\n",
  "SCRATCHPLATE": "a plastic or metal plate attached to the front of a guitar to protect it from pick scratches [n -S]\n",
  "SCRATCHPLATES": "SCRATCHPLATE, a plastic or metal plate attached to the front of a guitar to protect it from pick scratches [n]\n",
  "SCRATCHY": "made by scratching [adj SCRATCHIER, SCRATCHIEST, SCRATCHILY]\n",
  "SCRATS": "SCRAT, to scratch, also SCART [v]\n",
  "SCRATTED": "SCRAT, to scratch, also SCART [v]\n",
  "SCRATTING": "SCRAT, to scratch, also SCART [v]\n",
  "SCRATTLE": "to keep scratching, also SCRAB, SCRAT, SCRATCH, SCRAWM [v SCRATTLED, SCRATTLING, SCRATTLES]\n",
  "SCRATTLED": "SCRATTLE, to keep scratching, also SCRAB, SCRAT, SCRATCH, SCRAWM [v]\n",
  "SCRATTLES": "SCRATTLE, to keep scratching, also SCRAB, SCRAT, SCRATCH, SCRAWM [v]\n",
  "SCRATTLING": "SCRATTLE, to keep scratching, also SCRAB, SCRAT, SCRATCH, SCRAWM [v]\n",
  "SCRAUCH": "(Scots) to squawk, also SCRAUGH [v -ED, -ING, -S]\n",
  "SCRAUCHED": "SCRAUCH, (Scots) to squawk, also SCRAUGH [v]\n",
  "SCRAUCHING": "SCRAUCH, (Scots) to squawk, also SCRAUGH [v]\n",
  "SCRAUCHS": "SCRAUCH, (Scots) to squawk, also SCRAUGH [v]\n",
  "SCRAUGH": "(Scots) to squawk, also SCRAUCH [v -ED, -ING, -S]\n",
  "SCRAUGHED": "SCRAUGH, (Scots) to squawk, also SCRAUCH [v]\n",
  "SCRAUGHING": "SCRAUGH, (Scots) to squawk, also SCRAUCH [v]\n",
  "SCRAUGHS": "SCRAUGH, (Scots) to squawk, also SCRAUCH [v]\n",
  "SCRAVEL": "to move quickly, scramble [v SCRAVELED or SCRAVELLED, SCRAVELING or SCRAVELLING, SCRAVELS]\n",
  "SCRAVELED": "SCRAVEL, to move quickly, scramble [v]\n",
  "SCRAVELING": "SCRAVEL, to move quickly, scramble [v]\n",
  "SCRAVELLED": "SCRAVEL, to move quickly, scramble [v]\n",
  "SCRAVELLING": "SCRAVEL, to move quickly, scramble [v]\n",
  "SCRAVELS": "SCRAVEL, to move quickly, scramble [v]\n",
  "SCRAW": "(archaic) a thin sod or turf [n -S]\n",
  "SCRAWB": "to scrape with or as with claws [v -ED, -ING, -S]\n",
  "SCRAWBED": "SCRAWB, to scrape with or as with claws [v]\n",
  "SCRAWBING": "SCRAWB, to scrape with or as with claws [v]\n",
  "SCRAWBS": "SCRAWB, to scrape with or as with claws [v]\n",
  "SCRAWL": "to write hastily or illegibly, also SCRIBBLE [v -ED, -ING, -S]\n",
  "SCRAWLED": "SCRAWL, to write hastily or illegibly, also SCRIBBLE [v]\n",
  "SCRAWLER": "one who scrawls [n -S]\n",
  "SCRAWLERS": "SCRAWLER, one who scrawls [n]\n",
  "SCRAWLIER": "SCRAWLY, written hastily or illegibly, also SCRIBBLY [adj]\n",
  "SCRAWLIEST": "SCRAWLY, written hastily or illegibly, also SCRIBBLY [adj]\n",
  "SCRAWLING": "of writing, hasty, illegible [adj SCRAWLINGLY] / the act of scrawling [n -S]\n",
  "SCRAWLINGLY": "SCRAWLING, of writing, hasty, illegible [adv]\n",
  "SCRAWLINGS": "SCRAWLING, the act of scrawling [n]\n",
  "SCRAWLS": "SCRAWL, to write hastily or illegibly, also SCRIBBLE [v]\n",
  "SCRAWLY": "written hastily or illegibly, also SCRIBBLY [adj SCRAWLIER, SCRAWLIEST]\n",
  "SCRAWM": "(dialect) to scratch, also SCRAB, SCRAT, SCRATTLE [v -ED, -ING, -S]\n",
  "SCRAWMED": "SCRAWM, (dialect) to scratch, also SCRAB, SCRAT, SCRATTLE [v]\n",
  "SCRAWMING": "SCRAWM, (dialect) to scratch, also SCRAB, SCRAT, SCRATTLE [v]\n",
  "SCRAWMS": "SCRAWM, (dialect) to scratch, also SCRAB, SCRAT, SCRATTLE [v]\n",
  "SCRAWNIER": "SCRAWNY, extremely thin, also SCRANNY [adj]\n",
  "SCRAWNIEST": "SCRAWNY, extremely thin, also SCRANNY [adj]\n",
  "SCRAWNILY": "SCRAWNY, extremely thin, also SCRANNY [adv]\n",
  "SCRAWNINESS": "the state of being scrawny [n -ES]\n",
  "SCRAWNINESSES": "SCRAWNINESS, the state of being scrawny [n]\n",
  "SCRAWNY": "extremely thin, also SCRANNY [adj SCRAWNIER, SCRAWNIEST, SCRAWNILY]\n",
  "SCRAWP": "(dialect) to scratch the skin to relieve itching, also SCRORP [v -ED, -ING, -S]\n",
  "SCRAWPED": "SCRAWP, (dialect) to scratch the skin to relieve itching, also SCRORP [v]\n",
  "SCRAWPING": "SCRAWP, (dialect) to scratch the skin to relieve itching, also SCRORP [v]\n",
  "SCRAWPS": "SCRAWP, (dialect) to scratch the skin to relieve itching, also SCRORP [v]\n",
  "SCRAWS": "SCRAW, (archaic) a thin sod or turf [n]\n",
  "SCRAY": "the tern, also SCRAYE [n -S]\n",
  "SCRAYE": "the tern, also SCRAY [n -S]\n",
  "SCRAYES": "SCRAYE, the tern, also SCRAY [n]\n",
  "SCRAYS": "SCRAY, the tern, also SCRAYE [n]\n",
  "SCREAK": "to creak [v -ED, -ING, -S]\n",
  "SCREAKED": "SCREAK, to creak [v]\n",
  "SCREAKIER": "SCREAKY, creaky [adj]\n",
  "SCREAKIEST": "SCREAKY, creaky [adj]\n",
  "SCREAKING": "a creaking, as of a door or wheel [n -S]\n",
  "SCREAKINGS": "SCREAKING, a creaking, as of a door or wheel [n]\n",
  "SCREAKS": "SCREAK, to creak [v]\n",
  "SCREAKY": "creaky [adj SCREAKIER, SCREAKIEST]\n",
  "SCREAM": "to utter a prolonged, piercing cry [v -ED, -ING, -S]\n",
  "SCREAMED": "SCREAM, to utter a prolonged, piercing cry [v]\n",
  "SCREAMER": "a goose-like South American bird [n -S]\n",
  "SCREAMERS": "SCREAMER, a goose-like South American bird [n]\n",
  "SCREAMING": "uttering a scream [n -S]\n",
  "SCREAMINGLY": "SCREAMING [adv]\n",
  "SCREAMINGS": "SCREAMING, uttering a scream [n]\n",
  "SCREAMO": "a form of emo music typically featuring screaming vocals [n -S]\n",
  "SCREAMOS": "SCREAMO, a form of emo music typically featuring screaming vocals [n]\n",
  "SCREAMS": "SCREAM, to utter a prolonged, piercing cry [v]\n",
  "SCREE": "a mass of rocks at the foot of a slope [n -S]\n",
  "SCREECH": "to utter a harsh, shrill cry, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -ES]\n",
  "SCREECHED": "SCREECH, to utter a harsh, shrill cry, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCREECHER": "one who screeches [n -S]\n",
  "SCREECHERS": "SCREECHER, one who screeches [n]\n",
  "SCREECHES": "SCREECH, to utter a harsh, shrill cry, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCREECHIER": "SCREECHY, screeching [adj]\n",
  "SCREECHIEST": "SCREECHY, screeching [adj]\n",
  "SCREECHING": "SCREECH, to utter a harsh, shrill cry, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCREECHY": "screeching [adj SCREECHIER, SCREECHIEST]\n",
  "SCREED": "to tear; to make a shrill sound [v -ED, -ING, -S]\n",
  "SCREEDED": "SCREED, to tear; to make a shrill sound [v]\n",
  "SCREEDER": "a person who lays plaster or mortar [n -S]\n",
  "SCREEDERS": "SCREEDER, a person who lays plaster or mortar [n]\n",
  "SCREEDING": "the material of a screed, as used to finish a floor [n -S]\n",
  "SCREEDINGS": "SCREEDING, the material of a screed, as used to finish a floor [n]\n",
  "SCREEDS": "SCREED, to tear; to make a shrill sound [v]\n",
  "SCREEN": "to provide with a concealing partition [v -ED, -ING, -S]\n",
  "SCREENABLE": "that can be screened [adj]\n",
  "SCREENAGER": "a socially inept teenager who is adept at electronic communication [n -S]\n",
  "SCREENAGERS": "SCREENAGER, a socially inept teenager who is adept at electronic communication [n]\n",
  "SCREENCAST": "a digital recording of the display on a computer screen that may be viewed on another device [n -S]\n",
  "SCREENCASTS": "SCREENCAST, a digital recording of the display on a computer screen that may be viewed on another device [n]\n",
  "SCREENCRAFT": "the art of writing for the screen [n -S]\n",
  "SCREENCRAFTS": "SCREENCRAFT, the art of writing for the screen [n]\n",
  "SCREENED": "SCREEN, to provide with a concealing partition [v]\n",
  "SCREENER": "one who screens [n -S]\n",
  "SCREENERS": "SCREENER, one who screens [n]\n",
  "SCREENFUL": "the contents of a screen [n -S]\n",
  "SCREENFULS": "SCREENFUL, the contents of a screen [n]\n",
  "SCREENIE": "(Australian slang) a screensaver [n -S]\n",
  "SCREENIES": "SCREENIE, (Australian slang) a screensaver [n]\n",
  "SCREENING": "the act of screening [n -S]\n",
  "SCREENINGS": "SCREENING, the act of screening [n]\n",
  "SCREENLAND": "the cinema [n -S]\n",
  "SCREENLANDS": "SCREENLAND, the cinema [n]\n",
  "SCREENLIKE": "like a screen [adj]\n",
  "SCREENPLAY": "the script and often shooting directions of a story prepared for motion-picture production [n -S]\n",
  "SCREENPLAYS": "SCREENPLAY, the script and often shooting directions of a story prepared for motion-picture production [n]\n",
  "SCREENS": "SCREEN, to provide with a concealing partition [v]\n",
  "SCREENSAVER": "a picture showing on a computer when in screen save mode [n -S]\n",
  "SCREENSAVERS": "SCREENSAVER, a picture showing on a computer when in screen save mode [n]\n",
  "SCREENSHOT": "to take a print of the contents of a computer screen [v SCREENSHOTTED, SCREENSHOTTING, SCREENSHOTS]\n",
  "SCREENSHOTS": "SCREENSHOT, to take a print of the contents of a computer screen [v]\n",
  "SCREENSHOTTED": "SCREENSHOT, to take a print of the contents of a computer screen [v]\n",
  "SCREENSHOTTING": "SCREENSHOT, to take a print of the contents of a computer screen [v]\n",
  "SCREENWRITER": "a writer of screenplays [n -S]\n",
  "SCREENWRITERS": "SCREENWRITER, a writer of screenplays [n]\n",
  "SCREENWRITING": "the profession of writing screenplays [n -S]\n",
  "SCREENWRITINGS": "SCREENWRITING, the profession of writing screenplays [n]\n",
  "SCREES": "SCREE, a mass of rocks at the foot of a slope [n]\n",
  "SCREET": "(dialect) to weep [v -ED, -ING, -S]\n",
  "SCREETED": "SCREET, (dialect) to weep [v]\n",
  "SCREETING": "SCREET, (dialect) to weep [v]\n",
  "SCREETS": "SCREET, (dialect) to weep [v]\n",
  "SCREEVE": "to write begging letters [v SCREEVED, SCREEVING, SCREEVES]\n",
  "SCREEVED": "SCREEVE, to write begging letters [v]\n",
  "SCREEVER": "one who writes begging letters [n -S]\n",
  "SCREEVERS": "SCREEVER, one who writes begging letters [n]\n",
  "SCREEVES": "SCREEVE, to write begging letters [v]\n",
  "SCREEVING": "the writing of especially begging letters [n -S]\n",
  "SCREEVINGS": "SCREEVING, the writing of especially begging letters [n]\n",
  "SCREICH": "(Scots) to shriek, also SCRAICH, SCRAIGH, SCREECH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -S]\n",
  "SCREICHED": "SCREICH, (Scots) to shriek, also SCRAICH, SCRAIGH, SCREECH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCREICHING": "SCREICH, (Scots) to shriek, also SCRAICH, SCRAIGH, SCREECH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCREICHS": "SCREICH, (Scots) to shriek, also SCRAICH, SCRAIGH, SCREECH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCREIGH": "(Scots) to shriek, also SCREICH, SCRIECH, SCRIKE [v -ED, -ING, -S]\n",
  "SCREIGHED": "SCREIGH, (Scots) to shriek, also SCREICH, SCRIECH, SCRIKE [v]\n",
  "SCREIGHING": "SCREIGH, (Scots) to shriek, also SCREICH, SCRIECH, SCRIKE [v]\n",
  "SCREIGHS": "SCREIGH, (Scots) to shriek, also SCREICH, SCRIECH, SCRIKE [v]\n",
  "SCREW": "to attach with a type of metal fastener [v -ED, -ING, -S]\n",
  "SCREWABLE": "that can be screwed [adj]\n",
  "SCREWBALL": "a crazy person, an eccentric [n -S]\n",
  "SCREWBALLS": "SCREWBALL, a crazy person, an eccentric [n]\n",
  "SCREWBEAN": "a leguminous shrub or small tree of the southwestern US [n -S]\n",
  "SCREWBEANS": "SCREWBEAN, a leguminous shrub or small tree of the southwestern US [n]\n",
  "SCREWDRIVER": "a tool for turning screws [n -S]\n",
  "SCREWDRIVERS": "SCREWDRIVER, a tool for turning screws [n]\n",
  "SCREWED": "SCREW, to attach with a type of metal fastener [v]\n",
  "SCREWER": "one who screws [n -S]\n",
  "SCREWERS": "SCREWER, one who screws [n]\n",
  "SCREWHEAD": "the head of a screw [n -S]\n",
  "SCREWHEADS": "SCREWHEAD, the head of a screw [n]\n",
  "SCREWIER": "SCREWY, (colloquial) eccentric, slightly mad [adj]\n",
  "SCREWIEST": "SCREWY, (colloquial) eccentric, slightly mad [adj]\n",
  "SCREWINESS": "the state of being screwy [n -ES]\n",
  "SCREWINESSES": "SCREWINESS, the state of being screwy [n]\n",
  "SCREWING": "the act of screwing [n -S]\n",
  "SCREWINGS": "SCREWING, the act of screwing [n]\n",
  "SCREWLIKE": "like a screw [adj]\n",
  "SCREWS": "SCREW, to attach with a type of metal fastener [v]\n",
  "SCREWTOP": "a bottle with a screw stopper [n -S]\n",
  "SCREWTOPS": "SCREWTOP, a bottle with a screw stopper [n]\n",
  "SCREWUP": "an instance of bungling [n -S]\n",
  "SCREWUPS": "SCREWUP, an instance of bungling [n]\n",
  "SCREWWORM": "the larva of a dipterous fly which develops under the skin of certain animals [n -S]\n",
  "SCREWWORMS": "SCREWWORM, the larva of a dipterous fly which develops under the skin of certain animals [n]\n",
  "SCREWY": "(colloquial) eccentric, slightly mad [adj SCREWIER, SCREWIEST]\n",
  "SCRIBABLE": "capable of being written upon [adj]\n",
  "SCRIBACIOUS": "(archaic) given to writing [adj]\n",
  "SCRIBACIOUSNESS": "(archaic) the state of being scribacious, given to writing [n]\n",
  "SCRIBAL": "pertaining to a public clerk or secretary [adj]\n",
  "SCRIBBLE": "to write hastily or illegibly [v SCRIBBLED, SCRIBBLING, SCRIBBLES]\n",
  "SCRIBBLED": "SCRIBBLE, to write hastily or illegibly [v]\n",
  "SCRIBBLEMENT": "the act of scribbling [n -S]\n",
  "SCRIBBLEMENTS": "SCRIBBLEMENT, the act of scribbling [n]\n",
  "SCRIBBLER": "one who scribbles [n -S]\n",
  "SCRIBBLERS": "SCRIBBLER, one who scribbles [n]\n",
  "SCRIBBLES": "SCRIBBLE, to write hastily or illegibly [v]\n",
  "SCRIBBLIER": "SCRIBBLY, written hastily or illegibly [adj]\n",
  "SCRIBBLIEST": "SCRIBBLY, written hastily or illegibly [adj]\n",
  "SCRIBBLING": "hasty or careless writing [n -S]\n",
  "SCRIBBLINGLY": "SCRIBBLING [adv]\n",
  "SCRIBBLINGS": "SCRIBBLING, hasty or careless writing [n]\n",
  "SCRIBBLY": "written hastily or illegibly [adj SCRIBBLIER, SCRIBBLIEST]\n",
  "SCRIBE": "to mark with a pointed instrument [v SCRIBED, SCRIBING, SCRIBES]\n",
  "SCRIBED": "SCRIBE, to mark with a pointed instrument [v]\n",
  "SCRIBER": "a scribing tool for marking material [n -S]\n",
  "SCRIBERS": "SCRIBER, a scribing tool for marking material [n]\n",
  "SCRIBES": "SCRIBE, to mark with a pointed instrument [v]\n",
  "SCRIBING": "the act of scribing [n -S]\n",
  "SCRIBINGS": "SCRIBING, the act of scribing [n]\n",
  "SCRIBISM": "the character and opinions of a Jewish scribe in the time of Christ [n -S]\n",
  "SCRIBISMS": "SCRIBISM, the character and opinions of a Jewish scribe in the time of Christ [n]\n",
  "SCRIECH": "(Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -S]\n",
  "SCRIECHED": "SCRIECH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRIECHING": "SCRIECH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRIECHS": "SCRIECH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRITCH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRIED": "SCRY, to engage in crystal gazing, also SKRY [v]\n",
  "SCRIENE": "(obsolete) a screen, also SKREEN [n -S]\n",
  "SCRIENES": "SCRIENE, (obsolete) a screen, also SKREEN [n]\n",
  "SCRIES": "SCRY, to engage in crystal gazing, also SKRY [v]\n",
  "SCRIEVE": "(Scots) to glide swiftly along [v SCRIEVED, SCRIEVING, SCRIEVES]\n",
  "SCRIEVEBOARD": "a shipbuilder's drawing board, also SCRIVEBOARD [n -S]\n",
  "SCRIEVEBOARDS": "SCRIEVEBOARD, a shipbuilder's drawing board, also SCRIVEBOARD [n]\n",
  "SCRIEVED": "SCRIEVE, (Scots) to glide swiftly along [v]\n",
  "SCRIEVES": "SCRIEVE, (Scots) to glide swiftly along [v]\n",
  "SCRIEVING": "SCRIEVE, (Scots) to glide swiftly along [v]\n",
  "SCRIGGLE": "to wriggle, writhe [v SCRIGGLED, SCRIGGLING, SCRIGGLES]\n",
  "SCRIGGLED": "SCRIGGLE, to wriggle, writhe [v]\n",
  "SCRIGGLES": "SCRIGGLE, to wriggle, writhe [v]\n",
  "SCRIGGLIER": "SCRIGGLY, wriggly [adj]\n",
  "SCRIGGLIEST": "SCRIGGLY, wriggly [adj]\n",
  "SCRIGGLING": "SCRIGGLE, to wriggle, writhe [v]\n",
  "SCRIGGLY": "wriggly [adj SCRIGGLIER, SCRIGGLIEST]\n",
  "SCRIKE": "to shriek, also SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v SCRIKED, SCRIKING, SCRIKES]\n",
  "SCRIKED": "SCRIKE, to shriek, also SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SCRIKES": "SCRIKE, to shriek, also SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SCRIKING": "SCRIKE, to shriek, also SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SCRIM": "a durable plain-woven cotton fabric [n -S]\n",
  "SCRIMMAGE": "a noisy dispute or tussle; a rough or confused struggle [n -S] / to take part in a scrimmage, also SCRUMMAGE, SKRIMMAGE [v SCRIMMAGED, SCRIMMAGING, SCRIMMAGES]\n",
  "SCRIMMAGED": "SCRIMMAGE, to take part in a scrimmage, also SCRUMMAGE, SKRIMMAGE [v]\n",
  "SCRIMMAGER": "one who scrimmages [n -S]\n",
  "SCRIMMAGERS": "SCRIMMAGER, one who scrimmages [n]\n",
  "SCRIMMAGES": "SCRIMMAGE, to take part in a scrimmage, also SCRUMMAGE, SKRIMMAGE [v]\n",
  "SCRIMMAGING": "SCRIMMAGE, to take part in a scrimmage, also SCRUMMAGE, SKRIMMAGE [v]\n",
  "SCRIMP": "scanty, also SKRIMP [adj SCRIMPLY] / to scratch and save [v -ED, -ING, -S]\n",
  "SCRIMPED": "SCRIMP, to scratch and save [v]\n",
  "SCRIMPER": "one who scrimps [n -S]\n",
  "SCRIMPERS": "SCRIMPER, one who scrimps [n]\n",
  "SCRIMPIER": "SCRIMPY, scanty [adj]\n",
  "SCRIMPIEST": "SCRIMPY, scanty [adj]\n",
  "SCRIMPILY": "SCRIMPY, scanty [adv]\n",
  "SCRIMPINESS": "the state of being scrimpy, scantness, also SCRIMPNESS [n -ES]\n",
  "SCRIMPINESSES": "SCRIMPINESS, the state of being scrimpy, scantness, also SCRIMPNESS [n]\n",
  "SCRIMPING": "the exercise of frugality [n -S]\n",
  "SCRIMPINGS": "SCRIMPING, the exercise of frugality [n]\n",
  "SCRIMPIT": "(Scots) meager [adj]\n",
  "SCRIMPLY": "SCRIMP, scanty, also SKRIMP [adv]\n",
  "SCRIMPNESS": "the state of being scrimpy, scantness, also SCRIMPINESS [n -ES]\n",
  "SCRIMPNESSES": "SCRIMPNESS, the state of being scrimpy, scantness, also SCRIMPINESS [n]\n",
  "SCRIMPS": "SCRIMP, to scratch and save [v]\n",
  "SCRIMPY": "scanty [adj SCRIMPIER, SCRIMPIEST, SCRIMPILY]\n",
  "SCRIMS": "SCRIM, a durable plain-woven cotton fabric [n]\n",
  "SCRIMSHANDER": "to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDY, SCRIMSHAW [v -ED, -ING, -S]\n",
  "SCRIMSHANDERED": "SCRIMSHANDER, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDY, SCRIMSHAW [v]\n",
  "SCRIMSHANDERING": "SCRIMSHANDER, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDY, SCRIMSHAW [v]\n",
  "SCRIMSHANDERS": "SCRIMSHANDER, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDY, SCRIMSHAW [v]\n",
  "SCRIMSHANDIED": "SCRIMSHANDY, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHAW [v]\n",
  "SCRIMSHANDIES": "SCRIMSHANDY, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHAW [v]\n",
  "SCRIMSHANDY": "to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHAW [v SCRIMSHANDIED, SCRIMSHANDYING, SCRIMSHANDIES]\n",
  "SCRIMSHANDYING": "SCRIMSHANDY, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHAW [v]\n",
  "SCRIMSHANK": "to evade work or duty, also SKRIMSHANK [v -ED, -ING, -S]\n",
  "SCRIMSHANKED": "SCRIMSHANK, to evade work or duty, also SKRIMSHANK [v]\n",
  "SCRIMSHANKER": "a shirker, also SKRIMSHANKER [n -S]\n",
  "SCRIMSHANKERS": "SCRIMSHANKER, a shirker, also SKRIMSHANKER [n]\n",
  "SCRIMSHANKING": "SCRIMSHANK, to evade work or duty, also SKRIMSHANK [v]\n",
  "SCRIMSHANKS": "SCRIMSHANK, to evade work or duty, also SKRIMSHANK [v]\n",
  "SCRIMSHAW": "to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHANDY [v -ED, -ING, -S]\n",
  "SCRIMSHAWED": "SCRIMSHAW, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHANDY [v]\n",
  "SCRIMSHAWING": "SCRIMSHAW, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHANDY [v]\n",
  "SCRIMSHAWS": "SCRIMSHAW, to ornament, as shells, ivory, etc., by engraving, and (usually) rubbing pigments into the incised lines, also SCRIMSHANDER, SCRIMSHANDY [v]\n",
  "SCRIMSHONER": "one who makes scrimshaw carvings [n -S]\n",
  "SCRIMSHONERS": "SCRIMSHONER, one who makes scrimshaw carvings [n]\n",
  "SCRIMURE": "(obsolete) a fencer [n -S]\n",
  "SCRIMURES": "SCRIMURE, (obsolete) a fencer [n]\n",
  "SCRINE": "(obsolete) a chest for records, also SCRYNE [n -S]\n",
  "SCRINES": "SCRINE, (obsolete) a chest for records, also SCRYNE [n]\n",
  "SCRIP": "a small bag; a wallet [n -S]\n",
  "SCRIPHOLDER": "a person who owns a scrip or scrips [n -S]\n",
  "SCRIPHOLDERS": "SCRIPHOLDER, a person who owns a scrip or scrips [n]\n",
  "SCRIPOPHILE": "one who has the hobby of collecting stock and bond certificates [n -S]\n",
  "SCRIPOPHILES": "SCRIPOPHILE, one who has the hobby of collecting stock and bond certificates [n]\n",
  "SCRIPOPHILIES": "SCRIPOPHILY, the hobby of collecting historic stock and bond certificates [n]\n",
  "SCRIPOPHILIST": "one who practises scripophily [n -S]\n",
  "SCRIPOPHILISTS": "SCRIPOPHILIST, one who practises scripophily [n]\n",
  "SCRIPOPHILY": "the hobby of collecting historic stock and bond certificates [n SCRIPOPHILIES]\n",
  "SCRIPPAGE": "the contents of a scrip, or wallet [n -S]\n",
  "SCRIPPAGES": "SCRIPPAGE, the contents of a scrip, or wallet [n]\n",
  "SCRIPS": "SCRIP, a small bag; a wallet [n]\n",
  "SCRIPT": "to prepare a written text for a play [v -ED, -ING, -S]\n",
  "SCRIPTED": "SCRIPT, to prepare a written text for a play [v]\n",
  "SCRIPTER": "one who scripts [n -S]\n",
  "SCRIPTERS": "SCRIPTER, one who scripts [n]\n",
  "SCRIPTING": "SCRIPT, to prepare a written text for a play [v]\n",
  "SCRIPTORIA": "SCRIPTORIUM, (Latin) a writing room, esp. of scribes in medieval monastery [n]\n",
  "SCRIPTORIAL": "related to a scriptorium [adj]\n",
  "SCRIPTORIUM": "(Latin) a writing room, esp. of scribes in medieval monastery [n SCRIPTORIA or SCRIPTORIUMS]\n",
  "SCRIPTORIUMS": "SCRIPTORIUM, (Latin) a writing room, esp. of scribes in medieval monastery [n]\n",
  "SCRIPTORY": "by, in or relating to writing [adj]\n",
  "SCRIPTS": "SCRIPT, to prepare a written text for a play [v]\n",
  "SCRIPTURAL": "relating to scripture [adj SCRIPTURALLY]\n",
  "SCRIPTURALISM": "literal adherence to the Scriptures [n -S]\n",
  "SCRIPTURALISMS": "SCRIPTURALISM, literal adherence to the Scriptures [n]\n",
  "SCRIPTURALIST": "a person who adheres to the letter of Scripture [n -S]\n",
  "SCRIPTURALISTS": "SCRIPTURALIST, a person who adheres to the letter of Scripture [n]\n",
  "SCRIPTURALLY": "SCRIPTURAL, relating to scripture [adv]\n",
  "SCRIPTURE": "a biblical writing [n -S]\n",
  "SCRIPTURES": "SCRIPTURE, a biblical writing [n]\n",
  "SCRIPTURISM": "adherence to the scriptures [n -S]\n",
  "SCRIPTURISMS": "SCRIPTURISM, adherence to the scriptures [n]\n",
  "SCRIPTURIST": "a person versed in Scripture; a person who bases his or her belief on the Bible and the Bible alone [n -S]\n",
  "SCRIPTURISTS": "SCRIPTURIST, a person versed in Scripture; a person who bases his or her belief on the Bible and the Bible alone [n]\n",
  "SCRIPTWRITER": "a person who writes scripts, as for screenplays [n -S]\n",
  "SCRIPTWRITERS": "SCRIPTWRITER, a person who writes scripts, as for screenplays [n]\n",
  "SCRIPTWRITING": "the writing of scripts [n -S]\n",
  "SCRIPTWRITINGS": "SCRIPTWRITING, the writing of scripts [n]\n",
  "SCRITCH": "to utter a harsh shrill cry, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -ES]\n",
  "SCRITCHED": "SCRITCH, to utter a harsh shrill cry, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRITCHES": "SCRITCH, to utter a harsh shrill cry, also SCRAICH, SCRAIGH, SCREECH, SCREICH, SCREIGH, SCRIECH, SKREEGH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SCRITCHING": "a screeching [n -S]\n",
  "SCRITCHINGS": "SCRITCHING, a screeching [n]\n",
  "SCRIVE": "to write, esp. with copious fluency [v SCRIVED, SCRIVING, SCRIVES]\n",
  "SCRIVEBOARD": "a shipbuilder's drawing board, also SCRIEVEBOARD [n -S]\n",
  "SCRIVEBOARDS": "SCRIVEBOARD, a shipbuilder's drawing board, also SCRIEVEBOARD [n]\n",
  "SCRIVED": "SCRIVE, to write, esp. with copious fluency [v]\n",
  "SCRIVENER": "(historical) a scribe, a copyist [n -S]\n",
  "SCRIVENERS": "SCRIVENER, (historical) a scribe, a copyist [n]\n",
  "SCRIVENERSHIP": "the office of scrivener [n -S]\n",
  "SCRIVENERSHIPS": "SCRIVENERSHIP, the office of scrivener [n]\n",
  "SCRIVENING": "writing, esp. of a routine or arduous kind [n -S]\n",
  "SCRIVENINGS": "SCRIVENING, writing, esp. of a routine or arduous kind [n]\n",
  "SCRIVES": "SCRIVE, to write, esp. with copious fluency [v]\n",
  "SCRIVING": "SCRIVE, to write, esp. with copious fluency [v]\n",
  "SCROB": "to scrape with or as with claws [v SCROBBED, SCROBBING, SCROBS]\n",
  "SCROBBED": "SCROB, to scrape with or as with claws [v]\n",
  "SCROBBING": "SCROB, to scrape with or as with claws [v]\n",
  "SCROBBLE": "of an online music service, to record a listener's musical preferences and recommend similar music that he or she might enjoy [v SCROBBLED, SCROBBLING, SCROBBLES]\n",
  "SCROBBLED": "SCROBBLE, of an online music service, to record a listener's musical preferences and recommend similar music that he or she might enjoy [v]\n",
  "SCROBBLES": "SCROBBLE, of an online music service, to record a listener's musical preferences and recommend similar music that he or she might enjoy [v]\n",
  "SCROBBLING": "SCROBBLE, of an online music service, to record a listener's musical preferences and recommend similar music that he or she might enjoy [v]\n",
  "SCROBE": "a groove [n -S]\n",
  "SCROBES": "SCROBE, a groove [n]\n",
  "SCROBICULAR": "relating to or surrounded by scrobicules [adj]\n",
  "SCROBICULATE": "marked with many shallow depressions, grooves, or pits, also SCROBICULATED [adj]\n",
  "SCROBICULATED": "marked with many shallow depressions, grooves, or pits, also SCROBICULATE [adj]\n",
  "SCROBICULE": "a small pit or depression, as around the tubercles of a sea urchin [n -S]\n",
  "SCROBICULES": "SCROBICULE, a small pit or depression, as around the tubercles of a sea urchin [n]\n",
  "SCROBS": "SCROB, to scrape with or as with claws [v]\n",
  "SCROD": "a young cod, also SCHROD [n -S]\n",
  "SCRODDLED": "of pottery, made of clay scraps of different colours [adj]\n",
  "SCRODS": "SCROD, a young cod, also SCHROD [n]\n",
  "SCROFULA": "(Latin) tuberculosis of the lymph nodes, esp. in the neck, giving rise to abscesses [n -S]\n",
  "SCROFULAS": "SCROFULA, (Latin) tuberculosis of the lymph nodes, esp. in the neck, giving rise to abscesses [n]\n",
  "SCROFULOUS": "afflicted with scrofula [adj SCROFULOUSLY]\n",
  "SCROFULOUSLY": "SCROFULOUS, afflicted with scrofula [adv]\n",
  "SCROFULOUSNESS": "the state of being scrofulous [n]\n",
  "SCROG": "(dialect) a stunted bush or small tree; a broken branch [n -S]\n",
  "SCROGGIE": "abounding in scrogs, stunted bushes or undergrowth, also SCROGGY [adj SCROGGIER, SCROGGIEST]\n",
  "SCROGGIER": "SCROGGY, abounding in scrogs, stunted bushes or undergrowth, also SCROGGIE [adj]\n",
  "SCROGGIEST": "SCROGGY, abounding in scrogs, stunted bushes or undergrowth, also SCROGGIE [adj]\n",
  "SCROGGIN": "(New Zealand) a tramp's homemade high-calorie sweetmeat [n -S]\n",
  "SCROGGINS": "SCROGGIN, (New Zealand) a tramp's homemade high-calorie sweetmeat [n]\n",
  "SCROGGY": "abounding in scrogs, stunted bushes or undergrowth, also SCROGGIE [adj SCROGGIER, SCROGGIEST]\n",
  "SCROGS": "SCROG, (dialect) a stunted bush or small tree; a broken branch [n]\n",
  "SCROLL": "to move text across a display screen [v -ED, -ING, -S]\n",
  "SCROLLABLE": "that can be scrolled [adj]\n",
  "SCROLLED": "SCROLL, to move text across a display screen [v]\n",
  "SCROLLER": "someone or something that scrolls [n -S]\n",
  "SCROLLERS": "SCROLLER, someone or something that scrolls [n]\n",
  "SCROLLING": "the act of moving text across a display screen [n -S]\n",
  "SCROLLINGS": "SCROLLING, the act of moving text across a display screen [n]\n",
  "SCROLLS": "SCROLL, to move text across a display screen [v]\n",
  "SCROLLWISE": "in the fashion of a scroll [adv]\n",
  "SCROLLWORK": "ornamentation characterized by scrolls [n -S]\n",
  "SCROLLWORKS": "SCROLLWORK, ornamentation characterized by scrolls [n]\n",
  "SCROME": "(dialect) to crawl or climb, esp. using the hands [v SCROMED, SCROMING, SCROMES]\n",
  "SCROMED": "SCROME, (dialect) to crawl or climb, esp. using the hands [v]\n",
  "SCROMES": "SCROME, (dialect) to crawl or climb, esp. using the hands [v]\n",
  "SCROMING": "SCROME, (dialect) to crawl or climb, esp. using the hands [v]\n",
  "SCROOCH": "to crouch, also SCROOTCH [v -ED, -ING, -ES]\n",
  "SCROOCHED": "SCROOCH, to crouch, also SCROOTCH [v]\n",
  "SCROOCHES": "SCROOCH, to crouch, also SCROOTCH [v]\n",
  "SCROOCHING": "SCROOCH, to crouch, also SCROOTCH [v]\n",
  "SCROOGE": "to crowd; to squeeze, also SCROUGE, SCROWDGE, SCRUZE [v SCROOGED, SCROOGING, SCROOGES]\n",
  "SCROOGED": "SCROOGE, to crowd; to squeeze, also SCROUGE, SCROWDGE, SCRUZE [v]\n",
  "SCROOGES": "SCROOGE, to crowd; to squeeze, also SCROUGE, SCROWDGE, SCRUZE [v]\n",
  "SCROOGING": "SCROOGE, to crowd; to squeeze, also SCROUGE, SCROWDGE, SCRUZE [v]\n",
  "SCROOP": "to make a harsh grating sound [v -ED, -ING, -S]\n",
  "SCROOPED": "SCROOP, to make a harsh grating sound [v]\n",
  "SCROOPING": "SCROOP, to make a harsh grating sound [v]\n",
  "SCROOPS": "SCROOP, to make a harsh grating sound [v]\n",
  "SCROOTCH": "to crouch, also SCROOCH [v -ED, -ING, -ES]\n",
  "SCROOTCHED": "SCROOTCH, to crouch, also SCROOCH [v]\n",
  "SCROOTCHES": "SCROOTCH, to crouch, also SCROOCH [v]\n",
  "SCROOTCHING": "SCROOTCH, to crouch, also SCROOCH [v]\n",
  "SCROPHULARIA": "a plant of the figwort genus [n -S]\n",
  "SCROPHULARIAS": "SCROPHULARIA, a plant of the figwort genus [n]\n",
  "SCRORP": "(dialect) a deep scratch or weal, also SCRAWP [n -S]\n",
  "SCRORPS": "SCRORP, (dialect) a deep scratch or weal, also SCRAWP [n]\n",
  "SCROTA": "SCROTUM, (Latin) the bag of skin that contains the testes [n]\n",
  "SCROTAL": "pertaining to the scrotum [adj]\n",
  "SCROTE": "(slang) a worthless person [n -S]\n",
  "SCROTES": "SCROTE, (slang) a worthless person [n]\n",
  "SCROTUM": "(Latin) the bag of skin that contains the testes [n SCROTUMS or SCROTA]\n",
  "SCROTUMS": "SCROTUM, (Latin) the bag of skin that contains the testes [n]\n",
  "SCROUGE": "to crowd; to squeeze, also SCROOGE, SCROWDGE, SCRUZE [v SCROUGED, SCROUGING, SCROUGES]\n",
  "SCROUGED": "SCROUGE, to crowd; to squeeze, also SCROOGE, SCROWDGE, SCRUZE [v]\n",
  "SCROUGER": "(US archaic) a whopper, something large [n -S]\n",
  "SCROUGERS": "SCROUGER, (US archaic) a whopper, something large [n]\n",
  "SCROUGES": "SCROUGE, to crowd; to squeeze, also SCROOGE, SCROWDGE, SCRUZE [v]\n",
  "SCROUGING": "SCROUGE, to crowd; to squeeze, also SCROOGE, SCROWDGE, SCRUZE [v]\n",
  "SCROUNGE": "to gather by foraging [v SCROUNGED, SCROUNGING, SCROUNGES]\n",
  "SCROUNGED": "SCROUNGE, to gather by foraging [v]\n",
  "SCROUNGER": "one who scrounges [n -S]\n",
  "SCROUNGERS": "SCROUNGER, one who scrounges [n]\n",
  "SCROUNGES": "SCROUNGE, to gather by foraging [v]\n",
  "SCROUNGIER": "SCROUNGY, dirty [adj]\n",
  "SCROUNGIEST": "SCROUNGY, dirty [adj]\n",
  "SCROUNGING": "the act of scrounging [n -S]\n",
  "SCROUNGINGS": "SCROUNGING, the act of scrounging [n]\n",
  "SCROUNGY": "dirty [adj SCROUNGIER, SCROUNGIEST]\n",
  "SCROW": "a scroll [n -S]\n",
  "SCROWDGE": "to crowd; to squeeze, also SCROOGE, SCROUGE, SCRUZE [v SCROWDGED, SCROWDGING, SCROWDGES]\n",
  "SCROWDGED": "SCROWDGE, to crowd; to squeeze, also SCROOGE, SCROUGE, SCRUZE [v]\n",
  "SCROWDGES": "SCROWDGE, to crowd; to squeeze, also SCROOGE, SCROUGE, SCRUZE [v]\n",
  "SCROWDGING": "SCROWDGE, to crowd; to squeeze, also SCROOGE, SCROUGE, SCRUZE [v]\n",
  "SCROWL": "to draft, also SCROWLE [v -ED, -ING, -S]\n",
  "SCROWLE": "to draft, also SCROWL [v SCROWLED, SCROWLING, SCROWLES]\n",
  "SCROWLED": "SCROWLE, to draft, also SCROWL [v]\n",
  "SCROWLES": "SCROWLE, to draft, also SCROWL [v]\n",
  "SCROWLING": "SCROWLE, to draft, also SCROWL [v]\n",
  "SCROWLS": "SCROWL, to draft, also SCROWLE [v]\n",
  "SCROWS": "SCROW, a scroll [n]\n",
  "SCROYLE": "(obsolete) a wretch [n -S]\n",
  "SCROYLES": "SCROYLE, (obsolete) a wretch [n]\n",
  "SCRUB": "to rub hard in order to clean [v SCRUBBED, SCRUBBING, SCRUBS]\n",
  "SCRUBBABLE": "that can be scrubbed [adj]\n",
  "SCRUBBED": "SCRUB, to rub hard in order to clean [v]\n",
  "SCRUBBER": "an apparatus for removing impurities from gas or vapour [n -S]\n",
  "SCRUBBERS": "SCRUBBER, an apparatus for removing impurities from gas or vapour [n]\n",
  "SCRUBBIER": "SCRUBBY, inferior in size or quality [adj]\n",
  "SCRUBBIEST": "SCRUBBY, inferior in size or quality [adj]\n",
  "SCRUBBILY": "SCRUBBY, inferior in size or quality [adv]\n",
  "SCRUBBINESS": "the state of being scrubby [n -ES]\n",
  "SCRUBBINESSES": "SCRUBBINESS, the state of being scrubby [n]\n",
  "SCRUBBING": "the act of scrubbing [n -S]\n",
  "SCRUBBINGS": "SCRUBBING, the act of scrubbing [n]\n",
  "SCRUBBY": "inferior in size or quality [adj SCRUBBIER, SCRUBBIEST, SCRUBBILY]\n",
  "SCRUBLAND": "land covered by scrub [n -S]\n",
  "SCRUBLANDS": "SCRUBLAND, land covered by scrub [n]\n",
  "SCRUBS": "SCRUB, to rub hard in order to clean [v]\n",
  "SCRUBWOMAN": "a woman employed to scrub [n SCRUBWOMEN]\n",
  "SCRUBWOMEN": "SCRUBWOMAN, a woman employed to scrub [n]\n",
  "SCRUFF": "in rugby, to engage in a scrummage [v -ED, -ING, -S]\n",
  "SCRUFFED": "SCRUFF, in rugby, to engage in a scrummage [v]\n",
  "SCRUFFIER": "SCRUFFY, untidy, dirty [adj]\n",
  "SCRUFFIEST": "SCRUFFY, untidy, dirty [adj]\n",
  "SCRUFFILY": "SCRUFFY, untidy, dirty [adv]\n",
  "SCRUFFINESS": "the state of being scruffy [n -ES]\n",
  "SCRUFFINESSES": "SCRUFFINESS, the state of being scruffy [n]\n",
  "SCRUFFING": "SCRUFF, in rugby, to engage in a scrummage [v]\n",
  "SCRUFFS": "SCRUFF, in rugby, to engage in a scrummage [v]\n",
  "SCRUFFY": "untidy, dirty [adj SCRUFFIER, SCRUFFIEST, SCRUFFILY]\n",
  "SCRUM": "to mill around the ball in rugby [v SCRUMMED, SCRUMMING, SCRUMS]\n",
  "SCRUMDOWN": "the act of forming a rugby scrum [n -S]\n",
  "SCRUMDOWNS": "SCRUMDOWN, the act of forming a rugby scrum [n]\n",
  "SCRUMMAGE": "a noisy dispute or tussle; a rough or confused struggle [n -S] / to engage in a scrummage, also SCRIMMAGE, SKRIMMAGE [v SCRUMMAGED, SCRUMMAGING, SCRUMMAGES]\n",
  "SCRUMMAGED": "SCRUMMAGE, to engage in a scrummage, also SCRIMMAGE, SKRIMMAGE [v]\n",
  "SCRUMMAGER": "one who takes part in a scrummage [n -S]\n",
  "SCRUMMAGERS": "SCRUMMAGER, one who takes part in a scrummage [n]\n",
  "SCRUMMAGES": "SCRUMMAGE, a noisy dispute or tussle; a rough or confused struggle [n]\n",
  "SCRUMMAGING": "SCRUMMAGE, to engage in a scrummage, also SCRIMMAGE, SKRIMMAGE [v]\n",
  "SCRUMMED": "SCRUM, to mill around the ball in rugby [v]\n",
  "SCRUMMIE": "(slang) a rugby scrum half [n -S]\n",
  "SCRUMMIER": "SCRUMMY, (colloquial) scrumptious [adj]\n",
  "SCRUMMIES": "SCRUMMIE, (slang) a rugby scrum half [n]\n",
  "SCRUMMIEST": "SCRUMMY, (colloquial) scrumptious [adj]\n",
  "SCRUMMING": "SCRUM, to mill around the ball in rugby [v]\n",
  "SCRUMMY": "(colloquial) scrumptious [adj SCRUMMIER, SCRUMMIEST]\n",
  "SCRUMP": "to gather windfalls illegally [v -ED, -ING, -S]\n",
  "SCRUMPED": "SCRUMP, to gather windfalls illegally [v]\n",
  "SCRUMPIES": "SCRUMPY, a kind of rough cider [n]\n",
  "SCRUMPING": "SCRUMP, to gather windfalls illegally [v]\n",
  "SCRUMPLE": "to crumple or crush [v SCRUMPLED, SCRUMPLING, SCRUMPLES]\n",
  "SCRUMPLED": "SCRUMPLE, to crumple or crush [v]\n",
  "SCRUMPLES": "SCRUMPLE, to crumple or crush [v]\n",
  "SCRUMPLING": "SCRUMPLE, to crumple or crush [v]\n",
  "SCRUMPOX": "(slang) rugby slang for impetigo spread by players' faces rubbing together in the scrum [n -ES]\n",
  "SCRUMPOXES": "SCRUMPOX, (slang) rugby slang for impetigo spread by players' faces rubbing together in the scrum [n]\n",
  "SCRUMPS": "SCRUMP, to gather windfalls illegally [v]\n",
  "SCRUMPTIOUS": "delightful, delicious [adj SCRUMPTIOUSLY]\n",
  "SCRUMPTIOUSLY": "SCRUMPTIOUS, delightful, delicious [adv]\n",
  "SCRUMPTIOUSNESS": "the state of being scrumptious [n]\n",
  "SCRUMPY": "a kind of rough cider [n SCRUMPIES]\n",
  "SCRUMS": "SCRUM, to mill around the ball in rugby [v]\n",
  "SCRUNCH": "to crush [v -ED, -ING, -ES]\n",
  "SCRUNCHED": "SCRUNCH, to crush [v]\n",
  "SCRUNCHEON": "(Canadian) in Newfoundland, a small crisp piece of fried pork fat, also SCRUNCHIN, SCRUNCHION [n -S]\n",
  "SCRUNCHEONS": "SCRUNCHEON, (Canadian) in Newfoundland, a small crisp piece of fried pork fat, also SCRUNCHIN, SCRUNCHION [n]\n",
  "SCRUNCHES": "SCRUNCH, to crush [v]\n",
  "SCRUNCHIE": "a piece of elastic, loosely covered with fabric, for tying back the hair, also SCRUNCHY [n -S]\n",
  "SCRUNCHIER": "SCRUNCHY, able to be crushed [adj]\n",
  "SCRUNCHIES": "SCRUNCHIE, a piece of elastic, loosely covered with fabric, for tying back the hair, also SCRUNCHY [n]\n",
  "SCRUNCHIEST": "SCRUNCHY, able to be crushed [adj]\n",
  "SCRUNCHIN": "(Canadian) in Newfoundland, a small crisp piece of fried pork fat, also SCRUNCHEON, SCRUNCHION [n -S]\n",
  "SCRUNCHING": "a crunching [n -S]\n",
  "SCRUNCHINGS": "SCRUNCHING, a crunching [n]\n",
  "SCRUNCHINS": "SCRUNCHIN, (Canadian) in Newfoundland, a small crisp piece of fried pork fat, also SCRUNCHEON, SCRUNCHION [n]\n",
  "SCRUNCHION": "(Canadian) in Newfoundland, a small crisp piece of fried pork fat, also SCRUNCHEON, SCRUNCHIN [n -S]\n",
  "SCRUNCHIONS": "SCRUNCHION, (Canadian) in Newfoundland, a small crisp piece of fried pork fat, also SCRUNCHEON, SCRUNCHIN [n]\n",
  "SCRUNCHY": "able to be crushed [adj SCRUNCHIER, SCRUNCHIEST] / a piece of elastic, loosely covered with fabric, for tying back the hair, also SCRUNCHIE [n SCRUNCHIES]\n",
  "SCRUNT": "(Scots) anything stunted; a niggard [n -S]\n",
  "SCRUNTIER": "SCRUNTY, (Scots) stunted [adj]\n",
  "SCRUNTIEST": "SCRUNTY, (Scots) stunted [adj]\n",
  "SCRUNTS": "SCRUNT, (Scots) anything stunted; a niggard [n]\n",
  "SCRUNTY": "(Scots) stunted [adj SCRUNTIER, SCRUNTIEST]\n",
  "SCRUPLE": "to hesitate because of ethical considerations [v SCRUPLED, SCRUPLING, SCRUPLES]\n",
  "SCRUPLED": "SCRUPLE, to hesitate because of ethical considerations [v]\n",
  "SCRUPLELESS": "without scruples [adj]\n",
  "SCRUPLER": "one who has scruples [n -S]\n",
  "SCRUPLERS": "SCRUPLER, one who has scruples [n]\n",
  "SCRUPLES": "SCRUPLE, to hesitate because of ethical considerations [v]\n",
  "SCRUPLING": "SCRUPLE, to hesitate because of ethical considerations [v]\n",
  "SCRUPULOSITIES": "SCRUPULOSITY, the state of being scrupulous [n]\n",
  "SCRUPULOSITY": "the state of being scrupulous [n SCRUPULOSITIES]\n",
  "SCRUPULOUS": "having moral integrity, acting in strict regard for what is considered right or proper [adj SCRUPULOUSLY]\n",
  "SCRUPULOUSLY": "SCRUPULOUS, having moral integrity, acting in strict regard for what is considered right or proper [adv]\n",
  "SCRUPULOUSNESS": "the state of being scrupulous [n]\n",
  "SCRUTABILITIES": "SCRUTABILITY, the quality of being scrutable [n]\n",
  "SCRUTABILITY": "the quality of being scrutable [n SCRUTABILITIES]\n",
  "SCRUTABLE": "discoverable by scrutiny, inquiry, or critical examination [adj]\n",
  "SCRUTATOR": "one who investigates [n -S]\n",
  "SCRUTATORS": "SCRUTATOR, one who investigates [n]\n",
  "SCRUTINEER": "a scrutinizer; specifically, an examiner of votes, as at an election [n -S]\n",
  "SCRUTINEERS": "SCRUTINEER, a scrutinizer; specifically, an examiner of votes, as at an election [n]\n",
  "SCRUTINIES": "SCRUTINY, a close examination, also SURVEYAL [n]\n",
  "SCRUTINISE": "to examine closely and minutely, also SCRUTINIZE [v SCRUTINISED, SCRUTINISING, SCRUTINISES]\n",
  "SCRUTINISED": "SCRUTINISE, to examine closely and minutely, also SCRUTINIZE [v]\n",
  "SCRUTINISER": "one who scrutinises, also SCRUTINIZER [n -S]\n",
  "SCRUTINISERS": "SCRUTINISER, one who scrutinises, also SCRUTINIZER [n]\n",
  "SCRUTINISES": "SCRUTINISE, to examine closely and minutely, also SCRUTINIZE [v]\n",
  "SCRUTINISING": "SCRUTINISE, to examine closely and minutely, also SCRUTINIZE [v]\n",
  "SCRUTINISINGLY": "SCRUTINISING [adv]\n",
  "SCRUTINIZE": "to examine closely and minutely, also SCRUTINISE [v SCRUTINIZED, SCRUTINIZING, SCRUTINIZES]\n",
  "SCRUTINIZED": "SCRUTINIZE, to examine closely and minutely, also SCRUTINISE [v]\n",
  "SCRUTINIZER": "one who scrutinizes, also SCRUTINISER [n -S]\n",
  "SCRUTINIZERS": "SCRUTINIZER, one who scrutinizes, also SCRUTINISER [n]\n",
  "SCRUTINIZES": "SCRUTINIZE, to examine closely and minutely, also SCRUTINISE [v]\n",
  "SCRUTINIZING": "SCRUTINIZE, to examine closely and minutely, also SCRUTINISE [v]\n",
  "SCRUTINIZINGLY": "SCRUTINIZING, SCRUTINIZE, to examine closely and minutely, also SCRUTINISE [adv]\n",
  "SCRUTINOUS": "closely examining, or inquiring [adj SCRUTINOUSLY]\n",
  "SCRUTINOUSLY": "SCRUTINOUS, closely examining, or inquiring [adv]\n",
  "SCRUTINY": "a close examination, also SURVEYAL [n SCRUTINIES]\n",
  "SCRUTO": "a stage trapdoor [n -S]\n",
  "SCRUTOIRE": "(French) an escritoire, a writing desk, also ESCRITOIRE [n -S]\n",
  "SCRUTOIRES": "SCRUTOIRE, (French) an escritoire, a writing desk, also ESCRITOIRE [n]\n",
  "SCRUTOS": "SCRUTO, a stage trapdoor [n]\n",
  "SCRUZE": "(obsolete) to squeeze, also SCROOGE, SCROUGE, SCROWDGE [v SCRUZED, SCRUZING, SCRUZES]\n",
  "SCRUZED": "SCRUZE, (obsolete) to squeeze, also SCROOGE, SCROUGE, SCROWDGE [v]\n",
  "SCRUZES": "SCRUZE, (obsolete) to squeeze, also SCROOGE, SCROUGE, SCROWDGE [v]\n",
  "SCRUZING": "SCRUZE, (obsolete) to squeeze, also SCROOGE, SCROUGE, SCROWDGE [v]\n",
  "SCRY": "to engage in crystal gazing, also SKRY [v SCRIED or (Spenser) SCRYDE, SCRYING, SCRIES]\n",
  "SCRYDE": "SCRY, to engage in crystal gazing, also SKRY [v]\n",
  "SCRYER": "one who scries in a crystal ball, also SKRYER [n -S]\n",
  "SCRYERS": "SCRYER, one who scries in a crystal ball, also SKRYER [n]\n",
  "SCRYING": "the practice of crystal-gazing [n -S]\n",
  "SCRYINGS": "SCRYING, the practice of crystal-gazing [n]\n",
  "SCRYNE": "(Spenser) a chest for records, also SCRINE [n -S]\n",
  "SCRYNES": "SCRYNE, (Spenser) a chest for records, also SCRINE [n]\n",
  "SCUBA": "an underwater breathing device [n -S] / to dive using scuba equipment [v -ED, -ING, -S]\n",
  "SCUBAED": "SCUBA, to dive using scuba equipment [v]\n",
  "SCUBAING": "SCUBA, to dive using scuba equipment [v]\n",
  "SCUBAS": "SCUBA, to dive using scuba equipment [v]\n",
  "SCUCHIN": "(Spenser) a shield bearing a coat-of-arms, also ESCUTCHEON, SCUTCHEON [n -S]\n",
  "SCUCHINS": "SCUCHIN, (Spenser) a shield bearing a coat-of-arms, also ESCUTCHEON, SCUTCHEON [n]\n",
  "SCUD": "to run or move swiftly [v SCUDDED, SCUDDING, SCUDS]\n",
  "SCUDDALER": "in Shetland, the leader of a band of guisers, also SCUDLER, SKUDLER [n -S]\n",
  "SCUDDALERS": "SCUDDALER, in Shetland, the leader of a band of guisers, also SCUDLER, SKUDLER [n]\n",
  "SCUDDED": "SCUD, to run or move swiftly [v]\n",
  "SCUDDER": "one who scuds, a swift runner [n -S]\n",
  "SCUDDERS": "SCUDDER, one who scuds, a swift runner [n]\n",
  "SCUDDING": "SCUD, to run or move swiftly [v]\n",
  "SCUDDLE": "to run hastily, also SCUTTLE, SKUTTLE [v SCUDDLED, SCUDDLING, SCUDDLES]\n",
  "SCUDDLED": "SCUDDLE, to run hastily, also SCUTTLE, SKUTTLE [v]\n",
  "SCUDDLES": "SCUDDLE, to run hastily, also SCUTTLE, SKUTTLE [v]\n",
  "SCUDDLING": "SCUDDLE, to run hastily, also SCUTTLE, SKUTTLE [v]\n",
  "SCUDI": "SCUDO, (Italian) a former Italian coin [n]\n",
  "SCUDLER": "the conductor of a festival [n -S]\n",
  "SCUDLERS": "SCUDLER, the conductor of a festival [n]\n",
  "SCUDO": "(Italian) a former Italian coin [n SCUDI]\n",
  "SCUDS": "SCUD, to run or move swiftly [v]\n",
  "SCUFF": "to scrape the feet [v -ED, -ING, -S]\n",
  "SCUFFED": "SCUFF, to scrape the feet [v]\n",
  "SCUFFER": "a type of sandal [n -S]\n",
  "SCUFFERS": "SCUFFER, a type of sandal [n]\n",
  "SCUFFING": "SCUFF, to scrape the feet [v]\n",
  "SCUFFLE": "to struggle in a rough, confused manner [v SCUFFLED, SCUFFLING, SCUFFLES]\n",
  "SCUFFLED": "SCUFFLE, to struggle in a rough, confused manner [v]\n",
  "SCUFFLER": "one who scuffles [n -S]\n",
  "SCUFFLERS": "SCUFFLER, one who scuffles [n]\n",
  "SCUFFLES": "SCUFFLE, to struggle in a rough, confused manner [v]\n",
  "SCUFFLING": "a rough confused struggle [n -S]\n",
  "SCUFFLINGS": "SCUFFLING, a rough confused struggle [n]\n",
  "SCUFFS": "SCUFF, to scrape the feet [v]\n",
  "SCUFT": "(Old Norse) the nape of the neck [n -S]\n",
  "SCUFTS": "SCUFT, (Old Norse) the nape of the neck [n]\n",
  "SCUG": "(Scots) to shelter, also SCOG, SCOOG, SCOUG, SKOG, SKUG [v SCUGGED, SCUGGING, SCUGS]\n",
  "SCUGGED": "SCUG, (Scots) to shelter, also SCOG, SCOOG, SCOUG, SKOG, SKUG [v]\n",
  "SCUGGING": "SCUG, (Scots) to shelter, also SCOG, SCOOG, SCOUG, SKOG, SKUG [v]\n",
  "SCUGS": "SCUG, (Scots) to shelter, also SCOG, SCOOG, SCOUG, SKOG, SKUG [v]\n",
  "SCUL": "(obsolete) a school, also SCULLE [n -S]\n",
  "SCULCH": "rubbish, also SCULTCH [n -ES]\n",
  "SCULCHES": "SCULCH, rubbish, also SCULTCH [n]\n",
  "SCULDUDDERIES": "SCULDUDDERY, (Scots) a breach of chastity; bawdy talk, also SCULDUDDRY, SKULDUDDERY [n]\n",
  "SCULDUDDERY": "(Scots) a breach of chastity; bawdy talk, also SCULDUDDRY, SKULDUDDERY [n SCULDUDDERIES]\n",
  "SCULDUDDRIES": "SCULDUDDRY, (Scots) a breach of chastity; bawdy talk, also SCULDUDDERY, SKULDUDDERY [n]\n",
  "SCULDUDDRY": "(Scots) a breach of chastity; bawdy talk, also SCULDUDDERY, SKULDUDDERY [n SCULDUDDRIES]\n",
  "SCULDUGGERIES": "SCULDUGGERY, underhand dealing, trickery, also SKULDUGGERY, SKULLDUGGERY [n]\n",
  "SCULDUGGERY": "underhand dealing, trickery, also SKULDUGGERY, SKULLDUGGERY [n SCULDUGGERIES]\n",
  "SCULK": "to move about stealthily, also SKULK [v -ED, -ING, -S]\n",
  "SCULKED": "SCULK, to move about stealthily, also SKULK [v]\n",
  "SCULKER": "one that skulks, also SKULKER [n -S]\n",
  "SCULKERS": "SCULKER, one that skulks, also SKULKER [n]\n",
  "SCULKING": "SCULK, to move about stealthily, also SKULK [v]\n",
  "SCULKS": "SCULK, to move about stealthily, also SKULK [v]\n",
  "SCULL": "to propel with a type of oar, also SKULL [v -ED, -ING, -S]\n",
  "SCULLE": "(obsolete) a school, also SCUL [n -S]\n",
  "SCULLED": "SCULL, to propel with a type of oar, also SKULL [v]\n",
  "SCULLER": "one that sculls [n -S]\n",
  "SCULLERIES": "SCULLERY, a storeroom and cleaning room for utensils [n]\n",
  "SCULLERS": "SCULLER, one that sculls [n]\n",
  "SCULLERY": "a storeroom and cleaning room for utensils [n SCULLERIES]\n",
  "SCULLES": "SCULLE, (obsolete) a school, also SCUL [n]\n",
  "SCULLING": "the act of sculling [n -S]\n",
  "SCULLINGS": "SCULLING, the act of sculling [n]\n",
  "SCULLION": "a kitchen servant who does menial work [n -S]\n",
  "SCULLIONS": "SCULLION, a kitchen servant who does menial work [n]\n",
  "SCULLS": "SCULL, to propel with a type of oar, also SKULL [v]\n",
  "SCULP": "to form an image from solid material, also SCULPT [v -ED, -ING, -S]\n",
  "SCULPED": "SCULP, to form an image from solid material, also SCULPT [v]\n",
  "SCULPIN": "the scorpion fish, also SKULPIN [n -S]\n",
  "SCULPING": "SCULP, to form an image from solid material, also SCULPT [v]\n",
  "SCULPINS": "SCULPIN, the scorpion fish, also SKULPIN [n]\n",
  "SCULPS": "SCULP, to form an image from solid material, also SCULPT [v]\n",
  "SCULPSIT": "(Latin) he or she sculptured this work, appended to the signature of a sculptor [v]\n",
  "SCULPT": "to form an image from solid material, also SCULP [v -ED, -ING, -S]\n",
  "SCULPTED": "SCULPT, to form an image from solid material, also SCULP [v]\n",
  "SCULPTING": "the act of forming an image or representation of from solid material [n -S]\n",
  "SCULPTINGS": "SCULPTING, the act of forming an image or representation of from solid material [n]\n",
  "SCULPTOR": "one who sculpts [n -S]\n",
  "SCULPTORS": "SCULPTOR, one who sculpts [n]\n",
  "SCULPTRESS": "a woman who is a sculptor [n -ES]\n",
  "SCULPTRESSES": "SCULPTRESS, a woman who is a sculptor [n]\n",
  "SCULPTS": "SCULPT, to form an image from solid material, also SCULP [v]\n",
  "SCULPTURAL": "of or relating to sculpture [adj SCULPTURALLY]\n",
  "SCULPTURALLY": "SCULPTURAL, of or relating to sculpture [adv]\n",
  "SCULPTURE": "to carve in stone [v SCULPTURED, SCULPTURING, SCULPTURES]\n",
  "SCULPTURED": "SCULPTURE, to carve in stone [v]\n",
  "SCULPTURES": "SCULPTURE, to carve in stone [v]\n",
  "SCULPTURESQUE": "done in the manner of or resembling sculpture [adj SCULPTURESQUELY]\n",
  "SCULPTURESQUELY": "SCULPTURESQUE, done in the manner of or resembling sculpture [adv]\n",
  "SCULPTURING": "the act of making a sculpture [n -S]\n",
  "SCULPTURINGS": "SCULPTURING, the act of making a sculpture [n]\n",
  "SCULS": "SCUL, (obsolete) a school, also SCULLE [n]\n",
  "SCULTCH": "rubbish, also SCULCH [n -ES]\n",
  "SCULTCHES": "SCULTCH, rubbish, also SCULCH [n]\n",
  "SCUM": "to remove waste from [v SCUMMED, SCUMMING, SCUMS]\n",
  "SCUMBAG": "a contemptible person [n -S]\n",
  "SCUMBAGS": "SCUMBAG, a contemptible person [n]\n",
  "SCUMBALL": "a dirtbag [n -S]\n",
  "SCUMBALLS": "SCUMBALL, a dirtbag [n]\n",
  "SCUMBER": "(archaic) to void excrement, also SKUMMER [v -ED, -ING, -S]\n",
  "SCUMBERED": "SCUMBER, (archaic) to void excrement, also SKUMMER [v]\n",
  "SCUMBERING": "SCUMBER, (archaic) to void excrement, also SKUMMER [v]\n",
  "SCUMBERS": "SCUMBER, (archaic) to void excrement, also SKUMMER [v]\n",
  "SCUMBLE": "to soften the outlines by rubbing lightly [v SCUMBLED, SCUMBLING, SCUMBLES]\n",
  "SCUMBLED": "SCUMBLE, to soften the outlines by rubbing lightly [v]\n",
  "SCUMBLES": "SCUMBLE, to soften the outlines by rubbing lightly [v]\n",
  "SCUMBLING": "the act of scumbling [n -S]\n",
  "SCUMBLINGS": "SCUMBLING, the act of scumbling [n]\n",
  "SCUMFISH": "(Scots) to suffocate or stifle; to smother, also SCOMFISH [v -ED, -ING, -ES]\n",
  "SCUMFISHED": "SCUMFISH, (Scots) to suffocate or stifle; to smother, also SCOMFISH [v]\n",
  "SCUMFISHES": "SCUMFISH, (Scots) to suffocate or stifle; to smother, also SCOMFISH [v]\n",
  "SCUMFISHING": "SCUMFISH, (Scots) to suffocate or stifle; to smother, also SCOMFISH [v]\n",
  "SCUMLESS": "having no scum [adj]\n",
  "SCUMLIKE": "like scum [adj]\n",
  "SCUMMED": "SCUM, to remove waste from [v]\n",
  "SCUMMER": "(Scots) a shallow ladle or sieve for removing scum or floating matter from the surface of a liquid [n -S]\n",
  "SCUMMERS": "SCUMMER, (Scots) a shallow ladle or sieve for removing scum or floating matter from the surface of a liquid [n]\n",
  "SCUMMIER": "SCUMMY, covered with scum, dirty, unpleasant [adj]\n",
  "SCUMMIEST": "SCUMMY, covered with scum, dirty, unpleasant [adj]\n",
  "SCUMMILY": "SCUMMY, covered with scum, dirty, unpleasant [adv]\n",
  "SCUMMING": "matter removed as scum from the surface of a liquid [n -S]\n",
  "SCUMMINGS": "SCUMMING, matter removed as scum from the surface of a liquid [n]\n",
  "SCUMMY": "covered with scum, dirty, unpleasant [adj SCUMMIER, SCUMMIEST, SCUMMILY]\n",
  "SCUMS": "SCUM, to remove waste from [v]\n",
  "SCUNCHEON": "the inner part of a door jamb or window frame, also SCOINSON, SCONCHEON, SCONTION [n -S]\n",
  "SCUNCHEONS": "SCUNCHEON, the inner part of a door jamb or window frame, also SCOINSON, SCONCHEON, SCONTION [n]\n",
  "SCUNDERED": "(Irish dialect) embarrassed [adj]\n",
  "SCUNGE": "(Australian slang) to slink about [v SCUNGED, SCUNGING, SCUNGES]\n",
  "SCUNGED": "SCUNGE, (Australian slang) to slink about [v]\n",
  "SCUNGES": "SCUNGE, (Australian slang) to slink about [v]\n",
  "SCUNGIER": "SCUNGY, (Australian slang) dirty, unkempt, sordid [adj]\n",
  "SCUNGIEST": "SCUNGY, (Australian slang) dirty, unkempt, sordid [adj]\n",
  "SCUNGILE": "(Italian) the meat of a mollusc or conch, eaten as a delicacy, also SCUNGILLE [n SCUNGILI]\n",
  "SCUNGILI": "SCUNGILE, (Italian) the meat of a mollusc or conch, eaten as a delicacy, also SCUNGILLE [n]\n",
  "SCUNGILLE": "(Italian) the meat of a mollusc or conch, eaten as a delicacy, also SCUNGILE [n SCUNGILLI]\n",
  "SCUNGILLI": "(Italian) conch used as food [n -S]\n",
  "SCUNGILLIS": "SCUNGILLI, (Italian) conch used as food [n]\n",
  "SCUNGING": "SCUNGE, (Australian slang) to slink about [v]\n",
  "SCUNGY": "(Australian slang) dirty, unkempt, sordid [adj SCUNGIER, SCUNGIEST]\n",
  "SCUNNER": "(Scots) to feel loathing or disgust [v -ED, -ING, -S]\n",
  "SCUNNERED": "SCUNNER, (Scots) to feel loathing or disgust [v]\n",
  "SCUNNERING": "SCUNNER, (Scots) to feel loathing or disgust [v]\n",
  "SCUNNERS": "SCUNNER, (Scots) to feel loathing or disgust [v]\n",
  "SCUP": "(Native American) a marine food fish, also SCUPPAUG [n -S]\n",
  "SCUPPAUG": "(Native American) a marine fish food, also SCUP [n -S]\n",
  "SCUPPAUGS": "SCUPPAUG, (Native American) a marine fish food, also SCUP [n]\n",
  "SCUPPER": "to thwart, frustrate [v -ED, -ING, -S]\n",
  "SCUPPERED": "SCUPPER, to thwart, frustrate [v]\n",
  "SCUPPERING": "SCUPPER, to thwart, frustrate [v]\n",
  "SCUPPERNONG": "a native American grape from the region of the Scuppernong river; a sweet wine made from it [n -S]\n",
  "SCUPPERNONGS": "SCUPPERNONG, a native American grape from the region of the Scuppernong river; a sweet wine made from it [n]\n",
  "SCUPPERS": "SCUPPER, to thwart, frustrate [v]\n",
  "SCUPS": "SCUP, (Native American) a marine food fish, also SCUPPAUG [n]\n",
  "SCUR": "to scour, search; to send skimming, also SKER, SKIRR, SQUIRR [v SCURRED, SCURRING, SCURS]\n",
  "SCURF": "scaly or shredded dry skin [n -S]\n",
  "SCURFIER": "SCURFY, covered with scurf [adj]\n",
  "SCURFIEST": "SCURFY, covered with scurf [adj]\n",
  "SCURFINESS": "the state of being scurfy [n -ES]\n",
  "SCURFINESSES": "SCURFINESS, the state of being scurfy [n]\n",
  "SCURFS": "SCURF, scaly or shredded dry skin [n]\n",
  "SCURFY": "covered with scurf [adj SCURFIER, SCURFIEST]\n",
  "SCURRED": "SCUR, to scour, search; to send skimming, also SKER, SKIRR, SQUIRR [v]\n",
  "SCURRIED": "SCURRY, to move hurriedly, also SKURRY [v]\n",
  "SCURRIER": "(obsolete) a scout, also SCURRIOUR [n -S]\n",
  "SCURRIERS": "SCURRIER, (obsolete) a scout, also SCURRIOUR [n]\n",
  "SCURRIES": "SCURRY, to move hurriedly, also SKURRY [v]\n",
  "SCURRIL": "(archaic) like or worthy of a vulgar buffoon; indecently opprobrious or jocular, also SCURRILE [adj]\n",
  "SCURRILE": "(archaic) like or worthy of a vulgar buffoon; indecently opprobrious or jocular, also SCURRIL [adj]\n",
  "SCURRILITIES": "SCURRILITY, the state of being scurrilous [n]\n",
  "SCURRILITY": "the state of being scurrilous [n SCURRILITIES]\n",
  "SCURRILOUS": "using or given to coarse language [adj SCURRILOUSLY]\n",
  "SCURRILOUSLY": "SCURRILOUS, using or given to coarse language [adv]\n",
  "SCURRILOUSNESS": "the state of being scurrilous [n]\n",
  "SCURRING": "SCUR, to scour, search; to send skimming, also SKER, SKIRR, SQUIRR [v]\n",
  "SCURRIOUR": "(obsolete) a scout, also SCURRIER [n -S]\n",
  "SCURRIOURS": "SCURRIOUR, (obsolete) a scout, also SCURRIER [n]\n",
  "SCURRY": "to move hurriedly, also SKURRY [v SCURRIED, SCURRYING, SCURRIES]\n",
  "SCURRYING": "SCURRY, to move hurriedly, also SKURRY [v]\n",
  "SCURS": "SCUR, to scour, search; to send skimming, also SKER, SKIRR, SQUIRR [v]\n",
  "SCURVIER": "SCURVY, scabby, mean [adj]\n",
  "SCURVIES": "SCURVY, a disease caused by lack of Vitamin C [n]\n",
  "SCURVIEST": "SCURVY, scabby, mean [adj]\n",
  "SCURVILY": "SCURVY, scabby, mean [adv]\n",
  "SCURVINESS": "the state of being scurvy [n -ES]\n",
  "SCURVINESSES": "SCURVINESS, the state of being scurvy [n]\n",
  "SCURVY": "scabby, mean [adj SCURVIER, SCURVIEST, SCURVILY] / a disease caused by lack of Vitamin C [n SCURVIES]\n",
  "SCUSE": "an aphetic form of excuse [v SCUSED, SCUSING, SCUSES]\n",
  "SCUSED": "SCUSE, an aphetic form of excuse [v]\n",
  "SCUSES": "SCUSE, an aphetic form of excuse [v]\n",
  "SCUSING": "SCUSE, an aphetic form of excuse [v]\n",
  "SCUT": "the tail of e.g. a rabbit [n -S]\n",
  "SCUTA": "SCUTUM, (Latin) a horny plate or scale, also SCUTE [n]\n",
  "SCUTAGE": "(historical) the tax on a knight's fee, also ESCUAGE [n -S]\n",
  "SCUTAGES": "SCUTAGE, (historical) the tax on a knight's fee, also ESCUAGE [n]\n",
  "SCUTAL": "pertaining to shields [adj]\n",
  "SCUTATE": "shaped like a shield [adj]\n",
  "SCUTATION": "the state of being scutate, buckler-shaped [n -S]\n",
  "SCUTATIONS": "SCUTATION, the state of being scutate, buckler-shaped [n]\n",
  "SCUTCH": "to beat out impurities from flax or wool [v -ED, -ING, -ES]\n",
  "SCUTCHED": "SCUTCH, to beat out impurities from flax or wool [v]\n",
  "SCUTCHEON": "a shield bearing a coat-of-arms, also ESCUTCHEON, SCUCHIN [n -S]\n",
  "SCUTCHEONLESS": "without a scutcheon [adj]\n",
  "SCUTCHEONS": "SCUTCHEON, a shield bearing a coat-of-arms, also ESCUTCHEON, SCUCHIN [n]\n",
  "SCUTCHER": "one who scutches, beats out impurities from flax or wool [n -S]\n",
  "SCUTCHERS": "SCUTCHER, one who scutches, beats out impurities from flax or wool [n]\n",
  "SCUTCHES": "SCUTCH, to beat out impurities from flax or wool [v]\n",
  "SCUTCHING": "the act of beating out impurities from flax or wool [n -S]\n",
  "SCUTCHINGS": "SCUTCHING, the act of beating out impurities from flax or wool [n]\n",
  "SCUTE": "a horny plate or scale, also SCUTUM [n -S]\n",
  "SCUTELLA": "SCUTELLUM, (Latin) a scale on a bird's leg [n]\n",
  "SCUTELLAR": "like a scutella, a small scute, a hard exoskeletal plate [adj]\n",
  "SCUTELLATE": "shaped like a platter; covered with scutellae, also SCUTELLATED [adj]\n",
  "SCUTELLATED": "shaped like a platter; covered with scutella, also SCUTELLATE [adj]\n",
  "SCUTELLATION": "an arrangement of scales or plates on an animal's body [n -S]\n",
  "SCUTELLATIONS": "SCUTELLATION, an arrangement of scales or plates on an animal's body [n]\n",
  "SCUTELLUM": "(Latin) a scale on a bird's leg [n SCUTELLA]\n",
  "SCUTES": "SCUTE, a horny plate or scale, also SCUTUM [n]\n",
  "SCUTIFORM": "shield-shaped [adj]\n",
  "SCUTIGER": "(Latin) a kind of centipede; (facetious) a squire [n -S]\n",
  "SCUTIGERS": "SCUTIGER, (Latin) a kind of centipede; (facetious) a squire [n]\n",
  "SCUTS": "SCUT, the tail of e.g. a rabbit [n]\n",
  "SCUTTER": "to run hastily, scurry [v -ED, -ING, -S]\n",
  "SCUTTERED": "SCUTTER, to run hastily, scurry [v]\n",
  "SCUTTERING": "SCUTTER, to run hastily, scurry [v]\n",
  "SCUTTERS": "SCUTTER, to run hastily, scurry [v]\n",
  "SCUTTLE": "to move or run with short rapid steps, also SCUDDLE, SKUTTLE [v SCUTTLED, SCUTTLING, SCUTTLES]\n",
  "SCUTTLEBUTT": "a drinking fountain on a ship; gossip [n -S]\n",
  "SCUTTLEBUTTS": "SCUTTLEBUTT, a drinking fountain on a ship; gossip [n]\n",
  "SCUTTLED": "SCUTTLE, to move or run with short rapid steps, also SCUDDLE, SKUTTLE [v]\n",
  "SCUTTLEFUL": "the contents of a scuttle [n -S]\n",
  "SCUTTLEFULS": "SCUTTLEFUL, the contents of a scuttle [n]\n",
  "SCUTTLER": "one who scuttles [n -S]\n",
  "SCUTTLERS": "SCUTTLER, one who scuttles [n]\n",
  "SCUTTLES": "SCUTTLE, to move or run with short rapid steps, also SCUDDLE, SKUTTLE [v]\n",
  "SCUTTLING": "he act of sinking a ship deliberately [n -S]\n",
  "SCUTTLINGS": "SCUTTLING, he act of sinking a ship deliberately [n]\n",
  "SCUTUM": "(Latin) a horny plate or scale, also SCUTE [n SCUTA]\n",
  "SCUTWORK": "tedious or menial work [n -S]\n",
  "SCUTWORKS": "SCUTWORK, tedious or menial work [n]\n",
  "SCUZZ": "dirt [n -ES]\n",
  "SCUZZBAG": "a dirty, disreputable person, also SCUZZBALL [n -S]\n",
  "SCUZZBAGS": "SCUZZBAG, a dirty, disreputable person, also SCUZZBALL [n]\n",
  "SCUZZBALL": "a dirty, disreputable person, also SCUZZBAG [n -S]\n",
  "SCUZZBALLS": "SCUZZBALL, a dirty, disreputable person, also SCUZZBAG [n]\n",
  "SCUZZES": "SCUZZ, dirt [n]\n",
  "SCUZZIER": "SCUZZY, dirty or shabby [adj]\n",
  "SCUZZIEST": "SCUZZY, dirty or shabby [adj]\n",
  "SCUZZY": "dirty or shabby [adj SCUZZIER, SCUZZIEST]\n",
  "SCYBALA": "SCYBALUM, (Greek) a lump or mass of hard faeces in the intestine [n]\n",
  "SCYBALOUS": "of or like a scybalum, a lump or mass of hard faeces in the intestine [adj]\n",
  "SCYBALUM": "(Greek) a lump or mass of hard faeces in the intestine [n SCYBALA]\n",
  "SCYE": "an opening for the insertion of a sleeve [n -S]\n",
  "SCYES": "SCYE, an opening for the insertion of a sleeve [n]\n",
  "SCYPHATE": "shaped like a cup [adj]\n",
  "SCYPHI": "SCYPHUS, (Greek) a drinking vessel used in ancient Greece, also SKYPHOS [n]\n",
  "SCYPHIFORM": "cup-shaped [adj]\n",
  "SCYPHISTOMA": "the fixed polypoid stage in the life cycle of a scyphozoan, which reproduces asexually by budding or strobilation [n SCYPHISTOMAE or SCYPHISTOMAS]\n",
  "SCYPHISTOMAE": "SCYPHISTOMA, the fixed polypoid stage in the life cycle of a scyphozoan, which reproduces asexually by budding or strobilation [n]\n",
  "SCYPHISTOMAS": "SCYPHISTOMA, the fixed polypoid stage in the life cycle of a scyphozoan, which reproduces asexually by budding or strobilation [n]\n",
  "SCYPHOZOAN": "any of a class of medusoid coelenterates; a jelly fish [n -S]\n",
  "SCYPHOZOANS": "SCYPHOZOAN, any of a class of medusoid coelenterates; a jelly fish [n]\n",
  "SCYPHUS": "(Greek) a drinking vessel used in ancient Greece, also SKYPHOS [n SCYPHI]\n",
  "SCYTALE": "(Greek) a Spartan form of secret writing on a strip wound round a stick [n -S]\n",
  "SCYTALES": "SCYTALE, (Greek) a Spartan form of secret writing on a strip wound round a stick [n]\n",
  "SCYTHE": "to cut with a single-bladed cutting implement, also SITHE [v SCYTHED, SCYTHING, SCYTHES]\n",
  "SCYTHED": "SCYTHE, to cut with a single-bladed cutting implement, also SITHE [v]\n",
  "SCYTHELIKE": "like a scythe [adj]\n",
  "SCYTHEMAN": "one who uses a scythe [n SCYTHEMEN]\n",
  "SCYTHEMEN": "SCYTHEMAN, one who uses a scythe [n]\n",
  "SCYTHER": "one who uses a scythe [n -S]\n",
  "SCYTHERS": "SCYTHER, one who uses a scythe [n]\n",
  "SCYTHES": "SCYTHE, to cut with a single-bladed cutting implement, also SITHE [v]\n",
  "SCYTHING": "SCYTHE, to cut with a single-bladed cutting implement, also SITHE [v]\n",
  "SDAINE": "(obsolete) to disdain, also SDAYN, SDEIGN, SDEIGNE, SDEIN [v SDAINED, SDAINING, SDAINES]\n",
  "SDAINED": "SDAINE, (obsolete) to disdain, also SDAYN, SDEIGN, SDEIGNE, SDEIN [v]\n",
  "SDAINES": "SDAINE, (obsolete) to disdain, also SDAYN, SDEIGN, SDEIGNE, SDEIN [v]\n",
  "SDAINING": "SDAINE, (obsolete) to disdain, also SDAYN, SDEIGN, SDEIGNE, SDEIN [v]\n",
  "SDAYN": "(obsolete) to disdain, also SDAINE, SDEIGN, SDEIGNE, SDEIN [v -ED, -ING, -S]\n",
  "SDAYNED": "SDAYN, (obsolete) to disdain, also SDAINE, SDEIGN, SDEIGNE, SDEIN [v]\n",
  "SDAYNING": "SDAYN, (obsolete) to disdain, also SDAINE, SDEIGN, SDEIGNE, SDEIN [v]\n",
  "SDAYNS": "SDAYN, (obsolete) to disdain, also SDAINE, SDEIGN, SDEIGNE, SDEIN [v]\n",
  "SDEIGN": "(obsolete) to disdain, also SDAINE, SDAYN, SDEIGNE, SDEIN [v -ED, -ING, -S]\n",
  "SDEIGNE": "(obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIN [v SDEIGNED, SDEIGNING, SDEIGNES]\n",
  "SDEIGNED": "SDEIGNE, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIN [v]\n",
  "SDEIGNES": "SDEIGNE, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIN [v]\n",
  "SDEIGNFULL": "(obsolete) disdainful [adj SDEIGNFULLY]\n",
  "SDEIGNFULLY": "SDEIGNFULL, (obsolete) disdainful [adv]\n",
  "SDEIGNING": "SDEIGNE, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIN [v]\n",
  "SDEIGNS": "SDEIGN, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGNE, SDEIN [v]\n",
  "SDEIN": "(obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIGNE [v -ED, -ING, -S]\n",
  "SDEINED": "SDEIN, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIGNE [v]\n",
  "SDEINING": "SDEIN, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIGNE [v]\n",
  "SDEINS": "SDEIN, (obsolete) to disdain, also SDAINE, SDAYN, SDEIGN, SDEIGNE [v]\n",
  "SDRUCCIOLA": "(Italian) (of rhyme) triple [adj]\n",
  "SEA": "a great expanse of water [n -S]\n",
  "SEABAG": "a bag used by sailors [n -S]\n",
  "SEABAGS": "SEABAG, a bag used by sailors [n]\n",
  "SEABANK": "a bank beside the sea [n -S]\n",
  "SEABANKS": "SEABANK, a bank beside the sea [n]\n",
  "SEABEACH": "a beach lying along the sea [n -ES]\n",
  "SEABEACHES": "SEABEACH, a beach lying along the sea [n]\n",
  "SEABED": "the bottom of the sea [n -S]\n",
  "SEABEDS": "SEABED, the bottom of the sea [n]\n",
  "SEABIRD": "a bird frequenting the ocean or seacoast [n -S]\n",
  "SEABIRDS": "SEABIRD, a bird frequenting the ocean or seacoast [n]\n",
  "SEABLITE": "a salt-marsh plant [n -S]\n",
  "SEABLITES": "SEABLITE, a salt-marsh plant [n]\n",
  "SEABOARD": "the line where land and sea meet, the coastline [n -S]\n",
  "SEABOARDS": "SEABOARD, the line where land and sea meet, the coastline [n]\n",
  "SEABOOT": "a waterproof boot [n -S]\n",
  "SEABOOTS": "SEABOOT, a waterproof boot [n]\n",
  "SEABORGIUM": "an artificially produced radioactive element with atomic number 106 [n -S]\n",
  "SEABORGIUMS": "SEABORGIUM, an artificially produced radioactive element with atomic number 106 [n]\n",
  "SEABORNE": "carried on the sea [adj]\n",
  "SEABOTTLE": "a translucent inflated seaweed; bladderwrack [n -S]\n",
  "SEABOTTLES": "SEABOTTLE, a translucent inflated seaweed; bladderwrack [n]\n",
  "SEABREAM": "a popular food fish [n -S]\n",
  "SEABREAMS": "SEABREAM, a popular food fish [n]\n",
  "SEACHANGER": "a person who moves from a city to a coastal area in order to pursue a more relaxed lifestyle [n -S]\n",
  "SEACHANGERS": "SEACHANGER, a person who moves from a city to a coastal area in order to pursue a more relaxed lifestyle [n]\n",
  "SEACOAST": "land bordering the sea [n -S]\n",
  "SEACOASTS": "SEACOAST, land bordering the sea [n]\n",
  "SEACOCK": "a valve in a ship's hull [n -S]\n",
  "SEACOCKS": "SEACOCK, a valve in a ship's hull [n]\n",
  "SEACRAFT": "skill in navigation [n -S]\n",
  "SEACRAFTS": "SEACRAFT, skill in navigation [n]\n",
  "SEACUNNIES": "SEACUNNY, (Persian) a lascar steersman [n]\n",
  "SEACUNNY": "(Persian) a lascar steersman [n SEACUNNIES]\n",
  "SEADOG": "an old sailor [n -S]\n",
  "SEADOGS": "SEADOG, an old sailor [n]\n",
  "SEADROME": "a floating aerodrome [n -S]\n",
  "SEADROMES": "SEADROME, a floating aerodrome [n]\n",
  "SEAFARER": "one who travels by sea [n -S]\n",
  "SEAFARERS": "SEAFARER, one who travels by sea [n]\n",
  "SEAFARING": "travelling by sea [n -S]\n",
  "SEAFARINGS": "SEAFARING, travelling by sea [n]\n",
  "SEAFLOOR": "the bottom of the sea [n -S]\n",
  "SEAFLOORS": "SEAFLOOR, the bottom of the sea [n]\n",
  "SEAFOAM": "foam formed on the sea [n -S]\n",
  "SEAFOAMS": "SEAFOAM, foam formed on the sea [n]\n",
  "SEAFOLK": "seafaring people [n -S]\n",
  "SEAFOLKS": "SEAFOLK, seafaring people [n]\n",
  "SEAFOOD": "edible fish or shellfish from the sea [n -S]\n",
  "SEAFOODS": "SEAFOOD, edible fish or shellfish from the sea [n]\n",
  "SEAFOWL": "a seabird [n -S]\n",
  "SEAFOWLS": "SEAFOWL, a seabird [n]\n",
  "SEAFRONT": "an area along the edge of the sea [n -S]\n",
  "SEAFRONTS": "SEAFRONT, an area along the edge of the sea [n]\n",
  "SEAGIRT": "surrounded by the sea [adj]\n",
  "SEAGOING": "designed for use on the sea [adj]\n",
  "SEAGRASS": "a grasslike plant living in or close to the sea [n -ES]\n",
  "SEAGRASSES": "SEAGRASS, a grasslike plant living in or close to the sea [n]\n",
  "SEAGULL": "a gull frequenting the sea [n -S]\n",
  "SEAGULLS": "SEAGULL, a gull frequenting the sea [n]\n",
  "SEAHAWK": "a predatory seabird, aka skua [n -S]\n",
  "SEAHAWKS": "SEAHAWK, a predatory seabird, aka skua [n]\n",
  "SEAHOG": "a porpoise [n -S]\n",
  "SEAHOGS": "SEAHOG, a porpoise [n]\n",
  "SEAHORSE": "any marine fish of the genus Hippocampus with a prehensile tail and a horselike head [n -S]\n",
  "SEAHORSES": "SEAHORSE, any marine fish of the genus Hippocampus with a prehensile tail and a horselike head [n]\n",
  "SEAHOUND": "the dogfish [n -S]\n",
  "SEAHOUNDS": "SEAHOUND, the dogfish [n]\n",
  "SEAKALE": "a kind of maritime cabbage [n -S]\n",
  "SEAKALES": "SEAKALE, a kind of maritime cabbage [n]\n",
  "SEAKINDLY": "of a ship, easy to handle [adj]\n",
  "SEAL": "to close or make secure [v -ED, -ING, -S]\n",
  "SEALABLE": "able to be sealed [adj]\n",
  "SEALANT": "a sealing agent [n -S]\n",
  "SEALANTS": "SEALANT, a sealing agent [n]\n",
  "SEALCH": "(Scots) a seal (the animal), also SEALGH, SELKIE, SILKIE [n -S]\n",
  "SEALCHS": "SEALCH, (Scots) a seal (the animal), also SEALGH, SELKIE, SILKIE [n]\n",
  "SEALED": "SEAL, to close or make secure [v]\n",
  "SEALER": "one who hunts seals [n -S]\n",
  "SEALERIES": "SEALERY, the occupation of hunting seals [n]\n",
  "SEALERS": "SEALER, one who hunts seals [n]\n",
  "SEALERY": "the occupation of hunting seals [n SEALERIES]\n",
  "SEALGH": "(Scots) a seal (the animal), also SEALCH, SELKIE, SILKIE [n -S]\n",
  "SEALGHS": "SEALGH, (Scots) a seal (the animal), also SEALCH, SELKIE, SILKIE [n]\n",
  "SEALIFT": "to transport (military personnel and equipment) by ship [v -ED, -ING, -S]\n",
  "SEALIFTED": "SEALIFT, to transport (military personnel and equipment) by ship [v]\n",
  "SEALIFTING": "SEALIFT, to transport (military personnel and equipment) by ship [v]\n",
  "SEALIFTS": "SEALIFT, to transport (military personnel and equipment) by ship [v]\n",
  "SEALINE": "a coastline [n -S]\n",
  "SEALINES": "SEALINE, a coastline [n]\n",
  "SEALING": "the act of sealing [n -S]\n",
  "SEALINGS": "SEALING, the act of sealing [n]\n",
  "SEALLIKE": "like an aquatic mammal [adj]\n",
  "SEALPOINT": "a variety of Siamese cat [n -S]\n",
  "SEALPOINTS": "SEALPOINT, a variety of Siamese cat [n]\n",
  "SEALS": "SEAL, to close or make secure [v]\n",
  "SEALSKIN": "the skin of a seal [n -S]\n",
  "SEALSKINS": "SEALSKIN, the skin of a seal [n]\n",
  "SEALWAX": "sealing wax [n -ES]\n",
  "SEALWAXES": "SEALWAX, sealing wax [n]\n",
  "SEALYHAM": "a terrier dog [n -S]\n",
  "SEALYHAMS": "SEALYHAM, a terrier dog [n]\n",
  "SEAM": "to join by sewing together [v -ED, -ING, -S]\n",
  "SEAMAID": "(Shakespeare) a mermaid [n -S]\n",
  "SEAMAIDS": "SEAMAID, (Shakespeare) a mermaid [n]\n",
  "SEAMAN": "a sailor [n SEAMEN]\n",
  "SEAMANLIER": "SEAMANLY, like a seaman [adj]\n",
  "SEAMANLIEST": "SEAMANLY, like a seaman [adj]\n",
  "SEAMANLIKE": "characteristic of or befitting a competent seaman [adj]\n",
  "SEAMANLY": "like a seaman [adj SEAMANLIER, SEAMANLIEST]\n",
  "SEAMANSHIP": "the art or skill of handling, working, and navigating a ship [n -S]\n",
  "SEAMANSHIPS": "SEAMANSHIP, the art or skill of handling, working, and navigating a ship [n]\n",
  "SEAMARK": "a landmark serving as a navigational guide [n -S]\n",
  "SEAMARKS": "SEAMARK, a landmark serving as a navigational guide [n]\n",
  "SEAME": "grease; lard made from pork fat [n -S]\n",
  "SEAMED": "SEAM, to join by sewing together [v]\n",
  "SEAMEN": "SEAMAN, a sailor [n]\n",
  "SEAMER": "a ball delivered by seam bowling [n -S]\n",
  "SEAMERS": "SEAMER, a ball delivered by seam bowling [n]\n",
  "SEAMES": "SEAME, grease; lard made from pork fat [n]\n",
  "SEAMFREE": "of stockings, without a seam [adj]\n",
  "SEAMIER": "SEAMY, unpleasant [adj]\n",
  "SEAMIEST": "SEAMY, unpleasant [adj]\n",
  "SEAMINESS": "the state of being seamy [n -ES]\n",
  "SEAMINESSES": "SEAMINESS, the state of being seamy [n]\n",
  "SEAMING": "the act of joining by sewing together [n -S]\n",
  "SEAMINGS": "SEAMING, the act of joining by sewing together [n]\n",
  "SEAMLESS": "having no seam, also SEAMFREE [adj SEAMLESSLY]\n",
  "SEAMLESSLY": "SEAMLESS, having no seam, also SEAMFREE [adv]\n",
  "SEAMLESSNESS": "the state of being seamless [n -ES]\n",
  "SEAMLESSNESSES": "SEAMLESSNESS, the state of being seamless [n]\n",
  "SEAMLIKE": "like a seam [adj]\n",
  "SEAMOUNT": "a volcanic mountain on the seafloor [n -S]\n",
  "SEAMOUNTS": "SEAMOUNT, a volcanic mountain on the seafloor [n]\n",
  "SEAMS": "SEAM, to join by sewing together [v]\n",
  "SEAMSET": "a tool for flattening seams in metal etc. [n -S]\n",
  "SEAMSETS": "SEAMSET, a tool for flattening seams in metal etc. [n]\n",
  "SEAMSTER": "a person whose occupation is sewing, esp. the making and mending of garments, also SEMPSTER [n -S]\n",
  "SEAMSTERS": "SEAMSTER, a person whose occupation is sewing, esp. the making and mending of garments, also SEMPSTER [n]\n",
  "SEAMSTRESS": "a woman whose occupation is sewing [n -ES]\n",
  "SEAMSTRESSES": "SEAMSTRESS, a woman whose occupation is sewing [n]\n",
  "SEAMSTRESSIES": "SEAMSTRESSY, (Sterne) sewing, needlework [n]\n",
  "SEAMSTRESSY": "(Sterne) sewing, needlework [n SEAMSTRESSIES]\n",
  "SEAMY": "unpleasant [adj SEAMIER, SEAMIEST]\n",
  "SEAN": "to catch fish in a net, also SEINE [v -ED, -ING, -S]\n",
  "SEANCE": "(French) a session or meeting of psychical researchers or spiritualists for the purpose of trying to contact the spirits of the dead [n -S]\n",
  "SEANCES": "SEANCE, (French) a session or meeting of psychical researchers or spiritualists for the purpose of trying to contact the spirits of the dead [n]\n",
  "SEANED": "SEAN, to catch fish in a net, also SEINE [v]\n",
  "SEANING": "SEAN, to catch fish in a net, also SEINE [v]\n",
  "SEANNACHIE": "(Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHY, SENNACHIE, SHANACHIE [n -S]\n",
  "SEANNACHIES": "SEANNACHY, (Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHIE, SENNACHIE, SHANACHIE [n]\n",
  "SEANNACHY": "(Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHIE, SENNACHIE, SHANACHIE [n SEANNACHIES]\n",
  "SEANS": "SEAN, to catch fish in a net, also SEINE [v]\n",
  "SEAPIECE": "a picture representing a scene at sea; a marine picture [n -S]\n",
  "SEAPIECES": "SEAPIECE, a picture representing a scene at sea; a marine picture [n]\n",
  "SEAPLANE": "an airplane designed to take off from or land on the water [n -S]\n",
  "SEAPLANES": "SEAPLANE, an airplane designed to take off from or land on the water [n]\n",
  "SEAPORT": "a harbour for seagoing ships [n -S]\n",
  "SEAPORTS": "SEAPORT, a harbour for seagoing ships [n]\n",
  "SEAQUAKE": "an undersea earthquake [n -S]\n",
  "SEAQUAKES": "SEAQUAKE, an undersea earthquake [n]\n",
  "SEAQUARIA": "SEAQUARIUM, an oceanarium [n]\n",
  "SEAQUARIUM": "an oceanarium [n SEAQUARIA or SEAQUARIUMS]\n",
  "SEAQUARIUMS": "SEAQUARIUM, an oceanarium [n]\n",
  "SEAR": "scorched, withered, also SEARE, SERE [adj SEARER, SEAREST] / to burn, also SERE [v -ED, -ING, -S]\n",
  "SEARAT": "a pirate [n -S]\n",
  "SEARATS": "SEARAT, a pirate [n]\n",
  "SEARCE": "(obsolete) to sift [v SEARCED, SEARCING, SEARCES]\n",
  "SEARCED": "SEARCE, (obsolete) to sift [v]\n",
  "SEARCES": "SEARCE, (obsolete) to sift [v]\n",
  "SEARCH": "to look carefully for something [v -ED, -ING, -ES]\n",
  "SEARCHABLE": "that can be searched [adj]\n",
  "SEARCHED": "SEARCH, to look carefully for something [v]\n",
  "SEARCHER": "one that searches [n -S]\n",
  "SEARCHERS": "SEARCHER, one that searches [n]\n",
  "SEARCHES": "SEARCH, to look carefully for something [v]\n",
  "SEARCHING": "the act of conducting a search [n -S]\n",
  "SEARCHINGLY": "SEARCHING [adv]\n",
  "SEARCHINGNESS": "the state of being searching [n -ES]\n",
  "SEARCHINGNESSES": "SEARCHINGNESS, the state of being searching [n]\n",
  "SEARCHINGS": "SEARCHING, the act of conducting a search [n]\n",
  "SEARCHLESS": "impossible to be searched [adj]\n",
  "SEARCHLIGHT": "an apparatus for projecting a powerful beam of light [n -S]\n",
  "SEARCHLIGHTS": "SEARCHLIGHT, an apparatus for projecting a powerful beam of light [n]\n",
  "SEARCING": "SEARCE, (obsolete) to sift [v]\n",
  "SEARE": "(Spenser) sere, withered, also SEAR, SERE [adj]\n",
  "SEARED": "SEAR, to burn, also SERE [v]\n",
  "SEAREDNESS": "the state of being seared [n -ES]\n",
  "SEAREDNESSES": "SEAREDNESS, the state of being seared [n]\n",
  "SEARER": "SEAR, scorched, withered, also SEARE, SERE [adj]\n",
  "SEAREST": "SEAR, scorched, withered, also SEARE, SERE [adj]\n",
  "SEARING": "burning [adj SEARINGLY] / the act of searing [n -S]\n",
  "SEARINGLY": "SEARING, burning [adv]\n",
  "SEARINGS": "SEARING, the act of searing [n]\n",
  "SEARNESS": "the state of being dry and withered [n -ES]\n",
  "SEARNESSES": "SEARNESS, the state of being dry and withered [n]\n",
  "SEAROBIN": "an American fish of the gurnard family [n -S]\n",
  "SEAROBINS": "SEAROBIN, an American fish of the gurnard family [n]\n",
  "SEARS": "SEAR, to burn, also SERE [v]\n",
  "SEAS": "SEA, a great expanse of water [n]\n",
  "SEASCAPE": "a picture representing a scene at sea [n -S]\n",
  "SEASCAPES": "SEASCAPE, a picture representing a scene at sea [n]\n",
  "SEASCOUT": "a boy trained in water activities [n -S]\n",
  "SEASCOUTS": "SEASCOUT, a boy trained in water activities [n]\n",
  "SEASE": "(Spenser) to seize, also SEAZE [v SEASED, SEASING, SEASES]\n",
  "SEASED": "SEASE, (Spenser) to seize, also SEAZE [v]\n",
  "SEASES": "SEASE, (Spenser) to seize, also SEAZE [v]\n",
  "SEASHELL": "the shell of a marine mollusk [n -S]\n",
  "SEASHELLS": "SEASHELL, the shell of a marine mollusk [n]\n",
  "SEASHORE": "land bordering on the sea [n -S]\n",
  "SEASHORES": "SEASHORE, land bordering on the sea [n]\n",
  "SEASICK": "affected with nausea caused by sea motion [adj SEASICKER, SEASICKEST]\n",
  "SEASICKER": "SEASICK, affected with nausea caused by sea motion [adj]\n",
  "SEASICKEST": "SEASICK, affected with nausea caused by sea motion [adj]\n",
  "SEASICKNESS": "motion sickness experienced on the water [n -ES]\n",
  "SEASICKNESSES": "SEASICKNESS, motion sickness experienced on the water [n]\n",
  "SEASIDE": "the seashore [n -S]\n",
  "SEASIDES": "SEASIDE, the seashore [n]\n",
  "SEASING": "SEASE, (Spenser) to seize, also SEAZE [v]\n",
  "SEASON": "to improve flavour [v -ED, -ING, -S]\n",
  "SEASONABILITIES": "SEASONABILITY, appropriateness to the season [n]\n",
  "SEASONABILITY": "appropriateness to the season [n SEASONABILITIES]\n",
  "SEASONABLE": "appropriate to the particular season [adj SEASONABLY]\n",
  "SEASONABLENESS": "the state of being seasonable [n]\n",
  "SEASONABLY": "SEASONABLE, appropriate to the particular season [adv]\n",
  "SEASONAL": "occurring at certain times of the year [adj SEASONALLY] / a seasonal event [n -S]\n",
  "SEASONALITIES": "SEASONALITY, the state of being seasonal [n]\n",
  "SEASONALITY": "the state of being seasonal [n SEASONALITIES]\n",
  "SEASONALLY": "SEASONAL, occurring at certain times of the year [adv]\n",
  "SEASONALNESS": "the state of being seasonal [n -ES]\n",
  "SEASONALNESSES": "SEASONALNESS, the state of being seasonal [n]\n",
  "SEASONALS": "SEASONAL, a seasonal event [n]\n",
  "SEASONED": "SEASON, to improve flavour [v]\n",
  "SEASONER": "one who seasons [n -S]\n",
  "SEASONERS": "SEASONER, one who seasons [n]\n",
  "SEASONING": "the process or act by which anything is seasoned [n -S]\n",
  "SEASONINGS": "SEASONING, the process or act by which anything is seasoned [n]\n",
  "SEASONLESS": "without succession of the seasons [adj]\n",
  "SEASONS": "SEASON, to improve flavour [v]\n",
  "SEASPEAK": "a restricted variety of English used by sailors etc. for unambiguous communication [n -S]\n",
  "SEASPEAKS": "SEASPEAK, a restricted variety of English used by sailors etc. for unambiguous communication [n]\n",
  "SEASTRAND": "the seashore [n -S]\n",
  "SEASTRANDS": "SEASTRAND, the seashore [n]\n",
  "SEASURE": "(obsolete) a seizure, also SEISURE, SEYSURE [n -S]\n",
  "SEASURES": "SEASURE, (obsolete) a seizure, also SEISURE, SEYSURE [n]\n",
  "SEAT": "to place on a chair [v -ED, -ING, -S]\n",
  "SEATBACK": "the back of a seat [n -S]\n",
  "SEATBACKS": "SEATBACK, the back of a seat [n]\n",
  "SEATBELT": "an arrangement of straps to keep a person steady in a seat [n -S]\n",
  "SEATBELTS": "SEATBELT, an arrangement of straps to keep a person steady in a seat [n]\n",
  "SEATED": "SEAT, to place on a chair [v]\n",
  "SEATER": "someone or something that seats [n -S]\n",
  "SEATERS": "SEATER, someone or something that seats [n]\n",
  "SEATING": "material for covering seats [n -S]\n",
  "SEATINGS": "SEATING, material for covering seats [n]\n",
  "SEATLESS": "without seats [adj]\n",
  "SEATMATE": "one with whom one shares a seat [n -S]\n",
  "SEATMATES": "SEATMATE, one with whom one shares a seat [n]\n",
  "SEATRAIN": "a ship equipped to carry railroad cars [n -S]\n",
  "SEATRAINS": "SEATRAIN, a ship equipped to carry railroad cars [n]\n",
  "SEATROUT": "a marine fish [n -S]\n",
  "SEATROUTS": "SEATROUT, a marine fish [n]\n",
  "SEATS": "SEAT, to place on a chair [v]\n",
  "SEATWORK": "work done at one's seat [n -S]\n",
  "SEATWORKS": "SEATWORK, work done at one's seat [n]\n",
  "SEAWALL": "a wall to protect a shoreline from erosion [n -S]\n",
  "SEAWALLED": "having a seawall [adj]\n",
  "SEAWALLS": "SEAWALL, a wall to protect a shoreline from erosion [n]\n",
  "SEAWAN": "(Native American) shell beads used by Algonquin Indians as money, also SEAWANT, SEWAN [n -S]\n",
  "SEAWANS": "SEAWAN, (Native American) shell beads used by Algonquin Indians as money, also SEAWANT, SEWAN [n]\n",
  "SEAWANT": "(Native American) shell beads used by Algonquin Indians as money, also SEAWAN, SEWAN [n -S]\n",
  "SEAWANTS": "SEAWANT, (Native American) shell beads used by Algonquin Indians as money, also SEAWAN, SEWAN [n]\n",
  "SEAWARD": "towards the sea, also SEAWARDS [adv SEAWARDLY]\n",
  "SEAWARDLY": "SEAWARD, towards the sea, also SEAWARDS [adv]\n",
  "SEAWARDS": "towards the sea, also SEAWARD [adv]\n",
  "SEAWARE": "seaweed used as fertilizer [n -S]\n",
  "SEAWARES": "SEAWARE, seaweed used as fertilizer [n]\n",
  "SEAWATER": "water from the sea [n -S]\n",
  "SEAWATERS": "SEAWATER, water from the sea [n]\n",
  "SEAWAY": "an inland waterway on which oceangoing vessels can sail [n -S]\n",
  "SEAWAYS": "SEAWAY, an inland waterway on which oceangoing vessels can sail [n]\n",
  "SEAWEED": "any large photosynthetic protist, including Rhodophyta and kelps [n -S]\n",
  "SEAWEEDIER": "SEAWEEDY, abounding in seaweed [adj]\n",
  "SEAWEEDIEST": "SEAWEEDY, abounding in seaweed [adj]\n",
  "SEAWEEDS": "SEAWEED, any large photosynthetic protist, including Rhodophyta and kelps [n]\n",
  "SEAWEEDY": "abounding in seaweed [adj SEAWEEDIER, SEAWEEDIEST]\n",
  "SEAWIFE": "a kind of wrasse, a bony fish [n SEAWIVES]\n",
  "SEAWIVES": "SEAWIFE, a kind of wrasse, a bony fish [n]\n",
  "SEAWOMAN": "a woman serving at sea [n SEAWOMEN]\n",
  "SEAWOMEN": "SEAWOMAN, a woman serving at sea [n]\n",
  "SEAWORM": "a marine worm [n -S]\n",
  "SEAWORMS": "SEAWORM, a marine worm [n]\n",
  "SEAWORTHIER": "SEAWORTHY, able to be used on the sea [adj]\n",
  "SEAWORTHIEST": "SEAWORTHY, able to be used on the sea [adj]\n",
  "SEAWORTHINESS": "the state of being seaworthy [n -ES]\n",
  "SEAWORTHINESSES": "SEAWORTHINESS, the state of being seaworthy [n]\n",
  "SEAWORTHY": "able to be used on the sea [adj SEAWORTHIER, SEAWORTHIEST]\n",
  "SEAZE": "(Spenser) to seize, also SEASE [v SEAZED, SEAZING, SEAZES]\n",
  "SEAZED": "SEAZE, (Spenser) to seize, also SEASE [v]\n",
  "SEAZES": "SEAZE, (Spenser) to seize, also SEASE [v]\n",
  "SEAZING": "SEAZE, (Spenser) to seize, also SEASE [v]\n",
  "SEBACEOUS": "of or like tallow [adj]\n",
  "SEBACIC": "of or like sebum, as in sebacic acid, also SEBASIC [adj]\n",
  "SEBASIC": "derived from a certain acid, also SEBACIC [adj]\n",
  "SEBATE": "a salt of sebacic acid [n -S]\n",
  "SEBATES": "SEBATE, a salt of sebacic acid [n]\n",
  "SEBESTEN": "(Arabic) an oriental tree; its edible plumlike fruit [n -S]\n",
  "SEBESTENS": "SEBESTEN, (Arabic) an oriental tree; its edible plumlike fruit [n]\n",
  "SEBIFEROUS": "bearing fatty matter [adj]\n",
  "SEBIFIC": "producing fatty matter [adj]\n",
  "SEBORRHEA": "a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHOEA [n -S]\n",
  "SEBORRHEAL": "relating to seborrhea, a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHEIC, SEBORRHOEAL, SEBORRHOEIC [adj]\n",
  "SEBORRHEAS": "SEBORRHEA, a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHOEA [n]\n",
  "SEBORRHEIC": "relating to seborrhea, a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHEAL, SEBORRHOEAL, SEBORRHOEIC [adj]\n",
  "SEBORRHOEA": "a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHEA [n -S]\n",
  "SEBORRHOEAL": "relating to seborrhoea, a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHEAL, SEBORRHEIC, SEBORRHOEIC [adj]\n",
  "SEBORRHOEAS": "SEBORRHOEA, a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHEA [n]\n",
  "SEBORRHOEIC": "relating to seborrhoea, a morbidly increased discharge of sebaceous matter upon the skin, also SEBORRHEAL, SEBORRHEIC, SEBORRHOEAL [adj]\n",
  "SEBUM": "(Latin) the fatty secretion that lubricates the hair and skin [n -S]\n",
  "SEBUMS": "SEBUM, (Latin) the fatty secretion that lubricates the hair and skin [n]\n",
  "SEBUNDIES": "SEBUNDY, (Urdu) an Indian irregular soldier [n]\n",
  "SEBUNDY": "(Urdu) an Indian irregular soldier [n SEBUNDIES]\n",
  "SEC": "(short for) a second [n -S]\n",
  "SECALOSE": "a sugar which occurs in green rye and oats [n -S]\n",
  "SECALOSES": "SECALOSE, a sugar which occurs in green rye and oats [n]\n",
  "SECANT": "cutting [adj SECANTLY] / a trigonometric function of an angle [n -S]\n",
  "SECANTLY": "SECANT, cutting [adv]\n",
  "SECANTS": "SECANT, a trigonometric function of an angle [n]\n",
  "SECATEUR": "(French) a pruning tool [n -S]\n",
  "SECATEURS": "SECATEUR, (French) a pruning tool [n]\n",
  "SECCO": "(Italian) painting on dry plaster [n -S]\n",
  "SECCOS": "SECCO, (Italian) painting on dry plaster [n]\n",
  "SECEDE": "to withdraw formally from an alliance [v SECEDED, SECEDING, SECEDES]\n",
  "SECEDED": "SECEDE, to withdraw formally from an alliance [v]\n",
  "SECEDER": "one who secedes [n -S]\n",
  "SECEDERS": "SECEDER, one who secedes [n]\n",
  "SECEDES": "SECEDE, to withdraw formally from an alliance [v]\n",
  "SECEDING": "SECEDE, to withdraw formally from an alliance [v]\n",
  "SECERN": "to discern as separate [v -ED, -ING, -S]\n",
  "SECERNED": "SECERN, to discern as separate [v]\n",
  "SECERNENT": "secretory [adj] / a secretory organ [n -S]\n",
  "SECERNENTS": "SECERNENT, a secretory organ [n]\n",
  "SECERNING": "SECERN, to discern as separate [v]\n",
  "SECERNMENT": "the act of secerning [n -S]\n",
  "SECERNMENTS": "SECERNMENT, the act of secerning [n]\n",
  "SECERNS": "SECERN, to discern as separate [v]\n",
  "SECESH": "a secessionist, also SECESHER [n -ES]\n",
  "SECESHER": "a secessionist, also SECESH [n -S]\n",
  "SECESHERS": "SECESHER, a secessionist, also SECESH [n]\n",
  "SECESHES": "SECESH, a secessionist, also SECESHER [n]\n",
  "SECESSION": "the act of seceding [n -S]\n",
  "SECESSIONAL": "related to secession [adj]\n",
  "SECESSIONISM": "support for secession [n -S]\n",
  "SECESSIONISMS": "SECESSIONISM, support for secession [n]\n",
  "SECESSIONIST": "one who joins in a secession or maintains that secession is a right [n -S]\n",
  "SECESSIONISTS": "SECESSIONIST, one who joins in a secession or maintains that secession is a right [n]\n",
  "SECESSIONS": "SECESSION, the act of seceding [n]\n",
  "SECH": "a hyperbolic secant [n -S]\n",
  "SECHS": "SECH, a hyperbolic secant [n]\n",
  "SECKEL": "a small reddish brown sweet and juicy pear, also SECKLE [n -S]\n",
  "SECKELS": "SECKEL, a small reddish brown sweet and juicy pear, also SECKLE [n]\n",
  "SECKLE": "a small reddish brown sweet and juicy pear, also SECKEL [n -S]\n",
  "SECKLES": "SECKLE, a small reddish brown sweet and juicy pear, also SECKEL [n]\n",
  "SECLUDE": "to remove or set apart from others [v SECLUDED, SECLUDING, SECLUDES]\n",
  "SECLUDED": "SECLUDE, to remove or set apart from others [v]\n",
  "SECLUDEDLY": "SECLUDED, SECLUDE, to remove or set apart from others [adv]\n",
  "SECLUDEDNESS": "the state of being secluded [n -ES]\n",
  "SECLUDEDNESSES": "SECLUDEDNESS, the state of being secluded [n]\n",
  "SECLUDES": "SECLUDE, to remove or set apart from others [v]\n",
  "SECLUDING": "SECLUDE, to remove or set apart from others [v]\n",
  "SECLUSION": "the state of being secluded [n -S]\n",
  "SECLUSIONIST": "one who relishes seclusion [n -S]\n",
  "SECLUSIONISTS": "SECLUSIONIST, one who relishes seclusion [n]\n",
  "SECLUSIONS": "SECLUSION, the state of being secluded [n]\n",
  "SECLUSIVE": "tending to seclude [adj SECLUSIVELY]\n",
  "SECLUSIVELY": "SECLUSIVE, tending to seclude [adv]\n",
  "SECLUSIVENESS": "the state of being seclusive [n -ES]\n",
  "SECLUSIVENESSES": "SECLUSIVENESS, the state of being seclusive [n]\n",
  "SECO": "(Italian) (of wine) dry [adj]\n",
  "SECOBARBITAL": "a barbiturate used chiefly as a hypnotic and sedative [n -S]\n",
  "SECOBARBITALS": "SECOBARBITAL, a barbiturate used chiefly as a hypnotic and sedative [n]\n",
  "SECODONT": "the cutting of back teeth [n -S]\n",
  "SECODONTS": "SECODONT, the cutting of back teeth [n]\n",
  "SECONAL": "(tradename) a hypnotic and soporific barbiturate, aka secobarbital [n -S]\n",
  "SECONALS": "SECONAL, (tradename) a hypnotic and soporific barbiturate, aka secobarbital [n]\n",
  "SECOND": "number two in sequence [adj SECONDLY] / to support a motion [v -ED, -ING, -S]\n",
  "SECONDARIES": "SECONDARY, a subordinate [n]\n",
  "SECONDARILY": "SECONDARY, subordinate [adv]\n",
  "SECONDARINESS": "the state of being secondary [n -ES]\n",
  "SECONDARINESSES": "SECONDARINESS, the state of being secondary [n]\n",
  "SECONDARY": "subordinate [adj SECONDARILY] / a subordinate [n SECONDARIES]\n",
  "SECONDE": "(French) in fencing, a position in parrying [n -S]\n",
  "SECONDED": "SECOND, to support a motion [v]\n",
  "SECONDEE": "a person on secondment [n -S]\n",
  "SECONDEES": "SECONDEE, a person on secondment [n]\n",
  "SECONDER": "one who seconds or supports e.g. a motion [n -S]\n",
  "SECONDERS": "SECONDER, one who seconds or supports e.g. a motion [n]\n",
  "SECONDES": "SECONDE, (French) in fencing, a position in parrying [n]\n",
  "SECONDHAND": "received from or through an intermediary [adj]\n",
  "SECONDI": "SECONDO, (Italian) the second part in a concerted piece [n]\n",
  "SECONDING": "the act of supporting a speaker in a debate [n -S]\n",
  "SECONDINGS": "SECONDING, the act of supporting a speaker in a debate [n]\n",
  "SECONDLY": "SECOND, number two in sequence [adv]\n",
  "SECONDMENT": "the act of seconding [n -S]\n",
  "SECONDMENTS": "SECONDMENT, the act of seconding [n]\n",
  "SECONDO": "(Italian) the second part in a concerted piece [n SECONDI]\n",
  "SECONDS": "SECOND, to support a motion [v]\n",
  "SECPAR": "a unit of astronomical distance, also PARSEC [n -S]\n",
  "SECPARS": "SECPAR, a unit of astronomical distance, also PARSEC [n]\n",
  "SECRECIES": "SECRECY, the condition of being secret [n]\n",
  "SECRECY": "the condition of being secret [n SECRECIES]\n",
  "SECRET": "hidden [adj SECRETER, SECRETEST, SECRETLY] / something hidden [n -S]\n",
  "SECRETA": "(Latin) secreted matter; products of secretion [n]\n",
  "SECRETAGE": "treatment of furs with mercury before felting [n -S]\n",
  "SECRETAGES": "SECRETAGE, treatment of furs with mercury before felting [n]\n",
  "SECRETAGOGIC": "of or like a secretagogue [adj]\n",
  "SECRETAGOGUE": "a substance inducing or stimulating secretion [n -S]\n",
  "SECRETAGOGUES": "SECRETAGOGUE, a substance inducing or stimulating secretion [n]\n",
  "SECRETAIRE": "(French) a writing desk [n -S]\n",
  "SECRETAIRES": "SECRETAIRE, (French) a writing desk [n]\n",
  "SECRETARIAL": "like a secretary [adj]\n",
  "SECRETARIAT": "the office of secretary, also SECRETARIATE [n -S]\n",
  "SECRETARIATE": "the administrative department of a council, organization, legislative or executive body, also SECRETARIAT [n -S]\n",
  "SECRETARIATES": "SECRETARIATE, the administrative department of a council, organization, legislative or executive body, also SECRETARIAT [n]\n",
  "SECRETARIATS": "SECRETARIAT, the office of secretary, also SECRETARIATE [n]\n",
  "SECRETARIES": "SECRETARY, a person who types and deals with correspondence, and does general clerical and administrative work for a company or individual [n]\n",
  "SECRETARY": "a person who types and deals with correspondence, and does general clerical and administrative work for a company or individual [n SECRETARIES]\n",
  "SECRETARYSHIP": "the office of secretary [n -S]\n",
  "SECRETARYSHIPS": "SECRETARYSHIP, the office of secretary [n]\n",
  "SECRETE": "to emit by means of bodily functions [v SECRETED, SECRETING, SECRETES]\n",
  "SECRETED": "SECRETE, to emit by means of bodily functions [v]\n",
  "SECRETER": "SECRET, hidden [adj]\n",
  "SECRETES": "SECRETE, to emit by means of bodily functions [v]\n",
  "SECRETEST": "SECRET, hidden [adj]\n",
  "SECRETIN": "a hormone secreted by the duodenum [n -S]\n",
  "SECRETING": "SECRETE, to emit by means of bodily functions [v]\n",
  "SECRETINS": "SECRETIN, a hormone secreted by the duodenum [n]\n",
  "SECRETION": "something that is secreted [n -S]\n",
  "SECRETIONAL": "related to secretion [adj]\n",
  "SECRETIONARY": "relating to secretion [adj]\n",
  "SECRETIONS": "SECRETION, something that is secreted [n]\n",
  "SECRETIVE": "inclined to or fond of secrecy [adj SECRETIVELY]\n",
  "SECRETIVELY": "SECRETIVE, inclined to or fond of secrecy [adv]\n",
  "SECRETIVENESS": "the state of being secretive [n -ES]\n",
  "SECRETIVENESSES": "SECRETIVENESS, the state of being secretive [n]\n",
  "SECRETLY": "SECRET, hidden [adv]\n",
  "SECRETNESS": "the state of being secret [n -ES]\n",
  "SECRETNESSES": "SECRETNESS, the state of being secret [n]\n",
  "SECRETOR": "one that secretes [n -S]\n",
  "SECRETORIES": "SECRETORY, a secretory vessel [n]\n",
  "SECRETORS": "SECRETOR, one that secretes [n]\n",
  "SECRETORY": "secreting, as secretory vessels, nerves [adj] / a secretory vessel [n SECRETORIES]\n",
  "SECRETS": "SECRET, something hidden [n]\n",
  "SECS": "SEC, (short for) a second [n]\n",
  "SECT": "a group of people united by common beliefs [n -S]\n",
  "SECTARIAL": "distinguishing a sect, esp. in India [adj]\n",
  "SECTARIAN": "relating to a sect [adj] / a member of a sect, esp. a bigot [n -S]\n",
  "SECTARIANISE": "to make sectarian, also SECTARIANIZE [v SECTARIANISED, SECTARIANISING, SECTARIANISES]\n",
  "SECTARIANISED": "SECTARIANISE, to make sectarian, also SECTARIANIZE [v]\n",
  "SECTARIANISES": "SECTARIANISE, to make sectarian, also SECTARIANIZE [v]\n",
  "SECTARIANISING": "SECTARIANISE, to make sectarian, also SECTARIANIZE [v]\n",
  "SECTARIANISM": "being a sectarian [n -S]\n",
  "SECTARIANISMS": "SECTARIANISM, being a sectarian [n]\n",
  "SECTARIANIZE": "to make sectarian, also SECTARIANISE [v SECTARIANIZED, SECTARIANIZING, SECTARIANIZES]\n",
  "SECTARIANIZED": "SECTARIANIZE, to make sectarian, also SECTARIANISE [v]\n",
  "SECTARIANIZES": "SECTARIANIZE, to make sectarian, also SECTARIANISE [v]\n",
  "SECTARIANIZING": "SECTARIANIZE, to make sectarian, also SECTARIANISE [v]\n",
  "SECTARIANS": "SECTARIAN, a member of a sect, esp. a bigot [n]\n",
  "SECTARIES": "SECTARY, a member of a sect [n]\n",
  "SECTARY": "a member of a sect [n SECTARIES]\n",
  "SECTATOR": "an adherent of a party [n -S]\n",
  "SECTATORS": "SECTATOR, an adherent of a party [n]\n",
  "SECTILE": "capable of being cut smoothly [adj]\n",
  "SECTILITIES": "SECTILITY, the state of being sectile [n]\n",
  "SECTILITY": "the state of being sectile [n SECTILITIES]\n",
  "SECTION": "to divide into distinct parts [v -ED, -ING, -S]\n",
  "SECTIONAL": "in sections [adj SECTIONALLY] / a piece of furniture made up of modular units [n -S]\n",
  "SECTIONALISE": "to divide into sections, also SECTIONALIZE [v SECTIONALISED, SECTIONALISING, SECTIONALISES]\n",
  "SECTIONALISED": "SECTIONALISE, to divide into sections, also SECTIONALIZE [v]\n",
  "SECTIONALISES": "SECTIONALISE, to divide into sections, also SECTIONALIZE [v]\n",
  "SECTIONALISING": "SECTIONALISE, to divide into sections, also SECTIONALIZE [v]\n",
  "SECTIONALISM": "an exaggerated devotion to the interests of a region [n -S]\n",
  "SECTIONALISMS": "SECTIONALISM, an exaggerated devotion to the interests of a region [n]\n",
  "SECTIONALIST": "an adherent of sectionalism [n -S]\n",
  "SECTIONALISTS": "SECTIONALIST, an adherent of sectionalism [n]\n",
  "SECTIONALIZE": "to divide into sections, also SECTIONALISE [v SECTIONALIZED, SECTIONALIZING, SECTIONALIZES]\n",
  "SECTIONALIZED": "SECTIONALIZE, to divide into sections, also SECTIONALISE [v]\n",
  "SECTIONALIZES": "SECTIONALIZE, to divide into sections, also SECTIONALISE [v]\n",
  "SECTIONALIZING": "SECTIONALIZE, to divide into sections, also SECTIONALISE [v]\n",
  "SECTIONALLY": "SECTIONAL, in sections [adv]\n",
  "SECTIONALS": "SECTIONAL, a piece of furniture made up of modular units [n]\n",
  "SECTIONED": "SECTION, to divide into distinct parts [v]\n",
  "SECTIONING": "SECTION, to divide into distinct parts [v]\n",
  "SECTIONISATION": "the process of sectionising, also SECTIONIZATION [n -S]\n",
  "SECTIONISATIONS": "SECTIONISATION, the process of sectionising, also SECTIONIZATION [n]\n",
  "SECTIONISE": "to section; to cut sections of, also SECTIONIZE [v SECTIONISED, SECTIONISING, SECTIONISES]\n",
  "SECTIONISED": "SECTIONISE, to section; to cut sections of, also SECTIONIZE [v]\n",
  "SECTIONISES": "SECTIONISE, to section; to cut sections of, also SECTIONIZE [v]\n",
  "SECTIONISING": "SECTIONISE, to section; to cut sections of, also SECTIONIZE [v]\n",
  "SECTIONIZATION": "the process of sectionizing, also SECTIONISATION [n -S]\n",
  "SECTIONIZATIONS": "SECTIONIZATION, the process of sectionizing, also SECTIONISATION [n]\n",
  "SECTIONIZE": "to section; to cut sections of, also SECTIONISE [v SECTIONIZED, SECTIONIZING, SECTIONIZES]\n",
  "SECTIONIZED": "SECTIONIZE, to section; to cut sections of, also SECTIONISE [v]\n",
  "SECTIONIZES": "SECTIONIZE, to section; to cut sections of, also SECTIONISE [v]\n",
  "SECTIONIZING": "SECTIONIZE, to section; to cut sections of, also SECTIONISE [v]\n",
  "SECTIONS": "SECTION, to divide into distinct parts [v]\n",
  "SECTOR": "to divide into sections [v -ED, -ING, -S]\n",
  "SECTORAL": "pertaining to a sector [adj]\n",
  "SECTORED": "SECTOR, to divide into sections [v]\n",
  "SECTORIAL": "adapted for cutting [adj] / a tooth designed for flesh-eating [n -S]\n",
  "SECTORIALS": "SECTORIAL, a tooth designed for flesh-eating [n]\n",
  "SECTORING": "SECTOR, to divide into sections [v]\n",
  "SECTORISATION": "the process of sectorising, also SECTORIZATION [n -S]\n",
  "SECTORISATIONS": "SECTORISATION, the process of sectorising, also SECTORIZATION [n]\n",
  "SECTORISE": "to divide into sectors, also SECTORIZE [v SECTORISED, SECTORISING, SECTORISES]\n",
  "SECTORISED": "SECTORISE, to divide into sectors, also SECTORIZE [v]\n",
  "SECTORISES": "SECTORISE, to divide into sectors, also SECTORIZE [v]\n",
  "SECTORISING": "SECTORISE, to divide into sectors, also SECTORIZE [v]\n",
  "SECTORIZATION": "the process of sectorizing, also SECTORISATION [n -S]\n",
  "SECTORIZATIONS": "SECTORIZATION, the process of sectorizing, also SECTORISATION [n]\n",
  "SECTORIZE": "to divide into sectors, also SECTORISE [v SECTORIZED, SECTORIZING, SECTORIZES]\n",
  "SECTORIZED": "SECTORIZE, to divide into sectors, also SECTORISE [v]\n",
  "SECTORIZES": "SECTORIZE, to divide into sectors, also SECTORISE [v]\n",
  "SECTORIZING": "SECTORIZE, to divide into sectors, also SECTORISE [v]\n",
  "SECTORS": "SECTOR, to divide into sections [v]\n",
  "SECTS": "SECT, a group of people united by common beliefs [n]\n",
  "SECULA": "SECULUM, (Latin) an astronomical or geological age, also SAECULUM [n]\n",
  "SECULAR": "not spiritual [adj SECULARLY] / a layman; a clergyman not bound by monastic rules [n -S]\n",
  "SECULARISATION": "the act of secularising, also SECULARIZATION [n -S]\n",
  "SECULARISATIONS": "SECULARISATION, the act of secularising, also SECULARIZATION [n]\n",
  "SECULARISE": "to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARIZE [v SECULARISED, SECULARISING, SECULARISES]\n",
  "SECULARISED": "SECULARISE, to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARIZE [v]\n",
  "SECULARISER": "one who secularises, also SECULARIZER [n -S]\n",
  "SECULARISERS": "SECULARISER, one who secularises, also SECULARIZER [n]\n",
  "SECULARISES": "SECULARISE, to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARIZE [v]\n",
  "SECULARISING": "SECULARISE, to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARIZE [v]\n",
  "SECULARISM": "the belief that the state, morals, education, etc., should be independent of religion [n -S]\n",
  "SECULARISMS": "SECULARISM, the belief that the state, morals, education, etc., should be independent of religion [n]\n",
  "SECULARIST": "an adherent of secularism [n -S]\n",
  "SECULARISTIC": "relating to secularism, the belief that the state, morals, education, etc., should be independent of religion [adj]\n",
  "SECULARISTS": "SECULARIST, an adherent of secularism [n]\n",
  "SECULARITIES": "SECULARITY, supreme attention to the things of the present life [n]\n",
  "SECULARITY": "supreme attention to the things of the present life [n SECULARITIES]\n",
  "SECULARIZATION": "the act of rendering secular, also SECULARISATION [n -S]\n",
  "SECULARIZATIONS": "SECULARIZATION, the act of rendering secular, also SECULARISATION [n]\n",
  "SECULARIZE": "to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARISE [v SECULARIZED, SECULARIZING, SECULARIZES]\n",
  "SECULARIZED": "SECULARIZE, to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARISE [v]\n",
  "SECULARIZER": "one who secularizes, also SECULARISER [n -S]\n",
  "SECULARIZERS": "SECULARIZER, one who secularizes, also SECULARISER [n]\n",
  "SECULARIZES": "SECULARIZE, to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARISE [v]\n",
  "SECULARIZING": "SECULARIZE, to convert from regular or monastic into secular; as, to secularize a priest or a monk, also SECULARISE [v]\n",
  "SECULARLY": "SECULAR, not spiritual [adv]\n",
  "SECULARS": "SECULAR, a layman; a clergyman not bound by monastic rules [n]\n",
  "SECULUM": "(Latin) an astronomical or geological age, also SAECULUM [n SECULA or SECULUMS]\n",
  "SECULUMS": "SECULUM, (Latin) an astronomical or geological age, also SAECULUM [n]\n",
  "SECUND": "esp. of the flowers in an inflorescence, arranged on or directed towards one side only [adj SECUNDLY]\n",
  "SECUNDINE": "the second of the two integuments of an ovule [n -S]\n",
  "SECUNDINES": "SECUNDINE, the second of the two integuments of an ovule [n]\n",
  "SECUNDLY": "SECUND, esp. of the flowers in an inflorescence, arranged on or directed towards one side only [adv]\n",
  "SECUNDOGENITURE": "a custom whereby the second-oldest child inherits property [n]\n",
  "SECUNDUM": "(Latin) according to [prep]\n",
  "SECURABLE": "that may be secured [adj]\n",
  "SECURANCE": "the act of securing [n -S]\n",
  "SECURANCES": "SECURANCE, the act of securing [n]\n",
  "SECURE": "free from danger [adj SECURER, SECUREST, SECURELY] / to make firm or tight [v SECURED, SECURING, SECURES]\n",
  "SECURED": "SECURE, to make firm or tight [v]\n",
  "SECURELY": "SECURE, free from danger [adv]\n",
  "SECUREMENT": "the act of securing [n -S]\n",
  "SECUREMENTS": "SECUREMENT, the act of securing [n]\n",
  "SECURENESS": "the state of being secure [n -ES]\n",
  "SECURENESSES": "SECURENESS, the state of being secure [n]\n",
  "SECURER": "one who secures [n -S]\n",
  "SECURERS": "SECURER, one who secures [n]\n",
  "SECURES": "SECURE, to make firm or tight [v]\n",
  "SECUREST": "SECURE, free from danger [adj]\n",
  "SECURIFORM": "shaped like an axe [adj]\n",
  "SECURING": "SECURE, to make firm or tight [v]\n",
  "SECURITAN": "(obsolete) someone who dwells in fancied security [n -S]\n",
  "SECURITANS": "SECURITAN, (obsolete) someone who dwells in fancied security [n]\n",
  "SECURITIES": "SECURITY, the state of being secure [n]\n",
  "SECURITISATION": "the act of securitising, also SECURITIZATION [n -S]\n",
  "SECURITISATIONS": "SECURITISATION, the act of securitising, also SECURITIZATION [n]\n",
  "SECURITISE": "to make debts into securities, also SECURITIZE [v SECURITISED, SECURITISING, SECURITISES]\n",
  "SECURITISED": "SECURITISE, to make debts into securities, also SECURITIZE [v]\n",
  "SECURITISES": "SECURITISE, to make debts into securities, also SECURITIZE [v]\n",
  "SECURITISING": "SECURITISE, to make debts into securities, also SECURITIZE [v]\n",
  "SECURITIZATION": "the act of securitizing, also SECURITISATION [n -S]\n",
  "SECURITIZATIONS": "SECURITIZATION, the act of securitizing, also SECURITISATION [n]\n",
  "SECURITIZE": "to make debts into securities, also SECURITISE [v SECURITIZED, SECURITIZING, SECURITIZES]\n",
  "SECURITIZED": "SECURITIZE, to make debts into securities, also SECURITISE [v]\n",
  "SECURITIZES": "SECURITIZE, to make debts into securities, also SECURITISE [v]\n",
  "SECURITIZING": "SECURITIZE, to make debts into securities, also SECURITISE [v]\n",
  "SECURITY": "the state of being secure [n SECURITIES]\n",
  "SECUROCRAT": "an important personage in the security services [n -S]\n",
  "SECUROCRATS": "SECUROCRAT, an important personage in the security services [n]\n",
  "SED": "SAY, to utter in words, speak [v]\n",
  "SEDAN": "a type of automobile [n -S]\n",
  "SEDANS": "SEDAN, a type of automobile [n]\n",
  "SEDARIM": "SEDER, (Hebrew) a Pesach ceremonial meal [n]\n",
  "SEDATE": "calm, self-possessed [adj SEDATER, SEDATEST, SEDATELY] / to tranquillise [v SEDATED, SEDATING, SEDATES]\n",
  "SEDATED": "SEDATE, to tranquillise [v]\n",
  "SEDATELY": "SEDATE, calm, self-possessed [adv]\n",
  "SEDATENESS": "the state of being sedate [n -ES]\n",
  "SEDATENESSES": "SEDATENESS, the state of being sedate [n]\n",
  "SEDATER": "SEDATE, calm, self-possessed [adj]\n",
  "SEDATES": "SEDATE, to tranquillise [v]\n",
  "SEDATEST": "SEDATE, calm, self-possessed [adj]\n",
  "SEDATING": "SEDATE, to tranquillise [v]\n",
  "SEDATION": "the reduction of stress by sedatives [n -S]\n",
  "SEDATIONS": "SEDATION, the reduction of stress by sedatives [n]\n",
  "SEDATIVE": "a drug that induces a calm state [n -S]\n",
  "SEDATIVES": "SEDATIVE, a drug that induces a calm state [n]\n",
  "SEDENT": "(Latin) seated [adj]\n",
  "SEDENTARILY": "SEDENTARY, sitting; living in a fixed location [adv]\n",
  "SEDENTARINESS": "the state of being sedentary [n -ES]\n",
  "SEDENTARINESSES": "SEDENTARINESS, the state of being sedentary [n]\n",
  "SEDENTARY": "sitting; living in a fixed location [adj SEDENTARILY]\n",
  "SEDER": "(Hebrew) a Pesach ceremonial meal [n SEDARIM or SEDERS]\n",
  "SEDERS": "SEDER, (Hebrew) a Pesach ceremonial meal [n]\n",
  "SEDERUNT": "(Latin) a prolonged sitting (as for discussion) [n -S]\n",
  "SEDERUNTS": "SEDERUNT, (Latin) a prolonged sitting (as for discussion) [n]\n",
  "SEDES": "(Latin) a seat [n SEDES]\n",
  "SEDGE": "a plant like a grass but with solid stem [n -S]\n",
  "SEDGED": "bordered by sedge [adj]\n",
  "SEDGELAND": "land where sedge grows [n -S]\n",
  "SEDGELANDS": "SEDGELAND, land where sedge grows [n]\n",
  "SEDGES": "SEDGE, a plant like a grass but with solid stem [n]\n",
  "SEDGIER": "SEDGY, bordered by sedge [adj]\n",
  "SEDGIEST": "SEDGY, bordered by sedge [adj]\n",
  "SEDGY": "bordered by sedge [adj SEDGIER, SEDGIEST]\n",
  "SEDIGITATED": "six-fingered [adj]\n",
  "SEDILE": "(Latin) a seat in a church for officiating clergy, also SEDILIUM [n SEDILIA]\n",
  "SEDILIA": "SEDILIUM, (Latin) a seat in a church for officiating clergy, also SEDILE [n]\n",
  "SEDILIUM": "(Latin) a seat in a church for officiating clergy, also SEDILE [n SEDILIA]\n",
  "SEDIMENT": "to settle in the bottom of a liquid [v -ED, -ING, -S]\n",
  "SEDIMENTABLE": "capable of being sedimented by centrifugation [adj]\n",
  "SEDIMENTARILY": "SEDIMENTARY, relating to or composed of sediment [adv]\n",
  "SEDIMENTARY": "relating to or composed of sediment [adj SEDIMENTARILY]\n",
  "SEDIMENTATION": "the act of forming sediment [n -S]\n",
  "SEDIMENTATIONS": "SEDIMENTATION, the act of forming sediment [n]\n",
  "SEDIMENTED": "SEDIMENT, to settle in the bottom of a liquid [v]\n",
  "SEDIMENTING": "SEDIMENT, to settle in the bottom of a liquid [v]\n",
  "SEDIMENTOLOGIC": "relating to sedimentology [adj]\n",
  "SEDIMENTOLOGIES": "SEDIMENTOLOGY, the study of sediment [n]\n",
  "SEDIMENTOLOGIST": "one who studies sedimentology [n]\n",
  "SEDIMENTOLOGY": "the study of sediment [n SEDIMENTOLOGIES]\n",
  "SEDIMENTOUS": "of or like sediment [adj]\n",
  "SEDIMENTS": "SEDIMENT, to settle in the bottom of a liquid [v]\n",
  "SEDITION": "incitement or rebellion against a government [n -S]\n",
  "SEDITIONARIES": "SEDITIONARY, one who promotes sedition [n]\n",
  "SEDITIONARY": "one who promotes sedition [n SEDITIONARIES]\n",
  "SEDITIONS": "SEDITION, incitement or rebellion against a government [n]\n",
  "SEDITIOUS": "relating to sedition [adj SEDITIOUSLY]\n",
  "SEDITIOUSLY": "SEDITIOUS, relating to sedition [adv]\n",
  "SEDITIOUSNESS": "the state of being seditious [n -ES]\n",
  "SEDITIOUSNESSES": "SEDITIOUSNESS, the state of being seditious [n]\n",
  "SEDUCE": "to lead astray [v SEDUCED, SEDUCING, SEDUCES]\n",
  "SEDUCEABLE": "capable of being seduced [adj]\n",
  "SEDUCED": "SEDUCE, to lead astray [v]\n",
  "SEDUCEMENT": "the act of seducing [n -S]\n",
  "SEDUCEMENTS": "SEDUCEMENT, the act of seducing [n]\n",
  "SEDUCER": "one that seduces [n -S]\n",
  "SEDUCERS": "SEDUCER, one that seduces [n]\n",
  "SEDUCES": "SEDUCE, to lead astray [v]\n",
  "SEDUCIBLE": "capable of being seduced [adj]\n",
  "SEDUCING": "leading astray [adj SEDUCINGLY] / the act of seducing [n -S]\n",
  "SEDUCINGLY": "SEDUCING, leading astray [adv]\n",
  "SEDUCINGS": "SEDUCING, the act of seducing [n]\n",
  "SEDUCIVE": "able to seduce [adj]\n",
  "SEDUCTION": "the act of seducing [n -S]\n",
  "SEDUCTIONS": "SEDUCTION, the act of seducing [n]\n",
  "SEDUCTIVE": "tending to seduce, also SEDUCIVE [adj SEDUCTIVELY]\n",
  "SEDUCTIVELY": "SEDUCTIVE, tending to seduce, also SEDUCIVE [adv]\n",
  "SEDUCTIVENESS": "the state of being seductive [n -ES]\n",
  "SEDUCTIVENESSES": "SEDUCTIVENESS, the state of being seductive [n]\n",
  "SEDUCTOR": "(obsolete) one who seduces or misleads [n -S]\n",
  "SEDUCTORS": "SEDUCTOR, (obsolete) one who seduces or misleads [n]\n",
  "SEDUCTRESS": "a woman who seduces [n -ES]\n",
  "SEDUCTRESSES": "SEDUCTRESS, a woman who seduces [n]\n",
  "SEDULITIES": "SEDULITY, the state of being sedulous, diligent [n]\n",
  "SEDULITY": "the state of being sedulous, diligent [n SEDULITIES]\n",
  "SEDULOUS": "diligent, persevering [adj SEDULOUSLY]\n",
  "SEDULOUSLY": "SEDULOUS, diligent, persevering [adv]\n",
  "SEDULOUSNESS": "the state of being sedulous [n -ES]\n",
  "SEDULOUSNESSES": "SEDULOUSNESS, the state of being sedulous [n]\n",
  "SEDUM": "(Latin) any of a genus of plants, mostly perennial, having succulent leaves and cymose flowers [n -S]\n",
  "SEDUMS": "SEDUM, (Latin) any of a genus of plants, mostly perennial, having succulent leaves and cymose flowers [n]\n",
  "SEE": "to observe with the eyes [v SAW, SEEN, SEEING, SEES]\n",
  "SEEABLE": "able to be seen [adj]\n",
  "SEECATCH": "(Russian) an adult male Aleutian fur seal [n SEECATCHIE or SEECATCHES]\n",
  "SEECATCHES": "SEECATCH, (Russian) an adult male Aleutian fur seal [n]\n",
  "SEECATCHIE": "SEECATCH, (Russian) an adult male Aleutian fur seal [n]\n",
  "SEED": "to sow a crop [v -ED, -ING, -S]\n",
  "SEEDBED": "land prepared for seeding [n -S]\n",
  "SEEDBEDS": "SEEDBED, land prepared for seeding [n]\n",
  "SEEDBOX": "part of a plant that holds seeds [n -ES]\n",
  "SEEDBOXES": "SEEDBOX, part of a plant that holds seeds [n]\n",
  "SEEDCAKE": "a sweet cake with seeds [n -S]\n",
  "SEEDCAKES": "SEEDCAKE, a sweet cake with seeds [n]\n",
  "SEEDCASE": "the protective outer covering of a seed [n -S]\n",
  "SEEDCASES": "SEEDCASE, the protective outer covering of a seed [n]\n",
  "SEEDEATER": "a bird that eats seeds [n -S]\n",
  "SEEDEATERS": "SEEDEATER, a bird that eats seeds [n]\n",
  "SEEDED": "SEED, to sow a crop [v]\n",
  "SEEDER": "one who seeds [n -S]\n",
  "SEEDERS": "SEEDER, one who seeds [n]\n",
  "SEEDHEAD": "a seed-containing part of some plants that develops after flowering or fruiting [n -S]\n",
  "SEEDHEADS": "SEEDHEAD, a seed-containing part of some plants that develops after flowering or fruiting [n]\n",
  "SEEDIER": "SEEDY, shabby [adj]\n",
  "SEEDIEST": "SEEDY, shabby [adj]\n",
  "SEEDILY": "SEEDY, shabby [adv]\n",
  "SEEDINESS": "the state of being seedy [n -ES]\n",
  "SEEDINESSES": "SEEDINESS, the state of being seedy [n]\n",
  "SEEDING": "the act of seeding [n -S]\n",
  "SEEDINGS": "SEEDING, the act of seeding [n]\n",
  "SEEDLESS": "without seeds [adj]\n",
  "SEEDLIKE": "like a seed [adj]\n",
  "SEEDLING": "a young plant [n -S]\n",
  "SEEDLINGS": "SEEDLING, a young plant [n]\n",
  "SEEDLIP": "a sower's basket [n -S]\n",
  "SEEDLIPS": "SEEDLIP, a sower's basket [n]\n",
  "SEEDMAN": "a dealer in seeds, also SEEDSMAN [n SEEDMEN]\n",
  "SEEDMEN": "SEEDMAN, a dealer in seeds, also SEEDSMAN [n]\n",
  "SEEDNESS": "(obsolete) sowing, seedtime [n -ES]\n",
  "SEEDNESSES": "SEEDNESS, (obsolete) sowing, seedtime [n]\n",
  "SEEDPOD": "a type of seed vessel [n -S]\n",
  "SEEDPODS": "SEEDPOD, a type of seed vessel [n]\n",
  "SEEDS": "SEED, to sow a crop [v]\n",
  "SEEDSMAN": "a dealer in seeds, also SEEDMAN [n SEEDSMEN]\n",
  "SEEDSMEN": "SEEDSMAN, a dealer in seeds, also SEEDMAN [n]\n",
  "SEEDSTOCK": "livestock used for breeding [n -S]\n",
  "SEEDSTOCKS": "SEEDSTOCK, livestock used for breeding [n]\n",
  "SEEDTIME": "the season for sowing seeds [n -S]\n",
  "SEEDTIMES": "SEEDTIME, the season for sowing seeds [n]\n",
  "SEEDY": "shabby [adj SEEDIER, SEEDIEST, SEEDILY]\n",
  "SEEING": "the act of one who sees [n -S]\n",
  "SEEINGS": "SEEING, the act of one who sees [n]\n",
  "SEEK": "to go in search of [v SOUGHT, SEEKING, SEEKS]\n",
  "SEEKER": "one who seeks [n -S]\n",
  "SEEKERS": "SEEKER, one who seeks [n]\n",
  "SEEKING": "SEEK, to go in search of [v]\n",
  "SEEKS": "SEEK, to go in search of [v]\n",
  "SEEL": "to stitch closed the eyes of, as a falcon [v -ED, -ING, -S]\n",
  "SEELD": "(Spenser) rare, unusual, also SELD [adj]\n",
  "SEELED": "SEEL, to stitch closed the eyes of, as a falcon [v]\n",
  "SEELIE": "good benevolent fairies [n]\n",
  "SEELIER": "SEELY, fortunate; innocent [adj]\n",
  "SEELIEST": "SEELY, fortunate; innocent [adj]\n",
  "SEELING": "(Spenser) a ceiling [n -S]\n",
  "SEELINGS": "SEELING, (Spenser) a ceiling [n]\n",
  "SEELS": "SEEL, to stitch closed the eyes of, as a falcon [v]\n",
  "SEELY": "fortunate; innocent [adj SEELIER, SEELIEST]\n",
  "SEEM": "to appear to be [v -ED, -ING, -S]\n",
  "SEEMED": "SEEM, to appear to be [v]\n",
  "SEEMELESSE": "(Spenser) unseemly, also SEEMLESS [adj]\n",
  "SEEMER": "one who seems [n -S]\n",
  "SEEMERS": "SEEMER, one who seems [n]\n",
  "SEEMING": "apparent [adj SEEMINGLY] / appearance, semblance [n -S]\n",
  "SEEMINGLY": "SEEMING, apparent [adv]\n",
  "SEEMINGNESS": "the state of seeming or being apparent [n -ES]\n",
  "SEEMINGNESSES": "SEEMINGNESS, the state of seeming or being apparent [n]\n",
  "SEEMINGS": "SEEMING, appearance, semblance [n]\n",
  "SEEMLESS": "(Spenser) unseemly, also SEEMELESSE [adj]\n",
  "SEEMLIER": "SEEMLY, of pleasing appearance, proper [adj]\n",
  "SEEMLIEST": "SEEMLY, of pleasing appearance, proper [adj]\n",
  "SEEMLIHEAD": "(obsolete) seemliness, also SEEMLIHED, SEEMLYHED [n -S]\n",
  "SEEMLIHEADS": "SEEMLIHEAD, (obsolete) seemliness, also SEEMLIHED, SEEMLYHED [n]\n",
  "SEEMLIHED": "(obsolete) seemliness, also SEEMLIHEAD, SEEMLYHED [n -S]\n",
  "SEEMLIHEDS": "SEEMLIHED, (obsolete) seemliness, also SEEMLIHEAD, SEEMLYHED [n]\n",
  "SEEMLINESS": "the state of being seemly [n -ES]\n",
  "SEEMLINESSES": "SEEMLINESS, the state of being seemly [n]\n",
  "SEEMLY": "of pleasing appearance, proper [adj SEEMLIER, SEEMLIEST]\n",
  "SEEMLYHED": "(Spenser) seemliness, also SEEMLIHEAD, SEEMLIHED [n -S]\n",
  "SEEMLYHEDS": "SEEMLYHED, (Spenser) seemliness, also SEEMLIHEAD, SEEMLIHED [n]\n",
  "SEEMS": "SEEM, to appear to be [v]\n",
  "SEEN": "SEE, to observe with the eyes [v]\n",
  "SEEP": "to pass slowly through small openings [v -ED, -ING, -S]\n",
  "SEEPAGE": "the quantity of fluid that has seeped [n -S]\n",
  "SEEPAGES": "SEEPAGE, the quantity of fluid that has seeped [n]\n",
  "SEEPED": "SEEP, to pass slowly through small openings [v]\n",
  "SEEPIER": "SEEPY, oozing with water [adj]\n",
  "SEEPIEST": "SEEPY, oozing with water [adj]\n",
  "SEEPING": "SEEP, to pass slowly through small openings [v]\n",
  "SEEPS": "SEEP, to pass slowly through small openings [v]\n",
  "SEEPY": "oozing with water [adj SEEPIER, SEEPIEST]\n",
  "SEER": "a prophet [n -S]\n",
  "SEERESS": "a female seer [n -ES]\n",
  "SEERESSES": "SEERESS, a female seer [n]\n",
  "SEERS": "SEER, a prophet [n]\n",
  "SEERSUCKER": "(Persian) a light, thin fabric, such as cotton or rayon, with a crinkled surface and a usually striped pattern [n -S]\n",
  "SEERSUCKERS": "SEERSUCKER, (Persian) a light, thin fabric, such as cotton or rayon, with a crinkled surface and a usually striped pattern [n]\n",
  "SEES": "SEE, to observe with the eyes [v]\n",
  "SEESAW": "to move up and down or back and forth [v -ED, -ING, -S]\n",
  "SEESAWED": "SEESAW, to move up and down or back and forth [v]\n",
  "SEESAWING": "SEESAW, to move up and down or back and forth [v]\n",
  "SEESAWS": "SEESAW, to move up and down or back and forth [v]\n",
  "SEETHE": "to surge or foam as if boiling [v SEETHED or (archaic) SOD or SODDEN, SEETHING, SEETHES]\n",
  "SEETHED": "SEETHE, to surge or foam as if boiling [v]\n",
  "SEETHER": "a pot for boiling things [n -S]\n",
  "SEETHERS": "SEETHER, a pot for boiling things [n]\n",
  "SEETHES": "SEETHE, to surge or foam as if boiling [v]\n",
  "SEETHING": "very angry [adj SEETHINGLY] / the act of seething [n -S]\n",
  "SEETHINGLY": "SEETHING, very angry [adv]\n",
  "SEETHINGS": "SEETHING, the act of seething [n]\n",
  "SEEWING": "(Spenser) prosecution, pursuit [n -S]\n",
  "SEEWINGS": "SEEWING, (Spenser) prosecution, pursuit [n]\n",
  "SEFER": "(Hebrew) any book of Hebrew religious literature [n SIFREI]\n",
  "SEG": "a stud in the sole of a shoe [n -S]\n",
  "SEGAR": "a cigar [n -S]\n",
  "SEGARS": "SEGAR, a cigar [n]\n",
  "SEGETAL": "growing in fields of grain [adj]\n",
  "SEGGAR": "a clay box in which pottery is packed for baking, also SAGGAR, SAGGARD, SAGGER [n -S]\n",
  "SEGGARS": "SEGGAR, a clay box in which pottery is packed for baking, also SAGGAR, SAGGARD, SAGGER [n]\n",
  "SEGHOL": "(Hebrew) a vowel-point in Hebrew, also SEGOL [n -S]\n",
  "SEGHOLATE": "in Hebrew, a disyllabic noun form with a tone-long vowel in the first and a short seghol in the second syllable, also SEGOLATE [n -S]\n",
  "SEGHOLATES": "SEGHOLATE, in Hebrew, a disyllabic noun form with a tone-long vowel in the first and a short seghol in the second syllable, also SEGOLATE [n]\n",
  "SEGHOLS": "SEGHOL, (Hebrew) a vowel-point in Hebrew, also SEGOL [n]\n",
  "SEGMENT": "to divide into sections [v -ED, -ING, -S]\n",
  "SEGMENTAL": "relating to, or being, a segment [adj SEGMENTALLY]\n",
  "SEGMENTALLY": "SEGMENTAL, relating to, or being, a segment [adv]\n",
  "SEGMENTARY": "in segments [adj]\n",
  "SEGMENTATE": "in segments [adj]\n",
  "SEGMENTATION": "the state of being segmented [n -S]\n",
  "SEGMENTATIONS": "SEGMENTATION, the state of being segmented [n]\n",
  "SEGMENTED": "SEGMENT, to divide into sections [v]\n",
  "SEGMENTING": "SEGMENT, to divide into sections [v]\n",
  "SEGMENTS": "SEGMENT, to divide into sections [v]\n",
  "SEGNI": "SEGNO, (Italian) a musical sign [n]\n",
  "SEGNO": "(Italian) a musical sign [n SEGNOS or SEGNI]\n",
  "SEGNOS": "SEGNO, (Italian) a musical sign [n]\n",
  "SEGO": "(Native American) a liliaceous plant of Western North America, and its edible bulb [n -S]\n",
  "SEGOL": "(Hebrew) a vowel-point in Hebrew, also SEGHOL [n -S]\n",
  "SEGOLATE": "in Hebrew, a disyllabic noun form with a tone-long vowel in the first and a short seghol in the second syllable, also SEGHOLATE [n -S]\n",
  "SEGOLATES": "SEGOLATE, in Hebrew, a disyllabic noun form with a tone-long vowel in the first and a short seghol in the second syllable, also SEGHOLATE [n]\n",
  "SEGOLS": "SEGOL, (Hebrew) a vowel-point in Hebrew, also SEGHOL [n]\n",
  "SEGOS": "SEGO, (Native American) a liliaceous plant of Western North America, and its edible bulb [n]\n",
  "SEGREANT": "in heraldry, with raised wings [adj]\n",
  "SEGREGABLE": "that can be segregated [adj]\n",
  "SEGREGANT": "a genetic segregate [n -S]\n",
  "SEGREGANTS": "SEGREGANT, a genetic segregate [n]\n",
  "SEGREGATE": "to keep apart from [v SEGREGATED, SEGREGATING, SEGREGATES]\n",
  "SEGREGATED": "SEGREGATE, to keep apart from [v]\n",
  "SEGREGATES": "SEGREGATE, to keep apart from [v]\n",
  "SEGREGATING": "SEGREGATE, to keep apart from [v]\n",
  "SEGREGATION": "the act of segregating [n -S]\n",
  "SEGREGATIONAL": "relating to segregation [adj]\n",
  "SEGREGATIONIST": "a person who believes in or practices segregation esp. of races [n -S]\n",
  "SEGREGATIONISTS": "SEGREGATIONIST, a person who believes in or practices segregation esp. of races [n]\n",
  "SEGREGATIONS": "SEGREGATION, the act of segregating [n]\n",
  "SEGREGATIVE": "serving to segregate [adj]\n",
  "SEGREGATOR": "one who segregates [n -S]\n",
  "SEGREGATORS": "SEGREGATOR, one who segregates [n]\n",
  "SEGS": "SEG, a stud in the sole of a shoe [n]\n",
  "SEGUE": "(Italian) to proceed from one musical theme to another without pause [v SEGUED, SEGUEING, SEGUES]\n",
  "SEGUED": "SEGUE, (Italian) to proceed from one musical theme to another without pause [v]\n",
  "SEGUEING": "SEGUE, (Italian) to proceed from one musical theme to another without pause [v]\n",
  "SEGUES": "SEGUE, (Italian) to proceed from one musical theme to another without pause [v]\n",
  "SEGUGIO": "(Italian) an Italian breed of dog [n -S]\n",
  "SEGUGIOS": "SEGUGIO, (Italian) an Italian breed of dog [n]\n",
  "SEGUIDILLA": "(Spanish) a Spanish folk dance, a Spanish verse form of seven lines [n -S]\n",
  "SEGUIDILLAS": "SEGUIDILLA, (Spanish) a Spanish folk dance, a Spanish verse form of seven lines [n]\n",
  "SEHRI": "(Arabic) a meal eaten before sunrise by those fasting during Ramadan, also SOHUR, SUHUR [n -S]\n",
  "SEHRIS": "SEHRI, (Arabic) a meal eaten before sunrise by those fasting during Ramadan, also SOHUR, SUHUR [n]\n",
  "SEI": "a kind of rorqual whale [n -S]\n",
  "SEICENTO": "(Italian) the seventeenth century in Italy; the Italian style of art, literature, etc., of this period [n -S]\n",
  "SEICENTOS": "SEICENTO, (Italian) the seventeenth century in Italy; the Italian style of art, literature, etc., of this period [n]\n",
  "SEICHE": "(French) a rocking movement of the surface of a lake or inland sea [n -S]\n",
  "SEICHES": "SEICHE, (French) a rocking movement of the surface of a lake or inland sea [n]\n",
  "SEIDEL": "(German) a large glass for beer [n -S]\n",
  "SEIDELS": "SEIDEL, (German) a large glass for beer [n]\n",
  "SEIF": "(Arabic) a long sand-dune lying parallel to the direction of the wind that forms it [n -S]\n",
  "SEIFS": "SEIF, (Arabic) a long sand-dune lying parallel to the direction of the wind that forms it [n]\n",
  "SEIGNEUR": "(French) a feudal lord, also SEIGNIOR, SIGNIEUR [n -S]\n",
  "SEIGNEURIAL": "relating to a man of rank or authority [adj]\n",
  "SEIGNEURIE": "a domain, also SEIGNEURY [n -S]\n",
  "SEIGNEURIES": "SEIGNEURIE, a domain, also SEIGNEURY [n]\n",
  "SEIGNEURS": "SEIGNEUR, (French) a feudal lord, also SEIGNIOR, SIGNIEUR [n]\n",
  "SEIGNEURY": "esp. in France and Canada, a landed estate held by feudal tenure, the territory or domain of a seigneur, also SEIGNEURIE [n SEIGNEURIES]\n",
  "SEIGNIOR": "a feudal lord, also SEIGNEUR, SIGNIEUR [n -S]\n",
  "SEIGNIORAGE": "a government revenue from the manufacture of coins calculated as the difference between the monetary and the bullion value of the silver contained in silver coins [n -S]\n",
  "SEIGNIORAGES": "SEIGNIORAGE, a government revenue from the manufacture of coins calculated as the difference between the monetary and the bullion value of the silver contained in silver coins [n]\n",
  "SEIGNIORALTIES": "SEIGNIORALTY, feudal lordship, also SEIGNIORY, SEIGNORY, SIGNIORY, SIGNORY [n]\n",
  "SEIGNIORALTY": "feudal lordship, also SEIGNIORY, SEIGNORY, SIGNIORY, SIGNORY [n SEIGNIORALTIES]\n",
  "SEIGNIORIAL": "related to a seignior, also SEIGNORAL, SEIGNORIAL [adj]\n",
  "SEIGNIORIES": "SEIGNIORY, feudal lordship, also SEIGNIORALTY, SEIGNORY, SIGNIORY, SIGNORY [n]\n",
  "SEIGNIORS": "SEIGNIOR, a feudal lord, also SEIGNEUR, SIGNIEUR [n]\n",
  "SEIGNIORSHIP": "the office of seignior [n -S]\n",
  "SEIGNIORSHIPS": "SEIGNIORSHIP, the office of seignior [n]\n",
  "SEIGNIORY": "feudal lordship, also SEIGNIORALTY, SEIGNORY, SIGNIORY, SIGNORY [n SEIGNIORIES]\n",
  "SEIGNORAGE": "a government revenue from the manufacture of coins calculated as the difference between the monetary and the bullion value of the silver contained in silver coins [n -S]\n",
  "SEIGNORAGES": "SEIGNORAGE, a government revenue from the manufacture of coins calculated as the difference between the monetary and the bullion value of the silver contained in silver coins [n]\n",
  "SEIGNORAL": "related to a seignior, also SEIGNIORIAL, SEIGNORIAL [adj]\n",
  "SEIGNORIAL": "related to a seignior, also SEIGNIORIAL, SEIGNORAL [adj]\n",
  "SEIGNORIES": "SEIGNORY, feudal lordship, also SEIGNIORALTY, SEIGNIORY, SIGNIORY, SIGNORY [n]\n",
  "SEIGNORY": "feudal lordship, also SEIGNIORALTY, SEIGNIORY, SIGNIORY, SIGNORY [n SEIGNORIES]\n",
  "SEIK": "(Scots) sick [adj SEIKER, SEIKEST]\n",
  "SEIKER": "SEIK, (Scots) sick [adj]\n",
  "SEIKEST": "SEIK, (Scots) sick [adj]\n",
  "SEIL": "to strain, also SILE [v -ED, -ING, -S]\n",
  "SEILED": "SEIL, to strain, also SILE [v]\n",
  "SEILING": "SEIL, to strain, also SILE [v]\n",
  "SEILS": "SEIL, to strain, also SILE [v]\n",
  "SEINE": "to catch fish with a hanging net, also SEAN [v SEINED, SEINING, SEINES]\n",
  "SEINED": "SEINE, to catch fish with a hanging net, also SEAN [v]\n",
  "SEINER": "one who fishes with a seine [n -S]\n",
  "SEINERS": "SEINER, one who fishes with a seine [n]\n",
  "SEINES": "SEINE, to catch fish with a hanging net, also SEAN [v]\n",
  "SEINING": "fishing with a seine-net [n -S]\n",
  "SEININGS": "SEINING, fishing with a seine-net [n]\n",
  "SEIR": "(Portuguese) a fish of the mackerel family, found in the eastern coastal waters of India [n -S]\n",
  "SEIRS": "SEIR, (Portuguese) a fish of the mackerel family, found in the eastern coastal waters of India [n]\n",
  "SEIS": "SEI, a kind of rorqual whale [n]\n",
  "SEISABLE": "able to be seised [adj]\n",
  "SEISE": "to take hold of suddenly and forcibly, also SEIZE [v SEISED, SEISING, SEISES]\n",
  "SEISED": "SEISE, to take hold of suddenly and forcibly, also SEIZE [v]\n",
  "SEISER": "one who seizes (property), takes possession, also SEISOR, SEIZER, SEIZOR [n -S]\n",
  "SEISERS": "SEISER, one who seizes (property), takes possession, also SEISOR, SEIZER, SEIZOR [n]\n",
  "SEISES": "SEISE, to take hold of suddenly and forcibly, also SEIZE [v]\n",
  "SEISIN": "legal possession of land, also SEIZIN [n -S]\n",
  "SEISING": "the act of one that seizes, also SEIZING [n -S]\n",
  "SEISINGS": "SEISING, the act of one that seizes, also SEIZING [n]\n",
  "SEISINS": "SEISIN, legal possession of land, also SEIZIN [n]\n",
  "SEISM": "an earthquake [n -S]\n",
  "SEISMAL": "pertaining to an earthquake, also SEISMIC [adj]\n",
  "SEISMIC": "relating to earthquakes, also SEISMAL, SEISMICAL [adj SEISMICALLY]\n",
  "SEISMICAL": "relating to earthquakes, also SEISMAL, SEISMIC [adj SEISMICALLY]\n",
  "SEISMICALLY": "SEISMICAL, relating to earthquakes, also SEISMAL, SEISMIC [adv]\n",
  "SEISMICITIES": "SEISMICITY, the degree of vulnerability to earthquakes [n]\n",
  "SEISMICITY": "the degree of vulnerability to earthquakes [n SEISMICITIES]\n",
  "SEISMISM": "the natural activity involved in earthquakes [n -S]\n",
  "SEISMISMS": "SEISMISM, the natural activity involved in earthquakes [n]\n",
  "SEISMOGRAM": "a seismograph record [n -S]\n",
  "SEISMOGRAMS": "SEISMOGRAM, a seismograph record [n]\n",
  "SEISMOGRAPH": "an instrument for recording earthquakes [n -S]\n",
  "SEISMOGRAPHER": "one who uses a seismograph [n -S]\n",
  "SEISMOGRAPHERS": "SEISMOGRAPHER, one who uses a seismograph [n]\n",
  "SEISMOGRAPHIC": "relating to seismography, also SEISMOGRAPHICAL [adj]\n",
  "SEISMOGRAPHICAL": "relating to seismography, also SEISMOGRAPHIC [adj]\n",
  "SEISMOGRAPHIES": "SEISMOGRAPHY, measurement by use of the seismograph [n]\n",
  "SEISMOGRAPHS": "SEISMOGRAPH, an instrument for recording earthquakes [n]\n",
  "SEISMOGRAPHY": "measurement by use of the seismograph [n SEISMOGRAPHIES]\n",
  "SEISMOLOGIC": "related to seismology, also SEISMOLOGICAL [adj SEISMOLOGICALLY]\n",
  "SEISMOLOGICAL": "related to seismology, also SEISMOLOGIC [adj SEISMOLOGICALLY]\n",
  "SEISMOLOGICALLY": "SEISMOLOGICAL, related to seismology, also SEISMOLOGIC [adv]\n",
  "SEISMOLOGIES": "SEISMOLOGY, the study of earthquakes [n]\n",
  "SEISMOLOGIST": "one who studies earthquakes [n -S]\n",
  "SEISMOLOGISTS": "SEISMOLOGIST, one who studies earthquakes [n]\n",
  "SEISMOLOGY": "the study of earthquakes [n SEISMOLOGIES]\n",
  "SEISMOMETER": "an instrument for measuring earthquake intensity [n -S]\n",
  "SEISMOMETERS": "SEISMOMETER, an instrument for measuring earthquake intensity [n]\n",
  "SEISMOMETRIC": "relating to measurement by seismometer, also SEISMOMETRICAL [adj]\n",
  "SEISMOMETRICAL": "relating to measurement by seismometer, also SEISMOMETRIC [adj]\n",
  "SEISMOMETRIES": "SEISMOMETRY, the scientific study of earthquakes [n]\n",
  "SEISMOMETRY": "the scientific study of earthquakes [n SEISMOMETRIES]\n",
  "SEISMONASTIC": "relating to seismonasty, response to mechanical shock [adj]\n",
  "SEISMONASTIES": "SEISMONASTY, response to mechanical shock [n]\n",
  "SEISMONASTY": "response to mechanical shock [n SEISMONASTIES]\n",
  "SEISMOSCOPE": "an instrument for detecting earthquakes [n -S]\n",
  "SEISMOSCOPES": "SEISMOSCOPE, an instrument for detecting earthquakes [n]\n",
  "SEISMOSCOPIC": "pertaining to a seismoscope, an instrument for detecting earthquakes [adj]\n",
  "SEISMS": "SEISM, an earthquake [n]\n",
  "SEISOR": "one who seizes (property), takes possession, also SEISER, SEIZER, SEIZOR [n -S]\n",
  "SEISORS": "SEISOR, one who seizes (property), takes possession, also SEISER, SEIZER, SEIZOR [n]\n",
  "SEISURE": "the act of seizing, or the state of being seized, also SEASURE, SEIZURE, SEYSURE [n -S]\n",
  "SEISURES": "SEISURE, the act of seizing, or the state of being seized, also SEASURE, SEIZURE, SEYSURE [n]\n",
  "SEITAN": "(Japanese) a food made from wheat gluten, also SEITEN [n -S]\n",
  "SEITANS": "SEITAN, (Japanese) a food made from wheat gluten, also SEITEN [n]\n",
  "SEITEN": "(Japanese) a food made from wheat gluten, also SEITAN [n -S]\n",
  "SEITENS": "SEITEN, (Japanese) a food made from wheat gluten, also SEITAN [n]\n",
  "SEITIES": "SEITY, personal identity [n]\n",
  "SEITY": "personal identity [n SEITIES]\n",
  "SEIZA": "(Japanese) a kneeling position in Japanese martial arts [n -S]\n",
  "SEIZABLE": "able to be seized [adj]\n",
  "SEIZAS": "SEIZA, (Japanese) a kneeling position in Japanese martial arts [n]\n",
  "SEIZE": "to take hold of suddenly and forcibly, also SEISE [v SEIZED, SEIZING, SEIZES]\n",
  "SEIZED": "SEIZE, to take hold of suddenly and forcibly, also SEISE [v]\n",
  "SEIZER": "one who seizes (property), takes possession, also SEISER, SEISOR, SEIZOR [n -S]\n",
  "SEIZERS": "SEIZER, one who seizes (property), takes possession, also SEISER, SEISOR, SEIZOR [n]\n",
  "SEIZES": "SEIZE, to take hold of suddenly and forcibly, also SEISE [v]\n",
  "SEIZIN": "legal possession of land, also SEISIN [n -S]\n",
  "SEIZING": "the act of one that seizes, also SEISING [n -S]\n",
  "SEIZINGS": "SEIZING, the act of one that seizes, also SEISING [n]\n",
  "SEIZINS": "SEIZIN, legal possession of land, also SEISIN [n]\n",
  "SEIZOR": "one that takes seizing, also SEISOR [n -S]\n",
  "SEIZORS": "SEIZOR, one that takes seizing, also SEISOR [n]\n",
  "SEIZURE": "the act of seizing, also SEISURE [n -S]\n",
  "SEIZURES": "SEIZURE, the act of seizing, also SEISURE [n]\n",
  "SEJANT": "in heraldry, represented in a sitting position, also SEJEANT [adj]\n",
  "SEJEANT": "in heraldry, represented in a sitting position, also SEJANT [adj]\n",
  "SEKOS": "(Greek) a sacred enclosure in an ancient Egyptian temple [n -ES]\n",
  "SEKOSES": "SEKOS, (Greek) a sacred enclosure in an ancient Egyptian temple [n]\n",
  "SEKT": "(German) a sparkling wine [n -S]\n",
  "SEKTS": "SEKT, (German) a sparkling wine [n]\n",
  "SEL": "(Scots) self [n -S]\n",
  "SELACHIAN": "a member of the shark or ray family [n -S]\n",
  "SELACHIANS": "SELACHIAN, a member of the shark or ray family [n]\n",
  "SELADANG": "(Malay) a kind of wild ox, also SALADANG, SLADANG [n -S]\n",
  "SELADANGS": "SELADANG, (Malay) a kind of wild ox, also SALADANG, SLADANG [n]\n",
  "SELAGINELLA": "a plant of the genus Selaginella, heterosporous club mosses [n -S]\n",
  "SELAGINELLAS": "SELAGINELLA, a plant of the genus Selaginella, heterosporous club mosses [n]\n",
  "SELAH": "(Hebrew) a musical instruction meaning a pause, to reflect upon that which came before or which follows, for a meditative attitude [n -S]\n",
  "SELAHS": "SELAH, (Hebrew) a musical instruction meaning a pause, to reflect upon that which came before or which follows, for a meditative attitude [n]\n",
  "SELAMLIK": "(Turkish) the portion of a Turkish house reserved for men [n -S]\n",
  "SELAMLIKS": "SELAMLIK, (Turkish) the portion of a Turkish house reserved for men [n]\n",
  "SELCOUTH": "(obsolete) strange, unfamiliar [adj]\n",
  "SELD": "(obsolete) rare; unusual, also SEELD [adj]\n",
  "SELDOM": "infrequent [adj SELDOMLY]\n",
  "SELDOMLY": "SELDOM, infrequent [adv]\n",
  "SELDOMNESS": "the state of being seldom [n -ES]\n",
  "SELDOMNESSES": "SELDOMNESS, the state of being seldom [n]\n",
  "SELDSEEN": "(obsolete) seldom seen [adj]\n",
  "SELDSHOWN": "(Shakespeare) rarely shown [adj]\n",
  "SELE": "happiness [n -S]\n",
  "SELECT": "choice [adj SELECTLY] / to choose [v -ED, -ING, -S]\n",
  "SELECTA": "a disc jockey [n -S]\n",
  "SELECTABLE": "that can be selected [adj]\n",
  "SELECTAS": "SELECTA, a disc jockey [n]\n",
  "SELECTED": "SELECT, to choose [v]\n",
  "SELECTEE": "one that is selected [n -S]\n",
  "SELECTEES": "SELECTEE, one that is selected [n]\n",
  "SELECTING": "SELECT, to choose [v]\n",
  "SELECTION": "the act of selecting [n -S]\n",
  "SELECTIONIST": "one who considers natural selection a fundamental factor in evolution [n -S]\n",
  "SELECTIONISTS": "SELECTIONIST, one who considers natural selection a fundamental factor in evolution [n]\n",
  "SELECTIONS": "SELECTION, the act of selecting [n]\n",
  "SELECTIVE": "liking to choose [adj SELECTIVELY]\n",
  "SELECTIVELY": "SELECTIVE, liking to choose [adv]\n",
  "SELECTIVENESS": "the state of being selective [n -ES]\n",
  "SELECTIVENESSES": "SELECTIVENESS, the state of being selective [n]\n",
  "SELECTIVITIES": "SELECTIVITY, the state of being selective [n]\n",
  "SELECTIVITY": "the state of being selective [n SELECTIVITIES]\n",
  "SELECTLY": "SELECT, choice [adv]\n",
  "SELECTMAN": "one of a board of town officers chosen annually in the New England States to transact the general public business of the town [n SELECTMEN]\n",
  "SELECTMEN": "SELECTMAN, one of a board of town officers chosen annually in the New England States to transact the general public business of the town [n]\n",
  "SELECTNESS": "the state of being select [n -ES]\n",
  "SELECTNESSES": "SELECTNESS, the state of being select [n]\n",
  "SELECTOR": "something or someone that selects [n -S]\n",
  "SELECTORATE": "as in selectorate theory, a political term [n -S]\n",
  "SELECTORATES": "SELECTORATE, as in selectorate theory, a political term [n]\n",
  "SELECTORIAL": "related to selection [adj]\n",
  "SELECTORS": "SELECTOR, something or someone that selects [n]\n",
  "SELECTS": "SELECT, to choose [v]\n",
  "SELEGILINE": "a drug used in the treatment of Parkinson's disease [n -S]\n",
  "SELEGILINES": "SELEGILINE, a drug used in the treatment of Parkinson's disease [n]\n",
  "SELENATE": "a salt of selenic acid [n -S]\n",
  "SELENATES": "SELENATE, a salt of selenic acid [n]\n",
  "SELENIAN": "of the moon [adj]\n",
  "SELENIC": "(Greek) of or relating to the moon [adj]\n",
  "SELENIDE": "a compound of selenium [n -S]\n",
  "SELENIDES": "SELENIDE, a compound of selenium [n]\n",
  "SELENIFEROUS": "containing or yielding selenium [adj]\n",
  "SELENIOUS": "of selenium in lower valency, also SELENOUS [adj]\n",
  "SELENITE": "a variety of gypsum [n -S]\n",
  "SELENITES": "SELENITE, a variety of gypsum [n]\n",
  "SELENITIC": "pertaining to selenite [adj]\n",
  "SELENIUM": "a nonmetallic solid element used in photoelectric cells [n -S]\n",
  "SELENIUMS": "SELENIUM, a nonmetallic solid element used in photoelectric cells [n]\n",
  "SELENOCENTRIC": "pertaining to moon's centre; having moon as centre [adj]\n",
  "SELENODONT": "having crescent-shaped ridges on the crowns of the molar teeth [adj] / a selenodont animal [n -S]\n",
  "SELENODONTS": "SELENODONT, a selenodont animal [n]\n",
  "SELENOGRAPH": "a delineation of the moon [n -S]\n",
  "SELENOGRAPHER": "one who maps the moon, also SELENOGRAPHIST [n -S]\n",
  "SELENOGRAPHERS": "SELENOGRAPHER, one who maps the moon, also SELENOGRAPHIST [n]\n",
  "SELENOGRAPHIC": "relating to selenography, the mapping of the moon, also SELENOGRAPHICAL [adj]\n",
  "SELENOGRAPHICAL": "relating to selenography, the mapping of the moon, also SELENOGRAPHIC [adj]\n",
  "SELENOGRAPHIES": "SELENOGRAPHY, the branch of astronomy dealing with the physical features of the moon [n]\n",
  "SELENOGRAPHIST": "one who maps the moon, also SELENOGRAPHER [n -S]\n",
  "SELENOGRAPHISTS": "SELENOGRAPHIST, one who maps the moon, also SELENOGRAPHER [n]\n",
  "SELENOGRAPHS": "SELENOGRAPH, a delineation of the moon [n]\n",
  "SELENOGRAPHY": "the branch of astronomy dealing with the physical features of the moon [n SELENOGRAPHIES]\n",
  "SELENOLOGICAL": "relating to selenology [adj]\n",
  "SELENOLOGIES": "SELENOLOGY, the study of the moon [n]\n",
  "SELENOLOGIST": "one who studies the moon [n -S]\n",
  "SELENOLOGISTS": "SELENOLOGIST, one who studies the moon [n]\n",
  "SELENOLOGY": "the study of the moon [n SELENOLOGIES]\n",
  "SELENOSES": "SELENOSIS, selenium poisoning [n]\n",
  "SELENOSIS": "selenium poisoning [n SELENOSES]\n",
  "SELENOUS": "of selenium in lower valency, also SELENIOUS [adj]\n",
  "SELES": "SELE, happiness [n]\n",
  "SELF": "one's own person [n SELVES] / to fertilize by the same individual [v -ED, -ING, -S]\n",
  "SELFDOM": "selfhood [n -S]\n",
  "SELFDOMS": "SELFDOM, selfhood [n]\n",
  "SELFED": "SELF, to fertilize by the same individual [v]\n",
  "SELFHEAL": "a perennial herb with blue flowers [n -S]\n",
  "SELFHEALS": "SELFHEAL, a perennial herb with blue flowers [n]\n",
  "SELFHOOD": "the state of being an individual person, also SELFNESS [n -S]\n",
  "SELFHOODS": "SELFHOOD, the state of being an individual person, also SELFNESS [n]\n",
  "SELFIE": "(Australian) a photograph of oneself taken by oneself [n -S]\n",
  "SELFIES": "SELFIE, (Australian) a photograph of oneself taken by oneself [n]\n",
  "SELFING": "self-fertilization [n -S]\n",
  "SELFINGS": "SELFING, self-fertilization [n]\n",
  "SELFISH": "concerned only with oneself [adj SELFISHLY]\n",
  "SELFISHLY": "SELFISH, concerned only with oneself [adv]\n",
  "SELFISHNESS": "the state of being selfish [n -ES]\n",
  "SELFISHNESSES": "SELFISHNESS, the state of being selfish [n]\n",
  "SELFISM": "concentration on self [n -S]\n",
  "SELFISMS": "SELFISM, concentration on self [n]\n",
  "SELFIST": "one who is dedicated to self [n -S]\n",
  "SELFISTS": "SELFIST, one who is dedicated to self [n]\n",
  "SELFLESS": "unselfish [adj SELFLESSLY]\n",
  "SELFLESSLY": "SELFLESS, unselfish [adv]\n",
  "SELFLESSNESS": "the state of being selfless [n -ES]\n",
  "SELFLESSNESSES": "SELFLESSNESS, the state of being selfless [n]\n",
  "SELFNESS": "the state of being an individual person, also SELFHOOD [n -ES]\n",
  "SELFNESSES": "SELFNESS, the state of being an individual person, also SELFHOOD [n]\n",
  "SELFS": "SELF, to fertilize by the same individual [v]\n",
  "SELFSAME": "identical [adj]\n",
  "SELFSAMENESS": "the state of being selfsame [n -ES]\n",
  "SELFSAMENESSES": "SELFSAMENESS, the state of being selfsame [n]\n",
  "SELFWARD": "towards oneself [adv]\n",
  "SELFWARDS": "towards oneself, also SELFWARD [adv]\n",
  "SELICTAR": "(Turkish) a swordbearer [n -S]\n",
  "SELICTARS": "SELICTAR, (Turkish) a swordbearer [n]\n",
  "SELKIE": "(Scots) a seal, also SEALCH, SEALGH, SILKIE [n -S]\n",
  "SELKIES": "SELKIE, (Scots) a seal, also SEALCH, SEALGH, SILKIE [n]\n",
  "SELL": "to give up for money [v SOLD, SELLING, SELLS]\n",
  "SELLA": "(Latin) an area in the sphenoid bone [n SELLAS or SELLAE]\n",
  "SELLABLE": "able to be sold [adj]\n",
  "SELLAE": "SELLA, (Latin) an area in the sphenoid bone [n]\n",
  "SELLAS": "SELLA, (Latin) an area in the sphenoid bone [n]\n",
  "SELLE": "(archaic) a seat, saddle [n -S]\n",
  "SELLER": "one that sells [n -S]\n",
  "SELLERS": "SELLER, one that sells [n]\n",
  "SELLES": "SELLE, (archaic) a seat, saddle [n]\n",
  "SELLING": "the act of giving up for money [n -S]\n",
  "SELLINGS": "SELLING, the act of giving up for money [n]\n",
  "SELLOFF": "the sale of a large number of stocks, bonds, or commodities [n -S]\n",
  "SELLOFFS": "SELLOFF, the sale of a large number of stocks, bonds, or commodities [n]\n",
  "SELLOTAPE": "(tradename) a kind of adhesive tape [n -S] / to stick with sellotape [v SELLOTAPED, SELLOTAPING, SELLOTAPES]\n",
  "SELLOTAPED": "SELLOTAPE, to stick with sellotape [v]\n",
  "SELLOTAPES": "SELLOTAPE, to stick with sellotape [v]\n",
  "SELLOTAPING": "SELLOTAPE, to stick with sellotape [v]\n",
  "SELLOUT": "a performance for which all seats have been sold [n -S]\n",
  "SELLOUTS": "SELLOUT, a performance for which all seats have been sold [n]\n",
  "SELLS": "SELL, to give up for money [v]\n",
  "SELS": "SEL, (Scots) self [n]\n",
  "SELSYN": "a type of remote-control device [n -S]\n",
  "SELSYNS": "SELSYN, a type of remote-control device [n]\n",
  "SELTZER": "(German) naturally effervescent mineral water; artificially carbonated water [n -S]\n",
  "SELTZERS": "SELTZER, (German) naturally effervescent mineral water; artificially carbonated water [n]\n",
  "SELTZOGENE": "a gazogene, an apparatus for carbonating water [n -S]\n",
  "SELTZOGENES": "SELTZOGENE, a gazogene, an apparatus for carbonating water [n]\n",
  "SELVA": "(Spanish) a wet forest in the Amazon basin [n -S]\n",
  "SELVAGE": "to border a fabric to prevent fraying, also SELVEDGE [v SELVAGED, SELVAGING, SELVAGES]\n",
  "SELVAGED": "SELVAGE, to border a fabric to prevent fraying, also SELVEDGE [v]\n",
  "SELVAGEE": "an untwisted skein of rope yarn marled together to form a strop [n -S]\n",
  "SELVAGEES": "SELVAGEE, an untwisted skein of rope yarn marled together to form a strop [n]\n",
  "SELVAGES": "SELVAGE, to border a fabric to prevent fraying, also SELVEDGE [v]\n",
  "SELVAGING": "SELVAGE, to border a fabric to prevent fraying, also SELVEDGE [v]\n",
  "SELVAS": "SELVA, (Spanish) a wet forest in the Amazon basin [n]\n",
  "SELVEDGE": "to border a fabric to prevent fraying, also SELVAGE [v SELVEDGED, SELVEDGING, SELVEDGES]\n",
  "SELVEDGED": "SELVEDGE, to border a fabric to prevent fraying, also SELVAGE [v]\n",
  "SELVEDGES": "SELVEDGE, to border a fabric to prevent fraying, also SELVAGE [v]\n",
  "SELVEDGING": "SELVEDGE, to border a fabric to prevent fraying, also SELVAGE [v]\n",
  "SELVES": "SELF, one's own person [n]\n",
  "SEMAINIER": "(French) a chest of drawers [n -S]\n",
  "SEMAINIERS": "SEMAINIER, (French) a chest of drawers [n]\n",
  "SEMANTEME": "an irreducible linguistic unit of meaning [n -S]\n",
  "SEMANTEMES": "SEMANTEME, an irreducible linguistic unit of meaning [n]\n",
  "SEMANTIC": "of or relating to meaning, also SEMANTICAL [adj SEMANTICALLY]\n",
  "SEMANTICAL": "of or relating to meaning, also SEMANTIC [adj SEMANTICALLY]\n",
  "SEMANTICALLY": "SEMANTICAL, of or relating to meaning, also SEMANTIC [adv]\n",
  "SEMANTICIST": "a specialist in semantics [n -S]\n",
  "SEMANTICISTS": "SEMANTICIST, a specialist in semantics [n]\n",
  "SEMANTICS": "the study of meaning [n]\n",
  "SEMANTIDE": "a molecule carrying information, e.g. in a gene or messenger RNA [n -S]\n",
  "SEMANTIDES": "SEMANTIDE, a molecule carrying information, e.g. in a gene or messenger RNA [n]\n",
  "SEMANTRA": "SEMANTRON, (Greek) a wooden or metal bar struck with a mallet, used instead of a bell in Orthodox churches [n]\n",
  "SEMANTRON": "(Greek) a wooden or metal bar struck with a mallet, used instead of a bell in Orthodox churches [n SEMANTRA or SEMANTRONS]\n",
  "SEMANTRONS": "SEMANTRON, (Greek) a wooden or metal bar struck with a mallet, used instead of a bell in Orthodox churches [n]\n",
  "SEMAPHORE": "a method of signalling with flags [n -S] / to signal in this way [v SEMAPHORED, SEMAPHORING, SEMAPHORES]\n",
  "SEMAPHORED": "SEMAPHORE, to signal in this way [v]\n",
  "SEMAPHORES": "SEMAPHORE, to signal in this way [v]\n",
  "SEMAPHORIC": "related to semaphore, also SEMAPHORICAL [adj SEMAPHORICALLY]\n",
  "SEMAPHORICAL": "related to semaphore, also SEMAPHORIC [adj SEMAPHORICALLY]\n",
  "SEMAPHORICALLY": "SEMAPHORICAL, related to semaphore, also SEMAPHORIC [adv]\n",
  "SEMAPHORING": "SEMAPHORE, to signal in this way [v]\n",
  "SEMASIOLOGICAL": "relating to semasiology, the study of meaning [adj]\n",
  "SEMASIOLOGIES": "SEMASIOLOGY, the study of meaning, esp. the study of semantic change [n]\n",
  "SEMASIOLOGIST": "a student of semasiology, the study of meaning [n -S]\n",
  "SEMASIOLOGISTS": "SEMASIOLOGIST, a student of semasiology, the study of meaning [n]\n",
  "SEMASIOLOGY": "the study of meaning, esp. the study of semantic change [n SEMASIOLOGIES]\n",
  "SEMATIC": "of markings, coloration, etc., serving as a signal or warning [adj]\n",
  "SEMATOLOGIES": "SEMATOLOGY, another name for semantics, the study of meaning [n]\n",
  "SEMATOLOGY": "another name for semantics, the study of meaning [n SEMATOLOGIES]\n",
  "SEMBLABLE": "(obsolete) similar [adj SEMBLABLY] / something that is like or similar [n -S]\n",
  "SEMBLABLES": "SEMBLABLE, something that is like or similar [n]\n",
  "SEMBLABLY": "SEMBLABLE, (obsolete) similar [adv]\n",
  "SEMBLANCE": "an outward appearance [n -S]\n",
  "SEMBLANCES": "SEMBLANCE, an outward appearance [n]\n",
  "SEMBLANT": "(archaic) a likeness or copy [n -S]\n",
  "SEMBLANTS": "SEMBLANT, (archaic) a likeness or copy [n]\n",
  "SEMBLATIVE": "(obsolete) resembling [adj]\n",
  "SEMBLE": "to bring together, assemble [v SEMBLED, SEMBLING, SEMBLES]\n",
  "SEMBLED": "SEMBLE, to bring together, assemble [v]\n",
  "SEMBLES": "SEMBLE, to bring together, assemble [v]\n",
  "SEMBLING": "SEMBLE, to bring together, assemble [v]\n",
  "SEME": "a type of heraldic pattern [n -S]\n",
  "SEMEE": "in heraldry, strewn or scattered with small bearings, also SEME, SEMEED [adj]\n",
  "SEMEED": "in heraldry, strewn or scattered with small bearings, also SEME, SEMEE [adj]\n",
  "SEMEIA": "SEMEION, (Greek) in ancient prosody, one of the two divisions of a foot [n]\n",
  "SEMEIOLOGIC": "relating to semeiology, the study of signs and signals, also SEMEIOLOGICAL [adj]\n",
  "SEMEIOLOGICAL": "related to semeiology, the study of signs and signals, also SEMEIOLOGIC [adj]\n",
  "SEMEIOLOGIES": "SEMEIOLOGY, the study of signs and signals, also SEMIOLOGY [n]\n",
  "SEMEIOLOGIST": "a specialist in semeiology [n -S]\n",
  "SEMEIOLOGISTS": "SEMEIOLOGIST, a specialist in semeiology [n]\n",
  "SEMEIOLOGY": "the study of signs and signals, also SEMIOLOGY [n SEMEIOLOGIES]\n",
  "SEMEION": "(Greek) in ancient prosody, one of the two divisions of a foot [n SEMEIA]\n",
  "SEMEIOTIC": "relating to signs or symbols, esp. spoken or written signs, also SEMIOTIC [adj SEMEIOTICALLY]\n",
  "SEMEIOTICALLY": "SEMEIOTIC, relating to signs or symbols, esp. spoken or written signs, also SEMIOTIC [adv]\n",
  "SEMEIOTICIAN": "a practitioner of semiotics, a philosophical theory of signs and symbols, also SEMIOTICIAN, SEMIOTICIST [n -S]\n",
  "SEMEIOTICIANS": "SEMEIOTICIAN, a practitioner of semiotics, a philosophical theory of signs and symbols, also SEMIOTICIAN, SEMIOTICIST [n]\n",
  "SEMEIOTICS": "a philosophical theory of signs and symbols, also SEMIOTICS [n]\n",
  "SEMELPARITIES": "SEMELPARITY, the quality of having a single reproductive season and then dying [n]\n",
  "SEMELPARITY": "the quality of having a single reproductive season and then dying [n SEMELPARITIES]\n",
  "SEMELPAROUS": "reproducing or breeding only once in a lifetime, like salmon [adj]\n",
  "SEMEME": "the smallest unanalysable unit of linguistic meaning (e.g. a word or affix) [n -S]\n",
  "SEMEMES": "SEMEME, the smallest unanalysable unit of linguistic meaning (e.g. a word or affix) [n]\n",
  "SEMEMIC": "pertaining to a sememe or meaning of a linguistic unit [adj]\n",
  "SEMEN": "(Latin) the liquid that carries spermatozoa [n SEMENS or SEMINA]\n",
  "SEMENS": "SEMEN, (Latin) the liquid that carries spermatozoa [n]\n",
  "SEMES": "SEME, a type of heraldic pattern [n]\n",
  "SEMESTER": "(Latin) a period of six months; esp. a term in a college or university which divides the year into two terms [n -S]\n",
  "SEMESTERED": "educated according to a Canadian educational system [adj]\n",
  "SEMESTERING": "(Canadian) a type of educational system [n -S]\n",
  "SEMESTERINGS": "SEMESTERING, (Canadian) a type of educational system [n]\n",
  "SEMESTERS": "SEMESTER, (Latin) a period of six months; esp. a term in a college or university which divides the year into two terms [n]\n",
  "SEMESTRAL": "half-yearly, also SEMESTRIAL [adj]\n",
  "SEMESTRIAL": "half-yearly, also SEMESTRAL [adj]\n",
  "SEMI": "a semidetached house [n -S]\n",
  "SEMIABSTRACT": "having subject matter that is easily recognizable although the form is stylized [adj]\n",
  "SEMIABSTRACTION": "the state of being semiabstract, having subject matter that is easily recognizable although the form is stylized [n]\n",
  "SEMIANGLE": "the half of a given, or measuring, angle [n -S]\n",
  "SEMIANGLES": "SEMIANGLE, the half of a given, or measuring, angle [n]\n",
  "SEMIANNUAL": "half-yearly [adj SEMIANNUALLY]\n",
  "SEMIANNUALLY": "SEMIANNUAL, half-yearly [adv]\n",
  "SEMIAQUATIC": "growing equally well in or adjacent to water [adj]\n",
  "SEMIARBOREAL": "often inhabiting and frequenting trees but not completely arboreal [adj]\n",
  "SEMIARID": "receiving between 10 and 20 inches of precipitation annually [adj]\n",
  "SEMIARIDITIES": "SEMIARIDITY, the state of being semiarid [n]\n",
  "SEMIARIDITY": "the state of being semiarid [n SEMIARIDITIES]\n",
  "SEMIAUTOMATED": "partially automated [adj]\n",
  "SEMIAUTOMATIC": "a gun that is not fully automatic [n -S]\n",
  "SEMIAUTOMATICS": "SEMIAUTOMATIC, a gun that is not fully automatic [n]\n",
  "SEMIAUTONOMOUS": "largely self-governing within a larger political or organizational entity [adj]\n",
  "SEMIBALD": "partly bald [adj]\n",
  "SEMIBASEMENT": "a basement partly above ground, as in a house built on a slope [n -S]\n",
  "SEMIBASEMENTS": "SEMIBASEMENT, a basement partly above ground, as in a house built on a slope [n]\n",
  "SEMIBOLD": "a typeface between medium and bold [n -S]\n",
  "SEMIBOLDS": "SEMIBOLD, a typeface between medium and bold [n]\n",
  "SEMIBREVE": "the longest generally used note, having twice length of minim and half that of breve [n -S]\n",
  "SEMIBREVES": "SEMIBREVE, the longest generally used note, having twice length of minim and half that of breve [n]\n",
  "SEMIBULL": "a bull issued by a pope in the period between his election and coronation [n -S]\n",
  "SEMIBULLS": "SEMIBULL, a bull issued by a pope in the period between his election and coronation [n]\n",
  "SEMICARBAZIDE": "a base reacting with aldehydes and ketones to form semicarbazones [n -S]\n",
  "SEMICARBAZIDES": "SEMICARBAZIDE, a base reacting with aldehydes and ketones to form semicarbazones [n]\n",
  "SEMICARBAZONE": "a compound formed by the reaction of a semicarbazide with an aldehyde or ketone [n -S]\n",
  "SEMICARBAZONES": "SEMICARBAZONE, a compound formed by the reaction of a semicarbazide with an aldehyde or ketone [n]\n",
  "SEMICENTENNIAL": "a 50th anniversary or its celebration [n -S]\n",
  "SEMICENTENNIALS": "SEMICENTENNIAL, a 50th anniversary or its celebration [n]\n",
  "SEMICHORUS": "half, or part of, a chorus; a passage sung by it [n -ES]\n",
  "SEMICHORUSES": "SEMICHORUS, half, or part of, a chorus; a passage sung by it [n]\n",
  "SEMICIRCLE": "the half of a circle [n -S]\n",
  "SEMICIRCLED": "enclosed within a semicircle [adj]\n",
  "SEMICIRCLES": "SEMICIRCLE, the half of a circle [n]\n",
  "SEMICIRCULAR": "having the shape of semicircle [adj SEMICIRCULARLY]\n",
  "SEMICIRCULARLY": "SEMICIRCULAR, having the shape of semicircle [adv]\n",
  "SEMICIRQUE": "a semicircular hollow or opening among trees or hills [n -S]\n",
  "SEMICIRQUES": "SEMICIRQUE, a semicircular hollow or opening among trees or hills [n]\n",
  "SEMICIVILISED": "partly civilised, also SEMICIVILIZED [adj]\n",
  "SEMICIVILIZED": "partly civilized, also SEMICIVILISED [adj]\n",
  "SEMICLASSIC": "a semiclassical work [n -S]\n",
  "SEMICLASSICAL": "of, relating to, or being a musical composition that is intermediate in style between classical and popular music [adj]\n",
  "SEMICLASSICS": "SEMICLASSIC, a semiclassical work [n]\n",
  "SEMICOLON": "the punctuation mark (;) indicating a separation between parts or members of a sentence more distinct than that marked by a comma [n -S]\n",
  "SEMICOLONIAL": "nominally independent but actually under foreign domination [adj]\n",
  "SEMICOLONIALISM": "the state of being semicolonial, nominally independent but actually under foreign domination [n]\n",
  "SEMICOLONIES": "SEMICOLONY, a semicolonial state [n]\n",
  "SEMICOLONS": "SEMICOLON, the punctuation mark (;) indicating a separation between parts or members of a sentence more distinct than that marked by a comma [n]\n",
  "SEMICOLONY": "a semicolonial state [n SEMICOLONIES]\n",
  "SEMICOMA": "a coma from which a person can be aroused [n -S]\n",
  "SEMICOMAS": "SEMICOMA, a coma from which a person can be aroused [n]\n",
  "SEMICOMATOSE": "in a state of semicoma [adj]\n",
  "SEMICOMMERCIAL": "of, relating to, adapted to, or characterized by limited marketing of an experimental product [adj]\n",
  "SEMICONDUCTING": "of, relating to, or having the characteristics of a semiconductor [adj]\n",
  "SEMICONDUCTION": "the state of being a semiconductor [n -S]\n",
  "SEMICONDUCTIONS": "SEMICONDUCTION, the state of being a semiconductor [n]\n",
  "SEMICONDUCTOR": "an element or compound having a resistivity between that of a conductor and an insulator [n -S]\n",
  "SEMICONDUCTORS": "SEMICONDUCTOR, an element or compound having a resistivity between that of a conductor and an insulator [n]\n",
  "SEMICONSCIOUS": "incompletely conscious [adj SEMICONSCIOUSLY]\n",
  "SEMICONSCIOUSLY": "SEMICONSCIOUS, incompletely conscious [adv]\n",
  "SEMICONSONANT": "a speech sound having the nature of both a vowel and a consonant [n -S]\n",
  "SEMICONSONANTS": "SEMICONSONANT, a speech sound having the nature of both a vowel and a consonant [n]\n",
  "SEMICRYSTALLIC": "having, or being, a partly crystalline structure, also SEMICRYSTALLINE [adj]\n",
  "SEMICRYSTALLINE": "incompletely or imperfectly crystalline, also SEMICRYSTALLIC [adj]\n",
  "SEMICURED": "partly cured [adj]\n",
  "SEMICYLINDER": "a longitudinal half-cylinder [n -S]\n",
  "SEMICYLINDERS": "SEMICYLINDER, a longitudinal half-cylinder [n]\n",
  "SEMICYLINDRICAL": "having the shape of a longitudinal half of a cylinder [adj]\n",
  "SEMIDARKNESS": "a state between dark and light [n -ES]\n",
  "SEMIDARKNESSES": "SEMIDARKNESS, a state between dark and light [n]\n",
  "SEMIDEAF": "partly deaf [adj]\n",
  "SEMIDEIFIED": "SEMIDEIFY, to make something partially a god [v]\n",
  "SEMIDEIFIES": "SEMIDEIFY, to make something partially a god [v]\n",
  "SEMIDEIFY": "to make something partially a god [v SEMIDEIFIED, SEMIDEIFYING, SEMIDEIFIES]\n",
  "SEMIDEIFYING": "SEMIDEIFY, to make something partially a god [v]\n",
  "SEMIDEPONENT": "passive in form in the perfect only [adj] / a semideponent verb [n -S]\n",
  "SEMIDEPONENTS": "SEMIDEPONENT, a semideponent verb [n]\n",
  "SEMIDESERT": "a half desert [n -S]\n",
  "SEMIDESERTS": "SEMIDESERT, a half desert [n]\n",
  "SEMIDETACHED": "one of a pair of residences joined into one building by a common sidewall [n -S]\n",
  "SEMIDETACHEDS": "SEMIDETACHED, one of a pair of residences joined into one building by a common sidewall [n]\n",
  "SEMIDIAMETER": "half the diameter, esp. the angular diameter [n -S]\n",
  "SEMIDIAMETERS": "SEMIDIAMETER, half the diameter, esp. the angular diameter [n]\n",
  "SEMIDIURNAL": "relating to or accomplished in half a day [adj]\n",
  "SEMIDIVINE": "half divine [adj]\n",
  "SEMIDOCUMENTARY": "a motion picture that uses many details taken from actual events or situations in presenting a fictional story [n]\n",
  "SEMIDOME": "a half dome [n -S]\n",
  "SEMIDOMED": "having a half dome [adj]\n",
  "SEMIDOMES": "SEMIDOME, a half dome [n]\n",
  "SEMIDOMINANT": "producing an intermediate phenotype in the heterozygous condition [adj]\n",
  "SEMIDRIER": "SEMIDRY, half dry [adj]\n",
  "SEMIDRIEST": "SEMIDRY, half dry [adj]\n",
  "SEMIDRY": "half dry [adj SEMIDRIER, SEMIDRIEST]\n",
  "SEMIDRYING": "not drying completely [adj]\n",
  "SEMIDWARF": "a plant that is half dwarf [n SEMIDWARFS or SEMIDWARVES]\n",
  "SEMIDWARFS": "SEMIDWARF, a plant that is half dwarf [n]\n",
  "SEMIDWARVES": "SEMIDWARF, a plant that is half dwarf [n]\n",
  "SEMIE": "at Scottish universities, a second-year student [n -S]\n",
  "SEMIELLIPTICAL": "being in the form of a partial ellipse [adj]\n",
  "SEMIEMPIRICAL": "partly empirical [adj]\n",
  "SEMIERECT": "half erect [adj]\n",
  "SEMIES": "SEMIE, at Scottish universities, a second-year student [n]\n",
  "SEMIEVERGREEN": "having functional and persistent foliage during part of the winter or dry season [adj]\n",
  "SEMIFEUDAL": "half feudal [adj]\n",
  "SEMIFINAL": "the round before the final [n -S]\n",
  "SEMIFINALIST": "one taking part in a semifinal [n -S]\n",
  "SEMIFINALISTS": "SEMIFINALIST, one taking part in a semifinal [n]\n",
  "SEMIFINALS": "SEMIFINAL, the round before the final [n]\n",
  "SEMIFINISHED": "partially finished or processed [adj]\n",
  "SEMIFIT": "conforming somewhat to the lines of the body [adj]\n",
  "SEMIFITTED": "conforming somewhat to the lines of the body [adj]\n",
  "SEMIFLEXIBLE": "somewhat flexible [adj]\n",
  "SEMIFLUID": "something that is imperfectly fluid [n -S]\n",
  "SEMIFLUIDIC": "imperfectly fluid [adj]\n",
  "SEMIFLUIDITIES": "SEMIFLUIDITY, the state of being semifluid [n]\n",
  "SEMIFLUIDITY": "the state of being semifluid [n SEMIFLUIDITIES]\n",
  "SEMIFLUIDS": "SEMIFLUID, something that is imperfectly fluid [n]\n",
  "SEMIFORMAL": "being or suitable for an occasion of moderate formality [adj]\n",
  "SEMIFREDDI": "SEMIFREDDO, (Italian) a partially frozen Italian dessert similar to ice-cream [n]\n",
  "SEMIFREDDO": "(Italian) a partially frozen Italian dessert similar to ice-cream [n SEMIFREDDI or SEMIFREDDOS]\n",
  "SEMIFREDDOS": "SEMIFREDDO, (Italian) a partially frozen Italian dessert similar to ice-cream [n]\n",
  "SEMIGALA": "an event similar to a gala but on a lesser scale [n -S]\n",
  "SEMIGALAS": "SEMIGALA, an event similar to a gala but on a lesser scale [n]\n",
  "SEMIGLOBE": "a half globe, a hemisphere [n -S]\n",
  "SEMIGLOBES": "SEMIGLOBE, a half globe, a hemisphere [n]\n",
  "SEMIGLOBULAR": "being in the form of a half globe [adj]\n",
  "SEMIGLOSS": "a somewhat glossy paint [n -ES]\n",
  "SEMIGLOSSES": "SEMIGLOSS, a somewhat glossy paint [n]\n",
  "SEMIGROUP": "a mathematical group that is closed under an associative binary operation [n -S]\n",
  "SEMIGROUPS": "SEMIGROUP, a mathematical group that is closed under an associative binary operation [n]\n",
  "SEMIHARD": "moderately hard [adj]\n",
  "SEMIHIGH": "moderately high [adj]\n",
  "SEMIHOBO": "a person having some of the characteristics of a hobo [n -ES or -S]\n",
  "SEMIHOBOES": "SEMIHOBO, a person having some of the characteristics of a hobo [n]\n",
  "SEMIHOBOS": "SEMIHOBO, a person having some of the characteristics of a hobo [n]\n",
  "SEMILEGENDARY": "having historical foundation but elaborated in legend [adj]\n",
  "SEMILETHAL": "a mutation that tends to be lethal but is not always [n -S]\n",
  "SEMILETHALS": "SEMILETHAL, a mutation that tends to be lethal but is not always [n]\n",
  "SEMILIQUID": "a half liquid substance [n -S]\n",
  "SEMILIQUIDS": "SEMILIQUID, a half liquid substance [n]\n",
  "SEMILITERATE": "able to read and write on an elementary level [adj] / someone who is semiliterate [n -S]\n",
  "SEMILITERATES": "SEMILITERATE, someone who is semiliterate [n]\n",
  "SEMILLON": "a white grape grown in France [n -S]\n",
  "SEMILLONS": "SEMILLON, a white grape grown in France [n]\n",
  "SEMILOG": "having one scale logarithmic and the other arithmetic [adj]\n",
  "SEMILOGARITHMIC": "having one scale logarithmic and the other arithmetic [adj]\n",
  "SEMILUCENT": "half-transparent [adj]\n",
  "SEMILUNAR": "shaped like a half moon [adj]\n",
  "SEMILUNATE": "shaped like a half-moon [adj]\n",
  "SEMILUNE": "(French) a half-moon fortification, a ravelin, also DEMILUNE [n -S]\n",
  "SEMILUNES": "SEMILUNE, (French) a half-moon fortification, a ravelin, also DEMILUNE [n]\n",
  "SEMILUSTROUS": "slightly lustrous [adj]\n",
  "SEMIMANUFACTURE": "a manufactured product, material, etc., used to make an end-product [n]\n",
  "SEMIMAT": "having a slight lustre, also SEMIMATT, SEMIMATTE [adj]\n",
  "SEMIMATT": "having a slight lustre, also SEMIMAT, SEMIMATTE [adj]\n",
  "SEMIMATTE": "having a slight lustre, also SEMIMAT, SEMIMATT [adj]\n",
  "SEMIMENSTRUAL": "half-monthly [adj]\n",
  "SEMIMETAL": "a metal that is not malleable [n -S]\n",
  "SEMIMETALLIC": "of the nature of a semimetal [adj]\n",
  "SEMIMETALS": "SEMIMETAL, a metal that is not malleable [n]\n",
  "SEMIMICRO": "somewhat micro [adj]\n",
  "SEMIMILD": "partly mild [adj]\n",
  "SEMIMOIST": "slightly moist [adj]\n",
  "SEMIMONASTIC": "having some features characteristic of a monastic order [adj]\n",
  "SEMIMONTHLIES": "SEMIMONTHLY, a periodical appearing twice a month [n]\n",
  "SEMIMONTHLY": "half-monthly [adj] / a periodical appearing twice a month [n SEMIMONTHLIES]\n",
  "SEMIMUTE": "a person who is partially mute [n -S]\n",
  "SEMIMUTES": "SEMIMUTE, a person who is partially mute [n]\n",
  "SEMIMYSTICAL": "having some of the qualities of mysticism [adj]\n",
  "SEMINA": "SEMEN, (Latin) the liquid that carries spermatozoa [n]\n",
  "SEMINAL": "pertaining to semen [adj SEMINALLY]\n",
  "SEMINALITIES": "SEMINALITY, the state of being seminal [n]\n",
  "SEMINALITY": "the state of being seminal [n SEMINALITIES]\n",
  "SEMINALLY": "SEMINAL, pertaining to semen [adv]\n",
  "SEMINAR": "(Latin) an advanced study group [n -S]\n",
  "SEMINARIAL": "of a seminary [adj]\n",
  "SEMINARIAN": "a member of, or one educated in, a seminary; specifically, an ecclesiastic educated for the priesthood in a seminary, also SEMINARIST [n -S]\n",
  "SEMINARIANS": "SEMINARIAN, a member of, or one educated in, a seminary; specifically, an ecclesiastic educated for the priesthood in a seminary, also SEMINARIST [n]\n",
  "SEMINARIES": "SEMINARY, a school for training priests, ministers or rabbis [n]\n",
  "SEMINARIST": "a member of, or one educated in, a seminary; specifically, an ecclesiastic educated for the priesthood in a seminary, also SEMINARIAN [n -S]\n",
  "SEMINARISTS": "SEMINARIST, a member of, or one educated in, a seminary; specifically, an ecclesiastic educated for the priesthood in a seminary, also SEMINARIAN [n]\n",
  "SEMINARS": "SEMINAR, (Latin) an advanced study group [n]\n",
  "SEMINARY": "a school for training priests, ministers or rabbis [n SEMINARIES]\n",
  "SEMINATE": "to sow [v SEMINATED, SEMINATING, SEMINATES]\n",
  "SEMINATED": "SEMINATE, to sow [v]\n",
  "SEMINATES": "SEMINATE, to sow [v]\n",
  "SEMINATING": "SEMINATE, to sow [v]\n",
  "SEMINATION": "the act of sowing or spreading [n -S]\n",
  "SEMINATIONS": "SEMINATION, the act of sowing or spreading [n]\n",
  "SEMINATURAL": "modified by human influence but retaining many natural features [adj]\n",
  "SEMINIFEROUS": "seed-bearing [adj]\n",
  "SEMINOMA": "a malignant tumour of the testicle [n SEMINOMAS or SEMINOMATA]\n",
  "SEMINOMAD": "one leading a partially nomadic existence [n -S]\n",
  "SEMINOMADIC": "leading the life of a seminomad [adj]\n",
  "SEMINOMADS": "SEMINOMAD, one leading a partially nomadic existence [n]\n",
  "SEMINOMAS": "SEMINOMA, a malignant tumour of the testicle [n]\n",
  "SEMINOMATA": "SEMINOMA, a malignant tumour of the testicle [n]\n",
  "SEMINUDE": "partly nude [adj]\n",
  "SEMINUDITIES": "SEMINUDITY, being partially nude [n]\n",
  "SEMINUDITY": "being partially nude [n SEMINUDITIES]\n",
  "SEMIOCHEMICAL": "a chemical produced by an animal, e.g. in a scent gland, and used as a means of signalling its presence, readiness to mate etc. [n -S]\n",
  "SEMIOCHEMICALS": "SEMIOCHEMICAL, a chemical produced by an animal, e.g. in a scent gland, and used as a means of signalling its presence, readiness to mate etc. [n]\n",
  "SEMIOFFICIAL": "having some official authority or standing [adj SEMIOFFICIALLY]\n",
  "SEMIOFFICIALLY": "SEMIOFFICIAL, having some official authority or standing [adv]\n",
  "SEMIOLOGIC": "relating to semiology, the study of signs and signals, also SEMIOLOGICAL [adj]\n",
  "SEMIOLOGICAL": "relating to semiology, the study of signs and signals, also SEMIOLOGIC [adj]\n",
  "SEMIOLOGICALLY": "SEMIOLOGICAL, relating to semiology, the study of signs and signals, also SEMIOLOGIC [adv]\n",
  "SEMIOLOGIES": "SEMIOLOGY, the study of signs and signals, also SEMEIOLOGY [n]\n",
  "SEMIOLOGIST": "a student of semiology, the study of signs and signals [n -S]\n",
  "SEMIOLOGISTS": "SEMIOLOGIST, a student of semiology, the study of signs and signals [n]\n",
  "SEMIOLOGY": "the study of signs and signals, also SEMEIOLOGY [n SEMIOLOGIES]\n",
  "SEMIOPAQUE": "half opaque [adj]\n",
  "SEMIOPEN": "partly open [adj]\n",
  "SEMIOSES": "SEMIOSIS, (Greek) a process in which something functions at organism [n]\n",
  "SEMIOSIS": "(Greek) a process in which something functions at organism [n SEMIOSES]\n",
  "SEMIOTIC": "relating to signs or symbols, esp. spoken or written signs, also SEMEIOTIC [adj SEMIOTICALLY]\n",
  "SEMIOTICALLY": "SEMIOTIC, relating to signs or symbols, esp. spoken or written signs, also SEMEIOTIC [adv]\n",
  "SEMIOTICIAN": "a practitioner of semiotics, a philosophical theory of signs and symbols, also SEMEIOTICIAN, SEMIOTICIST [n -S]\n",
  "SEMIOTICIANS": "SEMIOTICIAN, a practitioner of semiotics, a philosophical theory of signs and symbols, also SEMEIOTICIAN, SEMIOTICIST [n]\n",
  "SEMIOTICIST": "a practitioner of semiotics, a philosophical theory of signs and symbols, also SEMEIOTICIAN, SEMIOTICIAN [n -S]\n",
  "SEMIOTICISTS": "SEMIOTICIST, a practitioner of semiotics, a philosophical theory of signs and symbols, also SEMEIOTICIAN, SEMIOTICIAN [n]\n",
  "SEMIOTICS": "a philosophical theory of signs and symbols [n]\n",
  "SEMIOVAL": "in the shape of half an oval [adj]\n",
  "SEMIOVIPAROUS": "bringing forth young in an incomplete developmental state [adj]\n",
  "SEMIPALMATE": "partly webfooted, also SEMIPALMATED [adj]\n",
  "SEMIPALMATED": "having the toes joined only part way down with a web, also SEMIPALMATE [adj]\n",
  "SEMIPALMATION": "the state of being semipalmate, partly webfooted [n -S]\n",
  "SEMIPALMATIONS": "SEMIPALMATION, the state of being semipalmate, partly webfooted [n]\n",
  "SEMIPARASITE": "a partial parasite, feeding partly independently [n -S]\n",
  "SEMIPARASITES": "SEMIPARASITE, a partial parasite, feeding partly independently [n]\n",
  "SEMIPARASITIC": "of, relating to, or being a parasitic plant that contains some chlorophyll and is capable of photosynthesis [adj]\n",
  "SEMIPARASITISM": "the state of being semiparasitic [n -S]\n",
  "SEMIPARASITISMS": "SEMIPARASITISM, the state of being semiparasitic [n]\n",
  "SEMIPED": "a half foot [n -S]\n",
  "SEMIPEDS": "SEMIPED, a half foot [n]\n",
  "SEMIPELLUCID": "partially pellucid [adj]\n",
  "SEMIPERIMETER": "half the perimeter [n -S]\n",
  "SEMIPERIMETERS": "SEMIPERIMETER, half the perimeter [n]\n",
  "SEMIPERMANENT": "lasting or intended to last for a long time but not permanent [adj]\n",
  "SEMIPERMEABLE": "partially but not freely or wholly permeable [adj]\n",
  "SEMIPIOUS": "quite pious [adj]\n",
  "SEMIPLUME": "a feather with an ordinary shaft but a downy web [n -S]\n",
  "SEMIPLUMES": "SEMIPLUME, a feather with an ordinary shaft but a downy web [n]\n",
  "SEMIPOLAR": "as in semipolar bond, a type of chemical bond [adj]\n",
  "SEMIPOLITICAL": "of, relating to, or involving some political features or activity [adj]\n",
  "SEMIPOPULAR": "somewhat popular [adj]\n",
  "SEMIPORCELAIN": "any of several ceramic wares resembling or imitative of porcelain [n -S]\n",
  "SEMIPORCELAINS": "SEMIPORCELAIN, any of several ceramic wares resembling or imitative of porcelain [n]\n",
  "SEMIPORNOGRAPHY": "material approaching the pornographic [n]\n",
  "SEMIPOSTAL": "an issue of postage stamps the proceeds of which are donated to charity [n -S]\n",
  "SEMIPOSTALS": "SEMIPOSTAL, an issue of postage stamps the proceeds of which are donated to charity [n]\n",
  "SEMIPRECIOUS": "of less commercial value than a precious stone [adj]\n",
  "SEMIPRIVATE": "partly private [adj]\n",
  "SEMIPRO": "one who is engaged in paid sport part-time [n -S]\n",
  "SEMIPROS": "SEMIPRO, one who is engaged in paid sport part-time [n]\n",
  "SEMIPUBLIC": "partly public [adj]\n",
  "SEMIQUAVER": "a 1/16 note in music [n -S]\n",
  "SEMIQUAVERS": "SEMIQUAVER, a 1/16 note in music [n]\n",
  "SEMIRAW": "somewhat raw [adj]\n",
  "SEMIREFINED": "partly refined [adj]\n",
  "SEMIRELIGIOUS": "somewhat religious [adj]\n",
  "SEMIRETIRED": "working only part-time, especially because of age or ill health [adj]\n",
  "SEMIRETIREMENT": "the state of being semiretired [n -S]\n",
  "SEMIRETIREMENTS": "SEMIRETIREMENT, the state of being semiretired [n]\n",
  "SEMIRIGID": "partly rigid [adj]\n",
  "SEMIROUND": "something half round [n -S]\n",
  "SEMIROUNDS": "SEMIROUND, something half round [n]\n",
  "SEMIRURAL": "partly rural [adj]\n",
  "SEMIS": "(Latin) a coin of ancient Rome [n -ES]\n",
  "SEMISACRED": "partly sacred [adj]\n",
  "SEMISECRET": "partly secret [adj]\n",
  "SEMISEDENTARY": "sedentary during part of the year and nomadic otherwise [adj]\n",
  "SEMISES": "SEMIS, (Latin) a coin of ancient Rome [n]\n",
  "SEMISHRUBBY": "partly like a shrub [adj]\n",
  "SEMISKILLED": "having or requiring less training than skilled labor and more than unskilled labor [adj]\n",
  "SEMISOFT": "moderately soft [adj]\n",
  "SEMISOLID": "partly solid [adj] / something partly solid [n -S]\n",
  "SEMISOLIDS": "SEMISOLID, something partly solid [n]\n",
  "SEMISOLUS": "an advertisement on the same page as another advertisement but not adjacent to it [n -ES]\n",
  "SEMISOLUSES": "SEMISOLUS, an advertisement on the same page as another advertisement but not adjacent to it [n]\n",
  "SEMISTIFF": "somewhat stiff [adj]\n",
  "SEMISUBMERSIBLE": "a floating deepwater drilling platform that is towed to a desired location and then partially flooded for stabilization and usually anchored [n]\n",
  "SEMISWEET": "somewhat sweet [adj]\n",
  "SEMISYNTHETIC": "produced by chemical alteration of a natural starting material [adj]\n",
  "SEMITAR": "(obsolete) a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n -S]\n",
  "SEMITARS": "SEMITAR, (obsolete) a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAUR, SIMITAR, SYMITAR, SYMITARE [n]\n",
  "SEMITAUR": "(obsolete) a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SIMITAR, SYMITAR, SYMITARE [n -S]\n",
  "SEMITAURS": "SEMITAUR, (obsolete) a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SIMITAR, SYMITAR, SYMITARE [n]\n",
  "SEMITERETE": "half-cylindrical [adj]\n",
  "SEMITERRESTRIAL": "growing on boggy ground [adj]\n",
  "SEMITIST": "a Semitic scholar [n -S]\n",
  "SEMITISTS": "SEMITIST, a Semitic scholar [n]\n",
  "SEMITONAL": "of or pertaining to a semitone, also SEMITONIC [adj SEMITONALLY]\n",
  "SEMITONALLY": "SEMITONAL, of or pertaining to a semitone, also SEMITONIC [adv]\n",
  "SEMITONE": "half a tone, one of the lesser intervals of the musical scale, as from B to C [n -S]\n",
  "SEMITONES": "SEMITONE, half a tone, one of the lesser intervals of the musical scale, as from B to C [n]\n",
  "SEMITONIC": "of or pertaining to a semitone, also SEMITONAL [adj SEMITONICALLY]\n",
  "SEMITONICALLY": "SEMITONIC, of or pertaining to a semitone, also SEMITONAL [adv]\n",
  "SEMITRAILER": "an articulated trailer or lorry [n -S]\n",
  "SEMITRAILERS": "SEMITRAILER, an articulated trailer or lorry [n]\n",
  "SEMITRANSLUCENT": "somewhat translucent [adj]\n",
  "SEMITRANSPARENT": "imperfectly transparent [adj]\n",
  "SEMITROPIC": "a somewhat tropical region [n -S]\n",
  "SEMITROPICAL": "subtropical [adj]\n",
  "SEMITROPICS": "SEMITROPIC, a somewhat tropical region [n]\n",
  "SEMITRUCK": "an articulated lorry [n -S]\n",
  "SEMITRUCKS": "SEMITRUCK, an articulated lorry [n]\n",
  "SEMIURBAN": "somewhat urban [adj]\n",
  "SEMIVITREOUS": "partially vitreous [adj]\n",
  "SEMIVOCAL": "of or relating to a semivowel, also SEMIVOCALIC [adj]\n",
  "SEMIVOCALIC": "of or relating to a semivowel, also SEMIVOCAL [adj]\n",
  "SEMIVOWEL": "a speech sound having the nature of both a vowel and a consonant [n -S]\n",
  "SEMIVOWELS": "SEMIVOWEL, a speech sound having the nature of both a vowel and a consonant [n]\n",
  "SEMIWATER": "as in semiwater gas, a mixed gas obtained by steam and air over incandescent coke, or other source of carbon [adj]\n",
  "SEMIWEEKLIES": "SEMIWEEKLY, a periodical issued twice a week [n]\n",
  "SEMIWEEKLY": "happening or issued twice a week [adj] / a periodical issued twice a week [n SEMIWEEKLIES]\n",
  "SEMIWILD": "somewhat wild [adj]\n",
  "SEMIWORKS": "a manufacturing plant operating on a limited commercial scale to provide final tests of a new product or process [n]\n",
  "SEMIYEARLY": "happening twice a year [adj]\n",
  "SEMMIT": "(Scots) a vest or undershirt [n -S]\n",
  "SEMMITS": "SEMMIT, (Scots) a vest or undershirt [n]\n",
  "SEMOLINA": "(Italian) a granular product of wheat [n -S]\n",
  "SEMOLINAS": "SEMOLINA, (Italian) a granular product of wheat [n]\n",
  "SEMPER": "(Latin) always [adj]\n",
  "SEMPERVIVUM": "a plant, the houseleek [n -S]\n",
  "SEMPERVIVUMS": "SEMPERVIVUM, a plant, the houseleek [n]\n",
  "SEMPITERNAL": "of never-ending duration, eternal [adj SEMPITERNALLY]\n",
  "SEMPITERNALLY": "SEMPITERNAL, of never-ending duration, eternal [adv]\n",
  "SEMPITERNITIES": "SEMPITERNITY, eternity [n]\n",
  "SEMPITERNITY": "eternity [n SEMPITERNITIES]\n",
  "SEMPITERNUM": "(obsolete) a durable woollen cloth [n -S]\n",
  "SEMPITERNUMS": "SEMPITERNUM, (obsolete) a durable woollen cloth [n]\n",
  "SEMPLE": "(Scots) of humble birth [adj SEMPLER, SEMPLEST]\n",
  "SEMPLER": "SEMPLE, (Scots) of humble birth [adj]\n",
  "SEMPLEST": "SEMPLE, (Scots) of humble birth [adj]\n",
  "SEMPLICE": "(Italian) as a musical direction, simply, plainly [adv]\n",
  "SEMPRE": "(Italian) in the same manner throughout (a musical direction) [adv]\n",
  "SEMPSTER": "a person who sews [n -S]\n",
  "SEMPSTERING": "working as a sempster [n -S]\n",
  "SEMPSTERINGS": "SEMPSTERING, working as a sempster [n]\n",
  "SEMPSTERS": "SEMPSTER, a person who sews [n]\n",
  "SEMPSTRESS": "a seamstress [n -ES]\n",
  "SEMPSTRESSES": "SEMPSTRESS, a seamstress [n]\n",
  "SEMPSTRESSING": "working as a sempstress [n -S]\n",
  "SEMPSTRESSINGS": "SEMPSTRESSING, working as a sempstress [n]\n",
  "SEMSEM": "(Arabic) an East Indian plant, also SESAME, TEEL [n -S]\n",
  "SEMSEMS": "SEMSEM, (Arabic) an East Indian plant, also SESAME, TEEL [n]\n",
  "SEMUNCIA": "(Latin) a Roman coin equivalent to one twenty-fourth part of a Roman pound [n SEMUNCIAE or SEMUNCIAS]\n",
  "SEMUNCIAE": "SEMUNCIA, (Latin) a Roman coin equivalent to one twenty-fourth part of a Roman pound [n]\n",
  "SEMUNCIAL": "relating to a semuncia, a Roman coin equivalent to one twenty-fourth part of a Roman pound [adj]\n",
  "SEMUNCIAS": "SEMUNCIA, (Latin) a Roman coin equivalent to one twenty-fourth part of a Roman pound [n]\n",
  "SEN": "(Japanese) a monetary unit of Japan [n SEN]\n",
  "SENA": "(Hindi) in India, an army, esp. used of paramilitary organisations representing various castes [n -S]\n",
  "SENARIES": "SENARY, a set of six [n]\n",
  "SENARII": "SENARIUS, (Latin) a Greek or Latin verse consisting of six metrical feet [n]\n",
  "SENARIUS": "(Latin) a Greek or Latin verse consisting of six metrical feet [n SENARII]\n",
  "SENARMONTITE": "antimony trioxide in cubic crystalline form [n -S]\n",
  "SENARMONTITES": "SENARMONTITE, antimony trioxide in cubic crystalline form [n]\n",
  "SENARY": "a set of six [n SENARIES]\n",
  "SENAS": "SENA, (Hindi) in India, an army, esp. used of paramilitary organisations representing various castes [n]\n",
  "SENATE": "a governing body [n -S]\n",
  "SENATES": "SENATE, a governing body [n]\n",
  "SENATOR": "(Latin) a member of a senate [n -S]\n",
  "SENATORIAL": "of or pertaining to a senator, also SENATORIAN [adj SENATORIALLY]\n",
  "SENATORIALLY": "SENATORIAL, of or pertaining to a senator, also SENATORIAN [adv]\n",
  "SENATORIAN": "of or pertaining to a senator, also SENATORIAL [adj]\n",
  "SENATORS": "SENATOR, (Latin) a member of a senate [n]\n",
  "SENATORSHIP": "the office of senator [n -S]\n",
  "SENATORSHIPS": "SENATORSHIP, the office of senator [n]\n",
  "SEND": "to cause to go [v SENT, SENDING, SENDS] / to pitch into a trough of sea, also SCEND [v SENDED, SENDING, SENDS]\n",
  "SENDABLE": "able to be sent [adj]\n",
  "SENDAL": "a silk fabric [n -S]\n",
  "SENDALS": "SENDAL, a silk fabric [n]\n",
  "SENDED": "SEND, to cause to go [v]\n",
  "SENDER": "one that sends [n -S]\n",
  "SENDERS": "SENDER, one that sends [n]\n",
  "SENDING": "an act of despatch or transmission [n -S]\n",
  "SENDINGS": "SENDING, an act of despatch or transmission [n]\n",
  "SENDOFF": "a farewell celebration [n -S]\n",
  "SENDOFFS": "SENDOFF, a farewell celebration [n]\n",
  "SENDS": "SEND, to cause to go [v]\n",
  "SENDUP": "a parody [n -S]\n",
  "SENDUPS": "SENDUP, a parody [n]\n",
  "SENE": "(Samoan) a Samoan monetary unit [n -S]\n",
  "SENECA": "a North American milkwort, or its root, used medicinally, also SENEGA [n -S]\n",
  "SENECAS": "SENECA, a North American milkwort, or its root, used medicinally, also SENEGA [n]\n",
  "SENECIO": "(Latin) any plant of the genus Senecio, that includes groundsels and ragworts [n -S]\n",
  "SENECIOS": "SENECIO, (Latin) any plant of the genus Senecio, that includes groundsels and ragworts [n]\n",
  "SENECTITUDE": "old age [n -S]\n",
  "SENECTITUDES": "SENECTITUDE, old age [n]\n",
  "SENEGA": "a North American milkwort, or its root, used medicinally, also SENECA [n -S]\n",
  "SENEGAS": "SENEGA, a North American milkwort, or its root, used medicinally, also SENECA [n]\n",
  "SENES": "SENE, (Samoan) a Samoan monetary unit [n]\n",
  "SENESCE": "to become old [v SENESCED, SENESCING, SENESCES]\n",
  "SENESCED": "SENESCE, to become old [v]\n",
  "SENESCENCE": "the state of growing old; decay by time [n -S]\n",
  "SENESCENCES": "SENESCENCE, the state of growing old; decay by time [n]\n",
  "SENESCENT": "growing old [adj]\n",
  "SENESCES": "SENESCE, to become old [v]\n",
  "SENESCHAL": "(historical) an agent or steward in charge of a lord's estate in feudal times [n -S]\n",
  "SENESCHALS": "SENESCHAL, (historical) an agent or steward in charge of a lord's estate in feudal times [n]\n",
  "SENESCHALSHIP": "the office of seneschal [n -S]\n",
  "SENESCHALSHIPS": "SENESCHALSHIP, the office of seneschal [n]\n",
  "SENESCING": "SENESCE, to become old [v]\n",
  "SENGI": "a monetary unit of Zaire [n -S]\n",
  "SENGIS": "SENGI, a monetary unit of Zaire [n]\n",
  "SENGREEN": "houseleek, a plant which often grows on roofs [n -S]\n",
  "SENGREENS": "SENGREEN, houseleek, a plant which often grows on roofs [n]\n",
  "SENHOR": "(Spanish) a Portuguese or Brazilian gentleman [n SENHORS or SENHORES]\n",
  "SENHORA": "(Spanish) a married Portuguese or Brazilian woman [n -S]\n",
  "SENHORAS": "SENHORA, (Spanish) a married Portuguese or Brazilian woman [n]\n",
  "SENHORES": "SENHOR, (Spanish) a Portuguese or Brazilian gentleman [n]\n",
  "SENHORITA": "(Spanish) a mode of address for an unmarried woman, also SENORITA [n -S]\n",
  "SENHORITAS": "SENHORITA, (Spanish) a mode of address for an unmarried woman, also SENORITA [n]\n",
  "SENHORS": "SENHOR, (Spanish) a Portuguese or Brazilian gentleman [n]\n",
  "SENILE": "deteriorated with age [adj SENILELY] / one who exhibits senility [n -S]\n",
  "SENILELY": "SENILE, deteriorated with age [adv]\n",
  "SENILES": "SENILE, one who exhibits senility [n]\n",
  "SENILITIES": "SENILITY, mental and physical infirmity due to old age [n]\n",
  "SENILITY": "mental and physical infirmity due to old age [n SENILITIES]\n",
  "SENIOR": "a person who is older than another [n -S]\n",
  "SENIORITIES": "SENIORITY, the state of being senior [n]\n",
  "SENIORITY": "the state of being senior [n SENIORITIES]\n",
  "SENIORS": "SENIOR, a person who is older than another [n]\n",
  "SENITI": "(Tongan) a monetary unit of Tonga [n -S]\n",
  "SENITIS": "SENITI, (Tongan) a monetary unit of Tonga [n]\n",
  "SENNA": "(Arabic) the leaves of several leguminous plants of the genus Cassia, used as a cathartic medicine [n -S]\n",
  "SENNACHIE": "(Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHIE, SEANNACHY, SHANACHIE [n -S]\n",
  "SENNACHIES": "SENNACHIE, (Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHIE, SEANNACHY, SHANACHIE [n]\n",
  "SENNAS": "SENNA, (Arabic) the leaves of several leguminous plants of the genus Cassia, used as a cathartic medicine [n]\n",
  "SENNET": "(Shakespeare) a trumpet call used for formal stage entrance or exit [n -S]\n",
  "SENNETS": "SENNET, (Shakespeare) a trumpet call used for formal stage entrance or exit [n]\n",
  "SENNIGHT": "(archaic) the space of seven nights and days, a week [n -S]\n",
  "SENNIGHTS": "SENNIGHT, (archaic) the space of seven nights and days, a week [n]\n",
  "SENNIT": "plaited straw or rope, also SINNET [n -S]\n",
  "SENNITS": "SENNIT, plaited straw or rope, also SINNET [n]\n",
  "SENOPIA": "improvement of near vision occurring during the aging process [n -S]\n",
  "SENOPIAS": "SENOPIA, improvement of near vision occurring during the aging process [n]\n",
  "SENOR": "(Spanish) a Spanish gentleman [n SENORS or SENORES]\n",
  "SENORA": "(Spanish) a married Spanish woman [n -S]\n",
  "SENORAS": "SENORA, (Spanish) a married Spanish woman [n]\n",
  "SENORES": "SENOR, (Spanish) a Spanish gentleman [n]\n",
  "SENORITA": "(Spanish) a mode of address for an unmarried woman, also SENHORITA [n -S]\n",
  "SENORITAS": "SENORITA, (Spanish) a mode of address for an unmarried woman, also SENHORITA [n]\n",
  "SENORS": "SENOR, (Spanish) a Spanish gentleman [n]\n",
  "SENRYU": "(Japanese) a 3-line Japanese poem [n SENRYU]\n",
  "SENS": "(obsolete) since, also SITH, SITHEN, SITHENCE, SITHENS [adv]\n",
  "SENSA": "SENSUM, (Latin) an object of sensation [n]\n",
  "SENSATE": "felt through the senses [adj SENSATELY] / to apprehend through the senses [v SENSATED, SENSATING, SENSATES]\n",
  "SENSATED": "SENSATE, to apprehend through the senses [v]\n",
  "SENSATELY": "SENSATE, felt through the senses [adv]\n",
  "SENSATES": "SENSATE, to apprehend through the senses [v]\n",
  "SENSATING": "SENSATE, to apprehend through the senses [v]\n",
  "SENSATION": "consciousness of a physical experience [n -S]\n",
  "SENSATIONAL": "of or relating to sensation or the senses [adj SENSATIONALLY]\n",
  "SENSATIONALISE": "to make (an event, situation, etc.) appear more exciting or shocking than it really is, also SENSATIONALIZE [v SENSATIONALISED, SENSATIONALISES]\n",
  "SENSATIONALISED": "SENSATIONALISE, to make (an event, situation, etc.) appear more exciting or shocking than it really is, also SENSATIONALIZE [v]\n",
  "SENSATIONALISES": "SENSATIONALISE, to make (an event, situation, etc.) appear more exciting or shocking than it really is, also SENSATIONALIZE [v]\n",
  "SENSATIONALISM": "the belief that ideas originate solely in sensation [n -S]\n",
  "SENSATIONALISMS": "SENSATIONALISM, the belief that ideas originate solely in sensation [n]\n",
  "SENSATIONALIST": "one who engages in sensationalism [n -S]\n",
  "SENSATIONALISTS": "SENSATIONALIST, one who engages in sensationalism [n]\n",
  "SENSATIONALIZE": "to present in a sensational manner, also SENSATIONALISE [v SENSATIONALIZED, SENSATIONALIZES]\n",
  "SENSATIONALIZED": "SENSATIONALIZE, to present in a sensational manner, also SENSATIONALISE [v]\n",
  "SENSATIONALIZES": "SENSATIONALIZE, to present in a sensational manner, also SENSATIONALISE [v]\n",
  "SENSATIONALLY": "SENSATIONAL, of or relating to sensation or the senses [adv]\n",
  "SENSATIONISM": "exploitation of the sensational [n -S]\n",
  "SENSATIONISMS": "SENSATIONISM, exploitation of the sensational [n]\n",
  "SENSATIONIST": "an exploiter of the sensational [n -S]\n",
  "SENSATIONISTS": "SENSATIONIST, an exploiter of the sensational [n]\n",
  "SENSATIONLESS": "without sensation [adj]\n",
  "SENSATIONS": "SENSATION, consciousness of a physical experience [n]\n",
  "SENSE": "to have an impression or inward feeling [v SENSED, SENSING, SENSES]\n",
  "SENSED": "SENSE, to have an impression or inward feeling [v]\n",
  "SENSEFUL": "full of sense; reasonable [adj]\n",
  "SENSEI": "(Japanese) a teacher, also SENSI [n -S]\n",
  "SENSEIS": "SENSEI, (Japanese) a teacher, also SENSI [n]\n",
  "SENSELESS": "without sense [adj SENSELESSLY]\n",
  "SENSELESSLY": "SENSELESS, without sense [adv]\n",
  "SENSELESSNESS": "the state of being senseless [n -ES]\n",
  "SENSELESSNESSES": "SENSELESSNESS, the state of being senseless [n]\n",
  "SENSES": "SENSE, to have an impression or inward feeling [v]\n",
  "SENSI": "(Japanese) a teacher, also SENSEI [n -S]\n",
  "SENSIBILIA": "(Latin) whatever may be perceived by the senses [n]\n",
  "SENSIBILITIES": "SENSIBILITY, the ability to receive sensations [n]\n",
  "SENSIBILITY": "the ability to receive sensations [n SENSIBILITIES]\n",
  "SENSIBLE": "something that can be sensed [n -S] / showing good judgement [adj SENSIBLER, SENSIBLEST]\n",
  "SENSIBLENESS": "the state of being sensible [n -ES]\n",
  "SENSIBLENESSES": "SENSIBLENESS, the state of being sensible [n]\n",
  "SENSIBLER": "SENSIBLE, showing good judgement [adj]\n",
  "SENSIBLES": "SENSIBLE, something that can be sensed [n]\n",
  "SENSIBLEST": "SENSIBLE, showing good judgement [adj]\n",
  "SENSIBLY": "SENSIBLE, showing good judgement [adv]\n",
  "SENSILE": "responsive to stimulus [adj]\n",
  "SENSILLA": "(Latin) in insects, a small sense organ on the integument, also SENSILLUM [n SENSILLAE]\n",
  "SENSILLAE": "SENSILLA, (Latin) in insects, a small sense organ on the integument, also SENSILLUM [n]\n",
  "SENSILLUM": "(Latin) in insects, a small sense organ on the integument, also SENSILLA [n SENSILLA]\n",
  "SENSING": "the act of sensing [n -S]\n",
  "SENSINGS": "SENSING, the act of sensing [n]\n",
  "SENSIS": "SENSI, (Japanese) a teacher, also SENSEI [n]\n",
  "SENSISM": "the doctrine that our ideas originate solely in sensation [n -S]\n",
  "SENSISMS": "SENSISM, the doctrine that our ideas originate solely in sensation [n]\n",
  "SENSIST": "one who indulges in sensationalism [n -S]\n",
  "SENSISTS": "SENSIST, one who indulges in sensationalism [n]\n",
  "SENSITISATION": "the act of sensitising, also SENSITIZATION [n -S]\n",
  "SENSITISATIONS": "SENSITISATION, the act of sensitising, also SENSITIZATION [n]\n",
  "SENSITISE": "to make sensitive, also SENSITIZE [v SENSITISED, SENSITISING, SENSITISES]\n",
  "SENSITISED": "SENSITISE, to make sensitive, also SENSITIZE [v]\n",
  "SENSITISER": "something that sensitises, also SENSITIZER [n -S]\n",
  "SENSITISERS": "SENSITISER, something that sensitises, also SENSITIZER [n]\n",
  "SENSITISES": "SENSITISE, to make sensitive, also SENSITIZE [v]\n",
  "SENSITISING": "SENSITISE, to make sensitive, also SENSITIZE [v]\n",
  "SENSITIVE": "having the power of sensation [adj SENSITIVELY] / one who is sensitive [n -S]\n",
  "SENSITIVELY": "SENSITIVE, having the power of sensation [adv]\n",
  "SENSITIVENESS": "the state of being sensitive [n -ES]\n",
  "SENSITIVENESSES": "SENSITIVENESS, the state of being sensitive [n]\n",
  "SENSITIVES": "SENSITIVE, one who is sensitive [n]\n",
  "SENSITIVITIES": "SENSITIVITY, the state of being sensitive [n]\n",
  "SENSITIVITY": "the state of being sensitive [n SENSITIVITIES]\n",
  "SENSITIZATION": "the act of sensitizing, also SENSITISATION [n -S]\n",
  "SENSITIZATIONS": "SENSITIZATION, the act of sensitizing, also SENSITISATION [n]\n",
  "SENSITIZE": "to make sensitive, also SENSITISE [v SENSITIZED, SENSITIZING, SENSITIZES]\n",
  "SENSITIZED": "SENSITIZE, to make sensitive, also SENSITISE [v]\n",
  "SENSITIZER": "something that sensitizes, also SENSITISER [n -S]\n",
  "SENSITIZERS": "SENSITIZER, something that sensitizes, also SENSITISER [n]\n",
  "SENSITIZES": "SENSITIZE, to make sensitive, also SENSITISE [v]\n",
  "SENSITIZING": "SENSITIZE, to make sensitive, also SENSITISE [v]\n",
  "SENSITOMETER": "an instrument for measuring the sensitivity of photographic material [n -S]\n",
  "SENSITOMETERS": "SENSITOMETER, an instrument for measuring the sensitivity of photographic material [n]\n",
  "SENSITOMETRIC": "relating to measurement by sensitometer [adj]\n",
  "SENSITOMETRIES": "SENSITOMETRY, measurement by sensitometer, an instrument for measuring the sensitivity of photographic material [n]\n",
  "SENSITOMETRY": "measurement by sensitometer, an instrument for measuring the sensitivity of photographic material [n SENSITOMETRIES]\n",
  "SENSOMOTOR": "of or relating to both the sensory and motor functions of an organism or to the nerves controlling them [adj]\n",
  "SENSOR": "a device that responds to a stimulus [n -S]\n",
  "SENSORIA": "SENSORIUM, the area of the brain that is the seat of sensation [n]\n",
  "SENSORIAL": "related to the sensorium [adj SENSORIALLY]\n",
  "SENSORIALLY": "SENSORIAL, related to the sensorium [adv]\n",
  "SENSORILY": "SENSORY, pertaining to the senses or sensation [adv]\n",
  "SENSORIMOTOR": "of, relating to, or functioning in both sensory and motor aspects of bodily activity [adj]\n",
  "SENSORINEURAL": "pertaining to the neural aspects of sensory perception [adj]\n",
  "SENSORIUM": "the area of the brain that is the seat of sensation [n SENSORIUMS or SENSORIA]\n",
  "SENSORIUMS": "SENSORIUM, the area of the brain that is the seat of sensation [n]\n",
  "SENSORS": "SENSOR, a device that responds to a stimulus [n]\n",
  "SENSORY": "pertaining to the senses or sensation [adj SENSORILY]\n",
  "SENSUAL": "pertaining to the physical senses [adj]\n",
  "SENSUALISATION": "the process of sensualising [n -S]\n",
  "SENSUALISATIONS": "SENSUALISATION, the process of sensualising [n]\n",
  "SENSUALISE": "to make sensual, also SENSUALIZE [v SENSUALISED, SENSUALISING, SENSUALISES]\n",
  "SENSUALISED": "SENSUALISE, to make sensual, also SENSUALIZE [v]\n",
  "SENSUALISES": "SENSUALISE, to make sensual, also SENSUALIZE [v]\n",
  "SENSUALISING": "SENSUALISE, to make sensual, also SENSUALIZE [v]\n",
  "SENSUALISM": "the condition or character of one who is sensual [n -S]\n",
  "SENSUALISMS": "SENSUALISM, the condition or character of one who is sensual [n]\n",
  "SENSUALIST": "one who is sensual; one given to the indulgence of the appetites or senses as the means of happiness [n -S]\n",
  "SENSUALISTIC": "relating to sensualism [adj]\n",
  "SENSUALISTS": "SENSUALIST, one who is sensual; one given to the indulgence of the appetites or senses as the means of happiness [n]\n",
  "SENSUALITIES": "SENSUALITY, the state of being sensual [n]\n",
  "SENSUALITY": "the state of being sensual [n SENSUALITIES]\n",
  "SENSUALIZATION": "the act of sensualizing [n -S]\n",
  "SENSUALIZATIONS": "SENSUALIZATION, the act of sensualizing [n]\n",
  "SENSUALIZE": "to make sensual, also SENSUALISE [v SENSUALIZED, SENSUALIZING, SENSUALIZES]\n",
  "SENSUALIZED": "SENSUALIZE, to make sensual, also SENSUALISE [v]\n",
  "SENSUALIZES": "SENSUALIZE, to make sensual, also SENSUALISE [v]\n",
  "SENSUALIZING": "SENSUALIZE, to make sensual, also SENSUALISE [v]\n",
  "SENSUALLY": "SENSUAL, pertaining to the physical senses [adv]\n",
  "SENSUALNESS": "the state of being sensual [n -ES]\n",
  "SENSUALNESSES": "SENSUALNESS, the state of being sensual [n]\n",
  "SENSUM": "(Latin) an object of sensation [n SENSA]\n",
  "SENSUOSITIES": "SENSUOSITY, the state of being sensuous [n]\n",
  "SENSUOSITY": "the state of being sensuous [n SENSUOSITIES]\n",
  "SENSUOUS": "pertaining to or derived from the senses [adj SENSUOUSLY]\n",
  "SENSUOUSLY": "SENSUOUS, pertaining to or derived from the senses [adv]\n",
  "SENSUOUSNESS": "the state of being sensuous [n -ES]\n",
  "SENSUOUSNESSES": "SENSUOUSNESS, the state of being sensuous [n]\n",
  "SENT": "(obsolete) to scent [v -ED, -ING, -S]\n",
  "SENTE": "a monetary unit of Lesotho [n LICENTE or LISENTE]\n",
  "SENTED": "SENT, (obsolete) to scent [v]\n",
  "SENTENCE": "to declare judicially the punishment [v SENTENCED, SENTENCING, SENTENCES]\n",
  "SENTENCED": "SENTENCE, to declare judicially the punishment [v]\n",
  "SENTENCER": "one who sentences [n -S]\n",
  "SENTENCERS": "SENTENCER, one who sentences [n]\n",
  "SENTENCES": "SENTENCE, to declare judicially the punishment [v]\n",
  "SENTENCING": "the act of declaring judicially the extent of punishment to be imposed [n -S]\n",
  "SENTENCINGS": "SENTENCING, the act of declaring judicially the extent of punishment to be imposed [n]\n",
  "SENTENTIA": "(Latin) an aphorism; an opinion [n SENTENTIAE]\n",
  "SENTENTIAE": "SENTENTIA, (Latin) an aphorism; an opinion [n]\n",
  "SENTENTIAL": "comprising sentences; as, a sentential translation [adj SENTENTIALLY]\n",
  "SENTENTIALLY": "SENTENTIAL, comprising sentences; as, a sentential translation [adv]\n",
  "SENTENTIOUS": "given to or abounding in aphoristic expression or excessive moralizing [adj SENTENTIOUSLY]\n",
  "SENTENTIOUSLY": "SENTENTIOUS, given to or abounding in aphoristic expression or excessive moralizing [adv]\n",
  "SENTENTIOUSNESS": "the state of being sententious [n]\n",
  "SENTI": "a former monetary unit of Tanzania [n SENTI]\n",
  "SENTIENCE": "the state of being sentient, also SENTIENCY [n -S]\n",
  "SENTIENCES": "SENTIENCE, the state of being sentient, also SENTIENCY [n]\n",
  "SENTIENCIES": "SENTIENCY, the state of being sentient, also SENTIENCE [n]\n",
  "SENTIENCY": "the state of being sentient, also SENTIENCE [n SENTIENCIES]\n",
  "SENTIENT": "capable of sensation [adj SENTIENTLY] / a person or thing capable of sensation [n -S]\n",
  "SENTIENTLY": "SENTIENT, capable of sensation [adv]\n",
  "SENTIENTS": "SENTIENT, a person or thing capable of sensation [n]\n",
  "SENTIMENT": "a thought or body of thought tinged with or influenced by emotion [n -S]\n",
  "SENTIMENTAL": "marked or governed by feeling, sensibility, or emotional idealism [adj SENTIMENTALLY]\n",
  "SENTIMENTALISE": "to indulge in sentiment, also SENTIMENTALIZE [v SENTIMENTALISED, SENTIMENTALISES]\n",
  "SENTIMENTALISED": "SENTIMENTALISE, to indulge in sentiment, also SENTIMENTALIZE [v]\n",
  "SENTIMENTALISES": "SENTIMENTALISE, to indulge in sentiment, also SENTIMENTALIZE [v]\n",
  "SENTIMENTALISM": "the disposition to favor or indulge in sentimentality [n -S]\n",
  "SENTIMENTALISMS": "SENTIMENTALISM, the disposition to favor or indulge in sentimentality [n]\n",
  "SENTIMENTALIST": "one who indulges in sentimentalism [n -S]\n",
  "SENTIMENTALISTS": "SENTIMENTALIST, one who indulges in sentimentalism [n]\n",
  "SENTIMENTALITY": "the state of being sentimental esp. to excess or in affectation [n]\n",
  "SENTIMENTALIZE": "to indulge in sentiment, also SENTIMENTALISE [v SENTIMENTALIZED, SENTIMENTALIZES]\n",
  "SENTIMENTALIZED": "SENTIMENTALIZE, to indulge in sentiment, also SENTIMENTALISE [v]\n",
  "SENTIMENTALIZES": "SENTIMENTALIZE, to indulge in sentiment, also SENTIMENTALISE [v]\n",
  "SENTIMENTALLY": "SENTIMENTAL, marked or governed by feeling, sensibility, or emotional idealism [adv]\n",
  "SENTIMENTS": "SENTIMENT, a thought or body of thought tinged with or influenced by emotion [n]\n",
  "SENTIMO": "a monetary unit of the Philippines [n -S]\n",
  "SENTIMOS": "SENTIMO, a monetary unit of the Philippines [n]\n",
  "SENTINEL": "to stand guard [v SENTINELED or SENTINELLED, SENTINELING or SENTINELLING, SENTINELS]\n",
  "SENTINELED": "SENTINEL, to stand guard [v]\n",
  "SENTINELING": "SENTINEL, to stand guard [v]\n",
  "SENTINELLED": "SENTINEL, to stand guard [v]\n",
  "SENTINELLING": "SENTINEL, to stand guard [v]\n",
  "SENTINELS": "SENTINEL, to stand guard [v]\n",
  "SENTING": "SENT, (obsolete) to scent [v]\n",
  "SENTRIES": "SENTRY, the one who stands guard [n]\n",
  "SENTRY": "the one who stands guard [n SENTRIES]\n",
  "SENTS": "SENT, (obsolete) to scent [v]\n",
  "SENVIES": "SENVY, (obsolete) mustard [n]\n",
  "SENVY": "(obsolete) mustard [n SENVIES]\n",
  "SENZA": "(Italian) without; as in 'senza stromenti', without instruments [prep]\n",
  "SEPAD": "to suppose, uphold [v SEPADDED, SEPADDING, SEPADS]\n",
  "SEPADDED": "SEPAD, to suppose, uphold [v]\n",
  "SEPADDING": "SEPAD, to suppose, uphold [v]\n",
  "SEPADS": "SEPAD, to suppose, uphold [v]\n",
  "SEPAL": "one of the leaves of a calyx [n -S]\n",
  "SEPALED": "having a sepal [adj]\n",
  "SEPALINE": "of the form of sepals, also SEPALOID [adj]\n",
  "SEPALLED": "having one or more sepals, also SEPALED [adj]\n",
  "SEPALODIES": "SEPALODY, transformation into sepals [n]\n",
  "SEPALODY": "transformation into sepals [n SEPALODIES]\n",
  "SEPALOID": "of the form of sepals, also SEPALINE [adj]\n",
  "SEPALOUS": "having sepals [adj]\n",
  "SEPALS": "SEPAL, one of the leaves of a calyx [n]\n",
  "SEPARABILITIES": "SEPARABILITY, the state of being separable [n]\n",
  "SEPARABILITY": "the state of being separable [n SEPARABILITIES]\n",
  "SEPARABLE": "that can be separated [adj]\n",
  "SEPARABLENESS": "the state of being separable [n -ES]\n",
  "SEPARABLENESSES": "SEPARABLENESS, the state of being separable [n]\n",
  "SEPARABLY": "SEPARABLE, that can be separated [adv]\n",
  "SEPARATA": "SEPARATUM, a separate offprint [n]\n",
  "SEPARATE": "apart [adj SEPARATELY] / to set or keep apart [v SEPARATED, SEPARATING, SEPARATES]\n",
  "SEPARATED": "SEPARATE, to set or keep apart [v]\n",
  "SEPARATELY": "SEPARATE, apart [adv]\n",
  "SEPARATENESS": "the state of being separate [n -ES]\n",
  "SEPARATENESSES": "SEPARATENESS, the state of being separate [n]\n",
  "SEPARATES": "SEPARATE, to set or keep apart [v]\n",
  "SEPARATING": "SEPARATE, to set or keep apart [v]\n",
  "SEPARATION": "the act of separating [n -S]\n",
  "SEPARATIONISM": "a belief in, movement for, or state of separation, also SEPARATISM [n -S]\n",
  "SEPARATIONISMS": "SEPARATIONISM, a belief in, movement for, or state of separation, also SEPARATISM [n]\n",
  "SEPARATIONIST": "a believer in separationism [n -S]\n",
  "SEPARATIONISTS": "SEPARATIONIST, a believer in separationism [n]\n",
  "SEPARATIONS": "SEPARATION, the act of separating [n]\n",
  "SEPARATISM": "a belief in, movement for, or state of separation, also SEPARATIONISM [n -S]\n",
  "SEPARATISMS": "SEPARATISM, a belief in, movement for, or state of separation, also SEPARATIONISM [n]\n",
  "SEPARATIST": "one that favors separatism [n -S]\n",
  "SEPARATISTIC": "relating to separatism, a belief in, movement for, or state of separation [adj]\n",
  "SEPARATISTS": "SEPARATIST, one that favors separatism [n]\n",
  "SEPARATIVE": "causing separation [adj SEPARATIVELY]\n",
  "SEPARATIVELY": "SEPARATIVE, causing separation [adv]\n",
  "SEPARATIVENESS": "the state of being separative [n]\n",
  "SEPARATOR": "something that separates [n -S]\n",
  "SEPARATORIES": "SEPARATORY, an instrument for separating [n]\n",
  "SEPARATORS": "SEPARATOR, something that separates [n]\n",
  "SEPARATORY": "an instrument for separating [n SEPARATORIES]\n",
  "SEPARATRICES": "SEPARATRIX, a solidus; a separating line [n]\n",
  "SEPARATRIX": "a solidus; a separating line [n SEPARATRICES]\n",
  "SEPARATUM": "a separate offprint [n SEPARATUMS or SEPARATA]\n",
  "SEPARATUMS": "SEPARATUM, a separate offprint [n]\n",
  "SEPHEN": "(Arabic) a large stingray of the Indian Ocean and the Red Sea [n -S]\n",
  "SEPHENS": "SEPHEN, (Arabic) a large stingray of the Indian Ocean and the Red Sea [n]\n",
  "SEPIA": "a brown pigment, obtained from the ink of the cuttlefish [n -S]\n",
  "SEPIAS": "SEPIA, a brown pigment, obtained from the ink of the cuttlefish [n]\n",
  "SEPIC": "of or pertaining to sepia; done in sepia; as, a sepic drawing [adj]\n",
  "SEPIMENT": "(Latin) a hedge, fence, barrier [n -S]\n",
  "SEPIMENTS": "SEPIMENT, (Latin) a hedge, fence, barrier [n]\n",
  "SEPIOLITE": "hydrated magnesium silicate occurring as a soft white or yellowish claylike mineral; aka meerschaum [n -S]\n",
  "SEPIOLITES": "SEPIOLITE, hydrated magnesium silicate occurring as a soft white or yellowish claylike mineral; aka meerschaum [n]\n",
  "SEPIOST": "cuttlebone, also SEPIOSTAIRE, SEPIUM [n -S]\n",
  "SEPIOSTAIRE": "(French) cuttlebone, also SEPIOST, SEPIUM [n -S]\n",
  "SEPIOSTAIRES": "SEPIOSTAIRE, (French) cuttlebone, also SEPIOST, SEPIUM [n]\n",
  "SEPIOSTS": "SEPIOST, cuttlebone, also SEPIOSTAIRE, SEPIUM [n]\n",
  "SEPIUM": "cuttlebone, also SEPIOST, SEPIOSTAIRE [n -S]\n",
  "SEPIUMS": "SEPIUM, cuttlebone, also SEPIOST, SEPIOSTAIRE [n]\n",
  "SEPMAG": "pertaining to synchronized sound and film [adj]\n",
  "SEPOY": "(historical) an Indian soldier [n -S]\n",
  "SEPOYS": "SEPOY, (historical) an Indian soldier [n]\n",
  "SEPPUKU": "(Japanese) a form of ritual suicide by cutting open the stomach [n -S]\n",
  "SEPPUKUS": "SEPPUKU, (Japanese) a form of ritual suicide by cutting open the stomach [n]\n",
  "SEPS": "(Greek) a skink of the genus Seps with a serpentlike body [n -ES]\n",
  "SEPSES": "SEPS, (Greek) a skink of the genus Seps with a serpentlike body [n]\n",
  "SEPSIS": "(Greek) the state of being septic [n SEPSES]\n",
  "SEPT": "a division of a tribe; a clan [n -S]\n",
  "SEPTA": "SEPTUM, (Latin) a dividing membrane or partition [n]\n",
  "SEPTAGE": "the waste in a septic tank [n -S]\n",
  "SEPTAGES": "SEPTAGE, the waste in a septic tank [n]\n",
  "SEPTAL": "of or pertaining to a septum or septa, as of a coral or a shell [adj]\n",
  "SEPTARIA": "SEPTARIUM, a nodule of mineral substance with a network of cracks filled with another mineral [n]\n",
  "SEPTARIAN": "relating to a septarium, a flattened concretionary nodule [adj]\n",
  "SEPTARIUM": "a nodule of mineral substance with a network of cracks filled with another mineral [n SEPTARIA]\n",
  "SEPTATE": "having a septum [adj]\n",
  "SEPTATION": "the state of being septate, partitioned by a septum [n -S]\n",
  "SEPTATIONS": "SEPTATION, the state of being septate, partitioned by a septum [n]\n",
  "SEPTAVALENT": "having a valency of seven, also HEPTAVALENT, SEPTIVALENT [adj]\n",
  "SEPTEMFID": "split into seven [adj]\n",
  "SEPTEMVIR": "(Latin) one of a board of seven men associated in some office [n SEPTEMVIRS or SEPTEMVIRI]\n",
  "SEPTEMVIRATE": "government by, or group of, seven men [n -S]\n",
  "SEPTEMVIRATES": "SEPTEMVIRATE, government by, or group of, seven men [n]\n",
  "SEPTEMVIRI": "SEPTEMVIR, (Latin) one of a board of seven men associated in some office [n]\n",
  "SEPTEMVIRS": "SEPTEMVIR, (Latin) one of a board of seven men associated in some office [n]\n",
  "SEPTENARIES": "SEPTENARY, a group of seven [n]\n",
  "SEPTENARII": "SEPTENARIUS, a seven-foot verse, esp. a trochaic tetrameter catalectic [n]\n",
  "SEPTENARIUS": "a seven-foot verse, esp. a trochaic tetrameter catalectic [n SEPTENARII]\n",
  "SEPTENARY": "a group of seven [n SEPTENARIES]\n",
  "SEPTENDECILLION": "ten to the power of 54 [n]\n",
  "SEPTENNATE": "a period of seven years; as, the septennate during which the President of the French Republic holds office [n -S]\n",
  "SEPTENNATES": "SEPTENNATE, a period of seven years; as, the septennate during which the President of the French Republic holds office [n]\n",
  "SEPTENNIA": "SEPTENNIUM, a period of seven years [n]\n",
  "SEPTENNIAL": "lasting or continuing seven years; as, septennial parliaments [adj SEPTENNIALLY]\n",
  "SEPTENNIALLY": "SEPTENNIAL, lasting or continuing seven years; as, septennial parliaments [adv]\n",
  "SEPTENNIUM": "a period of seven years [n SEPTENNIA or SEPTENNIUMS]\n",
  "SEPTENNIUMS": "SEPTENNIUM, a period of seven years [n]\n",
  "SEPTENTRIAL": "(obsolete) northern, also SEPTENTRIONAL [adj]\n",
  "SEPTENTRION": "(archaic) the north [n SEPTENTRIONES or SEPTENTRIONS]\n",
  "SEPTENTRIONAL": "(obsolete) northern, also SEPTENTRIAL [adj]\n",
  "SEPTENTRIONALLY": "SEPTENTRIONAL, (obsolete) northern, also SEPTENTRIAL [adv]\n",
  "SEPTENTRIONES": "SEPTENTRION, (archaic) the north [n]\n",
  "SEPTENTRIONS": "SEPTENTRION, (archaic) the north [n]\n",
  "SEPTET": "a group of seven, also SEPTETTE, SEPTUOR [n -S]\n",
  "SEPTETS": "SEPTET, a group of seven, also SEPTETTE, SEPTUOR [n]\n",
  "SEPTETTE": "a group of seven, also SEPTET, SEPTUOR [n -S]\n",
  "SEPTETTES": "SEPTETTE, a group of seven, also SEPTET, SEPTUOR [n]\n",
  "SEPTIC": "producing sepsis, also SEPTICAL [adj SEPTICALLY] / an agent producing sepsis [n -S]\n",
  "SEPTICAEMIA": "blood-poisoning with presence of bacteria and their toxins in blood, also SEPTICEMIA [n -S]\n",
  "SEPTICAEMIAS": "SEPTICAEMIA, blood-poisoning with presence of bacteria and their toxins in blood, also SEPTICEMIA [n]\n",
  "SEPTICAEMIC": "relating to septicaemia, also SEPTICEMIC [adj]\n",
  "SEPTICAL": "having power to promote putrefaction, also SEPTIC [adj SEPTICALLY]\n",
  "SEPTICALLY": "SEPTICAL, having power to promote putrefaction, also SEPTIC [adv]\n",
  "SEPTICEMIA": "blood-poisoning with presence of bacteria and their toxins in blood, also SEPTICAEMIA [n -S]\n",
  "SEPTICEMIAS": "SEPTICEMIA, blood-poisoning with presence of bacteria and their toxins in blood, also SEPTICAEMIA [n]\n",
  "SEPTICEMIC": "relating to septicemia, also SEPTICAEMIC [adj]\n",
  "SEPTICIDAL": "with splitting of septa, as when a fruit dehisces by separation of the carpels [adj SEPTICIDALLY]\n",
  "SEPTICIDALLY": "SEPTICIDAL, with splitting of septa, as when a fruit dehisces by separation of the carpels [adv]\n",
  "SEPTICITIES": "SEPTICITY, the state of being septic [n]\n",
  "SEPTICITY": "the state of being septic [n SEPTICITIES]\n",
  "SEPTICS": "SEPTIC, an agent producing sepsis [n]\n",
  "SEPTIFEROUS": "having barriers [adj]\n",
  "SEPTIFORM": "shaped like a partition [adj]\n",
  "SEPTIFRAGAL": "breaking away of certain parts of a plant from its dividing walls [adj]\n",
  "SEPTILATERAL": "having seven sides [adj]\n",
  "SEPTILLION": "a thousand raised to the eighth power (10 to the 24) [n -S]\n",
  "SEPTILLIONS": "SEPTILLION, a thousand raised to the eighth power (10 to the 24) [n]\n",
  "SEPTILLIONTH": "the ordinal of septillion [n -S]\n",
  "SEPTILLIONTHS": "SEPTILLIONTH, the ordinal of septillion [n]\n",
  "SEPTIMAL": "relating to seven [adj]\n",
  "SEPTIME": "the seventh parrying position in fencing [n -S]\n",
  "SEPTIMES": "SEPTIME, the seventh parrying position in fencing [n]\n",
  "SEPTIMOLE": "a group of seven notes to be played in the time of four or six [n -S]\n",
  "SEPTIMOLES": "SEPTIMOLE, a group of seven notes to be played in the time of four or six [n]\n",
  "SEPTIVALENT": "having a valency of seven, also HEPTAVALENT, SEPTAVALENT [adj]\n",
  "SEPTLEVA": "(French) in the game of basset, seven times as much added to the first stake [n -S]\n",
  "SEPTLEVAS": "SEPTLEVA, (French) in the game of basset, seven times as much added to the first stake [n]\n",
  "SEPTORIA": "a type of fungus [n -S]\n",
  "SEPTORIAS": "SEPTORIA, a type of fungus [n]\n",
  "SEPTS": "SEPT, a division of a tribe; a clan [n]\n",
  "SEPTUAGENARIAN": "a person whose age is in the seventies [n -S]\n",
  "SEPTUAGENARIANS": "SEPTUAGENARIAN, a person whose age is in the seventies [n]\n",
  "SEPTUAGENARIES": "SEPTUAGENARY, a septuagenarian [n]\n",
  "SEPTUAGENARY": "a septuagenarian [n SEPTUAGENARIES]\n",
  "SEPTUM": "(Latin) a dividing membrane or partition [n SEPTUMS or SEPTA]\n",
  "SEPTUMS": "SEPTUM, (Latin) a dividing membrane or partition [n]\n",
  "SEPTUOR": "a group of seven, also SEPTET, SEPTETTE [n -S]\n",
  "SEPTUORS": "SEPTUOR, a group of seven, also SEPTET, SEPTETTE [n]\n",
  "SEPTUPLE": "to make seven times as great [v SEPTUPLED, SEPTUPLING, SEPTUPLES]\n",
  "SEPTUPLED": "SEPTUPLE, to make seven times as great [v]\n",
  "SEPTUPLES": "SEPTUPLE, to make seven times as great [v]\n",
  "SEPTUPLET": "one of seven children born together [n -S]\n",
  "SEPTUPLETS": "SEPTUPLET, one of seven children born together [n]\n",
  "SEPTUPLICATE": "a group of seven things [n -S]\n",
  "SEPTUPLICATES": "SEPTUPLICATE, a group of seven things [n]\n",
  "SEPTUPLING": "SEPTUPLE, to make seven times as great [v]\n",
  "SEPULCHER": "a receptacle in an altar for holding religious relics [n -S] / to place in a sepulcher, also SEPULCHRE [v -ED, -ING, -S]\n",
  "SEPULCHERED": "SEPULCHER, to place in a sepulcher, also SEPULCHRE [v]\n",
  "SEPULCHERING": "SEPULCHER, to place in a sepulcher, also SEPULCHRE [v]\n",
  "SEPULCHERS": "SEPULCHER, to place in a sepulcher, also SEPULCHRE [v]\n",
  "SEPULCHRAL": "funereal; gloomy; dismal [adj SEPULCHRALLY]\n",
  "SEPULCHRALLY": "SEPULCHRAL, funereal; gloomy; dismal [adv]\n",
  "SEPULCHRE": "a receptacle in an altar for holding religious relics [n -S] / to bury in a sepulchre, also SEPULCHER [v SEPULCHRED, SEPULCHRING, SEPULCHRES]\n",
  "SEPULCHRED": "SEPULCHRE, to bury in a sepulchre, also SEPULCHER [v]\n",
  "SEPULCHRES": "SEPULCHRE, a receptacle in an altar for holding religious relics [n]\n",
  "SEPULCHRING": "SEPULCHRE, to bury in a sepulchre, also SEPULCHER [v]\n",
  "SEPULCHROUS": "of or like a sepulchre [adj]\n",
  "SEPULTURAL": "relating to sepulture, the act of burial in a sepulchre [adj]\n",
  "SEPULTURE": "the act of depositing the dead body of a human being in the grave [n -S] / to bury, inter [v SEPULTURED, SEPULTURING, SEPULTURES]\n",
  "SEPULTURED": "SEPULTURE, to bury, inter [v]\n",
  "SEPULTURES": "SEPULTURE, to bury, inter [v]\n",
  "SEPULTURING": "SEPULTURE, to bury, inter [v]\n",
  "SEQUACIOUS": "intellectually servile, unthinkingly following others [adj SEQUACIOUSLY]\n",
  "SEQUACIOUSLY": "SEQUACIOUS, intellectually servile, unthinkingly following others [adv]\n",
  "SEQUACIOUSNESS": "the state of being sequacious, intellectually servile [n]\n",
  "SEQUACITIES": "SEQUACITY, the state of being sequacious, intellectually servile [n]\n",
  "SEQUACITY": "the state of being sequacious, intellectually servile [n SEQUACITIES]\n",
  "SEQUEL": "something that follows and serves as a continuation [n -S]\n",
  "SEQUELA": "(Latin) an abnormal condition caused by a preceding disease [n SEQUELAE]\n",
  "SEQUELAE": "SEQUELA, (Latin) an abnormal condition caused by a preceding disease [n]\n",
  "SEQUELISE": "to create a sequel to, also SEQUELIZE [v SEQUELISED, SEQUELISING, SEQUELISES]\n",
  "SEQUELISED": "SEQUELISE, to create a sequel to, also SEQUELIZE [v]\n",
  "SEQUELISES": "SEQUELISE, to create a sequel to, also SEQUELIZE [v]\n",
  "SEQUELISING": "SEQUELISE, to create a sequel to, also SEQUELIZE [v]\n",
  "SEQUELIZE": "to create a sequel to, also SEQUELISE [v SEQUELIZED, SEQUELIZING, SEQUELIZES]\n",
  "SEQUELIZED": "SEQUELIZE, to create a sequel to, also SEQUELISE [v]\n",
  "SEQUELIZES": "SEQUELIZE, to create a sequel to, also SEQUELISE [v]\n",
  "SEQUELIZING": "SEQUELIZE, to create a sequel to, also SEQUELISE [v]\n",
  "SEQUELS": "SEQUEL, something that follows and serves as a continuation [n]\n",
  "SEQUENCE": "to arrange in order [v SEQUENCED, SEQUENCING, SEQUENCES]\n",
  "SEQUENCED": "SEQUENCE, to arrange in order [v]\n",
  "SEQUENCER": "a device connected to a synthesizer that can memorize sequences of notes [n -S]\n",
  "SEQUENCERS": "SEQUENCER, a device connected to a synthesizer that can memorize sequences of notes [n]\n",
  "SEQUENCES": "SEQUENCE, to arrange in order [v]\n",
  "SEQUENCIES": "SEQUENCY, the following of one thing after another [n]\n",
  "SEQUENCING": "he act of arranging in consecutive order [n -S]\n",
  "SEQUENCINGS": "SEQUENCING, he act of arranging in consecutive order [n]\n",
  "SEQUENCY": "the following of one thing after another [n SEQUENCIES]\n",
  "SEQUENT": "following [adj SEQUENTLY] / a follower [n -S]\n",
  "SEQUENTIAL": "succeeding or following in order [adj SEQUENTIALLY]\n",
  "SEQUENTIALITIES": "SEQUENTIALITY, the state of being sequential [n]\n",
  "SEQUENTIALITY": "the state of being sequential [n SEQUENTIALITIES]\n",
  "SEQUENTIALLY": "SEQUENTIAL, succeeding or following in order [adv]\n",
  "SEQUENTLY": "SEQUENT, following [adv]\n",
  "SEQUENTS": "SEQUENT, a follower [n]\n",
  "SEQUESTER": "to set apart; to seize by authority of a writ [v -ED, -ING, -S]\n",
  "SEQUESTERED": "SEQUESTER, to set apart; to seize by authority of a writ [v]\n",
  "SEQUESTERING": "SEQUESTER, to set apart; to seize by authority of a writ [v]\n",
  "SEQUESTERS": "SEQUESTER, to set apart; to seize by authority of a writ [v]\n",
  "SEQUESTRA": "SEQUESTRUM, (Latin) a portion of dead bone which becomes separated from the sound portion, as in necrosis [n]\n",
  "SEQUESTRABLE": "that can be sequestered [adj]\n",
  "SEQUESTRAL": "of or like a sequestrum, a portion of dead bone which becomes separated from the sound portion, as in necrosis [adj]\n",
  "SEQUESTRANT": "a chemical that promotes sequestration [n -S]\n",
  "SEQUESTRANTS": "SEQUESTRANT, a chemical that promotes sequestration [n]\n",
  "SEQUESTRATE": "to confiscate; to set income aside to meet claims [v SEQUESTRATED, SEQUESTRATING, SEQUESTRATES]\n",
  "SEQUESTRATED": "SEQUESTRATE, to confiscate; to set income aside to meet claims [v]\n",
  "SEQUESTRATES": "SEQUESTRATE, to confiscate; to set income aside to meet claims [v]\n",
  "SEQUESTRATING": "SEQUESTRATE, to confiscate; to set income aside to meet claims [v]\n",
  "SEQUESTRATION": "seizure of goods or property by the authority of a writ [n -S]\n",
  "SEQUESTRATIONS": "SEQUESTRATION, seizure of goods or property by the authority of a writ [n]\n",
  "SEQUESTRATOR": "one who sequestrates [n -S]\n",
  "SEQUESTRATORS": "SEQUESTRATOR, one who sequestrates [n]\n",
  "SEQUESTRUM": "(Latin) a portion of dead bone which becomes separated from the sound portion, as in necrosis [n SEQUESTRA or SEQUESTRUMS]\n",
  "SEQUESTRUMS": "SEQUESTRUM, (Latin) a portion of dead bone which becomes separated from the sound portion, as in necrosis [n]\n",
  "SEQUIN": "to apply shiny ornamental disks to [v SEQUINNED or SEQUINED, SEQUINING, SEQUINS]\n",
  "SEQUINED": "SEQUIN, to apply shiny ornamental disks to [v]\n",
  "SEQUINING": "SEQUIN, to apply shiny ornamental disks to [v]\n",
  "SEQUINNED": "SEQUIN, to apply shiny ornamental disks to [v]\n",
  "SEQUINS": "SEQUIN, to apply shiny ornamental disks to [v]\n",
  "SEQUITUR": "(Latin) something that follows logically [n -S]\n",
  "SEQUITURS": "SEQUITUR, (Latin) something that follows logically [n]\n",
  "SEQUOIA": "any of a genus of coniferous trees, attaining an immense size [n -S]\n",
  "SEQUOIAS": "SEQUOIA, any of a genus of coniferous trees, attaining an immense size [n]\n",
  "SER": "an Indian unit of weight [n -S]\n",
  "SERA": "SERUM, (Latin) the watery portion of whole blood [n]\n",
  "SERAC": "(French) a large mass of ice broken off a glacier and remaining behind in a crevasse [n -S]\n",
  "SERACS": "SERAC, (French) a large mass of ice broken off a glacier and remaining behind in a crevasse [n]\n",
  "SERAFILE": "men riding in the rear of a squadron [n -S]\n",
  "SERAFILES": "SERAFILE, men riding in the rear of a squadron [n]\n",
  "SERAFIN": "(Portuguese) a former silver coin of Goa, also SERAPHIN, XERAFIN, XERAPHIN [n -S]\n",
  "SERAFINS": "SERAFIN, (Portuguese) a former silver coin of Goa, also SERAPHIN, XERAFIN, XERAPHIN [n]\n",
  "SERAGLIO": "(Italian) a harem, also SERAIL [n -S]\n",
  "SERAGLIOS": "SERAGLIO, (Italian) a harem, also SERAIL [n]\n",
  "SERAI": "(Turkish) a caravanserai, or rest house [n -S]\n",
  "SERAIL": "(French) a harem, also SERAGLIO [n -S]\n",
  "SERAILS": "SERAIL, (French) a harem, also SERAGLIO [n]\n",
  "SERAIS": "SERAI, (Turkish) a caravanserai, or rest house [n]\n",
  "SERAL": "pertaining to a series of ecological changes [adj]\n",
  "SERANG": "(Urdu) the boatswain of a Lascar or East Indian crew [n -S]\n",
  "SERANGS": "SERANG, (Urdu) the boatswain of a Lascar or East Indian crew [n]\n",
  "SERAPE": "(Spanish) a blanket or shawl worn as an outer garment by the Spanish Americans, as in Mexico, also SARAPE, ZARAPE [n -S]\n",
  "SERAPES": "SERAPE, (Spanish) a blanket or shawl worn as an outer garment by the Spanish Americans, as in Mexico, also SARAPE, ZARAPE [n]\n",
  "SERAPH": "in Christian theology, a member of the highest order of the ninefold celestial hierarchy [n SERAPHS, SERAPHIM, previously also SERAPHIMS, SERAPHIN, SERAPHINS]\n",
  "SERAPHIC": "of or like a seraph, also SERAPHICAL [adj SERAPHICALLY]\n",
  "SERAPHICAL": "of or like a seraph, also SERAPHIC [adj SERAPHICALLY]\n",
  "SERAPHICALLY": "SERAPHICAL, of or like a seraph, also SERAPHIC [adv]\n",
  "SERAPHIM": "in Christian theology, a member of the highest order of the ninefold celestial hierarchy, also SERAPH [n -S]\n",
  "SERAPHIMS": "SERAPHIM, in Christian theology, a member of the highest order of the ninefold celestial hierarchy, also SERAPH [n]\n",
  "SERAPHIN": "(Portuguese) a former silver coin of Goa, also SERAFIN, XERAFIN, XERAPHIN [n -S]\n",
  "SERAPHINE": "a kind of small reed organ or harmonium [n -S]\n",
  "SERAPHINES": "SERAPHINE, a kind of small reed organ or harmonium [n]\n",
  "SERAPHINS": "SERAPHIN, (Portuguese) a former silver coin of Goa, also SERAFIN, XERAFIN, XERAPHIN [n]\n",
  "SERAPHS": "SERAPH, in Christian theology, a member of the highest order of the ninefold celestial hierarchy [n]\n",
  "SERASKIER": "(historical) a general or commander of land forces in the Turkish empire [n -S]\n",
  "SERASKIERATE": "the office or authority of a seraskier [n -S]\n",
  "SERASKIERATES": "SERASKIERATE, the office or authority of a seraskier [n]\n",
  "SERASKIERS": "SERASKIER, (historical) a general or commander of land forces in the Turkish empire [n]\n",
  "SERDAB": "(Persian) a chamber within an ancient Egyptian tomb [n -S]\n",
  "SERDABS": "SERDAB, (Persian) a chamber within an ancient Egyptian tomb [n]\n",
  "SERE": "withered, dry, also SEAR, SEARE [adj SERER, SEREST] / to burn the surface of, also SEAR [v SERED, SERING, SERES]\n",
  "SERED": "SERE, to burn the surface of, also SEAR [v]\n",
  "SEREIN": "(French) fine tropical rain falling from an apparently cloudless night sky [n -S]\n",
  "SEREINS": "SEREIN, (French) fine tropical rain falling from an apparently cloudless night sky [n]\n",
  "SERENADE": "(French) a piece of vocal music, esp. one on an amorous subject, also SERENATA, SERENATE [n -S] / to address a serenade to [v SERENADED, SERENADING, SERENADES]\n",
  "SERENADED": "SERENADE, to address a serenade to [v]\n",
  "SERENADER": "one who serenades [n -S]\n",
  "SERENADERS": "SERENADER, one who serenades [n]\n",
  "SERENADES": "SERENADE, to address a serenade to [v]\n",
  "SERENADING": "SERENADE, to address a serenade to [v]\n",
  "SERENATA": "(Italian) a piece of vocal music, esp. one on an amorous subject, also SERENADE, SERENATE [n -S]\n",
  "SERENATAS": "SERENATA, (Italian) a piece of vocal music, esp. one on an amorous subject, also SERENADE, SERENATE [n]\n",
  "SERENATE": "to calm, make serene [v SERENATED, SERENATING, SERENATES]\n",
  "SERENATED": "SERENATE, to calm, make serene [v]\n",
  "SERENATES": "SERENATE, to calm, make serene [v]\n",
  "SERENATING": "SERENATE, to calm, make serene [v]\n",
  "SERENDIPITIES": "SERENDIPITY, the faculty of making fortunate discoveries by accident [n]\n",
  "SERENDIPITIST": "a person who believes in serendipity; a person who has this faculty [n -S]\n",
  "SERENDIPITISTS": "SERENDIPITIST, a person who believes in serendipity; a person who has this faculty [n]\n",
  "SERENDIPITOUS": "obtained or characterized by serendipity [adj SERENDIPITOUSLY]\n",
  "SERENDIPITOUSLY": "SERENDIPITOUS, obtained or characterized by serendipity [adv]\n",
  "SERENDIPITY": "the faculty of making fortunate discoveries by accident [n SERENDIPITIES]\n",
  "SERENE": "calm, tranquil [adj SERENER, SERENEST] / to tranquillize [v SERENED, SERENING, SERENES]\n",
  "SERENED": "SERENE, to tranquillize [v]\n",
  "SERENELY": "SERENE, calm, tranquil [adv]\n",
  "SERENENESS": "the state of being serene [n -ES]\n",
  "SERENENESSES": "SERENENESS, the state of being serene [n]\n",
  "SERENER": "SERENE, calm, tranquil [adj]\n",
  "SERENES": "SERENE, to tranquillize [v]\n",
  "SERENEST": "SERENE, calm, tranquil [adj]\n",
  "SERENING": "SERENE, to tranquillize [v]\n",
  "SERENITIES": "SERENITY, the state of being serene [n]\n",
  "SERENITY": "the state of being serene [n SERENITIES]\n",
  "SERER": "SERE, withered, dry, also SEAR, SEARE [adj]\n",
  "SERES": "SERE, to burn the surface of, also SEAR [v]\n",
  "SEREST": "SERE, withered, dry, also SEAR, SEARE [adj]\n",
  "SERF": "a person in modified slavery, esp. one bound to work on the land [n -S]\n",
  "SERFAGE": "the state of being a serf, also SERFDOM, SERFHOOD, SERFSHIP [n -S]\n",
  "SERFAGES": "SERFAGE, the state of being a serf, also SERFDOM, SERFHOOD, SERFSHIP [n]\n",
  "SERFDOM": "the state of being a serf, also SERFAGE, SERFHOOD, SERFSHIP [n -S]\n",
  "SERFDOMS": "SERFDOM, the state of being a serf, also SERFAGE, SERFHOOD, SERFSHIP [n]\n",
  "SERFHOOD": "the state of being a serf, also SERFAGE, SERFDOM, SERFSHIP [n -S]\n",
  "SERFHOODS": "SERFHOOD, the state of being a serf, also SERFAGE, SERFDOM, SERFSHIP [n]\n",
  "SERFISH": "characteristic of a serf [adj]\n",
  "SERFLIKE": "like a serf [adj]\n",
  "SERFS": "SERF, a person in modified slavery, esp. one bound to work on the land [n]\n",
  "SERFSHIP": "the state of being a serf, also SERFAGE, SERFDOM, SERFHOOD [n -S]\n",
  "SERFSHIPS": "SERFSHIP, the state of being a serf, also SERFAGE, SERFDOM, SERFHOOD [n]\n",
  "SERGE": "a strong twilled worsted [n -S]\n",
  "SERGEANCIES": "SERGEANCY, the office or rank of a sergeant, also SERJEANCY [n]\n",
  "SERGEANCY": "the office or rank of a sergeant, also SERJEANCY [n SERGEANCIES]\n",
  "SERGEANT": "a noncommissioned military officer, also SERJEANT [n -S]\n",
  "SERGEANTIES": "SERGEANTY, a condition of tenure by service in person to the king, also SERJEANTRY, SERJEANTY [n]\n",
  "SERGEANTS": "SERGEANT, a noncommissioned military officer, also SERJEANT [n]\n",
  "SERGEANTSHIP": "the office of sergeant [n -S]\n",
  "SERGEANTSHIPS": "SERGEANTSHIP, the office of sergeant [n]\n",
  "SERGEANTY": "a condition of tenure by service in person to the king, also SERJEANTRY, SERJEANTY [n SERGEANTIES]\n",
  "SERGED": "with sewn seams [adj]\n",
  "SERGER": "a sewing machine attachment for finishing seams [n -S]\n",
  "SERGERS": "SERGER, a sewing machine attachment for finishing seams [n]\n",
  "SERGES": "SERGE, a strong twilled worsted [n]\n",
  "SERGING": "a process of finishing the raw edges of a fabric [n -S]\n",
  "SERGINGS": "SERGING, a process of finishing the raw edges of a fabric [n]\n",
  "SERIAL": "in sequence [adj SERIALLY] / a literary or dramatic work presented in successive installments [n -S]\n",
  "SERIALISATION": "the process of serialising, also SERIALIZATION [n -S]\n",
  "SERIALISATIONS": "SERIALISATION, the process of serialising, also SERIALIZATION [n]\n",
  "SERIALISE": "to convert into serial form, also SERIALIZE [v SERIALISED, SERIALISING, SERIALISES]\n",
  "SERIALISED": "SERIALISE, to convert into serial form, also SERIALIZE [v]\n",
  "SERIALISES": "SERIALISE, to convert into serial form, also SERIALIZE [v]\n",
  "SERIALISING": "SERIALISE, to convert into serial form, also SERIALIZE [v]\n",
  "SERIALISM": "serial technique, or the use of it, e.g. the twelve-note row [n -S]\n",
  "SERIALISMS": "SERIALISM, serial technique, or the use of it, e.g. the twelve-note row [n]\n",
  "SERIALIST": "a writer of serials [n -S]\n",
  "SERIALISTS": "SERIALIST, a writer of serials [n]\n",
  "SERIALITIES": "SERIALITY, the state of being serial [n]\n",
  "SERIALITY": "the state of being serial [n SERIALITIES]\n",
  "SERIALIZATION": "the process of serializing, also SERIALISATION [n -S]\n",
  "SERIALIZATIONS": "SERIALIZATION, the process of serializing, also SERIALISATION [n]\n",
  "SERIALIZE": "to convert into serial form, also SERIALISE [v SERIALIZED, SERIALIZING, SERIALIZES]\n",
  "SERIALIZED": "SERIALIZE, to convert into serial form, also SERIALISE [v]\n",
  "SERIALIZES": "SERIALIZE, to convert into serial form, also SERIALISE [v]\n",
  "SERIALIZING": "SERIALIZE, to convert into serial form, also SERIALISE [v]\n",
  "SERIALLY": "SERIAL, in sequence [adv]\n",
  "SERIALS": "SERIAL, a literary or dramatic work presented in successive installments [n]\n",
  "SERIATE": "arranged in a series or rows [adj SERIATELY] / to arrange in rows [v SERIATED, SERIATING, SERIATES]\n",
  "SERIATED": "SERIATE, to arrange in rows [v]\n",
  "SERIATELY": "SERIATE, arranged in a series or rows [adv]\n",
  "SERIATES": "SERIATE, to arrange in rows [v]\n",
  "SERIATIM": "(Latin) one after another; in a series [adj]\n",
  "SERIATING": "SERIATE, to arrange in rows [v]\n",
  "SERIATION": "arrangement or position in a series [n -S]\n",
  "SERIATIONS": "SERIATION, arrangement or position in a series [n]\n",
  "SERIC": "silken [adj]\n",
  "SERICEOUS": "of leaves, covered with fine silky hairs [adj]\n",
  "SERICICULTURE": "the cultivation of silkworms [n -S]\n",
  "SERICICULTURES": "SERICICULTURE, the cultivation of silkworms [n]\n",
  "SERICICULTURIST": "one who practises sericulture, the breeding of silkworms for silk production [n]\n",
  "SERICIN": "the gelatinous protein found in raw silk [n -S]\n",
  "SERICINS": "SERICIN, the gelatinous protein found in raw silk [n]\n",
  "SERICITE": "a silky potash mica [n -S]\n",
  "SERICITES": "SERICITE, a silky potash mica [n]\n",
  "SERICITIC": "like sericite, a silky soapy potash mica [adj]\n",
  "SERICITISATION": "conversion, esp. of orthoclase, into sericite, also SERICITIZATION [n -S]\n",
  "SERICITISATIONS": "SERICITISATION, conversion, esp. of orthoclase, into sericite, also SERICITIZATION [n]\n",
  "SERICITIZATION": "conversion, esp. of orthoclase, into sericite, also SERICITISATION [n -S]\n",
  "SERICITIZATIONS": "SERICITIZATION, conversion, esp. of orthoclase, into sericite, also SERICITISATION [n]\n",
  "SERICON": "a conjectural red or black tincture in alchemy [n -S]\n",
  "SERICONS": "SERICON, a conjectural red or black tincture in alchemy [n]\n",
  "SERICTERIA": "SERICTERIUM, a silk spinning gland [n]\n",
  "SERICTERIUM": "a silk spinning gland [n SERICTERIA]\n",
  "SERICULTURAL": "relating to sericulture [adj]\n",
  "SERICULTURE": "the breeding of silkworms for silk production [n -S]\n",
  "SERICULTURES": "SERICULTURE, the breeding of silkworms for silk production [n]\n",
  "SERICULTURIST": "one who practises sericulture [n -S]\n",
  "SERICULTURISTS": "SERICULTURIST, one who practises sericulture [n]\n",
  "SERIEMA": "(Tupi) a large South American bird related to the cranes, also CARIAMA [n -S]\n",
  "SERIEMAS": "SERIEMA, (Tupi) a large South American bird related to the cranes, also CARIAMA [n]\n",
  "SERIES": "an arrangement of one after another [n SERIES]\n",
  "SERIF": "a decorative stroke at the foot of a letter, also CERIPH, SERIPH [n -S]\n",
  "SERIFED": "with a serif, a decorative stroke at the foot of a letter, also SERIFFED [adj]\n",
  "SERIFFED": "with a serif, a decorative stroke at the foot of a letter, also SERIFED [adj]\n",
  "SERIFS": "SERIF, a decorative stroke at the foot of a letter, also CERIPH, SERIPH [n]\n",
  "SERIGRAPH": "a silkscreen print [n -S]\n",
  "SERIGRAPHER": "one who makes serigraphs, silkscreen prints [n -S]\n",
  "SERIGRAPHERS": "SERIGRAPHER, one who makes serigraphs, silkscreen prints [n]\n",
  "SERIGRAPHIC": "relating to serigraphy [adj]\n",
  "SERIGRAPHIES": "SERIGRAPHY, the making of silkscreen prints [n]\n",
  "SERIGRAPHS": "SERIGRAPH, a silkscreen print [n]\n",
  "SERIGRAPHY": "the making of silkscreen prints [n SERIGRAPHIES]\n",
  "SERIN": "(French) a bird of the finch family [n -S]\n",
  "SERINE": "a polar amino acid found in protein and synthesized in the body [n -S]\n",
  "SERINES": "SERINE, a polar amino acid found in protein and synthesized in the body [n]\n",
  "SERINETTE": "(French) a small barrel-organ for training songbirds [n -S]\n",
  "SERINETTES": "SERINETTE, (French) a small barrel-organ for training songbirds [n]\n",
  "SERING": "SERE, to burn the surface of, also SEAR [v]\n",
  "SERINGA": "(Portuguese) a Brazilian tree yielding rubber [n -S]\n",
  "SERINGAS": "SERINGA, (Portuguese) a Brazilian tree yielding rubber [n]\n",
  "SERINS": "SERIN, (French) a bird of the finch family [n]\n",
  "SERIOCOMIC": "partly serious and partly comic, also SERIOCOMICAL [adj SERIOCOMICALLY]\n",
  "SERIOCOMICAL": "partly serious and partly comic, also SERIOCOMIC [adj SERIOCOMICALLY]\n",
  "SERIOCOMICALLY": "SERIOCOMICAL, partly serious and partly comic, also SERIOCOMIC [adv]\n",
  "SERIOUS": "thoughtful or subdued in appearance [adj SERIOUSLY]\n",
  "SERIOUSLY": "SERIOUS, thoughtful or subdued in appearance [adv]\n",
  "SERIOUSNESS": "the state of being serious [n -ES]\n",
  "SERIOUSNESSES": "SERIOUSNESS, the state of being serious [n]\n",
  "SERIPH": "a decorative stroke at the foot of a letter, also CERIPH, SERIF [n -S]\n",
  "SERIPHS": "SERIPH, a decorative stroke at the foot of a letter, also CERIPH, SERIF [n]\n",
  "SERJEANCIES": "SERJEANCY, the office or rank of serjeant, also SERGEANCY [n]\n",
  "SERJEANCY": "the office or rank of serjeant, also SERGEANCY [n SERJEANCIES]\n",
  "SERJEANT": "a noncommissioned military officer, also SERGEANT [n -S]\n",
  "SERJEANTIES": "SERJEANTY, (historical) a condition of tenure by service in person to the king, also SERGEANTY, SERJEANTRY [n]\n",
  "SERJEANTRIES": "SERJEANTRY, a condition of tenure by service in person to the king, also SERGEANTY, SERJEANTY [n]\n",
  "SERJEANTRY": "a condition of tenure by service in person to the king, also SERGEANTY, SERJEANTY [n SERJEANTRIES]\n",
  "SERJEANTS": "SERJEANT, a noncommissioned military officer, also SERGEANT [n]\n",
  "SERJEANTSHIP": "the office of serjeant [n -S]\n",
  "SERJEANTSHIPS": "SERJEANTSHIP, the office of serjeant [n]\n",
  "SERJEANTY": "(historical) a condition of tenure by service in person to the king, also SERGEANTY, SERJEANTRY [n SERJEANTIES]\n",
  "SERK": "(Scots) a shirt or chemise, also SARK [n -S]\n",
  "SERKALI": "(Swahili) in Africa, the Government [n -S]\n",
  "SERKALIS": "SERKALI, (Swahili) in Africa, the Government [n]\n",
  "SERKS": "SERK, (Scots) a shirt or chemise, also SARK [n]\n",
  "SERMON": "to preach a religious discourse [v -ED, -ING, -S]\n",
  "SERMONED": "SERMON, to preach a religious discourse [v]\n",
  "SERMONEER": "a preacher; a sermonizer, also SERMONER [n -S]\n",
  "SERMONEERS": "SERMONEER, a preacher; a sermonizer, also SERMONER [n]\n",
  "SERMONER": "a preacher; a sermonizer, also SERMONEER [n -S]\n",
  "SERMONERS": "SERMONER, a preacher; a sermonizer, also SERMONEER [n]\n",
  "SERMONET": "a short sermon, also SERMONETTE [n -S]\n",
  "SERMONETS": "SERMONET, a short sermon, also SERMONETTE [n]\n",
  "SERMONETTE": "a short sermon, also SERMONET [n -S]\n",
  "SERMONETTES": "SERMONETTE, a short sermon, also SERMONET [n]\n",
  "SERMONIC": "like, or appropriate to, a sermon, also SERMONICAL [adj]\n",
  "SERMONICAL": "like, or appropriate to, a sermon, also SERMONIC [adj]\n",
  "SERMONING": "preaching a sermon [n -S]\n",
  "SERMONINGS": "SERMONING, preaching a sermon [n]\n",
  "SERMONISE": "to deliver or compose a sermon, also SERMONIZE [v SERMONISED, SERMONISING, SERMONISES]\n",
  "SERMONISED": "SERMONISE, to deliver or compose a sermon, also SERMONIZE [v]\n",
  "SERMONISER": "one who sermonises, also SERMONIZER [n -S]\n",
  "SERMONISERS": "SERMONISER, one who sermonises, also SERMONIZER [n]\n",
  "SERMONISES": "SERMONISE, to deliver or compose a sermon, also SERMONIZE [v]\n",
  "SERMONISING": "the act of giving a sermon [n -S]\n",
  "SERMONISINGS": "SERMONISING, the act of giving a sermon [n]\n",
  "SERMONIZE": "to deliver or compose a sermon, also SERMONISE [v SERMONIZED, SERMONIZING, SERMONIZES]\n",
  "SERMONIZED": "SERMONIZE, to deliver or compose a sermon, also SERMONISE [v]\n",
  "SERMONIZER": "one who sermonizes, also SERMONISER [n -S]\n",
  "SERMONIZERS": "SERMONIZER, one who sermonizes, also SERMONISER [n]\n",
  "SERMONIZES": "SERMONIZE, to deliver or compose a sermon, also SERMONISE [v]\n",
  "SERMONIZING": "the act of giving a sermon [n -S]\n",
  "SERMONIZINGS": "SERMONIZING, the act of giving a sermon [n]\n",
  "SERMONS": "SERMON, to preach a religious discourse [v]\n",
  "SEROCONVERSION": "the production of antibodies in response to an antigen [n -S]\n",
  "SEROCONVERSIONS": "SEROCONVERSION, the production of antibodies in response to an antigen [n]\n",
  "SEROCONVERT": "to produce specific antibodies in response to the presence of an antigen, such as a virus or vaccine [v -ED, -ING, -S]\n",
  "SEROCONVERTED": "SEROCONVERT, to produce specific antibodies in response to the presence of an antigen, such as a virus or vaccine [v]\n",
  "SEROCONVERTING": "SEROCONVERT, to produce specific antibodies in response to the presence of an antigen, such as a virus or vaccine [v]\n",
  "SEROCONVERTS": "SEROCONVERT, to produce specific antibodies in response to the presence of an antigen, such as a virus or vaccine [v]\n",
  "SERODIAGNOSES": "SERODIAGNOSIS, diagnosis using blood serum reactions [n]\n",
  "SERODIAGNOSIS": "diagnosis using blood serum reactions [n SERODIAGNOSES]\n",
  "SERODIAGNOSTIC": "denoting a method of testing test blood and serum for TB antibodies [adj]\n",
  "SEROGROUP": "any group of bacteria or other microorganisms that have a certain antigen in common [n -S]\n",
  "SEROGROUPS": "SEROGROUP, any group of bacteria or other microorganisms that have a certain antigen in common [n]\n",
  "SEROLOGIC": "as in serologic typing, a technique based on antibody-antigen reactions, for the identification of pathogenic organisms when morphological differentiation is difficult or impossible, also SEROLOGICAL [adj SEROLOGICALLY]\n",
  "SEROLOGICAL": "as in serological typing, a technique based on antibody-antigen reactions, for the identification of pathogenic organisms when morphological differentiation is difficult or impossible, also SEROLOGIC [adj SEROLOGICALLY]\n",
  "SEROLOGICALLY": "SEROLOGICAL, as in serological typing, a technique based on antibody-antigen reactions, for the identification of pathogenic organisms when morphological differentiation is difficult or impossible, also SEROLOGIC [adv]\n",
  "SEROLOGIES": "SEROLOGY, the science of serums [n]\n",
  "SEROLOGIST": "one who studies sera [n -S]\n",
  "SEROLOGISTS": "SEROLOGIST, one who studies sera [n]\n",
  "SEROLOGY": "the science of serums [n SEROLOGIES]\n",
  "SEROMA": "an abnormal pocket of clear fluid in the body [n -S]\n",
  "SEROMAS": "SEROMA, an abnormal pocket of clear fluid in the body [n]\n",
  "SERON": "a crate, also SEROON [n -S]\n",
  "SERONEGATIVE": "having or being a negative serum reaction esp. in a test for the presence of an antibody [adj]\n",
  "SERONEGATIVITY": "the state of being seronegative [n]\n",
  "SERONS": "SERON, a crate, also SEROON [n]\n",
  "SEROON": "(Spanish) a crate or hamper; a bale wrapped in hide, also CEROON, SERON [n -S]\n",
  "SEROONS": "SEROON, (Spanish) a crate or hamper; a bale wrapped in hide, also CEROON, SERON [n]\n",
  "SEROPOSITIVE": "having or being a positive serum reaction esp. in a test for the presence of an antibody [adj]\n",
  "SEROPOSITIVITY": "the state of being seropositive [n]\n",
  "SEROPURULENT": "serum and pus [adj]\n",
  "SEROPUS": "a mixture of serum and pus [n -ES]\n",
  "SEROPUSES": "SEROPUS, a mixture of serum and pus [n]\n",
  "SEROSA": "(Latin) a thin membrane lining some bodily cavities [n SEROSAS or SEROSAE]\n",
  "SEROSAE": "SEROSA, (Latin) a thin membrane lining some bodily cavities [n]\n",
  "SEROSAL": "relating to serosa, serous membrane [adj]\n",
  "SEROSAS": "SEROSA, (Latin) a thin membrane lining some bodily cavities [n]\n",
  "SEROSITIES": "SEROSITY, the state of being serous, of or relating to serum [n]\n",
  "SEROSITY": "the state of being serous, of or relating to serum [n SEROSITIES]\n",
  "SEROTAXONOMIES": "SEROTAXONOMY, serological analysis as a source of information for taxonomic classification [n]\n",
  "SEROTAXONOMY": "serological analysis as a source of information for taxonomic classification [n SEROTAXONOMIES]\n",
  "SEROTHERAPIES": "SEROTHERAPY, treatment with a serum or antitoxin [n]\n",
  "SEROTHERAPY": "treatment with a serum or antitoxin [n SEROTHERAPIES]\n",
  "SEROTINAL": "flowering in late summer [adj]\n",
  "SEROTINE": "(Latin) a kind of bat, named for its habit of appearing late in the evening [n -S]\n",
  "SEROTINES": "SEROTINE, (Latin) a kind of bat, named for its habit of appearing late in the evening [n]\n",
  "SEROTINIES": "SEROTINY, the condition of having late or gradual seed dispersal [n]\n",
  "SEROTINOUS": "flowering late [adj]\n",
  "SEROTINY": "the condition of having late or gradual seed dispersal [n SEROTINIES]\n",
  "SEROTONERGIC": "liberating, activated by, or involving serotonin in the transmission of nerve impulses, also SEROTONINERGIC [adj]\n",
  "SEROTONIN": "a compound occurring in the brain, acting as a neurotransmitter [n -S]\n",
  "SEROTONINERGIC": "liberating, activated by, or involving serotonin in the transmission of nerve impulses, also SEROTONERGIC [adj]\n",
  "SEROTONINS": "SEROTONIN, a compound occurring in the brain, acting as a neurotransmitter [n]\n",
  "SEROTYPE": "to classify according to the composition of antigens [v SEROTYPED, SEROTYPING, SEROTYPES]\n",
  "SEROTYPED": "SEROTYPE, to classify according to the composition of antigens [v]\n",
  "SEROTYPES": "SEROTYPE, to classify according to the composition of antigens [v]\n",
  "SEROTYPIC": "relating to a serotype, a group of related microorganisms related by their antigens [adj]\n",
  "SEROTYPING": "assignation to a particular serotype [n -S]\n",
  "SEROTYPINGS": "SEROTYPING, assignation to a particular serotype [n]\n",
  "SEROUS": "of or relating to serum; watery [adj]\n",
  "SEROUSNESS": "the state of being serous [n -ES]\n",
  "SEROUSNESSES": "SEROUSNESS, the state of being serous [n]\n",
  "SEROVAR": "a group of microorganisms having a characteristic set of antigens [n -S]\n",
  "SEROVARS": "SEROVAR, a group of microorganisms having a characteristic set of antigens [n]\n",
  "SEROW": "a Himalayan goatlike antelope, aka thar [n -S]\n",
  "SEROWS": "SEROW, a Himalayan goatlike antelope, aka thar [n]\n",
  "SERPENT": "a snake [n -S]\n",
  "SERPENTIFORM": "in the form of a serpent [adj]\n",
  "SERPENTINE": "winding [adj SERPENTINELY] / to wind [v SERPENTINED, SERPENTINING, SERPENTINES]\n",
  "SERPENTINED": "SERPENTINE, to wind [v]\n",
  "SERPENTINELY": "SERPENTINE, winding [adv]\n",
  "SERPENTINES": "SERPENTINE, to wind [v]\n",
  "SERPENTINIC": "of or like serpentine [adj]\n",
  "SERPENTINING": "winding [adj SERPENTININGLY] / the act of serpentining [n -S]\n",
  "SERPENTININGLY": "SERPENTINING, winding [adv]\n",
  "SERPENTININGS": "SERPENTINING, the act of serpentining [n]\n",
  "SERPENTINISE": "to wind, also SERPENTINIZE, SERPENTISE, SERPENTIZE [v SERPENTINISED, SERPENTINISING, SERPENTINISES]\n",
  "SERPENTINISED": "SERPENTINISE, to wind, also SERPENTINIZE, SERPENTISE, SERPENTIZE [v]\n",
  "SERPENTINISES": "SERPENTINISE, to wind, also SERPENTINIZE, SERPENTISE, SERPENTIZE [v]\n",
  "SERPENTINISING": "SERPENTINISE, to wind, also SERPENTINIZE, SERPENTISE, SERPENTIZE [v]\n",
  "SERPENTINITE": "a metamorphic rock that consists largely of the mineral serpentine [n -S]\n",
  "SERPENTINITES": "SERPENTINITE, a metamorphic rock that consists largely of the mineral serpentine [n]\n",
  "SERPENTINIZE": "to wind, also SERPENTINISE, SERPENTISE, SERPENTIZE [v SERPENTINIZED, SERPENTINIZING, SERPENTINIZES]\n",
  "SERPENTINIZED": "SERPENTINIZE, to wind, also SERPENTINISE, SERPENTISE, SERPENTIZE [v]\n",
  "SERPENTINIZES": "SERPENTINIZE, to wind, also SERPENTINISE, SERPENTISE, SERPENTIZE [v]\n",
  "SERPENTINIZING": "SERPENTINIZE, to wind, also SERPENTINISE, SERPENTISE, SERPENTIZE [v]\n",
  "SERPENTINOUS": "of serpentine, winding [adj]\n",
  "SERPENTISE": "to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTIZE [v SERPENTISED, SERPENTISING, SERPENTISES]\n",
  "SERPENTISED": "SERPENTISE, to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTIZE [v]\n",
  "SERPENTISES": "SERPENTISE, to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTIZE [v]\n",
  "SERPENTISING": "SERPENTISE, to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTIZE [v]\n",
  "SERPENTIZE": "to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTISE [v SERPENTIZED, SERPENTIZING, SERPENTIZES]\n",
  "SERPENTIZED": "SERPENTIZE, to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTISE [v]\n",
  "SERPENTIZES": "SERPENTIZE, to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTISE [v]\n",
  "SERPENTIZING": "SERPENTIZE, to wind; to cause to wind, also SERPENTINISE, SERPENTINIZE, SERPENTISE [v]\n",
  "SERPENTLIKE": "like a serpent [adj]\n",
  "SERPENTRIES": "SERPENTRY, serpents collectively [n]\n",
  "SERPENTRY": "serpents collectively [n SERPENTRIES]\n",
  "SERPENTS": "SERPENT, a snake [n]\n",
  "SERPIGINES": "SERPIGO, (Latin) a spreading skin eruption, also SAPEGO, SUPPEAGO [n]\n",
  "SERPIGINOUS": "spreading by creeping [adj SERPIGINOUSLY]\n",
  "SERPIGINOUSLY": "SERPIGINOUS, spreading by creeping [adv]\n",
  "SERPIGO": "(Latin) a spreading skin eruption, also SAPEGO, SUPPEAGO [n SERPIGOS or SERPIGINES or SERPIGOES]\n",
  "SERPIGOES": "SERPIGO, (Latin) a spreading skin eruption, also SAPEGO, SUPPEAGO [n]\n",
  "SERPIGOS": "SERPIGO, (Latin) a spreading skin eruption, also SAPEGO, SUPPEAGO [n]\n",
  "SERPULA": "a member of a genus of marine annelids or tubeworms, also SERPULID [n SERPULAE or SERPULAS]\n",
  "SERPULAE": "SERPULA, a member of a genus of marine annelids or tubeworms, also SERPULID [n]\n",
  "SERPULAS": "SERPULA, a member of a genus of marine annelids or tubeworms, also SERPULID [n]\n",
  "SERPULID": "a marine worm that lives in a stony tube, also SERPULA [n -S]\n",
  "SERPULIDS": "SERPULID, a marine worm that lives in a stony tube, also SERPULA [n]\n",
  "SERPULITE": "a fossil serpula shell [n -S]\n",
  "SERPULITES": "SERPULITE, a fossil serpula shell [n]\n",
  "SERR": "to press close, also SERRE [v -ED, -ING, -S]\n",
  "SERRA": "(Latin) a serrated organ, structure, or edge [n SERRAS or SERRAE]\n",
  "SERRADELLA": "a species of clover grown as fodder, also SERRADILLA [n -S]\n",
  "SERRADELLAS": "SERRADELLA, a species of clover grown as fodder, also SERRADILLA [n]\n",
  "SERRADILLA": "a species of clover grown as fodder, also SERRADELLA [n -S]\n",
  "SERRADILLAS": "SERRADILLA, a species of clover grown as fodder, also SERRADELLA [n]\n",
  "SERRAE": "SERRA, (Latin) a serrated organ, structure, or edge [n]\n",
  "SERRAN": "a fish of the genus Serranus, that includes sea bass and grouper [n -S]\n",
  "SERRANID": "a group of fish, sea basses and groupers, also SERRANOID [n -S]\n",
  "SERRANIDS": "SERRANID, a group of fish, sea basses and groupers, also SERRANOID [n]\n",
  "SERRANO": "(Spanish) a Mexican hot pepper [n -S]\n",
  "SERRANOID": "any of a group of fish including sea basses and groupers, also SERRANID [n -S]\n",
  "SERRANOIDS": "SERRANOID, any of a group of fish including sea basses and groupers, also SERRANID [n]\n",
  "SERRANOS": "SERRANO, (Spanish) a Mexican hot pepper [n]\n",
  "SERRANS": "SERRAN, a fish of the genus Serranus, that includes sea bass and grouper [n]\n",
  "SERRAS": "SERRA, (Latin) a serrated organ, structure, or edge [n]\n",
  "SERRASALMO": "a fish of the piranha genus [n -S]\n",
  "SERRASALMOS": "SERRASALMO, a fish of the piranha genus [n]\n",
  "SERRATE": "to supply with toothlike projections [v SERRATED, SERRATING, SERRATES]\n",
  "SERRATED": "SERRATE, to supply with toothlike projections [v]\n",
  "SERRATES": "SERRATE, to supply with toothlike projections [v]\n",
  "SERRATI": "SERRATUS, (Latin) a muscle of the thorax [n]\n",
  "SERRATING": "SERRATE, to supply with toothlike projections [v]\n",
  "SERRATION": "the state of being saw-edged [n -S]\n",
  "SERRATIONS": "SERRATION, the state of being saw-edged [n]\n",
  "SERRATIROSTRAL": "saw-billed [adj]\n",
  "SERRATULATE": "minutely serrate [adj]\n",
  "SERRATURE": "a notching, like that between the teeth of a saw [n -S]\n",
  "SERRATURES": "SERRATURE, a notching, like that between the teeth of a saw [n]\n",
  "SERRATUS": "(Latin) a muscle of the thorax [n SERRATUSES or SERRATI]\n",
  "SERRATUSES": "SERRATUS, (Latin) a muscle of the thorax [n]\n",
  "SERRE": "to press close, also SERR [v SERRED, SERRING, SERRES]\n",
  "SERRED": "SERR, to press close, also SERRE [v]\n",
  "SERREFILE": "(French) a file of officers or men appointed to ride at the rear rank of a squadron, also SERAFILE [n -S]\n",
  "SERREFILES": "SERREFILE, (French) a file of officers or men appointed to ride at the rear rank of a squadron, also SERAFILE [n]\n",
  "SERRES": "SERRE, to press close, also SERR [v]\n",
  "SERRICORN": "a kind of beetle with serrate antennae [n -S]\n",
  "SERRICORNS": "SERRICORN, a kind of beetle with serrate antennae [n]\n",
  "SERRIED": "SERRY, to press close, close the ranks of, also SERR, SERRE [v]\n",
  "SERRIEDLY": "SERRIED, SERRY, to press close, close the ranks of, also SERR, SERRE [adv]\n",
  "SERRIEDNESS": "the state of being serried [n -ES]\n",
  "SERRIEDNESSES": "SERRIEDNESS, the state of being serried [n]\n",
  "SERRIES": "SERRY, to press close, close the ranks of, also SERR, SERRE [v]\n",
  "SERRIFORM": "resembling a notched or sawlike edge [adj]\n",
  "SERRING": "SERR, to press close, also SERRE [v]\n",
  "SERRS": "SERR, to press close, also SERRE [v]\n",
  "SERRULATE": "finely serrate; having very minute teeth, also SERRULATED [adj]\n",
  "SERRULATED": "finely serrate; having very minute teeth, also SERRULATE [adj]\n",
  "SERRULATION": "the state of being serrulate, sawlike [n -S]\n",
  "SERRULATIONS": "SERRULATION, the state of being serrulate, sawlike [n]\n",
  "SERRY": "to press close, close the ranks of, also SERR, SERRE [v SERRIED, SERRYING, SERRIES]\n",
  "SERRYING": "SERRY, to press close, close the ranks of, also SERR, SERRE [v]\n",
  "SERS": "SER, an Indian unit of weight [n]\n",
  "SERTULARIAN": "a colonial hydroid with polyps arranged in pairs [n -S]\n",
  "SERTULARIANS": "SERTULARIAN, a colonial hydroid with polyps arranged in pairs [n]\n",
  "SERUEWE": "(Spenser) to surview, also SERVEWE [v SERUEWED, SERUEWING, SERUEWES]\n",
  "SERUEWED": "SERUEWE, (Spenser) to surview, also SERVEWE [v]\n",
  "SERUEWES": "SERUEWE, (Spenser) to surview, also SERVEWE [v]\n",
  "SERUEWING": "SERUEWE, (Spenser) to surview, also SERVEWE [v]\n",
  "SERUM": "(Latin) the watery portion of whole blood [n SERUMS or SERA]\n",
  "SERUMAL": "of or like serum [adj]\n",
  "SERUMS": "SERUM, (Latin) the watery portion of whole blood [n]\n",
  "SERVABLE": "capable of being served, also SERVEABLE [adj]\n",
  "SERVAL": "(Portuguese) a long-legged African wildcat with a yellowish coat and black spots [n -S]\n",
  "SERVALS": "SERVAL, (Portuguese) a long-legged African wildcat with a yellowish coat and black spots [n]\n",
  "SERVANT": "someone who is hired to perform service [n -S] / to act as servant [v -ED, -ING, -S]\n",
  "SERVANTED": "SERVANT, to act as servant [v]\n",
  "SERVANTHOOD": "the state of being a servant [n -S]\n",
  "SERVANTHOODS": "SERVANTHOOD, the state of being a servant [n]\n",
  "SERVANTING": "SERVANT, to act as servant [v]\n",
  "SERVANTLESS": "without servants [adj]\n",
  "SERVANTRIES": "SERVANTRY, a body of servants; servants, collectively [n]\n",
  "SERVANTRY": "a body of servants; servants, collectively [n SERVANTRIES]\n",
  "SERVANTS": "SERVANT, to act as servant [v]\n",
  "SERVANTSHIP": "the state of being a servant [n -S]\n",
  "SERVANTSHIPS": "SERVANTSHIP, the state of being a servant [n]\n",
  "SERVE": "to work for [v SERVED, SERVING, SERVES]\n",
  "SERVEABLE": "capable of being served, also SERVABLE [adj]\n",
  "SERVED": "SERVE, to work for [v]\n",
  "SERVER": "one who serves another [n -S]\n",
  "SERVERIES": "SERVERY, a room or rooms adjoining a dining-room, from which the food is served [n]\n",
  "SERVERS": "SERVER, one who serves another [n]\n",
  "SERVERY": "a room or rooms adjoining a dining-room, from which the food is served [n SERVERIES]\n",
  "SERVES": "SERVE, to work for [v]\n",
  "SERVEWARE": "items on or from which food etc. is served, e.g. bowls, butter dishes, shakers, creamers [n -S]\n",
  "SERVEWARES": "SERVEWARE, items on or from which food etc. is served, e.g. bowls, butter dishes, shakers, creamers [n]\n",
  "SERVEWE": "(Spenser) to surview, also SERUEWE [v SERVEWED, SERVEWING, SERVEWES]\n",
  "SERVEWED": "SERVEWE, (Spenser) to surview, also SERUEWE [v]\n",
  "SERVEWES": "SERVEWE, (Spenser) to surview, also SERUEWE [v]\n",
  "SERVEWING": "SERVEWE, (Spenser) to surview, also SERUEWE [v]\n",
  "SERVICE": "to repair [v SERVICED, SERVICING, SERVICES]\n",
  "SERVICEABILITY": "the state of being serviceable [n]\n",
  "SERVICEABLE": "able or willing to serve [adj SERVICEABLY]\n",
  "SERVICEABLENESS": "the state of being serviceable [n]\n",
  "SERVICEABLY": "SERVICEABLE, able or willing to serve [adv]\n",
  "SERVICEBERRIES": "SERVICEBERRY, the fruit of a North American tree of genus Amelanchier [n]\n",
  "SERVICEBERRY": "the fruit of a North American tree of genus Amelanchier [n SERVICEBERRIES]\n",
  "SERVICED": "SERVICE, to repair [v]\n",
  "SERVICELESS": "without service [adj]\n",
  "SERVICEMAN": "a male member of the armed forces [n SERVICEMEN]\n",
  "SERVICEMEN": "SERVICEMAN, a male member of the armed forces [n]\n",
  "SERVICER": "one who services [n -S]\n",
  "SERVICERS": "SERVICER, one who services [n]\n",
  "SERVICES": "SERVICE, to repair [v]\n",
  "SERVICEWOMAN": "a woman who is a member of the armed forces [n SERVICEWOMEN]\n",
  "SERVICEWOMEN": "SERVICEWOMAN, a woman who is a member of the armed forces [n]\n",
  "SERVICING": "the act of maintaining e.g. a vehicle [n -S]\n",
  "SERVICINGS": "SERVICING, the act of maintaining e.g. a vehicle [n]\n",
  "SERVIENT": "subordinate [adj]\n",
  "SERVIETTE": "(French) a table-napkin, esp. a paper one [n -S]\n",
  "SERVIETTES": "SERVIETTE, (French) a table-napkin, esp. a paper one [n]\n",
  "SERVILE": "slavish, fawning [adj SERVILELY] / a servile person [n -S]\n",
  "SERVILELY": "SERVILE, slavish, fawning [adv]\n",
  "SERVILENESS": "the state of being servile [n -ES]\n",
  "SERVILENESSES": "SERVILENESS, the state of being servile [n]\n",
  "SERVILES": "SERVILE, a servile person [n]\n",
  "SERVILISM": "system of slavery or serfdom [n -S]\n",
  "SERVILISMS": "SERVILISM, system of slavery or serfdom [n]\n",
  "SERVILITIES": "SERVILITY, the state of being servile [n]\n",
  "SERVILITY": "the state of being servile [n SERVILITIES]\n",
  "SERVING": "a portion of food [n -S]\n",
  "SERVINGS": "SERVING, a portion of food [n]\n",
  "SERVITOR": "one who serves; a clerk or assistant [n -S]\n",
  "SERVITORIAL": "of or like a servitor [adj]\n",
  "SERVITORS": "SERVITOR, one who serves; a clerk or assistant [n]\n",
  "SERVITORSHIP": "the office of servitor [n -S]\n",
  "SERVITORSHIPS": "SERVITORSHIP, the office of servitor [n]\n",
  "SERVITRESS": "a female servitor [n -ES]\n",
  "SERVITRESSES": "SERVITRESS, a female servitor [n]\n",
  "SERVITUDE": "the state of being a slave, subjection [n -S]\n",
  "SERVITUDES": "SERVITUDE, the state of being a slave, subjection [n]\n",
  "SERVLET": "a small program running on a server, accessing and delivering data [n -S]\n",
  "SERVLETS": "SERVLET, a small program running on a server, accessing and delivering data [n]\n",
  "SERVO": "(Australian slang) a service station [n -S]\n",
  "SERVOCONTROL": "in aircraft, a reinforcing mechanism for the pilot's effort, usually a small auxiliary aerofoil [n -S]\n",
  "SERVOCONTROLS": "SERVOCONTROL, in aircraft, a reinforcing mechanism for the pilot's effort, usually a small auxiliary aerofoil [n]\n",
  "SERVOMECHANICAL": "of or like a servomechanism [adj]\n",
  "SERVOMECHANISM": "an automatic device for controlling large amounts of power by means of very small amounts of power and automatically correcting the performance of a mechanism [n -S]\n",
  "SERVOMECHANISMS": "SERVOMECHANISM, an automatic device for controlling large amounts of power by means of very small amounts of power and automatically correcting the performance of a mechanism [n]\n",
  "SERVOMOTOR": "a motor using a servomechanism [n -S]\n",
  "SERVOMOTORS": "SERVOMOTOR, a motor using a servomechanism [n]\n",
  "SERVOS": "SERVO, (Australian slang) a service station [n]\n",
  "SERVQUAL": "a marketing concept of high quality service [n -S]\n",
  "SERVQUALS": "SERVQUAL, a marketing concept of high quality service [n]\n",
  "SESAME": "(Arabic) a plant native to SE Asia, producing seeds used as food and yielding an edible oil [n -S]\n",
  "SESAMES": "SESAME, (Arabic) a plant native to SE Asia, producing seeds used as food and yielding an edible oil [n]\n",
  "SESAMOID": "shaped like a sesame seed [adj] / a small rounded bone formed in the substance of a tendon, e.g. in the flexor tendon of the big toe [n -S]\n",
  "SESAMOIDS": "SESAMOID, a small rounded bone formed in the substance of a tendon, e.g. in the flexor tendon of the big toe [n]\n",
  "SESE": "(Shakespeare) enough said, also CAESE, CEAS, SESEY, SESSA [interj]\n",
  "SESELI": "(Greek) a kind of umbelliferous plant, sweet cicely [n -S]\n",
  "SESELIS": "SESELI, (Greek) a kind of umbelliferous plant, sweet cicely [n]\n",
  "SESEY": "(Shakespeare) enough said, also CAESE, CEAS, SESE, SESSA [interj]\n",
  "SESH": "(short for) session [n -ES]\n",
  "SESHES": "SESH, (short for) session [n]\n",
  "SESQUIALTER": "a mixture stop on an organ [n -S]\n",
  "SESQUIALTERA": "a perfect fifth; three notes against two; an organ stop giving the root, the twelfth and the tierce [n -S]\n",
  "SESQUIALTERAS": "SESQUIALTERA, a perfect fifth; three notes against two; an organ stop giving the root, the twelfth and the tierce [n]\n",
  "SESQUIALTERS": "SESQUIALTER, a mixture stop on an organ [n]\n",
  "SESQUICARBONATE": "a salt that is neither a simple normal carbonate nor a simple bicarbonate but often a combination of the two [n]\n",
  "SESQUICENTENARY": "a hundred and fiftieth anniversary [n]\n",
  "SESQUIOXIDE": "an oxide with three atoms of oxygen to two of the other constituent [n -S]\n",
  "SESQUIOXIDES": "SESQUIOXIDE, an oxide with three atoms of oxygen to two of the other constituent [n]\n",
  "SESQUIPEDAL": "tending to use long or cumbersome words, also SESQUIPEDALIAN [adj] / a polysyllabic word [n -S]\n",
  "SESQUIPEDALIAN": "tending to use long or cumbersome words [adj] / a polysyllabic word, also SESQUIPEDAL [n -S]\n",
  "SESQUIPEDALIANS": "SESQUIPEDALIAN, a polysyllabic word, also SESQUIPEDAL [n]\n",
  "SESQUIPEDALITY": "the practice of using long words [n]\n",
  "SESQUIPEDALS": "SESQUIPEDAL, a polysyllabic word [n]\n",
  "SESQUIPLICATE": "of or as the square roots of cubes [adj]\n",
  "SESQUISULPHIDE": "a compound with three atoms of sulphur to two of the other element or radical [n -S]\n",
  "SESQUISULPHIDES": "SESQUISULPHIDE, a compound with three atoms of sulphur to two of the other element or radical [n]\n",
  "SESQUITERPENE": "any of a group of terpene derivatives [n -S]\n",
  "SESQUITERPENES": "SESQUITERPENE, any of a group of terpene derivatives [n]\n",
  "SESQUITERTIA": "a perfect fourth; a rhythm of three notes against four [n -S]\n",
  "SESQUITERTIAS": "SESQUITERTIA, a perfect fourth; a rhythm of three notes against four [n]\n",
  "SESS": "a tax, a local rate for the maintenance of soldiers [n -ES] / to assess (how much tax is owed), also CESS [v -ED, -ING, -ES]\n",
  "SESSA": "(Shakespeare) enough said, also CAESE, CEAS, SESE, SESEY [interj]\n",
  "SESSED": "SESS, to assess (how much tax is owed), also CESS [v]\n",
  "SESSES": "SESS, to assess (how much tax is owed), also CESS [v]\n",
  "SESSILE": "stalkless, permanently attached [adj]\n",
  "SESSILITIES": "SESSILITY, the quality of being sessile [n]\n",
  "SESSILITY": "the quality of being sessile [n SESSILITIES]\n",
  "SESSING": "SESS, to assess (how much tax is owed), also CESS [v]\n",
  "SESSION": "a period of time spent on any one activity [n -S]\n",
  "SESSIONAL": "of or pertaining to a session or sessions [adj SESSIONALLY]\n",
  "SESSIONALLY": "SESSIONAL, of or pertaining to a session or sessions [adv]\n",
  "SESSIONS": "SESSION, a period of time spent on any one activity [n]\n",
  "SESSPOOL": "a covered well or pit for sewage, also CESSPOOL [n -S]\n",
  "SESSPOOLS": "SESSPOOL, a covered well or pit for sewage, also CESSPOOL [n]\n",
  "SESTERCE": "(Latin) a Roman coin or denomination of money, in value the fourth part of a denarius, also SESTERTIUS [n -S]\n",
  "SESTERCES": "SESTERCE, (Latin) a Roman coin or denomination of money, in value the fourth part of a denarius, also SESTERTIUS [n]\n",
  "SESTERTIA": "SESTERTIUM, (Latin) a Roman money of account equal to 1000 sesterces [n]\n",
  "SESTERTII": "SESTERTIUS, (Latin) a Roman coin or denomination of money, in value the fourth part of a denarius, also SESTERCE [n]\n",
  "SESTERTIUM": "(Latin) a Roman money of account equal to 1000 sesterces [n SESTERTIA]\n",
  "SESTERTIUS": "(Latin) a Roman coin or denomination of money, in value the fourth part of a denarius, also SESTERCE [n SESTERTII]\n",
  "SESTET": "a piece of music composed for six voices or six instruments, also SESTETT, SESTETTE, SESTETTO, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n -S]\n",
  "SESTETS": "SESTET, a piece of music composed for six voices or six instruments, also SESTETT, SESTETTE, SESTETTO, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n]\n",
  "SESTETT": "a piece of music composed for six voices or six instruments, also SESTET, SESTETTE, SESTETTO, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n -S]\n",
  "SESTETTE": "a group of six, a piece of music for six performers, also SESTET, SESTETT, SESTETTO, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n -S]\n",
  "SESTETTES": "SESTETTE, a group of six, a piece of music for six performers, also SESTET, SESTETT, SESTETTO, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n]\n",
  "SESTETTO": "a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n -S]\n",
  "SESTETTOS": "SESTETTO, a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n]\n",
  "SESTETTS": "SESTETT, a piece of music composed for six voices or six instruments, also SESTET, SESTETTE, SESTETTO, SEXTET, SEXTETT, SEXTETTE, SEXTUOR [n]\n",
  "SESTINA": "(Italian) an old verse-form of six six-lined stanzas, also SESTINE, SEXTAIN [n -S]\n",
  "SESTINAS": "SESTINA, (Italian) an old verse-form of six six-lined stanzas, also SESTINE, SEXTAIN [n]\n",
  "SESTINE": "an old verse-form of six six-lined stanzas, also SESTINA, SEXTAIN [n -S]\n",
  "SESTINES": "SESTINE, an old verse-form of six six-lined stanzas, also SESTINA, SEXTAIN [n]\n",
  "SESTON": "(Greek) a very small plankton organism [n -S]\n",
  "SESTONS": "SESTON, (Greek) a very small plankton organism [n]\n",
  "SET": "to put in a particular position [v SET, SETTING, SETS]\n",
  "SETA": "(Latin) a coarse, stiff hair [n SETAE]\n",
  "SETACEOUS": "set with, or consisting of, bristles [adj SETACEOUSLY]\n",
  "SETACEOUSLY": "SETACEOUS, set with, or consisting of, bristles [adv]\n",
  "SETAE": "SETA, (Latin) a coarse, stiff hair [n]\n",
  "SETAL": "like a bristle [adj]\n",
  "SETBACK": "a defeat [n -S]\n",
  "SETBACKS": "SETBACK, a defeat [n]\n",
  "SETENANT": "(French) in philately, two or more stamps joined together in an unsevered block of which at least one differs in design and value from the others [n -S]\n",
  "SETENANTS": "SETENANT, (French) in philately, two or more stamps joined together in an unsevered block of which at least one differs in design and value from the others [n]\n",
  "SETIFEROUS": "bearing bristles, also SETIGEROUS [adj]\n",
  "SETIFORM": "having the form of a seta [adj]\n",
  "SETIGEROUS": "bearing bristles, also SETIFEROUS [adj]\n",
  "SETLINE": "a strong fishing line between buoys [n -S]\n",
  "SETLINES": "SETLINE, a strong fishing line between buoys [n]\n",
  "SETNESS": "the state of being set [n -ES]\n",
  "SETNESSES": "SETNESS, the state of being set [n]\n",
  "SETOFF": "something that offsets something else [n -S]\n",
  "SETOFFS": "SETOFF, something that offsets something else [n]\n",
  "SETON": "a thread or the like passed through the skin as a counterirritant or for drainage [n -S]\n",
  "SETONS": "SETON, a thread or the like passed through the skin as a counterirritant or for drainage [n]\n",
  "SETOSE": "thickly set with bristles or bristly hairs, also SETOUS [adj]\n",
  "SETOUS": "thickly set with bristles or bristly hairs, also SETOSE [adj]\n",
  "SETOUT": "a display [n -S]\n",
  "SETOUTS": "SETOUT, a display [n]\n",
  "SETS": "SET, to put in a particular position [v]\n",
  "SETSCREW": "a type of screw [n -S]\n",
  "SETSCREWS": "SETSCREW, a type of screw [n]\n",
  "SETT": "a badger's home, also CETE [n -S]\n",
  "SETTEE": "a long seat with a high back [n -S]\n",
  "SETTEES": "SETTEE, a long seat with a high back [n]\n",
  "SETTER": "to treat with a seton of setterwort root [v -ED, -ING, -S]\n",
  "SETTERED": "SETTER, to treat with a seton of setterwort root [v]\n",
  "SETTERING": "SETTER, to treat with a seton of setterwort root [v]\n",
  "SETTERS": "SETTER, to treat with a seton of setterwort root [v]\n",
  "SETTERWORT": "the bear's-foot hellebore, so called because the root was used in settering, or inserting setons into the dewlaps of cattle [n -S]\n",
  "SETTERWORTS": "SETTERWORT, the bear's-foot hellebore, so called because the root was used in settering, or inserting setons into the dewlaps of cattle [n]\n",
  "SETTING": "the scenery used in a theatre production [n -S]\n",
  "SETTINGS": "SETTING, the scenery used in a theatre production [n]\n",
  "SETTLE": "to place in a desired order [v SETTLED, SETTLING, SETTLES]\n",
  "SETTLEABLE": "capable of being settled [adj]\n",
  "SETTLED": "SETTLE, to place in a desired order [v]\n",
  "SETTLEDNESS": "the state of being settled [n -ES]\n",
  "SETTLEDNESSES": "SETTLEDNESS, the state of being settled [n]\n",
  "SETTLEMENT": "the act of settling [n -S]\n",
  "SETTLEMENTS": "SETTLEMENT, the act of settling [n]\n",
  "SETTLER": "one who settles [n -S]\n",
  "SETTLERS": "SETTLER, one who settles [n]\n",
  "SETTLES": "SETTLE, to place in a desired order [v]\n",
  "SETTLING": "the residue in the bottom of a bottle [n -S]\n",
  "SETTLINGS": "SETTLING, the residue in the bottom of a bottle [n]\n",
  "SETTLOR": "one who makes a legal settlement [n -S]\n",
  "SETTLORS": "SETTLOR, one who makes a legal settlement [n]\n",
  "SETTS": "SETT, a badger's home, also CETE [n]\n",
  "SETUALE": "(Spenser) valerian, also CETYWALL, SETWALL [n -S]\n",
  "SETUALES": "SETUALE, (Spenser) valerian, also CETYWALL, SETWALL [n]\n",
  "SETULE": "a small bristle [n -S]\n",
  "SETULES": "SETULE, a small bristle [n]\n",
  "SETULOSE": "covered with setae, small bristles, also SETULOUS [adj]\n",
  "SETULOUS": "having small bristles or setules, also SETULOSE [adj]\n",
  "SETUP": "the way something is arranged [n -S]\n",
  "SETUPS": "SETUP, the way something is arranged [n]\n",
  "SETWALL": "valerian, a plant formerly valued for its restorative qualities, also CETYWALL, SETUALE [n -S]\n",
  "SETWALLS": "SETWALL, valerian, a plant formerly valued for its restorative qualities, also CETYWALL, SETUALE [n]\n",
  "SEV": "(Hindi) an Indian food of deep-fried strands of flour [n -S]\n",
  "SEVEN": "a number [n -S]\n",
  "SEVENFOLD": "multiplied by seven [adj]\n",
  "SEVENISH": "about seven [adj]\n",
  "SEVENPENCE": "a coin worth seven pence [n -S]\n",
  "SEVENPENCES": "SEVENPENCE, a coin worth seven pence [n]\n",
  "SEVENPENNIES": "SEVENPENNY, a coin worth seven pennies [n]\n",
  "SEVENPENNY": "a coin worth seven pennies [n SEVENPENNIES]\n",
  "SEVENS": "SEVEN, a number [n]\n",
  "SEVENTEEN": "a number, ten and seven [n -S]\n",
  "SEVENTEENS": "SEVENTEEN, a number, ten and seven [n]\n",
  "SEVENTEENTH": "number seventeen in sequence [adj SEVENTEENTHLY] / a seventeenth part [n -S]\n",
  "SEVENTEENTHLY": "SEVENTEENTH, number seventeen in sequence [adv]\n",
  "SEVENTEENTHS": "SEVENTEENTH, a seventeenth part [n]\n",
  "SEVENTH": "seventh in sequence [adj SEVENTHLY] / one of seven equal parts [n -S]\n",
  "SEVENTHLY": "SEVENTH, seventh in sequence [adv]\n",
  "SEVENTHS": "SEVENTH, one of seven equal parts [n]\n",
  "SEVENTIES": "SEVENTY, a number [n]\n",
  "SEVENTIETH": "a seventieth part of [n -S]\n",
  "SEVENTIETHS": "SEVENTIETH, a seventieth part of [n]\n",
  "SEVENTY": "a number [n SEVENTIES]\n",
  "SEVER": "to divide or cut into parts [v -ED, -ING, -S]\n",
  "SEVERABILITIES": "SEVERABILITY, the state of being severable [n]\n",
  "SEVERABILITY": "the state of being severable [n SEVERABILITIES]\n",
  "SEVERABLE": "that can be severed [adj]\n",
  "SEVERAL": "various [adj SEVERALLY] / privately owned land [n -S]\n",
  "SEVERALFOLD": "having several parts or aspects [adj]\n",
  "SEVERALLY": "SEVERAL, various [adv]\n",
  "SEVERALS": "SEVERAL, privately owned land [n]\n",
  "SEVERALTIES": "SEVERALTY, separateness; separate ownership of property [n]\n",
  "SEVERALTY": "separateness; separate ownership of property [n SEVERALTIES]\n",
  "SEVERANCE": "the act of severing [n -S]\n",
  "SEVERANCES": "SEVERANCE, the act of severing [n]\n",
  "SEVERE": "strict, harsh [adj SEVERER, SEVEREST, SEVERELY]\n",
  "SEVERED": "SEVER, to divide or cut into parts [v]\n",
  "SEVERELY": "SEVERE, strict, harsh [adv]\n",
  "SEVERENESS": "severity [n -ES]\n",
  "SEVERENESSES": "SEVERENESS, severity [n]\n",
  "SEVERER": "SEVERE, strict, harsh [adj]\n",
  "SEVEREST": "SEVERE, strict, harsh [adj]\n",
  "SEVERIES": "SEVERY, a compartment of vaulting [n]\n",
  "SEVERING": "SEVER, to divide or cut into parts [v]\n",
  "SEVERITIES": "SEVERITY, the state of being severe [n]\n",
  "SEVERITY": "the state of being severe [n SEVERITIES]\n",
  "SEVERS": "SEVER, to divide or cut into parts [v]\n",
  "SEVERY": "a compartment of vaulting [n SEVERIES]\n",
  "SEVICHE": "(Spanish) in Mexican cookery, raw fish marinated in lime juice and served as an hors d'oeuvre, also CEVICHE [n -S]\n",
  "SEVICHES": "SEVICHE, (Spanish) in Mexican cookery, raw fish marinated in lime juice and served as an hors d'oeuvre, also CEVICHE [n]\n",
  "SEVRUGA": "(Russian) a species of sturgeon found in the Black Sea [n -S]\n",
  "SEVRUGAS": "SEVRUGA, (Russian) a species of sturgeon found in the Black Sea [n]\n",
  "SEVS": "SEV, (Hindi) an Indian food of deep-fried strands of flour [n]\n",
  "SEW": "to mend or fasten with a needle and thread [v SEWED, SEWN, SEWING, SEWS]\n",
  "SEWABILITIES": "SEWABILITY, the ability to be sewed [n]\n",
  "SEWABILITY": "the ability to be sewed [n SEWABILITIES]\n",
  "SEWABLE": "able to be sewn [adj]\n",
  "SEWAGE": "the waste matter carried off by sewers, also SEWERAGE [n -S]\n",
  "SEWAGES": "SEWAGE, the waste matter carried off by sewers, also SEWERAGE [n]\n",
  "SEWAN": "(Native American) shell beads used by Algonquin Indians as money, also SEAWAN, SEAWANT [n -S]\n",
  "SEWANS": "SEWAN, (Native American) shell beads used by Algonquin Indians as money, also SEAWAN, SEAWANT [n]\n",
  "SEWAR": "a medieval servant who supervised the serving of meals [n -S]\n",
  "SEWARS": "SEWAR, a medieval servant who supervised the serving of meals [n]\n",
  "SEWED": "SEW, to mend or fasten with a needle and thread [v]\n",
  "SEWEL": "a scarecrow, a device to scare away deer, also SHEWEL [n -S]\n",
  "SEWELLEL": "(Native American) the mountain beaver, a squirrel-like burrowing rodent of coastal regions of NW America [n -S]\n",
  "SEWELLELS": "SEWELLEL, (Native American) the mountain beaver, a squirrel-like burrowing rodent of coastal regions of NW America [n]\n",
  "SEWELS": "SEWEL, a scarecrow, a device to scare away deer, also SHEWEL [n]\n",
  "SEWEN": "the Welsh or Irish name for the seatrout grilse, also SEWIN [n -S]\n",
  "SEWENS": "SEWEN, the Welsh or Irish name for the seatrout grilse, also SEWIN [n]\n",
  "SEWER": "to clean or maintain underground conduits for waste [v -ED, -ING, -S]\n",
  "SEWERAGE": "the waste matter carried off by sewers, also SEWAGE [n -S]\n",
  "SEWERAGES": "SEWERAGE, the waste matter carried off by sewers, also SEWAGE [n]\n",
  "SEWERED": "SEWER, to clean or maintain underground conduits for waste [v]\n",
  "SEWERING": "the provision of sewers [n -S]\n",
  "SEWERINGS": "SEWERING, the provision of sewers [n]\n",
  "SEWERLESS": "without a sewer [adj]\n",
  "SEWERLIKE": "like a sewer [adj]\n",
  "SEWERS": "SEWER, to clean or maintain underground conduits for waste [v]\n",
  "SEWIN": "the Welsh or Irish name for the seatrout grilse, also SEWEN [n -S]\n",
  "SEWING": "material that has been or is to be sewn [n -S]\n",
  "SEWINGS": "SEWING, material that has been or is to be sewn [n]\n",
  "SEWINS": "SEWIN, the Welsh or Irish name for the seatrout grilse, also SEWEN [n]\n",
  "SEWN": "SEW, to mend or fasten with a needle and thread [v]\n",
  "SEWS": "SEW, to mend or fasten with a needle and thread [v]\n",
  "SEX": "to assess organisms according to reproductive functions [v -ED, -ING, -ES]\n",
  "SEXAGENARIAN": "aged between sixty and seventy years old [adj] / a person aged between fifty and sixty [n -S]\n",
  "SEXAGENARIANS": "SEXAGENARIAN, a person aged between fifty and sixty [n]\n",
  "SEXAGENARIES": "SEXAGENARY, someone in their sixties [n]\n",
  "SEXAGENARY": "of, containing, based on, sixty [adj] / someone in their sixties [n SEXAGENARIES]\n",
  "SEXAGESIMAL": "relating to, or based on, sixty [adj SEXAGESIMALLY] / a sexagesimal fraction [n -S]\n",
  "SEXAGESIMALLY": "SEXAGESIMAL, relating to, or based on, sixty [adv]\n",
  "SEXAGESIMALS": "SEXAGESIMAL, a sexagesimal fraction [n]\n",
  "SEXAHOLIC": "someone addicted to sex [n -S]\n",
  "SEXAHOLICS": "SEXAHOLIC, someone addicted to sex [n]\n",
  "SEXANGULAR": "hexagonal [adj SEXANGULARLY]\n",
  "SEXANGULARLY": "SEXANGULAR, hexagonal [adv]\n",
  "SEXAVALENT": "hexavalent [adj]\n",
  "SEXCAPADE": "a sexual escapade [n -S]\n",
  "SEXCAPADES": "SEXCAPADE, a sexual escapade [n]\n",
  "SEXCENTENARIES": "SEXCENTENARY, an anniversary recurring every six hundred years [n]\n",
  "SEXCENTENARY": "an anniversary recurring every six hundred years [n SEXCENTENARIES]\n",
  "SEXDECILLION": "ten to the power of 51 [n -S]\n",
  "SEXDECILLIONS": "SEXDECILLION, ten to the power of 51 [n]\n",
  "SEXED": "SEX, to assess organisms according to reproductive functions [v]\n",
  "SEXENNIAL": "lasting six years, or happening once in six years [adj SEXENNIALLY] / a six-year anniversary [n -S]\n",
  "SEXENNIALLY": "SEXENNIAL, lasting six years, or happening once in six years [adv]\n",
  "SEXENNIALS": "SEXENNIAL, a six-year anniversary [n]\n",
  "SEXER": "one who sexes fowls [n -S]\n",
  "SEXERCISE": "sexual activity regarded as a way of keeping fit [n -S]\n",
  "SEXERCISES": "SEXERCISE, sexual activity regarded as a way of keeping fit [n]\n",
  "SEXERS": "SEXER, one who sexes fowls [n]\n",
  "SEXES": "SEX, to assess organisms according to reproductive functions [v]\n",
  "SEXFID": "cleft in six [adj]\n",
  "SEXFOIL": "an ornamental design having six leaves or petals radiating from a common centre [n -S]\n",
  "SEXFOILS": "SEXFOIL, an ornamental design having six leaves or petals radiating from a common centre [n]\n",
  "SEXIER": "SEXY, arousing sexual desire [adj]\n",
  "SEXIEST": "SEXY, arousing sexual desire [adj]\n",
  "SEXILY": "SEXY, arousing sexual desire [adv]\n",
  "SEXINESS": "the state of being sexy [n -ES]\n",
  "SEXINESSES": "SEXINESS, the state of being sexy [n]\n",
  "SEXING": "as in nuclear sexing, testing a person's sex by examining cells taken from inside the cheek [n -S]\n",
  "SEXINGS": "SEXING, as in nuclear sexing, testing a person's sex by examining cells taken from inside the cheek [n]\n",
  "SEXISM": "prejudice or discrimination against one sex [n -S]\n",
  "SEXISMS": "SEXISM, prejudice or discrimination against one sex [n]\n",
  "SEXIST": "one who practices sexism [n -S]\n",
  "SEXISTS": "SEXIST, one who practices sexism [n]\n",
  "SEXIVALENT": "of a valency of six, also SEXVALENT [adj]\n",
  "SEXLESS": "lacking sexual characteristics [adj SEXLESSLY]\n",
  "SEXLESSLY": "SEXLESS, lacking sexual characteristics [adv]\n",
  "SEXLESSNESS": "the state of being sexless [n -ES]\n",
  "SEXLESSNESSES": "SEXLESSNESS, the state of being sexless [n]\n",
  "SEXLINKED": "of a gene, found on a sex chromosome [adj]\n",
  "SEXLOCULAR": "having six cells for seeds; as, a sexlocular pericarp [adj]\n",
  "SEXOLOGIC": "relating to sexology [adj]\n",
  "SEXOLOGICAL": "relating to sexology, the study of sexual behaviour [adj]\n",
  "SEXOLOGIES": "SEXOLOGY, the study of human sexual behaviour [n]\n",
  "SEXOLOGIST": "an expert on sexual behaviour [n -S]\n",
  "SEXOLOGISTS": "SEXOLOGIST, an expert on sexual behaviour [n]\n",
  "SEXOLOGY": "the study of human sexual behaviour [n SEXOLOGIES]\n",
  "SEXPARTITE": "in six parts [adj]\n",
  "SEXPERT": "an expert in sexual behaviour [n -S]\n",
  "SEXPERTS": "SEXPERT, an expert in sexual behaviour [n]\n",
  "SEXPLOITATION": "the exploitation of sex in the media and esp. in film [n -S]\n",
  "SEXPLOITATIONS": "SEXPLOITATION, the exploitation of sex in the media and esp. in film [n]\n",
  "SEXPOT": "a sexually attractive woman [n -S]\n",
  "SEXPOTS": "SEXPOT, a sexually attractive woman [n]\n",
  "SEXT": "to send a text message of a sexual nature [v -ED, -ING, -S]\n",
  "SEXTAIN": "a stanza of six lines, also SESTINA, SESTINE [n -S]\n",
  "SEXTAINS": "SEXTAIN, a stanza of six lines, also SESTINA, SESTINE [n]\n",
  "SEXTAN": "a recurrent malarial fever [n -S]\n",
  "SEXTANS": "(Latin) a Roman gold coin [n -ES]\n",
  "SEXTANSES": "SEXTANS, (Latin) a Roman gold coin [n]\n",
  "SEXTANT": "a navigational instrument having a 60-degree arc, for measuring altitudes of stars and planets [n -S]\n",
  "SEXTANTAL": "relating to a sextant [adj]\n",
  "SEXTANTS": "SEXTANT, a navigational instrument having a 60-degree arc, for measuring altitudes of stars and planets [n]\n",
  "SEXTARII": "SEXTARIUS, (Latin) an ancient Roman unit of liquid measure [n]\n",
  "SEXTARIUS": "(Latin) an ancient Roman unit of liquid measure [n SEXTARII or SEXTARIUSES]\n",
  "SEXTARIUSES": "SEXTARIUS, (Latin) an ancient Roman unit of liquid measure [n]\n",
  "SEXTED": "SEXT, to send a text message of a sexual nature [v]\n",
  "SEXTET": "a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SESTETTO, SEXTETT, SEXTETTE, SEXTUOR [n -S]\n",
  "SEXTETS": "SEXTET, a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SESTETTO, SEXTETT, SEXTETTE, SEXTUOR [n]\n",
  "SEXTETT": "a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SESTETTO, SEXTET, SEXTETTE, SEXTUOR [n -S]\n",
  "SEXTETTE": "a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SESTETTO, SEXTET, SEXTETT, SEXTUOR [n -S]\n",
  "SEXTETTES": "SEXTETTE, a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SESTETTO, SEXTET, SEXTETT, SEXTUOR [n]\n",
  "SEXTETTS": "SEXTETT, a piece of music composed for six voices or six instruments, also SESTET, SESTETT, SESTETTE, SESTETTO, SEXTET, SEXTETTE, SEXTUOR [n]\n",
  "SEXTILE": "the aspect of two planets which are one-sixth of a circle (60 degrees) apart in the sky [n -S]\n",
  "SEXTILES": "SEXTILE, the aspect of two planets which are one-sixth of a circle (60 degrees) apart in the sky [n]\n",
  "SEXTILLION": "a thousand raised to the seventh power (10 to the 21) [n -S]\n",
  "SEXTILLIONS": "SEXTILLION, a thousand raised to the seventh power (10 to the 21) [n]\n",
  "SEXTILLIONTH": "the ordinal of a sextillion, a thousand raised to the seventh power [n -S]\n",
  "SEXTILLIONTHS": "SEXTILLIONTH, the ordinal of a sextillion, a thousand raised to the seventh power [n]\n",
  "SEXTING": "the act of sending text messages of a sexual nature [n -S]\n",
  "SEXTINGS": "SEXTING, the act of sending text messages of a sexual nature [n]\n",
  "SEXTO": "(Latin) a paper size, also SIXMO [n -S]\n",
  "SEXTODECIMO": "a book size 5 5/8 in. x 4 3/8 in. (abbreviated as 16mo.), also SIXTEENMO [n -S]\n",
  "SEXTODECIMOS": "SEXTODECIMO, a book size 5 5/8 in. x 4 3/8 in. (abbreviated as 16mo.), also SIXTEENMO [n]\n",
  "SEXTOLET": "a group of six notes performed in the time of four [n -S]\n",
  "SEXTOLETS": "SEXTOLET, a group of six notes performed in the time of four [n]\n",
  "SEXTON": "a church caretaker or bell-ringer [n -S]\n",
  "SEXTONESS": "a female sexton; a sexton's wife [n -ES]\n",
  "SEXTONESSES": "SEXTONESS, a female sexton; a sexton's wife [n]\n",
  "SEXTONS": "SEXTON, a church caretaker or bell-ringer [n]\n",
  "SEXTONSHIP": "the office of a sexton [n -S]\n",
  "SEXTONSHIPS": "SEXTONSHIP, the office of a sexton [n]\n",
  "SEXTOS": "SEXTO, (Latin) a paper size, also SIXMO [n]\n",
  "SEXTS": "SEXT, to send a text message of a sexual nature [v]\n",
  "SEXTUOR": "a group of six, also SEXTET, SEXTETTE [n -S]\n",
  "SEXTUORS": "SEXTUOR, a group of six, also SEXTET, SEXTETTE [n]\n",
  "SEXTUPLE": "sixfold [adj SEXTUPLY] / to multiply sixfold [v SEXTUPLED, SEXTUPLING, SEXTUPLES]\n",
  "SEXTUPLED": "SEXTUPLE, to multiply sixfold [v]\n",
  "SEXTUPLES": "SEXTUPLE, to multiply sixfold [v]\n",
  "SEXTUPLET": "one of six children born in a multiple birth [n -S]\n",
  "SEXTUPLETS": "SEXTUPLET, one of six children born in a multiple birth [n]\n",
  "SEXTUPLICATE": "to copy sixfold [v SEXTUPLICATED, SEXTUPLICATING, SEXTUPLICATES]\n",
  "SEXTUPLICATED": "SEXTUPLICATE, to copy sixfold [v]\n",
  "SEXTUPLICATES": "SEXTUPLICATE, to copy sixfold [v]\n",
  "SEXTUPLICATING": "SEXTUPLICATE, to copy sixfold [v]\n",
  "SEXTUPLIED": "SEXTUPLY, in Scots law, to offer a rejoinder [v]\n",
  "SEXTUPLIES": "SEXTUPLY, in Scots law, to offer a rejoinder [v]\n",
  "SEXTUPLING": "SEXTUPLE, to multiply sixfold [v]\n",
  "SEXTUPLY": "in Scots law, to offer a rejoinder [v SEXTUPLIED, SEXTUPLYING, SEXTUPLIES]\n",
  "SEXTUPLYING": "SEXTUPLY, in Scots law, to offer a rejoinder [v]\n",
  "SEXUAL": "pertaining to sex [adj SEXUALLY]\n",
  "SEXUALISATION": "the process of sexualising, also SEXUALIZATION [n -S]\n",
  "SEXUALISATIONS": "SEXUALISATION, the process of sexualising, also SEXUALIZATION [n]\n",
  "SEXUALISE": "to render sexual, also SEXUALIZE [v SEXUALISED, SEXUALISING, SEXUALISES]\n",
  "SEXUALISED": "SEXUALISE, to render sexual, also SEXUALIZE [v]\n",
  "SEXUALISES": "SEXUALISE, to render sexual, also SEXUALIZE [v]\n",
  "SEXUALISING": "SEXUALISE, to render sexual, also SEXUALIZE [v]\n",
  "SEXUALISM": "emphasis on sex [n -S]\n",
  "SEXUALISMS": "SEXUALISM, emphasis on sex [n]\n",
  "SEXUALIST": "one who classifies plants by the sexual method of Linnaeus [n -S]\n",
  "SEXUALISTS": "SEXUALIST, one who classifies plants by the sexual method of Linnaeus [n]\n",
  "SEXUALITIES": "SEXUALITY, sexual quality or orientation [n]\n",
  "SEXUALITY": "sexual quality or orientation [n SEXUALITIES]\n",
  "SEXUALIZATION": "the process of sexualizing, also SEXUALISATION [n -S]\n",
  "SEXUALIZATIONS": "SEXUALIZATION, the process of sexualizing, also SEXUALISATION [n]\n",
  "SEXUALIZE": "to render sexual, also SEXUALISE [v SEXUALIZED, SEXUALIZING, SEXUALIZES]\n",
  "SEXUALIZED": "SEXUALIZE, to render sexual, also SEXUALISE [v]\n",
  "SEXUALIZES": "SEXUALIZE, to render sexual, also SEXUALISE [v]\n",
  "SEXUALIZING": "SEXUALIZE, to render sexual, also SEXUALISE [v]\n",
  "SEXUALLY": "SEXUAL, pertaining to sex [adv]\n",
  "SEXVALENT": "of a valency of six, also SEXIVALENT [adj]\n",
  "SEXY": "arousing sexual desire [adj SEXIER, SEXIEST, SEXILY]\n",
  "SEY": "a part of a carcase of beef [n -S]\n",
  "SEYEN": "(Shakespeare) a scion, also CION, SIEN, SIENT, SYEN [n -S]\n",
  "SEYENS": "SEYEN, (Shakespeare) a scion, also CION, SIEN, SIENT, SYEN [n]\n",
  "SEYS": "SEY, a part of a carcase of beef [n]\n",
  "SEYSURE": "(Shakespeare) a seizure, also SEASURE, SEISURE [n -S]\n",
  "SEYSURES": "SEYSURE, (Shakespeare) a seizure, also SEASURE, SEISURE [n]\n",
  "SEZ": "SAY, to utter in words, speak [v]\n",
  "SFERICS": "(short for) atmospherics, noises interfering with radio reception, due to electric disturbances in the ether, also SPHERICS [n]\n",
  "SFORZANDI": "SFORZANDO, (Italian) a suddenly emphasised passage of music, also FORZANDO, FORZATO, SFORZATO [n]\n",
  "SFORZANDO": "(Italian) a suddenly emphasised passage of music, also FORZANDO, FORZATO, SFORZATO [n SFORZANDOS or SFORZANDI]\n",
  "SFORZANDOS": "SFORZANDO, (Italian) a suddenly emphasised passage of music, also FORZANDO, FORZATO, SFORZATO [n]\n",
  "SFORZATI": "SFORZATO, (Italian) a suddenly emphasised passage of music, also FORZANDO, FORZATO, SFORZANDO [n]\n",
  "SFORZATO": "(Italian) a suddenly emphasised passage of music, also FORZANDO, FORZATO, SFORZANDO [n SFORZATOS or SFORZATI]\n",
  "SFORZATOS": "SFORZATO, (Italian) a suddenly emphasised passage of music, also FORZANDO, FORZATO, SFORZANDO [n]\n",
  "SFUMATO": "(Italian) a painting having vague outlines, and colors and shades so mingled as to give a misty appearance [n -S]\n",
  "SFUMATOS": "SFUMATO, (Italian) a painting having vague outlines, and colors and shades so mingled as to give a misty appearance [n]\n",
  "SGRAFFITI": "SGRAFFITO, (Italian) the technique of scratching the surface of pottery to reveal a different colour [n]\n",
  "SGRAFFITO": "(Italian) the technique of scratching the surface of pottery to reveal a different colour [n SGRAFFITI]\n",
  "SH": "an interjection requesting silence, also SHA, SHH, SHHH [interj]\n",
  "SHA": "an interjection requesting silence, also SH, SHH, SHHH [interj]\n",
  "SHABASH": "(Hinglish) bravo or well done [interj]\n",
  "SHABBATOT": "(Hebrew) Jewish sabbaths [n]\n",
  "SHABBIER": "SHABBY, not smart [adj]\n",
  "SHABBIEST": "SHABBY, not smart [adj]\n",
  "SHABBILY": "SHABBY, not smart [adv]\n",
  "SHABBINESS": "the state of being shabby [n -ES]\n",
  "SHABBINESSES": "SHABBINESS, the state of being shabby [n]\n",
  "SHABBLE": "(Scots) an old rusty sword [n -S]\n",
  "SHABBLES": "SHABBLE, (Scots) an old rusty sword [n]\n",
  "SHABBY": "not smart [adj SHABBIER, SHABBIEST, SHABBILY]\n",
  "SHABRACK": "(historical) a trooper's housing or saddlecloth, also SHABRACQUE [n -S]\n",
  "SHABRACKS": "SHABRACK, (historical) a trooper's housing or saddlecloth, also SHABRACQUE [n]\n",
  "SHABRACQUE": "(historical) a trooper's housing or saddlecloth, also SHABRACK [n -S]\n",
  "SHABRACQUES": "SHABRACQUE, (historical) a trooper's housing or saddlecloth, also SHABRACK [n]\n",
  "SHACK": "a roughly built cabin or hut, esp. of logs, metal sheeting, etc. [n -S] / to avoid responsibility [v -ED, -ING, -S]\n",
  "SHACKED": "SHACK, to avoid responsibility [v]\n",
  "SHACKIER": "SHACKY, dilapidated [adj]\n",
  "SHACKIEST": "SHACKY, dilapidated [adj]\n",
  "SHACKING": "SHACK, to avoid responsibility [v]\n",
  "SHACKLE": "to confine with irons around wrists and ankles [v SHACKLED, SHACKLING, SHACKLES]\n",
  "SHACKLEBONE": "(Scots) the wrist [n -S]\n",
  "SHACKLEBONES": "SHACKLEBONE, (Scots) the wrist [n]\n",
  "SHACKLED": "SHACKLE, to confine with irons around wrists and ankles [v]\n",
  "SHACKLER": "one who shackles [n -S]\n",
  "SHACKLERS": "SHACKLER, one who shackles [n]\n",
  "SHACKLES": "SHACKLE, to confine with irons around wrists and ankles [v]\n",
  "SHACKLING": "SHACKLE, to confine with irons around wrists and ankles [v]\n",
  "SHACKO": "(Hungarian) the hat usually worn by members of a marching band, also CHACO, SHAKO [n -ES or -S]\n",
  "SHACKOES": "SHACKO, (Hungarian) the hat usually worn by members of a marching band, also CHACO, SHAKO [n]\n",
  "SHACKOS": "SHACKO, (Hungarian) the hat usually worn by members of a marching band, also CHACO, SHAKO [n]\n",
  "SHACKS": "SHACK, to avoid responsibility [v]\n",
  "SHACKTOWN": "(Canadian) a community or section of a community composed of shacks or other temporary housing [n -S]\n",
  "SHACKTOWNS": "SHACKTOWN, (Canadian) a community or section of a community composed of shacks or other temporary housing [n]\n",
  "SHACKY": "dilapidated [adj SHACKIER, SHACKIEST]\n",
  "SHAD": "a herring-like marine fish, spawning in rivers [n -S]\n",
  "SHADBERRIES": "SHADBERRY, the edible fruit of the shadbush [n]\n",
  "SHADBERRY": "the edible fruit of the shadbush [n SHADBERRIES]\n",
  "SHADBLOW": "an American rosaceous bush flowering at shad spawning time, also SHADBUSH [n -S]\n",
  "SHADBLOWS": "SHADBLOW, an American rosaceous bush flowering at shad spawning time, also SHADBUSH [n]\n",
  "SHADBUSH": "an American rosaceous bush flowering at shad spawning time, also SHADBLOW [n -ES]\n",
  "SHADBUSHES": "SHADBUSH, an American rosaceous bush flowering at shad spawning time, also SHADBLOW [n]\n",
  "SHADCHAN": "(Hebrew) a Jewish marriage broker, also SCHATCHEN, SHADKHAN [n SHADCHANS or SHADCHANIM]\n",
  "SHADCHANIM": "SHADCHAN, (Hebrew) a Jewish marriage broker, also SCHATCHEN, SHADKHAN [n]\n",
  "SHADCHANS": "SHADCHAN, (Hebrew) a Jewish marriage broker, also SCHATCHEN, SHADKHAN [n]\n",
  "SHADDOCK": "a grapefruit-like tree and fruit [n -S]\n",
  "SHADDOCKS": "SHADDOCK, a grapefruit-like tree and fruit [n]\n",
  "SHADDUP": "an interjection, shut up [interj]\n",
  "SHADE": "to screen from light or heat [v SHADED, SHADING, SHADES]\n",
  "SHADED": "SHADE, to screen from light or heat [v]\n",
  "SHADELESS": "without shade [adj]\n",
  "SHADER": "one who, or that which, shades [n -S]\n",
  "SHADERS": "SHADER, one who, or that which, shades [n]\n",
  "SHADES": "SHADE, to screen from light or heat [v]\n",
  "SHADFLIES": "SHADFLY, the mayfly [n]\n",
  "SHADFLY": "the mayfly [n SHADFLIES]\n",
  "SHADIER": "SHADY, full of shade; underhand [adj]\n",
  "SHADIEST": "SHADY, full of shade; underhand [adj]\n",
  "SHADILY": "SHADY, full of shade; underhand [adv]\n",
  "SHADINESS": "the state of being shady [n -ES]\n",
  "SHADINESSES": "SHADINESS, the state of being shady [n]\n",
  "SHADING": "protection against light or heat [n -S]\n",
  "SHADINGS": "SHADING, protection against light or heat [n]\n",
  "SHADKHAN": "(Hebrew) a Jewish marriage broker, also SCHATCHEN, SHADCHAN [n SHADKHANS or SHADKHANIM]\n",
  "SHADKHANIM": "SHADKHAN, (Hebrew) a Jewish marriage broker, also SCHATCHEN, SHADCHAN [n]\n",
  "SHADKHANS": "SHADKHAN, (Hebrew) a Jewish marriage broker, also SCHATCHEN, SHADCHAN [n]\n",
  "SHADOOF": "(Arabic) a machine, resembling a well sweep, used in Egypt for raising water from the Nile for irrigation, also SHADUF [n -S]\n",
  "SHADOOFS": "SHADOOF, (Arabic) a machine, resembling a well sweep, used in Egypt for raising water from the Nile for irrigation, also SHADUF [n]\n",
  "SHADOW": "to make dark or gloomy [v -ED, -ING, -S]\n",
  "SHADOWBOX": "to practise sparring with an invisible opponent [v -ED, -ING, -ES]\n",
  "SHADOWBOXED": "SHADOWBOX, to practise sparring with an invisible opponent [v]\n",
  "SHADOWBOXES": "SHADOWBOX, to practise sparring with an invisible opponent [v]\n",
  "SHADOWBOXING": "SHADOWBOX, to practise sparring with an invisible opponent [v]\n",
  "SHADOWCAST": "in microscopy, to cast shadows of projecting parts of a specimen by exposing to a stream of a vapour of a heavy metal [v SHADOWCAST or SHADOWCASTED, SHADOWCASTING, SHADOWCASTS]\n",
  "SHADOWCASTED": "SHADOWCAST, in microscopy, to cast shadows of projecting parts of a specimen by exposing to a stream of a vapour of a heavy metal [v]\n",
  "SHADOWCASTING": "in microscopy, casting shadows of projecting parts of a specimen by exposing to a stream of a vapour of a heavy metal [n -S]\n",
  "SHADOWCASTINGS": "SHADOWCASTING, in microscopy, casting shadows of projecting parts of a specimen by exposing to a stream of a vapour of a heavy metal [n]\n",
  "SHADOWCASTS": "SHADOWCAST, in microscopy, to cast shadows of projecting parts of a specimen by exposing to a stream of a vapour of a heavy metal [v]\n",
  "SHADOWED": "SHADOW, to make dark or gloomy [v]\n",
  "SHADOWER": "one who shadows [n -S]\n",
  "SHADOWERS": "SHADOWER, one who shadows [n]\n",
  "SHADOWGRAPH": "an image produced by throwing a shadow on a screen [n -S]\n",
  "SHADOWGRAPHIES": "SHADOWGRAPHY, the making of images by shadowgraph [n]\n",
  "SHADOWGRAPHS": "SHADOWGRAPH, an image produced by throwing a shadow on a screen [n]\n",
  "SHADOWGRAPHY": "the making of images by shadowgraph [n SHADOWGRAPHIES]\n",
  "SHADOWIER": "SHADOWY, full of shadows [adj]\n",
  "SHADOWIEST": "SHADOWY, full of shadows [adj]\n",
  "SHADOWILY": "SHADOWY, full of shadows [adv]\n",
  "SHADOWINESS": "the state of being shadowy [n -ES]\n",
  "SHADOWINESSES": "SHADOWINESS, the state of being shadowy [n]\n",
  "SHADOWING": "making dark or gloomy [n -S]\n",
  "SHADOWINGS": "SHADOWING, making dark or gloomy [n]\n",
  "SHADOWLESS": "without shadow [adj]\n",
  "SHADOWLIKE": "like a shadow [adj]\n",
  "SHADOWS": "SHADOW, to make dark or gloomy [v]\n",
  "SHADOWY": "full of shadows [adj SHADOWIER, SHADOWIEST, SHADOWILY]\n",
  "SHADRACH": "a mass of iron on which the operation of smelting has failed of its intended effect [n -S]\n",
  "SHADRACHS": "SHADRACH, a mass of iron on which the operation of smelting has failed of its intended effect [n]\n",
  "SHADS": "SHAD, a herring-like marine fish, spawning in rivers [n]\n",
  "SHADUF": "(Arabic) a machine, resembling a well sweep, used in Egypt for raising water from the Nile for irrigation, also SHADOOF [n -S]\n",
  "SHADUFS": "SHADUF, (Arabic) a machine, resembling a well sweep, used in Egypt for raising water from the Nile for irrigation, also SHADOOF [n]\n",
  "SHADY": "full of shade; underhand [adj SHADIER, SHADIEST, SHADILY]\n",
  "SHAFT": "to propel with a pole [v -ED, -ING, -S]\n",
  "SHAFTED": "SHAFT, to propel with a pole [v]\n",
  "SHAFTER": "a shaft-horse [n -S]\n",
  "SHAFTERS": "SHAFTER, a shaft-horse [n]\n",
  "SHAFTING": "a system of rods for transmitting power [n -S]\n",
  "SHAFTINGS": "SHAFTING, a system of rods for transmitting power [n]\n",
  "SHAFTLESS": "without shafts [adj]\n",
  "SHAFTS": "SHAFT, to propel with a pole [v]\n",
  "SHAG": "to make shaggy [v SHAGGED, SHAGGING, SHAGS]\n",
  "SHAGBARK": "a rough-barked species of hickory, aka shellbark [n -S]\n",
  "SHAGBARKS": "SHAGBARK, a rough-barked species of hickory, aka shellbark [n]\n",
  "SHAGGABLE": "(vulgar) worthy of a shag, i.e. sexually attractive [adj]\n",
  "SHAGGED": "SHAG, to make shaggy [v]\n",
  "SHAGGEDNESS": "the state of being shagged [n -ES]\n",
  "SHAGGEDNESSES": "SHAGGEDNESS, the state of being shagged [n]\n",
  "SHAGGER": "(vulgar slang) a person who engages in sexual intercourse [n -S]\n",
  "SHAGGERS": "SHAGGER, (vulgar slang) a person who engages in sexual intercourse [n]\n",
  "SHAGGIER": "SHAGGY, covered with long coarse hair [adj]\n",
  "SHAGGIEST": "SHAGGY, covered with long coarse hair [adj]\n",
  "SHAGGILY": "SHAGGY, covered with long coarse hair [adv]\n",
  "SHAGGINESS": "the state of being shaggy [n -ES]\n",
  "SHAGGINESSES": "SHAGGINESS, the state of being shaggy [n]\n",
  "SHAGGING": "SHAG, to make shaggy [v]\n",
  "SHAGGY": "covered with long coarse hair [adj SHAGGIER, SHAGGIEST, SHAGGILY]\n",
  "SHAGGYMANE": "an edible fungus [n -S]\n",
  "SHAGGYMANES": "SHAGGYMANE, an edible fungus [n]\n",
  "SHAGPILE": "of carpets, having a pile of long thick fibres [adj]\n",
  "SHAGREEN": "(French) the rough skin of certain sharks and rays, used as an abrasive [n -S]\n",
  "SHAGREENED": "made, covered with or resembling the leather called shagreen [adj]\n",
  "SHAGREENS": "SHAGREEN, (French) the rough skin of certain sharks and rays, used as an abrasive [n]\n",
  "SHAGROON": "(Irish) an early settler in New Zealand of other than British origin [n -S]\n",
  "SHAGROONS": "SHAGROON, (Irish) an early settler in New Zealand of other than British origin [n]\n",
  "SHAGS": "SHAG, to make shaggy [v]\n",
  "SHAGTASTIC": "sexually very attractive [adj]\n",
  "SHAH": "(Persian) a title of the monarch of Iran (Persia) [n -S]\n",
  "SHAHADA": "(Arabic) the Islamic declaration of faith, repeated daily, also SHAHADAH [n -S]\n",
  "SHAHADAH": "(Arabic) the Muslim profession of faith, also SHAHADA [n -S]\n",
  "SHAHADAHS": "SHAHADAH, (Arabic) the Muslim profession of faith, also SHAHADA [n]\n",
  "SHAHADAS": "SHAHADA, (Arabic) the Islamic declaration of faith, repeated daily, also SHAHADAH [n]\n",
  "SHAHDOM": "(Persian) the territory ruled by a shah [n -S]\n",
  "SHAHDOMS": "SHAHDOM, (Persian) the territory ruled by a shah [n]\n",
  "SHAHEED": "(Arabic) a martyr for the Islamic faith, also SHAHID [n -S]\n",
  "SHAHEEDS": "SHAHEED, (Arabic) a martyr for the Islamic faith, also SHAHID [n]\n",
  "SHAHID": "(Arabic) a martyr for the Islamic faith, also SHAHEED [n -S]\n",
  "SHAHIDS": "SHAHID, (Arabic) a martyr for the Islamic faith, also SHAHEED [n]\n",
  "SHAHS": "SHAH, (Persian) a title of the monarch of Iran (Persia) [n]\n",
  "SHAHTOOSH": "(Persian) the soft wool of the protected Tibetan antelope, also SHATOOSH [n -ES]\n",
  "SHAHTOOSHES": "SHAHTOOSH, (Persian) the soft wool of the protected Tibetan antelope, also SHATOOSH [n]\n",
  "SHAIKH": "(Arabic) an Arab chief, also SHAYKH, SHEIK, SHEIKH [n -S]\n",
  "SHAIKHS": "SHAIKH, (Arabic) an Arab chief, also SHAYKH, SHEIK, SHEIKH [n]\n",
  "SHAIRD": "a fragment of broken pottery, also SHARD, SHERD [n -S]\n",
  "SHAIRDS": "SHAIRD, a fragment of broken pottery, also SHARD, SHERD [n]\n",
  "SHAIRN": "(Scots) cow-dung, also SHARN [n -S]\n",
  "SHAIRNS": "SHAIRN, (Scots) cow-dung, also SHARN [n]\n",
  "SHAITAN": "(Arabic) an evil spirit, also SHEITAN [n -S]\n",
  "SHAITANS": "SHAITAN, (Arabic) an evil spirit, also SHEITAN [n]\n",
  "SHAKABLE": "that can be shaken, also SHAKEABLE [adj]\n",
  "SHAKE": "to move to and fro with short, rapid movements [v SHAKED or SHOOK, SHAKEN or SHAKT, SHAKING, SHAKES]\n",
  "SHAKEABLE": "that can be shaken, also SHAKABLE [adj]\n",
  "SHAKED": "SHAKE, to move to and fro with short, rapid movements [v]\n",
  "SHAKEDOWN": "any makeshift bed, esp. one made up on the floor [n -S]\n",
  "SHAKEDOWNS": "SHAKEDOWN, any makeshift bed, esp. one made up on the floor [n]\n",
  "SHAKEN": "SHAKE, to move to and fro with short, rapid movements [v]\n",
  "SHAKEOUT": "a minor economic recession [n -S]\n",
  "SHAKEOUTS": "SHAKEOUT, a minor economic recession [n]\n",
  "SHAKER": "one who shakes [n -S]\n",
  "SHAKERS": "SHAKER, one who shakes [n]\n",
  "SHAKES": "SHAKE, to move to and fro with short, rapid movements [v]\n",
  "SHAKEUP": "a total reorganization [n -S]\n",
  "SHAKEUPS": "SHAKEUP, a total reorganization [n]\n",
  "SHAKIER": "SHAKY, shaking [adj]\n",
  "SHAKIEST": "SHAKY, shaking [adj]\n",
  "SHAKILY": "SHAKY, shaking [adv]\n",
  "SHAKINESS": "the state of being shaky [n -ES]\n",
  "SHAKINESSES": "SHAKINESS, the state of being shaky [n]\n",
  "SHAKING": "the act of shaking [n -S]\n",
  "SHAKINGS": "SHAKING, the act of shaking [n]\n",
  "SHAKO": "(Hungarian) the hat usually worn by members of a marching band, also CHACO, SHACKO [n -ES or -S]\n",
  "SHAKOES": "SHAKO, (Hungarian) the hat usually worn by members of a marching band, also CHACO, SHACKO [n]\n",
  "SHAKOS": "SHAKO, (Hungarian) the hat usually worn by members of a marching band, also CHACO, SHACKO [n]\n",
  "SHAKT": "SHAKE, to move to and fro with short, rapid movements [v]\n",
  "SHAKUDO": "(Japanese) an alloy of copper and a small percentage of gold, used in Japanese decorative art, esp. in sword fittings [n -S]\n",
  "SHAKUDOS": "SHAKUDO, (Japanese) an alloy of copper and a small percentage of gold, used in Japanese decorative art, esp. in sword fittings [n]\n",
  "SHAKUHACHI": "(Japanese) a Japanese bamboo flute [n -S]\n",
  "SHAKUHACHIS": "SHAKUHACHI, (Japanese) a Japanese bamboo flute [n]\n",
  "SHAKY": "shaking [adj SHAKIER, SHAKIEST, SHAKILY]\n",
  "SHALE": "clay rock splitting readily into thin layers along the bedding planes [n -S] / to shell, husk, also SHEAL, SHEEL, SHIEL [v SHALED, SHALING, SHALES]\n",
  "SHALED": "SHALE, to shell, husk, also SHEAL, SHEEL, SHIEL [v]\n",
  "SHALELIKE": "like shale [adj]\n",
  "SHALES": "SHALE, to shell, husk, also SHEAL, SHEEL, SHIEL [v]\n",
  "SHALEY": "of or like shale, also SHALY [adj SHALIER, SHALIEST]\n",
  "SHALIER": "SHALY, resembling shale, also SHALEY [adj]\n",
  "SHALIEST": "SHALY, resembling shale, also SHALEY [adj]\n",
  "SHALING": "SHALE, to shell, husk, also SHEAL, SHEEL, SHIEL [v]\n",
  "SHALL": "used as an auxiliary to express futurity, inevitability, or command [v present sing 2d person SHALL or SHALT, past sing 2d person SHOULD, SHOULDST, or SHOULDEST]\n",
  "SHALLI": "a soft lightweight silk, wool or cotton fabric, also CHALLIE, CHALLIS, CHALLY [n -S]\n",
  "SHALLIS": "SHALLI, a soft lightweight silk, wool or cotton fabric, also CHALLIE, CHALLIS, CHALLY [n]\n",
  "SHALLON": "an evergreen shrub of NW America, aka salal [n -S]\n",
  "SHALLONS": "SHALLON, an evergreen shrub of NW America, aka salal [n]\n",
  "SHALLOON": "a light woollen fabric, used for coat-linings [n -S]\n",
  "SHALLOONS": "SHALLOON, a light woollen fabric, used for coat-linings [n]\n",
  "SHALLOP": "a light river boat with sail and oars [n -S]\n",
  "SHALLOPS": "SHALLOP, a light river boat with sail and oars [n]\n",
  "SHALLOT": "an onion with garlic-flavoured bulbs, also ESCHALOT, SHALOT [n -S]\n",
  "SHALLOTS": "SHALLOT, an onion with garlic-flavoured bulbs, also ESCHALOT, SHALOT [n]\n",
  "SHALLOW": "not deep [adj SHALLOWER, SHALLOWEST, SHALLOWLY] / to become shallow [v -ED, -ING, -S]\n",
  "SHALLOWED": "SHALLOW, to become shallow [v]\n",
  "SHALLOWER": "SHALLOW, not deep [adj]\n",
  "SHALLOWEST": "SHALLOW, not deep [adj]\n",
  "SHALLOWING": "the act of shallowing [n -S]\n",
  "SHALLOWINGS": "SHALLOWING, the act of shallowing [n]\n",
  "SHALLOWLY": "SHALLOW, not deep [adv]\n",
  "SHALLOWNESS": "the state of being shallow [n -ES]\n",
  "SHALLOWNESSES": "SHALLOWNESS, the state of being shallow [n]\n",
  "SHALLOWS": "SHALLOW, to become shallow [v]\n",
  "SHALM": "an ancient oboe-like musical instrument, also SHAWM [n -S]\n",
  "SHALMS": "SHALM, an ancient oboe-like musical instrument, also SHAWM [n]\n",
  "SHALOM": "(Hebrew) in Jewish society, a salutation at meeting or parting, also SHOLOM [n -S]\n",
  "SHALOMS": "SHALOM, (Hebrew) in Jewish society, a salutation at meeting or parting, also SHOLOM [n]\n",
  "SHALOT": "an onion with garlic-flavoured bulbs, also ESCHALOT, SHALLOT [n -S]\n",
  "SHALOTS": "SHALOT, an onion with garlic-flavoured bulbs, also ESCHALOT, SHALLOT [n]\n",
  "SHALT": "SHALL, used as an auxiliary to express futurity, inevitability, or command [v]\n",
  "SHALWAR": "(Urdu) loose-fitting trousers worn by both sexes in many parts of Asia [n -S]\n",
  "SHALWARS": "SHALWAR, (Urdu) loose-fitting trousers worn by both sexes in many parts of Asia [n]\n",
  "SHALY": "resembling shale, also SHALEY [adj SHALIER, SHALIEST]\n",
  "SHAM": "to feign [v SHAMMED, SHAMMING, SHAMS]\n",
  "SHAMA": "(Hindi) an Indian millet-like cereal; an Indian songbird [n -S]\n",
  "SHAMABLE": "capable of being shamed, also SHAMEABLE [adj]\n",
  "SHAMABLY": "SHAMABLE, capable of being shamed, also SHAMEABLE [adv]\n",
  "SHAMAL": "(Arabic) in the Middle East, a hot dry north wind that carries sand in desert places, also SHIMAAL [n -S]\n",
  "SHAMALS": "SHAMAL, (Arabic) in the Middle East, a hot dry north wind that carries sand in desert places, also SHIMAAL [n]\n",
  "SHAMAN": "(Russian) a doctor-priest or medicine man working by magic, esp. a priest of Asian Shamanism [n -S]\n",
  "SHAMANIC": "pertaining to a shaman, a doctor-priest or medicine man working by magic [adj]\n",
  "SHAMANISM": "the religion of certain peoples of North Asia, based essentially on magic and sorcery as practised by shamans [n -S]\n",
  "SHAMANISMS": "SHAMANISM, the religion of certain peoples of North Asia, based essentially on magic and sorcery as practised by shamans [n]\n",
  "SHAMANIST": "an adherent of shamanism [n -S]\n",
  "SHAMANISTIC": "relating to shamanism [adj]\n",
  "SHAMANISTS": "SHAMANIST, an adherent of shamanism [n]\n",
  "SHAMANS": "SHAMAN, (Russian) a doctor-priest or medicine man working by magic, esp. a priest of Asian Shamanism [n]\n",
  "SHAMAS": "SHAMA, (Hindi) an Indian millet-like cereal; an Indian songbird [n]\n",
  "SHAMATEUR": "an amateur who is actually paid for his or her performance [n -S]\n",
  "SHAMATEURISM": "the retention of amateur status while receiving payment for playing or competing [n -S]\n",
  "SHAMATEURISMS": "SHAMATEURISM, the retention of amateur status while receiving payment for playing or competing [n]\n",
  "SHAMATEURS": "SHAMATEUR, an amateur who is actually paid for his or her performance [n]\n",
  "SHAMBA": "(Swahili) in East Africa, any plot, farm or smallholding used for growing crops [n -S]\n",
  "SHAMBAS": "SHAMBA, (Swahili) in East Africa, any plot, farm or smallholding used for growing crops [n]\n",
  "SHAMBLE": "to walk awkwardly [v SHAMBLED, SHAMBLING, SHAMBLES]\n",
  "SHAMBLED": "SHAMBLE, to walk awkwardly [v]\n",
  "SHAMBLES": "SHAMBLE, to walk awkwardly [v]\n",
  "SHAMBLIER": "SHAMBLY, awkwardly [adj]\n",
  "SHAMBLIEST": "SHAMBLY, awkwardly [adj]\n",
  "SHAMBLING": "the act of shambling [n -S]\n",
  "SHAMBLINGS": "SHAMBLING, the act of shambling [n]\n",
  "SHAMBLY": "awkwardly [adj SHAMBLIER, SHAMBLIEST]\n",
  "SHAMBOLIC": "chaotic [adj SHAMBOLICALLY]\n",
  "SHAMBOLICALLY": "SHAMBOLIC, chaotic [adv]\n",
  "SHAME": "to cause to feel guilt [v SHAMED, SHAMING, SHAMES]\n",
  "SHAMEABLE": "capable of being shamed, also SHAMABLE [adj SHAMEABLY]\n",
  "SHAMEABLY": "SHAMEABLE, capable of being shamed, also SHAMABLE [adv]\n",
  "SHAMED": "SHAME, to cause to feel guilt [v]\n",
  "SHAMEFACED": "showing modesty, also SHAMEFAST [adj SHAMEFACEDLY]\n",
  "SHAMEFACEDLY": "SHAMEFACED, showing modesty, also SHAMEFAST [adv]\n",
  "SHAMEFACEDNESS": "the state of being shamefaced [n]\n",
  "SHAMEFAST": "modest, bashful, also SHAMEFACED [adj]\n",
  "SHAMEFASTNESS": "SHAMEFAST, modest, bashful, also SHAMEFACED [n]\n",
  "SHAMEFASTNESSES": "SHAMEFASTNESS, SHAMEFAST, modest, bashful, also SHAMEFACED [n]\n",
  "SHAMEFUL": "disgraceful [adj SHAMEFULLY]\n",
  "SHAMEFULLY": "SHAMEFUL, disgraceful [adv]\n",
  "SHAMEFULNESS": "the state of being shameful [n -ES]\n",
  "SHAMEFULNESSES": "SHAMEFULNESS, the state of being shameful [n]\n",
  "SHAMELESS": "without shame [adj SHAMELESSLY]\n",
  "SHAMELESSLY": "SHAMELESS, without shame [adv]\n",
  "SHAMELESSNESS": "the state of being shameless [n -ES]\n",
  "SHAMELESSNESSES": "SHAMELESSNESS, the state of being shameless [n]\n",
  "SHAMER": "one who causes shame [n -S]\n",
  "SHAMERS": "SHAMER, one who causes shame [n]\n",
  "SHAMES": "SHAME, to cause to feel guilt [v]\n",
  "SHAMEWORTHIER": "SHAMEWORTHY, worthy of shame [adj]\n",
  "SHAMEWORTHIEST": "SHAMEWORTHY, worthy of shame [adj]\n",
  "SHAMEWORTHY": "worthy of shame [adj SHAMEWORTHIER, SHAMEWORTHIEST]\n",
  "SHAMIANA": "(Hindi) in India, a large tent, awning or canopy, also SHAMIANAH, SHAMIYANAH [n -S]\n",
  "SHAMIANAH": "(Hindi) in India, a large tent, awning or canopy, also SHAMIANA, SHAMIYANAH [n -S]\n",
  "SHAMIANAHS": "SHAMIANAH, (Hindi) in India, a large tent, awning or canopy, also SHAMIANA, SHAMIYANAH [n]\n",
  "SHAMIANAS": "SHAMIANA, (Hindi) in India, a large tent, awning or canopy, also SHAMIANAH, SHAMIYANAH [n]\n",
  "SHAMINA": "a wool blend of shahtoosh and pashm [n -S]\n",
  "SHAMINAS": "SHAMINA, a wool blend of shahtoosh and pashm [n]\n",
  "SHAMING": "the act of causing someone to feel a painful sense of guilt or degradation [n -S]\n",
  "SHAMINGS": "SHAMING, the act of causing someone to feel a painful sense of guilt or degradation [n]\n",
  "SHAMISEN": "(Japanese) a banjo-like 3-stringed instrument, also SAMISEN [n -S]\n",
  "SHAMISENS": "SHAMISEN, (Japanese) a banjo-like 3-stringed instrument, also SAMISEN [n]\n",
  "SHAMIYANAH": "(Hindi) in India, a large tent or awning, also SHAMIANA, SHAMIANAH [n -S]\n",
  "SHAMIYANAHS": "SHAMIYANAH, (Hindi) in India, a large tent or awning, also SHAMIANA, SHAMIANAH [n]\n",
  "SHAMMAS": "(Yiddish) the sexton in a synagogue; the candle used to light the other 8 candles of a Chanukah menorah, also SHAMMASH, SHAMMES, SHAMMOS, SHAMOS [n SHAMMASIM]\n",
  "SHAMMASH": "(Yiddish) a minor official of a synagogue, also SHAMMES, SHAMAS, SHAMMAS, SHAMMOS, SHAMOS [n SHAMMASHIM or SHAMMOSIM]\n",
  "SHAMMASHIM": "SHAMMASH, (Yiddish) a minor official of a synagogue, also SHAMMES, SHAMAS, SHAMMAS, SHAMMOS, SHAMOS [n]\n",
  "SHAMMASIM": "SHAMMAS, (Yiddish) the sexton in a synagogue; the candle used to light the other 8 candles of a Chanukah menorah, also SHAMMASH, SHAMMES, SHAMMOS, SHAMOS [n]\n",
  "SHAMMED": "SHAM, to feign [v]\n",
  "SHAMMER": "one who shams; an impostor [n -S]\n",
  "SHAMMERS": "SHAMMER, one who shams; an impostor [n]\n",
  "SHAMMES": "(Yiddish) the sexton in a synagogue; the candle used to light the other 8 candles of a Chanukah menorah, also SHAMMAS, SHAMMASH, SHAMMOS, SHAMOS [n SHAMMOSIM]\n",
  "SHAMMIED": "SHAMMY, to prepare leather like chamois, also CHAMOIS [v]\n",
  "SHAMMIES": "SHAMMY, to prepare leather like chamois, also CHAMOIS [v]\n",
  "SHAMMING": "SHAM, to feign [v]\n",
  "SHAMMOS": "(Hebrew) the sexton in a synagogue; the candle used to light the other 8 candles of a Chanukah menorah, also SHAMMAS, SHAMMASH, SHAMMES, SHAMOS [n SHAMMOSIM]\n",
  "SHAMMOSIM": "SHAMMOS, (Hebrew) the sexton in a synagogue; the candle used to light the other 8 candles of a Chanukah menorah, also SHAMMAS, SHAMMASH, SHAMMES, SHAMOS [n]\n",
  "SHAMMY": "a soft leather, also CHAMOIS, CHAMOIX [n SHAMMIES] / to prepare leather like chamois, also CHAMOIS [v SHAMMIED, SHAMMYING, SHAMMIES]\n",
  "SHAMMYING": "SHAMMY, to prepare leather like chamois, also CHAMOIS [v]\n",
  "SHAMOIS": "(French) a kind of leather made from a goatlike antelope found in the Alps [n] / to clean with this [v -ED, -ING, -ES]\n",
  "SHAMOISED": "SHAMOIS, to clean with this [v]\n",
  "SHAMOISES": "SHAMOIS, to clean with this [v]\n",
  "SHAMOISING": "SHAMOIS, to clean with this [v]\n",
  "SHAMOS": "(Yiddish) a minor official of a synagogue, also SHAMMES, SHAMAS, SHAMMAS, SHAMMASH, SHAMMOS [n SHAMOSIM]\n",
  "SHAMOSIM": "SHAMOS, (Yiddish) a minor official of a synagogue, also SHAMMES, SHAMAS, SHAMMAS, SHAMMASH, SHAMMOS [n]\n",
  "SHAMOY": "to prepare skins by working oil into them [v -ED, -ING, -S]\n",
  "SHAMOYED": "SHAMOY, to prepare skins by working oil into them [v]\n",
  "SHAMOYING": "SHAMOY, to prepare skins by working oil into them [v]\n",
  "SHAMOYS": "SHAMOY, to prepare skins by working oil into them [v]\n",
  "SHAMPOO": "to wash with a liquid soap [v -ED, -ING, -S]\n",
  "SHAMPOOED": "SHAMPOO, to wash with a liquid soap [v]\n",
  "SHAMPOOER": "one who shampoos [n -S]\n",
  "SHAMPOOERS": "SHAMPOOER, one who shampoos [n]\n",
  "SHAMPOOING": "SHAMPOO, to wash with a liquid soap [v]\n",
  "SHAMPOOS": "SHAMPOO, to wash with a liquid soap [v]\n",
  "SHAMROCK": "a trifoliate leaf or plant [n -S]\n",
  "SHAMROCKS": "SHAMROCK, a trifoliate leaf or plant [n]\n",
  "SHAMS": "SHAM, to feign [v]\n",
  "SHAMUS": "(US slang) a private detective [n -ES]\n",
  "SHAMUSES": "SHAMUS, (US slang) a private detective [n]\n",
  "SHAN": "(obsolete) in criminal slang, a base or counterfeit coin, also SHAND [n -S]\n",
  "SHANACHIE": "(Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHIE, SEANNACHY, SENNACHIE [n -S]\n",
  "SHANACHIES": "SHANACHIE, (Gaelic) a Highland or Irish genealogist and transmitter of family lore, also SEANNACHIE, SEANNACHY, SENNACHIE [n]\n",
  "SHAND": "(obsolete) in criminal slang, a base or counterfeit coin, also SHAN [n -S]\n",
  "SHANDIES": "SHANDY, a mixture of beer or ginger beer and lemonade [n]\n",
  "SHANDRIES": "SHANDRY, a light, sprung cart [n]\n",
  "SHANDRY": "a light, sprung cart [n SHANDRIES]\n",
  "SHANDRYDAN": "an Irish two-wheeled cart; jocular, any worn-out antique vehicle [n -S]\n",
  "SHANDRYDANS": "SHANDRYDAN, an Irish two-wheeled cart; jocular, any worn-out antique vehicle [n]\n",
  "SHANDS": "SHAND, (obsolete) in criminal slang, a base or counterfeit coin, also SHAN [n]\n",
  "SHANDY": "a mixture of beer or ginger beer and lemonade [n SHANDIES]\n",
  "SHANDYGAFF": "a mixture of strong beer and ginger beer [n -S]\n",
  "SHANDYGAFFS": "SHANDYGAFF, a mixture of strong beer and ginger beer [n]\n",
  "SHANGHAI": "to kidnap for service aboard a ship [v -ED, -ING, -S]\n",
  "SHANGHAIED": "SHANGHAI, to kidnap for service aboard a ship [v]\n",
  "SHANGHAIER": "one who shanghais [n -S]\n",
  "SHANGHAIERS": "SHANGHAIER, one who shanghais [n]\n",
  "SHANGHAIING": "SHANGHAI, to kidnap for service aboard a ship [v]\n",
  "SHANGHAIS": "SHANGHAI, to kidnap for service aboard a ship [v]\n",
  "SHANK": "to hit sharply to the right, as a golf ball [v -ED, -ING, -S]\n",
  "SHANKBONE": "the bone of the shank [n -S]\n",
  "SHANKBONES": "SHANKBONE, the bone of the shank [n]\n",
  "SHANKED": "SHANK, to hit sharply to the right, as a golf ball [v]\n",
  "SHANKING": "SHANK, to hit sharply to the right, as a golf ball [v]\n",
  "SHANKPIECE": "an arch support [n -S]\n",
  "SHANKPIECES": "SHANKPIECE, an arch support [n]\n",
  "SHANKS": "SHANK, to hit sharply to the right, as a golf ball [v]\n",
  "SHANNIES": "SHANNY, a small marine fish found in inshore waters and rock pools, aka smooth blenny [n]\n",
  "SHANNY": "a small marine fish found in inshore waters and rock pools, aka smooth blenny [n SHANNIES]\n",
  "SHANS": "SHAN, (obsolete) in criminal slang, a base or counterfeit coin, also SHAND [n]\n",
  "SHANTEY": "a song sung by sailors as they worked, also CHANTEY, CHANTIE, CHANTY, SHANTY [n -S]\n",
  "SHANTEYS": "SHANTEY, a song sung by sailors as they worked, also CHANTEY, CHANTIE, CHANTY, SHANTY [n]\n",
  "SHANTI": "(Sanskrit) peace, also SHANTIH [n -S]\n",
  "SHANTIES": "SHANTY, a song sung by sailors as they worked, also CHANTEY, CHANTIE, CHANTY, SHANTEY [n]\n",
  "SHANTIH": "(Sanskrit) peace, also SHANTI [n -S]\n",
  "SHANTIHS": "SHANTIH, (Sanskrit) peace, also SHANTI [n]\n",
  "SHANTIS": "SHANTI, (Sanskrit) peace, also SHANTIH [n]\n",
  "SHANTUNG": "(Chinese) a plain rough cloth of wild silk [n -S]\n",
  "SHANTUNGS": "SHANTUNG, (Chinese) a plain rough cloth of wild silk [n]\n",
  "SHANTY": "a song sung by sailors as they worked, also CHANTEY, CHANTIE, CHANTY, SHANTEY [n SHANTIES]\n",
  "SHANTYMAN": "the solo singer in shanties [n SHANTYMEN]\n",
  "SHANTYMEN": "SHANTYMAN, the solo singer in shanties [n]\n",
  "SHANTYTOWN": "a usually poor town or section of a town consisting mostly of shanties [n -S]\n",
  "SHANTYTOWNS": "SHANTYTOWN, a usually poor town or section of a town consisting mostly of shanties [n]\n",
  "SHAPABLE": "that may be shaped, also SHAPEABLE [adj]\n",
  "SHAPE": "to fashion into a form [v SHOPE or SHAPED, SHAPEN, SHAPING, SHAPES]\n",
  "SHAPEABLE": "that can be shaped, also SHAPABLE [adj]\n",
  "SHAPED": "SHAPE, to fashion into a form [v]\n",
  "SHAPELESS": "without shape [adj SHAPELESSLY]\n",
  "SHAPELESSLY": "SHAPELESS, without shape [adv]\n",
  "SHAPELESSNESS": "the state of being shapeless [n -ES]\n",
  "SHAPELESSNESSES": "SHAPELESSNESS, the state of being shapeless [n]\n",
  "SHAPELIER": "SHAPELY, having a pleasing shape [adj]\n",
  "SHAPELIEST": "SHAPELY, having a pleasing shape [adj]\n",
  "SHAPELINESS": "the state of being shapely [n -ES]\n",
  "SHAPELINESSES": "SHAPELINESS, the state of being shapely [n]\n",
  "SHAPELY": "having a pleasing shape [adj SHAPELIER, SHAPELIEST]\n",
  "SHAPEN": "to shape [v -ED, -ING, -S]\n",
  "SHAPENED": "SHAPEN, to shape [v]\n",
  "SHAPENING": "SHAPEN, to shape [v]\n",
  "SHAPENS": "SHAPEN, to shape [v]\n",
  "SHAPER": "one that shapes [n -S]\n",
  "SHAPERS": "SHAPER, one that shapes [n]\n",
  "SHAPES": "SHAPE, to fashion into a form [v]\n",
  "SHAPESHIFTER": "(in folklore) a creature that has the ability to change its physical form at will [n -S]\n",
  "SHAPESHIFTERS": "SHAPESHIFTER, (in folklore) a creature that has the ability to change its physical form at will [n]\n",
  "SHAPESHIFTING": "(in folklore) the ability to change physical form at will [n -S]\n",
  "SHAPESHIFTINGS": "SHAPESHIFTING, (in folklore) the ability to change physical form at will [n]\n",
  "SHAPEUP": "a method of selecting workers esp. dockers for a single day's work from an assembly gathered for the purpose [n -S]\n",
  "SHAPEUPS": "SHAPEUP, a method of selecting workers esp. dockers for a single day's work from an assembly gathered for the purpose [n]\n",
  "SHAPEWEAR": "underwear that shapes the body [n -S]\n",
  "SHAPEWEARS": "SHAPEWEAR, underwear that shapes the body [n]\n",
  "SHAPING": "the act of fashioning [n -S]\n",
  "SHAPINGS": "SHAPING, the act of fashioning [n]\n",
  "SHAPS": "(short for) chaparajos, a cowboy's leather riding leggings [n]\n",
  "SHARABLE": "that can be shared, also SHAREABLE [adj]\n",
  "SHARAWADGI": "in design, architecture etc., the use of irregularity for deliberate, artful, contrastive effect, also SHARAWAGGI [n -S]\n",
  "SHARAWADGIS": "SHARAWADGI, in design, architecture etc., the use of irregularity for deliberate, artful, contrastive effect, also SHARAWAGGI [n]\n",
  "SHARAWAGGI": "in design, architecture etc., the use of irregularity for deliberate, artful, contrastive effect, also SHARAWADGI [n -S]\n",
  "SHARAWAGGIS": "SHARAWAGGI, in design, architecture etc., the use of irregularity for deliberate, artful, contrastive effect, also SHARAWADGI [n]\n",
  "SHARD": "a fragment of broken pottery, also SHAIRD, SHERD [n -S]\n",
  "SHARDED": "(archaic) sheltered under dung [adj]\n",
  "SHARDS": "SHARD, a fragment of broken pottery, also SHAIRD, SHERD [n]\n",
  "SHARE": "to use in common with others [v SHARED, SHARING, SHARES]\n",
  "SHAREABILITIES": "SHAREABILITY, the state of being shareable [n]\n",
  "SHAREABILITY": "the state of being shareable [n SHAREABILITIES]\n",
  "SHAREABLE": "that can be shared, also SHARABLE [adj]\n",
  "SHARECROP": "of a tenant farmer, to supply, in lieu of rent, a share of the crop [v SHARECROPPED, SHARECROPPING, SHARECROPS]\n",
  "SHARECROPPED": "SHARECROP, of a tenant farmer, to supply, in lieu of rent, a share of the crop [v]\n",
  "SHARECROPPER": "a tenant farmer esp. in the southern United States who is provided with credit for seed, tools, living quarters, and food, who works the land, and who receives an agreed share of the value of the crop minus charges [n -S]\n",
  "SHARECROPPERS": "SHARECROPPER, a tenant farmer esp. in the southern United States who is provided with credit for seed, tools, living quarters, and food, who works the land, and who receives an agreed share of the value of the crop minus charges [n]\n",
  "SHARECROPPING": "a kind of tenant farming where the farmer supplies, in lieu of rent, a share of the crop [n -S]\n",
  "SHARECROPPINGS": "SHARECROPPING, a kind of tenant farming where the farmer supplies, in lieu of rent, a share of the crop [n]\n",
  "SHARECROPS": "SHARECROP, of a tenant farmer, to supply, in lieu of rent, a share of the crop [v]\n",
  "SHARED": "SHARE, to use in common with others [v]\n",
  "SHAREFARMER": "a tenant farmer who pays a share of the proceeds as rent [n -S]\n",
  "SHAREFARMERS": "SHAREFARMER, a tenant farmer who pays a share of the proceeds as rent [n]\n",
  "SHAREHOLDER": "one that holds or owns a share in property [n -S]\n",
  "SHAREHOLDERS": "SHAREHOLDER, one that holds or owns a share in property [n]\n",
  "SHAREHOLDING": "the act of holding shares [n -S]\n",
  "SHAREHOLDINGS": "SHAREHOLDING, the act of holding shares [n]\n",
  "SHAREMAN": "a fisherman who shares profits with the owner, also SHARESMAN [n SHAREMEN]\n",
  "SHAREMEN": "SHAREMAN, a fisherman who shares profits with the owner, also SHARESMAN [n]\n",
  "SHAREMILKER": "(New Zealand) a sharefarmer on a dairy farm [n -S]\n",
  "SHAREMILKERS": "SHAREMILKER, (New Zealand) a sharefarmer on a dairy farm [n]\n",
  "SHARENTING": "the habitual use of social media to share news, images, etc of one\u0012s children [n -S]\n",
  "SHARENTINGS": "SHARENTING, the habitual use of social media to share news, images, etc of one\u0012s children [n]\n",
  "SHARER": "one that shares [n -S]\n",
  "SHARERS": "SHARER, one that shares [n]\n",
  "SHARES": "SHARE, to use in common with others [v]\n",
  "SHARESMAN": "a fisherman who shares profits with the owner, also SHAREMAN [n SHARESMEN]\n",
  "SHARESMEN": "SHARESMAN, a fisherman who shares profits with the owner, also SHAREMAN [n]\n",
  "SHAREWARE": "a computer program available for use for a small payment made on trust [n -S]\n",
  "SHAREWARES": "SHAREWARE, a computer program available for use for a small payment made on trust [n]\n",
  "SHARIA": "(Turkish) the body of Islamic religious law, also SHARIAH, SHARIAT, SHERIA, SHERIAT [n -S]\n",
  "SHARIAH": "(Turkish) the body of Islamic religious law, also SHARIA, SHARIAT, SHERIA, SHERIAT [n -S]\n",
  "SHARIAHS": "SHARIAH, (Turkish) the body of Islamic religious law, also SHARIA, SHARIAT, SHERIA, SHERIAT [n]\n",
  "SHARIAS": "SHARIA, (Turkish) the body of Islamic religious law, also SHARIAH, SHARIAT, SHERIA, SHERIAT [n]\n",
  "SHARIAT": "(Turkish) the body of Islamic religious law, also SHARIA, SHARIAH, SHERIA, SHERIAT [n -S]\n",
  "SHARIATS": "SHARIAT, (Turkish) the body of Islamic religious law, also SHARIA, SHARIAH, SHERIA, SHERIAT [n]\n",
  "SHARIF": "(Arabic) a descendant of Mohammed through his daughter Fatima, also SHEREEF, SHERIF [n SHARIFS or ASHRAF]\n",
  "SHARIFIAN": "relating to a sharif, a descendant of Mohammed through his daughter Fatima, also SHERIFIAN [adj]\n",
  "SHARIFS": "SHARIF, (Arabic) a descendant of Mohammed through his daughter Fatima, also SHEREEF, SHERIF [n]\n",
  "SHARING": "the act of sharing [n -S]\n",
  "SHARINGS": "SHARING, the act of sharing [n]\n",
  "SHARK": "to obtain by swindling [v -ED, -ING, -S]\n",
  "SHARKED": "SHARK, to obtain by swindling [v]\n",
  "SHARKER": "one who lives by sharking, a swindler [n -S]\n",
  "SHARKERS": "SHARKER, one who lives by sharking, a swindler [n]\n",
  "SHARKING": "trickery, deception [n -S]\n",
  "SHARKINGS": "SHARKING, trickery, deception [n]\n",
  "SHARKISH": "behaving like a shark [adj]\n",
  "SHARKLIKE": "like a shark [adj]\n",
  "SHARKS": "SHARK, to obtain by swindling [v]\n",
  "SHARKSKIN": "a smooth durable wool or worsted fabric [n -S]\n",
  "SHARKSKINS": "SHARKSKIN, a smooth durable wool or worsted fabric [n]\n",
  "SHARKSUCKER": "another name for the remora [n -S]\n",
  "SHARKSUCKERS": "SHARKSUCKER, another name for the remora [n]\n",
  "SHARN": "(Scots) cow-dung, also SHAIRN [n -S]\n",
  "SHARNIER": "SHARNY, (Scots) like cow-dung [adj]\n",
  "SHARNIES": "SHARNY, a person responsible for cleaning a cowhouse [n]\n",
  "SHARNIEST": "SHARNY, (Scots) like cow-dung [adj]\n",
  "SHARNS": "SHARN, (Scots) cow-dung, also SHAIRN [n]\n",
  "SHARNY": "(Scots) like cow-dung [adj SHARNIER, SHARNIEST] / a person responsible for cleaning a cowhouse [n SHARNIES]\n",
  "SHARON": "as in sharon fruit, persimmon [adj]\n",
  "SHARP": "keen, acute [adj SHARPER, SHARPEST, SHARPLY] / to raise in music by a semitone [v -ED, -ING, -S]\n",
  "SHARPBENDER": "an organization that has been underperforming its competitors but suddenly becomes more successful [n -S]\n",
  "SHARPBENDERS": "SHARPBENDER, an organization that has been underperforming its competitors but suddenly becomes more successful [n]\n",
  "SHARPED": "SHARP, to raise in music by a semitone [v]\n",
  "SHARPEN": "to make sharp [v -ED, -ING, -S]\n",
  "SHARPENED": "SHARPEN, to make sharp [v]\n",
  "SHARPENER": "a device for sharpening [n -S]\n",
  "SHARPENERS": "SHARPENER, a device for sharpening [n]\n",
  "SHARPENING": "the act of making sharp [n -S]\n",
  "SHARPENINGS": "SHARPENING, the act of making sharp [n]\n",
  "SHARPENS": "SHARPEN, to make sharp [v]\n",
  "SHARPER": "a cheat or hoaxer, esp. someone who cheats at cards [n -S]\n",
  "SHARPERS": "SHARPER, a cheat or hoaxer, esp. someone who cheats at cards [n]\n",
  "SHARPEST": "SHARP, keen, acute [adj]\n",
  "SHARPIE": "a flat-bottomed, two-masted vessel, also SHARPY [n -S]\n",
  "SHARPIES": "SHARPIE, a flat-bottomed, two-masted vessel, also SHARPY [n]\n",
  "SHARPING": "raising a note in music by a semitone [n -S]\n",
  "SHARPINGS": "SHARPING, raising a note in music by a semitone [n]\n",
  "SHARPISH": "somewhat sharp [adj]\n",
  "SHARPLY": "SHARP, keen, acute [adv]\n",
  "SHARPNESS": "the state of being sharp [n -ES]\n",
  "SHARPNESSES": "SHARPNESS, the state of being sharp [n]\n",
  "SHARPS": "SHARP, to raise in music by a semitone [v]\n",
  "SHARPSHOOTER": "a marksman [n -S]\n",
  "SHARPSHOOTERS": "SHARPSHOOTER, a marksman [n]\n",
  "SHARPSHOOTING": "shooting with great precision [n -S]\n",
  "SHARPSHOOTINGS": "SHARPSHOOTING, shooting with great precision [n]\n",
  "SHARPTAIL": "a kind of grouse [n -S]\n",
  "SHARPTAILS": "SHARPTAIL, a kind of grouse [n]\n",
  "SHARPY": "a flat-bottomed, two-masted vessel, also SHARPIE [n SHARPIES]\n",
  "SHASH": "to provide with a sash [v -ED, -ING, -ES]\n",
  "SHASHED": "SHASH, to provide with a sash [v]\n",
  "SHASHES": "SHASH, to provide with a sash [v]\n",
  "SHASHING": "SHASH, to provide with a sash [v]\n",
  "SHASHLICK": "(Russian) a type of lamb kebab, also SHASHLIK, SHASLIK [n -S]\n",
  "SHASHLICKS": "SHASHLICK, (Russian) a type of lamb kebab, also SHASHLIK, SHASLIK [n]\n",
  "SHASHLIK": "(Russian) a type of lamb kebab, also SHASHLICK, SHASLIK [n -S]\n",
  "SHASHLIKS": "SHASHLIK, (Russian) a type of lamb kebab, also SHASHLICK, SHASLIK [n]\n",
  "SHASLIK": "(Russian) a type of lamb kebab, also SHASHLICK, SHASHLIK [n -S]\n",
  "SHASLIKS": "SHASLIK, (Russian) a type of lamb kebab, also SHASHLICK, SHASHLIK [n]\n",
  "SHASTA": "a flowering plant of the daisy family [n -S]\n",
  "SHASTAS": "SHASTA, a flowering plant of the daisy family [n]\n",
  "SHASTER": "(Sanskrit) any of the sacred writings of Hinduism, also SASTRA, SHASTRA [n -S]\n",
  "SHASTERS": "SHASTER, (Sanskrit) any of the sacred writings of Hinduism, also SASTRA, SHASTRA [n]\n",
  "SHASTRA": "(Sanskrit) any of the sacred writings of Hinduism, also SASTRA, SHASTER [n -S]\n",
  "SHASTRAS": "SHASTRA, (Sanskrit) any of the sacred writings of Hinduism, also SASTRA, SHASTER [n]\n",
  "SHAT": "SHIT, (vulgar) to defecate [v]\n",
  "SHATOOSH": "(Persian) a fine wool made from the throat hairs of the chiru antelope, also SHAHTOOSH [n -ES]\n",
  "SHATOOSHES": "SHATOOSH, (Persian) a fine wool made from the throat hairs of the chiru antelope, also SHAHTOOSH [n]\n",
  "SHATTER": "to break into pieces [v -ED, -ING, -S]\n",
  "SHATTERED": "SHATTER, to break into pieces [v]\n",
  "SHATTERER": "something or someone that shatters [n -S]\n",
  "SHATTERERS": "SHATTERER, something or someone that shatters [n]\n",
  "SHATTERIER": "SHATTERY, brittle [adj]\n",
  "SHATTERIEST": "SHATTERY, brittle [adj]\n",
  "SHATTERING": "of e.g. news, devastating [adj SHATTERINGLY]\n",
  "SHATTERINGLY": "SHATTERING, of e.g. news, devastating [adv]\n",
  "SHATTERPROOF": "proof against shattering [adj]\n",
  "SHATTERS": "SHATTER, to break into pieces [v]\n",
  "SHATTERY": "brittle [adj SHATTERIER, SHATTERIEST]\n",
  "SHAUCHLE": "(Scots) to shuffle [v SHAUCHLED, SHAUCHLING, SHAUCHLES]\n",
  "SHAUCHLED": "SHAUCHLE, (Scots) to shuffle [v]\n",
  "SHAUCHLES": "SHAUCHLE, (Scots) to shuffle [v]\n",
  "SHAUCHLIER": "SHAUCHLY, shuffling [adj]\n",
  "SHAUCHLIEST": "SHAUCHLY, shuffling [adj]\n",
  "SHAUCHLING": "SHAUCHLE, (Scots) to shuffle [v]\n",
  "SHAUCHLY": "shuffling [adj SHAUCHLIER, SHAUCHLIEST]\n",
  "SHAUGH": "a thicket [n -S]\n",
  "SHAUGHS": "SHAUGH, a thicket [n]\n",
  "SHAUL": "to become shallow, also SHOAL [v -ED, -ING, -S]\n",
  "SHAULED": "SHAUL, to become shallow, also SHOAL [v]\n",
  "SHAULING": "SHAUL, to become shallow, also SHOAL [v]\n",
  "SHAULS": "SHAUL, to become shallow, also SHOAL [v]\n",
  "SHAVABLE": "capable of being shaved, also SHAVEABLE [adj]\n",
  "SHAVASANA": "a meditative posture in which one lies on one's back that is typically considered the final resting pose in yoga, also SAVASANA [n -S]\n",
  "SHAVASANAS": "SHAVASANA, a meditative posture in which one lies on one's back that is typically considered the final resting pose in yoga, also SAVASANA [n]\n",
  "SHAVE": "to remove hair with a razor [v SHAVED, SHAVEN, SHAVING, SHAVES]\n",
  "SHAVEABLE": "capable of being shaved, also SHAVABLE [adj]\n",
  "SHAVED": "SHAVE, to remove hair with a razor [v]\n",
  "SHAVELING": "a tonsured cleric [n -S]\n",
  "SHAVELINGS": "SHAVELING, a tonsured cleric [n]\n",
  "SHAVEN": "SHAVE, to remove hair with a razor [v]\n",
  "SHAVER": "a youngster [n -S]\n",
  "SHAVERS": "SHAVER, a youngster [n]\n",
  "SHAVES": "SHAVE, to remove hair with a razor [v]\n",
  "SHAVETAIL": "(US slang) a second lieutenant [n -S]\n",
  "SHAVETAILS": "SHAVETAIL, (US slang) a second lieutenant [n]\n",
  "SHAVIE": "(Scots) a trick [n -S]\n",
  "SHAVIES": "SHAVIE, (Scots) a trick [n]\n",
  "SHAVING": "something shaved off [n -S]\n",
  "SHAVINGS": "SHAVING, something shaved off [n]\n",
  "SHAW": "(Scots) to show [v SHAWED, SHAWN, SHAWING, SHAWS]\n",
  "SHAWARMA": "(Arabic) a sandwich of lamb or chicken, veg, and often tahini wrapped in pita [n -S]\n",
  "SHAWARMAS": "SHAWARMA, (Arabic) a sandwich of lamb or chicken, veg, and often tahini wrapped in pita [n]\n",
  "SHAWED": "SHAW, (Scots) to show [v]\n",
  "SHAWING": "SHAW, (Scots) to show [v]\n",
  "SHAWL": "to wrap the shoulders in a covering [v -ED, -ING, -S]\n",
  "SHAWLED": "SHAWL, to wrap the shoulders in a covering [v]\n",
  "SHAWLEY": "in Ireland, a working woman, esp. a fisherwoman, who wears a shawl, also SHAWLIE [n -S]\n",
  "SHAWLEYS": "SHAWLEY, in Ireland, a working woman, esp. a fisherwoman, who wears a shawl, also SHAWLIE [n]\n",
  "SHAWLIE": "in Ireland, a working woman, esp. a fisherwoman, who wears a shawl, also SHAWLEY [n -S]\n",
  "SHAWLIES": "SHAWLIE, in Ireland, a working woman, esp. a fisherwoman, who wears a shawl, also SHAWLEY [n]\n",
  "SHAWLING": "the wearing of a shawl [n -S]\n",
  "SHAWLINGS": "SHAWLING, the wearing of a shawl [n]\n",
  "SHAWLLESS": "without a shawl [adj]\n",
  "SHAWLS": "SHAWL, to wrap the shoulders in a covering [v]\n",
  "SHAWM": "an ancient oboe-like musical instrument, also SHALM [n -S]\n",
  "SHAWMS": "SHAWM, an ancient oboe-like musical instrument, also SHALM [n]\n",
  "SHAWN": "SHAW, (Scots) to show [v]\n",
  "SHAWS": "SHAW, (Scots) to show [v]\n",
  "SHAY": "a light carriage, also CHAISE [n -S]\n",
  "SHAYA": "(Tamil) an Indian plant of the madder family whose root chayroot yields a red dye, also CHAY, CHAYA [n -S]\n",
  "SHAYAS": "SHAYA, (Tamil) an Indian plant of the madder family whose root chayroot yields a red dye, also CHAY, CHAYA [n]\n",
  "SHAYKH": "(Arabic) an Arab chief, also SHAIKH, SHEIK, SHEIKH [n -S]\n",
  "SHAYKHS": "SHAYKH, (Arabic) an Arab chief, also SHAIKH, SHEIK, SHEIKH [n]\n",
  "SHAYS": "SHAY, a light carriage, also CHAISE [n]\n",
  "SHAZAM": "(tradename) a magic slogan [interj]\n",
  "SHCHI": "(Russian) a kind of cabbage soup, also SHTCHI [n -S]\n",
  "SHCHIS": "SHCHI, (Russian) a kind of cabbage soup, also SHTCHI [n]\n",
  "SHE": "a female person [n -S]\n",
  "SHEA": "an African tree, from the seeds of which a substance resembling butter is obtained [n -S]\n",
  "SHEADING": "an administrative division on the Isle of Man [n -S]\n",
  "SHEADINGS": "SHEADING, an administrative division on the Isle of Man [n]\n",
  "SHEAF": "to gather into a bundle, also SHEAVE [v -ED, -ING, -S]\n",
  "SHEAFED": "SHEAF, to gather into a bundle, also SHEAVE [v]\n",
  "SHEAFIER": "SHEAFY, like sheafs [adj]\n",
  "SHEAFIEST": "SHEAFY, like sheafs [adj]\n",
  "SHEAFING": "SHEAF, to gather into a bundle, also SHEAVE [v]\n",
  "SHEAFLIKE": "like a sheaf [adj]\n",
  "SHEAFS": "SHEAF, to gather into a bundle, also SHEAVE [v]\n",
  "SHEAFY": "like sheafs [adj SHEAFIER, SHEAFIEST]\n",
  "SHEAL": "to shell, husk, also SHALE, SHEEL, SHIEL [v -ED, -ING, -S]\n",
  "SHEALED": "SHEAL, to shell, husk, also SHALE, SHEEL, SHIEL [v]\n",
  "SHEALING": "a rough hut near summer pasture used as shelter by shepherds, also SHEILING, SHIELING [n -S]\n",
  "SHEALINGS": "SHEALING, a rough hut near summer pasture used as shelter by shepherds, also SHEILING, SHIELING [n]\n",
  "SHEALS": "SHEAL, to shell, husk, also SHALE, SHEEL, SHIEL [v]\n",
  "SHEAR": "to cut the wool or hair from [v SHEARED or SHORE, SHORN, SHEARING, SHEARS]\n",
  "SHEARED": "SHEAR, to cut the wool or hair from [v]\n",
  "SHEARER": "one who shears (sheep) [n -S]\n",
  "SHEARERS": "SHEARER, one who shears (sheep) [n]\n",
  "SHEARING": "the act of cutting wool or hair [n -S]\n",
  "SHEARINGS": "SHEARING, the act of cutting wool or hair [n]\n",
  "SHEARLEG": "one of the spars of sheers, also SHEERLEG [n -S]\n",
  "SHEARLEGS": "SHEARLEG, one of the spars of sheers, also SHEERLEG [n]\n",
  "SHEARLING": "a one-year-old sheep, from which one crop of wool has been taken [n -S]\n",
  "SHEARLINGS": "SHEARLING, a one-year-old sheep, from which one crop of wool has been taken [n]\n",
  "SHEARMAN": "a textile worker [n SHEARMEN]\n",
  "SHEARMEN": "SHEARMAN, a textile worker [n]\n",
  "SHEARS": "SHEAR, to cut the wool or hair from [v]\n",
  "SHEARWATER": "a gull-like oceanic bird of the petrel family [n -S]\n",
  "SHEARWATERS": "SHEARWATER, a gull-like oceanic bird of the petrel family [n]\n",
  "SHEAS": "SHEA, an African tree, from the seeds of which a substance resembling butter is obtained [n]\n",
  "SHEATFISH": "a European siluroid fish allied to the catfishes, the largest freshwater fish of Europe, also SHEATHFISH [n -ES]\n",
  "SHEATFISHES": "SHEATFISH, a European siluroid fish allied to the catfishes, the largest freshwater fish of Europe, also SHEATHFISH [n]\n",
  "SHEATH": "to put into a protective casing, also SHEATHE [v -ED, -ING, -S]\n",
  "SHEATHBILL": "either of two Antarctic seabirds having a white plumage and a horny sheath at the base of the bill [n -S]\n",
  "SHEATHBILLS": "SHEATHBILL, either of two Antarctic seabirds having a white plumage and a horny sheath at the base of the bill [n]\n",
  "SHEATHE": "to put into a protective casing, also SHEATH [v SHEATHED, SHEATHING, SHEATHES]\n",
  "SHEATHED": "SHEATHE, to put into a protective casing, also SHEATH [v]\n",
  "SHEATHER": "one who sheathes [n -S]\n",
  "SHEATHERS": "SHEATHER, one who sheathes [n]\n",
  "SHEATHES": "SHEATHE, to put into a protective casing, also SHEATH [v]\n",
  "SHEATHFISH": "a European siluroid fish allied to the catfishes, the largest freshwater fish of Europe, also SHEATFISH [n -ES]\n",
  "SHEATHFISHES": "SHEATHFISH, a European siluroid fish allied to the catfishes, the largest freshwater fish of Europe, also SHEATFISH [n]\n",
  "SHEATHIER": "SHEATHY, forming or resembling a sheath or case [adj]\n",
  "SHEATHIEST": "SHEATHY, forming or resembling a sheath or case [adj]\n",
  "SHEATHING": "the act of sheathing [n -S]\n",
  "SHEATHINGS": "SHEATHING, the act of sheathing [n]\n",
  "SHEATHLESS": "without a sheath or case [adj]\n",
  "SHEATHLIKE": "like a sheath [adj]\n",
  "SHEATHS": "SHEATH, to put into a protective casing, also SHEATHE [v]\n",
  "SHEATHY": "forming or resembling a sheath or case [adj SHEATHIER, SHEATHIEST]\n",
  "SHEAVE": "to gather into a bundle, also SHEAF [v SHEAVED, SHEAVING, SHEAVES]\n",
  "SHEAVED": "SHEAVE, to gather into a bundle, also SHEAF [v]\n",
  "SHEAVES": "SHEAVE, to gather into a bundle, also SHEAF [v]\n",
  "SHEAVING": "SHEAVE, to gather into a bundle, also SHEAF [v]\n",
  "SHEBAGGING": "the practice by a female passenger on public transport of placing a bag on the seat beside her, so denying it to another passenger [n -S]\n",
  "SHEBAGGINGS": "SHEBAGGING, the practice by a female passenger on public transport of placing a bag on the seat beside her, so denying it to another passenger [n]\n",
  "SHEBANG": "a situation, organization, or matter [n -S]\n",
  "SHEBANGS": "SHEBANG, a situation, organization, or matter [n]\n",
  "SHEBEAN": "a place where liquor is sold illegally, also SHEBEEN [n -S]\n",
  "SHEBEANS": "SHEBEAN, a place where liquor is sold illegally, also SHEBEEN [n]\n",
  "SHEBEEN": "a place where liquor is sold illegally, also SHEBEAN [n -S] / to operate an illicit liquor shop [v -ED, -ING, -S]\n",
  "SHEBEENED": "SHEBEEN, to operate an illicit liquor shop [v]\n",
  "SHEBEENER": "one who keeps a shebeen [n -S]\n",
  "SHEBEENERS": "SHEBEENER, one who keeps a shebeen [n]\n",
  "SHEBEENING": "keeping in a shebeen [n -S]\n",
  "SHEBEENINGS": "SHEBEENING, keeping in a shebeen [n]\n",
  "SHEBEENS": "SHEBEEN, to operate an illicit liquor shop [v]\n",
  "SHECHITA": "(Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITAH, SHEHITA, SHEHITAH [n -S]\n",
  "SHECHITAH": "(Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITA, SHEHITA, SHEHITAH [n -S]\n",
  "SHECHITAHS": "SHECHITAH, (Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITA, SHEHITA, SHEHITAH [n]\n",
  "SHECHITAS": "SHECHITA, (Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITAH, SHEHITA, SHEHITAH [n]\n",
  "SHECKLATON": "(Spenser) a kind of gilt leather, also CHECKLATON, SCHECKLATON [n -S]\n",
  "SHECKLATONS": "SHECKLATON, (Spenser) a kind of gilt leather, also CHECKLATON, SCHECKLATON [n]\n",
  "SHED": "to cast off [v SHEDDED, SHEDDING, SHEDS]\n",
  "SHEDABLE": "capable of being cast off, also SHEDDABLE [adj]\n",
  "SHEDDABLE": "capable of being cast off, also SHEDABLE [adj]\n",
  "SHEDDED": "SHED, to cast off [v]\n",
  "SHEDDER": "one that casts off something [n -S]\n",
  "SHEDDERS": "SHEDDER, one that casts off something [n]\n",
  "SHEDDING": "the act of casting off [n -S]\n",
  "SHEDDINGS": "SHEDDING, the act of casting off [n]\n",
  "SHEDFUL": "the contents of a shed [n -S]\n",
  "SHEDFULS": "SHEDFUL, the contents of a shed [n]\n",
  "SHEDHAND": "a person who works in a shearing shed [n -S]\n",
  "SHEDHANDS": "SHEDHAND, a person who works in a shearing shed [n]\n",
  "SHEDLIKE": "resembling a small, low structure [adj]\n",
  "SHEDLOAD": "a large amount [n -S]\n",
  "SHEDLOADS": "SHEDLOAD, a large amount [n]\n",
  "SHEDS": "SHED, to cast off [v]\n",
  "SHEEL": "(Shakespeare) to shell, husk, also SHALE, SHEAL, SHIEL [v -ED, -ING, -S]\n",
  "SHEELED": "SHEEL, (Shakespeare) to shell, husk, also SHALE, SHEAL, SHIEL [v]\n",
  "SHEELING": "SHEEL, (Shakespeare) to shell, husk, also SHALE, SHEAL, SHIEL [v]\n",
  "SHEELS": "SHEEL, (Shakespeare) to shell, husk, also SHALE, SHEAL, SHIEL [v]\n",
  "SHEEN": "to shine, have a lustre [v -ED, -ING, -S]\n",
  "SHEENED": "SHEEN, to shine, have a lustre [v]\n",
  "SHEENEY": "(offensive) a Jew, a pawnbroker, also SHEENIE, SHEENY [n -S]\n",
  "SHEENEYS": "SHEENEY, (offensive) a Jew, a pawnbroker, also SHEENIE, SHEENY [n]\n",
  "SHEENFUL": "shining [adj]\n",
  "SHEENIE": "(offensive) a Jew, a pawnbroker, also SHEENEY, SHEENY [n -S]\n",
  "SHEENIER": "SHEENY, bright, shining [adj]\n",
  "SHEENIES": "SHEENIE, (offensive) a Jew, a pawnbroker, also SHEENEY, SHEENY [n]\n",
  "SHEENIEST": "SHEENY, bright, shining [adj]\n",
  "SHEENING": "SHEEN, to shine, have a lustre [v]\n",
  "SHEENS": "SHEEN, to shine, have a lustre [v]\n",
  "SHEENY": "bright, shining [adj SHEENIER, SHEENIEST] / (offensive) a Jew, a pawnbroker, also SHEENEY, SHEENIE [n SHEENIES]\n",
  "SHEEP": "a ruminant woolgrowing mammal [n SHEEP]\n",
  "SHEEPBERRIES": "SHEEPBERRY, the edible fruit of a small North American tree of the genus Viburnum; also, the tree itself [n]\n",
  "SHEEPBERRY": "the edible fruit of a small North American tree of the genus Viburnum; also, the tree itself [n SHEEPBERRIES]\n",
  "SHEEPCOT": "a small enclosure for sheep, also SHEEPCOTE [n -S]\n",
  "SHEEPCOTE": "a small inclosure for sheep, also SHEEPCOT [n -S]\n",
  "SHEEPCOTES": "SHEEPCOTE, a small inclosure for sheep, also SHEEPCOT [n]\n",
  "SHEEPCOTS": "SHEEPCOT, a small enclosure for sheep, also SHEEPCOTE [n]\n",
  "SHEEPDOG": "a dog trained in the care of sheep [n -S]\n",
  "SHEEPDOGS": "SHEEPDOG, a dog trained in the care of sheep [n]\n",
  "SHEEPFOLD": "a pen for sheep [n -S]\n",
  "SHEEPFOLDS": "SHEEPFOLD, a pen for sheep [n]\n",
  "SHEEPHEAD": "a large and valuable sparoid food fish found on the Atlantic coast of the United States, also SHEEPSHEAD [n -S]\n",
  "SHEEPHEADS": "SHEEPHEAD, a large and valuable sparoid food fish found on the Atlantic coast of the United States, also SHEEPSHEAD [n]\n",
  "SHEEPHERDER": "a worker in charge of sheep esp. on open range [n -S]\n",
  "SHEEPHERDERS": "SHEEPHERDER, a worker in charge of sheep esp. on open range [n]\n",
  "SHEEPHERDING": "looking after sheep [n -S]\n",
  "SHEEPHERDINGS": "SHEEPHERDING, looking after sheep [n]\n",
  "SHEEPIER": "SHEEPY, sheeplike [adj]\n",
  "SHEEPIEST": "SHEEPY, sheeplike [adj]\n",
  "SHEEPISH": "embarrassed [adj SHEEPISHLY]\n",
  "SHEEPISHLY": "SHEEPISH, embarrassed [adv]\n",
  "SHEEPISHNESS": "the state of being sheepish [n -ES]\n",
  "SHEEPISHNESSES": "SHEEPISHNESS, the state of being sheepish [n]\n",
  "SHEEPLE": "(colloq.) people who follow the herd blindly [n -S]\n",
  "SHEEPLES": "SHEEPLE, (colloq.) people who follow the herd blindly [n]\n",
  "SHEEPLIKE": "like a sheep [adj]\n",
  "SHEEPMAN": "a man who raises sheep [n SHEEPMEN]\n",
  "SHEEPMEN": "SHEEPMAN, a man who raises sheep [n]\n",
  "SHEEPO": "(New Zealand slang) a worker who drives sheep into a pen for shearing [n -S]\n",
  "SHEEPOS": "SHEEPO, (New Zealand slang) a worker who drives sheep into a pen for shearing [n]\n",
  "SHEEPSHANK": "a hitch by which a rope may be temporarily shortened [n -S]\n",
  "SHEEPSHANKS": "SHEEPSHANK, a hitch by which a rope may be temporarily shortened [n]\n",
  "SHEEPSHEAD": "a large and valuable sparoid food fish found on the Atlantic coast of the United States, also SHEEPHEAD [n -S]\n",
  "SHEEPSHEADS": "SHEEPSHEAD, a large and valuable sparoid food fish found on the Atlantic coast of the United States, also SHEEPHEAD [n]\n",
  "SHEEPSHEARER": "one that shears sheep [n -S]\n",
  "SHEEPSHEARERS": "SHEEPSHEARER, one that shears sheep [n]\n",
  "SHEEPSHEARING": "the act of shearing sheep [n -S]\n",
  "SHEEPSHEARINGS": "SHEEPSHEARING, the act of shearing sheep [n]\n",
  "SHEEPSKIN": "the skin of a sheep [n -S]\n",
  "SHEEPSKINS": "SHEEPSKIN, the skin of a sheep [n]\n",
  "SHEEPTRACK": "a track made by sheep [n -S]\n",
  "SHEEPTRACKS": "SHEEPTRACK, a track made by sheep [n]\n",
  "SHEEPWALK": "a range of pasture for sheep [n -S]\n",
  "SHEEPWALKS": "SHEEPWALK, a range of pasture for sheep [n]\n",
  "SHEEPY": "sheeplike [adj SHEEPIER, SHEEPIEST]\n",
  "SHEER": "utter [adj SHEERER, SHEEREST, SHEERLY] / to swerve, to deviate [v -ED, -ING, -S]\n",
  "SHEERED": "SHEER, to swerve, to deviate [v]\n",
  "SHEERER": "SHEER, utter [adj]\n",
  "SHEEREST": "SHEER, utter [adj]\n",
  "SHEERING": "SHEER, to swerve, to deviate [v]\n",
  "SHEERLEG": "one of the spars of sheers, also SHEARLEG [n -S]\n",
  "SHEERLEGS": "SHEERLEG, one of the spars of sheers, also SHEARLEG [n]\n",
  "SHEERLY": "SHEER, utter [adv]\n",
  "SHEERNESS": "the state of being sheer [n -ES]\n",
  "SHEERNESSES": "SHEERNESS, the state of being sheer [n]\n",
  "SHEERS": "SHEER, to swerve, to deviate [v]\n",
  "SHEESH": "expressing consternation or surprise [interj]\n",
  "SHEESHA": "(Urdu) a kind of water-pipe for smoking, aka hookah, also SHISHA [n -S]\n",
  "SHEESHAS": "SHEESHA, (Urdu) a kind of water-pipe for smoking, aka hookah, also SHISHA [n]\n",
  "SHEET": "to cover with a large piece of material [v -ED, -ING, -S]\n",
  "SHEETED": "SHEET, to cover with a large piece of material [v]\n",
  "SHEETER": "one that sheets [n -S]\n",
  "SHEETERS": "SHEETER, one that sheets [n]\n",
  "SHEETFED": "pertaining to a type of printing press [adj]\n",
  "SHEETIER": "SHEETY, like sheets [adj]\n",
  "SHEETIEST": "SHEETY, like sheets [adj]\n",
  "SHEETING": "cloth for sheets [n -S]\n",
  "SHEETINGS": "SHEETING, cloth for sheets [n]\n",
  "SHEETLESS": "without a sheet [adj]\n",
  "SHEETLIKE": "like a sheet [adj]\n",
  "SHEETROCK": "(tradename) a type of plasterboard [n -S] / to cover with this [v -ED, -ING, -S]\n",
  "SHEETROCKED": "SHEETROCK, to cover with this [v]\n",
  "SHEETROCKING": "SHEETROCK, to cover with this [v]\n",
  "SHEETROCKS": "SHEETROCK, (tradename) a type of plasterboard [n]\n",
  "SHEETS": "SHEET, to cover with a large piece of material [v]\n",
  "SHEETY": "like sheets [adj SHEETIER, SHEETIEST]\n",
  "SHEEVE": "the wheel of a pulley, also SHEAVE [n -S]\n",
  "SHEEVES": "SHEEVE, the wheel of a pulley, also SHEAVE [n]\n",
  "SHEGETZ": "(Yiddish) among Jewish people, a Gentile boy; a Jewish boy not observing traditional Jewish behaviour [n SHKOTZIM]\n",
  "SHEHITA": "(Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITA, SHECHITAH, SHEHITAH [n -S]\n",
  "SHEHITAH": "(Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITA, SHECHITAH, SHEHITA [n -S]\n",
  "SHEHITAHS": "SHEHITAH, (Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITA, SHECHITAH, SHEHITA [n]\n",
  "SHEHITAS": "SHEHITA, (Hebrew) the slaughtering of animals in accordance with rabbinical law, also SCHECHITA, SCHECHITAH, SHECHITA, SHECHITAH, SHEHITAH [n]\n",
  "SHEHNAI": "(Bengali) a double-reed wind instrument of India, also SHENAI [n -S]\n",
  "SHEHNAIS": "SHEHNAI, (Bengali) a double-reed wind instrument of India, also SHENAI [n]\n",
  "SHEIK": "(Arabic) an Arab chief, also SHAIKH, SHAYKH, SHEIKH [n -S]\n",
  "SHEIKDOM": "the domain of a sheik, also SHEIKHDOM [n -S]\n",
  "SHEIKDOMS": "SHEIKDOM, the domain of a sheik, also SHEIKHDOM [n]\n",
  "SHEIKH": "(Arabic) an Arab chief, also SHAIKH, SHAYKH, SHEIK [n -S]\n",
  "SHEIKHA": "(Arabic) the chief wife or consort of a sheikh [n -S]\n",
  "SHEIKHAS": "SHEIKHA, (Arabic) the chief wife or consort of a sheikh [n]\n",
  "SHEIKHDOM": "the domain of a sheikh, also SHEIKDOM [n -S]\n",
  "SHEIKHDOMS": "SHEIKHDOM, the domain of a sheikh, also SHEIKDOM [n]\n",
  "SHEIKHS": "SHEIKH, (Arabic) an Arab chief, also SHAIKH, SHAYKH, SHEIK [n]\n",
  "SHEIKS": "SHEIK, (Arabic) an Arab chief, also SHAIKH, SHAYKH, SHEIKH [n]\n",
  "SHEILA": "(Australian slang) a young girl or woman [n -S]\n",
  "SHEILAS": "SHEILA, (Australian slang) a young girl or woman [n]\n",
  "SHEILING": "a rough hut near summer pasture used as shelter by shepherds, also SHEALING, SHIELING [n -S]\n",
  "SHEILINGS": "SHEILING, a rough hut near summer pasture used as shelter by shepherds, also SHEALING, SHIELING [n]\n",
  "SHEITAN": "(Arabic) an evil spirit, also SHAITAN [n -S]\n",
  "SHEITANS": "SHEITAN, (Arabic) an evil spirit, also SHAITAN [n]\n",
  "SHEITEL": "(Yiddish) a wig worn by a married Jewish woman [n -S]\n",
  "SHEITELS": "SHEITEL, (Yiddish) a wig worn by a married Jewish woman [n]\n",
  "SHEKALIM": "SHEKEL, (Hebrew) the standard unit of currency of Israel, worth 100 agorot, also SHEQEL [n]\n",
  "SHEKEL": "(Hebrew) the standard unit of currency of Israel, worth 100 agorot, also SHEQEL [n SHEKELS, SHEKELIM or SHEKALIM]\n",
  "SHEKELIM": "SHEKEL, (Hebrew) the standard unit of currency of Israel, worth 100 agorot, also SHEQEL [n]\n",
  "SHEKELS": "SHEKEL, (Hebrew) the standard unit of currency of Israel, worth 100 agorot, also SHEQEL [n]\n",
  "SHELDDUCK": "a large duck of genus Tadorna, also SHELDUCK, SHELLDUCK [n -S]\n",
  "SHELDDUCKS": "SHELDDUCK, a large duck of genus Tadorna, also SHELDUCK, SHELLDUCK [n]\n",
  "SHELDRAKE": "a male shelduck, also SHELLDRAKE, SHIELDRAKE [n -S]\n",
  "SHELDRAKES": "SHELDRAKE, a male shelduck, also SHELLDRAKE, SHIELDRAKE [n]\n",
  "SHELDUCK": "a large duck of genus Tadorna, also SHELDDUCK, SHELLDUCK [n -S]\n",
  "SHELDUCKS": "SHELDUCK, a large duck of genus Tadorna, also SHELDDUCK, SHELLDUCK [n]\n",
  "SHELF": "a board fixed horizontally on a wall, for putting things on [n SHELVES] / to put on a shelf, to shelve [v -ED, -ING, -S]\n",
  "SHELFED": "SHELF, to put on a shelf, to shelve [v]\n",
  "SHELFFUL": "as much as a shelf can hold [n -S]\n",
  "SHELFFULS": "SHELFFUL, as much as a shelf can hold [n]\n",
  "SHELFIER": "SHELFY, abounding in shelves; full of dangerous shallows, also SHELVY [adj]\n",
  "SHELFIEST": "SHELFY, abounding in shelves; full of dangerous shallows, also SHELVY [adj]\n",
  "SHELFING": "SHELF, to put on a shelf, to shelve [v]\n",
  "SHELFLIKE": "like a shelf [adj]\n",
  "SHELFROOM": "space or accommodation on shelves [n -S]\n",
  "SHELFROOMS": "SHELFROOM, space or accommodation on shelves [n]\n",
  "SHELFS": "SHELF, to put on a shelf, to shelve [v]\n",
  "SHELFTALKER": "a marketing device, e.g. a notice or mini-poster, attached to a shelf in a shop, to promote a specific product [n -S]\n",
  "SHELFTALKERS": "SHELFTALKER, a marketing device, e.g. a notice or mini-poster, attached to a shelf in a shop, to promote a specific product [n]\n",
  "SHELFY": "abounding in shelves; full of dangerous shallows, also SHELVY [adj SHELFIER, SHELFIEST]\n",
  "SHELL": "to remove the outer covering from nuts [v -ED, -ING, -S]\n",
  "SHELLAC": "to cover with a thin varnish, also SHELLACK [v SHELLACKED, SHELLACKING, SHELLACS]\n",
  "SHELLACK": "to cover with a thin varnish, also SHELLAC [v -ED, -ING, -S]\n",
  "SHELLACKED": "SHELLAC, to cover with a thin varnish, also SHELLACK [v]\n",
  "SHELLACKER": "one who shellacs, defeats completely [n -S]\n",
  "SHELLACKERS": "SHELLACKER, one who shellacs, defeats completely [n]\n",
  "SHELLACKING": "a heavy defeat [n -S]\n",
  "SHELLACKINGS": "SHELLACKING, a heavy defeat [n]\n",
  "SHELLACKS": "SHELLACK, to cover with a thin varnish, also SHELLAC [v]\n",
  "SHELLACS": "SHELLAC, to cover with a thin varnish, also SHELLACK [v]\n",
  "SHELLBACK": "a veteran sailor, esp. one who has crossed the equator [n -S]\n",
  "SHELLBACKS": "SHELLBACK, a veteran sailor, esp. one who has crossed the equator [n]\n",
  "SHELLBARK": "a species of hickory whose outer bark is loose and peeling, aka shagbark [n -S]\n",
  "SHELLBARKS": "SHELLBARK, a species of hickory whose outer bark is loose and peeling, aka shagbark [n]\n",
  "SHELLBOUND": "of a baby bird etc., unable to escape from the shell [adj]\n",
  "SHELLCRACKER": "a kind of sunfish, aka redear [n -S]\n",
  "SHELLCRACKERS": "SHELLCRACKER, a kind of sunfish, aka redear [n]\n",
  "SHELLDRAKE": "a male shelduck, also SHELDRAKE, SHIELDRAKE [n -S]\n",
  "SHELLDRAKES": "SHELLDRAKE, a male shelduck, also SHELDRAKE, SHIELDRAKE [n]\n",
  "SHELLDUCK": "a large duck of genus Tadorna, also SHELDDUCK, SHELDUCK [n -S]\n",
  "SHELLDUCKS": "SHELLDUCK, a large duck of genus Tadorna, also SHELDDUCK, SHELDUCK [n]\n",
  "SHELLED": "SHELL, to remove the outer covering from nuts [v]\n",
  "SHELLER": "one who shells [n -S]\n",
  "SHELLERS": "SHELLER, one who shells [n]\n",
  "SHELLFIRE": "the firing of shells [n -S]\n",
  "SHELLFIRES": "SHELLFIRE, the firing of shells [n]\n",
  "SHELLFISH": "a shelled aquatic invertebrate, esp. a mollusc or crustacean, or such animals collectively [n -ES]\n",
  "SHELLFISHERIES": "SHELLFISHERY, a commercially exploited population of shellfish [n]\n",
  "SHELLFISHERY": "a commercially exploited population of shellfish [n SHELLFISHERIES]\n",
  "SHELLFISHES": "SHELLFISH, a shelled aquatic invertebrate, esp. a mollusc or crustacean, or such animals collectively [n]\n",
  "SHELLFUL": "enough to fill a shell [n -S]\n",
  "SHELLFULS": "SHELLFUL, enough to fill a shell [n]\n",
  "SHELLIER": "SHELLY, abounding in shells [adj]\n",
  "SHELLIEST": "SHELLY, abounding in shells [adj]\n",
  "SHELLINESS": "the state of being shelly [n -ES]\n",
  "SHELLINESSES": "SHELLINESS, the state of being shelly [n]\n",
  "SHELLING": "the act of shelling [n -S]\n",
  "SHELLINGS": "SHELLING, the act of shelling [n]\n",
  "SHELLPROOF": "capable of resisting shells or bombs [adj]\n",
  "SHELLS": "SHELL, to remove the outer covering from nuts [v]\n",
  "SHELLSHOCK": "mental disturbance due to war experiences, once thought to be caused by the bursting of shells [n -S]\n",
  "SHELLSHOCKED": "suffering from shellshock [adj]\n",
  "SHELLSHOCKS": "SHELLSHOCK, mental disturbance due to war experiences, once thought to be caused by the bursting of shells [n]\n",
  "SHELLWORK": "work composed of shells, or adorned with them [n -S]\n",
  "SHELLWORKS": "SHELLWORK, work composed of shells, or adorned with them [n]\n",
  "SHELLY": "abounding in shells [adj SHELLIER, SHELLIEST]\n",
  "SHELLYCOAT": "(Scots) a water goblin dressed in shells [n -S]\n",
  "SHELLYCOATS": "SHELLYCOAT, (Scots) a water goblin dressed in shells [n]\n",
  "SHELTA": "(Irish) a secret jargon used by vagrants in Britain and Ireland [n -S]\n",
  "SHELTAS": "SHELTA, (Irish) a secret jargon used by vagrants in Britain and Ireland [n]\n",
  "SHELTER": "to provide cover or protection [v -ED, -ING, -S]\n",
  "SHELTERBELT": "a row of trees providing shelter from the wind [n -S]\n",
  "SHELTERBELTS": "SHELTERBELT, a row of trees providing shelter from the wind [n]\n",
  "SHELTERED": "SHELTER, to provide cover or protection [v]\n",
  "SHELTERER": "one who shelters [n -S]\n",
  "SHELTERERS": "SHELTERER, one who shelters [n]\n",
  "SHELTERIER": "SHELTERY, affording shelter [adj]\n",
  "SHELTERIEST": "SHELTERY, affording shelter [adj]\n",
  "SHELTERING": "the act of sheltering [n -S]\n",
  "SHELTERINGS": "SHELTERING, the act of sheltering [n]\n",
  "SHELTERLESS": "without shelter [adj]\n",
  "SHELTERS": "SHELTER, to provide cover or protection [v]\n",
  "SHELTERY": "affording shelter [adj SHELTERIER, SHELTERIEST]\n",
  "SHELTIE": "(Old Norse) a small, shaggy pony, also SHELTY [n -S]\n",
  "SHELTIES": "SHELTIE, (Old Norse) a small, shaggy pony, also SHELTY [n]\n",
  "SHELTY": "(Old Norse) a small, shaggy pony, also SHELTIE [n SHELTIES]\n",
  "SHELVE": "to place on a shelf; to postpone [v SHELVED, SHELVING, SHELVES]\n",
  "SHELVED": "SHELVE, to place on a shelf; to postpone [v]\n",
  "SHELVER": "a person employed to tilt and unload carts [n -S]\n",
  "SHELVERS": "SHELVER, a person employed to tilt and unload carts [n]\n",
  "SHELVES": "SHELVE, to place on a shelf; to postpone [v]\n",
  "SHELVIER": "SHELVY, having sandbanks, overhanging, also SHELFY [adj]\n",
  "SHELVIEST": "SHELVY, having sandbanks, overhanging, also SHELFY [adj]\n",
  "SHELVING": "material for shelves [n -S]\n",
  "SHELVINGS": "SHELVING, material for shelves [n]\n",
  "SHELVY": "having sandbanks, overhanging, also SHELFY [adj SHELVIER, SHELVIEST]\n",
  "SHEMALE": "a person, born a male, who has acquired female physical characteristics as a result of hormone treatment, but has not had surgery to remove the male genitalia [n -S]\n",
  "SHEMALES": "SHEMALE, a person, born a male, who has acquired female physical characteristics as a result of hormone treatment, but has not had surgery to remove the male genitalia [n]\n",
  "SHEMOZZLE": "(Yiddish) a mess, a scrape [n -S] / to make off, also SCHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v SHEMOZZLED, SHEMOZZLING, SHEMOZZLES]\n",
  "SHEMOZZLED": "SHEMOZZLE, to make off, also SCHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v]\n",
  "SHEMOZZLES": "SHEMOZZLE, to make off, also SCHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v]\n",
  "SHEMOZZLING": "SHEMOZZLE, to make off, also SCHEMOZZLE, SHIMOZZLE, SHLEMOZZLE [v]\n",
  "SHEN": "(Chinese) the spiritual element of a person's psyche [n SHEN]\n",
  "SHENAI": "(Bengali) a double-reed wind instrument of India, also SHEHNAI [n -S]\n",
  "SHENAIS": "SHENAI, (Bengali) a double-reed wind instrument of India, also SHEHNAI [n]\n",
  "SHENANIGAN": "a deceitful trick or mischievous act [n -S]\n",
  "SHENANIGANS": "SHENANIGAN, a deceitful trick or mischievous act [n]\n",
  "SHEND": "(archaic) to put to shame, chide, also YSHEND [v SHENT, SHENDING, SHENDS]\n",
  "SHENDING": "SHEND, (archaic) to put to shame, chide, also YSHEND [v]\n",
  "SHENDS": "SHEND, (archaic) to put to shame, chide, also YSHEND [v]\n",
  "SHENT": "SHEND, (archaic) to put to shame, chide, also YSHEND [v]\n",
  "SHEOL": "(Hebrew) the place of departed spirits, hell [n -S]\n",
  "SHEOLS": "SHEOL, (Hebrew) the place of departed spirits, hell [n]\n",
  "SHEPHERD": "to watch over carefully [v -ED, -ING, -S]\n",
  "SHEPHERDED": "SHEPHERD, to watch over carefully [v]\n",
  "SHEPHERDESS": "a woman or girl who tends sheep [n -ES]\n",
  "SHEPHERDESSES": "SHEPHERDESS, a woman or girl who tends sheep [n]\n",
  "SHEPHERDING": "the act of watching over carefully [n -S]\n",
  "SHEPHERDINGS": "SHEPHERDING, the act of watching over carefully [n]\n",
  "SHEPHERDLESS": "without a shepherd [adj]\n",
  "SHEPHERDLING": "a little shepherd [n -S]\n",
  "SHEPHERDLINGS": "SHEPHERDLING, a little shepherd [n]\n",
  "SHEPHERDS": "SHEPHERD, to watch over carefully [v]\n",
  "SHEQALIM": "SHEQEL, (Hebrew) an ancient unit of weight and money, also SHEKEL [n]\n",
  "SHEQEL": "(Hebrew) an ancient unit of weight and money, also SHEKEL [n SHEQELS or SHEQALIM]\n",
  "SHEQELS": "SHEQEL, (Hebrew) an ancient unit of weight and money, also SHEKEL [n]\n",
  "SHERANG": "(Australian slang) a boss, head person [n -S]\n",
  "SHERANGS": "SHERANG, (Australian slang) a boss, head person [n]\n",
  "SHERARDISATION": "the process of sherardising, also SHERARDIZATION [n -S]\n",
  "SHERARDISATIONS": "SHERARDISATION, the process of sherardising, also SHERARDIZATION [n]\n",
  "SHERARDISE": "to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDIZE [v SHERARDISED, SHERARDISING, SHERARDISES]\n",
  "SHERARDISED": "SHERARDISE, to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDIZE [v]\n",
  "SHERARDISES": "SHERARDISE, to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDIZE [v]\n",
  "SHERARDISING": "SHERARDISE, to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDIZE [v]\n",
  "SHERARDIZATION": "the process of sherardizing, also SHERARDISATION [n -S]\n",
  "SHERARDIZATIONS": "SHERARDIZATION, the process of sherardizing, also SHERARDISATION [n]\n",
  "SHERARDIZE": "to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDISE [v SHERARDIZED, SHERARDIZING, SHERARDIZES]\n",
  "SHERARDIZED": "SHERARDIZE, to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDISE [v]\n",
  "SHERARDIZES": "SHERARDIZE, to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDISE [v]\n",
  "SHERARDIZING": "SHERARDIZE, to coat with zinc by heating with zinc-dust in a vacuum, also SHERARDISE [v]\n",
  "SHERBERT": "(Arabic) a frozen fruit-flavored mixture, also SHERBET [n -S]\n",
  "SHERBERTS": "SHERBERT, (Arabic) a frozen fruit-flavored mixture, also SHERBET [n]\n",
  "SHERBET": "(Arabic) a frozen fruit-flavored mixture, also SHERBERT [n -S]\n",
  "SHERBETS": "SHERBET, (Arabic) a frozen fruit-flavored mixture, also SHERBERT [n]\n",
  "SHERD": "a fragment of broken pottery, also SHARD, SHAIRD [n -S]\n",
  "SHERDS": "SHERD, a fragment of broken pottery, also SHARD, SHAIRD [n]\n",
  "SHERE": "(Spenser) sheer [adj]\n",
  "SHEREEF": "(Arabic) a descendant of the prophet Muhammad through his daughter Fatima, also SHARIF, SHERIF [n -S]\n",
  "SHEREEFIAN": "relating to a shereef, a descendant of Mohammed through his daugher Fatima [adj]\n",
  "SHEREEFS": "SHEREEF, (Arabic) a descendant of the prophet Muhammad through his daughter Fatima, also SHARIF, SHERIF [n]\n",
  "SHERGOTTITE": "a type of meteorite, composed of solidified lava from celestial bodies other than earth [n -S]\n",
  "SHERGOTTITES": "SHERGOTTITE, a type of meteorite, composed of solidified lava from celestial bodies other than earth [n]\n",
  "SHERIA": "(Turkish) the body of Islamic religious law, also SHARIA, SHARIAH, SHARIAT, SHERIAT [n -S]\n",
  "SHERIAS": "SHERIA, (Turkish) the body of Islamic religious law, also SHARIA, SHARIAH, SHARIAT, SHERIAT [n]\n",
  "SHERIAT": "(Turkish) the body of Islamic religious law, also SHARIA, SHARIAH, SHARIAT, SHERIA [n -S]\n",
  "SHERIATS": "SHERIAT, (Turkish) the body of Islamic religious law, also SHARIA, SHARIAH, SHARIAT, SHERIA [n]\n",
  "SHERIF": "(Arabic) a descendant of the prophet Muhammad through his daughter Fatima, also SHARIF, SHEREEF [n -S]\n",
  "SHERIFF": "a law-enforcement officer of a county, also SHIRRA [n -S]\n",
  "SHERIFFALTIES": "SHERIFFALTY, the office of sheriff, also SHRIEVALTY [n]\n",
  "SHERIFFALTY": "the office of sheriff, also SHRIEVALTY [n SHERIFFALTIES]\n",
  "SHERIFFDOM": "the office of sheriff [n -S]\n",
  "SHERIFFDOMS": "SHERIFFDOM, the office of sheriff [n]\n",
  "SHERIFFS": "SHERIFF, a law-enforcement officer of a county, also SHIRRA [n]\n",
  "SHERIFFSHIP": "the office of sheriff [n -S]\n",
  "SHERIFFSHIPS": "SHERIFFSHIP, the office of sheriff [n]\n",
  "SHERIFIAN": "relating to a sherif, a descendant of Mohammed through his daugher Fatima, also SHARIFIAN [adj]\n",
  "SHERIFS": "SHERIF, (Arabic) a descendant of the prophet Muhammad through his daughter Fatima, also SHARIF, SHEREEF [n]\n",
  "SHERLOCK": "to investigate (something) in the manner of a detective [v -ED, -ING, -S]\n",
  "SHERLOCKED": "SHERLOCK, to investigate (something) in the manner of a detective [v]\n",
  "SHERLOCKING": "SHERLOCK, to investigate (something) in the manner of a detective [v]\n",
  "SHERLOCKS": "SHERLOCK, to investigate (something) in the manner of a detective [v]\n",
  "SHERO": "a woman regarded as a hero [n -ES]\n",
  "SHEROES": "SHERO, a woman regarded as a hero [n]\n",
  "SHEROOT": "(Tamil) a square-cut cigar, also CHEROOT [n -S]\n",
  "SHEROOTS": "SHEROOT, (Tamil) a square-cut cigar, also CHEROOT [n]\n",
  "SHERPA": "an aide to, or personal representative of, a head of government participating in a summit conference [n -S]\n",
  "SHERPAS": "SHERPA, an aide to, or personal representative of, a head of government participating in a summit conference [n]\n",
  "SHERRIED": "cooked or flavoured with sherry [adj]\n",
  "SHERRIES": "SHERRY, a fortified wine, originally from the Jerez region in South Spain, usually drunk as an aperitif [n]\n",
  "SHERRIS": "(archaic) sherry [n -ES]\n",
  "SHERRISES": "SHERRIS, (archaic) sherry [n]\n",
  "SHERRY": "a fortified wine, originally from the Jerez region in South Spain, usually drunk as an aperitif [n SHERRIES]\n",
  "SHERWANI": "(Hindi) in India, a man's knee-length coat buttoning up to the chin [n -S]\n",
  "SHERWANIS": "SHERWANI, (Hindi) in India, a man's knee-length coat buttoning up to the chin [n]\n",
  "SHES": "SHE, a female person [n]\n",
  "SHET": "(dialect) to shut [v SHET, SHETTING, SHETS]\n",
  "SHETLAND": "a lightweight loosely twisted wool fabric [n -S]\n",
  "SHETLANDS": "SHETLAND, a lightweight loosely twisted wool fabric [n]\n",
  "SHETS": "SHET, (dialect) to shut [v]\n",
  "SHETTING": "SHET, (dialect) to shut [v]\n",
  "SHEUCH": "(Scots) to plant temporarily, also SHEUGH [v -ED, -ING, -S]\n",
  "SHEUCHED": "SHEUCH, (Scots) to plant temporarily, also SHEUGH [v]\n",
  "SHEUCHING": "SHEUCH, (Scots) to plant temporarily, also SHEUGH [v]\n",
  "SHEUCHS": "SHEUCH, (Scots) to plant temporarily, also SHEUGH [v]\n",
  "SHEUGH": "(Scots) to plant temporarily, also SHEUCH [v -ED, -ING, -S]\n",
  "SHEUGHED": "SHEUGH, (Scots) to plant temporarily, also SHEUCH [v]\n",
  "SHEUGHING": "SHEUGH, (Scots) to plant temporarily, also SHEUCH [v]\n",
  "SHEUGHS": "SHEUGH, (Scots) to plant temporarily, also SHEUCH [v]\n",
  "SHEVA": "(Hebrew) in Hebrew grammar, a point placed under a consonant to indicate absence of a vowel [n -S]\n",
  "SHEVAS": "SHEVA, (Hebrew) in Hebrew grammar, a point placed under a consonant to indicate absence of a vowel [n]\n",
  "SHEW": "(archaic) to show, also SHAW [v SHEWED, SHEWN, SHEWING, SHEWS]\n",
  "SHEWBREAD": "twelve loaves placed every Sabbath beside the altar in the Jewish Temple and eaten by the priests at the end of the week, also SHOWBREAD [n -S]\n",
  "SHEWBREADS": "SHEWBREAD, twelve loaves placed every Sabbath beside the altar in the Jewish Temple and eaten by the priests at the end of the week, also SHOWBREAD [n]\n",
  "SHEWED": "SHEW, (archaic) to show, also SHAW [v]\n",
  "SHEWEL": "a scarecrow, a device to scare away deer, also SEWEL [n -S]\n",
  "SHEWELS": "SHEWEL, a scarecrow, a device to scare away deer, also SEWEL [n]\n",
  "SHEWER": "one who shews [n -S]\n",
  "SHEWERS": "SHEWER, one who shews [n]\n",
  "SHEWING": "SHEW, (archaic) to show, also SHAW [v]\n",
  "SHEWN": "SHEW, (archaic) to show, also SHAW [v]\n",
  "SHEWS": "SHEW, (archaic) to show, also SHAW [v]\n",
  "SHH": "an interjection requesting silence, also SH, SHA, SHHH [interj]\n",
  "SHHH": "an interjection requesting quietness, also SH, SHA, SHH [interj]\n",
  "SHIAI": "(Japanese) a judo contest [n -S]\n",
  "SHIAIS": "SHIAI, (Japanese) a judo contest [n]\n",
  "SHIATSU": "(Japanese) a massage technique using finger pressure at acupuncture centers, also SHIATZU [n -S]\n",
  "SHIATSUS": "SHIATSU, (Japanese) a massage technique using finger pressure at acupuncture centers, also SHIATZU [n]\n",
  "SHIATZU": "(Japanese) a massage technique using finger pressure at acupuncture centers, also SHIATSU [n -S]\n",
  "SHIATZUS": "SHIATZU, (Japanese) a massage technique using finger pressure at acupuncture centers, also SHIATSU [n]\n",
  "SHIBAH": "(Hebrew) in Judaism, a period of seven days' mourning observed after a family member's funeral, also SHIVA, SHIVAH [n -S]\n",
  "SHIBAHS": "SHIBAH, (Hebrew) in Judaism, a period of seven days' mourning observed after a family member's funeral, also SHIVA, SHIVAH [n]\n",
  "SHIBBOLETH": "(Hebrew) a slogan, catchword; a custom or usage regarded as a criterion for distinguishing membership [n -S]\n",
  "SHIBBOLETHS": "SHIBBOLETH, (Hebrew) a slogan, catchword; a custom or usage regarded as a criterion for distinguishing membership [n]\n",
  "SHIBUICHI": "(Japanese) an alloy of three parts copper to one part silver, used in Japanese decorative art to give a silver-grey patina [n -S]\n",
  "SHIBUICHIS": "SHIBUICHI, (Japanese) an alloy of three parts copper to one part silver, used in Japanese decorative art to give a silver-grey patina [n]\n",
  "SHICKER": "(Australian slang) strong liquor; a drunk, also SHIKKER [n -S]\n",
  "SHICKERED": "(Australian slang) drunk, also SHIKKERED [adj]\n",
  "SHICKERS": "SHICKER, (Australian slang) strong liquor; a drunk, also SHIKKER [n]\n",
  "SHICKSA": "(Yiddish) a non-Jewish girl or woman, also SHIKSA, SHIKSE, SHIKSEH [n -S]\n",
  "SHICKSAS": "SHICKSA, (Yiddish) a non-Jewish girl or woman, also SHIKSA, SHIKSE, SHIKSEH [n]\n",
  "SHIDDER": "(Spenser) a female animal [n -S]\n",
  "SHIDDERS": "SHIDDER, (Spenser) a female animal [n]\n",
  "SHIDDUCH": "(Yiddish) an arranged marriage [n SHIDDUCHIM]\n",
  "SHIDDUCHIM": "SHIDDUCH, (Yiddish) an arranged marriage [n]\n",
  "SHIED": "SHY, to jump aside, recoil [v]\n",
  "SHIEL": "(Shakespeare) to shell, husk, also SHALE, SHEAL, SHEEL [v -ED, -ING, -S]\n",
  "SHIELD": "to protect from harm [v -ED, -ING, -S]\n",
  "SHIELDED": "SHIELD, to protect from harm [v]\n",
  "SHIELDER": "one who shields [n -S]\n",
  "SHIELDERS": "SHIELDER, one who shields [n]\n",
  "SHIELDING": "the act of protecting [n -S]\n",
  "SHIELDINGS": "SHIELDING, the act of protecting [n]\n",
  "SHIELDLESS": "destitute of a shield, or of protection [adj]\n",
  "SHIELDLIKE": "like a shield [adj]\n",
  "SHIELDLING": "a protected person [n -S]\n",
  "SHIELDLINGS": "SHIELDLING, a protected person [n]\n",
  "SHIELDRAKE": "a male shelduck, also SHELDRAKE, SHELLDRAKE [n -S]\n",
  "SHIELDRAKES": "SHIELDRAKE, a male shelduck, also SHELDRAKE, SHELLDRAKE [n]\n",
  "SHIELDS": "SHIELD, to protect from harm [v]\n",
  "SHIELDWALL": "a defence of interlocked shields [n -S]\n",
  "SHIELDWALLS": "SHIELDWALL, a defence of interlocked shields [n]\n",
  "SHIELED": "SHIEL, (Shakespeare) to shell, husk, also SHALE, SHEAL, SHEEL [v]\n",
  "SHIELING": "a rough hut near summer pasture used as shelter by shepherds, also SHEALING, SHEILING [n -S]\n",
  "SHIELINGS": "SHIELING, a rough hut near summer pasture used as shelter by shepherds, also SHEALING, SHEILING [n]\n",
  "SHIELS": "SHIEL, (Shakespeare) to shell, husk, also SHALE, SHEAL, SHEEL [v]\n",
  "SHIER": "a horse that shies, also SHYER [n -S]\n",
  "SHIERS": "SHIER, a horse that shies, also SHYER [n]\n",
  "SHIES": "SHY, to jump aside, recoil [v]\n",
  "SHIEST": "SHY, embarrassed, bashful [adj]\n",
  "SHIFT": "to move from one position to another [v -ED, -ING, -S]\n",
  "SHIFTABLE": "capable of being shifted [adj]\n",
  "SHIFTED": "SHIFT, to move from one position to another [v]\n",
  "SHIFTER": "one who shifts [n -S]\n",
  "SHIFTERS": "SHIFTER, one who shifts [n]\n",
  "SHIFTIER": "SHIFTY, evasive [adj]\n",
  "SHIFTIEST": "SHIFTY, evasive [adj]\n",
  "SHIFTILY": "SHIFTY, evasive [adv]\n",
  "SHIFTINESS": "the state of being shifty [n -ES]\n",
  "SHIFTINESSES": "SHIFTINESS, the state of being shifty [n]\n",
  "SHIFTING": "the act of shifting [n -S]\n",
  "SHIFTINGS": "SHIFTING, the act of shifting [n]\n",
  "SHIFTLESS": "feckless [adj SHIFTLESSLY]\n",
  "SHIFTLESSLY": "SHIFTLESS, feckless [adv]\n",
  "SHIFTLESSNESS": "the state of being shiftless [n -ES]\n",
  "SHIFTLESSNESSES": "SHIFTLESSNESS, the state of being shiftless [n]\n",
  "SHIFTS": "SHIFT, to move from one position to another [v]\n",
  "SHIFTSTICK": "(US) a gear lever [n -S]\n",
  "SHIFTSTICKS": "SHIFTSTICK, (US) a gear lever [n]\n",
  "SHIFTWORK": "a system of working involving shifts outside the normal hours of work [n -S]\n",
  "SHIFTWORKS": "SHIFTWORK, a system of working involving shifts outside the normal hours of work [n]\n",
  "SHIFTY": "evasive [adj SHIFTIER, SHIFTIEST, SHIFTILY]\n",
  "SHIGELLA": "a rod-shaped bacterium that causes bacillary dysentery [n SHIGELLAS or SHIGELLAE]\n",
  "SHIGELLAE": "SHIGELLA, a rod-shaped bacterium that causes bacillary dysentery [n]\n",
  "SHIGELLAS": "SHIGELLA, a rod-shaped bacterium that causes bacillary dysentery [n]\n",
  "SHIGELLOSES": "SHIGELLOSIS, infestation of the intestinal tract by shigella, causing bacillary dysentery [n]\n",
  "SHIGELLOSIS": "infestation of the intestinal tract by shigella, causing bacillary dysentery [n SHIGELLOSES]\n",
  "SHIITAKE": "(Japanese) a large dark brown mushroom used in Japanese cookery, also SHITAKE [n -S]\n",
  "SHIITAKES": "SHIITAKE, (Japanese) a large dark brown mushroom used in Japanese cookery, also SHITAKE [n]\n",
  "SHIKAR": "(Urdu) to hunt (animal) as sport [v SHIKARRED, SHIKARRING, SHIKARS]\n",
  "SHIKARA": "(Hindi) a light, flat-bottomed boat in Kashmir [n -S]\n",
  "SHIKARAS": "SHIKARA, (Hindi) a light, flat-bottomed boat in Kashmir [n]\n",
  "SHIKAREE": "(Urdu) a hunter, esp. of big game, also SHIKARI [n -S]\n",
  "SHIKAREES": "SHIKAREE, (Urdu) a hunter, esp. of big game, also SHIKARI [n]\n",
  "SHIKARI": "(Urdu) a hunter, esp. of big game, also SHIKAREE [n -S]\n",
  "SHIKARIS": "SHIKARI, (Urdu) a hunter, esp. of big game, also SHIKAREE [n]\n",
  "SHIKARRED": "SHIKAR, (Urdu) to hunt (animal) as sport [v]\n",
  "SHIKARRING": "SHIKAR, (Urdu) to hunt (animal) as sport [v]\n",
  "SHIKARS": "SHIKAR, (Urdu) to hunt (animal) as sport [v]\n",
  "SHIKKER": "(Australian slang) strong liquor; a drunk, also SHICKER [n -S]\n",
  "SHIKKERED": "(Australian slang) drunk, also SHICKERED [adj]\n",
  "SHIKKERS": "SHIKKER, (Australian slang) strong liquor; a drunk, also SHICKER [n]\n",
  "SHIKRA": "(Hindi) a small sparrow hawk [n -S]\n",
  "SHIKRAS": "SHIKRA, (Hindi) a small sparrow hawk [n]\n",
  "SHIKSA": "(Yiddish) a non-Jewish girl or young woman, also SHICKSA, SHIKSE, SHIKSEH [n -S]\n",
  "SHIKSAS": "SHIKSA, (Yiddish) a non-Jewish girl or young woman, also SHICKSA, SHIKSE, SHIKSEH [n]\n",
  "SHIKSE": "(Yiddish) a non-Jewish girl or young woman, also SHICKSA, SHIKSA, SHIKSEH [n -S]\n",
  "SHIKSEH": "(Yiddish) a non-Jewish girl or young woman, also SHICKSA, SHIKSA, SHIKSE [n -S]\n",
  "SHIKSEHS": "SHIKSEH, (Yiddish) a non-Jewish girl or young woman, also SHICKSA, SHIKSA, SHIKSE [n]\n",
  "SHIKSES": "SHIKSE, (Yiddish) a non-Jewish girl or young woman, also SHICKSA, SHIKSA, SHIKSEH [n]\n",
  "SHILINGI": "a monetary unit of Tanzania [n -S]\n",
  "SHILINGIS": "SHILINGI, a monetary unit of Tanzania [n]\n",
  "SHILL": "to act as a decoy [v -ED, -ING, -S]\n",
  "SHILLABER": "an accomplice to a tradesman etc. who acts as a stooge, also SHILL [n -S]\n",
  "SHILLABERS": "SHILLABER, an accomplice to a tradesman etc. who acts as a stooge, also SHILL [n]\n",
  "SHILLALA": "(Irish) an Irish cudgel, also SHILLALAH, SHILLELAGH, SHILLELAH [n -S]\n",
  "SHILLALAH": "(Irish) an Irish cudgel, also SHILLALA, SHILLELAGH, SHILLELAH [n -S]\n",
  "SHILLALAHS": "SHILLALAH, (Irish) an Irish cudgel, also SHILLALA, SHILLELAGH, SHILLELAH [n]\n",
  "SHILLALAS": "SHILLALA, (Irish) an Irish cudgel, also SHILLALAH, SHILLELAGH, SHILLELAH [n]\n",
  "SHILLED": "SHILL, to act as a decoy [v]\n",
  "SHILLELAGH": "(Irish) an Irish cudgel, also SHILLALA, SHILLALAH, SHILLELAH [n -S]\n",
  "SHILLELAGHS": "SHILLELAGH, (Irish) an Irish cudgel, also SHILLALA, SHILLALAH, SHILLELAH [n]\n",
  "SHILLELAH": "(Irish) an Irish cudgel, also SHILLALA, SHILLALAH, SHILLELAGH [n -S]\n",
  "SHILLELAHS": "SHILLELAH, (Irish) an Irish cudgel, also SHILLALA, SHILLALAH, SHILLELAGH [n]\n",
  "SHILLING": "a former monetary unit of Great Britain [n -S]\n",
  "SHILLINGLESS": "without a shilling [adj]\n",
  "SHILLINGS": "SHILLING, a former monetary unit of Great Britain [n]\n",
  "SHILLINGSWORTH": "goods to the value of a shilling [n -S]\n",
  "SHILLINGSWORTHS": "SHILLINGSWORTH, goods to the value of a shilling [n]\n",
  "SHILLS": "SHILL, to act as a decoy [v]\n",
  "SHILLYSHALLIED": "SHILLYSHALLY, to be indecisive [v]\n",
  "SHILLYSHALLIER": "one who is indecisive [n -S]\n",
  "SHILLYSHALLIERS": "SHILLYSHALLIER, one who is indecisive [n]\n",
  "SHILLYSHALLIES": "SHILLYSHALLY, to be indecisive [v]\n",
  "SHILLYSHALLY": "to be indecisive [v SHILLYSHALLIED, SHILLYSHALLYING, SHILLYSHALLIES]\n",
  "SHILLYSHALLYING": "SHILLYSHALLY, to be indecisive [v]\n",
  "SHILPIT": "(Scots) sickly-looking, puny [adj]\n",
  "SHILY": "SHY, embarrassed, bashful [adv]\n",
  "SHIM": "to adjust by using a thin strip of metal or wood [v SHIMMED, SHIMMING, SHIMS]\n",
  "SHIMAAL": "(Arabic) in the Middle East, a hot dry north wind that carries sand in desert places, also SHAMAL [n -S]\n",
  "SHIMAALS": "SHIMAAL, (Arabic) in the Middle East, a hot dry north wind that carries sand in desert places, also SHAMAL [n]\n",
  "SHIMMED": "SHIM, to adjust by using a thin strip of metal or wood [v]\n",
  "SHIMMER": "to glimmer [v -ED, -ING, -S]\n",
  "SHIMMERED": "SHIMMER, to glimmer [v]\n",
  "SHIMMERIER": "SHIMMERY, glistening [adj]\n",
  "SHIMMERIEST": "SHIMMERY, glistening [adj]\n",
  "SHIMMERING": "a tremulous gleam [n -S]\n",
  "SHIMMERINGLY": "SHIMMERING [adv]\n",
  "SHIMMERINGS": "SHIMMERING, a tremulous gleam [n]\n",
  "SHIMMERS": "SHIMMER, to glimmer [v]\n",
  "SHIMMERY": "glistening [adj SHIMMERIER, SHIMMERIEST]\n",
  "SHIMMEY": "a chemise [n -S]\n",
  "SHIMMEYS": "SHIMMEY, a chemise [n]\n",
  "SHIMMIED": "SHIMMY, to dance the shimmy [v]\n",
  "SHIMMIES": "SHIMMY, to dance the shimmy [v]\n",
  "SHIMMING": "SHIM, to adjust by using a thin strip of metal or wood [v]\n",
  "SHIMMY": "a jazz dance featuring rapid shaking of the body [n SHIMMIES] / to dance the shimmy [v SHIMMIED, SHIMMYING, SHIMMIES]\n",
  "SHIMMYING": "SHIMMY, to dance the shimmy [v]\n",
  "SHIMOZZLE": "(Yiddish) a mess, a scrape, also SCHEMOZZLE, SHEMOZZLE, SHLEMOZZLE [n -S]\n",
  "SHIMOZZLES": "SHIMOZZLE, (Yiddish) a mess, a scrape, also SCHEMOZZLE, SHEMOZZLE, SHLEMOZZLE [n]\n",
  "SHIMS": "SHIM, to adjust by using a thin strip of metal or wood [v]\n",
  "SHIN": "to climb by gripping with the hands and legs, also SHINNY [v SHINNED, SHINNING, SHINS]\n",
  "SHINBONE": "the tibia [n -S]\n",
  "SHINBONES": "SHINBONE, the tibia [n]\n",
  "SHINDIES": "SHINDY, a commotion, uproar [n]\n",
  "SHINDIG": "a lively noisy gathering [n -S]\n",
  "SHINDIGS": "SHINDIG, a lively noisy gathering [n]\n",
  "SHINDY": "a commotion, uproar [n SHINDYS or SHINDIES]\n",
  "SHINDYS": "SHINDY, a commotion, uproar [n]\n",
  "SHINE": "to emit light [v SHONE or SHINED, SHINING, SHINES]\n",
  "SHINED": "SHINE, to emit light [v]\n",
  "SHINELESS": "without shine [adj]\n",
  "SHINER": "a black eye [n -S]\n",
  "SHINERS": "SHINER, a black eye [n]\n",
  "SHINES": "SHINE, to emit light [v]\n",
  "SHINESS": "(obsolete) shyness [n -ES]\n",
  "SHINESSES": "SHINESS, (obsolete) shyness [n]\n",
  "SHINGLE": "to cover with thin tiles of wood [v SHINGLED, SHINGLING, SHINGLES]\n",
  "SHINGLED": "SHINGLE, to cover with thin tiles of wood [v]\n",
  "SHINGLER": "a person who shingles houses etc. [n -S]\n",
  "SHINGLERS": "SHINGLER, a person who shingles houses etc. [n]\n",
  "SHINGLES": "SHINGLE, to cover with thin tiles of wood [v]\n",
  "SHINGLIER": "SHINGLY, covered with small, loose stones [adj]\n",
  "SHINGLIEST": "SHINGLY, covered with small, loose stones [adj]\n",
  "SHINGLING": "shingles collectively; the act or process of laying shingles [n -S]\n",
  "SHINGLINGS": "SHINGLING, shingles collectively; the act or process of laying shingles [n]\n",
  "SHINGLY": "covered with small, loose stones [adj SHINGLIER, SHINGLIEST]\n",
  "SHINGUARD": "a protection for the shin when playing football [n -S]\n",
  "SHINGUARDS": "SHINGUARD, a protection for the shin when playing football [n]\n",
  "SHINIER": "SHINY, filled with light [adj]\n",
  "SHINIES": "SHINY, a bright object [n]\n",
  "SHINIEST": "SHINY, filled with light [adj]\n",
  "SHINILY": "SHINY, filled with light [adv]\n",
  "SHININESS": "the state of being shiny [n -ES]\n",
  "SHININESSES": "SHININESS, the state of being shiny [n]\n",
  "SHINING": "bright, gleaming; excellent [adj SHININGLY]\n",
  "SHININGLY": "SHINING, bright, gleaming; excellent [adv]\n",
  "SHININGNESS": "the state of being shining [n -ES]\n",
  "SHININGNESSES": "SHININGNESS, the state of being shining [n]\n",
  "SHINJU": "(Japanese) a ritual double suicide of lovers [n -S]\n",
  "SHINJUS": "SHINJU, (Japanese) a ritual double suicide of lovers [n]\n",
  "SHINKIN": "(Welsh) a worthless person [n -S]\n",
  "SHINKINS": "SHINKIN, (Welsh) a worthless person [n]\n",
  "SHINLEAF": "a perennial herb [n SHINLEAFS or SHINLEAVES]\n",
  "SHINLEAFS": "SHINLEAF, a perennial herb [n]\n",
  "SHINLEAVES": "SHINLEAF, a perennial herb [n]\n",
  "SHINNE": "(archaic) chin [n -S]\n",
  "SHINNED": "SHIN, to climb by gripping with the hands and legs, also SHINNY [v]\n",
  "SHINNERIES": "SHINNERY, a dense growth of small trees [n]\n",
  "SHINNERY": "a dense growth of small trees [n SHINNERIES]\n",
  "SHINNES": "SHINNE, (archaic) chin [n]\n",
  "SHINNEY": "to play a form of hockey [v -ED, -ING, -S]\n",
  "SHINNEYED": "SHINNEY, to play a form of hockey [v]\n",
  "SHINNEYING": "SHINNEY, to play a form of hockey [v]\n",
  "SHINNEYS": "SHINNEY, to play a form of hockey [v]\n",
  "SHINNIED": "SHINNY, to climb by gripping with the hands and legs, also SHIN [v]\n",
  "SHINNIES": "SHINNY, to climb by gripping with the hands and legs, also SHIN [v]\n",
  "SHINNING": "SHIN, to climb by gripping with the hands and legs, also SHINNY [v]\n",
  "SHINNY": "to climb by gripping with the hands and legs, also SHIN [v SHINNIED, SHINNYING, SHINNIES]\n",
  "SHINNYING": "SHINNY, to climb by gripping with the hands and legs, also SHIN [v]\n",
  "SHINOLA": "(tradename) a kind of boot polish [n -S]\n",
  "SHINOLAS": "SHINOLA, (tradename) a kind of boot polish [n]\n",
  "SHINPLASTER": "paper currency issued privately, esp. with no backing [n -S]\n",
  "SHINPLASTERS": "SHINPLASTER, paper currency issued privately, esp. with no backing [n]\n",
  "SHINS": "SHIN, to climb by gripping with the hands and legs, also SHINNY [v]\n",
  "SHINSPLINTS": "inflammation of the muscles around the shinbone caused by strenuous exercise [n]\n",
  "SHINTIED": "SHINTY, to play shinty [v]\n",
  "SHINTIES": "SHINTY, to play shinty [v]\n",
  "SHINTY": "a game like hockey [n SHINTIES] / to play shinty [v SHINTIED, SHINTYING, SHINTIES]\n",
  "SHINTYING": "SHINTY, to play shinty [v]\n",
  "SHINY": "a bright object [n SHINIES] / filled with light [adj SHINIER, SHINIEST, SHINILY]\n",
  "SHIP": "to transport in a seagoing vessel [v SHIPPED, SHIPPING, SHIPS]\n",
  "SHIPBOARD": "a ship's side [n -S]\n",
  "SHIPBOARDS": "SHIPBOARD, a ship's side [n]\n",
  "SHIPBORNE": "carried by ship [adj]\n",
  "SHIPBROKER": "a broker for the sale, insurance etc. of ships [n -S]\n",
  "SHIPBROKERS": "SHIPBROKER, a broker for the sale, insurance etc. of ships [n]\n",
  "SHIPBUILDER": "one who designs or constructs ships [n -S]\n",
  "SHIPBUILDERS": "SHIPBUILDER, one who designs or constructs ships [n]\n",
  "SHIPBUILDING": "the occupation of building ships [n -S]\n",
  "SHIPBUILDINGS": "SHIPBUILDING, the occupation of building ships [n]\n",
  "SHIPFITTER": "one who fits out a ship [n -S]\n",
  "SHIPFITTERS": "SHIPFITTER, one who fits out a ship [n]\n",
  "SHIPFUL": "a ship with a full cargo, also SHIPLOAD [n -S]\n",
  "SHIPFULS": "SHIPFUL, a ship with a full cargo, also SHIPLOAD [n]\n",
  "SHIPLAP": "an arrangement of overlapping planks on a ship [n -S] / to overlap planks in this way [v SHIPLAPPED, SHIPLAPPING, SHIPLAPS]\n",
  "SHIPLAPPED": "SHIPLAP, to overlap planks in this way [v]\n",
  "SHIPLAPPING": "the overlapping of planks on a ship [n -S]\n",
  "SHIPLAPPINGS": "SHIPLAPPING, the overlapping of planks on a ship [n]\n",
  "SHIPLAPS": "SHIPLAP, an arrangement of overlapping planks on a ship [n]\n",
  "SHIPLESS": "without a ship [adj]\n",
  "SHIPLOAD": "a ship with a full cargo, also SHIPFUL [n -S]\n",
  "SHIPLOADS": "SHIPLOAD, a ship with a full cargo, also SHIPFUL [n]\n",
  "SHIPMAN": "a sailor; a skipper [n SHIPMEN]\n",
  "SHIPMASTER": "the master or commander of a ship other than a warship [n -S]\n",
  "SHIPMASTERS": "SHIPMASTER, the master or commander of a ship other than a warship [n]\n",
  "SHIPMATE": "a fellow sailor [n -S]\n",
  "SHIPMATES": "SHIPMATE, a fellow sailor [n]\n",
  "SHIPMEN": "SHIPMAN, a sailor; a skipper [n]\n",
  "SHIPMENT": "something that is shipped [n -S]\n",
  "SHIPMENTS": "SHIPMENT, something that is shipped [n]\n",
  "SHIPOWNER": "the owner of a ship [n -S]\n",
  "SHIPOWNERS": "SHIPOWNER, the owner of a ship [n]\n",
  "SHIPPABLE": "that can be shipped [adj]\n",
  "SHIPPED": "SHIP, to transport in a seagoing vessel [v]\n",
  "SHIPPEN": "a cowshed, also SHIPPON [n -S]\n",
  "SHIPPENS": "SHIPPEN, a cowshed, also SHIPPON [n]\n",
  "SHIPPER": "a person or company that sends goods by ship or aircraft [n -S]\n",
  "SHIPPERS": "SHIPPER, a person or company that sends goods by ship or aircraft [n]\n",
  "SHIPPIE": "(New Zealand) a prostitute who solicits at ports [n -S]\n",
  "SHIPPIES": "SHIPPIE, (New Zealand) a prostitute who solicits at ports [n]\n",
  "SHIPPING": "the business of one that ships [n -S]\n",
  "SHIPPINGS": "SHIPPING, the business of one that ships [n]\n",
  "SHIPPO": "(Japanese) a kind of cloisonne ware [n -S]\n",
  "SHIPPON": "a cowshed, also SHIPPEN [n -S]\n",
  "SHIPPONS": "SHIPPON, a cowshed, also SHIPPEN [n]\n",
  "SHIPPOS": "SHIPPO, (Japanese) a kind of cloisonne ware [n]\n",
  "SHIPPOUND": "in the Baltic ports, twenty lispounds, a varying weight, 12 to 34 pounds [n -S]\n",
  "SHIPPOUNDS": "SHIPPOUND, in the Baltic ports, twenty lispounds, a varying weight, 12 to 34 pounds [n]\n",
  "SHIPS": "SHIP, to transport in a seagoing vessel [v]\n",
  "SHIPSHAPE": "in a seamanlike condition; trim, neat, proper [adj]\n",
  "SHIPSIDE": "the area alongside a ship [n -S]\n",
  "SHIPSIDES": "SHIPSIDE, the area alongside a ship [n]\n",
  "SHIPTIME": "the annual arrival of a supply ship [n -S]\n",
  "SHIPTIMES": "SHIPTIME, the annual arrival of a supply ship [n]\n",
  "SHIPWAY": "a sliding way for launching ships [n -S]\n",
  "SHIPWAYS": "SHIPWAY, a sliding way for launching ships [n]\n",
  "SHIPWORM": "a wormlike mollusc, aka teredo, that makes shell-lined tunnels in submerged wood [n -S]\n",
  "SHIPWORMS": "SHIPWORM, a wormlike mollusc, aka teredo, that makes shell-lined tunnels in submerged wood [n]\n",
  "SHIPWRECK": "a wrecked ship [n -S] / to undergo shipwreck [v -ED, -ING, -S]\n",
  "SHIPWRECKED": "SHIPWRECK, to undergo shipwreck [v]\n",
  "SHIPWRECKING": "SHIPWRECK, to undergo shipwreck [v]\n",
  "SHIPWRECKS": "SHIPWRECK, to undergo shipwreck [v]\n",
  "SHIPWRIGHT": "a carpenter skilled in ship construction and repair [n -S]\n",
  "SHIPWRIGHTS": "SHIPWRIGHT, a carpenter skilled in ship construction and repair [n]\n",
  "SHIPYARD": "a place where ships are built or repaired [n -S]\n",
  "SHIPYARDS": "SHIPYARD, a place where ships are built or repaired [n]\n",
  "SHIR": "to pucker, also SHIRR [v -ED, -ING, -S]\n",
  "SHIRALEE": "(Australian slang) a swagman's bundle, also SHIRRALEE [n -S]\n",
  "SHIRALEES": "SHIRALEE, (Australian slang) a swagman's bundle, also SHIRRALEE [n]\n",
  "SHIRAZ": "(Persian) a type of wine grape, aka syrah [n -ES]\n",
  "SHIRAZES": "SHIRAZ, (Persian) a type of wine grape, aka syrah [n]\n",
  "SHIRE": "a rural district having its own elected council [n -S] / (Irish) to refresh or rest [v SHIRED, SHIRING, SHIRES]\n",
  "SHIRED": "SHIR, to pucker, also SHIRR [v]\n",
  "SHIREMAN": "a law-enforcement officer of a county, a sheriff [n SHIREMEN]\n",
  "SHIREMEN": "SHIREMAN, a law-enforcement officer of a county, a sheriff [n]\n",
  "SHIRES": "SHIRE, (Irish) to refresh or rest [v]\n",
  "SHIRETOWN": "(Canadian) (in Nova Scotia, New Brunswick, and Maine) a county seat [n -S]\n",
  "SHIRETOWNS": "SHIRETOWN, (Canadian) (in Nova Scotia, New Brunswick, and Maine) a county seat [n]\n",
  "SHIRING": "SHIR, to pucker, also SHIRR [v]\n",
  "SHIRK": "to avoid work or a duty [v -ED, -ING, -S]\n",
  "SHIRKED": "SHIRK, to avoid work or a duty [v]\n",
  "SHIRKER": "one who shirks [n -S]\n",
  "SHIRKERS": "SHIRKER, one who shirks [n]\n",
  "SHIRKING": "SHIRK, to avoid work or a duty [v]\n",
  "SHIRKS": "SHIRK, to avoid work or a duty [v]\n",
  "SHIRR": "to pucker, also SHIR [v -ED, -ING, -S]\n",
  "SHIRRA": "(Scots) a law-enforcement officer of a county, also SHERIFF [n -S]\n",
  "SHIRRALEE": "(Australian slang) a swagman's bundle, also SHIRALEE [n -S]\n",
  "SHIRRALEES": "SHIRRALEE, (Australian slang) a swagman's bundle, also SHIRALEE [n]\n",
  "SHIRRAS": "SHIRRA, (Scots) a law-enforcement officer of a county, also SHERIFF [n]\n",
  "SHIRRED": "SHIRR, to pucker, also SHIR [v]\n",
  "SHIRRING": "a puckered arrangement of cloth [n -S]\n",
  "SHIRRINGS": "SHIRRING, a puckered arrangement of cloth [n]\n",
  "SHIRRS": "SHIRR, to pucker, also SHIR [v]\n",
  "SHIRS": "SHIR, to pucker, also SHIRR [v]\n",
  "SHIRT": "to don a garment for the upper body [v -ED, -ING, -S]\n",
  "SHIRTBAND": "the neckband of a shirt [n -S]\n",
  "SHIRTBANDS": "SHIRTBAND, the neckband of a shirt [n]\n",
  "SHIRTDRESS": "a straight dress with a collar like a shirt's [n -ES]\n",
  "SHIRTDRESSES": "SHIRTDRESS, a straight dress with a collar like a shirt's [n]\n",
  "SHIRTED": "SHIRT, to don a garment for the upper body [v]\n",
  "SHIRTFRONT": "to knock (a person) to the ground by striking him or her in the chest with one's shoulder [v -ED, -ING, -S]\n",
  "SHIRTFRONTED": "SHIRTFRONT, to knock (a person) to the ground by striking him or her in the chest with one's shoulder [v]\n",
  "SHIRTFRONTING": "SHIRTFRONT, to knock (a person) to the ground by striking him or her in the chest with one's shoulder [v]\n",
  "SHIRTFRONTS": "SHIRTFRONT, to knock (a person) to the ground by striking him or her in the chest with one's shoulder [v]\n",
  "SHIRTIER": "SHIRTY, irritable, annoyed [adj]\n",
  "SHIRTIEST": "SHIRTY, irritable, annoyed [adj]\n",
  "SHIRTILY": "SHIRTY, irritable, annoyed [adv]\n",
  "SHIRTINESS": "the state of being shirty [n -ES]\n",
  "SHIRTINESSES": "SHIRTINESS, the state of being shirty [n]\n",
  "SHIRTING": "fabric used for making shirts [n -S]\n",
  "SHIRTINGS": "SHIRTING, fabric used for making shirts [n]\n",
  "SHIRTLESS": "without a shirt [adj]\n",
  "SHIRTLIFTER": "(offensive) a male homosexual [n -S]\n",
  "SHIRTLIFTERS": "SHIRTLIFTER, (offensive) a male homosexual [n]\n",
  "SHIRTLIKE": "like a shirt [adj]\n",
  "SHIRTMAKER": "one who makes shirts [n -S]\n",
  "SHIRTMAKERS": "SHIRTMAKER, one who makes shirts [n]\n",
  "SHIRTS": "SHIRT, to don a garment for the upper body [v]\n",
  "SHIRTSLEEVE": "the sleeve of a shirt [n -S]\n",
  "SHIRTSLEEVED": "in shirtsleeves, i.e. not wearing a jacket [adj]\n",
  "SHIRTSLEEVES": "SHIRTSLEEVE, the sleeve of a shirt [n]\n",
  "SHIRTTAIL": "the longer flap at the back of a shirt [n -S] / to make a brief addendum at the end of a newspaper article [v -ED, -ING, -S]\n",
  "SHIRTTAILED": "SHIRTTAIL, to make a brief addendum at the end of a newspaper article [v]\n",
  "SHIRTTAILING": "SHIRTTAIL, to make a brief addendum at the end of a newspaper article [v]\n",
  "SHIRTTAILS": "SHIRTTAIL, the longer flap at the back of a shirt [n]\n",
  "SHIRTWAIST": "a woman's tailored shirt with details copied from men's [n -S]\n",
  "SHIRTWAISTED": "as in shirtwaisted dress, another name for shirtwaister [adj]\n",
  "SHIRTWAISTER": "a tailored dress with a shirtwaist top [n -S]\n",
  "SHIRTWAISTERS": "SHIRTWAISTER, a tailored dress with a shirtwaist top [n]\n",
  "SHIRTWAISTS": "SHIRTWAIST, a woman's tailored shirt with details copied from men's [n]\n",
  "SHIRTY": "irritable, annoyed [adj SHIRTIER, SHIRTIEST, SHIRTILY]\n",
  "SHISH": "(Turkish) as in shish kebab, a dish of meat and vegetables threaded on to skewers and grilled [adj]\n",
  "SHISHA": "(Urdu) a kind of water-pipe for smoking, aka hookah, also SHEESHA [n -S]\n",
  "SHISHAS": "SHISHA, (Urdu) a kind of water-pipe for smoking, aka hookah, also SHEESHA [n]\n",
  "SHISO": "(Japanese) an Asian plant with aromatic leaves that are used in cooking [n -S]\n",
  "SHISOS": "SHISO, (Japanese) an Asian plant with aromatic leaves that are used in cooking [n]\n",
  "SHIST": "a type of metamorphic rock, also SCHIST [n -S]\n",
  "SHISTS": "SHIST, a type of metamorphic rock, also SCHIST [n]\n",
  "SHIT": "(vulgar) to defecate [v SHITTED, SHAT, SHITTING, SHITS]\n",
  "SHITAKE": "(Japanese) a type of mushroom, featured in Japanese cuisine, also SHIITAKE [n -S]\n",
  "SHITAKES": "SHITAKE, (Japanese) a type of mushroom, featured in Japanese cuisine, also SHIITAKE [n]\n",
  "SHITBAG": "an unpleasant or contemptible person [n -S]\n",
  "SHITBAGS": "SHITBAG, an unpleasant or contemptible person [n]\n",
  "SHITCAN": "(vulgar) to discard or reject [v SHITCANNED, SHITCANNING, SHITCANS]\n",
  "SHITCANNED": "SHITCAN, (vulgar) to discard or reject [v]\n",
  "SHITCANNING": "SHITCAN, (vulgar) to discard or reject [v]\n",
  "SHITCANS": "SHITCAN, (vulgar) to discard or reject [v]\n",
  "SHITE": "(vulgar slang) to shit, also SHIT [v SHITED, SHITING, SHITES]\n",
  "SHITED": "SHITE, (vulgar slang) to shit, also SHIT [v]\n",
  "SHITES": "SHITE, (vulgar slang) to shit, also SHIT [v]\n",
  "SHITFACE": "(vulgar) a contemptible person [n -S]\n",
  "SHITFACED": "(slang) drunk [adj]\n",
  "SHITFACES": "SHITFACE, (vulgar) a contemptible person [n]\n",
  "SHITHEAD": "an unpleasant person [n -S]\n",
  "SHITHEADS": "SHITHEAD, an unpleasant person [n]\n",
  "SHITHEEL": "(vulgar) a contemptible person [n -S]\n",
  "SHITHEELS": "SHITHEEL, (vulgar) a contemptible person [n]\n",
  "SHITHOLE": "(vulgar) a filthy place [n -S]\n",
  "SHITHOLES": "SHITHOLE, (vulgar) a filthy place [n]\n",
  "SHITHOUSE": "(vulgar) a lavatory [n -S]\n",
  "SHITHOUSES": "SHITHOUSE, (vulgar) a lavatory [n]\n",
  "SHITING": "SHITE, (vulgar slang) to shit, also SHIT [v]\n",
  "SHITLESS": "(vulgar) very frightened, as in the phrase scared shitless [adj]\n",
  "SHITLIST": "(vulgar) a blacklist of people out of favour [n -S]\n",
  "SHITLISTS": "SHITLIST, (vulgar) a blacklist of people out of favour [n]\n",
  "SHITLOAD": "(vulgar slang) a lot [n -S]\n",
  "SHITLOADS": "SHITLOAD, (vulgar slang) a lot [n]\n",
  "SHITS": "SHIT, (vulgar) to defecate [v]\n",
  "SHITSTORM": "(vulgar slang) a situation marked by violent controversy [n -S]\n",
  "SHITSTORMS": "SHITSTORM, (vulgar slang) a situation marked by violent controversy [n]\n",
  "SHITTAH": "(Hebrew) a Biblical tree, probably a species of acacia [n -S]\n",
  "SHITTAHS": "SHITTAH, (Hebrew) a Biblical tree, probably a species of acacia [n]\n",
  "SHITTED": "SHIT, (vulgar) to defecate [v]\n",
  "SHITTER": "(vulgar slang) a toilet [n -S]\n",
  "SHITTERS": "SHITTER, (vulgar slang) a toilet [n]\n",
  "SHITTIER": "SHITTY, (vulgar) very unpleasant [adj]\n",
  "SHITTIEST": "SHITTY, (vulgar) very unpleasant [adj]\n",
  "SHITTILY": "SHITTY, (vulgar) very unpleasant [adv]\n",
  "SHITTIM": "(Hebrew) the wood of the shittah tree, believed to be a species of acacia, also SHITTIMWOOD [n -S]\n",
  "SHITTIMS": "SHITTIM, (Hebrew) the wood of the shittah tree, believed to be a species of acacia, also SHITTIMWOOD [n]\n",
  "SHITTIMWOOD": "the wood of the shittah tree, believed to be a species of acacia, also SHITTIM [n -S]\n",
  "SHITTIMWOODS": "SHITTIMWOOD, the wood of the shittah tree, believed to be a species of acacia, also SHITTIM [n]\n",
  "SHITTINESS": "the state of being shitty [n -ES]\n",
  "SHITTINESSES": "SHITTINESS, the state of being shitty [n]\n",
  "SHITTING": "SHIT, (vulgar) to defecate [v]\n",
  "SHITTY": "(vulgar) very unpleasant [adj SHITTIER, SHITTIEST, SHITTILY]\n",
  "SHITWORK": "(vulgar) work considered to be menial or routine [n -S]\n",
  "SHITWORKS": "SHITWORK, (vulgar) work considered to be menial or routine [n]\n",
  "SHITZU": "(Chinese) a small longhaired dog bred from the Pekingese and Lhasa Apso [n -S]\n",
  "SHITZUS": "SHITZU, (Chinese) a small longhaired dog bred from the Pekingese and Lhasa Apso [n]\n",
  "SHIUR": "(Hebrew) a lesson, esp. one in which a passage of the Talmud is studied together by a group of people [n SHIURIM]\n",
  "SHIURIM": "SHIUR, (Hebrew) a lesson, esp. one in which a passage of the Talmud is studied together by a group of people [n]\n",
  "SHIV": "to cut with a kind fo knife, also CHIV, CHIVE [v SHIVVED, SHIVVING, SHIVS]\n",
  "SHIVA": "(Hebrew) in Judaism, a period of seven days' mourning observed after a family member's funeral, also SHIBAH, SHIVAH [n -S]\n",
  "SHIVAH": "(Hebrew) in Judaism, a period of seven days' mourning observed after a family member's funeral, also SHIBAH, SHIVA [n -S]\n",
  "SHIVAHS": "SHIVAH, (Hebrew) in Judaism, a period of seven days' mourning observed after a family member's funeral, also SHIBAH, SHIVA [n]\n",
  "SHIVAREE": "to perform a mock serenade, also CHIVAREE, CHIVARI [v SHIVAREED, SHIVAREEING, SHIVAREES]\n",
  "SHIVAREED": "SHIVAREE, to perform a mock serenade, also CHIVAREE, CHIVARI [v]\n",
  "SHIVAREEING": "SHIVAREE, to perform a mock serenade, also CHIVAREE, CHIVARI [v]\n",
  "SHIVAREES": "SHIVAREE, to perform a mock serenade, also CHIVAREE, CHIVARI [v]\n",
  "SHIVAS": "SHIVA, (Hebrew) in Judaism, a period of seven days' mourning observed after a family member's funeral, also SHIBAH, SHIVAH [n]\n",
  "SHIVE": "a thin fragment [n -S]\n",
  "SHIVER": "to tremble with fear or cold [v -ED, -ING, -S]\n",
  "SHIVERED": "SHIVER, to tremble with fear or cold [v]\n",
  "SHIVERER": "one who shivers [n -S]\n",
  "SHIVERERS": "SHIVERER, one who shivers [n]\n",
  "SHIVERIER": "SHIVERY, shivering [adj]\n",
  "SHIVERIEST": "SHIVERY, shivering [adj]\n",
  "SHIVERING": "trembling with fear or cold [adj SHIVERINGLY] / the act of shivering [n -S]\n",
  "SHIVERINGLY": "SHIVERING, trembling with fear or cold [adv]\n",
  "SHIVERINGS": "SHIVERING, the act of shivering [n]\n",
  "SHIVERS": "SHIVER, to tremble with fear or cold [v]\n",
  "SHIVERY": "shivering [adj SHIVERIER, SHIVERIEST]\n",
  "SHIVES": "SHIVE, a thin fragment [n]\n",
  "SHIVITI": "(Hebrew) a plaque with a Hebrew verse [n -S]\n",
  "SHIVITIS": "SHIVITI, (Hebrew) a plaque with a Hebrew verse [n]\n",
  "SHIVOO": "(Australian slang) a noisy party [n -S]\n",
  "SHIVOOS": "SHIVOO, (Australian slang) a noisy party [n]\n",
  "SHIVS": "SHIV, to cut with a kind fo knife, also CHIV, CHIVE [v]\n",
  "SHIVVED": "SHIV, to cut with a kind fo knife, also CHIV, CHIVE [v]\n",
  "SHIVVING": "SHIV, to cut with a kind fo knife, also CHIV, CHIVE [v]\n",
  "SHIZZLE": "a form of slang popularized by US rap musicians in which the trailing syllables of certain words are replaced by the suffix -izzle [n -S]\n",
  "SHIZZLES": "SHIZZLE, a form of slang popularized by US rap musicians in which the trailing syllables of certain words are replaced by the suffix -izzle [n]\n",
  "SHKOTZIM": "SHEGETZ, (Yiddish) among Jewish people, a Gentile boy; a Jewish boy not observing traditional Jewish behaviour [n]\n",
  "SHLEMIEHL": "(Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIEL, SCHLEMIHL, SHLEMIEL [n -S]\n",
  "SHLEMIEHLS": "SHLEMIEHL, (Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIEL, SCHLEMIHL, SHLEMIEL [n]\n",
  "SHLEMIEL": "(Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIEL, SCHLEMIHL, SHLEMIEHL [n -S]\n",
  "SHLEMIELS": "SHLEMIEL, (Yiddish) an unlucky or incompetent person who is often duped, also SCHLEMIEL, SCHLEMIHL, SHLEMIEHL [n]\n",
  "SHLEMOZZLE": "(Yiddish) to make off, also SCHEMOZZLE, SHEMOZZLE, SHIMOZZLE [v SHLEMOZZLED, SHLEMOZZLING, SHLEMOZZLES]\n",
  "SHLEMOZZLED": "SHLEMOZZLE, (Yiddish) to make off, also SCHEMOZZLE, SHEMOZZLE, SHIMOZZLE [v]\n",
  "SHLEMOZZLES": "SHLEMOZZLE, (Yiddish) to make off, also SCHEMOZZLE, SHEMOZZLE, SHIMOZZLE [v]\n",
  "SHLEMOZZLING": "SHLEMOZZLE, (Yiddish) to make off, also SCHEMOZZLE, SHEMOZZLE, SHIMOZZLE [v]\n",
  "SHLEP": "(Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SCHLEPP, SHLEPP [v SHLEPPED, SHLEPPING, SHLEPS]\n",
  "SHLEPP": "(Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SCHLEPP, SHLEP [v -ED, -ING, -S]\n",
  "SHLEPPED": "SHLEPP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SCHLEPP, SHLEP [v]\n",
  "SHLEPPER": "(Yiddish) an incompetent or nonentity, also SCHLEPPER [n -S]\n",
  "SHLEPPERS": "SHLEPPER, (Yiddish) an incompetent or nonentity, also SCHLEPPER [n]\n",
  "SHLEPPIER": "SHLEPPY, shabby, rundown, also SCHLEPPY [adj]\n",
  "SHLEPPIEST": "SHLEPPY, shabby, rundown, also SCHLEPPY [adj]\n",
  "SHLEPPING": "SHLEPP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SCHLEPP, SHLEP [v]\n",
  "SHLEPPS": "SHLEPP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SCHLEPP, SHLEP [v]\n",
  "SHLEPPY": "shabby, rundown, also SCHLEPPY [adj SHLEPPIER, SHLEPPIEST]\n",
  "SHLEPS": "SHLEP, (Yiddish) to drag one's feet; travel a great distance, also SCHLEP, SCHLEPP, SHLEPP [v]\n",
  "SHLIMAZEL": "(Yiddish) an unlucky person, also SCHLIMAZEL [n -S]\n",
  "SHLIMAZELS": "SHLIMAZEL, (Yiddish) an unlucky person, also SCHLIMAZEL [n]\n",
  "SHLOCK": "(Yiddish) inferior merchandise, also SCHLOCK [n -S]\n",
  "SHLOCKIER": "SHLOCKY, of poor quality, also SCHLOCKEY, SCHLOCKY [adj]\n",
  "SHLOCKIEST": "SHLOCKY, of poor quality, also SCHLOCKEY, SCHLOCKY [adj]\n",
  "SHLOCKS": "SHLOCK, (Yiddish) inferior merchandise, also SCHLOCK [n]\n",
  "SHLOCKY": "of poor quality, also SCHLOCKEY, SCHLOCKY [adj SHLOCKIER, SHLOCKIEST]\n",
  "SHLONG": "(slang) a penis, also SCHLONG [n -S]\n",
  "SHLONGS": "SHLONG, (slang) a penis, also SCHLONG [n]\n",
  "SHLOSHIM": "(Hebrew) the period of thirty days' deep mourning after a death [n -S]\n",
  "SHLOSHIMS": "SHLOSHIM, (Hebrew) the period of thirty days' deep mourning after a death [n]\n",
  "SHLUB": "(Yiddish) a stupid or unattractive person, also SCHLUB [n -S]\n",
  "SHLUBS": "SHLUB, (Yiddish) a stupid or unattractive person, also SCHLUB [n]\n",
  "SHLUMP": "(Yiddish) to dress sloppily, also SCHLUMP [v -ED, -ING, -S]\n",
  "SHLUMPED": "SHLUMP, (Yiddish) to dress sloppily, also SCHLUMP [v]\n",
  "SHLUMPIER": "SHLUMPY, (Yiddish) slovenly [adj]\n",
  "SHLUMPIEST": "SHLUMPY, (Yiddish) slovenly [adj]\n",
  "SHLUMPING": "SHLUMP, (Yiddish) to dress sloppily, also SCHLUMP [v]\n",
  "SHLUMPS": "SHLUMP, (Yiddish) to dress sloppily, also SCHLUMP [v]\n",
  "SHLUMPY": "(Yiddish) slovenly [adj SHLUMPIER, SHLUMPIEST]\n",
  "SHMALTZ": "(Yiddish) excessive sentimentality, also SCHMALTZ, SCHMALZ [n -ES]\n",
  "SHMALTZES": "SHMALTZ, (Yiddish) excessive sentimentality, also SCHMALTZ, SCHMALZ [n]\n",
  "SHMALTZIER": "SHMALTZY, (Yiddish) sickly sentimental, also SCHMALTZY, SCHMALZY [adj]\n",
  "SHMALTZIEST": "SHMALTZY, (Yiddish) sickly sentimental, also SCHMALTZY, SCHMALZY [adj]\n",
  "SHMALTZY": "(Yiddish) sickly sentimental, also SCHMALTZY, SCHMALZY [adj SHMALTZIER, SHMALTZIEST]\n",
  "SHMATTE": "(Yiddish) clothing, rags, also SCHMATTE, SCHMUTTER [n -S]\n",
  "SHMATTES": "SHMATTE, (Yiddish) clothing, rags, also SCHMATTE, SCHMUTTER [n]\n",
  "SHMEAR": "(Yiddish) to bribe [v -ED, -ING, -S]\n",
  "SHMEARED": "SHMEAR, (Yiddish) to bribe [v]\n",
  "SHMEARING": "SHMEAR, (Yiddish) to bribe [v]\n",
  "SHMEARS": "SHMEAR, (Yiddish) to bribe [v]\n",
  "SHMEER": "to bribe, also SCHMEAR, SCHMEER, SHMEAR [v -ED, -ING, -S]\n",
  "SHMEERED": "SHMEER, to bribe, also SCHMEAR, SCHMEER, SHMEAR [v]\n",
  "SHMEERING": "SHMEER, to bribe, also SCHMEAR, SCHMEER, SHMEAR [v]\n",
  "SHMEERS": "SHMEER, to bribe, also SCHMEAR, SCHMEER, SHMEAR [v]\n",
  "SHMEK": "(Yiddish) a taste or sniff; heroin, also SCHMECK [n -S]\n",
  "SHMEKS": "SHMEK, (Yiddish) a taste or sniff; heroin, also SCHMECK [n]\n",
  "SHMO": "(Yiddish) a stupid or boring person, also SCHMO, SCHMOE, SHMOE [n SHMOES]\n",
  "SHMOCK": "(Yiddish) a stupid or boring person, also SCHMOCK [n -S]\n",
  "SHMOCKS": "SHMOCK, (Yiddish) a stupid or boring person, also SCHMOCK [n]\n",
  "SHMOE": "(Yiddish) a stupid or boring person, also SCHMO, SCHMOE, SHMO [n -S]\n",
  "SHMOES": "SHMO, (Yiddish) a stupid or boring person, also SCHMO, SCHMOE, SHMOE [n]\n",
  "SHMOOSE": "(Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOZE [v SHMOOSED, SHMOOSING, SHMOOSES]\n",
  "SHMOOSED": "SHMOOSE, (Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOZE [v]\n",
  "SHMOOSES": "SHMOOSE, (Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOZE [v]\n",
  "SHMOOSING": "SHMOOSE, (Yiddish) to chat in a friendly way, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOZE [v]\n",
  "SHMOOZE": "(Yiddish) to chat, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE [v SHMOOZED, SHMOOZING, SHMOOZES]\n",
  "SHMOOZED": "SHMOOZE, (Yiddish) to chat, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE [v]\n",
  "SHMOOZER": "one who shmoozes, also SCHMOOZER [n -S]\n",
  "SHMOOZERS": "SHMOOZER, one who shmoozes, also SCHMOOZER [n]\n",
  "SHMOOZES": "SHMOOZE, (Yiddish) to chat, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE [v]\n",
  "SHMOOZIER": "SHMOOZY, given to shmoozing, gossipy, also SCHMOOZY [adj]\n",
  "SHMOOZIEST": "SHMOOZY, given to shmoozing, gossipy, also SCHMOOZY [adj]\n",
  "SHMOOZING": "SHMOOZE, (Yiddish) to chat, also SCHMOOS, SCHMOOSE, SCHMOOZ, SCHMOOZE, SHMOOSE [v]\n",
  "SHMOOZY": "given to shmoozing, gossipy, also SCHMOOZY [adj SHMOOZIER, SHMOOZIEST]\n",
  "SHMUCK": "(Yiddish) a pitiful, stupid or obnoxious person, also SCHMUCK [n -S]\n",
  "SHMUCKIER": "SHMUCKY, foolish, contemptible [adj]\n",
  "SHMUCKIEST": "SHMUCKY, foolish, contemptible [adj]\n",
  "SHMUCKS": "SHMUCK, (Yiddish) a pitiful, stupid or obnoxious person, also SCHMUCK [n]\n",
  "SHMUCKY": "foolish, contemptible [adj SHMUCKIER, SHMUCKIEST]\n",
  "SHNAPPS": "(German) a kind of brandy, also SCHNAPPS, SCHNAPS, SHNAPS [n]\n",
  "SHNAPS": "(German) a kind of brandy, also SCHNAPPS, SCHNAPS, SHNAPPS [n]\n",
  "SHNOOK": "(Yiddish) an unscrupulous person; a crook, also SCHNOOK [n -S]\n",
  "SHNOOKS": "SHNOOK, (Yiddish) an unscrupulous person; a crook, also SCHNOOK [n]\n",
  "SHNORRER": "(Yiddish) a beggar, esp. one who wheedles others into supplying his wants, also SCHNORRER [n -S]\n",
  "SHNORRERS": "SHNORRER, (Yiddish) a beggar, esp. one who wheedles others into supplying his wants, also SCHNORRER [n]\n",
  "SHO": "a nonstandard spelling of sure, representing its pronunciation in the southern US [adj]\n",
  "SHOAL": "shallow, also SHAUL [adj SHOALER, SHOALEST] / to sail into shallow water [v -ED, -ING, -S]\n",
  "SHOALED": "SHOAL, to sail into shallow water [v]\n",
  "SHOALER": "SHOAL, shallow, also SHAUL [adj]\n",
  "SHOALEST": "SHOAL, shallow, also SHAUL [adj]\n",
  "SHOALIER": "SHOALY, full of shallow areas [adj]\n",
  "SHOALIEST": "SHOALY, full of shallow areas [adj]\n",
  "SHOALINESS": "the state of being shoaly [n -ES]\n",
  "SHOALINESSES": "SHOALINESS, the state of being shoaly [n]\n",
  "SHOALING": "a shallow area of water [n -S]\n",
  "SHOALINGS": "SHOALING, a shallow area of water [n]\n",
  "SHOALNESS": "shallowness [n -ES]\n",
  "SHOALNESSES": "SHOALNESS, shallowness [n]\n",
  "SHOALS": "SHOAL, to sail into shallow water [v]\n",
  "SHOALWISE": "in shoals [adv]\n",
  "SHOALY": "full of shallow areas [adj SHOALIER, SHOALIEST]\n",
  "SHOAT": "a young pig, esp. one that has just been weaned, also SHOTE, SHOTTE [n -S]\n",
  "SHOATS": "SHOAT, a young pig, esp. one that has just been weaned, also SHOTE, SHOTTE [n]\n",
  "SHOCHET": "(Hebrew) a slaughterer who slaughters in the kosher manner [n SHOCHETIM or SHOCHETS]\n",
  "SHOCHETIM": "SHOCHET, (Hebrew) a slaughterer who slaughters in the kosher manner [n]\n",
  "SHOCHETS": "SHOCHET, (Hebrew) a slaughterer who slaughters in the kosher manner [n]\n",
  "SHOCHU": "(Japanese) a Japanese liquor [n -S]\n",
  "SHOCHUS": "SHOCHU, (Japanese) a Japanese liquor [n]\n",
  "SHOCK": "to outrage feelings [v -ED, -ING, -S]\n",
  "SHOCKABILITIES": "SHOCKABILITY, the quality of being shockable [n]\n",
  "SHOCKABILITY": "the quality of being shockable [n SHOCKABILITIES]\n",
  "SHOCKABLE": "able to be shocked [adj]\n",
  "SHOCKED": "SHOCK, to outrage feelings [v]\n",
  "SHOCKER": "one that shocks [n -S]\n",
  "SHOCKERS": "SHOCKER, one that shocks [n]\n",
  "SHOCKHEADED": "having a head of bushy or tousled hair [adj]\n",
  "SHOCKING": "SHOCK, to outrage feelings [v]\n",
  "SHOCKINGLY": "SHOCKING, SHOCK, to outrage feelings [adv]\n",
  "SHOCKINGNESS": "the state of being shocking [n -ES]\n",
  "SHOCKINGNESSES": "SHOCKINGNESS, the state of being shocking [n]\n",
  "SHOCKPROOF": "incapable of being shocked [adj]\n",
  "SHOCKS": "SHOCK, to outrage feelings [v]\n",
  "SHOCKSTALL": "in aeronautics, a loss of lift at high speed caused by the formation of shock waves [n -S]\n",
  "SHOCKSTALLS": "SHOCKSTALL, in aeronautics, a loss of lift at high speed caused by the formation of shock waves [n]\n",
  "SHOCKUMENTARIES": "SHOCKUMENTARY, a documentary intended to shock [n]\n",
  "SHOCKUMENTARY": "a documentary intended to shock [n SHOCKUMENTARIES]\n",
  "SHOD": "SHOE, to provide with a covering for the foot [v]\n",
  "SHODDEN": "SHOE, to provide with a covering for the foot [v]\n",
  "SHODDIER": "SHODDY, of poor quality [adj]\n",
  "SHODDIES": "SHODDY, woollen fibre obtained by shredding refuse woollen rags [n]\n",
  "SHODDIEST": "SHODDY, of poor quality [adj]\n",
  "SHODDILY": "SHODDY, of poor quality [adv]\n",
  "SHODDINESS": "the state of being shoddy [n -ES]\n",
  "SHODDINESSES": "SHODDINESS, the state of being shoddy [n]\n",
  "SHODDY": "of poor quality [adj SHODDIER, SHODDIEST, SHODDILY] / woollen fibre obtained by shredding refuse woollen rags [n SHODDIES]\n",
  "SHODER": "a package of gold beater's skins in which gold is subjected to the second process of beating [n -S]\n",
  "SHODERS": "SHODER, a package of gold beater's skins in which gold is subjected to the second process of beating [n]\n",
  "SHOE": "to provide with a covering for the foot [v SHOD or SHOED, SHODDEN or SHOED, SHOEING, SHOES] / a covering for the foot [n SHOES or SHOON]\n",
  "SHOEBILL": "a large African wading bird allied to the storks and herons, and remarkable for its enormous broad swollen bill [n -S]\n",
  "SHOEBILLS": "SHOEBILL, a large African wading bird allied to the storks and herons, and remarkable for its enormous broad swollen bill [n]\n",
  "SHOEBLACK": "one who polishes shoes [n -S]\n",
  "SHOEBLACKS": "SHOEBLACK, one who polishes shoes [n]\n",
  "SHOEBOX": "an oblong box for holding a pair of shoes [n -ES]\n",
  "SHOEBOXES": "SHOEBOX, an oblong box for holding a pair of shoes [n]\n",
  "SHOEBRUSH": "a brush for cleaning shoes [n -ES]\n",
  "SHOEBRUSHES": "SHOEBRUSH, a brush for cleaning shoes [n]\n",
  "SHOED": "SHOE, to provide with a covering for the foot [v]\n",
  "SHOEHORN": "to force into a small space [v -ED, -ING, -S]\n",
  "SHOEHORNED": "SHOEHORN, to force into a small space [v]\n",
  "SHOEHORNING": "SHOEHORN, to force into a small space [v]\n",
  "SHOEHORNS": "SHOEHORN, to force into a small space [v]\n",
  "SHOEING": "the act of nailing shoes on horses [n -S]\n",
  "SHOEINGS": "SHOEING, the act of nailing shoes on horses [n]\n",
  "SHOELACE": "a lace for fastening a shoe [n -S]\n",
  "SHOELACES": "SHOELACE, a lace for fastening a shoe [n]\n",
  "SHOELESS": "without shoes [adj]\n",
  "SHOEMAKER": "one who makes shoes [n -S]\n",
  "SHOEMAKERS": "SHOEMAKER, one who makes shoes [n]\n",
  "SHOEMAKING": "the business of a shoemaker [n -S]\n",
  "SHOEMAKINGS": "SHOEMAKING, the business of a shoemaker [n]\n",
  "SHOEPAC": "a waterproof boot, also SHOEPACK [n -S]\n",
  "SHOEPACK": "a waterproof boot, also SHOEPAC [n -S]\n",
  "SHOEPACKS": "SHOEPACK, a waterproof boot, also SHOEPAC [n]\n",
  "SHOEPACS": "SHOEPAC, a waterproof boot, also SHOEPACK [n]\n",
  "SHOER": "one who shoes horses [n -S]\n",
  "SHOERS": "SHOER, one who shoes horses [n]\n",
  "SHOES": "SHOE, to provide with a covering for the foot [v]\n",
  "SHOESHINE": "the act of polishing shoes [n -S]\n",
  "SHOESHINES": "SHOESHINE, the act of polishing shoes [n]\n",
  "SHOESTRING": "a shoelace [n -S]\n",
  "SHOESTRINGS": "SHOESTRING, a shoelace [n]\n",
  "SHOETREE": "a device for preventing shoes from losing their shape [n -S]\n",
  "SHOETREES": "SHOETREE, a device for preventing shoes from losing their shape [n]\n",
  "SHOFAR": "(Hebrew) a horn blown in certain Jewish rituals, also SHOPHAR [n SHOFARS or SHOFROTH]\n",
  "SHOFARS": "SHOFAR, (Hebrew) a horn blown in certain Jewish rituals, also SHOPHAR [n]\n",
  "SHOFROTH": "SHOFAR, (Hebrew) a horn blown in certain Jewish rituals, also SHOPHAR [n]\n",
  "SHOG": "(dialect) to move along [v SHOGGED, SHOGGING, SHOGS]\n",
  "SHOGGED": "SHOG, (dialect) to move along [v]\n",
  "SHOGGING": "SHOG, (dialect) to move along [v]\n",
  "SHOGGLE": "(Scots) to shake, also SHOOGIE, SHOOGLE [v SHOGGLED, SHOGGLING, SHOGGLES]\n",
  "SHOGGLED": "SHOGGLE, (Scots) to shake, also SHOOGIE, SHOOGLE [v]\n",
  "SHOGGLES": "SHOGGLE, (Scots) to shake, also SHOOGIE, SHOOGLE [v]\n",
  "SHOGGLIER": "SHOGGLY, (Scots) shaky, also SHOOGLY [adj]\n",
  "SHOGGLIEST": "SHOGGLY, (Scots) shaky, also SHOOGLY [adj]\n",
  "SHOGGLING": "SHOGGLE, (Scots) to shake, also SHOOGIE, SHOOGLE [v]\n",
  "SHOGGLY": "(Scots) shaky, also SHOOGLY [adj SHOGGLIER, SHOGGLIEST]\n",
  "SHOGI": "(Japanese) an Oriental board game [n -S]\n",
  "SHOGIS": "SHOGI, (Japanese) an Oriental board game [n]\n",
  "SHOGS": "SHOG, (dialect) to move along [v]\n",
  "SHOGUN": "(Japanese) a hereditary military governor of Japan [n -S]\n",
  "SHOGUNAL": "relating to a shogun, a hereditary military governor of Japan [adj]\n",
  "SHOGUNATE": "the office or dignity of a shogun, a hereditary military governor of Japan [n -S]\n",
  "SHOGUNATES": "SHOGUNATE, the office or dignity of a shogun, a hereditary military governor of Japan [n]\n",
  "SHOGUNS": "SHOGUN, (Japanese) a hereditary military governor of Japan [n]\n",
  "SHOJI": "(Japanese) a translucent paper screen forming a sliding door or partition in a Japanese house [n -S]\n",
  "SHOJIS": "SHOJI, (Japanese) a translucent paper screen forming a sliding door or partition in a Japanese house [n]\n",
  "SHOJO": "(Japanese) manga intended primarily for girls [n SHOJO]\n",
  "SHOLA": "(Hindi) an Indian plant with a pith used in making tropical hats, aka spongewood, also SOLA, SOLAH [n -S]\n",
  "SHOLAS": "SHOLA, (Hindi) an Indian plant with a pith used in making tropical hats, aka spongewood, also SOLA, SOLAH [n]\n",
  "SHOLOM": "(Hebrew) in Jewish society, a salutation at meeting or parting, also SHALOM [n -S]\n",
  "SHOLOMS": "SHOLOM, (Hebrew) in Jewish society, a salutation at meeting or parting, also SHALOM [n]\n",
  "SHONE": "SHINE, to emit light [v]\n",
  "SHONEEN": "(Irish) an Irishman who imitates the ways and manners of the English [n -S]\n",
  "SHONEENS": "SHONEEN, (Irish) an Irishman who imitates the ways and manners of the English [n]\n",
  "SHONGOLOLO": "(Nguni) a kind of millipede, having a hard shiny dark brown segmented exoskeleton, also SONGOLOLO [n -S]\n",
  "SHONGOLOLOS": "SHONGOLOLO, (Nguni) a kind of millipede, having a hard shiny dark brown segmented exoskeleton, also SONGOLOLO [n]\n",
  "SHONKIER": "SHONKY, (Australian slang) unreliable, dishonest [adj]\n",
  "SHONKIEST": "SHONKY, (Australian slang) unreliable, dishonest [adj]\n",
  "SHONKY": "(Australian slang) unreliable, dishonest [adj SHONKIER, SHONKIEST]\n",
  "SHOO": "to drive away [v -ED, -ING, -S]\n",
  "SHOOED": "SHOO, to drive away [v]\n",
  "SHOOFLIES": "SHOOFLY, a child's rocker with a seat between flat sides shaped like a bird or animal [n]\n",
  "SHOOFLY": "a child's rocker with a seat between flat sides shaped like a bird or animal [n SHOOFLIES]\n",
  "SHOOGIE": "(Scots) to swing, sway back and forth, also SHOGGLE, SHOOGLE [v SHOOGIED, SHOOGIEING, SHOOGIES]\n",
  "SHOOGIED": "SHOOGIE, (Scots) to swing, sway back and forth, also SHOGGLE, SHOOGLE [v]\n",
  "SHOOGIEING": "SHOOGIE, (Scots) to swing, sway back and forth, also SHOGGLE, SHOOGLE [v]\n",
  "SHOOGIES": "SHOOGIE, (Scots) to swing, sway back and forth, also SHOGGLE, SHOOGLE [v]\n",
  "SHOOGLE": "(Scots) to swing, sway back and forth, also SHOGGLE, SHOOGIE [v SHOOGLED, SHOOGLING, SHOOGLES]\n",
  "SHOOGLED": "SHOOGLE, (Scots) to swing, sway back and forth, also SHOGGLE, SHOOGIE [v]\n",
  "SHOOGLES": "SHOOGLE, (Scots) to swing, sway back and forth, also SHOGGLE, SHOOGIE [v]\n",
  "SHOOGLIER": "SHOOGLY, (Scots) shaky, also SHOGGLY [adj]\n",
  "SHOOGLIEST": "SHOOGLY, (Scots) shaky, also SHOGGLY [adj]\n",
  "SHOOGLING": "SHOOGLE, (Scots) to swing, sway back and forth, also SHOGGLE, SHOOGIE [v]\n",
  "SHOOGLY": "(Scots) shaky, also SHOGGLY [adj SHOOGLIER, SHOOGLIEST]\n",
  "SHOOING": "SHOO, to drive away [v]\n",
  "SHOOK": "a bundle of sheaves [n -S]\n",
  "SHOOKS": "SHOOK, a bundle of sheaves [n]\n",
  "SHOOL": "(dialect) to saunter, skulk, also SHOOLE, SHULE [v -ED, -ING, -S]\n",
  "SHOOLE": "(dialect) to saunter, skulk, also SHOOL, SHULE [v SHOOLED, SHOOLING, SHOOLES]\n",
  "SHOOLED": "SHOOL, (dialect) to saunter, skulk, also SHOOLE, SHULE [v]\n",
  "SHOOLES": "SHOOLE, (dialect) to saunter, skulk, also SHOOL, SHULE [v]\n",
  "SHOOLING": "SHOOL, (dialect) to saunter, skulk, also SHOOLE, SHULE [v]\n",
  "SHOOLS": "SHOOL, (dialect) to saunter, skulk, also SHOOLE, SHULE [v]\n",
  "SHOON": "SHOE, a covering for the foot [n]\n",
  "SHOORA": "(Arabic) the Islamic principle of (rule by) consultation; an Islamic consultative council, also SHURA [n -S]\n",
  "SHOORAS": "SHOORA, (Arabic) the Islamic principle of (rule by) consultation; an Islamic consultative council, also SHURA [n]\n",
  "SHOOS": "SHOO, to drive away [v]\n",
  "SHOOSH": "to move with a rushing sound [v -ED, -ING, -ES]\n",
  "SHOOSHED": "SHOOSH, to move with a rushing sound [v]\n",
  "SHOOSHES": "SHOOSH, to move with a rushing sound [v]\n",
  "SHOOSHING": "SHOOSH, to move with a rushing sound [v]\n",
  "SHOOT": "to hit, injure or kill with a missile [v SHOT, SHOTTEN, SHOOTING, SHOOTS]\n",
  "SHOOTABLE": "that can be shot [adj]\n",
  "SHOOTAROUND": "an informal basketball practice or warmup before a game, during which players take turns shooting baskets [n -S]\n",
  "SHOOTAROUNDS": "SHOOTAROUND, an informal basketball practice or warmup before a game, during which players take turns shooting baskets [n]\n",
  "SHOOTDOWN": "the act of shooting down aircraft [n -S]\n",
  "SHOOTDOWNS": "SHOOTDOWN, the act of shooting down aircraft [n]\n",
  "SHOOTER": "one who shoots [n -S]\n",
  "SHOOTERS": "SHOOTER, one who shoots [n]\n",
  "SHOOTIE": "a fashionable shoe that covers the ankle [n -S]\n",
  "SHOOTIES": "SHOOTIE, a fashionable shoe that covers the ankle [n]\n",
  "SHOOTING": "the act of one that shoots [n -S]\n",
  "SHOOTINGS": "SHOOTING, the act of one that shoots [n]\n",
  "SHOOTIST": "a skilled marksman [n -S]\n",
  "SHOOTISTS": "SHOOTIST, a skilled marksman [n]\n",
  "SHOOTOUT": "a battle fought with guns [n -S]\n",
  "SHOOTOUTS": "SHOOTOUT, a battle fought with guns [n]\n",
  "SHOOTS": "SHOOT, to hit, injure or kill with a missile [v]\n",
  "SHOP": "to engage in the buying of goods [v SHOPPED, SHOPPING, SHOPS]\n",
  "SHOPAHOLIC": "a compulsive shopper [n -S]\n",
  "SHOPAHOLICS": "SHOPAHOLIC, a compulsive shopper [n]\n",
  "SHOPAHOLISM": "an addiction to shopping [n -S]\n",
  "SHOPAHOLISMS": "SHOPAHOLISM, an addiction to shopping [n]\n",
  "SHOPBOARD": "a bench or board on which work is performed [n -S]\n",
  "SHOPBOARDS": "SHOPBOARD, a bench or board on which work is performed [n]\n",
  "SHOPBOT": "a website that offers price comparisons for particular products [n -S]\n",
  "SHOPBOTS": "SHOPBOT, a website that offers price comparisons for particular products [n]\n",
  "SHOPBOY": "a boy employed in a shop [n -S]\n",
  "SHOPBOYS": "SHOPBOY, a boy employed in a shop [n]\n",
  "SHOPBREAKER": "a person who breaks into a shop [n -S]\n",
  "SHOPBREAKERS": "SHOPBREAKER, a person who breaks into a shop [n]\n",
  "SHOPBREAKING": "the act of breaking into a shop [n -S]\n",
  "SHOPBREAKINGS": "SHOPBREAKING, the act of breaking into a shop [n]\n",
  "SHOPE": "SHAPE, to fashion into a form [v]\n",
  "SHOPFITTER": "a worker who makes and installs fittings for commercial premises [n -S]\n",
  "SHOPFITTERS": "SHOPFITTER, a worker who makes and installs fittings for commercial premises [n]\n",
  "SHOPFRONT": "the front of a shop [n -S]\n",
  "SHOPFRONTS": "SHOPFRONT, the front of a shop [n]\n",
  "SHOPFUL": "as much as a shop can hold [n -S]\n",
  "SHOPFULS": "SHOPFUL, as much as a shop can hold [n]\n",
  "SHOPGIRL": "a salesgirl [n -S]\n",
  "SHOPGIRLS": "SHOPGIRL, a salesgirl [n]\n",
  "SHOPHAR": "(Hebrew) a ram's horn trumpet used in Jewish religious ceremonies, also SHOFAR [n SHOPHARS or SHOPHROTH]\n",
  "SHOPHARS": "SHOPHAR, (Hebrew) a ram's horn trumpet used in Jewish religious ceremonies, also SHOFAR [n]\n",
  "SHOPHOUSE": "(in Southeast Asia) a store opening onto the sidewalk and also used as the owner's residence [n -S]\n",
  "SHOPHOUSES": "SHOPHOUSE, (in Southeast Asia) a store opening onto the sidewalk and also used as the owner's residence [n]\n",
  "SHOPHROTH": "SHOPHAR, (Hebrew) a ram's horn trumpet used in Jewish religious ceremonies, also SHOFAR [n]\n",
  "SHOPKEEPER": "one who keeps a shop [n -S]\n",
  "SHOPKEEPERS": "SHOPKEEPER, one who keeps a shop [n]\n",
  "SHOPKEEPING": "the occupation of keeping a shop [n -S]\n",
  "SHOPKEEPINGS": "SHOPKEEPING, the occupation of keeping a shop [n]\n",
  "SHOPLESS": "having no stores [adj]\n",
  "SHOPLIFT": "to steal goods from a store [v -ED, -ING, -S]\n",
  "SHOPLIFTED": "SHOPLIFT, to steal goods from a store [v]\n",
  "SHOPLIFTER": "one who shoplifts [n -S]\n",
  "SHOPLIFTERS": "SHOPLIFTER, one who shoplifts [n]\n",
  "SHOPLIFTING": "the act of stealing goods from a store [n -S]\n",
  "SHOPLIFTINGS": "SHOPLIFTING, the act of stealing goods from a store [n]\n",
  "SHOPLIFTS": "SHOPLIFT, to steal goods from a store [v]\n",
  "SHOPMAN": "a man who owns or operates a store [n SHOPMEN]\n",
  "SHOPMEN": "SHOPMAN, a man who owns or operates a store [n]\n",
  "SHOPPE": "a small store [n -S]\n",
  "SHOPPED": "SHOP, to engage in the buying of goods [v]\n",
  "SHOPPER": "one who shops [n -S]\n",
  "SHOPPERS": "SHOPPER, one who shops [n]\n",
  "SHOPPES": "SHOPPE, a small store [n]\n",
  "SHOPPIER": "SHOPPY, abounding with shops [adj]\n",
  "SHOPPIES": "SHOPPY, a shop assistant [n]\n",
  "SHOPPIEST": "SHOPPY, abounding with shops [adj]\n",
  "SHOPPING": "the activity of visiting shops [n -S]\n",
  "SHOPPINGS": "SHOPPING, the activity of visiting shops [n]\n",
  "SHOPPY": "abounding with shops [adj SHOPPIER, SHOPPIEST] / a shop assistant [n SHOPPIES]\n",
  "SHOPS": "SHOP, to engage in the buying of goods [v]\n",
  "SHOPSOILED": "of goods, having deteriorated through handling in a shop [adj]\n",
  "SHOPTALK": "conversation concerning one's occupation [n -S]\n",
  "SHOPTALKS": "SHOPTALK, conversation concerning one's occupation [n]\n",
  "SHOPWALKER": "a person employed by a departmental store to supervise sales personnel, assist customers, etc. [n -S]\n",
  "SHOPWALKERS": "SHOPWALKER, a person employed by a departmental store to supervise sales personnel, assist customers, etc. [n]\n",
  "SHOPWINDOW": "a display window of a store [n -S]\n",
  "SHOPWINDOWS": "SHOPWINDOW, a display window of a store [n]\n",
  "SHOPWOMAN": "a woman who works in a shop [n SHOPWOMEN]\n",
  "SHOPWOMEN": "SHOPWOMAN, a woman who works in a shop [n]\n",
  "SHOPWORN": "showing wear from being in a shop [adj]\n",
  "SHORAN": "a system of navigation in an aircraft or other vehicle using the measurement of the time taken for dispatched radar signals to return from two known fixed points [n -S]\n",
  "SHORANS": "SHORAN, a system of navigation in an aircraft or other vehicle using the measurement of the time taken for dispatched radar signals to return from two known fixed points [n]\n",
  "SHORE": "the seaward edge of coast between low tide and effective wave action [n -S] / to prop up [v SHORED, SHORING, SHORES]\n",
  "SHOREBIRD": "any of various birds that live on the shore or close to water [n -S]\n",
  "SHOREBIRDS": "SHOREBIRD, any of various birds that live on the shore or close to water [n]\n",
  "SHORED": "SHORE, to prop up [v]\n",
  "SHOREFAST": "of ice, attached to the shore, landfast [adj]\n",
  "SHOREFRONT": "the part of a shore nearest the sea [n -S]\n",
  "SHOREFRONTS": "SHOREFRONT, the part of a shore nearest the sea [n]\n",
  "SHORELESS": "without a shore [adj]\n",
  "SHORELINE": "the line separating land and water, that fluctuates as water rises and falls [n -S]\n",
  "SHORELINES": "SHORELINE, the line separating land and water, that fluctuates as water rises and falls [n]\n",
  "SHOREMAN": "one who dwells on or by the shore, also SHORESMAN [n SHOREMEN]\n",
  "SHOREMEN": "SHOREMAN, one who dwells on or by the shore, also SHORESMAN [n]\n",
  "SHORER": "one who props up things [n -S]\n",
  "SHORERS": "SHORER, one who props up things [n]\n",
  "SHORES": "SHORE, to prop up [v]\n",
  "SHORESIDE": "the area near the shore [n -S]\n",
  "SHORESIDES": "SHORESIDE, the area near the shore [n]\n",
  "SHORESMAN": "(US) one who dwells on or by the shore, also SHOREMAN [n SHORESMEN]\n",
  "SHORESMEN": "SHORESMAN, (US) one who dwells on or by the shore, also SHOREMAN [n]\n",
  "SHOREWARD": "in the direction of the shore, also SHOREWARDS [adv]\n",
  "SHOREWARDS": "in the direction of the shore, also SHOREWARD [adv]\n",
  "SHOREWEED": "a plant of the plantain family, found on lakesides [n -S]\n",
  "SHOREWEEDS": "SHOREWEED, a plant of the plantain family, found on lakesides [n]\n",
  "SHORING": "a system of supporting timbers [n -S]\n",
  "SHORINGS": "SHORING, a system of supporting timbers [n]\n",
  "SHORL": "(German) black tourmaline, also SCHORL [n -S]\n",
  "SHORLS": "SHORL, (German) black tourmaline, also SCHORL [n]\n",
  "SHORN": "SHEAR, to cut the wool or hair from [v]\n",
  "SHORT": "having little length [adj SHORTER, SHORTEST, SHORTLY] / to cause a type of electrical malfunction in [v -ED, -ING, -S]\n",
  "SHORTAGE": "an insufficient supply [n -S]\n",
  "SHORTAGES": "SHORTAGE, an insufficient supply [n]\n",
  "SHORTARM": "using a bent arm [adj]\n",
  "SHORTARSE": "(colloquial) a short person [n -S]\n",
  "SHORTARSES": "SHORTARSE, (colloquial) a short person [n]\n",
  "SHORTBOARD": "a surfboard between six and eight feet in length [n -S]\n",
  "SHORTBOARDS": "SHORTBOARD, a surfboard between six and eight feet in length [n]\n",
  "SHORTBREAD": "a brittle crumbling biscuit of flour, butter and sugar, also SHORTCAKE [n -S]\n",
  "SHORTBREADS": "SHORTBREAD, a brittle crumbling biscuit of flour, butter and sugar, also SHORTCAKE [n]\n",
  "SHORTCAKE": "a brittle crumbling biscuit of flour, butter and sugar, also SHORTBREAD [n -S]\n",
  "SHORTCAKES": "SHORTCAKE, a brittle crumbling biscuit of flour, butter and sugar, also SHORTBREAD [n]\n",
  "SHORTCHANGE": "to give less than the correct amount of change to [v SHORTCHANGED, SHORTCHANGING, SHORTCHANGES]\n",
  "SHORTCHANGED": "SHORTCHANGE, to give less than the correct amount of change to [v]\n",
  "SHORTCHANGER": "one who gives short change [n -S]\n",
  "SHORTCHANGERS": "SHORTCHANGER, one who gives short change [n]\n",
  "SHORTCHANGES": "SHORTCHANGE, to give less than the correct amount of change to [v]\n",
  "SHORTCHANGING": "SHORTCHANGE, to give less than the correct amount of change to [v]\n",
  "SHORTCOMING": "an imperfection or lack that detracts from the whole [n -S]\n",
  "SHORTCOMINGS": "SHORTCOMING, an imperfection or lack that detracts from the whole [n]\n",
  "SHORTCRUST": "designating a type of pastry [adj]\n",
  "SHORTCUT": "to take a shorter or quicker way [v SHORTCUT, SHORTCUTTING, SHORTCUTS]\n",
  "SHORTCUTS": "SHORTCUT, to take a shorter or quicker way [v]\n",
  "SHORTCUTTING": "SHORTCUT, to take a shorter or quicker way [v]\n",
  "SHORTED": "SHORT, to cause a type of electrical malfunction in [v]\n",
  "SHORTEN": "to check or lessen the length [v -ED, -ING, -S]\n",
  "SHORTENED": "SHORTEN, to check or lessen the length [v]\n",
  "SHORTENER": "someone or something that shortens [n -S]\n",
  "SHORTENERS": "SHORTENER, someone or something that shortens [n]\n",
  "SHORTENING": "fat for making pastry short [n -S]\n",
  "SHORTENINGS": "SHORTENING, fat for making pastry short [n]\n",
  "SHORTENS": "SHORTEN, to check or lessen the length [v]\n",
  "SHORTER": "SHORT, having little length [adj]\n",
  "SHORTEST": "SHORT, having little length [adj]\n",
  "SHORTFALL": "the fact or amount of falling short [n -S]\n",
  "SHORTFALLS": "SHORTFALL, the fact or amount of falling short [n]\n",
  "SHORTGOWN": "(Scots) a woman's short jacket [n -S]\n",
  "SHORTGOWNS": "SHORTGOWN, (Scots) a woman's short jacket [n]\n",
  "SHORTHAIR": "a breed of domestic cat with a short thick coat [n -S]\n",
  "SHORTHAIRED": "having short hair [adj]\n",
  "SHORTHAIRS": "SHORTHAIR, a breed of domestic cat with a short thick coat [n]\n",
  "SHORTHAND": "a system of writing used for recording speech at speaking pace [n -S]\n",
  "SHORTHANDED": "having, working with, or done with fewer than the regular or necessary number of people [adj]\n",
  "SHORTHANDS": "SHORTHAND, a system of writing used for recording speech at speaking pace [n]\n",
  "SHORTHEAD": "a fish, a species of American redhorse [n -S]\n",
  "SHORTHEADS": "SHORTHEAD, a fish, a species of American redhorse [n]\n",
  "SHORTHOLD": "of or being a tenancy of one to five years [adj]\n",
  "SHORTHORN": "a breed of sheep [n -S]\n",
  "SHORTHORNS": "SHORTHORN, a breed of sheep [n]\n",
  "SHORTIA": "a perennial herb [n -S]\n",
  "SHORTIAS": "SHORTIA, a perennial herb [n]\n",
  "SHORTIE": "(colloquial) a short person, also SHORTY [n -S]\n",
  "SHORTIES": "SHORTY, (colloquial) a short person, also SHORTIE [n]\n",
  "SHORTING": "SHORT, to cause a type of electrical malfunction in [v]\n",
  "SHORTISH": "somewhat short [adj]\n",
  "SHORTLIST": "a list of candidates for an office, post, etc. from which the successful candidate will be selected [n -S] / to include on a shortlist [v -ED, -ING, -S]\n",
  "SHORTLISTED": "SHORTLIST, to include on a shortlist [v]\n",
  "SHORTLISTING": "SHORTLIST, to include on a shortlist [v]\n",
  "SHORTLISTS": "SHORTLIST, to include on a shortlist [v]\n",
  "SHORTLY": "SHORT, having little length [adv]\n",
  "SHORTNESS": "the state of being short [n -ES]\n",
  "SHORTNESSES": "SHORTNESS, the state of being short [n]\n",
  "SHORTS": "SHORT, to cause a type of electrical malfunction in [v]\n",
  "SHORTSHEET": "(US) to fold a sheet so that it is impossible for a person to stretch their legs when they get into bed [v -ED, -ING, -S]\n",
  "SHORTSHEETED": "SHORTSHEET, (US) to fold a sheet so that it is impossible for a person to stretch their legs when they get into bed [v]\n",
  "SHORTSHEETING": "SHORTSHEET, (US) to fold a sheet so that it is impossible for a person to stretch their legs when they get into bed [v]\n",
  "SHORTSHEETS": "SHORTSHEET, (US) to fold a sheet so that it is impossible for a person to stretch their legs when they get into bed [v]\n",
  "SHORTSIGHTED": "lacking foresight [adj SHORTSIGHTEDLY]\n",
  "SHORTSIGHTEDLY": "SHORTSIGHTED, lacking foresight [adv]\n",
  "SHORTSTOP": "the player stationed in the field between the second and third bases [n -S]\n",
  "SHORTSTOPS": "SHORTSTOP, the player stationed in the field between the second and third bases [n]\n",
  "SHORTSWORD": "a sword with a short blade [n -S]\n",
  "SHORTSWORDS": "SHORTSWORD, a sword with a short blade [n]\n",
  "SHORTWAVE": "a radio wave with a frequency of between 10 metres and 100 metres [n -S] / to broadcast on shortwave [v SHORTWAVED, SHORTWAVING, SHORTWAVES]\n",
  "SHORTWAVED": "SHORTWAVE, to broadcast on shortwave [v]\n",
  "SHORTWAVES": "SHORTWAVE, to broadcast on shortwave [v]\n",
  "SHORTWAVING": "SHORTWAVE, to broadcast on shortwave [v]\n",
  "SHORTY": "(colloquial) a short person, also SHORTIE [n SHORTIES]\n",
  "SHOT": "to load with small pellets [v SHOTTED, SHOTTING, SHOTS]\n",
  "SHOTCRETE": "a type of concrete material commonly known as sprayed concrete, whereby layers of concrete are extruded from a gun or hose to form the required [n -S]\n",
  "SHOTCRETES": "SHOTCRETE, a type of concrete material commonly known as sprayed concrete, whereby layers of concrete are extruded from a gun or hose to form the required [n]\n",
  "SHOTE": "a young pig, esp. one that has just been weaned, also SHOAT, SHOTTE [n -S]\n",
  "SHOTES": "SHOTE, a young pig, esp. one that has just been weaned, also SHOAT, SHOTTE [n]\n",
  "SHOTFIRER": "the mining worker who fires the blasting charges [n -S]\n",
  "SHOTFIRERS": "SHOTFIRER, the mining worker who fires the blasting charges [n]\n",
  "SHOTGUN": "to shoot with a type of gun [v SHOTGUNNED, SHOTGUNNING, SHOTGUNS]\n",
  "SHOTGUNNED": "SHOTGUN, to shoot with a type of gun [v]\n",
  "SHOTGUNNER": "one who uses a shotgun [n -S]\n",
  "SHOTGUNNERS": "SHOTGUNNER, one who uses a shotgun [n]\n",
  "SHOTGUNNING": "SHOTGUN, to shoot with a type of gun [v]\n",
  "SHOTGUNS": "SHOTGUN, to shoot with a type of gun [v]\n",
  "SHOTHOLE": "a hole drilled in a rock to hold explosives [n -S]\n",
  "SHOTHOLES": "SHOTHOLE, a hole drilled in a rock to hold explosives [n]\n",
  "SHOTMAKER": "in sport, a person who produces winning or attacking shots [n -S]\n",
  "SHOTMAKERS": "SHOTMAKER, in sport, a person who produces winning or attacking shots [n]\n",
  "SHOTMAKING": "the making of winning or skilful shots [n -S]\n",
  "SHOTMAKINGS": "SHOTMAKING, the making of winning or skilful shots [n]\n",
  "SHOTPROOF": "proof against shot [adj]\n",
  "SHOTS": "SHOT, to load with small pellets [v]\n",
  "SHOTT": "(Arabic) a shallow saline lake of northern Africa; the dried bed of such a lake, also CHOTT [n -S]\n",
  "SHOTTE": "a young pig, esp. one that has just been weaned, also SHOAT, SHOTE [n -S]\n",
  "SHOTTED": "SHOT, to load with small pellets [v]\n",
  "SHOTTEN": "of a salmon, having recently spawned and less desirable as food [adj]\n",
  "SHOTTES": "SHOTTE, a young pig, esp. one that has just been weaned, also SHOAT, SHOTE [n]\n",
  "SHOTTING": "SHOT, to load with small pellets [v]\n",
  "SHOTTLE": "(Scots) a small drawer, esp. in a cabinet [n -S]\n",
  "SHOTTLES": "SHOTTLE, (Scots) a small drawer, esp. in a cabinet [n]\n",
  "SHOTTS": "SHOTT, (Arabic) a shallow saline lake of northern Africa; the dried bed of such a lake, also CHOTT [n]\n",
  "SHOUGH": "a shaggy lapdog, also SHOWGHE [n -S]\n",
  "SHOUGHS": "SHOUGH, a shaggy lapdog, also SHOWGHE [n]\n",
  "SHOULD": "SHALL, used as an auxiliary to express futurity, inevitability, or command [v]\n",
  "SHOULDER": "to assume the burden of, also SHOUTHER [v -ED, -ING, -S]\n",
  "SHOULDERED": "SHOULDER, to assume the burden of, also SHOUTHER [v]\n",
  "SHOULDERING": "the act of carrying on the shoulder [n -S]\n",
  "SHOULDERINGS": "SHOULDERING, the act of carrying on the shoulder [n]\n",
  "SHOULDERS": "SHOULDER, to assume the burden of, also SHOUTHER [v]\n",
  "SHOULDEST": "SHALL, used as an auxiliary to express futurity, inevitability, or command [v]\n",
  "SHOULDST": "SHALL, used as an auxiliary to express futurity, inevitability, or command [v]\n",
  "SHOUSE": "(Australian slang) a toilet [n -S]\n",
  "SHOUSES": "SHOUSE, (Australian slang) a toilet [n]\n",
  "SHOUT": "to yell loudly [v -ED, -ING, -S]\n",
  "SHOUTED": "SHOUT, to yell loudly [v]\n",
  "SHOUTER": "one who shouts [n -S]\n",
  "SHOUTERS": "SHOUTER, one who shouts [n]\n",
  "SHOUTHER": "(Scots) to assume the burden of, also SHOULDER [v -ED, -ING, -S]\n",
  "SHOUTHERED": "SHOUTHER, (Scots) to assume the burden of, also SHOULDER [v]\n",
  "SHOUTHERING": "SHOUTHER, (Scots) to assume the burden of, also SHOULDER [v]\n",
  "SHOUTHERS": "SHOUTHER, (Scots) to assume the burden of, also SHOULDER [v]\n",
  "SHOUTIER": "SHOUTY, prone to shouting [adj]\n",
  "SHOUTIEST": "SHOUTY, prone to shouting [adj]\n",
  "SHOUTING": "loud [adj SHOUTINGLY] / the act of shouting [n -S]\n",
  "SHOUTINGLY": "SHOUTING, loud [adv]\n",
  "SHOUTINGS": "SHOUTING, the act of shouting [n]\n",
  "SHOUTLINE": "a short line of text, usually printed in bold type, drawing attention to a major selling point in an advertisement [n -S]\n",
  "SHOUTLINES": "SHOUTLINE, a short line of text, usually printed in bold type, drawing attention to a major selling point in an advertisement [n]\n",
  "SHOUTOUT": "a public greeting, esp. one broadcast via television or radio [n -S]\n",
  "SHOUTOUTS": "SHOUTOUT, a public greeting, esp. one broadcast via television or radio [n]\n",
  "SHOUTS": "SHOUT, to yell loudly [v]\n",
  "SHOUTY": "prone to shouting [adj SHOUTIER, SHOUTIEST]\n",
  "SHOVE": "to push roughly [v SHOVED, SHOVING, SHOVES]\n",
  "SHOVED": "SHOVE, to push roughly [v]\n",
  "SHOVEL": "to use a digging implement [v SHOVELLED or SHOVELED, SHOVELLING or SHOVELING, SHOVELS]\n",
  "SHOVELBOARD": "an old game in which a coin or other disc was driven along a table by the hand, also SHUFFLEBOARD [n -S]\n",
  "SHOVELBOARDS": "SHOVELBOARD, an old game in which a coin or other disc was driven along a table by the hand, also SHUFFLEBOARD [n]\n",
  "SHOVELED": "SHOVEL, to use a digging implement [v]\n",
  "SHOVELER": "a kind of duck with a broad shovel-shaped bill, also SHOVELLER [n -S]\n",
  "SHOVELERS": "SHOVELER, a kind of duck with a broad shovel-shaped bill, also SHOVELLER [n]\n",
  "SHOVELFUL": "as much as a shovel will hold [n SHOVELFULS or SHOVELSFUL]\n",
  "SHOVELFULS": "SHOVELFUL, as much as a shovel will hold [n]\n",
  "SHOVELHEAD": "a kind of shark, allied to the hammerhead, and native of the warmer parts of the Atlantic and Pacific oceans [n -S]\n",
  "SHOVELHEADS": "SHOVELHEAD, a kind of shark, allied to the hammerhead, and native of the warmer parts of the Atlantic and Pacific oceans [n]\n",
  "SHOVELING": "SHOVEL, to use a digging implement [v]\n",
  "SHOVELLED": "SHOVEL, to use a digging implement [v]\n",
  "SHOVELLER": "a kind of duck with a broad shovel-shaped bill, also SHOVELER [n -S]\n",
  "SHOVELLERS": "SHOVELLER, a kind of duck with a broad shovel-shaped bill, also SHOVELER [n]\n",
  "SHOVELLING": "SHOVEL, to use a digging implement [v]\n",
  "SHOVELNOSE": "a freshwater sturgeon of North American rivers, having a broad shovel-like snout [n -S]\n",
  "SHOVELNOSES": "SHOVELNOSE, a freshwater sturgeon of North American rivers, having a broad shovel-like snout [n]\n",
  "SHOVELS": "SHOVEL, to use a digging implement [v]\n",
  "SHOVELSFUL": "SHOVELFUL, as much as a shovel will hold [n]\n",
  "SHOVER": "one who shoves, as in duck shover [n -S]\n",
  "SHOVERS": "SHOVER, one who shoves, as in duck shover [n]\n",
  "SHOVES": "SHOVE, to push roughly [v]\n",
  "SHOVING": "the act of shoving [n -S]\n",
  "SHOVINGS": "SHOVING, the act of shoving [n]\n",
  "SHOW": "to cause or permit to be seen [v SHOWED or SHEWED, SHOWN or SHEWN, SHOWING, SHOWS]\n",
  "SHOWABLE": "able to be shown [adj]\n",
  "SHOWBIZ": "(short for) show business [n SHOWBIZZES]\n",
  "SHOWBIZZES": "SHOWBIZ, (short for) show business [n]\n",
  "SHOWBIZZIER": "SHOWBIZZY, of or like showbiz, show business [adj]\n",
  "SHOWBIZZIEST": "SHOWBIZZY, of or like showbiz, show business [adj]\n",
  "SHOWBIZZY": "of or like showbiz, show business [adj SHOWBIZZIER, SHOWBIZZIEST]\n",
  "SHOWBOAT": "to show off [v -ED, -ING, -S]\n",
  "SHOWBOATED": "SHOWBOAT, to show off [v]\n",
  "SHOWBOATER": "one who behaves in an ostentatious manner to show off [n -S]\n",
  "SHOWBOATERS": "SHOWBOATER, one who behaves in an ostentatious manner to show off [n]\n",
  "SHOWBOATING": "SHOWBOAT, to show off [v]\n",
  "SHOWBOATS": "SHOWBOAT, to show off [v]\n",
  "SHOWBOX": "a showman's box [n -ES]\n",
  "SHOWBOXES": "SHOWBOX, a showman's box [n]\n",
  "SHOWBREAD": "twelve loaves placed every Sabbath beside the altar in the Jewish Temple and eaten by the priests at the end of the week, also SHEWBREAD [n -S]\n",
  "SHOWBREADS": "SHOWBREAD, twelve loaves placed every Sabbath beside the altar in the Jewish Temple and eaten by the priests at the end of the week, also SHEWBREAD [n]\n",
  "SHOWCASE": "to show something off to best advantage [v SHOWCASED, SHOWCASING, SHOWCASES]\n",
  "SHOWCASED": "SHOWCASE, to show something off to best advantage [v]\n",
  "SHOWCASES": "SHOWCASE, to show something off to best advantage [v]\n",
  "SHOWCASING": "SHOWCASE, to show something off to best advantage [v]\n",
  "SHOWD": "(Scots) to rock to and fro [v -ED, -ING, -S]\n",
  "SHOWDED": "SHOWD, (Scots) to rock to and fro [v]\n",
  "SHOWDING": "SHOWD, (Scots) to rock to and fro [v]\n",
  "SHOWDOWN": "an event that causes a conclusion of an issue [n -S]\n",
  "SHOWDOWNS": "SHOWDOWN, an event that causes a conclusion of an issue [n]\n",
  "SHOWDS": "SHOWD, (Scots) to rock to and fro [v]\n",
  "SHOWED": "SHOW, to cause or permit to be seen [v]\n",
  "SHOWER": "to bathe in a spray of water [v -ED, -ING, -S]\n",
  "SHOWERED": "SHOWER, to bathe in a spray of water [v]\n",
  "SHOWERER": "one who showers [n -S]\n",
  "SHOWERERS": "SHOWERER, one who showers [n]\n",
  "SHOWERFUL": "full of showers [adj]\n",
  "SHOWERHEAD": "a fixture for directing the spray of water from an overhead shower [n -S]\n",
  "SHOWERHEADS": "SHOWERHEAD, a fixture for directing the spray of water from an overhead shower [n]\n",
  "SHOWERIER": "SHOWERY, abounding with showers [adj]\n",
  "SHOWERIEST": "SHOWERY, abounding with showers [adj]\n",
  "SHOWERINESS": "the state of being showery [n -ES]\n",
  "SHOWERINESSES": "SHOWERINESS, the state of being showery [n]\n",
  "SHOWERING": "the act of taking a shower [n -S]\n",
  "SHOWERINGS": "SHOWERING, the act of taking a shower [n]\n",
  "SHOWERLESS": "rainless; free from showers [adj]\n",
  "SHOWERPROOF": "to make clothes resistant to light rain [v -ED, -ING, -S]\n",
  "SHOWERPROOFED": "SHOWERPROOF, to make clothes resistant to light rain [v]\n",
  "SHOWERPROOFING": "the act of making proof against showers [n -S]\n",
  "SHOWERPROOFINGS": "SHOWERPROOFING, the act of making proof against showers [n]\n",
  "SHOWERPROOFS": "SHOWERPROOF, to make clothes resistant to light rain [v]\n",
  "SHOWERS": "SHOWER, to bathe in a spray of water [v]\n",
  "SHOWERY": "abounding with showers [adj SHOWERIER, SHOWERIEST]\n",
  "SHOWGHE": "(Shakespeare) a shaggy dog, also SHOUGH [n -S]\n",
  "SHOWGHES": "SHOWGHE, (Shakespeare) a shaggy dog, also SHOUGH [n]\n",
  "SHOWGIRL": "a chorus girl [n -S]\n",
  "SHOWGIRLS": "SHOWGIRL, a chorus girl [n]\n",
  "SHOWGOER": "one who goes to shows [n -S]\n",
  "SHOWGOERS": "SHOWGOER, one who goes to shows [n]\n",
  "SHOWGROUND": "a plot of land on which an outdoor show is held [n -S]\n",
  "SHOWGROUNDS": "SHOWGROUND, a plot of land on which an outdoor show is held [n]\n",
  "SHOWIER": "SHOWY, making a brilliant display [adj]\n",
  "SHOWIEST": "SHOWY, making a brilliant display [adj]\n",
  "SHOWILY": "SHOWY, making a brilliant display [adv]\n",
  "SHOWINESS": "the state of being showy [n -ES]\n",
  "SHOWINESSES": "SHOWINESS, the state of being showy [n]\n",
  "SHOWING": "an exhibition or display [n -S]\n",
  "SHOWINGS": "SHOWING, an exhibition or display [n]\n",
  "SHOWJUMP": "to take part in a showjumping competition [v -ED, -ING, -S]\n",
  "SHOWJUMPED": "SHOWJUMP, to take part in a showjumping competition [v]\n",
  "SHOWJUMPER": "a horse or rider in a showjumping competition [n -S]\n",
  "SHOWJUMPERS": "SHOWJUMPER, a horse or rider in a showjumping competition [n]\n",
  "SHOWJUMPING": "a competition in which a succession of riders on horseback have to jump a series of obstacles of different kinds [n -S]\n",
  "SHOWJUMPINGS": "SHOWJUMPING, a competition in which a succession of riders on horseback have to jump a series of obstacles of different kinds [n]\n",
  "SHOWJUMPS": "SHOWJUMP, to take part in a showjumping competition [v]\n",
  "SHOWMAN": "a theatrical producer [n SHOWMEN]\n",
  "SHOWMANCE": "a romance between two stars that only lasts for the run of the show [n -S]\n",
  "SHOWMANCES": "SHOWMANCE, a romance between two stars that only lasts for the run of the show [n]\n",
  "SHOWMANLIER": "SHOWMANLY, having the manner of a showman [adj]\n",
  "SHOWMANLIEST": "SHOWMANLY, having the manner of a showman [adj]\n",
  "SHOWMANLY": "having the manner of a showman [adj SHOWMANLIER, SHOWMANLIEST]\n",
  "SHOWMANSHIP": "skilful display, or a talent for it [n -S]\n",
  "SHOWMANSHIPS": "SHOWMANSHIP, skilful display, or a talent for it [n]\n",
  "SHOWMEN": "SHOWMAN, a theatrical producer [n]\n",
  "SHOWN": "SHOW, to cause or permit to be seen [v]\n",
  "SHOWOFF": "one given to pretentious display [n -S]\n",
  "SHOWOFFS": "SHOWOFF, one given to pretentious display [n]\n",
  "SHOWPIECE": "something considered an esp. fine specimen of its type, etc. [n -S]\n",
  "SHOWPIECES": "SHOWPIECE, something considered an esp. fine specimen of its type, etc. [n]\n",
  "SHOWPLACE": "a place visited or shown as a sight [n -S]\n",
  "SHOWPLACES": "SHOWPLACE, a place visited or shown as a sight [n]\n",
  "SHOWRING": "a ring where animals are displayed [n -S]\n",
  "SHOWRINGS": "SHOWRING, a ring where animals are displayed [n]\n",
  "SHOWROOM": "a room used for the display of merchandise [n -S]\n",
  "SHOWROOMING": "the practice of looking at an item of merchandise in a shop, often using a smartphone app to compare its price elsewhere, before buying it from an online distributor [n -S]\n",
  "SHOWROOMINGS": "SHOWROOMING, the practice of looking at an item of merchandise in a shop, often using a smartphone app to compare its price elsewhere, before buying it from an online distributor [n]\n",
  "SHOWROOMS": "SHOWROOM, a room used for the display of merchandise [n]\n",
  "SHOWS": "SHOW, to cause or permit to be seen [v]\n",
  "SHOWSTOPPER": "a performer or performance that wins enthusiastic or prolonged applause [n -S]\n",
  "SHOWSTOPPERS": "SHOWSTOPPER, a performer or performance that wins enthusiastic or prolonged applause [n]\n",
  "SHOWSTOPPING": "denoting an extraordinary performance [adj]\n",
  "SHOWTIME": "the time at which an entertainment is to start [n -S]\n",
  "SHOWTIMES": "SHOWTIME, the time at which an entertainment is to start [n]\n",
  "SHOWY": "making a brilliant display [adj SHOWIER, SHOWIEST]\n",
  "SHOWYARD": "a yard for cattle shows [n -S]\n",
  "SHOWYARDS": "SHOWYARD, a yard for cattle shows [n]\n",
  "SHOYU": "(Japanese) a rich soy sauce made from soya beans naturally fermented with wheat or barley [n -S]\n",
  "SHOYUS": "SHOYU, (Japanese) a rich soy sauce made from soya beans naturally fermented with wheat or barley [n]\n",
  "SHRADDHA": "(Sanskrit) an offering to the manes of an ancestor, also SRADDHA, SRADHA [n -S]\n",
  "SHRADDHAS": "SHRADDHA, (Sanskrit) an offering to the manes of an ancestor, also SRADDHA, SRADHA [n]\n",
  "SHRANK": "SHRINK, to contract or draw back [v]\n",
  "SHRAPNEL": "fragments from an exploding bomb, mine, or shell [n -S]\n",
  "SHRAPNELS": "SHRAPNEL, fragments from an exploding bomb, mine, or shell [n]\n",
  "SHRED": "to cut into fine strips [v SHREDDED, SHREDDING, SHREDS]\n",
  "SHREDDED": "SHRED, to cut into fine strips [v]\n",
  "SHREDDER": "a machine that shreds [n -S]\n",
  "SHREDDERS": "SHREDDER, a machine that shreds [n]\n",
  "SHREDDIER": "SHREDDY, cut up [adj]\n",
  "SHREDDIEST": "SHREDDY, cut up [adj]\n",
  "SHREDDING": "the act of shredding [n -S]\n",
  "SHREDDINGS": "SHREDDING, the act of shredding [n]\n",
  "SHREDDY": "cut up [adj SHREDDIER, SHREDDIEST]\n",
  "SHREDLESS": "having no shreds; without a shred [adj]\n",
  "SHREDS": "SHRED, to cut into fine strips [v]\n",
  "SHREEK": "(Shakespeare) to shriek, also SCRIKE, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v -ED, -ING, -S]\n",
  "SHREEKED": "SHREEK, (Shakespeare) to shriek, also SCRIKE, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHREEKING": "SHREEK, (Shakespeare) to shriek, also SCRIKE, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHREEKS": "SHREEK, (Shakespeare) to shriek, also SCRIKE, SHREIK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHREIK": "(Milton) to shriek, also SCRIKE, SHREEK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v -ED, -ING, -S]\n",
  "SHREIKED": "SHREIK, (Milton) to shriek, also SCRIKE, SHREEK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHREIKING": "SHREIK, (Milton) to shriek, also SCRIKE, SHREEK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHREIKS": "SHREIK, (Milton) to shriek, also SCRIKE, SHREEK, SHRIECH, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHREW": "(Shakespeare) to curse [v -ED, -ING, -S]\n",
  "SHREWD": "having keen insight [adj SHREWDER, SHREWDEST, SHREWDLY]\n",
  "SHREWDER": "SHREWD, having keen insight [adj]\n",
  "SHREWDEST": "SHREWD, having keen insight [adj]\n",
  "SHREWDIE": "(Australian slang) a shrewd person [n -S]\n",
  "SHREWDIES": "SHREWDIE, (Australian slang) a shrewd person [n]\n",
  "SHREWDLY": "SHREWD, having keen insight [adv]\n",
  "SHREWDNESS": "the state of being shrewd [n -ES]\n",
  "SHREWDNESSES": "SHREWDNESS, the state of being shrewd [n]\n",
  "SHREWED": "SHREW, (Shakespeare) to curse [v]\n",
  "SHREWING": "SHREW, (Shakespeare) to curse [v]\n",
  "SHREWISH": "ill-tempered [adj SHREWISHLY]\n",
  "SHREWISHLY": "SHREWISH, ill-tempered [adv]\n",
  "SHREWISHNESS": "the state of being shrewish [n -ES]\n",
  "SHREWISHNESSES": "SHREWISHNESS, the state of being shrewish [n]\n",
  "SHREWLIKE": "like a shrew [adj]\n",
  "SHREWMICE": "SHREWMOUSE, a shrew [n]\n",
  "SHREWMOUSE": "a shrew [n SHREWMICE]\n",
  "SHREWS": "SHREW, (Shakespeare) to curse [v]\n",
  "SHRI": "(Sanskrit) in India, a title of great respect given to a man, also SRI [n -S]\n",
  "SHRIECH": "(Spenser) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v -ED, -ING, -ES]\n",
  "SHRIECHED": "SHRIECH, (Spenser) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHRIECHES": "SHRIECH, (Spenser) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHRIECHING": "SHRIECH, (Spenser) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIEK, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHRIEK": "to utter a scream, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH, SKRIKE [v -ED, -ING, -S]\n",
  "SHRIEKED": "SHRIEK, to utter a scream, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHRIEKER": "one who shrieks [n -S]\n",
  "SHRIEKERS": "SHRIEKER, one who shrieks [n]\n",
  "SHRIEKIER": "SHRIEKY, shrill [adj]\n",
  "SHRIEKIEST": "SHRIEKY, shrill [adj]\n",
  "SHRIEKING": "shrill [adj SHRIEKINGLY] / the act of shrieking [n -S]\n",
  "SHRIEKINGLY": "SHRIEKING, shrill [adv]\n",
  "SHRIEKINGS": "SHRIEKING, the act of shrieking [n]\n",
  "SHRIEKS": "SHRIEK, to utter a scream, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH, SKRIKE [v]\n",
  "SHRIEKY": "shrill [adj SHRIEKIER, SHRIEKIEST]\n",
  "SHRIEVAL": "relating to a sheriff [adj]\n",
  "SHRIEVALTIES": "SHRIEVALTY, the office of sheriff, also SHERIFFALTY [n]\n",
  "SHRIEVALTY": "the office of sheriff, also SHERIFFALTY [n SHRIEVALTIES]\n",
  "SHRIEVE": "(Spenser) to hear a confession and grant absolution, also SHRIVE [v SHRIEVED, SHRIEVING, SHRIEVES]\n",
  "SHRIEVED": "SHRIEVE, (Spenser) to hear a confession and grant absolution, also SHRIVE [v]\n",
  "SHRIEVES": "SHRIEVE, (Spenser) to hear a confession and grant absolution, also SHRIVE [v]\n",
  "SHRIEVING": "SHRIEVE, (Spenser) to hear a confession and grant absolution, also SHRIVE [v]\n",
  "SHRIFT": "(archaic) a prescribed penance; a confessional [n -S]\n",
  "SHRIFTS": "SHRIFT, (archaic) a prescribed penance; a confessional [n]\n",
  "SHRIGHT": "(Spenser) a shriek [n -S]\n",
  "SHRIGHTS": "SHRIGHT, (Spenser) a shriek [n]\n",
  "SHRIKE": "to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRITCH, SKRIKE [v SHRIKED, SHRIKING, SHRIKES]\n",
  "SHRIKED": "SHRIKE, to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRITCH, SKRIKE [v]\n",
  "SHRIKES": "SHRIKE, to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRITCH, SKRIKE [v]\n",
  "SHRIKING": "SHRIKE, to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRITCH, SKRIKE [v]\n",
  "SHRILL": "to utter a high-pitched sound [v -ED, -ING, -S] / having a high-pitched piercing quality [adj SHRILLER, SHRILLEST, SHRILLY]\n",
  "SHRILLED": "SHRILL, to utter a high-pitched sound [v]\n",
  "SHRILLER": "SHRILL, having a high-pitched piercing quality [adj]\n",
  "SHRILLEST": "SHRILL, having a high-pitched piercing quality [adj]\n",
  "SHRILLIER": "SHRILLY, high-pitched or piercing [adj]\n",
  "SHRILLIEST": "SHRILLY, high-pitched or piercing [adj]\n",
  "SHRILLING": "a piercing sound [n -S]\n",
  "SHRILLINGS": "SHRILLING, a piercing sound [n]\n",
  "SHRILLNESS": "the state of being shrill [n -ES]\n",
  "SHRILLNESSES": "SHRILLNESS, the state of being shrill [n]\n",
  "SHRILLS": "SHRILL, to utter a high-pitched sound [v]\n",
  "SHRILLY": "high-pitched or piercing [adj SHRILLIER, SHRILLIEST]\n",
  "SHRIMP": "to catch small edible crustaceans [v -ED, -ING, -S]\n",
  "SHRIMPED": "SHRIMP, to catch small edible crustaceans [v]\n",
  "SHRIMPER": "a fisher of shrimp [n -S]\n",
  "SHRIMPERS": "SHRIMPER, a fisher of shrimp [n]\n",
  "SHRIMPIER": "SHRIMPY, abounding in shrimp [adj]\n",
  "SHRIMPIEST": "SHRIMPY, abounding in shrimp [adj]\n",
  "SHRIMPING": "fishing for shrimps [n -S]\n",
  "SHRIMPINGS": "SHRIMPING, fishing for shrimps [n]\n",
  "SHRIMPLIKE": "like a shrimp [adj]\n",
  "SHRIMPS": "SHRIMP, to catch small edible crustaceans [v]\n",
  "SHRIMPY": "abounding in shrimp [adj SHRIMPIER, SHRIMPIEST]\n",
  "SHRINAL": "of a shrine [adj]\n",
  "SHRINE": "to place on an altar for sacred relics [v SHRINED, SHRINING, SHRINES]\n",
  "SHRINED": "SHRINE, to place on an altar for sacred relics [v]\n",
  "SHRINELIKE": "like a shrine [adj]\n",
  "SHRINES": "SHRINE, to place on an altar for sacred relics [v]\n",
  "SHRINING": "SHRINE, to place on an altar for sacred relics [v]\n",
  "SHRINK": "to contract or draw back [v SHRANK, SHRUNK or SHRUNKEN, SHRINKING, SHRINKS]\n",
  "SHRINKABLE": "that can be shrunken [adj]\n",
  "SHRINKAGE": "the amount by which something shrinks [n -S]\n",
  "SHRINKAGES": "SHRINKAGE, the amount by which something shrinks [n]\n",
  "SHRINKER": "one who shrinks [n -S]\n",
  "SHRINKERS": "SHRINKER, one who shrinks [n]\n",
  "SHRINKFLATION": "a reduction in the size of an item of packaged food, such as a chocolate bar, while the price remains the same [n -S]\n",
  "SHRINKFLATIONS": "SHRINKFLATION, a reduction in the size of an item of packaged food, such as a chocolate bar, while the price remains the same [n]\n",
  "SHRINKING": "drawing back, shy [adj SHRINKINGLY]\n",
  "SHRINKINGLY": "SHRINKING, drawing back, shy [adv]\n",
  "SHRINKPACK": "a shrink-wrapped package [n -S]\n",
  "SHRINKPACKS": "SHRINKPACK, a shrink-wrapped package [n]\n",
  "SHRINKS": "SHRINK, to contract or draw back [v]\n",
  "SHRIS": "SHRI, (Sanskrit) in India, a title of great respect given to a man, also SRI [n]\n",
  "SHRITCH": "(dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SKRIKE [v -ED, -ING, -ES]\n",
  "SHRITCHED": "SHRITCH, (dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SKRIKE [v]\n",
  "SHRITCHES": "SHRITCH, (dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SKRIKE [v]\n",
  "SHRITCHING": "SHRITCH, (dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIEK, SHRIKE, SKRIKE [v]\n",
  "SHRIVE": "to hear a confession and grant absolution, also SHRIEVE [v SHRIVED or SHROVE, SHRIVEN, SHRIVING, SHRIVES]\n",
  "SHRIVED": "SHRIVE, to hear a confession and grant absolution, also SHRIEVE [v]\n",
  "SHRIVEL": "to contract into wrinkles [v SHRIVELED or SHRIVELLED, SHRIVELING or SHRIVELLING, SHRIVELS]\n",
  "SHRIVELED": "SHRIVEL, to contract into wrinkles [v]\n",
  "SHRIVELING": "SHRIVEL, to contract into wrinkles [v]\n",
  "SHRIVELLED": "SHRIVEL, to contract into wrinkles [v]\n",
  "SHRIVELLING": "SHRIVEL, to contract into wrinkles [v]\n",
  "SHRIVELS": "SHRIVEL, to contract into wrinkles [v]\n",
  "SHRIVEN": "SHRIVE, to hear a confession and grant absolution, also SHRIEVE [v]\n",
  "SHRIVER": "one who shrives; a confessor [n -S]\n",
  "SHRIVERS": "SHRIVER, one who shrives; a confessor [n]\n",
  "SHRIVES": "SHRIVE, to hear a confession and grant absolution, also SHRIEVE [v]\n",
  "SHRIVING": "(Spenser) shrift [n -S]\n",
  "SHRIVINGS": "SHRIVING, (Spenser) shrift [n]\n",
  "SHROFF": "(Arabic) to test coins for authenticity [v -ED, -ING, -S]\n",
  "SHROFFAGE": "the examination of coins, and the separation of the good from the debased [n -S]\n",
  "SHROFFAGES": "SHROFFAGE, the examination of coins, and the separation of the good from the debased [n]\n",
  "SHROFFED": "SHROFF, (Arabic) to test coins for authenticity [v]\n",
  "SHROFFING": "SHROFF, (Arabic) to test coins for authenticity [v]\n",
  "SHROFFS": "SHROFF, (Arabic) to test coins for authenticity [v]\n",
  "SHROOM": "a magic mushroom [n -S] / to take magic mushrooms [v -ED, -ING, -S]\n",
  "SHROOMED": "SHROOM, to take magic mushrooms [v]\n",
  "SHROOMER": "one who takes magic mushrooms [n -S]\n",
  "SHROOMERS": "SHROOMER, one who takes magic mushrooms [n]\n",
  "SHROOMING": "SHROOM, to take magic mushrooms [v]\n",
  "SHROOMS": "SHROOM, to take magic mushrooms [v]\n",
  "SHROUD": "to attire in burial clothing [v -ED, -ING, -S]\n",
  "SHROUDED": "SHROUD, to attire in burial clothing [v]\n",
  "SHROUDIER": "SHROUDY, giving shelter [adj]\n",
  "SHROUDIEST": "SHROUDY, giving shelter [adj]\n",
  "SHROUDING": "the act of covering with a shroud [n -S]\n",
  "SHROUDINGS": "SHROUDING, the act of covering with a shroud [n]\n",
  "SHROUDLESS": "without a shroud [adj]\n",
  "SHROUDS": "SHROUD, to attire in burial clothing [v]\n",
  "SHROUDY": "giving shelter [adj SHROUDIER, SHROUDIEST]\n",
  "SHROVE": "to celebrate Shrovetide [v SHROVED, SHROVING, SHROVES]\n",
  "SHROVED": "SHROVE, to celebrate Shrovetide [v]\n",
  "SHROVES": "SHROVE, to celebrate Shrovetide [v]\n",
  "SHROVING": "SHROVE, to celebrate Shrovetide [v]\n",
  "SHROW": "(Shakespeare) to shrew, to curse, also SHREW [v -ED, -ING, -S]\n",
  "SHROWD": "(Shakespeare) shrewd [adj]\n",
  "SHROWED": "SHROW, (Shakespeare) to shrew, to curse, also SHREW [v]\n",
  "SHROWING": "SHROW, (Shakespeare) to shrew, to curse, also SHREW [v]\n",
  "SHROWS": "SHROW, (Shakespeare) to shrew, to curse, also SHREW [v]\n",
  "SHRUB": "a low woody plant smaller than a tree [n -S] / to lop; to cudgel [v SHRUBBED, SHRUBBING, SHRUBS]\n",
  "SHRUBBED": "SHRUB, to lop; to cudgel [v]\n",
  "SHRUBBERIED": "having a shrubbery [adj]\n",
  "SHRUBBERIES": "SHRUBBERY, a collection of shrubs [n]\n",
  "SHRUBBERY": "a collection of shrubs [n SHRUBBERIES]\n",
  "SHRUBBIER": "SHRUBBY, covered with shrubs [adj]\n",
  "SHRUBBIEST": "SHRUBBY, covered with shrubs [adj]\n",
  "SHRUBBINESS": "the state of being shrubby [n -ES]\n",
  "SHRUBBINESSES": "SHRUBBINESS, the state of being shrubby [n]\n",
  "SHRUBBING": "SHRUB, to lop; to cudgel [v]\n",
  "SHRUBBY": "covered with shrubs [adj SHRUBBIER, SHRUBBIEST]\n",
  "SHRUBLAND": "land covered by shrubs [n -S]\n",
  "SHRUBLANDS": "SHRUBLAND, land covered by shrubs [n]\n",
  "SHRUBLESS": "having no shrubs [adj]\n",
  "SHRUBLIKE": "resembling a shrub [adj]\n",
  "SHRUBS": "SHRUB, to lop; to cudgel [v]\n",
  "SHRUG": "to raise and contract the shoulders [v SHRUGGED, SHRUGGING, SHRUGS]\n",
  "SHRUGGED": "SHRUG, to raise and contract the shoulders [v]\n",
  "SHRUGGING": "SHRUG, to raise and contract the shoulders [v]\n",
  "SHRUGS": "SHRUG, to raise and contract the shoulders [v]\n",
  "SHRUNK": "SHRINK, to contract or draw back [v]\n",
  "SHRUNKEN": "SHRINK, to contract or draw back [v]\n",
  "SHTCHI": "(Russian) a kind of cabbage soup, also SHCHI [n -S]\n",
  "SHTCHIS": "SHTCHI, (Russian) a kind of cabbage soup, also SHCHI [n]\n",
  "SHTETEL": "(Yiddish) formerly, a Jewish community in an Eastern European town or village, also SHTETL [n SHTETELACH or SHTETELS]\n",
  "SHTETELACH": "SHTETEL, (Yiddish) formerly, a Jewish community in an Eastern European town or village, also SHTETL [n]\n",
  "SHTETELS": "SHTETEL, (Yiddish) formerly, a Jewish community in an Eastern European town or village, also SHTETL [n]\n",
  "SHTETL": "(Yiddish) formerly, a Jewish community in an Eastern European town or village, also SHTETEL [n SHTETLACH or SHTETLS]\n",
  "SHTETLACH": "SHTETL, (Yiddish) formerly, a Jewish community in an Eastern European town or village, also SHTETEL [n]\n",
  "SHTETLS": "SHTETL, (Yiddish) formerly, a Jewish community in an Eastern European town or village, also SHTETEL [n]\n",
  "SHTICK": "(Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTICK, SCHTIK, SHTIK [n -S]\n",
  "SHTICKIER": "SHTICKY, like a shtick, a familiar line of chat adapted by a particular comedian [adj]\n",
  "SHTICKIEST": "SHTICKY, like a shtick, a familiar line of chat adapted by a particular comedian [adj]\n",
  "SHTICKS": "SHTICK, (Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTICK, SCHTIK, SHTIK [n]\n",
  "SHTICKY": "like a shtick, a familiar line of chat adapted by a particular comedian [adj SHTICKIER, SHTICKIEST]\n",
  "SHTIK": "(Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTICK, SCHTIK, SHTICK [n -S]\n",
  "SHTIKS": "SHTIK, (Yiddish) a familiar line of chat adapted by a particular comedian, also SCHTICK, SCHTIK, SHTICK [n]\n",
  "SHTOOK": "(Yiddish) trouble, bother, also SCHTOOK, SCHTUCK, SHTUCK [n -S]\n",
  "SHTOOKS": "SHTOOK, (Yiddish) trouble, bother, also SCHTOOK, SCHTUCK, SHTUCK [n]\n",
  "SHTOOM": "(Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTUM, SHTUMM, STUMM [adj SHTOOMER, SHTOOMEST]\n",
  "SHTOOMER": "SHTOOM, (Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTUM, SHTUMM, STUMM [adj]\n",
  "SHTOOMEST": "SHTOOM, (Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTUM, SHTUMM, STUMM [adj]\n",
  "SHTREIMEL": "(Yiddish) a round, broad-brimmed hat edged with fur worn by some Hasidic Jews [n -S]\n",
  "SHTREIMELS": "SHTREIMEL, (Yiddish) a round, broad-brimmed hat edged with fur worn by some Hasidic Jews [n]\n",
  "SHTUCK": "(Yiddish) trouble, bother, also SCHTOOK, SCHTUCK, SHTOOK [n -S]\n",
  "SHTUCKS": "SHTUCK, (Yiddish) trouble, bother, also SCHTOOK, SCHTUCK, SHTOOK [n]\n",
  "SHTUM": "(Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTOOM, SHTUMM, STUMM [adj]\n",
  "SHTUMM": "(Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTOOM, SHTUM, STUMM [adj SHTUMMER, SHTUMMEST]\n",
  "SHTUMMER": "SHTUMM, (Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTOOM, SHTUM, STUMM [adj]\n",
  "SHTUMMEST": "SHTUMM, (Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTOOM, SHTUM, STUMM [adj]\n",
  "SHTUP": "(vulgar Yiddish) to have sexual intercourse with, also SCHTUP [v SHTUPPED, SHTUPPING, SHTUPS]\n",
  "SHTUPPED": "SHTUP, (vulgar Yiddish) to have sexual intercourse with, also SCHTUP [v]\n",
  "SHTUPPING": "SHTUP, (vulgar Yiddish) to have sexual intercourse with, also SCHTUP [v]\n",
  "SHTUPS": "SHTUP, (vulgar Yiddish) to have sexual intercourse with, also SCHTUP [v]\n",
  "SHUBUNKIN": "(Japanese) a type of variegated, large-finned goldfish [n -S]\n",
  "SHUBUNKINS": "SHUBUNKIN, (Japanese) a type of variegated, large-finned goldfish [n]\n",
  "SHUCK": "to remove husks or shells [v -ED, -ING, -S]\n",
  "SHUCKED": "SHUCK, to remove husks or shells [v]\n",
  "SHUCKER": "something or someone that shucks [n -S]\n",
  "SHUCKERS": "SHUCKER, something or someone that shucks [n]\n",
  "SHUCKING": "the act of one that shucks [n -S]\n",
  "SHUCKINGS": "SHUCKING, the act of one that shucks [n]\n",
  "SHUCKS": "SHUCK, to remove husks or shells [v]\n",
  "SHUDDER": "to shiver or tremble [v -ED, -ING, -S]\n",
  "SHUDDERED": "SHUDDER, to shiver or tremble [v]\n",
  "SHUDDERIER": "SHUDDERY, shuddering [adj]\n",
  "SHUDDERIEST": "SHUDDERY, shuddering [adj]\n",
  "SHUDDERING": "trembling [adj SHUDDERINGLY] / the act of shuddering [n -S]\n",
  "SHUDDERINGLY": "SHUDDERING, trembling [adv]\n",
  "SHUDDERINGS": "SHUDDERING, the act of shuddering [n]\n",
  "SHUDDERS": "SHUDDER, to shiver or tremble [v]\n",
  "SHUDDERSOME": "causing one to shudder [adj]\n",
  "SHUDDERY": "shuddering [adj SHUDDERIER, SHUDDERIEST]\n",
  "SHUFFLE": "to walk without lifting the feet [v SHUFFLED, SHUFFLING, SHUFFLES]\n",
  "SHUFFLEBOARD": "an old game in which a coin or other disc was driven along a table by the hand, also SHOVELBOARD [n -S]\n",
  "SHUFFLEBOARDS": "SHUFFLEBOARD, an old game in which a coin or other disc was driven along a table by the hand, also SHOVELBOARD [n]\n",
  "SHUFFLED": "SHUFFLE, to walk without lifting the feet [v]\n",
  "SHUFFLER": "one who shuffles [n -S]\n",
  "SHUFFLERS": "SHUFFLER, one who shuffles [n]\n",
  "SHUFFLES": "SHUFFLE, to walk without lifting the feet [v]\n",
  "SHUFFLING": "walking without lifting the feet [adj SHUFFLINGLY] / the act of shuffling [n -S]\n",
  "SHUFFLINGLY": "SHUFFLING, walking without lifting the feet [adv]\n",
  "SHUFFLINGS": "SHUFFLING, the act of shuffling [n]\n",
  "SHUFTI": "(colloquial) a look, a dekko, also SHUFTY [n -S]\n",
  "SHUFTIES": "SHUFTY, (colloquial) a look, a dekko, also SHUFTI [n]\n",
  "SHUFTIS": "SHUFTI, (colloquial) a look, a dekko, also SHUFTY [n]\n",
  "SHUFTY": "(colloquial) a look, a dekko, also SHUFTI [n SHUFTIES]\n",
  "SHUGGIES": "SHUGGY, (dialect) a swing, as at a fairground [n]\n",
  "SHUGGY": "(dialect) a swing, as at a fairground [n SHUGGIES]\n",
  "SHUL": "(Yiddish) a synagogue, also SCHUL [n SHULS or SHULN]\n",
  "SHULE": "(dialect) to saunter, skulk, also SHOOL, SHOOLE [v SHULED, SHULING, SHULES]\n",
  "SHULED": "SHULE, (dialect) to saunter, skulk, also SHOOL, SHOOLE [v]\n",
  "SHULES": "SHULE, (dialect) to saunter, skulk, also SHOOL, SHOOLE [v]\n",
  "SHULING": "SHULE, (dialect) to saunter, skulk, also SHOOL, SHOOLE [v]\n",
  "SHULN": "SHUL, (Yiddish) a synagogue, also SCHUL [n]\n",
  "SHULS": "SHUL, (Yiddish) a synagogue, also SCHUL [n]\n",
  "SHUMAI": "(Japanese) Japanese dumplings [n]\n",
  "SHUN": "to avoid [v SHUNNED, SHUNNING, SHUNS]\n",
  "SHUNAMITISM": "rejuvenation of an old man by a young woman [n -S]\n",
  "SHUNAMITISMS": "SHUNAMITISM, rejuvenation of an old man by a young woman [n]\n",
  "SHUNLESS": "(Shakespeare) not to be shunned [adj]\n",
  "SHUNNABLE": "that can be shunned [adj]\n",
  "SHUNNED": "SHUN, to avoid [v]\n",
  "SHUNNER": "one who shuns [n -S]\n",
  "SHUNNERS": "SHUNNER, one who shuns [n]\n",
  "SHUNNING": "SHUN, to avoid [v]\n",
  "SHUNPIKE": "to travel on sideroads to avoid expressways [v SHUNPIKED, SHUNPIKING, SHUNPIKES]\n",
  "SHUNPIKED": "SHUNPIKE, to travel on sideroads to avoid expressways [v]\n",
  "SHUNPIKER": "one who avoids toll roads [n -S]\n",
  "SHUNPIKERS": "SHUNPIKER, one who avoids toll roads [n]\n",
  "SHUNPIKES": "SHUNPIKE, to travel on sideroads to avoid expressways [v]\n",
  "SHUNPIKING": "travelling on shunpikes [n -S]\n",
  "SHUNPIKINGS": "SHUNPIKING, travelling on shunpikes [n]\n",
  "SHUNS": "SHUN, to avoid [v]\n",
  "SHUNT": "to turn aside [v -ED, -ING, -S]\n",
  "SHUNTED": "SHUNT, to turn aside [v]\n",
  "SHUNTER": "an engine used for shunting [n -S]\n",
  "SHUNTERS": "SHUNTER, an engine used for shunting [n]\n",
  "SHUNTING": "the act of shunting [n -S]\n",
  "SHUNTINGS": "SHUNTING, the act of shunting [n]\n",
  "SHUNTS": "SHUNT, to turn aside [v]\n",
  "SHURA": "(Arabic) the Islamic principle of (rule by) consultation; an Islamic consultative council, also SHOORA [n -S]\n",
  "SHURAS": "SHURA, (Arabic) the Islamic principle of (rule by) consultation; an Islamic consultative council, also SHOORA [n]\n",
  "SHURIKEN": "(Japanese) a handheld throwing weapon, either long and thin or flat and star-shaped, used by ninja warriors [n -S]\n",
  "SHURIKENS": "SHURIKEN, (Japanese) a handheld throwing weapon, either long and thin or flat and star-shaped, used by ninja warriors [n]\n",
  "SHUSH": "to hush [v SHUSHED, SHUSHING, SHUSHES]\n",
  "SHUSHED": "SHUSH, to hush [v]\n",
  "SHUSHER": "one who shushes [n -S]\n",
  "SHUSHERS": "SHUSHER, one who shushes [n]\n",
  "SHUSHES": "SHUSH, to hush [v]\n",
  "SHUSHING": "SHUSH, to hush [v]\n",
  "SHUT": "to close, also SHET [v SHUT, SHUTTING, SHUTS]\n",
  "SHUTDOWN": "a temporary closing of a factory [n -S]\n",
  "SHUTDOWNS": "SHUTDOWN, a temporary closing of a factory [n]\n",
  "SHUTE": "to convey by a vertical passage, also CHUTE [v SHUTED, SHUTING, SHUTES]\n",
  "SHUTED": "SHUTE, to convey by a vertical passage, also CHUTE [v]\n",
  "SHUTES": "SHUTE, to convey by a vertical passage, also CHUTE [v]\n",
  "SHUTEYE": "(colloquial) sleep [n -S]\n",
  "SHUTEYES": "SHUTEYE, (colloquial) sleep [n]\n",
  "SHUTING": "SHUTE, to convey by a vertical passage, also CHUTE [v]\n",
  "SHUTOFF": "a device that shuts something off [n -S]\n",
  "SHUTOFFS": "SHUTOFF, a device that shuts something off [n]\n",
  "SHUTOUT": "at bridge, a bid intended to stop opponents from bidding [n -S]\n",
  "SHUTOUTS": "SHUTOUT, at bridge, a bid intended to stop opponents from bidding [n]\n",
  "SHUTS": "SHUT, to close, also SHET [v]\n",
  "SHUTTER": "to provide with window covers [v -ED, -ING, -S]\n",
  "SHUTTERBUG": "(colloquial) a photography enthusiast [n -S]\n",
  "SHUTTERBUGS": "SHUTTERBUG, (colloquial) a photography enthusiast [n]\n",
  "SHUTTERED": "SHUTTER, to provide with window covers [v]\n",
  "SHUTTERING": "temporary support for concrete work [n -S]\n",
  "SHUTTERINGS": "SHUTTERING, temporary support for concrete work [n]\n",
  "SHUTTERLESS": "without shutters [adj]\n",
  "SHUTTERS": "SHUTTER, to provide with window covers [v]\n",
  "SHUTTING": "SHUT, to close, also SHET [v]\n",
  "SHUTTLE": "to move back and forth [v SHUTTLED, SHUTTLING, SHUTTLES]\n",
  "SHUTTLECOCK": "a lightweight cone consisting of a rounded cork stuck with feathered flights to be hit to and fro with badminton rackets [n -S] / to send or toss to and fro [v -ED, -ING, -S]\n",
  "SHUTTLECOCKED": "SHUTTLECOCK, to send or toss to and fro [v]\n",
  "SHUTTLECOCKING": "SHUTTLECOCK, to send or toss to and fro [v]\n",
  "SHUTTLECOCKS": "SHUTTLECOCK, to send or toss to and fro [v]\n",
  "SHUTTLED": "SHUTTLE, to move back and forth [v]\n",
  "SHUTTLELESS": "without a shuttle [adj]\n",
  "SHUTTLER": "one who uses a shuttle [n -S]\n",
  "SHUTTLERS": "SHUTTLER, one who uses a shuttle [n]\n",
  "SHUTTLES": "SHUTTLE, to move back and forth [v]\n",
  "SHUTTLEWISE": "backwards and forwards [adv]\n",
  "SHUTTLING": "SHUTTLE, to move back and forth [v]\n",
  "SHVARTZE": "(offensive Yiddish) a black person, also SCHVARTZE, SCHWARTZE [n -S]\n",
  "SHVARTZES": "SHVARTZE, (offensive Yiddish) a black person, also SCHVARTZE, SCHWARTZE [n]\n",
  "SHVITZ": "(Yiddish) to sweat, also SCHVITZ [v -ED, -ING, -ES]\n",
  "SHVITZED": "SHVITZ, (Yiddish) to sweat, also SCHVITZ [v]\n",
  "SHVITZES": "SHVITZ, (Yiddish) to sweat, also SCHVITZ [v]\n",
  "SHVITZING": "SHVITZ, (Yiddish) to sweat, also SCHVITZ [v]\n",
  "SHWA": "(German) a vowel sound, like \"a\" in alone or \"e\" in linen, that in English often appears unstressed, also SCHWA [n -S]\n",
  "SHWANPAN": "(Chinese) a Chinese abacus, also SWANPAN [n -S]\n",
  "SHWANPANS": "SHWANPAN, (Chinese) a Chinese abacus, also SWANPAN [n]\n",
  "SHWAS": "SHWA, (German) a vowel sound, like \"a\" in alone or \"e\" in linen, that in English often appears unstressed, also SCHWA [n]\n",
  "SHWESHWE": "(South African) an African cotton print fabric [n -S]\n",
  "SHWESHWES": "SHWESHWE, (South African) an African cotton print fabric [n]\n",
  "SHY": "embarrassed, bashful [adj SHIER or SHYER, SHIEST or SHYEST, SHILY or SHYLY] / to jump aside, recoil [v SHIED, SHYING, SHIES]\n",
  "SHYER": "a horse tending to shy [n -S]\n",
  "SHYERS": "SHYER, a horse tending to shy [n]\n",
  "SHYEST": "SHY, embarrassed, bashful [adj]\n",
  "SHYING": "SHY, to jump aside, recoil [v]\n",
  "SHYISH": "somewhat shy [adj]\n",
  "SHYLOCK": "to lend money at high interest rates [v -ED, -ING, -S]\n",
  "SHYLOCKED": "SHYLOCK, to lend money at high interest rates [v]\n",
  "SHYLOCKING": "SHYLOCK, to lend money at high interest rates [v]\n",
  "SHYLOCKS": "SHYLOCK, to lend money at high interest rates [v]\n",
  "SHYLY": "SHY, embarrassed, bashful [adv]\n",
  "SHYNESS": "the state of being shy, also SHINESS [n -ES]\n",
  "SHYNESSES": "SHYNESS, the state of being shy, also SHINESS [n]\n",
  "SHYPOO": "(Australian slang) liquor of poor quality [n -S]\n",
  "SHYPOOS": "SHYPOO, (Australian slang) liquor of poor quality [n]\n",
  "SHYSTER": "an unscrupulous lawyer or politician [n -S]\n",
  "SHYSTERS": "SHYSTER, an unscrupulous lawyer or politician [n]\n",
  "SI": "an earlier form of ti, a musical note [n -S]\n",
  "SIAL": "the upper layer of the continental crust, so called because it is rich in silica and aluminum oxide [n -S]\n",
  "SIALAGOGIC": "promoting salivation, also SIALOGOGIC [adj]\n",
  "SIALAGOGUE": "anything which promotes salivation, also SIALOGOGUE [n -S]\n",
  "SIALAGOGUES": "SIALAGOGUE, anything which promotes salivation, also SIALOGOGUE [n]\n",
  "SIALIC": "of or relating to saliva [adj]\n",
  "SIALID": "an alderfly, also SIALIDAN [n -S]\n",
  "SIALIDAN": "an alderfly, also SIALID [n -S]\n",
  "SIALIDANS": "SIALIDAN, an alderfly, also SIALID [n]\n",
  "SIALIDS": "SIALID, an alderfly, also SIALIDAN [n]\n",
  "SIALOGOGIC": "promoting salivation, also SIALAGOGIC [adj]\n",
  "SIALOGOGUE": "anything that stimulates the flow of saliva, also SIALAGOGUE [n -S]\n",
  "SIALOGOGUES": "SIALOGOGUE, anything that stimulates the flow of saliva, also SIALAGOGUE [n]\n",
  "SIALOGRAM": "an X-ray of the salivary tract [n -S]\n",
  "SIALOGRAMS": "SIALOGRAM, an X-ray of the salivary tract [n]\n",
  "SIALOGRAPHIES": "SIALOGRAPHY, the process of making sialograms, X-rays of the salivary tract [n]\n",
  "SIALOGRAPHY": "the process of making sialograms, X-rays of the salivary tract [n SIALOGRAPHIES]\n",
  "SIALOID": "like saliva [adj]\n",
  "SIALOLITH": "a calculus in a salivary gland [n -S]\n",
  "SIALOLITHS": "SIALOLITH, a calculus in a salivary gland [n]\n",
  "SIALON": "a type of ceramic material [n -S]\n",
  "SIALONS": "SIALON, a type of ceramic material [n]\n",
  "SIALORRHOEA": "excessive secretion of saliva, aka ptyalism [n -S]\n",
  "SIALORRHOEAS": "SIALORRHOEA, excessive secretion of saliva, aka ptyalism [n]\n",
  "SIALS": "SIAL, the upper layer of the continental crust, so called because it is rich in silica and aluminum oxide [n]\n",
  "SIAMANG": "(Malay) a large black gibbon, native to Sumatra [n -S]\n",
  "SIAMANGS": "SIAMANG, (Malay) a large black gibbon, native to Sumatra [n]\n",
  "SIAMESE": "to join pipes in a way suggestive of Siamese twins, also SIAMEZE [v SIAMESED, SIAMESING, SIAMESES]\n",
  "SIAMESED": "SIAMESE, to join pipes in a way suggestive of Siamese twins, also SIAMEZE [v]\n",
  "SIAMESES": "SIAMESE, to join pipes in a way suggestive of Siamese twins, also SIAMEZE [v]\n",
  "SIAMESING": "SIAMESE, to join pipes in a way suggestive of Siamese twins, also SIAMEZE [v]\n",
  "SIAMEZE": "to join pipes in a way suggestive of Siamese twins, also SIAMESE [v SIAMEZED, SIAMEZING, SIAMEZES]\n",
  "SIAMEZED": "SIAMEZE, to join pipes in a way suggestive of Siamese twins, also SIAMESE [v]\n",
  "SIAMEZES": "SIAMEZE, to join pipes in a way suggestive of Siamese twins, also SIAMESE [v]\n",
  "SIAMEZING": "SIAMEZE, to join pipes in a way suggestive of Siamese twins, also SIAMESE [v]\n",
  "SIB": "a blood relation, a kinsman, also SIBB, SYBBE [n -S]\n",
  "SIBB": "one who has the same parents as another, also SIBLING, SIB [n -S]\n",
  "SIBBS": "SIBB, one who has the same parents as another, also SIBLING, SIB [n]\n",
  "SIBILANCE": "pronunciation with a hissing sound, also SIBILANCY [n -S]\n",
  "SIBILANCES": "SIBILANCE, pronunciation with a hissing sound, also SIBILANCY [n]\n",
  "SIBILANCIES": "SIBILANCY, pronunciation with a hissing sound, also SIBILANCE [n]\n",
  "SIBILANCY": "pronunciation with a hissing sound, also SIBILANCE [n SIBILANCIES]\n",
  "SIBILANT": "hissing, also SIBILOUS [adj SIBILANTLY] / a hissing sound [n -S]\n",
  "SIBILANTLY": "SIBILANT, hissing, also SIBILOUS [adv]\n",
  "SIBILANTS": "SIBILANT, a hissing sound [n]\n",
  "SIBILATE": "to pronounce (words) with, or produce, a hissing sound [v SIBILATED, SIBILATING, SIBILATES]\n",
  "SIBILATED": "SIBILATE, to pronounce (words) with, or produce, a hissing sound [v]\n",
  "SIBILATES": "SIBILATE, to pronounce (words) with, or produce, a hissing sound [v]\n",
  "SIBILATING": "SIBILATE, to pronounce (words) with, or produce, a hissing sound [v]\n",
  "SIBILATION": "utterance with a hissing sound [n -S]\n",
  "SIBILATIONS": "SIBILATION, utterance with a hissing sound [n]\n",
  "SIBILATOR": "one who sibilates, hisses [n -S]\n",
  "SIBILATORS": "SIBILATOR, one who sibilates, hisses [n]\n",
  "SIBILATORY": "hissing; sibilant [adj]\n",
  "SIBILOUS": "having a hissing sound, also SIBILANT [adj]\n",
  "SIBLING": "one who has the same parents as another, also SIB, SIBB [n -S]\n",
  "SIBLINGS": "SIBLING, one who has the same parents as another, also SIB, SIBB [n]\n",
  "SIBS": "SIB, a blood relation, a kinsman, also SIBB, SYBBE [n]\n",
  "SIBSHIP": "kinship [n -S]\n",
  "SIBSHIPS": "SIBSHIP, kinship [n]\n",
  "SIBYL": "(Greek) any of various women in classical antiquity supposed to utter the oracles and prophecies of a god, also SYBIL [n -S]\n",
  "SIBYLIC": "of or like a sibyl, also SIBYLLIC, SIBYLLINE [adj]\n",
  "SIBYLLIC": "of or like a sibyl, also SIBYLIC, SIBYLLINE [adj]\n",
  "SIBYLLINE": "of or like a sibyl, also SIBYLIC, SIBYLLIC [adj]\n",
  "SIBYLS": "SIBYL, (Greek) any of various women in classical antiquity supposed to utter the oracles and prophecies of a god, also SYBIL [n]\n",
  "SIC": "to incite a dog to attack, also SICK [v SICCED, SICCING, SICS]\n",
  "SICARIO": "(Spanish) a hired gunman or assassin esp. in Latin America [n -S]\n",
  "SICARIOS": "SICARIO, (Spanish) a hired gunman or assassin esp. in Latin America [n]\n",
  "SICCAN": "(Scots) such, what a [adj]\n",
  "SICCAR": "(Scots) sure, certain, also SICKER, SIKER, SYKER [adj]\n",
  "SICCATIVE": "a drying agent [n -S]\n",
  "SICCATIVES": "SICCATIVE, a drying agent [n]\n",
  "SICCED": "SIC, to incite a dog to attack, also SICK [v]\n",
  "SICCING": "SIC, to incite a dog to attack, also SICK [v]\n",
  "SICCITIES": "SICCITY, dryness, aridity [n]\n",
  "SICCITY": "dryness, aridity [n SICCITIES]\n",
  "SICE": "(Arabic) a stableman or groom, esp. in India, also SAICE, SYCE [n -S]\n",
  "SICES": "SICE, (Arabic) a stableman or groom, esp. in India, also SAICE, SYCE [n]\n",
  "SICH": "(archaic) such [adj]\n",
  "SICHT": "(Scots) to sight [v -ED, -ING, -S]\n",
  "SICHTED": "SICHT, (Scots) to sight [v]\n",
  "SICHTING": "SICHT, (Scots) to sight [v]\n",
  "SICHTS": "SICHT, (Scots) to sight [v]\n",
  "SICILIANA": "(Italian) a Sicilian dance, resembling the pastorale, also SICILIANO [n SICILIANE or SICILIANAS]\n",
  "SICILIANAS": "SICILIANA, (Italian) a Sicilian dance, resembling the pastorale, also SICILIANO [n]\n",
  "SICILIANE": "SICILIANA, (Italian) a Sicilian dance, resembling the pastorale, also SICILIANO [n]\n",
  "SICILIANO": "(Italian) a Sicilian dance, resembling the pastorale, also SICILIANA [n -S]\n",
  "SICILIANOS": "SICILIANO, (Italian) a Sicilian dance, resembling the pastorale, also SICILIANA [n]\n",
  "SICILIENNE": "(French) a kind of ribbed silk [n -S]\n",
  "SICILIENNES": "SICILIENNE, (French) a kind of ribbed silk [n]\n",
  "SICK": "affected with ill health [adj SICKER, SICKEST, SICKLY] / to urge to attack, also SIC [v -ED, -ING, -S]\n",
  "SICKBAY": "a ship's hospital [n -S]\n",
  "SICKBAYS": "SICKBAY, a ship's hospital [n]\n",
  "SICKBED": "a sick person's bed [n -S]\n",
  "SICKBEDS": "SICKBED, a sick person's bed [n]\n",
  "SICKED": "SICK, to urge to attack, also SIC [v]\n",
  "SICKEE": "a day off work, also SICKIE, SICKY [n -S]\n",
  "SICKEES": "SICKEE, a day off work, also SICKIE, SICKY [n]\n",
  "SICKEN": "to make sick [v -ED, -ING, -S]\n",
  "SICKENED": "SICKEN, to make sick [v]\n",
  "SICKENER": "a poisonous toadstool [n -S]\n",
  "SICKENERS": "SICKENER, a poisonous toadstool [n]\n",
  "SICKENING": "nauseating [adj SICKENINGLY] / the act of sickening [n -S]\n",
  "SICKENINGLY": "SICKENING, nauseating [adv]\n",
  "SICKENINGS": "SICKENING, the act of sickening [n]\n",
  "SICKENS": "SICKEN, to make sick [v]\n",
  "SICKER": "(Scots) sure, certain, also SICCAR, SIKER, SYKER [adj SICKERLY]\n",
  "SICKERLY": "SICKER, (Scots) sure, certain, also SICCAR, SIKER, SYKER [adv]\n",
  "SICKERNESS": "(Scots) certainty [n -ES]\n",
  "SICKERNESSES": "SICKERNESS, (Scots) certainty [n]\n",
  "SICKEST": "SICK, affected with ill health [adj]\n",
  "SICKIE": "a day off work, also SICKEE, SICKY [n -S]\n",
  "SICKIES": "SICKIE, a day off work, also SICKEE, SICKY [n]\n",
  "SICKING": "SICK, to urge to attack, also SIC [v]\n",
  "SICKISH": "somewhat sick [adj SICKISHLY]\n",
  "SICKISHLY": "SICKISH, somewhat sick [adv]\n",
  "SICKISHNESS": "the state of being sickish, somewhat sick or diseased [n -ES]\n",
  "SICKISHNESSES": "SICKISHNESS, the state of being sickish, somewhat sick or diseased [n]\n",
  "SICKLE": "to harvest with a single blade implement [v SICKLED, SICKLING, SICKLES]\n",
  "SICKLEBILL": "any one of three species of humming birds, native of Central and South America [n -S]\n",
  "SICKLEBILLS": "SICKLEBILL, any one of three species of humming birds, native of Central and South America [n]\n",
  "SICKLED": "SICKLE, to harvest with a single blade implement [v]\n",
  "SICKLEMAN": "one who uses a sickle; a reaper [n SICKLEMEN]\n",
  "SICKLEMEN": "SICKLEMAN, one who uses a sickle; a reaper [n]\n",
  "SICKLEMIA": "a severe hereditary anaemia [n -S]\n",
  "SICKLEMIAS": "SICKLEMIA, a severe hereditary anaemia [n]\n",
  "SICKLEMIC": "relating to sicklemia, a severe hereditary anaemia [adj]\n",
  "SICKLES": "SICKLE, to harvest with a single blade implement [v]\n",
  "SICKLIED": "SICKLY, to make sickly-looking [v]\n",
  "SICKLIER": "SICKLY, in poor health [adj]\n",
  "SICKLIES": "SICKLY, to make sickly-looking [v]\n",
  "SICKLIEST": "SICKLY, in poor health [adj]\n",
  "SICKLILY": "SICKLY, in poor health [adv]\n",
  "SICKLINESS": "the state of being sickly [n -ES]\n",
  "SICKLINESSES": "SICKLINESS, the state of being sickly [n]\n",
  "SICKLING": "SICKLE, to harvest with a single blade implement [v]\n",
  "SICKLY": "in poor health [adj SICKLIER, SICKLIEST, SICKLILY] / to make sickly-looking [v SICKLIED, SICKLYING, SICKLIES]\n",
  "SICKLYING": "SICKLY, to make sickly-looking [v]\n",
  "SICKNESS": "the state of being sick [n -ES]\n",
  "SICKNESSES": "SICKNESS, the state of being sick [n]\n",
  "SICKNURSE": "to act in the manner of a nurse who attends the sick [v SICKNURSED, SICKNURSING, SICKNURSES]\n",
  "SICKNURSED": "SICKNURSE, to act in the manner of a nurse who attends the sick [v]\n",
  "SICKNURSES": "SICKNURSE, to act in the manner of a nurse who attends the sick [v]\n",
  "SICKNURSING": "the nursing of the sick [n -S]\n",
  "SICKNURSINGS": "SICKNURSING, the nursing of the sick [n]\n",
  "SICKO": "an emotionally sick person [n -S]\n",
  "SICKOS": "SICKO, an emotionally sick person [n]\n",
  "SICKOUT": "an organized absence of workers claiming to be sick [n -S]\n",
  "SICKOUTS": "SICKOUT, an organized absence of workers claiming to be sick [n]\n",
  "SICKROOM": "a room occupied by a sick person [n -S]\n",
  "SICKROOMS": "SICKROOM, a room occupied by a sick person [n]\n",
  "SICKS": "SICK, to urge to attack, also SIC [v]\n",
  "SICKY": "(Australian slang) a day off work, also SICKEE, SICKIE [n SICKIES]\n",
  "SICLIKE": "(Scots) suchlike, also SUCHLIKE [adj]\n",
  "SICS": "SIC, to incite a dog to attack, also SICK [v]\n",
  "SIDA": "(Greek) any plant of the Queensland hemp genus [n -S]\n",
  "SIDALCEA": "a plant of the marrow family [n -S]\n",
  "SIDALCEAS": "SIDALCEA, a plant of the marrow family [n]\n",
  "SIDAS": "SIDA, (Greek) any plant of the Queensland hemp genus [n]\n",
  "SIDDHA": "(Sanskrit) one who has attained occult power or siddhi, also SIDHA [n -S]\n",
  "SIDDHAS": "SIDDHA, (Sanskrit) one who has attained occult power or siddhi, also SIDHA [n]\n",
  "SIDDHI": "(Sanskrit) in Buddhism, the supernatural powers that come with meditation [n -S]\n",
  "SIDDHIS": "SIDDHI, (Sanskrit) in Buddhism, the supernatural powers that come with meditation [n]\n",
  "SIDDHUISM": "(Hinglish) any contrived metaphor or simile, also SIDHUISM [n -S]\n",
  "SIDDHUISMS": "SIDDHUISM, (Hinglish) any contrived metaphor or simile, also SIDHUISM [n]\n",
  "SIDDUR": "(Hebrew) a Jewish prayer book containing prayers and other information relevant to the daily liturgy [n SIDDURIM or SIDDURS]\n",
  "SIDDURIM": "SIDDUR, (Hebrew) a Jewish prayer book containing prayers and other information relevant to the daily liturgy [n]\n",
  "SIDDURS": "SIDDUR, (Hebrew) a Jewish prayer book containing prayers and other information relevant to the daily liturgy [n]\n",
  "SIDE": "to support or agree with [v SIDED, SIDING, SIDES]\n",
  "SIDEARM": "to pitch a ball at or below shoulder level [v -ED, -ING, -S]\n",
  "SIDEARMED": "SIDEARM, to pitch a ball at or below shoulder level [v]\n",
  "SIDEARMER": "one who throws with arm roughly parallel to the ground [n -S]\n",
  "SIDEARMERS": "SIDEARMER, one who throws with arm roughly parallel to the ground [n]\n",
  "SIDEARMING": "SIDEARM, to pitch a ball at or below shoulder level [v]\n",
  "SIDEARMS": "SIDEARM, to pitch a ball at or below shoulder level [v]\n",
  "SIDEBAND": "a band of radio frequencies [n -S]\n",
  "SIDEBANDS": "SIDEBAND, a band of radio frequencies [n]\n",
  "SIDEBAR": "a short news story accompanying a major story [n -S]\n",
  "SIDEBARS": "SIDEBAR, a short news story accompanying a major story [n]\n",
  "SIDEBOARD": "a piece of dining-room furniture for holding plates etc. [n -S]\n",
  "SIDEBOARDS": "SIDEBOARD, a piece of dining-room furniture for holding plates etc. [n]\n",
  "SIDEBONE": "ossification of the lateral cartilages in a horse's foot [n -S]\n",
  "SIDEBONES": "SIDEBONE, ossification of the lateral cartilages in a horse's foot [n]\n",
  "SIDEBURN": "either of two strips of hair grown by a man down either side of the face [n -S]\n",
  "SIDEBURNED": "having sideburns [adj]\n",
  "SIDEBURNS": "SIDEBURN, either of two strips of hair grown by a man down either side of the face [n]\n",
  "SIDECAR": "a passenger car attached to a motorcycle [n -S]\n",
  "SIDECARS": "SIDECAR, a passenger car attached to a motorcycle [n]\n",
  "SIDECHAIR": "an upright wooden chair without arms [n -S]\n",
  "SIDECHAIRS": "SIDECHAIR, an upright wooden chair without arms [n]\n",
  "SIDECHECK": "part of a horse's harness [n -S]\n",
  "SIDECHECKS": "SIDECHECK, part of a horse's harness [n]\n",
  "SIDED": "SIDE, to support or agree with [v]\n",
  "SIDEDLY": "adverb used in combination [adv]\n",
  "SIDEDNESS": "the quality of having a certain number of sides [n -ES]\n",
  "SIDEDNESSES": "SIDEDNESS, the quality of having a certain number of sides [n]\n",
  "SIDEDRESS": "fertilizer placed on or in the soil near the roots of (a crop, etc.) [n -ES]\n",
  "SIDEDRESSES": "SIDEDRESS, fertilizer placed on or in the soil near the roots of (a crop, etc.) [n]\n",
  "SIDEHILL": "the side or slope of a hill [n -S]\n",
  "SIDEHILLS": "SIDEHILL, the side or slope of a hill [n]\n",
  "SIDEKICK": "a partner [n -S]\n",
  "SIDEKICKS": "SIDEKICK, a partner [n]\n",
  "SIDELESS": "without sides [adj]\n",
  "SIDELEVERS": "(Australian slang) side whiskers, sideburns [n]\n",
  "SIDELIGHT": "a coloured light on the side of a ship under way at night [n -S]\n",
  "SIDELIGHTS": "SIDELIGHT, a coloured light on the side of a ship under way at night [n]\n",
  "SIDELINE": "to remove a player from a side [v SIDELINED, SIDELINING, SIDELINES]\n",
  "SIDELINED": "SIDELINE, to remove a player from a side [v]\n",
  "SIDELINER": "one who sidelines [n -S]\n",
  "SIDELINERS": "SIDELINER, one who sidelines [n]\n",
  "SIDELINES": "SIDELINE, to remove a player from a side [v]\n",
  "SIDELING": "a slope (esp. on the side of a road) [n -S]\n",
  "SIDELINGS": "SIDELING, a slope (esp. on the side of a road) [n]\n",
  "SIDELINING": "SIDELINE, to remove a player from a side [v]\n",
  "SIDELOCK": "a lock of hair at the side of the hair [n -S]\n",
  "SIDELOCKS": "SIDELOCK, a lock of hair at the side of the hair [n]\n",
  "SIDELONG": "directed to one side [adj]\n",
  "SIDEMAN": "a member of a jazz band [n SIDEMEN]\n",
  "SIDEMEAT": "meat cut from the side of the pig [n -S]\n",
  "SIDEMEATS": "SIDEMEAT, meat cut from the side of the pig [n]\n",
  "SIDEMEN": "SIDEMAN, a member of a jazz band [n]\n",
  "SIDENOTE": "a comment written in the margin [n -S]\n",
  "SIDENOTES": "SIDENOTE, a comment written in the margin [n]\n",
  "SIDEPATH": "a byway or sidewalk [n -S]\n",
  "SIDEPATHS": "SIDEPATH, a byway or sidewalk [n]\n",
  "SIDEPIECE": "the jamb, or cheek, of an opening in a wall, as of door or window [n -S]\n",
  "SIDEPIECES": "SIDEPIECE, the jamb, or cheek, of an opening in a wall, as of door or window [n]\n",
  "SIDER": "a native or inhabitant of a specified district [n -S]\n",
  "SIDERAL": "sent from the stars, said esp. of a malign influence [adj]\n",
  "SIDERATE": "to blast or strike [v SIDERATED, SIDERATING, SIDERATES]\n",
  "SIDERATED": "SIDERATE, to blast or strike [v]\n",
  "SIDERATES": "SIDERATE, to blast or strike [v]\n",
  "SIDERATING": "SIDERATE, to blast or strike [v]\n",
  "SIDERATION": "the use of green manure [n -S]\n",
  "SIDERATIONS": "SIDERATION, the use of green manure [n]\n",
  "SIDEREAL": "relating to the stars [adj SIDEREALLY]\n",
  "SIDEREALLY": "SIDEREAL, relating to the stars [adv]\n",
  "SIDERITE": "a carbonate of iron, aka chalybite [n -S]\n",
  "SIDERITES": "SIDERITE, a carbonate of iron, aka chalybite [n]\n",
  "SIDERITIC": "relating to siderite, carbonate of iron [adj]\n",
  "SIDEROAD": "a byroad [n -S]\n",
  "SIDEROADS": "SIDEROAD, a byroad [n]\n",
  "SIDEROLITE": "a meteorite made up partly of stone, partly of iron [n -S]\n",
  "SIDEROLITES": "SIDEROLITE, a meteorite made up partly of stone, partly of iron [n]\n",
  "SIDEROPENIA": "deficiency of iron [n -S]\n",
  "SIDEROPENIAS": "SIDEROPENIA, deficiency of iron [n]\n",
  "SIDEROPHILE": "an element with an affinity for iron, whose geochemical distribution is influenced by this property [n -S]\n",
  "SIDEROPHILES": "SIDEROPHILE, an element with an affinity for iron, whose geochemical distribution is influenced by this property [n]\n",
  "SIDEROPHILIC": "of or like a siderophile, an element with an affinity for iron [adj]\n",
  "SIDEROPHILIN": "any of a group of blood glycoproteins that transport iron, aka transferrin [n -S]\n",
  "SIDEROPHILINS": "SIDEROPHILIN, any of a group of blood glycoproteins that transport iron, aka transferrin [n]\n",
  "SIDEROSES": "SIDEROSIS, a sort of pneumonia occurring in iron workers, produced by the inhalation of particles of iron [n]\n",
  "SIDEROSIS": "a sort of pneumonia occurring in iron workers, produced by the inhalation of particles of iron [n SIDEROSES]\n",
  "SIDEROSTAT": "a mirror, or telescope with a mirror, for reflecting the rays of a star in a constant direction [n -S]\n",
  "SIDEROSTATIC": "of or like a siderostat, a mirror, or telescope with a mirror, for reflecting the rays of a star in a constant direction [adj]\n",
  "SIDEROSTATS": "SIDEROSTAT, a mirror, or telescope with a mirror, for reflecting the rays of a star in a constant direction [n]\n",
  "SIDEROTIC": "relating to siderosis, a sort of pneumonia occurring in iron workers [adj]\n",
  "SIDERS": "SIDER, a native or inhabitant of a specified district [n]\n",
  "SIDES": "SIDE, to support or agree with [v]\n",
  "SIDESADDLE": "a saddle for women in which the rider sits with both legs on one side of the horse [n -S]\n",
  "SIDESADDLES": "SIDESADDLE, a saddle for women in which the rider sits with both legs on one side of the horse [n]\n",
  "SIDESHOOT": "a shoot growing off the side of a main stem [n -S]\n",
  "SIDESHOOTS": "SIDESHOOT, a shoot growing off the side of a main stem [n]\n",
  "SIDESHOW": "a small show offered in addition to the main show [n -S]\n",
  "SIDESHOWS": "SIDESHOW, a small show offered in addition to the main show [n]\n",
  "SIDESLIP": "to slip to one side [v SIDESLIPPED, SIDESLIPPING, SIDESLIPS]\n",
  "SIDESLIPPED": "SIDESLIP, to slip to one side [v]\n",
  "SIDESLIPPING": "SIDESLIP, to slip to one side [v]\n",
  "SIDESLIPS": "SIDESLIP, to slip to one side [v]\n",
  "SIDESMAN": "a deputy churchwarden [n SIDESMEN]\n",
  "SIDESMEN": "SIDESMAN, a deputy churchwarden [n]\n",
  "SIDESPIN": "a type of spin imparted to a ball [n -S]\n",
  "SIDESPINS": "SIDESPIN, a type of spin imparted to a ball [n]\n",
  "SIDESPLIT": "a split-level house having floors raised half a level on one side thus having an upper and lower basement and an upper and lower main floor [n -S]\n",
  "SIDESPLITS": "SIDESPLIT, a split-level house having floors raised half a level on one side thus having an upper and lower basement and an upper and lower main floor [n]\n",
  "SIDESPLITTING": "extremely funny [adj SIDESPLITTINGLY]\n",
  "SIDESPLITTINGLY": "SIDESPLITTING, extremely funny [adv]\n",
  "SIDESTEP": "to step to one side [v SIDESTEPPED, SIDESTEPPING, SIDESTEPS]\n",
  "SIDESTEPPED": "SIDESTEP, to step to one side [v]\n",
  "SIDESTEPPER": "one who sidesteps [n -S]\n",
  "SIDESTEPPERS": "SIDESTEPPER, one who sidesteps [n]\n",
  "SIDESTEPPING": "the act of avoiding an issue [n -S]\n",
  "SIDESTEPPINGS": "SIDESTEPPING, the act of avoiding an issue [n]\n",
  "SIDESTEPS": "SIDESTEP, to step to one side [v]\n",
  "SIDESTREAM": "relating to or being tobacco smoke that is emitted from the lighted end of a cigarette or cigar [adj]\n",
  "SIDESTROKE": "a swimming stroke which is executed on the side and in which the arms are swept in separate strokes towards the feet and downward and the legs do a scissors kick [n -S]\n",
  "SIDESTROKES": "SIDESTROKE, a swimming stroke which is executed on the side and in which the arms are swept in separate strokes towards the feet and downward and the legs do a scissors kick [n]\n",
  "SIDESWIPE": "a blow dealt from the side [n -S] / to deal a blow from the side [v SIDESWIPED, SIDESWIPING, SIDESWIPES]\n",
  "SIDESWIPED": "SIDESWIPE, to deal a blow from the side [v]\n",
  "SIDESWIPER": "one who sideswipes [n -S]\n",
  "SIDESWIPERS": "SIDESWIPER, one who sideswipes [n]\n",
  "SIDESWIPES": "SIDESWIPE, to deal a blow from the side [v]\n",
  "SIDESWIPING": "SIDESWIPE, to deal a blow from the side [v]\n",
  "SIDETABLE": "a small table at the side of a room [n -S]\n",
  "SIDETABLES": "SIDETABLE, a small table at the side of a room [n]\n",
  "SIDETRACK": "a railway siding [n -S] / to divert or turn aside [v -ED, -ING, -S]\n",
  "SIDETRACKED": "SIDETRACK, to divert or turn aside [v]\n",
  "SIDETRACKING": "SIDETRACK, to divert or turn aside [v]\n",
  "SIDETRACKS": "SIDETRACK, to divert or turn aside [v]\n",
  "SIDEWALK": "the pavement [n -S]\n",
  "SIDEWALKS": "SIDEWALK, the pavement [n]\n",
  "SIDEWALL": "the side portion of a tyre between tread and tyre rim [n -S]\n",
  "SIDEWALLS": "SIDEWALL, the side portion of a tyre between tread and tyre rim [n]\n",
  "SIDEWARD": "in a sideways direction, also SIDEWARDS [adv]\n",
  "SIDEWARDS": "in a sideways direction, also SIDEWARD [adv]\n",
  "SIDEWAY": "from the side, also SIDEWAYS, SIDEWISE [adj]\n",
  "SIDEWAYS": "towards or from one side, also SIDEWISE [adv]\n",
  "SIDEWHEEL": "one of the paddle wheels of a sidewheeler [n -S]\n",
  "SIDEWHEELER": "a vessel, esp. a river boat, propelled by two large paddle wheels, one on each side [n -S]\n",
  "SIDEWHEELERS": "SIDEWHEELER, a vessel, esp. a river boat, propelled by two large paddle wheels, one on each side [n]\n",
  "SIDEWHEELS": "SIDEWHEEL, one of the paddle wheels of a sidewheeler [n]\n",
  "SIDEWINDER": "a rattlesnake [n -S]\n",
  "SIDEWINDERS": "SIDEWINDER, a rattlesnake [n]\n",
  "SIDEWISE": "toward or on one side, also SIDEWAY, SIDEWAYS [adj]\n",
  "SIDH": "(Irish) one of the fairy people [n SIDHE]\n",
  "SIDHA": "(Sanskrit) one who has attained occult powers or siddhi, also SIDDHA [n -S]\n",
  "SIDHAS": "SIDHA, (Sanskrit) one who has attained occult powers or siddhi, also SIDDHA [n]\n",
  "SIDHE": "SIDH, (Irish) one of the fairy people [n]\n",
  "SIDHUISM": "(Hinglish) any contrived metaphor or simile, also SIDDHUISM [n -S]\n",
  "SIDHUISMS": "SIDHUISM, (Hinglish) any contrived metaphor or simile, also SIDDHUISM [n]\n",
  "SIDING": "a short railway track for shunting [n -S]\n",
  "SIDINGS": "SIDING, a short railway track for shunting [n]\n",
  "SIDLE": "to move sideways [v SIDLED, SIDLING, SIDLES]\n",
  "SIDLED": "SIDLE, to move sideways [v]\n",
  "SIDLER": "one who sidles [n -S]\n",
  "SIDLERS": "SIDLER, one who sidles [n]\n",
  "SIDLES": "SIDLE, to move sideways [v]\n",
  "SIDLING": "SIDLE, to move sideways [v]\n",
  "SIDLINGLY": "SIDLING, SIDLE, to move sideways [adv]\n",
  "SIECLE": "(French) a century, period or era [n -S]\n",
  "SIECLES": "SIECLE, (French) a century, period or era [n]\n",
  "SIEGE": "the act or process of surrounding a town or fortress [n -S] / to subject to a siege [v SIEGED, SIEGING, SIEGES]\n",
  "SIEGECRAFT": "the military art of conducting a siege [n -S]\n",
  "SIEGECRAFTS": "SIEGECRAFT, the military art of conducting a siege [n]\n",
  "SIEGED": "SIEGE, to subject to a siege [v]\n",
  "SIEGER": "one who besieges, also BESIEGER [n -S]\n",
  "SIEGERS": "SIEGER, one who besieges, also BESIEGER [n]\n",
  "SIEGES": "SIEGE, to subject to a siege [v]\n",
  "SIEGEWORKS": "a besieger's engineering works [n]\n",
  "SIEGING": "SIEGE, to subject to a siege [v]\n",
  "SIELD": "(Spenser) provided with a ceiling [adj]\n",
  "SIEMENS": "a unit of electrical conductance equivalent to one ampere per volt [n -ES]\n",
  "SIEMENSES": "SIEMENS, a unit of electrical conductance equivalent to one ampere per volt [n]\n",
  "SIEN": "(Shakespeare) a scion, also CION, SEYEN, SIENT, SYEN [n -S]\n",
  "SIENITE": "a coarse-grained igneous rock, allied to granite, also SYENITE [n -S]\n",
  "SIENITES": "SIENITE, a coarse-grained igneous rock, allied to granite, also SYENITE [n]\n",
  "SIENNA": "(Italian) a fine pigment made from ferruginous ochreous earth, browny-yellow when raw, reddish-brown when burnt [n -S]\n",
  "SIENNAS": "SIENNA, (Italian) a fine pigment made from ferruginous ochreous earth, browny-yellow when raw, reddish-brown when burnt [n]\n",
  "SIENS": "SIEN, (Shakespeare) a scion, also CION, SEYEN, SIENT, SYEN [n]\n",
  "SIENT": "(archaic) a scion, also CION, SEYEN, SIEN, SYEN [n -S]\n",
  "SIENTS": "SIENT, (archaic) a scion, also CION, SEYEN, SIEN, SYEN [n]\n",
  "SIEROZEM": "(Russian) a type of soil, grayish at the top and brownish below, based on a carbonate or hardpan layer [n -S]\n",
  "SIEROZEMS": "SIEROZEM, (Russian) a type of soil, grayish at the top and brownish below, based on a carbonate or hardpan layer [n]\n",
  "SIERRA": "(Spanish) a ridge of mountain and craggy rocks, with a serrated or irregular outline [n -S]\n",
  "SIERRAN": "relating to a mountain range [adj]\n",
  "SIERRAS": "SIERRA, (Spanish) a ridge of mountain and craggy rocks, with a serrated or irregular outline [n]\n",
  "SIES": "(South African) an expression of disgust [interj]\n",
  "SIESTA": "(Spanish) a midday or afternoon nap [n -S]\n",
  "SIESTAS": "SIESTA, (Spanish) a midday or afternoon nap [n]\n",
  "SIETH": "(Shakespeare) a scythe, also SITHE [n -S]\n",
  "SIETHS": "SIETH, (Shakespeare) a scythe, also SITHE [n]\n",
  "SIEUR": "(French) an old French title of respect for a man [n -S]\n",
  "SIEURS": "SIEUR, (French) an old French title of respect for a man [n]\n",
  "SIEVE": "to pass through a strainer [v SIEVED, SIEVING, SIEVES]\n",
  "SIEVED": "SIEVE, to pass through a strainer [v]\n",
  "SIEVELIKE": "like a sieve [adj]\n",
  "SIEVERT": "(Swedish) the SI unit of radiation dose [n -S]\n",
  "SIEVERTS": "SIEVERT, (Swedish) the SI unit of radiation dose [n]\n",
  "SIEVES": "SIEVE, to pass through a strainer [v]\n",
  "SIEVING": "SIEVE, to pass through a strainer [v]\n",
  "SIF": "(South African) disgusting (syphilitic) [adj]\n",
  "SIFAKA": "(Malagasy) a kind of lemur, long-tailed and black and white, native to Madagascar [n -S]\n",
  "SIFAKAS": "SIFAKA, (Malagasy) a kind of lemur, long-tailed and black and white, native to Madagascar [n]\n",
  "SIFFLE": "to whistle, hiss [v SIFFLED, SIFFLING, SIFFLES]\n",
  "SIFFLED": "SIFFLE, to whistle, hiss [v]\n",
  "SIFFLES": "SIFFLE, to whistle, hiss [v]\n",
  "SIFFLEUR": "(French) a (male) professional whistler [n -S]\n",
  "SIFFLEURS": "SIFFLEUR, (French) a (male) professional whistler [n]\n",
  "SIFFLEUSE": "(French) a (female) professional whistler [n -S]\n",
  "SIFFLEUSES": "SIFFLEUSE, (French) a (female) professional whistler [n]\n",
  "SIFFLING": "SIFFLE, to whistle, hiss [v]\n",
  "SIFREI": "SEFER, (Hebrew) any book of Hebrew religious literature [n]\n",
  "SIFT": "to pass through a strainer, also SIEVE [v -ED, -ING, -S]\n",
  "SIFTED": "SIFT, to pass through a strainer, also SIEVE [v]\n",
  "SIFTER": "one who, or that which, sifts [n -S]\n",
  "SIFTERS": "SIFTER, one who, or that which, sifts [n]\n",
  "SIFTING": "sieving [adj SIFTINGLY] / the act of sifting [n -S]\n",
  "SIFTINGLY": "SIFTING, sieving [adv]\n",
  "SIFTINGS": "SIFTING, the act of sifting [n]\n",
  "SIFTS": "SIFT, to pass through a strainer, also SIEVE [v]\n",
  "SIG": "a short personalized message at the end of an email, a signature [n -S]\n",
  "SIGANID": "any of a family of fishes [n -S]\n",
  "SIGANIDS": "SIGANID, any of a family of fishes [n]\n",
  "SIGH": "to emit a deep, audible breath [v -ED, -ING, -S]\n",
  "SIGHED": "SIGH, to emit a deep, audible breath [v]\n",
  "SIGHER": "one who sighs [n -S]\n",
  "SIGHERS": "SIGHER, one who sighs [n]\n",
  "SIGHFUL": "full of sighs [adj]\n",
  "SIGHING": "making a sound like a sigh [n -S]\n",
  "SIGHINGLY": "SIGHING [adv]\n",
  "SIGHINGS": "SIGHING, making a sound like a sigh [n]\n",
  "SIGHLESS": "uttering no sighs [adj]\n",
  "SIGHLIKE": "resembling a sigh [adj]\n",
  "SIGHS": "SIGH, to emit a deep, audible breath [v]\n",
  "SIGHT": "to observe or notice [v -ED, -ING, -S]\n",
  "SIGHTABLE": "that can be sighted, e.g. of a gun [adj]\n",
  "SIGHTED": "SIGHT, to observe or notice [v]\n",
  "SIGHTER": "(Scots) an inspector [n -S]\n",
  "SIGHTERS": "SIGHTER, (Scots) an inspector [n]\n",
  "SIGHTING": "an observation [n -S]\n",
  "SIGHTINGS": "SIGHTING, an observation [n]\n",
  "SIGHTLESS": "blind [adj SIGHTLESSLY]\n",
  "SIGHTLESSLY": "SIGHTLESS, blind [adv]\n",
  "SIGHTLESSNESS": "the state of being sightless [n -ES]\n",
  "SIGHTLESSNESSES": "SIGHTLESSNESS, the state of being sightless [n]\n",
  "SIGHTLIER": "SIGHTLY, pleasing to look at [adj]\n",
  "SIGHTLIEST": "SIGHTLY, pleasing to look at [adj]\n",
  "SIGHTLINE": "a line of sight [n -S]\n",
  "SIGHTLINES": "SIGHTLINE, a line of sight [n]\n",
  "SIGHTLINESS": "the state of being sightly [n -ES]\n",
  "SIGHTLINESSES": "SIGHTLINESS, the state of being sightly [n]\n",
  "SIGHTLY": "pleasing to look at [adj SIGHTLIER, SIGHTLIEST]\n",
  "SIGHTS": "SIGHT, to observe or notice [v]\n",
  "SIGHTSAW": "SIGHTSEE, to view places of interest [v]\n",
  "SIGHTSCREEN": "a screen used in cricket to counter dazzle [n -S]\n",
  "SIGHTSCREENS": "SIGHTSCREEN, a screen used in cricket to counter dazzle [n]\n",
  "SIGHTSEE": "to view places of interest [v SIGHTSAW, SIGHTSEEN, SIGHTSEEING, SIGHTSEES]\n",
  "SIGHTSEEING": "viewing tourist attractions [n -S]\n",
  "SIGHTSEEINGS": "SIGHTSEEING, viewing tourist attractions [n]\n",
  "SIGHTSEEN": "SIGHTSEE, to view places of interest [v]\n",
  "SIGHTSEER": "one who sightsees [n -S]\n",
  "SIGHTSEERS": "SIGHTSEER, one who sightsees [n]\n",
  "SIGHTSEES": "SIGHTSEE, to view places of interest [v]\n",
  "SIGHTSMAN": "one who reads or performs music readily at first sight [n SIGHTSMEN]\n",
  "SIGHTSMEN": "SIGHTSMAN, one who reads or performs music readily at first sight [n]\n",
  "SIGHTWORTHIER": "SIGHTWORTHY, worth looking at [adj]\n",
  "SIGHTWORTHIEST": "SIGHTWORTHY, worth looking at [adj]\n",
  "SIGHTWORTHY": "worth looking at [adj SIGHTWORTHIER, SIGHTWORTHIEST]\n",
  "SIGIL": "(Latin) an official seal [n -S]\n",
  "SIGILLARIAN": "a seal, a signet [n -S]\n",
  "SIGILLARIANS": "SIGILLARIAN, a seal, a signet [n]\n",
  "SIGILLARID": "one of an extinct family of cryptogamous trees, including the genus Sigillaria and its allies [n -S]\n",
  "SIGILLARIDS": "SIGILLARID, one of an extinct family of cryptogamous trees, including the genus Sigillaria and its allies [n]\n",
  "SIGILLARY": "of or pertaining to a seal [adj]\n",
  "SIGILLATE": "sealed; with seallike impressions [adj]\n",
  "SIGILLATION": "marking with a seal [n -S]\n",
  "SIGILLATIONS": "SIGILLATION, marking with a seal [n]\n",
  "SIGILS": "SIGIL, (Latin) an official seal [n]\n",
  "SIGISBEI": "SIGISBEO, (Italian) a professed gallant of a married woman, also CICISBEO [n]\n",
  "SIGISBEO": "(Italian) a professed gallant of a married woman, also CICISBEO [n SIGISBEI]\n",
  "SIGLA": "(Latin) a list of symbols used in a book [n -S]\n",
  "SIGLAS": "SIGLA, (Latin) a list of symbols used in a book [n]\n",
  "SIGLOI": "SIGLOS, (Greek) an ancient Persian coin [n]\n",
  "SIGLOS": "(Greek) an ancient Persian coin [n SIGLOI]\n",
  "SIGLUM": "a symbol used in a book [n SIGLA]\n",
  "SIGMA": "(Greek) the Greek letter S [n -S]\n",
  "SIGMAS": "SIGMA, (Greek) the Greek letter S [n]\n",
  "SIGMATE": "S-shaped, also SIGMATED, SIGMOID, SIGMOIDAL [adj] / to add a sign to [v SIGMATED, SIGMATING, SIGMATES]\n",
  "SIGMATED": "SIGMATE, to add a sign to [v]\n",
  "SIGMATES": "SIGMATE, to add a sign to [v]\n",
  "SIGMATIC": "characterized by a sign [adj]\n",
  "SIGMATING": "SIGMATE, to add a sign to [v]\n",
  "SIGMATION": "the addition of a sigma at the end of a syllable [n -S]\n",
  "SIGMATIONS": "SIGMATION, the addition of a sigma at the end of a syllable [n]\n",
  "SIGMATISM": "repetition of the sigma sound [n -S]\n",
  "SIGMATISMS": "SIGMATISM, repetition of the sigma sound [n]\n",
  "SIGMATRON": "a machine generating high-potential X-rays [n -S]\n",
  "SIGMATRONS": "SIGMATRON, a machine generating high-potential X-rays [n]\n",
  "SIGMOID": "S-shaped, also SIGMATE, SIGMATED, SIGMOIDAL [adj] / an S-shaped curve in a bodily part [n -S]\n",
  "SIGMOIDAL": "S-shaped, also SIGMATE, SIGMATED, SIGMOID [adj SIGMOIDALLY]\n",
  "SIGMOIDALLY": "SIGMOIDAL, S-shaped, also SIGMATE, SIGMATED, SIGMOID [adv]\n",
  "SIGMOIDECTOMIES": "SIGMOIDECTOMY, removal of the sigmoid colon [n]\n",
  "SIGMOIDECTOMY": "removal of the sigmoid colon [n SIGMOIDECTOMIES]\n",
  "SIGMOIDOSCOPE": "an instrument for examining the interior of the rectum and sigmoid colon [n -S]\n",
  "SIGMOIDOSCOPES": "SIGMOIDOSCOPE, an instrument for examining the interior of the rectum and sigmoid colon [n]\n",
  "SIGMOIDOSCOPIC": "pertaining to a sigmoidoscope, an instrument for examining the interior of the rectum and sigmoid colon [adj]\n",
  "SIGMOIDOSCOPIES": "SIGMOIDOSCOPY, examination of the interior of the rectum and sigmoid colon [n]\n",
  "SIGMOIDOSCOPY": "examination of the interior of the rectum and sigmoid colon [n SIGMOIDOSCOPIES]\n",
  "SIGMOIDS": "SIGMOID, an S-shaped curve in a bodily part [n]\n",
  "SIGN": "to write one's name [v -ED, -ING, -S]\n",
  "SIGNA": "a verbal instruction: write on the label [v]\n",
  "SIGNABLE": "able to be signed [adj]\n",
  "SIGNAGE": "a system of signs in a community [n -S]\n",
  "SIGNAGES": "SIGNAGE, a system of signs in a community [n]\n",
  "SIGNAL": "notable [adj SIGNALLY] / to make a sign [v SIGNALED or SIGNALLED, SIGNALING or SIGNALLING, SIGNALS]\n",
  "SIGNALED": "SIGNAL, to make a sign [v]\n",
  "SIGNALER": "(US) one who signals, also SIGNALLER [n -S]\n",
  "SIGNALERS": "SIGNALER, (US) one who signals, also SIGNALLER [n]\n",
  "SIGNALING": "the act of sending a signal [n -S]\n",
  "SIGNALINGS": "SIGNALING, the act of sending a signal [n]\n",
  "SIGNALISATION": "the process of signalising [n -S]\n",
  "SIGNALISATIONS": "SIGNALISATION, the process of signalising [n]\n",
  "SIGNALISE": "to make signal or eminent; to distinguish, also SIGNALIZE [v SIGNALISED, SIGNALISING, SIGNALISES]\n",
  "SIGNALISED": "SIGNALISE, to make signal or eminent; to distinguish, also SIGNALIZE [v]\n",
  "SIGNALISES": "SIGNALISE, to make signal or eminent; to distinguish, also SIGNALIZE [v]\n",
  "SIGNALISING": "SIGNALISE, to make signal or eminent; to distinguish, also SIGNALIZE [v]\n",
  "SIGNALIZATION": "the act of signalizing [n -S]\n",
  "SIGNALIZATIONS": "SIGNALIZATION, the act of signalizing [n]\n",
  "SIGNALIZE": "to make signal or eminent; to distinguish, also SIGNALISE [v SIGNALIZED, SIGNALIZING, SIGNALIZES]\n",
  "SIGNALIZED": "SIGNALIZE, to make signal or eminent; to distinguish, also SIGNALISE [v]\n",
  "SIGNALIZES": "SIGNALIZE, to make signal or eminent; to distinguish, also SIGNALISE [v]\n",
  "SIGNALIZING": "SIGNALIZE, to make signal or eminent; to distinguish, also SIGNALISE [v]\n",
  "SIGNALLED": "SIGNAL, to make a sign [v]\n",
  "SIGNALLER": "one who signals, also SIGNALER [n -S]\n",
  "SIGNALLERS": "SIGNALLER, one who signals, also SIGNALER [n]\n",
  "SIGNALLING": "the act of signalling [n -S]\n",
  "SIGNALLINGS": "SIGNALLING, the act of signalling [n]\n",
  "SIGNALLY": "SIGNAL, notable [adv]\n",
  "SIGNALMAN": "a person who operates railway signals [n SIGNALMEN]\n",
  "SIGNALMEN": "SIGNALMAN, a person who operates railway signals [n]\n",
  "SIGNALMENT": "the act of signaling [n -S]\n",
  "SIGNALMENTS": "SIGNALMENT, the act of signaling [n]\n",
  "SIGNALS": "SIGNAL, to make a sign [v]\n",
  "SIGNARIES": "SIGNARY, a system of signals [n]\n",
  "SIGNARY": "a system of signals [n SIGNARIES]\n",
  "SIGNATORIES": "SIGNATORY, a person who has signed a treaty etc. [n]\n",
  "SIGNATORY": "having signed a treaty, etc. [adj] / a person who has signed a treaty etc. [n SIGNATORIES]\n",
  "SIGNATURE": "a signing, a signed name [n -S]\n",
  "SIGNATURES": "SIGNATURE, a signing, a signed name [n]\n",
  "SIGNBOARD": "a board bearing a notice or serving as a shop or inn sign [n -S]\n",
  "SIGNBOARDS": "SIGNBOARD, a board bearing a notice or serving as a shop or inn sign [n]\n",
  "SIGNED": "SIGN, to write one's name [v]\n",
  "SIGNEE": "a signer of a document [n -S]\n",
  "SIGNEES": "SIGNEE, a signer of a document [n]\n",
  "SIGNER": "one that signs [n -S]\n",
  "SIGNERS": "SIGNER, one that signs [n]\n",
  "SIGNET": "to mark with an official seal [v -ED, -ING, -S]\n",
  "SIGNETED": "SIGNET, to mark with an official seal [v]\n",
  "SIGNETING": "SIGNET, to mark with an official seal [v]\n",
  "SIGNETS": "SIGNET, to mark with an official seal [v]\n",
  "SIGNEUR": "(Shakespeare) senior [adj]\n",
  "SIGNEURIE": "(Shakespeare) seniority, also SENIORITY [n -S]\n",
  "SIGNEURIES": "SIGNEURIE, (Shakespeare) seniority, also SENIORITY [n]\n",
  "SIGNIEUR": "(Shakespeare) a lord, esp. of manor, also SEIGNEUR, SEIGNIOR [n -S]\n",
  "SIGNIEURS": "SIGNIEUR, (Shakespeare) a lord, esp. of manor, also SEIGNEUR, SEIGNIOR [n]\n",
  "SIGNIFIABLE": "capable of being signified [adj]\n",
  "SIGNIFICANCE": "something that is conveyed as a meaning often obscurely or indirectly [n -S]\n",
  "SIGNIFICANCES": "SIGNIFICANCE, something that is conveyed as a meaning often obscurely or indirectly [n]\n",
  "SIGNIFICANCIES": "SIGNIFICANCY, significance [n]\n",
  "SIGNIFICANCY": "significance [n SIGNIFICANCIES]\n",
  "SIGNIFICANT": "having meaning [adj SIGNIFICANTLY] / something having meaning [n -S]\n",
  "SIGNIFICANTLY": "SIGNIFICANT, having meaning [adv]\n",
  "SIGNIFICANTS": "SIGNIFICANT, something having meaning [n]\n",
  "SIGNIFICATE": "a thing signified [n -S]\n",
  "SIGNIFICATES": "SIGNIFICATE, a thing signified [n]\n",
  "SIGNIFICATION": "the act of signifying [n -S]\n",
  "SIGNIFICATIONS": "SIGNIFICATION, the act of signifying [n]\n",
  "SIGNIFICATIVE": "significant, suggestive [adj SIGNIFICATIVELY]\n",
  "SIGNIFICATIVELY": "SIGNIFICATIVE, significant, suggestive [adv]\n",
  "SIGNIFICATOR": "in astrology, a planet ruling a house [n -S]\n",
  "SIGNIFICATORS": "SIGNIFICATOR, in astrology, a planet ruling a house [n]\n",
  "SIGNIFICATORY": "of or relating to a significator, in astrology, a planet ruling a house [adj]\n",
  "SIGNIFICS": "the science of meaning [n]\n",
  "SIGNIFIED": "that which is meant [n -S]\n",
  "SIGNIFIEDS": "SIGNIFIED, that which is meant [n]\n",
  "SIGNIFIER": "something that signifies [n -S]\n",
  "SIGNIFIERS": "SIGNIFIER, something that signifies [n]\n",
  "SIGNIFIES": "SIGNIFY, to make known [v]\n",
  "SIGNIFY": "to make known [v SIGNIFIED, SIGNIFYING, SIGNIFIES]\n",
  "SIGNIFYING": "the act of signifying [n -S]\n",
  "SIGNIFYINGS": "SIGNIFYING, the act of signifying [n]\n",
  "SIGNING": "the use of sign language [n -S]\n",
  "SIGNINGS": "SIGNING, the use of sign language [n]\n",
  "SIGNIOR": "(Italian) an Italian title of courtesy for a man, also SIGNOR, SIGNORE [n -S]\n",
  "SIGNIORI": "SIGNOR, (Italian) an Italian title of courtesy for a man, also SIGNIOR, SIGNORE [n]\n",
  "SIGNIORIES": "SIGNIORY, the power of a seignior, also SEIGNORY, SIGNORIA, SIGNORY [n]\n",
  "SIGNIORS": "SIGNIOR, (Italian) an Italian title of courtesy for a man, also SIGNOR, SIGNORE [n]\n",
  "SIGNIORY": "the power of a seignior, also SEIGNORY, SIGNORIA, SIGNORY [n SIGNIORIES]\n",
  "SIGNLESS": "without signs [adj]\n",
  "SIGNOR": "(Italian) an Italian title of courtesy for a man, also SIGNIOR, SIGNORE [n SIGNORS or SIGNIORI or SIGNIORS]\n",
  "SIGNORA": "(Italian) an Italian title of courtesy for a married woman [n -S]\n",
  "SIGNORAS": "SIGNORA, (Italian) an Italian title of courtesy for a married woman [n]\n",
  "SIGNORE": "(Italian) an Italian title of courtesy for a man, also SIGNOR, SIGNIOR [n SIGNORES or SIGNORI]\n",
  "SIGNORES": "SIGNORE, (Italian) an Italian title of courtesy for a man, also SIGNOR, SIGNIOR [n]\n",
  "SIGNORI": "SIGNORE, (Italian) an Italian title of courtesy for a man, also SIGNOR, SIGNIOR [n]\n",
  "SIGNORIA": "(Italian) the governing body of any of various medieval Italian republics, esp. Venice [n -S]\n",
  "SIGNORIAL": "relating to a signoria, the governing body of any of various medieval Italian republics, esp. Venice [adj]\n",
  "SIGNORIAS": "SIGNORIA, (Italian) the governing body of any of various medieval Italian republics, esp. Venice [n]\n",
  "SIGNORIES": "SIGNORY, feudal lordship, also SEIGNIORALTY, SEIGNIORY, SEIGNORY, SIGNIORY [n]\n",
  "SIGNORINA": "(Italian) miss; a title of address among the Italians [n SIGNORINAS or SIGNORINE]\n",
  "SIGNORINAS": "SIGNORINA, (Italian) miss; a title of address among the Italians [n]\n",
  "SIGNORINE": "SIGNORINA, (Italian) miss; a title of address among the Italians [n]\n",
  "SIGNORINI": "SIGNORINO, (Italian) a young man, young gentleman [n]\n",
  "SIGNORINO": "(Italian) a young man, young gentleman [n SIGNORINI]\n",
  "SIGNORS": "SIGNOR, (Italian) an Italian title of courtesy for a man, also SIGNIOR, SIGNORE [n]\n",
  "SIGNORY": "feudal lordship, also SEIGNIORALTY, SEIGNIORY, SEIGNORY, SIGNIORY [n SIGNORIES]\n",
  "SIGNPOST": "to provide with posts bearing signs [v -ED, -ING, -S]\n",
  "SIGNPOSTED": "SIGNPOST, to provide with posts bearing signs [v]\n",
  "SIGNPOSTING": "the act of pointing out a direction [n -S]\n",
  "SIGNPOSTINGS": "SIGNPOSTING, the act of pointing out a direction [n]\n",
  "SIGNPOSTS": "SIGNPOST, to provide with posts bearing signs [v]\n",
  "SIGNS": "SIGN, to write one's name [v]\n",
  "SIGS": "SIG, a short personalized message at the end of an email, a signature [n]\n",
  "SIJO": "(Korean) a Korean verse form [n -S]\n",
  "SIJOS": "SIJO, (Korean) a Korean verse form [n]\n",
  "SIK": "(Australian slang) excellent [adj]\n",
  "SIKA": "(Japanese) a kind of deer, native to Japan [n -S]\n",
  "SIKAS": "SIKA, (Japanese) a kind of deer, native to Japan [n]\n",
  "SIKE": "a small stream, also SYKE [n -S]\n",
  "SIKER": "(US) secure, certain, also SICCAR, SICKER, SYKER [adj]\n",
  "SIKES": "SIKE, a small stream, also SYKE [n]\n",
  "SIKORSKIES": "SIKORSKY, a helicopter [n]\n",
  "SIKORSKY": "a helicopter [n SIKORSKIES]\n",
  "SIKSIK": "an Arctic ground squirrel, named for the short piercing whistle it makes [n -S]\n",
  "SIKSIKS": "SIKSIK, an Arctic ground squirrel, named for the short piercing whistle it makes [n]\n",
  "SILAGE": "to harvest and store a crop [v SILAGED, SILAGING or SILAGEING, SILAGES]\n",
  "SILAGED": "SILAGE, to harvest and store a crop [v]\n",
  "SILAGEING": "SILAGE, to harvest and store a crop [v]\n",
  "SILAGES": "SILAGE, to harvest and store a crop [v]\n",
  "SILAGING": "SILAGE, to harvest and store a crop [v]\n",
  "SILANE": "a gas, silicon hydride, used in the production of semiconductors [n -S]\n",
  "SILANES": "SILANE, a gas, silicon hydride, used in the production of semiconductors [n]\n",
  "SILASTIC": "(trademark) a flexible silicone rubber, used in the production of artificial limbs [n -S]\n",
  "SILASTICS": "SILASTIC, (trademark) a flexible silicone rubber, used in the production of artificial limbs [n]\n",
  "SILD": "(Norwegian) herring, esp. canned, lightly smoked herring imported from Scandinavia [n -S]\n",
  "SILDENAFIL": "a drug used to enhance erectile function [n -S]\n",
  "SILDENAFILS": "SILDENAFIL, a drug used to enhance erectile function [n]\n",
  "SILDS": "SILD, (Norwegian) herring, esp. canned, lightly smoked herring imported from Scandinavia [n]\n",
  "SILE": "to strain, also SEIL [v SILED, SILING, SILES]\n",
  "SILED": "SILE, to strain, also SEIL [v]\n",
  "SILEN": "a woodland god or elderly satyr, also SILENUS [n -S]\n",
  "SILENCE": "to make quiet [v SILENCED, SILENCING, SILENCES]\n",
  "SILENCED": "SILENCE, to make quiet [v]\n",
  "SILENCER": "one that silences [n -S]\n",
  "SILENCERS": "SILENCER, one that silences [n]\n",
  "SILENCES": "SILENCE, to make quiet [v]\n",
  "SILENCING": "SILENCE, to make quiet [v]\n",
  "SILENE": "a flowering plant of the genus Silene, including the campions and catchfly [n -S]\n",
  "SILENES": "SILENE, a flowering plant of the genus Silene, including the campions and catchfly [n]\n",
  "SILENI": "SILENUS, (Latin) a satyrlike woodland god, an attendant of Bacchus, also SILEN [n]\n",
  "SILENS": "SILEN, a woodland god or elderly satyr, also SILENUS [n]\n",
  "SILENT": "without sound [adj SILENTER, SILENTEST, SILENTLY] / a silent film [n -S]\n",
  "SILENTER": "SILENT, without sound [adj]\n",
  "SILENTEST": "SILENT, without sound [adj]\n",
  "SILENTIARIES": "SILENTIARY, a person maintaining or bound to silence [n]\n",
  "SILENTIARY": "a person maintaining or bound to silence [n SILENTIARIES]\n",
  "SILENTLY": "SILENT, without sound [adv]\n",
  "SILENTNESS": "the state of being silent [n -ES]\n",
  "SILENTNESSES": "SILENTNESS, the state of being silent [n]\n",
  "SILENTS": "SILENT, a silent film [n]\n",
  "SILENUS": "(Latin) a satyrlike woodland god, an attendant of Bacchus, also SILEN [n SILENI]\n",
  "SILER": "a strainer [n -S]\n",
  "SILERS": "SILER, a strainer [n]\n",
  "SILES": "SILE, to strain, also SEIL [v]\n",
  "SILESIA": "a thin twilled cotton or linen [n -S]\n",
  "SILESIAS": "SILESIA, a thin twilled cotton or linen [n]\n",
  "SILEX": "(Latin) finely ground tripoli used as a paint filler [n -ES]\n",
  "SILEXES": "SILEX, (Latin) finely ground tripoli used as a paint filler [n]\n",
  "SILHOUETTE": "(French) a portrait obtained by tracing the outline of a profile, head, or figure, esp. by means of its shadow [n -S] / to represent or show in silhouette [v SILHOUETTED, SILHOUETTING, SILHOUETTES]\n",
  "SILHOUETTED": "SILHOUETTE, to represent or show in silhouette [v]\n",
  "SILHOUETTES": "SILHOUETTE, (French) a portrait obtained by tracing the outline of a profile, head, or figure, esp. by means of its shadow [n]\n",
  "SILHOUETTING": "SILHOUETTE, to represent or show in silhouette [v]\n",
  "SILHOUETTIST": "one who makes silhouettes [n -S]\n",
  "SILHOUETTISTS": "SILHOUETTIST, one who makes silhouettes [n]\n",
  "SILICA": "silicon dioxide or silicic anhydride, occurring in nature as quartz, chalcedony, etc. [n -S]\n",
  "SILICAS": "SILICA, silicon dioxide or silicic anhydride, occurring in nature as quartz, chalcedony, etc. [n]\n",
  "SILICATE": "to combine with silica [v SILICATED, SILICATING, SILICATES]\n",
  "SILICATED": "SILICATE, to combine with silica [v]\n",
  "SILICATES": "SILICATE, to combine with silica [v]\n",
  "SILICATING": "SILICATE, to combine with silica [v]\n",
  "SILICEOUS": "consisting in a noteworthy part of silica, typically quartz, also SILICIOUS [adj]\n",
  "SILICIC": "relating to or obtained from silica; as, silicic acid [adj]\n",
  "SILICICOLOUS": "growing in silicate or sandy soil [adj]\n",
  "SILICIDE": "a silicon compound [n -S]\n",
  "SILICIDES": "SILICIDE, a silicon compound [n]\n",
  "SILICIFEROUS": "bearing or containing silica [adj]\n",
  "SILICIFICATION": "a process whereby silica replaces the original material of a substance, e.g. wood [n -S]\n",
  "SILICIFICATIONS": "SILICIFICATION, a process whereby silica replaces the original material of a substance, e.g. wood [n]\n",
  "SILICIFIED": "SILICIFY, to convert into silica [v]\n",
  "SILICIFIES": "SILICIFY, to convert into silica [v]\n",
  "SILICIFY": "to convert into silica [v SILICIFIED, SILICIFYING, SILICIFIES]\n",
  "SILICIFYING": "SILICIFY, to convert into silica [v]\n",
  "SILICIOUS": "consisting in a noteworthy part of silica, typically quartz, also SILICEOUS [adj]\n",
  "SILICIUM": "the original name of the element silicon [n -S]\n",
  "SILICIUMS": "SILICIUM, the original name of the element silicon [n]\n",
  "SILICLE": "a seed vessel resembling a silique, but about as broad as it is long, also SILICULA, SILICULE [n -S]\n",
  "SILICLES": "SILICLE, a seed vessel resembling a silique, but about as broad as it is long, also SILICULA, SILICULE [n]\n",
  "SILICON": "a nonmetallic element [n -S]\n",
  "SILICONE": "any of a number of extremely stable organic derivatives of silicon [n -S]\n",
  "SILICONES": "SILICONE, any of a number of extremely stable organic derivatives of silicon [n]\n",
  "SILICONISED": "of glassware, treated or coated with silicon, also SILICONIZED [adj]\n",
  "SILICONIZED": "of glassware, treated or coated with silicon, also SILICONISED [adj]\n",
  "SILICONS": "SILICON, a nonmetallic element [n]\n",
  "SILICOSES": "SILICOSIS, a lung disease caused by inhaling silica dust [n]\n",
  "SILICOSIS": "a lung disease caused by inhaling silica dust [n SILICOSES]\n",
  "SILICOTIC": "someone suffering from silicosis, a lung disease caused by inhaling silica dust [n -S]\n",
  "SILICOTICS": "SILICOTIC, someone suffering from silicosis, a lung disease caused by inhaling silica dust [n]\n",
  "SILICULA": "(Latin) a seed vessel resembling a silique, but about as broad as it is long, also SILICLE, SILICULE [n SILICULAE or SILICULAS]\n",
  "SILICULAE": "SILICULA, (Latin) a seed vessel resembling a silique, but about as broad as it is long, also SILICLE, SILICULE [n]\n",
  "SILICULAS": "SILICULA, (Latin) a seed vessel resembling a silique, but about as broad as it is long, also SILICLE, SILICULE [n]\n",
  "SILICULE": "a seed vessel resembling a silique, but about as broad as it is long, also SILICLE, SILICULA [n -S]\n",
  "SILICULES": "SILICULE, a seed vessel resembling a silique, but about as broad as it is long, also SILICLE, SILICULA [n]\n",
  "SILICULOSE": "pertaining to, or resembling, silicles [adj]\n",
  "SILING": "SILE, to strain, also SEIL [v]\n",
  "SILIQUA": "(Latin) a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUE [n SILIQUAS or SILIQUAE]\n",
  "SILIQUACEOUS": "of or like a siliqua, a type of dry fruit consisting of a long pod of two carpels divided by a partition [adj]\n",
  "SILIQUAE": "SILIQUA, (Latin) a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUE [n]\n",
  "SILIQUAS": "SILIQUA, (Latin) a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUE [n]\n",
  "SILIQUE": "(Latin) a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUA [n -S]\n",
  "SILIQUES": "SILIQUE, (Latin) a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUA [n]\n",
  "SILIQUOSE": "relating to a siliqua, a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUOUS [adj]\n",
  "SILIQUOUS": "relating to a siliqua, a type of dry fruit consisting of a long pod of two carpels divided by a partition, also SILIQUOSE [adj]\n",
  "SILK": "to cover with a soft lustrous fabric [v -ED, -ING, -S]\n",
  "SILKALENE": "a soft light cotton fabric resembling silk, also SILKALINE, SILKOLINE [n -S]\n",
  "SILKALENES": "SILKALENE, a soft light cotton fabric resembling silk, also SILKALINE, SILKOLINE [n]\n",
  "SILKALINE": "a soft light cotton fabric resembling silk, also SILKALENE, SILKOLINE [n -S]\n",
  "SILKALINES": "SILKALINE, a soft light cotton fabric resembling silk, also SILKALENE, SILKOLINE [n]\n",
  "SILKED": "SILK, to cover with a soft lustrous fabric [v]\n",
  "SILKEN": "to make soft and smooth [v -ED, -ING, -S]\n",
  "SILKENED": "SILKEN, to make soft and smooth [v]\n",
  "SILKENING": "SILKEN, to make soft and smooth [v]\n",
  "SILKENS": "SILKEN, to make soft and smooth [v]\n",
  "SILKGROWER": "a grower of silk [n -S]\n",
  "SILKGROWERS": "SILKGROWER, a grower of silk [n]\n",
  "SILKIE": "(Scots) a seal, also SEALCH, SEALGH, SELKIE [n -S]\n",
  "SILKIER": "SILKY, resembling silk [adj]\n",
  "SILKIES": "SILKIE, (Scots) a seal, also SEALCH, SEALGH, SELKIE [n]\n",
  "SILKIEST": "SILKY, resembling silk [adj]\n",
  "SILKILY": "SILKY, resembling silk [adv]\n",
  "SILKINESS": "the state of being silky [n -ES]\n",
  "SILKINESSES": "SILKINESS, the state of being silky [n]\n",
  "SILKING": "SILK, to cover with a soft lustrous fabric [v]\n",
  "SILKLIKE": "like silk [adj]\n",
  "SILKOLINE": "a soft light cotton fabric resembling silk, also SILKALENE, SILKALINE [n -S]\n",
  "SILKOLINES": "SILKOLINE, a soft light cotton fabric resembling silk, also SILKALENE, SILKALINE [n]\n",
  "SILKS": "SILK, to cover with a soft lustrous fabric [v]\n",
  "SILKSCREEN": "to print via a certain process [v -ED, -ING, -S]\n",
  "SILKSCREENED": "SILKSCREEN, to print via a certain process [v]\n",
  "SILKSCREENING": "SILKSCREEN, to print via a certain process [v]\n",
  "SILKSCREENS": "SILKSCREEN, to print via a certain process [v]\n",
  "SILKTAIL": "a bird, a kind of waxwing [n -S]\n",
  "SILKTAILS": "SILKTAIL, a bird, a kind of waxwing [n]\n",
  "SILKWEED": "another name for the plant milkweed [n -S]\n",
  "SILKWEEDS": "SILKWEED, another name for the plant milkweed [n]\n",
  "SILKWORM": "the larva of the Chinese moth Bombyx mori, that feeds on the leaves of the mulberry tree, widely cultivated as a source of silk [n -S]\n",
  "SILKWORMS": "SILKWORM, the larva of the Chinese moth Bombyx mori, that feeds on the leaves of the mulberry tree, widely cultivated as a source of silk [n]\n",
  "SILKY": "resembling silk [adj SILKIER, SILKIEST, SILKILY]\n",
  "SILL": "a part of a window [n -S]\n",
  "SILLABUB": "a frothy dish of cream curdled with wine, also SILLIBUB, SYLLABUB [n -S]\n",
  "SILLABUBS": "SILLABUB, a frothy dish of cream curdled with wine, also SILLIBUB, SYLLABUB [n]\n",
  "SILLADAR": "(Urdu) an irregular cavalryman who provided his own horse and arms [n -S]\n",
  "SILLADARS": "SILLADAR, (Urdu) an irregular cavalryman who provided his own horse and arms [n]\n",
  "SILLER": "(Scots) silver [n -S]\n",
  "SILLERS": "SILLER, (Scots) silver [n]\n",
  "SILLIBUB": "a frothy dish of cream curdled with wine, also SILLABUB, SYLLABUB [n -S]\n",
  "SILLIBUBS": "SILLIBUB, a frothy dish of cream curdled with wine, also SILLABUB, SYLLABUB [n]\n",
  "SILLIER": "SILLY, showing a lack of common sense [adj]\n",
  "SILLIES": "SILLY, a silly person [n]\n",
  "SILLIEST": "SILLY, showing a lack of common sense [adj]\n",
  "SILLILY": "SILLY, showing a lack of common sense [adv]\n",
  "SILLIMANITE": "a silicate of alumina, of fibrous or columnar structure; aka fibrolite [n -S]\n",
  "SILLIMANITES": "SILLIMANITE, a silicate of alumina, of fibrous or columnar structure; aka fibrolite [n]\n",
  "SILLINESS": "the state of being silly [n -ES]\n",
  "SILLINESSES": "SILLINESS, the state of being silly [n]\n",
  "SILLOCK": "(Scots) a young coalfish [n -S]\n",
  "SILLOCKS": "SILLOCK, (Scots) a young coalfish [n]\n",
  "SILLS": "SILL, a part of a window [n]\n",
  "SILLY": "a silly person [n SILLIES] / showing a lack of common sense [adj SILLIER, SILLIEST, SILLILY]\n",
  "SILO": "to store in a large cylindrical structure [v -ED, -ING, -S]\n",
  "SILOED": "SILO, to store in a large cylindrical structure [v]\n",
  "SILOING": "SILO, to store in a large cylindrical structure [v]\n",
  "SILOS": "SILO, to store in a large cylindrical structure [v]\n",
  "SILOXANE": "any of various polymers containing silicon and oxygen [n -S]\n",
  "SILOXANES": "SILOXANE, any of various polymers containing silicon and oxygen [n]\n",
  "SILPHIA": "SILPHIUM, (Latin) a plant imported by the Greeks from Cyrenaica and used as a foodstuff and in medicine [n]\n",
  "SILPHIUM": "(Latin) a plant imported by the Greeks from Cyrenaica and used as a foodstuff and in medicine [n SILPHIA or SILPHIUMS]\n",
  "SILPHIUMS": "SILPHIUM, (Latin) a plant imported by the Greeks from Cyrenaica and used as a foodstuff and in medicine [n]\n",
  "SILT": "to fill with a fine sediment [v -ED, -ING, -S]\n",
  "SILTATION": "the process of silting [n -S]\n",
  "SILTATIONS": "SILTATION, the process of silting [n]\n",
  "SILTED": "SILT, to fill with a fine sediment [v]\n",
  "SILTIER": "SILTY, full of silt [adj]\n",
  "SILTIEST": "SILTY, full of silt [adj]\n",
  "SILTING": "SILT, to fill with a fine sediment [v]\n",
  "SILTS": "SILT, to fill with a fine sediment [v]\n",
  "SILTSTONE": "a rock formed of hardened silt [n -S]\n",
  "SILTSTONES": "SILTSTONE, a rock formed of hardened silt [n]\n",
  "SILTY": "full of silt [adj SILTIER, SILTIEST]\n",
  "SILURIAN": "formed in the third period of the Palaeozoic era [adj]\n",
  "SILURID": "(Latin) any of a family of catfishes, also SILUROID [n -S]\n",
  "SILURIDS": "SILURID, (Latin) any of a family of catfishes, also SILUROID [n]\n",
  "SILURIST": "a member of the ancient British Silurian tribe [n -S]\n",
  "SILURISTS": "SILURIST, a member of the ancient British Silurian tribe [n]\n",
  "SILUROID": "any of a family of catfishes, also SILURID [n -S]\n",
  "SILUROIDS": "SILUROID, any of a family of catfishes, also SILURID [n]\n",
  "SILVA": "(Latin) the forest trees of an area, also SYLVA [n SILVAS or SILVAE]\n",
  "SILVAE": "SILVA, (Latin) the forest trees of an area, also SYLVA [n]\n",
  "SILVAN": "one that lives in a forest, also SYLVAN [n -S]\n",
  "SILVANS": "SILVAN, one that lives in a forest, also SYLVAN [n]\n",
  "SILVAS": "SILVA, (Latin) the forest trees of an area, also SYLVA [n]\n",
  "SILVATIC": "pertaining to the forest [adj]\n",
  "SILVER": "to cover with a metallic element [v -ED, -ING, -S]\n",
  "SILVERBACK": "an older male gorilla with grey hair on its back and flanks [n -S]\n",
  "SILVERBACKS": "SILVERBACK, an older male gorilla with grey hair on its back and flanks [n]\n",
  "SILVERBERRIES": "SILVERBERRY, a silvery North American shrub of the oleaster family [n]\n",
  "SILVERBERRY": "a silvery North American shrub of the oleaster family [n SILVERBERRIES]\n",
  "SILVERBILL": "an Old World finch of the genus Minia [n -S]\n",
  "SILVERBILLS": "SILVERBILL, an Old World finch of the genus Minia [n]\n",
  "SILVERED": "SILVER, to cover with a metallic element [v]\n",
  "SILVERER": "one who silvers [n -S]\n",
  "SILVERERS": "SILVERER, one who silvers [n]\n",
  "SILVEREYE": "a greenish-coloured tropical songbird, aka tauhou [n -S]\n",
  "SILVEREYES": "SILVEREYE, a greenish-coloured tropical songbird, aka tauhou [n]\n",
  "SILVERFISH": "any of various silver-coloured fishes, esp. the tarpon [n -ES]\n",
  "SILVERFISHES": "SILVERFISH, any of various silver-coloured fishes, esp. the tarpon [n]\n",
  "SILVERHORN": "any of various usually darkish caddis flies of the family Leptoceridae, characterized by very long pale antennae [n -S]\n",
  "SILVERHORNS": "SILVERHORN, any of various usually darkish caddis flies of the family Leptoceridae, characterized by very long pale antennae [n]\n",
  "SILVERIER": "SILVERY, appearing like silver [adj]\n",
  "SILVERIEST": "SILVERY, appearing like silver [adj]\n",
  "SILVERINESS": "the state of being silvery [n -ES]\n",
  "SILVERINESSES": "SILVERINESS, the state of being silvery [n]\n",
  "SILVERING": "the act of coating with silver [n -S]\n",
  "SILVERINGS": "SILVERING, the act of coating with silver [n]\n",
  "SILVERISE": "to cover with silver, also SILVERIZE [v SILVERISED, SILVERISING, SILVERISES]\n",
  "SILVERISED": "SILVERISE, to cover with silver, also SILVERIZE [v]\n",
  "SILVERISES": "SILVERISE, to cover with silver, also SILVERIZE [v]\n",
  "SILVERISING": "SILVERISE, to cover with silver, also SILVERIZE [v]\n",
  "SILVERIZE": "to cover with silver, also SILVERISE [v SILVERIZED, SILVERIZING, SILVERIZES]\n",
  "SILVERIZED": "SILVERIZE, to cover with silver, also SILVERISE [v]\n",
  "SILVERIZES": "SILVERIZE, to cover with silver, also SILVERISE [v]\n",
  "SILVERIZING": "SILVERIZE, to cover with silver, also SILVERISE [v]\n",
  "SILVERLING": "in the Bible, a small silver coin [n -S]\n",
  "SILVERLINGS": "SILVERLING, in the Bible, a small silver coin [n]\n",
  "SILVERLY": "with a silvery appearance [adv]\n",
  "SILVERN": "made of silver [adj]\n",
  "SILVERPOINT": "the process or product of drawing with a silver-tipped pencil [n -S]\n",
  "SILVERPOINTS": "SILVERPOINT, the process or product of drawing with a silver-tipped pencil [n]\n",
  "SILVERS": "SILVER, to cover with a metallic element [v]\n",
  "SILVERSIDE": "a cut of beef taken from the rump, below the aitchbone [n -S]\n",
  "SILVERSIDES": "a small fish, aka sand smelt [n SILVERSIDES]\n",
  "SILVERSKIN": "the fine skin of a coffee bean [n -S]\n",
  "SILVERSKINS": "SILVERSKIN, the fine skin of a coffee bean [n]\n",
  "SILVERSMITH": "an artisan who makes articles of silverware [n -S]\n",
  "SILVERSMITHING": "the craft of the silversmith [n -S]\n",
  "SILVERSMITHINGS": "SILVERSMITHING, the craft of the silversmith [n]\n",
  "SILVERSMITHS": "SILVERSMITH, an artisan who makes articles of silverware [n]\n",
  "SILVERTAIL": "(Australian slang) a wealthy socialite, a social climber [n -S]\n",
  "SILVERTAILS": "SILVERTAIL, (Australian slang) a wealthy socialite, a social climber [n]\n",
  "SILVERTIP": "a kind of grizzly bear [n -S]\n",
  "SILVERTIPS": "SILVERTIP, a kind of grizzly bear [n]\n",
  "SILVERWARE": "items, esp. tableware or sporting trophies, made from or coated with silver [n -S]\n",
  "SILVERWARES": "SILVERWARE, items, esp. tableware or sporting trophies, made from or coated with silver [n]\n",
  "SILVERWEED": "a perennial rosaceous herb having the leaves silvery white beneath [n -S]\n",
  "SILVERWEEDS": "SILVERWEED, a perennial rosaceous herb having the leaves silvery white beneath [n]\n",
  "SILVERY": "appearing like silver [adj SILVERIER, SILVERIEST]\n",
  "SILVESTRIAN": "relating to woodland, also SYLVESTRIAN [adj]\n",
  "SILVEX": "a herbicide [n -ES]\n",
  "SILVEXES": "SILVEX, a herbicide [n]\n",
  "SILVICAL": "relating to silvics, the study of forest trees [adj]\n",
  "SILVICS": "the study of forest trees [n]\n",
  "SILVICULTURAL": "relating to silviculture, also SYLVICULTURAL [adj SILVICULTURALLY]\n",
  "SILVICULTURALLY": "SILVICULTURAL, relating to silviculture, also SYLVICULTURAL [adv]\n",
  "SILVICULTURE": "the growing of trees, also SYLVICULTURE [n -S]\n",
  "SILVICULTURES": "SILVICULTURE, the growing of trees, also SYLVICULTURE [n]\n",
  "SILVICULTURIST": "one who practises silviculture, the growing of trees [n -S]\n",
  "SILVICULTURISTS": "SILVICULTURIST, one who practises silviculture, the growing of trees [n]\n",
  "SILYMARIN": "an antioxidant flavonoid found in milk thistle [n -S]\n",
  "SILYMARINS": "SILYMARIN, an antioxidant flavonoid found in milk thistle [n]\n",
  "SIM": "(short for) simulation or for Simeonite, an evangelical follower of Charles Simeon [n -S]\n",
  "SIMA": "the oceanic crust; also the lower layer of the continental crust, so called because it is enriched in silica and magnesium oxide [n -S]\n",
  "SIMAR": "(French) a loose coat, an undergarment formerly worn by women, also CIMAR, CYMAR, SIMARRE, SYMAR [n -S]\n",
  "SIMAROUBA": "a tropical American tree, also SIMARUBA [n -S]\n",
  "SIMAROUBACEOUS": "belonging to the Simarubaceae, a family of tropical trees related to the Rutaceae, also SIMARUBACEOUS [adj]\n",
  "SIMAROUBAS": "SIMAROUBA, a tropical American tree, also SIMARUBA [n]\n",
  "SIMARRE": "(French) a loose coat, an undergarment formerly worn by women, also CIMAR, CYMAR, SIMAR, SYMAR [n -S]\n",
  "SIMARRES": "SIMARRE, (French) a loose coat, an undergarment formerly worn by women, also CIMAR, CYMAR, SIMAR, SYMAR [n]\n",
  "SIMARS": "SIMAR, (French) a loose coat, an undergarment formerly worn by women, also CIMAR, CYMAR, SIMARRE, SYMAR [n]\n",
  "SIMARUBA": "a tropical American tree, also SIMAROUBA [n -S]\n",
  "SIMARUBACEOUS": "belonging to the Simarubaceae, a family of tropical trees related to the Rutaceae, also SIMAROUBACEOUS [adj]\n",
  "SIMARUBAS": "SIMARUBA, a tropical American tree, also SIMAROUBA [n]\n",
  "SIMAS": "SIMA, the oceanic crust; also the lower layer of the continental crust, so called because it is enriched in silica and magnesium oxide [n]\n",
  "SIMATIC": "relating to sima, igneous rock [adj]\n",
  "SIMAZINE": "an organic herbicide used as a general weedkiller [n -S]\n",
  "SIMAZINES": "SIMAZINE, an organic herbicide used as a general weedkiller [n]\n",
  "SIMBA": "(Swahili) a lion [n -S]\n",
  "SIMBAS": "SIMBA, (Swahili) a lion [n]\n",
  "SIMCHA": "(Hebrew) a Jewish private party [n -S]\n",
  "SIMCHAS": "SIMCHA, (Hebrew) a Jewish private party [n]\n",
  "SIMI": "(Swahili) in Africa, a short two-edged sword or large knife [n -S]\n",
  "SIMIAL": "apelike, also SIMIAN, SIMIOID, SIMIOUS [adj]\n",
  "SIMIAN": "an ape or monkey [n -S]\n",
  "SIMIANS": "SIMIAN, an ape or monkey [n]\n",
  "SIMILAR": "being alike but not identical [adj SIMILARLY]\n",
  "SIMILARITIES": "SIMILARITY, the state of being similar [n]\n",
  "SIMILARITY": "the state of being similar [n SIMILARITIES]\n",
  "SIMILARLY": "SIMILAR, being alike but not identical [adv]\n",
  "SIMILATIVE": "indicating likeness or resemblance [adj]\n",
  "SIMILE": "a figure of speech, an explicit comparison between two things using 'like' or 'as' [n -S]\n",
  "SIMILES": "SIMILE, a figure of speech, an explicit comparison between two things using 'like' or 'as' [n]\n",
  "SIMILISE": "to liken, also SIMILIZE [v SIMILISED, SIMILISING, SIMILISES]\n",
  "SIMILISED": "SIMILISE, to liken, also SIMILIZE [v]\n",
  "SIMILISES": "SIMILISE, to liken, also SIMILIZE [v]\n",
  "SIMILISING": "SIMILISE, to liken, also SIMILIZE [v]\n",
  "SIMILITUDE": "the state of being similar [n -S]\n",
  "SIMILITUDES": "SIMILITUDE, the state of being similar [n]\n",
  "SIMILIZE": "to liken, also SIMILISE [v SIMILIZED, SIMILIZING, SIMILIZES]\n",
  "SIMILIZED": "SIMILIZE, to liken, also SIMILISE [v]\n",
  "SIMILIZES": "SIMILIZE, to liken, also SIMILISE [v]\n",
  "SIMILIZING": "SIMILIZE, to liken, also SIMILISE [v]\n",
  "SIMILLIMUM": "a remedy chosen for the symptoms it emulates [n -S]\n",
  "SIMILLIMUMS": "SIMILLIMUM, a remedy chosen for the symptoms it emulates [n]\n",
  "SIMILOR": "an alloy of copper and zinc, resembling brass, but of a golden color [n -S]\n",
  "SIMILORS": "SIMILOR, an alloy of copper and zinc, resembling brass, but of a golden color [n]\n",
  "SIMIOID": "apelike, also SIMIAL, SIMIAN, SIMIOUS [adj]\n",
  "SIMIOUS": "apelike, also SIMIAL, SIMIAN, SIMIOID [adj]\n",
  "SIMIS": "SIMI, (Swahili) in Africa, a short two-edged sword or large knife [n]\n",
  "SIMITAR": "a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SYMITAR, SYMITARE [n -S]\n",
  "SIMITARS": "SIMITAR, a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SYMITAR, SYMITARE [n]\n",
  "SIMKIN": "an Urdu corruption of champagne, also SIMPKIN [n -S]\n",
  "SIMKINS": "SIMKIN, an Urdu corruption of champagne, also SIMPKIN [n]\n",
  "SIMLIN": "a variety of squash, also CYMBLING, CYMLIN, CYMLING [n -S]\n",
  "SIMLINS": "SIMLIN, a variety of squash, also CYMBLING, CYMLIN, CYMLING [n]\n",
  "SIMMER": "to cook just below boiling point [v -ED, -ING, -S]\n",
  "SIMMERED": "SIMMER, to cook just below boiling point [v]\n",
  "SIMMERING": "SIMMER, to cook just below boiling point [v]\n",
  "SIMMERS": "SIMMER, to cook just below boiling point [v]\n",
  "SIMNEL": "a fruitcake covered with almond paste, made at Easter and Christmas [n -S]\n",
  "SIMNELS": "SIMNEL, a fruitcake covered with almond paste, made at Easter and Christmas [n]\n",
  "SIMOLEON": "(US slang) a dollar [n -S]\n",
  "SIMOLEONS": "SIMOLEON, (US slang) a dollar [n]\n",
  "SIMONIAC": "one who practices simony, also SIMONIST [n -S]\n",
  "SIMONIACAL": "of or pertaining to simony, also SIMONIOUS [adj SIMONIACALLY]\n",
  "SIMONIACALLY": "SIMONIACAL, of or pertaining to simony, also SIMONIOUS [adv]\n",
  "SIMONIACS": "SIMONIAC, one who practices simony, also SIMONIST [n]\n",
  "SIMONIES": "SIMONY, the buying and selling of a church office [n]\n",
  "SIMONIOUS": "(obsolete) of or pertaining to simony, also SIMONIACAL [adj]\n",
  "SIMONISE": "to polish with wax, also SIMONIZE [v SIMONISED, SIMONISING, SIMONISES]\n",
  "SIMONISED": "SIMONISE, to polish with wax, also SIMONIZE [v]\n",
  "SIMONISES": "SIMONISE, to polish with wax, also SIMONIZE [v]\n",
  "SIMONISING": "SIMONISE, to polish with wax, also SIMONIZE [v]\n",
  "SIMONIST": "one who practices simony, also SIMONIAC [n -S]\n",
  "SIMONISTS": "SIMONIST, one who practices simony, also SIMONIAC [n]\n",
  "SIMONIZE": "to polish with wax, also SIMONISE [v SIMONIZED, SIMONIZING, SIMONIZES]\n",
  "SIMONIZED": "SIMONIZE, to polish with wax, also SIMONISE [v]\n",
  "SIMONIZES": "SIMONIZE, to polish with wax, also SIMONISE [v]\n",
  "SIMONIZING": "SIMONIZE, to polish with wax, also SIMONISE [v]\n",
  "SIMONY": "the buying and selling of a church office [n SIMONIES]\n",
  "SIMOOM": "(Arabic) a hot, dry desert wind, also SAMIEL, SIMOON [n -S]\n",
  "SIMOOMS": "SIMOOM, (Arabic) a hot, dry desert wind, also SAMIEL, SIMOON [n]\n",
  "SIMOON": "(Arabic) a hot, dry desert wind, also SIMOOM, SAMIEL [n -S]\n",
  "SIMOONS": "SIMOON, (Arabic) a hot, dry desert wind, also SIMOOM, SAMIEL [n]\n",
  "SIMORG": "(Persian) a monstrous bird of Persian fable, also SIMURG, SIMURGH [n -S]\n",
  "SIMORGS": "SIMORG, (Persian) a monstrous bird of Persian fable, also SIMURG, SIMURGH [n]\n",
  "SIMP": "(short for) a simpleton [n -S]\n",
  "SIMPAI": "(Malay) a long-tailed monkey, native to Sumatra [n -S]\n",
  "SIMPAIS": "SIMPAI, (Malay) a long-tailed monkey, native to Sumatra [n]\n",
  "SIMPATICO": "(Italian) of like mind, compatible, also SYMPATICO [adj]\n",
  "SIMPER": "to smirk in a silly manner [v -ED, -ING, -S]\n",
  "SIMPERED": "SIMPER, to smirk in a silly manner [v]\n",
  "SIMPERER": "one who simpers [n -S]\n",
  "SIMPERERS": "SIMPERER, one who simpers [n]\n",
  "SIMPERING": "smiling in a silly, weak or affected manner [adj SIMPERINGLY] / the act of simpering [n -S]\n",
  "SIMPERINGLY": "SIMPERING, smiling in a silly, weak or affected manner [adv]\n",
  "SIMPERINGS": "SIMPERING, the act of simpering [n]\n",
  "SIMPERS": "SIMPER, to smirk in a silly manner [v]\n",
  "SIMPKIN": "an Urdu corruption of champagne, also SIMKIN [n -S]\n",
  "SIMPKINS": "SIMPKIN, an Urdu corruption of champagne, also SIMKIN [n]\n",
  "SIMPLE": "straightforward, also SEMPLE [adj SIMPLER, SIMPLEST, SIMPLY] / (archaic) to gather medicinal plants [v SIMPLED, SIMPLING, SIMPLES]\n",
  "SIMPLED": "SIMPLE, (archaic) to gather medicinal plants [v]\n",
  "SIMPLEMINDED": "devoid of subtlety [adj SIMPLEMINDEDLY]\n",
  "SIMPLEMINDEDLY": "SIMPLEMINDED, devoid of subtlety [adv]\n",
  "SIMPLENESS": "the state of being simple [n -ES]\n",
  "SIMPLENESSES": "SIMPLENESS, the state of being simple [n]\n",
  "SIMPLER": "(archaic) one skilled in simples, or medicinal plants, also SIMPLIST [n -S]\n",
  "SIMPLERS": "SIMPLER, (archaic) one skilled in simples, or medicinal plants, also SIMPLIST [n]\n",
  "SIMPLES": "SIMPLE, (archaic) to gather medicinal plants [v]\n",
  "SIMPLESSE": "(Spenser) simplicity [n -S]\n",
  "SIMPLESSES": "SIMPLESSE, (Spenser) simplicity [n]\n",
  "SIMPLEST": "SIMPLE, straightforward, also SEMPLE [adj]\n",
  "SIMPLETON": "a feebleminded person [n -S]\n",
  "SIMPLETONS": "SIMPLETON, a feebleminded person [n]\n",
  "SIMPLEX": "(Latin) a geometrical term, a figure with a minimum number of vertices [n SIMPLICES or SIMPLEXES]\n",
  "SIMPLEXES": "SIMPLEX, (Latin) a geometrical term, a figure with a minimum number of vertices [n]\n",
  "SIMPLICES": "SIMPLEX, (Latin) a geometrical term, a figure with a minimum number of vertices [n]\n",
  "SIMPLICIA": "SIMPLEX, (Latin) a geometrical term, a figure with a minimum number of vertices [n]\n",
  "SIMPLICIAL": "of or relating to simplexes [adj SIMPLICIALLY]\n",
  "SIMPLICIALLY": "SIMPLICIAL, of or relating to simplexes [adv]\n",
  "SIMPLICIDENTATE": "denoting a member of the Simplicidentata, rodents [adj]\n",
  "SIMPLICITER": "(Latin) simply; not relatively; unconditionally [adv]\n",
  "SIMPLICITIES": "SIMPLICITY, the state of being simple [n]\n",
  "SIMPLICITY": "the state of being simple [n SIMPLICITIES]\n",
  "SIMPLIFIABLE": "capable of being simplified [adj]\n",
  "SIMPLIFICATION": "the act of simplifying [n -S]\n",
  "SIMPLIFICATIONS": "SIMPLIFICATION, the act of simplifying [n]\n",
  "SIMPLIFICATIVE": "serving to simplify [adj]\n",
  "SIMPLIFICATOR": "one who simplifies [n -S]\n",
  "SIMPLIFICATORS": "SIMPLIFICATOR, one who simplifies [n]\n",
  "SIMPLIFIED": "SIMPLIFY, to make simple [v]\n",
  "SIMPLIFIER": "something that simplifies [n -S]\n",
  "SIMPLIFIERS": "SIMPLIFIER, something that simplifies [n]\n",
  "SIMPLIFIES": "SIMPLIFY, to make simple [v]\n",
  "SIMPLIFY": "to make simple [v SIMPLIFIED, SIMPLIFYING, SIMPLIFIES]\n",
  "SIMPLIFYING": "SIMPLIFY, to make simple [v]\n",
  "SIMPLING": "the act of gathering medicinal plants [n -S]\n",
  "SIMPLINGS": "SIMPLING, the act of gathering medicinal plants [n]\n",
  "SIMPLISM": "affected simplicity [n -S]\n",
  "SIMPLISMS": "SIMPLISM, affected simplicity [n]\n",
  "SIMPLIST": "(archaic) one skilled in simples, or medicinal plants, also SIMPLER [n -S]\n",
  "SIMPLISTE": "(French) someone who tends to oversimplify [n -S]\n",
  "SIMPLISTES": "SIMPLISTE, (French) someone who tends to oversimplify [n]\n",
  "SIMPLISTIC": "tending to oversimplify [adj SIMPLISTICALLY]\n",
  "SIMPLISTICALLY": "SIMPLISTIC, tending to oversimplify [adv]\n",
  "SIMPLISTS": "SIMPLIST, (archaic) one skilled in simples, or medicinal plants, also SIMPLER [n]\n",
  "SIMPLY": "SIMPLE, straightforward, also SEMPLE [adv]\n",
  "SIMPS": "SIMP, (short for) a simpleton [n]\n",
  "SIMS": "SIM, (short for) simulation or for Simeonite, an evangelical follower of Charles Simeon [n]\n",
  "SIMUL": "(short for) a simultaneous, a display in which a player plays a number of games of chess simultaneously against different opponents [n -S]\n",
  "SIMULACRA": "SIMULACRUM, (Latin) an image, a semblance, also SIMULACRE [n]\n",
  "SIMULACRE": "a likeness, a semblance; now usually in a derogatory sense, also SIMULACRUM [n -S]\n",
  "SIMULACRES": "SIMULACRE, a likeness, a semblance; now usually in a derogatory sense, also SIMULACRUM [n]\n",
  "SIMULACRUM": "(Latin) an image, a semblance, also SIMULACRE [n SIMULACRA or SIMULACRUMS]\n",
  "SIMULACRUMS": "SIMULACRUM, (Latin) an image, a semblance, also SIMULACRE [n]\n",
  "SIMULANT": "a simulator [n -S]\n",
  "SIMULANTS": "SIMULANT, a simulator [n]\n",
  "SIMULAR": "one that simulates, a dissembler [n -S]\n",
  "SIMULARS": "SIMULAR, one that simulates, a dissembler [n]\n",
  "SIMULATE": "to take on the appearance of [v SIMULATED, SIMULATING, SIMULATES]\n",
  "SIMULATED": "SIMULATE, to take on the appearance of [v]\n",
  "SIMULATES": "SIMULATE, to take on the appearance of [v]\n",
  "SIMULATING": "SIMULATE, to take on the appearance of [v]\n",
  "SIMULATION": "the act of simulating [n -S]\n",
  "SIMULATIONS": "SIMULATION, the act of simulating [n]\n",
  "SIMULATIVE": "relating to simulation [adj SIMULATIVELY]\n",
  "SIMULATIVELY": "SIMULATIVE, relating to simulation [adv]\n",
  "SIMULATOR": "something that simulates [n -S]\n",
  "SIMULATORS": "SIMULATOR, something that simulates [n]\n",
  "SIMULATORY": "simulated, or capable of being simulated [adj]\n",
  "SIMULCAST": "to broadcast simultaneously on radio and television [v -ED, -ING, -S]\n",
  "SIMULCASTED": "SIMULCAST, to broadcast simultaneously on radio and television [v]\n",
  "SIMULCASTING": "SIMULCAST, to broadcast simultaneously on radio and television [v]\n",
  "SIMULCASTS": "SIMULCAST, to broadcast simultaneously on radio and television [v]\n",
  "SIMULIUM": "a small black bloodsucking fly [n -S]\n",
  "SIMULIUMS": "SIMULIUM, a small black bloodsucking fly [n]\n",
  "SIMULS": "SIMUL, (short for) a simultaneous, a display in which a player plays a number of games of chess simultaneously against different opponents [n]\n",
  "SIMULTANEITIES": "SIMULTANEITY, the state of being simultaneous [n]\n",
  "SIMULTANEITY": "the state of being simultaneous [n SIMULTANEITIES]\n",
  "SIMULTANEOUS": "existing or occurring at the same time [adj SIMULTANEOUSLY] / in chess, an exhibition in which one player plays several opponents at once [n -ES]\n",
  "SIMULTANEOUSES": "SIMULTANEOUS, in chess, an exhibition in which one player plays several opponents at once [n]\n",
  "SIMULTANEOUSLY": "SIMULTANEOUS, existing or occurring at the same time [adv]\n",
  "SIMURG": "(Persian) a monstrous bird of Persian fable, also SIMORG, SIMURGH [n -S]\n",
  "SIMURGH": "(Persian) a monstrous bird of Persian fable, also SIMORG, SIMURG [n -S]\n",
  "SIMURGHS": "SIMURGH, (Persian) a monstrous bird of Persian fable, also SIMORG, SIMURG [n]\n",
  "SIMURGS": "SIMURG, (Persian) a monstrous bird of Persian fable, also SIMORG, SIMURGH [n]\n",
  "SIMVASTATIN": "a type of statin drug [n -S]\n",
  "SIMVASTATINS": "SIMVASTATIN, a type of statin drug [n]\n",
  "SIN": "to offend against moral or religious law [v SINNED, SINNING, SINS]\n",
  "SINANTHROPUS": "Peking fossil man [n -ES]\n",
  "SINANTHROPUSES": "SINANTHROPUS, Peking fossil man [n]\n",
  "SINAPISM": "a mustard-plaster [n -S]\n",
  "SINAPISMS": "SINAPISM, a mustard-plaster [n]\n",
  "SINARCHISM": "the fascist movement in Mexico, prominent around the time of the Second World War, also SINARQUISM [n -S]\n",
  "SINARCHISMS": "SINARCHISM, the fascist movement in Mexico, prominent around the time of the Second World War, also SINARQUISM [n]\n",
  "SINARCHIST": "a member of the fascist movement in Mexico, prominent around the time of the Second World War, also SINARQUIST [n -S]\n",
  "SINARCHISTS": "SINARCHIST, a member of the fascist movement in Mexico, prominent around the time of the Second World War, also SINARQUIST [n]\n",
  "SINARQUISM": "the fascist movement in Mexico, prominent around the time of the Second World War, also SINARCHISM [n -S]\n",
  "SINARQUISMS": "SINARQUISM, the fascist movement in Mexico, prominent around the time of the Second World War, also SINARCHISM [n]\n",
  "SINARQUIST": "a member of the fascist movement in Mexico, prominent around the time of the Second World War, also SINARCHIST [n -S]\n",
  "SINARQUISTS": "SINARQUIST, a member of the fascist movement in Mexico, prominent around the time of the Second World War, also SINARCHIST [n]\n",
  "SINCE": "from then until now, also SENS, SITH, SITHEN, SITHENCE, SITHENS [adv]\n",
  "SINCERE": "free from hypocrisy or falseness [adj SINCERER, SINCEREST, SINCERELY]\n",
  "SINCERELY": "SINCERE, free from hypocrisy or falseness [adv]\n",
  "SINCERENESS": "sincerity [n -ES]\n",
  "SINCERENESSES": "SINCERENESS, sincerity [n]\n",
  "SINCERER": "SINCERE, free from hypocrisy or falseness [adj]\n",
  "SINCEREST": "SINCERE, free from hypocrisy or falseness [adj]\n",
  "SINCERITIES": "SINCERITY, the quality of being sincere [n]\n",
  "SINCERITY": "the quality of being sincere [n SINCERITIES]\n",
  "SINCIPITA": "SINCIPUT, (Latin) the forehead [n]\n",
  "SINCIPITAL": "of or pertaining to the sinciput [adj]\n",
  "SINCIPUT": "(Latin) the forehead [n SINCIPUTS or SINCIPITA]\n",
  "SINCIPUTS": "SINCIPUT, (Latin) the forehead [n]\n",
  "SIND": "(Scots) to rinse, wash out, also SINE, SYND, SYNE [v -ED, -ING, -S]\n",
  "SINDED": "SIND, (Scots) to rinse, wash out, also SINE, SYND, SYNE [v]\n",
  "SINDING": "the act of rinsing [n -S]\n",
  "SINDINGS": "the act of rinsing [n]\n",
  "SINDON": "(archaic) a fine thin fabric of linen, cotton, or silk [n -S]\n",
  "SINDONOLOGIES": "SINDONOLOGY, the study of the shroud of Turin [n]\n",
  "SINDONOLOGIST": "an expert on the Turin shroud [n -S]\n",
  "SINDONOLOGISTS": "SINDONOLOGIST, an expert on the Turin shroud [n]\n",
  "SINDONOLOGY": "the study of the shroud of Turin [n SINDONOLOGIES]\n",
  "SINDONOPHANIES": "SINDONOPHANY, the periodic exhibiting of the Turin shroud to the public [n]\n",
  "SINDONOPHANY": "the periodic exhibiting of the Turin shroud to the public [n SINDONOPHANIES]\n",
  "SINDONS": "SINDON, (archaic) a fine thin fabric of linen, cotton, or silk [n]\n",
  "SINDS": "SIND, (Scots) to rinse, wash out, also SINE, SYND, SYNE [v]\n",
  "SINE": "(Scots) to rinse, wash out, also SIND, SYND, SYNE [v SINED, SINING, SINES]\n",
  "SINECURE": "a position that requires little or no work, but provides income [n -S]\n",
  "SINECURES": "SINECURE, a position that requires little or no work, but provides income [n]\n",
  "SINECURISM": "the state of having a sinecure [n -S]\n",
  "SINECURISMS": "SINECURISM, the state of having a sinecure [n]\n",
  "SINECURIST": "one who has a sinecure [n -S]\n",
  "SINECURISTS": "SINECURIST, one who has a sinecure [n]\n",
  "SINED": "SINE, (Scots) to rinse, wash out, also SIND, SYND, SYNE [v]\n",
  "SINES": "SINE, (Scots) to rinse, wash out, also SIND, SYND, SYNE [v]\n",
  "SINEW": "to bind as if by sinews [v -ED, -ING, -S]\n",
  "SINEWED": "SINEW, to bind as if by sinews [v]\n",
  "SINEWIER": "SINEWY, lean and muscular [adj]\n",
  "SINEWIEST": "SINEWY, lean and muscular [adj]\n",
  "SINEWINESS": "the state of being sinewy [n -ES]\n",
  "SINEWINESSES": "SINEWINESS, the state of being sinewy [n]\n",
  "SINEWING": "SINEW, to bind as if by sinews [v]\n",
  "SINEWLESS": "having no sinews; hence, having no strength or vigor [adj]\n",
  "SINEWS": "SINEW, to bind as if by sinews [v]\n",
  "SINEWY": "lean and muscular [adj SINEWIER, SINEWIEST]\n",
  "SINFONIA": "(Italian) a symphony; a symphony orchestra [n SINFONIE or SINFONIAS]\n",
  "SINFONIAS": "SINFONIA, (Italian) a symphony; a symphony orchestra [n]\n",
  "SINFONIE": "SINFONIA, (Italian) a symphony; a symphony orchestra [n]\n",
  "SINFONIETTA": "(Italian) a short or simple symphony [n -S]\n",
  "SINFONIETTAS": "SINFONIETTA, (Italian) a short or simple symphony [n]\n",
  "SINFUL": "tainted with sin [adj SINFULLY]\n",
  "SINFULLY": "SINFUL, tainted with sin [adv]\n",
  "SINFULNESS": "the state of being sinful [n -ES]\n",
  "SINFULNESSES": "SINFULNESS, the state of being sinful [n]\n",
  "SING": "to utter melodious musical sounds [v SANG, SUNG, SINGING, SINGS]\n",
  "SINGABLE": "able to be sung [adj]\n",
  "SINGABLENESS": "the state of being singable [n -ES]\n",
  "SINGABLENESSES": "SINGABLENESS, the state of being singable [n]\n",
  "SINGALONG": "a performance where the audience joins in with a performer [n -S]\n",
  "SINGALONGS": "SINGALONG, a performance where the audience joins in with a performer [n]\n",
  "SINGE": "to burn slightly [v SINGED, SINGEING, SINGES]\n",
  "SINGED": "SINGE, to burn slightly [v]\n",
  "SINGEING": "SINGE, to burn slightly [v]\n",
  "SINGER": "one that sings [n -S]\n",
  "SINGERS": "SINGER, one that sings [n]\n",
  "SINGES": "SINGE, to burn slightly [v]\n",
  "SINGING": "the act of singing [n -S]\n",
  "SINGINGLY": "SINGING [adv]\n",
  "SINGINGS": "SINGING, the act of singing [n]\n",
  "SINGLE": "to select from a group [v SINGLED, SINGLING, SINGLES]\n",
  "SINGLED": "SINGLE, to select from a group [v]\n",
  "SINGLEDOM": "the state of being unmarried or not involved in a long-term relationship [n -S]\n",
  "SINGLEDOMS": "SINGLEDOM, the state of being unmarried or not involved in a long-term relationship [n]\n",
  "SINGLEHOOD": "the state of being unmarried [n -S]\n",
  "SINGLEHOODS": "SINGLEHOOD, the state of being unmarried [n]\n",
  "SINGLENESS": "the state of being single [n -ES]\n",
  "SINGLENESSES": "SINGLENESS, the state of being single [n]\n",
  "SINGLES": "SINGLE, to select from a group [v]\n",
  "SINGLESTICK": "a one-handed fencing stick with a hand guard [n -S]\n",
  "SINGLESTICKS": "SINGLESTICK, a one-handed fencing stick with a hand guard [n]\n",
  "SINGLET": "a man's undershirt [n -S]\n",
  "SINGLETON": "a playing card that is the only one of its suit in a player's hand [n -S]\n",
  "SINGLETONS": "SINGLETON, a playing card that is the only one of its suit in a player's hand [n]\n",
  "SINGLETRACK": "an off-road trail used by cyclists, wide enough for only one bicycle at a time [n -S]\n",
  "SINGLETRACKS": "SINGLETRACK, an off-road trail used by cyclists, wide enough for only one bicycle at a time [n]\n",
  "SINGLETREE": "the crosspiece of a carriage to which harnesses are attached, also SWINGLETREE, SWINGTREE, WHIFFLETREE, WHIPPLETREE [n -S]\n",
  "SINGLETREES": "SINGLETREE, the crosspiece of a carriage to which harnesses are attached, also SWINGLETREE, SWINGTREE, WHIFFLETREE, WHIPPLETREE [n]\n",
  "SINGLETS": "SINGLET, a man's undershirt [n]\n",
  "SINGLING": "the act of singling [n -S]\n",
  "SINGLINGS": "SINGLING, the act of singling [n]\n",
  "SINGLY": "without the company of others [adv]\n",
  "SINGS": "SING, to utter melodious musical sounds [v]\n",
  "SINGSONG": "a ballad; jingly verse [n -S] / to hold a singsong [v -ED, -ING, -S]\n",
  "SINGSONGED": "SINGSONG, to hold a singsong [v]\n",
  "SINGSONGIER": "SINGSONGY, having a singsong quality [adj]\n",
  "SINGSONGIEST": "SINGSONGY, having a singsong quality [adj]\n",
  "SINGSONGING": "SINGSONG, to hold a singsong [v]\n",
  "SINGSONGS": "SINGSONG, to hold a singsong [v]\n",
  "SINGSONGY": "having a singsong quality [adj SINGSONGIER, SINGSONGIEST]\n",
  "SINGSPIEL": "(German) a semi-dramatic play in dialogue and song [n -S]\n",
  "SINGSPIELS": "SINGSPIEL, (German) a semi-dramatic play in dialogue and song [n]\n",
  "SINGULAR": "not plural; strange [adj SINGULARLY] / a singular word or form [n -S]\n",
  "SINGULARISATION": "the process of singularising, also SINGULARIZATION [n]\n",
  "SINGULARISE": "to make singular, also SINGULARIZE [v SINGULARISED, SINGULARISING, SINGULARISES]\n",
  "SINGULARISED": "SINGULARISE, to make singular, also SINGULARIZE [v]\n",
  "SINGULARISES": "SINGULARISE, to make singular, also SINGULARIZE [v]\n",
  "SINGULARISING": "SINGULARISE, to make singular, also SINGULARIZE [v]\n",
  "SINGULARISM": "a philosophy that recognizes one principle only, as opposed to pluralism [n -S]\n",
  "SINGULARISMS": "SINGULARISM, a philosophy that recognizes one principle only, as opposed to pluralism [n]\n",
  "SINGULARIST": "an adherent of singularism [n -S]\n",
  "SINGULARISTS": "SINGULARIST, an adherent of singularism [n]\n",
  "SINGULARITIES": "SINGULARITY, the fact or state of being singular [n]\n",
  "SINGULARITY": "the fact or state of being singular [n SINGULARITIES]\n",
  "SINGULARIZATION": "the process of singularizing, also SINGULARISATION [n]\n",
  "SINGULARIZE": "to make singular, also SINGULARISE [v SINGULARIZED, SINGULARIZING, SINGULARIZES]\n",
  "SINGULARIZED": "SINGULARIZE, to make singular, also SINGULARISE [v]\n",
  "SINGULARIZES": "SINGULARIZE, to make singular, also SINGULARISE [v]\n",
  "SINGULARIZING": "SINGULARIZE, to make singular, also SINGULARISE [v]\n",
  "SINGULARLY": "SINGULAR, not plural; strange [adv]\n",
  "SINGULARNESS": "the state of being singular [n -ES]\n",
  "SINGULARNESSES": "SINGULARNESS, the state of being singular [n]\n",
  "SINGULARS": "SINGULAR, a singular word or form [n]\n",
  "SINGULARY": "of an operator, monadic [adj]\n",
  "SINGULT": "(archaic) a sob, also SINGULTUS [n -S]\n",
  "SINGULTS": "SINGULT, (archaic) a sob, also SINGULTUS [n]\n",
  "SINGULTUS": "(Latin) hiccuping, also SINGULT [n -ES]\n",
  "SINGULTUSES": "SINGULTUS, (Latin) hiccuping, also SINGULT [n]\n",
  "SINH": "a hyperbolic function of an angle [n -S]\n",
  "SINHS": "SINH, a hyperbolic function of an angle [n]\n",
  "SINICAL": "relating to a function of an angle [adj]\n",
  "SINICISE": "to modify by Chinese influence, also SINICIZE [v SINICISED, SINICISING, SINICISES]\n",
  "SINICISED": "SINICISE, to modify by Chinese influence, also SINICIZE [v]\n",
  "SINICISES": "SINICISE, to modify by Chinese influence, also SINICIZE [v]\n",
  "SINICISING": "SINICISE, to modify by Chinese influence, also SINICIZE [v]\n",
  "SINICIZE": "to modify by Chinese influence, also SINICISE [v SINICIZED, SINICIZING, SINICIZES]\n",
  "SINICIZED": "SINICIZE, to modify by Chinese influence, also SINICISE [v]\n",
  "SINICIZES": "SINICIZE, to modify by Chinese influence, also SINICISE [v]\n",
  "SINICIZING": "SINICIZE, to modify by Chinese influence, also SINICISE [v]\n",
  "SINING": "SINE, (Scots) to rinse, wash out, also SIND, SYND, SYNE [v]\n",
  "SINISTER": "threatening or portending evil, also SINISTROUS [adj SINISTERLY]\n",
  "SINISTERITIES": "SINISTERITY, left-handedness [n]\n",
  "SINISTERITY": "left-handedness [n SINISTERITIES]\n",
  "SINISTERLY": "SINISTER, threatening or portending evil, also SINISTROUS [adv]\n",
  "SINISTERNESS": "the state of being sinister [n -ES]\n",
  "SINISTERNESSES": "SINISTERNESS, the state of being sinister [n]\n",
  "SINISTERWISE": "in left-handed fashion [adv]\n",
  "SINISTRAL": "of or pertaining to the left, as opposed to dextral [adj SINISTRALLY] / a left-handed person [n -S]\n",
  "SINISTRALITIES": "SINISTRALITY, the state of being sinistral [n]\n",
  "SINISTRALITY": "the state of being sinistral [n SINISTRALITIES]\n",
  "SINISTRALLY": "SINISTRAL, of or pertaining to the left, as opposed to dextral [adv]\n",
  "SINISTRALS": "SINISTRAL, a left-handed person [n]\n",
  "SINISTRODEXTRAL": "going or directed from left to right, as a sinistrodextral script [adj]\n",
  "SINISTRORSAL": "of a climbing plant, rising helically and turning to the right [adj SINISTRORSALLY]\n",
  "SINISTRORSALLY": "SINISTRORSAL, of a climbing plant, rising helically and turning to the right [adv]\n",
  "SINISTRORSE": "rising spirally and turning from right to left [adj SINISTRORSELY]\n",
  "SINISTRORSELY": "SINISTRORSE, rising spirally and turning from right to left [adv]\n",
  "SINISTROUS": "inauspicious, sinister, also SINISTER [adj]\n",
  "SINISTROUSLY": "SINISTROUS, inauspicious, sinister, also SINISTER [adv]\n",
  "SINK": "to subside to a lower level [v SANK, SUNK or SUNKEN, SINKING, SINKS]\n",
  "SINKABLE": "able to be sunk [adj]\n",
  "SINKAGE": "the act of sinking [n -S]\n",
  "SINKAGES": "SINKAGE, the act of sinking [n]\n",
  "SINKER": "a weight for a fishing-line [n -S]\n",
  "SINKERS": "SINKER, a weight for a fishing-line [n]\n",
  "SINKFUL": "the contents of a sink [n -S]\n",
  "SINKFULS": "SINKFUL, the contents of a sink [n]\n",
  "SINKHOLE": "a natural depression in a land surface [n -S]\n",
  "SINKHOLES": "SINKHOLE, a natural depression in a land surface [n]\n",
  "SINKIER": "SINKY, yielding underfoot [adj]\n",
  "SINKIEST": "SINKY, yielding underfoot [adj]\n",
  "SINKING": "the act of sinking [n -S]\n",
  "SINKINGS": "SINKING, the act of sinking [n]\n",
  "SINKS": "SINK, to subside to a lower level [v]\n",
  "SINKY": "yielding underfoot [adj SINKIER, SINKIEST]\n",
  "SINLESS": "without sin [adj SINLESSLY]\n",
  "SINLESSLY": "SINLESS, without sin [adv]\n",
  "SINLESSNESS": "the state of being sinless [n -ES]\n",
  "SINLESSNESSES": "SINLESSNESS, the state of being sinless [n]\n",
  "SINNED": "SIN, to offend against moral or religious law [v]\n",
  "SINNER": "to transgress, to act as a sinner [v -ED, -ING, -S]\n",
  "SINNERED": "SINNER, to transgress, to act as a sinner [v]\n",
  "SINNERING": "SINNER, to transgress, to act as a sinner [v]\n",
  "SINNERS": "SINNER, to transgress, to act as a sinner [v]\n",
  "SINNET": "plaited straw or rope, also SENNIT [n -S]\n",
  "SINNETS": "SINNET, plaited straw or rope, also SENNIT [n]\n",
  "SINNING": "SIN, to offend against moral or religious law [v]\n",
  "SINNINGIA": "one of a family of Brazilian plants that includes gloxinia [n -S]\n",
  "SINNINGIAS": "SINNINGIA, one of a family of Brazilian plants that includes gloxinia [n]\n",
  "SINOATRIAL": "as in sinoatrial node, a small mass of tissue embedded in the right atrium of the heart, that regulates the heartbeat [adj]\n",
  "SINOLOGICAL": "relating to sinology, the study of Chinese language, culture, etc. [adj]\n",
  "SINOLOGIES": "SINOLOGY, the study of Chinese language, culture, etc. [n]\n",
  "SINOLOGIST": "one versed in Chinese culture, also SINOLOGUE [n -S]\n",
  "SINOLOGISTS": "SINOLOGIST, one versed in Chinese culture, also SINOLOGUE [n]\n",
  "SINOLOGUE": "one versed in Chinese culture, also SINOLOGIST [n -S]\n",
  "SINOLOGUES": "SINOLOGUE, one versed in Chinese culture, also SINOLOGIST [n]\n",
  "SINOLOGY": "the study of Chinese language, culture, etc. [n SINOLOGIES]\n",
  "SINOPIA": "(Latin) a reddish-brown pigment used for one of the preparatory drawings of a fresco, obtained from sinopite, an iron ore, also SINOPIS [n SINOPIAS or SINOPIE]\n",
  "SINOPIAS": "SINOPIA, (Latin) a reddish-brown pigment used for one of the preparatory drawings of a fresco, obtained from sinopite, an iron ore, also SINOPIS [n]\n",
  "SINOPIE": "SINOPIA, (Latin) a reddish-brown pigment used for one of the preparatory drawings of a fresco, obtained from sinopite, an iron ore, also SINOPIS [n]\n",
  "SINOPIS": "(Latin) a reddish-brown pigment used for one of the preparatory drawings of a fresco, obtained from sinopite, an iron ore, also SINOPIA [n -ES]\n",
  "SINOPISES": "SINOPIS, (Latin) a reddish-brown pigment used for one of the preparatory drawings of a fresco, obtained from sinopite, an iron ore, also SINOPIA [n]\n",
  "SINOPITE": "an iron ore, from which the pigment sinopia is obtained [n -S]\n",
  "SINOPITES": "SINOPITE, an iron ore, from which the pigment sinopia is obtained [n]\n",
  "SINS": "SIN, to offend against moral or religious law [v]\n",
  "SINSEMILLA": "(Spanish) a kind of marijuana [n -S]\n",
  "SINSEMILLAS": "SINSEMILLA, (Spanish) a kind of marijuana [n]\n",
  "SINSYNE": "(Scots) since that time [adv]\n",
  "SINTER": "to make cohesive by heat and pressure [v -ED, -ING, -S]\n",
  "SINTERABILITIES": "SINTERABILITY, the capacity for being sintered [n]\n",
  "SINTERABILITY": "the capacity for being sintered [n SINTERABILITIES]\n",
  "SINTERED": "SINTER, to make cohesive by heat and pressure [v]\n",
  "SINTERIER": "SINTERY, coalescing under heat without liquefaction [adj]\n",
  "SINTERIEST": "SINTERY, coalescing under heat without liquefaction [adj]\n",
  "SINTERING": "SINTER, to make cohesive by heat and pressure [v]\n",
  "SINTERS": "SINTER, to make cohesive by heat and pressure [v]\n",
  "SINTERY": "coalescing under heat without liquefaction [adj SINTERIER, SINTERIEST]\n",
  "SINUATE": "curved [adj SINUATELY] / to curve in and out [v SINUATED, SINUATING, SINUATES]\n",
  "SINUATED": "SINUATE, to curve in and out [v]\n",
  "SINUATELY": "SINUATE, curved [adv]\n",
  "SINUATES": "SINUATE, to curve in and out [v]\n",
  "SINUATING": "SINUATE, to curve in and out [v]\n",
  "SINUATION": "a winding or bending in and out [n -S]\n",
  "SINUATIONS": "SINUATION, a winding or bending in and out [n]\n",
  "SINUITIS": "inflammation of a sinus, also SINUSITIS [n -ES]\n",
  "SINUITISES": "SINUITIS, inflammation of a sinus, also SINUSITIS [n]\n",
  "SINUOSE": "characterized by curves, bends or turns, also SINUOUS [adj]\n",
  "SINUOSITIES": "SINUOSITY, the state of being sinuous [n]\n",
  "SINUOSITY": "the state of being sinuous [n SINUOSITIES]\n",
  "SINUOUS": "characterized by curves, bends or turns, also SINUOSE [adj SINUOUSLY]\n",
  "SINUOUSLY": "SINUOUS, characterized by curves, bends or turns, also SINUOSE [adv]\n",
  "SINUOUSNESS": "the state of being sinuous [n -ES]\n",
  "SINUOUSNESSES": "SINUOUSNESS, the state of being sinuous [n]\n",
  "SINUPALLIAL": "of certain bivalve molluscs, having an indented pallial line for the retraction and expansion of the pallial siphons, also SINUPALLIATE [adj]\n",
  "SINUPALLIATE": "of certain bivalve molluscs, having an indented pallial line for the retraction and expansion of the pallial siphons, also SINUPALLIAL [adj]\n",
  "SINUS": "(Latin) a cranial cavity [n -ES]\n",
  "SINUSES": "SINUS, (Latin) a cranial cavity [n]\n",
  "SINUSITIS": "inflammation of the sinuses, also SINUITIS [n -ES]\n",
  "SINUSITISES": "SINUSITIS, inflammation of the sinuses, also SINUITIS [n]\n",
  "SINUSLIKE": "resembling a sinus [adj]\n",
  "SINUSOID": "a curve having the form of a sine wave [n -S]\n",
  "SINUSOIDAL": "of or pertaining to a sinusoid [adj SINUSOIDALLY]\n",
  "SINUSOIDALLY": "SINUSOIDAL, of or pertaining to a sinusoid [adv]\n",
  "SINUSOIDS": "SINUSOID, a curve having the form of a sine wave [n]\n",
  "SIP": "to drink in small quantities [v SIPPED, SIPPING, SIPS]\n",
  "SIPE": "(dialect) to soak through, seep, also SYPE [v SIPED, SIPING, SIPES]\n",
  "SIPED": "SIPE, (dialect) to soak through, seep, also SYPE [v]\n",
  "SIPES": "SIPE, (dialect) to soak through, seep, also SYPE [v]\n",
  "SIPHON": "(Greek) to draw off through a tube, also SYPHON [v -ED, -ING, -S]\n",
  "SIPHONAGE": "the action of a siphon, also SYPHONAGE [n -S]\n",
  "SIPHONAGES": "SIPHONAGE, the action of a siphon, also SYPHONAGE [n]\n",
  "SIPHONAL": "pertaining to a siphon, also SIPHONIC [adj]\n",
  "SIPHONATE": "having a siphon or siphons [adj]\n",
  "SIPHONED": "SIPHON, (Greek) to draw off through a tube, also SYPHON [v]\n",
  "SIPHONET": "an aphid's honeydew tube [n -S]\n",
  "SIPHONETS": "SIPHONET, an aphid's honeydew tube [n]\n",
  "SIPHONIC": "pertaining to a siphon, also SIPHONAL [adj]\n",
  "SIPHONING": "SIPHON, (Greek) to draw off through a tube, also SYPHON [v]\n",
  "SIPHONOGAM": "a plant reproducing by seed [n -S]\n",
  "SIPHONOGAMIES": "SIPHONOGAMY, the state of reproducing by seed [n]\n",
  "SIPHONOGAMS": "SIPHONOGAM, a plant reproducing by seed [n]\n",
  "SIPHONOGAMY": "the state of reproducing by seed [n SIPHONOGAMIES]\n",
  "SIPHONOPHORE": "a marine creature, colonial in habit [n -S]\n",
  "SIPHONOPHORES": "SIPHONOPHORE, a marine creature, colonial in habit [n]\n",
  "SIPHONOPHOROUS": "of or like a siphonophore, a type of colonial hydrozoan [adj]\n",
  "SIPHONOSTELE": "the cylinder of conducting tissue surrounding a central core of pith in certain stems [n -S]\n",
  "SIPHONOSTELES": "SIPHONOSTELE, the cylinder of conducting tissue surrounding a central core of pith in certain stems [n]\n",
  "SIPHONOSTELIC": "of or like a siphonostele, the cylinder of conducting tissue surrounding a central core of pith in certain stems [adj]\n",
  "SIPHONS": "SIPHON, (Greek) to draw off through a tube, also SYPHON [v]\n",
  "SIPHUNCLE": "the tube which runs through the partitions of chambered cephalopod shells [n -S]\n",
  "SIPHUNCLES": "SIPHUNCLE, the tube which runs through the partitions of chambered cephalopod shells [n]\n",
  "SIPING": "SIPE, (dialect) to soak through, seep, also SYPE [v]\n",
  "SIPPABLE": "capable of being sipped [adj]\n",
  "SIPPED": "SIP, to drink in small quantities [v]\n",
  "SIPPER": "one who sips [n -S]\n",
  "SIPPERS": "SIPPER, one who sips [n]\n",
  "SIPPET": "a small piece of bread soaked in gravy [n -S]\n",
  "SIPPETS": "SIPPET, a small piece of bread soaked in gravy [n]\n",
  "SIPPING": "SIP, to drink in small quantities [v]\n",
  "SIPPLE": "to sip at leisure [v SIPPLED, SIPPLING, SIPPLES]\n",
  "SIPPLED": "SIPPLE, to sip at leisure [v]\n",
  "SIPPLES": "SIPPLE, to sip at leisure [v]\n",
  "SIPPLING": "SIPPLE, to sip at leisure [v]\n",
  "SIPPY": "as in sippy cup, an infant's drinking cup [adj]\n",
  "SIPS": "SIP, to drink in small quantities [v]\n",
  "SIPUNCULID": "a kind of marine worm with a retractile proboscis, also SIPUNCULOID [n -S]\n",
  "SIPUNCULIDS": "SIPUNCULID, a kind of marine worm with a retractile proboscis, also SIPUNCULOID [n]\n",
  "SIPUNCULOID": "a kind of marine worm with a retractile proboscis, also SIPUNCULID [n -S]\n",
  "SIPUNCULOIDS": "SIPUNCULOID, a kind of marine worm with a retractile proboscis, also SIPUNCULID [n]\n",
  "SIR": "to use a respectful form of address to a man [v SIRRED, SIRRING, SIRS]\n",
  "SIRCAR": "(Urdu) the state or government; the authorities, also CIRCAR, SIRKAR [n -S]\n",
  "SIRCARS": "SIRCAR, (Urdu) the state or government; the authorities, also CIRCAR, SIRKAR [n]\n",
  "SIRDAR": "(Urdu) a native chief in Hindostan; a headman, also SARDAR [n -S]\n",
  "SIRDARS": "SIRDAR, (Urdu) a native chief in Hindostan; a headman, also SARDAR [n]\n",
  "SIRE": "to beget [v SIRED, SIRING, SIRES]\n",
  "SIRED": "SIRE, to beget [v]\n",
  "SIREE": "(US) a mode of address, sir, also SIRRA, SIRRAH, SIRREE [n -S]\n",
  "SIREES": "SIREE, (US) a mode of address, sir, also SIRRA, SIRRAH, SIRREE [n]\n",
  "SIREN": "a device that produces a penetrating warning sound, also SYREN [n -S]\n",
  "SIRENIAN": "any of an order of aquatic mammals including the manatee and dugong [n -S]\n",
  "SIRENIANS": "SIRENIAN, any of an order of aquatic mammals including the manatee and dugong [n]\n",
  "SIRENIC": "like a siren, alluring [adj]\n",
  "SIRENISE": "to bewitch, also SIRENIZE [v SIRENISED, SIRENISING, SIRENISES]\n",
  "SIRENISED": "SIRENISE, to bewitch, also SIRENIZE [v]\n",
  "SIRENISES": "SIRENISE, to bewitch, also SIRENIZE [v]\n",
  "SIRENISING": "SIRENISE, to bewitch, also SIRENIZE [v]\n",
  "SIRENIZE": "to bewitch, also SIRENISE [v SIRENIZED, SIRENIZING, SIRENIZES]\n",
  "SIRENIZED": "SIRENIZE, to bewitch, also SIRENISE [v]\n",
  "SIRENIZES": "SIRENIZE, to bewitch, also SIRENISE [v]\n",
  "SIRENIZING": "SIRENIZE, to bewitch, also SIRENISE [v]\n",
  "SIRENS": "SIREN, a device that produces a penetrating warning sound, also SYREN [n]\n",
  "SIRES": "SIRE, to beget [v]\n",
  "SIRGANG": "a green Asiatic jay-like bird [n -S]\n",
  "SIRGANGS": "SIRGANG, a green Asiatic jay-like bird [n]\n",
  "SIRI": "(Malay) the betel pepper, also SIRIH [n -S]\n",
  "SIRIASES": "SIRIASIS, sunstroke [n]\n",
  "SIRIASIS": "sunstroke [n SIRIASES]\n",
  "SIRIH": "(Malay) the betel pepper, also SIRI [n -S]\n",
  "SIRIHS": "SIRIH, (Malay) the betel pepper, also SIRI [n]\n",
  "SIRING": "the act of begetting [n -S]\n",
  "SIRINGS": "SIRING, the act of begetting [n]\n",
  "SIRIS": "SIRI, (Malay) the betel pepper, also SIRIH [n]\n",
  "SIRKAR": "(Urdu) the state or government; the authorities, also CIRCAR, SIRCAR [n -S]\n",
  "SIRKARS": "SIRKAR, (Urdu) the state or government; the authorities, also CIRCAR, SIRCAR [n]\n",
  "SIRLOIN": "a loin of beef, or the upper part of the loin, also SURLOIN [n -S]\n",
  "SIRLOINS": "SIRLOIN, a loin of beef, or the upper part of the loin, also SURLOIN [n]\n",
  "SIRNAME": "to give the family name to, also SURNAME [v SIRNAMED, SIRNAMING, SIRNAMES]\n",
  "SIRNAMED": "SIRNAME, to give the family name to, also SURNAME [v]\n",
  "SIRNAMES": "SIRNAME, to give the family name to, also SURNAME [v]\n",
  "SIRNAMING": "SIRNAME, to give the family name to, also SURNAME [v]\n",
  "SIROC": "(Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROC, SCIROCCO, SIROCCO [n -S]\n",
  "SIROCCO": "(Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROC, SCIROCCO, SIROC [n -S]\n",
  "SIROCCOS": "SIROCCO, (Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROC, SCIROCCO, SIROC [n]\n",
  "SIROCS": "SIROC, (Italian) a hot, dry, dusty wind blowing from North Africa to the North Mediterranean coastline, also SCIROC, SCIROCCO, SIROCCO [n]\n",
  "SIRONISE": "to use a particular process to treat fabric to prevent wrinkling, also SIRONIZE [v SIRONISED, SIRONISING, SIRONISES]\n",
  "SIRONISED": "SIRONISE, to use a particular process to treat fabric to prevent wrinkling, also SIRONIZE [v]\n",
  "SIRONISES": "SIRONISE, to use a particular process to treat fabric to prevent wrinkling, also SIRONIZE [v]\n",
  "SIRONISING": "SIRONISE, to use a particular process to treat fabric to prevent wrinkling, also SIRONIZE [v]\n",
  "SIRONIZE": "to use a particular process to treat fabric to prevent wrinkling, also SIRONISE [v SIRONIZED, SIRONIZING, SIRONIZES]\n",
  "SIRONIZED": "SIRONIZE, to use a particular process to treat fabric to prevent wrinkling, also SIRONISE [v]\n",
  "SIRONIZES": "SIRONIZE, to use a particular process to treat fabric to prevent wrinkling, also SIRONISE [v]\n",
  "SIRONIZING": "SIRONIZE, to use a particular process to treat fabric to prevent wrinkling, also SIRONISE [v]\n",
  "SIROSET": "(Australian) of or relating to the chemical treatment of woollen fabrics to give a permanent-press effect [adj]\n",
  "SIRRA": "(obsolete) a mode of address, sir, also SIREE, SIRRAH, SIRREE [n -S]\n",
  "SIRRAH": "(archaic) a mode of address, sir, also SIREE, SIRRA, SIRREE [n -S]\n",
  "SIRRAHS": "SIRRAH, (archaic) a mode of address, sir, also SIREE, SIRRA, SIRREE [n]\n",
  "SIRRAS": "SIRRA, (obsolete) a mode of address, sir, also SIREE, SIRRAH, SIRREE [n]\n",
  "SIRRED": "SIR, to use a respectful form of address to a man [v]\n",
  "SIRREE": "(US) a mode of address, sir, also SIREE, SIRRA, SIRRAH [n -S]\n",
  "SIRREES": "SIRREE, (US) a mode of address, sir, also SIREE, SIRRA, SIRRAH [n]\n",
  "SIRRING": "SIR, to use a respectful form of address to a man [v]\n",
  "SIRS": "SIR, to use a respectful form of address to a man [v]\n",
  "SIRTUIN": "any of a group of enzymes which regulate cell metabolism and aging [n -S]\n",
  "SIRTUINS": "SIRTUIN, any of a group of enzymes which regulate cell metabolism and aging [n]\n",
  "SIRUP": "a saturated solution of sugar boiled to prevent fermentation, also SYRUP [n -S] / to make into a syrup [v -ED, -ING, -S]\n",
  "SIRUPED": "SIRUP, to make into a syrup [v]\n",
  "SIRUPIER": "SIRUPY, like sirup [adj]\n",
  "SIRUPIEST": "SIRUPY, like sirup [adj]\n",
  "SIRUPING": "SIRUP, to make into a syrup [v]\n",
  "SIRUPS": "SIRUP, to make into a syrup [v]\n",
  "SIRUPY": "like sirup [adj SIRUPIER, SIRUPIEST]\n",
  "SIRVENTE": "(French) a (usually satirical) poem or lay recited by a medieval troubadour [n -S]\n",
  "SIRVENTES": "SIRVENTE, (French) a (usually satirical) poem or lay recited by a medieval troubadour [n]\n",
  "SIS": "(short for) sister, also SISS [n -ES]\n",
  "SISAL": "a strong fibre used for rope [n -S]\n",
  "SISALS": "SISAL, a strong fibre used for rope [n]\n",
  "SISERARIES": "SISERARY, a scolding; a blow, also SASARARA, SASSARARA [n]\n",
  "SISERARY": "a scolding; a blow, also SASARARA, SASSARARA [n SISERARIES]\n",
  "SISES": "SIS, (short for) sister, also SISS [n]\n",
  "SISKIN": "a small green-yellow European finch [n -S]\n",
  "SISKINS": "SISKIN, a small green-yellow European finch [n]\n",
  "SISS": "(short for) sister, also SIS [n -ES]\n",
  "SISSES": "SISS, (short for) sister, also SIS [n]\n",
  "SISSIER": "SISSY, effeminate, also CISSY [adj]\n",
  "SISSIES": "SISSY, a weak, girlish male [n]\n",
  "SISSIEST": "SISSY, effeminate, also CISSY [adj]\n",
  "SISSIFIED": "like a sissy, also CISSIFIED [adj]\n",
  "SISSINESS": "the state of being sissy, also SISSYNESS [n -ES]\n",
  "SISSINESSES": "SISSINESS, the state of being sissy, also SISSYNESS [n]\n",
  "SISSOO": "(Hindi) an Indian timber tree [n -S]\n",
  "SISSOOS": "SISSOO, (Hindi) an Indian timber tree [n]\n",
  "SISSY": "effeminate, also CISSY [adj SISSIER, SISSIEST] / a weak, girlish male [n SISSIES]\n",
  "SISSYISH": "resembling a sissy [adj]\n",
  "SISSYNESS": "the state of being sissy, also SISSINESS [n -ES]\n",
  "SISSYNESSES": "SISSYNESS, the state of being sissy, also SISSINESS [n]\n",
  "SIST": "to stay, as judicial proceedings; to delay or suspend [v -ED, -ING, -S]\n",
  "SISTA": "an African-American woman [n -S]\n",
  "SISTAS": "SISTA, an African-American woman [n]\n",
  "SISTED": "SIST, to stay, as judicial proceedings; to delay or suspend [v]\n",
  "SISTER": "to treat like a female sibling [v -ED, -ING, -S]\n",
  "SISTERED": "SISTER, to treat like a female sibling [v]\n",
  "SISTERHOOD": "the state of being a sister [n -S]\n",
  "SISTERHOODS": "SISTERHOOD, the state of being a sister [n]\n",
  "SISTERING": "SISTER, to treat like a female sibling [v]\n",
  "SISTERLESS": "without a sister [adj]\n",
  "SISTERLIER": "SISTERLY, of or resembling a sister [adj]\n",
  "SISTERLIEST": "SISTERLY, of or resembling a sister [adj]\n",
  "SISTERLIKE": "like a sister [adj]\n",
  "SISTERLINESS": "the state of being sisterly [n -ES]\n",
  "SISTERLINESSES": "SISTERLINESS, the state of being sisterly [n]\n",
  "SISTERLY": "of or resembling a sister [adj SISTERLIER, SISTERLIEST]\n",
  "SISTERS": "SISTER, to treat like a female sibling [v]\n",
  "SISTING": "SIST, to stay, as judicial proceedings; to delay or suspend [v]\n",
  "SISTRA": "SISTRUM, (Latin) a kind of rattle, consisting of a wooden or metal frame fitted with loose strips of metal and disks which jingled when moved [n]\n",
  "SISTROID": "shaped like a sistrum, a kind of rattle [adj]\n",
  "SISTRUM": "(Latin) a kind of rattle, consisting of a wooden or metal frame fitted with loose strips of metal and disks which jingled when moved [n SISTRA or SISTRUMS]\n",
  "SISTRUMS": "SISTRUM, (Latin) a kind of rattle, consisting of a wooden or metal frame fitted with loose strips of metal and disks which jingled when moved [n]\n",
  "SISTS": "SIST, to stay, as judicial proceedings; to delay or suspend [v]\n",
  "SIT": "to rest on the buttocks [v SAT or (obsolete) SATE, SITTEN, SITTING, SITS]\n",
  "SITAR": "(Urdu) an Indian musical instrument, also SITTAR [n -S]\n",
  "SITARIST": "one who plays the sitar [n -S]\n",
  "SITARISTS": "SITARIST, one who plays the sitar [n]\n",
  "SITARS": "SITAR, (Urdu) an Indian musical instrument, also SITTAR [n]\n",
  "SITATUNGA": "(Swahili) a species of African antelope, also SITUTUNGA [n -S]\n",
  "SITATUNGAS": "SITATUNGA, (Swahili) a species of African antelope, also SITUTUNGA [n]\n",
  "SITCOM": "(colloquial) a situation comedy [n -S]\n",
  "SITCOMS": "SITCOM, (colloquial) a situation comedy [n]\n",
  "SITE": "to place in position for operation [v SITED, SITING, SITES]\n",
  "SITED": "SITE, to place in position for operation [v]\n",
  "SITELLA": "a small black-and-white bird, also SITTELLA [n -S]\n",
  "SITELLAS": "SITELLA, a small black-and-white bird, also SITTELLA [n]\n",
  "SITES": "SITE, to place in position for operation [v]\n",
  "SITFAST": "a lump on a horse's skin [n -S]\n",
  "SITFASTS": "SITFAST, a lump on a horse's skin [n]\n",
  "SITH": "(Shakespeare) since, also SENS, SITHEN, SITHENCE, SITHENS [adv]\n",
  "SITHE": "(archaic) to scythe [v SITHED, SITHING, SITHES]\n",
  "SITHED": "SITHE, (archaic) to scythe [v]\n",
  "SITHEE": "(dialect) see thee!, listen! [interj]\n",
  "SITHEN": "(Shakespeare) since; afterwards, also SENS, SITH, SITHENCE, SITHENS [adv]\n",
  "SITHENCE": "(Shakespeare) since; afterwards, also SENS, SITH, SITHEN, SITHENS [adv]\n",
  "SITHENS": "(Shakespeare) since; afterwards, also SENS, SITH, SITHEN, SITHENCE [adv]\n",
  "SITHES": "SITHE, (archaic) to scythe [v]\n",
  "SITHING": "SITHE, (archaic) to scythe [v]\n",
  "SITING": "the act of situating [n -S]\n",
  "SITINGS": "SITING, the act of situating [n]\n",
  "SITIOLOGIES": "SITIOLOGY, the science of diet, also SITOLOGY [n]\n",
  "SITIOLOGY": "the science of diet, also SITOLOGY [n SITIOLOGIES]\n",
  "SITIOPHOBIA": "a morbid aversion to food, also SITOPHOBIA [n -S]\n",
  "SITIOPHOBIAS": "SITIOPHOBIA, a morbid aversion to food, also SITOPHOBIA [n]\n",
  "SITKA": "as in sitka spruce, a tall North American spruce tree [adj]\n",
  "SITKAMER": "(South African) a sitting-room [n -S]\n",
  "SITKAMERS": "SITKAMER, (South African) a sitting-room [n]\n",
  "SITOLOGIES": "SITOLOGY, the science of nutrition and diet [n]\n",
  "SITOLOGY": "the science of nutrition and diet [n SITOLOGIES]\n",
  "SITOPHOBIA": "a morbid aversion to food, also SITIOPHOBIA [n -S]\n",
  "SITOPHOBIAS": "SITOPHOBIA, a morbid aversion to food, also SITIOPHOBIA [n]\n",
  "SITOSTEROL": "any of several sterols widespread in plant products [n -S]\n",
  "SITOSTEROLS": "SITOSTEROL, any of several sterols widespread in plant products [n]\n",
  "SITREP": "a report on a military position [n -S]\n",
  "SITREPS": "SITREP, a report on a military position [n]\n",
  "SITS": "SIT, to rest on the buttocks [v]\n",
  "SITTAR": "(Urdu) an Indian musical instrument, also SITAR [n -S]\n",
  "SITTARS": "SITTAR, (Urdu) an Indian musical instrument, also SITAR [n]\n",
  "SITTELLA": "a small black-and-white bird, also SITELLA [n -S]\n",
  "SITTELLAS": "SITTELLA, a small black-and-white bird, also SITELLA [n]\n",
  "SITTEN": "SIT, to rest on the buttocks [v]\n",
  "SITTER": "one who sits [n -S]\n",
  "SITTERS": "SITTER, one who sits [n]\n",
  "SITTINE": "any of the nuthatch species in the genus Sitta [n -S]\n",
  "SITTINES": "SITTINE, any of the nuthatch species in the genus Sitta [n]\n",
  "SITTING": "a meeting or session [n -S]\n",
  "SITTINGS": "SITTING, a meeting or session [n]\n",
  "SITUATE": "to place in a certain position [v SITUATED, SITUATING, SITUATES]\n",
  "SITUATED": "SITUATE, to place in a certain position [v]\n",
  "SITUATES": "SITUATE, to place in a certain position [v]\n",
  "SITUATING": "SITUATE, to place in a certain position [v]\n",
  "SITUATION": "a location, place [n -S]\n",
  "SITUATIONAL": "of, relating to, or appropriate to a situation [adj SITUATIONALLY]\n",
  "SITUATIONALLY": "SITUATIONAL, of, relating to, or appropriate to a situation [adv]\n",
  "SITUATIONISM": "the theory that behaviour is determined by surrounding situations rather than by personal qualities [n -S]\n",
  "SITUATIONISMS": "SITUATIONISM, the theory that behaviour is determined by surrounding situations rather than by personal qualities [n]\n",
  "SITUATIONS": "SITUATION, a location, place [n]\n",
  "SITULA": "(Latin) a bucket [n SITULAE]\n",
  "SITULAE": "SITULA, (Latin) a bucket [n]\n",
  "SITUP": "an exercise for the stomach [n -S]\n",
  "SITUPS": "SITUP, an exercise for the stomach [n]\n",
  "SITUS": "(Latin) the place to which for purposes of legal jurisdiction or taxation a property belongs [n -ES]\n",
  "SITUSES": "SITUS, (Latin) the place to which for purposes of legal jurisdiction or taxation a property belongs [n]\n",
  "SITUTUNGA": "(Swahili) a species of African antelope, also SITATUNGA [n -S]\n",
  "SITUTUNGAS": "SITUTUNGA, (Swahili) a species of African antelope, also SITATUNGA [n]\n",
  "SITZ": "as in sitz bath, a bath in which the hips and buttocks are immersed in warm water [adj]\n",
  "SITZKRIEG": "(German) (virtual) stalemate in warfare [n -S]\n",
  "SITZKRIEGS": "SITZKRIEG, (German) (virtual) stalemate in warfare [n]\n",
  "SITZMARK": "(German) a mark in the snow by a skier who has fallen [n -S]\n",
  "SITZMARKS": "SITZMARK, (German) a mark in the snow by a skier who has fallen [n]\n",
  "SIVER": "(Scots) a drain; a grating over a drain, also SYVER [n -S]\n",
  "SIVERS": "SIVER, (Scots) a drain; a grating over a drain, also SYVER [n]\n",
  "SIWASH": "to camp out using only natural shelter [v -ED, -ING, -ES]\n",
  "SIWASHED": "SIWASH, to camp out using only natural shelter [v]\n",
  "SIWASHES": "SIWASH, to camp out using only natural shelter [v]\n",
  "SIWASHING": "SIWASH, to camp out using only natural shelter [v]\n",
  "SIX": "a number [n -ES]\n",
  "SIXAIN": "(French) a stanza of six lines, also SIXAINE [n -S]\n",
  "SIXAINE": "(French) a stanza of six lines, also SIXAIN [n -S]\n",
  "SIXAINES": "SIXAINE, (French) a stanza of six lines, also SIXAIN [n]\n",
  "SIXAINS": "SIXAIN, (French) a stanza of six lines, also SIXAINE [n]\n",
  "SIXER": "anything counting for six [n -S]\n",
  "SIXERS": "SIXER, anything counting for six [n]\n",
  "SIXES": "SIX, a number [n]\n",
  "SIXFOLD": "being six times as great as [adj]\n",
  "SIXISH": "around six years of age [adj]\n",
  "SIXMO": "a paper size, also SEXTO [n -S]\n",
  "SIXMOS": "SIXMO, a paper size, also SEXTO [n]\n",
  "SIXPENCE": "an obsolete British coin worth six pence [n -S]\n",
  "SIXPENCES": "SIXPENCE, an obsolete British coin worth six pence [n]\n",
  "SIXPENNIES": "SIXPENNY, a coin worth six pence [n]\n",
  "SIXPENNY": "a coin worth six pence [n SIXPENNIES]\n",
  "SIXSCORE": "one hundred and twenty [n -S]\n",
  "SIXSCORES": "SIXSCORE, one hundred and twenty [n]\n",
  "SIXTE": "(French) a position in fencing [n -S]\n",
  "SIXTEEN": "a number [n -S]\n",
  "SIXTEENER": "a verse of sixteen syllables [n -S]\n",
  "SIXTEENERS": "SIXTEENER, a verse of sixteen syllables [n]\n",
  "SIXTEENMO": "a book size 5 5/8 in. x 4 3/8 in. (abbreviated as 16mo.), also SEXTODECIMO [n -S]\n",
  "SIXTEENMOS": "SIXTEENMO, a book size 5 5/8 in. x 4 3/8 in. (abbreviated as 16mo.), also SEXTODECIMO [n]\n",
  "SIXTEENS": "SIXTEEN, a number [n]\n",
  "SIXTEENTH": "number sixteen in sequence [adj SIXTEENTHLY] / the sixteenth part of something [n -S]\n",
  "SIXTEENTHLY": "SIXTEENTH, number sixteen in sequence [adv]\n",
  "SIXTEENTHS": "SIXTEENTH, the sixteenth part of something [n]\n",
  "SIXTES": "SIXTE, (French) a position in fencing [n]\n",
  "SIXTH": "number six in sequence [adj SIXTHLY] / one of six equal parts [n -S]\n",
  "SIXTHLY": "SIXTH, number six in sequence [adv]\n",
  "SIXTHS": "SIXTH, one of six equal parts [n]\n",
  "SIXTIES": "SIXTY, a number [n]\n",
  "SIXTIETH": "one of sixty equal parts [n -S]\n",
  "SIXTIETHS": "SIXTIETH, one of sixty equal parts [n]\n",
  "SIXTY": "a number [n SIXTIES]\n",
  "SIXTYFOLD": "multiplied by sixty [adj]\n",
  "SIXTYISH": "being about sixty years old [adj]\n",
  "SIZABLE": "of considerable size [adj SIZABLY]\n",
  "SIZABLENESS": "the state of being sizable, also SIZEABLENESS [n -ES]\n",
  "SIZABLENESSES": "SIZABLENESS, the state of being sizable, also SIZEABLENESS [n]\n",
  "SIZABLY": "SIZABLE, of considerable size [adv]\n",
  "SIZAR": "a British student who receives financial assistance, also SIZER [n -S]\n",
  "SIZARS": "SIZAR, a British student who receives financial assistance, also SIZER [n]\n",
  "SIZARSHIP": "the position or standing of a sizar [n -S]\n",
  "SIZARSHIPS": "SIZARSHIP, the position or standing of a sizar [n]\n",
  "SIZE": "to cover with a weak gluey material [v SIZED, SIZING, SIZES]\n",
  "SIZEABLE": "quite large, also SIZABLE [adj SIZEABLY]\n",
  "SIZEABLENESS": "the state of being sizeable, also SIZABLENESS [n -ES]\n",
  "SIZEABLENESSES": "SIZEABLENESS, the state of being sizeable, also SIZABLENESS [n]\n",
  "SIZEABLY": "SIZEABLE, quite large, also SIZABLE [adv]\n",
  "SIZED": "SIZE, to cover with a weak gluey material [v]\n",
  "SIZEISM": "prejudice against people on account of their size, also SIZISM [n -S]\n",
  "SIZEISMS": "SIZEISM, prejudice against people on account of their size, also SIZISM [n]\n",
  "SIZEIST": "one who believes in sizeism, also SIZIST [n -S]\n",
  "SIZEISTS": "SIZEIST, one who believes in sizeism, also SIZIST [n]\n",
  "SIZEL": "metal clippings; scrap metal, also SCISSEL, SCISSIL [n -S]\n",
  "SIZELS": "SIZEL, metal clippings; scrap metal, also SCISSEL, SCISSIL [n]\n",
  "SIZER": "a student at Cambridge and Dublin, who, having passed a certain examination, is exempted from paying college fees and charges, also SIZAR [n -S]\n",
  "SIZERS": "SIZER, a student at Cambridge and Dublin, who, having passed a certain examination, is exempted from paying college fees and charges, also SIZAR [n]\n",
  "SIZES": "SIZE, to cover with a weak gluey material [v]\n",
  "SIZIER": "SIZY, pertaining to size, in sense of a weak glue [adj]\n",
  "SIZIEST": "SIZY, pertaining to size, in sense of a weak glue [adj]\n",
  "SIZINESS": "the state of resembling size, being glutinous [n -ES]\n",
  "SIZINESSES": "SIZINESS, the state of resembling size, being glutinous [n]\n",
  "SIZING": "the substance used as a filler for porous materials [n -S]\n",
  "SIZINGS": "SIZING, the substance used as a filler for porous materials [n]\n",
  "SIZISM": "prejudice against people on account of their size, also SIZEISM [n -S]\n",
  "SIZISMS": "SIZISM, prejudice against people on account of their size, also SIZEISM [n]\n",
  "SIZIST": "one who pays undue attention to size, also SIZEIST [n -S]\n",
  "SIZISTS": "SIZIST, one who pays undue attention to size, also SIZEIST [n]\n",
  "SIZY": "pertaining to size, in sense of a weak glue [adj SIZIER, SIZIEST]\n",
  "SIZZLE": "to fry with a hissing sound, also ZIZZLE [v SIZZLED, SIZZLING, SIZZLES]\n",
  "SIZZLED": "SIZZLE, to fry with a hissing sound, also ZIZZLE [v]\n",
  "SIZZLER": "a very hot day [n -S]\n",
  "SIZZLERS": "SIZZLER, a very hot day [n]\n",
  "SIZZLES": "SIZZLE, to fry with a hissing sound, also ZIZZLE [v]\n",
  "SIZZLING": "very hot [adj SIZZLINGLY] / the act of sizzling [n -S]\n",
  "SIZZLINGLY": "SIZZLING, very hot [adv]\n",
  "SIZZLINGS": "SIZZLING, the act of sizzling [n]\n",
  "SJAMBOK": "(South African) to beat with a rhinoceros-hide whip, also JAMBOK [v SJAMBOKED or SJAMBOKKED, SJAMBOKING or SJAMBOKKING, SJAMBOKS]\n",
  "SJAMBOKED": "SJAMBOK, (South African) to beat with a rhinoceros-hide whip, also JAMBOK [v]\n",
  "SJAMBOKING": "SJAMBOK, (South African) to beat with a rhinoceros-hide whip, also JAMBOK [v]\n",
  "SJAMBOKKED": "SJAMBOK, (South African) to beat with a rhinoceros-hide whip, also JAMBOK [v]\n",
  "SJAMBOKKING": "SJAMBOK, (South African) to beat with a rhinoceros-hide whip, also JAMBOK [v]\n",
  "SJAMBOKS": "SJAMBOK, (South African) to beat with a rhinoceros-hide whip, also JAMBOK [v]\n",
  "SJOE": "(South African) expressing surprise, admiration etc. [interj]\n",
  "SKA": "a form of Jamaican music similar to reggae [n -S]\n",
  "SKAG": "(US slang) heroin [n -S]\n",
  "SKAGS": "SKAG, (US slang) heroin [n]\n",
  "SKAIL": "(Scots) to disperse, scatter, also SCAIL [v -ED, -ING, -S]\n",
  "SKAILED": "SKAIL, (Scots) to disperse, scatter, also SCAIL [v]\n",
  "SKAILING": "SKAIL, (Scots) to disperse, scatter, also SCAIL [v]\n",
  "SKAILS": "SKAIL, (Scots) to disperse, scatter, also SCAIL [v]\n",
  "SKAITH": "(Old Norse) (obsolete) to injure, also SCAITH, SCATH, SCATHE [v -ED, -ING, -S]\n",
  "SKAITHED": "SKAITH, (Old Norse) (obsolete) to injure, also SCAITH, SCATH, SCATHE [v]\n",
  "SKAITHING": "SKAITH, (Old Norse) (obsolete) to injure, also SCAITH, SCATH, SCATHE [v]\n",
  "SKAITHLESS": "without skaith, scathe, i.e. unhurt, also SCAITHLESS, SCATHELESS [adj]\n",
  "SKAITHS": "SKAITH, (Old Norse) (obsolete) to injure, also SCAITH, SCATH, SCATHE [v]\n",
  "SKALD": "(Old Norse) an ancient Scandinavian poet [n -S]\n",
  "SKALDIC": "pertaining to an ancient Scandinavian poet, also SCALDIC [adj]\n",
  "SKALDS": "SKALD, (Old Norse) an ancient Scandinavian poet [n]\n",
  "SKALDSHIP": "the office of skald, an ancient Scandinavian bard, also SCALDSHIP [n -S]\n",
  "SKALDSHIPS": "SKALDSHIP, the office of skald, an ancient Scandinavian bard, also SCALDSHIP [n]\n",
  "SKANGER": "(Irish) a young working-class person who wears casual clothes [n -S]\n",
  "SKANGERS": "SKANGER, (Irish) a young working-class person who wears casual clothes [n]\n",
  "SKANK": "to dance to reggae music, lifting the knees in a rapid jerky movement [v -ED, -ING, -S]\n",
  "SKANKED": "SKANK, to dance to reggae music, lifting the knees in a rapid jerky movement [v]\n",
  "SKANKER": "one who skanks, dances to reggae music [n -S]\n",
  "SKANKERS": "SKANKER, one who skanks, dances to reggae music [n]\n",
  "SKANKIER": "SKANKY, filthy or sleazy [adj]\n",
  "SKANKIEST": "SKANKY, filthy or sleazy [adj]\n",
  "SKANKINESS": "the state of being skanky [n -ES]\n",
  "SKANKINESSES": "SKANKINESS, the state of being skanky [n]\n",
  "SKANKING": "the act of dancing to reggae music [n -S]\n",
  "SKANKINGS": "SKANKING, the act of dancing to reggae music [n]\n",
  "SKANKS": "SKANK, to dance to reggae music, lifting the knees in a rapid jerky movement [v]\n",
  "SKANKY": "filthy or sleazy [adj SKANKIER, SKANKIEST]\n",
  "SKART": "(Scots) a cormorant, also SCART, SCARTH, SKARTH [n -S]\n",
  "SKARTH": "(Scots) a cormorant, also SCART, SKART, SCARTH [n -S]\n",
  "SKARTHS": "SKARTH, (Scots) a cormorant, also SCART, SKART, SCARTH [n]\n",
  "SKARTS": "SKART, (Scots) a cormorant, also SCART, SCARTH, SKARTH [n]\n",
  "SKAS": "SKA, a form of Jamaican music similar to reggae [n]\n",
  "SKAT": "(historical) a tribute, a tax, esp. in Orkney and Shetland, also SCAT, SCATT [n -S]\n",
  "SKATE": "to glide over ice with blades or wheels [v SKATED, SKATING, SKATES]\n",
  "SKATEBOARD": "a narrow board made of wood, fibreglass, etc., mounted on small wheels [n -S] / to ride or perform stunts on a skateboard [v -ED, -ING, -S]\n",
  "SKATEBOARDED": "SKATEBOARD, to ride or perform stunts on a skateboard [v]\n",
  "SKATEBOARDER": "one who skateboards [n -S]\n",
  "SKATEBOARDERS": "SKATEBOARDER, one who skateboards [n]\n",
  "SKATEBOARDING": "the sport of riding or performing stunts on a skateboard [n -S]\n",
  "SKATEBOARDINGS": "SKATEBOARDING, the sport of riding or performing stunts on a skateboard [n]\n",
  "SKATEBOARDS": "SKATEBOARD, to ride or perform stunts on a skateboard [v]\n",
  "SKATED": "SKATE, to glide over ice with blades or wheels [v]\n",
  "SKATEPARK": "an area set aside for skateboarding [n -S]\n",
  "SKATEPARKS": "SKATEPARK, an area set aside for skateboarding [n]\n",
  "SKATEPUNK": "a participant in a skateboarding subculture [n -S]\n",
  "SKATEPUNKS": "SKATEPUNK, a participant in a skateboarding subculture [n]\n",
  "SKATER": "one who skates [n -S]\n",
  "SKATERS": "SKATER, one who skates [n]\n",
  "SKATES": "SKATE, to glide over ice with blades or wheels [v]\n",
  "SKATING": "the act of skating [n -S]\n",
  "SKATINGS": "SKATING, the act of skating [n]\n",
  "SKATOL": "(Greek) a crystalline compound found in faeces and coal tar, also SCATOLE, SKATOLE [n -S]\n",
  "SKATOLE": "(Greek) a crystalline compound found in faeces and coal tar, also SCATOLE, SKATOL [n -S]\n",
  "SKATOLES": "SKATOLE, (Greek) a crystalline compound found in faeces and coal tar, also SCATOLE, SKATOL [n]\n",
  "SKATOLS": "SKATOL, (Greek) a crystalline compound found in faeces and coal tar, also SCATOLE, SKATOLE [n]\n",
  "SKATS": "SKAT, (historical) a tribute, a tax, esp. in Orkney and Shetland, also SCAT, SCATT [n]\n",
  "SKATT": "(dialect) a sudden blow [n -S]\n",
  "SKATTS": "SKATT, (dialect) a sudden blow [n]\n",
  "SKAW": "a low cape or headland, also SCAW [n -S]\n",
  "SKAWS": "SKAW, a low cape or headland, also SCAW [n]\n",
  "SKEAN": "(Gaelic) a double-edged dagger used in Ireland and Scotland, also SKEEN, SKENE [n -S]\n",
  "SKEANE": "a length of yarn wound in a loose coil, also SKEIN [n -S]\n",
  "SKEANES": "SKEANE, a length of yarn wound in a loose coil, also SKEIN [n]\n",
  "SKEANS": "SKEAN, (Gaelic) a double-edged dagger used in Ireland and Scotland, also SKEEN, SKENE [n]\n",
  "SKEAR": "(dialect) to scare, also SKEER [v -ED, -ING, -S]\n",
  "SKEARED": "SKEAR, (dialect) to scare, also SKEER [v]\n",
  "SKEARIER": "SKEARY, (dialect) scary, also SKEERY [adj]\n",
  "SKEARIEST": "SKEARY, (dialect) scary, also SKEERY [adj]\n",
  "SKEARING": "SKEAR, (dialect) to scare, also SKEER [v]\n",
  "SKEARS": "SKEAR, (dialect) to scare, also SKEER [v]\n",
  "SKEARY": "(dialect) scary, also SKEERY [adj SKEARIER, SKEARIEST]\n",
  "SKED": "to schedule [v SKEDDED, SKEDDING, SKEDS]\n",
  "SKEDADDLE": "to run off hurriedly [v SKEDADDLED, SKEDADDLING, SKEDADDLES]\n",
  "SKEDADDLED": "SKEDADDLE, to run off hurriedly [v]\n",
  "SKEDADDLER": "one who skedaddles [n -S]\n",
  "SKEDADDLERS": "SKEDADDLER, one who skedaddles [n]\n",
  "SKEDADDLES": "SKEDADDLE, to run off hurriedly [v]\n",
  "SKEDADDLING": "SKEDADDLE, to run off hurriedly [v]\n",
  "SKEDDED": "SKED, to schedule [v]\n",
  "SKEDDING": "SKED, to schedule [v]\n",
  "SKEDS": "SKED, to schedule [v]\n",
  "SKEE": "to ski [v SKEED, SKEEING, SKEES]\n",
  "SKEECHAN": "(Gaelic) a kind of beer made by mixing malt liquor with treacle [n -S]\n",
  "SKEECHANS": "SKEECHAN, (Gaelic) a kind of beer made by mixing malt liquor with treacle [n]\n",
  "SKEED": "SKEE, to ski [v]\n",
  "SKEEF": "(South African) at an oblique angle [adj]\n",
  "SKEEING": "SKEE, to ski [v]\n",
  "SKEELIER": "SKEELY, (Scots) skilful [adj]\n",
  "SKEELIEST": "SKEELY, (Scots) skilful [adj]\n",
  "SKEELY": "(Scots) skilful [adj SKEELIER, SKEELIEST]\n",
  "SKEEN": "(Gaelic) a double-edged dagger used in Ireland and Scotland, also SKEAN, SKENE [n -S]\n",
  "SKEENS": "SKEEN, (Gaelic) a double-edged dagger used in Ireland and Scotland, also SKEAN, SKENE [n]\n",
  "SKEER": "(dialect) to scare, also SKEAR [v -ED, -ING, -S]\n",
  "SKEERED": "SKEER, (dialect) to scare, also SKEAR [v]\n",
  "SKEERIER": "SKEERY, (dialect) scary, also SKEARY [adj]\n",
  "SKEERIEST": "SKEERY, (dialect) scary, also SKEARY [adj]\n",
  "SKEERING": "SKEER, (dialect) to scare, also SKEAR [v]\n",
  "SKEERS": "SKEER, (dialect) to scare, also SKEAR [v]\n",
  "SKEERY": "(dialect) scary, also SKEARY [adj SKEERIER, SKEERIEST]\n",
  "SKEES": "SKEE, to ski [v]\n",
  "SKEESICKS": "(US) a rascal [n SKEESICKS]\n",
  "SKEET": "the sport of clay bird shooting [n -S]\n",
  "SKEETER": "a skeet shooter [n -S]\n",
  "SKEETERS": "SKEETER, a skeet shooter [n]\n",
  "SKEETS": "SKEET, the sport of clay bird shooting [n]\n",
  "SKEEVIER": "SKEEVY, repulsive, disgusting [adj]\n",
  "SKEEVIEST": "SKEEVY, repulsive, disgusting [adj]\n",
  "SKEEVY": "repulsive, disgusting [adj SKEEVIER, SKEEVIEST]\n",
  "SKEG": "a length of keel projecting aft to protect the rudder, also SKEGG [n -S]\n",
  "SKEGG": "a length of keel projecting aft to protect the rudder, also SKEG [n -S]\n",
  "SKEGGER": "a young salmon [n -S]\n",
  "SKEGGERS": "SKEGGER, a young salmon [n]\n",
  "SKEGGS": "SKEGG, a length of keel projecting aft to protect the rudder, also SKEG [n]\n",
  "SKEGS": "SKEG, a length of keel projecting aft to protect the rudder, also SKEGG [n]\n",
  "SKEIGH": "(Scots) (of a horse) skittish, spirited; (of a person, esp. a woman) shy, coy, disdainful, proud [adj SKEIGHER, SKEIGHEST]\n",
  "SKEIGHER": "SKEIGH, (Scots) (of a horse) skittish, spirited; (of a person, esp. a woman) shy, coy, disdainful, proud [adj]\n",
  "SKEIGHEST": "SKEIGH, (Scots) (of a horse) skittish, spirited; (of a person, esp. a woman) shy, coy, disdainful, proud [adj]\n",
  "SKEIN": "to wind into long, loose coils [v -ED, -ING, -S]\n",
  "SKEINED": "SKEIN, to wind into long, loose coils [v]\n",
  "SKEINING": "SKEIN, to wind into long, loose coils [v]\n",
  "SKEINS": "SKEIN, to wind into long, loose coils [v]\n",
  "SKELDER": "to beg; to swindle; to cheat [v -ED, -ING, -S]\n",
  "SKELDERED": "SKELDER, to beg; to swindle; to cheat [v]\n",
  "SKELDERING": "SKELDER, to beg; to swindle; to cheat [v]\n",
  "SKELDERS": "SKELDER, to beg; to swindle; to cheat [v]\n",
  "SKELETAL": "like a skeleton [adj SKELETALLY]\n",
  "SKELETALLY": "SKELETAL, like a skeleton [adv]\n",
  "SKELETOGENOUS": "producing a skeleton [adj]\n",
  "SKELETON": "the supporting bone structure of a body [n -S]\n",
  "SKELETONIC": "of or like a skeleton [adj]\n",
  "SKELETONISE": "to reduce to a skeleton, also SKELETONIZE [v SKELETONISED, SKELETONISING, SKELETONISES]\n",
  "SKELETONISED": "SKELETONISE, to reduce to a skeleton, also SKELETONIZE [v]\n",
  "SKELETONISER": "any of the larva of various moths that feed on leaves reducing them to skeletons, also SKELETONIZER [n -S]\n",
  "SKELETONISERS": "SKELETONISER, any of the larva of various moths that feed on leaves reducing them to skeletons, also SKELETONIZER [n]\n",
  "SKELETONISES": "SKELETONISE, to reduce to a skeleton, also SKELETONIZE [v]\n",
  "SKELETONISING": "SKELETONISE, to reduce to a skeleton, also SKELETONIZE [v]\n",
  "SKELETONIZE": "to reduce to a skeleton, also SKELETONISE [v SKELETONIZED, SKELETONIZING, SKELETONIZES]\n",
  "SKELETONIZED": "SKELETONIZE, to reduce to a skeleton, also SKELETONISE [v]\n",
  "SKELETONIZER": "any of the larva of various moths that feed on leaves reducing them to skeletons, also SKELETONISER [n -S]\n",
  "SKELETONIZERS": "SKELETONIZER, any of the larva of various moths that feed on leaves reducing them to skeletons, also SKELETONISER [n]\n",
  "SKELETONIZES": "SKELETONIZE, to reduce to a skeleton, also SKELETONISE [v]\n",
  "SKELETONIZING": "SKELETONIZE, to reduce to a skeleton, also SKELETONISE [v]\n",
  "SKELETONS": "SKELETON, the supporting bone structure of a body [n]\n",
  "SKELF": "(Scots) a splinter of wood, esp. one embedded in the skin [n -S]\n",
  "SKELFS": "SKELF, (Scots) a splinter of wood, esp. one embedded in the skin [n]\n",
  "SKELL": "(slang) a homeless person who lives on the streets [n -S]\n",
  "SKELLIE": "(Scots) to squint, also SKELLY [v SKELLIED, SKELLYING, SKELLIES]\n",
  "SKELLIED": "SKELLIE, (Scots) to squint, also SKELLY [v]\n",
  "SKELLIER": "SKELLY, cross-eyed, also SKELLIE [adj]\n",
  "SKELLIES": "SKELLIE, (Scots) to squint, also SKELLY [v]\n",
  "SKELLIEST": "SKELLY, cross-eyed, also SKELLIE [adj]\n",
  "SKELLOCH": "(Scots) to yell [v -ED, -ING, -S]\n",
  "SKELLOCHED": "SKELLOCH, (Scots) to yell [v]\n",
  "SKELLOCHING": "SKELLOCH, (Scots) to yell [v]\n",
  "SKELLOCHS": "SKELLOCH, (Scots) to yell [v]\n",
  "SKELLS": "SKELL, (slang) a homeless person who lives on the streets [n]\n",
  "SKELLUM": "(Scots) a scoundrel, rascal, also SCHELLUM, SCHELM, SKELM, SKELUM [n -S]\n",
  "SKELLUMS": "SKELLUM, (Scots) a scoundrel, rascal, also SCHELLUM, SCHELM, SKELM, SKELUM [n]\n",
  "SKELLY": "cross-eyed, also SKELLIE [adj SKELLIER, SKELLIEST] / to squint [v SKELLIED, SKELLYING, SKELLIES]\n",
  "SKELLYING": "SKELLY, to squint [v]\n",
  "SKELM": "(South African) a scoundrel, rascal, also SCHELLUM, SCHELM, SKELLUM, SKELUM [n -S]\n",
  "SKELMS": "SKELM, (South African) a scoundrel, rascal, also SCHELLUM, SCHELM, SKELLUM, SKELUM [n]\n",
  "SKELP": "(Gaelic) to hustle; to slap, strike [v SKELPED or SKELPIT, SKELPING, SKELPS]\n",
  "SKELPED": "SKELP, (Gaelic) to hustle; to slap, strike [v]\n",
  "SKELPING": "a slapping [n -S]\n",
  "SKELPINGS": "SKELPING, a slapping [n]\n",
  "SKELPIT": "SKELP, (Gaelic) to hustle; to slap, strike [v]\n",
  "SKELPS": "SKELP, (Gaelic) to hustle; to slap, strike [v]\n",
  "SKELTER": "to scurry [v -ED, -ING, -S]\n",
  "SKELTERED": "SKELTER, to scurry [v]\n",
  "SKELTERING": "SKELTER, to scurry [v]\n",
  "SKELTERS": "SKELTER, to scurry [v]\n",
  "SKELUM": "(Scots) a scoundrel, rascal, also SCHELLUM, SCHELM, SKELLUM, SKELM [n -S]\n",
  "SKELUMS": "SKELUM, (Scots) a scoundrel, rascal, also SCHELLUM, SCHELM, SKELLUM, SKELM [n]\n",
  "SKEN": "(Scots) to squint [v SKENNED, SKENNING, SKENS]\n",
  "SKENE": "(Gaelic) a double-edged dagger used in Ireland and Scotland, also SKEAN, SKEEN [n -S]\n",
  "SKENES": "SKENE, (Gaelic) a double-edged dagger used in Ireland and Scotland, also SKEAN, SKEEN [n]\n",
  "SKENNED": "SKEN, (Scots) to squint [v]\n",
  "SKENNING": "SKEN, (Scots) to squint [v]\n",
  "SKENS": "SKEN, (Scots) to squint [v]\n",
  "SKEO": "(Orkney) a hut, a shed, also SKIO [n -ES or -S]\n",
  "SKEOES": "SKEO, (Orkney) a hut, a shed, also SKIO [n]\n",
  "SKEOS": "SKEO, (Orkney) a hut, a shed, also SKIO [n]\n",
  "SKEP": "(Old Norse) to collect into a hive [v SKEPPED, SKEPPING, SKEPS]\n",
  "SKEPFUL": "the contents of a skep [n -S]\n",
  "SKEPFULS": "SKEPFUL, the contents of a skep [n]\n",
  "SKEPPED": "SKEP, (Old Norse) to collect into a hive [v]\n",
  "SKEPPING": "SKEP, (Old Norse) to collect into a hive [v]\n",
  "SKEPS": "SKEP, (Old Norse) to collect into a hive [v]\n",
  "SKEPSIS": "(Greek) philosophical doubt, also SCEPSIS [n -ES]\n",
  "SKEPSISES": "SKEPSIS, (Greek) philosophical doubt, also SCEPSIS [n]\n",
  "SKEPTIC": "a person who doubts generally accepted ideas, also SCEPTIC [n -S]\n",
  "SKEPTICAL": "inclined to questioning and disbelief, also SCEPTICAL [adj SKEPTICALLY]\n",
  "SKEPTICALLY": "SKEPTICAL, inclined to questioning and disbelief, also SCEPTICAL [adv]\n",
  "SKEPTICALNESS": "the state of being skeptical [n -ES]\n",
  "SKEPTICALNESSES": "SKEPTICALNESS, the state of being skeptical [n]\n",
  "SKEPTICISM": "an undecided, inquiring state of mind, also SCEPTICISM [n -S]\n",
  "SKEPTICISMS": "SKEPTICISM, an undecided, inquiring state of mind, also SCEPTICISM [n]\n",
  "SKEPTICS": "SKEPTIC, a person who doubts generally accepted ideas, also SCEPTIC [n]\n",
  "SKER": "to scour, search; to send skimming, also SCUR, SKIRR, SQUIRR [v SKERRED, SKERRING, SKERS]\n",
  "SKERRED": "SKER, to scour, search; to send skimming, also SCUR, SKIRR, SQUIRR [v]\n",
  "SKERRICK": "(Australian slang) a minute quantity, a scrap, as in 'not a skerrick' [n -S]\n",
  "SKERRICKS": "SKERRICK, (Australian slang) a minute quantity, a scrap, as in 'not a skerrick' [n]\n",
  "SKERRIES": "SKERRY, (Old Norse) a small, rocky island [n]\n",
  "SKERRING": "SKER, to scour, search; to send skimming, also SCUR, SKIRR, SQUIRR [v]\n",
  "SKERRY": "(Old Norse) a small, rocky island [n SKERRIES]\n",
  "SKERS": "SKER, to scour, search; to send skimming, also SCUR, SKIRR, SQUIRR [v]\n",
  "SKET": "(dialect) to splash (water) [v SKETTED, SKETTING, SKETS]\n",
  "SKETCH": "to make a rough, hasty drawing [v -ED, -ING, -ES]\n",
  "SKETCHABILITIES": "SKETCHABILITY, the quality of being sketchable [n]\n",
  "SKETCHABILITY": "the quality of being sketchable [n SKETCHABILITIES]\n",
  "SKETCHABLE": "that can be sketched [adj]\n",
  "SKETCHBOOK": "a book of or for sketches [n -S]\n",
  "SKETCHBOOKS": "SKETCHBOOK, a book of or for sketches [n]\n",
  "SKETCHED": "SKETCH, to make a rough, hasty drawing [v]\n",
  "SKETCHER": "one who sketches [n -S]\n",
  "SKETCHERS": "SKETCHER, one who sketches [n]\n",
  "SKETCHES": "SKETCH, to make a rough, hasty drawing [v]\n",
  "SKETCHIER": "SKETCHY, lacking in completeness or clearness [adj]\n",
  "SKETCHIEST": "SKETCHY, lacking in completeness or clearness [adj]\n",
  "SKETCHILY": "SKETCHY, lacking in completeness or clearness [adv]\n",
  "SKETCHINESS": "the state of being sketchy [n -ES]\n",
  "SKETCHINESSES": "SKETCHINESS, the state of being sketchy [n]\n",
  "SKETCHING": "SKETCH, to make a rough, hasty drawing [v]\n",
  "SKETCHPAD": "a pad of paper for sketching [n -S]\n",
  "SKETCHPADS": "SKETCHPAD, a pad of paper for sketching [n]\n",
  "SKETCHY": "lacking in completeness or clearness [adj SKETCHIER, SKETCHIEST, SKETCHILY]\n",
  "SKETS": "SKET, (dialect) to splash (water) [v]\n",
  "SKETTED": "SKET, (dialect) to splash (water) [v]\n",
  "SKETTING": "SKET, (dialect) to splash (water) [v]\n",
  "SKEUOMORPH": "a design feature copied from a similar artifact in another material, even when not functionally necessary e.g. the click sound of a shutter in an analog camera that is now reproduced in a digital camera by playing a sound clip [n -S]\n",
  "SKEUOMORPHIC": "of or like a skeuomorph [adj]\n",
  "SKEUOMORPHISM": "the state of being a skeuomorph [n -S]\n",
  "SKEUOMORPHISMS": "SKEUOMORPHISM, the state of being a skeuomorph [n]\n",
  "SKEUOMORPHS": "SKEUOMORPH, a design feature copied from a similar artifact in another material, even when not functionally necessary e.g. the click sound of a shutter in an analog camera that is now reproduced in a digital camera by playing a sound clip [n]\n",
  "SKEW": "oblique, biased [adj SKEWER, SKEWEST] / to make oblique [v -ED, -ING, -S]\n",
  "SKEWBACK": "a sloping surface against which the end of an arch rests [n -S]\n",
  "SKEWBACKED": "having a skewback, the part or inclined surface on which a segmented arch abuts [adj]\n",
  "SKEWBACKS": "SKEWBACK, a sloping surface against which the end of an arch rests [n]\n",
  "SKEWBALD": "a horse with brown and white patches [n -S]\n",
  "SKEWBALDS": "SKEWBALD, a horse with brown and white patches [n]\n",
  "SKEWED": "SKEW, to make oblique [v]\n",
  "SKEWER": "a long pin of wood or metal, esp. for holding pieces of meat together for cooking [n -S] / to pierce with or as with a skewer [v -ED, -ING, -S]\n",
  "SKEWERED": "SKEWER, to pierce with or as with a skewer [v]\n",
  "SKEWERING": "SKEWER, to pierce with or as with a skewer [v]\n",
  "SKEWERS": "SKEWER, to pierce with or as with a skewer [v]\n",
  "SKEWEST": "SKEW, oblique, biased [adj]\n",
  "SKEWING": "SKEW, to make oblique [v]\n",
  "SKEWNESS": "lack of symmetry [n -ES]\n",
  "SKEWNESSES": "SKEWNESS, lack of symmetry [n]\n",
  "SKEWS": "SKEW, to make oblique [v]\n",
  "SKEWWHIFF": "awry, askew [adj]\n",
  "SKI": "to travel over snow on narrow strips of wood, also SKEE [v -ED, -ING, -S]\n",
  "SKIABLE": "capable of being skied over [adj]\n",
  "SKIAGRAM": "a shadow picture or photograph [n -S]\n",
  "SKIAGRAMS": "SKIAGRAM, a shadow picture or photograph [n]\n",
  "SKIAGRAPH": "a shadow picture or photograph, e.g. an X-ray photograph [n -S]\n",
  "SKIAGRAPHS": "SKIAGRAPH, a shadow picture or photograph, e.g. an X-ray photograph [n]\n",
  "SKIAMACHIES": "SKIAMACHY, fighting with a shadow or an imaginary opponent, also SCIAMACHY, SCIOMACHY [n]\n",
  "SKIAMACHY": "fighting with a shadow or an imaginary opponent, also SCIAMACHY, SCIOMACHY [n SKIAMACHIES]\n",
  "SKIASCOPE": "a medical instrument for examining the eye to detect errors of refraction [n -S]\n",
  "SKIASCOPES": "SKIASCOPE, a medical instrument for examining the eye to detect errors of refraction [n]\n",
  "SKIASCOPIES": "SKIASCOPY, retinoscopy [n]\n",
  "SKIASCOPY": "retinoscopy [n SKIASCOPIES]\n",
  "SKIATRON": "a cathode-ray tube [n -S]\n",
  "SKIATRONS": "SKIATRON, a cathode-ray tube [n]\n",
  "SKIBOB": "to travel in a sleigh-type vehicle over snow [v SKIBOBBED, SKIBOBBING, SKIBOBS]\n",
  "SKIBOBBED": "SKIBOB, to travel in a sleigh-type vehicle over snow [v]\n",
  "SKIBOBBER": "one who rides a skibob [n -S]\n",
  "SKIBOBBERS": "SKIBOBBER, one who rides a skibob [n]\n",
  "SKIBOBBING": "the sport of riding a skibob [n -S]\n",
  "SKIBOBBINGS": "SKIBOBBING, the sport of riding a skibob [n]\n",
  "SKIBOBS": "SKIBOB, to travel in a sleigh-type vehicle over snow [v]\n",
  "SKID": "to slide on account of a loss of traction [v SKIDDED, SKIDDING, SKIDS]\n",
  "SKIDDED": "SKID, to slide on account of a loss of traction [v]\n",
  "SKIDDER": "a tractor with thick tyres used for hauling logs [n -S]\n",
  "SKIDDERS": "SKIDDER, a tractor with thick tyres used for hauling logs [n]\n",
  "SKIDDIER": "SKIDDY, likely to cause skidding [adj]\n",
  "SKIDDIEST": "SKIDDY, likely to cause skidding [adj]\n",
  "SKIDDING": "the act of making a skid [n -S]\n",
  "SKIDDINGS": "SKIDDING, the act of making a skid [n]\n",
  "SKIDDOO": "(tradename) a motorized sledge, fitted with tracks at the rear and steerable skis at the front [n -S] / to ride a skiddoo, also SKIDOO [v -ED, -ING, -S]\n",
  "SKIDDOOED": "SKIDDOO, to ride a skiddoo, also SKIDOO [v]\n",
  "SKIDDOOING": "SKIDDOO, to ride a skiddoo, also SKIDOO [v]\n",
  "SKIDDOOS": "SKIDDOO, to ride a skiddoo, also SKIDOO [v]\n",
  "SKIDDY": "likely to cause skidding [adj SKIDDIER, SKIDDIEST]\n",
  "SKIDLID": "(colloquial) a crash helmet [n -S]\n",
  "SKIDLIDS": "SKIDLID, (colloquial) a crash helmet [n]\n",
  "SKIDMARK": "the mark left by a skid [n -S]\n",
  "SKIDMARKS": "SKIDMARK, the mark left by a skid [n]\n",
  "SKIDOO": "(tradename) a motorized sledge, fitted with tracks at the rear and steerable skis at the front [n -S] / to ride a skidoo, also SKIDDOO [v -ED, -ING, -S]\n",
  "SKIDOOED": "SKIDOO, to ride a skidoo, also SKIDDOO [v]\n",
  "SKIDOOER": "one that rides on a snowmobile [n -S]\n",
  "SKIDOOERS": "SKIDOOER, one that rides on a snowmobile [n]\n",
  "SKIDOOING": "travel by skidoo [n -S]\n",
  "SKIDOOINGS": "SKIDOOING, travel by skidoo [n]\n",
  "SKIDOOS": "SKIDOO, to ride a skidoo, also SKIDDOO [v]\n",
  "SKIDPAD": "a road surface on which drivers can practice controlling skidding [n -S]\n",
  "SKIDPADS": "SKIDPAD, a road surface on which drivers can practice controlling skidding [n]\n",
  "SKIDPAN": "a track for trialling cars [n -S]\n",
  "SKIDPANS": "SKIDPAN, a track for trialling cars [n]\n",
  "SKIDPROOF": "of a road surface etc., designed to prevent skids [adj]\n",
  "SKIDS": "SKID, to slide on account of a loss of traction [v]\n",
  "SKIDWAY": "a platform on which logs are piled for sawing [n -S]\n",
  "SKIDWAYS": "SKIDWAY, a platform on which logs are piled for sawing [n]\n",
  "SKIED": "SKI, to travel over snow on narrow strips of wood, also SKEE [v]\n",
  "SKIER": "one who skis [n -S]\n",
  "SKIERS": "SKIER, one who skis [n]\n",
  "SKIES": "SKY, to hit or throw towards the upper atmosphere [v]\n",
  "SKIEY": "resembling the sky, also SKYEY [adj SKIEYER, SKIEYEST]\n",
  "SKIEYER": "SKIEY, resembling the sky, also SKYEY [adj]\n",
  "SKIEYEST": "SKIEY, resembling the sky, also SKYEY [adj]\n",
  "SKIFF": "to skim [v -ED, -ING, -S]\n",
  "SKIFFED": "SKIFF, to skim [v]\n",
  "SKIFFING": "SKIFF, to skim [v]\n",
  "SKIFFLE": "to play a particular style of music [v SKIFFLED, SKIFFLING, SKIFFLES]\n",
  "SKIFFLED": "SKIFFLE, to play a particular style of music [v]\n",
  "SKIFFLES": "SKIFFLE, to play a particular style of music [v]\n",
  "SKIFFLESS": "without a skiff [adj]\n",
  "SKIFFLING": "SKIFFLE, to play a particular style of music [v]\n",
  "SKIFFS": "SKIFF, to skim [v]\n",
  "SKIING": "the sport of travelling on skis [n -S]\n",
  "SKIINGS": "SKIING, the sport of travelling on skis [n]\n",
  "SKIJORER": "one who does skijoring, also SKIKJORER, SKIORER [n -S]\n",
  "SKIJORERS": "SKIJORER, one who does skijoring, also SKIKJORER, SKIORER [n]\n",
  "SKIJORING": "(Norwegian) the sport of being drawn on skis over snow by horse or motor, also SKIKJORING, SKIORING [n -S]\n",
  "SKIJORINGS": "SKIJORING, (Norwegian) the sport of being drawn on skis over snow by horse or motor, also SKIKJORING, SKIORING [n]\n",
  "SKIJUMPER": "one who engages in the sport of ski-jumping [n -S]\n",
  "SKIJUMPERS": "SKIJUMPER, one who engages in the sport of ski-jumping [n]\n",
  "SKIKJORER": "one who engages in the sport of skijoring, also SKIJORER, SKIORER [n -S]\n",
  "SKIKJORERS": "SKIKJORER, one who engages in the sport of skijoring, also SKIJORER, SKIORER [n]\n",
  "SKIKJORING": "(Norwegian) the sport of being drawn on skis over snow by horse or motor, also SKIJORING, SKIORING [n -S]\n",
  "SKIKJORINGS": "SKIKJORING, (Norwegian) the sport of being drawn on skis over snow by horse or motor, also SKIJORING, SKIORING [n]\n",
  "SKILFUL": "full of skill, also SKILFULL, SKILLFUL [adj SKILFULLY]\n",
  "SKILFULL": "full of skill, also SKILFUL, SKILLFUL [adj]\n",
  "SKILFULLY": "SKILFUL, full of skill, also SKILFULL, SKILLFUL [adv]\n",
  "SKILFULNESS": "the state of being skilful [n -ES]\n",
  "SKILFULNESSES": "SKILFULNESS, the state of being skilful [n]\n",
  "SKILL": "the ability to do something well [n -S] / to matter, to signify [v -ED, -ING, -S]\n",
  "SKILLCENTRE": "formerly in Britain, a Government-funded training establishment to assist those who wish to develop new occupational skills [n -S]\n",
  "SKILLCENTRES": "SKILLCENTRE, formerly in Britain, a Government-funded training establishment to assist those who wish to develop new occupational skills [n]\n",
  "SKILLED": "SKILL, to matter, to signify [v]\n",
  "SKILLESS": "without skill [adj]\n",
  "SKILLESSNESS": "the state of being without skills [n -ES]\n",
  "SKILLESSNESSES": "SKILLESSNESS, the state of being without skills [n]\n",
  "SKILLET": "a frying pan [n -S]\n",
  "SKILLETS": "SKILLET, a frying pan [n]\n",
  "SKILLFUL": "having skill, also SKILFUL, SKILLY [adj SKILLFULLY]\n",
  "SKILLFULLY": "SKILLFUL, having skill, also SKILFUL, SKILLY [adv]\n",
  "SKILLFULNESS": "(US) the state of being skillful [n -ES]\n",
  "SKILLFULNESSES": "SKILLFULNESS, (US) the state of being skillful [n]\n",
  "SKILLIER": "SKILLY, having skill, also SKILLFUL, SKILFUL [adj]\n",
  "SKILLIES": "SKILLY, a thin soup [n]\n",
  "SKILLIEST": "SKILLY, having skill, also SKILLFUL, SKILFUL [adj]\n",
  "SKILLIGALEE": "a thin gruel, also SKILLIGOLEE, SKILLY [n -S]\n",
  "SKILLIGALEES": "SKILLIGALEE, a thin gruel, also SKILLIGOLEE, SKILLY [n]\n",
  "SKILLIGOLEE": "a thin gruel, also SKILLIGALEE, SKILLY [n -S]\n",
  "SKILLIGOLEES": "SKILLIGOLEE, a thin gruel, also SKILLIGALEE, SKILLY [n]\n",
  "SKILLING": "(Danish) an obsolete coin of Scandinavian countries [n -S]\n",
  "SKILLINGS": "SKILLING, (Danish) an obsolete coin of Scandinavian countries [n]\n",
  "SKILLION": "(Australian) an outhouse or lean-to, esp. one with a sloping roof [n -S]\n",
  "SKILLIONS": "SKILLION, (Australian) an outhouse or lean-to, esp. one with a sloping roof [n]\n",
  "SKILLS": "SKILL, to matter, to signify [v]\n",
  "SKILLY": "having skill, also SKILLFUL, SKILFUL [adj SKILLIER, SKILLIEST] / a thin soup [n SKILLIES]\n",
  "SKIM": "to remove floating matter from the surface [v SKIMMED, SKIMMING, SKIMS]\n",
  "SKIMBOARD": "a type of surfboard shorter than normal and rounded at both ends [n -S] / to use a skimboard [v -ED, -ING, -S]\n",
  "SKIMBOARDED": "SKIMBOARD, to use a skimboard [v]\n",
  "SKIMBOARDER": "one who uses a skimboard, a type of surfboard [n -S]\n",
  "SKIMBOARDERS": "SKIMBOARDER, one who uses a skimboard, a type of surfboard [n]\n",
  "SKIMBOARDING": "SKIMBOARD, to use a skimboard [v]\n",
  "SKIMBOARDS": "SKIMBOARD, to use a skimboard [v]\n",
  "SKIMMED": "SKIM, to remove floating matter from the surface [v]\n",
  "SKIMMER": "a seabird that skims the water [n -S]\n",
  "SKIMMERS": "SKIMMER, a seabird that skims the water [n]\n",
  "SKIMMIA": "(Japanese) an Asiatic shrub with holly-like leaves and fragrant panicles of flowers [n -S]\n",
  "SKIMMIAS": "SKIMMIA, (Japanese) an Asiatic shrub with holly-like leaves and fragrant panicles of flowers [n]\n",
  "SKIMMING": "something that is skimmed from a liquid [n -S]\n",
  "SKIMMINGLY": "SKIMMING [adv]\n",
  "SKIMMINGS": "SKIMMING, something that is skimmed from a liquid [n]\n",
  "SKIMMINGTON": "in rural Britain, the old custom of forming a burlesque procession to ridicule an unfaithful husband or nagging wife [n -S]\n",
  "SKIMMINGTONS": "SKIMMINGTON, in rural Britain, the old custom of forming a burlesque procession to ridicule an unfaithful husband or nagging wife [n]\n",
  "SKIMO": "(Canadian) an offensive term for an Inuit [n -S]\n",
  "SKIMOBILE": "a motorized vehicle on skis, also SKIMO [n -S] / to travel by skimobile [v SKIMOBILED, SKIMOBILING, SKIMOBILES]\n",
  "SKIMOBILED": "SKIMOBILE, to travel by skimobile [v]\n",
  "SKIMOBILES": "SKIMOBILE, a motorized vehicle on skis, also SKIMO [n]\n",
  "SKIMOBILING": "SKIMOBILE, to travel by skimobile [v]\n",
  "SKIMOS": "SKIMO, (Canadian) an offensive term for an Inuit [n]\n",
  "SKIMP": "to scrimp [v -ED, -ING, -S]\n",
  "SKIMPED": "SKIMP, to scrimp [v]\n",
  "SKIMPIER": "SKIMPY, brief, exiguous [adj]\n",
  "SKIMPIEST": "SKIMPY, brief, exiguous [adj]\n",
  "SKIMPILY": "SKIMPY, brief, exiguous [adv]\n",
  "SKIMPINESS": "the state of being skimpy [n -ES]\n",
  "SKIMPINESSES": "SKIMPINESS, the state of being skimpy [n]\n",
  "SKIMPING": "SKIMP, to scrimp [v]\n",
  "SKIMPINGLY": "SKIMPING, SKIMP, to scrimp [adv]\n",
  "SKIMPS": "SKIMP, to scrimp [v]\n",
  "SKIMPY": "brief, exiguous [adj SKIMPIER, SKIMPIEST, SKIMPILY]\n",
  "SKIMS": "SKIM, to remove floating matter from the surface [v]\n",
  "SKIN": "to remove the natural outer covering of tissue or hide [v SKINNED, SKINNING, SKINS]\n",
  "SKINCARE": "care of the skin using cosmetics [n -S]\n",
  "SKINCARES": "SKINCARE, care of the skin using cosmetics [n]\n",
  "SKINFLICK": "a pornographic movie [n -S]\n",
  "SKINFLICKS": "SKINFLICK, a pornographic movie [n]\n",
  "SKINFLINT": "a miser; a niggard [n -S]\n",
  "SKINFLINTIER": "SKINFLINTY, stingy, like a skinflint [adj]\n",
  "SKINFLINTIEST": "SKINFLINTY, stingy, like a skinflint [adj]\n",
  "SKINFLINTS": "SKINFLINT, a miser; a niggard [n]\n",
  "SKINFLINTY": "stingy, like a skinflint [adj SKINFLINTIER, SKINFLINTIEST]\n",
  "SKINFOOD": "a cosmetic intended to nourish the skin [n -S]\n",
  "SKINFOODS": "SKINFOOD, a cosmetic intended to nourish the skin [n]\n",
  "SKINFUL": "as much as a skin container can hold [n -S]\n",
  "SKINFULS": "SKINFUL, as much as a skin container can hold [n]\n",
  "SKINHEAD": "one whose hair is cut very short [n -S]\n",
  "SKINHEADS": "SKINHEAD, one whose hair is cut very short [n]\n",
  "SKINK": "to pour out [v -ED, -ING, -S]\n",
  "SKINKED": "SKINK, to pour out [v]\n",
  "SKINKER": "one employed to dispense liquors in a bar, a tapster [n -S]\n",
  "SKINKERS": "SKINKER, one employed to dispense liquors in a bar, a tapster [n]\n",
  "SKINKING": "SKINK, to pour out [v]\n",
  "SKINKS": "SKINK, to pour out [v]\n",
  "SKINLESS": "without skin [adj]\n",
  "SKINLIKE": "like skin [adj]\n",
  "SKINNED": "SKIN, to remove the natural outer covering of tissue or hide [v]\n",
  "SKINNER": "one who skins [n -S]\n",
  "SKINNERS": "SKINNER, one who skins [n]\n",
  "SKINNIER": "SKINNY, having little fat [adj]\n",
  "SKINNIES": "SKINNY, information, as in 'give me the skinny' [n]\n",
  "SKINNIEST": "SKINNY, having little fat [adj]\n",
  "SKINNINESS": "the state of being skinny [n -ES]\n",
  "SKINNINESSES": "SKINNINESS, the state of being skinny [n]\n",
  "SKINNING": "SKIN, to remove the natural outer covering of tissue or hide [v]\n",
  "SKINNY": "having little fat [adj SKINNIER, SKINNIEST] / information, as in 'give me the skinny' [n SKINNIES]\n",
  "SKINS": "SKIN, to remove the natural outer covering of tissue or hide [v]\n",
  "SKINSUIT": "a one-piece skintight garment worn by cyclists, athletes, etc. [n -S]\n",
  "SKINSUITS": "SKINSUIT, a one-piece skintight garment worn by cyclists, athletes, etc. [n]\n",
  "SKINT": "having no money [adj SKINTER, SKINTEST]\n",
  "SKINTER": "SKINT, having no money [adj]\n",
  "SKINTEST": "SKINT, having no money [adj]\n",
  "SKINTIGHT": "fitting the body closely like a skin [adj SKINTIGHTER, SKINTIGHTEST]\n",
  "SKINTIGHTER": "SKINTIGHT, fitting the body closely like a skin [adj]\n",
  "SKINTIGHTEST": "SKINTIGHT, fitting the body closely like a skin [adj]\n",
  "SKINTIGHTS": "close-fitting garments [n]\n",
  "SKIO": "(Orkney) a hut, a shed, also SKEO [n -ES or -S]\n",
  "SKIOES": "SKIO, (Orkney) a hut, a shed, also SKEO [n]\n",
  "SKIORER": "one who engages in the sport of skijoring, also SKIJORER [n -S]\n",
  "SKIORERS": "SKIORER, one who engages in the sport of skijoring, also SKIJORER [n]\n",
  "SKIORING": "(Norwegian) the sport of being drawn on skis over snow by horse or motor, also SKIJORING, SKIKJORING [n -S]\n",
  "SKIORINGS": "SKIORING, (Norwegian) the sport of being drawn on skis over snow by horse or motor, also SKIJORING, SKIKJORING [n]\n",
  "SKIOS": "SKIO, (Orkney) a hut, a shed, also SKEO [n]\n",
  "SKIP": "to move with light springing steps [v SKIPPED, SKIPPING, SKIPS]\n",
  "SKIPJACK": "a fish that swims near the surface, such as the skipjack tuna [n -S]\n",
  "SKIPJACKS": "SKIPJACK, a fish that swims near the surface, such as the skipjack tuna [n]\n",
  "SKIPLANE": "a plane designed for landing on snow [n -S]\n",
  "SKIPLANES": "SKIPLANE, a plane designed for landing on snow [n]\n",
  "SKIPPABLE": "that can be skipped [adj]\n",
  "SKIPPED": "SKIP, to move with light springing steps [v]\n",
  "SKIPPER": "to act as master or captain [v -ED, -ING, -S]\n",
  "SKIPPERED": "SKIPPER, to act as master or captain [v]\n",
  "SKIPPERING": "the act of sleeping rough [n -S]\n",
  "SKIPPERINGS": "SKIPPERING, the act of sleeping rough [n]\n",
  "SKIPPERS": "SKIPPER, to act as master or captain [v]\n",
  "SKIPPET": "a small box for protecting an official seal [n -S]\n",
  "SKIPPETS": "SKIPPET, a small box for protecting an official seal [n]\n",
  "SKIPPIER": "SKIPPY, frolicsome [adj]\n",
  "SKIPPIEST": "SKIPPY, frolicsome [adj]\n",
  "SKIPPING": "flighty, giddy [adj SKIPPINGLY] / the act of skipping [n -S]\n",
  "SKIPPINGLY": "SKIPPING, flighty, giddy [adv]\n",
  "SKIPPINGS": "SKIPPING, the act of skipping [n]\n",
  "SKIPPY": "frolicsome [adj SKIPPIER, SKIPPIEST]\n",
  "SKIPS": "SKIP, to move with light springing steps [v]\n",
  "SKIRL": "to produce a shrill sound [v -ED, -ING, -S]\n",
  "SKIRLED": "SKIRL, to produce a shrill sound [v]\n",
  "SKIRLING": "a shrill sound [n -S]\n",
  "SKIRLINGS": "SKIRLING, a shrill sound [n]\n",
  "SKIRLS": "SKIRL, to produce a shrill sound [v]\n",
  "SKIRMISH": "to engage in a minor battle [v -ED, -ING, -ES]\n",
  "SKIRMISHED": "SKIRMISH, to engage in a minor battle [v]\n",
  "SKIRMISHER": "one who skirmishes [n -S]\n",
  "SKIRMISHERS": "SKIRMISHER, one who skirmishes [n]\n",
  "SKIRMISHES": "SKIRMISH, to engage in a minor battle [v]\n",
  "SKIRMISHING": "the act of skirmishing [n -S]\n",
  "SKIRMISHINGS": "SKIRMISHING, the act of skirmishing [n]\n",
  "SKIRR": "to scour, search; to send skimming, also SCUR, SKER, SQUIRR [v -ED, -ING, -S]\n",
  "SKIRRED": "SKIRR, to scour, search; to send skimming, also SCUR, SKER, SQUIRR [v]\n",
  "SKIRRET": "a water parsnip with edible roots [n -S]\n",
  "SKIRRETS": "SKIRRET, a water parsnip with edible roots [n]\n",
  "SKIRRING": "SKIRR, to scour, search; to send skimming, also SCUR, SKER, SQUIRR [v]\n",
  "SKIRRS": "SKIRR, to scour, search; to send skimming, also SCUR, SKER, SQUIRR [v]\n",
  "SKIRT": "to pass along the border [v -ED, -ING, -S]\n",
  "SKIRTED": "SKIRT, to pass along the border [v]\n",
  "SKIRTER": "someone who removes skirts from fleeces; a huntsman who dodges jumps [n -S]\n",
  "SKIRTERS": "SKIRTER, someone who removes skirts from fleeces; a huntsman who dodges jumps [n]\n",
  "SKIRTING": "the board at the base of a wall [n -S]\n",
  "SKIRTINGS": "SKIRTING, the board at the base of a wall [n]\n",
  "SKIRTLESS": "without a skirt [adj]\n",
  "SKIRTLIKE": "like a skirt [adj]\n",
  "SKIRTS": "SKIRT, to pass along the border [v]\n",
  "SKIS": "SKI, to travel over snow on narrow strips of wood, also SKEE [v]\n",
  "SKIT": "a short satirical sketch in dramatic form [n -S]\n",
  "SKITCH": "(New Zealand) of a dog, to catch [v -ED, -ING, -ES]\n",
  "SKITCHED": "SKITCH, (New Zealand) of a dog, to catch [v]\n",
  "SKITCHES": "SKITCH, (New Zealand) of a dog, to catch [v]\n",
  "SKITCHING": "SKITCH, (New Zealand) of a dog, to catch [v]\n",
  "SKITE": "(Australian slang) to boast [v SKITED, SKITING, SKITES]\n",
  "SKITED": "SKITE, (Australian slang) to boast [v]\n",
  "SKITES": "SKITE, (Australian slang) to boast [v]\n",
  "SKITING": "SKITE, (Australian slang) to boast [v]\n",
  "SKITS": "SKIT, a short satirical sketch in dramatic form [n]\n",
  "SKITTER": "to skim over the surface of water [v -ED, -ING, -S]\n",
  "SKITTERED": "SKITTER, to skim over the surface of water [v]\n",
  "SKITTERIER": "SKITTERY, darting about [adj]\n",
  "SKITTERIEST": "SKITTERY, darting about [adj]\n",
  "SKITTERING": "SKITTER, to skim over the surface of water [v]\n",
  "SKITTERS": "SKITTER, to skim over the surface of water [v]\n",
  "SKITTERY": "darting about [adj SKITTERIER, SKITTERIEST]\n",
  "SKITTISH": "easily frightened [adj SKITTISHLY]\n",
  "SKITTISHLY": "SKITTISH, easily frightened [adv]\n",
  "SKITTISHNESS": "the state of being skittish [n -ES]\n",
  "SKITTISHNESSES": "SKITTISHNESS, the state of being skittish [n]\n",
  "SKITTLE": "to knock down [v SKITTLED, SKITTLING, SKITTLES]\n",
  "SKITTLED": "SKITTLE, to knock down [v]\n",
  "SKITTLES": "SKITTLE, to knock down [v]\n",
  "SKITTLING": "SKITTLE, to knock down [v]\n",
  "SKIVE": "to pare or split leather [v SKIVED, SKIVING, SKIVES]\n",
  "SKIVED": "SKIVE, to pare or split leather [v]\n",
  "SKIVER": "(dialect) to skewer [v -ED, -ING, -S]\n",
  "SKIVERED": "SKIVER, (dialect) to skewer [v]\n",
  "SKIVERING": "SKIVER, (dialect) to skewer [v]\n",
  "SKIVERS": "SKIVER, (dialect) to skewer [v]\n",
  "SKIVES": "SKIVE, to pare or split leather [v]\n",
  "SKIVIE": "(Scots) deranged, askew [adj]\n",
  "SKIVIER": "SKIVIE, (Scots) deranged, askew [adj]\n",
  "SKIVIEST": "SKIVIE, (Scots) deranged, askew [adj]\n",
  "SKIVING": "the act of splitting leather [n -S]\n",
  "SKIVINGS": "SKIVING, the act of splitting leather [n]\n",
  "SKIVVIED": "SKIVVY, to work as a female servant [v]\n",
  "SKIVVIES": "SKIVVY, to work as a female servant [v]\n",
  "SKIVVY": "to work as a female servant [v SKIVVIED, SKIVVYING, SKIVVIES]\n",
  "SKIVVYING": "SKIVVY, to work as a female servant [v]\n",
  "SKIVY": "inclined to slack off [adj SKIVIER, SKIVIEST]\n",
  "SKIWEAR": "clothes for skiing [n -S]\n",
  "SKIWEARS": "SKIWEAR, clothes for skiing [n]\n",
  "SKLATE": "(Scots) to cover with slate [v SKLATED, SKLATING, SKLATES]\n",
  "SKLATED": "SKLATE, (Scots) to cover with slate [v]\n",
  "SKLATES": "SKLATE, (Scots) to cover with slate [v]\n",
  "SKLATING": "SKLATE, (Scots) to cover with slate [v]\n",
  "SKLENT": "(Scots) to slant [v -ED, -ING, -S]\n",
  "SKLENTED": "SKLENT, (Scots) to slant [v]\n",
  "SKLENTING": "SKLENT, (Scots) to slant [v]\n",
  "SKLENTS": "SKLENT, (Scots) to slant [v]\n",
  "SKLIFF": "(Scots) to shuffle (the feet), also SCLIFF [v -ED, -ING, -S]\n",
  "SKLIFFED": "SKLIFF, (Scots) to shuffle (the feet), also SCLIFF [v]\n",
  "SKLIFFING": "SKLIFF, (Scots) to shuffle (the feet), also SCLIFF [v]\n",
  "SKLIFFS": "SKLIFF, (Scots) to shuffle (the feet), also SCLIFF [v]\n",
  "SKLIM": "(Scots) to climb, also SCLIM [v SKLIMMED, SKLIMMING, SKLIMS]\n",
  "SKLIMMED": "SKLIM, (Scots) to climb, also SCLIM [v]\n",
  "SKLIMMING": "SKLIM, (Scots) to climb, also SCLIM [v]\n",
  "SKLIMS": "SKLIM, (Scots) to climb, also SCLIM [v]\n",
  "SKOAL": "(Old Norse) to down a drink in one gulp, also SKOL [v -ED, -ING, -S]\n",
  "SKOALED": "SKOAL, (Old Norse) to down a drink in one gulp, also SKOL [v]\n",
  "SKOALING": "SKOAL, (Old Norse) to down a drink in one gulp, also SKOL [v]\n",
  "SKOALS": "SKOAL, (Old Norse) to down a drink in one gulp, also SKOL [v]\n",
  "SKODIER": "SKODY, dirty, unkempt, also SCODY [adj]\n",
  "SKODIEST": "SKODY, dirty, unkempt, also SCODY [adj]\n",
  "SKODY": "dirty, unkempt, also SCODY [adj SKODIER, SKODIEST]\n",
  "SKOFF": "to devour; to plunder, also SCOFF [v -ED, -ING, -S]\n",
  "SKOFFED": "SKOFF, to devour; to plunder, also SCOFF [v]\n",
  "SKOFFING": "SKOFF, to devour; to plunder, also SCOFF [v]\n",
  "SKOFFS": "SKOFF, to devour; to plunder, also SCOFF [v]\n",
  "SKOG": "to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKUG [v SKOGGED, SKOGGING, SKOGS]\n",
  "SKOGGED": "SKOG, to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKUG [v]\n",
  "SKOGGING": "SKOG, to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKUG [v]\n",
  "SKOGS": "SKOG, to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKUG [v]\n",
  "SKOKIAAN": "(South African) a strong home-brewed alcoholic liquor fermented with yeast [n -S]\n",
  "SKOKIAANS": "SKOKIAAN, (South African) a strong home-brewed alcoholic liquor fermented with yeast [n]\n",
  "SKOL": "(Old Norse) to down a drink in one go as a toast, also SKOAL [v SKOLLED or SKOLED, SKOLING or SKOLLING, SKOLS]\n",
  "SKOLED": "SKOL, (Old Norse) to down a drink in one go as a toast, also SKOAL [v]\n",
  "SKOLIA": "SKOLION, (Greek) a Greek drinking song, also SCOLION [n]\n",
  "SKOLING": "SKOL, (Old Norse) to down a drink in one go as a toast, also SKOAL [v]\n",
  "SKOLION": "(Greek) a Greek drinking song, also SCOLION [n SKOLIA]\n",
  "SKOLLED": "SKOL, (Old Norse) to down a drink in one go as a toast, also SKOAL [v]\n",
  "SKOLLIE": "(South African) a coloured hooligan, also SKOLLY [n -S]\n",
  "SKOLLIES": "SKOLLIE, (South African) a coloured hooligan, also SKOLLY [n]\n",
  "SKOLLING": "SKOL, (Old Norse) to down a drink in one go as a toast, also SKOAL [v]\n",
  "SKOLLY": "(South African) a coloured hooligan, also SKOLLIE [n SKOLLIES]\n",
  "SKOLS": "SKOL, (Old Norse) to down a drink in one go as a toast, also SKOAL [v]\n",
  "SKOOKUM": "(Native American) an evil spirit [n -S]\n",
  "SKOOKUMS": "SKOOKUM, (Native American) an evil spirit [n]\n",
  "SKOOL": "(colloquial) school [n -S]\n",
  "SKOOLS": "SKOOL, (colloquial) school [n]\n",
  "SKOOSH": "(Scots) to squirt, spurt, also SCOOSH [v -ED, -ING, -ES]\n",
  "SKOOSHED": "SKOOSH, (Scots) to squirt, spurt, also SCOOSH [v]\n",
  "SKOOSHES": "SKOOSH, (Scots) to squirt, spurt, also SCOOSH [v]\n",
  "SKOOSHING": "SKOOSH, (Scots) to squirt, spurt, also SCOOSH [v]\n",
  "SKORDALIA": "(Greek) a dip of cold whipped potatoes and garlic served with pita bread [n -S]\n",
  "SKORDALIAS": "SKORDALIA, (Greek) a dip of cold whipped potatoes and garlic served with pita bread [n]\n",
  "SKORT": "a pair of shorts with a front panel that gives the appearance of a skirt [n -S]\n",
  "SKORTS": "SKORT, a pair of shorts with a front panel that gives the appearance of a skirt [n]\n",
  "SKOSH": "(Japanese) a small amount [n -ES]\n",
  "SKOSHES": "SKOSH, (Japanese) a small amount [n]\n",
  "SKRAN": "(slang) food, provision, also SCRAN [n -S]\n",
  "SKRANS": "SKRAN, (slang) food, provision, also SCRAN [n]\n",
  "SKREEGH": "(Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREIGH, SKRIECH, SKRIEGH [v -ED, -ING, -S]\n",
  "SKREEGHED": "SKREEGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SKREEGHING": "SKREEGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SKREEGHS": "SKREEGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREIGH, SKRIECH, SKRIEGH [v]\n",
  "SKREEN": "a screen, esp. in the sense of a partition of wood or stone, also SCRIENE [n -S]\n",
  "SKREENS": "SKREEN, a screen, esp. in the sense of a partition of wood or stone, also SCRIENE [n]\n",
  "SKREIGH": "(Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKRIECH, SKRIEGH [v -ED, -ING, -S]\n",
  "SKREIGHED": "SKREIGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKRIECH, SKRIEGH [v]\n",
  "SKREIGHING": "SKREIGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKRIECH, SKRIEGH [v]\n",
  "SKREIGHS": "SKREIGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKRIECH, SKRIEGH [v]\n",
  "SKRIECH": "(Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIEGH [v -ED, -ING, -S]\n",
  "SKRIECHED": "SKRIECH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIEGH [v]\n",
  "SKRIECHING": "SKRIECH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIEGH [v]\n",
  "SKRIECHS": "SKRIECH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIEGH [v]\n",
  "SKRIED": "SKRY, to see the future e.g. via a crystal ball, also SCRY [v]\n",
  "SKRIEGH": "(Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH [v -ED, -ING, -S]\n",
  "SKRIEGHED": "SKRIEGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH [v]\n",
  "SKRIEGHING": "SKRIEGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH [v]\n",
  "SKRIEGHS": "SKRIEGH, (Scots) to screech, shriek, also SCRAICH, SCRAIGH, SCREICH, SCREIGH, SCRIECH, SCRITCH, SKREEGH, SKREIGH, SKRIECH [v]\n",
  "SKRIES": "SKRY, to see the future e.g. via a crystal ball, also SCRY [v]\n",
  "SKRIK": "(South African) a fright [n -S]\n",
  "SKRIKE": "(dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH [v SKRIKED, SKRIKING, SKRIKES]\n",
  "SKRIKED": "SKRIKE, (dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH [v]\n",
  "SKRIKES": "SKRIKE, (dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH [v]\n",
  "SKRIKING": "SKRIKE, (dialect) to shriek, also SCRIKE, SHREEK, SHREIK, SHRIECH, SHRIKE, SHRITCH [v]\n",
  "SKRIKS": "SKRIK, (South African) a fright [n]\n",
  "SKRIMMAGE": "a noisy dispute or tussle; a rough or confused struggle [n -S] / to scuffle, also SCRIMMAGE, SCRUMMAGE [v SKRIMMAGED, SKRIMMAGING, SKRIMMAGES]\n",
  "SKRIMMAGED": "SKRIMMAGE, to scuffle, also SCRIMMAGE, SCRUMMAGE [v]\n",
  "SKRIMMAGES": "SKRIMMAGE, to scuffle, also SCRIMMAGE, SCRUMMAGE [v]\n",
  "SKRIMMAGING": "SKRIMMAGE, to scuffle, also SCRIMMAGE, SCRUMMAGE [v]\n",
  "SKRIMP": "to scratch and save, also SCRIMP [v -ED, -ING, -S]\n",
  "SKRIMPED": "SKRIMP, to scratch and save, also SCRIMP [v]\n",
  "SKRIMPING": "SKRIMP, to scratch and save, also SCRIMP [v]\n",
  "SKRIMPS": "SKRIMP, to scratch and save, also SCRIMP [v]\n",
  "SKRIMSHANK": "to evade work or duty, also SCRIMSHANK [v -ED, -ING, -S]\n",
  "SKRIMSHANKED": "SKRIMSHANK, to evade work or duty, also SCRIMSHANK [v]\n",
  "SKRIMSHANKER": "one who evades work or duty, also SCRIMSHANKER [n -S]\n",
  "SKRIMSHANKERS": "SKRIMSHANKER, one who evades work or duty, also SCRIMSHANKER [n]\n",
  "SKRIMSHANKING": "SKRIMSHANK, to evade work or duty, also SCRIMSHANK [v]\n",
  "SKRIMSHANKS": "SKRIMSHANK, to evade work or duty, also SCRIMSHANK [v]\n",
  "SKRONK": "music that is grating, dissonant, and frequently avant-garde [n -S]\n",
  "SKRONKS": "SKRONK, music that is grating, dissonant, and frequently avant-garde [n]\n",
  "SKRUMP": "(colloquial) to steal fruit (esp. apples) from trees, also SCRUMP [v -ED, -ING, -S]\n",
  "SKRUMPED": "SKRUMP, (colloquial) to steal fruit (esp. apples) from trees, also SCRUMP [v]\n",
  "SKRUMPING": "SKRUMP, (colloquial) to steal fruit (esp. apples) from trees, also SCRUMP [v]\n",
  "SKRUMPS": "SKRUMP, (colloquial) to steal fruit (esp. apples) from trees, also SCRUMP [v]\n",
  "SKRY": "to see the future e.g. via a crystal ball, also SCRY [v SKRIED, SKRYING, SKRIES]\n",
  "SKRYER": "one who scries in a crystal ball, also SCRYER [n -S]\n",
  "SKRYERS": "SKRYER, one who scries in a crystal ball, also SCRYER [n]\n",
  "SKRYING": "SKRY, to see the future e.g. via a crystal ball, also SCRY [v]\n",
  "SKUA": "a predatory gull-like seabird [n -S]\n",
  "SKUAS": "SKUA, a predatory gull-like seabird [n]\n",
  "SKUDLER": "in Shetland, the leader of a band of guisers, also SCUDDALER, SCUDLER [n -S]\n",
  "SKUDLERS": "SKUDLER, in Shetland, the leader of a band of guisers, also SCUDDALER, SCUDLER [n]\n",
  "SKUG": "(Scots) to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKOG [v SKUGGED, SKUGGING, SKUGS]\n",
  "SKUGGED": "SKUG, (Scots) to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKOG [v]\n",
  "SKUGGING": "SKUG, (Scots) to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKOG [v]\n",
  "SKUGS": "SKUG, (Scots) to shelter, also SCOG, SCOOG, SCOUG, SCUG, SKOG [v]\n",
  "SKULDUDDERIES": "SKULDUDDERY, (Scots) a breach of chastity; bawdy talk, also SCULDUDDERY, SCULDUDDRY [n]\n",
  "SKULDUDDERY": "(Scots) a breach of chastity; bawdy talk, also SCULDUDDERY, SCULDUDDRY [n SKULDUDDERIES]\n",
  "SKULDUGGERIES": "SKULDUGGERY, underhand dealing, trickery, also SCULDUGGERY, SKULLDUGGERY [n]\n",
  "SKULDUGGERY": "underhand dealing, trickery, also SCULDUGGERY, SKULLDUGGERY [n SKULDUGGERIES]\n",
  "SKULK": "to move about stealthily, also SCULK [v -ED, -ING, -S]\n",
  "SKULKED": "SKULK, to move about stealthily, also SCULK [v]\n",
  "SKULKER": "one that skulks, also SCULKER [n -S]\n",
  "SKULKERS": "SKULKER, one that skulks, also SCULKER [n]\n",
  "SKULKING": "the act of skulking [n -S]\n",
  "SKULKINGLY": "SKULKING [adv]\n",
  "SKULKINGS": "SKULKING, the act of skulking [n]\n",
  "SKULKS": "SKULK, to move about stealthily, also SCULK [v]\n",
  "SKULL": "the framework of the head [n -S] / to propel with a type of oar, also SCULL [v -ED, -ING, -S]\n",
  "SKULLCAP": "a close-fitting cap [n -S]\n",
  "SKULLCAPS": "SKULLCAP, a close-fitting cap [n]\n",
  "SKULLDUGGERIES": "SKULLDUGGERY, underhand dealing, trickery, also SCULDUGGERY, SKULDUGGERY [n]\n",
  "SKULLDUGGERY": "underhand dealing, trickery, also SCULDUGGERY, SKULDUGGERY [n SKULLDUGGERIES]\n",
  "SKULLED": "SKULL, to propel with a type of oar, also SCULL [v]\n",
  "SKULLING": "SKULL, to propel with a type of oar, also SCULL [v]\n",
  "SKULLS": "SKULL, to propel with a type of oar, also SCULL [v]\n",
  "SKULPIN": "a kind of fish, aka scorpion fish, also SCULPIN [n -S]\n",
  "SKULPINS": "SKULPIN, a kind of fish, aka scorpion fish, also SCULPIN [n]\n",
  "SKUMMER": "(archaic) to void excrement, also SCUMBER [v -ED, -ING, -S]\n",
  "SKUMMERED": "SKUMMER, (archaic) to void excrement, also SCUMBER [v]\n",
  "SKUMMERING": "SKUMMER, (archaic) to void excrement, also SCUMBER [v]\n",
  "SKUMMERS": "SKUMMER, (archaic) to void excrement, also SCUMBER [v]\n",
  "SKUNK": "a foul-smelling musteline mammal [n -S] / to defeat overwhelmingly [v -ED, -ING, -S]\n",
  "SKUNKBIRD": "an American bird, aka bobolink or ricebird [n -S]\n",
  "SKUNKBIRDS": "SKUNKBIRD, an American bird, aka bobolink or ricebird [n]\n",
  "SKUNKED": "SKUNK, to defeat overwhelmingly [v]\n",
  "SKUNKIER": "SKUNKY, having a smell suggestive of a skunk [adj]\n",
  "SKUNKIEST": "SKUNKY, having a smell suggestive of a skunk [adj]\n",
  "SKUNKING": "SKUNK, to defeat overwhelmingly [v]\n",
  "SKUNKS": "SKUNK, to defeat overwhelmingly [v]\n",
  "SKUNKWEED": "a low-growing fetid swamp plant of North America [n -S]\n",
  "SKUNKWEEDS": "SKUNKWEED, a low-growing fetid swamp plant of North America [n]\n",
  "SKUNKY": "having a smell suggestive of a skunk [adj SKUNKIER, SKUNKIEST]\n",
  "SKURRIED": "SKURRY, to move in a quick scuttling fashion, also SCURRY [v]\n",
  "SKURRIES": "SKURRY, to move in a quick scuttling fashion, also SCURRY [v]\n",
  "SKURRY": "to move in a quick scuttling fashion, also SCURRY [v SKURRIED, SKURRYING, SKURRIES]\n",
  "SKURRYING": "SKURRY, to move in a quick scuttling fashion, also SCURRY [v]\n",
  "SKUTTERUDITE": "a cubic mineral, cobalt arsenide [n -S]\n",
  "SKUTTERUDITES": "SKUTTERUDITE, a cubic mineral, cobalt arsenide [n]\n",
  "SKUTTLE": "to move or run with short steps, also SCUDDLE, SCUTTLE [v SKUTTLED, SKUTTLING, SKUTTLES]\n",
  "SKUTTLED": "SKUTTLE, to move or run with short steps, also SCUDDLE, SCUTTLE [v]\n",
  "SKUTTLES": "SKUTTLE, to move or run with short steps, also SCUDDLE, SCUTTLE [v]\n",
  "SKUTTLING": "SKUTTLE, to move or run with short steps, also SCUDDLE, SCUTTLE [v]\n",
  "SKY": "to hit or throw towards the upper atmosphere [v SKIED or SKYED, SKYING, SKIES]\n",
  "SKYBOARD": "a board with foot bindings that is used for skysurfing [n -S]\n",
  "SKYBOARDS": "SKYBOARD, a board with foot bindings that is used for skysurfing [n]\n",
  "SKYBORN": "of heavenly birth [adj]\n",
  "SKYBORNE": "airborne [adj]\n",
  "SKYBOX": "an enclosure of seats high in a stadium [n -ES]\n",
  "SKYBOXES": "SKYBOX, an enclosure of seats high in a stadium [n]\n",
  "SKYBRIDGE": "a covered elevated bridge connecting two buildings [n -S]\n",
  "SKYBRIDGES": "SKYBRIDGE, a covered elevated bridge connecting two buildings [n]\n",
  "SKYCAP": "a porter in an airport [n -S]\n",
  "SKYCAPS": "SKYCAP, a porter in an airport [n]\n",
  "SKYCLAD": "naked [adj]\n",
  "SKYDIVE": "to parachute from a plane as a sport [v SKYDOVE or SKYDIVED, SKYDIVING, SKYDIVES]\n",
  "SKYDIVED": "SKYDIVE, to parachute from a plane as a sport [v]\n",
  "SKYDIVER": "one who practises skydiving [n -S]\n",
  "SKYDIVERS": "SKYDIVER, one who practises skydiving [n]\n",
  "SKYDIVES": "SKYDIVE, to parachute from a plane as a sport [v]\n",
  "SKYDIVING": "the sport of jumping by parachute [n -S]\n",
  "SKYDIVINGS": "SKYDIVING, the sport of jumping by parachute [n]\n",
  "SKYDOVE": "SKYDIVE, to parachute from a plane as a sport [v]\n",
  "SKYED": "SKY, to hit or throw towards the upper atmosphere [v]\n",
  "SKYER": "in cricket, a hit high into the air [n -S]\n",
  "SKYERS": "SKYER, in cricket, a hit high into the air [n]\n",
  "SKYEY": "like the sky; ethereal; being in the sky, also SKIEY [adj SKYIER or SKYEYER, SKYIEST or SKYEYEST]\n",
  "SKYEYER": "SKYEY, like the sky; ethereal; being in the sky, also SKIEY [adj]\n",
  "SKYEYEST": "SKYEY, like the sky; ethereal; being in the sky, also SKIEY [adj]\n",
  "SKYF": "(South African) to smoke [v -ED, -ING, -S]\n",
  "SKYFED": "SKYF, (South African) to smoke [v]\n",
  "SKYFING": "SKYF, (South African) to smoke [v]\n",
  "SKYFS": "SKYF, (South African) to smoke [v]\n",
  "SKYGLOW": "a glow in the night sky resulting from urban lights [n -S]\n",
  "SKYGLOWS": "SKYGLOW, a glow in the night sky resulting from urban lights [n]\n",
  "SKYHOME": "(Australian slang) a sub-penthouse flat in a tall building [n -S]\n",
  "SKYHOMES": "SKYHOME, (Australian slang) a sub-penthouse flat in a tall building [n]\n",
  "SKYHOOK": "an imaginary hook in the sky [n -S]\n",
  "SKYHOOKS": "SKYHOOK, an imaginary hook in the sky [n]\n",
  "SKYIER": "SKYEY, like the sky; ethereal; being in the sky, also SKIEY [adj]\n",
  "SKYIEST": "SKYEY, like the sky; ethereal; being in the sky, also SKIEY [adj]\n",
  "SKYING": "SKY, to hit or throw towards the upper atmosphere [v]\n",
  "SKYISH": "(Shakespeare) like the sky, or approaching the sky [adj]\n",
  "SKYJACK": "to hijack an airplane [v -ED, -ING, -S]\n",
  "SKYJACKED": "SKYJACK, to hijack an airplane [v]\n",
  "SKYJACKER": "one who skyjacks, hijacks an aeroplane [n -S]\n",
  "SKYJACKERS": "SKYJACKER, one who skyjacks, hijacks an aeroplane [n]\n",
  "SKYJACKING": "the sport of jumping by parachute [n -S]\n",
  "SKYJACKINGS": "SKYJACKING, the sport of jumping by parachute [n]\n",
  "SKYJACKS": "SKYJACK, to hijack an airplane [v]\n",
  "SKYLAB": "an experimental sky-station [n -S]\n",
  "SKYLABS": "SKYLAB, an experimental sky-station [n]\n",
  "SKYLARK": "to frolic [v -ED, -ING, -S]\n",
  "SKYLARKED": "SKYLARK, to frolic [v]\n",
  "SKYLARKER": "one who skylarks, frolics [n -S]\n",
  "SKYLARKERS": "SKYLARKER, one who skylarks, frolics [n]\n",
  "SKYLARKING": "frolicking, horseplay [n -S]\n",
  "SKYLARKINGS": "SKYLARKING, frolicking, horseplay [n]\n",
  "SKYLARKS": "SKYLARK, to frolic [v]\n",
  "SKYLESS": "without a sky [adj]\n",
  "SKYLIGHT": "a window placed in a roof or ceiling to admit daylight [n -S]\n",
  "SKYLIGHTED": "having a skylight [adj]\n",
  "SKYLIGHTS": "SKYLIGHT, a window placed in a roof or ceiling to admit daylight [n]\n",
  "SKYLIKE": "like the sky [adj]\n",
  "SKYLINE": "the horizon [n -S]\n",
  "SKYLINES": "SKYLINE, the horizon [n]\n",
  "SKYLIT": "lit by light from the sky [adj]\n",
  "SKYMAN": "a paratrooper [n SKYMEN]\n",
  "SKYMEN": "SKYMAN, a paratrooper [n]\n",
  "SKYPHOI": "SKYPHOS, (Greek) a drinking vessel used in ancient Greece [n]\n",
  "SKYPHOS": "(Greek) a drinking vessel used in ancient Greece [n SKYPHOI]\n",
  "SKYR": "(Old Norse) curds; a yogurt-like curd cheese [n -S]\n",
  "SKYRE": "(Scots) to shine, be gaudy [v SKYRED, SKYRING, SKYRES]\n",
  "SKYRED": "SKYRE, (Scots) to shine, be gaudy [v]\n",
  "SKYRES": "SKYRE, (Scots) to shine, be gaudy [v]\n",
  "SKYRING": "SKYRE, (Scots) to shine, be gaudy [v]\n",
  "SKYRMION": "a mathematical model used to model baryons [n -S]\n",
  "SKYRMIONS": "SKYRMION, a mathematical model used to model baryons [n]\n",
  "SKYROCKET": "a firework that bursts high in the sky [n -S] / to go up like a skyrocket [v -ED, -ING, -S]\n",
  "SKYROCKETED": "SKYROCKET, to go up like a skyrocket [v]\n",
  "SKYROCKETING": "SKYROCKET, to go up like a skyrocket [v]\n",
  "SKYROCKETS": "SKYROCKET, to go up like a skyrocket [v]\n",
  "SKYRS": "SKYR, (Old Norse) curds; a yogurt-like curd cheese [n]\n",
  "SKYSAIL": "a type of sail [n -S]\n",
  "SKYSAILS": "SKYSAIL, a type of sail [n]\n",
  "SKYSCAPE": "a picture of the sky [n -S]\n",
  "SKYSCAPES": "SKYSCAPE, a picture of the sky [n]\n",
  "SKYSCRAPER": "a very tall building [n -S]\n",
  "SKYSCRAPERS": "SKYSCRAPER, a very tall building [n]\n",
  "SKYSURF": "to perform maneuvers during free fall while riding on a skyboard [v -ED, -ING, -S]\n",
  "SKYSURFED": "SKYSURF, to perform maneuvers during free fall while riding on a skyboard [v]\n",
  "SKYSURFER": "one who skysurfs [n -S]\n",
  "SKYSURFERS": "SKYSURFER, one who skysurfs [n]\n",
  "SKYSURFING": "the sport of free-falling from an aeroplane with a modified surfboard attached to the feet, which is used to ride the air currents [n -S]\n",
  "SKYSURFINGS": "SKYSURFING, the sport of free-falling from an aeroplane with a modified surfboard attached to the feet, which is used to ride the air currents [n]\n",
  "SKYSURFS": "SKYSURF, to perform maneuvers during free fall while riding on a skyboard [v]\n",
  "SKYTE": "(Scots) to dart or glide [v SKYTED, SKYTING, SKYTES]\n",
  "SKYTED": "SKYTE, (Scots) to dart or glide [v]\n",
  "SKYTES": "SKYTE, (Scots) to dart or glide [v]\n",
  "SKYTING": "SKYTE, (Scots) to dart or glide [v]\n",
  "SKYWALK": "an elevated walkway between two buildings [n -S]\n",
  "SKYWALKS": "SKYWALK, an elevated walkway between two buildings [n]\n",
  "SKYWARD": "towards the sky, also SKYWARDS [adv]\n",
  "SKYWARDS": "towards the sky, also SKYWARD [adv]\n",
  "SKYWATCH": "to observe the sky for heavenly bodies or aircraft [v -ED, -ING, -ES]\n",
  "SKYWATCHED": "SKYWATCH, to observe the sky for heavenly bodies or aircraft [v]\n",
  "SKYWATCHES": "SKYWATCH, to observe the sky for heavenly bodies or aircraft [v]\n",
  "SKYWATCHING": "SKYWATCH, to observe the sky for heavenly bodies or aircraft [v]\n",
  "SKYWAY": "an elevated highway [n -S]\n",
  "SKYWAYS": "SKYWAY, an elevated highway [n]\n",
  "SKYWRITE": "to write in the sky with vapour from a plane [v SKYWROTE, SKYWRITTEN, SKYWRITING, SKYWRITES]\n",
  "SKYWRITER": "one who skywrites [n -S]\n",
  "SKYWRITERS": "SKYWRITER, one who skywrites [n]\n",
  "SKYWRITES": "SKYWRITE, to write in the sky with vapour from a plane [v]\n",
  "SKYWRITING": "tracing words on the sky using smoke from an aircraft [n -S]\n",
  "SKYWRITINGS": "SKYWRITING, tracing words on the sky using smoke from an aircraft [n]\n",
  "SKYWRITTEN": "SKYWRITE, to write in the sky with vapour from a plane [v]\n",
  "SKYWROTE": "SKYWRITE, to write in the sky with vapour from a plane [v]\n",
  "SLAB": "to cover with flat, broad pieces of material [v SLABBED, SLABBING, SLABS]\n",
  "SLABBED": "SLAB, to cover with flat, broad pieces of material [v]\n",
  "SLABBER": "to slaver; to drivel, also SLOBBER [v -ED, -ING, -S]\n",
  "SLABBERED": "SLABBER, to slaver; to drivel, also SLOBBER [v]\n",
  "SLABBERER": "one who slabbers, or drools; hence, an idiot [n -S]\n",
  "SLABBERERS": "SLABBERER, one who slabbers, or drools; hence, an idiot [n]\n",
  "SLABBERIER": "SLABBERY, like, or covered with, slabber [adj]\n",
  "SLABBERIEST": "SLABBERY, like, or covered with, slabber [adj]\n",
  "SLABBERING": "SLABBER, to slaver; to drivel, also SLOBBER [v]\n",
  "SLABBERS": "SLABBER, to slaver; to drivel, also SLOBBER [v]\n",
  "SLABBERY": "like, or covered with, slabber [adj SLABBERIER, SLABBERIEST]\n",
  "SLABBIER": "SLABBY, thick, viscous [adj]\n",
  "SLABBIES": "SLABBY, a person who works with slabs of timber [n]\n",
  "SLABBIEST": "SLABBY, thick, viscous [adj]\n",
  "SLABBINESS": "the state of being slabby [n -ES]\n",
  "SLABBINESSES": "SLABBINESS, the state of being slabby [n]\n",
  "SLABBING": "the act of forming into slabs [n -S]\n",
  "SLABBINGS": "SLABBING, the act of forming into slabs [n]\n",
  "SLABBY": "thick, viscous [adj SLABBIER, SLABBIEST] / a person who works with slabs of timber [n SLABBIES]\n",
  "SLABLIKE": "resembling a slab [adj]\n",
  "SLABS": "SLAB, to cover with flat, broad pieces of material [v]\n",
  "SLABSTONE": "flagstone [n -S]\n",
  "SLABSTONES": "SLABSTONE, flagstone [n]\n",
  "SLACK": "not tight or taut [adj SLACKER, SLACKEST, SLACKLY] / to slacken [v -ED, -ING, -S]\n",
  "SLACKED": "SLACK, to slacken [v]\n",
  "SLACKEN": "to loosen or retard, also SLACK [v -ED, -ING, -S]\n",
  "SLACKENED": "SLACKEN, to loosen or retard, also SLACK [v]\n",
  "SLACKENER": "one who slackens [n -S]\n",
  "SLACKENERS": "SLACKENER, one who slackens [n]\n",
  "SLACKENING": "a making less tight or taut [n -S]\n",
  "SLACKENINGS": "SLACKENING, a making less tight or taut [n]\n",
  "SLACKENS": "SLACKEN, to loosen or retard, also SLACK [v]\n",
  "SLACKER": "a shirker [n -S]\n",
  "SLACKERS": "SLACKER, a shirker [n]\n",
  "SLACKEST": "SLACK, not tight or taut [adj]\n",
  "SLACKING": "SLACK, to slacken [v]\n",
  "SLACKLINING": "the activity of walking across a narrow line of synthetic webbing hung slackly above the ground [n -S]\n",
  "SLACKLININGS": "SLACKLINING, the activity of walking across a narrow line of synthetic webbing hung slackly above the ground [n]\n",
  "SLACKLY": "SLACK, not tight or taut [adv]\n",
  "SLACKNESS": "the state of being slack [n -ES]\n",
  "SLACKNESSES": "SLACKNESS, the state of being slack [n]\n",
  "SLACKS": "SLACK, to slacken [v]\n",
  "SLACKTIVISM": "the carrying out of feelgood measures, in support of an issue or social cause, that have little or no practical effect other than to make the person doing it feel satisfaction, also SLACTIVISM [n -S]\n",
  "SLACKTIVISMS": "SLACKTIVISM, the carrying out of feelgood measures, in support of an issue or social cause, that have little or no practical effect other than to make the person doing it feel satisfaction, also SLACTIVISM [n]\n",
  "SLACKTIVIST": "one who engages in slacktivism, also SLACTIVIST [n -S]\n",
  "SLACKTIVISTS": "SLACKTIVIST, one who engages in slacktivism, also SLACTIVIST [n]\n",
  "SLACTIVISM": "the carrying out of feelgood measures, in support of an issue or social cause, that have little or no practical effect other than to make the person doing it feel satisfaction, also SLACKTIVISM [n -S]\n",
  "SLACTIVISMS": "SLACTIVISM, the carrying out of feelgood measures, in support of an issue or social cause, that have little or no practical effect other than to make the person doing it feel satisfaction, also SLACKTIVISM [n]\n",
  "SLACTIVIST": "one who engages in slactivism, also SLACKTIVIST [n -S]\n",
  "SLACTIVISTS": "SLACTIVIST, one who engages in slactivism, also SLACKTIVIST [n]\n",
  "SLADANG": "(Malay) a wild ox, also SALADANG, SELADANG [n -S]\n",
  "SLADANGS": "SLADANG, (Malay) a wild ox, also SALADANG, SELADANG [n]\n",
  "SLADE": "a little valley or dell [n -S]\n",
  "SLADES": "SLADE, a little valley or dell [n]\n",
  "SLAE": "(Scots) a sloe [n -S]\n",
  "SLAES": "SLAE, (Scots) a sloe [n]\n",
  "SLAG": "to criticize, mock or deride [v SLAGGED, SLAGGING, SLAGS]\n",
  "SLAGGED": "SLAG, to criticize, mock or deride [v]\n",
  "SLAGGIER": "SLAGGY, resembling residue of smelted ore [adj]\n",
  "SLAGGIEST": "SLAGGY, resembling residue of smelted ore [adj]\n",
  "SLAGGING": "an act of slagging [n -S]\n",
  "SLAGGINGS": "SLAGGING, an act of slagging [n]\n",
  "SLAGGY": "resembling residue of smelted ore [adj SLAGGIER, SLAGGIEST]\n",
  "SLAGHEAP": "a heap of slag refuse [n -S]\n",
  "SLAGHEAPS": "SLAGHEAP, a heap of slag refuse [n]\n",
  "SLAGS": "SLAG, to criticize, mock or deride [v]\n",
  "SLAHAL": "a team game played by indigenous peoples of the Pacific Northwest, also LAHAL [n -S]\n",
  "SLAHALS": "SLAHAL, a team game played by indigenous peoples of the Pacific Northwest, also LAHAL [n]\n",
  "SLAID": "a sledge [n -S]\n",
  "SLAIDS": "SLAID, a sledge [n]\n",
  "SLAIN": "SLAY, to kill [v]\n",
  "SLAINTE": "(Irish) an Irish drinking toast, your health [interj]\n",
  "SLAIRG": "(Scots) to spread or smear sloppily [v -ED, -ING, -S]\n",
  "SLAIRGED": "SLAIRG, (Scots) to spread or smear sloppily [v]\n",
  "SLAIRGING": "SLAIRG, (Scots) to spread or smear sloppily [v]\n",
  "SLAIRGS": "SLAIRG, (Scots) to spread or smear sloppily [v]\n",
  "SLAISTER": "(Scots) to do in a sloppy manner [v -ED, -ING, -S]\n",
  "SLAISTERED": "SLAISTER, (Scots) to do in a sloppy manner [v]\n",
  "SLAISTERIES": "SLAISTERY, slops, drudgery [n]\n",
  "SLAISTERING": "SLAISTER, (Scots) to do in a sloppy manner [v]\n",
  "SLAISTERS": "SLAISTER, (Scots) to do in a sloppy manner [v]\n",
  "SLAISTERY": "slops, drudgery [n SLAISTERIES]\n",
  "SLAKABLE": "that can be slaked, also SLAKEABLE [adj]\n",
  "SLAKE": "to quench [v SLAKED or (obsolete) YSLAKED, SLAKING, SLAKES]\n",
  "SLAKEABLE": "that can be slaked, also SLAKABLE [adj]\n",
  "SLAKED": "SLAKE, to quench [v]\n",
  "SLAKELESS": "not capable of being slaked [adj]\n",
  "SLAKER": "one who slakes [n -S]\n",
  "SLAKERS": "SLAKER, one who slakes [n]\n",
  "SLAKES": "SLAKE, to quench [v]\n",
  "SLAKING": "SLAKE, to quench [v]\n",
  "SLALOM": "(Norwegian) to ski in a zigzag course [v -ED, -ING, -S]\n",
  "SLALOMED": "SLALOM, (Norwegian) to ski in a zigzag course [v]\n",
  "SLALOMER": "one who slaloms [n -S]\n",
  "SLALOMERS": "SLALOMER, one who slaloms [n]\n",
  "SLALOMING": "SLALOM, (Norwegian) to ski in a zigzag course [v]\n",
  "SLALOMIST": "one who takes part in a slalom [n -S]\n",
  "SLALOMISTS": "SLALOMIST, one who takes part in a slalom [n]\n",
  "SLALOMS": "SLALOM, (Norwegian) to ski in a zigzag course [v]\n",
  "SLAM": "to shut forcibly and noisily [v SLAMMED, SLAMMING, SLAMS]\n",
  "SLAMDANCE": "to dance aggressively, bumping into others [v SLAMDANCED, SLAMDANCING, SLAMDANCES]\n",
  "SLAMDANCED": "SLAMDANCE, to dance aggressively, bumping into others [v]\n",
  "SLAMDANCES": "SLAMDANCE, to dance aggressively, bumping into others [v]\n",
  "SLAMDANCING": "SLAMDANCE, to dance aggressively, bumping into others [v]\n",
  "SLAMMAKIN": "(obsolete) a loose gown; a slovenly dressed woman, also SLAMMERKIN [n -S]\n",
  "SLAMMAKINS": "SLAMMAKIN, (obsolete) a loose gown; a slovenly dressed woman, also SLAMMERKIN [n]\n",
  "SLAMMED": "SLAM, to shut forcibly and noisily [v]\n",
  "SLAMMER": "(slang) prison [n -S]\n",
  "SLAMMERKIN": "(obsolete) a loose gown; a slatternly woman, also SLAMMAKIN [n -S]\n",
  "SLAMMERKINS": "SLAMMERKIN, (obsolete) a loose gown; a slatternly woman, also SLAMMAKIN [n]\n",
  "SLAMMERS": "SLAMMER, (slang) prison [n]\n",
  "SLAMMING": "slam dancing [n -S]\n",
  "SLAMMINGS": "SLAMMING, slam dancing [n]\n",
  "SLAMS": "SLAM, to shut forcibly and noisily [v]\n",
  "SLANDER": "to defame [v -ED, -ING, -S]\n",
  "SLANDERED": "SLANDER, to defame [v]\n",
  "SLANDERER": "one who slanders [n -S]\n",
  "SLANDERERS": "SLANDERER, one who slanders [n]\n",
  "SLANDERING": "SLANDER, to defame [v]\n",
  "SLANDEROUS": "relating to slander [adj SLANDEROUSLY]\n",
  "SLANDEROUSLY": "SLANDEROUS, relating to slander [adv]\n",
  "SLANDEROUSNESS": "SLANDEROUS, relating to slander [n]\n",
  "SLANDERS": "SLANDER, to defame [v]\n",
  "SLANE": "(Irish) a turf-cutting spade [n -S]\n",
  "SLANES": "SLANE, (Irish) a turf-cutting spade [n]\n",
  "SLANG": "to use extremely informal language [v -ED, -ING, -S]\n",
  "SLANGED": "SLANG, to use extremely informal language [v]\n",
  "SLANGER": "a hawker; a dealer in illegal drugs [n -S]\n",
  "SLANGERS": "SLANGER, a hawker; a dealer in illegal drugs [n]\n",
  "SLANGIER": "SLANGY, full of slang [adj]\n",
  "SLANGIEST": "SLANGY, full of slang [adj]\n",
  "SLANGILY": "SLANGY, full of slang [adv]\n",
  "SLANGINESS": "the state of being slangy [n -ES]\n",
  "SLANGINESSES": "SLANGINESS, the state of being slangy [n]\n",
  "SLANGING": "scolding [adj SLANGINGLY] / a scolding [n -S]\n",
  "SLANGINGLY": "SLANGING, scolding [adv]\n",
  "SLANGINGS": "SLANGING, a scolding [n]\n",
  "SLANGISH": "somewhat slangy [adj]\n",
  "SLANGS": "SLANG, to use extremely informal language [v]\n",
  "SLANGUAGE": "a slang language [n -S]\n",
  "SLANGUAGES": "SLANGUAGE, a slang language [n]\n",
  "SLANGULAR": "(Dickens) slangy [adj]\n",
  "SLANGY": "full of slang [adj SLANGIER, SLANGIEST, SLANGILY]\n",
  "SLANK": "SLINK, to move stealthily [v]\n",
  "SLANT": "oblique [adj SLANTLY] / to deviate from the horizontal or vertical [v -ED, -ING, -S]\n",
  "SLANTED": "SLANT, to deviate from the horizontal or vertical [v]\n",
  "SLANTENDICULAR": "oblique; neither horizontal nor perpendicular, also SLANTINDICULAR [adj]\n",
  "SLANTER": "(Australian slang) a dodge, a trick, also SLENTER, SLINTER [n -S]\n",
  "SLANTERS": "SLANTER, (Australian slang) a dodge, a trick, also SLENTER, SLINTER [n]\n",
  "SLANTIER": "SLANTY, deviating from the horizontal or vertical [adj]\n",
  "SLANTIEST": "SLANTY, deviating from the horizontal or vertical [adj]\n",
  "SLANTINDICULAR": "oblique; neither horizontal nor perpendicular, also SLANTENDICULAR [adj]\n",
  "SLANTING": "SLANT, to deviate from the horizontal or vertical [v]\n",
  "SLANTINGLY": "SLANTING, SLANT, to deviate from the horizontal or vertical [adv]\n",
  "SLANTINGWAYS": "in a slanting direction [adv]\n",
  "SLANTLY": "SLANT, oblique [adv]\n",
  "SLANTS": "SLANT, to deviate from the horizontal or vertical [v]\n",
  "SLANTWAYS": "in a slanting direction, also SLANTWISE [adv]\n",
  "SLANTWISE": "in a slanting direction, also SLANTWAYS [adv]\n",
  "SLANTY": "deviating from the horizontal or vertical [adj SLANTIER, SLANTIEST]\n",
  "SLAP": "to strike with the open hand [v SLAPPED, SLAPPING, SLAPS]\n",
  "SLAPDASH": "to do in a hasty, imperfect manner [v -ED, -ING, -ES]\n",
  "SLAPDASHED": "SLAPDASH, to do in a hasty, imperfect manner [v]\n",
  "SLAPDASHES": "SLAPDASH, to do in a hasty, imperfect manner [v]\n",
  "SLAPDASHING": "SLAPDASH, to do in a hasty, imperfect manner [v]\n",
  "SLAPHAPPIER": "SLAPHAPPY, happy-go-lucky [adj]\n",
  "SLAPHAPPIEST": "SLAPHAPPY, happy-go-lucky [adj]\n",
  "SLAPHAPPY": "happy-go-lucky [adj SLAPHAPPIER, SLAPHAPPIEST]\n",
  "SLAPHEAD": "(slang) a bald person [n -S]\n",
  "SLAPHEADS": "SLAPHEAD, (slang) a bald person [n]\n",
  "SLAPJACK": "a flat batter cake cooked on a griddle, also FLAPJACK [n -S]\n",
  "SLAPJACKS": "SLAPJACK, a flat batter cake cooked on a griddle, also FLAPJACK [n]\n",
  "SLAPPED": "SLAP, to strike with the open hand [v]\n",
  "SLAPPER": "(slang) a promiscuous woman [n -S]\n",
  "SLAPPERS": "SLAPPER, (slang) a promiscuous woman [n]\n",
  "SLAPPING": "the act of striking with the open hand [n -S]\n",
  "SLAPPINGS": "SLAPPING, the act of striking with the open hand [n]\n",
  "SLAPS": "SLAP, to strike with the open hand [v]\n",
  "SLAPSHOT": "a fast powerful shot in ice hockey [n -S]\n",
  "SLAPSHOTS": "SLAPSHOT, a fast powerful shot in ice hockey [n]\n",
  "SLAPSTICK": "comedy stressing farce and horseplay [n -S]\n",
  "SLAPSTICKS": "SLAPSTICK, comedy stressing farce and horseplay [n]\n",
  "SLART": "(dialect) to spill [v -ED, -ING, -S]\n",
  "SLARTED": "SLART, (dialect) to spill [v]\n",
  "SLARTING": "SLART, (dialect) to spill [v]\n",
  "SLARTS": "SLART, (dialect) to spill [v]\n",
  "SLASH": "to cut with violent sweeping strokes [v -ED, -ING, -ES]\n",
  "SLASHED": "SLASH, to cut with violent sweeping strokes [v]\n",
  "SLASHER": "one that slashes [n -S]\n",
  "SLASHERS": "SLASHER, one that slashes [n]\n",
  "SLASHES": "SLASH, to cut with violent sweeping strokes [v]\n",
  "SLASHFEST": "a film or computer game that involves bloody slayings involving blades [n -S]\n",
  "SLASHFESTS": "SLASHFEST, a film or computer game that involves bloody slayings involving blades [n]\n",
  "SLASHING": "the act of one that slashes [n -S]\n",
  "SLASHINGLY": "SLASHING [adv]\n",
  "SLASHINGS": "SLASHING, the act of one that slashes [n]\n",
  "SLAT": "to supply with narrow strips of wood or metal [v SLATTED, SLATTING, SLATS]\n",
  "SLATCH": "a calm between breaking waves [n -ES]\n",
  "SLATCHES": "SLATCH, a calm between breaking waves [n]\n",
  "SLATE": "a fine-grained argillaceous rock, also SCLATE, SKLATE [n -S] / to roof with slate [v SLATED, SLATING, SLATES]\n",
  "SLATED": "SLATE, to roof with slate [v]\n",
  "SLATELIKE": "like slate [adj]\n",
  "SLATER": "one who roofs with slate [n -S]\n",
  "SLATERS": "SLATER, one who roofs with slate [n]\n",
  "SLATES": "SLATE, to roof with slate [v]\n",
  "SLATEY": "resembling slate, also SLATY [adj]\n",
  "SLATHER": "to spread thickly [v -ED, -ING, -S]\n",
  "SLATHERED": "SLATHER, to spread thickly [v]\n",
  "SLATHERING": "SLATHER, to spread thickly [v]\n",
  "SLATHERS": "SLATHER, to spread thickly [v]\n",
  "SLATIER": "SLATY, resembling slate, also SLATEY [adj]\n",
  "SLATIEST": "SLATY, resembling slate, also SLATEY [adj]\n",
  "SLATINESS": "being like slate [n -ES]\n",
  "SLATINESSES": "SLATINESS, being like slate [n]\n",
  "SLATING": "a telling off [n -S]\n",
  "SLATINGS": "SLATING, a telling off [n]\n",
  "SLATS": "SLAT, to supply with narrow strips of wood or metal [v]\n",
  "SLATTED": "SLAT, to supply with narrow strips of wood or metal [v]\n",
  "SLATTER": "(dialect) to be untidy [v -ED, -ING, -S]\n",
  "SLATTERED": "SLATTER, (dialect) to be untidy [v]\n",
  "SLATTERING": "SLATTER, (dialect) to be untidy [v]\n",
  "SLATTERN": "a slovenly woman [n -S]\n",
  "SLATTERNLIER": "SLATTERNLY, like a slattern [adj]\n",
  "SLATTERNLIEST": "SLATTERNLY, like a slattern [adj]\n",
  "SLATTERNLINESS": "the state of being slatternly [n]\n",
  "SLATTERNLY": "like a slattern [adj SLATTERNLIER, SLATTERNLIEST]\n",
  "SLATTERNS": "SLATTERN, a slovenly woman [n]\n",
  "SLATTERS": "SLATTER, (dialect) to be untidy [v]\n",
  "SLATTERY": "(dialect) slovenly [adj]\n",
  "SLATTING": "material for making slats [n -S]\n",
  "SLATTINGS": "SLATTING, material for making slats [n]\n",
  "SLATY": "resembling slate, also SLATEY [adj SLATIER, SLATIEST]\n",
  "SLAUGHTER": "the act of killing, also SLAUGHTERY [n -S] / to kill, esp. animals for food [v -ED, -ING, -S]\n",
  "SLAUGHTERABLE": "that can be slaughtered [adj]\n",
  "SLAUGHTERED": "SLAUGHTER, to kill, esp. animals for food [v]\n",
  "SLAUGHTERER": "one who slaughters [n -S]\n",
  "SLAUGHTERERS": "SLAUGHTERER, one who slaughters [n]\n",
  "SLAUGHTERHOUSE": "an establishment where animals are butchered [n -S]\n",
  "SLAUGHTERHOUSES": "SLAUGHTERHOUSE, an establishment where animals are butchered [n]\n",
  "SLAUGHTERIES": "SLAUGHTERY, slaughter, also SLAUGHTER [n]\n",
  "SLAUGHTERING": "SLAUGHTER, to kill, esp. animals for food [v]\n",
  "SLAUGHTERMAN": "one whose occupation it is to kill for food [n SLAUGHTERMEN]\n",
  "SLAUGHTERMEN": "SLAUGHTERMAN, one whose occupation it is to kill for food [n]\n",
  "SLAUGHTEROUS": "of or relating to slaughter [adj SLAUGHTEROUSLY]\n",
  "SLAUGHTEROUSLY": "SLAUGHTEROUS, of or relating to slaughter [adv]\n",
  "SLAUGHTERS": "SLAUGHTER, to kill, esp. animals for food [v]\n",
  "SLAUGHTERY": "slaughter, also SLAUGHTER [n SLAUGHTERIES]\n",
  "SLAVE": "to work like a drudge [v SLAVED, SLAVING, SLAVES]\n",
  "SLAVED": "SLAVE, to work like a drudge [v]\n",
  "SLAVEHOLDER": "one who owns slaves [n -S]\n",
  "SLAVEHOLDERS": "SLAVEHOLDER, one who owns slaves [n]\n",
  "SLAVEHOLDING": "the keeping of slaves [n -S]\n",
  "SLAVEHOLDINGS": "SLAVEHOLDING, the keeping of slaves [n]\n",
  "SLAVER": "to drool [v -ED, -ING, -S]\n",
  "SLAVERED": "SLAVER, to drool [v]\n",
  "SLAVERER": "one who slavers [n -S]\n",
  "SLAVERERS": "SLAVERER, one who slavers [n]\n",
  "SLAVERIES": "SLAVERY, the ownership of one person by another [n]\n",
  "SLAVERING": "drooling [adj SLAVERINGLY] / letting spittle run from the mouth [n -S]\n",
  "SLAVERINGLY": "SLAVERING, drooling [adv]\n",
  "SLAVERINGS": "SLAVERING, letting spittle run from the mouth [n]\n",
  "SLAVERS": "SLAVER, to drool [v]\n",
  "SLAVERY": "the ownership of one person by another [n SLAVERIES]\n",
  "SLAVES": "SLAVE, to work like a drudge [v]\n",
  "SLAVEY": "a female servant [n -S]\n",
  "SLAVEYS": "SLAVEY, a female servant [n]\n",
  "SLAVING": "SLAVE, to work like a drudge [v]\n",
  "SLAVISH": "pertaining to a slave [adj SLAVISHLY]\n",
  "SLAVISHLY": "SLAVISH, pertaining to a slave [adv]\n",
  "SLAVISHNESS": "the state of being slavish [n -ES]\n",
  "SLAVISHNESSES": "SLAVISHNESS, the state of being slavish [n]\n",
  "SLAVOCRACIES": "SLAVOCRACY, slave-owners collectively [n]\n",
  "SLAVOCRACY": "slave-owners collectively [n SLAVOCRACIES]\n",
  "SLAVOCRAT": "a slave-owner [n -S]\n",
  "SLAVOCRATS": "SLAVOCRAT, a slave-owner [n]\n",
  "SLAVOPHIL": "a person who admires the Slavs or their culture, also SLAVOPHILE [n -S]\n",
  "SLAVOPHILE": "a person who admires the Slavs or their culture, also SLAVOPHIL [n -S]\n",
  "SLAVOPHILES": "SLAVOPHILE, a person who admires the Slavs or their culture, also SLAVOPHIL [n]\n",
  "SLAVOPHILS": "SLAVOPHIL, a person who admires the Slavs or their culture, also SLAVOPHILE [n]\n",
  "SLAW": "a salad of raw shredded cabbage, also COLESLAW [n -S]\n",
  "SLAWS": "SLAW, a salad of raw shredded cabbage, also COLESLAW [n]\n",
  "SLAY": "to kill [v SLEW, SLAIN, SLAYING, SLAYS] / to amuse very much [v SLAYED, SLAYING, SLAYS]\n",
  "SLAYABLE": "able to be slayed [adj]\n",
  "SLAYED": "SLAY, to kill [v]\n",
  "SLAYER": "one that slays [n -S]\n",
  "SLAYERS": "SLAYER, one that slays [n]\n",
  "SLAYING": "an act of killing [n -S]\n",
  "SLAYINGS": "SLAYING, an act of killing [n]\n",
  "SLAYS": "SLAY, to kill [v]\n",
  "SLEAVE": "to separate into fine filaments [v SLEAVED, SLEAVING, SLEAVES]\n",
  "SLEAVED": "SLEAVE, to separate into fine filaments [v]\n",
  "SLEAVES": "SLEAVE, to separate into fine filaments [v]\n",
  "SLEAVING": "SLEAVE, to separate into fine filaments [v]\n",
  "SLEAZE": "to behave in a sleazy, corrupt manner [v SLEAZED, SLEAZING, SLEAZES]\n",
  "SLEAZEBAG": "a sleazy person, esp. one who tries to take advantage of women [n -S]\n",
  "SLEAZEBAGS": "SLEAZEBAG, a sleazy person, esp. one who tries to take advantage of women [n]\n",
  "SLEAZEBALL": "a sleazy person, esp. one who tries to take advantage of women [n -S]\n",
  "SLEAZEBALLS": "SLEAZEBALL, a sleazy person, esp. one who tries to take advantage of women [n]\n",
  "SLEAZED": "SLEAZE, to behave in a sleazy, corrupt manner [v]\n",
  "SLEAZES": "SLEAZE, to behave in a sleazy, corrupt manner [v]\n",
  "SLEAZIER": "SLEAZY, shoddy, also SLEEZY [adj]\n",
  "SLEAZIEST": "SLEAZY, shoddy, also SLEEZY [adj]\n",
  "SLEAZILY": "SLEAZY, shoddy, also SLEEZY [adv]\n",
  "SLEAZINESS": "the state of being sleazy [n -ES]\n",
  "SLEAZINESSES": "SLEAZINESS, the state of being sleazy [n]\n",
  "SLEAZING": "SLEAZE, to behave in a sleazy, corrupt manner [v]\n",
  "SLEAZO": "a sleazy person [n -S]\n",
  "SLEAZOID": "a person of low morals or character [n -S]\n",
  "SLEAZOIDS": "SLEAZOID, a person of low morals or character [n]\n",
  "SLEAZOS": "SLEAZO, a sleazy person [n]\n",
  "SLEAZY": "shoddy, also SLEEZY [adj SLEAZIER, SLEAZIEST, SLEAZILY]\n",
  "SLEB": "(slang) a celebrity [n -S]\n",
  "SLEBS": "SLEB, (slang) a celebrity [n]\n",
  "SLED": "to transport on a wheelless structure over snow [v SLEDDED, SLEDDING, SLEDS]\n",
  "SLEDDED": "SLED, to transport on a wheelless structure over snow [v]\n",
  "SLEDDER": "one who goes on a sled [n -S]\n",
  "SLEDDERS": "SLEDDER, one who goes on a sled [n]\n",
  "SLEDDING": "conveyance by sled [n -S]\n",
  "SLEDDINGS": "SLEDDING, conveyance by sled [n]\n",
  "SLEDED": "(Shakespeare) an irregular form of sleaved, also SLEIDED [adj]\n",
  "SLEDGE": "to convey on a type of sled [v SLEDGED, SLEDGING, SLEDGES]\n",
  "SLEDGED": "SLEDGE, to convey on a type of sled [v]\n",
  "SLEDGEHAMMER": "a large hammer used e.g. for breaking rocks [n -S] / to strike with a sledgehammer [v -ED, -ING, -S]\n",
  "SLEDGEHAMMERED": "SLEDGEHAMMER, to strike with a sledgehammer [v]\n",
  "SLEDGEHAMMERING": "SLEDGEHAMMER, to strike with a sledgehammer [v]\n",
  "SLEDGEHAMMERS": "SLEDGEHAMMER, a large hammer used e.g. for breaking rocks [n]\n",
  "SLEDGER": "one who drives a sledge [n -S]\n",
  "SLEDGERS": "SLEDGER, one who drives a sledge [n]\n",
  "SLEDGES": "SLEDGE, to convey on a type of sled [v]\n",
  "SLEDGING": "journeying by sled [n -S]\n",
  "SLEDGINGS": "SLEDGING, journeying by sled [n]\n",
  "SLEDS": "SLED, to transport on a wheelless structure over snow [v]\n",
  "SLEE": "(Scots) sly [adj SLEER, SLEEST]\n",
  "SLEECH": "a mud flat [n -ES]\n",
  "SLEECHES": "SLEECH, a mud flat [n]\n",
  "SLEECHIER": "SLEECHY, slimy with mud [adj]\n",
  "SLEECHIEST": "SLEECHY, slimy with mud [adj]\n",
  "SLEECHY": "slimy with mud [adj SLEECHIER, SLEECHIEST]\n",
  "SLEEK": "smooth, glossy [adj SLEEKER, SLEEKEST, SLEEKLY] / to make smooth, also SLEEKEN [v -ED, -ING, -S]\n",
  "SLEEKED": "SLEEK, to make smooth, also SLEEKEN [v]\n",
  "SLEEKEN": "to make smooth or glossy, also SLEEK [v -ED, -ING, -S]\n",
  "SLEEKENED": "SLEEKEN, to make smooth or glossy, also SLEEK [v]\n",
  "SLEEKENING": "SLEEKEN, to make smooth or glossy, also SLEEK [v]\n",
  "SLEEKENS": "SLEEKEN, to make smooth or glossy, also SLEEK [v]\n",
  "SLEEKER": "a moulding tool for smoothing over small irregularities in the mould [n -S]\n",
  "SLEEKERS": "SLEEKER, a moulding tool for smoothing over small irregularities in the mould [n]\n",
  "SLEEKEST": "SLEEK, smooth, glossy [adj]\n",
  "SLEEKIER": "SLEEKY, sleek, smooth [adj]\n",
  "SLEEKIEST": "SLEEKY, sleek, smooth [adj]\n",
  "SLEEKING": "the act of making smooth [n -S]\n",
  "SLEEKINGS": "SLEEKING, the act of making smooth [n]\n",
  "SLEEKIT": "(Scots) crafty, sly, smooth [adj]\n",
  "SLEEKLY": "SLEEK, smooth, glossy [adv]\n",
  "SLEEKNESS": "the state of being sleek [n -ES]\n",
  "SLEEKNESSES": "SLEEKNESS, the state of being sleek [n]\n",
  "SLEEKS": "SLEEK, to make smooth, also SLEEKEN [v]\n",
  "SLEEKSTONE": "a polishing stone, also SLICKSTONE [n -S]\n",
  "SLEEKSTONES": "SLEEKSTONE, a polishing stone, also SLICKSTONE [n]\n",
  "SLEEKY": "sleek, smooth [adj SLEEKIER, SLEEKIEST]\n",
  "SLEEP": "to be in a natural, periodic state of rest [v SLEPT, SLEEPING, SLEEPS]\n",
  "SLEEPAWAY": "relating to a camp for teenagers [adj]\n",
  "SLEEPER": "one that sleeps [n -S]\n",
  "SLEEPERS": "SLEEPER, one that sleeps [n]\n",
  "SLEEPERY": "(Scots) sleepy [adj]\n",
  "SLEEPIER": "SLEEPY, inclined to sleep [adj]\n",
  "SLEEPIEST": "SLEEPY, inclined to sleep [adj]\n",
  "SLEEPILY": "SLEEPY, inclined to sleep [adv]\n",
  "SLEEPINESS": "the state of being sleepy [n -ES]\n",
  "SLEEPINESSES": "SLEEPINESS, the state of being sleepy [n]\n",
  "SLEEPING": "the act of one who sleeps [n -S]\n",
  "SLEEPINGS": "SLEEPING, the act of one who sleeps [n]\n",
  "SLEEPLESS": "without sleep [adj SLEEPLESSLY]\n",
  "SLEEPLESSLY": "SLEEPLESS, without sleep [adv]\n",
  "SLEEPLESSNESS": "the state of being sleepless [n -ES]\n",
  "SLEEPLESSNESSES": "SLEEPLESSNESS, the state of being sleepless [n]\n",
  "SLEEPLIKE": "like sleep [adj]\n",
  "SLEEPOUT": "part of a veranda partitioned off for sleeping [n -S]\n",
  "SLEEPOUTS": "SLEEPOUT, part of a veranda partitioned off for sleeping [n]\n",
  "SLEEPOVER": "the custom of staying overnight at a friend's house [n -S]\n",
  "SLEEPOVERS": "SLEEPOVER, the custom of staying overnight at a friend's house [n]\n",
  "SLEEPRY": "(Scots) sleepy, also SLEEPERY [adj]\n",
  "SLEEPS": "SLEEP, to be in a natural, periodic state of rest [v]\n",
  "SLEEPSUIT": "a baby's all-in-one garment for sleeping in [n -S]\n",
  "SLEEPSUITS": "SLEEPSUIT, a baby's all-in-one garment for sleeping in [n]\n",
  "SLEEPWALK": "to walk in one's sleep [v -ED, -ING, -S]\n",
  "SLEEPWALKED": "SLEEPWALK, to walk in one's sleep [v]\n",
  "SLEEPWALKER": "one who sleepwalks [n -S]\n",
  "SLEEPWALKERS": "SLEEPWALKER, one who sleepwalks [n]\n",
  "SLEEPWALKING": "walking in one's sleep [n -S]\n",
  "SLEEPWALKINGS": "SLEEPWALKING, walking in one's sleep [n]\n",
  "SLEEPWALKS": "SLEEPWALK, to walk in one's sleep [v]\n",
  "SLEEPWEAR": "clothes for sleeping in [n -S]\n",
  "SLEEPWEARS": "SLEEPWEAR, clothes for sleeping in [n]\n",
  "SLEEPY": "inclined to sleep [adj SLEEPIER, SLEEPIEST]\n",
  "SLEEPYHEAD": "a sleepy person [n -S]\n",
  "SLEEPYHEADED": "given to sleep [adj]\n",
  "SLEEPYHEADS": "SLEEPYHEAD, a sleepy person [n]\n",
  "SLEER": "SLEE, (Scots) sly [adj]\n",
  "SLEEST": "SLEE, (Scots) sly [adj]\n",
  "SLEET": "to shower frozen rain [v -ED, -ING, -S]\n",
  "SLEETED": "SLEET, to shower frozen rain [v]\n",
  "SLEETIER": "SLEETY, resembling sleet [adj]\n",
  "SLEETIEST": "SLEETY, resembling sleet [adj]\n",
  "SLEETINESS": "the state of being sleety [n -ES]\n",
  "SLEETINESSES": "SLEETINESS, the state of being sleety [n]\n",
  "SLEETING": "SLEET, to shower frozen rain [v]\n",
  "SLEETS": "SLEET, to shower frozen rain [v]\n",
  "SLEETY": "resembling sleet [adj SLEETIER, SLEETIEST]\n",
  "SLEEVE": "to supply with an arm covering [v SLEEVED, SLEEVING, SLEEVES]\n",
  "SLEEVED": "SLEEVE, to supply with an arm covering [v]\n",
  "SLEEVEEN": "(Irish) a crafty, smooth-talking person [n -S]\n",
  "SLEEVEENS": "SLEEVEEN, (Irish) a crafty, smooth-talking person [n]\n",
  "SLEEVEHAND": "(Shakespeare) a wristband [n -S]\n",
  "SLEEVEHANDS": "SLEEVEHAND, (Shakespeare) a wristband [n]\n",
  "SLEEVELESS": "without sleeves [adj]\n",
  "SLEEVELET": "a small sleeve [n -S]\n",
  "SLEEVELETS": "SLEEVELET, a small sleeve [n]\n",
  "SLEEVELIKE": "like a sleeve [adj]\n",
  "SLEEVER": "an old Welsh measure for beer, about 3/4 pint [n -S]\n",
  "SLEEVERS": "SLEEVER, an old Welsh measure for beer, about 3/4 pint [n]\n",
  "SLEEVES": "SLEEVE, to supply with an arm covering [v]\n",
  "SLEEVING": "a tubular covering for a cylindrical object, esp. one of insulating material for an electric cable [n -S]\n",
  "SLEEVINGS": "SLEEVING, a tubular covering for a cylindrical object, esp. one of insulating material for an electric cable [n]\n",
  "SLEEZIER": "SLEEZY, sordid, also SLEAZY [adj]\n",
  "SLEEZIEST": "SLEEZY, sordid, also SLEAZY [adj]\n",
  "SLEEZY": "sordid, also SLEAZY [adj SLEEZIER, SLEEZIEST]\n",
  "SLEIDED": "(Shakespeare) an irregular form of sleaved, also SLEDED [adj]\n",
  "SLEIGH": "to ride in a sled [v -ED, -ING, -S]\n",
  "SLEIGHED": "SLEIGH, to ride in a sled [v]\n",
  "SLEIGHER": "one who travels by sleigh [n -S]\n",
  "SLEIGHERS": "SLEIGHER, one who travels by sleigh [n]\n",
  "SLEIGHING": "travelling by sleigh [n -S]\n",
  "SLEIGHINGS": "SLEIGHING, travelling by sleigh [n]\n",
  "SLEIGHS": "SLEIGH, to ride in a sled [v]\n",
  "SLEIGHT": "cunning, dexterity [n -S]\n",
  "SLEIGHTS": "SLEIGHT, cunning, dexterity [n]\n",
  "SLENDER": "slight of build [adj SLENDERER, SLENDEREST, SLENDERLY]\n",
  "SLENDERER": "SLENDER, slight of build [adj]\n",
  "SLENDEREST": "SLENDER, slight of build [adj]\n",
  "SLENDERISE": "to make or become slender, also SLENDERIZE [v SLENDERISED, SLENDERISING, SLENDERISES]\n",
  "SLENDERISED": "SLENDERISE, to make or become slender, also SLENDERIZE [v]\n",
  "SLENDERISES": "SLENDERISE, to make or become slender, also SLENDERIZE [v]\n",
  "SLENDERISING": "SLENDERISE, to make or become slender, also SLENDERIZE [v]\n",
  "SLENDERIZE": "to make or become slender, also SLENDERISE [v SLENDERIZED, SLENDERIZING, SLENDERIZES]\n",
  "SLENDERIZED": "SLENDERIZE, to make or become slender, also SLENDERISE [v]\n",
  "SLENDERIZES": "SLENDERIZE, to make or become slender, also SLENDERISE [v]\n",
  "SLENDERIZING": "SLENDERIZE, to make or become slender, also SLENDERISE [v]\n",
  "SLENDERLY": "SLENDER, slight of build [adv]\n",
  "SLENDERNESS": "the state of being slender [n -ES]\n",
  "SLENDERNESSES": "SLENDERNESS, the state of being slender [n]\n",
  "SLENTER": "(Australian slang) a dodge, a trick, also SLANTER, SLINTER [n -S]\n",
  "SLENTERS": "SLENTER, (Australian slang) a dodge, a trick, also SLANTER, SLINTER [n]\n",
  "SLEPT": "SLEEP, to be in a natural, periodic state of rest [v]\n",
  "SLEUTH": "to act as a detective [v -ED, -ING, -S]\n",
  "SLEUTHED": "SLEUTH, to act as a detective [v]\n",
  "SLEUTHHOUND": "a bloodhound; (colloquial) a detective [n -S]\n",
  "SLEUTHHOUNDS": "SLEUTHHOUND, a bloodhound; (colloquial) a detective [n]\n",
  "SLEUTHING": "the work of a detective [n -S]\n",
  "SLEUTHINGS": "SLEUTHING, the work of a detective [n]\n",
  "SLEUTHS": "SLEUTH, to act as a detective [v]\n",
  "SLEW": "to cause to move sideways, also SLUE [v -ED, -ING, -S]\n",
  "SLEWED": "SLEW, to cause to move sideways, also SLUE [v]\n",
  "SLEWING": "SLEW, to cause to move sideways, also SLUE [v]\n",
  "SLEWS": "SLEW, to cause to move sideways, also SLUE [v]\n",
  "SLEY": "a weaver's reed [n -S]\n",
  "SLEYS": "SLEY, a weaver's reed [n]\n",
  "SLICE": "to cut in pieces [v SLICED, SLICING, SLICES]\n",
  "SLICEABLE": "that can be sliced [adj]\n",
  "SLICED": "SLICE, to cut in pieces [v]\n",
  "SLICER": "one that slices [n -S]\n",
  "SLICERS": "SLICER, one that slices [n]\n",
  "SLICES": "SLICE, to cut in pieces [v]\n",
  "SLICING": "the act of slicing [n -S]\n",
  "SLICINGS": "SLICING, the act of slicing [n]\n",
  "SLICK": "smooth and slippery [adj SLICKER, SLICKEST, SLICKLY] / to make slick [v -ED, -ING, -S]\n",
  "SLICKED": "SLICK, to make slick [v]\n",
  "SLICKEN": "to smooth, polish [v -ED, -ING, -S]\n",
  "SLICKENED": "SLICKEN, to smooth, polish [v]\n",
  "SLICKENER": "one who slickens [n -S]\n",
  "SLICKENERS": "SLICKENER, one who slickens [n]\n",
  "SLICKENING": "SLICKEN, to smooth, polish [v]\n",
  "SLICKENS": "SLICKEN, to smooth, polish [v]\n",
  "SLICKENSIDE": "a polished and smoothly striated rock surface that results from friction along a fault plane [n -S]\n",
  "SLICKENSIDED": "in the form of a slickenside [adj]\n",
  "SLICKENSIDES": "SLICKENSIDE, a polished and smoothly striated rock surface that results from friction along a fault plane [n]\n",
  "SLICKER": "an oilskin raincoat [n -S]\n",
  "SLICKERED": "wearing a slicker [adj]\n",
  "SLICKERS": "SLICKER, an oilskin raincoat [n]\n",
  "SLICKEST": "SLICK, smooth and slippery [adj]\n",
  "SLICKING": "a polishing up [n -S]\n",
  "SLICKINGS": "SLICKING, a polishing up [n]\n",
  "SLICKLY": "SLICK, smooth and slippery [adv]\n",
  "SLICKNESS": "the state of being slick [n -ES]\n",
  "SLICKNESSES": "SLICKNESS, the state of being slick [n]\n",
  "SLICKROCK": "smooth wind-polished rock [n -S]\n",
  "SLICKROCKS": "SLICKROCK, smooth wind-polished rock [n]\n",
  "SLICKS": "SLICK, to make slick [v]\n",
  "SLICKSTER": "a dishonest person [n -S]\n",
  "SLICKSTERS": "SLICKSTER, a dishonest person [n]\n",
  "SLICKSTONE": "a polishing stone, also SLEEKSTONE [n -S]\n",
  "SLICKSTONES": "SLICKSTONE, a polishing stone, also SLEEKSTONE [n]\n",
  "SLID": "SLIDE, to move smoothly along a surface [v]\n",
  "SLIDABLE": "able to be slid [adj]\n",
  "SLIDDEN": "SLIDE, to move smoothly along a surface [v]\n",
  "SLIDDER": "(Scots) to slip, slide [v -ED, -ING, -S]\n",
  "SLIDDERED": "SLIDDER, (Scots) to slip, slide [v]\n",
  "SLIDDERIER": "SLIDDERY, slippery [adj]\n",
  "SLIDDERIEST": "SLIDDERY, slippery [adj]\n",
  "SLIDDERING": "SLIDDER, (Scots) to slip, slide [v]\n",
  "SLIDDERS": "SLIDDER, (Scots) to slip, slide [v]\n",
  "SLIDDERY": "slippery [adj SLIDDERIER, SLIDDERIEST]\n",
  "SLIDE": "to move smoothly along a surface [v SLID or SLIDED, SLIDDEN, SLIDING, SLIDES]\n",
  "SLIDED": "SLIDE, to move smoothly along a surface [v]\n",
  "SLIDER": "a person who or thing that slides [n -S]\n",
  "SLIDERS": "SLIDER, a person who or thing that slides [n]\n",
  "SLIDES": "SLIDE, to move smoothly along a surface [v]\n",
  "SLIDESHOW": "a show involving slides [n -S]\n",
  "SLIDESHOWS": "SLIDESHOW, a show involving slides [n]\n",
  "SLIDEWAY": "a route along which something slides [n -S]\n",
  "SLIDEWAYS": "SLIDEWAY, a route along which something slides [n]\n",
  "SLIDING": "the act of sliding [n -S]\n",
  "SLIDINGLY": "SLIDING [adv]\n",
  "SLIDINGS": "SLIDING, the act of sliding [n]\n",
  "SLIER": "SLY, cunning, wily; surreptitious [adj]\n",
  "SLIEST": "SLY, cunning, wily; surreptitious [adj]\n",
  "SLIEVE": "(Irish) a mountain [n -S]\n",
  "SLIEVES": "SLIEVE, (Irish) a mountain [n]\n",
  "SLIGHT": "small in size or amount [adj SLIGHTER, SLIGHTEST, SLIGHTLY] / to treat with disregard [v -ED, -ING, -S]\n",
  "SLIGHTED": "SLIGHT, to treat with disregard [v]\n",
  "SLIGHTER": "one who slights [n -S]\n",
  "SLIGHTERS": "SLIGHTER, one who slights [n]\n",
  "SLIGHTEST": "SLIGHT, small in size or amount [adj]\n",
  "SLIGHTING": "SLIGHT, to treat with disregard [v]\n",
  "SLIGHTINGLY": "SLIGHTING, SLIGHT, to treat with disregard [adv]\n",
  "SLIGHTISH": "somewhat slight [adj]\n",
  "SLIGHTLY": "SLIGHT, small in size or amount [adv]\n",
  "SLIGHTNESS": "the state of being slight [n -ES]\n",
  "SLIGHTNESSES": "SLIGHTNESS, the state of being slight [n]\n",
  "SLIGHTS": "SLIGHT, to treat with disregard [v]\n",
  "SLILY": "SLY, cunning, wily; surreptitious [adv]\n",
  "SLIM": "slender [adj SLIMMER, SLIMMEST, SLIMLY] / to make slim [v SLIMMED, SLIMMING, SLIMS]\n",
  "SLIMDOWN": "an instance of an organisation slimming down [n -S]\n",
  "SLIMDOWNS": "SLIMDOWN, an instance of an organisation slimming down [n]\n",
  "SLIME": "to cover with viscous mud [v SLIMED, SLIMING, SLIMES]\n",
  "SLIMEBAG": "an odious and contemptible person [n -S]\n",
  "SLIMEBAGS": "SLIMEBAG, an odious and contemptible person [n]\n",
  "SLIMEBALL": "(slang) a disgusting person [n -S]\n",
  "SLIMEBALLS": "SLIMEBALL, (slang) a disgusting person [n]\n",
  "SLIMED": "SLIME, to cover with viscous mud [v]\n",
  "SLIMES": "SLIME, to cover with viscous mud [v]\n",
  "SLIMIER": "SLIMY, resembling slime [adj]\n",
  "SLIMIEST": "SLIMY, resembling slime [adj]\n",
  "SLIMILY": "SLIMY, resembling slime [adv]\n",
  "SLIMINESS": "the state of being slimy [n -ES]\n",
  "SLIMINESSES": "SLIMINESS, the state of being slimy [n]\n",
  "SLIMING": "SLIME, to cover with viscous mud [v]\n",
  "SLIMLINE": "slim, or conducive to slimness [adj]\n",
  "SLIMLY": "SLIM, slender [adv]\n",
  "SLIMMED": "SLIM, to make slim [v]\n",
  "SLIMMER": "one engaged in slimming [n -S]\n",
  "SLIMMERS": "SLIMMER, one engaged in slimming [n]\n",
  "SLIMMEST": "SLIM, slender [adj]\n",
  "SLIMMING": "the act of slimming [n -S]\n",
  "SLIMMINGS": "SLIMMING, the act of slimming [n]\n",
  "SLIMMISH": "somewhat slim [adj]\n",
  "SLIMNASTICS": "exercises designed to reduce one's weight [n]\n",
  "SLIMNESS": "the state of being slim [n -ES]\n",
  "SLIMNESSES": "SLIMNESS, the state of being slim [n]\n",
  "SLIMPSIER": "SLIMPSY, flimsy, also SLIMSY [adj]\n",
  "SLIMPSIEST": "SLIMPSY, flimsy, also SLIMSY [adj]\n",
  "SLIMPSY": "flimsy, also SLIMSY [adj SLIMPSIER, SLIMPSIEST]\n",
  "SLIMS": "SLIM, to make slim [v]\n",
  "SLIMSIER": "SLIMSY, flimsy, also SLIMPSY [adj]\n",
  "SLIMSIEST": "SLIMSY, flimsy, also SLIMPSY [adj]\n",
  "SLIMSY": "flimsy, also SLIMPSY [adj SLIMSIER, SLIMSIEST]\n",
  "SLIMY": "resembling slime [adj SLIMIER, SLIMIEST]\n",
  "SLING": "to throw with a sudden motion [v SLUNG, SLINGING, SLINGS]\n",
  "SLINGBACK": "a shoe without a covering for the heel, supported by a strap round the heel [n -S]\n",
  "SLINGBACKS": "SLINGBACK, a shoe without a covering for the heel, supported by a strap round the heel [n]\n",
  "SLINGER": "one who uses a sling [n -S]\n",
  "SLINGERS": "SLINGER, one who uses a sling [n]\n",
  "SLINGIER": "SLINGY, denoting a throwing motion which resembles the action of using a sling [adj]\n",
  "SLINGIEST": "SLINGY, denoting a throwing motion which resembles the action of using a sling [adj]\n",
  "SLINGING": "SLING, to throw with a sudden motion [v]\n",
  "SLINGS": "SLING, to throw with a sudden motion [v]\n",
  "SLINGSHOT": "a stone from a sling [n -S]\n",
  "SLINGSHOTS": "SLINGSHOT, a stone from a sling [n]\n",
  "SLINGSTONE": "a stone for use in a sling [n -S]\n",
  "SLINGSTONES": "SLINGSTONE, a stone for use in a sling [n]\n",
  "SLINGY": "denoting a throwing motion which resembles the action of using a sling [adj SLINGIER, SLINGIEST]\n",
  "SLINK": "to move stealthily [v SLANK or SLINKED, SLUNK, SLINKING, SLINKS]\n",
  "SLINKED": "SLINK, to move stealthily [v]\n",
  "SLINKER": "one who slinks [n -S]\n",
  "SLINKERS": "SLINKER, one who slinks [n]\n",
  "SLINKIER": "SLINKY, slinking, close-fitting [adj]\n",
  "SLINKIEST": "SLINKY, slinking, close-fitting [adj]\n",
  "SLINKILY": "SLINKY, slinking, close-fitting [adv]\n",
  "SLINKINESS": "the state of being slinky [n -ES]\n",
  "SLINKINESSES": "SLINKINESS, the state of being slinky [n]\n",
  "SLINKING": "SLINK, to move stealthily [v]\n",
  "SLINKS": "SLINK, to move stealthily [v]\n",
  "SLINKSKIN": "the skin of a slink (a prematurely born calf), or leather made from it [n -S]\n",
  "SLINKSKINS": "SLINKSKIN, the skin of a slink (a prematurely born calf), or leather made from it [n]\n",
  "SLINKWEED": "rosebay willowherb or other flower believed to make cattle slink, i.e. give birth prematurely [n -S]\n",
  "SLINKWEEDS": "SLINKWEED, rosebay willowherb or other flower believed to make cattle slink, i.e. give birth prematurely [n]\n",
  "SLINKY": "slinking, close-fitting [adj SLINKIER, SLINKIEST, SLINKILY]\n",
  "SLINTER": "(Australian slang) a trick, also SLANTER [n -S]\n",
  "SLINTERS": "SLINTER, (Australian slang) a trick, also SLANTER [n]\n",
  "SLIOTAR": "(Irish) the ball used in hurling [n -S]\n",
  "SLIOTARS": "SLIOTAR, (Irish) the ball used in hurling [n]\n",
  "SLIP": "to slide suddenly and accidentally [v SLIPPED, SLIPT, SLIPPING, SLIPS]\n",
  "SLIPCASE": "a protective case for a book [n -S]\n",
  "SLIPCASED": "contained in a slipcase [adj]\n",
  "SLIPCASES": "SLIPCASE, a protective case for a book [n]\n",
  "SLIPCOVER": "a cover for a book that slips on and off [n -S] / to cover with a slipcover [v -ED, -ING, -S]\n",
  "SLIPCOVERED": "SLIPCOVER, to cover with a slipcover [v]\n",
  "SLIPCOVERING": "SLIPCOVER, to cover with a slipcover [v]\n",
  "SLIPCOVERS": "SLIPCOVER, a cover for a book that slips on and off [n]\n",
  "SLIPDRESS": "a silky sleeveless dress [n -ES]\n",
  "SLIPDRESSES": "SLIPDRESS, a silky sleeveless dress [n]\n",
  "SLIPE": "to peel [v SLIPED, SLIPING, SLIPES]\n",
  "SLIPED": "SLIPE, to peel [v]\n",
  "SLIPES": "SLIPE, to peel [v]\n",
  "SLIPFORM": "to construct with the use of a mould [v -ED, -ING, -S]\n",
  "SLIPFORMED": "SLIPFORM, to construct with the use of a mould [v]\n",
  "SLIPFORMING": "SLIPFORM, to construct with the use of a mould [v]\n",
  "SLIPFORMS": "SLIPFORM, to construct with the use of a mould [v]\n",
  "SLIPING": "SLIPE, to peel [v]\n",
  "SLIPKNOT": "a knot that adjusts tightness by slipping along a rope [n -S]\n",
  "SLIPKNOTS": "SLIPKNOT, a knot that adjusts tightness by slipping along a rope [n]\n",
  "SLIPLESS": "free from errors [adj]\n",
  "SLIPNOOSE": "a noose made with a slipknot, that tightens when pulled [n -S]\n",
  "SLIPNOOSES": "SLIPNOOSE, a noose made with a slipknot, that tightens when pulled [n]\n",
  "SLIPOUT": "an insertion in a newspaper [n -S]\n",
  "SLIPOUTS": "SLIPOUT, an insertion in a newspaper [n]\n",
  "SLIPOVER": "a garment easily put on over the head [n -S]\n",
  "SLIPOVERS": "SLIPOVER, a garment easily put on over the head [n]\n",
  "SLIPPAGE": "a falling off from a standard [n -S]\n",
  "SLIPPAGES": "SLIPPAGE, a falling off from a standard [n]\n",
  "SLIPPED": "SLIP, to slide suddenly and accidentally [v]\n",
  "SLIPPER": "a shoe easily slipped onto the foot, esp. a loose indoor shoe [n -S] / to beat with a slipper [v -ED, -ING, -S]\n",
  "SLIPPERED": "SLIPPER, to beat with a slipper [v]\n",
  "SLIPPERIER": "SLIPPERY, causing slips [adj]\n",
  "SLIPPERIEST": "SLIPPERY, causing slips [adj]\n",
  "SLIPPERILY": "SLIPPERY, causing slips [adv]\n",
  "SLIPPERINESS": "the state of being slippery [n -ES]\n",
  "SLIPPERINESSES": "SLIPPERINESS, the state of being slippery [n]\n",
  "SLIPPERING": "SLIPPER, to beat with a slipper [v]\n",
  "SLIPPERS": "SLIPPER, to beat with a slipper [v]\n",
  "SLIPPERWORT": "the calceolaria [n -S]\n",
  "SLIPPERWORTS": "SLIPPERWORT, the calceolaria [n]\n",
  "SLIPPERY": "causing slips [adj SLIPPERIER, SLIPPERIEST, SLIPPERILY]\n",
  "SLIPPIER": "SLIPPY, slippery [adj]\n",
  "SLIPPIEST": "SLIPPY, slippery [adj]\n",
  "SLIPPILY": "SLIPPY, slippery [adv]\n",
  "SLIPPINESS": "the state of being slippy [n -ES]\n",
  "SLIPPINESSES": "SLIPPINESS, the state of being slippy [n]\n",
  "SLIPPING": "SLIP, to slide suddenly and accidentally [v]\n",
  "SLIPPY": "slippery [adj SLIPPIER, SLIPPIEST, SLIPPILY]\n",
  "SLIPRAIL": "(Australian) a movable rail serving as a gate [n -S]\n",
  "SLIPRAILS": "SLIPRAIL, (Australian) a movable rail serving as a gate [n]\n",
  "SLIPS": "SLIP, to slide suddenly and accidentally [v]\n",
  "SLIPSHEET": "a sheet of paper that is interleaved between freshly pressed sheets [n -S] / to insert a slipsheet [v -ED, -ING, -S]\n",
  "SLIPSHEETED": "SLIPSHEET, to insert a slipsheet [v]\n",
  "SLIPSHEETING": "SLIPSHEET, to insert a slipsheet [v]\n",
  "SLIPSHEETS": "SLIPSHEET, a sheet of paper that is interleaved between freshly pressed sheets [n]\n",
  "SLIPSHOD": "carelessly done [adj]\n",
  "SLIPSHODDINESS": "the state of being slipshod [n]\n",
  "SLIPSHODNESS": "the state of being slipshod [n -ES]\n",
  "SLIPSHODNESSES": "SLIPSHODNESS, the state of being slipshod [n]\n",
  "SLIPSLOP": "watery food [n -S]\n",
  "SLIPSLOPPIER": "SLIPSLOPPY, sloppy, nonsensical [adj]\n",
  "SLIPSLOPPIEST": "SLIPSLOPPY, sloppy, nonsensical [adj]\n",
  "SLIPSLOPPY": "sloppy, nonsensical [adj SLIPSLOPPIER, SLIPSLOPPIEST]\n",
  "SLIPSLOPS": "SLIPSLOP, watery food [n]\n",
  "SLIPSOLE": "a thin insole [n -S]\n",
  "SLIPSOLES": "SLIPSOLE, a thin insole [n]\n",
  "SLIPSTREAM": "the stream of air driven back by e.g. an aircraft propeller [n -S] / to drive in the slipstream of a vehicle [v -ED, -ING, -S]\n",
  "SLIPSTREAMED": "SLIPSTREAM, to drive in the slipstream of a vehicle [v]\n",
  "SLIPSTREAMING": "SLIPSTREAM, to drive in the slipstream of a vehicle [v]\n",
  "SLIPSTREAMS": "SLIPSTREAM, to drive in the slipstream of a vehicle [v]\n",
  "SLIPT": "SLIP, to slide suddenly and accidentally [v]\n",
  "SLIPUP": "a mistake [n -S]\n",
  "SLIPUPS": "SLIPUP, a mistake [n]\n",
  "SLIPWARE": "pottery decorated with slip [n -S]\n",
  "SLIPWARES": "SLIPWARE, pottery decorated with slip [n]\n",
  "SLIPWAY": "a ramp sloping into water for supporting a ship [n -S]\n",
  "SLIPWAYS": "SLIPWAY, a ramp sloping into water for supporting a ship [n]\n",
  "SLISH": "(Shakespeare) a cut [n -ES]\n",
  "SLISHES": "SLISH, (Shakespeare) a cut [n]\n",
  "SLIT": "to make a long narrow cut in [v SLITTED, SLITTING, SLITS]\n",
  "SLITHER": "to slide from side to side [v -ED, -ING, -S]\n",
  "SLITHERED": "SLITHER, to slide from side to side [v]\n",
  "SLITHERIER": "SLITHERY, given to slithering [adj]\n",
  "SLITHERIEST": "SLITHERY, given to slithering [adj]\n",
  "SLITHERING": "SLITHER, to slide from side to side [v]\n",
  "SLITHERS": "SLITHER, to slide from side to side [v]\n",
  "SLITHERY": "given to slithering [adj SLITHERIER, SLITHERIEST]\n",
  "SLITLESS": "without slits [adj]\n",
  "SLITLIKE": "like a slit [adj]\n",
  "SLITS": "SLIT, to make a long narrow cut in [v]\n",
  "SLITTED": "SLIT, to make a long narrow cut in [v]\n",
  "SLITTER": "one who, or that which, slits [n -S]\n",
  "SLITTERS": "SLITTER, one who, or that which, slits [n]\n",
  "SLITTIER": "SLITTY, of an opening, long and narrow [adj]\n",
  "SLITTIEST": "SLITTY, of an opening, long and narrow [adj]\n",
  "SLITTING": "SLIT, to make a long narrow cut in [v]\n",
  "SLITTY": "of an opening, long and narrow [adj SLITTIER, SLITTIEST]\n",
  "SLIVE": "to slip [v SLOVE or SLIVED, SLIVEN, SLIVING, SLIVES]\n",
  "SLIVED": "SLIVE, to slip [v]\n",
  "SLIVEN": "SLIVE, to slip [v]\n",
  "SLIVER": "to cut into long, thin pieces [v -ED, -ING, -S]\n",
  "SLIVERED": "SLIVER, to cut into long, thin pieces [v]\n",
  "SLIVERER": "one who slivers [n -S]\n",
  "SLIVERERS": "SLIVERER, one who slivers [n]\n",
  "SLIVERING": "SLIVER, to cut into long, thin pieces [v]\n",
  "SLIVERS": "SLIVER, to cut into long, thin pieces [v]\n",
  "SLIVES": "SLIVE, to slip [v]\n",
  "SLIVING": "SLIVE, to slip [v]\n",
  "SLIVOVIC": "(Serbo-Croat) a dry plum brandy, also SLIVOVICA, SLIVOVITZ, SLIVOWITZ [n -ES]\n",
  "SLIVOVICA": "(Serbo-Croat) a dry plum brandy, also SLIVOVIC, SLIVOVITZ, SLIVOWITZ [n -S]\n",
  "SLIVOVICAS": "SLIVOVICA, (Serbo-Croat) a dry plum brandy, also SLIVOVIC, SLIVOVITZ, SLIVOWITZ [n]\n",
  "SLIVOVICES": "SLIVOVIC, (Serbo-Croat) a dry plum brandy, also SLIVOVICA, SLIVOVITZ, SLIVOWITZ [n]\n",
  "SLIVOVITZ": "(Serbo-Croat) a dry plum brandy, also SLIVOVIC, SLIVOVICA, SLIVOWITZ [n -ES]\n",
  "SLIVOVITZES": "SLIVOVITZ, (Serbo-Croat) a dry plum brandy, also SLIVOVIC, SLIVOVICA, SLIVOWITZ [n]\n",
  "SLIVOWITZ": "(Serbo-Croat) a dry plum brandy, also SLIVOVIC, SLIVOVICA, SLIVOVITZ [n -ES]\n",
  "SLIVOWITZES": "SLIVOWITZ, (Serbo-Croat) a dry plum brandy, also SLIVOVIC, SLIVOVICA, SLIVOVITZ [n]\n",
  "SLOAN": "(Scots) a snub, reproof [n -S]\n",
  "SLOANS": "SLOAN, (Scots) a snub, reproof [n]\n",
  "SLOB": "to behave in a boorish manner [v SLOBBED, SLOBBING, SLOBS]\n",
  "SLOBBED": "SLOB, to behave in a boorish manner [v]\n",
  "SLOBBER": "to drool, also SLABBER [v -ED, -ING, -S]\n",
  "SLOBBERED": "SLOBBER, to drool, also SLABBER [v]\n",
  "SLOBBERER": "one who slobbers [n -S]\n",
  "SLOBBERERS": "SLOBBERER, one who slobbers [n]\n",
  "SLOBBERIER": "SLOBBERY, slobbering [adj]\n",
  "SLOBBERIEST": "SLOBBERY, slobbering [adj]\n",
  "SLOBBERING": "SLOBBER, to drool, also SLABBER [v]\n",
  "SLOBBERS": "SLOBBER, to drool, also SLABBER [v]\n",
  "SLOBBERY": "slobbering [adj SLOBBERIER, SLOBBERIEST]\n",
  "SLOBBIER": "SLOBBY, characteristic of a slob [adj]\n",
  "SLOBBIEST": "SLOBBY, characteristic of a slob [adj]\n",
  "SLOBBING": "SLOB, to behave in a boorish manner [v]\n",
  "SLOBBISH": "boorish [adj]\n",
  "SLOBBISHNESS": "the state of being slobbish [n -ES]\n",
  "SLOBBISHNESSES": "SLOBBISHNESS, the state of being slobbish [n]\n",
  "SLOBBY": "characteristic of a slob [adj SLOBBIER, SLOBBIEST]\n",
  "SLOBLAND": "a mudflat, reclaimed alluvial land [n -S]\n",
  "SLOBLANDS": "SLOBLAND, a mudflat, reclaimed alluvial land [n]\n",
  "SLOBS": "SLOB, to behave in a boorish manner [v]\n",
  "SLOCKDOLAGER": "a conclusive argument, a hard blow, also SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SLOCKDOLAGERS": "SLOCKDOLAGER, a conclusive argument, a hard blow, also SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SLOCKDOLIGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SLOCKDOLIGERS": "SLOCKDOLIGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SLOCKDOLOGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SLOCKDOLOGERS": "SLOCKDOLOGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SLOCKEN": "(Scots) to quench, moisten, also SLOKEN [v -ED, -ING, -S]\n",
  "SLOCKENED": "SLOCKEN, (Scots) to quench, moisten, also SLOKEN [v]\n",
  "SLOCKENING": "SLOCKEN, (Scots) to quench, moisten, also SLOKEN [v]\n",
  "SLOCKENS": "SLOCKEN, (Scots) to quench, moisten, also SLOKEN [v]\n",
  "SLOE": "the fruit of the blackthorn, also SLAE [n -S]\n",
  "SLOEBUSH": "the blackthorn, also SLOETHORN, SLOETREE [n -ES]\n",
  "SLOEBUSHES": "SLOEBUSH, the blackthorn, also SLOETHORN, SLOETREE [n]\n",
  "SLOES": "SLOE, the fruit of the blackthorn, also SLAE [n]\n",
  "SLOETHORN": "the blackthorn, also SLOEBUSH, SLOETREE [n -S]\n",
  "SLOETHORNS": "SLOETHORN, the blackthorn, also SLOEBUSH, SLOETREE [n]\n",
  "SLOETREE": "the blackthorn tree, also SLOEBUSH, SLOETHORN [n -S]\n",
  "SLOETREES": "SLOETREE, the blackthorn tree, also SLOEBUSH, SLOETHORN [n]\n",
  "SLOG": "to plod [v SLOGGED, SLOGGING, SLOGS]\n",
  "SLOGAN": "a motto adopted by a group, also SLUGHORN, SLUGHORNE [n -S]\n",
  "SLOGANED": "having a slogan [adj]\n",
  "SLOGANEER": "to invent or make heavy use of slogans [v -ED, -ING, -S]\n",
  "SLOGANEERED": "SLOGANEER, to invent or make heavy use of slogans [v]\n",
  "SLOGANEERING": "making use of slogans [n -S]\n",
  "SLOGANEERINGS": "SLOGANEERING, making use of slogans [n]\n",
  "SLOGANEERS": "SLOGANEER, to invent or make heavy use of slogans [v]\n",
  "SLOGANISE": "to utter or repeat slogans, also SLOGANIZE [v SLOGANISED, SLOGANISING, SLOGANISES]\n",
  "SLOGANISED": "SLOGANISE, to utter or repeat slogans, also SLOGANIZE [v]\n",
  "SLOGANISES": "SLOGANISE, to utter or repeat slogans, also SLOGANIZE [v]\n",
  "SLOGANISING": "the utterance of slogans [n -S]\n",
  "SLOGANISINGS": "SLOGANISING, the utterance of slogans [n]\n",
  "SLOGANIZE": "to utter or repeat slogans, also SLOGANISE [v SLOGANIZED, SLOGANIZING, SLOGANIZES]\n",
  "SLOGANIZED": "SLOGANIZE, to utter or repeat slogans, also SLOGANISE [v]\n",
  "SLOGANIZES": "SLOGANIZE, to utter or repeat slogans, also SLOGANISE [v]\n",
  "SLOGANIZING": "the utterance of slogans [n -S]\n",
  "SLOGANIZINGS": "SLOGANIZING, the utterance of slogans [n]\n",
  "SLOGANS": "SLOGAN, a motto adopted by a group, also SLUGHORN, SLUGHORNE [n]\n",
  "SLOGGED": "SLOG, to plod [v]\n",
  "SLOGGER": "a person who hits hard in boxing, baseball, etc., also SLUGGER [n -S]\n",
  "SLOGGERS": "SLOGGER, a person who hits hard in boxing, baseball, etc., also SLUGGER [n]\n",
  "SLOGGING": "SLOG, to plod [v]\n",
  "SLOGS": "SLOG, to plod [v]\n",
  "SLOID": "(Swedish) a Swedish system of manual training by woodwork, also SLOJD, SLOYD [n -S]\n",
  "SLOIDS": "SLOID, (Swedish) a Swedish system of manual training by woodwork, also SLOJD, SLOYD [n]\n",
  "SLOJD": "(Swedish) a Swedish system of manual training by woodwork, also SLOID, SLOYD [n -S]\n",
  "SLOJDS": "SLOJD, (Swedish) a Swedish system of manual training by woodwork, also SLOID, SLOYD [n]\n",
  "SLOKEN": "(Scots) to quench, moisten, also SLOCKEN [v -ED, -ING, -S]\n",
  "SLOKENED": "SLOKEN, (Scots) to quench, moisten, also SLOCKEN [v]\n",
  "SLOKENING": "SLOKEN, (Scots) to quench, moisten, also SLOCKEN [v]\n",
  "SLOKENS": "SLOKEN, (Scots) to quench, moisten, also SLOCKEN [v]\n",
  "SLOMMOCK": "(dialect) to walk with a hip-rolling gait, also SLUMMOCK [v -ED, -ING, -S]\n",
  "SLOMMOCKED": "SLOMMOCK, (dialect) to walk with a hip-rolling gait, also SLUMMOCK [v]\n",
  "SLOMMOCKING": "SLOMMOCK, (dialect) to walk with a hip-rolling gait, also SLUMMOCK [v]\n",
  "SLOMMOCKS": "SLOMMOCK, (dialect) to walk with a hip-rolling gait, also SLUMMOCK [v]\n",
  "SLOMO": "a slow-motion film [n -S]\n",
  "SLOMOS": "SLOMO, a slow-motion film [n]\n",
  "SLOOM": "to slumber [v -ED, -ING, -S]\n",
  "SLOOMED": "SLOOM, to slumber [v]\n",
  "SLOOMIER": "SLOOMY, sluggish, spiritless [adj]\n",
  "SLOOMIEST": "SLOOMY, sluggish, spiritless [adj]\n",
  "SLOOMING": "SLOOM, to slumber [v]\n",
  "SLOOMS": "SLOOM, to slumber [v]\n",
  "SLOOMY": "sluggish, spiritless [adj SLOOMIER, SLOOMIEST]\n",
  "SLOOP": "a type of single-masted sailing vessel [n -S]\n",
  "SLOOPS": "SLOOP, a type of single-masted sailing vessel [n]\n",
  "SLOOSH": "to wash or rinse with (usually large quantities of) water or other liquid [v -ED, -ING, -ES]\n",
  "SLOOSHED": "SLOOSH, to wash or rinse with (usually large quantities of) water or other liquid [v]\n",
  "SLOOSHES": "SLOOSH, to wash or rinse with (usually large quantities of) water or other liquid [v]\n",
  "SLOOSHING": "SLOOSH, to wash or rinse with (usually large quantities of) water or other liquid [v]\n",
  "SLOOT": "(South African) a narrow water-channel, also SLUIT [n -S]\n",
  "SLOOTS": "SLOOT, (South African) a narrow water-channel, also SLUIT [n]\n",
  "SLOP": "to spill or splash [v SLOPPED, SLOPPING, SLOPS]\n",
  "SLOPE": "to slant or incline [v SLOPED, SLOPING, SLOPES]\n",
  "SLOPED": "SLOPE, to slant or incline [v]\n",
  "SLOPER": "a native or inhabitant of the Pacific slope of the United States [n -S]\n",
  "SLOPERS": "SLOPER, a native or inhabitant of the Pacific slope of the United States [n]\n",
  "SLOPES": "SLOPE, to slant or incline [v]\n",
  "SLOPESIDE": "the side of a slope, especially a ski slope [n -S]\n",
  "SLOPESIDES": "SLOPESIDE, the side of a slope, especially a ski slope [n]\n",
  "SLOPEWISE": "obliquely [adv]\n",
  "SLOPIER": "SLOPY, sloping [adj]\n",
  "SLOPIEST": "SLOPY, sloping [adj]\n",
  "SLOPING": "SLOPE, to slant or incline [v]\n",
  "SLOPINGLY": "SLOPING, SLOPE, to slant or incline [adv]\n",
  "SLOPINGNESS": "the state of being sloping [n -ES]\n",
  "SLOPINGNESSES": "SLOPINGNESS, the state of being sloping [n]\n",
  "SLOPPED": "SLOP, to spill or splash [v]\n",
  "SLOPPIER": "SLOPPY, wet or muddy [adj]\n",
  "SLOPPIEST": "SLOPPY, wet or muddy [adj]\n",
  "SLOPPILY": "SLOPPY, wet or muddy [adv]\n",
  "SLOPPINESS": "the state of being sloppy [n -ES]\n",
  "SLOPPINESSES": "SLOPPINESS, the state of being sloppy [n]\n",
  "SLOPPING": "SLOP, to spill or splash [v]\n",
  "SLOPPY": "wet or muddy [adj SLOPPIER, SLOPPIEST, SLOPPILY]\n",
  "SLOPS": "SLOP, to spill or splash [v]\n",
  "SLOPWORK": "the manufacture of cheap clothing [n -S]\n",
  "SLOPWORKER": "one who does slopwork, the making of slop-clothing [n -S]\n",
  "SLOPWORKERS": "SLOPWORKER, one who does slopwork, the making of slop-clothing [n]\n",
  "SLOPWORKS": "SLOPWORK, the manufacture of cheap clothing [n]\n",
  "SLOPY": "sloping [adj SLOPIER, SLOPIEST]\n",
  "SLORM": "to wipe carelessly [v -ED, -ING, -S]\n",
  "SLORMED": "SLORM, to wipe carelessly [v]\n",
  "SLORMING": "SLORM, to wipe carelessly [v]\n",
  "SLORMS": "SLORM, to wipe carelessly [v]\n",
  "SLOSH": "to move with a splashing motion [v -ED, -ING, -ES]\n",
  "SLOSHED": "SLOSH, to move with a splashing motion [v]\n",
  "SLOSHES": "SLOSH, to move with a splashing motion [v]\n",
  "SLOSHIER": "SLOSHY, splashy [adj]\n",
  "SLOSHIEST": "SLOSHY, splashy [adj]\n",
  "SLOSHING": "the bulk motion of liquid propellants in their tanks [n -S]\n",
  "SLOSHINGS": "SLOSHING, the bulk motion of liquid propellants in their tanks [n]\n",
  "SLOSHY": "splashy [adj SLOSHIER, SLOSHIEST]\n",
  "SLOT": "to cut a long narrow opening in [v SLOTTED, SLOTTING, SLOTS]\n",
  "SLOTBACK": "a type of football player [n -S]\n",
  "SLOTBACKS": "SLOTBACK, a type of football player [n]\n",
  "SLOTH": "to be lazy [v -ED, -ING, -S]\n",
  "SLOTHED": "SLOTH, to be lazy [v]\n",
  "SLOTHFUL": "sluggish [adj SLOTHFULLY]\n",
  "SLOTHFULLY": "SLOTHFUL, sluggish [adv]\n",
  "SLOTHFULNESS": "the state of being slothful [n -ES]\n",
  "SLOTHFULNESSES": "SLOTHFULNESS, the state of being slothful [n]\n",
  "SLOTHING": "SLOTH, to be lazy [v]\n",
  "SLOTHS": "SLOTH, to be lazy [v]\n",
  "SLOTS": "SLOT, to cut a long narrow opening in [v]\n",
  "SLOTTED": "SLOT, to cut a long narrow opening in [v]\n",
  "SLOTTER": "a machine that cuts slots [n -S]\n",
  "SLOTTERS": "SLOTTER, a machine that cuts slots [n]\n",
  "SLOTTING": "SLOT, to cut a long narrow opening in [v]\n",
  "SLOUCH": "to sit, stand, or move with a drooping posture [v -ED, -ING, -ES]\n",
  "SLOUCHED": "SLOUCH, to sit, stand, or move with a drooping posture [v]\n",
  "SLOUCHER": "one who slouches [n -S]\n",
  "SLOUCHERS": "SLOUCHER, one who slouches [n]\n",
  "SLOUCHES": "SLOUCH, to sit, stand, or move with a drooping posture [v]\n",
  "SLOUCHIER": "SLOUCHY, slouching [adj]\n",
  "SLOUCHIEST": "SLOUCHY, slouching [adj]\n",
  "SLOUCHILY": "SLOUCHY, slouching [adv]\n",
  "SLOUCHINESS": "the state of being slouchy [n -ES]\n",
  "SLOUCHINESSES": "SLOUCHINESS, the state of being slouchy [n]\n",
  "SLOUCHING": "SLOUCH, to sit, stand, or move with a drooping posture [v]\n",
  "SLOUCHINGLY": "SLOUCHING, SLOUCH, to sit, stand, or move with a drooping posture [adv]\n",
  "SLOUCHY": "slouching [adj SLOUCHIER, SLOUCHIEST, SLOUCHILY]\n",
  "SLOUGH": "to cast off [v -ED, -ING, -S]\n",
  "SLOUGHED": "SLOUGH, to cast off [v]\n",
  "SLOUGHI": "a breed of dog, originally from NW Africa, with a smooth coat, lean body, and excellent vision [n -S]\n",
  "SLOUGHIER": "SLOUGHY, full of sloughs, miry [adj]\n",
  "SLOUGHIEST": "SLOUGHY, full of sloughs, miry [adj]\n",
  "SLOUGHING": "SLOUGH, to cast off [v]\n",
  "SLOUGHIS": "SLOUGHI, a breed of dog, originally from NW Africa, with a smooth coat, lean body, and excellent vision [n]\n",
  "SLOUGHS": "SLOUGH, to cast off [v]\n",
  "SLOUGHY": "full of sloughs, miry [adj SLOUGHIER, SLOUGHIEST]\n",
  "SLOVE": "SLIVE, to slip [v]\n",
  "SLOVEN": "a slovenly person [n -S]\n",
  "SLOVENLIER": "SLOVENLY, habitually untidy or unclean [adj]\n",
  "SLOVENLIEST": "SLOVENLY, habitually untidy or unclean [adj]\n",
  "SLOVENLIKE": "like a sloven [adj]\n",
  "SLOVENLINESS": "the state of being slovenly [n -ES]\n",
  "SLOVENLINESSES": "SLOVENLINESS, the state of being slovenly [n]\n",
  "SLOVENLY": "habitually untidy or unclean [adj SLOVENLIER, SLOVENLIEST]\n",
  "SLOVENRIES": "SLOVENRY, (Shakespeare) slovenliness [n]\n",
  "SLOVENRY": "(Shakespeare) slovenliness [n SLOVENRIES]\n",
  "SLOVENS": "SLOVEN, a slovenly person [n]\n",
  "SLOW": "to reduce speed [v -ED, -ING, -S] / moving with little speed [adj SLOWER, SLOWEST, SLOWLY]\n",
  "SLOWBACK": "(obsolete) a lazy person [n -S]\n",
  "SLOWBACKS": "SLOWBACK, (obsolete) a lazy person [n]\n",
  "SLOWCOACH": "a slow or sluggish person [n -ES]\n",
  "SLOWCOACHES": "SLOWCOACH, a slow or sluggish person [n]\n",
  "SLOWDOWN": "a lessening of pace [n -S]\n",
  "SLOWDOWNS": "SLOWDOWN, a lessening of pace [n]\n",
  "SLOWED": "SLOW, to reduce speed [v]\n",
  "SLOWER": "SLOW, moving with little speed [adj]\n",
  "SLOWEST": "SLOW, moving with little speed [adj]\n",
  "SLOWING": "the lessening of speed [n -S]\n",
  "SLOWINGS": "SLOWING, the lessening of speed [n]\n",
  "SLOWISH": "somewhat slow [adj]\n",
  "SLOWLY": "SLOW, moving with little speed [adv]\n",
  "SLOWNESS": "the state of being slow [n -ES]\n",
  "SLOWNESSES": "SLOWNESS, the state of being slow [n]\n",
  "SLOWPOKE": "a slow individual [n -S]\n",
  "SLOWPOKES": "SLOWPOKE, a slow individual [n]\n",
  "SLOWS": "SLOW, to reduce speed [v]\n",
  "SLOWWORM": "a kind of legless lizard [n -S]\n",
  "SLOWWORMS": "SLOWWORM, a kind of legless lizard [n]\n",
  "SLOYD": "(Swedish) a Swedish system of manual training by woodwork, also SLOID, SLOJD [n -S]\n",
  "SLOYDS": "SLOYD, (Swedish) a Swedish system of manual training by woodwork, also SLOID, SLOJD [n]\n",
  "SLUB": "pertaining to a soft thick yarn, also SLUBB [adj SLUBBER, SLUBBEST] / to twist fibre after carding to prepare it for spinning [v SLUBBED, SLUBBING, SLUBS]\n",
  "SLUBB": "to twist fibre after carding to prepare it for spinning, also SLUB [v -ED, -ING, -S]\n",
  "SLUBBED": "SLUB, to twist fibre after carding to prepare it for spinning [v]\n",
  "SLUBBER": "to stain or dirty [v -ED, -ING, -S]\n",
  "SLUBBERED": "SLUBBER, to stain or dirty [v]\n",
  "SLUBBERING": "smearing [adj SLUBBERINGLY] / the act of slubbering [n -S]\n",
  "SLUBBERINGLY": "SLUBBERING, smearing [adv]\n",
  "SLUBBERINGS": "SLUBBERING, the act of slubbering [n]\n",
  "SLUBBERS": "SLUBBER, to stain or dirty [v]\n",
  "SLUBBEST": "SLUB, pertaining to a soft thick yarn, also SLUBB [adj]\n",
  "SLUBBIER": "SLUBBY, lumpy, knobbly in texture [adj]\n",
  "SLUBBIEST": "SLUBBY, lumpy, knobbly in texture [adj]\n",
  "SLUBBING": "a slightly twisted roll of textile fibres [n -S]\n",
  "SLUBBINGS": "SLUBBING, a slightly twisted roll of textile fibres [n]\n",
  "SLUBBS": "SLUBB, to twist fibre after carding to prepare it for spinning, also SLUB [v]\n",
  "SLUBBY": "lumpy, knobbly in texture [adj SLUBBIER, SLUBBIEST]\n",
  "SLUBS": "SLUB, to twist fibre after carding to prepare it for spinning [v]\n",
  "SLUDGE": "to cover with a muddy deposit [v SLUDGED, SLUDGING, SLUDGES]\n",
  "SLUDGED": "SLUDGE, to cover with a muddy deposit [v]\n",
  "SLUDGES": "SLUDGE, to cover with a muddy deposit [v]\n",
  "SLUDGIER": "SLUDGY, covered with sludge [adj]\n",
  "SLUDGIEST": "SLUDGY, covered with sludge [adj]\n",
  "SLUDGING": "SLUDGE, to cover with a muddy deposit [v]\n",
  "SLUDGY": "covered with sludge [adj SLUDGIER, SLUDGIEST]\n",
  "SLUE": "to cause to move sideways, also SLEW [v SLUED, SLUEING or SLUING, SLUES]\n",
  "SLUED": "SLUE, to cause to move sideways, also SLEW [v]\n",
  "SLUEING": "SLUE, to cause to move sideways, also SLEW [v]\n",
  "SLUES": "SLUE, to cause to move sideways, also SLEW [v]\n",
  "SLUFF": "to discard a card or cards [v -ED, -ING, -S]\n",
  "SLUFFED": "SLUFF, to discard a card or cards [v]\n",
  "SLUFFING": "SLUFF, to discard a card or cards [v]\n",
  "SLUFFS": "SLUFF, to discard a card or cards [v]\n",
  "SLUG": "to strike heavily [v SLUGGED, SLUGGING, SLUGS]\n",
  "SLUGABED": "one who indulges in lying abed, also SLUGGABED [n -S]\n",
  "SLUGABEDS": "SLUGABED, one who indulges in lying abed, also SLUGGABED [n]\n",
  "SLUGFEST": "a vigorous fight [n -S]\n",
  "SLUGFESTS": "SLUGFEST, a vigorous fight [n]\n",
  "SLUGGABED": "(Shakespeare) one who indulges in lying abed; a sluggard, also SLUGABED [n -S]\n",
  "SLUGGABEDS": "SLUGGABED, (Shakespeare) one who indulges in lying abed; a sluggard, also SLUGABED [n]\n",
  "SLUGGARD": "a habitually lazy person [n -S]\n",
  "SLUGGARDISE": "(Shakespeare) to make lazy, also SLUGGARDIZE [v SLUGGARDISED, SLUGGARDISING, SLUGGARDISES]\n",
  "SLUGGARDISED": "SLUGGARDISE, (Shakespeare) to make lazy, also SLUGGARDIZE [v]\n",
  "SLUGGARDISES": "SLUGGARDISE, (Shakespeare) to make lazy, also SLUGGARDIZE [v]\n",
  "SLUGGARDISING": "SLUGGARDISE, (Shakespeare) to make lazy, also SLUGGARDIZE [v]\n",
  "SLUGGARDIZE": "(Shakespeare) to make lazy, also SLUGGARDISE [v SLUGGARDIZED, SLUGGARDIZING, SLUGGARDIZES]\n",
  "SLUGGARDIZED": "SLUGGARDIZE, (Shakespeare) to make lazy, also SLUGGARDISE [v]\n",
  "SLUGGARDIZES": "SLUGGARDIZE, (Shakespeare) to make lazy, also SLUGGARDISE [v]\n",
  "SLUGGARDIZING": "SLUGGARDIZE, (Shakespeare) to make lazy, also SLUGGARDISE [v]\n",
  "SLUGGARDLIER": "SLUGGARDLY, like a sluggard, a habitually lazy person [adj]\n",
  "SLUGGARDLIEST": "SLUGGARDLY, like a sluggard, a habitually lazy person [adj]\n",
  "SLUGGARDLINESS": "the state of being sluggardly [n]\n",
  "SLUGGARDLY": "like a sluggard, a habitually lazy person [adj SLUGGARDLIER, SLUGGARDLIEST]\n",
  "SLUGGARDNESS": "the state of being sluggard [n -ES]\n",
  "SLUGGARDNESSES": "SLUGGARDNESS, the state of being sluggard [n]\n",
  "SLUGGARDS": "SLUGGARD, a habitually lazy person [n]\n",
  "SLUGGED": "SLUG, to strike heavily [v]\n",
  "SLUGGER": "a person who hits hard in boxing, baseball, etc., also SLOGGER [n -S]\n",
  "SLUGGERS": "SLUGGER, a person who hits hard in boxing, baseball, etc., also SLOGGER [n]\n",
  "SLUGGING": "SLUG, to strike heavily [v]\n",
  "SLUGGISH": "slow-moving [adj SLUGGISHLY]\n",
  "SLUGGISHLY": "SLUGGISH, slow-moving [adv]\n",
  "SLUGGISHNESS": "the state of being sluggish [n -ES]\n",
  "SLUGGISHNESSES": "SLUGGISHNESS, the state of being sluggish [n]\n",
  "SLUGHORN": "(Browning) an old form of slogan, taken by Chatterton and then Browning to be a kind of clarion, also SLUGHORNE [n -S]\n",
  "SLUGHORNE": "(Browning) an old form of slogan, taken by Chatterton and then Browning to be a kind of clarion, also SLUGHORN [n -S]\n",
  "SLUGHORNES": "SLUGHORNE, (Browning) an old form of slogan, taken by Chatterton and then Browning to be a kind of clarion, also SLUGHORN [n]\n",
  "SLUGHORNS": "SLUGHORN, (Browning) an old form of slogan, taken by Chatterton and then Browning to be a kind of clarion, also SLUGHORNE [n]\n",
  "SLUGLIKE": "like a slug [adj]\n",
  "SLUGS": "SLUG, to strike heavily [v]\n",
  "SLUICE": "to wash with a sudden flow of water, also SLUSE [v SLUICED, SLUICING, SLUICES]\n",
  "SLUICED": "SLUICE, to wash with a sudden flow of water, also SLUSE [v]\n",
  "SLUICEGATE": "the gate of a sluice [n -S]\n",
  "SLUICEGATES": "SLUICEGATE, the gate of a sluice [n]\n",
  "SLUICELIKE": "like a sluice [adj]\n",
  "SLUICES": "SLUICE, to wash with a sudden flow of water, also SLUSE [v]\n",
  "SLUICEWAY": "an artificial channel into which water is let by a sluice [n -S]\n",
  "SLUICEWAYS": "SLUICEWAY, an artificial channel into which water is let by a sluice [n]\n",
  "SLUICIER": "SLUICY, falling in streams [adj]\n",
  "SLUICIEST": "SLUICY, falling in streams [adj]\n",
  "SLUICING": "SLUICE, to wash with a sudden flow of water, also SLUSE [v]\n",
  "SLUICY": "falling in streams [adj SLUICIER, SLUICIEST]\n",
  "SLUING": "SLUE, to cause to move sideways, also SLEW [v]\n",
  "SLUIT": "(South African) a narrow water-channel, also SLOOT [n -S]\n",
  "SLUITS": "SLUIT, (South African) a narrow water-channel, also SLOOT [n]\n",
  "SLUM": "to visit squalid urban areas [v SLUMMED, SLUMMING, SLUMS]\n",
  "SLUMBER": "to sleep [v -ED, -ING, -S]\n",
  "SLUMBERED": "SLUMBER, to sleep [v]\n",
  "SLUMBERER": "one who slumbers [n -S]\n",
  "SLUMBERERS": "SLUMBERER, one who slumbers [n]\n",
  "SLUMBERFUL": "sleepy [adj]\n",
  "SLUMBERIER": "SLUMBERY, full of slumber, also SLUMBEROUS, SLUMBROUS, SLUMBRY [adj]\n",
  "SLUMBERIEST": "SLUMBERY, full of slumber, also SLUMBEROUS, SLUMBROUS, SLUMBRY [adj]\n",
  "SLUMBERING": "sleeping [adj SLUMBERINGLY] / the act of slumbering [n -S]\n",
  "SLUMBERINGLY": "SLUMBERING, sleeping [adv]\n",
  "SLUMBERINGS": "SLUMBERING, the act of slumbering [n]\n",
  "SLUMBERLAND": "the state of slumber [n -S]\n",
  "SLUMBERLANDS": "SLUMBERLAND, the state of slumber [n]\n",
  "SLUMBERLESS": "without slumber [adj]\n",
  "SLUMBEROUS": "inviting or causing slumber, also SLUMBERY, SLUMBROUS, SLUMBRY [adj]\n",
  "SLUMBEROUSLY": "SLUMBEROUS, inviting or causing slumber, also SLUMBERY, SLUMBROUS, SLUMBRY [adv]\n",
  "SLUMBEROUSNESS": "the state of being slumberous, also SLUMBROUSNESS [n]\n",
  "SLUMBERS": "SLUMBER, to sleep [v]\n",
  "SLUMBERSOME": "sleepy [adj]\n",
  "SLUMBERY": "full of slumber, also SLUMBEROUS, SLUMBROUS, SLUMBRY [adj SLUMBERIER, SLUMBERIEST]\n",
  "SLUMBROUS": "full of sleep, also SLUMBEROUS, SLUMBERY, SLUMBRY [adj]\n",
  "SLUMBROUSLY": "SLUMBROUS, full of sleep, also SLUMBEROUS, SLUMBERY, SLUMBRY [adv]\n",
  "SLUMBROUSNESS": "the state of being slumbrous, also SLUMBEROUSNESS [n -ES]\n",
  "SLUMBROUSNESSES": "SLUMBROUSNESS, the state of being slumbrous, also SLUMBEROUSNESS [n]\n",
  "SLUMBRY": "full of slumber, also SLUMBEROUS, SLUMBERY, SLUMBROUS [adj]\n",
  "SLUMGULLION": "(Irish) a watery meat stew [n -S]\n",
  "SLUMGULLIONS": "SLUMGULLION, (Irish) a watery meat stew [n]\n",
  "SLUMGUM": "the residue remaining after honey is extracted from a honeycomb [n -S]\n",
  "SLUMGUMS": "SLUMGUM, the residue remaining after honey is extracted from a honeycomb [n]\n",
  "SLUMISM": "the prevalence of slums [n -S]\n",
  "SLUMISMS": "SLUMISM, the prevalence of slums [n]\n",
  "SLUMLORD": "a landlord of slum property [n -S]\n",
  "SLUMLORDS": "SLUMLORD, a landlord of slum property [n]\n",
  "SLUMMED": "SLUM, to visit squalid urban areas [v]\n",
  "SLUMMER": "one who slums [n -S]\n",
  "SLUMMERS": "SLUMMER, one who slums [n]\n",
  "SLUMMIER": "SLUMMY, resembling a slum [adj]\n",
  "SLUMMIEST": "SLUMMY, resembling a slum [adj]\n",
  "SLUMMING": "the visitation of slums [n -S]\n",
  "SLUMMINGS": "SLUMMING, the visitation of slums [n]\n",
  "SLUMMOCK": "to move slowly and awkwardly, also SLOMMOCK [v -ED, -ING, -S]\n",
  "SLUMMOCKED": "SLUMMOCK, to move slowly and awkwardly, also SLOMMOCK [v]\n",
  "SLUMMOCKING": "SLUMMOCK, to move slowly and awkwardly, also SLOMMOCK [v]\n",
  "SLUMMOCKS": "SLUMMOCK, to move slowly and awkwardly, also SLOMMOCK [v]\n",
  "SLUMMY": "resembling a slum [adj SLUMMIER, SLUMMIEST]\n",
  "SLUMP": "to sink suddenly [v -ED, -ING, -S]\n",
  "SLUMPED": "SLUMP, to sink suddenly [v]\n",
  "SLUMPFLATION": "a state or period of combined economic decline and rising inflation [n -S]\n",
  "SLUMPFLATIONARY": "relating to slumpflation [adj]\n",
  "SLUMPFLATIONS": "SLUMPFLATION, a state or period of combined economic decline and rising inflation [n]\n",
  "SLUMPIER": "SLUMPY, marshy [adj]\n",
  "SLUMPIEST": "SLUMPY, marshy [adj]\n",
  "SLUMPING": "SLUMP, to sink suddenly [v]\n",
  "SLUMPS": "SLUMP, to sink suddenly [v]\n",
  "SLUMPY": "marshy [adj SLUMPIER, SLUMPIEST]\n",
  "SLUMS": "SLUM, to visit squalid urban areas [v]\n",
  "SLUNG": "SLING, to throw with a sudden motion [v]\n",
  "SLUNGSHOT": "a weight attached to a cord, used as a weapon [n -S]\n",
  "SLUNGSHOTS": "SLUNGSHOT, a weight attached to a cord, used as a weapon [n]\n",
  "SLUNK": "SLINK, to move stealthily [v]\n",
  "SLUR": "to disparage [v SLURRED, SLURRING, SLURS]\n",
  "SLURB": "a poorly planned suburban area [n -S]\n",
  "SLURBAN": "like a slurb, i.e. combining the characteristics of a slum and a suburb [adj]\n",
  "SLURBS": "SLURB, a poorly planned suburban area [n]\n",
  "SLURP": "to drink noisily [v -ED, -ING, -S]\n",
  "SLURPED": "SLURP, to drink noisily [v]\n",
  "SLURPER": "one who drinks noisily [n -S]\n",
  "SLURPERS": "SLURPER, one who drinks noisily [n]\n",
  "SLURPIER": "SLURPY, like a slurp [adj]\n",
  "SLURPIEST": "SLURPY, like a slurp [adj]\n",
  "SLURPING": "SLURP, to drink noisily [v]\n",
  "SLURPS": "SLURP, to drink noisily [v]\n",
  "SLURPY": "like a slurp [adj SLURPIER, SLURPIEST]\n",
  "SLURRED": "SLUR, to disparage [v]\n",
  "SLURRIED": "SLURRY, to convert into a type of watery mixture [v]\n",
  "SLURRIES": "SLURRY, to convert into a type of watery mixture [v]\n",
  "SLURRING": "SLUR, to disparage [v]\n",
  "SLURRY": "to convert into a type of watery mixture [v SLURRIED, SLURRYING, SLURRIES]\n",
  "SLURRYING": "SLURRY, to convert into a type of watery mixture [v]\n",
  "SLURS": "SLUR, to disparage [v]\n",
  "SLURVE": "a type of pitch in baseball [n -S]\n",
  "SLURVES": "SLURVE, a type of pitch in baseball [n]\n",
  "SLUSE": "(Milton) a sluice [n -S]\n",
  "SLUSES": "SLUSE, (Milton) a sluice [n]\n",
  "SLUSH": "to splash with partly melted snow [v -ED, -ING, -ES]\n",
  "SLUSHED": "SLUSH, to splash with partly melted snow [v]\n",
  "SLUSHES": "SLUSH, to splash with partly melted snow [v]\n",
  "SLUSHIER": "SLUSHY, resembling slush [adj]\n",
  "SLUSHIES": "SLUSHY, an unskilled kitchen assistant [n]\n",
  "SLUSHIEST": "SLUSHY, resembling slush [adj]\n",
  "SLUSHILY": "SLUSHY, resembling slush [adv]\n",
  "SLUSHINESS": "the state of being slushy [n -ES]\n",
  "SLUSHINESSES": "SLUSHINESS, the state of being slushy [n]\n",
  "SLUSHING": "SLUSH, to splash with partly melted snow [v]\n",
  "SLUSHY": "resembling slush [adj SLUSHIER, SLUSHIEST, SLUSHILY] / an unskilled kitchen assistant [n SLUSHIES]\n",
  "SLUT": "a slovenly woman [n -S]\n",
  "SLUTCH": "(dialect) mud [n -ES]\n",
  "SLUTCHES": "SLUTCH, (dialect) mud [n]\n",
  "SLUTCHIER": "SLUTCHY, (English dialect) muddy [adj]\n",
  "SLUTCHIEST": "SLUTCHY, (English dialect) muddy [adj]\n",
  "SLUTCHY": "(English dialect) muddy [adj SLUTCHIER, SLUTCHIEST]\n",
  "SLUTS": "SLUT, a slovenly woman [n]\n",
  "SLUTTERIES": "SLUTTERY, the state of being a slut [n]\n",
  "SLUTTERY": "the state of being a slut [n SLUTTERIES]\n",
  "SLUTTIER": "SLUTTY, characteristic of a slut [adj]\n",
  "SLUTTIEST": "SLUTTY, characteristic of a slut [adj]\n",
  "SLUTTILY": "SLUTTY, characteristic of a slut [adv]\n",
  "SLUTTINESS": "the state of being slutty [n -ES]\n",
  "SLUTTINESSES": "SLUTTINESS, the state of being slutty [n]\n",
  "SLUTTISH": "like a slut [adj SLUTTISHLY]\n",
  "SLUTTISHLY": "SLUTTISH, like a slut [adv]\n",
  "SLUTTISHNESS": "the state of being sluttish [n -ES]\n",
  "SLUTTISHNESSES": "SLUTTISHNESS, the state of being sluttish [n]\n",
  "SLUTTY": "characteristic of a slut [adj SLUTTIER, SLUTTIEST, SLUTTILY]\n",
  "SLY": "cunning, wily; surreptitious [adj SLIER or SLYER, SLIEST or SLYEST, SLILY or SLYLY]\n",
  "SLYBOOTS": "a sly person [n SLYBOOTS]\n",
  "SLYER": "SLY, cunning, wily; surreptitious [adj]\n",
  "SLYEST": "SLY, cunning, wily; surreptitious [adj]\n",
  "SLYISH": "somewhat sly [adj]\n",
  "SLYLY": "SLY, cunning, wily; surreptitious [adv]\n",
  "SLYNESS": "the state of being sly [n -ES]\n",
  "SLYNESSES": "SLYNESS, the state of being sly [n]\n",
  "SLYPE": "a narrow passage in an English cathedral [n -S]\n",
  "SLYPES": "SLYPE, a narrow passage in an English cathedral [n]\n",
  "SMA": "(Scots) small [adj]\n",
  "SMAAK": "(South African) to like or love [v -ED, -ING, -S]\n",
  "SMAAKED": "SMAAK, (South African) to like or love [v]\n",
  "SMAAKING": "SMAAK, (South African) to like or love [v]\n",
  "SMAAKS": "SMAAK, (South African) to like or love [v]\n",
  "SMACK": "to strike sharply [v -ED, -ING, -S]\n",
  "SMACKDOWN": "a chastisement or defeat [n -S]\n",
  "SMACKDOWNS": "SMACKDOWN, a chastisement or defeat [n]\n",
  "SMACKED": "SMACK, to strike sharply [v]\n",
  "SMACKER": "(colloquial) a kiss [n -S]\n",
  "SMACKEROO": "a loud kiss; one pound stirling [n -S]\n",
  "SMACKEROOS": "SMACKEROO, a loud kiss; one pound stirling [n]\n",
  "SMACKERS": "SMACKER, (colloquial) a kiss [n]\n",
  "SMACKHEAD": "a person who is addicted to heroin [n -S]\n",
  "SMACKHEADS": "SMACKHEAD, a person who is addicted to heroin [n]\n",
  "SMACKING": "the act of smacking [n -S]\n",
  "SMACKINGS": "SMACKING, the act of smacking [n]\n",
  "SMACKS": "SMACK, to strike sharply [v]\n",
  "SMAIK": "(Scots) a contemptible fellow, a rascal [n -S]\n",
  "SMAIKS": "SMAIK, (Scots) a contemptible fellow, a rascal [n]\n",
  "SMALL": "not large [adj SMALLER, SMALLEST] / to make or become small [v -ED, -ING, -S]\n",
  "SMALLAGE": "a wild celery [n -S]\n",
  "SMALLAGES": "SMALLAGE, a wild celery [n]\n",
  "SMALLBOY": "a deputy steward in a European household in West Africa [n -S]\n",
  "SMALLBOYS": "SMALLBOY, a deputy steward in a European household in West Africa [n]\n",
  "SMALLCLOTHES": "knee-breeches, esp. those of the close-fitting eighteenth century form [n]\n",
  "SMALLED": "SMALL, to make or become small [v]\n",
  "SMALLER": "SMALL, not large [adj]\n",
  "SMALLEST": "SMALL, not large [adj]\n",
  "SMALLHOLDER": "one who keeps a smallholding [n -S]\n",
  "SMALLHOLDERS": "SMALLHOLDER, one who keeps a smallholding [n]\n",
  "SMALLHOLDING": "a small-scale farm [n -S]\n",
  "SMALLHOLDINGS": "SMALLHOLDING, a small-scale farm [n]\n",
  "SMALLING": "SMALL, to make or become small [v]\n",
  "SMALLISH": "somewhat small [adj]\n",
  "SMALLMOUTH": "a river fish, a kind of bass [n -S]\n",
  "SMALLMOUTHS": "SMALLMOUTH, a river fish, a kind of bass [n]\n",
  "SMALLNESS": "the state of being small [n -ES]\n",
  "SMALLNESSES": "SMALLNESS, the state of being small [n]\n",
  "SMALLPOX": "a virus disease [n -ES]\n",
  "SMALLPOXES": "SMALLPOX, a virus disease [n]\n",
  "SMALLS": "SMALL, to make or become small [v]\n",
  "SMALLSAT": "a relatively small, inexpensive communications satellite [n -S]\n",
  "SMALLSATS": "SMALLSAT, a relatively small, inexpensive communications satellite [n]\n",
  "SMALLSWORD": "a light sword used for thrusting only; esp. the sword worn by civilians of rank in the eighteenth century [n -S]\n",
  "SMALLSWORDS": "SMALLSWORD, a light sword used for thrusting only; esp. the sword worn by civilians of rank in the eighteenth century [n]\n",
  "SMALLTIME": "unimportant [adj]\n",
  "SMALM": "to smear, make oily, also SMARM [v -ED, -ING, -S]\n",
  "SMALMED": "SMALM, to smear, make oily, also SMARM [v]\n",
  "SMALMIER": "SMALMY, (obsolete) oily, ingratiating, also SMARMY [adj]\n",
  "SMALMIEST": "SMALMY, (obsolete) oily, ingratiating, also SMARMY [adj]\n",
  "SMALMILY": "SMALMY, (obsolete) oily, ingratiating, also SMARMY [adv]\n",
  "SMALMINESS": "(obsolete) the state of being smalmy [n -ES]\n",
  "SMALMINESSES": "SMALMINESS, (obsolete) the state of being smalmy [n]\n",
  "SMALMING": "SMALM, to smear, make oily, also SMARM [v]\n",
  "SMALMS": "SMALM, to smear, make oily, also SMARM [v]\n",
  "SMALMY": "(obsolete) oily, ingratiating, also SMARMY [adj SMALMIER, SMALMIEST]\n",
  "SMALT": "a blue pigment [n -S]\n",
  "SMALTI": "SMALTO, (Italian) a piece of coloured glass used in mosaic [n]\n",
  "SMALTINE": "a gray mineral of metallic luster, an arsenide of cobalt, nickel, and iron, also SMALTITE [n -S]\n",
  "SMALTINES": "SMALTINE, a gray mineral of metallic luster, an arsenide of cobalt, nickel, and iron, also SMALTITE [n]\n",
  "SMALTITE": "a gray mineral of metallic luster, an arsenide of cobalt, nickel, and iron, also SMALTINE [n -S]\n",
  "SMALTITES": "SMALTITE, a gray mineral of metallic luster, an arsenide of cobalt, nickel, and iron, also SMALTINE [n]\n",
  "SMALTO": "(Italian) a piece of coloured glass used in mosaic [n SMALTI or SMALTOS]\n",
  "SMALTOS": "SMALTO, (Italian) a piece of coloured glass used in mosaic [n]\n",
  "SMALTS": "SMALT, a blue pigment [n]\n",
  "SMARAGD": "(archaic) emerald, also EMERAUDE, SMARAGDE [n -S]\n",
  "SMARAGDE": "(archaic) emerald, also EMERAUDE, SMARAGD [n -S]\n",
  "SMARAGDES": "SMARAGDE, (archaic) emerald, also EMERAUDE, SMARAGD [n]\n",
  "SMARAGDINE": "emerald green [adj]\n",
  "SMARAGDITE": "a green foliated kind of amphibole, observed in eclogite and some varieties of gabbro [n -S]\n",
  "SMARAGDITES": "SMARAGDITE, a green foliated kind of amphibole, observed in eclogite and some varieties of gabbro [n]\n",
  "SMARAGDS": "SMARAGD, (archaic) emerald, also EMERAUDE, SMARAGDE [n]\n",
  "SMARM": "to smear, gush, make oily, also SMALM [v -ED, -ING, -S]\n",
  "SMARMED": "SMARM, to smear, gush, make oily, also SMALM [v]\n",
  "SMARMIER": "SMARMY, oily, ingratiating, also SMALMY [adj]\n",
  "SMARMIEST": "SMARMY, oily, ingratiating, also SMALMY [adj]\n",
  "SMARMILY": "SMARMY, oily, ingratiating, also SMALMY [adv]\n",
  "SMARMINESS": "the state of being smarmy [n -ES]\n",
  "SMARMINESSES": "SMARMINESS, the state of being smarmy [n]\n",
  "SMARMING": "SMARM, to smear, gush, make oily, also SMALM [v]\n",
  "SMARMS": "SMARM, to smear, gush, make oily, also SMALM [v]\n",
  "SMARMY": "oily, ingratiating, also SMALMY [adj SMARMIER, SMARMIEST, SMARMILY]\n",
  "SMART": "clever [adj SMARTER, SMARTEST, SMARTLY] / to sting [v -ED, -ING, -S]\n",
  "SMARTARSE": "(colloquial) a showily clever person, also SMARTASS [n -S]\n",
  "SMARTARSED": "offensively clever [adj]\n",
  "SMARTARSES": "SMARTARSE, (colloquial) a showily clever person, also SMARTASS [n]\n",
  "SMARTASS": "(colloquial) a showily clever person, also SMARTARSE [n -ES]\n",
  "SMARTASSES": "SMARTASS, (colloquial) a showily clever person, also SMARTARSE [n]\n",
  "SMARTED": "SMART, to sting [v]\n",
  "SMARTEN": "to improve in appearance [v -ED, -ING, -S]\n",
  "SMARTENED": "SMARTEN, to improve in appearance [v]\n",
  "SMARTENING": "SMARTEN, to improve in appearance [v]\n",
  "SMARTENS": "SMARTEN, to improve in appearance [v]\n",
  "SMARTER": "SMART, clever [adj]\n",
  "SMARTEST": "SMART, clever [adj]\n",
  "SMARTIE": "(colloquial) an irritatingly clever person, also SMARTY [n -S]\n",
  "SMARTIES": "SMARTY, (colloquial) an irritatingly clever person, also SMARTIE [n]\n",
  "SMARTING": "SMART, to sting [v]\n",
  "SMARTINGLY": "SMARTING, SMART, to sting [adv]\n",
  "SMARTISH": "somewhat smart [adj]\n",
  "SMARTLY": "SMART, clever [adv]\n",
  "SMARTMOUTH": "a clever or sarcastic person [n -S]\n",
  "SMARTMOUTHS": "SMARTMOUTH, a clever or sarcastic person [n]\n",
  "SMARTNESS": "the state of being smart [n -ES]\n",
  "SMARTNESSES": "SMARTNESS, the state of being smart [n]\n",
  "SMARTPHONE": "a portable device combining a mobile phone and a computer [n -S]\n",
  "SMARTPHONES": "SMARTPHONE, a portable device combining a mobile phone and a computer [n]\n",
  "SMARTS": "SMART, to sting [v]\n",
  "SMARTWATCH": "an electronic wristwatch that is able to perform many of the functions of a smartphone or tablet computer [n -ES]\n",
  "SMARTWATCHES": "SMARTWATCH, an electronic wristwatch that is able to perform many of the functions of a smartphone or tablet computer [n]\n",
  "SMARTWEED": "an acrid plant which produces smarting if applied where the skin is tender [n -S]\n",
  "SMARTWEEDS": "SMARTWEED, an acrid plant which produces smarting if applied where the skin is tender [n]\n",
  "SMARTY": "(colloquial) an irritatingly clever person, also SMARTIE [n SMARTIES]\n",
  "SMARTYPANTS": "an overly clever person [n SMARTYPANTS]\n",
  "SMASH": "to shatter violently [v -ED, -ING, -ES]\n",
  "SMASHABLE": "that can be smashed [adj]\n",
  "SMASHED": "SMASH, to shatter violently [v]\n",
  "SMASHER": "one that smashes [n -S]\n",
  "SMASHEROO": "(colloquial) a thing of superlative quality [n -S]\n",
  "SMASHEROOS": "SMASHEROO, (colloquial) a thing of superlative quality [n]\n",
  "SMASHERS": "SMASHER, one that smashes [n]\n",
  "SMASHES": "SMASH, to shatter violently [v]\n",
  "SMASHING": "strikingly good [adj SMASHINGLY] / the act of smashing [n -S]\n",
  "SMASHINGLY": "SMASHING, strikingly good [adv]\n",
  "SMASHINGS": "SMASHING, the act of smashing [n]\n",
  "SMASHMOUTH": "of, for example, football, characterized by brute force without finesse [adj]\n",
  "SMASHUP": "a collision of motor vehicles [n -S]\n",
  "SMASHUPS": "SMASHUP, a collision of motor vehicles [n]\n",
  "SMATCH": "(obsolete) to taste, smack [v -ED, -ING, -ES]\n",
  "SMATCHED": "SMATCH, (obsolete) to taste, smack [v]\n",
  "SMATCHES": "SMATCH, (obsolete) to taste, smack [v]\n",
  "SMATCHING": "SMATCH, (obsolete) to taste, smack [v]\n",
  "SMATTER": "to speak with little knowledge [v -ED, -ING, -S]\n",
  "SMATTERED": "SMATTER, to speak with little knowledge [v]\n",
  "SMATTERER": "one who has only a slight, superficial knowledge [n -S]\n",
  "SMATTERERS": "SMATTERER, one who has only a slight, superficial knowledge [n]\n",
  "SMATTERING": "a little knowledge of something [n -S]\n",
  "SMATTERINGLY": "SMATTERING [adv]\n",
  "SMATTERINGS": "SMATTERING, a little knowledge of something [n]\n",
  "SMATTERS": "SMATTER, to speak with little knowledge [v]\n",
  "SMAZE": "an atmospheric mixture of smoke and haze [n -S]\n",
  "SMAZES": "SMAZE, an atmospheric mixture of smoke and haze [n]\n",
  "SMEAR": "to spread with something oily or sticky [v -ED, -ING, -S]\n",
  "SMEARCASE": "(German) cottage cheese, also SMIERCASE [n -S]\n",
  "SMEARCASES": "SMEARCASE, (German) cottage cheese, also SMIERCASE [n]\n",
  "SMEARED": "SMEAR, to spread with something oily or sticky [v]\n",
  "SMEARER": "one who smears [n -S]\n",
  "SMEARERS": "SMEARER, one who smears [n]\n",
  "SMEARIER": "SMEARY, covered with smears [adj]\n",
  "SMEARIEST": "SMEARY, covered with smears [adj]\n",
  "SMEARILY": "SMEARY, covered with smears [adv]\n",
  "SMEARINESS": "the state of being smeary [n -ES]\n",
  "SMEARINESSES": "SMEARINESS, the state of being smeary [n]\n",
  "SMEARING": "SMEAR, to spread with something oily or sticky [v]\n",
  "SMEARS": "SMEAR, to spread with something oily or sticky [v]\n",
  "SMEARY": "covered with smears [adj SMEARIER, SMEARIEST, SMEARILY]\n",
  "SMEATH": "(dialect) a name for various ducks including smew and pochard, also SMEE [n -S]\n",
  "SMEATHS": "SMEATH, (dialect) a name for various ducks including smew and pochard, also SMEE [n]\n",
  "SMECTIC": "pertaining to a state between solid and liquid [adj]\n",
  "SMECTITE": "the family of minerals that are constituents of clays, including bentonite and saponite [n -S]\n",
  "SMECTITES": "SMECTITE, the family of minerals that are constituents of clays, including bentonite and saponite [n]\n",
  "SMECTITIC": "of or like smectite, a hydrous silicate of alumina [adj]\n",
  "SMEDDUM": "(Scots) a fine powder; (figurative) spirit, mettle [n -S]\n",
  "SMEDDUMS": "SMEDDUM, (Scots) a fine powder; (figurative) spirit, mettle [n]\n",
  "SMEE": "(dialect) a name for various ducks including smew, pochard, also SMEATH [n -S]\n",
  "SMEECH": "(dialect) to smoke, also SMEEK [v -ED, -ING, -ES]\n",
  "SMEECHED": "SMEECH, (dialect) to smoke, also SMEEK [v]\n",
  "SMEECHES": "SMEECH, (dialect) to smoke, also SMEEK [v]\n",
  "SMEECHING": "SMEECH, (dialect) to smoke, also SMEEK [v]\n",
  "SMEEK": "(Scots) to smoke, also SMEECH [v -ED, -ING, -S]\n",
  "SMEEKED": "SMEEK, (Scots) to smoke, also SMEECH [v]\n",
  "SMEEKING": "SMEEK, (Scots) to smoke, also SMEECH [v]\n",
  "SMEEKS": "SMEEK, (Scots) to smoke, also SMEECH [v]\n",
  "SMEES": "SMEE, (dialect) a name for various ducks including smew, pochard, also SMEATH [n]\n",
  "SMEETH": "to make smooth [v -ED, -ING, -S]\n",
  "SMEETHED": "SMEETH, to make smooth [v]\n",
  "SMEETHING": "SMEETH, to make smooth [v]\n",
  "SMEETHS": "SMEETH, to make smooth [v]\n",
  "SMEGMA": "(Latin) fatty matter secreted by glands, also SEBUM [n -S]\n",
  "SMEGMAS": "SMEGMA, (Latin) fatty matter secreted by glands, also SEBUM [n]\n",
  "SMEIK": "(Scots) to smoke, also SMEKE [v -ED, -ING, -S]\n",
  "SMEIKED": "SMEIK, (Scots) to smoke, also SMEKE [v]\n",
  "SMEIKING": "SMEIK, (Scots) to smoke, also SMEKE [v]\n",
  "SMEIKS": "SMEIK, (Scots) to smoke, also SMEKE [v]\n",
  "SMEKE": "(Scots) to smoke, also SMEIK [v SMEKED, SMEKING, SMEKES]\n",
  "SMEKED": "SMEKE, (Scots) to smoke, also SMEIK [v]\n",
  "SMEKES": "SMEKE, (Scots) to smoke, also SMEIK [v]\n",
  "SMEKING": "SMEKE, (Scots) to smoke, also SMEIK [v]\n",
  "SMELL": "to sense with the nose [v SMELLED or SMELT, SMELLING, SMELLS]\n",
  "SMELLABLE": "that can be smelled [adj]\n",
  "SMELLED": "SMELL, to sense with the nose [v]\n",
  "SMELLER": "one who smells [n -S]\n",
  "SMELLERS": "SMELLER, one who smells [n]\n",
  "SMELLIER": "SMELLY, having an unpleasant odour [adj]\n",
  "SMELLIES": "perfumes and other such sweet smelling things [n]\n",
  "SMELLIEST": "SMELLY, having an unpleasant odour [adj]\n",
  "SMELLINESS": "the state of being smelly [n -ES]\n",
  "SMELLINESSES": "SMELLINESS, the state of being smelly [n]\n",
  "SMELLING": "the act of using the nose to detect odours [n -S]\n",
  "SMELLINGS": "SMELLING, the act of using the nose to detect odours [n]\n",
  "SMELLS": "SMELL, to sense with the nose [v]\n",
  "SMELLY": "having an unpleasant odour [adj SMELLIER, SMELLIEST]\n",
  "SMELT": "to melt or fuse, as ores [v -ED, -ING, -S]\n",
  "SMELTED": "SMELT, to melt or fuse, as ores [v]\n",
  "SMELTER": "one who smelts [n -S]\n",
  "SMELTERIES": "SMELTERY, a place for smelting [n]\n",
  "SMELTERS": "SMELTER, one who smelts [n]\n",
  "SMELTERY": "a place for smelting [n SMELTERIES]\n",
  "SMELTING": "the act of smelting [n -S]\n",
  "SMELTINGS": "SMELTING, the act of smelting [n]\n",
  "SMELTS": "SMELT, to melt or fuse, as ores [v]\n",
  "SMERK": "to smile in a smug manner, also SMIRK [v -ED, -ING, -S]\n",
  "SMERKED": "SMERK, to smile in a smug manner, also SMIRK [v]\n",
  "SMERKING": "SMERK, to smile in a smug manner, also SMIRK [v]\n",
  "SMERKS": "SMERK, to smile in a smug manner, also SMIRK [v]\n",
  "SMEUSE": "(dialect) a space through which an animal track passes, also MEUSE, MEWS, MUSET, MUSIT [n -S]\n",
  "SMEUSES": "SMEUSE, (dialect) a space through which an animal track passes, also MEUSE, MEWS, MUSET, MUSIT [n]\n",
  "SMEW": "a bird, the smallest merganser [n -S]\n",
  "SMEWS": "SMEW, a bird, the smallest merganser [n]\n",
  "SMICKER": "(obsolete) to look amorously or wantonly; to smirk [v -ED, -ING, -S]\n",
  "SMICKERED": "SMICKER, (obsolete) to look amorously or wantonly; to smirk [v]\n",
  "SMICKERING": "an amorous inclination [n -S]\n",
  "SMICKERINGS": "SMICKERING, an amorous inclination [n]\n",
  "SMICKERS": "SMICKER, (obsolete) to look amorously or wantonly; to smirk [v]\n",
  "SMICKET": "a woman's undergarment; a smock [n -S]\n",
  "SMICKETS": "SMICKET, a woman's undergarment; a smock [n]\n",
  "SMICKLY": "amorously [adv]\n",
  "SMIDDIED": "SMIDDY, (Scots) to forge metal, also SMITHY [v]\n",
  "SMIDDIES": "SMIDDY, (Scots) to forge metal, also SMITHY [v]\n",
  "SMIDDY": "(Scots) to forge metal, also SMITHY [v SMIDDIED, SMIDDYING, SMIDDIES]\n",
  "SMIDDYING": "SMIDDY, (Scots) to forge metal, also SMITHY [v]\n",
  "SMIDGE": "a very small amount, also SMIDGEN, SMIDGEON, SMIDGIN [n -S]\n",
  "SMIDGEN": "a very small amount, also SMIDGE, SMIDGEON, SMIDGIN [n -S]\n",
  "SMIDGENS": "SMIDGEN, a very small amount, also SMIDGE, SMIDGEON, SMIDGIN [n]\n",
  "SMIDGEON": "a very small amount, also SMIDGEN, SMIDGE, SMIDGIN [n -S]\n",
  "SMIDGEONS": "SMIDGEON, a very small amount, also SMIDGEN, SMIDGE, SMIDGIN [n]\n",
  "SMIDGES": "SMIDGE, a very small amount, also SMIDGEN, SMIDGEON, SMIDGIN [n]\n",
  "SMIDGIN": "a very small amount, also SMIDGEN, SMIDGE, SMIDGEON [n -S]\n",
  "SMIDGINS": "SMIDGIN, a very small amount, also SMIDGEN, SMIDGE, SMIDGEON [n]\n",
  "SMIERCASE": "(German) cottage cheese, also SMEARCASE [n -S]\n",
  "SMIERCASES": "SMIERCASE, (German) cottage cheese, also SMEARCASE [n]\n",
  "SMIFLIGATE": "Charles Dickens's nonce word for to spiflicate [v SMIFLIGATED, SMIFLIGATING, SMIFLIGATES]\n",
  "SMIFLIGATED": "SMIFLIGATE, Charles Dickens's nonce word for to spiflicate [v]\n",
  "SMIFLIGATES": "SMIFLIGATE, Charles Dickens's nonce word for to spiflicate [v]\n",
  "SMIFLIGATING": "SMIFLIGATE, Charles Dickens's nonce word for to spiflicate [v]\n",
  "SMIGHT": "(Spenser) to smite [v SMOTE, SMIGHTING, SMIGHTS]\n",
  "SMIGHTING": "SMIGHT, (Spenser) to smite [v]\n",
  "SMIGHTS": "SMIGHT, (Spenser) to smite [v]\n",
  "SMILACACEOUS": "belonging to the smilax family [adj]\n",
  "SMILAX": "(Greek) a genus of perennial climbing plants, usually with a prickly woody stem [n -ES]\n",
  "SMILAXES": "SMILAX, (Greek) a genus of perennial climbing plants, usually with a prickly woody stem [n]\n",
  "SMILE": "to look joyful, also SMOILE, SMOYLE [v SMILED, SMILING, SMILES]\n",
  "SMILED": "SMILE, to look joyful, also SMOILE, SMOYLE [v]\n",
  "SMILEFUL": "full of smiles [adj]\n",
  "SMILELESS": "not having a smile [adj]\n",
  "SMILER": "one who smiles [n -S]\n",
  "SMILERS": "SMILER, one who smiles [n]\n",
  "SMILES": "SMILE, to look joyful, also SMOILE, SMOYLE [v]\n",
  "SMILET": "(Shakespeare) a little smile [n -S]\n",
  "SMILETS": "SMILET, (Shakespeare) a little smile [n]\n",
  "SMILEY": "given to smiling [adj SMILIER, SMILIEST] / a set of characters representing a smiling face [n SMILEYS or SMILIES]\n",
  "SMILEYS": "SMILEY, a set of characters representing a smiling face [n]\n",
  "SMILIER": "SMILEY, given to smiling [adj]\n",
  "SMILIES": "SMILEY, a set of characters representing a smiling face [n]\n",
  "SMILIEST": "SMILEY, given to smiling [adj]\n",
  "SMILING": "wearing a smile [adj SMILINGLY] / the act of smiling [n -S]\n",
  "SMILINGLY": "SMILING, wearing a smile [adv]\n",
  "SMILINGNESS": "the state of being smiling [n -ES]\n",
  "SMILINGNESSES": "SMILINGNESS, the state of being smiling [n]\n",
  "SMILINGS": "SMILING, the act of smiling [n]\n",
  "SMILODON": "an extinct genus of saber-toothed tigers [n -S]\n",
  "SMILODONS": "SMILODON, an extinct genus of saber-toothed tigers [n]\n",
  "SMIR": "to drizzle, also SMIRR, SMUR [v SMIRRED, SMIRRING, SMIRS]\n",
  "SMIRCH": "to soil, besmirch [v -ED, -ING, -ES]\n",
  "SMIRCHED": "SMIRCH, to soil, besmirch [v]\n",
  "SMIRCHER": "one who smirches [n -S]\n",
  "SMIRCHERS": "SMIRCHER, one who smirches [n]\n",
  "SMIRCHES": "SMIRCH, to soil, besmirch [v]\n",
  "SMIRCHING": "SMIRCH, to soil, besmirch [v]\n",
  "SMIRK": "to smile in a smug manner, also SMERK [v -ED, -ING, -S]\n",
  "SMIRKED": "SMIRK, to smile in a smug manner, also SMERK [v]\n",
  "SMIRKER": "one who smirks [n -S]\n",
  "SMIRKERS": "SMIRKER, one who smirks [n]\n",
  "SMIRKIER": "SMIRKY, given to smirking [adj]\n",
  "SMIRKIEST": "SMIRKY, given to smirking [adj]\n",
  "SMIRKILY": "SMIRKY, given to smirking [adv]\n",
  "SMIRKING": "SMIRK, to smile in a smug manner, also SMERK [v]\n",
  "SMIRKINGLY": "SMIRKING, SMIRK, to smile in a smug manner, also SMERK [adv]\n",
  "SMIRKS": "SMIRK, to smile in a smug manner, also SMERK [v]\n",
  "SMIRKY": "given to smirking [adj SMIRKIER, SMIRKIEST, SMIRKILY]\n",
  "SMIRR": "to drizzle [v -ED, -ING, -S]\n",
  "SMIRRED": "SMIR, to drizzle, also SMIRR, SMUR [v]\n",
  "SMIRRIER": "SMIRRY, drizzly [adj]\n",
  "SMIRRIEST": "SMIRRY, drizzly [adj]\n",
  "SMIRRING": "SMIR, to drizzle, also SMIRR, SMUR [v]\n",
  "SMIRRS": "SMIRR, to drizzle [v]\n",
  "SMIRRY": "drizzly [adj SMIRRIER, SMIRRIEST]\n",
  "SMIRS": "SMIR, to drizzle, also SMIRR, SMUR [v]\n",
  "SMIRTING": "(Irish) the act of arranging dates while smoking outside a pub [n -S]\n",
  "SMIRTINGS": "SMIRTING, (Irish) the act of arranging dates while smoking outside a pub [n]\n",
  "SMISHING": "the practice of using fraudulent text messages to extract financial data from users for purposes of identity theft [n -S]\n",
  "SMISHINGS": "SMISHING, the practice of using fraudulent text messages to extract financial data from users for purposes of identity theft [n]\n",
  "SMIT": "(Scots) to stain, infect [v SMITTED, SMITTING, SMITS]\n",
  "SMITE": "to strike heavily [v SMOTE, SMIT or SMITTEN, SMITING, SMITES]\n",
  "SMITER": "one who smites [n -S]\n",
  "SMITERS": "SMITER, one who smites [n]\n",
  "SMITES": "SMITE, to strike heavily [v]\n",
  "SMITH": "to forge metal, also SMITHY [v -ED, -ING, -S]\n",
  "SMITHCRAFT": "the craft of a smith [n -S]\n",
  "SMITHCRAFTS": "SMITHCRAFT, the craft of a smith [n]\n",
  "SMITHED": "SMITH, to forge metal, also SMITHY [v]\n",
  "SMITHEREEN": "to break into small fragments [v -ED, -ING, -S]\n",
  "SMITHEREENED": "SMITHEREEN, to break into small fragments [v]\n",
  "SMITHEREENING": "SMITHEREEN, to break into small fragments [v]\n",
  "SMITHEREENS": "SMITHEREEN, to break into small fragments [v]\n",
  "SMITHERIES": "SMITHERY, the trade of a smith [n]\n",
  "SMITHERS": "small fragments [n]\n",
  "SMITHERY": "the trade of a smith [n SMITHERIES]\n",
  "SMITHIED": "SMITHY, to forge metal, also SMITH, SMIDDY [v]\n",
  "SMITHIES": "SMITHY, to forge metal, also SMITH, SMIDDY [v]\n",
  "SMITHING": "the work of a smith [n -S]\n",
  "SMITHINGS": "SMITHING, the work of a smith [n]\n",
  "SMITHS": "SMITH, to forge metal, also SMITHY [v]\n",
  "SMITHSONITE": "natural zinc carbonate, aka calamine [n -S]\n",
  "SMITHSONITES": "SMITHSONITE, natural zinc carbonate, aka calamine [n]\n",
  "SMITHY": "to forge metal, also SMITH, SMIDDY [v SMITHIED, SMITHYING, SMITHIES]\n",
  "SMITHYING": "SMITHY, to forge metal, also SMITH, SMIDDY [v]\n",
  "SMITING": "SMITE, to strike heavily [v]\n",
  "SMITS": "SMIT, (Scots) to stain, infect [v]\n",
  "SMITTED": "SMIT, (Scots) to stain, infect [v]\n",
  "SMITTEN": "SMITE, to strike heavily [v]\n",
  "SMITTING": "SMIT, (Scots) to stain, infect [v]\n",
  "SMITTLE": "(Scots) infectious [adj]\n",
  "SMOCK": "to put on a loose outer garment [v -ED, -ING, -S]\n",
  "SMOCKED": "SMOCK, to put on a loose outer garment [v]\n",
  "SMOCKING": "a type of embroidery [n -S]\n",
  "SMOCKINGS": "SMOCKING, a type of embroidery [n]\n",
  "SMOCKLIKE": "like a smock [adj]\n",
  "SMOCKS": "SMOCK, to put on a loose outer garment [v]\n",
  "SMOG": "a mixture of smoke and fog [n -S]\n",
  "SMOGGIER": "SMOGGY, filled with smog [adj]\n",
  "SMOGGIEST": "SMOGGY, filled with smog [adj]\n",
  "SMOGGY": "filled with smog [adj SMOGGIER, SMOGGIEST]\n",
  "SMOGLESS": "without smog [adj]\n",
  "SMOGS": "SMOG, a mixture of smoke and fog [n]\n",
  "SMOILE": "(obsolete) to smile, also SMOYLE [v SMOILED, SMOILING, SMOILES]\n",
  "SMOILED": "SMOILE, (obsolete) to smile, also SMOYLE [v]\n",
  "SMOILES": "SMOILE, (obsolete) to smile, also SMOYLE [v]\n",
  "SMOILING": "SMOILE, (obsolete) to smile, also SMOYLE [v]\n",
  "SMOKABLE": "that can be smoked, also SMOKEABLE [adj]\n",
  "SMOKE": "to emit a gas or vapour due to burning [v SMOKED, SMOKING, SMOKES]\n",
  "SMOKEABLE": "that can be smoked, also SMOKABLE [adj]\n",
  "SMOKEBOARD": "a board suspended in front of a fireplace to prevent the smoke coming out into the room [n -S]\n",
  "SMOKEBOARDS": "SMOKEBOARD, a board suspended in front of a fireplace to prevent the smoke coming out into the room [n]\n",
  "SMOKEBOX": "part of a steam boiler where the smoke is collected before passing out at the chimney [n -ES]\n",
  "SMOKEBOXES": "SMOKEBOX, part of a steam boiler where the smoke is collected before passing out at the chimney [n]\n",
  "SMOKEBUSH": "a plant with purple leaves and small flowers that turn grey-white before they fall [n -ES]\n",
  "SMOKEBUSHES": "SMOKEBUSH, a plant with purple leaves and small flowers that turn grey-white before they fall [n]\n",
  "SMOKED": "SMOKE, to emit a gas or vapour due to burning [v]\n",
  "SMOKEHO": "in the Falkland Isles, an 11 a.m. meal consisting of sausage rolls, cream cakes and strong sweet tea, also SMOKO [n -S]\n",
  "SMOKEHOOD": "a protective hood for a firefighter that prevents the wearer from inhaling smoke [n -S]\n",
  "SMOKEHOODS": "SMOKEHOOD, a protective hood for a firefighter that prevents the wearer from inhaling smoke [n]\n",
  "SMOKEHOS": "SMOKEHO, in the Falkland Isles, an 11 a.m. meal consisting of sausage rolls, cream cakes and strong sweet tea, also SMOKO [n]\n",
  "SMOKEHOUSE": "a building where meat or fish is cured by subjecting it to a dense smoke [n -S]\n",
  "SMOKEHOUSES": "SMOKEHOUSE, a building where meat or fish is cured by subjecting it to a dense smoke [n]\n",
  "SMOKEJACK": "a contrivance for turning a spit by means of a fly or wheel moved by the current of ascending air in a chimney [n -S]\n",
  "SMOKEJACKS": "SMOKEJACK, a contrivance for turning a spit by means of a fly or wheel moved by the current of ascending air in a chimney [n]\n",
  "SMOKELESS": "without smoke [adj SMOKELESSLY]\n",
  "SMOKELESSLY": "SMOKELESS, without smoke [adv]\n",
  "SMOKELESSNESS": "the state of being smokeless [n -ES]\n",
  "SMOKELESSNESSES": "SMOKELESSNESS, the state of being smokeless [n]\n",
  "SMOKELIKE": "like smoke [adj]\n",
  "SMOKEPOT": "a container for giving off smoke [n -S]\n",
  "SMOKEPOTS": "SMOKEPOT, a container for giving off smoke [n]\n",
  "SMOKEPROOF": "proof against smoke [adj]\n",
  "SMOKER": "one that smokes [n -S]\n",
  "SMOKERS": "SMOKER, one that smokes [n]\n",
  "SMOKES": "SMOKE, to emit a gas or vapour due to burning [v]\n",
  "SMOKESCREEN": "a cloud of smoke raised to conceal movements [n -S]\n",
  "SMOKESCREENS": "SMOKESCREEN, a cloud of smoke raised to conceal movements [n]\n",
  "SMOKESTACK": "a pipe or funnel through which smoke and gases are discharged [n -S]\n",
  "SMOKESTACKS": "SMOKESTACK, a pipe or funnel through which smoke and gases are discharged [n]\n",
  "SMOKETIGHT": "proof against smoke [adj]\n",
  "SMOKEY": "full of smoke, also SMOKY [adj SMOKIER, SMOKIEST] / a police officer who patrols highways [n -S]\n",
  "SMOKEYS": "SMOKEY, a police officer who patrols highways [n]\n",
  "SMOKIE": "(Scots) a smoked haddock [n -S]\n",
  "SMOKIER": "SMOKY, full of smoke, also SMOKEY [adj]\n",
  "SMOKIES": "SMOKIE, (Scots) a smoked haddock [n]\n",
  "SMOKIEST": "SMOKY, full of smoke, also SMOKEY [adj]\n",
  "SMOKILY": "SMOKY, full of smoke, also SMOKEY [adv]\n",
  "SMOKINESS": "the state of being smoky [n -ES]\n",
  "SMOKINESSES": "SMOKINESS, the state of being smoky [n]\n",
  "SMOKING": "to preserve by smoke-drying [n -S]\n",
  "SMOKINGS": "SMOKING, to preserve by smoke-drying [n]\n",
  "SMOKO": "in the Falkland Isles, an 11 a.m. meal consisting of sausage rolls, cream cakes and strong sweet tea, also SMOKEHO [n -S]\n",
  "SMOKOS": "SMOKO, in the Falkland Isles, an 11 a.m. meal consisting of sausage rolls, cream cakes and strong sweet tea, also SMOKEHO [n]\n",
  "SMOKY": "full of smoke, also SMOKEY [adj SMOKIER, SMOKIEST, SMOKILY] / a smoked haddock [n SMOKIES]\n",
  "SMOLDER": "to burn with no flame, also SMOULDER [v -ED, -ING, -S]\n",
  "SMOLDERED": "SMOLDER, to burn with no flame, also SMOULDER [v]\n",
  "SMOLDERING": "SMOLDER, to burn with no flame, also SMOULDER [v]\n",
  "SMOLDERS": "SMOLDER, to burn with no flame, also SMOULDER [v]\n",
  "SMOLT": "a young salmon [n -S]\n",
  "SMOLTS": "SMOLT, a young salmon [n]\n",
  "SMOOCH": "to kiss, also SMOODGE, SMOOGE [v -ED, -ING, -ES]\n",
  "SMOOCHED": "SMOOCH, to kiss, also SMOODGE, SMOOGE [v]\n",
  "SMOOCHER": "one who smooches [n -S]\n",
  "SMOOCHERS": "SMOOCHER, one who smooches [n]\n",
  "SMOOCHES": "SMOOCH, to kiss, also SMOODGE, SMOOGE [v]\n",
  "SMOOCHIER": "SMOOCHY, given to smooching [adj]\n",
  "SMOOCHIEST": "SMOOCHY, given to smooching [adj]\n",
  "SMOOCHING": "SMOOCH, to kiss, also SMOODGE, SMOOGE [v]\n",
  "SMOOCHY": "given to smooching [adj SMOOCHIER, SMOOCHIEST]\n",
  "SMOODGE": "(Australian slang) to kiss closely, also SMOOCH, SMOOGE, SMOUCH [v SMOODGED, SMOODGING, SMOODGES]\n",
  "SMOODGED": "SMOODGE, (Australian slang) to kiss closely, also SMOOCH, SMOOGE, SMOUCH [v]\n",
  "SMOODGES": "SMOODGE, (Australian slang) to kiss closely, also SMOOCH, SMOOGE, SMOUCH [v]\n",
  "SMOODGING": "SMOODGE, (Australian slang) to kiss closely, also SMOOCH, SMOOGE, SMOUCH [v]\n",
  "SMOOGE": "(Australian slang) to kiss closely, also SMOOCH, SMOODGE, SMOUCH [v SMOOGED, SMOOGING, SMOOGES]\n",
  "SMOOGED": "SMOOGE, (Australian slang) to kiss closely, also SMOOCH, SMOODGE, SMOUCH [v]\n",
  "SMOOGES": "SMOOGE, (Australian slang) to kiss closely, also SMOOCH, SMOODGE, SMOUCH [v]\n",
  "SMOOGING": "SMOOGE, (Australian slang) to kiss closely, also SMOOCH, SMOODGE, SMOUCH [v]\n",
  "SMOOR": "(Scots) to smother, extinguish, also SMORE [v -ED, -ING, -S]\n",
  "SMOORED": "SMOOR, (Scots) to smother, extinguish, also SMORE [v]\n",
  "SMOORING": "SMOOR, (Scots) to smother, extinguish, also SMORE [v]\n",
  "SMOORS": "SMOOR, (Scots) to smother, extinguish, also SMORE [v]\n",
  "SMOOSH": "to paint to give a softened look [v SMOOSHED, SMOOSHING, SMOOSHES]\n",
  "SMOOSHED": "SMOOSH, to paint to give a softened look [v]\n",
  "SMOOSHES": "SMOOSH, to paint to give a softened look [v]\n",
  "SMOOSHING": "SMOOSH, to paint to give a softened look [v]\n",
  "SMOOT": "(slang) to work as a compositor doing odd jobs, also SMOUT [v -ED, -ING, -S]\n",
  "SMOOTED": "SMOOT, (slang) to work as a compositor doing odd jobs, also SMOUT [v]\n",
  "SMOOTH": "not rough [adj SMOOTHER, SMOOTHEST, SMOOTHLY] / to make smooth, also SMOOTHE [v SMOOTHED, SMOOTHING, SMOOTHS or SMOOTHES]\n",
  "SMOOTHABLE": "that can be smoothed [adj]\n",
  "SMOOTHBORE": "having a bore of perfectly smooth surface, not rifled [adj] / a gun with a smooth bore [n -S]\n",
  "SMOOTHBORED": "of a gun, having a smooth bore, not rifled [adj]\n",
  "SMOOTHBORES": "SMOOTHBORE, a gun with a smooth bore [n]\n",
  "SMOOTHE": "to make smooth, also SMOOTH [v SMOOTHED, SMOOTHING, SMOOTHES]\n",
  "SMOOTHED": "SMOOTH, to make smooth, also SMOOTHE [v]\n",
  "SMOOTHEN": "to free from lumps, also SMOOTH [v -ED, -ING, -S]\n",
  "SMOOTHENED": "SMOOTHEN, to free from lumps, also SMOOTH [v]\n",
  "SMOOTHENING": "SMOOTHEN, to free from lumps, also SMOOTH [v]\n",
  "SMOOTHENS": "SMOOTHEN, to free from lumps, also SMOOTH [v]\n",
  "SMOOTHER": "a smoothing tool [n -S]\n",
  "SMOOTHERS": "SMOOTHER, a smoothing tool [n]\n",
  "SMOOTHES": "SMOOTH, to make smooth, also SMOOTHE [v]\n",
  "SMOOTHEST": "SMOOTH, not rough [adj]\n",
  "SMOOTHIE": "a person with polished manners, also SMOOTHY [n -S]\n",
  "SMOOTHIES": "SMOOTHIE, a person with polished manners, also SMOOTHY [n]\n",
  "SMOOTHING": "the act of smoothing [n -S]\n",
  "SMOOTHINGS": "SMOOTHING, the act of smoothing [n]\n",
  "SMOOTHISH": "somewhat smooth [adj]\n",
  "SMOOTHLY": "SMOOTH, not rough [adv]\n",
  "SMOOTHNESS": "the state of being smooth [n -ES]\n",
  "SMOOTHNESSES": "SMOOTHNESS, the state of being smooth [n]\n",
  "SMOOTHPATE": "(archaic) a bald person [n -S]\n",
  "SMOOTHPATES": "SMOOTHPATE, (archaic) a bald person [n]\n",
  "SMOOTHS": "SMOOTH, to make smooth, also SMOOTHE [v]\n",
  "SMOOTHY": "a person with polished manners, also SMOOTHIE [n SMOOTHIES]\n",
  "SMOOTING": "SMOOT, (slang) to work as a compositor doing odd jobs, also SMOUT [v]\n",
  "SMOOTS": "SMOOT, (slang) to work as a compositor doing odd jobs, also SMOUT [v]\n",
  "SMORBROD": "(Norwegian) hors d'oeuvres served on slices of buttered bread, also SMORG, SMORGASBORD, SMORREBROD [n -S]\n",
  "SMORBRODS": "SMORBROD, (Norwegian) hors d'oeuvres served on slices of buttered bread, also SMORG, SMORGASBORD, SMORREBROD [n]\n",
  "SMORE": "(Scots) to smother, extinguish, also SMOOR [v SMORED, SMORING, SMORES]\n",
  "SMORED": "SMORE, (Scots) to smother, extinguish, also SMOOR [v]\n",
  "SMORES": "SMORE, (Scots) to smother, extinguish, also SMOOR [v]\n",
  "SMORG": "(short for) smorgasbord [n -S]\n",
  "SMORGASBORD": "(Norwegian) a buffet featuring various dishes, such as hors d'oeuvres, salads, etc., also SMORBROD, SMORG, SMORREBROD [n -S]\n",
  "SMORGASBORDS": "SMORGASBORD, (Norwegian) a buffet featuring various dishes, such as hors d'oeuvres, salads, etc., also SMORBROD, SMORG, SMORREBROD [n]\n",
  "SMORGS": "SMORG, (short for) smorgasbord [n]\n",
  "SMORING": "SMORE, (Scots) to smother, extinguish, also SMOOR [v]\n",
  "SMORREBROD": "(Danish) a buffet featuring various dishes, such as hors d'oeuvres, salads, etc., also SMORBROD, SMORG, SMORGASBORD [n -S]\n",
  "SMORREBRODS": "SMORREBROD, (Danish) a buffet featuring various dishes, such as hors d'oeuvres, salads, etc., also SMORBROD, SMORG, SMORGASBORD [n]\n",
  "SMORZANDO": "(Italian) with a gradual fading away, growing slower and softer, also SMORZATO [adv]\n",
  "SMORZATO": "(Italian) with a gradual fading away, growing slower and softer, also SMORZANDO [adv]\n",
  "SMOTE": "SMIGHT, (Spenser) to smite [v]\n",
  "SMOTHER": "to prevent from breathing [v -ED, -ING, -S]\n",
  "SMOTHERED": "SMOTHER, to prevent from breathing [v]\n",
  "SMOTHERER": "one who smothers [n -S]\n",
  "SMOTHERERS": "SMOTHERER, one who smothers [n]\n",
  "SMOTHERIER": "SMOTHERY, tending to smother; stifling [adj]\n",
  "SMOTHERIEST": "SMOTHERY, tending to smother; stifling [adj]\n",
  "SMOTHERINESS": "the state of being smothery, tending to smother [n -ES]\n",
  "SMOTHERINESSES": "SMOTHERINESS, the state of being smothery, tending to smother [n]\n",
  "SMOTHERING": "suffocating [adj SMOTHERINGLY] / the act of smothering [n -S]\n",
  "SMOTHERINGLY": "SMOTHERING, suffocating [adv]\n",
  "SMOTHERINGS": "SMOTHERING, the act of smothering [n]\n",
  "SMOTHERS": "SMOTHER, to prevent from breathing [v]\n",
  "SMOTHERY": "tending to smother; stifling [adj SMOTHERIER, SMOTHERIEST]\n",
  "SMOUCH": "to kiss closely, also SMOOCH, SMOODGE, SMOOGE [v -ED, -ING, -ES]\n",
  "SMOUCHED": "SMOUCH, to kiss closely, also SMOOCH, SMOODGE, SMOOGE [v]\n",
  "SMOUCHES": "SMOUCH, to kiss closely, also SMOOCH, SMOODGE, SMOOGE [v]\n",
  "SMOUCHING": "SMOUCH, to kiss closely, also SMOOCH, SMOODGE, SMOOGE [v]\n",
  "SMOULDER": "to burn with no flame, also SMOLDER [v -ED, -ING, -S]\n",
  "SMOULDERED": "SMOULDER, to burn with no flame, also SMOLDER [v]\n",
  "SMOULDERING": "burning slowly [adj SMOULDERINGLY] / a slow burning [n -S]\n",
  "SMOULDERINGLY": "in the manner of burning with no flame [adv]\n",
  "SMOULDERINGS": "SMOULDERING, a slow burning [n]\n",
  "SMOULDERS": "SMOULDER, to burn with no flame, also SMOLDER [v]\n",
  "SMOULDRIER": "SMOULDRY, (Spenser) smouldering [adj]\n",
  "SMOULDRIEST": "SMOULDRY, (Spenser) smouldering [adj]\n",
  "SMOULDRY": "(Spenser) smouldering [adj SMOULDRIER, SMOULDRIEST]\n",
  "SMOUSE": "(Yiddish) to trade as a pedlar [v SMOUSED, SMOUSING, SMOUSES]\n",
  "SMOUSED": "SMOUSE, (Yiddish) to trade as a pedlar [v]\n",
  "SMOUSER": "(South African) a pedlar [n -S]\n",
  "SMOUSERS": "SMOUSER, (South African) a pedlar [n]\n",
  "SMOUSES": "SMOUSE, (Yiddish) to trade as a pedlar [v]\n",
  "SMOUSING": "SMOUSE, (Yiddish) to trade as a pedlar [v]\n",
  "SMOUT": "(Scots) to work as a compositor doing odd jobs, also SMOOT [v -ED, -ING, -S]\n",
  "SMOUTED": "SMOUT, (Scots) to work as a compositor doing odd jobs, also SMOOT [v]\n",
  "SMOUTING": "SMOUT, (Scots) to work as a compositor doing odd jobs, also SMOOT [v]\n",
  "SMOUTS": "SMOUT, (Scots) to work as a compositor doing odd jobs, also SMOOT [v]\n",
  "SMOWT": "(Scots) a small person or child, also SMOUT [n -S]\n",
  "SMOWTS": "SMOWT, (Scots) a small person or child, also SMOUT [n]\n",
  "SMOYLE": "(obsolete) to smile, also SMOILE [v SMOYLED, SMOYLING, SMOYLES]\n",
  "SMOYLED": "SMOYLE, (obsolete) to smile, also SMOILE [v]\n",
  "SMOYLES": "SMOYLE, (obsolete) to smile, also SMOILE [v]\n",
  "SMOYLING": "SMOYLE, (obsolete) to smile, also SMOILE [v]\n",
  "SMRITI": "(Sanskrit) a class of Hindu sacred literature [n -S]\n",
  "SMRITIS": "SMRITI, (Sanskrit) a class of Hindu sacred literature [n]\n",
  "SMUDGE": "to smear or dirty [v SMUDGED, SMUDGING, SMUDGES]\n",
  "SMUDGED": "SMUDGE, to smear or dirty [v]\n",
  "SMUDGEDLY": "SMUDGED, SMUDGE, to smear or dirty [adv]\n",
  "SMUDGELESS": "without a smudge [adj]\n",
  "SMUDGER": "(slang) a street or press photographer [n -S]\n",
  "SMUDGERS": "SMUDGER, (slang) a street or press photographer [n]\n",
  "SMUDGES": "SMUDGE, to smear or dirty [v]\n",
  "SMUDGIER": "SMUDGY, having smudges [adj]\n",
  "SMUDGIEST": "SMUDGY, having smudges [adj]\n",
  "SMUDGILY": "SMUDGY, having smudges [adv]\n",
  "SMUDGINESS": "the state of being smudgy [n -ES]\n",
  "SMUDGINESSES": "SMUDGINESS, the state of being smudgy [n]\n",
  "SMUDGING": "the act of smudging [n -S]\n",
  "SMUDGINGS": "SMUDGING, the act of smudging [n]\n",
  "SMUDGY": "having smudges [adj SMUDGIER, SMUDGIEST, SMUDGILY]\n",
  "SMUG": "complacent [adj SMUGGER, SMUGGEST, SMUGLY] / to seize without ceremony [v SMUGGED, SMUGGING, SMUGS]\n",
  "SMUGGED": "SMUG, to seize without ceremony [v]\n",
  "SMUGGER": "SMUG, complacent [adj]\n",
  "SMUGGERIES": "SMUGGERY, a state of smugness [n]\n",
  "SMUGGERY": "a state of smugness [n SMUGGERIES]\n",
  "SMUGGEST": "SMUG, complacent [adj]\n",
  "SMUGGING": "SMUG, to seize without ceremony [v]\n",
  "SMUGGLE": "to import or export illicitly [v SMUGGLED, SMUGGLING, SMUGGLES]\n",
  "SMUGGLED": "SMUGGLE, to import or export illicitly [v]\n",
  "SMUGGLER": "one that smuggles [n -S]\n",
  "SMUGGLERS": "SMUGGLER, one that smuggles [n]\n",
  "SMUGGLES": "SMUGGLE, to import or export illicitly [v]\n",
  "SMUGGLING": "the illicit import or export of goods [n -S]\n",
  "SMUGGLINGS": "SMUGGLING, the illicit import or export of goods [n]\n",
  "SMUGLY": "SMUG, complacent [adv]\n",
  "SMUGNESS": "the state of being smug [n -ES]\n",
  "SMUGNESSES": "SMUGNESS, the state of being smug [n]\n",
  "SMUGS": "SMUG, to seize without ceremony [v]\n",
  "SMUR": "(Scots) to drizzle, also SMIR, SMIRR [v SMURRED, SMURRING, SMURS]\n",
  "SMURFING": "intentionally flooding a computer network with messages generated by a program [n -S]\n",
  "SMURFINGS": "SMURFING, intentionally flooding a computer network with messages generated by a program [n]\n",
  "SMURRED": "SMUR, (Scots) to drizzle, also SMIR, SMIRR [v]\n",
  "SMURRIER": "SMURRY, (Scots) like smur, a fine drizzly rain [adj]\n",
  "SMURRIEST": "SMURRY, (Scots) like smur, a fine drizzly rain [adj]\n",
  "SMURRING": "SMUR, (Scots) to drizzle, also SMIR, SMIRR [v]\n",
  "SMURRY": "(Scots) like smur, a fine drizzly rain [adj SMURRIER, SMURRIEST]\n",
  "SMURS": "SMUR, (Scots) to drizzle, also SMIR, SMIRR [v]\n",
  "SMUSH": "to crush [v SMUSHED, SMUSHING, SMUSHES]\n",
  "SMUSHED": "SMUSH, to crush [v]\n",
  "SMUSHES": "SMUSH, to crush [v]\n",
  "SMUSHING": "SMUSH, to crush [v]\n",
  "SMUT": "to soil, make smutty, also SMUTCH [v SMUTTED, SMUTTING, SMUTS]\n",
  "SMUTCH": "to soil [v -ED, -ING, -ES]\n",
  "SMUTCHED": "SMUTCH, to soil [v]\n",
  "SMUTCHES": "SMUTCH, to soil [v]\n",
  "SMUTCHIER": "SMUTCHY, smutched [adj]\n",
  "SMUTCHIEST": "SMUTCHY, smutched [adj]\n",
  "SMUTCHING": "SMUTCH, to soil [v]\n",
  "SMUTCHY": "smutched [adj SMUTCHIER, SMUTCHIEST]\n",
  "SMUTS": "SMUT, to soil, make smutty, also SMUTCH [v]\n",
  "SMUTTED": "SMUT, to soil, make smutty, also SMUTCH [v]\n",
  "SMUTTIER": "SMUTTY, sexually suggestive [adj]\n",
  "SMUTTIEST": "SMUTTY, sexually suggestive [adj]\n",
  "SMUTTILY": "SMUTTY, sexually suggestive [adv]\n",
  "SMUTTINESS": "the state of being smutty [n -ES]\n",
  "SMUTTINESSES": "SMUTTINESS, the state of being smutty [n]\n",
  "SMUTTING": "SMUT, to soil, make smutty, also SMUTCH [v]\n",
  "SMUTTY": "sexually suggestive [adj SMUTTIER, SMUTTIEST, SMUTTILY]\n",
  "SMYTRIE": "(Scots) a collection of small things [n -S]\n",
  "SMYTRIES": "SMYTRIE, (Scots) a collection of small things [n]\n",
  "SNAB": "(Scots) a cobbler; a shoemaker's apprentice [n -S]\n",
  "SNABBLE": "to put a bit on a horse [v SNABBLED, SNABBLING, SNABBLES]\n",
  "SNABBLED": "SNABBLE, to put a bit on a horse [v]\n",
  "SNABBLES": "SNABBLE, to put a bit on a horse [v]\n",
  "SNABBLING": "SNABBLE, to put a bit on a horse [v]\n",
  "SNABS": "SNAB, (Scots) a cobbler; a shoemaker's apprentice [n]\n",
  "SNACK": "to eat a light meal [v -ED, -ING, -S]\n",
  "SNACKED": "SNACK, to eat a light meal [v]\n",
  "SNACKER": "one who snacks [n -S]\n",
  "SNACKERS": "SNACKER, one who snacks [n]\n",
  "SNACKETTE": "(Caribbean) a snack bar [n -S]\n",
  "SNACKETTES": "SNACKETTE, (Caribbean) a snack bar [n]\n",
  "SNACKIER": "SNACKY, suitable as a light meal [adj]\n",
  "SNACKIEST": "SNACKY, suitable as a light meal [adj]\n",
  "SNACKING": "SNACK, to eat a light meal [v]\n",
  "SNACKS": "SNACK, to eat a light meal [v]\n",
  "SNACKY": "suitable as a light meal [adj SNACKIER, SNACKIEST]\n",
  "SNAFFLE": "to obtain by devious means [v SNAFFLED, SNAFFLING, SNAFFLES]\n",
  "SNAFFLED": "SNAFFLE, to obtain by devious means [v]\n",
  "SNAFFLES": "SNAFFLE, to obtain by devious means [v]\n",
  "SNAFFLING": "SNAFFLE, to obtain by devious means [v]\n",
  "SNAFU": "to cause confusion [v -ED, -ING, -S]\n",
  "SNAFUED": "SNAFU, to cause confusion [v]\n",
  "SNAFUING": "SNAFU, to cause confusion [v]\n",
  "SNAFUS": "SNAFU, to cause confusion [v]\n",
  "SNAG": "to catch on a hidden obstacle [v SNAGGED, SNAGGING, SNAGS]\n",
  "SNAGGED": "SNAG, to catch on a hidden obstacle [v]\n",
  "SNAGGER": "a person who uses illegal fishing methods [n -S]\n",
  "SNAGGERS": "SNAGGER, a person who uses illegal fishing methods [n]\n",
  "SNAGGIER": "SNAGGY, full of snags [adj]\n",
  "SNAGGIEST": "SNAGGY, full of snags [adj]\n",
  "SNAGGING": "SNAG, to catch on a hidden obstacle [v]\n",
  "SNAGGLE": "a tangled or knotted mass [n -S]\n",
  "SNAGGLES": "SNAGGLE, a tangled or knotted mass [n]\n",
  "SNAGGLETEETH": "SNAGGLETOOTH, an irregular, broken, or projecting tooth [n]\n",
  "SNAGGLETOOTH": "an irregular, broken, or projecting tooth [n SNAGGLETEETH]\n",
  "SNAGGLETOOTHED": "having a snaggletooth, an irregular, broken, or projecting tooth [adj]\n",
  "SNAGGY": "full of snags [adj SNAGGIER, SNAGGIEST]\n",
  "SNAGLIKE": "resembling a snag [adj]\n",
  "SNAGS": "SNAG, to catch on a hidden obstacle [v]\n",
  "SNAIL": "to move slowly [v -ED, -ING, -S]\n",
  "SNAILED": "SNAIL, to move slowly [v]\n",
  "SNAILERIES": "SNAILERY, a place where snails are bred [n]\n",
  "SNAILERY": "a place where snails are bred [n SNAILERIES]\n",
  "SNAILFISH": "a sea snail [n -ES]\n",
  "SNAILFISHES": "SNAILFISH, a sea snail [n]\n",
  "SNAILIER": "SNAILY, like a snail [adj]\n",
  "SNAILIEST": "SNAILY, like a snail [adj]\n",
  "SNAILING": "SNAIL, to move slowly [v]\n",
  "SNAILLIKE": "like a snail [adj]\n",
  "SNAILS": "SNAIL, to move slowly [v]\n",
  "SNAILY": "like a snail [adj SNAILIER, SNAILIEST]\n",
  "SNAKE": "to slither like a limbless reptile [v SNAKED, SNAKING, SNAKES]\n",
  "SNAKEBIRD": "the darter (anhinga) or the wryneck (jynx) [n -S]\n",
  "SNAKEBIRDS": "SNAKEBIRD, the darter (anhinga) or the wryneck (jynx) [n]\n",
  "SNAKEBIT": "unlucky [adj]\n",
  "SNAKEBITE": "the bite of a snake [n -S]\n",
  "SNAKEBITES": "SNAKEBITE, the bite of a snake [n]\n",
  "SNAKEBITTEN": "suffering from snakebite [adj]\n",
  "SNAKED": "SNAKE, to slither like a limbless reptile [v]\n",
  "SNAKEFISH": "a fish resembling a snake [n -ES]\n",
  "SNAKEFISHES": "SNAKEFISH, a fish resembling a snake [n]\n",
  "SNAKEHEAD": "a Chinese criminal involving the transport of criminals to other parts of the world [n -S]\n",
  "SNAKEHEADS": "SNAKEHEAD, a Chinese criminal involving the transport of criminals to other parts of the world [n]\n",
  "SNAKELIKE": "like a snake [adj]\n",
  "SNAKEMOUTH": "a North American orchid [n -S]\n",
  "SNAKEMOUTHS": "SNAKEMOUTH, a North American orchid [n]\n",
  "SNAKEPIT": "a pit filled with snakes [n -S]\n",
  "SNAKEPITS": "SNAKEPIT, a pit filled with snakes [n]\n",
  "SNAKEROOT": "bistort, milkwort, or any other plant whose root has been thought good for snakebites [n -S]\n",
  "SNAKEROOTS": "SNAKEROOT, bistort, milkwort, or any other plant whose root has been thought good for snakebites [n]\n",
  "SNAKES": "SNAKE, to slither like a limbless reptile [v]\n",
  "SNAKESKIN": "the skin of a snake [n -S]\n",
  "SNAKESKINS": "SNAKESKIN, the skin of a snake [n]\n",
  "SNAKESTONE": "a kind of hone slate or whetstone obtained in Scotland [n -S]\n",
  "SNAKESTONES": "SNAKESTONE, a kind of hone slate or whetstone obtained in Scotland [n]\n",
  "SNAKEWEED": "a plant with a twisted astringent root, aka bistort [n -S]\n",
  "SNAKEWEEDS": "SNAKEWEED, a plant with a twisted astringent root, aka bistort [n]\n",
  "SNAKEWISE": "in the manner of a snake [adv]\n",
  "SNAKEWOOD": "an East Indian climbing plant having a bitter taste, and supposed to be a remedy for the bite of the cobra [n -S]\n",
  "SNAKEWOODS": "SNAKEWOOD, an East Indian climbing plant having a bitter taste, and supposed to be a remedy for the bite of the cobra [n]\n",
  "SNAKEY": "like a snake, also SNAKY [adj SNAKIER, SNAKIEST]\n",
  "SNAKIER": "SNAKY, like a snake, also SNAKEY [adj]\n",
  "SNAKIEST": "SNAKY, like a snake, also SNAKEY [adj]\n",
  "SNAKILY": "SNAKY, like a snake, also SNAKEY [adv]\n",
  "SNAKINESS": "being like a snake [n -ES]\n",
  "SNAKINESSES": "SNAKINESS, being like a snake [n]\n",
  "SNAKING": "SNAKE, to slither like a limbless reptile [v]\n",
  "SNAKISH": "like a snake [adj]\n",
  "SNAKISHNESS": "the state of being snakish [n -ES]\n",
  "SNAKISHNESSES": "SNAKISHNESS, the state of being snakish [n]\n",
  "SNAKY": "like a snake, also SNAKEY [adj SNAKIER, SNAKIEST, SNAKILY]\n",
  "SNAP": "to make a sharp, cracking sound [v SNAPPED, SNAPPING, SNAPS]\n",
  "SNAPBACK": "a sudden rebound or recovery [n -S]\n",
  "SNAPBACKS": "SNAPBACK, a sudden rebound or recovery [n]\n",
  "SNAPDRAGON": "a plant of the figwort family whose flower when pinched and released snaps like a dragon [n -S]\n",
  "SNAPDRAGONS": "SNAPDRAGON, a plant of the figwort family whose flower when pinched and released snaps like a dragon [n]\n",
  "SNAPHANCE": "(obsolete) a freebooter; a flintlock; a spring catch or trap, also SNAPHAUNCE, SNAPHAUNCH [n -S]\n",
  "SNAPHANCES": "SNAPHANCE, (obsolete) a freebooter; a flintlock; a spring catch or trap, also SNAPHAUNCE, SNAPHAUNCH [n]\n",
  "SNAPHAUNCE": "(obsolete) a freebooter; a flintlock; a spring catch or trap, also SNAPHANCE, SNAPHAUNCH [n -S]\n",
  "SNAPHAUNCES": "SNAPHAUNCE, (obsolete) a freebooter; a flintlock; a spring catch or trap, also SNAPHANCE, SNAPHAUNCH [n]\n",
  "SNAPHAUNCH": "(obsolete) a freebooter; a flintlock; a spring catch or trap, also SNAPHANCE, SNAPHAUNCE [n -ES]\n",
  "SNAPHAUNCHES": "SNAPHAUNCH, (obsolete) a freebooter; a flintlock; a spring catch or trap, also SNAPHANCE, SNAPHAUNCE [n]\n",
  "SNAPLESS": "lacking a fastening device [adj]\n",
  "SNAPLINK": "a metal link used in mountaineering [n -S]\n",
  "SNAPLINKS": "SNAPLINK, a metal link used in mountaineering [n]\n",
  "SNAPPABLE": "that can be snapped [adj]\n",
  "SNAPPED": "SNAP, to make a sharp, cracking sound [v]\n",
  "SNAPPER": "to stumble, trip [v -ED, -ING, -S]\n",
  "SNAPPERED": "SNAPPER, to stumble, trip [v]\n",
  "SNAPPERING": "SNAPPER, to stumble, trip [v]\n",
  "SNAPPERS": "SNAPPER, to stumble, trip [v]\n",
  "SNAPPIER": "SNAPPY, bad-tempered [adj]\n",
  "SNAPPIEST": "SNAPPY, bad-tempered [adj]\n",
  "SNAPPILY": "SNAPPY, bad-tempered [adv]\n",
  "SNAPPINESS": "the state of being snappy [n -ES]\n",
  "SNAPPINESSES": "SNAPPINESS, the state of being snappy [n]\n",
  "SNAPPING": "irritable [adj SNAPPINGLY] / the act of snapping [n -S]\n",
  "SNAPPINGLY": "SNAPPING, irritable [adv]\n",
  "SNAPPINGS": "SNAPPING, the act of snapping [n]\n",
  "SNAPPISH": "tending to behave in an impatient or irritable manner [adj SNAPPISHLY]\n",
  "SNAPPISHLY": "SNAPPISH, tending to behave in an impatient or irritable manner [adv]\n",
  "SNAPPISHNESS": "the state of being snappish [n -ES]\n",
  "SNAPPISHNESSES": "SNAPPISHNESS, the state of being snappish [n]\n",
  "SNAPPY": "bad-tempered [adj SNAPPIER, SNAPPIEST, SNAPPILY]\n",
  "SNAPS": "SNAP, to make a sharp, cracking sound [v]\n",
  "SNAPSHOOTER": "one who takes snapshots [n -S]\n",
  "SNAPSHOOTERS": "SNAPSHOOTER, one who takes snapshots [n]\n",
  "SNAPSHOOTING": "the act of taking snapshots [n -S]\n",
  "SNAPSHOOTINGS": "SNAPSHOOTING, the act of taking snapshots [n]\n",
  "SNAPSHOT": "to photograph informally and quickly [v SNAPSHOTTED, SNAPSHOTTING, SNAPSHOTS]\n",
  "SNAPSHOTS": "SNAPSHOT, to photograph informally and quickly [v]\n",
  "SNAPSHOTTED": "SNAPSHOT, to photograph informally and quickly [v]\n",
  "SNAPSHOTTING": "SNAPSHOT, to photograph informally and quickly [v]\n",
  "SNAPTIN": "(dialect) a container for food [n -S]\n",
  "SNAPTINS": "SNAPTIN, (dialect) a container for food [n]\n",
  "SNAPWEED": "a flowering plant [n -S]\n",
  "SNAPWEEDS": "SNAPWEED, a flowering plant [n]\n",
  "SNAR": "(Spenser) to snarl [v SNARRED, SNARRING, SNARS]\n",
  "SNARE": "to trap [v SNARED, SNARING, SNARES]\n",
  "SNARED": "SNARE, to trap [v]\n",
  "SNARELESS": "without a snare [adj]\n",
  "SNARER": "one who sets snares [n -S]\n",
  "SNARERS": "SNARER, one who sets snares [n]\n",
  "SNARES": "SNARE, to trap [v]\n",
  "SNARF": "(colloquial) to eat or drink greedily [v -ED, -ING, -S]\n",
  "SNARFED": "SNARF, (colloquial) to eat or drink greedily [v]\n",
  "SNARFING": "SNARF, (colloquial) to eat or drink greedily [v]\n",
  "SNARFLE": "to snarl [v SNARFLED, SNARFLING, SNARFLES]\n",
  "SNARFLED": "SNARFLE, to snarl [v]\n",
  "SNARFLES": "SNARFLE, to snarl [v]\n",
  "SNARFLING": "SNARFLE, to snarl [v]\n",
  "SNARFS": "SNARF, (colloquial) to eat or drink greedily [v]\n",
  "SNARIER": "SNARY, in danger of entrapment [adj]\n",
  "SNARIEST": "SNARY, in danger of entrapment [adj]\n",
  "SNARING": "the act of snaring [n -S]\n",
  "SNARINGS": "SNARING, the act of snaring [n]\n",
  "SNARK": "an imaginary animal created by Lewis Carroll [n -S]\n",
  "SNARKIER": "SNARKY, crotchety [adj]\n",
  "SNARKIEST": "SNARKY, crotchety [adj]\n",
  "SNARKILY": "SNARKY, crotchety [adv]\n",
  "SNARKS": "SNARK, an imaginary animal created by Lewis Carroll [n]\n",
  "SNARKY": "crotchety [adj SNARKIER, SNARKIEST, SNARKILY]\n",
  "SNARL": "to growl viciously [v -ED, -ING, -S]\n",
  "SNARLED": "SNARL, to growl viciously [v]\n",
  "SNARLER": "one who snarls [n -S]\n",
  "SNARLERS": "SNARLER, one who snarls [n]\n",
  "SNARLIER": "SNARLY, tangled [adj]\n",
  "SNARLIEST": "SNARLY, tangled [adj]\n",
  "SNARLING": "making a snarling noise [adj SNARLINGLY] / the act of snarling [n -S]\n",
  "SNARLINGLY": "SNARLING, making a snarling noise [adv]\n",
  "SNARLINGS": "SNARLING, the act of snarling [n]\n",
  "SNARLS": "SNARL, to growl viciously [v]\n",
  "SNARLY": "tangled [adj SNARLIER, SNARLIEST]\n",
  "SNARRED": "SNAR, (Spenser) to snarl [v]\n",
  "SNARRING": "SNAR, (Spenser) to snarl [v]\n",
  "SNARS": "SNAR, (Spenser) to snarl [v]\n",
  "SNARY": "in danger of entrapment [adj SNARIER, SNARIEST]\n",
  "SNASH": "to talk abusively [v -ED, -ING, -ES]\n",
  "SNASHED": "SNASH, to talk abusively [v]\n",
  "SNASHES": "SNASH, to talk abusively [v]\n",
  "SNASHING": "SNASH, to talk abusively [v]\n",
  "SNASTE": "(dialect) a wick; a candle-snuff [n -S]\n",
  "SNASTES": "SNASTE, (dialect) a wick; a candle-snuff [n]\n",
  "SNATCH": "to seize suddenly [v -ED, -ING, -ES]\n",
  "SNATCHED": "SNATCH, to seize suddenly [v]\n",
  "SNATCHER": "one who snatches [n -S]\n",
  "SNATCHERS": "SNATCHER, one who snatches [n]\n",
  "SNATCHES": "SNATCH, to seize suddenly [v]\n",
  "SNATCHIER": "SNATCHY, irregular, in snatches [adj]\n",
  "SNATCHIEST": "SNATCHY, irregular, in snatches [adj]\n",
  "SNATCHILY": "SNATCHY, irregular, in snatches [adv]\n",
  "SNATCHING": "an act of snatching [n -S]\n",
  "SNATCHINGLY": "SNATCHING [adv]\n",
  "SNATCHINGS": "SNATCHING, an act of snatching [n]\n",
  "SNATCHY": "irregular, in snatches [adj SNATCHIER, SNATCHIEST, SNATCHILY]\n",
  "SNATH": "the curved handle of a scythe, also SNATHE, SNEAD, SNEATH [n -S]\n",
  "SNATHE": "the curved handle of a scythe, also SNATH, SNEAD, SNEATH [n -S]\n",
  "SNATHES": "SNATHE, the curved handle of a scythe, also SNATH, SNEAD, SNEATH [n]\n",
  "SNATHS": "SNATH, the curved handle of a scythe, also SNATHE, SNEAD, SNEATH [n]\n",
  "SNAW": "(dialect) to snow [v -ED, -ING, -S]\n",
  "SNAWED": "SNAW, (dialect) to snow [v]\n",
  "SNAWING": "SNAW, (dialect) to snow [v]\n",
  "SNAWS": "SNAW, (dialect) to snow [v]\n",
  "SNAZZIER": "SNAZZY, trendily smart [adj]\n",
  "SNAZZIEST": "SNAZZY, trendily smart [adj]\n",
  "SNAZZILY": "SNAZZY, trendily smart [adv]\n",
  "SNAZZINESS": "the state of being snazzy [n -ES]\n",
  "SNAZZINESSES": "SNAZZINESS, the state of being snazzy [n]\n",
  "SNAZZY": "trendily smart [adj SNAZZIER, SNAZZIEST, SNAZZILY]\n",
  "SNEAD": "the curved handle of a scythe, also SNATH, SNATHE, SNEATH [n -S]\n",
  "SNEADS": "SNEAD, the curved handle of a scythe, also SNATH, SNATHE, SNEATH [n]\n",
  "SNEAK": "to move stealthily [v SNEAKED or SNUCK, SNEAKING, SNEAKS]\n",
  "SNEAKBOX": "a small boat masked with brush and weeds that is used for wildfowl hunting [n -ES]\n",
  "SNEAKBOXES": "SNEAKBOX, a small boat masked with brush and weeds that is used for wildfowl hunting [n]\n",
  "SNEAKED": "SNEAK, to move stealthily [v]\n",
  "SNEAKER": "(colloquial) a plimsoll [n -S]\n",
  "SNEAKERED": "wearing sneakers [adj]\n",
  "SNEAKERS": "SNEAKER, (colloquial) a plimsoll [n]\n",
  "SNEAKEUP": "(Shakespeare) a sneak, a shirker [n -S]\n",
  "SNEAKEUPS": "SNEAKEUP, (Shakespeare) a sneak, a shirker [n]\n",
  "SNEAKIER": "SNEAKY, crafty [adj]\n",
  "SNEAKIEST": "SNEAKY, crafty [adj]\n",
  "SNEAKILY": "SNEAKY, crafty [adv]\n",
  "SNEAKINESS": "the state of being sneaky [n -ES]\n",
  "SNEAKINESSES": "SNEAKINESS, the state of being sneaky [n]\n",
  "SNEAKING": "SNEAK, to move stealthily [v]\n",
  "SNEAKINGLY": "SNEAKING, SNEAK, to move stealthily [adv]\n",
  "SNEAKINGNESS": "the state of being sneaking [n -ES]\n",
  "SNEAKINGNESSES": "SNEAKINGNESS, the state of being sneaking [n]\n",
  "SNEAKISH": "befitting a sneak [adj SNEAKISHLY]\n",
  "SNEAKISHLY": "SNEAKISH, befitting a sneak [adv]\n",
  "SNEAKISHNESS": "the state of being sneakish [n -ES]\n",
  "SNEAKISHNESSES": "SNEAKISHNESS, the state of being sneakish [n]\n",
  "SNEAKS": "SNEAK, to move stealthily [v]\n",
  "SNEAKSBIES": "SNEAKSBY, (archaic) a sneak [n]\n",
  "SNEAKSBY": "(archaic) a sneak [n SNEAKSBIES]\n",
  "SNEAKY": "crafty [adj SNEAKIER, SNEAKIEST, SNEAKILY]\n",
  "SNEAP": "to nip, pinch [v -ED, -ING, -S]\n",
  "SNEAPED": "SNEAP, to nip, pinch [v]\n",
  "SNEAPING": "SNEAP, to nip, pinch [v]\n",
  "SNEAPS": "SNEAP, to nip, pinch [v]\n",
  "SNEATH": "the curved handle of a scythe, also SNATH, SNATHE, SNEAD [n -S]\n",
  "SNEATHS": "SNEATH, the curved handle of a scythe, also SNATH, SNATHE, SNEAD [n]\n",
  "SNEB": "to reprimand, also SNEBBE, SNUB, SNUBBE [v SNEBBED, SNEBBING, SNEBS]\n",
  "SNEBBE": "to reprimand, also SNEB, SNUB, SNUBBE [v SNEBBED, SNEBBING, SNEBBES]\n",
  "SNEBBED": "SNEB, to reprimand, also SNEBBE, SNUB, SNUBBE [v]\n",
  "SNEBBES": "SNEBBE, to reprimand, also SNEB, SNUB, SNUBBE [v]\n",
  "SNEBBING": "SNEB, to reprimand, also SNEBBE, SNUB, SNUBBE [v]\n",
  "SNEBS": "SNEB, to reprimand, also SNEBBE, SNUB, SNUBBE [v]\n",
  "SNECK": "(Scots) to fasten with a latch [v -ED, -ING, -S]\n",
  "SNECKED": "SNECK, (Scots) to fasten with a latch [v]\n",
  "SNECKING": "SNECK, (Scots) to fasten with a latch [v]\n",
  "SNECKS": "SNECK, (Scots) to fasten with a latch [v]\n",
  "SNED": "to cut, lop [v SNEDDED, SNEDDING, SNEDS]\n",
  "SNEDDED": "SNED, to cut, lop [v]\n",
  "SNEDDING": "SNED, to cut, lop [v]\n",
  "SNEDS": "SNED, to cut, lop [v]\n",
  "SNEE": "(obsolete) to cut [v SNEED, SNEEING, SNEES]\n",
  "SNEED": "SNEE, (obsolete) to cut [v]\n",
  "SNEEING": "SNEE, (obsolete) to cut [v]\n",
  "SNEER": "to curl the lip in contempt [v -ED, -ING, -S]\n",
  "SNEERED": "SNEER, to curl the lip in contempt [v]\n",
  "SNEERER": "one who sneers [n -S]\n",
  "SNEERERS": "SNEERER, one who sneers [n]\n",
  "SNEERFUL": "given to sneering [adj]\n",
  "SNEERIER": "SNEERY, full of sneers [adj]\n",
  "SNEERIEST": "SNEERY, full of sneers [adj]\n",
  "SNEERING": "contemptuous [adj SNEERINGLY] / the act of sneering [n -S]\n",
  "SNEERINGLY": "SNEERING, contemptuous [adv]\n",
  "SNEERINGS": "SNEERING, the act of sneering [n]\n",
  "SNEERS": "SNEER, to curl the lip in contempt [v]\n",
  "SNEERY": "full of sneers [adj SNEERIER, SNEERIEST]\n",
  "SNEES": "SNEE, (obsolete) to cut [v]\n",
  "SNEESH": "(Scots) snuff, also SNEESHAN, SNEESHIN, SNEESHING [n -ES] / to take snuff [v -ED, -ING, -ES]\n",
  "SNEESHAN": "(Scots) snuff, also SNEESH, SNEESHIN, SNEESHING [n -S]\n",
  "SNEESHANS": "SNEESHAN, (Scots) snuff, also SNEESH, SNEESHIN, SNEESHING [n]\n",
  "SNEESHED": "SNEESH, to take snuff [v]\n",
  "SNEESHES": "SNEESH, (Scots) snuff, also SNEESHAN, SNEESHIN, SNEESHING [n]\n",
  "SNEESHIN": "(Scots) snuff, also SNEESH, SNEESHAN, SNEESHING [n -S]\n",
  "SNEESHING": "(Scots) snuff, also SNEESH, SNEESHAN, SNEESHIN [n -S]\n",
  "SNEESHINGS": "SNEESHING, (Scots) snuff, also SNEESH, SNEESHAN, SNEESHIN [n]\n",
  "SNEESHINS": "SNEESHIN, (Scots) snuff, also SNEESH, SNEESHAN, SNEESHING [n]\n",
  "SNEEZE": "to make a sudden expiration through nose and mouth [v SNEEZED, SNEEZING, SNEEZES]\n",
  "SNEEZED": "SNEEZE, to make a sudden expiration through nose and mouth [v]\n",
  "SNEEZELESS": "without a sneeze [adj]\n",
  "SNEEZER": "one who sneezes [n -S]\n",
  "SNEEZERS": "SNEEZER, one who sneezes [n]\n",
  "SNEEZES": "SNEEZE, to make a sudden expiration through nose and mouth [v]\n",
  "SNEEZEWEED": "any of several composite plants [n -S]\n",
  "SNEEZEWEEDS": "SNEEZEWEED, any of several composite plants [n]\n",
  "SNEEZEWOOD": "a South African timber tree, or its wood, whose sawdust causes sneezing [n -S]\n",
  "SNEEZEWOODS": "SNEEZEWOOD, a South African timber tree, or its wood, whose sawdust causes sneezing [n]\n",
  "SNEEZEWORT": "a herbaceous plant allied to the yarrow, having a strong, pungent smell [n -S]\n",
  "SNEEZEWORTS": "SNEEZEWORT, a herbaceous plant allied to the yarrow, having a strong, pungent smell [n]\n",
  "SNEEZIER": "SNEEZY, tending to sneeze [adj]\n",
  "SNEEZIEST": "SNEEZY, tending to sneeze [adj]\n",
  "SNEEZING": "the act of sneezing [n -S]\n",
  "SNEEZINGS": "SNEEZING, the act of sneezing [n]\n",
  "SNEEZY": "tending to sneeze [adj SNEEZIER, SNEEZIEST]\n",
  "SNELL": "keen, sharp [adj SNELLER, SNELLEST, SNELLY] / to attach such a hook [v -ED, -ING, -S]\n",
  "SNELLED": "SNELL, to attach such a hook [v]\n",
  "SNELLER": "SNELL, keen, sharp [adj]\n",
  "SNELLEST": "SNELL, keen, sharp [adj]\n",
  "SNELLING": "SNELL, to attach such a hook [v]\n",
  "SNELLS": "SNELL, to attach such a hook [v]\n",
  "SNELLY": "SNELL, keen, sharp [adv]\n",
  "SNIB": "(Scots) to fasten with a latch [v SNIBBED, SNIBBING, SNIBS]\n",
  "SNIBBED": "SNIB, (Scots) to fasten with a latch [v]\n",
  "SNIBBING": "SNIB, (Scots) to fasten with a latch [v]\n",
  "SNIBS": "SNIB, (Scots) to fasten with a latch [v]\n",
  "SNICK": "to snip, cut out [v -ED, -ING, -S]\n",
  "SNICKED": "SNICK, to snip, cut out [v]\n",
  "SNICKER": "to utter a partly stifled giggle [v -ED, -ING, -S]\n",
  "SNICKERED": "SNICKER, to utter a partly stifled giggle [v]\n",
  "SNICKERER": "one who snickers [n -S]\n",
  "SNICKERERS": "SNICKERER, one who snickers [n]\n",
  "SNICKERIER": "SNICKERY, tending to snicker [adj]\n",
  "SNICKERIEST": "SNICKERY, tending to snicker [adj]\n",
  "SNICKERING": "SNICKER, to utter a partly stifled giggle [v]\n",
  "SNICKERS": "SNICKER, to utter a partly stifled giggle [v]\n",
  "SNICKERSNEE": "(obsolete) a large knife, cutlass etc. [n -S] / to fight with knives [v SNICKERSNEED, SNICKERSNEEING, SNICKERSNEES]\n",
  "SNICKERSNEED": "SNICKERSNEE, to fight with knives [v]\n",
  "SNICKERSNEEING": "SNICKERSNEE, to fight with knives [v]\n",
  "SNICKERSNEES": "SNICKERSNEE, (obsolete) a large knife, cutlass etc. [n]\n",
  "SNICKERY": "tending to snicker [adj SNICKERIER, SNICKERIEST]\n",
  "SNICKET": "a narrow back street [n -S]\n",
  "SNICKETS": "SNICKET, a narrow back street [n]\n",
  "SNICKING": "SNICK, to snip, cut out [v]\n",
  "SNICKS": "SNICK, to snip, cut out [v]\n",
  "SNIDE": "base, also SNIDEY [adj SNIDER, SNIDEST, SNIDELY] / to fill or load [v SNIDED, SNIDING, SNIDES]\n",
  "SNIDED": "SNIDE, to fill or load [v]\n",
  "SNIDELY": "SNIDE, base, also SNIDEY [adv]\n",
  "SNIDENESS": "baseness, meanness [n -ES]\n",
  "SNIDENESSES": "SNIDENESS, baseness, meanness [n]\n",
  "SNIDER": "SNIDE, base, also SNIDEY [adj]\n",
  "SNIDES": "SNIDE, to fill or load [v]\n",
  "SNIDEST": "SNIDE, base, also SNIDEY [adj]\n",
  "SNIDEY": "maliciously derogatory, also SNIDE [adj SNIDIER, SNIDIEST]\n",
  "SNIDIER": "SNIDEY, maliciously derogatory, also SNIDE [adj]\n",
  "SNIDIEST": "SNIDEY, maliciously derogatory, also SNIDE [adj]\n",
  "SNIDING": "SNIDE, to fill or load [v]\n",
  "SNIES": "SNY, (Canadian) a side channel of a river, also SNYE [n]\n",
  "SNIFF": "to inhale audibly through the nose, also SNIFT [v -ED, -ING, -S]\n",
  "SNIFFABLE": "that can be sniffed [adj]\n",
  "SNIFFED": "SNIFF, to inhale audibly through the nose, also SNIFT [v]\n",
  "SNIFFER": "one who sniffs; a dog used to detect drugs [n -S]\n",
  "SNIFFERS": "SNIFFER, one who sniffs; a dog used to detect drugs [n]\n",
  "SNIFFIER": "SNIFFY, given to sniffing [adj]\n",
  "SNIFFIEST": "SNIFFY, given to sniffing [adj]\n",
  "SNIFFILY": "SNIFFY, given to sniffing [adv]\n",
  "SNIFFINESS": "the state of being sniffy [n -ES]\n",
  "SNIFFINESSES": "SNIFFINESS, the state of being sniffy [n]\n",
  "SNIFFING": "with a sniffing sound [adj SNIFFINGLY] / the act of sniffing [n -S]\n",
  "SNIFFINGLY": "SNIFFING, with a sniffing sound [adv]\n",
  "SNIFFINGS": "SNIFFING, the act of sniffing [n]\n",
  "SNIFFISH": "haughty [adj SNIFFISHLY]\n",
  "SNIFFISHLY": "SNIFFISH, haughty [adv]\n",
  "SNIFFISHNESS": "the state of being sniffish, haughty [n -ES]\n",
  "SNIFFISHNESSES": "SNIFFISHNESS, the state of being sniffish, haughty [n]\n",
  "SNIFFLE": "to sniff repeatedly [v SNIFFLED, SNIFFLING, SNIFFLES]\n",
  "SNIFFLED": "SNIFFLE, to sniff repeatedly [v]\n",
  "SNIFFLER": "one who sniffles; a light breeze [n -S]\n",
  "SNIFFLERS": "SNIFFLER, one who sniffles; a light breeze [n]\n",
  "SNIFFLES": "SNIFFLE, to sniff repeatedly [v]\n",
  "SNIFFLIER": "SNIFFLY, having a sniffle [adj]\n",
  "SNIFFLIEST": "SNIFFLY, having a sniffle [adj]\n",
  "SNIFFLING": "SNIFFLE, to sniff repeatedly [v]\n",
  "SNIFFLY": "having a sniffle [adj SNIFFLIER, SNIFFLIEST]\n",
  "SNIFFS": "SNIFF, to inhale audibly through the nose, also SNIFT [v]\n",
  "SNIFFY": "given to sniffing [adj SNIFFIER, SNIFFIEST, SNIFFILY]\n",
  "SNIFT": "to sniff, to blow out steam [v -ED, -ING, -S]\n",
  "SNIFTED": "SNIFT, to sniff, to blow out steam [v]\n",
  "SNIFTER": "to sniff, snivel [v -ED, -ING, -S]\n",
  "SNIFTERED": "SNIFTER, to sniff, snivel [v]\n",
  "SNIFTERING": "SNIFTER, to sniff, snivel [v]\n",
  "SNIFTERS": "SNIFTER, to sniff, snivel [v]\n",
  "SNIFTIER": "SNIFTY, (slang) having a tempting smell [adj]\n",
  "SNIFTIEST": "SNIFTY, (slang) having a tempting smell [adj]\n",
  "SNIFTING": "SNIFT, to sniff, to blow out steam [v]\n",
  "SNIFTS": "SNIFT, to sniff, to blow out steam [v]\n",
  "SNIFTY": "(slang) having a tempting smell [adj SNIFTIER, SNIFTIEST]\n",
  "SNIG": "to drag a load with chains [v SNIGGED, SNIGGING, SNIGS]\n",
  "SNIGGED": "SNIG, to drag a load with chains [v]\n",
  "SNIGGER": "to snicker [v -ED, -ING, -S]\n",
  "SNIGGERED": "SNIGGER, to snicker [v]\n",
  "SNIGGERER": "one who sniggers [n -S]\n",
  "SNIGGERERS": "SNIGGERER, one who sniggers [n]\n",
  "SNIGGERING": "laughing in a sly way [adj SNIGGERINGLY] / the act of sniggering [n -S]\n",
  "SNIGGERINGLY": "SNIGGERING, laughing in a sly way [adv]\n",
  "SNIGGERINGS": "SNIGGERING, the act of sniggering [n]\n",
  "SNIGGERS": "SNIGGER, to snicker [v]\n",
  "SNIGGING": "SNIG, to drag a load with chains [v]\n",
  "SNIGGLE": "to fish for eels [v SNIGGLED, SNIGGLING, SNIGGLES]\n",
  "SNIGGLED": "SNIGGLE, to fish for eels [v]\n",
  "SNIGGLER": "one who sniggles, fishes for eels [n -S]\n",
  "SNIGGLERS": "SNIGGLER, one who sniggles, fishes for eels [n]\n",
  "SNIGGLES": "SNIGGLE, to fish for eels [v]\n",
  "SNIGGLING": "fishing for eels by thrusting a baited hook into their holes or hiding places [n -S]\n",
  "SNIGGLINGS": "SNIGGLING, fishing for eels by thrusting a baited hook into their holes or hiding places [n]\n",
  "SNIGLET": "a word coined for something not having a name [n -S]\n",
  "SNIGLETS": "SNIGLET, a word coined for something not having a name [n]\n",
  "SNIGS": "SNIG, to drag a load with chains [v]\n",
  "SNIP": "to cut with a short, quick stroke [v SNIPPED, SNIPPING, SNIPS]\n",
  "SNIPE": "to shoot from a concealed place [v SNIPED, SNIPING, SNIPES]\n",
  "SNIPED": "SNIPE, to shoot from a concealed place [v]\n",
  "SNIPEFISH": "the trumpet fish [n -ES]\n",
  "SNIPEFISHES": "SNIPEFISH, the trumpet fish [n]\n",
  "SNIPELIKE": "like a snipe [adj]\n",
  "SNIPER": "one who snipes [n -S]\n",
  "SNIPERS": "SNIPER, one who snipes [n]\n",
  "SNIPERSCOPE": "an optical device for use esp. with a rifle that allows a person to see targets better in the dark [n -S]\n",
  "SNIPERSCOPES": "SNIPERSCOPE, an optical device for use esp. with a rifle that allows a person to see targets better in the dark [n]\n",
  "SNIPES": "SNIPE, to shoot from a concealed place [v]\n",
  "SNIPIER": "SNIPY, snipelike; frequented by snipe [adj]\n",
  "SNIPIEST": "SNIPY, snipelike; frequented by snipe [adj]\n",
  "SNIPING": "the act of sniping [n -S]\n",
  "SNIPINGS": "SNIPING, the act of sniping [n]\n",
  "SNIPPED": "SNIP, to cut with a short, quick stroke [v]\n",
  "SNIPPER": "a tool for snipping [n -S]\n",
  "SNIPPERS": "SNIPPER, a tool for snipping [n]\n",
  "SNIPPERSNAPPER": "a whippersnapper [n -S]\n",
  "SNIPPERSNAPPERS": "SNIPPERSNAPPER, a whippersnapper [n]\n",
  "SNIPPET": "a small piece snipped off [n -S]\n",
  "SNIPPETIER": "SNIPPETY, ridiculously small; petty [adj]\n",
  "SNIPPETIEST": "SNIPPETY, ridiculously small; petty [adj]\n",
  "SNIPPETINESS": "the state of being snippety, ridiculously small [n -ES]\n",
  "SNIPPETINESSES": "SNIPPETINESS, the state of being snippety, ridiculously small [n]\n",
  "SNIPPETS": "SNIPPET, a small piece snipped off [n]\n",
  "SNIPPETY": "ridiculously small; petty [adj SNIPPETIER, SNIPPETIEST]\n",
  "SNIPPIER": "SNIPPY, stingy, snappish [adj]\n",
  "SNIPPIEST": "SNIPPY, stingy, snappish [adj]\n",
  "SNIPPILY": "SNIPPY, stingy, snappish [adv]\n",
  "SNIPPINESS": "the state of being snippy, stingy [n -ES]\n",
  "SNIPPINESSES": "SNIPPINESS, the state of being snippy, stingy [n]\n",
  "SNIPPING": "a clipping [n -S]\n",
  "SNIPPINGS": "SNIPPING, a clipping [n]\n",
  "SNIPPY": "stingy, snappish [adj SNIPPIER, SNIPPIEST, SNIPPILY]\n",
  "SNIPS": "SNIP, to cut with a short, quick stroke [v]\n",
  "SNIPY": "snipelike; frequented by snipe [adj SNIPIER, SNIPIEST]\n",
  "SNIRT": "(Scots) to snigger [v -ED, -ING, -S]\n",
  "SNIRTED": "SNIRT, (Scots) to snigger [v]\n",
  "SNIRTING": "SNIRT, (Scots) to snigger [v]\n",
  "SNIRTLE": "(Scots) to snicker [v SNIRTLED, SNIRTLING, SNIRTLES]\n",
  "SNIRTLED": "SNIRTLE, (Scots) to snicker [v]\n",
  "SNIRTLES": "SNIRTLE, (Scots) to snicker [v]\n",
  "SNIRTLING": "SNIRTLE, (Scots) to snicker [v]\n",
  "SNIRTS": "SNIRT, (Scots) to snigger [v]\n",
  "SNIT": "a state of agitation [n -S]\n",
  "SNITCH": "to inform on, sneak [v -ED, -ING, -ES]\n",
  "SNITCHED": "SNITCH, to inform on, sneak [v]\n",
  "SNITCHER": "one who snitches, informs [n -S]\n",
  "SNITCHERS": "SNITCHER, one who snitches, informs [n]\n",
  "SNITCHES": "SNITCH, to inform on, sneak [v]\n",
  "SNITCHIER": "SNITCHY, (New Zealand) bad tempered [adj]\n",
  "SNITCHIEST": "SNITCHY, (New Zealand) bad tempered [adj]\n",
  "SNITCHING": "SNITCH, to inform on, sneak [v]\n",
  "SNITCHY": "(New Zealand) bad tempered [adj SNITCHIER, SNITCHIEST]\n",
  "SNITS": "SNIT, a state of agitation [n]\n",
  "SNITTIER": "SNITTY, disagreeably ill-tempered [adj]\n",
  "SNITTIEST": "SNITTY, disagreeably ill-tempered [adj]\n",
  "SNITTY": "disagreeably ill-tempered [adj SNITTIER, SNITTIEST]\n",
  "SNIVEL": "to cry or whine with sniffling [v SNIVELED or SNIVELLED, SNIVELING or SNIVELLING, SNIVELS]\n",
  "SNIVELED": "SNIVEL, to cry or whine with sniffling [v]\n",
  "SNIVELER": "one who snivels, also SNIVELLER [n -S]\n",
  "SNIVELERS": "SNIVELER, one who snivels, also SNIVELLER [n]\n",
  "SNIVELIER": "SNIVELY, given to snivelling, also SNIVELLY [adj]\n",
  "SNIVELIEST": "SNIVELY, given to snivelling, also SNIVELLY [adj]\n",
  "SNIVELING": "a snuffling sound indicative of crying [n -S]\n",
  "SNIVELINGS": "SNIVELING, a snuffling sound indicative of crying [n]\n",
  "SNIVELLED": "SNIVEL, to cry or whine with sniffling [v]\n",
  "SNIVELLER": "one who snivels, also SNIVELER [n -S]\n",
  "SNIVELLERS": "SNIVELLER, one who snivels, also SNIVELER [n]\n",
  "SNIVELLIER": "SNIVELLY, given to snivelling, also SNIVELY [adj]\n",
  "SNIVELLIEST": "SNIVELLY, given to snivelling, also SNIVELY [adj]\n",
  "SNIVELLING": "the act or sound of snivelling [n -S]\n",
  "SNIVELLINGS": "SNIVELLING, the act or sound of snivelling [n]\n",
  "SNIVELLY": "given to snivelling, also SNIVELY [adj SNIVELLIER, SNIVELLIEST]\n",
  "SNIVELS": "SNIVEL, to cry or whine with sniffling [v]\n",
  "SNIVELY": "given to snivelling, also SNIVELLY [adj SNIVELIER, SNIVELIEST]\n",
  "SNOB": "a person who puts too much value on social standing [n -S]\n",
  "SNOBBERIES": "SNOBBERY, snobbish behaviour [n]\n",
  "SNOBBERY": "snobbish behaviour [n SNOBBERIES]\n",
  "SNOBBIER": "SNOBBY, snobbish [adj]\n",
  "SNOBBIEST": "SNOBBY, snobbish [adj]\n",
  "SNOBBILY": "SNOBBY, snobbish [adv]\n",
  "SNOBBISH": "characteristic of a snob [adj SNOBBISHLY]\n",
  "SNOBBISHLY": "SNOBBISH, characteristic of a snob [adv]\n",
  "SNOBBISHNESS": "the state of being snobbish [n -ES]\n",
  "SNOBBISHNESSES": "SNOBBISHNESS, the state of being snobbish [n]\n",
  "SNOBBISM": "the practice of snobbery [n -S]\n",
  "SNOBBISMS": "SNOBBISM, the practice of snobbery [n]\n",
  "SNOBBOCRACIES": "SNOBBOCRACY, government by snobs [n]\n",
  "SNOBBOCRACY": "government by snobs [n SNOBBOCRACIES]\n",
  "SNOBBY": "snobbish [adj SNOBBIER, SNOBBIEST, SNOBBILY]\n",
  "SNOBLING": "a little snob [n -S]\n",
  "SNOBLINGS": "SNOBLING, a little snob [n]\n",
  "SNOBOCRACIES": "SNOBOCRACY, government by snobs [n]\n",
  "SNOBOCRACY": "government by snobs [n SNOBOCRACIES]\n",
  "SNOBOGRAPHER": "one who engages in snobography, the description of snobs [n -S]\n",
  "SNOBOGRAPHERS": "SNOBOGRAPHER, one who engages in snobography, the description of snobs [n]\n",
  "SNOBOGRAPHIES": "SNOBOGRAPHY, the description of snobs and snobbery [n]\n",
  "SNOBOGRAPHY": "the description of snobs and snobbery [n SNOBOGRAPHIES]\n",
  "SNOBS": "SNOB, a person who puts too much value on social standing [n]\n",
  "SNOCOACH": "a bus-like vehicle with large tyres or tracks for travelling on snow, also SNOWCOACH [n -ES]\n",
  "SNOCOACHES": "SNOCOACH, a bus-like vehicle with large tyres or tracks for travelling on snow, also SNOWCOACH [n]\n",
  "SNOD": "(Scots) smooth, neat [adj SNODDER, SNODDEST] / to trim, tidy [v SNODDED, SNODDIT, SNODDING, SNODS]\n",
  "SNODDED": "SNOD, to trim, tidy [v]\n",
  "SNODDER": "SNOD, (Scots) smooth, neat [adj]\n",
  "SNODDEST": "SNOD, (Scots) smooth, neat [adj]\n",
  "SNODDING": "SNOD, to trim, tidy [v]\n",
  "SNODDIT": "SNOD, to trim, tidy [v]\n",
  "SNODS": "SNOD, to trim, tidy [v]\n",
  "SNOEK": "(Dutch) the barracouta [n -S]\n",
  "SNOEKS": "SNOEK, (Dutch) the barracouta [n]\n",
  "SNOEP": "(South African) tightfisted [adj]\n",
  "SNOG": "(slang) to kiss [v SNOGGED, SNOGGING, SNOGS]\n",
  "SNOGGED": "SNOG, (slang) to kiss [v]\n",
  "SNOGGER": "one that snogs [n -S]\n",
  "SNOGGERS": "SNOGGER, one that snogs [n]\n",
  "SNOGGING": "SNOG, (slang) to kiss [v]\n",
  "SNOGS": "SNOG, (slang) to kiss [v]\n",
  "SNOKE": "to prowl or sneak about, also SNOOK, SNOWK [v SNOKED, SNOKING, SNOKES]\n",
  "SNOKED": "SNOKE, to prowl or sneak about, also SNOOK, SNOWK [v]\n",
  "SNOKES": "SNOKE, to prowl or sneak about, also SNOOK, SNOWK [v]\n",
  "SNOKING": "SNOKE, to prowl or sneak about, also SNOOK, SNOWK [v]\n",
  "SNOLLYGOSTER": "a shrewd unprincipled person, esp. a dishonest politician [n -S]\n",
  "SNOLLYGOSTERS": "SNOLLYGOSTER, a shrewd unprincipled person, esp. a dishonest politician [n]\n",
  "SNOOD": "to wear a net or fabric cap on the hair [v -ED, -ING, -S]\n",
  "SNOODED": "SNOOD, to wear a net or fabric cap on the hair [v]\n",
  "SNOODING": "SNOOD, to wear a net or fabric cap on the hair [v]\n",
  "SNOODS": "SNOOD, to wear a net or fabric cap on the hair [v]\n",
  "SNOOK": "to snuff or smell about, also SNOKE, SNOWK [v -ED, -ING, -S]\n",
  "SNOOKED": "SNOOK, to snuff or smell about, also SNOKE, SNOWK [v]\n",
  "SNOOKER": "to thwart, obstruct [v -ED, -ING, -S]\n",
  "SNOOKERED": "SNOOKER, to thwart, obstruct [v]\n",
  "SNOOKERING": "SNOOKER, to thwart, obstruct [v]\n",
  "SNOOKERS": "SNOOKER, to thwart, obstruct [v]\n",
  "SNOOKING": "SNOOK, to snuff or smell about, also SNOKE, SNOWK [v]\n",
  "SNOOKS": "SNOOK, to snuff or smell about, also SNOKE, SNOWK [v]\n",
  "SNOOL": "(Scots) to be tamely submissive [v -ED, -ING, -S]\n",
  "SNOOLED": "SNOOL, (Scots) to be tamely submissive [v]\n",
  "SNOOLING": "SNOOL, (Scots) to be tamely submissive [v]\n",
  "SNOOLS": "SNOOL, (Scots) to be tamely submissive [v]\n",
  "SNOOP": "to pry about [v -ED, -ING, -S]\n",
  "SNOOPED": "SNOOP, to pry about [v]\n",
  "SNOOPER": "one who snoops [n -S]\n",
  "SNOOPERS": "SNOOPER, one who snoops [n]\n",
  "SNOOPERSCOPE": "an instrument for viewing infrared radiation [n -S]\n",
  "SNOOPERSCOPES": "SNOOPERSCOPE, an instrument for viewing infrared radiation [n]\n",
  "SNOOPIER": "SNOOPY, prying [adj]\n",
  "SNOOPIEST": "SNOOPY, prying [adj]\n",
  "SNOOPILY": "SNOOPY, prying [adv]\n",
  "SNOOPING": "SNOOP, to pry about [v]\n",
  "SNOOPS": "SNOOP, to pry about [v]\n",
  "SNOOPY": "prying [adj SNOOPIER, SNOOPIEST, SNOOPILY]\n",
  "SNOOSE": "chewing tobacco [n -S]\n",
  "SNOOSES": "SNOOSE, chewing tobacco [n]\n",
  "SNOOT": "to treat with disdain [v -ED, -ING, -S]\n",
  "SNOOTED": "SNOOT, to treat with disdain [v]\n",
  "SNOOTFUL": "(colloquial) enough alcohol to make one drunk [n -S]\n",
  "SNOOTFULS": "SNOOTFUL, (colloquial) enough alcohol to make one drunk [n]\n",
  "SNOOTIER": "SNOOTY, supercilious [adj]\n",
  "SNOOTIEST": "SNOOTY, supercilious [adj]\n",
  "SNOOTILY": "SNOOTY, supercilious [adv]\n",
  "SNOOTINESS": "the state of being snooty [n -ES]\n",
  "SNOOTINESSES": "SNOOTINESS, the state of being snooty [n]\n",
  "SNOOTING": "SNOOT, to treat with disdain [v]\n",
  "SNOOTS": "SNOOT, to treat with disdain [v]\n",
  "SNOOTY": "supercilious [adj SNOOTIER, SNOOTIEST, SNOOTILY]\n",
  "SNOOZE": "to sleep lightly [v SNOOZED, SNOOZING, SNOOZES]\n",
  "SNOOZED": "SNOOZE, to sleep lightly [v]\n",
  "SNOOZER": "one who snoozes [n -S]\n",
  "SNOOZERS": "SNOOZER, one who snoozes [n]\n",
  "SNOOZES": "SNOOZE, to sleep lightly [v]\n",
  "SNOOZIER": "SNOOZY, given to snoozing [adj]\n",
  "SNOOZIEST": "SNOOZY, given to snoozing [adj]\n",
  "SNOOZING": "SNOOZE, to sleep lightly [v]\n",
  "SNOOZLE": "(colloquial) to nuzzle and then sleep [v SNOOZLED, SNOOZLING, SNOOZLES]\n",
  "SNOOZLED": "SNOOZLE, (colloquial) to nuzzle and then sleep [v]\n",
  "SNOOZLES": "SNOOZLE, (colloquial) to nuzzle and then sleep [v]\n",
  "SNOOZLING": "SNOOZLE, (colloquial) to nuzzle and then sleep [v]\n",
  "SNOOZY": "given to snoozing [adj SNOOZIER, SNOOZIEST]\n",
  "SNORE": "to breath noisily while sleeping [v SNORED, SNORING, SNORES]\n",
  "SNORED": "SNORE, to breath noisily while sleeping [v]\n",
  "SNORER": "one who snores [n -S]\n",
  "SNORERS": "SNORER, one who snores [n]\n",
  "SNORES": "SNORE, to breath noisily while sleeping [v]\n",
  "SNORING": "the act of snoring [n -S]\n",
  "SNORINGS": "SNORING, the act of snoring [n]\n",
  "SNORKEL": "(German) a mouthpiece used by an underwater swimmer, also SCHNORKEL [n -S] / to swim using a snorkel [v SNORKELED or SNORKELLED, SNORKELING or SNORKELLING, SNORKELS]\n",
  "SNORKELED": "SNORKEL, to swim using a snorkel [v]\n",
  "SNORKELER": "one who snorkels, also SNORKELLER [n -S]\n",
  "SNORKELERS": "SNORKELER, one who snorkels, also SNORKELLER [n]\n",
  "SNORKELING": "the act of using a snorkel [n -S]\n",
  "SNORKELINGS": "SNORKELING, the act of using a snorkel [n]\n",
  "SNORKELLED": "SNORKEL, to swim using a snorkel [v]\n",
  "SNORKELLER": "one who uses a snorkel, also SNORKELER [n -S]\n",
  "SNORKELLERS": "SNORKELLER, one who uses a snorkel, also SNORKELER [n]\n",
  "SNORKELLING": "the act of using a snorkel [n -S]\n",
  "SNORKELLINGS": "SNORKELLING, the act of using a snorkel [n]\n",
  "SNORKELS": "SNORKEL, to swim using a snorkel [v]\n",
  "SNORT": "to exhale noisily through the nostrils [v -ED, -ING, -S]\n",
  "SNORTED": "SNORT, to exhale noisily through the nostrils [v]\n",
  "SNORTER": "one that snorts [n -S]\n",
  "SNORTERS": "SNORTER, one that snorts [n]\n",
  "SNORTIER": "SNORTY, inclined to snort; (colloquial) ready to take offence [adj]\n",
  "SNORTIEST": "SNORTY, inclined to snort; (colloquial) ready to take offence [adj]\n",
  "SNORTING": "making a snorting noise [adj SNORTINGLY] / the act or sound of snorting [n -S]\n",
  "SNORTINGLY": "SNORTING, making a snorting noise [adv]\n",
  "SNORTINGS": "SNORTING, the act or sound of snorting [n]\n",
  "SNORTS": "SNORT, to exhale noisily through the nostrils [v]\n",
  "SNORTY": "inclined to snort; (colloquial) ready to take offence [adj SNORTIER, SNORTIEST]\n",
  "SNOT": "to blow the nose [v SNOTTED, SNOTTING, SNOTS]\n",
  "SNOTRAG": "(slang) a handkerchief [n -S]\n",
  "SNOTRAGS": "SNOTRAG, (slang) a handkerchief [n]\n",
  "SNOTS": "SNOT, to blow the nose [v]\n",
  "SNOTTED": "SNOT, to blow the nose [v]\n",
  "SNOTTER": "to snivel [v -ED, -ING, -S]\n",
  "SNOTTERED": "SNOTTER, to snivel [v]\n",
  "SNOTTERIES": "SNOTTERY, filthiness [n]\n",
  "SNOTTERING": "SNOTTER, to snivel [v]\n",
  "SNOTTERS": "SNOTTER, to snivel [v]\n",
  "SNOTTERY": "filthiness [n SNOTTERIES]\n",
  "SNOTTIE": "(slang) a midshipman, also SNOTTY [n -S]\n",
  "SNOTTIER": "SNOTTY, foul with snot [adj]\n",
  "SNOTTIES": "SNOTTIE, (slang) a midshipman, also SNOTTY [n]\n",
  "SNOTTIEST": "SNOTTY, foul with snot [adj]\n",
  "SNOTTILY": "SNOTTY, foul with snot [adv]\n",
  "SNOTTINESS": "the state of being snotty [n -ES]\n",
  "SNOTTINESSES": "SNOTTINESS, the state of being snotty [n]\n",
  "SNOTTING": "SNOT, to blow the nose [v]\n",
  "SNOTTY": "foul with snot [adj SNOTTIER, SNOTTIEST, SNOTTILY] / a midshipman, also SNOTTIE [n SNOTTIES]\n",
  "SNOUT": "to provide with a nozzle [v -ED, -ING, -S]\n",
  "SNOUTED": "SNOUT, to provide with a nozzle [v]\n",
  "SNOUTIER": "SNOUTY, resembling a long, projecting nose [adj]\n",
  "SNOUTIEST": "SNOUTY, resembling a long, projecting nose [adj]\n",
  "SNOUTING": "SNOUT, to provide with a nozzle [v]\n",
  "SNOUTISH": "like a snout [adj]\n",
  "SNOUTLESS": "without a snout [adj]\n",
  "SNOUTLIKE": "like a snout [adj]\n",
  "SNOUTS": "SNOUT, to provide with a nozzle [v]\n",
  "SNOUTY": "resembling a long, projecting nose [adj SNOUTIER, SNOUTIEST]\n",
  "SNOW": "to rain white frozen crystals, also SNAW [v -ED, -ING, -S]\n",
  "SNOWBALL": "to increase at a rapid rate [v -ED, -ING, -S]\n",
  "SNOWBALLED": "SNOWBALL, to increase at a rapid rate [v]\n",
  "SNOWBALLING": "SNOWBALL, to increase at a rapid rate [v]\n",
  "SNOWBALLS": "SNOWBALL, to increase at a rapid rate [v]\n",
  "SNOWBANK": "a mound of snow [n -S]\n",
  "SNOWBANKS": "SNOWBANK, a mound of snow [n]\n",
  "SNOWBELL": "a flowering shrub [n -S]\n",
  "SNOWBELLS": "SNOWBELL, a flowering shrub [n]\n",
  "SNOWBELT": "an area of regular snowfall [n -S]\n",
  "SNOWBELTS": "SNOWBELT, an area of regular snowfall [n]\n",
  "SNOWBERRIES": "SNOWBERRY, the white berry of a North American shrub of the honeysuckle family [n]\n",
  "SNOWBERRY": "the white berry of a North American shrub of the honeysuckle family [n SNOWBERRIES]\n",
  "SNOWBIRD": "an arctic finch, often appearing in large flocks during snowstorms [n -S]\n",
  "SNOWBIRDS": "SNOWBIRD, an arctic finch, often appearing in large flocks during snowstorms [n]\n",
  "SNOWBLADER": "one who engages in snowblading, a form of skiing without poles, using short skis [n -S]\n",
  "SNOWBLADERS": "SNOWBLADER, one who engages in snowblading, a form of skiing without poles, using short skis [n]\n",
  "SNOWBLADES": "short skis used without poles [n]\n",
  "SNOWBLADING": "a form of skiing without poles, using short skis [n -S]\n",
  "SNOWBLADINGS": "SNOWBLADING, a form of skiing without poles, using short skis [n]\n",
  "SNOWBLINK": "a glare in the sky caused by light reflected off snow [n -S]\n",
  "SNOWBLINKS": "SNOWBLINK, a glare in the sky caused by light reflected off snow [n]\n",
  "SNOWBLOWER": "a machine for clearing snow by blowing it away [n -S]\n",
  "SNOWBLOWERS": "SNOWBLOWER, a machine for clearing snow by blowing it away [n]\n",
  "SNOWBOARD": "a board, similar to a skateboard but without wheels, on which the user balances, guiding the board with movements of the feet and body [n -S] / to use a snowboard [v -ED, -ING, -S]\n",
  "SNOWBOARDED": "SNOWBOARD, to use a snowboard [v]\n",
  "SNOWBOARDER": "one who rides on a snowboard [n -S]\n",
  "SNOWBOARDERS": "SNOWBOARDER, one who rides on a snowboard [n]\n",
  "SNOWBOARDING": "the sport of using a snowboard [n -S]\n",
  "SNOWBOARDINGS": "SNOWBOARDING, the sport of using a snowboard [n]\n",
  "SNOWBOARDS": "SNOWBOARD, to use a snowboard [v]\n",
  "SNOWBOOT": "a boot for walking in snow [n -S]\n",
  "SNOWBOOTS": "SNOWBOOT, a boot for walking in snow [n]\n",
  "SNOWBOUND": "shut in or prevented from travelling by snow [adj]\n",
  "SNOWBRUSH": "a brush for clearing snow [n -ES]\n",
  "SNOWBRUSHES": "SNOWBRUSH, a brush for clearing snow [n]\n",
  "SNOWBUSH": "any of several white-flowered ornamental North American shrubs [n -ES]\n",
  "SNOWBUSHES": "SNOWBUSH, any of several white-flowered ornamental North American shrubs [n]\n",
  "SNOWCAP": "a very small humming bird native of New Grenada [n -S]\n",
  "SNOWCAPPED": "covered with snow [adj]\n",
  "SNOWCAPS": "SNOWCAP, a very small humming bird native of New Grenada [n]\n",
  "SNOWCAT": "a tracklaying vehicle for travel on snow [n -S]\n",
  "SNOWCATS": "SNOWCAT, a tracklaying vehicle for travel on snow [n]\n",
  "SNOWCLONE": "a kind of cliche in which an existing cliche or pop culture catchphrases is turned into a modern analogy [n -S]\n",
  "SNOWCLONES": "SNOWCLONE, a kind of cliche in which an existing cliche or pop culture catchphrases is turned into a modern analogy [n]\n",
  "SNOWCOACH": "a bus-like vehicle with large tyres or tracks for travelling on snow, also SNOCOACH [n -ES]\n",
  "SNOWCOACHES": "SNOWCOACH, a bus-like vehicle with large tyres or tracks for travelling on snow, also SNOCOACH [n]\n",
  "SNOWDOME": "a leisure centre offering snow and ice facilities [n -S]\n",
  "SNOWDOMES": "SNOWDOME, a leisure centre offering snow and ice facilities [n]\n",
  "SNOWDRIFT": "a drift of snow [n -S]\n",
  "SNOWDRIFTS": "SNOWDRIFT, a drift of snow [n]\n",
  "SNOWDROP": "a drooping white flower of early spring [n -S]\n",
  "SNOWDROPS": "SNOWDROP, a drooping white flower of early spring [n]\n",
  "SNOWED": "SNOW, to rain white frozen crystals, also SNAW [v]\n",
  "SNOWFALL": "a fall of snow [n -S]\n",
  "SNOWFALLS": "SNOWFALL, a fall of snow [n]\n",
  "SNOWFIELD": "an area of snow [n -S]\n",
  "SNOWFIELDS": "SNOWFIELD, an area of snow [n]\n",
  "SNOWFLAKE": "a flake of snow [n -S]\n",
  "SNOWFLAKES": "SNOWFLAKE, a flake of snow [n]\n",
  "SNOWFLEA": "a wingless insect appearing on snow in the spring [n -S]\n",
  "SNOWFLEAS": "SNOWFLEA, a wingless insect appearing on snow in the spring [n]\n",
  "SNOWFLECK": "the snow bunting, also SNOWFLICK [n -S]\n",
  "SNOWFLECKS": "SNOWFLECK, the snow bunting, also SNOWFLICK [n]\n",
  "SNOWFLICK": "the snow bunting, also SNOWFLECK [n -S]\n",
  "SNOWFLICKS": "SNOWFLICK, the snow bunting, also SNOWFLECK [n]\n",
  "SNOWGLOBE": "a transparent sphere usually made of glass enclosing a miniaturized scene of some sort, often together with a model of a landscape [n -S]\n",
  "SNOWGLOBES": "SNOWGLOBE, a transparent sphere usually made of glass enclosing a miniaturized scene of some sort, often together with a model of a landscape [n]\n",
  "SNOWIER": "SNOWY, full of snow [adj]\n",
  "SNOWIEST": "SNOWY, full of snow [adj]\n",
  "SNOWILY": "SNOWY, full of snow [adv]\n",
  "SNOWINESS": "the state of being snowy [n -ES]\n",
  "SNOWINESSES": "SNOWINESS, the state of being snowy [n]\n",
  "SNOWING": "SNOW, to rain white frozen crystals, also SNAW [v]\n",
  "SNOWISH": "somewhat snowy [adj]\n",
  "SNOWK": "(Scots) to snuff or smell about, also SNOKE, SNOOK [v -ED, -ING, -S]\n",
  "SNOWKED": "SNOWK, (Scots) to snuff or smell about, also SNOKE, SNOOK [v]\n",
  "SNOWKING": "SNOWK, (Scots) to snuff or smell about, also SNOKE, SNOOK [v]\n",
  "SNOWKS": "SNOWK, (Scots) to snuff or smell about, also SNOKE, SNOOK [v]\n",
  "SNOWLAND": "an area marked by a great amount of snow [n -S]\n",
  "SNOWLANDS": "SNOWLAND, an area marked by a great amount of snow [n]\n",
  "SNOWLESS": "without snow [adj]\n",
  "SNOWLIKE": "having the appearance of snow [adj]\n",
  "SNOWLINE": "an area which defines permanent snow [n -S]\n",
  "SNOWLINES": "SNOWLINE, an area which defines permanent snow [n]\n",
  "SNOWMAKER": "a machine for producing artificial snow [n -S]\n",
  "SNOWMAKERS": "SNOWMAKER, a machine for producing artificial snow [n]\n",
  "SNOWMAKING": "of a machine, used for the production of artificial snow for ski slopes [adj]\n",
  "SNOWMAN": "a figure made of snow [n SNOWMEN]\n",
  "SNOWMELT": "water produced by the melting of snow [n -S]\n",
  "SNOWMELTS": "SNOWMELT, water produced by the melting of snow [n]\n",
  "SNOWMEN": "SNOWMAN, a figure made of snow [n]\n",
  "SNOWMOBILE": "to travel by any of various automotive vehicles for travel on snow [v SNOWMOBILED, SNOWMOBILING, SNOWMOBILES]\n",
  "SNOWMOBILED": "SNOWMOBILE, to travel by any of various automotive vehicles for travel on snow [v]\n",
  "SNOWMOBILER": "one who travels by snowmobile [n -S]\n",
  "SNOWMOBILERS": "SNOWMOBILER, one who travels by snowmobile [n]\n",
  "SNOWMOBILES": "SNOWMOBILE, to travel by any of various automotive vehicles for travel on snow [v]\n",
  "SNOWMOBILING": "the sport of using a snowmobile [n -S]\n",
  "SNOWMOBILINGS": "SNOWMOBILING, the sport of using a snowmobile [n]\n",
  "SNOWMOBILIST": "one who engages in the sport of snowmobiling [n -S]\n",
  "SNOWMOBILISTS": "SNOWMOBILIST, one who engages in the sport of snowmobiling [n]\n",
  "SNOWMOLD": "a fungus disease of grasses near the edge of melting snow, also SNOWMOULD [n -S]\n",
  "SNOWMOLDS": "SNOWMOLD, a fungus disease of grasses near the edge of melting snow, also SNOWMOULD [n]\n",
  "SNOWMOULD": "a fungus disease of grasses near the edge of melting snow, also SNOWMOLD [n -S]\n",
  "SNOWMOULDS": "SNOWMOULD, a fungus disease of grasses near the edge of melting snow, also SNOWMOLD [n]\n",
  "SNOWPACK": "an accumulation of packed snow [n -S]\n",
  "SNOWPACKS": "SNOWPACK, an accumulation of packed snow [n]\n",
  "SNOWPLOUGH": "an implement operating like a plow, but on a larger scale, for clearing away the snow from roads, railways, etc. [n -S] / to clear with a snowplough, also SNOWPLOW [v -ED, -ING, -S]\n",
  "SNOWPLOUGHED": "SNOWPLOUGH, to clear with a snowplough, also SNOWPLOW [v]\n",
  "SNOWPLOUGHING": "SNOWPLOUGH, to clear with a snowplough, also SNOWPLOW [v]\n",
  "SNOWPLOUGHS": "SNOWPLOUGH, an implement operating like a plow, but on a larger scale, for clearing away the snow from roads, railways, etc. [n]\n",
  "SNOWPLOW": "to execute a type of skiing maneuver [v -ED, -ING, -S]\n",
  "SNOWPLOWED": "SNOWPLOW, to execute a type of skiing maneuver [v]\n",
  "SNOWPLOWING": "SNOWPLOW, to execute a type of skiing maneuver [v]\n",
  "SNOWPLOWS": "SNOWPLOW, to execute a type of skiing maneuver [v]\n",
  "SNOWS": "SNOW, to rain white frozen crystals, also SNAW [v]\n",
  "SNOWSCAPE": "a landscape under snow [n -S]\n",
  "SNOWSCAPES": "SNOWSCAPE, a landscape under snow [n]\n",
  "SNOWSHED": "a structure which provides protection from snow [n -S]\n",
  "SNOWSHEDS": "SNOWSHED, a structure which provides protection from snow [n]\n",
  "SNOWSHOE": "to walk on oval frames on deep snow [v SNOWSHOED, SNOWSHOEING, SNOWSHOES]\n",
  "SNOWSHOED": "SNOWSHOE, to walk on oval frames on deep snow [v]\n",
  "SNOWSHOEING": "travel by snowshoe [n -S]\n",
  "SNOWSHOEINGS": "SNOWSHOEING, travel by snowshoe [n]\n",
  "SNOWSHOER": "one who travels by snowshoe [n -S]\n",
  "SNOWSHOERS": "SNOWSHOER, one who travels by snowshoe [n]\n",
  "SNOWSHOES": "SNOWSHOE, to walk on oval frames on deep snow [v]\n",
  "SNOWSLIDE": "a slide of snow, an avalanche [n -S]\n",
  "SNOWSLIDES": "SNOWSLIDE, a slide of snow, an avalanche [n]\n",
  "SNOWSLIP": "a large mass or avalanche of snow which slips down the side of a mountain, etc. [n -S]\n",
  "SNOWSLIPS": "SNOWSLIP, a large mass or avalanche of snow which slips down the side of a mountain, etc. [n]\n",
  "SNOWSNAKE": "an Indian game in which a straight wooden rod having a weighted head like that of a snake is slid over a smooth field of snow or down specially constructed runways [n -S]\n",
  "SNOWSNAKES": "SNOWSNAKE, an Indian game in which a straight wooden rod having a weighted head like that of a snake is slid over a smooth field of snow or down specially constructed runways [n]\n",
  "SNOWSTORM": "a storm of snow [n -S]\n",
  "SNOWSTORMS": "SNOWSTORM, a storm of snow [n]\n",
  "SNOWSUIT": "a child's garment for winter wear [n -S]\n",
  "SNOWSUITS": "SNOWSUIT, a child's garment for winter wear [n]\n",
  "SNOWSURFING": "surfing on snow [n -S]\n",
  "SNOWSURFINGS": "SNOWSURFING, surfing on snow [n]\n",
  "SNOWTUBING": "a winter snow sport that involves sliding down a chute in the snow [n -S]\n",
  "SNOWTUBINGS": "SNOWTUBING, a winter snow sport that involves sliding down a chute in the snow [n]\n",
  "SNOWY": "full of snow [adj SNOWIER, SNOWIEST, SNOWILY]\n",
  "SNUB": "blunt, as of nose [adj SNUBBER, SNUBBEST] / a check, a rebuke, also SNEB, SNEBBE, SNUBBE / to treat with contempt or neglect [v SNUBBED, SNUBBING, SNUBS]\n",
  "SNUBBE": "(archaic) a snub [n -S]\n",
  "SNUBBED": "SNUB, to treat with contempt or neglect [v]\n",
  "SNUBBER": "a device for stopping a rope; a shock absorber [n -S]\n",
  "SNUBBERS": "SNUBBER, a device for stopping a rope; a shock absorber [n]\n",
  "SNUBBES": "SNUBBE, (archaic) a snub [n]\n",
  "SNUBBEST": "SNUB, blunt, as of nose [adj]\n",
  "SNUBBIER": "SNUBBY, inclined to snub or check [adj]\n",
  "SNUBBIEST": "SNUBBY, inclined to snub or check [adj]\n",
  "SNUBBINESS": "the quality of being snubby, inclined to snub or check [n -ES]\n",
  "SNUBBINESSES": "SNUBBINESS, the quality of being snubby, inclined to snub or check [n]\n",
  "SNUBBING": "the act of snubbing [n -S]\n",
  "SNUBBINGLY": "SNUBBING [adv]\n",
  "SNUBBINGS": "SNUBBING, the act of snubbing [n]\n",
  "SNUBBISH": "inclined to snub [adj]\n",
  "SNUBBY": "inclined to snub or check [adj SNUBBIER, SNUBBIEST]\n",
  "SNUBFIN": "as in snubfin dolphin, a species of dolphin with a small stubby dorsal fin [adj]\n",
  "SNUBNESS": "the quality of being snub [n -ES]\n",
  "SNUBNESSES": "SNUBNESS, the quality of being snub [n]\n",
  "SNUBS": "SNUB, to treat with contempt or neglect [v]\n",
  "SNUCK": "SNEAK, to move stealthily [v]\n",
  "SNUDGE": "to be snug and quiet [v SNUDGED, SNUDGING, SNUDGES]\n",
  "SNUDGED": "SNUDGE, to be snug and quiet [v]\n",
  "SNUDGES": "SNUDGE, to be snug and quiet [v]\n",
  "SNUDGING": "SNUDGE, to be snug and quiet [v]\n",
  "SNUFF": "to put a candle out [v -ED, -ING, -S]\n",
  "SNUFFBOX": "a box for holding snuff [n -ES]\n",
  "SNUFFBOXES": "SNUFFBOX, a box for holding snuff [n]\n",
  "SNUFFED": "SNUFF, to put a candle out [v]\n",
  "SNUFFER": "an instrument for extinguishing candles [n -S]\n",
  "SNUFFERS": "SNUFFER, an instrument for extinguishing candles [n]\n",
  "SNUFFIER": "SNUFFY, soiled with snuff [adj]\n",
  "SNUFFIEST": "SNUFFY, soiled with snuff [adj]\n",
  "SNUFFILY": "SNUFFY, soiled with snuff [adv]\n",
  "SNUFFINESS": "the quality of being snuffy, soiled with snuff [n -ES]\n",
  "SNUFFINESSES": "SNUFFINESS, the quality of being snuffy, soiled with snuff [n]\n",
  "SNUFFING": "the act of snuffing [n -S]\n",
  "SNUFFINGS": "SNUFFING, the act of snuffing [n]\n",
  "SNUFFLE": "to sniffle [v SNUFFLED, SNUFFLING, SNUFFLES]\n",
  "SNUFFLED": "SNUFFLE, to sniffle [v]\n",
  "SNUFFLER": "a person who snuffles [n -S]\n",
  "SNUFFLERS": "SNUFFLER, a person who snuffles [n]\n",
  "SNUFFLES": "SNUFFLE, to sniffle [v]\n",
  "SNUFFLIER": "SNUFFLY, tending to snuffle [adj]\n",
  "SNUFFLIEST": "SNUFFLY, tending to snuffle [adj]\n",
  "SNUFFLING": "the act of snuffling [n -S]\n",
  "SNUFFLINGS": "SNUFFLING, the act of snuffling [n]\n",
  "SNUFFLY": "tending to snuffle [adj SNUFFLIER, SNUFFLIEST]\n",
  "SNUFFS": "SNUFF, to put a candle out [v]\n",
  "SNUFFY": "soiled with snuff [adj SNUFFIER, SNUFFIEST, SNUFFILY]\n",
  "SNUG": "cosy [adj SNUGGER, SNUGGEST, SNUGLY] / to lie close [v SNUGGED, SNUGGING, SNUGS]\n",
  "SNUGGED": "SNUG, to lie close [v]\n",
  "SNUGGER": "SNUG, cosy [adj]\n",
  "SNUGGERIE": "a snug cozy place; esp. a small room in a pub, also SNUGGERY [n -S]\n",
  "SNUGGERIES": "SNUGGERY, a snug place e.g. in a pub, also SNUGGERIE [n]\n",
  "SNUGGERY": "a snug place e.g. in a pub, also SNUGGERIE [n SNUGGERIES]\n",
  "SNUGGEST": "SNUG, cosy [adj]\n",
  "SNUGGIES": "women's long underwear [n]\n",
  "SNUGGING": "SNUG, to lie close [v]\n",
  "SNUGGLE": "to press closely together [v SNUGGLED, SNUGGLING, SNUGGLES]\n",
  "SNUGGLED": "SNUGGLE, to press closely together [v]\n",
  "SNUGGLES": "SNUGGLE, to press closely together [v]\n",
  "SNUGGLIER": "SNUGGLY, warm and cosy [adj]\n",
  "SNUGGLIEST": "SNUGGLY, warm and cosy [adj]\n",
  "SNUGGLING": "SNUGGLE, to press closely together [v]\n",
  "SNUGGLY": "warm and cosy [adj SNUGGLIER, SNUGGLIEST]\n",
  "SNUGLY": "SNUG, cosy [adv]\n",
  "SNUGNESS": "the state of being snug [n -ES]\n",
  "SNUGNESSES": "SNUGNESS, the state of being snug [n]\n",
  "SNUGS": "SNUG, to lie close [v]\n",
  "SNUSH": "(obsolete) to snuff [v -ED, -ING, -ES]\n",
  "SNUSHED": "SNUSH, (obsolete) to snuff [v]\n",
  "SNUSHES": "SNUSH, (obsolete) to snuff [v]\n",
  "SNUSHING": "SNUSH, (obsolete) to snuff [v]\n",
  "SNUZZLE": "to caress with the nose [v SNUZZLED, SNUZZLING, SNUZZLES]\n",
  "SNUZZLED": "SNUZZLE, to caress with the nose [v]\n",
  "SNUZZLES": "SNUZZLE, to caress with the nose [v]\n",
  "SNUZZLING": "SNUZZLE, to caress with the nose [v]\n",
  "SNY": "(Canadian) a side channel of a river, also SNYE [n SNIES]\n",
  "SNYE": "(Canadian) a side channel of a river, also SNY [n -S]\n",
  "SNYES": "SNYE, (Canadian) a side channel of a river, also SNY [n]\n",
  "SO": "the fifth tone of the scale, also SOH, SOL [n -S]\n",
  "SOAK": "to saturate in liquid [v SOAKED, SOAKEN, SOAKING, SOAKS]\n",
  "SOAKAGE": "the act of soaking [n -S]\n",
  "SOAKAGES": "SOAKAGE, the act of soaking [n]\n",
  "SOAKAWAY": "a depression into which water percolates [n -S]\n",
  "SOAKAWAYS": "SOAKAWAY, a depression into which water percolates [n]\n",
  "SOAKED": "SOAK, to saturate in liquid [v]\n",
  "SOAKEN": "SOAK, to saturate in liquid [v]\n",
  "SOAKER": "a small piece of lead used to form a watertight joint with a chimney where it projects from a roof [n -S]\n",
  "SOAKERS": "SOAKER, a small piece of lead used to form a watertight joint with a chimney where it projects from a roof [n]\n",
  "SOAKING": "very wet [adj SOAKINGLY] / the act of soaking [n -S]\n",
  "SOAKINGLY": "SOAKING, very wet [adv]\n",
  "SOAKINGS": "SOAKING, the act of soaking [n]\n",
  "SOAKS": "SOAK, to saturate in liquid [v]\n",
  "SOAP": "to treat with a cleansing agent [v -ED, -ING, -S]\n",
  "SOAPBARK": "a South American tree, the bark of which can be used as soap [n -S]\n",
  "SOAPBARKS": "SOAPBARK, a South American tree, the bark of which can be used as soap [n]\n",
  "SOAPBERRIES": "SOAPBERRY, any tree of the genus Sapindus, the fleshy part of whose fruit is used instead of soap in washing linen [n]\n",
  "SOAPBERRY": "any tree of the genus Sapindus, the fleshy part of whose fruit is used instead of soap in washing linen [n SOAPBERRIES]\n",
  "SOAPBOX": "a box for soap, a platform for opinions [n -ES] / to give an opinion to the public [v -ED, -ING, -ES]\n",
  "SOAPBOXED": "SOAPBOX, to give an opinion to the public [v]\n",
  "SOAPBOXES": "SOAPBOX, to give an opinion to the public [v]\n",
  "SOAPBOXING": "SOAPBOX, to give an opinion to the public [v]\n",
  "SOAPDISH": "a dish for holding soap [n -ES]\n",
  "SOAPDISHES": "SOAPDISH, a dish for holding soap [n]\n",
  "SOAPED": "SOAP, to treat with a cleansing agent [v]\n",
  "SOAPER": "a serial melodrama on radio or television, also SOAPIE [n -S]\n",
  "SOAPERS": "SOAPER, a serial melodrama on radio or television, also SOAPIE [n]\n",
  "SOAPFISH": "a tropical fish that produces toxic mucus [n -ES]\n",
  "SOAPFISHES": "SOAPFISH, a tropical fish that produces toxic mucus [n]\n",
  "SOAPFLAKES": "small particles of solid soap or detergent used for washing clothes [n]\n",
  "SOAPIE": "(Australian slang) a serial melodrama on radio or television, also SOAPER [n -S]\n",
  "SOAPIER": "SOAPY, like soap [adj]\n",
  "SOAPIES": "SOAPIE, (Australian slang) a serial melodrama on radio or television, also SOAPER [n]\n",
  "SOAPIEST": "SOAPY, like soap [adj]\n",
  "SOAPILY": "SOAPY, like soap [adv]\n",
  "SOAPINESS": "the state of being soapy [n -ES]\n",
  "SOAPINESSES": "SOAPINESS, the state of being soapy [n]\n",
  "SOAPING": "SOAP, to treat with a cleansing agent [v]\n",
  "SOAPLAND": "(slang) a red-light district [n -S]\n",
  "SOAPLANDS": "SOAPLAND, (slang) a red-light district [n]\n",
  "SOAPLESS": "without soap [adj]\n",
  "SOAPLIKE": "like soap [adj]\n",
  "SOAPOLALLIE": "a drink made by crushing soapberries [n -S]\n",
  "SOAPOLALLIES": "SOAPOLALLIE, a drink made by crushing soapberries [n]\n",
  "SOAPROOT": "any plant whose root can be used for soap [n -S]\n",
  "SOAPROOTS": "SOAPROOT, any plant whose root can be used for soap [n]\n",
  "SOAPS": "SOAP, to treat with a cleansing agent [v]\n",
  "SOAPSTONE": "a soft soapy rock [n -S]\n",
  "SOAPSTONES": "SOAPSTONE, a soft soapy rock [n]\n",
  "SOAPSUDS": "soapy water [n]\n",
  "SOAPSUDSIER": "SOAPSUDSY, like soapsuds [adj]\n",
  "SOAPSUDSIEST": "SOAPSUDSY, like soapsuds [adj]\n",
  "SOAPSUDSY": "like soapsuds [adj SOAPSUDSIER, SOAPSUDSIEST]\n",
  "SOAPWORT": "a tall herb of the pink family, whose roots and leaves contain saponin [n -S]\n",
  "SOAPWORTS": "SOAPWORT, a tall herb of the pink family, whose roots and leaves contain saponin [n]\n",
  "SOAPY": "like soap [adj SOAPIER, SOAPIEST, SOAPILY]\n",
  "SOAR": "to fly at a great height [v -ED, -ING, -S]\n",
  "SOARAWAY": "making spectacular progress [adj]\n",
  "SOARE": "(obsolete) a young hawk [n -S]\n",
  "SOARED": "SOAR, to fly at a great height [v]\n",
  "SOARER": "a person who or thing which soars; specifically an aircraft designed for soaring, a glider [n -S]\n",
  "SOARERS": "SOARER, a person who or thing which soars; specifically an aircraft designed for soaring, a glider [n]\n",
  "SOARES": "SOARE, (obsolete) a young hawk [n]\n",
  "SOARING": "flying high [adj SOARINGLY] / the act of soaring [n -S]\n",
  "SOARINGLY": "SOARING, flying high [adv]\n",
  "SOARINGS": "SOARING, the act of soaring [n]\n",
  "SOARS": "SOAR, to fly at a great height [v]\n",
  "SOAVE": "(Italian) an Italian white wine [n -S]\n",
  "SOAVES": "SOAVE, (Italian) an Italian white wine [n]\n",
  "SOB": "to cry with a convulsive catching of the breath [v SOBBED, SOBBING, SOBS]\n",
  "SOBA": "(Japanese) noodles made from buckwheat [n -S]\n",
  "SOBAS": "SOBA, (Japanese) noodles made from buckwheat [n]\n",
  "SOBBED": "SOB, to cry with a convulsive catching of the breath [v]\n",
  "SOBBER": "one who sobs [n -S]\n",
  "SOBBERS": "SOBBER, one who sobs [n]\n",
  "SOBBING": "making a sobbing noise [adj SOBBINGLY] / the act of sobbing [n -S]\n",
  "SOBBINGLY": "SOBBING, making a sobbing noise [adv]\n",
  "SOBBINGS": "SOBBING, the act of sobbing [n]\n",
  "SOBEIT": "provided that [conj]\n",
  "SOBER": "having control of one's faculties [adj SOBERER, SOBEREST, SOBERLY] / to make sober [v -ED, -ING, -S]\n",
  "SOBERED": "SOBER, to make sober [v]\n",
  "SOBERER": "SOBER, having control of one's faculties [adj]\n",
  "SOBEREST": "SOBER, having control of one's faculties [adj]\n",
  "SOBERING": "SOBER, to make sober [v]\n",
  "SOBERINGLY": "SOBERING, SOBER, to make sober [adv]\n",
  "SOBERISE": "to make sober, also SOBERIZE [v SOBERISED, SOBERISING, SOBERISES]\n",
  "SOBERISED": "SOBERISE, to make sober, also SOBERIZE [v]\n",
  "SOBERISES": "SOBERISE, to make sober, also SOBERIZE [v]\n",
  "SOBERISING": "SOBERISE, to make sober, also SOBERIZE [v]\n",
  "SOBERIZE": "to make sober, also SOBERISE [v SOBERIZED, SOBERIZING, SOBERIZES]\n",
  "SOBERIZED": "SOBERIZE, to make sober, also SOBERISE [v]\n",
  "SOBERIZES": "SOBERIZE, to make sober, also SOBERISE [v]\n",
  "SOBERIZING": "SOBERIZE, to make sober, also SOBERISE [v]\n",
  "SOBERLY": "SOBER, having control of one's faculties [adv]\n",
  "SOBERNESS": "sobriety [n -ES]\n",
  "SOBERNESSES": "SOBERNESS, sobriety [n]\n",
  "SOBERS": "SOBER, to make sober [v]\n",
  "SOBERSIDED": "devoid of extreme qualities such as exaggeration; sober [adj]\n",
  "SOBERSIDEDNESS": "the state of being sobersided [n]\n",
  "SOBERSIDES": "a sober, dull person [n SOBERSIDES]\n",
  "SOBFUL": "given to sobbing [adj]\n",
  "SOBOLE": "(Latin) a creeping underground stem [n -S]\n",
  "SOBOLES": "SOBOLE, (Latin) a creeping underground stem [n]\n",
  "SOBOLIFEROUS": "bearing shoots or suckers [adj]\n",
  "SOBRIETIES": "SOBRIETY, the state of being sober [n]\n",
  "SOBRIETY": "the state of being sober [n SOBRIETIES]\n",
  "SOBRIQUET": "(French) a nickname, also SOUBRIQUET [n -S]\n",
  "SOBRIQUETS": "SOBRIQUET, (French) a nickname, also SOUBRIQUET [n]\n",
  "SOBS": "SOB, to cry with a convulsive catching of the breath [v]\n",
  "SOC": "the right of holding a local court [n -S]\n",
  "SOCA": "a variety of Caribbean calypso music, also SOKAH [n -S]\n",
  "SOCAGE": "a form of feudal land tenure, also SOCCAGE [n -S]\n",
  "SOCAGER": "a tenant by socage, also SOCKMAN, SOCMAN, SOKEMAN [n -S]\n",
  "SOCAGERS": "SOCAGER, a tenant by socage, also SOCKMAN, SOCMAN, SOKEMAN [n]\n",
  "SOCAGES": "SOCAGE, a form of feudal land tenure, also SOCCAGE [n]\n",
  "SOCAS": "SOCA, a variety of Caribbean calypso music, also SOKAH [n]\n",
  "SOCCAGE": "a form of feudal land tenure, also SOCAGE [n -S]\n",
  "SOCCAGES": "SOCCAGE, a form of feudal land tenure, also SOCAGE [n]\n",
  "SOCCER": "a type of ball game [n -S]\n",
  "SOCCERS": "SOCCER, a type of ball game [n]\n",
  "SOCDOLAGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOCDOLAGERS": "SOCDOLAGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOCDOLIGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOCDOLIGERS": "SOCDOLIGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOCDOLOGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLIGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOCDOLOGERS": "SOCDOLOGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLIGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOCES": "SOC, the right of holding a local court [n]\n",
  "SOCIABILITIES": "SOCIABILITY, the state of being sociable [n]\n",
  "SOCIABILITY": "the state of being sociable [n SOCIABILITIES]\n",
  "SOCIABLE": "gregarious [adj SOCIABLY] / a four-wheeled open carriage with side-seats [n -S]\n",
  "SOCIABLENESS": "the state of being sociable [n -ES]\n",
  "SOCIABLENESSES": "SOCIABLENESS, the state of being sociable [n]\n",
  "SOCIABLES": "SOCIABLE, a four-wheeled open carriage with side-seats [n]\n",
  "SOCIABLY": "SOCIABLE, gregarious [adv]\n",
  "SOCIAL": "related to society [adj SOCIALLY] / a social event [n -S]\n",
  "SOCIALISABLE": "that can be socialised, also SOCIALIZABLE [adj]\n",
  "SOCIALISATION": "the act of socialising, also SOCIALIZATION [n -S]\n",
  "SOCIALISATIONS": "SOCIALISATION, the act of socialising, also SOCIALIZATION [n]\n",
  "SOCIALISE": "to make social, also SOCIALIZE [v SOCIALISED, SOCIALISING, SOCIALISES]\n",
  "SOCIALISED": "SOCIALISE, to make social, also SOCIALIZE [v]\n",
  "SOCIALISER": "one who socialises, also SOCIALIZER [n -S]\n",
  "SOCIALISERS": "SOCIALISER, one who socialises, also SOCIALIZER [n]\n",
  "SOCIALISES": "SOCIALISE, to make social, also SOCIALIZE [v]\n",
  "SOCIALISING": "the act of being sociable [n -S]\n",
  "SOCIALISINGS": "SOCIALISING, the act of being sociable [n]\n",
  "SOCIALISM": "the theory, principle, or scheme of social organization which places the means of production of wealth and the distribution of that wealth in the hands of the community [n -S]\n",
  "SOCIALISMS": "SOCIALISM, the theory, principle, or scheme of social organization which places the means of production of wealth and the distribution of that wealth in the hands of the community [n]\n",
  "SOCIALIST": "an adherent of socialism [n -S]\n",
  "SOCIALISTIC": "related to socialism [adj SOCIALISTICALLY]\n",
  "SOCIALISTICALLY": "SOCIALISTIC, related to socialism [adv]\n",
  "SOCIALISTS": "SOCIALIST, an adherent of socialism [n]\n",
  "SOCIALITE": "a person having a place in fashionable society [n -S]\n",
  "SOCIALITES": "SOCIALITE, a person having a place in fashionable society [n]\n",
  "SOCIALITIES": "SOCIALITY, the quality of being social [n]\n",
  "SOCIALITY": "the quality of being social [n SOCIALITIES]\n",
  "SOCIALIZABLE": "that can be socialized, also SOCIALISABLE [adj]\n",
  "SOCIALIZATION": "the act of socializing, also SOCIALISATION [n -S]\n",
  "SOCIALIZATIONS": "SOCIALIZATION, the act of socializing, also SOCIALISATION [n]\n",
  "SOCIALIZE": "to make social, also SOCIALISE [v SOCIALIZED, SOCIALIZING, SOCIALIZES]\n",
  "SOCIALIZED": "SOCIALIZE, to make social, also SOCIALISE [v]\n",
  "SOCIALIZER": "one who socializes, also SOCIALISER [n -S]\n",
  "SOCIALIZERS": "SOCIALIZER, one who socializes, also SOCIALISER [n]\n",
  "SOCIALIZES": "SOCIALIZE, to make social, also SOCIALISE [v]\n",
  "SOCIALIZING": "the act of being sociable [n -S]\n",
  "SOCIALIZINGS": "SOCIALIZING, the act of being sociable [n]\n",
  "SOCIALLY": "with respect to society [adv]\n",
  "SOCIALNESS": "the state of being social [n -ES]\n",
  "SOCIALNESSES": "SOCIALNESS, the state of being social [n]\n",
  "SOCIALS": "SOCIAL, a social event [n]\n",
  "SOCIATE": "(archaic) an associate [n -S]\n",
  "SOCIATES": "SOCIATE, (archaic) an associate [n]\n",
  "SOCIATION": "a plant community; the smallest area in which a full range of plants making up such a plant community may be found [n -S]\n",
  "SOCIATIONS": "SOCIATION, a plant community; the smallest area in which a full range of plants making up such a plant community may be found [n]\n",
  "SOCIATIVE": "expressing association [adj]\n",
  "SOCIETAL": "relating to society [adj SOCIETALLY]\n",
  "SOCIETALLY": "SOCIETAL, relating to society [adv]\n",
  "SOCIETIES": "SOCIETY, an organized group, a fellowship, also SODALITY [n]\n",
  "SOCIETY": "an organized group, a fellowship, also SODALITY [n SOCIETIES]\n",
  "SOCIOBIOLOGICAL": "relating to sociobiology [adj]\n",
  "SOCIOBIOLOGIES": "SOCIOBIOLOGY, the study of the biological basis of human behaviour [n]\n",
  "SOCIOBIOLOGIST": "one who studies sociobiology [n -S]\n",
  "SOCIOBIOLOGISTS": "SOCIOBIOLOGIST, one who studies sociobiology [n]\n",
  "SOCIOBIOLOGY": "the study of the biological basis of human behaviour [n SOCIOBIOLOGIES]\n",
  "SOCIOCULTURAL": "of, relating to, or involving a combination of social and cultural factors [adj SOCIOCULTURALLY]\n",
  "SOCIOCULTURALLY": "SOCIOCULTURAL, of, relating to, or involving a combination of social and cultural factors [adv]\n",
  "SOCIOECONOMIC": "of, relating to, or involving a combination of social and economic factors [adj]\n",
  "SOCIOGRAM": "a diagram of social relationships within a group [n -S]\n",
  "SOCIOGRAMS": "SOCIOGRAM, a diagram of social relationships within a group [n]\n",
  "SOCIOHISTORICAL": "of, relating to, or involving social history or a combination of social and historical factors [adj]\n",
  "SOCIOLECT": "a variety of languages used by members of a particular social class or group [n -S]\n",
  "SOCIOLECTS": "SOCIOLECT, a variety of languages used by members of a particular social class or group [n]\n",
  "SOCIOLINGUIST": "one who studies sociolinguistics [n -S]\n",
  "SOCIOLINGUISTIC": "of or relating to the social aspects of language [adj]\n",
  "SOCIOLINGUISTS": "SOCIOLINGUIST, one who studies sociolinguistics [n]\n",
  "SOCIOLOGESE": "sociological jargon [n -S]\n",
  "SOCIOLOGESES": "SOCIOLOGESE, sociological jargon [n]\n",
  "SOCIOLOGIC": "of or relating to sociology, also SOCIOLOGICAL [adj SOCIOLOGICALLY]\n",
  "SOCIOLOGICAL": "of or relating to sociology, also SOCIOLOGIC [adj SOCIOLOGICALLY]\n",
  "SOCIOLOGICALLY": "SOCIOLOGICAL, of or relating to sociology, also SOCIOLOGIC [adv]\n",
  "SOCIOLOGIES": "SOCIOLOGY, the study of society [n]\n",
  "SOCIOLOGISM": "interpretation emphasizing social factors [n -S]\n",
  "SOCIOLOGISMS": "SOCIOLOGISM, interpretation emphasizing social factors [n]\n",
  "SOCIOLOGIST": "a student of sociology [n -S]\n",
  "SOCIOLOGISTIC": "relating to sociology [adj]\n",
  "SOCIOLOGISTS": "SOCIOLOGIST, a student of sociology [n]\n",
  "SOCIOLOGY": "the study of society [n SOCIOLOGIES]\n",
  "SOCIOMETRIC": "relating to sociometry [adj]\n",
  "SOCIOMETRIES": "SOCIOMETRY, the study of sociological relationships and attitudes, esp. as expressed by preferences [n]\n",
  "SOCIOMETRIST": "one who practises sociometry [n -S]\n",
  "SOCIOMETRISTS": "SOCIOMETRIST, one who practises sociometry [n]\n",
  "SOCIOMETRY": "the study of sociological relationships and attitudes, esp. as expressed by preferences [n SOCIOMETRIES]\n",
  "SOCIOPATH": "a person hostile to society [n -S]\n",
  "SOCIOPATHIC": "of, relating to, or characterized by asocial or antisocial behavior or exhibiting antisocial personality disorder [adj]\n",
  "SOCIOPATHIES": "SOCIOPATHY, hostility to society [n]\n",
  "SOCIOPATHS": "SOCIOPATH, a person hostile to society [n]\n",
  "SOCIOPATHY": "hostility to society [n SOCIOPATHIES]\n",
  "SOCIOPOLITICAL": "of, relating to, or involving a combination of social and political factors [adj]\n",
  "SOCIORELIGIOUS": "involving a combination of social and religious factors [adj]\n",
  "SOCIOSEXUAL": "of or relating to the interpersonal aspects of sexuality [adj]\n",
  "SOCK": "to strike forcefully [v -ED, -ING, -S] / a covering for the foot [n SOCKS or SOX]\n",
  "SOCKDOLAGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOCKDOLAGERS": "SOCKDOLAGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOCKDOLIGER": "a conclusive argument; a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOCKDOLIGERS": "SOCKDOLIGER, a conclusive argument; a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOCKDOLOGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOCKDOLOGERS": "SOCKDOLOGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOGDOLAGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOCKED": "SOCK, to strike forcefully [v]\n",
  "SOCKET": "to provide with an opening for an appliance [v -ED, -ING, -S]\n",
  "SOCKETED": "SOCKET, to provide with an opening for an appliance [v]\n",
  "SOCKETING": "SOCKET, to provide with an opening for an appliance [v]\n",
  "SOCKETS": "SOCKET, to provide with an opening for an appliance [v]\n",
  "SOCKETTE": "a foot covering [n -S]\n",
  "SOCKETTES": "SOCKETTE, a foot covering [n]\n",
  "SOCKEYE": "a Pacific salmon [n -S]\n",
  "SOCKEYES": "SOCKEYE, a Pacific salmon [n]\n",
  "SOCKING": "SOCK, to strike forcefully [v]\n",
  "SOCKLESS": "without socks [adj]\n",
  "SOCKMAN": "a tenant by socage, also SOCAGER, SOCMAN, SOKEMAN [n SOCKMEN]\n",
  "SOCKMEN": "SOCKMAN, a tenant by socage, also SOCAGER, SOCMAN, SOKEMAN [n]\n",
  "SOCKO": "strikingly impressive [adj]\n",
  "SOCKS": "SOCK, to strike forcefully [v]\n",
  "SOCLE": "a plain face or plinth at the foot of a wall, column etc., also ZOCCO, ZOCCOLO [n -S]\n",
  "SOCLES": "SOCLE, a plain face or plinth at the foot of a wall, column etc., also ZOCCO, ZOCCOLO [n]\n",
  "SOCMAN": "a tenant by socage, also SOCAGER, SOCKMAN, SOKEMAN [n SOCMEN]\n",
  "SOCMEN": "SOCMAN, a tenant by socage, also SOCAGER, SOCKMAN, SOKEMAN [n]\n",
  "SOCS": "SOC, the right of holding a local court [n]\n",
  "SOD": "to cover with turf [v SODDED, SODDING, SODS]\n",
  "SODA": "any of a number of common sodium compounds [n -S]\n",
  "SODAIC": "relating to soda [adj]\n",
  "SODAIN": "(obsolete) sudden, also SODAINE [adj]\n",
  "SODAINE": "(obsolete) sudden, also SODAIN [adj]\n",
  "SODALESS": "without soda [adj]\n",
  "SODALIST": "a member of a sodality [n -S]\n",
  "SODALISTS": "SODALIST, a member of a sodality [n]\n",
  "SODALITE": "a transparent or translucent silicate of aluminium and sodium [n -S]\n",
  "SODALITES": "SODALITE, a transparent or translucent silicate of aluminium and sodium [n]\n",
  "SODALITIES": "SODALITY, an organized group, a fellowship [n]\n",
  "SODALITY": "an organized group, a fellowship [n SODALITIES]\n",
  "SODAMIDE": "a compound formed when ammonia gas is passed over hot sodium [n -S]\n",
  "SODAMIDES": "SODAMIDE, a compound formed when ammonia gas is passed over hot sodium [n]\n",
  "SODAS": "SODA, any of a number of common sodium compounds [n]\n",
  "SODBUSTER": "(US) a farmer who works the soil [n -S]\n",
  "SODBUSTERS": "SODBUSTER, (US) a farmer who works the soil [n]\n",
  "SODDED": "SOD, to cover with turf [v]\n",
  "SODDEN": "wet through [adj SODDENLY] / to make or become sodden [v -ED, -ING, -S]\n",
  "SODDENED": "SODDEN, to make or become sodden [v]\n",
  "SODDENING": "SODDEN, to make or become sodden [v]\n",
  "SODDENLY": "SODDEN, wet through [adv]\n",
  "SODDENNESS": "the state of being sodden [n -ES]\n",
  "SODDENNESSES": "SODDENNESS, the state of being sodden [n]\n",
  "SODDENS": "SODDEN, to make or become sodden [v]\n",
  "SODDIE": "a house built of sod, also SODDY [n SODDIES]\n",
  "SODDIER": "SODDY, consisting of sod; covered with sod [adj]\n",
  "SODDIES": "SODDY, a house built of sod, also SODDIE [n]\n",
  "SODDIEST": "SODDY, consisting of sod; covered with sod [adj]\n",
  "SODDING": "SOD, to cover with turf [v]\n",
  "SODDY": "consisting of sod; covered with sod [adj SODDIER, SODDIEST] / a house built of sod, also SODDIE [n SODDIES]\n",
  "SODGER": "(colloquial) a soldier, also SOGER [n -S] / to soldier [v -ED, -ING, -S]\n",
  "SODGERED": "SODGER, to soldier [v]\n",
  "SODGERING": "SODGER, to soldier [v]\n",
  "SODGERS": "SODGER, to soldier [v]\n",
  "SODIC": "of or pertaining to sodium [adj]\n",
  "SODICITIES": "SODICITY, the amount of sodium in soils [n]\n",
  "SODICITY": "the amount of sodium in soils [n SODICITIES]\n",
  "SODIUM": "a metallic element [n -S]\n",
  "SODIUMS": "SODIUM, a metallic element [n]\n",
  "SODOM": "a place notorious for vice and corruption [n -S]\n",
  "SODOMIES": "SODOMY, anal intercourse [n]\n",
  "SODOMISE": "to engage in sodomy with, also SODOMIZE [v SODOMISED, SODOMISING, SODOMISES]\n",
  "SODOMISED": "SODOMISE, to engage in sodomy with, also SODOMIZE [v]\n",
  "SODOMISES": "SODOMISE, to engage in sodomy with, also SODOMIZE [v]\n",
  "SODOMISING": "SODOMISE, to engage in sodomy with, also SODOMIZE [v]\n",
  "SODOMIST": "one who practices sodomy, also SODOMITE [n -S]\n",
  "SODOMISTS": "SODOMIST, one who practices sodomy, also SODOMITE [n]\n",
  "SODOMITE": "one who practices sodomy, also SODOMIST [n -S]\n",
  "SODOMITES": "SODOMITE, one who practices sodomy, also SODOMIST [n]\n",
  "SODOMITIC": "relating to sodomy, also SODOMITICAL [adj SODOMITICALLY]\n",
  "SODOMITICAL": "relating to sodomy, also SODOMITIC [adj SODOMITICALLY]\n",
  "SODOMITICALLY": "SODOMITICAL, relating to sodomy, also SODOMITIC [adv]\n",
  "SODOMIZE": "to engage in sodomy with, also SODOMISE [v SODOMIZED, SODOMIZING, SODOMIZES]\n",
  "SODOMIZED": "SODOMIZE, to engage in sodomy with, also SODOMISE [v]\n",
  "SODOMIZES": "SODOMIZE, to engage in sodomy with, also SODOMISE [v]\n",
  "SODOMIZING": "SODOMIZE, to engage in sodomy with, also SODOMISE [v]\n",
  "SODOMS": "SODOM, a place notorious for vice and corruption [n]\n",
  "SODOMY": "anal intercourse [n SODOMIES]\n",
  "SODS": "SOD, to cover with turf [v]\n",
  "SOEVER": "to an indefinite degree, in any way [adv]\n",
  "SOFA": "a long upholstered seat [n -S]\n",
  "SOFABED": "a sofa that can be made into a bed [n -S]\n",
  "SOFABEDS": "SOFABED, a sofa that can be made into a bed [n]\n",
  "SOFAR": "a system for locating underwater explosions [n -S]\n",
  "SOFARS": "SOFAR, a system for locating underwater explosions [n]\n",
  "SOFAS": "SOFA, a long upholstered seat [n]\n",
  "SOFFIONI": "(Italian) volcanic steam-holes [n]\n",
  "SOFFIT": "the underside of an architectural structure [n -S]\n",
  "SOFFITS": "SOFFIT, the underside of an architectural structure [n]\n",
  "SOFT": "not hard, also SAFT [adj SOFTER, SOFTEST, SOFTLY] / (Spenser) to soften [v -ED, -ING, -S]\n",
  "SOFTA": "(Turkish) a Muslim student or practitioner of sacred law and theology [n -S]\n",
  "SOFTAS": "SOFTA, (Turkish) a Muslim student or practitioner of sacred law and theology [n]\n",
  "SOFTBACK": "a book bound in a flexible paper cover [n -S]\n",
  "SOFTBACKS": "SOFTBACK, a book bound in a flexible paper cover [n]\n",
  "SOFTBALL": "an American game similar to baseball [n -S]\n",
  "SOFTBALLER": "one who plays softball [n -S]\n",
  "SOFTBALLERS": "SOFTBALLER, one who plays softball [n]\n",
  "SOFTBALLS": "SOFTBALL, an American game similar to baseball [n]\n",
  "SOFTBOUND": "bound in soft covers [adj] / a book bound in soft covers [n -S]\n",
  "SOFTBOUNDS": "SOFTBOUND, a book bound in soft covers [n]\n",
  "SOFTCORE": "of pornography, not explicit [adj]\n",
  "SOFTCOVER": "a paperback book [n -S]\n",
  "SOFTCOVERS": "SOFTCOVER, a paperback book [n]\n",
  "SOFTED": "SOFT, (Spenser) to soften [v]\n",
  "SOFTEN": "to make soft [v -ED, -ING, -S]\n",
  "SOFTENED": "SOFTEN, to make soft [v]\n",
  "SOFTENER": "one that softens [n -S]\n",
  "SOFTENERS": "SOFTENER, one that softens [n]\n",
  "SOFTENING": "the act of making soft [n -S]\n",
  "SOFTENINGS": "SOFTENING, the act of making soft [n]\n",
  "SOFTENS": "SOFTEN, to make soft [v]\n",
  "SOFTER": "SOFT, not hard, also SAFT [adj]\n",
  "SOFTEST": "SOFT, not hard, also SAFT [adj]\n",
  "SOFTGOODS": "clothing and soft furniture [n]\n",
  "SOFTHEAD": "a foolish person [n -S]\n",
  "SOFTHEADED": "having or indicative of a weak, unrealistic, or uncritical mind [adj SOFTHEADEDLY]\n",
  "SOFTHEADEDLY": "SOFTHEADED, having or indicative of a weak, unrealistic, or uncritical mind [adv]\n",
  "SOFTHEADEDNESS": "the state of being softheaded [n]\n",
  "SOFTHEADS": "SOFTHEAD, a foolish person [n]\n",
  "SOFTHEARTED": "emotionally responsive [adj SOFTHEARTEDLY]\n",
  "SOFTHEARTEDLY": "SOFTHEARTED, emotionally responsive [adv]\n",
  "SOFTHEARTEDNESS": "the state of being softhearted [n]\n",
  "SOFTIE": "a sentimental person, also SOFTY [n -S]\n",
  "SOFTIES": "SOFTY, a sentimental person, also SOFTIE [n]\n",
  "SOFTING": "SOFT, (Spenser) to soften [v]\n",
  "SOFTISH": "somewhat soft [adj]\n",
  "SOFTLING": "(archaic) a soft, effeminate person [n -S]\n",
  "SOFTLINGS": "SOFTLING, (archaic) a soft, effeminate person [n]\n",
  "SOFTLY": "SOFT, not hard, also SAFT [adv]\n",
  "SOFTNESS": "the state of being soft [n -ES]\n",
  "SOFTNESSES": "SOFTNESS, the state of being soft [n]\n",
  "SOFTPASTE": "as in softpaste porcelain, an artificial porcelain made from clay, bone ash, etc [adj]\n",
  "SOFTS": "SOFT, (Spenser) to soften [v]\n",
  "SOFTSCAPE": "vegetation (as shrubs and flowers) that is incorporated into a landscape [n -S]\n",
  "SOFTSCAPES": "SOFTSCAPE, vegetation (as shrubs and flowers) that is incorporated into a landscape [n]\n",
  "SOFTSHELL": "moderate in policy or principle [adj] / a moderate [n -S]\n",
  "SOFTSHELLS": "SOFTSHELL, a moderate [n]\n",
  "SOFTWARE": "data used in computer operations [n -S]\n",
  "SOFTWARES": "SOFTWARE, data used in computer operations [n]\n",
  "SOFTWOOD": "the soft wood of various trees [n -S]\n",
  "SOFTWOODS": "SOFTWOOD, the soft wood of various trees [n]\n",
  "SOFTY": "a sentimental person, also SOFTIE [n SOFTIES]\n",
  "SOG": "(dialect) to soak [v SOGGED, SOGGING, SOGS]\n",
  "SOGDOLAGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLIGER, SOGDOLOGER [n -S]\n",
  "SOGDOLAGERS": "SOGDOLAGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLIGER, SOGDOLOGER [n]\n",
  "SOGDOLIGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLOGER [n -S]\n",
  "SOGDOLIGERS": "SOGDOLIGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCDOLOGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLOGER [n]\n",
  "SOGDOLOGER": "a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOCDOLOGER [n -S]\n",
  "SOGDOLOGERS": "SOGDOLOGER, a conclusive argument, a hard blow, also SLOCKDOLAGER, SLOCKDOLIGER, SLOCKDOLOGER, SOCDOLAGER, SOCDOLIGER, SOCKDOLAGER, SOCKDOLIGER, SOCKDOLOGER, SOGDOLAGER, SOGDOLIGER, SOCDOLOGER [n]\n",
  "SOGER": "(dialect) a soldier, also SODGER [n -S]\n",
  "SOGERS": "SOGER, (dialect) a soldier, also SODGER [n]\n",
  "SOGGED": "SOG, (dialect) to soak [v]\n",
  "SOGGIER": "SOGGY, heavy with moisture [adj]\n",
  "SOGGIEST": "SOGGY, heavy with moisture [adj]\n",
  "SOGGILY": "SOGGY, heavy with moisture [adv]\n",
  "SOGGINESS": "the state of being soggy [n -ES]\n",
  "SOGGINESSES": "SOGGINESS, the state of being soggy [n]\n",
  "SOGGING": "the act of making soggy [n -S]\n",
  "SOGGINGS": "SOGGING, the act of making soggy [n]\n",
  "SOGGY": "heavy with moisture [adj SOGGIER, SOGGIEST, SOGGILY]\n",
  "SOGS": "SOG, (dialect) to soak [v]\n",
  "SOH": "the fifth note of the musical scale, also SO, SOL [n -S]\n",
  "SOHO": "(Shakespeare) a huntsman's halloo [interj]\n",
  "SOHS": "SOH, the fifth note of the musical scale, also SO, SOL [n]\n",
  "SOHUR": "a meal eaten before sunrise by those fasting during Ramadan, also SEHRI, SUHUR [n -S]\n",
  "SOHURS": "SOHUR, a meal eaten before sunrise by those fasting during Ramadan, also SEHRI, SUHUR [n]\n",
  "SOIGNE": "(French) carefully done, also SOIGNEE [adj]\n",
  "SOIGNEE": "(French) carefully done, also SOIGNE [adj]\n",
  "SOIL": "to make dirty [v -ED, -ING, -S]\n",
  "SOILAGE": "green crops for feeding animals [n -S]\n",
  "SOILAGES": "SOILAGE, green crops for feeding animals [n]\n",
  "SOILBORNE": "carried by the soil [adj]\n",
  "SOILED": "SOIL, to make dirty [v]\n",
  "SOILIER": "SOILY, dirty, soiled [adj]\n",
  "SOILIEST": "SOILY, dirty, soiled [adj]\n",
  "SOILINESS": "stain; foulness [n -ES]\n",
  "SOILINESSES": "SOILINESS, stain; foulness [n]\n",
  "SOILING": "the act of soiling [n -S]\n",
  "SOILINGS": "SOILING, the act of soiling [n]\n",
  "SOILLESS": "without dirt [adj]\n",
  "SOILS": "SOIL, to make dirty [v]\n",
  "SOILURE": "a stain or smudge [n -S]\n",
  "SOILURES": "SOILURE, a stain or smudge [n]\n",
  "SOILY": "dirty, soiled [adj SOILIER, SOILIEST]\n",
  "SOIREE": "(French) an evening party [n -S]\n",
  "SOIREES": "SOIREE, (French) an evening party [n]\n",
  "SOJA": "a dark, salty sauce made from fermented soy beans and wheat flour, also SOY, SOYA [n -S]\n",
  "SOJAS": "SOJA, a dark, salty sauce made from fermented soy beans and wheat flour, also SOY, SOYA [n]\n",
  "SOJOURN": "to stay temporarily [v -ED, -ING, -S]\n",
  "SOJOURNED": "SOJOURN, to stay temporarily [v]\n",
  "SOJOURNER": "one who sojourns [n -S]\n",
  "SOJOURNERS": "SOJOURNER, one who sojourns [n]\n",
  "SOJOURNING": "the act of making a sojourn [n -S]\n",
  "SOJOURNINGS": "SOJOURNING, the act of making a sojourn [n]\n",
  "SOJOURNMENT": "the act of sojourning [n -S]\n",
  "SOJOURNMENTS": "SOJOURNMENT, the act of sojourning [n]\n",
  "SOJOURNS": "SOJOURN, to stay temporarily [v]\n",
  "SOJU": "(Korean) a Korean vodka distilled from rice or sweet potato [n -S]\n",
  "SOJUS": "SOJU, (Korean) a Korean vodka distilled from rice or sweet potato [n]\n",
  "SOKAH": "a variety of Caribbean calypso music, also SOCA [n -S]\n",
  "SOKAHS": "SOKAH, a variety of Caribbean calypso music, also SOCA [n]\n",
  "SOKAIYA": "(Japanese) in Japan, a corporate racketeer [n SOKAIYA]\n",
  "SOKE": "a feudal right to administer justice in a certain area [n -S]\n",
  "SOKEMAN": "a tenant by socage, also SOCAGER, SOCKMAN, SOCMAN [n SOKEMEN]\n",
  "SOKEMANRIES": "SOKEMANRY, tenure by socage, a feudal tenure of land involving payment of rent or other nonmilitary services to a superior [n]\n",
  "SOKEMANRY": "tenure by socage, a feudal tenure of land involving payment of rent or other nonmilitary services to a superior [n SOKEMANRIES]\n",
  "SOKEMEN": "SOKEMAN, a tenant by socage, also SOCAGER, SOCKMAN, SOCMAN [n]\n",
  "SOKEN": "a feudal district under a particular jurisdiction, also SUCKEN [n -S]\n",
  "SOKENS": "SOKEN, a feudal district under a particular jurisdiction, also SUCKEN [n]\n",
  "SOKES": "SOKE, a feudal right to administer justice in a certain area [n]\n",
  "SOKOL": "an international group promoting physical fitness [n -S]\n",
  "SOKOLS": "SOKOL, an international group promoting physical fitness [n]\n",
  "SOL": "the fifth tone of the scale, also SO, SOH [n -S]\n",
  "SOLA": "(Hindi) an Indian plant with a pith used in making tropical hats, aka spongewood, also SHOLA, SOLAH [n -S]\n",
  "SOLACE": "to console [v SOLACED, SOLACING, SOLACES]\n",
  "SOLACED": "SOLACE, to console [v]\n",
  "SOLACEMENT": "the act of solacing [n -S]\n",
  "SOLACEMENTS": "SOLACEMENT, the act of solacing [n]\n",
  "SOLACER": "one who solaces [n -S]\n",
  "SOLACERS": "SOLACER, one who solaces [n]\n",
  "SOLACES": "SOLACE, to console [v]\n",
  "SOLACING": "SOLACE, to console [v]\n",
  "SOLACIOUS": "(archaic) giving solace [adj]\n",
  "SOLAH": "(Hindi) an Indian plant with a pith used in making tropical hats, aka spongewood, also SHOLA, SOLA [n -S]\n",
  "SOLAHS": "SOLAH, (Hindi) an Indian plant with a pith used in making tropical hats, aka spongewood, also SHOLA, SOLA [n]\n",
  "SOLAN": "the common gannet, also SOLAND [n -S]\n",
  "SOLANACEOUS": "pertaining to or like a potato or nightshade plant; belonging to the potato or nightshade family of plants [adj]\n",
  "SOLAND": "the common gannet, also SOLAN [n -S]\n",
  "SOLANDER": "(Swedish) a case for maps, plates, etc., made to resemble a book and having the front cover and fore edge hinged [n -S]\n",
  "SOLANDERS": "SOLANDER, (Swedish) a case for maps, plates, etc., made to resemble a book and having the front cover and fore edge hinged [n]\n",
  "SOLANDS": "SOLAND, the common gannet, also SOLAN [n]\n",
  "SOLANIN": "a poisonous alkaloid glucoside extracted from the berries of common nightshade, also SOLANINE [n -S]\n",
  "SOLANINE": "a poisonous alkaloid glucoside extracted from the berries of common nightshade, also SOLANIN [n -S]\n",
  "SOLANINES": "SOLANINE, a poisonous alkaloid glucoside extracted from the berries of common nightshade, also SOLANIN [n]\n",
  "SOLANINS": "SOLANIN, a poisonous alkaloid glucoside extracted from the berries of common nightshade, also SOLANINE [n]\n",
  "SOLANO": "(Spanish) a hot, dust-laden southeasterly wind in Spain [n -S]\n",
  "SOLANOS": "SOLANO, (Spanish) a hot, dust-laden southeasterly wind in Spain [n]\n",
  "SOLANS": "SOLAN, the common gannet, also SOLAND [n]\n",
  "SOLANUM": "(Latin) any herbaceous plant of the genus Solanum, including the potato, bittersweet and certain nightshades [n -S]\n",
  "SOLANUMS": "SOLANUM, (Latin) any herbaceous plant of the genus Solanum, including the potato, bittersweet and certain nightshades [n]\n",
  "SOLAR": "an upper room, a garret, also SOLER, SOLLAR, SOLLER [n -S]\n",
  "SOLARIA": "SOLARIUM, (Latin) a room exposed to the sun [n]\n",
  "SOLARIMETER": "an instrument for measuring solar radiation [n -S]\n",
  "SOLARIMETERS": "SOLARIMETER, an instrument for measuring solar radiation [n]\n",
  "SOLARISATION": "the reversal of an image by overexposure, also SOLARIZATION [n -S]\n",
  "SOLARISATIONS": "SOLARISATION, the reversal of an image by overexposure, also SOLARIZATION [n]\n",
  "SOLARISE": "to expose to sunlight, also SOLARIZE [v SOLARISED, SOLARISING, SOLARISES]\n",
  "SOLARISED": "SOLARISE, to expose to sunlight, also SOLARIZE [v]\n",
  "SOLARISES": "SOLARISE, to expose to sunlight, also SOLARIZE [v]\n",
  "SOLARISING": "SOLARISE, to expose to sunlight, also SOLARIZE [v]\n",
  "SOLARISM": "folk tales as concepts of the nature of the sun [n -S]\n",
  "SOLARISMS": "SOLARISM, folk tales as concepts of the nature of the sun [n]\n",
  "SOLARIST": "one who practises solarism, excessive use of solar myths in explaining mythology [n -S]\n",
  "SOLARISTS": "SOLARIST, one who practises solarism, excessive use of solar myths in explaining mythology [n]\n",
  "SOLARIUM": "(Latin) a room exposed to the sun [n SOLARIUMS or SOLARIA]\n",
  "SOLARIUMS": "SOLARIUM, (Latin) a room exposed to the sun [n]\n",
  "SOLARIZATION": "the reversal of an image by overexposure, also SOLARISATION [n -S]\n",
  "SOLARIZATIONS": "SOLARIZATION, the reversal of an image by overexposure, also SOLARISATION [n]\n",
  "SOLARIZE": "to expose to sunlight, also SOLARISE [v SOLARIZED, SOLARIZING, SOLARIZES]\n",
  "SOLARIZED": "SOLARIZE, to expose to sunlight, also SOLARISE [v]\n",
  "SOLARIZES": "SOLARIZE, to expose to sunlight, also SOLARISE [v]\n",
  "SOLARIZING": "SOLARIZE, to expose to sunlight, also SOLARISE [v]\n",
  "SOLARS": "SOLAR, an upper room, a garret, also SOLER, SOLLAR, SOLLER [n]\n",
  "SOLAS": "SOLA, (Hindi) an Indian plant with a pith used in making tropical hats, aka spongewood, also SHOLA, SOLAH [n]\n",
  "SOLATE": "to convert or be converted from a gel into a sol [v SOLATED, SOLATING, SOLATES]\n",
  "SOLATED": "SOLATE, to convert or be converted from a gel into a sol [v]\n",
  "SOLATES": "SOLATE, to convert or be converted from a gel into a sol [v]\n",
  "SOLATIA": "SOLATIUM, (Latin) a compensation (as money) given as solace for suffering, loss, or injured feelings [n]\n",
  "SOLATING": "SOLATE, to convert or be converted from a gel into a sol [v]\n",
  "SOLATION": "liquefaction of a gel [n -S]\n",
  "SOLATIONS": "SOLATION, liquefaction of a gel [n]\n",
  "SOLATIUM": "(Latin) a compensation (as money) given as solace for suffering, loss, or injured feelings [n SOLATIA]\n",
  "SOLD": "(Spenser) pay, remuneration, also SOLDE [n -S]\n",
  "SOLDADO": "(Spanish) a soldier [n -ES or -S]\n",
  "SOLDADOES": "SOLDADO, (Spanish) a soldier [n]\n",
  "SOLDADOS": "SOLDADO, (Spanish) a soldier [n]\n",
  "SOLDAN": "(archaic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOUDAN, SOULDAN, SULDAN, SULTAN [n -S]\n",
  "SOLDANS": "SOLDAN, (archaic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOUDAN, SOULDAN, SULDAN, SULTAN [n]\n",
  "SOLDATESQUE": "soldierlike [adj]\n",
  "SOLDE": "(Spenser) pay, remuneration, also SOLD [n -S]\n",
  "SOLDER": "to join together with heat [v -ED, -ING, -S]\n",
  "SOLDERABILITIES": "SOLDERABILITY, the state of being solderable [n]\n",
  "SOLDERABILITY": "the state of being solderable [n SOLDERABILITIES]\n",
  "SOLDERABLE": "that can be soldered [adj]\n",
  "SOLDERED": "SOLDER, to join together with heat [v]\n",
  "SOLDERER": "one who solders [n -S]\n",
  "SOLDERERS": "SOLDERER, one who solders [n]\n",
  "SOLDERING": "the act of soldering [n -S]\n",
  "SOLDERINGS": "SOLDERING, the act of soldering [n]\n",
  "SOLDERS": "SOLDER, to join together with heat [v]\n",
  "SOLDES": "SOLDE, (Spenser) pay, remuneration, also SOLD [n]\n",
  "SOLDI": "SOLDO, (Italian) a former Italian coin, one twentieth of a lira [n]\n",
  "SOLDIER": "to perform military service [v -ED, -ING, -S]\n",
  "SOLDIERED": "SOLDIER, to perform military service [v]\n",
  "SOLDIERIES": "SOLDIERY, the military profession [n]\n",
  "SOLDIERING": "the profession of soldier [n -S]\n",
  "SOLDIERINGS": "SOLDIERING, the profession of soldier [n]\n",
  "SOLDIERLIER": "SOLDIERLY, like a soldier [adj]\n",
  "SOLDIERLIEST": "SOLDIERLY, like a soldier [adj]\n",
  "SOLDIERLIKE": "like a soldier [adj]\n",
  "SOLDIERLINESS": "the state of being soldierly [n -ES]\n",
  "SOLDIERLINESSES": "SOLDIERLINESS, the state of being soldierly [n]\n",
  "SOLDIERLY": "like a soldier [adj SOLDIERLIER, SOLDIERLIEST]\n",
  "SOLDIERS": "SOLDIER, to perform military service [v]\n",
  "SOLDIERSHIP": "the state of being a soldier [n -S]\n",
  "SOLDIERSHIPS": "SOLDIERSHIP, the state of being a soldier [n]\n",
  "SOLDIERY": "the military profession [n SOLDIERIES]\n",
  "SOLDO": "(Italian) a former Italian coin, one twentieth of a lira [n SOLDI]\n",
  "SOLDS": "SOLD, (Spenser) pay, remuneration, also SOLDE [n]\n",
  "SOLE": "alone [adj SOLELY] / to replace the bottom of a shoe or boot [v SOLED, SOLING, SOLES]\n",
  "SOLECISE": "to use an ungrammatical combination of words, also SOLECIZE [v SOLECISED, SOLECISING, SOLECISES]\n",
  "SOLECISED": "SOLECISE, to use an ungrammatical combination of words, also SOLECIZE [v]\n",
  "SOLECISES": "SOLECISE, to use an ungrammatical combination of words, also SOLECIZE [v]\n",
  "SOLECISING": "SOLECISE, to use an ungrammatical combination of words, also SOLECIZE [v]\n",
  "SOLECISM": "an ungrammatical combination of words [n -S]\n",
  "SOLECISMS": "SOLECISM, an ungrammatical combination of words [n]\n",
  "SOLECIST": "one who commits a solecism [n -S]\n",
  "SOLECISTIC": "having the nature of a solecism, also SOLECISTICAL [adj SOLECISTICALLY]\n",
  "SOLECISTICAL": "having the nature of a solecism, also SOLECISTIC [adj SOLECISTICALLY]\n",
  "SOLECISTICALLY": "SOLECISTICAL, having the nature of a solecism, also SOLECISTIC [adv]\n",
  "SOLECISTS": "SOLECIST, one who commits a solecism [n]\n",
  "SOLECIZE": "to use an ungrammatical combination of words, also SOLECISE [v SOLECIZED, SOLECIZING, SOLECIZES]\n",
  "SOLECIZED": "SOLECIZE, to use an ungrammatical combination of words, also SOLECISE [v]\n",
  "SOLECIZES": "SOLECIZE, to use an ungrammatical combination of words, also SOLECISE [v]\n",
  "SOLECIZING": "SOLECIZE, to use an ungrammatical combination of words, also SOLECISE [v]\n",
  "SOLED": "SOLE, to replace the bottom of a shoe or boot [v]\n",
  "SOLEI": "SOLEUS, (Latin) a leg muscle [n]\n",
  "SOLEIN": "(Spenser) sullen [adj]\n",
  "SOLELESS": "without a sole [adj]\n",
  "SOLELY": "SOLE, alone [adv]\n",
  "SOLEMN": "serious [adj SOLEMNER, SOLEMNEST, SOLEMNLY]\n",
  "SOLEMNER": "SOLEMN, serious [adj]\n",
  "SOLEMNESS": "the state of being solemn, also SOLEMNNESS [n -ES]\n",
  "SOLEMNESSES": "SOLEMNESS, the state of being solemn, also SOLEMNNESS [n]\n",
  "SOLEMNEST": "SOLEMN, serious [adj]\n",
  "SOLEMNIFICATION": "the act of solemnifying [n]\n",
  "SOLEMNIFIED": "SOLEMNIFY, to make solemn [v]\n",
  "SOLEMNIFIES": "SOLEMNIFY, to make solemn [v]\n",
  "SOLEMNIFY": "to make solemn [v SOLEMNIFIED, SOLEMNIFYING, SOLEMNIFIES]\n",
  "SOLEMNIFYING": "SOLEMNIFY, to make solemn [v]\n",
  "SOLEMNISATION": "the act of solemnising, also SOLEMNIZATION [n -S]\n",
  "SOLEMNISATIONS": "SOLEMNISATION, the act of solemnising, also SOLEMNIZATION [n]\n",
  "SOLEMNISE": "to make solemn, also SOLEMNIZE [v SOLEMNISED, SOLEMNISING, SOLEMNISES]\n",
  "SOLEMNISED": "SOLEMNISE, to make solemn, also SOLEMNIZE [v]\n",
  "SOLEMNISER": "one who solemnises, also SOLEMNIZER [n -S]\n",
  "SOLEMNISERS": "SOLEMNISER, one who solemnises, also SOLEMNIZER [n]\n",
  "SOLEMNISES": "SOLEMNISE, to make solemn, also SOLEMNIZE [v]\n",
  "SOLEMNISING": "SOLEMNISE, to make solemn, also SOLEMNIZE [v]\n",
  "SOLEMNITIES": "SOLEMNITY, the quality of being solemn [n]\n",
  "SOLEMNITY": "the quality of being solemn [n SOLEMNITIES]\n",
  "SOLEMNIZATION": "the act of solemnizing, also SOLEMNISATION [n -S]\n",
  "SOLEMNIZATIONS": "SOLEMNIZATION, the act of solemnizing, also SOLEMNISATION [n]\n",
  "SOLEMNIZE": "to make solemn, also SOLEMNISE [v SOLEMNIZED, SOLEMNIZING, SOLEMNIZES]\n",
  "SOLEMNIZED": "SOLEMNIZE, to make solemn, also SOLEMNISE [v]\n",
  "SOLEMNIZER": "one who solemnizes, also SOLEMNISER [n -S]\n",
  "SOLEMNIZERS": "SOLEMNIZER, one who solemnizes, also SOLEMNISER [n]\n",
  "SOLEMNIZES": "SOLEMNIZE, to make solemn, also SOLEMNISE [v]\n",
  "SOLEMNIZING": "SOLEMNIZE, to make solemn, also SOLEMNISE [v]\n",
  "SOLEMNLY": "SOLEMN, serious [adv]\n",
  "SOLEMNNESS": "the state of being solemn, also SOLEMNESS [n -ES]\n",
  "SOLEMNNESSES": "SOLEMNNESS, the state of being solemn, also SOLEMNESS [n]\n",
  "SOLENESS": "the state of being the only one [n -ES]\n",
  "SOLENESSES": "SOLENESS, the state of being the only one [n]\n",
  "SOLENETTE": "a small European species of sole [n -S]\n",
  "SOLENETTES": "SOLENETTE, a small European species of sole [n]\n",
  "SOLENODON": "either of two species of singular West Indian insectivores, allied to the tenrec [n -S]\n",
  "SOLENODONS": "SOLENODON, either of two species of singular West Indian insectivores, allied to the tenrec [n]\n",
  "SOLENOID": "a cylindrical wire coil acting as a magnet when charged [n -S]\n",
  "SOLENOIDAL": "like a solenoid [adj SOLENOIDALLY]\n",
  "SOLENOIDALLY": "SOLENOIDAL, like a solenoid [adv]\n",
  "SOLENOIDS": "SOLENOID, a cylindrical wire coil acting as a magnet when charged [n]\n",
  "SOLEPLATE": "a bedplate; as, the soleplate of a steam engine [n -S]\n",
  "SOLEPLATES": "SOLEPLATE, a bedplate; as, the soleplate of a steam engine [n]\n",
  "SOLEPRINT": "the print of the sole of the foot [n -S]\n",
  "SOLEPRINTS": "SOLEPRINT, the print of the sole of the foot [n]\n",
  "SOLER": "(archaic) an upper room, a garret, also SOLAR, SOLLAR, SOLLER [n -S]\n",
  "SOLERA": "(Spanish) a system of sherry production involving the blending of wines from different casks [n -S]\n",
  "SOLERAS": "SOLERA, (Spanish) a system of sherry production involving the blending of wines from different casks [n]\n",
  "SOLERET": "a metallic pointy toed shoe worn by knights, aka sabaton, also SOLLERET [n -S]\n",
  "SOLERETS": "SOLERET, a metallic pointy toed shoe worn by knights, aka sabaton, also SOLLERET [n]\n",
  "SOLERS": "SOLER, (archaic) an upper room, a garret, also SOLAR, SOLLAR, SOLLER [n]\n",
  "SOLES": "SOLE, to replace the bottom of a shoe or boot [v]\n",
  "SOLEUS": "(Latin) a leg muscle [n SOLEUSES or SOLEI]\n",
  "SOLEUSES": "SOLEUS, (Latin) a leg muscle [n]\n",
  "SOLFATARA": "(Italian) a volcanic vent emitting only gases [n -S]\n",
  "SOLFATARAS": "SOLFATARA, (Italian) a volcanic vent emitting only gases [n]\n",
  "SOLFATARIC": "relating to a solfatara, a volcanic vent emitting only gases [adj]\n",
  "SOLFEGE": "(French) a singing exercise using the syllable do, re, mi, fa, so, la, ti, also SOLFEGGIO [n -S]\n",
  "SOLFEGES": "SOLFEGE, (French) a singing exercise using the syllable do, re, mi, fa, so, la, ti, also SOLFEGGIO [n]\n",
  "SOLFEGGI": "SOLFEGGIO, a singing exercise using the syllable do, re, mi, fa, so, la, ti, also SOLFEGE [n]\n",
  "SOLFEGGIO": "a singing exercise using the syllable do, re, mi, fa, so, la, ti, also SOLFEGE [n SOLFEGGI or SOLFEGGIOS]\n",
  "SOLFEGGIOS": "SOLFEGGIO, a singing exercise using the syllable do, re, mi, fa, so, la, ti, also SOLFEGE [n]\n",
  "SOLFERINO": "(Italian) a moderate purplish-red [n -S]\n",
  "SOLFERINOS": "SOLFERINO, (Italian) a moderate purplish-red [n]\n",
  "SOLGEL": "involving changes in the state of a colloidal system [adj]\n",
  "SOLI": "SOLO, a performance by one person [n]\n",
  "SOLICIT": "to ask for earnestly [v -ED, -ING, -S]\n",
  "SOLICITANT": "one who solicits [n -S]\n",
  "SOLICITANTS": "SOLICITANT, one who solicits [n]\n",
  "SOLICITATION": "the practice or act or an instance of soliciting [n -S]\n",
  "SOLICITATIONS": "SOLICITATION, the practice or act or an instance of soliciting [n]\n",
  "SOLICITED": "SOLICIT, to ask for earnestly [v]\n",
  "SOLICITIES": "SOLICITY, (Shakespeare) solicitation [n]\n",
  "SOLICITING": "the act of soliciting [n -S]\n",
  "SOLICITINGS": "SOLICITING, the act of soliciting [n]\n",
  "SOLICITOR": "a person who is legally qualified to act for another in a court of law [n -S]\n",
  "SOLICITORS": "SOLICITOR, a person who is legally qualified to act for another in a court of law [n]\n",
  "SOLICITORSHIP": "the office of solicitor [n -S]\n",
  "SOLICITORSHIPS": "SOLICITORSHIP, the office of solicitor [n]\n",
  "SOLICITOUS": "expressing solicitude [adj SOLICITOUSLY]\n",
  "SOLICITOUSLY": "SOLICITOUS, expressing solicitude [adv]\n",
  "SOLICITOUSNESS": "the state of being solicitous [n]\n",
  "SOLICITS": "SOLICIT, to ask for earnestly [v]\n",
  "SOLICITUDE": "the state of being concerned and anxious [n -S]\n",
  "SOLICITUDES": "SOLICITUDE, the state of being concerned and anxious [n]\n",
  "SOLICITY": "(Shakespeare) solicitation [n SOLICITIES]\n",
  "SOLID": "having definite shape and volume [adj SOLIDER, SOLIDEST, SOLIDLY] / a solid substance [n -S]\n",
  "SOLIDAGO": "a flower, goldenrod [n -S]\n",
  "SOLIDAGOS": "SOLIDAGO, a flower, goldenrod [n]\n",
  "SOLIDARE": "(Shakespeare) a small coin [n -S]\n",
  "SOLIDARES": "SOLIDARE, (Shakespeare) a small coin [n]\n",
  "SOLIDARISM": "solidarity [n -S]\n",
  "SOLIDARISMS": "SOLIDARISM, solidarity [n]\n",
  "SOLIDARIST": "one who practises solidarity [n -S]\n",
  "SOLIDARISTIC": "relating to solidarism [adj]\n",
  "SOLIDARISTS": "SOLIDARIST, one who practises solidarity [n]\n",
  "SOLIDARITIES": "SOLIDARITY, unity (as of a group or class) that produces or is based on community of interests, objectives, and standards [n]\n",
  "SOLIDARITY": "unity (as of a group or class) that produces or is based on community of interests, objectives, and standards [n SOLIDARITIES]\n",
  "SOLIDARY": "united [adj]\n",
  "SOLIDATE": "to consolidate [v SOLIDATED, SOLIDATING, SOLIDATES]\n",
  "SOLIDATED": "SOLIDATE, to consolidate [v]\n",
  "SOLIDATES": "SOLIDATE, to consolidate [v]\n",
  "SOLIDATING": "SOLIDATE, to consolidate [v]\n",
  "SOLIDER": "SOLID, having definite shape and volume [adj]\n",
  "SOLIDEST": "SOLID, having definite shape and volume [adj]\n",
  "SOLIDI": "SOLIDUS, (Latin) a Roman gold coin, aka bezant; a mediaeval silver coin worth 12 denarii [n]\n",
  "SOLIDIFIABLE": "that can be solidified [adj]\n",
  "SOLIDIFICATION": "the act of solidifying [n -S]\n",
  "SOLIDIFICATIONS": "SOLIDIFICATION, the act of solidifying [n]\n",
  "SOLIDIFIED": "SOLIDIFY, to make solid [v]\n",
  "SOLIDIFIER": "one who solidifies [n -S]\n",
  "SOLIDIFIERS": "SOLIDIFIER, one who solidifies [n]\n",
  "SOLIDIFIES": "SOLIDIFY, to make solid [v]\n",
  "SOLIDIFY": "to make solid [v SOLIDIFIED, SOLIDIFYING, SOLIDIFIES]\n",
  "SOLIDIFYING": "SOLIDIFY, to make solid [v]\n",
  "SOLIDISH": "somewhat solid [adj]\n",
  "SOLIDISM": "a doctrine on disease [n -S]\n",
  "SOLIDISMS": "SOLIDISM, a doctrine on disease [n]\n",
  "SOLIDIST": "an advocate of, or believer in, solidism, the doctrine that refers all diseases to morbid changes of the solid parts of the body [n -S]\n",
  "SOLIDISTS": "SOLIDIST, an advocate of, or believer in, solidism, the doctrine that refers all diseases to morbid changes of the solid parts of the body [n]\n",
  "SOLIDITIES": "SOLIDITY, the state of being solid, also SOLIDNESS [n]\n",
  "SOLIDITY": "the state of being solid, also SOLIDNESS [n SOLIDITIES]\n",
  "SOLIDLY": "SOLID, having definite shape and volume [adv]\n",
  "SOLIDNESS": "the state of being solid, also SOLIDITY [n -ES]\n",
  "SOLIDNESSES": "SOLIDNESS, the state of being solid, also SOLIDITY [n]\n",
  "SOLIDS": "SOLID, a solid substance [n]\n",
  "SOLIDUM": "(Latin) a large moulding along the base of a pedestal [n -S]\n",
  "SOLIDUMS": "SOLIDUM, (Latin) a large moulding along the base of a pedestal [n]\n",
  "SOLIDUNGULATE": "an animal with an uncloven hoof, also SOLIDUNGULOUS [n -S]\n",
  "SOLIDUNGULATES": "SOLIDUNGULATE, an animal with an uncloven hoof, also SOLIDUNGULOUS [n]\n",
  "SOLIDUNGULOUS": "having a single hoof on each foot, also SOLIDUNGULATE [adj]\n",
  "SOLIDUS": "(Latin) a Roman gold coin, aka bezant; a mediaeval silver coin worth 12 denarii [n SOLIDI]\n",
  "SOLIFIDIAN": "maintaining that only faith can bring redemption [adj] / one who maintains that only faith can bring redemption [n -S]\n",
  "SOLIFIDIANISM": "the doctrine that faith alone will ensure salvation [n -S]\n",
  "SOLIFIDIANISMS": "SOLIFIDIANISM, the doctrine that faith alone will ensure salvation [n]\n",
  "SOLIFIDIANS": "SOLIFIDIAN, one who maintains that only faith can bring redemption [n]\n",
  "SOLIFLUCTION": "the turbulent movement of saturated soil or surficial debris, also SOLIFLUXION [n -S]\n",
  "SOLIFLUCTIONS": "SOLIFLUCTION, the turbulent movement of saturated soil or surficial debris, also SOLIFLUXION [n]\n",
  "SOLIFLUXION": "the turbulent movement of saturated soil or surficial debris, also SOLIFLUCTION [n -S]\n",
  "SOLIFLUXIONS": "SOLIFLUXION, the turbulent movement of saturated soil or surficial debris, also SOLIFLUCTION [n]\n",
  "SOLILOQUIES": "SOLILOQUY, an act of talking to oneself; a speech of this nature made by a character in a play, etc. [n]\n",
  "SOLILOQUISE": "to talk reflectively to oneself, also SOLILOQUIZE [v SOLILOQUISED, SOLILOQUISING, SOLILOQUISES]\n",
  "SOLILOQUISED": "SOLILOQUISE, to talk reflectively to oneself, also SOLILOQUIZE [v]\n",
  "SOLILOQUISER": "one who soliloquises, also SOLILOQUIZER [n -S]\n",
  "SOLILOQUISERS": "SOLILOQUISER, one who soliloquises, also SOLILOQUIZER [n]\n",
  "SOLILOQUISES": "SOLILOQUISE, to talk reflectively to oneself, also SOLILOQUIZE [v]\n",
  "SOLILOQUISING": "SOLILOQUISE, to talk reflectively to oneself, also SOLILOQUIZE [v]\n",
  "SOLILOQUIST": "one who soliloquizes [n -S]\n",
  "SOLILOQUISTS": "SOLILOQUIST, one who soliloquizes [n]\n",
  "SOLILOQUIZE": "to talk reflectively to oneself, also SOLILOQUISE [v SOLILOQUIZED, SOLILOQUIZING, SOLILOQUIZES]\n",
  "SOLILOQUIZED": "SOLILOQUIZE, to talk reflectively to oneself, also SOLILOQUISE [v]\n",
  "SOLILOQUIZER": "one who soliloquises, also SOLILOQUISER [n -S]\n",
  "SOLILOQUIZERS": "SOLILOQUIZER, one who soliloquises, also SOLILOQUISER [n]\n",
  "SOLILOQUIZES": "SOLILOQUIZE, to talk reflectively to oneself, also SOLILOQUISE [v]\n",
  "SOLILOQUIZING": "SOLILOQUIZE, to talk reflectively to oneself, also SOLILOQUISE [v]\n",
  "SOLILOQUY": "an act of talking to oneself; a speech of this nature made by a character in a play, etc. [n SOLILOQUIES]\n",
  "SOLING": "SOLE, to replace the bottom of a shoe or boot [v]\n",
  "SOLION": "an electronic detecting and amplifying device [n -S]\n",
  "SOLIONS": "SOLION, an electronic detecting and amplifying device [n]\n",
  "SOLIPED": "an animal with uncloven hoofs [n -S]\n",
  "SOLIPEDOUS": "having single hoofs [adj]\n",
  "SOLIPEDS": "SOLIPED, an animal with uncloven hoofs [n]\n",
  "SOLIPSISM": "a theory holding that the self can know nothing but its own modifications and that the self is the only existent thing [n -S]\n",
  "SOLIPSISMS": "SOLIPSISM, a theory holding that the self can know nothing but its own modifications and that the self is the only existent thing [n]\n",
  "SOLIPSIST": "one who practises solipsism, the belief that the self is all that exists [n -S]\n",
  "SOLIPSISTIC": "relating to solipsism [adj SOLIPSISTICALLY]\n",
  "SOLIPSISTICALLY": "SOLIPSISTIC, relating to solipsism [adv]\n",
  "SOLIPSISTS": "SOLIPSIST, one who practises solipsism, the belief that the self is all that exists [n]\n",
  "SOLIQUID": "a fluid colloidal system [n -S]\n",
  "SOLIQUIDS": "SOLIQUID, a fluid colloidal system [n]\n",
  "SOLITAIRE": "a game played by one person with a board and balls, pegs, etc. [n -S]\n",
  "SOLITAIRES": "SOLITAIRE, a game played by one person with a board and balls, pegs, etc. [n]\n",
  "SOLITARIAN": "a hermit; a solitary [n -S]\n",
  "SOLITARIANS": "SOLITARIAN, a hermit; a solitary [n]\n",
  "SOLITARIES": "SOLITARY, one who lives alone [n]\n",
  "SOLITARILY": "SOLITARY, alone [adv]\n",
  "SOLITARINESS": "the state of being solitary [n -ES]\n",
  "SOLITARINESSES": "SOLITARINESS, the state of being solitary [n]\n",
  "SOLITARY": "alone [adj SOLITARILY] / one who lives alone [n SOLITARIES]\n",
  "SOLITO": "(Italian) in the usual manner [adv]\n",
  "SOLITON": "a solitary wave in physics [n -S]\n",
  "SOLITONS": "SOLITON, a solitary wave in physics [n]\n",
  "SOLITUDE": "the state of being alone [n -S]\n",
  "SOLITUDES": "SOLITUDE, the state of being alone [n]\n",
  "SOLITUDINARIAN": "a recluse [n -S]\n",
  "SOLITUDINARIANS": "SOLITUDINARIAN, a recluse [n]\n",
  "SOLITUDINOUS": "related to solitude [adj]\n",
  "SOLIVAGANT": "wandering alone [adj] / one who wanders alone [n -S]\n",
  "SOLIVAGANTS": "SOLIVAGANT, one who wanders alone [n]\n",
  "SOLIVE": "a joist or beam of secondary importance [n -S]\n",
  "SOLIVES": "SOLIVE, a joist or beam of secondary importance [n]\n",
  "SOLLAR": "(archaic) to put in a floor or garret [v -ED, -ING, -S]\n",
  "SOLLARED": "SOLLAR, (archaic) to put in a floor or garret [v]\n",
  "SOLLARING": "SOLLAR, (archaic) to put in a floor or garret [v]\n",
  "SOLLARS": "SOLLAR, (archaic) to put in a floor or garret [v]\n",
  "SOLLER": "(archaic) an upper room, a garret, also SOLAR, SOLER, SOLLAR [n -S]\n",
  "SOLLERET": "a metallic pointy toed shoe worn by knights, aka sabaton, also SOLERET [n -S]\n",
  "SOLLERETS": "SOLLERET, a metallic pointy toed shoe worn by knights, aka sabaton, also SOLERET [n]\n",
  "SOLLERS": "SOLLER, (archaic) an upper room, a garret, also SOLAR, SOLER, SOLLAR [n]\n",
  "SOLLICKER": "(Australian slang) something very large [n -S]\n",
  "SOLLICKERS": "SOLLICKER, (Australian slang) something very large [n]\n",
  "SOLMISATION": "a recital of the notes of the gamut, also SOLMIZATION [n -S]\n",
  "SOLMISATIONS": "SOLMISATION, a recital of the notes of the gamut, also SOLMIZATION [n]\n",
  "SOLMIZATION": "a recital of the notes of the gamut, also SOLMISATION [n -S]\n",
  "SOLMIZATIONS": "SOLMIZATION, a recital of the notes of the gamut, also SOLMISATION [n]\n",
  "SOLO": "a performance by one person [n SOLOS or SOLI] / to perform a solo [v -ED, -ING, -ES]\n",
  "SOLOED": "SOLO, to perform a solo [v]\n",
  "SOLOES": "SOLO, to perform a solo [v]\n",
  "SOLOING": "SOLO, to perform a solo [v]\n",
  "SOLOIST": "one who performs alone [n -S]\n",
  "SOLOISTIC": "relating to a soloist [adj]\n",
  "SOLOISTS": "SOLOIST, one who performs alone [n]\n",
  "SOLON": "a wise lawgiver [n -S]\n",
  "SOLONCHAK": "(Russian) a pale or grey soil type found in arid to subhumid, poorly drained conditions [n -S]\n",
  "SOLONCHAKS": "SOLONCHAK, (Russian) a pale or grey soil type found in arid to subhumid, poorly drained conditions [n]\n",
  "SOLONETS": "(Russian) a type of soil, also SOLONETZ [n -ES]\n",
  "SOLONETSES": "SOLONETS, (Russian) a type of soil, also SOLONETZ [n]\n",
  "SOLONETZ": "(Russian) a type of soil, also SOLONETS [n -ES]\n",
  "SOLONETZES": "SOLONETZ, (Russian) a type of soil, also SOLONETS [n]\n",
  "SOLONETZIC": "relating to solonetz, a soil type [adj]\n",
  "SOLONISATION": "the process by which a solonetz is formed, also SOLONIZATION [n -S]\n",
  "SOLONISATIONS": "SOLONISATION, the process by which a solonetz is formed, also SOLONIZATION [n]\n",
  "SOLONIZATION": "the process by which a solonetz is formed, also SOLONISATION [n -S]\n",
  "SOLONIZATIONS": "SOLONIZATION, the process by which a solonetz is formed, also SOLONISATION [n]\n",
  "SOLONS": "SOLON, a wise lawgiver [n]\n",
  "SOLOS": "SOLO, to perform a solo [v]\n",
  "SOLPUGID": "(Latin) a type of venomous arachnid, aka camel spider [n -S]\n",
  "SOLPUGIDS": "SOLPUGID, (Latin) a type of venomous arachnid, aka camel spider [n]\n",
  "SOLS": "SOL, the fifth tone of the scale, also SO, SOH [n]\n",
  "SOLSTICE": "the time when the sun is farthest from the equator [n -S]\n",
  "SOLSTICES": "SOLSTICE, the time when the sun is farthest from the equator [n]\n",
  "SOLSTITIAL": "of or pertaining to a solstice [adj SOLSTITIALLY]\n",
  "SOLSTITIALLY": "SOLSTITIAL, of or pertaining to a solstice [adv]\n",
  "SOLUBILISATION": "the act of solubilising, also SOLUBILIZATION [n -S]\n",
  "SOLUBILISATIONS": "SOLUBILISATION, the act of solubilising, also SOLUBILIZATION [n]\n",
  "SOLUBILISE": "to render soluble, also SOLUBILIZE [v SOLUBILISED, SOLUBILISING, SOLUBILISES]\n",
  "SOLUBILISED": "SOLUBILISE, to render soluble, also SOLUBILIZE [v]\n",
  "SOLUBILISES": "SOLUBILISE, to render soluble, also SOLUBILIZE [v]\n",
  "SOLUBILISING": "SOLUBILISE, to render soluble, also SOLUBILIZE [v]\n",
  "SOLUBILITIES": "SOLUBILITY, the state of being soluble [n]\n",
  "SOLUBILITY": "the state of being soluble [n SOLUBILITIES]\n",
  "SOLUBILIZATION": "the act of solubilizing, also SOLUBILISATION [n -S]\n",
  "SOLUBILIZATIONS": "SOLUBILIZATION, the act of solubilizing, also SOLUBILISATION [n]\n",
  "SOLUBILIZE": "to render soluble, also SOLUBILISE [v SOLUBILIZED, SOLUBILIZING, SOLUBILIZES]\n",
  "SOLUBILIZED": "SOLUBILIZE, to render soluble, also SOLUBILISE [v]\n",
  "SOLUBILIZES": "SOLUBILIZE, to render soluble, also SOLUBILISE [v]\n",
  "SOLUBILIZING": "SOLUBILIZE, to render soluble, also SOLUBILISE [v]\n",
  "SOLUBLE": "that dissolves [adj SOLUBLY] / something that is soluble [n -S]\n",
  "SOLUBLENESS": "the state of being soluble [n -ES]\n",
  "SOLUBLENESSES": "SOLUBLENESS, the state of being soluble [n]\n",
  "SOLUBLES": "SOLUBLE, something that is soluble [n]\n",
  "SOLUBLY": "SOLUBLE, that dissolves [adv]\n",
  "SOLUM": "(Latin) the surface layer of soil in which topsoil formation occurs [n -S]\n",
  "SOLUMS": "SOLUM, (Latin) the surface layer of soil in which topsoil formation occurs [n]\n",
  "SOLUNAR": "pertaining to tables of solar and lunar times [adj]\n",
  "SOLUS": "a poster or advertisement appearing in isolation from any others [n -ES]\n",
  "SOLUSES": "SOLUS, a poster or advertisement appearing in isolation from any others [n]\n",
  "SOLUTAL": "of or like a solute [adj]\n",
  "SOLUTE": "the minor component in a solution, which is dissolved in the solvent [n -S]\n",
  "SOLUTES": "SOLUTE, the minor component in a solution, which is dissolved in the solvent [n]\n",
  "SOLUTION": "the act of solving or dissolving [n -S] / to provide with a solution [v -ED, -ING, -S]\n",
  "SOLUTIONAL": "relating to a solution [adj]\n",
  "SOLUTIONED": "SOLUTION, to provide with a solution [v]\n",
  "SOLUTIONING": "SOLUTION, to provide with a solution [v]\n",
  "SOLUTIONIST": "a solver, as of puzzles [n -S]\n",
  "SOLUTIONISTS": "SOLUTIONIST, a solver, as of puzzles [n]\n",
  "SOLUTIONS": "SOLUTION, to provide with a solution [v]\n",
  "SOLUTIVE": "a solvent or laxative [n -S]\n",
  "SOLUTIVES": "SOLUTIVE, a solvent or laxative [n]\n",
  "SOLVABILITIES": "SOLVABILITY, the ability to be solved [n]\n",
  "SOLVABILITY": "the ability to be solved [n SOLVABILITIES]\n",
  "SOLVABLE": "able to be solved [adj]\n",
  "SOLVABLENESS": "the state of being solvable [n -ES]\n",
  "SOLVABLENESSES": "SOLVABLENESS, the state of being solvable [n]\n",
  "SOLVATE": "to convert into a type of ion [v SOLVATED, SOLVATING, SOLVATES]\n",
  "SOLVATED": "SOLVATE, to convert into a type of ion [v]\n",
  "SOLVATES": "SOLVATE, to convert into a type of ion [v]\n",
  "SOLVATING": "SOLVATE, to convert into a type of ion [v]\n",
  "SOLVATION": "a chemical process in which a solute and solvent combine with relatively weak covalent bonds, e.g. hydration [n -S]\n",
  "SOLVATIONS": "SOLVATION, a chemical process in which a solute and solvent combine with relatively weak covalent bonds, e.g. hydration [n]\n",
  "SOLVE": "to find the answer to [v SOLVED, SOLVING, SOLVES]\n",
  "SOLVED": "SOLVE, to find the answer to [v]\n",
  "SOLVENCIES": "SOLVENCY, the ability to pay all debts [n]\n",
  "SOLVENCY": "the ability to pay all debts [n SOLVENCIES]\n",
  "SOLVENT": "able to solve and dissolve [adj SOLVENTLY] / a substance capable of dissolving others [n -S]\n",
  "SOLVENTLESS": "without solvent [adj]\n",
  "SOLVENTLY": "SOLVENT, able to solve and dissolve [adv]\n",
  "SOLVENTS": "SOLVENT, a substance capable of dissolving others [n]\n",
  "SOLVER": "one who solves [n -S]\n",
  "SOLVERS": "SOLVER, one who solves [n]\n",
  "SOLVES": "SOLVE, to find the answer to [v]\n",
  "SOLVING": "SOLVE, to find the answer to [v]\n",
  "SOLVOLYSES": "SOLVOLYSIS, the decomposition of a dissolved substance [n]\n",
  "SOLVOLYSIS": "the decomposition of a dissolved substance [n SOLVOLYSES]\n",
  "SOLVOLYTIC": "relating to solvolysis, the decomposition of a dissolved substance [adj]\n",
  "SOM": "a monetary unit of Kyrgyzstan [n SOMS or SOMY]\n",
  "SOMA": "(Greek) the whole axial portion of an animal, including the head, neck, trunk, and tail [n SOMAS or SOMATA]\n",
  "SOMAESTHESIA": "sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIS, SOMESTHESIA, SOMESTHESIS [n -S]\n",
  "SOMAESTHESIAS": "SOMAESTHESIA, sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIS, SOMESTHESIA, SOMESTHESIS [n]\n",
  "SOMAESTHESIS": "sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIA, SOMESTHESIA, SOMESTHESIS [n SOMAESTHESISES]\n",
  "SOMAESTHESISES": "SOMAESTHESIS, sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIA, SOMESTHESIA, SOMESTHESIS [n]\n",
  "SOMAESTHETIC": "relating to somaesthesia [adj]\n",
  "SOMAN": "a nerve agent developed for chemical warfare [n -S]\n",
  "SOMANS": "SOMAN, a nerve agent developed for chemical warfare [n]\n",
  "SOMAS": "SOMA, (Greek) the whole axial portion of an animal, including the head, neck, trunk, and tail [n]\n",
  "SOMASCOPE": "an instrument detecting disease of the internal organs by 'echo-sounding' methods and producing images of the diseased tissue on a television screen [n -S]\n",
  "SOMASCOPES": "SOMASCOPE, an instrument detecting disease of the internal organs by 'echo-sounding' methods and producing images of the diseased tissue on a television screen [n]\n",
  "SOMATA": "SOMA, (Greek) the whole axial portion of an animal, including the head, neck, trunk, and tail [n]\n",
  "SOMATIC": "of or pertaining to the body as a whole [adj SOMATICALLY]\n",
  "SOMATICALLY": "SOMATIC, of or pertaining to the body as a whole [adv]\n",
  "SOMATISM": "materialism [n -S]\n",
  "SOMATISMS": "SOMATISM, materialism [n]\n",
  "SOMATIST": "one who admits the existence of material beings only; a materialist [n -S]\n",
  "SOMATISTS": "SOMATIST, one who admits the existence of material beings only; a materialist [n]\n",
  "SOMATOGENIC": "caused from within the body or by the cells of the body [adj]\n",
  "SOMATOLOGIC": "relating to somatology, also SOMATOLOGICAL [adj SOMATOLOGICALLY]\n",
  "SOMATOLOGICAL": "relating to somatology, also SOMATOLOGIC [adj SOMATOLOGICALLY]\n",
  "SOMATOLOGICALLY": "SOMATOLOGICAL, relating to somatology, also SOMATOLOGIC [adv]\n",
  "SOMATOLOGIES": "SOMATOLOGY, the science of the properties of matter [n]\n",
  "SOMATOLOGIST": "a specialist in somatology [n -S]\n",
  "SOMATOLOGISTS": "SOMATOLOGIST, a specialist in somatology [n]\n",
  "SOMATOLOGY": "the science of the properties of matter [n SOMATOLOGIES]\n",
  "SOMATOMEDIN": "an endogenous peptide pronounced in the liver [n -S]\n",
  "SOMATOMEDINS": "SOMATOMEDIN, an endogenous peptide pronounced in the liver [n]\n",
  "SOMATOPLASM": "protoplasm of the somatic cells [n -S]\n",
  "SOMATOPLASMS": "SOMATOPLASM, protoplasm of the somatic cells [n]\n",
  "SOMATOPLASTIC": "of or like somatoplasm, protoplasm of the somatic cells [adj]\n",
  "SOMATOPLEURAL": "of or like a somatopleure, also SOMATOPLEURIC [adj]\n",
  "SOMATOPLEURE": "a cellular sheet in some vertebrates that develops into the internal body wall [n -S]\n",
  "SOMATOPLEURES": "SOMATOPLEURE, a cellular sheet in some vertebrates that develops into the internal body wall [n]\n",
  "SOMATOPLEURIC": "of or like a somatopleure, also SOMATOPLEURAL [adj]\n",
  "SOMATOSENSORY": "of, relating to, or being sensory activity having its origin elsewhere than in the special sense organs (as eyes and ears) and conveying information about the state of the body proper and its immediate environment [adj]\n",
  "SOMATOSTATIN": "a polypeptide neurohormone [n -S]\n",
  "SOMATOSTATINS": "SOMATOSTATIN, a polypeptide neurohormone [n]\n",
  "SOMATOTENSIC": "that which restores the equilibrium of an organism (applied esp. to certain plants when eaten as food) [adj]\n",
  "SOMATOTONIA": "a pattern of temperament and body type in which alertness and aggression are combined with mesomorphic build [n -S]\n",
  "SOMATOTONIAS": "SOMATOTONIA, a pattern of temperament and body type in which alertness and aggression are combined with mesomorphic build [n]\n",
  "SOMATOTONIC": "a person who has an extroverted and aggressive personality type [n -S]\n",
  "SOMATOTONICS": "SOMATOTONIC, a person who has an extroverted and aggressive personality type [n]\n",
  "SOMATOTROPHIC": "promoting bodily growth, also SOMATOTROPIC [adj]\n",
  "SOMATOTROPHIN": "a polypeptide growth hormone, also SOMATOTROPIN, SOMATOTROPINE [n -S]\n",
  "SOMATOTROPHINS": "SOMATOTROPHIN, a polypeptide growth hormone, also SOMATOTROPIN, SOMATOTROPINE [n]\n",
  "SOMATOTROPIC": "promoting bodily growth, also SOMATOTROPHIC [adj]\n",
  "SOMATOTROPIN": "a polypeptide growth hormone, also SOMATOTROPHIN, SOMATOTROPINE [n -S]\n",
  "SOMATOTROPINE": "a growth hormone, also SOMATOTROPHIN, SOMATOTROPIN [n -S]\n",
  "SOMATOTROPINES": "SOMATOTROPINE, a growth hormone, also SOMATOTROPHIN, SOMATOTROPIN [n]\n",
  "SOMATOTROPINS": "SOMATOTROPIN, a polypeptide growth hormone, also SOMATOTROPHIN, SOMATOTROPINE [n]\n",
  "SOMATOTYPE": "a type consisting of a physical build paired with a particular temperament [n -S] / to place with regard to somatotype [v SOMATOTYPED, SOMATOTYPING, SOMATOTYPES]\n",
  "SOMATOTYPED": "SOMATOTYPE, to place with regard to somatotype [v]\n",
  "SOMATOTYPES": "SOMATOTYPE, to place with regard to somatotype [v]\n",
  "SOMATOTYPING": "SOMATOTYPE, to place with regard to somatotype [v]\n",
  "SOMBER": "(US) sombre [adj SOMBERER, SOMBEREST, SOMBERLY] / to make sombre [v -ED, -ING, -S]\n",
  "SOMBERED": "SOMBER, to make sombre [v]\n",
  "SOMBERER": "SOMBER, (US) sombre [adj]\n",
  "SOMBEREST": "SOMBER, (US) sombre [adj]\n",
  "SOMBERING": "SOMBER, to make sombre [v]\n",
  "SOMBERLY": "SOMBER, (US) sombre [adv]\n",
  "SOMBERNESS": "the state of being somber, also SOMBRENESS [n -ES]\n",
  "SOMBERNESSES": "SOMBERNESS, the state of being somber, also SOMBRENESS [n]\n",
  "SOMBERS": "SOMBER, to make sombre [v]\n",
  "SOMBRE": "gloomy, dark [adj SOMBRER, SOMBREST, SOMBRELY] / to make sombre [v SOMBRED, SOMBRING, SOMBRES]\n",
  "SOMBRED": "SOMBRE, to make sombre [v]\n",
  "SOMBRELY": "SOMBRE, gloomy, dark [adv]\n",
  "SOMBRENESS": "the state of being sombre, also SOMBERNESS [n -ES]\n",
  "SOMBRENESSES": "SOMBRENESS, the state of being sombre, also SOMBERNESS [n]\n",
  "SOMBRER": "SOMBRE, gloomy, dark [adj]\n",
  "SOMBRERITE": "rock-guano [n -S]\n",
  "SOMBRERITES": "SOMBRERITE, rock-guano [n]\n",
  "SOMBRERO": "(Spanish) a broad-brimmed hat [n -S]\n",
  "SOMBREROS": "SOMBRERO, (Spanish) a broad-brimmed hat [n]\n",
  "SOMBRES": "SOMBRE, to make sombre [v]\n",
  "SOMBREST": "SOMBRE, gloomy, dark [adj]\n",
  "SOMBRING": "SOMBRE, to make sombre [v]\n",
  "SOMBROUS": "gloomy; somber [adj]\n",
  "SOME": "being an unspecified number or part [adj]\n",
  "SOMEBODIES": "SOMEBODY, an important person [n]\n",
  "SOMEBODY": "an important person [n SOMEBODIES]\n",
  "SOMEDAY": "at some future time [adv]\n",
  "SOMEDEAL": "(archaic) a large part of something, also SOMEDELE [n -S]\n",
  "SOMEDEALS": "SOMEDEAL, (archaic) a large part of something, also SOMEDELE [n]\n",
  "SOMEDELE": "(archaic) somewhat, also SOMEDEAL [adv]\n",
  "SOMEGATE": "(Scots) somewhere [adv]\n",
  "SOMEHOW": "by some means [adv]\n",
  "SOMEONE": "a somebody [n -S]\n",
  "SOMEONES": "SOMEONE, a somebody [n]\n",
  "SOMEPLACE": "somewhere [n -S]\n",
  "SOMEPLACES": "SOMEPLACE, somewhere [n]\n",
  "SOMERSAULT": "a leap in which a person turns his heels over his head and lights upon his feet [n -S] / to perform a somersault, also SOMERSET, SUMMERSAULT, SUMMERSET [v -ED, -ING, -S]\n",
  "SOMERSAULTED": "SOMERSAULT, to perform a somersault, also SOMERSET, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMERSAULTING": "SOMERSAULT, to perform a somersault, also SOMERSET, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMERSAULTS": "SOMERSAULT, a leap in which a person turns his heels over his head and lights upon his feet [n]\n",
  "SOMERSET": "to make a leap in which a person turns his heels over his head and lights upon his fee, also SOMERSAULT, SUMMERSAULT, SUMMERSET [v SOMERSETED or SOMERSETTED, SOMERSETING or SOMERSETTING, SOMERSETS]\n",
  "SOMERSETED": "SOMERSET, to make a leap in which a person turns his heels over his head and lights upon his fee, also SOMERSAULT, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMERSETING": "SOMERSET, to make a leap in which a person turns his heels over his head and lights upon his fee, also SOMERSAULT, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMERSETS": "SOMERSET, to make a leap in which a person turns his heels over his head and lights upon his fee, also SOMERSAULT, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMERSETTED": "SOMERSET, to make a leap in which a person turns his heels over his head and lights upon his fee, also SOMERSAULT, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMERSETTING": "SOMERSET, to make a leap in which a person turns his heels over his head and lights upon his fee, also SOMERSAULT, SUMMERSAULT, SUMMERSET [v]\n",
  "SOMESTHESIA": "sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIA, SOMAESTHESIS, SOMESTHESIS [n -S]\n",
  "SOMESTHESIAS": "SOMESTHESIA, sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIA, SOMAESTHESIS, SOMESTHESIS [n]\n",
  "SOMESTHESIS": "sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIA, SOMAESTHESIS, SOMESTHESIA [n SOMESTHESISES]\n",
  "SOMESTHESISES": "SOMESTHESIS, sensory perception of bodily feelings like touch, pain, position of the limbs, etc., also SOMAESTHESIA, SOMAESTHESIS, SOMESTHESIA [n]\n",
  "SOMESTHETIC": "relating to somesthesia [adj]\n",
  "SOMETHING": "an undefined thing [n -S]\n",
  "SOMETHINGS": "SOMETHING, an undefined thing [n]\n",
  "SOMETIME": "at some future time [adv]\n",
  "SOMETIMES": "happening from time to time [adv]\n",
  "SOMEWAY": "in some way, somehow, also SOMEWAYS, SOMEWISE [adv]\n",
  "SOMEWAYS": "in some way, somehow, also SOMEWAY, SOMEWISE [adv]\n",
  "SOMEWHAT": "an unspecified number or part [n -S]\n",
  "SOMEWHATS": "SOMEWHAT, an unspecified number or part [n]\n",
  "SOMEWHEN": "at some indefinite time [adv]\n",
  "SOMEWHENCE": "from some place or other [adv]\n",
  "SOMEWHERE": "in or to some place [n -S]\n",
  "SOMEWHERES": "SOMEWHERE, in or to some place [n]\n",
  "SOMEWHILE": "at or in some former time; erewhile [adv]\n",
  "SOMEWHILES": "sometimes [adv]\n",
  "SOMEWHITHER": "(archaic) to some place; somewhere [adv]\n",
  "SOMEWHY": "for some reason [adv]\n",
  "SOMEWISE": "in some way, somehow, also SOMEWAY, SOMEWAYS [adv]\n",
  "SOMITAL": "relating to a somite, the body segment of a vertebrate embryo, also SOMITIC [adj]\n",
  "SOMITE": "a body segment of some animals [n -S]\n",
  "SOMITES": "SOMITE, a body segment of some animals [n]\n",
  "SOMITIC": "relating to a somite, the body segment of a vertebrate embryo, also SOMITAL [adj]\n",
  "SOMMELIER": "(French) a wine steward in a restaurant [n -S]\n",
  "SOMMELIERS": "SOMMELIER, (French) a wine steward in a restaurant [n]\n",
  "SOMNAMBULANCE": "sleepwalking [n -S]\n",
  "SOMNAMBULANCES": "SOMNAMBULANCE, sleepwalking [n]\n",
  "SOMNAMBULANT": "having the habit of walking while asleep [adj] / a sleepwalker [n -S]\n",
  "SOMNAMBULANTS": "SOMNAMBULANT, a sleepwalker [n]\n",
  "SOMNAMBULAR": "relating to somnambulation, sleepwalking, also SOMNAMBULARY [adj]\n",
  "SOMNAMBULARY": "relating to somnambulation, sleepwalking, also SOMNAMBULAR [adj]\n",
  "SOMNAMBULATE": "to walk when asleep [v SOMNAMBULATED, SOMNAMBULATING, SOMNAMBULATES]\n",
  "SOMNAMBULATED": "SOMNAMBULATE, to walk when asleep [v]\n",
  "SOMNAMBULATES": "SOMNAMBULATE, to walk when asleep [v]\n",
  "SOMNAMBULATING": "SOMNAMBULATE, to walk when asleep [v]\n",
  "SOMNAMBULATION": "sleepwalking [n -S]\n",
  "SOMNAMBULATIONS": "SOMNAMBULATION, sleepwalking [n]\n",
  "SOMNAMBULATOR": "a sleepwalker [n -S]\n",
  "SOMNAMBULATORS": "SOMNAMBULATOR, a sleepwalker [n]\n",
  "SOMNAMBULE": "a sleepwalker, also SOMNAMBULIST [n -S]\n",
  "SOMNAMBULES": "SOMNAMBULE, a sleepwalker, also SOMNAMBULIST [n]\n",
  "SOMNAMBULIC": "like a somnambule, a sleepwalker [adj]\n",
  "SOMNAMBULISM": "an abnormal condition of sleep in which motor acts, such as walking, are performed [n -S]\n",
  "SOMNAMBULISMS": "SOMNAMBULISM, an abnormal condition of sleep in which motor acts, such as walking, are performed [n]\n",
  "SOMNAMBULIST": "a sleepwalker, also SOMNAMBULE [n -S]\n",
  "SOMNAMBULISTIC": "relating to somnambulism [adj]\n",
  "SOMNAMBULISTS": "SOMNAMBULIST, a sleepwalker, also SOMNAMBULE [n]\n",
  "SOMNIAL": "pertaining to dreams [adj]\n",
  "SOMNIATE": "to dream [v SOMNIATED, SOMNIATING, SOMNIATES]\n",
  "SOMNIATED": "SOMNIATE, to dream [v]\n",
  "SOMNIATES": "SOMNIATE, to dream [v]\n",
  "SOMNIATING": "SOMNIATE, to dream [v]\n",
  "SOMNIATIVE": "pertaining to sleep or dreams, also SOMNIATORY [adj]\n",
  "SOMNIATORY": "pertaining to sleep or dreams, also SOMNIATIVE [adj]\n",
  "SOMNIFACIENT": "a substance inducing sleep [n -S]\n",
  "SOMNIFACIENTS": "SOMNIFACIENT, a substance inducing sleep [n]\n",
  "SOMNIFEROUS": "causing sleep [adj SOMNIFEROUSLY]\n",
  "SOMNIFEROUSLY": "SOMNIFEROUS, causing sleep [adv]\n",
  "SOMNIFIC": "sleep inducing [adj]\n",
  "SOMNILOQUENCE": "talking in one's sleep [n -S]\n",
  "SOMNILOQUENCES": "SOMNILOQUENCE, talking in one's sleep [n]\n",
  "SOMNILOQUIES": "SOMNILOQUY, the act or habit of talking while asleep [n]\n",
  "SOMNILOQUISE": "to talk in one's sleep, also SOMNILOQUIZE [v SOMNILOQUISED, SOMNILOQUISING, SOMNILOQUISES]\n",
  "SOMNILOQUISED": "SOMNILOQUISE, to talk in one's sleep, also SOMNILOQUIZE [v]\n",
  "SOMNILOQUISES": "SOMNILOQUISE, to talk in one's sleep, also SOMNILOQUIZE [v]\n",
  "SOMNILOQUISING": "SOMNILOQUISE, to talk in one's sleep, also SOMNILOQUIZE [v]\n",
  "SOMNILOQUISM": "talking in one's sleep [n -S]\n",
  "SOMNILOQUISMS": "SOMNILOQUISM, talking in one's sleep [n]\n",
  "SOMNILOQUIST": "one who talks in his sleep [n -S]\n",
  "SOMNILOQUISTS": "SOMNILOQUIST, one who talks in his sleep [n]\n",
  "SOMNILOQUIZE": "to talk in one's sleep, also SOMNILOQUISE [v SOMNILOQUIZED, SOMNILOQUIZING, SOMNILOQUIZES]\n",
  "SOMNILOQUIZED": "SOMNILOQUIZE, to talk in one's sleep, also SOMNILOQUISE [v]\n",
  "SOMNILOQUIZES": "SOMNILOQUIZE, to talk in one's sleep, also SOMNILOQUISE [v]\n",
  "SOMNILOQUIZING": "SOMNILOQUIZE, to talk in one's sleep, also SOMNILOQUISE [v]\n",
  "SOMNILOQUOUS": "talking in one's sleep [adj]\n",
  "SOMNILOQUY": "the act or habit of talking while asleep [n SOMNILOQUIES]\n",
  "SOMNOLENCE": "sleepiness, also SOMNOLENCY [n -S]\n",
  "SOMNOLENCES": "SOMNOLENCE, sleepiness, also SOMNOLENCY [n]\n",
  "SOMNOLENCIES": "SOMNOLENCY, sleepiness, also SOMNOLENCE [n]\n",
  "SOMNOLENCY": "sleepiness, also SOMNOLENCE [n SOMNOLENCIES]\n",
  "SOMNOLENT": "sleepy; causing, or resembling, sleep [adj SOMNOLENTLY]\n",
  "SOMNOLENTLY": "SOMNOLENT, sleepy; causing, or resembling, sleep [adv]\n",
  "SOMNOLESCENT": "becoming sleepy [adj]\n",
  "SOMONI": "the standard monetary unit of Tajikistan [n -S]\n",
  "SOMONIS": "SOMONI, the standard monetary unit of Tajikistan [n]\n",
  "SOMS": "SOM, a monetary unit of Kyrgyzstan [n]\n",
  "SOMY": "SOM, a monetary unit of Kyrgyzstan [n]\n",
  "SON": "a male offspring [n -S]\n",
  "SONANCE": "a sounding, also SONANCY [n -S]\n",
  "SONANCES": "SONANCE, a sounding, also SONANCY [n]\n",
  "SONANCIES": "SONANCY, the quality of being sonant, also SONANCE [n]\n",
  "SONANCY": "the quality of being sonant, also SONANCE [n SONANCIES]\n",
  "SONANT": "a sound made by vibration of the vocal chords [n -S]\n",
  "SONANTAL": "of a sound, uttered with vibration of the vocal chords, also SONANTIC [adj]\n",
  "SONANTIC": "of a sound, uttered with vibration of the vocal chords, also SONANTAL [adj]\n",
  "SONANTS": "SONANT, a sound made by vibration of the vocal chords [n]\n",
  "SONAR": "an underwater locating device [n -S]\n",
  "SONARMAN": "a man who operates sonar equipment [n SONARMEN]\n",
  "SONARMEN": "SONARMAN, a man who operates sonar equipment [n]\n",
  "SONARS": "SONAR, an underwater locating device [n]\n",
  "SONATA": "(Italian) a musical composition, usually of three or more movements, designed chiefly for a solo instrument [n -S]\n",
  "SONATAS": "SONATA, (Italian) a musical composition, usually of three or more movements, designed chiefly for a solo instrument [n]\n",
  "SONATINA": "(Italian) a short and simple sonata [n SONATINAS or SONATINE]\n",
  "SONATINAS": "SONATINA, (Italian) a short and simple sonata [n]\n",
  "SONATINE": "SONATINA, (Italian) a short and simple sonata [n]\n",
  "SONCE": "(Scots) good luck, abundance, also SONSE [n -S]\n",
  "SONCES": "SONCE, (Scots) good luck, abundance, also SONSE [n]\n",
  "SONDAGE": "(French) a trial bore or excavation; a sounding out of opinion [n -S]\n",
  "SONDAGES": "SONDAGE, (French) a trial bore or excavation; a sounding out of opinion [n]\n",
  "SONDE": "(French) an instrument probe for transmitting information about its surroundings underground or under water [n -S]\n",
  "SONDELI": "the Indian musk shrew [n -S]\n",
  "SONDELIS": "SONDELI, the Indian musk shrew [n]\n",
  "SONDER": "a class of small yachts [n -S]\n",
  "SONDERS": "SONDER, a class of small yachts [n]\n",
  "SONDES": "SONDE, (French) an instrument probe for transmitting information about its surroundings underground or under water [n]\n",
  "SONE": "a unit of loudness on a scale based on subjective or perceived loudness [n -S]\n",
  "SONERI": "(Hindi) a cloth of gold [n -S]\n",
  "SONERIS": "SONERI, (Hindi) a cloth of gold [n]\n",
  "SONES": "SONE, a unit of loudness on a scale based on subjective or perceived loudness [n]\n",
  "SONG": "a musical composition written for singing [n -S]\n",
  "SONGBIRD": "a bird that utters a musical call [n -S]\n",
  "SONGBIRDS": "SONGBIRD, a bird that utters a musical call [n]\n",
  "SONGBOOK": "a book of songs [n -S]\n",
  "SONGBOOKS": "SONGBOOK, a book of songs [n]\n",
  "SONGCRAFT": "the art of making songs or verse [n -S]\n",
  "SONGCRAFTS": "SONGCRAFT, the art of making songs or verse [n]\n",
  "SONGFEST": "a gathering for singing songs [n -S]\n",
  "SONGFESTS": "SONGFEST, a gathering for singing songs [n]\n",
  "SONGFUL": "disposed to sing; full of song [adj SONGFULLY]\n",
  "SONGFULLY": "SONGFUL, disposed to sing; full of song [adv]\n",
  "SONGFULNESS": "the state of being songful [n -ES]\n",
  "SONGFULNESSES": "SONGFULNESS, the state of being songful [n]\n",
  "SONGKOK": "(Malay) an oval brimless hat [n -S]\n",
  "SONGKOKS": "SONGKOK, (Malay) an oval brimless hat [n]\n",
  "SONGLESS": "without songs [adj SONGLESSLY]\n",
  "SONGLESSLY": "SONGLESS, without songs [adv]\n",
  "SONGLIKE": "like a song [adj]\n",
  "SONGMAN": "(Shakespeare) a singer, a member of a choir [n SONGMEN]\n",
  "SONGMEN": "SONGMAN, (Shakespeare) a singer, a member of a choir [n]\n",
  "SONGOLOLO": "(Nguni) a kind of millipede, having a hard shiny dark brown segmented exoskeleton, also SHONGOLOLO [n -S]\n",
  "SONGOLOLOS": "SONGOLOLO, (Nguni) a kind of millipede, having a hard shiny dark brown segmented exoskeleton, also SHONGOLOLO [n]\n",
  "SONGS": "SONG, a musical composition written for singing [n]\n",
  "SONGSHEET": "a piece of paper with the words to one or more songs on it [n -S]\n",
  "SONGSHEETS": "SONGSHEET, a piece of paper with the words to one or more songs on it [n]\n",
  "SONGSMITH": "a composer of songs [n -S]\n",
  "SONGSMITHS": "SONGSMITH, a composer of songs [n]\n",
  "SONGSTER": "a singing bird [n -S]\n",
  "SONGSTERS": "SONGSTER, a singing bird [n]\n",
  "SONGSTRESS": "a woman who sings; a female singing bird [n -ES]\n",
  "SONGSTRESSES": "SONGSTRESS, a woman who sings; a female singing bird [n]\n",
  "SONGWRITER": "a person who composes words or music or both esp. for popular songs [n -S]\n",
  "SONGWRITERS": "SONGWRITER, a person who composes words or music or both esp. for popular songs [n]\n",
  "SONGWRITING": "the activities of a songwriter [n -S]\n",
  "SONGWRITINGS": "SONGWRITING, the activities of a songwriter [n]\n",
  "SONHOOD": "the state of being a son, also SONSHIP [n -S]\n",
  "SONHOODS": "SONHOOD, the state of being a son, also SONSHIP [n]\n",
  "SONIC": "pertaining to sound [adj SONICALLY]\n",
  "SONICALLY": "SONIC, pertaining to sound [adv]\n",
  "SONICATE": "to disrupt with sound waves [v SONICATED, SONICATING, SONICATES]\n",
  "SONICATED": "SONICATE, to disrupt with sound waves [v]\n",
  "SONICATES": "SONICATE, to disrupt with sound waves [v]\n",
  "SONICATING": "SONICATE, to disrupt with sound waves [v]\n",
  "SONICATION": "the disruption of bacteria by treating them with high-frequency sound waves [n -S]\n",
  "SONICATIONS": "SONICATION, the disruption of bacteria by treating them with high-frequency sound waves [n]\n",
  "SONICATOR": "a device that sonicates [n -S]\n",
  "SONICATORS": "SONICATOR, a device that sonicates [n]\n",
  "SONICS": "the study of technological application of sounds [n]\n",
  "SONIFEROUS": "carrying or producing sound [adj]\n",
  "SONLESS": "without a son [adj]\n",
  "SONLIER": "SONLY, pertaining to a son [adj]\n",
  "SONLIEST": "SONLY, pertaining to a son [adj]\n",
  "SONLIKE": "like a son [adj]\n",
  "SONLY": "pertaining to a son [adj SONLIER, SONLIEST]\n",
  "SONNE": "(obsolete) sun or son [n -S]\n",
  "SONNES": "SONNE, (obsolete) sun or son [n]\n",
  "SONNET": "to compose a type of poem [v SONNETED or SONNETTED, SONNETING or SONNETTING, SONNETS]\n",
  "SONNETARY": "of or like a sonnet [adj]\n",
  "SONNETED": "SONNET, to compose a type of poem [v]\n",
  "SONNETEER": "a writer of sonnets, a poetaster [n -S]\n",
  "SONNETEERING": "the composition of sonnets [n -S]\n",
  "SONNETEERINGS": "SONNETEERING, the composition of sonnets [n]\n",
  "SONNETEERS": "SONNETEER, a writer of sonnets, a poetaster [n]\n",
  "SONNETING": "SONNET, to compose a type of poem [v]\n",
  "SONNETISE": "to compose sonnets, also SONNETIZE [v SONNETISED, SONNETISING, SONNETISES]\n",
  "SONNETISED": "SONNETISE, to compose sonnets, also SONNETIZE [v]\n",
  "SONNETISES": "SONNETISE, to compose sonnets, also SONNETIZE [v]\n",
  "SONNETISING": "SONNETISE, to compose sonnets, also SONNETIZE [v]\n",
  "SONNETIZE": "to compose sonnets, also SONNETISE [v SONNETIZED, SONNETIZING, SONNETIZES]\n",
  "SONNETIZED": "SONNETIZE, to compose sonnets, also SONNETISE [v]\n",
  "SONNETIZES": "SONNETIZE, to compose sonnets, also SONNETISE [v]\n",
  "SONNETIZING": "SONNETIZE, to compose sonnets, also SONNETISE [v]\n",
  "SONNETS": "SONNET, to compose a type of poem [v]\n",
  "SONNETTED": "SONNET, to compose a type of poem [v]\n",
  "SONNETTING": "SONNET, to compose a type of poem [v]\n",
  "SONNIES": "SONNY, (colloquial) a son [n]\n",
  "SONNY": "(colloquial) a son [n SONNIES]\n",
  "SONOBUOY": "a buoy that detects and transmits underwater sounds [n -S]\n",
  "SONOBUOYS": "SONOBUOY, a buoy that detects and transmits underwater sounds [n]\n",
  "SONOFABITCH": "an abusive term of address or of description, also SUMBITCH [n]\n",
  "SONOGRAM": "an image produced by ultrasound [n -S]\n",
  "SONOGRAMS": "SONOGRAM, an image produced by ultrasound [n]\n",
  "SONOGRAPH": "an instrument for recording and analysing sound [n -S]\n",
  "SONOGRAPHER": "one who uses a sonograph, an instrument for recording and analysing sound [n -S]\n",
  "SONOGRAPHERS": "SONOGRAPHER, one who uses a sonograph, an instrument for recording and analysing sound [n]\n",
  "SONOGRAPHIES": "SONOGRAPHY, the use of ultrasound [n]\n",
  "SONOGRAPHS": "SONOGRAPH, an instrument for recording and analysing sound [n]\n",
  "SONOGRAPHY": "the use of ultrasound [n SONOGRAPHIES]\n",
  "SONOMETER": "a musical instrument having only one string, aka monochord [n -S]\n",
  "SONOMETERS": "SONOMETER, a musical instrument having only one string, aka monochord [n]\n",
  "SONORANT": "a voiced consonant regarded as a syllabic sound, e.g. the n in sudden [n -S]\n",
  "SONORANTS": "SONORANT, a voiced consonant regarded as a syllabic sound, e.g. the n in sudden [n]\n",
  "SONORITIES": "SONORITY, the quality of being sonorous [n]\n",
  "SONORITY": "the quality of being sonorous [n SONORITIES]\n",
  "SONOROUS": "characterized by a full and loud sound [adj SONOROUSLY]\n",
  "SONOROUSLY": "SONOROUS, characterized by a full and loud sound [adv]\n",
  "SONOROUSNESS": "the state of being sonorous [n -ES]\n",
  "SONOROUSNESSES": "SONOROUSNESS, the state of being sonorous [n]\n",
  "SONOVOX": "a sound effects device [n -ES]\n",
  "SONOVOXES": "SONOVOX, a sound effects device [n]\n",
  "SONS": "SON, a male offspring [n]\n",
  "SONSE": "(Scots) good luck, abundance, also SONCE [n -S]\n",
  "SONSES": "SONSE, (Scots) good luck, abundance, also SONCE [n]\n",
  "SONSHIP": "the state of being a son, also SONHOOD [n -S]\n",
  "SONSHIPS": "SONSHIP, the state of being a son, also SONHOOD [n]\n",
  "SONSIE": "buxom, comely, also SONSY [adj SONSIER, SONSIEST]\n",
  "SONSIER": "SONSIE, buxom, comely, also SONSY [adj]\n",
  "SONSIEST": "SONSIE, buxom, comely, also SONSY [adj]\n",
  "SONSY": "buxom, comely, also SONSIE [adj SONSIER, SONSIEST]\n",
  "SONTAG": "(German) a woman's knitted cape, tied round the waist [n -S]\n",
  "SONTAGS": "SONTAG, (German) a woman's knitted cape, tied round the waist [n]\n",
  "SONTIES": "a mild oath, sanctities [interj]\n",
  "SOOCHONG": "(Chinese) a kind of black tea of a fine quality, also SOUCHONG [n -S]\n",
  "SOOCHONGS": "SOOCHONG, (Chinese) a kind of black tea of a fine quality, also SOUCHONG [n]\n",
  "SOOEY": "used for calling pigs [interj]\n",
  "SOOGEE": "to clean a ship's deck with a solution of soap, soda etc., also SOOGIE, SOOJEY, SUJEE [v SOOGEED, SOOGEEING, SOOGEES]\n",
  "SOOGEED": "SOOGEE, to clean a ship's deck with a solution of soap, soda etc., also SOOGIE, SOOJEY, SUJEE [v]\n",
  "SOOGEEING": "SOOGEE, to clean a ship's deck with a solution of soap, soda etc., also SOOGIE, SOOJEY, SUJEE [v]\n",
  "SOOGEES": "SOOGEE, to clean a ship's deck with a solution of soap, soda etc., also SOOGIE, SOOJEY, SUJEE [v]\n",
  "SOOGIE": "to clean a ship's deck with a solution of soap, soda etc., also SOOGEE, SOOJEY, SUJEE [v SOOGIED, SOOGIEING, SOOGIES]\n",
  "SOOGIED": "SOOGIE, to clean a ship's deck with a solution of soap, soda etc., also SOOGEE, SOOJEY, SUJEE [v]\n",
  "SOOGIEING": "SOOGIE, to clean a ship's deck with a solution of soap, soda etc., also SOOGEE, SOOJEY, SUJEE [v]\n",
  "SOOGIES": "SOOGIE, to clean a ship's deck with a solution of soap, soda etc., also SOOGEE, SOOJEY, SUJEE [v]\n",
  "SOOJEY": "a solution of soap, soda etc. for cleaning the deck of a ship, also SOOGEE, SOOGIE, SUJEE [n -S]\n",
  "SOOJEYS": "SOOJEY, a solution of soap, soda etc. for cleaning the deck of a ship, also SOOGEE, SOOGIE, SUJEE [n]\n",
  "SOOK": "(Scots) to suck, also SOUK [v -ED, -ING, -S]\n",
  "SOOKED": "SOOK, (Scots) to suck, also SOUK [v]\n",
  "SOOKIER": "SOOKY, (Australian slang) given to petulant complaining [adj]\n",
  "SOOKIEST": "SOOKY, (Australian slang) given to petulant complaining [adj]\n",
  "SOOKING": "SOOK, (Scots) to suck, also SOUK [v]\n",
  "SOOKS": "SOOK, (Scots) to suck, also SOUK [v]\n",
  "SOOKY": "(Australian slang) given to petulant complaining [adj SOOKIER, SOOKIEST]\n",
  "SOOL": "to incite (a dog) to attack [v -ED, -ING, -S]\n",
  "SOOLE": "(Scots) to pull by the ears, also SOWL, SOWLE [v SOOLED, SOOLING, SOOLES]\n",
  "SOOLED": "SOOL, to incite (a dog) to attack [v]\n",
  "SOOLER": "one who sools, incites a dog to attack [n -S]\n",
  "SOOLERS": "SOOLER, one who sools, incites a dog to attack [n]\n",
  "SOOLES": "SOOLE, (Scots) to pull by the ears, also SOWL, SOWLE [v]\n",
  "SOOLING": "SOOL, to incite (a dog) to attack [v]\n",
  "SOOLS": "SOOL, to incite (a dog) to attack [v]\n",
  "SOOM": "(Scots) to swim [v -ED, -ING, -S]\n",
  "SOOMED": "SOOM, (Scots) to swim [v]\n",
  "SOOMING": "SOOM, (Scots) to swim [v]\n",
  "SOOMS": "SOOM, (Scots) to swim [v]\n",
  "SOON": "in the near future [adv SOONER, SOONEST]\n",
  "SOONER": "one who settles on government prematurely [n -S]\n",
  "SOONERS": "SOONER, one who settles on government prematurely [n]\n",
  "SOONEST": "SOON, in the near future [adv]\n",
  "SOONISH": "somewhat soon [adj]\n",
  "SOOP": "(Scots) to sweep [v -ED, -ING, -S]\n",
  "SOOPED": "SOOP, (Scots) to sweep [v]\n",
  "SOOPING": "the act of sweeping [n -S]\n",
  "SOOPINGS": "SOOPING, the act of sweeping [n]\n",
  "SOOPS": "SOOP, (Scots) to sweep [v]\n",
  "SOOPSTAKE": "(Shakespeare) with a sweep of the stakes [adj]\n",
  "SOOT": "to cover with a residue of burning [v -ED, -ING, -S]\n",
  "SOOTE": "(obsolete) a sweet [n -S]\n",
  "SOOTED": "SOOT, to cover with a residue of burning [v]\n",
  "SOOTERKIN": "(Dutch) a kind of false birth, fabled to be produced by Dutch women from sitting over their stoves [n -S]\n",
  "SOOTERKINS": "SOOTERKIN, (Dutch) a kind of false birth, fabled to be produced by Dutch women from sitting over their stoves [n]\n",
  "SOOTES": "SOOTE, (obsolete) a sweet [n]\n",
  "SOOTFLAKE": "a smut of soot [n -S]\n",
  "SOOTFLAKES": "SOOTFLAKE, a smut of soot [n]\n",
  "SOOTH": "true, real, also SOTH [adj SOOTHLY] / the truth [n -S]\n",
  "SOOTHE": "to calm, or comfort [v SOOTHED, SOOTHING, SOOTHES]\n",
  "SOOTHED": "SOOTHE, to calm, or comfort [v]\n",
  "SOOTHER": "to cajole, flatter; to soothe, calm [v -ED, -ING, -S]\n",
  "SOOTHERED": "SOOTHER, to cajole, flatter; to soothe, calm [v]\n",
  "SOOTHERING": "SOOTHER, to cajole, flatter; to soothe, calm [v]\n",
  "SOOTHERS": "SOOTHER, to cajole, flatter; to soothe, calm [v]\n",
  "SOOTHES": "SOOTHE, to calm, or comfort [v]\n",
  "SOOTHEST": "SOOTH, true, real, also SOTH [adj]\n",
  "SOOTHFAST": "(archaic) truthful, honest [adj SOOTHFASTLY]\n",
  "SOOTHFASTLY": "SOOTHFAST, (archaic) truthful, honest [adv]\n",
  "SOOTHFASTNESS": "the state of being soothfast [n -ES]\n",
  "SOOTHFASTNESSES": "SOOTHFASTNESS, the state of being soothfast [n]\n",
  "SOOTHFUL": "truthful, faithful [adj]\n",
  "SOOTHING": "reassuring, calming [adj SOOTHINGLY] / the act of soothing [n -S]\n",
  "SOOTHINGLY": "SOOTHING, reassuring, calming [adv]\n",
  "SOOTHINGNESS": "the state of being soothing [n -ES]\n",
  "SOOTHINGNESSES": "SOOTHINGNESS, the state of being soothing [n]\n",
  "SOOTHINGS": "SOOTHING, the act of soothing [n]\n",
  "SOOTHLICH": "(Spenser) truly, indeed, also SOOTHLY [adv]\n",
  "SOOTHLY": "(Spenser) truly, indeed, also SOOTHLICH [adv]\n",
  "SOOTHS": "SOOTH, the truth [n]\n",
  "SOOTHSAID": "SOOTHSAY, to foretell, to divine, also SOUTHSAY [v]\n",
  "SOOTHSAY": "to foretell, to divine, also SOUTHSAY [v SOOTHSAID, SOOTHSAYING, SOOTHSAYS]\n",
  "SOOTHSAYER": "a person who predicts the future by magical, intuitive, or more rational means [n -S]\n",
  "SOOTHSAYERS": "SOOTHSAYER, a person who predicts the future by magical, intuitive, or more rational means [n]\n",
  "SOOTHSAYING": "the act of divining [n -S]\n",
  "SOOTHSAYINGS": "SOOTHSAYING, the act of divining [n]\n",
  "SOOTHSAYS": "SOOTHSAY, to foretell, to divine, also SOUTHSAY [v]\n",
  "SOOTIER": "SOOTY, covered with soot [adj]\n",
  "SOOTIEST": "SOOTY, covered with soot [adj]\n",
  "SOOTILY": "SOOTY, covered with soot [adv]\n",
  "SOOTINESS": "the state of being sooty [n -ES]\n",
  "SOOTINESSES": "SOOTINESS, the state of being sooty [n]\n",
  "SOOTING": "the act of covering with soot [n -S]\n",
  "SOOTINGS": "SOOTING, the act of covering with soot [n]\n",
  "SOOTLESS": "without soot [adj]\n",
  "SOOTS": "SOOT, to cover with a residue of burning [v]\n",
  "SOOTY": "covered with soot [adj SOOTIER, SOOTIEST, SOOTILY]\n",
  "SOP": "to dip or soak in a liquid [v SOPPED, SOPPING, SOPS]\n",
  "SOPAIPILLA": "a square of deep-fried dough often sweetened and eaten as dessert, also SOPAPILLA [n -S]\n",
  "SOPAIPILLAS": "SOPAIPILLA, a square of deep-fried dough often sweetened and eaten as dessert, also SOPAPILLA [n]\n",
  "SOPAPILLA": "a square of deep-fried dough often sweetened and eaten as dessert, also SOPAIPILLA [n -S]\n",
  "SOPAPILLAS": "SOPAPILLA, a square of deep-fried dough often sweetened and eaten as dessert, also SOPAIPILLA [n]\n",
  "SOPH": "(short for) a sophomore, one belonging to the second of the four classes in an American college [n -S]\n",
  "SOPHERIC": "(Hebrew) relating to the sopherim, Jewish scribes [adj]\n",
  "SOPHERIM": "(Hebrew) the scribes, the expounders of Jewish oral law [n]\n",
  "SOPHIES": "SOPHY, (Arabic) a ruler of Persia [n]\n",
  "SOPHISM": "a plausible, deceptive fallacy [n -S]\n",
  "SOPHISMS": "SOPHISM, a plausible, deceptive fallacy [n]\n",
  "SOPHIST": "a person who uses deceptive reasoning to win debates, also SOPHISTER [n -S]\n",
  "SOPHISTER": "a person who uses deceptive reasoning to win debates, also SOPHIST [n -S]\n",
  "SOPHISTERS": "SOPHISTER, a person who uses deceptive reasoning to win debates, also SOPHIST [n]\n",
  "SOPHISTIC": "relating to sophistry, also SOPHISTICAL [adj SOPHISTICALLY]\n",
  "SOPHISTICAL": "relating to sophistry, also SOPHISTIC [adj SOPHISTICALLY]\n",
  "SOPHISTICALLY": "SOPHISTICAL, relating to sophistry, also SOPHISTIC [adv]\n",
  "SOPHISTICATE": "to make artificial or worldly [v SOPHISTICATED, SOPHISTICATING, SOPHISTICATES]\n",
  "SOPHISTICATED": "SOPHISTICATE, to make artificial or worldly [v]\n",
  "SOPHISTICATEDLY": "SOPHISTICATED, SOPHISTICATE, to make artificial or worldly [adv]\n",
  "SOPHISTICATES": "SOPHISTICATE, to make artificial or worldly [v]\n",
  "SOPHISTICATING": "SOPHISTICATE, to make artificial or worldly [v]\n",
  "SOPHISTICATION": "the use of sophistry [n -S]\n",
  "SOPHISTICATIONS": "SOPHISTICATION, the use of sophistry [n]\n",
  "SOPHISTICATOR": "one who sophisticates [n -S]\n",
  "SOPHISTICATORS": "SOPHISTICATOR, one who sophisticates [n]\n",
  "SOPHISTRIES": "SOPHISTRY, deceptively subtle reasoning or argumentation; an argument used to deceive [n]\n",
  "SOPHISTRY": "deceptively subtle reasoning or argumentation; an argument used to deceive [n SOPHISTRIES]\n",
  "SOPHISTS": "SOPHIST, a person who uses deceptive reasoning to win debates, also SOPHISTER [n]\n",
  "SOPHOMORE": "a second year student in an American college [n -S]\n",
  "SOPHOMORES": "SOPHOMORE, a second year student in an American college [n]\n",
  "SOPHOMORIC": "of or like a sophomore, also SOPHOMORICAL [adj]\n",
  "SOPHOMORICAL": "of or like a sophomore, also SOPHOMORIC [adj]\n",
  "SOPHS": "SOPH, (short for) a sophomore, one belonging to the second of the four classes in an American college [n]\n",
  "SOPHY": "(Arabic) a ruler of Persia [n SOPHIES]\n",
  "SOPITE": "to put to sleep [v SOPITED, SOPITING, SOPITES]\n",
  "SOPITED": "SOPITE, to put to sleep [v]\n",
  "SOPITES": "SOPITE, to put to sleep [v]\n",
  "SOPITING": "SOPITE, to put to sleep [v]\n",
  "SOPOR": "a profound sleep from which a person can be roused only with difficulty [n -S]\n",
  "SOPORIFEROUS": "causing or tending to cause sleep [adj SOPORIFEROUSLY]\n",
  "SOPORIFEROUSLY": "SOPORIFEROUS, causing or tending to cause sleep [adv]\n",
  "SOPORIFIC": "tending to produce sleep [adj SOPORIFICALLY] / a drug producing sleep [n -S]\n",
  "SOPORIFICALLY": "SOPORIFIC, tending to produce sleep [adv]\n",
  "SOPORIFICS": "SOPORIFIC, a drug producing sleep [n]\n",
  "SOPOROSE": "causing sleep; sleepy, also SOPOROUS [adj]\n",
  "SOPOROUS": "causing sleep; sleepy, also SOPOROSE [adj]\n",
  "SOPORS": "SOPOR, a profound sleep from which a person can be roused only with difficulty [n]\n",
  "SOPPED": "SOP, to dip or soak in a liquid [v]\n",
  "SOPPIER": "SOPPY, foolishly sentimental [adj]\n",
  "SOPPIEST": "SOPPY, foolishly sentimental [adj]\n",
  "SOPPILY": "SOPPY, foolishly sentimental [adv]\n",
  "SOPPINESS": "the state of being soppy [n -ES]\n",
  "SOPPINESSES": "SOPPINESS, the state of being soppy [n]\n",
  "SOPPING": "the act of soaking [n -S]\n",
  "SOPPINGS": "SOPPING, the act of soaking [n]\n",
  "SOPPY": "foolishly sentimental [adj SOPPIER, SOPPIEST, SOPPILY]\n",
  "SOPRA": "(Italian) above [adv]\n",
  "SOPRANI": "SOPRANO, (Italian) the highest singing voice [n]\n",
  "SOPRANINI": "SOPRANINO, (Italian) an instrument higher than the corresponding soprano [n]\n",
  "SOPRANINO": "(Italian) an instrument higher than the corresponding soprano [n SOPRANINI or SOPRANINOS]\n",
  "SOPRANINOS": "SOPRANINO, (Italian) an instrument higher than the corresponding soprano [n]\n",
  "SOPRANIST": "a treble singer [n -S]\n",
  "SOPRANISTS": "SOPRANIST, a treble singer [n]\n",
  "SOPRANO": "(Italian) the highest singing voice [n SOPRANOS or SOPRANI]\n",
  "SOPRANOS": "SOPRANO, (Italian) the highest singing voice [n]\n",
  "SOPS": "SOP, to dip or soak in a liquid [v]\n",
  "SORA": "(Native American) a North American bird of the rail family, also SOREE [n -S]\n",
  "SORAGE": "a hawk in its first year [n -S]\n",
  "SORAGES": "SORAGE, a hawk in its first year [n]\n",
  "SORAL": "pertaining to a sorus, a cluster of sporangia [adj]\n",
  "SORAS": "SORA, (Native American) a North American bird of the rail family, also SOREE [n]\n",
  "SORB": "to adsorb or adsorb another substance [v -ED, -ING, -S]\n",
  "SORBABILITIES": "SORBABILITY, the ability to be absorbed [n]\n",
  "SORBABILITY": "the ability to be absorbed [n SORBABILITIES]\n",
  "SORBABLE": "able to be absorbed [adj]\n",
  "SORBARIA": "a small deciduous shrub with clusters of white flowers [n -S]\n",
  "SORBARIAS": "SORBARIA, a small deciduous shrub with clusters of white flowers [n]\n",
  "SORBATE": "a salt of sorbic acid [n -S]\n",
  "SORBATES": "SORBATE, a salt of sorbic acid [n]\n",
  "SORBED": "SORB, to adsorb or adsorb another substance [v]\n",
  "SORBEFACIENT": "a substance promoting absorption [n -S]\n",
  "SORBEFACIENTS": "SORBEFACIENT, a substance promoting absorption [n]\n",
  "SORBENT": "a substance that sorbs [n -S]\n",
  "SORBENTS": "SORBENT, a substance that sorbs [n]\n",
  "SORBET": "a water-ice (originally an Eastern sherbet) [n -S]\n",
  "SORBETS": "SORBET, a water-ice (originally an Eastern sherbet) [n]\n",
  "SORBIC": "as in sorbic acid, an acid obtained from the rowanberry, used in food preservation [adj]\n",
  "SORBING": "SORB, to adsorb or adsorb another substance [v]\n",
  "SORBITAN": "a mixture of isomeric organic compounds derived from the dehydration of sorbitol [n -S]\n",
  "SORBITANS": "SORBITAN, a mixture of isomeric organic compounds derived from the dehydration of sorbitol [n]\n",
  "SORBITE": "a fine-grained constituent of steel formed of ferrite and cementite [n -S]\n",
  "SORBITES": "SORBITE, a fine-grained constituent of steel formed of ferrite and cementite [n]\n",
  "SORBITIC": "of or like sorbite, a constituent of steel [adj]\n",
  "SORBITISATION": "the process of sorbitising, also SORBITIZATION [n -S]\n",
  "SORBITISATIONS": "SORBITISATION, the process of sorbitising, also SORBITIZATION [n]\n",
  "SORBITISE": "to turn (a metal) into a form containing sorbite, also SORBITIZE [v SORBITISED, SORBITISING, SORBITISES]\n",
  "SORBITISED": "SORBITISE, to turn (a metal) into a form containing sorbite, also SORBITIZE [v]\n",
  "SORBITISES": "SORBITISE, to turn (a metal) into a form containing sorbite, also SORBITIZE [v]\n",
  "SORBITISING": "SORBITISE, to turn (a metal) into a form containing sorbite, also SORBITIZE [v]\n",
  "SORBITIZATION": "the process of sorbitizing, also SORBITISATION [n -S]\n",
  "SORBITIZATIONS": "SORBITIZATION, the process of sorbitizing, also SORBITISATION [n]\n",
  "SORBITIZE": "to turn (a metal) into a form containing sorbite, also SORBITISE [v SORBITIZED, SORBITIZING, SORBITIZES]\n",
  "SORBITIZED": "SORBITIZE, to turn (a metal) into a form containing sorbite, also SORBITISE [v]\n",
  "SORBITIZES": "SORBITIZE, to turn (a metal) into a form containing sorbite, also SORBITISE [v]\n",
  "SORBITIZING": "SORBITIZE, to turn (a metal) into a form containing sorbite, also SORBITISE [v]\n",
  "SORBITOL": "a white crystalline substance derived from (and used as a substitute for) sugar [n -S]\n",
  "SORBITOLS": "SORBITOL, a white crystalline substance derived from (and used as a substitute for) sugar [n]\n",
  "SORBO": "as in sorbo rubber, a spongy form of rubber [adj]\n",
  "SORBOSE": "a type of sugar [n -S]\n",
  "SORBOSES": "SORBOSE, a type of sugar [n]\n",
  "SORBS": "SORB, to adsorb or adsorb another substance [v]\n",
  "SORBUS": "(Latin) any plant of a large genus of deciduous trees, including the service tree and rowan [n -ES]\n",
  "SORBUSES": "SORBUS, (Latin) any plant of a large genus of deciduous trees, including the service tree and rowan [n]\n",
  "SORCERER": "a magician who employs sorcery, divination by the assistance of evil spirits [n -S]\n",
  "SORCERERS": "SORCERER, a magician who employs sorcery, divination by the assistance of evil spirits [n]\n",
  "SORCERESS": "a female sorcerer [n -ES]\n",
  "SORCERESSES": "SORCERESS, a female sorcerer [n]\n",
  "SORCERIES": "SORCERY, alleged use of supernatural powers [n]\n",
  "SORCEROUS": "having the nature of sorcery, divination by the assistance of evil spirits [adj]\n",
  "SORCERY": "alleged use of supernatural powers [n SORCERIES]\n",
  "SORD": "of mallard, to ascend in flight [v -ED, -ING, -S]\n",
  "SORDA": "(Italian) muted, damped, also SORDO [adj]\n",
  "SORDAMENTE": "(Italian) gently, softly [adv]\n",
  "SORDED": "SORD, of mallard, to ascend in flight [v]\n",
  "SORDES": "dark incrustations on the lips of fever patients [n]\n",
  "SORDID": "low, mean [adj SORDIDER, SORDIDEST, SORDIDLY]\n",
  "SORDIDER": "SORDID, low, mean [adj]\n",
  "SORDIDEST": "SORDID, low, mean [adj]\n",
  "SORDIDLY": "SORDID, low, mean [adv]\n",
  "SORDIDNESS": "the state of being sordid [n -ES]\n",
  "SORDIDNESSES": "SORDIDNESS, the state of being sordid [n]\n",
  "SORDINE": "a cone-shaped mute for a trumpet, also SORDINO, SOURDINE [n -S]\n",
  "SORDINES": "SORDINE, a cone-shaped mute for a trumpet, also SORDINO, SOURDINE [n]\n",
  "SORDING": "SORD, of mallard, to ascend in flight [v]\n",
  "SORDINI": "SORDINO, (Italian) a mute or damper, also SORDINE, SOURDINE [n]\n",
  "SORDINO": "(Italian) a mute or damper, also SORDINE, SOURDINE [n SORDINI]\n",
  "SORDO": "(Italian) muted, damped, also SORDA [adj]\n",
  "SORDOR": "(Latin) refuse, foul matter [n -S]\n",
  "SORDORS": "SORDOR, (Latin) refuse, foul matter [n]\n",
  "SORDS": "SORD, of mallard, to ascend in flight [v]\n",
  "SORE": "sensitive to pain [adj SORER, SOREST, SORELY] / to make sore [v SORED, SORING, SORES]\n",
  "SORED": "SORE, to make sore [v]\n",
  "SOREDIA": "SOREDIUM, (Greek) a reproductive body in lichens [n]\n",
  "SOREDIAL": "relating to a soredium, a small vegetative reproduction body in lichen [adj]\n",
  "SOREDIATE": "bearing soredia, small vegetative reproduction bodies in lichen [adj]\n",
  "SOREDIUM": "(Greek) a reproductive body in lichens [n SOREDIA]\n",
  "SOREE": "(Native American) a North American bird of the rail family, also SORA [n -S]\n",
  "SOREES": "SOREE, (Native American) a North American bird of the rail family, also SORA [n]\n",
  "SOREHEAD": "a person who is easily angered or offended [n -S]\n",
  "SOREHEADED": "irritable, grumpy [adj SOREHEADEDLY]\n",
  "SOREHEADEDLY": "SOREHEADED, irritable, grumpy [adv]\n",
  "SOREHEADEDNESS": "the state of being soreheaded [n]\n",
  "SOREHEADS": "SOREHEAD, a person who is easily angered or offended [n]\n",
  "SOREHON": "(Irish) an ancient Irish exaction of free accommodation by a lord of a tenant [n -S]\n",
  "SOREHONS": "SOREHON, (Irish) an ancient Irish exaction of free accommodation by a lord of a tenant [n]\n",
  "SOREL": "(Shakespeare) a buck in its third year, also SORELL [n -S]\n",
  "SORELL": "(Shakespeare) a buck in its third year, also SOREL [n -S]\n",
  "SORELLS": "SORELL, (Shakespeare) a buck in its third year, also SOREL [n]\n",
  "SORELS": "SOREL, (Shakespeare) a buck in its third year, also SORELL [n]\n",
  "SORELY": "SORE, sensitive to pain [adv]\n",
  "SORENESS": "the state of being sore [n -ES]\n",
  "SORENESSES": "SORENESS, the state of being sore [n]\n",
  "SORER": "SORE, sensitive to pain [adj]\n",
  "SORES": "SORE, to make sore [v]\n",
  "SOREST": "SORE, sensitive to pain [adj]\n",
  "SOREX": "(Latin) the common shrew [n -ES]\n",
  "SOREXES": "SOREX, (Latin) the common shrew [n]\n",
  "SORGHO": "(French) a variety of sorghum, also SORGO [n -S]\n",
  "SORGHOS": "SORGHO, (French) a variety of sorghum, also SORGO [n]\n",
  "SORGHUM": "a genus of grasses related to sugarcane, and including durra and Kaffir corn [n -S]\n",
  "SORGHUMS": "SORGHUM, a genus of grasses related to sugarcane, and including durra and Kaffir corn [n]\n",
  "SORGO": "(French) a variety of sorghum, also SORGHO [n -S]\n",
  "SORGOS": "SORGO, (French) a variety of sorghum, also SORGHO [n]\n",
  "SORI": "SORUS, (Greek) a cluster of sporangia [n]\n",
  "SORICIDENT": "having teeth like a shrew's [adj]\n",
  "SORICINE": "shrewlike, also SORICOID [adj]\n",
  "SORICOID": "shrewlike, also SORICINE [adj]\n",
  "SORING": "the practise of making a horse's front feet sore to force high stepping [n -S]\n",
  "SORINGS": "SORING, the practise of making a horse's front feet sore to force high stepping [n]\n",
  "SORITES": "(Greek) a string of statements where the end of one is the subject of the next [n]\n",
  "SORITIC": "relating to sorites, a string of statements where the end of one is the subject of the next, also SORITICAL [adj]\n",
  "SORITICAL": "relating to sorites, a string of statements where the end of one is the subject of the next, also SORITIC [adj]\n",
  "SORN": "(Scots) to impose in order to obtain hospitality, to sponge [v -ED, -ING, -S]\n",
  "SORNED": "SORN, (Scots) to impose in order to obtain hospitality, to sponge [v]\n",
  "SORNER": "one who obtrudes himself on another for bed and board [n -S]\n",
  "SORNERS": "SORNER, one who obtrudes himself on another for bed and board [n]\n",
  "SORNING": "the act of obtruding oneself as an uninvited guest [n -S]\n",
  "SORNINGS": "SORNING, the act of obtruding oneself as an uninvited guest [n]\n",
  "SORNS": "SORN, (Scots) to impose in order to obtain hospitality, to sponge [v]\n",
  "SOROBAN": "(Japanese) a Japanese abacus [n -S]\n",
  "SOROBANS": "SOROBAN, (Japanese) a Japanese abacus [n]\n",
  "SOROCHE": "(Quechua) mountain sickness [n -S]\n",
  "SOROCHES": "SOROCHE, (Quechua) mountain sickness [n]\n",
  "SORORAL": "pertaining to sisters, also SORORIAL [adj SORORALLY]\n",
  "SORORALLY": "SORORAL, pertaining to sisters, also SORORIAL [adv]\n",
  "SORORATE": "the marriage of a man with his dead wife's sister [n -S]\n",
  "SORORATES": "SORORATE, the marriage of a man with his dead wife's sister [n]\n",
  "SORORIAL": "pertaining to sisters, also SORORAL [adj SORORIALLY]\n",
  "SORORIALLY": "SORORIAL, pertaining to sisters, also SORORAL [adv]\n",
  "SORORICIDAL": "relating to sororicide, the killing of one's own sister [adj]\n",
  "SORORICIDE": "the killing of one's own sister [n -S]\n",
  "SORORICIDES": "SORORICIDE, the killing of one's own sister [n]\n",
  "SORORISE": "to associate in a sisterly way, also SORORIZE [v SORORISED, SORORISING, SORORISES]\n",
  "SORORISED": "SORORISE, to associate in a sisterly way, also SORORIZE [v]\n",
  "SORORISES": "SORORISE, to associate in a sisterly way, also SORORIZE [v]\n",
  "SORORISING": "SORORISE, to associate in a sisterly way, also SORORIZE [v]\n",
  "SORORITIES": "SORORITY, a social club for women [n]\n",
  "SORORITY": "a social club for women [n SORORITIES]\n",
  "SORORIZE": "to associate in a sisterly way, also SORORISE [v SORORIZED, SORORIZING, SORORIZES]\n",
  "SORORIZED": "SORORIZE, to associate in a sisterly way, also SORORISE [v]\n",
  "SORORIZES": "SORORIZE, to associate in a sisterly way, also SORORISE [v]\n",
  "SORORIZING": "SORORIZE, to associate in a sisterly way, also SORORISE [v]\n",
  "SOROSES": "SOROSIS, (Greek) a fleshy fruit in which many flowers are united, as in pineapple [n]\n",
  "SOROSIS": "(Greek) a fleshy fruit in which many flowers are united, as in pineapple [n SOROSES or SOROSISES]\n",
  "SOROSISES": "SOROSIS, (Greek) a fleshy fruit in which many flowers are united, as in pineapple [n]\n",
  "SORPTION": "absorption and/or adsorption [n -S]\n",
  "SORPTIONS": "SORPTION, absorption and/or adsorption [n]\n",
  "SORPTIVE": "tending to absorb and/or adsorb [adj]\n",
  "SORRA": "(Irish) sorrow, the devil [n -S]\n",
  "SORRAS": "SORRA, (Irish) sorrow, the devil [n]\n",
  "SORREL": "reddish-brown; light chestnut [n -S]\n",
  "SORRELS": "SORREL, reddish-brown; light chestnut [n]\n",
  "SORRIER": "SORRY, feeling regret or grief [adj]\n",
  "SORRIEST": "SORRY, feeling regret or grief [adj]\n",
  "SORRILY": "SORRY, feeling regret or grief [adv]\n",
  "SORRINESS": "the state of being sorry [n -ES]\n",
  "SORRINESSES": "SORRINESS, the state of being sorry [n]\n",
  "SORROW": "to grieve [v -ED, -ING, -S]\n",
  "SORROWED": "SORROW, to grieve [v]\n",
  "SORROWER": "one who sorrows [n -S]\n",
  "SORROWERS": "SORROWER, one who sorrows [n]\n",
  "SORROWFUL": "sad [adj SORROWFULLY]\n",
  "SORROWFULLY": "SORROWFUL, sad [adv]\n",
  "SORROWFULNESS": "the state of being sorrowful [n -ES]\n",
  "SORROWFULNESSES": "SORROWFULNESS, the state of being sorrowful [n]\n",
  "SORROWING": "the act of sorrowing [n -S]\n",
  "SORROWINGS": "SORROWING, the act of sorrowing [n]\n",
  "SORROWLESS": "free from sorrow [adj]\n",
  "SORROWS": "SORROW, to grieve [v]\n",
  "SORRY": "feeling regret or grief [adj SORRIER, SORRIEST, SORRILY]\n",
  "SORRYISH": "somewhat sorry [adj]\n",
  "SORT": "to arrange in class, kind or size [v -ED, -ING, -S]\n",
  "SORTA": "(colloquial) sort of [adv]\n",
  "SORTABLE": "able to be sorted [adj SORTABLY]\n",
  "SORTABLY": "SORTABLE, able to be sorted [adv]\n",
  "SORTAL": "a concept in linguistics [n -S]\n",
  "SORTALS": "SORTAL, a concept in linguistics [n]\n",
  "SORTANCE": "suitableness [n -S]\n",
  "SORTANCES": "SORTANCE, suitableness [n]\n",
  "SORTATION": "sorting out [n -S]\n",
  "SORTATIONS": "SORTATION, sorting out [n]\n",
  "SORTED": "SORT, to arrange in class, kind or size [v]\n",
  "SORTER": "one that sorts [n -S]\n",
  "SORTERS": "SORTER, one that sorts [n]\n",
  "SORTES": "(Latin) divination by chance opening of the Bible, Homer, Virgil etc. [n]\n",
  "SORTIE": "to attack suddenly from a defensive position [v SORTIED, SORTIEING, SORTIES]\n",
  "SORTIED": "SORTIE, to attack suddenly from a defensive position [v]\n",
  "SORTIEING": "SORTIE, to attack suddenly from a defensive position [v]\n",
  "SORTIES": "SORTIE, to attack suddenly from a defensive position [v]\n",
  "SORTILEGE": "divination by drawing lots, also SORTILEGY [n -S]\n",
  "SORTILEGER": "one who divines by sortilege [n -S]\n",
  "SORTILEGERS": "SORTILEGER, one who divines by sortilege [n]\n",
  "SORTILEGES": "SORTILEGE, divination by drawing lots, also SORTILEGY [n]\n",
  "SORTILEGIES": "SORTILEGY, divination by drawing lots, also SORTILEGE [n]\n",
  "SORTILEGY": "divination by drawing lots, also SORTILEGE [n SORTILEGIES]\n",
  "SORTING": "the act of sorting [n -S]\n",
  "SORTINGS": "SORTING, the act of sorting [n]\n",
  "SORTITION": "the casting of lots [n -S]\n",
  "SORTITIONS": "SORTITION, the casting of lots [n]\n",
  "SORTMENT": "an assortment [n -S]\n",
  "SORTMENTS": "SORTMENT, an assortment [n]\n",
  "SORTS": "SORT, to arrange in class, kind or size [v]\n",
  "SORUS": "(Greek) a cluster of sporangia [n SORI]\n",
  "SOS": "SO, the fifth tone of the scale, also SOH, SOL [n]\n",
  "SOSATIE": "(South African) curried meat on a skewer [n -S]\n",
  "SOSATIES": "SOSATIE, (South African) curried meat on a skewer [n]\n",
  "SOSS": "to fall at once into a chair or seat; to sit lazily [v -ED, -ING, -ES]\n",
  "SOSSED": "SOSS, to fall at once into a chair or seat; to sit lazily [v]\n",
  "SOSSES": "SOSS, to fall at once into a chair or seat; to sit lazily [v]\n",
  "SOSSING": "the act of sossing, falling into a chair [n -S]\n",
  "SOSSINGS": "SOSSING, the act of sossing, falling into a chair [n]\n",
  "SOSTENUTI": "SOSTENUTO, (Italian) a piece played in a sustained or drawn out manner [n]\n",
  "SOSTENUTO": "(Italian) a piece played in a sustained or drawn out manner [n SOSTENUTOS or SOSTENUTI]\n",
  "SOSTENUTOS": "SOSTENUTO, (Italian) a piece played in a sustained or drawn out manner [n]\n",
  "SOT": "to play the drunken fool [v SOTTED, SOTTING, SOTS]\n",
  "SOTERIAL": "pertaining to salvation [adj]\n",
  "SOTERIOLOGIC": "relating to soteriology, the theological doctrine of salvation, also SOTERIOLOGICAL [adj]\n",
  "SOTERIOLOGICAL": "relating to soteriology, the theological doctrine of salvation, also SOTERIOLOGIC [adj]\n",
  "SOTERIOLOGIES": "SOTERIOLOGY, the theological doctrine of salvation, as effected by Christ [n]\n",
  "SOTERIOLOGY": "the theological doctrine of salvation, as effected by Christ [n SOTERIOLOGIES]\n",
  "SOTH": "truth, also SOOTH [n -S]\n",
  "SOTHS": "SOTH, truth, also SOOTH [n]\n",
  "SOTOL": "(Nahuatl) any of several desert plants of the agave family, native to southwestern North America [n -S]\n",
  "SOTOLS": "SOTOL, (Nahuatl) any of several desert plants of the agave family, native to southwestern North America [n]\n",
  "SOTS": "SOT, to play the drunken fool [v]\n",
  "SOTTED": "SOT, to play the drunken fool [v]\n",
  "SOTTEDLY": "SOTTED, SOT, to play the drunken fool [adv]\n",
  "SOTTING": "the act of sotting [n -S]\n",
  "SOTTINGS": "SOTTING, the act of sotting [n]\n",
  "SOTTISH": "resembling a sot [adj SOTTISHLY]\n",
  "SOTTISHLY": "SOTTISH, resembling a sot [adv]\n",
  "SOTTISHNESS": "the state of being sottish [n -ES]\n",
  "SOTTISHNESSES": "SOTTISHNESS, the state of being sottish [n]\n",
  "SOTTISIER": "(French) a collection of jokes, ridiculous remarks etc. [n -S]\n",
  "SOTTISIERS": "SOTTISIER, (French) a collection of jokes, ridiculous remarks etc. [n]\n",
  "SOU": "(French) a former French coin [n -S]\n",
  "SOUARI": "a tree of Guiana, yielding butternuts, also SAOUARI [n -S]\n",
  "SOUARIS": "SOUARI, a tree of Guiana, yielding butternuts, also SAOUARI [n]\n",
  "SOUBISE": "(French) a sauce made with onions or onion puree [n -S]\n",
  "SOUBISES": "SOUBISE, (French) a sauce made with onions or onion puree [n]\n",
  "SOUBRETTE": "(French) a coquettish and intriguing maid; such a role in drama [n -S]\n",
  "SOUBRETTES": "SOUBRETTE, (French) a coquettish and intriguing maid; such a role in drama [n]\n",
  "SOUBRETTISH": "like a soubrette, pert, flirtatious [adj]\n",
  "SOUBRIQUET": "(French) a nickname, also SOBRIQUET [n -S]\n",
  "SOUBRIQUETS": "SOUBRIQUET, (French) a nickname, also SOBRIQUET [n]\n",
  "SOUCAR": "(Hindi) a Hindu banker, also SOWCAR [n -S]\n",
  "SOUCARS": "SOUCAR, (Hindi) a Hindu banker, also SOWCAR [n]\n",
  "SOUCE": "(Spenser) to pickle; to marinade, also SOUSE, SOWCE, SOWSE, SOWSSE [v SOUCED, SOUCING, SOUCES]\n",
  "SOUCED": "SOUCE, (Spenser) to pickle; to marinade, also SOUSE, SOWCE, SOWSE, SOWSSE [v]\n",
  "SOUCES": "SOUCE, (Spenser) to pickle; to marinade, also SOUSE, SOWCE, SOWSE, SOWSSE [v]\n",
  "SOUCHONG": "(Chinese) a kind of black tea of a fine quality, also SOOCHONG [n -S]\n",
  "SOUCHONGS": "SOUCHONG, (Chinese) a kind of black tea of a fine quality, also SOOCHONG [n]\n",
  "SOUCING": "SOUCE, (Spenser) to pickle; to marinade, also SOUSE, SOWCE, SOWSE, SOWSSE [v]\n",
  "SOUCT": "(Spenser) soused [v]\n",
  "SOUDAN": "(Arabic) the monarch or chief ruler of a Muslim country, esp that of Turkey, also SOLDAN, SOULDAN, SULDAN, SULTAN [n -S]\n",
  "SOUDANS": "SOUDAN, (Arabic) the monarch or chief ruler of a Muslim country, esp that of Turkey, also SOLDAN, SOULDAN, SULDAN, SULTAN [n]\n",
  "SOUFFLE": "(French) a light dish, properly one made with egg-whites whisked into a froth [n -S]\n",
  "SOUFFLED": "like a souffle, made puffy by beating and baking, also SOUFFLEED [adj]\n",
  "SOUFFLEED": "like a souffle, made puffy by beating and baking, also SOUFFLED [adj]\n",
  "SOUFFLES": "SOUFFLE, (French) a light dish, properly one made with egg-whites whisked into a froth [n]\n",
  "SOUGH": "to make a moaning or sighing sound, also SUGH [v -ED, -ING, -S]\n",
  "SOUGHED": "SOUGH, to make a moaning or sighing sound, also SUGH [v]\n",
  "SOUGHING": "SOUGH, to make a moaning or sighing sound, also SUGH [v]\n",
  "SOUGHS": "SOUGH, to make a moaning or sighing sound, also SUGH [v]\n",
  "SOUGHT": "SEEK, to go in search of [v]\n",
  "SOUK": "(Scots) to suck, also SOOK [v -ED, -ING, -S]\n",
  "SOUKED": "SOUK, (Scots) to suck, also SOOK [v]\n",
  "SOUKING": "SOUK, (Scots) to suck, also SOOK [v]\n",
  "SOUKOUS": "(French) a form of Central African dance music [n -ES]\n",
  "SOUKOUSES": "SOUKOUS, (French) a form of Central African dance music [n]\n",
  "SOUKS": "SOUK, (Scots) to suck, also SOOK [v]\n",
  "SOUL": "the spiritual aspect of human beings [n -S]\n",
  "SOULDAN": "(Arabic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOLDAN, SOUDAN, SULDAN, SULTAN [n -S]\n",
  "SOULDANS": "SOULDAN, (Arabic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOLDAN, SOUDAN, SULDAN, SULTAN [n]\n",
  "SOULDIER": "(archaic) to soldier [v -ED, -ING, -S]\n",
  "SOULDIERED": "SOULDIER, (archaic) to soldier [v]\n",
  "SOULDIERING": "SOULDIER, (archaic) to soldier [v]\n",
  "SOULDIERS": "SOULDIER, (archaic) to soldier [v]\n",
  "SOULED": "having a soul [adj]\n",
  "SOULFUL": "full of emotion [adj SOULFULLY]\n",
  "SOULFULLY": "SOULFUL, full of emotion [adv]\n",
  "SOULFULNESS": "the state of being soulful [n -ES]\n",
  "SOULFULNESSES": "SOULFULNESS, the state of being soulful [n]\n",
  "SOULLESS": "without a soul [adj SOULLESSLY]\n",
  "SOULLESSLY": "SOULLESS, without a soul [adv]\n",
  "SOULLESSNESS": "the state of being soulless [n -ES]\n",
  "SOULLESSNESSES": "SOULLESSNESS, the state of being soulless [n]\n",
  "SOULLIKE": "like a soul [adj]\n",
  "SOULMATE": "a person with whom one is perfectly suited [n -S]\n",
  "SOULMATES": "SOULMATE, a person with whom one is perfectly suited [n]\n",
  "SOULS": "SOUL, the spiritual aspect of human beings [n]\n",
  "SOULSTER": "a singer of soul music [n -S]\n",
  "SOULSTERS": "SOULSTER, a singer of soul music [n]\n",
  "SOUM": "(Scots) to reckon the proportion of sheep or cattle suitable for any pasture, also SOWM [v -ED, -ING, -S]\n",
  "SOUMED": "SOUM, (Scots) to reckon the proportion of sheep or cattle suitable for any pasture, also SOWM [v]\n",
  "SOUMING": "the act of souming [n -S]\n",
  "SOUMINGS": "SOUMING, the act of souming [n]\n",
  "SOUMS": "SOUM, (Scots) to reckon the proportion of sheep or cattle suitable for any pasture, also SOWM [v]\n",
  "SOUND": "being in good health or condition [adj SOUNDER, SOUNDEST, SOUNDLY] / to make a sound [v -ED, -ING, -S]\n",
  "SOUNDABLE": "capable of being sounded [adj]\n",
  "SOUNDALIKE": "one that sounds like another [n -S]\n",
  "SOUNDALIKES": "SOUNDALIKE, one that sounds like another [n]\n",
  "SOUNDBAR": "a long, slender speaker used with a TV, games console, MP3 player, etc [n -S]\n",
  "SOUNDBARS": "SOUNDBAR, a long, slender speaker used with a TV, games console, MP3 player, etc [n]\n",
  "SOUNDBITE": "a brief section on radio or television in which e.g. a political leader makes a short succinct statement [n -S]\n",
  "SOUNDBITES": "SOUNDBITE, a brief section on radio or television in which e.g. a political leader makes a short succinct statement [n]\n",
  "SOUNDBOARD": "a thin resonant board (as the belly of a violin) so placed in an instrument as to reinforce its tones by sympathetic vibration [n -S]\n",
  "SOUNDBOARDS": "SOUNDBOARD, a thin resonant board (as the belly of a violin) so placed in an instrument as to reinforce its tones by sympathetic vibration [n]\n",
  "SOUNDBOX": "a resonant cavity in a musical instrument [n -ES]\n",
  "SOUNDBOXES": "SOUNDBOX, a resonant cavity in a musical instrument [n]\n",
  "SOUNDCARD": "the card in a computer that produces audio [n -S]\n",
  "SOUNDCARDS": "SOUNDCARD, the card in a computer that produces audio [n]\n",
  "SOUNDED": "SOUND, to make a sound [v]\n",
  "SOUNDER": "a herd of pigs; a young boar [n -S]\n",
  "SOUNDERS": "SOUNDER, a herd of pigs; a young boar [n]\n",
  "SOUNDEST": "SOUND, being in good health or condition [adj]\n",
  "SOUNDING": "the action of determining depth of water [n -S]\n",
  "SOUNDINGLY": "SOUNDING [adv]\n",
  "SOUNDINGS": "SOUNDING, the action of determining depth of water [n]\n",
  "SOUNDLESS": "without sound [adj SOUNDLESSLY]\n",
  "SOUNDLESSLY": "SOUNDLESS, without sound [adv]\n",
  "SOUNDLESSNESS": "the state of being soundless [n -ES]\n",
  "SOUNDLESSNESSES": "SOUNDLESSNESS, the state of being soundless [n]\n",
  "SOUNDLY": "SOUND, being in good health or condition [adv]\n",
  "SOUNDMAN": "a person who controls the quality of sound [n SOUNDMEN]\n",
  "SOUNDMEN": "SOUNDMAN, a person who controls the quality of sound [n]\n",
  "SOUNDNESS": "the state of being sound [n -ES]\n",
  "SOUNDNESSES": "SOUNDNESS, the state of being sound [n]\n",
  "SOUNDPOST": "a small post on guitars, violins etc. that joins the front surface to the back [n -S]\n",
  "SOUNDPOSTS": "SOUNDPOST, a small post on guitars, violins etc. that joins the front surface to the back [n]\n",
  "SOUNDPROOF": "impenetrable by sound [adj] / to insulate so as to obstruct the passage of sound [v -ED, -ING, -S]\n",
  "SOUNDPROOFED": "SOUNDPROOF, to insulate so as to obstruct the passage of sound [v]\n",
  "SOUNDPROOFING": "insulation to obstruct the passage of sound [n -S]\n",
  "SOUNDPROOFINGS": "SOUNDPROOFING, insulation to obstruct the passage of sound [n]\n",
  "SOUNDPROOFS": "SOUNDPROOF, to insulate so as to obstruct the passage of sound [v]\n",
  "SOUNDS": "SOUND, to make a sound [v]\n",
  "SOUNDSCAPE": "in pop music, a mixture of sounds producing an overall effect [n -S]\n",
  "SOUNDSCAPES": "SOUNDSCAPE, in pop music, a mixture of sounds producing an overall effect [n]\n",
  "SOUNDSTAGE": "the soundproof area of a motion picture studio [n -S]\n",
  "SOUNDSTAGES": "SOUNDSTAGE, the soundproof area of a motion picture studio [n]\n",
  "SOUNDTRACK": "a recording of the sound (esp. musical) accompaniment to a film [n -S] / to provide with a soundtrack [v -ED, -ING, -S]\n",
  "SOUNDTRACKED": "SOUNDTRACK, to provide with a soundtrack [v]\n",
  "SOUNDTRACKING": "SOUNDTRACK, to provide with a soundtrack [v]\n",
  "SOUNDTRACKS": "SOUNDTRACK, a recording of the sound (esp. musical) accompaniment to a film [n]\n",
  "SOUP": "to increase the power or efficiency of [v -ED, -ING, -S]\n",
  "SOUPCON": "(French) a suspicion, a trace [n -S]\n",
  "SOUPCONS": "SOUPCON, (French) a suspicion, a trace [n]\n",
  "SOUPED": "SOUP, to increase the power or efficiency of [v]\n",
  "SOUPER": "in Ireland, a person who dispenses soup as a means of proselytising; one who has been converted in this way [n -S]\n",
  "SOUPERS": "SOUPER, in Ireland, a person who dispenses soup as a means of proselytising; one who has been converted in this way [n]\n",
  "SOUPFIN": "the requiem shark, whose fin is used for soup [n -S]\n",
  "SOUPFINS": "SOUPFIN, the requiem shark, whose fin is used for soup [n]\n",
  "SOUPIER": "SOUPY, having the consistency of soup [adj]\n",
  "SOUPIEST": "SOUPY, having the consistency of soup [adj]\n",
  "SOUPILY": "SOUPY, having the consistency of soup [adv]\n",
  "SOUPINESS": "the quality of being soupy [n -ES]\n",
  "SOUPINESSES": "SOUPINESS, the quality of being soupy [n]\n",
  "SOUPING": "SOUP, to increase the power or efficiency of [v]\n",
  "SOUPLE": "to make supple [v SOUPLED, SOUPLING, SOUPLES]\n",
  "SOUPLED": "SOUPLE, to make supple [v]\n",
  "SOUPLES": "SOUPLE, to make supple [v]\n",
  "SOUPLESS": "without soup [adj]\n",
  "SOUPLIKE": "like soup [adj]\n",
  "SOUPLING": "SOUPLE, to make supple [v]\n",
  "SOUPS": "SOUP, to increase the power or efficiency of [v]\n",
  "SOUPSPOON": "a spoon for eating soup [n -S]\n",
  "SOUPSPOONS": "SOUPSPOON, a spoon for eating soup [n]\n",
  "SOUPY": "having the consistency of soup [adj SOUPIER, SOUPIEST, SOUPILY]\n",
  "SOUR": "having an acid taste [adj SOURER, SOUREST, SOURLY] / to make sour [v -ED, -ING, -S]\n",
  "SOURBALL": "a sour candy [n -S]\n",
  "SOURBALLS": "SOURBALL, a sour candy [n]\n",
  "SOURCE": "to originate from [v SOURCED, SOURCING, SOURCES]\n",
  "SOURCEBOOK": "a book of original documents for (esp. historic) study [n -S]\n",
  "SOURCEBOOKS": "SOURCEBOOK, a book of original documents for (esp. historic) study [n]\n",
  "SOURCED": "SOURCE, to originate from [v]\n",
  "SOURCEFUL": "offering useful things [adj]\n",
  "SOURCELESS": "without a source [adj]\n",
  "SOURCES": "SOURCE, to originate from [v]\n",
  "SOURCING": "the act of sourcing [n -S]\n",
  "SOURCINGS": "SOURCING, the act of sourcing [n]\n",
  "SOURDELINE": "(French) a kind of small bagpipe [n -S]\n",
  "SOURDELINES": "SOURDELINE, (French) a kind of small bagpipe [n]\n",
  "SOURDINE": "a mute or damper, also SORDINE, SORDINO [n -S]\n",
  "SOURDINES": "SOURDINE, a mute or damper, also SORDINE, SORDINO [n]\n",
  "SOURDOUGH": "leaven; a piece of dough kept to leaven a new batch; in Alaska, an old-timer [n -S]\n",
  "SOURDOUGHS": "SOURDOUGH, leaven; a piece of dough kept to leaven a new batch; in Alaska, an old-timer [n]\n",
  "SOURED": "SOUR, to make sour [v]\n",
  "SOURER": "SOUR, having an acid taste [adj]\n",
  "SOUREST": "SOUR, having an acid taste [adj]\n",
  "SOURGUM": "a softwood tree of eastern North America [n -S]\n",
  "SOURGUMS": "SOURGUM, a softwood tree of eastern North America [n]\n",
  "SOURING": "a crabapple [n -S]\n",
  "SOURINGS": "SOURING, a crabapple [n]\n",
  "SOURISH": "somewhat sour [adj SOURISHLY]\n",
  "SOURISHLY": "SOURISH, somewhat sour [adv]\n",
  "SOURLY": "SOUR, having an acid taste [adv]\n",
  "SOURNESS": "the state of being sour [n -ES]\n",
  "SOURNESSES": "SOURNESS, the state of being sour [n]\n",
  "SOUROCK": "(Scots) sorrel [n -S]\n",
  "SOUROCKS": "SOUROCK, (Scots) sorrel [n]\n",
  "SOURPUSS": "a grouchy person [n -ES]\n",
  "SOURPUSSES": "SOURPUSS, a grouchy person [n]\n",
  "SOURS": "SOUR, to make sour [v]\n",
  "SOURSE": "(Spenser) a source [n -S]\n",
  "SOURSES": "SOURSE, (Spenser) a source [n]\n",
  "SOURSOP": "a West Indian tree of the Anona species; its large, sour, pulpy fruit [n -S]\n",
  "SOURSOPS": "SOURSOP, a West Indian tree of the Anona species; its large, sour, pulpy fruit [n]\n",
  "SOURVELD": "(South African) in South Africa, a type of grazing characterised by long coarse grass [n -S]\n",
  "SOURVELDS": "SOURVELD, (South African) in South Africa, a type of grazing characterised by long coarse grass [n]\n",
  "SOURWOOD": "the sorrel tree [n -S]\n",
  "SOURWOODS": "SOURWOOD, the sorrel tree [n]\n",
  "SOUS": "SOU, (French) a former French coin [n]\n",
  "SOUSAPHONE": "a musical instrument similar to a tuba [n -S]\n",
  "SOUSAPHONES": "SOUSAPHONE, a musical instrument similar to a tuba [n]\n",
  "SOUSAPHONIST": "one who plays the sousaphone [n -S]\n",
  "SOUSAPHONISTS": "SOUSAPHONIST, one who plays the sousaphone [n]\n",
  "SOUSE": "to pickle; to marinade, also SOUCE, SOWCE, SOWSE, SOWSSE [v SOUSED, SOUSING, SOUSES]\n",
  "SOUSED": "SOUSE, to pickle; to marinade, also SOUCE, SOWCE, SOWSE, SOWSSE [v]\n",
  "SOUSER": "a drunkard [n -S]\n",
  "SOUSERS": "SOUSER, a drunkard [n]\n",
  "SOUSES": "SOUSE, to pickle; to marinade, also SOUCE, SOWCE, SOWSE, SOWSSE [v]\n",
  "SOUSING": "the act of sousing [n -S]\n",
  "SOUSINGS": "SOUSING, the act of sousing [n]\n",
  "SOUSLIK": "(Russian) a ground squirrel, also SUSLIK [n -S]\n",
  "SOUSLIKS": "SOUSLIK, (Russian) a ground squirrel, also SUSLIK [n]\n",
  "SOUT": "(Spenser) soot [n -S]\n",
  "SOUTACHE": "(French) a narrow braid used for trimming [n -S]\n",
  "SOUTACHES": "SOUTACHE, (French) a narrow braid used for trimming [n]\n",
  "SOUTANE": "(French) a Roman Catholic priest's cassock [n -S]\n",
  "SOUTANES": "SOUTANE, (French) a Roman Catholic priest's cassock [n]\n",
  "SOUTAR": "(Scots) a shoemaker; a cobbler, also SOUTER, SOWTER, SUTOR [n -S]\n",
  "SOUTARS": "SOUTAR, (Scots) a shoemaker; a cobbler, also SOUTER, SOWTER, SUTOR [n]\n",
  "SOUTENEUR": "(French) a prostitute's pimp or bully [n -S]\n",
  "SOUTENEURS": "SOUTENEUR, (French) a prostitute's pimp or bully [n]\n",
  "SOUTER": "(Scots) a shoemaker; a cobbler, also SOUTAR, SOWTER, SUTOR [n -S]\n",
  "SOUTERLY": "like a shoemaker [adj]\n",
  "SOUTERRAIN": "(French) an underground chamber, room or dwelling, also SUBTERRAIN, SUBTERRANE, SUBTERRENE [n -S]\n",
  "SOUTERRAINS": "SOUTERRAIN, (French) an underground chamber, room or dwelling, also SUBTERRAIN, SUBTERRANE, SUBTERRENE [n]\n",
  "SOUTERS": "SOUTER, (Scots) a shoemaker; a cobbler, also SOUTAR, SOWTER, SUTOR [n]\n",
  "SOUTH": "a point of the compass [n -S] / (archaic) to move toward a cardinal point of the compass [v -ED, -ING, -S]\n",
  "SOUTHBOUND": "travelling or heading south [adj]\n",
  "SOUTHEAST": "the direction between south and east [n -S]\n",
  "SOUTHEASTER": "a southeast wind [n -S]\n",
  "SOUTHEASTERLIES": "SOUTHEASTERLY, a wind from the southeast [n]\n",
  "SOUTHEASTERLY": "from the southeast [adj] / a wind from the southeast [n SOUTHEASTERLIES]\n",
  "SOUTHEASTERN": "of, relating to, or characteristic of a region conventionally designated southeast [adj]\n",
  "SOUTHEASTERS": "SOUTHEASTER, a southeast wind [n]\n",
  "SOUTHEASTS": "SOUTHEAST, the direction between south and east [n]\n",
  "SOUTHEASTWARD": "in a southeasterly direction, also SOUTHEASTWARDS [adv]\n",
  "SOUTHEASTWARDS": "in a southeasterly direction, also SOUTHEASTWARD [adv]\n",
  "SOUTHED": "SOUTH, (archaic) to move toward a cardinal point of the compass [v]\n",
  "SOUTHER": "to move towards the south [v -ED, -ING, -S]\n",
  "SOUTHERED": "SOUTHER, to move towards the south [v]\n",
  "SOUTHERING": "SOUTHER, to move towards the south [v]\n",
  "SOUTHERLIES": "SOUTHERLY, a southerly wind [n]\n",
  "SOUTHERLINESS": "the state of being southerly [n -ES]\n",
  "SOUTHERLINESSES": "SOUTHERLINESS, the state of being southerly [n]\n",
  "SOUTHERLY": "from the south [adj] / a southerly wind [n SOUTHERLIES]\n",
  "SOUTHERMOST": "(obsolete) most southerly, also SOUTHERNMOST, SOUTHMOST [adj]\n",
  "SOUTHERN": "in the south [adj SOUTHERNLY] / a southerner, also SOUTHRON [n -S]\n",
  "SOUTHERNER": "an inhabitant or native of the south, esp. of the southern States of North America [n -S]\n",
  "SOUTHERNERS": "SOUTHERNER, an inhabitant or native of the south, esp. of the southern States of North America [n]\n",
  "SOUTHERNISE": "to make southern, also SOUTHERNIZE [v SOUTHERNISED, SOUTHERNISING, SOUTHERNISES]\n",
  "SOUTHERNISED": "SOUTHERNISE, to make southern, also SOUTHERNIZE [v]\n",
  "SOUTHERNISES": "SOUTHERNISE, to make southern, also SOUTHERNIZE [v]\n",
  "SOUTHERNISING": "SOUTHERNISE, to make southern, also SOUTHERNIZE [v]\n",
  "SOUTHERNISM": "a southern expression [n -S]\n",
  "SOUTHERNISMS": "SOUTHERNISM, a southern expression [n]\n",
  "SOUTHERNIZE": "to make southern, also SOUTHERNISE [v SOUTHERNIZED, SOUTHERNIZING, SOUTHERNIZES]\n",
  "SOUTHERNIZED": "SOUTHERNIZE, to make southern, also SOUTHERNISE [v]\n",
  "SOUTHERNIZES": "SOUTHERNIZE, to make southern, also SOUTHERNISE [v]\n",
  "SOUTHERNIZING": "SOUTHERNIZE, to make southern, also SOUTHERNISE [v]\n",
  "SOUTHERNLY": "somewhat southern [adj]\n",
  "SOUTHERNMOST": "situated furthest south, also SOUTHERMOST, SOUTHMOST [adj]\n",
  "SOUTHERNNESS": "the state of being southern [n -ES]\n",
  "SOUTHERNNESSES": "SOUTHERNNESS, the state of being southern [n]\n",
  "SOUTHERNS": "SOUTHERN, a southerner, also SOUTHRON [n]\n",
  "SOUTHERNWOOD": "an aromatic South European shrub of the wormwood genus [n -S]\n",
  "SOUTHERNWOODS": "SOUTHERNWOOD, an aromatic South European shrub of the wormwood genus [n]\n",
  "SOUTHERS": "SOUTHER, to move towards the south [v]\n",
  "SOUTHING": "movement toward the south [n -S]\n",
  "SOUTHINGS": "SOUTHING, movement toward the south [n]\n",
  "SOUTHLAND": "the southern part of a country [n -S]\n",
  "SOUTHLANDER": "one who lives in the south [n -S]\n",
  "SOUTHLANDERS": "SOUTHLANDER, one who lives in the south [n]\n",
  "SOUTHLANDS": "SOUTHLAND, the southern part of a country [n]\n",
  "SOUTHMOST": "situated furthest south, also SOUTHERMOST, SOUTHERNMOST [adj]\n",
  "SOUTHPAW": "a left-handed sportsman, esp. a boxer who leads with his right [n -S]\n",
  "SOUTHPAWS": "SOUTHPAW, a left-handed sportsman, esp. a boxer who leads with his right [n]\n",
  "SOUTHRON": "someone from the south, also SOUTHERN [n -S]\n",
  "SOUTHRONS": "SOUTHRON, someone from the south, also SOUTHERN [n]\n",
  "SOUTHS": "SOUTH, (archaic) to move toward a cardinal point of the compass [v]\n",
  "SOUTHSAID": "SOUTHSAY, to foretell, to divine, also SOOTHSAY [v]\n",
  "SOUTHSAY": "to foretell, to divine, also SOOTHSAY [v SOUTHSAID, SOUTHSAYING, SOUTHSAYS]\n",
  "SOUTHSAYING": "SOUTHSAY, to foretell, to divine, also SOOTHSAY [v]\n",
  "SOUTHSAYS": "SOUTHSAY, to foretell, to divine, also SOOTHSAY [v]\n",
  "SOUTHWARD": "towards the south, also SOUTHWARDS [adv SOUTHWARDLY]\n",
  "SOUTHWARDLY": "in a southward direction [adv]\n",
  "SOUTHWARDS": "towards the south, also SOUTHWARD [adv]\n",
  "SOUTHWEST": "between south and west [n -S]\n",
  "SOUTHWESTER": "a waterproof hat [n -S]\n",
  "SOUTHWESTERLIES": "SOUTHWESTERLY, a wind from the southwest [n]\n",
  "SOUTHWESTERLY": "from the southwest [adj] / a wind from the southwest [n SOUTHWESTERLIES]\n",
  "SOUTHWESTERN": "lying toward or coming from the southwest [adj]\n",
  "SOUTHWESTERS": "SOUTHWESTER, a waterproof hat [n]\n",
  "SOUTHWESTS": "SOUTHWEST, between south and west [n]\n",
  "SOUTHWESTWARD": "in a southwesterly direction, also SOUTHWESTWARDS [adv SOUTHWESTWARDLY]\n",
  "SOUTHWESTWARDLY": "in a southwesterly direction [adv]\n",
  "SOUTHWESTWARDS": "in a southwesterly direction, also SOUTHWESTWARD [adv]\n",
  "SOUTIE": "(South African) derogatory for an English-speaking South African, also SOUTPIEL [n -S]\n",
  "SOUTIES": "SOUTIE, (South African) derogatory for an English-speaking South African, also SOUTPIEL [n]\n",
  "SOUTPIEL": "(South African) derogatory for an English-speaking South African, also SOUTIE [n -S]\n",
  "SOUTPIELS": "SOUTPIEL, (South African) derogatory for an English-speaking South African, also SOUTIE [n]\n",
  "SOUTS": "SOUT, (Spenser) soot [n]\n",
  "SOUVENIR": "a remembrance [n -S] / to provide a souvenir of [v -ED, -ING, -S]\n",
  "SOUVENIRED": "SOUVENIR, to provide a souvenir of [v]\n",
  "SOUVENIRING": "SOUVENIR, to provide a souvenir of [v]\n",
  "SOUVENIRS": "SOUVENIR, to provide a souvenir of [v]\n",
  "SOUVLAKI": "(Modern Greek) a Greek dish of lamb, similar to a shish kebab, also SOUVLAKIA [n -S]\n",
  "SOUVLAKIA": "(Modern Greek) a Greek dish of lamb, similar to a shish kebab, also SOUVLAKI [n -S]\n",
  "SOUVLAKIAS": "SOUVLAKIA, (Modern Greek) a Greek dish of lamb, similar to a shish kebab, also SOUVLAKI [n]\n",
  "SOUVLAKIS": "SOUVLAKI, (Modern Greek) a Greek dish of lamb, similar to a shish kebab, also SOUVLAKIA [n]\n",
  "SOV": "(short for) a sovereign, a gold coin [n -S]\n",
  "SOVENANCE": "(archaic) remembrance; memory [n -S]\n",
  "SOVENANCES": "SOVENANCE, (archaic) remembrance; memory [n]\n",
  "SOVEREIGN": "supreme, also SOVRAN [adj SOVEREIGNLY] / in pre-decimal coinage, a coin worth one pound sterling [n -S]\n",
  "SOVEREIGNLY": "SOVEREIGN, supreme, also SOVRAN [adv]\n",
  "SOVEREIGNS": "SOVEREIGN, in pre-decimal coinage, a coin worth one pound sterling [n]\n",
  "SOVEREIGNTIES": "SOVEREIGNTY, the state of being sovereign, also SOVRANTY [n]\n",
  "SOVEREIGNTIST": "in Canada, a supporter of sovereignty association [n -S]\n",
  "SOVEREIGNTISTS": "SOVEREIGNTIST, in Canada, a supporter of sovereignty association [n]\n",
  "SOVEREIGNTY": "the state of being sovereign, also SOVRANTY [n SOVEREIGNTIES]\n",
  "SOVIET": "(Russian) a legislative body in a Communist country [n -S]\n",
  "SOVIETIC": "of or like a soviet [adj]\n",
  "SOVIETISATION": "the process of sovietising, also SOVIETIZATION [n -S]\n",
  "SOVIETISATIONS": "SOVIETISATION, the process of sovietising, also SOVIETIZATION [n]\n",
  "SOVIETISE": "to transform to the soviet model, also SOVIETIZE [v SOVIETISED, SOVIETISING, SOVIETISES]\n",
  "SOVIETISED": "SOVIETISE, to transform to the soviet model, also SOVIETIZE [v]\n",
  "SOVIETISES": "SOVIETISE, to transform to the soviet model, also SOVIETIZE [v]\n",
  "SOVIETISING": "SOVIETISE, to transform to the soviet model, also SOVIETIZE [v]\n",
  "SOVIETISM": "the principles and practice of soviet government [n -S]\n",
  "SOVIETISMS": "SOVIETISM, the principles and practice of soviet government [n]\n",
  "SOVIETIST": "a believer in sovietism, the principles and practice of Soviet government [n -S]\n",
  "SOVIETISTIC": "relating to sovietism, the principles and practice of soviet government [adj]\n",
  "SOVIETISTS": "SOVIETIST, a believer in sovietism, the principles and practice of Soviet government [n]\n",
  "SOVIETIZATION": "the process of sovietizing, also SOVIETISATION [n -S]\n",
  "SOVIETIZATIONS": "SOVIETIZATION, the process of sovietizing, also SOVIETISATION [n]\n",
  "SOVIETIZE": "to transform to the soviet model, also SOVIETISE [v SOVIETIZED, SOVIETIZING, SOVIETIZES]\n",
  "SOVIETIZED": "SOVIETIZE, to transform to the soviet model, also SOVIETISE [v]\n",
  "SOVIETIZES": "SOVIETIZE, to transform to the soviet model, also SOVIETISE [v]\n",
  "SOVIETIZING": "SOVIETIZE, to transform to the soviet model, also SOVIETISE [v]\n",
  "SOVIETOLOGICAL": "relating to Sovietology, the study of Soviet affairs [adj]\n",
  "SOVIETOLOGIST": "an expert on Soviet affairs [n -S]\n",
  "SOVIETOLOGISTS": "SOVIETOLOGIST, an expert on Soviet affairs [n]\n",
  "SOVIETS": "SOVIET, (Russian) a legislative body in a Communist country [n]\n",
  "SOVKHOZ": "(Russian) a Soviet state-owned farm [n SOVKHOZY or SOVKHOZES]\n",
  "SOVKHOZES": "SOVKHOZ, (Russian) a Soviet state-owned farm [n]\n",
  "SOVKHOZY": "SOVKHOZ, (Russian) a Soviet state-owned farm [n]\n",
  "SOVRAN": "sovereign [adj SOVRANLY] / a sovereign [n -S]\n",
  "SOVRANLY": "supremely [adv]\n",
  "SOVRANS": "SOVRAN, a sovereign [n]\n",
  "SOVRANTIES": "SOVRANTY, sovereignty [n]\n",
  "SOVRANTY": "sovereignty [n SOVRANTIES]\n",
  "SOVS": "SOV, (short for) a sovereign, a gold coin [n]\n",
  "SOW": "to scatter seeds for a crop [v SOWED, SOWN, SOWING, SOWS]\n",
  "SOWABLE": "able to be sown [adj]\n",
  "SOWANS": "(Gaelic) a kind of oat porridge, a traditional dish for Hallowe'en, also SOWENS [n]\n",
  "SOWAR": "(Urdu) a mounted native soldier in India [n -S]\n",
  "SOWARREE": "(Urdu) a mounted retinue, a cavalcade, also SOWARRY [n -S]\n",
  "SOWARREES": "SOWARREE, (Urdu) a mounted retinue, a cavalcade, also SOWARRY [n]\n",
  "SOWARRIES": "SOWARRY, (Urdu) a mounted retinue, a cavalcade, also SOWARREE [n]\n",
  "SOWARRY": "(Urdu) a mounted retinue, a cavalcade, also SOWARREE [n SOWARRIES]\n",
  "SOWARS": "SOWAR, (Urdu) a mounted native soldier in India [n]\n",
  "SOWBACK": "an eroded, steeply tilted ridge of resistant rocks with equal slopes on the sides, also HOGBACK [n -S]\n",
  "SOWBACKS": "SOWBACK, an eroded, steeply tilted ridge of resistant rocks with equal slopes on the sides, also HOGBACK [n]\n",
  "SOWBELLIES": "SOWBELLY, pork cured in salt [n]\n",
  "SOWBELLY": "pork cured in salt [n SOWBELLIES]\n",
  "SOWBREAD": "a kind of cyclamen, so called because its tubers are eaten by pigs [n -S]\n",
  "SOWBREADS": "SOWBREAD, a kind of cyclamen, so called because its tubers are eaten by pigs [n]\n",
  "SOWBUG": "a woodlouse [n -S]\n",
  "SOWBUGS": "SOWBUG, a woodlouse [n]\n",
  "SOWCAR": "(Hindi) a Hindu banker, also SOUCAR [n -S]\n",
  "SOWCARS": "SOWCAR, (Hindi) a Hindu banker, also SOUCAR [n]\n",
  "SOWCE": "to pickle; to marinade, also SOUCE, SOUSE, SOWSE, SOWSSE [v SOWCED, SOWCING, SOWCES]\n",
  "SOWCED": "SOWCE, to pickle; to marinade, also SOUCE, SOUSE, SOWSE, SOWSSE [v]\n",
  "SOWCES": "SOWCE, to pickle; to marinade, also SOUCE, SOUSE, SOWSE, SOWSSE [v]\n",
  "SOWCING": "SOWCE, to pickle; to marinade, also SOUCE, SOUSE, SOWSE, SOWSSE [v]\n",
  "SOWDER": "as in soft sowder, flattery, also SAWDER [n -S]\n",
  "SOWDERS": "SOWDER, as in soft sowder, flattery, also SAWDER [n]\n",
  "SOWED": "SOW, to scatter seeds for a crop [v]\n",
  "SOWENS": "(Gaelic) a kind of oat porridge, a traditional dish for Hallowe'en, also SOWANS [n]\n",
  "SOWER": "one who sows [n -S]\n",
  "SOWERS": "SOWER, one who sows [n]\n",
  "SOWF": "(Scots) to whistle or hum softly, also SOWFF, SOWTH [v -ED, -ING, -S]\n",
  "SOWFED": "SOWF, (Scots) to whistle or hum softly, also SOWFF, SOWTH [v]\n",
  "SOWFF": "(Scots) to whistle or hum softly, also SOWF, SOWTH [v -ED, -ING, -S]\n",
  "SOWFFED": "SOWFF, (Scots) to whistle or hum softly, also SOWF, SOWTH [v]\n",
  "SOWFFING": "SOWFF, (Scots) to whistle or hum softly, also SOWF, SOWTH [v]\n",
  "SOWFFS": "SOWFF, (Scots) to whistle or hum softly, also SOWF, SOWTH [v]\n",
  "SOWFING": "SOWF, (Scots) to whistle or hum softly, also SOWFF, SOWTH [v]\n",
  "SOWFS": "SOWF, (Scots) to whistle or hum softly, also SOWFF, SOWTH [v]\n",
  "SOWING": "the act of sowing [n -S]\n",
  "SOWINGS": "SOWING, the act of sowing [n]\n",
  "SOWL": "(dialect) to lug, drag, also SOOLE, SOWLE [v -ED, -ING, -S]\n",
  "SOWLE": "(Scots) to pull by the ears, also SOOLE, SOWL [v SOWLED, SOWLING, SOWLES]\n",
  "SOWLED": "SOWLE, (Scots) to pull by the ears, also SOOLE, SOWL [v]\n",
  "SOWLES": "SOWLE, (Scots) to pull by the ears, also SOOLE, SOWL [v]\n",
  "SOWLING": "SOWLE, (Scots) to pull by the ears, also SOOLE, SOWL [v]\n",
  "SOWLS": "SOWL, (dialect) to lug, drag, also SOOLE, SOWLE [v]\n",
  "SOWM": "(Scots) to ascertain the ratio of cattle to pasture, also SOUM [v -ED, -ING, -S]\n",
  "SOWMED": "SOWM, (Scots) to ascertain the ratio of cattle to pasture, also SOUM [v]\n",
  "SOWMING": "SOWM, (Scots) to ascertain the ratio of cattle to pasture, also SOUM [v]\n",
  "SOWMS": "SOWM, (Scots) to ascertain the ratio of cattle to pasture, also SOUM [v]\n",
  "SOWN": "SOW, to scatter seeds for a crop [v]\n",
  "SOWND": "(Spenser) to wield [v -ED, -ING, -S]\n",
  "SOWNDED": "SOWND, (Spenser) to wield [v]\n",
  "SOWNDING": "SOWND, (Spenser) to wield [v]\n",
  "SOWNDS": "SOWND, (Spenser) to wield [v]\n",
  "SOWNE": "(Spenser) sound [n -S]\n",
  "SOWNES": "SOWNE, (Spenser) sound [n]\n",
  "SOWP": "(Scots) to soak [v -ED, -ING, -S]\n",
  "SOWPED": "SOWP, (Scots) to soak [v]\n",
  "SOWPING": "SOWP, (Scots) to soak [v]\n",
  "SOWPS": "SOWP, (Scots) to soak [v]\n",
  "SOWS": "SOW, to scatter seeds for a crop [v]\n",
  "SOWSE": "(Spenser) to souse, also SOUCE, SOWCE, SOWSSE [v SOWSED, SOWSING, SOWSES]\n",
  "SOWSED": "SOWSE, (Spenser) to souse, also SOUCE, SOWCE, SOWSSE [v]\n",
  "SOWSES": "SOWSE, (Spenser) to souse, also SOUCE, SOWCE, SOWSSE [v]\n",
  "SOWSING": "SOWSE, (Spenser) to souse, also SOUCE, SOWCE, SOWSSE [v]\n",
  "SOWSSE": "(Spenser) to souse, also SOUCE, SOWCE, SOWSE [v SOWSSED, SOWSSING, SOWSSES]\n",
  "SOWSSED": "SOWSSE, (Spenser) to souse, also SOUCE, SOWCE, SOWSE [v]\n",
  "SOWSSES": "SOWSSE, (Spenser) to souse, also SOUCE, SOWCE, SOWSE [v]\n",
  "SOWSSING": "SOWSSE, (Spenser) to souse, also SOUCE, SOWCE, SOWSE [v]\n",
  "SOWTER": "(Scots) a cobbler, also SOUTAR, SOUTER, SUTOR [n -S]\n",
  "SOWTERS": "SOWTER, (Scots) a cobbler, also SOUTAR, SOUTER, SUTOR [n]\n",
  "SOWTH": "(Scots) to whistle or hum softly, also SOWF, SOWFF [v -ED, -ING, -S]\n",
  "SOWTHED": "SOWTH, (Scots) to whistle or hum softly, also SOWF, SOWFF [v]\n",
  "SOWTHING": "SOWTH, (Scots) to whistle or hum softly, also SOWF, SOWFF [v]\n",
  "SOWTHS": "SOWTH, (Scots) to whistle or hum softly, also SOWF, SOWFF [v]\n",
  "SOX": "(slang) socks [n]\n",
  "SOY": "a dark, salty sauce made from fermented beans and wheat flour, also SOJA, SOYA [n -S]\n",
  "SOYA": "a dark, salty sauce made from fermented soy beans and wheat flour, also SOJA, SOY [n -S]\n",
  "SOYAS": "SOYA, a dark, salty sauce made from fermented soy beans and wheat flour, also SOJA, SOY [n]\n",
  "SOYBEAN": "a bean produced by an eastern Asiatic plant [n -S]\n",
  "SOYBEANS": "SOYBEAN, a bean produced by an eastern Asiatic plant [n]\n",
  "SOYBURGER": "a burger made with soya rather than meat [n -S]\n",
  "SOYBURGERS": "SOYBURGER, a burger made with soya rather than meat [n]\n",
  "SOYLE": "(obsolete) to elucidate [v SOYLED, SOYLING, SOYLES]\n",
  "SOYLED": "SOYLE, (obsolete) to elucidate [v]\n",
  "SOYLES": "SOYLE, (obsolete) to elucidate [v]\n",
  "SOYLING": "SOYLE, (obsolete) to elucidate [v]\n",
  "SOYMEAL": "the residue of the extraction of oil from soybean seeds [n -S]\n",
  "SOYMEALS": "SOYMEAL, the residue of the extraction of oil from soybean seeds [n]\n",
  "SOYMILK": "a milk substitute made from soybeans [n -S]\n",
  "SOYMILKS": "SOYMILK, a milk substitute made from soybeans [n]\n",
  "SOYS": "SOY, a dark, salty sauce made from fermented beans and wheat flour, also SOJA, SOYA [n]\n",
  "SOYUZ": "(Russian) a Soviet manned spacecraft [n -ES]\n",
  "SOYUZES": "SOYUZ, (Russian) a Soviet manned spacecraft [n]\n",
  "SOZ": "(short for) sorry [interj]\n",
  "SOZIN": "a type of protein, also SOZINE [n -S]\n",
  "SOZINE": "a type of protein, also SOZIN [n -S]\n",
  "SOZINES": "SOZINE, a type of protein, also SOZIN [n]\n",
  "SOZINS": "SOZIN, a type of protein, also SOZINE [n]\n",
  "SOZZLE": "to intoxicate [v SOZZLED, SOZZLING, SOZZLES]\n",
  "SOZZLED": "SOZZLE, to intoxicate [v]\n",
  "SOZZLES": "SOZZLE, to intoxicate [v]\n",
  "SOZZLIER": "SOZZLY, drunk [adj]\n",
  "SOZZLIEST": "SOZZLY, drunk [adj]\n",
  "SOZZLING": "SOZZLE, to intoxicate [v]\n",
  "SOZZLY": "drunk [adj SOZZLIER, SOZZLIEST]\n",
  "SPA": "a resort with a mineral spring [n -S] / to stay at a spa [v -ED, -ING, -S]\n",
  "SPACE": "to arrange at intervals apart [v SPACED, SPACING, SPACES]\n",
  "SPACEBAND": "a wedge for justifying the line in mediaeval typesetting [n -S]\n",
  "SPACEBANDS": "SPACEBAND, a wedge for justifying the line in mediaeval typesetting [n]\n",
  "SPACEBORNE": "carried in space e.g. of spores [adj]\n",
  "SPACECRAFT": "a vehicle or device designed for travel or operation outside the earth's atmosphere [n -S]\n",
  "SPACECRAFTS": "SPACECRAFT, a vehicle or device designed for travel or operation outside the earth's atmosphere [n]\n",
  "SPACED": "SPACE, to arrange at intervals apart [v]\n",
  "SPACEFARING": "voyaging in space [n -S]\n",
  "SPACEFARINGS": "SPACEFARING, voyaging in space [n]\n",
  "SPACEFLIGHT": "flight beyond the earth's atmosphere [n -S]\n",
  "SPACEFLIGHTS": "SPACEFLIGHT, flight beyond the earth's atmosphere [n]\n",
  "SPACELAB": "a laboratory in space where scientific experiments are performed [n -S]\n",
  "SPACELABS": "SPACELAB, a laboratory in space where scientific experiments are performed [n]\n",
  "SPACELESS": "without space [adj]\n",
  "SPACEMAN": "an astronaut [n SPACEMEN]\n",
  "SPACEMEN": "SPACEMAN, an astronaut [n]\n",
  "SPACEPLANE": "an aircraft that can fly in space [n -S]\n",
  "SPACEPLANES": "SPACEPLANE, an aircraft that can fly in space [n]\n",
  "SPACEPORT": "a place from which spacecraft are launched [n -S]\n",
  "SPACEPORTS": "SPACEPORT, a place from which spacecraft are launched [n]\n",
  "SPACER": "someone who, or something which, spaces [n -S]\n",
  "SPACERS": "SPACER, someone who, or something which, spaces [n]\n",
  "SPACES": "SPACE, to arrange at intervals apart [v]\n",
  "SPACESHIP": "a spacecraft [n -S]\n",
  "SPACESHIPS": "SPACESHIP, a spacecraft [n]\n",
  "SPACESUIT": "a protective suit worn by astronauts [n -S]\n",
  "SPACESUITS": "SPACESUIT, a protective suit worn by astronauts [n]\n",
  "SPACETIME": "time and three-dimensional space regarded as fused in a four-dimensional continuum [n -S]\n",
  "SPACETIMES": "SPACETIME, time and three-dimensional space regarded as fused in a four-dimensional continuum [n]\n",
  "SPACEWALK": "an excursion by an astronaut outside his or her craft while in space [n -S] / to walk in space [v -ED, -ING, -S]\n",
  "SPACEWALKED": "SPACEWALK, to walk in space [v]\n",
  "SPACEWALKER": "one who walks in space [n -S]\n",
  "SPACEWALKERS": "SPACEWALKER, one who walks in space [n]\n",
  "SPACEWALKING": "SPACEWALK, to walk in space [v]\n",
  "SPACEWALKS": "SPACEWALK, to walk in space [v]\n",
  "SPACEWARD": "towards space [adv]\n",
  "SPACEWOMAN": "a female astronaut [n SPACEWOMEN]\n",
  "SPACEWOMEN": "SPACEWOMAN, a female astronaut [n]\n",
  "SPACEY": "dreamy, behaving as if spaced out, also SPACY [adj SPACIER, SPACIEST]\n",
  "SPACIAL": "pertaining to space, also SPATIAL [adj SPACIALLY]\n",
  "SPACIALLY": "SPACIAL, pertaining to space, also SPATIAL [adv]\n",
  "SPACIER": "SPACY, weird in behaviour, also SPACEY [adj]\n",
  "SPACIEST": "SPACY, weird in behaviour, also SPACEY [adj]\n",
  "SPACINESS": "the state of being spacy [n -ES]\n",
  "SPACINESSES": "SPACINESS, the state of being spacy [n]\n",
  "SPACING": "the distance between any two objects [n -S]\n",
  "SPACINGS": "SPACING, the distance between any two objects [n]\n",
  "SPACIOUS": "ample in extent [adj SPACIOUSLY]\n",
  "SPACIOUSLY": "SPACIOUS, ample in extent [adv]\n",
  "SPACIOUSNESS": "the state of being spacious [n -ES]\n",
  "SPACIOUSNESSES": "SPACIOUSNESS, the state of being spacious [n]\n",
  "SPACKLE": "to fill cracks or holes [v SPACKLED, SPACKLING, SPACKLES]\n",
  "SPACKLED": "SPACKLE, to fill cracks or holes [v]\n",
  "SPACKLES": "SPACKLE, to fill cracks or holes [v]\n",
  "SPACKLING": "SPACKLE, to fill cracks or holes [v]\n",
  "SPACY": "weird in behaviour, also SPACEY [adj SPACIER, SPACIEST]\n",
  "SPADASSIN": "(Italian) a swordsman; a fighter [n -S]\n",
  "SPADASSINS": "SPADASSIN, (Italian) a swordsman; a fighter [n]\n",
  "SPADE": "to dig with an implement [v SPADED, SPADING, SPADES]\n",
  "SPADED": "SPADE, to dig with an implement [v]\n",
  "SPADEFEET": "SPADEFOOT, a kind of toad [n]\n",
  "SPADEFISH": "a fish, a member of the sturgeon family, aka paddlefish [n -ES]\n",
  "SPADEFISHES": "SPADEFISH, a fish, a member of the sturgeon family, aka paddlefish [n]\n",
  "SPADEFOOT": "a kind of toad [n SPADEFEET or SPADEFOOTS]\n",
  "SPADEFOOTS": "SPADEFOOT, a kind of toad [n]\n",
  "SPADEFUL": "as much as a spade can hold [n -S]\n",
  "SPADEFULS": "SPADEFUL, as much as a spade can hold [n]\n",
  "SPADELIKE": "like a spade [adj]\n",
  "SPADEMAN": "a worker with a spade [n SPADEMEN]\n",
  "SPADEMEN": "SPADEMAN, a worker with a spade [n]\n",
  "SPADER": "one who, or that which, spades; specifically, a digging machine [n -S]\n",
  "SPADERS": "SPADER, one who, or that which, spades; specifically, a digging machine [n]\n",
  "SPADES": "SPADE, to dig with an implement [v]\n",
  "SPADESMAN": "a worker with the spade [n SPADESMEN]\n",
  "SPADESMEN": "SPADESMAN, a worker with the spade [n]\n",
  "SPADEWORK": "preparatory drudgery [n -S]\n",
  "SPADEWORKS": "SPADEWORK, preparatory drudgery [n]\n",
  "SPADGER": "(slang) a sparrow [n -S]\n",
  "SPADGERS": "SPADGER, (slang) a sparrow [n]\n",
  "SPADICEOUS": "chestnut-coloured [adj]\n",
  "SPADICES": "SPADIX, (Greek) a flower-spike covered by large leaf, as in the arum plant [n]\n",
  "SPADICIFLORAL": "having flowers in a spathe, as do arum, palms, and some other monocotyledons [adj]\n",
  "SPADILLE": "the ace of spades in the game of ombre, also SPADILLIO, SPADILLO [n -S]\n",
  "SPADILLES": "SPADILLE, the ace of spades in the game of ombre, also SPADILLIO, SPADILLO [n]\n",
  "SPADILLIO": "(obsolete) the ace of spades in the game of ombre, also SPADILLE, SPADILLO [n -S]\n",
  "SPADILLIOS": "SPADILLIO, (obsolete) the ace of spades in the game of ombre, also SPADILLE, SPADILLO [n]\n",
  "SPADILLO": "(obsolete) the ace of spades in the game of ombre, also SPADILLE, SPADILLIO [n -S]\n",
  "SPADILLOS": "SPADILLO, (obsolete) the ace of spades in the game of ombre, also SPADILLE, SPADILLIO [n]\n",
  "SPADING": "SPADE, to dig with an implement [v]\n",
  "SPADIX": "(Greek) a flower-spike covered by large leaf, as in the arum plant [n SPADICES or SPADIXES]\n",
  "SPADIXES": "SPADIX, (Greek) a flower-spike covered by large leaf, as in the arum plant [n]\n",
  "SPADO": "(Latin) a castrated or impotent person or animal [n SPADOES, SPADOS or SPADONES]\n",
  "SPADOES": "SPADO, (Latin) a castrated or impotent person or animal [n]\n",
  "SPADONES": "SPADO, (Latin) a castrated or impotent person or animal [n]\n",
  "SPADOS": "SPADO, (Latin) a castrated or impotent person or animal [n]\n",
  "SPADROON": "(historical) a sword, esp. a broadsword, formerly used both to cut and thrust [n -S]\n",
  "SPADROONS": "SPADROON, (historical) a sword, esp. a broadsword, formerly used both to cut and thrust [n]\n",
  "SPAE": "(Old Norse) to foretell [v SPAED, SPAEING, SPAES]\n",
  "SPAED": "SPAE, (Old Norse) to foretell [v]\n",
  "SPAEING": "the act of foretelling [n -S]\n",
  "SPAEINGS": "SPAEING, the act of foretelling [n]\n",
  "SPAEMAN": "a fortune teller [n SPAEMEN]\n",
  "SPAEMEN": "SPAEMAN, a fortune teller [n]\n",
  "SPAER": "(Scots) one who foresees the future [n -S]\n",
  "SPAERS": "SPAER, (Scots) one who foresees the future [n]\n",
  "SPAES": "SPAE, (Old Norse) to foretell [v]\n",
  "SPAETZLE": "(German) in Jewish cooking, a small dumpling, also SPATZLE [n -S]\n",
  "SPAETZLES": "SPAETZLE, (German) in Jewish cooking, a small dumpling, also SPATZLE [n]\n",
  "SPAEWIFE": "(Scots) a wise woman [n SPAEWIVES]\n",
  "SPAEWIVES": "SPAEWIFE, (Scots) a wise woman [n]\n",
  "SPAG": "(of a cat) to scratch with the claws [v SPAGGED, SPAGGING, SPAGS]\n",
  "SPAGERIC": "alchemical, also SPAGIRIC, SPAGYRIC, SPAGYRICAL [adj]\n",
  "SPAGGED": "SPAG, (of a cat) to scratch with the claws [v]\n",
  "SPAGGING": "SPAG, (of a cat) to scratch with the claws [v]\n",
  "SPAGHETTI": "(Italian) pasta in the form of long solid threads, between macaroni and vermicelli in thickness [n -S]\n",
  "SPAGHETTIFIED": "SPAGHETTIFY, to make into spaghetti, with particular reference to black holes [v]\n",
  "SPAGHETTIFIES": "SPAGHETTIFY, to make into spaghetti, with particular reference to black holes [v]\n",
  "SPAGHETTIFY": "to make into spaghetti, with particular reference to black holes [v SPAGHETTIFIED, SPAGHETTIFYING, SPAGHETTIFIES]\n",
  "SPAGHETTIFYING": "SPAGHETTIFY, to make into spaghetti, with particular reference to black holes [v]\n",
  "SPAGHETTILIKE": "like spaghetti [adj]\n",
  "SPAGHETTINI": "(Italian) pasta in the form of strings of thin spaghetti [n -S]\n",
  "SPAGHETTINIS": "SPAGHETTINI, (Italian) pasta in the form of strings of thin spaghetti [n]\n",
  "SPAGHETTIS": "SPAGHETTI, (Italian) pasta in the form of long solid threads, between macaroni and vermicelli in thickness [n]\n",
  "SPAGIRIC": "pertaining to alchemy, also SPAGERIC, SPAGYRIC [adj]\n",
  "SPAGIRIST": "an alchemist, also SPAGYRIST [n -S]\n",
  "SPAGIRISTS": "SPAGIRIST, an alchemist, also SPAGYRIST [n]\n",
  "SPAGS": "SPAG, (of a cat) to scratch with the claws [v]\n",
  "SPAGYRIC": "alchemical, also SPAGERIC, SPAGIRIC, SPAGYRICAL [adj SPAGYRICALLY]\n",
  "SPAGYRICAL": "alchemical, also SPAGERIC, SPAGIRIC, SPAGYRIC [adj SPAGYRICALLY]\n",
  "SPAGYRICALLY": "SPAGYRICAL, alchemical, also SPAGERIC, SPAGIRIC, SPAGYRIC [adv]\n",
  "SPAGYRICS": "the science of alchemy [n]\n",
  "SPAGYRIST": "an alchemist, also SPAGIRIST [n -S]\n",
  "SPAGYRISTS": "SPAGYRIST, an alchemist, also SPAGIRIST [n]\n",
  "SPAHEE": "(Turkish) formerly, a Turkish or French Algerian cavalryman, also SPAHI [n -S]\n",
  "SPAHEES": "SPAHEE, (Turkish) formerly, a Turkish or French Algerian cavalryman, also SPAHI [n]\n",
  "SPAHI": "(Turkish) formerly, a Turkish or French Algerian cavalryman, also SPAHEE [n -S]\n",
  "SPAHIS": "SPAHI, (Turkish) formerly, a Turkish or French Algerian cavalryman, also SPAHEE [n]\n",
  "SPAIL": "a splinter or chip, also SPALE, SPALL, SPALT [n -S]\n",
  "SPAILS": "SPAIL, a splinter or chip, also SPALE, SPALL, SPALT [n]\n",
  "SPAIN": "(Scots) to wean, also SPANE, SPEAN [v -ED, -ING, -S]\n",
  "SPAINED": "SPAIN, (Scots) to wean, also SPANE, SPEAN [v]\n",
  "SPAING": "staying at a spa [n -S]\n",
  "SPAINGS": "SPAING, staying at a spa [n]\n",
  "SPAINING": "SPAIN, (Scots) to wean, also SPANE, SPEAN [v]\n",
  "SPAINS": "SPAIN, (Scots) to wean, also SPANE, SPEAN [v]\n",
  "SPAIRGE": "to sprinkle (with moisture), also SPARGE [v SPAIRGED, SPAIRGING, SPAIRGES]\n",
  "SPAIRGED": "SPAIRGE, to sprinkle (with moisture), also SPARGE [v]\n",
  "SPAIRGES": "SPAIRGE, to sprinkle (with moisture), also SPARGE [v]\n",
  "SPAIRGING": "SPAIRGE, to sprinkle (with moisture), also SPARGE [v]\n",
  "SPAIT": "a flood, a surge, also SPATE, SPEAT [n -S]\n",
  "SPAITS": "SPAIT, a flood, a surge, also SPATE, SPEAT [n]\n",
  "SPAKE": "SPEAK, to speak [v]\n",
  "SPALD": "(Scots) the shoulder, esp. of an animal used as food, also SPALLE, SPAUL, SPAULD, SPEAL, SPULE [n -S]\n",
  "SPALDEEN": "a small hollow rubber ball used in a street game [n -S]\n",
  "SPALDEENS": "SPALDEEN, a small hollow rubber ball used in a street game [n]\n",
  "SPALDS": "SPALD, (Scots) the shoulder, esp. of an animal used as food, also SPALLE, SPAUL, SPAULD, SPEAL, SPULE [n]\n",
  "SPALE": "(Scots) a splinter, chip, also SPAIL, SPALL, SPALT [n -S]\n",
  "SPALES": "SPALE, (Scots) a splinter, chip, also SPAIL, SPALL, SPALT [n]\n",
  "SPALL": "to break up into fragments [v -ED, -ING, -S]\n",
  "SPALLABLE": "that can be spalled [adj]\n",
  "SPALLATION": "splitting into numerous fragments of the nucleus of an atom by high-energy bombardment [n -S]\n",
  "SPALLATIONS": "SPALLATION, splitting into numerous fragments of the nucleus of an atom by high-energy bombardment [n]\n",
  "SPALLE": "(Spenser) the shoulder, esp. of an animal used as food, also SPALD, SPAUL, SPAULD, SPEAL, SPULE [n -S]\n",
  "SPALLED": "SPALL, to break up into fragments [v]\n",
  "SPALLER": "one who spalls; a tool for spalling [n -S]\n",
  "SPALLERS": "SPALLER, one who spalls; a tool for spalling [n]\n",
  "SPALLES": "SPALLE, (Spenser) the shoulder, esp. of an animal used as food, also SPALD, SPAUL, SPAULD, SPEAL, SPULE [n]\n",
  "SPALLING": "the breaking of stone or concrete from a surface, usually caused by water ingress through fine cracks [n -S]\n",
  "SPALLINGS": "SPALLING, the breaking of stone or concrete from a surface, usually caused by water ingress through fine cracks [n]\n",
  "SPALLS": "SPALL, to break up into fragments [v]\n",
  "SPALPEEN": "(Irish) a scamp, a good-for-nothing fellow [n -S]\n",
  "SPALPEENS": "SPALPEEN, (Irish) a scamp, a good-for-nothing fellow [n]\n",
  "SPALT": "to splinter [v -ED, -ING, -S]\n",
  "SPALTED": "SPALT, to splinter [v]\n",
  "SPALTING": "SPALT, to splinter [v]\n",
  "SPALTS": "SPALT, to splinter [v]\n",
  "SPAM": "electronic junk mail [n -S] / to send out spam [v SPAMMED, SPAMMING, SPAMS]\n",
  "SPAMBOT": "a computer program that sends out unsolicited email [n -S]\n",
  "SPAMBOTS": "SPAMBOT, a computer program that sends out unsolicited email [n]\n",
  "SPAMMED": "SPAM, to send out spam [v]\n",
  "SPAMMER": "someone who sends out spam (electronic junk mail) [n -S]\n",
  "SPAMMERS": "SPAMMER, someone who sends out spam (electronic junk mail) [n]\n",
  "SPAMMIE": "(dialect) a lovebite [n -S]\n",
  "SPAMMIER": "SPAMMY, bland, unexciting [adj]\n",
  "SPAMMIES": "SPAMMIE, (dialect) a lovebite [n]\n",
  "SPAMMIEST": "SPAMMY, bland, unexciting [adj]\n",
  "SPAMMING": "sending out electronic junk mail [n -S]\n",
  "SPAMMINGS": "SPAMMING, sending out electronic junk mail [n]\n",
  "SPAMMY": "bland, unexciting [adj SPAMMIER, SPAMMIEST]\n",
  "SPAMS": "SPAM, to send out spam [v]\n",
  "SPAN": "to extend over or across [v SPANNED, SPANNING, SPANS]\n",
  "SPANAEMIA": "a deficiency of red corpuscles in the blood [n -S]\n",
  "SPANAEMIAS": "SPANAEMIA, a deficiency of red corpuscles in the blood [n]\n",
  "SPANAEMIC": "of or pertaining to spanaemia; having impoverished blood [adj]\n",
  "SPANAKOPITA": "(Modern Greek) a Greek dish of spinach and feta cheese in filo pastry, also SPANOKOPITA [n -S]\n",
  "SPANAKOPITAS": "SPANAKOPITA, (Modern Greek) a Greek dish of spinach and feta cheese in filo pastry, also SPANOKOPITA [n]\n",
  "SPANCEL": "to bind with a rope [v SPANCELED or SPANCELLED, SPANCELING or SPANCELLING, SPANCELS]\n",
  "SPANCELED": "SPANCEL, to bind with a rope [v]\n",
  "SPANCELING": "SPANCEL, to bind with a rope [v]\n",
  "SPANCELLED": "SPANCEL, to bind with a rope [v]\n",
  "SPANCELLING": "SPANCEL, to bind with a rope [v]\n",
  "SPANCELS": "SPANCEL, to bind with a rope [v]\n",
  "SPANDEX": "(tradename) a synthetic elastic fibre [n -ES]\n",
  "SPANDEXED": "wearing spandex [adj]\n",
  "SPANDEXES": "SPANDEX, (tradename) a synthetic elastic fibre [n]\n",
  "SPANDREL": "a space between two adjoining arches, also SPANDRIL [n -S]\n",
  "SPANDRELS": "SPANDREL, a space between two adjoining arches, also SPANDRIL [n]\n",
  "SPANDRIL": "a space between two adjoining arches, also SPANDREL [n -S]\n",
  "SPANDRILS": "SPANDRIL, a space between two adjoining arches, also SPANDREL [n]\n",
  "SPANE": "(Scots) to wean, also SPAIN, SPEAN [v SPANED, SPANING, SPANES]\n",
  "SPANED": "SPANE, (Scots) to wean, also SPAIN, SPEAN [v]\n",
  "SPANES": "SPANE, (Scots) to wean, also SPAIN, SPEAN [v]\n",
  "SPANG": "to cover with glittering ornaments [v -ED, -ING, -S]\n",
  "SPANGED": "SPANG, to cover with glittering ornaments [v]\n",
  "SPANGHEW": "(dialect) to fling into the air [v -ED, -ING, -S]\n",
  "SPANGHEWED": "SPANGHEW, (dialect) to fling into the air [v]\n",
  "SPANGHEWING": "SPANGHEW, (dialect) to fling into the air [v]\n",
  "SPANGHEWS": "SPANGHEW, (dialect) to fling into the air [v]\n",
  "SPANGING": "SPANG, to cover with glittering ornaments [v]\n",
  "SPANGLE": "to adorn with bits of sparkling metal [v SPANGLED, SPANGLING, SPANGLES]\n",
  "SPANGLED": "SPANGLE, to adorn with bits of sparkling metal [v]\n",
  "SPANGLER": "one who spangles [n -S]\n",
  "SPANGLERS": "SPANGLER, one who spangles [n]\n",
  "SPANGLES": "SPANGLE, to adorn with bits of sparkling metal [v]\n",
  "SPANGLET": "a sparkling bit of metal [n -S]\n",
  "SPANGLETS": "SPANGLET, a sparkling bit of metal [n]\n",
  "SPANGLIER": "SPANGLY, covered with spangles [adj]\n",
  "SPANGLIEST": "SPANGLY, covered with spangles [adj]\n",
  "SPANGLING": "the act of adorning with spangles [n -S]\n",
  "SPANGLINGS": "SPANGLING, the act of adorning with spangles [n]\n",
  "SPANGLY": "covered with spangles [adj SPANGLIER, SPANGLIEST]\n",
  "SPANGS": "SPANG, to cover with glittering ornaments [v]\n",
  "SPANIEL": "a breed of dog [n -S] / to follow devotedly [v SPANIELLED, SPANIELLING, SPANIELS]\n",
  "SPANIELLED": "SPANIEL, to follow devotedly [v]\n",
  "SPANIELLING": "SPANIEL, to follow devotedly [v]\n",
  "SPANIELS": "SPANIEL, to follow devotedly [v]\n",
  "SPANING": "SPANE, (Scots) to wean, also SPAIN, SPEAN [v]\n",
  "SPANIOLATE": "to hispanicize, make Spanish [v SPANIOLATED, SPANIOLATING, SPANIOLATES]\n",
  "SPANIOLATED": "SPANIOLATE, to hispanicize, make Spanish [v]\n",
  "SPANIOLATES": "SPANIOLATE, to hispanicize, make Spanish [v]\n",
  "SPANIOLATING": "SPANIOLATE, to hispanicize, make Spanish [v]\n",
  "SPANIOLISE": "to hispanicize, also SPANIOLIZE [v SPANIOLISED, SPANIOLISING, SPANIOLISES]\n",
  "SPANIOLISED": "SPANIOLISE, to hispanicize, also SPANIOLIZE [v]\n",
  "SPANIOLISES": "SPANIOLISE, to hispanicize, also SPANIOLIZE [v]\n",
  "SPANIOLISING": "SPANIOLISE, to hispanicize, also SPANIOLIZE [v]\n",
  "SPANIOLIZE": "to hispanicize, also SPANIOLISE [v SPANIOLIZED, SPANIOLIZING, SPANIOLIZES]\n",
  "SPANIOLIZED": "SPANIOLIZE, to hispanicize, also SPANIOLISE [v]\n",
  "SPANIOLIZES": "SPANIOLIZE, to hispanicize, also SPANIOLISE [v]\n",
  "SPANIOLIZING": "SPANIOLIZE, to hispanicize, also SPANIOLISE [v]\n",
  "SPANK": "to slap on the buttocks [v -ED, -ING, -S]\n",
  "SPANKED": "SPANK, to slap on the buttocks [v]\n",
  "SPANKER": "the sail on the mast nearest the stern of a square-rigged ship [n -S]\n",
  "SPANKERS": "SPANKER, the sail on the mast nearest the stern of a square-rigged ship [n]\n",
  "SPANKING": "spirited, going freely [adj SPANKINGLY] / the act of one that spanks [n -S]\n",
  "SPANKINGLY": "SPANKING, spirited, going freely [adv]\n",
  "SPANKINGS": "SPANKING, the act of one that spanks [n]\n",
  "SPANKS": "SPANK, to slap on the buttocks [v]\n",
  "SPANLESS": "having no extent [adj]\n",
  "SPANNED": "SPAN, to extend over or across [v]\n",
  "SPANNER": "a tool for undoing nuts [n -S]\n",
  "SPANNERS": "SPANNER, a tool for undoing nuts [n]\n",
  "SPANNING": "SPAN, to extend over or across [v]\n",
  "SPANOKOPITA": "(Modern Greek) a Greek dish of spinach and feta cheese in filo pastry, also SPANAKOPITA [n -S]\n",
  "SPANOKOPITAS": "SPANOKOPITA, (Modern Greek) a Greek dish of spinach and feta cheese in filo pastry, also SPANAKOPITA [n]\n",
  "SPANS": "SPAN, to extend over or across [v]\n",
  "SPANSPEK": "(South African) a sweet tough-skinned melon [n -S]\n",
  "SPANSPEKS": "SPANSPEK, (South African) a sweet tough-skinned melon [n]\n",
  "SPANSULE": "a pill [n -S]\n",
  "SPANSULES": "SPANSULE, a pill [n]\n",
  "SPANWORM": "the larva of any geometrid moth, such as the cankerworm [n -S]\n",
  "SPANWORMS": "SPANWORM, the larva of any geometrid moth, such as the cankerworm [n]\n",
  "SPAR": "to practise boxing [v SPARRED, SPARRING, SPARS]\n",
  "SPARABLE": "a type of nail [n -S]\n",
  "SPARABLES": "SPARABLE, a type of nail [n]\n",
  "SPARAGMATIC": "like a Sparagmite, a type of Precambrian rock [adj]\n",
  "SPARAGRASS": "(dialect) asparagus [n -ES]\n",
  "SPARAGRASSES": "SPARAGRASS, (dialect) asparagus [n]\n",
  "SPARAXIS": "a South African iridaceous plant with starlike flowers and lacerated spathes [n -ES]\n",
  "SPARAXISES": "SPARAXIS, a South African iridaceous plant with starlike flowers and lacerated spathes [n]\n",
  "SPARD": "(archaic) spared [adj]\n",
  "SPARE": "meagre [adj SPARER, SPAREST, SPARELY] / to refrain from punishing, harming, or destroying [v SPARED, SPARING, SPARES]\n",
  "SPAREABLE": "that can be spared [adj]\n",
  "SPARED": "SPARE, to refrain from punishing, harming, or destroying [v]\n",
  "SPARELESS": "unsparing [adj]\n",
  "SPARELY": "SPARE, meagre [adv]\n",
  "SPARENESS": "the state of being spare; leanness [n -ES]\n",
  "SPARENESSES": "SPARENESS, the state of being spare; leanness [n]\n",
  "SPARER": "one who spares [n -S]\n",
  "SPARERIB": "a cut of pork [n -S]\n",
  "SPARERIBS": "SPARERIB, a cut of pork [n]\n",
  "SPARERS": "SPARER, one who spares [n]\n",
  "SPARES": "SPARE, to refrain from punishing, harming, or destroying [v]\n",
  "SPAREST": "SPARE, meagre [adj]\n",
  "SPARGANIUM": "a plant of the bur-reed genus [n -S]\n",
  "SPARGANIUMS": "SPARGANIUM, a plant of the bur-reed genus [n]\n",
  "SPARGE": "to sprinkle (with moisture), also SPAIRGE [v SPARGED, SPARGING, SPARGES]\n",
  "SPARGED": "SPARGE, to sprinkle (with moisture), also SPAIRGE [v]\n",
  "SPARGER": "a vessel with a perforated cover, for sprinkling with a liquid [n -S]\n",
  "SPARGERS": "SPARGER, a vessel with a perforated cover, for sprinkling with a liquid [n]\n",
  "SPARGES": "SPARGE, to sprinkle (with moisture), also SPAIRGE [v]\n",
  "SPARGING": "SPARGE, to sprinkle (with moisture), also SPAIRGE [v]\n",
  "SPARID": "any of a family of marine fishes, also SPAROID [n -S]\n",
  "SPARIDS": "SPARID, any of a family of marine fishes, also SPAROID [n]\n",
  "SPARING": "frugal [adj SPARINGLY]\n",
  "SPARINGLY": "SPARING, frugal [adv]\n",
  "SPARINGNESS": "the state of being sparing [n -ES]\n",
  "SPARINGNESSES": "SPARINGNESS, the state of being sparing [n]\n",
  "SPARK": "to emit small fiery particles [v -ED, -ING, -S]\n",
  "SPARKE": "(Spenser) a weapon of some kind, possibly an error for sparthe [n -S]\n",
  "SPARKED": "SPARK, to emit small fiery particles [v]\n",
  "SPARKER": "a powerful form of sonar apparatus used to investigate solid structures underlying sediment on the seabed [n -S]\n",
  "SPARKERS": "SPARKER, a powerful form of sonar apparatus used to investigate solid structures underlying sediment on the seabed [n]\n",
  "SPARKES": "SPARKE, (Spenser) a weapon of some kind, possibly an error for sparthe [n]\n",
  "SPARKIE": "(colloquial) an electrician, also SPARKY [n -S]\n",
  "SPARKIER": "SPARKY, lively, also SPARKIE [adj]\n",
  "SPARKIES": "SPARKIE, (colloquial) an electrician, also SPARKY [n]\n",
  "SPARKIEST": "SPARKY, lively, also SPARKIE [adj]\n",
  "SPARKILY": "SPARKY, lively, also SPARKIE [adv]\n",
  "SPARKING": "SPARK, to emit small fiery particles [v]\n",
  "SPARKISH": "jaunty, showy [adj]\n",
  "SPARKISHLY": "SPARKISH, jaunty, showy [adv]\n",
  "SPARKLE": "to reflect flashes of light [v SPARKLED, SPARKLING, SPARKLES]\n",
  "SPARKLEBERRIES": "SPARKLEBERRY, a shrub or small tree bearing black berries, native to southern parts of North America [n]\n",
  "SPARKLEBERRY": "a shrub or small tree bearing black berries, native to southern parts of North America [n SPARKLEBERRIES]\n",
  "SPARKLED": "SPARKLE, to reflect flashes of light [v]\n",
  "SPARKLER": "something that sparkles [n -S]\n",
  "SPARKLERS": "SPARKLER, something that sparkles [n]\n",
  "SPARKLES": "SPARKLE, to reflect flashes of light [v]\n",
  "SPARKLESS": "without a spark [adj SPARKLESSLY]\n",
  "SPARKLESSLY": "SPARKLESS, without a spark [adv]\n",
  "SPARKLET": "a small spark [n -S]\n",
  "SPARKLETS": "SPARKLET, a small spark [n]\n",
  "SPARKLIER": "SPARKLY, sparkling [adj]\n",
  "SPARKLIES": "SPARKLY, something that sparkles [n]\n",
  "SPARKLIEST": "SPARKLY, sparkling [adj]\n",
  "SPARKLING": "giving off flashes of light [adj SPARKLINGLY] / the act of sparkling [n -S]\n",
  "SPARKLINGLY": "SPARKLING, giving off flashes of light [adv]\n",
  "SPARKLINGS": "SPARKLING, the act of sparkling [n]\n",
  "SPARKLY": "sparkling [adj SPARKLIER, SPARKLIEST] / something that sparkles [n SPARKLIES]\n",
  "SPARKPLUG": "to spark something off, in the manner of a sparkplug in a car carrying wires between which an electric spark passes to fire the explosive mixture of gases [v SPARKPLUGGED, SPARKPLUGGING, SPARKPLUGS]\n",
  "SPARKPLUGGED": "SPARKPLUG, to spark something off, in the manner of a sparkplug in a car carrying wires between which an electric spark passes to fire the explosive mixture of gases [v]\n",
  "SPARKPLUGGING": "SPARKPLUG, to spark something off, in the manner of a sparkplug in a car carrying wires between which an electric spark passes to fire the explosive mixture of gases [v]\n",
  "SPARKPLUGS": "SPARKPLUG, to spark something off, in the manner of a sparkplug in a car carrying wires between which an electric spark passes to fire the explosive mixture of gases [v]\n",
  "SPARKS": "SPARK, to emit small fiery particles [v]\n",
  "SPARKY": "lively, also SPARKIE [adj SPARKIER, SPARKIEST, SPARKILY] / an electrician [n SPARKIES]\n",
  "SPARLIKE": "resembling a spar [adj]\n",
  "SPARLING": "a kind of fish, the smelt, also SPERLING, SPIRLING [n -S]\n",
  "SPARLINGS": "SPARLING, a kind of fish, the smelt, also SPERLING, SPIRLING [n]\n",
  "SPAROID": "any of a family of marine fishes, also SPARID [n -S]\n",
  "SPAROIDS": "SPAROID, any of a family of marine fishes, also SPARID [n]\n",
  "SPARRE": "(archaic) a spar, a rafter [n -S]\n",
  "SPARRED": "SPAR, to practise boxing [v]\n",
  "SPARRER": "one who spars [n -S]\n",
  "SPARRERS": "SPARRER, one who spars [n]\n",
  "SPARRES": "SPARRE, (archaic) a spar, a rafter [n]\n",
  "SPARRIER": "SPARRY, having a confused crystalline structure [adj]\n",
  "SPARRIEST": "SPARRY, having a confused crystalline structure [adj]\n",
  "SPARRING": "the act of sparring [n -S]\n",
  "SPARRINGS": "SPARRING, the act of sparring [n]\n",
  "SPARROW": "a small bird [n -S]\n",
  "SPARROWFART": "(colloquial) the very early morning [n -S]\n",
  "SPARROWFARTS": "SPARROWFART, (colloquial) the very early morning [n]\n",
  "SPARROWGRASS": "(dialect) asparagus [n -ES]\n",
  "SPARROWGRASSES": "SPARROWGRASS, (dialect) asparagus [n]\n",
  "SPARROWHAWK": "any of several small hawks of Eurasia and North Africa that prey on smaller birds [n -S]\n",
  "SPARROWHAWKS": "SPARROWHAWK, any of several small hawks of Eurasia and North Africa that prey on smaller birds [n]\n",
  "SPARROWLIKE": "like a sparrow [adj]\n",
  "SPARROWS": "SPARROW, a small bird [n]\n",
  "SPARRY": "having a confused crystalline structure [adj SPARRIER, SPARRIEST]\n",
  "SPARS": "SPAR, to practise boxing [v]\n",
  "SPARSE": "thinly distributed [adj SPARSER, SPARSEST, SPARSELY]\n",
  "SPARSEDLY": "sparsely [adv]\n",
  "SPARSELY": "SPARSE, thinly distributed [adv]\n",
  "SPARSENESS": "the state of being sparse [n -ES]\n",
  "SPARSENESSES": "SPARSENESS, the state of being sparse [n]\n",
  "SPARSER": "SPARSE, thinly distributed [adj]\n",
  "SPARSEST": "SPARSE, thinly distributed [adj]\n",
  "SPARSITIES": "SPARSITY, the state of being sparse [n]\n",
  "SPARSITY": "the state of being sparse [n SPARSITIES]\n",
  "SPART": "esparto, Spanish broom [n -S]\n",
  "SPARTAN": "a crisp red-skinned eating apple of a variety originally bred in Canada to withstand cold winters [n -S]\n",
  "SPARTANS": "SPARTAN, a crisp red-skinned eating apple of a variety originally bred in Canada to withstand cold winters [n]\n",
  "SPARTEINE": "a narcotic alkaloid extracted from the tops of the common broom [n -S]\n",
  "SPARTEINES": "SPARTEINE, a narcotic alkaloid extracted from the tops of the common broom [n]\n",
  "SPARTERIE": "(French) articles made of esparto [n -S]\n",
  "SPARTERIES": "SPARTERIE, (French) articles made of esparto [n]\n",
  "SPARTH": "(archaic) a long battleaxe, also SPARTHE, SPERTHE [n -S]\n",
  "SPARTHE": "(archaic) a long battleaxe, also SPARTH, SPERTHE [n -S]\n",
  "SPARTHES": "SPARTHE, (archaic) a long battleaxe, also SPARTH, SPERTHE [n]\n",
  "SPARTHS": "SPARTH, (archaic) a long battleaxe, also SPARTHE, SPERTHE [n]\n",
  "SPARTICLE": "a shadow particle such as a squark believed to have been produced at the time of the Big Bang [n -S]\n",
  "SPARTICLES": "SPARTICLE, a shadow particle such as a squark believed to have been produced at the time of the Big Bang [n]\n",
  "SPARTINA": "a salt-marsh grass of coastal regions [n -S]\n",
  "SPARTINAS": "SPARTINA, a salt-marsh grass of coastal regions [n]\n",
  "SPARTS": "SPART, esparto, Spanish broom [n]\n",
  "SPAS": "SPA, a resort with a mineral spring [n]\n",
  "SPASM": "a sustained involuntary muscular contraction [n -S] / to go into spasm [v -ED, -ING, -S]\n",
  "SPASMATIC": "in spasms, also SPASMATICAL, SPASMIC [adj]\n",
  "SPASMATICAL": "in spasms, also SPASMATIC, SPASMIC [adj]\n",
  "SPASMED": "SPASM, to go into spasm [v]\n",
  "SPASMIC": "in spasms, also SPASMATIC, SPASMATICAL [adj]\n",
  "SPASMING": "SPASM, to go into spasm [v]\n",
  "SPASMODIC": "relating to, or occurring in, spasms, also SPASMODICAL [adj SPASMODICALLY]\n",
  "SPASMODICAL": "relating to, or occurring in, spasms, also SPASMODIC [adj SPASMODICALLY]\n",
  "SPASMODICALLY": "SPASMODICAL, relating to, or occurring in, spasms, also SPASMODIC [adv]\n",
  "SPASMODIST": "a person whose work is spasmodic [n -S]\n",
  "SPASMODISTS": "SPASMODIST, a person whose work is spasmodic [n]\n",
  "SPASMOLYTIC": "having the power to relieve spasms or convulsions [adj] / a spasmolytic drug [n -S]\n",
  "SPASMOLYTICS": "SPASMOLYTIC, a spasmolytic drug [n]\n",
  "SPASMS": "SPASM, to go into spasm [v]\n",
  "SPASTIC": "of the nature of a spasm [adj SPASTICALLY] / one affected with spastic paralysis [n -S]\n",
  "SPASTICALLY": "SPASTIC, of the nature of a spasm [adv]\n",
  "SPASTICITIES": "SPASTICITY, a state of spasm [n]\n",
  "SPASTICITY": "a state of spasm [n SPASTICITIES]\n",
  "SPASTICS": "SPASTIC, one affected with spastic paralysis [n]\n",
  "SPAT": "to slap, strike [v SPATTED, SPATTING, SPATS]\n",
  "SPATANGOID": "a heart urchin, a member of the Spangoidea, an order of more or less heart-shaped sea urchins with eccentric anus [n -S]\n",
  "SPATANGOIDS": "SPATANGOID, a heart urchin, a member of the Spangoidea, an order of more or less heart-shaped sea urchins with eccentric anus [n]\n",
  "SPATCHCOCK": "to split open (a fowl, eel etc.) for grilling, also SPITCHCOCK [v -ED, -ING, -S]\n",
  "SPATCHCOCKED": "SPATCHCOCK, to split open (a fowl, eel etc.) for grilling, also SPITCHCOCK [v]\n",
  "SPATCHCOCKING": "SPATCHCOCK, to split open (a fowl, eel etc.) for grilling, also SPITCHCOCK [v]\n",
  "SPATCHCOCKS": "SPATCHCOCK, to split open (a fowl, eel etc.) for grilling, also SPITCHCOCK [v]\n",
  "SPATE": "a flood, a surge, also SPAIT, SPEAT [n -S]\n",
  "SPATES": "SPATE, a flood, a surge, also SPAIT, SPEAT [n]\n",
  "SPATFALL": "a mass of shellfish larvae [n -S]\n",
  "SPATFALLS": "SPATFALL, a mass of shellfish larvae [n]\n",
  "SPATHACEOUS": "having a spathe [adj]\n",
  "SPATHAL": "furnished with a spathe; as, spathal flowers [adj]\n",
  "SPATHE": "a large sheath-like bract or leaf, as of arum plant [n -S]\n",
  "SPATHED": "having a spathe [adj]\n",
  "SPATHES": "SPATHE, a large sheath-like bract or leaf, as of arum plant [n]\n",
  "SPATHIC": "relating to spar, also SPATHOSE [adj]\n",
  "SPATHIPHYLLUM": "any tropical plant of the genus Spathiphyllum, having lance-shaped leaves and fleshy white spadices of flowers in white spathes [n -S]\n",
  "SPATHIPHYLLUMS": "SPATHIPHYLLUM, any tropical plant of the genus Spathiphyllum, having lance-shaped leaves and fleshy white spadices of flowers in white spathes [n]\n",
  "SPATHOSE": "relating to spar, also SPATHIC [adj]\n",
  "SPATHULATE": "spoon-shaped [adj]\n",
  "SPATIAL": "pertaining to space, also SPACIAL [adj SPATIALLY]\n",
  "SPATIALISATION": "the process of causing something to occupy space or assume some of the properties of space, also SPATIALIZATION [n -S]\n",
  "SPATIALISATIONS": "SPATIALISATION, the process of causing something to occupy space or assume some of the properties of space, also SPATIALIZATION [n]\n",
  "SPATIALITIES": "SPATIALITY, relation to space [n]\n",
  "SPATIALITY": "relation to space [n SPATIALITIES]\n",
  "SPATIALIZATION": "the process of causing something to occupy space or assume some of the properties of space, also SPATIALISATION [n -S]\n",
  "SPATIALIZATIONS": "SPATIALIZATION, the process of causing something to occupy space or assume some of the properties of space, also SPATIALISATION [n]\n",
  "SPATIALLY": "SPATIAL, pertaining to space, also SPACIAL [adv]\n",
  "SPATIOTEMPORAL": "pertaining to time and space [adj]\n",
  "SPATLESE": "(German) a sweet white wine made from grapes harvested after the main vintage [n SPATLESES or SPATLESEN]\n",
  "SPATLESEN": "SPATLESE, (German) a sweet white wine made from grapes harvested after the main vintage [n]\n",
  "SPATLESES": "SPATLESE, (German) a sweet white wine made from grapes harvested after the main vintage [n]\n",
  "SPATS": "SPAT, to slap, strike [v]\n",
  "SPATTED": "SPAT, to slap, strike [v]\n",
  "SPATTEE": "a protective outer stocking [n -S]\n",
  "SPATTEES": "SPATTEE, a protective outer stocking [n]\n",
  "SPATTER": "to scatter in drops [v -ED, -ING, -S]\n",
  "SPATTERDASH": "an old type of long gaiter or legging to protect the trousers from mud [n -ES]\n",
  "SPATTERDASHES": "SPATTERDASH, an old type of long gaiter or legging to protect the trousers from mud [n]\n",
  "SPATTERDOCK": "the yellow water lily of the genus Nuphar [n -S]\n",
  "SPATTERDOCKS": "SPATTERDOCK, the yellow water lily of the genus Nuphar [n]\n",
  "SPATTERED": "SPATTER, to scatter in drops [v]\n",
  "SPATTERING": "SPATTER, to scatter in drops [v]\n",
  "SPATTERS": "SPATTER, to scatter in drops [v]\n",
  "SPATTERWORK": "reproduction of designs by covering the surface with the pattern and spattering colour on the parts exposed [n -S]\n",
  "SPATTERWORKS": "SPATTERWORK, reproduction of designs by covering the surface with the pattern and spattering colour on the parts exposed [n]\n",
  "SPATTING": "SPAT, to slap, strike [v]\n",
  "SPATULA": "(Latin) a broad, blunt, flexible blade or flattened spoon, also SPATULE [n -S]\n",
  "SPATULAR": "shaped like a spatula, broad and blunt, also SPATULATE [adj]\n",
  "SPATULAS": "SPATULA, (Latin) a broad, blunt, flexible blade or flattened spoon, also SPATULE [n]\n",
  "SPATULATE": "shaped like a spatula, broad and blunt, also SPATULAR [adj]\n",
  "SPATULE": "(Latin) a broad, blunt, flexible blade or flattened spoon, also SPATULA [n -S]\n",
  "SPATULES": "SPATULE, (Latin) a broad, blunt, flexible blade or flattened spoon, also SPATULA [n]\n",
  "SPATZLE": "(German) in Jewish cooking, a small dumpling, also SPAETZLE [n -S]\n",
  "SPATZLES": "SPATZLE, (German) in Jewish cooking, a small dumpling, also SPAETZLE [n]\n",
  "SPAUL": "(Scots) the shoulder, esp. of an animal used as food, also SPALD, SPALLE, SPAULD, SPEAL, SPULE [n -S]\n",
  "SPAULD": "(Scots) the shoulder, esp. of an animal used as food, also SPALD, SPALLE, SPAUL, SPEAL, SPULE [n -S]\n",
  "SPAULDS": "SPAULD, (Scots) the shoulder, esp. of an animal used as food, also SPALD, SPALLE, SPAUL, SPEAL, SPULE [n]\n",
  "SPAULS": "SPAUL, (Scots) the shoulder, esp. of an animal used as food, also SPALD, SPALLE, SPAULD, SPEAL, SPULE [n]\n",
  "SPAVIE": "(Scots) spavin, a disease of horses [n -S]\n",
  "SPAVIES": "SPAVIE, (Scots) spavin, a disease of horses [n]\n",
  "SPAVIET": "relating to a spavie [adj]\n",
  "SPAVIN": "a disease of horses, also SPAVIE [n -S]\n",
  "SPAVINED": "infected with spavin [adj]\n",
  "SPAVINS": "SPAVIN, a disease of horses, also SPAVIE [n]\n",
  "SPAW": "(obsolete) a spa [n -S]\n",
  "SPAWL": "(archaic) to spit [v -ED, -ING, -S]\n",
  "SPAWLED": "SPAWL, (archaic) to spit [v]\n",
  "SPAWLING": "SPAWL, (archaic) to spit [v]\n",
  "SPAWLS": "SPAWL, (archaic) to spit [v]\n",
  "SPAWN": "to deposit eggs [v -ED, -ING, -S]\n",
  "SPAWNED": "SPAWN, to deposit eggs [v]\n",
  "SPAWNER": "a mature female fish [n -S]\n",
  "SPAWNERS": "SPAWNER, a mature female fish [n]\n",
  "SPAWNIER": "SPAWNY, of or like spawn [adj]\n",
  "SPAWNIEST": "SPAWNY, of or like spawn [adj]\n",
  "SPAWNING": "the act of spawning [n -S]\n",
  "SPAWNINGS": "SPAWNING, the act of spawning [n]\n",
  "SPAWNS": "SPAWN, to deposit eggs [v]\n",
  "SPAWNY": "of or like spawn [adj SPAWNIER, SPAWNIEST]\n",
  "SPAWS": "SPAW, (obsolete) a spa [n]\n",
  "SPAY": "to remove the ovaries from (a female animal) [v -ED, -ING, -S]\n",
  "SPAYAD": "(obsolete) a male deer in its third year, also SPAYD [n -S]\n",
  "SPAYADS": "SPAYAD, (obsolete) a male deer in its third year, also SPAYD [n]\n",
  "SPAYD": "a male deer in his third year, also SPAYAD [n -S]\n",
  "SPAYDS": "SPAYD, a male deer in his third year, also SPAYAD [n]\n",
  "SPAYED": "SPAY, to remove the ovaries from (a female animal) [v]\n",
  "SPAYING": "SPAY, to remove the ovaries from (a female animal) [v]\n",
  "SPAYS": "SPAY, to remove the ovaries from (a female animal) [v]\n",
  "SPAZ": "(offensive) a clumsy, foolish person [n SPAZZES]\n",
  "SPAZA": "(South African) as in spaza shop, a small shop in a township [adj]\n",
  "SPAZZ": "(slang) to lapse into a state of incompetence [v -ED, -ING, -ES]\n",
  "SPAZZED": "SPAZZ, (slang) to lapse into a state of incompetence [v]\n",
  "SPAZZES": "SPAZZ, (slang) to lapse into a state of incompetence [v]\n",
  "SPAZZING": "SPAZZ, (slang) to lapse into a state of incompetence [v]\n",
  "SPEAK": "to speak [v SPOKE or (obsolete) SPAKE, SPOKEN, SPEAKING, SPEAKS]\n",
  "SPEAKABLE": "capable of being spoken; fit to be spoken [adj]\n",
  "SPEAKEASIES": "SPEAKEASY, an illicit bar for selling alcohol [n]\n",
  "SPEAKEASY": "an illicit bar for selling alcohol [n SPEAKEASIES]\n",
  "SPEAKER": "one who speaks [n -S]\n",
  "SPEAKERINE": "a female announcer or programme hostess [n -S]\n",
  "SPEAKERINES": "SPEAKERINE, a female announcer or programme hostess [n]\n",
  "SPEAKERPHONE": "a combination microphone and loudspeaker device for two-way communication by telephone lines [n -S]\n",
  "SPEAKERPHONES": "SPEAKERPHONE, a combination microphone and loudspeaker device for two-way communication by telephone lines [n]\n",
  "SPEAKERS": "SPEAKER, one who speaks [n]\n",
  "SPEAKERSHIP": "the office of speaker [n -S]\n",
  "SPEAKERSHIPS": "SPEAKERSHIP, the office of speaker [n]\n",
  "SPEAKING": "a speech or discourse [n -S]\n",
  "SPEAKINGLY": "SPEAKING [adv]\n",
  "SPEAKINGS": "SPEAKING, a speech or discourse [n]\n",
  "SPEAKOUT": "the act of speaking boldly [n -S]\n",
  "SPEAKOUTS": "SPEAKOUT, the act of speaking boldly [n]\n",
  "SPEAKS": "SPEAK, to speak [v]\n",
  "SPEAL": "(Scots) the shoulder, also SPALD, SPALLE, SPAUL, SPAULD, SPULE [n -S]\n",
  "SPEALS": "SPEAL, (Scots) the shoulder, also SPALD, SPALLE, SPAUL, SPAULD, SPULE [n]\n",
  "SPEAN": "(Scots) to wean, also SPAIN, SPANE [v -ED, -ING, -S]\n",
  "SPEANED": "SPEAN, (Scots) to wean, also SPAIN, SPANE [v]\n",
  "SPEANING": "SPEAN, (Scots) to wean, also SPAIN, SPANE [v]\n",
  "SPEANS": "SPEAN, (Scots) to wean, also SPAIN, SPANE [v]\n",
  "SPEAR": "to pierce with a long pointed weapon [v -ED, -ING, -S]\n",
  "SPEARCARRIER": "an extra in a theatrical or operatic production, as one of a group of soldiers or a member of a crowd [n -S]\n",
  "SPEARCARRIERS": "SPEARCARRIER, an extra in a theatrical or operatic production, as one of a group of soldiers or a member of a crowd [n]\n",
  "SPEARED": "SPEAR, to pierce with a long pointed weapon [v]\n",
  "SPEARER": "one who spears [n -S]\n",
  "SPEARERS": "SPEARER, one who spears [n]\n",
  "SPEARFISH": "to hunt for fish with a speargun [v -ED, -ING, -ES]\n",
  "SPEARFISHED": "SPEARFISH, to hunt for fish with a speargun [v]\n",
  "SPEARFISHES": "SPEARFISH, to hunt for fish with a speargun [v]\n",
  "SPEARFISHING": "SPEARFISH, to hunt for fish with a speargun [v]\n",
  "SPEARGUN": "a gun that shoots spears [n -S]\n",
  "SPEARGUNS": "SPEARGUN, a gun that shoots spears [n]\n",
  "SPEARHEAD": "the pointed head, or end, of a spear [n -S] / to lead an attack [v -ED, -ING, -S]\n",
  "SPEARHEADED": "SPEARHEAD, to lead an attack [v]\n",
  "SPEARHEADING": "SPEARHEAD, to lead an attack [v]\n",
  "SPEARHEADS": "SPEARHEAD, the pointed head, or end, of a spear [n]\n",
  "SPEARIER": "SPEARY, like a spear [adj]\n",
  "SPEARIEST": "SPEARY, like a spear [adj]\n",
  "SPEARING": "the act of piercing with a spear [n -S]\n",
  "SPEARINGS": "SPEARING, the act of piercing with a spear [n]\n",
  "SPEARLIKE": "like a spear [adj]\n",
  "SPEARMAN": "a man armed with a spear [n SPEARMEN]\n",
  "SPEARMEN": "SPEARMAN, a man armed with a spear [n]\n",
  "SPEARMINT": "a common garden mint used in cooking and flavouring [n -S]\n",
  "SPEARMINTS": "SPEARMINT, a common garden mint used in cooking and flavouring [n]\n",
  "SPEARS": "SPEAR, to pierce with a long pointed weapon [v]\n",
  "SPEARWORT": "a name given to several species of crowfoot which have spear-shaped leaves [n -S]\n",
  "SPEARWORTS": "SPEARWORT, a name given to several species of crowfoot which have spear-shaped leaves [n]\n",
  "SPEARY": "like a spear [adj SPEARIER, SPEARIEST]\n",
  "SPEAT": "a flood, a surge, also SPAIT, SPATE [n -S]\n",
  "SPEATS": "SPEAT, a flood, a surge, also SPAIT, SPATE [n]\n",
  "SPEC": "to write specifications for [v SPECCED, SPECCING, SPECS]\n",
  "SPECCED": "SPEC, to write specifications for [v]\n",
  "SPECCIER": "SPECCY, wearing spectacles [adj]\n",
  "SPECCIES": "SPECCY, someone who is bespectacled [n]\n",
  "SPECCIEST": "SPECCY, wearing spectacles [adj]\n",
  "SPECCING": "SPEC, to write specifications for [v]\n",
  "SPECCY": "wearing spectacles [adj SPECCIER, SPECCIEST] / someone who is bespectacled [n SPECCIES]\n",
  "SPECIAL": "particular [adj SPECIALER, SPECIALEST, SPECIALLY] / to sell at item at a reduced price [v SPECIALLED, SPECIALLING, SPECIALS]\n",
  "SPECIALER": "SPECIAL, particular [adj]\n",
  "SPECIALEST": "SPECIAL, particular [adj]\n",
  "SPECIALISATION": "the act of specialising, also SPECIALIZATION [n -S]\n",
  "SPECIALISATIONS": "SPECIALISATION, the act of specialising, also SPECIALIZATION [n]\n",
  "SPECIALISE": "to make special or specific, also SPECIALIZE [v SPECIALISED, SPECIALISING, SPECIALISES]\n",
  "SPECIALISED": "SPECIALISE, to make special or specific, also SPECIALIZE [v]\n",
  "SPECIALISER": "one who specialises, also SPECIALIZER [n -S]\n",
  "SPECIALISERS": "SPECIALISER, one who specialises, also SPECIALIZER [n]\n",
  "SPECIALISES": "SPECIALISE, to make special or specific, also SPECIALIZE [v]\n",
  "SPECIALISING": "SPECIALISE, to make special or specific, also SPECIALIZE [v]\n",
  "SPECIALISM": "devotion to some particular study or pursuit [n -S]\n",
  "SPECIALISMS": "SPECIALISM, devotion to some particular study or pursuit [n]\n",
  "SPECIALIST": "a person whose work, interest or expertise is concentrated on a particular subject [n -S]\n",
  "SPECIALISTIC": "relating to specialism [adj]\n",
  "SPECIALISTS": "SPECIALIST, a person whose work, interest or expertise is concentrated on a particular subject [n]\n",
  "SPECIALITIES": "SPECIALITY, the particular characteristic skill, use, etc. of a person or thing, also SPECIALTY [n]\n",
  "SPECIALITY": "the particular characteristic skill, use, etc. of a person or thing, also SPECIALTY [n SPECIALITIES]\n",
  "SPECIALIZATION": "the act of specializing, also SPECIALISATION [n -S]\n",
  "SPECIALIZATIONS": "SPECIALIZATION, the act of specializing, also SPECIALISATION [n]\n",
  "SPECIALIZE": "to make special or specific, also SPECIALISE [v SPECIALIZED, SPECIALIZING, SPECIALIZES]\n",
  "SPECIALIZED": "SPECIALIZE, to make special or specific, also SPECIALISE [v]\n",
  "SPECIALIZER": "one who specializes, also SPECIALISER [n -S]\n",
  "SPECIALIZERS": "SPECIALIZER, one who specializes, also SPECIALISER [n]\n",
  "SPECIALIZES": "SPECIALIZE, to make special or specific, also SPECIALISE [v]\n",
  "SPECIALIZING": "SPECIALIZE, to make special or specific, also SPECIALISE [v]\n",
  "SPECIALLED": "SPECIAL, to sell at item at a reduced price [v]\n",
  "SPECIALLING": "SPECIAL, to sell at item at a reduced price [v]\n",
  "SPECIALLY": "SPECIAL, particular [adv]\n",
  "SPECIALNESS": "the state of being special [n -ES]\n",
  "SPECIALNESSES": "SPECIALNESS, the state of being special [n]\n",
  "SPECIALOGUE": "a mail order catalogue aimed at a specific target group of customers [n -S]\n",
  "SPECIALOGUES": "SPECIALOGUE, a mail order catalogue aimed at a specific target group of customers [n]\n",
  "SPECIALS": "SPECIAL, to sell at item at a reduced price [v]\n",
  "SPECIALTIES": "SPECIALTY, the particular characteristic skill, use, etc. of a person or thing, also SPECIALITY [n]\n",
  "SPECIALTY": "the particular characteristic skill, use, etc. of a person or thing, also SPECIALITY [n SPECIALTIES]\n",
  "SPECIATE": "to undergo a type of evolutionary process [v SPECIATED, SPECIATING, SPECIATES]\n",
  "SPECIATED": "SPECIATE, to undergo a type of evolutionary process [v]\n",
  "SPECIATES": "SPECIATE, to undergo a type of evolutionary process [v]\n",
  "SPECIATING": "SPECIATE, to undergo a type of evolutionary process [v]\n",
  "SPECIATION": "the act of forming a species [n -S]\n",
  "SPECIATIONAL": "relating to speciation [adj]\n",
  "SPECIATIONS": "SPECIATION, the act of forming a species [n]\n",
  "SPECIE": "(Latin) coined money [n]\n",
  "SPECIES": "(Latin) a population of individuals which share the same gene pool and which is unable to interbreed with closely related populations to produce viable offspring [n]\n",
  "SPECIESISM": "prejudice in favour of one's own species [n -S]\n",
  "SPECIESISMS": "SPECIESISM, prejudice in favour of one's own species [n]\n",
  "SPECIESIST": "one who is prejudiced on behalf on his own species [n -S]\n",
  "SPECIESISTS": "SPECIESIST, one who is prejudiced on behalf on his own species [n]\n",
  "SPECIFIABLE": "that can be specified [adj]\n",
  "SPECIFIC": "for a particular purpose, also SPECIFICAL [adj SPECIFICALLY] / a remedy intended for a particular disease [n -S]\n",
  "SPECIFICAL": "for a particular purpose, also SPECIFIC [adj SPECIFICALLY]\n",
  "SPECIFICALLY": "SPECIFICAL, for a particular purpose, also SPECIFIC [adv]\n",
  "SPECIFICATE": "to specify [v SPECIFICATED, SPECIFICATING, SPECIFICATES]\n",
  "SPECIFICATED": "SPECIFICATE, to specify [v]\n",
  "SPECIFICATES": "SPECIFICATE, to specify [v]\n",
  "SPECIFICATING": "SPECIFICATE, to specify [v]\n",
  "SPECIFICATION": "the act of specifying [n -S]\n",
  "SPECIFICATIONS": "SPECIFICATION, the act of specifying [n]\n",
  "SPECIFICATIVE": "serving to specify [adj]\n",
  "SPECIFICATORY": "serving to specify [adj]\n",
  "SPECIFICITIES": "SPECIFICITY, the state of being specific [n]\n",
  "SPECIFICITY": "the state of being specific [n SPECIFICITIES]\n",
  "SPECIFICS": "SPECIFIC, a remedy intended for a particular disease [n]\n",
  "SPECIFIED": "SPECIFY, to state in detail [v]\n",
  "SPECIFIER": "one who specifies [n -S]\n",
  "SPECIFIERS": "SPECIFIER, one who specifies [n]\n",
  "SPECIFIES": "SPECIFY, to state in detail [v]\n",
  "SPECIFY": "to state in detail [v SPECIFIED, SPECIFYING, SPECIFIES]\n",
  "SPECIFYING": "SPECIFY, to state in detail [v]\n",
  "SPECIMEN": "a representative of a group or a whole thing [n -S]\n",
  "SPECIMENS": "SPECIMEN, a representative of a group or a whole thing [n]\n",
  "SPECIOCIDE": "the destruction of an entire species [n -S]\n",
  "SPECIOCIDES": "SPECIOCIDE, the destruction of an entire species [n]\n",
  "SPECIOSITIES": "SPECIOSITY, the state of being specious [n]\n",
  "SPECIOSITY": "the state of being specious [n SPECIOSITIES]\n",
  "SPECIOUS": "plausible, but inaccurate [adj SPECIOUSLY]\n",
  "SPECIOUSLY": "SPECIOUS, plausible, but inaccurate [adv]\n",
  "SPECIOUSNESS": "the state of being specious [n -ES]\n",
  "SPECIOUSNESSES": "SPECIOUSNESS, the state of being specious [n]\n",
  "SPECK": "to mark with small spots, also SPECKLE [v -ED, -ING, -S]\n",
  "SPECKED": "SPECK, to mark with small spots, also SPECKLE [v]\n",
  "SPECKIER": "SPECKY, having specks [adj]\n",
  "SPECKIES": "SPECKY, someone who wears spectacles [n]\n",
  "SPECKIEST": "SPECKY, having specks [adj]\n",
  "SPECKING": "SPECK, to mark with small spots, also SPECKLE [v]\n",
  "SPECKLE": "to mark with small spots, also SPECK [v SPECKLED, SPECKLING, SPECKLES]\n",
  "SPECKLED": "SPECKLE, to mark with small spots, also SPECK [v]\n",
  "SPECKLEDNESS": "the state of being speckled [n -ES]\n",
  "SPECKLEDNESSES": "SPECKLEDNESS, the state of being speckled [n]\n",
  "SPECKLES": "SPECKLE, to mark with small spots, also SPECK [v]\n",
  "SPECKLESS": "without a speck [adj]\n",
  "SPECKLING": "SPECKLE, to mark with small spots, also SPECK [v]\n",
  "SPECKS": "SPECK, to mark with small spots, also SPECKLE [v]\n",
  "SPECKSIONEER": "(Dutch) the chief harpooner on a whaler, who directs the flensing of the whale, also SPECKTIONEER [n -S]\n",
  "SPECKSIONEERS": "SPECKSIONEER, (Dutch) the chief harpooner on a whaler, who directs the flensing of the whale, also SPECKTIONEER [n]\n",
  "SPECKTIONEER": "(Dutch) the chief harpooner on a whaler, who directs the flensing of the whale, also SPECKSIONEER [n -S]\n",
  "SPECKTIONEERS": "SPECKTIONEER, (Dutch) the chief harpooner on a whaler, who directs the flensing of the whale, also SPECKSIONEER [n]\n",
  "SPECKY": "having specks [adj SPECKIER, SPECKIEST] / someone who wears spectacles [n SPECKIES]\n",
  "SPECS": "SPEC, to write specifications for [v]\n",
  "SPECT": "a nonstandard form of expect [v -ED, -ING, -S]\n",
  "SPECTACLE": "a sight, show, pageant [n -S]\n",
  "SPECTACLED": "wearing spectacles [adj]\n",
  "SPECTACLES": "SPECTACLE, a sight, show, pageant [n]\n",
  "SPECTACULAR": "of the nature of a spectacle [adj SPECTACULARLY] / something that is spectacular [n -S]\n",
  "SPECTACULARITY": "the state of being spectacular [n]\n",
  "SPECTACULARLY": "SPECTACULAR, of the nature of a spectacle [adv]\n",
  "SPECTACULARS": "SPECTACULAR, something that is spectacular [n]\n",
  "SPECTATE": "to attend and view [v SPECTATED, SPECTATING, SPECTATES]\n",
  "SPECTATED": "SPECTATE, to attend and view [v]\n",
  "SPECTATES": "SPECTATE, to attend and view [v]\n",
  "SPECTATING": "SPECTATE, to attend and view [v]\n",
  "SPECTATOR": "an onlooker [n -S]\n",
  "SPECTATORIAL": "of or like a spectator [adj]\n",
  "SPECTATORS": "SPECTATOR, an onlooker [n]\n",
  "SPECTATORSHIP": "the office of spectator [n -S]\n",
  "SPECTATORSHIPS": "SPECTATORSHIP, the office of spectator [n]\n",
  "SPECTATRESS": "a female spectator, also SPECTATRIX [n -ES]\n",
  "SPECTATRESSES": "SPECTATRESS, a female spectator, also SPECTATRIX [n]\n",
  "SPECTATRICES": "SPECTATRIX, a female spectator, also SPECTATRESS [n]\n",
  "SPECTATRIX": "a female spectator, also SPECTATRESS [n SPECTATRICES or SPECTATRIXES]\n",
  "SPECTATRIXES": "SPECTATRIX, a female spectator, also SPECTATRESS [n]\n",
  "SPECTED": "SPECT, a nonstandard form of expect [v]\n",
  "SPECTER": "a visible disembodied spirit, also SPECTRE [n -S]\n",
  "SPECTERS": "SPECTER, a visible disembodied spirit, also SPECTRE [n]\n",
  "SPECTING": "SPECT, a nonstandard form of expect [v]\n",
  "SPECTINOMYCIN": "a white crystalline broad-spectrum antibiotic produced by a bacterium that is used clinically esp. in the form of its hydrochloride to treat gonorrhea [n -S]\n",
  "SPECTINOMYCINS": "SPECTINOMYCIN, a white crystalline broad-spectrum antibiotic produced by a bacterium that is used clinically esp. in the form of its hydrochloride to treat gonorrhea [n]\n",
  "SPECTRA": "SPECTRUM, (Latin) an array of the components of a light wave [n]\n",
  "SPECTRAL": "resembling a spectre [adj SPECTRALLY]\n",
  "SPECTRALITIES": "SPECTRALITY, the state of being spectral, also SPECTRALNESS [n]\n",
  "SPECTRALITY": "the state of being spectral, also SPECTRALNESS [n SPECTRALITIES]\n",
  "SPECTRALLY": "SPECTRAL, resembling a spectre [adv]\n",
  "SPECTRALNESS": "the state of being spectral, also SPECTRALITY [n -ES]\n",
  "SPECTRALNESSES": "SPECTRALNESS, the state of being spectral, also SPECTRALITY [n]\n",
  "SPECTRE": "a visible disembodied spirit, also SPECTER [n -S]\n",
  "SPECTRES": "SPECTRE, a visible disembodied spirit, also SPECTER [n]\n",
  "SPECTRIN": "a protein found in red blood cells and elsewhere [n -S]\n",
  "SPECTRINS": "SPECTRIN, a protein found in red blood cells and elsewhere [n]\n",
  "SPECTROGRAM": "a photograph, image, or diagram of a spectrum [n -S]\n",
  "SPECTROGRAMS": "SPECTROGRAM, a photograph, image, or diagram of a spectrum [n]\n",
  "SPECTROGRAPH": "an instrument for viewing a spectrum [n -S]\n",
  "SPECTROGRAPHIC": "relating to spectrography [adj]\n",
  "SPECTROGRAPHIES": "SPECTROGRAPHY, the use of the spectrograph [n]\n",
  "SPECTROGRAPHS": "SPECTROGRAPH, an instrument for viewing a spectrum [n]\n",
  "SPECTROGRAPHY": "the use of the spectrograph [n SPECTROGRAPHIES]\n",
  "SPECTROLOGICAL": "relating to spectrology [adj]\n",
  "SPECTROLOGIES": "SPECTROLOGY, the study of ghosts [n]\n",
  "SPECTROLOGY": "the study of ghosts [n SPECTROLOGIES]\n",
  "SPECTROMETER": "an instrument for measuring the wavelengths of light of a spectrum [n -S]\n",
  "SPECTROMETERS": "SPECTROMETER, an instrument for measuring the wavelengths of light of a spectrum [n]\n",
  "SPECTROMETRIC": "relating to measurement by spectrometer [adj]\n",
  "SPECTROMETRIES": "SPECTROMETRY, measurement by use of the spectrometer [n]\n",
  "SPECTROMETRY": "measurement by use of the spectrometer [n SPECTROMETRIES]\n",
  "SPECTROSCOPE": "an instrument for forming spectra by dispersing rays of light [n -S]\n",
  "SPECTROSCOPES": "SPECTROSCOPE, an instrument for forming spectra by dispersing rays of light [n]\n",
  "SPECTROSCOPIC": "relating to spectroscopy, also SPECTROSCOPICAL [adj]\n",
  "SPECTROSCOPICAL": "relating to spectroscopy, also SPECTROSCOPIC [adj]\n",
  "SPECTROSCOPIES": "SPECTROSCOPY, the process or technique of using a spectroscope or spectrometer [n]\n",
  "SPECTROSCOPIST": "one who uses a spectroscope [n -S]\n",
  "SPECTROSCOPISTS": "SPECTROSCOPIST, one who uses a spectroscope [n]\n",
  "SPECTROSCOPY": "the process or technique of using a spectroscope or spectrometer [n SPECTROSCOPIES]\n",
  "SPECTRUM": "(Latin) an array of the components of a light wave [n SPECTRUMS or SPECTRA]\n",
  "SPECTRUMS": "SPECTRUM, (Latin) an array of the components of a light wave [n]\n",
  "SPECTS": "SPECT, a nonstandard form of expect [v]\n",
  "SPECULA": "SPECULUM, (Latin) a medical instrument [n]\n",
  "SPECULAR": "relating to a speculum [adj SPECULARLY]\n",
  "SPECULARITIES": "SPECULARITY, the state of being specular [n]\n",
  "SPECULARITY": "the state of being specular [n SPECULARITIES]\n",
  "SPECULARLY": "SPECULAR, relating to a speculum [adv]\n",
  "SPECULATE": "to make conjectures or guesses [v SPECULATED, SPECULATING, SPECULATES]\n",
  "SPECULATED": "SPECULATE, to make conjectures or guesses [v]\n",
  "SPECULATES": "SPECULATE, to make conjectures or guesses [v]\n",
  "SPECULATING": "SPECULATE, to make conjectures or guesses [v]\n",
  "SPECULATION": "an act or instance of speculating [n -S]\n",
  "SPECULATIONS": "SPECULATION, an act or instance of speculating [n]\n",
  "SPECULATIST": "a speculative philosopher; a speculator [n -S]\n",
  "SPECULATISTS": "SPECULATIST, a speculative philosopher; a speculator [n]\n",
  "SPECULATIVE": "involving, based on, or constituting intellectual speculation [adj SPECULATIVELY]\n",
  "SPECULATIVELY": "SPECULATIVE, involving, based on, or constituting intellectual speculation [adv]\n",
  "SPECULATIVENESS": "SPECULATIVE, involving, based on, or constituting intellectual speculation [n]\n",
  "SPECULATOR": "one who speculates [n -S]\n",
  "SPECULATORS": "SPECULATOR, one who speculates [n]\n",
  "SPECULATORY": "exercising speculation; adapted for spying or viewing [adj]\n",
  "SPECULATRICE": "a female speculator, also SPECULATRIX [n SPECULATRICES]\n",
  "SPECULATRICES": "SPECULATRIX, a female speculator, also SPECULATRICE [n]\n",
  "SPECULATRIX": "a female speculator, also SPECULATRICE [n SPECULATRICES or SPECULATRIXES]\n",
  "SPECULATRIXES": "SPECULATRIX, a female speculator, also SPECULATRICE [n]\n",
  "SPECULUM": "(Latin) a medical instrument [n SPECULUMS or SPECULA]\n",
  "SPECULUMS": "SPECULUM, (Latin) a medical instrument [n]\n",
  "SPED": "SPEED, to move swiftly [v]\n",
  "SPEECH": "to harangue [v -ED, -ING, -ES]\n",
  "SPEECHCRAFT": "the art of making speeches [n -S]\n",
  "SPEECHCRAFTS": "SPEECHCRAFT, the art of making speeches [n]\n",
  "SPEECHED": "SPEECH, to harangue [v]\n",
  "SPEECHES": "SPEECH, to harangue [v]\n",
  "SPEECHFUL": "full of speech or words; loquacious [adj]\n",
  "SPEECHFULNESS": "the state of being speechful [n -ES]\n",
  "SPEECHFULNESSES": "SPEECHFULNESS, the state of being speechful [n]\n",
  "SPEECHIFICATION": "the making of speeches [n]\n",
  "SPEECHIFIED": "SPEECHIFY, to make long speeches [v]\n",
  "SPEECHIFIER": "one who speechifies [n -S]\n",
  "SPEECHIFIERS": "SPEECHIFIER, one who speechifies [n]\n",
  "SPEECHIFIES": "SPEECHIFY, to make long speeches [v]\n",
  "SPEECHIFY": "to make long speeches [v SPEECHIFIED, SPEECHIFYING, SPEECHIFIES]\n",
  "SPEECHIFYING": "making long speeches [n -S]\n",
  "SPEECHIFYINGS": "SPEECHIFYING, making long speeches [n]\n",
  "SPEECHING": "SPEECH, to harangue [v]\n",
  "SPEECHLESS": "unable to speak [adj SPEECHLESSLY]\n",
  "SPEECHLESSLY": "SPEECHLESS, unable to speak [adv]\n",
  "SPEECHLESSNESS": "the state of being speechless [n]\n",
  "SPEECHMAKER": "one who makes speeches [n -S]\n",
  "SPEECHMAKERS": "SPEECHMAKER, one who makes speeches [n]\n",
  "SPEECHMAKING": "the making of speeches [n -S]\n",
  "SPEECHMAKINGS": "SPEECHMAKING, the making of speeches [n]\n",
  "SPEECHWRITER": "a person who writes speeches (as for a politician) [n -S]\n",
  "SPEECHWRITERS": "SPEECHWRITER, a person who writes speeches (as for a politician) [n]\n",
  "SPEED": "to move swiftly [v SPEEDED, SPED, SPEEDING, SPEEDS]\n",
  "SPEEDBALL": "a mixture of cocaine and opiates, esp. heroin or morphine [n -S] / to take cocaine and heroin taken intravenously [v -ED, -ING, -S]\n",
  "SPEEDBALLED": "SPEEDBALL, to take cocaine and heroin taken intravenously [v]\n",
  "SPEEDBALLING": "the practice of taking cocaine and heroin taken intravenously [n -S]\n",
  "SPEEDBALLINGS": "SPEEDBALLING, the practice of taking cocaine and heroin taken intravenously [n]\n",
  "SPEEDBALLS": "SPEEDBALL, to take cocaine and heroin taken intravenously [v]\n",
  "SPEEDBOAT": "a high-speed motorboat having either an inboard or outboard motor [n -S]\n",
  "SPEEDBOATING": "the sport of driving a speedboat [n -S]\n",
  "SPEEDBOATINGS": "SPEEDBOATING, the sport of driving a speedboat [n]\n",
  "SPEEDBOATS": "SPEEDBOAT, a high-speed motorboat having either an inboard or outboard motor [n]\n",
  "SPEEDED": "SPEED, to move swiftly [v]\n",
  "SPEEDER": "one who speeds [n -S]\n",
  "SPEEDERS": "SPEEDER, one who speeds [n]\n",
  "SPEEDFREAK": "an amphetamine addict [n -S]\n",
  "SPEEDFREAKS": "SPEEDFREAK, an amphetamine addict [n]\n",
  "SPEEDFUL": "full of speed [adj SPEEDFULLY]\n",
  "SPEEDFULLY": "SPEEDFUL, full of speed [adv]\n",
  "SPEEDIER": "SPEEDY, fast [adj]\n",
  "SPEEDIEST": "SPEEDY, fast [adj]\n",
  "SPEEDILY": "SPEEDY, fast [adv]\n",
  "SPEEDINESS": "the state of being speedy [n -ES]\n",
  "SPEEDINESSES": "SPEEDINESS, the state of being speedy [n]\n",
  "SPEEDING": "the act of driving over the speed limit [n -S]\n",
  "SPEEDINGS": "SPEEDING, the act of driving over the speed limit [n]\n",
  "SPEEDLESS": "being without speed [adj]\n",
  "SPEEDO": "(colloquial) a speedometer [n -S]\n",
  "SPEEDOMETER": "an instrument for measuring speed [n -S]\n",
  "SPEEDOMETERS": "SPEEDOMETER, an instrument for measuring speed [n]\n",
  "SPEEDOS": "SPEEDO, (colloquial) a speedometer [n]\n",
  "SPEEDREAD": "to read quickly [v SPEEDREAD, SPEEDREADING, SPEEDREADS]\n",
  "SPEEDREADING": "SPEEDREAD, to read quickly [v]\n",
  "SPEEDREADS": "SPEEDREAD, to read quickly [v]\n",
  "SPEEDS": "SPEED, to move swiftly [v]\n",
  "SPEEDSKATING": "the sport of skating for speed [n -S]\n",
  "SPEEDSKATINGS": "SPEEDSKATING, the sport of skating for speed [n]\n",
  "SPEEDSTER": "one who likes to travel fast [n -S]\n",
  "SPEEDSTERS": "SPEEDSTER, one who likes to travel fast [n]\n",
  "SPEEDUP": "an acceleration of production without a pay increase [n -S]\n",
  "SPEEDUPS": "SPEEDUP, an acceleration of production without a pay increase [n]\n",
  "SPEEDWALK": "(US) an endless conveyor belt or moving walkway used to transport standing persons from place to place [n -S]\n",
  "SPEEDWALKS": "SPEEDWALK, (US) an endless conveyor belt or moving walkway used to transport standing persons from place to place [n]\n",
  "SPEEDWAY": "a road designed for rapid travel [n -S]\n",
  "SPEEDWAYS": "SPEEDWAY, a road designed for rapid travel [n]\n",
  "SPEEDWELL": "any species of the scrophulariaceous genus Veronica, typically blue-flowered [n -S]\n",
  "SPEEDWELLS": "SPEEDWELL, any species of the scrophulariaceous genus Veronica, typically blue-flowered [n]\n",
  "SPEEDY": "fast [adj SPEEDIER, SPEEDIEST, SPEEDILY]\n",
  "SPEEL": "(Scots) to climb, also SPEIL [v -ED, -ING, -S]\n",
  "SPEELED": "SPEEL, (Scots) to climb, also SPEIL [v]\n",
  "SPEELER": "a climber (originally an acrobat, a performer) [n -S]\n",
  "SPEELERS": "SPEELER, a climber (originally an acrobat, a performer) [n]\n",
  "SPEELING": "SPEEL, (Scots) to climb, also SPEIL [v]\n",
  "SPEELS": "SPEEL, (Scots) to climb, also SPEIL [v]\n",
  "SPEER": "(Scots) to ask, also SPEIR, SPIER [v -ED, -ING, -S]\n",
  "SPEERED": "SPEER, (Scots) to ask, also SPEIR, SPIER [v]\n",
  "SPEERING": "an inquiry [n -S]\n",
  "SPEERINGS": "(Scots) news, also SPEIRINGS [n]\n",
  "SPEERS": "SPEER, (Scots) to ask, also SPEIR, SPIER [v]\n",
  "SPEIL": "(Scots) to climb, also SPEEL [v -ED, -ING, -S]\n",
  "SPEILED": "SPEIL, (Scots) to climb, also SPEEL [v]\n",
  "SPEILING": "SPEIL, (Scots) to climb, also SPEEL [v]\n",
  "SPEILS": "SPEIL, (Scots) to climb, also SPEEL [v]\n",
  "SPEIR": "(Scots) to ask, also SPEER, SPIER [v -ED, -ING, -S]\n",
  "SPEIRED": "SPEIR, (Scots) to ask, also SPEER, SPIER [v]\n",
  "SPEIRING": "an inquiry [n -S]\n",
  "SPEIRINGS": "(Scots) news, also SPEERINGS [n]\n",
  "SPEIRS": "SPEIR, (Scots) to ask, also SPEER, SPIER [v]\n",
  "SPEISE": "(German) a metallic mixture obtained in smelting, also SPEISS [n -S]\n",
  "SPEISES": "SPEISE, (German) a metallic mixture obtained in smelting, also SPEISS [n]\n",
  "SPEISS": "(German) a metallic mixture obtained in smelting, also SPEISE [n -ES]\n",
  "SPEISSES": "SPEISS, (German) a metallic mixture obtained in smelting, also SPEISE [n]\n",
  "SPEK": "blubber from a whale [n -S]\n",
  "SPEKBOOM": "(South African) a succulent shrub of the purslane family [n -S]\n",
  "SPEKBOOMS": "SPEKBOOM, (South African) a succulent shrub of the purslane family [n]\n",
  "SPEKS": "SPEK, blubber from a whale [n]\n",
  "SPELAEAN": "living in caves, also SPELEAN [adj]\n",
  "SPELAEOLOGICAL": "relating to spelaeology, the scientific study of caves [adj]\n",
  "SPELAEOLOGIES": "SPELAEOLOGY, the study and exploration of caves, also SPELEOLOGY [n]\n",
  "SPELAEOLOGIST": "one who explores caves [n -S]\n",
  "SPELAEOLOGISTS": "SPELAEOLOGIST, one who explores caves [n]\n",
  "SPELAEOLOGY": "the study and exploration of caves, also SPELEOLOGY [n SPELAEOLOGIES]\n",
  "SPELAEOTHEM": "a term for depositional features, such as stalactites and stalagmites, found in caves, also SPELEOTHEM [n -S]\n",
  "SPELAEOTHEMS": "SPELAEOTHEM, a term for depositional features, such as stalactites and stalagmites, found in caves, also SPELEOTHEM [n]\n",
  "SPELD": "(Scots) to spread open, sprawl, also SPELDER [v -ED, -ING, -S]\n",
  "SPELDED": "SPELD, (Scots) to spread open, sprawl, also SPELDER [v]\n",
  "SPELDER": "(Scots) to spread open, sprawl, also SPELD [v -ED, -ING, -S]\n",
  "SPELDERED": "SPELDER, (Scots) to spread open, sprawl, also SPELD [v]\n",
  "SPELDERING": "SPELDER, (Scots) to spread open, sprawl, also SPELD [v]\n",
  "SPELDERS": "SPELDER, (Scots) to spread open, sprawl, also SPELD [v]\n",
  "SPELDIN": "a haddock or other small fish split open and dried in the sun, also SPELDING, SPELDRIN, SPELDRING [n -S]\n",
  "SPELDING": "a haddock or other small fish split open and dried in the sun, also SPELDIN, SPELDRIN, SPELDRING [n -S]\n",
  "SPELDINGS": "SPELDING, a haddock or other small fish split open and dried in the sun, also SPELDIN, SPELDRIN, SPELDRING [n]\n",
  "SPELDINS": "SPELDIN, a haddock or other small fish split open and dried in the sun, also SPELDING, SPELDRIN, SPELDRING [n]\n",
  "SPELDRIN": "a haddock or other small fish split open and dried in the sun, also SPELDIN, SPELDING, SPELDRING [n -S]\n",
  "SPELDRING": "a haddock or other small fish split open and dried in the sun, also SPELDIN, SPELDING, SPELDRIN [n -S]\n",
  "SPELDRINGS": "SPELDRING, a haddock or other small fish split open and dried in the sun, also SPELDIN, SPELDING, SPELDRIN [n]\n",
  "SPELDRINS": "SPELDRIN, a haddock or other small fish split open and dried in the sun, also SPELDIN, SPELDING, SPELDRING [n]\n",
  "SPELDS": "SPELD, (Scots) to spread open, sprawl, also SPELDER [v]\n",
  "SPELEAN": "living in caves, also SPELAEAN [adj]\n",
  "SPELEOLOGICAL": "relating to speleology [adj]\n",
  "SPELEOLOGIES": "SPELEOLOGY, the study and exploration of caves, also SPELAEOLOGY [n]\n",
  "SPELEOLOGIST": "one who explores caves [n -S]\n",
  "SPELEOLOGISTS": "SPELEOLOGIST, one who explores caves [n]\n",
  "SPELEOLOGY": "the study and exploration of caves, also SPELAEOLOGY [n SPELEOLOGIES]\n",
  "SPELEOTHEM": "a term for depositional features, such as stalactites and stalagmites, found in caves, also SPELAEOTHEM [n -S]\n",
  "SPELEOTHEMS": "SPELEOTHEM, a term for depositional features, such as stalactites and stalagmites, found in caves, also SPELAEOTHEM [n]\n",
  "SPELEOTHERAPIES": "SPELEOTHERAPY, an alternative or complementary method of therapy for treating asthma and other respiratory diseases, involving periods spent underground in a salt mine [n]\n",
  "SPELEOTHERAPY": "an alternative or complementary method of therapy for treating asthma and other respiratory diseases, involving periods spent underground in a salt mine [n SPELEOTHERAPIES]\n",
  "SPELK": "a splinter of wood [n -S]\n",
  "SPELKS": "SPELK, a splinter of wood [n]\n",
  "SPELL": "to read or write laboriously, letter by letter [v SPELLED, SPELT, SPELLING, SPELLS]\n",
  "SPELLABLE": "that can be spelled [adj]\n",
  "SPELLBIND": "to bind by or as by a spell [v SPELLBOUND, SPELLBINDING, SPELLBINDS]\n",
  "SPELLBINDER": "something that rivets the attention [n -S]\n",
  "SPELLBINDERS": "SPELLBINDER, something that rivets the attention [n]\n",
  "SPELLBINDING": "SPELLBIND, to bind by or as by a spell [v]\n",
  "SPELLBINDINGLY": "SPELLBINDING, SPELLBIND, to bind by or as by a spell [adv]\n",
  "SPELLBINDS": "SPELLBIND, to bind by or as by a spell [v]\n",
  "SPELLBOUND": "SPELLBIND, to bind by or as by a spell [v]\n",
  "SPELLCHECK": "to carry out a spelling check by computer [v -ED, -ING, -S]\n",
  "SPELLCHECKED": "SPELLCHECK, to carry out a spelling check by computer [v]\n",
  "SPELLCHECKER": "a piece of computer software that checks spellings in a document [n -S]\n",
  "SPELLCHECKERS": "SPELLCHECKER, a piece of computer software that checks spellings in a document [n]\n",
  "SPELLCHECKING": "SPELLCHECK, to carry out a spelling check by computer [v]\n",
  "SPELLCHECKS": "SPELLCHECK, to carry out a spelling check by computer [v]\n",
  "SPELLDOWN": "(US) a spelling competition [n -S]\n",
  "SPELLDOWNS": "SPELLDOWN, (US) a spelling competition [n]\n",
  "SPELLED": "SPELL, to read or write laboriously, letter by letter [v]\n",
  "SPELLER": "one who spells [n -S]\n",
  "SPELLERS": "SPELLER, one who spells [n]\n",
  "SPELLFUL": "abounding in spells, or charms [adj]\n",
  "SPELLICAN": "a small slip of wood, ivory, etc., to be picked out from a heap without disturbing the others in the game of spillikins, also SPILIKIN, SPILLIKIN [n -S]\n",
  "SPELLICANS": "SPELLICAN, a small slip of wood, ivory, etc., to be picked out from a heap without disturbing the others in the game of spillikins, also SPILIKIN, SPILLIKIN [n]\n",
  "SPELLING": "a sequence of letters composing a word [n -S]\n",
  "SPELLINGLY": "letter by letter [adv]\n",
  "SPELLINGS": "SPELLING, a sequence of letters composing a word [n]\n",
  "SPELLS": "SPELL, to read or write laboriously, letter by letter [v]\n",
  "SPELLSTOPT": "(archaic) brought to a standstill by a spell [adj]\n",
  "SPELT": "a hardy wheat, aka emmer, also SPELTZ [n -S]\n",
  "SPELTER": "zinc in the form of ingots [n -S]\n",
  "SPELTERS": "SPELTER, zinc in the form of ingots [n]\n",
  "SPELTS": "SPELT, a hardy wheat, aka emmer, also SPELTZ [n]\n",
  "SPELTZ": "a hardy wheat, aka emmer, also SPELT [n -ES]\n",
  "SPELTZES": "SPELTZ, a hardy wheat, aka emmer, also SPELT [n]\n",
  "SPELUNK": "to explore caves [v -ED, -ING, -S]\n",
  "SPELUNKED": "SPELUNK, to explore caves [v]\n",
  "SPELUNKER": "one who explores caves [n -S]\n",
  "SPELUNKERS": "SPELUNKER, one who explores caves [n]\n",
  "SPELUNKING": "the sport of exploring caves [n -S]\n",
  "SPELUNKINGS": "SPELUNKING, the sport of exploring caves [n]\n",
  "SPELUNKS": "SPELUNK, to explore caves [v]\n",
  "SPENCE": "a pantry, also SPENSE [n -S]\n",
  "SPENCER": "one who has the care of the spence, or buttery [n -S]\n",
  "SPENCERS": "SPENCER, one who has the care of the spence, or buttery [n]\n",
  "SPENCES": "SPENCE, a pantry, also SPENSE [n]\n",
  "SPEND": "to expend, to pay out [v SPENT, SPENDING, SPENDS]\n",
  "SPENDABLE": "that can be spent [adj]\n",
  "SPENDALL": "a spendthrift [n -S]\n",
  "SPENDALLS": "SPENDALL, a spendthrift [n]\n",
  "SPENDER": "one who spends [n -S]\n",
  "SPENDERS": "SPENDER, one who spends [n]\n",
  "SPENDIER": "SPENDY, expensive [adj]\n",
  "SPENDIEST": "SPENDY, expensive [adj]\n",
  "SPENDING": "the act of spending [n -S]\n",
  "SPENDINGS": "SPENDING, the act of spending [n]\n",
  "SPENDS": "SPEND, to expend, to pay out [v]\n",
  "SPENDTHRIFT": "one who spends his money recklessly [n -S]\n",
  "SPENDTHRIFTS": "SPENDTHRIFT, one who spends his money recklessly [n]\n",
  "SPENDY": "expensive [adj SPENDIER, SPENDIEST]\n",
  "SPENSE": "a pantry, also SPENCE [n -S]\n",
  "SPENSES": "SPENSE, a pantry, also SPENCE [n]\n",
  "SPENT": "SPEND, to expend, to pay out [v]\n",
  "SPEOS": "(Greek) a grotto-temple or tomb [n -ES]\n",
  "SPEOSES": "SPEOS, (Greek) a grotto-temple or tomb [n]\n",
  "SPERLING": "a kind of fish, the smelt, also SPARLING, SPIRLING [n -S]\n",
  "SPERLINGS": "SPERLING, a kind of fish, the smelt, also SPARLING, SPIRLING [n]\n",
  "SPERM": "a male gamete [n -S]\n",
  "SPERMACETI": "a waxlike substance used in candles, ointments, etc., obtained from oil of sperm-whale, etc., also PARMACITIE [n -S]\n",
  "SPERMACETIS": "SPERMACETI, a waxlike substance used in candles, ointments, etc., obtained from oil of sperm-whale, etc., also PARMACITIE [n]\n",
  "SPERMADUCT": "a duct conveying spermatozoa, also SPERMIDUCT [n -S]\n",
  "SPERMADUCTS": "SPERMADUCT, a duct conveying spermatozoa, also SPERMIDUCT [n]\n",
  "SPERMAGONIA": "SPERMAGONIUM, a receptacle in which spermatia are produced in some fungi and lichens [n]\n",
  "SPERMAGONIUM": "a receptacle in which spermatia are produced in some fungi and lichens [n SPERMAGONIA]\n",
  "SPERMAPHYTE": "any member of the Spermatophyta, seed-bearing plants, also SPERMOPHYTE [n -S]\n",
  "SPERMAPHYTES": "SPERMAPHYTE, any member of the Spermatophyta, seed-bearing plants, also SPERMOPHYTE [n]\n",
  "SPERMAPHYTIC": "of or like a spermaphyte, also SPERMOPHYTIC [adj]\n",
  "SPERMARIA": "SPERMARIUM, the male germ gland, also SPERMARY [n]\n",
  "SPERMARIES": "SPERMARY, an organ in which sperm is formed [n]\n",
  "SPERMARIUM": "the male germ gland, also SPERMARY [n SPERMARIA]\n",
  "SPERMARY": "an organ in which sperm is formed [n SPERMARIES]\n",
  "SPERMATHECA": "a receptacle for storing spermatozoa in insects [n SPERMATHECAE or SPERMATHECAS]\n",
  "SPERMATHECAE": "SPERMATHECA, a receptacle for storing spermatozoa in insects [n]\n",
  "SPERMATHECAL": "of or like a spermatheca, a receptacle for storing spermatozoa in insects [adj]\n",
  "SPERMATHECAS": "SPERMATHECA, a receptacle for storing spermatozoa in insects [n]\n",
  "SPERMATIA": "SPERMATIUM, one of the motionless spermatozoids in the conceptacles of certain fungi [n]\n",
  "SPERMATIAL": "of or like a spermatium, one of the motionless spermatozoids in the conceptacles of certain fungi [adj]\n",
  "SPERMATIC": "pertaining to sperm, also SPERMATICAL, SPERMIC, SPERMOUS [adj SPERMATICALLY] / a spermatic vessel [n -S]\n",
  "SPERMATICAL": "pertaining to sperm, also SPERMATIC, SPERMIC, SPERMOUS [adj SPERMATICALLY]\n",
  "SPERMATICALLY": "SPERMATICAL, pertaining to sperm, also SPERMATIC, SPERMIC, SPERMOUS [adv]\n",
  "SPERMATICS": "SPERMATIC, a spermatic vessel [n]\n",
  "SPERMATID": "a cell that develops directly into a spermatozoon [n -S]\n",
  "SPERMATIDS": "SPERMATID, a cell that develops directly into a spermatozoon [n]\n",
  "SPERMATIUM": "one of the motionless spermatozoids in the conceptacles of certain fungi [n SPERMATIA]\n",
  "SPERMATOBLAST": "a sperm-producing cell [n -S]\n",
  "SPERMATOBLASTIC": "of or like a spermatoblast, a sperm-producing cell [adj]\n",
  "SPERMATOBLASTS": "SPERMATOBLAST, a sperm-producing cell [n]\n",
  "SPERMATOCELE": "a cystic swelling of the testicle arising from the epididymis and containing sperm [n -S]\n",
  "SPERMATOCELES": "SPERMATOCELE, a cystic swelling of the testicle arising from the epididymis and containing sperm [n]\n",
  "SPERMATOCIDAL": "of or like a spermatocide, a substance that kills sperm [adj]\n",
  "SPERMATOCIDE": "a substance that kills sperm [n -S]\n",
  "SPERMATOCIDES": "SPERMATOCIDE, a substance that kills sperm [n]\n",
  "SPERMATOCYTE": "a cell producing spermatozoa [n -S]\n",
  "SPERMATOCYTES": "SPERMATOCYTE, a cell producing spermatozoa [n]\n",
  "SPERMATOGENESES": "SPERMATOGENESIS, the formation of spermatozoa [n]\n",
  "SPERMATOGENESIS": "the formation of spermatozoa [n SPERMATOGENESES]\n",
  "SPERMATOGENETIC": "relating to spermatogenesis, the formation of spermatozoa, also SPERMATOGENIC, SPERMATOGENOUS [adj]\n",
  "SPERMATOGENIC": "relating to spermatogenesis, the formation of spermatozoa, also SPERMATOGENETIC, SPERMATOGENOUS [adj]\n",
  "SPERMATOGENIES": "SPERMATOGENY, the formation of spermatozoa [n]\n",
  "SPERMATOGENOUS": "relating to spermatogenesis, the formation of spermatozoa, also SPERMATOGENETIC, SPERMATOGENIC [adj]\n",
  "SPERMATOGENY": "the formation of spermatozoa [n SPERMATOGENIES]\n",
  "SPERMATOGONIA": "SPERMATOGONIUM, a primitive male germ cell [n]\n",
  "SPERMATOGONIAL": "of or like a spermatogonium [adj]\n",
  "SPERMATOGONIUM": "a primitive male germ cell [n SPERMATOGONIA]\n",
  "SPERMATOPHORAL": "of or like a spermatophore, a case enclosing the spermatozoa of certain crustaceans [adj]\n",
  "SPERMATOPHORE": "a case enclosing the spermatozoa of certain crustaceans, molluscs and amphibians [n -S]\n",
  "SPERMATOPHORES": "SPERMATOPHORE, a case enclosing the spermatozoa of certain crustaceans, molluscs and amphibians [n]\n",
  "SPERMATOPHYTE": "a seed plant [n -S]\n",
  "SPERMATOPHYTES": "SPERMATOPHYTE, a seed plant [n]\n",
  "SPERMATOPHYTIC": "of or like a spermatophyte, a seed plant [adj]\n",
  "SPERMATORRHEA": "involuntary seminal discharge without orgasm, also SPERMATORRHOEA [n -S]\n",
  "SPERMATORRHEAS": "SPERMATORRHEA, involuntary seminal discharge without orgasm, also SPERMATORRHOEA [n]\n",
  "SPERMATORRHOEA": "involuntary seminal discharge without orgasm, also SPERMATORRHEA [n -S]\n",
  "SPERMATORRHOEAS": "SPERMATORRHOEA, involuntary seminal discharge without orgasm, also SPERMATORRHEA [n]\n",
  "SPERMATOTHECA": "a receptacle for storing sperm [n SPERMATOTHECAE or SPERMATOTHECAS]\n",
  "SPERMATOTHECAE": "SPERMATOTHECA, a receptacle for storing sperm [n]\n",
  "SPERMATOTHECAS": "SPERMATOTHECA, a receptacle for storing sperm [n]\n",
  "SPERMATOZOA": "SPERMATOZOON, a male sexual cell, which fertilises the egg, also SPERMATOZOAN [n]\n",
  "SPERMATOZOAL": "of or like a spermatozoon, a male sexual cell, which fertilises the egg [adj]\n",
  "SPERMATOZOAN": "a male sex cell, also SPERMATOZOON [n -S]\n",
  "SPERMATOZOANS": "SPERMATOZOAN, a male sex cell, also SPERMATOZOON [n]\n",
  "SPERMATOZOIC": "of or like a spermatozoon, a male sex cell [adj]\n",
  "SPERMATOZOID": "a motile male gamete of a plant usually produced in an antheridium [n -S]\n",
  "SPERMATOZOIDS": "SPERMATOZOID, a motile male gamete of a plant usually produced in an antheridium [n]\n",
  "SPERMATOZOON": "a male sexual cell, which fertilises the egg, also SPERMATOZOAN [n SPERMATOZOA]\n",
  "SPERMIC": "pertaining to sperm, also SPERMATIC, SPERMATICAL, SPERMOUS [adj]\n",
  "SPERMICIDAL": "of or like a spermicide, a substance that kills sperm [adj]\n",
  "SPERMICIDE": "a substance that kills sperm [n -S]\n",
  "SPERMICIDES": "SPERMICIDE, a substance that kills sperm [n]\n",
  "SPERMIDUCT": "a duct conveying spermatozoa, also SPERMADUCT [n -S]\n",
  "SPERMIDUCTS": "SPERMIDUCT, a duct conveying spermatozoa, also SPERMADUCT [n]\n",
  "SPERMINE": "a polyamine found in eukaryotic cells [n -S]\n",
  "SPERMINES": "SPERMINE, a polyamine found in eukaryotic cells [n]\n",
  "SPERMIOGENESES": "SPERMIOGENESIS, the stage in spermatogenesis in which spermatozoa are formed from spermatids [n]\n",
  "SPERMIOGENESIS": "the stage in spermatogenesis in which spermatozoa are formed from spermatids [n SPERMIOGENESES]\n",
  "SPERMIOGENETIC": "relating to spermiogenesis, the stage in spermatogenesis in which spermatozoa are formed from spermatids [adj]\n",
  "SPERMOGONE": "a flask-shaped structure in some fungi, also SPERMOGONIUM [n -S]\n",
  "SPERMOGONES": "SPERMOGONE, a flask-shaped structure in some fungi, also SPERMOGONIUM [n]\n",
  "SPERMOGONIA": "SPERMOGONIUM, a flask-shaped structure in some fungi, also SPERMOGONE [n]\n",
  "SPERMOGONIUM": "a flask-shaped structure in some fungi, also SPERMOGONE [n SPERMOGONIA]\n",
  "SPERMOPHILE": "a member of family of seed-loving rodents [n -S]\n",
  "SPERMOPHILES": "SPERMOPHILE, a member of family of seed-loving rodents [n]\n",
  "SPERMOPHYTE": "any member of the Spermatophyta, seed-bearing plants, also SPERMAPHYTE [n -S]\n",
  "SPERMOPHYTES": "SPERMOPHYTE, any member of the Spermatophyta, seed-bearing plants, also SPERMAPHYTE [n]\n",
  "SPERMOPHYTIC": "of or like a spermaphyte, also SPERMAPHYTIC [adj]\n",
  "SPERMOUS": "pertaining to sperm, also SPERMATIC, SPERMATICAL, SPERMIC [adj]\n",
  "SPERMS": "SPERM, a male gamete [n]\n",
  "SPERRE": "(Spenser) to bolt, bar [v SPERRED, SPERRING, SPERRES]\n",
  "SPERRED": "SPERRE, (Spenser) to bolt, bar [v]\n",
  "SPERRES": "SPERRE, (Spenser) to bolt, bar [v]\n",
  "SPERRING": "SPERRE, (Spenser) to bolt, bar [v]\n",
  "SPERRYLITE": "an arsenide of platinum, the only known compound of platinum occurring in nature [n -S]\n",
  "SPERRYLITES": "SPERRYLITE, an arsenide of platinum, the only known compound of platinum occurring in nature [n]\n",
  "SPERSE": "(archaic) to disperse [v SPERSED or (Spenser) SPERST, SPERSING, SPERSES]\n",
  "SPERSED": "SPERSE, (archaic) to disperse [v]\n",
  "SPERSES": "SPERSE, (archaic) to disperse [v]\n",
  "SPERSING": "SPERSE, (archaic) to disperse [v]\n",
  "SPERST": "SPERSE, (archaic) to disperse [v]\n",
  "SPERTHE": "(Old Norse) a long battleaxe, also SPARTH, SPARTHE [n -S]\n",
  "SPERTHES": "SPERTHE, (Old Norse) a long battleaxe, also SPARTH, SPARTHE [n]\n",
  "SPESSARTINE": "a dark orange-red garnet, also SPESSARTITE [n -S]\n",
  "SPESSARTINES": "SPESSARTINE, a dark orange-red garnet, also SPESSARTITE [n]\n",
  "SPESSARTITE": "a dark orange-red garnet, also SPESSARTINE [n -S]\n",
  "SPESSARTITES": "SPESSARTITE, a dark orange-red garnet, also SPESSARTINE [n]\n",
  "SPET": "to spit [v SPAT, SPETTING, SPETS]\n",
  "SPETCH": "to repair or patch esp. with leather and glue [v -ED, -ING, -ES]\n",
  "SPETCHED": "SPETCH, to repair or patch esp. with leather and glue [v]\n",
  "SPETCHES": "SPETCH, to repair or patch esp. with leather and glue [v]\n",
  "SPETCHING": "SPETCH, to repair or patch esp. with leather and glue [v]\n",
  "SPETS": "SPET, to spit [v]\n",
  "SPETSNAZ": "(Russian) a select military unit in the former Soviet Union, also SPETZNAZ [n -ES]\n",
  "SPETSNAZES": "SPETSNAZ, (Russian) a select military unit in the former Soviet Union, also SPETZNAZ [n]\n",
  "SPETTING": "SPET, to spit [v]\n",
  "SPETZNAZ": "(Russian) a select military unit in the former Soviet Union, also SPETSNAZ [n -ES]\n",
  "SPETZNAZES": "SPETZNAZ, (Russian) a select military unit in the former Soviet Union, also SPETSNAZ [n]\n",
  "SPEUG": "(Scots) a sparrow, also SPRUG, SPUG, SPUGGY [n -S]\n",
  "SPEUGS": "SPEUG, (Scots) a sparrow, also SPRUG, SPUG, SPUGGY [n]\n",
  "SPEW": "to vomit [v -ED, -ING, -S]\n",
  "SPEWED": "SPEW, to vomit [v]\n",
  "SPEWER": "one who spews, also SPUER [n -S]\n",
  "SPEWERS": "SPEWER, one who spews, also SPUER [n]\n",
  "SPEWIER": "SPEWY, boggy [adj]\n",
  "SPEWIEST": "SPEWY, boggy [adj]\n",
  "SPEWINESS": "the state of being spewy, boggy [n -ES]\n",
  "SPEWINESSES": "SPEWINESS, the state of being spewy, boggy [n]\n",
  "SPEWING": "SPEW, to vomit [v]\n",
  "SPEWS": "SPEW, to vomit [v]\n",
  "SPEWY": "boggy [adj SPEWIER, SPEWIEST]\n",
  "SPHACELATE": "to cause or affect with gangrene or mortification [v SPHACELATED, SPHACELATING, SPHACELATES]\n",
  "SPHACELATED": "SPHACELATE, to cause or affect with gangrene or mortification [v]\n",
  "SPHACELATES": "SPHACELATE, to cause or affect with gangrene or mortification [v]\n",
  "SPHACELATING": "SPHACELATE, to cause or affect with gangrene or mortification [v]\n",
  "SPHACELATION": "gangrene [n -S]\n",
  "SPHACELATIONS": "SPHACELATION, gangrene [n]\n",
  "SPHACELUS": "necrosis, mortification [n -ES]\n",
  "SPHACELUSES": "SPHACELUS, necrosis, mortification [n]\n",
  "SPHAER": "(obsolete) a sphere, also SPHAERE, SPHEAR, SPHEARE [n -S]\n",
  "SPHAERE": "(obsolete) a sphere, also SPHAER, SPHEAR, SPHEARE [n -S]\n",
  "SPHAERES": "SPHAERE, (obsolete) a sphere, also SPHAER, SPHEAR, SPHEARE [n]\n",
  "SPHAERIDIA": "SPHAERIDIUM, a minute spheroidal body on the surface of a sea urchin, perhaps a sense organ [n]\n",
  "SPHAERIDIUM": "a minute spheroidal body on the surface of a sea urchin, perhaps a sense organ [n SPHAERIDIA]\n",
  "SPHAERITE": "a hydrous aluminium phosphate [n -S]\n",
  "SPHAERITES": "SPHAERITE, a hydrous aluminium phosphate [n]\n",
  "SPHAEROCRYSTAL": "a rounded crystalline mass [n -S]\n",
  "SPHAEROCRYSTALS": "SPHAEROCRYSTAL, a rounded crystalline mass [n]\n",
  "SPHAEROSIDERITE": "concretionary clay-ironstone [n]\n",
  "SPHAERS": "SPHAER, (obsolete) a sphere, also SPHAERE, SPHEAR, SPHEARE [n]\n",
  "SPHAGNICOLOUS": "living in peat moss [adj]\n",
  "SPHAGNOLOGIES": "SPHAGNOLOGY, the study of peat moss [n]\n",
  "SPHAGNOLOGIST": "a student of sphagnology, the study of peat moss [n -S]\n",
  "SPHAGNOLOGISTS": "SPHAGNOLOGIST, a student of sphagnology, the study of peat moss [n]\n",
  "SPHAGNOLOGY": "the study of peat moss [n SPHAGNOLOGIES]\n",
  "SPHAGNOUS": "pertaining to moss of the genus Sphagnum, or bog moss [adj]\n",
  "SPHAGNUM": "(Greek) a grayish moss [n -S]\n",
  "SPHAGNUMS": "SPHAGNUM, (Greek) a grayish moss [n]\n",
  "SPHAIREE": "(Australian) an alternative to tennis played on a very small court, e.g. a garage floor [n -S]\n",
  "SPHAIREES": "SPHAIREE, (Australian) an alternative to tennis played on a very small court, e.g. a garage floor [n]\n",
  "SPHAIRISTIKE": "(Greek) a ball game that developed into lawn tennis [n -S]\n",
  "SPHAIRISTIKES": "SPHAIRISTIKE, (Greek) a ball game that developed into lawn tennis [n]\n",
  "SPHALERITE": "zinc sulphide, the chief source of zinc [n -S]\n",
  "SPHALERITES": "SPHALERITE, zinc sulphide, the chief source of zinc [n]\n",
  "SPHEAR": "(archaic) a sphere, also SPHAER, SPHAERE, SPHEARE [n -S]\n",
  "SPHEARE": "(archaic) a sphere, also SPHAER, SPHAERE, SPHEAR [n -S]\n",
  "SPHEARES": "SPHEARE, (archaic) a sphere, also SPHAER, SPHAERE, SPHEAR [n]\n",
  "SPHEARS": "SPHEAR, (archaic) a sphere, also SPHAER, SPHAERE, SPHEARE [n]\n",
  "SPHENDONE": "(Greek) a headband or fillet worn by women in ancient Greece [n -S]\n",
  "SPHENDONES": "SPHENDONE, (Greek) a headband or fillet worn by women in ancient Greece [n]\n",
  "SPHENE": "the mineral titanite, occurring as wedge-shaped crystals in igneous and metamorphic rocks [n -S]\n",
  "SPHENES": "SPHENE, the mineral titanite, occurring as wedge-shaped crystals in igneous and metamorphic rocks [n]\n",
  "SPHENIC": "shaped like a wedge [adj]\n",
  "SPHENODON": "a member of the Sphenodont group of lizards, to which the tuatara belongs [n -S]\n",
  "SPHENODONS": "SPHENODON, a member of the Sphenodont group of lizards, to which the tuatara belongs [n]\n",
  "SPHENODONT": "a member of the Sphenodont group of lizards, to which the tuatara belongs [n -S]\n",
  "SPHENODONTS": "SPHENODONT, a member of the Sphenodont group of lizards, to which the tuatara belongs [n]\n",
  "SPHENOGRAM": "a cuneiform character [n -S]\n",
  "SPHENOGRAMS": "SPHENOGRAM, a cuneiform character [n]\n",
  "SPHENOID": "wedge-shaped, also SPHENOIDAL [adj] / a wedge-shaped bone [n -S]\n",
  "SPHENOIDAL": "wedge-shaped, also SPHENOID [adj]\n",
  "SPHENOIDS": "SPHENOID, a wedge-shaped bone [n]\n",
  "SPHENOPSID": "any of a class of tracheophyte with jointed ribbed stems [n -S]\n",
  "SPHENOPSIDS": "SPHENOPSID, any of a class of tracheophyte with jointed ribbed stems [n]\n",
  "SPHERAL": "having the form of a sphere, also SPHERIC, SPHERICAL [adj]\n",
  "SPHERE": "to form into a type of geometric solid circle [v SPHERED, SPHERING, SPHERES]\n",
  "SPHERED": "SPHERE, to form into a type of geometric solid circle [v]\n",
  "SPHERELESS": "without a sphere [adj]\n",
  "SPHERELIKE": "like a sphere [adj]\n",
  "SPHERES": "SPHERE, to form into a type of geometric solid circle [v]\n",
  "SPHERIC": "having the shape of a sphere, also SPHERAL, SPHERICAL [adj SPHERICALLY]\n",
  "SPHERICAL": "having the shape of a sphere, also SPHERAL, SPHERIC [adj SPHERICALLY]\n",
  "SPHERICALITIES": "SPHERICALITY, the state of being spherical, also SPHERICALNESS [n]\n",
  "SPHERICALITY": "the state of being spherical, also SPHERICALNESS [n SPHERICALITIES]\n",
  "SPHERICALLY": "SPHERICAL, having the shape of a sphere, also SPHERAL, SPHERIC [adv]\n",
  "SPHERICALNESS": "the state of being spherical, also SPHERICALITY [n -ES]\n",
  "SPHERICALNESSES": "SPHERICALNESS, the state of being spherical, also SPHERICALITY [n]\n",
  "SPHERICITIES": "SPHERICITY, a descriptive term to describe how close a particle's shape is to a sphere [n]\n",
  "SPHERICITY": "a descriptive term to describe how close a particle's shape is to a sphere [n SPHERICITIES]\n",
  "SPHERICS": "(short for) atmospherics; the branch of science that deals with these, esp. for the radiolocation of electrical storms, also SFERICS [n]\n",
  "SPHERIER": "SPHERY, resembling a sphere [adj]\n",
  "SPHERIEST": "SPHERY, resembling a sphere [adj]\n",
  "SPHERING": "SPHERE, to form into a type of geometric solid circle [v]\n",
  "SPHERISTERION": "a room or court for ball games [n -S]\n",
  "SPHERISTERIONS": "SPHERISTERION, a room or court for ball games [n]\n",
  "SPHEROCYTE": "an abnormal red-blood cell that is spherical rather than disc-shaped [n -S]\n",
  "SPHEROCYTES": "SPHEROCYTE, an abnormal red-blood cell that is spherical rather than disc-shaped [n]\n",
  "SPHEROCYTOSES": "SPHEROCYTOSIS, the presence of spherocytes in the blood, as in certain haemolytic anaemias [n]\n",
  "SPHEROCYTOSIS": "the presence of spherocytes in the blood, as in certain haemolytic anaemias [n SPHEROCYTOSES]\n",
  "SPHEROID": "a body resembling or approximating to a sphere in shape [n -S]\n",
  "SPHEROIDAL": "having the form of a spheroid [adj SPHEROIDALLY or SPHEROIDICALLY]\n",
  "SPHEROIDALLY": "SPHEROIDAL, having the form of a spheroid [adv]\n",
  "SPHEROIDICALLY": "in a spheroidal manner [adv]\n",
  "SPHEROIDICITIES": "SPHEROIDICITY, the state of being spheroid [n]\n",
  "SPHEROIDICITY": "the state of being spheroid [n SPHEROIDICITIES]\n",
  "SPHEROIDISATION": "the process of spheroidising, also SPHEROIDIZATION [n]\n",
  "SPHEROIDISE": "to develop spherulitic or granular structure in, also SPHEROIDIZE [v SPHEROIDISED, SPHEROIDISING, SPHEROIDISES]\n",
  "SPHEROIDISED": "SPHEROIDISE, to develop spherulitic or granular structure in, also SPHEROIDIZE [v]\n",
  "SPHEROIDISES": "SPHEROIDISE, to develop spherulitic or granular structure in, also SPHEROIDIZE [v]\n",
  "SPHEROIDISING": "SPHEROIDISE, to develop spherulitic or granular structure in, also SPHEROIDIZE [v]\n",
  "SPHEROIDIZATION": "the process of spheroidizing, also SPHEROIDISATION [n]\n",
  "SPHEROIDIZE": "to develop spherulitic or granular structure in, also SPHEROIDISE [v SPHEROIDIZED, SPHEROIDIZING, SPHEROIDIZES]\n",
  "SPHEROIDIZED": "SPHEROIDIZE, to develop spherulitic or granular structure in, also SPHEROIDISE [v]\n",
  "SPHEROIDIZES": "SPHEROIDIZE, to develop spherulitic or granular structure in, also SPHEROIDISE [v]\n",
  "SPHEROIDIZING": "SPHEROIDIZE, to develop spherulitic or granular structure in, also SPHEROIDISE [v]\n",
  "SPHEROIDS": "SPHEROID, a body resembling or approximating to a sphere in shape [n]\n",
  "SPHEROMETER": "an instrument for measuring curvature [n -S]\n",
  "SPHEROMETERS": "SPHEROMETER, an instrument for measuring curvature [n]\n",
  "SPHEROPLAST": "a bacterium or yeast cell that is modified, as by enzymatic action, so that there is partial loss of the cell wall and increased osmotic sensitivity [n -S]\n",
  "SPHEROPLASTS": "SPHEROPLAST, a bacterium or yeast cell that is modified, as by enzymatic action, so that there is partial loss of the cell wall and increased osmotic sensitivity [n]\n",
  "SPHERULAR": "like a spherule or small sphere [adj]\n",
  "SPHERULE": "a small sphere [n -S]\n",
  "SPHERULES": "SPHERULE, a small sphere [n]\n",
  "SPHERULITE": "a radiating spherical group of minute crystalline fibres occurring in certain rocks [n -S]\n",
  "SPHERULITES": "SPHERULITE, a radiating spherical group of minute crystalline fibres occurring in certain rocks [n]\n",
  "SPHERULITIC": "of or like a spherulite [adj]\n",
  "SPHERY": "resembling a sphere [adj SPHERIER, SPHERIEST]\n",
  "SPHINCTER": "a ringlike muscle whose contraction narrows or shuts an orifice, e.g. the anus [n -S]\n",
  "SPHINCTERAL": "relating to the sphincter, also SPHINCTERIAL, SPHINCTERIC [adj]\n",
  "SPHINCTERIAL": "relating to the sphincter, also SPHINCTERAL, SPHINCTERIC [adj]\n",
  "SPHINCTERIC": "relating to the sphincter, also SPHINCTERAL, SPHINCTERIAL [adj]\n",
  "SPHINCTERS": "SPHINCTER, a ringlike muscle whose contraction narrows or shuts an orifice, e.g. the anus [n]\n",
  "SPHINGES": "SPHINX, (Greek) any of several Egyptian stone figures of a creature with a human or animal head and (occasionally) breast and a lion's body [n]\n",
  "SPHINGID": "a member of the Sphingidae family, hawkmoths [n -S]\n",
  "SPHINGIDS": "SPHINGID, a member of the Sphingidae family, hawkmoths [n]\n",
  "SPHINGOMYELIN": "a phospholipid derived from sphingosine, occurring in cell membranes [n -S]\n",
  "SPHINGOMYELINS": "SPHINGOMYELIN, a phospholipid derived from sphingosine, occurring in cell membranes [n]\n",
  "SPHINGOSINE": "an unsaturated amino alcohol found esp. in nervous tissue and cell membranes [n -S]\n",
  "SPHINGOSINES": "SPHINGOSINE, an unsaturated amino alcohol found esp. in nervous tissue and cell membranes [n]\n",
  "SPHINX": "(Greek) any of several Egyptian stone figures of a creature with a human or animal head and (occasionally) breast and a lion's body [n SPHINXES or SPHINGES]\n",
  "SPHINXES": "SPHINX, (Greek) any of several Egyptian stone figures of a creature with a human or animal head and (occasionally) breast and a lion's body [n]\n",
  "SPHINXLIKE": "like a sphinx [adj]\n",
  "SPHRAGISTIC": "of or pertaining to seals and signets [adj]\n",
  "SPHRAGISTICS": "the study of seals and signets [n]\n",
  "SPHYGMIC": "pertaining to the pulse or heartbeat [adj]\n",
  "SPHYGMOGRAM": "a sphygmograph record [n -S]\n",
  "SPHYGMOGRAMS": "SPHYGMOGRAM, a sphygmograph record [n]\n",
  "SPHYGMOGRAPH": "an instrument for recording the pulse [n -S]\n",
  "SPHYGMOGRAPHIC": "relating to a sphygmograph, an instrument for recording the pulse [adj]\n",
  "SPHYGMOGRAPHIES": "SPHYGMOGRAPHY, the measurement of the pulse [n]\n",
  "SPHYGMOGRAPHS": "SPHYGMOGRAPH, an instrument for recording the pulse [n]\n",
  "SPHYGMOGRAPHY": "the measurement of the pulse [n SPHYGMOGRAPHIES]\n",
  "SPHYGMOID": "like a pulse [adj]\n",
  "SPHYGMOLOGIES": "SPHYGMOLOGY, the study of the pulse [n]\n",
  "SPHYGMOLOGY": "the study of the pulse [n SPHYGMOLOGIES]\n",
  "SPHYGMOMETER": "an instrument for measuring arterial blood pressure [n -S]\n",
  "SPHYGMOMETERS": "SPHYGMOMETER, an instrument for measuring arterial blood pressure [n]\n",
  "SPHYGMOPHONE": "an instrument for hearing the pulse [n -S]\n",
  "SPHYGMOPHONES": "SPHYGMOPHONE, an instrument for hearing the pulse [n]\n",
  "SPHYGMOSCOPE": "an instrument for making arterial pulsations visible [n -S]\n",
  "SPHYGMOSCOPES": "SPHYGMOSCOPE, an instrument for making arterial pulsations visible [n]\n",
  "SPHYGMUS": "(Greek) the pulse [n -ES]\n",
  "SPHYGMUSES": "SPHYGMUS, (Greek) the pulse [n]\n",
  "SPHYNX": "a hairless breed of cats [n -ES]\n",
  "SPHYNXES": "SPHYNX, a hairless breed of cats [n]\n",
  "SPIAL": "(obsolete) a spy, a scout, also SPYAL [n -S]\n",
  "SPIALS": "SPIAL, (obsolete) a spy, a scout, also SPYAL [n]\n",
  "SPIC": "(offensive US slang) a person from a Spanish-speaking American country, also SPICK, SPIK [n -S]\n",
  "SPICA": "(Latin) a bandage wound around an injured limb in repeated figures-of-eight forming a series of overlapping V-shapes suggesting an ear of barley [n SPICAE or SPICAS]\n",
  "SPICAE": "SPICA, (Latin) a bandage wound around an injured limb in repeated figures-of-eight forming a series of overlapping V-shapes suggesting an ear of barley [n]\n",
  "SPICAS": "SPICA, (Latin) a bandage wound around an injured limb in repeated figures-of-eight forming a series of overlapping V-shapes suggesting an ear of barley [n]\n",
  "SPICATE": "spiked; spikelike, also SPICATED [adj]\n",
  "SPICATED": "spiked; spikelike, also SPICATE [adj]\n",
  "SPICCATO": "(Italian) a method of playing a stringed instrument with staccato bowing [n -S]\n",
  "SPICCATOS": "SPICCATO, (Italian) a method of playing a stringed instrument with staccato bowing [n]\n",
  "SPICE": "to season with an aromatic vegetable substance [v SPICED, SPICING, SPICES]\n",
  "SPICEBERRIES": "SPICEBERRY, any of several plants having spicy edible berries [n]\n",
  "SPICEBERRY": "any of several plants having spicy edible berries [n SPICEBERRIES]\n",
  "SPICEBUSH": "a pungently aromatic North American shrub of the laurel family [n -ES]\n",
  "SPICEBUSHES": "SPICEBUSH, a pungently aromatic North American shrub of the laurel family [n]\n",
  "SPICED": "SPICE, to season with an aromatic vegetable substance [v]\n",
  "SPICELESS": "without spices [adj]\n",
  "SPICER": "(obsolete) a dealer in spices; an apothecary [n -S]\n",
  "SPICERIES": "SPICERY, spices in general; a repository of spices [n]\n",
  "SPICERS": "SPICER, (obsolete) a dealer in spices; an apothecary [n]\n",
  "SPICERY": "spices in general; a repository of spices [n SPICERIES]\n",
  "SPICES": "SPICE, to season with an aromatic vegetable substance [v]\n",
  "SPICEY": "tasting of spice, also SPICY [adj SPICIER, SPICIEST, SPICILY]\n",
  "SPICIER": "SPICY, tasting of spice, also SPICEY [adj]\n",
  "SPICIEST": "SPICY, tasting of spice, also SPICEY [adj]\n",
  "SPICILEGE": "a gleaning, an anthology [n -S]\n",
  "SPICILEGES": "SPICILEGE, a gleaning, an anthology [n]\n",
  "SPICILY": "SPICY, tasting of spice, also SPICEY [adv]\n",
  "SPICINESS": "the state of being spicy [n -ES]\n",
  "SPICINESSES": "SPICINESS, the state of being spicy [n]\n",
  "SPICING": "SPICE, to season with an aromatic vegetable substance [v]\n",
  "SPICK": "tidy, fresh [adj SPICKER, SPICKEST] / (offensive US slang) a person from a Spanish-speaking American country [n -S]\n",
  "SPICKER": "SPICK, tidy, fresh [adj]\n",
  "SPICKEST": "SPICK, tidy, fresh [adj]\n",
  "SPICKNEL": "(obsolete) an umbelliferous herb having finely divided leaves, common in Europe; aka baldmoney, meu, also SPIGNEL [n -S]\n",
  "SPICKNELS": "SPICKNEL, (obsolete) an umbelliferous herb having finely divided leaves, common in Europe; aka baldmoney, meu, also SPIGNEL [n]\n",
  "SPICKS": "SPICK, (offensive US slang) a person from a Spanish-speaking American country [n]\n",
  "SPICS": "SPIC, (offensive US slang) a person from a Spanish-speaking American country, also SPICK, SPIK [n]\n",
  "SPICULA": "(Latin) a spike or splinter, also SPICULE [n SPICULAE]\n",
  "SPICULAE": "SPICULA, (Latin) a spike or splinter, also SPICULE [n]\n",
  "SPICULAR": "resembling a dart; having sharp points [adj]\n",
  "SPICULATE": "having a sharp point [adj]\n",
  "SPICULATED": "covered with spicules or needlelike [adj]\n",
  "SPICULATION": "the state of being spiculate, having a sharp point [n -S]\n",
  "SPICULATIONS": "SPICULATION, the state of being spiculate, having a sharp point [n]\n",
  "SPICULE": "a needlelike structure, also SPICULA, SPICULUM [n -S]\n",
  "SPICULES": "SPICULE, a needlelike structure, also SPICULA, SPICULUM [n]\n",
  "SPICULUM": "(Latin) a needlelike structure, also SPICULE, SPICULA [n SPICULA]\n",
  "SPICY": "tasting of spice, also SPICEY [adj SPICIER, SPICIEST, SPICILY]\n",
  "SPIDE": "(Irish) a young working class man who wears casual sports clothes [n -S]\n",
  "SPIDER": "to move in a scuttling manner [v -ED, -ING, -S]\n",
  "SPIDERED": "SPIDER, to move in a scuttling manner [v]\n",
  "SPIDERIER": "SPIDERY, like a spider, scrawly [adj]\n",
  "SPIDERIEST": "SPIDERY, like a spider, scrawly [adj]\n",
  "SPIDERING": "SPIDER, to move in a scuttling manner [v]\n",
  "SPIDERISH": "like a spider [adj]\n",
  "SPIDERLIKE": "like a spider [adj]\n",
  "SPIDERMAN": "(colloquial) a construction worker etc. employed on a high building [n SPIDERMEN]\n",
  "SPIDERMEN": "SPIDERMAN, (colloquial) a construction worker etc. employed on a high building [n]\n",
  "SPIDERS": "SPIDER, to move in a scuttling manner [v]\n",
  "SPIDERWEB": "a thread of silk spun by a spider [n -S]\n",
  "SPIDERWEBS": "SPIDERWEB, a thread of silk spun by a spider [n]\n",
  "SPIDERWOOD": "a kind of tree found in New Zealand, aka neinei [n -S]\n",
  "SPIDERWOODS": "SPIDERWOOD, a kind of tree found in New Zealand, aka neinei [n]\n",
  "SPIDERWORK": "lace worked by spider-stitch [n -S]\n",
  "SPIDERWORKS": "SPIDERWORK, lace worked by spider-stitch [n]\n",
  "SPIDERWORT": "any plant of the genus Tradescantia, with deep-blue or reddish-violet flowers [n -S]\n",
  "SPIDERWORTS": "SPIDERWORT, any plant of the genus Tradescantia, with deep-blue or reddish-violet flowers [n]\n",
  "SPIDERY": "like a spider, scrawly [adj SPIDERIER, SPIDERIEST]\n",
  "SPIDES": "SPIDE, (Irish) a young working class man who wears casual sports clothes [n]\n",
  "SPIE": "(Spenser) a spy [n -S]\n",
  "SPIED": "SPY, to watch secretly, also SPIE [v]\n",
  "SPIEGEL": "(German) an iron alloy used in the Bessemer process, also SPIEGELEISEN [n -S]\n",
  "SPIEGELEISEN": "(German) an iron alloy used in the Bessemer process, also SPIEGEL [n -S]\n",
  "SPIEGELEISENS": "SPIEGELEISEN, (German) an iron alloy used in the Bessemer process, also SPIEGEL [n]\n",
  "SPIEGELS": "SPIEGEL, (German) an iron alloy used in the Bessemer process, also SPIEGELEISEN [n]\n",
  "SPIEL": "to talk at length [v -ED, -ING, -S]\n",
  "SPIELED": "SPIEL, to talk at length [v]\n",
  "SPIELER": "a swindler or cardsharper; a gambling den [n -S]\n",
  "SPIELERS": "SPIELER, a swindler or cardsharper; a gambling den [n]\n",
  "SPIELING": "SPIEL, to talk at length [v]\n",
  "SPIELS": "SPIEL, to talk at length [v]\n",
  "SPIER": "(Scots) to ask, also SPEER, SPEIR [v -ED, -ING, -S]\n",
  "SPIERED": "SPIER, (Scots) to ask, also SPEER, SPEIR [v]\n",
  "SPIERING": "SPIER, (Scots) to ask, also SPEER, SPEIR [v]\n",
  "SPIERS": "SPIER, (Scots) to ask, also SPEER, SPEIR [v]\n",
  "SPIES": "SPY, to watch secretly, also SPIE [v]\n",
  "SPIF": "a postage stamp perforated with the initials of a firm to avoid theft by employees [n -S]\n",
  "SPIFF": "(dialect) smart, spruce [adj] / to make spiffy [v -ED, -ING, -S]\n",
  "SPIFFED": "SPIFF, to make spiffy [v]\n",
  "SPIFFIED": "SPIFFY, to make spiffy [v]\n",
  "SPIFFIER": "SPIFFY, excellent [adj]\n",
  "SPIFFIES": "SPIFFY, to make spiffy [v]\n",
  "SPIFFIEST": "SPIFFY, excellent [adj]\n",
  "SPIFFILY": "SPIFFY, excellent [adv]\n",
  "SPIFFINESS": "the state of being spiffy [n -ES]\n",
  "SPIFFINESSES": "SPIFFINESS, the state of being spiffy [n]\n",
  "SPIFFING": "SPIFF, to make spiffy [v]\n",
  "SPIFFLICATE": "to overcome or dispose of by violence, also SPIFLICATE [v SPIFFLICATED, SPIFFLICATING, SPIFFLICATES]\n",
  "SPIFFLICATED": "SPIFFLICATE, to overcome or dispose of by violence, also SPIFLICATE [v]\n",
  "SPIFFLICATES": "SPIFFLICATE, to overcome or dispose of by violence, also SPIFLICATE [v]\n",
  "SPIFFLICATING": "SPIFFLICATE, to overcome or dispose of by violence, also SPIFLICATE [v]\n",
  "SPIFFLICATION": "the act of spifflicating, also SPIFLICATION [n -S]\n",
  "SPIFFLICATIONS": "SPIFFLICATION, the act of spifflicating, also SPIFLICATION [n]\n",
  "SPIFFS": "SPIFF, to make spiffy [v]\n",
  "SPIFFY": "excellent [adj SPIFFIER, SPIFFIEST, SPIFFILY] / to make spiffy [v SPIFFIED, SPIFFYING, SPIFFIES]\n",
  "SPIFFYING": "SPIFFY, to make spiffy [v]\n",
  "SPIFLICATE": "to overcome or dispose of by violence, also SPIFFLICATE [v SPIFLICATED, SPIFLICATING, SPIFLICATES]\n",
  "SPIFLICATED": "SPIFLICATE, to overcome or dispose of by violence, also SPIFFLICATE [v]\n",
  "SPIFLICATES": "SPIFLICATE, to overcome or dispose of by violence, also SPIFFLICATE [v]\n",
  "SPIFLICATING": "SPIFLICATE, to overcome or dispose of by violence, also SPIFFLICATE [v]\n",
  "SPIFLICATION": "the act of spiflicating, also SPIFFLICATION [n -S]\n",
  "SPIFLICATIONS": "SPIFLICATION, the act of spiflicating, also SPIFFLICATION [n]\n",
  "SPIFS": "SPIF, a postage stamp perforated with the initials of a firm to avoid theft by employees [n]\n",
  "SPIGHT": "(Spenser) to spite, also SPITE [v -ED, -ING, -S]\n",
  "SPIGHTED": "SPIGHT, (Spenser) to spite, also SPITE [v]\n",
  "SPIGHTING": "SPIGHT, (Spenser) to spite, also SPITE [v]\n",
  "SPIGHTS": "SPIGHT, (Spenser) to spite, also SPITE [v]\n",
  "SPIGNEL": "an umbelliferous herb having finely divided leaves, common in Europe; aka baldmoney and meu, also SPICKNEL [n -S]\n",
  "SPIGNELS": "SPIGNEL, an umbelliferous herb having finely divided leaves, common in Europe; aka baldmoney and meu, also SPICKNEL [n]\n",
  "SPIGOT": "a peg for a vent-hole, or peg used to close the opening of a tube or pipe [n -S]\n",
  "SPIGOTS": "SPIGOT, a peg for a vent-hole, or peg used to close the opening of a tube or pipe [n]\n",
  "SPIK": "(US slang) a person from a Spanish-speaking American country, also SPIC, SPICK [n -S]\n",
  "SPIKE": "to fasten with a long, thick nail [v SPIKED, SPIKING, SPIKES]\n",
  "SPIKED": "SPIKE, to fasten with a long, thick nail [v]\n",
  "SPIKEFISH": "(US) a kind of sailfish [n -ES]\n",
  "SPIKEFISHES": "SPIKEFISH, (US) a kind of sailfish [n]\n",
  "SPIKELET": "a type of flower cluster [n -S]\n",
  "SPIKELETS": "SPIKELET, a type of flower cluster [n]\n",
  "SPIKELIKE": "like a spike [adj]\n",
  "SPIKENARD": "an aromatic oil or balsam yielded by an Indian valerianaceous herb [n -S]\n",
  "SPIKENARDS": "SPIKENARD, an aromatic oil or balsam yielded by an Indian valerianaceous herb [n]\n",
  "SPIKER": "a device for spiking a cannon [n -S]\n",
  "SPIKERIES": "SPIKERY, very High-Church Anglican [n]\n",
  "SPIKERS": "SPIKER, a device for spiking a cannon [n]\n",
  "SPIKERY": "very High-Church Anglican [n SPIKERIES]\n",
  "SPIKES": "SPIKE, to fasten with a long, thick nail [v]\n",
  "SPIKEY": "having spikes, also SPIKY [adj SPIKIER, SPIKIEST]\n",
  "SPIKIER": "SPIKY, resembling a spike, also SPIKEY [adj]\n",
  "SPIKIEST": "SPIKY, resembling a spike, also SPIKEY [adj]\n",
  "SPIKILY": "SPIKY, resembling a spike, also SPIKEY [adv]\n",
  "SPIKINESS": "the state of being spiky [n -ES]\n",
  "SPIKINESSES": "SPIKINESS, the state of being spiky [n]\n",
  "SPIKING": "SPIKE, to fasten with a long, thick nail [v]\n",
  "SPIKS": "SPIK, (US slang) a person from a Spanish-speaking American country, also SPIC, SPICK [n]\n",
  "SPIKY": "resembling a spike, also SPIKEY [adj SPIKIER, SPIKIEST, SPIKILY]\n",
  "SPILE": "to stop up with a wooden peg [v SPILED, SPILING, SPILES]\n",
  "SPILED": "SPILE, to stop up with a wooden peg [v]\n",
  "SPILES": "SPILE, to stop up with a wooden peg [v]\n",
  "SPILIKIN": "a small slip of wood, ivory, etc., to be picked out from a heap without disturbing the others in the game of spillikins, also SPELLICAN, SPILLIKIN [n -S]\n",
  "SPILIKINS": "SPILIKIN, a small slip of wood, ivory, etc., to be picked out from a heap without disturbing the others in the game of spillikins, also SPELLICAN, SPILLIKIN [n]\n",
  "SPILING": "the act of stopping with a spile [n -S]\n",
  "SPILINGS": "SPILING, the act of stopping with a spile [n]\n",
  "SPILITE": "a fine-grained igneous rock of basaltic composition [n -S]\n",
  "SPILITES": "SPILITE, a fine-grained igneous rock of basaltic composition [n]\n",
  "SPILITIC": "of or like spilite, a fine-grained igneous rock of basaltic composition [adj]\n",
  "SPILL": "to overflow from a container [v SPILLED, SPILT, SPILLING, SPILLS]\n",
  "SPILLABLE": "that can be spilt [adj]\n",
  "SPILLAGE": "that which is spilt, also SPILTH [n -S]\n",
  "SPILLAGES": "SPILLAGE, that which is spilt, also SPILTH [n]\n",
  "SPILLED": "SPILL, to overflow from a container [v]\n",
  "SPILLER": "one who spills [n -S]\n",
  "SPILLERS": "SPILLER, one who spills [n]\n",
  "SPILLIKIN": "a small slip of wood, ivory, etc., to be picked out from a heap without disturbing the others in the game of spillikins, also SPELLICAN, SPILIKIN [n -S]\n",
  "SPILLIKINS": "SPILLIKIN, a small slip of wood, ivory, etc., to be picked out from a heap without disturbing the others in the game of spillikins, also SPELLICAN, SPILIKIN [n]\n",
  "SPILLING": "the amount spilt [n -S]\n",
  "SPILLINGS": "SPILLING, the amount spilt [n]\n",
  "SPILLOVER": "an overflow [n -S]\n",
  "SPILLOVERS": "SPILLOVER, an overflow [n]\n",
  "SPILLS": "SPILL, to overflow from a container [v]\n",
  "SPILLWAY": "a channel for overflow water in a reservoir [n -S]\n",
  "SPILLWAYS": "SPILLWAY, a channel for overflow water in a reservoir [n]\n",
  "SPILOSITE": "a spotted slate, formed by contact metamorphism [n -S]\n",
  "SPILOSITES": "SPILOSITE, a spotted slate, formed by contact metamorphism [n]\n",
  "SPILT": "SPILL, to overflow from a container [v]\n",
  "SPILTH": "that which is spilt, also SPILLAGE [n -S]\n",
  "SPILTHS": "SPILTH, that which is spilt, also SPILLAGE [n]\n",
  "SPIM": "spam received via an instant messaging system [n -S]\n",
  "SPIMMER": "a person who sends unsolicited commercial communications via an instant-messaging system [n -S]\n",
  "SPIMMERS": "SPIMMER, a person who sends unsolicited commercial communications via an instant-messaging system [n]\n",
  "SPIMMING": "the activity of sending unsolicited commercial communications via an instant-messaging system [n -S]\n",
  "SPIMMINGS": "SPIMMING, the activity of sending unsolicited commercial communications via an instant-messaging system [n]\n",
  "SPIMS": "SPIM, spam received via an instant messaging system [n]\n",
  "SPIN": "to draw out and twist into threads [v SPUN or SPAN, SPINNING, SPINS]\n",
  "SPINA": "(Latin) the spinal column [n SPINAS or SPINAE]\n",
  "SPINACENE": "a natural oil obtained e.g. from shark-liver, aka squalene [n -S]\n",
  "SPINACENES": "SPINACENE, a natural oil obtained e.g. from shark-liver, aka squalene [n]\n",
  "SPINACEOUS": "of or pertaining to spinach [adj]\n",
  "SPINACH": "a plant of the goosefoot family; its young leaves used as a vegetable, also SPINAGE [n -ES]\n",
  "SPINACHES": "SPINACH, a plant of the goosefoot family; its young leaves used as a vegetable, also SPINAGE [n]\n",
  "SPINACHIER": "SPINACHY, resembling spinach [adj]\n",
  "SPINACHIEST": "SPINACHY, resembling spinach [adj]\n",
  "SPINACHLIKE": "like spinach [adj]\n",
  "SPINACHY": "resembling spinach [adj SPINACHIER, SPINACHIEST]\n",
  "SPINAE": "SPINA, (Latin) the spinal column [n]\n",
  "SPINAGE": "a cultivated herb, also SPINACH [n -S]\n",
  "SPINAGES": "SPINAGE, a cultivated herb, also SPINACH [n]\n",
  "SPINAL": "related to the spine [adj SPINALLY] / an injection of anaesthetic into the spinal cord [n -S]\n",
  "SPINALLY": "SPINAL, related to the spine [adv]\n",
  "SPINALS": "SPINAL, an injection of anaesthetic into the spinal cord [n]\n",
  "SPINAR": "a rapidly spinning galactic body [n -S]\n",
  "SPINARAMA": "(Canadian) an evasive move, especially in hockey, consisting of an abrupt 360-degree turn [n -S]\n",
  "SPINARAMAS": "SPINARAMA, (Canadian) an evasive move, especially in hockey, consisting of an abrupt 360-degree turn [n]\n",
  "SPINARS": "SPINAR, a rapidly spinning galactic body [n]\n",
  "SPINAS": "SPINA, (Latin) the spinal column [n]\n",
  "SPINATE": "bearing a spine; in the form of a spine [adj]\n",
  "SPINDLE": "to impale on a slender rod [v SPINDLED, SPINDLING, SPINDLES]\n",
  "SPINDLED": "SPINDLE, to impale on a slender rod [v]\n",
  "SPINDLELEGS": "long thin legs; a person who has these, also SPINDLESHANKS [n]\n",
  "SPINDLER": "one that spindles [n -S]\n",
  "SPINDLERS": "SPINDLER, one that spindles [n]\n",
  "SPINDLES": "SPINDLE, to impale on a slender rod [v]\n",
  "SPINDLESHANKS": "long thin legs; a person who has these, also SPINDLELEGS [n]\n",
  "SPINDLIER": "SPINDLY, long and slender [adj]\n",
  "SPINDLIEST": "SPINDLY, long and slender [adj]\n",
  "SPINDLING": "a person or thing too long and slender; a slender shoot [n -S]\n",
  "SPINDLINGS": "SPINDLING, a person or thing too long and slender; a slender shoot [n]\n",
  "SPINDLY": "long and slender [adj SPINDLIER, SPINDLIEST]\n",
  "SPINDRIFT": "the ocean spray which is blown by the wind, also SPOONDRIFT [n -S]\n",
  "SPINDRIFTS": "SPINDRIFT, the ocean spray which is blown by the wind, also SPOONDRIFT [n]\n",
  "SPINE": "the vertebral column [n -S]\n",
  "SPINED": "having a spine [adj]\n",
  "SPINEL": "any mineral of a group of aluminates, ferrates, and chromates of magnesium, iron, zinc etc., also SPINELLE [n -S]\n",
  "SPINELESS": "without spine [adj SPINELESSLY]\n",
  "SPINELESSLY": "SPINELESS, without spine [adv]\n",
  "SPINELESSNESS": "the state of being spineless [n -ES]\n",
  "SPINELESSNESSES": "SPINELESSNESS, the state of being spineless [n]\n",
  "SPINELIKE": "like a spine [adj]\n",
  "SPINELLE": "any mineral of a group of aluminates, ferrates, and chromates of magnesium, iron, zinc, etc., also SPINEL [n -S]\n",
  "SPINELLES": "SPINELLE, any mineral of a group of aluminates, ferrates, and chromates of magnesium, iron, zinc, etc., also SPINEL [n]\n",
  "SPINELS": "SPINEL, any mineral of a group of aluminates, ferrates, and chromates of magnesium, iron, zinc etc., also SPINELLE [n]\n",
  "SPINES": "SPINE, the vertebral column [n]\n",
  "SPINESCENCE": "the quality of being spiny [n -S]\n",
  "SPINESCENCES": "SPINESCENCE, the quality of being spiny [n]\n",
  "SPINESCENT": "tapering or developing into a spine [adj]\n",
  "SPINET": "a musical instrument like a small harpsichord, also SPINETTE, SPINNET [n -S]\n",
  "SPINETS": "SPINET, a musical instrument like a small harpsichord, also SPINETTE, SPINNET [n]\n",
  "SPINETTE": "a musical instrument like a small harpsichord, also SPINET, SPINNET [n -S]\n",
  "SPINETTES": "SPINETTE, a musical instrument like a small harpsichord, also SPINET, SPINNET [n]\n",
  "SPINIER": "SPINY, having spines [adj]\n",
  "SPINIEST": "SPINY, having spines [adj]\n",
  "SPINIFEROUS": "bearing spines, also SPINIGEROUS [adj]\n",
  "SPINIFEX": "(Latin) a sharp-pointed Australian grass [n -ES]\n",
  "SPINIFEXES": "SPINIFEX, (Latin) a sharp-pointed Australian grass [n]\n",
  "SPINIFORM": "like a thorn or spine [adj]\n",
  "SPINIGEROUS": "bearing spines, also SPINIFEROUS [adj]\n",
  "SPINIGRADE": "a type of spiny echinoderm [n -S]\n",
  "SPINIGRADES": "SPINIGRADE, a type of spiny echinoderm [n]\n",
  "SPININESS": "the state of being spiny [n -ES]\n",
  "SPININESSES": "SPININESS, the state of being spiny [n]\n",
  "SPINK": "of a finch, to chirp, chirm [v -ED, -ING, -S]\n",
  "SPINKED": "SPINK, of a finch, to chirp, chirm [v]\n",
  "SPINKING": "SPINK, of a finch, to chirp, chirm [v]\n",
  "SPINKS": "SPINK, of a finch, to chirp, chirm [v]\n",
  "SPINLESS": "having no rotation [adj]\n",
  "SPINMEISTER": "a spin doctor [n -S]\n",
  "SPINMEISTERS": "SPINMEISTER, a spin doctor [n]\n",
  "SPINNAKER": "a large triangular sail opposite the mainsail [n -S]\n",
  "SPINNAKERS": "SPINNAKER, a large triangular sail opposite the mainsail [n]\n",
  "SPINNER": "one that spins [n -S]\n",
  "SPINNERET": "the silk-spinning organ of an insect or spider, also SPINNERETTE [n -S]\n",
  "SPINNERETS": "SPINNERET, the silk-spinning organ of an insect or spider, also SPINNERETTE [n]\n",
  "SPINNERETTE": "the silk-spinning organ of an insect or spider, also SPINNERET [n -S]\n",
  "SPINNERETTES": "SPINNERETTE, the silk-spinning organ of an insect or spider, also SPINNERET [n]\n",
  "SPINNERIES": "SPINNERY, a spinning mill [n]\n",
  "SPINNERS": "SPINNER, one that spins [n]\n",
  "SPINNERULE": "one of the numerous small spinning tubes on the spinnerets of spiders [n -S]\n",
  "SPINNERULES": "SPINNERULE, one of the numerous small spinning tubes on the spinnerets of spiders [n]\n",
  "SPINNERY": "a spinning mill [n SPINNERIES]\n",
  "SPINNET": "a musical instrument like a small harpsichord, also SPINET, SPINETTE [n -S]\n",
  "SPINNETS": "SPINNET, a musical instrument like a small harpsichord, also SPINET, SPINETTE [n]\n",
  "SPINNEY": "a small thicket or grove with undergrowth, also SPINNY [n -S]\n",
  "SPINNEYS": "SPINNEY, a small thicket or grove with undergrowth, also SPINNY [n]\n",
  "SPINNIER": "SPINNY, crazy, foolish [adj]\n",
  "SPINNIES": "SPINNY, a small thicket or grove with undergrowth, also SPINNEY [n]\n",
  "SPINNIEST": "SPINNY, crazy, foolish [adj]\n",
  "SPINNING": "the act of one who spins [n -S]\n",
  "SPINNINGS": "SPINNING, the act of one who spins [n]\n",
  "SPINNY": "crazy, foolish [adj SPINNIER, SPINNIEST] / a small thicket or grove with undergrowth, also SPINNEY [n SPINNIES]\n",
  "SPINODE": "the cusp of a point [n -S]\n",
  "SPINODES": "SPINODE, the cusp of a point [n]\n",
  "SPINOFF": "an incidental result [n -S]\n",
  "SPINOFFS": "SPINOFF, an incidental result [n]\n",
  "SPINONE": "(Italian) as in Italian spinone, a wiry-coated big-eared gun dog [n SPINONI]\n",
  "SPINONI": "SPINONE, (Italian) as in Italian spinone, a wiry-coated big-eared gun dog [n]\n",
  "SPINOR": "a type of mathematical vector [n -S]\n",
  "SPINORS": "SPINOR, a type of mathematical vector [n]\n",
  "SPINOSE": "covered with thorns, also SPINOUS [adj]\n",
  "SPINOSELY": "SPINOSE, covered with thorns, also SPINOUS [adv]\n",
  "SPINOSITIES": "SPINOSITY, thorniness [n]\n",
  "SPINOSITY": "thorniness [n SPINOSITIES]\n",
  "SPINOUS": "covered with thorns, also SPINOSE [adj]\n",
  "SPINOUT": "a rotational skid by an automobile [n -S]\n",
  "SPINOUTS": "SPINOUT, a rotational skid by an automobile [n]\n",
  "SPINS": "SPIN, to draw out and twist into threads [v]\n",
  "SPINSTER": "an older unmarried woman [n -S]\n",
  "SPINSTERDOM": "the state of being a spinster, also SPINSTERHOOD, SPINSTERSHIP [n -S]\n",
  "SPINSTERDOMS": "SPINSTERDOM, the state of being a spinster, also SPINSTERHOOD, SPINSTERSHIP [n]\n",
  "SPINSTERHOOD": "the state of being a spinster, also SPINSTERDOM, SPINSTERSHIP [n -S]\n",
  "SPINSTERHOODS": "SPINSTERHOOD, the state of being a spinster, also SPINSTERDOM, SPINSTERSHIP [n]\n",
  "SPINSTERIAL": "like a spinster, also SPINSTERIAN, SPINSTERISH, SPINSTERLY [adj]\n",
  "SPINSTERIAN": "like a spinster, also SPINSTERIAL, SPINSTERISH, SPINSTERLY [adj]\n",
  "SPINSTERISH": "like a spinster, also SPINSTERIAL, SPINSTERIAN, SPINSTERLY [adj]\n",
  "SPINSTERLIER": "SPINSTERLY, like a spinster, also SPINSTERIAL, SPINSTERIAN, SPINSTERISH [adj]\n",
  "SPINSTERLIEST": "SPINSTERLY, like a spinster, also SPINSTERIAL, SPINSTERIAN, SPINSTERISH [adj]\n",
  "SPINSTERLY": "like a spinster, also SPINSTERIAL, SPINSTERIAN, SPINSTERISH [adj SPINSTERLIER, SPINSTERLIEST]\n",
  "SPINSTERS": "SPINSTER, an older unmarried woman [n]\n",
  "SPINSTERSHIP": "the state of being a spinster, also SPINSTERDOM, SPINSTERHOOD [n -S]\n",
  "SPINSTERSHIPS": "SPINSTERSHIP, the state of being a spinster, also SPINSTERDOM, SPINSTERHOOD [n]\n",
  "SPINSTRESS": "a woman who spins [n -ES]\n",
  "SPINSTRESSES": "SPINSTRESS, a woman who spins [n]\n",
  "SPINTEXT": "a clergyman, a long-winded preacher [n -S]\n",
  "SPINTEXTS": "SPINTEXT, a clergyman, a long-winded preacher [n]\n",
  "SPINTHARISCOPE": "an instrument for visually detecting alpha particles [n -S]\n",
  "SPINTHARISCOPES": "SPINTHARISCOPE, an instrument for visually detecting alpha particles [n]\n",
  "SPINTO": "(Italian) a singing voice that is lyric and dramatic [n -S]\n",
  "SPINTOS": "SPINTO, (Italian) a singing voice that is lyric and dramatic [n]\n",
  "SPINULA": "(Latin) a small thorn, also SPINULE [n SPINULAE]\n",
  "SPINULAE": "SPINULA, (Latin) a small thorn, also SPINULE [n]\n",
  "SPINULATE": "in the form of a spinule, a small spine [adj]\n",
  "SPINULE": "a small thorn, also SPINULA [n -S]\n",
  "SPINULES": "SPINULE, a small thorn, also SPINULA [n]\n",
  "SPINULESCENT": "like a spinule [adj]\n",
  "SPINULIFEROUS": "bearing spinules [adj]\n",
  "SPINULOSE": "covered with small spines, also SPINULOUS [adj]\n",
  "SPINULOUS": "covered with small spines, also SPINULOSE [adj]\n",
  "SPINY": "having spines [adj SPINIER, SPINIEST]\n",
  "SPIRACLE": "an orifice through which breathing occurs [n -S]\n",
  "SPIRACLES": "SPIRACLE, an orifice through which breathing occurs [n]\n",
  "SPIRACULA": "SPIRACULUM, a breathing-hole; a vent, orifice [n]\n",
  "SPIRACULAR": "of or pertaining to a spiracle [adj]\n",
  "SPIRACULATE": "having airholes [adj]\n",
  "SPIRACULUM": "a breathing-hole; a vent, orifice [n SPIRACULA]\n",
  "SPIRAEA": "(Greek) any of a group of plants, including hardhack and meadowsweet, also SPIREA [n -S]\n",
  "SPIRAEAS": "SPIRAEA, (Greek) any of a group of plants, including hardhack and meadowsweet, also SPIREA [n]\n",
  "SPIRAL": "winding like the thread of a screw [adj SPIRALLY] / to move in spiral fashion [v SPIRALED or SPIRALLED, SPIRALING or SPIRALLING, SPIRALS]\n",
  "SPIRALED": "SPIRAL, to move in spiral fashion [v]\n",
  "SPIRALIFORM": "shaped like a spiral [adj]\n",
  "SPIRALING": "SPIRAL, to move in spiral fashion [v]\n",
  "SPIRALISER": "a kitchen appliance for cutting vegetables into noodle-like strands, also SPIRALIZER [n -S]\n",
  "SPIRALISERS": "SPIRALISER, a kitchen appliance for cutting vegetables into noodle-like strands, also SPIRALIZER [n]\n",
  "SPIRALISM": "advancement through a spirally structured career [n -S]\n",
  "SPIRALISMS": "SPIRALISM, advancement through a spirally structured career [n]\n",
  "SPIRALIST": "someone engaged in spiralism; loosely, an ambitious person [n -S]\n",
  "SPIRALISTS": "SPIRALIST, someone engaged in spiralism; loosely, an ambitious person [n]\n",
  "SPIRALITIES": "SPIRALITY, the state of being spiral [n]\n",
  "SPIRALITY": "the state of being spiral [n SPIRALITIES]\n",
  "SPIRALIZER": "a kitchen appliance for cutting vegetables into noodle-like strands, also SPIRALISER [n -S]\n",
  "SPIRALIZERS": "SPIRALIZER, a kitchen appliance for cutting vegetables into noodle-like strands, also SPIRALISER [n]\n",
  "SPIRALLED": "SPIRAL, to move in spiral fashion [v]\n",
  "SPIRALLING": "SPIRAL, to move in spiral fashion [v]\n",
  "SPIRALLY": "SPIRAL, winding like the thread of a screw [adv]\n",
  "SPIRALS": "SPIRAL, to move in spiral fashion [v]\n",
  "SPIRANT": "a sound produced by narrowing the air passage [n -S]\n",
  "SPIRANTS": "SPIRANT, a sound produced by narrowing the air passage [n]\n",
  "SPIRASTER": "a coiled sponge spicule with radiating spines [n -S]\n",
  "SPIRASTERS": "SPIRASTER, a coiled sponge spicule with radiating spines [n]\n",
  "SPIRATED": "spirally twisted [adj]\n",
  "SPIRATION": "the act of breathing [n -S]\n",
  "SPIRATIONS": "SPIRATION, the act of breathing [n]\n",
  "SPIRE": "to rise in a tapering manner [v SPIRED, SPIRING, SPIRES]\n",
  "SPIREA": "(Greek) a group of plants, including hardhack and meadowsweet, also SPIRAEA [n -S]\n",
  "SPIREAS": "SPIREA, (Greek) a group of plants, including hardhack and meadowsweet, also SPIRAEA [n]\n",
  "SPIRED": "SPIRE, to rise in a tapering manner [v]\n",
  "SPIRELESS": "without a spire [adj]\n",
  "SPIRELET": "a slender spire [n -S]\n",
  "SPIRELETS": "SPIRELET, a slender spire [n]\n",
  "SPIREM": "a filament forming part of a cell nucleus, also SPIREME [n -S]\n",
  "SPIREME": "a filament forming part of a cell nucleus, also SPIREM [n -S]\n",
  "SPIREMES": "SPIREME, a filament forming part of a cell nucleus, also SPIREM [n]\n",
  "SPIREMS": "SPIREM, a filament forming part of a cell nucleus, also SPIREME [n]\n",
  "SPIRES": "SPIRE, to rise in a tapering manner [v]\n",
  "SPIREWISE": "in the form of a spire [adv]\n",
  "SPIRIC": "a curve, the plane section of a tore [n -S]\n",
  "SPIRICS": "SPIRIC, a curve, the plane section of a tore [n]\n",
  "SPIRIER": "SPIRY, tall, slender and tapering [adj]\n",
  "SPIRIEST": "SPIRY, tall, slender and tapering [adj]\n",
  "SPIRIFEROUS": "of a shell, having a spire [adj]\n",
  "SPIRILLA": "SPIRILLUM, a rigid, spiral-shaped bacterium [n]\n",
  "SPIRILLAR": "of or like a spirillum, a rod-shaped bacterium [adj]\n",
  "SPIRILLOSES": "SPIRILLOSIS, infection with a spirillum [n]\n",
  "SPIRILLOSIS": "infection with a spirillum [n SPIRILLOSES]\n",
  "SPIRILLUM": "a rigid, spiral-shaped bacterium [n SPIRILLA]\n",
  "SPIRING": "SPIRE, to rise in a tapering manner [v]\n",
  "SPIRIT": "to carry off secretly [v -ED, -ING, -S]\n",
  "SPIRITED": "SPIRIT, to carry off secretly [v]\n",
  "SPIRITEDLY": "SPIRITED, SPIRIT, to carry off secretly [adv]\n",
  "SPIRITEDNESS": "the state of being spirited [n -ES]\n",
  "SPIRITEDNESSES": "SPIRITEDNESS, the state of being spirited [n]\n",
  "SPIRITFUL": "full of spirit; spirited [adj]\n",
  "SPIRITING": "the act of spiriting [n -S]\n",
  "SPIRITINGS": "SPIRITING, the act of spiriting [n]\n",
  "SPIRITISM": "the belief that nothing is real except the soul or spirit, also SPIRITUALISM [n -S]\n",
  "SPIRITISMS": "SPIRITISM, the belief that nothing is real except the soul or spirit, also SPIRITUALISM [n]\n",
  "SPIRITIST": "one who believes that nothing is real except the soul or spirit, also SPIRITUALIST [n -S]\n",
  "SPIRITISTIC": "relating to spiritism [adj]\n",
  "SPIRITISTS": "SPIRITIST, one who believes that nothing is real except the soul or spirit, also SPIRITUALIST [n]\n",
  "SPIRITLESS": "lacking animation or courage [adj SPIRITLESSLY]\n",
  "SPIRITLESSLY": "SPIRITLESS, lacking animation or courage [adv]\n",
  "SPIRITLESSNESS": "SPIRITLESS, lacking animation or courage [n]\n",
  "SPIRITOSO": "(Italian) spirited; a direction to perform a passage in an animated, lively manner [adv]\n",
  "SPIRITOUS": "like spirit; refined; pure [adj]\n",
  "SPIRITOUSNESS": "the state of being spiritous [n -ES]\n",
  "SPIRITOUSNESSES": "SPIRITOUSNESS, the state of being spiritous [n]\n",
  "SPIRITS": "SPIRIT, to carry off secretly [v]\n",
  "SPIRITUAL": "related to the spirit [adj SPIRITUALLY] / a black religious song [n -S]\n",
  "SPIRITUALISE": "to make spiritual, also SPIRITUALIZE [v SPIRITUALISED, SPIRITUALISING, SPIRITUALISES]\n",
  "SPIRITUALISED": "SPIRITUALISE, to make spiritual, also SPIRITUALIZE [v]\n",
  "SPIRITUALISER": "one who spiritualises, also SPIRITUALIZER [n -S]\n",
  "SPIRITUALISERS": "SPIRITUALISER, one who spiritualises, also SPIRITUALIZER [n]\n",
  "SPIRITUALISES": "SPIRITUALISE, to make spiritual, also SPIRITUALIZE [v]\n",
  "SPIRITUALISING": "SPIRITUALISE, to make spiritual, also SPIRITUALIZE [v]\n",
  "SPIRITUALISM": "the belief that nothing is real except the soul or spirit, also SPIRITISM [n -S]\n",
  "SPIRITUALISMS": "SPIRITUALISM, the belief that nothing is real except the soul or spirit, also SPIRITISM [n]\n",
  "SPIRITUALIST": "one who believes that nothing is real except the soul or spirit, also SPIRITIST [n -S]\n",
  "SPIRITUALISTIC": "relating to spiritualism [adj]\n",
  "SPIRITUALISTS": "SPIRITUALIST, one who believes that nothing is real except the soul or spirit, also SPIRITIST [n]\n",
  "SPIRITUALITIES": "SPIRITUALITY, something that in ecclesiastical law belongs to the church or to a cleric as such [n]\n",
  "SPIRITUALITY": "something that in ecclesiastical law belongs to the church or to a cleric as such [n SPIRITUALITIES]\n",
  "SPIRITUALIZE": "to make spiritual, also SPIRITUALISE [v SPIRITUALIZED, SPIRITUALIZING, SPIRITUALIZES]\n",
  "SPIRITUALIZED": "SPIRITUALIZE, to make spiritual, also SPIRITUALISE [v]\n",
  "SPIRITUALIZER": "one who spiritualises, also SPIRITUALISER [n -S]\n",
  "SPIRITUALIZERS": "SPIRITUALIZER, one who spiritualises, also SPIRITUALISER [n]\n",
  "SPIRITUALIZES": "SPIRITUALIZE, to make spiritual, also SPIRITUALISE [v]\n",
  "SPIRITUALIZING": "SPIRITUALIZE, to make spiritual, also SPIRITUALISE [v]\n",
  "SPIRITUALLY": "SPIRITUAL, related to the spirit [adv]\n",
  "SPIRITUALNESS": "the state of being spiritual [n -ES]\n",
  "SPIRITUALNESSES": "SPIRITUALNESS, the state of being spiritual [n]\n",
  "SPIRITUALS": "SPIRITUAL, a black religious song [n]\n",
  "SPIRITUALTIES": "SPIRITUALTY, being spiritual [n]\n",
  "SPIRITUALTY": "being spiritual [n SPIRITUALTIES]\n",
  "SPIRITUEL": "(French) showing refined and witty grace and delicacy [adj]\n",
  "SPIRITUELLE": "(French) showing refined and witty grace and delicacy (feminine) [adj]\n",
  "SPIRITUOSITIES": "SPIRITUOSITY, the state of being spirituous [n]\n",
  "SPIRITUOSITY": "the state of being spirituous [n SPIRITUOSITIES]\n",
  "SPIRITUOUS": "alcoholic [adj]\n",
  "SPIRITUOUSNESS": "the state of being spirituous [n]\n",
  "SPIRITUS": "(Latin) spirit; a breathing [n -ES]\n",
  "SPIRITUSES": "SPIRITUS, (Latin) spirit; a breathing [n]\n",
  "SPIRITY": "(dialect) spirited; spirituous [adj]\n",
  "SPIRKETTING": "deck planking near the bulwarks [n -S]\n",
  "SPIRKETTINGS": "SPIRKETTING, deck planking near the bulwarks [n]\n",
  "SPIRLING": "a kind of fish, aka smelt, also SPARLING, SPERLING [n -S]\n",
  "SPIRLINGS": "SPIRLING, a kind of fish, aka smelt, also SPARLING, SPERLING [n]\n",
  "SPIROCHAETAEMIA": "the presence of spirochaetes in the blood [n]\n",
  "SPIROCHAETAL": "resulting from spirochaetes, also SPIROCHETAL [adj]\n",
  "SPIROCHAETE": "a slender, twisted, non-flagellated microorganism causing malaria, relapsing fever, yaws, and other maladies, also SPIROCHETE [n -S]\n",
  "SPIROCHAETES": "SPIROCHAETE, a slender, twisted, non-flagellated microorganism causing malaria, relapsing fever, yaws, and other maladies, also SPIROCHETE [n]\n",
  "SPIROCHAETOSES": "SPIROCHAETOSIS, infection by spirochaetes [n]\n",
  "SPIROCHAETOSIS": "infection by spirochaetes [n SPIROCHAETOSES]\n",
  "SPIROCHETAL": "caused by spirochetes, also SPIROCHAETAL [adj]\n",
  "SPIROCHETE": "a spirally coiled bacterium lacking a rigid cell wall, the cause of syphilis and other diseases, also SPIROCHAETE [n -S]\n",
  "SPIROCHETES": "SPIROCHETE, a spirally coiled bacterium lacking a rigid cell wall, the cause of syphilis and other diseases, also SPIROCHAETE [n]\n",
  "SPIROCHETOSES": "SPIROCHETOSIS, infection with or a disease caused by spirochetes [n]\n",
  "SPIROCHETOSIS": "infection with or a disease caused by spirochetes [n SPIROCHETOSES]\n",
  "SPIROGRAM": "a record made by a spirograph, an instrument recording movements of breathing [n -S]\n",
  "SPIROGRAMS": "SPIROGRAM, a record made by a spirograph, an instrument recording movements of breathing [n]\n",
  "SPIROGRAPH": "an instrument recording movements of breathing [n -S]\n",
  "SPIROGRAPHIC": "relating to a spirograph, an instrument recording movements of breathing [adj]\n",
  "SPIROGRAPHIES": "SPIROGRAPHY, the recording of breathing movements [n]\n",
  "SPIROGRAPHS": "SPIROGRAPH, an instrument recording movements of breathing [n]\n",
  "SPIROGRAPHY": "the recording of breathing movements [n SPIROGRAPHIES]\n",
  "SPIROGYRA": "any of various minute green filamentous freshwater algae constituting the genus Spirogyra [n -S]\n",
  "SPIROGYRAS": "SPIROGYRA, any of various minute green filamentous freshwater algae constituting the genus Spirogyra [n]\n",
  "SPIROID": "resembling a spiral [adj]\n",
  "SPIROMETER": "an instrument measuring lung capacity [n -S]\n",
  "SPIROMETERS": "SPIROMETER, an instrument measuring lung capacity [n]\n",
  "SPIROMETRIC": "relating to measurement by spirometer [adj]\n",
  "SPIROMETRIES": "SPIROMETRY, the act of measuring the chest capacity by means of a spirometer [n]\n",
  "SPIROMETRY": "the act of measuring the chest capacity by means of a spirometer [n SPIROMETRIES]\n",
  "SPIRONOLACTONE": "a synthetic corticosteroid drug used in the treatment of hypertension and as a diuretic [n -S]\n",
  "SPIRONOLACTONES": "SPIRONOLACTONE, a synthetic corticosteroid drug used in the treatment of hypertension and as a diuretic [n]\n",
  "SPIROPHORE": "an apparatus for inducing artificial respiration by means of an airtight case for the body and an air pump [n -S]\n",
  "SPIROPHORES": "SPIROPHORE, an apparatus for inducing artificial respiration by means of an airtight case for the body and an air pump [n]\n",
  "SPIRT": "to emit liquid forcibly, also SPURT [v -ED, -ING, -S]\n",
  "SPIRTED": "SPIRT, to emit liquid forcibly, also SPURT [v]\n",
  "SPIRTING": "SPIRT, to emit liquid forcibly, also SPURT [v]\n",
  "SPIRTLE": "a wooden stick for stirring porridge, also SPURTLE [n -S]\n",
  "SPIRTLES": "SPIRTLE, a wooden stick for stirring porridge, also SPURTLE [n]\n",
  "SPIRTS": "SPIRT, to emit liquid forcibly, also SPURT [v]\n",
  "SPIRULA": "(Latin) a spiral-shelled mollusk [n SPIRULAS or SPIRULAE]\n",
  "SPIRULAE": "SPIRULA, (Latin) a spiral-shelled mollusk [n]\n",
  "SPIRULAS": "SPIRULA, (Latin) a spiral-shelled mollusk [n]\n",
  "SPIRULINA": "any filamentous cyanobacterium of the genus Spirulina [n SPIRULINAE or SPIRULINAS]\n",
  "SPIRULINAE": "SPIRULINA, any filamentous cyanobacterium of the genus Spirulina [n]\n",
  "SPIRULINAS": "SPIRULINA, any filamentous cyanobacterium of the genus Spirulina [n]\n",
  "SPIRY": "tall, slender and tapering [adj SPIRIER, SPIRIEST]\n",
  "SPISSITUDE": "density [n -S]\n",
  "SPISSITUDES": "SPISSITUDE, density [n]\n",
  "SPIT": "to throw out saliva from the mouth [v SPAT, SPITTING, SPITS] / to pierce with a metal rod [v SPITTED, SPITTEN, SPITTING, SPITS]\n",
  "SPITAL": "(archaic) a hospital [n -S]\n",
  "SPITALS": "SPITAL, (archaic) a hospital [n]\n",
  "SPITBALL": "to pitch a baseball where the ball has been altered by the application of saliva, petroleum jelly, or some other foreign substance [v -ED, -ING, -S]\n",
  "SPITBALLED": "SPITBALL, to pitch a baseball where the ball has been altered by the application of saliva, petroleum jelly, or some other foreign substance [v]\n",
  "SPITBALLING": "SPITBALL, to pitch a baseball where the ball has been altered by the application of saliva, petroleum jelly, or some other foreign substance [v]\n",
  "SPITBALLS": "SPITBALL, to pitch a baseball where the ball has been altered by the application of saliva, petroleum jelly, or some other foreign substance [v]\n",
  "SPITCHCOCK": "to split open (a fowl, eel etc.) for grilling, also SPATCHCOCK [v -ED, -ING, -S]\n",
  "SPITCHCOCKED": "SPITCHCOCK, to split open (a fowl, eel etc.) for grilling, also SPATCHCOCK [v]\n",
  "SPITCHCOCKING": "SPITCHCOCK, to split open (a fowl, eel etc.) for grilling, also SPATCHCOCK [v]\n",
  "SPITCHCOCKS": "SPITCHCOCK, to split open (a fowl, eel etc.) for grilling, also SPATCHCOCK [v]\n",
  "SPITCHER": "(slang) to be doomed [v -ED, -ING, -S]\n",
  "SPITCHERED": "SPITCHER, (slang) to be doomed [v]\n",
  "SPITCHERING": "SPITCHER, (slang) to be doomed [v]\n",
  "SPITCHERS": "SPITCHER, (slang) to be doomed [v]\n",
  "SPITE": "to treat with malice [v SPITED, SPITING, SPITES]\n",
  "SPITED": "SPITE, to treat with malice [v]\n",
  "SPITEFUL": "malicious [adj SPITEFULLER, SPITEFULLEST, SPITEFULLY]\n",
  "SPITEFULLER": "SPITEFUL, malicious [adj]\n",
  "SPITEFULLEST": "SPITEFUL, malicious [adj]\n",
  "SPITEFULLY": "SPITEFUL, malicious [adv]\n",
  "SPITEFULNESS": "the state of being spiteful [n -ES]\n",
  "SPITEFULNESSES": "SPITEFULNESS, the state of being spiteful [n]\n",
  "SPITES": "SPITE, to treat with malice [v]\n",
  "SPITFIRE": "a hot-tempered person [n -S]\n",
  "SPITFIRES": "SPITFIRE, a hot-tempered person [n]\n",
  "SPITING": "SPITE, to treat with malice [v]\n",
  "SPITS": "SPIT, to throw out saliva from the mouth [v]\n",
  "SPITSTICKER": "a wood engraving tool with a fine point for cutting curved lines [n -S]\n",
  "SPITSTICKERS": "SPITSTICKER, a wood engraving tool with a fine point for cutting curved lines [n]\n",
  "SPITTED": "SPIT, to throw out saliva from the mouth [v]\n",
  "SPITTEN": "SPIT, to throw out saliva from the mouth [v]\n",
  "SPITTER": "a type of pitch in baseball, also SPITBALL [n -S]\n",
  "SPITTERS": "SPITTER, a type of pitch in baseball, also SPITBALL [n]\n",
  "SPITTIER": "SPITTY, marked with saliva [adj]\n",
  "SPITTIEST": "SPITTY, marked with saliva [adj]\n",
  "SPITTING": "the act of ejecting saliva [n -S]\n",
  "SPITTINGS": "SPITTING, the act of ejecting saliva [n]\n",
  "SPITTLE": "saliva [n -S]\n",
  "SPITTLEBUG": "any of a family of leaping homopterous insects whose larvae emit froth, aka froghopper [n -S]\n",
  "SPITTLEBUGS": "SPITTLEBUG, any of a family of leaping homopterous insects whose larvae emit froth, aka froghopper [n]\n",
  "SPITTLES": "SPITTLE, saliva [n]\n",
  "SPITTLIER": "SPITTLY, like or covered with spittle [adj]\n",
  "SPITTLIEST": "SPITTLY, like or covered with spittle [adj]\n",
  "SPITTLY": "like or covered with spittle [adj SPITTLIER, SPITTLIEST]\n",
  "SPITTOON": "a receptacle for saliva [n -S]\n",
  "SPITTOONS": "SPITTOON, a receptacle for saliva [n]\n",
  "SPITTY": "marked with saliva [adj SPITTIER, SPITTIEST]\n",
  "SPITZ": "(German) a breed of dogs with long hair [n -ES]\n",
  "SPITZES": "SPITZ, (German) a breed of dogs with long hair [n]\n",
  "SPIV": "a petty criminal [n -S]\n",
  "SPIVS": "SPIV, a petty criminal [n]\n",
  "SPIVVERIES": "SPIVVERY, the world of spivs [n]\n",
  "SPIVVERY": "the world of spivs [n SPIVVERIES]\n",
  "SPIVVIER": "SPIVVY, like a spiv [adj]\n",
  "SPIVVIEST": "SPIVVY, like a spiv [adj]\n",
  "SPIVVISH": "like a spiv [adj]\n",
  "SPIVVY": "like a spiv [adj SPIVVIER, SPIVVIEST]\n",
  "SPLAKE": "a freshwater fish [n -S]\n",
  "SPLAKES": "SPLAKE, a freshwater fish [n]\n",
  "SPLANCHNIC": "visceral [adj]\n",
  "SPLANCHNOCELE": "a hernia of any of the abdominal viscera [n -S]\n",
  "SPLANCHNOCELES": "SPLANCHNOCELE, a hernia of any of the abdominal viscera [n]\n",
  "SPLANCHNOLOGIES": "SPLANCHNOLOGY, the study of the entrails or viscera [n]\n",
  "SPLANCHNOLOGY": "the study of the entrails or viscera [n SPLANCHNOLOGIES]\n",
  "SPLASH": "to scatter liquid about, also SPLISH, SPLOOSH, SPLOSH [v -ED, -ING, -ES]\n",
  "SPLASHBACK": "a sheet of glass, plastic, etc. attached to a wall above a basin to protect the wall against splashing [n -S]\n",
  "SPLASHBACKS": "SPLASHBACK, a sheet of glass, plastic, etc. attached to a wall above a basin to protect the wall against splashing [n]\n",
  "SPLASHBOARD": "a mudguard; a dashboard [n -S]\n",
  "SPLASHBOARDS": "SPLASHBOARD, a mudguard; a dashboard [n]\n",
  "SPLASHDOWN": "a landing in the sea e.g. of a spacecraft [n -S]\n",
  "SPLASHDOWNS": "SPLASHDOWN, a landing in the sea e.g. of a spacecraft [n]\n",
  "SPLASHED": "SPLASH, to scatter liquid about, also SPLISH, SPLOOSH, SPLOSH [v]\n",
  "SPLASHER": "one that splashes [n -S]\n",
  "SPLASHERS": "SPLASHER, one that splashes [n]\n",
  "SPLASHES": "SPLASH, to scatter liquid about, also SPLISH, SPLOOSH, SPLOSH [v]\n",
  "SPLASHIER": "SPLASHY, given to splashing [adj]\n",
  "SPLASHIEST": "SPLASHY, given to splashing [adj]\n",
  "SPLASHILY": "SPLASHY, given to splashing [adv]\n",
  "SPLASHINESS": "the state of being splashy [n -ES]\n",
  "SPLASHINESSES": "SPLASHINESS, the state of being splashy [n]\n",
  "SPLASHING": "the act of splashing [n -S]\n",
  "SPLASHINGS": "SPLASHING, the act of splashing [n]\n",
  "SPLASHPROOF": "resistant to being splashed [adj]\n",
  "SPLASHY": "given to splashing [adj SPLASHIER, SPLASHIEST, SPLASHILY]\n",
  "SPLAT": "to flatten on impact [v SPLATTED, SPLATTING, SPLATS]\n",
  "SPLATCH": "(Scots) to splotch, also SPLODGE, SPLOTCH [v -ED, -ING, -ES]\n",
  "SPLATCHED": "SPLATCH, (Scots) to splotch, also SPLODGE, SPLOTCH [v]\n",
  "SPLATCHES": "SPLATCH, (Scots) to splotch, also SPLODGE, SPLOTCH [v]\n",
  "SPLATCHING": "SPLATCH, (Scots) to splotch, also SPLODGE, SPLOTCH [v]\n",
  "SPLATS": "SPLAT, to flatten on impact [v]\n",
  "SPLATTED": "SPLAT, to flatten on impact [v]\n",
  "SPLATTER": "to spatter, to splash [v -ED, -ING, -S]\n",
  "SPLATTERED": "SPLATTER, to spatter, to splash [v]\n",
  "SPLATTERING": "SPLATTER, to spatter, to splash [v]\n",
  "SPLATTERPUNK": "a genre of fiction centring on extremely gory scenes [n -S]\n",
  "SPLATTERPUNKS": "SPLATTERPUNK, a genre of fiction centring on extremely gory scenes [n]\n",
  "SPLATTERS": "SPLATTER, to spatter, to splash [v]\n",
  "SPLATTING": "the sound of a splat [n -S]\n",
  "SPLATTINGS": "SPLATTING, the sound of a splat [n]\n",
  "SPLAY": "to spread out [v -ED, -ING, -S]\n",
  "SPLAYED": "SPLAY, to spread out [v]\n",
  "SPLAYFEET": "SPLAYFOOT, a foot that is abnormally flattened and spread out [n]\n",
  "SPLAYFOOT": "a foot that is abnormally flattened and spread out [n SPLAYFEET]\n",
  "SPLAYFOOTED": "having splayed feet [adj SPLAYFOOTEDLY]\n",
  "SPLAYFOOTEDLY": "SPLAYFOOTED, having splayed feet [adv]\n",
  "SPLAYING": "SPLAY, to spread out [v]\n",
  "SPLAYS": "SPLAY, to spread out [v]\n",
  "SPLEEN": "a ductless organ of the body [n -S]\n",
  "SPLEENFUL": "affected with spleen, fretful, also SPLEENISH [adj SPLEENFULLY]\n",
  "SPLEENFULLY": "SPLEENFUL, affected with spleen, fretful, also SPLEENISH [adv]\n",
  "SPLEENIER": "SPLEENY, (Shakespeare) irritable; peevish [adj]\n",
  "SPLEENIEST": "SPLEENY, (Shakespeare) irritable; peevish [adj]\n",
  "SPLEENISH": "affected with spleen; fretful, also SPLEENFUL [adj]\n",
  "SPLEENLESS": "having no spleen; hence kind, mild [adj]\n",
  "SPLEENLIKE": "like a spleen [adj]\n",
  "SPLEENS": "SPLEEN, a ductless organ of the body [n]\n",
  "SPLEENSTONE": "(obsolete) jade [n -S]\n",
  "SPLEENSTONES": "SPLEENSTONE, (obsolete) jade [n]\n",
  "SPLEENWORT": "any fern of the genus Asplenium, some species of which were anciently used as remedies for disorders of the spleen [n -S]\n",
  "SPLEENWORTS": "SPLEENWORT, any fern of the genus Asplenium, some species of which were anciently used as remedies for disorders of the spleen [n]\n",
  "SPLEENY": "(Shakespeare) irritable; peevish [adj SPLEENIER, SPLEENIEST]\n",
  "SPLENATIVE": "(obsolete) hot-tempered [adj]\n",
  "SPLENDENT": "(archaic) glossy; brilliant [adj]\n",
  "SPLENDID": "magnificent [adj SPLENDIDER, SPLENDIDEST, SPLENDIDLY]\n",
  "SPLENDIDER": "SPLENDID, magnificent [adj]\n",
  "SPLENDIDEST": "SPLENDID, magnificent [adj]\n",
  "SPLENDIDIOUS": "(obsolete) splendid, also SPLENDIDOUS [adj]\n",
  "SPLENDIDLY": "SPLENDID, magnificent [adv]\n",
  "SPLENDIDNESS": "the state of being splendid [n -ES]\n",
  "SPLENDIDNESSES": "SPLENDIDNESS, the state of being splendid [n]\n",
  "SPLENDIDOUS": "(obsolete) splendid, also SPLENDIDIOUS [adj]\n",
  "SPLENDIFEROUS": "splendid [adj SPLENDIFEROUSLY]\n",
  "SPLENDIFEROUSLY": "SPLENDIFEROUS, splendid [adv]\n",
  "SPLENDOR": "magnificence [n -S]\n",
  "SPLENDOROUS": "full of splendour, also SPLENDROUS [adj]\n",
  "SPLENDORS": "SPLENDOR, magnificence [n]\n",
  "SPLENDOUR": "brilliance, magnificence, also SPLENDOR [n -S]\n",
  "SPLENDOURS": "SPLENDOUR, brilliance, magnificence, also SPLENDOR [n]\n",
  "SPLENDROUS": "full of splendour, also SPLENDOROUS [adj]\n",
  "SPLENECTOMIES": "SPLENECTOMY, the surgical removal of the spleen [n]\n",
  "SPLENECTOMISE": "to remove the spleen, also SPLENECTOMIZE [v SPLENECTOMISED, SPLENECTOMISING, SPLENECTOMISES]\n",
  "SPLENECTOMISED": "SPLENECTOMISE, to remove the spleen, also SPLENECTOMIZE [v]\n",
  "SPLENECTOMISES": "SPLENECTOMISE, to remove the spleen, also SPLENECTOMIZE [v]\n",
  "SPLENECTOMISING": "SPLENECTOMISE, to remove the spleen, also SPLENECTOMIZE [v]\n",
  "SPLENECTOMIZE": "to remove the spleen, also SPLENECTOMISE [v SPLENECTOMIZED, SPLENECTOMIZING, SPLENECTOMIZES]\n",
  "SPLENECTOMIZED": "SPLENECTOMIZE, to remove the spleen, also SPLENECTOMISE [v]\n",
  "SPLENECTOMIZES": "SPLENECTOMIZE, to remove the spleen, also SPLENECTOMISE [v]\n",
  "SPLENECTOMIZING": "SPLENECTOMIZE, to remove the spleen, also SPLENECTOMISE [v]\n",
  "SPLENECTOMY": "the surgical removal of the spleen [n SPLENECTOMIES]\n",
  "SPLENETIC": "marked by bad temper, malevolence or spite [adj SPLENETICALLY] / one who is splenetic [n -S]\n",
  "SPLENETICAL": "marked by bad temper, malevolence or spite [adj SPLENETICALLY]\n",
  "SPLENETICALLY": "SPLENETICAL, marked by bad temper, malevolence or spite [adv]\n",
  "SPLENETICS": "SPLENETIC, one who is splenetic [n]\n",
  "SPLENIA": "SPLENIUM, (Latin) a surgical bandage [n]\n",
  "SPLENIAL": "of or like the splenius, a muscle of the neck [adj]\n",
  "SPLENIC": "pertaining to the spleen [adj]\n",
  "SPLENII": "SPLENIUS, (Latin) a muscle of the neck [n]\n",
  "SPLENISATION": "conversion (e.g. of the lung) into a spongy, spleen-like substance, also SPLENIZATION [n -S]\n",
  "SPLENISATIONS": "SPLENISATION, conversion (e.g. of the lung) into a spongy, spleen-like substance, also SPLENIZATION [n]\n",
  "SPLENITIS": "inflammation of the spleen [n -ES]\n",
  "SPLENITISES": "SPLENITIS, inflammation of the spleen [n]\n",
  "SPLENIUM": "(Latin) a surgical bandage [n SPLENIUMS or SPLENIA]\n",
  "SPLENIUMS": "SPLENIUM, (Latin) a surgical bandage [n]\n",
  "SPLENIUS": "(Latin) a muscle of the neck [n SPLENII or SPLENIUSES]\n",
  "SPLENIUSES": "SPLENIUS, (Latin) a muscle of the neck [n]\n",
  "SPLENIZATION": "conversion (e.g. of the lung) into a spongy, spleen-like substance, also SPLENISATION [n -S]\n",
  "SPLENIZATIONS": "SPLENIZATION, conversion (e.g. of the lung) into a spongy, spleen-like substance, also SPLENISATION [n]\n",
  "SPLENOMEGALIES": "SPLENOMEGALY, abnormal enlargement of the spleen [n]\n",
  "SPLENOMEGALY": "abnormal enlargement of the spleen [n SPLENOMEGALIES]\n",
  "SPLENT": "a contrivance for holding a broken bone, etc. in position, also SPLINT [n -S]\n",
  "SPLENTS": "SPLENT, a contrivance for holding a broken bone, etc. in position, also SPLINT [n]\n",
  "SPLEUCHAN": "(Gaelic) a pouch, as for tobacco [n -S]\n",
  "SPLEUCHANS": "SPLEUCHAN, (Gaelic) a pouch, as for tobacco [n]\n",
  "SPLICE": "to join at both ends [v SPLICED, SPLICING, SPLICES]\n",
  "SPLICED": "SPLICE, to join at both ends [v]\n",
  "SPLICER": "one who splices [n -S]\n",
  "SPLICERS": "SPLICER, one who splices [n]\n",
  "SPLICES": "SPLICE, to join at both ends [v]\n",
  "SPLICING": "the act of joining at both ends [n -S]\n",
  "SPLICINGS": "SPLICING, the act of joining at both ends [n]\n",
  "SPLIFF": "(slang) a marijuana cigarette [n -S]\n",
  "SPLIFFS": "SPLIFF, (slang) a marijuana cigarette [n]\n",
  "SPLINE": "to provide with a key to make a wheel and shaft revolve [v SPLINED, SPLINING, SPLINES]\n",
  "SPLINED": "SPLINE, to provide with a key to make a wheel and shaft revolve [v]\n",
  "SPLINES": "SPLINE, to provide with a key to make a wheel and shaft revolve [v]\n",
  "SPLINING": "SPLINE, to provide with a key to make a wheel and shaft revolve [v]\n",
  "SPLINT": "a contrivance for holding a broken bone, etc. in position, also SPLENT [n -S] / to put a splint on [v -ED, -ING, -S]\n",
  "SPLINTED": "SPLINT, to put a splint on [v]\n",
  "SPLINTER": "to split into sharp, slender pieces [v -ED, -ING, -S]\n",
  "SPLINTERED": "SPLINTER, to split into sharp, slender pieces [v]\n",
  "SPLINTERIER": "SPLINTERY, given to splintering [adj]\n",
  "SPLINTERIEST": "SPLINTERY, given to splintering [adj]\n",
  "SPLINTERING": "SPLINTER, to split into sharp, slender pieces [v]\n",
  "SPLINTERS": "SPLINTER, to split into sharp, slender pieces [v]\n",
  "SPLINTERY": "given to splintering [adj SPLINTERIER, SPLINTERIEST]\n",
  "SPLINTING": "SPLINT, to put a splint on [v]\n",
  "SPLINTLIKE": "like a splint [adj]\n",
  "SPLINTS": "SPLINT, to put a splint on [v]\n",
  "SPLINTWOOD": "sapwood [n -S]\n",
  "SPLINTWOODS": "SPLINTWOOD, sapwood [n]\n",
  "SPLISH": "to splash, also SPLASH, SPLOOSH, SPLOSH [v SPLISHED, SPLISHING, SPLISHES]\n",
  "SPLISHED": "SPLISH, to splash, also SPLASH, SPLOOSH, SPLOSH [v]\n",
  "SPLISHES": "SPLISH, to splash, also SPLASH, SPLOOSH, SPLOSH [v]\n",
  "SPLISHING": "SPLISH, to splash, also SPLASH, SPLOOSH, SPLOSH [v]\n",
  "SPLIT": "to separate lengthwise [v SPLIT or SPLITTED, SPLITTING, SPLITS]\n",
  "SPLITS": "SPLIT, to separate lengthwise [v]\n",
  "SPLITTED": "SPLIT, to separate lengthwise [v]\n",
  "SPLITTER": "one that splits [n -S]\n",
  "SPLITTERS": "SPLITTER, one that splits [n]\n",
  "SPLITTING": "the act of separating lengthwise [n -S]\n",
  "SPLITTINGS": "SPLITTING, the act of separating lengthwise [n]\n",
  "SPLITTISM": "advocating the withdrawal of a group from a large centralized body [n -S]\n",
  "SPLITTISMS": "SPLITTISM, advocating the withdrawal of a group from a large centralized body [n]\n",
  "SPLITTIST": "one advocating the withdrawal of a group from a large centralized body [n -S]\n",
  "SPLITTISTS": "SPLITTIST, one advocating the withdrawal of a group from a large centralized body [n]\n",
  "SPLODGE": "to make a splash, also SPLATCH, SPLOTCH [v SPLODGED, SPLODGING, SPLODGES]\n",
  "SPLODGED": "SPLODGE, to make a splash, also SPLATCH, SPLOTCH [v]\n",
  "SPLODGES": "SPLODGE, to make a splash, also SPLATCH, SPLOTCH [v]\n",
  "SPLODGIER": "SPLODGY, covered with splodges [adj]\n",
  "SPLODGIEST": "SPLODGY, covered with splodges [adj]\n",
  "SPLODGILY": "SPLODGY, covered with splodges [adv]\n",
  "SPLODGINESS": "the state of being splodgy [n -ES]\n",
  "SPLODGINESSES": "SPLODGINESS, the state of being splodgy [n]\n",
  "SPLODGING": "SPLODGE, to make a splash, also SPLATCH, SPLOTCH [v]\n",
  "SPLODGY": "covered with splodges [adj SPLODGIER, SPLODGIEST, SPLODGILY]\n",
  "SPLOG": "a spam blog, an artificially created weblog site which the author uses to promote affiliated websites or to increase the search engine rankings of associated sites [n -S]\n",
  "SPLOGS": "SPLOG, a spam blog, an artificially created weblog site which the author uses to promote affiliated websites or to increase the search engine rankings of associated sites [n]\n",
  "SPLOOSH": "to splash, also SPLASH, SPLISH, SPLOSH [v -ED, -ING, -ES]\n",
  "SPLOOSHED": "SPLOOSH, to splash, also SPLASH, SPLISH, SPLOSH [v]\n",
  "SPLOOSHES": "SPLOOSH, to splash, also SPLASH, SPLISH, SPLOSH [v]\n",
  "SPLOOSHING": "SPLOOSH, to splash, also SPLASH, SPLISH, SPLOSH [v]\n",
  "SPLORE": "(Scots) a frolic, a spree [n -S]\n",
  "SPLORES": "SPLORE, (Scots) a frolic, a spree [n]\n",
  "SPLOSH": "to splash, also SPLASH, SPLISH, SPLOOSH [v -ED, -ING, -ES]\n",
  "SPLOSHED": "SPLOSH, to splash, also SPLASH, SPLISH, SPLOOSH [v]\n",
  "SPLOSHES": "SPLOSH, to splash, also SPLASH, SPLISH, SPLOOSH [v]\n",
  "SPLOSHING": "SPLOSH, to splash, also SPLASH, SPLISH, SPLOOSH [v]\n",
  "SPLOTCH": "to mark with spots, also SPLATCH, SPLODGE [v -ED, -ING, -ES]\n",
  "SPLOTCHED": "SPLOTCH, to mark with spots, also SPLATCH, SPLODGE [v]\n",
  "SPLOTCHES": "SPLOTCH, to mark with spots, also SPLATCH, SPLODGE [v]\n",
  "SPLOTCHIER": "SPLOTCHY, covered with splotches [adj]\n",
  "SPLOTCHIEST": "SPLOTCHY, covered with splotches [adj]\n",
  "SPLOTCHILY": "SPLOTCHY, covered with splotches [adv]\n",
  "SPLOTCHINESS": "the state of being splotchy [n -ES]\n",
  "SPLOTCHINESSES": "SPLOTCHINESS, the state of being splotchy [n]\n",
  "SPLOTCHING": "SPLOTCH, to mark with spots, also SPLATCH, SPLODGE [v]\n",
  "SPLOTCHY": "covered with splotches [adj SPLOTCHIER, SPLOTCHIEST, SPLOTCHILY]\n",
  "SPLURGE": "to spend money lavishly [v SPLURGED, SPLURGING, SPLURGES]\n",
  "SPLURGED": "SPLURGE, to spend money lavishly [v]\n",
  "SPLURGER": "one who splurges [n -S]\n",
  "SPLURGERS": "SPLURGER, one who splurges [n]\n",
  "SPLURGES": "SPLURGE, to spend money lavishly [v]\n",
  "SPLURGIER": "SPLURGY, tending to splurge [adj]\n",
  "SPLURGIEST": "SPLURGY, tending to splurge [adj]\n",
  "SPLURGING": "SPLURGE, to spend money lavishly [v]\n",
  "SPLURGY": "tending to splurge [adj SPLURGIER, SPLURGIEST]\n",
  "SPLURT": "to gush forth in a stream or jet [v -ED, -ING, -S]\n",
  "SPLURTED": "SPLURT, to gush forth in a stream or jet [v]\n",
  "SPLURTING": "SPLURT, to gush forth in a stream or jet [v]\n",
  "SPLURTS": "SPLURT, to gush forth in a stream or jet [v]\n",
  "SPLUTTER": "to speak rapidly and confusedly [v -ED, -ING, -S]\n",
  "SPLUTTERED": "SPLUTTER, to speak rapidly and confusedly [v]\n",
  "SPLUTTERER": "one who splutters [n -S]\n",
  "SPLUTTERERS": "SPLUTTERER, one who splutters [n]\n",
  "SPLUTTERIER": "SPLUTTERY, given to spluttering [adj]\n",
  "SPLUTTERIEST": "SPLUTTERY, given to spluttering [adj]\n",
  "SPLUTTERING": "speaking rapidly and confusedly [adj SPLUTTERINGLY] / the act of spluttering [n -S]\n",
  "SPLUTTERINGLY": "SPLUTTERING, speaking rapidly and confusedly [adv]\n",
  "SPLUTTERINGS": "SPLUTTERING, the act of spluttering [n]\n",
  "SPLUTTERS": "SPLUTTER, to speak rapidly and confusedly [v]\n",
  "SPLUTTERY": "given to spluttering [adj SPLUTTERIER, SPLUTTERIEST]\n",
  "SPOD": "a boring, studious person [n -S]\n",
  "SPODDIER": "SPODDY, boring, studious [adj]\n",
  "SPODDIEST": "SPODDY, boring, studious [adj]\n",
  "SPODDY": "boring, studious [adj SPODDIER, SPODDIEST]\n",
  "SPODE": "a fine china [n -S]\n",
  "SPODES": "SPODE, a fine china [n]\n",
  "SPODIUM": "(Greek) bone charcoal; powder obtained from calcination of substances [n -S]\n",
  "SPODIUMS": "SPODIUM, (Greek) bone charcoal; powder obtained from calcination of substances [n]\n",
  "SPODOGRAM": "a preparation of the ash from a section of a plant, used in microscopy [n -S]\n",
  "SPODOGRAMS": "SPODOGRAM, a preparation of the ash from a section of a plant, used in microscopy [n]\n",
  "SPODOMANCIES": "SPODOMANCY, divination by means of ashes [n]\n",
  "SPODOMANCY": "divination by means of ashes [n SPODOMANCIES]\n",
  "SPODOMANTIC": "relating to spodomancy, divination by means of ashes [adj]\n",
  "SPODOSOL": "a type of ashy soil [n -S]\n",
  "SPODOSOLS": "SPODOSOL, a type of ashy soil [n]\n",
  "SPODS": "SPOD, a boring, studious person [n]\n",
  "SPODUMENE": "a monoclinic pyroxene, a silicate of aluminium and lithium occurring in granite pegmatites [n -S]\n",
  "SPODUMENES": "SPODUMENE, a monoclinic pyroxene, a silicate of aluminium and lithium occurring in granite pegmatites [n]\n",
  "SPOFFISH": "(archaic) fussy, officious, also SPOFFY [adj]\n",
  "SPOFFY": "(archaic) fussy, officious, also SPOFFISH [adj]\n",
  "SPOIL": "to mar [v SPOILT or SPOILED, SPOILING, SPOILS]\n",
  "SPOILABLE": "capable of being spoiled [adj]\n",
  "SPOILAGE": "something that is spoiled or wasted [n -S]\n",
  "SPOILAGES": "SPOILAGE, something that is spoiled or wasted [n]\n",
  "SPOILED": "SPOIL, to mar [v]\n",
  "SPOILER": "one who spoils [n -S]\n",
  "SPOILERS": "SPOILER, one who spoils [n]\n",
  "SPOILFIVE": "a certain game at cards in which, if no player wins three of the five tricks possible on any deal, the game is said to be spoiled [n -S]\n",
  "SPOILFIVES": "SPOILFIVE, a certain game at cards in which, if no player wins three of the five tricks possible on any deal, the game is said to be spoiled [n]\n",
  "SPOILFUL": "wasteful; rapacious, also SPOYLEFULL [adj]\n",
  "SPOILING": "SPOIL, to mar [v]\n",
  "SPOILS": "SPOIL, to mar [v]\n",
  "SPOILSMAN": "(US) someone who looks for profit out of politics or who advocates the spoils system [n SPOILSMEN]\n",
  "SPOILSMEN": "SPOILSMAN, (US) someone who looks for profit out of politics or who advocates the spoils system [n]\n",
  "SPOILSPORT": "one who spoils the sport or pleasure of others [n -S]\n",
  "SPOILSPORTS": "SPOILSPORT, one who spoils the sport or pleasure of others [n]\n",
  "SPOILT": "SPOIL, to mar [v]\n",
  "SPOKE": "to supply with rods for the rim of wheels [v SPOKED, SPOKING, SPOKES]\n",
  "SPOKED": "SPOKE, to supply with rods for the rim of wheels [v]\n",
  "SPOKEN": "SPEAK, to speak [v]\n",
  "SPOKES": "SPOKE, to supply with rods for the rim of wheels [v]\n",
  "SPOKESHAVE": "a plane or knife used to round spokes [n -S]\n",
  "SPOKESHAVES": "SPOKESHAVE, a plane or knife used to round spokes [n]\n",
  "SPOKESMAN": "a person who speaks for another, or for others [n SPOKESMEN]\n",
  "SPOKESMANSHIP": "the office of spokesman [n -S]\n",
  "SPOKESMANSHIPS": "SPOKESMANSHIP, the office of spokesman [n]\n",
  "SPOKESMEN": "SPOKESMAN, a person who speaks for another, or for others [n]\n",
  "SPOKESPEOPLE": "people serving as spokesmen or spokeswomen [n]\n",
  "SPOKESPERSON": "a spokesman or spokeswoman [n -S]\n",
  "SPOKESPERSONS": "SPOKESPERSON, a spokesman or spokeswoman [n]\n",
  "SPOKESWOMAN": "a woman who speaks as the representative of another or others often in a professional capacity [n SPOKESWOMEN]\n",
  "SPOKESWOMEN": "SPOKESWOMAN, a woman who speaks as the representative of another or others often in a professional capacity [n]\n",
  "SPOKEWISE": "arranged in the fashion of spokes [adv]\n",
  "SPOKING": "SPOKE, to supply with rods for the rim of wheels [v]\n",
  "SPOLIATE": "to despoil; to plunder [v SPOLIATED, SPOLIATING, SPOLIATES]\n",
  "SPOLIATED": "SPOLIATE, to despoil; to plunder [v]\n",
  "SPOLIATES": "SPOLIATE, to despoil; to plunder [v]\n",
  "SPOLIATING": "SPOLIATE, to despoil; to plunder [v]\n",
  "SPOLIATION": "the act of pillaging and plundering [n -S]\n",
  "SPOLIATIONS": "SPOLIATION, the act of pillaging and plundering [n]\n",
  "SPOLIATIVE": "tending to spoil, also SPOLIATORY [adj]\n",
  "SPOLIATOR": "one who spoliates [n -S]\n",
  "SPOLIATORS": "SPOLIATOR, one who spoliates [n]\n",
  "SPOLIATORY": "tending to spoil, also SPOLIATIVE [adj]\n",
  "SPONDAIC": "or of pertaining to a spondee, also SPONDAICAL [adj] / a spondee [n -S]\n",
  "SPONDAICAL": "or of pertaining to a spondee, also SPONDAIC [adj]\n",
  "SPONDAICS": "SPONDAIC, a spondee [n]\n",
  "SPONDEE": "(Greek) a type of metrical foot, also SPONDAIC [n -S]\n",
  "SPONDEES": "SPONDEE, (Greek) a type of metrical foot, also SPONDAIC [n]\n",
  "SPONDOOLICKS": "(US slang) cash, money, also SPONDULICKS, SPONDULIX [n]\n",
  "SPONDULICKS": "(US slang) cash, money, also SPONDOOLICKS, SPONDULIX [n]\n",
  "SPONDULIX": "(US slang) cash, money, also SPONDOOLICKS, SPONDULICKS [n SPONDULIX]\n",
  "SPONDYL": "(Greek) a vertebra; a thorny oyster [n -S]\n",
  "SPONDYLITIC": "relating to spondylitis [adj] / a person affected with spondylitis [n -S]\n",
  "SPONDYLITICS": "SPONDYLITIC, a person affected with spondylitis [n]\n",
  "SPONDYLITIDES": "SPONDYLITIS, inflammation of the vertebra [n]\n",
  "SPONDYLITIS": "inflammation of the vertebra [n SPONDYLITIDES or SPONDYLITISES]\n",
  "SPONDYLITISES": "SPONDYLITIS, inflammation of the vertebra [n]\n",
  "SPONDYLOLYSES": "SPONDYLOLYSIS, disintegration of one or more vertebrae, also SPONDYLOSIS [n]\n",
  "SPONDYLOLYSIS": "disintegration of one or more vertebrae, also SPONDYLOSIS [n SPONDYLOLYSES]\n",
  "SPONDYLOSES": "SPONDYLOSIS, disintegration of one or more vertebrae [n]\n",
  "SPONDYLOSIS": "disintegration of one or more vertebrae [n -ES]\n",
  "SPONDYLOSISES": "SPONDYLOSIS, disintegration of one or more vertebrae [n]\n",
  "SPONDYLOUS": "like a spondyl, a vertebra [adj]\n",
  "SPONDYLS": "SPONDYL, (Greek) a vertebra; a thorny oyster [n]\n",
  "SPONGE": "to wipe with absorbent material, also SPUNGE [v SPONGED, SPONGING or SPONGEING, SPONGES]\n",
  "SPONGEABLE": "that can be sponged [adj]\n",
  "SPONGEBAG": "a bag for holding a toilet sponge [n -S]\n",
  "SPONGEBAGS": "SPONGEBAG, a bag for holding a toilet sponge [n]\n",
  "SPONGED": "SPONGE, to wipe with absorbent material, also SPUNGE [v]\n",
  "SPONGEING": "SPONGE, to wipe with absorbent material, also SPUNGE [v]\n",
  "SPONGELIKE": "like a sponge [adj]\n",
  "SPONGEOUS": "somewhat spongy; spongelike, also SPONGIOSE, SPONGIOUS [adj]\n",
  "SPONGER": "one that sponges [n -S]\n",
  "SPONGERS": "SPONGER, one that sponges [n]\n",
  "SPONGES": "SPONGE, to wipe with absorbent material, also SPUNGE [v]\n",
  "SPONGEWARE": "pottery on which patterns etc. are applied using a sponge [n -S]\n",
  "SPONGEWARES": "SPONGEWARE, pottery on which patterns etc. are applied using a sponge [n]\n",
  "SPONGEWOOD": "an Indian plant with a pith used in making tropical hats, aka sola [n -S]\n",
  "SPONGEWOODS": "SPONGEWOOD, an Indian plant with a pith used in making tropical hats, aka sola [n]\n",
  "SPONGICOLOUS": "living in association with, usually within, a sponge [adj]\n",
  "SPONGIER": "SPONGY, absorptive [adj]\n",
  "SPONGIEST": "SPONGY, absorptive [adj]\n",
  "SPONGIFORM": "resembling a sponge; soft and porous [adj]\n",
  "SPONGILY": "SPONGY, absorptive [adv]\n",
  "SPONGIN": "a horny substance in the skeletons of various sponges [n -S]\n",
  "SPONGINESS": "the state of being spongy [n -ES]\n",
  "SPONGINESSES": "SPONGINESS, the state of being spongy [n]\n",
  "SPONGING": "SPONGE, to wipe with absorbent material, also SPUNGE [v]\n",
  "SPONGINS": "SPONGIN, a horny substance in the skeletons of various sponges [n]\n",
  "SPONGIOBLAST": "any of numerous columnar epithelial cells in the brain and spinal cord that develop into neuroglia [n -S]\n",
  "SPONGIOBLASTIC": "of or like a spongioblast, any of numerous columnar epithelial cells in the brain and spinal cord that develop into neuroglia [adj]\n",
  "SPONGIOBLASTS": "SPONGIOBLAST, any of numerous columnar epithelial cells in the brain and spinal cord that develop into neuroglia [n]\n",
  "SPONGIOSE": "somewhat spongy; spongelike, also SPONGEOUS, SPONGIOUS [adj]\n",
  "SPONGIOUS": "somewhat spongy; spongelike, also SPONGEOUS, SPONGIOSE [adj]\n",
  "SPONGOID": "resembling a sponge [adj]\n",
  "SPONGOLOGIES": "SPONGOLOGY, the study of sponges [n]\n",
  "SPONGOLOGIST": "one who studies sponges [n -S]\n",
  "SPONGOLOGISTS": "SPONGOLOGIST, one who studies sponges [n]\n",
  "SPONGOLOGY": "the study of sponges [n SPONGOLOGIES]\n",
  "SPONGY": "absorptive [adj SPONGIER, SPONGIEST, SPONGILY]\n",
  "SPONSAL": "relating to sponsalia, nuptial [adj]\n",
  "SPONSALIA": "nuptials, marriage [n]\n",
  "SPONSIBLE": "responsible; worthy of credit [adj]\n",
  "SPONSING": "a platform jutting from ship's deck for gun or wheel, also SPONSON [n -S]\n",
  "SPONSINGS": "SPONSING, a platform jutting from ship's deck for gun or wheel, also SPONSON [n]\n",
  "SPONSION": "the act of becoming surety for another [n -S]\n",
  "SPONSIONAL": "of or pertaining to a pledge or agreement [adj]\n",
  "SPONSIONS": "SPONSION, the act of becoming surety for another [n]\n",
  "SPONSON": "a platform jutting from ship's deck for gun or wheel, also SPONSING [n -S]\n",
  "SPONSONS": "SPONSON, a platform jutting from ship's deck for gun or wheel, also SPONSING [n]\n",
  "SPONSOR": "a person who promises responsibility [n -S] / to act as a sponsor [v -ED, -ING, -S]\n",
  "SPONSORED": "SPONSOR, to act as a sponsor [v]\n",
  "SPONSORIAL": "relating to a sponsor [adj]\n",
  "SPONSORING": "SPONSOR, to act as a sponsor [v]\n",
  "SPONSORS": "SPONSOR, to act as a sponsor [v]\n",
  "SPONSORSHIP": "support by a sponsor [n -S]\n",
  "SPONSORSHIPS": "SPONSORSHIP, support by a sponsor [n]\n",
  "SPONTANEITIES": "SPONTANEITY, the state of being spontaneous [n]\n",
  "SPONTANEITY": "the state of being spontaneous [n SPONTANEITIES]\n",
  "SPONTANEOUS": "acting by its own impulse or natural law [adj SPONTANEOUSLY]\n",
  "SPONTANEOUSLY": "SPONTANEOUS, acting by its own impulse or natural law [adv]\n",
  "SPONTANEOUSNESS": "the state of being spontaneous [n]\n",
  "SPONTOON": "a small-headed halberd formerly carried by some infantry officers [n -S]\n",
  "SPONTOONS": "SPONTOON, a small-headed halberd formerly carried by some infantry officers [n]\n",
  "SPOOF": "to ridicule in fun [v -ED, -ING, -S]\n",
  "SPOOFED": "SPOOF, to ridicule in fun [v]\n",
  "SPOOFER": "one who spoofs, a hoaxer [n -S]\n",
  "SPOOFERIES": "SPOOFERY, good-natured ridicule [n]\n",
  "SPOOFERS": "SPOOFER, one who spoofs, a hoaxer [n]\n",
  "SPOOFERY": "good-natured ridicule [n SPOOFERIES]\n",
  "SPOOFIER": "SPOOFY, humorously satiric [adj]\n",
  "SPOOFIEST": "SPOOFY, humorously satiric [adj]\n",
  "SPOOFING": "an act of spoofing [n -S]\n",
  "SPOOFINGS": "SPOOFING, an act of spoofing [n]\n",
  "SPOOFS": "SPOOF, to ridicule in fun [v]\n",
  "SPOOFY": "humorously satiric [adj SPOOFIER, SPOOFIEST]\n",
  "SPOOK": "to frighten, startle [v -ED, -ING, -S]\n",
  "SPOOKED": "SPOOK, to frighten, startle [v]\n",
  "SPOOKERIES": "SPOOKERY, something spooky [n]\n",
  "SPOOKERY": "something spooky [n SPOOKERIES]\n",
  "SPOOKIER": "SPOOKY, scary, also SPOOKISH [adj]\n",
  "SPOOKIEST": "SPOOKY, scary, also SPOOKISH [adj]\n",
  "SPOOKILY": "SPOOKY, scary, also SPOOKISH [adv]\n",
  "SPOOKINESS": "the state of being spooky [n -ES]\n",
  "SPOOKINESSES": "SPOOKINESS, the state of being spooky [n]\n",
  "SPOOKING": "SPOOK, to frighten, startle [v]\n",
  "SPOOKISH": "spooky [adj]\n",
  "SPOOKS": "SPOOK, to frighten, startle [v]\n",
  "SPOOKY": "scary, also SPOOKISH [adj SPOOKIER, SPOOKIEST, SPOOKILY]\n",
  "SPOOL": "to wind on a small cylinder [v -ED, -ING, -S]\n",
  "SPOOLED": "SPOOL, to wind on a small cylinder [v]\n",
  "SPOOLER": "a device for transferring data to a memory store for later printing or processing [n -S]\n",
  "SPOOLERS": "SPOOLER, a device for transferring data to a memory store for later printing or processing [n]\n",
  "SPOOLING": "the temporary storage of data for later output [n -S]\n",
  "SPOOLINGS": "SPOOLING, the temporary storage of data for later output [n]\n",
  "SPOOLS": "SPOOL, to wind on a small cylinder [v]\n",
  "SPOOM": "to scud before the wind [v -ED, -ING, -S]\n",
  "SPOOMED": "SPOOM, to scud before the wind [v]\n",
  "SPOOMING": "SPOOM, to scud before the wind [v]\n",
  "SPOOMS": "SPOOM, to scud before the wind [v]\n",
  "SPOON": "to eat with a scooping eating utensil [v -ED, -ING, -S]\n",
  "SPOONBAIT": "a lure on a swivel, used in trolling for fish, also SPOONHOOK [n -S]\n",
  "SPOONBAITS": "SPOONBAIT, a lure on a swivel, used in trolling for fish, also SPOONHOOK [n]\n",
  "SPOONBILL": "a kind of wading bird with a spoon-shaped bill [n -S]\n",
  "SPOONBILLS": "SPOONBILL, a kind of wading bird with a spoon-shaped bill [n]\n",
  "SPOONDRIFT": "the ocean spray which is blown by the wind, also SPINDRIFT [n -S]\n",
  "SPOONDRIFTS": "SPOONDRIFT, the ocean spray which is blown by the wind, also SPINDRIFT [n]\n",
  "SPOONED": "SPOON, to eat with a scooping eating utensil [v]\n",
  "SPOONER": "one who engages in spooning (amorous behaviour) [n -S]\n",
  "SPOONERISM": "a transposition of initial sounds of spoken words, e.g. 'shoving leopard' for 'loving shepherd' [n -S]\n",
  "SPOONERISMS": "SPOONERISM, a transposition of initial sounds of spoken words, e.g. 'shoving leopard' for 'loving shepherd' [n]\n",
  "SPOONERS": "SPOONER, one who engages in spooning (amorous behaviour) [n]\n",
  "SPOONEY": "foolishly fond, also SPOONY [adj] / one who is spooney [n -S]\n",
  "SPOONEYS": "SPOONEY, one who is spooney [n]\n",
  "SPOONFED": "aided in every way [adj]\n",
  "SPOONFUL": "as much as a spoon can hold [n SPOONFULS or SPOONSFUL]\n",
  "SPOONFULS": "SPOONFUL, as much as a spoon can hold [n]\n",
  "SPOONHOOK": "a lure on a swivel, used in trolling for fish, also SPOONBAIT [n -S]\n",
  "SPOONHOOKS": "SPOONHOOK, a lure on a swivel, used in trolling for fish, also SPOONBAIT [n]\n",
  "SPOONIER": "SPOONY, foolishly fond [adj]\n",
  "SPOONIES": "SPOONY, one who is foolishly fooled, also SPOONEY [n]\n",
  "SPOONIEST": "SPOONY, foolishly fond [adj]\n",
  "SPOONILY": "SPOONY, foolishly fond [adv]\n",
  "SPOONING": "SPOON, to eat with a scooping eating utensil [v]\n",
  "SPOONLIKE": "like a spoon [adj]\n",
  "SPOONS": "SPOON, to eat with a scooping eating utensil [v]\n",
  "SPOONSFUL": "SPOONFUL, as much as a spoon can hold [n]\n",
  "SPOONWAYS": "like spoons packed closely together, also SPOONWISE [adv]\n",
  "SPOONWISE": "like spoons packed closely together, also SPOONWAYS [adv]\n",
  "SPOONWORM": "a marine invertebrate of the phylum Echiura with a spoon-like mouthpiece [n -S]\n",
  "SPOONWORMS": "SPOONWORM, a marine invertebrate of the phylum Echiura with a spoon-like mouthpiece [n]\n",
  "SPOONY": "foolishly fond [adj SPOONIER, SPOONIEST, SPOONILY] / one who is foolishly fooled, also SPOONEY [n SPOONIES]\n",
  "SPOOR": "to follow a trail [v -ED, -ING, -S]\n",
  "SPOORED": "SPOOR, to follow a trail [v]\n",
  "SPOORER": "one who spoors, a tracker [n -S]\n",
  "SPOORERS": "SPOORER, one who spoors, a tracker [n]\n",
  "SPOORING": "SPOOR, to follow a trail [v]\n",
  "SPOORS": "SPOOR, to follow a trail [v]\n",
  "SPOOT": "the razor-shell mollusc [n -S]\n",
  "SPOOTS": "SPOOT, the razor-shell mollusc [n]\n",
  "SPORADIC": "occurring at irregular intervals, also SPORADICAL [adj SPORADICALLY]\n",
  "SPORADICAL": "occurring at irregular intervals, also SPORADIC [adj SPORADICALLY]\n",
  "SPORADICALLY": "SPORADICAL, occurring at irregular intervals, also SPORADIC [adv]\n",
  "SPORADICALNESS": "the state of being sporadical [n]\n",
  "SPORAL": "resembling a spore [adj]\n",
  "SPORANGIA": "SPORANGIUM, a chamber inside of which spores are produced through meiosis [n]\n",
  "SPORANGIAL": "of or like a sporangium, a chamber inside of which spores are produced through meiosis [adj]\n",
  "SPORANGIOLA": "SPORANGIOLUM, a sporangium containing one or few spores, also SPORANGIOLE [n]\n",
  "SPORANGIOLE": "a sporangium containing one or few spores, also SPORANGIOLUM [n -S]\n",
  "SPORANGIOLES": "SPORANGIOLE, a sporangium containing one or few spores, also SPORANGIOLUM [n]\n",
  "SPORANGIOLUM": "a sporangium containing one or few spores, also SPORANGIOLE [n SPORANGIOLA]\n",
  "SPORANGIOPHORE": "a stalk to which sporangia are attached [n -S]\n",
  "SPORANGIOPHORES": "SPORANGIOPHORE, a stalk to which sporangia are attached [n]\n",
  "SPORANGIOSPORE": "a spore developed in a sporangium [n -S]\n",
  "SPORANGIOSPORES": "SPORANGIOSPORE, a spore developed in a sporangium [n]\n",
  "SPORANGIUM": "a chamber inside of which spores are produced through meiosis [n SPORANGIA]\n",
  "SPORE": "to produce an asexual reproductive body [v SPORED, SPORING, SPORES]\n",
  "SPORED": "SPORE, to produce an asexual reproductive body [v]\n",
  "SPORELIKE": "like a spore [adj]\n",
  "SPORES": "SPORE, to produce an asexual reproductive body [v]\n",
  "SPORICIDAL": "killing spores [adj]\n",
  "SPORICIDE": "a substance that kills spores [n -S]\n",
  "SPORICIDES": "SPORICIDE, a substance that kills spores [n]\n",
  "SPORIDESM": "a multicellular body or group of spores of which every cell is capable of generating [n -S]\n",
  "SPORIDESMS": "SPORIDESM, a multicellular body or group of spores of which every cell is capable of generating [n]\n",
  "SPORIDIA": "SPORIDIUM, a secondary spore, or a filament produced from a spore, in certain kinds of minute fungi [n]\n",
  "SPORIDIAL": "of or like a sporidium, a secondary spore, or a filament produced from a spore, in certain kinds of minute fungi [adj]\n",
  "SPORIDIUM": "a secondary spore, or a filament produced from a spore, in certain kinds of minute fungi [n SPORIDIA]\n",
  "SPORING": "SPORE, to produce an asexual reproductive body [v]\n",
  "SPORK": "a spoon-like shallow scoop with the addition of the tines of a fork [n -S]\n",
  "SPORKS": "SPORK, a spoon-like shallow scoop with the addition of the tines of a fork [n]\n",
  "SPOROCARP": "a closed body or conceptacle containing one or more masses of spores or sporangia [n -S]\n",
  "SPOROCARPS": "SPOROCARP, a closed body or conceptacle containing one or more masses of spores or sporangia [n]\n",
  "SPOROCYST": "a rounded, thick-walled structure produced, as by protozoans, in the process of sporulation [n -S]\n",
  "SPOROCYSTIC": "of or like a sporocyst [adj]\n",
  "SPOROCYSTS": "SPOROCYST, a rounded, thick-walled structure produced, as by protozoans, in the process of sporulation [n]\n",
  "SPOROCYTE": "a diploid cell that divides by meiosis to produce four haploid spores [n -S]\n",
  "SPOROCYTES": "SPOROCYTE, a diploid cell that divides by meiosis to produce four haploid spores [n]\n",
  "SPOROGENESES": "SPOROGENESIS, reproduction by means of spores [n]\n",
  "SPOROGENESIS": "reproduction by means of spores [n SPOROGENESES]\n",
  "SPOROGENIC": "producing spores [adj]\n",
  "SPOROGENIES": "SPOROGENY, the production of spores [n]\n",
  "SPOROGENOUS": "of tissue or cells in which the spores are formed [adj]\n",
  "SPOROGENY": "the production of spores [n SPOROGENIES]\n",
  "SPOROGONIA": "SPOROGONIUM, an organ that produces asexual spores in mosses [n]\n",
  "SPOROGONIAL": "of or like a sporogonium, an organ that produces asexual spores in mosses [adj]\n",
  "SPOROGONIC": "relating to a sporogonium, an organ that produces asexual spores in mosses [adj]\n",
  "SPOROGONIES": "SPOROGONY, the growth or development of an animal or a zooid from a nonsexual germ [n]\n",
  "SPOROGONIUM": "an organ that produces asexual spores in mosses [n SPOROGONIA]\n",
  "SPOROGONY": "the growth or development of an animal or a zooid from a nonsexual germ [n SPOROGONIES]\n",
  "SPOROID": "resembling a spore [adj]\n",
  "SPOROPHORE": "a spore-bearing stalk or structure, as in fungi [n -S]\n",
  "SPOROPHORES": "SPOROPHORE, a spore-bearing stalk or structure, as in fungi [n]\n",
  "SPOROPHORIC": "bearing spores, also SPOROPHOROUS [adj]\n",
  "SPOROPHOROUS": "bearing spores, also SPOROPHORIC [adj]\n",
  "SPOROPHYL": "a leaf that bears sporangia, also SPOROPHYLL [n -S]\n",
  "SPOROPHYLL": "a leaf that bears sporangia, also SPOROPHYL [n -S]\n",
  "SPOROPHYLLS": "SPOROPHYLL, a leaf that bears sporangia, also SPOROPHYL [n]\n",
  "SPOROPHYLS": "SPOROPHYL, a leaf that bears sporangia, also SPOROPHYLL [n]\n",
  "SPOROPHYTE": "a spore-producing phase in plants that reproduce by metagenesis (alternating asexual and sexual reproduction) [n -S]\n",
  "SPOROPHYTES": "SPOROPHYTE, a spore-producing phase in plants that reproduce by metagenesis (alternating asexual and sexual reproduction) [n]\n",
  "SPOROPHYTIC": "of or like a sporophyte [adj]\n",
  "SPOROPOLLENIN": "a polymer that comprises the exine (outer layer of the wall) of spores and pollen grains [n -S]\n",
  "SPOROPOLLENINS": "SPOROPOLLENIN, a polymer that comprises the exine (outer layer of the wall) of spores and pollen grains [n]\n",
  "SPOROTRICHOSES": "SPOROTRICHOSIS, an infection of the skin caused by the fungi of the genus Sporotrichum, resulting in granulomatous lesions [n]\n",
  "SPOROTRICHOSIS": "an infection of the skin caused by the fungi of the genus Sporotrichum, resulting in granulomatous lesions [n SPOROTRICHOSES]\n",
  "SPOROZOA": "SPOROZOON, a parasitic one-celled animal [n]\n",
  "SPOROZOAL": "related to sporozoa, also SPOROZOIC [adj]\n",
  "SPOROZOAN": "any parasitic protozoan of the class Sporozoa, including the causal organisms of malaria and pebrine, also SPOROZOON [n -S]\n",
  "SPOROZOANS": "SPOROZOAN, any parasitic protozoan of the class Sporozoa, including the causal organisms of malaria and pebrine, also SPOROZOON [n]\n",
  "SPOROZOIC": "related to sporozoa, also SPOROZOAL [adj]\n",
  "SPOROZOITE": "a minute, mobile, preadult spore developed by sporozoans [n -S]\n",
  "SPOROZOITES": "SPOROZOITE, a minute, mobile, preadult spore developed by sporozoans [n]\n",
  "SPOROZOON": "a parasitic one-celled animal [n SPOROZOA]\n",
  "SPORRAN": "(Gaelic) a large purse worn by Scottish Highlanders [n -S]\n",
  "SPORRANS": "SPORRAN, (Gaelic) a large purse worn by Scottish Highlanders [n]\n",
  "SPORT": "to frolic [v -ED, -ING, -S]\n",
  "SPORTABILITIES": "SPORTABILITY, the quality of being sportable [n]\n",
  "SPORTABILITY": "the quality of being sportable [n SPORTABILITIES]\n",
  "SPORTABLE": "sportive [adj]\n",
  "SPORTANCE": "playful, sportive, or frolicsome activity [n -S]\n",
  "SPORTANCES": "SPORTANCE, playful, sportive, or frolicsome activity [n]\n",
  "SPORTBIKE": "a kind of high-speed, high-performance motorcycle [n -S]\n",
  "SPORTBIKES": "SPORTBIKE, a kind of high-speed, high-performance motorcycle [n]\n",
  "SPORTCASTER": "a sports commentator, also SPORTSCASTER [n -S]\n",
  "SPORTCASTERS": "SPORTCASTER, a sports commentator, also SPORTSCASTER [n]\n",
  "SPORTCOAT": "(Canadian) a sports jacket [n -S]\n",
  "SPORTCOATS": "SPORTCOAT, (Canadian) a sports jacket [n]\n",
  "SPORTED": "SPORT, to frolic [v]\n",
  "SPORTER": "one who sports, a sportsman [n -S]\n",
  "SPORTERS": "SPORTER, one who sports, a sportsman [n]\n",
  "SPORTFISHERMAN": "a motorboat equipped for sportfishing [n SPORTFISHERMEN]\n",
  "SPORTFISHERMEN": "SPORTFISHERMAN, a motorboat equipped for sportfishing [n]\n",
  "SPORTFISHING": "fishing for sport [n -S]\n",
  "SPORTFISHINGS": "SPORTFISHING, fishing for sport [n]\n",
  "SPORTFUL": "full of sport; merry [adj SPORTFULLY]\n",
  "SPORTFULLY": "SPORTFUL, full of sport; merry [adv]\n",
  "SPORTFULNESS": "the state of being sportful [n -ES]\n",
  "SPORTFULNESSES": "SPORTFULNESS, the state of being sportful [n]\n",
  "SPORTIER": "SPORTY, inclined to sport [adj]\n",
  "SPORTIES": "SPORTY, a sporty young person [n]\n",
  "SPORTIEST": "SPORTY, inclined to sport [adj]\n",
  "SPORTIF": "(French) a person who is active or interested in physical competition [n -S]\n",
  "SPORTIFS": "SPORTIF, (French) a person who is active or interested in physical competition [n]\n",
  "SPORTILY": "SPORTY, inclined to sport [adv]\n",
  "SPORTINESS": "the state of being sporty [n -ES]\n",
  "SPORTINESSES": "SPORTINESS, the state of being sporty [n]\n",
  "SPORTING": "sportsmanlike; fair and generous [adj SPORTINGLY]\n",
  "SPORTINGLY": "SPORTING, sportsmanlike; fair and generous [adv]\n",
  "SPORTIVE": "playful [adj SPORTIVELY]\n",
  "SPORTIVELY": "SPORTIVE, playful [adv]\n",
  "SPORTIVENESS": "the state of being sportive [n -ES]\n",
  "SPORTIVENESSES": "SPORTIVENESS, the state of being sportive [n]\n",
  "SPORTLESS": "without sport or mirth; joyless [adj]\n",
  "SPORTS": "SPORT, to frolic [v]\n",
  "SPORTSCAST": "a broadcast of a sporting event [n -S]\n",
  "SPORTSCASTER": "a sports commentator, also SPORTCASTER [n -S]\n",
  "SPORTSCASTERS": "SPORTSCASTER, a sports commentator, also SPORTCASTER [n]\n",
  "SPORTSCASTS": "SPORTSCAST, a broadcast of a sporting event [n]\n",
  "SPORTSMAN": "a man who engages in sport [n SPORTSMEN]\n",
  "SPORTSMANLIER": "SPORTSMANLY, like a sportsman [adj]\n",
  "SPORTSMANLIEST": "SPORTSMANLY, like a sportsman [adj]\n",
  "SPORTSMANLIKE": "like a sportsman [adj]\n",
  "SPORTSMANLY": "like a sportsman [adj SPORTSMANLIER, SPORTSMANLIEST]\n",
  "SPORTSMANSHIP": "conduct (as fairness, respect for one's opponent, and graciousness in winning or losing) becoming to one participating in a sport [n -S]\n",
  "SPORTSMANSHIPS": "SPORTSMANSHIP, conduct (as fairness, respect for one's opponent, and graciousness in winning or losing) becoming to one participating in a sport [n]\n",
  "SPORTSMEN": "SPORTSMAN, a man who engages in sport [n]\n",
  "SPORTSPEOPLE": "people who take part in sport [n]\n",
  "SPORTSPERSON": "a sportsman or sportswoman [n -S]\n",
  "SPORTSPERSONS": "SPORTSPERSON, a sportsman or sportswoman [n]\n",
  "SPORTSWEAR": "sports clothes [n -S]\n",
  "SPORTSWEARS": "SPORTSWEAR, sports clothes [n]\n",
  "SPORTSWOMAN": "a woman who engages in sports [n SPORTSWOMEN]\n",
  "SPORTSWOMEN": "SPORTSWOMAN, a woman who engages in sports [n]\n",
  "SPORTSWRITER": "a person who writes about sports esp. for a newspaper [n -S]\n",
  "SPORTSWRITERS": "SPORTSWRITER, a person who writes about sports esp. for a newspaper [n]\n",
  "SPORTSWRITING": "journalism on sports subjects [n -S]\n",
  "SPORTSWRITINGS": "SPORTSWRITING, journalism on sports subjects [n]\n",
  "SPORTY": "inclined to sport [adj SPORTIER, SPORTIEST, SPORTILY] / a sporty young person [n SPORTIES]\n",
  "SPORULAR": "of or like a sporule, a small spore [adj]\n",
  "SPORULATE": "to form (into) spores [v SPORULATED, SPORULATING, SPORULATES]\n",
  "SPORULATED": "SPORULATE, to form (into) spores [v]\n",
  "SPORULATES": "SPORULATE, to form (into) spores [v]\n",
  "SPORULATING": "SPORULATE, to form (into) spores [v]\n",
  "SPORULATION": "the formation or production of spores [n -S]\n",
  "SPORULATIONS": "SPORULATION, the formation or production of spores [n]\n",
  "SPORULATIVE": "relating to sporulation [adj]\n",
  "SPORULE": "a small spore [n -S]\n",
  "SPORULES": "SPORULE, a small spore [n]\n",
  "SPOSH": "(US) slush [n -ES]\n",
  "SPOSHES": "SPOSH, (US) slush [n]\n",
  "SPOSHIER": "SPOSHY, (US) slushy [adj]\n",
  "SPOSHIEST": "SPOSHY, (US) slushy [adj]\n",
  "SPOSHY": "(US) slushy [adj SPOSHIER, SPOSHIEST]\n",
  "SPOT": "to mark with small round discolourations [v SPOTTED, SPOTTING, SPOTS]\n",
  "SPOTLESS": "perfectly clean [adj SPOTLESSLY]\n",
  "SPOTLESSLY": "SPOTLESS, perfectly clean [adv]\n",
  "SPOTLESSNESS": "the state of being spotless [n -ES]\n",
  "SPOTLESSNESSES": "SPOTLESSNESS, the state of being spotless [n]\n",
  "SPOTLIGHT": "to highlight [v SPOTLIT or SPOTLIGHTED, SPOTLIGHTING, SPOTLIGHTS]\n",
  "SPOTLIGHTED": "SPOTLIGHT, to highlight [v]\n",
  "SPOTLIGHTING": "SPOTLIGHT, to highlight [v]\n",
  "SPOTLIGHTS": "SPOTLIGHT, to highlight [v]\n",
  "SPOTLIT": "SPOTLIGHT, to highlight [v]\n",
  "SPOTS": "SPOT, to mark with small round discolourations [v]\n",
  "SPOTTABLE": "that can be spotted [adj]\n",
  "SPOTTED": "SPOT, to mark with small round discolourations [v]\n",
  "SPOTTEDNESS": "the state of being spotted [n -ES]\n",
  "SPOTTEDNESSES": "SPOTTEDNESS, the state of being spotted [n]\n",
  "SPOTTER": "one who spots e.g. for artillery [n -S]\n",
  "SPOTTERS": "SPOTTER, one who spots e.g. for artillery [n]\n",
  "SPOTTIE": "(New Zealand) a deer up to three months old [n -S]\n",
  "SPOTTIER": "SPOTTY, marked with spots [adj]\n",
  "SPOTTIES": "SPOTTIE, (New Zealand) a deer up to three months old [n]\n",
  "SPOTTIEST": "SPOTTY, marked with spots [adj]\n",
  "SPOTTILY": "SPOTTY, marked with spots [adv]\n",
  "SPOTTINESS": "the state of being spotty [n -ES]\n",
  "SPOTTINESSES": "SPOTTINESS, the state of being spotty [n]\n",
  "SPOTTING": "the act of spotting [n -S]\n",
  "SPOTTINGS": "SPOTTING, the act of spotting [n]\n",
  "SPOTTY": "marked with spots [adj SPOTTIER, SPOTTIEST, SPOTTILY]\n",
  "SPOUSAGE": "espousal [n -S]\n",
  "SPOUSAGES": "SPOUSAGE, espousal [n]\n",
  "SPOUSAL": "nuptial [adj SPOUSALLY] / the state of being married, also ESPOUSAL [n -S]\n",
  "SPOUSALLY": "SPOUSAL, nuptial [adv]\n",
  "SPOUSALS": "SPOUSAL, the state of being married, also ESPOUSAL [n]\n",
  "SPOUSE": "a wife or husband [n -S] / to betroth, marry, also ESPOUSE [v SPOUSED, SPOUSING, SPOUSES]\n",
  "SPOUSED": "SPOUSE, to betroth, marry, also ESPOUSE [v]\n",
  "SPOUSELESS": "destitute of a spouse [adj]\n",
  "SPOUSES": "SPOUSE, to betroth, marry, also ESPOUSE [v]\n",
  "SPOUSING": "SPOUSE, to betroth, marry, also ESPOUSE [v]\n",
  "SPOUT": "to eject in a rapid stream [v -ED, -ING, -S]\n",
  "SPOUTED": "SPOUT, to eject in a rapid stream [v]\n",
  "SPOUTER": "a spouting whale; a whaling ship [n -S]\n",
  "SPOUTERS": "SPOUTER, a spouting whale; a whaling ship [n]\n",
  "SPOUTIER": "SPOUTY, having a spout [adj]\n",
  "SPOUTIEST": "SPOUTY, having a spout [adj]\n",
  "SPOUTING": "a rainwater downpipe [n -S]\n",
  "SPOUTINGS": "SPOUTING, a rainwater downpipe [n]\n",
  "SPOUTLESS": "having no spout [adj]\n",
  "SPOUTS": "SPOUT, to eject in a rapid stream [v]\n",
  "SPOUTY": "having a spout [adj SPOUTIER, SPOUTIEST]\n",
  "SPOYLEFULL": "(Spenser) plundering, also SPOILFUL [adj]\n",
  "SPRACHGEFUHL": "(German) an intuitive sense of what is linguistically appropriate [n -S]\n",
  "SPRACHGEFUHLS": "SPRACHGEFUHL, (German) an intuitive sense of what is linguistically appropriate [n]\n",
  "SPRACK": "quick; lively; alert [adj]\n",
  "SPRACKLE": "(Scots) to clamber, also SPRAUCHLE [v SPRACKLED, SPRACKLING, SPRACKLES]\n",
  "SPRACKLED": "SPRACKLE, (Scots) to clamber, also SPRAUCHLE [v]\n",
  "SPRACKLES": "SPRACKLE, (Scots) to clamber, also SPRAUCHLE [v]\n",
  "SPRACKLING": "SPRACKLE, (Scots) to clamber, also SPRAUCHLE [v]\n",
  "SPRAD": "SPREAD, to stretch over an area [v]\n",
  "SPRADDLE": "to straddle [v SPRADDLED, SPRADDLING, SPRADDLES]\n",
  "SPRADDLED": "SPRADDLE, to straddle [v]\n",
  "SPRADDLES": "SPRADDLE, to straddle [v]\n",
  "SPRADDLING": "SPRADDLE, to straddle [v]\n",
  "SPRAG": "a wheel chock; a pointed stake driven into the ground to keep a vehicle from moving [n -S] / to stop with a sprag [v SPRAGGED, SPRAGGING, SPRAGS]\n",
  "SPRAGGED": "SPRAG, to stop with a sprag [v]\n",
  "SPRAGGING": "SPRAG, to stop with a sprag [v]\n",
  "SPRAGS": "SPRAG, to stop with a sprag [v]\n",
  "SPRAID": "SPRAY, to disperse in fine particles [v]\n",
  "SPRAIN": "to injure by twisting or wrenching [v -ED, -ING, -S]\n",
  "SPRAINED": "SPRAIN, to injure by twisting or wrenching [v]\n",
  "SPRAINING": "SPRAIN, to injure by twisting or wrenching [v]\n",
  "SPRAINS": "SPRAIN, to injure by twisting or wrenching [v]\n",
  "SPRAINT": "otter's dung [n -S]\n",
  "SPRAINTS": "SPRAINT, otter's dung [n]\n",
  "SPRANG": "a weaving technique to form an openwork mesh [n -S]\n",
  "SPRANGLE": "(US) to sprawl, to straggle [v SPRANGLED, SPRANGLING, SPRANGLES]\n",
  "SPRANGLED": "SPRANGLE, (US) to sprawl, to straggle [v]\n",
  "SPRANGLES": "SPRANGLE, (US) to sprawl, to straggle [v]\n",
  "SPRANGLING": "SPRANGLE, (US) to sprawl, to straggle [v]\n",
  "SPRANGS": "SPRANG, a weaving technique to form an openwork mesh [n]\n",
  "SPRAT": "a young herring [n -S]\n",
  "SPRATS": "SPRAT, a young herring [n]\n",
  "SPRATTLE": "(Scots) to scramble [v SPRATTLED, SPRATTLING, SPRATTLES]\n",
  "SPRATTLED": "SPRATTLE, (Scots) to scramble [v]\n",
  "SPRATTLES": "SPRATTLE, (Scots) to scramble [v]\n",
  "SPRATTLING": "SPRATTLE, (Scots) to scramble [v]\n",
  "SPRAUCHLE": "(Scots) to clamber, also SPRACKLE [v SPRAUCHLED, SPRAUCHLING, SPRAUCHLES]\n",
  "SPRAUCHLED": "SPRAUCHLE, (Scots) to clamber, also SPRACKLE [v]\n",
  "SPRAUCHLES": "SPRAUCHLE, (Scots) to clamber, also SPRACKLE [v]\n",
  "SPRAUCHLING": "SPRAUCHLE, (Scots) to clamber, also SPRACKLE [v]\n",
  "SPRAUNCIER": "SPRAUNCY, smart, dapper [adj]\n",
  "SPRAUNCIEST": "SPRAUNCY, smart, dapper [adj]\n",
  "SPRAUNCY": "smart, dapper [adj SPRAUNCIER, SPRAUNCIEST]\n",
  "SPRAWL": "to stretch out ungracefully [v -ED, -ING, -S]\n",
  "SPRAWLED": "SPRAWL, to stretch out ungracefully [v]\n",
  "SPRAWLER": "one who sprawls [n -S]\n",
  "SPRAWLERS": "SPRAWLER, one who sprawls [n]\n",
  "SPRAWLIER": "SPRAWLY, tending to sprawl [adj]\n",
  "SPRAWLIEST": "SPRAWLY, tending to sprawl [adj]\n",
  "SPRAWLING": "SPRAWL, to stretch out ungracefully [v]\n",
  "SPRAWLS": "SPRAWL, to stretch out ungracefully [v]\n",
  "SPRAWLY": "tending to sprawl [adj SPRAWLIER, SPRAWLIEST]\n",
  "SPRAY": "to disperse in fine particles [v SPRAYED, SPRAYING, SPRAYS] / to chap, roughen [v SPRAID, SPRAYING, SPRAYS]\n",
  "SPRAYED": "SPRAY, to disperse in fine particles [v]\n",
  "SPRAYER": "a device for spraying [n -S]\n",
  "SPRAYERS": "SPRAYER, a device for spraying [n]\n",
  "SPRAYEY": "full of spray [adj SPRAYIER, SPRAYIEST]\n",
  "SPRAYIER": "SPRAYEY, full of spray [adj]\n",
  "SPRAYIEST": "SPRAYEY, full of spray [adj]\n",
  "SPRAYING": "an act of spraying [n -S]\n",
  "SPRAYINGS": "SPRAYING, an act of spraying [n]\n",
  "SPRAYS": "SPRAY, to disperse in fine particles [v]\n",
  "SPREAD": "to stretch over an area [v SPREAD or (obsolete) SPRAD, SPRED, SPREDD or SPREDDE, SPREADING, SPREADS]\n",
  "SPREADABILITIES": "SPREADABILITY, the state of being spreadable [n]\n",
  "SPREADABILITY": "the state of being spreadable [n SPREADABILITIES]\n",
  "SPREADABLE": "that can be spread [adj]\n",
  "SPREADEAGLED": "spread out flat [adj]\n",
  "SPREADER": "one who spreads [n -S]\n",
  "SPREADERS": "SPREADER, one who spreads [n]\n",
  "SPREADING": "expansive [adj SPREADINGLY] / the act of spreading [n -S]\n",
  "SPREADINGLY": "SPREADING, expansive [adv]\n",
  "SPREADINGS": "SPREADING, the act of spreading [n]\n",
  "SPREADS": "SPREAD, to stretch over an area [v]\n",
  "SPREADSHEET": "a program with which data, formatted in rows and columns of cells, can be viewed on a screen and manipulated to make projections, calculations etc. [n -S]\n",
  "SPREADSHEETS": "SPREADSHEET, a program with which data, formatted in rows and columns of cells, can be viewed on a screen and manipulated to make projections, calculations etc. [n]\n",
  "SPREAGH": "(Gaelic) a cattle raid, a foray [n -S]\n",
  "SPREAGHERIES": "SPREAGHERY, cattle-stealing; plunder esp. of petty possessions, also SPRECHERY [n]\n",
  "SPREAGHERY": "cattle-stealing; plunder esp. of petty possessions, also SPRECHERY [n SPREAGHERIES]\n",
  "SPREAGHS": "SPREAGH, (Gaelic) a cattle raid, a foray [n]\n",
  "SPREATHE": "(SW dialect) to chap, roughen, also SPRAY, SPREAZE, SPREETHE, SPREEZE [v SPREATHED, SPREATHING, SPREATHES]\n",
  "SPREATHED": "SPREATHE, (SW dialect) to chap, roughen, also SPRAY, SPREAZE, SPREETHE, SPREEZE [v]\n",
  "SPREATHES": "SPREATHE, (SW dialect) to chap, roughen, also SPRAY, SPREAZE, SPREETHE, SPREEZE [v]\n",
  "SPREATHING": "SPREATHE, (SW dialect) to chap, roughen, also SPRAY, SPREAZE, SPREETHE, SPREEZE [v]\n",
  "SPREAZE": "(SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREETHE, SPREEZE [v SPREAZED, SPREAZING, SPREAZES]\n",
  "SPREAZED": "SPREAZE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREETHE, SPREEZE [v]\n",
  "SPREAZES": "SPREAZE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREETHE, SPREEZE [v]\n",
  "SPREAZING": "SPREAZE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREETHE, SPREEZE [v]\n",
  "SPRECHERIES": "SPRECHERY, cattle-stealing; plunder esp. of petty possessions, also SPREAGHERY [n]\n",
  "SPRECHERY": "cattle-stealing; plunder esp. of petty possessions, also SPREAGHERY [n SPRECHERIES]\n",
  "SPRECHGESANG": "(German) a style of vocal delivery introduced by Schoenberg [n -S]\n",
  "SPRECHGESANGS": "SPRECHGESANG, (German) a style of vocal delivery introduced by Schoenberg [n]\n",
  "SPRECHSTIMME": "(German) music using the sprechgesang form of vocalization [n -S]\n",
  "SPRECHSTIMMES": "SPRECHSTIMME, (German) music using the sprechgesang form of vocalization [n]\n",
  "SPRECKLED": "(dialect) speckled [adj]\n",
  "SPRED": "(obsolete) to spread, also SPREDD, SPREDDE [v SPRED, SPREDDING, SPREDS]\n",
  "SPREDD": "(obsolete) to spread, also SPRED, SPREDDE [v SPRED, SPREDDING, SPREDDS]\n",
  "SPREDDE": "(obsolete) to spread, also SPRED, SPREDD [v SPREDDEN, SPREDDING, SPREDDES]\n",
  "SPREDDEN": "SPRED, (obsolete) to spread, also SPREDD, SPREDDE [v]\n",
  "SPREDDES": "SPREDDE, (obsolete) to spread, also SPRED, SPREDD [v]\n",
  "SPREDDING": "SPREDD, (obsolete) to spread, also SPRED, SPREDDE [v]\n",
  "SPREDDS": "SPREDD, (obsolete) to spread, also SPRED, SPREDDE [v]\n",
  "SPREDS": "SPRED, (obsolete) to spread, also SPREDD, SPREDDE [v]\n",
  "SPREE": "to carouse [v SPREED, SPREEING, SPREES]\n",
  "SPREED": "SPREE, to carouse [v]\n",
  "SPREEING": "SPREE, to carouse [v]\n",
  "SPREES": "SPREE, to carouse [v]\n",
  "SPREETHE": "(SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREEZE [v SPREETHED, SPREETHING, SPREETHES]\n",
  "SPREETHED": "SPREETHE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREEZE [v]\n",
  "SPREETHES": "SPREETHE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREEZE [v]\n",
  "SPREETHING": "SPREETHE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREEZE [v]\n",
  "SPREEZE": "(SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREETHE [v SPREEZED, SPREEZING, SPREEZES]\n",
  "SPREEZED": "SPREEZE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREETHE [v]\n",
  "SPREEZES": "SPREEZE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREETHE [v]\n",
  "SPREEZING": "SPREEZE, (SW dialect) to chap, roughen, also SPRAY, SPREATHE, SPREAZE, SPREETHE [v]\n",
  "SPREKELIA": "a bulbous plant grown for its striking crimson or white pendent flowers [n -S]\n",
  "SPREKELIAS": "SPREKELIA, a bulbous plant grown for its striking crimson or white pendent flowers [n]\n",
  "SPRENT": "to spring or leap forward in an agile way [v -ED, -ING, -S]\n",
  "SPRENTED": "SPRENT, to spring or leap forward in an agile way [v]\n",
  "SPRENTING": "SPRENT, to spring or leap forward in an agile way [v]\n",
  "SPRENTS": "SPRENT, to spring or leap forward in an agile way [v]\n",
  "SPREW": "a thin, inferior asparagus [n -S]\n",
  "SPREWS": "SPREW, a thin, inferior asparagus [n]\n",
  "SPRIER": "SPRY, smart, dapper [adj]\n",
  "SPRIEST": "SPRY, smart, dapper [adj]\n",
  "SPRIG": "a shoot, twig, or spray of a plant, shrub, or tree [n -S] / to embroider with representations of twigs [v SPRIGGED, SPRIGGING, SPRIGS]\n",
  "SPRIGGED": "SPRIG, to embroider with representations of twigs [v]\n",
  "SPRIGGER": "one that decorates with sprigs [n -S]\n",
  "SPRIGGERS": "SPRIGGER, one that decorates with sprigs [n]\n",
  "SPRIGGIER": "SPRIGGY, having small branches [adj]\n",
  "SPRIGGIEST": "SPRIGGY, having small branches [adj]\n",
  "SPRIGGING": "SPRIG, to embroider with representations of twigs [v]\n",
  "SPRIGGY": "having small branches [adj SPRIGGIER, SPRIGGIEST]\n",
  "SPRIGHT": "(Shakespeare) to haunt [v -ED, -ING, -S]\n",
  "SPRIGHTED": "SPRIGHT, (Shakespeare) to haunt [v]\n",
  "SPRIGHTFUL": "(obsolete) full of spirit or of life [adj SPRIGHTFULLY]\n",
  "SPRIGHTFULLY": "SPRIGHTFUL, (obsolete) full of spirit or of life [adv]\n",
  "SPRIGHTFULNESS": "(obsolete) the state of being sprightful [n]\n",
  "SPRIGHTING": "SPRIGHT, (Shakespeare) to haunt [v]\n",
  "SPRIGHTLESS": "(obsolete) spiritless [adj]\n",
  "SPRIGHTLIER": "SPRIGHTLY, lively, also SPRITELY [adj]\n",
  "SPRIGHTLIEST": "SPRIGHTLY, lively, also SPRITELY [adj]\n",
  "SPRIGHTLINESS": "the state of being sprightly [n -ES]\n",
  "SPRIGHTLINESSES": "SPRIGHTLINESS, the state of being sprightly [n]\n",
  "SPRIGHTLY": "lively, also SPRITELY [adj SPRIGHTLIER, SPRIGHTLIEST]\n",
  "SPRIGHTS": "SPRIGHT, (Shakespeare) to haunt [v]\n",
  "SPRIGS": "SPRIG, to embroider with representations of twigs [v]\n",
  "SPRIGTAIL": "a species of duck [n -S]\n",
  "SPRIGTAILS": "SPRIGTAIL, a species of duck [n]\n",
  "SPRING": "to leap upward [v SPRANG or SPRONG or SPRINGED, SPRUNG, SPRINGING, SPRINGS]\n",
  "SPRINGAL": "(archaic) an active young man; a youth, also SPRINGALD [n -S]\n",
  "SPRINGALD": "(archaic) an active young man, also SPRINGAL [n -S]\n",
  "SPRINGALDS": "SPRINGALD, (archaic) an active young man, also SPRINGAL [n]\n",
  "SPRINGALS": "SPRINGAL, (archaic) an active young man; a youth, also SPRINGALD [n]\n",
  "SPRINGBOARD": "a flexible board usually secured at one end and used for gymnastic stunts or diving [n -S]\n",
  "SPRINGBOARDS": "SPRINGBOARD, a flexible board usually secured at one end and used for gymnastic stunts or diving [n]\n",
  "SPRINGBOK": "(South African) a kind of antelope, that moves in leaps when alarmed, also SPRINGBUCK [n -S]\n",
  "SPRINGBOKS": "SPRINGBOK, (South African) a kind of antelope, that moves in leaps when alarmed, also SPRINGBUCK [n]\n",
  "SPRINGBUCK": "a South African antelope, that moves in leaps when alarmed, also SPRINGBOK [n -S]\n",
  "SPRINGBUCKS": "SPRINGBUCK, a South African antelope, that moves in leaps when alarmed, also SPRINGBOK [n]\n",
  "SPRINGE": "a snare with noose and spring, also SPRINGLE [n -S] / to snare in a springe [v SPRINGED, SPRINGEING, SPRINGES]\n",
  "SPRINGED": "SPRINGE, to snare in a springe [v]\n",
  "SPRINGEING": "SPRINGE, to snare in a springe [v]\n",
  "SPRINGER": "a kind of spaniel [n -S]\n",
  "SPRINGERS": "SPRINGER, a kind of spaniel [n]\n",
  "SPRINGES": "SPRINGE, to snare in a springe [v]\n",
  "SPRINGHAAS": "(South African) a nocturnal rodent [n SPRINGHAAS or SPRINGHASE]\n",
  "SPRINGHALT": "a jerking lameness in which a horse suddenly twitches up its leg or legs, also STRINGHALT [n -S]\n",
  "SPRINGHALTS": "SPRINGHALT, a jerking lameness in which a horse suddenly twitches up its leg or legs, also STRINGHALT [n]\n",
  "SPRINGHASE": "SPRINGHAAS, (South African) a nocturnal rodent [n]\n",
  "SPRINGHEAD": "a fountain or source [n -S]\n",
  "SPRINGHEADS": "SPRINGHEAD, a fountain or source [n]\n",
  "SPRINGHOUSE": "a storehouse built over a spring for keeping dairy products and meat cool and fresh [n -S]\n",
  "SPRINGHOUSES": "SPRINGHOUSE, a storehouse built over a spring for keeping dairy products and meat cool and fresh [n]\n",
  "SPRINGIER": "SPRINGY, resilient [adj]\n",
  "SPRINGIEST": "SPRINGY, resilient [adj]\n",
  "SPRINGILY": "SPRINGY, resilient [adv]\n",
  "SPRINGINESS": "the state of being springy [n -ES]\n",
  "SPRINGINESSES": "SPRINGINESS, the state of being springy [n]\n",
  "SPRINGING": "the act of springing [n -S]\n",
  "SPRINGINGS": "SPRINGING, the act of springing [n]\n",
  "SPRINGKEEPER": "a salamander [n -S]\n",
  "SPRINGKEEPERS": "SPRINGKEEPER, a salamander [n]\n",
  "SPRINGLE": "a snare with a noose and spring, also SPRINGE [n -S]\n",
  "SPRINGLES": "SPRINGLE, a snare with a noose and spring, also SPRINGE [n]\n",
  "SPRINGLESS": "without a spring [adj]\n",
  "SPRINGLET": "a little spring [n -S]\n",
  "SPRINGLETS": "SPRINGLET, a little spring [n]\n",
  "SPRINGLIKE": "like spring [adj]\n",
  "SPRINGS": "SPRING, to leap upward [v]\n",
  "SPRINGTAIL": "any one of numerous species of small apterous insects belonging to the order Thysanura [n -S]\n",
  "SPRINGTAILS": "SPRINGTAIL, any one of numerous species of small apterous insects belonging to the order Thysanura [n]\n",
  "SPRINGTIDE": "springtime [n -S]\n",
  "SPRINGTIDES": "SPRINGTIDE, springtime [n]\n",
  "SPRINGTIME": "the time during which it is spring [n -S]\n",
  "SPRINGTIMES": "SPRINGTIME, the time during which it is spring [n]\n",
  "SPRINGWATER": "water from a spring [n -S]\n",
  "SPRINGWATERS": "SPRINGWATER, water from a spring [n]\n",
  "SPRINGWOOD": "secondary wood formed in spring and early summer [n -S]\n",
  "SPRINGWOODS": "SPRINGWOOD, secondary wood formed in spring and early summer [n]\n",
  "SPRINGWORT": "a root thought to be magical, perhaps mandrake [n -S]\n",
  "SPRINGWORTS": "SPRINGWORT, a root thought to be magical, perhaps mandrake [n]\n",
  "SPRINGY": "resilient [adj SPRINGIER, SPRINGIEST, SPRINGILY]\n",
  "SPRINKLE": "to scatter drops on [v SPRINKLED, SPRINKLING, SPRINKLES]\n",
  "SPRINKLED": "SPRINKLE, to scatter drops on [v]\n",
  "SPRINKLER": "a device for sprinkling e.g. a lawn [n -S] / to water with a sprinkler [v -ED, -ING, -S]\n",
  "SPRINKLERED": "SPRINKLER, to water with a sprinkler [v]\n",
  "SPRINKLERING": "SPRINKLER, to water with a sprinkler [v]\n",
  "SPRINKLERS": "SPRINKLER, a device for sprinkling e.g. a lawn [n]\n",
  "SPRINKLES": "SPRINKLE, to scatter drops on [v]\n",
  "SPRINKLING": "the act of sprinkling [n -S]\n",
  "SPRINKLINGS": "SPRINKLING, the act of sprinkling [n]\n",
  "SPRINT": "to run at top speed [v -ED, -ING, -S]\n",
  "SPRINTED": "SPRINT, to run at top speed [v]\n",
  "SPRINTER": "one who sprints [n -S]\n",
  "SPRINTERS": "SPRINTER, one who sprints [n]\n",
  "SPRINTING": "the act of running at top speed [n -S]\n",
  "SPRINTINGS": "SPRINTING, the act of running at top speed [n]\n",
  "SPRINTS": "SPRINT, to run at top speed [v]\n",
  "SPRIT": "a ship's spar [n -S]\n",
  "SPRITE": "an elf or fairy [n -S]\n",
  "SPRITEFUL": "impish [adj SPRITEFULLY]\n",
  "SPRITEFULLY": "SPRITEFUL, impish [adv]\n",
  "SPRITEFULNESS": "the state of being spriteful [n -ES]\n",
  "SPRITEFULNESSES": "SPRITEFULNESS, the state of being spriteful [n]\n",
  "SPRITELIER": "SPRITELY, lively, also SPRIGHTLY [adj]\n",
  "SPRITELIEST": "SPRITELY, lively, also SPRIGHTLY [adj]\n",
  "SPRITELY": "lively, also SPRIGHTLY [adj SPRITELIER, SPRITELIEST]\n",
  "SPRITES": "SPRITE, an elf or fairy [n]\n",
  "SPRITS": "SPRIT, a ship's spar [n]\n",
  "SPRITSAIL": "a sail extended by a sprit [n -S]\n",
  "SPRITSAILS": "SPRITSAIL, a sail extended by a sprit [n]\n",
  "SPRITZ": "(German) to spray (liquid) [v -ED, -ING, -ES]\n",
  "SPRITZED": "SPRITZ, (German) to spray (liquid) [v]\n",
  "SPRITZER": "(German) a drink of (white) wine and soda water [n -S]\n",
  "SPRITZERS": "SPRITZER, (German) a drink of (white) wine and soda water [n]\n",
  "SPRITZES": "SPRITZ, (German) to spray (liquid) [v]\n",
  "SPRITZIER": "SPRITZY, emitting a spray [adj]\n",
  "SPRITZIEST": "SPRITZY, emitting a spray [adj]\n",
  "SPRITZIG": "(German) a usually sparkling white wine [n -S]\n",
  "SPRITZIGS": "SPRITZIG, (German) a usually sparkling white wine [n]\n",
  "SPRITZING": "SPRITZ, (German) to spray (liquid) [v]\n",
  "SPRITZY": "emitting a spray [adj SPRITZIER, SPRITZIEST]\n",
  "SPROCKET": "a toothlike projection that turns the links of a chain [n -S]\n",
  "SPROCKETS": "SPROCKET, a toothlike projection that turns the links of a chain [n]\n",
  "SPROD": "a salmon in its second year [n -S]\n",
  "SPRODS": "SPROD, a salmon in its second year [n]\n",
  "SPROG": "a young child [n -S]\n",
  "SPROGLET": "a small child [n -S]\n",
  "SPROGLETS": "SPROGLET, a small child [n]\n",
  "SPROGS": "SPROG, a young child [n]\n",
  "SPRONG": "SPRING, to leap upward [v]\n",
  "SPROUT": "to begin to grow [v -ED, -ING, -S]\n",
  "SPROUTED": "SPROUT, to begin to grow [v]\n",
  "SPROUTING": "the act of sprouting [n -S]\n",
  "SPROUTINGS": "SPROUTING, the act of sprouting [n]\n",
  "SPROUTS": "SPROUT, to begin to grow [v]\n",
  "SPRUCE": "smart, dapper [adj SPRUCER, SPRUCEST, SPRUCELY] / to make smart [v SPRUCED, SPRUCING, SPRUCES]\n",
  "SPRUCED": "SPRUCE, to make smart [v]\n",
  "SPRUCELY": "SPRUCE, smart, dapper [adv]\n",
  "SPRUCENESS": "the state of being spruce [n -ES]\n",
  "SPRUCENESSES": "SPRUCENESS, the state of being spruce [n]\n",
  "SPRUCER": "SPRUCE, smart, dapper [adj]\n",
  "SPRUCES": "SPRUCE, to make smart [v]\n",
  "SPRUCEST": "SPRUCE, smart, dapper [adj]\n",
  "SPRUCIER": "SPRUCY, neat and trim [adj]\n",
  "SPRUCIEST": "SPRUCY, neat and trim [adj]\n",
  "SPRUCING": "SPRUCE, to make smart [v]\n",
  "SPRUCY": "neat and trim [adj SPRUCIER, SPRUCIEST]\n",
  "SPRUE": "infantile thrush [n -S]\n",
  "SPRUES": "SPRUE, infantile thrush [n]\n",
  "SPRUG": "(Scots) a sparrow, also SPEUG, SPUG, SPUGGY [n -S]\n",
  "SPRUGS": "SPRUG, (Scots) a sparrow, also SPEUG, SPUG, SPUGGY [n]\n",
  "SPRUIK": "(Australian slang) of a showman, etc., to harangue people in public [v -ED, -ING, -S]\n",
  "SPRUIKED": "SPRUIK, (Australian slang) of a showman, etc., to harangue people in public [v]\n",
  "SPRUIKER": "(Australian slang) one who spruiks, harangues people in public [n -S]\n",
  "SPRUIKERS": "SPRUIKER, (Australian slang) one who spruiks, harangues people in public [n]\n",
  "SPRUIKING": "SPRUIK, (Australian slang) of a showman, etc., to harangue people in public [v]\n",
  "SPRUIKS": "SPRUIK, (Australian slang) of a showman, etc., to harangue people in public [v]\n",
  "SPRUIT": "(South African) a small stream flowing only in the wet season [n -S]\n",
  "SPRUITS": "SPRUIT, (South African) a small stream flowing only in the wet season [n]\n",
  "SPRUNG": "SPRING, to leap upward [v]\n",
  "SPRUSH": "(Scots) to spruce, make neat [v -ED, -ING, -ES]\n",
  "SPRUSHED": "SPRUSH, (Scots) to spruce, make neat [v]\n",
  "SPRUSHES": "SPRUSH, (Scots) to spruce, make neat [v]\n",
  "SPRUSHING": "SPRUSH, (Scots) to spruce, make neat [v]\n",
  "SPRY": "smart, dapper [adj SPRIER or SPRYER, SPRIEST or SPRYEST, SPRYLY]\n",
  "SPRYER": "SPRY, smart, dapper [adj]\n",
  "SPRYEST": "SPRY, smart, dapper [adj]\n",
  "SPRYLY": "SPRY, smart, dapper [adv]\n",
  "SPRYNESS": "the state of being spry [n -ES]\n",
  "SPRYNESSES": "SPRYNESS, the state of being spry [n]\n",
  "SPUD": "to dig up with a spadelike tool [v SPUDDED, SPUDDING, SPUDS]\n",
  "SPUDDED": "SPUD, to dig up with a spadelike tool [v]\n",
  "SPUDDER": "a tool for removing bark from trees [n -S]\n",
  "SPUDDERS": "SPUDDER, a tool for removing bark from trees [n]\n",
  "SPUDDIER": "SPUDDY, podgy [adj]\n",
  "SPUDDIEST": "SPUDDY, podgy [adj]\n",
  "SPUDDING": "the process of starting to excavate or drill (e.g. an oil-well) [n -S]\n",
  "SPUDDINGS": "SPUDDING, the process of starting to excavate or drill (e.g. an oil-well) [n]\n",
  "SPUDDLE": "(dialect) a feeble movement [n -S]\n",
  "SPUDDLES": "SPUDDLE, (dialect) a feeble movement [n]\n",
  "SPUDDY": "podgy [adj SPUDDIER, SPUDDIEST]\n",
  "SPUDGEL": "a bucket attached to a long pole [n -S]\n",
  "SPUDGELS": "SPUDGEL, a bucket attached to a long pole [n]\n",
  "SPUDS": "SPUD, to dig up with a spadelike tool [v]\n",
  "SPUE": "(archaic) to spew [v SPUED, SPUING or SPUEING, SPUES]\n",
  "SPUED": "SPUE, (archaic) to spew [v]\n",
  "SPUEING": "SPUE, (archaic) to spew [v]\n",
  "SPUER": "one who spues, also SPEWER [n -S]\n",
  "SPUERS": "SPUER, one who spues, also SPEWER [n]\n",
  "SPUES": "SPUE, (archaic) to spew [v]\n",
  "SPUG": "(colloquial) a sparrow, also SPEUG, SPRUG, SPUGGY [n -S]\n",
  "SPUGGIES": "SPUGGY, (Scots) a house sparrow, also SPUG, SPEUG [n]\n",
  "SPUGGY": "(Scots) a house sparrow, also SPUG, SPEUG [n SPUGGIES]\n",
  "SPUGS": "SPUG, (colloquial) a sparrow, also SPEUG, SPRUG, SPUGGY [n]\n",
  "SPUILZIE": "(Scots) to plunder, also SPULYE, SPULYIE, SPULZIE [v SPUILZIED, SPUILZIEING, SPUILZIES]\n",
  "SPUILZIED": "SPUILZIE, (Scots) to plunder, also SPULYE, SPULYIE, SPULZIE [v]\n",
  "SPUILZIEING": "SPUILZIE, (Scots) to plunder, also SPULYE, SPULYIE, SPULZIE [v]\n",
  "SPUILZIES": "SPUILZIE, (Scots) to plunder, also SPULYE, SPULYIE, SPULZIE [v]\n",
  "SPUING": "SPUE, (archaic) to spew [v]\n",
  "SPULE": "(Scots) the shoulder, also SPALD, SPALLE, SPAUL, SPAULD, SPEAL [n -S]\n",
  "SPULEBLADE": "(Scots) the shoulder-blade [n -S]\n",
  "SPULEBLADES": "SPULEBLADE, (Scots) the shoulder-blade [n]\n",
  "SPULES": "SPULE, (Scots) the shoulder, also SPALD, SPALLE, SPAUL, SPAULD, SPEAL [n]\n",
  "SPULYE": "(Scots) to plunder, also SPUILZIE, SPULYIE, SPULZIE [v SPULYED, SPULYEING, SPULYES]\n",
  "SPULYED": "SPULYE, (Scots) to plunder, also SPUILZIE, SPULYIE, SPULZIE [v]\n",
  "SPULYEING": "SPULYE, (Scots) to plunder, also SPUILZIE, SPULYIE, SPULZIE [v]\n",
  "SPULYES": "SPULYE, (Scots) to plunder, also SPUILZIE, SPULYIE, SPULZIE [v]\n",
  "SPULYIE": "(Scots) to plunder, also SPUILZIE, SPULYE, SPULZIE [v SPULYIED, SPULYIEING, SPULYIES]\n",
  "SPULYIED": "SPULYIE, (Scots) to plunder, also SPUILZIE, SPULYE, SPULZIE [v]\n",
  "SPULYIEING": "SPULYIE, (Scots) to plunder, also SPUILZIE, SPULYE, SPULZIE [v]\n",
  "SPULYIES": "SPULYIE, (Scots) to plunder, also SPUILZIE, SPULYE, SPULZIE [v]\n",
  "SPULZIE": "(Scots) to plunder, also SPUILZIE, SPULYE, SPULYIE [v SPULZIED, SPULZIEING, SPULZIES]\n",
  "SPULZIED": "SPULZIE, (Scots) to plunder, also SPUILZIE, SPULYE, SPULYIE [v]\n",
  "SPULZIEING": "SPULZIE, (Scots) to plunder, also SPUILZIE, SPULYE, SPULYIE [v]\n",
  "SPULZIES": "SPULZIE, (Scots) to plunder, also SPUILZIE, SPULYE, SPULYIE [v]\n",
  "SPUMANTE": "(Italian) a sparkling white wine [n -S]\n",
  "SPUMANTES": "SPUMANTE, (Italian) a sparkling white wine [n]\n",
  "SPUME": "to foam [v SPUMED, SPUMING, SPUMES]\n",
  "SPUMED": "SPUME, to foam [v]\n",
  "SPUMES": "SPUME, to foam [v]\n",
  "SPUMESCENCE": "foaminess, frothiness [n -S]\n",
  "SPUMESCENCES": "SPUMESCENCE, foaminess, frothiness [n]\n",
  "SPUMESCENT": "frothy, foamy [adj]\n",
  "SPUMIER": "SPUMY, like spume [adj]\n",
  "SPUMIEST": "SPUMY, like spume [adj]\n",
  "SPUMING": "SPUME, to foam [v]\n",
  "SPUMONE": "(Italian) a rich Italian dessert consisting of layered ice-cream with candied fruits, nuts, and sometimes brandy, also SPUMONI [n SPUMONES]\n",
  "SPUMONES": "SPUMONE, (Italian) a rich Italian dessert consisting of layered ice-cream with candied fruits, nuts, and sometimes brandy, also SPUMONI [n]\n",
  "SPUMONI": "(Italian) a rich Italian dessert consisting of layered ice-cream with candied fruits, nuts, and sometimes brandy, also SPUMONE [n -S]\n",
  "SPUMONIS": "SPUMONI, (Italian) a rich Italian dessert consisting of layered ice-cream with candied fruits, nuts, and sometimes brandy, also SPUMONE [n]\n",
  "SPUMOUS": "spumy, full of spume [adj]\n",
  "SPUMY": "like spume [adj SPUMIER, SPUMIEST]\n",
  "SPUN": "SPIN, to draw out and twist into threads [v]\n",
  "SPUNBONDED": "of or relating to a nonbonded polymeric material that resembles cloth or fabric [adj]\n",
  "SPUNGE": "(obsolete) a sponge [n -S]\n",
  "SPUNGES": "SPUNGE, (obsolete) a sponge [n]\n",
  "SPUNK": "to begin to burn [v -ED, -ING, -S]\n",
  "SPUNKED": "SPUNK, to begin to burn [v]\n",
  "SPUNKIE": "(Scots) an ignis fatuus [n -S]\n",
  "SPUNKIER": "SPUNKY, courageous, spirited [adj]\n",
  "SPUNKIES": "SPUNKIE, (Scots) an ignis fatuus [n]\n",
  "SPUNKIEST": "SPUNKY, courageous, spirited [adj]\n",
  "SPUNKILY": "SPUNKY, courageous, spirited [adv]\n",
  "SPUNKINESS": "pluck, spirit [n -ES]\n",
  "SPUNKINESSES": "SPUNKINESS, pluck, spirit [n]\n",
  "SPUNKING": "SPUNK, to begin to burn [v]\n",
  "SPUNKS": "SPUNK, to begin to burn [v]\n",
  "SPUNKY": "courageous, spirited [adj SPUNKIER, SPUNKIEST, SPUNKILY]\n",
  "SPUNYARN": "rope of yarns twisted into a cord [n -S]\n",
  "SPUNYARNS": "SPUNYARN, rope of yarns twisted into a cord [n]\n",
  "SPUR": "to urge on with a horseman's goad [v SPURRED, SPURRING, SPURS]\n",
  "SPURDOG": "the dogfish [n -S]\n",
  "SPURDOGS": "SPURDOG, the dogfish [n]\n",
  "SPURGALL": "to injure with a spur [v -ED, -ING, -S]\n",
  "SPURGALLED": "SPURGALL, to injure with a spur [v]\n",
  "SPURGALLING": "SPURGALL, to injure with a spur [v]\n",
  "SPURGALLS": "SPURGALL, to injure with a spur [v]\n",
  "SPURGE": "a plant of genus Euphorbia, usually having a milky juice which yields powerful emetic and cathartic products [n -S]\n",
  "SPURGES": "SPURGE, a plant of genus Euphorbia, usually having a milky juice which yields powerful emetic and cathartic products [n]\n",
  "SPURIAE": "(Latin) in birds, feathers of the bastard wing [n]\n",
  "SPURIOSITIES": "SPURIOSITY, the state of being spurious [n]\n",
  "SPURIOSITY": "the state of being spurious [n SPURIOSITIES]\n",
  "SPURIOUS": "not genuine [adj SPURIOUSLY]\n",
  "SPURIOUSLY": "SPURIOUS, not genuine [adv]\n",
  "SPURIOUSNESS": "the state of being spurious [n -ES]\n",
  "SPURIOUSNESSES": "SPURIOUSNESS, the state of being spurious [n]\n",
  "SPURLESS": "without spurs [adj]\n",
  "SPURLIKE": "like a spur [adj]\n",
  "SPURLING": "a tern [n -S]\n",
  "SPURLINGS": "SPURLING, a tern [n]\n",
  "SPURN": "to reject with contempt [v -ED, -ING, -S]\n",
  "SPURNE": "(Spenser) to spur [v SPURNED, SPURNING, SPURNES]\n",
  "SPURNED": "SPURN, to reject with contempt [v]\n",
  "SPURNER": "one who spurns [n -S]\n",
  "SPURNERS": "SPURNER, one who spurns [n]\n",
  "SPURNES": "SPURNE, (Spenser) to spur [v]\n",
  "SPURNING": "the act of spurning [n -S]\n",
  "SPURNINGS": "SPURNING, the act of spurning [n]\n",
  "SPURNS": "SPURN, to reject with contempt [v]\n",
  "SPURRED": "SPUR, to urge on with a horseman's goad [v]\n",
  "SPURRER": "one who spurs [n -S]\n",
  "SPURRERS": "SPURRER, one who spurs [n]\n",
  "SPURREY": "an annual herb with whorled leaves, sometimes grown for fodder, also SPURRY [n -S]\n",
  "SPURREYS": "SPURREY, an annual herb with whorled leaves, sometimes grown for fodder, also SPURRY [n]\n",
  "SPURRIER": "one whose occupation is to make spurs [n -S]\n",
  "SPURRIERS": "SPURRIER, one whose occupation is to make spurs [n]\n",
  "SPURRIES": "SPURRY, an annual herb with whorled filiform leaves, sometimes grown for fodder, also SPURREY [n]\n",
  "SPURRIEST": "SPURRY, spur-like [adj]\n",
  "SPURRING": "the act of spurring [n -S]\n",
  "SPURRINGS": "SPURRING, the act of spurring [n]\n",
  "SPURRY": "spur-like [adj SPURRIER, SPURRIEST] / an annual herb with whorled filiform leaves, sometimes grown for fodder, also SPURREY [n SPURRIES]\n",
  "SPURS": "SPUR, to urge on with a horseman's goad [v]\n",
  "SPURT": "to gush forth, also SPIRT [v -ED, -ING, -S]\n",
  "SPURTED": "SPURT, to gush forth, also SPIRT [v]\n",
  "SPURTER": "one who spurts [n -S]\n",
  "SPURTERS": "SPURTER, one who spurts [n]\n",
  "SPURTING": "SPURT, to gush forth, also SPIRT [v]\n",
  "SPURTLE": "a wooden stick for stirring porridge, also SPIRTLE [n -S]\n",
  "SPURTLES": "SPURTLE, a wooden stick for stirring porridge, also SPIRTLE [n]\n",
  "SPURTS": "SPURT, to gush forth, also SPIRT [v]\n",
  "SPURWAY": "a bridle road [n -S]\n",
  "SPURWAYS": "SPURWAY, a bridle road [n]\n",
  "SPUTA": "SPUTUM, (Latin) thick mucus coughed up from the respiratory tract esp in certain diseases of the lungs, chest, or throat [n]\n",
  "SPUTNIK": "(Russian) an orbiting spacecraft [n -S]\n",
  "SPUTNIKS": "SPUTNIK, (Russian) an orbiting spacecraft [n]\n",
  "SPUTTER": "to spit, or to emit saliva from the mouth [v -ED, -ING, -S]\n",
  "SPUTTERED": "SPUTTER, to spit, or to emit saliva from the mouth [v]\n",
  "SPUTTERER": "one who sputters [n -S]\n",
  "SPUTTERERS": "SPUTTERER, one who sputters [n]\n",
  "SPUTTERIER": "SPUTTERY, sputtering [adj]\n",
  "SPUTTERIEST": "SPUTTERY, sputtering [adj]\n",
  "SPUTTERING": "spitting [adj SPUTTERINGLY] / the act of sputtering [n -S]\n",
  "SPUTTERINGLY": "SPUTTERING, spitting [adv]\n",
  "SPUTTERINGS": "SPUTTERING, the act of sputtering [n]\n",
  "SPUTTERS": "SPUTTER, to spit, or to emit saliva from the mouth [v]\n",
  "SPUTTERY": "sputtering [adj SPUTTERIER, SPUTTERIEST]\n",
  "SPUTUM": "(Latin) thick mucus coughed up from the respiratory tract esp in certain diseases of the lungs, chest, or throat [n SPUTA or SPUTUMS]\n",
  "SPUTUMS": "SPUTUM, (Latin) thick mucus coughed up from the respiratory tract esp in certain diseases of the lungs, chest, or throat [n]\n",
  "SPY": "to watch secretly, also SPIE [v SPIED or (obsolete) SPIDE, SPYING, SPIES]\n",
  "SPYAL": "(Spenser) a spy, also SPIAL [n -S]\n",
  "SPYALS": "SPYAL, (Spenser) a spy, also SPIAL [n]\n",
  "SPYCAM": "a camera set up for hidden surveillance purposes, esp. a webcam relaying pictures to a computer [n -S]\n",
  "SPYCAMS": "SPYCAM, a camera set up for hidden surveillance purposes, esp. a webcam relaying pictures to a computer [n]\n",
  "SPYCATCHER": "a person who works in counterintelligence to detect enemy espionage activities [n -S]\n",
  "SPYCATCHERS": "SPYCATCHER, a person who works in counterintelligence to detect enemy espionage activities [n]\n",
  "SPYGLASS": "a small telescope [n -ES]\n",
  "SPYGLASSES": "SPYGLASS, a small telescope [n]\n",
  "SPYHOLE": "a peephole [n -S]\n",
  "SPYHOLES": "SPYHOLE, a peephole [n]\n",
  "SPYING": "the act of spying [n -S]\n",
  "SPYINGS": "SPYING, the act of spying [n]\n",
  "SPYMASTER": "one who controls spies [n -S]\n",
  "SPYMASTERS": "SPYMASTER, one who controls spies [n]\n",
  "SPYPLANE": "a plane equipped to collect enemy information [n -S]\n",
  "SPYPLANES": "SPYPLANE, a plane equipped to collect enemy information [n]\n",
  "SPYRE": "(Spenser) a spire [n -S]\n",
  "SPYRES": "SPYRE, (Spenser) a spire [n]\n",
  "SPYWARE": "software which unbeknown to the user, sends private information to another computer [n -S]\n",
  "SPYWARES": "SPYWARE, software which unbeknown to the user, sends private information to another computer [n]\n",
  "SQUAB": "fat, clumsy, unfledged, also SQUABBISH, SQUABBY [adj SQUABBER, SQUABBEST] / to stuff, upholster [v SQUABBED, SQUABBING, SQUABS]\n",
  "SQUABASH": "to crush esp. with criticism; to lambaste [v -ED, -ING, -ES]\n",
  "SQUABASHED": "SQUABASH, to crush esp. with criticism; to lambaste [v]\n",
  "SQUABASHER": "one who deals a squabash, a crushing blow [n -S]\n",
  "SQUABASHERS": "SQUABASHER, one who deals a squabash, a crushing blow [n]\n",
  "SQUABASHES": "SQUABASH, to crush esp. with criticism; to lambaste [v]\n",
  "SQUABASHING": "SQUABASH, to crush esp. with criticism; to lambaste [v]\n",
  "SQUABBED": "SQUAB, to stuff, upholster [v]\n",
  "SQUABBER": "SQUAB, fat, clumsy, unfledged, also SQUABBISH, SQUABBY [adj]\n",
  "SQUABBEST": "SQUAB, fat, clumsy, unfledged, also SQUABBISH, SQUABBY [adj]\n",
  "SQUABBIER": "SQUABBY, short and thick, also SQUAB, SQUABBISH [adj]\n",
  "SQUABBIEST": "SQUABBY, short and thick, also SQUAB, SQUABBISH [adj]\n",
  "SQUABBING": "SQUAB, to stuff, upholster [v]\n",
  "SQUABBISH": "somewhat fat or squat, also SQUAB, SQUABBY [adj]\n",
  "SQUABBLE": "to quarrel [v SQUABBLED, SQUABBLING, SQUABBLES]\n",
  "SQUABBLED": "SQUABBLE, to quarrel [v]\n",
  "SQUABBLER": "one who squabbles [n -S]\n",
  "SQUABBLERS": "SQUABBLER, one who squabbles [n]\n",
  "SQUABBLES": "SQUABBLE, to quarrel [v]\n",
  "SQUABBLING": "petty quarrelling [n -S]\n",
  "SQUABBLINGS": "SQUABBLING, petty quarrelling [n]\n",
  "SQUABBY": "short and thick, also SQUAB, SQUABBISH [adj SQUABBIER, SQUABBIEST]\n",
  "SQUABS": "SQUAB, to stuff, upholster [v]\n",
  "SQUACCO": "(Italian) a kind of heron found in Asia, North Africa, and southern Europe [n -S]\n",
  "SQUACCOS": "SQUACCO, (Italian) a kind of heron found in Asia, North Africa, and southern Europe [n]\n",
  "SQUAD": "to form into small, organised groups [v SQUADDED, SQUADDING, SQUADS]\n",
  "SQUADDED": "SQUAD, to form into small, organised groups [v]\n",
  "SQUADDIE": "(colloquial) a soldier, also SQUADDY [n -S]\n",
  "SQUADDIES": "SQUADDY, (colloquial) a soldier, also SQUADDIE [n]\n",
  "SQUADDING": "SQUAD, to form into small, organised groups [v]\n",
  "SQUADDY": "(colloquial) a soldier, also SQUADDIE [n SQUADDIES]\n",
  "SQUADOOSH": "(US slang) nothing [n -ES]\n",
  "SQUADOOSHES": "SQUADOOSH, (US slang) nothing [n]\n",
  "SQUADRON": "to organize in divisions of a regiment [v -ED, -ING, -S]\n",
  "SQUADRONAL": "relating to a squadron [adj]\n",
  "SQUADRONE": "(Italian) as in squadrone volante, an early eighteenth century Scottish political party opposed to the Argathelians [n -S]\n",
  "SQUADRONED": "SQUADRON, to organize in divisions of a regiment [v]\n",
  "SQUADRONES": "SQUADRONE, (Italian) as in squadrone volante, an early eighteenth century Scottish political party opposed to the Argathelians [n]\n",
  "SQUADRONING": "SQUADRON, to organize in divisions of a regiment [v]\n",
  "SQUADRONS": "SQUADRON, to organize in divisions of a regiment [v]\n",
  "SQUADS": "SQUAD, to form into small, organised groups [v]\n",
  "SQUAIL": "to pelt with sticks [v -ED, -ING, -S]\n",
  "SQUAILED": "SQUAIL, to pelt with sticks [v]\n",
  "SQUAILER": "a throwing stick [n -S]\n",
  "SQUAILERS": "SQUAILER, a throwing stick [n]\n",
  "SQUAILING": "the act of squailing, pelting with sticks [n -S]\n",
  "SQUAILINGS": "SQUAILING, the act of squailing, pelting with sticks [n]\n",
  "SQUAILS": "SQUAIL, to pelt with sticks [v]\n",
  "SQUALENE": "a natural oil obtained e.g. from shark liver [n -S]\n",
  "SQUALENES": "SQUALENE, a natural oil obtained e.g. from shark liver [n]\n",
  "SQUALID": "filthy, neglected [adj SQUALIDER, SQUALIDEST, SQUALIDLY]\n",
  "SQUALIDER": "SQUALID, filthy, neglected [adj]\n",
  "SQUALIDEST": "SQUALID, filthy, neglected [adj]\n",
  "SQUALIDITIES": "SQUALIDITY, the state of being squalid, also SQUALIDNESS [n]\n",
  "SQUALIDITY": "the state of being squalid, also SQUALIDNESS [n SQUALIDITIES]\n",
  "SQUALIDLY": "SQUALID, filthy, neglected [adv]\n",
  "SQUALIDNESS": "the state of being squalid, also SQUALIDITY [n -ES]\n",
  "SQUALIDNESSES": "SQUALIDNESS, the state of being squalid, also SQUALIDITY [n]\n",
  "SQUALL": "to rain or blow with sudden strength [v -ED, -ING, -S]\n",
  "SQUALLED": "SQUALL, to rain or blow with sudden strength [v]\n",
  "SQUALLER": "a person, esp. a child, given to squalling [n -S]\n",
  "SQUALLERS": "SQUALLER, a person, esp. a child, given to squalling [n]\n",
  "SQUALLIER": "SQUALLY, full of squalls [adj]\n",
  "SQUALLIEST": "SQUALLY, full of squalls [adj]\n",
  "SQUALLING": "the act of making a squall [n -S]\n",
  "SQUALLINGS": "SQUALLING, the act of making a squall [n]\n",
  "SQUALLISH": "somewhat like a squall [adj]\n",
  "SQUALLS": "SQUALL, to rain or blow with sudden strength [v]\n",
  "SQUALLY": "full of squalls [adj SQUALLIER, SQUALLIEST]\n",
  "SQUALOID": "like a shark [adj]\n",
  "SQUALOR": "the state of being squalid [n -S]\n",
  "SQUALORS": "SQUALOR, the state of being squalid [n]\n",
  "SQUAMA": "(Latin) a scale, also SQUAME [n SQUAMAE]\n",
  "SQUAMAE": "SQUAMA, (Latin) a scale, also SQUAME [n]\n",
  "SQUAMATE": "covered with scales, also SQUAMOSE, SQUAMOUS [adj] / a creature covered with scales [n -S]\n",
  "SQUAMATES": "SQUAMATE, a creature covered with scales [n]\n",
  "SQUAMATION": "scaliness [n -S]\n",
  "SQUAMATIONS": "SQUAMATION, scaliness [n]\n",
  "SQUAME": "a scale, also SQUAMA [n -S]\n",
  "SQUAMELLA": "a little scale, also SQUAMULA, SQUAMULE [n -S]\n",
  "SQUAMELLAS": "SQUAMELLA, a little scale, also SQUAMULA, SQUAMULE [n]\n",
  "SQUAMES": "SQUAME, a scale, also SQUAMA [n]\n",
  "SQUAMIFORM": "shaped like a scale [adj]\n",
  "SQUAMOSAL": "a paired membrane bone of the vertebrate skull, the squamous portion of the temporal bone [n -S]\n",
  "SQUAMOSALS": "SQUAMOSAL, a paired membrane bone of the vertebrate skull, the squamous portion of the temporal bone [n]\n",
  "SQUAMOSE": "covered with scales, also SQUAMOUS, SQUAMATE [adj SQUAMOSELY]\n",
  "SQUAMOSELY": "SQUAMOSE, covered with scales, also SQUAMOUS, SQUAMATE [adv]\n",
  "SQUAMOSENESS": "the state of being squamose [n -ES]\n",
  "SQUAMOSENESSES": "SQUAMOSENESS, the state of being squamose [n]\n",
  "SQUAMOSITIES": "SQUAMOSITY, scaliness [n]\n",
  "SQUAMOSITY": "scaliness [n SQUAMOSITIES]\n",
  "SQUAMOUS": "covered with scales, also SQUAMOSE, SQUAMATE [adj SQUAMOUSLY]\n",
  "SQUAMOUSLY": "SQUAMOUS, covered with scales, also SQUAMOSE, SQUAMATE [adv]\n",
  "SQUAMOUSNESS": "the state of being squamous [n -ES]\n",
  "SQUAMOUSNESSES": "SQUAMOUSNESS, the state of being squamous [n]\n",
  "SQUAMULA": "a little scale, also SQUAMELLA, SQUAMULE [n -S]\n",
  "SQUAMULAS": "SQUAMULA, a little scale, also SQUAMELLA, SQUAMULE [n]\n",
  "SQUAMULE": "a little scale, also SQUAMELLA, SQUAMULA [n -S]\n",
  "SQUAMULES": "SQUAMULE, a little scale, also SQUAMELLA, SQUAMULA [n]\n",
  "SQUAMULOSE": "covered with very small scales, as in snakes [adj]\n",
  "SQUANDER": "to spend wastefully [v -ED, -ING, -S]\n",
  "SQUANDERED": "SQUANDER, to spend wastefully [v]\n",
  "SQUANDERER": "one who squanders [n -S]\n",
  "SQUANDERERS": "SQUANDERER, one who squanders [n]\n",
  "SQUANDERING": "the act of squandering [n -S]\n",
  "SQUANDERINGLY": "SQUANDERING [adv]\n",
  "SQUANDERINGS": "SQUANDERING, the act of squandering [n]\n",
  "SQUANDERMANIA": "irrational propensity for spending money wastefully [n -S]\n",
  "SQUANDERMANIAS": "SQUANDERMANIA, irrational propensity for spending money wastefully [n]\n",
  "SQUANDERS": "SQUANDER, to spend wastefully [v]\n",
  "SQUARE": "rigidly conventional [adj SQUARER, SQUAREST, SQUARELY] / to make equal all over [v SQUARED, SQUARING, SQUARES]\n",
  "SQUARED": "SQUARE, to make equal all over [v]\n",
  "SQUAREHEAD": "(offensive) a German or Scandinavian [n -S]\n",
  "SQUAREHEADS": "SQUAREHEAD, (offensive) a German or Scandinavian [n]\n",
  "SQUARELY": "SQUARE, rigidly conventional [adv]\n",
  "SQUARENESS": "the state of being square [n -ES]\n",
  "SQUARENESSES": "SQUARENESS, the state of being square [n]\n",
  "SQUARER": "(Shakespeare) a fighting, quarrelsome person [n -S]\n",
  "SQUARERS": "SQUARER, (Shakespeare) a fighting, quarrelsome person [n]\n",
  "SQUARES": "SQUARE, to make equal all over [v]\n",
  "SQUAREST": "SQUARE, rigidly conventional [adj]\n",
  "SQUAREWISE": "in squares [adv]\n",
  "SQUARIAL": "a flat diamond-shaped aerial [n -S]\n",
  "SQUARIALS": "SQUARIAL, a flat diamond-shaped aerial [n]\n",
  "SQUARING": "the act of making square [n -S]\n",
  "SQUARINGS": "SQUARING, the act of making square [n]\n",
  "SQUARISH": "somewhat square [adj SQUARISHLY]\n",
  "SQUARISHLY": "SQUARISH, somewhat square [adv]\n",
  "SQUARISHNESS": "the state of being squarish [n -ES]\n",
  "SQUARISHNESSES": "SQUARISHNESS, the state of being squarish [n]\n",
  "SQUARK": "the hypothetical boson analogue of a quark [n -S]\n",
  "SQUARKS": "SQUARK, the hypothetical boson analogue of a quark [n]\n",
  "SQUARROSE": "rough with projecting or deflexed scales, bracts, etc. [adj]\n",
  "SQUARSON": "a clergyman who is also a squire or landowner in his parish [n -S]\n",
  "SQUARSONAGE": "the dwelling of a squarson [n -S]\n",
  "SQUARSONAGES": "SQUARSONAGE, the dwelling of a squarson [n]\n",
  "SQUARSONS": "SQUARSON, a clergyman who is also a squire or landowner in his parish [n]\n",
  "SQUASH": "to press into a flat mess, also SQUISH, SQUOOSH, SQUUSH [v -ED, -ING, -ES]\n",
  "SQUASHABLE": "that can be squashed [adj]\n",
  "SQUASHED": "SQUASH, to press into a flat mess, also SQUISH, SQUOOSH, SQUUSH [v]\n",
  "SQUASHER": "one who squashes [n -S]\n",
  "SQUASHERS": "SQUASHER, one who squashes [n]\n",
  "SQUASHES": "SQUASH, to press into a flat mess, also SQUISH, SQUOOSH, SQUUSH [v]\n",
  "SQUASHIER": "SQUASHY, yielding, soft and moist, also SQUISHY [adj]\n",
  "SQUASHIEST": "SQUASHY, yielding, soft and moist, also SQUISHY [adj]\n",
  "SQUASHILY": "SQUASHY, yielding, soft and moist, also SQUISHY [adv]\n",
  "SQUASHINESS": "the state of being squashy [n -ES]\n",
  "SQUASHINESSES": "SQUASHINESS, the state of being squashy [n]\n",
  "SQUASHING": "SQUASH, to press into a flat mess, also SQUISH, SQUOOSH, SQUUSH [v]\n",
  "SQUASHY": "yielding, soft and moist, also SQUISHY [adj SQUASHIER, SQUASHIEST, SQUASHILY]\n",
  "SQUAT": "short and thick [adj SQUATTER, SQUATTEST, SQUATLY] / to sit on one's heels [v SQUATTED, SQUATTING, SQUATS]\n",
  "SQUATLY": "SQUAT, short and thick [adv]\n",
  "SQUATNESS": "the state of being squat [n -ES]\n",
  "SQUATNESSES": "SQUATNESS, the state of being squat [n]\n",
  "SQUATS": "SQUAT, to sit on one's heels [v]\n",
  "SQUATTED": "SQUAT, to sit on one's heels [v]\n",
  "SQUATTER": "(dialect) to splash water about, also SWATTER [v -ED, -ING, -S]\n",
  "SQUATTERED": "SQUATTER, (dialect) to splash water about, also SWATTER [v]\n",
  "SQUATTERING": "SQUATTER, (dialect) to splash water about, also SWATTER [v]\n",
  "SQUATTERS": "SQUATTER, (dialect) to splash water about, also SWATTER [v]\n",
  "SQUATTEST": "SQUAT, short and thick [adj]\n",
  "SQUATTIER": "SQUATTY, squat, dumpy [adj]\n",
  "SQUATTIEST": "SQUATTY, squat, dumpy [adj]\n",
  "SQUATTILY": "SQUATTY, squat, dumpy [adv]\n",
  "SQUATTINESS": "the state of being squatty [n -ES]\n",
  "SQUATTINESSES": "SQUATTINESS, the state of being squatty [n]\n",
  "SQUATTING": "the act of sitting on the heels [n -S]\n",
  "SQUATTINGS": "SQUATTING, the act of sitting on the heels [n]\n",
  "SQUATTLE": "(Scots) to squat down [v SQUATTLED, SQUATTLING, SQUATTLES]\n",
  "SQUATTLED": "SQUATTLE, (Scots) to squat down [v]\n",
  "SQUATTLES": "SQUATTLE, (Scots) to squat down [v]\n",
  "SQUATTLING": "SQUATTLE, (Scots) to squat down [v]\n",
  "SQUATTOCRACIES": "SQUATTOCRACY, (Australian) the powerful landowning class [n]\n",
  "SQUATTOCRACY": "(Australian) the powerful landowning class [n SQUATTOCRACIES]\n",
  "SQUATTY": "squat, dumpy [adj SQUATTIER, SQUATTIEST, SQUATTILY]\n",
  "SQUAW": "(Native American) an offensive word for a woman, esp. a wife [n -S]\n",
  "SQUAWBUSH": "an American shrub [n -ES]\n",
  "SQUAWBUSHES": "SQUAWBUSH, an American shrub [n]\n",
  "SQUAWFISH": "a large cyprinid fish of North America [n -ES]\n",
  "SQUAWFISHES": "SQUAWFISH, a large cyprinid fish of North America [n]\n",
  "SQUAWK": "to utter a loud, harsh cry [v -ED, -ING, -S]\n",
  "SQUAWKED": "SQUAWK, to utter a loud, harsh cry [v]\n",
  "SQUAWKER": "a loudspeaker for reproducing sounds in the middle of the audible range [n -S]\n",
  "SQUAWKERS": "SQUAWKER, a loudspeaker for reproducing sounds in the middle of the audible range [n]\n",
  "SQUAWKIER": "SQUAWKY, shrill and grating [adj]\n",
  "SQUAWKIEST": "SQUAWKY, shrill and grating [adj]\n",
  "SQUAWKING": "the act of squawking [n -S]\n",
  "SQUAWKINGS": "SQUAWKING, the act of squawking [n]\n",
  "SQUAWKS": "SQUAWK, to utter a loud, harsh cry [v]\n",
  "SQUAWKY": "shrill and grating [adj SQUAWKIER, SQUAWKIEST]\n",
  "SQUAWMAN": "a white man with an Indian wife [n SQUAWMEN]\n",
  "SQUAWMEN": "SQUAWMAN, a white man with an Indian wife [n]\n",
  "SQUAWROOT": "a scaly parasitic plant found in oak woods in the United States [n -S]\n",
  "SQUAWROOTS": "SQUAWROOT, a scaly parasitic plant found in oak woods in the United States [n]\n",
  "SQUAWS": "SQUAW, (Native American) an offensive word for a woman, esp. a wife [n]\n",
  "SQUEAK": "to make a sharp, high-pitched sound [v -ED, -ING, -S]\n",
  "SQUEAKED": "SQUEAK, to make a sharp, high-pitched sound [v]\n",
  "SQUEAKER": "something that squeaks; a young bird [n -S]\n",
  "SQUEAKERIES": "SQUEAKERY, an assemblage of things that squeak [n]\n",
  "SQUEAKERS": "SQUEAKER, something that squeaks; a young bird [n]\n",
  "SQUEAKERY": "an assemblage of things that squeak [n SQUEAKERIES]\n",
  "SQUEAKIER": "SQUEAKY, making a squeak [adj]\n",
  "SQUEAKIEST": "SQUEAKY, making a squeak [adj]\n",
  "SQUEAKILY": "SQUEAKY, making a squeak [adv]\n",
  "SQUEAKINESS": "the state of being squeaky [n -ES]\n",
  "SQUEAKINESSES": "SQUEAKINESS, the state of being squeaky [n]\n",
  "SQUEAKING": "making a sharp, high-pitched sound [adj SQUEAKINGLY] / the act of squeaking [n -S]\n",
  "SQUEAKINGLY": "SQUEAKING, making a sharp, high-pitched sound [adv]\n",
  "SQUEAKINGS": "SQUEAKING, the act of squeaking [n]\n",
  "SQUEAKS": "SQUEAK, to make a sharp, high-pitched sound [v]\n",
  "SQUEAKY": "making a squeak [adj SQUEAKIER, SQUEAKIEST, SQUEAKILY]\n",
  "SQUEAL": "to utter a sharp, shrill cry [v -ED, -ING, -S]\n",
  "SQUEALED": "SQUEAL, to utter a sharp, shrill cry [v]\n",
  "SQUEALER": "an informer [n -S]\n",
  "SQUEALERS": "SQUEALER, an informer [n]\n",
  "SQUEALING": "the act of making a squeal [n -S]\n",
  "SQUEALINGS": "SQUEALING, the act of making a squeal [n]\n",
  "SQUEALS": "SQUEAL, to utter a sharp, shrill cry [v]\n",
  "SQUEAMISH": "feeling nauseous, sick [adj SQUEAMISHLY]\n",
  "SQUEAMISHLY": "SQUEAMISH, feeling nauseous, sick [adv]\n",
  "SQUEAMISHNESS": "the state of being squeamish [n -ES]\n",
  "SQUEAMISHNESSES": "SQUEAMISHNESS, the state of being squeamish [n]\n",
  "SQUEEGEE": "to wipe with a type of mop, also SQUILGEE [v SQUEEGEED, SQUEEGEEING, SQUEEGEES]\n",
  "SQUEEGEED": "SQUEEGEE, to wipe with a type of mop, also SQUILGEE [v]\n",
  "SQUEEGEEING": "SQUEEGEE, to wipe with a type of mop, also SQUILGEE [v]\n",
  "SQUEEGEES": "SQUEEGEE, to wipe with a type of mop, also SQUILGEE [v]\n",
  "SQUEEZABILITIES": "SQUEEZABILITY, the state of being squeezable [n]\n",
  "SQUEEZABILITY": "the state of being squeezable [n SQUEEZABILITIES]\n",
  "SQUEEZABLE": "that can be squeezed [adj]\n",
  "SQUEEZE": "to press hard [v SQUEEZED, SQUEEZING, SQUEEZES]\n",
  "SQUEEZED": "SQUEEZE, to press hard [v]\n",
  "SQUEEZER": "one that squeezes [n -S]\n",
  "SQUEEZERS": "SQUEEZER, one that squeezes [n]\n",
  "SQUEEZES": "SQUEEZE, to press hard [v]\n",
  "SQUEEZIER": "SQUEEZY, squeezable [adj]\n",
  "SQUEEZIEST": "SQUEEZY, squeezable [adj]\n",
  "SQUEEZING": "the act of squeezing [n -S]\n",
  "SQUEEZINGS": "SQUEEZING, the act of squeezing [n]\n",
  "SQUEEZY": "squeezable [adj SQUEEZIER, SQUEEZIEST]\n",
  "SQUEG": "to oscillate in an irregular manner [v SQUEGGED, SQUEGGING, SQUEGS]\n",
  "SQUEGGED": "SQUEG, to oscillate in an irregular manner [v]\n",
  "SQUEGGER": "a squegging oscillator [n -S]\n",
  "SQUEGGERS": "SQUEGGER, a squegging oscillator [n]\n",
  "SQUEGGING": "a type of oscillation in which the oscillations build up to a certain value and then stop for a time before resuming [n -S]\n",
  "SQUEGGINGS": "SQUEGGING, a type of oscillation in which the oscillations build up to a certain value and then stop for a time before resuming [n]\n",
  "SQUEGS": "SQUEG, to oscillate in an irregular manner [v]\n",
  "SQUELCH": "to make a gurgling, sucking sound [v -ED, -ING, -ES]\n",
  "SQUELCHED": "SQUELCH, to make a gurgling, sucking sound [v]\n",
  "SQUELCHER": "an overwhelming blow, retort etc. [n -S]\n",
  "SQUELCHERS": "SQUELCHER, an overwhelming blow, retort etc. [n]\n",
  "SQUELCHES": "SQUELCH, to make a gurgling, sucking sound [v]\n",
  "SQUELCHIER": "SQUELCHY, sounding like a squelch [adj]\n",
  "SQUELCHIEST": "SQUELCHY, sounding like a squelch [adj]\n",
  "SQUELCHING": "the act of squelching [n -S]\n",
  "SQUELCHINGS": "SQUELCHING, the act of squelching [n]\n",
  "SQUELCHY": "sounding like a squelch [adj SQUELCHIER, SQUELCHIEST]\n",
  "SQUETEAGUE": "(Native American) an American sciaenoid fish, aka weakfish, abundant on the Atlantic coast of the United States [n -S]\n",
  "SQUETEAGUES": "SQUETEAGUE, (Native American) an American sciaenoid fish, aka weakfish, abundant on the Atlantic coast of the United States [n]\n",
  "SQUIB": "to lampoon [v SQUIBBED, SQUIBBING, SQUIBS]\n",
  "SQUIBBED": "SQUIB, to lampoon [v]\n",
  "SQUIBBER": "in baseball, an infield grounder that becomes a base hit [n -S]\n",
  "SQUIBBERS": "SQUIBBER, in baseball, an infield grounder that becomes a base hit [n]\n",
  "SQUIBBING": "the act of squibbing, lampooning [n -S]\n",
  "SQUIBBINGS": "SQUIBBING, the act of squibbing, lampooning [n]\n",
  "SQUIBS": "SQUIB, to lampoon [v]\n",
  "SQUID": "a kind of cephalopod mollusc [n -S] / to fish with squid for bait [v SQUIDDED, SQUIDDING, SQUIDS]\n",
  "SQUIDDED": "SQUID, to fish with squid for bait [v]\n",
  "SQUIDDING": "SQUID, to fish with squid for bait [v]\n",
  "SQUIDGE": "to squeeze or squash [v SQUIDGED, SQUIDGING, SQUIDGES]\n",
  "SQUIDGED": "SQUIDGE, to squeeze or squash [v]\n",
  "SQUIDGES": "SQUIDGE, to squeeze or squash [v]\n",
  "SQUIDGIER": "SQUIDGY, unpleasantly damp, clammy [adj]\n",
  "SQUIDGIEST": "SQUIDGY, unpleasantly damp, clammy [adj]\n",
  "SQUIDGING": "SQUIDGE, to squeeze or squash [v]\n",
  "SQUIDGY": "unpleasantly damp, clammy [adj SQUIDGIER, SQUIDGIEST]\n",
  "SQUIDLIKE": "like a squid [adj]\n",
  "SQUIDS": "SQUID, to fish with squid for bait [v]\n",
  "SQUIER": "(Shakespeare) a square or rule [n -S]\n",
  "SQUIERS": "SQUIER, (Shakespeare) a square or rule [n]\n",
  "SQUIFF": "(colloquial) tipsy, drunk, also SQUIFFED, SQUIFFY [adj]\n",
  "SQUIFFED": "(colloquial) tipsy, drunk, also SQUIFF, SQUIFFY [adj]\n",
  "SQUIFFER": "(slang) a concertina [n -S]\n",
  "SQUIFFERS": "SQUIFFER, (slang) a concertina [n]\n",
  "SQUIFFIER": "SQUIFFY, (colloquial) tipsy, drunk, also SQUIFF, SQUIFFED [adj]\n",
  "SQUIFFIEST": "SQUIFFY, (colloquial) tipsy, drunk, also SQUIFF, SQUIFFED [adj]\n",
  "SQUIFFY": "(colloquial) tipsy, drunk, also SQUIFF, SQUIFFED [adj SQUIFFIER, SQUIFFIEST]\n",
  "SQUIGGLE": "to writhe about; squirm, wriggle [v SQUIGGLED, SQUIGGLING, SQUIGGLES]\n",
  "SQUIGGLED": "SQUIGGLE, to writhe about; squirm, wriggle [v]\n",
  "SQUIGGLER": "one who squiggles, wriggles [n -S]\n",
  "SQUIGGLERS": "SQUIGGLER, one who squiggles, wriggles [n]\n",
  "SQUIGGLES": "SQUIGGLE, to writhe about; squirm, wriggle [v]\n",
  "SQUIGGLIER": "SQUIGGLY, like squiggles, wriggly [adj]\n",
  "SQUIGGLIEST": "SQUIGGLY, like squiggles, wriggly [adj]\n",
  "SQUIGGLING": "SQUIGGLE, to writhe about; squirm, wriggle [v]\n",
  "SQUIGGLY": "like squiggles, wriggly [adj SQUIGGLIER, SQUIGGLIEST]\n",
  "SQUILGEE": "to wipe with a type of mop, also SQUEEGEE [v SQUILGEED, SQUILGEEING, SQUILGEES]\n",
  "SQUILGEED": "SQUILGEE, to wipe with a type of mop, also SQUEEGEE [v]\n",
  "SQUILGEEING": "SQUILGEE, to wipe with a type of mop, also SQUEEGEE [v]\n",
  "SQUILGEES": "SQUILGEE, to wipe with a type of mop, also SQUEEGEE [v]\n",
  "SQUILL": "a blue wild flower, also SQUILLA [n -S]\n",
  "SQUILLA": "a kind of burrowing crustacean, a mantis shrimp [n SQUILLAS or SQUILLAE]\n",
  "SQUILLAE": "SQUILLA, a kind of burrowing crustacean, a mantis shrimp [n]\n",
  "SQUILLAS": "SQUILLA, a kind of burrowing crustacean, a mantis shrimp [n]\n",
  "SQUILLION": "an indefinitely large number [n -S]\n",
  "SQUILLIONS": "SQUILLION, an indefinitely large number [n]\n",
  "SQUILLS": "SQUILL, a blue wild flower, also SQUILLA [n]\n",
  "SQUINANCIES": "SQUINANCY, (obsolete) quinsy, suppurating tonsillitis [n]\n",
  "SQUINANCY": "(obsolete) quinsy, suppurating tonsillitis [n SQUINANCIES]\n",
  "SQUINCH": "to screw up, contort (one's face, features, etc.) [v -ED, -ING, -ES]\n",
  "SQUINCHED": "SQUINCH, to screw up, contort (one's face, features, etc.) [v]\n",
  "SQUINCHES": "SQUINCH, to screw up, contort (one's face, features, etc.) [v]\n",
  "SQUINCHING": "SQUINCH, to screw up, contort (one's face, features, etc.) [v]\n",
  "SQUINIED": "SQUINY, (dialect) to squint, also SQUINNY [v]\n",
  "SQUINIES": "SQUINY, (dialect) to squint, also SQUINNY [v]\n",
  "SQUINNIED": "SQUINNY, to squint, look askance, also SQUINY [v]\n",
  "SQUINNIER": "SQUINNY, squinting [adj]\n",
  "SQUINNIES": "SQUINNY, to squint, look askance, also SQUINY [v]\n",
  "SQUINNIEST": "SQUINNY, squinting [adj]\n",
  "SQUINNY": "squinting [adj SQUINNIER, SQUINNIEST] / to squint, look askance, also SQUINY [v SQUINNIED, SQUINNYING, SQUINNIES]\n",
  "SQUINNYING": "SQUINNY, to squint, look askance, also SQUINY [v]\n",
  "SQUINT": "cross-eyed [adj SQUINTER, SQUINTEST] / to look with the eyes partly closed [v -ED, -ING, -S]\n",
  "SQUINTED": "SQUINT, to look with the eyes partly closed [v]\n",
  "SQUINTER": "one who squints [n -S]\n",
  "SQUINTERS": "SQUINTER, one who squints [n]\n",
  "SQUINTEST": "SQUINT, cross-eyed [adj]\n",
  "SQUINTIER": "SQUINTY, marked by squinting [adj]\n",
  "SQUINTIEST": "SQUINTY, marked by squinting [adj]\n",
  "SQUINTING": "looking with the eyes partly closed [adj SQUINTINGLY] / the act of squinting [n -S]\n",
  "SQUINTINGLY": "SQUINTING, looking with the eyes partly closed [adv]\n",
  "SQUINTINGS": "SQUINTING, the act of squinting [n]\n",
  "SQUINTS": "SQUINT, to look with the eyes partly closed [v]\n",
  "SQUINTY": "marked by squinting [adj SQUINTIER, SQUINTIEST]\n",
  "SQUINY": "(dialect) to squint, also SQUINNY [v SQUINIED, SQUINYING, SQUINIES]\n",
  "SQUINYING": "SQUINY, (dialect) to squint, also SQUINNY [v]\n",
  "SQUIRAGE": "squires collectively, also SQUIRALITY, SQUIRALTY, SQUIRARCHY, SQUIREAGE, SQUIREARCHY [n -S]\n",
  "SQUIRAGES": "SQUIRAGE, squires collectively, also SQUIRALITY, SQUIRALTY, SQUIRARCHY, SQUIREAGE, SQUIREARCHY [n]\n",
  "SQUIRALITIES": "SQUIRALITY, squires collectively, also SQUIRAGE, SQUIRALTY, SQUIRARCHY, SQUIREAGE, SQUIREARCHY [n]\n",
  "SQUIRALITY": "squires collectively, also SQUIRAGE, SQUIRALTY, SQUIRARCHY, SQUIREAGE, SQUIREARCHY [n SQUIRALITIES]\n",
  "SQUIRALTIES": "SQUIRALTY, squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRARCHY, SQUIREAGE, SQUIREARCHY [n]\n",
  "SQUIRALTY": "squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRARCHY, SQUIREAGE, SQUIREARCHY [n SQUIRALTIES]\n",
  "SQUIRARCH": "one who belongs to the squirarchy [n -S]\n",
  "SQUIRARCHAL": "related to the squirarchy, also SQUIRARCHICAL, SQUIREARCHAL, SQUIREARCHICAL [adj]\n",
  "SQUIRARCHICAL": "relating to a squirarchy, also SQUIRARCHAL, SQUIREARCHAL, SQUIREARCHICAL [adj]\n",
  "SQUIRARCHIES": "SQUIRARCHY, squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRALTY, SQUIREAGE, SQUIREARCHY [n]\n",
  "SQUIRARCHS": "SQUIRARCH, one who belongs to the squirarchy [n]\n",
  "SQUIRARCHY": "squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRALTY, SQUIREAGE, SQUIREARCHY [n SQUIRARCHIES]\n",
  "SQUIRE": "an English or Irish landed gentleman, esp. of old family [adj] / to escort [v SQUIRED, SQUIRING, SQUIRES]\n",
  "SQUIREAGE": "squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRALTY, SQUIRARCHY, SQUIREARCHY [n -S]\n",
  "SQUIREAGES": "SQUIREAGE, squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRALTY, SQUIRARCHY, SQUIREARCHY [n]\n",
  "SQUIREARCH": "a squire, a member of the squirearchy [n -S]\n",
  "SQUIREARCHAL": "relating to a squirearchy, also SQUIRARCHAL, SQUIRARCHICAL, SQUIREARCHICAL [adj]\n",
  "SQUIREARCHICAL": "relating to a squirearchy, also SQUIRARCHAL, SQUIRARCHICAL, SQUIREARCHAL [adj]\n",
  "SQUIREARCHIES": "SQUIREARCHY, squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRALTY, SQUIRARCHY, SQUIREAGE [n]\n",
  "SQUIREARCHS": "SQUIREARCH, a squire, a member of the squirearchy [n]\n",
  "SQUIREARCHY": "squires collectively, also SQUIRAGE, SQUIRALITY, SQUIRALTY, SQUIRARCHY, SQUIREAGE [n SQUIREARCHIES]\n",
  "SQUIRED": "SQUIRE, to escort [v]\n",
  "SQUIREDOM": "the office of squire [n -S]\n",
  "SQUIREDOMS": "SQUIREDOM, the office of squire [n]\n",
  "SQUIREEN": "(facetious) one who is half squire and half farmer [n -S]\n",
  "SQUIREENS": "SQUIREEN, (facetious) one who is half squire and half farmer [n]\n",
  "SQUIREHOOD": "the rank of squire [n -S]\n",
  "SQUIREHOODS": "SQUIREHOOD, the rank of squire [n]\n",
  "SQUIRELIKE": "like a squire [adj]\n",
  "SQUIRELING": "a petty squire [n -S]\n",
  "SQUIRELINGS": "SQUIRELING, a petty squire [n]\n",
  "SQUIRELY": "like a squire [adj]\n",
  "SQUIRES": "SQUIRE, to escort [v]\n",
  "SQUIRESHIP": "squirehood [n -S]\n",
  "SQUIRESHIPS": "SQUIRESHIP, squirehood [n]\n",
  "SQUIRESS": "a squire's wife [n -ES]\n",
  "SQUIRESSES": "SQUIRESS, a squire's wife [n]\n",
  "SQUIRING": "SQUIRE, to escort [v]\n",
  "SQUIRISH": "resembling a squire [adj]\n",
  "SQUIRL": "an ornamental curve in handwriting [n -S]\n",
  "SQUIRLS": "SQUIRL, an ornamental curve in handwriting [n]\n",
  "SQUIRM": "to wriggle [v -ED, -ING, -S]\n",
  "SQUIRMED": "SQUIRM, to wriggle [v]\n",
  "SQUIRMER": "a person who squirms, esp. with embarrassment [n -S]\n",
  "SQUIRMERS": "SQUIRMER, a person who squirms, esp. with embarrassment [n]\n",
  "SQUIRMIER": "SQUIRMY, given to squirming [adj]\n",
  "SQUIRMIEST": "SQUIRMY, given to squirming [adj]\n",
  "SQUIRMING": "SQUIRM, to wriggle [v]\n",
  "SQUIRMINGLY": "SQUIRMING, SQUIRM, to wriggle [adv]\n",
  "SQUIRMS": "SQUIRM, to wriggle [v]\n",
  "SQUIRMY": "given to squirming [adj SQUIRMIER, SQUIRMIEST]\n",
  "SQUIRR": "to scour, search; to send skimming, also SCUR, SKER, SKIRR [v -ED, -ING, -S]\n",
  "SQUIRRED": "SQUIRR, to scour, search; to send skimming, also SCUR, SKER, SKIRR [v]\n",
  "SQUIRREL": "to store up for future use [v SQUIRRELED or SQUIRRELLED, SQUIRRELING or SQUIRRELLING, SQUIRRELS]\n",
  "SQUIRRELED": "SQUIRREL, to store up for future use [v]\n",
  "SQUIRRELFISH": "any of various brightly-coloured marine fishes of the family Holocentridae of shallow tropical waters, so called because their large eyes resemble those of the squirrel [n -ES]\n",
  "SQUIRRELFISHES": "SQUIRRELFISH, any of various brightly-coloured marine fishes of the family Holocentridae of shallow tropical waters, so called because their large eyes resemble those of the squirrel [n]\n",
  "SQUIRRELIER": "SQUIRRELY, like a squirrel, also SQUIRRELLY [adj]\n",
  "SQUIRRELIEST": "SQUIRRELY, like a squirrel, also SQUIRRELLY [adj]\n",
  "SQUIRRELING": "SQUIRREL, to store up for future use [v]\n",
  "SQUIRRELLED": "SQUIRREL, to store up for future use [v]\n",
  "SQUIRRELLIER": "SQUIRRELLY, like a squirrel, also SQUIRRELY [adj]\n",
  "SQUIRRELLIEST": "SQUIRRELLY, like a squirrel, also SQUIRRELY [adj]\n",
  "SQUIRRELLING": "SQUIRREL, to store up for future use [v]\n",
  "SQUIRRELLY": "like a squirrel, also SQUIRRELY [adj SQUIRRELLIER, SQUIRRELLIEST]\n",
  "SQUIRRELS": "SQUIRREL, to store up for future use [v]\n",
  "SQUIRRELY": "like a squirrel, also SQUIRRELLY [adj SQUIRRELIER, SQUIRRELIEST]\n",
  "SQUIRRING": "SQUIRR, to scour, search; to send skimming, also SCUR, SKER, SKIRR [v]\n",
  "SQUIRRS": "SQUIRR, to scour, search; to send skimming, also SCUR, SKER, SKIRR [v]\n",
  "SQUIRT": "to throw out in a jet [v -ED, -ING, -S]\n",
  "SQUIRTED": "SQUIRT, to throw out in a jet [v]\n",
  "SQUIRTER": "a device for squirting water etc. [n -S]\n",
  "SQUIRTERS": "SQUIRTER, a device for squirting water etc. [n]\n",
  "SQUIRTING": "the act of squirting [n -S]\n",
  "SQUIRTINGS": "SQUIRTING, the act of squirting [n]\n",
  "SQUIRTS": "SQUIRT, to throw out in a jet [v]\n",
  "SQUISH": "to squash, also SQUOOSH, SQUUSH [v -ED, -ING, -ES]\n",
  "SQUISHED": "SQUISH, to squash, also SQUOOSH, SQUUSH [v]\n",
  "SQUISHES": "SQUISH, to squash, also SQUOOSH, SQUUSH [v]\n",
  "SQUISHIER": "SQUISHY, squashy [adj]\n",
  "SQUISHIEST": "SQUISHY, squashy [adj]\n",
  "SQUISHINESS": "the state of being squishy [n -ES]\n",
  "SQUISHINESSES": "SQUISHINESS, the state of being squishy [n]\n",
  "SQUISHING": "SQUISH, to squash, also SQUOOSH, SQUUSH [v]\n",
  "SQUISHY": "squashy [adj SQUISHIER, SQUISHIEST]\n",
  "SQUIT": "(slang) a contemptible person, nonsense [n -S]\n",
  "SQUITCH": "quitch grass [n -ES]\n",
  "SQUITCHES": "SQUITCH, quitch grass [n]\n",
  "SQUITS": "SQUIT, (slang) a contemptible person, nonsense [n]\n",
  "SQUITTERS": "(colloquial) diarrhoea [n]\n",
  "SQUIZ": "(Australian slang) a quick, close look [n SQUIZZES]\n",
  "SQUIZZES": "SQUIZ, (Australian slang) a quick, close look [n]\n",
  "SQUOOSH": "to squash, also SQUISH, SQUUSH [v -ED, -ING, -ES]\n",
  "SQUOOSHED": "SQUOOSH, to squash, also SQUISH, SQUUSH [v]\n",
  "SQUOOSHES": "SQUOOSH, to squash, also SQUISH, SQUUSH [v]\n",
  "SQUOOSHIER": "SQUOOSHY, squashy [adj]\n",
  "SQUOOSHIEST": "SQUOOSHY, squashy [adj]\n",
  "SQUOOSHING": "SQUOOSH, to squash, also SQUISH, SQUUSH [v]\n",
  "SQUOOSHY": "squashy [adj SQUOOSHIER, SQUOOSHIEST]\n",
  "SQUUSH": "to squash [v -ED, -ING, -ES]\n",
  "SQUUSHED": "SQUUSH, to squash [v]\n",
  "SQUUSHES": "SQUUSH, to squash [v]\n",
  "SQUUSHING": "SQUUSH, to squash [v]\n",
  "SRADDHA": "(Sanskrit) an offering to the manes of an ancestor, also SHRADDHA, SRADHA [n -S]\n",
  "SRADDHAS": "SRADDHA, (Sanskrit) an offering to the manes of an ancestor, also SHRADDHA, SRADHA [n]\n",
  "SRADHA": "(Sanskrit) an offering to the manes of an ancestor, also SHRADDHA, SRADDHA [n -S]\n",
  "SRADHAS": "SRADHA, (Sanskrit) an offering to the manes of an ancestor, also SHRADDHA, SRADDHA [n]\n",
  "SRI": "(Sanskrit) in India, a title of great respect given to a man, also SHRI [n -S]\n",
  "SRIRACHA": "(Thai) a spicy sauce made with red chilli peppers, vinegar, and garlic [n -S]\n",
  "SRIRACHAS": "SRIRACHA, (Thai) a spicy sauce made with red chilli peppers, vinegar, and garlic [n]\n",
  "SRIS": "SRI, (Sanskrit) in India, a title of great respect given to a man, also SHRI [n]\n",
  "ST": "hush [interj]\n",
  "STAB": "to pierce with a pointed weapon [v STABBED, STABBING, STABS]\n",
  "STABBED": "STAB, to pierce with a pointed weapon [v]\n",
  "STABBER": "one who stabs [n -S]\n",
  "STABBERS": "STABBER, one who stabs [n]\n",
  "STABBING": "of a pain, sharp and repeated [adj STABBINGLY] / the act of stabbing [n -S]\n",
  "STABBINGLY": "STABBING, of a pain, sharp and repeated [adv]\n",
  "STABBINGS": "STABBING, the act of stabbing [n]\n",
  "STABILATE": "a population preserved in a viable state though subject to extraordinary conditions e.g. microorganisms in deep freeze [n -S]\n",
  "STABILATES": "STABILATE, a population preserved in a viable state though subject to extraordinary conditions e.g. microorganisms in deep freeze [n]\n",
  "STABILE": "a stationary abstract sculpture [n -S]\n",
  "STABILES": "STABILE, a stationary abstract sculpture [n]\n",
  "STABILISATION": "the act of stabilising, also STABILIZATION [n -S]\n",
  "STABILISATIONS": "STABILISATION, the act of stabilising, also STABILIZATION [n]\n",
  "STABILISATOR": "something that stabilizes, also STABILIZATOR [n -S]\n",
  "STABILISATORS": "STABILISATOR, something that stabilizes, also STABILIZATOR [n]\n",
  "STABILISE": "to make stable, also STABILIZE [v STABILISED, STABILISING, STABILISES]\n",
  "STABILISED": "STABILISE, to make stable, also STABILIZE [v]\n",
  "STABILISER": "one that stabilises something, also STABILIZER [n -S]\n",
  "STABILISERS": "STABILISER, one that stabilises something, also STABILIZER [n]\n",
  "STABILISES": "STABILISE, to make stable, also STABILIZE [v]\n",
  "STABILISING": "STABILISE, to make stable, also STABILIZE [v]\n",
  "STABILITIES": "STABILITY, the quality of being stable [n]\n",
  "STABILITY": "the quality of being stable [n STABILITIES]\n",
  "STABILIZATION": "the act of stabilizing, also STABILISATION [n -S]\n",
  "STABILIZATIONS": "STABILIZATION, the act of stabilizing, also STABILISATION [n]\n",
  "STABILIZATOR": "something that stabilizes, also STABILISATOR [n -S]\n",
  "STABILIZATORS": "STABILIZATOR, something that stabilizes, also STABILISATOR [n]\n",
  "STABILIZE": "to make stable, also STABILISE [v STABILIZED, STABILIZING, STABILIZES]\n",
  "STABILIZED": "STABILIZE, to make stable, also STABILISE [v]\n",
  "STABILIZER": "one that stabilizes something, also STABILISER [n -S]\n",
  "STABILIZERS": "STABILIZER, one that stabilizes something, also STABILISER [n]\n",
  "STABILIZES": "STABILIZE, to make stable, also STABILISE [v]\n",
  "STABILIZING": "STABILIZE, to make stable, also STABILISE [v]\n",
  "STABLE": "well-founded [adj STABLER, STABLEST, STABLY] / to put in a shelter for animals [v STABLED, STABLING, STABLES]\n",
  "STABLEBOY": "someone who works at a stable, also STABLEMAN [n -S]\n",
  "STABLEBOYS": "STABLEBOY, someone who works at a stable, also STABLEMAN [n]\n",
  "STABLED": "STABLE, to put in a shelter for animals [v]\n",
  "STABLEMAN": "someone who works at a stable, also STABLEBOY [n STABLEMEN]\n",
  "STABLEMATE": "a horse from the same stable as another [n -S]\n",
  "STABLEMATES": "STABLEMATE, a horse from the same stable as another [n]\n",
  "STABLEMEN": "STABLEMAN, someone who works at a stable, also STABLEBOY [n]\n",
  "STABLENESS": "the state of being stable [n -ES]\n",
  "STABLENESSES": "STABLENESS, the state of being stable [n]\n",
  "STABLER": "one who keeps a stable [n -S]\n",
  "STABLERS": "STABLER, one who keeps a stable [n]\n",
  "STABLES": "STABLE, to put in a shelter for animals [v]\n",
  "STABLEST": "STABLE, well-founded [adj]\n",
  "STABLING": "accommodation for animals [n -S]\n",
  "STABLINGS": "STABLING, accommodation for animals [n]\n",
  "STABLISH": "(archaic) to establish [v -ED, -ING, -ES]\n",
  "STABLISHED": "STABLISH, (archaic) to establish [v]\n",
  "STABLISHES": "STABLISH, (archaic) to establish [v]\n",
  "STABLISHING": "STABLISH, (archaic) to establish [v]\n",
  "STABLISHMENT": "the act of stablishing [n -S]\n",
  "STABLISHMENTS": "STABLISHMENT, the act of stablishing [n]\n",
  "STABLY": "STABLE, well-founded [adv]\n",
  "STABS": "STAB, to pierce with a pointed weapon [v]\n",
  "STACATION": "a holiday in which leisure activities are pursued while staying at one's own home, also STAYCATION [n -S]\n",
  "STACATIONS": "STACATION, a holiday in which leisure activities are pursued while staying at one's own home, also STAYCATION [n]\n",
  "STACCATI": "STACCATO, (Italian) a musical passage with each note detached [n]\n",
  "STACCATISSIMO": "in a very staccato manner [adv]\n",
  "STACCATO": "(Italian) a musical passage with each note detached [n STACCATOS or STACCATI]\n",
  "STACCATOS": "STACCATO, (Italian) a musical passage with each note detached [n]\n",
  "STACHYS": "(Greek) a labiate plant [n -ES]\n",
  "STACHYSES": "STACHYS, (Greek) a labiate plant [n]\n",
  "STACK": "to pile [v -ED, -ING, -S]\n",
  "STACKABLE": "that can be stacked [adj]\n",
  "STACKED": "STACK, to pile [v]\n",
  "STACKER": "one who stacks [n -S]\n",
  "STACKERS": "STACKER, one who stacks [n]\n",
  "STACKET": "(Scots) a stockade [n -S]\n",
  "STACKETS": "STACKET, (Scots) a stockade [n]\n",
  "STACKING": "the act of stacking [n -S]\n",
  "STACKINGS": "STACKING, the act of stacking [n]\n",
  "STACKLESS": "without a stack [adj]\n",
  "STACKROOM": "in a library, a room where books are kept in stacks [n -S]\n",
  "STACKROOMS": "STACKROOM, in a library, a room where books are kept in stacks [n]\n",
  "STACKS": "STACK, to pile [v]\n",
  "STACKUP": "an arrangement of circling airplanes over an airport waiting to land [n -S]\n",
  "STACKUPS": "STACKUP, an arrangement of circling airplanes over an airport waiting to land [n]\n",
  "STACKYARD": "a yard or inclosure for stacks of hay or grain [n -S]\n",
  "STACKYARDS": "STACKYARD, a yard or inclosure for stacks of hay or grain [n]\n",
  "STACTE": "a sweet-smelling spice, liquid myrrh, used in incense by the ancient Hebrews [n -S]\n",
  "STACTES": "STACTE, a sweet-smelling spice, liquid myrrh, used in incense by the ancient Hebrews [n]\n",
  "STACTOMETER": "a pipette with a hollow bulb in the middle for counting drops, also STAKTOMETER [n -S]\n",
  "STACTOMETERS": "STACTOMETER, a pipette with a hollow bulb in the middle for counting drops, also STAKTOMETER [n]\n",
  "STADDA": "a comb-maker's double-bladed handsaw [n -S]\n",
  "STADDAS": "STADDA, a comb-maker's double-bladed handsaw [n]\n",
  "STADDLE": "a support for a haystack, also STUDDLE [n -S]\n",
  "STADDLES": "STADDLE, a support for a haystack, also STUDDLE [n]\n",
  "STADDLESTONE": "a low mushroom-shaped arrangement of a conical and flat, circular stone, used as a support for a haystack [n -S]\n",
  "STADDLESTONES": "STADDLESTONE, a low mushroom-shaped arrangement of a conical and flat, circular stone, used as a support for a haystack [n]\n",
  "STADE": "a single period of colder climate or advancing ice, as a subdivision of a longer glacial period, also STADIAL [n -S]\n",
  "STADES": "STADE, a single period of colder climate or advancing ice, as a subdivision of a longer glacial period, also STADIAL [n]\n",
  "STADHOLDER": "(Dutch) a Dutch viceroy or provincial governor, also STADTHOLDER [n -S]\n",
  "STADHOLDERATE": "the office of stadholder, a Dutch viceroy or provincial governor, also STADHOLDERSHIP, STADTHOLDERATE, STADTHOLDERSHIP [n -S]\n",
  "STADHOLDERATES": "STADHOLDERATE, the office of stadholder, a Dutch viceroy or provincial governor, also STADHOLDERSHIP, STADTHOLDERATE, STADTHOLDERSHIP [n]\n",
  "STADHOLDERS": "STADHOLDER, (Dutch) a Dutch viceroy or provincial governor, also STADTHOLDER [n]\n",
  "STADHOLDERSHIP": "the office of stadholder, a Dutch viceroy or provincial governor, also STADHOLDERATE, STADTHOLDERATE, STADTHOLDERSHIP [n -S]\n",
  "STADHOLDERSHIPS": "STADHOLDERSHIP, the office of stadholder, a Dutch viceroy or provincial governor, also STADHOLDERATE, STADTHOLDERATE, STADTHOLDERSHIP [n]\n",
  "STADIA": "a graduated rod used in measuring distances [n -S]\n",
  "STADIAL": "a single period of colder climate or advancing ice, as a subdivision of a longer glacial period, also STADE [n -S]\n",
  "STADIALS": "STADIAL, a single period of colder climate or advancing ice, as a subdivision of a longer glacial period, also STADE [n]\n",
  "STADIAS": "STADIA, a graduated rod used in measuring distances [n]\n",
  "STADIOMETER": "an instrument that measures the length of curves, dashes, etc., by running a toothed wheel along them [n -S]\n",
  "STADIOMETERS": "STADIOMETER, an instrument that measures the length of curves, dashes, etc., by running a toothed wheel along them [n]\n",
  "STADIUM": "a race course, sports ground [n STADIA or STADIUMS]\n",
  "STADIUMS": "STADIUM, a race course, sports ground [n]\n",
  "STADTHOLDER": "(Dutch) a Dutch viceroy or provincial governor, also STADHOLDER [n -S]\n",
  "STADTHOLDERATE": "the office of stadtholder, also STADHOLDERATE, STADHOLDERSHIP, STADTHOLDERSHIP [n -S]\n",
  "STADTHOLDERATES": "STADTHOLDERATE, the office of stadtholder, also STADHOLDERATE, STADHOLDERSHIP, STADTHOLDERSHIP [n]\n",
  "STADTHOLDERS": "STADTHOLDER, (Dutch) a Dutch viceroy or provincial governor, also STADHOLDER [n]\n",
  "STADTHOLDERSHIP": "the office of stadtholder, also STADHOLDERATE, STADHOLDERSHIP, STADTHOLDERATE [n]\n",
  "STAFF": "a pole carried in the hand [n STAFFS or STAVES] / to fill positions with employees [v -ED, -ING, -S]\n",
  "STAFFAGE": "decorative addition to a work of art [n -S]\n",
  "STAFFAGES": "STAFFAGE, decorative addition to a work of art [n]\n",
  "STAFFED": "STAFF, to fill positions with employees [v]\n",
  "STAFFER": "a member of the permanent staff of a business etc. [n -S]\n",
  "STAFFERS": "STAFFER, a member of the permanent staff of a business etc. [n]\n",
  "STAFFING": "the provision of staff [n -S]\n",
  "STAFFINGS": "STAFFING, the provision of staff [n]\n",
  "STAFFMAN": "a person who holds the levelling staff when a survey is being made [n STAFFMEN]\n",
  "STAFFMEN": "STAFFMAN, a person who holds the levelling staff when a survey is being made [n]\n",
  "STAFFRIDER": "(South African) a person who illegally rides on the outside of a suburban train [n -S]\n",
  "STAFFRIDERS": "STAFFRIDER, (South African) a person who illegally rides on the outside of a suburban train [n]\n",
  "STAFFROOM": "a room in a school set aside for the teaching staff [n -S]\n",
  "STAFFROOMS": "STAFFROOM, a room in a school set aside for the teaching staff [n]\n",
  "STAFFS": "STAFF, to fill positions with employees [v]\n",
  "STAG": "to attend a function without a female companion [v STAGGED, STAGGING, STAGS]\n",
  "STAGE": "to produce for public viewing [v STAGED, STAGING, STAGES]\n",
  "STAGEABLE": "that can be staged [adj]\n",
  "STAGECOACH": "a horse-drawn passenger and mail coach running on a regular schedule between established stops [n -ES]\n",
  "STAGECOACHES": "STAGECOACH, a horse-drawn passenger and mail coach running on a regular schedule between established stops [n]\n",
  "STAGECOACHING": "travel by stagecoach [n -S]\n",
  "STAGECOACHINGS": "STAGECOACHING, travel by stagecoach [n]\n",
  "STAGECOACHMAN": "the driver of a stagecoach [n STAGECOACHMEN]\n",
  "STAGECOACHMEN": "STAGECOACHMAN, the driver of a stagecoach [n]\n",
  "STAGECRAFT": "the effective management of theatrical devices or techniques [n -S]\n",
  "STAGECRAFTS": "STAGECRAFT, the effective management of theatrical devices or techniques [n]\n",
  "STAGED": "STAGE, to produce for public viewing [v]\n",
  "STAGEFUL": "as much as a stage can hold [n -S]\n",
  "STAGEFULS": "STAGEFUL, as much as a stage can hold [n]\n",
  "STAGEHAND": "a workman employed about the stage [n -S]\n",
  "STAGEHANDS": "STAGEHAND, a workman employed about the stage [n]\n",
  "STAGEHEAD": "(Canadian) the part of a fishing stage which extends over the water [n -S]\n",
  "STAGEHEADS": "STAGEHEAD, (Canadian) the part of a fishing stage which extends over the water [n]\n",
  "STAGELIKE": "like a stage [adj]\n",
  "STAGER": "an experienced person [n -S]\n",
  "STAGERIES": "STAGERY, theatrical contrivances [n]\n",
  "STAGERS": "STAGER, an experienced person [n]\n",
  "STAGERY": "theatrical contrivances [n STAGERIES]\n",
  "STAGES": "STAGE, to produce for public viewing [v]\n",
  "STAGESTRUCK": "fascinated by the stage [adj]\n",
  "STAGETTE": "a young unmarried profession woman [n -S]\n",
  "STAGETTES": "STAGETTE, a young unmarried profession woman [n]\n",
  "STAGEY": "savouring of the stage, acted, assumed, also STAGY [adj STAGIER, STAGIEST]\n",
  "STAGFLATION": "persistent inflation combined with stagnant consumer demand and relatively high unemployment [n -S]\n",
  "STAGFLATIONARY": "relating to stagflation [adj]\n",
  "STAGFLATIONS": "STAGFLATION, persistent inflation combined with stagnant consumer demand and relatively high unemployment [n]\n",
  "STAGGARD": "the male red deer when four years old, also STAGGART [n -S]\n",
  "STAGGARDS": "STAGGARD, the male red deer when four years old, also STAGGART [n]\n",
  "STAGGART": "the male red deer when four years old, also STAGGARD [n -S]\n",
  "STAGGARTS": "STAGGART, the male red deer when four years old, also STAGGARD [n]\n",
  "STAGGED": "STAG, to attend a function without a female companion [v]\n",
  "STAGGER": "to walk or stand unsteadily [v -ED, -ING, -S]\n",
  "STAGGERBUSH": "a shrubby heath of the Eastern US, poisonous to livestock [n -ES]\n",
  "STAGGERBUSHES": "STAGGERBUSH, a shrubby heath of the Eastern US, poisonous to livestock [n]\n",
  "STAGGERED": "STAGGER, to walk or stand unsteadily [v]\n",
  "STAGGERER": "one who staggers [n -S]\n",
  "STAGGERERS": "STAGGERER, one who staggers [n]\n",
  "STAGGERIER": "STAGGERY, given to staggering [adj]\n",
  "STAGGERIEST": "STAGGERY, given to staggering [adj]\n",
  "STAGGERING": "astonishing, unbelievable [adj STAGGERINGLY] / the act of staggering [n -S]\n",
  "STAGGERINGLY": "STAGGERING, astonishing, unbelievable [adv]\n",
  "STAGGERINGS": "STAGGERING, the act of staggering [n]\n",
  "STAGGERS": "STAGGER, to walk or stand unsteadily [v]\n",
  "STAGGERY": "given to staggering [adj STAGGERIER, STAGGERIEST]\n",
  "STAGGIE": "(Scots) a colt, also STAIG [n -S]\n",
  "STAGGIER": "STAGGY, having the appearance of a mature male [adj]\n",
  "STAGGIES": "STAGGIE, (Scots) a colt, also STAIG [n]\n",
  "STAGGIEST": "STAGGY, having the appearance of a mature male [adj]\n",
  "STAGGING": "STAG, to attend a function without a female companion [v]\n",
  "STAGGY": "having the appearance of a mature male [adj STAGGIER, STAGGIEST]\n",
  "STAGHORN": "a stag's antler [n -S]\n",
  "STAGHORNS": "STAGHORN, a stag's antler [n]\n",
  "STAGHOUND": "a dog used for hunting stags [n -S]\n",
  "STAGHOUNDS": "STAGHOUND, a dog used for hunting stags [n]\n",
  "STAGIER": "STAGY, having a theatrical quality, also STAGEY [adj]\n",
  "STAGIEST": "STAGY, having a theatrical quality, also STAGEY [adj]\n",
  "STAGILY": "STAGY, having a theatrical quality, also STAGEY [adv]\n",
  "STAGINESS": "being stagy, theatrical [n -ES]\n",
  "STAGINESSES": "STAGINESS, being stagy, theatrical [n]\n",
  "STAGING": "a temporary platform [n -S]\n",
  "STAGINGS": "STAGING, a temporary platform [n]\n",
  "STAGNANCE": "the state of being stagnant, also STAGNANCY [n -S]\n",
  "STAGNANCES": "STAGNANCE, the state of being stagnant, also STAGNANCY [n]\n",
  "STAGNANCIES": "STAGNANCY, the state of being stagnant, also STAGNANCE [n]\n",
  "STAGNANCY": "the state of being stagnant, also STAGNANCE [n STAGNANCIES]\n",
  "STAGNANT": "like still and often foul water [adj STAGNANTLY]\n",
  "STAGNANTLY": "STAGNANT, like still and often foul water [adv]\n",
  "STAGNATE": "to become still and dull [v STAGNATED, STAGNATING, STAGNATES]\n",
  "STAGNATED": "STAGNATE, to become still and dull [v]\n",
  "STAGNATES": "STAGNATE, to become still and dull [v]\n",
  "STAGNATING": "STAGNATE, to become still and dull [v]\n",
  "STAGNATION": "the act of stagnating [n -S]\n",
  "STAGNATIONS": "STAGNATION, the act of stagnating [n]\n",
  "STAGS": "STAG, to attend a function without a female companion [v]\n",
  "STAGY": "having a theatrical quality, also STAGEY [adj STAGIER, STAGIEST, STAGILY]\n",
  "STAID": "sober and sedate [adj STAIDER, STAIDEST, STAIDLY]\n",
  "STAIDER": "STAID, sober and sedate [adj]\n",
  "STAIDEST": "STAID, sober and sedate [adj]\n",
  "STAIDLY": "STAID, sober and sedate [adv]\n",
  "STAIDNESS": "the state of being staid [n -ES]\n",
  "STAIDNESSES": "STAIDNESS, the state of being staid [n]\n",
  "STAIG": "a colt or stallion, also STAGGIE [n -S]\n",
  "STAIGS": "STAIG, a colt or stallion, also STAGGIE [n]\n",
  "STAIN": "to discolour, also STAYNE [v -ED, -ING, -S]\n",
  "STAINABILITIES": "STAINABILITY, the capacity of cells and cell parts to stain specifically and consistently with particular dyes and stains [n]\n",
  "STAINABILITY": "the capacity of cells and cell parts to stain specifically and consistently with particular dyes and stains [n STAINABILITIES]\n",
  "STAINABLE": "that can be stained [adj]\n",
  "STAINED": "STAIN, to discolour, also STAYNE [v]\n",
  "STAINER": "that which stains [n -S]\n",
  "STAINERS": "STAINER, that which stains [n]\n",
  "STAINING": "the act of staining [n -S]\n",
  "STAININGS": "STAINING, the act of staining [n]\n",
  "STAINLESS": "without stain [adj STAINLESSLY] / tableware made from stainless steel [n -ES]\n",
  "STAINLESSES": "STAINLESS, tableware made from stainless steel [n]\n",
  "STAINLESSLY": "STAINLESS, without stain [adv]\n",
  "STAINLESSNESS": "the state of being stainless [n -ES]\n",
  "STAINLESSNESSES": "STAINLESSNESS, the state of being stainless [n]\n",
  "STAINPROOF": "proof against stains [adj]\n",
  "STAINS": "STAIN, to discolour, also STAYNE [v]\n",
  "STAIR": "a rest for the foot used in going from one level to another, also STAYRE [n -S]\n",
  "STAIRCASE": "a flight of stairs, its supporting framework, and, usually, a handrail or banisters [n -S]\n",
  "STAIRCASED": "having a staircase [adj]\n",
  "STAIRCASES": "STAIRCASE, a flight of stairs, its supporting framework, and, usually, a handrail or banisters [n]\n",
  "STAIRCASING": "a staircase or staircases collectively [n -S]\n",
  "STAIRCASINGS": "STAIRCASING, a staircase or staircases collectively [n]\n",
  "STAIRED": "having, or arranged like, stairs [adj]\n",
  "STAIRFOOT": "the level place at the foot of the stairs [n -S]\n",
  "STAIRFOOTS": "STAIRFOOT, the level place at the foot of the stairs [n]\n",
  "STAIRHEAD": "the level place at the top of the stairs [n -S]\n",
  "STAIRHEADS": "STAIRHEAD, the level place at the top of the stairs [n]\n",
  "STAIRLESS": "without a stair [adj]\n",
  "STAIRLIFT": "a lift to enable people to get up the stairs [n -S]\n",
  "STAIRLIFTS": "STAIRLIFT, a lift to enable people to get up the stairs [n]\n",
  "STAIRLIKE": "like a stair [adj]\n",
  "STAIRS": "STAIR, a rest for the foot used in going from one level to another, also STAYRE [n]\n",
  "STAIRSTEP": "to carry out an exercise like stepping on a stair [v STAIRSTEPPED, STAIRSTEPPING, STAIRSTEPS]\n",
  "STAIRSTEPPED": "STAIRSTEP, to carry out an exercise like stepping on a stair [v]\n",
  "STAIRSTEPPING": "STAIRSTEP, to carry out an exercise like stepping on a stair [v]\n",
  "STAIRSTEPS": "STAIRSTEP, to carry out an exercise like stepping on a stair [v]\n",
  "STAIRWAY": "a flight of stairs [n -S]\n",
  "STAIRWAYS": "STAIRWAY, a flight of stairs [n]\n",
  "STAIRWELL": "a vertical shaft or opening that contains a staircase [n -S]\n",
  "STAIRWELLS": "STAIRWELL, a vertical shaft or opening that contains a staircase [n]\n",
  "STAIRWISE": "in the fashion of stairs [adv]\n",
  "STAIRWORK": "backstairs intriguing [n -S]\n",
  "STAIRWORKS": "STAIRWORK, backstairs intriguing [n]\n",
  "STAITH": "a wharf for the transfer of coal or ore, also STAITHE [n -S]\n",
  "STAITHE": "a wharf for the transfer of coal or ore, also STAITH [n -S]\n",
  "STAITHES": "STAITHE, a wharf for the transfer of coal or ore, also STAITH [n]\n",
  "STAITHS": "STAITH, a wharf for the transfer of coal or ore, also STAITHE [n]\n",
  "STAKE": "to fasten with a pointed piece of wood or metal [v STAKED, STAKING, STAKES]\n",
  "STAKED": "STAKE, to fasten with a pointed piece of wood or metal [v]\n",
  "STAKEHOLDER": "a person entrusted with the stakes of bettors [n -S]\n",
  "STAKEHOLDERS": "STAKEHOLDER, a person entrusted with the stakes of bettors [n]\n",
  "STAKEOUT": "a surveillance of an area [n -S]\n",
  "STAKEOUTS": "STAKEOUT, a surveillance of an area [n]\n",
  "STAKER": "one that marks off an area with stakes [n -S]\n",
  "STAKERS": "STAKER, one that marks off an area with stakes [n]\n",
  "STAKES": "STAKE, to fasten with a pointed piece of wood or metal [v]\n",
  "STAKHANOVISM": "the practice of working like a stakhanovite, a worker who received recognition for his or her part in increasing the rate of production [n -S]\n",
  "STAKHANOVISMS": "STAKHANOVISM, the practice of working like a stakhanovite, a worker who received recognition for his or her part in increasing the rate of production [n]\n",
  "STAKHANOVITE": "a superlative worker [n -S]\n",
  "STAKHANOVITES": "STAKHANOVITE, a superlative worker [n]\n",
  "STAKING": "STAKE, to fasten with a pointed piece of wood or metal [v]\n",
  "STAKTOMETER": "a pipette with a hollow bulb in the middle for counting drops, also STACTOMETER [n -S]\n",
  "STAKTOMETERS": "STAKTOMETER, a pipette with a hollow bulb in the middle for counting drops, also STACTOMETER [n]\n",
  "STALACTIC": "of or like a stalactite, also STALACTITIC, STALACTITICAL [adj]\n",
  "STALACTICAL": "like a stalactite, also STALACTITAL [adj]\n",
  "STALACTIFORM": "shaped like a stalactite or icicle [adj]\n",
  "STALACTITAL": "like a stalactite, also STALACTICAL [adj]\n",
  "STALACTITE": "a roughly conical or icicle-shaped speleothem that hangs down from the roof of a cave [n -S]\n",
  "STALACTITED": "having stalactites [adj]\n",
  "STALACTITES": "STALACTITE, a roughly conical or icicle-shaped speleothem that hangs down from the roof of a cave [n]\n",
  "STALACTITIC": "of or like a stalactite, also STALACTIC, STALACTITICAL [adj]\n",
  "STALACTITICAL": "of or like a stalactite, also STALACTIC, STALACTITIC [adj STALACTITICALLY]\n",
  "STALACTITICALLY": "STALACTITICAL, of or like a stalactite, also STALACTIC, STALACTITIC [adv]\n",
  "STALACTITIFORM": "having the form of a stalactite [adj]\n",
  "STALACTITIOUS": "of or like a stalactite [adj]\n",
  "STALAG": "(German) a German camp for prisoners of war [n -S]\n",
  "STALAGMA": "a stalactite [n -S]\n",
  "STALAGMAS": "STALAGMA, a stalactite [n]\n",
  "STALAGMITE": "a roughly conical shaped speleothem that rises from the floor of a cave [n -S]\n",
  "STALAGMITES": "STALAGMITE, a roughly conical shaped speleothem that rises from the floor of a cave [n]\n",
  "STALAGMITIC": "of or like a stalagmite, also STALAGMITICAL [adj STALAGMITICALLY]\n",
  "STALAGMITICAL": "of or like a stalagmite, also STALAGMITIC [adj STALAGMITICALLY]\n",
  "STALAGMITICALLY": "STALAGMITICAL, of or like a stalagmite, also STALAGMITIC [adv]\n",
  "STALAGMOMETER": "instrument for measuring surface tension by drops [n -S]\n",
  "STALAGMOMETERS": "STALAGMOMETER, instrument for measuring surface tension by drops [n]\n",
  "STALAGMOMETRIES": "STALAGMOMETRY, measurement of surface tension by drops [n]\n",
  "STALAGMOMETRY": "measurement of surface tension by drops [n STALAGMOMETRIES]\n",
  "STALAGS": "STALAG, (German) a German camp for prisoners of war [n]\n",
  "STALE": "not fresh [adj STALER, STALEST, STALELY] / to become past its best [v STALED, STALING, STALES]\n",
  "STALED": "STALE, to become past its best [v]\n",
  "STALELY": "STALE, not fresh [adv]\n",
  "STALEMATE": "in chess, a situation where a player not actually in check has no possible legal move, resulting in a draw; an inglorious deadlock [n -S] / to subject to a stalemate [v STALEMATED, STALEMATING, STALEMATES]\n",
  "STALEMATED": "STALEMATE, to subject to a stalemate [v]\n",
  "STALEMATES": "STALEMATE, to subject to a stalemate [v]\n",
  "STALEMATING": "STALEMATE, to subject to a stalemate [v]\n",
  "STALENESS": "the state of being stale [n -ES]\n",
  "STALENESSES": "STALENESS, the state of being stale [n]\n",
  "STALER": "STALE, not fresh [adj]\n",
  "STALES": "STALE, to become past its best [v]\n",
  "STALEST": "STALE, not fresh [adj]\n",
  "STALING": "STALE, to become past its best [v]\n",
  "STALK": "to pursue stealthily [v -ED, -ING, -S]\n",
  "STALKED": "STALK, to pursue stealthily [v]\n",
  "STALKER": "one who stalks [n -S]\n",
  "STALKERS": "STALKER, one who stalks [n]\n",
  "STALKIER": "STALKY, long and slender [adj]\n",
  "STALKIEST": "STALKY, long and slender [adj]\n",
  "STALKILY": "STALKY, long and slender [adv]\n",
  "STALKINESS": "the quality of being stalky [n -ES]\n",
  "STALKINESSES": "STALKINESS, the quality of being stalky [n]\n",
  "STALKING": "the act of stalking [n -S]\n",
  "STALKINGS": "STALKING, the act of stalking [n]\n",
  "STALKLESS": "without a stalk [adj]\n",
  "STALKLIKE": "like a stalk [adj]\n",
  "STALKO": "(Irish) a gentleman without fortune or occupation [n STALKOES or STALKOS]\n",
  "STALKOES": "STALKO, (Irish) a gentleman without fortune or occupation [n]\n",
  "STALKOS": "STALKO, (Irish) a gentleman without fortune or occupation [n]\n",
  "STALKS": "STALK, to pursue stealthily [v]\n",
  "STALKY": "long and slender [adj STALKIER, STALKIEST, STALKILY]\n",
  "STALL": "to come to a standstill [v -ED, -ING, -S]\n",
  "STALLAGE": "rent paid for a market stall [n -S]\n",
  "STALLAGES": "STALLAGE, rent paid for a market stall [n]\n",
  "STALLED": "STALL, to come to a standstill [v]\n",
  "STALLENGER": "(historical) a keeper of a stall; a person who paid for the privilege of trading in a burgh of which he was not a freeman, also STALLINGER [n -S]\n",
  "STALLENGERS": "STALLENGER, (historical) a keeper of a stall; a person who paid for the privilege of trading in a burgh of which he was not a freeman, also STALLINGER [n]\n",
  "STALLHOLDER": "one who manages a stall at which articles are sold [n -S]\n",
  "STALLHOLDERS": "STALLHOLDER, one who manages a stall at which articles are sold [n]\n",
  "STALLING": "the act of stalling [n -S]\n",
  "STALLINGER": "(historical) a keeper of a stall; a person who paid for the privilege of trading in a burgh of which he was not a freeman, also STALLENGER [n -S]\n",
  "STALLINGERS": "STALLINGER, (historical) a keeper of a stall; a person who paid for the privilege of trading in a burgh of which he was not a freeman, also STALLENGER [n]\n",
  "STALLINGS": "STALLING, the act of stalling [n]\n",
  "STALLION": "an uncastrated male horse [n -S]\n",
  "STALLIONS": "STALLION, an uncastrated male horse [n]\n",
  "STALLMAN": "a keeper of a stall [n STALLMEN]\n",
  "STALLMASTER": "a master of horse [n -S]\n",
  "STALLMASTERS": "STALLMASTER, a master of horse [n]\n",
  "STALLMEN": "STALLMAN, a keeper of a stall [n]\n",
  "STALLS": "STALL, to come to a standstill [v]\n",
  "STALWART": "staunch, also STALWORTH [adj STALWARTLY] / a sturdy, persistent person [n -S]\n",
  "STALWARTLY": "STALWART, staunch, also STALWORTH [adv]\n",
  "STALWARTNESS": "the state of being stalwart [n -ES]\n",
  "STALWARTNESSES": "STALWARTNESS, the state of being stalwart [n]\n",
  "STALWARTS": "STALWART, a sturdy, persistent person [n]\n",
  "STALWORTH": "(archaic) stalwart [adj] / a stalwart person, also STALWART [n -S]\n",
  "STALWORTHS": "STALWORTH, a stalwart person, also STALWART [n]\n",
  "STAMEN": "(Latin) the male part of the flower, made up of a pollen-producing anther on a stalk [n -S]\n",
  "STAMENED": "having stamens [adj]\n",
  "STAMENS": "STAMEN, (Latin) the male part of the flower, made up of a pollen-producing anther on a stalk [n]\n",
  "STAMINA": "(Latin) sustained energy, staying power [n -S]\n",
  "STAMINAL": "relating to stamina [adj]\n",
  "STAMINAS": "STAMINA, (Latin) sustained energy, staying power [n]\n",
  "STAMINATE": "furnished with stamens; producing stamens [adj]\n",
  "STAMINEAL": "related to stamens, also STAMINEOUS [adj]\n",
  "STAMINEOUS": "related to stamens, also STAMINEAL [adj]\n",
  "STAMINIFEROUS": "bearing stamens [adj]\n",
  "STAMINODE": "a sterile stamen, also STAMINODIUM [n -S]\n",
  "STAMINODES": "STAMINODE, a sterile stamen, also STAMINODIUM [n]\n",
  "STAMINODIA": "STAMINODIUM, a sterile stamen, also STAMINODE [n]\n",
  "STAMINODIES": "STAMINODY, the transformation of a floral organ into a stamen [n]\n",
  "STAMINODIUM": "a sterile stamen, also STAMINODE [n STAMINODIA]\n",
  "STAMINODY": "the transformation of a floral organ into a stamen [n STAMINODIES]\n",
  "STAMINOID": "like, or metamorphosed into, a stamen [adj]\n",
  "STAMMEL": "(historical) a coarse woollen fabric, usually dyed red [n -S]\n",
  "STAMMELS": "STAMMEL, (historical) a coarse woollen fabric, usually dyed red [n]\n",
  "STAMMER": "to speak with involuntary breaks and pauses [v -ED, -ING, -S]\n",
  "STAMMERED": "STAMMER, to speak with involuntary breaks and pauses [v]\n",
  "STAMMERER": "one who stammers [n -S]\n",
  "STAMMERERS": "STAMMERER, one who stammers [n]\n",
  "STAMMERING": "hesitant [adj STAMMERINGLY] / the act of stammering [n -S]\n",
  "STAMMERINGLY": "STAMMERING, hesitant [adv]\n",
  "STAMMERINGS": "STAMMERING, the act of stammering [n]\n",
  "STAMMERS": "STAMMER, to speak with involuntary breaks and pauses [v]\n",
  "STAMNOI": "STAMNOS, (Greek) an ancient Greek short-necked jar [n]\n",
  "STAMNOS": "(Greek) an ancient Greek short-necked jar [n STAMNOI]\n",
  "STAMP": "to bring the foot down heavily [v -ED, -ING, -S]\n",
  "STAMPED": "STAMP, to bring the foot down heavily [v]\n",
  "STAMPEDE": "to send rushing in panic, also STAMPEDO [v STAMPEDED, STAMPEDING, STAMPEDES]\n",
  "STAMPEDED": "STAMPEDE, to send rushing in panic, also STAMPEDO [v]\n",
  "STAMPEDER": "one who stampedes [n -S]\n",
  "STAMPEDERS": "STAMPEDER, one who stampedes [n]\n",
  "STAMPEDES": "STAMPEDE, to send rushing in panic, also STAMPEDO [v]\n",
  "STAMPEDING": "STAMPEDE, to send rushing in panic, also STAMPEDO [v]\n",
  "STAMPEDO": "(obsolete) to stampede [v -ED, -ING, -S]\n",
  "STAMPEDOED": "STAMPEDO, (obsolete) to stampede [v]\n",
  "STAMPEDOING": "STAMPEDO, (obsolete) to stampede [v]\n",
  "STAMPEDOS": "STAMPEDO, (obsolete) to stampede [v]\n",
  "STAMPER": "one who stamps [n -S]\n",
  "STAMPERS": "STAMPER, one who stamps [n]\n",
  "STAMPING": "the act of stamping [n -S]\n",
  "STAMPINGS": "STAMPING, the act of stamping [n]\n",
  "STAMPLESS": "without a stamp [adj]\n",
  "STAMPS": "STAMP, to bring the foot down heavily [v]\n",
  "STANCE": "a manner of standing [n -S]\n",
  "STANCES": "STANCE, a manner of standing [n]\n",
  "STANCH": "firm, steadfast, also STAUNCH [adj STANCHER, STANCHEST, STANCHLY] / to stop the flowing of, as blood, also STAUNCH [v -ED, -ING, -ES]\n",
  "STANCHABLE": "that can be stanched, also STAUNCHABLE [adj]\n",
  "STANCHED": "STANCH, to stop the flowing of, as blood, also STAUNCH [v]\n",
  "STANCHEL": "an upright beam, bar or support, also STANCHER, STANCHION [n -S] / to support by a stanchel [v STANCHELLED, STANCHELLING, STANCHELS]\n",
  "STANCHELLED": "STANCHEL, to support by a stanchel [v]\n",
  "STANCHELLING": "STANCHEL, to support by a stanchel [v]\n",
  "STANCHELS": "STANCHEL, an upright beam, bar or support, also STANCHER, STANCHION [n]\n",
  "STANCHER": "an upright beam, bar or support [n -S] / to support by means of an iron bar, also STANCHEL, STANCHION [v -ED, -ING, -S]\n",
  "STANCHERED": "STANCHER, to support by means of an iron bar, also STANCHEL, STANCHION [v]\n",
  "STANCHERING": "STANCHER, to support by means of an iron bar, also STANCHEL, STANCHION [v]\n",
  "STANCHERS": "STANCHER, to support by means of an iron bar, also STANCHEL, STANCHION [v]\n",
  "STANCHES": "STANCH, to stop the flowing of, as blood, also STAUNCH [v]\n",
  "STANCHEST": "STANCH, firm, steadfast, also STAUNCH [adj]\n",
  "STANCHING": "the act of stanching [n -S]\n",
  "STANCHINGS": "STANCHING, the act of stanching [n]\n",
  "STANCHION": "an upright beam, bar or support [n -S] / to support by a stanchion, also STANCHEL, STANCHER [v -ED, -ING, -S]\n",
  "STANCHIONED": "STANCHION, to support by a stanchion, also STANCHEL, STANCHER [v]\n",
  "STANCHIONING": "STANCHION, to support by a stanchion, also STANCHEL, STANCHER [v]\n",
  "STANCHIONS": "STANCHION, an upright beam, bar or support [n]\n",
  "STANCHLESS": "(Shakespeare) that cannot be staunched [adj]\n",
  "STANCHLY": "STANCH, firm, steadfast, also STAUNCH [adv]\n",
  "STANCHNESS": "the state of being stanch [n -ES]\n",
  "STANCHNESSES": "STANCHNESS, the state of being stanch [n]\n",
  "STANCK": "(Spenser) faint, weary [adj]\n",
  "STAND": "to assume an upright position, also STAUN [v STOOD, STOODEN or STUDDEN, STANDING, STANDS, STANDEN]\n",
  "STANDARD": "conforming to the norm [adj STANDARDLY] / an established measure of comparison [n -S]\n",
  "STANDARDBRED": "any of a breed of trotting and pacing horses developed in the United States, noted for speed and stamina, and used esp. in harness racing [n -S]\n",
  "STANDARDBREDS": "STANDARDBRED, any of a breed of trotting and pacing horses developed in the United States, noted for speed and stamina, and used esp. in harness racing [n]\n",
  "STANDARDISATION": "the act of standardising, also STANDARDIZATION [n]\n",
  "STANDARDISE": "to make standard, also STANDARDIZE [v STANDARDISED, STANDARDISING, STANDARDISES]\n",
  "STANDARDISED": "STANDARDISE, to make standard, also STANDARDIZE [v]\n",
  "STANDARDISER": "one who standardises, also STANDARDIZER [n -S]\n",
  "STANDARDISERS": "STANDARDISER, one who standardises, also STANDARDIZER [n]\n",
  "STANDARDISES": "STANDARDISE, to make standard, also STANDARDIZE [v]\n",
  "STANDARDISING": "STANDARDISE, to make standard, also STANDARDIZE [v]\n",
  "STANDARDIZATION": "the act of standardizing, also STANDARDISATION [n]\n",
  "STANDARDIZE": "to make standard, also STANDARDISE [v STANDARDIZED, STANDARDIZING, STANDARDIZES]\n",
  "STANDARDIZED": "STANDARDIZE, to make standard, also STANDARDISE [v]\n",
  "STANDARDIZER": "one who standardizes, also STANDARDISER [n -S]\n",
  "STANDARDIZERS": "STANDARDIZER, one who standardizes, also STANDARDISER [n]\n",
  "STANDARDIZES": "STANDARDIZE, to make standard, also STANDARDISE [v]\n",
  "STANDARDIZING": "STANDARDIZE, to make standard, also STANDARDISE [v]\n",
  "STANDARDLESS": "without standards [adj]\n",
  "STANDARDLY": "STANDARD, conforming to the norm [adv]\n",
  "STANDARDS": "STANDARD, an established measure of comparison [n]\n",
  "STANDAWAY": "of a skirt, standing out from the body [adj]\n",
  "STANDBY": "one who can be relied on [n -S]\n",
  "STANDBYS": "STANDBY, one who can be relied on [n]\n",
  "STANDDOWN": "a return to normal after alert [n -S]\n",
  "STANDDOWNS": "STANDDOWN, a return to normal after alert [n]\n",
  "STANDEE": "one who stands because of lack of seats [n -S]\n",
  "STANDEES": "STANDEE, one who stands because of lack of seats [n]\n",
  "STANDEN": "(Spenser) to stand (no inflections) [v]\n",
  "STANDER": "one who stands [n -S]\n",
  "STANDERS": "STANDER, one who stands [n]\n",
  "STANDFAST": "a reliable person or thing [n -S]\n",
  "STANDFASTS": "STANDFAST, a reliable person or thing [n]\n",
  "STANDFIRST": "an introductory paragraph in an article, printed in larger or bolder type or in capitals, which summarizes the article [n -S]\n",
  "STANDFIRSTS": "STANDFIRST, an introductory paragraph in an article, printed in larger or bolder type or in capitals, which summarizes the article [n]\n",
  "STANDGALE": "a corrupt form of staniel, the kestrel, also STANIEL, STANNEL, STANYEL [n -S]\n",
  "STANDGALES": "STANDGALE, a corrupt form of staniel, the kestrel, also STANIEL, STANNEL, STANYEL [n]\n",
  "STANDING": "a position in society [n -S]\n",
  "STANDINGS": "STANDING, a position in society [n]\n",
  "STANDISH": "a receptacle for pens and ink [n -ES]\n",
  "STANDISHES": "STANDISH, a receptacle for pens and ink [n]\n",
  "STANDOFF": "a tie or a draw, in a game [n -S]\n",
  "STANDOFFISH": "somewhat cold and reserved [adj STANDOFFISHLY]\n",
  "STANDOFFISHLY": "STANDOFFISH, somewhat cold and reserved [adv]\n",
  "STANDOFFISHNESS": "the state of being standoffish [n]\n",
  "STANDOFFS": "STANDOFF, a tie or a draw, in a game [n]\n",
  "STANDOUT": "one that shows marked superiority [n -S]\n",
  "STANDOUTS": "STANDOUT, one that shows marked superiority [n]\n",
  "STANDOVER": "a threatening or intimidating act [n -S]\n",
  "STANDOVERS": "STANDOVER, a threatening or intimidating act [n]\n",
  "STANDPAT": "resisting or opposing change [adj]\n",
  "STANDPATTER": "(US) one who refuses to accept or consider political change [n -S]\n",
  "STANDPATTERS": "STANDPATTER, (US) one who refuses to accept or consider political change [n]\n",
  "STANDPATTISM": "the practice of refusing to consider change in one's beliefs and opinions, esp. in politics [n -S]\n",
  "STANDPATTISMS": "STANDPATTISM, the practice of refusing to consider change in one's beliefs and opinions, esp. in politics [n]\n",
  "STANDPIPE": "a pipe for supplying water [n -S]\n",
  "STANDPIPES": "STANDPIPE, a pipe for supplying water [n]\n",
  "STANDPOINT": "a position from which objects or principles are viewed and according to which they are compared and judged [n -S]\n",
  "STANDPOINTS": "STANDPOINT, a position from which objects or principles are viewed and according to which they are compared and judged [n]\n",
  "STANDS": "STAND, to assume an upright position, also STAUN [v]\n",
  "STANDSTILL": "a state characterized by absence of motion or of progress [n -S]\n",
  "STANDSTILLS": "STANDSTILL, a state characterized by absence of motion or of progress [n]\n",
  "STANDUP": "having an upright position [adj] / a standup comedian [n -S]\n",
  "STANDUPS": "STANDUP, a standup comedian [n]\n",
  "STANE": "(Scots) to stone [v STANED, STANING, STANES]\n",
  "STANED": "STANE, (Scots) to stone [v]\n",
  "STANES": "STANE, (Scots) to stone [v]\n",
  "STANG": "(Scots) to sting [v -ED, -ING, -S]\n",
  "STANGED": "STANG, (Scots) to sting [v]\n",
  "STANGING": "STANG, (Scots) to sting [v]\n",
  "STANGS": "STANG, (Scots) to sting [v]\n",
  "STANHOPE": "a light, open carriage [n -S]\n",
  "STANHOPES": "STANHOPE, a light, open carriage [n]\n",
  "STANIEL": "the kestrel, also STANDGALE, STANNEL, STANYEL [n -S]\n",
  "STANIELS": "STANIEL, the kestrel, also STANDGALE, STANNEL, STANYEL [n]\n",
  "STANINE": "a nine-point scale on which test scores can be grouped in descending order of achievement, first developed by the US Air Force [n -S]\n",
  "STANINES": "STANINE, a nine-point scale on which test scores can be grouped in descending order of achievement, first developed by the US Air Force [n]\n",
  "STANING": "STANE, (Scots) to stone [v]\n",
  "STANK": "(Scots) to dam [v -ED, -ING, -S]\n",
  "STANKED": "STANK, (Scots) to dam [v]\n",
  "STANKING": "STANK, (Scots) to dam [v]\n",
  "STANKS": "STANK, (Scots) to dam [v]\n",
  "STANNARIES": "STANNARY, a tin-mining region [n]\n",
  "STANNARY": "a tin-mining region [n STANNARIES]\n",
  "STANNATE": "a salt of stannic acid [n -S]\n",
  "STANNATES": "STANNATE, a salt of stannic acid [n]\n",
  "STANNATOR": "one of the members of the Stannary Parliament [n -S]\n",
  "STANNATORS": "STANNATOR, one of the members of the Stannary Parliament [n]\n",
  "STANNEL": "the kestrel, also STANDGALE, STANIEL, STANYEL [n -S]\n",
  "STANNELS": "STANNEL, the kestrel, also STANDGALE, STANIEL, STANYEL [n]\n",
  "STANNIC": "as in stannic acid, an acid containing tin its its quadrivalent state [adj]\n",
  "STANNIFEROUS": "bearing tin [adj]\n",
  "STANNITE": "an ore of tin [n -S]\n",
  "STANNITES": "STANNITE, an ore of tin [n]\n",
  "STANNOTYPE": "a photograph taken upon a tin plate [n -S]\n",
  "STANNOTYPES": "STANNOTYPE, a photograph taken upon a tin plate [n]\n",
  "STANNOUS": "of bivalent tin [adj]\n",
  "STANNUM": "(Latin) the technical name of tin [n -S]\n",
  "STANNUMS": "STANNUM, (Latin) the technical name of tin [n]\n",
  "STANOL": "a drug taken to prevent heart disease [n -S]\n",
  "STANOLS": "STANOL, a drug taken to prevent heart disease [n]\n",
  "STANYEL": "the kestrel, also STANDGALE, STANIEL, STANNEL [n -S]\n",
  "STANYELS": "STANYEL, the kestrel, also STANDGALE, STANIEL, STANNEL [n]\n",
  "STANZA": "a division of a poem, also STANZE, STANZO [n -S]\n",
  "STANZAED": "having a stanza [adj]\n",
  "STANZAIC": "pertaining to, or consisting of, stanzas [adj]\n",
  "STANZAS": "STANZA, a division of a poem, also STANZE, STANZO [n]\n",
  "STANZE": "(Shakespeare) a stanza, also STANZO [n -S]\n",
  "STANZES": "STANZE, (Shakespeare) a stanza, also STANZO [n]\n",
  "STANZO": "(Shakespeare) a stanza, also STANZE [n -ES or -S]\n",
  "STANZOES": "STANZO, (Shakespeare) a stanza, also STANZE [n]\n",
  "STANZOS": "STANZO, (Shakespeare) a stanza, also STANZE [n]\n",
  "STAP": "(Scots) to stuff, thrust, cram [v STAPPED, STAPPING, STAPS]\n",
  "STAPEDECTOMIES": "STAPEDECTOMY, the removal of the stapes and insertion of an artificial replacement to relieve deafness [n]\n",
  "STAPEDECTOMY": "the removal of the stapes and insertion of an artificial replacement to relieve deafness [n STAPEDECTOMIES]\n",
  "STAPEDES": "STAPES, (Latin) a bone of the middle ear [n]\n",
  "STAPEDIAL": "of or pertaining to the stapes, the stirrup-shaped bone of the ear [adj]\n",
  "STAPEDII": "STAPEDIUS, the muscle of the middle ear [n]\n",
  "STAPEDIUS": "the muscle of the middle ear [n STAPEDIUSES or STAPEDII]\n",
  "STAPEDIUSES": "STAPEDIUS, the muscle of the middle ear [n]\n",
  "STAPELIA": "any of various succulent southern African plants constituting the genus Stapelia [n -S]\n",
  "STAPELIAS": "STAPELIA, any of various succulent southern African plants constituting the genus Stapelia [n]\n",
  "STAPES": "(Latin) a bone of the middle ear [n STAPEDES]\n",
  "STAPH": "any of various spherical bacteria [n -S]\n",
  "STAPHS": "STAPH, any of various spherical bacteria [n]\n",
  "STAPHYLINE": "like a bunch of grapes [adj]\n",
  "STAPHYLINID": "a kind of beetle aka rove beetle [n -S]\n",
  "STAPHYLINIDS": "STAPHYLINID, a kind of beetle aka rove beetle [n]\n",
  "STAPHYLITIS": "inflammation of the uvula [n -ES]\n",
  "STAPHYLITISES": "STAPHYLITIS, inflammation of the uvula [n]\n",
  "STAPHYLOCOCCAL": "relating to staphylococci [adj]\n",
  "STAPHYLOCOCCI": "STAPHYLOCOCCUS, a bacteria causing infection in wounds etc. [n]\n",
  "STAPHYLOCOCCIC": "relating to staphylococci [adj]\n",
  "STAPHYLOCOCCUS": "a bacteria causing infection in wounds etc. [n STAPHYLOCOCCI]\n",
  "STAPHYLOMA": "a protrusion of any part of the globe of the eye; as, a staphyloma of the cornea [n STAPHYLOMAS or STAPHYLOMATA]\n",
  "STAPHYLOMAS": "STAPHYLOMA, a protrusion of any part of the globe of the eye; as, a staphyloma of the cornea [n]\n",
  "STAPHYLOMATA": "STAPHYLOMA, a protrusion of any part of the globe of the eye; as, a staphyloma of the cornea [n]\n",
  "STAPHYLOPLASTIC": "relating to staphyloplasty, plastic surgery involving the soft palate and the uvula [adj]\n",
  "STAPHYLOPLASTY": "plastic surgery involving the soft palate and the uvula [n]\n",
  "STAPHYLORRHAPHY": "the operation of uniting a cleft palate [n]\n",
  "STAPLE": "to fasten with a U-shaped metal clip [v STAPLED, STAPLING, STAPLES]\n",
  "STAPLED": "STAPLE, to fasten with a U-shaped metal clip [v]\n",
  "STAPLER": "a stapling machine [n -S]\n",
  "STAPLERS": "STAPLER, a stapling machine [n]\n",
  "STAPLES": "STAPLE, to fasten with a U-shaped metal clip [v]\n",
  "STAPLING": "the act of fastening with a U-shaped metal clip [n -S]\n",
  "STAPLINGS": "STAPLING, the act of fastening with a U-shaped metal clip [n]\n",
  "STAPPED": "STAP, (Scots) to stuff, thrust, cram [v]\n",
  "STAPPING": "STAP, (Scots) to stuff, thrust, cram [v]\n",
  "STAPPLE": "the stem of a tobacco pipe [n -S]\n",
  "STAPPLES": "STAPPLE, the stem of a tobacco pipe [n]\n",
  "STAPS": "STAP, (Scots) to stuff, thrust, cram [v]\n",
  "STAR": "to shine as an actor or singer [v STARRED, STARRING, STARS]\n",
  "STARAGEN": "(obsolete) the tarragon plant, also ESTRAGON [n -S]\n",
  "STARAGENS": "STARAGEN, (obsolete) the tarragon plant, also ESTRAGON [n]\n",
  "STARBOARD": "the right-hand side of a ship [n -S] / to put or turn (the helm) to the starboard side of the vessel [v -ED, -ING, -S]\n",
  "STARBOARDED": "STARBOARD, to put or turn (the helm) to the starboard side of the vessel [v]\n",
  "STARBOARDING": "STARBOARD, to put or turn (the helm) to the starboard side of the vessel [v]\n",
  "STARBOARDS": "STARBOARD, to put or turn (the helm) to the starboard side of the vessel [v]\n",
  "STARBURST": "a pattern of rays or lines emanating from a light source [n -S]\n",
  "STARBURSTS": "STARBURST, a pattern of rays or lines emanating from a light source [n]\n",
  "STARCH": "to stiffen a fabric [v -ED, -ING, -ES]\n",
  "STARCHED": "STARCH, to stiffen a fabric [v]\n",
  "STARCHEDLY": "STARCHED, STARCH, to stiffen a fabric [adv]\n",
  "STARCHEDNESS": "the state of being starched [n -ES]\n",
  "STARCHEDNESSES": "STARCHEDNESS, the state of being starched [n]\n",
  "STARCHER": "one who starches [n -S]\n",
  "STARCHERS": "STARCHER, one who starches [n]\n",
  "STARCHES": "STARCH, to stiffen a fabric [v]\n",
  "STARCHIER": "STARCHY, containing starch [adj]\n",
  "STARCHIEST": "STARCHY, containing starch [adj]\n",
  "STARCHILY": "STARCHY, containing starch [adv]\n",
  "STARCHINESS": "the state of being starchy [n -ES]\n",
  "STARCHINESSES": "STARCHINESS, the state of being starchy [n]\n",
  "STARCHING": "STARCH, to stiffen a fabric [v]\n",
  "STARCHLIKE": "like starch [adj]\n",
  "STARCHY": "containing starch [adj STARCHIER, STARCHIEST, STARCHILY]\n",
  "STARDOM": "the status of a top performer [n -S]\n",
  "STARDOMS": "STARDOM, the status of a top performer [n]\n",
  "STARDRIFT": "a common proper motion of a number of stars in the same region [n -S]\n",
  "STARDRIFTS": "STARDRIFT, a common proper motion of a number of stars in the same region [n]\n",
  "STARDUST": "cosmic dust, meteoric matter in fine particles [n -S]\n",
  "STARDUSTS": "STARDUST, cosmic dust, meteoric matter in fine particles [n]\n",
  "STARE": "to gaze fixedly [v STARED, STARING, STARES]\n",
  "STARED": "STARE, to gaze fixedly [v]\n",
  "STARER": "one who stares [n -S]\n",
  "STARERS": "STARER, one who stares [n]\n",
  "STARES": "STARE, to gaze fixedly [v]\n",
  "STARETS": "(Russian) a spiritual adviser in the Eastern Orthodox Church, also STARETZ [n STARETSES or STARTSY]\n",
  "STARETSES": "STARETS, (Russian) a spiritual adviser in the Eastern Orthodox Church, also STARETZ [n]\n",
  "STARETZ": "(Russian) an Eastern Orthodox spiritual advisor, also STARETS [n -ES]\n",
  "STARETZES": "STARETZ, (Russian) an Eastern Orthodox spiritual advisor, also STARETS [n]\n",
  "STARFISH": "a star-shaped marine animal [n -ES]\n",
  "STARFISHED": "spreadeagled [adj]\n",
  "STARFISHES": "STARFISH, a star-shaped marine animal [n]\n",
  "STARFLOWER": "any of several plants having star-shaped pentamerous flowers [n -S]\n",
  "STARFLOWERS": "STARFLOWER, any of several plants having star-shaped pentamerous flowers [n]\n",
  "STARFRUIT": "a flower, the Star of Bethlehem [n -S]\n",
  "STARFRUITS": "STARFRUIT, a flower, the Star of Bethlehem [n]\n",
  "STARFUCKER": "(vulgar) a person who seeks to have sexual relations with celebrities [n -S]\n",
  "STARFUCKERS": "STARFUCKER, (vulgar) a person who seeks to have sexual relations with celebrities [n]\n",
  "STARFUCKING": "(vulgar) having sexual relations with celebrities [n -S]\n",
  "STARFUCKINGS": "STARFUCKING, (vulgar) having sexual relations with celebrities [n]\n",
  "STARGAZE": "to gaze at the stars [v STARGAZED, STARGAZING, STARGAZES]\n",
  "STARGAZED": "STARGAZE, to gaze at the stars [v]\n",
  "STARGAZER": "any of various marine bony fishes [n -S]\n",
  "STARGAZERS": "STARGAZER, any of various marine bony fishes [n]\n",
  "STARGAZES": "STARGAZE, to gaze at the stars [v]\n",
  "STARGAZEY": "as in stargazey pie, a savoury Cornish fish pie in which whole fish are baked in pastry with their heads protruding through the crust [adj]\n",
  "STARGAZING": "observation of the stars [n -S]\n",
  "STARGAZINGS": "STARGAZING, observation of the stars [n]\n",
  "STARING": "looking fixedly [adj STARINGLY] / the act of staring [n -S]\n",
  "STARINGLY": "STARING, looking fixedly [adv]\n",
  "STARINGS": "STARING, the act of staring [n]\n",
  "STARK": "stern, harsh [adj STARKER, STARKEST, STARKLY] / to stiffen [v -ED, -ING, -S]\n",
  "STARKED": "STARK, to stiffen [v]\n",
  "STARKEN": "to make or become stark [v -ED, -ING, -S]\n",
  "STARKENED": "STARKEN, to make or become stark [v]\n",
  "STARKENING": "STARKEN, to make or become stark [v]\n",
  "STARKENS": "STARKEN, to make or become stark [v]\n",
  "STARKER": "STARK, stern, harsh [adj]\n",
  "STARKERS": "(colloquial) naked [adj]\n",
  "STARKEST": "STARK, stern, harsh [adj]\n",
  "STARKING": "STARK, to stiffen [v]\n",
  "STARKLY": "STARK, stern, harsh [adv]\n",
  "STARKNESS": "the state of being stark [n -ES]\n",
  "STARKNESSES": "STARKNESS, the state of being stark [n]\n",
  "STARKS": "STARK, to stiffen [v]\n",
  "STARLESS": "without stars [adj]\n",
  "STARLET": "a minor showbiz personality [n -S]\n",
  "STARLETS": "STARLET, a minor showbiz personality [n]\n",
  "STARLIGHT": "the light of stars [n -S]\n",
  "STARLIGHTED": "lighted by the stars, also STARLIT [adj]\n",
  "STARLIGHTS": "STARLIGHT, the light of stars [n]\n",
  "STARLIKE": "like a star [adj]\n",
  "STARLING": "a European bird [n -S]\n",
  "STARLINGS": "STARLING, a European bird [n]\n",
  "STARLIT": "lighted by the stars, also STARLIGHTED [adj]\n",
  "STARMONGER": "a fortune teller; an astrologer [n -S]\n",
  "STARMONGERS": "STARMONGER, a fortune teller; an astrologer [n]\n",
  "STARN": "to row backwards, also STERN [v -ED, -ING, -S]\n",
  "STARNED": "STARN, to row backwards, also STERN [v]\n",
  "STARNIE": "(Scots) a small star [n -S]\n",
  "STARNIES": "STARNIE, (Scots) a small star [n]\n",
  "STARNING": "STARN, to row backwards, also STERN [v]\n",
  "STARNOSE": "a curious American mole having the nose expanded at the end into a stellate disk [n -S]\n",
  "STARNOSES": "STARNOSE, a curious American mole having the nose expanded at the end into a stellate disk [n]\n",
  "STARNS": "STARN, to row backwards, also STERN [v]\n",
  "STAROSTA": "(Russian) a village headman; a Polish noble holding a starosty or domain bestowed by the crown [n -S]\n",
  "STAROSTAS": "STAROSTA, (Russian) a village headman; a Polish noble holding a starosty or domain bestowed by the crown [n]\n",
  "STAROSTIES": "STAROSTY, (Russian) a domain bestowed by the crown [n]\n",
  "STAROSTY": "(Russian) a domain bestowed by the crown [n STAROSTIES]\n",
  "STARR": "(Hebrew) a Jewish deed or bond, e.g. of acquittance of a debt [n -S]\n",
  "STARRED": "STAR, to shine as an actor or singer [v]\n",
  "STARRIER": "STARRY, abounding with stars [adj]\n",
  "STARRIEST": "STARRY, abounding with stars [adj]\n",
  "STARRILY": "STARRY, abounding with stars [adv]\n",
  "STARRINESS": "the state of being starry [n -ES]\n",
  "STARRINESSES": "STARRINESS, the state of being starry [n]\n",
  "STARRING": "the act of starring [n -S]\n",
  "STARRINGS": "STARRING, the act of starring [n]\n",
  "STARRS": "STARR, (Hebrew) a Jewish deed or bond, e.g. of acquittance of a debt [n]\n",
  "STARRY": "abounding with stars [adj STARRIER, STARRIEST, STARRILY]\n",
  "STARS": "STAR, to shine as an actor or singer [v]\n",
  "STARSHINE": "the light of stars [n -S]\n",
  "STARSHINES": "STARSHINE, the light of stars [n]\n",
  "STARSHIP": "a spaceship for interstellar travel [n -S]\n",
  "STARSHIPS": "STARSHIP, a spaceship for interstellar travel [n]\n",
  "STARSPOT": "an area of darkness on a star [n -S]\n",
  "STARSPOTS": "STARSPOT, an area of darkness on a star [n]\n",
  "STARSTONE": "asteriated sapphire [n -S]\n",
  "STARSTONES": "STARSTONE, asteriated sapphire [n]\n",
  "STARSTRUCK": "particularly taken with celebrities (as movie stars) [adj]\n",
  "START": "to begin, set out [v -ED, -ING, -S]\n",
  "STARTED": "START, to begin, set out [v]\n",
  "STARTER": "one who starts [n -S]\n",
  "STARTERS": "STARTER, one who starts [n]\n",
  "STARTFUL": "of a horse, apt to start, also STARTISH, STARTLISH, STARTLY [adj]\n",
  "STARTING": "beginning [adj STARTINGLY] / the act of starting [n -S]\n",
  "STARTINGLY": "(Shakespeare) in fits and starts [adv]\n",
  "STARTINGS": "STARTING, the act of starting [n]\n",
  "STARTISH": "of a horse, apt to start, also STARTFUL, STARTLISH, STARTLY [adj]\n",
  "STARTLE": "to frighten or surprise [v STARTLED, STARTLING, STARTLES]\n",
  "STARTLED": "STARTLE, to frighten or surprise [v]\n",
  "STARTLEMENT": "the state of being startled [n -S]\n",
  "STARTLEMENTS": "STARTLEMENT, the state of being startled [n]\n",
  "STARTLER": "one who startles [n -S]\n",
  "STARTLERS": "STARTLER, one who startles [n]\n",
  "STARTLES": "STARTLE, to frighten or surprise [v]\n",
  "STARTLIER": "STARTLY, of a horse, apt to start, also STARTFUL, STARTISH, STARTLISH [adj]\n",
  "STARTLIEST": "STARTLY, of a horse, apt to start, also STARTFUL, STARTISH, STARTLISH [adj]\n",
  "STARTLING": "very surprising [adj STARTLINGLY] / the act of startling [n -S]\n",
  "STARTLINGLY": "STARTLING, very surprising [adv]\n",
  "STARTLINGS": "STARTLING, the act of startling [n]\n",
  "STARTLISH": "of a horse, apt to start, also STARTFUL, STARTISH, STARTLY [adj]\n",
  "STARTLY": "of a horse, apt to start, also STARTFUL, STARTISH, STARTLISH [adj STARTLIER, STARTLIEST]\n",
  "STARTS": "START, to begin, set out [v]\n",
  "STARTSY": "STARETS, (Russian) a spiritual adviser in the Eastern Orthodox Church, also STARETZ [n]\n",
  "STARTUP": "the act of starting something [n -S]\n",
  "STARTUPS": "STARTUP, the act of starting something [n]\n",
  "STARVATION": "the act or an instance of starving [n -S]\n",
  "STARVATIONS": "STARVATION, the act or an instance of starving [n]\n",
  "STARVE": "to die from lack of food [v STARVED, STARVING, STARVES]\n",
  "STARVED": "STARVE, to die from lack of food [v]\n",
  "STARVELING": "a starving, weak, hungry or pining person [n -S]\n",
  "STARVELINGS": "STARVELING, a starving, weak, hungry or pining person [n]\n",
  "STARVER": "one who starves [n -S]\n",
  "STARVERS": "STARVER, one who starves [n]\n",
  "STARVES": "STARVE, to die from lack of food [v]\n",
  "STARVING": "the act of starving [n -S]\n",
  "STARVINGS": "STARVING, the act of starving [n]\n",
  "STARWORT": "any plant of the genus Aster [n -S]\n",
  "STARWORTS": "STARWORT, any plant of the genus Aster [n]\n",
  "STASES": "STASIS, a stoppage of the normal flow of bodily fluids [n]\n",
  "STASH": "to store in a secret place [v -ED, -ING, -ES]\n",
  "STASHED": "STASH, to store in a secret place [v]\n",
  "STASHES": "STASH, to store in a secret place [v]\n",
  "STASHIE": "(Scots) fuss, ado, disturbance, also STISHIE, STOOSHIE, STOUSHIE, STUSHIE [n -S]\n",
  "STASHIES": "STASHIE, (Scots) fuss, ado, disturbance, also STISHIE, STOOSHIE, STOUSHIE, STUSHIE [n]\n",
  "STASHING": "STASH, to store in a secret place [v]\n",
  "STASIDION": "(Modern Greek) a stall in a Greek church [n -S]\n",
  "STASIDIONS": "STASIDION, (Modern Greek) a stall in a Greek church [n]\n",
  "STASIMA": "STASIMON, (Greek) a choral ode in an ancient Greek drama [n]\n",
  "STASIMON": "(Greek) a choral ode in an ancient Greek drama [n STASIMA]\n",
  "STASIMORPHIES": "STASIMORPHY, structural modification by arrested development [n]\n",
  "STASIMORPHY": "structural modification by arrested development [n STASIMORPHIES]\n",
  "STASIS": "a stoppage of the normal flow of bodily fluids [n STASES]\n",
  "STAT": "(short for) a statistic [n -S]\n",
  "STATABLE": "capable of being stated [adj]\n",
  "STATAL": "of a passive verbal form, expressing a state or condition rather than an action [adj]\n",
  "STATANT": "in heraldry, standing with all feet on the ground [adj]\n",
  "STATE": "to set forth in words [v STATED, STATING, STATES]\n",
  "STATEABLE": "that can be stated, also STATABLE [adj]\n",
  "STATECRAFT": "the art of conducting state affairs [n -S]\n",
  "STATECRAFTS": "STATECRAFT, the art of conducting state affairs [n]\n",
  "STATED": "STATE, to set forth in words [v]\n",
  "STATEDLY": "at stated times; regularly [adv]\n",
  "STATEHOOD": "the status of a state [n -S]\n",
  "STATEHOODS": "STATEHOOD, the status of a state [n]\n",
  "STATEHOUSE": "the building in which a State legislature holds its sessions [n -S]\n",
  "STATEHOUSES": "STATEHOUSE, the building in which a State legislature holds its sessions [n]\n",
  "STATELESS": "without a state [adj]\n",
  "STATELESSNESS": "the condition of being stateless [n -ES]\n",
  "STATELESSNESSES": "STATELESSNESS, the condition of being stateless [n]\n",
  "STATELET": "a small political state [n -S]\n",
  "STATELETS": "STATELET, a small political state [n]\n",
  "STATELIER": "STATELY, dignified [adj]\n",
  "STATELIEST": "STATELY, dignified [adj]\n",
  "STATELILY": "STATELY, dignified [adv]\n",
  "STATELINESS": "the state of being stately [n -ES]\n",
  "STATELINESSES": "STATELINESS, the state of being stately [n]\n",
  "STATELY": "dignified [adj STATELIER, STATELIEST, STATELILY]\n",
  "STATEMENT": "something said formally [n -S] / to take a statement [v -ED, -ING, -S]\n",
  "STATEMENTED": "STATEMENT, to take a statement [v]\n",
  "STATEMENTING": "the process of taking a statement [n -S]\n",
  "STATEMENTINGS": "STATEMENTING, the process of taking a statement [n]\n",
  "STATEMENTS": "STATEMENT, to take a statement [v]\n",
  "STATER": "(Greek) an ancient Greek coin [n -S]\n",
  "STATEROOM": "a private cabin or room on a ship, train, etc.; a large room in a palace or other building for use on state occasions [n -S]\n",
  "STATEROOMS": "STATEROOM, a private cabin or room on a ship, train, etc.; a large room in a palace or other building for use on state occasions [n]\n",
  "STATERS": "STATER, (Greek) an ancient Greek coin [n]\n",
  "STATES": "STATE, to set forth in words [v]\n",
  "STATESIDE": "of, in, or pertaining to the United States of America [adj]\n",
  "STATESMAN": "a person who takes an important part in governing the state [n STATESMEN]\n",
  "STATESMANLIER": "STATESMANLY, like a statesman [adj]\n",
  "STATESMANLIEST": "STATESMANLY, like a statesman [adj]\n",
  "STATESMANLIKE": "like a statesman [adj]\n",
  "STATESMANLY": "like a statesman [adj STATESMANLIER, STATESMANLIEST]\n",
  "STATESMANSHIP": "the skills of the statesman [n -S]\n",
  "STATESMANSHIPS": "STATESMANSHIP, the skills of the statesman [n]\n",
  "STATESMEN": "STATESMAN, a person who takes an important part in governing the state [n]\n",
  "STATESPERSON": "a statesman or stateswoman [n -S]\n",
  "STATESPERSONS": "STATESPERSON, a statesman or stateswoman [n]\n",
  "STATESWOMAN": "a female statesman [n STATESWOMEN]\n",
  "STATESWOMEN": "STATESWOMAN, a female statesman [n]\n",
  "STATEWIDE": "throughout a state [adj]\n",
  "STATIC": "not moving, also STATICAL [adj STATICALLY] / random noise produced in a radio or television receiver [n -S]\n",
  "STATICAL": "relating to statics, the science of forces in equilibrium, also STATIC [adj STATICALLY]\n",
  "STATICALLY": "STATICAL, relating to statics, the science of forces in equilibrium, also STATIC [adv]\n",
  "STATICE": "(Latin) the flower sea lavender [n -S]\n",
  "STATICES": "STATICE, (Latin) the flower sea lavender [n]\n",
  "STATICKIER": "STATICKY, marked by static [adj]\n",
  "STATICKIEST": "STATICKY, marked by static [adj]\n",
  "STATICKY": "marked by static [adj STATICKIER, STATICKIEST]\n",
  "STATICS": "the science of forces in equilibrium [n]\n",
  "STATIM": "(Latin) immediately; at once [adv]\n",
  "STATIN": "a type of drug that lowers the level of lipoproteins in the blood [n -S]\n",
  "STATING": "STATE, to set forth in words [v]\n",
  "STATINS": "STATIN, a type of drug that lowers the level of lipoproteins in the blood [n]\n",
  "STATION": "to assign to a position [v -ED, -ING, -S]\n",
  "STATIONAL": "of or pertaining to a station or stations [adj]\n",
  "STATIONARIES": "STATIONARY, something fixed [n]\n",
  "STATIONARILY": "STATIONARY, fixed in a station, course, or mode [adv]\n",
  "STATIONARINESS": "the state of being stationary [n]\n",
  "STATIONARY": "fixed in a station, course, or mode [adj STATIONARILY] / something fixed [n STATIONARIES]\n",
  "STATIONED": "STATION, to assign to a position [v]\n",
  "STATIONER": "one who sells stationery [n -S]\n",
  "STATIONERIES": "STATIONERY, materials (as paper, pens, and ink) for writing or typing [n]\n",
  "STATIONERS": "STATIONER, one who sells stationery [n]\n",
  "STATIONERY": "materials (as paper, pens, and ink) for writing or typing [n STATIONERIES]\n",
  "STATIONING": "STATION, to assign to a position [v]\n",
  "STATIONMASTER": "an official in charge of the operation of a railroad station [n -S]\n",
  "STATIONMASTERS": "STATIONMASTER, an official in charge of the operation of a railroad station [n]\n",
  "STATIONS": "STATION, to assign to a position [v]\n",
  "STATISM": "a theory of government [n -S]\n",
  "STATISMS": "STATISM, a theory of government [n]\n",
  "STATIST": "a statesman; a politician [n -S]\n",
  "STATISTIC": "a tabulated numerical fact [n -S]\n",
  "STATISTICAL": "relating to statistics [adj STATISTICALLY]\n",
  "STATISTICALLY": "STATISTICAL, relating to statistics [adv]\n",
  "STATISTICIAN": "one versed in or engaged in compiling statistics [n -S]\n",
  "STATISTICIANS": "STATISTICIAN, one versed in or engaged in compiling statistics [n]\n",
  "STATISTICS": "STATISTIC, a tabulated numerical fact [n]\n",
  "STATISTS": "STATIST, a statesman; a politician [n]\n",
  "STATIVE": "a verb indicating a state rather than an action [n -S]\n",
  "STATIVES": "STATIVE, a verb indicating a state rather than an action [n]\n",
  "STATOBLAST": "a reproductive body on bryozoans [n -S]\n",
  "STATOBLASTS": "STATOBLAST, a reproductive body on bryozoans [n]\n",
  "STATOCYST": "an organ of balance in some invertebrates [n -S]\n",
  "STATOCYSTS": "STATOCYST, an organ of balance in some invertebrates [n]\n",
  "STATOLATRIES": "STATOLATRY, the act or practice of idolizing the state [n]\n",
  "STATOLATRY": "the act or practice of idolizing the state [n STATOLATRIES]\n",
  "STATOLITH": "a small calcareous stone used by invertebrates to maintain equilibrium [n -S]\n",
  "STATOLITHIC": "of or like a statolith [adj]\n",
  "STATOLITHS": "STATOLITH, a small calcareous stone used by invertebrates to maintain equilibrium [n]\n",
  "STATOR": "a part of a machine about which the rotor revolves [n -S]\n",
  "STATORS": "STATOR, a part of a machine about which the rotor revolves [n]\n",
  "STATOSCOPE": "an instrument for measuring small changes in atmospheric pressure [n -S]\n",
  "STATOSCOPES": "STATOSCOPE, an instrument for measuring small changes in atmospheric pressure [n]\n",
  "STATS": "STAT, (short for) a statistic [n]\n",
  "STATTO": "(colloquial) a person who is preoccupied with the facts and figures of a particular subject, esp. a sport [n -S]\n",
  "STATTOS": "STATTO, (colloquial) a person who is preoccupied with the facts and figures of a particular subject, esp. a sport [n]\n",
  "STATUA": "(obsolete) a statue [n -S]\n",
  "STATUARIES": "STATUARY, a group of statues [n]\n",
  "STATUARY": "a group of statues [n STATUARIES]\n",
  "STATUAS": "STATUA, (obsolete) a statue [n]\n",
  "STATUE": "a three-dimensional work or art [n -S]\n",
  "STATUED": "having a statue [adj]\n",
  "STATUES": "STATUE, a three-dimensional work or art [n]\n",
  "STATUESQUE": "tall and well-proportioned in figure [adj STATUESQUELY]\n",
  "STATUESQUELY": "STATUESQUE, tall and well-proportioned in figure [adv]\n",
  "STATUESQUENESS": "the state of being statuesque [n]\n",
  "STATUETTE": "a small statue [n -S]\n",
  "STATUETTES": "STATUETTE, a small statue [n]\n",
  "STATURE": "the natural height of a human or animal body [n -S]\n",
  "STATURED": "sculptured [adj]\n",
  "STATURES": "STATURE, the natural height of a human or animal body [n]\n",
  "STATUS": "(Latin) a state of affairs; condition [n -ES]\n",
  "STATUSES": "STATUS, (Latin) a state of affairs; condition [n]\n",
  "STATUSIER": "STATUSY, having status [adj]\n",
  "STATUSIEST": "STATUSY, having status [adj]\n",
  "STATUSY": "having status [adj STATUSIER, STATUSIEST]\n",
  "STATUTABLE": "made or introduced by statute [adj STATUTABLY]\n",
  "STATUTABLY": "STATUTABLE, made or introduced by statute [adv]\n",
  "STATUTE": "a law enacted by the legislative branch of a government [n -S]\n",
  "STATUTES": "STATUTE, a law enacted by the legislative branch of a government [n]\n",
  "STATUTORILY": "STATUTORY, of or related to statute [adv]\n",
  "STATUTORY": "of or related to statute [adj STATUTORILY]\n",
  "STAUMREL": "a dolt [n -S]\n",
  "STAUMRELS": "STAUMREL, a dolt [n]\n",
  "STAUN": "(Scots) to stand [v STUDE, STAUNING, STAUNS]\n",
  "STAUNCH": "firm, steadfast, also STANCH [adj STAUNCHER, STAUNCHEST, STAUNCHLY] / to stop the flowing of, as blood, also STANCH [v -ED, -ING, -ES]\n",
  "STAUNCHABLE": "that can be staunched, also STANCHABLE [adj]\n",
  "STAUNCHED": "STAUNCH, to stop the flowing of, as blood, also STANCH [v]\n",
  "STAUNCHER": "something or someone that staunches [n -S]\n",
  "STAUNCHERS": "STAUNCHER, something or someone that staunches [n]\n",
  "STAUNCHES": "STAUNCH, to stop the flowing of, as blood, also STANCH [v]\n",
  "STAUNCHEST": "STAUNCH, firm, steadfast, also STANCH [adj]\n",
  "STAUNCHING": "the act of staunching [n -S]\n",
  "STAUNCHINGS": "STAUNCHING, the act of staunching [n]\n",
  "STAUNCHLESS": "without staunch [adj]\n",
  "STAUNCHLY": "STAUNCH, firm, steadfast, also STANCH [adv]\n",
  "STAUNCHNESS": "the state of being staunch [n -ES]\n",
  "STAUNCHNESSES": "STAUNCHNESS, the state of being staunch [n]\n",
  "STAUNING": "STAUN, (Scots) to stand [v]\n",
  "STAUNS": "STAUN, (Scots) to stand [v]\n",
  "STAUROLITE": "a silicate of aluminum and iron, generally found imbedded in mica schist [n -S]\n",
  "STAUROLITES": "STAUROLITE, a silicate of aluminum and iron, generally found imbedded in mica schist [n]\n",
  "STAUROLITIC": "relating to a staurolite [adj]\n",
  "STAUROSCOPE": "an instrument for studying the structure of crystals with polarised light [n -S]\n",
  "STAUROSCOPES": "STAUROSCOPE, an instrument for studying the structure of crystals with polarised light [n]\n",
  "STAUROSCOPIC": "of or like a stauroscope, an instrument for studying the structure of crystals with polarised light [adj]\n",
  "STAVE": "to drive or thrust away [v STAVED, STAVING, STAVES]\n",
  "STAVED": "STAVE, to drive or thrust away [v]\n",
  "STAVES": "STAVE, to drive or thrust away [v]\n",
  "STAVESACRE": "a tall larkspur whose seeds were formerly used against lice [n -S]\n",
  "STAVESACRES": "STAVESACRE, a tall larkspur whose seeds were formerly used against lice [n]\n",
  "STAVING": "STAVE, to drive or thrust away [v]\n",
  "STAVUDINE": "a drug used to treat HIV [n -S]\n",
  "STAVUDINES": "STAVUDINE, a drug used to treat HIV [n]\n",
  "STAW": "(Scots) to stall [v -ED, -ING, -S]\n",
  "STAWED": "STAW, (Scots) to stall [v]\n",
  "STAWING": "STAW, (Scots) to stall [v]\n",
  "STAWS": "STAW, (Scots) to stall [v]\n",
  "STAY": "to remain in a place or a condition [v -ED, -ING, -S]\n",
  "STAYAWAY": "in South Africa, a strike; a person participating in a strike [n -S]\n",
  "STAYAWAYS": "STAYAWAY, in South Africa, a strike; a person participating in a strike [n]\n",
  "STAYCATION": "a holiday in which leisure activities are pursued while staying at one's own home, also STACATION [n -S]\n",
  "STAYCATIONS": "STAYCATION, a holiday in which leisure activities are pursued while staying at one's own home, also STACATION [n]\n",
  "STAYED": "STAY, to remain in a place or a condition [v]\n",
  "STAYER": "one who stays [n -S]\n",
  "STAYERS": "STAYER, one who stays [n]\n",
  "STAYING": "STAY, to remain in a place or a condition [v]\n",
  "STAYLESS": "without stays [adj]\n",
  "STAYMAKER": "one whose occupation is to make stays [n -S]\n",
  "STAYMAKERS": "STAYMAKER, one whose occupation is to make stays [n]\n",
  "STAYNE": "(Spenser) to stain [v STAYNED, STAYNING, STAYNES]\n",
  "STAYNED": "STAYNE, (Spenser) to stain [v]\n",
  "STAYNES": "STAYNE, (Spenser) to stain [v]\n",
  "STAYNING": "STAYNE, (Spenser) to stain [v]\n",
  "STAYRE": "(Spenser) a stair [n -S]\n",
  "STAYRES": "STAYRE, (Spenser) a stair [n]\n",
  "STAYS": "STAY, to remain in a place or a condition [v]\n",
  "STAYSAIL": "a fore-and-aft sail hoisted on a stay [n -S]\n",
  "STAYSAILS": "STAYSAIL, a fore-and-aft sail hoisted on a stay [n]\n",
  "STEAD": "to avail, help, serve, also STED, STEDD, STEDDE, STEDE, STEED [v -ED, -ING, -S]\n",
  "STEADED": "STEAD, to avail, help, serve, also STED, STEDD, STEDDE, STEDE, STEED [v]\n",
  "STEADFAST": "firm, unwavering, also STEDFAST [adj STEADFASTLY]\n",
  "STEADFASTLY": "STEADFAST, firm, unwavering, also STEDFAST [adv]\n",
  "STEADFASTNESS": "the state of being steadfast [n -ES]\n",
  "STEADFASTNESSES": "STEADFASTNESS, the state of being steadfast [n]\n",
  "STEADIED": "STEADY, to make steady [v]\n",
  "STEADIER": "one who steadies [n -S]\n",
  "STEADIERS": "STEADIER, one who steadies [n]\n",
  "STEADIES": "STEADY, to make steady [v]\n",
  "STEADIEST": "STEADY, well-balanced [adj]\n",
  "STEADILY": "STEADY, well-balanced [adv]\n",
  "STEADINESS": "the state of being steady [n -ES]\n",
  "STEADINESSES": "STEADINESS, the state of being steady [n]\n",
  "STEADING": "a small farm [n -S]\n",
  "STEADINGS": "STEADING, a small farm [n]\n",
  "STEADS": "STEAD, to avail, help, serve, also STED, STEDD, STEDDE, STEDE, STEED [v]\n",
  "STEADY": "well-balanced [adj STEADIER, STEADIEST, STEADILY] / to make steady [v STEADIED, STEADYING, STEADIES]\n",
  "STEADYING": "STEADY, to make steady [v]\n",
  "STEAK": "any of several cuts of beef graded for frying, braising, stewing, etc. [n -S]\n",
  "STEAKETTE": "(Canadian) a thin patty of ground beef, meant to be cooked quickly [n -S]\n",
  "STEAKETTES": "STEAKETTE, (Canadian) a thin patty of ground beef, meant to be cooked quickly [n]\n",
  "STEAKHOUSE": "a restaurant specialising in steak [n -S]\n",
  "STEAKHOUSES": "STEAKHOUSE, a restaurant specialising in steak [n]\n",
  "STEAKS": "STEAK, any of several cuts of beef graded for frying, braising, stewing, etc. [n]\n",
  "STEAL": "to take by theft [v STEALT or STOLE or STAW or STEALED, STOLEN or STOLN or STOWN, STEALING, STEALS]\n",
  "STEALABLE": "that can be stolen [adj]\n",
  "STEALAGE": "theft [n -S]\n",
  "STEALAGES": "STEALAGE, theft [n]\n",
  "STEALE": "(Scots) a handle, also STEIL [n -S]\n",
  "STEALED": "STEAL, to take by theft [v]\n",
  "STEALER": "one who steals [n -S]\n",
  "STEALERS": "STEALER, one who steals [n]\n",
  "STEALES": "STEALE, (Scots) a handle, also STEIL [n]\n",
  "STEALING": "the act of stealing [n -S]\n",
  "STEALINGLY": "STEALING [adv]\n",
  "STEALINGS": "STEALING, the act of stealing [n]\n",
  "STEALS": "STEAL, to take by theft [v]\n",
  "STEALT": "STEAL, to take by theft [v]\n",
  "STEALTH": "to approach furtively [v -ED, -ING, -S]\n",
  "STEALTHED": "STEALTH, to approach furtively [v]\n",
  "STEALTHFUL": "stealthy [adj]\n",
  "STEALTHIER": "STEALTHY, acting with stealth, furtive [adj]\n",
  "STEALTHIEST": "STEALTHY, acting with stealth, furtive [adj]\n",
  "STEALTHILY": "STEALTHY, acting with stealth, furtive [adv]\n",
  "STEALTHINESS": "the state of being stealthy [n -ES]\n",
  "STEALTHINESSES": "STEALTHINESS, the state of being stealthy [n]\n",
  "STEALTHING": "the act of making e.g. a plane proof against radar [n -S]\n",
  "STEALTHINGS": "STEALTHING, the act of making e.g. a plane proof against radar [n]\n",
  "STEALTHS": "STEALTH, to approach furtively [v]\n",
  "STEALTHY": "acting with stealth, furtive [adj STEALTHIER, STEALTHIEST, STEALTHILY]\n",
  "STEAM": "to cook by water in the form of vapour [v -ED, -ING, -S]\n",
  "STEAMBOAT": "a boat powered by steam [n -S]\n",
  "STEAMBOATS": "STEAMBOAT, a boat powered by steam [n]\n",
  "STEAMED": "STEAM, to cook by water in the form of vapour [v]\n",
  "STEAMER": "to travel by steamship [v -ED, -ING, -S]\n",
  "STEAMERED": "STEAMER, to travel by steamship [v]\n",
  "STEAMERING": "STEAMER, to travel by steamship [v]\n",
  "STEAMERS": "STEAMER, to travel by steamship [v]\n",
  "STEAMFITTER": "one that installs or repairs equipment, such as steam pipes, for heating, ventilating, or refrigerating systems [n -S]\n",
  "STEAMFITTERS": "STEAMFITTER, one that installs or repairs equipment, such as steam pipes, for heating, ventilating, or refrigerating systems [n]\n",
  "STEAMIE": "(Scots) a public laundry [n -S]\n",
  "STEAMIER": "STEAMY, like steam [adj]\n",
  "STEAMIES": "STEAMIE, (Scots) a public laundry [n]\n",
  "STEAMIEST": "STEAMY, like steam [adj]\n",
  "STEAMILY": "STEAMY, like steam [adv]\n",
  "STEAMINESS": "the state of being steamy [n -ES]\n",
  "STEAMINESSES": "STEAMINESS, the state of being steamy [n]\n",
  "STEAMING": "a method of cooking [n -S]\n",
  "STEAMINGS": "STEAMING, a method of cooking [n]\n",
  "STEAMPUNK": "a genre of science fiction set in an era of steam power, esp. Victorian Britain [n -S]\n",
  "STEAMPUNKS": "STEAMPUNK, a genre of science fiction set in an era of steam power, esp. Victorian Britain [n]\n",
  "STEAMROLL": "to crush with a steamroller [v -ED, -ING, -S]\n",
  "STEAMROLLED": "STEAMROLL, to crush with a steamroller [v]\n",
  "STEAMROLLER": "to overwhelm usually by greatly superior force [v -ED, -ING, -S]\n",
  "STEAMROLLERED": "STEAMROLLER, to overwhelm usually by greatly superior force [v]\n",
  "STEAMROLLERING": "STEAMROLLER, to overwhelm usually by greatly superior force [v]\n",
  "STEAMROLLERS": "STEAMROLLER, to overwhelm usually by greatly superior force [v]\n",
  "STEAMROLLING": "STEAMROLL, to crush with a steamroller [v]\n",
  "STEAMROLLS": "STEAMROLL, to crush with a steamroller [v]\n",
  "STEAMS": "STEAM, to cook by water in the form of vapour [v]\n",
  "STEAMSHIP": "a ship powered by steam [n -S]\n",
  "STEAMSHIPS": "STEAMSHIP, a ship powered by steam [n]\n",
  "STEAMTIGHT": "impervious to steam [adj]\n",
  "STEAMTIGHTNESS": "the state of being steamtight [n]\n",
  "STEAMY": "like steam [adj STEAMIER, STEAMIEST, STEAMILY]\n",
  "STEAN": "to line e.g. a well with stone, also STEANE, STEEN, STEIN [v -ED, -ING, -S]\n",
  "STEANE": "to line e.g. a well with stone, also STEAN, STEEN, STEIN [v STEANED, STEANING, STEANES]\n",
  "STEANED": "STEAN, to line e.g. a well with stone, also STEANE, STEEN, STEIN [v]\n",
  "STEANES": "STEANE, to line e.g. a well with stone, also STEAN, STEEN, STEIN [v]\n",
  "STEANING": "a stone lining of a well [n -S]\n",
  "STEANINGS": "STEANING, a stone lining of a well [n]\n",
  "STEANS": "STEAN, to line e.g. a well with stone, also STEANE, STEEN, STEIN [v]\n",
  "STEAPSIN": "an enzyme present in pancreatic juice, aka lipase [n -S]\n",
  "STEAPSINS": "STEAPSIN, an enzyme present in pancreatic juice, aka lipase [n]\n",
  "STEAR": "(obsolete) to steer [v STEARED or STEARD, STEARING, STEARS]\n",
  "STEARAGE": "(obsolete) the act or practice of steering, also STEERAGE [n -S]\n",
  "STEARAGES": "STEARAGE, (obsolete) the act or practice of steering, also STEERAGE [n]\n",
  "STEARATE": "a salt of stearic acid [n -S]\n",
  "STEARATES": "STEARATE, a salt of stearic acid [n]\n",
  "STEARD": "STEER, to guide or direct, also STEAR [v]\n",
  "STEARE": "(archaic) a steer, a young bullock [n -S]\n",
  "STEARED": "STEAR, (obsolete) to steer [v]\n",
  "STEARES": "STEARE, (archaic) a steer, a young bullock [n]\n",
  "STEARIC": "pertaining to, or obtained from, stearin or tallow [adj]\n",
  "STEARIN": "(Greek) the solid portion of a fat, also STEARINE [n -S]\n",
  "STEARINE": "the solid portion of a fat, also STEARIN [n -S]\n",
  "STEARINES": "STEARINE, the solid portion of a fat, also STEARIN [n]\n",
  "STEARING": "STEAR, (obsolete) to steer [v]\n",
  "STEARINS": "STEARIN, (Greek) the solid portion of a fat, also STEARINE [n]\n",
  "STEAROPTENE": "the part of an essential oil that separates out as a solid on cooling or standing [n -S]\n",
  "STEAROPTENES": "STEAROPTENE, the part of an essential oil that separates out as a solid on cooling or standing [n]\n",
  "STEARS": "STEAR, (obsolete) to steer [v]\n",
  "STEARSMAN": "(obsolete) a steersman [n STEARSMEN]\n",
  "STEARSMATE": "one who steers, also STEERSMATE [n -S]\n",
  "STEARSMATES": "STEARSMATE, one who steers, also STEERSMATE [n]\n",
  "STEARSMEN": "STEARSMAN, (obsolete) a steersman [n]\n",
  "STEATITE": "the massive talc that is used in paints, ceramics, and insulation [n -S]\n",
  "STEATITES": "STEATITE, the massive talc that is used in paints, ceramics, and insulation [n]\n",
  "STEATITIC": "pertaining to, or of the nature of, steatite [adj]\n",
  "STEATOCELE": "a fatty tumour in the scrotum [n -S]\n",
  "STEATOCELES": "STEATOCELE, a fatty tumour in the scrotum [n]\n",
  "STEATOLYSES": "STEATOLYSIS, the breaking down of fat esp. by digestion [n]\n",
  "STEATOLYSIS": "the breaking down of fat esp. by digestion [n STEATOLYSES]\n",
  "STEATOMA": "(Greek) a cyst containing matter like suet [n -S]\n",
  "STEATOMAS": "STEATOMA, (Greek) a cyst containing matter like suet [n]\n",
  "STEATOMATOUS": "relating to a steatoma, a tumour of the sebaceous gland [adj]\n",
  "STEATOPYGA": "an excessive development of fat on the buttocks, esp. on females, also STEATOPYGIA [n -S]\n",
  "STEATOPYGAS": "STEATOPYGA, an excessive development of fat on the buttocks, esp. on females, also STEATOPYGIA [n]\n",
  "STEATOPYGIA": "an excessive development of fat on the buttocks, esp. of females, also STEATOPYGA [n -S]\n",
  "STEATOPYGIAS": "STEATOPYGIA, an excessive development of fat on the buttocks, esp. of females, also STEATOPYGA [n]\n",
  "STEATOPYGIC": "having fat buttocks, also STEATOPYGOUS [adj]\n",
  "STEATOPYGOUS": "having fat buttocks, also STEATOPYGIC [adj]\n",
  "STEATORRHEA": "the accumulation of abnormal levels of fat in the faeces, also STEATORRHOEA [n -S]\n",
  "STEATORRHEAS": "STEATORRHEA, the accumulation of abnormal levels of fat in the faeces, also STEATORRHOEA [n]\n",
  "STEATORRHOEA": "the accumulation of abnormal levels of fat in the faeces, also STEATORRHEA [n -S]\n",
  "STEATORRHOEAS": "STEATORRHOEA, the accumulation of abnormal levels of fat in the faeces, also STEATORRHEA [n]\n",
  "STEATOSES": "STEATOSIS, adiposity [n]\n",
  "STEATOSIS": "adiposity [n STEATOSES]\n",
  "STED": "(Spenser) to stead, help, also STEDD, STEDDE, STEDE, STEED [v STEDDED, STEDDING, STEDS]\n",
  "STEDD": "(Spenser) to stead, help, also STED, STEDDE, STEDE, STEED [v -ED, -ING, -S]\n",
  "STEDDE": "(Spenser) to stead, help, also STED, STEDD, STEDE, STEED [v STEDDED, STEDDING, STEDDES]\n",
  "STEDDED": "STEDD, (Spenser) to stead, help, also STED, STEDDE, STEDE, STEED [v]\n",
  "STEDDES": "STEDDE, (Spenser) to stead, help, also STED, STEDD, STEDE, STEED [v]\n",
  "STEDDIED": "STEDDY, (archaic) to steady, also STEEDY [v]\n",
  "STEDDIES": "STEDDY, (archaic) to steady, also STEEDY [v]\n",
  "STEDDING": "STEDD, (Spenser) to stead, help, also STED, STEDDE, STEDE, STEED [v]\n",
  "STEDDS": "STEDD, (Spenser) to stead, help, also STED, STEDDE, STEDE, STEED [v]\n",
  "STEDDY": "(archaic) to steady, also STEEDY [v STEDDIED, STEDDYING, STEDDIES]\n",
  "STEDDYING": "STEDDY, (archaic) to steady, also STEEDY [v]\n",
  "STEDE": "(Spenser) to stead, help, also STED, STEDD, STEDDE, STEED [v STEDED, STEDING, STEDES]\n",
  "STEDED": "STEDE, (Spenser) to stead, help, also STED, STEDD, STEDDE, STEED [v]\n",
  "STEDES": "STEDE, (Spenser) to stead, help, also STED, STEDD, STEDDE, STEED [v]\n",
  "STEDFAST": "(obsolete) of a person, a person's belief, loyalty, etc., constant, unwavering, also STEADFAST [adj STEDFASTLY]\n",
  "STEDFASTLY": "STEDFAST, (obsolete) of a person, a person's belief, loyalty, etc., constant, unwavering, also STEADFAST [adv]\n",
  "STEDFASTNESS": "the state of being stedfast [n -ES]\n",
  "STEDFASTNESSES": "STEDFASTNESS, the state of being stedfast [n]\n",
  "STEDING": "STEDE, (Spenser) to stead, help, also STED, STEDD, STEDDE, STEED [v]\n",
  "STEDS": "STED, (Spenser) to stead, help, also STEDD, STEDDE, STEDE, STEED [v]\n",
  "STEED": "(Spenser) to stead, help, also STED, STEDD, STEDDE, STEDE [v -ED, -ING, -S]\n",
  "STEEDED": "STEED, (Spenser) to stead, help, also STED, STEDD, STEDDE, STEDE [v]\n",
  "STEEDIED": "STEEDY, (archaic) to steady, also STEDDY [v]\n",
  "STEEDIES": "STEEDY, (archaic) to steady, also STEDDY [v]\n",
  "STEEDING": "STEED, (Spenser) to stead, help, also STED, STEDD, STEDDE, STEDE [v]\n",
  "STEEDLIKE": "like a steed [adj]\n",
  "STEEDS": "STEED, (Spenser) to stead, help, also STED, STEDD, STEDDE, STEDE [v]\n",
  "STEEDY": "(archaic) to steady, also STEDDY [v STEEDIED, STEEDYING, STEEDIES]\n",
  "STEEDYING": "STEEDY, (archaic) to steady, also STEDDY [v]\n",
  "STEEK": "(Scots) to stitch [v STEEKED, STEEKIT, STEEKING, STEEKS]\n",
  "STEEKED": "STEEK, (Scots) to stitch [v]\n",
  "STEEKING": "STEEK, (Scots) to stitch [v]\n",
  "STEEKIT": "STEEK, (Scots) to stitch [v]\n",
  "STEEKS": "STEEK, (Scots) to stitch [v]\n",
  "STEEL": "to cover with a tough iron alloy [v -ED, -ING, -S]\n",
  "STEELBOW": "(Scots) stock and goods received from a landlord with obligation to return a like amount and value when the lease expires [n -S]\n",
  "STEELBOWS": "STEELBOW, (Scots) stock and goods received from a landlord with obligation to return a like amount and value when the lease expires [n]\n",
  "STEELD": "STELL, to establish, fix firmly [v]\n",
  "STEELED": "STEEL, to cover with a tough iron alloy [v]\n",
  "STEELHEAD": "a north Pacific salmon found from northern California to Siberia [n -S]\n",
  "STEELHEADS": "STEELHEAD, a north Pacific salmon found from northern California to Siberia [n]\n",
  "STEELIE": "a steel playing marble [n -S]\n",
  "STEELIER": "STEELY, resembling steel [adj]\n",
  "STEELIES": "STEELIE, a steel playing marble [n]\n",
  "STEELIEST": "STEELY, resembling steel [adj]\n",
  "STEELINESS": "the state of being steely [n -ES]\n",
  "STEELINESSES": "STEELINESS, the state of being steely [n]\n",
  "STEELING": "the act of steeling [n -S]\n",
  "STEELINGS": "STEELING, the act of steeling [n]\n",
  "STEELMAKER": "a worker in steel [n -S]\n",
  "STEELMAKERS": "STEELMAKER, a worker in steel [n]\n",
  "STEELMAKING": "the process of making steel [n -S]\n",
  "STEELMAKINGS": "STEELMAKING, the process of making steel [n]\n",
  "STEELMAN": "a worker in the steel industry [n STEELMEN]\n",
  "STEELMEN": "STEELMAN, a worker in the steel industry [n]\n",
  "STEELS": "STEEL, to cover with a tough iron alloy [v]\n",
  "STEELWARE": "articles made of steel [n -S]\n",
  "STEELWARES": "STEELWARE, articles made of steel [n]\n",
  "STEELWORK": "work executed in steel [n -S]\n",
  "STEELWORKER": "a person who works in steel and esp. in the manufacturing of it [n -S]\n",
  "STEELWORKERS": "STEELWORKER, a person who works in steel and esp. in the manufacturing of it [n]\n",
  "STEELWORKING": "the business of producing steel [n -S]\n",
  "STEELWORKINGS": "STEELWORKING, the business of producing steel [n]\n",
  "STEELWORKS": "STEELWORK, work executed in steel [n]\n",
  "STEELY": "resembling steel [adj STEELIER, STEELIEST]\n",
  "STEELYARD": "a weighing-machine consisting of a lever with a short arm for the thing weighed and a long graduated arm on which a single weight moves [n -S]\n",
  "STEELYARDS": "STEELYARD, a weighing-machine consisting of a lever with a short arm for the thing weighed and a long graduated arm on which a single weight moves [n]\n",
  "STEEM": "(archaic) to esteem [v -ED, -ING, -S]\n",
  "STEEMED": "STEEM, (archaic) to esteem [v]\n",
  "STEEMING": "STEEM, (archaic) to esteem [v]\n",
  "STEEMS": "STEEM, (archaic) to esteem [v]\n",
  "STEEN": "to line e.g. a well with stone, also STEAN, STEANE, STEIN [v -ED, -ING, -S]\n",
  "STEENBOK": "(South African) a small antelope, also STEENBUCK, STEINBOCK, STEINBOK, STEMBOK, STEMBUCK [n -S]\n",
  "STEENBOKS": "STEENBOK, (South African) a small antelope, also STEENBUCK, STEINBOCK, STEINBOK, STEMBOK, STEMBUCK [n]\n",
  "STEENBRAS": "(South African) an edible estuarine South African fish [n -ES]\n",
  "STEENBRASES": "STEENBRAS, (South African) an edible estuarine South African fish [n]\n",
  "STEENBUCK": "(South African) a small South African antelope, also STEENBOK, STEINBOCK, STEINBOK, STEMBOK, STEMBUCK [n -S]\n",
  "STEENBUCKS": "STEENBUCK, (South African) a small South African antelope, also STEENBOK, STEINBOCK, STEINBOK, STEMBOK, STEMBUCK [n]\n",
  "STEENED": "STEEN, to line e.g. a well with stone, also STEAN, STEANE, STEIN [v]\n",
  "STEENING": "a stone lining, also STEANING, STEINING [n -S]\n",
  "STEENINGS": "STEENING, a stone lining, also STEANING, STEINING [n]\n",
  "STEENKIRK": "(historical) a neckcloth or cravat with long lace ends, also STEINKIRK [n -S]\n",
  "STEENKIRKS": "STEENKIRK, (historical) a neckcloth or cravat with long lace ends, also STEINKIRK [n]\n",
  "STEENS": "STEEN, to line e.g. a well with stone, also STEAN, STEANE, STEIN [v]\n",
  "STEEP": "inclined sharply [adj STEEPER, STEEPEST, STEEPLY] / to soak in a liquid [v -ED, -ING, -S]\n",
  "STEEPDOWNE": "(Shakespeare) precipitous, also STEEPEDOWNE, STEEPEUP, STEEPUP [adj]\n",
  "STEEPED": "STEEP, to soak in a liquid [v]\n",
  "STEEPEDOWNE": "(Shakespeare) precipitous, also STEEPDOWNE, STEEPEUP, STEEPUP [adj]\n",
  "STEEPEN": "to become steep [v -ED, -ING, -S]\n",
  "STEEPENED": "STEEPEN, to become steep [v]\n",
  "STEEPENING": "STEEPEN, to become steep [v]\n",
  "STEEPENS": "STEEPEN, to become steep [v]\n",
  "STEEPER": "a vessel for steeping in [n -S]\n",
  "STEEPERS": "STEEPER, a vessel for steeping in [n]\n",
  "STEEPEST": "STEEP, inclined sharply [adj]\n",
  "STEEPEUP": "(Shakespeare) precipitous or perilous, also STEEPDOWNE, STEEPEDOWNE, STEEPUP [adj]\n",
  "STEEPIER": "STEEPY, steep; precipitous [adj]\n",
  "STEEPIEST": "STEEPY, steep; precipitous [adj]\n",
  "STEEPINESS": "(obsolete) steepness [n -ES]\n",
  "STEEPINESSES": "STEEPINESS, (obsolete) steepness [n]\n",
  "STEEPING": "STEEP, to soak in a liquid [v]\n",
  "STEEPISH": "somewhat steep [adj]\n",
  "STEEPLE": "a tower-like structure on a church [n -S]\n",
  "STEEPLEBUSH": "another name for hardhack [n -ES]\n",
  "STEEPLEBUSHES": "STEEPLEBUSH, another name for hardhack [n]\n",
  "STEEPLECHASE": "a race over a course with obstacles to be jumped [n -S] / to ride in such a race [v STEEPLECHASED, STEEPLECHASING, STEEPLECHASES]\n",
  "STEEPLECHASED": "STEEPLECHASE, to ride in such a race [v]\n",
  "STEEPLECHASER": "a horse used in steeplechasing [n -S]\n",
  "STEEPLECHASERS": "STEEPLECHASER, a horse used in steeplechasing [n]\n",
  "STEEPLECHASES": "STEEPLECHASE, a race over a course with obstacles to be jumped [n]\n",
  "STEEPLECHASING": "the sport of riding in steeplechases [n -S]\n",
  "STEEPLECHASINGS": "STEEPLECHASING, the sport of riding in steeplechases [n]\n",
  "STEEPLED": "having a steeple [adj]\n",
  "STEEPLEJACK": "a person who repairs steeples and high chimneys [n -S]\n",
  "STEEPLEJACKS": "STEEPLEJACK, a person who repairs steeples and high chimneys [n]\n",
  "STEEPLES": "STEEPLE, a tower-like structure on a church [n]\n",
  "STEEPLING": "rising on a high trajectory [adj]\n",
  "STEEPLY": "STEEP, inclined sharply [adv]\n",
  "STEEPNESS": "the state of being steep, also STEEPINESS [n -ES]\n",
  "STEEPNESSES": "STEEPNESS, the state of being steep, also STEEPINESS [n]\n",
  "STEEPS": "STEEP, to soak in a liquid [v]\n",
  "STEEPUP": "(Shakespeare) precipitous or perilous, also STEEPDOWNE, STEEPEDOWNE, STEEPEUP [adj]\n",
  "STEEPY": "steep; precipitous [adj STEEPIER, STEEPIEST]\n",
  "STEER": "to guide or direct, also STEAR [v -ED, -ING, -S]\n",
  "STEERABLE": "that can be steered [adj]\n",
  "STEERAGE": "a section in a passenger ship for passengers paying the lowest fares and given inferior accommodations, also STEARAGE [n -S]\n",
  "STEERAGES": "STEERAGE, a section in a passenger ship for passengers paying the lowest fares and given inferior accommodations, also STEARAGE [n]\n",
  "STEERAGEWAY": "a rate of motion sufficient to make a ship or boat respond to movements of the rudder [n -S]\n",
  "STEERAGEWAYS": "STEERAGEWAY, a rate of motion sufficient to make a ship or boat respond to movements of the rudder [n]\n",
  "STEERED": "STEER, to guide or direct, also STEAR [v]\n",
  "STEERER": "one who steers [n -S]\n",
  "STEERERS": "STEERER, one who steers [n]\n",
  "STEERIER": "STEERY, busy or bustling [adj]\n",
  "STEERIES": "STEERY, a commotion [n]\n",
  "STEERIEST": "STEERY, busy or bustling [adj]\n",
  "STEERING": "the guiding of a vehicle [n -S]\n",
  "STEERINGS": "STEERING, the guiding of a vehicle [n]\n",
  "STEERLING": "a young small steer [n -S]\n",
  "STEERLINGS": "STEERLING, a young small steer [n]\n",
  "STEERS": "STEER, to guide or direct, also STEAR [v]\n",
  "STEERSMAN": "the person who steers a vessel, a helmsman, also STEARSMAN [n STEERSMEN]\n",
  "STEERSMATE": "one who steers, also STEARSMATE [n -S]\n",
  "STEERSMATES": "STEERSMATE, one who steers, also STEARSMATE [n]\n",
  "STEERSMEN": "STEERSMAN, the person who steers a vessel, a helmsman, also STEARSMAN [n]\n",
  "STEERY": "busy or bustling [adj STEERIER, STEERIEST] / a commotion [n STEERIES]\n",
  "STEEVE": "(Scots) firm, also STIEVE [adj STEEVER, STEEVEST, STEEVELY] / to stow in the hold of a ship [v STEEVED, STEEVING, STEEVES]\n",
  "STEEVED": "STEEVE, to stow in the hold of a ship [v]\n",
  "STEEVELY": "STEEVE, (Scots) firm, also STIEVE [adv]\n",
  "STEEVER": "STEEVE, (Scots) firm, also STIEVE [adj]\n",
  "STEEVES": "STEEVE, to stow in the hold of a ship [v]\n",
  "STEEVEST": "STEEVE, (Scots) firm, also STIEVE [adj]\n",
  "STEEVING": "the angular elevation of a bowsprit from a ship's keel [n -S]\n",
  "STEEVINGS": "STEEVING, the angular elevation of a bowsprit from a ship's keel [n]\n",
  "STEGANOGRAM": "a cryptogram, also STEGANOGRAPH [n -S]\n",
  "STEGANOGRAMS": "STEGANOGRAM, a cryptogram, also STEGANOGRAPH [n]\n",
  "STEGANOGRAPH": "a cryptogram, also STEGANOGRAM [n -S]\n",
  "STEGANOGRAPHER": "a cryptographer; one who works with ciphers [n -S]\n",
  "STEGANOGRAPHERS": "STEGANOGRAPHER, a cryptographer; one who works with ciphers [n]\n",
  "STEGANOGRAPHIC": "relating to steganography, the practice of concealing digital data within some of the pixels of an image [adj]\n",
  "STEGANOGRAPHIES": "STEGANOGRAPHY, the practice of concealing digital data within some of the pixels of an image [n]\n",
  "STEGANOGRAPHIST": "one who practises steganography [n]\n",
  "STEGANOGRAPHS": "STEGANOGRAPH, a cryptogram, also STEGANOGRAM [n]\n",
  "STEGANOGRAPHY": "the practice of concealing digital data within some of the pixels of an image [n STEGANOGRAPHIES]\n",
  "STEGANOPOD": "any bird of the pelican order [n -S]\n",
  "STEGANOPODOUS": "relating to the Steganopodes, an order of birds including pelicans [adj]\n",
  "STEGANOPODS": "STEGANOPOD, any bird of the pelican order [n]\n",
  "STEGNOSES": "STEGNOSIS, constipation [n]\n",
  "STEGNOSIS": "constipation [n STEGNOSES]\n",
  "STEGNOTIC": "a drug tending to render costive, or to diminish excretions or discharges generally [n -S]\n",
  "STEGNOTICS": "STEGNOTIC, a drug tending to render costive, or to diminish excretions or discharges generally [n]\n",
  "STEGOCARPOUS": "of fruit, having a lidded capsule [adj]\n",
  "STEGOCEPHALIAN": "any member of the Stegocephalia, an extinct order of amphibians having the skull protected by bony plates [n -S]\n",
  "STEGOCEPHALIANS": "STEGOCEPHALIAN, any member of the Stegocephalia, an extinct order of amphibians having the skull protected by bony plates [n]\n",
  "STEGOCEPHALOUS": "relating to the Stegocephalia, an extinct order of amphibians having the skull protected by bony plates [adj]\n",
  "STEGODON": "an extinct mammal with ridged teeth, also STEGODONT [n -S]\n",
  "STEGODONS": "STEGODON, an extinct mammal with ridged teeth, also STEGODONT [n]\n",
  "STEGODONT": "an extinct mammal with ridged teeth, also STEGODON [n -S]\n",
  "STEGODONTS": "STEGODONT, an extinct mammal with ridged teeth, also STEGODON [n]\n",
  "STEGOMYIA": "a genus of mosquito, including one that carries dengue and yellow fever [n -S]\n",
  "STEGOMYIAS": "STEGOMYIA, a genus of mosquito, including one that carries dengue and yellow fever [n]\n",
  "STEGOPHILIST": "one who climbs buildings for sport [n -S]\n",
  "STEGOPHILISTS": "STEGOPHILIST, one who climbs buildings for sport [n]\n",
  "STEGOSAUR": "a herbivorous dinosaur of the Jurassic period, also STEGOSAURUS [n -S]\n",
  "STEGOSAURIAN": "any quadrupedal herbivorous ornithischian dinosaur of the suborder Stegosauria [n -S]\n",
  "STEGOSAURIANS": "STEGOSAURIAN, any quadrupedal herbivorous ornithischian dinosaur of the suborder Stegosauria [n]\n",
  "STEGOSAURS": "STEGOSAUR, a herbivorous dinosaur of the Jurassic period, also STEGOSAURUS [n]\n",
  "STEGOSAURUS": "a herbivorous dinosaur of the Jurassic period, also STEGOSAUR [n -ES]\n",
  "STEGOSAURUSES": "STEGOSAURUS, a herbivorous dinosaur of the Jurassic period, also STEGOSAUR [n]\n",
  "STEIL": "(dialect) a handle, also STEALE [n -S]\n",
  "STEILS": "STEIL, (dialect) a handle, also STEALE [n]\n",
  "STEIN": "to line e.g. a well with stone, also STEAN, STEANE, STEEN [v -ED, -ING, -S]\n",
  "STEINBOCK": "(South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOK, STEMBOK, STEMBUCK [n -S]\n",
  "STEINBOCKS": "STEINBOCK, (South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOK, STEMBOK, STEMBUCK [n]\n",
  "STEINBOK": "(South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOCK, STEMBOK, STEMBUCK [n -S]\n",
  "STEINBOKS": "STEINBOK, (South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOCK, STEMBOK, STEMBUCK [n]\n",
  "STEINED": "STEIN, to line e.g. a well with stone, also STEAN, STEANE, STEEN [v]\n",
  "STEINING": "a stone lining of a well, also STEANING, STEENING [n -S]\n",
  "STEININGS": "STEINING, a stone lining of a well, also STEANING, STEENING [n]\n",
  "STEINKIRK": "a neckcloth or cravat with long lace ends, also STEENKIRK [n -S]\n",
  "STEINKIRKS": "STEINKIRK, a neckcloth or cravat with long lace ends, also STEENKIRK [n]\n",
  "STEINS": "STEIN, to line e.g. a well with stone, also STEAN, STEANE, STEEN [v]\n",
  "STELA": "(Greek) an inscribed slab used as a monument, also STELE [n STELAE or STELAI]\n",
  "STELAE": "STELA, (Greek) an inscribed slab used as a monument, also STELE [n]\n",
  "STELAI": "STELA, (Greek) an inscribed slab used as a monument, also STELE [n]\n",
  "STELAR": "relating to a stele, an upright stone slab, also STELENE, STELIC [adj]\n",
  "STELE": "(Greek) an upright stone slab, also STELA [n STELAE] / (Scots) a handle [n STELES]\n",
  "STELENE": "relating to a stele, an upright stone slab, also STELAR, STELIC [adj]\n",
  "STELES": "STELE, (Greek) an upright stone slab, also STELA [n]\n",
  "STELIC": "relating to a stele, an upright stone slab, also STELAR, STELENE [adj]\n",
  "STELL": "to establish, fix firmly [v STELLED or (Scots) STEELD, STELLING, STELLS]\n",
  "STELLA": "a former coin of the United States [n -S]\n",
  "STELLAR": "pertaining to the stars [adj]\n",
  "STELLARATOR": "a twisted torus in which plasma can be confined by a magnetic field, used for producing thermonuclear power by nuclear fusion [n -S]\n",
  "STELLARATORS": "STELLARATOR, a twisted torus in which plasma can be confined by a magnetic field, used for producing thermonuclear power by nuclear fusion [n]\n",
  "STELLAS": "STELLA, a former coin of the United States [n]\n",
  "STELLATE": "star-shaped; starry, also STELLATED [adj STELLATELY]\n",
  "STELLATED": "star-shaped; starry, also STELLATE [adj]\n",
  "STELLATELY": "STELLATE, star-shaped; starry, also STELLATED [adv]\n",
  "STELLED": "STELL, to establish, fix firmly [v]\n",
  "STELLERID": "a starfish, also STELLERIDAN [n -S]\n",
  "STELLERIDAN": "a starfish, also STELLERID [n -S]\n",
  "STELLERIDANS": "STELLERIDAN, a starfish, also STELLERID [n]\n",
  "STELLERIDS": "STELLERID, a starfish, also STELLERIDAN [n]\n",
  "STELLIFEROUS": "having many stars [adj]\n",
  "STELLIFIED": "STELLIFY, to convert into a star [v]\n",
  "STELLIFIES": "STELLIFY, to convert into a star [v]\n",
  "STELLIFORM": "shaped like a star [adj]\n",
  "STELLIFY": "to convert into a star [v STELLIFIED, STELLIFYING, STELLIFIES]\n",
  "STELLIFYING": "the act of turning into star [n -S]\n",
  "STELLIFYINGS": "STELLIFYING, the act of turning into star [n]\n",
  "STELLING": "STELL, to establish, fix firmly [v]\n",
  "STELLIO": "as in stellio lizard, a STELLION [adj]\n",
  "STELLION": "(Latin) an East Mediterranean lizard with starry spots, also STELLIO [n -S]\n",
  "STELLIONATE": "fraud committed in making contracts, esp. that which involves selling the same thing, or rights to the same thing, to different persons [n -S]\n",
  "STELLIONATES": "STELLIONATE, fraud committed in making contracts, esp. that which involves selling the same thing, or rights to the same thing, to different persons [n]\n",
  "STELLIONS": "STELLION, (Latin) an East Mediterranean lizard with starry spots, also STELLIO [n]\n",
  "STELLITE": "a cobalt-base alloy with chromium and other metals, used to make cutting tools and for surfaces subject to heavy wear [n -S]\n",
  "STELLITES": "STELLITE, a cobalt-base alloy with chromium and other metals, used to make cutting tools and for surfaces subject to heavy wear [n]\n",
  "STELLS": "STELL, to establish, fix firmly [v]\n",
  "STELLULAR": "starlike; having starlike spots [adj STELLULARLY]\n",
  "STELLULARLY": "STELLULAR, starlike; having starlike spots [adv]\n",
  "STELLULATE": "minutely stellate [adj]\n",
  "STEM": "to staunch, stop [v STEMMED, STEMMING, STEMS]\n",
  "STEMBOK": "(South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOCK, STEINBOK, STEMBUCK [n -S]\n",
  "STEMBOKS": "STEMBOK, (South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOCK, STEINBOK, STEMBUCK [n]\n",
  "STEMBUCK": "(South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOCK, STEINBOK, STEMBOK [n -S]\n",
  "STEMBUCKS": "STEMBUCK, (South African) a small South African antelope, also STEENBOK, STEENBUCK, STEINBOCK, STEINBOK, STEMBOK [n]\n",
  "STEME": "(archaic) to steam, evaporate [v STEMED, STEMING, STEMES]\n",
  "STEMED": "STEME, (archaic) to steam, evaporate [v]\n",
  "STEMES": "STEME, (archaic) to steam, evaporate [v]\n",
  "STEMHEAD": "the head of the stem of a nautical vessel [n -S]\n",
  "STEMHEADS": "STEMHEAD, the head of the stem of a nautical vessel [n]\n",
  "STEMING": "STEME, (archaic) to steam, evaporate [v]\n",
  "STEMLESS": "without a stem [adj]\n",
  "STEMLET": "a small stem [n -S]\n",
  "STEMLETS": "STEMLET, a small stem [n]\n",
  "STEMLIKE": "like a stem [adj]\n",
  "STEMMA": "(Greek) a diagram representing a reconstruction of the interrelationships between surviving witnesses in the (esp. manuscript) tradition of a text [n STEMMAS or STEMMATA]\n",
  "STEMMAS": "STEMMA, (Greek) a diagram representing a reconstruction of the interrelationships between surviving witnesses in the (esp. manuscript) tradition of a text [n]\n",
  "STEMMATA": "STEMMA, (Greek) a diagram representing a reconstruction of the interrelationships between surviving witnesses in the (esp. manuscript) tradition of a text [n]\n",
  "STEMMATIC": "relating to a stemma, a diagram representing a reconstruction of the interrelationships between surviving witnesses in the (esp. manuscript) tradition of a text [adj]\n",
  "STEMMATOUS": "of or like a stemma [adj]\n",
  "STEMME": "(Spenser) to encircle [v STEMMED, STEMMING, STEMMES]\n",
  "STEMMED": "STEMME, (Spenser) to encircle [v]\n",
  "STEMMER": "a metal bar used to tamp down a charge in a blasting hole [n -S]\n",
  "STEMMERIES": "STEMMERY, a place where tobacco leaves are stripped [n]\n",
  "STEMMERS": "STEMMER, a metal bar used to tamp down a charge in a blasting hole [n]\n",
  "STEMMERY": "a place where tobacco leaves are stripped [n STEMMERIES]\n",
  "STEMMES": "STEMME, (Spenser) to encircle [v]\n",
  "STEMMIER": "STEMMY, abounding in stems, or mixed with stems; said of tea, dried currants, etc. [adj]\n",
  "STEMMIEST": "STEMMY, abounding in stems, or mixed with stems; said of tea, dried currants, etc. [adj]\n",
  "STEMMING": "material used for tamping a hole [n -S]\n",
  "STEMMINGS": "STEMMING, material used for tamping a hole [n]\n",
  "STEMMY": "abounding in stems, or mixed with stems; said of tea, dried currants, etc. [adj STEMMIER, STEMMIEST]\n",
  "STEMPEL": "(German) a cross-timber in a shaft, also STEMPLE [n -S]\n",
  "STEMPELS": "STEMPEL, (German) a cross-timber in a shaft, also STEMPLE [n]\n",
  "STEMPLE": "a cross-timber in a shaft, also STEMPEL [n -S]\n",
  "STEMPLES": "STEMPLE, a cross-timber in a shaft, also STEMPEL [n]\n",
  "STEMS": "STEM, to staunch, stop [v]\n",
  "STEMSON": "a supporting timber of a ship [n -S]\n",
  "STEMSONS": "STEMSON, a supporting timber of a ship [n]\n",
  "STEMWARE": "a type of glassware [n -S]\n",
  "STEMWARES": "STEMWARE, a type of glassware [n]\n",
  "STEMWINDER": "a keyless pocket watch [n -S]\n",
  "STEMWINDERS": "STEMWINDER, a keyless pocket watch [n]\n",
  "STEN": "to stride vigorously, also STEND [v STENNED, STENNING, STENS]\n",
  "STENCH": "to cause to stink [v -ED, -ING, -ES]\n",
  "STENCHED": "STENCH, to cause to stink [v]\n",
  "STENCHES": "STENCH, to cause to stink [v]\n",
  "STENCHFUL": "evil-smelling [adj]\n",
  "STENCHIER": "STENCHY, having a foul odour [adj]\n",
  "STENCHIEST": "STENCHY, having a foul odour [adj]\n",
  "STENCHING": "STENCH, to cause to stink [v]\n",
  "STENCHY": "having a foul odour [adj STENCHIER, STENCHIEST]\n",
  "STENCIL": "to produce by means of a perforated sheet of material [v STENCILED or STENCILLED, STENCILING or STENCILLING, STENCILS]\n",
  "STENCILED": "STENCIL, to produce by means of a perforated sheet of material [v]\n",
  "STENCILER": "one who paints or colors in figures by means of stencil, also STENCILLER [n -S]\n",
  "STENCILERS": "STENCILER, one who paints or colors in figures by means of stencil, also STENCILLER [n]\n",
  "STENCILING": "the act of marking or painting (a surface) with an inscription or design by means of a stencil, also STENCILLING [n -S]\n",
  "STENCILINGS": "STENCILING, the act of marking or painting (a surface) with an inscription or design by means of a stencil, also STENCILLING [n]\n",
  "STENCILLED": "STENCIL, to produce by means of a perforated sheet of material [v]\n",
  "STENCILLER": "one who paints or colors in figures by means of stencil, also STENCILER [n -S]\n",
  "STENCILLERS": "STENCILLER, one who paints or colors in figures by means of stencil, also STENCILER [n]\n",
  "STENCILLING": "marking by means of a stencil, also STENCILING [n -S]\n",
  "STENCILLINGS": "STENCILLING, marking by means of a stencil, also STENCILING [n]\n",
  "STENCILS": "STENCIL, to produce by means of a perforated sheet of material [v]\n",
  "STEND": "(Scots) to bound, stride vigorously, also STEN [v -ED, -ING, -S]\n",
  "STENDED": "STEND, (Scots) to bound, stride vigorously, also STEN [v]\n",
  "STENDING": "STEND, (Scots) to bound, stride vigorously, also STEN [v]\n",
  "STENDS": "STEND, (Scots) to bound, stride vigorously, also STEN [v]\n",
  "STENGAH": "(Malay) a drink of whisky and soda [n -S]\n",
  "STENGAHS": "STENGAH, (Malay) a drink of whisky and soda [n]\n",
  "STENLOCK": "(Scots) a coalfish [n -S]\n",
  "STENLOCKS": "STENLOCK, (Scots) a coalfish [n]\n",
  "STENNED": "STEN, to stride vigorously, also STEND [v]\n",
  "STENNING": "STEN, to stride vigorously, also STEND [v]\n",
  "STENO": "(short for) a stenographer [n -S]\n",
  "STENOBATH": "a stenobathic organism [n -S]\n",
  "STENOBATHIC": "able to live only within a narrow range of depth of water [adj]\n",
  "STENOBATHS": "STENOBATH, a stenobathic organism [n]\n",
  "STENOCARDIA": "another name for the heart condition angina pectoris [n -S]\n",
  "STENOCARDIAS": "STENOCARDIA, another name for the heart condition angina pectoris [n]\n",
  "STENOCHROME": "a print by stenochromy, printing in several colours at one printing [n -S]\n",
  "STENOCHROMES": "STENOCHROME, a print by stenochromy, printing in several colours at one printing [n]\n",
  "STENOCHROMIES": "STENOCHROMY, printing in several colours at one printing [n]\n",
  "STENOCHROMY": "printing in several colours at one printing [n STENOCHROMIES]\n",
  "STENOGRAPH": "to write or report in stenographic characters [v -ED, -ING, -S]\n",
  "STENOGRAPHED": "STENOGRAPH, to write or report in stenographic characters [v]\n",
  "STENOGRAPHER": "a writer of shorthand [n -S]\n",
  "STENOGRAPHERS": "STENOGRAPHER, a writer of shorthand [n]\n",
  "STENOGRAPHIC": "relating to stenography, also STENOGRAPHICAL [adj]\n",
  "STENOGRAPHICAL": "relating to stenography, also STENOGRAPHIC [adj]\n",
  "STENOGRAPHIES": "STENOGRAPHY, the skill or occupation of writing in shorthand [n]\n",
  "STENOGRAPHING": "STENOGRAPH, to write or report in stenographic characters [v]\n",
  "STENOGRAPHIST": "one who practises stenography [n -S]\n",
  "STENOGRAPHISTS": "STENOGRAPHIST, one who practises stenography [n]\n",
  "STENOGRAPHS": "STENOGRAPH, to write or report in stenographic characters [v]\n",
  "STENOGRAPHY": "the skill or occupation of writing in shorthand [n STENOGRAPHIES]\n",
  "STENOHALINE": "of an aquatic organism, unable to withstand wide variations in salinity [adj]\n",
  "STENOKIES": "STENOKY, (Greek) the ability to live only under limited conditions [n]\n",
  "STENOKOUS": "able to live in a narrow range of environments [adj]\n",
  "STENOKY": "(Greek) the ability to live only under limited conditions [n STENOKIES]\n",
  "STENOPAEIC": "of spectacles, optical instruments, etc., having a narrow slit or aperture; designating such a slit, also STENOPAIC [adj]\n",
  "STENOPAIC": "of spectacles, optical instruments, etc., having a narrow slit or aperture; designating such a slit, also STENOPAEIC [adj]\n",
  "STENOPETALOUS": "having narrow petals [adj]\n",
  "STENOPHAGOUS": "of animals, feeding on a single type or limited variety of food [adj]\n",
  "STENOPHYLLOUS": "with narrow leaves [adj]\n",
  "STENOS": "STENO, (short for) a stenographer [n]\n",
  "STENOSED": "affected with stenosis [adj]\n",
  "STENOSES": "STENOSIS, a narrowing of a bodily passage [n]\n",
  "STENOSING": "causing or characterized by stenosis (as of a tendon sheath) [adj]\n",
  "STENOSIS": "a narrowing of a bodily passage [n STENOSES]\n",
  "STENOTHERM": "an organism capable of surviving over only a narrow range of temperatures [n -S]\n",
  "STENOTHERMAL": "capable of surviving over only a narrow range of temperatures [adj]\n",
  "STENOTHERMS": "STENOTHERM, an organism capable of surviving over only a narrow range of temperatures [n]\n",
  "STENOTIC": "relating to a stenosis, the narrowing of an orifice [adj]\n",
  "STENOTOPIC": "able to adapt only to a small range of environmental conditions, also STENOTROPIC [adj]\n",
  "STENOTROPIC": "able to adapt only to a small range of environmental conditions, also STENOTOPIC [adj]\n",
  "STENOTYPE": "a form of typewriter used for recording speech in phonetic form [n -S] / to record speech using a stenotype [v STENOTYPED, STENOTYPING, STENOTYPES]\n",
  "STENOTYPED": "STENOTYPE, to record speech using a stenotype [v]\n",
  "STENOTYPER": "one who does stenotypy, also STENOTYPIST [n -S]\n",
  "STENOTYPERS": "STENOTYPER, one who does stenotypy, also STENOTYPIST [n]\n",
  "STENOTYPES": "STENOTYPE, a form of typewriter used for recording speech in phonetic form [n]\n",
  "STENOTYPIC": "relating to a stenotype [adj]\n",
  "STENOTYPIES": "STENOTYPY, a type of shorthand using ordinary characters [n]\n",
  "STENOTYPING": "STENOTYPE, to record speech using a stenotype [v]\n",
  "STENOTYPIST": "one who types with a stenotype, also STENOTYPER [n -S]\n",
  "STENOTYPISTS": "STENOTYPIST, one who types with a stenotype, also STENOTYPER [n]\n",
  "STENOTYPY": "a type of shorthand using ordinary characters [n STENOTYPIES]\n",
  "STENS": "STEN, to stride vigorously, also STEND [v]\n",
  "STENT": "(Scots) to stint [v -ED, -ING, -S]\n",
  "STENTED": "STENT, (Scots) to stint [v]\n",
  "STENTING": "STENT, (Scots) to stint [v]\n",
  "STENTMASTER": "one who determines the amount of tax to be paid [n -S]\n",
  "STENTMASTERS": "STENTMASTER, one who determines the amount of tax to be paid [n]\n",
  "STENTOR": "a person who has a very loud voice [n -S]\n",
  "STENTORIAN": "extremely loud [adj]\n",
  "STENTORS": "STENTOR, a person who has a very loud voice [n]\n",
  "STENTOUR": "one who determines tax to be paid [n -S]\n",
  "STENTOURS": "STENTOUR, one who determines tax to be paid [n]\n",
  "STENTS": "STENT, (Scots) to stint [v]\n",
  "STEP": "to measure by pacing [v STEPPED, STEPT, STEPPING, STEPS]\n",
  "STEPBAIRN": "(Scots) a stepchild [n -S]\n",
  "STEPBAIRNS": "STEPBAIRN, (Scots) a stepchild [n]\n",
  "STEPBROTHER": "a son of one's stepparent by a former partner [n -S]\n",
  "STEPBROTHERS": "STEPBROTHER, a son of one's stepparent by a former partner [n]\n",
  "STEPCHILD": "a wife's or husband's but not one's own child, daughter or son [n STEPCHILDREN]\n",
  "STEPCHILDREN": "STEPCHILD, a wife's or husband's but not one's own child, daughter or son [n]\n",
  "STEPDAD": "a stepfather [n -S]\n",
  "STEPDADS": "STEPDAD, a stepfather [n]\n",
  "STEPDAME": "a stepmother [n -S]\n",
  "STEPDAMES": "STEPDAME, a stepmother [n]\n",
  "STEPDANCER": "one who does a step dance, a dance involving an effective display of steps by an individual dancer [n -S]\n",
  "STEPDANCERS": "STEPDANCER, one who does a step dance, a dance involving an effective display of steps by an individual dancer [n]\n",
  "STEPDANCING": "doing a step dance [n -S]\n",
  "STEPDANCINGS": "STEPDANCING, doing a step dance [n]\n",
  "STEPDAUGHTER": "a daughter of one's wife or husband by a former partner [n -S]\n",
  "STEPDAUGHTERS": "STEPDAUGHTER, a daughter of one's wife or husband by a former partner [n]\n",
  "STEPFAMILIES": "STEPFAMILY, a family acquired by a second marriage [n]\n",
  "STEPFAMILY": "a family acquired by a second marriage [n STEPFAMILIES]\n",
  "STEPFATHER": "the husband of one's mother when distinct from one's natural or legal father [n -S]\n",
  "STEPFATHERS": "STEPFATHER, the husband of one's mother when distinct from one's natural or legal father [n]\n",
  "STEPHANE": "(Greek) an ancient Greek headdress like a diadem [n -S]\n",
  "STEPHANES": "STEPHANE, (Greek) an ancient Greek headdress like a diadem [n]\n",
  "STEPHANITE": "a brittle silver ore, composed of silver, sulphur, and antimony [n -S]\n",
  "STEPHANITES": "STEPHANITE, a brittle silver ore, composed of silver, sulphur, and antimony [n]\n",
  "STEPHANOTIS": "a kind of flowering vine [n -ES]\n",
  "STEPHANOTISES": "STEPHANOTIS, a kind of flowering vine [n]\n",
  "STEPLADDER": "a ladder that has broad flat steps and two pairs of legs connected by a hinge at the top and that opens at the bottom to become freestanding [n -S]\n",
  "STEPLADDERS": "STEPLADDER, a ladder that has broad flat steps and two pairs of legs connected by a hinge at the top and that opens at the bottom to become freestanding [n]\n",
  "STEPLESS": "lacking steps [adj]\n",
  "STEPLIKE": "like a step [adj]\n",
  "STEPMOM": "(colloquial) a stepmother [n -S]\n",
  "STEPMOMS": "STEPMOM, (colloquial) a stepmother [n]\n",
  "STEPMOTHER": "the wife of one's father when distinct from one's natural or legal mother [n -S]\n",
  "STEPMOTHERLIER": "STEPMOTHERLY, like a stepmother [adj]\n",
  "STEPMOTHERLIEST": "STEPMOTHERLY, like a stepmother [adj]\n",
  "STEPMOTHERLY": "like a stepmother [adj STEPMOTHERLIER, STEPMOTHERLIEST]\n",
  "STEPMOTHERS": "STEPMOTHER, the wife of one's father when distinct from one's natural or legal mother [n]\n",
  "STEPNEY": "(slang) a spare wheel [n -S]\n",
  "STEPNEYS": "STEPNEY, (slang) a spare wheel [n]\n",
  "STEPOVER": "an instance of raising the foot over the ball while in possession in order to wrong-foot an opponent [n -S]\n",
  "STEPOVERS": "STEPOVER, an instance of raising the foot over the ball while in possession in order to wrong-foot an opponent [n]\n",
  "STEPPARENT": "a person who is a stepmother or stepfather [n -S]\n",
  "STEPPARENTING": "parenting by a stepparent [n -S]\n",
  "STEPPARENTINGS": "STEPPARENTING, parenting by a stepparent [n]\n",
  "STEPPARENTS": "STEPPARENT, a person who is a stepmother or stepfather [n]\n",
  "STEPPE": "(Russian) one of the vast plains in SE Europe and in Asia [n -S]\n",
  "STEPPED": "STEP, to measure by pacing [v]\n",
  "STEPPER": "one who steps [n -S]\n",
  "STEPPERS": "STEPPER, one who steps [n]\n",
  "STEPPES": "STEPPE, (Russian) one of the vast plains in SE Europe and in Asia [n]\n",
  "STEPPING": "STEP, to measure by pacing [v]\n",
  "STEPS": "STEP, to measure by pacing [v]\n",
  "STEPSISTER": "a daughter of one's stepparent by a former partner [n -S]\n",
  "STEPSISTERS": "STEPSISTER, a daughter of one's stepparent by a former partner [n]\n",
  "STEPSON": "a son of one's spouse by a former marriage [n -S]\n",
  "STEPSONS": "STEPSON, a son of one's spouse by a former marriage [n]\n",
  "STEPSTOOL": "a stool able to be used as a step [n -S]\n",
  "STEPSTOOLS": "STEPSTOOL, a stool able to be used as a step [n]\n",
  "STEPT": "STEP, to measure by pacing [v]\n",
  "STEPWISE": "marked by a gradual progression [adj]\n",
  "STERADIAN": "a unit of measurement for solid angles [n -S]\n",
  "STERADIANS": "STERADIAN, a unit of measurement for solid angles [n]\n",
  "STERANE": "any of a class of saturated polycyclic hydrocarbons found in crude oils [n -S]\n",
  "STERANES": "STERANE, any of a class of saturated polycyclic hydrocarbons found in crude oils [n]\n",
  "STERCORACEOUS": "of or relating to feces [adj]\n",
  "STERCORAL": "pertaining to dung [adj]\n",
  "STERCORANISM": "formerly, a name for the belief that the sacramental bread is digested and evacuated like other food [n -S]\n",
  "STERCORANISMS": "STERCORANISM, formerly, a name for the belief that the sacramental bread is digested and evacuated like other food [n]\n",
  "STERCORANIST": "a disparaging nickname given to one who holds that the consecrated elements of the Eucharist undergo digestion in and evacuation from the body of the recipient [n -S]\n",
  "STERCORANISTS": "STERCORANIST, a disparaging nickname given to one who holds that the consecrated elements of the Eucharist undergo digestion in and evacuation from the body of the recipient [n]\n",
  "STERCORARIES": "STERCORARY, a weatherproof place where dung is stored [n]\n",
  "STERCORARIOUS": "relating to dung, also STERCORARY [adj]\n",
  "STERCORARY": "relating to dung, also STERCORARIOUS [adj] / a weatherproof place where dung is stored [n STERCORARIES]\n",
  "STERCORATE": "to defecate [v STERCORATED, STERCORATING, STERCORATES]\n",
  "STERCORATED": "STERCORATE, to defecate [v]\n",
  "STERCORATES": "STERCORATE, to defecate [v]\n",
  "STERCORATING": "STERCORATE, to defecate [v]\n",
  "STERCORICOLOUS": "living in dung [adj]\n",
  "STERCULIA": "any tree or shrub of genus Sterculia, including kola and cacao [n -S]\n",
  "STERCULIACEOUS": "belonging to the Sterculiaceae, a chiefly tropical family of plants that includes cacao and cola [adj]\n",
  "STERCULIAS": "STERCULIA, any tree or shrub of genus Sterculia, including kola and cacao [n]\n",
  "STERE": "(French) a timber measure, a cubic metre (about 35.315 cubic feet) [n -S]\n",
  "STEREO": "to make a type of printing plate [v -ED, -ING, -S]\n",
  "STEREOACUITIES": "STEREOACUITY, the degree to which a person is aware of the separation of objects along the line of sight [n]\n",
  "STEREOACUITY": "the degree to which a person is aware of the separation of objects along the line of sight [n STEREOACUITIES]\n",
  "STEREOBATE": "a substructure foundation [n -S]\n",
  "STEREOBATES": "STEREOBATE, a substructure foundation [n]\n",
  "STEREOBATIC": "of or like a stereobate, a substructure foundation [adj]\n",
  "STEREOBLIND": "having two-dimensional rather than normal three-dimensional vision [adj]\n",
  "STEREOCARD": "a card on which a pair of stereoscopic pictures are mounted [n -S]\n",
  "STEREOCARDS": "STEREOCARD, a card on which a pair of stereoscopic pictures are mounted [n]\n",
  "STEREOCHEMICAL": "relating to stereochemistry [adj]\n",
  "STEREOCHEMISTRY": "chemical study of arrangement of molecules and atoms [n]\n",
  "STEREOCHROME": "a mural painting fixed with waterglass [n -S] / to paint a mural fixed with waterglass [v STEREOCHROMED, STEREOCHROMING, STEREOCHROMES]\n",
  "STEREOCHROMED": "STEREOCHROME, to paint a mural fixed with waterglass [v]\n",
  "STEREOCHROMES": "STEREOCHROME, a mural painting fixed with waterglass [n]\n",
  "STEREOCHROMIES": "STEREOCHROMY, colourful wall painting [n]\n",
  "STEREOCHROMING": "STEREOCHROME, to paint a mural fixed with waterglass [v]\n",
  "STEREOCHROMY": "colourful wall painting [n STEREOCHROMIES]\n",
  "STEREOED": "STEREO, to make a type of printing plate [v]\n",
  "STEREOGNOSES": "STEREOGNOSIS, the ability to establish the weight and form of an object by touch alone [n]\n",
  "STEREOGNOSIS": "the ability to establish the weight and form of an object by touch alone [n STEREOGNOSES]\n",
  "STEREOGRAM": "a diagram or picture which represents objects in such a way as to give the impression of relief or solidity [n -S]\n",
  "STEREOGRAMS": "STEREOGRAM, a diagram or picture which represents objects in such a way as to give the impression of relief or solidity [n]\n",
  "STEREOGRAPH": "a picture used in stereoscope [n -S] / to make a stereograph [v -ED, -ING, -S]\n",
  "STEREOGRAPHED": "STEREOGRAPH, to make a stereograph [v]\n",
  "STEREOGRAPHIC": "of, relating to, or being a delineation of the form of a solid body (as the earth) on a plane, also STEREOGRAPHICAL [adj]\n",
  "STEREOGRAPHICAL": "of, relating to, or being a delineation of the form of a solid body (as the earth) on a plane, also STEREOGRAPHIC [adj]\n",
  "STEREOGRAPHIES": "STEREOGRAPHY, the representation of solid bodies on a plane surface [n]\n",
  "STEREOGRAPHING": "STEREOGRAPH, to make a stereograph [v]\n",
  "STEREOGRAPHS": "STEREOGRAPH, a picture used in stereoscope [n]\n",
  "STEREOGRAPHY": "the representation of solid bodies on a plane surface [n STEREOGRAPHIES]\n",
  "STEREOING": "STEREO, to make a type of printing plate [v]\n",
  "STEREOISOMER": "any of a group of isomers in which atoms are linked in the same order but differ in their spatial arrangement [n -S]\n",
  "STEREOISOMERIC": "of or like a stereoisomer [adj]\n",
  "STEREOISOMERISM": "the property of substances which are stereoisomers [n]\n",
  "STEREOISOMERS": "STEREOISOMER, any of a group of isomers in which atoms are linked in the same order but differ in their spatial arrangement [n]\n",
  "STEREOISOMETRIC": "related to stereoisomerism [adj]\n",
  "STEREOLOGICAL": "relating to stereology [adj STEREOLOGICALLY]\n",
  "STEREOLOGICALLY": "STEREOLOGICAL, relating to stereology [adv]\n",
  "STEREOLOGIES": "STEREOLOGY, the study of three-dimensional properties of objects usually observed two-dimensionally [n]\n",
  "STEREOLOGY": "the study of three-dimensional properties of objects usually observed two-dimensionally [n STEREOLOGIES]\n",
  "STEREOME": "mechanical tissue in plants [n -S]\n",
  "STEREOMES": "STEREOME, mechanical tissue in plants [n]\n",
  "STEREOMETER": "an instrument for measuring specific gravity [n -S]\n",
  "STEREOMETERS": "STEREOMETER, an instrument for measuring specific gravity [n]\n",
  "STEREOMETRIC": "relating to the measurement of specific gravity, also STEREOMETRICAL [adj]\n",
  "STEREOMETRICAL": "relating to the measurement of specific gravity, also STEREOMETRIC [adj]\n",
  "STEREOMETRIES": "STEREOMETRY, the measurement of volumes of solid figures [n]\n",
  "STEREOMETRY": "the measurement of volumes of solid figures [n STEREOMETRIES]\n",
  "STEREOPHONIC": "of, relating to, or constituting sound reproduction involving the use of separated microphones and two transmission channels to achieve the sound separation of a live hearing [adj]\n",
  "STEREOPHONIES": "STEREOPHONY, the reproduction of sound [n]\n",
  "STEREOPHONY": "the reproduction of sound [n STEREOPHONIES]\n",
  "STEREOPSES": "STEREOPSIS, stereoscopic or three-dimensional vision [n]\n",
  "STEREOPSIS": "stereoscopic or three-dimensional vision [n STEREOPSES]\n",
  "STEREOPTICON": "a projector for transparent slides often made double so as to produce dissolving views [n -S]\n",
  "STEREOPTICONS": "STEREOPTICON, a projector for transparent slides often made double so as to produce dissolving views [n]\n",
  "STEREOPTICS": "the optics of stereoscopy [n]\n",
  "STEREOREGULAR": "of, relating to, or involving stereochemical regularity in the repeating units of a polymeric structure [adj]\n",
  "STEREOS": "STEREO, to make a type of printing plate [v]\n",
  "STEREOSCOPE": "an instrument for viewing special three-dimensional photographs [n -S]\n",
  "STEREOSCOPES": "STEREOSCOPE, an instrument for viewing special three-dimensional photographs [n]\n",
  "STEREOSCOPIC": "of or relating to stereoscopy or the stereoscope, also STEREOSCOPICAL [adj]\n",
  "STEREOSCOPICAL": "of or relating to stereoscopy or the stereoscope, also STEREOSCOPIC [adj]\n",
  "STEREOSCOPIES": "STEREOSCOPY, the use of a stereoscope [n]\n",
  "STEREOSCOPIST": "one who uses a stereoscope, an instrument for viewing special three-dimensional photographs [n -S]\n",
  "STEREOSCOPISTS": "STEREOSCOPIST, one who uses a stereoscope, an instrument for viewing special three-dimensional photographs [n]\n",
  "STEREOSCOPY": "the use of a stereoscope [n STEREOSCOPIES]\n",
  "STEREOSONIC": "stereophonic [adj]\n",
  "STEREOSPECIFIC": "being, produced by, or involved in a stereochemically specific process [adj]\n",
  "STEREOTACTIC": "involving or used in a surgical technique for directing the tip of a delicate instrument or beam of radiation using coordinates provided by medical imaging, also STEREOTACTICAL [adj]\n",
  "STEREOTACTICAL": "involving or used in a surgical technique for directing the tip of a delicate instrument or beam of radiation using coordinates provided by medical imaging, also STEREOTACTIC [adj]\n",
  "STEREOTAXES": "STEREOTAXIS, the reaction of an organism to contact with a solid body [n]\n",
  "STEREOTAXIA": "the electrical destruction of a small area of brain tissue, using stereotactic methods, to relieve disorders such as epilepsy and Parkinsonism [n -S]\n",
  "STEREOTAXIAS": "STEREOTAXIA, the electrical destruction of a small area of brain tissue, using stereotactic methods, to relieve disorders such as epilepsy and Parkinsonism [n]\n",
  "STEREOTAXIC": "relating to stereotaxis, the reaction of an organism to contact with a solid body [adj STEREOTAXICALLY]\n",
  "STEREOTAXICALLY": "STEREOTAXIC, relating to stereotaxis, the reaction of an organism to contact with a solid body [adv]\n",
  "STEREOTAXIS": "the reaction of an organism to contact with a solid body [n STEREOTAXES]\n",
  "STEREOTOMIES": "STEREOTOMY, the cutting of stone or other solid materials [n]\n",
  "STEREOTOMY": "the cutting of stone or other solid materials [n STEREOTOMIES]\n",
  "STEREOTROPIC": "relating to stereotropism [adj]\n",
  "STEREOTROPISM": "the tendency to bend or turn in response to contact with a solid object [n -S]\n",
  "STEREOTROPISMS": "STEREOTROPISM, the tendency to bend or turn in response to contact with a solid object [n]\n",
  "STEREOTYPE": "a fixed conventionalized or stock image [n -S] / to make a stereotype of [v STEREOTYPED, STEREOTYPING, STEREOTYPES]\n",
  "STEREOTYPED": "STEREOTYPE, to make a stereotype of [v]\n",
  "STEREOTYPER": "one who stereotypes [n -S]\n",
  "STEREOTYPERS": "STEREOTYPER, one who stereotypes [n]\n",
  "STEREOTYPES": "STEREOTYPE, a fixed conventionalized or stock image [n]\n",
  "STEREOTYPIC": "of or like a stereotype, also STEREOTYPICAL [adj STEREOTYPICALLY]\n",
  "STEREOTYPICAL": "of or like a stereotype, also STEREOTYPIC [adj STEREOTYPICALLY]\n",
  "STEREOTYPICALLY": "STEREOTYPICAL, of or like a stereotype, also STEREOTYPIC [adv]\n",
  "STEREOTYPIES": "STEREOTYPY, the art or process of making stereotype plates [n]\n",
  "STEREOTYPING": "the act of making a stereotype [n -S]\n",
  "STEREOTYPINGS": "STEREOTYPING, the act of making a stereotype [n]\n",
  "STEREOTYPIST": "one who makes stereotypes [n -S]\n",
  "STEREOTYPISTS": "STEREOTYPIST, one who makes stereotypes [n]\n",
  "STEREOTYPY": "the art or process of making stereotype plates [n STEREOTYPIES]\n",
  "STEREOVISION": "the perception or exhibition of three-dimensional objects in three dimensions [n -S]\n",
  "STEREOVISIONS": "STEREOVISION, the perception or exhibition of three-dimensional objects in three dimensions [n]\n",
  "STERES": "STERE, (French) a timber measure, a cubic metre (about 35.315 cubic feet) [n]\n",
  "STERIC": "pertaining to atoms in a molecule, also STERICAL [adj STERICALLY]\n",
  "STERICAL": "pertaining to atoms in a molecule, also STERIC [adj STERICALLY]\n",
  "STERICALLY": "STERICAL, pertaining to atoms in a molecule, also STERIC [adv]\n",
  "STERIGMA": "(Greek) a spore-bearing stalk of certain fungi [n STERIGMAS or STERIGMATA]\n",
  "STERIGMAS": "STERIGMA, (Greek) a spore-bearing stalk of certain fungi [n]\n",
  "STERIGMATA": "STERIGMA, (Greek) a spore-bearing stalk of certain fungi [n]\n",
  "STERILANT": "a sterilizing agent [n -S]\n",
  "STERILANTS": "STERILANT, a sterilizing agent [n]\n",
  "STERILE": "incapable of producing offspring [adj STERILELY]\n",
  "STERILELY": "STERILE, incapable of producing offspring [adv]\n",
  "STERILISABLE": "that can be sterilised, also STERILIZABLE [adj]\n",
  "STERILISATION": "the act of sterilising, also STERILIZATION [n -S]\n",
  "STERILISATIONS": "STERILISATION, the act of sterilising, also STERILIZATION [n]\n",
  "STERILISE": "to make sterile, also STERILIZE [v STERILISED, STERILISING, STERILISES]\n",
  "STERILISED": "STERILISE, to make sterile, also STERILIZE [v]\n",
  "STERILISER": "an apparatus for sterilising, also STERILIZER [n -S]\n",
  "STERILISERS": "STERILISER, an apparatus for sterilising, also STERILIZER [n]\n",
  "STERILISES": "STERILISE, to make sterile, also STERILIZE [v]\n",
  "STERILISING": "STERILISE, to make sterile, also STERILIZE [v]\n",
  "STERILITIES": "STERILITY, the quality of being sterile [n]\n",
  "STERILITY": "the quality of being sterile [n STERILITIES]\n",
  "STERILIZABLE": "that can be sterilized, also STERILISABLE [adj]\n",
  "STERILIZATION": "the act of sterilizing, also STERILISATION [n -S]\n",
  "STERILIZATIONS": "STERILIZATION, the act of sterilizing, also STERILISATION [n]\n",
  "STERILIZE": "to render sterile, also STERILISE [v STERILIZED, STERILIZING, STERILIZES]\n",
  "STERILIZED": "STERILIZE, to render sterile, also STERILISE [v]\n",
  "STERILIZER": "an apparatus for sterilising, also STERILISER [n -S]\n",
  "STERILIZERS": "STERILIZER, an apparatus for sterilising, also STERILISER [n]\n",
  "STERILIZES": "STERILIZE, to render sterile, also STERILISE [v]\n",
  "STERILIZING": "STERILIZE, to render sterile, also STERILISE [v]\n",
  "STERLET": "(Russian) a small sturgeon found in the Caspian Sea [n -S]\n",
  "STERLETS": "STERLET, (Russian) a small sturgeon found in the Caspian Sea [n]\n",
  "STERLING": "genuine, authentic [adj STERLINGLY] / an English penny of the Norman and subsequent dynasties [n -S]\n",
  "STERLINGLY": "STERLING, genuine, authentic [adv]\n",
  "STERLINGNESS": "the state of being sterling [n -ES]\n",
  "STERLINGNESSES": "STERLINGNESS, the state of being sterling [n]\n",
  "STERLINGS": "STERLING, an English penny of the Norman and subsequent dynasties [n]\n",
  "STERN": "severe [adj STERNER, STERNEST, STERNLY] / to back, row backwards, also STARN [v -ED, -ING, -S]\n",
  "STERNA": "STERNUM, (Greek) a long, flat supporting bone of most vertebrates [n]\n",
  "STERNAGE": "(Shakespeare) sterns collectively [n -S]\n",
  "STERNAGES": "STERNAGE, (Shakespeare) sterns collectively [n]\n",
  "STERNAL": "pertaining to the sternum [adj]\n",
  "STERNALGIA": "pain around the sternum, angina pectoris [n -S]\n",
  "STERNALGIAS": "STERNALGIA, pain around the sternum, angina pectoris [n]\n",
  "STERNALGIC": "relating to sternalgia, pain around the sternum [adj]\n",
  "STERNBOARD": "the backward motion of a ship; loss of way in tacking [n -S]\n",
  "STERNBOARDS": "STERNBOARD, the backward motion of a ship; loss of way in tacking [n]\n",
  "STERNEBRA": "one of the segments of the sternum [n STERNEBRAE]\n",
  "STERNEBRAE": "STERNEBRA, one of the segments of the sternum [n]\n",
  "STERNED": "STERN, to back, row backwards, also STARN [v]\n",
  "STERNER": "STERN, severe [adj]\n",
  "STERNEST": "STERN, severe [adj]\n",
  "STERNFAST": "a rope or chain for making fast a ship's stern to a wharf [n -S]\n",
  "STERNFASTS": "STERNFAST, a rope or chain for making fast a ship's stern to a wharf [n]\n",
  "STERNFOREMOST": "with the stern in advance [adv]\n",
  "STERNING": "STERN, to back, row backwards, also STARN [v]\n",
  "STERNITE": "the ventral plate of a segment in arthropods [n -S]\n",
  "STERNITES": "STERNITE, the ventral plate of a segment in arthropods [n]\n",
  "STERNITIC": "relating to the sternite, the sternum of an arthropod somite [adj]\n",
  "STERNLY": "STERN, severe [adv]\n",
  "STERNMOST": "farthest astern; as, the sternmost ship in a convoy [adj]\n",
  "STERNNESS": "the state of being stern [n -ES]\n",
  "STERNNESSES": "STERNNESS, the state of being stern [n]\n",
  "STERNOCOSTAL": "of, relating to, or situated between the sternum and ribs [adj]\n",
  "STERNOTRIBE": "pollinated by touching an insect's undersurface [adj]\n",
  "STERNPORT": "a port or opening in the stern of a ship [n -S]\n",
  "STERNPORTS": "STERNPORT, a port or opening in the stern of a ship [n]\n",
  "STERNPOST": "the main member at the stern of a ship extending from keel to deck [n -S]\n",
  "STERNPOSTS": "STERNPOST, the main member at the stern of a ship extending from keel to deck [n]\n",
  "STERNS": "STERN, to back, row backwards, also STARN [v]\n",
  "STERNSHEET": "the part of a boat between the stern and the rowers [n -S]\n",
  "STERNSHEETS": "STERNSHEET, the part of a boat between the stern and the rowers [n]\n",
  "STERNSON": "the end of a ship's keelson, to which the sternpost is bolted [n -S]\n",
  "STERNSONS": "STERNSON, the end of a ship's keelson, to which the sternpost is bolted [n]\n",
  "STERNUM": "(Greek) a long, flat supporting bone of most vertebrates [n STERNUMS or STERNA]\n",
  "STERNUMS": "STERNUM, (Greek) a long, flat supporting bone of most vertebrates [n]\n",
  "STERNUTATION": "the act of sneezing [n -S]\n",
  "STERNUTATIONS": "STERNUTATION, the act of sneezing [n]\n",
  "STERNUTATIVE": "a substance which causes sneezing, also STERNUTATOR, STERNUTATORY [n -S]\n",
  "STERNUTATIVES": "STERNUTATIVE, a substance which causes sneezing, also STERNUTATOR, STERNUTATORY [n]\n",
  "STERNUTATOR": "a substance which causes sneezing, also STERNUTATIVE, STERNUTATORY [n -S]\n",
  "STERNUTATORIES": "STERNUTATORY, a substance which causes sneezing, also STERNUTATIVE, STERNUTATOR [n]\n",
  "STERNUTATORS": "STERNUTATOR, a substance which causes sneezing, also STERNUTATIVE, STERNUTATORY [n]\n",
  "STERNUTATORY": "a substance which causes sneezing, also STERNUTATIVE, STERNUTATOR [n STERNUTATORIES]\n",
  "STERNWARD": "towards the stern, also STERNWARDS [adv]\n",
  "STERNWARDS": "towards the stern, also STERNWARD [adv]\n",
  "STERNWAY": "the backward movement of a vessel [n -S]\n",
  "STERNWAYS": "STERNWAY, the backward movement of a vessel [n]\n",
  "STERNWORKS": "hinder parts [n]\n",
  "STEROID": "any of a class of compounds including the sterols, bile acids, adrenal hormones, sex hormones [n -S]\n",
  "STEROIDAL": "relating to steroids [adj]\n",
  "STEROIDOGENESES": "STEROIDOGENESIS, the synthesis of steroids [n]\n",
  "STEROIDOGENESIS": "the synthesis of steroids [n STEROIDOGENESES]\n",
  "STEROIDOGENIC": "relating to steroidogenesis [adj]\n",
  "STEROIDS": "STEROID, any of a class of compounds including the sterols, bile acids, adrenal hormones, sex hormones [n]\n",
  "STEROL": "a solid higher alcohol, such as cholesterol or ergosterol [n -S]\n",
  "STEROLS": "STEROL, a solid higher alcohol, such as cholesterol or ergosterol [n]\n",
  "STERTOR": "(Latin) a heavy snoring sound, as that accompanying breathing in a deeply unconscious person [n -S]\n",
  "STERTOROUS": "with a snoring sound [adj STERTOROUSLY]\n",
  "STERTOROUSLY": "STERTOROUS, with a snoring sound [adv]\n",
  "STERTOROUSNESS": "the state of being stertorous [n]\n",
  "STERTORS": "STERTOR, (Latin) a heavy snoring sound, as that accompanying breathing in a deeply unconscious person [n]\n",
  "STERVE": "(Spenser) to starve, die [v STERVED, STERVING, STERVES]\n",
  "STERVED": "STERVE, (Spenser) to starve, die [v]\n",
  "STERVES": "STERVE, (Spenser) to starve, die [v]\n",
  "STERVING": "STERVE, (Spenser) to starve, die [v]\n",
  "STET": "(Latin) to cancel a previously made printing correction [v STETTED, STETTING, STETS]\n",
  "STETHOSCOPE": "an instrument with which to listen to the sounds produced by the heart, lungs, etc. [n -S]\n",
  "STETHOSCOPES": "STETHOSCOPE, an instrument with which to listen to the sounds produced by the heart, lungs, etc. [n]\n",
  "STETHOSCOPIC": "relating to use of the stethoscope [adj]\n",
  "STETHOSCOPIES": "STETHOSCOPY, examination with a stethoscope [n]\n",
  "STETHOSCOPIST": "one who uses a stethoscope [n -S]\n",
  "STETHOSCOPISTS": "STETHOSCOPIST, one who uses a stethoscope [n]\n",
  "STETHOSCOPY": "examination with a stethoscope [n STETHOSCOPIES]\n",
  "STETS": "STET, (Latin) to cancel a previously made printing correction [v]\n",
  "STETSON": "(tradename) a broad-brimmed high-crowned felt hat [n -S]\n",
  "STETSONS": "STETSON, (tradename) a broad-brimmed high-crowned felt hat [n]\n",
  "STETTED": "STET, (Latin) to cancel a previously made printing correction [v]\n",
  "STETTING": "STET, (Latin) to cancel a previously made printing correction [v]\n",
  "STEVEDORE": "a dock worker who loads and unloads ships [n -S] / to work as a stevedore [v STEVEDORED, STEVEDORING, STEVEDORES]\n",
  "STEVEDORED": "STEVEDORE, to work as a stevedore [v]\n",
  "STEVEDORES": "STEVEDORE, a dock worker who loads and unloads ships [n]\n",
  "STEVEDORING": "the work of a stevedore [n -S]\n",
  "STEVEDORINGS": "STEVEDORING, the work of a stevedore [n]\n",
  "STEVEN": "(dialect) a voice; an outcry [n -S]\n",
  "STEVENGRAPH": "a silk picture woven in colours [n -S]\n",
  "STEVENGRAPHS": "STEVENGRAPH, a silk picture woven in colours [n]\n",
  "STEVENS": "STEVEN, (dialect) a voice; an outcry [n]\n",
  "STEVIA": "a South American plant cultivated for its sweet-tasting leaves; an extract of this plant used to sweeten foods [n -S]\n",
  "STEVIAS": "STEVIA, a South American plant cultivated for its sweet-tasting leaves; an extract of this plant used to sweeten foods [n]\n",
  "STEW": "to cook by boiling slowly [v -ED, -ING, -S]\n",
  "STEWABLE": "able to be stewed [adj]\n",
  "STEWARD": "to act as a steward [v -ED, -ING, -S]\n",
  "STEWARDED": "STEWARD, to act as a steward [v]\n",
  "STEWARDESS": "a woman who performs the duties of a steward [n -ES]\n",
  "STEWARDESSES": "STEWARDESS, a woman who performs the duties of a steward [n]\n",
  "STEWARDING": "STEWARD, to act as a steward [v]\n",
  "STEWARDRIES": "STEWARDRY, being a steward [n]\n",
  "STEWARDRY": "being a steward [n STEWARDRIES]\n",
  "STEWARDS": "STEWARD, to act as a steward [v]\n",
  "STEWARDSHIP": "the office, duties, and obligations of a steward [n -S]\n",
  "STEWARDSHIPS": "STEWARDSHIP, the office, duties, and obligations of a steward [n]\n",
  "STEWARTRIES": "STEWARTRY, (Scots) a former territorial division of Scotland (abolished in 1747) under the jurisdiction of a steward; now only in The Stewartry, the Kirkcudbright district of Galloway [n]\n",
  "STEWARTRY": "(Scots) a former territorial division of Scotland (abolished in 1747) under the jurisdiction of a steward; now only in The Stewartry, the Kirkcudbright district of Galloway [n STEWARTRIES]\n",
  "STEWBUM": "a drunken bum [n -S]\n",
  "STEWBUMS": "STEWBUM, a drunken bum [n]\n",
  "STEWED": "STEW, to cook by boiling slowly [v]\n",
  "STEWER": "one who stews [n -S]\n",
  "STEWERS": "STEWER, one who stews [n]\n",
  "STEWIER": "STEWY, like a stew [adj]\n",
  "STEWIEST": "STEWY, like a stew [adj]\n",
  "STEWING": "the act of stewing [n -S]\n",
  "STEWINGS": "STEWING, the act of stewing [n]\n",
  "STEWPAN": "a pan used for stewing [n -S]\n",
  "STEWPANS": "STEWPAN, a pan used for stewing [n]\n",
  "STEWPOND": "a fish pond [n -S]\n",
  "STEWPONDS": "STEWPOND, a fish pond [n]\n",
  "STEWPOT": "a pot for cooking stew [n -S]\n",
  "STEWPOTS": "STEWPOT, a pot for cooking stew [n]\n",
  "STEWS": "STEW, to cook by boiling slowly [v]\n",
  "STEWY": "like a stew [adj STEWIER, STEWIEST]\n",
  "STEY": "(Scots) steep [adj STEYER, STEYEST] / a ladder [n -S]\n",
  "STEYER": "STEY, (Scots) steep [adj]\n",
  "STEYEST": "STEY, (Scots) steep [adj]\n",
  "STEYS": "STEY, a ladder [n]\n",
  "STHENIA": "unusual or abnormal strength [n -S]\n",
  "STHENIAS": "STHENIA, unusual or abnormal strength [n]\n",
  "STHENIC": "(Greek) strong, robust [adj]\n",
  "STIACCIATO": "(Italian) very low relief, as on coins [n -S]\n",
  "STIACCIATOS": "STIACCIATO, (Italian) very low relief, as on coins [n]\n",
  "STIBBLE": "(Scots) the leavings of a crop after harvest, also STUBBLE [n -S]\n",
  "STIBBLER": "(Scots) a horse turned out to feed on stubble [n -S]\n",
  "STIBBLERS": "STIBBLER, (Scots) a horse turned out to feed on stubble [n]\n",
  "STIBBLES": "STIBBLE, (Scots) the leavings of a crop after harvest, also STUBBLE [n]\n",
  "STIBIAL": "pertaining to antimony (stibium) [adj]\n",
  "STIBIALISM": "antimony poisoning [n -S]\n",
  "STIBIALISMS": "STIBIALISM, antimony poisoning [n]\n",
  "STIBINE": "antimony hydride, a poisonous gas [n -S]\n",
  "STIBINES": "STIBINE, antimony hydride, a poisonous gas [n]\n",
  "STIBIUM": "(Latin) antimony [n -S]\n",
  "STIBIUMS": "STIBIUM, (Latin) antimony [n]\n",
  "STIBNITE": "an ore of antimony [n -S]\n",
  "STIBNITES": "STIBNITE, an ore of antimony [n]\n",
  "STICCADO": "(Italian) an instrument like a xylophone, also STICCATO [n -ES or -S]\n",
  "STICCADOES": "STICCADO, (Italian) an instrument like a xylophone, also STICCATO [n]\n",
  "STICCADOS": "STICCADO, (Italian) an instrument like a xylophone, also STICCATO [n]\n",
  "STICCATO": "(Italian) an instrument like a xylophone, also STICCADO [n -ES or -S]\n",
  "STICCATOES": "STICCATO, (Italian) an instrument like a xylophone, also STICCADO [n]\n",
  "STICCATOS": "STICCATO, (Italian) an instrument like a xylophone, also STICCADO [n]\n",
  "STICH": "(Greek) a line of verse, or section of prose of comparable length [n -S]\n",
  "STICHARIA": "STICHARION, a vestment like an alb worn by Orthodox priests [n]\n",
  "STICHARION": "a vestment like an alb worn by Orthodox priests [n STICHARIA or STICHARIONS]\n",
  "STICHARIONS": "STICHARION, a vestment like an alb worn by Orthodox priests [n]\n",
  "STICHERA": "STICHERON, (Greek) a short hymn [n]\n",
  "STICHERON": "(Greek) a short hymn [n STICHERA]\n",
  "STICHIC": "relating to verse composed in homogeneous and recurrent lines, as in recitative poetry [adj STICHICALLY]\n",
  "STICHICALLY": "STICHIC, relating to verse composed in homogeneous and recurrent lines, as in recitative poetry [adv]\n",
  "STICHIDIA": "STICHIDIUM, a branch producing tetraspores, in red seaweeds [n]\n",
  "STICHIDIUM": "a branch producing tetraspores, in red seaweeds [n STICHIDIA]\n",
  "STICHOI": "STICHOS, (Greek) a stichometric line of a manuscript; a verse [n]\n",
  "STICHOLOGIES": "STICHOLOGY, metrical theory [n]\n",
  "STICHOLOGY": "metrical theory [n STICHOLOGIES]\n",
  "STICHOMETRIC": "relating to stichometry, also STICHOMETRICAL [adj]\n",
  "STICHOMETRICAL": "relating to stichometry, also STICHOMETRIC [adj]\n",
  "STICHOMETRIES": "STICHOMETRY, the numbering or counting of lines in books or documents [n]\n",
  "STICHOMETRY": "the numbering or counting of lines in books or documents [n STICHOMETRIES]\n",
  "STICHOMYTHIA": "dialogue in alternate lines, also STICHOMYTHY [n -S]\n",
  "STICHOMYTHIAS": "STICHOMYTHIA, dialogue in alternate lines, also STICHOMYTHY [n]\n",
  "STICHOMYTHIC": "relating to stichomythia [adj]\n",
  "STICHOMYTHIES": "STICHOMYTHY, dialogue in alternate lines, also STICHOMYTHIA [n]\n",
  "STICHOMYTHY": "dialogue in alternate lines, also STICHOMYTHIA [n STICHOMYTHIES]\n",
  "STICHOS": "(Greek) a stichometric line of a manuscript; a verse [n STICHOI]\n",
  "STICHS": "STICH, (Greek) a line of verse, or section of prose of comparable length [n]\n",
  "STICK": "to support with slender pieces of wood [v STICKED, STICKING, STICKS] / to pierce with a pointed object [v STUCK, STICKIT, STICKING, STICKS]\n",
  "STICKABILITIES": "STICKABILITY, the quality of being stickable [n]\n",
  "STICKABILITY": "the quality of being stickable [n STICKABILITIES]\n",
  "STICKABLE": "that can be stuck [adj]\n",
  "STICKBALL": "baseball adapted for play in streets, using a broom handle and a lightweight ball [n -S]\n",
  "STICKBALLS": "STICKBALL, baseball adapted for play in streets, using a broom handle and a lightweight ball [n]\n",
  "STICKED": "STICK, to support with slender pieces of wood [v]\n",
  "STICKER": "to apply adhesive labels to [v -ED, -ING, -S]\n",
  "STICKERED": "STICKER, to apply adhesive labels to [v]\n",
  "STICKERING": "STICKER, to apply adhesive labels to [v]\n",
  "STICKERS": "STICKER, to apply adhesive labels to [v]\n",
  "STICKFUL": "as much set type as fills a composing stick [n -S]\n",
  "STICKFULS": "STICKFUL, as much set type as fills a composing stick [n]\n",
  "STICKHANDLE": "to manoeuvre (the puck) deftly in ice hockey [v STICKHANDLED, STICKHANDLING, STICKHANDLES]\n",
  "STICKHANDLED": "STICKHANDLE, to manoeuvre (the puck) deftly in ice hockey [v]\n",
  "STICKHANDLER": "one who stickhandles, controls the puck or ball in a game played with a stick [n -S]\n",
  "STICKHANDLERS": "STICKHANDLER, one who stickhandles, controls the puck or ball in a game played with a stick [n]\n",
  "STICKHANDLES": "STICKHANDLE, to manoeuvre (the puck) deftly in ice hockey [v]\n",
  "STICKHANDLING": "the act of manoeuvring (the puck) deftly in ice hockey [n -S]\n",
  "STICKHANDLINGS": "STICKHANDLING, the act of manoeuvring (the puck) deftly in ice hockey [n]\n",
  "STICKIE": "a slip of notepaper having an adhesive strip on the back [n STICKIES]\n",
  "STICKIED": "STICKY, to make sticky [v]\n",
  "STICKIER": "STICKY, adhesive [adj]\n",
  "STICKIES": "STICKY, to make sticky [v]\n",
  "STICKIEST": "STICKY, adhesive [adj]\n",
  "STICKILY": "STICKY, adhesive [adv]\n",
  "STICKINESS": "the state of being sticky [n -ES]\n",
  "STICKINESSES": "STICKINESS, the state of being sticky [n]\n",
  "STICKING": "the act of sticking [n -S]\n",
  "STICKINGS": "STICKING, the act of sticking [n]\n",
  "STICKIT": "(Scots) unfinished; having failed esp. in an intended profession [adj]\n",
  "STICKJAW": "a sweet meat [n -S]\n",
  "STICKJAWS": "STICKJAW, a sweet meat [n]\n",
  "STICKLE": "to argue stubbornly [v STICKLED, STICKLING, STICKLES]\n",
  "STICKLEADER": "the leader of a stick of paratroops [n -S]\n",
  "STICKLEADERS": "STICKLEADER, the leader of a stick of paratroops [n]\n",
  "STICKLEBACK": "a freshwater fish with a spiny back [n -S]\n",
  "STICKLEBACKS": "STICKLEBACK, a freshwater fish with a spiny back [n]\n",
  "STICKLED": "STICKLE, to argue stubbornly [v]\n",
  "STICKLER": "one who has scruples [n -S]\n",
  "STICKLERS": "STICKLER, one who has scruples [n]\n",
  "STICKLES": "STICKLE, to argue stubbornly [v]\n",
  "STICKLIKE": "like a stick [adj]\n",
  "STICKLING": "making objections [n -S]\n",
  "STICKLINGS": "STICKLING, making objections [n]\n",
  "STICKMAN": "one who supervises play at a dice table [n STICKMEN]\n",
  "STICKMEN": "STICKMAN, one who supervises play at a dice table [n]\n",
  "STICKOUT": "one who is conspicuous [n -S]\n",
  "STICKOUTS": "STICKOUT, one who is conspicuous [n]\n",
  "STICKPIN": "a decorative tiepin [n -S]\n",
  "STICKPINS": "STICKPIN, a decorative tiepin [n]\n",
  "STICKS": "STICK, to support with slender pieces of wood [v]\n",
  "STICKSEED": "any of various weedy herbs of the borage family [n -S]\n",
  "STICKSEEDS": "STICKSEED, any of various weedy herbs of the borage family [n]\n",
  "STICKTIGHT": "a plant with sticky burs, bur marigold [n -S]\n",
  "STICKTIGHTS": "STICKTIGHT, a plant with sticky burs, bur marigold [n]\n",
  "STICKUM": "a substance that causes adhesion [n -S]\n",
  "STICKUMS": "STICKUM, a substance that causes adhesion [n]\n",
  "STICKUP": "(colloquial) a robbery at gunpoint [n -S]\n",
  "STICKUPS": "STICKUP, (colloquial) a robbery at gunpoint [n]\n",
  "STICKWEED": "any of several plants, such as beggar's lice, with adhesive seeds [n -S]\n",
  "STICKWEEDS": "STICKWEED, any of several plants, such as beggar's lice, with adhesive seeds [n]\n",
  "STICKWORK": "skill in using one's stick in any game played with one [n -S]\n",
  "STICKWORKS": "STICKWORK, skill in using one's stick in any game played with one [n]\n",
  "STICKY": "adhesive [adj STICKIER, STICKIEST, STICKILY] / to make sticky [v STICKIED, STICKYING, STICKIES]\n",
  "STICKYBEAK": "(Australian slang) a Nosey Parker [n -S] / to pry [v -ED, -ING, -S]\n",
  "STICKYBEAKED": "STICKYBEAK, to pry [v]\n",
  "STICKYBEAKING": "STICKYBEAK, to pry [v]\n",
  "STICKYBEAKS": "STICKYBEAK, (Australian slang) a Nosey Parker [n]\n",
  "STICKYING": "STICKY, to make sticky [v]\n",
  "STICTION": "frictional force which occurs two surfaces contact [n -S]\n",
  "STICTIONS": "STICTION, frictional force which occurs two surfaces contact [n]\n",
  "STIDDIE": "(Old Norse) to forge on an anvil, also STITHY [v STIDDIED, STIDDIEING, STIDDIES]\n",
  "STIDDIED": "STIDDIE, (Old Norse) to forge on an anvil, also STITHY [v]\n",
  "STIDDIEING": "STIDDIE, (Old Norse) to forge on an anvil, also STITHY [v]\n",
  "STIDDIES": "STIDDIE, (Old Norse) to forge on an anvil, also STITHY [v]\n",
  "STIE": "to keep in a sty [v STIED, STYING, STIES]\n",
  "STIED": "STY, to keep in a pigpen [v]\n",
  "STIES": "STY, to keep in a pigpen [v]\n",
  "STIEVE": "(Scots) stiff, firm, also STEEVE [adj STIEVER, STIEVEST, STIEVELY]\n",
  "STIEVELY": "STIEVE, (Scots) stiff, firm, also STEEVE [adv]\n",
  "STIEVER": "STIEVE, (Scots) stiff, firm, also STEEVE [adj]\n",
  "STIEVEST": "STIEVE, (Scots) stiff, firm, also STEEVE [adj]\n",
  "STIFF": "rigid [adj STIFFER, STIFFEST, STIFFLY] / to cheat, rob [v -ED, -ING, -S]\n",
  "STIFFED": "STIFF, to cheat, rob [v]\n",
  "STIFFEN": "to make stiff [v -ED, -ING, -S]\n",
  "STIFFENED": "STIFFEN, to make stiff [v]\n",
  "STIFFENER": "something used to stiffen [n -S]\n",
  "STIFFENERS": "STIFFENER, something used to stiffen [n]\n",
  "STIFFENING": "the act of stiffening [n -S]\n",
  "STIFFENINGS": "STIFFENING, the act of stiffening [n]\n",
  "STIFFENS": "STIFFEN, to make stiff [v]\n",
  "STIFFER": "STIFF, rigid [adj]\n",
  "STIFFEST": "STIFF, rigid [adj]\n",
  "STIFFIE": "(vulgar slang) an erect penis, also STIFFY [n -S]\n",
  "STIFFIES": "STIFFIE, (vulgar slang) an erect penis, also STIFFY [n]\n",
  "STIFFING": "STIFF, to cheat, rob [v]\n",
  "STIFFISH": "somewhat stiff [adj]\n",
  "STIFFLY": "STIFF, rigid [adv]\n",
  "STIFFNESS": "the state of being stiff [n -ES]\n",
  "STIFFNESSES": "STIFFNESS, the state of being stiff [n]\n",
  "STIFFS": "STIFF, to cheat, rob [v]\n",
  "STIFFWARE": "software that is no longer flexible [n -S]\n",
  "STIFFWARES": "STIFFWARE, software that is no longer flexible [n]\n",
  "STIFFY": "(vulgar slang) an erect penis, also STIFFIE [n STIFFIES]\n",
  "STIFLE": "to smother [v STIFLED, STIFLING, STIFLES]\n",
  "STIFLED": "STIFLE, to smother [v]\n",
  "STIFLER": "one who, or that which, stifles [n -S]\n",
  "STIFLERS": "STIFLER, one who, or that which, stifles [n]\n",
  "STIFLES": "STIFLE, to smother [v]\n",
  "STIFLING": "very hot [adj STIFLINGLY] / the act of stifling [n -S]\n",
  "STIFLINGLY": "STIFLING, very hot [adv]\n",
  "STIFLINGS": "STIFLING, the act of stifling [n]\n",
  "STIGMA": "(Latin) a mark of disgrace [n STIGMAS or STIGMATA]\n",
  "STIGMAL": "relating to a stigma [adj]\n",
  "STIGMARIAN": "the pitted underground part of Sigillaria or other fossil tree [n -S]\n",
  "STIGMARIANS": "STIGMARIAN, the pitted underground part of Sigillaria or other fossil tree [n]\n",
  "STIGMAS": "STIGMA, (Latin) a mark of disgrace [n]\n",
  "STIGMASTEROL": "a crystalline sterol obtained esp. from soybean oil [n -S]\n",
  "STIGMASTEROLS": "STIGMASTEROL, a crystalline sterol obtained esp. from soybean oil [n]\n",
  "STIGMATA": "STIGMA, (Latin) a mark of disgrace [n]\n",
  "STIGMATIC": "related to stigma [adj STIGMATICALLY] / a person who bears a stigma [n -S]\n",
  "STIGMATICAL": "stigmatic [adj STIGMATICALLY]\n",
  "STIGMATICALLY": "STIGMATICAL, stigmatic [adv]\n",
  "STIGMATICS": "STIGMATIC, a person who bears a stigma [n]\n",
  "STIGMATIFEROUS": "bearing stigma [adj]\n",
  "STIGMATISATION": "the act of stigmatising, also STIGMATIZATION [n -S]\n",
  "STIGMATISATIONS": "STIGMATISATION, the act of stigmatising, also STIGMATIZATION [n]\n",
  "STIGMATISE": "to mark with a stigma, or brand; as, the ancients stigmatised their slaves and soldiers, also STIGMATIZE [v STIGMATISED, STIGMATISING, STIGMATISES]\n",
  "STIGMATISED": "STIGMATISE, to mark with a stigma, or brand; as, the ancients stigmatised their slaves and soldiers, also STIGMATIZE [v]\n",
  "STIGMATISER": "one who stigmatises, also STIGMATIZER [n -S]\n",
  "STIGMATISERS": "STIGMATISER, one who stigmatises, also STIGMATIZER [n]\n",
  "STIGMATISES": "STIGMATISE, to mark with a stigma, or brand; as, the ancients stigmatised their slaves and soldiers, also STIGMATIZE [v]\n",
  "STIGMATISING": "STIGMATISE, to mark with a stigma, or brand; as, the ancients stigmatised their slaves and soldiers, also STIGMATIZE [v]\n",
  "STIGMATISM": "the impression of stigmata [n -S]\n",
  "STIGMATISMS": "STIGMATISM, the impression of stigmata [n]\n",
  "STIGMATIST": "one believed to be supernaturally impressed with the marks of Christ's wounds [n -S]\n",
  "STIGMATISTS": "STIGMATIST, one believed to be supernaturally impressed with the marks of Christ's wounds [n]\n",
  "STIGMATIZATION": "the act of stigmatizing, also STIGMATISATION [n -S]\n",
  "STIGMATIZATIONS": "STIGMATIZATION, the act of stigmatizing, also STIGMATISATION [n]\n",
  "STIGMATIZE": "to mark with a stigma, or brand; as, the ancients stigmatized their slaves and soldiers, also STIGMATISE [v STIGMATIZED, STIGMATIZING, STIGMATIZES]\n",
  "STIGMATIZED": "STIGMATIZE, to mark with a stigma, or brand; as, the ancients stigmatized their slaves and soldiers, also STIGMATISE [v]\n",
  "STIGMATIZER": "one who stigmatizes, also STIGMATISER [n -S]\n",
  "STIGMATIZERS": "STIGMATIZER, one who stigmatizes, also STIGMATISER [n]\n",
  "STIGMATIZES": "STIGMATIZE, to mark with a stigma, or brand; as, the ancients stigmatized their slaves and soldiers, also STIGMATISE [v]\n",
  "STIGMATIZING": "STIGMATIZE, to mark with a stigma, or brand; as, the ancients stigmatized their slaves and soldiers, also STIGMATISE [v]\n",
  "STIGMATOPHILIA": "an obsession with tattooing or branding [n -S]\n",
  "STIGMATOPHILIAS": "STIGMATOPHILIA, an obsession with tattooing or branding [n]\n",
  "STIGMATOPHILIST": "one suffering from stigmatophilia [n]\n",
  "STIGMATOSE": "stigmatic [adj]\n",
  "STIGME": "(Greek) a dot used as a punctuation mark [n -S]\n",
  "STIGMES": "STIGME, (Greek) a dot used as a punctuation mark [n]\n",
  "STILB": "the c/g/s unit of intrinsic brightness [n -S]\n",
  "STILBENE": "a crystalline hydrocarbon, used in dye manufacture [n -S]\n",
  "STILBENES": "STILBENE, a crystalline hydrocarbon, used in dye manufacture [n]\n",
  "STILBESTROL": "(US) a synthetic oestrogen, also STILBOESTROL [n -S]\n",
  "STILBESTROLS": "STILBESTROL, (US) a synthetic oestrogen, also STILBOESTROL [n]\n",
  "STILBITE": "a common mineral of the zeolite family, a hydrous silicate of alumina and lime [n -S]\n",
  "STILBITES": "STILBITE, a common mineral of the zeolite family, a hydrous silicate of alumina and lime [n]\n",
  "STILBOESTROL": "a synthetic oestrogen, also STILBESTROL [n -S]\n",
  "STILBOESTROLS": "STILBOESTROL, a synthetic oestrogen, also STILBESTROL [n]\n",
  "STILBS": "STILB, the c/g/s unit of intrinsic brightness [n]\n",
  "STILE": "to style, designate [v STILED, STILING, STILES]\n",
  "STILED": "STILE, to style, designate [v]\n",
  "STILES": "STILE, to style, designate [v]\n",
  "STILET": "a small poniard, a stiletto, also STYLET [n -S]\n",
  "STILETS": "STILET, a small poniard, a stiletto, also STYLET [n]\n",
  "STILETTO": "(Italian) a narrow dagger [n -S] / to stab with a stiletto [v -ED, -ING, -ES]\n",
  "STILETTOED": "STILETTO, to stab with a stiletto [v]\n",
  "STILETTOES": "STILETTO, to stab with a stiletto [v]\n",
  "STILETTOING": "STILETTO, to stab with a stiletto [v]\n",
  "STILETTOS": "STILETTO, (Italian) a narrow dagger [n]\n",
  "STILING": "STILE, to style, designate [v]\n",
  "STILL": "free from sound or motion [adj STILLER, STILLEST, STILLY] / to make still [v -ED, -ING, -S]\n",
  "STILLAGE": "a cask stand, also STILLING, STILLION [n -S]\n",
  "STILLAGES": "STILLAGE, a cask stand, also STILLING, STILLION [n]\n",
  "STILLATORIES": "STILLATORY, a still, a distillery [n]\n",
  "STILLATORY": "a still, a distillery [n STILLATORIES]\n",
  "STILLBIRTH": "the birth of a dead fetus [n -S]\n",
  "STILLBIRTHS": "STILLBIRTH, the birth of a dead fetus [n]\n",
  "STILLBORN": "a baby dead at birth [n -S]\n",
  "STILLBORNS": "STILLBORN, a baby dead at birth [n]\n",
  "STILLED": "STILL, to make still [v]\n",
  "STILLER": "a distiller [n -S]\n",
  "STILLERS": "STILLER, a distiller [n]\n",
  "STILLEST": "STILL, free from sound or motion [adj]\n",
  "STILLHOUSE": "(US) a distillery [n -S]\n",
  "STILLHOUSES": "STILLHOUSE, (US) a distillery [n]\n",
  "STILLICIDE": "a succession of drops of water, esp. falling from the eaves of a house [n -S]\n",
  "STILLICIDES": "STILLICIDE, a succession of drops of water, esp. falling from the eaves of a house [n]\n",
  "STILLIER": "STILLY, still, quiet [adj]\n",
  "STILLIEST": "STILLY, still, quiet [adj]\n",
  "STILLIFORM": "having the shape of a drop or globule [adj]\n",
  "STILLING": "a cask stand, also STILLAGE, STILLION [n -S]\n",
  "STILLINGS": "STILLING, a cask stand, also STILLAGE, STILLION [n]\n",
  "STILLION": "a cask stand, also STILLAGE, STILLING [n -S]\n",
  "STILLIONS": "STILLION, a cask stand, also STILLAGE, STILLING [n]\n",
  "STILLMAN": "one who operates a distillery [n STILLMEN]\n",
  "STILLMEN": "STILLMAN, one who operates a distillery [n]\n",
  "STILLNESS": "the state of being still [n -ES]\n",
  "STILLNESSES": "STILLNESS, the state of being still [n]\n",
  "STILLROOM": "a room, in a large house, where liquors, preserves, etc. are kept, and where tea, etc. is prepared for the table [n -S]\n",
  "STILLROOMS": "STILLROOM, a room, in a large house, where liquors, preserves, etc. are kept, and where tea, etc. is prepared for the table [n]\n",
  "STILLS": "STILL, to make still [v]\n",
  "STILLSON": "(tradename) a kind of wrench [n -S]\n",
  "STILLSONS": "STILLSON, (tradename) a kind of wrench [n]\n",
  "STILLY": "still, quiet [adj STILLIER, STILLIEST]\n",
  "STILPNOSIDERITE": "another name for limonite [n]\n",
  "STILT": "to raise on long slender poles [v -ED, -ING, -S]\n",
  "STILTBIRD": "a long-legged wading bird related to the avocet [n -S]\n",
  "STILTBIRDS": "STILTBIRD, a long-legged wading bird related to the avocet [n]\n",
  "STILTED": "STILT, to raise on long slender poles [v]\n",
  "STILTEDLY": "STILTED, STILT, to raise on long slender poles [adv]\n",
  "STILTEDNESS": "the state of being stilted [n -ES]\n",
  "STILTEDNESSES": "STILTEDNESS, the state of being stilted [n]\n",
  "STILTER": "one who walks on stilts [n -S]\n",
  "STILTERS": "STILTER, one who walks on stilts [n]\n",
  "STILTIER": "STILTY, stilt-like [adj]\n",
  "STILTIEST": "STILTY, stilt-like [adj]\n",
  "STILTINESS": "the quality of being stilted [n -ES]\n",
  "STILTINESSES": "STILTINESS, the quality of being stilted [n]\n",
  "STILTING": "the act of stilting [n -S]\n",
  "STILTINGS": "STILTING, the act of stilting [n]\n",
  "STILTISH": "somewhat stilty [adj]\n",
  "STILTLIKE": "like a stilt [adj]\n",
  "STILTS": "STILT, to raise on long slender poles [v]\n",
  "STILTY": "stilt-like [adj STILTIER, STILTIEST]\n",
  "STIM": "(Irish) a very small amount [n -S]\n",
  "STIME": "(Scots) to peer, also STYME [v STIMED, STIMING, STIMES]\n",
  "STIMED": "STIME, (Scots) to peer, also STYME [v]\n",
  "STIMES": "STIME, (Scots) to peer, also STYME [v]\n",
  "STIMIE": "to thwart, stump, or obstruct, also STIMY, STYMIE, STYMY [v STIMIED, STIMYING, STIMIES]\n",
  "STIMIED": "STIMIE, to thwart, stump, or obstruct, also STIMY, STYMIE, STYMY [v]\n",
  "STIMIES": "STIMIE, to thwart, stump, or obstruct, also STIMY, STYMIE, STYMY [v]\n",
  "STIMING": "STIME, (Scots) to peer, also STYME [v]\n",
  "STIMPMETER": "a device that measures the speed of a putting green by propelling a golf ball down a ramp at a standard initial velocity and measuring how far it travels [n -S]\n",
  "STIMPMETERS": "STIMPMETER, a device that measures the speed of a putting green by propelling a golf ball down a ramp at a standard initial velocity and measuring how far it travels [n]\n",
  "STIMS": "STIM, (Irish) a very small amount [n]\n",
  "STIMULABLE": "that can be stimulated [adj]\n",
  "STIMULANCIES": "STIMULANCY, the quality of being stimulating [n]\n",
  "STIMULANCY": "the quality of being stimulating [n STIMULANCIES]\n",
  "STIMULANT": "a substance that stimulates [n -S]\n",
  "STIMULANTS": "STIMULANT, a substance that stimulates [n]\n",
  "STIMULATE": "to excite, to inspire enthusiasm in [v STIMULATED, STIMULATING, STIMULATES]\n",
  "STIMULATED": "STIMULATE, to excite, to inspire enthusiasm in [v]\n",
  "STIMULATER": "an agent that stimulates, also STIMULATOR [n -S]\n",
  "STIMULATERS": "STIMULATER, an agent that stimulates, also STIMULATOR [n]\n",
  "STIMULATES": "STIMULATE, to excite, to inspire enthusiasm in [v]\n",
  "STIMULATING": "STIMULATE, to excite, to inspire enthusiasm in [v]\n",
  "STIMULATINGLY": "STIMULATING, STIMULATE, to excite, to inspire enthusiasm in [adv]\n",
  "STIMULATION": "the act of stimulating [n -S]\n",
  "STIMULATIONS": "STIMULATION, the act of stimulating [n]\n",
  "STIMULATIVE": "serving to stimulate [adj] / a stimulative substance [n -S]\n",
  "STIMULATIVES": "STIMULATIVE, a stimulative substance [n]\n",
  "STIMULATOR": "an agent that stimulates, also STIMULATER [n -S]\n",
  "STIMULATORS": "STIMULATOR, an agent that stimulates, also STIMULATER [n]\n",
  "STIMULATORY": "serving to stimulate [adj]\n",
  "STIMULI": "STIMULUS, (Latin) an agency that produces a response [n]\n",
  "STIMULUS": "(Latin) an agency that produces a response [n STIMULI]\n",
  "STIMY": "to thwart, stump, or obstruct, also STIMIE, STYMIE, STYMY [v STIMIED, STIMYING, STIMIES]\n",
  "STIMYING": "STIMY, to thwart, stump, or obstruct, also STIMIE, STYMIE, STYMY [v]\n",
  "STING": "to prick painfully [v STUNG or STINGED or STONG or STANG, STUNG, STINGING, STINGS]\n",
  "STINGAREE": "a ray with a formidable barbed dorsal spine on its tail, also STINGRAY [n -S]\n",
  "STINGAREES": "STINGAREE, a ray with a formidable barbed dorsal spine on its tail, also STINGRAY [n]\n",
  "STINGBULL": "the weever fish, which is capable of inflicting severe wounds with the spinous rays of its dorsal fin, also STINGFISH [n -S]\n",
  "STINGBULLS": "STINGBULL, the weever fish, which is capable of inflicting severe wounds with the spinous rays of its dorsal fin, also STINGFISH [n]\n",
  "STINGE": "a stingy person [n -S]\n",
  "STINGED": "STING, to prick painfully [v]\n",
  "STINGER": "one that stings [n -S]\n",
  "STINGERS": "STINGER, one that stings [n]\n",
  "STINGES": "STINGE, a stingy person [n]\n",
  "STINGFISH": "the weever fish, also STINGBULL [n -ES]\n",
  "STINGFISHES": "STINGFISH, the weever fish, also STINGBULL [n]\n",
  "STINGIER": "STINGY, mean, niggardly [adj]\n",
  "STINGIES": "STINGY, a stinging nettle [n]\n",
  "STINGIEST": "STINGY, mean, niggardly [adj]\n",
  "STINGILY": "STINGY, mean, niggardly [adv]\n",
  "STINGINESS": "the state of being stingy [n -ES]\n",
  "STINGINESSES": "STINGINESS, the state of being stingy [n]\n",
  "STINGING": "painful, severe [adj STINGINGLY] / the act of stinging [n -S]\n",
  "STINGINGLY": "STINGING, painful, severe [adv]\n",
  "STINGINGNESS": "the state of being stinging [n -ES]\n",
  "STINGINGNESSES": "STINGINGNESS, the state of being stinging [n]\n",
  "STINGINGS": "STINGING, the act of stinging [n]\n",
  "STINGLESS": "having no sting [adj]\n",
  "STINGO": "a strong ale or beer [n -S]\n",
  "STINGOS": "STINGO, a strong ale or beer [n]\n",
  "STINGRAY": "a ray with a formidable barbed dorsal spine on its tail, also STINGAREE [n -S]\n",
  "STINGRAYS": "STINGRAY, a ray with a formidable barbed dorsal spine on its tail, also STINGAREE [n]\n",
  "STINGS": "STING, to prick painfully [v]\n",
  "STINGY": "mean, niggardly [adj STINGIER, STINGIEST, STINGILY] / a stinging nettle [n STINGIES]\n",
  "STINK": "to emit a foul odour [v STUNK or STANK, STINKING, STINKS]\n",
  "STINKARD": "a despicable person [n -S]\n",
  "STINKARDS": "STINKARD, a despicable person [n]\n",
  "STINKBIRD": "another name for the hoatzin [n -S]\n",
  "STINKBIRDS": "STINKBIRD, another name for the hoatzin [n]\n",
  "STINKBUG": "a shield bug that releases foul-smelling secretions [n -S]\n",
  "STINKBUGS": "STINKBUG, a shield bug that releases foul-smelling secretions [n]\n",
  "STINKER": "a very unpleasant person [n -S]\n",
  "STINKEROO": "a bad or contemptible person [n -S]\n",
  "STINKEROOS": "STINKEROO, a bad or contemptible person [n]\n",
  "STINKERS": "STINKER, a very unpleasant person [n]\n",
  "STINKHORN": "a kind of fungus of the genus Phallus, which emits a fetid odor [n -S]\n",
  "STINKHORNS": "STINKHORN, a kind of fungus of the genus Phallus, which emits a fetid odor [n]\n",
  "STINKIER": "STINKY, emitting a foul odour [adj]\n",
  "STINKIEST": "STINKY, emitting a foul odour [adj]\n",
  "STINKING": "evil-smelling [adj STINKINGLY]\n",
  "STINKINGLY": "STINKING, evil-smelling [adv]\n",
  "STINKINGNESS": "the state of being stinking [n -ES]\n",
  "STINKINGNESSES": "STINKINGNESS, the state of being stinking [n]\n",
  "STINKO": "(slang) drunk [adj]\n",
  "STINKPOT": "a common musk turtle found in SE Canada and the eastern US, which emits a foul-smelling secretion when disturbed [n -S]\n",
  "STINKPOTS": "STINKPOT, a common musk turtle found in SE Canada and the eastern US, which emits a foul-smelling secretion when disturbed [n]\n",
  "STINKS": "STINK, to emit a foul odour [v]\n",
  "STINKSTONE": "a limestone that gives a fetid urinous smell when struck, also SWINESTONE [n -S]\n",
  "STINKSTONES": "STINKSTONE, a limestone that gives a fetid urinous smell when struck, also SWINESTONE [n]\n",
  "STINKWEED": "any foul-smelling plant [n -S]\n",
  "STINKWEEDS": "STINKWEED, any foul-smelling plant [n]\n",
  "STINKWOOD": "a name given to several kinds of wood with an unpleasant smell [n -S]\n",
  "STINKWOODS": "STINKWOOD, a name given to several kinds of wood with an unpleasant smell [n]\n",
  "STINKY": "emitting a foul odour [adj STINKIER, STINKIEST]\n",
  "STINT": "to be niggardly with [v -ED, -ING, -S]\n",
  "STINTED": "STINT, to be niggardly with [v]\n",
  "STINTEDLY": "STINTED, STINT, to be niggardly with [adv]\n",
  "STINTEDNESS": "the state of being stinted [n -ES]\n",
  "STINTEDNESSES": "STINTEDNESS, the state of being stinted [n]\n",
  "STINTER": "one who, or that which, stints [n -S]\n",
  "STINTERS": "STINTER, one who, or that which, stints [n]\n",
  "STINTIER": "STINTY, limited [adj]\n",
  "STINTIEST": "STINTY, limited [adj]\n",
  "STINTING": "grudging [adj STINTINGLY] / the act of stinting [n -S]\n",
  "STINTINGLY": "STINTING, grudging [adv]\n",
  "STINTINGS": "STINTING, the act of stinting [n]\n",
  "STINTLESS": "without stint or restraint [adj]\n",
  "STINTS": "STINT, to be niggardly with [v]\n",
  "STINTY": "limited [adj STINTIER, STINTIEST]\n",
  "STIPA": "(Latin) any grass of the feather grass genus Stipa [n -S]\n",
  "STIPAS": "STIPA, (Latin) any grass of the feather grass genus Stipa [n]\n",
  "STIPE": "a slender supporting part of a plant, also STIPES [n -S]\n",
  "STIPED": "having a stipe, a stalk [adj]\n",
  "STIPEL": "the stipule of a leaflet, also STIPULE [n -S]\n",
  "STIPELLATE": "having stipels [adj]\n",
  "STIPELS": "STIPEL, the stipule of a leaflet, also STIPULE [n]\n",
  "STIPEND": "a fixed amount paid periodically, esp. to a clergyman [n -S]\n",
  "STIPENDIARIES": "STIPENDIARY, one who receives a stipend [n]\n",
  "STIPENDIARY": "one who receives a stipend [n STIPENDIARIES]\n",
  "STIPENDIATE": "to provide with a salary [v STIPENDIATED, STIPENDIATING, STIPENDIATES]\n",
  "STIPENDIATED": "STIPENDIATE, to provide with a salary [v]\n",
  "STIPENDIATES": "STIPENDIATE, to provide with a salary [v]\n",
  "STIPENDIATING": "STIPENDIATE, to provide with a salary [v]\n",
  "STIPENDS": "STIPEND, a fixed amount paid periodically, esp. to a clergyman [n]\n",
  "STIPES": "(Latin) a slender supporting part of a plant, also STIPE [n STIPITES]\n",
  "STIPIFORM": "resembling a stipe, also STIPITIFORM [adj]\n",
  "STIPITATE": "supported by a stipe [adj]\n",
  "STIPITES": "STIPES, (Latin) a slender supporting part of a plant, also STIPE [n]\n",
  "STIPITIFORM": "in the form of a stipes, also STIPIFORM [adj]\n",
  "STIPPLE": "to paint or engrave using dots or short touches [v STIPPLED, STIPPLING, STIPPLES]\n",
  "STIPPLED": "STIPPLE, to paint or engrave using dots or short touches [v]\n",
  "STIPPLER": "one who stipples [n -S]\n",
  "STIPPLERS": "STIPPLER, one who stipples [n]\n",
  "STIPPLES": "STIPPLE, to paint or engrave using dots or short touches [v]\n",
  "STIPPLING": "the act of stippling [n -S]\n",
  "STIPPLINGS": "STIPPLING, the act of stippling [n]\n",
  "STIPULABLE": "that can be stipulated [adj]\n",
  "STIPULACEOUS": "having stipules [adj]\n",
  "STIPULAR": "of or pertaining to stipules, also STIPULARY [adj]\n",
  "STIPULARY": "of or pertaining to stipules, also STIPULAR [adj]\n",
  "STIPULATE": "to set or require as a condition of an agreement [v STIPULATED, STIPULATING, STIPULATES]\n",
  "STIPULATED": "STIPULATE, to set or require as a condition of an agreement [v]\n",
  "STIPULATES": "STIPULATE, to set or require as a condition of an agreement [v]\n",
  "STIPULATING": "STIPULATE, to set or require as a condition of an agreement [v]\n",
  "STIPULATION": "an act of stipulating [n -S]\n",
  "STIPULATIONS": "STIPULATION, an act of stipulating [n]\n",
  "STIPULATOR": "one who stipulates [n -S]\n",
  "STIPULATORS": "STIPULATOR, one who stipulates [n]\n",
  "STIPULATORY": "relating to stipulation [adj]\n",
  "STIPULE": "an appendage at the base of a leaf, also STIPEL [n -S]\n",
  "STIPULED": "having a stipule [adj]\n",
  "STIPULES": "STIPULE, an appendage at the base of a leaf, also STIPEL [n]\n",
  "STIR": "to move around or mix [v STIRRED, STIRRING, STIRS]\n",
  "STIRABOUT": "(Anglo-Irish) porridge; a bustle, commotion [n -S]\n",
  "STIRABOUTS": "STIRABOUT, (Anglo-Irish) porridge; a bustle, commotion [n]\n",
  "STIRE": "(archaic) to stir, also STYRE [v STIRED, STIRING, STIRES]\n",
  "STIRED": "STIRE, (archaic) to stir, also STYRE [v]\n",
  "STIRES": "STIRE, (archaic) to stir, also STYRE [v]\n",
  "STIRING": "STIRE, (archaic) to stir, also STYRE [v]\n",
  "STIRK": "a yearling ox or cow [n -S]\n",
  "STIRKS": "STIRK, a yearling ox or cow [n]\n",
  "STIRLESS": "without stir [adj]\n",
  "STIRP": "a branch of a family; pedigree, also STIRPS [n -S]\n",
  "STIRPES": "STIRPS, (Latin) a branch of a family; pedigree, also STIRP [n]\n",
  "STIRPICULTURE": "selective breeding [n -S]\n",
  "STIRPICULTURES": "STIRPICULTURE, selective breeding [n]\n",
  "STIRPS": "(Latin) a branch of a family; pedigree, also STIRP [n STIRPES]\n",
  "STIRRA": "(Scots) a respectful mode of address, also STIRRAH [n -S]\n",
  "STIRRABLE": "that can be stirred [adj]\n",
  "STIRRAH": "(Scots) a respectful mode of address, also STIRRA [n -S]\n",
  "STIRRAHS": "STIRRAH, (Scots) a respectful mode of address, also STIRRA [n]\n",
  "STIRRAS": "STIRRA, (Scots) a respectful mode of address, also STIRRAH [n]\n",
  "STIRRE": "(Shakespeare) probably a misprint for 'sperre' [n -S]\n",
  "STIRRED": "STIR, to move around or mix [v]\n",
  "STIRRER": "a troublemaker [n -S]\n",
  "STIRRERS": "STIRRER, a troublemaker [n]\n",
  "STIRRES": "STIRRE, (Shakespeare) probably a misprint for 'sperre' [n]\n",
  "STIRRING": "rousing, exciting [adj STIRRINGLY] / the act of stirring [n -S]\n",
  "STIRRINGLY": "STIRRING, rousing, exciting [adv]\n",
  "STIRRINGS": "STIRRING, the act of stirring [n]\n",
  "STIRRUP": "a support for the foot of a horseman [n -S]\n",
  "STIRRUPS": "STIRRUP, a support for the foot of a horseman [n]\n",
  "STIRS": "STIR, to move around or mix [v]\n",
  "STISHIE": "(Scots) fuss, ado, disturbance, also STASHIE, STOOSHIE, STOUSHIE, STUSHIE [n -S]\n",
  "STISHIES": "STISHIE, (Scots) fuss, ado, disturbance, also STASHIE, STOOSHIE, STOUSHIE, STUSHIE [n]\n",
  "STITCH": "to sew together [v STITCHED, STITCHING, STITCHES]\n",
  "STITCHCRAFT": "the art of sewing [n -S]\n",
  "STITCHCRAFTS": "STITCHCRAFT, the art of sewing [n]\n",
  "STITCHED": "STITCH, to sew together [v]\n",
  "STITCHER": "one who stitches [n -S]\n",
  "STITCHERIES": "STITCHERY, needlework [n]\n",
  "STITCHERS": "STITCHER, one who stitches [n]\n",
  "STITCHERY": "needlework [n STITCHERIES]\n",
  "STITCHES": "STITCH, to sew together [v]\n",
  "STITCHING": "the act of stitching [n -S]\n",
  "STITCHINGS": "STITCHING, the act of stitching [n]\n",
  "STITCHWORK": "embroidery [n -S]\n",
  "STITCHWORKS": "STITCHWORK, embroidery [n]\n",
  "STITCHWORT": "any plant of the chickweed genus Stellaria [n -S]\n",
  "STITCHWORTS": "STITCHWORT, any plant of the chickweed genus Stellaria [n]\n",
  "STITHIED": "STITHY, (Old Norse) to forge on an anvil, also STIDDIE, STUDDIE [v]\n",
  "STITHIES": "STITHY, (Old Norse) to forge on an anvil, also STIDDIE, STUDDIE [v]\n",
  "STITHY": "(Old Norse) to forge on an anvil, also STIDDIE, STUDDIE [v STITHIED, STITHYING, STITHIES]\n",
  "STITHYING": "STITHY, (Old Norse) to forge on an anvil, also STIDDIE, STUDDIE [v]\n",
  "STIVE": "(dialect) to stifle [v STIVED, STIVING, STIVES]\n",
  "STIVED": "STIVE, (dialect) to stifle [v]\n",
  "STIVER": "(Dutch) a former Dutch coin, also STUIVER [n -S]\n",
  "STIVERS": "STIVER, (Dutch) a former Dutch coin, also STUIVER [n]\n",
  "STIVES": "STIVE, (dialect) to stifle [v]\n",
  "STIVIER": "STIVY, stuffy [adj]\n",
  "STIVIEST": "STIVY, stuffy [adj]\n",
  "STIVING": "STIVE, (dialect) to stifle [v]\n",
  "STIVY": "stuffy [adj STIVIER, STIVIEST]\n",
  "STOA": "(Greek) an ancient Greek covered walkway [n STOAS or STOAE or STOAI]\n",
  "STOAE": "STOA, (Greek) an ancient Greek covered walkway [n]\n",
  "STOAI": "STOA, (Greek) an ancient Greek covered walkway [n]\n",
  "STOAS": "STOA, (Greek) an ancient Greek covered walkway [n]\n",
  "STOAT": "a weasel with a black-tipped tail [n -S]\n",
  "STOATS": "STOAT, a weasel with a black-tipped tail [n]\n",
  "STOB": "to stab [v STOBBED, STOBBING, STOBS]\n",
  "STOBBED": "STOB, to stab [v]\n",
  "STOBBING": "STOB, to stab [v]\n",
  "STOBIE": "as in stobie pole, a steel and concrete pole for supporting electricity wires [adj]\n",
  "STOBS": "STOB, to stab [v]\n",
  "STOCCADO": "(Italian) a stab; a straight thrust with a rapier, also STOCCATA [n -ES or -S]\n",
  "STOCCADOES": "STOCCADO, (Italian) a stab; a straight thrust with a rapier, also STOCCATA [n]\n",
  "STOCCADOS": "STOCCADO, (Italian) a stab; a straight thrust with a rapier, also STOCCATA [n]\n",
  "STOCCATA": "(Italian) a straight thrust with a rapier, also STOCCADO [n -S]\n",
  "STOCCATAS": "STOCCATA, (Italian) a straight thrust with a rapier, also STOCCADO [n]\n",
  "STOCHASTIC": "involving chance or randomness [adj STOCHASTICALLY]\n",
  "STOCHASTICALLY": "STOCHASTIC, involving chance or randomness [adv]\n",
  "STOCIOUS": "(Irish slang) drunk, intoxicated, also STOTIOUS [adj]\n",
  "STOCK": "to keep for future sale or use [v -ED, -ING, -S]\n",
  "STOCKADE": "to build a type of protective fence [v STOCKADED, STOCKADING, STOCKADES]\n",
  "STOCKADED": "STOCKADE, to build a type of protective fence [v]\n",
  "STOCKADES": "STOCKADE, to build a type of protective fence [v]\n",
  "STOCKADING": "STOCKADE, to build a type of protective fence [v]\n",
  "STOCKAGE": "the amount of supplies on hand [n -S]\n",
  "STOCKAGES": "STOCKAGE, the amount of supplies on hand [n]\n",
  "STOCKBREEDER": "a person engaged in the breeding and care of livestock for the market, for show purposes, or for racing [n -S]\n",
  "STOCKBREEDERS": "STOCKBREEDER, a person engaged in the breeding and care of livestock for the market, for show purposes, or for racing [n]\n",
  "STOCKBREEDING": "the breeding of stock [n -S]\n",
  "STOCKBREEDINGS": "STOCKBREEDING, the breeding of stock [n]\n",
  "STOCKBROKER": "a broker who executes orders to buy and sell securities and often also acts as a security dealer [n -S]\n",
  "STOCKBROKERAGE": "the activities of a stockbroker [n -S]\n",
  "STOCKBROKERAGES": "STOCKBROKERAGE, the activities of a stockbroker [n]\n",
  "STOCKBROKERS": "STOCKBROKER, a broker who executes orders to buy and sell securities and often also acts as a security dealer [n]\n",
  "STOCKBROKING": "the business of a stockbroker [n -S]\n",
  "STOCKBROKINGS": "STOCKBROKING, the business of a stockbroker [n]\n",
  "STOCKCAR": "a boxcar for carrying livestock [n -S]\n",
  "STOCKCARS": "STOCKCAR, a boxcar for carrying livestock [n]\n",
  "STOCKED": "STOCK, to keep for future sale or use [v]\n",
  "STOCKER": "an animal kept while being fattened or matured for slaughter [n -S]\n",
  "STOCKERS": "STOCKER, an animal kept while being fattened or matured for slaughter [n]\n",
  "STOCKFISH": "unsalted dried hake, cod, etc., commonly beaten with a stick before cooking [n -ES]\n",
  "STOCKFISHES": "STOCKFISH, unsalted dried hake, cod, etc., commonly beaten with a stick before cooking [n]\n",
  "STOCKHOLDER": "an owner of corporate stock [n -S]\n",
  "STOCKHOLDERS": "STOCKHOLDER, an owner of corporate stock [n]\n",
  "STOCKHOLDING": "a holding of stock [n -S]\n",
  "STOCKHOLDINGS": "STOCKHOLDING, a holding of stock [n]\n",
  "STOCKHORN": "a primitive Scottish musical instrument made of a cow's horn, a sheep's thigh bone or elder pipe, with stops and a single reed [n -S]\n",
  "STOCKHORNS": "STOCKHORN, a primitive Scottish musical instrument made of a cow's horn, a sheep's thigh bone or elder pipe, with stops and a single reed [n]\n",
  "STOCKHORSE": "(Australian) a horse trained to work with sheep and cattle [n -S]\n",
  "STOCKHORSES": "STOCKHORSE, (Australian) a horse trained to work with sheep and cattle [n]\n",
  "STOCKIER": "STOCKY, having a short, thick body [adj]\n",
  "STOCKIEST": "STOCKY, having a short, thick body [adj]\n",
  "STOCKILY": "STOCKY, having a short, thick body [adv]\n",
  "STOCKINESS": "the state of being stocky [n -ES]\n",
  "STOCKINESSES": "STOCKINESS, the state of being stocky [n]\n",
  "STOCKINET": "an elastic knitted fabric for undergarments, etc., also STOCKINETTE [n -S]\n",
  "STOCKINETS": "STOCKINET, an elastic knitted fabric for undergarments, etc., also STOCKINETTE [n]\n",
  "STOCKINETTE": "an elastic knitted fabric for undergarments, etc., also STOCKINET [n -S]\n",
  "STOCKINETTES": "STOCKINETTE, an elastic knitted fabric for undergarments, etc., also STOCKINET [n]\n",
  "STOCKING": "a covering for the foot and leg [n -S]\n",
  "STOCKINGED": "wearing stockings [adj]\n",
  "STOCKINGER": "a stocking weaver [n -S]\n",
  "STOCKINGERS": "STOCKINGER, a stocking weaver [n]\n",
  "STOCKINGLESS": "without stockings [adj]\n",
  "STOCKINGS": "STOCKING, a covering for the foot and leg [n]\n",
  "STOCKISH": "like a stock; stupid [adj STOCKISHLY]\n",
  "STOCKISHLY": "STOCKISH, like a stock; stupid [adv]\n",
  "STOCKISHNESS": "the state of being stockish [n -ES]\n",
  "STOCKISHNESSES": "STOCKISHNESS, the state of being stockish [n]\n",
  "STOCKIST": "a shopkeeper who stocks a specific line [n -S]\n",
  "STOCKISTS": "STOCKIST, a shopkeeper who stocks a specific line [n]\n",
  "STOCKJOBBER": "a wholesale dealer in stocks and shares [n -S]\n",
  "STOCKJOBBERIES": "STOCKJOBBERY, the profession of stockjobber [n]\n",
  "STOCKJOBBERS": "STOCKJOBBER, a wholesale dealer in stocks and shares [n]\n",
  "STOCKJOBBERY": "the profession of stockjobber [n STOCKJOBBERIES]\n",
  "STOCKJOBBING": "a list of stocks and current prices regularly issued [n -S]\n",
  "STOCKJOBBINGS": "STOCKJOBBING, a list of stocks and current prices regularly issued [n]\n",
  "STOCKKEEPER": "one that keeps and records stock, as in a warehouse [n -S]\n",
  "STOCKKEEPERS": "STOCKKEEPER, one that keeps and records stock, as in a warehouse [n]\n",
  "STOCKLESS": "without stock [adj]\n",
  "STOCKLIST": "a list of items in stock [n -S]\n",
  "STOCKLISTS": "STOCKLIST, a list of items in stock [n]\n",
  "STOCKLOCK": "a lock with a wooden case [n -S]\n",
  "STOCKLOCKS": "STOCKLOCK, a lock with a wooden case [n]\n",
  "STOCKMAN": "a man who owns or raises livestock [n STOCKMEN]\n",
  "STOCKMEN": "STOCKMAN, a man who owns or raises livestock [n]\n",
  "STOCKPILE": "an accumulated reserve supply [n -S] / to make such a supply [v STOCKPILED, STOCKPILING, STOCKPILES]\n",
  "STOCKPILED": "STOCKPILE, to make such a supply [v]\n",
  "STOCKPILER": "one who stockpiles [n -S]\n",
  "STOCKPILERS": "STOCKPILER, one who stockpiles [n]\n",
  "STOCKPILES": "STOCKPILE, to make such a supply [v]\n",
  "STOCKPILING": "the creation of a reserve supply [n -S]\n",
  "STOCKPILINGS": "STOCKPILING, the creation of a reserve supply [n]\n",
  "STOCKPOT": "a pot for making soup [n -S]\n",
  "STOCKPOTS": "STOCKPOT, a pot for making soup [n]\n",
  "STOCKPUNISHT": "(Shakespeare) punished by being put in the stocks [adj]\n",
  "STOCKROOM": "a room where goods are kept [n -S]\n",
  "STOCKROOMS": "STOCKROOM, a room where goods are kept [n]\n",
  "STOCKROUTE": "in Australia and New Zealand, a right of way for travelling stock [n -S]\n",
  "STOCKROUTES": "STOCKROUTE, in Australia and New Zealand, a right of way for travelling stock [n]\n",
  "STOCKS": "STOCK, to keep for future sale or use [v]\n",
  "STOCKTAKE": "to perform the counting stock [v STOCKTOOK, STOCKTAKEN, STOCKTAKING, STOCKTAKES]\n",
  "STOCKTAKEN": "STOCKTAKE, to perform the counting stock [v]\n",
  "STOCKTAKES": "STOCKTAKE, to perform the counting stock [v]\n",
  "STOCKTAKING": "the inventorying and valuation of stock [n -S]\n",
  "STOCKTAKINGS": "STOCKTAKING, the inventorying and valuation of stock [n]\n",
  "STOCKTOOK": "STOCKTAKE, to perform the counting stock [v]\n",
  "STOCKWORK": "(German) a mass of veins, impregnations, etc. of ore that can be worked as one deposit [n -S]\n",
  "STOCKWORKS": "STOCKWORK, (German) a mass of veins, impregnations, etc. of ore that can be worked as one deposit [n]\n",
  "STOCKY": "having a short, thick body [adj STOCKIER, STOCKIEST, STOCKILY]\n",
  "STOCKYARD": "a large yard with pens where cattle are kept for slaughter, market etc. [n -S]\n",
  "STOCKYARDS": "STOCKYARD, a large yard with pens where cattle are kept for slaughter, market etc. [n]\n",
  "STODGE": "to stuff full of food [v STODGED, STODGING, STODGES]\n",
  "STODGED": "STODGE, to stuff full of food [v]\n",
  "STODGER": "a dull person [n -S]\n",
  "STODGERS": "STODGER, a dull person [n]\n",
  "STODGES": "STODGE, to stuff full of food [v]\n",
  "STODGIER": "STODGY, boring [adj]\n",
  "STODGIEST": "STODGY, boring [adj]\n",
  "STODGILY": "STODGY, boring [adv]\n",
  "STODGINESS": "the state of being stodgy [n -ES]\n",
  "STODGINESSES": "STODGINESS, the state of being stodgy [n]\n",
  "STODGING": "STODGE, to stuff full of food [v]\n",
  "STODGY": "boring [adj STODGIER, STODGIEST, STODGILY]\n",
  "STOECHIOLOGICAL": "related to stoechiology [adj]\n",
  "STOECHIOLOGIES": "STOECHIOLOGY, the branch of biology that deals with the elements comprising animal tissues, also STOICHEIOLOGY [n]\n",
  "STOECHIOLOGY": "the branch of biology that deals with the elements comprising animal tissues, also STOICHEIOLOGY [n STOECHIOLOGIES]\n",
  "STOECHIOMETRIC": "relating to stoechiometry, the branch of chemistry that deals with the numerical proportions in which substances react, also STOICHEIOMETRIC [adj]\n",
  "STOECHIOMETRIES": "STOECHIOMETRY, the branch of chemistry that deals with the numerical proportions in which substances react, also STOICHIOMETRY [n]\n",
  "STOECHIOMETRY": "the branch of chemistry that deals with the numerical proportions in which substances react, also STOICHIOMETRY [n STOECHIOMETRIES]\n",
  "STOEP": "(Dutch) a platform along the front, and sometimes the side, of a house [n -S]\n",
  "STOEPS": "STOEP, (Dutch) a platform along the front, and sometimes the side, of a house [n]\n",
  "STOGEY": "a long, slender cigar, also STOGY, STOGIE [n -S]\n",
  "STOGEYS": "STOGEY, a long, slender cigar, also STOGY, STOGIE [n]\n",
  "STOGIE": "a long, slender cigar, also STOGY, STOGEY [n -S]\n",
  "STOGIES": "STOGIE, a long, slender cigar, also STOGY, STOGEY [n]\n",
  "STOGY": "(US) a long inexpensive cigar, also STOGEY, STOGIE [n STOGIES]\n",
  "STOIC": "enduring pain without complaint [adj STOICALLY] / a stoical person [n -S]\n",
  "STOICAL": "indifferent to pleasure or pain; uncomplaining in suffering, also STOIC [adj STOICALLY]\n",
  "STOICALLY": "STOICAL, indifferent to pleasure or pain; uncomplaining in suffering, also STOIC [adv]\n",
  "STOICALNESS": "the state of being stoical [n -ES]\n",
  "STOICALNESSES": "STOICALNESS, the state of being stoical [n]\n",
  "STOICHEIOLOGIES": "STOICHEIOLOGY, the branch of biology that deals with the elements comprising animal tissues, also STOECHIOLOGY [n]\n",
  "STOICHEIOLOGY": "the branch of biology that deals with the elements comprising animal tissues, also STOECHIOLOGY [n STOICHEIOLOGIES]\n",
  "STOICHEIOMETRIC": "relating to stoechiometry, the branch of chemistry that deals with the numerical proportions in which substances react, also STOECHIOMETRIC [adj]\n",
  "STOICHEIOMETRY": "the branch of chemistry that deals with the numerical proportions in which substances react [n]\n",
  "STOICHIOLOGICAL": "related to stoichiology [adj]\n",
  "STOICHIOLOGIES": "STOICHIOLOGY, the science of elements of animal tissues [n]\n",
  "STOICHIOLOGY": "the science of elements of animal tissues [n STOICHIOLOGIES]\n",
  "STOICHIOMETRIC": "of a chemical formula in which the numbers of atoms are simple integers determined by valency; (of quantities of reactants) present or involved in the simple integral ratios prescribed by an equation or formula [adj]\n",
  "STOICHIOMETRIES": "STOICHIOMETRY, the branch of chemistry that deals with the numerical proportions in which substances react, also STOECHIOMETRY [n]\n",
  "STOICHIOMETRY": "the branch of chemistry that deals with the numerical proportions in which substances react, also STOECHIOMETRY [n STOICHIOMETRIES]\n",
  "STOICISM": "indifference to pleasure or pain [n -S]\n",
  "STOICISMS": "STOICISM, indifference to pleasure or pain [n]\n",
  "STOICS": "STOIC, a stoical person [n]\n",
  "STOIT": "(Scots) to stagger, also STOITER, STOTTER, STYTE [v -ED, -ING, -S]\n",
  "STOITED": "STOIT, (Scots) to stagger, also STOITER, STOTTER, STYTE [v]\n",
  "STOITER": "(Scots) to stagger, also STOIT, STOTTER, STYTE [v -ED, -ING, -S]\n",
  "STOITERED": "STOITER, (Scots) to stagger, also STOIT, STOTTER, STYTE [v]\n",
  "STOITERING": "STOITER, (Scots) to stagger, also STOIT, STOTTER, STYTE [v]\n",
  "STOITERS": "STOITER, (Scots) to stagger, also STOIT, STOTTER, STYTE [v]\n",
  "STOITING": "STOIT, (Scots) to stagger, also STOITER, STOTTER, STYTE [v]\n",
  "STOITS": "STOIT, (Scots) to stagger, also STOITER, STOTTER, STYTE [v]\n",
  "STOKE": "to supply a furnace with fuel [v STOKED, STOKING, STOKES]\n",
  "STOKED": "STOKE, to supply a furnace with fuel [v]\n",
  "STOKEHOLD": "a ship's furnace chamber [n -S]\n",
  "STOKEHOLDS": "STOKEHOLD, a ship's furnace chamber [n]\n",
  "STOKEHOLE": "the area round the mouth of a furnace [n -S]\n",
  "STOKEHOLES": "STOKEHOLE, the area round the mouth of a furnace [n]\n",
  "STOKER": "a person who or thing which feeds a furnace with fuel [n -S]\n",
  "STOKERS": "STOKER, a person who or thing which feeds a furnace with fuel [n]\n",
  "STOKES": "STOKE, to supply a furnace with fuel [v]\n",
  "STOKESIA": "a perennial herb of the southern US [n -S]\n",
  "STOKESIAS": "STOKESIA, a perennial herb of the southern US [n]\n",
  "STOKING": "STOKE, to supply a furnace with fuel [v]\n",
  "STOKVEL": "(South African) a savings club amongst friends [n -S]\n",
  "STOKVELS": "STOKVEL, (South African) a savings club amongst friends [n]\n",
  "STOLE": "a narrow ecclesiastical vestment or scarf [n -S]\n",
  "STOLED": "wearing a stole [adj]\n",
  "STOLEN": "STEAL, to take by theft [v]\n",
  "STOLENWISE": "(archaic) by stealth [adv]\n",
  "STOLES": "STOLE, a narrow ecclesiastical vestment or scarf [n]\n",
  "STOLID": "impassive, unemotional [adj STOLIDER, STOLIDEST, STOLIDLY]\n",
  "STOLIDER": "STOLID, impassive, unemotional [adj]\n",
  "STOLIDEST": "STOLID, impassive, unemotional [adj]\n",
  "STOLIDITIES": "STOLIDITY, impassivity [n]\n",
  "STOLIDITY": "impassivity [n STOLIDITIES]\n",
  "STOLIDLY": "STOLID, impassive, unemotional [adv]\n",
  "STOLIDNESS": "the state of being stolid [n -ES]\n",
  "STOLIDNESSES": "STOLIDNESS, the state of being stolid [n]\n",
  "STOLLEN": "(German) a rich sweet German bread made with raisins etc. and coated with icing sugar [n -S]\n",
  "STOLLENS": "STOLLEN, (German) a rich sweet German bread made with raisins etc. and coated with icing sugar [n]\n",
  "STOLN": "(Milton) stolen [adj]\n",
  "STOLON": "(Latin) a runner or shoot from the base of a plant [n -S]\n",
  "STOLONATE": "having a stolon [adj]\n",
  "STOLONIC": "of or like a stolon, a runner or shoot from base of a plant [adj]\n",
  "STOLONIFEROUS": "bearing or having runners [adj]\n",
  "STOLONS": "STOLON, (Latin) a runner or shoot from the base of a plant [n]\n",
  "STOLPORT": "an airport for aircraft needing shorter runways [n -S]\n",
  "STOLPORTS": "STOLPORT, an airport for aircraft needing shorter runways [n]\n",
  "STOMA": "(Greek) a minute opening in the epidermis of a plant organ, also STOMATE [n STOMAS or STOMATA]\n",
  "STOMACH": "to tolerate [v -ED, -ING, -S]\n",
  "STOMACHACHE": "pain in or in the region of the stomach [n -S]\n",
  "STOMACHACHES": "STOMACHACHE, pain in or in the region of the stomach [n]\n",
  "STOMACHAL": "a medicine that is good for the stomach [n -S]\n",
  "STOMACHALS": "STOMACHAL, a medicine that is good for the stomach [n]\n",
  "STOMACHED": "STOMACH, to tolerate [v]\n",
  "STOMACHER": "armour for the chest; a covering or ornament for the chest area [n -S]\n",
  "STOMACHERS": "STOMACHER, armour for the chest; a covering or ornament for the chest area [n]\n",
  "STOMACHFUL": "proud, haughty [adj] / the contents of a stomach [n -S]\n",
  "STOMACHFULNESS": "the state of being stomachful, spirited, haughty [n]\n",
  "STOMACHFULS": "STOMACHFUL, the contents of a stomach [n]\n",
  "STOMACHIC": "of the stomach; promoting digestion [adj] / a stomachic medicine [n -S]\n",
  "STOMACHICAL": "of the stomach [adj]\n",
  "STOMACHICS": "STOMACHIC, a stomachic medicine [n]\n",
  "STOMACHIER": "STOMACHY, paunchy; easily angered, irritable [adj]\n",
  "STOMACHIEST": "STOMACHY, paunchy; easily angered, irritable [adj]\n",
  "STOMACHING": "STOMACH, to tolerate [v]\n",
  "STOMACHLESS": "without a stomach [adj]\n",
  "STOMACHOUS": "(archaic) proud [adj]\n",
  "STOMACHS": "STOMACH, to tolerate [v]\n",
  "STOMACHY": "paunchy; easily angered, irritable [adj STOMACHIER, STOMACHIEST]\n",
  "STOMACK": "(East Africa) in the phrase have a stomack, to be pregnant [n -S]\n",
  "STOMACKS": "STOMACK, (East Africa) in the phrase have a stomack, to be pregnant [n]\n",
  "STOMAL": "pertaining to the stoma, also STOMATAL [adj]\n",
  "STOMAS": "STOMA, (Greek) a minute opening in the epidermis of a plant organ, also STOMATE [n]\n",
  "STOMATA": "STOMA, (Greek) a minute opening in the epidermis of a plant organ, also STOMATE [n]\n",
  "STOMATAL": "pertaining to the stoma, also STOMAL [adj]\n",
  "STOMATE": "a minute opening in the epidermis of a plant organ, also STOMA [n -S]\n",
  "STOMATES": "STOMATE, a minute opening in the epidermis of a plant organ, also STOMA [n]\n",
  "STOMATIC": "of or pertaining to a stoma; of the nature of a stoma [adj]\n",
  "STOMATITIC": "relating to stomatitis, inflammation of the mouth [adj]\n",
  "STOMATITIDES": "STOMATITIS, inflammation of the mucous membrane of the mouth [n]\n",
  "STOMATITIS": "inflammation of the mucous membrane of the mouth [n STOMATITIDES or STOMATITISES]\n",
  "STOMATITISES": "STOMATITIS, inflammation of the mucous membrane of the mouth [n]\n",
  "STOMATODAEA": "STOMATODAEUM, in embryology, the invagination that forms the anterior part of the digestive tract [n]\n",
  "STOMATODAEUM": "in embryology, the invagination that forms the anterior part of the digestive tract [n STOMATODAEA]\n",
  "STOMATOGASTRIC": "of or relating to the mouth and stomach, or the upper alimentary tract [adj]\n",
  "STOMATOLOGICAL": "related to stomatology, the study of the mouth [adj]\n",
  "STOMATOLOGIES": "STOMATOLOGY, the study of the mouth [n]\n",
  "STOMATOLOGIST": "a person who works in stomatology [n -S]\n",
  "STOMATOLOGISTS": "STOMATOLOGIST, a person who works in stomatology [n]\n",
  "STOMATOLOGY": "the study of the mouth [n STOMATOLOGIES]\n",
  "STOMATOPLASTIES": "STOMATOPLASTY, plastic surgery of the mouth [n]\n",
  "STOMATOPLASTY": "plastic surgery of the mouth [n STOMATOPLASTIES]\n",
  "STOMATOPOD": "one of the Stomatopoda, marine crustaceans, including the squilla [n -S]\n",
  "STOMATOPODS": "STOMATOPOD, one of the Stomatopoda, marine crustaceans, including the squilla [n]\n",
  "STOMATOUS": "pertaining to a stoma, one of the minute apertures between the cells in many serous membranes, also STOMATAL [adj]\n",
  "STOMIA": "STOMIUM, a pollen cell which splits open to scatter pollen [n]\n",
  "STOMIUM": "a pollen cell which splits open to scatter pollen [n STOMIUMS or STOMIA]\n",
  "STOMIUMS": "STOMIUM, a pollen cell which splits open to scatter pollen [n]\n",
  "STOMODAEA": "STOMODAEUM, in embryology, the invagination that forms the anterior part of the digestive tract, also STOMODEUM [n]\n",
  "STOMODAEAL": "of or like a stomodaeum, in embryology, the invagination that forms the anterior part of the digestive tract [adj]\n",
  "STOMODAEUM": "in embryology, the invagination that forms the anterior part of the digestive tract, also STOMODEUM [n STOMODAEUMS or STOMODAEA]\n",
  "STOMODAEUMS": "STOMODAEUM, in embryology, the invagination that forms the anterior part of the digestive tract, also STOMODEUM [n]\n",
  "STOMODEA": "STOMODEUM, an embryonic oral cavity [n]\n",
  "STOMODEAL": "relating to the stomodeum, in embryology, the invagination that forms the anterior part of the digestive tract [adj]\n",
  "STOMODEUM": "an embryonic oral cavity [n STOMODEUMS or STOMODEA]\n",
  "STOMODEUMS": "STOMODEUM, an embryonic oral cavity [n]\n",
  "STOMP": "to tread heavily [v -ED, -ING, -S]\n",
  "STOMPED": "STOMP, to tread heavily [v]\n",
  "STOMPER": "one who stomps [n -S]\n",
  "STOMPERS": "STOMPER, one who stomps [n]\n",
  "STOMPIE": "(South African) a cigarette butt; a short man [n -S]\n",
  "STOMPIER": "STOMPY, conducive to stomping the feet [adj]\n",
  "STOMPIES": "STOMPIE, (South African) a cigarette butt; a short man [n]\n",
  "STOMPIEST": "STOMPY, conducive to stomping the feet [adj]\n",
  "STOMPING": "STOMP, to tread heavily [v]\n",
  "STOMPS": "STOMP, to tread heavily [v]\n",
  "STOMPY": "conducive to stomping the feet [adj STOMPIER, STOMPIEST]\n",
  "STONABLE": "carrying the penalty of being stoned, i.e. pelted with stones, also STONEABLE [adj]\n",
  "STOND": "(Spenser) a stand [n -S]\n",
  "STONDS": "STOND, (Spenser) a stand [n]\n",
  "STONE": "to pelt with pieces or mineral matter [v STONED, STONING, STONES]\n",
  "STONEABLE": "carrying the penalty of being stoned, i.e. pelted with stones, also STONABLE [adj]\n",
  "STONEBOAT": "(US) a low sledge for carrying rocks or other heavy objects [n -S]\n",
  "STONEBOATS": "STONEBOAT, (US) a low sledge for carrying rocks or other heavy objects [n]\n",
  "STONEBORER": "any boring mollusc [n -S]\n",
  "STONEBORERS": "STONEBORER, any boring mollusc [n]\n",
  "STONEBRASH": "a subsoil made up of small stones or finely-broken rock [n -ES]\n",
  "STONEBRASHES": "STONEBRASH, a subsoil made up of small stones or finely-broken rock [n]\n",
  "STONEBREAK": "another name for saxifrage [n -S]\n",
  "STONEBREAKER": "a person that breaks up stone; a machine used to break up stone [n -S]\n",
  "STONEBREAKERS": "STONEBREAKER, a person that breaks up stone; a machine used to break up stone [n]\n",
  "STONEBREAKS": "STONEBREAK, another name for saxifrage [n]\n",
  "STONECAST": "the throw of a stone [n -S]\n",
  "STONECASTS": "STONECAST, the throw of a stone [n]\n",
  "STONECHAT": "a small bird of heath and moor [n -S]\n",
  "STONECHATS": "STONECHAT, a small bird of heath and moor [n]\n",
  "STONECROP": "a yellow flower of rockeries etc. [n -S]\n",
  "STONECROPS": "STONECROP, a yellow flower of rockeries etc. [n]\n",
  "STONECUT": "a print made from an image engraved on a stone [n -S]\n",
  "STONECUTS": "STONECUT, a print made from an image engraved on a stone [n]\n",
  "STONECUTTER": "one who cuts stone [n -S]\n",
  "STONECUTTERS": "STONECUTTER, one who cuts stone [n]\n",
  "STONECUTTING": "the business of a stonecutter [n -S]\n",
  "STONECUTTINGS": "STONECUTTING, the business of a stonecutter [n]\n",
  "STONED": "STONE, to pelt with pieces or mineral matter [v]\n",
  "STONEFISH": "a venomous fish of North Australia [n -ES]\n",
  "STONEFISHES": "STONEFISH, a venomous fish of North Australia [n]\n",
  "STONEFLIES": "STONEFLY, a winged insect [n]\n",
  "STONEFLY": "a winged insect [n STONEFLIES]\n",
  "STONEGROUND": "of flour, ground with stones [adj]\n",
  "STONEHAND": "in printing, an imposer, a person whose sets the type in a chase [n -S]\n",
  "STONEHANDS": "STONEHAND, in printing, an imposer, a person whose sets the type in a chase [n]\n",
  "STONEHORSE": "a stallion [n -S]\n",
  "STONEHORSES": "STONEHORSE, a stallion [n]\n",
  "STONELESS": "without a stone [adj]\n",
  "STONELESSNESS": "the state of being stoneless [n -ES]\n",
  "STONELESSNESSES": "STONELESSNESS, the state of being stoneless [n]\n",
  "STONELIKE": "like stone [adj]\n",
  "STONEMASON": "a mason who builds with stone [n -S]\n",
  "STONEMASONRIES": "STONEMASONRY, the craft of the stonemason [n]\n",
  "STONEMASONRY": "the craft of the stonemason [n STONEMASONRIES]\n",
  "STONEMASONS": "STONEMASON, a mason who builds with stone [n]\n",
  "STONEN": "(dialect) of stone, also STONERN [adj]\n",
  "STONER": "one who stones [n -S]\n",
  "STONERAG": "a kind of lichen, also STONERAW [n -S]\n",
  "STONERAGS": "STONERAG, a kind of lichen, also STONERAW [n]\n",
  "STONERAW": "a kind of lichen, also STONERAG [n -S]\n",
  "STONERAWS": "STONERAW, a kind of lichen, also STONERAG [n]\n",
  "STONERN": "(dialect) of stone, also STONEN [adj]\n",
  "STONERS": "STONER, one who stones [n]\n",
  "STONES": "STONE, to pelt with pieces or mineral matter [v]\n",
  "STONESHOT": "a stone or stones used as shot [n -S]\n",
  "STONESHOTS": "STONESHOT, a stone or stones used as shot [n]\n",
  "STONEWALL": "of a batsman, to play defensively [v -ED, -ING, -S]\n",
  "STONEWALLED": "STONEWALL, of a batsman, to play defensively [v]\n",
  "STONEWALLER": "one who stonewalls [n -S]\n",
  "STONEWALLERS": "STONEWALLER, one who stonewalls [n]\n",
  "STONEWALLING": "defensive play in cricket [n -S]\n",
  "STONEWALLINGS": "STONEWALLING, defensive play in cricket [n]\n",
  "STONEWALLS": "STONEWALL, of a batsman, to play defensively [v]\n",
  "STONEWARE": "a species of coarse potter's ware, glazed and baked [n -S]\n",
  "STONEWARES": "STONEWARE, a species of coarse potter's ware, glazed and baked [n]\n",
  "STONEWASH": "to wash with stones to give a worn appearance [v -ED, -ING, -ES]\n",
  "STONEWASHED": "STONEWASH, to wash with stones to give a worn appearance [v]\n",
  "STONEWASHES": "STONEWASH, to wash with stones to give a worn appearance [v]\n",
  "STONEWASHING": "STONEWASH, to wash with stones to give a worn appearance [v]\n",
  "STONEWORK": "any work in stone [n -S]\n",
  "STONEWORKER": "a worker in stone [n -S]\n",
  "STONEWORKERS": "STONEWORKER, a worker in stone [n]\n",
  "STONEWORKS": "STONEWORK, any work in stone [n]\n",
  "STONEWORT": "any plant of the Characeae (from the limy crust); stone parsley [n -S]\n",
  "STONEWORTS": "STONEWORT, any plant of the Characeae (from the limy crust); stone parsley [n]\n",
  "STONEY": "abounding in small rocks, also STONY [adj STONIER, STONIEST, STONILY]\n",
  "STONG": "STING, to prick painfully [v]\n",
  "STONIED": "STONY, aphetic for astony, to astonish [v]\n",
  "STONIER": "STONY, of or like stone, also STONEY [adj]\n",
  "STONIES": "STONY, aphetic for astony, to astonish [v]\n",
  "STONIEST": "STONY, of or like stone, also STONEY [adj]\n",
  "STONILY": "STONY, of or like stone, also STONEY [adv]\n",
  "STONINESS": "the state of being stony [n -ES]\n",
  "STONINESSES": "STONINESS, the state of being stony [n]\n",
  "STONING": "the act of stoning [n -S]\n",
  "STONINGS": "STONING, the act of stoning [n]\n",
  "STONISH": "to astonish [v -ED, -ING, -ES]\n",
  "STONISHED": "STONISH, to astonish [v]\n",
  "STONISHES": "STONISH, to astonish [v]\n",
  "STONISHING": "STONISH, to astonish [v]\n",
  "STONK": "(slang) to bombard [v -ED, -ING, -S]\n",
  "STONKED": "STONK, (slang) to bombard [v]\n",
  "STONKER": "(Australian slang) to hit hard, to knock unconscious [v -ED, -ING, -S]\n",
  "STONKERED": "STONKER, (Australian slang) to hit hard, to knock unconscious [v]\n",
  "STONKERING": "STONKER, (Australian slang) to hit hard, to knock unconscious [v]\n",
  "STONKERS": "STONKER, (Australian slang) to hit hard, to knock unconscious [v]\n",
  "STONKING": "STONK, (slang) to bombard [v]\n",
  "STONKS": "STONK, (slang) to bombard [v]\n",
  "STONN": "(obsolete) to stun, also STONNE, STOUN [v -ED, -ING, -S]\n",
  "STONNE": "(obsolete) to stun, also STONN, STOUN [v STONNED, STONNING, STONNES]\n",
  "STONNED": "STONNE, (obsolete) to stun, also STONN, STOUN [v]\n",
  "STONNES": "STONNE, (obsolete) to stun, also STONN, STOUN [v]\n",
  "STONNING": "STONNE, (obsolete) to stun, also STONN, STOUN [v]\n",
  "STONNS": "STONN, (obsolete) to stun, also STONNE, STOUN [v]\n",
  "STONY": "of or like stone, also STONEY [adj STONIER, STONIEST, STONILY] / aphetic for astony, to astonish [v STONIED, STONYING, STONIES]\n",
  "STONYHEARTED": "unfeeling, cruel [adj]\n",
  "STONYING": "STONY, aphetic for astony, to astonish [v]\n",
  "STOOD": "STAND, to assume an upright position, also STAUN [v]\n",
  "STOODEN": "STAND, to assume an upright position, also STAUN [v]\n",
  "STOOGE": "to act as a comedian's straight man [v STOOGED, STOOGING, STOOGES]\n",
  "STOOGED": "STOOGE, to act as a comedian's straight man [v]\n",
  "STOOGES": "STOOGE, to act as a comedian's straight man [v]\n",
  "STOOGING": "STOOGE, to act as a comedian's straight man [v]\n",
  "STOOK": "to stack grain upright in a field for drying [v -ED, -ING, -S]\n",
  "STOOKED": "STOOK, to stack grain upright in a field for drying [v]\n",
  "STOOKER": "one who stooks, sets up sheaves in a field [n -S]\n",
  "STOOKERS": "STOOKER, one who stooks, sets up sheaves in a field [n]\n",
  "STOOKIE": "(Scots) stucco; a statue [n -S]\n",
  "STOOKIES": "STOOKIE, (Scots) stucco; a statue [n]\n",
  "STOOKING": "the act of putting corn in stooks [n -S]\n",
  "STOOKINGS": "STOOKING, the act of putting corn in stooks [n]\n",
  "STOOKS": "STOOK, to stack grain upright in a field for drying [v]\n",
  "STOOL": "to put forth shoots [v -ED, -ING, -S]\n",
  "STOOLBALL": "a kind of game with balls, formerly common in England, esp. with young women [n -S]\n",
  "STOOLBALLS": "STOOLBALL, a kind of game with balls, formerly common in England, esp. with young women [n]\n",
  "STOOLED": "STOOL, to put forth shoots [v]\n",
  "STOOLIE": "(short for) a stool-pigeon, a police informer, also STOOLY [n -S]\n",
  "STOOLIES": "STOOLIE, (short for) a stool-pigeon, a police informer, also STOOLY [n]\n",
  "STOOLING": "STOOL, to put forth shoots [v]\n",
  "STOOLS": "STOOL, to put forth shoots [v]\n",
  "STOOLY": "(US) an informant for the police, also STOOLIE [n STOOLIES]\n",
  "STOOP": "to bend the body forward and down [v -ED, -ING, -S]\n",
  "STOOPBALL": "a variation of baseball [n -S]\n",
  "STOOPBALLS": "STOOPBALL, a variation of baseball [n]\n",
  "STOOPE": "(Shakespeare) a vessel for holy water, also STOUP, STOWP [n -S]\n",
  "STOOPED": "STOOP, to bend the body forward and down [v]\n",
  "STOOPER": "one who stoops [n -S]\n",
  "STOOPERS": "STOOPER, one who stoops [n]\n",
  "STOOPES": "STOOPE, (Shakespeare) a vessel for holy water, also STOUP, STOWP [n]\n",
  "STOOPING": "STOOP, to bend the body forward and down [v]\n",
  "STOOPINGLY": "STOOPING, STOOP, to bend the body forward and down [adv]\n",
  "STOOPS": "STOOP, to bend the body forward and down [v]\n",
  "STOOR": "a battle, an affray, also STOUR, STOURE, STOWRE, STURE [n -S]\n",
  "STOORS": "STOOR, a battle, an affray, also STOUR, STOURE, STOWRE, STURE [n]\n",
  "STOOSHIE": "(Scots) fuss, ado, also STASHIE, STISHIE, STOUSHIE, STUSHIE [n -S]\n",
  "STOOSHIES": "STOOSHIE, (Scots) fuss, ado, also STASHIE, STISHIE, STOUSHIE, STUSHIE [n]\n",
  "STOOZE": "to borrow money at an interest rate of 0%, a rate typically offered by credit card companies as an incentive for new customers [v STOOZED, STOOZING, STOOZES]\n",
  "STOOZED": "STOOZE, to borrow money at an interest rate of 0%, a rate typically offered by credit card companies as an incentive for new customers [v]\n",
  "STOOZER": "one who stoozes [n -S]\n",
  "STOOZERS": "STOOZER, one who stoozes [n]\n",
  "STOOZES": "STOOZE, to borrow money at an interest rate of 0%, a rate typically offered by credit card companies as an incentive for new customers [v]\n",
  "STOOZING": "the practice of taking advantage of an introductory interest-free period offered by a credit-card company to borrow money for investment elsewhere, esp. in a high-interest account [n -S]\n",
  "STOOZINGS": "STOOZING, the practice of taking advantage of an introductory interest-free period offered by a credit-card company to borrow money for investment elsewhere, esp. in a high-interest account [n]\n",
  "STOP": "to halt or discontinue [v STOPT or STOPPED, STOPPING, STOPS]\n",
  "STOPBAND": "a band of frequencies limited by a filter [n -S]\n",
  "STOPBANDS": "STOPBAND, a band of frequencies limited by a filter [n]\n",
  "STOPBANK": "(New Zealand) an embankment along a river [n -S]\n",
  "STOPBANKS": "STOPBANK, (New Zealand) an embankment along a river [n]\n",
  "STOPCOCK": "a short pipe opened and stopped by turning a key or handle [n -S]\n",
  "STOPCOCKS": "STOPCOCK, a short pipe opened and stopped by turning a key or handle [n]\n",
  "STOPE": "to excavate in layers [v STOPED, STOPING, STOPES]\n",
  "STOPED": "STOPE, to excavate in layers [v]\n",
  "STOPER": "one that stopes, excavates in mining using a stope [n -S]\n",
  "STOPERS": "STOPER, one that stopes, excavates in mining using a stope [n]\n",
  "STOPES": "STOPE, to excavate in layers [v]\n",
  "STOPGAP": "a temporary substitute [n -S]\n",
  "STOPGAPS": "STOPGAP, a temporary substitute [n]\n",
  "STOPING": "the process of steplike excavation [n -S]\n",
  "STOPINGS": "STOPING, the process of steplike excavation [n]\n",
  "STOPLESS": "without a stop [adj]\n",
  "STOPLIGHT": "the brake light on a car [n -S]\n",
  "STOPLIGHTS": "STOPLIGHT, the brake light on a car [n]\n",
  "STOPOFF": "a brief stop in the course of a journey, also STOPOVER [n -S]\n",
  "STOPOFFS": "STOPOFF, a brief stop in the course of a journey, also STOPOVER [n]\n",
  "STOPOVER": "a brief stop in the course of a journey, also STOPOFF [n -S]\n",
  "STOPOVERS": "STOPOVER, a brief stop in the course of a journey, also STOPOFF [n]\n",
  "STOPPABLE": "that can be stopped [adj]\n",
  "STOPPAGE": "the act of stopping [n -S]\n",
  "STOPPAGES": "STOPPAGE, the act of stopping [n]\n",
  "STOPPED": "STOP, to halt or discontinue [v]\n",
  "STOPPER": "a plug, usually glass, for a bottle [n -S] / to seal with a stopper [v -ED, -ING, -S]\n",
  "STOPPERED": "STOPPER, to seal with a stopper [v]\n",
  "STOPPERING": "STOPPER, to seal with a stopper [v]\n",
  "STOPPERS": "STOPPER, to seal with a stopper [v]\n",
  "STOPPING": "the action of one who stops [n -S]\n",
  "STOPPINGS": "STOPPING, the action of one who stops [n]\n",
  "STOPPLE": "to stop up, plug [v STOPPLED, STOPPLING, STOPPLES]\n",
  "STOPPLED": "STOPPLE, to stop up, plug [v]\n",
  "STOPPLES": "STOPPLE, to stop up, plug [v]\n",
  "STOPPLING": "STOPPLE, to stop up, plug [v]\n",
  "STOPS": "STOP, to halt or discontinue [v]\n",
  "STOPT": "STOP, to halt or discontinue [v]\n",
  "STOPWATCH": "an accurate watch readily started and stopped, used in timing a race, etc. [n -ES]\n",
  "STOPWATCHES": "STOPWATCH, an accurate watch readily started and stopped, used in timing a race, etc. [n]\n",
  "STOPWORD": "a frequently used word that is not searchable by search engines [n -S]\n",
  "STOPWORDS": "STOPWORD, a frequently used word that is not searchable by search engines [n]\n",
  "STORABLE": "something that can be stored [n -S]\n",
  "STORABLES": "STORABLE, something that can be stored [n]\n",
  "STORAGE": "a place for storing [n -S]\n",
  "STORAGES": "STORAGE, a place for storing [n]\n",
  "STORAX": "(Latin) a fragrant resin, also STYRAX [n -ES]\n",
  "STORAXES": "STORAX, (Latin) a fragrant resin, also STYRAX [n]\n",
  "STORE": "to put away for future use [v STORED, STORING, STORES]\n",
  "STORECARD": "a charge card [n -S]\n",
  "STORECARDS": "STORECARD, a charge card [n]\n",
  "STORED": "STORE, to put away for future use [v]\n",
  "STOREFRONT": "the front side of a store or store building facing a street [n -S]\n",
  "STOREFRONTS": "STOREFRONT, the front side of a store or store building facing a street [n]\n",
  "STOREHOUSE": "a place where food and other stores are kept [n -S]\n",
  "STOREHOUSES": "STOREHOUSE, a place where food and other stores are kept [n]\n",
  "STOREKEEPER": "one that has charge of supplies, as military stores [n -S]\n",
  "STOREKEEPERS": "STOREKEEPER, one that has charge of supplies, as military stores [n]\n",
  "STOREKEEPING": "the business of keeping a store [n -S]\n",
  "STOREKEEPINGS": "STOREKEEPING, the business of keeping a store [n]\n",
  "STOREMAN": "a storekeeper [n STOREMEN]\n",
  "STOREMEN": "STOREMAN, a storekeeper [n]\n",
  "STORER": "one who stores things [n -S]\n",
  "STOREROOM": "a room in which things are stored [n -S]\n",
  "STOREROOMS": "STOREROOM, a room in which things are stored [n]\n",
  "STORERS": "STORER, one who stores things [n]\n",
  "STORES": "STORE, to put away for future use [v]\n",
  "STORESHIP": "a vessel used to carry naval stores for a fleet, garrison, or the like [n -S]\n",
  "STORESHIPS": "STORESHIP, a vessel used to carry naval stores for a fleet, garrison, or the like [n]\n",
  "STOREWIDE": "extending throughout a store [adj]\n",
  "STOREY": "a horizontal division of a building [n -S]\n",
  "STOREYED": "having a storey [adj]\n",
  "STOREYS": "STOREY, a horizontal division of a building [n]\n",
  "STORGE": "(Greek) natural or parental affection [n -S]\n",
  "STORGES": "STORGE, (Greek) natural or parental affection [n]\n",
  "STORIATED": "decorated with elaborate ornamental designs, also HISTORIATED [adj]\n",
  "STORIED": "STORY, to relate an account of an event [v]\n",
  "STORIES": "STORY, to relate an account of an event [v]\n",
  "STORIETTE": "a short tale, also STORYETTE [n -S]\n",
  "STORIETTES": "STORIETTE, a short tale, also STORYETTE [n]\n",
  "STORING": "STORE, to put away for future use [v]\n",
  "STORIOLOGIES": "STORIOLOGY, the study of folk tales [n]\n",
  "STORIOLOGIST": "a folklorist [n -S]\n",
  "STORIOLOGISTS": "STORIOLOGIST, a folklorist [n]\n",
  "STORIOLOGY": "the study of folk tales [n STORIOLOGIES]\n",
  "STORK": "any large wading bird of the family Ciconiidae [n -S]\n",
  "STORKS": "STORK, any large wading bird of the family Ciconiidae [n]\n",
  "STORKSBILL": "any plant of the genus Erodium [n -S]\n",
  "STORKSBILLS": "STORKSBILL, any plant of the genus Erodium [n]\n",
  "STORM": "to blow violently [v -ED, -ING, -S]\n",
  "STORMBIRD": "a petrel [n -S]\n",
  "STORMBIRDS": "STORMBIRD, a petrel [n]\n",
  "STORMBOUND": "trapped by a storm [adj]\n",
  "STORMCOCK": "a missel-thrush [n -S]\n",
  "STORMCOCKS": "STORMCOCK, a missel-thrush [n]\n",
  "STORMED": "STORM, to blow violently [v]\n",
  "STORMER": "a humdinger, a really outstanding instance of something [n -S]\n",
  "STORMERS": "STORMER, a humdinger, a really outstanding instance of something [n]\n",
  "STORMFUL": "abounding with storms [adj STORMFULLY]\n",
  "STORMFULLY": "STORMFUL, abounding with storms [adv]\n",
  "STORMFULNESS": "the state of being stormful, abounding with storms [n -ES]\n",
  "STORMFULNESSES": "STORMFULNESS, the state of being stormful, abounding with storms [n]\n",
  "STORMIER": "STORMY, wild, tempestuous [adj]\n",
  "STORMIEST": "STORMY, wild, tempestuous [adj]\n",
  "STORMILY": "STORMY, wild, tempestuous [adv]\n",
  "STORMINESS": "the state of being stormy [n -ES]\n",
  "STORMINESSES": "STORMINESS, the state of being stormy [n]\n",
  "STORMING": "the act of storming [n -S]\n",
  "STORMINGS": "STORMING, the act of storming [n]\n",
  "STORMLESS": "without storms [adj]\n",
  "STORMLIKE": "like a storm [adj]\n",
  "STORMPROOF": "proof against bad weather [adj]\n",
  "STORMS": "STORM, to blow violently [v]\n",
  "STORMSTAYED": "(Canadian) isolated or unable to travel because of adverse weather conditions, esp a snowstorm [adj]\n",
  "STORMY": "wild, tempestuous [adj STORMIER, STORMIEST, STORMILY]\n",
  "STORNELLI": "STORNELLO, (Italian) an Italian folk verse form [n]\n",
  "STORNELLO": "(Italian) an Italian folk verse form [n STORNELLI]\n",
  "STORY": "to relate an account of an event [v STORIED, STORYING, STORIES]\n",
  "STORYBOARD": "a board on which is mounted a series of rough sketches outlining a story [n -S] / to put on a storyboard [v -ED, -ING, -S]\n",
  "STORYBOARDED": "STORYBOARD, to put on a storyboard [v]\n",
  "STORYBOARDING": "STORYBOARD, to put on a storyboard [v]\n",
  "STORYBOARDS": "STORYBOARD, a board on which is mounted a series of rough sketches outlining a story [n]\n",
  "STORYBOOK": "a book of tales true or fictitious, esp. one for children [n -S]\n",
  "STORYBOOKS": "STORYBOOK, a book of tales true or fictitious, esp. one for children [n]\n",
  "STORYETTE": "a short tale, also STORIETTE [n -S]\n",
  "STORYETTES": "STORYETTE, a short tale, also STORIETTE [n]\n",
  "STORYING": "the art of relating tales [n -S]\n",
  "STORYINGS": "STORYING, the art of relating tales [n]\n",
  "STORYLESS": "without a story [adj]\n",
  "STORYLINE": "the main plot of a novel, film, television series, etc. [n -S]\n",
  "STORYLINES": "STORYLINE, the main plot of a novel, film, television series, etc. [n]\n",
  "STORYTELLER": "a teller of stories [n -S]\n",
  "STORYTELLERS": "STORYTELLER, a teller of stories [n]\n",
  "STORYTELLING": "the craft of telling stories [n -S]\n",
  "STORYTELLINGS": "STORYTELLING, the craft of telling stories [n]\n",
  "STORYTIME": "a time set aside for the telling of stories [n -S]\n",
  "STORYTIMES": "STORYTIME, a time set aside for the telling of stories [n]\n",
  "STOSS": "the side of a hill facing upstream [n -ES]\n",
  "STOSSES": "STOSS, the side of a hill facing upstream [n]\n",
  "STOT": "to bound, also STOTT [v STOTTED, STOTTING, STOTS]\n",
  "STOTIN": "a monetary unit of Slovenia, worth one hundredth of a tolar [n STOTINS or STOTINOV]\n",
  "STOTINKA": "(Bulgarian) a Bulgarian monetary unit, worth one hundredth of a lev [n STOTINKI or STOTINKAS]\n",
  "STOTINKAS": "STOTINKA, (Bulgarian) a Bulgarian monetary unit, worth one hundredth of a lev [n]\n",
  "STOTINKI": "STOTINKA, (Bulgarian) a Bulgarian monetary unit, worth one hundredth of a lev [n]\n",
  "STOTINOV": "STOTIN, a monetary unit of Slovenia, worth one hundredth of a tolar [n]\n",
  "STOTINS": "STOTIN, a monetary unit of Slovenia, worth one hundredth of a tolar [n]\n",
  "STOTIOUS": "(Irish slang) drunk, intoxicated, also STOCIOUS [adj]\n",
  "STOTS": "STOT, to bound, also STOTT [v]\n",
  "STOTT": "to bound with a stiff gait, also STOT [v -ED, -ING, -S]\n",
  "STOTTED": "STOTT, to bound with a stiff gait, also STOT [v]\n",
  "STOTTER": "to stagger, also STOIT, STOITER, STYTE [v -ED, -ING, -S]\n",
  "STOTTERED": "STOTTER, to stagger, also STOIT, STOITER, STYTE [v]\n",
  "STOTTERING": "STOTTER, to stagger, also STOIT, STOITER, STYTE [v]\n",
  "STOTTERS": "STOTTER, to stagger, also STOIT, STOITER, STYTE [v]\n",
  "STOTTIE": "(dialect) a wedge of bread cut from a round loaf and stuffed with meat or cheese, also STOTTY [n -S]\n",
  "STOTTIES": "STOTTIE, (dialect) a wedge of bread cut from a round loaf and stuffed with meat or cheese, also STOTTY [n]\n",
  "STOTTING": "STOTT, to bound with a stiff gait, also STOT [v]\n",
  "STOTTS": "STOTT, to bound with a stiff gait, also STOT [v]\n",
  "STOTTY": "(dialect) a wedge of bread cut from a round loaf and stuffed with meat or cheese, also STOTTIE [n STOTTIES]\n",
  "STOUN": "(Spenser) to stun, astound, also STONN, STONNE, STUN [v STOUND, STOUNING, STOUNS]\n",
  "STOUND": "to ache, throb, also STOWND [v -ED, -ING, -S]\n",
  "STOUNDED": "STOUND, to ache, throb, also STOWND [v]\n",
  "STOUNDING": "STOUND, to ache, throb, also STOWND [v]\n",
  "STOUNDS": "STOUND, to ache, throb, also STOWND [v]\n",
  "STOUNING": "STOUN, (Spenser) to stun, astound, also STONN, STONNE, STUN [v]\n",
  "STOUNS": "STOUN, (Spenser) to stun, astound, also STONN, STONNE, STUN [v]\n",
  "STOUP": "a vessel for holding holy water, also STOOPE, STOWP [n -S]\n",
  "STOUPS": "STOUP, a vessel for holding holy water, also STOOPE, STOWP [n]\n",
  "STOUR": "(Scots) a battle, assault, also STOOR, STOURE, STOWRE, STURE [n -S]\n",
  "STOURE": "(archaic) tumult, disturbance, also STOOR, STOUR, STOWRE, STURE [n -S]\n",
  "STOURES": "STOURE, (archaic) tumult, disturbance, also STOOR, STOUR, STOWRE, STURE [n]\n",
  "STOURIE": "(Scots) dusty, also STOURY [adj STOURIER, STOURIEST]\n",
  "STOURIER": "STOURY, (Scots) dusty, also STOURIE [adj]\n",
  "STOURIEST": "STOURY, (Scots) dusty, also STOURIE [adj]\n",
  "STOURS": "STOUR, (Scots) a battle, assault, also STOOR, STOURE, STOWRE, STURE [n]\n",
  "STOURY": "(Scots) dusty, also STOURIE [adj STOURIER, STOURIEST]\n",
  "STOUSH": "(Australian slang) to fight [v -ED, -ING, -ES]\n",
  "STOUSHED": "STOUSH, (Australian slang) to fight [v]\n",
  "STOUSHES": "STOUSH, (Australian slang) to fight [v]\n",
  "STOUSHIE": "(Scots) fuss, ado, also STASHIE, STISHIE, STOOSHIE, STUSHIE [n -S]\n",
  "STOUSHIES": "STOUSHIE, (Scots) fuss, ado, also STASHIE, STISHIE, STOOSHIE, STUSHIE [n]\n",
  "STOUSHING": "STOUSH, (Australian slang) to fight [v]\n",
  "STOUT": "thick, resolute [adj STOUTER, STOUTEST, STOUTLY] / a strong dark beer brewed with roasted malt or barley [n -S]\n",
  "STOUTEN": "to make stout [v -ED, -ING, -S]\n",
  "STOUTENED": "STOUTEN, to make stout [v]\n",
  "STOUTENING": "STOUTEN, to make stout [v]\n",
  "STOUTENS": "STOUTEN, to make stout [v]\n",
  "STOUTER": "STOUT, thick, resolute [adj]\n",
  "STOUTEST": "STOUT, thick, resolute [adj]\n",
  "STOUTH": "(Scots) theft [n -S]\n",
  "STOUTHEARTED": "having a stout heart or spirit [adj STOUTHEARTEDLY]\n",
  "STOUTHEARTEDLY": "STOUTHEARTED, having a stout heart or spirit [adv]\n",
  "STOUTHERIE": "(Scots) theft, stolen goods [n -S]\n",
  "STOUTHERIES": "STOUTHERIE, (Scots) theft, stolen goods [n]\n",
  "STOUTHRIEF": "(Scots) theft with violence [n -S]\n",
  "STOUTHRIEFS": "STOUTHRIEF, (Scots) theft with violence [n]\n",
  "STOUTHS": "STOUTH, (Scots) theft [n]\n",
  "STOUTISH": "somewhat stout [adj]\n",
  "STOUTLY": "STOUT, thick, resolute [adv]\n",
  "STOUTNESS": "the state of being stout [n -ES]\n",
  "STOUTNESSES": "STOUTNESS, the state of being stout [n]\n",
  "STOUTS": "STOUT, a strong dark beer brewed with roasted malt or barley [n]\n",
  "STOVAINE": "an anaesthetic cocaine-substitute, chiefly injected into spine [n -S]\n",
  "STOVAINES": "STOVAINE, an anaesthetic cocaine-substitute, chiefly injected into spine [n]\n",
  "STOVE": "to dry in a heating or cooking apparatus [v STOVED, STOVING, STOVES]\n",
  "STOVED": "STOVE, to dry in a heating or cooking apparatus [v]\n",
  "STOVEPIPE": "a man's tall cylindrical (usually silk) hat [n -S]\n",
  "STOVEPIPES": "STOVEPIPE, a man's tall cylindrical (usually silk) hat [n]\n",
  "STOVER": "(archaic) the dried leaves and stalks of a cereal crop after harvest, also ESTOVER [n -S]\n",
  "STOVERS": "STOVER, (archaic) the dried leaves and stalks of a cereal crop after harvest, also ESTOVER [n]\n",
  "STOVES": "STOVE, to dry in a heating or cooking apparatus [v]\n",
  "STOVETOP": "the hob of a stove [n -S]\n",
  "STOVETOPS": "STOVETOP, the hob of a stove [n]\n",
  "STOVEWOOD": "wood split for burning in a stove [n -S]\n",
  "STOVEWOODS": "STOVEWOOD, wood split for burning in a stove [n]\n",
  "STOVIES": "(Scots) a thick stew of potatoes, lard, onions and sausage-meat [n]\n",
  "STOVING": "the act of drying paint with heat quickly [n -S]\n",
  "STOVINGS": "STOVING, the act of drying paint with heat quickly [n]\n",
  "STOW": "to put away [v -ED, -ING, -S]\n",
  "STOWABLE": "able to be stowed [adj]\n",
  "STOWAGE": "goods in storage [n -S]\n",
  "STOWAGES": "STOWAGE, goods in storage [n]\n",
  "STOWAWAY": "a person who hides away to get free passage [n -S]\n",
  "STOWAWAYS": "STOWAWAY, a person who hides away to get free passage [n]\n",
  "STOWDOWN": "the process of stowing in a ship's hold [n -S]\n",
  "STOWDOWNS": "STOWDOWN, the process of stowing in a ship's hold [n]\n",
  "STOWED": "STOW, to put away [v]\n",
  "STOWER": "one who stows [n -S]\n",
  "STOWERS": "STOWER, one who stows [n]\n",
  "STOWING": "the act of stowing [n -S]\n",
  "STOWINGS": "STOWING, the act of stowing [n]\n",
  "STOWLINS": "(Scots) by stealth, also STOWNLINS [adv]\n",
  "STOWN": "STEAL, to take by theft [v]\n",
  "STOWND": "to ache, throb, also STOUND [v -ED, -ING, -S]\n",
  "STOWNDED": "STOWND, to ache, throb, also STOUND [v]\n",
  "STOWNDING": "STOWND, to ache, throb, also STOUND [v]\n",
  "STOWNDS": "STOWND, to ache, throb, also STOUND [v]\n",
  "STOWNLINS": "(Scots) by stealth, also STOWLINS [adv]\n",
  "STOWP": "a vessel for holding holy water, also STOOPE, STOUP [n -S]\n",
  "STOWPS": "STOWP, a vessel for holding holy water, also STOOPE, STOUP [n]\n",
  "STOWRE": "(Scots) a battle assault, also STOOR, STOUR, STOURE, STURE [n -S]\n",
  "STOWRES": "STOWRE, (Scots) a battle assault, also STOOR, STOUR, STOURE, STURE [n]\n",
  "STOWS": "STOW, to put away [v]\n",
  "STRABISM": "a squint, also STRABISMUS [n -S]\n",
  "STRABISMAL": "of or like a strabismus, a squint, also STRABISMIC, STRABISMICAL [adj]\n",
  "STRABISMIC": "of or like a strabismus, a squint, also STRABISMAL, STRABISMICAL [adj]\n",
  "STRABISMICAL": "of or like a strabismus, a squint, also STRABISMAL, STRABISMIC [adj]\n",
  "STRABISMOMETER": "an instrument measuring the degree of strabismus in the eyes, also STRABOMETER [n -S]\n",
  "STRABISMOMETERS": "STRABISMOMETER, an instrument measuring the degree of strabismus in the eyes, also STRABOMETER [n]\n",
  "STRABISMS": "STRABISM, a squint, also STRABISMUS [n]\n",
  "STRABISMUS": "a squint, also STRABISM [n -ES]\n",
  "STRABISMUSES": "STRABISMUS, a squint, also STRABISM [n]\n",
  "STRABOMETER": "an instrument measuring the degree of strabismus in the eyes, also STRABISMOMETER [n -S]\n",
  "STRABOMETERS": "STRABOMETER, an instrument measuring the degree of strabismus in the eyes, also STRABISMOMETER [n]\n",
  "STRABOTOMIES": "STRABOTOMY, surgical removal of a squint [n]\n",
  "STRABOTOMY": "surgical removal of a squint [n STRABOTOMIES]\n",
  "STRACCHINI": "STRACCHINO, (Italian) a type of soft whole-milk Italian cheese [n]\n",
  "STRACCHINO": "(Italian) a type of soft whole-milk Italian cheese [n STRACCHINI]\n",
  "STRACK": "STRIKE, to hit [v]\n",
  "STRAD": "(short for) a Stradivarius, a make of violin [n -S]\n",
  "STRADDLE": "to bestride; to set (the legs) far apart, also STRIDDLE, STRODDLE, STRODLE [v STRADDLED, STRADDLING, STRADDLES]\n",
  "STRADDLEBACK": "with legs astride [adv]\n",
  "STRADDLED": "STRADDLE, to bestride; to set (the legs) far apart, also STRIDDLE, STRODDLE, STRODLE [v]\n",
  "STRADDLER": "one who straddles [n -S]\n",
  "STRADDLERS": "STRADDLER, one who straddles [n]\n",
  "STRADDLES": "STRADDLE, to bestride; to set (the legs) far apart, also STRIDDLE, STRODDLE, STRODLE [v]\n",
  "STRADDLING": "STRADDLE, to bestride; to set (the legs) far apart, also STRIDDLE, STRODDLE, STRODLE [v]\n",
  "STRADIOT": "(historical) a Venetian light horseman from Albania or Greece [n -S]\n",
  "STRADIOTS": "STRADIOT, (historical) a Venetian light horseman from Albania or Greece [n]\n",
  "STRADS": "STRAD, (short for) a Stradivarius, a make of violin [n]\n",
  "STRAE": "(Scots) straw [n -S]\n",
  "STRAES": "STRAE, (Scots) straw [n]\n",
  "STRAFE": "(German) to rake with machinegun fire from a low-flying aeroplane [v STRAFED, STRAFING, STRAFES]\n",
  "STRAFED": "STRAFE, (German) to rake with machinegun fire from a low-flying aeroplane [v]\n",
  "STRAFER": "one who strafes [n -S]\n",
  "STRAFERS": "STRAFER, one who strafes [n]\n",
  "STRAFES": "STRAFE, (German) to rake with machinegun fire from a low-flying aeroplane [v]\n",
  "STRAFF": "(German) to rake with machinegun fire from low-flying aircraft, also STRAFE [v -ED, -ING, -S]\n",
  "STRAFFED": "STRAFF, (German) to rake with machinegun fire from low-flying aircraft, also STRAFE [v]\n",
  "STRAFFING": "STRAFF, (German) to rake with machinegun fire from low-flying aircraft, also STRAFE [v]\n",
  "STRAFFS": "STRAFF, (German) to rake with machinegun fire from low-flying aircraft, also STRAFE [v]\n",
  "STRAFING": "the act of raking with machinegun fire from low-flying aeroplanes [n -S]\n",
  "STRAFINGS": "STRAFING, the act of raking with machinegun fire from low-flying aeroplanes [n]\n",
  "STRAG": "a straggler [n -S]\n",
  "STRAGGLE": "to stray [v STRAGGLED, STRAGGLING, STRAGGLES]\n",
  "STRAGGLED": "STRAGGLE, to stray [v]\n",
  "STRAGGLER": "one who straggles [n -S]\n",
  "STRAGGLERS": "STRAGGLER, one who straggles [n]\n",
  "STRAGGLES": "STRAGGLE, to stray [v]\n",
  "STRAGGLIER": "STRAGGLY, irregularly spread out [adj]\n",
  "STRAGGLIEST": "STRAGGLY, irregularly spread out [adj]\n",
  "STRAGGLING": "wandering from the main group or course [adj STRAGGLINGLY] / the act of straggling [n -S]\n",
  "STRAGGLINGLY": "STRAGGLING, wandering from the main group or course [adv]\n",
  "STRAGGLINGS": "STRAGGLING, the act of straggling [n]\n",
  "STRAGGLY": "irregularly spread out [adj STRAGGLIER, STRAGGLIEST]\n",
  "STRAGS": "STRAG, a straggler [n]\n",
  "STRAICHT": "(Scots) straight, also STRAUCHT, STRAUGHT [adj STRAICHTER, STRAICHTEST]\n",
  "STRAICHTER": "STRAICHT, (Scots) straight, also STRAUCHT, STRAUGHT [adj]\n",
  "STRAICHTEST": "STRAICHT, (Scots) straight, also STRAUCHT, STRAUGHT [adj]\n",
  "STRAIGHT": "uncurved, also STRAICHT, STRAUCHT, STRAUGHT [adj STRAIGHTER, STRAIGHTEST, STRAIGHTLY] / to lay out a corpse [v -ED, -ING, -S]\n",
  "STRAIGHTAWAY": "immediately [adj] / five cards in sequence irrespective of suit [n -S]\n",
  "STRAIGHTAWAYS": "STRAIGHTAWAY, five cards in sequence irrespective of suit [n]\n",
  "STRAIGHTBRED": "an animal produced by breeding a single breed, strain, or type [n -S]\n",
  "STRAIGHTBREDS": "STRAIGHTBRED, an animal produced by breeding a single breed, strain, or type [n]\n",
  "STRAIGHTED": "STRAIGHT, to lay out a corpse [v]\n",
  "STRAIGHTEDGE": "a bar or piece of material (as of wood, metal, or plastic) with a straight edge for testing straight lines and surfaces or for cutting along or drawing straight lines [n -S]\n",
  "STRAIGHTEDGED": "having a straight edge [adj]\n",
  "STRAIGHTEDGES": "STRAIGHTEDGE, a bar or piece of material (as of wood, metal, or plastic) with a straight edge for testing straight lines and surfaces or for cutting along or drawing straight lines [n]\n",
  "STRAIGHTEN": "to make straight [v -ED, -ING, -S]\n",
  "STRAIGHTENED": "STRAIGHTEN, to make straight [v]\n",
  "STRAIGHTENER": "something that straightens [n -S]\n",
  "STRAIGHTENERS": "STRAIGHTENER, something that straightens [n]\n",
  "STRAIGHTENING": "STRAIGHTEN, to make straight [v]\n",
  "STRAIGHTENS": "STRAIGHTEN, to make straight [v]\n",
  "STRAIGHTER": "STRAIGHT, uncurved, also STRAICHT, STRAUCHT, STRAUGHT [adj]\n",
  "STRAIGHTEST": "STRAIGHT, uncurved, also STRAICHT, STRAUCHT, STRAUGHT [adj]\n",
  "STRAIGHTFORTH": "directly forward; straight away, immediately [adv]\n",
  "STRAIGHTFORWARD": "free from evasiveness or obscurity [adj]\n",
  "STRAIGHTING": "STRAIGHT, to lay out a corpse [v]\n",
  "STRAIGHTISH": "somewhat straight [adj]\n",
  "STRAIGHTJACKET": "a straitjacket [n -S]\n",
  "STRAIGHTJACKETS": "STRAIGHTJACKET, a straitjacket [n]\n",
  "STRAIGHTLACED": "excessively strict in manners, morals, or opinion, also STRAITLACED [adj]\n",
  "STRAIGHTLY": "STRAIGHT, uncurved, also STRAICHT, STRAUCHT, STRAUGHT [adv]\n",
  "STRAIGHTNESS": "the state of being straight [n -ES]\n",
  "STRAIGHTNESSES": "STRAIGHTNESS, the state of being straight [n]\n",
  "STRAIGHTS": "STRAIGHT, to lay out a corpse [v]\n",
  "STRAIGHTWAY": "(archaic) in a direct course, also STRAIGHTWAYS [adv]\n",
  "STRAIGHTWAYS": "(archaic) in a direct course, also STRAIGHTWAY [adv]\n",
  "STRAIK": "to stroke, also STRAKE [v -ED, -ING, -S]\n",
  "STRAIKED": "STRAIK, to stroke, also STRAKE [v]\n",
  "STRAIKING": "STRAIK, to stroke, also STRAKE [v]\n",
  "STRAIKS": "STRAIK, to stroke, also STRAKE [v]\n",
  "STRAIN": "to exert to the utmost [v -ED, -ING, -S]\n",
  "STRAINED": "STRAIN, to exert to the utmost [v]\n",
  "STRAINEDLY": "STRAINED, STRAIN, to exert to the utmost [adv]\n",
  "STRAINER": "a utensil used to separate liquids from solids [n -S]\n",
  "STRAINERS": "STRAINER, a utensil used to separate liquids from solids [n]\n",
  "STRAINING": "the act of straining [n -S]\n",
  "STRAININGS": "STRAINING, the act of straining [n]\n",
  "STRAINS": "STRAIN, to exert to the utmost [v]\n",
  "STRAINT": "(Spenser) pressure [n -S]\n",
  "STRAINTS": "STRAINT, (Spenser) pressure [n]\n",
  "STRAIT": "confined, rigorous [adj STRAITER, STRAITEST, STRAITLY] / to confine [v -ED, -ING, -S]\n",
  "STRAITED": "STRAIT, to confine [v]\n",
  "STRAITEN": "to make strait, narrow [v -ED, -ING, -S]\n",
  "STRAITENED": "STRAITEN, to make strait, narrow [v]\n",
  "STRAITENING": "STRAITEN, to make strait, narrow [v]\n",
  "STRAITENS": "STRAITEN, to make strait, narrow [v]\n",
  "STRAITER": "STRAIT, confined, rigorous [adj]\n",
  "STRAITEST": "STRAIT, confined, rigorous [adj]\n",
  "STRAITING": "STRAIT, to confine [v]\n",
  "STRAITJACKET": "a garment for restraining a person with violent tendencies, also STRAIGHTJACKET [n -S] / to confine in or as if in a straitjacket [v -ED, -ING, -S]\n",
  "STRAITJACKETED": "STRAITJACKET, to confine in or as if in a straitjacket [v]\n",
  "STRAITJACKETING": "STRAITJACKET, to confine in or as if in a straitjacket [v]\n",
  "STRAITJACKETS": "STRAITJACKET, to confine in or as if in a straitjacket [v]\n",
  "STRAITLACED": "excessively strict in manners, morals, or opinion, also STRAIGHTLACED [adj STRAITLACEDLY]\n",
  "STRAITLACEDLY": "STRAITLACED, excessively strict in manners, morals, or opinion, also STRAIGHTLACED [adv]\n",
  "STRAITLACEDNESS": "the state of being straitlaced [n]\n",
  "STRAITLY": "STRAIT, confined, rigorous [adv]\n",
  "STRAITNESS": "the state of being strait [n -ES]\n",
  "STRAITNESSES": "STRAITNESS, the state of being strait [n]\n",
  "STRAITS": "STRAIT, to confine [v]\n",
  "STRAITWAISTCOAT": "a straitjacket [n]\n",
  "STRAK": "STRIKE, to hit [v]\n",
  "STRAKE": "the planking extending along a ship's hull, also STRAIK [n -S]\n",
  "STRAKED": "having a strake, a line of planking or plating in a ship [adj]\n",
  "STRAKES": "STRAKE, the planking extending along a ship's hull, also STRAIK [n]\n",
  "STRAMACON": "(obsolete) a downward cut in fencing, also ESTRAMAZONE, STRAMAZON [n -S]\n",
  "STRAMACONS": "STRAMACON, (obsolete) a downward cut in fencing, also ESTRAMAZONE, STRAMAZON [n]\n",
  "STRAMASH": "(Scots) to make a racket [v -ED, -ING, -ES]\n",
  "STRAMASHED": "STRAMASH, (Scots) to make a racket [v]\n",
  "STRAMASHES": "STRAMASH, (Scots) to make a racket [v]\n",
  "STRAMASHING": "STRAMASH, (Scots) to make a racket [v]\n",
  "STRAMAZON": "(obsolete) a downward cut in fencing, also ESTRAMAZONE, STRAMACON [n -S]\n",
  "STRAMAZONS": "STRAMAZON, (obsolete) a downward cut in fencing, also ESTRAMAZONE, STRAMACON [n]\n",
  "STRAMINEOUS": "strawy; light; worthless; straw-coloured [adj]\n",
  "STRAMMEL": "(obsolete) a straw; hence, hair, also STRUMMEL [n -S]\n",
  "STRAMMELS": "STRAMMEL, (obsolete) a straw; hence, hair, also STRUMMEL [n]\n",
  "STRAMONIES": "STRAMONY, thorn apple, and its leaves used in medicine, also STRAMONIUM [n]\n",
  "STRAMONIUM": "thorn apple, and its leaves used in medicine, also STRAMONY [n -S]\n",
  "STRAMONIUMS": "STRAMONIUM, thorn apple, and its leaves used in medicine, also STRAMONY [n]\n",
  "STRAMONY": "thorn apple, and its leaves used in medicine, also STRAMONIUM [n STRAMONIES]\n",
  "STRAMP": "(Scots) to tread, stamp [v -ED, -ING, -S]\n",
  "STRAMPED": "STRAMP, (Scots) to tread, stamp [v]\n",
  "STRAMPING": "STRAMP, (Scots) to tread, stamp [v]\n",
  "STRAMPS": "STRAMP, (Scots) to tread, stamp [v]\n",
  "STRAND": "to leave in an unfavourable situation [v -ED, -ING, -S]\n",
  "STRANDED": "STRAND, to leave in an unfavourable situation [v]\n",
  "STRANDEDNESS": "the state of being stranded [n -ES]\n",
  "STRANDEDNESSES": "STRANDEDNESS, the state of being stranded [n]\n",
  "STRANDER": "a machine that twists fibres into rope [n -S]\n",
  "STRANDERS": "STRANDER, a machine that twists fibres into rope [n]\n",
  "STRANDFLAT": "in Norway, a gently sloping coastal platform extending seaward [n -S]\n",
  "STRANDFLATS": "STRANDFLAT, in Norway, a gently sloping coastal platform extending seaward [n]\n",
  "STRANDING": "STRAND, to leave in an unfavourable situation [v]\n",
  "STRANDLINE": "the shoreline [n -S]\n",
  "STRANDLINES": "STRANDLINE, the shoreline [n]\n",
  "STRANDS": "STRAND, to leave in an unfavourable situation [v]\n",
  "STRANDWOLF": "the brown hyena that scavenges the shores in Africa [n STRANDWOLVES]\n",
  "STRANDWOLVES": "STRANDWOLF, the brown hyena that scavenges the shores in Africa [n]\n",
  "STRANG": "strong [adj]\n",
  "STRANGE": "unusual or unfamiliar, also STRAUNGE [adj STRANGER, STRANGEST, STRANGELY] / an unfamiliar thing [n -S]\n",
  "STRANGELY": "STRANGE, unusual or unfamiliar, also STRAUNGE [adv]\n",
  "STRANGENESS": "the state of being strange [n -ES]\n",
  "STRANGENESSES": "STRANGENESS, the state of being strange [n]\n",
  "STRANGER": "to make a stranger [v -ED, -ING, -S]\n",
  "STRANGERED": "STRANGER, to make a stranger [v]\n",
  "STRANGERING": "STRANGER, to make a stranger [v]\n",
  "STRANGERS": "STRANGER, to make a stranger [v]\n",
  "STRANGES": "STRANGE, an unfamiliar thing [n]\n",
  "STRANGEST": "STRANGE, unusual or unfamiliar, also STRAUNGE [adj]\n",
  "STRANGLE": "to choke to death [v STRANGLED, STRANGLING, STRANGLES]\n",
  "STRANGLED": "STRANGLE, to choke to death [v]\n",
  "STRANGLEHOLD": "an illegal wrestling hold by which one's opponent is choked [n -S]\n",
  "STRANGLEHOLDS": "STRANGLEHOLD, an illegal wrestling hold by which one's opponent is choked [n]\n",
  "STRANGLEMENT": "the act of strangling [n -S]\n",
  "STRANGLEMENTS": "STRANGLEMENT, the act of strangling [n]\n",
  "STRANGLER": "one who stranglers [n -S]\n",
  "STRANGLERS": "STRANGLER, one who stranglers [n]\n",
  "STRANGLES": "STRANGLE, to choke to death [v]\n",
  "STRANGLING": "STRANGLE, to choke to death [v]\n",
  "STRANGULATE": "to strangle, constrict [v STRANGULATED, STRANGULATING, STRANGULATES]\n",
  "STRANGULATED": "STRANGULATE, to strangle, constrict [v]\n",
  "STRANGULATES": "STRANGULATE, to strangle, constrict [v]\n",
  "STRANGULATING": "STRANGULATE, to strangle, constrict [v]\n",
  "STRANGULATION": "the act of strangling [n -S]\n",
  "STRANGULATIONS": "STRANGULATION, the act of strangling [n]\n",
  "STRANGURIES": "STRANGURY, severe pain in the urethra with intense desire to pass urine or painful passage of a few drops of urine [n]\n",
  "STRANGURY": "severe pain in the urethra with intense desire to pass urine or painful passage of a few drops of urine [n STRANGURIES]\n",
  "STRAP": "to fasten with a narrow strip of flexible material [v STRAPPED, STRAPPING, STRAPS]\n",
  "STRAPHANG": "of a passenger in a train or bus, to hold on to a strap for safety [v STRAPHANGED or STRAPHUNG, STRAPHANGING, STRAPHANGS]\n",
  "STRAPHANGED": "STRAPHANG, of a passenger in a train or bus, to hold on to a strap for safety [v]\n",
  "STRAPHANGER": "a standing passenger in a train, bus, etc. who holds on to a strap for safety [n -S]\n",
  "STRAPHANGERS": "STRAPHANGER, a standing passenger in a train, bus, etc. who holds on to a strap for safety [n]\n",
  "STRAPHANGING": "the act of straphanging [n -S]\n",
  "STRAPHANGINGS": "STRAPHANGING, the act of straphanging [n]\n",
  "STRAPHANGS": "STRAPHANG, of a passenger in a train or bus, to hold on to a strap for safety [v]\n",
  "STRAPHUNG": "STRAPHANG, of a passenger in a train or bus, to hold on to a strap for safety [v]\n",
  "STRAPLESS": "without (shoulder) straps [adj] / a strapless garment [n -ES]\n",
  "STRAPLESSES": "STRAPLESS, a strapless garment [n]\n",
  "STRAPLIKE": "like a strap [adj]\n",
  "STRAPLINE": "a subsidiary headline in a newspaper or magazine [n -S]\n",
  "STRAPLINES": "STRAPLINE, a subsidiary headline in a newspaper or magazine [n]\n",
  "STRAPONTIN": "(French) a folding seat in a theatre [n -S]\n",
  "STRAPONTINS": "STRAPONTIN, (French) a folding seat in a theatre [n]\n",
  "STRAPPADO": "(Italian) a form of torture in which victim is left dangling from a rope [n -S] / to torture by this [v STRAPPADOED, STRAPPADOING, STRAPPADOS or STRAPPADOES]\n",
  "STRAPPADOED": "STRAPPADO, to torture by this [v]\n",
  "STRAPPADOES": "STRAPPADO, to torture by this [v]\n",
  "STRAPPADOING": "STRAPPADO, to torture by this [v]\n",
  "STRAPPADOS": "STRAPPADO, (Italian) a form of torture in which victim is left dangling from a rope [n]\n",
  "STRAPPED": "STRAP, to fasten with a narrow strip of flexible material [v]\n",
  "STRAPPER": "an apprentice, a learner [n -S]\n",
  "STRAPPERS": "STRAPPER, an apprentice, a learner [n]\n",
  "STRAPPIER": "STRAPPY, having straps [adj]\n",
  "STRAPPIEST": "STRAPPY, having straps [adj]\n",
  "STRAPPING": "fastening with a strap [n -S]\n",
  "STRAPPINGS": "STRAPPING, fastening with a strap [n]\n",
  "STRAPPY": "having straps [adj STRAPPIER, STRAPPIEST]\n",
  "STRAPS": "STRAP, to fasten with a narrow strip of flexible material [v]\n",
  "STRAPWORT": "a seaside plant of the pink family [n -S]\n",
  "STRAPWORTS": "STRAPWORT, a seaside plant of the pink family [n]\n",
  "STRASS": "(German) a paste for making false gems [n -ES]\n",
  "STRASSES": "STRASS, (German) a paste for making false gems [n]\n",
  "STRATA": "(Latin) a layer, a stratum [n -S]\n",
  "STRATAGEM": "a plan for deceiving an enemy or gaining an advantage; any artifice generally [n -S]\n",
  "STRATAGEMS": "STRATAGEM, a plan for deceiving an enemy or gaining an advantage; any artifice generally [n]\n",
  "STRATAL": "pertaining to a stratum, also STRATOUS [adj]\n",
  "STRATAS": "STRATA, (Latin) a layer, a stratum [n]\n",
  "STRATEGETIC": "strategical, also STRATEGETICAL [adj]\n",
  "STRATEGETICAL": "strategical, also STRATEGETIC [adj]\n",
  "STRATEGIC": "relating to strategy, also STRATEGICAL [adj STRATEGICALLY]\n",
  "STRATEGICAL": "relating to strategy, also STRATEGIC [adj STRATEGICALLY]\n",
  "STRATEGICALLY": "STRATEGICAL, relating to strategy, also STRATEGIC [adv]\n",
  "STRATEGICS": "strategy [n]\n",
  "STRATEGIES": "STRATEGY, a plan for obtaining a specific goal [n]\n",
  "STRATEGISE": "to devise a strategy or course of action, also STRATEGIZE [v STRATEGISED, STRATEGISING, STRATEGISES]\n",
  "STRATEGISED": "STRATEGISE, to devise a strategy or course of action, also STRATEGIZE [v]\n",
  "STRATEGISES": "STRATEGISE, to devise a strategy or course of action, also STRATEGIZE [v]\n",
  "STRATEGISING": "STRATEGISE, to devise a strategy or course of action, also STRATEGIZE [v]\n",
  "STRATEGIST": "one skilled in strategy [n -S]\n",
  "STRATEGISTS": "STRATEGIST, one skilled in strategy [n]\n",
  "STRATEGIZE": "to devise a strategy or course of action, also STRATEGISE [v STRATEGIZED, STRATEGIZING, STRATEGIZES]\n",
  "STRATEGIZED": "STRATEGIZE, to devise a strategy or course of action, also STRATEGISE [v]\n",
  "STRATEGIZES": "STRATEGIZE, to devise a strategy or course of action, also STRATEGISE [v]\n",
  "STRATEGIZING": "STRATEGIZE, to devise a strategy or course of action, also STRATEGISE [v]\n",
  "STRATEGY": "a plan for obtaining a specific goal [n STRATEGIES]\n",
  "STRATH": "(Scots) a valley of considerable size, through which a river runs [n -S]\n",
  "STRATHS": "STRATH, (Scots) a valley of considerable size, through which a river runs [n]\n",
  "STRATHSPEY": "a reel-like Scottish dance of moderate tempo [n -S]\n",
  "STRATHSPEYS": "STRATHSPEY, a reel-like Scottish dance of moderate tempo [n]\n",
  "STRATI": "STRATUS, (Latin) a low-lying cloud resembling a horizontal fog bank [n]\n",
  "STRATICULATE": "composed of parallel strata [adj]\n",
  "STRATICULATION": "the state of being straticulate [n -S]\n",
  "STRATICULATIONS": "STRATICULATION, the state of being straticulate [n]\n",
  "STRATIFICATION": "(geology) the accumulation of material in layers or beds [n -S]\n",
  "STRATIFICATIONS": "STRATIFICATION, (geology) the accumulation of material in layers or beds [n]\n",
  "STRATIFIED": "STRATIFY, to arrange in layers [v]\n",
  "STRATIFIES": "STRATIFY, to arrange in layers [v]\n",
  "STRATIFORM": "layered; forming a layer [adj]\n",
  "STRATIFY": "to arrange in layers [v STRATIFIED, STRATIFYING, STRATIFIES]\n",
  "STRATIFYING": "STRATIFY, to arrange in layers [v]\n",
  "STRATIGRAPHER": "a practitioner of stratigraphy, also STRATIGRAPHIST [n -S]\n",
  "STRATIGRAPHERS": "STRATIGRAPHER, a practitioner of stratigraphy, also STRATIGRAPHIST [n]\n",
  "STRATIGRAPHIC": "relating to stratigraphy, the study of geological layers or strata, also STRATIGRAPHICAL [adj]\n",
  "STRATIGRAPHICAL": "relating to stratigraphy, the study of geological layers or strata, also STRATIGRAPHIC [adj]\n",
  "STRATIGRAPHIES": "STRATIGRAPHY, the study of geological layers or strata [n]\n",
  "STRATIGRAPHIST": "a practitioner of stratigraphy, also STRATIGRAPHER [n -S]\n",
  "STRATIGRAPHISTS": "STRATIGRAPHIST, a practitioner of stratigraphy, also STRATIGRAPHER [n]\n",
  "STRATIGRAPHY": "the study of geological layers or strata [n STRATIGRAPHIES]\n",
  "STRATOCRACIES": "STRATOCRACY, government by the military [n]\n",
  "STRATOCRACY": "government by the military [n STRATOCRACIES]\n",
  "STRATOCRAT": "a member of a stratocracy, military rule or despotism [n -S]\n",
  "STRATOCRATIC": "relating to a stratocracy, government by the military [adj]\n",
  "STRATOCRATS": "STRATOCRAT, a member of a stratocracy, military rule or despotism [n]\n",
  "STRATOCUMULI": "STRATOCUMULUS, a type of long, wide, low-lying cloud with massive, rounded summits [n]\n",
  "STRATOCUMULUS": "a type of long, wide, low-lying cloud with massive, rounded summits [n STRATOCUMULI]\n",
  "STRATONIC": "of an army or armies [adj]\n",
  "STRATOPAUSE": "the transitional layer between the stratosphere and the mesosphere [n -S]\n",
  "STRATOPAUSES": "STRATOPAUSE, the transitional layer between the stratosphere and the mesosphere [n]\n",
  "STRATOSE": "in strata, layered, also STRATOUS [adj]\n",
  "STRATOSPHERE": "a region of the atmosphere beginning about 4.5 to 10 miles up, in which temperature does not fall as altitude increases [n -S]\n",
  "STRATOSPHERES": "STRATOSPHERE, a region of the atmosphere beginning about 4.5 to 10 miles up, in which temperature does not fall as altitude increases [n]\n",
  "STRATOSPHERIC": "relating to stratosphere, also STRATOSPHERICAL [adj]\n",
  "STRATOSPHERICAL": "relating to the stratosphere, also STRATOSPHERIC [adj]\n",
  "STRATOTANKER": "a type of aeroplane which refuels other planes at high altitudes [n -S]\n",
  "STRATOTANKERS": "STRATOTANKER, a type of aeroplane which refuels other planes at high altitudes [n]\n",
  "STRATOUS": "in strata, layered, also STRATOSE [adj]\n",
  "STRATOVOLCANO": "a composite volcano, composed of alternating layers of lava and pyroclastic material, along with abundant dikes and sills [n -ES or -S]\n",
  "STRATOVOLCANOES": "STRATOVOLCANO, a composite volcano, composed of alternating layers of lava and pyroclastic material, along with abundant dikes and sills [n]\n",
  "STRATOVOLCANOS": "STRATOVOLCANO, a composite volcano, composed of alternating layers of lava and pyroclastic material, along with abundant dikes and sills [n]\n",
  "STRATUM": "(Latin) a layer of material [n STRATUMS or STRATA]\n",
  "STRATUMS": "STRATUM, (Latin) a layer of material [n]\n",
  "STRATUS": "(Latin) a low-lying cloud resembling a horizontal fog bank [n STRATI or STRATUSES]\n",
  "STRATUSES": "STRATUS, (Latin) a low-lying cloud resembling a horizontal fog bank [n]\n",
  "STRAUCHT": "(Scots) straight, also STRAICHT, STRAIGHT, STRAUGHT [adj STRAUCHTER, STRAUCHTEST] / to stretch, lay out (e.g. a corpse) [v -ED, -ING, -S]\n",
  "STRAUCHTED": "STRAUCHT, to stretch, lay out (e.g. a corpse) [v]\n",
  "STRAUCHTER": "STRAUCHT, (Scots) straight, also STRAICHT, STRAIGHT, STRAUGHT [adj]\n",
  "STRAUCHTEST": "STRAUCHT, (Scots) straight, also STRAICHT, STRAIGHT, STRAUGHT [adj]\n",
  "STRAUCHTING": "STRAUCHT, to stretch, lay out (e.g. a corpse) [v]\n",
  "STRAUCHTS": "STRAUCHT, to stretch, lay out (e.g. a corpse) [v]\n",
  "STRAUGHT": "(Scots) straight, also STRAICHT, STRAIGHT, STRAUCHT [adj STRAUGHTER, STRAUGHTEST] / to stretch, lay out (e.g. a corpse) [v -ED, -ING, -S]\n",
  "STRAUGHTED": "STRAUGHT, to stretch, lay out (e.g. a corpse) [v]\n",
  "STRAUGHTER": "STRAUGHT, (Scots) straight, also STRAICHT, STRAIGHT, STRAUCHT [adj]\n",
  "STRAUGHTEST": "STRAUGHT, (Scots) straight, also STRAICHT, STRAIGHT, STRAUCHT [adj]\n",
  "STRAUGHTING": "STRAUGHT, to stretch, lay out (e.g. a corpse) [v]\n",
  "STRAUGHTS": "STRAUGHT, to stretch, lay out (e.g. a corpse) [v]\n",
  "STRAUNGE": "(archaic) strange, in the sense of foreign, borrowed [adj]\n",
  "STRAVAGE": "to stroll, also STRAVAIG [v STRAVAGED, STRAVAGING, STRAVAGES]\n",
  "STRAVAGED": "STRAVAGE, to stroll, also STRAVAIG [v]\n",
  "STRAVAGES": "STRAVAGE, to stroll, also STRAVAIG [v]\n",
  "STRAVAGING": "STRAVAGE, to stroll, also STRAVAIG [v]\n",
  "STRAVAIG": "(Scots) to wander aimlessly, also STRAVAGE, STRAYVE [v -ED, -ING, -S]\n",
  "STRAVAIGED": "STRAVAIG, (Scots) to wander aimlessly, also STRAVAGE, STRAYVE [v]\n",
  "STRAVAIGER": "(Scots) a wanderer, idler [n -S]\n",
  "STRAVAIGERS": "STRAVAIGER, (Scots) a wanderer, idler [n]\n",
  "STRAVAIGING": "STRAVAIG, (Scots) to wander aimlessly, also STRAVAGE, STRAYVE [v]\n",
  "STRAVAIGS": "STRAVAIG, (Scots) to wander aimlessly, also STRAVAGE, STRAYVE [v]\n",
  "STRAW": "to cover with stalks of threshed grain [v STRAWED, STRAWN, STRAWING, STRAWS]\n",
  "STRAWBERRIES": "STRAWBERRY, the fruit of any species of the rosaceous genus Fragaria [n]\n",
  "STRAWBERRY": "the fruit of any species of the rosaceous genus Fragaria [n STRAWBERRIES]\n",
  "STRAWBOARD": "pasteboard made of pulp of straw [n -S]\n",
  "STRAWBOARDS": "STRAWBOARD, pasteboard made of pulp of straw [n]\n",
  "STRAWED": "STRAW, to cover with stalks of threshed grain [v]\n",
  "STRAWEN": "(archaic) made of straw [adj]\n",
  "STRAWFLOWER": "any Australian composite flowering plant of the genus Helichrysum [n -S]\n",
  "STRAWFLOWERS": "STRAWFLOWER, any Australian composite flowering plant of the genus Helichrysum [n]\n",
  "STRAWHAT": "pertaining to a summer theatre in a resort area [adj]\n",
  "STRAWIER": "STRAWY, resembling straw [adj]\n",
  "STRAWIEST": "STRAWY, resembling straw [adj]\n",
  "STRAWING": "STRAW, to cover with stalks of threshed grain [v]\n",
  "STRAWLESS": "without straw [adj]\n",
  "STRAWLIKE": "like straw [adj]\n",
  "STRAWN": "STRAW, to cover with stalks of threshed grain [v]\n",
  "STRAWS": "STRAW, to cover with stalks of threshed grain [v]\n",
  "STRAWWEIGHT": "a professional boxer weighing not more than 47.6 kg [n -S]\n",
  "STRAWWEIGHTS": "STRAWWEIGHT, a professional boxer weighing not more than 47.6 kg [n]\n",
  "STRAWWORM": "a caddice worm [n -S]\n",
  "STRAWWORMS": "STRAWWORM, a caddice worm [n]\n",
  "STRAWY": "resembling straw [adj STRAWIER, STRAWIEST]\n",
  "STRAY": "to wander from the proper course [v -ED, -ING, -S]\n",
  "STRAYED": "STRAY, to wander from the proper course [v]\n",
  "STRAYER": "one who strays [n -S]\n",
  "STRAYERS": "STRAYER, one who strays [n]\n",
  "STRAYING": "the act of straying [n -S]\n",
  "STRAYINGS": "STRAYING, the act of straying [n]\n",
  "STRAYLING": "a stray [n -S]\n",
  "STRAYLINGS": "STRAYLING, a stray [n]\n",
  "STRAYS": "STRAY, to wander from the proper course [v]\n",
  "STRAYVE": "(dialect) to wander aimlessly, also STRAVAGE, STRAVAIG [v STRAYVED, STRAYVING, STRAYVES]\n",
  "STRAYVED": "STRAYVE, (dialect) to wander aimlessly, also STRAVAGE, STRAVAIG [v]\n",
  "STRAYVES": "STRAYVE, (dialect) to wander aimlessly, also STRAVAGE, STRAVAIG [v]\n",
  "STRAYVING": "STRAYVE, (dialect) to wander aimlessly, also STRAVAGE, STRAVAIG [v]\n",
  "STREAK": "to cover with long narrow marks [v -ED, -ING, -S]\n",
  "STREAKED": "STREAK, to cover with long narrow marks [v]\n",
  "STREAKER": "a person who runs naked through a public place [n -S]\n",
  "STREAKERS": "STREAKER, a person who runs naked through a public place [n]\n",
  "STREAKIER": "STREAKY, covered with streaks [adj]\n",
  "STREAKIEST": "STREAKY, covered with streaks [adj]\n",
  "STREAKILY": "STREAKY, covered with streaks [adv]\n",
  "STREAKINESS": "the state of being streaky [n -ES]\n",
  "STREAKINESSES": "STREAKINESS, the state of being streaky [n]\n",
  "STREAKING": "the practice of running naked in public venues [n -S]\n",
  "STREAKINGS": "STREAKING, the practice of running naked in public venues [n]\n",
  "STREAKLIKE": "like a streak [adj]\n",
  "STREAKS": "STREAK, to cover with long narrow marks [v]\n",
  "STREAKY": "covered with streaks [adj STREAKIER, STREAKIEST, STREAKILY]\n",
  "STREAM": "to flow in a steady current [v -ED, -ING, -S]\n",
  "STREAMBED": "the bed of a stream [n -S]\n",
  "STREAMBEDS": "STREAMBED, the bed of a stream [n]\n",
  "STREAMED": "STREAM, to flow in a steady current [v]\n",
  "STREAMER": "a long narrow flag [n -S]\n",
  "STREAMERED": "having streamers [adj]\n",
  "STREAMERS": "STREAMER, a long narrow flag [n]\n",
  "STREAMIER": "STREAMY, streaming [adj]\n",
  "STREAMIEST": "STREAMY, streaming [adj]\n",
  "STREAMINESS": "the state of being streamy [n -ES]\n",
  "STREAMINESSES": "STREAMINESS, the state of being streamy [n]\n",
  "STREAMING": "of a cold, heavy and running [adj STREAMINGLY] / the act of streaming [n -S]\n",
  "STREAMINGLY": "STREAMING, of a cold, heavy and running [adv]\n",
  "STREAMINGS": "STREAMING, the act of streaming [n]\n",
  "STREAMLESS": "destitute of streams, or of a stream, as a region of country, or a dry channel [adj]\n",
  "STREAMLET": "a small stream [n -S]\n",
  "STREAMLETS": "STREAMLET, a small stream [n]\n",
  "STREAMLIKE": "like a stream [adj]\n",
  "STREAMLINE": "to design or construct with a streamline [v STREAMLINED, STREAMLINING, STREAMLINES]\n",
  "STREAMLINED": "STREAMLINE, to design or construct with a streamline [v]\n",
  "STREAMLINER": "one that is streamlined [n -S]\n",
  "STREAMLINERS": "STREAMLINER, one that is streamlined [n]\n",
  "STREAMLINES": "STREAMLINE, to design or construct with a streamline [v]\n",
  "STREAMLING": "a small stream [n -S]\n",
  "STREAMLINGS": "STREAMLING, a small stream [n]\n",
  "STREAMLINING": "the act of designing with a streamline [n -S]\n",
  "STREAMLININGS": "STREAMLINING, the act of designing with a streamline [n]\n",
  "STREAMS": "STREAM, to flow in a steady current [v]\n",
  "STREAMSIDE": "the side of a stream [n -S]\n",
  "STREAMSIDES": "STREAMSIDE, the side of a stream [n]\n",
  "STREAMY": "streaming [adj STREAMIER, STREAMIEST]\n",
  "STREEK": "to stretch; also, to lay out, as a dead body [v -ED, -ING, -S]\n",
  "STREEKED": "STREEK, to stretch; also, to lay out, as a dead body [v]\n",
  "STREEKER": "one that streeks, stretches [n -S]\n",
  "STREEKERS": "STREEKER, one that streeks, stretches [n]\n",
  "STREEKING": "STREEK, to stretch; also, to lay out, as a dead body [v]\n",
  "STREEKS": "STREEK, to stretch; also, to lay out, as a dead body [v]\n",
  "STREEL": "(Irish) to trail, stream [v -ED, -ING, -S]\n",
  "STREELED": "STREEL, (Irish) to trail, stream [v]\n",
  "STREELING": "STREEL, (Irish) to trail, stream [v]\n",
  "STREELS": "STREEL, (Irish) to trail, stream [v]\n",
  "STREET": "a public thoroughfare [n -S] / to provide with a street [v -ED, -ING, -S]\n",
  "STREETAGE": "a toll for street facilities [n -S]\n",
  "STREETAGES": "STREETAGE, a toll for street facilities [n]\n",
  "STREETBOY": "a boy who lives mainly on the streets [n -S]\n",
  "STREETBOYS": "STREETBOY, a boy who lives mainly on the streets [n]\n",
  "STREETCAR": "(US) a tramcar [n -S]\n",
  "STREETCARS": "STREETCAR, (US) a tramcar [n]\n",
  "STREETED": "STREET, to provide with a street [v]\n",
  "STREETFUL": "the contents of a street [n -S]\n",
  "STREETFULS": "STREETFUL, the contents of a street [n]\n",
  "STREETIER": "STREETY, abounding in streets [adj]\n",
  "STREETIEST": "STREETY, abounding in streets [adj]\n",
  "STREETING": "STREET, to provide with a street [v]\n",
  "STREETKEEPER": "an official formerly employed to keep order in a street or streets [n -S]\n",
  "STREETKEEPERS": "STREETKEEPER, an official formerly employed to keep order in a street or streets [n]\n",
  "STREETLAMP": "a lamp for lighting a street, also STREETLIGHT [n -S]\n",
  "STREETLAMPS": "STREETLAMP, a lamp for lighting a street, also STREETLIGHT [n]\n",
  "STREETLIGHT": "a lamp for lighting a street, also STREETLAMP [n -S]\n",
  "STREETLIGHTS": "STREETLIGHT, a lamp for lighting a street, also STREETLAMP [n]\n",
  "STREETROOM": "space enough in the street [n -S]\n",
  "STREETROOMS": "STREETROOM, space enough in the street [n]\n",
  "STREETS": "STREET, to provide with a street [v]\n",
  "STREETSCAPE": "the appearance or view of a street [n -S]\n",
  "STREETSCAPES": "STREETSCAPE, the appearance or view of a street [n]\n",
  "STREETSMART": "adapted to life on the street [adj]\n",
  "STREETWALKER": "a prostitute [n -S]\n",
  "STREETWALKERS": "STREETWALKER, a prostitute [n]\n",
  "STREETWALKING": "prostitution [n -S]\n",
  "STREETWALKINGS": "STREETWALKING, prostitution [n]\n",
  "STREETWARD": "towards or facing the street, also STREETWARDS [adv]\n",
  "STREETWARDS": "towards or facing the street, also STREETWARD [adv]\n",
  "STREETWEAR": "clothes suitable for wear in the street [n -S]\n",
  "STREETWEARS": "STREETWEAR, clothes suitable for wear in the street [n]\n",
  "STREETWISE": "possessing the skills and attitudes necessary to survive in a difficult or dangerous situation or environment [adj]\n",
  "STREETY": "abounding in streets [adj STREETIER, STREETIEST]\n",
  "STREIGHT": "(Spenser) a strait, also STRAIT [n -S]\n",
  "STREIGHTS": "STREIGHT, (Spenser) a strait, also STRAIT [n]\n",
  "STREIGNE": "(obsolete) to strain, also STRENE [v STREIGNED, STREIGNING, STREIGNES]\n",
  "STREIGNED": "STREIGNE, (obsolete) to strain, also STRENE [v]\n",
  "STREIGNES": "STREIGNE, (obsolete) to strain, also STRENE [v]\n",
  "STREIGNING": "STREIGNE, (obsolete) to strain, also STRENE [v]\n",
  "STRELITZ": "(Russian) a soldier of the ancient Muscovite guard or Russian standing army [n STRELITZI or STRELITZES]\n",
  "STRELITZES": "STRELITZ, (Russian) a soldier of the ancient Muscovite guard or Russian standing army [n]\n",
  "STRELITZI": "STRELITZ, (Russian) a soldier of the ancient Muscovite guard or Russian standing army [n]\n",
  "STRELITZIA": "a plant of the South African genus Strelitzia, of the banana family, with large showy flowers [n -S]\n",
  "STRELITZIAS": "STRELITZIA, a plant of the South African genus Strelitzia, of the banana family, with large showy flowers [n]\n",
  "STRENE": "(Spenser) strain, in the sense of race, also STREIGNE [n -S]\n",
  "STRENES": "STRENE, (Spenser) strain, in the sense of race, also STREIGNE [n]\n",
  "STRENGTH": "a degree of being mentally or physically strong [n -S]\n",
  "STRENGTHEN": "to make stronger [v -ED, -ING, -S]\n",
  "STRENGTHENED": "STRENGTHEN, to make stronger [v]\n",
  "STRENGTHENER": "something that strengthens [n -S]\n",
  "STRENGTHENERS": "STRENGTHENER, something that strengthens [n]\n",
  "STRENGTHENING": "the act of making stronger [n -S]\n",
  "STRENGTHENINGS": "STRENGTHENING, the act of making stronger [n]\n",
  "STRENGTHENS": "STRENGTHEN, to make stronger [v]\n",
  "STRENGTHFUL": "full of strength [adj]\n",
  "STRENGTHLESS": "without strength [adj]\n",
  "STRENGTHS": "STRENGTH, a degree of being mentally or physically strong [n]\n",
  "STRENUITIES": "STRENUITY, strenuousness; activity [n]\n",
  "STRENUITY": "strenuousness; activity [n STRENUITIES]\n",
  "STRENUOSITIES": "STRENUOSITY, the state of being strenuous [n]\n",
  "STRENUOSITY": "the state of being strenuous [n STRENUOSITIES]\n",
  "STRENUOUS": "requiring great exertion [adj STRENUOUSLY]\n",
  "STRENUOUSLY": "STRENUOUS, requiring great exertion [adv]\n",
  "STRENUOUSNESS": "the state of being strenuous [n -ES]\n",
  "STRENUOUSNESSES": "STRENUOUSNESS, the state of being strenuous [n]\n",
  "STREP": "any of various spherical bacteria [n -S]\n",
  "STREPENT": "(Latin) noisy [adj]\n",
  "STREPEROUS": "loud; boisterous [adj]\n",
  "STREPHOSYMBOLIA": "a visual disorder where letters are seen mirror imaged [n]\n",
  "STREPITANT": "making a great clamor; noisy; boisterous, also STREPITOUS [adj]\n",
  "STREPITATION": "a clamour [n -S]\n",
  "STREPITATIONS": "STREPITATION, a clamour [n]\n",
  "STREPITOSO": "(Italian) noisy, boisterous [adv]\n",
  "STREPITOUS": "making a great clamor; noisy; boisterous, also STREPITANT [adj]\n",
  "STREPS": "STREP, any of various spherical bacteria [n]\n",
  "STREPSIPTEROUS": "of, relating or belonging to a genus of insects parasitic in other insects [adj]\n",
  "STREPTOBACILLI": "STREPTOBACILLUS, any of a genus of rod-shaped bacteria in which the individual cells are often joined in a chain [n]\n",
  "STREPTOBACILLUS": "any of a genus of rod-shaped bacteria in which the individual cells are often joined in a chain [n STREPTOBACILLI]\n",
  "STREPTOCARPUS": "any flowering plant of the Cape primrose genus Streptocarpus, with foxglove-like flowers [n -ES]\n",
  "STREPTOCARPUSES": "STREPTOCARPUS, any flowering plant of the Cape primrose genus Streptocarpus, with foxglove-like flowers [n]\n",
  "STREPTOCOCCAL": "relating to streptococci, also STREPTOCOCCIC [adj]\n",
  "STREPTOCOCCI": "STREPTOCOCCUS, any of a genus bacteria forming bent chains [n]\n",
  "STREPTOCOCCIC": "relating to streptococci, also STREPTOCOCCAL [adj]\n",
  "STREPTOCOCCUS": "any of a genus bacteria forming bent chains [n STREPTOCOCCI]\n",
  "STREPTOKINASE": "a proteolytic enzyme produced by hemolytic streptococci that promotes the dissolution of blood clots by activating plasminogen to produce plasmin [n -S]\n",
  "STREPTOKINASES": "STREPTOKINASE, a proteolytic enzyme produced by hemolytic streptococci that promotes the dissolution of blood clots by activating plasminogen to produce plasmin [n]\n",
  "STREPTOLYSIN": "an antigenic hemolysin produced by streptococci [n -S]\n",
  "STREPTOLYSINS": "STREPTOLYSIN, an antigenic hemolysin produced by streptococci [n]\n",
  "STREPTOMYCES": "any of a genus of mostly soil streptomycetes, including some that form antibiotics [n]\n",
  "STREPTOMYCETE": "any of a family of actinomycetes [n -S]\n",
  "STREPTOMYCETES": "STREPTOMYCETE, any of a family of actinomycetes [n]\n",
  "STREPTOMYCIN": "an antibiotic produced by the soil bacterium Streptomyces griseus, the first drug to be successful against tuberculosis [n -S]\n",
  "STREPTOMYCINS": "STREPTOMYCIN, an antibiotic produced by the soil bacterium Streptomyces griseus, the first drug to be successful against tuberculosis [n]\n",
  "STREPTOSOLEN": "an evergreen solanaceous flowering shrub of the genus Streptosolen, with panicles of tubular orange flowers [n -S]\n",
  "STREPTOSOLENS": "STREPTOSOLEN, an evergreen solanaceous flowering shrub of the genus Streptosolen, with panicles of tubular orange flowers [n]\n",
  "STREPTOTHRICIN": "any of a group of related basic antibiotics produced by a streptomyces and active esp. against bacteria [n -S]\n",
  "STREPTOTHRICINS": "STREPTOTHRICIN, any of a group of related basic antibiotics produced by a streptomyces and active esp. against bacteria [n]\n",
  "STRESS": "to place emphasis on [v -ED, -ING, -ES]\n",
  "STRESSBUSTER": "any product intended to relieve stress [n -S]\n",
  "STRESSBUSTERS": "STRESSBUSTER, any product intended to relieve stress [n]\n",
  "STRESSBUSTING": "designed to reduce stress [adj]\n",
  "STRESSED": "STRESS, to place emphasis on [v]\n",
  "STRESSES": "STRESS, to place emphasis on [v]\n",
  "STRESSFUL": "causing stress [adj STRESSFULLY]\n",
  "STRESSFULLY": "STRESSFUL, causing stress [adv]\n",
  "STRESSFULNESS": "the state of being stressful [n -ES]\n",
  "STRESSFULNESSES": "STRESSFULNESS, the state of being stressful [n]\n",
  "STRESSIER": "STRESSY, (colloquial) causing or affected by stress [adj]\n",
  "STRESSIEST": "STRESSY, (colloquial) causing or affected by stress [adj]\n",
  "STRESSING": "STRESS, to place emphasis on [v]\n",
  "STRESSLESS": "without stress [adj]\n",
  "STRESSLESSNESS": "the state of being stressless [n]\n",
  "STRESSOR": "an agent or factor that causes stress [n -S]\n",
  "STRESSORS": "STRESSOR, an agent or factor that causes stress [n]\n",
  "STRESSY": "(colloquial) causing or affected by stress [adj STRESSIER, STRESSIEST]\n",
  "STRETCH": "to draw out or open to full length [v -ED, -ING, -ES]\n",
  "STRETCHABILITY": "the state of being stretchable [n]\n",
  "STRETCHABLE": "that can be stretched [adj]\n",
  "STRETCHED": "STRETCH, to draw out or open to full length [v]\n",
  "STRETCHER": "a frame for carrying the sick or wounded [n -S] / to carry by stretcher [v -ED, -ING, -S]\n",
  "STRETCHERED": "STRETCHER, to carry by stretcher [v]\n",
  "STRETCHERING": "STRETCHER, to carry by stretcher [v]\n",
  "STRETCHERS": "STRETCHER, to carry by stretcher [v]\n",
  "STRETCHES": "STRETCH, to draw out or open to full length [v]\n",
  "STRETCHIER": "STRETCHY, tending to stretch [adj]\n",
  "STRETCHIEST": "STRETCHY, tending to stretch [adj]\n",
  "STRETCHINESS": "the state of being stretchy [n -ES]\n",
  "STRETCHINESSES": "STRETCHINESS, the state of being stretchy [n]\n",
  "STRETCHING": "the act of stretching [n -S]\n",
  "STRETCHINGS": "STRETCHING, the act of stretching [n]\n",
  "STRETCHLESS": "without stretch [adj]\n",
  "STRETCHMARKS": "marks left by pregnancy [n]\n",
  "STRETCHY": "tending to stretch [adj STRETCHIER, STRETCHIEST]\n",
  "STRETTA": "(Italian) a concluding musical passage played faster, also STRETTO [n STRETTAS or STRETTE]\n",
  "STRETTAS": "STRETTA, (Italian) a concluding musical passage played faster, also STRETTO [n]\n",
  "STRETTE": "STRETTA, (Italian) a concluding musical passage played faster, also STRETTO [n]\n",
  "STRETTI": "STRETTO, (Italian) a concluding musical passage played faster, also STRETTA [n]\n",
  "STRETTO": "(Italian) a concluding musical passage played faster, also STRETTA [n STRETTOS or STRETTI]\n",
  "STRETTOS": "STRETTO, (Italian) a concluding musical passage played faster, also STRETTA [n]\n",
  "STREUSEL": "(German) a crumb-like cake or pie topping of flour, sugar, butter, and nuts [n -S]\n",
  "STREUSELS": "STREUSEL, (German) a crumb-like cake or pie topping of flour, sugar, butter, and nuts [n]\n",
  "STREW": "to scatter, spread, also STROW [v STREWED, STREWN, STREWING, STREWS]\n",
  "STREWAGE": "items discarded [n -S]\n",
  "STREWAGES": "STREWAGE, items discarded [n]\n",
  "STREWED": "STREW, to scatter, spread, also STROW [v]\n",
  "STREWER": "one who strews, also STROWER [n -S]\n",
  "STREWERS": "STREWER, one who strews, also STROWER [n]\n",
  "STREWING": "the act of strewing [n -S]\n",
  "STREWINGS": "STREWING, the act of strewing [n]\n",
  "STREWMENT": "(Shakespeare) strewings [n -S]\n",
  "STREWMENTS": "STREWMENT, (Shakespeare) strewings [n]\n",
  "STREWN": "STREW, to scatter, spread, also STROW [v]\n",
  "STREWS": "STREW, to scatter, spread, also STROW [v]\n",
  "STREWTH": "a mild oath, God's truth [interj]\n",
  "STRIA": "(Latin) a thin groove, stripe or streak [n STRIAE]\n",
  "STRIAE": "STRIA, (Latin) a thin groove, stripe or streak [n]\n",
  "STRIATA": "STRIATUM, (Latin) part of the forebrain [n]\n",
  "STRIATAL": "relating to the corpus striatum, the great ganglion of the forebrain [adj]\n",
  "STRIATE": "to mark with striae, streaks [v STRIATED, STRIATING, STRIATES]\n",
  "STRIATED": "STRIATE, to mark with striae, streaks [v]\n",
  "STRIATES": "STRIATE, to mark with striae, streaks [v]\n",
  "STRIATING": "STRIATE, to mark with striae, streaks [v]\n",
  "STRIATION": "marking with striae, streaks [n -S]\n",
  "STRIATIONS": "STRIATION, marking with striae, streaks [n]\n",
  "STRIATUM": "(Latin) part of the forebrain [n STRIATUMS or STRIATA]\n",
  "STRIATUMS": "STRIATUM, (Latin) part of the forebrain [n]\n",
  "STRIATURE": "a stria, a streak [n -S]\n",
  "STRIATURES": "STRIATURE, a stria, a streak [n]\n",
  "STRICH": "(archaic) the screech-owl [n -ES]\n",
  "STRICHES": "STRICH, (archaic) the screech-owl [n]\n",
  "STRICK": "a bunch of hackled flax prepared for drawing into slivers [n -S]\n",
  "STRICKEN": "strongly affected or afflicted [adj STRICKENLY]\n",
  "STRICKENLY": "STRICKEN, strongly affected or afflicted [adv]\n",
  "STRICKLE": "to shape grain with an instrument [v STRICKLED, STRICKLING, STRICKLES]\n",
  "STRICKLED": "STRICKLE, to shape grain with an instrument [v]\n",
  "STRICKLES": "STRICKLE, to shape grain with an instrument [v]\n",
  "STRICKLING": "STRICKLE, to shape grain with an instrument [v]\n",
  "STRICKS": "STRICK, a bunch of hackled flax prepared for drawing into slivers [n]\n",
  "STRICT": "kept within narrow and specific limits [adj STRICTER, STRICTEST, STRICTLY]\n",
  "STRICTER": "STRICT, kept within narrow and specific limits [adj]\n",
  "STRICTEST": "STRICT, kept within narrow and specific limits [adj]\n",
  "STRICTION": "the act of restricting [n -S]\n",
  "STRICTIONS": "STRICTION, the act of restricting [n]\n",
  "STRICTISH": "somewhat strict [adj]\n",
  "STRICTLY": "STRICT, kept within narrow and specific limits [adv]\n",
  "STRICTNESS": "the state of being strict [n -ES]\n",
  "STRICTNESSES": "STRICTNESS, the state of being strict [n]\n",
  "STRICTURE": "an adverse criticism or censorious remark [n -S]\n",
  "STRICTURED": "affected with a stricture; as, a strictured duct [adj]\n",
  "STRICTURES": "STRICTURE, an adverse criticism or censorious remark [n]\n",
  "STRIDDEN": "STRIDE, to walk with long steps [v]\n",
  "STRIDDLE": "to stand astride something, also STRADDLE, STRODDLE, STRODLE [v STRIDDLED, STRIDDLING, STRIDDLES]\n",
  "STRIDDLED": "STRIDDLE, to stand astride something, also STRADDLE, STRODDLE, STRODLE [v]\n",
  "STRIDDLES": "STRIDDLE, to stand astride something, also STRADDLE, STRODDLE, STRODLE [v]\n",
  "STRIDDLING": "STRIDDLE, to stand astride something, also STRADDLE, STRODDLE, STRODLE [v]\n",
  "STRIDE": "to walk with long steps [v STRODE, STRIDDEN, STRIDING, STRIDES]\n",
  "STRIDELEGGED": "(Scots) astride, also STRIDELEGS [adv]\n",
  "STRIDELEGS": "(Scots) astride, also STRIDELEGGED [adv]\n",
  "STRIDENCE": "the quality of being strident, also STRIDENCY [n -S]\n",
  "STRIDENCES": "STRIDENCE, the quality of being strident, also STRIDENCY [n]\n",
  "STRIDENCIES": "STRIDENCY, the quality of being strident, also STRIDENCE [n]\n",
  "STRIDENCY": "the quality of being strident, also STRIDENCE [n STRIDENCIES]\n",
  "STRIDENT": "loud, grating [adj STRIDENTLY]\n",
  "STRIDENTLY": "STRIDENT, loud, grating [adv]\n",
  "STRIDER": "one who strides [n -S]\n",
  "STRIDERS": "STRIDER, one who strides [n]\n",
  "STRIDES": "STRIDE, to walk with long steps [v]\n",
  "STRIDEWAYS": "astride [adv]\n",
  "STRIDING": "STRIDE, to walk with long steps [v]\n",
  "STRIDLING": "(dialect) astride [adv]\n",
  "STRIDOR": "(Latin) a harsh shrill sound [n -S]\n",
  "STRIDORS": "STRIDOR, (Latin) a harsh shrill sound [n]\n",
  "STRIDULANCE": "stridulation [n -S]\n",
  "STRIDULANCES": "STRIDULANCE, stridulation [n]\n",
  "STRIDULANT": "stridulating [adj STRIDULANTLY]\n",
  "STRIDULANTLY": "STRIDULANT, stridulating [adv]\n",
  "STRIDULATE": "to make a chirping or scraping sound, like a grasshopper [v STRIDULATED, STRIDULATING, STRIDULATES]\n",
  "STRIDULATED": "STRIDULATE, to make a chirping or scraping sound, like a grasshopper [v]\n",
  "STRIDULATES": "STRIDULATE, to make a chirping or scraping sound, like a grasshopper [v]\n",
  "STRIDULATING": "STRIDULATE, to make a chirping or scraping sound, like a grasshopper [v]\n",
  "STRIDULATION": "the shrill sound produced by crickets and other insects [n -S]\n",
  "STRIDULATIONS": "STRIDULATION, the shrill sound produced by crickets and other insects [n]\n",
  "STRIDULATOR": "an insect that makes a sound by scraping [n -S]\n",
  "STRIDULATORS": "STRIDULATOR, an insect that makes a sound by scraping [n]\n",
  "STRIDULATORY": "of or like stridulation [adj]\n",
  "STRIDULOUS": "squeaky [adj STRIDULOUSLY]\n",
  "STRIDULOUSLY": "STRIDULOUS, squeaky [adv]\n",
  "STRIDULOUSNESS": "the state of being stridulous [n]\n",
  "STRIFE": "contention or conflict [n -S]\n",
  "STRIFEFUL": "contentious; discordant [adj]\n",
  "STRIFELESS": "without strife [adj]\n",
  "STRIFES": "STRIFE, contention or conflict [n]\n",
  "STRIFT": "a struggle [n -S]\n",
  "STRIFTS": "STRIFT, a struggle [n]\n",
  "STRIG": "(dialect) to remove the stalks from [v STRIGGED, STRIGGING, STRIGS]\n",
  "STRIGA": "(Latin) the flute of a column [n STRIGAE]\n",
  "STRIGAE": "STRIGA, (Latin) the flute of a column [n]\n",
  "STRIGATE": "having strigae, bristles, also STRIGOSE [adj]\n",
  "STRIGGED": "STRIG, (dialect) to remove the stalks from [v]\n",
  "STRIGGING": "STRIG, (dialect) to remove the stalks from [v]\n",
  "STRIGIFORM": "shaped like an owl [adj]\n",
  "STRIGIL": "(Latin) an instrument used by ancient Romans/Greeks for scraping the skin esp. after the bath [n -S]\n",
  "STRIGILS": "STRIGIL, (Latin) an instrument used by ancient Romans/Greeks for scraping the skin esp. after the bath [n]\n",
  "STRIGINE": "owllike [adj]\n",
  "STRIGOSE": "having strigae, bristles, also STRIGATE [adj]\n",
  "STRIGS": "STRIG, (dialect) to remove the stalks from [v]\n",
  "STRIKABLE": "capable of being struck [adj]\n",
  "STRIKE": "to hit [v STRUCK or (obsolete) STROOK, STRACK, STRAK, STROOKE or STRAKE, STRICKEN or STROOKEN or STRUCKEN or STROKEN, STRIKING, STRIKES]\n",
  "STRIKEBOUND": "subjected to a strike [adj]\n",
  "STRIKEBREAKER": "a person hired to replace a striking worker [n -S]\n",
  "STRIKEBREAKERS": "STRIKEBREAKER, a person hired to replace a striking worker [n]\n",
  "STRIKEBREAKING": "action designed to break up a strike [n -S]\n",
  "STRIKEBREAKINGS": "STRIKEBREAKING, action designed to break up a strike [n]\n",
  "STRIKELESS": "without a strike [adj]\n",
  "STRIKEOUT": "an out in baseball resulting from a batsman's being charged with three strikes [n -S]\n",
  "STRIKEOUTS": "STRIKEOUT, an out in baseball resulting from a batsman's being charged with three strikes [n]\n",
  "STRIKEOVER": "an act or instance of striking a typewritten character on a spot occupied by another character [n -S]\n",
  "STRIKEOVERS": "STRIKEOVER, an act or instance of striking a typewritten character on a spot occupied by another character [n]\n",
  "STRIKER": "an attacking player, esp. one whose task is to attempt to score goals [n -S]\n",
  "STRIKERS": "STRIKER, an attacking player, esp. one whose task is to attempt to score goals [n]\n",
  "STRIKES": "STRIKE, to hit [v]\n",
  "STRIKING": "impressive [adj STRIKINGLY] / the act of striking [n -S]\n",
  "STRIKINGLY": "STRIKING, impressive [adv]\n",
  "STRIKINGNESS": "the state of being striking [n -ES]\n",
  "STRIKINGNESSES": "STRIKINGNESS, the state of being striking [n]\n",
  "STRIKINGS": "STRIKING, the act of striking [n]\n",
  "STRIM": "to cut grass with a Strimmer [v STRIMMED, STRIMMING, STRIMS]\n",
  "STRIMMED": "STRIM, to cut grass with a Strimmer [v]\n",
  "STRIMMING": "STRIM, to cut grass with a Strimmer [v]\n",
  "STRIMS": "STRIM, to cut grass with a Strimmer [v]\n",
  "STRINE": "(Australian slang) English as spoken in Australia [n -S]\n",
  "STRINES": "STRINE, (Australian slang) English as spoken in Australia [n]\n",
  "STRING": "to provide with catgut, silk, wire or cord [v STRINGED, STRUNG, STRINGING, STRINGS]\n",
  "STRINGBOARD": "a board that covers the ends of the steps in a staircase [n -S]\n",
  "STRINGBOARDS": "STRINGBOARD, a board that covers the ends of the steps in a staircase [n]\n",
  "STRINGCOURSE": "a horizontal band or molding set in the front of a building [n -S]\n",
  "STRINGCOURSES": "STRINGCOURSE, a horizontal band or molding set in the front of a building [n]\n",
  "STRINGED": "STRING, to provide with catgut, silk, wire or cord [v]\n",
  "STRINGENCIES": "STRINGENCY, the state of being stringent [n]\n",
  "STRINGENCY": "the state of being stringent [n STRINGENCIES]\n",
  "STRINGENDO": "(Italian) urging or hastening the time, as to a climax [adv]\n",
  "STRINGENT": "tight, binding, rigorous [adj STRINGENTLY]\n",
  "STRINGENTLY": "STRINGENT, tight, binding, rigorous [adv]\n",
  "STRINGENTNESS": "the state of being stringent [n -ES]\n",
  "STRINGENTNESSES": "STRINGENTNESS, the state of being stringent [n]\n",
  "STRINGER": "a journalist or reporter not on the regular staff of a newspaper or organization, esp. one retained on a part-time basis to report on events in a particular place [n -S]\n",
  "STRINGERS": "STRINGER, a journalist or reporter not on the regular staff of a newspaper or organization, esp. one retained on a part-time basis to report on events in a particular place [n]\n",
  "STRINGHALT": "a jerking lameness in which a horse suddenly twitches up its leg or legs, also SPRINGHALT [n -S]\n",
  "STRINGHALTED": "afflicted with stringhalt, a jerking lameness in which a horse suddenly twitches up its leg or legs [adj]\n",
  "STRINGHALTS": "STRINGHALT, a jerking lameness in which a horse suddenly twitches up its leg or legs, also SPRINGHALT [n]\n",
  "STRINGIER": "STRINGY, fibrous [adj]\n",
  "STRINGIEST": "STRINGY, fibrous [adj]\n",
  "STRINGILY": "STRINGY, fibrous [adv]\n",
  "STRINGINESS": "the state of being stringy [n -ES]\n",
  "STRINGINESSES": "STRINGINESS, the state of being stringy [n]\n",
  "STRINGING": "the act of stringing [n -S]\n",
  "STRINGINGS": "STRINGING, the act of stringing [n]\n",
  "STRINGLESS": "having no strings [adj]\n",
  "STRINGLIKE": "lIke a string [adj]\n",
  "STRINGPIECE": "the heavy squared timber lying along the top of the piles forming a dock front or timber pier [n -S]\n",
  "STRINGPIECES": "STRINGPIECE, the heavy squared timber lying along the top of the piles forming a dock front or timber pier [n]\n",
  "STRINGS": "STRING, to provide with catgut, silk, wire or cord [v]\n",
  "STRINGY": "fibrous [adj STRINGIER, STRINGIEST, STRINGILY]\n",
  "STRINGYBARK": "an Australian tree, a kind of eucalyptus [n -S]\n",
  "STRINGYBARKS": "STRINGYBARK, an Australian tree, a kind of eucalyptus [n]\n",
  "STRINKLE": "(Scots) to sprinkle [v STRINKLED, STRINKLING, STRINKLES]\n",
  "STRINKLED": "STRINKLE, (Scots) to sprinkle [v]\n",
  "STRINKLES": "STRINKLE, (Scots) to sprinkle [v]\n",
  "STRINKLING": "a sprinkling [n -S]\n",
  "STRINKLINGS": "STRINKLING, a sprinkling [n]\n",
  "STRIP": "to remove the outer covering [v STRIPT or STRIPPED, STRIPPING, STRIPS]\n",
  "STRIPAGRAM": "a greetings message delivered by a stripper who does a striptease on delivery, also STRIPOGRAM, STRIPPAGRAM, STRIPPERGRAM [n -S]\n",
  "STRIPAGRAMS": "STRIPAGRAM, a greetings message delivered by a stripper who does a striptease on delivery, also STRIPOGRAM, STRIPPAGRAM, STRIPPERGRAM [n]\n",
  "STRIPE": "to mark with distinct bands [v STRIPED, STRIPING, STRIPES]\n",
  "STRIPED": "STRIPE, to mark with distinct bands [v]\n",
  "STRIPELESS": "without a stripe [adj]\n",
  "STRIPER": "a food and game fish [n -S]\n",
  "STRIPERS": "STRIPER, a food and game fish [n]\n",
  "STRIPES": "STRIPE, to mark with distinct bands [v]\n",
  "STRIPEY": "patterned with stripes, also STRIPY [adj STRIPIER, STRIPIEST]\n",
  "STRIPIER": "STRIPY, marked with stripes, also STRIPEY [adj]\n",
  "STRIPIEST": "STRIPY, marked with stripes, also STRIPEY [adj]\n",
  "STRIPINESS": "the state of being stripy [n -ES]\n",
  "STRIPINESSES": "STRIPINESS, the state of being stripy [n]\n",
  "STRIPING": "stripes marked or painted on something [n -S]\n",
  "STRIPINGS": "STRIPING, stripes marked or painted on something [n]\n",
  "STRIPLING": "a youth in the state of adolescence, or just passing from boyhood to manhood [n -S]\n",
  "STRIPLINGS": "STRIPLING, a youth in the state of adolescence, or just passing from boyhood to manhood [n]\n",
  "STRIPOGRAM": "a message deliver by a messenger who performs a striptease act for the recipient, also STRIPAGRAM, STRIPPAGRAM, STRIPPERGRAM [n -S]\n",
  "STRIPOGRAMS": "STRIPOGRAM, a message deliver by a messenger who performs a striptease act for the recipient, also STRIPAGRAM, STRIPPAGRAM, STRIPPERGRAM [n]\n",
  "STRIPPABLE": "that can be stripped [adj]\n",
  "STRIPPAGRAM": "a greetings message delivered by a stripper who does a striptease on delivery, also STRIPAGRAM, STRIPOGRAM, STRIPPERGRAM [n -S]\n",
  "STRIPPAGRAMS": "STRIPPAGRAM, a greetings message delivered by a stripper who does a striptease on delivery, also STRIPAGRAM, STRIPOGRAM, STRIPPERGRAM [n]\n",
  "STRIPPED": "STRIP, to remove the outer covering [v]\n",
  "STRIPPER": "one who removes his or clothes for a living [n -S]\n",
  "STRIPPERGRAM": "a message delivered by a messenger who performs a striptease act for the recipient, also STRIPAGRAM, STRIPOGRAM, STRIPPAGRAM [n -S]\n",
  "STRIPPERGRAMS": "STRIPPERGRAM, a message delivered by a messenger who performs a striptease act for the recipient, also STRIPAGRAM, STRIPOGRAM, STRIPPAGRAM [n]\n",
  "STRIPPERS": "STRIPPER, one who removes his or clothes for a living [n]\n",
  "STRIPPING": "the act of stripping [n -S]\n",
  "STRIPPINGS": "STRIPPING, the act of stripping [n]\n",
  "STRIPS": "STRIP, to remove the outer covering [v]\n",
  "STRIPT": "STRIP, to remove the outer covering [v]\n",
  "STRIPTEASE": "a burlesque act in which a performer removes clothing piece by piece [n -S]\n",
  "STRIPTEASER": "one who carries out a striptease [n -S]\n",
  "STRIPTEASERS": "STRIPTEASER, one who carries out a striptease [n]\n",
  "STRIPTEASES": "STRIPTEASE, a burlesque act in which a performer removes clothing piece by piece [n]\n",
  "STRIPY": "marked with stripes, also STRIPEY [adj STRIPIER, STRIPIEST]\n",
  "STRIVE": "to try hard [v STROVE or STRIVED, STRIVEN, STRIVING, STRIVES]\n",
  "STRIVED": "STRIVE, to try hard [v]\n",
  "STRIVEN": "STRIVE, to try hard [v]\n",
  "STRIVER": "one who strives [n -S]\n",
  "STRIVERS": "STRIVER, one who strives [n]\n",
  "STRIVES": "STRIVE, to try hard [v]\n",
  "STRIVING": "trying hard [adj STRIVINGLY] / the act of striving [n -S]\n",
  "STRIVINGLY": "STRIVING, trying hard [adv]\n",
  "STRIVINGS": "STRIVING, the act of striving [n]\n",
  "STROAM": "to wander about idly and vacantly [v -ED, -ING, -S]\n",
  "STROAMED": "STROAM, to wander about idly and vacantly [v]\n",
  "STROAMING": "STROAM, to wander about idly and vacantly [v]\n",
  "STROAMS": "STROAM, to wander about idly and vacantly [v]\n",
  "STROBE": "to produce vibrating bright light [v STROBED, STROBING, STROBES]\n",
  "STROBED": "STROBE, to produce vibrating bright light [v]\n",
  "STROBES": "STROBE, to produce vibrating bright light [v]\n",
  "STROBIC": "spinning [adj]\n",
  "STROBIL": "(Greek) a scaly spike of female flowers, as in the hop, also STROBILE, STROBILUS [n -S]\n",
  "STROBILA": "(Greek) a stack of immature larval jellyfish formed on a scyphistoma by budding [n STROBILAE]\n",
  "STROBILACEOUS": "of or like a strobile; bearing strobiles [adj]\n",
  "STROBILAE": "STROBILA, (Greek) a stack of immature larval jellyfish formed on a scyphistoma by budding [n]\n",
  "STROBILAR": "of or like a strobila, a stack of immature larval jellyfish [adj]\n",
  "STROBILATE": "to undergo strobilation [v STROBILATED, STROBILATING, STROBILATES]\n",
  "STROBILATED": "STROBILATE, to undergo strobilation [v]\n",
  "STROBILATES": "STROBILATE, to undergo strobilation [v]\n",
  "STROBILATING": "STROBILATE, to undergo strobilation [v]\n",
  "STROBILATION": "production or reproduction by strobilae, as in jellyfish [n -S]\n",
  "STROBILATIONS": "STROBILATION, production or reproduction by strobilae, as in jellyfish [n]\n",
  "STROBILE": "(Greek) a scaly spike of female flowers, as in the hop, also STROBIL, STROBILUS [n -S]\n",
  "STROBILES": "STROBILE, (Greek) a scaly spike of female flowers, as in the hop, also STROBIL, STROBILUS [n]\n",
  "STROBILI": "STROBILUS, (Greek) a scaly spike of female flowers, as in the hop, also STROBIL, STROBILE [n]\n",
  "STROBILIFORM": "having the form of a strobil [adj]\n",
  "STROBILINE": "of or pertaining to a strobile [adj]\n",
  "STROBILISATION": "production or reproduction by strobilae, also STROBILIZATION [n -S]\n",
  "STROBILISATIONS": "STROBILISATION, production or reproduction by strobilae, also STROBILIZATION [n]\n",
  "STROBILIZATION": "production or reproduction by strobilae, also STROBILISATION [n -S]\n",
  "STROBILIZATIONS": "STROBILIZATION, production or reproduction by strobilae, also STROBILISATION [n]\n",
  "STROBILOID": "like a strobile, a scaly multiple fruit resulting from the ripening of an ament in certain plants [adj]\n",
  "STROBILS": "STROBIL, (Greek) a scaly spike of female flowers, as in the hop, also STROBILE, STROBILUS [n]\n",
  "STROBILUS": "(Greek) a scaly spike of female flowers, as in the hop, also STROBIL, STROBILE [n STROBILI or STROBILUSES]\n",
  "STROBILUSES": "STROBILUS, (Greek) a scaly spike of female flowers, as in the hop, also STROBIL, STROBILE [n]\n",
  "STROBING": "an unwanted jerky effect in a television or cinematic [n -S]\n",
  "STROBINGS": "STROBING, an unwanted jerky effect in a television or cinematic [n]\n",
  "STROBOSCOPE": "an instrument for studying motion using flashes of light [n -S]\n",
  "STROBOSCOPES": "STROBOSCOPE, an instrument for studying motion using flashes of light [n]\n",
  "STROBOSCOPIC": "of or like a stroboscope, an instrument for studying motion using flashes of light, also STROBOSCOPICAL [adj]\n",
  "STROBOSCOPICAL": "of or like a stroboscope, an instrument for studying motion using flashes of light, also STROBOSCOPIC [adj]\n",
  "STROBOTRON": "a gas-filled electron tube used esp. as a source of bright flashes of light for a stroboscope [n -S]\n",
  "STROBOTRONS": "STROBOTRON, a gas-filled electron tube used esp. as a source of bright flashes of light for a stroboscope [n]\n",
  "STRODDLE": "(dialect) to straddle, also STRIDDLE, STRODLE [v STRODDLED, STRODDLING, STRODDLES]\n",
  "STRODDLED": "STRODDLE, (dialect) to straddle, also STRIDDLE, STRODLE [v]\n",
  "STRODDLES": "STRODDLE, (dialect) to straddle, also STRIDDLE, STRODLE [v]\n",
  "STRODDLING": "STRODDLE, (dialect) to straddle, also STRIDDLE, STRODLE [v]\n",
  "STRODE": "STRIDE, to walk with long steps [v]\n",
  "STRODLE": "(dialect) to stand astride something, also STRADDLE, STRIDDLE, STRODDLE [v STRODLED, STRODLING, STRODLES]\n",
  "STRODLED": "STRODLE, (dialect) to stand astride something, also STRADDLE, STRIDDLE, STRODDLE [v]\n",
  "STRODLES": "STRODLE, (dialect) to stand astride something, also STRADDLE, STRIDDLE, STRODDLE [v]\n",
  "STRODLING": "STRODLE, (dialect) to stand astride something, also STRADDLE, STRIDDLE, STRODDLE [v]\n",
  "STROGANOFF": "(Russian) of meat, cut thinly and cooked with onions [n -S]\n",
  "STROGANOFFS": "STROGANOFF, (Russian) of meat, cut thinly and cooked with onions [n]\n",
  "STROKABLE": "that can be stroked [adj]\n",
  "STROKE": "to rub gently [v STROKED, STROKING, STROKES]\n",
  "STROKED": "STROKE, to rub gently [v]\n",
  "STROKEN": "STRIKE, to hit [v]\n",
  "STROKEPLAY": "referring to scoring by counting the total number of strokes played (rather than the number of holes won) [adj]\n",
  "STROKER": "one who strokes [n -S]\n",
  "STROKERS": "STROKER, one who strokes [n]\n",
  "STROKES": "STROKE, to rub gently [v]\n",
  "STROKING": "the act of stroking [n -S]\n",
  "STROKINGS": "STROKING, the act of stroking [n]\n",
  "STROLL": "to walk in a leisurely manner [v -ED, -ING, -S]\n",
  "STROLLED": "STROLL, to walk in a leisurely manner [v]\n",
  "STROLLER": "one who strolls [n -S]\n",
  "STROLLERS": "STROLLER, one who strolls [n]\n",
  "STROLLING": "the act of strolling [n -S]\n",
  "STROLLINGS": "STROLLING, the act of strolling [n]\n",
  "STROLLS": "STROLL, to walk in a leisurely manner [v]\n",
  "STROMA": "(Latin) a supporting framework of connecting tissue [n STROMATA]\n",
  "STROMAL": "of or like a stroma, the connective tissue or supporting framework of an organ [adj]\n",
  "STROMATA": "STROMA, (Latin) a supporting framework of connecting tissue [n]\n",
  "STROMATIC": "of the nature of or resembling a stroma [adj]\n",
  "STROMATOLITE": "a rounded, multilayered structure, found in rocks dating back at least 2800 million years, having present-day equivalents that result from the growth, under special conditions, of blue-green algae [n -S]\n",
  "STROMATOLITES": "STROMATOLITE, a rounded, multilayered structure, found in rocks dating back at least 2800 million years, having present-day equivalents that result from the growth, under special conditions, of blue-green algae [n]\n",
  "STROMATOLITIC": "of or like a stromatolite [adj]\n",
  "STROMATOUS": "of or like a stroma, the connective tissue or supporting framework of an organ [adj]\n",
  "STROMB": "a very large gastropod related to the whelk, also STROMBUS [n -S]\n",
  "STROMBS": "STROMB, a very large gastropod related to the whelk, also STROMBUS [n]\n",
  "STROMBULIFEROUS": "bearing spirally coiled organs [adj]\n",
  "STROMBULIFORM": "shaped like a spinning top; spirally twisted [adj]\n",
  "STROMBUS": "(Greek) a very large gastropod related to the whelk, also STROMB [n -ES]\n",
  "STROMBUSES": "STROMBUS, (Greek) a very large gastropod related to the whelk, also STROMB [n]\n",
  "STROND": "(Spenser) a strand, a beach [n -S]\n",
  "STRONDS": "STROND, (Spenser) a strand, a beach [n]\n",
  "STRONG": "having great strength [adj STRONGER, STRONGEST, STRONGLY]\n",
  "STRONGARM": "to use forceful tactics [v -ED, -ING, -S]\n",
  "STRONGARMED": "STRONGARM, to use forceful tactics [v]\n",
  "STRONGARMING": "STRONGARM, to use forceful tactics [v]\n",
  "STRONGARMS": "STRONGARM, to use forceful tactics [v]\n",
  "STRONGBOX": "a box for holding valuables [n -ES]\n",
  "STRONGBOXES": "STRONGBOX, a box for holding valuables [n]\n",
  "STRONGER": "STRONG, having great strength [adj]\n",
  "STRONGEST": "STRONG, having great strength [adj]\n",
  "STRONGHOLD": "a fortified place [n -S]\n",
  "STRONGHOLDS": "STRONGHOLD, a fortified place [n]\n",
  "STRONGISH": "somewhat strong [adj]\n",
  "STRONGLY": "STRONG, having great strength [adv]\n",
  "STRONGMAN": "a person who performs feats of strength, in a circus etc. [n STRONGMEN]\n",
  "STRONGMEN": "STRONGMAN, a person who performs feats of strength, in a circus etc. [n]\n",
  "STRONGNESS": "the state of being strong [n -ES]\n",
  "STRONGNESSES": "STRONGNESS, the state of being strong [n]\n",
  "STRONGPOINT": "a well-fortified defensive position [n -S]\n",
  "STRONGPOINTS": "STRONGPOINT, a well-fortified defensive position [n]\n",
  "STRONGROOM": "a room for the keeping of valuables etc. [n -S]\n",
  "STRONGROOMS": "STRONGROOM, a room for the keeping of valuables etc. [n]\n",
  "STRONGYL": "(Greek) a parasitic threadworm, also STRONGYLE [n -S]\n",
  "STRONGYLE": "(Greek) a parasitic threadworm, also STRONGYL [n -S]\n",
  "STRONGYLES": "STRONGYLE, (Greek) a parasitic threadworm, also STRONGYL [n]\n",
  "STRONGYLOID": "a strongyl, a parasitic threadworm [n -S]\n",
  "STRONGYLOIDOSES": "STRONGYLOIDOSIS, an intestinal disease caused by infestation with a type of threadworm [n]\n",
  "STRONGYLOIDOSIS": "an intestinal disease caused by infestation with a type of threadworm [n STRONGYLOIDOSES]\n",
  "STRONGYLOIDS": "STRONGYLOID, a strongyl, a parasitic threadworm [n]\n",
  "STRONGYLOSES": "STRONGYLOSIS, infestation with strongyles [n]\n",
  "STRONGYLOSIS": "infestation with strongyles [n STRONGYLOSES]\n",
  "STRONGYLS": "STRONGYL, (Greek) a parasitic threadworm, also STRONGYLE [n]\n",
  "STRONTIA": "an oxide of the metal strontium, also STRONTIAN [n -S]\n",
  "STRONTIAN": "an oxide of the metal strontium, also STRONTIA [n -S]\n",
  "STRONTIANITE": "strontium ore [n -S]\n",
  "STRONTIANITES": "STRONTIANITE, strontium ore [n]\n",
  "STRONTIANS": "STRONTIAN, an oxide of the metal strontium, also STRONTIA [n]\n",
  "STRONTIAS": "STRONTIA, an oxide of the metal strontium, also STRONTIAN [n]\n",
  "STRONTIC": "containing, or designating the compounds of, strontium [adj]\n",
  "STRONTIUM": "a metallic element of the calcium group [n -S]\n",
  "STRONTIUMS": "STRONTIUM, a metallic element of the calcium group [n]\n",
  "STROOK": "STRIKE, to hit [v]\n",
  "STROOKE": "(obsolete) a stroke [n -S]\n",
  "STROOKEN": "STRIKE, to hit [v]\n",
  "STROOKES": "STROOKE, (obsolete) a stroke [n]\n",
  "STROP": "to sharpen on a strip of leather [v STROPPED, STROPPING, STROPS]\n",
  "STROPHANTHIN": "a very poisonous glucoside found in the seeds of the plant Strophanthus [n -S]\n",
  "STROPHANTHINS": "STROPHANTHIN, a very poisonous glucoside found in the seeds of the plant Strophanthus [n]\n",
  "STROPHANTHUS": "a plant of the African and Asiatic genus Strophanthus, of the periwinkle family [n -ES]\n",
  "STROPHANTHUSES": "STROPHANTHUS, a plant of the African and Asiatic genus Strophanthus, of the periwinkle family [n]\n",
  "STROPHE": "(Greek) a group of lines forming a section of a lyric poem [n -S]\n",
  "STROPHES": "STROPHE, (Greek) a group of lines forming a section of a lyric poem [n]\n",
  "STROPHIC": "pertaining to or consisting of strophes, also STROPHICAL [adj]\n",
  "STROPHICAL": "pertaining to or consisting of strophes, also STROPHIC [adj]\n",
  "STROPHIOLATE": "having strophioles, caruncles, also STROPHIOLATED [adj]\n",
  "STROPHIOLATED": "having strophioles, caruncles, also STROPHIOLATE [adj]\n",
  "STROPHIOLE": "a caruncle [n -S]\n",
  "STROPHIOLES": "STROPHIOLE, a caruncle [n]\n",
  "STROPHOID": "a type of curve on a graph [n -S]\n",
  "STROPHOIDS": "STROPHOID, a type of curve on a graph [n]\n",
  "STROPHULI": "STROPHULUS, a skin inflammation found primarily on small children [n]\n",
  "STROPHULUS": "a skin inflammation found primarily on small children [n STROPHULI]\n",
  "STROPPED": "STROP, to sharpen on a strip of leather [v]\n",
  "STROPPER": "one who strops [n -S]\n",
  "STROPPERS": "STROPPER, one who strops [n]\n",
  "STROPPIER": "STROPPY, (colloquial) touchy, belligerent [adj]\n",
  "STROPPIEST": "STROPPY, (colloquial) touchy, belligerent [adj]\n",
  "STROPPILY": "STROPPY, (colloquial) touchy, belligerent [adv]\n",
  "STROPPINESS": "the state of being stroppy [n -ES]\n",
  "STROPPINESSES": "STROPPINESS, the state of being stroppy [n]\n",
  "STROPPING": "STROP, to sharpen on a strip of leather [v]\n",
  "STROPPY": "(colloquial) touchy, belligerent [adj STROPPIER, STROPPIEST, STROPPILY]\n",
  "STROPS": "STROP, to sharpen on a strip of leather [v]\n",
  "STROSSERS": "(Shakespeare) trousers [n]\n",
  "STROUD": "a kind of coarse blanket or garment used by the North American Indians [n -S]\n",
  "STROUDING": "the material used for a stroud, coarse wool [n -S]\n",
  "STROUDINGS": "STROUDING, the material used for a stroud, coarse wool [n]\n",
  "STROUDS": "STROUD, a kind of coarse blanket or garment used by the North American Indians [n]\n",
  "STROUP": "(Scots) a spout, nozzle eg of a kettle, jug etc [n -S]\n",
  "STROUPACH": "(Scots) a drink of tea, also STROUPAN [n -S]\n",
  "STROUPACHS": "STROUPACH, (Scots) a drink of tea, also STROUPAN [n]\n",
  "STROUPAN": "(Scots) a drink of tea, also STROUPACH [n -S]\n",
  "STROUPANS": "STROUPAN, (Scots) a drink of tea, also STROUPACH [n]\n",
  "STROUPS": "STROUP, (Scots) a spout, nozzle eg of a kettle, jug etc [n]\n",
  "STROUT": "to swell; to puff out [v -ED, -ING, -S]\n",
  "STROUTED": "STROUT, to swell; to puff out [v]\n",
  "STROUTING": "STROUT, to swell; to puff out [v]\n",
  "STROUTS": "STROUT, to swell; to puff out [v]\n",
  "STROVE": "STRIVE, to try hard [v]\n",
  "STROW": "to scatter, also STREW [v STROWED, STROWN, STROWING, STROWS]\n",
  "STROWED": "STROW, to scatter, also STREW [v]\n",
  "STROWER": "one who strows, also STREWER [n -S]\n",
  "STROWERS": "STROWER, one who strows, also STREWER [n]\n",
  "STROWING": "the act of strowing [n -S]\n",
  "STROWINGS": "STROWING, the act of strowing [n]\n",
  "STROWN": "STROW, to scatter, also STREW [v]\n",
  "STROWS": "STROW, to scatter, also STREW [v]\n",
  "STROY": "(dialect) to destroy [v -ED, -ING, -S]\n",
  "STROYED": "STROY, (dialect) to destroy [v]\n",
  "STROYER": "one who stroys [n -S]\n",
  "STROYERS": "STROYER, one who stroys [n]\n",
  "STROYING": "STROY, (dialect) to destroy [v]\n",
  "STROYS": "STROY, (dialect) to destroy [v]\n",
  "STRUCK": "STRIKE, to hit [v]\n",
  "STRUCKEN": "STRIKE, to hit [v]\n",
  "STRUCTURAL": "relating to structure [adj STRUCTURALLY]\n",
  "STRUCTURALISE": "to organize or incorporate into a structure, also STRUCTURALIZE [v STRUCTURALISED, STRUCTURALISING, STRUCTURALISES]\n",
  "STRUCTURALISED": "STRUCTURALISE, to organize or incorporate into a structure, also STRUCTURALIZE [v]\n",
  "STRUCTURALISES": "STRUCTURALISE, to organize or incorporate into a structure, also STRUCTURALIZE [v]\n",
  "STRUCTURALISING": "STRUCTURALISE, to organize or incorporate into a structure, also STRUCTURALIZE [v]\n",
  "STRUCTURALISM": "a branch of psychology concerned esp. with the resolution of the mind into structural elements [n -S]\n",
  "STRUCTURALISMS": "STRUCTURALISM, a branch of psychology concerned esp. with the resolution of the mind into structural elements [n]\n",
  "STRUCTURALIST": "an exponent of structuralism [n -S]\n",
  "STRUCTURALISTS": "STRUCTURALIST, an exponent of structuralism [n]\n",
  "STRUCTURALIZE": "to organize or incorporate into a structure, also STRUCTURALISE [v STRUCTURALIZED, STRUCTURALIZING, STRUCTURALIZES]\n",
  "STRUCTURALIZED": "STRUCTURALIZE, to organize or incorporate into a structure, also STRUCTURALISE [v]\n",
  "STRUCTURALIZES": "STRUCTURALIZE, to organize or incorporate into a structure, also STRUCTURALISE [v]\n",
  "STRUCTURALIZING": "STRUCTURALIZE, to organize or incorporate into a structure, also STRUCTURALISE [v]\n",
  "STRUCTURALLY": "STRUCTURAL, relating to structure [adv]\n",
  "STRUCTURATION": "the interrelation of parts in an organized whole [n -S]\n",
  "STRUCTURATIONS": "STRUCTURATION, the interrelation of parts in an organized whole [n]\n",
  "STRUCTURE": "the arrangement of parts [n -S] / to give a framework to [v STRUCTURED, STRUCTURING, STRUCTURES]\n",
  "STRUCTURED": "STRUCTURE, to give a framework to [v]\n",
  "STRUCTURELESS": "without structure [adj]\n",
  "STRUCTURES": "STRUCTURE, to give a framework to [v]\n",
  "STRUCTURING": "STRUCTURE, to give a framework to [v]\n",
  "STRUDEL": "(German) a very thin pastry enclosing fruit, cheese etc. [n -S]\n",
  "STRUDELS": "STRUDEL, (German) a very thin pastry enclosing fruit, cheese etc. [n]\n",
  "STRUGGLE": "to strive vigorously in resistance [v STRUGGLED, STRUGGLING, STRUGGLES]\n",
  "STRUGGLED": "STRUGGLE, to strive vigorously in resistance [v]\n",
  "STRUGGLER": "one who struggles [n -S]\n",
  "STRUGGLERS": "STRUGGLER, one who struggles [n]\n",
  "STRUGGLES": "STRUGGLE, to strive vigorously in resistance [v]\n",
  "STRUGGLING": "making strenuous efforts [adj STRUGGLINGLY] / the act of struggling [n -S]\n",
  "STRUGGLINGLY": "STRUGGLING, making strenuous efforts [adv]\n",
  "STRUGGLINGS": "STRUGGLING, the act of struggling [n]\n",
  "STRUM": "to play a stringed instrument with the fingers [v STRUMMED, STRUMMING, STRUMS]\n",
  "STRUMA": "(Latin) a disease of the lymph glands [n STRUMAS or STRUMAE]\n",
  "STRUMAE": "STRUMA, (Latin) a disease of the lymph glands [n]\n",
  "STRUMAS": "STRUMA, (Latin) a disease of the lymph glands [n]\n",
  "STRUMATIC": "scrofulous; having strumae, also STRUMOSE, STRUMOUS [adj]\n",
  "STRUMITIS": "inflammation of the thyroid gland [n -ES]\n",
  "STRUMITISES": "STRUMITIS, inflammation of the thyroid gland [n]\n",
  "STRUMMED": "STRUM, to play a stringed instrument with the fingers [v]\n",
  "STRUMMEL": "(obsolete) a straw; hence, hair, also STRAMMEL [n -S]\n",
  "STRUMMELS": "STRUMMEL, (obsolete) a straw; hence, hair, also STRAMMEL [n]\n",
  "STRUMMER": "one who strums [n -S]\n",
  "STRUMMERS": "STRUMMER, one who strums [n]\n",
  "STRUMMING": "STRUM, to play a stringed instrument with the fingers [v]\n",
  "STRUMOSE": "scrofulous; having strumae, also STRUMATIC, STRUMOUS [adj]\n",
  "STRUMOUS": "scrofulous; having strumae, also STRUMATIC, STRUMOSE [adj]\n",
  "STRUMPET": "(archaic) a whore [n -S] / to act like a strumpet [v -ED, -ING, -S]\n",
  "STRUMPETED": "STRUMPET, to act like a strumpet [v]\n",
  "STRUMPETING": "STRUMPET, to act like a strumpet [v]\n",
  "STRUMPETS": "STRUMPET, to act like a strumpet [v]\n",
  "STRUMS": "STRUM, to play a stringed instrument with the fingers [v]\n",
  "STRUNG": "STRING, to provide with catgut, silk, wire or cord [v]\n",
  "STRUNT": "to walk with a pompous air, also STRUT [v -ED, -ING, -S]\n",
  "STRUNTED": "STRUNT, to walk with a pompous air, also STRUT [v]\n",
  "STRUNTING": "STRUNT, to walk with a pompous air, also STRUT [v]\n",
  "STRUNTS": "STRUNT, to walk with a pompous air, also STRUT [v]\n",
  "STRUT": "to walk with a pompous air, also STRUNT [v STRUTTED, STRUTTING, STRUTS]\n",
  "STRUTHIOID": "a member of the ostrich family [n -S]\n",
  "STRUTHIOIDS": "STRUTHIOID, a member of the ostrich family [n]\n",
  "STRUTHIOUS": "of or relating to ostriches or related birds [adj]\n",
  "STRUTS": "STRUT, to walk with a pompous air, also STRUNT [v]\n",
  "STRUTTED": "STRUT, to walk with a pompous air, also STRUNT [v]\n",
  "STRUTTER": "one who struts [n -S]\n",
  "STRUTTERS": "STRUTTER, one who struts [n]\n",
  "STRUTTING": "pompous [adj STRUTTINGLY] / the act of strutting [n -S]\n",
  "STRUTTINGLY": "STRUTTING, pompous [adv]\n",
  "STRUTTINGS": "STRUTTING, the act of strutting [n]\n",
  "STRYCHNIA": "(obsolete) strychnine [n -S]\n",
  "STRYCHNIAS": "STRYCHNIA, (obsolete) strychnine [n]\n",
  "STRYCHNIC": "of or pertaining to strychnine [adj]\n",
  "STRYCHNINE": "to poison with strychnine, a very poisonous alkaloid obtained from the seeds of the nux vomica plant [v STRYCHNINED, STRYCHNINING, STRYCHNINES]\n",
  "STRYCHNINED": "STRYCHNINE, to poison with strychnine, a very poisonous alkaloid obtained from the seeds of the nux vomica plant [v]\n",
  "STRYCHNINES": "STRYCHNINE, to poison with strychnine, a very poisonous alkaloid obtained from the seeds of the nux vomica plant [v]\n",
  "STRYCHNINING": "STRYCHNINE, to poison with strychnine, a very poisonous alkaloid obtained from the seeds of the nux vomica plant [v]\n",
  "STRYCHNINISM": "strychnine poisoning, also STRYCHNISM [n -S]\n",
  "STRYCHNINISMS": "STRYCHNINISM, strychnine poisoning, also STRYCHNISM [n]\n",
  "STRYCHNISM": "strychnine poisoning, also STRYCHNINISM [n -S]\n",
  "STRYCHNISMS": "STRYCHNISM, strychnine poisoning, also STRYCHNINISM [n]\n",
  "STUB": "to strike accidentally against a projecting object [v STUBBED, STUBBING, STUBS]\n",
  "STUBBED": "STUB, to strike accidentally against a projecting object [v]\n",
  "STUBBIE": "(Australian slang) a small squat beer bottle, also STUBBY [n -S]\n",
  "STUBBIER": "STUBBY, short and squat [adj]\n",
  "STUBBIES": "STUBBIE, (Australian slang) a small squat beer bottle, also STUBBY [n]\n",
  "STUBBIEST": "STUBBY, short and squat [adj]\n",
  "STUBBILY": "STUBBY, short and squat [adv]\n",
  "STUBBINESS": "the state of being stubby [n -ES]\n",
  "STUBBINESSES": "STUBBINESS, the state of being stubby [n]\n",
  "STUBBING": "STUB, to strike accidentally against a projecting object [v]\n",
  "STUBBLE": "the leavings of a crop of corn after harvest, also STIBBLE [n -S]\n",
  "STUBBLED": "having a stubble [adj]\n",
  "STUBBLES": "STUBBLE, the leavings of a crop of corn after harvest, also STIBBLE [n]\n",
  "STUBBLIER": "STUBBLY, covered with stubble [adj]\n",
  "STUBBLIEST": "STUBBLY, covered with stubble [adj]\n",
  "STUBBLY": "covered with stubble [adj STUBBLIER, STUBBLIEST]\n",
  "STUBBORN": "obstinate [adj STUBBORNER, STUBBORNEST, STUBBORNLY] / to be stubborn, persist [v -ED, -ING, -S]\n",
  "STUBBORNED": "STUBBORN, to be stubborn, persist [v]\n",
  "STUBBORNER": "STUBBORN, obstinate [adj]\n",
  "STUBBORNEST": "STUBBORN, obstinate [adj]\n",
  "STUBBORNING": "STUBBORN, to be stubborn, persist [v]\n",
  "STUBBORNLY": "STUBBORN, obstinate [adv]\n",
  "STUBBORNNESS": "the state of being stubborn [n -ES]\n",
  "STUBBORNNESSES": "STUBBORNNESS, the state of being stubborn [n]\n",
  "STUBBORNS": "STUBBORN, to be stubborn, persist [v]\n",
  "STUBBY": "short and squat [adj STUBBIER, STUBBIEST, STUBBILY] / (Australian slang) a small squat beer bottle, also STUBBIE [n STUBBIES]\n",
  "STUBS": "STUB, to strike accidentally against a projecting object [v]\n",
  "STUCCO": "(Italian) to coat with a type of plaster [v STUCCOED, STUCCOING, STUCCOES or STUCCOS]\n",
  "STUCCOED": "STUCCO, (Italian) to coat with a type of plaster [v]\n",
  "STUCCOER": "one who stuccoes [n -S]\n",
  "STUCCOERS": "STUCCOER, one who stuccoes [n]\n",
  "STUCCOES": "STUCCO, (Italian) to coat with a type of plaster [v]\n",
  "STUCCOING": "STUCCO, (Italian) to coat with a type of plaster [v]\n",
  "STUCCOS": "STUCCO, (Italian) to coat with a type of plaster [v]\n",
  "STUCCOWORK": "work done in stucco [n -S]\n",
  "STUCCOWORKS": "STUCCOWORK, work done in stucco [n]\n",
  "STUCK": "(Shakespeare) a thrust [n -S]\n",
  "STUCKS": "STUCK, (Shakespeare) a thrust [n]\n",
  "STUD": "to adorn with small projections [v STUDDED, STUDDING, STUDS]\n",
  "STUDBOOK": "a record of the pedigree of purebred animals [n -S]\n",
  "STUDBOOKS": "STUDBOOK, a record of the pedigree of purebred animals [n]\n",
  "STUDDED": "STUD, to adorn with small projections [v]\n",
  "STUDDEN": "STAND, to assume an upright position, also STAUN [v]\n",
  "STUDDIE": "(Old Norse) a blacksmith's forge or anvil, also STIDDIE, STITHY [n -S]\n",
  "STUDDIES": "STUDDIE, (Old Norse) a blacksmith's forge or anvil, also STIDDIE, STITHY [n]\n",
  "STUDDING": "the woodwork of a lath and plaster wall or partition [n -S]\n",
  "STUDDINGS": "STUDDING, the woodwork of a lath and plaster wall or partition [n]\n",
  "STUDDINGSAIL": "an additional sail set at the outer edges of a square sail when the wind is light and abaft the beam, also STUNSAIL [n -S]\n",
  "STUDDINGSAILS": "STUDDINGSAIL, an additional sail set at the outer edges of a square sail when the wind is light and abaft the beam, also STUNSAIL [n]\n",
  "STUDDLE": "a post, a prop, also STADDLE [n -S]\n",
  "STUDDLES": "STUDDLE, a post, a prop, also STADDLE [n]\n",
  "STUDE": "STAUN, (Scots) to stand [v]\n",
  "STUDENT": "a person formally engaged in learning [n -S]\n",
  "STUDENTIER": "STUDENTY, like or in the manner of a student [adj]\n",
  "STUDENTIEST": "STUDENTY, like or in the manner of a student [adj]\n",
  "STUDENTRIES": "STUDENTRY, a body of students [n]\n",
  "STUDENTRY": "a body of students [n STUDENTRIES]\n",
  "STUDENTS": "STUDENT, a person formally engaged in learning [n]\n",
  "STUDENTSHIP": "a grant for university study [n -S]\n",
  "STUDENTSHIPS": "STUDENTSHIP, a grant for university study [n]\n",
  "STUDENTY": "like or in the manner of a student [adj STUDENTIER, STUDENTIEST]\n",
  "STUDFARM": "a horse-breeding farm [n -S]\n",
  "STUDFARMS": "STUDFARM, a horse-breeding farm [n]\n",
  "STUDFISH": "any one of several species of small American minnows [n -ES]\n",
  "STUDFISHES": "STUDFISH, any one of several species of small American minnows [n]\n",
  "STUDHORSE": "a stallion kept for breeding [n -S]\n",
  "STUDHORSES": "STUDHORSE, a stallion kept for breeding [n]\n",
  "STUDIED": "STUDY, to apply oneself to learning [v]\n",
  "STUDIEDLY": "STUDIED, STUDY, to apply oneself to learning [adv]\n",
  "STUDIEDNESS": "the state of being studied [n -ES]\n",
  "STUDIEDNESSES": "STUDIEDNESS, the state of being studied [n]\n",
  "STUDIER": "one who studies [n -S]\n",
  "STUDIERS": "STUDIER, one who studies [n]\n",
  "STUDIES": "STUDY, to apply oneself to learning [v]\n",
  "STUDIO": "an artist's workroom [n -S]\n",
  "STUDIOS": "STUDIO, an artist's workroom [n]\n",
  "STUDIOUS": "given to study [adj STUDIOUSLY]\n",
  "STUDIOUSLY": "STUDIOUS, given to study [adv]\n",
  "STUDIOUSNESS": "the state of being studious [n -ES]\n",
  "STUDIOUSNESSES": "STUDIOUSNESS, the state of being studious [n]\n",
  "STUDLIER": "STUDLY, (slang) hunky, muscular and attractive [adj]\n",
  "STUDLIEST": "STUDLY, (slang) hunky, muscular and attractive [adj]\n",
  "STUDLIKE": "like a stud [adj]\n",
  "STUDLY": "(slang) hunky, muscular and attractive [adj STUDLIER, STUDLIEST]\n",
  "STUDS": "STUD, to adorn with small projections [v]\n",
  "STUDWORK": "brickwork walls between studs; studded leather [n -S]\n",
  "STUDWORKS": "STUDWORK, brickwork walls between studs; studded leather [n]\n",
  "STUDY": "to apply oneself to learning [v STUDIED, STUDYING, STUDIES]\n",
  "STUDYING": "STUDY, to apply oneself to learning [v]\n",
  "STUFF": "to fill or pack tightly [v -ED, -ING, -S]\n",
  "STUFFED": "STUFF, to fill or pack tightly [v]\n",
  "STUFFER": "one that stuffs [n -S]\n",
  "STUFFERS": "STUFFER, one that stuffs [n]\n",
  "STUFFIER": "STUFFY, badly ventilated [adj]\n",
  "STUFFIEST": "STUFFY, badly ventilated [adj]\n",
  "STUFFILY": "STUFFY, badly ventilated [adv]\n",
  "STUFFINESS": "the state of being stuffy [n -ES]\n",
  "STUFFINESSES": "STUFFINESS, the state of being stuffy [n]\n",
  "STUFFING": "material with which something is stuffed [n -S]\n",
  "STUFFINGS": "STUFFING, material with which something is stuffed [n]\n",
  "STUFFLESS": "lacking in stuff [adj]\n",
  "STUFFS": "STUFF, to fill or pack tightly [v]\n",
  "STUFFY": "badly ventilated [adj STUFFIER, STUFFIEST, STUFFILY]\n",
  "STUGGIER": "STUGGY, (dialect) thickset, stout [adj]\n",
  "STUGGIEST": "STUGGY, (dialect) thickset, stout [adj]\n",
  "STUGGY": "(dialect) thickset, stout [adj STUGGIER, STUGGIEST]\n",
  "STUIVER": "(Dutch) a Dutch coin worth a penny or two; something of little value, also STIVER [n -S]\n",
  "STUIVERS": "STUIVER, (Dutch) a Dutch coin worth a penny or two; something of little value, also STIVER [n]\n",
  "STUKKEND": "(South African) broken or wrecked [adj]\n",
  "STULL": "a supporting timber in a mine [n -S]\n",
  "STULLS": "STULL, a supporting timber in a mine [n]\n",
  "STULM": "an adit or level in a mine [n -S]\n",
  "STULMS": "STULM, an adit or level in a mine [n]\n",
  "STULTIFICATION": "the act of stultifying [n -S]\n",
  "STULTIFICATIONS": "STULTIFICATION, the act of stultifying [n]\n",
  "STULTIFIED": "STULTIFY, to cause to appear absurd [v]\n",
  "STULTIFIER": "one who stultifies [n -S]\n",
  "STULTIFIERS": "STULTIFIER, one who stultifies [n]\n",
  "STULTIFIES": "STULTIFY, to cause to appear absurd [v]\n",
  "STULTIFY": "to cause to appear absurd [v STULTIFIED, STULTIFYING, STULTIFIES]\n",
  "STULTIFYING": "STULTIFY, to cause to appear absurd [v]\n",
  "STUM": "to increase fermentation by adding grape juice [v STUMMED, STUMMING, STUMS]\n",
  "STUMBLE": "to trip when walking or running [v STUMBLED, STUMBLING, STUMBLES]\n",
  "STUMBLEBUM": "(US) an awkward person [n -S]\n",
  "STUMBLEBUMS": "STUMBLEBUM, (US) an awkward person [n]\n",
  "STUMBLED": "STUMBLE, to trip when walking or running [v]\n",
  "STUMBLER": "one who stumbles [n -S]\n",
  "STUMBLERS": "STUMBLER, one who stumbles [n]\n",
  "STUMBLES": "STUMBLE, to trip when walking or running [v]\n",
  "STUMBLIER": "STUMBLY, apt to stumble [adj]\n",
  "STUMBLIEST": "STUMBLY, apt to stumble [adj]\n",
  "STUMBLING": "STUMBLE, to trip when walking or running [v]\n",
  "STUMBLINGLY": "STUMBLING, STUMBLE, to trip when walking or running [adv]\n",
  "STUMBLY": "apt to stumble [adj STUMBLIER, STUMBLIEST]\n",
  "STUMER": "(slang) a counterfeit coin or note [n -S]\n",
  "STUMERS": "STUMER, (slang) a counterfeit coin or note [n]\n",
  "STUMM": "(Yiddish) silent, dumb, quiet, also SCHTOOM, SCHTUM, SHTOOM, SHTUM, SHTUMM [adj]\n",
  "STUMMED": "STUM, to increase fermentation by adding grape juice [v]\n",
  "STUMMEL": "(German) a bowl and adjacent part of a pipe [n -S]\n",
  "STUMMELS": "STUMMEL, (German) a bowl and adjacent part of a pipe [n]\n",
  "STUMMING": "STUM, to increase fermentation by adding grape juice [v]\n",
  "STUMP": "to baffle [v -ED, -ING, -S]\n",
  "STUMPAGE": "uncut marketable timber [n -S]\n",
  "STUMPAGES": "STUMPAGE, uncut marketable timber [n]\n",
  "STUMPED": "STUMP, to baffle [v]\n",
  "STUMPER": "a baffling question [n -S]\n",
  "STUMPERS": "STUMPER, a baffling question [n]\n",
  "STUMPIER": "STUMPY, short and squat [adj]\n",
  "STUMPIES": "STUMPY, (colloquial) cash [n]\n",
  "STUMPIEST": "STUMPY, short and squat [adj]\n",
  "STUMPILY": "STUMPY, short and squat [adv]\n",
  "STUMPINESS": "the state of being stumpy [n -ES]\n",
  "STUMPINESSES": "STUMPINESS, the state of being stumpy [n]\n",
  "STUMPING": "the act of baffling [n -S]\n",
  "STUMPINGS": "STUMPING, the act of baffling [n]\n",
  "STUMPS": "STUMP, to baffle [v]\n",
  "STUMPWORK": "a type of embroidery featuring raised figures, padded with cotton, wool or hair [n -S]\n",
  "STUMPWORKS": "STUMPWORK, a type of embroidery featuring raised figures, padded with cotton, wool or hair [n]\n",
  "STUMPY": "short and squat [adj STUMPIER, STUMPIEST, STUMPILY] / (colloquial) cash [n STUMPIES]\n",
  "STUMS": "STUM, to increase fermentation by adding grape juice [v]\n",
  "STUN": "to render unconscious [v STUNNED, STUNNING, STUNS]\n",
  "STUNG": "STING, to prick painfully [v]\n",
  "STUNK": "STINK, to emit a foul odour [v]\n",
  "STUNKARD": "(Scots) sulky, sullen [adj]\n",
  "STUNNED": "STUN, to render unconscious [v]\n",
  "STUNNER": "a very attractive person [n -S]\n",
  "STUNNERS": "STUNNER, a very attractive person [n]\n",
  "STUNNING": "stupefying, excellent [adj STUNNINGLY] / the act of stunning [n -S]\n",
  "STUNNINGLY": "STUNNING, stupefying, excellent [adv]\n",
  "STUNNINGS": "STUNNING, the act of stunning [n]\n",
  "STUNS": "STUN, to render unconscious [v]\n",
  "STUNSAIL": "a contraction of studdingsail, an additional sail set at the outer edges of a square sail when the wind is light and abaft the beam [n -S]\n",
  "STUNSAILS": "STUNSAIL, a contraction of studdingsail, an additional sail set at the outer edges of a square sail when the wind is light and abaft the beam [n]\n",
  "STUNT": "to hinder from growth [v -ED, -ING, -S]\n",
  "STUNTED": "STUNT, to hinder from growth [v]\n",
  "STUNTEDNESS": "the state of being stunted [n -ES]\n",
  "STUNTEDNESSES": "STUNTEDNESS, the state of being stunted [n]\n",
  "STUNTING": "STUNT, to hinder from growth [v]\n",
  "STUNTMAN": "a stand-in for dangerous feats [n STUNTMEN]\n",
  "STUNTMEN": "STUNTMAN, a stand-in for dangerous feats [n]\n",
  "STUNTS": "STUNT, to hinder from growth [v]\n",
  "STUNTWOMAN": "a woman who doubles for an actress during the filming of stunts and dangerous scenes [n STUNTWOMEN]\n",
  "STUNTWOMEN": "STUNTWOMAN, a woman who doubles for an actress during the filming of stunts and dangerous scenes [n]\n",
  "STUPA": "(Sanskrit) a mound or monument commemorative of Buddha [n -S]\n",
  "STUPAS": "STUPA, (Sanskrit) a mound or monument commemorative of Buddha [n]\n",
  "STUPE": "to treat with a medicated cloth [v STUPED, STUPING, STUPES]\n",
  "STUPED": "STUPE, to treat with a medicated cloth [v]\n",
  "STUPEFACIENT": "a narcotic, a stupefying drug [n -S]\n",
  "STUPEFACIENTS": "STUPEFACIENT, a narcotic, a stupefying drug [n]\n",
  "STUPEFACTION": "the act of stupefying [n -S]\n",
  "STUPEFACTIONS": "STUPEFACTION, the act of stupefying [n]\n",
  "STUPEFACTIVE": "causing stupefaction [adj]\n",
  "STUPEFIED": "STUPEFY, to dull the senses of [v]\n",
  "STUPEFIER": "something that stupefies [n -S]\n",
  "STUPEFIERS": "STUPEFIER, something that stupefies [n]\n",
  "STUPEFIES": "STUPEFY, to dull the senses of [v]\n",
  "STUPEFY": "to dull the senses of [v STUPEFIED, STUPEFYING, STUPEFIES]\n",
  "STUPEFYING": "STUPEFY, to dull the senses of [v]\n",
  "STUPEFYINGLY": "STUPEFYING, STUPEFY, to dull the senses of [adv]\n",
  "STUPENDIOUS": "(Milton) stupendous [adj]\n",
  "STUPENDOUS": "causing astonishment or wonder, also STUPENDIOUS [adj STUPENDOUSLY]\n",
  "STUPENDOUSLY": "STUPENDOUS, causing astonishment or wonder, also STUPENDIOUS [adv]\n",
  "STUPENDOUSNESS": "the state of being stupendous [n]\n",
  "STUPENT": "astounded [adj]\n",
  "STUPES": "STUPE, to treat with a medicated cloth [v]\n",
  "STUPID": "foolish [adj STUPIDER, STUPIDEST, STUPIDLY] / a stupid person [n -S]\n",
  "STUPIDER": "STUPID, foolish [adj]\n",
  "STUPIDEST": "STUPID, foolish [adj]\n",
  "STUPIDITIES": "STUPIDITY, the quality of being stupid [n]\n",
  "STUPIDITY": "the quality of being stupid [n STUPIDITIES]\n",
  "STUPIDLY": "STUPID, foolish [adv]\n",
  "STUPIDNESS": "the state of being stupid [n -ES]\n",
  "STUPIDNESSES": "STUPIDNESS, the state of being stupid [n]\n",
  "STUPIDS": "STUPID, a stupid person [n]\n",
  "STUPING": "STUPE, to treat with a medicated cloth [v]\n",
  "STUPOR": "(Latin) a state of reduced sensibility [n -S]\n",
  "STUPOROUS": "in a state of stupor, drowsy [adj]\n",
  "STUPORS": "STUPOR, (Latin) a state of reduced sensibility [n]\n",
  "STUPRATE": "(archaic) to ravish; to violate [v STUPRATED, STUPRATING, STUPRATES]\n",
  "STUPRATED": "STUPRATE, (archaic) to ravish; to violate [v]\n",
  "STUPRATES": "STUPRATE, (archaic) to ravish; to violate [v]\n",
  "STUPRATING": "STUPRATE, (archaic) to ravish; to violate [v]\n",
  "STUPRATION": "(archaic) rape, violation [n -S]\n",
  "STUPRATIONS": "STUPRATION, (archaic) rape, violation [n]\n",
  "STURDIED": "afflicted with sturdy [adj]\n",
  "STURDIER": "STURDY, strongly built [adj]\n",
  "STURDIES": "STURDY, a disease of sheep [n]\n",
  "STURDIEST": "STURDY, strongly built [adj]\n",
  "STURDILY": "STURDY, strongly built [adv]\n",
  "STURDINESS": "the state of being sturdy [n -ES]\n",
  "STURDINESSES": "STURDINESS, the state of being sturdy [n]\n",
  "STURDY": "strongly built [adj STURDIER, STURDIEST, STURDILY] / a disease of sheep [n STURDIES]\n",
  "STURE": "great, formidable, also STOOR, STOUR, STOURE, STOWRE [adj]\n",
  "STURGEON": "a large fish of northern temperate waters [n -S]\n",
  "STURGEONS": "STURGEON, a large fish of northern temperate waters [n]\n",
  "STURMER": "a variety of dessert apple [n -S]\n",
  "STURMERS": "STURMER, a variety of dessert apple [n]\n",
  "STURNINE": "pertaining to starlings, also STURNOID [adj]\n",
  "STURNOID": "pertaining to starlings, also STURNINE [adj]\n",
  "STURNUS": "(Latin) any bird of the starling genus [n -ES]\n",
  "STURNUSES": "STURNUS, (Latin) any bird of the starling genus [n]\n",
  "STURT": "to vex; to annoy [v -ED, -ING, -S]\n",
  "STURTED": "STURT, to vex; to annoy [v]\n",
  "STURTING": "STURT, to vex; to annoy [v]\n",
  "STURTS": "STURT, to vex; to annoy [v]\n",
  "STUSHIE": "(Scots) fuss, ado, disturbance, also STASHIE, STISHIE, STOOSHIE, STOUSHIE [n -S]\n",
  "STUSHIES": "STUSHIE, (Scots) fuss, ado, disturbance, also STASHIE, STISHIE, STOOSHIE, STOUSHIE [n]\n",
  "STUTTER": "to speak with spasmodic repetition [v -ED, -ING, -S]\n",
  "STUTTERED": "STUTTER, to speak with spasmodic repetition [v]\n",
  "STUTTERER": "one who stutters [n -S]\n",
  "STUTTERERS": "STUTTERER, one who stutters [n]\n",
  "STUTTERING": "hesitant [adj STUTTERINGLY] / the act of stuttering [n -S]\n",
  "STUTTERINGLY": "STUTTERING, hesitant [adv]\n",
  "STUTTERINGS": "STUTTERING, the act of stuttering [n]\n",
  "STUTTERS": "STUTTER, to speak with spasmodic repetition [v]\n",
  "STY": "to keep in a pigpen [v STIED or STYED, STYED, STYING, STIES]\n",
  "STYE": "an inflamed swelling of the eyelid [n -S]\n",
  "STYED": "STY, to keep in a pigpen [v]\n",
  "STYES": "STYE, an inflamed swelling of the eyelid [n]\n",
  "STYGIAN": "(Greek) of or relating to the river Styx; extremely dark [adj]\n",
  "STYING": "STY, to keep in a pigpen [v]\n",
  "STYLAR": "relating to a style, the narrow stalk of the pistil, located above the ovary but below the stigma [adj]\n",
  "STYLATE": "having a style or persistent style [adj]\n",
  "STYLE": "to name [v STYLED, STYLING, STYLES]\n",
  "STYLEBOOK": "a book of rules for printers and editors [n -S]\n",
  "STYLEBOOKS": "STYLEBOOK, a book of rules for printers and editors [n]\n",
  "STYLED": "STYLE, to name [v]\n",
  "STYLEE": "a facetious or jocular rendering of style [n -S]\n",
  "STYLEES": "STYLEE, a facetious or jocular rendering of style [n]\n",
  "STYLELESS": "without a style [adj]\n",
  "STYLELESSNESS": "the state of being styleless [n -ES]\n",
  "STYLELESSNESSES": "STYLELESSNESS, the state of being styleless [n]\n",
  "STYLER": "one who styles [n -S]\n",
  "STYLERS": "STYLER, one who styles [n]\n",
  "STYLES": "STYLE, to name [v]\n",
  "STYLET": "a small poniard; a stiletto, also STILET [n -S]\n",
  "STYLETS": "STYLET, a small poniard; a stiletto, also STILET [n]\n",
  "STYLI": "STYLUS, (Latin) a pointed instrument for writing, marking or engraving [n]\n",
  "STYLIE": "(New Zealand) fashion conscious [adj STYLIER, STYLIEST]\n",
  "STYLIER": "STYLIE, (New Zealand) fashion conscious [adj]\n",
  "STYLIEST": "STYLIE, (New Zealand) fashion conscious [adj]\n",
  "STYLIFEROUS": "bearing a bristle [adj]\n",
  "STYLIFORM": "shaped like a style or bristle [adj]\n",
  "STYLING": "the way in which something is styled [n -S]\n",
  "STYLINGS": "STYLING, the way in which something is styled [n]\n",
  "STYLISATION": "the act of stylising, also STYLIZATION [n -S]\n",
  "STYLISATIONS": "STYLISATION, the act of stylising, also STYLIZATION [n]\n",
  "STYLISE": "to make conventional, also STYLIZE [v STYLISED, STYLISING, STYLISES]\n",
  "STYLISED": "STYLISE, to make conventional, also STYLIZE [v]\n",
  "STYLISER": "one who stylises, also STYLIZER [n -S]\n",
  "STYLISERS": "STYLISER, one who stylises, also STYLIZER [n]\n",
  "STYLISES": "STYLISE, to make conventional, also STYLIZE [v]\n",
  "STYLISH": "fashionable [adj STYLISHLY]\n",
  "STYLISHLY": "STYLISH, fashionable [adv]\n",
  "STYLISHNESS": "the state of being stylish [n -ES]\n",
  "STYLISHNESSES": "STYLISHNESS, the state of being stylish [n]\n",
  "STYLISING": "STYLISE, to make conventional, also STYLIZE [v]\n",
  "STYLIST": "one who is master of a literary or rhetorical style [n -S]\n",
  "STYLISTIC": "relating to style [adj STYLISTICALLY]\n",
  "STYLISTICALLY": "STYLISTIC, relating to style [adv]\n",
  "STYLISTICS": "the science of variations in language [n]\n",
  "STYLISTS": "STYLIST, one who is master of a literary or rhetorical style [n]\n",
  "STYLITE": "(Greek) one of a class of ascetics who lived on the tops of pillars in ancient times [n -S]\n",
  "STYLITES": "STYLITE, (Greek) one of a class of ascetics who lived on the tops of pillars in ancient times [n]\n",
  "STYLITIC": "of or like a stylite, one of a class of ascetics who lived on the tops of pillars in ancient times [adj]\n",
  "STYLITISM": "the practice of being a stylite [n -S]\n",
  "STYLITISMS": "STYLITISM, the practice of being a stylite [n]\n",
  "STYLIZATION": "the act of stylizing, also STYLISATION [n -S]\n",
  "STYLIZATIONS": "STYLIZATION, the act of stylizing, also STYLISATION [n]\n",
  "STYLIZE": "to make conventional, also STYLISE [v STYLIZED, STYLIZING, STYLIZES]\n",
  "STYLIZED": "STYLIZE, to make conventional, also STYLISE [v]\n",
  "STYLIZER": "one who stylises, also STYLISER [n -S]\n",
  "STYLIZERS": "STYLIZER, one who stylises, also STYLISER [n]\n",
  "STYLIZES": "STYLIZE, to make conventional, also STYLISE [v]\n",
  "STYLIZING": "STYLIZE, to make conventional, also STYLISE [v]\n",
  "STYLO": "(short for) a stylograph, a stylographic pen [n -S]\n",
  "STYLOBATE": "(Greek) a continuous pedestal supporting a row of columns [n -S]\n",
  "STYLOBATES": "STYLOBATE, (Greek) a continuous pedestal supporting a row of columns [n]\n",
  "STYLOGRAPH": "a stylographic pen [n -S]\n",
  "STYLOGRAPHIC": "relating to stylography, a mode of writing or engraving with a pen, also STYLOGRAPHICAL [adj]\n",
  "STYLOGRAPHICAL": "relating to stylography, a mode of writing or engraving with a pen, also STYLOGRAPHIC [adj]\n",
  "STYLOGRAPHIES": "STYLOGRAPHY, a mode of writing or engraving with a pen [n]\n",
  "STYLOGRAPHS": "STYLOGRAPH, a stylographic pen [n]\n",
  "STYLOGRAPHY": "a mode of writing or engraving with a pen [n STYLOGRAPHIES]\n",
  "STYLOID": "a spiny process [n -S]\n",
  "STYLOIDS": "STYLOID, a spiny process [n]\n",
  "STYLOLITE": "an irregular suture-like boundary creating columnar formations in some limestones and evaporites [n -S]\n",
  "STYLOLITES": "STYLOLITE, an irregular suture-like boundary creating columnar formations in some limestones and evaporites [n]\n",
  "STYLOLITIC": "of or like a stylolite, a small columnar rock formation in limestone [adj]\n",
  "STYLOMETRIES": "STYLOMETRY, the study of literature by means of statistical analysis [n]\n",
  "STYLOMETRY": "the study of literature by means of statistical analysis [n STYLOMETRIES]\n",
  "STYLOPES": "STYLOPS, a genus of insects including parasitic wasps, also STYLOPID [n]\n",
  "STYLOPHONE": "a type of battery-powered electronic instrument played with a steel-tipped pen-like stylus [n -S]\n",
  "STYLOPHONES": "STYLOPHONE, a type of battery-powered electronic instrument played with a steel-tipped pen-like stylus [n]\n",
  "STYLOPID": "an insect that is a parasite of other insects, also STYLOPS [n -S]\n",
  "STYLOPIDS": "STYLOPID, an insect that is a parasite of other insects, also STYLOPS [n]\n",
  "STYLOPISE": "to paralyse a host, also STYLOPIZE [v STYLOPISED, STYLOPISING, STYLOPISES]\n",
  "STYLOPISED": "STYLOPISE, to paralyse a host, also STYLOPIZE [v]\n",
  "STYLOPISES": "STYLOPISE, to paralyse a host, also STYLOPIZE [v]\n",
  "STYLOPISING": "STYLOPISE, to paralyse a host, also STYLOPIZE [v]\n",
  "STYLOPIZE": "to paralyse a host, also STYLOPISE [v STYLOPIZED, STYLOPIZING, STYLOPIZES]\n",
  "STYLOPIZED": "STYLOPIZE, to paralyse a host, also STYLOPISE [v]\n",
  "STYLOPIZES": "STYLOPIZE, to paralyse a host, also STYLOPISE [v]\n",
  "STYLOPIZING": "STYLOPIZE, to paralyse a host, also STYLOPISE [v]\n",
  "STYLOPODIA": "STYLOPODIUM, an enlargement at the end of the style base of certain flowers [n]\n",
  "STYLOPODIUM": "an enlargement at the end of the style base of certain flowers [n STYLOPODIA]\n",
  "STYLOPS": "a genus of insects including parasitic wasps, also STYLOPID [n STYLOPES]\n",
  "STYLOS": "STYLO, (short for) a stylograph, a stylographic pen [n]\n",
  "STYLOSTIXES": "STYLOSTIXIS, acupuncture [n]\n",
  "STYLOSTIXIS": "acupuncture [n STYLOSTIXES]\n",
  "STYLUS": "(Latin) a pointed instrument for writing, marking or engraving [n STYLUSES or STYLI]\n",
  "STYLUSES": "STYLUS, (Latin) a pointed instrument for writing, marking or engraving [n]\n",
  "STYME": "(Scots) to peer, also STIME [v STYMED, STYMING, STYMES]\n",
  "STYMED": "STYME, (Scots) to peer, also STIME [v]\n",
  "STYMES": "STYME, (Scots) to peer, also STIME [v]\n",
  "STYMIE": "to thwart, stump, or obstruct, also STIMIE, STIMY, STYMY [v STYMIED, STYMIEING, STYMIES]\n",
  "STYMIED": "STYMIE, to thwart, stump, or obstruct, also STIMIE, STIMY, STYMY [v]\n",
  "STYMIEING": "STYMIE, to thwart, stump, or obstruct, also STIMIE, STIMY, STYMY [v]\n",
  "STYMIES": "STYMIE, to thwart, stump, or obstruct, also STIMIE, STIMY, STYMY [v]\n",
  "STYMING": "STYME, (Scots) to peer, also STIME [v]\n",
  "STYMY": "to thwart, stump, or obstruct, also STIMIE, STIMY, STYMIE [v STYMIED, STYMYING, STYMIES]\n",
  "STYMYING": "STYMY, to thwart, stump, or obstruct, also STIMIE, STIMY, STYMIE [v]\n",
  "STYPSIS": "(Greek) the use, action etc. of a styptic [n -ES]\n",
  "STYPSISES": "STYPSIS, (Greek) the use, action etc. of a styptic [n]\n",
  "STYPTIC": "astringent, also STYPTICAL [adj] / a substance that stops bleeding of minor cuts, also STYPTICAL [n -S]\n",
  "STYPTICAL": "astringent, also STYPTIC [adj]\n",
  "STYPTICITIES": "STYPTICITY, the state of being styptic [n]\n",
  "STYPTICITY": "the state of being styptic [n STYPTICITIES]\n",
  "STYPTICS": "STYPTIC, a substance that stops bleeding of minor cuts, also STYPTICAL [n]\n",
  "STYRACACEOUS": "belonging to the storax family [adj]\n",
  "STYRAX": "(Greek) a fragrant resin, also STORAX [n -ES]\n",
  "STYRAXES": "STYRAX, (Greek) a fragrant resin, also STORAX [n]\n",
  "STYRE": "(Spenser) to stir, also STIRE [v STYRED, STYRING, STYRES]\n",
  "STYRED": "STYRE, (Spenser) to stir, also STIRE [v]\n",
  "STYRENE": "an unsaturated hydrocarbon obtained from essential oils and coal-tar, forming thermoplastics [n -S]\n",
  "STYRENES": "STYRENE, an unsaturated hydrocarbon obtained from essential oils and coal-tar, forming thermoplastics [n]\n",
  "STYRES": "STYRE, (Spenser) to stir, also STIRE [v]\n",
  "STYRING": "STYRE, (Spenser) to stir, also STIRE [v]\n",
  "STYROFOAM": "(tradename) a type of expanded plastic made from polystyrene [n -S]\n",
  "STYROFOAMS": "STYROFOAM, (tradename) a type of expanded plastic made from polystyrene [n]\n",
  "STYTE": "(Scots) to stagger; of a fish, to leap above the surface of the water, also STOIT, STOITER, STOTTER [v STYTED, STYTING, STYTES]\n",
  "STYTED": "STYTE, (Scots) to stagger; of a fish, to leap above the surface of the water, also STOIT, STOITER, STOTTER [v]\n",
  "STYTES": "STYTE, (Scots) to stagger; of a fish, to leap above the surface of the water, also STOIT, STOITER, STOTTER [v]\n",
  "STYTING": "STYTE, (Scots) to stagger; of a fish, to leap above the surface of the water, also STOIT, STOITER, STOTTER [v]\n",
  "SUABILITIES": "SUABILITY, liability to be sued, also SUEABILITY [n]\n",
  "SUABILITY": "liability to be sued, also SUEABILITY [n SUABILITIES]\n",
  "SUABLE": "that may be sued, also SUEABLE [adj SUABLY]\n",
  "SUABLY": "SUABLE, that may be sued, also SUEABLE [adv]\n",
  "SUASIBLE": "capable of being persuaded; easily persuaded [adj]\n",
  "SUASION": "persuasion [n -S]\n",
  "SUASIONS": "SUASION, persuasion [n]\n",
  "SUASIVE": "persuasive [adj SUASIVELY]\n",
  "SUASIVELY": "SUASIVE, persuasive [adv]\n",
  "SUASIVENESS": "the state of being suasive [n -ES]\n",
  "SUASIVENESSES": "SUASIVENESS, the state of being suasive [n]\n",
  "SUASORY": "tending to persuade; suasive [adj]\n",
  "SUAVE": "(French) sophisticated and smoothly affable [adj SUAVER, SUAVEST, SUAVELY]\n",
  "SUAVELY": "SUAVE, (French) sophisticated and smoothly affable [adv]\n",
  "SUAVENESS": "the state of being suave, also SUAVITY [n -ES]\n",
  "SUAVENESSES": "SUAVENESS, the state of being suave, also SUAVITY [n]\n",
  "SUAVEOLENT": "fragrant [adj]\n",
  "SUAVER": "SUAVE, (French) sophisticated and smoothly affable [adj]\n",
  "SUAVEST": "SUAVE, (French) sophisticated and smoothly affable [adj]\n",
  "SUAVITIES": "SUAVITY, the state of being suave, also SUAVENESS [n]\n",
  "SUAVITY": "the state of being suave, also SUAVENESS [n SUAVITIES]\n",
  "SUB": "to act as a substitute [v SUBBED, SUBBING, SUBS]\n",
  "SUBA": "(Hindi) a province of the Mogul empire, also SUBAH [n -S]\n",
  "SUBABBOT": "a subordinate abbot [n -S]\n",
  "SUBABBOTS": "SUBABBOT, a subordinate abbot [n]\n",
  "SUBABDOMINAL": "relating to the lower abdomen [adj]\n",
  "SUBACETATE": "an acetate in smaller proportion [n -S]\n",
  "SUBACETATES": "SUBACETATE, an acetate in smaller proportion [n]\n",
  "SUBACID": "slightly sour [adj SUBACIDLY]\n",
  "SUBACIDITIES": "SUBACIDITY, the state of being subacid [n]\n",
  "SUBACIDITY": "the state of being subacid [n SUBACIDITIES]\n",
  "SUBACIDLY": "SUBACID, slightly sour [adv]\n",
  "SUBACIDNESS": "the state of being subacid [n -ES]\n",
  "SUBACIDNESSES": "SUBACIDNESS, the state of being subacid [n]\n",
  "SUBACRID": "somewhat acrid [adj]\n",
  "SUBACT": "to subdue [v -ED, -ING, -S]\n",
  "SUBACTED": "SUBACT, to subdue [v]\n",
  "SUBACTING": "SUBACT, to subdue [v]\n",
  "SUBACTION": "the act of reducing to any state, as of mixing two bodies completely [n -S]\n",
  "SUBACTIONS": "SUBACTION, the act of reducing to any state, as of mixing two bodies completely [n]\n",
  "SUBACTS": "SUBACT, to subdue [v]\n",
  "SUBACUTE": "somewhat acute [adj SUBACUTELY]\n",
  "SUBACUTELY": "SUBACUTE, somewhat acute [adv]\n",
  "SUBADAR": "(Hindi) a native officer in an Indian regiment corresponding to a captain, also SUBAHDAR, SUBEDAR [n -S]\n",
  "SUBADARS": "SUBADAR, (Hindi) a native officer in an Indian regiment corresponding to a captain, also SUBAHDAR, SUBEDAR [n]\n",
  "SUBADOLESCENT": "a child who has not yet reached the age of adolescence [n -S]\n",
  "SUBADOLESCENTS": "SUBADOLESCENT, a child who has not yet reached the age of adolescence [n]\n",
  "SUBADULT": "an individual approaching adulthood [n -S]\n",
  "SUBADULTS": "SUBADULT, an individual approaching adulthood [n]\n",
  "SUBAERIAL": "in open air [adj SUBAERIALLY]\n",
  "SUBAERIALLY": "SUBAERIAL, in open air [adv]\n",
  "SUBAFFLUENT": "less than affluent [adj]\n",
  "SUBAGENCIES": "SUBAGENCY, a subordinate agency [n]\n",
  "SUBAGENCY": "a subordinate agency [n SUBAGENCIES]\n",
  "SUBAGENT": "a subordinate agent [n -S]\n",
  "SUBAGENTS": "SUBAGENT, a subordinate agent [n]\n",
  "SUBAGGREGATE": "part of an aggregate [n -S]\n",
  "SUBAGGREGATES": "SUBAGGREGATE, part of an aggregate [n]\n",
  "SUBAGGREGATION": "a partial aggregation [n -S]\n",
  "SUBAGGREGATIONS": "SUBAGGREGATION, a partial aggregation [n]\n",
  "SUBAH": "(Hindi) a province of the Mogul empire, also SUBA [n -S]\n",
  "SUBAHDAR": "(Hindi) a native officer in an Indian regiment corresponding to a captain, also SUBADAR, SUBEDAR [n -S]\n",
  "SUBAHDARIES": "SUBAHDARY, the office of a subahdar [n]\n",
  "SUBAHDARS": "SUBAHDAR, (Hindi) a native officer in an Indian regiment corresponding to a captain, also SUBADAR, SUBEDAR [n]\n",
  "SUBAHDARY": "the office of a subahdar [n SUBAHDARIES]\n",
  "SUBAHS": "SUBAH, (Hindi) a province of the Mogul empire, also SUBA [n]\n",
  "SUBAHSHIP": "the office of a subahdar [n -S]\n",
  "SUBAHSHIPS": "SUBAHSHIP, the office of a subahdar [n]\n",
  "SUBALAR": "under the wing [adj]\n",
  "SUBALLIANCE": "a subordinate alliance [n -S]\n",
  "SUBALLIANCES": "SUBALLIANCE, a subordinate alliance [n]\n",
  "SUBALLOCATION": "a subdivision of an allocation [n -S]\n",
  "SUBALLOCATIONS": "SUBALLOCATION, a subdivision of an allocation [n]\n",
  "SUBALPINE": "inhabiting the somewhat high slopes and summits of mountains, but considerably below the snow line [adj]\n",
  "SUBALTERN": "a person holding a subordinate position; specifically, a junior officer (as in the British army) [n -S]\n",
  "SUBALTERNANT": "in logic, a universal in relation to the subaltern particular [n -S]\n",
  "SUBALTERNANTS": "SUBALTERNANT, in logic, a universal in relation to the subaltern particular [n]\n",
  "SUBALTERNATE": "a particular proposition in relation to the subaltern particular [n -S]\n",
  "SUBALTERNATES": "SUBALTERNATE, a particular proposition in relation to the subaltern particular [n]\n",
  "SUBALTERNATION": "the relation between a universal and particular of the same quality [n -S]\n",
  "SUBALTERNATIONS": "SUBALTERNATION, the relation between a universal and particular of the same quality [n]\n",
  "SUBALTERNITIES": "SUBALTERNITY, subordinate position [n]\n",
  "SUBALTERNITY": "subordinate position [n SUBALTERNITIES]\n",
  "SUBALTERNS": "SUBALTERN, a person holding a subordinate position; specifically, a junior officer (as in the British army) [n]\n",
  "SUBANGULAR": "slightly angular [adj]\n",
  "SUBANTARCTIC": "of, relating to, characteristic of, or being a region just outside the antarctic circle [adj]\n",
  "SUBAPICAL": "of or pertaining to the part just below the apex [adj]\n",
  "SUBAPOSTOLIC": "of the time just after that of the apostles [adj]\n",
  "SUBAPPEARANCE": "a subsidiary or supporting appearance [n -S]\n",
  "SUBAPPEARANCES": "SUBAPPEARANCE, a subsidiary or supporting appearance [n]\n",
  "SUBAQUA": "relating to underwater sport [adj]\n",
  "SUBAQUATIC": "under water [adj]\n",
  "SUBAQUEOUS": "under water [adj]\n",
  "SUBARACHNOID": "the space situated under the arachnoid membrane [n -S]\n",
  "SUBARACHNOIDAL": "situated under the arachnoid membrane, also SUBARACHNOID [adj]\n",
  "SUBARACHNOIDS": "SUBARACHNOID, the space situated under the arachnoid membrane [n]\n",
  "SUBARBOREAL": "growing or living under trees [adj]\n",
  "SUBARBORESCENT": "partially arborescent [adj]\n",
  "SUBARCTIC": "the zone just below the arctic circle [n -S]\n",
  "SUBARCTICS": "SUBARCTIC, the zone just below the arctic circle [n]\n",
  "SUBARCUATE": "somewhat arched; with two or more arches under a main arch [adj]\n",
  "SUBARCUATION": "the state of being subarcuate, somewhat arched [n -S]\n",
  "SUBARCUATIONS": "SUBARCUATION, the state of being subarcuate, somewhat arched [n]\n",
  "SUBAREA": "a subdivision of an area [n -S]\n",
  "SUBAREAS": "SUBAREA, a subdivision of an area [n]\n",
  "SUBARID": "somewhat arid [adj]\n",
  "SUBARRATION": "an ancient form of betrothal in which pledges of money, rings, etc. were given by the man to the woman, also SUBARRHATION [n -S]\n",
  "SUBARRATIONS": "SUBARRATION, an ancient form of betrothal in which pledges of money, rings, etc. were given by the man to the woman, also SUBARRHATION [n]\n",
  "SUBARRHATION": "an ancient form of betrothal in which pledges of money, rings, etc. were given by the man to the woman, also SUBARRATION [n -S]\n",
  "SUBARRHATIONS": "SUBARRHATION, an ancient form of betrothal in which pledges of money, rings, etc. were given by the man to the woman, also SUBARRATION [n]\n",
  "SUBARTICLE": "a subordinate article [n -S]\n",
  "SUBARTICLES": "SUBARTICLE, a subordinate article [n]\n",
  "SUBAS": "SUBA, (Hindi) a province of the Mogul empire, also SUBAH [n]\n",
  "SUBASSEMBLE": "to assemble a part of [v SUBASSEMBLED, SUBASSEMBLING, SUBASSEMBLES]\n",
  "SUBASSEMBLED": "SUBASSEMBLE, to assemble a part of [v]\n",
  "SUBASSEMBLES": "SUBASSEMBLE, to assemble a part of [v]\n",
  "SUBASSEMBLIES": "SUBASSEMBLY, a subordinate part of an assembly [n]\n",
  "SUBASSEMBLING": "SUBASSEMBLE, to assemble a part of [v]\n",
  "SUBASSEMBLY": "a subordinate part of an assembly [n SUBASSEMBLIES]\n",
  "SUBASSOCIATION": "a subordinate association [n -S]\n",
  "SUBASSOCIATIONS": "SUBASSOCIATION, a subordinate association [n]\n",
  "SUBASTRAL": "beneath the stars or heavens; terrestrial [adj]\n",
  "SUBATMOSPHERIC": "less or lower than that of the atmosphere [adj]\n",
  "SUBATOM": "a component of an atom [n -S]\n",
  "SUBATOMIC": "relating to particles constituting the atom or processes that occur within the atom or at less than atomic level [adj]\n",
  "SUBATOMICS": "the study of subatomic particles [n]\n",
  "SUBATOMS": "SUBATOM, a component of an atom [n]\n",
  "SUBAUDIBLE": "hardly audible [adj]\n",
  "SUBAUDIO": "relating to low-frequency audio [adj]\n",
  "SUBAUDITION": "understanding of something not expressed [n -S]\n",
  "SUBAUDITIONS": "SUBAUDITION, understanding of something not expressed [n]\n",
  "SUBAURAL": "below the normal range of hearing [adj]\n",
  "SUBAURICULAR": "below the ear [adj]\n",
  "SUBAVERAGE": "below average [adj]\n",
  "SUBAXIAL": "somewhat axial [adj]\n",
  "SUBAXILLARY": "situated below the armpit [adj]\n",
  "SUBBASAL": "below the base [adj]\n",
  "SUBBASE": "the lowest part of a base [n -S]\n",
  "SUBBASEMENT": "a basement below a basement [n -S]\n",
  "SUBBASEMENTS": "SUBBASEMENT, a basement below a basement [n]\n",
  "SUBBASES": "SUBBASE, the lowest part of a base [n]\n",
  "SUBBASIN": "a section of an area drained by a river [n -S]\n",
  "SUBBASINS": "SUBBASIN, a section of an area drained by a river [n]\n",
  "SUBBASS": "a pedal stop producing the lowest tones of an organ [n -ES]\n",
  "SUBBASSES": "SUBBASS, a pedal stop producing the lowest tones of an organ [n]\n",
  "SUBBED": "SUB, to act as a substitute [v]\n",
  "SUBBIE": "(Australian slang) a subcontractor, esp. in the construction industry, also SUBBY [n -S]\n",
  "SUBBIES": "SUBBY, (Australian slang) a subcontractor, esp. in the construction industry, also SUBBIE [n]\n",
  "SUBBING": "the act of subediting [n -S]\n",
  "SUBBINGS": "SUBBING, the act of subediting [n]\n",
  "SUBBITUMINOUS": "of, relating to, or being coal of lower rank than bituminous coal but higher than lignite [adj]\n",
  "SUBBLOCK": "a subdivision of a block [n -S]\n",
  "SUBBLOCKS": "SUBBLOCK, a subdivision of a block [n]\n",
  "SUBBRANCH": "a subdivision of a branch [n -ES]\n",
  "SUBBRANCHES": "SUBBRANCH, a subdivision of a branch [n]\n",
  "SUBBREED": "a distinguishable strain within a breed [n -S]\n",
  "SUBBREEDS": "SUBBREED, a distinguishable strain within a breed [n]\n",
  "SUBBUREAU": "a subdivision of a bureau [n SUBBUREAUS or SUBBUREAUX]\n",
  "SUBBUREAUS": "SUBBUREAU, a subdivision of a bureau [n]\n",
  "SUBBUREAUX": "SUBBUREAU, a subdivision of a bureau [n]\n",
  "SUBBY": "(Australian slang) a subcontractor, esp. in the construction industry, also SUBBIE [n SUBBIES]\n",
  "SUBCABINET": "a subdivision of a cabinet [n -S]\n",
  "SUBCABINETS": "SUBCABINET, a subdivision of a cabinet [n]\n",
  "SUBCALIBER": "of ammunition, having a calibre less than the firearm or barrel used to fire it, also SUBCALIBRE [adj]\n",
  "SUBCALIBRE": "of ammunition, having a calibre less than the firearm or barrel used to fire it, also SUBCALIBER [adj]\n",
  "SUBCANTOR": "a subordinate cantor, a singer; esp. the leader of a church choir [n -S]\n",
  "SUBCANTORS": "SUBCANTOR, a subordinate cantor, a singer; esp. the leader of a church choir [n]\n",
  "SUBCAPSULAR": "situated or occurring beneath or within a capsule [adj]\n",
  "SUBCARDINAL": "a subordinate cardinal [n -S]\n",
  "SUBCARDINALS": "SUBCARDINAL, a subordinate cardinal [n]\n",
  "SUBCARRIER": "a modulated frequency used to modulate, with others, a main carrier wave [n -S]\n",
  "SUBCARRIERS": "SUBCARRIER, a modulated frequency used to modulate, with others, a main carrier wave [n]\n",
  "SUBCASTE": "a subdivision of a caste [n -S]\n",
  "SUBCASTES": "SUBCASTE, a subdivision of a caste [n]\n",
  "SUBCATEGORIES": "SUBCATEGORY, a subdivision of a category [n]\n",
  "SUBCATEGORISE": "to classify into subcategories, also SUBCATEGORIZE [v SUBCATEGORISED, SUBCATEGORISING, SUBCATEGORISES]\n",
  "SUBCATEGORISED": "SUBCATEGORISE, to classify into subcategories, also SUBCATEGORIZE [v]\n",
  "SUBCATEGORISES": "SUBCATEGORISE, to classify into subcategories, also SUBCATEGORIZE [v]\n",
  "SUBCATEGORISING": "SUBCATEGORISE, to classify into subcategories, also SUBCATEGORIZE [v]\n",
  "SUBCATEGORIZE": "to classify into subcategories, also SUBCATEGORISE [v SUBCATEGORIZED, SUBCATEGORIZING, SUBCATEGORIZES]\n",
  "SUBCATEGORIZED": "SUBCATEGORIZE, to classify into subcategories, also SUBCATEGORISE [v]\n",
  "SUBCATEGORIZES": "SUBCATEGORIZE, to classify into subcategories, also SUBCATEGORISE [v]\n",
  "SUBCATEGORIZING": "SUBCATEGORIZE, to classify into subcategories, also SUBCATEGORISE [v]\n",
  "SUBCATEGORY": "a subdivision of a category [n SUBCATEGORIES]\n",
  "SUBCAUDAL": "situated under, or on the ventral side of, the tail; as, the subcaudal bones [adj]\n",
  "SUBCAUSE": "a subordinate cause [n -S]\n",
  "SUBCAUSES": "SUBCAUSE, a subordinate cause [n]\n",
  "SUBCAVITIES": "SUBCAVITY, a subordinate cavity [n]\n",
  "SUBCAVITY": "a subordinate cavity [n SUBCAVITIES]\n",
  "SUBCEILING": "an under-ceiling [n -S]\n",
  "SUBCEILINGS": "SUBCEILING, an under-ceiling [n]\n",
  "SUBCELESTIAL": "living below the heavens [adj] / someone living below the heavens [n -S]\n",
  "SUBCELESTIALS": "SUBCELESTIAL, someone living below the heavens [n]\n",
  "SUBCELL": "a subdivision of a cell [n -S]\n",
  "SUBCELLAR": "a subdivision of a cellar [n -S]\n",
  "SUBCELLARS": "SUBCELLAR, a subdivision of a cellar [n]\n",
  "SUBCELLS": "SUBCELL, a subdivision of a cell [n]\n",
  "SUBCELLULAR": "of less than cellular scope or level of organization [adj]\n",
  "SUBCENTER": "a subordinate center, also SUBCENTRE [n -S]\n",
  "SUBCENTERS": "SUBCENTER, a subordinate center, also SUBCENTRE [n]\n",
  "SUBCENTRAL": "under the center [adj SUBCENTRALLY]\n",
  "SUBCENTRALLY": "SUBCENTRAL, under the center [adv]\n",
  "SUBCENTRE": "a subordinate center, also SUBCENTER [n -S]\n",
  "SUBCENTRES": "SUBCENTRE, a subordinate center, also SUBCENTER [n]\n",
  "SUBCEPTION": "subliminal perception [n -S]\n",
  "SUBCEPTIONS": "SUBCEPTION, subliminal perception [n]\n",
  "SUBCHANTER": "a precentor's deputy; an officer or lay member of a cathedral who assists in chanting the litany [n -S]\n",
  "SUBCHANTERS": "SUBCHANTER, a precentor's deputy; an officer or lay member of a cathedral who assists in chanting the litany [n]\n",
  "SUBCHAPTER": "a subordinate part of a chapter [n -S]\n",
  "SUBCHAPTERS": "SUBCHAPTER, a subordinate part of a chapter [n]\n",
  "SUBCHARTER": "to rent a chartered vehicle [v -ED, -ING, -S]\n",
  "SUBCHARTERED": "SUBCHARTER, to rent a chartered vehicle [v]\n",
  "SUBCHARTERING": "SUBCHARTER, to rent a chartered vehicle [v]\n",
  "SUBCHARTERS": "SUBCHARTER, to rent a chartered vehicle [v]\n",
  "SUBCHASER": "a small manoeuvrable craft used in antisubmarine warfare [n -S]\n",
  "SUBCHASERS": "SUBCHASER, a small manoeuvrable craft used in antisubmarine warfare [n]\n",
  "SUBCHELATE": "in smaller proportion than a chelate [adj]\n",
  "SUBCHIEF": "a subordinate chief [n -S]\n",
  "SUBCHIEFS": "SUBCHIEF, a subordinate chief [n]\n",
  "SUBCHLORIDE": "a sub-compound of chloride [n -S]\n",
  "SUBCHLORIDES": "SUBCHLORIDE, a sub-compound of chloride [n]\n",
  "SUBCHORD": "a subdivision of a chord [n -S]\n",
  "SUBCHORDS": "SUBCHORD, a subdivision of a chord [n]\n",
  "SUBCIRCUIT": "a part of a circuit [n -S]\n",
  "SUBCIRCUITS": "SUBCIRCUIT, a part of a circuit [n]\n",
  "SUBCIVILISATION": "the state of being subcivilised, also SUBCIVILIZATION [n]\n",
  "SUBCIVILISED": "not fully civilised, also SUBCIVILIZED [adj]\n",
  "SUBCIVILIZATION": "the state of being subcivilized, also SUBCIVILISATION [n]\n",
  "SUBCIVILIZED": "not fully civilised, also SUBCIVILISED [adj]\n",
  "SUBCLAIM": "a subdivision of a claim [n -S]\n",
  "SUBCLAIMS": "SUBCLAIM, a subdivision of a claim [n]\n",
  "SUBCLAN": "a subdivision of a clan [n -S]\n",
  "SUBCLANS": "SUBCLAN, a subdivision of a clan [n]\n",
  "SUBCLASS": "to place in a subdivision of a class [v -ED, -ING, -ES]\n",
  "SUBCLASSED": "SUBCLASS, to place in a subdivision of a class [v]\n",
  "SUBCLASSES": "SUBCLASS, to place in a subdivision of a class [v]\n",
  "SUBCLASSIFIED": "SUBCLASSIFY, to group into subclasses [v]\n",
  "SUBCLASSIFIES": "SUBCLASSIFY, to group into subclasses [v]\n",
  "SUBCLASSIFY": "to group into subclasses [v SUBCLASSIFIED, SUBCLASSIFYING, SUBCLASSIFIES]\n",
  "SUBCLASSIFYING": "SUBCLASSIFY, to group into subclasses [v]\n",
  "SUBCLASSING": "SUBCLASS, to place in a subdivision of a class [v]\n",
  "SUBCLAUSE": "a part of a clause [n -S]\n",
  "SUBCLAUSES": "SUBCLAUSE, a part of a clause [n]\n",
  "SUBCLAVIAN": "situated or passing under the clavicle [adj] / a subclavian nerve, artery etc. [n -S]\n",
  "SUBCLAVIANS": "SUBCLAVIAN, a subclavian nerve, artery etc. [n]\n",
  "SUBCLAVICULAR": "situated below the clavicle [adj]\n",
  "SUBCLERK": "a subordinate clerk [n -S]\n",
  "SUBCLERKS": "SUBCLERK, a subordinate clerk [n]\n",
  "SUBCLIMACTIC": "like a subclimax, a subordinate climax [adj]\n",
  "SUBCLIMAX": "a subordinate climax [n SUBCLIMAXES]\n",
  "SUBCLIMAXES": "SUBCLIMAX, a subordinate climax [n]\n",
  "SUBCLINICAL": "producing effects that are not detectable by the usual clinical tests [adj SUBCLINICALLY]\n",
  "SUBCLINICALLY": "SUBCLINICAL, producing effects that are not detectable by the usual clinical tests [adv]\n",
  "SUBCLUSTER": "to form part of a cluster of galaxies [v -ED, -ING, -S]\n",
  "SUBCLUSTERED": "SUBCLUSTER, to form part of a cluster of galaxies [v]\n",
  "SUBCLUSTERING": "SUBCLUSTER, to form part of a cluster of galaxies [v]\n",
  "SUBCLUSTERS": "SUBCLUSTER, to form part of a cluster of galaxies [v]\n",
  "SUBCODE": "a subdivision of a code [n -S]\n",
  "SUBCODES": "SUBCODE, a subdivision of a code [n]\n",
  "SUBCOLLECTION": "a subdivision of a collection [n -S]\n",
  "SUBCOLLECTIONS": "SUBCOLLECTION, a subdivision of a collection [n]\n",
  "SUBCOLLEGE": "an institution of higher learning, especially one providing a general or liberal arts education rather than technical or professional training [n -S]\n",
  "SUBCOLLEGES": "SUBCOLLEGE, an institution of higher learning, especially one providing a general or liberal arts education rather than technical or professional training [n]\n",
  "SUBCOLLEGIATE": "relating to departments of a college [adj]\n",
  "SUBCOLONIES": "SUBCOLONY, a subordinate colony [n]\n",
  "SUBCOLONY": "a subordinate colony [n SUBCOLONIES]\n",
  "SUBCOMMISSION": "to give a subsidiary commission [v -ED, -S]\n",
  "SUBCOMMISSIONED": "SUBCOMMISSION, to give a subsidiary commission [v]\n",
  "SUBCOMMISSIONER": "a subordinate commissioner [n]\n",
  "SUBCOMMISSIONS": "SUBCOMMISSION, to give a subsidiary commission [v]\n",
  "SUBCOMMITTEE": "a subdivision of a committee usually organized for a specific purpose [n -S]\n",
  "SUBCOMMITTEES": "SUBCOMMITTEE, a subdivision of a committee usually organized for a specific purpose [n]\n",
  "SUBCOMMUNITIES": "SUBCOMMUNITY, a distinct grouping within a community [n]\n",
  "SUBCOMMUNITY": "a distinct grouping within a community [n SUBCOMMUNITIES]\n",
  "SUBCOMPACT": "a small car, such as a sports car [n -S]\n",
  "SUBCOMPACTS": "SUBCOMPACT, a small car, such as a sports car [n]\n",
  "SUBCOMPONENT": "a subordinate component [n -S]\n",
  "SUBCOMPONENTS": "SUBCOMPONENT, a subordinate component [n]\n",
  "SUBCONSCIOUS": "below the threshold of consciousness [adj SUBCONSCIOUSLY] / the mental activities just below the threshold of consciousness [n -ES]\n",
  "SUBCONSCIOUSES": "SUBCONSCIOUS, the mental activities just below the threshold of consciousness [n]\n",
  "SUBCONSCIOUSLY": "SUBCONSCIOUS, below the threshold of consciousness [adv]\n",
  "SUBCONSUL": "an assistant to a consul [n -S]\n",
  "SUBCONSULS": "SUBCONSUL, an assistant to a consul [n]\n",
  "SUBCONTIGUOUS": "partially contiguous [adj]\n",
  "SUBCONTINENT": "a large landmass smaller than a continent [n -S]\n",
  "SUBCONTINENTAL": "pertaining to a large land mass, that is separate to some degree but still part of a continent [adj]\n",
  "SUBCONTINENTS": "SUBCONTINENT, a large landmass smaller than a continent [n]\n",
  "SUBCONTINUOUS": "partially continuous [adj]\n",
  "SUBCONTRACT": "a contract between a party to an original contract and a third party [n -S] / to enter into a subcontract [v -ED, -ING, -S]\n",
  "SUBCONTRACTED": "SUBCONTRACT, to enter into a subcontract [v]\n",
  "SUBCONTRACTING": "the act of subcontracting [n -S]\n",
  "SUBCONTRACTINGS": "SUBCONTRACTING, the act of subcontracting [n]\n",
  "SUBCONTRACTOR": "an individual or business firm contracting to perform part or all of another's contract [n -S]\n",
  "SUBCONTRACTORS": "SUBCONTRACTOR, an individual or business firm contracting to perform part or all of another's contract [n]\n",
  "SUBCONTRACTS": "SUBCONTRACT, a contract between a party to an original contract and a third party [n]\n",
  "SUBCONTRAOCTAVE": "the octave below the contraoctave [n]\n",
  "SUBCONTRARIES": "SUBCONTRARY, a proposition so related to another that though both may be true they cannot both be false [n]\n",
  "SUBCONTRARIETY": "the state of being subcontrary [n]\n",
  "SUBCONTRARY": "a proposition so related to another that though both may be true they cannot both be false [n SUBCONTRARIES]\n",
  "SUBCOOL": "to cool below the freezing point [v -ED, -ING, -S]\n",
  "SUBCOOLED": "SUBCOOL, to cool below the freezing point [v]\n",
  "SUBCOOLING": "SUBCOOL, to cool below the freezing point [v]\n",
  "SUBCOOLS": "SUBCOOL, to cool below the freezing point [v]\n",
  "SUBCORDATE": "somewhat cordate; somewhat like a heart in shape [adj]\n",
  "SUBCORIACEOUS": "situated below the corium [adj]\n",
  "SUBCORTEX": "a part of the cortex [n SUBCORTEXES or SUBCORTICES]\n",
  "SUBCORTEXES": "SUBCORTEX, a part of the cortex [n]\n",
  "SUBCORTICAL": "of, relating to, involving, or being a part of the brain below the cerebral cortex [adj]\n",
  "SUBCORTICES": "SUBCORTEX, a part of the cortex [n]\n",
  "SUBCOSTA": "the vein on an insect's wing [n SUBCOSTAE]\n",
  "SUBCOSTAE": "SUBCOSTA, the vein on an insect's wing [n]\n",
  "SUBCOSTAL": "situated below the ribs [adj] / a subcostal muscle [n -S]\n",
  "SUBCOSTALS": "SUBCOSTAL, a subcostal muscle [n]\n",
  "SUBCOUNTIES": "SUBCOUNTY, a part of a county [n]\n",
  "SUBCOUNTY": "a part of a county [n SUBCOUNTIES]\n",
  "SUBCRANIAL": "situated under, or on the ventral side of, the cranium [adj]\n",
  "SUBCRITICAL": "less or lower than critical in respect to a specified factor [adj]\n",
  "SUBCRUST": "a subdivision of a crust [n -S]\n",
  "SUBCRUSTAL": "relating to the subcrust, the part of the earth below the crust [adj]\n",
  "SUBCRUSTS": "SUBCRUST, a subdivision of a crust [n]\n",
  "SUBCULT": "a subdivision of a cult [n -S]\n",
  "SUBCULTS": "SUBCULT, a subdivision of a cult [n]\n",
  "SUBCULTURAL": "relating to a subculture [adj SUBCULTURALLY]\n",
  "SUBCULTURALLY": "SUBCULTURAL, relating to a subculture [adv]\n",
  "SUBCULTURE": "a social, ethnic or economic group with a particular character of its own within a larger culture or society [n -S] / to create a subculture e.g. of bacteria [v SUBCULTURED, SUBCULTURING, SUBCULTURES]\n",
  "SUBCULTURED": "SUBCULTURE, to create a subculture e.g. of bacteria [v]\n",
  "SUBCULTURES": "SUBCULTURE, to create a subculture e.g. of bacteria [v]\n",
  "SUBCULTURING": "SUBCULTURE, to create a subculture e.g. of bacteria [v]\n",
  "SUBCURATIVE": "less than wholly curative [adj]\n",
  "SUBCUTANEOUS": "beneath the skin [adj SUBCUTANEOUSLY]\n",
  "SUBCUTANEOUSLY": "SUBCUTANEOUS, beneath the skin [adv]\n",
  "SUBCUTES": "SUBCUTIS, the deeper part of the dermis [n]\n",
  "SUBCUTIS": "the deeper part of the dermis [n SUBCUTISES or SUBCUTES]\n",
  "SUBCUTISES": "SUBCUTIS, the deeper part of the dermis [n]\n",
  "SUBDEACON": "a minister of an order next below that of deacon [n -S]\n",
  "SUBDEACONATE": "the office of subdeacon [n -S]\n",
  "SUBDEACONATES": "SUBDEACONATE, the office of subdeacon [n]\n",
  "SUBDEACONRIES": "SUBDEACONRY, the office of subdeacon [n]\n",
  "SUBDEACONRY": "the office of subdeacon [n SUBDEACONRIES]\n",
  "SUBDEACONS": "SUBDEACON, a minister of an order next below that of deacon [n]\n",
  "SUBDEACONSHIP": "the office of subdeacon [n -S]\n",
  "SUBDEACONSHIPS": "SUBDEACONSHIP, the office of subdeacon [n]\n",
  "SUBDEALER": "a dealer who buys from other dealers [n -S]\n",
  "SUBDEALERS": "SUBDEALER, a dealer who buys from other dealers [n]\n",
  "SUBDEAN": "a subordinate dean [n -S]\n",
  "SUBDEANERIES": "SUBDEANERY, the office or rank of subdean [n]\n",
  "SUBDEANERY": "the office or rank of subdean [n SUBDEANERIES]\n",
  "SUBDEANS": "SUBDEAN, a subordinate dean [n]\n",
  "SUBDEB": "(short for) subdebutante, a girl the year before she becomes a debutante [n -S]\n",
  "SUBDEBS": "SUBDEB, (short for) subdebutante, a girl the year before she becomes a debutante [n]\n",
  "SUBDEBUTANTE": "a young girl who is about to become a debutante, also SUBDEB [n -S]\n",
  "SUBDEBUTANTES": "SUBDEBUTANTE, a young girl who is about to become a debutante, also SUBDEB [n]\n",
  "SUBDECANAL": "of or pertaining to a subdean or subdeanery [adj]\n",
  "SUBDECISION": "part of a decision [n -S]\n",
  "SUBDECISIONS": "SUBDECISION, part of a decision [n]\n",
  "SUBDELIRIA": "SUBDELIRIUM, a mild or intermittent delirium [n]\n",
  "SUBDELIRIOUS": "mildly or intermittently delirious [adj]\n",
  "SUBDELIRIUM": "a mild or intermittent delirium [n SUBDELIRIA or SUBDELIRIUMS]\n",
  "SUBDELIRIUMS": "SUBDELIRIUM, a mild or intermittent delirium [n]\n",
  "SUBDEPARTMENT": "a subdivision of a department [n -S]\n",
  "SUBDEPARTMENTS": "SUBDEPARTMENT, a subdivision of a department [n]\n",
  "SUBDEPOT": "a subdivision of a military depot [n -S]\n",
  "SUBDEPOTS": "SUBDEPOT, a subdivision of a military depot [n]\n",
  "SUBDEPUTIES": "SUBDEPUTY, an assistant to a deputy [n]\n",
  "SUBDEPUTY": "an assistant to a deputy [n SUBDEPUTIES]\n",
  "SUBDERMAL": "subcutaneous [adj SUBDERMALLY]\n",
  "SUBDERMALLY": "SUBDERMAL, subcutaneous [adv]\n",
  "SUBDEVELOPMENT": "a subdivision of a development [n -S]\n",
  "SUBDEVELOPMENTS": "SUBDEVELOPMENT, a subdivision of a development [n]\n",
  "SUBDEW": "(Spenser) to bring under control, also SUBDUE [v -ED, -ING, -S]\n",
  "SUBDEWED": "SUBDEW, (Spenser) to bring under control, also SUBDUE [v]\n",
  "SUBDEWING": "SUBDEW, (Spenser) to bring under control, also SUBDUE [v]\n",
  "SUBDEWS": "SUBDEW, (Spenser) to bring under control, also SUBDUE [v]\n",
  "SUBDIACONAL": "relating to a subdeacon [adj]\n",
  "SUBDIACONATE": "the office of subdeacon [n -S]\n",
  "SUBDIACONATES": "SUBDIACONATE, the office of subdeacon [n]\n",
  "SUBDIALECT": "a subdivision of a dialect [n -S]\n",
  "SUBDIALECTS": "SUBDIALECT, a subdivision of a dialect [n]\n",
  "SUBDIRECTOR": "one below a director [n -S]\n",
  "SUBDIRECTORS": "SUBDIRECTOR, one below a director [n]\n",
  "SUBDISCIPLINE": "a subdivision of a discipline [n -S]\n",
  "SUBDISCIPLINES": "SUBDISCIPLINE, a subdivision of a discipline [n]\n",
  "SUBDISTRICT": "a subdivision of a district [n -S]\n",
  "SUBDISTRICTS": "SUBDISTRICT, a subdivision of a district [n]\n",
  "SUBDIVIDABLE": "that can be subdivided, also SUBDIVISIBLE [adj]\n",
  "SUBDIVIDE": "to divide into smaller divisions [v SUBDIVIDED, SUBDIVIDING, SUBDIVIDES]\n",
  "SUBDIVIDED": "SUBDIVIDE, to divide into smaller divisions [v]\n",
  "SUBDIVIDER": "one who subdivides [n -S]\n",
  "SUBDIVIDERS": "SUBDIVIDER, one who subdivides [n]\n",
  "SUBDIVIDES": "SUBDIVIDE, to divide into smaller divisions [v]\n",
  "SUBDIVIDING": "SUBDIVIDE, to divide into smaller divisions [v]\n",
  "SUBDIVISIBLE": "that can be subdivided, also SUBDIVIDABLE [adj]\n",
  "SUBDIVISION": "a subordinate part of a larger whole [n -S]\n",
  "SUBDIVISIONAL": "relating to a subdivision [adj]\n",
  "SUBDIVISIONS": "SUBDIVISION, a subordinate part of a larger whole [n]\n",
  "SUBDIVISIVE": "relating to a subdivision [adj]\n",
  "SUBDOLOUS": "rather crafty [adj]\n",
  "SUBDOMINANT": "the fourth degree of the diatonic scale, e.g. F in the scale of C [n -S]\n",
  "SUBDOMINANTS": "SUBDOMINANT, the fourth degree of the diatonic scale, e.g. F in the scale of C [n]\n",
  "SUBDORSAL": "relating to the lower back [adj]\n",
  "SUBDUABLE": "able to be subdued [adj SUBDUABLY]\n",
  "SUBDUABLY": "SUBDUABLE, able to be subdued [adv]\n",
  "SUBDUAL": "the act of subduing [n -S]\n",
  "SUBDUALS": "SUBDUAL, the act of subduing [n]\n",
  "SUBDUCE": "to take away [v SUBDUCED, SUBDUCING, SUBDUCES]\n",
  "SUBDUCED": "SUBDUCE, to take away [v]\n",
  "SUBDUCES": "SUBDUCE, to take away [v]\n",
  "SUBDUCING": "SUBDUCE, to take away [v]\n",
  "SUBDUCT": "to withdraw; to take away, also SUBDUCE [v -ED, -ING, -S]\n",
  "SUBDUCTED": "SUBDUCT, to withdraw; to take away, also SUBDUCE [v]\n",
  "SUBDUCTING": "SUBDUCT, to withdraw; to take away, also SUBDUCE [v]\n",
  "SUBDUCTION": "the process of one plate descending beneath another [n -S]\n",
  "SUBDUCTIONS": "SUBDUCTION, the process of one plate descending beneath another [n]\n",
  "SUBDUCTS": "SUBDUCT, to withdraw; to take away, also SUBDUCE [v]\n",
  "SUBDUE": "to bring under control, also SUBDEW [v SUBDUED, SUBDUING, SUBDUES]\n",
  "SUBDUED": "SUBDUE, to bring under control, also SUBDEW [v]\n",
  "SUBDUEDLY": "SUBDUED, SUBDUE, to bring under control, also SUBDEW [adv]\n",
  "SUBDUEDNESS": "the state of being subdued [n -ES]\n",
  "SUBDUEDNESSES": "SUBDUEDNESS, the state of being subdued [n]\n",
  "SUBDUEMENT": "subdual [n -S]\n",
  "SUBDUEMENTS": "SUBDUEMENT, subdual [n]\n",
  "SUBDUER": "one who subduers [n -S]\n",
  "SUBDUERS": "SUBDUER, one who subduers [n]\n",
  "SUBDUES": "SUBDUE, to bring under control, also SUBDEW [v]\n",
  "SUBDUING": "SUBDUE, to bring under control, also SUBDEW [v]\n",
  "SUBDUPLE": "in the ratio of one to two [adj]\n",
  "SUBDUPLICATE": "expressed by a square root [adj]\n",
  "SUBDURAL": "situated under the dura mater [adj]\n",
  "SUBDWARF": "a small star of relatively low luminosity [n -S]\n",
  "SUBDWARFS": "SUBDWARF, a small star of relatively low luminosity [n]\n",
  "SUBECHO": "an inferior echo [n SUBECHOES]\n",
  "SUBECHOES": "SUBECHO, an inferior echo [n]\n",
  "SUBECONOMIC": "below the economy [adj]\n",
  "SUBECONOMIES": "SUBECONOMY, the lower reaches of the economy [n]\n",
  "SUBECONOMY": "the lower reaches of the economy [n SUBECONOMIES]\n",
  "SUBEDAR": "(Hindi) a native officer in an Indian regiment corresponding to a captain, also SUBADAR, SUBAHDAR [n -S]\n",
  "SUBEDARS": "SUBEDAR, (Hindi) a native officer in an Indian regiment corresponding to a captain, also SUBADAR, SUBAHDAR [n]\n",
  "SUBEDIT": "to act as assistant editor [v -ED, -ING, -S]\n",
  "SUBEDITED": "SUBEDIT, to act as assistant editor [v]\n",
  "SUBEDITING": "SUBEDIT, to act as assistant editor [v]\n",
  "SUBEDITOR": "an assistant editor, as of a periodical or journal [n -S]\n",
  "SUBEDITORIAL": "relating to the role of subeditor [adj]\n",
  "SUBEDITORS": "SUBEDITOR, an assistant editor, as of a periodical or journal [n]\n",
  "SUBEDITORSHIP": "the office of subeditor [n -S]\n",
  "SUBEDITORSHIPS": "SUBEDITORSHIP, the office of subeditor [n]\n",
  "SUBEDITS": "SUBEDIT, to act as assistant editor [v]\n",
  "SUBEMPLOYED": "employed by a subcontractor [adj]\n",
  "SUBEMPLOYMENT": "a condition of inadequate employment in a labor force including unemployment and underemployment [n -S]\n",
  "SUBEMPLOYMENTS": "SUBEMPLOYMENT, a condition of inadequate employment in a labor force including unemployment and underemployment [n]\n",
  "SUBENTIRE": "of a leaf, with very faintly indented margin [adj]\n",
  "SUBENTRIES": "SUBENTRY, an entry made under a more general entry [n]\n",
  "SUBENTRY": "an entry made under a more general entry [n SUBENTRIES]\n",
  "SUBEPIDERMAL": "lying beneath or constituting the innermost part of the epidermis [adj]\n",
  "SUBEPOCH": "a subdivision of an epoch [n -S]\n",
  "SUBEPOCHS": "SUBEPOCH, a subdivision of an epoch [n]\n",
  "SUBEQUAL": "subordinately equal [adj]\n",
  "SUBEQUATORIAL": "below the equator [adj]\n",
  "SUBER": "(Latin) the bark of the cork tree [n -S]\n",
  "SUBERATE": "a salt of suberic acid [n -S]\n",
  "SUBERATES": "SUBERATE, a salt of suberic acid [n]\n",
  "SUBERECT": "nearly erect [adj]\n",
  "SUBEREOUS": "pertaining to cork, also SUBEROSE, SUBEROUS [adj]\n",
  "SUBERIC": "relating to an acid obtained by the action of nitric acid on cork [adj]\n",
  "SUBERIN": "a substance found in cork cells [n -S]\n",
  "SUBERINS": "SUBERIN, a substance found in cork cells [n]\n",
  "SUBERISATION": "the deposition of suberin in the cell walls of cork, also SUBERIZATION [n -S]\n",
  "SUBERISATIONS": "SUBERISATION, the deposition of suberin in the cell walls of cork, also SUBERIZATION [n]\n",
  "SUBERISE": "to convert into cork tissue, also SUBERIZE [v SUBERISED, SUBERISING, SUBERISES]\n",
  "SUBERISED": "SUBERISE, to convert into cork tissue, also SUBERIZE [v]\n",
  "SUBERISES": "SUBERISE, to convert into cork tissue, also SUBERIZE [v]\n",
  "SUBERISING": "SUBERISE, to convert into cork tissue, also SUBERIZE [v]\n",
  "SUBERIZATION": "the deposition of suberin in the cell walls of cork, also SUBERISATION [n -S]\n",
  "SUBERIZATIONS": "SUBERIZATION, the deposition of suberin in the cell walls of cork, also SUBERISATION [n]\n",
  "SUBERIZE": "to convert into cork tissue, also SUBERISE [v SUBERIZED, SUBERIZING, SUBERIZES]\n",
  "SUBERIZED": "SUBERIZE, to convert into cork tissue, also SUBERISE [v]\n",
  "SUBERIZES": "SUBERIZE, to convert into cork tissue, also SUBERISE [v]\n",
  "SUBERIZING": "SUBERIZE, to convert into cork tissue, also SUBERISE [v]\n",
  "SUBEROSE": "pertaining to cork, also SUBEREOUS, SUBEROUS [adj]\n",
  "SUBEROUS": "pertaining to cork, also SUBEREOUS, SUBEROSE [adj]\n",
  "SUBERS": "SUBER, (Latin) the bark of the cork tree [n]\n",
  "SUBFACTORIAL": "something below a factorial [n -S]\n",
  "SUBFACTORIALS": "SUBFACTORIAL, something below a factorial [n]\n",
  "SUBFAMILIES": "SUBFAMILY, a taxonomic division of a family, of one or more genera [n]\n",
  "SUBFAMILY": "a taxonomic division of a family, of one or more genera [n SUBFAMILIES]\n",
  "SUBFERTILE": "not very fertile [adj]\n",
  "SUBFERTILITIES": "SUBFERTILITY, the state of being subfertile [n]\n",
  "SUBFERTILITY": "the state of being subfertile [n SUBFERTILITIES]\n",
  "SUBFEU": "to grant land to under Scottish feudal law [v -ED, -ING, -S]\n",
  "SUBFEUDATION": "subinfeudation [n -S]\n",
  "SUBFEUDATIONS": "SUBFEUDATION, subinfeudation [n]\n",
  "SUBFEUDATORY": "of or like a subfeu [adj]\n",
  "SUBFEUED": "SUBFEU, to grant land to under Scottish feudal law [v]\n",
  "SUBFEUING": "SUBFEU, to grant land to under Scottish feudal law [v]\n",
  "SUBFEUS": "SUBFEU, to grant land to under Scottish feudal law [v]\n",
  "SUBFIELD": "a subset of a mathematical field [n -S]\n",
  "SUBFIELDS": "SUBFIELD, a subset of a mathematical field [n]\n",
  "SUBFILE": "a subdivision of a file [n -S]\n",
  "SUBFILES": "SUBFILE, a subdivision of a file [n]\n",
  "SUBFIX": "a distinguishing symbol written below another character [n -ES]\n",
  "SUBFIXES": "SUBFIX, a distinguishing symbol written below another character [n]\n",
  "SUBFLOOR": "a rough floor laid as a base for a finished floor [n -S]\n",
  "SUBFLOORS": "SUBFLOOR, a rough floor laid as a base for a finished floor [n]\n",
  "SUBFLUID": "somewhat fluid [adj]\n",
  "SUBFOLDER": "a subdivision of a folder [n -S]\n",
  "SUBFOLDERS": "SUBFOLDER, a subdivision of a folder [n]\n",
  "SUBFOSSIL": "part of a fossil [n -S]\n",
  "SUBFOSSILS": "SUBFOSSIL, part of a fossil [n]\n",
  "SUBFRAME": "a frame for the attachment of a finish frame [n -S]\n",
  "SUBFRAMES": "SUBFRAME, a frame for the attachment of a finish frame [n]\n",
  "SUBFREEZING": "below freezing [adj]\n",
  "SUBFUSC": "duskish; moderately dark, also SUBFUSCOUS, SUBFUSK [adj] / dark, formal clothes worn in combination with the academic gown, esp. at Oxford University [n -S]\n",
  "SUBFUSCOUS": "duskish; moderately dark, also SUBFUSC, SUBFUSK [adj]\n",
  "SUBFUSCS": "SUBFUSC, dark, formal clothes worn in combination with the academic gown, esp. at Oxford University [n]\n",
  "SUBFUSK": "duskish; moderately dark, also SUBFUSCOUS [adj] / dark, formal clothes worn in combination with the academic gown, esp. at Oxford University, also SUBFUSC [n -S]\n",
  "SUBFUSKS": "SUBFUSK, dark, formal clothes worn in combination with the academic gown, esp. at Oxford University, also SUBFUSC [n]\n",
  "SUBGENERA": "SUBGENUS, a subdivision of a genus [n]\n",
  "SUBGENERATION": "a subdivision of a generation [n -S]\n",
  "SUBGENERATIONS": "SUBGENERATION, a subdivision of a generation [n]\n",
  "SUBGENERIC": "of or pertaining to a subgenus [adj SUBGENERICALLY]\n",
  "SUBGENERICALLY": "SUBGENERIC, of or pertaining to a subgenus [adv]\n",
  "SUBGENRE": "a subdivision of a genre [n -S]\n",
  "SUBGENRES": "SUBGENRE, a subdivision of a genre [n]\n",
  "SUBGENUS": "a subdivision of a genus [n SUBGENUSES or SUBGENERA]\n",
  "SUBGENUSES": "SUBGENUS, a subdivision of a genus [n]\n",
  "SUBGLACIAL": "of or relating to the bottom of a glacier or the area immediately underlying a glacier [adj SUBGLACIALLY]\n",
  "SUBGLACIALLY": "SUBGLACIAL, of or relating to the bottom of a glacier or the area immediately underlying a glacier [adv]\n",
  "SUBGLOBOSE": "not quite globose [adj]\n",
  "SUBGLOBULAR": "having nearly the shape of a globe [adj]\n",
  "SUBGOAL": "a subordinate goal [n -S]\n",
  "SUBGOALS": "SUBGOAL, a subordinate goal [n]\n",
  "SUBGOVERNMENT": "a subdivision of a government [n -S]\n",
  "SUBGOVERNMENTS": "SUBGOVERNMENT, a subdivision of a government [n]\n",
  "SUBGRADE": "a surface on which a pavement is placed [n -S]\n",
  "SUBGRADES": "SUBGRADE, a surface on which a pavement is placed [n]\n",
  "SUBGRAPH": "a graph contained within a larger graph [n -S]\n",
  "SUBGRAPHS": "SUBGRAPH, a graph contained within a larger graph [n]\n",
  "SUBGROUP": "a distinct group within a group [n -S] / to divide into subgroups [v -ED, -ING, -S]\n",
  "SUBGROUPED": "SUBGROUP, to divide into subgroups [v]\n",
  "SUBGROUPING": "SUBGROUP, to divide into subgroups [v]\n",
  "SUBGROUPS": "SUBGROUP, to divide into subgroups [v]\n",
  "SUBGUM": "(Chinese) a Chinese-style dish consisting of mixed vegetables, and sometimes diced meat or seafood [n -S]\n",
  "SUBGUMS": "SUBGUM, (Chinese) a Chinese-style dish consisting of mixed vegetables, and sometimes diced meat or seafood [n]\n",
  "SUBHA": "(Arabic) a string of beads used by Muslims in meditation and prayer, also SABHA [n -S]\n",
  "SUBHARMONIC": "a tone below a harmonic [n -S]\n",
  "SUBHARMONICS": "SUBHARMONIC, a tone below a harmonic [n]\n",
  "SUBHAS": "SUBHA, (Arabic) a string of beads used by Muslims in meditation and prayer, also SABHA [n]\n",
  "SUBHASTATION": "(historical) sale by public auction [n -S]\n",
  "SUBHASTATIONS": "SUBHASTATION, (historical) sale by public auction [n]\n",
  "SUBHEAD": "an inferior heading, also SUBHEADING [n -S]\n",
  "SUBHEADING": "an inferior heading, also SUBHEAD [n -S]\n",
  "SUBHEADINGS": "SUBHEADING, an inferior heading, also SUBHEAD [n]\n",
  "SUBHEADS": "SUBHEAD, an inferior heading, also SUBHEADING [n]\n",
  "SUBHEDRAL": "showing some traces of crystal form [adj]\n",
  "SUBHUMAN": "one that is less than human [n -S]\n",
  "SUBHUMANS": "SUBHUMAN, one that is less than human [n]\n",
  "SUBHUMID": "of a climate, too wet for xerophytic vegetation, but not wet enough for tree growth [adj]\n",
  "SUBIDEA": "an inferior idea [n -S]\n",
  "SUBIDEAS": "SUBIDEA, an inferior idea [n]\n",
  "SUBIMAGINAL": "relating to a subimago [adj]\n",
  "SUBIMAGINES": "SUBIMAGO, a stage in the life of a mayfly [n]\n",
  "SUBIMAGO": "a stage in the life of a mayfly [n SUBIMAGOS or SUBIMAGINES or SUBIMAGOES]\n",
  "SUBIMAGOES": "SUBIMAGO, a stage in the life of a mayfly [n]\n",
  "SUBIMAGOS": "SUBIMAGO, a stage in the life of a mayfly [n]\n",
  "SUBINCISE": "to perform subincision, the formation of an opening into the urethra by the incision of the underside of the penis, a puberty rite practised by some tribal people [v SUBINCISED, SUBINCISING, SUBINCISES]\n",
  "SUBINCISED": "SUBINCISE, to perform subincision, the formation of an opening into the urethra by the incision of the underside of the penis, a puberty rite practised by some tribal people [v]\n",
  "SUBINCISES": "SUBINCISE, to perform subincision, the formation of an opening into the urethra by the incision of the underside of the penis, a puberty rite practised by some tribal people [v]\n",
  "SUBINCISING": "SUBINCISE, to perform subincision, the formation of an opening into the urethra by the incision of the underside of the penis, a puberty rite practised by some tribal people [v]\n",
  "SUBINCISION": "the formation of an opening into the urethra by the incision of the underside of the penis, a puberty rite practised by some tribal people [n -S]\n",
  "SUBINCISIONS": "SUBINCISION, the formation of an opening into the urethra by the incision of the underside of the penis, a puberty rite practised by some tribal people [n]\n",
  "SUBINDEX": "a distinguishing symbol written below another character [n SUBINDEXES or SUBINDICES]\n",
  "SUBINDEXES": "SUBINDEX, a distinguishing symbol written below another character [n]\n",
  "SUBINDICATE": "(obsolete) to hint [v SUBINDICATED, SUBINDICATING, SUBINDICATES]\n",
  "SUBINDICATED": "SUBINDICATE, (obsolete) to hint [v]\n",
  "SUBINDICATES": "SUBINDICATE, (obsolete) to hint [v]\n",
  "SUBINDICATING": "SUBINDICATE, (obsolete) to hint [v]\n",
  "SUBINDICATION": "(obsolete) a hint [n -S]\n",
  "SUBINDICATIONS": "SUBINDICATION, (obsolete) a hint [n]\n",
  "SUBINDICATIVE": "(obsolete) of the nature of a hint [adj]\n",
  "SUBINDICES": "SUBINDEX, a distinguishing symbol written below another character [n]\n",
  "SUBINDUSTRIES": "SUBINDUSTRY, a subordinate industry [n]\n",
  "SUBINDUSTRY": "a subordinate industry [n SUBINDUSTRIES]\n",
  "SUBINFEUD": "to grant by feudal tenant to a further tenant, also SUBFEU, SUBINFEUDATE [v -ED, -ING, -S]\n",
  "SUBINFEUDATE": "to grant to another land held by another feudal lord, also SUBFEU, SUBINFEUD [v SUBINFEUDATED, SUBINFEUDATING, SUBINFEUDATES]\n",
  "SUBINFEUDATED": "SUBINFEUDATE, to grant to another land held by another feudal lord, also SUBFEU, SUBINFEUD [v]\n",
  "SUBINFEUDATES": "SUBINFEUDATE, to grant to another land held by another feudal lord, also SUBFEU, SUBINFEUD [v]\n",
  "SUBINFEUDATING": "SUBINFEUDATE, to grant to another land held by another feudal lord, also SUBFEU, SUBINFEUD [v]\n",
  "SUBINFEUDATION": "the sublease of a portion of a feudal estate by a vassal to a tenant who pays fealty to the vassal [n -S]\n",
  "SUBINFEUDATIONS": "SUBINFEUDATION, the sublease of a portion of a feudal estate by a vassal to a tenant who pays fealty to the vassal [n]\n",
  "SUBINFEUDATORY": "relating to subinfeudation, the sublease of a portion of a feudal estate by a vassal to a tenant who pays fealty to the vassal [adj]\n",
  "SUBINFEUDED": "SUBINFEUD, to grant by feudal tenant to a further tenant, also SUBFEU, SUBINFEUDATE [v]\n",
  "SUBINFEUDING": "SUBINFEUD, to grant by feudal tenant to a further tenant, also SUBFEU, SUBINFEUDATE [v]\n",
  "SUBINFEUDS": "SUBINFEUD, to grant by feudal tenant to a further tenant, also SUBFEU, SUBINFEUDATE [v]\n",
  "SUBINHIBITORY": "below a level that causes inhibition [adj]\n",
  "SUBINSINUATION": "something less than an insinuation [n -S]\n",
  "SUBINSINUATIONS": "SUBINSINUATION, something less than an insinuation [n]\n",
  "SUBINSPECTOR": "a subordinate inspector [n -S]\n",
  "SUBINSPECTORS": "SUBINSPECTOR, a subordinate inspector [n]\n",
  "SUBINTELLECTION": "an implication that is understood without necessarily being stated, also SUBINTELLIGENCE [n]\n",
  "SUBINTELLIGENCE": "an implication that is understood without necessarily being stated, also SUBINTELLECTION [n]\n",
  "SUBINTELLIGITUR": "something that is not stated but understood [n]\n",
  "SUBINTERVAL": "an interval that is a subdivision or a subset of an interval [n -S]\n",
  "SUBINTERVALS": "SUBINTERVAL, an interval that is a subdivision or a subset of an interval [n]\n",
  "SUBINTRANT": "of fevers, with paroxysms succeeding close upon one another [adj]\n",
  "SUBINTRODUCE": "to bring in surreptitiously or subtly [v SUBINTRODUCED, SUBINTRODUCING, SUBINTRODUCES]\n",
  "SUBINTRODUCED": "SUBINTRODUCE, to bring in surreptitiously or subtly [v]\n",
  "SUBINTRODUCES": "SUBINTRODUCE, to bring in surreptitiously or subtly [v]\n",
  "SUBINTRODUCING": "SUBINTRODUCE, to bring in surreptitiously or subtly [v]\n",
  "SUBINVOLUTION": "partial or complete failure of the uterus to return to its normal size in the six weeks following childbirth [n -S]\n",
  "SUBINVOLUTIONS": "SUBINVOLUTION, partial or complete failure of the uterus to return to its normal size in the six weeks following childbirth [n]\n",
  "SUBIRRIGATE": "to irrigate by underground pipes [v SUBIRRIGATED, SUBIRRIGATING, SUBIRRIGATES]\n",
  "SUBIRRIGATED": "SUBIRRIGATE, to irrigate by underground pipes [v]\n",
  "SUBIRRIGATES": "SUBIRRIGATE, to irrigate by underground pipes [v]\n",
  "SUBIRRIGATING": "SUBIRRIGATE, to irrigate by underground pipes [v]\n",
  "SUBIRRIGATION": "irrigation below the surface, as by a periodic rise of the water table or by a system of underground porous pipes [n -S]\n",
  "SUBIRRIGATIONS": "SUBIRRIGATION, irrigation below the surface, as by a periodic rise of the water table or by a system of underground porous pipes [n]\n",
  "SUBITANEOUS": "sudden; hasty; hastily made [adj]\n",
  "SUBITEM": "an item that forms a subdivision of a larger topic [n -S]\n",
  "SUBITEMS": "SUBITEM, an item that forms a subdivision of a larger topic [n]\n",
  "SUBITISE": "to perceive, also SUBITIZE [v SUBITISED, SUBITISING, SUBITISES]\n",
  "SUBITISED": "SUBITISE, to perceive, also SUBITIZE [v]\n",
  "SUBITISES": "SUBITISE, to perceive, also SUBITIZE [v]\n",
  "SUBITISING": "SUBITISE, to perceive, also SUBITIZE [v]\n",
  "SUBITIZE": "to perceive, also SUBITISE [v SUBITIZED, SUBITIZING, SUBITIZES]\n",
  "SUBITIZED": "SUBITIZE, to perceive, also SUBITISE [v]\n",
  "SUBITIZES": "SUBITIZE, to perceive, also SUBITISE [v]\n",
  "SUBITIZING": "SUBITIZE, to perceive, also SUBITISE [v]\n",
  "SUBITO": "(Italian) at once; immediately [interj]\n",
  "SUBJACENCIES": "SUBJACENCY, the state of being subjacent, underlying [n]\n",
  "SUBJACENCY": "the state of being subjacent, underlying [n SUBJACENCIES]\n",
  "SUBJACENT": "lying under or below something [adj SUBJACENTLY]\n",
  "SUBJACENTLY": "SUBJACENT, lying under or below something [adv]\n",
  "SUBJECT": "to cause to experience [v -ED, -ING, -S]\n",
  "SUBJECTABILITY": "the quality of being subjectable [n]\n",
  "SUBJECTABLE": "capable of being subjected [adj]\n",
  "SUBJECTED": "SUBJECT, to cause to experience [v]\n",
  "SUBJECTIFIED": "SUBJECTIFY, to make subjective [v]\n",
  "SUBJECTIFIES": "SUBJECTIFY, to make subjective [v]\n",
  "SUBJECTIFY": "to make subjective [v SUBJECTIFIED, SUBJECTIFYING, SUBJECTIFIES]\n",
  "SUBJECTIFYING": "SUBJECTIFY, to make subjective [v]\n",
  "SUBJECTING": "SUBJECT, to cause to experience [v]\n",
  "SUBJECTION": "the act of making subject [n -S]\n",
  "SUBJECTIONS": "SUBJECTION, the act of making subject [n]\n",
  "SUBJECTIVE": "relating to the subject [adj SUBJECTIVELY] / the subjective case [n -S]\n",
  "SUBJECTIVELY": "SUBJECTIVE, relating to the subject [adv]\n",
  "SUBJECTIVENESS": "the state of being subjective [n]\n",
  "SUBJECTIVES": "SUBJECTIVE, the subjective case [n]\n",
  "SUBJECTIVISE": "to make subjective, also SUBJECTIVIZE [v SUBJECTIVISED, SUBJECTIVISING, SUBJECTIVISES]\n",
  "SUBJECTIVISED": "SUBJECTIVISE, to make subjective, also SUBJECTIVIZE [v]\n",
  "SUBJECTIVISES": "SUBJECTIVISE, to make subjective, also SUBJECTIVIZE [v]\n",
  "SUBJECTIVISING": "SUBJECTIVISE, to make subjective, also SUBJECTIVIZE [v]\n",
  "SUBJECTIVISM": "the doctrine that all knowledge is subjective [n -S]\n",
  "SUBJECTIVISMS": "SUBJECTIVISM, the doctrine that all knowledge is subjective [n]\n",
  "SUBJECTIVIST": "a believer in subjectivism [n -S]\n",
  "SUBJECTIVISTIC": "relating to subjectivism [adj]\n",
  "SUBJECTIVISTS": "SUBJECTIVIST, a believer in subjectivism [n]\n",
  "SUBJECTIVITIES": "SUBJECTIVITY, the state of being subjective [n]\n",
  "SUBJECTIVITY": "the state of being subjective [n SUBJECTIVITIES]\n",
  "SUBJECTIVIZE": "to make subjective, also SUBJECTIVISE [v SUBJECTIVIZED, SUBJECTIVIZING, SUBJECTIVIZES]\n",
  "SUBJECTIVIZED": "SUBJECTIVIZE, to make subjective, also SUBJECTIVISE [v]\n",
  "SUBJECTIVIZES": "SUBJECTIVIZE, to make subjective, also SUBJECTIVISE [v]\n",
  "SUBJECTIVIZING": "SUBJECTIVIZE, to make subjective, also SUBJECTIVISE [v]\n",
  "SUBJECTLESS": "without a subject [adj]\n",
  "SUBJECTS": "SUBJECT, to cause to experience [v]\n",
  "SUBJECTSHIP": "the state of being a subject [n -S]\n",
  "SUBJECTSHIPS": "SUBJECTSHIP, the state of being a subject [n]\n",
  "SUBJOIN": "to add at the end [v -ED, -ING, -S]\n",
  "SUBJOINDER": "an additional remark [n -S]\n",
  "SUBJOINDERS": "SUBJOINDER, an additional remark [n]\n",
  "SUBJOINED": "SUBJOIN, to add at the end [v]\n",
  "SUBJOINING": "SUBJOIN, to add at the end [v]\n",
  "SUBJOINS": "SUBJOIN, to add at the end [v]\n",
  "SUBJUGABLE": "that can be subjugated [adj]\n",
  "SUBJUGATE": "to bring under the yoke; to make subservient [v SUBJUGATED, SUBJUGATING, SUBJUGATES]\n",
  "SUBJUGATED": "SUBJUGATE, to bring under the yoke; to make subservient [v]\n",
  "SUBJUGATES": "SUBJUGATE, to bring under the yoke; to make subservient [v]\n",
  "SUBJUGATING": "SUBJUGATE, to bring under the yoke; to make subservient [v]\n",
  "SUBJUGATION": "the act of subjugating [n -S]\n",
  "SUBJUGATIONS": "SUBJUGATION, the act of subjugating [n]\n",
  "SUBJUGATOR": "one who subjugates [n -S]\n",
  "SUBJUGATORS": "SUBJUGATOR, one who subjugates [n]\n",
  "SUBJUNCTION": "an act of subjoining or the state of being subjoined [n -S]\n",
  "SUBJUNCTIONS": "SUBJUNCTION, an act of subjoining or the state of being subjoined [n]\n",
  "SUBJUNCTIVE": "of a verb, in a mood or form expressing condition, hypothesis, or contingency [adj SUBJUNCTIVELY] / the subjunctive mood of a verb [n -S]\n",
  "SUBJUNCTIVELY": "SUBJUNCTIVE, of a verb, in a mood or form expressing condition, hypothesis, or contingency [adv]\n",
  "SUBJUNCTIVES": "SUBJUNCTIVE, the subjunctive mood of a verb [n]\n",
  "SUBKINGDOM": "a taxonomic division of a kingdom; a phylum [n -S]\n",
  "SUBKINGDOMS": "SUBKINGDOM, a taxonomic division of a kingdom; a phylum [n]\n",
  "SUBLANCEOLATE": "not quite lanceolate [adj]\n",
  "SUBLANGUAGE": "a subdivision of a language [n -S]\n",
  "SUBLANGUAGES": "SUBLANGUAGE, a subdivision of a language [n]\n",
  "SUBLAPSARIAN": "a believer in sublapsarianism [n -S]\n",
  "SUBLAPSARIANISM": "a doctrine of moderate Calvinists, that God permitted the fall of Adam without preordaining it [n]\n",
  "SUBLAPSARIANS": "SUBLAPSARIAN, a believer in sublapsarianism [n]\n",
  "SUBLATE": "to deny; to contradict [v SUBLATED, SUBLATING, SUBLATES]\n",
  "SUBLATED": "SUBLATE, to deny; to contradict [v]\n",
  "SUBLATES": "SUBLATE, to deny; to contradict [v]\n",
  "SUBLATING": "SUBLATE, to deny; to contradict [v]\n",
  "SUBLATION": "the act of taking or carrying away [n -S]\n",
  "SUBLATIONS": "SUBLATION, the act of taking or carrying away [n]\n",
  "SUBLEASE": "to rent leased property to another, also SUBLET [v SUBLEASED, SUBLEASING, SUBLEASES]\n",
  "SUBLEASED": "SUBLEASE, to rent leased property to another, also SUBLET [v]\n",
  "SUBLEASES": "SUBLEASE, to rent leased property to another, also SUBLET [v]\n",
  "SUBLEASING": "SUBLEASE, to rent leased property to another, also SUBLET [v]\n",
  "SUBLESSEE": "a holder of a sublease, a lease by a tenant or lessee to another person [n -S]\n",
  "SUBLESSEES": "SUBLESSEE, a holder of a sublease, a lease by a tenant or lessee to another person [n]\n",
  "SUBLESSOR": "a person who grants a sublease, a lease by a tenant or lessee to another person [n -S]\n",
  "SUBLESSORS": "SUBLESSOR, a person who grants a sublease, a lease by a tenant or lessee to another person [n]\n",
  "SUBLET": "to rent leased property to another, also SUBLEASE [v SUBLET, SUBLETTING, SUBLETS]\n",
  "SUBLETHAL": "not quite fatal [adj SUBLETHALLY]\n",
  "SUBLETHALLY": "SUBLETHAL, not quite fatal [adv]\n",
  "SUBLETS": "SUBLET, to rent leased property to another, also SUBLEASE [v]\n",
  "SUBLETTER": "one who sublets [n -S]\n",
  "SUBLETTERS": "SUBLETTER, one who sublets [n]\n",
  "SUBLETTING": "the act of renting leased property to another [n -S]\n",
  "SUBLETTINGS": "SUBLETTING, the act of renting leased property to another [n]\n",
  "SUBLEVEL": "a lower level [n -S]\n",
  "SUBLEVELS": "SUBLEVEL, a lower level [n]\n",
  "SUBLIBRARIAN": "a subordinate librarian [n -S]\n",
  "SUBLIBRARIANS": "SUBLIBRARIAN, a subordinate librarian [n]\n",
  "SUBLICENSE": "to license part of one's license [v SUBLICENSED, SUBLICENSING, SUBLICENSES]\n",
  "SUBLICENSED": "SUBLICENSE, to license part of one's license [v]\n",
  "SUBLICENSES": "SUBLICENSE, to license part of one's license [v]\n",
  "SUBLICENSING": "SUBLICENSE, to license part of one's license [v]\n",
  "SUBLIEUTENANCY": "the office of sublieutenant [n]\n",
  "SUBLIEUTENANT": "a commissioned officer in the British navy ranking immediately below lieutenant [n -S]\n",
  "SUBLIEUTENANTS": "SUBLIEUTENANT, a commissioned officer in the British navy ranking immediately below lieutenant [n]\n",
  "SUBLIMABLE": "capable of being sublimed or sublimated [adj]\n",
  "SUBLIMATE": "to cause to pass directly from the solid to the vapor state and condense back to solid form [v SUBLIMATED, SUBLIMATING, SUBLIMATES]\n",
  "SUBLIMATED": "SUBLIMATE, to cause to pass directly from the solid to the vapor state and condense back to solid form [v]\n",
  "SUBLIMATES": "SUBLIMATE, to cause to pass directly from the solid to the vapor state and condense back to solid form [v]\n",
  "SUBLIMATING": "SUBLIMATE, to cause to pass directly from the solid to the vapor state and condense back to solid form [v]\n",
  "SUBLIMATION": "the process by which matter in the solid state passes directly to the gaseous state without first becoming liquid [n -S]\n",
  "SUBLIMATIONS": "SUBLIMATION, the process by which matter in the solid state passes directly to the gaseous state without first becoming liquid [n]\n",
  "SUBLIME": "lofty [adj SUBLIMER, SUBLIMEST, SUBLIMELY] / to sublimate [v SUBLIMED, SUBLIMING, SUBLIMES]\n",
  "SUBLIMED": "SUBLIME, to sublimate [v]\n",
  "SUBLIMELY": "SUBLIME, lofty [adv]\n",
  "SUBLIMENESS": "the state of being sublime [n -ES]\n",
  "SUBLIMENESSES": "SUBLIMENESS, the state of being sublime [n]\n",
  "SUBLIMER": "one who sublimes [n -S]\n",
  "SUBLIMERS": "SUBLIMER, one who sublimes [n]\n",
  "SUBLIMES": "SUBLIME, to sublimate [v]\n",
  "SUBLIMEST": "SUBLIME, lofty [adj]\n",
  "SUBLIMINAL": "inadequate to produce a sensation or a perception [adj SUBLIMINALLY] / a subliminal message [n -S]\n",
  "SUBLIMINALLY": "SUBLIMINAL, inadequate to produce a sensation or a perception [adv]\n",
  "SUBLIMINALS": "SUBLIMINAL, a subliminal message [n]\n",
  "SUBLIMING": "the act of subliming [n -S]\n",
  "SUBLIMINGS": "SUBLIMING, the act of subliming [n]\n",
  "SUBLIMISE": "to make sublime, also SUBLIMIZE [v SUBLIMISED, SUBLIMISING, SUBLIMISES]\n",
  "SUBLIMISED": "SUBLIMISE, to make sublime, also SUBLIMIZE [v]\n",
  "SUBLIMISES": "SUBLIMISE, to make sublime, also SUBLIMIZE [v]\n",
  "SUBLIMISING": "SUBLIMISE, to make sublime, also SUBLIMIZE [v]\n",
  "SUBLIMIT": "a limit within a limit [n -S]\n",
  "SUBLIMITIES": "SUBLIMITY, the quality of being sublime [n]\n",
  "SUBLIMITS": "SUBLIMIT, a limit within a limit [n]\n",
  "SUBLIMITY": "the quality of being sublime [n SUBLIMITIES]\n",
  "SUBLIMIZE": "to make sublime, also SUBLIMISE [v SUBLIMIZED, SUBLIMIZING, SUBLIMIZES]\n",
  "SUBLIMIZED": "SUBLIMIZE, to make sublime, also SUBLIMISE [v]\n",
  "SUBLIMIZES": "SUBLIMIZE, to make sublime, also SUBLIMISE [v]\n",
  "SUBLIMIZING": "SUBLIMIZE, to make sublime, also SUBLIMISE [v]\n",
  "SUBLINE": "an inbred line within a strain [n -S]\n",
  "SUBLINEAR": "under the line; nearly linear [adj]\n",
  "SUBLINEATION": "the act of underlining [n -S]\n",
  "SUBLINEATIONS": "SUBLINEATION, the act of underlining [n]\n",
  "SUBLINES": "SUBLINE, an inbred line within a strain [n]\n",
  "SUBLINGUAL": "situated under the tongue; as, the sublingual gland [adj]\n",
  "SUBLITERACIES": "SUBLITERACY, the state of being subliterate [n]\n",
  "SUBLITERACY": "the state of being subliterate [n SUBLITERACIES]\n",
  "SUBLITERARY": "relating to or being subliterature [adj]\n",
  "SUBLITERATE": "not fully literate [adj] / one who is not fully literate [n -S]\n",
  "SUBLITERATES": "SUBLITERATE, one who is not fully literate [n]\n",
  "SUBLITERATURE": "popular writing (as mystery or adventure stories) considered inferior to standard literature [n -S]\n",
  "SUBLITERATURES": "SUBLITERATURE, popular writing (as mystery or adventure stories) considered inferior to standard literature [n]\n",
  "SUBLITTORAL": "the area lying between the shoreline and the edge of the continental shelf [n -S]\n",
  "SUBLITTORALS": "SUBLITTORAL, the area lying between the shoreline and the edge of the continental shelf [n]\n",
  "SUBLOT": "a subdivision of a lot [n -S]\n",
  "SUBLOTS": "SUBLOT, a subdivision of a lot [n]\n",
  "SUBLUNAR": "under the moon, terrestrial, also SUBLUNARY [adj]\n",
  "SUBLUNARY": "under the moon, terrestrial, also SUBLUNAR [adj]\n",
  "SUBLUNATE": "approaching the form of a crescent [adj]\n",
  "SUBLUXATE": "to partially dislocate [v SUBLUXATED, SUBLUXATING, SUBLUXATES]\n",
  "SUBLUXATED": "SUBLUXATE, to partially dislocate [v]\n",
  "SUBLUXATES": "SUBLUXATE, to partially dislocate [v]\n",
  "SUBLUXATING": "SUBLUXATE, to partially dislocate [v]\n",
  "SUBLUXATION": "an incomplete dislocation of a bone in a joint [n -S]\n",
  "SUBLUXATIONS": "SUBLUXATION, an incomplete dislocation of a bone in a joint [n]\n",
  "SUBMAN": "a primitive being [n SUBMEN]\n",
  "SUBMANAGER": "an under-manager [n -S]\n",
  "SUBMANAGERS": "SUBMANAGER, an under-manager [n]\n",
  "SUBMANDIBULAR": "a submandibular part (as an artery or bone) [n -S]\n",
  "SUBMANDIBULARS": "SUBMANDIBULAR, a submandibular part (as an artery or bone) [n]\n",
  "SUBMANIFOLD": "in mathematics, a subset of a manifold which itself has the properties of a manifold [n -S]\n",
  "SUBMANIFOLDS": "SUBMANIFOLD, in mathematics, a subset of a manifold which itself has the properties of a manifold [n]\n",
  "SUBMARGINAL": "adjacent to a margin or a marginal part or structure [adj SUBMARGINALLY]\n",
  "SUBMARGINALLY": "SUBMARGINAL, adjacent to a margin or a marginal part or structure [adv]\n",
  "SUBMARINE": "a submersible vessel [n -S] / to travel by submarine [v SUBMARINED, SUBMARINING, SUBMARINES]\n",
  "SUBMARINED": "SUBMARINE, to travel by submarine [v]\n",
  "SUBMARINER": "one who works in a submarine [n -S]\n",
  "SUBMARINERS": "SUBMARINER, one who works in a submarine [n]\n",
  "SUBMARINES": "SUBMARINE, to travel by submarine [v]\n",
  "SUBMARINING": "SUBMARINE, to travel by submarine [v]\n",
  "SUBMARKET": "a subordinate market [n -S]\n",
  "SUBMARKETS": "SUBMARKET, a subordinate market [n]\n",
  "SUBMATRICES": "SUBMATRIX, part of a matrix [n]\n",
  "SUBMATRIX": "part of a matrix [n SUBMATRIXES or SUBMATRICES]\n",
  "SUBMATRIXES": "SUBMATRIX, part of a matrix [n]\n",
  "SUBMAXILLARIES": "SUBMAXILLARY, the submaxillary gland [n]\n",
  "SUBMAXILLARY": "situated beneath the lower jaw, as in submaxillary gland, a salivary gland discharging beneath tongue [adj] / the submaxillary gland [n SUBMAXILLARIES]\n",
  "SUBMAXIMAL": "below maximal [adj]\n",
  "SUBMEDIANT": "the sixth degree of the diatonic scale, e.g. A in the scale of C major [n -S]\n",
  "SUBMEDIANTS": "SUBMEDIANT, the sixth degree of the diatonic scale, e.g. A in the scale of C major [n]\n",
  "SUBMEN": "SUBMAN, a primitive being [n]\n",
  "SUBMENTA": "SUBMENTUM, the basal part of the labium of insects [n]\n",
  "SUBMENTAL": "situated under the chin; as, the submental artery [adj]\n",
  "SUBMENTUM": "the basal part of the labium of insects [n SUBMENTA or SUBMENTUMS]\n",
  "SUBMENTUMS": "SUBMENTUM, the basal part of the labium of insects [n]\n",
  "SUBMENU": "a secondary list of options for a computer [n -S]\n",
  "SUBMENUS": "SUBMENU, a secondary list of options for a computer [n]\n",
  "SUBMERGE": "to place below the surface of a liquid, also SUBMERSE [v SUBMERGED, SUBMERGING, SUBMERGES]\n",
  "SUBMERGED": "SUBMERGE, to place below the surface of a liquid, also SUBMERSE [v]\n",
  "SUBMERGEMENT": "the state of being submerged [n -S]\n",
  "SUBMERGEMENTS": "SUBMERGEMENT, the state of being submerged [n]\n",
  "SUBMERGENCE": "the act of submerging [n -S]\n",
  "SUBMERGENCES": "SUBMERGENCE, the act of submerging [n]\n",
  "SUBMERGES": "SUBMERGE, to place below the surface of a liquid, also SUBMERSE [v]\n",
  "SUBMERGIBILITY": "the state of being submergible [n]\n",
  "SUBMERGIBLE": "a vessel used for undersea exploration or maintenance, also SUBMERSIBLE [n -S]\n",
  "SUBMERGIBLES": "SUBMERGIBLE, a vessel used for undersea exploration or maintenance, also SUBMERSIBLE [n]\n",
  "SUBMERGING": "SUBMERGE, to place below the surface of a liquid, also SUBMERSE [v]\n",
  "SUBMERSE": "to place below the surface of a liquid, also SUBMERGE [v SUBMERSED, SUBMERSING, SUBMERSES]\n",
  "SUBMERSED": "SUBMERSE, to place below the surface of a liquid, also SUBMERGE [v]\n",
  "SUBMERSES": "SUBMERSE, to place below the surface of a liquid, also SUBMERGE [v]\n",
  "SUBMERSIBILITY": "the state of being submersible [n]\n",
  "SUBMERSIBLE": "a vessel used for undersea exploration or maintenance, also SUBMERGIBLE [n -S]\n",
  "SUBMERSIBLES": "SUBMERSIBLE, a vessel used for undersea exploration or maintenance, also SUBMERGIBLE [n]\n",
  "SUBMERSING": "SUBMERSE, to place below the surface of a liquid, also SUBMERGE [v]\n",
  "SUBMERSION": "the act of submerging [n -S]\n",
  "SUBMERSIONS": "SUBMERSION, the act of submerging [n]\n",
  "SUBMETACENTRIC": "a chromosome having the centromere situated so that one chromosome arm is somewhat shorter than the other [n -S]\n",
  "SUBMETACENTRICS": "SUBMETACENTRIC, a chromosome having the centromere situated so that one chromosome arm is somewhat shorter than the other [n]\n",
  "SUBMICROGRAM": "relating to or having a mass of less than one microgram [adj]\n",
  "SUBMICRON": "a particle visible by ultramicroscope but not by the ordinary microscope [n -S]\n",
  "SUBMICRONS": "SUBMICRON, a particle visible by ultramicroscope but not by the ordinary microscope [n]\n",
  "SUBMICROSCOPIC": "too small to be seen in an ordinary light microscope [adj]\n",
  "SUBMILLIMETER": "a microscopic division of a millimetre, also SUBMILLIMETRE [n -S]\n",
  "SUBMILLIMETERS": "SUBMILLIMETER, a microscopic division of a millimetre, also SUBMILLIMETRE [n]\n",
  "SUBMILLIMETRE": "a microscopic division of a millimetre, also SUBMILLIMETER [n -S]\n",
  "SUBMILLIMETRES": "SUBMILLIMETRE, a microscopic division of a millimetre, also SUBMILLIMETER [n]\n",
  "SUBMINIATURE": "smaller than miniature [adj] / a subminiature camera or component [n -S]\n",
  "SUBMINIATURES": "SUBMINIATURE, a subminiature camera or component [n]\n",
  "SUBMINIATURISE": "to reduce to a size below miniature, also SUBMINIATURIZE [v SUBMINIATURISED, SUBMINIATURISES]\n",
  "SUBMINIATURISED": "SUBMINIATURISE, to reduce to a size below miniature, also SUBMINIATURIZE [v]\n",
  "SUBMINIATURISES": "SUBMINIATURISE, to reduce to a size below miniature, also SUBMINIATURIZE [v]\n",
  "SUBMINIATURIZE": "to reduce to a size below miniature, also SUBMINIATURISE [v SUBMINIATURIZED, SUBMINIATURIZES]\n",
  "SUBMINIATURIZED": "SUBMINIATURIZE, to reduce to a size below miniature, also SUBMINIATURISE [v]\n",
  "SUBMINIATURIZES": "SUBMINIATURIZE, to reduce to a size below miniature, also SUBMINIATURISE [v]\n",
  "SUBMINIMAL": "less than minimum necessary [adj]\n",
  "SUBMINISTER": "to supply, to administer [v -ED, -ING, -S]\n",
  "SUBMINISTERED": "SUBMINISTER, to supply, to administer [v]\n",
  "SUBMINISTERING": "SUBMINISTER, to supply, to administer [v]\n",
  "SUBMINISTERS": "SUBMINISTER, to supply, to administer [v]\n",
  "SUBMISS": "(archaic) submissive, humble [adj SUBMISSLY]\n",
  "SUBMISSIBLE": "submissive [adj]\n",
  "SUBMISSION": "the act of submitting [n -S]\n",
  "SUBMISSIONS": "SUBMISSION, the act of submitting [n]\n",
  "SUBMISSIVE": "tending to submit [adj SUBMISSIVELY]\n",
  "SUBMISSIVELY": "SUBMISSIVE, tending to submit [adv]\n",
  "SUBMISSIVENESS": "the state of being submissive [n]\n",
  "SUBMISSLY": "SUBMISS, (archaic) submissive, humble [adv]\n",
  "SUBMISSNESS": "(archaic) the state of being submiss [n -ES]\n",
  "SUBMISSNESSES": "SUBMISSNESS, (archaic) the state of being submiss [n]\n",
  "SUBMIT": "to yield to the power of another [v SUBMITTED, SUBMITTING, SUBMITS]\n",
  "SUBMITS": "SUBMIT, to yield to the power of another [v]\n",
  "SUBMITTABLE": "capable of being submitted [adj]\n",
  "SUBMITTAL": "the act of submitting [n -S]\n",
  "SUBMITTALS": "SUBMITTAL, the act of submitting [n]\n",
  "SUBMITTED": "SUBMIT, to yield to the power of another [v]\n",
  "SUBMITTER": "one who submits [n -S]\n",
  "SUBMITTERS": "SUBMITTER, one who submits [n]\n",
  "SUBMITTING": "the act of submitting [n -S]\n",
  "SUBMITTINGS": "SUBMITTING, the act of submitting [n]\n",
  "SUBMOLECULE": "a part of a molecule [n -S]\n",
  "SUBMOLECULES": "SUBMOLECULE, a part of a molecule [n]\n",
  "SUBMONTANE": "situated on or characteristic of the lower slopes of a mountain range [adj SUBMONTANELY]\n",
  "SUBMONTANELY": "SUBMONTANE, situated on or characteristic of the lower slopes of a mountain range [adv]\n",
  "SUBMUCOSA": "the connective tissue underlying a mucous membrane [n SUBMUCOSAE or SUBMUCOSAS]\n",
  "SUBMUCOSAE": "SUBMUCOSA, the connective tissue underlying a mucous membrane [n]\n",
  "SUBMUCOSAL": "relating to the submucosa, the connective tissue underlying a mucous membrane [adj]\n",
  "SUBMUCOSAS": "SUBMUCOSA, the connective tissue underlying a mucous membrane [n]\n",
  "SUBMUCOUS": "situated under a mucous membrane [adj]\n",
  "SUBMULTIPLE": "a quantity that divides into another exactly [n -S]\n",
  "SUBMULTIPLES": "SUBMULTIPLE, a quantity that divides into another exactly [n]\n",
  "SUBMUNITION": "any of a group of smaller weapons carried as a warhead by a missile or projectile and expelled as the carrier approaches its target [n -S]\n",
  "SUBMUNITIONS": "SUBMUNITION, any of a group of smaller weapons carried as a warhead by a missile or projectile and expelled as the carrier approaches its target [n]\n",
  "SUBNASAL": "situated under the nose [adj]\n",
  "SUBNASCENT": "growing up from beneath [adj]\n",
  "SUBNATIONAL": "below the level of national [adj]\n",
  "SUBNATURAL": "almost natural [adj]\n",
  "SUBNET": "a system contained within a communications system [n -S]\n",
  "SUBNETS": "SUBNET, a system contained within a communications system [n]\n",
  "SUBNETWORK": "a subdivision of a network [n -S] / to use a subnetwork [v -ED, -ING, -S]\n",
  "SUBNETWORKED": "SUBNETWORK, to use a subnetwork [v]\n",
  "SUBNETWORKING": "SUBNETWORK, to use a subnetwork [v]\n",
  "SUBNETWORKS": "SUBNETWORK, a subdivision of a network [n]\n",
  "SUBNEURAL": "situated beneath a main neural axis [adj]\n",
  "SUBNICHE": "a subdivision of a habitat [n -S]\n",
  "SUBNICHES": "SUBNICHE, a subdivision of a habitat [n]\n",
  "SUBNIVEAL": "under snow, also SUBNIVEAN [adj]\n",
  "SUBNIVEAN": "under snow, also SUBNIVEAL [adj]\n",
  "SUBNODAL": "situated under a node [adj]\n",
  "SUBNORMAL": "below normal [adj SUBNORMALLY] / one who is subnormal [n -S]\n",
  "SUBNORMALITIES": "SUBNORMALITY, the state of being subnormal [n]\n",
  "SUBNORMALITY": "the state of being subnormal [n SUBNORMALITIES]\n",
  "SUBNORMALLY": "SUBNORMAL, below normal [adv]\n",
  "SUBNORMALS": "SUBNORMAL, one who is subnormal [n]\n",
  "SUBNUCLEAR": "of, relating to, or being a particle smaller than the atomic nucleus [adj]\n",
  "SUBNUCLEI": "SUBNUCLEUS, a secondary nucleus [n]\n",
  "SUBNUCLEUS": "a secondary nucleus [n SUBNUCLEI or SUBNUCLEUSES]\n",
  "SUBNUCLEUSES": "SUBNUCLEUS, a secondary nucleus [n]\n",
  "SUBOCCIPITAL": "below the occiput [adj]\n",
  "SUBOCEAN": "beneath the ocean [adj]\n",
  "SUBOCEANIC": "below the ocean [adj]\n",
  "SUBOCTAVE": "the octave below [n -S]\n",
  "SUBOCTAVES": "SUBOCTAVE, the octave below [n]\n",
  "SUBOCTUPLE": "containing one part of eight; having the ratio of one to eight [adj]\n",
  "SUBOCULAR": "situated under, or on the ventral side of, the eye [adj]\n",
  "SUBOFFICE": "part of an office [n -S]\n",
  "SUBOFFICER": "an under or subordinate officer [n -S]\n",
  "SUBOFFICERS": "SUBOFFICER, an under or subordinate officer [n]\n",
  "SUBOFFICES": "SUBOFFICE, part of an office [n]\n",
  "SUBOPERCULA": "SUBOPERCULUM, in fishes, a bone below and partly behind the gill cover [n]\n",
  "SUBOPERCULAR": "related to the suboperculum, in fishes, a bone below and partly behind the gill cover [adj]\n",
  "SUBOPERCULUM": "in fishes, a bone below and partly behind the gill cover [n SUBOPERCULA or SUBOPERCULUMS]\n",
  "SUBOPERCULUMS": "SUBOPERCULUM, in fishes, a bone below and partly behind the gill cover [n]\n",
  "SUBOPTIC": "situated under the eyes [adj]\n",
  "SUBOPTIMAL": "less than optimal [adj]\n",
  "SUBOPTIMISATION": "the process of suboptimising, also SUBOPTIMIZATION [n]\n",
  "SUBOPTIMISE": "to optimize to an inferior degree, also SUBOPTIMIZE [v SUBOPTIMISED, SUBOPTIMISING, SUBOPTIMISES]\n",
  "SUBOPTIMISED": "SUBOPTIMISE, to optimize to an inferior degree, also SUBOPTIMIZE [v]\n",
  "SUBOPTIMISES": "SUBOPTIMISE, to optimize to an inferior degree, also SUBOPTIMIZE [v]\n",
  "SUBOPTIMISING": "SUBOPTIMISE, to optimize to an inferior degree, also SUBOPTIMIZE [v]\n",
  "SUBOPTIMIZATION": "the process of suboptimizing, also SUBOPTIMISATION [n]\n",
  "SUBOPTIMIZE": "to optimize to an inferior degree, also SUBOPTIMISE [v SUBOPTIMIZED, SUBOPTIMIZING, SUBOPTIMIZES]\n",
  "SUBOPTIMIZED": "SUBOPTIMIZE, to optimize to an inferior degree, also SUBOPTIMISE [v]\n",
  "SUBOPTIMIZES": "SUBOPTIMIZE, to optimize to an inferior degree, also SUBOPTIMISE [v]\n",
  "SUBOPTIMIZING": "SUBOPTIMIZE, to optimize to an inferior degree, also SUBOPTIMISE [v]\n",
  "SUBOPTIMUM": "something that is less than optimal [n -S]\n",
  "SUBOPTIMUMS": "SUBOPTIMUM, something that is less than optimal [n]\n",
  "SUBORAL": "situated under the mouth [adj]\n",
  "SUBORBICULAR": "almost orbicular, nearly circular [adj]\n",
  "SUBORBITAL": "below the orbit of the eyes [adj]\n",
  "SUBORDER": "a category of related families within an order [n -S]\n",
  "SUBORDERS": "SUBORDER, a category of related families within an order [n]\n",
  "SUBORDINAL": "almost ordinal [adj]\n",
  "SUBORDINANCIES": "SUBORDINANCY, subordination [n]\n",
  "SUBORDINANCY": "subordination [n SUBORDINANCIES]\n",
  "SUBORDINARIES": "SUBORDINARY, any of several heraldic bearings of secondary importance to the ordinary, such as the lozenge and the orle [n]\n",
  "SUBORDINARY": "any of several heraldic bearings of secondary importance to the ordinary, such as the lozenge and the orle [n SUBORDINARIES]\n",
  "SUBORDINATE": "subservient [adj SUBORDINATELY] / to make subject or subservient [v SUBORDINATED, SUBORDINATING, SUBORDINATES]\n",
  "SUBORDINATED": "SUBORDINATE, to make subject or subservient [v]\n",
  "SUBORDINATELY": "SUBORDINATE, subservient [adv]\n",
  "SUBORDINATENESS": "the state of being subordinate [n]\n",
  "SUBORDINATES": "SUBORDINATE, to make subject or subservient [v]\n",
  "SUBORDINATING": "SUBORDINATE, to make subject or subservient [v]\n",
  "SUBORDINATION": "the act of subordinating or placing in a lower order [n -S]\n",
  "SUBORDINATIONS": "SUBORDINATION, the act of subordinating or placing in a lower order [n]\n",
  "SUBORDINATIVE": "containing a subordinate clause or clauses [adj]\n",
  "SUBORDINATOR": "one that subordinates [n -S]\n",
  "SUBORDINATORS": "SUBORDINATOR, one that subordinates [n]\n",
  "SUBORGANISATION": "a subsidiary part of an organisation, also SUBORGANIZATION [n]\n",
  "SUBORGANIZATION": "a subsidiary part of an organisation, also SUBORGANISATION [n]\n",
  "SUBORN": "to induce to commit perjury [v -ED, -ING, -S]\n",
  "SUBORNATION": "the act of suborning [n -S]\n",
  "SUBORNATIONS": "SUBORNATION, the act of suborning [n]\n",
  "SUBORNATIVE": "serving to suborn [adj]\n",
  "SUBORNED": "SUBORN, to induce to commit perjury [v]\n",
  "SUBORNER": "one who suborns [n -S]\n",
  "SUBORNERS": "SUBORNER, one who suborns [n]\n",
  "SUBORNING": "SUBORN, to induce to commit perjury [v]\n",
  "SUBORNS": "SUBORN, to induce to commit perjury [v]\n",
  "SUBOSCINE": "a member of a certain subfamily of birds [n -S]\n",
  "SUBOSCINES": "SUBOSCINE, a member of a certain subfamily of birds [n]\n",
  "SUBOVAL": "nearly oval [adj]\n",
  "SUBOVATE": "nearly ovate [adj]\n",
  "SUBOXIDE": "an oxide containing little oxygen [n -S]\n",
  "SUBOXIDES": "SUBOXIDE, an oxide containing little oxygen [n]\n",
  "SUBPANATION": "the doctrine that the body and blood of Christ are locally and materially present in the Eucharist [n -S]\n",
  "SUBPANATIONS": "SUBPANATION, the doctrine that the body and blood of Christ are locally and materially present in the Eucharist [n]\n",
  "SUBPANEL": "a subdivision of a panel [n -S]\n",
  "SUBPANELS": "SUBPANEL, a subdivision of a panel [n]\n",
  "SUBPAR": "below par [adj]\n",
  "SUBPARAGRAPH": "a subdivision of a paragraph [n -S]\n",
  "SUBPARAGRAPHS": "SUBPARAGRAPH, a subdivision of a paragraph [n]\n",
  "SUBPARALLEL": "almost parallel [adj]\n",
  "SUBPART": "a subdivision of a part [n -S]\n",
  "SUBPARTS": "SUBPART, a subdivision of a part [n]\n",
  "SUBPENA": "(Latin) to summon with a type of judicial writ, also SUBPOENA [v -ED, -ING, -S]\n",
  "SUBPENAED": "SUBPENA, (Latin) to summon with a type of judicial writ, also SUBPOENA [v]\n",
  "SUBPENAING": "SUBPENA, (Latin) to summon with a type of judicial writ, also SUBPOENA [v]\n",
  "SUBPENAS": "SUBPENA, (Latin) to summon with a type of judicial writ, also SUBPOENA [v]\n",
  "SUBPERIOD": "part of a period [n -S]\n",
  "SUBPERIODS": "SUBPERIOD, part of a period [n]\n",
  "SUBPHASE": "a subdivision of a phase [n -S]\n",
  "SUBPHASES": "SUBPHASE, a subdivision of a phase [n]\n",
  "SUBPHRENIC": "placed below the midriff [adj]\n",
  "SUBPHYLA": "SUBPHYLUM, (Latin) the taxonomic division below a phylum [n]\n",
  "SUBPHYLAR": "relating to a subphylum [adj]\n",
  "SUBPHYLUM": "(Latin) the taxonomic division below a phylum [n SUBPHYLA or SUBPHYLUMS]\n",
  "SUBPHYLUMS": "SUBPHYLUM, (Latin) the taxonomic division below a phylum [n]\n",
  "SUBPLOT": "a subordinate plot in a novel etc. [n -S]\n",
  "SUBPLOTS": "SUBPLOT, a subordinate plot in a novel etc. [n]\n",
  "SUBPOENA": "(Latin) to summon with a type of judicial writ, also SUBPENA [v -ED, -ING, -S]\n",
  "SUBPOENAED": "SUBPOENA, (Latin) to summon with a type of judicial writ, also SUBPENA [v]\n",
  "SUBPOENAING": "SUBPOENA, (Latin) to summon with a type of judicial writ, also SUBPENA [v]\n",
  "SUBPOENAS": "SUBPOENA, (Latin) to summon with a type of judicial writ, also SUBPENA [v]\n",
  "SUBPOLAR": "situated just outside the polar circles [adj]\n",
  "SUBPOPULATION": "an identifiable fraction or subdivision of a population [n -S]\n",
  "SUBPOPULATIONS": "SUBPOPULATION, an identifiable fraction or subdivision of a population [n]\n",
  "SUBPOTENCIES": "SUBPOTENCY, the state (in a drug) of being subpotent, having less than normal potency [n]\n",
  "SUBPOTENCY": "the state (in a drug) of being subpotent, having less than normal potency [n SUBPOTENCIES]\n",
  "SUBPOTENT": "of drugs, less potent than normal [adj]\n",
  "SUBPREFECT": "one ranking below a prefect [n -S]\n",
  "SUBPREFECTS": "SUBPREFECT, one ranking below a prefect [n]\n",
  "SUBPREFECTURE": "the office of subprefect [n -S]\n",
  "SUBPREFECTURES": "SUBPREFECTURE, the office of subprefect [n]\n",
  "SUBPRIMATE": "one ranked below a primate [n -S]\n",
  "SUBPRIMATES": "SUBPRIMATE, one ranked below a primate [n]\n",
  "SUBPRIME": "a loan made to a borrower with a poor credit rating, usually at a high rate of interest [n -S]\n",
  "SUBPRIMES": "SUBPRIME, a loan made to a borrower with a poor credit rating, usually at a high rate of interest [n]\n",
  "SUBPRINCIPAL": "an assistant principal, as of a school [n -S]\n",
  "SUBPRINCIPALS": "SUBPRINCIPAL, an assistant principal, as of a school [n]\n",
  "SUBPRIOR": "the vicegerent of a prior; a claustral officer who assists the prior [n -S]\n",
  "SUBPRIORESS": "an assistant prioress [n -ES]\n",
  "SUBPRIORESSES": "SUBPRIORESS, an assistant prioress [n]\n",
  "SUBPRIORS": "SUBPRIOR, the vicegerent of a prior; a claustral officer who assists the prior [n]\n",
  "SUBPROBLEM": "a subdivision of a problem [n -S]\n",
  "SUBPROBLEMS": "SUBPROBLEM, a subdivision of a problem [n]\n",
  "SUBPROCESS": "part of a process [n -ES]\n",
  "SUBPROCESSES": "SUBPROCESS, part of a process [n]\n",
  "SUBPRODUCT": "a subsidiary product [n -S]\n",
  "SUBPRODUCTS": "SUBPRODUCT, a subsidiary product [n]\n",
  "SUBPROFESSIONAL": "functioning or qualified to function below the professional level but distinctly above the clerical or labor level and usually under the supervision of a professionally trained person [adj]\n",
  "SUBPROGRAM": "a subpart of a program [n -S]\n",
  "SUBPROGRAMS": "SUBPROGRAM, a subpart of a program [n]\n",
  "SUBPROJECT": "part of a project [n -S]\n",
  "SUBPROJECTS": "SUBPROJECT, part of a project [n]\n",
  "SUBPROLETARIAT": "the social class below the proletariat [n -S]\n",
  "SUBPROLETARIATS": "SUBPROLETARIAT, the social class below the proletariat [n]\n",
  "SUBPUBIC": "situated under the pubis [adj]\n",
  "SUBRACE": "a subdivision of a race [n -S]\n",
  "SUBRACES": "SUBRACE, a subdivision of a race [n]\n",
  "SUBRATIONAL": "less than rational [adj]\n",
  "SUBREFERENCE": "an incomplete or surreptitious reference [n -S]\n",
  "SUBREFERENCES": "SUBREFERENCE, an incomplete or surreptitious reference [n]\n",
  "SUBREGION": "part of a region [n -S]\n",
  "SUBREGIONAL": "relating to a subregion [adj]\n",
  "SUBREGIONS": "SUBREGION, part of a region [n]\n",
  "SUBRENT": "to sublet or rent out (a property that is already rented) [v -ED, -ING, -S]\n",
  "SUBRENTED": "SUBRENT, to sublet or rent out (a property that is already rented) [v]\n",
  "SUBRENTING": "SUBRENT, to sublet or rent out (a property that is already rented) [v]\n",
  "SUBRENTS": "SUBRENT, to sublet or rent out (a property that is already rented) [v]\n",
  "SUBREPTION": "a deliberate misrepresentation; an inference drawn from it [n -S]\n",
  "SUBREPTIONS": "SUBREPTION, a deliberate misrepresentation; an inference drawn from it [n]\n",
  "SUBREPTITIOUS": "fraudulently obtained; surreptitious [adj SUBREPTITIOUSLY]\n",
  "SUBREPTITIOUSLY": "SUBREPTITIOUS, fraudulently obtained; surreptitious [adv]\n",
  "SUBREPTIVE": "surreptitious [adj]\n",
  "SUBRING": "a subset of a mathematical ring [n -S]\n",
  "SUBRINGS": "SUBRING, a subset of a mathematical ring [n]\n",
  "SUBROGATE": "to substitute for another with regard to a legal right or claim [v SUBROGATED, SUBROGATING, SUBROGATES]\n",
  "SUBROGATED": "SUBROGATE, to substitute for another with regard to a legal right or claim [v]\n",
  "SUBROGATES": "SUBROGATE, to substitute for another with regard to a legal right or claim [v]\n",
  "SUBROGATING": "SUBROGATE, to substitute for another with regard to a legal right or claim [v]\n",
  "SUBROGATION": "the act of subrogating, also SURROGATION [n -S]\n",
  "SUBROGATIONS": "SUBROGATION, the act of subrogating, also SURROGATION [n]\n",
  "SUBROUTINE": "a subordinate routine [n -S]\n",
  "SUBROUTINES": "SUBROUTINE, a subordinate routine [n]\n",
  "SUBRULE": "a subordinate rule [n -S]\n",
  "SUBRULES": "SUBRULE, a subordinate rule [n]\n",
  "SUBS": "SUB, to act as a substitute [v]\n",
  "SUBSACRAL": "situated under, or on the ventral side of, the sacrum [adj]\n",
  "SUBSALE": "a resale of purchased goods [n -S]\n",
  "SUBSALES": "SUBSALE, a resale of purchased goods [n]\n",
  "SUBSAMPLE": "a part of a sample [n -S] / to create a subsample [v SUBSAMPLED, SUBSAMPLING, SUBSAMPLES]\n",
  "SUBSAMPLED": "SUBSAMPLE, to create a subsample [v]\n",
  "SUBSAMPLES": "SUBSAMPLE, to create a subsample [v]\n",
  "SUBSAMPLING": "SUBSAMPLE, to create a subsample [v]\n",
  "SUBSATELLITE": "an object carried into orbit in and subsequently released from a satellite or spacecraft [n -S]\n",
  "SUBSATELLITES": "SUBSATELLITE, an object carried into orbit in and subsequently released from a satellite or spacecraft [n]\n",
  "SUBSATURATED": "incompletely saturated [adj]\n",
  "SUBSATURATION": "a state of incomplete saturation [n -S]\n",
  "SUBSATURATIONS": "SUBSATURATION, a state of incomplete saturation [n]\n",
  "SUBSCALE": "a subdivision of a scale [n -S]\n",
  "SUBSCALES": "SUBSCALE, a subdivision of a scale [n]\n",
  "SUBSCAPULAR": "below (in man in front of) the shoulder-blade [adj] / a subscapular vessel or nerve [n -S]\n",
  "SUBSCAPULARS": "SUBSCAPULAR, a subscapular vessel or nerve [n]\n",
  "SUBSCHEMA": "part of a schema [n SUBSCHEMATA]\n",
  "SUBSCHEMATA": "SUBSCHEMA, part of a schema [n]\n",
  "SUBSCIENCE": "a branch of a science [n -S]\n",
  "SUBSCIENCES": "SUBSCIENCE, a branch of a science [n]\n",
  "SUBSCRIBABLE": "capable of being subscribed to [adj]\n",
  "SUBSCRIBE": "to write underneath, as one's name; to sign (one's name) to a document [v SUBSCRIBED, SUBSCRIBING, SUBSCRIBES]\n",
  "SUBSCRIBED": "SUBSCRIBE, to write underneath, as one's name; to sign (one's name) to a document [v]\n",
  "SUBSCRIBER": "one who subscribes [n -S]\n",
  "SUBSCRIBERS": "SUBSCRIBER, one who subscribes [n]\n",
  "SUBSCRIBES": "SUBSCRIBE, to write underneath, as one's name; to sign (one's name) to a document [v]\n",
  "SUBSCRIBING": "the act of taking out a subscription [n -S]\n",
  "SUBSCRIBINGS": "SUBSCRIBING, the act of taking out a subscription [n]\n",
  "SUBSCRIPT": "a number or letter written below or underneath; as, iota subscript [n -S]\n",
  "SUBSCRIPTION": "an autograph signature [n -S]\n",
  "SUBSCRIPTIONS": "SUBSCRIPTION, an autograph signature [n]\n",
  "SUBSCRIPTIVE": "relating to subscription [adj]\n",
  "SUBSCRIPTS": "SUBSCRIPT, a number or letter written below or underneath; as, iota subscript [n]\n",
  "SUBSEA": "situated below the surface of the sea [adj]\n",
  "SUBSECIVE": "remaining over; spare [adj]\n",
  "SUBSECRETARIES": "SUBSECRETARY, a subordinate secretary [n]\n",
  "SUBSECRETARY": "a subordinate secretary [n SUBSECRETARIES]\n",
  "SUBSECT": "a sect directly derived from another [n -S]\n",
  "SUBSECTION": "a subdivision or a subordinate division of a section [n -S]\n",
  "SUBSECTIONS": "SUBSECTION, a subdivision or a subordinate division of a section [n]\n",
  "SUBSECTOR": "part of a sector [n -S]\n",
  "SUBSECTORS": "SUBSECTOR, part of a sector [n]\n",
  "SUBSECTS": "SUBSECT, a sect directly derived from another [n]\n",
  "SUBSEGMENT": "a subdivision of a segment [n -S]\n",
  "SUBSEGMENTS": "SUBSEGMENT, a subdivision of a segment [n]\n",
  "SUBSEIZURE": "a subsidiary seizure [n -S]\n",
  "SUBSEIZURES": "SUBSEIZURE, a subsidiary seizure [n]\n",
  "SUBSELLIA": "SUBSELLIUM, one of the stalls of the lower range where there are two ranges [n]\n",
  "SUBSELLIUM": "one of the stalls of the lower range where there are two ranges [n SUBSELLIA]\n",
  "SUBSENSE": "a subdivision of a sense [n -S]\n",
  "SUBSENSES": "SUBSENSE, a subdivision of a sense [n]\n",
  "SUBSENSIBLE": "below the range of sense [adj]\n",
  "SUBSENTENCE": "part of a sentence [n -S]\n",
  "SUBSENTENCES": "SUBSENTENCE, part of a sentence [n]\n",
  "SUBSEQUENCE": "the state of being subsequent [n -S]\n",
  "SUBSEQUENCES": "SUBSEQUENCE, the state of being subsequent [n]\n",
  "SUBSEQUENT": "happening after [adj SUBSEQUENTLY] / something subsequent [n -S]\n",
  "SUBSEQUENTIAL": "subsequent [adj]\n",
  "SUBSEQUENTLY": "SUBSEQUENT, happening after [adv]\n",
  "SUBSEQUENTNESS": "the state of being subsequent [n]\n",
  "SUBSEQUENTS": "SUBSEQUENT, something subsequent [n]\n",
  "SUBSERE": "a type of ecological succession [n -S]\n",
  "SUBSERES": "SUBSERE, a type of ecological succession [n]\n",
  "SUBSERIES": "a subdivision of a series [n SUBSERIES]\n",
  "SUBSERVE": "to help forward [v SUBSERVED, SUBSERVING, SUBSERVES]\n",
  "SUBSERVED": "SUBSERVE, to help forward [v]\n",
  "SUBSERVES": "SUBSERVE, to help forward [v]\n",
  "SUBSERVIENCE": "the state of being subservient, also SUBSERVIENCY [n -S]\n",
  "SUBSERVIENCES": "SUBSERVIENCE, the state of being subservient, also SUBSERVIENCY [n]\n",
  "SUBSERVIENCIES": "SUBSERVIENCY, the state of being subservient, also SUBSERVIENCE [n]\n",
  "SUBSERVIENCY": "the state of being subservient, also SUBSERVIENCE [n SUBSERVIENCIES]\n",
  "SUBSERVIENT": "useful in an inferior capacity [adj SUBSERVIENTLY] / one who is subservient [n -S]\n",
  "SUBSERVIENTLY": "SUBSERVIENT, useful in an inferior capacity [adv]\n",
  "SUBSERVIENTS": "SUBSERVIENT, one who is subservient [n]\n",
  "SUBSERVING": "SUBSERVE, to help forward [v]\n",
  "SUBSESSILE": "almost sessile [adj]\n",
  "SUBSET": "a mathematical set contained within a larger set [n -S]\n",
  "SUBSETS": "SUBSET, a mathematical set contained within a larger set [n]\n",
  "SUBSHAFT": "a shaft that is beneath another shaft [n -S]\n",
  "SUBSHAFTS": "SUBSHAFT, a shaft that is beneath another shaft [n]\n",
  "SUBSHELL": "one of the orbitals making up an electron shell of an atom [n -S]\n",
  "SUBSHELLS": "SUBSHELL, one of the orbitals making up an electron shell of an atom [n]\n",
  "SUBSHRUB": "a low shrub [n -S]\n",
  "SUBSHRUBBY": "like a subshrub, a low shrub [adj]\n",
  "SUBSHRUBS": "SUBSHRUB, a low shrub [n]\n",
  "SUBSIDE": "to sink to a lower or normal level [v SUBSIDED, SUBSIDING, SUBSIDES]\n",
  "SUBSIDED": "SUBSIDE, to sink to a lower or normal level [v]\n",
  "SUBSIDENCE": "the act of subsiding, also SUBSIDENCY [n -S]\n",
  "SUBSIDENCES": "SUBSIDENCE, the act of subsiding, also SUBSIDENCY [n]\n",
  "SUBSIDENCIES": "SUBSIDENCY, the act of subsiding, also SUBSIDENCE [n]\n",
  "SUBSIDENCY": "the act of subsiding, also SUBSIDENCE [n SUBSIDENCIES]\n",
  "SUBSIDER": "something or someone that subsides [n -S]\n",
  "SUBSIDERS": "SUBSIDER, something or someone that subsides [n]\n",
  "SUBSIDES": "SUBSIDE, to sink to a lower or normal level [v]\n",
  "SUBSIDIARIAT": "a collective term for the news sources that would not survive without being subsidized directly (by a government, etc.) [n -S]\n",
  "SUBSIDIARIATS": "SUBSIDIARIAT, a collective term for the news sources that would not survive without being subsidized directly (by a government, etc.) [n]\n",
  "SUBSIDIARIES": "SUBSIDIARY, one that is subsidiary [n]\n",
  "SUBSIDIARILY": "SUBSIDIARY, subordinate [adv]\n",
  "SUBSIDIARINESS": "the state of being subsidiary [n]\n",
  "SUBSIDIARITIES": "SUBSIDIARITY, the state of being subsidiary [n]\n",
  "SUBSIDIARITY": "the state of being subsidiary [n SUBSIDIARITIES]\n",
  "SUBSIDIARY": "subordinate [adj SUBSIDIARILY] / one that is subsidiary [n SUBSIDIARIES]\n",
  "SUBSIDIES": "SUBSIDY, a grant or contribution of money [n]\n",
  "SUBSIDING": "SUBSIDE, to sink to a lower or normal level [v]\n",
  "SUBSIDISABLE": "capable of being subsidised, also SUBSIDIZABLE [adj]\n",
  "SUBSIDISATION": "the act of subsidising, also SUBSIDIZATION [n -S]\n",
  "SUBSIDISATIONS": "SUBSIDISATION, the act of subsidising, also SUBSIDIZATION [n]\n",
  "SUBSIDISE": "to furnish with a subsidy, also SUBSIDIZE [v SUBSIDISED, SUBSIDISING, SUBSIDISES]\n",
  "SUBSIDISED": "SUBSIDISE, to furnish with a subsidy, also SUBSIDIZE [v]\n",
  "SUBSIDISER": "one who subsidises, also SUBSIDIZER [n -S]\n",
  "SUBSIDISERS": "SUBSIDISER, one who subsidises, also SUBSIDIZER [n]\n",
  "SUBSIDISES": "SUBSIDISE, to furnish with a subsidy, also SUBSIDIZE [v]\n",
  "SUBSIDISING": "SUBSIDISE, to furnish with a subsidy, also SUBSIDIZE [v]\n",
  "SUBSIDIZABLE": "capable of being subsidized, also SUBSIDISABLE [adj]\n",
  "SUBSIDIZATION": "the act of subsidizing, also SUBSIDISATION [n -S]\n",
  "SUBSIDIZATIONS": "SUBSIDIZATION, the act of subsidizing, also SUBSIDISATION [n]\n",
  "SUBSIDIZE": "to furnish with a subsidy, also SUBSIDISE [v SUBSIDIZED, SUBSIDIZING, SUBSIDIZES]\n",
  "SUBSIDIZED": "SUBSIDIZE, to furnish with a subsidy, also SUBSIDISE [v]\n",
  "SUBSIDIZER": "one who subsidizes, also SUBSIDISER [n -S]\n",
  "SUBSIDIZERS": "SUBSIDIZER, one who subsidizes, also SUBSIDISER [n]\n",
  "SUBSIDIZES": "SUBSIDIZE, to furnish with a subsidy, also SUBSIDISE [v]\n",
  "SUBSIDIZING": "SUBSIDIZE, to furnish with a subsidy, also SUBSIDISE [v]\n",
  "SUBSIDY": "a grant or contribution of money [n SUBSIDIES]\n",
  "SUBSIST": "to continue to exist [v -ED, -ING, -S]\n",
  "SUBSISTED": "SUBSIST, to continue to exist [v]\n",
  "SUBSISTENCE": "the minimum (as of food and shelter) necessary to support life [n -S]\n",
  "SUBSISTENCES": "SUBSISTENCE, the minimum (as of food and shelter) necessary to support life [n]\n",
  "SUBSISTENT": "having real being; as, a subsistent spirit [adj]\n",
  "SUBSISTENTIAL": "relating to subsistence [adj]\n",
  "SUBSISTER": "one who subsists [n -S]\n",
  "SUBSISTERS": "SUBSISTER, one who subsists [n]\n",
  "SUBSISTING": "SUBSIST, to continue to exist [v]\n",
  "SUBSISTS": "SUBSIST, to continue to exist [v]\n",
  "SUBSITE": "a division of a site [n -S]\n",
  "SUBSITES": "SUBSITE, a division of a site [n]\n",
  "SUBSIZAR": "a student of lower rank than a sizar [n -S]\n",
  "SUBSIZARS": "SUBSIZAR, a student of lower rank than a sizar [n]\n",
  "SUBSKILL": "a subordinate skill [n -S]\n",
  "SUBSKILLS": "SUBSKILL, a subordinate skill [n]\n",
  "SUBSOCIAL": "tending to associate gregariously but lacking a fixed social structure [adj SUBSOCIALLY]\n",
  "SUBSOCIALLY": "SUBSOCIAL, tending to associate gregariously but lacking a fixed social structure [adv]\n",
  "SUBSOCIETIES": "SUBSOCIETY, a subdivision of a society [n]\n",
  "SUBSOCIETY": "a subdivision of a society [n SUBSOCIETIES]\n",
  "SUBSOIL": "to plow the layer of earth below the surface [v -ED, -ING, -S]\n",
  "SUBSOILED": "SUBSOIL, to plow the layer of earth below the surface [v]\n",
  "SUBSOILER": "a plough for subsoiling [n -S]\n",
  "SUBSOILERS": "SUBSOILER, a plough for subsoiling [n]\n",
  "SUBSOILING": "the act of ploughing the subsoil [n -S]\n",
  "SUBSOILINGS": "SUBSOILING, the act of ploughing the subsoil [n]\n",
  "SUBSOILS": "SUBSOIL, to plow the layer of earth below the surface [v]\n",
  "SUBSOLAR": "directly under the sun, as a point on the earth's surface where the sun is vertically overhead [adj]\n",
  "SUBSONG": "a bird's undersong [n -S]\n",
  "SUBSONGS": "SUBSONG, a bird's undersong [n]\n",
  "SUBSONIC": "moving at a speed less than that of sound [adj SUBSONICALLY]\n",
  "SUBSONICALLY": "SUBSONIC, moving at a speed less than that of sound [adv]\n",
  "SUBSPACE": "a subset of a mathematical space [n -S]\n",
  "SUBSPACES": "SUBSPACE, a subset of a mathematical space [n]\n",
  "SUBSPECIALISE": "to practise a subspecialty, also SUBSPECIALIZE [v SUBSPECIALISED, SUBSPECIALISING, SUBSPECIALISES]\n",
  "SUBSPECIALISED": "SUBSPECIALISE, to practise a subspecialty, also SUBSPECIALIZE [v]\n",
  "SUBSPECIALISES": "SUBSPECIALISE, to practise a subspecialty, also SUBSPECIALIZE [v]\n",
  "SUBSPECIALISING": "SUBSPECIALISE, to practise a subspecialty, also SUBSPECIALIZE [v]\n",
  "SUBSPECIALIST": "one who practises a subspecialty [n -S]\n",
  "SUBSPECIALISTS": "SUBSPECIALIST, one who practises a subspecialty [n]\n",
  "SUBSPECIALITIES": "SUBSPECIALITY, a subordinate speciality, also SUBSPECIALTY [n]\n",
  "SUBSPECIALITY": "a subordinate speciality, also SUBSPECIALTY [n SUBSPECIALITIES]\n",
  "SUBSPECIALIZE": "to practise a subspecialty, also SUBSPECIALISE [v SUBSPECIALIZED, SUBSPECIALIZING, SUBSPECIALIZES]\n",
  "SUBSPECIALIZED": "SUBSPECIALIZE, to practise a subspecialty, also SUBSPECIALISE [v]\n",
  "SUBSPECIALIZES": "SUBSPECIALIZE, to practise a subspecialty, also SUBSPECIALISE [v]\n",
  "SUBSPECIALIZING": "SUBSPECIALIZE, to practise a subspecialty, also SUBSPECIALISE [v]\n",
  "SUBSPECIALTIES": "SUBSPECIALTY, a subordinate specialty, also SUBSPECIALITY [n]\n",
  "SUBSPECIALTY": "a subordinate specialty, also SUBSPECIALITY [n SUBSPECIALTIES]\n",
  "SUBSPECIES": "a population whose characteristics are subtly distinct from the nominate form [n SUBSPECIES]\n",
  "SUBSPECIFIC": "relating to a subspecies [adj SUBSPECIFICALLY]\n",
  "SUBSPECIFICALLY": "SUBSPECIFIC, relating to a subspecies [adv]\n",
  "SUBSPINOUS": "subvertebral [adj]\n",
  "SUBSPONTANEOUS": "less than spontaneous [adj]\n",
  "SUBSTAGE": "a part of a microscope for supporting accessories [n -S]\n",
  "SUBSTAGES": "SUBSTAGE, a part of a microscope for supporting accessories [n]\n",
  "SUBSTANCE": "something in which qualities or attributes exist [n -S]\n",
  "SUBSTANCELESS": "without substance [adj]\n",
  "SUBSTANCES": "SUBSTANCE, something in which qualities or attributes exist [n]\n",
  "SUBSTANDARD": "deviating from or falling short of a standard or norm [adj]\n",
  "SUBSTANTIAL": "consisting of or relating to substance [adj SUBSTANTIALLY] / something of substance [n -S]\n",
  "SUBSTANTIALISE": "to make substantial, also SUBSTANTIALIZE [v SUBSTANTIALISED, SUBSTANTIALISES]\n",
  "SUBSTANTIALISED": "SUBSTANTIALISE, to make substantial, also SUBSTANTIALIZE [v]\n",
  "SUBSTANTIALISES": "SUBSTANTIALISE, to make substantial, also SUBSTANTIALIZE [v]\n",
  "SUBSTANTIALISM": "the belief that there is a real existence underlying phenomena [n -S]\n",
  "SUBSTANTIALISMS": "SUBSTANTIALISM, the belief that there is a real existence underlying phenomena [n]\n",
  "SUBSTANTIALIST": "a believer in substantialism, the belief that there is a real existence underlying phenomena [n -S]\n",
  "SUBSTANTIALISTS": "SUBSTANTIALIST, a believer in substantialism, the belief that there is a real existence underlying phenomena [n]\n",
  "SUBSTANTIALITY": "the state of being substantial [n]\n",
  "SUBSTANTIALIZE": "to make substantial, also SUBSTANTIALISE [v SUBSTANTIALIZED, SUBSTANTIALIZES]\n",
  "SUBSTANTIALIZED": "SUBSTANTIALIZE, to make substantial, also SUBSTANTIALISE [v]\n",
  "SUBSTANTIALIZES": "SUBSTANTIALIZE, to make substantial, also SUBSTANTIALISE [v]\n",
  "SUBSTANTIALLY": "SUBSTANTIAL, consisting of or relating to substance [adv]\n",
  "SUBSTANTIALNESS": "the state of being substantial [n]\n",
  "SUBSTANTIALS": "SUBSTANTIAL, something of substance [n]\n",
  "SUBSTANTIATE": "to give substance or form to [v SUBSTANTIATED, SUBSTANTIATING, SUBSTANTIATES]\n",
  "SUBSTANTIATED": "SUBSTANTIATE, to give substance or form to [v]\n",
  "SUBSTANTIATES": "SUBSTANTIATE, to give substance or form to [v]\n",
  "SUBSTANTIATING": "SUBSTANTIATE, to give substance or form to [v]\n",
  "SUBSTANTIATION": "the act of substantiating [n -S]\n",
  "SUBSTANTIATIONS": "SUBSTANTIATION, the act of substantiating [n]\n",
  "SUBSTANTIATIVE": "tending to substantiate [adj]\n",
  "SUBSTANTIATOR": "one who substantiator [n -S]\n",
  "SUBSTANTIATORS": "SUBSTANTIATOR, one who substantiator [n]\n",
  "SUBSTANTIVAL": "of, relating to, or serving as a substantive [adj SUBSTANTIVALLY]\n",
  "SUBSTANTIVALLY": "SUBSTANTIVAL, of, relating to, or serving as a substantive [adv]\n",
  "SUBSTANTIVE": "relating to substance [adj SUBSTANTIVELY] / in grammar, a noun [n -S]\n",
  "SUBSTANTIVELY": "SUBSTANTIVE, relating to substance [adv]\n",
  "SUBSTANTIVENESS": "the state of being substantive [n]\n",
  "SUBSTANTIVES": "SUBSTANTIVE, in grammar, a noun [n]\n",
  "SUBSTANTIVISE": "to make substantive, also SUBSTANTIVIZE [v SUBSTANTIVISED, SUBSTANTIVISING, SUBSTANTIVISES]\n",
  "SUBSTANTIVISED": "SUBSTANTIVISE, to make substantive, also SUBSTANTIVIZE [v]\n",
  "SUBSTANTIVISES": "SUBSTANTIVISE, to make substantive, also SUBSTANTIVIZE [v]\n",
  "SUBSTANTIVISING": "SUBSTANTIVISE, to make substantive, also SUBSTANTIVIZE [v]\n",
  "SUBSTANTIVITIES": "SUBSTANTIVITY, the state of being substantive [n]\n",
  "SUBSTANTIVITY": "the state of being substantive [n SUBSTANTIVITIES]\n",
  "SUBSTANTIVIZE": "to make substantive, also SUBSTANTIVISE [v SUBSTANTIVIZED, SUBSTANTIVIZING, SUBSTANTIVIZES]\n",
  "SUBSTANTIVIZED": "SUBSTANTIVIZE, to make substantive, also SUBSTANTIVISE [v]\n",
  "SUBSTANTIVIZES": "SUBSTANTIVIZE, to make substantive, also SUBSTANTIVISE [v]\n",
  "SUBSTANTIVIZING": "SUBSTANTIVIZE, to make substantive, also SUBSTANTIVISE [v]\n",
  "SUBSTATE": "a subdivision of a state [n -S]\n",
  "SUBSTATES": "SUBSTATE, a subdivision of a state [n]\n",
  "SUBSTATION": "a subordinate or subsidiary station [n -S]\n",
  "SUBSTATIONS": "SUBSTATION, a subordinate or subsidiary station [n]\n",
  "SUBSTELLAR": "directly under a star [adj]\n",
  "SUBSTERNAL": "positioned below the breastbone [adj]\n",
  "SUBSTITUENT": "a thing, esp. an atom, substituted for another [n -S]\n",
  "SUBSTITUENTS": "SUBSTITUENT, a thing, esp. an atom, substituted for another [n]\n",
  "SUBSTITUTABLE": "capable of being substituted [adj]\n",
  "SUBSTITUTE": "to put or use in the place of another [v SUBSTITUTED, SUBSTITUTING, SUBSTITUTES]\n",
  "SUBSTITUTED": "SUBSTITUTE, to put or use in the place of another [v]\n",
  "SUBSTITUTES": "SUBSTITUTE, to put or use in the place of another [v]\n",
  "SUBSTITUTING": "SUBSTITUTE, to put or use in the place of another [v]\n",
  "SUBSTITUTION": "the act of substituting one thing for another [n -S]\n",
  "SUBSTITUTIONAL": "relating to substitution [adj]\n",
  "SUBSTITUTIONARY": "relating to substitution [adj]\n",
  "SUBSTITUTIONS": "SUBSTITUTION, the act of substituting one thing for another [n]\n",
  "SUBSTITUTIVE": "serving or suitable as a substitute [adj SUBSTITUTIVELY]\n",
  "SUBSTITUTIVELY": "SUBSTITUTIVE, serving or suitable as a substitute [adv]\n",
  "SUBSTITUTIVITY": "the state of being substitutive [n]\n",
  "SUBSTORM": "activity that disrupts the magnetic field of a planet [n -S]\n",
  "SUBSTORMS": "SUBSTORM, activity that disrupts the magnetic field of a planet [n]\n",
  "SUBSTRACT": "to subtract; to withdraw, also SUBTRACT [v -ED, -ING, -S]\n",
  "SUBSTRACTED": "SUBSTRACT, to subtract; to withdraw, also SUBTRACT [v]\n",
  "SUBSTRACTING": "SUBSTRACT, to subtract; to withdraw, also SUBTRACT [v]\n",
  "SUBSTRACTION": "subtraction, also SUBTRACTION [n -S]\n",
  "SUBSTRACTIONS": "SUBSTRACTION, subtraction, also SUBTRACTION [n]\n",
  "SUBSTRACTOR": "(Shakespeare) a detractor [n -S]\n",
  "SUBSTRACTORS": "SUBSTRACTOR, (Shakespeare) a detractor [n]\n",
  "SUBSTRACTS": "SUBSTRACT, to subtract; to withdraw, also SUBTRACT [v]\n",
  "SUBSTRATA": "SUBSTRATUM, that which underlies something, as a layer of earth lying under another, also SUBSTRATE [n]\n",
  "SUBSTRATAL": "relating to a substrate [adj]\n",
  "SUBSTRATE": "a substratum, also SUBSTRATUM [n -S]\n",
  "SUBSTRATES": "SUBSTRATE, a substratum, also SUBSTRATUM [n]\n",
  "SUBSTRATIVE": "relating to a substratum [adj]\n",
  "SUBSTRATOSPHERE": "the area of the atmosphere below the stratosphere [n]\n",
  "SUBSTRATUM": "that which underlies something, as a layer of earth lying under another, also SUBSTRATE [n SUBSTRATA or SUBSTRATUMS]\n",
  "SUBSTRATUMS": "SUBSTRATUM, that which underlies something, as a layer of earth lying under another, also SUBSTRATE [n]\n",
  "SUBSTRUCT": "to build beneath; to lay as a foundation [v -ED, -ING, -S]\n",
  "SUBSTRUCTED": "SUBSTRUCT, to build beneath; to lay as a foundation [v]\n",
  "SUBSTRUCTING": "SUBSTRUCT, to build beneath; to lay as a foundation [v]\n",
  "SUBSTRUCTION": "an underlying structure [n -S]\n",
  "SUBSTRUCTIONS": "SUBSTRUCTION, an underlying structure [n]\n",
  "SUBSTRUCTS": "SUBSTRUCT, to build beneath; to lay as a foundation [v]\n",
  "SUBSTRUCTURAL": "relating to substructure [adj]\n",
  "SUBSTRUCTURE": "an underlying or supporting part of a structure [n -S]\n",
  "SUBSTRUCTURES": "SUBSTRUCTURE, an underlying or supporting part of a structure [n]\n",
  "SUBSTYLAR": "pertaining to a substyle, the line on which the style or gnomon of a sundial stands [adj]\n",
  "SUBSTYLE": "the straight line on which the style of a dial is erected [n -S]\n",
  "SUBSTYLES": "SUBSTYLE, the straight line on which the style of a dial is erected [n]\n",
  "SUBSULTIVE": "moving by sudden leaps or starts; twitching, also SUBSULTORY [adj]\n",
  "SUBSULTORILY": "SUBSULTORY, moving by sudden leaps or starts; twitching, also SUBSULTIVE [adv]\n",
  "SUBSULTORY": "moving by sudden leaps or starts; twitching, also SUBSULTIVE [adj SUBSULTORILY]\n",
  "SUBSULTUS": "(Latin) a convulsive or twitching movement [n -ES]\n",
  "SUBSULTUSES": "SUBSULTUS, (Latin) a convulsive or twitching movement [n]\n",
  "SUBSUMABLE": "capable of being subsumed [adj]\n",
  "SUBSUME": "to classify within a larger category [v SUBSUMED, SUBSUMING, SUBSUMES]\n",
  "SUBSUMED": "SUBSUME, to classify within a larger category [v]\n",
  "SUBSUMES": "SUBSUME, to classify within a larger category [v]\n",
  "SUBSUMING": "SUBSUME, to classify within a larger category [v]\n",
  "SUBSUMPTION": "the minor premise of a syllogism [n -S]\n",
  "SUBSUMPTIONS": "SUBSUMPTION, the minor premise of a syllogism [n]\n",
  "SUBSUMPTIVE": "tending to subsume [adj]\n",
  "SUBSURFACE": "earth material (as rock) near but not exposed at the surface of the ground [n -S]\n",
  "SUBSURFACES": "SUBSURFACE, earth material (as rock) near but not exposed at the surface of the ground [n]\n",
  "SUBSYSTEM": "part of a system [n -S]\n",
  "SUBSYSTEMS": "SUBSYSTEM, part of a system [n]\n",
  "SUBTACK": "a sublease in Scotland [n -S]\n",
  "SUBTACKS": "SUBTACK, a sublease in Scotland [n]\n",
  "SUBTACKSMAN": "a holder (of land) by subtack [n SUBTACKSMEN]\n",
  "SUBTACKSMEN": "SUBTACKSMAN, a holder (of land) by subtack [n]\n",
  "SUBTALAR": "below the anklebone [adj]\n",
  "SUBTANGENT": "the part of the axis contained between the ordinate and tangent drawn to the same point in a curve [n -S]\n",
  "SUBTANGENTS": "SUBTANGENT, the part of the axis contained between the ordinate and tangent drawn to the same point in a curve [n]\n",
  "SUBTASK": "a subordinate task [n -S]\n",
  "SUBTASKS": "SUBTASK, a subordinate task [n]\n",
  "SUBTAXA": "SUBTAXON, a subdivision of a taxon [n]\n",
  "SUBTAXON": "a subdivision of a taxon [n SUBTAXONS or SUBTAXA]\n",
  "SUBTAXONS": "SUBTAXON, a subdivision of a taxon [n]\n",
  "SUBTEEN": "a person approaching the teenage years [n -S]\n",
  "SUBTEENS": "SUBTEEN, a person approaching the teenage years [n]\n",
  "SUBTEMPERATE": "of or occurring in the colder parts of the temperate zones [adj]\n",
  "SUBTENANCIES": "SUBTENANCY, the state of being a subtenant, one who rents a tenement, or land, etc. [n]\n",
  "SUBTENANCY": "the state of being a subtenant, one who rents a tenement, or land, etc. [n SUBTENANCIES]\n",
  "SUBTENANT": "one who rents a tenement, or land, etc. of one who is also a tenant [n -S]\n",
  "SUBTENANTS": "SUBTENANT, one who rents a tenement, or land, etc. of one who is also a tenant [n]\n",
  "SUBTEND": "to extend under or opposite to [v -ED, -ING, -S]\n",
  "SUBTENDED": "SUBTEND, to extend under or opposite to [v]\n",
  "SUBTENDING": "SUBTEND, to extend under or opposite to [v]\n",
  "SUBTENDS": "SUBTEND, to extend under or opposite to [v]\n",
  "SUBTENSE": "a line subtending, or stretching across; a chord; as, the subtense of an arc [n -S]\n",
  "SUBTENSES": "SUBTENSE, a line subtending, or stretching across; a chord; as, the subtense of an arc [n]\n",
  "SUBTENURE": "tenure held under somebody else's tenure [n -S]\n",
  "SUBTENURES": "SUBTENURE, tenure held under somebody else's tenure [n]\n",
  "SUBTERFUGE": "deception by artifice or stratagem in order to conceal or evade [n -S]\n",
  "SUBTERFUGES": "SUBTERFUGE, deception by artifice or stratagem in order to conceal or evade [n]\n",
  "SUBTERMINAL": "of a band or stripe, situated before the tip of the tail [adj]\n",
  "SUBTERNATURAL": "less than natural [adj]\n",
  "SUBTERRAIN": "an underground chamber, room or dwelling, also SOUTERRAIN, SUBTERRANE, SUBTERRENE [n -S]\n",
  "SUBTERRAINS": "SUBTERRAIN, an underground chamber, room or dwelling, also SOUTERRAIN, SUBTERRANE, SUBTERRENE [n]\n",
  "SUBTERRANE": "an underground chamber, room or dwelling, also SOUTERRAIN, SUBTERRAIN, SUBTERRENE [n -S]\n",
  "SUBTERRANEAN": "underground [adj SUBTERRANEANLY] / a person who or thing that is subterranean [n -S]\n",
  "SUBTERRANEANLY": "SUBTERRANEAN, underground [adv]\n",
  "SUBTERRANEANS": "SUBTERRANEAN, a person who or thing that is subterranean [n]\n",
  "SUBTERRANEOUS": "subterranean [adj SUBTERRANEOUSLY]\n",
  "SUBTERRANEOUSLY": "SUBTERRANEOUS, subterranean [adv]\n",
  "SUBTERRANES": "SUBTERRANE, an underground chamber, room or dwelling, also SOUTERRAIN, SUBTERRAIN, SUBTERRENE [n]\n",
  "SUBTERRENE": "an underground chamber, room or dwelling, also SOUTERRAIN, SUBTERRAIN, SUBTERRANE [n -S]\n",
  "SUBTERRENES": "SUBTERRENE, an underground chamber, room or dwelling, also SOUTERRAIN, SUBTERRAIN, SUBTERRANE [n]\n",
  "SUBTERRESTRIAL": "existing underground [adj] / a subterrestrial person or thing [n -S]\n",
  "SUBTERRESTRIALS": "SUBTERRESTRIAL, a subterrestrial person or thing [n]\n",
  "SUBTEST": "a subdivision of a test [n -S]\n",
  "SUBTESTS": "SUBTEST, a subdivision of a test [n]\n",
  "SUBTEXT": "written or printed matter under a more general text [n -S]\n",
  "SUBTEXTS": "SUBTEXT, written or printed matter under a more general text [n]\n",
  "SUBTEXTUAL": "relating to a subtext, an underlying theme in a literary work [adj]\n",
  "SUBTHEME": "a subordinate theme [n -S]\n",
  "SUBTHEMES": "SUBTHEME, a subordinate theme [n]\n",
  "SUBTHERAPEUTIC": "below the dosage levels used to treat diseases [adj]\n",
  "SUBTHRESHOLD": "inadequate to produce a response [adj]\n",
  "SUBTIDAL": "of a subordinate tide [adj]\n",
  "SUBTIL": "(archaic) subtle, delicate, also SUBTILE, SUBTLE [adj SUBTILER, SUBTILEST]\n",
  "SUBTILE": "(archaic) subtle, delicate, also SUBTIL, SUBTLE [adj SUBTILER, SUBTILEST, SUBTILELY]\n",
  "SUBTILELY": "SUBTILE, (archaic) subtle, delicate, also SUBTIL, SUBTLE [adv]\n",
  "SUBTILENESS": "the state of being subtile [n -ES]\n",
  "SUBTILENESSES": "SUBTILENESS, the state of being subtile [n]\n",
  "SUBTILER": "SUBTIL, (archaic) subtle, delicate, also SUBTILE, SUBTLE [adj]\n",
  "SUBTILEST": "SUBTIL, (archaic) subtle, delicate, also SUBTILE, SUBTLE [adj]\n",
  "SUBTILIN": "an antibiotic [n -S]\n",
  "SUBTILINS": "SUBTILIN, an antibiotic [n]\n",
  "SUBTILISATION": "the process of subtilising, also SUBTILIZATION [n -S]\n",
  "SUBTILISATIONS": "SUBTILISATION, the process of subtilising, also SUBTILIZATION [n]\n",
  "SUBTILISE": "to make subtle; now esp. to argue subtly on, also SUBTILIZE [v SUBTILISED, SUBTILISING, SUBTILISES]\n",
  "SUBTILISED": "SUBTILISE, to make subtle; now esp. to argue subtly on, also SUBTILIZE [v]\n",
  "SUBTILISER": "one who subtilises, also SUBTILIZER [n -S]\n",
  "SUBTILISERS": "SUBTILISER, one who subtilises, also SUBTILIZER [n]\n",
  "SUBTILISES": "SUBTILISE, to make subtle; now esp. to argue subtly on, also SUBTILIZE [v]\n",
  "SUBTILISIN": "an extracellular protease created by a soil bacillus [n -S]\n",
  "SUBTILISING": "SUBTILISE, to make subtle; now esp. to argue subtly on, also SUBTILIZE [v]\n",
  "SUBTILISINS": "SUBTILISIN, an extracellular protease created by a soil bacillus [n]\n",
  "SUBTILITIES": "SUBTILITY, subtlety, also SUBTILTY, SUBTLETY, SUTTLETIE [n]\n",
  "SUBTILITY": "subtlety, also SUBTILTY, SUBTLETY, SUTTLETIE [n SUBTILITIES]\n",
  "SUBTILIZATION": "the act of subtilizing, also SUBTILISATION [n -S]\n",
  "SUBTILIZATIONS": "SUBTILIZATION, the act of subtilizing, also SUBTILISATION [n]\n",
  "SUBTILIZE": "to make subtle; now esp. to argue subtly on, also SUBTILISE [v SUBTILIZED, SUBTILIZING, SUBTILIZES]\n",
  "SUBTILIZED": "SUBTILIZE, to make subtle; now esp. to argue subtly on, also SUBTILISE [v]\n",
  "SUBTILIZER": "one who subtilizes, also SUBTILISER [n -S]\n",
  "SUBTILIZERS": "SUBTILIZER, one who subtilizes, also SUBTILISER [n]\n",
  "SUBTILIZES": "SUBTILIZE, to make subtle; now esp. to argue subtly on, also SUBTILISE [v]\n",
  "SUBTILIZING": "SUBTILIZE, to make subtle; now esp. to argue subtly on, also SUBTILISE [v]\n",
  "SUBTILTIES": "SUBTILTY, the state of being subtil, also SUBTILITY, SUBTLETY, SUTTLETIE [n]\n",
  "SUBTILTY": "the state of being subtil, also SUBTILITY, SUBTLETY, SUTTLETIE [n SUBTILTIES]\n",
  "SUBTITLE": "to give a secondary title to [v SUBTITLED, SUBTITLING, SUBTITLES]\n",
  "SUBTITLED": "SUBTITLE, to give a secondary title to [v]\n",
  "SUBTITLES": "SUBTITLE, to give a secondary title to [v]\n",
  "SUBTITLING": "the act of providing with a subtitle [n -S]\n",
  "SUBTITLINGS": "SUBTITLING, the act of providing with a subtitle [n]\n",
  "SUBTITULAR": "having the nature of a subtitle [adj]\n",
  "SUBTLE": "so slight as to be difficult to detect, also SUBTIL, SUBTILE [adj SUBTLER, SUBTLEST, SUBTLY]\n",
  "SUBTLENESS": "the state of being subtle [n -ES]\n",
  "SUBTLENESSES": "SUBTLENESS, the state of being subtle [n]\n",
  "SUBTLER": "SUBTLE, so slight as to be difficult to detect, also SUBTIL, SUBTILE [adj]\n",
  "SUBTLEST": "SUBTLE, so slight as to be difficult to detect, also SUBTIL, SUBTILE [adj]\n",
  "SUBTLETIES": "SUBTLETY, the state of being subtle, also SUBTILITY, SUBTILTY, SUTTLETIE [n]\n",
  "SUBTLETY": "the state of being subtle, also SUBTILITY, SUBTILTY, SUTTLETIE [n SUBTLETIES]\n",
  "SUBTLY": "SUBTLE, so slight as to be difficult to detect, also SUBTIL, SUBTILE [adv]\n",
  "SUBTONE": "a low or subdued tone [n -S]\n",
  "SUBTONES": "SUBTONE, a low or subdued tone [n]\n",
  "SUBTONIC": "the seventh tone of a diatonic scale, immediately below the tonic [n -S]\n",
  "SUBTONICS": "SUBTONIC, the seventh tone of a diatonic scale, immediately below the tonic [n]\n",
  "SUBTOPIA": "the suburbs of a city [n -S]\n",
  "SUBTOPIAN": "of or like subtopia, the suburbs of a city [adj]\n",
  "SUBTOPIAS": "SUBTOPIA, the suburbs of a city [n]\n",
  "SUBTOPIC": "a secondary topic [n -S]\n",
  "SUBTOPICS": "SUBTOPIC, a secondary topic [n]\n",
  "SUBTORRID": "nearly torrid [adj]\n",
  "SUBTOTAL": "partially total [adj SUBTOTALLY] / to total a portion of [v SUBTOTALED or SUBTOTALLED, SUBTOTALING or SUBTOTALLING, SUBTOTALS]\n",
  "SUBTOTALED": "SUBTOTAL, to total a portion of [v]\n",
  "SUBTOTALING": "SUBTOTAL, to total a portion of [v]\n",
  "SUBTOTALLED": "SUBTOTAL, to total a portion of [v]\n",
  "SUBTOTALLING": "SUBTOTAL, to total a portion of [v]\n",
  "SUBTOTALLY": "SUBTOTAL, partially total [adv]\n",
  "SUBTOTALS": "SUBTOTAL, to total a portion of [v]\n",
  "SUBTRACT": "to take away, also SUBSTRACT [v -ED, -ING, -S]\n",
  "SUBTRACTED": "SUBTRACT, to take away, also SUBSTRACT [v]\n",
  "SUBTRACTER": "one who subtracts, also SUBTRACTOR [n -S]\n",
  "SUBTRACTERS": "SUBTRACTER, one who subtracts, also SUBTRACTOR [n]\n",
  "SUBTRACTING": "SUBTRACT, to take away, also SUBSTRACT [v]\n",
  "SUBTRACTION": "the act of subtracting, also SUBSTRACTION [n -S]\n",
  "SUBTRACTIONS": "SUBTRACTION, the act of subtracting, also SUBSTRACTION [n]\n",
  "SUBTRACTIVE": "tending to subtract [adj]\n",
  "SUBTRACTOR": "one who subtracts, also SUBTRACTER [n -S]\n",
  "SUBTRACTORS": "SUBTRACTOR, one who subtracts, also SUBTRACTER [n]\n",
  "SUBTRACTS": "SUBTRACT, to take away, also SUBSTRACT [v]\n",
  "SUBTRADE": "in the construction business, a trade such as plumber and electrician [n -S]\n",
  "SUBTRADES": "SUBTRADE, in the construction business, a trade such as plumber and electrician [n]\n",
  "SUBTRAHEND": "the sum or number to be subtracted, or taken from another [n -S]\n",
  "SUBTRAHENDS": "SUBTRAHEND, the sum or number to be subtracted, or taken from another [n]\n",
  "SUBTREASURER": "a subordinate treasurer [n -S]\n",
  "SUBTREASURERS": "SUBTREASURER, a subordinate treasurer [n]\n",
  "SUBTREASURIES": "SUBTREASURY, a subordinate treasury [n]\n",
  "SUBTREASURY": "a subordinate treasury [n SUBTREASURIES]\n",
  "SUBTREND": "a subordinate trend [n -S]\n",
  "SUBTRENDS": "SUBTREND, a subordinate trend [n]\n",
  "SUBTRIANGULAR": "not quite triangular [adj]\n",
  "SUBTRIBE": "a subdivision of a tribe [n -S]\n",
  "SUBTRIBES": "SUBTRIBE, a subdivision of a tribe [n]\n",
  "SUBTRIPLICATE": "expressed by the cube root [adj]\n",
  "SUBTRIST": "(archaic) somewhat sad [adj]\n",
  "SUBTROPIC": "relating to the area lying between the Tropic of Cancer and 40 degrees N, and the Tropic of Capricorn and 40 degrees south, also SUBTROPICAL [adj SUBTROPICALLY] / a subtropical region [n -S]\n",
  "SUBTROPICAL": "relating to the area lying between the Tropic of Cancer and 40 degrees N, and the Tropic of Capricorn and 40 degrees south, also SUBTROPIC [adj SUBTROPICALLY]\n",
  "SUBTROPICALLY": "SUBTROPICAL, relating to the area lying between the Tropic of Cancer and 40 degrees N, and the Tropic of Capricorn and 40 degrees south, also SUBTROPIC [adv]\n",
  "SUBTROPICS": "SUBTROPIC, a subtropical region [n]\n",
  "SUBTRUDE": "to push in stealthily [v SUBTRUDED, SUBTRUDING, SUBTRUDES]\n",
  "SUBTRUDED": "SUBTRUDE, to push in stealthily [v]\n",
  "SUBTRUDES": "SUBTRUDE, to push in stealthily [v]\n",
  "SUBTRUDING": "SUBTRUDE, to push in stealthily [v]\n",
  "SUBTUNIC": "a tunic worn under another tunic [n -S]\n",
  "SUBTUNICS": "SUBTUNIC, a tunic worn under another tunic [n]\n",
  "SUBTWEET": "(on the Twitter application) to post a message about (another user), usually negative in its content, but not explicitly naming him or her [v -ED, -ING, -S]\n",
  "SUBTWEETED": "SUBTWEET, (on the Twitter application) to post a message about (another user), usually negative in its content, but not explicitly naming him or her [v]\n",
  "SUBTWEETING": "SUBTWEET, (on the Twitter application) to post a message about (another user), usually negative in its content, but not explicitly naming him or her [v]\n",
  "SUBTWEETS": "SUBTWEET, (on the Twitter application) to post a message about (another user), usually negative in its content, but not explicitly naming him or her [v]\n",
  "SUBTYPE": "a type that is subordinate to another type [n -S]\n",
  "SUBTYPES": "SUBTYPE, a type that is subordinate to another type [n]\n",
  "SUBTYPICAL": "relating to a subtype [adj]\n",
  "SUBUCULA": "(Latin) in the early English church, a kind of cassock worn under the alb [n -S]\n",
  "SUBUCULAS": "SUBUCULA, (Latin) in the early English church, a kind of cassock worn under the alb [n]\n",
  "SUBULATE": "awl-shaped, long and tapering to a point [adj]\n",
  "SUBUMBRELLA": "the concave undersurface of a jellyfish [n -S]\n",
  "SUBUMBRELLAR": "relating to the subumbrella, the concave undersurface of a jellyfish [adj]\n",
  "SUBUMBRELLAS": "SUBUMBRELLA, the concave undersurface of a jellyfish [n]\n",
  "SUBUNGULATE": "belonging to the Subungulata, a classification of animals including the elephants, hyraxes, sea cows and aardvark [adj] / a member of the Subungulata [n -S]\n",
  "SUBUNGULATES": "SUBUNGULATE, a member of the Subungulata [n]\n",
  "SUBUNIT": "a unit that is part of a larger unit [n -S]\n",
  "SUBUNITS": "SUBUNIT, a unit that is part of a larger unit [n]\n",
  "SUBURB": "a residential area adjacent to a city [n -S]\n",
  "SUBURBAN": "one who lives in a suburb [n -S]\n",
  "SUBURBANISATION": "the act of suburbanising, also SUBURBANIZATION [n]\n",
  "SUBURBANISE": "to make suburban, also SUBURBANIZE [v SUBURBANISED, SUBURBANISING, SUBURBANISES]\n",
  "SUBURBANISED": "SUBURBANISE, to make suburban, also SUBURBANIZE [v]\n",
  "SUBURBANISES": "SUBURBANISE, to make suburban, also SUBURBANIZE [v]\n",
  "SUBURBANISING": "SUBURBANISE, to make suburban, also SUBURBANIZE [v]\n",
  "SUBURBANISM": "the state of being suburban [n -S]\n",
  "SUBURBANISMS": "SUBURBANISM, the state of being suburban [n]\n",
  "SUBURBANITE": "one who lives in the suburbs [n -S]\n",
  "SUBURBANITES": "SUBURBANITE, one who lives in the suburbs [n]\n",
  "SUBURBANITIES": "SUBURBANITY, the state of being suburban [n]\n",
  "SUBURBANITY": "the state of being suburban [n SUBURBANITIES]\n",
  "SUBURBANIZATION": "the act of suburbanizing, also SUBURBANISATION [n]\n",
  "SUBURBANIZE": "to make suburban, also SUBURBANISE [v SUBURBANIZED, SUBURBANIZING, SUBURBANIZES]\n",
  "SUBURBANIZED": "SUBURBANIZE, to make suburban, also SUBURBANISE [v]\n",
  "SUBURBANIZES": "SUBURBANIZE, to make suburban, also SUBURBANISE [v]\n",
  "SUBURBANIZING": "SUBURBANIZE, to make suburban, also SUBURBANISE [v]\n",
  "SUBURBANS": "SUBURBAN, one who lives in a suburb [n]\n",
  "SUBURBED": "having a suburb [adj]\n",
  "SUBURBIA": "the suburbs of a city [n -S]\n",
  "SUBURBIAS": "SUBURBIA, the suburbs of a city [n]\n",
  "SUBURBICARIAN": "pertaining to suburbs, used esp. of the dioceses surrounding Rome [adj]\n",
  "SUBURBS": "SUBURB, a residential area adjacent to a city [n]\n",
  "SUBURSINE": "almost like a bear [adj]\n",
  "SUBVARIETIES": "SUBVARIETY, a subordinate variety, or a division of a variety [n]\n",
  "SUBVARIETY": "a subordinate variety, or a division of a variety [n SUBVARIETIES]\n",
  "SUBVASSAL": "the vassal of a vassal [n -S]\n",
  "SUBVASSALS": "SUBVASSAL, the vassal of a vassal [n]\n",
  "SUBVENE": "to arrive or occur as a support or relief [v SUBVENED, SUBVENING, SUBVENES]\n",
  "SUBVENED": "SUBVENE, to arrive or occur as a support or relief [v]\n",
  "SUBVENES": "SUBVENE, to arrive or occur as a support or relief [v]\n",
  "SUBVENING": "SUBVENE, to arrive or occur as a support or relief [v]\n",
  "SUBVENTION": "the provision of assistance or financial support [n -S]\n",
  "SUBVENTIONARY": "relating to subvention [adj]\n",
  "SUBVENTIONS": "SUBVENTION, the provision of assistance or financial support [n]\n",
  "SUBVERSAL": "the act of subverting [n -S]\n",
  "SUBVERSALS": "SUBVERSAL, the act of subverting [n]\n",
  "SUBVERSE": "to overthrow, also SUBVERT [v SUBVERSED or (Spenser) SUBVERST, SUBVERSING, SUBVERSES]\n",
  "SUBVERSED": "SUBVERSE, to overthrow, also SUBVERT [v]\n",
  "SUBVERSES": "SUBVERSE, to overthrow, also SUBVERT [v]\n",
  "SUBVERSING": "SUBVERSE, to overthrow, also SUBVERT [v]\n",
  "SUBVERSION": "the act of subverting [n -S]\n",
  "SUBVERSIONARIES": "SUBVERSIONARY, a subversive person [n]\n",
  "SUBVERSIONARY": "a subversive person [n SUBVERSIONARIES]\n",
  "SUBVERSIONS": "SUBVERSION, the act of subverting [n]\n",
  "SUBVERSIVE": "tending to subvert [adj SUBVERSIVELY] / one who subverts [n -S]\n",
  "SUBVERSIVELY": "SUBVERSIVE, tending to subvert [adv]\n",
  "SUBVERSIVENESS": "the state of being subversive [n]\n",
  "SUBVERSIVES": "SUBVERSIVE, one who subverts [n]\n",
  "SUBVERST": "SUBVERSE, to overthrow, also SUBVERT [v]\n",
  "SUBVERT": "to destroy completely, also SUBVERSE [v -ED, -ING, -S]\n",
  "SUBVERTEBRAL": "situated below the vertebrae [adj]\n",
  "SUBVERTED": "SUBVERT, to destroy completely, also SUBVERSE [v]\n",
  "SUBVERTER": "one who, or that which, subverts [n -S]\n",
  "SUBVERTERS": "SUBVERTER, one who, or that which, subverts [n]\n",
  "SUBVERTICAL": "below the vertical [adj]\n",
  "SUBVERTING": "SUBVERT, to destroy completely, also SUBVERSE [v]\n",
  "SUBVERTS": "SUBVERT, to destroy completely, also SUBVERSE [v]\n",
  "SUBVICAR": "a subordinate vicar [n -S]\n",
  "SUBVICARS": "SUBVICAR, a subordinate vicar [n]\n",
  "SUBVIRAL": "pertaining to a part of a virus [adj]\n",
  "SUBVIRUS": "a viral protein smaller than a virus [n -ES]\n",
  "SUBVIRUSES": "SUBVIRUS, a viral protein smaller than a virus [n]\n",
  "SUBVISIBLE": "below the threshold of visibility [adj]\n",
  "SUBVISUAL": "below the threshold of visual perception [adj]\n",
  "SUBVITREOUS": "somewhat vitreous [adj]\n",
  "SUBVOCAL": "of words formed in speech order in the mind with or without (inaudible) movements of the speech organs [adj SUBVOCALLY]\n",
  "SUBVOCALISATION": "the act of inaudibly articulating speech with the speech organs, also SUBVOCALIZATION [n]\n",
  "SUBVOCALISE": "to say below the breath, also SUBVOCALIZE [v SUBVOCALISED, SUBVOCALISING, SUBVOCALISES]\n",
  "SUBVOCALISED": "SUBVOCALISE, to say below the breath, also SUBVOCALIZE [v]\n",
  "SUBVOCALISES": "SUBVOCALISE, to say below the breath, also SUBVOCALIZE [v]\n",
  "SUBVOCALISING": "SUBVOCALISE, to say below the breath, also SUBVOCALIZE [v]\n",
  "SUBVOCALIZATION": "the act of inaudibly articulating speech with the speech organs, also SUBVOCALISATION [n]\n",
  "SUBVOCALIZE": "to say below the breath, also SUBVOCALISE [v SUBVOCALIZED, SUBVOCALIZING, SUBVOCALIZES]\n",
  "SUBVOCALIZED": "SUBVOCALIZE, to say below the breath, also SUBVOCALISE [v]\n",
  "SUBVOCALIZES": "SUBVOCALIZE, to say below the breath, also SUBVOCALISE [v]\n",
  "SUBVOCALIZING": "SUBVOCALIZE, to say below the breath, also SUBVOCALISE [v]\n",
  "SUBVOCALLY": "SUBVOCAL, of words formed in speech order in the mind with or without (inaudible) movements of the speech organs [adv]\n",
  "SUBWARDEN": "a subordinate warden [n -S]\n",
  "SUBWARDENS": "SUBWARDEN, a subordinate warden [n]\n",
  "SUBWAY": "to travel by an underground railroad [v -ED, -ING, -S]\n",
  "SUBWAYED": "SUBWAY, to travel by an underground railroad [v]\n",
  "SUBWAYING": "SUBWAY, to travel by an underground railroad [v]\n",
  "SUBWAYS": "SUBWAY, to travel by an underground railroad [v]\n",
  "SUBWOOFER": "part of a sound system [n -S]\n",
  "SUBWOOFERS": "SUBWOOFER, part of a sound system [n]\n",
  "SUBWORLD": "a subdivision of a sphere of interest [n -S]\n",
  "SUBWORLDS": "SUBWORLD, a subdivision of a sphere of interest [n]\n",
  "SUBWRITER": "one who writes under the direction of another [n -S]\n",
  "SUBWRITERS": "SUBWRITER, one who writes under the direction of another [n]\n",
  "SUBZERO": "registering less than zero [adj]\n",
  "SUBZONAL": "pertaining to a subdivision of a zone [adj]\n",
  "SUBZONE": "a subdivision of a zone [n -S]\n",
  "SUBZONES": "SUBZONE, a subdivision of a zone [n]\n",
  "SUCCADE": "a candied fruit, a sweetmeat, also SUCKET [n -S]\n",
  "SUCCADES": "SUCCADE, a candied fruit, a sweetmeat, also SUCKET [n]\n",
  "SUCCAH": "(Hebrew) a shelter where meals are eaten during Jewish festivals [n SUCCAHS or SUCCOS or SUCCOT or SUCCOTH]\n",
  "SUCCAHS": "SUCCAH, (Hebrew) a shelter where meals are eaten during Jewish festivals [n]\n",
  "SUCCEDANEA": "SUCCEDANEUM, (Latin) a substitute; a remedy [n]\n",
  "SUCCEDANEOUS": "subrogated, substituted [adj]\n",
  "SUCCEDANEUM": "(Latin) a substitute; a remedy [n SUCCEDANEA or SUCCEDANEUMS]\n",
  "SUCCEDANEUMS": "SUCCEDANEUM, (Latin) a substitute; a remedy [n]\n",
  "SUCCEDENT": "a person or thing that follows [n -S]\n",
  "SUCCEDENTS": "SUCCEDENT, a person or thing that follows [n]\n",
  "SUCCEED": "to accomplish something [v -ED, -ING, -S]\n",
  "SUCCEEDABLE": "capable of being succeeded [adj]\n",
  "SUCCEEDED": "SUCCEED, to accomplish something [v]\n",
  "SUCCEEDER": "a successor [n -S]\n",
  "SUCCEEDERS": "SUCCEEDER, a successor [n]\n",
  "SUCCEEDING": "following [adj SUCCEEDINGLY]\n",
  "SUCCEEDINGLY": "SUCCEEDING, following [adv]\n",
  "SUCCEEDS": "SUCCEED, to accomplish something [v]\n",
  "SUCCENTOR": "a bass soloist in a choir [n -S]\n",
  "SUCCENTORS": "SUCCENTOR, a bass soloist in a choir [n]\n",
  "SUCCENTORSHIP": "the office of succentor [n -S]\n",
  "SUCCENTORSHIPS": "SUCCENTORSHIP, the office of succentor [n]\n",
  "SUCCES": "(French) success [n SUCCES]\n",
  "SUCCESS": "the attainment of something desired or intended [n -ES]\n",
  "SUCCESSANTLY": "(Shakespeare) in succession [adv]\n",
  "SUCCESSES": "SUCCESS, the attainment of something desired or intended [n]\n",
  "SUCCESSFUL": "resulting or terminating in success [adj SUCCESSFULLY]\n",
  "SUCCESSFULLY": "SUCCESSFUL, resulting or terminating in success [adv]\n",
  "SUCCESSFULNESS": "the state of being successful [n]\n",
  "SUCCESSION": "a coming after or following [n -S]\n",
  "SUCCESSIONAL": "relating to succession [adj SUCCESSIONALLY]\n",
  "SUCCESSIONALLY": "SUCCESSIONAL, relating to succession [adv]\n",
  "SUCCESSIONIST": "a believer in the necessity of Apostolic succession [n -S]\n",
  "SUCCESSIONISTS": "SUCCESSIONIST, a believer in the necessity of Apostolic succession [n]\n",
  "SUCCESSIONLESS": "without succession [adj]\n",
  "SUCCESSIONS": "SUCCESSION, a coming after or following [n]\n",
  "SUCCESSIVE": "following in order [adj SUCCESSIVELY]\n",
  "SUCCESSIVELY": "SUCCESSIVE, following in order [adv]\n",
  "SUCCESSIVENESS": "the state of being successive [n]\n",
  "SUCCESSLESS": "without success [adj SUCCESSLESSLY]\n",
  "SUCCESSLESSLY": "SUCCESSLESS, without success [adv]\n",
  "SUCCESSLESSNESS": "the state of being successless [n]\n",
  "SUCCESSOR": "one who succeeds, comes after [n -S]\n",
  "SUCCESSORAL": "relating to a successor [adj]\n",
  "SUCCESSORS": "SUCCESSOR, one who succeeds, comes after [n]\n",
  "SUCCESSORSHIP": "being a successor, one who succeeds [n -S]\n",
  "SUCCESSORSHIPS": "SUCCESSORSHIP, being a successor, one who succeeds [n]\n",
  "SUCCI": "SUCCUS, (Latin) juice, any fluid secretion from a plant or animal [n]\n",
  "SUCCINATE": "a salt of succinic acid [n -S]\n",
  "SUCCINATES": "SUCCINATE, a salt of succinic acid [n]\n",
  "SUCCINCT": "clearly expressed in a few words [adj SUCCINCTER, SUCCINCTEST, SUCCINCTLY]\n",
  "SUCCINCTER": "SUCCINCT, clearly expressed in a few words [adj]\n",
  "SUCCINCTEST": "SUCCINCT, clearly expressed in a few words [adj]\n",
  "SUCCINCTLY": "SUCCINCT, clearly expressed in a few words [adv]\n",
  "SUCCINCTNESS": "the state of being succinct [n -ES]\n",
  "SUCCINCTNESSES": "SUCCINCTNESS, the state of being succinct [n]\n",
  "SUCCINCTORIA": "SUCCINCTORIUM, a band embroidered with an Agnus Dei, worn hanging from the girdle by the Pope on some occasions [n]\n",
  "SUCCINCTORIES": "SUCCINCTORY, a band embroidered with an Agnus Dei, worn hanging from the girdle by the Pope on some occasions [n]\n",
  "SUCCINCTORIUM": "a band embroidered with an Agnus Dei, worn hanging from the girdle by the Pope on some occasions [n SUCCINCTORIA or SUCCINCTORIUMS]\n",
  "SUCCINCTORIUMS": "SUCCINCTORIUM, a band embroidered with an Agnus Dei, worn hanging from the girdle by the Pope on some occasions [n]\n",
  "SUCCINCTORY": "a band embroidered with an Agnus Dei, worn hanging from the girdle by the Pope on some occasions [n SUCCINCTORIES]\n",
  "SUCCINIC": "of, relating to or derived from amber [adj]\n",
  "SUCCINITE": "amber, especially a variety from which succinic acid was originally obtained [n -S]\n",
  "SUCCINITES": "SUCCINITE, amber, especially a variety from which succinic acid was originally obtained [n]\n",
  "SUCCINYL": "the radical of succinic acid [n -S]\n",
  "SUCCINYLCHOLINE": "a basic compound that is used intravenously chiefly in the form of a hydrated chloride as a muscle relaxant in surgery [n]\n",
  "SUCCINYLS": "SUCCINYL, the radical of succinic acid [n]\n",
  "SUCCISE": "(Latin) ending abruptly below [adj]\n",
  "SUCCOR": "to go to the aid of, also SUCCOUR [v -ED, -ING, -S]\n",
  "SUCCORABLE": "that can be succored, also SUCCOURABLE [adj]\n",
  "SUCCORED": "SUCCOR, to go to the aid of, also SUCCOUR [v]\n",
  "SUCCORER": "one who succors, also SUCCOURER [n -S]\n",
  "SUCCORERS": "SUCCORER, one who succors, also SUCCOURER [n]\n",
  "SUCCORIES": "SUCCORY, chicory [n]\n",
  "SUCCORING": "SUCCOR, to go to the aid of, also SUCCOUR [v]\n",
  "SUCCORLESS": "without succor, also SUCCOURLESS [adj]\n",
  "SUCCORS": "SUCCOR, to go to the aid of, also SUCCOUR [v]\n",
  "SUCCORY": "chicory [n SUCCORIES]\n",
  "SUCCOS": "SUCCAH, (Hebrew) a shelter where meals are eaten during Jewish festivals [n]\n",
  "SUCCOSE": "of or like succus, juicy, also SUCCOUS [adj]\n",
  "SUCCOT": "SUCCAH, (Hebrew) a shelter where meals are eaten during Jewish festivals [n]\n",
  "SUCCOTASH": "(Native American) a traditional American dish made from corn kernels and lima beans [n -ES]\n",
  "SUCCOTASHES": "SUCCOTASH, (Native American) a traditional American dish made from corn kernels and lima beans [n]\n",
  "SUCCOTH": "SUCCAH, (Hebrew) a shelter where meals are eaten during Jewish festivals [n]\n",
  "SUCCOUR": "to go to the aid of, also SUCCOR [v -ED, -ING, -S]\n",
  "SUCCOURABLE": "that can be succored, also SUCCORABLE [adj]\n",
  "SUCCOURED": "SUCCOUR, to go to the aid of, also SUCCOR [v]\n",
  "SUCCOURER": "one who succours, also SUCCORER [n -S]\n",
  "SUCCOURERS": "SUCCOURER, one who succours, also SUCCORER [n]\n",
  "SUCCOURING": "SUCCOUR, to go to the aid of, also SUCCOR [v]\n",
  "SUCCOURLESS": "without succour, also SUCCORLESS [adj]\n",
  "SUCCOURS": "SUCCOUR, to go to the aid of, also SUCCOR [v]\n",
  "SUCCOUS": "of or like succus, juicy, also SUCCOSE [adj]\n",
  "SUCCUBA": "(Latin) a female demon, also SUCCUBUS [n SUCCUBAS or SUCCUBAE]\n",
  "SUCCUBAE": "SUCCUBA, (Latin) a female demon, also SUCCUBUS [n]\n",
  "SUCCUBAS": "SUCCUBA, (Latin) a female demon, also SUCCUBUS [n]\n",
  "SUCCUBI": "SUCCUBUS, (Latin) a female demon, also SUCCUBA [n]\n",
  "SUCCUBINE": "of or pertaining to succubi [adj]\n",
  "SUCCUBOUS": "having the lower leaf-margin overlapping the leaf below, as in some mosses [adj]\n",
  "SUCCUBUS": "(Latin) a female demon, also SUCCUBA [n SUCCUBUSES or SUCCUBI]\n",
  "SUCCUBUSES": "SUCCUBUS, (Latin) a female demon, also SUCCUBA [n]\n",
  "SUCCULENCE": "the state of being succulent, also SUCCULENCY [n -S]\n",
  "SUCCULENCES": "SUCCULENCE, the state of being succulent, also SUCCULENCY [n]\n",
  "SUCCULENCIES": "SUCCULENCY, the state of being succulent, also SUCCULENCE [n]\n",
  "SUCCULENCY": "the state of being succulent, also SUCCULENCE [n SUCCULENCIES]\n",
  "SUCCULENT": "juicy, sappy [adj SUCCULENTLY] / a plant, such as a cactus, that stores water in its stem and leaves [n -S]\n",
  "SUCCULENTLY": "SUCCULENT, juicy, sappy [adv]\n",
  "SUCCULENTS": "SUCCULENT, a plant, such as a cactus, that stores water in its stem and leaves [n]\n",
  "SUCCUMB": "to yield to superior force [v -ED, -ING, -S]\n",
  "SUCCUMBED": "SUCCUMB, to yield to superior force [v]\n",
  "SUCCUMBER": "one who succumbs [n -S]\n",
  "SUCCUMBERS": "SUCCUMBER, one who succumbs [n]\n",
  "SUCCUMBING": "SUCCUMB, to yield to superior force [v]\n",
  "SUCCUMBS": "SUCCUMB, to yield to superior force [v]\n",
  "SUCCURSAL": "subsidiary [adj] / a branch or subsidiary establishment, esp. religious, also SUCCURSALE [n -S]\n",
  "SUCCURSALE": "subsidiary [adj] / a branch or subsidiary establishment, esp. religious, also SUCCURSAL [n -S]\n",
  "SUCCURSALES": "SUCCURSALE, a branch or subsidiary establishment, esp. religious, also SUCCURSAL [n]\n",
  "SUCCURSALS": "SUCCURSAL, a branch or subsidiary establishment, esp. religious, also SUCCURSALE [n]\n",
  "SUCCUS": "(Latin) juice, any fluid secretion from a plant or animal [n SUCCI]\n",
  "SUCCUSS": "to shake violently [v -ED, -ING, -ES]\n",
  "SUCCUSSATION": "a violent shaking [n -S]\n",
  "SUCCUSSATIONS": "SUCCUSSATION, a violent shaking [n]\n",
  "SUCCUSSED": "SUCCUSS, to shake violently [v]\n",
  "SUCCUSSES": "SUCCUSS, to shake violently [v]\n",
  "SUCCUSSING": "SUCCUSS, to shake violently [v]\n",
  "SUCCUSSION": "the act of shaking [n -S]\n",
  "SUCCUSSIONS": "SUCCUSSION, the act of shaking [n]\n",
  "SUCCUSSIVE": "characterized by a shaking motion, esp. an up and down movement [adj]\n",
  "SUCH": "of that kind, also SICH [adj]\n",
  "SUCHLIKE": "things of a similar kind, also SICLIKE [n -S]\n",
  "SUCHLIKES": "SUCHLIKE, things of a similar kind, also SICLIKE [n]\n",
  "SUCHNESS": "essential or characteristic quality [n -ES]\n",
  "SUCHNESSES": "SUCHNESS, essential or characteristic quality [n]\n",
  "SUCHWISE": "in such a manner [adv]\n",
  "SUCK": "to draw in by establishing a partial vacuum [v -ED, -ING, -S]\n",
  "SUCKED": "SUCK, to draw in by establishing a partial vacuum [v]\n",
  "SUCKEN": "a feudal district under a particular jurisdiction, also SOKEN [n -S]\n",
  "SUCKENER": "a tenant under the thirlage system [n -S]\n",
  "SUCKENERS": "SUCKENER, a tenant under the thirlage system [n]\n",
  "SUCKENS": "SUCKEN, a feudal district under a particular jurisdiction, also SOKEN [n]\n",
  "SUCKER": "to strip off superfluous shoots [v -ED, -ING, -S]\n",
  "SUCKERED": "SUCKER, to strip off superfluous shoots [v]\n",
  "SUCKERFISH": "the remora or any other fish with an adhesive disc, e.g. a lumpsucker [n -ES]\n",
  "SUCKERFISHES": "SUCKERFISH, the remora or any other fish with an adhesive disc, e.g. a lumpsucker [n]\n",
  "SUCKERING": "SUCKER, to strip off superfluous shoots [v]\n",
  "SUCKERS": "SUCKER, to strip off superfluous shoots [v]\n",
  "SUCKET": "(obsolete) a dainty or delicacy, also SUNKET [n -S]\n",
  "SUCKETS": "SUCKET, (obsolete) a dainty or delicacy, also SUNKET [n]\n",
  "SUCKFISH": "a remora, sucker fish [n -ES]\n",
  "SUCKFISHES": "SUCKFISH, a remora, sucker fish [n]\n",
  "SUCKHOLE": "(Australian slang) to act sycophantically [v SUCKHOLED, SUCKHOLING, SUCKHOLES]\n",
  "SUCKHOLED": "SUCKHOLE, (Australian slang) to act sycophantically [v]\n",
  "SUCKHOLES": "SUCKHOLE, (Australian slang) to act sycophantically [v]\n",
  "SUCKHOLING": "SUCKHOLE, (Australian slang) to act sycophantically [v]\n",
  "SUCKIER": "SUCKY, not good [adj]\n",
  "SUCKIEST": "SUCKY, not good [adj]\n",
  "SUCKINESS": "the quality of being sucky [n -ES]\n",
  "SUCKINESSES": "SUCKINESS, the quality of being sucky [n]\n",
  "SUCKING": "the act of sucking [n -S]\n",
  "SUCKINGS": "SUCKING, the act of sucking [n]\n",
  "SUCKLE": "to feed mild from the breast [v SUCKLED, SUCKLING, SUCKLES]\n",
  "SUCKLED": "SUCKLE, to feed mild from the breast [v]\n",
  "SUCKLER": "an animal that suckles, also SUCKLING [n -S]\n",
  "SUCKLERS": "SUCKLER, an animal that suckles, also SUCKLING [n]\n",
  "SUCKLES": "SUCKLE, to feed mild from the breast [v]\n",
  "SUCKLESS": "having no juice [adj]\n",
  "SUCKLING": "a young mammal that has not been weaned [n -S]\n",
  "SUCKLINGS": "SUCKLING, a young mammal that has not been weaned [n]\n",
  "SUCKS": "SUCK, to draw in by establishing a partial vacuum [v]\n",
  "SUCKY": "not good [adj SUCKIER, SUCKIEST]\n",
  "SUCRALFATE": "a drug used in the treatment of peptic ulcer [n -S]\n",
  "SUCRALFATES": "SUCRALFATE, a drug used in the treatment of peptic ulcer [n]\n",
  "SUCRALOSE": "an artificial sweetener [n -S]\n",
  "SUCRALOSES": "SUCRALOSE, an artificial sweetener [n]\n",
  "SUCRASE": "an enzyme that inverts cane sugar, aka invertase [n -S]\n",
  "SUCRASES": "SUCRASE, an enzyme that inverts cane sugar, aka invertase [n]\n",
  "SUCRE": "a monetary unit of Ecuador, a silver coin worth 68 cents [n -S]\n",
  "SUCRES": "SUCRE, a monetary unit of Ecuador, a silver coin worth 68 cents [n]\n",
  "SUCRIER": "(French) a table vessel for sugar [n -S]\n",
  "SUCRIERS": "SUCRIER, (French) a table vessel for sugar [n]\n",
  "SUCROSE": "a white crystalline disaccharide composed of a glucose and a fructose unit [n -S]\n",
  "SUCROSES": "SUCROSE, a white crystalline disaccharide composed of a glucose and a fructose unit [n]\n",
  "SUCTION": "to remove by sucking [v -ED, -ING, -S]\n",
  "SUCTIONAL": "as in suctional stop, a stop consonant in which the contact of the articulating organs is followed by an inrush of air [adj]\n",
  "SUCTIONED": "SUCTION, to remove by sucking [v]\n",
  "SUCTIONING": "SUCTION, to remove by sucking [v]\n",
  "SUCTIONS": "SUCTION, to remove by sucking [v]\n",
  "SUCTORIAL": "designed for sucking or adhering [adj]\n",
  "SUCTORIAN": "a cartilaginous fish with a mouth adapted for suction, as the lamprey [n -S]\n",
  "SUCTORIANS": "SUCTORIAN, a cartilaginous fish with a mouth adapted for suction, as the lamprey [n]\n",
  "SUCURUJU": "a South American Indian name for the anaconda [n -S]\n",
  "SUCURUJUS": "SUCURUJU, a South American Indian name for the anaconda [n]\n",
  "SUD": "a froth of soapy water [n -S]\n",
  "SUDAMEN": "(Latin) a whitish vesicle due to the retention of sweat in the sweat ducts or under the skin [n SUDAMINA or SUDAMENS]\n",
  "SUDAMENS": "SUDAMEN, (Latin) a whitish vesicle due to the retention of sweat in the sweat ducts or under the skin [n]\n",
  "SUDAMINA": "SUDAMEN, (Latin) a whitish vesicle due to the retention of sweat in the sweat ducts or under the skin [n]\n",
  "SUDAMINAL": "relating to sudamina, whitish vesicles due to the retention of sweat in the sweat ducts or under the skin [adj]\n",
  "SUDARIA": "SUDARIUM, (Latin) a cloth for wiping the face, also SUDARY [n]\n",
  "SUDARIES": "SUDARY, a cloth for wiping the face, also SUDARIUM [n]\n",
  "SUDARIUM": "(Latin) a cloth for wiping the face, also SUDARY [n SUDARIA]\n",
  "SUDARY": "a cloth for wiping the face, also SUDARIUM [n SUDARIES]\n",
  "SUDATE": "to sweat [v SUDATED, SUDATING, SUDATES]\n",
  "SUDATED": "SUDATE, to sweat [v]\n",
  "SUDATES": "SUDATE, to sweat [v]\n",
  "SUDATING": "SUDATE, to sweat [v]\n",
  "SUDATION": "excessive sweating [n -S]\n",
  "SUDATIONS": "SUDATION, excessive sweating [n]\n",
  "SUDATORIA": "SUDATORIUM, (Latin) a sweat room in a bath [n]\n",
  "SUDATORIES": "SUDATORY, a hot-air bath for inducing sweating [n]\n",
  "SUDATORIUM": "(Latin) a sweat room in a bath [n SUDATORIA or SUDATORIUMS]\n",
  "SUDATORIUMS": "SUDATORIUM, (Latin) a sweat room in a bath [n]\n",
  "SUDATORY": "a hot-air bath for inducing sweating [n SUDATORIES]\n",
  "SUDD": "(Arabic) a mass of vegetation floating on water in NE Africa [n -S]\n",
  "SUDDEN": "without warning, also SODAIN, SODAINE [adj SUDDENLY] / a sudden occurrence [n -S]\n",
  "SUDDENLY": "SUDDEN, without warning, also SODAIN, SODAINE [adv]\n",
  "SUDDENNESS": "the state of being sudden [n -ES]\n",
  "SUDDENNESSES": "SUDDENNESS, the state of being sudden [n]\n",
  "SUDDENS": "SUDDEN, a sudden occurrence [n]\n",
  "SUDDENTIES": "SUDDENTY, (Scots) suddenness [n]\n",
  "SUDDENTY": "(Scots) suddenness [n SUDDENTIES]\n",
  "SUDDER": "(Arabic) a supreme court [n -S]\n",
  "SUDDERS": "SUDDER, (Arabic) a supreme court [n]\n",
  "SUDDS": "SUDD, (Arabic) a mass of vegetation floating on water in NE Africa [n]\n",
  "SUDOKU": "a type of puzzle in which numbers must be entered into a square grid in such a way that no number is repeated in any row, column or internal square [n -S]\n",
  "SUDOKUS": "SUDOKU, a type of puzzle in which numbers must be entered into a square grid in such a way that no number is repeated in any row, column or internal square [n]\n",
  "SUDOR": "(Latin) sweat [n -S]\n",
  "SUDORAL": "pertaining to sweat [adj]\n",
  "SUDORIFEROUS": "inducing or secreting sweat [adj]\n",
  "SUDORIFIC": "inducing sweating [adj] / a drug causing or inducing sweat [n -S]\n",
  "SUDORIFICS": "SUDORIFIC, a drug causing or inducing sweat [n]\n",
  "SUDORIPAROUS": "secreting sweat [adj]\n",
  "SUDOROUS": "sweaty [adj]\n",
  "SUDORS": "SUDOR, (Latin) sweat [n]\n",
  "SUDS": "to wash in soapy water [v -ED, -ING, -ES]\n",
  "SUDSED": "SUDS, to wash in soapy water [v]\n",
  "SUDSER": "(slang) a soap opera [n -S]\n",
  "SUDSERS": "SUDSER, (slang) a soap opera [n]\n",
  "SUDSES": "SUDS, to wash in soapy water [v]\n",
  "SUDSIER": "SUDSY, full of suds [adj]\n",
  "SUDSIEST": "SUDSY, full of suds [adj]\n",
  "SUDSING": "SUDS, to wash in soapy water [v]\n",
  "SUDSLESS": "without suds [adj]\n",
  "SUDSY": "full of suds [adj SUDSIER, SUDSIEST]\n",
  "SUE": "to institute legal proceedings against [v SUED, SUING, SUES]\n",
  "SUEABILITIES": "SUEABILITY, liability to be sued, also SUABILITY [n]\n",
  "SUEABILITY": "liability to be sued, also SUABILITY [n SUEABILITIES]\n",
  "SUEABLE": "that may be sued, also SUABLE [adj]\n",
  "SUED": "SUE, to institute legal proceedings against [v]\n",
  "SUEDE": "to finish leather with a soft, napped surface [v SUEDED, SUEDING, SUEDES]\n",
  "SUEDED": "SUEDE, to finish leather with a soft, napped surface [v]\n",
  "SUEDELIKE": "like suede [adj]\n",
  "SUEDES": "SUEDE, to finish leather with a soft, napped surface [v]\n",
  "SUEDETTE": "a fabric made with a velvetlike nap representing suede [n -S]\n",
  "SUEDETTES": "SUEDETTE, a fabric made with a velvetlike nap representing suede [n]\n",
  "SUEDING": "SUEDE, to finish leather with a soft, napped surface [v]\n",
  "SUENT": "(dialect) smooth and evenly spread [adj]\n",
  "SUER": "one who sues [n -S]\n",
  "SUERS": "SUER, one who sues [n]\n",
  "SUES": "SUE, to institute legal proceedings against [v]\n",
  "SUET": "the hard, fatty tissue around the kidneys of cattle and sheep [n -S]\n",
  "SUETE": "(French) a southeasterly wind in areas of Cape Breton Island [n -S]\n",
  "SUETES": "SUETE, (French) a southeasterly wind in areas of Cape Breton Island [n]\n",
  "SUETIER": "SUETY, resembling suet, also SUETTY [adj]\n",
  "SUETIEST": "SUETY, resembling suet, also SUETTY [adj]\n",
  "SUETS": "SUET, the hard, fatty tissue around the kidneys of cattle and sheep [n]\n",
  "SUETTIER": "SUETTY, resembling suet, also SUETY [adj]\n",
  "SUETTIEST": "SUETTY, resembling suet, also SUETY [adj]\n",
  "SUETTY": "resembling suet, also SUETY [adj SUETTIER, SUETTIEST]\n",
  "SUETY": "resembling suet, also SUETTY [adj SUETIER, SUETIEST]\n",
  "SUFFARI": "(Swahili) a hunting expedition, also SAFARI [n -S]\n",
  "SUFFARIS": "SUFFARI, (Swahili) a hunting expedition, also SAFARI [n]\n",
  "SUFFECT": "(Latin) in ancient Rome, an additional consul elected during the official year [n -S]\n",
  "SUFFECTS": "SUFFECT, (Latin) in ancient Rome, an additional consul elected during the official year [n]\n",
  "SUFFER": "to feel pain or distress [v -ED, -ING, -S]\n",
  "SUFFERABLE": "that can be suffered [adj SUFFERABLY]\n",
  "SUFFERABLENESS": "the state of being sufferable [n]\n",
  "SUFFERABLY": "SUFFERABLE, that can be suffered [adv]\n",
  "SUFFERANCE": "passive tolerance, by the absence of objection rather than by express permission [n -S]\n",
  "SUFFERANCES": "SUFFERANCE, passive tolerance, by the absence of objection rather than by express permission [n]\n",
  "SUFFERED": "SUFFER, to feel pain or distress [v]\n",
  "SUFFERER": "one who suffers [n -S]\n",
  "SUFFERERS": "SUFFERER, one who suffers [n]\n",
  "SUFFERING": "feeling pain or distress [n -S]\n",
  "SUFFERINGLY": "SUFFERING [adv]\n",
  "SUFFERINGS": "SUFFERING, feeling pain or distress [n]\n",
  "SUFFERS": "SUFFER, to feel pain or distress [v]\n",
  "SUFFETE": "(Latin) one of the chief administrative officials of ancient Carthage [n -S]\n",
  "SUFFETES": "SUFFETE, (Latin) one of the chief administrative officials of ancient Carthage [n]\n",
  "SUFFICE": "to be adequate [v SUFFICED, SUFFICING, SUFFICES]\n",
  "SUFFICED": "SUFFICE, to be adequate [v]\n",
  "SUFFICER": "one who suffices [n -S]\n",
  "SUFFICERS": "SUFFICER, one who suffices [n]\n",
  "SUFFICES": "SUFFICE, to be adequate [v]\n",
  "SUFFICIENCE": "(archaic) a sufficiency [n -S]\n",
  "SUFFICIENCES": "SUFFICIENCE, (archaic) a sufficiency [n]\n",
  "SUFFICIENCIES": "SUFFICIENCY, the state of being sufficient, also SUFFICIENCE [n]\n",
  "SUFFICIENCY": "the state of being sufficient, also SUFFICIENCE [n SUFFICIENCIES]\n",
  "SUFFICIENT": "adequate [adj SUFFICIENTLY] / something sufficient [n -S]\n",
  "SUFFICIENTLY": "SUFFICIENT, adequate [adv]\n",
  "SUFFICIENTS": "SUFFICIENT, something sufficient [n]\n",
  "SUFFICING": "SUFFICE, to be adequate [v]\n",
  "SUFFICINGNESS": "the state of being sufficing [n -ES]\n",
  "SUFFICINGNESSES": "SUFFICINGNESS, the state of being sufficing [n]\n",
  "SUFFIGANCE": "(Shakespeare) Dogberry's blunder for suffisance [n -S]\n",
  "SUFFIGANCES": "SUFFIGANCE, (Shakespeare) Dogberry's blunder for suffisance [n]\n",
  "SUFFISANCE": "(obsolete) sufficiency [n -S]\n",
  "SUFFISANCES": "SUFFISANCE, (obsolete) sufficiency [n]\n",
  "SUFFIX": "to add to the end of a root word [v -ED, -ING, -ES]\n",
  "SUFFIXAL": "pertaining to a suffix [adj]\n",
  "SUFFIXATION": "the act of creating a suffix [n -S]\n",
  "SUFFIXATIONS": "SUFFIXATION, the act of creating a suffix [n]\n",
  "SUFFIXED": "SUFFIX, to add to the end of a root word [v]\n",
  "SUFFIXES": "SUFFIX, to add to the end of a root word [v]\n",
  "SUFFIXING": "SUFFIX, to add to the end of a root word [v]\n",
  "SUFFIXION": "the act of suffixing, or the state of being suffixed [n -S]\n",
  "SUFFIXIONS": "SUFFIXION, the act of suffixing, or the state of being suffixed [n]\n",
  "SUFFLATE": "(archaic) to inflate [v SUFFLATED, SUFFLATING, SUFFLATES]\n",
  "SUFFLATED": "SUFFLATE, (archaic) to inflate [v]\n",
  "SUFFLATES": "SUFFLATE, (archaic) to inflate [v]\n",
  "SUFFLATING": "SUFFLATE, (archaic) to inflate [v]\n",
  "SUFFLATION": "(archaic) the act of blowing up or inflating [n -S]\n",
  "SUFFLATIONS": "SUFFLATION, (archaic) the act of blowing up or inflating [n]\n",
  "SUFFOCATE": "to kill by depriving of air [v SUFFOCATED, SUFFOCATING, SUFFOCATES]\n",
  "SUFFOCATED": "SUFFOCATE, to kill by depriving of air [v]\n",
  "SUFFOCATES": "SUFFOCATE, to kill by depriving of air [v]\n",
  "SUFFOCATING": "oppressive [adj SUFFOCATINGLY] / the act of suffocation [n -S]\n",
  "SUFFOCATINGLY": "SUFFOCATING, oppressive [adv]\n",
  "SUFFOCATINGS": "SUFFOCATING, the act of suffocation [n]\n",
  "SUFFOCATION": "the act of suffocating [n -S]\n",
  "SUFFOCATIONS": "SUFFOCATION, the act of suffocating [n]\n",
  "SUFFOCATIVE": "serving to suffocate [adj]\n",
  "SUFFRAGAN": "an assistant bishop; any bishop in relation to his metropolitan [n -S]\n",
  "SUFFRAGANS": "SUFFRAGAN, an assistant bishop; any bishop in relation to his metropolitan [n]\n",
  "SUFFRAGANSHIP": "the office a suffragan [n -S]\n",
  "SUFFRAGANSHIPS": "SUFFRAGANSHIP, the office a suffragan [n]\n",
  "SUFFRAGE": "the right to vote [n -S]\n",
  "SUFFRAGES": "SUFFRAGE, the right to vote [n]\n",
  "SUFFRAGETTE": "(historical) a member of a movement demanding votes for women [n -S]\n",
  "SUFFRAGETTES": "SUFFRAGETTE, (historical) a member of a movement demanding votes for women [n]\n",
  "SUFFRAGETTISM": "belief in the aims of the suffragette [n -S]\n",
  "SUFFRAGETTISMS": "SUFFRAGETTISM, belief in the aims of the suffragette [n]\n",
  "SUFFRAGISM": "voting rights [n -S]\n",
  "SUFFRAGISMS": "SUFFRAGISM, voting rights [n]\n",
  "SUFFRAGIST": "one who possesses or exercises the political right of suffrage [n -S]\n",
  "SUFFRAGISTS": "SUFFRAGIST, one who possesses or exercises the political right of suffrage [n]\n",
  "SUFFRUTESCENT": "having a woody base [adj]\n",
  "SUFFRUTICOSE": "of a perennial plant, having a woody base, but remaining herbaceous in upper part [adj]\n",
  "SUFFUMIGATE": "to fumigate from below [v SUFFUMIGATED, SUFFUMIGATING, SUFFUMIGATES]\n",
  "SUFFUMIGATED": "SUFFUMIGATE, to fumigate from below [v]\n",
  "SUFFUMIGATES": "SUFFUMIGATE, to fumigate from below [v]\n",
  "SUFFUMIGATING": "SUFFUMIGATE, to fumigate from below [v]\n",
  "SUFFUMIGATION": "fumigation from below [n -S]\n",
  "SUFFUMIGATIONS": "SUFFUMIGATION, fumigation from below [n]\n",
  "SUFFUSE": "to spread throughout [v SUFFUSED, SUFFUSING, SUFFUSES]\n",
  "SUFFUSED": "SUFFUSE, to spread throughout [v]\n",
  "SUFFUSES": "SUFFUSE, to spread throughout [v]\n",
  "SUFFUSING": "SUFFUSE, to spread throughout [v]\n",
  "SUFFUSION": "the act of suffusing [n -S]\n",
  "SUFFUSIONS": "SUFFUSION, the act of suffusing [n]\n",
  "SUFFUSIVE": "relating to suffusion [adj]\n",
  "SUG": "to attempt to sell a product while purporting to be engaged in market research [v SUGGED, SUGGING, SUGS]\n",
  "SUGAN": "(Irish) a straw rope [n -S]\n",
  "SUGANS": "SUGAN, (Irish) a straw rope [n]\n",
  "SUGAR": "to sweeten with a carbohydrate [v -ED, -ING, -S]\n",
  "SUGARALLIE": "(Scots) liquorice, also SUGARALLY [n -S]\n",
  "SUGARALLIES": "SUGARALLIE, (Scots) liquorice, also SUGARALLY [n]\n",
  "SUGARALLY": "(Scots) liquorice, also SUGARALLIE [n SUGARALLIES]\n",
  "SUGARBERRIES": "SUGARBERRY, any of several hackberries with sweet edible fruits [n]\n",
  "SUGARBERRY": "any of several hackberries with sweet edible fruits [n SUGARBERRIES]\n",
  "SUGARBUSH": "an area covered in sugar maple trees [n -ES]\n",
  "SUGARBUSHES": "SUGARBUSH, an area covered in sugar maple trees [n]\n",
  "SUGARCANE": "a tall woody grass of tropical and semitropical regions, yielding sugar [n -S]\n",
  "SUGARCANES": "SUGARCANE, a tall woody grass of tropical and semitropical regions, yielding sugar [n]\n",
  "SUGARCOAT": "to coat with sugar; to make palatable [v -ED, -ING, -S]\n",
  "SUGARCOATED": "SUGARCOAT, to coat with sugar; to make palatable [v]\n",
  "SUGARCOATING": "SUGARCOAT, to coat with sugar; to make palatable [v]\n",
  "SUGARCOATS": "SUGARCOAT, to coat with sugar; to make palatable [v]\n",
  "SUGARED": "SUGAR, to sweeten with a carbohydrate [v]\n",
  "SUGARER": "one that makes sugar [n -S]\n",
  "SUGARERS": "SUGARER, one that makes sugar [n]\n",
  "SUGARHOUSE": "a factory etc. where sugar or maple syrup is made [n -S]\n",
  "SUGARHOUSES": "SUGARHOUSE, a factory etc. where sugar or maple syrup is made [n]\n",
  "SUGARIER": "SUGARY, containing sugar [adj]\n",
  "SUGARIEST": "SUGARY, containing sugar [adj]\n",
  "SUGARINESS": "the state of being sugary [n -ES]\n",
  "SUGARINESSES": "SUGARINESS, the state of being sugary [n]\n",
  "SUGARING": "sweetening with sugar [n -S]\n",
  "SUGARINGS": "SUGARING, sweetening with sugar [n]\n",
  "SUGARLESS": "without sugar; free from sugar [adj]\n",
  "SUGARLIKE": "like sugar [adj]\n",
  "SUGARLOAF": "a loaf or hard mass of refined sugar [n SUGARLOAVES]\n",
  "SUGARLOAVES": "SUGARLOAF, a loaf or hard mass of refined sugar [n]\n",
  "SUGARPLUM": "a kind of candy or sweetmeat made up in small balls or disks [n -S]\n",
  "SUGARPLUMS": "SUGARPLUM, a kind of candy or sweetmeat made up in small balls or disks [n]\n",
  "SUGARS": "SUGAR, to sweeten with a carbohydrate [v]\n",
  "SUGARY": "containing sugar [adj SUGARIER, SUGARIEST]\n",
  "SUGGED": "SUG, to attempt to sell a product while purporting to be engaged in market research [v]\n",
  "SUGGEST": "to put forward for consideration [v -ED, -ING, -S]\n",
  "SUGGESTED": "SUGGEST, to put forward for consideration [v]\n",
  "SUGGESTER": "one who suggests [n -S]\n",
  "SUGGESTERS": "SUGGESTER, one who suggests [n]\n",
  "SUGGESTIBILITY": "the state of being suggestible [n]\n",
  "SUGGESTIBLE": "easily influenced by suggestion [adj SUGGESTIBLY]\n",
  "SUGGESTIBLENESS": "the state of being suggestible [n]\n",
  "SUGGESTIBLY": "SUGGESTIBLE, easily influenced by suggestion [adv]\n",
  "SUGGESTING": "SUGGEST, to put forward for consideration [v]\n",
  "SUGGESTION": "the act of suggesting [n -S]\n",
  "SUGGESTIONISE": "to subject to suggestion, also SUGGESTIONIZE [v SUGGESTIONISED, SUGGESTIONISING, SUGGESTIONISES]\n",
  "SUGGESTIONISED": "SUGGESTIONISE, to subject to suggestion, also SUGGESTIONIZE [v]\n",
  "SUGGESTIONISES": "SUGGESTIONISE, to subject to suggestion, also SUGGESTIONIZE [v]\n",
  "SUGGESTIONISING": "SUGGESTIONISE, to subject to suggestion, also SUGGESTIONIZE [v]\n",
  "SUGGESTIONISM": "treatment by suggestion; the theory that hypnotic effects are entirely due to the action of suggestion [n -S]\n",
  "SUGGESTIONISMS": "SUGGESTIONISM, treatment by suggestion; the theory that hypnotic effects are entirely due to the action of suggestion [n]\n",
  "SUGGESTIONIST": "a believer in suggestionism [n -S]\n",
  "SUGGESTIONISTS": "SUGGESTIONIST, a believer in suggestionism [n]\n",
  "SUGGESTIONIZE": "to subject to suggestion, also SUGGESTIONISE [v SUGGESTIONIZED, SUGGESTIONIZING, SUGGESTIONIZES]\n",
  "SUGGESTIONIZED": "SUGGESTIONIZE, to subject to suggestion, also SUGGESTIONISE [v]\n",
  "SUGGESTIONIZES": "SUGGESTIONIZE, to subject to suggestion, also SUGGESTIONISE [v]\n",
  "SUGGESTIONIZING": "SUGGESTIONIZE, to subject to suggestion, also SUGGESTIONISE [v]\n",
  "SUGGESTIONS": "SUGGESTION, the act of suggesting [n]\n",
  "SUGGESTIVE": "giving a suggestion [adj SUGGESTIVELY]\n",
  "SUGGESTIVELY": "SUGGESTIVE, giving a suggestion [adv]\n",
  "SUGGESTIVENESS": "the state of being suggestive [n]\n",
  "SUGGESTS": "SUGGEST, to put forward for consideration [v]\n",
  "SUGGING": "selling under the guise of market research [n -S]\n",
  "SUGGINGS": "SUGGING, selling under the guise of market research [n]\n",
  "SUGH": "to make a moaning or sighing sound, also SOUGH [v -ED, -ING, -S]\n",
  "SUGHED": "SUGH, to make a moaning or sighing sound, also SOUGH [v]\n",
  "SUGHING": "SUGH, to make a moaning or sighing sound, also SOUGH [v]\n",
  "SUGHS": "SUGH, to make a moaning or sighing sound, also SOUGH [v]\n",
  "SUGO": "(Italian) an Italian meat sauce [n -S]\n",
  "SUGOS": "SUGO, (Italian) an Italian meat sauce [n]\n",
  "SUGS": "SUG, to attempt to sell a product while purporting to be engaged in market research [v]\n",
  "SUHUR": "a meal eaten before sunrise by those fasting during Ramadan, also SEHRI, SOHUR [n -S]\n",
  "SUHURS": "SUHUR, a meal eaten before sunrise by those fasting during Ramadan, also SEHRI, SOHUR [n]\n",
  "SUI": "(Latin) of himself, itself [pron]\n",
  "SUICIDAL": "self-destructive [adj SUICIDALLY]\n",
  "SUICIDALLY": "SUICIDAL, self-destructive [adv]\n",
  "SUICIDE": "to kill oneself intentionally [v SUICIDED, SUICIDING, SUICIDES]\n",
  "SUICIDED": "SUICIDE, to kill oneself intentionally [v]\n",
  "SUICIDES": "SUICIDE, to kill oneself intentionally [v]\n",
  "SUICIDING": "SUICIDE, to kill oneself intentionally [v]\n",
  "SUICIDOLOGIES": "SUICIDOLOGY, the study of suicide [n]\n",
  "SUICIDOLOGIST": "a student of suicidology [n -S]\n",
  "SUICIDOLOGISTS": "SUICIDOLOGIST, a student of suicidology [n]\n",
  "SUICIDOLOGY": "the study of suicide [n SUICIDOLOGIES]\n",
  "SUID": "any member of the pig family Suidae, including wild pigs, warthogs and the domestic pig, also SUIDIAN [n -S]\n",
  "SUIDIAN": "belonging to the pig family [adj] / a member of the pig family, also SUID [n -S]\n",
  "SUIDIANS": "SUIDIAN, a member of the pig family, also SUID [n]\n",
  "SUIDS": "SUID, any member of the pig family Suidae, including wild pigs, warthogs and the domestic pig, also SUIDIAN [n]\n",
  "SUILLINE": "of pigs [adj]\n",
  "SUING": "the act of suing [n -S]\n",
  "SUINGS": "SUING, the act of suing [n]\n",
  "SUINT": "a natural grease found in the wool of sheep [n -S]\n",
  "SUINTS": "SUINT, a natural grease found in the wool of sheep [n]\n",
  "SUIPLAP": "(South African) a drunkard [n -S]\n",
  "SUIPLAPS": "SUIPLAP, (South African) a drunkard [n]\n",
  "SUIT": "to be appropriate [v -ED, -ING, -S]\n",
  "SUITABILITIES": "SUITABILITY, the state of being suitable [n]\n",
  "SUITABILITY": "the state of being suitable [n SUITABILITIES]\n",
  "SUITABLE": "appropriate [adj SUITABLY]\n",
  "SUITABLENESS": "the state of being suitable [n -ES]\n",
  "SUITABLENESSES": "SUITABLENESS, the state of being suitable [n]\n",
  "SUITABLY": "SUITABLE, appropriate [adv]\n",
  "SUITCASE": "a piece of luggage for transporting possessions [n -S]\n",
  "SUITCASES": "SUITCASE, a piece of luggage for transporting possessions [n]\n",
  "SUITE": "(French) a series of things forming a unit [n -S]\n",
  "SUITED": "SUIT, to be appropriate [v]\n",
  "SUITER": "a special suitcase for holding suits [n -S]\n",
  "SUITERS": "SUITER, a special suitcase for holding suits [n]\n",
  "SUITES": "SUITE, (French) a series of things forming a unit [n]\n",
  "SUITING": "fabric for making suits [n -S]\n",
  "SUITINGS": "SUITING, fabric for making suits [n]\n",
  "SUITLIKE": "like a suit [adj]\n",
  "SUITOR": "one making a suit [n -S] / (archaic) to be or act as a suitor [v -ED, -ING, -S]\n",
  "SUITORED": "SUITOR, (archaic) to be or act as a suitor [v]\n",
  "SUITORING": "SUITOR, (archaic) to be or act as a suitor [v]\n",
  "SUITORS": "SUITOR, (archaic) to be or act as a suitor [v]\n",
  "SUITRESS": "a female suitor [n -ES]\n",
  "SUITRESSES": "SUITRESS, a female suitor [n]\n",
  "SUITS": "SUIT, to be appropriate [v]\n",
  "SUIVANTE": "(French) a waiting woman or confidential maid [n -S]\n",
  "SUIVANTES": "SUIVANTE, (French) a waiting woman or confidential maid [n]\n",
  "SUIVEZ": "(French) follow (the solo part, as a direction to accompanists) [v]\n",
  "SUJEE": "a solution of soap, soda etc. for cleaning the deck of a ship, also SOOGEE, SOOGIE, SOOJEY [n -S]\n",
  "SUJEES": "SUJEE, a solution of soap, soda etc. for cleaning the deck of a ship, also SOOGEE, SOOGIE, SOOJEY [n]\n",
  "SUK": "(Arabic) an Arab marketplace, also SUKH, SUQ [n -S]\n",
  "SUKH": "(Arabic) an Arab marketplace, also SUK, SUQ [n -S]\n",
  "SUKHS": "SUKH, (Arabic) an Arab marketplace, also SUK, SUQ [n]\n",
  "SUKIYAKI": "(Japanese) sliced meat, vegetables, and seasoning, fried together [n -S]\n",
  "SUKIYAKIS": "SUKIYAKI, (Japanese) sliced meat, vegetables, and seasoning, fried together [n]\n",
  "SUKKAH": "(Hebrew) a shelter where meals are eaten during Jewish festivals, also SUCCAH [n SUKKAHS or SUKKOS or SUKKOT or SUKKOTH]\n",
  "SUKKAHS": "SUKKAH, (Hebrew) a shelter where meals are eaten during Jewish festivals, also SUCCAH [n]\n",
  "SUKKOS": "SUKKAH, (Hebrew) a shelter where meals are eaten during Jewish festivals, also SUCCAH [n]\n",
  "SUKKOT": "SUKKAH, (Hebrew) a shelter where meals are eaten during Jewish festivals, also SUCCAH [n]\n",
  "SUKKOTH": "SUKKAH, (Hebrew) a shelter where meals are eaten during Jewish festivals, also SUCCAH [n]\n",
  "SUKS": "SUK, (Arabic) an Arab marketplace, also SUKH, SUQ [n]\n",
  "SUKUK": "(Arabic) a financial certificate that conforms to Muslim strictures on the charging or paying of interest [n -S]\n",
  "SUKUKS": "SUKUK, (Arabic) a financial certificate that conforms to Muslim strictures on the charging or paying of interest [n]\n",
  "SULCAL": "like a sulcus, grooved [adj]\n",
  "SULCALISE": "to furrow, also SULCALIZE [v SULCALISED, SULCALISING, SULCALISES]\n",
  "SULCALISED": "SULCALISE, to furrow, also SULCALIZE [v]\n",
  "SULCALISES": "SULCALISE, to furrow, also SULCALIZE [v]\n",
  "SULCALISING": "SULCALISE, to furrow, also SULCALIZE [v]\n",
  "SULCALIZE": "to furrow, also SULCALISE [v SULCALIZED, SULCALIZING, SULCALIZES]\n",
  "SULCALIZED": "SULCALIZE, to furrow, also SULCALISE [v]\n",
  "SULCALIZES": "SULCALIZE, to furrow, also SULCALISE [v]\n",
  "SULCALIZING": "SULCALIZE, to furrow, also SULCALISE [v]\n",
  "SULCATE": "having long, narrow furrows, also SULCATED [adj]\n",
  "SULCATED": "having long, narrow furrows, also SULCATE [adj]\n",
  "SULCATION": "a channel or furrow [n -S]\n",
  "SULCATIONS": "SULCATION, a channel or furrow [n]\n",
  "SULCI": "SULCUS, (Latin) a groove or furrow in a body, organ, or tissue, esp. one between two convolutions of the brain [n]\n",
  "SULCUS": "(Latin) a groove or furrow in a body, organ, or tissue, esp. one between two convolutions of the brain [n SULCI]\n",
  "SULDAN": "(Arabic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOLDAN, SOUDAN, SOULDAN, SULTAN [n -S]\n",
  "SULDANS": "SULDAN, (Arabic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOLDAN, SOUDAN, SOULDAN, SULTAN [n]\n",
  "SULFA": "a bacteria-inhibiting drug, also SULPHA [n -S]\n",
  "SULFACETAMIDE": "a sulphonamide used in eye drops against conjunctivitis, etc., also SULPHACETAMIDE [n -S]\n",
  "SULFACETAMIDES": "SULFACETAMIDE, a sulphonamide used in eye drops against conjunctivitis, etc., also SULPHACETAMIDE [n]\n",
  "SULFADIAZINE": "a sulfa drug used esp. in the treatment of toxoplasmosis [n -S]\n",
  "SULFADIAZINES": "SULFADIAZINE, a sulfa drug used esp. in the treatment of toxoplasmosis [n]\n",
  "SULFADIMIDINE": "a sulpha drug used in human and veterinary medicine [n -S]\n",
  "SULFADIMIDINES": "SULFADIMIDINE, a sulpha drug used in human and veterinary medicine [n]\n",
  "SULFADOXINE": "a drug used to prevent and treat malaria, also SULPHADOXINE [n -S]\n",
  "SULFADOXINES": "SULFADOXINE, a drug used to prevent and treat malaria, also SULPHADOXINE [n]\n",
  "SULFAMETHAZINE": "an American name for sulfadimidine, a white odourless crystalline compound formerly used in medicine in the treatment of bacterial infections [n -S]\n",
  "SULFAMETHAZINES": "SULFAMETHAZINE, an American name for sulfadimidine, a white odourless crystalline compound formerly used in medicine in the treatment of bacterial infections [n]\n",
  "SULFANILAMIDE": "a crystalline sulfonamide that is the parent compound of most of the sulfa drugs [n -S]\n",
  "SULFANILAMIDES": "SULFANILAMIDE, a crystalline sulfonamide that is the parent compound of most of the sulfa drugs [n]\n",
  "SULFAS": "SULFA, a bacteria-inhibiting drug, also SULPHA [n]\n",
  "SULFATASE": "any of various esterases that accelerate the hydrolysis of sulfuric esters, also SULPHATASE [n -S]\n",
  "SULFATASES": "SULFATASE, any of various esterases that accelerate the hydrolysis of sulfuric esters, also SULPHATASE [n]\n",
  "SULFATE": "to treat with sulfuric acid, also SULPHATE [v SULFATED, SULFATING, SULFATES]\n",
  "SULFATED": "SULFATE, to treat with sulfuric acid, also SULPHATE [v]\n",
  "SULFATES": "SULFATE, to treat with sulfuric acid, also SULPHATE [v]\n",
  "SULFATHIAZOLE": "a sulphonamide formerly used in human medicine against staphylococcal infection (now only used in veterinary medicine), also SULPHATHIAZOLE [n -S]\n",
  "SULFATHIAZOLES": "SULFATHIAZOLE, a sulphonamide formerly used in human medicine against staphylococcal infection (now only used in veterinary medicine), also SULPHATHIAZOLE [n]\n",
  "SULFATIC": "pertaining to a salt of sulphuric acid, also SULPHATIC [adj]\n",
  "SULFATING": "SULFATE, to treat with sulfuric acid, also SULPHATE [v]\n",
  "SULFATION": "the act of forming a sulfate, also SULPHATION [n -S]\n",
  "SULFATIONS": "SULFATION, the act of forming a sulfate, also SULPHATION [n]\n",
  "SULFHYDRYL": "a chemical group, SH, characteristic of sulphur-containing compounds, also SULPHHYDRYL [n -S]\n",
  "SULFHYDRYLS": "SULFHYDRYL, a chemical group, SH, characteristic of sulphur-containing compounds, also SULPHHYDRYL [n]\n",
  "SULFID": "a compound of an element or radical with sulphur, also SULFIDE, SULPHID, SULPHIDE [n -S]\n",
  "SULFIDE": "a compound of an element or radical with sulphur, also SULFID, SULPHID, SULPHIDE [n -S]\n",
  "SULFIDES": "SULFIDE, a compound of an element or radical with sulphur, also SULFID, SULPHID, SULPHIDE [n]\n",
  "SULFIDS": "SULFID, a compound of an element or radical with sulphur, also SULFIDE, SULPHID, SULPHIDE [n]\n",
  "SULFINPYRAZONE": "a uricosuric drug used in the long-term treatment of chronic gout [n -S]\n",
  "SULFINPYRAZONES": "SULFINPYRAZONE, a uricosuric drug used in the long-term treatment of chronic gout [n]\n",
  "SULFINYL": "the bivalent chemical group, SO, also SULPHINYL [n -S]\n",
  "SULFINYLS": "SULFINYL, the bivalent chemical group, SO, also SULPHINYL [n]\n",
  "SULFITE": "a salt of sulphurous acid, also SULPHITE [n -S]\n",
  "SULFITES": "SULFITE, a salt of sulphurous acid, also SULPHITE [n]\n",
  "SULFITIC": "pertaining to sulfite, also SULPHITIC [adj]\n",
  "SULFO": "containing a certain univalent radical, also SULFONIC [adj]\n",
  "SULFONAMIDE": "any of various amides, such as sulfanilamide, of a sulfonic acid [n -S]\n",
  "SULFONAMIDES": "SULFONAMIDE, any of various amides, such as sulfanilamide, of a sulfonic acid [n]\n",
  "SULFONATE": "a salt of sulphonic acid [n -S] / to convert into sulphonic acid, also SULPHONATE [v SULFONATED, SULFONATING, SULFONATES]\n",
  "SULFONATED": "SULFONATE, to convert into sulphonic acid, also SULPHONATE [v]\n",
  "SULFONATES": "SULFONATE, a salt of sulphonic acid [n]\n",
  "SULFONATING": "SULFONATE, to convert into sulphonic acid, also SULPHONATE [v]\n",
  "SULFONATION": "the act of sulfonating [n -S]\n",
  "SULFONATIONS": "SULFONATION, the act of sulfonating [n]\n",
  "SULFONE": "a sulfur compound, also SULPHONE [n -S]\n",
  "SULFONES": "SULFONE, a sulfur compound, also SULPHONE [n]\n",
  "SULFONIC": "relating to a sulfone, any of a class of substances consisting of two organic radicals combined with SO2, also SULPHONIC [adj]\n",
  "SULFONIUM": "the positively charged group SH3, its salts or derivatives, also SULPHONIUM [n -S]\n",
  "SULFONIUMS": "SULFONIUM, the positively charged group SH3, its salts or derivatives, also SULPHONIUM [n]\n",
  "SULFONMETHANE": "(US) a colourless crystalline compound used medicinally as a hypnotic, also SULPHONMETHANE [n -S]\n",
  "SULFONMETHANES": "SULFONMETHANE, (US) a colourless crystalline compound used medicinally as a hypnotic, also SULPHONMETHANE [n]\n",
  "SULFONYL": "a bivalent sulphone group, also SULFURYL, SULPHONYL, SULPHURYL [n -S]\n",
  "SULFONYLS": "SULFONYL, a bivalent sulphone group, also SULFURYL, SULPHONYL, SULPHURYL [n]\n",
  "SULFONYLUREA": "any of several hypoglycemic compounds related to the sulfonamides and used in the oral treatment of diabetes [n -S]\n",
  "SULFONYLUREAS": "SULFONYLUREA, any of several hypoglycemic compounds related to the sulfonamides and used in the oral treatment of diabetes [n]\n",
  "SULFOXIDE": "any of a class of carbon compounds featuring sulphur, also SULPHOXIDE [n -S]\n",
  "SULFOXIDES": "SULFOXIDE, any of a class of carbon compounds featuring sulphur, also SULPHOXIDE [n]\n",
  "SULFUR": "a non metallic element [n -S] / to treat with sulfur, also SULPHUR [v -ED, -ING, -S]\n",
  "SULFURATE": "to combine with sulfur, also SULPHURATE [v SULFURATED, SULFURATING, SULFURATES]\n",
  "SULFURATED": "SULFURATE, to combine with sulfur, also SULPHURATE [v]\n",
  "SULFURATES": "SULFURATE, to combine with sulfur, also SULPHURATE [v]\n",
  "SULFURATING": "SULFURATE, to combine with sulfur, also SULPHURATE [v]\n",
  "SULFURATION": "the process of treating with sulfur, also SULPHURATION [n -S]\n",
  "SULFURATIONS": "SULFURATION, the process of treating with sulfur, also SULPHURATION [n]\n",
  "SULFURED": "SULFUR, to treat with sulfur, also SULPHUR [v]\n",
  "SULFUREOUS": "pertaining to or like sulfur, also SULPHUREOUS [adj]\n",
  "SULFURET": "to treat with sulfur, also SULPHURET [v SULFURETED or SULFURETTED, SULFURETING or SULFURETTING, SULFURETS]\n",
  "SULFURETED": "SULFURET, to treat with sulfur, also SULPHURET [v]\n",
  "SULFURETING": "SULFURET, to treat with sulfur, also SULPHURET [v]\n",
  "SULFURETS": "SULFURET, to treat with sulfur, also SULPHURET [v]\n",
  "SULFURETTED": "SULFURET, to treat with sulfur, also SULPHURET [v]\n",
  "SULFURETTING": "SULFURET, to treat with sulfur, also SULPHURET [v]\n",
  "SULFURIC": "pertaining to sulfur, also SULPHURIC [adj]\n",
  "SULFURIER": "SULFURY, resembling, or partaking of the nature of, sulphur, also SULPHURY [adj]\n",
  "SULFURIEST": "SULFURY, resembling, or partaking of the nature of, sulphur, also SULPHURY [adj]\n",
  "SULFURING": "SULFUR, to treat with sulfur, also SULPHUR [v]\n",
  "SULFURISATION": "the process of sulfurising, also SULFURIZATION [n -S]\n",
  "SULFURISATIONS": "SULFURISATION, the process of sulfurising, also SULFURIZATION [n]\n",
  "SULFURISE": "to combine or impregnate with sulphur or any of its compounds, also SULFURIZE, SULPHURISE, SULPHURIZE [v SULFURISED, SULFURISING, SULFURISES]\n",
  "SULFURISED": "SULFURISE, to combine or impregnate with sulphur or any of its compounds, also SULFURIZE, SULPHURISE, SULPHURIZE [v]\n",
  "SULFURISES": "SULFURISE, to combine or impregnate with sulphur or any of its compounds, also SULFURIZE, SULPHURISE, SULPHURIZE [v]\n",
  "SULFURISING": "SULFURISE, to combine or impregnate with sulphur or any of its compounds, also SULFURIZE, SULPHURISE, SULPHURIZE [v]\n",
  "SULFURIZATION": "the process of treating with sulfur, also SULFURISATION [n -S]\n",
  "SULFURIZATIONS": "SULFURIZATION, the process of treating with sulfur, also SULFURISATION [n]\n",
  "SULFURIZE": "to combine or impregnate with sulphur or any of its compounds, also SULFURISE, SULPHURISE, SULPHURIZE [v SULFURIZED, SULFURIZING, SULFURIZES]\n",
  "SULFURIZED": "SULFURIZE, to combine or impregnate with sulphur or any of its compounds, also SULFURISE, SULPHURISE, SULPHURIZE [v]\n",
  "SULFURIZES": "SULFURIZE, to combine or impregnate with sulphur or any of its compounds, also SULFURISE, SULPHURISE, SULPHURIZE [v]\n",
  "SULFURIZING": "SULFURIZE, to combine or impregnate with sulphur or any of its compounds, also SULFURISE, SULPHURISE, SULPHURIZE [v]\n",
  "SULFUROUS": "containing sulphur in lower valency; pertaining to hellfire, also SULPHUROUS [adj SULFUROUSLY]\n",
  "SULFUROUSLY": "SULFUROUS, containing sulphur in lower valency; pertaining to hellfire, also SULPHUROUS [adv]\n",
  "SULFUROUSNESS": "the state of being sulfurous, also SULPHUROUSNESS [n -ES]\n",
  "SULFUROUSNESSES": "SULFUROUSNESS, the state of being sulfurous, also SULPHUROUSNESS [n]\n",
  "SULFURS": "SULFUR, to treat with sulfur, also SULPHUR [v]\n",
  "SULFURY": "resembling, or partaking of the nature of, sulphur, also SULPHURY [adj SULFURIER, SULFURIEST]\n",
  "SULFURYL": "a bivalent sulphone group, also SULFONYL, SULPHONYL, SULPHURYL [n -S]\n",
  "SULFURYLS": "SULFURYL, a bivalent sulphone group, also SULFONYL, SULPHONYL, SULPHURYL [n]\n",
  "SULK": "to become sullen and aloof [v -ED, -ING, -S]\n",
  "SULKED": "SULK, to become sullen and aloof [v]\n",
  "SULKER": "one who sulks [n -S]\n",
  "SULKERS": "SULKER, one who sulks [n]\n",
  "SULKIER": "SULKY, in a resentful mood [adj]\n",
  "SULKIES": "SULKY, a kind of horse-drawn vehicle [n]\n",
  "SULKIEST": "SULKY, in a resentful mood [adj]\n",
  "SULKILY": "SULKY, in a resentful mood [adv]\n",
  "SULKINESS": "the state of being sulky [n -ES]\n",
  "SULKINESSES": "SULKINESS, the state of being sulky [n]\n",
  "SULKING": "SULK, to become sullen and aloof [v]\n",
  "SULKS": "SULK, to become sullen and aloof [v]\n",
  "SULKY": "in a resentful mood [adj SULKIER, SULKIEST, SULKILY] / a kind of horse-drawn vehicle [n SULKIES]\n",
  "SULLAGE": "filth; refuse; sewage [n -S]\n",
  "SULLAGES": "SULLAGE, filth; refuse; sewage [n]\n",
  "SULLEN": "showing brooding ill humour [adj SULLENER, SULLENEST, SULLENLY] / a sullen mood [n -S]\n",
  "SULLENER": "SULLEN, showing brooding ill humour [adj]\n",
  "SULLENEST": "SULLEN, showing brooding ill humour [adj]\n",
  "SULLENLY": "SULLEN, showing brooding ill humour [adv]\n",
  "SULLENNESS": "the state of being sullen [n -ES]\n",
  "SULLENNESSES": "SULLENNESS, the state of being sullen [n]\n",
  "SULLENS": "SULLEN, a sullen mood [n]\n",
  "SULLIABLE": "that can be sullied [adj]\n",
  "SULLIED": "SULLY, to soil, make impure [v]\n",
  "SULLIES": "SULLY, to soil, make impure [v]\n",
  "SULLY": "to soil, make impure [v SULLIED, SULLYING, SULLIES]\n",
  "SULLYING": "SULLY, to soil, make impure [v]\n",
  "SULPH": "(slang) amphetamine sulphate [n -S]\n",
  "SULPHA": "a bacteria-inhibiting drug, also SULFA [n -S]\n",
  "SULPHACETAMIDE": "a sulphonamide used in eye drops against conjunctivitis, etc., also SULFACETAMIDE [n -S]\n",
  "SULPHACETAMIDES": "SULPHACETAMIDE, a sulphonamide used in eye drops against conjunctivitis, etc., also SULFACETAMIDE [n]\n",
  "SULPHADIAZINE": "a sulphonamide used, usually in combination with an antibiotic, in the treatment of pneumonia, meningitis, etc. [n -S]\n",
  "SULPHADIAZINES": "SULPHADIAZINE, a sulphonamide used, usually in combination with an antibiotic, in the treatment of pneumonia, meningitis, etc. [n]\n",
  "SULPHADOXINE": "an antibiotic drug of the sulphonamide group, commonly used in combination with pyrimethamine to treat malaria, also SULFADOXINE [n -S]\n",
  "SULPHADOXINES": "SULPHADOXINE, an antibiotic drug of the sulphonamide group, commonly used in combination with pyrimethamine to treat malaria, also SULFADOXINE [n]\n",
  "SULPHANILAMIDE": "a white crystalline compound formerly used as an antibacterial drug [n -S]\n",
  "SULPHANILAMIDES": "SULPHANILAMIDE, a white crystalline compound formerly used as an antibacterial drug [n]\n",
  "SULPHAS": "SULPHA, a bacteria-inhibiting drug, also SULFA [n]\n",
  "SULPHATASE": "any of various esterases that accelerate the hydrolysis of sulfuric esters, also SULFATASE [n -S]\n",
  "SULPHATASES": "SULPHATASE, any of various esterases that accelerate the hydrolysis of sulfuric esters, also SULFATASE [n]\n",
  "SULPHATE": "to treat with sulfuric acid, also SULFATE [v SULPHATED, SULPHATING, SULPHATES]\n",
  "SULPHATED": "SULPHATE, to treat with sulfuric acid, also SULFATE [v]\n",
  "SULPHATES": "SULPHATE, to treat with sulfuric acid, also SULFATE [v]\n",
  "SULPHATHIAZOLE": "a sulphonamide formerly used in human medicine against staphylococcal infection (now only used in veterinary medicine), also SULFATHIAZOLE [n -S]\n",
  "SULPHATHIAZOLES": "SULPHATHIAZOLE, a sulphonamide formerly used in human medicine against staphylococcal infection (now only used in veterinary medicine), also SULFATHIAZOLE [n]\n",
  "SULPHATIC": "pertaining to a salt of sulphuric acid, also SULFATIC [adj]\n",
  "SULPHATING": "SULPHATE, to treat with sulfuric acid, also SULFATE [v]\n",
  "SULPHATION": "the act of forming a sulphate, also SULFATION [n -S]\n",
  "SULPHATIONS": "SULPHATION, the act of forming a sulphate, also SULFATION [n]\n",
  "SULPHHYDRYL": "a chemical group, SH, characteristic of sulphur-containing compounds, also SULFHYDRYL [n -S]\n",
  "SULPHHYDRYLS": "SULPHHYDRYL, a chemical group, SH, characteristic of sulphur-containing compounds, also SULFHYDRYL [n]\n",
  "SULPHID": "a sulfur compound, also SULFIDE, SULFID, SULPHIDE [n -S]\n",
  "SULPHIDE": "a sulfur compound, also SULFIDE, SULFID, SULPHID [n -S]\n",
  "SULPHIDES": "SULPHIDE, a sulfur compound, also SULFIDE, SULFID, SULPHID [n]\n",
  "SULPHIDS": "SULPHID, a sulfur compound, also SULFIDE, SULFID, SULPHIDE [n]\n",
  "SULPHINPYRAZONE": "a drug used to treat gout [n]\n",
  "SULPHINYL": "the bivalent chemical group SO, also SULFINYL [n -S]\n",
  "SULPHINYLS": "SULPHINYL, the bivalent chemical group SO, also SULFINYL [n]\n",
  "SULPHITE": "a salt of sulphurous acid, also SULFITE [n -S]\n",
  "SULPHITES": "SULPHITE, a salt of sulphurous acid, also SULFITE [n]\n",
  "SULPHITIC": "pertaining to sulfite, also SULFITIC [adj]\n",
  "SULPHONAMIDE": "an organic amide of a sulphonic acid; specifically any of the drugs derived from sulphanilamide [n -S]\n",
  "SULPHONAMIDES": "SULPHONAMIDE, an organic amide of a sulphonic acid; specifically any of the drugs derived from sulphanilamide [n]\n",
  "SULPHONATE": "a salt of sulphonic acid [n -S] / to convert into sulphonic acid, also SULFONATE [v SULPHONATED, SULPHONATING, SULPHONATES]\n",
  "SULPHONATED": "SULPHONATE, to convert into sulphonic acid, also SULFONATE [v]\n",
  "SULPHONATES": "SULPHONATE, a salt of sulphonic acid [n]\n",
  "SULPHONATING": "SULPHONATE, to convert into sulphonic acid, also SULFONATE [v]\n",
  "SULPHONATION": "the act of sulphonating [n -S]\n",
  "SULPHONATIONS": "SULPHONATION, the act of sulphonating [n]\n",
  "SULPHONE": "a sulfur compound, also SULFONE [n -S]\n",
  "SULPHONES": "SULPHONE, a sulfur compound, also SULFONE [n]\n",
  "SULPHONIC": "relating to a sulphone, any of a class of substances consisting of two organic radicals combined with SO2, also SULFONIC [adj]\n",
  "SULPHONIUM": "the positively charged group SH3, its salts or derivatives, also SULFONIUM [n -S]\n",
  "SULPHONIUMS": "SULPHONIUM, the positively charged group SH3, its salts or derivatives, also SULFONIUM [n]\n",
  "SULPHONMETHANE": "a colourless crystalline compound used medicinally as a hypnotic, also SULFONMETHANE [n -S]\n",
  "SULPHONMETHANES": "SULPHONMETHANE, a colourless crystalline compound used medicinally as a hypnotic, also SULFONMETHANE [n]\n",
  "SULPHONYL": "a particular chemical divalent group, also SULFONYL, SULFURYL, SULPHURYL [n -S]\n",
  "SULPHONYLS": "SULPHONYL, a particular chemical divalent group, also SULFONYL, SULFURYL, SULPHURYL [n]\n",
  "SULPHONYLUREA": "a synthetic compound used to reduce the level of glucose in the blood in diabetes mellitus [n -S]\n",
  "SULPHONYLUREAS": "SULPHONYLUREA, a synthetic compound used to reduce the level of glucose in the blood in diabetes mellitus [n]\n",
  "SULPHOXIDE": "any compound containing a sulphinyl group and a hydrocarbon radical, also SULFOXIDE [n -S]\n",
  "SULPHOXIDES": "SULPHOXIDE, any compound containing a sulphinyl group and a hydrocarbon radical, also SULFOXIDE [n]\n",
  "SULPHS": "SULPH, (slang) amphetamine sulphate [n]\n",
  "SULPHUR": "a non metallic element [n -S] / to treat with sulphur, also SULFUR [v -ED, -ING, -S]\n",
  "SULPHURATE": "to combine with sulphur, also SULFURATE [v SULPHURATED, SULPHURATING, SULPHURATES]\n",
  "SULPHURATED": "SULPHURATE, to combine with sulphur, also SULFURATE [v]\n",
  "SULPHURATES": "SULPHURATE, to combine with sulphur, also SULFURATE [v]\n",
  "SULPHURATING": "SULPHURATE, to combine with sulphur, also SULFURATE [v]\n",
  "SULPHURATION": "the act of sulphurating, also SULFURATION [n -S]\n",
  "SULPHURATIONS": "SULPHURATION, the act of sulphurating, also SULFURATION [n]\n",
  "SULPHURATOR": "a device for sulphurating [n -S]\n",
  "SULPHURATORS": "SULPHURATOR, a device for sulphurating [n]\n",
  "SULPHURED": "SULPHUR, to treat with sulphur, also SULFUR [v]\n",
  "SULPHUREOUS": "pertaining to or like sulphur, also SULFUREOUS [adj SULPHUREOUSLY]\n",
  "SULPHUREOUSLY": "SULPHUREOUS, pertaining to or like sulphur, also SULFUREOUS [adv]\n",
  "SULPHUREOUSNESS": "the state of being sulphureous [n]\n",
  "SULPHURET": "to treat with sulfur, also SULFURET [v SULPHURETED or SULPHURETTED, SULPHURETING or SULPHURETTING, SULPHURETS]\n",
  "SULPHURETED": "SULPHURET, to treat with sulfur, also SULFURET [v]\n",
  "SULPHURETING": "SULPHURET, to treat with sulfur, also SULFURET [v]\n",
  "SULPHURETS": "SULPHURET, to treat with sulfur, also SULFURET [v]\n",
  "SULPHURETTED": "SULPHURET, to treat with sulfur, also SULFURET [v]\n",
  "SULPHURETTING": "SULPHURET, to treat with sulfur, also SULFURET [v]\n",
  "SULPHURIC": "pertaining to sulfur, also SULFURIC [adj]\n",
  "SULPHURIER": "SULPHURY, resembling, or partaking of the nature of, sulphur, also SULFURY [adj]\n",
  "SULPHURIEST": "SULPHURY, resembling, or partaking of the nature of, sulphur, also SULFURY [adj]\n",
  "SULPHURING": "SULPHUR, to treat with sulphur, also SULFUR [v]\n",
  "SULPHURISATION": "the process of sulphurising, also SULPHURIZATION [n -S]\n",
  "SULPHURISATIONS": "SULPHURISATION, the process of sulphurising, also SULPHURIZATION [n]\n",
  "SULPHURISE": "to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURIZE [v SULPHURISED, SULPHURISING, SULPHURISES]\n",
  "SULPHURISED": "SULPHURISE, to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURIZE [v]\n",
  "SULPHURISES": "SULPHURISE, to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURIZE [v]\n",
  "SULPHURISING": "SULPHURISE, to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURIZE [v]\n",
  "SULPHURIZATION": "the process of sulphurizing, also SULPHURISATION [n -S]\n",
  "SULPHURIZATIONS": "SULPHURIZATION, the process of sulphurizing, also SULPHURISATION [n]\n",
  "SULPHURIZE": "to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURISE [v SULPHURIZED, SULPHURIZING, SULPHURIZES]\n",
  "SULPHURIZED": "SULPHURIZE, to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURISE [v]\n",
  "SULPHURIZES": "SULPHURIZE, to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURISE [v]\n",
  "SULPHURIZING": "SULPHURISE, to combine or impregnate with sulphur, also SULFURISE, SULFURIZE, SULPHURIZE [v]\n",
  "SULPHUROUS": "containing sulphur in lower valency; pertaining to hellfire, also SULFUROUS [adj SULPHUROUSLY]\n",
  "SULPHUROUSLY": "SULPHUROUS, containing sulphur in lower valency; pertaining to hellfire, also SULFUROUS [adv]\n",
  "SULPHUROUSNESS": "the state of being sulphurous, also SULFUROUSNESS [n]\n",
  "SULPHURS": "SULPHUR, to treat with sulphur, also SULFUR [v]\n",
  "SULPHURWORT": "an umbelliferous plant akin to parsnip, with yellow flowers and juice [n -S]\n",
  "SULPHURWORTS": "SULPHURWORT, an umbelliferous plant akin to parsnip, with yellow flowers and juice [n]\n",
  "SULPHURY": "resembling, or partaking of the nature of, sulphur, also SULFURY [adj SULPHURIER, SULPHURIEST]\n",
  "SULPHURYL": "a particular chemical divalent group, also SULFONYL, SULFURYL, SULPHONYL [n -S]\n",
  "SULPHURYLS": "SULPHURYL, a particular chemical divalent group, also SULFONYL, SULFURYL, SULPHONYL [n]\n",
  "SULTAN": "(Arabic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOLDAN, SOUDAN, SOULDAN, SULDAN [n -S]\n",
  "SULTANA": "a small, pale, seedless raisin [n -S]\n",
  "SULTANAS": "SULTANA, a small, pale, seedless raisin [n]\n",
  "SULTANATE": "the rule or dominion of a sultan [n -S]\n",
  "SULTANATES": "SULTANATE, the rule or dominion of a sultan [n]\n",
  "SULTANESS": "a female sultan [n -ES]\n",
  "SULTANESSES": "SULTANESS, a female sultan [n]\n",
  "SULTANIC": "pertaining to a sultan [adj]\n",
  "SULTANS": "SULTAN, (Arabic) the monarch or chief ruler of a Muslim country, esp. that of Turkey, also SOLDAN, SOUDAN, SOULDAN, SULDAN [n]\n",
  "SULTANSHIP": "the office or dignity of a sultan [n -S]\n",
  "SULTANSHIPS": "SULTANSHIP, the office or dignity of a sultan [n]\n",
  "SULTRIER": "SULTRY, humid and oppressive [adj]\n",
  "SULTRIEST": "SULTRY, humid and oppressive [adj]\n",
  "SULTRILY": "SULTRY, humid and oppressive [adv]\n",
  "SULTRINESS": "the state of being sultry [n -ES]\n",
  "SULTRINESSES": "SULTRINESS, the state of being sultry [n]\n",
  "SULTRY": "humid and oppressive [adj SULTRIER, SULTRIEST, SULTRILY]\n",
  "SULU": "(Fijian) in Fiji, a cloth worn as a sarong [n -S]\n",
  "SULUS": "SULU, (Fijian) in Fiji, a cloth worn as a sarong [n]\n",
  "SUM": "a monetary unit of Uzbekistan [n SUMY] / to add, make up the total of [v SUMMED, SUMMING, SUMS]\n",
  "SUMAC": "any of various shrubs and small trees of the genus Rhus, also SUMACH [n -S]\n",
  "SUMACH": "any of various shrubs and small trees of the genus Rhus, also SUMAC [n -S]\n",
  "SUMACHS": "SUMACH, any of various shrubs and small trees of the genus Rhus, also SUMAC [n]\n",
  "SUMACS": "SUMAC, any of various shrubs and small trees of the genus Rhus, also SUMACH [n]\n",
  "SUMATRA": "a short, violent squall in or near the Straits of Malacca, coming from Sumatra [n -S]\n",
  "SUMATRAS": "SUMATRA, a short, violent squall in or near the Straits of Malacca, coming from Sumatra [n]\n",
  "SUMBITCH": "(colloquial) sonofabitch [n -ES]\n",
  "SUMBITCHES": "SUMBITCH, (colloquial) sonofabitch [n]\n",
  "SUMI": "(Japanese) a type of black Japanese ink [n -S]\n",
  "SUMIS": "SUMI, (Japanese) a type of black Japanese ink [n]\n",
  "SUMLESS": "too large for calculation [adj]\n",
  "SUMMA": "(Latin) a comprehensive work covering a specific subject [n SUMMAS or SUMMAE]\n",
  "SUMMABILITIES": "SUMMABILITY, the ability to be summed [n]\n",
  "SUMMABILITY": "the ability to be summed [n SUMMABILITIES]\n",
  "SUMMABLE": "able to be summed [adj]\n",
  "SUMMAE": "SUMMA, (Latin) a comprehensive work covering a specific subject [n]\n",
  "SUMMAND": "an addend, a number to be added in a sum [n -S]\n",
  "SUMMANDS": "SUMMAND, an addend, a number to be added in a sum [n]\n",
  "SUMMAR": "(Scots) summary [adj]\n",
  "SUMMARIES": "SUMMARY, a condensation of the substance of a larger work [n]\n",
  "SUMMARILY": "SUMMARY, condensed, brief [adv]\n",
  "SUMMARINESS": "the state of being summary [n -ES]\n",
  "SUMMARINESSES": "SUMMARINESS, the state of being summary [n]\n",
  "SUMMARISABLE": "capable of being summarised, also SUMMARIZABLE [adj]\n",
  "SUMMARISATION": "the act of summarising, also SUMMARIZATION [n -S]\n",
  "SUMMARISATIONS": "SUMMARISATION, the act of summarising, also SUMMARIZATION [n]\n",
  "SUMMARISE": "to make a summary of, also SUMMARIZE [v SUMMARISED, SUMMARISING, SUMMARISES]\n",
  "SUMMARISED": "SUMMARISE, to make a summary of, also SUMMARIZE [v]\n",
  "SUMMARISER": "one who summarises, also SUMMARIZER [n -S]\n",
  "SUMMARISERS": "SUMMARISER, one who summarises, also SUMMARIZER [n]\n",
  "SUMMARISES": "SUMMARISE, to make a summary of, also SUMMARIZE [v]\n",
  "SUMMARISING": "SUMMARISE, to make a summary of, also SUMMARIZE [v]\n",
  "SUMMARIST": "one who summarized [n -S]\n",
  "SUMMARISTS": "SUMMARIST, one who summarized [n]\n",
  "SUMMARIZABLE": "capable of being summarized, also SUMMARISABLE [adj]\n",
  "SUMMARIZATION": "the act of summarizing, also SUMMARISATION [n -S]\n",
  "SUMMARIZATIONS": "SUMMARIZATION, the act of summarizing, also SUMMARISATION [n]\n",
  "SUMMARIZE": "to make a summary of, also SUMMARISE [v SUMMARIZED, SUMMARIZING, SUMMARIZES]\n",
  "SUMMARIZED": "SUMMARIZE, to make a summary of, also SUMMARISE [v]\n",
  "SUMMARIZER": "one who summarizes, also SUMMARISER [n -S]\n",
  "SUMMARIZERS": "SUMMARIZER, one who summarizes, also SUMMARISER [n]\n",
  "SUMMARIZES": "SUMMARIZE, to make a summary of, also SUMMARISE [v]\n",
  "SUMMARIZING": "SUMMARIZE, to make a summary of, also SUMMARISE [v]\n",
  "SUMMARY": "condensed, brief [adj SUMMARILY] / a condensation of the substance of a larger work [n SUMMARIES]\n",
  "SUMMAS": "SUMMA, (Latin) a comprehensive work covering a specific subject [n]\n",
  "SUMMAT": "(dialect) something, somewhat [n -S]\n",
  "SUMMATE": "to add together [v SUMMATED, SUMMATING, SUMMATES]\n",
  "SUMMATED": "SUMMATE, to add together [v]\n",
  "SUMMATES": "SUMMATE, to add together [v]\n",
  "SUMMATING": "SUMMATE, to add together [v]\n",
  "SUMMATION": "the act of summing [n -S]\n",
  "SUMMATIONAL": "relating to summation, the act of summing [adj]\n",
  "SUMMATIONS": "SUMMATION, the act of summing [n]\n",
  "SUMMATIVE": "relating to summation, the act of summing [adj]\n",
  "SUMMATS": "SUMMAT, (dialect) something, somewhat [n]\n",
  "SUMMED": "SUM, to add, make up the total of [v]\n",
  "SUMMER": "to pass the warmest season of the year [v -ED, -ING, -S]\n",
  "SUMMERED": "SUMMER, to pass the warmest season of the year [v]\n",
  "SUMMERHOUSE": "an outdoor structure for use during the summer [n -S]\n",
  "SUMMERHOUSES": "SUMMERHOUSE, an outdoor structure for use during the summer [n]\n",
  "SUMMERIER": "SUMMERY, characteristic of summer, also SUMMERLY [adj]\n",
  "SUMMERIEST": "SUMMERY, characteristic of summer, also SUMMERLY [adj]\n",
  "SUMMERINESS": "the state of being summery [n -ES]\n",
  "SUMMERINESSES": "SUMMERINESS, the state of being summery [n]\n",
  "SUMMERING": "passing the summer [n -S]\n",
  "SUMMERINGS": "SUMMERING, passing the summer [n]\n",
  "SUMMERLESS": "without a summer [adj]\n",
  "SUMMERLIER": "SUMMERLY, of or like summer, also SUMMERY [adj]\n",
  "SUMMERLIEST": "SUMMERLY, of or like summer, also SUMMERY [adj]\n",
  "SUMMERLIKE": "like summer e.g. of weather [adj]\n",
  "SUMMERLONG": "lasting all summer [adj]\n",
  "SUMMERLY": "of or like summer, also SUMMERY [adj SUMMERLIER, SUMMERLIEST]\n",
  "SUMMERS": "SUMMER, to pass the warmest season of the year [v]\n",
  "SUMMERSAULT": "to perform a leap in which a person turns his heels over his head and lights upon his feet; a turning end over end, also SOMERSAULT, SOMERSET, SUMMERSET [v -ED, -ING, -S]\n",
  "SUMMERSAULTED": "SUMMERSAULT, to perform a leap in which a person turns his heels over his head and lights upon his feet; a turning end over end, also SOMERSAULT, SOMERSET, SUMMERSET [v]\n",
  "SUMMERSAULTING": "SUMMERSAULT, to perform a leap in which a person turns his heels over his head and lights upon his feet; a turning end over end, also SOMERSAULT, SOMERSET, SUMMERSET [v]\n",
  "SUMMERSAULTS": "SUMMERSAULT, to perform a leap in which a person turns his heels over his head and lights upon his feet; a turning end over end, also SOMERSAULT, SOMERSET, SUMMERSET [v]\n",
  "SUMMERSET": "a leap in which a person turns his heels over his head and lights upon his feet [n -S] / to somersault, also SOMERSAULT, SOMERSET, SUMMERSAULT [v SUMMERSETTED, SUMMERSETTING, SUMMERSETS]\n",
  "SUMMERSETS": "SUMMERSET, a leap in which a person turns his heels over his head and lights upon his feet [n]\n",
  "SUMMERSETTED": "SUMMERSET, to somersault, also SOMERSAULT, SOMERSET, SUMMERSAULT [v]\n",
  "SUMMERSETTING": "SUMMERSET, to somersault, also SOMERSAULT, SOMERSET, SUMMERSAULT [v]\n",
  "SUMMERTIDE": "summer time [n -S]\n",
  "SUMMERTIDES": "SUMMERTIDE, summer time [n]\n",
  "SUMMERTIME": "the time during which it is summer [n -S]\n",
  "SUMMERTIMES": "SUMMERTIME, the time during which it is summer [n]\n",
  "SUMMERWEIGHT": "of clothes, suitable in weight for wear in the summer; relatively light [adj]\n",
  "SUMMERWOOD": "wood with smaller and thicker-walled cells than springwood [n -S]\n",
  "SUMMERWOODS": "SUMMERWOOD, wood with smaller and thicker-walled cells than springwood [n]\n",
  "SUMMERY": "characteristic of summer, also SUMMERLY [adj SUMMERIER, SUMMERIEST]\n",
  "SUMMING": "the act of summing [n -S]\n",
  "SUMMINGS": "SUMMING, the act of summing [n]\n",
  "SUMMIST": "a writer of summae; an epitomist [n -S]\n",
  "SUMMISTS": "SUMMIST, a writer of summae; an epitomist [n]\n",
  "SUMMIT": "to take part in a summit conference [v -ED, -ING, -S]\n",
  "SUMMITAL": "pertaining to the summit [adj]\n",
  "SUMMITED": "SUMMIT, to take part in a summit conference [v]\n",
  "SUMMITEER": "a participant in summit conferences [n -S]\n",
  "SUMMITEERS": "SUMMITEER, a participant in summit conferences [n]\n",
  "SUMMITING": "SUMMIT, to take part in a summit conference [v]\n",
  "SUMMITLESS": "having no summit [adj]\n",
  "SUMMITRIES": "SUMMITRY, conferences between world leaders for negotiation [n]\n",
  "SUMMITRY": "conferences between world leaders for negotiation [n SUMMITRIES]\n",
  "SUMMITS": "SUMMIT, to take part in a summit conference [v]\n",
  "SUMMON": "to order to appear [v -ED, -ING, -S]\n",
  "SUMMONABLE": "that can be summoned [adj]\n",
  "SUMMONED": "SUMMON, to order to appear [v]\n",
  "SUMMONER": "one who summons [n -S]\n",
  "SUMMONERS": "SUMMONER, one who summons [n]\n",
  "SUMMONING": "SUMMON, to order to appear [v]\n",
  "SUMMONS": "a call to appear in court [n -ES] / to summon with a court order [v -ED, -ING, -ES]\n",
  "SUMMONSED": "SUMMONS, to summon with a court order [v]\n",
  "SUMMONSES": "SUMMONS, to summon with a court order [v]\n",
  "SUMMONSING": "SUMMONS, to summon with a court order [v]\n",
  "SUMO": "(Japanese) a form of wrestling [n -S]\n",
  "SUMOIST": "a sumo wrestler [n -S]\n",
  "SUMOISTS": "SUMOIST, a sumo wrestler [n]\n",
  "SUMOS": "SUMO, (Japanese) a form of wrestling [n]\n",
  "SUMOTORI": "(Japanese) a sumo wrestler [n -S]\n",
  "SUMOTORIS": "SUMOTORI, (Japanese) a sumo wrestler [n]\n",
  "SUMP": "a low area serving as a drain [n -S]\n",
  "SUMPH": "(Scots) a dunce, a blockhead [n -S]\n",
  "SUMPHISH": "(Scots) stupid, doltish [adj]\n",
  "SUMPHISHNESS": "the state of being sumphish, stupid [n -ES]\n",
  "SUMPHISHNESSES": "SUMPHISHNESS, the state of being sumphish, stupid [n]\n",
  "SUMPHS": "SUMPH, (Scots) a dunce, a blockhead [n]\n",
  "SUMPIT": "(Malay) a Malay blowpipe made from a hollow cane, also SUMPITAN [n -S]\n",
  "SUMPITAN": "(Malay) a Malay blowpipe made from a hollow cane, also SUMPIT [n -S]\n",
  "SUMPITANS": "SUMPITAN, (Malay) a Malay blowpipe made from a hollow cane, also SUMPIT [n]\n",
  "SUMPITS": "SUMPIT, (Malay) a Malay blowpipe made from a hollow cane, also SUMPITAN [n]\n",
  "SUMPS": "SUMP, a low area serving as a drain [n]\n",
  "SUMPSIMUS": "(Latin) a correct expression that replaces a popular but wrong one [n -ES]\n",
  "SUMPSIMUSES": "SUMPSIMUS, (Latin) a correct expression that replaces a popular but wrong one [n]\n",
  "SUMPTER": "(archaic) a pack horse; a beast of burden [n -S]\n",
  "SUMPTERS": "SUMPTER, (archaic) a pack horse; a beast of burden [n]\n",
  "SUMPTUARY": "relating to or regulating expense; relating to the control or moderation of extravagance [adj]\n",
  "SUMPTUOSITIES": "SUMPTUOSITY, the quality of being sumptuous [n]\n",
  "SUMPTUOSITY": "the quality of being sumptuous [n SUMPTUOSITIES]\n",
  "SUMPTUOUS": "luxurious [adj SUMPTUOUSLY]\n",
  "SUMPTUOUSLY": "SUMPTUOUS, luxurious [adv]\n",
  "SUMPTUOUSNESS": "the quality of being sumptuous [n -ES]\n",
  "SUMPTUOUSNESSES": "SUMPTUOUSNESS, the quality of being sumptuous [n]\n",
  "SUMPWEED": "a marsh plant [n -S]\n",
  "SUMPWEEDS": "SUMPWEED, a marsh plant [n]\n",
  "SUMS": "SUM, to add, make up the total of [v]\n",
  "SUMY": "SUM, a monetary unit of Uzbekistan [n]\n",
  "SUN": "to expose to sunlight [v SUNNED, SUNNING, SUNS]\n",
  "SUNBACK": "cut low to expose the back to sunlight [adj]\n",
  "SUNBAKE": "to bake e.g. mud hard by the action of sun [v SUNBAKED, SUNBAKING, SUNBAKES]\n",
  "SUNBAKED": "SUNBAKE, to bake e.g. mud hard by the action of sun [v]\n",
  "SUNBAKES": "SUNBAKE, to bake e.g. mud hard by the action of sun [v]\n",
  "SUNBAKING": "SUNBAKE, to bake e.g. mud hard by the action of sun [v]\n",
  "SUNBATH": "an exposure to sunlight [n -S]\n",
  "SUNBATHE": "to take a sunbath [v SUNBATHED, SUNBATHING, SUNBATHES]\n",
  "SUNBATHED": "SUNBATHE, to take a sunbath [v]\n",
  "SUNBATHER": "one who sunbathes [n -S]\n",
  "SUNBATHERS": "SUNBATHER, one who sunbathes [n]\n",
  "SUNBATHES": "SUNBATHE, to take a sunbath [v]\n",
  "SUNBATHING": "the act of sunbathing [n -S]\n",
  "SUNBATHINGS": "SUNBATHING, the act of sunbathing [n]\n",
  "SUNBATHS": "SUNBATH, an exposure to sunlight [n]\n",
  "SUNBEAM": "a beam of sunlight [n -S]\n",
  "SUNBEAMED": "with sunbeams [adj]\n",
  "SUNBEAMIER": "SUNBEAMY, full of sunbeams [adj]\n",
  "SUNBEAMIEST": "SUNBEAMY, full of sunbeams [adj]\n",
  "SUNBEAMS": "SUNBEAM, a beam of sunlight [n]\n",
  "SUNBEAMY": "full of sunbeams [adj SUNBEAMIER, SUNBEAMIEST]\n",
  "SUNBEAT": "continually exposed to the sun, also SUNBEATEN [adj]\n",
  "SUNBEATEN": "continually exposed to the sun, also SUNBEAT [adj]\n",
  "SUNBED": "a unit consisting of a couch with sunlamps for obtaining an artificial suntan [n -S]\n",
  "SUNBEDS": "SUNBED, a unit consisting of a couch with sunlamps for obtaining an artificial suntan [n]\n",
  "SUNBELT": "the southern and southwestern states of the US [n -S]\n",
  "SUNBELTS": "SUNBELT, the southern and southwestern states of the US [n]\n",
  "SUNBERRIES": "SUNBERRY, dark edible fruit [n]\n",
  "SUNBERRY": "dark edible fruit [n SUNBERRIES]\n",
  "SUNBIRD": "a family of small, often brightly-coloured, tropical birds related to honeyeaters [n -S]\n",
  "SUNBIRDS": "SUNBIRD, a family of small, often brightly-coloured, tropical birds related to honeyeaters [n]\n",
  "SUNBLIND": "a blind to keep out the sun [n -S]\n",
  "SUNBLINDS": "SUNBLIND, a blind to keep out the sun [n]\n",
  "SUNBLOCK": "a lotion to protect the skin from the sun [n -S]\n",
  "SUNBLOCKS": "SUNBLOCK, a lotion to protect the skin from the sun [n]\n",
  "SUNBONNET": "a bonnet worn by women as a protection against the sun [n -S]\n",
  "SUNBONNETED": "wearing a sunbonnet [adj]\n",
  "SUNBONNETS": "SUNBONNET, a bonnet worn by women as a protection against the sun [n]\n",
  "SUNBOW": "an arc of spectral colours formed by the sun through mist [n -S]\n",
  "SUNBOWS": "SUNBOW, an arc of spectral colours formed by the sun through mist [n]\n",
  "SUNBRIGHT": "bright as the sun [adj]\n",
  "SUNBURN": "to burn by exposure to sun [v SUNBURNED, SUNBURNT, SUNBURNING, SUNBURNS]\n",
  "SUNBURNED": "SUNBURN, to burn by exposure to sun [v]\n",
  "SUNBURNING": "SUNBURN, to burn by exposure to sun [v]\n",
  "SUNBURNS": "SUNBURN, to burn by exposure to sun [v]\n",
  "SUNBURNT": "SUNBURN, to burn by exposure to sun [v]\n",
  "SUNBURST": "a burst of sunlight [n -S]\n",
  "SUNBURSTS": "SUNBURST, a burst of sunlight [n]\n",
  "SUNCARE": "protection of the skin from damage by the sun [n -S]\n",
  "SUNCARES": "SUNCARE, protection of the skin from damage by the sun [n]\n",
  "SUNCHOKE": "a type of sunflower [n -S]\n",
  "SUNCHOKES": "SUNCHOKE, a type of sunflower [n]\n",
  "SUNDAE": "a dish of ice-cream topped or mixed with fruit, nuts, syrup, whipped cream, etc. [n -S]\n",
  "SUNDAES": "SUNDAE, a dish of ice-cream topped or mixed with fruit, nuts, syrup, whipped cream, etc. [n]\n",
  "SUNDARI": "(Sanskrit) an East Indian tree, also SUNDRA, SUNDRI [n -S]\n",
  "SUNDARIS": "SUNDARI, (Sanskrit) an East Indian tree, also SUNDRA, SUNDRI [n]\n",
  "SUNDECK": "the upper deck of a passenger ship that is exposed to the sun [n -S]\n",
  "SUNDECKS": "SUNDECK, the upper deck of a passenger ship that is exposed to the sun [n]\n",
  "SUNDER": "to break apart [v -ED, -ING, -S]\n",
  "SUNDERABLE": "that can be sundered [adj]\n",
  "SUNDERANCE": "(archaic) separation [n -S]\n",
  "SUNDERANCES": "SUNDERANCE, (archaic) separation [n]\n",
  "SUNDERED": "SUNDER, to break apart [v]\n",
  "SUNDERER": "one who sunders [n -S]\n",
  "SUNDERERS": "SUNDERER, one who sunders [n]\n",
  "SUNDERING": "the act of sundering [n -S]\n",
  "SUNDERINGS": "SUNDERING, the act of sundering [n]\n",
  "SUNDERMENT": "(archaic) separation [n -S]\n",
  "SUNDERMENTS": "SUNDERMENT, (archaic) separation [n]\n",
  "SUNDERS": "SUNDER, to break apart [v]\n",
  "SUNDEW": "an insectivorous bog-plant [n -S]\n",
  "SUNDEWS": "SUNDEW, an insectivorous bog-plant [n]\n",
  "SUNDIAL": "a type of time-telling device [n -S]\n",
  "SUNDIALS": "SUNDIAL, a type of time-telling device [n]\n",
  "SUNDOG": "a bright spot or halo appearing on either side of sun, aka parhelion [n -S]\n",
  "SUNDOGS": "SUNDOG, a bright spot or halo appearing on either side of sun, aka parhelion [n]\n",
  "SUNDOWN": "the time at which the sun goes down [n -S] / to arrive at a place to stay too late to do any work [v -ED, -ING, -S]\n",
  "SUNDOWNED": "SUNDOWN, to arrive at a place to stay too late to do any work [v]\n",
  "SUNDOWNER": "(Australian slang) a loafer or tramp who arrives at a place in time for an evening meal but too late to do any work [n -S]\n",
  "SUNDOWNERS": "SUNDOWNER, (Australian slang) a loafer or tramp who arrives at a place in time for an evening meal but too late to do any work [n]\n",
  "SUNDOWNING": "SUNDOWN, to arrive at a place to stay too late to do any work [v]\n",
  "SUNDOWNS": "SUNDOWN, the time at which the sun goes down [n]\n",
  "SUNDRA": "(Sanskrit) a timber tree, also SUNDARI, SUNDRI [n -S]\n",
  "SUNDRAS": "SUNDRA, (Sanskrit) a timber tree, also SUNDARI, SUNDRI [n]\n",
  "SUNDRENCHED": "exposed to much sun [adj]\n",
  "SUNDRESS": "a low-cut dress, leaving the arms, shoulders and back exposed to the sun [n -ES]\n",
  "SUNDRESSES": "SUNDRESS, a low-cut dress, leaving the arms, shoulders and back exposed to the sun [n]\n",
  "SUNDRI": "(Sanskrit) an East Indian tree, also SUNDARI, SUNDRA [n -S]\n",
  "SUNDRIES": "miscellaneous items [n]\n",
  "SUNDRILY": "SUNDRY, miscellaneous [adv]\n",
  "SUNDRIS": "SUNDRI, (Sanskrit) an East Indian tree, also SUNDARI, SUNDRA [n]\n",
  "SUNDROPS": "an American evening primrose with flowers that open at sunset [n]\n",
  "SUNDRY": "miscellaneous [adj SUNDRILY]\n",
  "SUNFAST": "resistant to fading by the sun [adj]\n",
  "SUNFISH": "a marine fish [n -ES]\n",
  "SUNFISHES": "SUNFISH, a marine fish [n]\n",
  "SUNFLOWER": "a composite plant with yellow rays and edible seeds from which an oil is extracted [n -S]\n",
  "SUNFLOWERS": "SUNFLOWER, a composite plant with yellow rays and edible seeds from which an oil is extracted [n]\n",
  "SUNG": "SING, to utter melodious musical sounds [v]\n",
  "SUNGAR": "(Pushtu) a temporary fortification, also SANGA, SANGAR [n -S]\n",
  "SUNGARS": "SUNGAR, (Pushtu) a temporary fortification, also SANGA, SANGAR [n]\n",
  "SUNGAZER": "an African lizard given to basking in the sun [n -S]\n",
  "SUNGAZERS": "SUNGAZER, an African lizard given to basking in the sun [n]\n",
  "SUNGAZING": "the practice of staring directly at the sun at sunset or sunrise, esp. in the belief that doing so allows one to survive without eating food [n -S]\n",
  "SUNGAZINGS": "SUNGAZING, the practice of staring directly at the sun at sunset or sunrise, esp. in the belief that doing so allows one to survive without eating food [n]\n",
  "SUNGLASS": "a lens for concentrating the suns's rays for heat [n -ES]\n",
  "SUNGLASSES": "SUNGLASS, a lens for concentrating the suns's rays for heat [n]\n",
  "SUNGLOW": "a glow in the sky caused by the sun [n -S]\n",
  "SUNGLOWS": "SUNGLOW, a glow in the sky caused by the sun [n]\n",
  "SUNGREBE": "the finfoot, a South American bird allied to the grebes [n -S]\n",
  "SUNGREBES": "SUNGREBE, the finfoot, a South American bird allied to the grebes [n]\n",
  "SUNHAT": "a hat worn for protection against the sun [n -S]\n",
  "SUNHATS": "SUNHAT, a hat worn for protection against the sun [n]\n",
  "SUNI": "(Bantu) a small South African antelope [n -S]\n",
  "SUNIS": "SUNI, (Bantu) a small South African antelope [n]\n",
  "SUNK": "a turf seat [n -S]\n",
  "SUNKEN": "SINK, to subside to a lower level [v]\n",
  "SUNKER": "a ridge of rock near the surface of the sea [n -S]\n",
  "SUNKERS": "SUNKER, a ridge of rock near the surface of the sea [n]\n",
  "SUNKET": "(Scots) a dainty or delicacy, also SUCKET [n -S]\n",
  "SUNKETS": "SUNKET, (Scots) a dainty or delicacy, also SUCKET [n]\n",
  "SUNKIE": "(Scots) a little stool [n -S]\n",
  "SUNKIES": "SUNKIE, (Scots) a little stool [n]\n",
  "SUNKS": "SUNK, a turf seat [n]\n",
  "SUNLAMP": "a lamp that radiates ultraviolet rays [n -S]\n",
  "SUNLAMPS": "SUNLAMP, a lamp that radiates ultraviolet rays [n]\n",
  "SUNLAND": "an area marked by a great amount of sunshine [n -S]\n",
  "SUNLANDS": "SUNLAND, an area marked by a great amount of sunshine [n]\n",
  "SUNLESS": "without sun [adj SUNLESSLY]\n",
  "SUNLESSLY": "SUNLESS, without sun [adv]\n",
  "SUNLESSNESS": "the state of being sunless [n -ES]\n",
  "SUNLESSNESSES": "SUNLESSNESS, the state of being sunless [n]\n",
  "SUNLIGHT": "the light of the sun [n -S]\n",
  "SUNLIGHTS": "SUNLIGHT, the light of the sun [n]\n",
  "SUNLIKE": "like the sun [adj]\n",
  "SUNLIT": "lit by the sun [adj]\n",
  "SUNLOUNGER": "an upholstered couch for sunbathing [n -S]\n",
  "SUNLOUNGERS": "SUNLOUNGER, an upholstered couch for sunbathing [n]\n",
  "SUNN": "(Hindi) an East Indian plant with tough fibre used in cordage [n -S]\n",
  "SUNNA": "(Arabic) a collection of traditions received by orthodox Muslims as of equal authority with the Koran, also SUNNAH [n -S]\n",
  "SUNNAH": "(Arabic) a collection of traditions received by orthodox Muslims as of equal authority with the Koran, also SUNNA [n -S]\n",
  "SUNNAHS": "SUNNAH, (Arabic) a collection of traditions received by orthodox Muslims as of equal authority with the Koran, also SUNNA [n]\n",
  "SUNNAS": "SUNNA, (Arabic) a collection of traditions received by orthodox Muslims as of equal authority with the Koran, also SUNNAH [n]\n",
  "SUNNED": "SUN, to expose to sunlight [v]\n",
  "SUNNIER": "SUNNY, full of sun [adj]\n",
  "SUNNIES": "(Australian) sunglasses [n]\n",
  "SUNNIEST": "SUNNY, full of sun [adj]\n",
  "SUNNILY": "SUNNY, full of sun [adv]\n",
  "SUNNINESS": "the state of being sunny [n -ES]\n",
  "SUNNINESSES": "SUNNINESS, the state of being sunny [n]\n",
  "SUNNING": "SUN, to expose to sunlight [v]\n",
  "SUNNS": "SUNN, (Hindi) an East Indian plant with tough fibre used in cordage [n]\n",
  "SUNNY": "full of sun [adj SUNNIER, SUNNIEST, SUNNILY]\n",
  "SUNPORCH": "a porch that admits much sunlight [n -ES]\n",
  "SUNPORCHES": "SUNPORCH, a porch that admits much sunlight [n]\n",
  "SUNPROOF": "resistant to damage by sunlight [adj]\n",
  "SUNRAY": "a ray of sunshine [n -S]\n",
  "SUNRAYS": "SUNRAY, a ray of sunshine [n]\n",
  "SUNRISE": "the rising or first appearance of the sun above the horizon, also SUNRISING [n -S]\n",
  "SUNRISES": "SUNRISE, the rising or first appearance of the sun above the horizon, also SUNRISING [n]\n",
  "SUNRISING": "the rising or first appearance of the sun above the horizon, also SUNRISE [n -S]\n",
  "SUNRISINGS": "SUNRISING, the rising or first appearance of the sun above the horizon, also SUNRISE [n]\n",
  "SUNROOF": "a roof of a car that slides open to admit the sun [n -S]\n",
  "SUNROOFS": "SUNROOF, a roof of a car that slides open to admit the sun [n]\n",
  "SUNROOM": "a room built to admit much sunlight [n -S]\n",
  "SUNROOMS": "SUNROOM, a room built to admit much sunlight [n]\n",
  "SUNS": "SUN, to expose to sunlight [v]\n",
  "SUNSCALD": "an injury of woody plants caused by the sun [n -S]\n",
  "SUNSCALDS": "SUNSCALD, an injury of woody plants caused by the sun [n]\n",
  "SUNSCREEN": "a cream preventing sunburn [n -S]\n",
  "SUNSCREENING": "the use of sunscreens [n -S]\n",
  "SUNSCREENINGS": "SUNSCREENING, the use of sunscreens [n]\n",
  "SUNSCREENS": "SUNSCREEN, a cream preventing sunburn [n]\n",
  "SUNSEEKER": "one who seeks the sun [n -S]\n",
  "SUNSEEKERS": "SUNSEEKER, one who seeks the sun [n]\n",
  "SUNSET": "of the sun, to set below the horizon, also SUNSETTING [v SUNSETTED, SUNSETTING, SUNSETS]\n",
  "SUNSETS": "SUNSET [n]\n",
  "SUNSETTED": "SUNSET, of the sun, to set below the horizon, also SUNSETTING [v]\n",
  "SUNSETTING": "the descent of the sun below the horizon, also SUNSET [n -S]\n",
  "SUNSETTINGS": "SUNSETTING, the descent of the sun below the horizon, also SUNSET [n]\n",
  "SUNSHADE": "an umbrella-like protection from the sun [n -S]\n",
  "SUNSHADES": "SUNSHADE, an umbrella-like protection from the sun [n]\n",
  "SUNSHINE": "the light of the sun [n -S]\n",
  "SUNSHINES": "SUNSHINE, the light of the sun [n]\n",
  "SUNSHINIER": "SUNSHINY, full of sunshine [adj]\n",
  "SUNSHINIEST": "SUNSHINY, full of sunshine [adj]\n",
  "SUNSHINY": "full of sunshine [adj SUNSHINIER, SUNSHINIEST]\n",
  "SUNSPECS": "(colloquial) sunglasses [n]\n",
  "SUNSPOT": "a dark spot on the surface of the sun [n -S]\n",
  "SUNSPOTS": "SUNSPOT, a dark spot on the surface of the sun [n]\n",
  "SUNSPOTTED": "showing sunspots [adj]\n",
  "SUNSTAR": "a kind of starfish [n -S]\n",
  "SUNSTARS": "SUNSTAR, a kind of starfish [n]\n",
  "SUNSTONE": "a variety of quartz [n -S]\n",
  "SUNSTONES": "SUNSTONE, a variety of quartz [n]\n",
  "SUNSTROKE": "a medical condition of general collapse caused by prolonged exposure to intense sunlight [n -S]\n",
  "SUNSTROKES": "SUNSTROKE, a medical condition of general collapse caused by prolonged exposure to intense sunlight [n]\n",
  "SUNSTRUCK": "affected with sunstroke [adj]\n",
  "SUNSUIT": "an outfit worn for sunbathing [n -S]\n",
  "SUNSUITS": "SUNSUIT, an outfit worn for sunbathing [n]\n",
  "SUNTAN": "a brown skin colour as a result of sun exposure [n -S] / to tan in the sun [v SUNTANNED, SUNTANNING, SUNTANS]\n",
  "SUNTANNED": "SUNTAN, to tan in the sun [v]\n",
  "SUNTANNING": "the act of tanning by the sun [n -S]\n",
  "SUNTANNINGS": "SUNTANNING, the act of tanning by the sun [n]\n",
  "SUNTANS": "SUNTAN, to tan in the sun [v]\n",
  "SUNTRAP": "a sheltered sunny place [n -S]\n",
  "SUNTRAPS": "SUNTRAP, a sheltered sunny place [n]\n",
  "SUNUP": "sunrise [n -S]\n",
  "SUNUPS": "SUNUP, sunrise [n]\n",
  "SUNWARD": "towards the sun [adv]\n",
  "SUNWARDS": "towards the sun, also SUNWARD [adv]\n",
  "SUNWISE": "in the direction of the sun's apparent revolution [adv]\n",
  "SUNWORSHIPPER": "one who worships the sun [n -S]\n",
  "SUNWORSHIPPERS": "SUNWORSHIPPER, one who worships the sun [n]\n",
  "SUOVETAURILIA": "(Latin) a Roman sacrifice of a sheep, pig or ox [n -S]\n",
  "SUOVETAURILIAS": "SUOVETAURILIA, (Latin) a Roman sacrifice of a sheep, pig or ox [n]\n",
  "SUP": "to eat supper [v SUPPED, SUPPING, SUPS]\n",
  "SUPAWN": "(Native American) a kind of maize porridge, also SUPPAWN [n -S]\n",
  "SUPAWNS": "SUPAWN, (Native American) a kind of maize porridge, also SUPPAWN [n]\n",
  "SUPE": "(short for) a superintendent [n -S]\n",
  "SUPER": "to reinforce with a thin cotton mesh, as a book [v -ED, -ING, -S]\n",
  "SUPERABILITIES": "SUPERABILITY, the quality of being superable [n]\n",
  "SUPERABILITY": "the quality of being superable [n SUPERABILITIES]\n",
  "SUPERABLE": "capable of being overcome or conquered [adj SUPERABLY]\n",
  "SUPERABLENESS": "the state of being superable [n -ES]\n",
  "SUPERABLENESSES": "SUPERABLENESS, the state of being superable [n]\n",
  "SUPERABLY": "SUPERABLE, capable of being overcome or conquered [adv]\n",
  "SUPERABOUND": "to be superabundant [v -ED, -ING, -S]\n",
  "SUPERABOUNDED": "SUPERABOUND, to be superabundant [v]\n",
  "SUPERABOUNDING": "SUPERABOUND, to be superabundant [v]\n",
  "SUPERABOUNDS": "SUPERABOUND, to be superabundant [v]\n",
  "SUPERABSORBENT": "an exceptionally absorbent substance [n -S]\n",
  "SUPERABSORBENTS": "SUPERABSORBENT, an exceptionally absorbent substance [n]\n",
  "SUPERABUNDANCE": "extreme abundance [n -S]\n",
  "SUPERABUNDANCES": "SUPERABUNDANCE, extreme abundance [n]\n",
  "SUPERABUNDANT": "more than ample [adj SUPERABUNDANTLY]\n",
  "SUPERABUNDANTLY": "SUPERABUNDANT, more than ample [adv]\n",
  "SUPERACHIEVER": "an extreme achiever [n -S]\n",
  "SUPERACHIEVERS": "SUPERACHIEVER, an extreme achiever [n]\n",
  "SUPERACTIVE": "extremely active [adj]\n",
  "SUPERACTIVITIES": "SUPERACTIVITY, the state of being superactive [n]\n",
  "SUPERACTIVITY": "the state of being superactive [n SUPERACTIVITIES]\n",
  "SUPERACUTE": "exceptionally acute [adj]\n",
  "SUPERADD": "to add further [v -ED, -ING, -S]\n",
  "SUPERADDED": "SUPERADD, to add further [v]\n",
  "SUPERADDING": "SUPERADD, to add further [v]\n",
  "SUPERADDITION": "addition over and above [n -S]\n",
  "SUPERADDITIONAL": "added over and above [adj]\n",
  "SUPERADDITIONS": "SUPERADDITION, addition over and above [n]\n",
  "SUPERADDS": "SUPERADD, to add further [v]\n",
  "SUPERAGENCIES": "SUPERAGENCY, a large complex governmental agency esp. when set up to supervise other agencies [n]\n",
  "SUPERAGENCY": "a large complex governmental agency esp. when set up to supervise other agencies [n SUPERAGENCIES]\n",
  "SUPERAGENT": "a top agent [n -S]\n",
  "SUPERAGENTS": "SUPERAGENT, a top agent [n]\n",
  "SUPERALLOY": "an alloy that has good stability at 600 degrees to 1000 degrees C [n -S]\n",
  "SUPERALLOYS": "SUPERALLOY, an alloy that has good stability at 600 degrees to 1000 degrees C [n]\n",
  "SUPERALTAR": "a raised shelf or stand on the back of an altar [n -S]\n",
  "SUPERALTARS": "SUPERALTAR, a raised shelf or stand on the back of an altar [n]\n",
  "SUPERALTERN": "a kind of universal proposition in logic [n -S]\n",
  "SUPERALTERNS": "SUPERALTERN, a kind of universal proposition in logic [n]\n",
  "SUPERAMBITIOUS": "extremely ambitious [adj]\n",
  "SUPERANNUABLE": "that can be superannuated [adj]\n",
  "SUPERANNUATE": "to render antiquated or obsolete [v SUPERANNUATED, SUPERANNUATING, SUPERANNUATES]\n",
  "SUPERANNUATED": "SUPERANNUATE, to render antiquated or obsolete [v]\n",
  "SUPERANNUATES": "SUPERANNUATE, to render antiquated or obsolete [v]\n",
  "SUPERANNUATING": "SUPERANNUATE, to render antiquated or obsolete [v]\n",
  "SUPERANNUATION": "the act of superannuating [n -S]\n",
  "SUPERANNUATIONS": "SUPERANNUATION, the act of superannuating [n]\n",
  "SUPERATE": "(obsolete) to overcome, surmount [v SUPERATED, SUPERATING, SUPERATES]\n",
  "SUPERATED": "SUPERATE, (obsolete) to overcome, surmount [v]\n",
  "SUPERATES": "SUPERATE, (obsolete) to overcome, surmount [v]\n",
  "SUPERATHLETE": "a very good athlete [n -S]\n",
  "SUPERATHLETES": "SUPERATHLETE, a very good athlete [n]\n",
  "SUPERATING": "SUPERATE, (obsolete) to overcome, surmount [v]\n",
  "SUPERATION": "the act of superating, overcoming or surmounting [n -S]\n",
  "SUPERATIONS": "SUPERATION, the act of superating, overcoming or surmounting [n]\n",
  "SUPERATOM": "a cluster of atoms behaving like a single atom [n -S]\n",
  "SUPERATOMS": "SUPERATOM, a cluster of atoms behaving like a single atom [n]\n",
  "SUPERB": "of excellent quality [adj SUPERBER, SUPERBEST, SUPERBLY]\n",
  "SUPERBAD": "exceedingly bad; exceedingly good [adj]\n",
  "SUPERBANK": "a very large bank [n -S]\n",
  "SUPERBANKS": "SUPERBANK, a very large bank [n]\n",
  "SUPERBAZAAR": "in India, a large department store or supermarket, esp. one set up as a cooperative store by the government, also SUPERBAZAR [n -S]\n",
  "SUPERBAZAARS": "SUPERBAZAAR, in India, a large department store or supermarket, esp. one set up as a cooperative store by the government, also SUPERBAZAR [n]\n",
  "SUPERBAZAR": "in India, a large department store or supermarket, esp. one set up as a cooperative store by the government, also SUPERBAZAAR [n -S]\n",
  "SUPERBAZARS": "SUPERBAZAR, in India, a large department store or supermarket, esp. one set up as a cooperative store by the government, also SUPERBAZAAR [n]\n",
  "SUPERBER": "SUPERB, of excellent quality [adj]\n",
  "SUPERBEST": "SUPERB, of excellent quality [adj]\n",
  "SUPERBIKE": "a high-powered motorbike [n -S]\n",
  "SUPERBIKES": "SUPERBIKE, a high-powered motorbike [n]\n",
  "SUPERBITCH": "(offensive) a highly-placed aggressive female [n -ES]\n",
  "SUPERBITCHES": "SUPERBITCH, (offensive) a highly-placed aggressive female [n]\n",
  "SUPERBITIES": "SUPERBITY, haughtiness, arrogance [n]\n",
  "SUPERBITY": "haughtiness, arrogance [n SUPERBITIES]\n",
  "SUPERBLOCK": "a large block composed of other blocks [n -S]\n",
  "SUPERBLOCKS": "SUPERBLOCK, a large block composed of other blocks [n]\n",
  "SUPERBLY": "SUPERB, of excellent quality [adv]\n",
  "SUPERBNESS": "the quality of being superb [n -ES]\n",
  "SUPERBNESSES": "SUPERBNESS, the quality of being superb [n]\n",
  "SUPERBOARD": "a board above other boards [n -S]\n",
  "SUPERBOARDS": "SUPERBOARD, a board above other boards [n]\n",
  "SUPERBOLD": "very bold [adj]\n",
  "SUPERBOMB": "a very big bomb [n -S]\n",
  "SUPERBOMBER": "a very large bomber [n -S]\n",
  "SUPERBOMBERS": "SUPERBOMBER, a very large bomber [n]\n",
  "SUPERBOMBS": "SUPERBOMB, a very big bomb [n]\n",
  "SUPERBRAIN": "an extraordinary intelligence [n -S]\n",
  "SUPERBRAINS": "SUPERBRAIN, an extraordinary intelligence [n]\n",
  "SUPERBRAT": "a very brattish child [n -S]\n",
  "SUPERBRATS": "SUPERBRAT, a very brattish child [n]\n",
  "SUPERBRIGHT": "very bright [adj]\n",
  "SUPERBUG": "a bacterium resistant to antibiotics [n -S]\n",
  "SUPERBUGS": "SUPERBUG, a bacterium resistant to antibiotics [n]\n",
  "SUPERBUREAUCRAT": "a highly-placed bureaucrat [n]\n",
  "SUPERCABINET": "a cabinet above other cabinets [n -S]\n",
  "SUPERCABINETS": "SUPERCABINET, a cabinet above other cabinets [n]\n",
  "SUPERCALENDER": "to give a high polish to [v -ED, -S]\n",
  "SUPERCALENDERED": "SUPERCALENDER, to give a high polish to [v]\n",
  "SUPERCALENDERS": "SUPERCALENDER, to give a high polish to [v]\n",
  "SUPERCAR": "a very big or fast car [n -S]\n",
  "SUPERCARGO": "a ship's official in charge of business affairs [n -ES or -S]\n",
  "SUPERCARGOES": "SUPERCARGO, a ship's official in charge of business affairs [n]\n",
  "SUPERCARGOS": "SUPERCARGO, a ship's official in charge of business affairs [n]\n",
  "SUPERCARGOSHIP": "the office of supercargo [n -S]\n",
  "SUPERCARGOSHIPS": "SUPERCARGOSHIP, the office of supercargo [n]\n",
  "SUPERCARRIER": "a large aircraft carrier [n -S]\n",
  "SUPERCARRIERS": "SUPERCARRIER, a large aircraft carrier [n]\n",
  "SUPERCARS": "SUPERCAR, a very big or fast car [n]\n",
  "SUPERCAUTIOUS": "extremely cautious [adj]\n",
  "SUPERCEDE": "to take the place of, also SUPERSEDE [v SUPERCEDED, SUPERCEDING, SUPERCEDES]\n",
  "SUPERCEDED": "SUPERCEDE, to take the place of, also SUPERSEDE [v]\n",
  "SUPERCEDES": "SUPERCEDE, to take the place of, also SUPERSEDE [v]\n",
  "SUPERCEDING": "SUPERCEDE, to take the place of, also SUPERSEDE [v]\n",
  "SUPERCELESTIAL": "exceedingly celestial [adj]\n",
  "SUPERCELL": "an unusually large storm cell; a severe storm generated by such a cell [n -S]\n",
  "SUPERCELLS": "SUPERCELL, an unusually large storm cell; a severe storm generated by such a cell [n]\n",
  "SUPERCENTER": "a very large discount department store that also sells a complete line of grocery merchandise [n -S]\n",
  "SUPERCENTERS": "SUPERCENTER, a very large discount department store that also sells a complete line of grocery merchandise [n]\n",
  "SUPERCHARGE": "to charge greatly or excessively, as with vigor or tension [v SUPERCHARGED, SUPERCHARGING, SUPERCHARGES]\n",
  "SUPERCHARGED": "SUPERCHARGE, to charge greatly or excessively, as with vigor or tension [v]\n",
  "SUPERCHARGER": "a device for increasing the pressure, and hence the power output, in an internal-combustion engine [n -S]\n",
  "SUPERCHARGERS": "SUPERCHARGER, a device for increasing the pressure, and hence the power output, in an internal-combustion engine [n]\n",
  "SUPERCHARGES": "SUPERCHARGE, to charge greatly or excessively, as with vigor or tension [v]\n",
  "SUPERCHARGING": "SUPERCHARGE, to charge greatly or excessively, as with vigor or tension [v]\n",
  "SUPERCHERIE": "(French) deception, hoax, fraud [n -S]\n",
  "SUPERCHERIES": "SUPERCHERIE, (French) deception, hoax, fraud [n]\n",
  "SUPERCHIC": "very chic [adj]\n",
  "SUPERCHURCH": "a very large church [n -ES]\n",
  "SUPERCHURCHES": "SUPERCHURCH, a very large church [n]\n",
  "SUPERCILIARIES": "SUPERCILIARY, a ridge or mark over the eyebrow [n]\n",
  "SUPERCILIARY": "of, on or near the eyebrow [adj] / a ridge or mark over the eyebrow [n SUPERCILIARIES]\n",
  "SUPERCILIOUS": "haughtily contemptuous [adj SUPERCILIOUSLY]\n",
  "SUPERCILIOUSLY": "SUPERCILIOUS, haughtily contemptuous [adv]\n",
  "SUPERCITIES": "SUPERCITY, a very big city [n]\n",
  "SUPERCITY": "a very big city [n SUPERCITIES]\n",
  "SUPERCIVILISED": "extremely civilised, also SUPERCIVILIZED [adj]\n",
  "SUPERCIVILIZED": "extremely civilized, also SUPERCIVILISED [adj]\n",
  "SUPERCLASS": "a taxonomic category between class and phylum [n -ES]\n",
  "SUPERCLASSES": "SUPERCLASS, a taxonomic category between class and phylum [n]\n",
  "SUPERCLEAN": "exceptionally clean [adj]\n",
  "SUPERCLUB": "a very big club [n -S]\n",
  "SUPERCLUBS": "SUPERCLUB, a very big club [n]\n",
  "SUPERCLUSTER": "a group of gravitationally associated clusters of galaxies [n -S]\n",
  "SUPERCLUSTERS": "SUPERCLUSTER, a group of gravitationally associated clusters of galaxies [n]\n",
  "SUPERCOIL": "a complex coil formed by intertwining strands of protein or DNA [n -S] / to create such a coil [v -ED, -ING, -S]\n",
  "SUPERCOILED": "SUPERCOIL, to create such a coil [v]\n",
  "SUPERCOILING": "SUPERCOIL, to create such a coil [v]\n",
  "SUPERCOILS": "SUPERCOIL, a complex coil formed by intertwining strands of protein or DNA [n]\n",
  "SUPERCOLD": "cryogenic [adj]\n",
  "SUPERCOLLIDER": "a very large collider capable of accelerating particles to very high energies [n -S]\n",
  "SUPERCOLLIDERS": "SUPERCOLLIDER, a very large collider capable of accelerating particles to very high energies [n]\n",
  "SUPERCOLOSSAL": "extremely colossal [adj]\n",
  "SUPERCOLUMNAR": "above a column or colonnade; with one colonnade above another [adj]\n",
  "SUPERCOMPUTER": "a large very fast mainframe used esp. for scientific computations [n -S]\n",
  "SUPERCOMPUTERS": "SUPERCOMPUTER, a large very fast mainframe used esp. for scientific computations [n]\n",
  "SUPERCOMPUTING": "computing using a supercomputer, a large very fast mainframe used esp. for scientific computations [n -S]\n",
  "SUPERCOMPUTINGS": "SUPERCOMPUTING, computing using a supercomputer, a large very fast mainframe used esp. for scientific computations [n]\n",
  "SUPERCONDUCT": "to exhibit superconductivity [v -ED, -ING, -S]\n",
  "SUPERCONDUCTED": "SUPERCONDUCT, to exhibit superconductivity [v]\n",
  "SUPERCONDUCTING": "SUPERCONDUCT, to exhibit superconductivity [v]\n",
  "SUPERCONDUCTION": "the act of superconducting [n]\n",
  "SUPERCONDUCTIVE": "capable of superconduction [adj]\n",
  "SUPERCONDUCTOR": "a material that exhibits superconductivity [n -S]\n",
  "SUPERCONDUCTORS": "SUPERCONDUCTOR, a material that exhibits superconductivity [n]\n",
  "SUPERCONDUCTS": "SUPERCONDUCT, to exhibit superconductivity [v]\n",
  "SUPERCONFIDENCE": "a state of very high confidence [n]\n",
  "SUPERCONFIDENT": "extremely confident [adj]\n",
  "SUPERCONTINENT": "a hypothetical former large continent from which other continents are held to have broken off and drifted away [n -S]\n",
  "SUPERCONTINENTS": "SUPERCONTINENT, a hypothetical former large continent from which other continents are held to have broken off and drifted away [n]\n",
  "SUPERCONVENIENT": "extremely convenient [adj]\n",
  "SUPERCOOL": "to cool a liquid below its normal freezing point [v -ED, -ING, -S]\n",
  "SUPERCOOLED": "SUPERCOOL, to cool a liquid below its normal freezing point [v]\n",
  "SUPERCOOLING": "SUPERCOOL, to cool a liquid below its normal freezing point [v]\n",
  "SUPERCOOLS": "SUPERCOOL, to cool a liquid below its normal freezing point [v]\n",
  "SUPERCOP": "a superior police officer [n -S]\n",
  "SUPERCOPS": "SUPERCOP, a superior police officer [n]\n",
  "SUPERCOVER": "an insurance policy with additional benefits [n -S]\n",
  "SUPERCOVERS": "SUPERCOVER, an insurance policy with additional benefits [n]\n",
  "SUPERCOW": "a dairy cow that produces a very high milk yield [n -S]\n",
  "SUPERCOWS": "SUPERCOW, a dairy cow that produces a very high milk yield [n]\n",
  "SUPERCRIMINAL": "an exceptional criminal [n -S]\n",
  "SUPERCRIMINALS": "SUPERCRIMINAL, an exceptional criminal [n]\n",
  "SUPERCRITICAL": "of a fluid, brought to a temperature and pressure higher than its critical temperature and pressure, so that its physical and chemical properties change [adj]\n",
  "SUPERCURRENT": "a current of electricity flowing in a superconductor [n -S]\n",
  "SUPERCURRENTS": "SUPERCURRENT, a current of electricity flowing in a superconductor [n]\n",
  "SUPERCUTE": "very cute [adj]\n",
  "SUPERDAINTIER": "SUPERDAINTY, extremely dainty [adj]\n",
  "SUPERDAINTIEST": "SUPERDAINTY, extremely dainty [adj]\n",
  "SUPERDAINTY": "extremely dainty [adj SUPERDAINTIER, SUPERDAINTIEST]\n",
  "SUPERDELEGATE": "an unpledged delegate [n -S]\n",
  "SUPERDELEGATES": "SUPERDELEGATE, an unpledged delegate [n]\n",
  "SUPERDELUXE": "extra luxurious [adj]\n",
  "SUPERDENSE": "very dense [adj]\n",
  "SUPERDIPLOMAT": "an exceptional diplomat [n -S]\n",
  "SUPERDIPLOMATS": "SUPERDIPLOMAT, an exceptional diplomat [n]\n",
  "SUPERDOMINANT": "the submediant or 6th tone of the diatonic scale [n -S]\n",
  "SUPERDOMINANTS": "SUPERDOMINANT, the submediant or 6th tone of the diatonic scale [n]\n",
  "SUPERED": "SUPER, to reinforce with a thin cotton mesh, as a book [v]\n",
  "SUPEREFFECTIVE": "extremely effective [adj]\n",
  "SUPEREFFICIENCY": "the state of being superefficient [n]\n",
  "SUPEREFFICIENT": "extremely efficient [adj]\n",
  "SUPEREGO": "a part of the psyche [n -S]\n",
  "SUPEREGOIST": "a very egotistical person [n -S]\n",
  "SUPEREGOISTS": "SUPEREGOIST, a very egotistical person [n]\n",
  "SUPEREGOS": "SUPEREGO, a part of the psyche [n]\n",
  "SUPERELASTIC": "elastic to a very high degree [adj]\n",
  "SUPERELEVATE": "to raise above a normal level [v SUPERELEVATED, SUPERELEVATING, SUPERELEVATES]\n",
  "SUPERELEVATED": "SUPERELEVATE, to raise above a normal level [v]\n",
  "SUPERELEVATES": "SUPERELEVATE, to raise above a normal level [v]\n",
  "SUPERELEVATING": "SUPERELEVATE, to raise above a normal level [v]\n",
  "SUPERELEVATION": "the vertical distance between the heights of inner and outer edges of highway pavement or railroad rails [n -S]\n",
  "SUPERELEVATIONS": "SUPERELEVATION, the vertical distance between the heights of inner and outer edges of highway pavement or railroad rails [n]\n",
  "SUPERELITE": "a very elite group [n -S]\n",
  "SUPERELITES": "SUPERELITE, a very elite group [n]\n",
  "SUPEREMINENCE": "exceptional eminence [n -S]\n",
  "SUPEREMINENCES": "SUPEREMINENCE, exceptional eminence [n]\n",
  "SUPEREMINENT": "outstandingly eminent [adj SUPEREMINENTLY]\n",
  "SUPEREMINENTLY": "SUPEREMINENT, outstandingly eminent [adv]\n",
  "SUPEREROGANT": "doing more than is necessary [adj]\n",
  "SUPEREROGATE": "(obsolete) to do more than is required, ordered or expected [v SUPEREROGATED, SUPEREROGATING, SUPEREROGATES]\n",
  "SUPEREROGATED": "SUPEREROGATE, (obsolete) to do more than is required, ordered or expected [v]\n",
  "SUPEREROGATES": "SUPEREROGATE, (obsolete) to do more than is required, ordered or expected [v]\n",
  "SUPEREROGATING": "SUPEREROGATE, (obsolete) to do more than is required, ordered or expected [v]\n",
  "SUPEREROGATION": "the act of performing more than is required by duty, obligation or need [n -S]\n",
  "SUPEREROGATIONS": "SUPEREROGATION, the act of performing more than is required by duty, obligation or need [n]\n",
  "SUPEREROGATIVE": "doing more than is necessary [adj]\n",
  "SUPEREROGATOR": "one who does or performs more than is required [n -S]\n",
  "SUPEREROGATORS": "SUPEREROGATOR, one who does or performs more than is required [n]\n",
  "SUPEREROGATORY": "going beyond the call of duty; superfluous [adj]\n",
  "SUPERESSENTIAL": "essential to a very high degree [adj]\n",
  "SUPERETTE": "(New Zealand) a small local supermarket [n -S]\n",
  "SUPERETTES": "SUPERETTE, (New Zealand) a small local supermarket [n]\n",
  "SUPEREVIDENT": "very evident [adj]\n",
  "SUPEREXALT": "to exalt to a superior degree [v -ED, -ING, -S]\n",
  "SUPEREXALTATION": "a state of very high exaltation [n]\n",
  "SUPEREXALTED": "SUPEREXALT, to exalt to a superior degree [v]\n",
  "SUPEREXALTING": "SUPEREXALT, to exalt to a superior degree [v]\n",
  "SUPEREXALTS": "SUPEREXALT, to exalt to a superior degree [v]\n",
  "SUPEREXCELLENCE": "excellence to a very high degree [n]\n",
  "SUPEREXCELLENT": "excellent to a very high degree [adj]\n",
  "SUPEREXPENSIVE": "extremely expensive [adj]\n",
  "SUPEREXPRESS": "a very fast express [n -ES]\n",
  "SUPEREXPRESSES": "SUPEREXPRESS, a very fast express [n]\n",
  "SUPERFAMILIES": "SUPERFAMILY, a category of biological classification ranking below an order and above a family [n]\n",
  "SUPERFAMILY": "a category of biological classification ranking below an order and above a family [n SUPERFAMILIES]\n",
  "SUPERFAN": "an exceedingly devoted enthusiast [n -S]\n",
  "SUPERFANS": "SUPERFAN, an exceedingly devoted enthusiast [n]\n",
  "SUPERFARM": "a very big farm [n -S]\n",
  "SUPERFARMS": "SUPERFARM, a very big farm [n]\n",
  "SUPERFAST": "very fast [adj]\n",
  "SUPERFATTED": "of soap, having an excess of fat, so that there is no free alkali [adj]\n",
  "SUPERFECTA": "a bet in which the bettor must pick the first four winners of a race in the correct order [n -S]\n",
  "SUPERFECTAS": "SUPERFECTA, a bet in which the bettor must pick the first four winners of a race in the correct order [n]\n",
  "SUPERFEMALE": "a very remarkable female [n -S]\n",
  "SUPERFEMALES": "SUPERFEMALE, a very remarkable female [n]\n",
  "SUPERFETATE": "to conceive when a fetus is already in the uterus [v SUPERFETATED, SUPERFETATING, SUPERFETATES]\n",
  "SUPERFETATED": "SUPERFETATE, to conceive when a fetus is already in the uterus [v]\n",
  "SUPERFETATES": "SUPERFETATE, to conceive when a fetus is already in the uterus [v]\n",
  "SUPERFETATING": "SUPERFETATE, to conceive when a fetus is already in the uterus [v]\n",
  "SUPERFETATION": "a second conception when there is already a fetus in the womb, also SUPERFOETATION [n -S]\n",
  "SUPERFETATIONS": "SUPERFETATION, a second conception when there is already a fetus in the womb, also SUPERFOETATION [n]\n",
  "SUPERFICIAL": "on the surface [adj SUPERFICIALLY] / that which is superficial [n -S]\n",
  "SUPERFICIALISE": "to make superficial, also SUPERFICIALIZE [v SUPERFICIALISED, SUPERFICIALISES]\n",
  "SUPERFICIALISED": "SUPERFICIALISE, to make superficial, also SUPERFICIALIZE [v]\n",
  "SUPERFICIALISES": "SUPERFICIALISE, to make superficial, also SUPERFICIALIZE [v]\n",
  "SUPERFICIALITY": "the state of being superficial [n]\n",
  "SUPERFICIALIZE": "to make superficial, also SUPERFICIALISE [v SUPERFICIALIZED, SUPERFICIALIZES]\n",
  "SUPERFICIALIZED": "SUPERFICIALIZE, to make superficial, also SUPERFICIALISE [v]\n",
  "SUPERFICIALIZES": "SUPERFICIALIZE, to make superficial, also SUPERFICIALISE [v]\n",
  "SUPERFICIALLY": "SUPERFICIAL, on the surface [adv]\n",
  "SUPERFICIALNESS": "the state of being superficial [n]\n",
  "SUPERFICIALS": "SUPERFICIAL, that which is superficial [n]\n",
  "SUPERFICIES": "(Latin) the outer surface or appearance of something or someone [n]\n",
  "SUPERFINE": "very fine, or most fine, as superfine cloth [adj]\n",
  "SUPERFINENESS": "the state of being superfine [n -ES]\n",
  "SUPERFINENESSES": "SUPERFINENESS, the state of being superfine [n]\n",
  "SUPERFIRM": "a large firm [n -S]\n",
  "SUPERFIRMS": "SUPERFIRM, a large firm [n]\n",
  "SUPERFIT": "exceptionally fit [adj]\n",
  "SUPERFIX": "a recurrent pattern of stress in speech [n -ES]\n",
  "SUPERFIXES": "SUPERFIX, a recurrent pattern of stress in speech [n]\n",
  "SUPERFLACK": "a superior press agent [n -S]\n",
  "SUPERFLACKS": "SUPERFLACK, a superior press agent [n]\n",
  "SUPERFLUID": "relating to, or demonstrating, superfluidity [adj] / a superfluid substance [n -S]\n",
  "SUPERFLUIDITIES": "SUPERFLUIDITY, the state of being superfluid [n]\n",
  "SUPERFLUIDITY": "the state of being superfluid [n SUPERFLUIDITIES]\n",
  "SUPERFLUIDS": "SUPERFLUID, a superfluid substance [n]\n",
  "SUPERFLUITIES": "SUPERFLUITY, excess [n]\n",
  "SUPERFLUITY": "excess [n SUPERFLUITIES]\n",
  "SUPERFLUOUS": "extraneous [adj SUPERFLUOUSLY]\n",
  "SUPERFLUOUSLY": "SUPERFLUOUS, extraneous [adv]\n",
  "SUPERFLUOUSNESS": "the state of being superfluous [n]\n",
  "SUPERFLUX": "(Shakespeare) superfluity [n -ES]\n",
  "SUPERFLUXES": "SUPERFLUX, (Shakespeare) superfluity [n]\n",
  "SUPERFLY": "showily pretentious [adj]\n",
  "SUPERFOETATION": "a second conception when there is already a fetus in the womb, also SUPERFETATION [n -S]\n",
  "SUPERFOETATIONS": "SUPERFOETATION, a second conception when there is already a fetus in the womb, also SUPERFETATION [n]\n",
  "SUPERFOOD": "a food with a high plant nutrient content that some may believe confers health benefits as a result [n -S]\n",
  "SUPERFOODS": "SUPERFOOD, a food with a high plant nutrient content that some may believe confers health benefits as a result [n]\n",
  "SUPERFRONTAL": "a covering hanging over the upper edge of an altar frontal [n -S]\n",
  "SUPERFRONTALS": "SUPERFRONTAL, a covering hanging over the upper edge of an altar frontal [n]\n",
  "SUPERFUND": "a superior fund [n -S]\n",
  "SUPERFUNDS": "SUPERFUND, a superior fund [n]\n",
  "SUPERFUSE": "to pour over [v SUPERFUSED, SUPERFUSING, SUPERFUSES]\n",
  "SUPERFUSED": "SUPERFUSE, to pour over [v]\n",
  "SUPERFUSES": "SUPERFUSE, to pour over [v]\n",
  "SUPERFUSING": "SUPERFUSE, to pour over [v]\n",
  "SUPERFUSION": "the act of superfusing [n -S]\n",
  "SUPERFUSIONS": "SUPERFUSION, the act of superfusing [n]\n",
  "SUPERGENE": "a group of closely linked genes, frequently having related functions [n -S]\n",
  "SUPERGENES": "SUPERGENE, a group of closely linked genes, frequently having related functions [n]\n",
  "SUPERGIANT": "a very bright star of enormous size and low density, such as Antares [n -S]\n",
  "SUPERGIANTS": "SUPERGIANT, a very bright star of enormous size and low density, such as Antares [n]\n",
  "SUPERGLACIAL": "occurring or originating on the surface of a glacier [adj]\n",
  "SUPERGLUE": "to glue with a powerful adhesive [v SUPERGLUED, SUPERGLUING or SUPERGLUEING, SUPERGLUES]\n",
  "SUPERGLUED": "SUPERGLUE, to glue with a powerful adhesive [v]\n",
  "SUPERGLUEING": "SUPERGLUE, to glue with a powerful adhesive [v]\n",
  "SUPERGLUES": "SUPERGLUE, to glue with a powerful adhesive [v]\n",
  "SUPERGLUING": "SUPERGLUE, to glue with a powerful adhesive [v]\n",
  "SUPERGOOD": "very good [adj]\n",
  "SUPERGOVERNMENT": "government above other governments [n]\n",
  "SUPERGRAPHICS": "billboard-sized graphic shapes usually of bright color and simple design [n]\n",
  "SUPERGRASS": "a very important police informer [n -ES]\n",
  "SUPERGRASSES": "SUPERGRASS, a very important police informer [n]\n",
  "SUPERGRAVITIES": "SUPERGRAVITY, any of various theories in physics that are based on supersymmetry and attempt to unify general relativity and quantum theory and that state that the principal transmitter of gravity is the graviton [n]\n",
  "SUPERGRAVITY": "any of various theories in physics that are based on supersymmetry and attempt to unify general relativity and quantum theory and that state that the principal transmitter of gravity is the graviton [n SUPERGRAVITIES]\n",
  "SUPERGROUP": "a pop group made up of established solo artists [n -S]\n",
  "SUPERGROUPS": "SUPERGROUP, a pop group made up of established solo artists [n]\n",
  "SUPERGROWTH": "exceptional growth [n -S]\n",
  "SUPERGROWTHS": "SUPERGROWTH, exceptional growth [n]\n",
  "SUPERGUN": "a very large gun [n -S]\n",
  "SUPERGUNS": "SUPERGUN, a very large gun [n]\n",
  "SUPERHARD": "extremely hard [adj]\n",
  "SUPERHARDEN": "to harden to extremes [v -ED, -ING, -S]\n",
  "SUPERHARDENED": "SUPERHARDEN, to harden to extremes [v]\n",
  "SUPERHARDENING": "SUPERHARDEN, to harden to extremes [v]\n",
  "SUPERHARDENS": "SUPERHARDEN, to harden to extremes [v]\n",
  "SUPERHEAT": "the state of being superheated [n -S] / to heat to excess [v -ED, -ING, -S]\n",
  "SUPERHEATED": "SUPERHEAT, to heat to excess [v]\n",
  "SUPERHEATER": "a device for superheating [n -S]\n",
  "SUPERHEATERS": "SUPERHEATER, a device for superheating [n]\n",
  "SUPERHEATING": "SUPERHEAT, to heat to excess [v]\n",
  "SUPERHEATS": "SUPERHEAT, to heat to excess [v]\n",
  "SUPERHEAVIES": "SUPERHEAVY, a superheavy element [n]\n",
  "SUPERHEAVY": "having an atomic weight or number heavier than the heaviest known [adj] / a superheavy element [n SUPERHEAVIES]\n",
  "SUPERHELICAL": "of or like a superhelix [adj]\n",
  "SUPERHELICES": "SUPERHELIX, a helix, as of DNA, which has its axis arranged in a helical coil [n]\n",
  "SUPERHELIX": "a helix, as of DNA, which has its axis arranged in a helical coil [n SUPERHELICES or SUPERHELIXES]\n",
  "SUPERHELIXES": "SUPERHELIX, a helix, as of DNA, which has its axis arranged in a helical coil [n]\n",
  "SUPERHERO": "any of various comic-book heroes with supernormal or superhuman powers [n -ES]\n",
  "SUPERHEROES": "SUPERHERO, any of various comic-book heroes with supernormal or superhuman powers [n]\n",
  "SUPERHEROINE": "an exceptional heroine [n -S]\n",
  "SUPERHEROINES": "SUPERHEROINE, an exceptional heroine [n]\n",
  "SUPERHET": "a superheterodyne receiver, a type of radio receiver [n -S]\n",
  "SUPERHETERODYNE": "applied to radio reception in which oscillations of slightly different frequency are imposed on the received oscillations, producing beats of a frequency above audio-frequency which are easily amplified [n]\n",
  "SUPERHETS": "SUPERHET, a superheterodyne receiver, a type of radio receiver [n]\n",
  "SUPERHIGH": "extremely high [adj]\n",
  "SUPERHIGHWAY": "a multilane highway (as an expressway or turnpike) designed for high-speed traffic [n -S]\n",
  "SUPERHIGHWAYS": "SUPERHIGHWAY, a multilane highway (as an expressway or turnpike) designed for high-speed traffic [n]\n",
  "SUPERHIT": "something exceedingly successful [n -S]\n",
  "SUPERHITS": "SUPERHIT, something exceedingly successful [n]\n",
  "SUPERHIVE": "a removable upper part of a beehive [n -S]\n",
  "SUPERHIVES": "SUPERHIVE, a removable upper part of a beehive [n]\n",
  "SUPERHOT": "extremely hot [adj]\n",
  "SUPERHUMAN": "being above the human [adj SUPERHUMANLY] / someone above the human [n -S]\n",
  "SUPERHUMANISE": "to make superhuman, also SUPERHUMANIZE [v SUPERHUMANISED, SUPERHUMANISING, SUPERHUMANISES]\n",
  "SUPERHUMANISED": "SUPERHUMANISE, to make superhuman, also SUPERHUMANIZE [v]\n",
  "SUPERHUMANISES": "SUPERHUMANISE, to make superhuman, also SUPERHUMANIZE [v]\n",
  "SUPERHUMANISING": "SUPERHUMANISE, to make superhuman, also SUPERHUMANIZE [v]\n",
  "SUPERHUMANITIES": "SUPERHUMANITY, the state of being superhuman [n]\n",
  "SUPERHUMANITY": "the state of being superhuman [n SUPERHUMANITIES]\n",
  "SUPERHUMANIZE": "to make superhuman, also SUPERHUMANISE [v SUPERHUMANIZED, SUPERHUMANIZING, SUPERHUMANIZES]\n",
  "SUPERHUMANIZED": "SUPERHUMANIZE, to make superhuman, also SUPERHUMANISE [v]\n",
  "SUPERHUMANIZES": "SUPERHUMANIZE, to make superhuman, also SUPERHUMANISE [v]\n",
  "SUPERHUMANIZING": "SUPERHUMANIZE, to make superhuman, also SUPERHUMANISE [v]\n",
  "SUPERHUMANLY": "SUPERHUMAN, being above the human [adv]\n",
  "SUPERHUMANNESS": "the state of being superhuman [n]\n",
  "SUPERHUMANS": "SUPERHUMAN, someone above the human [n]\n",
  "SUPERHUMERAL": "an ecclesiastical garment worn over the shoulders [n -S]\n",
  "SUPERHUMERALS": "SUPERHUMERAL, an ecclesiastical garment worn over the shoulders [n]\n",
  "SUPERHYPE": "to subject to an exceptional degree of hype [v SUPERHYPED, SUPERHYPING, SUPERHYPES]\n",
  "SUPERHYPED": "SUPERHYPE, to subject to an exceptional degree of hype [v]\n",
  "SUPERHYPES": "SUPERHYPE, to subject to an exceptional degree of hype [v]\n",
  "SUPERHYPING": "SUPERHYPE, to subject to an exceptional degree of hype [v]\n",
  "SUPERIMPORTANT": "having a very high degree of importance [adj]\n",
  "SUPERIMPOSABLE": "capable of being superimposed [adj]\n",
  "SUPERIMPOSE": "to place or lay over or above something [v SUPERIMPOSED, SUPERIMPOSING, SUPERIMPOSES]\n",
  "SUPERIMPOSED": "SUPERIMPOSE, to place or lay over or above something [v]\n",
  "SUPERIMPOSES": "SUPERIMPOSE, to place or lay over or above something [v]\n",
  "SUPERIMPOSING": "SUPERIMPOSE, to place or lay over or above something [v]\n",
  "SUPERIMPOSITION": "the act of superimposing [n]\n",
  "SUPERINCUMBENCE": "the state of lying on top of, also SUPERINCUMBENCY [n]\n",
  "SUPERINCUMBENCY": "the state of lying on top of, also SUPERINCUMBENCE [n]\n",
  "SUPERINCUMBENT": "resting on top; overlying; overhanging [adj]\n",
  "SUPERINDIVIDUAL": "of, relating to, or being an organism, entity, or complex of more than individual complexity or nature [adj]\n",
  "SUPERINDUCE": "to bring as addition [v SUPERINDUCED, SUPERINDUCING, SUPERINDUCES]\n",
  "SUPERINDUCED": "SUPERINDUCE, to bring as addition [v]\n",
  "SUPERINDUCEMENT": "the act of superinducing [n]\n",
  "SUPERINDUCES": "SUPERINDUCE, to bring as addition [v]\n",
  "SUPERINDUCING": "SUPERINDUCE, to bring as addition [v]\n",
  "SUPERINDUCTION": "the act of superinducing [n -S]\n",
  "SUPERINDUCTIONS": "SUPERINDUCTION, the act of superinducing [n]\n",
  "SUPERINFECT": "to infect with a superinfection [v -ED, -ING, -S]\n",
  "SUPERINFECTED": "SUPERINFECT, to infect with a superinfection [v]\n",
  "SUPERINFECTING": "SUPERINFECT, to infect with a superinfection [v]\n",
  "SUPERINFECTION": "an infection arising during and in addition to another infection and caused by a different (or a different variety of the same) microorganism [n -S]\n",
  "SUPERINFECTIONS": "SUPERINFECTION, an infection arising during and in addition to another infection and caused by a different (or a different variety of the same) microorganism [n]\n",
  "SUPERINFECTS": "SUPERINFECT, to infect with a superinfection [v]\n",
  "SUPERING": "SUPER, to reinforce with a thin cotton mesh, as a book [v]\n",
  "SUPERINSULATED": "extremely insulated [adj]\n",
  "SUPERINTEND": "to have or exercise the charge and oversight of [v -ED, -ING, -S]\n",
  "SUPERINTENDED": "SUPERINTEND, to have or exercise the charge and oversight of [v]\n",
  "SUPERINTENDENCE": "the act or function of superintending or directing, also SUPERINTENDENCY [n]\n",
  "SUPERINTENDENCY": "the act or function of superintending or directing, also SUPERINTENDENCE [n]\n",
  "SUPERINTENDENT": "one who has executive oversight and charge [n -S]\n",
  "SUPERINTENDENTS": "SUPERINTENDENT, one who has executive oversight and charge [n]\n",
  "SUPERINTENDING": "SUPERINTEND, to have or exercise the charge and oversight of [v]\n",
  "SUPERINTENDS": "SUPERINTEND, to have or exercise the charge and oversight of [v]\n",
  "SUPERINTENSITY": "extreme intensity [n]\n",
  "SUPERIOR": "of higher rank, quality, or authority than another [adj SUPERIORLY] / one who is superior [n -S]\n",
  "SUPERIORESS": "the head of a nunnery [n -ES]\n",
  "SUPERIORESSES": "SUPERIORESS, the head of a nunnery [n]\n",
  "SUPERIORITIES": "SUPERIORITY, the state of being superior [n]\n",
  "SUPERIORITY": "the state of being superior [n SUPERIORITIES]\n",
  "SUPERIORLY": "SUPERIOR, of higher rank, quality, or authority than another [adv]\n",
  "SUPERIORS": "SUPERIOR, one who is superior [n]\n",
  "SUPERIORSHIP": "the office of superior [n -S]\n",
  "SUPERIORSHIPS": "SUPERIORSHIP, the office of superior [n]\n",
  "SUPERJACENT": "lying above or upon [adj]\n",
  "SUPERJET": "a type of jet airplane [n -S]\n",
  "SUPERJETS": "SUPERJET, a type of jet airplane [n]\n",
  "SUPERJOCK": "a very good athlete [n -S]\n",
  "SUPERJOCKS": "SUPERJOCK, a very good athlete [n]\n",
  "SUPERJUMBO": "a very large airliner [n -S]\n",
  "SUPERJUMBOS": "SUPERJUMBO, a very large airliner [n]\n",
  "SUPERKINGDOM": "a taxonomical classification comprising several kingdoms [n -S]\n",
  "SUPERKINGDOMS": "SUPERKINGDOM, a taxonomical classification comprising several kingdoms [n]\n",
  "SUPERLAIN": "SUPERLIE, to lie above [v]\n",
  "SUPERLARGE": "exceptionally large [adj]\n",
  "SUPERLATIVE": "excelling [adj SUPERLATIVELY] / the superlative degree of comparison in a language [n -S]\n",
  "SUPERLATIVELY": "SUPERLATIVE, excelling [adv]\n",
  "SUPERLATIVENESS": "the state of being superlative [n]\n",
  "SUPERLATIVES": "SUPERLATIVE, the superlative degree of comparison in a language [n]\n",
  "SUPERLAWYER": "a top class lawyer [n -S]\n",
  "SUPERLAWYERS": "SUPERLAWYER, a top class lawyer [n]\n",
  "SUPERLAY": "SUPERLIE, to lie above [v]\n",
  "SUPERLIE": "to lie above [v SUPERLAY, SUPERLAIN, SUPERLYING, SUPERLIES]\n",
  "SUPERLIES": "SUPERLIE, to lie above [v]\n",
  "SUPERLIGHT": "very light [adj]\n",
  "SUPERLINER": "a very large ocean liner [n -S]\n",
  "SUPERLINERS": "SUPERLINER, a very large ocean liner [n]\n",
  "SUPERLOAD": "a variable weight on a structure [n -S]\n",
  "SUPERLOADS": "SUPERLOAD, a variable weight on a structure [n]\n",
  "SUPERLOBBYIST": "an exceptionally effective lobbyist [n -S]\n",
  "SUPERLOBBYISTS": "SUPERLOBBYIST, an exceptionally effective lobbyist [n]\n",
  "SUPERLONG": "extremely long [adj]\n",
  "SUPERLOO": "a self-cleaning public toilet [n -S]\n",
  "SUPERLOOS": "SUPERLOO, a self-cleaning public toilet [n]\n",
  "SUPERLOYALIST": "an extreme loyalist [n -S]\n",
  "SUPERLOYALISTS": "SUPERLOYALIST, an extreme loyalist [n]\n",
  "SUPERLUMINAL": "faster than light [adj]\n",
  "SUPERLUNAR": "otherworldly; above the moon, also SUPERLUNARY [adj]\n",
  "SUPERLUNARY": "otherworldly; above the moon, also SUPERLUNAR [adj]\n",
  "SUPERLUXURIES": "SUPERLUXURY, extreme luxury [n]\n",
  "SUPERLUXURIOUS": "very luxurious [adj]\n",
  "SUPERLUXURY": "extreme luxury [n SUPERLUXURIES]\n",
  "SUPERLYING": "SUPERLIE, to lie above [v]\n",
  "SUPERMACHO": "very macho [adj]\n",
  "SUPERMAJORITIES": "SUPERMAJORITY, a majority (as two-thirds or three-fifths) greater than a simple majority [n]\n",
  "SUPERMAJORITY": "a majority (as two-thirds or three-fifths) greater than a simple majority [n SUPERMAJORITIES]\n",
  "SUPERMALE": "an excessively macho male [n -S]\n",
  "SUPERMALES": "SUPERMALE, an excessively macho male [n]\n",
  "SUPERMAN": "a hypothetical superior man [n SUPERMEN]\n",
  "SUPERMARKET": "a self-service retail market selling especially foods and household merchandise [n -S]\n",
  "SUPERMARKETS": "SUPERMARKET, a self-service retail market selling especially foods and household merchandise [n]\n",
  "SUPERMART": "a big supermarket [n -S]\n",
  "SUPERMARTS": "SUPERMART, a big supermarket [n]\n",
  "SUPERMASCULINE": "extremely masculine [adj]\n",
  "SUPERMASSIVE": "extremely massive [adj]\n",
  "SUPERMAX": "a jail with the highest level of security [n -ES]\n",
  "SUPERMAXES": "SUPERMAX, a jail with the highest level of security [n]\n",
  "SUPERMEMBRANE": "a type of membrane postulated in certain theories of elementary particles that involve supersymmetry [n -S]\n",
  "SUPERMEMBRANES": "SUPERMEMBRANE, a type of membrane postulated in certain theories of elementary particles that involve supersymmetry [n]\n",
  "SUPERMEN": "SUPERMAN, a hypothetical superior man [n]\n",
  "SUPERMICRO": "a very small micro computer [n -S]\n",
  "SUPERMICROS": "SUPERMICRO, a very small micro computer [n]\n",
  "SUPERMILITANT": "an exceptionally militant person [n -S]\n",
  "SUPERMILITANTS": "SUPERMILITANT, an exceptionally militant person [n]\n",
  "SUPERMIND": "a more than human intelligence [n -S]\n",
  "SUPERMINDS": "SUPERMIND, a more than human intelligence [n]\n",
  "SUPERMINI": "a small car with a good standard of performance and comfort [n -S]\n",
  "SUPERMINIS": "SUPERMINI, a small car with a good standard of performance and comfort [n]\n",
  "SUPERMINISTER": "a minister above other ministers [n -S]\n",
  "SUPERMINISTERS": "SUPERMINISTER, a minister above other ministers [n]\n",
  "SUPERMODEL": "a famous and successful fashion model [n -S]\n",
  "SUPERMODELS": "SUPERMODEL, a famous and successful fashion model [n]\n",
  "SUPERMODERN": "very modern [adj]\n",
  "SUPERMOM": "a superior mother [n -S]\n",
  "SUPERMOMS": "SUPERMOM, a superior mother [n]\n",
  "SUPERMOON": "an instance of the moon appearing particularly large in the sky due to its closest approach to the earth (the perigee) coinciding with a full moon [n -S]\n",
  "SUPERMOONS": "SUPERMOON, an instance of the moon appearing particularly large in the sky due to its closest approach to the earth (the perigee) coinciding with a full moon [n]\n",
  "SUPERMOTO": "a form of motorcycle racing over part tarmac, part dirt [n -S]\n",
  "SUPERMOTOS": "SUPERMOTO, a form of motorcycle racing over part tarmac, part dirt [n]\n",
  "SUPERMUNDANE": "above worldly things [adj]\n",
  "SUPERNACULA": "SUPERNACULUM, liquor of the best kind [n]\n",
  "SUPERNACULAR": "very good; first rate [adj]\n",
  "SUPERNACULUM": "liquor of the best kind [n SUPERNACULA]\n",
  "SUPERNAL": "being or coming from on high; celestial [adj]\n",
  "SUPERNALLY": "SUPERNAL, being or coming from on high; celestial [adv]\n",
  "SUPERNANNIES": "SUPERNANNY, an expert who advises parents on how to deal with badly-behaved children [n]\n",
  "SUPERNANNY": "an expert who advises parents on how to deal with badly-behaved children [n SUPERNANNIES]\n",
  "SUPERNATANT": "floating or swimming above [adj] / a liquid overlying a sediment [n -S]\n",
  "SUPERNATANTS": "SUPERNATANT, a liquid overlying a sediment [n]\n",
  "SUPERNATATION": "the state of being supernatant, floating or swimming above [n -S]\n",
  "SUPERNATATIONS": "SUPERNATATION, the state of being supernatant, floating or swimming above [n]\n",
  "SUPERNATE": "to float on a surface [v SUPERNATED, SUPERNATING, SUPERNATES]\n",
  "SUPERNATED": "SUPERNATE, to float on a surface [v]\n",
  "SUPERNATES": "SUPERNATE, to float on a surface [v]\n",
  "SUPERNATING": "SUPERNATE, to float on a surface [v]\n",
  "SUPERNATION": "an aggregate of nations [n -S]\n",
  "SUPERNATIONAL": "overriding national sovereignty; in or belonging to more than one nation [adj SUPERNATIONALLY]\n",
  "SUPERNATIONALLY": "SUPERNATIONAL, overriding national sovereignty; in or belonging to more than one nation [adv]\n",
  "SUPERNATIONS": "SUPERNATION, an aggregate of nations [n]\n",
  "SUPERNATURAL": "of or relating to an order of existence beyond the visible observable universe [adj SUPERNATURALLY] / that which is supernatural [n -S]\n",
  "SUPERNATURALISE": "to make supernatural, also SUPERNATURALIZE [v]\n",
  "SUPERNATURALISM": "the state of being supernatural [n]\n",
  "SUPERNATURALIST": "relating to supernaturalism [n]\n",
  "SUPERNATURALIZE": "to make supernatural, also SUPERNATURALISE [v]\n",
  "SUPERNATURALLY": "SUPERNATURAL, of or relating to an order of existence beyond the visible observable universe [adv]\n",
  "SUPERNATURALS": "SUPERNATURAL, that which is supernatural [n]\n",
  "SUPERNATURE": "the realm of the supernatural [n -S]\n",
  "SUPERNATURES": "SUPERNATURE, the realm of the supernatural [n]\n",
  "SUPERNORMAL": "exceeding the normal or average [adj SUPERNORMALLY]\n",
  "SUPERNORMALITY": "the state of being supernormal [n]\n",
  "SUPERNORMALLY": "SUPERNORMAL, exceeding the normal or average [adv]\n",
  "SUPERNOVA": "(Latin) a very brilliant nova resulting from an explosion which blows the star's material into space, leaving an expanding cloud of gas [n SUPERNOVAE or SUPERNOVAS]\n",
  "SUPERNOVAE": "SUPERNOVA, (Latin) a very brilliant nova resulting from an explosion which blows the star's material into space, leaving an expanding cloud of gas [n]\n",
  "SUPERNOVAS": "SUPERNOVA, (Latin) a very brilliant nova resulting from an explosion which blows the star's material into space, leaving an expanding cloud of gas [n]\n",
  "SUPERNUMERARIES": "SUPERNUMERARY, an actor without a speaking part [n]\n",
  "SUPERNUMERARY": "above the stated, usual or necessary number [adj] / an actor without a speaking part [n SUPERNUMERARIES]\n",
  "SUPERNURSE": "a highly experienced nurse paid to remain in the field of direct patient care rather than seek promotion to a management post [n -S]\n",
  "SUPERNURSES": "SUPERNURSE, a highly experienced nurse paid to remain in the field of direct patient care rather than seek promotion to a management post [n]\n",
  "SUPERNUTRIENT": "an exceptionally good nutrient [n -S]\n",
  "SUPERNUTRIENTS": "SUPERNUTRIENT, an exceptionally good nutrient [n]\n",
  "SUPERNUTRITION": "exceptional nutrition [n -S]\n",
  "SUPERNUTRITIONS": "SUPERNUTRITION, exceptional nutrition [n]\n",
  "SUPEROCTAVE": "an organ coupler giving an octave higher; an organ stop two octaves above the basic pitch [n -S]\n",
  "SUPEROCTAVES": "SUPEROCTAVE, an organ coupler giving an octave higher; an organ stop two octaves above the basic pitch [n]\n",
  "SUPERORDER": "a group intermediate in importance between an order and a subclass [n -S]\n",
  "SUPERORDERS": "SUPERORDER, a group intermediate in importance between an order and a subclass [n]\n",
  "SUPERORDINAL": "relating to a superorder [adj]\n",
  "SUPERORDINARY": "ordinary to a very high degree [adj]\n",
  "SUPERORDINATE": "superior in rank, class, or status [n -S] / to make superordinate [v SUPERORDINATED, SUPERORDINATING, SUPERORDINATES]\n",
  "SUPERORDINATED": "SUPERORDINATE, to make superordinate [v]\n",
  "SUPERORDINATES": "SUPERORDINATE, to make superordinate [v]\n",
  "SUPERORDINATING": "SUPERORDINATE, to make superordinate [v]\n",
  "SUPERORDINATION": "the relation of a universal proposition to a particular proposition in the same terms [n]\n",
  "SUPERORGANIC": "relating to those aspects of a culture that are conceived as being superior to the individual members of the society [adj]\n",
  "SUPERORGANICISM": "the state of being superorganic [n]\n",
  "SUPERORGANICIST": "one who studies the superorganic [n]\n",
  "SUPERORGANISM": "an organized society (as of a social insect) that functions as an organic whole [n -S]\n",
  "SUPERORGANISMS": "SUPERORGANISM, an organized society (as of a social insect) that functions as an organic whole [n]\n",
  "SUPERORGASM": "an extreme orgasm [n -S]\n",
  "SUPERORGASMS": "SUPERORGASM, an extreme orgasm [n]\n",
  "SUPEROVULATE": "to produce a larger number of ova than usual, e.g. under stimulus of injected hormones [v SUPEROVULATED, SUPEROVULATING, SUPEROVULATES]\n",
  "SUPEROVULATED": "SUPEROVULATE, to produce a larger number of ova than usual, e.g. under stimulus of injected hormones [v]\n",
  "SUPEROVULATES": "SUPEROVULATE, to produce a larger number of ova than usual, e.g. under stimulus of injected hormones [v]\n",
  "SUPEROVULATING": "SUPEROVULATE, to produce a larger number of ova than usual, e.g. under stimulus of injected hormones [v]\n",
  "SUPEROVULATION": "production of exceptional numbers of ova at one time [n -S]\n",
  "SUPEROVULATIONS": "SUPEROVULATION, production of exceptional numbers of ova at one time [n]\n",
  "SUPEROXIDE": "a peroxide, an oxide with the highest proportion of oxygen [n -S]\n",
  "SUPEROXIDES": "SUPEROXIDE, a peroxide, an oxide with the highest proportion of oxygen [n]\n",
  "SUPERPARASITISM": "parasitization of a host by more than one parasitic individual usually of one kind [n]\n",
  "SUPERPARTICLE": "a particle postulated in supersymmetry theory [n -S]\n",
  "SUPERPARTICLES": "SUPERPARTICLE, a particle postulated in supersymmetry theory [n]\n",
  "SUPERPATRIOT": "an exceptional patriot [n -S]\n",
  "SUPERPATRIOTIC": "extremely patriotic [adj]\n",
  "SUPERPATRIOTISM": "extreme patriotism [n]\n",
  "SUPERPATRIOTS": "SUPERPATRIOT, an exceptional patriot [n]\n",
  "SUPERPEOPLE": "SUPERPERSON, a very remarkable person [n]\n",
  "SUPERPERSON": "a very remarkable person [n SUPERPERSONS or SUPERPEOPLE]\n",
  "SUPERPERSONAL": "extremely personal [adj]\n",
  "SUPERPERSONS": "SUPERPERSON, a very remarkable person [n]\n",
  "SUPERPHENOMENA": "SUPERPHENOMENON, an exceptional phenomenon [n]\n",
  "SUPERPHENOMENON": "an exceptional phenomenon [n SUPERPHENOMENA]\n",
  "SUPERPHONE": "a telephone with a high-speed processor that can perform many of the functions of a computer [n -S]\n",
  "SUPERPHONES": "SUPERPHONE, a telephone with a high-speed processor that can perform many of the functions of a computer [n]\n",
  "SUPERPHOSPHATE": "acid phosphate [n -S]\n",
  "SUPERPHOSPHATES": "SUPERPHOSPHATE, acid phosphate [n]\n",
  "SUPERPHYLA": "SUPERPHYLUM, a taxonomical division above phylum [n]\n",
  "SUPERPHYLUM": "a taxonomical division above phylum [n SUPERPHYLA]\n",
  "SUPERPHYSICAL": "being above or beyond the physical world or explanation on physical principles [adj]\n",
  "SUPERPIMP": "a pimp controlling other pimps [n -S]\n",
  "SUPERPIMPS": "SUPERPIMP, a pimp controlling other pimps [n]\n",
  "SUPERPLANE": "a very large plane [n -S]\n",
  "SUPERPLANES": "SUPERPLANE, a very large plane [n]\n",
  "SUPERPLASTIC": "capable of plastic deformation under low stress at an elevated temperature [adj] / a plastic with these qualities [n -S]\n",
  "SUPERPLASTICITY": "the state of being superplastic [n]\n",
  "SUPERPLASTICS": "SUPERPLASTIC, a plastic with these qualities [n]\n",
  "SUPERPLAYER": "an exceptionally talented player [n -S]\n",
  "SUPERPLAYERS": "SUPERPLAYER, an exceptionally talented player [n]\n",
  "SUPERPLUS": "(obsolete) a surplus [n -ES]\n",
  "SUPERPLUSES": "SUPERPLUS, (obsolete) a surplus [n]\n",
  "SUPERPOLITE": "extremely polite [adj]\n",
  "SUPERPOLYMER": "a superior polymer [n -S]\n",
  "SUPERPOLYMERS": "SUPERPOLYMER, a superior polymer [n]\n",
  "SUPERPORT": "a superior port [n -S]\n",
  "SUPERPORTS": "SUPERPORT, a superior port [n]\n",
  "SUPERPOSABLE": "capable of being superposed [adj]\n",
  "SUPERPOSE": "to place above or on something else [v SUPERPOSED, SUPERPOSING, SUPERPOSES]\n",
  "SUPERPOSED": "SUPERPOSE, to place above or on something else [v]\n",
  "SUPERPOSES": "SUPERPOSE, to place above or on something else [v]\n",
  "SUPERPOSING": "SUPERPOSE, to place above or on something else [v]\n",
  "SUPERPOSITION": "the act of superposing [n -S]\n",
  "SUPERPOSITIONS": "SUPERPOSITION, the act of superposing [n]\n",
  "SUPERPOWER": "a great power [n -S]\n",
  "SUPERPOWERED": "having a superpower [adj]\n",
  "SUPERPOWERFUL": "very powerful [adj]\n",
  "SUPERPOWERS": "SUPERPOWER, a great power [n]\n",
  "SUPERPRAISE": "to give very high praise [v SUPERPRAISED, SUPERPRAISING, SUPERPRAISES]\n",
  "SUPERPRAISED": "SUPERPRAISE, to give very high praise [v]\n",
  "SUPERPRAISES": "SUPERPRAISE, to give very high praise [v]\n",
  "SUPERPRAISING": "SUPERPRAISE, to give very high praise [v]\n",
  "SUPERPREMIUM": "a very large premium [n -S]\n",
  "SUPERPREMIUMS": "SUPERPREMIUM, a very large premium [n]\n",
  "SUPERPRO": "a superior professional [n -S]\n",
  "SUPERPROFIT": "an exceptional profit [n -S]\n",
  "SUPERPROFITS": "SUPERPROFIT, an exceptional profit [n]\n",
  "SUPERPROS": "SUPERPRO, a superior professional [n]\n",
  "SUPERQUALITIES": "SUPERQUALITY, exceptional quality [n]\n",
  "SUPERQUALITY": "exceptional quality [n SUPERQUALITIES]\n",
  "SUPERRACE": "a race that dominates, or thinks it has the right to dominate, other inferior races [n -S]\n",
  "SUPERRACES": "SUPERRACE, a race that dominates, or thinks it has the right to dominate, other inferior races [n]\n",
  "SUPERREAL": "excessively real [adj]\n",
  "SUPERREALISM": "in art, a style that transcends realism [n -S]\n",
  "SUPERREALISMS": "SUPERREALISM, in art, a style that transcends realism [n]\n",
  "SUPERREALIST": "an adherent of superrealism [n -S]\n",
  "SUPERREALISTS": "SUPERREALIST, an adherent of superrealism [n]\n",
  "SUPERREFINE": "to refine to a very high degree [v SUPERREFINED, SUPERREFINING, SUPERREFINES]\n",
  "SUPERREFINED": "SUPERREFINE, to refine to a very high degree [v]\n",
  "SUPERREFINES": "SUPERREFINE, to refine to a very high degree [v]\n",
  "SUPERREFINING": "SUPERREFINE, to refine to a very high degree [v]\n",
  "SUPERREGIONAL": "a sporting event contested by many regions [n -S]\n",
  "SUPERREGIONALS": "SUPERREGIONAL, a sporting event contested by many regions [n]\n",
  "SUPERRICH": "very rich [adj]\n",
  "SUPERROAD": "a superior road [n -S]\n",
  "SUPERROADS": "SUPERROAD, a superior road [n]\n",
  "SUPERROMANTIC": "extremely romantic [adj]\n",
  "SUPERS": "SUPER, to reinforce with a thin cotton mesh, as a book [v]\n",
  "SUPERSAFE": "very safe [adj]\n",
  "SUPERSAFETIES": "SUPERSAFETY, the state of being supersafe [n]\n",
  "SUPERSAFETY": "the state of being supersafe [n SUPERSAFETIES]\n",
  "SUPERSALE": "a big sale [n -S]\n",
  "SUPERSALES": "SUPERSALE, a big sale [n]\n",
  "SUPERSALESMAN": "an exceptional salesman [n SUPERSALESMEN]\n",
  "SUPERSALESMEN": "SUPERSALESMAN, an exceptional salesman [n]\n",
  "SUPERSALT": "an acid salt [n -S]\n",
  "SUPERSALTS": "SUPERSALT, an acid salt [n]\n",
  "SUPERSATURATE": "to add to (a solution) beyond saturation [v SUPERSATURATED, SUPERSATURATING, SUPERSATURATES]\n",
  "SUPERSATURATED": "SUPERSATURATE, to add to (a solution) beyond saturation [v]\n",
  "SUPERSATURATES": "SUPERSATURATE, to add to (a solution) beyond saturation [v]\n",
  "SUPERSATURATING": "SUPERSATURATE, to add to (a solution) beyond saturation [v]\n",
  "SUPERSATURATION": "the state of being supersaturated [n]\n",
  "SUPERSAUR": "a very large dinosaur [n -S]\n",
  "SUPERSAURS": "SUPERSAUR, a very large dinosaur [n]\n",
  "SUPERSAVER": "an exceptional bargain in a supermarket [n -S]\n",
  "SUPERSAVERS": "SUPERSAVER, an exceptional bargain in a supermarket [n]\n",
  "SUPERSCALAR": "of a processor, able to perform more than one instruction simultaneously [adj]\n",
  "SUPERSCALE": "on a very large scale [adj]\n",
  "SUPERSCHOOL": "an exceptional school [n -S]\n",
  "SUPERSCHOOLS": "SUPERSCHOOL, an exceptional school [n]\n",
  "SUPERSCOUT": "a superlative scout [n -S]\n",
  "SUPERSCOUTS": "SUPERSCOUT, a superlative scout [n]\n",
  "SUPERSCREEN": "a very large screen [n -S]\n",
  "SUPERSCREENS": "SUPERSCREEN, a very large screen [n]\n",
  "SUPERSCRIBE": "to write at the top or at the head [v SUPERSCRIBED, SUPERSCRIBING, SUPERSCRIBES]\n",
  "SUPERSCRIBED": "SUPERSCRIBE, to write at the top or at the head [v]\n",
  "SUPERSCRIBES": "SUPERSCRIBE, to write at the top or at the head [v]\n",
  "SUPERSCRIBING": "SUPERSCRIBE, to write at the top or at the head [v]\n",
  "SUPERSCRIPT": "something written above [n -S]\n",
  "SUPERSCRIPTION": "something written above [n -S]\n",
  "SUPERSCRIPTIONS": "SUPERSCRIPTION, something written above [n]\n",
  "SUPERSCRIPTS": "SUPERSCRIPT, something written above [n]\n",
  "SUPERSECRECIES": "SUPERSECRECY, extreme secrecy [n]\n",
  "SUPERSECRECY": "extreme secrecy [n SUPERSECRECIES]\n",
  "SUPERSECRET": "a top secret [n -S]\n",
  "SUPERSECRETS": "SUPERSECRET, a top secret [n]\n",
  "SUPERSEDABLE": "that can be superseded [adj]\n",
  "SUPERSEDE": "to take the place of, also SUPERCEDE [v SUPERSEDED, SUPERSEDING, SUPERSEDES]\n",
  "SUPERSEDEAS": "a stay order (to stay an execution or legal proceedings) [n -ES]\n",
  "SUPERSEDEASES": "SUPERSEDEAS, a stay order (to stay an execution or legal proceedings) [n]\n",
  "SUPERSEDED": "SUPERSEDE, to take the place of, also SUPERCEDE [v]\n",
  "SUPERSEDENCE": "the act of superseding [n -S]\n",
  "SUPERSEDENCES": "SUPERSEDENCE, the act of superseding [n]\n",
  "SUPERSEDER": "one who supersedes [n -S]\n",
  "SUPERSEDERE": "(Scots) a private agreement among creditors, under a trust-law, to supersede or sist diligence for a certain period [n -S]\n",
  "SUPERSEDERES": "SUPERSEDERE, (Scots) a private agreement among creditors, under a trust-law, to supersede or sist diligence for a certain period [n]\n",
  "SUPERSEDERS": "SUPERSEDER, one who supersedes [n]\n",
  "SUPERSEDES": "SUPERSEDE, to take the place of, also SUPERCEDE [v]\n",
  "SUPERSEDING": "SUPERSEDE, to take the place of, also SUPERCEDE [v]\n",
  "SUPERSEDURE": "the act of superseding [n -S]\n",
  "SUPERSEDURES": "SUPERSEDURE, the act of superseding [n]\n",
  "SUPERSELL": "to sell in exceptional quantities [v SUPERSOLD, SUPERSELLING, SUPERSELLS]\n",
  "SUPERSELLER": "something that sells exceptionally well [n -S]\n",
  "SUPERSELLERS": "SUPERSELLER, something that sells exceptionally well [n]\n",
  "SUPERSELLING": "SUPERSELL, to sell in exceptional quantities [v]\n",
  "SUPERSELLS": "SUPERSELL, to sell in exceptional quantities [v]\n",
  "SUPERSENSIBLE": "beyond physical perception; spiritual [adj SUPERSENSIBLY]\n",
  "SUPERSENSIBLY": "SUPERSENSIBLE, beyond physical perception; spiritual [adv]\n",
  "SUPERSENSITIVE": "extremely sensitive [adj]\n",
  "SUPERSENSORY": "above the range, beyond the reach, or outside the realm, of the senses [adj]\n",
  "SUPERSENSUAL": "sensual to a very high degree [adj]\n",
  "SUPERSESSION": "the act of superseding [n -S]\n",
  "SUPERSESSIONS": "SUPERSESSION, the act of superseding [n]\n",
  "SUPERSET": "a set that includes all the elements of another set plus further elements [n -S]\n",
  "SUPERSETS": "SUPERSET, a set that includes all the elements of another set plus further elements [n]\n",
  "SUPERSEX": "very good sex [n -ES]\n",
  "SUPERSEXES": "SUPERSEX, very good sex [n]\n",
  "SUPERSEXUALITY": "exceptional sexuality [n]\n",
  "SUPERSHARP": "exceptionally sharp [adj]\n",
  "SUPERSHOW": "an exceptional show [n -S]\n",
  "SUPERSHOWS": "SUPERSHOW, an exceptional show [n]\n",
  "SUPERSINGER": "an exceptionally talented singer [n -S]\n",
  "SUPERSINGERS": "SUPERSINGER, an exceptionally talented singer [n]\n",
  "SUPERSIZE": "to increase the size of [v SUPERSIZED, SUPERSIZING, SUPERSIZES]\n",
  "SUPERSIZED": "SUPERSIZE, to increase the size of [v]\n",
  "SUPERSIZES": "SUPERSIZE, to increase the size of [v]\n",
  "SUPERSIZING": "SUPERSIZE, to increase the size of [v]\n",
  "SUPERSLEUTH": "a very effective detective [n -S]\n",
  "SUPERSLEUTHS": "SUPERSLEUTH, a very effective detective [n]\n",
  "SUPERSLICK": "very slick [adj]\n",
  "SUPERSMART": "very smart [adj]\n",
  "SUPERSMOOTH": "very very smooth [adj]\n",
  "SUPERSOFT": "very soft [adj]\n",
  "SUPERSOLD": "SUPERSELL, to sell in exceptional quantities [v]\n",
  "SUPERSONIC": "above the speed of sound [adj SUPERSONICALLY] / a supersonic wave or frequency [n -S]\n",
  "SUPERSONICALLY": "SUPERSONIC, above the speed of sound [adv]\n",
  "SUPERSONICS": "SUPERSONIC, a supersonic wave or frequency [n]\n",
  "SUPERSOUND": "sound vibrations too rapid to be audible [n -S]\n",
  "SUPERSOUNDS": "SUPERSOUND, sound vibrations too rapid to be audible [n]\n",
  "SUPERSPECIAL": "something exceptionally special [n -S]\n",
  "SUPERSPECIALIST": "an exceptional specialist [n]\n",
  "SUPERSPECIALS": "SUPERSPECIAL, something exceptionally special [n]\n",
  "SUPERSPECIES": "a term for two or more species that are separated geographically but are so similar in form and habits that if the barrier were removed they would probably interbreed and produce fertile young [n]\n",
  "SUPERSPECTACLE": "an exceptional spectacle [n -S]\n",
  "SUPERSPECTACLES": "SUPERSPECTACLE, an exceptional spectacle [n]\n",
  "SUPERSPEED": "a very high speed [n -S]\n",
  "SUPERSPEEDS": "SUPERSPEED, a very high speed [n]\n",
  "SUPERSPIES": "SUPERSPY, a superior spy [n]\n",
  "SUPERSPY": "a superior spy [n SUPERSPIES]\n",
  "SUPERSTAR": "an extremely popular and successful star of the cinema, popular music, etc. [n -S]\n",
  "SUPERSTARDOM": "being a superstar [n -S]\n",
  "SUPERSTARDOMS": "SUPERSTARDOM, being a superstar [n]\n",
  "SUPERSTARS": "SUPERSTAR, an extremely popular and successful star of the cinema, popular music, etc. [n]\n",
  "SUPERSTATE": "a state or organization having governing power over subordinate states [n -S]\n",
  "SUPERSTATES": "SUPERSTATE, a state or organization having governing power over subordinate states [n]\n",
  "SUPERSTATION": "an exceptional station [n -S]\n",
  "SUPERSTATIONS": "SUPERSTATION, an exceptional station [n]\n",
  "SUPERSTIMULATE": "to stimulate beyond a normal level [v SUPERSTIMULATED, SUPERSTIMULATES]\n",
  "SUPERSTIMULATED": "SUPERSTIMULATE, to stimulate beyond a normal level [v]\n",
  "SUPERSTIMULATES": "SUPERSTIMULATE, to stimulate beyond a normal level [v]\n",
  "SUPERSTITION": "false worship or religion; an ignorant and irrational belief in supernatural agency [n -S]\n",
  "SUPERSTITIONS": "SUPERSTITION, false worship or religion; an ignorant and irrational belief in supernatural agency [n]\n",
  "SUPERSTITIOUS": "relating to superstition [adj SUPERSTITIOUSLY]\n",
  "SUPERSTITIOUSLY": "SUPERSTITIOUS, relating to superstition [adv]\n",
  "SUPERSTOCK": "a very high-performing stock [n -S]\n",
  "SUPERSTOCKS": "SUPERSTOCK, a very high-performing stock [n]\n",
  "SUPERSTORE": "a very large store often offering a wide variety of merchandise for sale [n -S]\n",
  "SUPERSTORES": "SUPERSTORE, a very large store often offering a wide variety of merchandise for sale [n]\n",
  "SUPERSTORM": "an extremely powerful storm that causes widespread devastation [n -S]\n",
  "SUPERSTORMS": "SUPERSTORM, an extremely powerful storm that causes widespread devastation [n]\n",
  "SUPERSTRATA": "SUPERSTRATUM, an overlying layer [n]\n",
  "SUPERSTRATUM": "an overlying layer [n SUPERSTRATA or SUPERSTRATUMS]\n",
  "SUPERSTRATUMS": "SUPERSTRATUM, an overlying layer [n]\n",
  "SUPERSTRENGTH": "exceptional strength [n -S]\n",
  "SUPERSTRENGTHS": "SUPERSTRENGTH, exceptional strength [n]\n",
  "SUPERSTRIKE": "an exceptional strike [n -S]\n",
  "SUPERSTRIKES": "SUPERSTRIKE, an exceptional strike [n]\n",
  "SUPERSTRING": "a hypothetical very small one-dimensional particle from which other fundamental particles arise [n -S]\n",
  "SUPERSTRINGS": "SUPERSTRING, a hypothetical very small one-dimensional particle from which other fundamental particles arise [n]\n",
  "SUPERSTRONG": "very very strong [adj]\n",
  "SUPERSTRUCT": "to build on something else as a foundation [v -ED, -ING, -S]\n",
  "SUPERSTRUCTED": "SUPERSTRUCT, to build on something else as a foundation [v]\n",
  "SUPERSTRUCTING": "SUPERSTRUCT, to build on something else as a foundation [v]\n",
  "SUPERSTRUCTION": "the act of superstructing [n -S]\n",
  "SUPERSTRUCTIONS": "SUPERSTRUCTION, the act of superstructing [n]\n",
  "SUPERSTRUCTIVE": "relating to a superstructure [adj]\n",
  "SUPERSTRUCTS": "SUPERSTRUCT, to build on something else as a foundation [v]\n",
  "SUPERSTRUCTURAL": "relating to superstructure [adj]\n",
  "SUPERSTRUCTURE": "all of a building above the basement [n -S]\n",
  "SUPERSTRUCTURES": "SUPERSTRUCTURE, all of a building above the basement [n]\n",
  "SUPERSTUD": "an exceptionally virile male [n -S]\n",
  "SUPERSTUDS": "SUPERSTUD, an exceptionally virile male [n]\n",
  "SUPERSUBTILE": "(obsolete) overly subtle, also SUPERSUBTLE [adj]\n",
  "SUPERSUBTLE": "overly subtle, also SUPERSUBTILE [adj]\n",
  "SUPERSUBTLETIES": "SUPERSUBTLETY, the state of being supersubtle [n]\n",
  "SUPERSUBTLETY": "the state of being supersubtle [n SUPERSUBTLETIES]\n",
  "SUPERSURGEON": "an exceptional surgeon [n -S]\n",
  "SUPERSURGEONS": "SUPERSURGEON, an exceptional surgeon [n]\n",
  "SUPERSWEET": "exceptionally sweet [adj]\n",
  "SUPERSYMMETRIC": "relating to supersymmetry [adj]\n",
  "SUPERSYMMETRIES": "SUPERSYMMETRY, the correspondence between fermions and bosons of identical mass that is postulated to have existed during the opening moments of the big bang and that relates gravity to the other forces of nature [n]\n",
  "SUPERSYMMETRY": "the correspondence between fermions and bosons of identical mass that is postulated to have existed during the opening moments of the big bang and that relates gravity to the other forces of nature [n SUPERSYMMETRIES]\n",
  "SUPERSYSTEM": "a system that is made up of systems [n -S]\n",
  "SUPERSYSTEMS": "SUPERSYSTEM, a system that is made up of systems [n]\n",
  "SUPERTANKER": "a very large tanker [n -S]\n",
  "SUPERTANKERS": "SUPERTANKER, a very large tanker [n]\n",
  "SUPERTAX": "an additional tax [n -ES]\n",
  "SUPERTAXES": "SUPERTAX, an additional tax [n]\n",
  "SUPERTEACHER": "an exceptional teacher [n -S]\n",
  "SUPERTEACHERS": "SUPERTEACHER, an exceptional teacher [n]\n",
  "SUPERTERRANEAN": "above or on surface of earth [adj]\n",
  "SUPERTERRIFIC": "extremely terrific [adj]\n",
  "SUPERTHICK": "exceptionally thick [adj]\n",
  "SUPERTHIN": "very thin [adj]\n",
  "SUPERTHRILLER": "an exceptional thriller [n -S]\n",
  "SUPERTHRILLERS": "SUPERTHRILLER, an exceptional thriller [n]\n",
  "SUPERTIGHT": "superlatively tight [adj]\n",
  "SUPERTITLE": "a surtitle, a printed translation of the libretto of an opera in a language foreign to the audience [n -S]\n",
  "SUPERTITLES": "SUPERTITLE, a surtitle, a printed translation of the libretto of an opera in a language foreign to the audience [n]\n",
  "SUPERTONIC": "the note next above the keynote; the second of the scale [n -S]\n",
  "SUPERTONICS": "SUPERTONIC, the note next above the keynote; the second of the scale [n]\n",
  "SUPERTRAM": "a very superior tram [n -S]\n",
  "SUPERTRAMS": "SUPERTRAM, a very superior tram [n]\n",
  "SUPERTRUCK": "a very large truck [n -S]\n",
  "SUPERTRUCKS": "SUPERTRUCK, a very large truck [n]\n",
  "SUPERTWIST": "a technique of twisting light rays, used to improve the quality of LCD's [n -S]\n",
  "SUPERTWISTS": "SUPERTWIST, a technique of twisting light rays, used to improve the quality of LCD's [n]\n",
  "SUPERUSER": "in computing, a special facility used by a systems administrator, giving unrestricted access to the system [n -S]\n",
  "SUPERUSERS": "SUPERUSER, in computing, a special facility used by a systems administrator, giving unrestricted access to the system [n]\n",
  "SUPERVENE": "to come in addition, or closely after, esp. so as to cause a change [v SUPERVENED, SUPERVENING, SUPERVENES]\n",
  "SUPERVENED": "SUPERVENE, to come in addition, or closely after, esp. so as to cause a change [v]\n",
  "SUPERVENES": "SUPERVENE, to come in addition, or closely after, esp. so as to cause a change [v]\n",
  "SUPERVENIENCE": "the act of supervening [n -S]\n",
  "SUPERVENIENCES": "SUPERVENIENCE, the act of supervening [n]\n",
  "SUPERVENIENT": "extraneous, additional or unexpected [adj]\n",
  "SUPERVENING": "SUPERVENE, to come in addition, or closely after, esp. so as to cause a change [v]\n",
  "SUPERVENTION": "the act of supervening [n -S]\n",
  "SUPERVENTIONS": "SUPERVENTION, the act of supervening [n]\n",
  "SUPERVIRILE": "excessively virile [adj]\n",
  "SUPERVIRTUOSI": "SUPERVIRTUOSO, an exceptionally talented virtuoso [n]\n",
  "SUPERVIRTUOSO": "an exceptionally talented virtuoso [n SUPERVIRTUOSI or SUPERVIRTUOSOS]\n",
  "SUPERVIRTUOSOS": "SUPERVIRTUOSO, an exceptionally talented virtuoso [n]\n",
  "SUPERVIRULENT": "virulent to a very high degree [adj]\n",
  "SUPERVISAL": "supervision [n -S]\n",
  "SUPERVISALS": "SUPERVISAL, supervision [n]\n",
  "SUPERVISE": "to oversee, superintend [v SUPERVISED, SUPERVISING, SUPERVISES]\n",
  "SUPERVISED": "SUPERVISE, to oversee, superintend [v]\n",
  "SUPERVISEE": "one who is supervised [n -S]\n",
  "SUPERVISEES": "SUPERVISEE, one who is supervised [n]\n",
  "SUPERVISES": "SUPERVISE, to oversee, superintend [v]\n",
  "SUPERVISING": "SUPERVISE, to oversee, superintend [v]\n",
  "SUPERVISION": "the act of supervising [n -S]\n",
  "SUPERVISIONS": "SUPERVISION, the act of supervising [n]\n",
  "SUPERVISOR": "one that supervises [n -S]\n",
  "SUPERVISORS": "SUPERVISOR, one that supervises [n]\n",
  "SUPERVISORSHIP": "the office of supervisor [n -S]\n",
  "SUPERVISORSHIPS": "SUPERVISORSHIP, the office of supervisor [n]\n",
  "SUPERVISORY": "relating to or having supervision [adj]\n",
  "SUPERVOLUTE": "convolute [adj]\n",
  "SUPERWAIF": "an extremely thin and childlike young fashion model [n -S]\n",
  "SUPERWAIFS": "SUPERWAIF, an extremely thin and childlike young fashion model [n]\n",
  "SUPERWAVE": "an exceptionally large wave [n -S]\n",
  "SUPERWAVES": "SUPERWAVE, an exceptionally large wave [n]\n",
  "SUPERWEAPON": "an exceptionally effective weapon [n -S]\n",
  "SUPERWEAPONS": "SUPERWEAPON, an exceptionally effective weapon [n]\n",
  "SUPERWEED": "a hybrid plant that contains genes for herbicide resistance [n -S]\n",
  "SUPERWEEDS": "SUPERWEED, a hybrid plant that contains genes for herbicide resistance [n]\n",
  "SUPERWIDE": "a very wide camera lens [n -S]\n",
  "SUPERWIDES": "SUPERWIDE, a very wide camera lens [n]\n",
  "SUPERWIFE": "an exceptional wife who combines a career with running a home [n SUPERWIVES]\n",
  "SUPERWIVES": "SUPERWIFE, an exceptional wife who combines a career with running a home [n]\n",
  "SUPERWOMAN": "an exceptional woman [n SUPERWOMEN]\n",
  "SUPERWOMEN": "SUPERWOMAN, an exceptional woman [n]\n",
  "SUPES": "SUPE, (short for) a superintendent [n]\n",
  "SUPINATE": "to turn so that the palm is facing upward [v SUPINATED, SUPINATING, SUPINATES]\n",
  "SUPINATED": "SUPINATE, to turn so that the palm is facing upward [v]\n",
  "SUPINATES": "SUPINATE, to turn so that the palm is facing upward [v]\n",
  "SUPINATING": "SUPINATE, to turn so that the palm is facing upward [v]\n",
  "SUPINATION": "being turned upward [n -S]\n",
  "SUPINATIONS": "SUPINATION, being turned upward [n]\n",
  "SUPINATOR": "a muscle which produces the motion of supination [n -S]\n",
  "SUPINATORS": "SUPINATOR, a muscle which produces the motion of supination [n]\n",
  "SUPINE": "lying on the back, passive [adj SUPINELY] / a Latin verbal noun [n -S]\n",
  "SUPINELY": "SUPINE, lying on the back, passive [adv]\n",
  "SUPINENESS": "the state of being supine [n -ES]\n",
  "SUPINENESSES": "SUPINENESS, the state of being supine [n]\n",
  "SUPINES": "SUPINE, a Latin verbal noun [n]\n",
  "SUPLEX": "a wrestling hold, grasping one's opponent around the waist from behind [n -ES]\n",
  "SUPLEXES": "SUPLEX, a wrestling hold, grasping one's opponent around the waist from behind [n]\n",
  "SUPPAWN": "(Native American) a kind of maize porridge, also SUPAWN [n -S]\n",
  "SUPPAWNS": "SUPPAWN, (Native American) a kind of maize porridge, also SUPAWN [n]\n",
  "SUPPEAGO": "a skin disease [n -ES]\n",
  "SUPPEAGOES": "SUPPEAGO, a skin disease [n]\n",
  "SUPPED": "SUP, to eat supper [v]\n",
  "SUPPEDANEA": "SUPPEDANEUM, a support under the foot of a crucified person [n]\n",
  "SUPPEDANEUM": "a support under the foot of a crucified person [n SUPPEDANEA]\n",
  "SUPPER": "to supply with an evening meal [v -ED, -ING, -S]\n",
  "SUPPERED": "SUPPER, to supply with an evening meal [v]\n",
  "SUPPERING": "SUPPER, to supply with an evening meal [v]\n",
  "SUPPERLESS": "having no supper [adj]\n",
  "SUPPERS": "SUPPER, to supply with an evening meal [v]\n",
  "SUPPERTIME": "the time at which supper is eaten [n -S]\n",
  "SUPPERTIMES": "SUPPERTIME, the time at which supper is eaten [n]\n",
  "SUPPING": "SUP, to eat supper [v]\n",
  "SUPPLANT": "to take the place of [v -ED, -ING, -S]\n",
  "SUPPLANTATION": "the act of supplanting [n -S]\n",
  "SUPPLANTATIONS": "SUPPLANTATION, the act of supplanting [n]\n",
  "SUPPLANTED": "SUPPLANT, to take the place of [v]\n",
  "SUPPLANTER": "one who supplants [n -S]\n",
  "SUPPLANTERS": "SUPPLANTER, one who supplants [n]\n",
  "SUPPLANTING": "SUPPLANT, to take the place of [v]\n",
  "SUPPLANTS": "SUPPLANT, to take the place of [v]\n",
  "SUPPLE": "pliant, lithe [adj SUPPLER, SUPPLEST, SUPPLELY] / to make supple [v SUPPLED, SUPPLING, SUPPLES]\n",
  "SUPPLED": "SUPPLE, to make supple [v]\n",
  "SUPPLEJACK": "a woody climber with a tough pliant stem [n -S]\n",
  "SUPPLEJACKS": "SUPPLEJACK, a woody climber with a tough pliant stem [n]\n",
  "SUPPLELY": "SUPPLE, pliant, lithe [adv]\n",
  "SUPPLEMENT": "to add or serve as a supplement to [v -ED, -ING, -S]\n",
  "SUPPLEMENTAL": "serving to supplement [adj SUPPLEMENTALLY] / something serving to supplement [n -S]\n",
  "SUPPLEMENTALLY": "SUPPLEMENTAL, serving to supplement [adv]\n",
  "SUPPLEMENTALS": "SUPPLEMENTAL, something serving to supplement [n]\n",
  "SUPPLEMENTARIES": "SUPPLEMENTARY, a supplement [n]\n",
  "SUPPLEMENTARILY": "SUPPLEMENTARY, added or serving as a supplement [adv]\n",
  "SUPPLEMENTARY": "added or serving as a supplement [adj SUPPLEMENTARILY] / a supplement [n SUPPLEMENTARIES]\n",
  "SUPPLEMENTATION": "the act of supplementing [n]\n",
  "SUPPLEMENTED": "SUPPLEMENT, to add or serve as a supplement to [v]\n",
  "SUPPLEMENTER": "one who supplements [n -S]\n",
  "SUPPLEMENTERS": "SUPPLEMENTER, one who supplements [n]\n",
  "SUPPLEMENTING": "SUPPLEMENT, to add or serve as a supplement to [v]\n",
  "SUPPLEMENTS": "SUPPLEMENT, to add or serve as a supplement to [v]\n",
  "SUPPLENESS": "the state of being supple [n -ES]\n",
  "SUPPLENESSES": "SUPPLENESS, the state of being supple [n]\n",
  "SUPPLER": "SUPPLE, pliant, lithe [adj]\n",
  "SUPPLES": "SUPPLE, to make supple [v]\n",
  "SUPPLEST": "SUPPLE, pliant, lithe [adj]\n",
  "SUPPLETION": "addition; supplement [n -S]\n",
  "SUPPLETIONS": "SUPPLETION, addition; supplement [n]\n",
  "SUPPLETIVE": "supplementary, also SUPPLETORY [adj] / something supplementary [n -S]\n",
  "SUPPLETIVES": "SUPPLETIVE, something supplementary [n]\n",
  "SUPPLETORILY": "SUPPLETORY, supplemental, also SUPPLETIVE [adv]\n",
  "SUPPLETORY": "supplemental, also SUPPLETIVE [adj SUPPLETORILY]\n",
  "SUPPLIABLE": "that can be supplied [adj]\n",
  "SUPPLIAL": "the act of supplying [n -S]\n",
  "SUPPLIALS": "SUPPLIAL, the act of supplying [n]\n",
  "SUPPLIANCE": "(Shakespeare) supplying [n -S]\n",
  "SUPPLIANCES": "SUPPLIANCE, (Shakespeare) supplying [n]\n",
  "SUPPLIANT": "(Shakespeare) supplicating, asking [adj SUPPLIANTLY] / one who supplicates, also SUPPLICANT [n -S]\n",
  "SUPPLIANTLY": "SUPPLIANT, (Shakespeare) supplicating, asking [adv]\n",
  "SUPPLIANTS": "SUPPLIANT, one who supplicates, also SUPPLICANT [n]\n",
  "SUPPLICANT": "one who supplicates, also SUPPLIANT [n -S]\n",
  "SUPPLICANTS": "SUPPLICANT, one who supplicates, also SUPPLIANT [n]\n",
  "SUPPLICAT": "in English universities, a petition [n -S]\n",
  "SUPPLICATE": "to entreat for [v SUPPLICATED, SUPPLICATING, SUPPLICATES]\n",
  "SUPPLICATED": "SUPPLICATE, to entreat for [v]\n",
  "SUPPLICATES": "SUPPLICATE, to entreat for [v]\n",
  "SUPPLICATING": "SUPPLICATE, to entreat for [v]\n",
  "SUPPLICATINGLY": "SUPPLICATING, SUPPLICATE, to entreat for [adv]\n",
  "SUPPLICATION": "an act of supplicating; an earnest or humble petition [n -S]\n",
  "SUPPLICATIONS": "SUPPLICATION, an act of supplicating; an earnest or humble petition [n]\n",
  "SUPPLICATORY": "humbly pleading [adj]\n",
  "SUPPLICATS": "SUPPLICAT, in English universities, a petition [n]\n",
  "SUPPLICAVIT": "formerly, a writ issued by the King's Bench or Chancery for taking the surety of the peace against a person [n -S]\n",
  "SUPPLICAVITS": "SUPPLICAVIT, formerly, a writ issued by the King's Bench or Chancery for taking the surety of the peace against a person [n]\n",
  "SUPPLIED": "SUPPLY, to provide with service or goods [v]\n",
  "SUPPLIER": "one that supplies [n -S]\n",
  "SUPPLIERS": "SUPPLIER, one that supplies [n]\n",
  "SUPPLIES": "SUPPLY, to provide with service or goods [v]\n",
  "SUPPLING": "SUPPLE, to make supple [v]\n",
  "SUPPLY": "to provide with service or goods [v SUPPLIED, SUPPLYING, SUPPLIES]\n",
  "SUPPLYING": "SUPPLY, to provide with service or goods [v]\n",
  "SUPPLYMENT": "(Shakespeare) a supplying or furnishing [n -S]\n",
  "SUPPLYMENTS": "SUPPLYMENT, (Shakespeare) a supplying or furnishing [n]\n",
  "SUPPORT": "to hold up [v -ED, -ING, -S]\n",
  "SUPPORTABILITY": "the state of being supportable [n]\n",
  "SUPPORTABLE": "that can be supported [adj SUPPORTABLY]\n",
  "SUPPORTABLENESS": "the state of being supportable [n]\n",
  "SUPPORTABLY": "SUPPORTABLE, that can be supported [adv]\n",
  "SUPPORTANCE": "(Shakespeare) support [n -S]\n",
  "SUPPORTANCES": "SUPPORTANCE, (Shakespeare) support [n]\n",
  "SUPPORTED": "SUPPORT, to hold up [v]\n",
  "SUPPORTER": "a figure in heraldry depicted as holding up a shield [n -S]\n",
  "SUPPORTERS": "SUPPORTER, a figure in heraldry depicted as holding up a shield [n]\n",
  "SUPPORTING": "the act of supporting [n -S]\n",
  "SUPPORTINGS": "SUPPORTING, the act of supporting [n]\n",
  "SUPPORTIVE": "tending to support [adj SUPPORTIVELY]\n",
  "SUPPORTIVELY": "SUPPORTIVE, tending to support [adv]\n",
  "SUPPORTIVENESS": "the state of being supportive [n]\n",
  "SUPPORTLESS": "without support [adj]\n",
  "SUPPORTMENT": "support [n -S]\n",
  "SUPPORTMENTS": "SUPPORTMENT, support [n]\n",
  "SUPPORTRESS": "a female supporter [n -ES]\n",
  "SUPPORTRESSES": "SUPPORTRESS, a female supporter [n]\n",
  "SUPPORTS": "SUPPORT, to hold up [v]\n",
  "SUPPORTURE": "support [n -S]\n",
  "SUPPORTURES": "SUPPORTURE, support [n]\n",
  "SUPPOSABLE": "capable of being supposed [adj SUPPOSABLY]\n",
  "SUPPOSABLY": "SUPPOSABLE, capable of being supposed [adv]\n",
  "SUPPOSAL": "something supposed [n -S]\n",
  "SUPPOSALS": "SUPPOSAL, something supposed [n]\n",
  "SUPPOSE": "to assume to be true [v SUPPOSED, SUPPOSING, SUPPOSES]\n",
  "SUPPOSED": "SUPPOSE, to assume to be true [v]\n",
  "SUPPOSEDLY": "SUPPOSED, SUPPOSE, to assume to be true [adv]\n",
  "SUPPOSER": "one who supposes [n -S]\n",
  "SUPPOSERS": "SUPPOSER, one who supposes [n]\n",
  "SUPPOSES": "SUPPOSE, to assume to be true [v]\n",
  "SUPPOSING": "the act of supposing [n -S]\n",
  "SUPPOSINGS": "SUPPOSING, the act of supposing [n]\n",
  "SUPPOSITION": "something that is supposed [n -S]\n",
  "SUPPOSITIONAL": "having the nature of a supposition [adj SUPPOSITIONALLY]\n",
  "SUPPOSITIONALLY": "SUPPOSITIONAL, having the nature of a supposition [adv]\n",
  "SUPPOSITIONARY": "suppositional [adj]\n",
  "SUPPOSITIONLESS": "without supposition [adj]\n",
  "SUPPOSITIONS": "SUPPOSITION, something that is supposed [n]\n",
  "SUPPOSITIOUS": "fraudulently substituted, also SUPPOSITITIOUS [adj SUPPOSITIOUSLY]\n",
  "SUPPOSITIOUSLY": "SUPPOSITIOUS, fraudulently substituted, also SUPPOSITITIOUS [adv]\n",
  "SUPPOSITITIOUS": "fraudulently substituted, also SUPPOSITIOUS [adj]\n",
  "SUPPOSITIVE": "suppositional [adj SUPPOSITIVELY] / a suppositive conjunction [n -S]\n",
  "SUPPOSITIVELY": "SUPPOSITIVE, suppositional [adv]\n",
  "SUPPOSITIVES": "SUPPOSITIVE, a suppositive conjunction [n]\n",
  "SUPPOSITORIES": "SUPPOSITORY, a solid but readily meltable cone or cylinder of usually medicated material for insertion into a bodily passage or cavity, as the rectum [n]\n",
  "SUPPOSITORY": "a solid but readily meltable cone or cylinder of usually medicated material for insertion into a bodily passage or cavity, as the rectum [n SUPPOSITORIES]\n",
  "SUPPRESS": "to subdue or hold back [v -ED, -ING, -ES]\n",
  "SUPPRESSANT": "a drug that tends to suppress or reduce in intensity rather than eliminate something [n -S]\n",
  "SUPPRESSANTS": "SUPPRESSANT, a drug that tends to suppress or reduce in intensity rather than eliminate something [n]\n",
  "SUPPRESSED": "SUPPRESS, to subdue or hold back [v]\n",
  "SUPPRESSEDLY": "SUPPRESSED, SUPPRESS, to subdue or hold back [adv]\n",
  "SUPPRESSER": "something that suppresses, also SUPPRESSOR [n -S]\n",
  "SUPPRESSERS": "SUPPRESSER, something that suppresses, also SUPPRESSOR [n]\n",
  "SUPPRESSES": "SUPPRESS, to subdue or hold back [v]\n",
  "SUPPRESSIBILITY": "the state of being suppressible [n]\n",
  "SUPPRESSIBLE": "capable of being suppressed [adj]\n",
  "SUPPRESSING": "SUPPRESS, to subdue or hold back [v]\n",
  "SUPPRESSION": "an act or instance of suppressing [n -S]\n",
  "SUPPRESSIONS": "SUPPRESSION, an act or instance of suppressing [n]\n",
  "SUPPRESSIVE": "serving to suppress [adj]\n",
  "SUPPRESSIVENESS": "the state of being suppressive [n]\n",
  "SUPPRESSOR": "something that suppresses, also SUPPRESSER [n -S]\n",
  "SUPPRESSORS": "SUPPRESSOR, something that suppresses, also SUPPRESSER [n]\n",
  "SUPPURATE": "to discharge pus [v SUPPURATED, SUPPURATING, SUPPURATES]\n",
  "SUPPURATED": "SUPPURATE, to discharge pus [v]\n",
  "SUPPURATES": "SUPPURATE, to discharge pus [v]\n",
  "SUPPURATING": "SUPPURATE, to discharge pus [v]\n",
  "SUPPURATION": "the discharge of pus [n -S]\n",
  "SUPPURATIONS": "SUPPURATION, the discharge of pus [n]\n",
  "SUPPURATIVE": "causing suppuration [adj] / a suppurative agent [n -S]\n",
  "SUPPURATIVES": "SUPPURATIVE, a suppurative agent [n]\n",
  "SUPRA": "(Latin) above; earlier in a text [adj]\n",
  "SUPRACHIASMIC": "above the chiasm (esp. in suprachiasmic nucleus, a small area in the hypothalamus thought to regulate the biological clock) [adj]\n",
  "SUPRACHOROIDAL": "relating to, or being the layer of loose connective tissue situated between the choroid and sclerotic coats of the eyeball [adj]\n",
  "SUPRACILIARY": "above the eyebrow [adj]\n",
  "SUPRACOSTAL": "situated above the ribs [adj]\n",
  "SUPRACRUSTAL": "of rocks, on or near the surface, above the earth's crust [adj]\n",
  "SUPRAGLOTTAL": "above the glottis [adj]\n",
  "SUPRALAPSARIAN": "one of a class of Calvinists who make the decree of election and predestination to precede the Creation and the Fall [n -S]\n",
  "SUPRALAPSARIANS": "SUPRALAPSARIAN, one of a class of Calvinists who make the decree of election and predestination to precede the Creation and the Fall [n]\n",
  "SUPRALIMINAL": "conscious [adj SUPRALIMINALLY]\n",
  "SUPRALIMINALLY": "SUPRALIMINAL, conscious [adv]\n",
  "SUPRALUNAR": "beyond the moon; very lofty [adj]\n",
  "SUPRAMAXILLARY": "above the maxilla [adj]\n",
  "SUPRAMOLECULAR": "more complex than a molecule [adj]\n",
  "SUPRAMOLECULE": "a cluster of molecules, usually created artificially [n -S]\n",
  "SUPRAMOLECULES": "SUPRAMOLECULE, a cluster of molecules, usually created artificially [n]\n",
  "SUPRAMUNDANE": "above or beyond this world [adj]\n",
  "SUPRANATIONAL": "transcending national boundaries, authority, or interests [adj SUPRANATIONALLY]\n",
  "SUPRANATIONALLY": "SUPRANATIONAL, transcending national boundaries, authority, or interests [adv]\n",
  "SUPRAOPTIC": "situated above the optic chiasma [adj]\n",
  "SUPRAORBITAL": "situated above the eye socket [adj]\n",
  "SUPRAPUBIC": "situated above, or anterior to, the pubic bone [adj]\n",
  "SUPRARATIONAL": "transcending the rational [adj]\n",
  "SUPRARENAL": "situated above, or anterior to, the kidneys [adj] / a suprarenal gland [n -S]\n",
  "SUPRARENALS": "SUPRARENAL, a suprarenal gland [n]\n",
  "SUPRASEGMENTAL": "representing or continuing through two or more speech sounds [adj]\n",
  "SUPRASENSIBLE": "above the reach of the senses [adj]\n",
  "SUPRATEMPORAL": "transcending time; of the upper part of the temples or temporal region [adj]\n",
  "SUPRAVITAL": "relating to the staining of living tissues [adj SUPRAVITALLY]\n",
  "SUPRAVITALLY": "SUPRAVITAL, relating to the staining of living tissues [adv]\n",
  "SUPREMA": "SUPREMUM, in maths, a maximum bound [n]\n",
  "SUPREMACIES": "SUPREMACY, the state of being supreme [n]\n",
  "SUPREMACISM": "belief in the supremacy of one particular group of people [n -S]\n",
  "SUPREMACISMS": "SUPREMACISM, belief in the supremacy of one particular group of people [n]\n",
  "SUPREMACIST": "an advocate or adherent of group supremacy [n -S]\n",
  "SUPREMACISTS": "SUPREMACIST, an advocate or adherent of group supremacy [n]\n",
  "SUPREMACY": "the state of being supreme [n SUPREMACIES]\n",
  "SUPREMATISM": "an early 20th century art movement in Russia producing abstract works featuring flat geometric forms [n -S]\n",
  "SUPREMATISMS": "SUPREMATISM, an early 20th century art movement in Russia producing abstract works featuring flat geometric forms [n]\n",
  "SUPREMATIST": "a practitioner in suprematism [n -S]\n",
  "SUPREMATISTS": "SUPREMATIST, a practitioner in suprematism [n]\n",
  "SUPREME": "highest, greatest [adj SUPREMER, SUPREMEST, SUPREMELY] / the highest point or authority [n -S]\n",
  "SUPREMELY": "SUPREME, highest, greatest [adv]\n",
  "SUPREMENESS": "the state of being supreme [n -ES]\n",
  "SUPREMENESSES": "SUPREMENESS, the state of being supreme [n]\n",
  "SUPREMER": "SUPREME, highest, greatest [adj]\n",
  "SUPREMES": "SUPREME, the highest point or authority [n]\n",
  "SUPREMEST": "SUPREME, highest, greatest [adj]\n",
  "SUPREMITIES": "SUPREMITY, supremacy [n]\n",
  "SUPREMITY": "supremacy [n SUPREMITIES]\n",
  "SUPREMO": "(Spanish) a supreme head, a leader with unlimited powers [n -S]\n",
  "SUPREMOS": "SUPREMO, (Spanish) a supreme head, a leader with unlimited powers [n]\n",
  "SUPREMUM": "in maths, a maximum bound [n SUPREMA or SUPREMUMS]\n",
  "SUPREMUMS": "SUPREMUM, in maths, a maximum bound [n]\n",
  "SUPS": "SUP, to eat supper [v]\n",
  "SUQ": "(Arabic) an Arab marketplace, also SUK, SUKH [n -S]\n",
  "SUQS": "SUQ, (Arabic) an Arab marketplace, also SUK, SUKH [n]\n",
  "SUR": "(French) on, above [prep]\n",
  "SURA": "(Arabic) a chapter of the Koran, also SURAH [n -S]\n",
  "SURADDITION": "(Shakespeare) an additional title or designation [n -S]\n",
  "SURADDITIONS": "SURADDITION, (Shakespeare) an additional title or designation [n]\n",
  "SURAH": "(Arabic) a chapter of the Koran, also SURA [n -S]\n",
  "SURAHS": "SURAH, (Arabic) a chapter of the Koran, also SURA [n]\n",
  "SURAL": "pertaining to the calf of the leg [adj]\n",
  "SURAMIN": "a drug used in the treatment of trypanosomiasis [n -S]\n",
  "SURAMINS": "SURAMIN, a drug used in the treatment of trypanosomiasis [n]\n",
  "SURANCE": "(Shakespeare) assurance [n -S]\n",
  "SURANCES": "SURANCE, (Shakespeare) assurance [n]\n",
  "SURAS": "SURA, (Arabic) a chapter of the Koran, also SURAH [n]\n",
  "SURAT": "(Hindi) a coarse uncoloured cotton [n -S]\n",
  "SURATS": "SURAT, (Hindi) a coarse uncoloured cotton [n]\n",
  "SURBAHAR": "(Bengali) an Indian stringed instrument, larger than a sitar [n -S]\n",
  "SURBAHARS": "SURBAHAR, (Bengali) an Indian stringed instrument, larger than a sitar [n]\n",
  "SURBASE": "a border above the base of a structure [n -S]\n",
  "SURBASED": "having a surbase [adj]\n",
  "SURBASEMENT": "a surbase [n -S]\n",
  "SURBASEMENTS": "SURBASEMENT, a surbase [n]\n",
  "SURBASES": "SURBASE, a border above the base of a structure [n]\n",
  "SURBATE": "to make footsore; to harass or fatigue [v SURBATED or (Spenser) SURBET, SURBATING, SURBATES]\n",
  "SURBATED": "SURBATE, to make footsore; to harass or fatigue [v]\n",
  "SURBATES": "SURBATE, to make footsore; to harass or fatigue [v]\n",
  "SURBATING": "SURBATE, to make footsore; to harass or fatigue [v]\n",
  "SURBED": "(obsolete) to set on edge (applied to a stone with reference to the grain) [v SURBEDDED, SURBEDDING, SURBEDS]\n",
  "SURBEDDED": "SURBED, (obsolete) to set on edge (applied to a stone with reference to the grain) [v]\n",
  "SURBEDDING": "SURBED, (obsolete) to set on edge (applied to a stone with reference to the grain) [v]\n",
  "SURBEDS": "SURBED, (obsolete) to set on edge (applied to a stone with reference to the grain) [v]\n",
  "SURBET": "SURBATE, to make footsore; to harass or fatigue [v]\n",
  "SURCEASE": "to stop or cease [v SURCEASED, SURCEASING, SURCEASES]\n",
  "SURCEASED": "SURCEASE, to stop or cease [v]\n",
  "SURCEASES": "SURCEASE, to stop or cease [v]\n",
  "SURCEASING": "SURCEASE, to stop or cease [v]\n",
  "SURCHARGE": "an additional charge [n -S] / to exact a surcharge from; to overload [v SURCHARGED, SURCHARGING, SURCHARGES]\n",
  "SURCHARGED": "SURCHARGE, to exact a surcharge from; to overload [v]\n",
  "SURCHARGEMENT": "the act of surcharging [n -S]\n",
  "SURCHARGEMENTS": "SURCHARGEMENT, the act of surcharging [n]\n",
  "SURCHARGER": "one who surcharges [n -S]\n",
  "SURCHARGERS": "SURCHARGER, one who surcharges [n]\n",
  "SURCHARGES": "SURCHARGE, to exact a surcharge from; to overload [v]\n",
  "SURCHARGING": "SURCHARGE, to exact a surcharge from; to overload [v]\n",
  "SURCINGLE": "a girth or strap for holding saddle to animal's back [n -S] / to fasten with a surcingle [v SURCINGLED, SURCINGLING, SURCINGLES]\n",
  "SURCINGLED": "SURCINGLE, to fasten with a surcingle [v]\n",
  "SURCINGLES": "SURCINGLE, a girth or strap for holding saddle to animal's back [n]\n",
  "SURCINGLING": "SURCINGLE, to fasten with a surcingle [v]\n",
  "SURCOAT": "a tunic worn over armour [n -S]\n",
  "SURCOATS": "SURCOAT, a tunic worn over armour [n]\n",
  "SURCULI": "SURCULUS, (Latin) a sucker [n]\n",
  "SURCULOSE": "having or producing suckers [adj]\n",
  "SURCULUS": "(Latin) a sucker [n SURCULUSES or SURCULI]\n",
  "SURCULUSES": "SURCULUS, (Latin) a sucker [n]\n",
  "SURD": "a voiceless speech sound [n -S]\n",
  "SURDITIES": "SURDITY, deafness [n]\n",
  "SURDITY": "deafness [n SURDITIES]\n",
  "SURDS": "SURD, a voiceless speech sound [n]\n",
  "SURE": "certain [adj SURER, SUREST, SURELY] / to provide with sewers [v SURED, SURING, SURES]\n",
  "SURED": "SURE, to provide with sewers [v]\n",
  "SUREFIRE": "sure to meet expectations [adj]\n",
  "SUREFOOTED": "not given to stumbling [adj SUREFOOTEDLY]\n",
  "SUREFOOTEDLY": "SUREFOOTED, not given to stumbling [adv]\n",
  "SUREFOOTEDNESS": "the state of being surefooted [n]\n",
  "SURELY": "SURE, certain [adv]\n",
  "SURENESS": "the state of being sure [n -ES]\n",
  "SURENESSES": "SURENESS, the state of being sure [n]\n",
  "SURER": "SURE, certain [adj]\n",
  "SURES": "SURE, to provide with sewers [v]\n",
  "SUREST": "SURE, certain [adj]\n",
  "SURETIED": "SURETY, (Shakespeare) to be security for [v]\n",
  "SURETIES": "SURETY, (Shakespeare) to be security for [v]\n",
  "SURETY": "a guarantee [n SURETIES] / (Shakespeare) to be security for [v SURETIED, SURETYING, SURETIES]\n",
  "SURETYING": "SURETY, (Shakespeare) to be security for [v]\n",
  "SURETYSHIP": "the state of being surety [n -S]\n",
  "SURETYSHIPS": "SURETYSHIP, the state of being surety [n]\n",
  "SURF": "to ride breaking waves on a narrow board [v -ED, -ING, -S]\n",
  "SURFABLE": "able to be surfed [adj]\n",
  "SURFACE": "to apply an outer layer to [v SURFACED, SURFACING, SURFACES]\n",
  "SURFACED": "SURFACE, to apply an outer layer to [v]\n",
  "SURFACELESS": "without a surface [adj]\n",
  "SURFACEMAN": "a workman who keeps a railway bed in repair [n SURFACEMEN]\n",
  "SURFACEMEN": "SURFACEMAN, a workman who keeps a railway bed in repair [n]\n",
  "SURFACER": "a form of machine for dressing the surface of wood, metal, stone, etc. [n -S]\n",
  "SURFACERS": "SURFACER, a form of machine for dressing the surface of wood, metal, stone, etc. [n]\n",
  "SURFACES": "SURFACE, to apply an outer layer to [v]\n",
  "SURFACING": "the act of surfacing [n -S]\n",
  "SURFACINGS": "SURFACING, the act of surfacing [n]\n",
  "SURFACTANT": "a substance which reduces surface tension [n -S]\n",
  "SURFACTANTS": "SURFACTANT, a substance which reduces surface tension [n]\n",
  "SURFBIRD": "an American Pacific shorebird [n -S]\n",
  "SURFBIRDS": "SURFBIRD, an American Pacific shorebird [n]\n",
  "SURFBOARD": "a long narrow board used in surfing [n -S] / to surf on a surfboard [v -ED, -ING, -S]\n",
  "SURFBOARDED": "SURFBOARD, to surf on a surfboard [v]\n",
  "SURFBOARDER": "one who uses a surfboard [n -S]\n",
  "SURFBOARDERS": "SURFBOARDER, one who uses a surfboard [n]\n",
  "SURFBOARDING": "the sport of surfing on a surfboard [n -S]\n",
  "SURFBOARDINGS": "SURFBOARDING, the sport of surfing on a surfboard [n]\n",
  "SURFBOARDS": "SURFBOARD, to surf on a surfboard [v]\n",
  "SURFBOAT": "a strong rowboat [n -S]\n",
  "SURFBOATS": "SURFBOAT, a strong rowboat [n]\n",
  "SURFCASTER": "one who fishes from the shore by casting into the surf [n -S]\n",
  "SURFCASTERS": "SURFCASTER, one who fishes from the shore by casting into the surf [n]\n",
  "SURFCASTING": "fishing from the shore by casting into surf [n -S]\n",
  "SURFCASTINGS": "SURFCASTING, fishing from the shore by casting into surf [n]\n",
  "SURFED": "SURF, to ride breaking waves on a narrow board [v]\n",
  "SURFEIT": "to indulge in excess [v -ED, -ING, -S]\n",
  "SURFEITED": "SURFEIT, to indulge in excess [v]\n",
  "SURFEITER": "one who surfeits [n -S]\n",
  "SURFEITERS": "SURFEITER, one who surfeits [n]\n",
  "SURFEITING": "feeding or filling to satiety or disgust [n -S]\n",
  "SURFEITINGS": "SURFEITING, feeding or filling to satiety or disgust [n]\n",
  "SURFEITS": "SURFEIT, to indulge in excess [v]\n",
  "SURFER": "one who surfs, also SURFIE [n -S]\n",
  "SURFERS": "SURFER, one who surfs, also SURFIE [n]\n",
  "SURFFISH": "a Western American fish, aka surfperch [n -ES]\n",
  "SURFFISHES": "SURFFISH, a Western American fish, aka surfperch [n]\n",
  "SURFICIAL": "superficial, found on the surface [adj]\n",
  "SURFIE": "(Australian slang) a young usually unemployed person who spends much time surfing [n -S]\n",
  "SURFIER": "SURFY, abounding in breaking waves [adj]\n",
  "SURFIES": "SURFIE, (Australian slang) a young usually unemployed person who spends much time surfing [n]\n",
  "SURFIEST": "SURFY, abounding in breaking waves [adj]\n",
  "SURFING": "the sport of riding waves [n -S]\n",
  "SURFINGS": "SURFING, the sport of riding waves [n]\n",
  "SURFLIKE": "resembling breaking waves [adj]\n",
  "SURFMAN": "skilful boat handlers in surf [n SURFMEN]\n",
  "SURFMEN": "SURFMAN, skilful boat handlers in surf [n]\n",
  "SURFPERCH": "a Western American fish, aka surffish [n -ES]\n",
  "SURFPERCHES": "SURFPERCH, a Western American fish, aka surffish [n]\n",
  "SURFRIDDEN": "SURFRIDE, to ride on surf [v]\n",
  "SURFRIDE": "to ride on surf [v SURFRODE, SURFRIDDEN, SURFRIDING, SURFRIDES]\n",
  "SURFRIDER": "one who engages in surfing [n -S]\n",
  "SURFRIDERS": "SURFRIDER, one who engages in surfing [n]\n",
  "SURFRIDES": "SURFRIDE, to ride on surf [v]\n",
  "SURFRIDING": "the sport of riding on surf [n -S]\n",
  "SURFRIDINGS": "SURFRIDING, the sport of riding on surf [n]\n",
  "SURFRODE": "SURFRIDE, to ride on surf [v]\n",
  "SURFS": "SURF, to ride breaking waves on a narrow board [v]\n",
  "SURFSIDE": "beside the sea [adj]\n",
  "SURFY": "abounding in breaking waves [adj SURFIER, SURFIEST]\n",
  "SURGE": "to move in a swelling manner [v SURGED, SURGING, SURGES]\n",
  "SURGED": "SURGE, to move in a swelling manner [v]\n",
  "SURGEFUL": "full of surges [adj]\n",
  "SURGELESS": "free from surges; smooth [adj]\n",
  "SURGENT": "rising; swelling, as a flood [adj]\n",
  "SURGEON": "one who practices surgery [n -S]\n",
  "SURGEONCIES": "SURGEONCY, the office or employment of a surgeon, as in the naval or military service [n]\n",
  "SURGEONCY": "the office or employment of a surgeon, as in the naval or military service [n SURGEONCIES]\n",
  "SURGEONFISH": "a kind of tropical fish with razor-sharp spines on the tail [n -ES]\n",
  "SURGEONFISHES": "SURGEONFISH, a kind of tropical fish with razor-sharp spines on the tail [n]\n",
  "SURGEONS": "SURGEON, one who practices surgery [n]\n",
  "SURGEONSHIP": "the office of surgeon [n -S]\n",
  "SURGEONSHIPS": "SURGEONSHIP, the office of surgeon [n]\n",
  "SURGER": "one who surges [n -S]\n",
  "SURGERIES": "SURGERY, the treatment of medical problems by operation [n]\n",
  "SURGERS": "SURGER, one who surges [n]\n",
  "SURGERY": "the treatment of medical problems by operation [n SURGERIES]\n",
  "SURGES": "SURGE, to move in a swelling manner [v]\n",
  "SURGICAL": "pertaining to surgery [adj SURGICALLY]\n",
  "SURGICALLY": "SURGICAL, pertaining to surgery [adv]\n",
  "SURGIER": "SURGY, surging [adj]\n",
  "SURGIEST": "SURGY, surging [adj]\n",
  "SURGING": "the act of surging [n -S]\n",
  "SURGINGS": "SURGING, the act of surging [n]\n",
  "SURGY": "surging [adj SURGIER, SURGIEST]\n",
  "SURICATE": "(Dutch) a South African carnivore, aka meerkat, related to the ichneumon [n -S]\n",
  "SURICATES": "SURICATE, (Dutch) a South African carnivore, aka meerkat, related to the ichneumon [n]\n",
  "SURIMI": "(Japanese) synthetic Japanese crabmeat [n -S]\n",
  "SURIMIS": "SURIMI, (Japanese) synthetic Japanese crabmeat [n]\n",
  "SURING": "SURE, to provide with sewers [v]\n",
  "SURJECTION": "a mapping function in which all elements in one set correspond to all elements in another set [n -S]\n",
  "SURJECTIONS": "SURJECTION, a mapping function in which all elements in one set correspond to all elements in another set [n]\n",
  "SURJECTIVE": "relating to surjection, a mapping function in which all elements in one set correspond to all elements in another set [adj]\n",
  "SURLIER": "SURLY, sullenly rude [adj]\n",
  "SURLIEST": "SURLY, sullenly rude [adj]\n",
  "SURLILY": "SURLY, sullenly rude [adv]\n",
  "SURLINESS": "the state of being surly [n -ES]\n",
  "SURLINESSES": "SURLINESS, the state of being surly [n]\n",
  "SURLOIN": "a loin of beef, or the upper part of the loin, also SIRLOIN [n -S]\n",
  "SURLOINS": "SURLOIN, a loin of beef, or the upper part of the loin, also SIRLOIN [n]\n",
  "SURLY": "sullenly rude [adj SURLIER, SURLIEST, SURLILY]\n",
  "SURMASTER": "(archaic) the second master or deputy head in a school [n -S]\n",
  "SURMASTERS": "SURMASTER, (archaic) the second master or deputy head in a school [n]\n",
  "SURMISABLE": "capable of being surmised [adj]\n",
  "SURMISAL": "a guess [n -S]\n",
  "SURMISALS": "SURMISAL, a guess [n]\n",
  "SURMISE": "to infer with little evidence [v SURMISED, SURMISING, SURMISES]\n",
  "SURMISED": "SURMISE, to infer with little evidence [v]\n",
  "SURMISER": "one who surmises [n -S]\n",
  "SURMISERS": "SURMISER, one who surmises [n]\n",
  "SURMISES": "SURMISE, to infer with little evidence [v]\n",
  "SURMISING": "the act of surmising [n -S]\n",
  "SURMISINGS": "SURMISING, the act of surmising [n]\n",
  "SURMISTRESS": "a female surmaster, the second master or deputy head in a school [n -ES]\n",
  "SURMISTRESSES": "SURMISTRESS, a female surmaster, the second master or deputy head in a school [n]\n",
  "SURMOUNT": "to get over or across [v -ED, -ING, -S]\n",
  "SURMOUNTABLE": "capable of being surmounted [adj]\n",
  "SURMOUNTED": "SURMOUNT, to get over or across [v]\n",
  "SURMOUNTER": "one who, or that which, surmounts [n -S]\n",
  "SURMOUNTERS": "SURMOUNTER, one who, or that which, surmounts [n]\n",
  "SURMOUNTING": "the act of surmounting [n -S]\n",
  "SURMOUNTINGS": "SURMOUNTING, the act of surmounting [n]\n",
  "SURMOUNTS": "SURMOUNT, to get over or across [v]\n",
  "SURMULLET": "a fish much esteemed by the Romans for its dramatic color changes as it died [n -S]\n",
  "SURMULLETS": "SURMULLET, a fish much esteemed by the Romans for its dramatic color changes as it died [n]\n",
  "SURNAME": "to give the family name to, also SIRNAME [v SURNAMED, SURNAMING, SURNAMES]\n",
  "SURNAMED": "SURNAME, to give the family name to, also SIRNAME [v]\n",
  "SURNAMER": "one who allots a surname [n -S]\n",
  "SURNAMERS": "SURNAMER, one who allots a surname [n]\n",
  "SURNAMES": "SURNAME, to give the family name to, also SIRNAME [v]\n",
  "SURNAMING": "SURNAME, to give the family name to, also SIRNAME [v]\n",
  "SURNOMINAL": "pertaining to surnames [adj]\n",
  "SURPASS": "to go beyond [v -ED, -ING, -ES]\n",
  "SURPASSABLE": "capable of being surpassed [adj]\n",
  "SURPASSED": "SURPASS, to go beyond [v]\n",
  "SURPASSER": "one who surpasses [n -S]\n",
  "SURPASSERS": "SURPASSER, one who surpasses [n]\n",
  "SURPASSES": "SURPASS, to go beyond [v]\n",
  "SURPASSING": "SURPASS, to go beyond [v]\n",
  "SURPASSINGLY": "SURPASSING, SURPASS, to go beyond [adv]\n",
  "SURPASSINGNESS": "the state of being surpassing [n]\n",
  "SURPLICE": "a loose-fitting ankle length overgarment worn by clerics [n -S]\n",
  "SURPLICED": "wearing a surplice [adj]\n",
  "SURPLICES": "SURPLICE, a loose-fitting ankle length overgarment worn by clerics [n]\n",
  "SURPLUS": "an excess [n SURPLUSES or SURPLUSSES] / to be in excess [v SURPLUSED or SURPLUSSED, SURPLUSING or SURPLUSSING, SURPLUSES or SURPLUSSES]\n",
  "SURPLUSAGE": "surplus [n -S]\n",
  "SURPLUSAGES": "SURPLUSAGE, surplus [n]\n",
  "SURPLUSED": "SURPLUS, to be in excess [v]\n",
  "SURPLUSES": "SURPLUS, an excess [n]\n",
  "SURPLUSING": "SURPLUS, to be in excess [v]\n",
  "SURPLUSSED": "SURPLUS, to be in excess [v]\n",
  "SURPLUSSES": "SURPLUS, an excess [n]\n",
  "SURPLUSSING": "SURPLUS, to be in excess [v]\n",
  "SURPRINT": "to print over printing [v -ED, -ING, -S]\n",
  "SURPRINTED": "SURPRINT, to print over printing [v]\n",
  "SURPRINTING": "SURPRINT, to print over printing [v]\n",
  "SURPRINTS": "SURPRINT, to print over printing [v]\n",
  "SURPRISAL": "an act of surprising [n -S]\n",
  "SURPRISALS": "SURPRISAL, an act of surprising [n]\n",
  "SURPRISE": "to come upon unexpectedly, also SURPRIZE [v SURPRISED, SURPRISING, SURPRISES]\n",
  "SURPRISED": "SURPRISE, to come upon unexpectedly, also SURPRIZE [v]\n",
  "SURPRISEDLY": "SURPRISED, SURPRISE, to come upon unexpectedly, also SURPRIZE [adv]\n",
  "SURPRISER": "one who surprises [n -S]\n",
  "SURPRISERS": "SURPRISER, one who surprises [n]\n",
  "SURPRISES": "SURPRISE, to come upon unexpectedly, also SURPRIZE [v]\n",
  "SURPRISING": "causing surprise [adj SURPRISINGLY] / the act of causing surprise [n -S]\n",
  "SURPRISINGLY": "SURPRISING, causing surprise [adv]\n",
  "SURPRISINGNESS": "the state of being surprising [n]\n",
  "SURPRISINGS": "SURPRISING, the act of causing surprise [n]\n",
  "SURPRIZE": "to come upon unexpectedly, also SURPRISE [v SURPRIZED, SURPRIZING, SURPRIZES]\n",
  "SURPRIZED": "SURPRIZE, to come upon unexpectedly, also SURPRISE [v]\n",
  "SURPRIZES": "SURPRIZE, to come upon unexpectedly, also SURPRISE [v]\n",
  "SURPRIZING": "SURPRIZE, to come upon unexpectedly, also SURPRISE [v]\n",
  "SURQUEDIES": "SURQUEDY, (obsolete) arrogance; haughty pride, also SURQUEDRY [n]\n",
  "SURQUEDRIES": "SURQUEDRY, (obsolete) arrogance; haughty pride, also SURQUEDY [n]\n",
  "SURQUEDRY": "(obsolete) arrogance; haughty pride, also SURQUEDY [n SURQUEDRIES]\n",
  "SURQUEDY": "(obsolete) arrogance; haughty pride, also SURQUEDRY [n SURQUEDIES]\n",
  "SURRA": "(Marathi) a trypanosome disease of the blood in horses [n -S]\n",
  "SURRAS": "SURRA, (Marathi) a trypanosome disease of the blood in horses [n]\n",
  "SURREAL": "of or relating to surrealism; dreamlike, bizarre [adj SURREALLY] / the atmosphere or qualities associated with surrealism [n -S]\n",
  "SURREALISM": "a movement in art and literature, begun in France around 1919 [n -S]\n",
  "SURREALISMS": "SURREALISM, a movement in art and literature, begun in France around 1919 [n]\n",
  "SURREALIST": "an exponent of surrealism [n -S]\n",
  "SURREALISTIC": "of or relating to surrealism [adj]\n",
  "SURREALISTS": "SURREALIST, an exponent of surrealism [n]\n",
  "SURREALLY": "SURREAL, of or relating to surrealism; dreamlike, bizarre [adv]\n",
  "SURREALS": "SURREAL, the atmosphere or qualities associated with surrealism [n]\n",
  "SURREBUT": "to reply to a rebutter [v SURREBUTTED, SURREBUTTING, SURREBUTS]\n",
  "SURREBUTS": "SURREBUT, to reply to a rebutter [v]\n",
  "SURREBUTTAL": "a plaintiff's evidence or presentation of evidence, in response to a defendant's rebuttal [n -S]\n",
  "SURREBUTTALS": "SURREBUTTAL, a plaintiff's evidence or presentation of evidence, in response to a defendant's rebuttal [n]\n",
  "SURREBUTTED": "SURREBUT, to reply to a rebutter [v]\n",
  "SURREBUTTER": "in law, a plaintiff's reply to defendant's rebutter [n -S]\n",
  "SURREBUTTERS": "SURREBUTTER, in law, a plaintiff's reply to defendant's rebutter [n]\n",
  "SURREBUTTING": "SURREBUT, to reply to a rebutter [v]\n",
  "SURREINED": "of a horse, overridden, overworked [adj]\n",
  "SURREJOIN": "to reply, as a plaintiff to a defendant's rejoinder [v -ED, -ING, -S]\n",
  "SURREJOINDER": "in law, a plaintiff's reply to defendant's rejoinder [n -S]\n",
  "SURREJOINDERS": "SURREJOINDER, in law, a plaintiff's reply to defendant's rejoinder [n]\n",
  "SURREJOINED": "SURREJOIN, to reply, as a plaintiff to a defendant's rejoinder [v]\n",
  "SURREJOINING": "SURREJOIN, to reply, as a plaintiff to a defendant's rejoinder [v]\n",
  "SURREJOINS": "SURREJOIN, to reply, as a plaintiff to a defendant's rejoinder [v]\n",
  "SURRENDER": "to yield, give up [v -ED, -ING, -S]\n",
  "SURRENDERED": "SURRENDER, to yield, give up [v]\n",
  "SURRENDEREE": "one who is surrendered [n -S]\n",
  "SURRENDEREES": "SURRENDEREE, one who is surrendered [n]\n",
  "SURRENDERER": "one who surrenders, also SURRENDEROR [n -S]\n",
  "SURRENDERERS": "SURRENDERER, one who surrenders, also SURRENDEROR [n]\n",
  "SURRENDERING": "SURRENDER, to yield, give up [v]\n",
  "SURRENDEROR": "one who surrenders, also SURRENDERER [n -S]\n",
  "SURRENDERORS": "SURRENDEROR, one who surrenders, also SURRENDERER [n]\n",
  "SURRENDERS": "SURRENDER, to yield, give up [v]\n",
  "SURRENDRIES": "SURRENDRY, (obsolete) a surrender [n]\n",
  "SURRENDRY": "(obsolete) a surrender [n SURRENDRIES]\n",
  "SURREPTITIOUS": "done by stealth [adj SURREPTITIOUSLY]\n",
  "SURREPTITIOUSLY": "SURREPTITIOUS, done by stealth [adv]\n",
  "SURREY": "a light four-wheeled carriage with two seats [n -S]\n",
  "SURREYS": "SURREY, a light four-wheeled carriage with two seats [n]\n",
  "SURROGACIES": "SURROGACY, the state of being a surrogate [n]\n",
  "SURROGACY": "the state of being a surrogate [n SURROGACIES]\n",
  "SURROGATE": "a substitute; a deputy [n -S] / to act as a surrogate [v SURROGATED, SURROGATING, SURROGATES]\n",
  "SURROGATED": "SURROGATE, to act as a surrogate [v]\n",
  "SURROGATES": "SURROGATE, to act as a surrogate [v]\n",
  "SURROGATESHIP": "the office of surrogate [n -S]\n",
  "SURROGATESHIPS": "SURROGATESHIP, the office of surrogate [n]\n",
  "SURROGATING": "SURROGATE, to act as a surrogate [v]\n",
  "SURROGATION": "subrogation [n -S]\n",
  "SURROGATIONS": "SURROGATION, subrogation [n]\n",
  "SURROGATUM": "something that stands in place of something else, e.g. a price instead of the thing itself [n -S]\n",
  "SURROGATUMS": "SURROGATUM, something that stands in place of something else, e.g. a price instead of the thing itself [n]\n",
  "SURROUND": "to encompass [v -ED, -ING, -S]\n",
  "SURROUNDED": "SURROUND, to encompass [v]\n",
  "SURROUNDING": "SURROUND, to encompass [v]\n",
  "SURROUNDINGS": "the circumstances, conditions, or objects by which one is surrounded [n]\n",
  "SURROUNDS": "SURROUND, to encompass [v]\n",
  "SURROYAL": "the topmost prong of a stag's antler [n -S]\n",
  "SURROYALS": "SURROYAL, the topmost prong of a stag's antler [n]\n",
  "SURTARBRAND": "(Icelandic) a lignite found interbedded with lavas in Iceland, also SURTURBRAND [n -S]\n",
  "SURTARBRANDS": "SURTARBRAND, (Icelandic) a lignite found interbedded with lavas in Iceland, also SURTURBRAND [n]\n",
  "SURTAX": "to assess with an extra tax [v -ED, -ING, -ES]\n",
  "SURTAXED": "SURTAX, to assess with an extra tax [v]\n",
  "SURTAXES": "SURTAX, to assess with an extra tax [v]\n",
  "SURTAXING": "SURTAX, to assess with an extra tax [v]\n",
  "SURTITLE": "a translation printed above a performance [n -S]\n",
  "SURTITLES": "SURTITLE, a translation printed above a performance [n]\n",
  "SURTOUT": "(French) a man's coat to be worn over his other garments [n -S]\n",
  "SURTOUTS": "SURTOUT, (French) a man's coat to be worn over his other garments [n]\n",
  "SURTURBRAND": "(Icelandic) a lignite found interbedded with lavas in Iceland, also SURTARBRAND [n -S]\n",
  "SURTURBRANDS": "SURTURBRAND, (Icelandic) a lignite found interbedded with lavas in Iceland, also SURTARBRAND [n]\n",
  "SURUCUCU": "a South American Indian name for the bushmaster snake [n -S]\n",
  "SURUCUCUS": "SURUCUCU, a South American Indian name for the bushmaster snake [n]\n",
  "SURVEIL": "to watch closely, also SURVEILLE [v SURVEILED or SURVEILLED, SURVEILING or SURVEILLING, SURVEILS]\n",
  "SURVEILED": "SURVEIL, to watch closely, also SURVEILLE [v]\n",
  "SURVEILING": "SURVEIL, to watch closely, also SURVEILLE [v]\n",
  "SURVEILLANCE": "(French) a watch kept over someone or something, esp. over a criminal [n -S]\n",
  "SURVEILLANCES": "SURVEILLANCE, (French) a watch kept over someone or something, esp. over a criminal [n]\n",
  "SURVEILLANT": "one that exercises surveillance [n -S]\n",
  "SURVEILLANTS": "SURVEILLANT, one that exercises surveillance [n]\n",
  "SURVEILLE": "to observe, keep under surveillance, also SURVEIL [v SURVEILLED, SURVEILLING, SURVEILLES]\n",
  "SURVEILLED": "SURVEIL, to watch closely, also SURVEILLE [v]\n",
  "SURVEILLES": "SURVEILLE, to observe, keep under surveillance, also SURVEIL [v]\n",
  "SURVEILLING": "SURVEIL, to watch closely, also SURVEILLE [v]\n",
  "SURVEILS": "SURVEIL, to watch closely, also SURVEILLE [v]\n",
  "SURVEY": "to examine in detail [v -ED, -ING, -S]\n",
  "SURVEYABLE": "that can be surveyed [adj]\n",
  "SURVEYAL": "a close examination, also SCRUTINY [n -S]\n",
  "SURVEYALS": "SURVEYAL, a close examination, also SCRUTINY [n]\n",
  "SURVEYANCE": "survey; inspection [n -S]\n",
  "SURVEYANCES": "SURVEYANCE, survey; inspection [n]\n",
  "SURVEYED": "SURVEY, to examine in detail [v]\n",
  "SURVEYING": "the act of surveying [n -S]\n",
  "SURVEYINGS": "SURVEYING, the act of surveying [n]\n",
  "SURVEYOR": "one who surveys land [n -S]\n",
  "SURVEYORS": "SURVEYOR, one who surveys land [n]\n",
  "SURVEYORSHIP": "the office of surveyor [n -S]\n",
  "SURVEYORSHIPS": "SURVEYORSHIP, the office of surveyor [n]\n",
  "SURVEYS": "SURVEY, to examine in detail [v]\n",
  "SURVIEW": "to survey, look over, also SERUEWE, SERVEWE [v -ED, -ING, -S]\n",
  "SURVIEWED": "SURVIEW, to survey, look over, also SERUEWE, SERVEWE [v]\n",
  "SURVIEWING": "SURVIEW, to survey, look over, also SERUEWE, SERVEWE [v]\n",
  "SURVIEWS": "SURVIEW, to survey, look over, also SERUEWE, SERVEWE [v]\n",
  "SURVIVABILITIES": "SURVIVABILITY, the state of being survivable [n]\n",
  "SURVIVABILITY": "the state of being survivable [n SURVIVABILITIES]\n",
  "SURVIVABLE": "resulting in or permitting survival [adj]\n",
  "SURVIVAL": "a living or continuing longer than another person or thing [n -S]\n",
  "SURVIVALISM": "the practice of taking of measures to ensure personal survival [n -S]\n",
  "SURVIVALISMS": "SURVIVALISM, the practice of taking of measures to ensure personal survival [n]\n",
  "SURVIVALIST": "a person who advocates or practices survivalism [n -S]\n",
  "SURVIVALISTS": "SURVIVALIST, a person who advocates or practices survivalism [n]\n",
  "SURVIVALS": "SURVIVAL, a living or continuing longer than another person or thing [n]\n",
  "SURVIVANCE": "survival; the succession or right to succeed on surviving the present holder [n -S]\n",
  "SURVIVANCES": "SURVIVANCE, survival; the succession or right to succeed on surviving the present holder [n]\n",
  "SURVIVE": "to remain in existence [v SURVIVED, SURVIVING, SURVIVES]\n",
  "SURVIVED": "SURVIVE, to remain in existence [v]\n",
  "SURVIVER": "one that survives, also SURVIVOR [n -S]\n",
  "SURVIVERS": "SURVIVER, one that survives, also SURVIVOR [n]\n",
  "SURVIVES": "SURVIVE, to remain in existence [v]\n",
  "SURVIVING": "SURVIVE, to remain in existence [v]\n",
  "SURVIVOR": "one that survives, also SURVIVER [n -S]\n",
  "SURVIVORS": "SURVIVOR, one that survives, also SURVIVER [n]\n",
  "SURVIVORSHIP": "the legal right of the survivor of persons having joint interests in property to take the interest of the person who has died [n -S]\n",
  "SURVIVORSHIPS": "SURVIVORSHIP, the legal right of the survivor of persons having joint interests in property to take the interest of the person who has died [n]\n",
  "SUS": "to arrest for suspicious behaviour, also SUSS [v SUSED or SUSSED, SUSING or SUSSING, SUSES or SUSSES]\n",
  "SUSCEPTANCE": "the imaginary part of the admittance [n -S]\n",
  "SUSCEPTANCES": "SUSCEPTANCE, the imaginary part of the admittance [n]\n",
  "SUSCEPTIBILITY": "the state of being susceptible [n]\n",
  "SUSCEPTIBLE": "open to the influence of [adj SUSCEPTIBLY]\n",
  "SUSCEPTIBLENESS": "the state of being susceptible [n]\n",
  "SUSCEPTIBLY": "SUSCEPTIBLE, open to the influence of [adv]\n",
  "SUSCEPTIVE": "susceptible [adj]\n",
  "SUSCEPTIVENESS": "the state of being susceptive [n]\n",
  "SUSCEPTIVITIES": "SUSCEPTIVITY, the state of being susceptive, susceptible [n]\n",
  "SUSCEPTIVITY": "the state of being susceptive, susceptible [n SUSCEPTIVITIES]\n",
  "SUSCEPTOR": "(obsolete) a sponsor [n -S]\n",
  "SUSCEPTORS": "SUSCEPTOR, (obsolete) a sponsor [n]\n",
  "SUSCIPIENT": "the recipient of a sacrament [n -S]\n",
  "SUSCIPIENTS": "SUSCIPIENT, the recipient of a sacrament [n]\n",
  "SUSCITATE": "to excite; to rouse [v SUSCITATED, SUSCITATING, SUSCITATES]\n",
  "SUSCITATED": "SUSCITATE, to excite; to rouse [v]\n",
  "SUSCITATES": "SUSCITATE, to excite; to rouse [v]\n",
  "SUSCITATING": "SUSCITATE, to excite; to rouse [v]\n",
  "SUSCITATION": "the act of suscitating [n -S]\n",
  "SUSCITATIONS": "SUSCITATION, the act of suscitating [n]\n",
  "SUSED": "SUS, to arrest for suspicious behaviour, also SUSS [v]\n",
  "SUSES": "SUS, to arrest for suspicious behaviour, also SUSS [v]\n",
  "SUSHI": "(Japanese) a dish of raw fish sliced with rice [n -S]\n",
  "SUSHIS": "SUSHI, (Japanese) a dish of raw fish sliced with rice [n]\n",
  "SUSING": "SUS, to arrest for suspicious behaviour, also SUSS [v]\n",
  "SUSLIK": "(Russian) a ground squirrel, also SOUSLIK [n -S]\n",
  "SUSLIKS": "SUSLIK, (Russian) a ground squirrel, also SOUSLIK [n]\n",
  "SUSPECT": "to think guilty [v -ED, -ING, -S]\n",
  "SUSPECTABLE": "that can be suspected [adj]\n",
  "SUSPECTED": "SUSPECT, to think guilty [v]\n",
  "SUSPECTEDLY": "SUSPECTED, SUSPECT, to think guilty [adv]\n",
  "SUSPECTEDNESS": "the state of being suspected [n -ES]\n",
  "SUSPECTEDNESSES": "SUSPECTEDNESS, the state of being suspected [n]\n",
  "SUSPECTER": "one who suspects [n -S]\n",
  "SUSPECTERS": "SUSPECTER, one who suspects [n]\n",
  "SUSPECTFUL": "apt to suspect or mistrust [adj]\n",
  "SUSPECTING": "SUSPECT, to think guilty [v]\n",
  "SUSPECTLESS": "without a suspect [adj]\n",
  "SUSPECTS": "SUSPECT, to think guilty [v]\n",
  "SUSPENCE": "(Milton) suspended, held back, also SUSPENS [adj]\n",
  "SUSPEND": "to stop for a period [v -ED, -ING, -S]\n",
  "SUSPENDED": "SUSPEND, to stop for a period [v]\n",
  "SUSPENDER": "a strap to support a sock or stocking [n -S]\n",
  "SUSPENDERED": "wearing suspenders [adj]\n",
  "SUSPENDERS": "SUSPENDER, a strap to support a sock or stocking [n]\n",
  "SUSPENDIBILITY": "the state of being suspendible [n]\n",
  "SUSPENDIBLE": "that can be suspended, also SUSPENSIBLE [adj]\n",
  "SUSPENDING": "SUSPEND, to stop for a period [v]\n",
  "SUSPENDS": "SUSPEND, to stop for a period [v]\n",
  "SUSPENS": "(Milton) suspended, held back, also SUSPENCE [adj]\n",
  "SUSPENSE": "a state of mental uncertainty or excitement [n -S]\n",
  "SUSPENSEFUL": "full of suspense [adj SUSPENSEFULLY]\n",
  "SUSPENSEFULLY": "SUSPENSEFUL, full of suspense [adv]\n",
  "SUSPENSEFULNESS": "the state of being suspenseful [n]\n",
  "SUSPENSELESS": "without suspense [adj]\n",
  "SUSPENSER": "something, e.g. a film or book, that is filled with suspense [n -S]\n",
  "SUSPENSERS": "SUSPENSER, something, e.g. a film or book, that is filled with suspense [n]\n",
  "SUSPENSES": "SUSPENSE, a state of mental uncertainty or excitement [n]\n",
  "SUSPENSIBILITY": "the state of being suspensible, that can be suspended [n]\n",
  "SUSPENSIBLE": "that can be suspended, also SUSPENDIBLE [adj]\n",
  "SUSPENSION": "temporary removal (as from office or privileges) [n -S]\n",
  "SUSPENSIONS": "SUSPENSION, temporary removal (as from office or privileges) [n]\n",
  "SUSPENSIVE": "tending to suspend, or to keep in suspense [adj SUSPENSIVELY]\n",
  "SUSPENSIVELY": "SUSPENSIVE, tending to suspend, or to keep in suspense [adv]\n",
  "SUSPENSIVENESS": "the state of being suspensive [n]\n",
  "SUSPENSOID": "a colloid dispersed with difficulty, yielding an unstable solution that cannot be reformed after coagulation [n -S]\n",
  "SUSPENSOIDS": "SUSPENSOID, a colloid dispersed with difficulty, yielding an unstable solution that cannot be reformed after coagulation [n]\n",
  "SUSPENSOR": "a suspensory ligament, bandage, etc., also SUSPENSORY [n -S]\n",
  "SUSPENSORIA": "SUSPENSORIUM, that which holds up a part, esp. the arrangement joining the lower jaw to the cranium in vertebrates below mammals [n]\n",
  "SUSPENSORIAL": "of or like the suspensorium [adj]\n",
  "SUSPENSORIES": "SUSPENSORY, a suspensory ligament, bandage, etc., also SUSPENSOR [n]\n",
  "SUSPENSORIUM": "that which holds up a part, esp. the arrangement joining the lower jaw to the cranium in vertebrates below mammals [n SUSPENSORIA]\n",
  "SUSPENSORS": "SUSPENSOR, a suspensory ligament, bandage, etc., also SUSPENSORY [n]\n",
  "SUSPENSORY": "a suspensory ligament, bandage, etc., also SUSPENSOR [n SUSPENSORIES]\n",
  "SUSPERCOLLATE": "to hang by the neck [v SUSPERCOLLATED, SUSPERCOLLATING, SUSPERCOLLATES]\n",
  "SUSPERCOLLATED": "SUSPERCOLLATE, to hang by the neck [v]\n",
  "SUSPERCOLLATES": "SUSPERCOLLATE, to hang by the neck [v]\n",
  "SUSPERCOLLATING": "SUSPERCOLLATE, to hang by the neck [v]\n",
  "SUSPICION": "the act of suspecting [n -S] / to suspect [v -ED, -ING, -S]\n",
  "SUSPICIONAL": "relating to suspicion [adj]\n",
  "SUSPICIONED": "SUSPICION, to suspect [v]\n",
  "SUSPICIONING": "SUSPICION, to suspect [v]\n",
  "SUSPICIONLESS": "without suspicion [adj]\n",
  "SUSPICIONS": "SUSPICION, to suspect [v]\n",
  "SUSPICIOUS": "tending to arouse suspicion [adj SUSPICIOUSLY]\n",
  "SUSPICIOUSLY": "SUSPICIOUS, tending to arouse suspicion [adv]\n",
  "SUSPICIOUSNESS": "the state of being suspicious [n]\n",
  "SUSPIRATION": "the act of sighing, or fetching a long and deep breath [n -S]\n",
  "SUSPIRATIONS": "SUSPIRATION, the act of sighing, or fetching a long and deep breath [n]\n",
  "SUSPIRE": "to sigh [v SUSPIRED, SUSPIRING, SUSPIRES]\n",
  "SUSPIRED": "SUSPIRE, to sigh [v]\n",
  "SUSPIRES": "SUSPIRE, to sigh [v]\n",
  "SUSPIRING": "SUSPIRE, to sigh [v]\n",
  "SUSPIRIOUS": "breathing labouredly; sighing [adj]\n",
  "SUSS": "to arrest for suspicious behaviour, also SUS [v -ED, -ING, -ES]\n",
  "SUSSED": "SUSS, to arrest for suspicious behaviour, also SUS [v]\n",
  "SUSSES": "SUSS, to arrest for suspicious behaviour, also SUS [v]\n",
  "SUSSING": "SUSS, to arrest for suspicious behaviour, also SUS [v]\n",
  "SUSTAIN": "to maintain by providing with food and drink [v -ED, -ING, -S]\n",
  "SUSTAINABILITY": "the state of being sustainable [n]\n",
  "SUSTAINABLE": "capable of being sustained [adj SUSTAINABLY]\n",
  "SUSTAINABLY": "SUSTAINABLE, capable of being sustained [adv]\n",
  "SUSTAINED": "SUSTAIN, to maintain by providing with food and drink [v]\n",
  "SUSTAINEDLY": "SUSTAINED, SUSTAIN, to maintain by providing with food and drink [adv]\n",
  "SUSTAINER": "one who sustains [n -S]\n",
  "SUSTAINERS": "SUSTAINER, one who sustains [n]\n",
  "SUSTAINING": "preserving life [adj SUSTAININGLY] / the act of sustaining [n -S]\n",
  "SUSTAININGLY": "SUSTAINING, preserving life [adv]\n",
  "SUSTAININGS": "SUSTAINING, the act of sustaining [n]\n",
  "SUSTAINMENT": "the act of sustaining [n -S]\n",
  "SUSTAINMENTS": "SUSTAINMENT, the act of sustaining [n]\n",
  "SUSTAINS": "SUSTAIN, to maintain by providing with food and drink [v]\n",
  "SUSTENANCE": "nourishment [n -S]\n",
  "SUSTENANCES": "SUSTENANCE, nourishment [n]\n",
  "SUSTENTACULA": "SUSTENTACULUM, a supporting part or structure [n]\n",
  "SUSTENTACULAR": "supporting or maintaining [adj]\n",
  "SUSTENTACULUM": "a supporting part or structure [n SUSTENTACULA]\n",
  "SUSTENTATE": "to sustain [v SUSTENTATED, SUSTENTATING, SUSTENTATES]\n",
  "SUSTENTATED": "SUSTENTATE, to sustain [v]\n",
  "SUSTENTATES": "SUSTENTATE, to sustain [v]\n",
  "SUSTENTATING": "SUSTENTATE, to sustain [v]\n",
  "SUSTENTATION": "the action of bearing or enduring [n -S]\n",
  "SUSTENTATIONS": "SUSTENTATION, the action of bearing or enduring [n]\n",
  "SUSTENTATIVE": "sustaining, enduring [adj]\n",
  "SUSTENTATOR": "a sustaining part or structure [n -S]\n",
  "SUSTENTATORS": "SUSTENTATOR, a sustaining part or structure [n]\n",
  "SUSTENTION": "the act of sustaining [n -S]\n",
  "SUSTENTIONS": "SUSTENTION, the act of sustaining [n]\n",
  "SUSTENTIVE": "relating to sustention, the act of sustaining [adj]\n",
  "SUSTINENT": "sustaining [adj]\n",
  "SUSU": "(Caribbean) an arrangement made among friends whereby each person makes regular contributions to a fund, the money being drawn out periodically by each individual in turn [n -S]\n",
  "SUSURRANT": "whispering [adj]\n",
  "SUSURRATE": "to whisper [v SUSURRATED, SUSURRATING, SUSURRATES]\n",
  "SUSURRATED": "SUSURRATE, to whisper [v]\n",
  "SUSURRATES": "SUSURRATE, to whisper [v]\n",
  "SUSURRATING": "SUSURRATE, to whisper [v]\n",
  "SUSURRATION": "whispering, murmuring, or rustling [n -S]\n",
  "SUSURRATIONS": "SUSURRATION, whispering, murmuring, or rustling [n]\n",
  "SUSURROUS": "full of whispering sounds [adj]\n",
  "SUSURRUS": "(Latin) a soft rustling sound [n -ES]\n",
  "SUSURRUSES": "SUSURRUS, (Latin) a soft rustling sound [n]\n",
  "SUSUS": "SUSU, (Caribbean) an arrangement made among friends whereby each person makes regular contributions to a fund, the money being drawn out periodically by each individual in turn [n]\n",
  "SUTILE": "done by stitching [adj]\n",
  "SUTLER": "one who peddles goods to soldiers [n -S]\n",
  "SUTLERIES": "SUTLERY, a camp hawker's stall [n]\n",
  "SUTLERS": "SUTLER, one who peddles goods to soldiers [n]\n",
  "SUTLERSHIP": "the office of sutler, one who sells liquor or provisions to soldiers [n -S]\n",
  "SUTLERSHIPS": "SUTLERSHIP, the office of sutler, one who sells liquor or provisions to soldiers [n]\n",
  "SUTLERY": "a camp hawker's stall [n SUTLERIES]\n",
  "SUTOR": "(archaic) a cobbler, also SOUTAR, SOUTER, SOWTER [n -S]\n",
  "SUTORIAL": "relating to cobbling, also SUTORIAN [adj]\n",
  "SUTORIAN": "relating to cobbling, also SUTORIAL [adj]\n",
  "SUTORS": "SUTOR, (archaic) a cobbler, also SOUTAR, SOUTER, SOWTER [n]\n",
  "SUTRA": "(Sanskrit) a precept; an aphorism; a brief rule, also SUTTA [n -S]\n",
  "SUTRAS": "SUTRA, (Sanskrit) a precept; an aphorism; a brief rule, also SUTTA [n]\n",
  "SUTTA": "(Pali) a precept; an aphorism; a brief rule, also SUTRA [n -S]\n",
  "SUTTAS": "SUTTA, (Pali) a precept; an aphorism; a brief rule, also SUTRA [n]\n",
  "SUTTEE": "(Sanskrit) the act of a Hindu widow willingly being cremated on the funeral pyre of her husband, also SATI [n -S]\n",
  "SUTTEEISM": "the Indian practice of self-immolation of widows [n -S]\n",
  "SUTTEEISMS": "SUTTEEISM, the Indian practice of self-immolation of widows [n]\n",
  "SUTTEES": "SUTTEE, (Sanskrit) the act of a Hindu widow willingly being cremated on the funeral pyre of her husband, also SATI [n]\n",
  "SUTTLE": "subtle [adj SUTTLY] / to trade as a camp hawker [v SUTTLED, SUTTLING, SUTTLES]\n",
  "SUTTLED": "SUTTLE, to trade as a camp hawker [v]\n",
  "SUTTLES": "SUTTLE, to trade as a camp hawker [v]\n",
  "SUTTLETIE": "(Milton) subtlety, also SUBTILITY, SUBTILTY, SUBTLETY [n -S]\n",
  "SUTTLETIES": "SUTTLETIE, (Milton) subtlety, also SUBTILITY, SUBTILTY, SUBTLETY [n]\n",
  "SUTTLING": "SUTTLE, to trade as a camp hawker [v]\n",
  "SUTTLY": "(Milton) subtly [adv]\n",
  "SUTURAL": "pertaining to the junction between two bones [adj SUTURALLY]\n",
  "SUTURALLY": "SUTURAL, pertaining to the junction between two bones [adv]\n",
  "SUTURATION": "the act of applying sutures [n -S]\n",
  "SUTURATIONS": "SUTURATION, the act of applying sutures [n]\n",
  "SUTURE": "to unite by sewing [v SUTURED, SUTURING, SUTURES]\n",
  "SUTURED": "SUTURE, to unite by sewing [v]\n",
  "SUTURES": "SUTURE, to unite by sewing [v]\n",
  "SUTURING": "SUTURE, to unite by sewing [v]\n",
  "SUZERAIN": "(French) a feudal lord [n -S]\n",
  "SUZERAINS": "SUZERAIN, (French) a feudal lord [n]\n",
  "SUZERAINTIES": "SUZERAINTY, the dominion or authority of a suzerain [n]\n",
  "SUZERAINTY": "the dominion or authority of a suzerain [n SUZERAINTIES]\n",
  "SVARABHAKTI": "(Sanskrit) the development of a vowel between consonants [n -S]\n",
  "SVARABHAKTIS": "SVARABHAKTI, (Sanskrit) the development of a vowel between consonants [n]\n",
  "SVARAJ": "(Sanskrit) self-government, home rule, also SWARAJ [n -ES]\n",
  "SVARAJES": "SVARAJ, (Sanskrit) self-government, home rule, also SWARAJ [n]\n",
  "SVASTIKA": "(Sanskrit) a Greek cross with arms bent at a right angle, also SWASTICA, SWASTIKA [n -S]\n",
  "SVASTIKAS": "SVASTIKA, (Sanskrit) a Greek cross with arms bent at a right angle, also SWASTICA, SWASTIKA [n]\n",
  "SVEDBERG": "(Swedish) a unit of time used to measure sedimentation velocity [n -S]\n",
  "SVEDBERGS": "SVEDBERG, (Swedish) a unit of time used to measure sedimentation velocity [n]\n",
  "SVELTE": "(French) slender, sleek [adj SVELTER, SVELTEST, SVELTELY]\n",
  "SVELTELY": "SVELTE, (French) slender, sleek [adv]\n",
  "SVELTENESS": "the quality of being svelte [n -ES]\n",
  "SVELTENESSES": "SVELTENESS, the quality of being svelte [n]\n",
  "SVELTER": "SVELTE, (French) slender, sleek [adj]\n",
  "SVELTEST": "SVELTE, (French) slender, sleek [adj]\n",
  "SWAB": "to clean with a large mop, also SWOB [v SWABBED, SWABBING, SWABS]\n",
  "SWABBED": "SWAB, to clean with a large mop, also SWOB [v]\n",
  "SWABBER": "one that swabs, also SWOBBER [n -S]\n",
  "SWABBERS": "SWABBER, one that swabs, also SWOBBER [n]\n",
  "SWABBIE": "(US slang) a seaman, esp. a new recruit, also SWABBY [n -S]\n",
  "SWABBIES": "SWABBIE, (US slang) a seaman, esp. a new recruit, also SWABBY [n]\n",
  "SWABBING": "SWAB, to clean with a large mop, also SWOB [v]\n",
  "SWABBY": "(US slang) a seaman, esp. a new recruit, also SWABBIE [n SWABBIES]\n",
  "SWABS": "SWAB, to clean with a large mop, also SWOB [v]\n",
  "SWACHH": "(Hindi) clean [adj]\n",
  "SWACK": "(Scots) to strike, brandish [v -ED, -ING, -S]\n",
  "SWACKED": "SWACK, (Scots) to strike, brandish [v]\n",
  "SWACKING": "SWACK, (Scots) to strike, brandish [v]\n",
  "SWACKS": "SWACK, (Scots) to strike, brandish [v]\n",
  "SWAD": "(dialect) a country lout, a soldier [n -S]\n",
  "SWADDIE": "a soldier, esp. a militiaman, also SWADDY [n -S]\n",
  "SWADDIES": "SWADDY, a soldier, esp. a militiaman, also SWADDIE [n]\n",
  "SWADDLE": "to wrap in bandages [v SWADDLED, SWADDLING, SWADDLES]\n",
  "SWADDLED": "SWADDLE, to wrap in bandages [v]\n",
  "SWADDLER": "a term of contempt for an Irish Methodist [n -S]\n",
  "SWADDLERS": "SWADDLER, a term of contempt for an Irish Methodist [n]\n",
  "SWADDLES": "SWADDLE, to wrap in bandages [v]\n",
  "SWADDLING": "SWADDLE, to wrap in bandages [v]\n",
  "SWADDY": "a soldier, esp. a militiaman, also SWADDIE [n SWADDIES]\n",
  "SWADS": "SWAD, (dialect) a country lout, a soldier [n]\n",
  "SWAG": "to sway, sag [v SWAGGED, SWAGGING, SWAGS]\n",
  "SWAGE": "to shape with a hammering tool [v SWAGED, SWAGING, SWAGES]\n",
  "SWAGED": "SWAGE, to shape with a hammering tool [v]\n",
  "SWAGER": "one who uses a swage, a grooved shaping tool [n -S]\n",
  "SWAGERS": "SWAGER, one who uses a swage, a grooved shaping tool [n]\n",
  "SWAGES": "SWAGE, to shape with a hammering tool [v]\n",
  "SWAGGED": "SWAG, to sway, sag [v]\n",
  "SWAGGER": "to walk with a pompous air [v -ED, -ING, -S]\n",
  "SWAGGERED": "SWAGGER, to walk with a pompous air [v]\n",
  "SWAGGERER": "one who swaggers [n -S]\n",
  "SWAGGERERS": "SWAGGERER, one who swaggers [n]\n",
  "SWAGGERING": "blustering, superior [adj SWAGGERINGLY] / the act of swaggering [n -S]\n",
  "SWAGGERINGLY": "SWAGGERING [adv]\n",
  "SWAGGERINGS": "SWAGGERING, the act of swaggering [n]\n",
  "SWAGGERS": "SWAGGER, to walk with a pompous air [v]\n",
  "SWAGGIE": "(Australian slang) a hobo, also SWAGMAN [n -S]\n",
  "SWAGGIES": "SWAGGIE, (Australian slang) a hobo, also SWAGMAN [n]\n",
  "SWAGGING": "SWAG, to sway, sag [v]\n",
  "SWAGING": "SWAGE, to shape with a hammering tool [v]\n",
  "SWAGMAN": "a hobo, also SWAGGIE [n SWAGMEN]\n",
  "SWAGMEN": "SWAGMAN, a hobo, also SWAGGIE [n]\n",
  "SWAGS": "SWAG, to sway, sag [v]\n",
  "SWAGSHOP": "a place where cheap and trashy goods are sold [n -S]\n",
  "SWAGSHOPS": "SWAGSHOP, a place where cheap and trashy goods are sold [n]\n",
  "SWAGSMAN": "a man who seeks work while travelling about carrying his swag, also SWAGGIE, SWAGMAN [n SWAGSMEN]\n",
  "SWAGSMEN": "SWAGSMAN, a man who seeks work while travelling about carrying his swag, also SWAGGIE, SWAGMAN [n]\n",
  "SWAIL": "a tract of low, marshy ground, also SWALE [n -S]\n",
  "SWAILS": "SWAIL, a tract of low, marshy ground, also SWALE [n]\n",
  "SWAIN": "a country boy [n -S]\n",
  "SWAINING": "lovemaking [n -S]\n",
  "SWAININGS": "SWAINING, lovemaking [n]\n",
  "SWAINISH": "boorish [adj]\n",
  "SWAINISHNESS": "the state of being swainish, boorish [n -ES]\n",
  "SWAINISHNESSES": "SWAINISHNESS, the state of being swainish, boorish [n]\n",
  "SWAINS": "SWAIN, a country boy [n]\n",
  "SWALE": "to scorch, singe [v SWALED, SWALING, SWALES]\n",
  "SWALED": "SWALE, to scorch, singe [v]\n",
  "SWALES": "SWALE, to scorch, singe [v]\n",
  "SWALIER": "SWALY, marshy [adj]\n",
  "SWALIEST": "SWALY, marshy [adj]\n",
  "SWALING": "the act of scorching [n -S]\n",
  "SWALINGS": "SWALING, the act of scorching [n]\n",
  "SWALLET": "a place where water disappears underground, aka swallow hole [n -S]\n",
  "SWALLETS": "SWALLET, a place where water disappears underground, aka swallow hole [n]\n",
  "SWALLIES": "SWALLY, (Scots) an alcoholic drink [n]\n",
  "SWALLOW": "to take into the stomach through the mouth and gullet [v -ED, -ING, -S]\n",
  "SWALLOWABLE": "that can swallowed [adj]\n",
  "SWALLOWED": "SWALLOW, to take into the stomach through the mouth and gullet [v]\n",
  "SWALLOWER": "one who swallows [n -S]\n",
  "SWALLOWERS": "SWALLOWER, one who swallows [n]\n",
  "SWALLOWING": "SWALLOW, to take into the stomach through the mouth and gullet [v]\n",
  "SWALLOWS": "SWALLOW, to take into the stomach through the mouth and gullet [v]\n",
  "SWALLOWTAIL": "a kind of butterfly [n -S]\n",
  "SWALLOWTAILS": "SWALLOWTAIL, a kind of butterfly [n]\n",
  "SWALLOWWORT": "a kind of vine with brownish-purple flowers [n -S]\n",
  "SWALLOWWORTS": "SWALLOWWORT, a kind of vine with brownish-purple flowers [n]\n",
  "SWALLY": "(Scots) an alcoholic drink [n SWALLIES]\n",
  "SWALY": "marshy [adj SWALIER, SWALIEST]\n",
  "SWAM": "SWIM, to propel oneself in water [v]\n",
  "SWAMI": "(Hindi) a Hindu mystic, also SWAMY [n -S]\n",
  "SWAMIES": "SWAMY, (Hindi) a Hindu mystic, also SWAMI [n]\n",
  "SWAMIS": "SWAMI, (Hindi) a Hindu mystic, also SWAMY [n]\n",
  "SWAMP": "to inundate [v -ED, -ING, -S]\n",
  "SWAMPED": "SWAMP, to inundate [v]\n",
  "SWAMPER": "one that lives in a swampy area [n -S]\n",
  "SWAMPERS": "SWAMPER, one that lives in a swampy area [n]\n",
  "SWAMPIER": "SWAMPY, like a swamp [adj]\n",
  "SWAMPIEST": "SWAMPY, like a swamp [adj]\n",
  "SWAMPINESS": "the state of being swampy [n -ES]\n",
  "SWAMPINESSES": "SWAMPINESS, the state of being swampy [n]\n",
  "SWAMPING": "SWAMP, to inundate [v]\n",
  "SWAMPISH": "like a swamp [adj]\n",
  "SWAMPLAND": "swamp country [n -S]\n",
  "SWAMPLANDS": "SWAMPLAND, swamp country [n]\n",
  "SWAMPLESS": "without a swamp [adj]\n",
  "SWAMPS": "SWAMP, to inundate [v]\n",
  "SWAMPY": "like a swamp [adj SWAMPIER, SWAMPIEST]\n",
  "SWAMY": "(Hindi) a Hindu mystic, also SWAMI [n SWAMIES]\n",
  "SWAN": "to move like a swan [v SWANNED, SWANNING, SWANS]\n",
  "SWANG": "SWING, to move freely back and forth [v]\n",
  "SWANHERD": "one who tends swans [n -S]\n",
  "SWANHERDS": "SWANHERD, one who tends swans [n]\n",
  "SWANK": "slender, pliant [adj SWANKER, SWANKEST] / to show off [v -ED, -ING, -S]\n",
  "SWANKED": "SWANK, to show off [v]\n",
  "SWANKER": "one who shows off, also SWANKEY, SWANKIE, SWANKPOT [n -S]\n",
  "SWANKERS": "SWANKER, one who shows off, also SWANKEY, SWANKIE, SWANKPOT [n]\n",
  "SWANKEST": "SWANK, slender, pliant [adj]\n",
  "SWANKEY": "(Scots) one who shows off, also SWANKER, SWANKIE, SWANKPOT [n -S]\n",
  "SWANKEYS": "SWANKEY, (Scots) one who shows off, also SWANKER, SWANKIE, SWANKPOT [n]\n",
  "SWANKIE": "(Scots) one who shows off, also SWANKER, SWANKEY, SWANKPOT [n -S]\n",
  "SWANKIER": "SWANKY, ostentatiously smart [adj]\n",
  "SWANKIES": "SWANKIE, (Scots) one who shows off, also SWANKER, SWANKEY, SWANKPOT [n]\n",
  "SWANKIEST": "SWANKY, ostentatiously smart [adj]\n",
  "SWANKILY": "SWANKY, ostentatiously smart [adv]\n",
  "SWANKINESS": "the state of being swanky [n -ES]\n",
  "SWANKINESSES": "SWANKINESS, the state of being swanky [n]\n",
  "SWANKING": "SWANK, to show off [v]\n",
  "SWANKPOT": "one who shows off, also SWANKER, SWANKEY, SWANKIE [n -S]\n",
  "SWANKPOTS": "SWANKPOT, one who shows off, also SWANKER, SWANKEY, SWANKIE [n]\n",
  "SWANKS": "SWANK, to show off [v]\n",
  "SWANKY": "ostentatiously smart [adj SWANKIER, SWANKIEST, SWANKILY] / (Scots) an active, smart, vigorous person [n SWANKIES]\n",
  "SWANLIKE": "like a swan [adv]\n",
  "SWANNED": "SWAN, to move like a swan [v]\n",
  "SWANNERIES": "SWANNERY, a place where swans are raised [n]\n",
  "SWANNERY": "a place where swans are raised [n SWANNERIES]\n",
  "SWANNIE": "(tradename) in New Zealand, a type of allweather heavy woollen shirt [n -S]\n",
  "SWANNIER": "SWANNY, swanlike [adj]\n",
  "SWANNIES": "SWANNIE, (tradename) in New Zealand, a type of allweather heavy woollen shirt [n]\n",
  "SWANNIEST": "SWANNY, swanlike [adj]\n",
  "SWANNING": "the act of swanning [n -S]\n",
  "SWANNINGS": "SWANNING, the act of swanning [n]\n",
  "SWANNY": "swanlike [adj SWANNIER, SWANNIEST]\n",
  "SWANPAN": "(Chinese) a Chinese abacus, also SHWANPAN [n -S]\n",
  "SWANPANS": "SWANPAN, (Chinese) a Chinese abacus, also SHWANPAN [n]\n",
  "SWANS": "SWAN, to move like a swan [v]\n",
  "SWANSDOWN": "heavy napped cotton flannel [n -S]\n",
  "SWANSDOWNS": "SWANSDOWN, heavy napped cotton flannel [n]\n",
  "SWANSKIN": "a soft napped fabric resembling flannel [n -S]\n",
  "SWANSKINS": "SWANSKIN, a soft napped fabric resembling flannel [n]\n",
  "SWANSONG": "the fabled song of a swan just before its death; a writer's or musician's last work [n -S]\n",
  "SWANSONGS": "SWANSONG, the fabled song of a swan just before its death; a writer's or musician's last work [n]\n",
  "SWAP": "to barter, give in exchange, also SWOP [v SWAPPED or SWAPT, SWAPPING, SWAPS]\n",
  "SWAPFILE": "a computer file with space for transferred programs [n -S]\n",
  "SWAPFILES": "SWAPFILE, a computer file with space for transferred programs [n]\n",
  "SWAPPABLE": "capable of being swapped, also SWOPPABLE [adj]\n",
  "SWAPPED": "SWAP, to barter, give in exchange, also SWOP [v]\n",
  "SWAPPER": "a person who swaps [n -S]\n",
  "SWAPPERS": "SWAPPER, a person who swaps [n]\n",
  "SWAPPING": "the act of swapping [n -S]\n",
  "SWAPPINGS": "SWAPPING, the act of swapping [n]\n",
  "SWAPS": "SWAP, to barter, give in exchange, also SWOP [v]\n",
  "SWAPT": "SWAP, to barter, give in exchange, also SWOP [v]\n",
  "SWAPTION": "a swap option [n -S]\n",
  "SWAPTIONS": "SWAPTION, a swap option [n]\n",
  "SWARAJ": "(Sanskrit) self-government, home rule, also SVARAJ [n -ES]\n",
  "SWARAJES": "SWARAJ, (Sanskrit) self-government, home rule, also SVARAJ [n]\n",
  "SWARAJISM": "the policy of Indian political independence [n -S]\n",
  "SWARAJISMS": "SWARAJISM, the policy of Indian political independence [n]\n",
  "SWARAJIST": "one who adhered to swaraj, the policy of Indian political independence [n -S]\n",
  "SWARAJISTS": "SWARAJIST, one who adhered to swaraj, the policy of Indian political independence [n]\n",
  "SWARD": "to cover with turf [v -ED, -ING, -S]\n",
  "SWARDED": "SWARD, to cover with turf [v]\n",
  "SWARDIER": "SWARDY, covered with turf [adj]\n",
  "SWARDIEST": "SWARDY, covered with turf [adj]\n",
  "SWARDING": "SWARD, to cover with turf [v]\n",
  "SWARDS": "SWARD, to cover with turf [v]\n",
  "SWARDY": "covered with turf [adj SWARDIER, SWARDIEST]\n",
  "SWARE": "SWEAR, to utter a solemn oath [v]\n",
  "SWARF": "to faint, also SWERF [v -ED, -ING, -S]\n",
  "SWARFED": "SWARF, to faint, also SWERF [v]\n",
  "SWARFING": "SWARF, to faint, also SWERF [v]\n",
  "SWARFS": "SWARF, to faint, also SWERF [v]\n",
  "SWARM": "to move in a large group [v -ED, -ING, -S]\n",
  "SWARMED": "SWARM, to move in a large group [v]\n",
  "SWARMER": "one who swarms [n -S]\n",
  "SWARMERS": "SWARMER, one who swarms [n]\n",
  "SWARMING": "the act of swarming [n -S]\n",
  "SWARMINGS": "SWARMING, the act of swarming [n]\n",
  "SWARMS": "SWARM, to move in a large group [v]\n",
  "SWART": "dark-complexioned, blackish, also SWARTHY, SWARTY [adj]\n",
  "SWARTH": "the quantity of grass cut down by one sweep of the scythe, also SWATH, SWATHE [n -S]\n",
  "SWARTHIER": "SWARTHY, having a dark complexion, also SWARTY [adj]\n",
  "SWARTHIEST": "SWARTHY, having a dark complexion, also SWARTY [adj]\n",
  "SWARTHILY": "SWARTHY, having a dark complexion, also SWARTY [adv]\n",
  "SWARTHINESS": "the state of being swarthy [n -ES]\n",
  "SWARTHINESSES": "SWARTHINESS, the state of being swarthy [n]\n",
  "SWARTHNESS": "the state of being swarth, swarthy, also SWARTNESS [n -ES]\n",
  "SWARTHNESSES": "SWARTHNESS, the state of being swarth, swarthy, also SWARTNESS [n]\n",
  "SWARTHS": "SWARTH, the quantity of grass cut down by one sweep of the scythe, also SWATH, SWATHE [n]\n",
  "SWARTHY": "having a dark complexion, also SWARTY [adj SWARTHIER, SWARTHIEST, SWARTHILY]\n",
  "SWARTIER": "SWARTY, (obsolete) black, dusky, also SWART, SWARTHY [adj]\n",
  "SWARTIEST": "SWARTY, (obsolete) black, dusky, also SWART, SWARTHY [adj]\n",
  "SWARTNESS": "the state of being swart, also SWARTHNESS [n -ES]\n",
  "SWARTNESSES": "SWARTNESS, the state of being swart, also SWARTHNESS [n]\n",
  "SWARTY": "(obsolete) black, dusky, also SWART, SWARTHY [adj SWARTIER, SWARTIEST]\n",
  "SWARVE": "to swerve [v SWARVED, SWARVING, SWARVES]\n",
  "SWARVED": "SWARVE, to swerve [v]\n",
  "SWARVES": "SWARVE, to swerve [v]\n",
  "SWARVING": "SWARVE, to swerve [v]\n",
  "SWASH": "to dash, splash [v -ED, -ING, -ES]\n",
  "SWASHBUCKLE": "to act the part of a swashbuckler [v SWASHBUCKLED, SWASHBUCKLING, SWASHBUCKLES]\n",
  "SWASHBUCKLED": "SWASHBUCKLE, to act the part of a swashbuckler [v]\n",
  "SWASHBUCKLER": "a swaggering or daring soldier or adventurer [n -S]\n",
  "SWASHBUCKLERS": "SWASHBUCKLER, a swaggering or daring soldier or adventurer [n]\n",
  "SWASHBUCKLES": "SWASHBUCKLE, to act the part of a swashbuckler [v]\n",
  "SWASHBUCKLING": "SWASHBUCKLE, to act the part of a swashbuckler [v]\n",
  "SWASHED": "SWASH, to dash, splash [v]\n",
  "SWASHER": "(Shakespeare) a blusterer [n -S]\n",
  "SWASHERS": "SWASHER, (Shakespeare) a blusterer [n]\n",
  "SWASHES": "SWASH, to dash, splash [v]\n",
  "SWASHIER": "SWASHY, slushy [adj]\n",
  "SWASHIEST": "SWASHY, slushy [adj]\n",
  "SWASHING": "the act of slashing [n -S]\n",
  "SWASHINGS": "SWASHING, the act of slashing [n]\n",
  "SWASHWORK": "a wood-turner's work cut obliquely [n -S]\n",
  "SWASHWORKS": "SWASHWORK, a wood-turner's work cut obliquely [n]\n",
  "SWASHY": "slushy [adj SWASHIER, SWASHIEST]\n",
  "SWASTICA": "(Sanskrit) a Greek cross with arms bent at a right angle, also SVASTIKA, SWASTIKA [n -S]\n",
  "SWASTICAS": "SWASTICA, (Sanskrit) a Greek cross with arms bent at a right angle, also SVASTIKA, SWASTIKA [n]\n",
  "SWASTIKA": "(Sanskrit) a Greek cross with arms bent at a right angle, also SVASTIKA, SWASTICA [n -S]\n",
  "SWASTIKAS": "SWASTIKA, (Sanskrit) a Greek cross with arms bent at a right angle, also SVASTIKA, SWASTICA [n]\n",
  "SWAT": "to hit sharply [v SWATTED, SWATTING, SWATS]\n",
  "SWATCH": "a sample piece of cloth [n -ES]\n",
  "SWATCHBOOK": "a collection of swatches bound together in book form [n -S]\n",
  "SWATCHBOOKS": "SWATCHBOOK, a collection of swatches bound together in book form [n]\n",
  "SWATCHES": "SWATCH, a sample piece of cloth [n]\n",
  "SWATH": "a row of cut grass or grain [n -S] / to cut a swathe [v -ED, -ING, -S]\n",
  "SWATHABLE": "that can be swathed, also SWATHEABLE [adj]\n",
  "SWATHE": "to wrap in bandages [v SWATHED, SWATHING, SWATHES]\n",
  "SWATHEABLE": "that can be swathed, also SWATHABLE [adj]\n",
  "SWATHED": "SWATHE, to wrap in bandages [v]\n",
  "SWATHER": "a device attached to a mowing machine for raising the uncut fallen grain and marking the limit of the swath [n -S]\n",
  "SWATHERS": "SWATHER, a device attached to a mowing machine for raising the uncut fallen grain and marking the limit of the swath [n]\n",
  "SWATHES": "SWATHE, to wrap in bandages [v]\n",
  "SWATHIER": "SWATHY, in swathes [adj]\n",
  "SWATHIEST": "SWATHY, in swathes [adj]\n",
  "SWATHING": "a wrapping [n -S]\n",
  "SWATHINGS": "SWATHING, a wrapping [n]\n",
  "SWATHS": "SWATH, a row of cut grass or grain [n]\n",
  "SWATHY": "in swathes [adj SWATHIER, SWATHIEST]\n",
  "SWATS": "SWAT, to hit sharply [v]\n",
  "SWATTED": "SWAT, to hit sharply [v]\n",
  "SWATTER": "(dialect) to splash or spill about [v -ED, -ING, -S]\n",
  "SWATTERED": "SWATTER, (dialect) to splash or spill about [v]\n",
  "SWATTERING": "SWATTER, (dialect) to splash or spill about [v]\n",
  "SWATTERS": "SWATTER, (dialect) to splash or spill about [v]\n",
  "SWATTIER": "SWATTY, given to hard study, also SWOTTY [adj]\n",
  "SWATTIEST": "SWATTY, given to hard study, also SWOTTY [adj]\n",
  "SWATTING": "the act of swatting [n -S]\n",
  "SWATTINGS": "SWATTING, the act of swatting [n]\n",
  "SWATTY": "given to hard study, also SWOTTY [adj SWATTIER, SWATTIEST]\n",
  "SWAY": "to move slowly back and forth [v -ED, -ING, -S]\n",
  "SWAYABLE": "able to be swayed [adj]\n",
  "SWAYBACK": "an abnormal sagging of the back [n -S]\n",
  "SWAYBACKED": "of a horse, bent down in the back [adj]\n",
  "SWAYBACKS": "SWAYBACK, an abnormal sagging of the back [n]\n",
  "SWAYED": "SWAY, to move slowly back and forth [v]\n",
  "SWAYER": "one who sways [n -S]\n",
  "SWAYERS": "SWAYER, one who sways [n]\n",
  "SWAYFUL": "capable of influencing [adj]\n",
  "SWAYING": "the act of swaying [n -S]\n",
  "SWAYINGS": "SWAYING, the act of swaying [n]\n",
  "SWAYL": "to scorch, singe, also SWAIL, SWALE, SWEAL, SWEEL [v -ED, -ING, -S]\n",
  "SWAYLED": "SWAYL, to scorch, singe, also SWAIL, SWALE, SWEAL, SWEEL [v]\n",
  "SWAYLING": "a scorching [n -S]\n",
  "SWAYLINGS": "SWAYLING, a scorching [n]\n",
  "SWAYLS": "SWAYL, to scorch, singe, also SWAIL, SWALE, SWEAL, SWEEL [v]\n",
  "SWAYS": "SWAY, to move slowly back and forth [v]\n",
  "SWAZZLE": "an instrument which produces Mr Punch's voice, also SWOZZLE [n -S]\n",
  "SWAZZLES": "SWAZZLE, an instrument which produces Mr Punch's voice, also SWOZZLE [n]\n",
  "SWEAL": "to scorch, singe, also SWAIL, SWALE, SWAYL, SWEEL [v -ED, -ING, -S]\n",
  "SWEALED": "SWEAL, to scorch, singe, also SWAIL, SWALE, SWAYL, SWEEL [v]\n",
  "SWEALING": "a melting [n -S]\n",
  "SWEALINGS": "SWEALING, a melting [n]\n",
  "SWEALS": "SWEAL, to scorch, singe, also SWAIL, SWALE, SWAYL, SWEEL [v]\n",
  "SWEAR": "to utter a solemn oath [v SWARE or SWORE, SWORN, SWEARING, SWEARS]\n",
  "SWEARD": "(Spenser) a sword [n -S]\n",
  "SWEARDS": "SWEARD, (Spenser) a sword [n]\n",
  "SWEARER": "one who swears [n -S]\n",
  "SWEARERS": "SWEARER, one who swears [n]\n",
  "SWEARIER": "SWEARY, relating to, containing or inclined to use swearwords [adj]\n",
  "SWEARIEST": "SWEARY, relating to, containing or inclined to use swearwords [adj]\n",
  "SWEARING": "the act of swearing [n -S]\n",
  "SWEARINGS": "SWEARING, the act of swearing [n]\n",
  "SWEARS": "SWEAR, to utter a solemn oath [v]\n",
  "SWEARWORD": "an expletive [n -S]\n",
  "SWEARWORDS": "SWEARWORD, an expletive [n]\n",
  "SWEARY": "relating to, containing or inclined to use swearwords [adj SWEARIER, SWEARIEST]\n",
  "SWEAT": "to perspire [v -ED, -ING, -S]\n",
  "SWEATBAND": "an absorbent wristlet worn by e.g. tennis players to prevent sweat running down to their hands [n -S]\n",
  "SWEATBANDS": "SWEATBAND, an absorbent wristlet worn by e.g. tennis players to prevent sweat running down to their hands [n]\n",
  "SWEATBOX": "a small enclosure in which one is made to sweat [n -ES]\n",
  "SWEATBOXES": "SWEATBOX, a small enclosure in which one is made to sweat [n]\n",
  "SWEATED": "SWEAT, to perspire [v]\n",
  "SWEATER": "a heavy jersey for leisurewear, intervals in exercise etc. [n -S]\n",
  "SWEATERDRESS": "a knitted or crocheted dress [n -ES]\n",
  "SWEATERDRESSES": "SWEATERDRESS, a knitted or crocheted dress [n]\n",
  "SWEATERED": "wearing a sweater [adj]\n",
  "SWEATERS": "SWEATER, a heavy jersey for leisurewear, intervals in exercise etc. [n]\n",
  "SWEATIER": "SWEATY, covered with perspiration [adj]\n",
  "SWEATIEST": "SWEATY, covered with perspiration [adj]\n",
  "SWEATILY": "SWEATY, covered with perspiration [adv]\n",
  "SWEATINESS": "the state of being sweaty [n -ES]\n",
  "SWEATINESSES": "SWEATINESS, the state of being sweaty [n]\n",
  "SWEATING": "the act of sweating [n -S]\n",
  "SWEATINGS": "SWEATING, the act of sweating [n]\n",
  "SWEATLESS": "without sweat [adj]\n",
  "SWEATPANTS": "trousers of (usually thick) cotton material, with drawstring or elasticated waist and cuffs, as worn by athletes when warming up or after exercise [n]\n",
  "SWEATS": "SWEAT, to perspire [v]\n",
  "SWEATSHIRT": "a long-sleeved knitted cotton sweater, usually fleecy on the inside [n -S]\n",
  "SWEATSHIRTS": "SWEATSHIRT, a long-sleeved knitted cotton sweater, usually fleecy on the inside [n]\n",
  "SWEATSHOP": "a factory or shop using sweated labour [n -S]\n",
  "SWEATSHOPS": "SWEATSHOP, a factory or shop using sweated labour [n]\n",
  "SWEATSUIT": "a loose-fitting suit consisting of sweater and trousers, usually close-fitting at wrist and ankle, worn by athletes, etc. [n -S]\n",
  "SWEATSUITS": "SWEATSUIT, a loose-fitting suit consisting of sweater and trousers, usually close-fitting at wrist and ankle, worn by athletes, etc. [n]\n",
  "SWEATY": "covered with perspiration [adj SWEATIER, SWEATIEST, SWEATILY]\n",
  "SWEDE": "a vegetable like a turnip [n -S]\n",
  "SWEDES": "SWEDE, a vegetable like a turnip [n]\n",
  "SWEDGER": "(Scots) a sweet [n -S]\n",
  "SWEDGERS": "SWEDGER, (Scots) a sweet [n]\n",
  "SWEE": "to sway, swing, also SWEY [v SWEED, SWEEING, SWEES]\n",
  "SWEED": "SWEE, to sway, swing, also SWEY [v]\n",
  "SWEEING": "SWEE, to sway, swing, also SWEY [v]\n",
  "SWEEL": "to scorch, singe, also SWAIL, SWALE, SWAYL, SWEAL [v -ED, -ING, -S]\n",
  "SWEELED": "SWEEL, to scorch, singe, also SWAIL, SWALE, SWAYL, SWEAL [v]\n",
  "SWEELING": "SWEEL, to scorch, singe, also SWAIL, SWALE, SWAYL, SWEAL [v]\n",
  "SWEELS": "SWEEL, to scorch, singe, also SWAIL, SWALE, SWAYL, SWEAL [v]\n",
  "SWEENEY": "atrophy of a horse's shoulder muscle, also SWEENY, SWINNEY [n -S]\n",
  "SWEENEYS": "SWEENEY, atrophy of a horse's shoulder muscle, also SWEENY, SWINNEY [n]\n",
  "SWEENIES": "SWEENY, atrophy of a horse's shoulder muscle, also SWEENEY, SWINNEY [n]\n",
  "SWEENY": "atrophy of a horse's shoulder muscle, also SWEENEY, SWINNEY [n SWEENIES]\n",
  "SWEEP": "to clean with a broom [v SWEPT, SWEEPING, SWEEPS]\n",
  "SWEEPBACK": "the angle at which an aircraft wing is set back relative to the axis [n -S]\n",
  "SWEEPBACKS": "SWEEPBACK, the angle at which an aircraft wing is set back relative to the axis [n]\n",
  "SWEEPER": "one who sweeps [n -S]\n",
  "SWEEPERS": "SWEEPER, one who sweeps [n]\n",
  "SWEEPIER": "SWEEPY, of wide range or scope [adj]\n",
  "SWEEPIEST": "SWEEPY, of wide range or scope [adj]\n",
  "SWEEPING": "wide-ranging [adj SWEEPINGLY] / the act of sweeping [n -S]\n",
  "SWEEPINGLY": "SWEEPING, wide-ranging [adv]\n",
  "SWEEPINGNESS": "the state of being sweeping [n -ES]\n",
  "SWEEPINGNESSES": "SWEEPINGNESS, the state of being sweeping [n]\n",
  "SWEEPINGS": "SWEEPING, the act of sweeping [n]\n",
  "SWEEPS": "SWEEP, to clean with a broom [v]\n",
  "SWEEPSTAKE": "a method of gambling by which participators' stakes are pooled, numbers, horses, etc. assigned by lot, and prize(s) awarded accordingly on decision of event [n -S]\n",
  "SWEEPSTAKES": "SWEEPSTAKE, a method of gambling by which participators' stakes are pooled, numbers, horses, etc. assigned by lot, and prize(s) awarded accordingly on decision of event [n]\n",
  "SWEEPY": "of wide range or scope [adj SWEEPIER, SWEEPIEST]\n",
  "SWEER": "(Scots) slothful; grievous, heavy, also SWEERED, SWEERT, SWEIR, SWEIRT [adj] / to swear [v -ED, -ING, -S]\n",
  "SWEERED": "(Scots) slothful; grievous, heavy, also SWEER, SWEERT, SWEIR, SWEIRT [adj]\n",
  "SWEERING": "SWEER, to swear [v]\n",
  "SWEERS": "SWEER, to swear [v]\n",
  "SWEERT": "(Scots) slothful; grievous, heavy, also SWEER, SWEERED, SWEIR, SWEIRT [adj]\n",
  "SWEES": "SWEE, to sway, swing, also SWEY [v]\n",
  "SWEET": "tasting like sugar [adj SWEETER, SWEETEST, SWEETLY] / to sweeten [v -ED, -ING, -S]\n",
  "SWEETBREAD": "the thymus gland of a young animal [n -S]\n",
  "SWEETBREADS": "SWEETBREAD, the thymus gland of a young animal [n]\n",
  "SWEETBRIAR": "a wild rose with fragrant foliage, also SWEETBRIER [n -S]\n",
  "SWEETBRIARS": "SWEETBRIAR, a wild rose with fragrant foliage, also SWEETBRIER [n]\n",
  "SWEETBRIER": "a wild rose with fragrant foliage, also SWEETBRIAR [n -S]\n",
  "SWEETBRIERS": "SWEETBRIER, a wild rose with fragrant foliage, also SWEETBRIAR [n]\n",
  "SWEETCORN": "a sweet variety of maize; the yellow kernels of this, eaten as a vegetable [n -S]\n",
  "SWEETCORNS": "SWEETCORN, a sweet variety of maize; the yellow kernels of this, eaten as a vegetable [n]\n",
  "SWEETED": "SWEET, to sweeten [v]\n",
  "SWEETEN": "to make sweet [v -ED, -ING, -S]\n",
  "SWEETENED": "SWEETEN, to make sweet [v]\n",
  "SWEETENER": "a substance that sweetens, esp. one not containing sugar [n -S]\n",
  "SWEETENERS": "SWEETENER, a substance that sweetens, esp. one not containing sugar [n]\n",
  "SWEETENING": "the act of making sweet [n -S]\n",
  "SWEETENINGS": "SWEETENING, the act of making sweet [n]\n",
  "SWEETENS": "SWEETEN, to make sweet [v]\n",
  "SWEETER": "SWEET, tasting like sugar [adj]\n",
  "SWEETEST": "SWEET, tasting like sugar [adj]\n",
  "SWEETFISH": "the ayu, a small edible Japanese fish [n -ES]\n",
  "SWEETFISHES": "SWEETFISH, the ayu, a small edible Japanese fish [n]\n",
  "SWEETHEART": "a loved one [n -S] / to court [v -ED, -ING, -S]\n",
  "SWEETHEARTED": "SWEETHEART, to court [v]\n",
  "SWEETHEARTING": "the granting of unauthorized discounts or the abetting of shoplifting by staff in a shop [n -S]\n",
  "SWEETHEARTINGS": "SWEETHEARTING, the granting of unauthorized discounts or the abetting of shoplifting by staff in a shop [n]\n",
  "SWEETHEARTS": "SWEETHEART, a loved one [n]\n",
  "SWEETIE": "an attractive person, a poppet, also SWEETY [n -S]\n",
  "SWEETIES": "SWEETY, an attractive person, a poppet, also SWEETIE [n]\n",
  "SWEETIEWIFE": "(Scots) a woman who sells sweets; (esp. of an effeminate man) a gossip, scandalmonger [n SWEETIEWIVES]\n",
  "SWEETIEWIVES": "SWEETIEWIFE, (Scots) a woman who sells sweets; (esp. of an effeminate man) a gossip, scandalmonger [n]\n",
  "SWEETING": "a sweet apple [n -S]\n",
  "SWEETINGS": "SWEETING, a sweet apple [n]\n",
  "SWEETISH": "somewhat sweet [adj SWEETISHLY]\n",
  "SWEETISHLY": "SWEETISH, somewhat sweet [adv]\n",
  "SWEETISHNESS": "the state of being sweetish [n -ES]\n",
  "SWEETISHNESSES": "SWEETISHNESS, the state of being sweetish [n]\n",
  "SWEETLIP": "an Australian fish [n -S]\n",
  "SWEETLIPS": "SWEETLIP, an Australian fish [n]\n",
  "SWEETLY": "SWEET, tasting like sugar [adv]\n",
  "SWEETMAN": "(Caribbean) a man kept by a woman [n SWEETMEN]\n",
  "SWEETMEAL": "of biscuits, made of wholemeal and sweetened [adj]\n",
  "SWEETMEAT": "any concoction made mainly or wholly with sugar [n -S]\n",
  "SWEETMEATS": "SWEETMEAT, any concoction made mainly or wholly with sugar [n]\n",
  "SWEETMEN": "SWEETMAN, (Caribbean) a man kept by a woman [n]\n",
  "SWEETNESS": "the state of being sweet [n -ES]\n",
  "SWEETNESSES": "SWEETNESS, the state of being sweet [n]\n",
  "SWEETS": "SWEET, to sweeten [v]\n",
  "SWEETSHOP": "a shop that sells sweets [n -S]\n",
  "SWEETSHOPS": "SWEETSHOP, a shop that sells sweets [n]\n",
  "SWEETSOP": "a tropical American evergreen; its sweet fruit [n -S]\n",
  "SWEETSOPS": "SWEETSOP, a tropical American evergreen; its sweet fruit [n]\n",
  "SWEETVELD": "(South African) a type of grazing characterised by sweet grass [n -S]\n",
  "SWEETVELDS": "SWEETVELD, (South African) a type of grazing characterised by sweet grass [n]\n",
  "SWEETWATER": "freshwater [n -S]\n",
  "SWEETWATERS": "SWEETWATER, freshwater [n]\n",
  "SWEETWOOD": "a South American lauraceous tree [n -S]\n",
  "SWEETWOODS": "SWEETWOOD, a South American lauraceous tree [n]\n",
  "SWEETY": "an attractive person, a poppet, also SWEETIE [n SWEETIES]\n",
  "SWEIR": "(Scots) slothful; grievous, heavy, also SWEER, SWEERED, SWEERT, SWEIRT [adj SWEIRER, SWEIREST] / to swear [v -ED, -ING, -S]\n",
  "SWEIRED": "SWEIR, to swear [v]\n",
  "SWEIRER": "SWEIR, (Scots) slothful; grievous, heavy, also SWEER, SWEERED, SWEERT, SWEIRT [adj]\n",
  "SWEIREST": "SWEIR, (Scots) slothful; grievous, heavy, also SWEER, SWEERED, SWEERT, SWEIRT [adj]\n",
  "SWEIRING": "SWEIR, to swear [v]\n",
  "SWEIRNESS": "(Scots) sloth [n -ES]\n",
  "SWEIRNESSES": "SWEIRNESS, (Scots) sloth [n]\n",
  "SWEIRS": "SWEIR, to swear [v]\n",
  "SWEIRT": "(Scots) slothful; grievous, heavy, also SWEER, SWEERED, SWEERT, SWEIR [adj]\n",
  "SWELCHIE": "(Old Norse) in the Orkneys, a whirlpool; a tidal race [n -S]\n",
  "SWELCHIES": "SWELCHIE, (Old Norse) in the Orkneys, a whirlpool; a tidal race [n]\n",
  "SWELL": "stylish [adj SWELLER, SWELLEST] / to increase in size or volume [v SWELLED, SWOLLEN or (obsolete) SWOLN, SWELLING, SWELLS]\n",
  "SWELLDOM": "the fashionable world [n -S]\n",
  "SWELLDOMS": "SWELLDOM, the fashionable world [n]\n",
  "SWELLED": "SWELL, to increase in size or volume [v]\n",
  "SWELLER": "a member of the fashionable world [n -S]\n",
  "SWELLERS": "SWELLER, a member of the fashionable world [n]\n",
  "SWELLEST": "SWELL, stylish [adj]\n",
  "SWELLFISH": "a fish, the puffer fish [n -ES]\n",
  "SWELLFISHES": "SWELLFISH, a fish, the puffer fish [n]\n",
  "SWELLHEAD": "a conceited person [n -S]\n",
  "SWELLHEADED": "conceited [adj]\n",
  "SWELLHEADEDNESS": "the state of being swellheaded [n]\n",
  "SWELLHEADS": "SWELLHEAD, a conceited person [n]\n",
  "SWELLING": "something that is swollen [n -S]\n",
  "SWELLINGLY": "SWELLING [adv]\n",
  "SWELLINGS": "SWELLING, something that is swollen [n]\n",
  "SWELLISH": "foppish, dandified [adj]\n",
  "SWELLS": "SWELL, to increase in size or volume [v]\n",
  "SWELT": "(dialect) to die, to faint [v -ED, -ING, -S]\n",
  "SWELTED": "SWELT, (dialect) to die, to faint [v]\n",
  "SWELTER": "to suffer from oppressive heat [v -ED, -ING, -S]\n",
  "SWELTERED": "SWELTER, to suffer from oppressive heat [v]\n",
  "SWELTERING": "very hot [adj SWELTERINGLY] / the act of sweltering [n -S]\n",
  "SWELTERINGLY": "SWELTERING [adv]\n",
  "SWELTERINGS": "SWELTERING, the act of sweltering [n]\n",
  "SWELTERS": "SWELTER, to suffer from oppressive heat [v]\n",
  "SWELTING": "SWELT, (dialect) to die, to faint [v]\n",
  "SWELTRIER": "SWELTRY, oppressively hot [adj]\n",
  "SWELTRIEST": "SWELTRY, oppressively hot [adj]\n",
  "SWELTRY": "oppressively hot [adj SWELTRIER, SWELTRIEST]\n",
  "SWELTS": "SWELT, (dialect) to die, to faint [v]\n",
  "SWEPT": "SWEEP, to clean with a broom [v]\n",
  "SWEPTBACK": "of an aircraft, with sweptback wings [adj]\n",
  "SWEPTWING": "with sweptback wings [adj] / an aircraft with sweptback wings [n -S]\n",
  "SWEPTWINGS": "SWEPTWING, an aircraft with sweptback wings [n]\n",
  "SWERF": "(Scots) to faint, also SWARF [v -ED, -ING, -S]\n",
  "SWERFED": "SWERF, (Scots) to faint, also SWARF [v]\n",
  "SWERFING": "SWERF, (Scots) to faint, also SWARF [v]\n",
  "SWERFS": "SWERF, (Scots) to faint, also SWARF [v]\n",
  "SWERVABLE": "capable of being swerved [adj]\n",
  "SWERVE": "to turn aside suddenly from a straight course [v SWERVED, SWERVING, SWERVES]\n",
  "SWERVED": "SWERVE, to turn aside suddenly from a straight course [v]\n",
  "SWERVELESS": "without swerving [adj]\n",
  "SWERVER": "one who swerves [n -S]\n",
  "SWERVERS": "SWERVER, one who swerves [n]\n",
  "SWERVES": "SWERVE, to turn aside suddenly from a straight course [v]\n",
  "SWERVING": "the act of swerving [n -S]\n",
  "SWERVINGS": "SWERVING, the act of swerving [n]\n",
  "SWEVEN": "(obsolete) a dream, vision [n -S]\n",
  "SWEVENS": "SWEVEN, (obsolete) a dream, vision [n]\n",
  "SWEY": "(Scots) to sway, swing, also SWAY, SWEE [v -ED, -ING, -S]\n",
  "SWEYED": "SWEY, (Scots) to sway, swing, also SWAY, SWEE [v]\n",
  "SWEYING": "SWEY, (Scots) to sway, swing, also SWAY, SWEE [v]\n",
  "SWEYS": "SWEY, (Scots) to sway, swing, also SWAY, SWEE [v]\n",
  "SWIDDEN": "(Old Norse) land prepared by burning off cover [n -S]\n",
  "SWIDDENS": "SWIDDEN, (Old Norse) land prepared by burning off cover [n]\n",
  "SWIES": "SWY, (Australian) the Australian game of two-up [n]\n",
  "SWIFT": "rapid [adj SWIFTER, SWIFTEST, SWIFTLY] / to tighten with a rope [v -ED, -ING, -S]\n",
  "SWIFTED": "SWIFT, to tighten with a rope [v]\n",
  "SWIFTER": "a rope used to tighten or keep a thing in place [n -S]\n",
  "SWIFTERS": "SWIFTER, a rope used to tighten or keep a thing in place [n]\n",
  "SWIFTEST": "SWIFT, rapid [adj]\n",
  "SWIFTIE": "(Australian slang) a trick, deception, also SWIFTY [n -S]\n",
  "SWIFTIES": "SWIFTIE, (Australian slang) a trick, deception, also SWIFTY [n]\n",
  "SWIFTING": "SWIFT, to tighten with a rope [v]\n",
  "SWIFTLET": "a cave-dwelling swift (bird) [n -S]\n",
  "SWIFTLETS": "SWIFTLET, a cave-dwelling swift (bird) [n]\n",
  "SWIFTLY": "SWIFT, rapid [adv]\n",
  "SWIFTNESS": "the state of being swift [n -ES]\n",
  "SWIFTNESSES": "SWIFTNESS, the state of being swift [n]\n",
  "SWIFTS": "SWIFT, to tighten with a rope [v]\n",
  "SWIFTY": "(Australian slang) a trick, deception, also SWIFTIE [n SWIFTIES]\n",
  "SWIG": "to drink rapidly [v SWIGGED, SWIGGING, SWIGS]\n",
  "SWIGGED": "SWIG, to drink rapidly [v]\n",
  "SWIGGER": "one who swigs [n -S]\n",
  "SWIGGERS": "SWIGGER, one who swigs [n]\n",
  "SWIGGING": "SWIG, to drink rapidly [v]\n",
  "SWIGS": "SWIG, to drink rapidly [v]\n",
  "SWILE": "a seal (marine animal) [n -S]\n",
  "SWILER": "(Canadian) in Newfoundland, a seal hunter [n -S]\n",
  "SWILERS": "SWILER, (Canadian) in Newfoundland, a seal hunter [n]\n",
  "SWILES": "SWILE, a seal (marine animal) [n]\n",
  "SWILING": "the activity of hunting seals [n -S]\n",
  "SWILINGS": "SWILING, the activity of hunting seals [n]\n",
  "SWILL": "to dash water over or around [v -ED, -ING, -S]\n",
  "SWILLED": "SWILL, to dash water over or around [v]\n",
  "SWILLER": "one who swills [n -S]\n",
  "SWILLERS": "SWILLER, one who swills [n]\n",
  "SWILLING": "the act of swilling [n -S]\n",
  "SWILLINGS": "SWILLING, the act of swilling [n]\n",
  "SWILLS": "SWILL, to dash water over or around [v]\n",
  "SWIM": "to propel oneself in water [v SWAM, SWUM, SWIMMING, SWIMS]\n",
  "SWIMFEEDER": "a device containing bait, attached to the line to ensure the gradual baiting of the swim from under the surface [n -S]\n",
  "SWIMFEEDERS": "SWIMFEEDER, a device containing bait, attached to the line to ensure the gradual baiting of the swim from under the surface [n]\n",
  "SWIMMABLE": "that can be swum [adj]\n",
  "SWIMMER": "one that swims [n -S]\n",
  "SWIMMERET": "a crustacean's abdominal appendage used in swimming [n -S]\n",
  "SWIMMERETS": "SWIMMERET, a crustacean's abdominal appendage used in swimming [n]\n",
  "SWIMMERS": "SWIMMER, one that swims [n]\n",
  "SWIMMIER": "SWIMMY, blurred, swimming [adj]\n",
  "SWIMMIEST": "SWIMMY, blurred, swimming [adj]\n",
  "SWIMMILY": "SWIMMY, blurred, swimming [adv]\n",
  "SWIMMING": "smooth [adj SWIMMINGLY] / the act of swimming [n -S]\n",
  "SWIMMINGLY": "SWIMMING, smooth [adv]\n",
  "SWIMMINGNESS": "the state of being swimming [n -ES]\n",
  "SWIMMINGNESSES": "SWIMMINGNESS, the state of being swimming [n]\n",
  "SWIMMINGS": "SWIMMING, the act of swimming [n]\n",
  "SWIMMY": "blurred, swimming [adj SWIMMIER, SWIMMIEST, SWIMMILY]\n",
  "SWIMS": "SWIM, to propel oneself in water [v]\n",
  "SWIMSUIT": "a bathing suit [n -S]\n",
  "SWIMSUITS": "SWIMSUIT, a bathing suit [n]\n",
  "SWIMWEAR": "garments made for swimming [n -S]\n",
  "SWIMWEARS": "SWIMWEAR, garments made for swimming [n]\n",
  "SWINDGE": "(Shakespeare) to swinge, beat [v SWINDGED, SWINDGING, SWINDGES]\n",
  "SWINDGED": "SWINDGE, (Shakespeare) to swinge, beat [v]\n",
  "SWINDGES": "SWINDGE, (Shakespeare) to swinge, beat [v]\n",
  "SWINDGING": "SWINDGE, (Shakespeare) to swinge, beat [v]\n",
  "SWINDLE": "to take money or property from by fraudulent means [v SWINDLED, SWINDLING, SWINDLES]\n",
  "SWINDLED": "SWINDLE, to take money or property from by fraudulent means [v]\n",
  "SWINDLER": "one who swindles [n -S]\n",
  "SWINDLERS": "SWINDLER, one who swindles [n]\n",
  "SWINDLES": "SWINDLE, to take money or property from by fraudulent means [v]\n",
  "SWINDLING": "the act of swindling [n -S]\n",
  "SWINDLINGS": "SWINDLING, the act of swindling [n]\n",
  "SWINE": "a domestic pig [n SWINES]\n",
  "SWINEHERD": "(archaic) one who looks after pigs [n -S]\n",
  "SWINEHERDS": "SWINEHERD, (archaic) one who looks after pigs [n]\n",
  "SWINEHOOD": "the state of being a pig [n -S]\n",
  "SWINEHOODS": "SWINEHOOD, the state of being a pig [n]\n",
  "SWINELIKE": "like a swine [adj]\n",
  "SWINEPOX": "a disease of swine [n -ES]\n",
  "SWINEPOXES": "SWINEPOX, a disease of swine [n]\n",
  "SWINERIES": "SWINERY, a place where pigs are kept [n]\n",
  "SWINERY": "a place where pigs are kept [n SWINERIES]\n",
  "SWINES": "SWINE, a domestic pig [n]\n",
  "SWINESTONE": "a limestone that gives a fetid urinous smell when struck, also STINKSTONE [n -S]\n",
  "SWINESTONES": "SWINESTONE, a limestone that gives a fetid urinous smell when struck, also STINKSTONE [n]\n",
  "SWING": "to move freely back and forth [v SWUNG or SWANG, SWUNG, SWINGING, SWINGS]\n",
  "SWINGARM": "the part of a motorcycle chassis to which the rear wheel is attached [n -S]\n",
  "SWINGARMS": "SWINGARM, the part of a motorcycle chassis to which the rear wheel is attached [n]\n",
  "SWINGBEAT": "a type of dance music [n -S]\n",
  "SWINGBEATS": "SWINGBEAT, a type of dance music [n]\n",
  "SWINGBIN": "a rubbish bin with a lid that opens when pushed and swings shut [n -S]\n",
  "SWINGBINS": "SWINGBIN, a rubbish bin with a lid that opens when pushed and swings shut [n]\n",
  "SWINGBOAT": "a boat-shaped swinging carriage for fairs etc. [n -S]\n",
  "SWINGBOATS": "SWINGBOAT, a boat-shaped swinging carriage for fairs etc. [n]\n",
  "SWINGBY": "a spacecraft mission which uses gravitational pull [n -S]\n",
  "SWINGBYS": "SWINGBY, a spacecraft mission which uses gravitational pull [n]\n",
  "SWINGE": "to beat, chastise, also SWINDGE [v SWINGED, SWINGEING, SWINGES]\n",
  "SWINGED": "SWINGE, to beat, chastise, also SWINDGE [v]\n",
  "SWINGEING": "SWINGE, to beat, chastise, also SWINDGE [v]\n",
  "SWINGEINGLY": "SWINGEING, SWINGE, to beat, chastise, also SWINDGE [adv]\n",
  "SWINGER": "one that swings [n -S]\n",
  "SWINGERS": "SWINGER, one that swings [n]\n",
  "SWINGES": "SWINGE, to beat, chastise, also SWINDGE [v]\n",
  "SWINGIER": "SWINGY, having swing [adj]\n",
  "SWINGIEST": "SWINGY, having swing [adj]\n",
  "SWINGING": "lively and hip [adj SWINGINGER, SWINGINGEST, SWINGINGLY] / the practice of swapping sex partners [n -S]\n",
  "SWINGINGER": "SWINGING, lively and hip [adj]\n",
  "SWINGINGEST": "SWINGING, lively and hip [adj]\n",
  "SWINGINGLY": "SWINGING, lively and hip [adv]\n",
  "SWINGINGS": "SWINGING, the practice of swapping sex partners [n]\n",
  "SWINGISM": "the ideas of Captain Swing, a fictitious character in whose name rickburners sent threatening letters [n -S]\n",
  "SWINGISMS": "SWINGISM, the ideas of Captain Swing, a fictitious character in whose name rickburners sent threatening letters [n]\n",
  "SWINGLE": "to separate the woody fibre from flax by beating, also SCUTCH [v SWINGLED, SWINGLING, SWINGLES]\n",
  "SWINGLED": "SWINGLE, to separate the woody fibre from flax by beating, also SCUTCH [v]\n",
  "SWINGLES": "SWINGLE, to separate the woody fibre from flax by beating, also SCUTCH [v]\n",
  "SWINGLETREE": "the crosspiece of a carriage to which harnesses are attached, also SINGLETREE, SWINGTREE, WHIFFLETREE, WHIPPLETREE [n -S]\n",
  "SWINGLETREES": "SWINGLETREE, the crosspiece of a carriage to which harnesses are attached, also SINGLETREE, SWINGTREE, WHIFFLETREE, WHIPPLETREE [n]\n",
  "SWINGLING": "the act of swingling, beating flax to separate the fibres [n -S]\n",
  "SWINGLINGS": "SWINGLING, the act of swingling, beating flax to separate the fibres [n]\n",
  "SWINGMAN": "a basketball player who can play guard or forward [n SWINGMEN]\n",
  "SWINGMEN": "SWINGMAN, a basketball player who can play guard or forward [n]\n",
  "SWINGOMETER": "instrument for measuring swing in votes during an election [n -S]\n",
  "SWINGOMETERS": "SWINGOMETER, instrument for measuring swing in votes during an election [n]\n",
  "SWINGS": "SWING, to move freely back and forth [v]\n",
  "SWINGTAIL": "as in swingtail cargo aircraft, an aircraft with tail that swings aside to give access to the full cross-section of the fuselage for rapid loading and unloading of cargo [adj]\n",
  "SWINGTREE": "the crosspiece of a carriage to which harnesses are attached, also SINGLETREE, SWINGLETREE, WHIFFLETREE, WHIPPLETREE [n -S]\n",
  "SWINGTREES": "SWINGTREE, the crosspiece of a carriage to which harnesses are attached, also SINGLETREE, SWINGLETREE, WHIFFLETREE, WHIPPLETREE [n]\n",
  "SWINGY": "having swing [adj SWINGIER, SWINGIEST]\n",
  "SWINISH": "resembling or befitting swine [adj SWINISHLY]\n",
  "SWINISHLY": "SWINISH, resembling or befitting swine [adv]\n",
  "SWINISHNESS": "the state of being swinish [n -ES]\n",
  "SWINISHNESSES": "SWINISHNESS, the state of being swinish [n]\n",
  "SWINK": "(archaic) to toil [v -ED, -ING, -S]\n",
  "SWINKED": "SWINK, (archaic) to toil [v]\n",
  "SWINKER": "a hard worker [n -S]\n",
  "SWINKERS": "SWINKER, a hard worker [n]\n",
  "SWINKING": "SWINK, (archaic) to toil [v]\n",
  "SWINKS": "SWINK, (archaic) to toil [v]\n",
  "SWINNEY": "atrophy of a horse's shoulder muscle, also SWEENEY, SWEENY [n -S]\n",
  "SWINNEYS": "SWINNEY, atrophy of a horse's shoulder muscle, also SWEENEY, SWEENY [n]\n",
  "SWIPE": "to strike with a sweeping blow [v SWIPED, SWIPING, SWIPES]\n",
  "SWIPED": "SWIPE, to strike with a sweeping blow [v]\n",
  "SWIPER": "one who sweeps for old anchors [n -S]\n",
  "SWIPERS": "SWIPER, one who sweeps for old anchors [n]\n",
  "SWIPES": "SWIPE, to strike with a sweeping blow [v]\n",
  "SWIPEY": "fuddled with malt liquor [adj SWIPIER, SWIPIEST]\n",
  "SWIPIER": "SWIPEY, fuddled with malt liquor [adj]\n",
  "SWIPIEST": "SWIPEY, fuddled with malt liquor [adj]\n",
  "SWIPING": "SWIPE, to strike with a sweeping blow [v]\n",
  "SWIPLE": "a part of a threshing device, also SWIPPLE [n -S]\n",
  "SWIPLES": "SWIPLE, a part of a threshing device, also SWIPPLE [n]\n",
  "SWIPPLE": "a part of a threshing device, also SWIPLE [n -S]\n",
  "SWIPPLES": "SWIPPLE, a part of a threshing device, also SWIPLE [n]\n",
  "SWIRE": "a hollow between two hills [n -S]\n",
  "SWIRES": "SWIRE, a hollow between two hills [n]\n",
  "SWIRL": "to move with a whirling motion [v -ED, -ING, -S]\n",
  "SWIRLED": "SWIRL, to move with a whirling motion [v]\n",
  "SWIRLIER": "SWIRLY, swirling [adj]\n",
  "SWIRLIEST": "SWIRLY, swirling [adj]\n",
  "SWIRLING": "SWIRL, to move with a whirling motion [v]\n",
  "SWIRLINGLY": "SWIRLING, SWIRL, to move with a whirling motion [adv]\n",
  "SWIRLS": "SWIRL, to move with a whirling motion [v]\n",
  "SWIRLY": "swirling [adj SWIRLIER, SWIRLIEST]\n",
  "SWISH": "smart, stylish [adj SWISHER, SWISHEST] / to make this sound [v -ED, -ING, -ES]\n",
  "SWISHED": "SWISH, to make this sound [v]\n",
  "SWISHER": "one who swishes [n -S]\n",
  "SWISHERS": "SWISHER, one who swishes [n]\n",
  "SWISHES": "SWISH, to make this sound [v]\n",
  "SWISHEST": "SWISH, smart, stylish [adj]\n",
  "SWISHIER": "SWISHY, swishing [adj]\n",
  "SWISHIEST": "SWISHY, swishing [adj]\n",
  "SWISHING": "making a swishing noise [adj SWISHINGLY] / the act of swishing [n -S]\n",
  "SWISHINGLY": "SWISHING, making a swishing noise [adv]\n",
  "SWISHINGS": "SWISHING, the act of swishing [n]\n",
  "SWISHY": "swishing [adj SWISHIER, SWISHIEST]\n",
  "SWISS": "a cotton fabric [n -ES]\n",
  "SWISSES": "SWISS, a cotton fabric [n]\n",
  "SWISSING": "ordinary calendering of cloth [n -S]\n",
  "SWISSINGS": "SWISSING, ordinary calendering of cloth [n]\n",
  "SWITCH": "to beat with a flexible rod [v -ED, -ING, -ES]\n",
  "SWITCHABLE": "that can be switched [adj]\n",
  "SWITCHBACK": "a zigzag mountain railway on which the train shunted back at each stage [n -S] / to follow a zigzag course esp. for ascent or descent [v -ED, -ING, -S]\n",
  "SWITCHBACKED": "SWITCHBACK, to follow a zigzag course esp. for ascent or descent [v]\n",
  "SWITCHBACKING": "SWITCHBACK, to follow a zigzag course esp. for ascent or descent [v]\n",
  "SWITCHBACKS": "SWITCHBACK, to follow a zigzag course esp. for ascent or descent [v]\n",
  "SWITCHBLADE": "a pocketknife having the blade spring-operated so that pressure on a release catch causes it to fly open [n -S]\n",
  "SWITCHBLADES": "SWITCHBLADE, a pocketknife having the blade spring-operated so that pressure on a release catch causes it to fly open [n]\n",
  "SWITCHBOARD": "a board or frame bearing apparatus for making or breaking an electric current or circuit [n -S]\n",
  "SWITCHBOARDS": "SWITCHBOARD, a board or frame bearing apparatus for making or breaking an electric current or circuit [n]\n",
  "SWITCHED": "SWITCH, to beat with a flexible rod [v]\n",
  "SWITCHEL": "(US) a drink of molasses and water, aka treacle-beer [n -S]\n",
  "SWITCHELS": "SWITCHEL, (US) a drink of molasses and water, aka treacle-beer [n]\n",
  "SWITCHER": "one who switches [n -S]\n",
  "SWITCHEROO": "a surprising variation, a reversal [n -S]\n",
  "SWITCHEROOS": "SWITCHEROO, a surprising variation, a reversal [n]\n",
  "SWITCHERS": "SWITCHER, one who switches [n]\n",
  "SWITCHES": "SWITCH, to beat with a flexible rod [v]\n",
  "SWITCHGEAR": "the apparatus that controls the switches in the electric circuits of a power station [n -S]\n",
  "SWITCHGEARS": "SWITCHGEAR, the apparatus that controls the switches in the electric circuits of a power station [n]\n",
  "SWITCHGIRL": "a women who operates a telephone switchboard [n -S]\n",
  "SWITCHGIRLS": "SWITCHGIRL, a women who operates a telephone switchboard [n]\n",
  "SWITCHGRASS": "a panic grass of the western US that is used for hay [n -ES]\n",
  "SWITCHGRASSES": "SWITCHGRASS, a panic grass of the western US that is used for hay [n]\n",
  "SWITCHIER": "SWITCHY, full of switches [adj]\n",
  "SWITCHIEST": "SWITCHY, full of switches [adj]\n",
  "SWITCHING": "a beating with a flexible rod [n -S]\n",
  "SWITCHINGS": "SWITCHING, a beating with a flexible rod [n]\n",
  "SWITCHLIKE": "like a switch [adj]\n",
  "SWITCHMAN": "a pointsman [n SWITCHMEN]\n",
  "SWITCHMEN": "SWITCHMAN, a pointsman [n]\n",
  "SWITCHOVER": "the act of switching over from one method to another [n -S]\n",
  "SWITCHOVERS": "SWITCHOVER, the act of switching over from one method to another [n]\n",
  "SWITCHY": "full of switches [adj SWITCHIER, SWITCHIEST]\n",
  "SWITCHYARD": "an enclosed area for the switching facilities of a power station [n -S]\n",
  "SWITCHYARDS": "SWITCHYARD, an enclosed area for the switching facilities of a power station [n]\n",
  "SWITH": "(obsolete) quickly, also SWITHE [adv SWITHLY]\n",
  "SWITHE": "(US) quickly, at once, also SWITH [adv]\n",
  "SWITHER": "(Scots) to be undecided [v -ED, -ING, -S]\n",
  "SWITHERED": "SWITHER, (Scots) to be undecided [v]\n",
  "SWITHERING": "SWITHER, (Scots) to be undecided [v]\n",
  "SWITHERS": "SWITHER, (Scots) to be undecided [v]\n",
  "SWITHLY": "quickly, at once [adv]\n",
  "SWITS": "(Shakespeare) a switch [n -ES]\n",
  "SWITSES": "SWITS, (Shakespeare) a switch [n]\n",
  "SWIVE": "(archaic) to have sexual intercourse with [v SWIVED, SWIVING, SWIVES]\n",
  "SWIVED": "SWIVE, (archaic) to have sexual intercourse with [v]\n",
  "SWIVEL": "to turn on a pivoted support [v SWIVELLED or SWIVELED, SWIVELLING or SWIVELING, SWIVELS]\n",
  "SWIVELBLOCK": "a block on which a swivel is mounted [n -S]\n",
  "SWIVELBLOCKS": "SWIVELBLOCK, a block on which a swivel is mounted [n]\n",
  "SWIVELED": "SWIVEL, to turn on a pivoted support [v]\n",
  "SWIVELING": "SWIVEL, to turn on a pivoted support [v]\n",
  "SWIVELLED": "SWIVEL, to turn on a pivoted support [v]\n",
  "SWIVELLING": "SWIVEL, to turn on a pivoted support [v]\n",
  "SWIVELS": "SWIVEL, to turn on a pivoted support [v]\n",
  "SWIVES": "SWIVE, (archaic) to have sexual intercourse with [v]\n",
  "SWIVET": "(dialect) a state of extreme agitation [n -S]\n",
  "SWIVETS": "SWIVET, (dialect) a state of extreme agitation [n]\n",
  "SWIVING": "SWIVE, (archaic) to have sexual intercourse with [v]\n",
  "SWIZ": "to defraud, also SWIZZ [v SWIZZED, SWIZZING, SWIZZES]\n",
  "SWIZZ": "to defraud, also SWIZ [v -ED, -ING, -ES]\n",
  "SWIZZED": "SWIZZ, to defraud, also SWIZ [v]\n",
  "SWIZZES": "SWIZZ, to defraud, also SWIZ [v]\n",
  "SWIZZING": "SWIZZ, to defraud, also SWIZ [v]\n",
  "SWIZZLE": "to defraud, cheat [v SWIZZLED, SWIZZLING, SWIZZLES]\n",
  "SWIZZLED": "SWIZZLE, to defraud, cheat [v]\n",
  "SWIZZLER": "one that swizzles, swindles [n -S]\n",
  "SWIZZLERS": "SWIZZLER, one that swizzles, swindles [n]\n",
  "SWIZZLES": "SWIZZLE, to defraud, cheat [v]\n",
  "SWIZZLING": "SWIZZLE, to defraud, cheat [v]\n",
  "SWOB": "to mop up [v SWOBBED, SWOBBING, SWOBS]\n",
  "SWOBBED": "SWOB, to mop up [v]\n",
  "SWOBBER": "a sweeper of the deck of a ship, also SWABBER [n -S]\n",
  "SWOBBERS": "SWOBBER, a sweeper of the deck of a ship, also SWABBER [n]\n",
  "SWOBBING": "SWOB, to mop up [v]\n",
  "SWOBS": "SWOB, to mop up [v]\n",
  "SWOFFER": "someone who engages in salt water fly fishing [n -S]\n",
  "SWOFFERS": "SWOFFER, someone who engages in salt water fly fishing [n]\n",
  "SWOFFING": "the sport of saltwater fly-fishing [n -S]\n",
  "SWOFFINGS": "SWOFFING, the sport of saltwater fly-fishing [n]\n",
  "SWOLE": "having well-developed muscles as a result of weight training [adj SWOLER, SWOLEST]\n",
  "SWOLER": "SWOLE, having well-developed muscles as a result of weight training [adj]\n",
  "SWOLEST": "SWOLE, having well-developed muscles as a result of weight training [adj]\n",
  "SWOLLEN": "SWELL, to increase in size or volume [v]\n",
  "SWOLLENLY": "SWOLLEN, SWELL, to increase in size or volume [adv]\n",
  "SWOLLENNESS": "the state of being swollen [n -ES]\n",
  "SWOLLENNESSES": "SWOLLENNESS, the state of being swollen [n]\n",
  "SWOLN": "SWELL, to increase in size or volume [v]\n",
  "SWOON": "to faint, also SWOUN, SWOUND [v -ED, -ING, -S]\n",
  "SWOONED": "SWOON, to faint, also SWOUN, SWOUND [v]\n",
  "SWOONER": "one who swoons [n -S]\n",
  "SWOONERS": "SWOONER, one who swoons [n]\n",
  "SWOONIER": "SWOONY, languid, dazed [adj]\n",
  "SWOONIEST": "SWOONY, languid, dazed [adj]\n",
  "SWOONING": "fainting [adj SWOONINGLY] / the act of swooning [n -S]\n",
  "SWOONINGLY": "SWOONING, fainting [adv]\n",
  "SWOONINGS": "SWOONING, the act of swooning [n]\n",
  "SWOONS": "SWOON, to faint, also SWOUN, SWOUND [v]\n",
  "SWOONY": "languid, dazed [adj SWOONIER, SWOONIEST]\n",
  "SWOOP": "to make a sudden descent [v -ED, -ING, -S]\n",
  "SWOOPED": "SWOOP, to make a sudden descent [v]\n",
  "SWOOPER": "one who swoops [n -S]\n",
  "SWOOPERS": "SWOOPER, one who swoops [n]\n",
  "SWOOPIER": "SWOOPY, having sweeping lines or features [adj]\n",
  "SWOOPIEST": "SWOOPY, having sweeping lines or features [adj]\n",
  "SWOOPING": "SWOOP, to make a sudden descent [v]\n",
  "SWOOPS": "SWOOP, to make a sudden descent [v]\n",
  "SWOOPSTAKE": "(archaic) in an indiscriminate manner [adj]\n",
  "SWOOPY": "having sweeping lines or features [adj SWOOPIER, SWOOPIEST]\n",
  "SWOOSH": "to make a noise like a rush or air or water [v -ED, -ING, -ES]\n",
  "SWOOSHED": "SWOOSH, to make a noise like a rush or air or water [v]\n",
  "SWOOSHES": "SWOOSH, to make a noise like a rush or air or water [v]\n",
  "SWOOSHING": "SWOOSH, to make a noise like a rush or air or water [v]\n",
  "SWOP": "to barter, give in exchange, also SWAP [v SWOPPED or SWOPT, SWOPPING, SWOPS]\n",
  "SWOPPABLE": "capable of being swoppe, also SWAPPABLE [adj]\n",
  "SWOPPED": "SWOP, to barter, give in exchange, also SWAP [v]\n",
  "SWOPPER": "one who swops [n -S]\n",
  "SWOPPERS": "SWOPPER, one who swops [n]\n",
  "SWOPPING": "the act of swopping [n -S]\n",
  "SWOPPINGS": "SWOPPING, the act of swopping [n]\n",
  "SWOPS": "SWOP, to barter, give in exchange, also SWAP [v]\n",
  "SWOPT": "SWOP, to barter, give in exchange, also SWAP [v]\n",
  "SWORD": "a weapon with a long blade [n -S] / to wield a sword [v -ED, -ING, -S]\n",
  "SWORDBEARER": "one who carries a sword [n -S]\n",
  "SWORDBEARERS": "SWORDBEARER, one who carries a sword [n]\n",
  "SWORDBILL": "a kind of South American hummingbird [n -S]\n",
  "SWORDBILLS": "SWORDBILL, a kind of South American hummingbird [n]\n",
  "SWORDCRAFT": "skill at making swords [n -S]\n",
  "SWORDCRAFTS": "SWORDCRAFT, skill at making swords [n]\n",
  "SWORDED": "SWORD, to wield a sword [v]\n",
  "SWORDER": "(archaic) a gladiator, a swordsman [n -S]\n",
  "SWORDERS": "SWORDER, (archaic) a gladiator, a swordsman [n]\n",
  "SWORDFERN": "any of several ferns with long narrow fronds [n -S]\n",
  "SWORDFERNS": "SWORDFERN, any of several ferns with long narrow fronds [n]\n",
  "SWORDFISH": "a large fish with upper jaw compressed and prolonged as a stabbing weapon [n -ES]\n",
  "SWORDFISHES": "SWORDFISH, a large fish with upper jaw compressed and prolonged as a stabbing weapon [n]\n",
  "SWORDING": "SWORD, to wield a sword [v]\n",
  "SWORDLESS": "without a sword [adj]\n",
  "SWORDLIKE": "like a sword [adj]\n",
  "SWORDMAN": "one who wields a sword, also SWORDSMAN [n SWORDMEN]\n",
  "SWORDMEN": "SWORDMAN, one who wields a sword, also SWORDSMAN [n]\n",
  "SWORDPLAY": "fighting with swords [n -S]\n",
  "SWORDPLAYER": "one who engages in swordplay [n -S]\n",
  "SWORDPLAYERS": "SWORDPLAYER, one who engages in swordplay [n]\n",
  "SWORDPLAYS": "SWORDPLAY, fighting with swords [n]\n",
  "SWORDPROOF": "proof against swords [adj]\n",
  "SWORDS": "SWORD, a weapon with a long blade [n]\n",
  "SWORDSMAN": "one who wields a sword, also SWORDMAN [n SWORDSMEN]\n",
  "SWORDSMANSHIP": "the skills of the swordsman [n -S]\n",
  "SWORDSMANSHIPS": "SWORDSMANSHIP, the skills of the swordsman [n]\n",
  "SWORDSMEN": "SWORDSMAN, one who wields a sword, also SWORDMAN [n]\n",
  "SWORDSTICK": "a hollow walking stick containing a short sword or dagger [n -S]\n",
  "SWORDSTICKS": "SWORDSTICK, a hollow walking stick containing a short sword or dagger [n]\n",
  "SWORDSWOMAN": "a woman who uses a sword [n SWORDSWOMEN]\n",
  "SWORDSWOMEN": "SWORDSWOMAN, a woman who uses a sword [n]\n",
  "SWORDTAIL": "a small Central American freshwater fish [n -S]\n",
  "SWORDTAILS": "SWORDTAIL, a small Central American freshwater fish [n]\n",
  "SWORE": "SWEAR, to utter a solemn oath [v]\n",
  "SWORN": "SWEAR, to utter a solemn oath [v]\n",
  "SWOT": "to study hard [v SWOTTED, SWOTTING, SWOTS]\n",
  "SWOTS": "SWOT, to study hard [v]\n",
  "SWOTTED": "SWOT, to study hard [v]\n",
  "SWOTTER": "one who swots [n -S]\n",
  "SWOTTERS": "SWOTTER, one who swots [n]\n",
  "SWOTTIER": "SWOTTY, given to hard study, also SWATTY [adj]\n",
  "SWOTTIEST": "SWOTTY, given to hard study, also SWATTY [adj]\n",
  "SWOTTING": "the act of swotting [n -S]\n",
  "SWOTTINGS": "SWOTTING, the act of swotting [n]\n",
  "SWOTTY": "given to hard study, also SWATTY [adj SWOTTIER, SWOTTIEST]\n",
  "SWOUN": "to faint, also SWOON, SWOUND [v -ED, -ING, -S]\n",
  "SWOUND": "to faint, also SWOON, SWOUN [v -ED, -ING, -S]\n",
  "SWOUNDED": "SWOUND, to faint, also SWOON, SWOUN [v]\n",
  "SWOUNDING": "SWOUND, to faint, also SWOON, SWOUN [v]\n",
  "SWOUNDS": "SWOUND, to faint, also SWOON, SWOUN [v]\n",
  "SWOUNE": "(Spenser) to swoon [v SWOUNED, SWOUNING, SWOUNES]\n",
  "SWOUNED": "SWOUN, to faint, also SWOON, SWOUND [v]\n",
  "SWOUNES": "SWOUNE, (Spenser) to swoon [v]\n",
  "SWOUNING": "SWOUN, to faint, also SWOON, SWOUND [v]\n",
  "SWOUNS": "SWOUN, to faint, also SWOON, SWOUND [v]\n",
  "SWOWND": "(Spenser) a fainting fit, also SWOUNE, SWOWNE [n -S]\n",
  "SWOWNDS": "SWOWND, (Spenser) a fainting fit, also SWOUNE, SWOWNE [n]\n",
  "SWOWNE": "(Spenser) a fainting fit, also SWOUNE, SWOWND [n -S]\n",
  "SWOWNES": "SWOWNE, (Spenser) a fainting fit, also SWOUNE, SWOWND [n]\n",
  "SWOZZLE": "an instrument which produces Mr Punch's voice, also SWAZZLE [n -S]\n",
  "SWOZZLES": "SWOZZLE, an instrument which produces Mr Punch's voice, also SWAZZLE [n]\n",
  "SWUM": "SWIM, to propel oneself in water [v]\n",
  "SWUNG": "SWING, to move freely back and forth [v]\n",
  "SWY": "(Australian) the Australian game of two-up [n SWIES]\n",
  "SYBARITE": "a person devoted to pleasure and luxury [n -S]\n",
  "SYBARITES": "SYBARITE, a person devoted to pleasure and luxury [n]\n",
  "SYBARITIC": "like a sybarite, devoted to luxury, also SYBARITICAL, SYBARITISH [adj SYBARITICALLY]\n",
  "SYBARITICAL": "like a sybarite, devoted to luxury, also SYBARITIC, SYBARITISH [adj SYBARITICALLY]\n",
  "SYBARITICALLY": "SYBARITICAL, like a sybarite, devoted to luxury, also SYBARITIC, SYBARITISH [adv]\n",
  "SYBARITISH": "like a sybarite, devoted to luxury, also SYBARITIC, SYBARITICAL [adj]\n",
  "SYBARITISM": "devotion to luxury [n -S]\n",
  "SYBARITISMS": "SYBARITISM, devotion to luxury [n]\n",
  "SYBBE": "(Spenser) a blood relation, a kinsman, also SIB, SIBB [n -S]\n",
  "SYBBES": "SYBBE, (Spenser) a blood relation, a kinsman, also SIB, SIBB [n]\n",
  "SYBIL": "(Greek) any of various women in classical antiquity supposed to utter the oracles and prophecies of a god, also SIBYL [n -S]\n",
  "SYBILS": "SYBIL, (Greek) any of various women in classical antiquity supposed to utter the oracles and prophecies of a god, also SIBYL [n]\n",
  "SYBO": "(Scots) a spring onion, also CHIBOL, CIBOL, CIBOULE, SYBOE, SYBOW [n -ES]\n",
  "SYBOE": "(Scots) a spring onion, also CHIBOL, CIBOL, CIBOULE, SYBO, SYBOW [n -S]\n",
  "SYBOES": "SYBO, (Scots) a spring onion, also CHIBOL, CIBOL, CIBOULE, SYBOE, SYBOW [n]\n",
  "SYBOTIC": "(Greek) pertaining to a swine herd [adj]\n",
  "SYBOTISM": "the study of swine herds [n -S]\n",
  "SYBOTISMS": "SYBOTISM, the study of swine herds [n]\n",
  "SYBOW": "(Scots) a spring onion, also CHIBOL, CIBOL, CIBOULE, SYBO, SYBOE [n -S]\n",
  "SYBOWS": "SYBOW, (Scots) a spring onion, also CHIBOL, CIBOL, CIBOULE, SYBO, SYBOE [n]\n",
  "SYCAMINE": "the mulberry tree [n -S]\n",
  "SYCAMINES": "SYCAMINE, the mulberry tree [n]\n",
  "SYCAMORE": "the great maple [n -S]\n",
  "SYCAMORES": "SYCAMORE, the great maple [n]\n",
  "SYCE": "(Arabic) a male servant in India, also SAICE, SICE [n -S]\n",
  "SYCEE": "(Chinese) lumps of pure silver bearing the stamp of a banker or assayer and formerly used as money in China [n -S]\n",
  "SYCEES": "SYCEE, (Chinese) lumps of pure silver bearing the stamp of a banker or assayer and formerly used as money in China [n]\n",
  "SYCES": "SYCE, (Arabic) a male servant in India, also SAICE, SICE [n]\n",
  "SYCOMORE": "a kind of fig tree [n -S]\n",
  "SYCOMORES": "SYCOMORE, a kind of fig tree [n]\n",
  "SYCON": "a type of sponge [n -S]\n",
  "SYCONIA": "SYCONIUM, (Greek) a form of fruit with ovaries on an enlarged receptacle [n]\n",
  "SYCONIUM": "(Greek) a form of fruit with ovaries on an enlarged receptacle [n SYCONIA]\n",
  "SYCONOID": "of or like a sycon, a type of sponge [adj]\n",
  "SYCONS": "SYCON, a type of sponge [n]\n",
  "SYCOPHANCIES": "SYCOPHANCY, obsequious flattery [n]\n",
  "SYCOPHANCY": "obsequious flattery [n SYCOPHANCIES]\n",
  "SYCOPHANT": "one who attempts to gain a personal advantage by servile flattery [n -S]\n",
  "SYCOPHANTIC": "of or like a sycophant, also SYCOPHANTICAL [adj SYCOPHANTICALLY]\n",
  "SYCOPHANTICAL": "(obsolete) sycophantic, also SYCOPHANTIC [adj SYCOPHANTICALLY]\n",
  "SYCOPHANTICALLY": "SYCOPHANTICAL, (obsolete) sycophantic, also SYCOPHANTIC [adv]\n",
  "SYCOPHANTISE": "to be a sycophant, also SYCOPHANTIZE [v SYCOPHANTISED, SYCOPHANTISING, SYCOPHANTISES]\n",
  "SYCOPHANTISED": "SYCOPHANTISE, to be a sycophant, also SYCOPHANTIZE [v]\n",
  "SYCOPHANTISES": "SYCOPHANTISE, to be a sycophant, also SYCOPHANTIZE [v]\n",
  "SYCOPHANTISH": "like a sycophant [adj]\n",
  "SYCOPHANTISHLY": "SYCOPHANTISH, like a sycophant [adv]\n",
  "SYCOPHANTISING": "SYCOPHANTISE, to be a sycophant, also SYCOPHANTIZE [v]\n",
  "SYCOPHANTISM": "sycophancy [n -S]\n",
  "SYCOPHANTISMS": "SYCOPHANTISM, sycophancy [n]\n",
  "SYCOPHANTIZE": "to be a sycophant, also SYCOPHANTISE [v SYCOPHANTIZED, SYCOPHANTIZING, SYCOPHANTIZES]\n",
  "SYCOPHANTIZED": "SYCOPHANTIZE, to be a sycophant, also SYCOPHANTISE [v]\n",
  "SYCOPHANTIZES": "SYCOPHANTIZE, to be a sycophant, also SYCOPHANTISE [v]\n",
  "SYCOPHANTIZING": "SYCOPHANTIZE, to be a sycophant, also SYCOPHANTISE [v]\n",
  "SYCOPHANTLIER": "SYCOPHANTLY, like a sycophant [adj]\n",
  "SYCOPHANTLIEST": "SYCOPHANTLY, like a sycophant [adj]\n",
  "SYCOPHANTLY": "like a sycophant [adj SYCOPHANTLIER, SYCOPHANTLIEST]\n",
  "SYCOPHANTRIES": "SYCOPHANTRY, flattery [n]\n",
  "SYCOPHANTRY": "flattery [n SYCOPHANTRIES]\n",
  "SYCOPHANTS": "SYCOPHANT, one who attempts to gain a personal advantage by servile flattery [n]\n",
  "SYCOSES": "SYCOSIS, (Greek) an inflammatory disease of the hair follicles [n]\n",
  "SYCOSIS": "(Greek) an inflammatory disease of the hair follicles [n SYCOSES]\n",
  "SYE": "to strain [v SYED, SYEING, SYES]\n",
  "SYED": "SYE, to strain [v]\n",
  "SYEING": "SYE, to strain [v]\n",
  "SYEN": "(Shakespeare) a scion, also CION, SEYEN, SIEN, SIENT [n -S]\n",
  "SYENITE": "a coarse-grained igneous rock, allied to granite, also SIENITE [n -S]\n",
  "SYENITES": "SYENITE, a coarse-grained igneous rock, allied to granite, also SIENITE [n]\n",
  "SYENITIC": "of or like syenite, a kind of igneous rock [adj]\n",
  "SYENS": "SYEN, (Shakespeare) a scion, also CION, SEYEN, SIEN, SIENT [n]\n",
  "SYES": "SYE, to strain [v]\n",
  "SYKE": "a rill or small ditch, also SIKE [n -S]\n",
  "SYKER": "(Spenser) sure, certain, also SICCAR, SICKER, SIKER [adj]\n",
  "SYKES": "SYKE, a rill or small ditch, also SIKE [n]\n",
  "SYLI": "a former monetary unit of Guinea [n -S]\n",
  "SYLIS": "SYLI, a former monetary unit of Guinea [n]\n",
  "SYLLABARIA": "SYLLABARIUM, a syllabary [n]\n",
  "SYLLABARIES": "SYLLABARY, a system of writing composed of a set of symbols representing syllables [n]\n",
  "SYLLABARIUM": "a syllabary [n SYLLABARIA]\n",
  "SYLLABARY": "a system of writing composed of a set of symbols representing syllables [n SYLLABARIES]\n",
  "SYLLABI": "SYLLABUS, (Latin) an outline of a course of study [n]\n",
  "SYLLABIC": "relating to syllables, also SYLLABICAL [adj SYLLABICALLY] / a syllabic sound; a unit of sound capable by itself of forming a syllable [n -S]\n",
  "SYLLABICAL": "(obsolete) syllabic, also SYLLABIC [adj SYLLABICALLY]\n",
  "SYLLABICALLY": "SYLLABICAL, (obsolete) syllabic, also SYLLABIC [adv]\n",
  "SYLLABICATE": "to syllabify [v SYLLABICATED, SYLLABICATING, SYLLABICATES]\n",
  "SYLLABICATED": "SYLLABICATE, to syllabify [v]\n",
  "SYLLABICATES": "SYLLABICATE, to syllabify [v]\n",
  "SYLLABICATING": "SYLLABICATE, to syllabify [v]\n",
  "SYLLABICATION": "the act of dividing words into syllables, also SYLLABIFICATION [n -S]\n",
  "SYLLABICATIONS": "SYLLABICATION, the act of dividing words into syllables, also SYLLABIFICATION [n]\n",
  "SYLLABICITIES": "SYLLABICITY, the state of being in syllables [n]\n",
  "SYLLABICITY": "the state of being in syllables [n SYLLABICITIES]\n",
  "SYLLABICS": "SYLLABIC, a syllabic sound; a unit of sound capable by itself of forming a syllable [n]\n",
  "SYLLABIFICATION": "the act of dividing words into syllables, also SYLLABICATION [n]\n",
  "SYLLABIFIED": "SYLLABIFY, to divide into syllables [v]\n",
  "SYLLABIFIES": "SYLLABIFY, to divide into syllables [v]\n",
  "SYLLABIFY": "to divide into syllables [v SYLLABIFIED, SYLLABIFYING, SYLLABIFIES]\n",
  "SYLLABIFYING": "SYLLABIFY, to divide into syllables [v]\n",
  "SYLLABISE": "to form or divide into syllables, also SYLLABIZE [v SYLLABISED, SYLLABISING, SYLLABISES]\n",
  "SYLLABISED": "SYLLABISE, to form or divide into syllables, also SYLLABIZE [v]\n",
  "SYLLABISES": "SYLLABISE, to form or divide into syllables, also SYLLABIZE [v]\n",
  "SYLLABISING": "SYLLABISE, to form or divide into syllables, also SYLLABIZE [v]\n",
  "SYLLABISM": "use of a writing system consisting of characters for syllables rather than for individual sounds or whole words [n -S]\n",
  "SYLLABISMS": "SYLLABISM, use of a writing system consisting of characters for syllables rather than for individual sounds or whole words [n]\n",
  "SYLLABIZE": "to form or divide into syllables, also SYLLABISE [v SYLLABIZED, SYLLABIZING, SYLLABIZES]\n",
  "SYLLABIZED": "SYLLABIZE, to form or divide into syllables, also SYLLABISE [v]\n",
  "SYLLABIZES": "SYLLABIZE, to form or divide into syllables, also SYLLABISE [v]\n",
  "SYLLABIZING": "SYLLABIZE, to form or divide into syllables, also SYLLABISE [v]\n",
  "SYLLABLE": "to pronounce units of spoken language [v SYLLABLED, SYLLABLING, SYLLABLES]\n",
  "SYLLABLED": "SYLLABLE, to pronounce units of spoken language [v]\n",
  "SYLLABLES": "SYLLABLE, to pronounce units of spoken language [v]\n",
  "SYLLABLING": "SYLLABLE, to pronounce units of spoken language [v]\n",
  "SYLLABOGRAM": "a written symbol representing a single syllable [n -S]\n",
  "SYLLABOGRAMS": "SYLLABOGRAM, a written symbol representing a single syllable [n]\n",
  "SYLLABOGRAPHIES": "SYLLABOGRAPHY, use of a writing system consisting of characters for syllables rather than for individual sounds or whole words [n]\n",
  "SYLLABOGRAPHY": "use of a writing system consisting of characters for syllables rather than for individual sounds or whole words [n SYLLABOGRAPHIES]\n",
  "SYLLABUB": "a frothy dish of cream curdled with wine, also SILLABUB, SILLIBUB [n -S]\n",
  "SYLLABUBS": "SYLLABUB, a frothy dish of cream curdled with wine, also SILLABUB, SILLIBUB [n]\n",
  "SYLLABUS": "(Latin) an outline of a course of study [n SYLLABUSES or SYLLABI]\n",
  "SYLLABUSES": "SYLLABUS, (Latin) an outline of a course of study [n]\n",
  "SYLLEPSES": "SYLLEPSIS, (Greek) a construction in which a word governs two or more other words but agrees in number, gender, or case with only one, or has a different meaning when applied to each of the words, as in 'He lost his coat and his temper' [n]\n",
  "SYLLEPSIS": "(Greek) a construction in which a word governs two or more other words but agrees in number, gender, or case with only one, or has a different meaning when applied to each of the words, as in 'He lost his coat and his temper' [n SYLLEPSES]\n",
  "SYLLEPTIC": "relating to syllepsis, a construction in which a word governs two or more other words, also SYLLEPTICAL [adj SYLLEPTICALLY]\n",
  "SYLLEPTICAL": "relating to syllepsis, a construction in which a word governs two or more other words, also SYLLEPTIC [adj SYLLEPTICALLY]\n",
  "SYLLEPTICALLY": "SYLLEPTICAL, relating to syllepsis, a construction in which a word governs two or more other words, also SYLLEPTIC [adv]\n",
  "SYLLOGE": "a collection or summary [n -S]\n",
  "SYLLOGES": "SYLLOGE, a collection or summary [n]\n",
  "SYLLOGISATION": "the process of syllogising, also SYLLOGIZATION [n -S]\n",
  "SYLLOGISATIONS": "SYLLOGISATION, the process of syllogising, also SYLLOGIZATION [n]\n",
  "SYLLOGISE": "to reason by syllogisms, also SYLLOGIZE [v SYLLOGISED, SYLLOGISING, SYLLOGISES]\n",
  "SYLLOGISED": "SYLLOGISE, to reason by syllogisms, also SYLLOGIZE [v]\n",
  "SYLLOGISER": "one who reasons by syllogisms, also SYLLOGIZER [n -S]\n",
  "SYLLOGISERS": "SYLLOGISER, one who reasons by syllogisms, also SYLLOGIZER [n]\n",
  "SYLLOGISES": "SYLLOGISE, to reason by syllogisms, also SYLLOGIZE [v]\n",
  "SYLLOGISING": "SYLLOGISE, to reason by syllogisms, also SYLLOGIZE [v]\n",
  "SYLLOGISM": "an argument in which two premises lead to a logical conclusion [n -S]\n",
  "SYLLOGISMS": "SYLLOGISM, an argument in which two premises lead to a logical conclusion [n]\n",
  "SYLLOGIST": "one who reasons by syllogisms [n -S]\n",
  "SYLLOGISTIC": "relating to syllogism, an argument in which two premises lead to a logical conclusion [adj]\n",
  "SYLLOGISTICAL": "of or like a syllogism [adj SYLLOGISTICALLY]\n",
  "SYLLOGISTICALLY": "SYLLOGISTICAL, of or like a syllogism [adv]\n",
  "SYLLOGISTICS": "the branch of logic concerned with syllogisms [n]\n",
  "SYLLOGISTS": "SYLLOGIST, one who reasons by syllogisms [n]\n",
  "SYLLOGIZATION": "the process of syllogizing, also SYLLOGISATION [n -S]\n",
  "SYLLOGIZATIONS": "SYLLOGIZATION, the process of syllogizing, also SYLLOGISATION [n]\n",
  "SYLLOGIZE": "to reason by syllogisms, also SYLLOGISE [v SYLLOGIZED, SYLLOGIZING, SYLLOGIZES]\n",
  "SYLLOGIZED": "SYLLOGIZE, to reason by syllogisms, also SYLLOGISE [v]\n",
  "SYLLOGIZER": "one who reasons by syllogisms, also SYLLOGISER [n -S]\n",
  "SYLLOGIZERS": "SYLLOGIZER, one who reasons by syllogisms, also SYLLOGISER [n]\n",
  "SYLLOGIZES": "SYLLOGIZE, to reason by syllogisms, also SYLLOGISE [v]\n",
  "SYLLOGIZING": "SYLLOGIZE, to reason by syllogisms, also SYLLOGISE [v]\n",
  "SYLPH": "a slender, graceful girl or woman [n -S]\n",
  "SYLPHIC": "of or like a sylph [adj]\n",
  "SYLPHID": "a young sylph, also SYLPHIDE [n -S]\n",
  "SYLPHIDE": "a young sylph, also SYLPHID [n -S]\n",
  "SYLPHIDES": "SYLPHIDE, a young sylph, also SYLPHID [n]\n",
  "SYLPHIDINE": "like a sylphid, a little sylph [adj]\n",
  "SYLPHIDS": "SYLPHID, a young sylph, also SYLPHIDE [n]\n",
  "SYLPHIER": "SYLPHY, like a sylph [adj]\n",
  "SYLPHIEST": "SYLPHY, like a sylph [adj]\n",
  "SYLPHINE": "pertaining to a sylph, a spirit of the air [adj]\n",
  "SYLPHISH": "sylphlike [adj]\n",
  "SYLPHLIKE": "like a sylph [adj]\n",
  "SYLPHS": "SYLPH, a slender, graceful girl or woman [n]\n",
  "SYLPHY": "like a sylph [adj SYLPHIER, SYLPHIEST]\n",
  "SYLVA": "(Latin) the forest trees of an area, also SILVA [n SYLVAS or SYLVAE]\n",
  "SYLVAE": "SYLVA, (Latin) the forest trees of an area, also SILVA [n]\n",
  "SYLVAN": "one that lives in a forest, also SILVAN [n -S]\n",
  "SYLVANER": "(German) a German grape used in making white wine; the wine itself [n -S]\n",
  "SYLVANERS": "SYLVANER, (German) a German grape used in making white wine; the wine itself [n]\n",
  "SYLVANITE": "a monoclinic telluride of gold and silver that occurs as silver or yellow crystals or masses with metallic lustre [n -S]\n",
  "SYLVANITES": "SYLVANITE, a monoclinic telluride of gold and silver that occurs as silver or yellow crystals or masses with metallic lustre [n]\n",
  "SYLVANS": "SYLVAN, one that lives in a forest, also SILVAN [n]\n",
  "SYLVAS": "SYLVA, (Latin) the forest trees of an area, also SILVA [n]\n",
  "SYLVATIC": "relating to woodland, also SILVATIC [adj]\n",
  "SYLVESTRAL": "of a plant, growing typically in woods or bushy places [adj]\n",
  "SYLVESTRIAN": "relating to woodland, also SILVESTRIAN [adj]\n",
  "SYLVIA": "(Latin) any warbler of the genus Sylvia [n -S]\n",
  "SYLVIAS": "SYLVIA, (Latin) any warbler of the genus Sylvia [n]\n",
  "SYLVICULTURAL": "relating to sylviculture, also SILVICULTURAL [adj]\n",
  "SYLVICULTURE": "the growing of trees, also SILVICULTURE [n -S]\n",
  "SYLVICULTURES": "SYLVICULTURE, the growing of trees, also SILVICULTURE [n]\n",
  "SYLVIINE": "of the thrush family [adj]\n",
  "SYLVIN": "a native potassium chloride, a source of potash, also SYLVINE, SYLVITE [n -S]\n",
  "SYLVINE": "a native potassium chloride, a source of potash, also SYLVIN, SYLVITE [n -S]\n",
  "SYLVINES": "SYLVINE, a native potassium chloride, a source of potash, also SYLVIN, SYLVITE [n]\n",
  "SYLVINITE": "a rock composed of sylvine and rock salt [n -S]\n",
  "SYLVINITES": "SYLVINITE, a rock composed of sylvine and rock salt [n]\n",
  "SYLVINS": "SYLVIN, a native potassium chloride, a source of potash, also SYLVINE, SYLVITE [n]\n",
  "SYLVITE": "a native potassium chloride, a source of potash, also SYLVIN, SYLVINE [n -S]\n",
  "SYLVITES": "SYLVITE, a native potassium chloride, a source of potash, also SYLVIN, SYLVINE [n]\n",
  "SYMAR": "a loose coat, an undergarment formerly worn by women, also CIMAR, CYMAR, SIMAR, SIMARRE [n -S]\n",
  "SYMARS": "SYMAR, a loose coat, an undergarment formerly worn by women, also CIMAR, CYMAR, SIMAR, SIMARRE [n]\n",
  "SYMBION": "(Greek) an organism living in close association with another, also SYMBIONT, SYMBIOT, SYMBIOTE [n -S]\n",
  "SYMBIONS": "SYMBION, (Greek) an organism living in close association with another, also SYMBIONT, SYMBIOT, SYMBIOTE [n]\n",
  "SYMBIONT": "(Greek) an organism living in close association with another, also SYMBION, SYMBIOT, SYMBIOTE [n -S]\n",
  "SYMBIONTIC": "of or like a symbiont [adj SYMBIONTICALLY]\n",
  "SYMBIONTICALLY": "SYMBIONTIC, of or like a symbiont [adv]\n",
  "SYMBIONTS": "SYMBIONT, (Greek) an organism living in close association with another, also SYMBION, SYMBIOT, SYMBIOTE [n]\n",
  "SYMBIOSES": "SYMBIOSIS, a relationship of mutually beneficial or dependence [n]\n",
  "SYMBIOSIS": "a relationship of mutually beneficial or dependence [n SYMBIOSES]\n",
  "SYMBIOT": "(Greek) an organism living in close association with another, also SYMBIONT, SYMBION, SYMBIOTE [n -S]\n",
  "SYMBIOTE": "(Greek) an organism living in close association with another, also SYMBIONT, SYMBION, SYMBIOT [n -S]\n",
  "SYMBIOTES": "SYMBIOTE, (Greek) an organism living in close association with another, also SYMBIONT, SYMBION, SYMBIOT [n]\n",
  "SYMBIOTIC": "relating to symbiosis, also SYMBIOTICAL [adj SYMBIOTICALLY]\n",
  "SYMBIOTICAL": "relating to symbiosis, also SYMBIOTIC [adj SYMBIOTICALLY]\n",
  "SYMBIOTICALLY": "SYMBIOTICAL, relating to symbiosis, also SYMBIOTIC [adv]\n",
  "SYMBIOTS": "SYMBIOT, (Greek) an organism living in close association with another, also SYMBIONT, SYMBION, SYMBIOTE [n]\n",
  "SYMBOL": "to serve as a representation [v SYMBOLED or SYMBOLLED, SYMBOLING or SYMBOLLING, SYMBOLS]\n",
  "SYMBOLE": "(obsolete) a cymbal [n -S]\n",
  "SYMBOLED": "SYMBOL, to serve as a representation [v]\n",
  "SYMBOLES": "SYMBOLE, (obsolete) a cymbal [n]\n",
  "SYMBOLIC": "pertaining to a symbol, also SYMBOLICAL [adj SYMBOLICALLY]\n",
  "SYMBOLICAL": "of the nature of a symbol, also SYMBOLIC [adj SYMBOLICALLY]\n",
  "SYMBOLICALLY": "SYMBOLICAL, of the nature of a symbol, also SYMBOLIC [adv]\n",
  "SYMBOLICALNESS": "the state of being symbolical [n]\n",
  "SYMBOLICS": "the branch of knowledge that deals with symbols [n]\n",
  "SYMBOLING": "SYMBOL, to serve as a representation [v]\n",
  "SYMBOLISATION": "the act of symbolising, also SYMBOLIZATION [n -S]\n",
  "SYMBOLISATIONS": "SYMBOLISATION, the act of symbolising, also SYMBOLIZATION [n]\n",
  "SYMBOLISE": "to be symbolic of, also SYMBOLIZE [v SYMBOLISED, SYMBOLISING, SYMBOLISES]\n",
  "SYMBOLISED": "SYMBOLISE, to be symbolic of, also SYMBOLIZE [v]\n",
  "SYMBOLISER": "one who symbolises, also SYMBOLIZER [n -S]\n",
  "SYMBOLISERS": "SYMBOLISER, one who symbolises, also SYMBOLIZER [n]\n",
  "SYMBOLISES": "SYMBOLISE, to be symbolic of, also SYMBOLIZE [v]\n",
  "SYMBOLISING": "SYMBOLISE, to be symbolic of, also SYMBOLIZE [v]\n",
  "SYMBOLISM": "the use of symbols in literature or art [n -S]\n",
  "SYMBOLISMS": "SYMBOLISM, the use of symbols in literature or art [n]\n",
  "SYMBOLIST": "a practitioner of symbolism, the use of symbols in literature or art [n -S]\n",
  "SYMBOLISTIC": "relating to symbolism, also SYMBOLISTICAL [adj SYMBOLISTICALLY]\n",
  "SYMBOLISTICAL": "relating to symbolism, also SYMBOLISTIC [adj SYMBOLISTICALLY]\n",
  "SYMBOLISTICALLY": "SYMBOLISTICAL, relating to symbolism, also SYMBOLISTIC [adv]\n",
  "SYMBOLISTS": "SYMBOLIST, a practitioner of symbolism, the use of symbols in literature or art [n]\n",
  "SYMBOLIZATION": "the act of symbolizing, also SYMBOLISATION [n -S]\n",
  "SYMBOLIZATIONS": "SYMBOLIZATION, the act of symbolizing, also SYMBOLISATION [n]\n",
  "SYMBOLIZE": "to be symbolic of, also SYMBOLISE [v SYMBOLIZED, SYMBOLIZING, SYMBOLIZES]\n",
  "SYMBOLIZED": "SYMBOLIZE, to be symbolic of, also SYMBOLISE [v]\n",
  "SYMBOLIZER": "one who symbolizes, also SYMBOLISER [n -S]\n",
  "SYMBOLIZERS": "SYMBOLIZER, one who symbolizes, also SYMBOLISER [n]\n",
  "SYMBOLIZES": "SYMBOLIZE, to be symbolic of, also SYMBOLISE [v]\n",
  "SYMBOLIZING": "SYMBOLIZE, to be symbolic of, also SYMBOLISE [v]\n",
  "SYMBOLLED": "SYMBOL, to serve as a representation [v]\n",
  "SYMBOLLING": "SYMBOL, to serve as a representation [v]\n",
  "SYMBOLOGICAL": "related to symbology [adj]\n",
  "SYMBOLOGIES": "SYMBOLOGY, the study of symbols, also SYMBOLOLOGY [n]\n",
  "SYMBOLOGIST": "a student of symbolology [n -S]\n",
  "SYMBOLOGISTS": "SYMBOLOGIST, a student of symbolology [n]\n",
  "SYMBOLOGRAPHIES": "SYMBOLOGRAPHY, symbolic writing or representation [n]\n",
  "SYMBOLOGRAPHY": "symbolic writing or representation [n SYMBOLOGRAPHIES]\n",
  "SYMBOLOGY": "the study of symbols, also SYMBOLOLOGY [n SYMBOLOGIES]\n",
  "SYMBOLOLATRIES": "SYMBOLOLATRY, the worship of symbols [n]\n",
  "SYMBOLOLATRY": "the worship of symbols [n SYMBOLOLATRIES]\n",
  "SYMBOLOLOGIES": "SYMBOLOLOGY, the study of symbols, also SYMBOLOGY [n]\n",
  "SYMBOLOLOGY": "the study of symbols, also SYMBOLOGY [n SYMBOLOLOGIES]\n",
  "SYMBOLS": "SYMBOL, to serve as a representation [v]\n",
  "SYMITAR": "a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITARE [n -S]\n",
  "SYMITARE": "a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR [n -S]\n",
  "SYMITARES": "SYMITARE, a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITAR [n]\n",
  "SYMITARS": "SYMITAR, a curved oriental sword, also CEMITARE, SCIMITAR, SCIMETAR, SCIMITER, SEMITAR, SEMITAUR, SIMITAR, SYMITARE [n]\n",
  "SYMMETALISM": "a system of coinage in which the unit of currency consists of a particular weight of an alloy of two or more metals, also SYMMETALLISM [n -S]\n",
  "SYMMETALISMS": "SYMMETALISM, a system of coinage in which the unit of currency consists of a particular weight of an alloy of two or more metals, also SYMMETALLISM [n]\n",
  "SYMMETALLIC": "relating to symmetallism [adj]\n",
  "SYMMETALLISM": "a system of coinage in which the unit of currency consists of a particular weight of an alloy of two or more metals, also SYMMETALISM [n -S]\n",
  "SYMMETALLISMS": "SYMMETALLISM, a system of coinage in which the unit of currency consists of a particular weight of an alloy of two or more metals, also SYMMETALISM [n]\n",
  "SYMMETRAL": "of symmetry [adj]\n",
  "SYMMETRIAN": "a person who studies or theorizes on the due proportions of things [n -S]\n",
  "SYMMETRIANS": "SYMMETRIAN, a person who studies or theorizes on the due proportions of things [n]\n",
  "SYMMETRIC": "having symmetry, also SYMMETRICAL [adj SYMMETRICALLY]\n",
  "SYMMETRICAL": "having symmetry, also SYMMETRIC [adj SYMMETRICALLY]\n",
  "SYMMETRICALLY": "SYMMETRICAL, having symmetry, also SYMMETRIC [adv]\n",
  "SYMMETRICALNESS": "the state of being symmetrical [n]\n",
  "SYMMETRIES": "SYMMETRY, exact correspondence between the opposite halves of a figure [n]\n",
  "SYMMETRISATION": "the act of symmetrising, also SYMMETRIZATION [n -S]\n",
  "SYMMETRISATIONS": "SYMMETRISATION, the act of symmetrising, also SYMMETRIZATION [n]\n",
  "SYMMETRISE": "to make symmetrical, also SYMMETRIZE [v SYMMETRISED, SYMMETRISING, SYMMETRISES]\n",
  "SYMMETRISED": "SYMMETRISE, to make symmetrical, also SYMMETRIZE [v]\n",
  "SYMMETRISES": "SYMMETRISE, to make symmetrical, also SYMMETRIZE [v]\n",
  "SYMMETRISING": "SYMMETRISE, to make symmetrical, also SYMMETRIZE [v]\n",
  "SYMMETRIZATION": "the act of symmetrizing, also SYMMETRISATION [n -S]\n",
  "SYMMETRIZATIONS": "SYMMETRIZATION, the act of symmetrizing, also SYMMETRISATION [n]\n",
  "SYMMETRIZE": "to make symmetrical, also SYMMETRISE [v SYMMETRIZED, SYMMETRIZING, SYMMETRIZES]\n",
  "SYMMETRIZED": "SYMMETRIZE, to make symmetrical, also SYMMETRISE [v]\n",
  "SYMMETRIZES": "SYMMETRIZE, to make symmetrical, also SYMMETRISE [v]\n",
  "SYMMETRIZING": "SYMMETRISE, to make symmetrical, also SYMMETRIZE [v]\n",
  "SYMMETROPHOBIA": "fear of symmetry [n -S]\n",
  "SYMMETROPHOBIAS": "SYMMETROPHOBIA, fear of symmetry [n]\n",
  "SYMMETRY": "exact correspondence between the opposite halves of a figure [n SYMMETRIES]\n",
  "SYMPATHECTOMIES": "SYMPATHECTOMY, the surgical excision of a sympathetic ganglion or other part of the sympathetic system [n]\n",
  "SYMPATHECTOMY": "the surgical excision of a sympathetic ganglion or other part of the sympathetic system [n SYMPATHECTOMIES]\n",
  "SYMPATHETIC": "feeling together, also SYMPATHETICAL [adj SYMPATHETICALLY] / a sympathetic structure [n -S]\n",
  "SYMPATHETICAL": "(obsolete) sympathetic, also SYMPATHETIC [adj]\n",
  "SYMPATHETICALLY": "SYMPATHETICAL, (obsolete) sympathetic, also SYMPATHETIC [adv]\n",
  "SYMPATHETICS": "SYMPATHETIC, a sympathetic structure [n]\n",
  "SYMPATHIES": "SYMPATHY, a feeling of compassion for another's suffering [n]\n",
  "SYMPATHIN": "a substance secreted by sympathetic nerve-endings, which constricts and dilates blood-vessels [n -S]\n",
  "SYMPATHINS": "SYMPATHIN, a substance secreted by sympathetic nerve-endings, which constricts and dilates blood-vessels [n]\n",
  "SYMPATHIQUE": "(French) attractive [adj]\n",
  "SYMPATHISE": "to be in keeping, accord, or harmony, also SYMPATHIZE [v SYMPATHISED, SYMPATHISING, SYMPATHISES]\n",
  "SYMPATHISED": "SYMPATHISE, to be in keeping, accord, or harmony, also SYMPATHIZE [v]\n",
  "SYMPATHISER": "one who sympathises, also SYMPATHIZER [n -S]\n",
  "SYMPATHISERS": "SYMPATHISER, one who sympathises, also SYMPATHIZER [n]\n",
  "SYMPATHISES": "SYMPATHISE, to be in keeping, accord, or harmony, also SYMPATHIZE [v]\n",
  "SYMPATHISING": "SYMPATHISE, to be in keeping, accord, or harmony, also SYMPATHIZE [v]\n",
  "SYMPATHIZE": "to be in keeping, accord, or harmony, also SYMPATHISE [v SYMPATHIZED, SYMPATHIZING, SYMPATHIZES]\n",
  "SYMPATHIZED": "SYMPATHIZE, to be in keeping, accord, or harmony, also SYMPATHISE [v]\n",
  "SYMPATHIZER": "one who sympathizes, also SYMPATHISER [n -S]\n",
  "SYMPATHIZERS": "SYMPATHIZER, one who sympathizes, also SYMPATHISER [n]\n",
  "SYMPATHIZES": "SYMPATHIZE, to be in keeping, accord, or harmony, also SYMPATHISE [v]\n",
  "SYMPATHIZING": "SYMPATHIZE, to be in keeping, accord, or harmony, also SYMPATHISE [v]\n",
  "SYMPATHOLYTIC": "inhibiting the action of the sympathetic nervous system [adj] / a sympatholytic drug [n -S]\n",
  "SYMPATHOLYTICS": "SYMPATHOLYTIC, a sympatholytic drug [n]\n",
  "SYMPATHOMIMETIC": "simulating sympathetic nervous action in physiological effect [adj]\n",
  "SYMPATHY": "a feeling of compassion for another's suffering [n SYMPATHIES]\n",
  "SYMPATICO": "(Italian) of like mind or temperament; agreeable; pleasing, also SIMPATICO [adj]\n",
  "SYMPATRIC": "pertaining to species the ranges of which overlap, i.e. species occupying the same regions but not interbreeding [adj SYMPATRICALLY]\n",
  "SYMPATRICALLY": "SYMPATRIC, pertaining to species the ranges of which overlap, i.e. species occupying the same regions but not interbreeding [adv]\n",
  "SYMPATRIES": "SYMPATRY, the state of occupying an area without loss of identity from interbreeding [n]\n",
  "SYMPATRY": "the state of occupying an area without loss of identity from interbreeding [n SYMPATRIES]\n",
  "SYMPETALIES": "SYMPETALY, of petals, being united [n]\n",
  "SYMPETALOUS": "having the petals united [adj]\n",
  "SYMPETALY": "of petals, being united [n SYMPETALIES]\n",
  "SYMPHILE": "an animal kept as a guest in a termite's nest [n -S]\n",
  "SYMPHILES": "SYMPHILE, an animal kept as a guest in a termite's nest [n]\n",
  "SYMPHILIES": "SYMPHILY, the practise of keeping a guest in a termite's nest [n]\n",
  "SYMPHILISM": "the state of being in a symbiotic relationship [n -S]\n",
  "SYMPHILISMS": "SYMPHILISM, the state of being in a symbiotic relationship [n]\n",
  "SYMPHILOUS": "of or like a symphile, an animal of another kind kept in an ants' or termites' nest [adj]\n",
  "SYMPHILY": "the practise of keeping a guest in a termite's nest [n SYMPHILIES]\n",
  "SYMPHONIC": "relating to a symphony [adj SYMPHONICALLY]\n",
  "SYMPHONICALLY": "SYMPHONIC, relating to a symphony [adv]\n",
  "SYMPHONIES": "SYMPHONY, an orchestral composition [n]\n",
  "SYMPHONION": "a combination of piano and harmonium [n -S]\n",
  "SYMPHONIONS": "SYMPHONION, a combination of piano and harmonium [n]\n",
  "SYMPHONIOUS": "agreeing esp. in sound [adj SYMPHONIOUSLY]\n",
  "SYMPHONIOUSLY": "SYMPHONIOUS, agreeing esp. in sound [adv]\n",
  "SYMPHONIST": "a composer or (rarely) performer of symphonies [n -S]\n",
  "SYMPHONISTS": "SYMPHONIST, a composer or (rarely) performer of symphonies [n]\n",
  "SYMPHONY": "an orchestral composition [n SYMPHONIES]\n",
  "SYMPHYLOUS": "of or like a symphile, an animal of another kind kept in an ants' or termites' nest [adj]\n",
  "SYMPHYSEAL": "relating to symphysis, the union or growing together of bones, also SYMPHYSIAL, SYMPHYSTIC [adj]\n",
  "SYMPHYSEOTOMIES": "SYMPHYSEOTOMY, the operation of cutting through the pubic symphysis, also SYMPHYSIOTOMY [n]\n",
  "SYMPHYSEOTOMY": "the operation of cutting through the pubic symphysis, also SYMPHYSIOTOMY [n SYMPHYSEOTOMIES]\n",
  "SYMPHYSES": "SYMPHYSIS, the union or growing together of bones [n]\n",
  "SYMPHYSIAL": "relating to symphysis, the union or growing together of bones, also SYMPHYSEAL, SYMPHYSTIC [adj]\n",
  "SYMPHYSIOTOMIES": "SYMPHYSIOTOMY, the operation of cutting through the pubic symphysis, also SYMPHYSEOTOMY [n]\n",
  "SYMPHYSIOTOMY": "the operation of cutting through the pubic symphysis, also SYMPHYSEOTOMY [n SYMPHYSIOTOMIES]\n",
  "SYMPHYSIS": "the union or growing together of bones [n SYMPHYSES]\n",
  "SYMPHYSTIC": "relating to symphysis, the union or growing together of bones, also SYMPHYSEAL, SYMPHYSIAL [adj]\n",
  "SYMPHYTIC": "relating to symphysis, the union or growing together of bones [adj]\n",
  "SYMPIESOMETER": "instrument for measuring pressure of a current [n -S]\n",
  "SYMPIESOMETERS": "SYMPIESOMETER, instrument for measuring pressure of a current [n]\n",
  "SYMPLAST": "the continuous network of protoplasts [n -S]\n",
  "SYMPLASTIC": "relating to a symplast, a continuous network of protoplasts [adj]\n",
  "SYMPLASTS": "SYMPLAST, the continuous network of protoplasts [n]\n",
  "SYMPLOCE": "(Greek) the repetition of a word at the start of one and end of the next clause [n -S]\n",
  "SYMPLOCES": "SYMPLOCE, (Greek) the repetition of a word at the start of one and end of the next clause [n]\n",
  "SYMPODIA": "SYMPODIUM, a stem involved in sympodial growth [n]\n",
  "SYMPODIAL": "relating to a sympodium, a stem involved in sympodial growth [adj SYMPODIALLY]\n",
  "SYMPODIALLY": "SYMPODIAL, relating to a sympodium, a stem involved in sympodial growth [adv]\n",
  "SYMPODIUM": "a stem involved in sympodial growth [n SYMPODIA]\n",
  "SYMPOSIA": "SYMPOSIUM, (Greek) a conference [n]\n",
  "SYMPOSIAC": "pertaining to a symposium, a conference, also SYMPOSIAL [adj] / a symposium [n -S]\n",
  "SYMPOSIACS": "SYMPOSIAC, a symposium [n]\n",
  "SYMPOSIAL": "pertaining to a symposium, a conference, also SYMPOSIAC [adj]\n",
  "SYMPOSIARCH": "the master, director, etc. of a feast or conference [n -S]\n",
  "SYMPOSIARCHS": "SYMPOSIARCH, the master, director, etc. of a feast or conference [n]\n",
  "SYMPOSIAST": "a participant at a conference [n -S]\n",
  "SYMPOSIASTS": "SYMPOSIAST, a participant at a conference [n]\n",
  "SYMPOSIUM": "(Greek) a conference [n SYMPOSIUMS or SYMPOSIA]\n",
  "SYMPOSIUMS": "SYMPOSIUM, (Greek) a conference [n]\n",
  "SYMPTOM": "a subjective indication of a disease [n -S]\n",
  "SYMPTOMATIC": "relating to or displaying symptom, also SYMPTOMATICAL [adj SYMPTOMATICALLY]\n",
  "SYMPTOMATICAL": "relating to or displaying symptom, also SYMPTOMATIC [adj SYMPTOMATICALLY]\n",
  "SYMPTOMATICALLY": "SYMPTOMATICAL, relating to or displaying symptom, also SYMPTOMATIC [adv]\n",
  "SYMPTOMATISE": "to be a symptom of, also SYMPTOMATIZE [v SYMPTOMATISED, SYMPTOMATISING, SYMPTOMATISES]\n",
  "SYMPTOMATISED": "SYMPTOMATISE, to be a symptom of, also SYMPTOMATIZE [v]\n",
  "SYMPTOMATISES": "SYMPTOMATISE, to be a symptom of, also SYMPTOMATIZE [v]\n",
  "SYMPTOMATISING": "SYMPTOMATISE, to be a symptom of, also SYMPTOMATIZE [v]\n",
  "SYMPTOMATIZE": "to be a symptom of, also SYMPTOMATISE [v SYMPTOMATIZED, SYMPTOMATIZING, SYMPTOMATIZES]\n",
  "SYMPTOMATIZED": "SYMPTOMATIZE, to be a symptom of, also SYMPTOMATISE [v]\n",
  "SYMPTOMATIZES": "SYMPTOMATIZE, to be a symptom of, also SYMPTOMATISE [v]\n",
  "SYMPTOMATIZING": "SYMPTOMATIZE, to be a symptom of, also SYMPTOMATISE [v]\n",
  "SYMPTOMATOLOGIC": "relating to symptomatology [adj]\n",
  "SYMPTOMATOLOGY": "the study of symptoms of illness [n]\n",
  "SYMPTOMLESS": "without symptoms [adj]\n",
  "SYMPTOMOLOGICAL": "related to symptomology [adj]\n",
  "SYMPTOMOLOGIES": "SYMPTOMOLOGY, the science of symptoms [n]\n",
  "SYMPTOMOLOGY": "the science of symptoms [n SYMPTOMOLOGIES]\n",
  "SYMPTOMS": "SYMPTOM, a subjective indication of a disease [n]\n",
  "SYMPTOSES": "SYMPTOSIS, emaciation [n]\n",
  "SYMPTOSIS": "emaciation [n SYMPTOSES]\n",
  "SYMPTOTIC": "relating to symptosis, emaciation [adj]\n",
  "SYN": "since [prep]\n",
  "SYNADELPHITE": "a manganese aluminium arsenate [n -S]\n",
  "SYNADELPHITES": "SYNADELPHITE, a manganese aluminium arsenate [n]\n",
  "SYNAERESES": "SYNAERESIS, the running together of vowels into a diphthong, also SYNERESIS [n]\n",
  "SYNAERESIS": "the running together of vowels into a diphthong, also SYNERESIS [n SYNAERESES]\n",
  "SYNAESTHESES": "SYNAESTHESIS, harmony of differing impulses from a work of art [n]\n",
  "SYNAESTHESIA": "a sensation felt in one part of the body when stimulus is applied to another part, e.g. visualization of a color on hearing a sound, also SYNESTHESIA [n -S]\n",
  "SYNAESTHESIAS": "SYNAESTHESIA, a sensation felt in one part of the body when stimulus is applied to another part, e.g. visualization of a color on hearing a sound, also SYNESTHESIA [n]\n",
  "SYNAESTHESIS": "harmony of differing impulses from a work of art [n SYNAESTHESES]\n",
  "SYNAESTHETIC": "relating to synaesthesia, also SYNESTHETIC [adj]\n",
  "SYNAGOG": "(Greek) a Jewish church, also SYNAGOGUE [n -S]\n",
  "SYNAGOGAL": "relating to a synagog, a Jewish church [adj]\n",
  "SYNAGOGICAL": "relating to a synagogue [adj]\n",
  "SYNAGOGS": "SYNAGOG, (Greek) a Jewish church, also SYNAGOGUE [n]\n",
  "SYNAGOGUE": "(Greek) a Jewish church, also SYNAGOG [n -S]\n",
  "SYNAGOGUES": "SYNAGOGUE, (Greek) a Jewish church, also SYNAGOG [n]\n",
  "SYNALEPHA": "the melting of a final vowel or diphthong into the initial vowel or diphthong of the next word, also SYNALOEPHA [n -S]\n",
  "SYNALEPHAS": "SYNALEPHA, the melting of a final vowel or diphthong into the initial vowel or diphthong of the next word, also SYNALOEPHA [n]\n",
  "SYNALLAGMATIC": "mutually or reciprocally obligatory; bilateral [adj]\n",
  "SYNALOEPHA": "the melting of a final vowel or diphthong into the initial vowel or diphthong of the next word, also SYNALEPHA [n -S]\n",
  "SYNALOEPHAS": "SYNALOEPHA, the melting of a final vowel or diphthong into the initial vowel or diphthong of the next word, also SYNALEPHA [n]\n",
  "SYNANDRIA": "SYNANDRIUM, a mass of united stamens [n]\n",
  "SYNANDRIUM": "a mass of united stamens [n SYNANDRIA]\n",
  "SYNANDROUS": "having united stamens [adj]\n",
  "SYNANGIA": "SYNANGIUM, a cluster of sporangia which have become fused in development [n]\n",
  "SYNANGIUM": "a cluster of sporangia which have become fused in development [n SYNANGIA]\n",
  "SYNANON": "a method of group therapy for drug addicts [n -S]\n",
  "SYNANONS": "SYNANON, a method of group therapy for drug addicts [n]\n",
  "SYNANTHEROUS": "having the anthers united in a tube around the style, as in Compositae [adj]\n",
  "SYNANTHESES": "SYNANTHESIS, synchronous maturity of male and female elements of plant [n]\n",
  "SYNANTHESIS": "synchronous maturity of male and female elements of plant [n SYNANTHESES]\n",
  "SYNANTHETIC": "showing synanthy, the abnormal fusion of flowers, also SYNANTHIC [adj]\n",
  "SYNANTHIC": "showing synanthy, the abnormal fusion of flowers, also SYNANTHETIC [adj]\n",
  "SYNANTHIES": "SYNANTHY, abnormal fusion of flowers [n]\n",
  "SYNANTHOUS": "synanthic, flowering and leafing simultaneously [adj]\n",
  "SYNANTHY": "abnormal fusion of flowers [n SYNANTHIES]\n",
  "SYNAPHEA": "a metrical system of continuity between verses [n -S]\n",
  "SYNAPHEAS": "SYNAPHEA, a metrical system of continuity between verses [n]\n",
  "SYNAPHEIA": "metrical continuity between two verses in a system, also SYNAPHEA [n -S]\n",
  "SYNAPHEIAS": "SYNAPHEIA, metrical continuity between two verses in a system, also SYNAPHEA [n]\n",
  "SYNAPOSEMATIC": "having a warning coloration common to a number of dangerous species in the same region [adj]\n",
  "SYNAPOSEMATISM": "warning coloration common to many species in region [n -S]\n",
  "SYNAPOSEMATISMS": "SYNAPOSEMATISM, warning coloration common to many species in region [n]\n",
  "SYNAPSE": "to come together at a certain point [v SYNAPSED, SYNAPSING, SYNAPSES]\n",
  "SYNAPSED": "SYNAPSE, to come together at a certain point [v]\n",
  "SYNAPSES": "SYNAPSE, to come together at a certain point [v]\n",
  "SYNAPSID": "one of a group of extinct reptiles [n -S]\n",
  "SYNAPSIDS": "SYNAPSID, one of a group of extinct reptiles [n]\n",
  "SYNAPSING": "SYNAPSE, to come together at a certain point [v]\n",
  "SYNAPSIS": "the point at which an impulse passes from one neuron to another, also SYNDESIS [n SYNAPSES]\n",
  "SYNAPTASE": "emulsin, the white milky pulp or extract of bitter almonds [n -S]\n",
  "SYNAPTASES": "SYNAPTASE, emulsin, the white milky pulp or extract of bitter almonds [n]\n",
  "SYNAPTE": "(Greek) in the Greek church, a litany [n -S]\n",
  "SYNAPTES": "SYNAPTE, (Greek) in the Greek church, a litany [n]\n",
  "SYNAPTIC": "of or pertaining to a synapse or synapses between nerve cells [adj SYNAPTICALLY]\n",
  "SYNAPTICAL": "of or pertaining to a synapse or synapses between nerve cells, also SYNAPTIC [adj]\n",
  "SYNAPTICALLY": "SYNAPTICAL, of or pertaining to a synapse or synapses between nerve cells, also SYNAPTIC [adv]\n",
  "SYNAPTOSOMAL": "of or like a synaptosome, a nerve ending that is isolated from homogenized nerve tissue [adj]\n",
  "SYNAPTOSOME": "a nerve ending that is isolated from homogenized nerve tissue [n -S]\n",
  "SYNAPTOSOMES": "SYNAPTOSOME, a nerve ending that is isolated from homogenized nerve tissue [n]\n",
  "SYNARCHIES": "SYNARCHY, joint sovereignty [n]\n",
  "SYNARCHY": "joint sovereignty [n SYNARCHIES]\n",
  "SYNARTHRODIAL": "of, relating to, or being a synarthrosis [adj SYNARTHRODIALLY]\n",
  "SYNARTHRODIALLY": "SYNARTHRODIAL, of, relating to, or being a synarthrosis [adv]\n",
  "SYNARTHROSES": "SYNARTHROSIS, the fixed articulation of bones [n]\n",
  "SYNARTHROSIS": "the fixed articulation of bones [n SYNARTHROSES]\n",
  "SYNASTRIES": "SYNASTRY, coincidence of stellar influences [n]\n",
  "SYNASTRY": "coincidence of stellar influences [n SYNASTRIES]\n",
  "SYNAXARIA": "SYNAXARION, a lection containing an account of a saint's life [n]\n",
  "SYNAXARION": "a lection containing an account of a saint's life [n SYNAXARIA]\n",
  "SYNAXES": "SYNAXIS, (Greek) in the early Church, meeting for worship, esp. the Eucharist [n]\n",
  "SYNAXIS": "(Greek) in the early Church, meeting for worship, esp. the Eucharist [n SYNAXES]\n",
  "SYNBIOTIC": "a substance that contains a probiotic and a prebiotic that supports it [n -S]\n",
  "SYNBIOTICS": "SYNBIOTIC, a substance that contains a probiotic and a prebiotic that supports it [n]\n",
  "SYNC": "to cause to operate in unison, also SYNCH [v -ED, -ING, -S]\n",
  "SYNCARP": "a fleshy multiple fruit [n -S]\n",
  "SYNCARPIES": "SYNCARPY, the state of being a syncarp [n]\n",
  "SYNCARPOUS": "bearing syncarps, fleshy fruit developing from several carpels [adj]\n",
  "SYNCARPS": "SYNCARP, a fleshy multiple fruit [n]\n",
  "SYNCARPY": "the state of being a syncarp [n SYNCARPIES]\n",
  "SYNCED": "SYNC, to cause to operate in unison, also SYNCH [v]\n",
  "SYNCH": "to cause to operate in unison, also SYNC [v -ED, -ING, -S]\n",
  "SYNCHED": "SYNCH, to cause to operate in unison, also SYNC [v]\n",
  "SYNCHING": "SYNCH, to cause to operate in unison, also SYNC [v]\n",
  "SYNCHONDROSES": "SYNCHONDROSIS, synarthrosis in which the bone surfaces are connected by cartilage [n]\n",
  "SYNCHONDROSIS": "synarthrosis in which the bone surfaces are connected by cartilage [n SYNCHONDROSES]\n",
  "SYNCHORESES": "SYNCHORESIS, a concession, esp. one made for the sake of a more effective retort [n]\n",
  "SYNCHORESIS": "a concession, esp. one made for the sake of a more effective retort [n SYNCHORESES]\n",
  "SYNCHRO": "(short for) synchronized swimming [n -S]\n",
  "SYNCHROFLASH": "a mechanism which synchronizes the opening of a camera shutter with the peak of brilliance of a flash bulb [n -ES]\n",
  "SYNCHROFLASHES": "SYNCHROFLASH, a mechanism which synchronizes the opening of a camera shutter with the peak of brilliance of a flash bulb [n]\n",
  "SYNCHROMESH": "designed for effecting synchronized shifting of gears [adj] / a synchromesh gear [n -ES]\n",
  "SYNCHROMESHES": "SYNCHROMESH, a synchromesh gear [n]\n",
  "SYNCHRONAL": "coinciding in time [adj]\n",
  "SYNCHRONEITIES": "SYNCHRONEITY, the state of being synchronous [n]\n",
  "SYNCHRONEITY": "the state of being synchronous [n SYNCHRONEITIES]\n",
  "SYNCHRONIC": "concerned with the study of a subject (esp. a language) at a particular period, without considering the past or the future, also SYNCHRONICAL [adj SYNCHRONICALLY]\n",
  "SYNCHRONICAL": "concerned with the study of a subject (esp. a language) at a particular period, without considering the past or the future, also SYNCHRONIC [adj SYNCHRONICALLY]\n",
  "SYNCHRONICALLY": "SYNCHRONICAL, concerned with the study of a subject (esp. a language) at a particular period, without considering the past or the future, also SYNCHRONIC [adv]\n",
  "SYNCHRONICITIES": "SYNCHRONICITY, the coincidental occurrence of events and esp. psychic events [n]\n",
  "SYNCHRONICITY": "the coincidental occurrence of events and esp. psychic events [n SYNCHRONICITIES]\n",
  "SYNCHRONIES": "SYNCHRONY, simultaneity [n]\n",
  "SYNCHRONISATION": "the act of synchronising, also SYNCHRONIZATION [n]\n",
  "SYNCHRONISE": "to cause to happen at the same time, also SYNCHRONIZE [v SYNCHRONISED, SYNCHRONISING, SYNCHRONISES]\n",
  "SYNCHRONISED": "SYNCHRONISE, to cause to happen at the same time, also SYNCHRONIZE [v]\n",
  "SYNCHRONISER": "one who synchronises, also SYNCHRONIZER [n -S]\n",
  "SYNCHRONISERS": "SYNCHRONISER, one who synchronises, also SYNCHRONIZER [n]\n",
  "SYNCHRONISES": "SYNCHRONISE, to cause to happen at the same time, also SYNCHRONIZE [v]\n",
  "SYNCHRONISING": "SYNCHRONISE, to cause to happen at the same time, also SYNCHRONIZE [v]\n",
  "SYNCHRONISM": "the state of being synchronous [n -S]\n",
  "SYNCHRONISMS": "SYNCHRONISM, the state of being synchronous [n]\n",
  "SYNCHRONISTIC": "relating to synchronism, also SYNCHRONISTICAL [adj]\n",
  "SYNCHRONISTICAL": "relating to synchronism, also SYNCHRONISTIC [adj]\n",
  "SYNCHRONIZATION": "the act of synchronizing, also SYNCHRONISATION [n]\n",
  "SYNCHRONIZE": "to cause to happen at the same time, also SYNCHRONISE [v SYNCHRONIZED, SYNCHRONIZING, SYNCHRONIZES]\n",
  "SYNCHRONIZED": "SYNCHRONIZE, to cause to happen at the same time, also SYNCHRONISE [v]\n",
  "SYNCHRONIZER": "one who synchronizes, also SYNCHRONISER [n -S]\n",
  "SYNCHRONIZERS": "SYNCHRONIZER, one who synchronizes, also SYNCHRONISER [n]\n",
  "SYNCHRONIZES": "SYNCHRONIZE, to cause to happen at the same time, also SYNCHRONISE [v]\n",
  "SYNCHRONIZING": "SYNCHRONIZE, to cause to happen at the same time, also SYNCHRONISE [v]\n",
  "SYNCHRONOLOGIES": "SYNCHRONOLOGY, a chronological arrangement side by side [n]\n",
  "SYNCHRONOLOGY": "a chronological arrangement side by side [n SYNCHRONOLOGIES]\n",
  "SYNCHRONOSCOPE": "an instrument used to indicate whether two periodic quantities or motions are synchronous [n -S]\n",
  "SYNCHRONOSCOPES": "SYNCHRONOSCOPE, an instrument used to indicate whether two periodic quantities or motions are synchronous [n]\n",
  "SYNCHRONOUS": "happening at the same time [adj SYNCHRONOUSLY]\n",
  "SYNCHRONOUSLY": "SYNCHRONOUS, happening at the same time [adv]\n",
  "SYNCHRONOUSNESS": "the state of being synchronous [n]\n",
  "SYNCHRONY": "simultaneity [n SYNCHRONIES]\n",
  "SYNCHROS": "SYNCHRO, (short for) synchronized swimming [n]\n",
  "SYNCHROSCOPE": "an instrument for detecting whether two moving parts are synchronized [n -S]\n",
  "SYNCHROSCOPES": "SYNCHROSCOPE, an instrument for detecting whether two moving parts are synchronized [n]\n",
  "SYNCHROTRON": "a type of very high-energy particle accelerator [n -S]\n",
  "SYNCHROTRONS": "SYNCHROTRON, a type of very high-energy particle accelerator [n]\n",
  "SYNCHS": "SYNCH, to cause to operate in unison, also SYNC [v]\n",
  "SYNCHYSES": "SYNCHYSIS, a confused arrangement of words in a sentence, obscuring the meaning [n]\n",
  "SYNCHYSIS": "a confused arrangement of words in a sentence, obscuring the meaning [n SYNCHYSES]\n",
  "SYNCING": "SYNC, to cause to operate in unison, also SYNCH [v]\n",
  "SYNCLASTIC": "curved in all directions towards a single point [adj]\n",
  "SYNCLINAL": "of or like a syncline, a fold of rock layers that is convex downwards [adj] / a syncline [n -S]\n",
  "SYNCLINALS": "SYNCLINAL, a syncline [n]\n",
  "SYNCLINE": "a type of rock formation [n -S]\n",
  "SYNCLINES": "SYNCLINE, a type of rock formation [n]\n",
  "SYNCLINORIA": "SYNCLINORIUM, a great synclinal structure carrying minor flexures [n]\n",
  "SYNCLINORIUM": "a great synclinal structure carrying minor flexures [n SYNCLINORIA]\n",
  "SYNCOM": "a type of communications satellite [n -S]\n",
  "SYNCOMS": "SYNCOM, a type of communications satellite [n]\n",
  "SYNCOPAL": "of or showing syncope, the shortening a word by the omission of a sound, letter, or syllable from the middle of the word, also SYNCOPIC, SYNCOPTIC [adj]\n",
  "SYNCOPATE": "to shorten a word by cutting out its middle [v SYNCOPATED, SYNCOPATING, SYNCOPATES]\n",
  "SYNCOPATED": "SYNCOPATE, to shorten a word by cutting out its middle [v]\n",
  "SYNCOPATES": "SYNCOPATE, to shorten a word by cutting out its middle [v]\n",
  "SYNCOPATING": "SYNCOPATE, to shorten a word by cutting out its middle [v]\n",
  "SYNCOPATION": "a shift of accent in a musical passage that occurs when a normally weak beat is stressed [n -S]\n",
  "SYNCOPATIONS": "SYNCOPATION, a shift of accent in a musical passage that occurs when a normally weak beat is stressed [n]\n",
  "SYNCOPATIVE": "relating to syncopation [adj]\n",
  "SYNCOPATOR": "one who syncopates [n -S]\n",
  "SYNCOPATORS": "SYNCOPATOR, one who syncopates [n]\n",
  "SYNCOPE": "(Greek) a contraction of a word by omitting sounds from the middle [n -S]\n",
  "SYNCOPES": "SYNCOPE, (Greek) a contraction of a word by omitting sounds from the middle [n]\n",
  "SYNCOPIC": "of or showing syncope, the shortening a word by the omission of a sound, letter, or syllable from the middle of the word, also SYNCOPAL, SYNCOPTIC [adj]\n",
  "SYNCOPTIC": "of or showing syncope, the shortening a word by the omission of a sound, letter, or syllable from the middle of the word, also SYNCOPAL, SYNCOPIC [adj]\n",
  "SYNCRETIC": "combining different forms of belief or practice [adj]\n",
  "SYNCRETISATION": "the process of syncretising, also SYNCRETIZATION [n -S]\n",
  "SYNCRETISATIONS": "SYNCRETISATION, the process of syncretising, also SYNCRETIZATION [n]\n",
  "SYNCRETISE": "to become or cause to become fused, also SYNCRETIZE [v SYNCRETISED, SYNCRETISING, SYNCRETISES]\n",
  "SYNCRETISED": "SYNCRETISE, to become or cause to become fused, also SYNCRETIZE [v]\n",
  "SYNCRETISES": "SYNCRETISE, to become or cause to become fused, also SYNCRETIZE [v]\n",
  "SYNCRETISING": "SYNCRETISE, to become or cause to become fused, also SYNCRETIZE [v]\n",
  "SYNCRETISM": "the reconciliation or union of conflicting beliefs or an effort intending such; a flagrant compromise in religion or philosophy [n -S]\n",
  "SYNCRETISMS": "SYNCRETISM, the reconciliation or union of conflicting beliefs or an effort intending such; a flagrant compromise in religion or philosophy [n]\n",
  "SYNCRETIST": "a believer in syncretism [n -S]\n",
  "SYNCRETISTIC": "relating to syncretism [adj]\n",
  "SYNCRETISTS": "SYNCRETIST, a believer in syncretism [n]\n",
  "SYNCRETIZATION": "the process of syncretizing, also SYNCRETISATION [n -S]\n",
  "SYNCRETIZATIONS": "SYNCRETIZATION, the process of syncretizing, also SYNCRETISATION [n]\n",
  "SYNCRETIZE": "to become or cause to become fused, also SYNCRETISE [v SYNCRETIZED, SYNCRETIZING, SYNCRETIZES]\n",
  "SYNCRETIZED": "SYNCRETIZE, to become or cause to become fused, also SYNCRETISE [v]\n",
  "SYNCRETIZES": "SYNCRETIZE, to become or cause to become fused, also SYNCRETISE [v]\n",
  "SYNCRETIZING": "SYNCRETIZE, to become or cause to become fused, also SYNCRETISE [v]\n",
  "SYNCS": "SYNC, to cause to operate in unison, also SYNCH [v]\n",
  "SYNCYTIA": "SYNCYTIUM, a multinucleate cell [n]\n",
  "SYNCYTIAL": "relating to a syncytium, a mass of protoplasm with many nuclei but no clear cell boundaries [adj]\n",
  "SYNCYTIUM": "a multinucleate cell [n SYNCYTIA]\n",
  "SYND": "(Scots) to rinse, wash out, also SIND, SINE, SYNE [v -ED, -ING, -S]\n",
  "SYNDACTYL": "with digits joined together [adj] / an animal with digits joined together [n -S]\n",
  "SYNDACTYLIES": "SYNDACTYLY, the state of being syndactyl, with digits joined together [n]\n",
  "SYNDACTYLISM": "being syndactyl, having fused digits [n -S]\n",
  "SYNDACTYLISMS": "SYNDACTYLISM, being syndactyl, having fused digits [n]\n",
  "SYNDACTYLOUS": "having fused digits, as do many birds and lower mammals [adj]\n",
  "SYNDACTYLS": "SYNDACTYL, an animal with digits joined together [n]\n",
  "SYNDACTYLY": "the state of being syndactyl, with digits joined together [n SYNDACTYLIES]\n",
  "SYNDED": "SYND, (Scots) to rinse, wash out, also SIND, SINE, SYNE [v]\n",
  "SYNDERESES": "SYNDERESIS, conscience as a guide to action; intuitive moral knowledge, also SYNTERESIS [n]\n",
  "SYNDERESIS": "conscience as a guide to action; intuitive moral knowledge, also SYNTERESIS [n SYNDERESES]\n",
  "SYNDESES": "SYNDESIS, the point at which an impulse passes from one neuron to another, also SYNAPSIS [n]\n",
  "SYNDESIS": "the point at which an impulse passes from one neuron to another, also SYNAPSIS [n SYNDESISES or SYNDESES]\n",
  "SYNDESISES": "SYNDESIS, the point at which an impulse passes from one neuron to another, also SYNAPSIS [n]\n",
  "SYNDESMOSES": "SYNDESMOSIS, an articulation in which the contiguous surfaces of the bones are rough and are bound together by a ligament [n]\n",
  "SYNDESMOSIS": "an articulation in which the contiguous surfaces of the bones are rough and are bound together by a ligament [n SYNDESMOSES]\n",
  "SYNDESMOTIC": "relating to syndesmosis, an articulation in which the contiguous surfaces of the bones are rough and are bound together by a ligament [adj]\n",
  "SYNDET": "a synthetic detergent [n -S]\n",
  "SYNDETIC": "in grammar, connecting two clauses with a conjunction, also SYNDETICAL [adj SYNDETICALLY]\n",
  "SYNDETICAL": "in grammar, connecting two clauses with a conjunction, also SYNDETIC [adj SYNDETICALLY]\n",
  "SYNDETICALLY": "SYNDETICAL, in grammar, connecting two clauses with a conjunction, also SYNDETIC [adv]\n",
  "SYNDETON": "in grammar, a syndetic construction [n -S]\n",
  "SYNDETONS": "SYNDETON, in grammar, a syndetic construction [n]\n",
  "SYNDETS": "SYNDET, a synthetic detergent [n]\n",
  "SYNDIC": "a business agent [n -S]\n",
  "SYNDICAL": "relating to a syndic [adj]\n",
  "SYNDICALISM": "the doctrine of direct worker control of capital [n -S]\n",
  "SYNDICALISMS": "SYNDICALISM, the doctrine of direct worker control of capital [n]\n",
  "SYNDICALIST": "a believer in syndicalism [n -S]\n",
  "SYNDICALISTIC": "relating to syndicalism [adj]\n",
  "SYNDICALISTS": "SYNDICALIST, a believer in syndicalism [n]\n",
  "SYNDICATE": "a combination of people for some common purpose [n -S] / to sell (e.g. an article) for simultaneous publication in a number of newspapers or periodicals [v SYNDICATED, SYNDICATING, SYNDICATES]\n",
  "SYNDICATED": "SYNDICATE, to sell (e.g. an article) for simultaneous publication in a number of newspapers or periodicals [v]\n",
  "SYNDICATES": "SYNDICATE, to sell (e.g. an article) for simultaneous publication in a number of newspapers or periodicals [v]\n",
  "SYNDICATING": "SYNDICATE, to sell (e.g. an article) for simultaneous publication in a number of newspapers or periodicals [v]\n",
  "SYNDICATION": "the act of syndicating [n -S]\n",
  "SYNDICATIONS": "SYNDICATION, the act of syndicating [n]\n",
  "SYNDICATOR": "one who syndicates [n -S]\n",
  "SYNDICATORS": "SYNDICATOR, one who syndicates [n]\n",
  "SYNDICS": "SYNDIC, a business agent [n]\n",
  "SYNDICSHIP": "the office of syndic, a magistrate; a member of committee [n -S]\n",
  "SYNDICSHIPS": "SYNDICSHIP, the office of syndic, a magistrate; a member of committee [n]\n",
  "SYNDING": "the act of rinsing or washing out [n -S]\n",
  "SYNDINGS": "SYNDING, the act of rinsing or washing out [n]\n",
  "SYNDIOTACTIC": "of a stereospecific polymer, having alternating stereochemical configurations of the groups on successive carbon atoms in the chain [adj]\n",
  "SYNDROME": "a group of symptoms that characterize a particular disorder [n -S]\n",
  "SYNDROMES": "SYNDROME, a group of symptoms that characterize a particular disorder [n]\n",
  "SYNDROMIC": "of or like a syndrome, a characteristic group of symptoms [adj]\n",
  "SYNDS": "SYND, (Scots) to rinse, wash out, also SIND, SINE, SYNE [v]\n",
  "SYNDYASMIAN": "loose temporary pair-bonding, one-night stand [adj]\n",
  "SYNE": "to rinse, wash out, also SIND, SINE, SYND [v SYNED, SYNING, SYNES]\n",
  "SYNECDOCHE": "a figure of speech by which a part is used for the whole (as fifty sail for fifty ships), or the whole for a part (as the smiling year for spring) [n -S]\n",
  "SYNECDOCHES": "SYNECDOCHE, a figure of speech by which a part is used for the whole (as fifty sail for fifty ships), or the whole for a part (as the smiling year for spring) [n]\n",
  "SYNECDOCHIC": "relating to synecdoche, also SYNECDOCHICAL [adj]\n",
  "SYNECDOCHICAL": "relating to synecdoche, also SYNECDOCHIC [adj SYNECDOCHICALLY]\n",
  "SYNECDOCHICALLY": "SYNECDOCHICAL, relating to synecdoche, also SYNECDOCHIC [adv]\n",
  "SYNECDOCHISM": "the use of synecdoche; the use of a part for the whole in sympathetic magic [n -S]\n",
  "SYNECDOCHISMS": "SYNECDOCHISM, the use of synecdoche; the use of a part for the whole in sympathetic magic [n]\n",
  "SYNECHIA": "an abnormal adhesion [n -S]\n",
  "SYNECHIAS": "SYNECHIA, an abnormal adhesion [n]\n",
  "SYNECIOUS": "having male and female organs together on a branch [adj]\n",
  "SYNECOLOGIC": "relating to synecology [adj SYNECOLOGICALLY]\n",
  "SYNECOLOGICAL": "relating to synecology [adj SYNECOLOGICALLY]\n",
  "SYNECOLOGICALLY": "SYNECOLOGICAL, relating to synecology [adv]\n",
  "SYNECOLOGIES": "SYNECOLOGY, the study of ecological communities, also SYNOECOLOGY [n]\n",
  "SYNECOLOGIST": "a specialist in synecology [n -S]\n",
  "SYNECOLOGISTS": "SYNECOLOGIST, a specialist in synecology [n]\n",
  "SYNECOLOGY": "the study of ecological communities, also SYNOECOLOGY [n SYNECOLOGIES]\n",
  "SYNECPHONESES": "SYNECPHONESIS, the union into one syllable of two vowels without forming a recognized diphthong [n]\n",
  "SYNECPHONESIS": "the union into one syllable of two vowels without forming a recognized diphthong [n SYNECPHONESES]\n",
  "SYNECTIC": "pertaining to a system of problem solving [adj SYNECTICALLY]\n",
  "SYNECTICALLY": "SYNECTIC, pertaining to a system of problem solving [adv]\n",
  "SYNECTICS": "the study of the processes leading to invention [n]\n",
  "SYNED": "SYNE, to rinse, wash out, also SIND, SINE, SYND [v]\n",
  "SYNEDRIA": "SYNEDRIUM, an ancient rabbinical council of 70 sages, the highest court of ancient Jerusalem, also SYNEDRION [n]\n",
  "SYNEDRIAL": "of or like a synedrium, an ancient rabbinical council of 70 sages, the highest court of ancient Jerusalem [adj]\n",
  "SYNEDRION": "an ancient rabbinical council of 70 sages, the highest court of ancient Jerusalem, also SYNEDRIUM [n SYNEDRIA]\n",
  "SYNEDRIUM": "an ancient rabbinical council of 70 sages, the highest court of ancient Jerusalem, also SYNEDRION [n SYNEDRIA]\n",
  "SYNEIDESES": "SYNEIDESIS, (obsolete) conscience as passing judgement on past acts [n]\n",
  "SYNEIDESIS": "(obsolete) conscience as passing judgement on past acts [n SYNEIDESES]\n",
  "SYNERESES": "SYNERESIS, the running together of vowels into a diphthong, also SYNAERESIS [n]\n",
  "SYNERESIS": "the running together of vowels into a diphthong, also SYNAERESIS [n SYNERESES]\n",
  "SYNERGETIC": "cooperating, working together [adj SYNERGETICALLY]\n",
  "SYNERGETICALLY": "SYNERGETIC, cooperating, working together [adv]\n",
  "SYNERGIA": "(Greek) combined action, also SYNERGY [n -S]\n",
  "SYNERGIAS": "SYNERGIA, (Greek) combined action, also SYNERGY [n]\n",
  "SYNERGIC": "relating to synergy [adj SYNERGICALLY]\n",
  "SYNERGICALLY": "SYNERGIC, relating to synergy [adv]\n",
  "SYNERGID": "a cell found in the embryo sac of a seed plant [n -S]\n",
  "SYNERGIDS": "SYNERGID, a cell found in the embryo sac of a seed plant [n]\n",
  "SYNERGIES": "SYNERGY, (Greek) combined action, also SYNERGIA [n]\n",
  "SYNERGISE": "to act as a synergist, also SYNERGIZE [v SYNERGISED, SYNERGISING, SYNERGISES]\n",
  "SYNERGISED": "SYNERGISE, to act as a synergist, also SYNERGIZE [v]\n",
  "SYNERGISES": "SYNERGISE, to act as a synergist, also SYNERGIZE [v]\n",
  "SYNERGISING": "SYNERGISE, to act as a synergist, also SYNERGIZE [v]\n",
  "SYNERGISM": "the belief that human will and divine spirit cooperate in salvation [n -S]\n",
  "SYNERGISMS": "SYNERGISM, the belief that human will and divine spirit cooperate in salvation [n]\n",
  "SYNERGIST": "a substance which increases the effect of another e.g. a pesticide [n -S]\n",
  "SYNERGISTIC": "showing synergy [adj SYNERGISTICALLY]\n",
  "SYNERGISTICALLY": "SYNERGISTIC, showing synergy [adv]\n",
  "SYNERGISTS": "SYNERGIST, a substance which increases the effect of another e.g. a pesticide [n]\n",
  "SYNERGIZE": "to act as a synergist, also SYNERGISE [v SYNERGIZED, SYNERGIZING, SYNERGIZES]\n",
  "SYNERGIZED": "SYNERGIZE, to act as a synergist, also SYNERGISE [v]\n",
  "SYNERGIZES": "SYNERGIZE, to act as a synergist, also SYNERGISE [v]\n",
  "SYNERGIZING": "SYNERGIZE, to act as a synergist, also SYNERGISE [v]\n",
  "SYNERGY": "(Greek) combined action, also SYNERGIA [n SYNERGIES]\n",
  "SYNES": "SYNE, to rinse, wash out, also SIND, SINE, SYND [v]\n",
  "SYNESES": "SYNESIS, a construction in which a form differs in number but agrees in meaning with the word governing it, e. g. if anyone arrives, tell them to wait [n]\n",
  "SYNESIS": "a construction in which a form differs in number but agrees in meaning with the word governing it, e. g. if anyone arrives, tell them to wait [n SYNESES or SYNESISES]\n",
  "SYNESISES": "SYNESIS, a construction in which a form differs in number but agrees in meaning with the word governing it, e. g. if anyone arrives, tell them to wait [n]\n",
  "SYNESTHESIA": "a sensation felt in one part of the body when stimulus is applied to another part, e.g. visualization of a color on hearing a sound, also SYNAESTHESIA [n -S]\n",
  "SYNESTHESIAS": "SYNESTHESIA, a sensation felt in one part of the body when stimulus is applied to another part, e.g. visualization of a color on hearing a sound, also SYNAESTHESIA [n]\n",
  "SYNESTHETIC": "relating to synesthesia, also SYNAESTHETIC [adj]\n",
  "SYNFUEL": "a fuel derived from fossil fuels [n -S]\n",
  "SYNFUELS": "SYNFUEL, a fuel derived from fossil fuels [n]\n",
  "SYNGAMIC": "of or like syngamy, the process of union of two gametes [adj]\n",
  "SYNGAMIES": "SYNGAMY, (Greek) the union of two gametes [n]\n",
  "SYNGAMOUS": "relating to syngamy, free interbreeding [adj]\n",
  "SYNGAMY": "(Greek) the union of two gametes [n SYNGAMIES]\n",
  "SYNGAS": "a mixture of carbon monoxide and hydrogen [n SYNGASES or SYNGASSES]\n",
  "SYNGASES": "SYNGAS, a mixture of carbon monoxide and hydrogen [n]\n",
  "SYNGASSES": "SYNGAS, a mixture of carbon monoxide and hydrogen [n]\n",
  "SYNGENEIC": "genetically similar or identical, e.g. in respect of grafts, also SYNGENIC [adj]\n",
  "SYNGENESES": "SYNGENESIS, sexual reproduction [n]\n",
  "SYNGENESIOUS": "having the anthers united in a tube around the style, as in Compositae [adj]\n",
  "SYNGENESIS": "sexual reproduction [n SYNGENESES]\n",
  "SYNGENETIC": "relating to syngenesis, sexual reproduction [adj]\n",
  "SYNGENIC": "genetically similar or identical, e.g. in respect of grafts, also SYNGENEIC [adj]\n",
  "SYNGNATHOUS": "of certain fish, having the jaws fused to form a tubular structure [adj]\n",
  "SYNGRAPH": "a contract signed all or both parties [n -S]\n",
  "SYNGRAPHS": "SYNGRAPH, a contract signed all or both parties [n]\n",
  "SYNING": "SYNE, to rinse, wash out, also SIND, SINE, SYND [v]\n",
  "SYNIZESES": "SYNIZESIS, a stage of meiosis in some species in which all the chromosomes contract together [n]\n",
  "SYNIZESIS": "a stage of meiosis in some species in which all the chromosomes contract together [n SYNIZESES]\n",
  "SYNKARYA": "SYNKARYON, the nucleus of a fertilized egg [n]\n",
  "SYNKARYON": "the nucleus of a fertilized egg [n SYNKARYONS or SYNKARYA]\n",
  "SYNKARYONIC": "like a synkaryon [adj]\n",
  "SYNKARYONS": "SYNKARYON, the nucleus of a fertilized egg [n]\n",
  "SYNOD": "an ecclesiastical assembly or council [n -S]\n",
  "SYNODAL": "a payment made by a clergyman on the occasion of a synod [n -S]\n",
  "SYNODALS": "SYNODAL, a payment made by a clergyman on the occasion of a synod [n]\n",
  "SYNODIC": "enacted or made by or at a synod, also SYNODICAL [adj SYNODICALLY]\n",
  "SYNODICAL": "enacted or made by or at a synod, also SYNODIC [adj SYNODICALLY]\n",
  "SYNODICALLY": "SYNODICAL, enacted or made by or at a synod, also SYNODIC [adv]\n",
  "SYNODS": "SYNOD, an ecclesiastical assembly or council [n]\n",
  "SYNODSMAN": "a member of a synod, an ecclesiastical assembly or council [n SYNODSMEN]\n",
  "SYNODSMEN": "SYNODSMAN, a member of a synod, an ecclesiastical assembly or council [n]\n",
  "SYNOECETE": "a guest tolerated with indifference in an ants' or termites' nest, also SYNOEKETE [n -S]\n",
  "SYNOECETES": "SYNOECETE, a guest tolerated with indifference in an ants' or termites' nest, also SYNOEKETE [n]\n",
  "SYNOECIOSES": "SYNOECIOSIS, the rhetorical figure of coupling opposites [n]\n",
  "SYNOECIOSIS": "the rhetorical figure of coupling opposites [n SYNOECIOSES]\n",
  "SYNOECIOUS": "having antheridia and archegonia in the same group, also SYNOICOUS [adj]\n",
  "SYNOECISE": "to unite in one community or city-state, also SYNOECIZE [v SYNOECISED, SYNOECISING, SYNOECISES]\n",
  "SYNOECISED": "SYNOECISE, to unite in one community or city-state, also SYNOECIZE [v]\n",
  "SYNOECISES": "SYNOECISE, to unite in one community or city-state, also SYNOECIZE [v]\n",
  "SYNOECISING": "SYNOECISE, to unite in one community or city-state, also SYNOECIZE [v]\n",
  "SYNOECISM": "association of species with benefit to one and neither harm nor benefit to other [n -S]\n",
  "SYNOECISMS": "SYNOECISM, association of species with benefit to one and neither harm nor benefit to other [n]\n",
  "SYNOECIZE": "to unite in one community or city-state, also SYNOECISE [v SYNOECIZED, SYNOECIZING, SYNOECIZES]\n",
  "SYNOECIZED": "SYNOECIZE, to unite in one community or city-state, also SYNOECISE [v]\n",
  "SYNOECIZES": "SYNOECIZE, to unite in one community or city-state, also SYNOECISE [v]\n",
  "SYNOECIZING": "SYNOECIZE, to unite in one community or city-state, also SYNOECISE [v]\n",
  "SYNOECOLOGIES": "SYNOECOLOGY, the study of ecological communities, also SYNECOLOGY [n]\n",
  "SYNOECOLOGY": "the study of ecological communities, also SYNECOLOGY [n SYNOECOLOGIES]\n",
  "SYNOEKETE": "a guest tolerated with indifference in an ants' or termites' nest, also SYNOECETE [n -S]\n",
  "SYNOEKETES": "SYNOEKETE, a guest tolerated with indifference in an ants' or termites' nest, also SYNOECETE [n]\n",
  "SYNOICOUS": "having antheridia and archegonia in the same group, also SYNOECIOUS [adj]\n",
  "SYNONYM": "a word having the same meaning as another, also SYNONYME [n -S]\n",
  "SYNONYMATIC": "of, consisting of or relating to synonyms [adj]\n",
  "SYNONYME": "a word having the same meaning as another, also SYNONYM [n -S]\n",
  "SYNONYMES": "SYNONYME, a word having the same meaning as another, also SYNONYM [n]\n",
  "SYNONYMIC": "like a synonym, also SYNONYMICAL [adj]\n",
  "SYNONYMICAL": "like a synonym, also SYNONYMIC [adj]\n",
  "SYNONYMICON": "a dictionary of synonyms, a thesaurus [n -S]\n",
  "SYNONYMICONS": "SYNONYMICON, a dictionary of synonyms, a thesaurus [n]\n",
  "SYNONYMIES": "SYNONYMY, equivalence of meaning [n]\n",
  "SYNONYMISE": "to make synonymous, also SYNONYMIZE [v SYNONYMISED, SYNONYMISING, SYNONYMISES]\n",
  "SYNONYMISED": "SYNONYMISE, to make synonymous, also SYNONYMIZE [v]\n",
  "SYNONYMISES": "SYNONYMISE, to make synonymous, also SYNONYMIZE [v]\n",
  "SYNONYMISING": "SYNONYMISE, to make synonymous, also SYNONYMIZE [v]\n",
  "SYNONYMIST": "a student of synonyms [n -S]\n",
  "SYNONYMISTS": "SYNONYMIST, a student of synonyms [n]\n",
  "SYNONYMITIES": "SYNONYMITY, the state of being synonymous [n]\n",
  "SYNONYMITY": "the state of being synonymous [n SYNONYMITIES]\n",
  "SYNONYMIZE": "to make synonymous, also SYNONYMISE [v SYNONYMIZED, SYNONYMIZING, SYNONYMIZES]\n",
  "SYNONYMIZED": "SYNONYMIZE, to make synonymous, also SYNONYMISE [v]\n",
  "SYNONYMIZES": "SYNONYMIZE, to make synonymous, also SYNONYMISE [v]\n",
  "SYNONYMIZING": "SYNONYMIZE, to make synonymous, also SYNONYMISE [v]\n",
  "SYNONYMOUS": "having the character of a synonym [adj SYNONYMOUSLY]\n",
  "SYNONYMOUSLY": "SYNONYMOUS, having the character of a synonym [adv]\n",
  "SYNONYMOUSNESS": "the state of being synonymous [n]\n",
  "SYNONYMS": "SYNONYM, a word having the same meaning as another, also SYNONYME [n]\n",
  "SYNONYMY": "equivalence of meaning [n SYNONYMIES]\n",
  "SYNOPSES": "SYNOPSIS, a general view; a summary [n]\n",
  "SYNOPSIS": "a general view; a summary [n SYNOPSES]\n",
  "SYNOPSISE": "to make a synopsis of, also SYNOPSIZE [v SYNOPSISED, SYNOPSISING, SYNOPSISES]\n",
  "SYNOPSISED": "SYNOPSISE, to make a synopsis of, also SYNOPSIZE [v]\n",
  "SYNOPSISES": "SYNOPSISE, to make a synopsis of, also SYNOPSIZE [v]\n",
  "SYNOPSISING": "SYNOPSISE, to make a synopsis of, also SYNOPSIZE [v]\n",
  "SYNOPSIZE": "to make a synopsis of, also SYNOPSISE [v SYNOPSIZED, SYNOPSIZING, SYNOPSIZES]\n",
  "SYNOPSIZED": "SYNOPSIZE, to make a synopsis of, also SYNOPSISE [v]\n",
  "SYNOPSIZES": "SYNOPSIZE, to make a synopsis of, also SYNOPSISE [v]\n",
  "SYNOPSIZING": "SYNOPSIZE, to make a synopsis of, also SYNOPSISE [v]\n",
  "SYNOPTIC": "of or giving a synopsis or summary [adj SYNOPTICALLY] / one of the three synoptic gospels [n -S]\n",
  "SYNOPTICAL": "relating to a synopsis [adj SYNOPTICALLY]\n",
  "SYNOPTICALLY": "SYNOPTICAL, relating to a synopsis [adv]\n",
  "SYNOPTICS": "SYNOPTIC, one of the three synoptic gospels [n]\n",
  "SYNOPTIST": "one of the writers of the Synoptic Gospels [n -S]\n",
  "SYNOPTISTIC": "of or like a synoptist, one of the writers of the Synoptic Gospels [adj]\n",
  "SYNOPTISTS": "SYNOPTIST, one of the writers of the Synoptic Gospels [n]\n",
  "SYNOSTOSES": "SYNOSTOSIS, a complete union of bones [n]\n",
  "SYNOSTOSIS": "a complete union of bones [n SYNOSTOSES]\n",
  "SYNOVIA": "a lubricating fluid secreted by certain membranes [n -S]\n",
  "SYNOVIAL": "relating to the synovia, a lubricating fluid in the joints [adj]\n",
  "SYNOVIALLY": "SYNOVIAL, relating to the synovia, a lubricating fluid in the joints [adv]\n",
  "SYNOVIAS": "SYNOVIA, a lubricating fluid secreted by certain membranes [n]\n",
  "SYNOVITIC": "relating to synovitis, inflammation of a synovial membrane [adj]\n",
  "SYNOVITIS": "inflammation of a synovial membrane [n -ES]\n",
  "SYNOVITISES": "SYNOVITIS, inflammation of a synovial membrane [n]\n",
  "SYNROC": "a type of synthetic rock developed esp. to fuse with radioactive waste [n -S]\n",
  "SYNROCS": "SYNROC, a type of synthetic rock developed esp. to fuse with radioactive waste [n]\n",
  "SYNSEPALOUS": "another word for gamosepalous, with sepals partly united [adj]\n",
  "SYNTACTIC": "relating to syntax, also SYNTACTICAL [adj SYNTACTICALLY]\n",
  "SYNTACTICAL": "relating to syntax, also SYNTACTIC [adj SYNTACTICALLY]\n",
  "SYNTACTICALLY": "SYNTACTICAL, relating to syntax, also SYNTACTIC [adv]\n",
  "SYNTACTICS": "the branch of semiotics that deals with the formal properties of signs and symbols [n]\n",
  "SYNTAGM": "a syntactic unit comprising one or more (esp. linguistic) signs or elements, also SYNTAGMA [n -S]\n",
  "SYNTAGMA": "a syntactic unit comprising one or more (esp. linguistic) signs or elements, also SYNTAGM [n SYNTAGMAS or SYNTAGMATA]\n",
  "SYNTAGMAS": "SYNTAGMA, a syntactic unit comprising one or more (esp. linguistic) signs or elements, also SYNTAGM [n]\n",
  "SYNTAGMATA": "SYNTAGMA, a syntactic unit comprising one or more (esp. linguistic) signs or elements, also SYNTAGM [n]\n",
  "SYNTAGMATIC": "of or like a syntagma [adj]\n",
  "SYNTAGMATITE": "a kind of hornblende [n -S]\n",
  "SYNTAGMATITES": "SYNTAGMATITE, a kind of hornblende [n]\n",
  "SYNTAGMIC": "relating to a syntagma [adj]\n",
  "SYNTAGMS": "SYNTAGM, a syntactic unit comprising one or more (esp. linguistic) signs or elements, also SYNTAGMA [n]\n",
  "SYNTAN": "a synthetic tanning agent [n -S]\n",
  "SYNTANS": "SYNTAN, a synthetic tanning agent [n]\n",
  "SYNTAX": "the way words are put together to form phrases and sentences [n -ES]\n",
  "SYNTAXES": "SYNTAX, the way words are put together to form phrases and sentences [n]\n",
  "SYNTECTIC": "(obsolete) pertaining to syntexis, liquefaction, also SYNTECTICAL [adj]\n",
  "SYNTECTICAL": "(obsolete) pertaining to syntexis, liquefaction, also SYNTECTIC [adj]\n",
  "SYNTENIC": "of genes, being on the same chromosome [adj]\n",
  "SYNTENIES": "SYNTENY, the presence of several genes on the same chromosome [n]\n",
  "SYNTENOSES": "SYNTENOSIS, the connection of bones by tendons [n]\n",
  "SYNTENOSIS": "the connection of bones by tendons [n SYNTENOSES]\n",
  "SYNTENY": "the presence of several genes on the same chromosome [n SYNTENIES]\n",
  "SYNTERESES": "SYNTERESIS, conscience as a guide to action; intuitive moral knowledge, also SYNDERESIS [n]\n",
  "SYNTERESIS": "conscience as a guide to action; intuitive moral knowledge, also SYNDERESIS [n SYNTERESES]\n",
  "SYNTEXIS": "(Greek) the alteration of magma by the melting or assimilation of another rock [n -ES]\n",
  "SYNTEXISES": "SYNTEXIS, (Greek) the alteration of magma by the melting or assimilation of another rock [n]\n",
  "SYNTH": "(short for) a synthesiser [n -S]\n",
  "SYNTHASE": "an enzyme that catalyses a particular synthesis [n -S]\n",
  "SYNTHASES": "SYNTHASE, an enzyme that catalyses a particular synthesis [n]\n",
  "SYNTHESES": "SYNTHESIS, a putting together [n]\n",
  "SYNTHESIS": "a putting together [n SYNTHESES]\n",
  "SYNTHESISATION": "the process of synthesising, also SYNTHESIZATION [n -S]\n",
  "SYNTHESISATIONS": "SYNTHESISATION, the process of synthesising, also SYNTHESIZATION [n]\n",
  "SYNTHESISE": "to combine or produce by synthesis, also SYNTHESIZE [v SYNTHESISED, SYNTHESISING, SYNTHESISES]\n",
  "SYNTHESISED": "SYNTHESISE, to combine or produce by synthesis, also SYNTHESIZE [v]\n",
  "SYNTHESISER": "a person who, or thing which, synthesizes, also SYNTHESIZER [n -S]\n",
  "SYNTHESISERS": "SYNTHESISER, a person who, or thing which, synthesizes, also SYNTHESIZER [n]\n",
  "SYNTHESISES": "SYNTHESISE, to combine or produce by synthesis, also SYNTHESIZE [v]\n",
  "SYNTHESISING": "SYNTHESISE, to combine or produce by synthesis, also SYNTHESIZE [v]\n",
  "SYNTHESIST": "someone who makes a synthesis [n -S]\n",
  "SYNTHESISTS": "SYNTHESIST, someone who makes a synthesis [n]\n",
  "SYNTHESIZATION": "the process of synthesizing, also SYNTHESISATION [n -S]\n",
  "SYNTHESIZATIONS": "SYNTHESIZATION, the process of synthesizing, also SYNTHESISATION [n]\n",
  "SYNTHESIZE": "to combine or produce by synthesis, also SYNTHESISE [v SYNTHESIZED, SYNTHESIZING, SYNTHESIZES]\n",
  "SYNTHESIZED": "SYNTHESIZE, to combine or produce by synthesis, also SYNTHESISE [v]\n",
  "SYNTHESIZER": "a person who, or thing which, synthesizes, also SYNTHESISER [n -S]\n",
  "SYNTHESIZERS": "SYNTHESIZER, a person who, or thing which, synthesizes, also SYNTHESISER [n]\n",
  "SYNTHESIZES": "SYNTHESIZE, to combine or produce by synthesis, also SYNTHESISE [v]\n",
  "SYNTHESIZING": "SYNTHESIZE, to combine or produce by synthesis, also SYNTHESISE [v]\n",
  "SYNTHESPIAN": "a computer-generated image of a film actor used in place of the actor when filming stunts [n -S]\n",
  "SYNTHESPIANS": "SYNTHESPIAN, a computer-generated image of a film actor used in place of the actor when filming stunts [n]\n",
  "SYNTHETASE": "a kind of enzyme [n -S]\n",
  "SYNTHETASES": "SYNTHETASE, a kind of enzyme [n]\n",
  "SYNTHETIC": "artificially produced but of similar nature to, not a mere substitute for, the natural product, also SYNTHETICAL [adj SYNTHETICALLY] / a synthetic substance [n -S]\n",
  "SYNTHETICAL": "artificially produced but of similar nature to, not a mere substitute for, the natural product, also SYNTHETIC [adj SYNTHETICALLY]\n",
  "SYNTHETICALLY": "SYNTHETICAL, artificially produced but of similar nature to, not a mere substitute for, the natural product, also SYNTHETIC [adv]\n",
  "SYNTHETICISM": "the principles of synthesis, a synthetic system [n -S]\n",
  "SYNTHETICISMS": "SYNTHETICISM, the principles of synthesis, a synthetic system [n]\n",
  "SYNTHETICS": "SYNTHETIC, a synthetic substance [n]\n",
  "SYNTHETISATION": "the process of synthetising, also SYNTHETIZATION [n -S]\n",
  "SYNTHETISATIONS": "SYNTHETISATION, the process of synthetising, also SYNTHETIZATION [n]\n",
  "SYNTHETISE": "to put together in a synthesis, also SYNTHETIZE [v SYNTHETISED, SYNTHETISING, SYNTHETISES]\n",
  "SYNTHETISED": "SYNTHETISE, to put together in a synthesis, also SYNTHETIZE [v]\n",
  "SYNTHETISER": "one who synthetises, also SYNTHETIZER [n -S]\n",
  "SYNTHETISERS": "SYNTHETISER, one who synthetises, also SYNTHETIZER [n]\n",
  "SYNTHETISES": "SYNTHETISE, to put together in a synthesis, also SYNTHETIZE [v]\n",
  "SYNTHETISING": "SYNTHETISE, to put together in a synthesis, also SYNTHETIZE [v]\n",
  "SYNTHETISM": "the symbolism of Gauguin and the Nabis, who reacted against the impressionists and realists by seeking to produce brightly coloured abstractions of their inner experience [n -S]\n",
  "SYNTHETISMS": "SYNTHETISM, the symbolism of Gauguin and the Nabis, who reacted against the impressionists and realists by seeking to produce brightly coloured abstractions of their inner experience [n]\n",
  "SYNTHETIST": "one who synthetises [n -S]\n",
  "SYNTHETISTS": "SYNTHETIST, one who synthetises [n]\n",
  "SYNTHETIZATION": "the process of synthetizing, also SYNTHETISATION [n -S]\n",
  "SYNTHETIZATIONS": "SYNTHETIZATION, the process of synthetizing, also SYNTHETISATION [n]\n",
  "SYNTHETIZE": "to put together in a synthesis, also SYNTHETISE [v SYNTHETIZED, SYNTHETIZING, SYNTHETIZES]\n",
  "SYNTHETIZED": "SYNTHETIZE, to put together in a synthesis, also SYNTHETISE [v]\n",
  "SYNTHETIZER": "one who synthetizes, also SYNTHETISER [n -S]\n",
  "SYNTHETIZERS": "SYNTHETIZER, one who synthetizes, also SYNTHETISER [n]\n",
  "SYNTHETIZES": "SYNTHETIZE, to put together in a synthesis, also SYNTHETISE [v]\n",
  "SYNTHETIZING": "SYNTHETIZE, to put together in a synthesis, also SYNTHETISE [v]\n",
  "SYNTHON": "a constituent part in the synthesis process [n -S]\n",
  "SYNTHONS": "SYNTHON, a constituent part in the synthesis process [n]\n",
  "SYNTHPOP": "popular music played with synthesizers [n -S]\n",
  "SYNTHPOPS": "SYNTHPOP, popular music played with synthesizers [n]\n",
  "SYNTHRONI": "SYNTHRONUS, the seat of a bishop and his presbyters, behind the altar [n]\n",
  "SYNTHRONUS": "the seat of a bishop and his presbyters, behind the altar [n SYNTHRONI]\n",
  "SYNTHS": "SYNTH, (short for) a synthesiser [n]\n",
  "SYNTONE": "a person having a syntonic temperament [n -S]\n",
  "SYNTONES": "SYNTONE, a person having a syntonic temperament [n]\n",
  "SYNTONIC": "pertaining to syntony; in harmony with one's surroundings, also SYNTONOUS [adj SYNTONICALLY]\n",
  "SYNTONICALLY": "SYNTONIC, pertaining to syntony; in harmony with one's surroundings, also SYNTONOUS [adv]\n",
  "SYNTONIES": "SYNTONY, the tuning of transmitters and receivers with each other [n]\n",
  "SYNTONIN": "a substance similar to fibrin [n -S]\n",
  "SYNTONINS": "SYNTONIN, a substance similar to fibrin [n]\n",
  "SYNTONISE": "to adjust to agree in frequency, also SYNTONIZE [v SYNTONISED, SYNTONISING, SYNTONISES]\n",
  "SYNTONISED": "SYNTONISE, to adjust to agree in frequency, also SYNTONIZE [v]\n",
  "SYNTONISES": "SYNTONISE, to adjust to agree in frequency, also SYNTONIZE [v]\n",
  "SYNTONISING": "SYNTONISE, to adjust to agree in frequency, also SYNTONIZE [v]\n",
  "SYNTONIZE": "to adjust to agree in frequency, also SYNTONISE [v SYNTONIZED, SYNTONIZING, SYNTONIZES]\n",
  "SYNTONIZED": "SYNTONIZE, to adjust to agree in frequency, also SYNTONISE [v]\n",
  "SYNTONIZES": "SYNTONIZE, to adjust to agree in frequency, also SYNTONISE [v]\n",
  "SYNTONIZING": "SYNTONIZE, to adjust to agree in frequency, also SYNTONISE [v]\n",
  "SYNTONOUS": "pertaining to syntony; in harmony with one's surroundings, also SYNTONIC [adj]\n",
  "SYNTONY": "the tuning of transmitters and receivers with each other [n SYNTONIES]\n",
  "SYNTYPE": "each of a set of type specimens on which the name of a new species is based [n -S]\n",
  "SYNTYPES": "SYNTYPE, each of a set of type specimens on which the name of a new species is based [n]\n",
  "SYNURA": "(Latin) any of several species of green algae [n SYNURAE]\n",
  "SYNURAE": "SYNURA, (Latin) any of several species of green algae [n]\n",
  "SYPE": "(dialect) to soak through, seep, also SIPE [v SYPED, SYPING, SYPES]\n",
  "SYPED": "SYPE, (dialect) to soak through, seep, also SIPE [v]\n",
  "SYPES": "SYPE, (dialect) to soak through, seep, also SIPE [v]\n",
  "SYPH": "a venereal disease, also SYPHILIS [n -S]\n",
  "SYPHER": "to lay an edge over another to make a flush surface [v -ED, -ING, -S]\n",
  "SYPHERED": "SYPHER, to lay an edge over another to make a flush surface [v]\n",
  "SYPHERING": "joining boards edge to edge or overlapping to form a level surface [n -S]\n",
  "SYPHERINGS": "SYPHERING, joining boards edge to edge or overlapping to form a level surface [n]\n",
  "SYPHERS": "SYPHER, to lay an edge over another to make a flush surface [v]\n",
  "SYPHILIS": "a venereal disease, also SYPH [n -ES]\n",
  "SYPHILISATION": "the process of syphilising, also SYPHILIZATION [n -S]\n",
  "SYPHILISATIONS": "SYPHILISATION, the process of syphilising, also SYPHILIZATION [n]\n",
  "SYPHILISE": "to inoculate or infect with syphilis, also SYPHILIZE [v SYPHILISED, SYPHILISING, SYPHILISES]\n",
  "SYPHILISED": "SYPHILISE, to inoculate or infect with syphilis, also SYPHILIZE [v]\n",
  "SYPHILISES": "SYPHILIS, a venereal disease, also SYPH [n]\n",
  "SYPHILISING": "SYPHILISE, to inoculate or infect with syphilis, also SYPHILIZE [v]\n",
  "SYPHILITIC": "of or like syphilis, a venereal disease [adj SYPHILITICALLY] / one suffering from syphilis [n -S]\n",
  "SYPHILITICALLY": "SYPHILITIC, of or like syphilis, a venereal disease [adv]\n",
  "SYPHILITICS": "SYPHILITIC, one suffering from syphilis [n]\n",
  "SYPHILIZATION": "the process of syphilizing, also SYPHILISATION [n -S]\n",
  "SYPHILIZATIONS": "SYPHILIZATION, the process of syphilizing, also SYPHILISATION [n]\n",
  "SYPHILIZE": "to inoculate or infect with syphilis, also SYPHILISE [v SYPHILIZED, SYPHILIZING, SYPHILIZES]\n",
  "SYPHILIZED": "SYPHILIZE, to inoculate or infect with syphilis, also SYPHILISE [v]\n",
  "SYPHILIZES": "SYPHILIZE, to inoculate or infect with syphilis, also SYPHILISE [v]\n",
  "SYPHILIZING": "SYPHILIZE, to inoculate or infect with syphilis, also SYPHILISE [v]\n",
  "SYPHILOID": "like syphilis [adj]\n",
  "SYPHILOLOGIES": "SYPHILOLOGY, the study of syphilis [n]\n",
  "SYPHILOLOGIST": "a specialist in syphilology [n -S]\n",
  "SYPHILOLOGISTS": "SYPHILOLOGIST, a specialist in syphilology [n]\n",
  "SYPHILOLOGY": "the study of syphilis [n SYPHILOLOGIES]\n",
  "SYPHILOMA": "a syphilitic tumour [n SYPHILOMAS or SYPHILOMATA]\n",
  "SYPHILOMAS": "SYPHILOMA, a syphilitic tumour [n]\n",
  "SYPHILOMATA": "SYPHILOMA, a syphilitic tumour [n]\n",
  "SYPHILOPHOBIA": "fear of syphilis [n -S]\n",
  "SYPHILOPHOBIAS": "SYPHILOPHOBIA, fear of syphilis [n]\n",
  "SYPHON": "to draw off through a tube, also SIPHON [v -ED, -ING, -S]\n",
  "SYPHONAGE": "the action of a syphon, also SIPHONAGE [n -S]\n",
  "SYPHONAGES": "SYPHONAGE, the action of a syphon, also SIPHONAGE [n]\n",
  "SYPHONAL": "like a syphon, also SYPHONIC [adj]\n",
  "SYPHONED": "SYPHON, to draw off through a tube, also SIPHON [v]\n",
  "SYPHONIC": "like a syphon, also SYPHONAL [adj]\n",
  "SYPHONING": "SYPHON, to draw off through a tube, also SIPHON [v]\n",
  "SYPHONS": "SYPHON, to draw off through a tube, also SIPHON [v]\n",
  "SYPHS": "SYPH, a venereal disease, also SYPHILIS [n]\n",
  "SYPING": "SYPE, (dialect) to soak through, seep, also SIPE [v]\n",
  "SYRAH": "a red wine grape [n -S]\n",
  "SYRAHS": "SYRAH, a red wine grape [n]\n",
  "SYREN": "a siren [n -S]\n",
  "SYRENS": "SYREN, a siren [n]\n",
  "SYRETTE": "a small tube fitted with a hypodermic needle containing a single dose of medication [n -S]\n",
  "SYRETTES": "SYRETTE, a small tube fitted with a hypodermic needle containing a single dose of medication [n]\n",
  "SYRINGA": "an ornamental shrub, aka mock orange [n -S]\n",
  "SYRINGAS": "SYRINGA, an ornamental shrub, aka mock orange [n]\n",
  "SYRINGE": "to treat with injected fluid [v SYRINGED, SYRINGING, SYRINGES]\n",
  "SYRINGEAL": "of, pertaining to, or connected with the syrinx of a bird [adj]\n",
  "SYRINGED": "SYRINGE, to treat with injected fluid [v]\n",
  "SYRINGES": "SYRINGE, to treat with injected fluid [v]\n",
  "SYRINGING": "SYRINGE, to treat with injected fluid [v]\n",
  "SYRINGITIS": "inflammation of the Eustachian tube [n -ES]\n",
  "SYRINGITISES": "SYRINGITIS, inflammation of the Eustachian tube [n]\n",
  "SYRINGOMYELIA": "a chronic progressive disease of the spinal cord associated with sensory disturbances, muscle atrophy, and spasticity [n -S]\n",
  "SYRINGOMYELIAS": "SYRINGOMYELIA, a chronic progressive disease of the spinal cord associated with sensory disturbances, muscle atrophy, and spasticity [n]\n",
  "SYRINGOMYELIC": "relating to syringomyelia [adj]\n",
  "SYRINGOTOMIES": "SYRINGOTOMY, cutting of a fistula [n]\n",
  "SYRINGOTOMY": "cutting of a fistula [n SYRINGOTOMIES]\n",
  "SYRINX": "(Greek) the vocal organ of a bird [n -ES]\n",
  "SYRINXES": "SYRINX, (Greek) the vocal organ of a bird [n]\n",
  "SYRPHIAN": "a wasplike fly, also SYRPHID [n -S]\n",
  "SYRPHIANS": "SYRPHIAN, a wasplike fly, also SYRPHID [n]\n",
  "SYRPHID": "(Greek) a wasplike fly, also SYRPHIAN [n -S]\n",
  "SYRPHIDS": "SYRPHID, (Greek) a wasplike fly, also SYRPHIAN [n]\n",
  "SYRTES": "SYRTIS, (Milton) an area of quicksand [n]\n",
  "SYRTIS": "(Milton) an area of quicksand [n SYRTES]\n",
  "SYRUP": "to make into a thick, sweet liquid, also SIRUP [v -ED, -ING, -S]\n",
  "SYRUPED": "SYRUP, to make into a thick, sweet liquid, also SIRUP [v]\n",
  "SYRUPIER": "SYRUPY, like syrup, also SIRUPY [adj]\n",
  "SYRUPIEST": "SYRUPY, like syrup, also SIRUPY [adj]\n",
  "SYRUPING": "SYRUP, to make into a thick, sweet liquid, also SIRUP [v]\n",
  "SYRUPLIKE": "like syrup [adj]\n",
  "SYRUPS": "SYRUP, to make into a thick, sweet liquid, also SIRUP [v]\n",
  "SYRUPY": "like syrup, also SIRUPY [adj SYRUPIER, SYRUPIEST]\n",
  "SYSADMIN": "a computer system administrator [n -S]\n",
  "SYSADMINS": "SYSADMIN, a computer system administrator [n]\n",
  "SYSOP": "(short for) systems operator, the administrator of a computer bulletin board [n -S]\n",
  "SYSOPS": "SYSOP, (short for) systems operator, the administrator of a computer bulletin board [n]\n",
  "SYSSARCOSES": "SYSSARCOSIS, the union of bones, as the hyoid bone (the U-shaped bone at the base of the mouth) and the lower jaw, by muscle [n]\n",
  "SYSSARCOSIS": "the union of bones, as the hyoid bone (the U-shaped bone at the base of the mouth) and the lower jaw, by muscle [n SYSSARCOSES]\n",
  "SYSSARCOTIC": "relating to syssarcosis, the union of bones [adj]\n",
  "SYSSITIA": "(Greek) the ancient Spartan custom of eating the main meal together in public [n -S]\n",
  "SYSSITIAS": "SYSSITIA, (Greek) the ancient Spartan custom of eating the main meal together in public [n]\n",
  "SYSTALTIC": "of the nature of contraction, esp. with alternate contraction and dilatation [adj]\n",
  "SYSTEM": "a group of interacting elements forming a unified whole [n -S]\n",
  "SYSTEMATIC": "relating to or consisting of a system, also SYSTEMATICAL [adj SYSTEMATICALLY]\n",
  "SYSTEMATICAL": "relating to or consisting of a system, also SYSTEMATIC [adj SYSTEMATICALLY]\n",
  "SYSTEMATICALLY": "SYSTEMATICAL, relating to or consisting of a system, also SYSTEMATIC [adv]\n",
  "SYSTEMATICIAN": "one who studies systems [n -S]\n",
  "SYSTEMATICIANS": "SYSTEMATICIAN, one who studies systems [n]\n",
  "SYSTEMATICNESS": "the state of being systematic [n]\n",
  "SYSTEMATICS": "the new science of taxonomy [n]\n",
  "SYSTEMATISATION": "the act of systematising, also SYSTEMATIZATION [n]\n",
  "SYSTEMATISE": "to reduce to a system, also SYSTEMATIZE [v SYSTEMATISED, SYSTEMATISING, SYSTEMATISES]\n",
  "SYSTEMATISED": "SYSTEMATISE, to reduce to a system, also SYSTEMATIZE [v]\n",
  "SYSTEMATISER": "one who systematises, also SYSTEMATIZER [n -S]\n",
  "SYSTEMATISERS": "SYSTEMATISER, one who systematises, also SYSTEMATIZER [n]\n",
  "SYSTEMATISES": "SYSTEMATISE, to reduce to a system, also SYSTEMATIZE [v]\n",
  "SYSTEMATISING": "SYSTEMATISE, to reduce to a system, also SYSTEMATIZE [v]\n",
  "SYSTEMATISM": "the practice of forming intellectual systems [n -S]\n",
  "SYSTEMATISMS": "SYSTEMATISM, the practice of forming intellectual systems [n]\n",
  "SYSTEMATIST": "a person who constructs or follows a system; specifically a biologist specializing in systematics [n -S]\n",
  "SYSTEMATISTS": "SYSTEMATIST, a person who constructs or follows a system; specifically a biologist specializing in systematics [n]\n",
  "SYSTEMATIZATION": "the act of systematizing, also SYSTEMATISATION [n]\n",
  "SYSTEMATIZE": "to reduce to a system, also SYSTEMATISE [v SYSTEMATIZED, SYSTEMATIZING, SYSTEMATIZES]\n",
  "SYSTEMATIZED": "SYSTEMATIZE, to reduce to a system, also SYSTEMATISE [v]\n",
  "SYSTEMATIZER": "one who systematizes, also SYSTEMATISER [n -S]\n",
  "SYSTEMATIZERS": "SYSTEMATIZER, one who systematizes, also SYSTEMATISER [n]\n",
  "SYSTEMATIZES": "SYSTEMATIZE, to reduce to a system, also SYSTEMATISE [v]\n",
  "SYSTEMATIZING": "SYSTEMATIZE, to reduce to a system, also SYSTEMATISE [v]\n",
  "SYSTEMATOLOGIES": "SYSTEMATOLOGY, the study of systems [n]\n",
  "SYSTEMATOLOGY": "the study of systems [n SYSTEMATOLOGIES]\n",
  "SYSTEMED": "having a system [adj]\n",
  "SYSTEMIC": "relating to a system [adj SYSTEMICALLY] / something affecting the whole system, as a systemic pesticide [n -S]\n",
  "SYSTEMICALLY": "SYSTEMIC, relating to a system [adv]\n",
  "SYSTEMICS": "SYSTEMIC, something affecting the whole system, as a systemic pesticide [n]\n",
  "SYSTEMISATION": "the act of systemising, also SYSTEMIZATION [n -S]\n",
  "SYSTEMISATIONS": "SYSTEMISATION, the act of systemising, also SYSTEMIZATION [n]\n",
  "SYSTEMISE": "to reduce to a system, also SYSTEMIZE [v SYSTEMISED, SYSTEMISING, SYSTEMISES]\n",
  "SYSTEMISED": "SYSTEMISE, to reduce to a system, also SYSTEMIZE [v]\n",
  "SYSTEMISER": "one who systemises, also SYSTEMIZER [n -S]\n",
  "SYSTEMISERS": "SYSTEMISER, one who systemises, also SYSTEMIZER [n]\n",
  "SYSTEMISES": "SYSTEMISE, to reduce to a system, also SYSTEMIZE [v]\n",
  "SYSTEMISING": "SYSTEMISE, to reduce to a system, also SYSTEMIZE [v]\n",
  "SYSTEMIZATION": "the act of systemizing, also SYSTEMISATION [n -S]\n",
  "SYSTEMIZATIONS": "SYSTEMIZATION, the act of systemizing, also SYSTEMISATION [n]\n",
  "SYSTEMIZE": "to reduce to a system, also SYSTEMISE [v SYSTEMIZED, SYSTEMIZING, SYSTEMIZES]\n",
  "SYSTEMIZED": "SYSTEMIZE, to reduce to a system, also SYSTEMISE [v]\n",
  "SYSTEMIZER": "one who systemizes, also SYSTEMISER [n -S]\n",
  "SYSTEMIZERS": "SYSTEMIZER, one who systemizes, also SYSTEMISER [n]\n",
  "SYSTEMIZES": "SYSTEMIZE, to reduce to a system, also SYSTEMISE [v]\n",
  "SYSTEMIZING": "SYSTEMIZE, to reduce to a system, also SYSTEMISE [v]\n",
  "SYSTEMLESS": "without a system [adj]\n",
  "SYSTEMS": "SYSTEM, a group of interacting elements forming a unified whole [n]\n",
  "SYSTOLE": "(Greek) the normal rhythmic contraction of the heart [n -S]\n",
  "SYSTOLES": "SYSTOLE, (Greek) the normal rhythmic contraction of the heart [n]\n",
  "SYSTOLIC": "of or like systole, the rhythmic contraction of the heart [adj]\n",
  "SYSTYLE": "a building with intercolumniation of two diameters [n -S]\n",
  "SYSTYLES": "SYSTYLE, a building with intercolumniation of two diameters [n]\n",
  "SYTHE": "(Spenser) a time [n -S]\n",
  "SYTHES": "SYTHE, (Spenser) a time [n]\n",
  "SYVER": "(Scots) a drain; a grating over a drain, also SIVER [n -S]\n",
  "SYVERS": "SYVER, (Scots) a drain; a grating over a drain, also SIVER [n]\n",
  "SYZYGAL": "related to a syzygy, also SYZYGETIC, SYZYGIAL [adj]\n",
  "SYZYGETIC": "relating to a syzygy, also SYZYGAL, SYZYGIAL [adj SYZYGETICALLY]\n",
  "SYZYGETICALLY": "SYZYGETIC, relating to a syzygy, also SYZYGAL, SYZYGIAL [adv]\n",
  "SYZYGIAL": "related to a syzygy, also SYZYGAL, SYZYGETIC [adj]\n",
  "SYZYGIES": "SYZYGY, (Greek) the configuration of the earth, moon and sun lying in a straight line [n]\n",
  "SYZYGY": "(Greek) the configuration of the earth, moon and sun lying in a straight line [n SYZYGIES]\n",
  "TA": "an expression meaning thank you [n -S]\n",
  "TAAL": "(South African) the Afrikaans language [n -S]\n",
  "TAALS": "TAAL, (South African) the Afrikaans language [n]\n",
  "TAATA": "(East Africa) a child's word for father [n -S]\n",
  "TAATAS": "TAATA, (East Africa) a child's word for father [n]\n",
  "TAB": "to provide with an identifying mark [v TABBED, TABBING, TABS]\n",
  "TABANID": "(Latin) a bloodsucking insect of the gadfly genus [n -S]\n",
  "TABANIDS": "TABANID, (Latin) a bloodsucking insect of the gadfly genus [n]\n",
  "TABARD": "a herald's or knight's cape over his armor blazoned with his coat of arms [n -S]\n",
  "TABARDED": "wearing a tabard [adj]\n",
  "TABARDS": "TABARD, a herald's or knight's cape over his armor blazoned with his coat of arms [n]\n",
  "TABARET": "an upholsterer's silk fabric, with alternate stripes of watered and satin surface [n -S]\n",
  "TABARETS": "TABARET, an upholsterer's silk fabric, with alternate stripes of watered and satin surface [n]\n",
  "TABASHEER": "(Hindi) a siliceous substance sometimes found in crude form in hollows of bamboos, used in Eastern medicine, also TABASHIR [n -S]\n",
  "TABASHEERS": "TABASHEER, (Hindi) a siliceous substance sometimes found in crude form in hollows of bamboos, used in Eastern medicine, also TABASHIR [n]\n",
  "TABASHIR": "(Portuguese) a siliceous substance sometimes found in crude form in hollows of bamboos, used in Eastern medicine, also TABASHEER [n -S]\n",
  "TABASHIRS": "TABASHIR, (Portuguese) a siliceous substance sometimes found in crude form in hollows of bamboos, used in Eastern medicine, also TABASHEER [n]\n",
  "TABBED": "TAB, to provide with an identifying mark [v]\n",
  "TABBIED": "TABBY, to water silk to cause it look wavy [v]\n",
  "TABBIER": "TABBY, brindled [adj]\n",
  "TABBIES": "TABBY, to water silk to cause it look wavy [v]\n",
  "TABBIEST": "TABBY, brindled [adj]\n",
  "TABBINET": "a fabric like poplin, with a watered surface, also TABINET [n -S]\n",
  "TABBINETS": "TABBINET, a fabric like poplin, with a watered surface, also TABINET [n]\n",
  "TABBING": "the use of the tab key on a keyboard [n -S]\n",
  "TABBINGS": "TABBING, the use of the tab key on a keyboard [n]\n",
  "TABBIS": "a silk fabric [n -ES]\n",
  "TABBISES": "TABBIS, a silk fabric [n]\n",
  "TABBOULEH": "(Arabic) a kind of Lebanese salad, also TABBOULI, TABOOLEY, TABOULEH, TABOULI, TABULI [n -S]\n",
  "TABBOULEHS": "TABBOULEH, (Arabic) a kind of Lebanese salad, also TABBOULI, TABOOLEY, TABOULEH, TABOULI, TABULI [n]\n",
  "TABBOULI": "(Arabic) a kind of Lebanese salad, also TABBOULEH, TABOOLEY, TABOULEH, TABOULI, TABULI [n -S]\n",
  "TABBOULIS": "TABBOULI, (Arabic) a kind of Lebanese salad, also TABBOULEH, TABOOLEY, TABOULEH, TABOULI, TABULI [n]\n",
  "TABBY": "brindled [adj TABBIER, TABBIEST] / to water silk to cause it look wavy [v TABBIED, TABBYING, TABBIES]\n",
  "TABBYHOOD": "(obsolete) the state of being an old maid [n -S]\n",
  "TABBYHOODS": "TABBYHOOD, (obsolete) the state of being an old maid [n]\n",
  "TABBYING": "TABBY, to water silk to cause it look wavy [v]\n",
  "TABEFACTION": "wasting away, emaciation [n -S]\n",
  "TABEFACTIONS": "TABEFACTION, wasting away, emaciation [n]\n",
  "TABEFIED": "TABEFY, to waste away [v]\n",
  "TABEFIES": "TABEFY, to waste away [v]\n",
  "TABEFY": "to waste away [v TABEFIED, TABEFYING, TABEFIES]\n",
  "TABEFYING": "TABEFY, to waste away [v]\n",
  "TABELLION": "(Latin) an official scrivener in the Roman empire and elsewhere [n -S]\n",
  "TABELLIONS": "TABELLION, (Latin) an official scrivener in the Roman empire and elsewhere [n]\n",
  "TABER": "a light medieval drum buckled onto the player's chest, also TABOR, TABOUR [n -S] / to play on this [v -ED, -ING, -S]\n",
  "TABERD": "a herald's or knight's cape over his armor blazoned with his coat of arms [n -S]\n",
  "TABERDAR": "a scholar of Queen's College, Oxford, named for the gown they wore [n -S]\n",
  "TABERDARS": "TABERDAR, a scholar of Queen's College, Oxford, named for the gown they wore [n]\n",
  "TABERDS": "TABERD, a herald's or knight's cape over his armor blazoned with his coat of arms [n]\n",
  "TABERED": "TABER, to play on this [v]\n",
  "TABERING": "TABER, to play on this [v]\n",
  "TABERNACLE": "the tent carried by the Jews through the desert, used as a temple and to house the Ark of the Covenant; a tent or movable hut [n -S] / to sojourn [v TABERNACLED, TABERNACLING, TABERNACLES]\n",
  "TABERNACLED": "TABERNACLE, to sojourn [v]\n",
  "TABERNACLES": "TABERNACLE, the tent carried by the Jews through the desert, used as a temple and to house the Ark of the Covenant; a tent or movable hut [n]\n",
  "TABERNACLING": "TABERNACLE, to sojourn [v]\n",
  "TABERNACULAR": "of or like a tabernacle [adj]\n",
  "TABERS": "TABER, to play on this [v]\n",
  "TABES": "(Latin) a syphilitic disease [n TABES]\n",
  "TABESCENCE": "a wasting, a shrivelling [n -S]\n",
  "TABESCENCES": "TABESCENCE, a wasting, a shrivelling [n]\n",
  "TABESCENT": "wasting; shrivelling [adj]\n",
  "TABETIC": "one affected with tabes [n -S]\n",
  "TABETICS": "TABETIC, one affected with tabes [n]\n",
  "TABI": "(Japanese) a kind of sock worn with Japanese sandals [n -S]\n",
  "TABID": "affected by tabes, progressive emaciation of the body [adj]\n",
  "TABINET": "a delicate material, also TABBINET [n -S]\n",
  "TABINETS": "TABINET, a delicate material, also TABBINET [n]\n",
  "TABIS": "TABI, (Japanese) a kind of sock worn with Japanese sandals [n]\n",
  "TABLA": "(Hindi) an Indian percussion instrument, a pair of small drums [n -S]\n",
  "TABLANETTE": "(French) a variant of the card game cassino [n -S]\n",
  "TABLANETTES": "TABLANETTE, (French) a variant of the card game cassino [n]\n",
  "TABLAS": "TABLA, (Hindi) an Indian percussion instrument, a pair of small drums [n]\n",
  "TABLATURE": "an old notation for lute music etc. [n -S]\n",
  "TABLATURES": "TABLATURE, an old notation for lute music etc. [n]\n",
  "TABLE": "to place on furniture having a large flat surface [v TABLED, TABLING, TABLES]\n",
  "TABLEAU": "(French) a picture or vivid pictorial impression [n TABLEAUS or TABLEAUX]\n",
  "TABLEAUS": "TABLEAU, (French) a picture or vivid pictorial impression [n]\n",
  "TABLEAUX": "TABLEAU, (French) a picture or vivid pictorial impression [n]\n",
  "TABLECLOTH": "a covering spread over a dining table before the tableware is set [n -S]\n",
  "TABLECLOTHS": "TABLECLOTH, a covering spread over a dining table before the tableware is set [n]\n",
  "TABLED": "TABLE, to place on furniture having a large flat surface [v]\n",
  "TABLEFUL": "the contents of a table [n TABLEFULS or TABLESFUL]\n",
  "TABLEFULS": "TABLEFUL, the contents of a table [n]\n",
  "TABLELAND": "a plateau [n -S]\n",
  "TABLELANDS": "TABLELAND, a plateau [n]\n",
  "TABLELESS": "without a table [adj]\n",
  "TABLEMAT": "a small mat used on a table to protect the surface of the table from the plate and from food [n -S]\n",
  "TABLEMATE": "one who shares a table [n -S]\n",
  "TABLEMATES": "TABLEMATE, one who shares a table [n]\n",
  "TABLEMATS": "TABLEMAT, a small mat used on a table to protect the surface of the table from the plate and from food [n]\n",
  "TABLES": "TABLE, to place on furniture having a large flat surface [v]\n",
  "TABLESFUL": "TABLEFUL, the contents of a table [n]\n",
  "TABLESIDE": "(of food preparation etc.) performed adjacent to the table of a dining patron [adj]\n",
  "TABLESPOON": "a large spoon used esp. for serving [n -S]\n",
  "TABLESPOONFUL": "the contents of a tablespoon [n TABLESPOONFULS or TABLESPOONSFUL]\n",
  "TABLESPOONFULS": "TABLESPOONFUL, the contents of a tablespoon [n]\n",
  "TABLESPOONS": "TABLESPOON, a large spoon used esp. for serving [n]\n",
  "TABLESPOONSFUL": "TABLESPOONFUL, the contents of a tablespoon [n]\n",
  "TABLET": "to write on a small flat surface [v TABLETED or TABLETTED, TABLETING or TABLETTING, TABLETS]\n",
  "TABLETED": "TABLET, to write on a small flat surface [v]\n",
  "TABLETING": "TABLET, to write on a small flat surface [v]\n",
  "TABLETOP": "the top of a table [n -S]\n",
  "TABLETOPPED": "having a tabletop [adj]\n",
  "TABLETOPS": "TABLETOP, the top of a table [n]\n",
  "TABLETS": "TABLET, to write on a small flat surface [v]\n",
  "TABLETTED": "TABLET, to write on a small flat surface [v]\n",
  "TABLETTING": "TABLET, to write on a small flat surface [v]\n",
  "TABLEWARE": "ware, or articles collectively, for table use [n -S]\n",
  "TABLEWARES": "TABLEWARE, ware, or articles collectively, for table use [n]\n",
  "TABLEWISE": "in the manner of a table [adv]\n",
  "TABLIER": "(historical) an apron; a part of dress resembling an apron [n -S]\n",
  "TABLIERS": "TABLIER, (historical) an apron; a part of dress resembling an apron [n]\n",
  "TABLING": "the presentation of a paper for discussion [n -S]\n",
  "TABLINGS": "TABLING, the presentation of a paper for discussion [n]\n",
  "TABLOID": "a small newspaper [n -S]\n",
  "TABLOIDIER": "TABLOIDY, like a tabloid newspaper [adj]\n",
  "TABLOIDIEST": "TABLOIDY, like a tabloid newspaper [adj]\n",
  "TABLOIDS": "TABLOID, a small newspaper [n]\n",
  "TABLOIDY": "like a tabloid newspaper [adj TABLOIDIER, TABLOIDIEST]\n",
  "TABOGGAN": "a kind of sledge, also TARBOGGIN, TOBOGGAN, TOBOGGIN [n -S] / to sledge on a taboggan [v -ED, -ING, -S]\n",
  "TABOGGANED": "TABOGGAN, to sledge on a taboggan [v]\n",
  "TABOGGANING": "TABOGGAN, to sledge on a taboggan [v]\n",
  "TABOGGANS": "TABOGGAN, to sledge on a taboggan [v]\n",
  "TABOO": "(Tongan) to exclude or prohibit by social influence, also TABU [v -ED, -ING, -S]\n",
  "TABOOED": "TABOO, (Tongan) to exclude or prohibit by social influence, also TABU [v]\n",
  "TABOOING": "TABOO, (Tongan) to exclude or prohibit by social influence, also TABU [v]\n",
  "TABOOLEY": "(Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOULEH, TABOULI, TABULI [n -S]\n",
  "TABOOLEYS": "TABOOLEY, (Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOULEH, TABOULI, TABULI [n]\n",
  "TABOOS": "TABOO, (Tongan) to exclude or prohibit by social influence, also TABU [v]\n",
  "TABOPARESES": "TABOPARESIS, an effect of syphilitic infection of the nervous system in which there are symptoms of tabes dorsalis and general paresis [n]\n",
  "TABOPARESIS": "an effect of syphilitic infection of the nervous system in which there are symptoms of tabes dorsalis and general paresis [n TABOPARESES]\n",
  "TABOR": "a light medieval drum buckled onto the player's chest, also TABER, TABOUR [n -S] / to play on this [v -ED, -ING, -S]\n",
  "TABORED": "TABOR, to play on this [v]\n",
  "TABORER": "one who tabors, also TABOURER [n -S]\n",
  "TABORERS": "TABORER, one who tabors, also TABOURER [n]\n",
  "TABORET": "a low stool without a back or arms; a low stand or cabinet; an embroidery frame, also TABOURET [n -S]\n",
  "TABORETS": "TABORET, a low stool without a back or arms; a low stand or cabinet; an embroidery frame, also TABOURET [n]\n",
  "TABORIN": "a small drum, also TABORET, TABORINE, TABOURET [n -S]\n",
  "TABORINE": "a small drum, also TABORET, TABORIN, TABOURET [n -S]\n",
  "TABORINES": "TABORINE, a small drum, also TABORET, TABORIN, TABOURET [n]\n",
  "TABORING": "TABOR, to play on this [v]\n",
  "TABORINS": "TABORIN, a small drum, also TABORET, TABORINE, TABOURET [n]\n",
  "TABORS": "TABOR, to play on this [v]\n",
  "TABOULEH": "(Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOOLEY, TABOULI, TABULI [n -S]\n",
  "TABOULEHS": "TABOULEH, (Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOOLEY, TABOULI, TABULI [n]\n",
  "TABOULI": "(Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOOLEY, TABOULEH, TABULI [n -S]\n",
  "TABOULIS": "TABOULI, (Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOOLEY, TABOULEH, TABULI [n]\n",
  "TABOUR": "to beat on a small drum, also TABOR, TABER [v -ED, -ING, -S]\n",
  "TABOURED": "TABOUR, to beat on a small drum, also TABOR, TABER [v]\n",
  "TABOURER": "one who tabors, also TABORER [n -S]\n",
  "TABOURERS": "TABOURER, one who tabors, also TABORER [n]\n",
  "TABOURET": "a low stool without a back or arms; a low stand or cabinet; an embroidery frame, also TABORET [n -S]\n",
  "TABOURETS": "TABOURET, a low stool without a back or arms; a low stand or cabinet; an embroidery frame, also TABORET [n]\n",
  "TABOURIN": "a small drum longer in body than the tabor, also TABORIN, TABORINE [n -S]\n",
  "TABOURING": "TABOUR, to beat on a small drum, also TABOR, TABER [v]\n",
  "TABOURINS": "TABOURIN, a small drum longer in body than the tabor, also TABORIN, TABORINE [n]\n",
  "TABOURS": "TABOUR, to beat on a small drum, also TABOR, TABER [v]\n",
  "TABRERE": "(Spenser) a person who plays the tabour [n -S]\n",
  "TABRERES": "TABRERE, (Spenser) a person who plays the tabour [n]\n",
  "TABRET": "(historical) a small tabor [n -S]\n",
  "TABRETS": "TABRET, (historical) a small tabor [n]\n",
  "TABS": "TAB, to provide with an identifying mark [v]\n",
  "TABU": "(Tongan) to exclude or prohibit by social influence, also TABOO [v -ED, -ING, -S]\n",
  "TABUED": "TABU, (Tongan) to exclude or prohibit by social influence, also TABOO [v]\n",
  "TABUING": "TABU, (Tongan) to exclude or prohibit by social influence, also TABOO [v]\n",
  "TABULA": "(Latin) a table; a tablet [n TABULAE]\n",
  "TABULABLE": "that can be tabulated [adj]\n",
  "TABULAE": "TABULA, (Latin) a table; a tablet [n]\n",
  "TABULAR": "pertaining to a list [adj TABULARLY]\n",
  "TABULARISATION": "the process of tabularising, also TABULARIZATION [n -S]\n",
  "TABULARISATIONS": "TABULARISATION, the process of tabularising, also TABULARIZATION [n]\n",
  "TABULARISE": "to tabulate, also TABULARIZE [v TABULARISED, TABULARISING, TABULARISES]\n",
  "TABULARISED": "TABULARISE, to tabulate, also TABULARIZE [v]\n",
  "TABULARISES": "TABULARISE, to tabulate, also TABULARIZE [v]\n",
  "TABULARISING": "TABULARISE, to tabulate, also TABULARIZE [v]\n",
  "TABULARIZATION": "the process of tabularizing, also TABULARISATION [n -S]\n",
  "TABULARIZATIONS": "TABULARIZATION, the process of tabularizing, also TABULARISATION [n]\n",
  "TABULARIZE": "to tabulate, also TABULARISE [v TABULARIZED, TABULARIZING, TABULARIZES]\n",
  "TABULARIZED": "TABULARIZE, to tabulate, also TABULARISE [v]\n",
  "TABULARIZES": "TABULARIZE, to tabulate, also TABULARISE [v]\n",
  "TABULARIZING": "TABULARIZE, to tabulate, also TABULARISE [v]\n",
  "TABULARLY": "TABULAR, pertaining to a list [adv]\n",
  "TABULATE": "to arrange in a list [v TABULATED, TABULATING, TABULATES]\n",
  "TABULATED": "TABULATE, to arrange in a list [v]\n",
  "TABULATES": "TABULATE, to arrange in a list [v]\n",
  "TABULATING": "TABULATE, to arrange in a list [v]\n",
  "TABULATION": "the act of making a table [n -S]\n",
  "TABULATIONS": "TABULATION, the act of making a table [n]\n",
  "TABULATOR": "one who tabulates [n -S]\n",
  "TABULATORS": "TABULATOR, one who tabulates [n]\n",
  "TABULATORY": "relating to tabulation [adj]\n",
  "TABULI": "(Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOOLEY, TABOULEH, TABOULI [n -S]\n",
  "TABULIS": "TABULI, (Arabic) a kind of Lebanese salad, also TABBOULEH, TABBOULI, TABOOLEY, TABOULEH, TABOULI [n]\n",
  "TABUN": "(German) an organic phosphorus compound, which can be used as a nerve gas [n -S]\n",
  "TABUNS": "TABUN, (German) an organic phosphorus compound, which can be used as a nerve gas [n]\n",
  "TABUS": "TABU, (Tongan) to exclude or prohibit by social influence, also TABOO [v]\n",
  "TACAHOUT": "a gall on the tamarisk, a source of gallic acid [n -S]\n",
  "TACAHOUTS": "TACAHOUT, a gall on the tamarisk, a source of gallic acid [n]\n",
  "TACAMAHAC": "(Nahuatl) a gum resin yielded by various tropical trees, also TACMAHACK, TAKAMAKA [n -S]\n",
  "TACAMAHACS": "TACAMAHAC, (Nahuatl) a gum resin yielded by various tropical trees, also TACMAHACK, TAKAMAKA [n]\n",
  "TACAN": "an electronic system of air navigation [n -S]\n",
  "TACANS": "TACAN, an electronic system of air navigation [n]\n",
  "TACE": "in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TASLET, TASSE, TASSET [n -S]\n",
  "TACES": "TACE, in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TASLET, TASSE, TASSET [n]\n",
  "TACET": "(Latin) it is silent; a direction for a vocal or instrumental part to be silent during a whole movement [v]\n",
  "TACH": "(short for) tachometer, a device for indicating speed of rotation [n -S]\n",
  "TACHE": "(biblical) a fastening or clasp [n -S]\n",
  "TACHEOMETER": "an instrument for rapidly measuring survey points on a map [n -S]\n",
  "TACHEOMETERS": "TACHEOMETER, an instrument for rapidly measuring survey points on a map [n]\n",
  "TACHEOMETRIC": "relating to tacheometry, the rapid measurement of points on a survey, such as distance, elevation, etc., also TACHEOMETRICAL [adj]\n",
  "TACHEOMETRICAL": "relating to tacheometry, the rapid measurement of points on a survey, such as distance, elevation, etc., also TACHEOMETRIC [adj]\n",
  "TACHEOMETRIES": "TACHEOMETRY, measurement by use of a tacheometer, an instrument for rapidly measuring survey points on a map [n]\n",
  "TACHEOMETRY": "measurement by use of a tacheometer, an instrument for rapidly measuring survey points on a map [n TACHEOMETRIES]\n",
  "TACHES": "TACHE, (biblical) a fastening or clasp [n]\n",
  "TACHINA": "as in tachina fly, bristly fly [adj]\n",
  "TACHINID": "any dipterous bristly fly of the family Tachinidae [n -S]\n",
  "TACHINIDS": "TACHINID, any dipterous bristly fly of the family Tachinidae [n]\n",
  "TACHISM": "(French) a type of abstract painting, also TACHISME [n -S]\n",
  "TACHISME": "(French) a type of abstract painting, also TACHISM [n -S]\n",
  "TACHISMES": "TACHISME, (French) a type of abstract painting, also TACHISM [n]\n",
  "TACHISMS": "TACHISM, (French) a type of abstract painting, also TACHISME [n]\n",
  "TACHIST": "(French) an abstract painter, also TACHISTE [n -S]\n",
  "TACHISTE": "(French) an abstract painter, also TACHIST [n -S]\n",
  "TACHISTES": "TACHISTE, (French) an abstract painter, also TACHIST [n]\n",
  "TACHISTOSCOPE": "an instrument for rapidly showing images on a screen to test perception [n -S]\n",
  "TACHISTOSCOPES": "TACHISTOSCOPE, an instrument for rapidly showing images on a screen to test perception [n]\n",
  "TACHISTOSCOPIC": "relating to use of the tachistoscope [adj]\n",
  "TACHISTS": "TACHIST, (French) an abstract painter, also TACHISTE [n]\n",
  "TACHO": "(short for) a tachogram, a record made by a tachograph [n -S]\n",
  "TACHOGRAM": "a record made by a tachograph, an instrument for recording speed of rotation [n -S]\n",
  "TACHOGRAMS": "TACHOGRAM, a record made by a tachograph, an instrument for recording speed of rotation [n]\n",
  "TACHOGRAPH": "an instrument for recording speed of rotation [n -S]\n",
  "TACHOGRAPHS": "TACHOGRAPH, an instrument for recording speed of rotation [n]\n",
  "TACHOMETER": "an instrument for measuring speed of rotation [n -S]\n",
  "TACHOMETERS": "TACHOMETER, an instrument for measuring speed of rotation [n]\n",
  "TACHOMETRIC": "relating to measurement by tachometer, also TACHOMETRICAL [adj TACHOMETRICALLY]\n",
  "TACHOMETRICAL": "relating to measurement by tachometer, also TACHOMETRIC [adj TACHOMETRICALLY]\n",
  "TACHOMETRICALLY": "TACHOMETRICAL, relating to measurement by tachometer, also TACHOMETRIC [adv]\n",
  "TACHOMETRIES": "TACHOMETRY, the measurement of speed, also TACHYMETRY [n]\n",
  "TACHOMETRY": "the measurement of speed, also TACHYMETRY [n TACHOMETRIES]\n",
  "TACHOS": "TACHO, (short for) a tachogram, a record made by a tachograph [n]\n",
  "TACHS": "TACH, (short for) tachometer, a device for indicating speed of rotation [n]\n",
  "TACHYARRHYTHMIA": "arrhythmia characterized by a rapid irregular heartbeat [n]\n",
  "TACHYCARDIA": "quick heart-rate [n -S]\n",
  "TACHYCARDIAC": "related to tachycardia, quick heart-rate [adj]\n",
  "TACHYCARDIAS": "TACHYCARDIA, quick heart-rate [n]\n",
  "TACHYGRAPH": "a shorthand writer, also TACHYGRAPHER, TACHYGRAPHIST [n -S]\n",
  "TACHYGRAPHER": "a shorthand writer, also TACHYGRAPH, TACHYGRAPHIST [n -S]\n",
  "TACHYGRAPHERS": "TACHYGRAPHER, a shorthand writer, also TACHYGRAPH, TACHYGRAPHIST [n]\n",
  "TACHYGRAPHIC": "relating to tachygraphy, shorthand, also TACHYGRAPHICAL [adj]\n",
  "TACHYGRAPHICAL": "relating to tachygraphy, shorthand, also TACHYGRAPHIC [adj]\n",
  "TACHYGRAPHIES": "TACHYGRAPHY, shorthand [n]\n",
  "TACHYGRAPHIST": "a shorthand writer, also TACHYGRAPH, TACHYGRAPHER [n -S]\n",
  "TACHYGRAPHISTS": "TACHYGRAPHIST, a shorthand writer, also TACHYGRAPH, TACHYGRAPHER [n]\n",
  "TACHYGRAPHS": "TACHYGRAPH, a shorthand writer, also TACHYGRAPHER, TACHYGRAPHIST [n]\n",
  "TACHYGRAPHY": "shorthand [n TACHYGRAPHIES]\n",
  "TACHYLITE": "a vitreous form of basalt, also TACHYLYTE [n -S]\n",
  "TACHYLITES": "TACHYLITE, a vitreous form of basalt, also TACHYLYTE [n]\n",
  "TACHYLITIC": "of or like tachylyte, a vitreous form of basalt, also TACHYLYTIC [adj]\n",
  "TACHYLYTE": "a vitreous form of basalt, also TACHYLITE [n -S]\n",
  "TACHYLYTES": "TACHYLYTE, a vitreous form of basalt, also TACHYLITE [n]\n",
  "TACHYLYTIC": "of or like tachylyte, a vitreous form of basalt, also TACHYLITIC [adj]\n",
  "TACHYMETER": "a surveying instrument for rapid measurements of distances, elevations, and bearings [n -S]\n",
  "TACHYMETERS": "TACHYMETER, a surveying instrument for rapid measurements of distances, elevations, and bearings [n]\n",
  "TACHYMETRIC": "relating to measurement by tachymeter, also TACHYMETRICAL [adj TACHYMETRICALLY]\n",
  "TACHYMETRICAL": "relating to measurement by tachymeter, also TACHYMETRIC [adj TACHYMETRICALLY]\n",
  "TACHYMETRICALLY": "TACHYMETRICAL, relating to measurement by tachymeter, also TACHYMETRIC [adv]\n",
  "TACHYMETRIES": "TACHYMETRY, the measurement of speed, also TACHOMETRY [n]\n",
  "TACHYMETRY": "the measurement of speed, also TACHOMETRY [n TACHYMETRIES]\n",
  "TACHYON": "a theoretical elementary particle moving faster than light [n -S]\n",
  "TACHYONIC": "relating to a tachyon, a faster-than-light particle [adj]\n",
  "TACHYONS": "TACHYON, a theoretical elementary particle moving faster than light [n]\n",
  "TACHYPHASIA": "abnormally rapid or voluble speech, also TACHYPHRASIA [n -S]\n",
  "TACHYPHASIAS": "TACHYPHASIA, abnormally rapid or voluble speech, also TACHYPHRASIA [n]\n",
  "TACHYPHRASIA": "abnormally rapid or voluble speech, also TACHYPHASIA [n -S]\n",
  "TACHYPHRASIAS": "TACHYPHRASIA, abnormally rapid or voluble speech, also TACHYPHASIA [n]\n",
  "TACHYPHYLAXES": "TACHYPHYLAXIS, very rapid development of tolerance or immunity to the effects of a drug [n]\n",
  "TACHYPHYLAXIS": "very rapid development of tolerance or immunity to the effects of a drug [n TACHYPHYLAXES]\n",
  "TACHYPNEA": "abnormally rapid breathing, also TACHYPNOEA [n -S]\n",
  "TACHYPNEAS": "TACHYPNEA, abnormally rapid breathing, also TACHYPNOEA [n]\n",
  "TACHYPNOEA": "abnormally rapid respiration, also TACHYPNEA [n -S]\n",
  "TACHYPNOEAS": "TACHYPNOEA, abnormally rapid respiration, also TACHYPNEA [n]\n",
  "TACIT": "unspoken; understood or implied without being expressed directly [adj]\n",
  "TACITLY": "TACIT, unspoken; understood or implied without being expressed directly [adv]\n",
  "TACITNESS": "the quality of being tacit [n -ES]\n",
  "TACITNESSES": "TACITNESS, the quality of being tacit [n]\n",
  "TACITURN": "habitually silent [adj TACITURNLY]\n",
  "TACITURNITIES": "TACITURNITY, the state of being taciturn [n]\n",
  "TACITURNITY": "the state of being taciturn [n TACITURNITIES]\n",
  "TACITURNLY": "TACITURN, habitually silent [adv]\n",
  "TACK": "to fasten with short, sharp-pointed nails [v -ED, -ING, -S]\n",
  "TACKBOARD": "a board, as of cork, for tacking up notices and display materials [n -S]\n",
  "TACKBOARDS": "TACKBOARD, a board, as of cork, for tacking up notices and display materials [n]\n",
  "TACKED": "TACK, to fasten with short, sharp-pointed nails [v]\n",
  "TACKER": "(Australian slang) a young child [n -S]\n",
  "TACKERS": "TACKER, (Australian slang) a young child [n]\n",
  "TACKET": "(Scots) a small, broad-headed nail, a hobnail [n -S]\n",
  "TACKETIER": "TACKETY, like a tacket or hobnail [adj]\n",
  "TACKETIEST": "TACKETY, like a tacket or hobnail [adj]\n",
  "TACKETS": "TACKET, (Scots) a small, broad-headed nail, a hobnail [n]\n",
  "TACKETY": "like a tacket or hobnail [adj TACKETIER, TACKETIEST]\n",
  "TACKEY": "slightly sticky, also TACKY [adj TACKIER, TACKIEST, TACKILY]\n",
  "TACKIER": "TACKEY, slightly sticky, also TACKY [adj]\n",
  "TACKIES": "TACKY, a tennis shoe, also TAKKY [n]\n",
  "TACKIEST": "TACKEY, slightly sticky, also TACKY [adj]\n",
  "TACKIFIED": "TACKIFY, to make tacky [v]\n",
  "TACKIFIER": "something for making a resin tacky or more tacky [n -S]\n",
  "TACKIFIERS": "TACKIFIER, something for making a resin tacky or more tacky [n]\n",
  "TACKIFIES": "TACKIFY, to make tacky [v]\n",
  "TACKIFY": "to make tacky [v TACKIFIED, TACKIFYING, TACKIFIES]\n",
  "TACKIFYING": "TACKIFY, to make tacky [v]\n",
  "TACKILY": "TACKY, adhesive, also TACKEY [adv]\n",
  "TACKINESS": "stickiness [n -ES]\n",
  "TACKINESSES": "TACKINESS, stickiness [n]\n",
  "TACKING": "a nautical manoeuvre [n -S]\n",
  "TACKINGS": "TACKING, a nautical manoeuvre [n]\n",
  "TACKLE": "to seize and throw to the ground [v TACKLED, TACKLING, TACKLES]\n",
  "TACKLED": "TACKLE, to seize and throw to the ground [v]\n",
  "TACKLER": "one who tackles [n -S]\n",
  "TACKLERS": "TACKLER, one who tackles [n]\n",
  "TACKLES": "TACKLE, to seize and throw to the ground [v]\n",
  "TACKLESS": "without tacks [adj]\n",
  "TACKLING": "equipment for a particular purpose [n -S]\n",
  "TACKLINGS": "TACKLING, equipment for a particular purpose [n]\n",
  "TACKS": "TACK, to fasten with short, sharp-pointed nails [v]\n",
  "TACKSMAN": "one who holds a tack or lease from another; a tenant, or lessee [n TACKSMEN]\n",
  "TACKSMEN": "TACKSMAN, one who holds a tack or lease from another; a tenant, or lessee [n]\n",
  "TACKY": "adhesive, also TACKEY [adj TACKIER, TACKIEST, TACKILY] / a tennis shoe, also TAKKY [n TACKIES]\n",
  "TACMAHACK": "(Nahuatl) a gum resin yielded by various tropical trees, also TACAMAHAC, TAKAMAKA [n -S]\n",
  "TACMAHACKS": "TACMAHACK, (Nahuatl) a gum resin yielded by various tropical trees, also TACAMAHAC, TAKAMAKA [n]\n",
  "TACNODE": "a point of contact between two curves [n -S]\n",
  "TACNODES": "TACNODE, a point of contact between two curves [n]\n",
  "TACO": "(Spanish) in Mexican cooking, a very thin rolled pancake with a meat filling [n -S]\n",
  "TACONITE": "a low-grade iron ore [n -S]\n",
  "TACONITES": "TACONITE, a low-grade iron ore [n]\n",
  "TACOS": "TACO, (Spanish) in Mexican cooking, a very thin rolled pancake with a meat filling [n]\n",
  "TACRINE": "a drug for treating Alzheimer's disease [n -S]\n",
  "TACRINES": "TACRINE, a drug for treating Alzheimer's disease [n]\n",
  "TACT": "skill in dealing with delicate situations [n -S]\n",
  "TACTFUL": "having tact [adj TACTFULLY]\n",
  "TACTFULLY": "TACTFUL, having tact [adv]\n",
  "TACTFULNESS": "the state of being tactful [n -ES]\n",
  "TACTFULNESSES": "TACTFULNESS, the state of being tactful [n]\n",
  "TACTIC": "a manoeuvre for gaining an objective [n -S]\n",
  "TACTICAL": "relating to tactics [adj TACTICALLY]\n",
  "TACTICALLY": "TACTICAL, relating to tactics [adv]\n",
  "TACTICIAN": "one skilled in tactics [n -S]\n",
  "TACTICIANS": "TACTICIAN, one skilled in tactics [n]\n",
  "TACTICITIES": "TACTICITY, the stereochemical arrangement of units in the main chain of a polymer [n]\n",
  "TACTICITY": "the stereochemical arrangement of units in the main chain of a polymer [n TACTICITIES]\n",
  "TACTICS": "TACTIC, a manoeuvre for gaining an objective [n]\n",
  "TACTILE": "pertaining to the sense of touch, also TACTUAL [adj TACTILELY]\n",
  "TACTILELY": "TACTILE, pertaining to the sense of touch, also TACTUAL [adv]\n",
  "TACTILIST": "a painter who aims at tactile effects [n -S]\n",
  "TACTILISTS": "TACTILIST, a painter who aims at tactile effects [n]\n",
  "TACTILITIES": "TACTILITY, the state of being tactile [n]\n",
  "TACTILITY": "the state of being tactile [n TACTILITIES]\n",
  "TACTION": "the act of touching [n -S]\n",
  "TACTIONS": "TACTION, the act of touching [n]\n",
  "TACTISM": "the movement of a whole organism [n -S]\n",
  "TACTISMS": "TACTISM, the movement of a whole organism [n]\n",
  "TACTLESS": "without tact [adj TACTLESSLY]\n",
  "TACTLESSLY": "TACTLESS, without tact [adv]\n",
  "TACTLESSNESS": "the state of being tactless [n -ES]\n",
  "TACTLESSNESSES": "TACTLESSNESS, the state of being tactless [n]\n",
  "TACTS": "TACT, skill in dealing with delicate situations [n]\n",
  "TACTUAL": "pertaining to the sense of touch, also TACTILE [adj TACTUALLY]\n",
  "TACTUALITIES": "TACTUALITY, tactual quality [n]\n",
  "TACTUALITY": "tactual quality [n TACTUALITIES]\n",
  "TACTUALLY": "TACTUAL, pertaining to the sense of touch, also TACTILE [adv]\n",
  "TAD": "a small amount [n -S]\n",
  "TADALAFIL": "a drug used to treat erectile dysfunction and benign prostatic hyperplasia [n -S]\n",
  "TADALAFILS": "TADALAFIL, a drug used to treat erectile dysfunction and benign prostatic hyperplasia [n]\n",
  "TADDIE": "(Australian slang) a tadpole [n -S]\n",
  "TADDIES": "TADDIE, (Australian slang) a tadpole [n]\n",
  "TADPOLE": "the aquatic larva of an amphibian [n -S]\n",
  "TADPOLES": "TADPOLE, the aquatic larva of an amphibian [n]\n",
  "TADS": "TAD, a small amount [n]\n",
  "TAE": "(Scots) to toe the line [v TAED, TAEING, TAES]\n",
  "TAED": "TAE, (Scots) to toe the line [v]\n",
  "TAEDIUM": "the state of being tedious, also TEDIUM [n -S]\n",
  "TAEDIUMS": "TAEDIUM, the state of being tedious, also TEDIUM [n]\n",
  "TAEING": "TAE, (Scots) to toe the line [v]\n",
  "TAEKWONDO": "(Korean) a Korean martial art [n -S]\n",
  "TAEKWONDOS": "TAEKWONDO, (Korean) a Korean martial art [n]\n",
  "TAEL": "(Malay) an Oriental unit of weight [n -S]\n",
  "TAELS": "TAEL, (Malay) an Oriental unit of weight [n]\n",
  "TAENIA": "(Latin) a narrow band or hair-ribbon worn in Greece, also TENIA [n TAENIAE or TAENIAS]\n",
  "TAENIACIDE": "the killing of tapeworms [n -S]\n",
  "TAENIACIDES": "TAENIACIDE, the killing of tapeworms [n]\n",
  "TAENIAE": "TAENIA, (Latin) a narrow band or hair-ribbon worn in Greece, also TENIA [n]\n",
  "TAENIAFUGE": "a substance, e.g. a drug, for expelling tapeworms [n -S]\n",
  "TAENIAFUGES": "TAENIAFUGE, a substance, e.g. a drug, for expelling tapeworms [n]\n",
  "TAENIAS": "TAENIA, (Latin) a narrow band or hair-ribbon worn in Greece, also TENIA [n]\n",
  "TAENIASES": "TAENIASIS, infestation with tapeworms [n]\n",
  "TAENIASIS": "infestation with tapeworms [n TAENIASES]\n",
  "TAENIATE": "ribbonlike; shaped like a ribbon or tapeworm, also TAENIOID, TENIOID [adj]\n",
  "TAENIOID": "like a tapeworm [adj]\n",
  "TAENITE": "a nickel-iron alloy found in meteorites [n -S]\n",
  "TAENITES": "TAENITE, a nickel-iron alloy found in meteorites [n]\n",
  "TAES": "TAE, (Scots) to toe the line [v]\n",
  "TAFFAREL": "(Dutch) a rail around the stern of a ship, also TAFFRAIL, TAFFEREL [n -S]\n",
  "TAFFARELS": "TAFFAREL, (Dutch) a rail around the stern of a ship, also TAFFRAIL, TAFFEREL [n]\n",
  "TAFFEREL": "(Dutch) a rail around the stern of a ship, also TAFFRAIL, TAFFAREL [n -S]\n",
  "TAFFERELS": "TAFFEREL, (Dutch) a rail around the stern of a ship, also TAFFRAIL, TAFFAREL [n]\n",
  "TAFFETA": "a thin glossy silk, also TAFFETAS [n -S]\n",
  "TAFFETAS": "a thin glossy silk, also TAFFETA [n -ES]\n",
  "TAFFETASES": "TAFFETAS, a thin glossy silk, also TAFFETA [n]\n",
  "TAFFETIER": "TAFFETY, made of taffeta, a thin glossy silk [adj]\n",
  "TAFFETIEST": "TAFFETY, made of taffeta, a thin glossy silk [adj]\n",
  "TAFFETISED": "resembling taffeta, also TAFFETIZED [adj]\n",
  "TAFFETIZED": "resembling taffeta, also TAFFETISED [adj]\n",
  "TAFFETY": "made of taffeta, a thin glossy silk [adj TAFFETIER, TAFFETIEST]\n",
  "TAFFIA": "a liquor resembling rum distilled from the lower grades of molasses, refuse brown sugar, etc., also TAFIA [n -S]\n",
  "TAFFIAS": "TAFFIA, a liquor resembling rum distilled from the lower grades of molasses, refuse brown sugar, etc., also TAFIA [n]\n",
  "TAFFIES": "TAFFY, a hard-baked chewy sweet, made of sugar and butter, also TOFFEE, TOFFY [n]\n",
  "TAFFRAIL": "(Dutch) a rail around the stern of a ship, also TAFFAREL, TAFFEREL [n -S]\n",
  "TAFFRAILS": "TAFFRAIL, (Dutch) a rail around the stern of a ship, also TAFFAREL, TAFFEREL [n]\n",
  "TAFFY": "a hard-baked chewy sweet, made of sugar and butter, also TOFFEE, TOFFY [n TAFFIES]\n",
  "TAFIA": "a liquor resembling rum distilled from the lower grades of molasses, refuse brown sugar, etc., also TAFFIA [n -S]\n",
  "TAFIAS": "TAFIA, a liquor resembling rum distilled from the lower grades of molasses, refuse brown sugar, etc., also TAFFIA [n]\n",
  "TAG": "to provide with an identifying marker [v TAGGED, TAGGING, TAGS]\n",
  "TAGALONG": "one that follows another [n -S]\n",
  "TAGALONGS": "TAGALONG, one that follows another [n]\n",
  "TAGAREEN": "(dialect) a junk shop [n -S]\n",
  "TAGAREENS": "TAGAREEN, (dialect) a junk shop [n]\n",
  "TAGBOARD": "a material for making shipping tags [n -S]\n",
  "TAGBOARDS": "TAGBOARD, a material for making shipping tags [n]\n",
  "TAGETES": "(Latin) a garden plant with yellow flowers [n TAGETES]\n",
  "TAGGANT": "a substance added to a product to indicate its source of manufacture [n -S]\n",
  "TAGGANTS": "TAGGANT, a substance added to a product to indicate its source of manufacture [n]\n",
  "TAGGED": "TAG, to provide with an identifying marker [v]\n",
  "TAGGEE": "a person wearing an electronic tag [n -S]\n",
  "TAGGEES": "TAGGEE, a person wearing an electronic tag [n]\n",
  "TAGGER": "the pursuer in a game of tag [n -S]\n",
  "TAGGERS": "TAGGER, the pursuer in a game of tag [n]\n",
  "TAGGIER": "TAGGY, matted into tags [adj]\n",
  "TAGGIEST": "TAGGY, matted into tags [adj]\n",
  "TAGGING": "the act of tagging [n -S]\n",
  "TAGGINGS": "TAGGING, the act of tagging [n]\n",
  "TAGGY": "matted into tags [adj TAGGIER, TAGGIEST]\n",
  "TAGHAIRM": "(Gaelic) inspiration sought by lying in a bullock's hide behind a waterfall [n -S]\n",
  "TAGHAIRMS": "TAGHAIRM, (Gaelic) inspiration sought by lying in a bullock's hide behind a waterfall [n]\n",
  "TAGINE": "a conical clay pot used in North African cooking, also TAJINE [n -S]\n",
  "TAGINES": "TAGINE, a conical clay pot used in North African cooking, also TAJINE [n]\n",
  "TAGLESS": "without a tag [adj]\n",
  "TAGLIARINI": "(Italian) pasta cut into very thin, flat strips [n -S]\n",
  "TAGLIARINIS": "TAGLIARINI, (Italian) pasta cut into very thin, flat strips [n]\n",
  "TAGLIATELLE": "(Italian) pasta made in narrow strips; an Italian dish consisting largely of this and usually a sauce [n -S]\n",
  "TAGLIATELLES": "TAGLIATELLE, (Italian) pasta made in narrow strips; an Italian dish consisting largely of this and usually a sauce [n]\n",
  "TAGLIKE": "like a tag [adj]\n",
  "TAGLINE": "the final line of a play or joke that makes the point [n -S]\n",
  "TAGLINES": "TAGLINE, the final line of a play or joke that makes the point [n]\n",
  "TAGLIONI": "(Italian) a kind of outer coat, or overcoat [n -S]\n",
  "TAGLIONIS": "TAGLIONI, (Italian) a kind of outer coat, or overcoat [n]\n",
  "TAGMA": "(Greek) any of the distinct regions of the body in arthropods [n TAGMATA]\n",
  "TAGMATA": "TAGMA, (Greek) any of the distinct regions of the body in arthropods [n]\n",
  "TAGMEME": "the analysis of arrangement of spoken elements [n -S]\n",
  "TAGMEMES": "TAGMEME, the analysis of arrangement of spoken elements [n]\n",
  "TAGMEMIC": "relating to tagmeme, the analysis of the arrangement of spoken elements [adj]\n",
  "TAGMEMICS": "the analysis of the grammar of a language based on the arrangement of spoken elements [n]\n",
  "TAGRAG": "riffraff [n -S]\n",
  "TAGRAGS": "TAGRAG, riffraff [n]\n",
  "TAGS": "TAG, to provide with an identifying marker [v]\n",
  "TAGUAN": "(Tagalog) a giant flying squirrel of SE Asia [n -S]\n",
  "TAGUANS": "TAGUAN, (Tagalog) a giant flying squirrel of SE Asia [n]\n",
  "TAHA": "(Zulu) the South African weaverbird [n -S]\n",
  "TAHAS": "TAHA, (Zulu) the South African weaverbird [n]\n",
  "TAHINA": "(Arabic) a paste made of crushed sesame seeds, also TAHINI [n -S]\n",
  "TAHINAS": "TAHINA, (Arabic) a paste made of crushed sesame seeds, also TAHINI [n]\n",
  "TAHINI": "(Arabic) a paste made of crushed sesame seeds, also TAHINA [n -S]\n",
  "TAHINIS": "TAHINI, (Arabic) a paste made of crushed sesame seeds, also TAHINA [n]\n",
  "TAHR": "a Himalayan wild goat, also TEHR [n -S]\n",
  "TAHRS": "TAHR, a Himalayan wild goat, also TEHR [n]\n",
  "TAHSIL": "(Urdu) in India, a division of a district for revenue and certain other purposes, also TEHSIL [n -S]\n",
  "TAHSILDAR": "an Indian district official in charge of revenues [n -S]\n",
  "TAHSILDARS": "TAHSILDAR, an Indian district official in charge of revenues [n]\n",
  "TAHSILS": "TAHSIL, (Urdu) in India, a division of a district for revenue and certain other purposes, also TEHSIL [n]\n",
  "TAI": "(Japanese) a Japanese sea bream [n -S]\n",
  "TAIAHA": "(Maori) a long-handled club with a sharp tip [n -S]\n",
  "TAIAHAS": "TAIAHA, (Maori) a long-handled club with a sharp tip [n]\n",
  "TAIG": "(Irish) a derogatory name for a Roman Catholic [n -S]\n",
  "TAIGA": "(Russian) subarctic Siberian evergreen forest [n -S]\n",
  "TAIGAS": "TAIGA, (Russian) subarctic Siberian evergreen forest [n]\n",
  "TAIGLACH": "(Yiddish) a confection of dough balls boiled in honey, also TEIGLACH [n TAIGLACH]\n",
  "TAIGLE": "to entangle or hinder [v TAIGLED, TAIGLING, TAIGLES]\n",
  "TAIGLED": "TAIGLE, to entangle or hinder [v]\n",
  "TAIGLES": "TAIGLE, to entangle or hinder [v]\n",
  "TAIGLING": "TAIGLE, to entangle or hinder [v]\n",
  "TAIGS": "TAIG, (Irish) a derogatory name for a Roman Catholic [n]\n",
  "TAIHOA": "(Maori) to hold on, wait [v TAIHOAED, TAIHOAING, TAIHOAS]\n",
  "TAIHOAED": "TAIHOA, (Maori) to hold on, wait [v]\n",
  "TAIHOAING": "TAIHOA, (Maori) to hold on, wait [v]\n",
  "TAIHOAS": "TAIHOA, (Maori) to hold on, wait [v]\n",
  "TAIKO": "(Japanese) a large Japanese drum, also DAIKO [n -S]\n",
  "TAIKONAUT": "a Chinese astronaut [n -S]\n",
  "TAIKONAUTS": "TAIKONAUT, a Chinese astronaut [n]\n",
  "TAIKOS": "TAIKO, (Japanese) a large Japanese drum, also DAIKO [n]\n",
  "TAIL": "to follow closely, to shadow [v -ED, -ING, -S]\n",
  "TAILARD": "(obsolete) a person with a tail [n -S]\n",
  "TAILARDS": "TAILARD, (obsolete) a person with a tail [n]\n",
  "TAILBACK": "a member of a football formation [n -S]\n",
  "TAILBACKS": "TAILBACK, a member of a football formation [n]\n",
  "TAILBOARD": "a hinged or removable flap at the rear end of a cart, lorry, etc. [n -S]\n",
  "TAILBOARDS": "TAILBOARD, a hinged or removable flap at the rear end of a cart, lorry, etc. [n]\n",
  "TAILBONE": "the coccyx [n -S]\n",
  "TAILBONES": "TAILBONE, the coccyx [n]\n",
  "TAILCOAT": "a man's formal coat, with narrow tails at the back [n -S]\n",
  "TAILCOATED": "wearing a tailcoat [adj]\n",
  "TAILCOATS": "TAILCOAT, a man's formal coat, with narrow tails at the back [n]\n",
  "TAILED": "TAIL, to follow closely, to shadow [v]\n",
  "TAILENDER": "someone coming at the end, esp. in cricket [n -S]\n",
  "TAILENDERS": "TAILENDER, someone coming at the end, esp. in cricket [n]\n",
  "TAILER": "one who secretly follows another [n -S]\n",
  "TAILERON": "either part of a two-piece tailplane whose two halves can operate independently or together [n -S]\n",
  "TAILERONS": "TAILERON, either part of a two-piece tailplane whose two halves can operate independently or together [n]\n",
  "TAILERS": "TAILER, one who secretly follows another [n]\n",
  "TAILFAN": "a fanlike swimming organ of some crustaceans [n -S]\n",
  "TAILFANS": "TAILFAN, a fanlike swimming organ of some crustaceans [n]\n",
  "TAILFIN": "a decorative projection at the back of a car [n -S]\n",
  "TAILFINS": "TAILFIN, a decorative projection at the back of a car [n]\n",
  "TAILFLIES": "TAILFLY, part of a fishing fly which resembles the tail of an insect [n]\n",
  "TAILFLY": "part of a fishing fly which resembles the tail of an insect [n TAILFLIES]\n",
  "TAILGATE": "to drive dangerously close behind another vehicle [v TAILGATED, TAILGATING, TAILGATES]\n",
  "TAILGATED": "TAILGATE, to drive dangerously close behind another vehicle [v]\n",
  "TAILGATER": "a person who tailgates, drives dangerously close behind another vehicle [n -S]\n",
  "TAILGATERS": "TAILGATER, a person who tailgates, drives dangerously close behind another vehicle [n]\n",
  "TAILGATES": "TAILGATE, to drive dangerously close behind another vehicle [v]\n",
  "TAILGATING": "the act of following another vehicle closely [n -S]\n",
  "TAILGATINGS": "TAILGATING, the act of following another vehicle closely [n]\n",
  "TAILHOOK": "a hook lowered from the tail of an aircraft to engage a braking cable [n -S]\n",
  "TAILHOOKS": "TAILHOOK, a hook lowered from the tail of an aircraft to engage a braking cable [n]\n",
  "TAILHOPPING": "the act of hopping to lift the tails of the skis off the ground while flexing the knees into a crouching position [n -S]\n",
  "TAILHOPPINGS": "TAILHOPPING, the act of hopping to lift the tails of the skis off the ground while flexing the knees into a crouching position [n]\n",
  "TAILING": "the refuse part of mined ore [n -S]\n",
  "TAILINGS": "TAILING, the refuse part of mined ore [n]\n",
  "TAILLAMP": "a light at the rear of a vehicle [n -S]\n",
  "TAILLAMPS": "TAILLAMP, a light at the rear of a vehicle [n]\n",
  "TAILLE": "(historical) a tax levied by a French king or overlord on his subjects, or on lands held from or under him [n -S]\n",
  "TAILLES": "TAILLE, (historical) a tax levied by a French king or overlord on his subjects, or on lands held from or under him [n]\n",
  "TAILLESS": "without a tail [adj TAILLESSLY]\n",
  "TAILLESSLY": "TAILLESS, without a tail [adv]\n",
  "TAILLESSNESS": "the state of being tailless [n -ES]\n",
  "TAILLESSNESSES": "TAILLESSNESS, the state of being tailless [n]\n",
  "TAILLEUR": "(French) a woman's tailored suit [n -S]\n",
  "TAILLEURS": "TAILLEUR, (French) a woman's tailored suit [n]\n",
  "TAILLIE": "(Scots) an entailment or deed whereby the legal course of succession is cut off, and an arbitrary one substituted, also TAILYE, TAILZIE [n -S]\n",
  "TAILLIES": "TAILLIE, (Scots) an entailment or deed whereby the legal course of succession is cut off, and an arbitrary one substituted, also TAILYE, TAILZIE [n]\n",
  "TAILLIGHT": "a rear light on a vehicle [n -S]\n",
  "TAILLIGHTS": "TAILLIGHT, a rear light on a vehicle [n]\n",
  "TAILLIKE": "like a tail [adj]\n",
  "TAILOR": "to fit with clothes [v -ED, -ING, -S]\n",
  "TAILORBIRD": "a kind of Asian warbler [n -S]\n",
  "TAILORBIRDS": "TAILORBIRD, a kind of Asian warbler [n]\n",
  "TAILORED": "TAILOR, to fit with clothes [v]\n",
  "TAILORESS": "a female tailor [n -ES]\n",
  "TAILORESSES": "TAILORESS, a female tailor [n]\n",
  "TAILORING": "the act of tailoring [n -S]\n",
  "TAILORINGS": "TAILORING, the act of tailoring [n]\n",
  "TAILORMADE": "TAILORMAKE, to make esp. to suit a particular person or purpose [v]\n",
  "TAILORMAKE": "to make esp. to suit a particular person or purpose [v TAILORMADE, TAILORMAKING, TAILORMAKES]\n",
  "TAILORMAKES": "TAILORMAKE, to make esp. to suit a particular person or purpose [v]\n",
  "TAILORMAKING": "TAILORMAKE, to make esp. to suit a particular person or purpose [v]\n",
  "TAILORS": "TAILOR, to fit with clothes [v]\n",
  "TAILPIECE": "a piece at the end; an appendage [n -S]\n",
  "TAILPIECES": "TAILPIECE, a piece at the end; an appendage [n]\n",
  "TAILPIPE": "to tie cans to the exhaust pipe of a vehicle [v TAILPIPED, TAILPIPING, TAILPIPES]\n",
  "TAILPIPED": "TAILPIPE, to tie cans to the exhaust pipe of a vehicle [v]\n",
  "TAILPIPES": "TAILPIPE, to tie cans to the exhaust pipe of a vehicle [v]\n",
  "TAILPIPING": "TAILPIPE, to tie cans to the exhaust pipe of a vehicle [v]\n",
  "TAILPLANE": "a small horizontal wing at the tail of an aircraft [n -S]\n",
  "TAILPLANES": "TAILPLANE, a small horizontal wing at the tail of an aircraft [n]\n",
  "TAILRACE": "the channel in which water runs away below a millstream [n -S]\n",
  "TAILRACES": "TAILRACE, the channel in which water runs away below a millstream [n]\n",
  "TAILS": "TAIL, to follow closely, to shadow [v]\n",
  "TAILSKID": "a support on which the tail of a plane rests [n -S]\n",
  "TAILSKIDS": "TAILSKID, a support on which the tail of a plane rests [n]\n",
  "TAILSLIDE": "an aerobatic manoeuvre in which an aircraft that has been put into a steep climb stalls and loses height by slipping backwards [n -S]\n",
  "TAILSLIDES": "TAILSLIDE, an aerobatic manoeuvre in which an aircraft that has been put into a steep climb stalls and loses height by slipping backwards [n]\n",
  "TAILSPIN": "to perform a kind of spin in an aeroplane [v TAILSPINNED, TAILSPUN, TAILSPINNING, TAILSPINS]\n",
  "TAILSPINNED": "TAILSPIN, to perform a kind of spin in an aeroplane [v]\n",
  "TAILSPINNING": "TAILSPIN, to perform a kind of spin in an aeroplane [v]\n",
  "TAILSPINS": "TAILSPIN, to perform a kind of spin in an aeroplane [v]\n",
  "TAILSPUN": "TAILSPIN, to perform a kind of spin in an aeroplane [v]\n",
  "TAILSTOCK": "a slidable casting mounted on a lathe, aligned with the headstock, used to support the free end of the piece being worked on [n -S]\n",
  "TAILSTOCKS": "TAILSTOCK, a slidable casting mounted on a lathe, aligned with the headstock, used to support the free end of the piece being worked on [n]\n",
  "TAILWATER": "water below a dam or waterpower development [n -S]\n",
  "TAILWATERS": "TAILWATER, water below a dam or waterpower development [n]\n",
  "TAILWHEEL": "a wheel at the rear of a vehicle [n -S]\n",
  "TAILWHEELS": "TAILWHEEL, a wheel at the rear of a vehicle [n]\n",
  "TAILWIND": "a wind coming from behind a moving vehicle [n -S]\n",
  "TAILWINDS": "TAILWIND, a wind coming from behind a moving vehicle [n]\n",
  "TAILYE": "(Scots) an entailment or deed whereby the legal course of succession is cut off, and an arbitrary one substituted, also TAILLIE, TAILZIE [n -S]\n",
  "TAILYES": "TAILYE, (Scots) an entailment or deed whereby the legal course of succession is cut off, and an arbitrary one substituted, also TAILLIE, TAILZIE [n]\n",
  "TAILZIE": "(Scots) an entailment or deed whereby the legal course of succession is cut off, and an arbitrary one substituted, also TAILLIE, TAILYE [n -S]\n",
  "TAILZIES": "TAILZIE, (Scots) an entailment or deed whereby the legal course of succession is cut off, and an arbitrary one substituted, also TAILLIE, TAILYE [n]\n",
  "TAIN": "paper-thin tin plate; tinfoil used as a backing for mirrors [n -S]\n",
  "TAINS": "TAIN, paper-thin tin plate; tinfoil used as a backing for mirrors [n]\n",
  "TAINT": "to stain or blemish [v -ED, -ING, -S]\n",
  "TAINTED": "TAINT, to stain or blemish [v]\n",
  "TAINTING": "TAINT, to stain or blemish [v]\n",
  "TAINTLESS": "free from taint or infection [adj TAINTLESSLY]\n",
  "TAINTLESSLY": "TAINTLESS, free from taint or infection [adv]\n",
  "TAINTS": "TAINT, to stain or blemish [v]\n",
  "TAINTURE": "defilement [n -S]\n",
  "TAINTURES": "TAINTURE, defilement [n]\n",
  "TAIPAN": "(Native Australian) an Australian venomous snake [n -S]\n",
  "TAIPANS": "TAIPAN, (Native Australian) an Australian venomous snake [n]\n",
  "TAIRA": "(Tupi) a large South American member of the weasel family, also TAYRA [n -S]\n",
  "TAIRAS": "TAIRA, (Tupi) a large South American member of the weasel family, also TAYRA [n]\n",
  "TAIS": "TAI, (Japanese) a Japanese sea bream [n]\n",
  "TAISCH": "(Gaelic) an apparition of someone about to die, also TAISH [n -ES]\n",
  "TAISCHES": "TAISCH, (Gaelic) an apparition of someone about to die, also TAISH [n]\n",
  "TAISH": "(Gaelic) an apparition of someone about to die, also TAISCH [n -ES]\n",
  "TAISHES": "TAISH, (Gaelic) an apparition of someone about to die, also TAISCH [n]\n",
  "TAIT": "(Scots) a small portion, a pinch, also TATE [n -S]\n",
  "TAITS": "TAIT, (Scots) a small portion, a pinch, also TATE [n]\n",
  "TAIVER": "(Scots) to wander, to rave, also TAVER [v -ED, -ING, -S]\n",
  "TAIVERED": "TAIVER, (Scots) to wander, to rave, also TAVER [v]\n",
  "TAIVERING": "TAIVER, (Scots) to wander, to rave, also TAVER [v]\n",
  "TAIVERS": "TAIVER, (Scots) to wander, to rave, also TAVER [v]\n",
  "TAIVERT": "(Scots) muddled, fuddled, also TAVERT [adj]\n",
  "TAJ": "a dervish's tall conical cap [n -ES]\n",
  "TAJES": "TAJ, a dervish's tall conical cap [n]\n",
  "TAJINE": "a conical clay pot used in North African cooking, also TAGINE [n -S]\n",
  "TAJINES": "TAJINE, a conical clay pot used in North African cooking, also TAGINE [n]\n",
  "TAK": "(Scots) to take [v TAKEN, TOOK, TAKING, TAKS]\n",
  "TAKA": "(Bengali) a monetary unit of Bangladesh [n -S]\n",
  "TAKABLE": "that can be taken, also TAKEABLE [adj]\n",
  "TAKAHE": "(Maori) an almost-extinct New Zealand bird, brightly colored, flightless, with a large bill [n -S]\n",
  "TAKAHES": "TAKAHE, (Maori) an almost-extinct New Zealand bird, brightly colored, flightless, with a large bill [n]\n",
  "TAKAMAKA": "(Nahuatl) a gum resin yielded by various tropical trees, also TACAMAHAC, TACMAHACK [n -S]\n",
  "TAKAMAKAS": "TAKAMAKA, (Nahuatl) a gum resin yielded by various tropical trees, also TACAMAHAC, TACMAHACK [n]\n",
  "TAKAS": "TAKA, (Bengali) a monetary unit of Bangladesh [n]\n",
  "TAKE": "to seize possession [v TOOK, TAKEN, TAKING, TAKES]\n",
  "TAKEABLE": "that can be taken, also TAKABLE [adj]\n",
  "TAKEAWAY": "a meal that is taken away from the place of purchase [n -S]\n",
  "TAKEAWAYS": "TAKEAWAY, a meal that is taken away from the place of purchase [n]\n",
  "TAKEDOWN": "an article that can be easily taken apart [n -S]\n",
  "TAKEDOWNS": "TAKEDOWN, an article that can be easily taken apart [n]\n",
  "TAKEN": "TAKE, to seize possession [v]\n",
  "TAKEOFF": "the act of rising in flight [n -S]\n",
  "TAKEOFFS": "TAKEOFF, the act of rising in flight [n]\n",
  "TAKEOUT": "a takeaway meal [n -S]\n",
  "TAKEOUTS": "TAKEOUT, a takeaway meal [n]\n",
  "TAKEOVER": "the act of assuming control [n -S]\n",
  "TAKEOVERS": "TAKEOVER, the act of assuming control [n]\n",
  "TAKER": "one who takes [n -S]\n",
  "TAKERS": "TAKER, one who takes [n]\n",
  "TAKES": "TAKE, to seize possession [v]\n",
  "TAKEUP": "the act of taking something up [n -S]\n",
  "TAKEUPS": "TAKEUP, the act of taking something up [n]\n",
  "TAKHI": "(Mongolian) a rare wild horse, also TAKI [n -S]\n",
  "TAKHIS": "TAKHI, (Mongolian) a rare wild horse, also TAKI [n]\n",
  "TAKI": "(Mongolian) a rare wild horse, also TAKHI [n -S]\n",
  "TAKIER": "TAKY, (obsolete) attractive [adj]\n",
  "TAKIEST": "TAKY, (obsolete) attractive [adj]\n",
  "TAKIN": "(Tibetan) a large horned hoofed animal of the Himalayas, related to the goats and antelopes [n -S]\n",
  "TAKING": "attractive [adj TAKINGLY] / the act of taking [n -S]\n",
  "TAKINGLY": "TAKING, attractive [adv]\n",
  "TAKINGNESS": "the quality of being taking [n -ES]\n",
  "TAKINGNESSES": "TAKINGNESS, the quality of being taking [n]\n",
  "TAKINGS": "TAKING, the act of taking [n]\n",
  "TAKINS": "TAKIN, (Tibetan) a large horned hoofed animal of the Himalayas, related to the goats and antelopes [n]\n",
  "TAKIS": "TAKI, (Mongolian) a rare wild horse, also TAKHI [n]\n",
  "TAKKIES": "TAKKY, (South African) a tennis shoe or plimsoll, also TACKY [n]\n",
  "TAKKY": "(South African) a tennis shoe or plimsoll, also TACKY [n TAKKIES]\n",
  "TAKS": "TAK, (Scots) to take [v]\n",
  "TAKY": "(obsolete) attractive [adj TAKIER, TAKIEST]\n",
  "TALA": "(Sanskrit) a traditional rhythmic pattern in Indian music [n -S]\n",
  "TALAK": "(Arabic) in Islamic law, divorce, esp. by the husband's verbal repudiation of his wife in the presence of witnesses, also TALAQ [n -S]\n",
  "TALAKS": "TALAK, (Arabic) in Islamic law, divorce, esp. by the husband's verbal repudiation of his wife in the presence of witnesses, also TALAQ [n]\n",
  "TALANT": "(Spenser) talon, also TALAUNT, TALON [n -S]\n",
  "TALANTS": "TALANT, (Spenser) talon, also TALAUNT, TALON [n]\n",
  "TALAPOIN": "(Portuguese) a small green West African guenon monkey; a title of respect for a Buddhist monk [n -S]\n",
  "TALAPOINS": "TALAPOIN, (Portuguese) a small green West African guenon monkey; a title of respect for a Buddhist monk [n]\n",
  "TALAQ": "(Arabic) in Islamic law, divorce, esp. by the husband's verbal repudiation of his wife in the presence of witnesses, also TALAK [n -S]\n",
  "TALAQS": "TALAQ, (Arabic) in Islamic law, divorce, esp. by the husband's verbal repudiation of his wife in the presence of witnesses, also TALAK [n]\n",
  "TALAR": "an ankle-length robe [n -S]\n",
  "TALARIA": "(Latin) small wings or winged shoes represented as fastened to the ankles, chiefly used as an attribute of Mercury or Hermes [n]\n",
  "TALARS": "TALAR, an ankle-length robe [n]\n",
  "TALAS": "TALA, (Sanskrit) a traditional rhythmic pattern in Indian music [n]\n",
  "TALAUNT": "(Spenser) a talon, also TALANT, TALON [n -S]\n",
  "TALAUNTS": "TALAUNT, (Spenser) a talon, also TALANT, TALON [n]\n",
  "TALAYOT": "(Spanish) a prehistoric stone monument of the Balearic Isles [n -S]\n",
  "TALAYOTS": "TALAYOT, (Spanish) a prehistoric stone monument of the Balearic Isles [n]\n",
  "TALBOT": "a broad-mouthed, large-eared hound, now extinct [n -S]\n",
  "TALBOTS": "TALBOT, a broad-mouthed, large-eared hound, now extinct [n]\n",
  "TALBOTYPE": "(tradename) a method of taking photographic pictures, on paper sensitized with iodide of silver, aka calotype, kalotype [n -S]\n",
  "TALBOTYPES": "TALBOTYPE, (tradename) a method of taking photographic pictures, on paper sensitized with iodide of silver, aka calotype, kalotype [n]\n",
  "TALC": "to treat with a fine powdery mineral [v TALCED or TALCKED, TALCING or TALCKING, TALCS]\n",
  "TALCED": "TALC, to treat with a fine powdery mineral [v]\n",
  "TALCIER": "TALCY, like talc, also TALCKY [adj]\n",
  "TALCIEST": "TALCY, like talc, also TALCKY [adj]\n",
  "TALCING": "TALC, to treat with a fine powdery mineral [v]\n",
  "TALCKED": "TALC, to treat with a fine powdery mineral [v]\n",
  "TALCKIER": "TALCKY, pertaining to talc [adj]\n",
  "TALCKIEST": "TALCKY, pertaining to talc [adj]\n",
  "TALCKING": "TALC, to treat with a fine powdery mineral [v]\n",
  "TALCKY": "pertaining to talc [adj TALCKIER, TALCKIEST]\n",
  "TALCOSE": "of or pertaining to talc, also TALCOUS [adj]\n",
  "TALCOUS": "pertaining to talc [adj]\n",
  "TALCS": "TALC, to treat with a fine powdery mineral [v]\n",
  "TALCUM": "to treat with a powder made from talc [v -ED, -ING, -S]\n",
  "TALCUMED": "TALCUM, to treat with a powder made from talc [v]\n",
  "TALCUMING": "TALCUM, to treat with a powder made from talc [v]\n",
  "TALCUMS": "TALCUM, to treat with a powder made from talc [v]\n",
  "TALCY": "like talc, also TALCKY [adj TALCIER, TALCIEST]\n",
  "TALE": "a story [n -S]\n",
  "TALEA": "(Latin) a recurring rhythmic pattern [n TALEAE]\n",
  "TALEAE": "TALEA, (Latin) a recurring rhythmic pattern [n]\n",
  "TALEBEARER": "one who tells tales, a sneak [n -S]\n",
  "TALEBEARERS": "TALEBEARER, one who tells tales, a sneak [n]\n",
  "TALEBEARING": "the act of bearing tales [n -S]\n",
  "TALEBEARINGS": "TALEBEARING, the act of bearing tales [n]\n",
  "TALEFUL": "full of stories [adj]\n",
  "TALEGALLA": "(Malagasy) a genus of Australian birds which includes the brush turkey [n -S]\n",
  "TALEGALLAS": "TALEGALLA, (Malagasy) a genus of Australian birds which includes the brush turkey [n]\n",
  "TALEGGIO": "(Italian) a soft creamy cheese [n -S]\n",
  "TALEGGIOS": "TALEGGIO, (Italian) a soft creamy cheese [n]\n",
  "TALENT": "a special natural ability, also TALLENT [n -S]\n",
  "TALENTED": "having a talent [adj]\n",
  "TALENTLESS": "without talent [adj]\n",
  "TALENTS": "TALENT, a special natural ability, also TALLENT [n]\n",
  "TALER": "(German) an obsolete German silver coin, also THALER [n -S]\n",
  "TALERS": "TALER, (German) an obsolete German silver coin, also THALER [n]\n",
  "TALES": "TALE, a story [n]\n",
  "TALESMAN": "a bystander chosen to make up a deficiency in a jury [n TALESMEN]\n",
  "TALESMEN": "TALESMAN, a bystander chosen to make up a deficiency in a jury [n]\n",
  "TALETELLER": "a teller of tales [n -S]\n",
  "TALETELLERS": "TALETELLER, a teller of tales [n]\n",
  "TALETELLING": "the act of telling stories; the act of gossiping in an indiscreet manner [n -S]\n",
  "TALETELLINGS": "TALETELLING, the act of telling stories; the act of gossiping in an indiscreet manner [n]\n",
  "TALEYSIM": "TALLITH, (Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n]\n",
  "TALI": "TALUS, (Latin) a slope formed by an accumulation of rock debris [n]\n",
  "TALIGRADE": "walking on the outer side of the foot, as opposed to plantigrade [adj]\n",
  "TALION": "(historical) a punishment identical to the crime e.g. death sentence for murder [n -S]\n",
  "TALIONIC": "pertaining to revenge in kind [adj]\n",
  "TALIONS": "TALION, (historical) a punishment identical to the crime e.g. death sentence for murder [n]\n",
  "TALIPAT": "(Sinhalese) a very tall southern Indian fan palm with enormous leaves which are used as sunshades etc., also TALIPOT [n -S]\n",
  "TALIPATS": "TALIPAT, (Sinhalese) a very tall southern Indian fan palm with enormous leaves which are used as sunshades etc., also TALIPOT [n]\n",
  "TALIPED": "(Latin) a person afflicted with a clubfoot [n -S]\n",
  "TALIPEDS": "TALIPED, (Latin) a person afflicted with a clubfoot [n]\n",
  "TALIPES": "(Latin) clubfoot [n TALIPES]\n",
  "TALIPOT": "(Sinhalese) a very tall southern Indian fan palm with enormous leaves which are used as sunshades etc., also TALIPAT [n -S]\n",
  "TALIPOTS": "TALIPOT, (Sinhalese) a very tall southern Indian fan palm with enormous leaves which are used as sunshades etc., also TALIPAT [n]\n",
  "TALISMAN": "(Arabic) an object supposed to have occult or magic powers, esp an inscribed stone or ring worn as an amulet to avert evil or bring good luck, health, etc, also TELESM [n -S]\n",
  "TALISMANIC": "of or like a talisman, also TALISMANICAL [adj TALISMANICALLY]\n",
  "TALISMANICAL": "of or like a talisman, also TALISMANIC [adj TALISMANICALLY]\n",
  "TALISMANICALLY": "TALISMANICAL, of or like a talisman, also TALISMANIC [adv]\n",
  "TALISMANS": "TALISMAN, (Arabic) an object supposed to have occult or magic powers, esp an inscribed stone or ring worn as an amulet to avert evil or bring good luck, health, etc, also TELESM [n]\n",
  "TALK": "to communicate by speaking [v -ED, -ING, -S]\n",
  "TALKABILITIES": "TALKABILITY, the quality of being talkable, easy to converse with [n]\n",
  "TALKABILITY": "the quality of being talkable, easy to converse with [n TALKABILITIES]\n",
  "TALKABLE": "able to be talked about [adj]\n",
  "TALKATHON": "a long talking session [n -S]\n",
  "TALKATHONS": "TALKATHON, a long talking session [n]\n",
  "TALKATIVE": "given to talking [adj TALKATIVELY]\n",
  "TALKATIVELY": "TALKATIVE, given to talking [adv]\n",
  "TALKATIVENESS": "TALKATIVE, given to talking [n]\n",
  "TALKATIVENESSES": "TALKATIVENESS, TALKATIVE, given to talking [n]\n",
  "TALKBACK": "a phone-in [n -S]\n",
  "TALKBACKS": "TALKBACK, a phone-in [n]\n",
  "TALKBOX": "a device for modulating a guitar's sound to be speech-like [n -ES]\n",
  "TALKBOXES": "TALKBOX, a device for modulating a guitar's sound to be speech-like [n]\n",
  "TALKED": "TALK, to communicate by speaking [v]\n",
  "TALKER": "one who talks [n -S]\n",
  "TALKERS": "TALKER, one who talks [n]\n",
  "TALKFEST": "an informal discussion meeting [n -S]\n",
  "TALKFESTS": "TALKFEST, an informal discussion meeting [n]\n",
  "TALKIE": "a moving picture with synchronized sound [n -S]\n",
  "TALKIER": "TALKY, tending to talk a great deal [adj]\n",
  "TALKIES": "TALKIE, a moving picture with synchronized sound [n]\n",
  "TALKIEST": "TALKY, tending to talk a great deal [adj]\n",
  "TALKINESS": "talkativeness [n -ES]\n",
  "TALKINESSES": "TALKINESS, talkativeness [n]\n",
  "TALKING": "conversation [n -S]\n",
  "TALKINGS": "TALKING, conversation [n]\n",
  "TALKS": "TALK, to communicate by speaking [v]\n",
  "TALKTIME": "the total amount of time available to the user of a telephone to make calls [n -S]\n",
  "TALKTIMES": "TALKTIME, the total amount of time available to the user of a telephone to make calls [n]\n",
  "TALKY": "tending to talk a great deal [adj TALKIER, TALKIEST]\n",
  "TALL": "having great height [adj TALLER, TALLEST] / a garment size for a tall person [n -S]\n",
  "TALLAGE": "a tax levied by the Norman and Angevin kings on their demesne lands and towns, or by a feudal lord on his tenants [n -S] / to levy tallage [v TALLAGED, TALLAGING, TALLAGES]\n",
  "TALLAGED": "TALLAGE, to levy tallage [v]\n",
  "TALLAGES": "TALLAGE, to levy tallage [v]\n",
  "TALLAGING": "TALLAGE, to levy tallage [v]\n",
  "TALLAISIM": "TALLITH, (Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n]\n",
  "TALLAT": "in the West of England, a loft, also TALLET, TALLOT [n -S]\n",
  "TALLATS": "TALLAT, in the West of England, a loft, also TALLET, TALLOT [n]\n",
  "TALLBOY": "a high chest of drawers [n -S]\n",
  "TALLBOYS": "TALLBOY, a high chest of drawers [n]\n",
  "TALLENT": "(Shakespeare) an old weight, also TALENT [n -S]\n",
  "TALLENTS": "TALLENT, (Shakespeare) an old weight, also TALENT [n]\n",
  "TALLER": "TALL, having great height [adj]\n",
  "TALLEST": "TALL, having great height [adj]\n",
  "TALLET": "in the West of England, a loft, also TALLAT, TALLOT [n -S]\n",
  "TALLETS": "TALLET, in the West of England, a loft, also TALLAT, TALLOT [n]\n",
  "TALLGRASS": "long grass in a North American prairie [n -ES]\n",
  "TALLGRASSES": "TALLGRASS, long grass in a North American prairie [n]\n",
  "TALLIABLE": "that can be tallied [adj]\n",
  "TALLIATE": "to lay a tallage upon [v TALLIATED, TALLIATING, TALLIATES]\n",
  "TALLIATED": "TALLIATE, to lay a tallage upon [v]\n",
  "TALLIATES": "TALLIATE, to lay a tallage upon [v]\n",
  "TALLIATING": "TALLIATE, to lay a tallage upon [v]\n",
  "TALLIED": "TALLY, to count up, reckon [v]\n",
  "TALLIER": "one who keeps tally [n -S]\n",
  "TALLIERS": "TALLIER, one who keeps tally [n]\n",
  "TALLIES": "TALLY, to count up, reckon [v]\n",
  "TALLIS": "(Hebrew) a Jewish prayer shawl, also TALLITH, TALLIT [n TALLISES or TALLISIM]\n",
  "TALLISES": "TALLIS, (Hebrew) a Jewish prayer shawl, also TALLITH, TALLIT [n]\n",
  "TALLISH": "somewhat tall [adj]\n",
  "TALLISIM": "TALLIS, (Hebrew) a Jewish prayer shawl, also TALLITH, TALLIT [n]\n",
  "TALLIT": "(Hebrew) a Jewish prayer shawl, also TALLITH, TALLIS [n TALLITS or TALLITES or TALLITIM or TALLITOT]\n",
  "TALLITES": "TALLIT, (Hebrew) a Jewish prayer shawl, also TALLITH, TALLIS [n]\n",
  "TALLITH": "(Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n TALLITHS or TALEYSIM or TALLAISIM or TALLITHES or TALLITHIM or TALLITOTH]\n",
  "TALLITHES": "TALLITH, (Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n]\n",
  "TALLITHIM": "TALLITH, (Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n]\n",
  "TALLITHS": "TALLITH, (Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n]\n",
  "TALLITIM": "TALLIT, (Hebrew) a Jewish prayer shawl, also TALLITH, TALLIS [n]\n",
  "TALLITOT": "TALLIT, (Hebrew) a Jewish prayer shawl, also TALLITH, TALLIS [n]\n",
  "TALLITOTH": "TALLITH, (Hebrew) a Jewish prayer shawl, also TALLIS, TALLIT [n]\n",
  "TALLITS": "TALLIT, (Hebrew) a Jewish prayer shawl, also TALLITH, TALLIS [n]\n",
  "TALLNESS": "the state of being tall [n -ES]\n",
  "TALLNESSES": "TALLNESS, the state of being tall [n]\n",
  "TALLOL": "a resinous liquid [n -S]\n",
  "TALLOLS": "TALLOL, a resinous liquid [n]\n",
  "TALLOT": "in the West of England, a loft, also TALLAT, TALLET [n -S]\n",
  "TALLOTS": "TALLOT, in the West of England, a loft, also TALLAT, TALLET [n]\n",
  "TALLOW": "to smear with a mixture of animal fats [v -ED, -ING, -S]\n",
  "TALLOWED": "TALLOW, to smear with a mixture of animal fats [v]\n",
  "TALLOWIER": "TALLOWY, of or like tallow, also TALLOWISH [adj]\n",
  "TALLOWIEST": "TALLOWY, of or like tallow, also TALLOWISH [adj]\n",
  "TALLOWING": "TALLOW, to smear with a mixture of animal fats [v]\n",
  "TALLOWISH": "of or like tallow, also TALLOWY [adj]\n",
  "TALLOWS": "TALLOW, to smear with a mixture of animal fats [v]\n",
  "TALLOWY": "of or like tallow, also TALLOWISH [adj TALLOWIER, TALLOWIEST]\n",
  "TALLS": "TALL, a garment size for a tall person [n]\n",
  "TALLY": "to count up, reckon [v TALLIED, TALLYING, TALLIES]\n",
  "TALLYHO": "a hunting cry [n TALLYHOS] / to utter a hunting cry [v -ED, -ING, -ES]\n",
  "TALLYHOED": "TALLYHO, to utter a hunting cry [v]\n",
  "TALLYHOES": "TALLYHO, a hunting cry [n]\n",
  "TALLYHOING": "TALLYHO, to utter a hunting cry [v]\n",
  "TALLYHOS": "TALLYHO, to utter a hunting cry [v]\n",
  "TALLYING": "TALLY, to count up, reckon [v]\n",
  "TALLYMAN": "a person who tallies [n TALLYMEN]\n",
  "TALLYMEN": "TALLYMAN, a person who tallies [n]\n",
  "TALLYSHOP": "a shop where goods are sold on credit to be paid for by instalments [n -S]\n",
  "TALLYSHOPS": "TALLYSHOP, a shop where goods are sold on credit to be paid for by instalments [n]\n",
  "TALLYWOMAN": "a female tallyman [n TALLYWOMEN]\n",
  "TALLYWOMEN": "TALLYWOMAN, a female tallyman [n]\n",
  "TALMA": "a long loose black cloak, often worn by tragedians [n -S]\n",
  "TALMAS": "TALMA, a long loose black cloak, often worn by tragedians [n]\n",
  "TALMUD": "(Hebrew) the body of the Jewish civil and canonical law not comprised in the Pentateuch [n -S]\n",
  "TALMUDIC": "(Hebrew) pertaining to Jewish civil and religious law [adj]\n",
  "TALMUDISM": "belief in the doctrines of the talmud, the body of the Jewish civil and canonical law not comprised in the Pentateuch [n -S]\n",
  "TALMUDISMS": "TALMUDISM, belief in the doctrines of the talmud, the body of the Jewish civil and canonical law not comprised in the Pentateuch [n]\n",
  "TALMUDS": "TALMUD, (Hebrew) the body of the Jewish civil and canonical law not comprised in the Pentateuch [n]\n",
  "TALON": "a hooked claw or finger, also TALANT, TALAUNT [n -S]\n",
  "TALONED": "having a talon [adj]\n",
  "TALONS": "TALON, a hooked claw or finger, also TALANT, TALAUNT [n]\n",
  "TALOOKA": "(Hindi) an estate in India, also TALUK, TALUKA [n -S]\n",
  "TALOOKAS": "TALOOKA, (Hindi) an estate in India, also TALUK, TALUKA [n]\n",
  "TALPA": "(Latin) an encysted tumour on the head, a wen [n TALPAE or TALPAS]\n",
  "TALPAE": "TALPA, (Latin) an encysted tumour on the head, a wen [n]\n",
  "TALPAS": "TALPA, (Latin) an encysted tumour on the head, a wen [n]\n",
  "TALUK": "(Hindi) a large estate, a revenue district, also TALOOKA, TALUKA [n -S]\n",
  "TALUKA": "(Hindi) an estate in India, also TALUK, TALOOKA [n -S]\n",
  "TALUKAS": "TALUKA, (Hindi) an estate in India, also TALUK, TALOOKA [n]\n",
  "TALUKDAR": "(Hindi) a proprietor of a taluk, a large estate [n -S]\n",
  "TALUKDARS": "TALUKDAR, (Hindi) a proprietor of a taluk, a large estate [n]\n",
  "TALUKS": "TALUK, (Hindi) a large estate, a revenue district, also TALOOKA, TALUKA [n]\n",
  "TALUS": "(Latin) a slope formed by an accumulation of rock debris [n TALUSES] / a bone of the foot [n TALI]\n",
  "TALUSES": "TALUS, (Latin) a slope formed by an accumulation of rock debris [n]\n",
  "TALWEG": "(German) a line following the lowest point of a valley; the middle of a navigable waterway used as boundary line, also THALWEG [n -S]\n",
  "TALWEGS": "TALWEG, (German) a line following the lowest point of a valley; the middle of a navigable waterway used as boundary line, also THALWEG [n]\n",
  "TAM": "a tight-fitting Scottish cap [n -S]\n",
  "TAMABILITIES": "TAMABILITY, the state of being tamable, also TAMEABILITY [n]\n",
  "TAMABILITY": "the state of being tamable, also TAMEABILITY [n TAMABILITIES]\n",
  "TAMABLE": "capable of being tamed [adj]\n",
  "TAMABLENESS": "the state of being tamable, also TAMEABLENESS [n -ES]\n",
  "TAMABLENESSES": "TAMABLENESS, the state of being tamable, also TAMEABLENESS [n]\n",
  "TAMAL": "(Nahuatl) cornmeal dough rolled with ground meat or beans seasoned usually with chili, also TAMALE [n -S]\n",
  "TAMALE": "(Nahuatl) cornmeal dough rolled with ground meat or beans seasoned usually with chili, also TAMAL [n -S]\n",
  "TAMALES": "TAMALE, (Nahuatl) cornmeal dough rolled with ground meat or beans seasoned usually with chili, also TAMAL [n]\n",
  "TAMALS": "TAMAL, (Nahuatl) cornmeal dough rolled with ground meat or beans seasoned usually with chili, also TAMALE [n]\n",
  "TAMANDU": "(Tupi) a tropical American arboreal anteater having a dense furry coat, also TAMANDUA [n -S]\n",
  "TAMANDUA": "(Tupi) a tropical American arboreal anteater having a dense furry coat, also TAMANDU [n -S]\n",
  "TAMANDUAS": "TAMANDUA, (Tupi) a tropical American arboreal anteater having a dense furry coat, also TAMANDU [n]\n",
  "TAMANDUS": "TAMANDU, (Tupi) a tropical American arboreal anteater having a dense furry coat, also TAMANDUA [n]\n",
  "TAMANOIR": "(Tupi) the giant anteater or antbear [n -S]\n",
  "TAMANOIRS": "TAMANOIR, (Tupi) the giant anteater or antbear [n]\n",
  "TAMANU": "(Tahitian) an East Indian tree, yielding tacamahac, a kind of gum resin [n -S]\n",
  "TAMANUS": "TAMANU, (Tahitian) an East Indian tree, yielding tacamahac, a kind of gum resin [n]\n",
  "TAMARA": "a mixture of cinnamon, cloves, coriander etc. [n -S]\n",
  "TAMARACK": "(Native American) the American or black larch [n -S]\n",
  "TAMARACKS": "TAMARACK, (Native American) the American or black larch [n]\n",
  "TAMARAO": "(Tagalog) a small wild buffalo of the Philippines, also TAMARAU, TIMARAU [n -S]\n",
  "TAMARAOS": "TAMARAO, (Tagalog) a small wild buffalo of the Philippines, also TAMARAU, TIMARAU [n]\n",
  "TAMARAS": "TAMARA, a mixture of cinnamon, cloves, coriander etc. [n]\n",
  "TAMARAU": "(Tagalog) a small wild buffalo of the Philippines, also TAMARAO, TIMARAU [n -S]\n",
  "TAMARAUS": "TAMARAU, (Tagalog) a small wild buffalo of the Philippines, also TAMARAO, TIMARAU [n]\n",
  "TAMARI": "(Japanese) a concentrated sauce made of soya beans and salt [n -S]\n",
  "TAMARILLO": "the tree tomato [n -S]\n",
  "TAMARILLOS": "TAMARILLO, the tree tomato [n]\n",
  "TAMARIN": "(French) a genus of small South American monkeys [n -S]\n",
  "TAMARIND": "(Arabic) a large tropical tree; its fruit [n -S]\n",
  "TAMARINDS": "TAMARIND, (Arabic) a large tropical tree; its fruit [n]\n",
  "TAMARINS": "TAMARIN, (French) a genus of small South American monkeys [n]\n",
  "TAMARIS": "TAMARI, (Japanese) a concentrated sauce made of soya beans and salt [n]\n",
  "TAMARISK": "a heathlike shrub or tree of warm regions [n -S]\n",
  "TAMARISKS": "TAMARISK, a heathlike shrub or tree of warm regions [n]\n",
  "TAMASHA": "(Urdu) in the Indian subcontinent, an entertainment, a show, a public function [n -S]\n",
  "TAMASHAS": "TAMASHA, (Urdu) in the Indian subcontinent, an entertainment, a show, a public function [n]\n",
  "TAMBAC": "(Malay) an alloy of copper and zinc, also TOMBAC, TAMBAK, TOMBACK, TOMBAK [n -S]\n",
  "TAMBACS": "TAMBAC, (Malay) an alloy of copper and zinc, also TOMBAC, TAMBAK, TOMBACK, TOMBAK [n]\n",
  "TAMBAK": "(Malay) an alloy of copper and zinc, also TOMBAC, TAMBAC, TOMBACK, TOMBAK [n -S]\n",
  "TAMBAKS": "TAMBAK, (Malay) an alloy of copper and zinc, also TOMBAC, TAMBAC, TOMBACK, TOMBAK [n]\n",
  "TAMBALA": "(Nyanja) a monetary unit of Malawi [n TAMBALAS or MATAMBALA]\n",
  "TAMBALAS": "TAMBALA, (Nyanja) a monetary unit of Malawi [n]\n",
  "TAMBER": "the distinctive quality of a sound, also TIMBRE [n -S]\n",
  "TAMBERS": "TAMBER, the distinctive quality of a sound, also TIMBRE [n]\n",
  "TAMBOUR": "to embroider on a round wooden frame [v -ED, -ING, -S]\n",
  "TAMBOURA": "(Arabic) an Eastern stringed instrument, used to produce a drone, also TAMBUR, TAMBURA [n -S]\n",
  "TAMBOURAS": "TAMBOURA, (Arabic) an Eastern stringed instrument, used to produce a drone, also TAMBUR, TAMBURA [n]\n",
  "TAMBOURED": "TAMBOUR, to embroider on a round wooden frame [v]\n",
  "TAMBOURER": "one who embroiders on a tambour [n -S]\n",
  "TAMBOURERS": "TAMBOURER, one who embroiders on a tambour [n]\n",
  "TAMBOURIN": "a long, narrow, Provencal drum; a two-beat dance style, accompanied by a tambourin [n -S]\n",
  "TAMBOURINE": "a shallow single-headed drum with jingles fitted round its rim, played on by beating or tapping with the hand, also TAMBURIN [n -S]\n",
  "TAMBOURINES": "TAMBOURINE, a shallow single-headed drum with jingles fitted round its rim, played on by beating or tapping with the hand, also TAMBURIN [n]\n",
  "TAMBOURING": "TAMBOUR, to embroider on a round wooden frame [v]\n",
  "TAMBOURINIST": "one who plays the tambourin [n -S]\n",
  "TAMBOURINISTS": "TAMBOURINIST, one who plays the tambourin [n]\n",
  "TAMBOURINS": "TAMBOURIN, a long, narrow, Provencal drum; a two-beat dance style, accompanied by a tambourin [n]\n",
  "TAMBOURS": "TAMBOUR, to embroider on a round wooden frame [v]\n",
  "TAMBUR": "(Arabic) an Eastern stringed instrument, used to produce a drone, also TAMBOURA, TAMBURA [n -S]\n",
  "TAMBURA": "(Arabic) an Eastern stringed instrument, used to produce a drone, also TAMBOURA, TAMBUR [n -S]\n",
  "TAMBURAS": "TAMBURA, (Arabic) an Eastern stringed instrument, used to produce a drone, also TAMBOURA, TAMBUR [n]\n",
  "TAMBURIN": "(Spenser) a tambourine [n -S]\n",
  "TAMBURINS": "TAMBURIN, (Spenser) a tambourine [n]\n",
  "TAMBURS": "TAMBUR, (Arabic) an Eastern stringed instrument, used to produce a drone, also TAMBOURA, TAMBURA [n]\n",
  "TAME": "not wild [adj TAMER, TAMEST, TAMELY] / to make tame [v TAMED, TAMING, TAMES]\n",
  "TAMEABILITIES": "TAMEABILITY, the quality of being tameable, also TAMABILITY [n]\n",
  "TAMEABILITY": "the quality of being tameable, also TAMABILITY [n TAMEABILITIES]\n",
  "TAMEABLE": "capable of being tamed, also TAMABLE [adj]\n",
  "TAMEABLENESS": "the state of being tameable, also TAMABLENESS [n -ES]\n",
  "TAMEABLENESSES": "TAMEABLENESS, the state of being tameable, also TAMABLENESS [n]\n",
  "TAMED": "TAME, to make tame [v]\n",
  "TAMEIN": "a garment worn by Burmese women [n -S]\n",
  "TAMEINS": "TAMEIN, a garment worn by Burmese women [n]\n",
  "TAMELESS": "not capable of being tamed [adj]\n",
  "TAMELESSNESS": "the state of being tameless [n -ES]\n",
  "TAMELESSNESSES": "TAMELESSNESS, the state of being tameless [n]\n",
  "TAMELY": "TAME, not wild [adv]\n",
  "TAMENESS": "the state of being tame [n -ES]\n",
  "TAMENESSES": "TAMENESS, the state of being tame [n]\n",
  "TAMER": "one that tames [n -S]\n",
  "TAMERS": "TAMER, one that tames [n]\n",
  "TAMES": "TAME, to make tame [v]\n",
  "TAMEST": "TAME, not wild [adj]\n",
  "TAMIN": "(French) a thin worsted stuff, highly glazed, also TAMINE [n -S]\n",
  "TAMINE": "(French) a thin worsted stuff, highly glazed, also TAMIN [n -S]\n",
  "TAMINES": "TAMINE, (French) a thin worsted stuff, highly glazed, also TAMIN [n]\n",
  "TAMING": "the act of taming [n -S]\n",
  "TAMINGS": "TAMING, the act of taming [n]\n",
  "TAMINS": "TAMIN, (French) a thin worsted stuff, highly glazed, also TAMINE [n]\n",
  "TAMIS": "(French) a strainer; a glazed woollen or mixed fabric [n TAMIS]\n",
  "TAMISE": "a thin woollen fabric [n -S]\n",
  "TAMISES": "TAMISE, a thin woollen fabric [n]\n",
  "TAMMAR": "(Native Australian) a small scrub wallaby [n -S]\n",
  "TAMMARS": "TAMMAR, (Native Australian) a small scrub wallaby [n]\n",
  "TAMMIE": "(Scots) a Tam o' Shanter, also TAMMY [n -S]\n",
  "TAMMIED": "TAMMY, to strain soup through a tammy [v]\n",
  "TAMMIES": "TAMMIE, (Scots) a Tam o' Shanter, also TAMMY [n]\n",
  "TAMMY": "(Scots) a Tam o' Shanter, also TAMMIE [n TAMMIES] / to strain soup through a tammy [v TAMMIED, TAMMYING, TAMMIES]\n",
  "TAMMYING": "TAMMY, to strain soup through a tammy [v]\n",
  "TAMOXIFEN": "a drug which inhibits the effects of oestrogen [n -S]\n",
  "TAMOXIFENS": "TAMOXIFEN, a drug which inhibits the effects of oestrogen [n]\n",
  "TAMP": "to pack down by tapping [v -ED, -ING, -S]\n",
  "TAMPALA": "an annual herb [n -S]\n",
  "TAMPALAS": "TAMPALA, an annual herb [n]\n",
  "TAMPAN": "(Setswana) a venomous South African tick [n -S]\n",
  "TAMPANS": "TAMPAN, (Setswana) a venomous South African tick [n]\n",
  "TAMPED": "TAMP, to pack down by tapping [v]\n",
  "TAMPER": "to interfere in a harmful manner [v -ED, -ING, -S]\n",
  "TAMPERED": "TAMPER, to interfere in a harmful manner [v]\n",
  "TAMPERER": "one who tampers [n -S]\n",
  "TAMPERERS": "TAMPERER, one who tampers [n]\n",
  "TAMPERING": "the act of tampering [n -S]\n",
  "TAMPERINGS": "TAMPERING, the act of tampering [n]\n",
  "TAMPERPROOF": "proof against tampering [adj]\n",
  "TAMPERS": "TAMPER, to interfere in a harmful manner [v]\n",
  "TAMPING": "the act of filling a hole for blasting [n -S]\n",
  "TAMPINGS": "TAMPING, the act of filling a hole for blasting [n]\n",
  "TAMPION": "(French) a protective plug placed in the mouth of a gun or cannon, also TOMPION [n -S]\n",
  "TAMPIONS": "TAMPION, (French) a protective plug placed in the mouth of a gun or cannon, also TOMPION [n]\n",
  "TAMPON": "(French) a plug in a wound to staunch flow of blood [n -S] / to plug with a tampon, also TOMPON [v -ED, -ING, -S]\n",
  "TAMPONADE": "the surgical use of a tampon, also TAMPONAGE [n -S]\n",
  "TAMPONADES": "TAMPONADE, the surgical use of a tampon, also TAMPONAGE [n]\n",
  "TAMPONAGE": "the surgical use of a tampon, also TAMPONADE [n -S]\n",
  "TAMPONAGES": "TAMPONAGE, the surgical use of a tampon, also TAMPONADE [n]\n",
  "TAMPONED": "TAMPON, to plug with a tampon, also TOMPON [v]\n",
  "TAMPONING": "TAMPON, to plug with a tampon, also TOMPON [v]\n",
  "TAMPONS": "TAMPON, to plug with a tampon, also TOMPON [v]\n",
  "TAMPS": "TAMP, to pack down by tapping [v]\n",
  "TAMS": "TAM, a tight-fitting Scottish cap [n]\n",
  "TAMWORTH": "a breed of long-bodied pigs with red-golden hair [n -S]\n",
  "TAMWORTHS": "TAMWORTH, a breed of long-bodied pigs with red-golden hair [n]\n",
  "TAN": "brown [adj TANNER, TANNEST] / to become brown in the sun [v TANNED, TANNING, TANS]\n",
  "TANA": "(Hindi) an Indian police station, also TANNA, TANNAH, THANA, THANAH, THANNA, THANNAH [n -S]\n",
  "TANADAR": "(Hindi) an officer in charge of a tana, a police station, also THANADAR [n -S]\n",
  "TANADARS": "TANADAR, (Hindi) an officer in charge of a tana, a police station, also THANADAR [n]\n",
  "TANAGER": "(Tupi) a brightly-coloured South American bird [n -S]\n",
  "TANAGERS": "TANAGER, (Tupi) a brightly-coloured South American bird [n]\n",
  "TANAGRA": "a kind of terracotta figurine [n -S]\n",
  "TANAGRAS": "TANAGRA, a kind of terracotta figurine [n]\n",
  "TANAGRINE": "of or pertaining to the tanagers, a family of brightly-coloured South American birds [adj]\n",
  "TANAISTE": "(Irish) in Irish politics, the vice-Taoiseach or deputy prime minister of the Republic of Ireland [n -S]\n",
  "TANAISTES": "TANAISTE, (Irish) in Irish politics, the vice-Taoiseach or deputy prime minister of the Republic of Ireland [n]\n",
  "TANALISED": "of timber, treated with Tanalith, a proprietary preservative, also TANALIZED [adj]\n",
  "TANALIZED": "of timber, treated with Tanalith, a proprietary preservative, also TANALISED [adj]\n",
  "TANAS": "TANA, (Hindi) an Indian police station, also TANNA, TANNAH, THANA, THANAH, THANNA, THANNAH [n]\n",
  "TANBARK": "a tree bark used for tanning [n -S]\n",
  "TANBARKS": "TANBARK, a tree bark used for tanning [n]\n",
  "TANDEM": "(Latin) a bicycle built for two [n -S]\n",
  "TANDEMS": "TANDEM, (Latin) a bicycle built for two [n]\n",
  "TANDEMWISE": "in tandem [adv]\n",
  "TANDOOR": "(Hindi) a type of Indian cooking in which meat, vegetables etc. are baked over charcoal in a clay oven, also TANDOORI [n -S]\n",
  "TANDOORI": "(Hindi) a type of Indian cooking in which meat, vegetables etc. are baked over charcoal in a clay oven, also TANDOOR [n -S]\n",
  "TANDOORIS": "TANDOORI, (Hindi) a type of Indian cooking in which meat, vegetables etc. are baked over charcoal in a clay oven, also TANDOOR [n]\n",
  "TANDOORS": "TANDOOR, (Hindi) a type of Indian cooking in which meat, vegetables etc. are baked over charcoal in a clay oven, also TANDOORI [n]\n",
  "TANE": "(Spenser) taken [v]\n",
  "TANG": "to ring [v -ED, -ING, -S]\n",
  "TANGA": "(Portuguese) a brief stringlike bikini [n -S]\n",
  "TANGAS": "TANGA, (Portuguese) a brief stringlike bikini [n]\n",
  "TANGED": "TANG, to ring [v]\n",
  "TANGELO": "a hybrid between a tangerine orange and a pomelo [n -S]\n",
  "TANGELOS": "TANGELO, a hybrid between a tangerine orange and a pomelo [n]\n",
  "TANGENCE": "the state of being in immediate physical contact, also TANGENCY [n -S]\n",
  "TANGENCES": "TANGENCE, the state of being in immediate physical contact, also TANGENCY [n]\n",
  "TANGENCIES": "TANGENCY, the state of being in immediate physical contact, also TANGENCE [n]\n",
  "TANGENCY": "the state of being in immediate physical contact, also TANGENCE [n TANGENCIES]\n",
  "TANGENT": "a line that touches a curve [n -S]\n",
  "TANGENTAL": "of or pertaining to the nature of a tangent, also TANGENTIAL [adj]\n",
  "TANGENTALLY": "TANGENTAL, of or pertaining to the nature of a tangent, also TANGENTIAL [adv]\n",
  "TANGENTIAL": "of or pertaining to the nature of a tangent, also TANGENTAL [adj TANGENTIALLY]\n",
  "TANGENTIALITIES": "TANGENTIALITY, the state of being tangential [n]\n",
  "TANGENTIALITY": "the state of being tangential [n TANGENTIALITIES]\n",
  "TANGENTIALLY": "TANGENTIAL, of or pertaining to the nature of a tangent, also TANGENTAL [adv]\n",
  "TANGENTS": "TANGENT, a line that touches a curve [n]\n",
  "TANGERINE": "a mandarin orange, esp. a small, flattish, loose-skinned variety [n -S]\n",
  "TANGERINES": "TANGERINE, a mandarin orange, esp. a small, flattish, loose-skinned variety [n]\n",
  "TANGHIN": "(Malagasy) a Madagascan poison formerly used to test the guilt of someone suspected of a crime [n -S]\n",
  "TANGHININ": "the active principle in tanghin, a Madagascan poison formerly used to test the guilt of someone suspected of a crime [n -S]\n",
  "TANGHININS": "TANGHININ, the active principle in tanghin, a Madagascan poison formerly used to test the guilt of someone suspected of a crime [n]\n",
  "TANGHINS": "TANGHIN, (Malagasy) a Madagascan poison formerly used to test the guilt of someone suspected of a crime [n]\n",
  "TANGI": "(Maori) a ceremony of mourning [n -S]\n",
  "TANGIBILITIES": "TANGIBILITY, the state of being tangible [n]\n",
  "TANGIBILITY": "the state of being tangible [n TANGIBILITIES]\n",
  "TANGIBLE": "able to be touched [adj TANGIBLY] / something tangible [n -S]\n",
  "TANGIBLENESS": "the state of being tangible [n -ES]\n",
  "TANGIBLENESSES": "TANGIBLENESS, the state of being tangible [n]\n",
  "TANGIBLES": "TANGIBLE, something tangible [n]\n",
  "TANGIBLY": "TANGIBLE, able to be touched [adv]\n",
  "TANGIE": "an Orcadian water-spirit, appearing as a seahorse, or a man covered with seaweed [n -S]\n",
  "TANGIER": "TANGY, having a fresh or sharp taste [adj]\n",
  "TANGIES": "TANGIE, an Orcadian water-spirit, appearing as a seahorse, or a man covered with seaweed [n]\n",
  "TANGIEST": "TANGY, having a fresh or sharp taste [adj]\n",
  "TANGINESS": "the state of being tangy [n -ES]\n",
  "TANGINESSES": "TANGINESS, the state of being tangy [n]\n",
  "TANGING": "TANG, to ring [v]\n",
  "TANGIS": "TANGI, (Maori) a ceremony of mourning [n]\n",
  "TANGLE": "to form into an interwoven mass [v TANGLED, TANGLING, TANGLES]\n",
  "TANGLED": "TANGLE, to form into an interwoven mass [v]\n",
  "TANGLEFOOT": "(US) whisky, intoxicating liquor [n -S]\n",
  "TANGLEFOOTS": "TANGLEFOOT, (US) whisky, intoxicating liquor [n]\n",
  "TANGLEMENT": "a state of being entangled [n -S]\n",
  "TANGLEMENTS": "TANGLEMENT, a state of being entangled [n]\n",
  "TANGLER": "one who tangles [n -S]\n",
  "TANGLERS": "TANGLER, one who tangles [n]\n",
  "TANGLES": "TANGLE, to form into an interwoven mass [v]\n",
  "TANGLESOME": "causing entanglement [adj]\n",
  "TANGLEWEED": "a coarse seaweed [n -S]\n",
  "TANGLEWEEDS": "TANGLEWEED, a coarse seaweed [n]\n",
  "TANGLIER": "TANGLY, tangled [adj]\n",
  "TANGLIEST": "TANGLY, tangled [adj]\n",
  "TANGLING": "causing a tangle [adj TANGLINGLY] / the act of tangling [n -S]\n",
  "TANGLINGLY": "TANGLING, causing a tangle [adv]\n",
  "TANGLINGS": "TANGLING, the act of tangling [n]\n",
  "TANGLY": "tangled [adj TANGLIER, TANGLIEST]\n",
  "TANGO": "a kind of dance [n -S] / to dance the tango [v -ED, -ING, -ES]\n",
  "TANGOED": "TANGO, to dance the tango [v]\n",
  "TANGOES": "TANGO, to dance the tango [v]\n",
  "TANGOING": "TANGO, to dance the tango [v]\n",
  "TANGOIST": "a tango dancer [n -S]\n",
  "TANGOISTS": "TANGOIST, a tango dancer [n]\n",
  "TANGOLIKE": "like a tango, a kind of dance [adj]\n",
  "TANGOS": "TANGO, to dance the tango [v]\n",
  "TANGRAM": "a Chinese geometrical puzzle [n -S]\n",
  "TANGRAMS": "TANGRAM, a Chinese geometrical puzzle [n]\n",
  "TANGS": "TANG, to ring [v]\n",
  "TANGUN": "(Hindi) a piebald variety of the horse, native of Tibet [n -S]\n",
  "TANGUNS": "TANGUN, (Hindi) a piebald variety of the horse, native of Tibet [n]\n",
  "TANGY": "having a fresh or sharp taste [adj TANGIER, TANGIEST]\n",
  "TANH": "(short for) a hyperbolic tangent [n -S]\n",
  "TANHS": "TANH, (short for) a hyperbolic tangent [n]\n",
  "TANIST": "(historical) the heir apparent to a Celtic chief [n -S]\n",
  "TANISTRIES": "TANISTRY, the system of electing a tanist [n]\n",
  "TANISTRY": "the system of electing a tanist [n TANISTRIES]\n",
  "TANISTS": "TANIST, (historical) the heir apparent to a Celtic chief [n]\n",
  "TANIWHA": "(Maori) a mythical monster, that lives in very deep water [n -S]\n",
  "TANIWHAS": "TANIWHA, (Maori) a mythical monster, that lives in very deep water [n]\n",
  "TANK": "to store in a container for liquids [v -ED, -ING, -S]\n",
  "TANKA": "(Japanese) a Japanese verse form [n -S]\n",
  "TANKAGE": "the capacity of a tank [n -S]\n",
  "TANKAGES": "TANKAGE, the capacity of a tank [n]\n",
  "TANKARD": "a large mug-like vessel, usually with a handle [n -S]\n",
  "TANKARDS": "TANKARD, a large mug-like vessel, usually with a handle [n]\n",
  "TANKAS": "TANKA, (Japanese) a Japanese verse form [n]\n",
  "TANKBUSTER": "a plane that specialises in attacking tanks [n -S]\n",
  "TANKBUSTERS": "TANKBUSTER, a plane that specialises in attacking tanks [n]\n",
  "TANKBUSTING": "the use of a tankbuster, a plane that specialises in attacking tanks [n -S]\n",
  "TANKBUSTINGS": "TANKBUSTING, the use of a tankbuster, a plane that specialises in attacking tanks [n]\n",
  "TANKED": "TANK, to store in a container for liquids [v]\n",
  "TANKER": "to transport by a ship designed to transport liquids [v -ED, -ING, -S]\n",
  "TANKERED": "TANKER, to transport by a ship designed to transport liquids [v]\n",
  "TANKERING": "TANKER, to transport by a ship designed to transport liquids [v]\n",
  "TANKERS": "TANKER, to transport by a ship designed to transport liquids [v]\n",
  "TANKFUL": "the amount a tank can hold [n -S]\n",
  "TANKFULS": "TANKFUL, the amount a tank can hold [n]\n",
  "TANKIA": "(Chinese) the boat-dwelling population of China [n -S]\n",
  "TANKIAS": "TANKIA, (Chinese) the boat-dwelling population of China [n]\n",
  "TANKIES": "TANKY, a hardline communist [n]\n",
  "TANKING": "a defeat [n -S]\n",
  "TANKINGS": "TANKING, a defeat [n]\n",
  "TANKINI": "a woman's swimsuit consisting of bikini briefs and a tank top [n -S]\n",
  "TANKINIS": "TANKINI, a woman's swimsuit consisting of bikini briefs and a tank top [n]\n",
  "TANKLESS": "without a tank [adj]\n",
  "TANKLIKE": "like a tank [adj]\n",
  "TANKS": "TANK, to store in a container for liquids [v]\n",
  "TANKSHIP": "a tanker [n -S]\n",
  "TANKSHIPS": "TANKSHIP, a tanker [n]\n",
  "TANKY": "a hardline communist [n TANKIES]\n",
  "TANLING": "(Shakespeare) someone tanned by the sun [n -S]\n",
  "TANLINGS": "TANLING, (Shakespeare) someone tanned by the sun [n]\n",
  "TANNA": "(Hindi) an Indian police station, also TANA, TANNAH, THANA, THANAH, THANNA, THANNAH [n -S]\n",
  "TANNABLE": "capable of being tanned [adj]\n",
  "TANNAGE": "the process of tanning [n -S]\n",
  "TANNAGES": "TANNAGE, the process of tanning [n]\n",
  "TANNAH": "(Hindi) an Indian police station, also TANA, TANNA, THANA, THANAH, THANNA, THANNAH [n -S]\n",
  "TANNAHS": "TANNAH, (Hindi) an Indian police station, also TANA, TANNA, THANA, THANAH, THANNA, THANNAH [n]\n",
  "TANNAS": "TANNA, (Hindi) an Indian police station, also TANA, TANNAH, THANA, THANAH, THANNA, THANNAH [n]\n",
  "TANNATE": "a salt of tannic acid [n -S]\n",
  "TANNATES": "TANNATE, a salt of tannic acid [n]\n",
  "TANNED": "TAN, to become brown in the sun [v]\n",
  "TANNER": "in pre-decimal coinage, a sixpence [n -S]\n",
  "TANNERIES": "TANNERY, a place where hides are tanned [n]\n",
  "TANNERS": "TANNER, in pre-decimal coinage, a sixpence [n]\n",
  "TANNERY": "a place where hides are tanned [n TANNERIES]\n",
  "TANNEST": "TAN, brown [adj]\n",
  "TANNIC": "containing tannin [adj]\n",
  "TANNIE": "(South African) literally aunt, a title of respect for an elderly woman [n -S]\n",
  "TANNIES": "TANNIE, (South African) literally aunt, a title of respect for an elderly woman [n]\n",
  "TANNIN": "any of a group of yellowish or brownish acidic astringent compounds related to gallic acid [n -S]\n",
  "TANNING": "the process of converting hides into leather [n -S]\n",
  "TANNINGS": "TANNING, the process of converting hides into leather [n]\n",
  "TANNINS": "TANNIN, any of a group of yellowish or brownish acidic astringent compounds related to gallic acid [n]\n",
  "TANNISH": "somewhat tan [adj]\n",
  "TANNOY": "(tradename) a public announcement system [n -S] / to announce by tannoy [v -ED, -ING, -S]\n",
  "TANNOYED": "TANNOY, to announce by tannoy [v]\n",
  "TANNOYING": "TANNOY, to announce by tannoy [v]\n",
  "TANNOYS": "TANNOY, to announce by tannoy [v]\n",
  "TANOREXIC": "a person obsessed with maintaining a permanent deep tan, esp. through use of tanning machines [n -S]\n",
  "TANOREXICS": "TANOREXIC, a person obsessed with maintaining a permanent deep tan, esp. through use of tanning machines [n]\n",
  "TANREC": "(Malagasy) a small insectivore, native to Madagascar, also TENREC [n -S]\n",
  "TANRECS": "TANREC, (Malagasy) a small insectivore, native to Madagascar, also TENREC [n]\n",
  "TANS": "TAN, to become brown in the sun [v]\n",
  "TANSIES": "TANSY, a perennial herb [n]\n",
  "TANSY": "a perennial herb [n TANSIES]\n",
  "TANTALATE": "a salt of tantalic acid [n -S]\n",
  "TANTALATES": "TANTALATE, a salt of tantalic acid [n]\n",
  "TANTALIC": "of or containing tantalum, esp. in a higher valency [adj]\n",
  "TANTALISATION": "the process of tantalising, also TANTALIZATION [n -S]\n",
  "TANTALISATIONS": "TANTALISATION, the process of tantalising, also TANTALIZATION [n]\n",
  "TANTALISE": "to torment by presenting something desirable but keeping it out of reach, also TANTALIZE [v TANTALISED, TANTALISING, TANTALISES]\n",
  "TANTALISED": "TANTALISE, to torment by presenting something desirable but keeping it out of reach, also TANTALIZE [v]\n",
  "TANTALISER": "something or someone that tantalises, also TANTALIZER [n -S]\n",
  "TANTALISERS": "TANTALISER, something or someone that tantalises, also TANTALIZER [n]\n",
  "TANTALISES": "TANTALISE, to torment by presenting something desirable but keeping it out of reach, also TANTALIZE [v]\n",
  "TANTALISING": "frustratingly enticing [adj TANTALISINGLY] / tormenting by presenting something desirable but keeping it out of reach [n -S]\n",
  "TANTALISINGLY": "TANTALISING, frustratingly enticing [adv]\n",
  "TANTALISINGS": "TANTALISING, tormenting by presenting something desirable but keeping it out of reach [n]\n",
  "TANTALISM": "the punishment of Tantalus; a tormenting [n -S]\n",
  "TANTALISMS": "TANTALISM, the punishment of Tantalus; a tormenting [n]\n",
  "TANTALITE": "a black mineral, the main ore from which tantalum is derived [n -S]\n",
  "TANTALITES": "TANTALITE, a black mineral, the main ore from which tantalum is derived [n]\n",
  "TANTALIZATION": "the process of tantalizing, also TANTALISATION [n -S]\n",
  "TANTALIZATIONS": "TANTALIZATION, the process of tantalizing, also TANTALISATION [n]\n",
  "TANTALIZE": "to torment by presenting something desirable but keeping it out of reach, also TANTALISE [v TANTALIZED, TANTALIZING, TANTALIZES]\n",
  "TANTALIZED": "TANTALIZE, to torment by presenting something desirable but keeping it out of reach, also TANTALISE [v]\n",
  "TANTALIZER": "something or someone that tantalises, also TANTALISER [n -S]\n",
  "TANTALIZERS": "TANTALIZER, something or someone that tantalises, also TANTALISER [n]\n",
  "TANTALIZES": "TANTALIZE, to torment by presenting something desirable but keeping it out of reach, also TANTALISE [v]\n",
  "TANTALIZING": "frustratingly enticing [adj TANTALIZINGLY] / tormenting by presenting something desirable but keeping it out of reach [n -S]\n",
  "TANTALIZINGLY": "TANTALIZING, frustratingly enticing [adv]\n",
  "TANTALIZINGS": "TANTALIZING, tormenting by presenting something desirable but keeping it out of reach [n]\n",
  "TANTALOUS": "of or containing trivalent tantalum [adj]\n",
  "TANTALUM": "an acid-resistant metallic element, useful for electronic and surgical parts [n -S]\n",
  "TANTALUMS": "TANTALUM, an acid-resistant metallic element, useful for electronic and surgical parts [n]\n",
  "TANTALUS": "a case in which alcohol decanters are visible but locked up [n -ES]\n",
  "TANTALUSES": "TANTALUS, a case in which alcohol decanters are visible but locked up [n]\n",
  "TANTAMOUNT": "equivalent in value, significance, or effect [adj]\n",
  "TANTARA": "a trumpet fanfare; a hunting cry, also TANTARARA [n -S]\n",
  "TANTARARA": "a trumpet fanfare; a hunting cry, also TANTARA [n -S]\n",
  "TANTARARAS": "TANTARARA, a trumpet fanfare; a hunting cry, also TANTARA [n]\n",
  "TANTARAS": "TANTARA, a trumpet fanfare; a hunting cry, also TANTARARA [n]\n",
  "TANTI": "(archaic) worthwhile [adj]\n",
  "TANTIES": "TANTY, (short for) tantrum [n]\n",
  "TANTIVIES": "TANTIVY, a hunting cry [n]\n",
  "TANTIVY": "a hunting cry [n TANTIVIES]\n",
  "TANTO": "(Japanese) a short Japanese sword [n -S]\n",
  "TANTONIES": "TANTONY, the smallest pig in a litter [n]\n",
  "TANTONY": "the smallest pig in a litter [n TANTONIES]\n",
  "TANTOS": "TANTO, (Japanese) a short Japanese sword [n]\n",
  "TANTRA": "(Sanskrit) a class of Hindu religious writings [n -S]\n",
  "TANTRAS": "TANTRA, (Sanskrit) a class of Hindu religious writings [n]\n",
  "TANTRIC": "relating to tantra [adj]\n",
  "TANTRISM": "a school of Buddhism incorporating Hindu and pagan elements [n -S]\n",
  "TANTRISMS": "TANTRISM, a school of Buddhism incorporating Hindu and pagan elements [n]\n",
  "TANTRIST": "an adherent of the yogic discipline tantrism [n -S]\n",
  "TANTRISTS": "TANTRIST, an adherent of the yogic discipline tantrism [n]\n",
  "TANTRUM": "a fit of rage [n -S]\n",
  "TANTRUMS": "TANTRUM, a fit of rage [n]\n",
  "TANTY": "(short for) tantrum [n TANTIES]\n",
  "TANUKI": "(Japanese) a raccoon dog [n -S]\n",
  "TANUKIS": "TANUKI, (Japanese) a raccoon dog [n]\n",
  "TANYARD": "the section of a tannery containing the vats [n -S]\n",
  "TANYARDS": "TANYARD, the section of a tannery containing the vats [n]\n",
  "TANZANITE": "a gemstone that exhibits blue, violet, or greenish color depending on the polarization of the light [n -S]\n",
  "TANZANITES": "TANZANITE, a gemstone that exhibits blue, violet, or greenish color depending on the polarization of the light [n]\n",
  "TAO": "(Chinese) a path of virtuous conduct in Chinese philosophy [n -S]\n",
  "TAONGA": "(Maori) treasure, something highly prized [n -S]\n",
  "TAONGAS": "TAONGA, (Maori) treasure, something highly prized [n]\n",
  "TAOS": "TAO, (Chinese) a path of virtuous conduct in Chinese philosophy [n]\n",
  "TAP": "to strike gently [v TAPPED, TAPPING, TAPS]\n",
  "TAPA": "(Polynesian) a kind of cloth prepared by the Polynesians from the inner bark of the paper mulberry, also TAPPA [n -S]\n",
  "TAPACOLO": "(Spanish) a small South American bird, also TAPACULO [n -S]\n",
  "TAPACOLOS": "TAPACOLO, (Spanish) a small South American bird, also TAPACULO [n]\n",
  "TAPACULO": "(Spanish) a small South American bird, also TAPACOLO [n -S]\n",
  "TAPACULOS": "TAPACULO, (Spanish) a small South American bird, also TAPACOLO [n]\n",
  "TAPADERA": "(Spanish) the leather guard in front of a Mexican stirrup, also TAPADERO [n -S]\n",
  "TAPADERAS": "TAPADERA, (Spanish) the leather guard in front of a Mexican stirrup, also TAPADERO [n]\n",
  "TAPADERO": "(Spanish) the leather guard in front of a Mexican stirrup, also TAPADERA [n -S]\n",
  "TAPADEROS": "TAPADERO, (Spanish) the leather guard in front of a Mexican stirrup, also TAPADERA [n]\n",
  "TAPALO": "(Spanish) a scarf worn in Latin-American countries [n -S]\n",
  "TAPALOS": "TAPALO, (Spanish) a scarf worn in Latin-American countries [n]\n",
  "TAPAS": "TAPA, (Polynesian) a kind of cloth prepared by the Polynesians from the inner bark of the paper mulberry, also TAPPA [n]\n",
  "TAPE": "a long, narrow strip or band [n -S] / to put tape over [v TAPED, TAPING, TAPES]\n",
  "TAPEABLE": "able to be taped [adj]\n",
  "TAPED": "TAPE, to put tape over [v]\n",
  "TAPELESS": "without a tape [adj]\n",
  "TAPELIKE": "like a tape [adj]\n",
  "TAPELINE": "a tape for measuring distances [n -S]\n",
  "TAPELINES": "TAPELINE, a tape for measuring distances [n]\n",
  "TAPEN": "made of tape [adj]\n",
  "TAPENADE": "(French) a paste made of olives, anchovies and capers [n -S]\n",
  "TAPENADES": "TAPENADE, (French) a paste made of olives, anchovies and capers [n]\n",
  "TAPER": "to become gradually narrower [v -ED, -ING, -S]\n",
  "TAPERED": "TAPER, to become gradually narrower [v]\n",
  "TAPERER": "one who carries a candle in a religious procession [n -S]\n",
  "TAPERERS": "TAPERER, one who carries a candle in a religious procession [n]\n",
  "TAPERING": "becoming smaller towards one end [adj TAPERINGLY] / the act of tapering [n -S]\n",
  "TAPERINGLY": "TAPERING, becoming smaller towards one end [adv]\n",
  "TAPERINGS": "TAPERING, the act of tapering [n]\n",
  "TAPERNESS": "the state of being taper [n -ES]\n",
  "TAPERNESSES": "TAPERNESS, the state of being taper [n]\n",
  "TAPERS": "TAPER, to become gradually narrower [v]\n",
  "TAPERSTICK": "a stick for holding a taper [n -S]\n",
  "TAPERSTICKS": "TAPERSTICK, a stick for holding a taper [n]\n",
  "TAPERWISE": "in tapering fashion [adv]\n",
  "TAPES": "TAPE, to put tape over [v]\n",
  "TAPESCRIPT": "a tape-recorded reading of a complete script [n -S]\n",
  "TAPESCRIPTS": "TAPESCRIPT, a tape-recorded reading of a complete script [n]\n",
  "TAPESTRIED": "TAPESTRY, to decorate with a woven wall hanging [v]\n",
  "TAPESTRIES": "TAPESTRY, to decorate with a woven wall hanging [v]\n",
  "TAPESTRY": "to decorate with a woven wall hanging [v TAPESTRIED, TAPESTRYING, TAPESTRIES]\n",
  "TAPESTRYING": "TAPESTRY, to decorate with a woven wall hanging [v]\n",
  "TAPET": "(Spenser) to decorate with tapestries [v -ED, -ING, -S]\n",
  "TAPETA": "TAPETUM, (Latin) a reflective layer of the choroid in the eyes of many animals, causing them to shine in the dark [n]\n",
  "TAPETAL": "relating to the tapetum, a reflective layer of the choroid in the eyes of many animals [adj]\n",
  "TAPETED": "TAPET, (Spenser) to decorate with tapestries [v]\n",
  "TAPETI": "(Tupi) a small South American hare [n -S]\n",
  "TAPETING": "TAPET, (Spenser) to decorate with tapestries [v]\n",
  "TAPETIS": "TAPETI, (Tupi) a small South American hare [n]\n",
  "TAPETS": "TAPET, (Spenser) to decorate with tapestries [v]\n",
  "TAPETUM": "(Latin) a reflective layer of the choroid in the eyes of many animals, causing them to shine in the dark [n TAPETA or TAPETUMS]\n",
  "TAPETUMS": "TAPETUM, (Latin) a reflective layer of the choroid in the eyes of many animals, causing them to shine in the dark [n]\n",
  "TAPEWORM": "a parasitic worm [n -S]\n",
  "TAPEWORMS": "TAPEWORM, a parasitic worm [n]\n",
  "TAPHEPHOBIA": "the morbid fear of being buried alive, also TAPHOPHOBIA [n -S]\n",
  "TAPHEPHOBIAS": "TAPHEPHOBIA, the morbid fear of being buried alive, also TAPHOPHOBIA [n]\n",
  "TAPHEPHOBIC": "suffering from taphephobia, the morbid fear of being buried alive [adj]\n",
  "TAPHOLE": "a hole in a blast furnace [n -S]\n",
  "TAPHOLES": "TAPHOLE, a hole in a blast furnace [n]\n",
  "TAPHONOMIC": "relating to taphonomy, also TAPHONOMICAL [adj]\n",
  "TAPHONOMICAL": "relating to taphonomy, also TAPHONOMIC [adj]\n",
  "TAPHONOMIES": "TAPHONOMY, the study or science of how plants and animals die, decay and become buried and fossilized [n]\n",
  "TAPHONOMIST": "an expert or specialist in taphonomy [n -S]\n",
  "TAPHONOMISTS": "TAPHONOMIST, an expert or specialist in taphonomy [n]\n",
  "TAPHONOMY": "the study or science of how plants and animals die, decay and become buried and fossilized [n TAPHONOMIES]\n",
  "TAPHOPHOBIA": "the morbid fear of being buried alive, also TAPHEPHOBIA [n -S]\n",
  "TAPHOPHOBIAS": "TAPHOPHOBIA, the morbid fear of being buried alive, also TAPHEPHOBIA [n]\n",
  "TAPHOUSE": "a tavern [n -S]\n",
  "TAPHOUSES": "TAPHOUSE, a tavern [n]\n",
  "TAPHROGENESES": "TAPHROGENESIS, vertical movement of the earth's crust [n]\n",
  "TAPHROGENESIS": "vertical movement of the earth's crust [n TAPHROGENESES]\n",
  "TAPING": "the act of recording something to magnetic tape [n -S]\n",
  "TAPINGS": "TAPING, the act of recording something to magnetic tape [n]\n",
  "TAPIOCA": "(Tupi) a starchy food made by heating cassava [n -S]\n",
  "TAPIOCAS": "TAPIOCA, (Tupi) a starchy food made by heating cassava [n]\n",
  "TAPIR": "(Tupi) a large odd-toed hoofed mammal with a short flexible proboscis [n -S]\n",
  "TAPIROID": "any member of the tapir family [n -S]\n",
  "TAPIROIDS": "TAPIROID, any member of the tapir family [n]\n",
  "TAPIRS": "TAPIR, (Tupi) a large odd-toed hoofed mammal with a short flexible proboscis [n]\n",
  "TAPIS": "(French) a tapestry; formerly, the cover of a council table [n -ES]\n",
  "TAPISES": "TAPIS, (French) a tapestry; formerly, the cover of a council table [n]\n",
  "TAPIST": "one who revels in the use of red tape [n -S]\n",
  "TAPISTS": "TAPIST, one who revels in the use of red tape [n]\n",
  "TAPLASH": "bad small beer; also, the refuse or dregs of liquor [n -ES]\n",
  "TAPLASHES": "TAPLASH, bad small beer; also, the refuse or dregs of liquor [n]\n",
  "TAPLESS": "lacking a tap [adj]\n",
  "TAPOTEMENT": "(French) the use of light taps in massage [n -S]\n",
  "TAPOTEMENTS": "TAPOTEMENT, (French) the use of light taps in massage [n]\n",
  "TAPPA": "(Polynesian) a kind of cloth prepared by Polynesians from the inner bark of the paper mulberry, also TAPA [n -S]\n",
  "TAPPABLE": "able to be tapped [adj]\n",
  "TAPPAS": "TAPPA, (Polynesian) a kind of cloth prepared by Polynesians from the inner bark of the paper mulberry, also TAPA [n]\n",
  "TAPPED": "TAP, to strike gently [v]\n",
  "TAPPER": "a person who taps; a person who attaches soles and heels to shoes [n -S]\n",
  "TAPPERS": "TAPPER, a person who taps; a person who attaches soles and heels to shoes [n]\n",
  "TAPPET": "a projection that transmits motion [n -S]\n",
  "TAPPETS": "TAPPET, a projection that transmits motion [n]\n",
  "TAPPICE": "to lie low [v TAPPICED, TAPPICING, TAPPICES]\n",
  "TAPPICED": "TAPPICE, to lie low [v]\n",
  "TAPPICES": "TAPPICE, to lie low [v]\n",
  "TAPPICING": "TAPPICE, to lie low [v]\n",
  "TAPPING": "the act of tapping [n -S]\n",
  "TAPPINGS": "TAPPING, the act of tapping [n]\n",
  "TAPPIT": "(Scots) crested [adj]\n",
  "TAPROOM": "a room where liquors are kept on tap; a barroom [n -S]\n",
  "TAPROOMS": "TAPROOM, a room where liquors are kept on tap; a barroom [n]\n",
  "TAPROOT": "the main root of a plant [n -S]\n",
  "TAPROOTED": "having a taproot [adj]\n",
  "TAPROOTS": "TAPROOT, the main root of a plant [n]\n",
  "TAPS": "TAP, to strike gently [v]\n",
  "TAPSALTEERIE": "(Scots) confusion, also TAPSIETEERIE [n -S]\n",
  "TAPSALTEERIES": "TAPSALTEERIE, (Scots) confusion, also TAPSIETEERIE [n]\n",
  "TAPSIETEERIE": "(Scots) confusion, also TAPSALTEERIE [n -S]\n",
  "TAPSIETEERIES": "TAPSIETEERIE, (Scots) confusion, also TAPSALTEERIE [n]\n",
  "TAPSMAN": "a chief servant [n TAPSMEN]\n",
  "TAPSMEN": "TAPSMAN, a chief servant [n]\n",
  "TAPSTER": "a person who draws and serves ale or other alcoholic drinks at an inn, bar, etc [n -S]\n",
  "TAPSTERS": "TAPSTER, a person who draws and serves ale or other alcoholic drinks at an inn, bar, etc [n]\n",
  "TAPSTRESS": "a female tapster [n -ES]\n",
  "TAPSTRESSES": "TAPSTRESS, a female tapster [n]\n",
  "TAPSTRIES": "TAPSTRY, a taproom in a public house [n]\n",
  "TAPSTRY": "a taproom in a public house [n TAPSTRIES]\n",
  "TAPU": "(Tongan) to forbid the use of, also TABOO, TABU [v -ED, -ING, -S]\n",
  "TAPUED": "TAPU, (Tongan) to forbid the use of, also TABOO, TABU [v]\n",
  "TAPUING": "TAPU, (Tongan) to forbid the use of, also TABOO, TABU [v]\n",
  "TAPUS": "TAPU, (Tongan) to forbid the use of, also TABOO, TABU [v]\n",
  "TAQUERIA": "(Spanish) a Mexican restaurant serving mainly tacos [n -S]\n",
  "TAQUERIAS": "TAQUERIA, (Spanish) a Mexican restaurant serving mainly tacos [n]\n",
  "TAR": "to cover with a viscous black liquid [v TARRED, TARRING, TARS]\n",
  "TARA": "(Maori) a variety of bracken found in New Zealand and Tasmania [n -S]\n",
  "TARABISH": "a trick-taking card game popular in Nova Scotia [n -ES]\n",
  "TARABISHES": "TARABISH, a trick-taking card game popular in Nova Scotia [n]\n",
  "TARADIDDLE": "a fib; a piece of pretentious nonsense, also TARRADIDDLE [n -S]\n",
  "TARADIDDLES": "TARADIDDLE, a fib; a piece of pretentious nonsense, also TARRADIDDLE [n]\n",
  "TARAIRE": "(Maori) a type of New Zealand tree with broad green leaves and purple fruit [n -S]\n",
  "TARAIRES": "TARAIRE, (Maori) a type of New Zealand tree with broad green leaves and purple fruit [n]\n",
  "TARAKIHI": "(Maori) an Australasian food fish, also TERAKIHI [n -S]\n",
  "TARAKIHIS": "TARAKIHI, (Maori) an Australasian food fish, also TERAKIHI [n]\n",
  "TARAMA": "(Turkish) a Greek paste of fish roe, garlic and lemon juice [n -S]\n",
  "TARAMAS": "TARAMA, (Turkish) a Greek paste of fish roe, garlic and lemon juice [n]\n",
  "TARAMASALATA": "(Modern Greek) a fish paste made from the roe of the grey mullet or from smoked cod's roe, mixed with garlic, lemon juice, olive oil, etc. [n -S]\n",
  "TARAMASALATAS": "TARAMASALATA, (Modern Greek) a fish paste made from the roe of the grey mullet or from smoked cod's roe, mixed with garlic, lemon juice, olive oil, etc. [n]\n",
  "TARAMEA": "(Maori) a variety of New Zealand spear-grass [n -S]\n",
  "TARAMEAS": "TARAMEA, (Maori) a variety of New Zealand spear-grass [n]\n",
  "TARAND": "(Greek) a mythical creature said to have the power of changing colour to match its surroundings [n -S]\n",
  "TARANDS": "TARAND, (Greek) a mythical creature said to have the power of changing colour to match its surroundings [n]\n",
  "TARANTARA": "to make the sound of a trumpet or horn [v -ED, -ING, -S]\n",
  "TARANTARAED": "TARANTARA, to make the sound of a trumpet or horn [v]\n",
  "TARANTARAING": "TARANTARA, to make the sound of a trumpet or horn [v]\n",
  "TARANTARAS": "TARANTARA, to make the sound of a trumpet or horn [v]\n",
  "TARANTAS": "(Russian) a low four-wheeled carriage used in Russia, also TARANTASS [n -ES]\n",
  "TARANTASES": "TARANTAS, (Russian) a low four-wheeled carriage used in Russia, also TARANTASS [n]\n",
  "TARANTASS": "(Russian) a low four-wheeled carriage used in Russia, also TARANTAS [n -ES]\n",
  "TARANTASSES": "TARANTASS, (Russian) a low four-wheeled carriage used in Russia, also TARANTAS [n]\n",
  "TARANTELLA": "(Italian) a lively, whirling South Italian dance once thought to be caused by tarantism [n -S]\n",
  "TARANTELLAS": "TARANTELLA, (Italian) a lively, whirling South Italian dance once thought to be caused by tarantism [n]\n",
  "TARANTISM": "a dancing mania or malady of late medieval Europe, attributed popularly to the bite of a tarantula [n -S]\n",
  "TARANTISMS": "TARANTISM, a dancing mania or malady of late medieval Europe, attributed popularly to the bite of a tarantula [n]\n",
  "TARANTIST": "one suffering from tarantism [n -S]\n",
  "TARANTISTS": "TARANTIST, one suffering from tarantism [n]\n",
  "TARANTULA": "any one of several species of large spiders, popularly supposed to be very venomous [n TARANTULAE or TARANTULAS]\n",
  "TARANTULAE": "TARANTULA, any one of several species of large spiders, popularly supposed to be very venomous [n]\n",
  "TARANTULAS": "TARANTULA, any one of several species of large spiders, popularly supposed to be very venomous [n]\n",
  "TARAS": "TARA, (Maori) a variety of bracken found in New Zealand and Tasmania [n]\n",
  "TARATANTARA": "to make the sound of a trumpet [v -ED, -ING, -S]\n",
  "TARATANTARAED": "TARATANTARA, to make the sound of a trumpet [v]\n",
  "TARATANTARAING": "TARATANTARA, to make the sound of a trumpet [v]\n",
  "TARATANTARAS": "TARATANTARA, to make the sound of a trumpet [v]\n",
  "TARAXACUM": "a plant of the dandelion genus [n -S]\n",
  "TARAXACUMS": "TARAXACUM, a plant of the dandelion genus [n]\n",
  "TARBOGGIN": "a kind of sledge [n -S] / to sledge on a tarboggin, also TABOGGAN, TOBOGGAN, TOBOGGIN [v -ED, -ING, -S]\n",
  "TARBOGGINED": "TARBOGGIN, to sledge on a tarboggin, also TABOGGAN, TOBOGGAN, TOBOGGIN [v]\n",
  "TARBOGGINING": "TARBOGGIN, to sledge on a tarboggin, also TABOGGAN, TOBOGGAN, TOBOGGIN [v]\n",
  "TARBOGGINS": "TARBOGGIN, to sledge on a tarboggin, also TABOGGAN, TOBOGGAN, TOBOGGIN [v]\n",
  "TARBOOSH": "(Arabic) a fez, a hat worn by Muslim men, also TARBOUCHE, TARBOUSH, TARBUSH [n -ES]\n",
  "TARBOOSHES": "TARBOOSH, (Arabic) a fez, a hat worn by Muslim men, also TARBOUCHE, TARBOUSH, TARBUSH [n]\n",
  "TARBOUCHE": "(Arabic) a fez, a hat worn by Muslim men, also TARBOOSH, TARBOUSH, TARBUSH [n -S]\n",
  "TARBOUCHES": "TARBOUCHE, (Arabic) a fez, a hat worn by Muslim men, also TARBOOSH, TARBOUSH, TARBUSH [n]\n",
  "TARBOUSH": "(Arabic) a fez, a hat worn by Muslim men, also TARBOOSH, TARBOUCHE, TARBUSH [n -ES]\n",
  "TARBOUSHES": "TARBOUSH, (Arabic) a fez, a hat worn by Muslim men, also TARBOOSH, TARBOUCHE, TARBUSH [n]\n",
  "TARBOY": "(Australian) a boy who applies tar to the skin of sheep cut during shearing [n -S]\n",
  "TARBOYS": "TARBOY, (Australian) a boy who applies tar to the skin of sheep cut during shearing [n]\n",
  "TARBUSH": "(Arabic) a fez, a hat worn by Muslim men, also TARBOOSH, TARBOUCHE, TARBOUSH [n -ES]\n",
  "TARBUSHES": "TARBUSH, (Arabic) a fez, a hat worn by Muslim men, also TARBOOSH, TARBOUCHE, TARBOUSH [n]\n",
  "TARCEL": "a male hawk, also TARSAL, TARSEL, TASSELL, TERCEL, TIERCEL [n -S]\n",
  "TARCELS": "TARCEL, a male hawk, also TARSAL, TARSEL, TASSELL, TERCEL, TIERCEL [n]\n",
  "TARDIED": "TARDY, (Shakespeare) to retard [v]\n",
  "TARDIER": "TARDY, late [adj]\n",
  "TARDIES": "TARDY, (Shakespeare) to retard [v]\n",
  "TARDIEST": "TARDY, late [adj]\n",
  "TARDIGRADE": "an arthropod with eight legs living in water or damp moss [n -S]\n",
  "TARDIGRADES": "TARDIGRADE, an arthropod with eight legs living in water or damp moss [n]\n",
  "TARDILY": "TARDY, late [adv]\n",
  "TARDINESS": "the state of being tardy [n -ES]\n",
  "TARDINESSES": "TARDINESS, the state of being tardy [n]\n",
  "TARDIVE": "late in development [adj]\n",
  "TARDO": "(Italian) a direction to perform a passage slowly [adv]\n",
  "TARDY": "late [adj TARDIER, TARDIEST, TARDILY] / (Shakespeare) to retard [v TARDIED, TARDYING, TARDIES]\n",
  "TARDYING": "TARDY, (Shakespeare) to retard [v]\n",
  "TARDYON": "a subatomic particle that travels slower than the speed of light [n -S]\n",
  "TARDYONS": "TARDYON, a subatomic particle that travels slower than the speed of light [n]\n",
  "TARE": "to assess the weight of a goods container [v TARED, TARING, TARES]\n",
  "TARED": "TAR, to cover with a viscous black liquid [v]\n",
  "TARES": "TARE, to assess the weight of a goods container [v]\n",
  "TARGA": "(tradename) a car with a removable hard roof, which fits into the boot when not in use [n -S]\n",
  "TARGAS": "TARGA, (tradename) a car with a removable hard roof, which fits into the boot when not in use [n]\n",
  "TARGE": "(Scots) to cross-examine, reprimand [v TARGED, TARGING, TARGES]\n",
  "TARGED": "TARGE, (Scots) to cross-examine, reprimand [v]\n",
  "TARGES": "TARGE, (Scots) to cross-examine, reprimand [v]\n",
  "TARGET": "to make a goal of [v -ED, -ING, -S]\n",
  "TARGETABLE": "that can be targeted [adj]\n",
  "TARGETED": "TARGET, to make a goal of [v]\n",
  "TARGETEER": "(historical) one who is armed with a target or shield [n -S]\n",
  "TARGETEERS": "TARGETEER, (historical) one who is armed with a target or shield [n]\n",
  "TARGETING": "making a goal of [n -S]\n",
  "TARGETINGS": "TARGETING, making a goal of [n]\n",
  "TARGETITIS": "an obsession with achieving targets [n -ES]\n",
  "TARGETITISES": "TARGETITIS, an obsession with achieving targets [n]\n",
  "TARGETLESS": "without a target [adj]\n",
  "TARGETS": "TARGET, to make a goal of [v]\n",
  "TARGING": "TARGE, (Scots) to cross-examine, reprimand [v]\n",
  "TARIFF": "to tax imported or exported goods [v -ED, -ING, -S]\n",
  "TARIFFED": "TARIFF, to tax imported or exported goods [v]\n",
  "TARIFFICATION": "the fixing of a tariff; conversion (e.g. of import restrictions) into a tariff [n -S]\n",
  "TARIFFICATIONS": "TARIFFICATION, the fixing of a tariff; conversion (e.g. of import restrictions) into a tariff [n]\n",
  "TARIFFING": "TARIFF, to tax imported or exported goods [v]\n",
  "TARIFFLESS": "without a tariff [adj]\n",
  "TARIFFS": "TARIFF, to tax imported or exported goods [v]\n",
  "TARING": "the calculating of a tare [n -S]\n",
  "TARINGS": "TARING, the calculating of a tare [n]\n",
  "TARLATAN": "(French) a thin, stiffly-starched, open-weave muslin, also TARLETAN [n -S]\n",
  "TARLATANS": "TARLATAN, (French) a thin, stiffly-starched, open-weave muslin, also TARLETAN [n]\n",
  "TARLETAN": "(French) a thin, stiffly-starched, open-weave muslin, also TARLATAN [n -S]\n",
  "TARLETANS": "TARLETAN, (French) a thin, stiffly-starched, open-weave muslin, also TARLATAN [n]\n",
  "TARMAC": "to surface with tarmacadam [v TARMACKED, TARMACKING, TARMACS]\n",
  "TARMACADAM": "(tradename) a paving material [n -S]\n",
  "TARMACADAMS": "TARMACADAM, (tradename) a paving material [n]\n",
  "TARMACKED": "TARMAC, to surface with tarmacadam [v]\n",
  "TARMACKING": "TARMAC, to surface with tarmacadam [v]\n",
  "TARMACS": "TARMAC, to surface with tarmacadam [v]\n",
  "TARN": "a small mountain lake [n -S]\n",
  "TARNAL": "(US slang) eternal, damned [adj TARNALLY]\n",
  "TARNALLY": "TARNAL, (US slang) eternal, damned [adv]\n",
  "TARNATION": "(US slang) damnation, also DARNATION [n -S]\n",
  "TARNATIONS": "TARNATION, (US slang) damnation, also DARNATION [n]\n",
  "TARNISH": "to dull the lustre of [v -ED, -ING, -ES]\n",
  "TARNISHABLE": "that can be tarnished [adj]\n",
  "TARNISHED": "TARNISH, to dull the lustre of [v]\n",
  "TARNISHER": "something that causes tarnishing [n -S]\n",
  "TARNISHERS": "TARNISHER, something that causes tarnishing [n]\n",
  "TARNISHES": "TARNISH, to dull the lustre of [v]\n",
  "TARNISHING": "TARNISH, to dull the lustre of [v]\n",
  "TARNS": "TARN, a small mountain lake [n]\n",
  "TARO": "a kind of yam, aka dasheen, eddo [n -S]\n",
  "TAROC": "a pack of cards used in fortune-telling, also TAROK, TAROT [n -S]\n",
  "TAROCS": "TAROC, a pack of cards used in fortune-telling, also TAROK, TAROT [n]\n",
  "TAROK": "a pack of cards used in fortune-telling, also TAROC, TAROT [n -S]\n",
  "TAROKS": "TAROK, a pack of cards used in fortune-telling, also TAROC, TAROT [n]\n",
  "TAROS": "TARO, a kind of yam, aka dasheen, eddo [n]\n",
  "TAROT": "a pack of cards used in fortune-telling, also TAROC, TAROK [n -S]\n",
  "TAROTS": "TAROT, a pack of cards used in fortune-telling, also TAROC, TAROK [n]\n",
  "TARP": "(slang) a tarpaulin, a protective canvas covering [n -S]\n",
  "TARPAN": "an Asian wild horse [n -S]\n",
  "TARPANS": "TARPAN, an Asian wild horse [n]\n",
  "TARPAPER": "a heavy paper coated with tar [n -S]\n",
  "TARPAPERS": "TARPAPER, a heavy paper coated with tar [n]\n",
  "TARPAULIN": "a strong linen or hempen cloth waterproofed with tar, also TARPAULING [n -S]\n",
  "TARPAULING": "a strong linen or hempen cloth waterproofed with tar, also TARPAULIN [n -S]\n",
  "TARPAULINGS": "TARPAULING, a strong linen or hempen cloth waterproofed with tar, also TARPAULIN [n]\n",
  "TARPAULINS": "TARPAULIN, a strong linen or hempen cloth waterproofed with tar, also TARPAULING [n]\n",
  "TARPON": "a marine game fish [n -S]\n",
  "TARPONS": "TARPON, a marine game fish [n]\n",
  "TARPS": "TARP, (slang) a tarpaulin, a protective canvas covering [n]\n",
  "TARRADIDDLE": "a fib; a piece of pretentious nonsense, also TARADIDDLE [n -S]\n",
  "TARRADIDDLES": "TARRADIDDLE, a fib; a piece of pretentious nonsense, also TARADIDDLE [n]\n",
  "TARRAGON": "(Arabic) a kind of herb, also ESTRAGON, STARAGEN [n -S]\n",
  "TARRAGONS": "TARRAGON, (Arabic) a kind of herb, also ESTRAGON, STARAGEN [n]\n",
  "TARRAS": "(Dutch) an earthy volcanic tuff used as a hydraulic cement, also TERRAS, TRASS [n -ES]\n",
  "TARRASES": "TARRAS, (Dutch) an earthy volcanic tuff used as a hydraulic cement, also TERRAS, TRASS [n]\n",
  "TARRE": "(Shakespeare) to excite, urge on [v TARRED, TARRING, TARRES]\n",
  "TARRED": "TARRE, (Shakespeare) to excite, urge on [v]\n",
  "TARRES": "TARRE, (Shakespeare) to excite, urge on [v]\n",
  "TARRIANCE": "(archaic) delay, dallying [n -S]\n",
  "TARRIANCES": "TARRIANCE, (archaic) delay, dallying [n]\n",
  "TARRIED": "TARRY, to linger [v]\n",
  "TARRIER": "one who tarries [n -S]\n",
  "TARRIERS": "TARRIER, one who tarries [n]\n",
  "TARRIES": "TARRY, to linger [v]\n",
  "TARRIEST": "TARRY, like tar [adj]\n",
  "TARRINESS": "the state of being tarry [n -ES]\n",
  "TARRINESSES": "TARRINESS, the state of being tarry [n]\n",
  "TARRING": "the act of tarring [n -S]\n",
  "TARRINGS": "TARRING, the act of tarring [n]\n",
  "TARROCK": "(dialect) the young of the kittiwake gull before the first molt [n -S]\n",
  "TARROCKS": "TARROCK, (dialect) the young of the kittiwake gull before the first molt [n]\n",
  "TARROW": "(Scots) to hesitate, be unwilling [v -ED, -ING, -S]\n",
  "TARROWED": "TARROW, (Scots) to hesitate, be unwilling [v]\n",
  "TARROWING": "TARROW, (Scots) to hesitate, be unwilling [v]\n",
  "TARROWS": "TARROW, (Scots) to hesitate, be unwilling [v]\n",
  "TARRY": "like tar [adj TARRIER, TARRIEST] / to linger [v TARRIED, TARRYING, TARRIES]\n",
  "TARRYING": "TARRY, to linger [v]\n",
  "TARS": "TAR, to cover with a viscous black liquid [v]\n",
  "TARSAL": "a male hawk, also TARCEL, TARSEL, TASSELL, TERCEL, TIERCEL [n -S]\n",
  "TARSALGIA": "pain in the instep [n -S]\n",
  "TARSALGIAS": "TARSALGIA, pain in the instep [n]\n",
  "TARSALS": "TARSAL, a male hawk, also TARCEL, TARSEL, TASSELL, TERCEL, TIERCEL [n]\n",
  "TARSEAL": "(New Zealand) the bitumen surface of a road [n -S]\n",
  "TARSEALS": "TARSEAL, (New Zealand) the bitumen surface of a road [n]\n",
  "TARSEL": "a male hawk, also TARCEL, TARSAL, TASSELL, TERCEL, TIERCEL [n -S]\n",
  "TARSELS": "TARSEL, a male hawk, also TARCEL, TARSAL, TASSELL, TERCEL, TIERCEL [n]\n",
  "TARSI": "TARSUS, (Greek) the part of the leg between the knee and the foot [n]\n",
  "TARSIA": "(Italian) a form of decorative wood inlay work, developed in Italy, also INTARSIA [n -S]\n",
  "TARSIAS": "TARSIA, (Italian) a form of decorative wood inlay work, developed in Italy, also INTARSIA [n]\n",
  "TARSIER": "(French) a kind of lemur native to Madagascar [n -S]\n",
  "TARSIERS": "TARSIER, (French) a kind of lemur native to Madagascar [n]\n",
  "TARSIOID": "a fossil of the suborder Tarsioidea [n -S]\n",
  "TARSIOIDS": "TARSIOID, a fossil of the suborder Tarsioidea [n]\n",
  "TARSIPED": "a marsupial of the genus Tarsipes [n -S]\n",
  "TARSIPEDS": "TARSIPED, a marsupial of the genus Tarsipes [n]\n",
  "TARSOMETATARSAL": "relating to the tarsometatarsus, a bird's shankbone [adj]\n",
  "TARSOMETATARSI": "TARSOMETATARSUS, a long bone in the lower leg of birds and some reptiles, formed by the fusion of tarsal and metatarsal structures [n]\n",
  "TARSOMETATARSUS": "a long bone in the lower leg of birds and some reptiles, formed by the fusion of tarsal and metatarsal structures [n TARSOMETATARSI]\n",
  "TARSUS": "(Greek) the part of the leg between the knee and the foot [n TARSI]\n",
  "TART": "sharp tasting [adj TARTER, TARTEST, TARTLY] / to smarten up [v -ED, -ING, -S]\n",
  "TARTAN": "a patterned woollen fabric [n -S]\n",
  "TARTANA": "a Mediterranean sailing vessel, also TARTANE [n -S]\n",
  "TARTANALIA": "artefacts etc. that are self-consciously Scottish [n -S]\n",
  "TARTANALIAS": "TARTANALIA, artefacts etc. that are self-consciously Scottish [n]\n",
  "TARTANAS": "TARTANA, a Mediterranean sailing vessel, also TARTANE [n]\n",
  "TARTANE": "(French) a Mediterranean sailing vessel, also TARTANA [n -S]\n",
  "TARTANED": "clad in tartan [adj]\n",
  "TARTANES": "TARTANE, (French) a Mediterranean sailing vessel, also TARTANA [n]\n",
  "TARTANRIES": "TARTANRY, Scottish cultural artefacts [n]\n",
  "TARTANRY": "Scottish cultural artefacts [n TARTANRIES]\n",
  "TARTANS": "TARTAN, a patterned woollen fabric [n]\n",
  "TARTAR": "a formidable or ferocious person, also TATAR [n -S]\n",
  "TARTARE": "(French) a mayonnaise dressing [n -S]\n",
  "TARTAREOUS": "of or pertaining to Tartarus; hellish [adj]\n",
  "TARTARES": "TARTARE, (French) a mayonnaise dressing [n]\n",
  "TARTARIC": "of or derived from tartar [adj]\n",
  "TARTARISATION": "the process of tartarising, also TARTARIZATION [n -S]\n",
  "TARTARISATIONS": "TARTARISATION, the process of tartarising, also TARTARIZATION [n]\n",
  "TARTARISE": "to treat, mix or combine with tartar [v TARTARISED, TARTARISING, TARTARISES]\n",
  "TARTARISED": "TARTARISE, to treat, mix or combine with tartar [v]\n",
  "TARTARISES": "TARTARISE, to treat, mix or combine with tartar [v]\n",
  "TARTARISING": "TARTARISE, to treat, mix or combine with tartar [v]\n",
  "TARTARIZATION": "the process of tartarizing, also TARTARISATION [n -S]\n",
  "TARTARIZATIONS": "TARTARIZATION, the process of tartarizing, also TARTARISATION [n]\n",
  "TARTARIZE": "to treat, mix or combine with tartar, also TARTARISE [v TARTARIZED, TARTARIZING, TARTARIZES]\n",
  "TARTARIZED": "TARTARIZE, to treat, mix or combine with tartar, also TARTARISE [v]\n",
  "TARTARIZES": "TARTARIZE, to treat, mix or combine with tartar, also TARTARISE [v]\n",
  "TARTARIZING": "TARTARIZE, to treat, mix or combine with tartar, also TARTARISE [v]\n",
  "TARTARLY": "ferocious [adj]\n",
  "TARTAROUS": "consisting of, containing or resembling tartar [adj]\n",
  "TARTARS": "TARTAR, a formidable or ferocious person, also TATAR [n]\n",
  "TARTED": "TART, to smarten up [v]\n",
  "TARTER": "TART, sharp tasting [adj]\n",
  "TARTEST": "TART, sharp tasting [adj]\n",
  "TARTIER": "TARTY, like a prostitute [adj]\n",
  "TARTIEST": "TARTY, like a prostitute [adj]\n",
  "TARTILY": "TARTY, like a prostitute [adv]\n",
  "TARTINE": "(French) a slice of bread and butter with jam [n -S]\n",
  "TARTINES": "TARTINE, (French) a slice of bread and butter with jam [n]\n",
  "TARTINESS": "the state of being tarty [n -ES]\n",
  "TARTINESSES": "TARTINESS, the state of being tarty [n]\n",
  "TARTING": "TART, to smarten up [v]\n",
  "TARTISH": "somewhat tart [adj TARTISHLY]\n",
  "TARTISHLY": "TARTISH, somewhat tart [adv]\n",
  "TARTLET": "a small pie [n -S]\n",
  "TARTLETS": "TARTLET, a small pie [n]\n",
  "TARTLY": "TART, sharp tasting [adv]\n",
  "TARTNESS": "the state of being tart [n -ES]\n",
  "TARTNESSES": "TARTNESS, the state of being tart [n]\n",
  "TARTRATE": "a salt of tartaric acid [n -S]\n",
  "TARTRATED": "being in the form of a tartrate, a salt of tartaric acid [adj]\n",
  "TARTRATES": "TARTRATE, a salt of tartaric acid [n]\n",
  "TARTRAZINE": "a yellow dye used in textiles, food and drugs [n -S]\n",
  "TARTRAZINES": "TARTRAZINE, a yellow dye used in textiles, food and drugs [n]\n",
  "TARTS": "TART, to smarten up [v]\n",
  "TARTUFE": "(French) a hypocrite, esp. one who affects religious piety, also TARTUFFE [n -S]\n",
  "TARTUFES": "TARTUFE, (French) a hypocrite, esp. one who affects religious piety, also TARTUFFE [n]\n",
  "TARTUFFE": "(French) a hypocrite, esp. one who affects religious piety, also TARTUFE [n -S]\n",
  "TARTUFFES": "TARTUFFE, (French) a hypocrite, esp. one who affects religious piety, also TARTUFE [n]\n",
  "TARTUFI": "TARTUFO, (Italian) a dessert of light mousse-like chocolate [n]\n",
  "TARTUFO": "(Italian) a dessert of light mousse-like chocolate [n TARTUFI or TARTUFOS]\n",
  "TARTUFOS": "TARTUFO, (Italian) a dessert of light mousse-like chocolate [n]\n",
  "TARTY": "like a prostitute [adj TARTIER, TARTIEST, TARTILY]\n",
  "TARWEED": "a flowering plant [n -S]\n",
  "TARWEEDS": "TARWEED, a flowering plant [n]\n",
  "TARWHINE": "(Native Australian) an Australian sea-bream [n -S]\n",
  "TARWHINES": "TARWHINE, (Native Australian) an Australian sea-bream [n]\n",
  "TARZAN": "a person of superior strength and agility [n -S]\n",
  "TARZANS": "TARZAN, a person of superior strength and agility [n]\n",
  "TAS": "TA, an expression meaning thank you [n]\n",
  "TASAR": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSORE, TUSSUR [n -S]\n",
  "TASARS": "TASAR, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSORE, TUSSUR [n]\n",
  "TASBIH": "(Arabic) a form of Islamic prayer that involves the repetitive utterances of short sentences glorifying God, aka sabha [n -S]\n",
  "TASBIHS": "TASBIH, (Arabic) a form of Islamic prayer that involves the repetitive utterances of short sentences glorifying God, aka sabha [n]\n",
  "TASE": "to stun with a gun that fires electrified darts [v TASED, TASING, TASES]\n",
  "TASED": "TASE, to stun with a gun that fires electrified darts [v]\n",
  "TASEOMETER": "an instrument for measuring stress in a structure [n -S]\n",
  "TASEOMETERS": "TASEOMETER, an instrument for measuring stress in a structure [n]\n",
  "TASER": "(tradename) a gun-like device which fires electrified darts [n -S] / to immobilize with a taser [v -ED, -ING, -S]\n",
  "TASERED": "TASER, to immobilize with a taser [v]\n",
  "TASERING": "TASER, to immobilize with a taser [v]\n",
  "TASERS": "TASER, to immobilize with a taser [v]\n",
  "TASES": "TASE, to stun with a gun that fires electrified darts [v]\n",
  "TASH": "(Scots) to soil, blemish [v -ED, -ING, -ES]\n",
  "TASHED": "TASH, (Scots) to soil, blemish [v]\n",
  "TASHES": "TASH, (Scots) to soil, blemish [v]\n",
  "TASHING": "TASH, (Scots) to soil, blemish [v]\n",
  "TASIMETER": "an instrument for measuring small changes in temperature [n -S]\n",
  "TASIMETERS": "TASIMETER, an instrument for measuring small changes in temperature [n]\n",
  "TASIMETRIC": "relating to a tasimeter, an instrument for measuring changes in pressure [adj]\n",
  "TASIMETRIES": "TASIMETRY, measurement by use of a tasimeter, an instrument for measuring small changes in temperature [n]\n",
  "TASIMETRY": "measurement by use of a tasimeter, an instrument for measuring small changes in temperature [n TASIMETRIES]\n",
  "TASING": "TASE, to stun with a gun that fires electrified darts [v]\n",
  "TASK": "to assign a mission to [v -ED, -ING, -S]\n",
  "TASKBAR": "a row of graphical controls on a computer screen [n -S]\n",
  "TASKBARS": "TASKBAR, a row of graphical controls on a computer screen [n]\n",
  "TASKED": "TASK, to assign a mission to [v]\n",
  "TASKER": "one who performs a task [n -S]\n",
  "TASKERS": "TASKER, one who performs a task [n]\n",
  "TASKING": "the act of assigning a task [n -S]\n",
  "TASKINGS": "TASKING, the act of assigning a task [n]\n",
  "TASKLESS": "without a task [adj]\n",
  "TASKMASTER": "one who imposes a task, an overseer [n -S]\n",
  "TASKMASTERS": "TASKMASTER, one who imposes a task, an overseer [n]\n",
  "TASKMISTRESS": "a woman who is a taskmaster [n -ES]\n",
  "TASKMISTRESSES": "TASKMISTRESS, a woman who is a taskmaster [n]\n",
  "TASKS": "TASK, to assign a mission to [v]\n",
  "TASKWORK": "hard work [n -S]\n",
  "TASKWORKS": "TASKWORK, hard work [n]\n",
  "TASLET": "in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TACE, TASSE, TASSET [n -S]\n",
  "TASLETS": "TASLET, in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TACE, TASSE, TASSET [n]\n",
  "TASS": "(dialect) a mow, a heap [n -ES]\n",
  "TASSA": "(Hindi) a large Indian kettledrum, worn hanging round the neck [n -S]\n",
  "TASSAS": "TASSA, (Hindi) a large Indian kettledrum, worn hanging round the neck [n]\n",
  "TASSE": "in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TACE, TASLET, TASSET [n -S]\n",
  "TASSEL": "to adorn with dangling ornaments [v TASSELED or TASSELLED, TASSELING or TASSELLING, TASSELS]\n",
  "TASSELED": "TASSEL, to adorn with dangling ornaments [v]\n",
  "TASSELIER": "TASSELY, decorated with tassels [adj]\n",
  "TASSELIEST": "TASSELY, decorated with tassels [adj]\n",
  "TASSELING": "TASSEL, to adorn with dangling ornaments [v]\n",
  "TASSELL": "a male hawk, also TARCEL, TARSAL, TARSEL, TERCEL, TIERCEL [n -S]\n",
  "TASSELLED": "TASSEL, to adorn with dangling ornaments [v]\n",
  "TASSELLIER": "TASSELLY, decorated with tassels [adj]\n",
  "TASSELLIEST": "TASSELLY, decorated with tassels [adj]\n",
  "TASSELLING": "adornment with tassels [n -S]\n",
  "TASSELLINGS": "TASSELLING, adornment with tassels [n]\n",
  "TASSELLS": "TASSELL, a male hawk, also TARCEL, TARSAL, TARSEL, TERCEL, TIERCEL [n]\n",
  "TASSELLY": "decorated with tassels [adj TASSELLIER, TASSELLIEST]\n",
  "TASSELS": "TASSEL, to adorn with dangling ornaments [v]\n",
  "TASSELY": "decorated with tassels [adj TASSELIER, TASSELIEST]\n",
  "TASSES": "TASSE, in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TACE, TASLET, TASSET [n]\n",
  "TASSET": "in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TACE, TASLET, TASSE [n -S]\n",
  "TASSETS": "TASSET, in plate armour, one of a series of overlapping pieces forming a kind of skirt, also TACE, TASLET, TASSE [n]\n",
  "TASSIE": "(Scots) a small cup [n -S]\n",
  "TASSIES": "TASSIE, (Scots) a small cup [n]\n",
  "TASSO": "spicy cured pork [n TASSOS]\n",
  "TASSOS": "TASSO, spicy cured pork [n]\n",
  "TASSWAGE": "(obsolete) to assuage [v]\n",
  "TASTABLE": "that can be tasted, also TASTEABLE [adj]\n",
  "TASTE": "to savour with the tongue [v TASTED, TASTING, TASTES]\n",
  "TASTEABLE": "that can be tasted, also TASTABLE [adj]\n",
  "TASTED": "TASTE, to savour with the tongue [v]\n",
  "TASTEFUL": "full of taste [adj TASTEFULLY]\n",
  "TASTEFULLY": "TASTEFUL, full of taste [adv]\n",
  "TASTEFULNESS": "the state of being tasteful [n -ES]\n",
  "TASTEFULNESSES": "TASTEFULNESS, the state of being tasteful [n]\n",
  "TASTELESS": "without taste [adj TASTELESSLY]\n",
  "TASTELESSLY": "TASTELESS, without taste [adv]\n",
  "TASTELESSNESS": "the state of being tasteless [n -ES]\n",
  "TASTELESSNESSES": "TASTELESSNESS, the state of being tasteless [n]\n",
  "TASTEMAKER": "one who sets aesthetic standards [n -S]\n",
  "TASTEMAKERS": "TASTEMAKER, one who sets aesthetic standards [n]\n",
  "TASTER": "one who tastes [n -S]\n",
  "TASTERS": "TASTER, one who tastes [n]\n",
  "TASTES": "TASTE, to savour with the tongue [v]\n",
  "TASTEVIN": "(French) a small shallow cup used for tasting wine [n -S]\n",
  "TASTEVINS": "TASTEVIN, (French) a small shallow cup used for tasting wine [n]\n",
  "TASTIER": "TASTY, pleasant to the taste [adj]\n",
  "TASTIEST": "TASTY, pleasant to the taste [adj]\n",
  "TASTILY": "TASTY, pleasant to the taste [adv]\n",
  "TASTINESS": "the state of being tasty [n -ES]\n",
  "TASTINESSES": "TASTINESS, the state of being tasty [n]\n",
  "TASTING": "the act of tasting [n -S]\n",
  "TASTINGS": "TASTING, the act of tasting [n]\n",
  "TASTY": "pleasant to the taste [adj TASTIER, TASTIEST, TASTILY]\n",
  "TAT": "to make lace, also TATT [v TATTED, TATTING, TATS]\n",
  "TATAHASH": "(dialect) a stew containing potatoes and cheap cuts of meat [n -ES]\n",
  "TATAHASHES": "TATAHASH, (dialect) a stew containing potatoes and cheap cuts of meat [n]\n",
  "TATAMI": "(Japanese) straw matting used as a floor covering [n -S]\n",
  "TATAMIS": "TATAMI, (Japanese) straw matting used as a floor covering [n]\n",
  "TATAR": "a ferocious person, also TARTAR [n -S]\n",
  "TATARS": "TATAR, a ferocious person, also TARTAR [n]\n",
  "TATE": "(Scots) a small portion, a pinch, also TAIT [n -S]\n",
  "TATER": "(colloquial) a potato, also TATIE, TATTIE [n -S]\n",
  "TATERS": "TATER, (colloquial) a potato, also TATIE, TATTIE [n]\n",
  "TATES": "TATE, (Scots) a small portion, a pinch, also TAIT [n]\n",
  "TATH": "to manure [v -ED, -ING, -S]\n",
  "TATHATA": "(Sanskrit) the ultimate nature of things in Buddhism [n -S]\n",
  "TATHATAS": "TATHATA, (Sanskrit) the ultimate nature of things in Buddhism [n]\n",
  "TATHED": "TATH, to manure [v]\n",
  "TATHING": "TATH, to manure [v]\n",
  "TATHS": "TATH, to manure [v]\n",
  "TATIE": "(colloquial) a potato, also TATER, TATTIE [n -S]\n",
  "TATIES": "TATIE, (colloquial) a potato, also TATER, TATTIE [n]\n",
  "TATLER": "an indiscreet talker, a gossip, also TATTLER [n -S]\n",
  "TATLERS": "TATLER, an indiscreet talker, a gossip, also TATTLER [n]\n",
  "TATOU": "(French) an armadillo, esp. the giant armadillo [n -S]\n",
  "TATOUAY": "a South American armadillo [n -S]\n",
  "TATOUAYS": "TATOUAY, a South American armadillo [n]\n",
  "TATOUS": "TATOU, (French) an armadillo, esp. the giant armadillo [n]\n",
  "TATPURUSHA": "(Sanskrit) a class of compound words in which the first element modifies the second by standing to it in various types of relation e.g. goatskin, fieldmouse [n -S]\n",
  "TATPURUSHAS": "TATPURUSHA, (Sanskrit) a class of compound words in which the first element modifies the second by standing to it in various types of relation e.g. goatskin, fieldmouse [n]\n",
  "TATS": "TAT, to make lace, also TATT [v]\n",
  "TATSOI": "(Chinese) a variety of Chinese cabbage [n -S]\n",
  "TATSOIS": "TATSOI, (Chinese) a variety of Chinese cabbage [n]\n",
  "TATT": "to make lace, also TAT [v -ED, -ING, -S]\n",
  "TATTED": "TATT, to make lace, also TAT [v]\n",
  "TATTER": "to become torn and worn [v -ED, -ING, -S]\n",
  "TATTERDEMALION": "ragged, tattered [adj] / a person in ragged clothes, also TATTERDEMALLION [n -S]\n",
  "TATTERDEMALIONS": "TATTERDEMALION, a person in ragged clothes, also TATTERDEMALLION [n]\n",
  "TATTERDEMALLION": "ragged, tattered [adj] / a person in ragged clothes, also TATTERDEMALION [n]\n",
  "TATTERED": "TATTER, to become torn and worn [v]\n",
  "TATTERIER": "TATTERY, ragged [adj]\n",
  "TATTERIEST": "TATTERY, ragged [adj]\n",
  "TATTERING": "TATTER, to become torn and worn [v]\n",
  "TATTERS": "TATTER, to become torn and worn [v]\n",
  "TATTERSALL": "a pattern of squares formed by dark lines on a light background; a cloth with this pattern [n -S]\n",
  "TATTERSALLS": "TATTERSALL, a pattern of squares formed by dark lines on a light background; a cloth with this pattern [n]\n",
  "TATTERY": "ragged [adj TATTERIER, TATTERIEST]\n",
  "TATTIE": "(colloquial) a potato, also TATER, TATIE [n -S]\n",
  "TATTIER": "TATTY, shabby, frayed [adj]\n",
  "TATTIES": "TATTIE, (colloquial) a potato, also TATER, TATIE [n]\n",
  "TATTIEST": "TATTY, shabby, frayed [adj]\n",
  "TATTILY": "TATTY, shabby, frayed [adv]\n",
  "TATTINESS": "the state of being tatty [n -ES]\n",
  "TATTINESSES": "TATTINESS, the state of being tatty [n]\n",
  "TATTING": "delicate handmade lace [n -S]\n",
  "TATTINGS": "TATTING, delicate handmade lace [n]\n",
  "TATTLE": "to tell tales [v TATTLED, TATTLING, TATTLES]\n",
  "TATTLED": "TATTLE, to tell tales [v]\n",
  "TATTLER": "an indiscreet person, a gossip, also TATLER [n -S]\n",
  "TATTLERS": "TATTLER, an indiscreet person, a gossip, also TATLER [n]\n",
  "TATTLES": "TATTLE, to tell tales [v]\n",
  "TATTLETALE": "to tell tales [v TATTLETALED, TATTLETALING, TATTLETALES]\n",
  "TATTLETALED": "TATTLETALE, to tell tales [v]\n",
  "TATTLETALES": "TATTLETALE, to tell tales [v]\n",
  "TATTLETALING": "TATTLETALE, to tell tales [v]\n",
  "TATTLING": "taletelling [adj TATTLINGLY] / the act of tattling [n -S]\n",
  "TATTLINGLY": "TATTLING, taletelling [adv]\n",
  "TATTLINGS": "TATTLING, the act of tattling [n]\n",
  "TATTOO": "to mark the skin with indelible pigments, also TATTOW, TATU [v -ED, -ING, -S]\n",
  "TATTOOED": "TATTOO, to mark the skin with indelible pigments, also TATTOW, TATU [v]\n",
  "TATTOOER": "one who tattoos, also TATTOOIST [n -S]\n",
  "TATTOOERS": "TATTOOER, one who tattoos, also TATTOOIST [n]\n",
  "TATTOOING": "TATTOO, to mark the skin with indelible pigments, also TATTOW, TATU [v]\n",
  "TATTOOIST": "one who tattoos, also TATTOOER [n -S]\n",
  "TATTOOISTS": "TATTOOIST, one who tattoos, also TATTOOER [n]\n",
  "TATTOOS": "TATTOO, to mark the skin with indelible pigments, also TATTOW, TATU [v]\n",
  "TATTOW": "to mark the skin by pricking in indelible dyes, also TATTOO, TATU [v -ED, -ING, -S]\n",
  "TATTOWED": "TATTOW, to mark the skin by pricking in indelible dyes, also TATTOO, TATU [v]\n",
  "TATTOWING": "TATTOW, to mark the skin by pricking in indelible dyes, also TATTOO, TATU [v]\n",
  "TATTOWS": "TATTOW, to mark the skin by pricking in indelible dyes, also TATTOO, TATU [v]\n",
  "TATTS": "TATT, to make lace, also TAT [v]\n",
  "TATTY": "shabby, frayed [adj TATTIER, TATTIEST, TATTILY]\n",
  "TATU": "a design marked on the skin by pricking in indelible dyes [n -S] / to mark the skin in this way, also TATTOO, TATTOW [v -ED, -ING, -S]\n",
  "TATUED": "TATU, to mark the skin in this way, also TATTOO, TATTOW [v]\n",
  "TATUING": "TATU, to mark the skin in this way, also TATTOO, TATTOW [v]\n",
  "TATUS": "TATU, to mark the skin in this way, also TATTOO, TATTOW [v]\n",
  "TAU": "a Greek letter [n -S]\n",
  "TAUBE": "(German) a German monoplane with recurved wings [n -S]\n",
  "TAUBES": "TAUBE, (German) a German monoplane with recurved wings [n]\n",
  "TAUGHT": "TEACH, to impart knowledge or skill to [v]\n",
  "TAUHINU": "(Maori) a poplar tree [n -S]\n",
  "TAUHINUS": "TAUHINU, (Maori) a poplar tree [n]\n",
  "TAUHOU": "(Maori) a greenish-coloured tropical songbird, aka silvereye [n -S]\n",
  "TAUHOUS": "TAUHOU, (Maori) a greenish-coloured tropical songbird, aka silvereye [n]\n",
  "TAUIWI": "(Maori) literally \"foreign race\", the non-Maori people of New Zealand [n -S]\n",
  "TAUIWIS": "TAUIWI, (Maori) literally \"foreign race\", the non-Maori people of New Zealand [n]\n",
  "TAULD": "TELL, to inform [v]\n",
  "TAUNT": "to goad or provoke [v -ED, -ING, -S]\n",
  "TAUNTED": "TAUNT, to goad or provoke [v]\n",
  "TAUNTER": "one who taunts [n -S]\n",
  "TAUNTERS": "TAUNTER, one who taunts [n]\n",
  "TAUNTING": "goading [adj TAUNTINGLY] / the act of taunting [n -S]\n",
  "TAUNTINGLY": "TAUNTING, goading [adv]\n",
  "TAUNTINGS": "TAUNTING, the act of taunting [n]\n",
  "TAUNTS": "TAUNT, to goad or provoke [v]\n",
  "TAUON": "a lepton of mass about 3600 times greater than that of an electron [n -S]\n",
  "TAUONS": "TAUON, a lepton of mass about 3600 times greater than that of an electron [n]\n",
  "TAUPATA": "(Maori) a New Zealand tree with shiny dark green leaves [n -S]\n",
  "TAUPATAS": "TAUPATA, (Maori) a New Zealand tree with shiny dark green leaves [n]\n",
  "TAUPE": "(French) a brownish gray, similar to the color of moleskin [n -S]\n",
  "TAUPES": "TAUPE, (French) a brownish gray, similar to the color of moleskin [n]\n",
  "TAUPIE": "(Scots) a foolish or awkward young person, also TAWPIE [n -S]\n",
  "TAUPIES": "TAUPIE, (Scots) a foolish or awkward young person, also TAWPIE [n]\n",
  "TAUREAN": "of or relating to a bull, also TAURIC [adj]\n",
  "TAURIC": "of or relating to a bull, also TAUREAN [adj]\n",
  "TAURIFORM": "having the form of a bull [adj]\n",
  "TAURINE": "a crystalline compound occurring in invertebrates [n -S]\n",
  "TAURINES": "TAURINE, a crystalline compound occurring in invertebrates [n]\n",
  "TAUROBOLIA": "TAUROBOLIUM, the sacrifice of a bull, as in the ancient Phrygian cult of Cybele [n]\n",
  "TAUROBOLIUM": "the sacrifice of a bull, as in the ancient Phrygian cult of Cybele [n TAUROBOLIA]\n",
  "TAUROMACHIAN": "pertaining to bullfights [adj]\n",
  "TAUROMACHIES": "TAUROMACHY, the art of bullfighting [n]\n",
  "TAUROMACHY": "the art of bullfighting [n TAUROMACHIES]\n",
  "TAUROMORPHOUS": "bull-shaped [adj]\n",
  "TAUS": "TAU, a Greek letter [n]\n",
  "TAUT": "stretched tight [adj TAUTER, TAUTEST, TAUTLY] / (Scots) to mat, tangle, also TAWT [v -ED, -ING, -S]\n",
  "TAUTAUG": "(Native American) a labroid fish of the North American coast, also TAUTOG [n -S]\n",
  "TAUTAUGS": "TAUTAUG, (Native American) a labroid fish of the North American coast, also TAUTOG [n]\n",
  "TAUTED": "TAUT, (Scots) to mat, tangle, also TAWT [v]\n",
  "TAUTEN": "to make taut [v -ED, -ING, -S]\n",
  "TAUTENED": "TAUTEN, to make taut [v]\n",
  "TAUTENING": "TAUTEN, to make taut [v]\n",
  "TAUTENS": "TAUTEN, to make taut [v]\n",
  "TAUTER": "TAUT, stretched tight [adj]\n",
  "TAUTEST": "TAUT, stretched tight [adj]\n",
  "TAUTING": "TAUT, (Scots) to mat, tangle, also TAWT [v]\n",
  "TAUTIT": "(Scots) matted, tangled [adj]\n",
  "TAUTLY": "TAUT, stretched tight [adv]\n",
  "TAUTNESS": "the state of being taut [n -ES]\n",
  "TAUTNESSES": "TAUTNESS, the state of being taut [n]\n",
  "TAUTOCHRONE": "a curve such that a particle travelling along it under gravity reaches a fixed point in the same time, no matter where it starts [n -S]\n",
  "TAUTOCHRONES": "TAUTOCHRONE, a curve such that a particle travelling along it under gravity reaches a fixed point in the same time, no matter where it starts [n]\n",
  "TAUTOCHRONISM": "the state of being a tautochrone [n -S]\n",
  "TAUTOCHRONISMS": "TAUTOCHRONISM, the state of being a tautochrone [n]\n",
  "TAUTOCHRONOUS": "lasting the same amount of time [adj]\n",
  "TAUTOG": "(Native American) a labroid fish of the North American coast, also TAUTAUG [n -S]\n",
  "TAUTOGS": "TAUTOG, (Native American) a labroid fish of the North American coast, also TAUTAUG [n]\n",
  "TAUTOLOGIC": "relating to tautology, also TAUTOLOGICAL [adj TAUTOLOGICALLY]\n",
  "TAUTOLOGICAL": "relating to tautology, also TAUTOLOGIC [adj TAUTOLOGICALLY]\n",
  "TAUTOLOGICALLY": "TAUTOLOGICAL, relating to tautology, also TAUTOLOGIC [adv]\n",
  "TAUTOLOGIES": "TAUTOLOGY, the needless repetition of an idea, statement or word; a redundant statement [n]\n",
  "TAUTOLOGISE": "to use tautology, also TAUTOLOGIZE [v TAUTOLOGISED, TAUTOLOGISING, TAUTOLOGISES]\n",
  "TAUTOLOGISED": "TAUTOLOGISE, to use tautology, also TAUTOLOGIZE [v]\n",
  "TAUTOLOGISES": "TAUTOLOGISE, to use tautology, also TAUTOLOGIZE [v]\n",
  "TAUTOLOGISING": "TAUTOLOGISE, to use tautology, also TAUTOLOGIZE [v]\n",
  "TAUTOLOGISM": "the use of tautology [n -S]\n",
  "TAUTOLOGISMS": "TAUTOLOGISM, the use of tautology [n]\n",
  "TAUTOLOGIST": "one who uses tautology [n -S]\n",
  "TAUTOLOGISTS": "TAUTOLOGIST, one who uses tautology [n]\n",
  "TAUTOLOGIZE": "to use tautology, also TAUTOLOGISE [v TAUTOLOGIZED, TAUTOLOGIZING, TAUTOLOGIZES]\n",
  "TAUTOLOGIZED": "TAUTOLOGIZE, to use tautology, also TAUTOLOGISE [v]\n",
  "TAUTOLOGIZES": "TAUTOLOGIZE, to use tautology, also TAUTOLOGISE [v]\n",
  "TAUTOLOGIZING": "TAUTOLOGIZE, to use tautology, also TAUTOLOGISE [v]\n",
  "TAUTOLOGOUS": "involving or containing rhetorical tautology [adj TAUTOLOGOUSLY]\n",
  "TAUTOLOGOUSLY": "TAUTOLOGOUS, involving or containing rhetorical tautology [adv]\n",
  "TAUTOLOGY": "the needless repetition of an idea, statement or word; a redundant statement [n TAUTOLOGIES]\n",
  "TAUTOMER": "a type of chemical compound [n -S]\n",
  "TAUTOMERIC": "relating to, or characterized by, tautomerism [adj]\n",
  "TAUTOMERISM": "possession of more than one structure by a substance [n -S]\n",
  "TAUTOMERISMS": "TAUTOMERISM, possession of more than one structure by a substance [n]\n",
  "TAUTOMERS": "TAUTOMER, a type of chemical compound [n]\n",
  "TAUTOMETRIC": "exactly corresponding in arrangement of syllables, also TAUTOMETRICAL [adj]\n",
  "TAUTOMETRICAL": "exactly corresponding in arrangement of syllables, also TAUTOMETRIC [adj]\n",
  "TAUTONYM": "a taxonomic name in which the specific name repeats the generic [n -S]\n",
  "TAUTONYMIC": "like a tautonym, a taxonomic name in which genus and species are the same [adj]\n",
  "TAUTONYMIES": "TAUTONYMY, the practice of using a specific name the same as the generic name [n]\n",
  "TAUTONYMOUS": "of or like a tautonym, a taxonomic name in which genus and species are the same [adj]\n",
  "TAUTONYMS": "TAUTONYM, a taxonomic name in which the specific name repeats the generic [n]\n",
  "TAUTONYMY": "the practice of using a specific name the same as the generic name [n TAUTONYMIES]\n",
  "TAUTOPHONIC": "relating to tautophony, also TAUTOPHONICAL [adj]\n",
  "TAUTOPHONICAL": "relating to tautophony, also TAUTOPHONIC [adj]\n",
  "TAUTOPHONIES": "TAUTOPHONY, repetition of the same sound [n]\n",
  "TAUTOPHONY": "repetition of the same sound [n TAUTOPHONIES]\n",
  "TAUTS": "TAUT, (Scots) to mat, tangle, also TAWT [v]\n",
  "TAV": "a letter of the Hebrew alphabet [n -S]\n",
  "TAVA": "(Hindi) a griddle in Indian cookery, also TAVAH, TAWA [n -S]\n",
  "TAVAH": "(Hindi) a griddle in Indian cookery, also TAVA, TAWA [n -S]\n",
  "TAVAHS": "TAVAH, (Hindi) a griddle in Indian cookery, also TAVA, TAWA [n]\n",
  "TAVAS": "TAVA, (Hindi) a griddle in Indian cookery, also TAVAH, TAWA [n]\n",
  "TAVER": "(Scots) to wander, rave, also TAIVER [v -ED, -ING, -S]\n",
  "TAVERED": "TAVER, (Scots) to wander, rave, also TAIVER [v]\n",
  "TAVERING": "TAVER, (Scots) to wander, rave, also TAIVER [v]\n",
  "TAVERN": "an ale house [n -S]\n",
  "TAVERNA": "(Modern Greek) in Greece, a type of guesthouse with bar [n -S]\n",
  "TAVERNAS": "TAVERNA, (Modern Greek) in Greece, a type of guesthouse with bar [n]\n",
  "TAVERNER": "one who runs a tavern [n -S]\n",
  "TAVERNERS": "TAVERNER, one who runs a tavern [n]\n",
  "TAVERNS": "TAVERN, an ale house [n]\n",
  "TAVERS": "TAVER, (Scots) to wander, rave, also TAIVER [v]\n",
  "TAVERT": "(Scots) muddled, fuddled, also TAIVERT [adj]\n",
  "TAVS": "TAV, a letter of the Hebrew alphabet [n]\n",
  "TAW": "to convert into white leather with minerals [v -ED, -ING, -S]\n",
  "TAWA": "(Hindi) a griddle in Indian cookery, also TAVA, TAVAH [n -S]\n",
  "TAWAI": "(Maori) a New Zealand beech, also TAWHAI [n -S]\n",
  "TAWAIS": "TAWAI, (Maori) a New Zealand beech, also TAWHAI [n]\n",
  "TAWAS": "TAWA, (Hindi) a griddle in Indian cookery, also TAVA, TAVAH [n]\n",
  "TAWDRIER": "TAWDRY, cheap, trashy [adj]\n",
  "TAWDRIES": "TAWDRY, trumpery, tawdry-lace [n]\n",
  "TAWDRIEST": "TAWDRY, cheap, trashy [adj]\n",
  "TAWDRILY": "TAWDRY, cheap, trashy [adv]\n",
  "TAWDRINESS": "the state of being tawdry [n -ES]\n",
  "TAWDRINESSES": "TAWDRINESS, the state of being tawdry [n]\n",
  "TAWDRY": "cheap, trashy [adj TAWDRIER, TAWDRIEST, TAWDRILY] / trumpery, tawdry-lace [n TAWDRIES]\n",
  "TAWED": "TAW, to convert into white leather with minerals [v]\n",
  "TAWER": "a maker of white leather [n -S]\n",
  "TAWERIES": "TAWERY, a place where skins are dressed [n]\n",
  "TAWERS": "TAWER, a maker of white leather [n]\n",
  "TAWERY": "a place where skins are dressed [n TAWERIES]\n",
  "TAWHAI": "(Maori) a New Zealand beech, also TAWAI [n -S]\n",
  "TAWHAIS": "TAWHAI, (Maori) a New Zealand beech, also TAWAI [n]\n",
  "TAWHEOWHEO": "(Maori) a type of azalea found in New Zealand [n -S]\n",
  "TAWHEOWHEOS": "TAWHEOWHEO, (Maori) a type of azalea found in New Zealand [n]\n",
  "TAWHIRI": "(Maori) a small New Zealand tree with wavy glossy dark green leaves [n -S]\n",
  "TAWHIRIS": "TAWHIRI, (Maori) a small New Zealand tree with wavy glossy dark green leaves [n]\n",
  "TAWIE": "(Scots) tractable [adj TAWIER, TAWIEST]\n",
  "TAWIER": "TAWIE, (Scots) tractable [adj]\n",
  "TAWIEST": "TAWIE, (Scots) tractable [adj]\n",
  "TAWING": "the act of tawing, converting skin to white leather by tanning with alum and salt [n -S]\n",
  "TAWINGS": "TAWING, the act of tawing, converting skin to white leather by tanning with alum and salt [n]\n",
  "TAWNEY": "light brown, also TAWNY [adj TAWNIER, TAWNIEST] / a port of a rich orange-brown colour [n -S]\n",
  "TAWNEYS": "TAWNEY, a port of a rich orange-brown colour [n]\n",
  "TAWNIER": "TAWNY, orange-brown, also TAWNEY [adj]\n",
  "TAWNIES": "TAWNY, a port of a rich orange-brown colour [n]\n",
  "TAWNIEST": "TAWNY, orange-brown, also TAWNEY [adj]\n",
  "TAWNILY": "TAWNY, orange-brown, also TAWNEY [adv]\n",
  "TAWNINESS": "the state of being tawny [n -ES]\n",
  "TAWNINESSES": "TAWNINESS, the state of being tawny [n]\n",
  "TAWNY": "orange-brown, also TAWNEY [adj TAWNIER, TAWNIEST, TAWNILY] / a port of a rich orange-brown colour [n TAWNIES]\n",
  "TAWPIE": "(Scots) a foolish or awkward young person, also TAUPIE [n -S]\n",
  "TAWPIES": "TAWPIE, (Scots) a foolish or awkward young person, also TAUPIE [n]\n",
  "TAWS": "TAW, to convert into white leather with minerals [v]\n",
  "TAWSE": "to beat with a taws [v TAWSED, TAWSING, TAWSES]\n",
  "TAWSED": "TAWSE, to beat with a taws [v]\n",
  "TAWSES": "TAWSE, to beat with a taws [v]\n",
  "TAWSING": "TAWSE, to beat with a taws [v]\n",
  "TAWT": "(Scots) to mat, tangle, also TAUT [v -ED, -ING, -S]\n",
  "TAWTED": "TAWT, (Scots) to mat, tangle, also TAUT [v]\n",
  "TAWTIE": "(Scots) matted, tangled [adj TAWTIER, TAWTIEST]\n",
  "TAWTIER": "TAWTIE, (Scots) matted, tangled [adj]\n",
  "TAWTIEST": "TAWTIE, (Scots) matted, tangled [adj]\n",
  "TAWTING": "TAWT, (Scots) to mat, tangle, also TAUT [v]\n",
  "TAWTS": "TAWT, (Scots) to mat, tangle, also TAUT [v]\n",
  "TAX": "to impose a charge for public purposes [v -ED, -ING, -ES]\n",
  "TAXA": "TAXON, a unit of scientific classification [n]\n",
  "TAXABILITIES": "TAXABILITY, the state of being taxable [n]\n",
  "TAXABILITY": "the state of being taxable [n TAXABILITIES]\n",
  "TAXABLE": "capable of being taxed [adj TAXABLY] / a taxable item [n -S]\n",
  "TAXABLENESS": "the state of being taxable [n -ES]\n",
  "TAXABLENESSES": "TAXABLENESS, the state of being taxable [n]\n",
  "TAXABLES": "TAXABLE, a taxable item [n]\n",
  "TAXABLY": "TAXABLE, capable of being taxed [adv]\n",
  "TAXACEOUS": "pertaining to yew trees [adj]\n",
  "TAXAMETER": "(obsolete) an instrument for measuring fee for hired vehicle, also TAXIMETER [n -S]\n",
  "TAXAMETERS": "TAXAMETER, (obsolete) an instrument for measuring fee for hired vehicle, also TAXIMETER [n]\n",
  "TAXATION": "the process of taxing [n -S]\n",
  "TAXATIONAL": "relating to taxation [adj]\n",
  "TAXATIONS": "TAXATION, the process of taxing [n]\n",
  "TAXATIVE": "of taxing [adj]\n",
  "TAXED": "TAX, to impose a charge for public purposes [v]\n",
  "TAXEME": "any element of language that can affect the meaning of an utterance [n -S]\n",
  "TAXEMES": "TAXEME, any element of language that can affect the meaning of an utterance [n]\n",
  "TAXEMIC": "relating to a taxeme, a unit of grammatical relationship [adj]\n",
  "TAXER": "one who imposes taxes, also TAXOR [n -S]\n",
  "TAXERS": "TAXER, one who imposes taxes, also TAXOR [n]\n",
  "TAXES": "TAX, to impose a charge for public purposes [v]\n",
  "TAXI": "to travel in a taxicab [v TAXIED, TAXIING or TAXYING, TAXIS or TAXIES]\n",
  "TAXIARCH": "an Athenian military officer commanding a certain division of an army [n -S]\n",
  "TAXIARCHS": "TAXIARCH, an Athenian military officer commanding a certain division of an army [n]\n",
  "TAXICAB": "automobile for hire [n -S]\n",
  "TAXICABS": "TAXICAB, automobile for hire [n]\n",
  "TAXIDERMAL": "relating to taxidermy, also TAXIDERMIC [adj]\n",
  "TAXIDERMIC": "relating to taxidermy, also TAXIDERMAL [adj]\n",
  "TAXIDERMIES": "TAXIDERMY, the art of stuffing animals [n]\n",
  "TAXIDERMISE": "to practise taxidermy, also TAXIDERMIZE [v TAXIDERMISED, TAXIDERMISING, TAXIDERMISES]\n",
  "TAXIDERMISED": "TAXIDERMISE, to practise taxidermy, also TAXIDERMIZE [v]\n",
  "TAXIDERMISES": "TAXIDERMISE, to practise taxidermy, also TAXIDERMIZE [v]\n",
  "TAXIDERMISING": "TAXIDERMISE, to practise taxidermy, also TAXIDERMIZE [v]\n",
  "TAXIDERMIST": "one who practises taxidermy [n -S]\n",
  "TAXIDERMISTS": "TAXIDERMIST, one who practises taxidermy [n]\n",
  "TAXIDERMIZE": "to practise taxidermy, also TAXIDERMISE [v TAXIDERMIZED, TAXIDERMIZING, TAXIDERMIZES]\n",
  "TAXIDERMIZED": "TAXIDERMIZE, to practise taxidermy, also TAXIDERMISE [v]\n",
  "TAXIDERMIZES": "TAXIDERMIZE, to practise taxidermy, also TAXIDERMISE [v]\n",
  "TAXIDERMIZING": "TAXIDERMIZE, to practise taxidermy, also TAXIDERMISE [v]\n",
  "TAXIDERMY": "the art of stuffing animals [n TAXIDERMIES]\n",
  "TAXIED": "TAXI, to travel in a taxicab [v]\n",
  "TAXIES": "TAXI, to travel in a taxicab [v]\n",
  "TAXIING": "TAXI, to travel in a taxicab [v]\n",
  "TAXIMAN": "the driver of a taxicab [n TAXIMEN]\n",
  "TAXIMEN": "TAXIMAN, the driver of a taxicab [n]\n",
  "TAXIMETER": "an instrument for measuring fee for hired vehicle, also TAXAMETER [n -S]\n",
  "TAXIMETERS": "TAXIMETER, an instrument for measuring fee for hired vehicle, also TAXAMETER [n]\n",
  "TAXING": "imposition of taxes [n -S]\n",
  "TAXINGLY": "TAXING [adv]\n",
  "TAXINGS": "TAXING, imposition of taxes [n]\n",
  "TAXIPLANE": "an aircraft that is available for hire [n -S]\n",
  "TAXIPLANES": "TAXIPLANE, an aircraft that is available for hire [n]\n",
  "TAXIS": "the movement of a cell or organism in a particular direction in response to an external stimulus [n -ES]\n",
  "TAXISES": "TAXIS, the movement of a cell or organism in a particular direction in response to an external stimulus [n]\n",
  "TAXITE": "a kind of volcanic rock [n -S]\n",
  "TAXITES": "TAXITE, a kind of volcanic rock [n]\n",
  "TAXITIC": "relating to taxite, a volcanic rock [adj]\n",
  "TAXIWAY": "at an airport, a specially prepared track used for the movement of aircraft [n -S]\n",
  "TAXIWAYS": "TAXIWAY, at an airport, a specially prepared track used for the movement of aircraft [n]\n",
  "TAXLESS": "free from taxation [adj]\n",
  "TAXMAN": "one who collects taxes [n TAXMEN]\n",
  "TAXMEN": "TAXMAN, one who collects taxes [n]\n",
  "TAXOL": "(tradename) a drug obtained from the Pacific yew [n -S]\n",
  "TAXOLS": "TAXOL, (tradename) a drug obtained from the Pacific yew [n]\n",
  "TAXON": "a unit of scientific classification [n TAXONS or TAXA]\n",
  "TAXONOMER": "a specialist in taxonomy, also TAXONOMIST [n -S]\n",
  "TAXONOMERS": "TAXONOMER, a specialist in taxonomy, also TAXONOMIST [n]\n",
  "TAXONOMIC": "relating to taxonomy, the science of classifying living organisms, also TAXONOMICAL [adj TAXONOMICALLY]\n",
  "TAXONOMICAL": "relating to taxonomy, the science of classifying living organisms, also TAXONOMIC [adj TAXONOMICALLY]\n",
  "TAXONOMICALLY": "TAXONOMICAL, relating to taxonomy, the science of classifying living organisms, also TAXONOMIC [adv]\n",
  "TAXONOMIES": "TAXONOMY, the study of scientific classification [n]\n",
  "TAXONOMIST": "a specialist in taxonomy, also TAXONOMER [n -S]\n",
  "TAXONOMISTS": "TAXONOMIST, a specialist in taxonomy, also TAXONOMER [n]\n",
  "TAXONOMY": "the study of scientific classification [n TAXONOMIES]\n",
  "TAXONS": "TAXON, a unit of scientific classification [n]\n",
  "TAXOR": "one who taxes, also TAXER [n -S]\n",
  "TAXORS": "TAXOR, one who taxes, also TAXER [n]\n",
  "TAXPAID": "paid for by taxes [adj]\n",
  "TAXPAYER": "one who pays taxes [n -S]\n",
  "TAXPAYERS": "TAXPAYER, one who pays taxes [n]\n",
  "TAXPAYING": "the paying of taxes [n -S]\n",
  "TAXPAYINGS": "TAXPAYING, the paying of taxes [n]\n",
  "TAXUS": "(Latin) a member of the yew genus of evergreen shrubs [n TAXUS]\n",
  "TAXWISE": "pertaining to taxes [adj]\n",
  "TAXYING": "TAXI, to travel in a taxicab [v]\n",
  "TAY": "(dialect) tea [n -S]\n",
  "TAYASSUID": "(Tupi) any member of the Tayassuid family of New World pigs [n -S]\n",
  "TAYASSUIDS": "TAYASSUID, (Tupi) any member of the Tayassuid family of New World pigs [n]\n",
  "TAYBERRIES": "TAYBERRY, a hybrid plant, a blackberry crossed with a raspberry [n]\n",
  "TAYBERRY": "a hybrid plant, a blackberry crossed with a raspberry [n TAYBERRIES]\n",
  "TAYRA": "(Tupi) a large South American member of the weasel family, also TAIRA [n -S]\n",
  "TAYRAS": "TAYRA, (Tupi) a large South American member of the weasel family, also TAIRA [n]\n",
  "TAYS": "TAY, (dialect) tea [n]\n",
  "TAZZA": "(Italian) a cup with saucer-shaped bowl on a pedestal [n TAZZE or TAZZAS]\n",
  "TAZZAS": "TAZZA, (Italian) a cup with saucer-shaped bowl on a pedestal [n]\n",
  "TAZZE": "TAZZA, (Italian) a cup with saucer-shaped bowl on a pedestal [n]\n",
  "TCHICK": "to make a sound by clicking the tongue against the roof of the mouth [v -ED, -ING, -S]\n",
  "TCHICKED": "TCHICK, to make a sound by clicking the tongue against the roof of the mouth [v]\n",
  "TCHICKING": "TCHICK, to make a sound by clicking the tongue against the roof of the mouth [v]\n",
  "TCHICKS": "TCHICK, to make a sound by clicking the tongue against the roof of the mouth [v]\n",
  "TCHOTCHKE": "(Yiddish) a knickknack, also CHACHKA, CHATCHKE, CHATCHKA, TSATSKE [n -S]\n",
  "TCHOTCHKES": "TCHOTCHKE, (Yiddish) a knickknack, also CHACHKA, CHATCHKE, CHATCHKA, TSATSKE [n]\n",
  "TCHOUKBALL": "a ball game involving a ball thrown against a highly sprung net [n -S]\n",
  "TCHOUKBALLS": "TCHOUKBALL, a ball game involving a ball thrown against a highly sprung net [n]\n",
  "TE": "(in tonic sol-fa) the seventh degree of any major scale [n -S]\n",
  "TEA": "to drink a beverage made with tea leaves and boiling water [v -ED, -ING, -S]\n",
  "TEABAG": "a bag containing tea leaves for infusion [n -S]\n",
  "TEABAGS": "TEABAG, a bag containing tea leaves for infusion [n]\n",
  "TEABERRIES": "TEABERRY, a North American shrub [n]\n",
  "TEABERRY": "a North American shrub [n TEABERRIES]\n",
  "TEABOARD": "a tray for serving tea [n -S]\n",
  "TEABOARDS": "TEABOARD, a tray for serving tea [n]\n",
  "TEABOWL": "a teacup without a handle [n -S]\n",
  "TEABOWLS": "TEABOWL, a teacup without a handle [n]\n",
  "TEABOX": "a box for storing tea leaves [n -ES]\n",
  "TEABOXES": "TEABOX, a box for storing tea leaves [n]\n",
  "TEABREAD": "a loaf of cake containing dried fruit, dipped in cold tea before baking [n -S]\n",
  "TEABREADS": "TEABREAD, a loaf of cake containing dried fruit, dipped in cold tea before baking [n]\n",
  "TEACAKE": "a small cake served with tea [n -S]\n",
  "TEACAKES": "TEACAKE, a small cake served with tea [n]\n",
  "TEACART": "a trolley used for serving tea [n -S]\n",
  "TEACARTS": "TEACART, a trolley used for serving tea [n]\n",
  "TEACH": "to impart knowledge or skill to [v TAUGHT, TEACHING, TEACHES]\n",
  "TEACHABILITIES": "TEACHABILITY, the quality of being teachable [n]\n",
  "TEACHABILITY": "the quality of being teachable [n TEACHABILITIES]\n",
  "TEACHABLE": "capable of being taught [adj TEACHABLY]\n",
  "TEACHABLENESS": "the state of being teachable [n -ES]\n",
  "TEACHABLENESSES": "TEACHABLENESS, the state of being teachable [n]\n",
  "TEACHABLY": "TEACHABLE, capable of being taught [adv]\n",
  "TEACHER": "one that teaches [n -S]\n",
  "TEACHERLESS": "without a teacher [adj]\n",
  "TEACHERLIER": "TEACHERLY, like a teacher [adj]\n",
  "TEACHERLIEST": "TEACHERLY, like a teacher [adj]\n",
  "TEACHERLY": "like a teacher [adj TEACHERLIER, TEACHERLIEST]\n",
  "TEACHERS": "TEACHER, one that teaches [n]\n",
  "TEACHERSHIP": "the office of teacher [n -S]\n",
  "TEACHERSHIPS": "TEACHERSHIP, the office of teacher [n]\n",
  "TEACHES": "TEACH, to impart knowledge or skill to [v]\n",
  "TEACHIE": "(obsolete) tetchy, also TECHY [adj]\n",
  "TEACHING": "a doctrine [n -S]\n",
  "TEACHINGS": "TEACHING, a doctrine [n]\n",
  "TEACHLESS": "not teachable [adj]\n",
  "TEACUP": "a cup in which tea is served [n -S]\n",
  "TEACUPFUL": "enough to fill a teacup [n TEACUPFULS or TEACUPSFUL]\n",
  "TEACUPFULS": "TEACUPFUL, enough to fill a teacup [n]\n",
  "TEACUPS": "TEACUP, a cup in which tea is served [n]\n",
  "TEACUPSFUL": "TEACUPFUL, enough to fill a teacup [n]\n",
  "TEAD": "(Spenser) a torch, also TEADE [n -S]\n",
  "TEADE": "(Spenser) a torch, also TEAD [n -S]\n",
  "TEADES": "TEADE, (Spenser) a torch, also TEAD [n]\n",
  "TEADS": "TEAD, (Spenser) a torch, also TEADE [n]\n",
  "TEAED": "TEA, to drink a beverage made with tea leaves and boiling water [v]\n",
  "TEAGLE": "to hoist [v TEAGLED, TEAGLING, TEAGLES]\n",
  "TEAGLED": "TEAGLE, to hoist [v]\n",
  "TEAGLES": "TEAGLE, to hoist [v]\n",
  "TEAGLING": "TEAGLE, to hoist [v]\n",
  "TEAHOUSE": "a public establishment serving tea [n -S]\n",
  "TEAHOUSES": "TEAHOUSE, a public establishment serving tea [n]\n",
  "TEAING": "TEA, to drink a beverage made with tea leaves and boiling water [v]\n",
  "TEAK": "(Malay) an East Indian tree, or its dark heavy timber [n -S]\n",
  "TEAKETTLE": "a kettle used for making tea [n -S]\n",
  "TEAKETTLES": "TEAKETTLE, a kettle used for making tea [n]\n",
  "TEAKS": "TEAK, (Malay) an East Indian tree, or its dark heavy timber [n]\n",
  "TEAKWOOD": "the wood of the teak [n -S]\n",
  "TEAKWOODS": "TEAKWOOD, the wood of the teak [n]\n",
  "TEAL": "a river duck [n -S]\n",
  "TEALIGHT": "a candle used in tea or food warmers or as a night light [n -S]\n",
  "TEALIGHTS": "TEALIGHT, a candle used in tea or food warmers or as a night light [n]\n",
  "TEALIKE": "resembling tea [adj]\n",
  "TEALS": "TEAL, a river duck [n]\n",
  "TEAM": "to join together for joint action [v -ED, -ING, -S]\n",
  "TEAMAKER": "one that makes tea [n -S]\n",
  "TEAMAKERS": "TEAMAKER, one that makes tea [n]\n",
  "TEAMED": "TEAM, to join together for joint action [v]\n",
  "TEAMER": "a person who drives a team; a truck-driver, also TEAMSTER [n -S]\n",
  "TEAMERS": "TEAMER, a person who drives a team; a truck-driver, also TEAMSTER [n]\n",
  "TEAMING": "the act of driving a team [n -S]\n",
  "TEAMINGS": "TEAMING, the act of driving a team [n]\n",
  "TEAMMATE": "a member of the same team [n -S]\n",
  "TEAMMATES": "TEAMMATE, a member of the same team [n]\n",
  "TEAMS": "TEAM, to join together for joint action [v]\n",
  "TEAMSTER": "a truck driver, also TEAMER [n -S]\n",
  "TEAMSTERS": "TEAMSTER, a truck driver, also TEAMER [n]\n",
  "TEAMWISE": "harnessed together [adv]\n",
  "TEAMWORK": "a pulling together of a team [n -S]\n",
  "TEAMWORKS": "TEAMWORK, a pulling together of a team [n]\n",
  "TEAPOT": "a vessel used in making and serving tea [n -S]\n",
  "TEAPOTS": "TEAPOT, a vessel used in making and serving tea [n]\n",
  "TEAPOY": "(Hindi) an ornamental stand, usually with three legs, having caddies for holding tea, also TEPOY [n -S]\n",
  "TEAPOYS": "TEAPOY, (Hindi) an ornamental stand, usually with three legs, having caddies for holding tea, also TEPOY [n]\n",
  "TEAR": "to weep [v -ED, -ING, -S] / to pull apart [v TORE, TORN, TEARING, TEARS]\n",
  "TEARABLE": "able to be torn [adj]\n",
  "TEARAWAY": "a rebellious person [n -S]\n",
  "TEARAWAYS": "TEARAWAY, a rebellious person [n]\n",
  "TEARDOWN": "the process of disassembling [n -S]\n",
  "TEARDOWNS": "TEARDOWN, the process of disassembling [n]\n",
  "TEARDROP": "a tear [n -S]\n",
  "TEARDROPS": "TEARDROP, a tear [n]\n",
  "TEARED": "TEAR, to weep [v]\n",
  "TEARER": "(slang) a boisterous person [n -S]\n",
  "TEARERS": "TEARER, (slang) a boisterous person [n]\n",
  "TEARFUL": "full of tears [adj TEARFULLY]\n",
  "TEARFULLY": "TEARFUL, full of tears [adv]\n",
  "TEARFULNESS": "the state of being tearful [n -ES]\n",
  "TEARFULNESSES": "TEARFULNESS, the state of being tearful [n]\n",
  "TEARGAS": "to assault with a gas that irritates the eyes [v TEARGASSED, TEARGASSING, TEARGASES or TEARGASSES]\n",
  "TEARGASES": "TEARGAS, to assault with a gas that irritates the eyes [v]\n",
  "TEARGASSED": "TEARGAS, to assault with a gas that irritates the eyes [v]\n",
  "TEARGASSES": "TEARGAS, to assault with a gas that irritates the eyes [v]\n",
  "TEARGASSING": "TEARGAS, to assault with a gas that irritates the eyes [v]\n",
  "TEARIER": "TEARY, wet with tears, tearful [adj]\n",
  "TEARIEST": "TEARY, wet with tears, tearful [adj]\n",
  "TEARILY": "TEARY, wet with tears, tearful [adv]\n",
  "TEARINESS": "the state of being teary [n -ES]\n",
  "TEARINESSES": "TEARINESS, the state of being teary [n]\n",
  "TEARING": "TEAR, to weep [v]\n",
  "TEARJERKER": "a story, song, play, film, or broadcast that moves or is intended to move its audience to tears [n -S]\n",
  "TEARJERKERS": "TEARJERKER, a story, song, play, film, or broadcast that moves or is intended to move its audience to tears [n]\n",
  "TEARLESS": "without tears [adj TEARLESSLY]\n",
  "TEARLESSLY": "TEARLESS, without tears [adv]\n",
  "TEARLIKE": "resembling a tear [adj]\n",
  "TEAROOM": "a restaurant serving tea [n -S]\n",
  "TEAROOMS": "TEAROOM, a restaurant serving tea [n]\n",
  "TEARS": "TEAR, to weep [v]\n",
  "TEARSHEET": "a page in a magazine perforated to facilitate its removal [n -S]\n",
  "TEARSHEETS": "TEARSHEET, a page in a magazine perforated to facilitate its removal [n]\n",
  "TEARSTAIN": "the mark left by tears [n -S]\n",
  "TEARSTAINED": "marked with tears [adj]\n",
  "TEARSTAINS": "TEARSTAIN, the mark left by tears [n]\n",
  "TEARSTRIP": "a part of a packaging torn to open it [n -S]\n",
  "TEARSTRIPS": "TEARSTRIP, a part of a packaging torn to open it [n]\n",
  "TEARY": "wet with tears, tearful [adj TEARIER, TEARIEST, TEARILY]\n",
  "TEAS": "TEA, to drink a beverage made with tea leaves and boiling water [v]\n",
  "TEASABLE": "liable to be teased [adj]\n",
  "TEASE": "to make fun of; to draw out, also TEAZE, TOAZE, TOSE, TOZE [v TEASED, TEASING, TEASES]\n",
  "TEASED": "TEASE, to make fun of; to draw out, also TEAZE, TOAZE, TOSE, TOZE [v]\n",
  "TEASEL": "to raise a nap on fabric, also TEAZEL, TEAZLE [v TEASELLED or TEASELED, TEASELLING or TEASELING, TEASELS]\n",
  "TEASELED": "TEASEL, to raise a nap on fabric, also TEAZEL, TEAZLE [v]\n",
  "TEASELER": "one who uses teasels for raising a nap on cloth, also TEASELLER [n -S]\n",
  "TEASELERS": "TEASELER, one who uses teasels for raising a nap on cloth, also TEASELLER [n]\n",
  "TEASELING": "the act of raising a nap on cloth with teasel [n -S]\n",
  "TEASELINGS": "TEASELING, the act of raising a nap on cloth with teasel [n]\n",
  "TEASELLED": "TEASEL, to raise a nap on fabric, also TEAZEL, TEAZLE [v]\n",
  "TEASELLER": "one who uses teasels for raising a nap on cloth, also TEASELER [n -S]\n",
  "TEASELLERS": "TEASELLER, one who uses teasels for raising a nap on cloth, also TEASELER [n]\n",
  "TEASELLING": "the act of raising a nap on cloth with teasel [n -S]\n",
  "TEASELLINGS": "TEASELLING, the act of raising a nap on cloth with teasel [n]\n",
  "TEASELS": "TEASEL, to raise a nap on fabric, also TEAZEL, TEAZLE [v]\n",
  "TEASER": "one who teases [n -S]\n",
  "TEASERS": "TEASER, one who teases [n]\n",
  "TEASES": "TEASE, to make fun of; to draw out, also TEAZE, TOAZE, TOSE, TOZE [v]\n",
  "TEASHOP": "a tearoom [n -S]\n",
  "TEASHOPS": "TEASHOP, a tearoom [n]\n",
  "TEASING": "making fun of [adj TEASINGLY] / the act of teasing [n -S]\n",
  "TEASINGLY": "TEASING, making fun of [adv]\n",
  "TEASINGS": "TEASING, the act of teasing [n]\n",
  "TEASPOON": "a small spoon [n -S]\n",
  "TEASPOONFUL": "the contents of a teaspoon [n TEASPOONFULS or TEASPOONSFUL]\n",
  "TEASPOONFULS": "TEASPOONFUL, the contents of a teaspoon [n]\n",
  "TEASPOONS": "TEASPOON, a small spoon [n]\n",
  "TEASPOONSFUL": "TEASPOONFUL, the contents of a teaspoon [n]\n",
  "TEAT": "a mammary gland [n -S]\n",
  "TEATASTER": "one whose job is to taste tea [n -S]\n",
  "TEATASTERS": "TEATASTER, one whose job is to taste tea [n]\n",
  "TEATED": "having a teat [adj]\n",
  "TEATIME": "the usual time for tea [n -S]\n",
  "TEATIMES": "TEATIME, the usual time for tea [n]\n",
  "TEATS": "TEAT, a mammary gland [n]\n",
  "TEAWARE": "a tea service [n -S]\n",
  "TEAWARES": "TEAWARE, a tea service [n]\n",
  "TEAZE": "(obsolete) to tease, also TOAZE, TOSE, TOZE [v TEAZED, TEAZING, TEAZES]\n",
  "TEAZED": "TEAZE, (obsolete) to tease, also TOAZE, TOSE, TOZE [v]\n",
  "TEAZEL": "to raise a nap on fabric, also TEASEL, TEAZLE [v TEAZELLED or TEAZELED, TEAZELLING or TEAZELING, TEAZELS]\n",
  "TEAZELED": "TEAZEL, to raise a nap on fabric, also TEASEL, TEAZLE [v]\n",
  "TEAZELING": "TEAZEL, to raise a nap on fabric, also TEASEL, TEAZLE [v]\n",
  "TEAZELLED": "TEAZEL, to raise a nap on fabric, also TEASEL, TEAZLE [v]\n",
  "TEAZELLING": "TEAZEL, to raise a nap on fabric, also TEASEL, TEAZLE [v]\n",
  "TEAZELS": "TEAZEL, to raise a nap on fabric, also TEASEL, TEAZLE [v]\n",
  "TEAZES": "TEAZE, (obsolete) to tease, also TOAZE, TOSE, TOZE [v]\n",
  "TEAZING": "TEAZE, (obsolete) to tease, also TOAZE, TOSE, TOZE [v]\n",
  "TEAZLE": "to raise a nap on fabric, also TEASEL, TEAZEL [v TEAZLED, TEAZLING, TEAZLES]\n",
  "TEAZLED": "TEAZLE, to raise a nap on fabric, also TEASEL, TEAZEL [v]\n",
  "TEAZLES": "TEAZLE, to raise a nap on fabric, also TEASEL, TEAZEL [v]\n",
  "TEAZLING": "TEAZLE, to raise a nap on fabric, also TEASEL, TEAZEL [v]\n",
  "TEBBAD": "(Persian) a sandstorm [n -S]\n",
  "TEBBADS": "TEBBAD, (Persian) a sandstorm [n]\n",
  "TEBIBYTE": "two to the power of forty bytes [n -S]\n",
  "TEBIBYTES": "TEBIBYTE, two to the power of forty bytes [n]\n",
  "TEC": "(slang) a detective [n -S]\n",
  "TECH": "(short for) a technical college [n -S]\n",
  "TECHED": "(colloquial) crazy, also TETCHED [adj]\n",
  "TECHIE": "an expert in or enthusiast for technology, also TEKKIE [n -S]\n",
  "TECHIER": "TECHY, irritable, also TEACHIE, TETCHY [adj]\n",
  "TECHIES": "TECHIE, an expert in or enthusiast for technology, also TEKKIE [n]\n",
  "TECHIEST": "TECHY, irritable, also TEACHIE, TETCHY [adj]\n",
  "TECHILY": "TECHY, irritable, also TEACHIE, TETCHY [adv]\n",
  "TECHINESS": "the state of being techy [n -ES]\n",
  "TECHINESSES": "TECHINESS, the state of being techy [n]\n",
  "TECHNETIUM": "a chemical element [n -S]\n",
  "TECHNETIUMS": "TECHNETIUM, a chemical element [n]\n",
  "TECHNETRONIC": "shaped or influenced by the changes wrought by advances in technology and communications [adj]\n",
  "TECHNIC": "a technique [n -S]\n",
  "TECHNICAL": "related to technique [adj TECHNICALLY] / a worker on technical matters [n -S]\n",
  "TECHNICALISE": "to give a technical slant to, also TECHNICALIZE [v TECHNICALISED, TECHNICALISING, TECHNICALISES]\n",
  "TECHNICALISED": "TECHNICALISE, to give a technical slant to, also TECHNICALIZE [v]\n",
  "TECHNICALISES": "TECHNICALISE, to give a technical slant to, also TECHNICALIZE [v]\n",
  "TECHNICALISING": "TECHNICALISE, to give a technical slant to, also TECHNICALIZE [v]\n",
  "TECHNICALITIES": "TECHNICALITY, something technical [n]\n",
  "TECHNICALITY": "something technical [n TECHNICALITIES]\n",
  "TECHNICALIZE": "to give a technical slant to, also TECHNICALISE [v TECHNICALIZED, TECHNICALIZING, TECHNICALIZES]\n",
  "TECHNICALIZED": "TECHNICALIZE, to give a technical slant to, also TECHNICALISE [v]\n",
  "TECHNICALIZES": "TECHNICALIZE, to give a technical slant to, also TECHNICALISE [v]\n",
  "TECHNICALIZING": "TECHNICALIZE, to give a technical slant to, also TECHNICALISE [v]\n",
  "TECHNICALLY": "TECHNICAL, related to technique [adv]\n",
  "TECHNICALNESS": "the state of being technical [n -ES]\n",
  "TECHNICALNESSES": "TECHNICALNESS, the state of being technical [n]\n",
  "TECHNICALS": "TECHNICAL, a worker on technical matters [n]\n",
  "TECHNICIAN": "a specialist in the technical details of a subject or occupation [n -S]\n",
  "TECHNICIANS": "TECHNICIAN, a specialist in the technical details of a subject or occupation [n]\n",
  "TECHNICISE": "to render technical or technological, also TECHNICIZE [v TECHNICISED, TECHNICISING, TECHNICISES]\n",
  "TECHNICISED": "TECHNICISE, to render technical or technological, also TECHNICIZE [v]\n",
  "TECHNICISES": "TECHNICISE, to render technical or technological, also TECHNICIZE [v]\n",
  "TECHNICISING": "TECHNICISE, to render technical or technological, also TECHNICIZE [v]\n",
  "TECHNICISM": "an emphasis on or concern with practical results and method [n -S]\n",
  "TECHNICISMS": "TECHNICISM, an emphasis on or concern with practical results and method [n]\n",
  "TECHNICIST": "one skilled in technics or in one or more of the practical arts [n -S]\n",
  "TECHNICISTS": "TECHNICIST, one skilled in technics or in one or more of the practical arts [n]\n",
  "TECHNICIZE": "to render technical or technological, also TECHNICISE [v TECHNICIZED, TECHNICIZING, TECHNICIZES]\n",
  "TECHNICIZED": "TECHNICIZE, to render technical or technological, also TECHNICISE [v]\n",
  "TECHNICIZES": "TECHNICIZE, to render technical or technological, also TECHNICISE [v]\n",
  "TECHNICIZING": "TECHNICIZE, to render technical or technological, also TECHNICISE [v]\n",
  "TECHNICOLOUR": "in artificially or exaggeratedly bright colours, also TECHNICOLOURED [adj]\n",
  "TECHNICOLOURED": "in artificially or exaggeratedly bright colours, also TECHNICOLOUR [adj]\n",
  "TECHNICS": "TECHNIC, a technique [n]\n",
  "TECHNIKON": "a technical college [n -S]\n",
  "TECHNIKONS": "TECHNIKON, a technical college [n]\n",
  "TECHNIQUE": "a skilled procedure or method [n -S]\n",
  "TECHNIQUES": "TECHNIQUE, a skilled procedure or method [n]\n",
  "TECHNO": "(short for) technomusic, a type of fast, repetitive electronic dance music [n -S]\n",
  "TECHNOBABBLE": "technical jargon [n -S]\n",
  "TECHNOBABBLES": "TECHNOBABBLE, technical jargon [n]\n",
  "TECHNOCRACIES": "TECHNOCRACY, government by technical experts [n]\n",
  "TECHNOCRACY": "government by technical experts [n TECHNOCRACIES]\n",
  "TECHNOCRAT": "an adherent of technocracy [n -S]\n",
  "TECHNOCRATIC": "of, relating to, or suggestive of a technocrat or a technocracy [adj]\n",
  "TECHNOCRATS": "TECHNOCRAT, an adherent of technocracy [n]\n",
  "TECHNOFEAR": "(colloquial) an irrational fear of technology [n -S]\n",
  "TECHNOFEARS": "TECHNOFEAR, (colloquial) an irrational fear of technology [n]\n",
  "TECHNOGRAPHIES": "TECHNOGRAPHY, the description of arts and crafts [n]\n",
  "TECHNOGRAPHY": "the description of arts and crafts [n TECHNOGRAPHIES]\n",
  "TECHNOID": "a technician [n -S]\n",
  "TECHNOIDS": "TECHNOID, a technician [n]\n",
  "TECHNOJUNKIE": "someone who is obsessed with technology [n -S]\n",
  "TECHNOJUNKIES": "TECHNOJUNKIE, someone who is obsessed with technology [n]\n",
  "TECHNOLOGIC": "relating to technology, also TECHNOLOGICAL [adj TECHNOLOGICALLY]\n",
  "TECHNOLOGICAL": "relating to technology, also TECHNOLOGIC [adj TECHNOLOGICALLY]\n",
  "TECHNOLOGICALLY": "TECHNOLOGICAL, relating to technology, also TECHNOLOGIC [adv]\n",
  "TECHNOLOGIES": "TECHNOLOGY, the practical application of knowledge esp. in a particular area [n]\n",
  "TECHNOLOGISE": "to affect or alter by technology, also TECHNOLOGIZE [v TECHNOLOGISED, TECHNOLOGISING, TECHNOLOGISES]\n",
  "TECHNOLOGISED": "TECHNOLOGISE, to affect or alter by technology, also TECHNOLOGIZE [v]\n",
  "TECHNOLOGISES": "TECHNOLOGISE, to affect or alter by technology, also TECHNOLOGIZE [v]\n",
  "TECHNOLOGISING": "TECHNOLOGISE, to affect or alter by technology, also TECHNOLOGIZE [v]\n",
  "TECHNOLOGIST": "one versed in technology [n -S]\n",
  "TECHNOLOGISTS": "TECHNOLOGIST, one versed in technology [n]\n",
  "TECHNOLOGIZE": "to affect or alter by technology, also TECHNOLOGISE [v TECHNOLOGIZED, TECHNOLOGIZING, TECHNOLOGIZES]\n",
  "TECHNOLOGIZED": "TECHNOLOGIZE, to affect or alter by technology, also TECHNOLOGISE [v]\n",
  "TECHNOLOGIZES": "TECHNOLOGIZE, to affect or alter by technology, also TECHNOLOGISE [v]\n",
  "TECHNOLOGIZING": "TECHNOLOGIZE, to affect or alter by technology, also TECHNOLOGISE [v]\n",
  "TECHNOLOGY": "the practical application of knowledge esp. in a particular area [n TECHNOLOGIES]\n",
  "TECHNOMANIA": "an obsession with technology [n -S]\n",
  "TECHNOMANIAC": "one with an excessive enthusiasm for technology [n -S]\n",
  "TECHNOMANIACS": "TECHNOMANIAC, one with an excessive enthusiasm for technology [n]\n",
  "TECHNOMANIAS": "TECHNOMANIA, an obsession with technology [n]\n",
  "TECHNOMUSIC": "a type of fast, repetitive electronic dance music [n -S]\n",
  "TECHNOMUSICS": "TECHNOMUSIC, a type of fast, repetitive electronic dance music [n]\n",
  "TECHNOPHILE": "an enthusiast of technology [n -S]\n",
  "TECHNOPHILES": "TECHNOPHILE, an enthusiast of technology [n]\n",
  "TECHNOPHILIA": "love of technology [n -S]\n",
  "TECHNOPHILIAS": "TECHNOPHILIA, love of technology [n]\n",
  "TECHNOPHOBE": "one with a fear of technology [n -S]\n",
  "TECHNOPHOBES": "TECHNOPHOBE, one with a fear of technology [n]\n",
  "TECHNOPHOBIA": "fear of technology [n -S]\n",
  "TECHNOPHOBIAS": "TECHNOPHOBIA, fear of technology [n]\n",
  "TECHNOPHOBIC": "one suffering from technophobia [n -S]\n",
  "TECHNOPHOBICS": "TECHNOPHOBIC, one suffering from technophobia [n]\n",
  "TECHNOPOLE": "a place where high-technology industries are located [n -S]\n",
  "TECHNOPOLES": "TECHNOPOLE, a place where high-technology industries are located [n]\n",
  "TECHNOPOLIS": "a society ruled by technology; a geographical area where projects in technological research and development are concentrated [n -ES]\n",
  "TECHNOPOLISES": "TECHNOPOLIS, a society ruled by technology; a geographical area where projects in technological research and development are concentrated [n]\n",
  "TECHNOPOLITAN": "a member of a technopolis [n -S]\n",
  "TECHNOPOLITANS": "TECHNOPOLITAN, a member of a technopolis [n]\n",
  "TECHNOPOP": "pop music featuring synthesisers and other technological equipment [n -S]\n",
  "TECHNOPOPS": "TECHNOPOP, pop music featuring synthesisers and other technological equipment [n]\n",
  "TECHNOS": "TECHNO, (short for) technomusic, a type of fast, repetitive electronic dance music [n]\n",
  "TECHNOSPEAK": "technical jargon [n -S]\n",
  "TECHNOSPEAKS": "TECHNOSPEAK, technical jargon [n]\n",
  "TECHNOSTRESS": "stress resulting from over-involvement with computers [n -ES]\n",
  "TECHNOSTRESSES": "TECHNOSTRESS, stress resulting from over-involvement with computers [n]\n",
  "TECHNOSTRUCTURE": "the network of professionally skilled managers (as scientists, engineers, and administrators) that tends to control the economy both within and beyond individual corporate groups [n]\n",
  "TECHS": "TECH, (short for) a technical college [n]\n",
  "TECHY": "irritable, also TEACHIE, TETCHY [adj TECHIER, TECHIEST, TECHILY]\n",
  "TECKEL": "(German) a dachshund [n -S]\n",
  "TECKELS": "TECKEL, (German) a dachshund [n]\n",
  "TECS": "TEC, (slang) a detective [n]\n",
  "TECTA": "TECTUM, (Latin) a rooflike body structure, esp. the dorsal part of the midbrain [n]\n",
  "TECTAL": "relating to a tectum, a rooflike body structure [adj]\n",
  "TECTIBRANCH": "any member of the Tectibranchiata, molluscs including sea-slugs [n -S]\n",
  "TECTIBRANCHIATE": "of a like a tectibranch, any member of the Tectibranchiata, molluscs including sea-slugs [adj]\n",
  "TECTIBRANCHS": "TECTIBRANCH, any member of the Tectibranchiata, molluscs including sea-slugs [n]\n",
  "TECTIFORM": "shaped like a roof [adj]\n",
  "TECTITE": "a type of small glassy stone, thought to be a product of meteorite impact, also TEKTITE [n -S]\n",
  "TECTITES": "TECTITE, a type of small glassy stone, thought to be a product of meteorite impact, also TEKTITE [n]\n",
  "TECTONIC": "relating to structural changes in the earth's crust caused by upheavals and other movements within it [adj TECTONICALLY]\n",
  "TECTONICALLY": "TECTONIC, relating to structural changes in the earth's crust caused by upheavals and other movements within it [adv]\n",
  "TECTONICS": "the science of structure of objects, buildings and landforms [n]\n",
  "TECTONISM": "tectonics [n -S]\n",
  "TECTONISMS": "TECTONISM, tectonics [n]\n",
  "TECTORIAL": "covering, e.g. a tectorial membrane [adj]\n",
  "TECTRICES": "TECTRIX, (Latin) one of the coverts (feathers covering the main feathers) of a bird's wing [n]\n",
  "TECTRICIAL": "of or like a tectrix, one of the coverts (feathers covering the main feathers) of a bird's wing [adj]\n",
  "TECTRIX": "(Latin) one of the coverts (feathers covering the main feathers) of a bird's wing [n TECTRICES]\n",
  "TECTUM": "(Latin) a rooflike body structure, esp. the dorsal part of the midbrain [n TECTA or TECTUMS]\n",
  "TECTUMS": "TECTUM, (Latin) a rooflike body structure, esp. the dorsal part of the midbrain [n]\n",
  "TED": "to spread hay for drying [v TEDDED, TEDDING, TEDS]\n",
  "TEDDED": "TED, to spread hay for drying [v]\n",
  "TEDDER": "a machine for tedding hay [n -S] / to use such a machine [v -ED, -ING, -S]\n",
  "TEDDERED": "TEDDER, to use such a machine [v]\n",
  "TEDDERING": "TEDDER, to use such a machine [v]\n",
  "TEDDERS": "TEDDER, to use such a machine [v]\n",
  "TEDDIE": "an item of woman's underwear, also TEDDY [n -S]\n",
  "TEDDIES": "TEDDIE, an item of woman's underwear, also TEDDY [n]\n",
  "TEDDING": "TED, to spread hay for drying [v]\n",
  "TEDDY": "a one-piece undergarment for a woman, also TEDDIE [n TEDDIES]\n",
  "TEDIER": "TEDY, (Scott) tedious [adj]\n",
  "TEDIEST": "TEDY, (Scott) tedious [adj]\n",
  "TEDIOSITIES": "TEDIOSITY, tediousness [n]\n",
  "TEDIOSITY": "tediousness [n TEDIOSITIES]\n",
  "TEDIOUS": "causing weariness [adj TEDIOUSLY]\n",
  "TEDIOUSLY": "TEDIOUS, causing weariness [adv]\n",
  "TEDIOUSNESS": "the state of being tedious [n -ES]\n",
  "TEDIOUSNESSES": "TEDIOUSNESS, the state of being tedious [n]\n",
  "TEDIOUSOME": "(Scots) tedious, also TEDISOME [adj]\n",
  "TEDISOME": "(Scots) tedious, also TEDIOUSOME [adj]\n",
  "TEDIUM": "(Latin) the state of being tedious, also TAEDIUM [n -S]\n",
  "TEDIUMS": "TEDIUM, (Latin) the state of being tedious, also TAEDIUM [n]\n",
  "TEDS": "TED, to spread hay for drying [v]\n",
  "TEDY": "(Scott) tedious [adj TEDIER, TEDIEST]\n",
  "TEE": "to place a golf ball on a small peg [v TEED, TEEING, TEES]\n",
  "TEED": "TEE, to place a golf ball on a small peg [v]\n",
  "TEEING": "TEE, to place a golf ball on a small peg [v]\n",
  "TEEK": "(Hinglish) well [adj]\n",
  "TEEL": "the sesame plant, also TIL [n -S]\n",
  "TEELS": "TEEL, the sesame plant, also TIL [n]\n",
  "TEEM": "to be full to overflowing [v -ED, -ING, -S]\n",
  "TEEMED": "TEEM, to be full to overflowing [v]\n",
  "TEEMER": "one who teems, or brings forth [n -S]\n",
  "TEEMERS": "TEEMER, one who teems, or brings forth [n]\n",
  "TEEMFUL": "pregnant; prolific [adj]\n",
  "TEEMING": "TEEM, to be full to overflowing [v]\n",
  "TEEMINGLY": "TEEMING, TEEM, to be full to overflowing [adv]\n",
  "TEEMINGNESS": "the state of being teeming [n -ES]\n",
  "TEEMINGNESSES": "TEEMINGNESS, the state of being teeming [n]\n",
  "TEEMLESS": "not fruitful or prolific, barren [adj]\n",
  "TEEMS": "TEEM, to be full to overflowing [v]\n",
  "TEEN": "(obsolete) to injure [v TEENED, TEENING, TEENS]\n",
  "TEENAGE": "the age between 13 and 20 [n -S]\n",
  "TEENAGED": "teenage [adj]\n",
  "TEENAGER": "a person between the ages of thirteen and nineteen, also TEENER [n -S]\n",
  "TEENAGERS": "TEENAGER, a person between the ages of thirteen and nineteen, also TEENER [n]\n",
  "TEENAGES": "TEENAGE, the age between 13 and 20 [n]\n",
  "TEEND": "to kindle, burn, also TIND [v -ED, -ING, -S]\n",
  "TEENDED": "TEEND, to kindle, burn, also TIND [v]\n",
  "TEENDING": "TEEND, to kindle, burn, also TIND [v]\n",
  "TEENDOM": "teenagers collectively [n -S]\n",
  "TEENDOMS": "TEENDOM, teenagers collectively [n]\n",
  "TEENDS": "TEEND, to kindle, burn, also TIND [v]\n",
  "TEENE": "(archaic) injury, pain, also TEEN, TENE [n -S]\n",
  "TEENED": "TEEN, (obsolete) to injure [v]\n",
  "TEENER": "a teenager [n -S]\n",
  "TEENERS": "TEENER, a teenager [n]\n",
  "TEENES": "TEENE, (archaic) injury, pain, also TEEN, TENE [n]\n",
  "TEENFUL": "filled with grief [adj]\n",
  "TEENIER": "TEENY, (colloquial) very small, also TEENSY, TEENTSY, TEENTY [adj]\n",
  "TEENIEST": "TEENY, (colloquial) very small, also TEENSY, TEENTSY, TEENTY [adj]\n",
  "TEENING": "TEEN, (obsolete) to injure [v]\n",
  "TEENS": "TEEN, (obsolete) to injure [v]\n",
  "TEENSIER": "TEENSY, (colloquial) very small, also TEENTSY, TEENTY, TEENY [adj]\n",
  "TEENSIEST": "TEENSY, (colloquial) very small, also TEENTSY, TEENTY, TEENY [adj]\n",
  "TEENSY": "(colloquial) very small, also TEENTSY, TEENTY, TEENY [adj TEENSIER, TEENSIEST]\n",
  "TEENTIER": "TEENTY, (colloquial) very small, also TEENSY, TEENTSY, TEENY [adj]\n",
  "TEENTIEST": "TEENTY, (colloquial) very small, also TEENSY, TEENTSY, TEENY [adj]\n",
  "TEENTSIER": "TEENTSY, (colloquial) very small, also TEENSY, TEENTY, TEENY [adj]\n",
  "TEENTSIEST": "TEENTSY, (colloquial) very small, also TEENSY, TEENTY, TEENY [adj]\n",
  "TEENTSY": "(colloquial) very small, also TEENSY, TEENTY, TEENY [adj TEENTSIER, TEENTSIEST]\n",
  "TEENTY": "(colloquial) very small, also TEENSY, TEENTSY, TEENY [adj TEENTIER, TEENTIEST]\n",
  "TEENY": "(colloquial) very small, also TEENSY, TEENTSY, TEENTY [adj TEENIER, TEENIEST]\n",
  "TEENYBOP": "pertaining to a young teenager [adj]\n",
  "TEENYBOPPER": "a teenage girl [n -S]\n",
  "TEENYBOPPERS": "TEENYBOPPER, a teenage girl [n]\n",
  "TEEPEE": "(Native American) a conical tent of the North American Indians, also TEPEE, TIPI [n -S]\n",
  "TEEPEES": "TEEPEE, (Native American) a conical tent of the North American Indians, also TEPEE, TIPI [n]\n",
  "TEER": "to daub, plaster [v -ED, -ING, -S]\n",
  "TEERED": "TEER, to daub, plaster [v]\n",
  "TEERING": "TEER, to daub, plaster [v]\n",
  "TEERS": "TEER, to daub, plaster [v]\n",
  "TEES": "TEE, to place a golf ball on a small peg [v]\n",
  "TEETER": "to move unsteadily [v -ED, -ING, -S]\n",
  "TEETERBOARD": "a seesaw; a board which throws one into the air when someone else jumps on the other end of it [n -S]\n",
  "TEETERBOARDS": "TEETERBOARD, a seesaw; a board which throws one into the air when someone else jumps on the other end of it [n]\n",
  "TEETERED": "TEETER, to move unsteadily [v]\n",
  "TEETERING": "TEETER, to move unsteadily [v]\n",
  "TEETERS": "TEETER, to move unsteadily [v]\n",
  "TEETH": "TOOTH, one of the hard bone-like enamel-coated structures embedded in the jawbones [n]\n",
  "TEETHE": "to cut teeth [v TEETHED, TEETHING, TEETHES]\n",
  "TEETHED": "TEETHE, to cut teeth [v]\n",
  "TEETHER": "an article that a baby bites on during teething [n -S]\n",
  "TEETHERS": "TEETHER, an article that a baby bites on during teething [n]\n",
  "TEETHES": "TEETHE, to cut teeth [v]\n",
  "TEETHING": "the first growth of teeth [n -S]\n",
  "TEETHINGS": "TEETHING, the first growth of teeth [n]\n",
  "TEETHLESS": "without teeth [adj]\n",
  "TEETHRIDGE": "the inner surface of the gums of the upper front teeth [n -S]\n",
  "TEETHRIDGES": "TEETHRIDGE, the inner surface of the gums of the upper front teeth [n]\n",
  "TEETOTAL": "abstaining from alcohol [adj TEETOTALLY] / to practise or advocate teetotalism [v TEETOTALED or TEETOTALLED, TEETOTALING or TEETOTALLING, TEETOTALS]\n",
  "TEETOTALED": "TEETOTAL, to practise or advocate teetotalism [v]\n",
  "TEETOTALER": "one who does not drink alcohol, also TEETOTALIST, TEETOTALLER [n -S]\n",
  "TEETOTALERS": "TEETOTALER, one who does not drink alcohol, also TEETOTALIST, TEETOTALLER [n]\n",
  "TEETOTALING": "TEETOTAL, to practise or advocate teetotalism [v]\n",
  "TEETOTALISM": "the principle or practice of complete abstinence from alcoholic drinks [n -S]\n",
  "TEETOTALISMS": "TEETOTALISM, the principle or practice of complete abstinence from alcoholic drinks [n]\n",
  "TEETOTALIST": "one who does not drink alcohol, also TEETOTALER, TEETOTALLER [n -S]\n",
  "TEETOTALISTS": "TEETOTALIST, one who does not drink alcohol, also TEETOTALER, TEETOTALLER [n]\n",
  "TEETOTALLED": "TEETOTAL, to practise or advocate teetotalism [v]\n",
  "TEETOTALLER": "one who does not drink alcohol, also TEETOTALER, TEETOTALIST [n -S]\n",
  "TEETOTALLERS": "TEETOTALLER, one who does not drink alcohol, also TEETOTALER, TEETOTALIST [n]\n",
  "TEETOTALLING": "TEETOTAL, to practise or advocate teetotalism [v]\n",
  "TEETOTALLY": "TEETOTAL, abstaining from alcohol [adv]\n",
  "TEETOTALS": "TEETOTAL, to practise or advocate teetotalism [v]\n",
  "TEETOTUM": "(historical) a child's toy, somewhat resembling a top, and twirled by the fingers, also TETOTUM [n -S]\n",
  "TEETOTUMS": "TEETOTUM, (historical) a child's toy, somewhat resembling a top, and twirled by the fingers, also TETOTUM [n]\n",
  "TEEVEE": "(colloquial) television [n -S]\n",
  "TEEVEES": "TEEVEE, (colloquial) television [n]\n",
  "TEF": "(Amharic) a kind of cereal grass, also TEFF [n -S]\n",
  "TEFF": "(Amharic) a kind of cereal grass, also TEF [n -S]\n",
  "TEFFS": "TEFF, (Amharic) a kind of cereal grass, also TEF [n]\n",
  "TEFILLAH": "(Hebrew) a phylactery worn by Jews, also TEPHILLAH [n TEFILLIN]\n",
  "TEFILLIN": "TEFILLAH, (Hebrew) a phylactery worn by Jews, also TEPHILLAH [n]\n",
  "TEFLON": "(tradename) a nonstick surface used in cooking utensils [n -S]\n",
  "TEFLONS": "TEFLON, (tradename) a nonstick surface used in cooking utensils [n]\n",
  "TEFS": "TEF, (Amharic) a kind of cereal grass, also TEFF [n]\n",
  "TEG": "a sheep in its second year, also TEGG [n -S]\n",
  "TEGG": "a sheep in its second year, also TEG [n -S]\n",
  "TEGGS": "TEGG, a sheep in its second year, also TEG [n]\n",
  "TEGMEN": "(Latin) the inner covering of a seed, also TEGUMEN [n TEGMINA]\n",
  "TEGMENTA": "TEGMENTUM, (Latin) a scale protecting a bud [n]\n",
  "TEGMENTAL": "relating to tegmenta, bud-scales [adj]\n",
  "TEGMENTUM": "(Latin) a scale protecting a bud [n TEGMENTA]\n",
  "TEGMINA": "TEGMEN, (Latin) the inner covering of a seed, also TEGUMEN [n]\n",
  "TEGMINAL": "relating to a tegmen, the inner covering of a seed [adj]\n",
  "TEGS": "TEG, a sheep in its second year, also TEGG [n]\n",
  "TEGU": "(Aztec) a large black and yellow South American lizard, also TEGUEXIN [n -S]\n",
  "TEGUA": "an ankle-high moccasin worn by Mexican and Indians [n -S]\n",
  "TEGUAS": "TEGUA, an ankle-high moccasin worn by Mexican and Indians [n]\n",
  "TEGUEXIN": "(Aztec) a large black and yellow South American lizard, also TEGU [n -S]\n",
  "TEGUEXINS": "TEGUEXIN, (Aztec) a large black and yellow South American lizard, also TEGU [n]\n",
  "TEGULA": "(Latin) a scale on the wings of insects [n TEGULAE]\n",
  "TEGULAE": "TEGULA, (Latin) a scale on the wings of insects [n]\n",
  "TEGULAR": "Overlapping like tiles or slates [adj TEGULARLY]\n",
  "TEGULARLY": "TEGULAR, Overlapping like tiles or slates [adv]\n",
  "TEGULATED": "composed of plates overlapping like tiles [adj]\n",
  "TEGUMEN": "(Latin) the inner covering of a seed, also TEGMEN [n TEGUMINA]\n",
  "TEGUMENT": "the natural covering of an animal or plant body [n -S]\n",
  "TEGUMENTAL": "of or like a tegument, also TEGUMENTARY [adj]\n",
  "TEGUMENTARY": "of or like a tegument, also TEGUMENTAL [adj]\n",
  "TEGUMENTS": "TEGUMENT, the natural covering of an animal or plant body [n]\n",
  "TEGUMINA": "TEGUMEN, (Latin) the inner covering of a seed, also TEGMEN [n]\n",
  "TEGUS": "TEGU, (Aztec) a large black and yellow South American lizard, also TEGUEXIN [n]\n",
  "TEHR": "a Himalayan wild goat, also TAHR [n -S]\n",
  "TEHRS": "TEHR, a Himalayan wild goat, also TAHR [n]\n",
  "TEHSIL": "(Hindi) in India, a division of a district for revenue and certain other purposes, also TAHSIL [n -S]\n",
  "TEHSILDAR": "(Hindi) one who administrates a tehsil [n -S]\n",
  "TEHSILDARS": "TEHSILDAR, (Hindi) one who administrates a tehsil [n]\n",
  "TEHSILS": "TEHSIL, (Hindi) in India, a division of a district for revenue and certain other purposes, also TAHSIL [n]\n",
  "TEICHOPSIA": "visual blurring and colours associated with migraines [n -S]\n",
  "TEICHOPSIAS": "TEICHOPSIA, visual blurring and colours associated with migraines [n]\n",
  "TEIGLACH": "(Yiddish) small, fruit- or nut-filled pastries, dipped in honey, also TAIGLACH [n]\n",
  "TEIID": "a tropical American lizard [n -S]\n",
  "TEIIDS": "TEIID, a tropical American lizard [n]\n",
  "TEIL": "(Biblical) an oaklike hardwood tree, the terebinth, which when cut exudes a fragrant resinous juice [n -S]\n",
  "TEILS": "TEIL, (Biblical) an oaklike hardwood tree, the terebinth, which when cut exudes a fragrant resinous juice [n]\n",
  "TEIN": "a monetary unit of Kazakhstan, equal to one hundredth of a tenge [n -S]\n",
  "TEIND": "(Scots) to assess or take a tithe on [v -ED, -ING, -S]\n",
  "TEINDED": "TEIND, (Scots) to assess or take a tithe on [v]\n",
  "TEINDING": "TEIND, (Scots) to assess or take a tithe on [v]\n",
  "TEINDS": "TEIND, (Scots) to assess or take a tithe on [v]\n",
  "TEINOSCOPE": "(obsolete) a prism telescope [n -S]\n",
  "TEINOSCOPES": "TEINOSCOPE, (obsolete) a prism telescope [n]\n",
  "TEINS": "TEIN, a monetary unit of Kazakhstan, equal to one hundredth of a tenge [n]\n",
  "TEKKIE": "an expert in or enthusiast for technology, also TECHIE [n -S]\n",
  "TEKKIES": "TEKKIE, an expert in or enthusiast for technology, also TECHIE [n]\n",
  "TEKNONYMIES": "TEKNONYMY, the naming of the parent after the child [n]\n",
  "TEKNONYMOUS": "relating to teknonymy, the naming of the parent after the child [adj]\n",
  "TEKNONYMY": "the naming of the parent after the child [n TEKNONYMIES]\n",
  "TEKTITE": "a type of small glassy stone, thought to be a product of meteorite impact, also TECTITE [n -S]\n",
  "TEKTITES": "TEKTITE, a type of small glassy stone, thought to be a product of meteorite impact, also TECTITE [n]\n",
  "TEKTITIC": "relating to a tektite, a type of small glassy stone [adj]\n",
  "TEL": "in Arab lands, a hill or ancient mound formed from the accumulated debris from earlier mud or wattle habitations [n -S]\n",
  "TELA": "(Latin) a weblike structure [n TELAE]\n",
  "TELAE": "TELA, (Latin) a weblike structure [n]\n",
  "TELAESTHESIA": "the perception of events or objects not actually present or near, also TELESTHESIA [n -S]\n",
  "TELAESTHESIAS": "TELAESTHESIA, the perception of events or objects not actually present or near, also TELESTHESIA [n]\n",
  "TELAESTHETIC": "relating to telaesthesia, the perception of events or objects not actually present or near, also TELESTHETIC [adj]\n",
  "TELAMON": "(Greek) a draped male figure used like a caryatid as a supporting column or pilaster [n TELAMONES or TELAMONS]\n",
  "TELAMONES": "TELAMON, (Greek) a draped male figure used like a caryatid as a supporting column or pilaster [n]\n",
  "TELAMONS": "TELAMON, (Greek) a draped male figure used like a caryatid as a supporting column or pilaster [n]\n",
  "TELANGIECTASES": "TELANGIECTASIS, dilatation of the small arteries or capillaries [n]\n",
  "TELANGIECTASIA": "an abnormal dilation of red, blue, or purple superficial capillaries, arterioles, or venules typically localized just below the skin's surface [n -S]\n",
  "TELANGIECTASIAS": "TELANGIECTASIA, an abnormal dilation of red, blue, or purple superficial capillaries, arterioles, or venules typically localized just below the skin's surface [n]\n",
  "TELANGIECTASIS": "dilatation of the small arteries or capillaries [n TELANGIECTASES]\n",
  "TELANGIECTATIC": "relating to telangiectasia [adj]\n",
  "TELARY": "web-spinning [adj]\n",
  "TELAUTOGRAPHIC": "relating to telautography [adj]\n",
  "TELAUTOGRAPHIES": "TELAUTOGRAPHY, transmission by use of a Telautograph, a telegraph for reproducing the movement of a pen or pencil and so transmitting writings or drawings [n]\n",
  "TELAUTOGRAPHY": "transmission by use of a Telautograph, a telegraph for reproducing the movement of a pen or pencil and so transmitting writings or drawings [n TELAUTOGRAPHIES]\n",
  "TELCO": "(short for) a telecommunications company [n -S]\n",
  "TELCOS": "TELCO, (short for) a telecommunications company [n]\n",
  "TELD": "TELL, to inform [v]\n",
  "TELE": "(short for) television, also TELLY [n -S]\n",
  "TELEARCHICS": "control of mechanical devices remotely, either by radio (as of ships and aircraft), by sound waves, or by beams of light, also TELECONTROL [n]\n",
  "TELEBANKING": "an electronic banking service accessed by telephone [n -S]\n",
  "TELEBANKINGS": "TELEBANKING, an electronic banking service accessed by telephone [n]\n",
  "TELEBRIDGE": "a television broadcast of a discussion between studio audiences in different countries linked by satellite [n -S]\n",
  "TELEBRIDGES": "TELEBRIDGE, a television broadcast of a discussion between studio audiences in different countries linked by satellite [n]\n",
  "TELECAMERA": "a television camera [n -S]\n",
  "TELECAMERAS": "TELECAMERA, a television camera [n]\n",
  "TELECAST": "to broadcast by television [v -ED, -ING, -S]\n",
  "TELECASTED": "TELECAST, to broadcast by television [v]\n",
  "TELECASTER": "one who telecasts [n -S]\n",
  "TELECASTERS": "TELECASTER, one who telecasts [n]\n",
  "TELECASTING": "TELECAST, to broadcast by television [v]\n",
  "TELECASTS": "TELECAST, to broadcast by television [v]\n",
  "TELECHIR": "a form of robot controlled by telecommand [n -S]\n",
  "TELECHIRIC": "of or like a telechir, a form of robot controlled by telecommand [adj]\n",
  "TELECHIRS": "TELECHIR, a form of robot controlled by telecommand [n]\n",
  "TELECINE": "the transmission of filmed material by television [n -S]\n",
  "TELECINES": "TELECINE, the transmission of filmed material by television [n]\n",
  "TELECOM": "(short for) telecommunications, also TELECOMM [n -S]\n",
  "TELECOMM": "(short for) telecommunication, also TELECOM [n -S]\n",
  "TELECOMMAND": "the operation of machinery by remote electronic control [n -S]\n",
  "TELECOMMANDS": "TELECOMMAND, the operation of machinery by remote electronic control [n]\n",
  "TELECOMMS": "TELECOMM, (short for) telecommunication, also TELECOM [n]\n",
  "TELECOMMUTE": "to work at home by the use of an electronic linkup with a central office [v TELECOMMUTED, TELECOMMUTING, TELECOMMUTES]\n",
  "TELECOMMUTED": "TELECOMMUTE, to work at home by the use of an electronic linkup with a central office [v]\n",
  "TELECOMMUTER": "one who telecommutes [n -S]\n",
  "TELECOMMUTERS": "TELECOMMUTER, one who telecommutes [n]\n",
  "TELECOMMUTES": "TELECOMMUTE, to work at home by the use of an electronic linkup with a central office [v]\n",
  "TELECOMMUTING": "working at home by the use of an electronic linkup with a central office [n -S]\n",
  "TELECOMMUTINGS": "TELECOMMUTING, working at home by the use of an electronic linkup with a central office [n]\n",
  "TELECOMS": "TELECOM, (short for) telecommunications, also TELECOMM [n]\n",
  "TELECON": "(short for) teleconference [n -S]\n",
  "TELECONFERENCE": "a meeting between people physically separated but linked by video, audio and/or computer facilities [n -S]\n",
  "TELECONFERENCES": "TELECONFERENCE, a meeting between people physically separated but linked by video, audio and/or computer facilities [n]\n",
  "TELECONNECTION": "connection by telephone line [n -S]\n",
  "TELECONNECTIONS": "TELECONNECTION, connection by telephone line [n]\n",
  "TELECONS": "TELECON, (short for) teleconference [n]\n",
  "TELECONTROL": "control of mechanical devices remotely, either by radio (as of ships and aircraft), by sound waves, or by beams of light, also TELEARCHICS [n -S]\n",
  "TELECONTROLS": "TELECONTROL, control of mechanical devices remotely, either by radio (as of ships and aircraft), by sound waves, or by beams of light, also TELEARCHICS [n]\n",
  "TELECONVERTER": "a supplementary lens system for converting a camera lens to a greater focal length [n -S]\n",
  "TELECONVERTERS": "TELECONVERTER, a supplementary lens system for converting a camera lens to a greater focal length [n]\n",
  "TELECOPIES": "TELECOPY, a message or document sent by fax [n]\n",
  "TELECOPY": "a message or document sent by fax [n TELECOPIES]\n",
  "TELECOTTAGE": "a building or room in a rural area with electronic equipment, services, etc. for teleworking, often shared by a number of local residents [n -S]\n",
  "TELECOTTAGES": "TELECOTTAGE, a building or room in a rural area with electronic equipment, services, etc. for teleworking, often shared by a number of local residents [n]\n",
  "TELECOTTAGING": "working from a telecottage [n -S]\n",
  "TELECOTTAGINGS": "TELECOTTAGING, working from a telecottage [n]\n",
  "TELECOURSE": "a course of study conducted over television [n -S]\n",
  "TELECOURSES": "TELECOURSE, a course of study conducted over television [n]\n",
  "TELEDILDONICS": "sexual activity available through computer networks or by means of virtual reality [n]\n",
  "TELEDU": "(Javanese) an East Indian carnivore allied to the badger, and noted for the very offensive odor that it emits [n -S]\n",
  "TELEDUS": "TELEDU, (Javanese) an East Indian carnivore allied to the badger, and noted for the very offensive odor that it emits [n]\n",
  "TELEFACSIMILE": "a facsimile [n -S]\n",
  "TELEFACSIMILES": "TELEFACSIMILE, a facsimile [n]\n",
  "TELEFAX": "to send by fax [v -ED, -ING, -ES]\n",
  "TELEFAXED": "TELEFAX, to send by fax [v]\n",
  "TELEFAXES": "TELEFAX, to send by fax [v]\n",
  "TELEFAXING": "TELEFAX, to send by fax [v]\n",
  "TELEFERIQUE": "(French) a cableway, also TELEPHERIQUE [n -S]\n",
  "TELEFERIQUES": "TELEFERIQUE, (French) a cableway, also TELEPHERIQUE [n]\n",
  "TELEFILM": "a motion picture made for television [n -S]\n",
  "TELEFILMS": "TELEFILM, a motion picture made for television [n]\n",
  "TELEGA": "(Russian) a four-wheeled springless wagon [n -S]\n",
  "TELEGAS": "TELEGA, (Russian) a four-wheeled springless wagon [n]\n",
  "TELEGENIC": "well-suited to the medium of television, esp. in having an appearance and manner that are markedly attractive to television viewers [adj TELEGENICALLY]\n",
  "TELEGENICALLY": "TELEGENIC, well-suited to the medium of television, esp. in having an appearance and manner that are markedly attractive to television viewers [adv]\n",
  "TELEGNOSES": "TELEGNOSIS, knowledge of events taking place far away [n]\n",
  "TELEGNOSIS": "knowledge of events taking place far away [n TELEGNOSES]\n",
  "TELEGNOSTIC": "relating to telegnosis, knowledge of events taking place far away [adj]\n",
  "TELEGONIC": "relating to telegony, the (imaginary) transmitted influence of a previous mate on the offspring of current one [adj]\n",
  "TELEGONIES": "TELEGONY, the influence of a prior mating on a future one with a new mate [n]\n",
  "TELEGONOUS": "relating to telegony, the (imaginary) transmitted influence of a previous mate on the offspring of current one [adj]\n",
  "TELEGONY": "the influence of a prior mating on a future one with a new mate [n TELEGONIES]\n",
  "TELEGRAM": "to send a message by telegraph [v TELEGRAMMED, TELEGRAMMING, TELEGRAMS]\n",
  "TELEGRAMMATIC": "like a telegram [adj]\n",
  "TELEGRAMMED": "TELEGRAM, to send a message by telegraph [v]\n",
  "TELEGRAMMIC": "of or like a telegram [adj]\n",
  "TELEGRAMMING": "TELEGRAM, to send a message by telegraph [v]\n",
  "TELEGRAMS": "TELEGRAM, to send a message by telegraph [v]\n",
  "TELEGRAPH": "to transmit by telegraph, a combination of apparatus for transmitting information to a distance [v -ED, -ING, -S]\n",
  "TELEGRAPHED": "TELEGRAPH, to transmit by telegraph, a combination of apparatus for transmitting information to a distance [v]\n",
  "TELEGRAPHER": "one who operates a telegraph [n -S]\n",
  "TELEGRAPHERS": "TELEGRAPHER, one who operates a telegraph [n]\n",
  "TELEGRAPHESE": "language characterized by the terseness and ellipses that are common in telegrams [n -S]\n",
  "TELEGRAPHESES": "TELEGRAPHESE, language characterized by the terseness and ellipses that are common in telegrams [n]\n",
  "TELEGRAPHIC": "of or relating to the telegraph [adj TELEGRAPHICALLY]\n",
  "TELEGRAPHICALLY": "TELEGRAPHIC, of or relating to the telegraph [adv]\n",
  "TELEGRAPHIES": "TELEGRAPHY, the use or operation of a telegraph apparatus or system for communication [n]\n",
  "TELEGRAPHING": "TELEGRAPH, to transmit by telegraph, a combination of apparatus for transmitting information to a distance [v]\n",
  "TELEGRAPHIST": "a person who works a telegraph [n -S]\n",
  "TELEGRAPHISTS": "TELEGRAPHIST, a person who works a telegraph [n]\n",
  "TELEGRAPHS": "TELEGRAPH, to transmit by telegraph, a combination of apparatus for transmitting information to a distance [v]\n",
  "TELEGRAPHY": "the use or operation of a telegraph apparatus or system for communication [n TELEGRAPHIES]\n",
  "TELEHEALTH": "the delivery of health related services and information via telecommunications technologies [n -S]\n",
  "TELEHEALTHS": "TELEHEALTH, the delivery of health related services and information via telecommunications technologies [n]\n",
  "TELEJOURNALISM": "journalism for television [n -S]\n",
  "TELEJOURNALISMS": "TELEJOURNALISM, journalism for television [n]\n",
  "TELEJOURNALIST": "a journalist working for television [n -S]\n",
  "TELEJOURNALISTS": "TELEJOURNALIST, a journalist working for television [n]\n",
  "TELEKINESES": "TELEKINESIS, the production of motion in objects (as by a spiritualistic medium) without contact or other physical means [n]\n",
  "TELEKINESIS": "the production of motion in objects (as by a spiritualistic medium) without contact or other physical means [n TELEKINESES]\n",
  "TELEKINETIC": "relating to telekinesis [adj TELEKINETICALLY]\n",
  "TELEKINETICALLY": "TELEKINETIC, relating to telekinesis [adv]\n",
  "TELEMAN": "a naval officer [n TELEMEN]\n",
  "TELEMARK": "(Norwegian) a type of turn in skiing [n -S] / to make this kind of skiing turn [v -ED, -ING, -S]\n",
  "TELEMARKED": "TELEMARK, to make this kind of skiing turn [v]\n",
  "TELEMARKETER": "one involved in telemarketing [n -S]\n",
  "TELEMARKETERS": "TELEMARKETER, one involved in telemarketing [n]\n",
  "TELEMARKETING": "the marketing of goods or services by telephone [n -S]\n",
  "TELEMARKETINGS": "TELEMARKETING, the marketing of goods or services by telephone [n]\n",
  "TELEMARKING": "TELEMARK, to make this kind of skiing turn [v]\n",
  "TELEMARKS": "TELEMARK, to make this kind of skiing turn [v]\n",
  "TELEMATIC": "relating to telematics, the transmission of computerized data over long distances [adj]\n",
  "TELEMATICS": "the transmission of computerized data over long distances [n]\n",
  "TELEMEDICINE": "medical treatment effected remotely [n -S]\n",
  "TELEMEDICINES": "TELEMEDICINE, medical treatment effected remotely [n]\n",
  "TELEMEETING": "a teleconference [n -S]\n",
  "TELEMEETINGS": "TELEMEETING, a teleconference [n]\n",
  "TELEMEN": "TELEMAN, a naval officer [n]\n",
  "TELEMESSAGE": "any of various messages sent by telephone or a telecommunication system, spec. a message sent by telephone or telex [n -S]\n",
  "TELEMESSAGES": "TELEMESSAGE, any of various messages sent by telephone or a telecommunication system, spec. a message sent by telephone or telex [n]\n",
  "TELEMETER": "to measure using a telemeter, an instrument for measuring strain or distance from observer [v -ED, -ING, -S]\n",
  "TELEMETERED": "TELEMETER, to measure using a telemeter, an instrument for measuring strain or distance from observer [v]\n",
  "TELEMETERING": "TELEMETER, to measure using a telemeter, an instrument for measuring strain or distance from observer [v]\n",
  "TELEMETERS": "TELEMETER, to measure using a telemeter, an instrument for measuring strain or distance from observer [v]\n",
  "TELEMETRIC": "relating to a telemeter [adj]\n",
  "TELEMETRICAL": "relating to telemetry [adj TELEMETRICALLY]\n",
  "TELEMETRICALLY": "TELEMETRICAL, relating to telemetry [adv]\n",
  "TELEMETRIES": "TELEMETRY, measurement using a telemeter, an instrument for measuring strain or distance from observer [n]\n",
  "TELEMETRY": "measurement using a telemeter, an instrument for measuring strain or distance from observer [n TELEMETRIES]\n",
  "TELENCEPHALA": "TELENCEPHALON, the anterior subdivision of the embryonic forebrain or corresponding part of the adult forebrain [n]\n",
  "TELENCEPHALIC": "relating to telencephalon [adj]\n",
  "TELENCEPHALON": "the anterior subdivision of the embryonic forebrain or corresponding part of the adult forebrain [n TELENCEPHALA or TELENCEPHALONS]\n",
  "TELENCEPHALONS": "TELENCEPHALON, the anterior subdivision of the embryonic forebrain or corresponding part of the adult forebrain [n]\n",
  "TELEOLOGIC": "exhibiting or relating to design or purpose esp. in nature, also TELEOLOGICAL [adj TELEOLOGICALLY]\n",
  "TELEOLOGICAL": "exhibiting or relating to design or purpose esp. in nature, also TELEOLOGIC [adj TELEOLOGICALLY]\n",
  "TELEOLOGICALLY": "TELEOLOGICAL, exhibiting or relating to design or purpose esp. in nature, also TELEOLOGIC [adv]\n",
  "TELEOLOGIES": "TELEOLOGY, the doctrine that final causes exist in nature [n]\n",
  "TELEOLOGISM": "belief in teleology [n -S]\n",
  "TELEOLOGISMS": "TELEOLOGISM, belief in teleology [n]\n",
  "TELEOLOGIST": "an adherent of teleology [n -S]\n",
  "TELEOLOGISTS": "TELEOLOGIST, an adherent of teleology [n]\n",
  "TELEOLOGY": "the doctrine that final causes exist in nature [n TELEOLOGIES]\n",
  "TELEONOMIC": "relating to teleonomy, the property of living systems of being organized towards the attainment of ends without true purposiveness [adj]\n",
  "TELEONOMIES": "TELEONOMY, the property of living systems of being organized towards the attainment of ends without true purposiveness [n]\n",
  "TELEONOMY": "the property of living systems of being organized towards the attainment of ends without true purposiveness [n TELEONOMIES]\n",
  "TELEOSAUR": "an extinct marine crocodile, having a slender snout and short front legs [n -S]\n",
  "TELEOSAURIAN": "a teleosaur, a member of a Jurassic genus of fossil crocodiles [n -S]\n",
  "TELEOSAURIANS": "TELEOSAURIAN, a teleosaur, a member of a Jurassic genus of fossil crocodiles [n]\n",
  "TELEOSAURS": "TELEOSAUR, an extinct marine crocodile, having a slender snout and short front legs [n]\n",
  "TELEOST": "a type of fish, having a bony skeleton and rayed fins, also TELEOSTEAN [n -S]\n",
  "TELEOSTEAN": "a type of fish, having a bony skeletons and rayed fins, also TELEOST [n -S]\n",
  "TELEOSTEANS": "TELEOSTEAN, a type of fish, having a bony skeletons and rayed fins, also TELEOST [n]\n",
  "TELEOSTOME": "a fish with membrane bones in the skull, jaws etc., as with any ordinary fish except skates and rays [n -S]\n",
  "TELEOSTOMES": "TELEOSTOME, a fish with membrane bones in the skull, jaws etc., as with any ordinary fish except skates and rays [n]\n",
  "TELEOSTOMOUS": "belonging to the Teleostomi, fishes with membrane bones in the skull [adj]\n",
  "TELEOSTS": "TELEOST, a type of fish, having a bony skeleton and rayed fins, also TELEOSTEAN [n]\n",
  "TELEPATH": "one who claims to be able to read other minds [n -S] / to read minds [v -ED, -ING, -S]\n",
  "TELEPATHED": "TELEPATH, to read minds [v]\n",
  "TELEPATHIC": "related to telepathy [adj TELEPATHICALLY]\n",
  "TELEPATHICALLY": "TELEPATHIC, related to telepathy [adv]\n",
  "TELEPATHIES": "TELEPATHY, mind-reading [n]\n",
  "TELEPATHING": "TELEPATH, to read minds [v]\n",
  "TELEPATHISE": "to communicate by telepathy, also TELEPATHIZE [v TELEPATHISED, TELEPATHISING, TELEPATHISES]\n",
  "TELEPATHISED": "TELEPATHISE, to communicate by telepathy, also TELEPATHIZE [v]\n",
  "TELEPATHISES": "TELEPATHISE, to communicate by telepathy, also TELEPATHIZE [v]\n",
  "TELEPATHISING": "TELEPATHISE, to communicate by telepathy, also TELEPATHIZE [v]\n",
  "TELEPATHIST": "one who practises telepathy [n -S]\n",
  "TELEPATHISTS": "TELEPATHIST, one who practises telepathy [n]\n",
  "TELEPATHIZE": "to communicate by telepathy, also TELEPATHISE [v TELEPATHIZED, TELEPATHIZING, TELEPATHIZES]\n",
  "TELEPATHIZED": "TELEPATHIZE, to communicate by telepathy, also TELEPATHISE [v]\n",
  "TELEPATHIZES": "TELEPATHIZE, to communicate by telepathy, also TELEPATHISE [v]\n",
  "TELEPATHIZING": "TELEPATHIZE, to communicate by telepathy, also TELEPATHISE [v]\n",
  "TELEPATHS": "TELEPATH, to read minds [v]\n",
  "TELEPATHY": "mind-reading [n TELEPATHIES]\n",
  "TELEPHEME": "a message by a telephone [n -S]\n",
  "TELEPHEMES": "TELEPHEME, a message by a telephone [n]\n",
  "TELEPHERIQUE": "(French) a cableway, also TELEFERIQUE [n -S]\n",
  "TELEPHERIQUES": "TELEPHERIQUE, (French) a cableway, also TELEFERIQUE [n]\n",
  "TELEPHONE": "an instrument for reproducing sound at a distance, esp. by means of electricity [n -S] / to contact someone by telephone [v TELEPHONED, TELEPHONING, TELEPHONES]\n",
  "TELEPHONED": "TELEPHONE, to contact someone by telephone [v]\n",
  "TELEPHONER": "one who telephones [n -S]\n",
  "TELEPHONERS": "TELEPHONER, one who telephones [n]\n",
  "TELEPHONES": "TELEPHONE, to contact someone by telephone [v]\n",
  "TELEPHONIC": "of, relating to, or conveyed by a telephone [adj TELEPHONICALLY]\n",
  "TELEPHONICALLY": "TELEPHONIC, of, relating to, or conveyed by a telephone [adv]\n",
  "TELEPHONIES": "TELEPHONY, the art or science of making telephones; the working or use of a telephone [n]\n",
  "TELEPHONING": "TELEPHONE, to contact someone by telephone [v]\n",
  "TELEPHONIST": "a telephone switchboard operator [n -S]\n",
  "TELEPHONISTS": "TELEPHONIST, a telephone switchboard operator [n]\n",
  "TELEPHONITIS": "excessive use of the telephone [n -ES]\n",
  "TELEPHONITISES": "TELEPHONITIS, excessive use of the telephone [n]\n",
  "TELEPHONY": "the art or science of making telephones; the working or use of a telephone [n TELEPHONIES]\n",
  "TELEPHOTO": "a photo taken through a long-distance lens [n -S]\n",
  "TELEPHOTOGRAPH": "a photograph of a distant object taken by a suitable lens [n -S]\n",
  "TELEPHOTOGRAPHS": "TELEPHOTOGRAPH, a photograph of a distant object taken by a suitable lens [n]\n",
  "TELEPHOTOGRAPHY": "the photography of distant objects (as by a camera provided with a telephoto lens) [n]\n",
  "TELEPHOTOS": "TELEPHOTO, a photo taken through a long-distance lens [n]\n",
  "TELEPIC": "a feature-length motion picture made for TV [n -S]\n",
  "TELEPICS": "TELEPIC, a feature-length motion picture made for TV [n]\n",
  "TELEPLAY": "a play written for television [n -S]\n",
  "TELEPLAYS": "TELEPLAY, a play written for television [n]\n",
  "TELEPOINT": "a device located in a public place that activates cordless phones [n -S]\n",
  "TELEPOINTS": "TELEPOINT, a device located in a public place that activates cordless phones [n]\n",
  "TELEPORT": "to transport by willpower or thought [v -ED, -ING, -S]\n",
  "TELEPORTATION": "the act of moving an object or person by psychokinesis [n -S]\n",
  "TELEPORTATIONS": "TELEPORTATION, the act of moving an object or person by psychokinesis [n]\n",
  "TELEPORTED": "TELEPORT, to transport by willpower or thought [v]\n",
  "TELEPORTING": "TELEPORT, to transport by willpower or thought [v]\n",
  "TELEPORTS": "TELEPORT, to transport by willpower or thought [v]\n",
  "TELEPRESENCE": "the use of virtual reality to create the illusion of being at a different or imaginary location [n -S]\n",
  "TELEPRESENCES": "TELEPRESENCE, the use of virtual reality to create the illusion of being at a different or imaginary location [n]\n",
  "TELEPRINT": "to print out (a message) using a teleprinter [v -ED, -ING, -S]\n",
  "TELEPRINTED": "TELEPRINT, to print out (a message) using a teleprinter [v]\n",
  "TELEPRINTER": "a device capable of producing hard copy from signals received over a communications circuit [n -S]\n",
  "TELEPRINTERS": "TELEPRINTER, a device capable of producing hard copy from signals received over a communications circuit [n]\n",
  "TELEPRINTING": "TELEPRINT, to print out (a message) using a teleprinter [v]\n",
  "TELEPRINTS": "TELEPRINT, to print out (a message) using a teleprinter [v]\n",
  "TELEPROCESSING": "remote-controlled computer processing [n -S]\n",
  "TELEPROCESSINGS": "TELEPROCESSING, remote-controlled computer processing [n]\n",
  "TELERAN": "(trademark) an air-traffic control system, in which ground based radar screen is televised to pilots [n -S]\n",
  "TELERANS": "TELERAN, (trademark) an air-traffic control system, in which ground based radar screen is televised to pilots [n]\n",
  "TELERECORD": "to make a telerecording, a recording for broadcast by television [v -ED, -ING, -S]\n",
  "TELERECORDED": "TELERECORD, to make a telerecording, a recording for broadcast by television [v]\n",
  "TELERECORDING": "a recording for broadcast by television [n -S]\n",
  "TELERECORDINGS": "TELERECORDING, a recording for broadcast by television [n]\n",
  "TELERECORDS": "TELERECORD, to make a telerecording, a recording for broadcast by television [v]\n",
  "TELERGIC": "working at a distance as in telepathy [adj TELERGICALLY]\n",
  "TELERGICALLY": "TELERGIC, working at a distance as in telepathy [adv]\n",
  "TELERGIES": "TELERGY, a physical force in telepathy [n]\n",
  "TELERGY": "a physical force in telepathy [n TELERGIES]\n",
  "TELEROBOT": "a robot under continuous human control), for example as used to perform a task in an area unsafe for the human operator such as in nuclear decommissioning [n -S]\n",
  "TELEROBOTS": "TELEROBOT, a robot under continuous human control), for example as used to perform a task in an area unsafe for the human operator such as in nuclear decommissioning [n]\n",
  "TELES": "TELE, (short for) television, also TELLY [n]\n",
  "TELESALE": "a sale made on the telephone [n -S]\n",
  "TELESALES": "TELESALE, a sale made on the telephone [n]\n",
  "TELESCIENCE": "the performing of scientific experiments at a distance, controlled remotely by the experimenter [n -S]\n",
  "TELESCIENCES": "TELESCIENCE, the performing of scientific experiments at a distance, controlled remotely by the experimenter [n]\n",
  "TELESCOPE": "an optical instrument for viewing objects at a distance [n -S] / to collapse part within part, like a telescope [v TELESCOPED, TELESCOPING, TELESCOPES]\n",
  "TELESCOPED": "TELESCOPE, to collapse part within part, like a telescope [v]\n",
  "TELESCOPES": "TELESCOPE, to collapse part within part, like a telescope [v]\n",
  "TELESCOPIC": "of, relating to, or performed with a telescope, also TELESCOPICAL [adj TELESCOPICALLY]\n",
  "TELESCOPICAL": "of, relating to, or performed with a telescope, also TELESCOPIC [adj TELESCOPICALLY]\n",
  "TELESCOPICALLY": "TELESCOPICAL, of, relating to, or performed with a telescope, also TELESCOPIC [adv]\n",
  "TELESCOPIES": "TELESCOPY, the art or practice of using or making telescopes [n]\n",
  "TELESCOPIFORM": "in the form of a telescope [adj]\n",
  "TELESCOPING": "TELESCOPE, to collapse part within part, like a telescope [v]\n",
  "TELESCOPIST": "a person who uses a telescope [n -S]\n",
  "TELESCOPISTS": "TELESCOPIST, a person who uses a telescope [n]\n",
  "TELESCOPY": "the art or practice of using or making telescopes [n TELESCOPIES]\n",
  "TELESCREEN": "a television screen [n -S]\n",
  "TELESCREENS": "TELESCREEN, a television screen [n]\n",
  "TELESELLING": "selling by telephone [n -S]\n",
  "TELESELLINGS": "TELESELLING, selling by telephone [n]\n",
  "TELESEME": "a signalling apparatus with an indicator [n -S]\n",
  "TELESEMES": "TELESEME, a signalling apparatus with an indicator [n]\n",
  "TELESERVICES": "information, etc. services available to users of teletext and viewdata systems [n]\n",
  "TELESES": "TELESIS, (Greek) planned progress [n]\n",
  "TELESHOP": "to shop by interactive telecommunications systems [v TELESHOPPED, TELESHOPPING, TELESHOPS]\n",
  "TELESHOPPED": "TELESHOP, to shop by interactive telecommunications systems [v]\n",
  "TELESHOPPING": "buying goods by telephone or the Internet [n -S]\n",
  "TELESHOPPINGS": "TELESHOPPING, buying goods by telephone or the Internet [n]\n",
  "TELESHOPS": "TELESHOP, to shop by interactive telecommunications systems [v]\n",
  "TELESIS": "(Greek) planned progress [n TELESES]\n",
  "TELESM": "(Greek) a talisman [n -S]\n",
  "TELESMATIC": "relating to a telesm, a talisman, also TELESMATICAL [adj TELESMATICALLY]\n",
  "TELESMATICAL": "relating to a telesm, a talisman, also TELESMATIC [adj TELESMATICALLY]\n",
  "TELESMATICALLY": "TELESMATICAL, relating to a telesm, a talisman, also TELESMATIC [adv]\n",
  "TELESMS": "TELESM, (Greek) a talisman [n]\n",
  "TELESOFTWARE": "software that is transmitted to users by means of a teletext or viewdata system [n -S]\n",
  "TELESOFTWARES": "TELESOFTWARE, software that is transmitted to users by means of a teletext or viewdata system [n]\n",
  "TELESTEREOSCOPE": "an instrument for viewing distant objects stereoscopically [n]\n",
  "TELESTHESIA": "the perception of events or objects not actually present or near, also TELAESTHESIA [n -S]\n",
  "TELESTHESIAS": "TELESTHESIA, the perception of events or objects not actually present or near, also TELAESTHESIA [n]\n",
  "TELESTHETIC": "relating to telesthesia, also TELAESTHETIC [adj]\n",
  "TELESTIC": "a type of acrostic [n -S]\n",
  "TELESTICH": "a poem in which the consecutive final letters of the lines spell a name [n -S]\n",
  "TELESTICHS": "TELESTICH, a poem in which the consecutive final letters of the lines spell a name [n]\n",
  "TELESTICS": "TELESTIC, a type of acrostic [n]\n",
  "TELESURGERIES": "TELESURGERY, surgery carried out remotely [n]\n",
  "TELESURGERY": "surgery carried out remotely [n TELESURGERIES]\n",
  "TELETEX": "a means of transmitting written data, a more advanced form of telex [n -ES]\n",
  "TELETEXES": "TELETEX, a means of transmitting written data, a more advanced form of telex [n]\n",
  "TELETEXT": "a system by which an adapted television set is able to show alphanumeric information selected from displays transmitted using the spare capacity of existing television channels [n -S]\n",
  "TELETEXTS": "TELETEXT, a system by which an adapted television set is able to show alphanumeric information selected from displays transmitted using the spare capacity of existing television channels [n]\n",
  "TELETHON": "an exceptionally long television programme to raise money for a charity or cause [n -S]\n",
  "TELETHONS": "TELETHON, an exceptionally long television programme to raise money for a charity or cause [n]\n",
  "TELETRON": "a cathode-ray tube for synthesis of television images [n -S]\n",
  "TELETRONS": "TELETRON, a cathode-ray tube for synthesis of television images [n]\n",
  "TELETYPE": "(tradename) to send by teletypewriter [v TELETYPED, TELETYPING, TELETYPES]\n",
  "TELETYPED": "TELETYPE, (tradename) to send by teletypewriter [v]\n",
  "TELETYPES": "TELETYPE, (tradename) to send by teletypewriter [v]\n",
  "TELETYPESETTING": "typesetting by use of a Teletypesetter [n]\n",
  "TELETYPEWRITER": "a printing device resembling a typewriter that is used to send and receive telephonic signals [n -S]\n",
  "TELETYPEWRITERS": "TELETYPEWRITER, a printing device resembling a typewriter that is used to send and receive telephonic signals [n]\n",
  "TELETYPING": "TELETYPE, (tradename) to send by teletypewriter [v]\n",
  "TELEUTOSPORE": "a thick-walled winter spore of the rust fungi, producing a promycelium on germination [n -S]\n",
  "TELEUTOSPORES": "TELEUTOSPORE, a thick-walled winter spore of the rust fungi, producing a promycelium on germination [n]\n",
  "TELEUTOSPORIC": "of or like a teleutospore, a thick-walled winter spore of the rust fungi [adj]\n",
  "TELEVANGELICAL": "relating to televangelism, evangelism through the medium of television [adj]\n",
  "TELEVANGELISM": "evangelism through the medium of television [n -S]\n",
  "TELEVANGELISMS": "TELEVANGELISM, evangelism through the medium of television [n]\n",
  "TELEVANGELIST": "an evangelist who conducts regularly televised religious programs [n -S]\n",
  "TELEVANGELISTS": "TELEVANGELIST, an evangelist who conducts regularly televised religious programs [n]\n",
  "TELEVERITE": "the televising of scenes from actual life to give a sense of heightened realism [n -S]\n",
  "TELEVERITES": "TELEVERITE, the televising of scenes from actual life to give a sense of heightened realism [n]\n",
  "TELEVIEW": "to observe by means of television [v -ED, -ING, -S]\n",
  "TELEVIEWED": "TELEVIEW, to observe by means of television [v]\n",
  "TELEVIEWER": "one who views by television [n -S]\n",
  "TELEVIEWERS": "TELEVIEWER, one who views by television [n]\n",
  "TELEVIEWING": "the act of observing by means of television [n -S]\n",
  "TELEVIEWINGS": "TELEVIEWING, the act of observing by means of television [n]\n",
  "TELEVIEWS": "TELEVIEW, to observe by means of television [v]\n",
  "TELEVISE": "to broadcast by television [v TELEVISED, TELEVISING, TELEVISES]\n",
  "TELEVISED": "TELEVISE, to broadcast by television [v]\n",
  "TELEVISER": "one who televises [n -S]\n",
  "TELEVISERS": "TELEVISER, one who televises [n]\n",
  "TELEVISES": "TELEVISE, to broadcast by television [v]\n",
  "TELEVISING": "TELEVISE, to broadcast by television [v]\n",
  "TELEVISION": "the transmission by radio waves, and reproduction on a screen, of visual images, usually accompanied by sound [n -S]\n",
  "TELEVISIONAL": "relating to television, also TELEVISIONARY [adj TELEVISIONALLY]\n",
  "TELEVISIONALLY": "TELEVISIONAL, relating to television, also TELEVISIONARY [adv]\n",
  "TELEVISIONARY": "relating to television, also TELEVISIONAL [adj]\n",
  "TELEVISIONS": "TELEVISION, the transmission by radio waves, and reproduction on a screen, of visual images, usually accompanied by sound [n]\n",
  "TELEVISOR": "a receiver for television [n -S]\n",
  "TELEVISORS": "TELEVISOR, a receiver for television [n]\n",
  "TELEVISUAL": "of, relating to, or suitable for broadcast by television [adj TELEVISUALLY]\n",
  "TELEVISUALLY": "TELEVISUAL, of, relating to, or suitable for broadcast by television [adv]\n",
  "TELEWORK": "to work at home communicating with the office by telephone or computer [v -ED, -ING, -S]\n",
  "TELEWORKED": "TELEWORK, to work at home communicating with the office by telephone or computer [v]\n",
  "TELEWORKER": "a telecommuter [n -S]\n",
  "TELEWORKERS": "TELEWORKER, a telecommuter [n]\n",
  "TELEWORKING": "working from home via electronic links [n -S]\n",
  "TELEWORKINGS": "TELEWORKING, working from home via electronic links [n]\n",
  "TELEWORKS": "TELEWORK, to work at home communicating with the office by telephone or computer [v]\n",
  "TELEWRITER": "a telegraph instrument that reproduces handwriting [n -S]\n",
  "TELEWRITERS": "TELEWRITER, a telegraph instrument that reproduces handwriting [n]\n",
  "TELEX": "(tradename) to send a message by a type of telegraphic system [v -ED, -ING, -ES]\n",
  "TELEXED": "TELEX, (tradename) to send a message by a type of telegraphic system [v]\n",
  "TELEXES": "TELEX, (tradename) to send a message by a type of telegraphic system [v]\n",
  "TELEXING": "TELEX, (tradename) to send a message by a type of telegraphic system [v]\n",
  "TELFER": "to transport by a system of aerial cable cars, also TELPHER [v -ED, -ING, -S]\n",
  "TELFERAGE": "use of a telfer, a contrivance for the conveyance of vehicles or loads by means of electricity [n -S]\n",
  "TELFERAGES": "TELFERAGE, use of a telfer, a contrivance for the conveyance of vehicles or loads by means of electricity [n]\n",
  "TELFERED": "TELFER, to transport by a system of aerial cable cars, also TELPHER [v]\n",
  "TELFERIC": "relating to a telfer, a contrivance for the conveyance of vehicles or loads by means of electricity, also TELPHERIC [adj]\n",
  "TELFERING": "TELFER, to transport by a system of aerial cable cars, also TELPHER [v]\n",
  "TELFERS": "TELFER, to transport by a system of aerial cable cars, also TELPHER [v]\n",
  "TELFORD": "a road made of stones [n -S]\n",
  "TELFORDS": "TELFORD, a road made of stones [n]\n",
  "TELIA": "TELIUM, the cluster of spore cases of the rust fungi [n]\n",
  "TELIAL": "relating to a telium, a cluster of spore cases of the rust fungus [adj]\n",
  "TELIC": "directed or tending toward a goal or purpose [adj TELICALLY]\n",
  "TELICALLY": "TELIC, directed or tending toward a goal or purpose [adv]\n",
  "TELICITIES": "TELICITY, the quality of being telic, directed or tending toward a goal or purpose [n]\n",
  "TELICITY": "the quality of being telic, directed or tending toward a goal or purpose [n TELICITIES]\n",
  "TELIOSPORE": "the thick-walled resting spore of rusts and smuts from which the basidium arises [n -S]\n",
  "TELIOSPORES": "TELIOSPORE, the thick-walled resting spore of rusts and smuts from which the basidium arises [n]\n",
  "TELIUM": "the cluster of spore cases of the rust fungi [n TELIA]\n",
  "TELL": "to inform [v TOLD or (Scots) TELT or TAULD or (Spenser) TELD, TELLING, TELLS]\n",
  "TELLABLE": "able to be told [adj]\n",
  "TELLAR": "a sapling, a shoot from a tree-stump [n -S] / to produce such a shoot, also TELLER, TILLER [v -ED, -ING, -S]\n",
  "TELLARED": "TELLAR, to produce such a shoot, also TELLER, TILLER [v]\n",
  "TELLARING": "TELLAR, to produce such a shoot, also TELLER, TILLER [v]\n",
  "TELLARS": "TELLAR, to produce such a shoot, also TELLER, TILLER [v]\n",
  "TELLEN": "a kind of bivalve mollusc, also TELLIN [n -S]\n",
  "TELLENS": "TELLEN, a kind of bivalve mollusc, also TELLIN [n]\n",
  "TELLER": "a sapling, a shoot from a tree-stump [n -S] / to produce such a shoot, also TELLAR, TILLER [v -ED, -ING, -S]\n",
  "TELLERED": "TELLER, to produce such a shoot, also TELLAR, TILLER [v]\n",
  "TELLERING": "TELLER, to produce such a shoot, also TELLAR, TILLER [v]\n",
  "TELLERS": "TELLER, to produce such a shoot, also TELLAR, TILLER [v]\n",
  "TELLERSHIP": "the office or employment of a teller [n -S]\n",
  "TELLERSHIPS": "TELLERSHIP, the office or employment of a teller [n]\n",
  "TELLIES": "TELLY, (colloquial) television, also TELE [n]\n",
  "TELLIN": "a kind of bivalve mollusc, also TELLEN [n -S]\n",
  "TELLING": "effective; significant, meaningful [adj TELLINGLY] / the act of telling [n -S]\n",
  "TELLINGLY": "TELLING, effective; significant, meaningful [adv]\n",
  "TELLINGS": "TELLING, the act of telling [n]\n",
  "TELLINOID": "like a tellin, a kind of marine shell [adj]\n",
  "TELLINS": "TELLIN, a kind of bivalve mollusc, also TELLEN [n]\n",
  "TELLS": "TELL, to inform [v]\n",
  "TELLTALE": "a sneak, a talebearer [n -S]\n",
  "TELLTALES": "TELLTALE, a sneak, a talebearer [n]\n",
  "TELLURAL": "of or pertaining to the earth, also TELLURIC [adj]\n",
  "TELLURATE": "a salt of telluric acid [n -S]\n",
  "TELLURATES": "TELLURATE, a salt of telluric acid [n]\n",
  "TELLURETTED": "combined with tellurium [adj]\n",
  "TELLURIAN": "an apparatus representing earth and sun, showing day and night, the seasons etc., also TELLURION [n -S]\n",
  "TELLURIANS": "TELLURIAN, an apparatus representing earth and sun, showing day and night, the seasons etc., also TELLURION [n]\n",
  "TELLURIC": "of or pertaining to the earth, also TELLURAL [adj]\n",
  "TELLURIDE": "a compound of tellurium with a more positive element or radical [n -S]\n",
  "TELLURIDES": "TELLURIDE, a compound of tellurium with a more positive element or radical [n]\n",
  "TELLURION": "an apparatus representing earth and sun, showing day and night, the seasons etc., also TELLURIAN [n -S]\n",
  "TELLURIONS": "TELLURION, an apparatus representing earth and sun, showing day and night, the seasons etc., also TELLURIAN [n]\n",
  "TELLURISE": "to combine with tellurium, a rare nonmetallic element, also TELLURIZE [v TELLURISED, TELLURISING, TELLURISES]\n",
  "TELLURISED": "TELLURISE, to combine with tellurium, a rare nonmetallic element, also TELLURIZE [v]\n",
  "TELLURISES": "TELLURISE, to combine with tellurium, a rare nonmetallic element, also TELLURIZE [v]\n",
  "TELLURISING": "TELLURISE, to combine with tellurium, a rare nonmetallic element, also TELLURIZE [v]\n",
  "TELLURITE": "a salt of tellurous acid [n -S]\n",
  "TELLURITES": "TELLURITE, a salt of tellurous acid [n]\n",
  "TELLURIUM": "a rare chemical element, a silvery-white brittle metalloid resembling selenium [n -S]\n",
  "TELLURIUMS": "TELLURIUM, a rare chemical element, a silvery-white brittle metalloid resembling selenium [n]\n",
  "TELLURIZE": "to combine with tellurium, a rare nonmetallic element, also TELLURISE [v TELLURIZED, TELLURIZING, TELLURIZES]\n",
  "TELLURIZED": "TELLURIZE, to combine with tellurium, a rare nonmetallic element, also TELLURISE [v]\n",
  "TELLURIZES": "TELLURIZE, to combine with tellurium, a rare nonmetallic element, also TELLURISE [v]\n",
  "TELLURIZING": "TELLURIZE, to combine with tellurium, a rare nonmetallic element, also TELLURISE [v]\n",
  "TELLUROMETER": "an instrument using microwaves to measure distance [n -S]\n",
  "TELLUROMETERS": "TELLUROMETER, an instrument using microwaves to measure distance [n]\n",
  "TELLUROUS": "of or containing tellurium, esp. in a low oxidation state [adj]\n",
  "TELLUS": "(Latin) the earth, esp. personified as a goddess [n -ES]\n",
  "TELLUSES": "TELLUS, (Latin) the earth, esp. personified as a goddess [n]\n",
  "TELLY": "(colloquial) television, also TELE [n TELLIES or TELLYS]\n",
  "TELLYS": "TELLY, (colloquial) television, also TELE [n]\n",
  "TELNET": "to access a computer system remotely [v TELNETTED or TELNETED, TELNETTING or TELNETING, TELNETS]\n",
  "TELNETED": "TELNET, to access a computer system remotely [v]\n",
  "TELNETING": "TELNET, to access a computer system remotely [v]\n",
  "TELNETS": "TELNET, to access a computer system remotely [v]\n",
  "TELNETTED": "TELNET, to access a computer system remotely [v]\n",
  "TELNETTING": "TELNET, to access a computer system remotely [v]\n",
  "TELOCENTRIC": "of a chromosome, having the centromere at one end of the chromosome [adj] / a telocentric chromosome [n -S]\n",
  "TELOCENTRICS": "TELOCENTRIC, a telocentric chromosome [n]\n",
  "TELOGEN": "the phase in the hair growth cycle during which a new hair is formed in the follicle and a hair that has stopped growing is shed [n -S]\n",
  "TELOGENS": "TELOGEN, the phase in the hair growth cycle during which a new hair is formed in the follicle and a hair that has stopped growing is shed [n]\n",
  "TELOI": "TELOS, (Greek) an ultimate end [n]\n",
  "TELOME": "a structural unit of a vascular plant [n -S]\n",
  "TELOMERASE": "an enzyme, found in some cancer cells, that negates the actions of telomeres and enables rapid cell division [n -S]\n",
  "TELOMERASES": "TELOMERASE, an enzyme, found in some cancer cells, that negates the actions of telomeres and enables rapid cell division [n]\n",
  "TELOMERE": "a centromere that is located in a terminal position on a chromosome [n -S]\n",
  "TELOMERES": "TELOMERE, a centromere that is located in a terminal position on a chromosome [n]\n",
  "TELOMERISATION": "the process of making into a telomere, also TELOMERIZATION [n -S]\n",
  "TELOMERISATIONS": "TELOMERISATION, the process of making into a telomere, also TELOMERIZATION [n]\n",
  "TELOMERIZATION": "the process of making into a telomere, also TELOMERISATION [n -S]\n",
  "TELOMERIZATIONS": "TELOMERIZATION, the process of making into a telomere, also TELOMERISATION [n]\n",
  "TELOMES": "TELOME, a structural unit of a vascular plant [n]\n",
  "TELOMIC": "relating to a telome, the structural unit of a vascular plant [adj]\n",
  "TELOPHASE": "the last phase of mitosis in which the chromosomes of the daughter cells are grouped in separate nuclei [n -S]\n",
  "TELOPHASES": "TELOPHASE, the last phase of mitosis in which the chromosomes of the daughter cells are grouped in separate nuclei [n]\n",
  "TELOPHASIC": "relating to telophase, the last phase of mitosis in which the chromosomes of the daughter cells are grouped in separate nuclei [adj]\n",
  "TELOS": "(Greek) an ultimate end [n TELOI]\n",
  "TELOTAXES": "TELOTAXIS, a taxis by which an organism orients itself in respect to a stimulus [n]\n",
  "TELOTAXIS": "a taxis by which an organism orients itself in respect to a stimulus [n TELOTAXES]\n",
  "TELPHER": "to transport by a system of aerial cable cars, also TELFER [v -ED, -ING, -S]\n",
  "TELPHERAGE": "the conveyance of vehicles or loads by means of electricity, in buckets suspended from a cable [n -S]\n",
  "TELPHERAGES": "TELPHERAGE, the conveyance of vehicles or loads by means of electricity, in buckets suspended from a cable [n]\n",
  "TELPHERED": "TELPHER, to transport by a system of aerial cable cars, also TELFER [v]\n",
  "TELPHERIC": "relating to a telpher, a contrivance for the conveyance of vehicles or loads by means of electricity, also TELFERIC [adj]\n",
  "TELPHERING": "TELPHER, to transport by a system of aerial cable cars, also TELFER [v]\n",
  "TELPHERLINE": "a line bearing a telpher [n -S]\n",
  "TELPHERLINES": "TELPHERLINE, a line bearing a telpher [n]\n",
  "TELPHERMAN": "a man who works on a telpher system, a contrivance for the conveyance of vehicles or loads by means of electricity [n TELPHERMEN]\n",
  "TELPHERMEN": "TELPHERMAN, a man who works on a telpher system, a contrivance for the conveyance of vehicles or loads by means of electricity [n]\n",
  "TELPHERS": "TELPHER, to transport by a system of aerial cable cars, also TELFER [v]\n",
  "TELPHERWAY": "a route for the conveyance of vehicles or loads by telpher [n -S]\n",
  "TELPHERWAYS": "TELPHERWAY, a route for the conveyance of vehicles or loads by telpher [n]\n",
  "TELS": "TEL, in Arab lands, a hill or ancient mound formed from the accumulated debris from earlier mud or wattle habitations [n]\n",
  "TELSON": "(Greek) the terminal segment of an arthropod [n -S]\n",
  "TELSONIC": "relating to a telson, the last segment of the abdomen in many arthropods [adj]\n",
  "TELSONS": "TELSON, (Greek) the terminal segment of an arthropod [n]\n",
  "TELT": "TELL, to inform [v]\n",
  "TEMAZEPAM": "a drug used to treat insomnia [n -S]\n",
  "TEMAZEPAMS": "TEMAZEPAM, a drug used to treat insomnia [n]\n",
  "TEMBLOR": "(Spanish) an earthquake or earth tremor, also TREMBLOR [n TEMBLORS or TEMBLORES]\n",
  "TEMBLORES": "TEMBLOR, (Spanish) an earthquake or earth tremor, also TREMBLOR [n]\n",
  "TEMBLORS": "TEMBLOR, (Spanish) an earthquake or earth tremor, also TREMBLOR [n]\n",
  "TEME": "(obsolete) a team [n -S]\n",
  "TEMED": "(Spenser) brought together in a team [v]\n",
  "TEMENE": "TEMENOS, (Greek) a sacred precinct [n]\n",
  "TEMENOS": "(Greek) a sacred precinct [n TEMENE]\n",
  "TEMERARIOUS": "rashly or presumptuously daring, also TEMEROUS [adj TEMERARIOUSLY]\n",
  "TEMERARIOUSLY": "TEMERARIOUS, rashly or presumptuously daring, also TEMEROUS [adv]\n",
  "TEMERARIOUSNESS": "the state of being temerarious [n]\n",
  "TEMERITIES": "TEMERITY, foolish boldness [n]\n",
  "TEMERITY": "foolish boldness [n TEMERITIES]\n",
  "TEMEROUS": "rashly or presumptuously daring, also TEMERARIOUS [adj]\n",
  "TEMEROUSLY": "TEMEROUS, rashly or presumptuously daring, also TEMERARIOUS [adv]\n",
  "TEMES": "TEME, (obsolete) a team [n]\n",
  "TEMP": "to be employed as a temporary worker [v -ED, -ING, -S]\n",
  "TEMPED": "TEMP, to be employed as a temporary worker [v]\n",
  "TEMPEH": "a high-protein food prepared from soya beans [n -S]\n",
  "TEMPEHS": "TEMPEH, a high-protein food prepared from soya beans [n]\n",
  "TEMPER": "to moderate by adding a counterbalancing agent [v -ED, -ING, -S]\n",
  "TEMPERA": "(Italian) an emulsion, esp. made with egg yolk, used as a medium for powdering pigments [n -S]\n",
  "TEMPERABILITIES": "TEMPERABILITY, the quality of being temperable [n]\n",
  "TEMPERABILITY": "the quality of being temperable [n TEMPERABILITIES]\n",
  "TEMPERABLE": "capable of being tempered [adj]\n",
  "TEMPERALITIE": "(Shakespeare) Mistress Quickly's elaboration of temper, frame of mind [n -S]\n",
  "TEMPERALITIES": "TEMPERALITIE, (Shakespeare) Mistress Quickly's elaboration of temper, frame of mind [n]\n",
  "TEMPERAMENT": "disposition, personality, esp. with regard to emotional makeup [n -S]\n",
  "TEMPERAMENTAL": "relating to temperament [adj TEMPERAMENTALLY]\n",
  "TEMPERAMENTALLY": "TEMPERAMENTAL, relating to temperament [adv]\n",
  "TEMPERAMENTFUL": "full of temperament [adj]\n",
  "TEMPERAMENTS": "TEMPERAMENT, disposition, personality, esp. with regard to emotional makeup [n]\n",
  "TEMPERANCE": "moderation in action, thought, or feeling [n -S]\n",
  "TEMPERANCES": "TEMPERANCE, moderation in action, thought, or feeling [n]\n",
  "TEMPERAS": "TEMPERA, (Italian) an emulsion, esp. made with egg yolk, used as a medium for powdering pigments [n]\n",
  "TEMPERATE": "mild, moderate [adj TEMPERATELY] / to temper [v TEMPERATED, TEMPERATING, TEMPERATES]\n",
  "TEMPERATED": "TEMPERATE, to temper [v]\n",
  "TEMPERATELY": "TEMPERATE, mild, moderate [adv]\n",
  "TEMPERATENESS": "the state of being temperate [n -ES]\n",
  "TEMPERATENESSES": "TEMPERATENESS, the state of being temperate [n]\n",
  "TEMPERATES": "TEMPERATE, to temper [v]\n",
  "TEMPERATING": "TEMPERATE, to temper [v]\n",
  "TEMPERATIVE": "having a moderating influence [adj]\n",
  "TEMPERATURE": "the degree of hotness of a body [n -S]\n",
  "TEMPERATURES": "TEMPERATURE, the degree of hotness of a body [n]\n",
  "TEMPERED": "TEMPER, to moderate by adding a counterbalancing agent [v]\n",
  "TEMPERER": "one who tempers [n -S]\n",
  "TEMPERERS": "TEMPERER, one who tempers [n]\n",
  "TEMPERING": "the act of tempering [n -S]\n",
  "TEMPERINGS": "TEMPERING, the act of tempering [n]\n",
  "TEMPERS": "TEMPER, to moderate by adding a counterbalancing agent [v]\n",
  "TEMPEST": "a violent wind or storm [n -S] / (Milton) to stir violently [v -ED, -ING, -S]\n",
  "TEMPESTED": "TEMPEST, (Milton) to stir violently [v]\n",
  "TEMPESTING": "TEMPEST, (Milton) to stir violently [v]\n",
  "TEMPESTIVE": "timely; seasonable [adj]\n",
  "TEMPESTS": "TEMPEST, (Milton) to stir violently [v]\n",
  "TEMPESTUOUS": "of or like a tempest [adj TEMPESTUOUSLY]\n",
  "TEMPESTUOUSLY": "TEMPESTUOUS, of or like a tempest [adv]\n",
  "TEMPESTUOUSNESS": "the state of being tempestuous [n]\n",
  "TEMPI": "TEMPO, the rate of speed of a musical piece [n]\n",
  "TEMPING": "working as a temporary employee [n -S]\n",
  "TEMPINGS": "TEMPING, working as a temporary employee [n]\n",
  "TEMPLAR": "a student of lawyer, living or with chambers, in the Temple, London [n -S]\n",
  "TEMPLARS": "TEMPLAR, a student of lawyer, living or with chambers, in the Temple, London [n]\n",
  "TEMPLATE": "a thin plate used as a pattern in cutting, also TEMPLET [n -S]\n",
  "TEMPLATES": "TEMPLATE, a thin plate used as a pattern in cutting, also TEMPLET [n]\n",
  "TEMPLE": "a house of worship [n -S]\n",
  "TEMPLED": "having a temple [adj]\n",
  "TEMPLES": "TEMPLE, a house of worship [n]\n",
  "TEMPLET": "a thin plate used as a pattern in cutting, also TEMPLATE [n -S]\n",
  "TEMPLETS": "TEMPLET, a thin plate used as a pattern in cutting, also TEMPLATE [n]\n",
  "TEMPO": "the rate of speed of a musical piece [n TEMPOS or TEMPI]\n",
  "TEMPOLABILE": "in chemistry, tending to change with time [adj]\n",
  "TEMPORAL": "related to time [adj TEMPORALLY] / a bone or muscle in the temples [n -S]\n",
  "TEMPORALISE": "to make temporal, also TEMPORALIZE [v TEMPORALISED, TEMPORALISING, TEMPORALISES]\n",
  "TEMPORALISED": "TEMPORALISE, to make temporal, also TEMPORALIZE [v]\n",
  "TEMPORALISES": "TEMPORALISE, to make temporal, also TEMPORALIZE [v]\n",
  "TEMPORALISING": "TEMPORALISE, to make temporal, also TEMPORALIZE [v]\n",
  "TEMPORALITIES": "TEMPORALITY, civil or political as distinguished from spiritual or ecclesiastical power or authority [n]\n",
  "TEMPORALITY": "civil or political as distinguished from spiritual or ecclesiastical power or authority [n TEMPORALITIES]\n",
  "TEMPORALIZE": "to make temporal, also TEMPORALISE [v TEMPORALIZED, TEMPORALIZING, TEMPORALIZES]\n",
  "TEMPORALIZED": "TEMPORALIZE, to make temporal, also TEMPORALISE [v]\n",
  "TEMPORALIZES": "TEMPORALIZE, to make temporal, also TEMPORALISE [v]\n",
  "TEMPORALIZING": "TEMPORALIZE, to make temporal, also TEMPORALISE [v]\n",
  "TEMPORALLY": "TEMPORAL, related to time [adv]\n",
  "TEMPORALNESS": "the state of being temporal [n -ES]\n",
  "TEMPORALNESSES": "TEMPORALNESS, the state of being temporal [n]\n",
  "TEMPORALS": "TEMPORAL, a bone or muscle in the temples [n]\n",
  "TEMPORALTIES": "TEMPORALTY, the laity; secular people [n]\n",
  "TEMPORALTY": "the laity; secular people [n TEMPORALTIES]\n",
  "TEMPORANEOUS": "(obsolete) lasting only a short while [adj]\n",
  "TEMPORARIES": "TEMPORARY, someone in a position of temporary employment [n]\n",
  "TEMPORARILY": "TEMPORARY, not permanent [adv]\n",
  "TEMPORARINESS": "the state of being temporary [n -ES]\n",
  "TEMPORARINESSES": "TEMPORARINESS, the state of being temporary [n]\n",
  "TEMPORARY": "not permanent [adj TEMPORARILY] / someone in a position of temporary employment [n TEMPORARIES]\n",
  "TEMPORE": "(Latin) in the time of [adv]\n",
  "TEMPORISATION": "the act of temporising, also TEMPORIZATION [n -S]\n",
  "TEMPORISATIONS": "TEMPORISATION, the act of temporising, also TEMPORIZATION [n]\n",
  "TEMPORISE": "to delay so as to gain time or to avoid making a decision, also TEMPORIZE [v TEMPORISED, TEMPORISING, TEMPORISES]\n",
  "TEMPORISED": "TEMPORISE, to delay so as to gain time or to avoid making a decision, also TEMPORIZE [v]\n",
  "TEMPORISER": "one who temporises, also TEMPORIZER [n -S]\n",
  "TEMPORISERS": "TEMPORISER, one who temporises, also TEMPORIZER [n]\n",
  "TEMPORISES": "TEMPORISE, to delay so as to gain time or to avoid making a decision, also TEMPORIZE [v]\n",
  "TEMPORISING": "delaying so as to gain time or to avoid making a decision [n -S]\n",
  "TEMPORISINGLY": "TEMPORISING [adv]\n",
  "TEMPORISINGS": "TEMPORISING, delaying so as to gain time or to avoid making a decision [n]\n",
  "TEMPORIZATION": "the act of temporizing, also TEMPORISATION [n -S]\n",
  "TEMPORIZATIONS": "TEMPORIZATION, the act of temporizing, also TEMPORISATION [n]\n",
  "TEMPORIZE": "to delay so as to gain time or to avoid making a decision, also TEMPORISE [v TEMPORIZED, TEMPORIZING, TEMPORIZES]\n",
  "TEMPORIZED": "TEMPORIZE, to delay so as to gain time or to avoid making a decision, also TEMPORISE [v]\n",
  "TEMPORIZER": "one who temporizes, also TEMPORISER [n -S]\n",
  "TEMPORIZERS": "TEMPORIZER, one who temporizes, also TEMPORISER [n]\n",
  "TEMPORIZES": "TEMPORIZE, to delay so as to gain time or to avoid making a decision, also TEMPORISE [v]\n",
  "TEMPORIZING": "delaying so as to gain time or to avoid making a decision [n -S]\n",
  "TEMPORIZINGLY": "TEMPORIZING [adv]\n",
  "TEMPORIZINGS": "TEMPORIZING, delaying so as to gain time or to avoid making a decision [n]\n",
  "TEMPOS": "TEMPO, the rate of speed of a musical piece [n]\n",
  "TEMPS": "TEMP, to be employed as a temporary worker [v]\n",
  "TEMPT": "to entice to commit an unwise or immoral act [v -ED, -ING, -S]\n",
  "TEMPTABILITIES": "TEMPTABILITY, the quality of being temptable [n]\n",
  "TEMPTABILITY": "the quality of being temptable [n TEMPTABILITIES]\n",
  "TEMPTABLE": "capable of being tempted [adj]\n",
  "TEMPTABLENESS": "the state of being temptable [n -ES]\n",
  "TEMPTABLENESSES": "TEMPTABLENESS, the state of being temptable [n]\n",
  "TEMPTATION": "the act of tempting or the state of being tempted esp. to evil [n -S]\n",
  "TEMPTATIONS": "TEMPTATION, the act of tempting or the state of being tempted esp. to evil [n]\n",
  "TEMPTATIOUS": "seductive [adj]\n",
  "TEMPTED": "TEMPT, to entice to commit an unwise or immoral act [v]\n",
  "TEMPTER": "one that tempts [n -S]\n",
  "TEMPTERS": "TEMPTER, one that tempts [n]\n",
  "TEMPTING": "attractive [adj TEMPTINGLY] / the act of tempting [n -S]\n",
  "TEMPTINGLY": "TEMPTING, attractive [adv]\n",
  "TEMPTINGNESS": "the state of being tempting [n -ES]\n",
  "TEMPTINGNESSES": "TEMPTINGNESS, the state of being tempting [n]\n",
  "TEMPTINGS": "TEMPTING, the act of tempting [n]\n",
  "TEMPTRESS": "a female tempter [n -ES]\n",
  "TEMPTRESSES": "TEMPTRESS, a female tempter [n]\n",
  "TEMPTS": "TEMPT, to entice to commit an unwise or immoral act [v]\n",
  "TEMPURA": "(Japanese) a dish of vegetables and shrimp dipped in batter and deep-fried [n -S]\n",
  "TEMPURAS": "TEMPURA, (Japanese) a dish of vegetables and shrimp dipped in batter and deep-fried [n]\n",
  "TEMS": "to sift, also TEMSE [v -ED, -ING, -ES]\n",
  "TEMSE": "to sift, also TEMS [v TEMSED, TEMSING, TEMSES]\n",
  "TEMSED": "TEMS, to sift, also TEMSE [v]\n",
  "TEMSES": "TEMS, to sift, also TEMSE [v]\n",
  "TEMSING": "TEMS, to sift, also TEMSE [v]\n",
  "TEMULENCE": "intoxication, also TEMULENCY [n -S]\n",
  "TEMULENCES": "TEMULENCE, intoxication, also TEMULENCY [n]\n",
  "TEMULENCIES": "TEMULENCY, intoxication, also TEMULENCE [n]\n",
  "TEMULENCY": "intoxication, also TEMULENCE [n TEMULENCIES]\n",
  "TEMULENT": "pertaining to temulence [adj TEMULENTLY]\n",
  "TEMULENTLY": "TEMULENT, pertaining to temulence [adv]\n",
  "TEN": "the next whole number after nine [n -S]\n",
  "TENABILITIES": "TENABILITY, the state of being tenable [n]\n",
  "TENABILITY": "the state of being tenable [n TENABILITIES]\n",
  "TENABLE": "capable of being held [adj TENABLY]\n",
  "TENABLENESS": "the state of being tenable [n -ES]\n",
  "TENABLENESSES": "TENABLENESS, the state of being tenable [n]\n",
  "TENABLY": "TENABLE, capable of being held [adv]\n",
  "TENACE": "(Spanish) a combination of two high cards in some card games [n -S]\n",
  "TENACES": "TENACE, (Spanish) a combination of two high cards in some card games [n]\n",
  "TENACIOUS": "holding on [adj TENACIOUSLY]\n",
  "TENACIOUSLY": "TENACIOUS, holding on [adv]\n",
  "TENACIOUSNESS": "the state of being tenacious [n -ES]\n",
  "TENACIOUSNESSES": "TENACIOUSNESS, the state of being tenacious [n]\n",
  "TENACITIES": "TENACITY, persistence [n]\n",
  "TENACITY": "persistence [n TENACITIES]\n",
  "TENACULA": "TENACULUM, (Latin) a surgical hook or forceps [n]\n",
  "TENACULUM": "(Latin) a surgical hook or forceps [n TENACULUMS or TENACULA]\n",
  "TENACULUMS": "TENACULUM, (Latin) a surgical hook or forceps [n]\n",
  "TENAIL": "an outwork in a main fortification ditch, also TENAILLE [n -S]\n",
  "TENAILLE": "(French) an outwork in a main fortification ditch, also TENAIL [n -S]\n",
  "TENAILLES": "TENAILLE, (French) an outwork in a main fortification ditch, also TENAIL [n]\n",
  "TENAILLON": "(French) an outwork to strengthen the side of a small ravelin [n -S]\n",
  "TENAILLONS": "TENAILLON, (French) an outwork to strengthen the side of a small ravelin [n]\n",
  "TENAILS": "TENAIL, an outwork in a main fortification ditch, also TENAILLE [n]\n",
  "TENANCIES": "TENANCY, the temporary occupancy of something that belongs to another, also TENANTRY [n]\n",
  "TENANCY": "the temporary occupancy of something that belongs to another, also TENANTRY [n TENANCIES]\n",
  "TENANT": "a person who occupies property owned by another, in return for rent, service, etc. [n -S] / to occupy as tenant [v -ED, -ING, -S]\n",
  "TENANTABLE": "fit to be rented; in a condition suitable for a tenant [adj]\n",
  "TENANTED": "TENANT, to occupy as tenant [v]\n",
  "TENANTING": "TENANT, to occupy as tenant [v]\n",
  "TENANTLESS": "without a tenant [adj]\n",
  "TENANTRIES": "TENANTRY, the temporary occupancy of something that belongs to another, also TENANCY [n]\n",
  "TENANTRY": "the temporary occupancy of something that belongs to another, also TENANCY [n TENANTRIES]\n",
  "TENANTS": "TENANT, to occupy as tenant [v]\n",
  "TENANTSHIP": "the state of being a tenant [n -S]\n",
  "TENANTSHIPS": "TENANTSHIP, the state of being a tenant [n]\n",
  "TENCH": "a freshwater fish [n -ES]\n",
  "TENCHES": "TENCH, a freshwater fish [n]\n",
  "TEND": "to watch over [v -ED, -ING, -S]\n",
  "TENDANCE": "watchful care, also TENDENCE [n -S]\n",
  "TENDANCES": "TENDANCE, watchful care, also TENDENCE [n]\n",
  "TENDED": "TEND, to watch over [v]\n",
  "TENDENCE": "watchful care, also TENDANCE [n -S]\n",
  "TENDENCES": "TENDENCE, watchful care, also TENDANCE [n]\n",
  "TENDENCIAL": "having or showing an intentional tendency or bias, esp a controversial one, also TENDENCIOUS, TENDENTIAL, TENDENTIOUS [adj]\n",
  "TENDENCIALLY": "tendentiously [adv]\n",
  "TENDENCIES": "TENDENCY, a trend or inclination, also TENDENCE, TENDENZ [n]\n",
  "TENDENCIOUS": "marked by a tendency in favor of a particular point of view, biased, also TENDENTIAL, TENDENTIOUS [adj TENDENCIOUSLY]\n",
  "TENDENCIOUSLY": "TENDENCIOUS, marked by a tendency in favor of a particular point of view, biased, also TENDENTIAL, TENDENTIOUS [adv]\n",
  "TENDENCIOUSNESS": "the state of being tendencious [n]\n",
  "TENDENCY": "a trend or inclination, also TENDENCE, TENDENZ [n TENDENCIES]\n",
  "TENDENTIAL": "having or showing an intentional tendency or bias, esp a controversial one, biased, also TENDENCIAL, TENDENCIOUS, TENDENTIOUS [adj TENDENTIALLY]\n",
  "TENDENTIALLY": "TENDENTIAL, having or showing an intentional tendency or bias, esp a controversial one, biased, also TENDENCIAL, TENDENCIOUS, TENDENTIOUS [adv]\n",
  "TENDENTIOUS": "marked by a tendency in favor of a particular point of view, biased, also TENDENCIOUS, TENDENTIAL [adj TENDENTIOUSLY]\n",
  "TENDENTIOUSLY": "TENDENTIOUS, marked by a tendency in favor of a particular point of view, biased, also TENDENCIOUS, TENDENTIAL [adv]\n",
  "TENDENTIOUSNESS": "the state of being tendentious [n]\n",
  "TENDENZ": "(German) tendency, esp. in musical composition, also TENDENCE, TENDENCY [n TENDENZEN]\n",
  "TENDENZEN": "TENDENZ, (German) tendency, esp. in musical composition, also TENDENCE, TENDENCY [n]\n",
  "TENDER": "soft, sensitive [adj TENDERER, TENDEREST, TENDERLY] / to offer [v -ED, -ING, -S]\n",
  "TENDERABLE": "that can be tendered [adj]\n",
  "TENDERED": "TENDER, to offer [v]\n",
  "TENDERER": "one who tenders [n -S]\n",
  "TENDERERS": "TENDERER, one who tenders [n]\n",
  "TENDEREST": "TENDER, soft, sensitive [adj]\n",
  "TENDERFEET": "TENDERFOOT, a newcomer in a comparatively rough or newly settled region [n]\n",
  "TENDERFOOT": "a newcomer in a comparatively rough or newly settled region [n TENDERFOOTS or TENDERFEET]\n",
  "TENDERFOOTS": "TENDERFOOT, a newcomer in a comparatively rough or newly settled region [n]\n",
  "TENDERHEARTED": "easily moved to love, pity, or sorrow [adj TENDERHEARTEDLY]\n",
  "TENDERHEARTEDLY": "TENDERHEARTED, easily moved to love, pity, or sorrow [adv]\n",
  "TENDERING": "the act of offering [n -S]\n",
  "TENDERINGS": "TENDERING, the act of offering [n]\n",
  "TENDERISATION": "the act of tenderising, also TENDERIZATION [n -S]\n",
  "TENDERISATIONS": "TENDERISATION, the act of tenderising, also TENDERIZATION [n]\n",
  "TENDERISE": "to make tender, also TENDERIZE [v TENDERISED, TENDERISING, TENDERISES]\n",
  "TENDERISED": "TENDERISE, to make tender, also TENDERIZE [v]\n",
  "TENDERISER": "a pounding instrument or substance that tenderises meat, also TENDERIZER [n -S]\n",
  "TENDERISERS": "TENDERISER, a pounding instrument or substance that tenderises meat, also TENDERIZER [n]\n",
  "TENDERISES": "TENDERISE, to make tender, also TENDERIZE [v]\n",
  "TENDERISING": "TENDERISE, to make tender, also TENDERIZE [v]\n",
  "TENDERIZATION": "the act of tenderizing, also TENDERISATION [n -S]\n",
  "TENDERIZATIONS": "TENDERIZATION, the act of tenderizing, also TENDERISATION [n]\n",
  "TENDERIZE": "to make tender, also TENDERISE [v TENDERIZED, TENDERIZING, TENDERIZES]\n",
  "TENDERIZED": "TENDERIZE, to make tender, also TENDERISE [v]\n",
  "TENDERIZER": "a pounding instrument or substance that tenderises meat, also TENDERISER [n -S]\n",
  "TENDERIZERS": "TENDERIZER, a pounding instrument or substance that tenderises meat, also TENDERISER [n]\n",
  "TENDERIZES": "TENDERIZE, to make tender, also TENDERISE [v]\n",
  "TENDERIZING": "TENDERIZE, to make tender, also TENDERISE [v]\n",
  "TENDERLING": "one made tender by too much kindness [n -S]\n",
  "TENDERLINGS": "TENDERLING, one made tender by too much kindness [n]\n",
  "TENDERLOIN": "a strip of tender flesh on either side of the vertebral column under the short ribs, in the hind quarter of beef and pork [n -S]\n",
  "TENDERLOINS": "TENDERLOIN, a strip of tender flesh on either side of the vertebral column under the short ribs, in the hind quarter of beef and pork [n]\n",
  "TENDERLY": "TENDER, soft, sensitive [adv]\n",
  "TENDERNESS": "the state of being tender [n -ES]\n",
  "TENDERNESSES": "TENDERNESS, the state of being tender [n]\n",
  "TENDEROMETER": "an instrument for measuring tenderness of fruits and vegetables [n -S]\n",
  "TENDEROMETERS": "TENDEROMETER, an instrument for measuring tenderness of fruits and vegetables [n]\n",
  "TENDERS": "TENDER, to offer [v]\n",
  "TENDING": "TEND, to watch over [v]\n",
  "TENDINITIDES": "TENDINITIS, inflammation of a tendon, also TENDONITIS [n]\n",
  "TENDINITIS": "inflammation of a tendon, also TENDONITIS [n TENDINITIDES or TENDINITISES]\n",
  "TENDINITISES": "TENDINITIS, inflammation of a tendon, also TENDONITIS [n]\n",
  "TENDINOUS": "of or like a tendon [adj]\n",
  "TENDON": "a cord or fibrous tissue [n -S]\n",
  "TENDONITIDES": "TENDONITIS, inflammation of a tendon, also TENDINITIS [n]\n",
  "TENDONITIS": "inflammation of a tendon, also TENDINITIS [n TENDONITIDES or TENDONITISES]\n",
  "TENDONITISES": "TENDONITIS, inflammation of a tendon, also TENDINITIS [n]\n",
  "TENDONS": "TENDON, a cord or fibrous tissue [n]\n",
  "TENDOVAGINITIS": "inflammation or thickening of the fibrous wall of the sheath surrounding a tendon, esp. in the hand, also TENOVAGINITIS [n]\n",
  "TENDRE": "(French) a tender feeling, a fondness, also TENDRESSE [n -S]\n",
  "TENDRES": "TENDRE, (French) a tender feeling, a fondness, also TENDRESSE [n]\n",
  "TENDRESSE": "(French) a tender feeling, a fondness, also TENDRE [n -S]\n",
  "TENDRESSES": "TENDRESSE, (French) a tender feeling, a fondness, also TENDRE [n]\n",
  "TENDRIL": "a coiling, threadlike, climbing organ of a plant [n -S]\n",
  "TENDRILED": "having tendrils, also TENDRILLED [adj]\n",
  "TENDRILLAR": "of or like a tendril, also TENDRILLOUS, TENDRILLY, TENDRILOUS [adj]\n",
  "TENDRILLED": "having tendrils, also TENDRILED [adj]\n",
  "TENDRILLIER": "TENDRILLY, having tendrils, also TENDRILLAR, TENDRILLOUS, TENDRILOUS [adj]\n",
  "TENDRILLIEST": "TENDRILLY, having tendrils, also TENDRILLAR, TENDRILLOUS, TENDRILOUS [adj]\n",
  "TENDRILLOUS": "of or like a tendril, also TENDRILLAR, TENDRILLY, TENDRILOUS [adj]\n",
  "TENDRILLY": "having tendrils, also TENDRILLAR, TENDRILLOUS, TENDRILOUS [adj TENDRILLIER, TENDRILLIEST]\n",
  "TENDRILOUS": "of or like a tendril, also TENDRILLAR, TENDRILLOUS, TENDRILLY [adj]\n",
  "TENDRILS": "TENDRIL, a coiling, threadlike, climbing organ of a plant [n]\n",
  "TENDRON": "(French) a tendril [n -S]\n",
  "TENDRONS": "TENDRON, (French) a tendril [n]\n",
  "TENDS": "TEND, to watch over [v]\n",
  "TENDU": "an Asian ebony tree [n -S]\n",
  "TENDUS": "TENDU, an Asian ebony tree [n]\n",
  "TENE": "(archaic) injury, pain, also TEEN, TEENE [n -S]\n",
  "TENEBRAE": "(Latin) a religious service with candles [n]\n",
  "TENEBRIFIC": "producing darkness; obscuring [adj]\n",
  "TENEBRIO": "(Latin) a night spirit, a night prowler [n -S]\n",
  "TENEBRIONID": "a dark-coloured nocturnal beetle [n -S]\n",
  "TENEBRIONIDS": "TENEBRIONID, a dark-coloured nocturnal beetle [n]\n",
  "TENEBRIOS": "TENEBRIO, (Latin) a night spirit, a night prowler [n]\n",
  "TENEBRIOUS": "gloomy, obscure, also TENEBROSE, TENEBROUS [adj]\n",
  "TENEBRIOUSNESS": "the state of being tenebrious, also TENEBROUSNESS [n]\n",
  "TENEBRISM": "a style of painting, associated with the Italian painter Caravaggio, in which most of the figures are engulfed in shadow but some are dramatically illuminated by concentrated light [n -S]\n",
  "TENEBRISMS": "TENEBRISM, a style of painting, associated with the Italian painter Caravaggio, in which most of the figures are engulfed in shadow but some are dramatically illuminated by concentrated light [n]\n",
  "TENEBRIST": "a painter in the style of tenebrism [n -S]\n",
  "TENEBRISTS": "TENEBRIST, a painter in the style of tenebrism [n]\n",
  "TENEBRITIES": "TENEBRITY, gloom, darkness [n]\n",
  "TENEBRITY": "gloom, darkness [n TENEBRITIES]\n",
  "TENEBROSE": "gloomy, obscure, also TENEBRIOUS, TENEBROUS [adj]\n",
  "TENEBROSITIES": "TENEBROSITY, darkness [n]\n",
  "TENEBROSITY": "darkness [n TENEBROSITIES]\n",
  "TENEBROUS": "gloomy, obscure, also TENEBRIOUS, TENEBROSE [adj]\n",
  "TENEBROUSNESS": "the state of being tenebrous, also TENEBRIOUSNESS [n -ES]\n",
  "TENEBROUSNESSES": "TENEBROUSNESS, the state of being tenebrous, also TENEBRIOUSNESS [n]\n",
  "TENEMENT": "an apartment house [n -S]\n",
  "TENEMENTAL": "of or pertaining to a tenement, also TENEMENTARY [adj]\n",
  "TENEMENTARY": "of or pertaining to a tenement, also TENEMENTAL [adj]\n",
  "TENEMENTED": "possessing tenements [adj]\n",
  "TENEMENTS": "TENEMENT, an apartment house [n]\n",
  "TENENDA": "TENENDUM, (Latin) a clause in a deed defining land tenure [n]\n",
  "TENENDUM": "(Latin) a clause in a deed defining land tenure [n TENENDA or TENENDUMS]\n",
  "TENENDUMS": "TENENDUM, (Latin) a clause in a deed defining land tenure [n]\n",
  "TENES": "TENE, (archaic) injury, pain, also TEEN, TEENE [n]\n",
  "TENESI": "a monetary unit of Turkmenistan, also TENNE, TENNY [n]\n",
  "TENESMIC": "pertaining to tenesmus, a painful but ineffectual effort to urinate or defecate [adj]\n",
  "TENESMUS": "a frequent but ineffectual urge to defecate [n -ES]\n",
  "TENESMUSES": "TENESMUS, a frequent but ineffectual urge to defecate [n]\n",
  "TENET": "(Latin) an opinion, principle or doctrine held to be true [n -S]\n",
  "TENETS": "TENET, (Latin) an opinion, principle or doctrine held to be true [n]\n",
  "TENFOLD": "ten times as much [n -S]\n",
  "TENFOLDS": "TENFOLD, ten times as much [n]\n",
  "TENGE": "the standard monetary unit of Kazakhstan [n -S]\n",
  "TENGES": "TENGE, the standard monetary unit of Kazakhstan [n]\n",
  "TENIA": "(Latin) a narrow band or hair-ribbon worn in Greece, also TAENIA [n TENIAE or TENIAS]\n",
  "TENIACIDE": "a substance, esp. a drug, that kills a tapeworm, also TENIAFUGE [n -S]\n",
  "TENIACIDES": "TENIACIDE, a substance, esp. a drug, that kills a tapeworm, also TENIAFUGE [n]\n",
  "TENIAE": "TENIA, (Latin) a narrow band or hair-ribbon worn in Greece, also TAENIA [n]\n",
  "TENIAFUGE": "a substance, esp. a drug, that kills a tapeworm, also TENIACIDE [n -S]\n",
  "TENIAFUGES": "TENIAFUGE, a substance, esp. a drug, that kills a tapeworm, also TENIACIDE [n]\n",
  "TENIAS": "TENIA, (Latin) a narrow band or hair-ribbon worn in Greece, also TAENIA [n]\n",
  "TENIASES": "TENIASIS, an infestation with tapeworms [n]\n",
  "TENIASIS": "an infestation with tapeworms [n TENIASES]\n",
  "TENIOID": "ribbonlike; shaped like a ribbon, also TAENIATE, TAENIOID [adj]\n",
  "TENNANTITE": "a blackish lead-gray mineral, a sulphide of arsenic and copper [n -S]\n",
  "TENNANTITES": "TENNANTITE, a blackish lead-gray mineral, a sulphide of arsenic and copper [n]\n",
  "TENNE": "(French) an orange-brown colour, also TENNY [n -S] / a monetary unit of Turkmenistan, also TENESI [n TENNESI]\n",
  "TENNER": "(colloquial) a ten-pound note [n -S]\n",
  "TENNERS": "TENNER, (colloquial) a ten-pound note [n]\n",
  "TENNES": "TENNE, (French) an orange-brown colour, also TENNY [n]\n",
  "TENNESI": "TENNE, (French) an orange-brown colour, also TENNY [n]\n",
  "TENNESSINE": "a highly radioactive element, of which only a few atoms have ever been produced [n -S]\n",
  "TENNESSINES": "TENNESSINE, a highly radioactive element, of which only a few atoms have ever been produced [n]\n",
  "TENNIES": "TENNY, the colour orange-brown, also TENNE [n]\n",
  "TENNIS": "an outdoor ball game [n -ES]\n",
  "TENNISES": "TENNIS, an outdoor ball game [n]\n",
  "TENNIST": "a tennis player [n -S]\n",
  "TENNISTS": "TENNIST, a tennis player [n]\n",
  "TENNO": "(Japanese) the formal title of an Emperor of Japan [n -S]\n",
  "TENNOS": "TENNO, (Japanese) the formal title of an Emperor of Japan [n]\n",
  "TENNY": "the colour orange-brown, also TENNE [n TENNIES]\n",
  "TENON": "a projecting part of a joint for inserting into mortise [n -S] / to fix or fit with a tenon [v -ED, -ING, -S]\n",
  "TENONED": "TENON, to fix or fit with a tenon [v]\n",
  "TENONER": "one who tenons [n -S]\n",
  "TENONERS": "TENONER, one who tenons [n]\n",
  "TENONING": "TENON, to fix or fit with a tenon [v]\n",
  "TENONS": "TENON, to fix or fit with a tenon [v]\n",
  "TENOR": "a high male singing voice, also TENOUR [n -S]\n",
  "TENORINI": "TENORINO, a high tenor [n]\n",
  "TENORINO": "a high tenor [n TENORINI]\n",
  "TENORIST": "one who sings tenor or plays a tenor instrument [n -S]\n",
  "TENORISTS": "TENORIST, one who sings tenor or plays a tenor instrument [n]\n",
  "TENORITE": "a triclinic oxide of copper occurring in minute iron-grey scales or black masses [n -S]\n",
  "TENORITES": "TENORITE, a triclinic oxide of copper occurring in minute iron-grey scales or black masses [n]\n",
  "TENORLESS": "without a tenor [adj]\n",
  "TENORMAN": "a person who plays tenor saxophone [n TENORMEN]\n",
  "TENORMEN": "TENORMAN, a person who plays tenor saxophone [n]\n",
  "TENOROON": "an obsolete tenor bassoon [n -S]\n",
  "TENOROONS": "TENOROON, an obsolete tenor bassoon [n]\n",
  "TENORRHAPHIES": "TENORRHAPHY, the repairing of a split or torn tendon by sutures [n]\n",
  "TENORRHAPHY": "the repairing of a split or torn tendon by sutures [n TENORRHAPHIES]\n",
  "TENORS": "TENOR, a high male singing voice, also TENOUR [n]\n",
  "TENOSYNOVITIS": "inflammation of a tendon sheath [n -ES]\n",
  "TENOSYNOVITISES": "TENOSYNOVITIS, inflammation of a tendon sheath [n]\n",
  "TENOTOMIES": "TENOTOMY, the surgical division of a tendon [n]\n",
  "TENOTOMIST": "one who surgically cuts tendons [n -S]\n",
  "TENOTOMISTS": "TENOTOMIST, one who surgically cuts tendons [n]\n",
  "TENOTOMY": "the surgical division of a tendon [n TENOTOMIES]\n",
  "TENOUR": "(obsolete) tenor [n -S]\n",
  "TENOURS": "TENOUR, (obsolete) tenor [n]\n",
  "TENOVAGINITIS": "inflammation or thickening of the fibrous wall of the sheath surrounding a tendon, esp. in the hand, also TENDOVAGINITIS [n -ES]\n",
  "TENOVAGINITISES": "TENOVAGINITIS, inflammation or thickening of the fibrous wall of the sheath surrounding a tendon, esp. in the hand, also TENDOVAGINITIS [n]\n",
  "TENPENCE": "the sum of ten pennies [n -S]\n",
  "TENPENCES": "TENPENCE, the sum of ten pennies [n]\n",
  "TENPENNY": "worth tenpence [adj]\n",
  "TENPIN": "a bowling pin [n -S]\n",
  "TENPINNER": "one who engages in tenpin bowling [n -S]\n",
  "TENPINNERS": "TENPINNER, one who engages in tenpin bowling [n]\n",
  "TENPINS": "TENPIN, a bowling pin [n]\n",
  "TENPOUNDER": "a ten-pound gun [n -S]\n",
  "TENPOUNDERS": "TENPOUNDER, a ten-pound gun [n]\n",
  "TENREC": "(Malagasy) a small insectivore, native to Madagascar, also TANREC [n -S]\n",
  "TENRECS": "TENREC, (Malagasy) a small insectivore, native to Madagascar, also TANREC [n]\n",
  "TENS": "TEN, the next whole number after nine [n]\n",
  "TENSE": "taut [adj TENSER, TENSEST, TENSELY] / to make tense [v TENSED, TENSING, TENSES]\n",
  "TENSED": "TENSE, to make tense [v]\n",
  "TENSELESS": "without tenses, e.g. a language [adj]\n",
  "TENSELY": "TENSE, taut [adv]\n",
  "TENSENESS": "the state of being tense [n -ES]\n",
  "TENSENESSES": "TENSENESS, the state of being tense [n]\n",
  "TENSER": "TENSE, taut [adj]\n",
  "TENSES": "TENSE, to make tense [v]\n",
  "TENSEST": "TENSE, taut [adj]\n",
  "TENSIBILITIES": "TENSIBILITY, the state of being tensible [n]\n",
  "TENSIBILITY": "the state of being tensible [n TENSIBILITIES]\n",
  "TENSIBLE": "capable of being stretched [adj TENSIBLY]\n",
  "TENSIBLENESS": "the state of being tensible [n -ES]\n",
  "TENSIBLENESSES": "TENSIBLENESS, the state of being tensible [n]\n",
  "TENSIBLY": "TENSIBLE, capable of being stretched [adv]\n",
  "TENSILE": "of or relating to stretching [adj TENSILELY]\n",
  "TENSILELY": "TENSILE, of or relating to stretching [adv]\n",
  "TENSILENESS": "the state of being tensile [n -ES]\n",
  "TENSILENESSES": "TENSILENESS, the state of being tensile [n]\n",
  "TENSILITIES": "TENSILITY, the state of being tensile [n]\n",
  "TENSILITY": "the state of being tensile [n TENSILITIES]\n",
  "TENSIMETER": "an instrument for measuring vapour pressure [n -S]\n",
  "TENSIMETERS": "TENSIMETER, an instrument for measuring vapour pressure [n]\n",
  "TENSING": "TENSE, to make tense [v]\n",
  "TENSIOMETER": "an instrument for measuring tension [n -S]\n",
  "TENSIOMETERS": "TENSIOMETER, an instrument for measuring tension [n]\n",
  "TENSIOMETRIC": "relating to measurement by tensiometer, an instrument for measuring tension [adj]\n",
  "TENSIOMETRIES": "TENSIOMETRY, the measurement of tension [n]\n",
  "TENSIOMETRY": "the measurement of tension [n TENSIOMETRIES]\n",
  "TENSION": "to make strained [v -ED, -ING, -S]\n",
  "TENSIONAL": "relating to tension [adj TENSIONALLY]\n",
  "TENSIONALLY": "TENSIONAL, relating to tension [adv]\n",
  "TENSIONED": "TENSION, to make strained [v]\n",
  "TENSIONER": "something that tensions [n -S]\n",
  "TENSIONERS": "TENSIONER, something that tensions [n]\n",
  "TENSIONING": "TENSION, to make strained [v]\n",
  "TENSIONLESS": "without tension [adj]\n",
  "TENSIONS": "TENSION, to make strained [v]\n",
  "TENSITIES": "TENSITY, the state of being tense [n]\n",
  "TENSITY": "the state of being tense [n TENSITIES]\n",
  "TENSIVE": "causing tensity [adj]\n",
  "TENSON": "(French) a competition in verse between two troubadours, also TENZON [n -S]\n",
  "TENSONS": "TENSON, (French) a competition in verse between two troubadours, also TENZON [n]\n",
  "TENSOR": "a muscle that stretches a body part [n -S]\n",
  "TENSORIAL": "relating to a tensor, a muscle that stretches a part, or renders it tense [adj]\n",
  "TENSORS": "TENSOR, a muscle that stretches a body part [n]\n",
  "TENT": "a portable shelter of canvas or other cloth stretched on poles [n -S] / to cover with a tent [v -ED, -ING, -S]\n",
  "TENTACLE": "a slender flexible organ in invertebrates [n -S]\n",
  "TENTACLED": "having tentacles [adj]\n",
  "TENTACLES": "TENTACLE, a slender flexible organ in invertebrates [n]\n",
  "TENTACULA": "TENTACULUM, a tentacle [n]\n",
  "TENTACULAR": "of or pertaining to a tentacle or tentacles [adj]\n",
  "TENTACULATE": "like a tentacle [adj]\n",
  "TENTACULIFEROUS": "having tentacles [adj]\n",
  "TENTACULITE": "a ringed conical Silurian fossil [n -S]\n",
  "TENTACULITES": "TENTACULITE, a ringed conical Silurian fossil [n]\n",
  "TENTACULOID": "like a tentacle [adj]\n",
  "TENTACULUM": "a tentacle [n TENTACULA]\n",
  "TENTAGE": "a supply of tents [n -S]\n",
  "TENTAGES": "TENTAGE, a supply of tents [n]\n",
  "TENTATION": "experiment by trial and error [n -S]\n",
  "TENTATIONS": "TENTATION, experiment by trial and error [n]\n",
  "TENTATIVE": "cautious [adj TENTATIVELY] / something done as an experiment or trial [n -S]\n",
  "TENTATIVELY": "TENTATIVE, cautious [adv]\n",
  "TENTATIVENESS": "the state of being tentative [n -ES]\n",
  "TENTATIVENESSES": "TENTATIVENESS, the state of being tentative [n]\n",
  "TENTATIVES": "TENTATIVE, something done as an experiment or trial [n]\n",
  "TENTED": "TENT, to cover with a tent [v]\n",
  "TENTER": "to stretch on a type of frame [v -ED, -ING, -S]\n",
  "TENTERED": "TENTER, to stretch on a type of frame [v]\n",
  "TENTERHOOK": "a sharp, hooked nail to fasten cloth to a tenter [n -S]\n",
  "TENTERHOOKS": "TENTERHOOK, a sharp, hooked nail to fasten cloth to a tenter [n]\n",
  "TENTERING": "TENTER, to stretch on a type of frame [v]\n",
  "TENTERS": "TENTER, to stretch on a type of frame [v]\n",
  "TENTFUL": "as much as a tent can hold [n -S]\n",
  "TENTFULS": "TENTFUL, as much as a tent can hold [n]\n",
  "TENTH": "number ten in sequence [adj TENTHLY] / one of ten equal parts [n -S]\n",
  "TENTHLY": "TENTH, number ten in sequence [adv]\n",
  "TENTHS": "TENTH, one of ten equal parts [n]\n",
  "TENTIE": "watchful, also TENTY [adj TENTIER, TENTIEST]\n",
  "TENTIER": "TENTY, watchful, also TENTIE [adj]\n",
  "TENTIEST": "TENTY, watchful, also TENTIE [adj]\n",
  "TENTIGINOUS": "morbidly lascivious [adj]\n",
  "TENTIGO": "(Latin) morbid lasciviousness [n -S]\n",
  "TENTIGOS": "TENTIGO, (Latin) morbid lasciviousness [n]\n",
  "TENTING": "an assemblage of tents [n -S]\n",
  "TENTINGS": "TENTING, an assemblage of tents [n]\n",
  "TENTLESS": "without a tent [adj]\n",
  "TENTLIKE": "like a tent [adj]\n",
  "TENTMAKER": "one who makes tents [n -S]\n",
  "TENTMAKERS": "TENTMAKER, one who makes tents [n]\n",
  "TENTORIA": "TENTORIUM, (Latin) a sheet of the dura mater stretched between the cerebrum and the cerebellum [n]\n",
  "TENTORIAL": "relating to a tentorium, a fold of the dura mater [adj]\n",
  "TENTORIUM": "(Latin) a sheet of the dura mater stretched between the cerebrum and the cerebellum [n TENTORIA]\n",
  "TENTPOLE": "a big budget movie whose high earnings are intended to offset the cost of less profitable ones [n -S]\n",
  "TENTPOLES": "TENTPOLE, a big budget movie whose high earnings are intended to offset the cost of less profitable ones [n]\n",
  "TENTS": "TENT, to cover with a tent [v]\n",
  "TENTWISE": "pertaining to a tent [adj]\n",
  "TENTY": "watchful, also TENTIE [adj TENTIER, TENTIEST]\n",
  "TENUE": "(French) bearing; manner of dress [n -S]\n",
  "TENUES": "TENUIS, (Latin) a voiceless stop consonant, such as k, p or t [n]\n",
  "TENUIOUS": "thin, slender, insubstantial, also TENUOUS [adj]\n",
  "TENUIROSTRAL": "of a bird, slender-billed [adj]\n",
  "TENUIS": "(Latin) a voiceless stop consonant, such as k, p or t [n TENUES]\n",
  "TENUITIES": "TENUITY, lack of strength [n]\n",
  "TENUITY": "lack of strength [n TENUITIES]\n",
  "TENUOUS": "thin, slight, insubstantial, also TENUIOUS [adj TENUOUSLY]\n",
  "TENUOUSLY": "TENUOUS, thin, slight, insubstantial, also TENUIOUS [adv]\n",
  "TENUOUSNESS": "the state of being tenuous [n -ES]\n",
  "TENUOUSNESSES": "TENUOUSNESS, the state of being tenuous [n]\n",
  "TENURABLE": "of a university post, giving tenure [adj]\n",
  "TENURE": "the holding of something [n -S] / to grant a permanent position at a university to [v TENURED, TENURING, TENURES]\n",
  "TENURED": "TENURE, to grant a permanent position at a university to [v]\n",
  "TENURES": "TENURE, to grant a permanent position at a university to [v]\n",
  "TENURIAL": "relating to tenure [adj TENURIALLY]\n",
  "TENURIALLY": "TENURIAL, relating to tenure [adv]\n",
  "TENURING": "TENURE, to grant a permanent position at a university to [v]\n",
  "TENUTI": "TENUTO, (Italian) a sustained note or chord [n]\n",
  "TENUTO": "(Italian) a sustained note or chord [n TENUTOS or TENUTI]\n",
  "TENUTOS": "TENUTO, (Italian) a sustained note or chord [n]\n",
  "TENZON": "(French) a competition in verse between two troubadours, also TENSON [n -S]\n",
  "TENZONS": "TENZON, (French) a competition in verse between two troubadours, also TENSON [n]\n",
  "TEOCALLI": "(Nahuatl) an Aztec pyramid temple, also TEOPAN [n -S]\n",
  "TEOCALLIS": "TEOCALLI, (Nahuatl) an Aztec pyramid temple, also TEOPAN [n]\n",
  "TEOPAN": "(Nahuatl) an Aztec pyramid temple, also TEOCALLI [n -S]\n",
  "TEOPANS": "TEOPAN, (Nahuatl) an Aztec pyramid temple, also TEOCALLI [n]\n",
  "TEOSINTE": "(Nahuatl) a Mexican grass grown as fodder, allied to maize but with several stems from the base [n -S]\n",
  "TEOSINTES": "TEOSINTE, (Nahuatl) a Mexican grass grown as fodder, allied to maize but with several stems from the base [n]\n",
  "TEPA": "an organophosphorus compound used as an insect sterilant and formerly to treat cancer [n -S]\n",
  "TEPACHE": "(Spanish) a Mexican drink made with pineapple, brown sugar and water [n -S]\n",
  "TEPACHES": "TEPACHE, (Spanish) a Mexican drink made with pineapple, brown sugar and water [n]\n",
  "TEPAL": "a segment of a perianth in which the corolla and calyx are not differentiated [n -S]\n",
  "TEPALS": "TEPAL, a segment of a perianth in which the corolla and calyx are not differentiated [n]\n",
  "TEPAS": "TEPA, an organophosphorus compound used as an insect sterilant and formerly to treat cancer [n]\n",
  "TEPEE": "(Native American) a conical tent of the North American Indians, also TEEPEE, TIPI [n -S]\n",
  "TEPEES": "TEPEE, (Native American) a conical tent of the North American Indians, also TEEPEE, TIPI [n]\n",
  "TEPEFACTION": "making or becoming tepid [n -S]\n",
  "TEPEFACTIONS": "TEPEFACTION, making or becoming tepid [n]\n",
  "TEPEFIED": "TEPEFY, to make or become tepid, or moderately warm [v]\n",
  "TEPEFIES": "TEPEFY, to make or become tepid, or moderately warm [v]\n",
  "TEPEFY": "to make or become tepid, or moderately warm [v TEPEFIED, TEPEFYING, TEPEFIES]\n",
  "TEPEFYING": "TEPEFY, to make or become tepid, or moderately warm [v]\n",
  "TEPHIGRAM": "a diagram on which information about vertical variation in the atmosphere is plotted [n -S]\n",
  "TEPHIGRAMS": "TEPHIGRAM, a diagram on which information about vertical variation in the atmosphere is plotted [n]\n",
  "TEPHILLAH": "(Hebrew) a phylactery worn by Jews, also TEFILLAH [n TEPHILLIN]\n",
  "TEPHILLIN": "TEPHILLAH, (Hebrew) a phylactery worn by Jews, also TEFILLAH [n]\n",
  "TEPHRA": "(Greek) ash and debris ejected by a volcano [n -S]\n",
  "TEPHRAS": "TEPHRA, (Greek) ash and debris ejected by a volcano [n]\n",
  "TEPHRITE": "a kind of igneous rock [n -S]\n",
  "TEPHRITES": "TEPHRITE, a kind of igneous rock [n]\n",
  "TEPHRITIC": "of or like tephrite, an igneous rock consisting essentially of plagioclase and either leucite or nephelite, or both [adj]\n",
  "TEPHROITE": "an orthorhombic manganese silicate of the olivine group which forms ashy grey or reddish crystalline masses [n -S]\n",
  "TEPHROITES": "TEPHROITE, an orthorhombic manganese silicate of the olivine group which forms ashy grey or reddish crystalline masses [n]\n",
  "TEPHROMANCIES": "TEPHROMANCY, divination by ashes [n]\n",
  "TEPHROMANCY": "divination by ashes [n TEPHROMANCIES]\n",
  "TEPID": "moderately warm [adj TEPIDER, TEPIDEST, TEPIDLY]\n",
  "TEPIDARIA": "TEPIDARIUM, (Latin) a warm room between the hot and cold rooms of a Roman bath [n]\n",
  "TEPIDARIUM": "(Latin) a warm room between the hot and cold rooms of a Roman bath [n TEPIDARIA]\n",
  "TEPIDER": "TEPID, moderately warm [adj]\n",
  "TEPIDEST": "TEPID, moderately warm [adj]\n",
  "TEPIDITIES": "TEPIDITY, the state of being tepid [n]\n",
  "TEPIDITY": "the state of being tepid [n TEPIDITIES]\n",
  "TEPIDLY": "TEPID, moderately warm [adv]\n",
  "TEPIDNESS": "the state of being tepid [n -ES]\n",
  "TEPIDNESSES": "TEPIDNESS, the state of being tepid [n]\n",
  "TEPOY": "(Hindi) an ornamental stand, usually with three legs, having caddies for holding tea, also TEAPOY [n -S]\n",
  "TEPOYS": "TEPOY, (Hindi) an ornamental stand, usually with three legs, having caddies for holding tea, also TEAPOY [n]\n",
  "TEQUILA": "a Mexican alcoholic drink made from the agave plant, also TEQUILLA [n -S]\n",
  "TEQUILAS": "TEQUILA, a Mexican alcoholic drink made from the agave plant, also TEQUILLA [n]\n",
  "TEQUILLA": "a Mexican alcoholic drink made from the agave plant, also TEQUILA [n -S]\n",
  "TEQUILLAS": "TEQUILLA, a Mexican alcoholic drink made from the agave plant, also TEQUILA [n]\n",
  "TERABYTE": "a large unit of computer memory, one trillion bytes [n -S]\n",
  "TERABYTES": "TERABYTE, a large unit of computer memory, one trillion bytes [n]\n",
  "TERAFLOP": "a unit of processing speed equal to a trillion (thousand billion) floating-point operations per second [n -S]\n",
  "TERAFLOPS": "TERAFLOP, a unit of processing speed equal to a trillion (thousand billion) floating-point operations per second [n]\n",
  "TERAGLIN": "(Native Australian) an edible marine fish of Australia [n -S]\n",
  "TERAGLINS": "TERAGLIN, (Native Australian) an edible marine fish of Australia [n]\n",
  "TERAHERTZ": "a large unit of electrical frequency [n -ES]\n",
  "TERAHERTZES": "TERAHERTZ, a large unit of electrical frequency [n]\n",
  "TERAI": "(Hindi) a wide-brimmed ventilated hat [n -S]\n",
  "TERAIS": "TERAI, (Hindi) a wide-brimmed ventilated hat [n]\n",
  "TERAKIHI": "(Maori) an Australasian food fish, also TARAKIHI [n -S]\n",
  "TERAKIHIS": "TERAKIHI, (Maori) an Australasian food fish, also TARAKIHI [n]\n",
  "TERAMETER": "ten to the power of twelve metres [n -S]\n",
  "TERAMETERS": "TERAMETER, ten to the power of twelve metres [n]\n",
  "TERAOHM": "one trillion ohms [n -S]\n",
  "TERAOHMS": "TERAOHM, one trillion ohms [n]\n",
  "TERAPH": "(Hebrew) an image of a Semitic household god [n TERAPHIM]\n",
  "TERAPHIM": "an image of a Semitic household god [n -S]\n",
  "TERAPHIMS": "TERAPHIM, an image of a Semitic household god [n]\n",
  "TERAS": "(Greek) a monstrosity [n TERATA]\n",
  "TERATA": "TERAS, (Greek) a monstrosity [n]\n",
  "TERATISM": "a malformed fetus [n -S]\n",
  "TERATISMS": "TERATISM, a malformed fetus [n]\n",
  "TERATOCARCINOMA": "a malignant teratoma [n]\n",
  "TERATOGEN": "an agent that raises the incidence of congenital malformation [n -S]\n",
  "TERATOGENESES": "TERATOGENESIS, the production of developmental malformations [n]\n",
  "TERATOGENESIS": "the production of developmental malformations [n TERATOGENESES]\n",
  "TERATOGENIC": "producing monsters or abnormal growth [adj]\n",
  "TERATOGENICIST": "one who studies teratogens [n -S]\n",
  "TERATOGENICISTS": "TERATOGENICIST, one who studies teratogens [n]\n",
  "TERATOGENICITY": "the state of being teratogenic [n]\n",
  "TERATOGENIES": "TERATOGENY, the formation of monsters [n]\n",
  "TERATOGENS": "TERATOGEN, an agent that raises the incidence of congenital malformation [n]\n",
  "TERATOGENY": "the formation of monsters [n TERATOGENIES]\n",
  "TERATOID": "resembling a monster; formed by abnormal development [adj]\n",
  "TERATOLOGIC": "relating to teratology, also TERATOLOGICAL [adj]\n",
  "TERATOLOGICAL": "relating to teratology, also TERATOLOGIC [adj]\n",
  "TERATOLOGIES": "TERATOLOGY, the study of malformations, monstrosities or serious deviations from the normal type in organisms [n]\n",
  "TERATOLOGIST": "a student of teratology [n -S]\n",
  "TERATOLOGISTS": "TERATOLOGIST, a student of teratology [n]\n",
  "TERATOLOGY": "the study of malformations, monstrosities or serious deviations from the normal type in organisms [n TERATOLOGIES]\n",
  "TERATOMA": "(Greek) a tumor, sometimes found in newborn children, which is made up of a mixture of tissues, as of bone, cartilage and muscle [n TERATOMAS or TERATOMATA]\n",
  "TERATOMAS": "TERATOMA, (Greek) a tumor, sometimes found in newborn children, which is made up of a mixture of tissues, as of bone, cartilage and muscle [n]\n",
  "TERATOMATA": "TERATOMA, (Greek) a tumor, sometimes found in newborn children, which is made up of a mixture of tissues, as of bone, cartilage and muscle [n]\n",
  "TERATOMATOUS": "of or like a teratoma [adj]\n",
  "TERATOPHOBIA": "an irrational fear of monsters [n -S]\n",
  "TERATOPHOBIAS": "TERATOPHOBIA, an irrational fear of monsters [n]\n",
  "TERAWATT": "a trillion watts [n -S]\n",
  "TERAWATTS": "TERAWATT, a trillion watts [n]\n",
  "TERBIA": "an oxide of terbium [n -S]\n",
  "TERBIAS": "TERBIA, an oxide of terbium [n]\n",
  "TERBIC": "(Swedish) pertaining to the element terbium [adj]\n",
  "TERBIUM": "(Swedish) a metallic element [n -S]\n",
  "TERBIUMS": "TERBIUM, (Swedish) a metallic element [n]\n",
  "TERCE": "a prayer service held at 9 a.m. [n -S]\n",
  "TERCEL": "a male hawk, also TARCEL, TARSAL, TARSEL, TASSELL, TIERCEL [n -S]\n",
  "TERCELET": "the male of various falcons, esp. of the peregrine, also TIERCELET [n -S]\n",
  "TERCELETS": "TERCELET, the male of various falcons, esp. of the peregrine, also TIERCELET [n]\n",
  "TERCELS": "TERCEL, a male hawk, also TARCEL, TARSAL, TARSEL, TASSELL, TIERCEL [n]\n",
  "TERCENTENARIES": "TERCENTENARY, a three-hundred year anniversary, also TRICENTENARY [n]\n",
  "TERCENTENARY": "pertaining to a three-hundred year anniversary [adj] / a three-hundred year anniversary, also TRICENTENARY [n TERCENTENARIES]\n",
  "TERCENTENNIAL": "a three hundred year anniversary [n -S]\n",
  "TERCENTENNIALS": "TERCENTENNIAL, a three hundred year anniversary [n]\n",
  "TERCES": "TERCE, a prayer service held at 9 a.m. [n]\n",
  "TERCET": "(Italian) a group of three lines of verse, also TERZETTA, TIERCET [n -S]\n",
  "TERCETS": "TERCET, (Italian) a group of three lines of verse, also TERZETTA, TIERCET [n]\n",
  "TERCIO": "(Spanish) an infantry regiment, originally Spanish, also TERTIA [n -S]\n",
  "TERCIOS": "TERCIO, (Spanish) an infantry regiment, originally Spanish, also TERTIA [n]\n",
  "TEREBENE": "a light yellow disinfectant liquid, a mixture of hydrocarbons made from oil of turpentine, used as a solvent for paint [n -S]\n",
  "TEREBENES": "TEREBENE, a light yellow disinfectant liquid, a mixture of hydrocarbons made from oil of turpentine, used as a solvent for paint [n]\n",
  "TEREBIC": "pertaining to an acid from oil of turpentine [adj]\n",
  "TEREBINTH": "a small Mediterranean tree yielding a resinous liquid [n -S]\n",
  "TEREBINTHINE": "of or relating to the terebinth; of, relating to or resembling turpentine [adj]\n",
  "TEREBINTHS": "TEREBINTH, a small Mediterranean tree yielding a resinous liquid [n]\n",
  "TEREBRA": "(Latin) a boring instrument [n TEREBRAS or TEREBRAE]\n",
  "TEREBRAE": "TEREBRA, (Latin) a boring instrument [n]\n",
  "TEREBRANT": "boring, having a piercing ovipositor [adj] / (facetious) a bore [n -S]\n",
  "TEREBRANTS": "TEREBRANT, (facetious) a bore [n]\n",
  "TEREBRAS": "TEREBRA, (Latin) a boring instrument [n]\n",
  "TEREBRATE": "to bore into; to pierce [v TEREBRATED, TEREBRATING, TEREBRATES]\n",
  "TEREBRATED": "TEREBRATE, to bore into; to pierce [v]\n",
  "TEREBRATES": "TEREBRATE, to bore into; to pierce [v]\n",
  "TEREBRATING": "TEREBRATE, to bore into; to pierce [v]\n",
  "TEREBRATION": "a pain that feels as though a drill is boring through some body part [n -S]\n",
  "TEREBRATIONS": "TEREBRATION, a pain that feels as though a drill is boring through some body part [n]\n",
  "TEREBRATULA": "a member of Terebratula, the lampshell genus of brachiopods, with perforated beak [n TEREBRATULAE or TEREBRATULAS]\n",
  "TEREBRATULAE": "TEREBRATULA, a member of Terebratula, the lampshell genus of brachiopods, with perforated beak [n]\n",
  "TEREBRATULAS": "TEREBRATULA, a member of Terebratula, the lampshell genus of brachiopods, with perforated beak [n]\n",
  "TEREDINES": "TEREDO, (Latin) a bivalve mollusk [n]\n",
  "TEREDO": "(Latin) a bivalve mollusk [n TEREDOS or TEREDINES]\n",
  "TEREDOS": "TEREDO, (Latin) a bivalve mollusk [n]\n",
  "TEREFA": "(Hebrew) not ritually clean, not kosher, also TEREFAH, TRAYF, TREF, TREFA, TREFAH, TREIF, TREIFA, TREYF, TREYFA [adj]\n",
  "TEREFAH": "(Hebrew) not ritually clean, not kosher, also TEREFA, TRAYF, TREF, TREFA, TREFAH, TREIF, TREIFA, TREYF, TREYFA [adj]\n",
  "TEREK": "(Russian) a kind of sandpiper [n -S]\n",
  "TEREKS": "TEREK, (Russian) a kind of sandpiper [n]\n",
  "TEREPHTHALATE": "a salt or ester of terephthalic acid [n -S]\n",
  "TEREPHTHALATES": "TEREPHTHALATE, a salt or ester of terephthalic acid [n]\n",
  "TEREPHTHALIC": "derived from or containing terebic and phthalic acids, as in terephthalic acid [adj]\n",
  "TERES": "(Latin) either of two muscles of the shoulder-blade [n TERETES or TERESES]\n",
  "TERESES": "TERES, (Latin) either of two muscles of the shoulder-blade [n]\n",
  "TERETE": "smooth-surfaced, cylindrical, and tapering at the ends [adj]\n",
  "TERETES": "TERES, (Latin) either of two muscles of the shoulder-blade [n]\n",
  "TERF": "(Milton) turf, also TERFE [n -S]\n",
  "TERFE": "(Milton) turf, also TERF [n -S]\n",
  "TERFES": "TERFE, (Milton) turf, also TERF [n]\n",
  "TERFS": "TERF, (Milton) turf, also TERFE [n]\n",
  "TERGA": "TERGUM, (Latin) the back of an arthropod, also TERGITE [n]\n",
  "TERGAL": "relating to the tergum, an insect's upper or dorsal surface, esp. of a body segment [adj]\n",
  "TERGITE": "the back of an arthropod, also TERGUM [n -S]\n",
  "TERGITES": "TERGITE, the back of an arthropod, also TERGUM [n]\n",
  "TERGIVERSANT": "one who tergiversates [n -S]\n",
  "TERGIVERSANTS": "TERGIVERSANT, one who tergiversates [n]\n",
  "TERGIVERSATE": "to turn one's back on one's party or cause; also, to make evasive statements or equivocate [v TERGIVERSATED, TERGIVERSATING, TERGIVERSATES]\n",
  "TERGIVERSATED": "TERGIVERSATE, to turn one's back on one's party or cause; also, to make evasive statements or equivocate [v]\n",
  "TERGIVERSATES": "TERGIVERSATE, to turn one's back on one's party or cause; also, to make evasive statements or equivocate [v]\n",
  "TERGIVERSATING": "TERGIVERSATE, to turn one's back on one's party or cause; also, to make evasive statements or equivocate [v]\n",
  "TERGIVERSATION": "desertion of a cause, position, party, or faith; equivocation [n -S]\n",
  "TERGIVERSATIONS": "TERGIVERSATION, desertion of a cause, position, party, or faith; equivocation [n]\n",
  "TERGIVERSATOR": "one who tergiversates, turning one's back on one's party or cause [n -S]\n",
  "TERGIVERSATORS": "TERGIVERSATOR, one who tergiversates, turning one's back on one's party or cause [n]\n",
  "TERGIVERSATORY": "of or like tergiversation, desertion of a cause, position, party, or faith [adj]\n",
  "TERGUM": "(Latin) the back of an arthropod, also TERGITE [n TERGA]\n",
  "TERIYAKI": "(Japanese) a dish of meat or shellfish [n -S]\n",
  "TERIYAKIS": "TERIYAKI, (Japanese) a dish of meat or shellfish [n]\n",
  "TERM": "to designate [v -ED, -ING, -S]\n",
  "TERMAGANCIES": "TERMAGANCY, the state of being a termagant [n]\n",
  "TERMAGANCY": "the state of being a termagant [n TERMAGANCIES]\n",
  "TERMAGANT": "a shrewish, bullying woman [n -S]\n",
  "TERMAGANTLY": "like a termagant, a shrewish, bullying woman [adj]\n",
  "TERMAGANTS": "TERMAGANT, a shrewish, bullying woman [n]\n",
  "TERMED": "TERM, to designate [v]\n",
  "TERMER": "a person who holds an estate for a term of years or for life, also TERMOR [n -S]\n",
  "TERMERS": "TERMER, a person who holds an estate for a term of years or for life, also TERMOR [n]\n",
  "TERMINABILITIES": "TERMINABILITY, the quality of being terminable [n]\n",
  "TERMINABILITY": "the quality of being terminable [n TERMINABILITIES]\n",
  "TERMINABLE": "capable of being terminated; limitable [adj TERMINABLY]\n",
  "TERMINABLENESS": "TERMINABLE, capable of being terminated; limitable [n]\n",
  "TERMINABLY": "TERMINABLE, capable of being terminated; limitable [adv]\n",
  "TERMINAL": "at the end [adj TERMINALLY] / an end or extremity [n -S]\n",
  "TERMINALLY": "TERMINAL, at the end [adv]\n",
  "TERMINALS": "TERMINAL, an end or extremity [n]\n",
  "TERMINATE": "to bring to an end [v TERMINATED, TERMINATING, TERMINATES]\n",
  "TERMINATED": "TERMINATE, to bring to an end [v]\n",
  "TERMINATES": "TERMINATE, to bring to an end [v]\n",
  "TERMINATING": "TERMINATE, to bring to an end [v]\n",
  "TERMINATION": "end in time or existence [n -S]\n",
  "TERMINATIONAL": "relating to termination [adj]\n",
  "TERMINATIONS": "TERMINATION, end in time or existence [n]\n",
  "TERMINATIVE": "expressive of completion [adj TERMINATIVELY]\n",
  "TERMINATIVELY": "TERMINATIVE, expressive of completion [adv]\n",
  "TERMINATOR": "something that terminates [n -S]\n",
  "TERMINATORS": "TERMINATOR, something that terminates [n]\n",
  "TERMINATORY": "serving as a terminator [adj]\n",
  "TERMINER": "(obsolete) a determining; as, in oyer and terminer [n -S]\n",
  "TERMINERS": "TERMINER, (obsolete) a determining; as, in oyer and terminer [n]\n",
  "TERMING": "TERM, to designate [v]\n",
  "TERMINI": "TERMINUS, (Latin) an end [n]\n",
  "TERMINISM": "the doctrine that there is a time limit for repentance [n -S]\n",
  "TERMINISMS": "TERMINISM, the doctrine that there is a time limit for repentance [n]\n",
  "TERMINIST": "a believer in terminism, the doctrine that there is a time limit for repentance [n -S]\n",
  "TERMINISTS": "TERMINIST, a believer in terminism, the doctrine that there is a time limit for repentance [n]\n",
  "TERMINOLOGICAL": "relating to terminology [adj]\n",
  "TERMINOLOGIES": "TERMINOLOGY, the technical or special terms used in a business, art, science, or special subject [n]\n",
  "TERMINOLOGIST": "a specialist in terminology [n -S]\n",
  "TERMINOLOGISTS": "TERMINOLOGIST, a specialist in terminology [n]\n",
  "TERMINOLOGY": "the technical or special terms used in a business, art, science, or special subject [n TERMINOLOGIES]\n",
  "TERMINUS": "(Latin) an end [n TERMINUSES or TERMINI]\n",
  "TERMINUSES": "TERMINUS, (Latin) an end [n]\n",
  "TERMITARIA": "TERMITARIUM, (Latin) a termite nest [n]\n",
  "TERMITARIES": "TERMITARY, a nest or mound of termites [n]\n",
  "TERMITARIUM": "(Latin) a termite nest [n TERMITARIA or TERMITARIUMS]\n",
  "TERMITARIUMS": "TERMITARIUM, (Latin) a termite nest [n]\n",
  "TERMITARY": "a nest or mound of termites [n TERMITARIES]\n",
  "TERMITE": "a so-called white ant, a pale-coloured insect of the order Isoptera [n -S]\n",
  "TERMITES": "TERMITE, a so-called white ant, a pale-coloured insect of the order Isoptera [n]\n",
  "TERMITIC": "of termites [adj]\n",
  "TERMLESS": "having no limits [adj]\n",
  "TERMLIES": "TERMLY, a publication once a term [n]\n",
  "TERMLY": "a publication once a term [n TERMLIES]\n",
  "TERMOR": "a person who holds an estate for a term of years or for life, also TERMER [n -S]\n",
  "TERMORS": "TERMOR, a person who holds an estate for a term of years or for life, also TERMER [n]\n",
  "TERMS": "TERM, to designate [v]\n",
  "TERMTIME": "the time when a school or court is in session [n -S]\n",
  "TERMTIMES": "TERMTIME, the time when a school or court is in session [n]\n",
  "TERN": "a long-winged aquatic bird, related to the gulls [n -S]\n",
  "TERNAL": "threefold [adj]\n",
  "TERNARIES": "TERNARY, a group of three [n]\n",
  "TERNARY": "a group of three [n TERNARIES]\n",
  "TERNATE": "with three leaflets [adj TERNATELY]\n",
  "TERNATELY": "TERNATE, with three leaflets [adv]\n",
  "TERNE": "to cover with an alloy of lead and tin [v TERNED, TERNING, TERNES]\n",
  "TERNED": "TERNE, to cover with an alloy of lead and tin [v]\n",
  "TERNEPLATE": "thin iron sheets coated with an alloy of lead and tin [n -S]\n",
  "TERNEPLATES": "TERNEPLATE, thin iron sheets coated with an alloy of lead and tin [n]\n",
  "TERNES": "TERNE, to cover with an alloy of lead and tin [v]\n",
  "TERNING": "TERNE, to cover with an alloy of lead and tin [v]\n",
  "TERNION": "a triad; a section of a book with three double leaves [n -S]\n",
  "TERNIONS": "TERNION, a triad; a section of a book with three double leaves [n]\n",
  "TERNS": "TERN, a long-winged aquatic bird, related to the gulls [n]\n",
  "TEROTECHNOLOGY": "the application of managerial, financial, engineering and other skills to extend the operational life of, and increase the efficiency of, equipment and machinery [n]\n",
  "TERPENE": "any of a class of volatile aromatic hydrocarbons, many of which occur in essential plant oils, esp. of conifers and citrus trees [n -S]\n",
  "TERPENELESS": "without terpenes [adj]\n",
  "TERPENES": "TERPENE, any of a class of volatile aromatic hydrocarbons, many of which occur in essential plant oils, esp. of conifers and citrus trees [n]\n",
  "TERPENIC": "relating to a terpene, an isomeric hydrocarbon [adj]\n",
  "TERPENOID": "any one of a series of isomeric hydrocarbons of pleasant aromatic odor [n -S]\n",
  "TERPENOIDS": "TERPENOID, any one of a series of isomeric hydrocarbons of pleasant aromatic odor [n]\n",
  "TERPINE": "a derivative of pinene and other terpenes [n -S]\n",
  "TERPINEOL": "a terpene alcohol used as a perfume base, also TERPINOL [n -S]\n",
  "TERPINEOLS": "TERPINEOL, a terpene alcohol used as a perfume base, also TERPINOL [n]\n",
  "TERPINES": "TERPINE, a derivative of pinene and other terpenes [n]\n",
  "TERPINOL": "a terpene alcohol used as a perfume base, also TERPINEOL [n -S]\n",
  "TERPINOLS": "TERPINOL, a terpene alcohol used as a perfume base, also TERPINEOL [n]\n",
  "TERPOLYMER": "a polymer such as a complex resin [n -S]\n",
  "TERPOLYMERS": "TERPOLYMER, a polymer such as a complex resin [n]\n",
  "TERPSICHOREAL": "of or relating to dancing, also TERPSICHOREAN [adj]\n",
  "TERPSICHOREAN": "of or relating to dancing, also TERPSICHOREAL [adj]\n",
  "TERRA": "(Latin) the earth [n TERRAE or TERRAS]\n",
  "TERRACE": "to form into raised banks [v TERRACED, TERRACING, TERRACES]\n",
  "TERRACED": "TERRACE, to form into raised banks [v]\n",
  "TERRACELESS": "without a terrace [adj]\n",
  "TERRACES": "TERRACE, to form into raised banks [v]\n",
  "TERRACETTE": "a small terrace on a slope resulting from soil creep or erosion; a sheeptrack [n -S]\n",
  "TERRACETTES": "TERRACETTE, a small terrace on a slope resulting from soil creep or erosion; a sheeptrack [n]\n",
  "TERRACING": "terraces collectively [n -S]\n",
  "TERRACINGS": "TERRACING, terraces collectively [n]\n",
  "TERRACOTTA": "(Italian) reddish-brown [adj] / a type of pottery [n -S]\n",
  "TERRACOTTAS": "TERRACOTTA, a type of pottery [n]\n",
  "TERRAE": "TERRA, (Latin) the earth [n]\n",
  "TERRAFORM": "to make (another planet) earthlike [v -ED, -ING, -S]\n",
  "TERRAFORMED": "TERRAFORM, to make (another planet) earthlike [v]\n",
  "TERRAFORMING": "the act of making another planet earthlike [n -S]\n",
  "TERRAFORMINGS": "TERRAFORMING, the act of making another planet earthlike [n]\n",
  "TERRAFORMS": "TERRAFORM, to make (another planet) earthlike [v]\n",
  "TERRAIN": "(French) a tract of land [n -S]\n",
  "TERRAINS": "TERRAIN, (French) a tract of land [n]\n",
  "TERRAMARA": "(Italian) a dark earthy deposit formed under prehistoric pile-dwellings in Italy, also TERRAMARE [n TERRAMARE or TERRAMARAS]\n",
  "TERRAMARAS": "TERRAMARA, (Italian) a dark earthy deposit formed under prehistoric pile-dwellings in Italy, also TERRAMARE [n]\n",
  "TERRAMARE": "(Italian) a dark earthy deposit formed under prehistoric pile-dwellings in Italy, also TERRAMARA [n -S]\n",
  "TERRAMARES": "TERRAMARE, (Italian) a dark earthy deposit formed under prehistoric pile-dwellings in Italy, also TERRAMARA [n]\n",
  "TERRANE": "a kind of rock formation [n -S]\n",
  "TERRANES": "TERRANE, a kind of rock formation [n]\n",
  "TERRAPIN": "any of various webfooted pond or river turtles [n -S]\n",
  "TERRAPINS": "TERRAPIN, any of various webfooted pond or river turtles [n]\n",
  "TERRAQUEOUS": "consisting of land and water, as the earth [adj]\n",
  "TERRARIA": "TERRARIUM, (Latin) a glass enclosure for plants [n]\n",
  "TERRARIUM": "(Latin) a glass enclosure for plants [n TERRARIUMS or TERRARIA]\n",
  "TERRARIUMS": "TERRARIUM, (Latin) a glass enclosure for plants [n]\n",
  "TERRAS": "(Dutch) an earthy volcanic tuff used as a hydraulic cement, also TARRAS, TRASS [n -ES]\n",
  "TERRASES": "TERRAS, (Dutch) an earthy volcanic tuff used as a hydraulic cement, also TARRAS, TRASS [n]\n",
  "TERRASSE": "(French) a paved area outside a French cafe [n -S]\n",
  "TERRASSES": "TERRASSE, (French) a paved area outside a French cafe [n]\n",
  "TERRAZZO": "(Italian) a flooring of marble chips set in mortar and then polished [n -S]\n",
  "TERRAZZOS": "TERRAZZO, (Italian) a flooring of marble chips set in mortar and then polished [n]\n",
  "TERREEN": "an earthenware jar, also TERRINE [n -S]\n",
  "TERREENS": "TERREEN, an earthenware jar, also TERRINE [n]\n",
  "TERRELLA": "a spherical magnet [n -S]\n",
  "TERRELLAS": "TERRELLA, a spherical magnet [n]\n",
  "TERREMOTIVE": "related to an earthquake [adj]\n",
  "TERRENE": "earthly [adj TERRENELY] / the world, a region [n -S]\n",
  "TERRENELY": "TERRENE, earthly [adv]\n",
  "TERRENES": "TERRENE, the world, a region [n]\n",
  "TERREPLEIN": "(French) a horizontal platform behind a parapet where heavy guns are mounted [n -S]\n",
  "TERREPLEINS": "TERREPLEIN, (French) a horizontal platform behind a parapet where heavy guns are mounted [n]\n",
  "TERRESTRIAL": "living on land [adj TERRESTRIALLY] / a creature living on land [n -S]\n",
  "TERRESTRIALLY": "TERRESTRIAL, living on land [adv]\n",
  "TERRESTRIALNESS": "the state of being terrestrial [n]\n",
  "TERRESTRIALS": "TERRESTRIAL, a creature living on land [n]\n",
  "TERRET": "a metal ring on a harness, also TERRIT [n -S]\n",
  "TERRETS": "TERRET, a metal ring on a harness, also TERRIT [n]\n",
  "TERRIBILITIES": "TERRIBILITY, the state of being terrible [n]\n",
  "TERRIBILITY": "the state of being terrible [n TERRIBILITIES]\n",
  "TERRIBLE": "awful [adj TERRIBLY] / a terrible thing [n -S]\n",
  "TERRIBLENESS": "the state of being terrible [n -ES]\n",
  "TERRIBLENESSES": "TERRIBLENESS, the state of being terrible [n]\n",
  "TERRIBLES": "TERRIBLE, a terrible thing [n]\n",
  "TERRIBLY": "TERRIBLE, awful [adv]\n",
  "TERRICOLE": "a land animal or plant; a burrower [n -S]\n",
  "TERRICOLES": "TERRICOLE, a land animal or plant; a burrower [n]\n",
  "TERRICOLOUS": "living in or on the soil [adj]\n",
  "TERRIER": "a small dog of various breeds, originally one that would follow burrowing animals underground [n -S]\n",
  "TERRIERS": "TERRIER, a small dog of various breeds, originally one that would follow burrowing animals underground [n]\n",
  "TERRIES": "TERRY, an absorbent fabric [n]\n",
  "TERRIFIC": "marvellous [adj TERRIFICALLY]\n",
  "TERRIFICALLY": "TERRIFIC, marvellous [adv]\n",
  "TERRIFIED": "TERRIFY, to cause terror in [v]\n",
  "TERRIFIER": "one who terrifies [n -S]\n",
  "TERRIFIERS": "TERRIFIER, one who terrifies [n]\n",
  "TERRIFIES": "TERRIFY, to cause terror in [v]\n",
  "TERRIFY": "to cause terror in [v TERRIFIED, TERRIFYING, TERRIFIES]\n",
  "TERRIFYING": "TERRIFY, to cause terror in [v]\n",
  "TERRIFYINGLY": "TERRIFYING, TERRIFY, to cause terror in [adv]\n",
  "TERRIGENOUS": "produced on land; produced by the land [adj]\n",
  "TERRINE": "(French) an earthenware jar or dish; a pate of meat or fish cooked in this [n -S]\n",
  "TERRINES": "TERRINE, (French) an earthenware jar or dish; a pate of meat or fish cooked in this [n]\n",
  "TERRIT": "a metal ring on a harness through which the reins pass, also TERRET, TORRET [n -S]\n",
  "TERRITORIAL": "relating to territory [adj TERRITORIALLY] / a member of a territorial military unit [n -S]\n",
  "TERRITORIALISE": "to organize on a territorial basis, also TERRITORIALIZE [v TERRITORIALISED, TERRITORIALISES]\n",
  "TERRITORIALISED": "TERRITORIALISE, to organize on a territorial basis, also TERRITORIALIZE [v]\n",
  "TERRITORIALISES": "TERRITORIALISE, to organize on a territorial basis, also TERRITORIALIZE [v]\n",
  "TERRITORIALISM": "a social system in which the landowning class is dominant, organized on a territorial basis [n -S]\n",
  "TERRITORIALISMS": "TERRITORIALISM, a social system in which the landowning class is dominant, organized on a territorial basis [n]\n",
  "TERRITORIALIST": "a supporter of territorialism [n -S]\n",
  "TERRITORIALISTS": "TERRITORIALIST, a supporter of territorialism [n]\n",
  "TERRITORIALITY": "the state of being territorial [n]\n",
  "TERRITORIALIZE": "to organize on a territorial basis, also TERRITORIALISE [v TERRITORIALIZED, TERRITORIALIZES]\n",
  "TERRITORIALIZED": "TERRITORIALIZE, to organize on a territorial basis, also TERRITORIALISE [v]\n",
  "TERRITORIALIZES": "TERRITORIALIZE, to organize on a territorial basis, also TERRITORIALISE [v]\n",
  "TERRITORIALLY": "TERRITORIAL, relating to territory [adv]\n",
  "TERRITORIALS": "TERRITORIAL, a member of a territorial military unit [n]\n",
  "TERRITORIED": "having territory [adj]\n",
  "TERRITORIES": "TERRITORY, possessions in land; the whole, or a portion, of the land belonging to a state [n]\n",
  "TERRITORY": "possessions in land; the whole, or a portion, of the land belonging to a state [n TERRITORIES]\n",
  "TERRITS": "TERRIT, a metal ring on a harness through which the reins pass, also TERRET, TORRET [n]\n",
  "TERROIR": "(French) the combination of factors, such as soil and climate, that gives a wine its character [n -S]\n",
  "TERROIRS": "TERROIR, (French) the combination of factors, such as soil and climate, that gives a wine its character [n]\n",
  "TERROR": "intense fear [n -S]\n",
  "TERRORFUL": "full of terror [adj]\n",
  "TERRORISATION": "the act of terrorising, also TERRORIZATION [n -S]\n",
  "TERRORISATIONS": "TERRORISATION, the act of terrorising, also TERRORIZATION [n]\n",
  "TERRORISE": "to inflict terror on, also TERRORIZE [v TERRORISED, TERRORISING, TERRORISES]\n",
  "TERRORISED": "TERRORISE, to inflict terror on, also TERRORIZE [v]\n",
  "TERRORISER": "one who terrorises, also TERRORIZER [n -S]\n",
  "TERRORISERS": "TERRORISER, one who terrorises, also TERRORIZER [n]\n",
  "TERRORISES": "TERRORISE, to inflict terror on, also TERRORIZE [v]\n",
  "TERRORISING": "TERRORISE, to inflict terror on, also TERRORIZE [v]\n",
  "TERRORISM": "an organized system of violence and intimidation, esp. for political ends [n -S]\n",
  "TERRORISMS": "TERRORISM, an organized system of violence and intimidation, esp. for political ends [n]\n",
  "TERRORIST": "one who engages in terrorism [n -S]\n",
  "TERRORISTIC": "relating to terrorism [adj]\n",
  "TERRORISTS": "TERRORIST, one who engages in terrorism [n]\n",
  "TERRORIZATION": "the act of terrorizing, also TERRORISATION [n -S]\n",
  "TERRORIZATIONS": "TERRORIZATION, the act of terrorizing, also TERRORISATION [n]\n",
  "TERRORIZE": "to inflict terror on, also TERRORISE [v TERRORIZED, TERRORIZING, TERRORIZES]\n",
  "TERRORIZED": "TERRORIZE, to inflict terror on, also TERRORISE [v]\n",
  "TERRORIZER": "one who terrorises, also TERRORISER [n -S]\n",
  "TERRORIZERS": "TERRORIZER, one who terrorises, also TERRORISER [n]\n",
  "TERRORIZES": "TERRORIZE, to inflict terror on, also TERRORISE [v]\n",
  "TERRORIZING": "TERRORIZE, to inflict terror on, also TERRORISE [v]\n",
  "TERRORLESS": "free from terror [adj]\n",
  "TERRORS": "TERROR, intense fear [n]\n",
  "TERRY": "an absorbent fabric [n TERRIES]\n",
  "TERSANCTUS": "(Latin) the hymn beginning 'Sanctus, sanctus, sanctus', which forms the conclusion of the Eucharistic preface [n -ES]\n",
  "TERSANCTUSES": "TERSANCTUS, (Latin) the hymn beginning 'Sanctus, sanctus, sanctus', which forms the conclusion of the Eucharistic preface [n]\n",
  "TERSE": "succinct [adj TERSER, TERSEST, TERSELY]\n",
  "TERSELY": "TERSE, succinct [adv]\n",
  "TERSENESS": "the state of being terse [n -ES]\n",
  "TERSENESSES": "TERSENESS, the state of being terse [n]\n",
  "TERSER": "TERSE, succinct [adj]\n",
  "TERSEST": "TERSE, succinct [adj]\n",
  "TERSION": "the act of wiping [n -S]\n",
  "TERSIONS": "TERSION, the act of wiping [n]\n",
  "TERTIA": "(Scott) an infantry regiment, originally Spanish, also TERCIO [n -S]\n",
  "TERTIAL": "a flight feather of a bird's wing, also TERTIARY [n -S]\n",
  "TERTIALS": "TERTIAL, a flight feather of a bird's wing, also TERTIARY [n]\n",
  "TERTIAN": "a fever recurring every third day [n -S]\n",
  "TERTIANS": "TERTIAN, a fever recurring every third day [n]\n",
  "TERTIARIES": "TERTIARY, a flight feather of a bird's wing, also TERTIAL [n]\n",
  "TERTIARY": "a flight feather of a bird's wing, also TERTIAL [n TERTIARIES]\n",
  "TERTIAS": "TERTIA, (Scott) an infantry regiment, originally Spanish, also TERCIO [n]\n",
  "TERTIUM": "(Latin) something neither one thing or its opposite [n TERTIA]\n",
  "TERTIUS": "(Latin) the third person [n -ES]\n",
  "TERTIUSES": "TERTIUS, (Latin) the third person [n]\n",
  "TERTS": "(short for) tetrachlorethylene, a chemical [n]\n",
  "TERVALENCIES": "TERVALENCY, the state of being trivalent, also TRIVALENCE, TRIVALENCY [n]\n",
  "TERVALENCY": "the state of being trivalent, also TRIVALENCE, TRIVALENCY [n TERVALENCIES]\n",
  "TERVALENT": "having a valency of three [adj]\n",
  "TERYLENE": "a kind of polyester fabric [n -S]\n",
  "TERYLENES": "TERYLENE, a kind of polyester fabric [n]\n",
  "TERZETTA": "(Italian) a triplet of lines that rhyme together or are connected with adjacent rhymes, also TERCET, TIERCET [n -S]\n",
  "TERZETTAS": "TERZETTA, (Italian) a triplet of lines that rhyme together or are connected with adjacent rhymes, also TERCET, TIERCET [n]\n",
  "TERZETTI": "TERZETTO, (Italian) a composition in three voice parts; a vocal (rarely an instrumental) trio [n]\n",
  "TERZETTO": "(Italian) a composition in three voice parts; a vocal (rarely an instrumental) trio [n TERZETTI or TERZETTOS]\n",
  "TERZETTOS": "TERZETTO, (Italian) a composition in three voice parts; a vocal (rarely an instrumental) trio [n]\n",
  "TES": "TE, (in tonic sol-fa) the seventh degree of any major scale [n]\n",
  "TESCHENITE": "a coarse-grained basic igneous rock composed of plagioclase and augite [n -S]\n",
  "TESCHENITES": "TESCHENITE, a coarse-grained basic igneous rock composed of plagioclase and augite [n]\n",
  "TESLA": "a unit of magnetic flux density equal to one weber per square meter [n -S]\n",
  "TESLAS": "TESLA, a unit of magnetic flux density equal to one weber per square meter [n]\n",
  "TESSARAGLOT": "speaking four languages [adj]\n",
  "TESSELATE": "to cover with small tiles, also TESSELLATE [v TESSELATED, TESSELATING, TESSELATES]\n",
  "TESSELATED": "TESSELATE, to cover with small tiles, also TESSELLATE [v]\n",
  "TESSELATES": "TESSELATE, to cover with small tiles, also TESSELLATE [v]\n",
  "TESSELATING": "TESSELATE, to cover with small tiles, also TESSELLATE [v]\n",
  "TESSELLA": "(Latin) a small tessera, a square block of marble, glass, tile, etc., used in mosaic [n TESSELLAE]\n",
  "TESSELLAE": "TESSELLA, (Latin) a small tessera, a square block of marble, glass, tile, etc., used in mosaic [n]\n",
  "TESSELLAR": "like a tessella, a small tessera, a token or ticket [adj]\n",
  "TESSELLATE": "to cover with small tiles, also TESSELATE [v TESSELLATED, TESSELLATING, TESSELLATES]\n",
  "TESSELLATED": "TESSELLATE, to cover with small tiles, also TESSELATE [v]\n",
  "TESSELLATES": "TESSELLATE, to cover with small tiles, also TESSELATE [v]\n",
  "TESSELLATING": "TESSELLATE, to cover with small tiles, also TESSELATE [v]\n",
  "TESSELLATION": "fitting together exactly; leaving no spaces [n -S]\n",
  "TESSELLATIONS": "TESSELLATION, fitting together exactly; leaving no spaces [n]\n",
  "TESSERA": "(Latin) a small piece of stone, glass or tile used in mosaic [n TESSERAE]\n",
  "TESSERACT": "a figure of a cube within a cube [n -S]\n",
  "TESSERACTS": "TESSERACT, a figure of a cube within a cube [n]\n",
  "TESSERAE": "TESSERA, (Latin) a small piece of stone, glass or tile used in mosaic [n]\n",
  "TESSERAL": "of, pertaining to, or containing, tesserae, small blocks of stone used in a mosaic [adj]\n",
  "TESSITURA": "(Italian) the ordinary range of pitch of a voice or vocal piece of music [n TESSITURAS or TESSITURE]\n",
  "TESSITURAS": "TESSITURA, (Italian) the ordinary range of pitch of a voice or vocal piece of music [n]\n",
  "TESSITURE": "TESSITURA, (Italian) the ordinary range of pitch of a voice or vocal piece of music [n]\n",
  "TEST": "to examine critically [v -ED, -ING, -S]\n",
  "TESTA": "(Latin) the hard external covering of a seed [n TESTAE]\n",
  "TESTABILITIES": "TESTABILITY, the ability to be tested [n]\n",
  "TESTABILITY": "the ability to be tested [n TESTABILITIES]\n",
  "TESTABLE": "able to be tested [adj]\n",
  "TESTACEAN": "a microscopic animal with a hard shell [n -S]\n",
  "TESTACEANS": "TESTACEAN, a microscopic animal with a hard shell [n]\n",
  "TESTACEOUS": "having a hard shell; brick-red [adj]\n",
  "TESTACIES": "TESTACY, the state of being testate [n]\n",
  "TESTACY": "the state of being testate [n TESTACIES]\n",
  "TESTAE": "TESTA, (Latin) the hard external covering of a seed [n]\n",
  "TESTAMENT": "that which testifies; a will [n -S]\n",
  "TESTAMENTAL": "relating to a testament or will; bequeathed or done by will, also TESTAMENTAR, TESTAMENTARY [adj]\n",
  "TESTAMENTAR": "relating to a testament or will; bequeathed or done by will, also TESTAMENTAL, TESTAMENTARY [adj]\n",
  "TESTAMENTARILY": "TESTAMENTARY, relating to a testament or will; bequeathed or done by will, also TESTAMENTAL, TESTAMENTAR [adv]\n",
  "TESTAMENTARY": "relating to a testament or will; bequeathed or done by will, also TESTAMENTAL, TESTAMENTAR [adj TESTAMENTARILY]\n",
  "TESTAMENTS": "TESTAMENT, that which testifies; a will [n]\n",
  "TESTAMUR": "(Latin) a certificate of having passed an examination [n -S]\n",
  "TESTAMURS": "TESTAMUR, (Latin) a certificate of having passed an examination [n]\n",
  "TESTATA": "TESTATUM, (Latin) one of the clauses of an English deed [n]\n",
  "TESTATE": "one who makes a will, also TESTATOR [n -S]\n",
  "TESTATES": "TESTATE, one who makes a will, also TESTATOR [n]\n",
  "TESTATION": "a witnessing or witness [n -S]\n",
  "TESTATIONS": "TESTATION, a witnessing or witness [n]\n",
  "TESTATOR": "one who makes a will, also TESTATE [n -S]\n",
  "TESTATORS": "TESTATOR, one who makes a will, also TESTATE [n]\n",
  "TESTATRICES": "TESTATRIX, a (female) person who leaves a valid will at death [n]\n",
  "TESTATRIX": "a (female) person who leaves a valid will at death [n TESTATRIXES or TESTATRICES]\n",
  "TESTATRIXES": "TESTATRIX, a (female) person who leaves a valid will at death [n]\n",
  "TESTATUM": "(Latin) one of the clauses of an English deed [n TESTATA or TESTATUMS]\n",
  "TESTATUMS": "TESTATUM, (Latin) one of the clauses of an English deed [n]\n",
  "TESTCROSS": "a type of genetic cross [n -ES] / to make a testcross [v -ED, -ING, -ES]\n",
  "TESTCROSSED": "TESTCROSS, to make a testcross [v]\n",
  "TESTCROSSES": "TESTCROSS, to make a testcross [v]\n",
  "TESTCROSSING": "TESTCROSS, to make a testcross [v]\n",
  "TESTE": "(Latin) on the authority or testimony of (a specified person) [prep]\n",
  "TESTED": "TEST, to examine critically [v]\n",
  "TESTEE": "one who is tested [n -S]\n",
  "TESTEES": "TESTEE, one who is tested [n]\n",
  "TESTER": "a canopy over a bed [n -S]\n",
  "TESTERN": "(Shakespeare) to reward with sixpence [v -ED, -ING, -S]\n",
  "TESTERNED": "TESTERN, (Shakespeare) to reward with sixpence [v]\n",
  "TESTERNING": "TESTERN, (Shakespeare) to reward with sixpence [v]\n",
  "TESTERNS": "TESTERN, (Shakespeare) to reward with sixpence [v]\n",
  "TESTERS": "TESTER, a canopy over a bed [n]\n",
  "TESTES": "TESTIS, (Latin) a male reproductive gland, also TESTICLE [n]\n",
  "TESTICLE": "a male reproductive gland, also TESTIS [n -S]\n",
  "TESTICLES": "TESTICLE, a male reproductive gland, also TESTIS [n]\n",
  "TESTICULAR": "of or pertaining to the testicle [adj]\n",
  "TESTICULATE": "like a testicle, esp. in shape, also TESTICULATED [adj]\n",
  "TESTICULATED": "like a testicle, esp. in shape, also TESTICULATE [adj]\n",
  "TESTIER": "TESTY, irritable [adj]\n",
  "TESTIEST": "TESTY, irritable [adj]\n",
  "TESTIFICATE": "in Scots law, a solemn written assertion [n -S]\n",
  "TESTIFICATES": "TESTIFICATE, in Scots law, a solemn written assertion [n]\n",
  "TESTIFICATION": "the act of testifying or of bearing witness [n -S]\n",
  "TESTIFICATIONS": "TESTIFICATION, the act of testifying or of bearing witness [n]\n",
  "TESTIFICATOR": "one who testifies [n -S]\n",
  "TESTIFICATORS": "TESTIFICATOR, one who testifies [n]\n",
  "TESTIFICATORY": "bearing witness [adj]\n",
  "TESTIFIED": "TESTIFY, to bear witness [v]\n",
  "TESTIFIER": "one who testifies [n -S]\n",
  "TESTIFIERS": "TESTIFIER, one who testifies [n]\n",
  "TESTIFIES": "TESTIFY, to bear witness [v]\n",
  "TESTIFY": "to bear witness [v TESTIFIED, TESTIFYING, TESTIFIES]\n",
  "TESTIFYING": "TESTIFY, to bear witness [v]\n",
  "TESTILY": "TESTY, irritable [adv]\n",
  "TESTIMONIAL": "a written attestation [n -S]\n",
  "TESTIMONIALISE": "to present with a testimonial, also TESTIMONIALIZE [v TESTIMONIALISED, TESTIMONIALISES]\n",
  "TESTIMONIALISED": "TESTIMONIALISE, to present with a testimonial, also TESTIMONIALIZE [v]\n",
  "TESTIMONIALISES": "TESTIMONIALISE, to present with a testimonial, also TESTIMONIALIZE [v]\n",
  "TESTIMONIALIZE": "to present with a testimonial, also TESTIMONIALISE [v TESTIMONIALIZED, TESTIMONIALIZES]\n",
  "TESTIMONIALIZED": "TESTIMONIALIZE, to present with a testimonial, also TESTIMONIALISE [v]\n",
  "TESTIMONIALIZES": "TESTIMONIALIZE, to present with a testimonial, also TESTIMONIALISE [v]\n",
  "TESTIMONIALS": "TESTIMONIAL, a written attestation [n]\n",
  "TESTIMONIED": "TESTIMONY, (Shakespeare) to testify [v]\n",
  "TESTIMONIES": "TESTIMONY, (Shakespeare) to testify [v]\n",
  "TESTIMONY": "evidence [n TESTIMONIES] / (Shakespeare) to testify [v TESTIMONIED, TESTIMONYING, TESTIMONIES]\n",
  "TESTIMONYING": "TESTIMONY, (Shakespeare) to testify [v]\n",
  "TESTINESS": "the state of being testy [n -ES]\n",
  "TESTINESSES": "TESTINESS, the state of being testy [n]\n",
  "TESTING": "the act of testing [n -S]\n",
  "TESTINGS": "TESTING, the act of testing [n]\n",
  "TESTIS": "(Latin) a male reproductive gland, also TESTICLE [n TESTES]\n",
  "TESTON": "a name for various silver coins, originally bearing a king's or duke's head [n -S]\n",
  "TESTONS": "TESTON, a name for various silver coins, originally bearing a king's or duke's head [n]\n",
  "TESTOON": "a Portuguese or Italian teston, a kind of coin [n -S]\n",
  "TESTOONS": "TESTOON, a Portuguese or Italian teston, a kind of coin [n]\n",
  "TESTOSTERONE": "the chief male sex hormone, a steroid secreted by the testes [n -S]\n",
  "TESTOSTERONES": "TESTOSTERONE, the chief male sex hormone, a steroid secreted by the testes [n]\n",
  "TESTRIL": "(obsolete) a sixpence, also TESTRILL [n -S]\n",
  "TESTRILL": "(obsolete) a sixpence, also TESTRIL [n -S]\n",
  "TESTRILLS": "TESTRILL, (obsolete) a sixpence, also TESTRIL [n]\n",
  "TESTRILS": "TESTRIL, (obsolete) a sixpence, also TESTRILL [n]\n",
  "TESTS": "TEST, to examine critically [v]\n",
  "TESTUDINAL": "like a tortoiseshell or testudo, also TESTUDINARY, TESTUDINEOUS [adj]\n",
  "TESTUDINARY": "like a tortoiseshell or testudo, also TESTUDINAL, TESTUDINEOUS [adj]\n",
  "TESTUDINEOUS": "like a tortoiseshell or testudo, also TESTUDINAL, TESTUDINARY [adj]\n",
  "TESTUDINES": "TESTUDO, (Latin) a wheeled shelter used in assaults for protection from above attacks [n]\n",
  "TESTUDO": "(Latin) a wheeled shelter used in assaults for protection from above attacks [n TESTUDOS or TESTUDINES]\n",
  "TESTUDOS": "TESTUDO, (Latin) a wheeled shelter used in assaults for protection from above attacks [n]\n",
  "TESTY": "irritable [adj TESTIER, TESTIEST, TESTILY]\n",
  "TET": "(Hebrew) a letter of the Hebrew alphabet, also TETH [n -S]\n",
  "TETANAL": "relating to tetanus [adj]\n",
  "TETANIC": "related to tetanus, also TETANICAL [adj TETANICALLY] / an agent causing tetanus, a drug used to treat tetanus [n -S]\n",
  "TETANICAL": "relating to tetanus, also TETANIC [adj TETANICALLY]\n",
  "TETANICALLY": "TETANICAL, relating to tetanus, also TETANIC [adv]\n",
  "TETANICS": "TETANIC, an agent causing tetanus, a drug used to treat tetanus [n]\n",
  "TETANIES": "TETANY, a morbid condition resembling tetanus, but distinguished from it by being less severe and having intermittent spasms [n]\n",
  "TETANISATION": "infection with tetanus, also TETANIZATION [n -S]\n",
  "TETANISATIONS": "TETANISATION, infection with tetanus, also TETANIZATION [n]\n",
  "TETANISE": "to affect with convulsions, also TETANIZE [v TETANISED, TETANISING, TETANISES]\n",
  "TETANISED": "TETANISE, to affect with convulsions, also TETANIZE [v]\n",
  "TETANISES": "TETANISE, to affect with convulsions, also TETANIZE [v]\n",
  "TETANISING": "TETANISE, to affect with convulsions, also TETANIZE [v]\n",
  "TETANIZATION": "infection with tetanus, also TETANISATION [n -S]\n",
  "TETANIZATIONS": "TETANIZATION, infection with tetanus, also TETANISATION [n]\n",
  "TETANIZE": "to affect with convulsions, also TETANISE [v TETANIZED, TETANIZING, TETANIZES]\n",
  "TETANIZED": "TETANIZE, to affect with convulsions, also TETANISE [v]\n",
  "TETANIZES": "TETANIZE, to affect with convulsions, also TETANISE [v]\n",
  "TETANIZING": "TETANIZE, to affect with convulsions, also TETANISE [v]\n",
  "TETANOID": "resembling tetanus [adj]\n",
  "TETANUS": "(Latin) a disease due to a bacillus, marked by painful tonic spasms of the muscles of the jaw; aka lockjaw [n -ES]\n",
  "TETANUSES": "TETANUS, (Latin) a disease due to a bacillus, marked by painful tonic spasms of the muscles of the jaw; aka lockjaw [n]\n",
  "TETANY": "a morbid condition resembling tetanus, but distinguished from it by being less severe and having intermittent spasms [n TETANIES]\n",
  "TETARTOHEDRAL": "having one fourth the number of planes required by complete symmetry [adj TETARTOHEDRALLY]\n",
  "TETARTOHEDRALLY": "TETARTOHEDRAL, having one fourth the number of planes required by complete symmetry [adv]\n",
  "TETARTOHEDRISM": "the state of being tetartohedral, having one fourth the number of planes required by complete symmetry [n -S]\n",
  "TETARTOHEDRISMS": "TETARTOHEDRISM, the state of being tetartohedral, having one fourth the number of planes required by complete symmetry [n]\n",
  "TETCHED": "(colloquial) crazy, also TECHED [adj]\n",
  "TETCHIER": "TETCHY, peevish, fretful, also TEACHIE, TECHY [adj]\n",
  "TETCHIEST": "TETCHY, peevish, fretful, also TEACHIE, TECHY [adj]\n",
  "TETCHILY": "TETCHY, peevish, fretful, also TEACHIE, TECHY [adv]\n",
  "TETCHINESS": "the state of being tetchy [n -ES]\n",
  "TETCHINESSES": "TETCHINESS, the state of being tetchy [n]\n",
  "TETCHY": "peevish, fretful, also TEACHIE, TECHY [adj TETCHIER, TETCHIEST, TETCHILY]\n",
  "TETE": "(French) an elaborately dressed head of hair; a headdress [n -S]\n",
  "TETES": "TETE, (French) an elaborately dressed head of hair; a headdress [n]\n",
  "TETH": "(Hebrew) a letter of the Hebrew alphabet, also TET [n -S]\n",
  "TETHER": "to confine with a rope [v -ED, -ING, -S]\n",
  "TETHERBALL": "a ball suspended by a string from a pole [n -S]\n",
  "TETHERBALLS": "TETHERBALL, a ball suspended by a string from a pole [n]\n",
  "TETHERED": "TETHER, to confine with a rope [v]\n",
  "TETHERING": "TETHER, to confine with a rope [v]\n",
  "TETHERS": "TETHER, to confine with a rope [v]\n",
  "TETHS": "TETH, (Hebrew) a letter of the Hebrew alphabet, also TET [n]\n",
  "TETOTUM": "a child's toy, somewhat resembling a top, and twirled by the fingers, also TEETOTUM [n -S]\n",
  "TETOTUMS": "TETOTUM, a child's toy, somewhat resembling a top, and twirled by the fingers, also TEETOTUM [n]\n",
  "TETRA": "any of various small, often brightly coloured tropical freshwater fishes of the characin family [n -S]\n",
  "TETRABASIC": "of acids, having four replaceable hydrogen atoms [adj]\n",
  "TETRABASICITIES": "TETRABASICITY, the state of being tetrabasic [n]\n",
  "TETRABASICITY": "the state of being tetrabasic [n TETRABASICITIES]\n",
  "TETRABORATE": "a salt, ester, or anion of boric acid [n -S]\n",
  "TETRABORATES": "TETRABORATE, a salt, ester, or anion of boric acid [n]\n",
  "TETRABRACH": "in classical prosody, a word or metrical foot composed of four short syllables [n -S]\n",
  "TETRABRACHS": "TETRABRACH, in classical prosody, a word or metrical foot composed of four short syllables [n]\n",
  "TETRABRANCHIATE": "any mollusc belonging to the Tetrabranchia, with four gills [n]\n",
  "TETRACAINE": "a crystalline basic ester [n -S]\n",
  "TETRACAINES": "TETRACAINE, a crystalline basic ester [n]\n",
  "TETRACHLORIDE": "a chloride containing four atoms of chlorine [n -S]\n",
  "TETRACHLORIDES": "TETRACHLORIDE, a chloride containing four atoms of chlorine [n]\n",
  "TETRACHORD": "a series of four sounds, forming a scale of two tones and a half [n -S]\n",
  "TETRACHORDAL": "having four chords [adj]\n",
  "TETRACHORDS": "TETRACHORD, a series of four sounds, forming a scale of two tones and a half [n]\n",
  "TETRACHOTOMIES": "TETRACHOTOMY, division in fours [n]\n",
  "TETRACHOTOMOUS": "divided into fours [adj]\n",
  "TETRACHOTOMY": "division in fours [n TETRACHOTOMIES]\n",
  "TETRACID": "a substance capable of neutralizing four molecules of a monobasic acid [n -S]\n",
  "TETRACIDS": "TETRACID, a substance capable of neutralizing four molecules of a monobasic acid [n]\n",
  "TETRACT": "a sponge spicule, also TETRAXON [n -S]\n",
  "TETRACTINAL": "a sponge spicule having four rays, also TETRACTINE [n -S]\n",
  "TETRACTINALS": "TETRACTINAL, a sponge spicule having four rays, also TETRACTINE [n]\n",
  "TETRACTINE": "a sponge spicule having four rays, also TETRACTINAL [n -S]\n",
  "TETRACTINES": "TETRACTINE, a sponge spicule having four rays, also TETRACTINAL [n]\n",
  "TETRACTS": "TETRACT, a sponge spicule, also TETRAXON [n]\n",
  "TETRACYCLIC": "of, in or with four whorls or rings [adj]\n",
  "TETRACYCLINE": "a yellow crystalline broad-spectrum antibiotic produced by streptomyces or synthetically [n -S]\n",
  "TETRACYCLINES": "TETRACYCLINE, a yellow crystalline broad-spectrum antibiotic produced by streptomyces or synthetically [n]\n",
  "TETRAD": "a group of four [n -S]\n",
  "TETRADACTYL": "a four-toed animal [n -S]\n",
  "TETRADACTYLIES": "TETRADACTYLY, the state of being a tetradactyl, a four-toed animal [n]\n",
  "TETRADACTYLOUS": "having four fingers [adj]\n",
  "TETRADACTYLS": "TETRADACTYL, a four-toed animal [n]\n",
  "TETRADACTYLY": "the state of being a tetradactyl, a four-toed animal [n TETRADACTYLIES]\n",
  "TETRADIC": "of or pertaining to a tetrad; as, a carbon is a tetradic element [adj]\n",
  "TETRADITE": "a person who attaches mystic properties to the number four; a believer in a godhead of four persons [n -S]\n",
  "TETRADITES": "TETRADITE, a person who attaches mystic properties to the number four; a believer in a godhead of four persons [n]\n",
  "TETRADRACHM": "(Greek) a unit of Greek currency [n -S]\n",
  "TETRADRACHMS": "TETRADRACHM, (Greek) a unit of Greek currency [n]\n",
  "TETRADS": "TETRAD, a group of four [n]\n",
  "TETRADYMITE": "bismuth ore [n -S]\n",
  "TETRADYMITES": "TETRADYMITE, bismuth ore [n]\n",
  "TETRADYNAMOUS": "having six stamens, two shorter than the other four [adj]\n",
  "TETRAETHYL": "a compound with four ethyl groups [n -S]\n",
  "TETRAETHYLLEAD": "a colourless oily insoluble liquid formerly used in petrol to prevent knocking [n -S]\n",
  "TETRAETHYLLEADS": "TETRAETHYLLEAD, a colourless oily insoluble liquid formerly used in petrol to prevent knocking [n]\n",
  "TETRAETHYLS": "TETRAETHYL, a compound with four ethyl groups [n]\n",
  "TETRAFLUORIDE": "a fluoride containing four atoms of fluorine [n -S]\n",
  "TETRAFLUORIDES": "TETRAFLUORIDE, a fluoride containing four atoms of fluorine [n]\n",
  "TETRAGON": "a four-sided polygon [n -S]\n",
  "TETRAGONAL": "of or pertaining to a tetragon [adj TETRAGONALLY]\n",
  "TETRAGONALLY": "TETRAGONAL, of or pertaining to a tetragon [adv]\n",
  "TETRAGONALNESS": "the state of being tetragonal [n]\n",
  "TETRAGONOUS": "having four angles [adj]\n",
  "TETRAGONS": "TETRAGON, a four-sided polygon [n]\n",
  "TETRAGRAM": "a word or inscription of four letters [n -S]\n",
  "TETRAGRAMMATON": "a sacred word or acronym of four letters [n -S]\n",
  "TETRAGRAMMATONS": "TETRAGRAMMATON, a sacred word or acronym of four letters [n]\n",
  "TETRAGRAMS": "TETRAGRAM, a word or inscription of four letters [n]\n",
  "TETRAGYNIAN": "having four pistils, also TETRAGYNOUS [adj]\n",
  "TETRAGYNOUS": "having four pistils, also TETRAGYNIAN [adj]\n",
  "TETRAHEDRA": "TETRAHEDRON, a polyhedron that has four faces [n]\n",
  "TETRAHEDRAL": "of a solid with four sides [adj TETRAHEDRALLY]\n",
  "TETRAHEDRALLY": "TETRAHEDRAL, of a solid with four sides [adv]\n",
  "TETRAHEDRITE": "native sulphide of antimony, iron, and copper, forming a series with tennantite and typically occurring as tetrahedral crystals [n -S]\n",
  "TETRAHEDRITES": "TETRAHEDRITE, native sulphide of antimony, iron, and copper, forming a series with tennantite and typically occurring as tetrahedral crystals [n]\n",
  "TETRAHEDRON": "a polyhedron that has four faces [n TETRAHEDRA or TETRAHEDRONS]\n",
  "TETRAHEDRONS": "TETRAHEDRON, a polyhedron that has four faces [n]\n",
  "TETRAHYDROFURAN": "a flammable liquid ether derived from furan and used as a solvent and as an intermediate in organic synthesis [n]\n",
  "TETRAHYMENA": "any of a genus of ciliate protozoans [n -S]\n",
  "TETRAHYMENAS": "TETRAHYMENA, any of a genus of ciliate protozoans [n]\n",
  "TETRALOGIES": "TETRALOGY, a series of four connected literary, artistic, or musical works [n]\n",
  "TETRALOGY": "a series of four connected literary, artistic, or musical works [n TETRALOGIES]\n",
  "TETRAMER": "a polymer consisting of four identical isomers [n -S]\n",
  "TETRAMERAL": "of or like a tetramer, a polymer consisting of four identical isomers, also TETRAMERIC [adj]\n",
  "TETRAMERIC": "of or like a tetramer, a polymer consisting of four identical isomers, also TETRAMERAL [adj]\n",
  "TETRAMERISM": "division into four parts [n -S]\n",
  "TETRAMERISMS": "TETRAMERISM, division into four parts [n]\n",
  "TETRAMEROUS": "having four similar parts, e.g. of flowers with petals in sets of four [adj]\n",
  "TETRAMERS": "TETRAMER, a polymer consisting of four identical isomers [n]\n",
  "TETRAMETER": "a line of verse of four measures [n -S]\n",
  "TETRAMETERS": "TETRAMETER, a line of verse of four measures [n]\n",
  "TETRAMETHYL": "as in tetramethyl lead, a colourless oily insoluble liquid formerly used in petrol to prevent knocking [adj]\n",
  "TETRAMETHYLLEAD": "a volatile poisonous liquid used esp. formerly as an antiknock agent [n]\n",
  "TETRAMORPHIC": "having four forms [adj]\n",
  "TETRANDRIAN": "having four stamens, also TETRANDROUS [adj]\n",
  "TETRANDROUS": "having four stamens, also TETRANDRIAN [adj]\n",
  "TETRAPLA": "(Greek) an edition of four parallel texts, esp. Origen's of the Old Testament [n -S]\n",
  "TETRAPLAS": "TETRAPLA, (Greek) an edition of four parallel texts, esp. Origen's of the Old Testament [n]\n",
  "TETRAPLEGIA": "paralysis of both arms and both legs, also QUADRAPLEGIA, QUADRIPLEGIA [n -S]\n",
  "TETRAPLEGIAS": "TETRAPLEGIA, paralysis of both arms and both legs, also QUADRAPLEGIA, QUADRIPLEGIA [n]\n",
  "TETRAPLEGIC": "suffering from tetraplegia [adj]\n",
  "TETRAPLOID": "four haploid sets of chromosomes [n -S]\n",
  "TETRAPLOIDIES": "TETRAPLOIDY, the state of being tetraploid, having four haploid sets of chromosomes [n]\n",
  "TETRAPLOIDS": "TETRAPLOID, four haploid sets of chromosomes [n]\n",
  "TETRAPLOIDY": "the state of being tetraploid, having four haploid sets of chromosomes [n TETRAPLOIDIES]\n",
  "TETRAPOD": "a four-footed animal [n -S]\n",
  "TETRAPODIC": "of verse, having four metrical feet [adj]\n",
  "TETRAPODIES": "TETRAPODY, a set of four metrical feet [n]\n",
  "TETRAPODOUS": "having four feet [adj]\n",
  "TETRAPODS": "TETRAPOD, a four-footed animal [n]\n",
  "TETRAPODY": "a set of four metrical feet [n TETRAPODIES]\n",
  "TETRAPOLIS": "a group of four cities [n -ES]\n",
  "TETRAPOLISES": "TETRAPOLIS, a group of four cities [n]\n",
  "TETRAPOLITAN": "relating to a tetrapolis, a group of four towns [adj]\n",
  "TETRAPTERAN": "having four wings, also TETRAPTEROUS [adj]\n",
  "TETRAPTEROUS": "having four wings, also TETRAPTERAN [adj]\n",
  "TETRAPTOTE": "a noun that has four grammatical cases only [n -S]\n",
  "TETRAPTOTES": "TETRAPTOTE, a noun that has four grammatical cases only [n]\n",
  "TETRAPYRROLE": "a chemical group consisting of four pyrrole rings joined either in a straight chain or in a ring, as in chlorophyll [n -S]\n",
  "TETRAPYRROLES": "TETRAPYRROLE, a chemical group consisting of four pyrrole rings joined either in a straight chain or in a ring, as in chlorophyll [n]\n",
  "TETRARCH": "a Roman governor of the fourth part of a province; hence, any subordinate or dependent prince [n -S]\n",
  "TETRARCHATE": "the fourth part of a province, a tetrarchy [n -S]\n",
  "TETRARCHATES": "TETRARCHATE, the fourth part of a province, a tetrarchy [n]\n",
  "TETRARCHIC": "having four xylem strands, also TETRARCHICAL [adj]\n",
  "TETRARCHICAL": "having four xylem strands, also TETRARCHIC [adj]\n",
  "TETRARCHIES": "TETRARCHY, government by four people [n]\n",
  "TETRARCHS": "TETRARCH, a Roman governor of the fourth part of a province; hence, any subordinate or dependent prince [n]\n",
  "TETRARCHY": "government by four people [n TETRARCHIES]\n",
  "TETRAS": "TETRA, any of various small, often brightly coloured tropical freshwater fishes of the characin family [n]\n",
  "TETRASEMIC": "in Greek prosody, equivalent to four short syllables [adj]\n",
  "TETRASPORANGIA": "TETRASPORANGIUM, the sporangium in which tetraspores are formed [n]\n",
  "TETRASPORANGIUM": "the sporangium in which tetraspores are formed [n TETRASPORANGIA]\n",
  "TETRASPORE": "a nonsexual spore, one of a group of four regularly occurring in red seaweeds [n -S]\n",
  "TETRASPORES": "TETRASPORE, a nonsexual spore, one of a group of four regularly occurring in red seaweeds [n]\n",
  "TETRASPORIC": "relating to tetraspores, also TETRASPOROUS [adj]\n",
  "TETRASPOROUS": "of or like a tetraspore, also TETRASPORIC [adj]\n",
  "TETRASTICH": "a stanza, epigram, or poem, consisting of four verses or lines [n -S]\n",
  "TETRASTICHAL": "of or like a tetrastich, also TETRASTICHIC [adj]\n",
  "TETRASTICHIC": "of or like a tetrastich, also TETRASTICHAL [adj]\n",
  "TETRASTICHOUS": "having four rows [adj]\n",
  "TETRASTICHS": "TETRASTICH, a stanza, epigram, or poem, consisting of four verses or lines [n]\n",
  "TETRASTYLE": "a building with four columns [n -S]\n",
  "TETRASTYLES": "TETRASTYLE, a building with four columns [n]\n",
  "TETRASYLLABIC": "having four syllables, also TETRASYLLABICAL [adj]\n",
  "TETRASYLLABICAL": "having four syllables, also TETRASYLLABIC [adj]\n",
  "TETRASYLLABLE": "a word with four syllables [n -S]\n",
  "TETRASYLLABLES": "TETRASYLLABLE, a word with four syllables [n]\n",
  "TETRATHEISM": "the belief in four elements in the Godhead, i.e. the three persons of the Trinity and a divine essence out of which each of these originates [n -S]\n",
  "TETRATHEISMS": "TETRATHEISM, the belief in four elements in the Godhead, i.e. the three persons of the Trinity and a divine essence out of which each of these originates [n]\n",
  "TETRATHLON": "a four-event sporting contest [n -S]\n",
  "TETRATHLONS": "TETRATHLON, a four-event sporting contest [n]\n",
  "TETRATOMIC": "consisting of four atoms; having four atoms in the molecule, as phosphorus and arsenic [adj]\n",
  "TETRAVALENCE": "the condition of having a valency of four, also TETRAVALENCY [n -S]\n",
  "TETRAVALENCES": "TETRAVALENCE, the condition of having a valency of four, also TETRAVALENCY [n]\n",
  "TETRAVALENCIES": "TETRAVALENCY, the state of being tetravalent, also TETRAVALENCE [n]\n",
  "TETRAVALENCY": "the state of being tetravalent, also TETRAVALENCE [n TETRAVALENCIES]\n",
  "TETRAVALENT": "a compound having a valency of four [n -S]\n",
  "TETRAVALENTS": "TETRAVALENT, a compound having a valency of four [n]\n",
  "TETRAXON": "a sponge spicule, also TETRACT [n -S]\n",
  "TETRAXONS": "TETRAXON, a sponge spicule, also TETRACT [n]\n",
  "TETRAZOLIUM": "a monovalent cation or group that is analogous to ammonium [n -S]\n",
  "TETRAZOLIUMS": "TETRAZOLIUM, a monovalent cation or group that is analogous to ammonium [n]\n",
  "TETRAZZINI": "noodles, mushrooms, almonds, in a cream sauce topped with cheese [n]\n",
  "TETRI": "a currency unit of Georgia, also THETRI [n -S]\n",
  "TETRIS": "TETRI, a currency unit of Georgia, also THETRI [n]\n",
  "TETRODE": "a type of electron tube [n -S]\n",
  "TETRODES": "TETRODE, a type of electron tube [n]\n",
  "TETRODOTOXIN": "a deadly nerve poison found in a species of Japanese puffer fish, also TETROTOXIN [n -S]\n",
  "TETRODOTOXINS": "TETRODOTOXIN, a deadly nerve poison found in a species of Japanese puffer fish, also TETROTOXIN [n]\n",
  "TETRONAL": "a hypnotic and sedative drug, rarely used because of its toxicity [n -S]\n",
  "TETRONALS": "TETRONAL, a hypnotic and sedative drug, rarely used because of its toxicity [n]\n",
  "TETROSE": "a sugar whose molecules contain four carbon atoms [n -S]\n",
  "TETROSES": "TETROSE, a sugar whose molecules contain four carbon atoms [n]\n",
  "TETROTOXIN": "a deadly nerve poison found in a species of Japanese puffer fish, also TETRODOTOXIN [n -S]\n",
  "TETROTOXINS": "TETROTOXIN, a deadly nerve poison found in a species of Japanese puffer fish, also TETRODOTOXIN [n]\n",
  "TETROXID": "an oxide having four atoms of oxygen in the molecule; as, osmium tetroxide, also TETROXIDE [n -S]\n",
  "TETROXIDE": "an oxide having four atoms of oxygen in the molecule; as, osmium tetroxide, also TETROXID [n -S]\n",
  "TETROXIDES": "TETROXIDE, an oxide having four atoms of oxygen in the molecule; as, osmium tetroxide, also TETROXID [n]\n",
  "TETROXIDS": "TETROXID, an oxide having four atoms of oxygen in the molecule; as, osmium tetroxide, also TETROXIDE [n]\n",
  "TETRYL": "a yellow crystalline explosive [n -S]\n",
  "TETRYLS": "TETRYL, a yellow crystalline explosive [n]\n",
  "TETS": "TET, (Hebrew) a letter of the Hebrew alphabet, also TETH [n]\n",
  "TETTER": "to affect with a skin disease [v -ED, -ING, -S]\n",
  "TETTERED": "TETTER, to affect with a skin disease [v]\n",
  "TETTERING": "TETTER, to affect with a skin disease [v]\n",
  "TETTEROUS": "having the character of, or pertaining to, tetter, a skin eruption [adj]\n",
  "TETTERS": "TETTER, to affect with a skin disease [v]\n",
  "TETTIX": "(Greek) the cicada [n -ES]\n",
  "TETTIXES": "TETTIX, (Greek) the cicada [n]\n",
  "TEUCH": "(Scots) tough, also TEUGH [adj TEUCHER, TEUCHEST]\n",
  "TEUCHAT": "(Scots) a shore bird, also TEWHIT, TEWIT [n -S]\n",
  "TEUCHATS": "TEUCHAT, (Scots) a shore bird, also TEWHIT, TEWIT [n]\n",
  "TEUCHER": "TEUCH, (Scots) tough, also TEUGH [adj]\n",
  "TEUCHEST": "TEUCH, (Scots) tough, also TEUGH [adj]\n",
  "TEUCHTER": "(Scots) a derogatory term used by a Lowland Scot for a Highlander [n -S]\n",
  "TEUCHTERS": "TEUCHTER, (Scots) a derogatory term used by a Lowland Scot for a Highlander [n]\n",
  "TEUGH": "(Scots) tough, also TEUCH [adj TEUGHER, TEUGHEST, TEUGHLY]\n",
  "TEUGHER": "TEUGH, (Scots) tough, also TEUCH [adj]\n",
  "TEUGHEST": "TEUGH, (Scots) tough, also TEUCH [adj]\n",
  "TEUGHLY": "TEUGH, (Scots) tough, also TEUCH [adv]\n",
  "TEUTONISE": "to render German, also TEUTONIZE [v TEUTONISED, TEUTONISING, TEUTONISES]\n",
  "TEUTONISED": "TEUTONISE, to render German, also TEUTONIZE [v]\n",
  "TEUTONISES": "TEUTONISE, to render German, also TEUTONIZE [v]\n",
  "TEUTONISING": "TEUTONISE, to render German, also TEUTONIZE [v]\n",
  "TEUTONIZE": "to render German, also TEUTONISE [v TEUTONIZED, TEUTONIZING, TEUTONIZES]\n",
  "TEUTONIZED": "TEUTONIZE, to render German, also TEUTONISE [v]\n",
  "TEUTONIZES": "TEUTONIZE, to render German, also TEUTONISE [v]\n",
  "TEUTONIZING": "TEUTONIZE, to render German, also TEUTONISE [v]\n",
  "TEVATRON": "a kind of particle accelerator [n -S]\n",
  "TEVATRONS": "TEVATRON, a kind of particle accelerator [n]\n",
  "TEW": "to hustle [v -ED, -ING, -S]\n",
  "TEWART": "(Native Australian) a strong-timbered eucalyptus, also TOOART, TUART [n -S]\n",
  "TEWARTS": "TEWART, (Native Australian) a strong-timbered eucalyptus, also TOOART, TUART [n]\n",
  "TEWED": "TEW, to hustle [v]\n",
  "TEWEL": "a chimney; the rectum or anus of a horse [n -S]\n",
  "TEWELS": "TEWEL, a chimney; the rectum or anus of a horse [n]\n",
  "TEWHIT": "(Scots) the lapwing, also TEUCHAT, TEWIT [n -S]\n",
  "TEWHITS": "TEWHIT, (Scots) the lapwing, also TEUCHAT, TEWIT [n]\n",
  "TEWING": "TEW, to hustle [v]\n",
  "TEWIT": "(Scots) the lapwing, also TEUCHAT, TEWHIT [n -S]\n",
  "TEWITS": "TEWIT, (Scots) the lapwing, also TEUCHAT, TEWHIT [n]\n",
  "TEWS": "TEW, to hustle [v]\n",
  "TEX": "a unit of linear density of yarn, 1 gramme per kilometre [n -ES]\n",
  "TEXAS": "the uppermost structure on a steamboat [n -ES]\n",
  "TEXASES": "TEXAS, the uppermost structure on a steamboat [n]\n",
  "TEXES": "TEX, a unit of linear density of yarn, 1 gramme per kilometre [n]\n",
  "TEXT": "the main body of a printed work [n -S] / to send a text message (mobile phone) [v -ED, -ING, -S]\n",
  "TEXTBOOK": "a book used in the study of a subject [n -S]\n",
  "TEXTBOOKISH": "written in a style reminiscent of textbooks [adj]\n",
  "TEXTBOOKS": "TEXTBOOK, a book used in the study of a subject [n]\n",
  "TEXTED": "TEXT, to send a text message (mobile phone) [v]\n",
  "TEXTER": "a person who communicates by text messaging [n -S]\n",
  "TEXTERS": "TEXTER, a person who communicates by text messaging [n]\n",
  "TEXTILE": "a woven fabric [n -S]\n",
  "TEXTILES": "TEXTILE, a woven fabric [n]\n",
  "TEXTING": "the act of sending a text message (mobile phone) [n -S]\n",
  "TEXTINGS": "TEXTING, the act of sending a text message (mobile phone) [n]\n",
  "TEXTISM": "the language, or a particular usage, characteristic of text messages [n -S]\n",
  "TEXTISMS": "TEXTISM, the language, or a particular usage, characteristic of text messages [n]\n",
  "TEXTLESS": "without a text [adj]\n",
  "TEXTONYM": "one of several words that may be keyed into a mobile phone by pressing the same sequence of buttons [n -S]\n",
  "TEXTONYMS": "TEXTONYM, one of several words that may be keyed into a mobile phone by pressing the same sequence of buttons [n]\n",
  "TEXTORIAL": "(archaic) of or pertaining to weaving [adj]\n",
  "TEXTPHONE": "a phone that can transmit text messages [n -S]\n",
  "TEXTPHONES": "TEXTPHONE, a phone that can transmit text messages [n]\n",
  "TEXTS": "TEXT, to send a text message (mobile phone) [v]\n",
  "TEXTSPEAK": "the style of language commonly used in text messages, including abbreviations, truncations, use of numbers, etc. [n -S]\n",
  "TEXTSPEAKS": "TEXTSPEAK, the style of language commonly used in text messages, including abbreviations, truncations, use of numbers, etc. [n]\n",
  "TEXTUAL": "pertaining to a text [adj TEXTUALLY]\n",
  "TEXTUALISM": "strict adherence to a text, esp. that of the Bible [n -S]\n",
  "TEXTUALISMS": "TEXTUALISM, strict adherence to a text, esp. that of the Bible [n]\n",
  "TEXTUALIST": "a person learned in, or a strict adherer to, the text, esp. of the Bible [n -S]\n",
  "TEXTUALISTS": "TEXTUALIST, a person learned in, or a strict adherer to, the text, esp. of the Bible [n]\n",
  "TEXTUALLY": "TEXTUAL, pertaining to a text [adv]\n",
  "TEXTUARIES": "TEXTUARY, a specialist in the study of the Scriptures [n]\n",
  "TEXTUARY": "a specialist in the study of the Scriptures [n TEXTUARIES]\n",
  "TEXTURAL": "pertaining to the surface characteristics of something [adj TEXTURALLY]\n",
  "TEXTURALLY": "TEXTURAL, pertaining to the surface characteristics of something [adv]\n",
  "TEXTURE": "to make by weaving [v TEXTURED, TEXTURING, TEXTURES]\n",
  "TEXTURED": "TEXTURE, to make by weaving [v]\n",
  "TEXTURELESS": "without texture [adj]\n",
  "TEXTURES": "TEXTURE, to make by weaving [v]\n",
  "TEXTURING": "making a texture by weaving [n -S]\n",
  "TEXTURINGS": "TEXTURING, making a texture by weaving [n]\n",
  "TEXTURISE": "to give a particular texture to, also TEXTURIZE [v TEXTURISED, TEXTURISING, TEXTURISES]\n",
  "TEXTURISED": "TEXTURISE, to give a particular texture to, also TEXTURIZE [v]\n",
  "TEXTURISES": "TEXTURISE, to give a particular texture to, also TEXTURIZE [v]\n",
  "TEXTURISING": "TEXTURISE, to give a particular texture to, also TEXTURIZE [v]\n",
  "TEXTURIZE": "to give a particular texture to, also TEXTURISE [v TEXTURIZED, TEXTURIZING, TEXTURIZES]\n",
  "TEXTURIZED": "TEXTURIZE, to give a particular texture to, also TEXTURISE [v]\n",
  "TEXTURIZES": "TEXTURIZE, to give a particular texture to, also TEXTURISE [v]\n",
  "TEXTURIZING": "TEXTURIZE, to give a particular texture to, also TEXTURISE [v]\n",
  "TEXTUROUS": "possessing texture [adj]\n",
  "THACK": "(Scots) to thatch, also THEEK, THETCH [v -ED, -ING, -S]\n",
  "THACKED": "THACK, (Scots) to thatch, also THEEK, THETCH [v]\n",
  "THACKING": "THACK, (Scots) to thatch, also THEEK, THETCH [v]\n",
  "THACKS": "THACK, (Scots) to thatch, also THEEK, THETCH [v]\n",
  "THAE": "(Scots) these [adj]\n",
  "THAGI": "(Hindi) murder and robbery by thugs, also THUGGEE [n -S]\n",
  "THAGIS": "THAGI, (Hindi) murder and robbery by thugs, also THUGGEE [n]\n",
  "THAIM": "(Scots) them [pron]\n",
  "THAIRM": "(Scots) an intestine, catgut, also THARM [n -S]\n",
  "THAIRMS": "THAIRM, (Scots) an intestine, catgut, also THARM [n]\n",
  "THALAMENCEPHALA": "plural of thalamencephalon (which has sixteenletters), the part of the diencephalon of the brain that includes the thalamus, pineal gland, and adjacent structures\n",
  "THALAMI": "THALAMUS, (Greek) a part of the brain [n]\n",
  "THALAMIC": "pertaining to the thalamus [adj THALAMICALLY]\n",
  "THALAMICALLY": "THALAMIC, pertaining to the thalamus [adv]\n",
  "THALAMIFLORAL": "having petals free and stamens hypogynous [adj]\n",
  "THALAMUS": "(Greek) a part of the brain [n THALAMI]\n",
  "THALASSAEMIA": "anemia resulting from faulty synthesis of hemoglobin, also THALASSEMIA [n -S]\n",
  "THALASSAEMIAS": "THALASSAEMIA, anemia resulting from faulty synthesis of hemoglobin, also THALASSEMIA [n]\n",
  "THALASSAEMIC": "a person who has the blood disorder thalassaemia [n -S]\n",
  "THALASSAEMICS": "THALASSAEMIC, a person who has the blood disorder thalassaemia [n]\n",
  "THALASSEMIA": "anemia resulting from faulty synthesis of hemoglobin, also THALASSAEMIA [n -S]\n",
  "THALASSEMIAS": "THALASSEMIA, anemia resulting from faulty synthesis of hemoglobin, also THALASSAEMIA [n]\n",
  "THALASSEMIC": "relating to thalassemia [adj] / one suffering from thalassemia [n -S]\n",
  "THALASSEMICS": "THALASSEMIC, one suffering from thalassemia [n]\n",
  "THALASSIAN": "a type of sea turtle [n -S]\n",
  "THALASSIANS": "THALASSIAN, a type of sea turtle [n]\n",
  "THALASSIC": "marine; of the seas, esp. those which are small or inland [adj]\n",
  "THALASSOCRACIES": "THALASSOCRACY, sovereignty of the seas, also THALATTOCRACY [n]\n",
  "THALASSOCRACY": "sovereignty of the seas, also THALATTOCRACY [n THALASSOCRACIES]\n",
  "THALASSOCRAT": "one who has maritime supremacy [n -S]\n",
  "THALASSOCRATS": "THALASSOCRAT, one who has maritime supremacy [n]\n",
  "THALASSOGRAPHER": "one who studies thalassography, the science of the sea [n]\n",
  "THALASSOGRAPHIC": "relating to thalassography, the science of the sea [adj]\n",
  "THALASSOGRAPHY": "the science of the sea [n]\n",
  "THALASSOTHERAPY": "medical treatment using baths in sea water [n]\n",
  "THALATTOCRACIES": "THALATTOCRACY, sovereignty of the seas, also THALASSOCRACY [n]\n",
  "THALATTOCRACY": "sovereignty of the seas, also THALASSOCRACY [n THALATTOCRACIES]\n",
  "THALE": "as in thale cress, a cruciferous wall plant [adj]\n",
  "THALER": "(German) an obsolete German silver coin, also TALER [n -S]\n",
  "THALERS": "THALER, (German) an obsolete German silver coin, also TALER [n]\n",
  "THALI": "(Hindi) a meal consisting of several small meat or vegetable dishes accompanied by rice, bread, etc., and sometimes by a starter or a sweet [n -S]\n",
  "THALIAN": "pertaining to the Muse of comedy [adj]\n",
  "THALICTRUM": "a plant of the meadow-rue genus [n -S]\n",
  "THALICTRUMS": "THALICTRUM, a plant of the meadow-rue genus [n]\n",
  "THALIDOMIDE": "a nonbarbiturate sedative drug, withdrawn in 1961 because found to cause malformation in the fetus if taken during pregnancy [n -S]\n",
  "THALIDOMIDES": "THALIDOMIDE, a nonbarbiturate sedative drug, withdrawn in 1961 because found to cause malformation in the fetus if taken during pregnancy [n]\n",
  "THALIS": "THALI, (Hindi) a meal consisting of several small meat or vegetable dishes accompanied by rice, bread, etc., and sometimes by a starter or a sweet [n]\n",
  "THALLI": "THALLUS, (Greek) a plant body not differentiated into leaf, stem and root [n]\n",
  "THALLIC": "of or containing trivalent thallium [adj]\n",
  "THALLIFORM": "shaped like a thallus, a plant body not differentiated into leaf, stem and root [adj]\n",
  "THALLINE": "a chemical compound used for medicinal purposes [n -S]\n",
  "THALLINES": "THALLINE, a chemical compound used for medicinal purposes [n]\n",
  "THALLIOUS": "containing thallium [adj]\n",
  "THALLIUM": "a rare bluish-white metallic chemical element [n -S]\n",
  "THALLIUMS": "THALLIUM, a rare bluish-white metallic chemical element [n]\n",
  "THALLOID": "having the form of a thallus [adj]\n",
  "THALLOPHYTE": "any organism belonging to the Thallophyta, that includes algae, fungi, and bacteria [n -S]\n",
  "THALLOPHYTES": "THALLOPHYTE, any organism belonging to the Thallophyta, that includes algae, fungi, and bacteria [n]\n",
  "THALLOPHYTIC": "of or like a thallophyte [adj]\n",
  "THALLOUS": "of or containing divalent thallium [adj]\n",
  "THALLUS": "(Greek) a plant body not differentiated into leaf, stem and root [n THALLUSES or THALLI]\n",
  "THALLUSES": "THALLUS, (Greek) a plant body not differentiated into leaf, stem and root [n]\n",
  "THALWEG": "(German) a line following the lowest point of a valley; the middle of a navigable waterway used as boundary line, also TALWEG [n -S]\n",
  "THALWEGS": "THALWEG, (German) a line following the lowest point of a valley; the middle of a navigable waterway used as boundary line, also TALWEG [n]\n",
  "THAN": "(obsolete) then. that time [n -S]\n",
  "THANA": "(Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANAH, THANNA, THANNAH [n -S]\n",
  "THANADAR": "(Hindi) an officer in charge of a tana, a police station, also TANADAR [n -S]\n",
  "THANADARS": "THANADAR, (Hindi) an officer in charge of a tana, a police station, also TANADAR [n]\n",
  "THANAGE": "the district in which a thane anciently had jurisdiction, also THANEDOM, THANEHOOD, THANESHIP, THENAGE [n -S]\n",
  "THANAGES": "THANAGE, the district in which a thane anciently had jurisdiction, also THANEDOM, THANEHOOD, THANESHIP, THENAGE [n]\n",
  "THANAH": "(Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANA, THANNA, THANNAH [n -S]\n",
  "THANAHS": "THANAH, (Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANA, THANNA, THANNAH [n]\n",
  "THANAS": "THANA, (Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANAH, THANNA, THANNAH [n]\n",
  "THANATISM": "the belief that the soul dies with the body [n -S]\n",
  "THANATISMS": "THANATISM, the belief that the soul dies with the body [n]\n",
  "THANATIST": "one believing that the soul dies with the body [n -S]\n",
  "THANATISTS": "THANATIST, one believing that the soul dies with the body [n]\n",
  "THANATOGNOMONIC": "indicating or characteristic of death [adj]\n",
  "THANATOGRAPHIES": "THANATOGRAPHY, the narrative of a death [n]\n",
  "THANATOGRAPHY": "the narrative of a death [n THANATOGRAPHIES]\n",
  "THANATOID": "apparently dead; deadly [adj]\n",
  "THANATOLOGICAL": "relating to thanatology [adj]\n",
  "THANATOLOGIES": "THANATOLOGY, the description or study of the phenomena of death and of psychological mechanisms for coping with them [n]\n",
  "THANATOLOGIST": "one who studies thanatology [n -S]\n",
  "THANATOLOGISTS": "THANATOLOGIST, one who studies thanatology [n]\n",
  "THANATOLOGY": "the description or study of the phenomena of death and of psychological mechanisms for coping with them [n THANATOLOGIES]\n",
  "THANATOPHOBIA": "an abnormal fear of death [n -S]\n",
  "THANATOPHOBIAS": "THANATOPHOBIA, an abnormal fear of death [n]\n",
  "THANATOPSES": "THANATOPSIS, a meditation upon death [n]\n",
  "THANATOPSIS": "a meditation upon death [n THANATOPSES]\n",
  "THANATOS": "(Greek) in Freudian psychology, the urge for destruction or self-destruction [n -ES]\n",
  "THANATOSES": "THANATOS, (Greek) in Freudian psychology, the urge for destruction or self-destruction [n]\n",
  "THANATOSIS": "gangrene [n THANATOSES]\n",
  "THANE": "a freeman granted land in return for military service; a Scottish feudal lord, also THEGN [n -S]\n",
  "THANEDOM": "the state or dignity of a thane, also THANAGE, THANEHOOD, THANESHIP, THENAGE [n -S]\n",
  "THANEDOMS": "THANEDOM, the state or dignity of a thane, also THANAGE, THANEHOOD, THANESHIP, THENAGE [n]\n",
  "THANEHOOD": "the state or dignity of a thane, also THANAGE, THANEDOM, THANESHIP, THENAGE [n -S]\n",
  "THANEHOODS": "THANEHOOD, the state or dignity of a thane, also THANAGE, THANEDOM, THANESHIP, THENAGE [n]\n",
  "THANES": "THANE, a freeman granted land in return for military service; a Scottish feudal lord, also THEGN [n]\n",
  "THANESHIP": "the state or dignity of a thane, also THANAGE, THANEDOM, THANEHOOD, THENAGE [n -S]\n",
  "THANESHIPS": "THANESHIP, the state or dignity of a thane, also THANAGE, THANEDOM, THANEHOOD, THENAGE [n]\n",
  "THANG": "(colloquial) thing [n -S]\n",
  "THANGKA": "(Tibetan) a religious painting on a scroll [n -S]\n",
  "THANGKAS": "THANGKA, (Tibetan) a religious painting on a scroll [n]\n",
  "THANGS": "THANG, (colloquial) thing [n]\n",
  "THANK": "to express gratitude [v -ED, -ING, -S]\n",
  "THANKED": "THANK, to express gratitude [v]\n",
  "THANKEE": "(colloquial) thank you [interj]\n",
  "THANKER": "one who thanks [n -S]\n",
  "THANKERS": "THANKER, one who thanks [n]\n",
  "THANKFUL": "grateful [adj THANKFULLER, THANKFULLEST, THANKFULLY]\n",
  "THANKFULLER": "THANKFUL, grateful [adj]\n",
  "THANKFULLEST": "THANKFUL, grateful [adj]\n",
  "THANKFULLY": "THANKFUL, grateful [adv]\n",
  "THANKFULNESS": "the state of being thankful [n -ES]\n",
  "THANKFULNESSES": "THANKFULNESS, the state of being thankful [n]\n",
  "THANKING": "the act of thanking [n -S]\n",
  "THANKINGS": "THANKING, the act of thanking [n]\n",
  "THANKIT": "(Scots) as in be thankit, thank God [adj]\n",
  "THANKLESS": "giving no reward [adj THANKLESSLY]\n",
  "THANKLESSLY": "THANKLESS, giving no reward [adv]\n",
  "THANKLESSNESS": "the state of being thankless [n -ES]\n",
  "THANKLESSNESSES": "THANKLESSNESS, the state of being thankless [n]\n",
  "THANKS": "THANK, to express gratitude [v]\n",
  "THANKSGIVER": "one who gives thanks [n -S]\n",
  "THANKSGIVERS": "THANKSGIVER, one who gives thanks [n]\n",
  "THANKSGIVING": "the act of giving thanks [n -S]\n",
  "THANKSGIVINGS": "THANKSGIVING, the act of giving thanks [n]\n",
  "THANKWORTHIER": "THANKWORTHY, worthy of thanks [adj]\n",
  "THANKWORTHIEST": "THANKWORTHY, worthy of thanks [adj]\n",
  "THANKWORTHILY": "THANKWORTHY, worthy of thanks [adv]\n",
  "THANKWORTHINESS": "the state of being thankworthy [n]\n",
  "THANKWORTHY": "worthy of thanks [adj THANKWORTHIER, THANKWORTHIEST; THANKWORTHILY]\n",
  "THANKYOU": "anything expressing gratitude, esp. a gift [n -S]\n",
  "THANKYOUS": "THANKYOU, anything expressing gratitude, esp. a gift [n]\n",
  "THANNA": "(Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANA, THANAH, THANNAH [n -S]\n",
  "THANNAH": "(Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANA, THANAH, THANNA [n -S]\n",
  "THANNAHS": "THANNAH, (Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANA, THANAH, THANNA [n]\n",
  "THANNAS": "THANNA, (Hindi) an Indian police station, also TANA, TANNA, TANNAH, THANA, THANAH, THANNAH [n]\n",
  "THANS": "THAN, (obsolete) then. that time [n]\n",
  "THANX": "(colloquial) thank you [interj]\n",
  "THAR": "(Nepali) a Himalayan goatlike antelope, aka serow [n -S]\n",
  "THARBOROUGH": "(Shakespeare) a mispronunciation of thirdborough, also FARBOROUGH [n -S]\n",
  "THARBOROUGHS": "THARBOROUGH, (Shakespeare) a mispronunciation of thirdborough, also FARBOROUGH [n]\n",
  "THARM": "the belly, intestines, also THAIRM [n -S]\n",
  "THARMS": "THARM, the belly, intestines, also THAIRM [n]\n",
  "THARS": "THAR, (Nepali) a Himalayan goatlike antelope, aka serow [n]\n",
  "THAT": "the one indicated [pron THOSE]\n",
  "THATAWAY": "in that direction [adv]\n",
  "THATCH": "to cover with plant stalks or foliage [v -ED, -ING, -ES]\n",
  "THATCHED": "THATCH, to cover with plant stalks or foliage [v]\n",
  "THATCHER": "one that thatches [n -S]\n",
  "THATCHERS": "THATCHER, one that thatches [n]\n",
  "THATCHES": "THATCH, to cover with plant stalks or foliage [v]\n",
  "THATCHIER": "THATCHY, resembling thatch [adj]\n",
  "THATCHIEST": "THATCHY, resembling thatch [adj]\n",
  "THATCHING": "the act of applying thatch [n -S]\n",
  "THATCHINGS": "THATCHING, the act of applying thatch [n]\n",
  "THATCHLESS": "without thatch [adj]\n",
  "THATCHT": "THATCH, to cover with plant stalks or foliage [v]\n",
  "THATCHY": "resembling thatch [adj THATCHIER, THATCHIEST]\n",
  "THATNESS": "the quality of being a definite thing [n -ES]\n",
  "THATNESSES": "THATNESS, the quality of being a definite thing [n]\n",
  "THAUMASITE": "a mineral, hydrated silicate, carbonate and sulphate of calcium [n -S]\n",
  "THAUMASITES": "THAUMASITE, a mineral, hydrated silicate, carbonate and sulphate of calcium [n]\n",
  "THAUMATIN": "a sweetener extracted from a West Indian fruit [n -S]\n",
  "THAUMATINS": "THAUMATIN, a sweetener extracted from a West Indian fruit [n]\n",
  "THAUMATOGENIES": "THAUMATOGENY, the doctrine of the miraculous origin of life [n]\n",
  "THAUMATOGENY": "the doctrine of the miraculous origin of life [n THAUMATOGENIES]\n",
  "THAUMATOGRAPHY": "the description of natural wonders [n]\n",
  "THAUMATOLATRIES": "THAUMATOLATRY, the worship of miracles or wonders [n]\n",
  "THAUMATOLATRY": "the worship of miracles or wonders [n THAUMATOLATRIES]\n",
  "THAUMATOLOGIES": "THAUMATOLOGY, the study of miracles [n]\n",
  "THAUMATOLOGY": "the study of miracles [n THAUMATOLOGIES]\n",
  "THAUMATROPE": "an optical toy in which pictures on both sides of a card are seen to combine when the card is rotated rapidly [n -S]\n",
  "THAUMATROPES": "THAUMATROPE, an optical toy in which pictures on both sides of a card are seen to combine when the card is rotated rapidly [n]\n",
  "THAUMATROPICAL": "of or like a thaumatrope, an optical toy in which pictures on both sides of a card are seen to combine when the card is rotated rapidly [adj]\n",
  "THAUMATURGE": "a performer of miracles, esp. a magician [n -S]\n",
  "THAUMATURGES": "THAUMATURGE, a performer of miracles, esp. a magician [n]\n",
  "THAUMATURGIC": "relating to the supposed working of miracles, also THAUMATURGICAL [adj]\n",
  "THAUMATURGICAL": "relating to the supposed working of miracles, also THAUMATURGIC [adj]\n",
  "THAUMATURGICS": "the performance of magic tricks using sleight-of-hand etc. [n]\n",
  "THAUMATURGIES": "THAUMATURGY, the performance of miracles [n]\n",
  "THAUMATURGISM": "belief in the performance of miracles [n -S]\n",
  "THAUMATURGISMS": "THAUMATURGISM, belief in the performance of miracles [n]\n",
  "THAUMATURGIST": "a performer of miracles, also THAUMATURGUS [n -S]\n",
  "THAUMATURGISTS": "THAUMATURGIST, a performer of miracles, also THAUMATURGUS [n]\n",
  "THAUMATURGUS": "a performer of miracles, also THAUMATURGIST [n -ES]\n",
  "THAUMATURGUSES": "THAUMATURGUS, a performer of miracles, also THAUMATURGIST [n]\n",
  "THAUMATURGY": "the performance of miracles [n THAUMATURGIES]\n",
  "THAW": "to melt [v -ED, -ING, -S]\n",
  "THAWED": "THAW, to melt [v]\n",
  "THAWER": "an ice-melting agent or apparatus [n -S]\n",
  "THAWERS": "THAWER, an ice-melting agent or apparatus [n]\n",
  "THAWIER": "THAWY, inclined to melt [adj]\n",
  "THAWIEST": "THAWY, inclined to melt [adj]\n",
  "THAWING": "the act of melting [n -S]\n",
  "THAWINGS": "THAWING, the act of melting [n]\n",
  "THAWLESS": "never thawing [adj]\n",
  "THAWS": "THAW, to melt [v]\n",
  "THAWY": "inclined to melt [adj THAWIER, THAWIEST]\n",
  "THE": "the definite article [adj]\n",
  "THEACEOUS": "relating to the tea genus of evergreen plants [adj]\n",
  "THEANDRIC": "divine and human at the same time [adj]\n",
  "THEANINE": "an amino acid with health benefits [n -S]\n",
  "THEANINES": "THEANINE, an amino acid with health benefits [n]\n",
  "THEANTHROPIC": "having the nature of both God and human [adj]\n",
  "THEANTHROPIES": "THEANTHROPY, a belief in the union of divine and human [n]\n",
  "THEANTHROPISM": "the belief in the union of the divine and human [n -S]\n",
  "THEANTHROPISMS": "THEANTHROPISM, the belief in the union of the divine and human [n]\n",
  "THEANTHROPIST": "one who believes that gods can take human forms [n -S]\n",
  "THEANTHROPISTS": "THEANTHROPIST, one who believes that gods can take human forms [n]\n",
  "THEANTHROPY": "a belief in the union of divine and human [n THEANTHROPIES]\n",
  "THEARCHIC": "divinely sovereign or supreme [adj]\n",
  "THEARCHIES": "THEARCHY, rule by a God [n]\n",
  "THEARCHY": "rule by a God [n THEARCHIES]\n",
  "THEATER": "a building for dramatic presentations, also THEATRE [n -S]\n",
  "THEATERGOER": "one who visits the theater, also THEATREGOER [n -S]\n",
  "THEATERGOERS": "THEATERGOER, one who visits the theater, also THEATREGOER [n]\n",
  "THEATERGOING": "visiting the theatre, also THEATREGOING [n -S]\n",
  "THEATERGOINGS": "THEATERGOING, visiting the theatre, also THEATREGOING [n]\n",
  "THEATERLAND": "the main theatre district of a city, esp. in the West End of London, also THEATRELAND [n -S]\n",
  "THEATERLANDS": "THEATERLAND, the main theatre district of a city, esp. in the West End of London, also THEATRELAND [n]\n",
  "THEATERS": "THEATER, a building for dramatic presentations, also THEATRE [n]\n",
  "THEATRAL": "of or pertaining to a theatre, also THEATRIC, THEATRICAL [adj]\n",
  "THEATRE": "a building for dramatic presentations, also THEATER [n -S]\n",
  "THEATREGOER": "one who habitually visits the theatre, also THEATERGOER [n -S]\n",
  "THEATREGOERS": "THEATREGOER, one who habitually visits the theatre, also THEATERGOER [n]\n",
  "THEATREGOING": "the practice of going to the theatre, also THEATERGOING [n -S]\n",
  "THEATREGOINGS": "THEATREGOING, the practice of going to the theatre, also THEATERGOING [n]\n",
  "THEATRELAND": "the main theatre district of a city, esp. in the West End of London, also THEATERLAND [n -S]\n",
  "THEATRELANDS": "THEATRELAND, the main theatre district of a city, esp. in the West End of London, also THEATERLAND [n]\n",
  "THEATRES": "THEATRE, a building for dramatic presentations, also THEATER [n]\n",
  "THEATRIC": "relating to or suitable for the stage, also THEATRAL, THEATRICAL [adj THEATRICALLY]\n",
  "THEATRICAL": "of or pertaining to a theater, also THEATRAL, THEATRIC [adj]\n",
  "THEATRICALISE": "to adapt to the theatre, also THEATRICALIZE [v THEATRICALISED, THEATRICALISING, THEATRICALISES]\n",
  "THEATRICALISED": "THEATRICALISE, to adapt to the theatre, also THEATRICALIZE [v]\n",
  "THEATRICALISES": "THEATRICALISE, to adapt to the theatre, also THEATRICALIZE [v]\n",
  "THEATRICALISING": "THEATRICALISE, to adapt to the theatre, also THEATRICALIZE [v]\n",
  "THEATRICALISM": "the state of being theatrical [n -S]\n",
  "THEATRICALISMS": "THEATRICALISM, the state of being theatrical [n]\n",
  "THEATRICALITIES": "THEATRICALITY, the state of being theatrical [n]\n",
  "THEATRICALITY": "the state of being theatrical [n THEATRICALITIES]\n",
  "THEATRICALIZE": "to adapt to the theatre, also THEATRICALISE [v THEATRICALIZED, THEATRICALIZING, THEATRICALIZES]\n",
  "THEATRICALIZED": "THEATRICALIZE, to adapt to the theatre, also THEATRICALISE [v]\n",
  "THEATRICALIZES": "THEATRICALIZE, to adapt to the theatre, also THEATRICALISE [v]\n",
  "THEATRICALIZING": "THEATRICALIZE, to adapt to the theatre, also THEATRICALISE [v]\n",
  "THEATRICALLY": "THEATRICAL, of or pertaining to a theater, also THEATRAL, THEATRIC [adv]\n",
  "THEATRICALNESS": "the state of being theatrical [n]\n",
  "THEATRICALS": "dramatic performances; theatrical affairs, properties or people [n]\n",
  "THEATRICISE": "to play a part, also THEATRICIZE [v THEATRICISED, THEATRICISING, THEATRICISES]\n",
  "THEATRICISED": "THEATRICISE, to play a part, also THEATRICIZE [v]\n",
  "THEATRICISES": "THEATRICISE, to play a part, also THEATRICIZE [v]\n",
  "THEATRICISING": "THEATRICISE, to play a part, also THEATRICIZE [v]\n",
  "THEATRICISM": "theatricality, affectation, staginess [n -S]\n",
  "THEATRICISMS": "THEATRICISM, theatricality, affectation, staginess [n]\n",
  "THEATRICIZE": "to play a part, also THEATRICISE [v THEATRICIZED, THEATRICIZING, THEATRICIZES]\n",
  "THEATRICIZED": "THEATRICIZE, to play a part, also THEATRICISE [v]\n",
  "THEATRICIZES": "THEATRICIZE, to play a part, also THEATRICISE [v]\n",
  "THEATRICIZING": "THEATRICIZE, to play a part, also THEATRICISE [v]\n",
  "THEATRICS": "the activity of a theatrical character [n]\n",
  "THEATROMANIA": "a craze for going to plays [n -S]\n",
  "THEATROMANIAS": "THEATROMANIA, a craze for going to plays [n]\n",
  "THEATROPHONE": "(historical) a telephone connecting callers to a theatre so they can listen to a live performance there [n -S]\n",
  "THEATROPHONES": "THEATROPHONE, (historical) a telephone connecting callers to a theatre so they can listen to a live performance there [n]\n",
  "THEAVE": "(dialect) a young ewe [n -S]\n",
  "THEAVES": "THEAVE, (dialect) a young ewe [n]\n",
  "THEBAINE": "a poisonous alkaloid obtained from opium [n -S]\n",
  "THEBAINES": "THEBAINE, a poisonous alkaloid obtained from opium [n]\n",
  "THEBE": "(Setswana) a monetary unit of Botswana [n -S]\n",
  "THEBES": "THEBE, (Setswana) a monetary unit of Botswana [n]\n",
  "THECA": "(Greek) a lobe, a lobulus of an anther [n THECAE]\n",
  "THECAE": "THECA, (Greek) a lobe, a lobulus of an anther [n]\n",
  "THECAL": "of or pertaining to a theca, as, a thecal abscess [adj]\n",
  "THECATE": "having a theca, an envelope of hormonally active cells enclosing a tertiary (vesicular) or a mature (Graafian) ovarian follicle [adj]\n",
  "THECODONT": "a member of the order Thecodontia of archosaurian reptiles with teeth fixed in sockets in the jawbone [n -S]\n",
  "THECODONTS": "THECODONT, a member of the order Thecodontia of archosaurian reptiles with teeth fixed in sockets in the jawbone [n]\n",
  "THEE": "to use the pronoun thee [v THEED, THEEING, THEES]\n",
  "THEED": "THEE, to use the pronoun thee [v]\n",
  "THEEING": "THEE, to use the pronoun thee [v]\n",
  "THEEK": "(Scots) to thatch, also THACK, THETCH [v -ED, -ING, -S]\n",
  "THEEKED": "THEEK, (Scots) to thatch, also THACK, THETCH [v]\n",
  "THEEKING": "THEEK, (Scots) to thatch, also THACK, THETCH [v]\n",
  "THEEKS": "THEEK, (Scots) to thatch, also THACK, THETCH [v]\n",
  "THEELIN": "a female sex hormone [n -S]\n",
  "THEELINS": "THEELIN, a female sex hormone [n]\n",
  "THEELOL": "a female sex hormone [n -S]\n",
  "THEELOLS": "THEELOL, a female sex hormone [n]\n",
  "THEES": "THEE, to use the pronoun thee [v]\n",
  "THEFT": "the act of stealing [n -S]\n",
  "THEFTLESS": "without theft [adj]\n",
  "THEFTS": "THEFT, the act of stealing [n]\n",
  "THEFTUOUS": "thievish [adj THEFTUOUSLY]\n",
  "THEFTUOUSLY": "THEFTUOUS, thievish [adv]\n",
  "THEGITHER": "(Scots) together [adv]\n",
  "THEGN": "(Old English) a king's companion in Anglo-Saxon England, also THANE [n -S]\n",
  "THEGNLIER": "THEGNLY, like a thegn [adj]\n",
  "THEGNLIEST": "THEGNLY, like a thegn [adj]\n",
  "THEGNLY": "like a thegn [adj THEGNLIER, THEGNLIEST]\n",
  "THEGNS": "THEGN, (Old English) a king's companion in Anglo-Saxon England, also THANE [n]\n",
  "THEIC": "one who drinks too much tea [n -S]\n",
  "THEICS": "THEIC, one who drinks too much tea [n]\n",
  "THEIN": "caffeine, also THEINE [n -S]\n",
  "THEINE": "an alkaloid found in tea, identical to caffeine, also THEIN [n -S]\n",
  "THEINES": "THEINE, an alkaloid found in tea, identical to caffeine, also THEIN [n]\n",
  "THEINS": "THEIN, caffeine, also THEINE [n]\n",
  "THEIR": "a possessive form of the pronoun they [adj]\n",
  "THEIRS": "a possessive form of the pronoun they [pron]\n",
  "THEIRSELF": "(dialect) themselves [pron]\n",
  "THEIRSELVES": "(dialect) themselves [pron]\n",
  "THEISM": "belief in the existence of a God [n -S]\n",
  "THEISMS": "THEISM, belief in the existence of a God [n]\n",
  "THEIST": "one who believes in the existence of a God [n -S]\n",
  "THEISTIC": "of or pertaining to theism, also THEISTICAL [adj THEISTICALLY]\n",
  "THEISTICAL": "of or pertaining to theism, also THEISTIC [adj THEISTICALLY]\n",
  "THEISTICALLY": "THEISTICAL, of or pertaining to theism, also THEISTIC [adv]\n",
  "THEISTS": "THEIST, one who believes in the existence of a God [n]\n",
  "THELEMENT": "(Spenser) the element [n -S]\n",
  "THELEMENTS": "THELEMENT, (Spenser) the element [n]\n",
  "THELF": "(Spenser) the elf [n THELVES]\n",
  "THELITIS": "inflammation of the nipple [n -ES]\n",
  "THELITISES": "THELITIS, inflammation of the nipple [n]\n",
  "THELVES": "THELF, (Spenser) the elf [n]\n",
  "THELYTOKIES": "THELYTOKY, the parthenogenetic production of females only [n]\n",
  "THELYTOKOUS": "producing only female offspring [adj]\n",
  "THELYTOKY": "the parthenogenetic production of females only [n THELYTOKIES]\n",
  "THEM": "the objective case of the pronoun they [pron]\n",
  "THEMA": "(Greek) the theme or subject of a declamation or discourse [n THEMATA]\n",
  "THEMATA": "THEMA, (Greek) the theme or subject of a declamation or discourse [n]\n",
  "THEMATIC": "of or relating to a theme [adj THEMATICALLY] / a thematic vowel [n -S]\n",
  "THEMATICALLY": "THEMATIC, of or relating to a theme [adv]\n",
  "THEMATICS": "THEMATIC, a thematic vowel [n]\n",
  "THEMATISATION": "the process of making thematic, also THEMATIZATION [n -S]\n",
  "THEMATISATIONS": "THEMATISATION, the process of making thematic, also THEMATIZATION [n]\n",
  "THEMATISE": "to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATIZE [v THEMATISED, THEMATISING, THEMATISES]\n",
  "THEMATISED": "THEMATISE, to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATIZE [v]\n",
  "THEMATISES": "THEMATISE, to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATIZE [v]\n",
  "THEMATISING": "THEMATISE, to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATIZE [v]\n",
  "THEMATIZATION": "the process of making thematic, also THEMATISATION [n -S]\n",
  "THEMATIZATIONS": "THEMATIZATION, the process of making thematic, also THEMATISATION [n]\n",
  "THEMATIZE": "to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATISE [v THEMATIZED, THEMATIZING, THEMATIZES]\n",
  "THEMATIZED": "THEMATIZE, to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATISE [v]\n",
  "THEMATIZES": "THEMATIZE, to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATISE [v]\n",
  "THEMATIZING": "THEMATIZE, to place (a word or phrase) at the start of a sentence in order to focus attention on it, also THEMATISE [v]\n",
  "THEME": "to plan according to a central subject [v THEMED, THEMING, THEMES]\n",
  "THEMED": "THEME, to plan according to a central subject [v]\n",
  "THEMELESS": "without a theme [adj]\n",
  "THEMES": "THEME, to plan according to a central subject [v]\n",
  "THEMING": "THEME, to plan according to a central subject [v]\n",
  "THEMSELF": "a pronoun, unrecognized in standard English, introduced as a sing pronoun to avoid himself or herself when the sex of the person is unspecified [pron]\n",
  "THEMSELVES": "the reflexive pronoun of them [pron]\n",
  "THEN": "that time [n -S]\n",
  "THENABOUT": "at about that time, also THENABOUTS [adv]\n",
  "THENABOUTS": "at about that time, also THENABOUT [adv]\n",
  "THENAGE": "the district in which a thane anciently had jurisdiction, also THANAGE, THANEDOM, THANEHOOD, THANESHIP [n -S]\n",
  "THENAGES": "THENAGE, the district in which a thane anciently had jurisdiction, also THANAGE, THANEDOM, THANEHOOD, THANESHIP [n]\n",
  "THENAL": "pertaining to the thenar, the ball of the thumb [adj]\n",
  "THENAR": "(Greek) the fleshy part (ball) of the thumb [n -S]\n",
  "THENARDITE": "a whitish vitreous mineral that consists of anhydrous sodium sulphate and occurs in saline residues [n -S]\n",
  "THENARDITES": "THENARDITE, a whitish vitreous mineral that consists of anhydrous sodium sulphate and occurs in saline residues [n]\n",
  "THENARS": "THENAR, (Greek) the fleshy part (ball) of the thumb [n]\n",
  "THENCE": "from that place [adv]\n",
  "THENCEFORTH": "from that time forward [adv]\n",
  "THENCEFORWARD": "from that time on, also THENCEFORWARDS [adv]\n",
  "THENCEFORWARDS": "from that time on, also THENCEFORWARD [adv]\n",
  "THENS": "THEN, that time [n]\n",
  "THEOBROMINE": "an alkaloid obtained from the chocolate seed, used in medicine [n -S]\n",
  "THEOBROMINES": "THEOBROMINE, an alkaloid obtained from the chocolate seed, used in medicine [n]\n",
  "THEOCENTRIC": "having God as the central interest and ultimate concern [adj]\n",
  "THEOCENTRICISM": "the state of being theocentric, having God as the central interest and ultimate concern, also THEOCENTRICITY [n -S]\n",
  "THEOCENTRICISMS": "THEOCENTRICISM, the state of being theocentric, having God as the central interest and ultimate concern, also THEOCENTRICITY [n]\n",
  "THEOCENTRICITY": "the state of being theocentric, having God as the central interest and ultimate concern, also THEOCENTRICISM [n]\n",
  "THEOCENTRISM": "the belief that God is the central fact of existence [n -S]\n",
  "THEOCENTRISMS": "THEOCENTRISM, the belief that God is the central fact of existence [n]\n",
  "THEOCON": "a conservative who believes that religion should play a major role in forming and implementing public policy [n -S]\n",
  "THEOCONS": "THEOCON, a conservative who believes that religion should play a major role in forming and implementing public policy [n]\n",
  "THEOCRACIES": "THEOCRACY, government by priests or by religious law [n]\n",
  "THEOCRACY": "government by priests or by religious law [n THEOCRACIES]\n",
  "THEOCRASIES": "THEOCRASY, the mingling of several gods into one personality [n]\n",
  "THEOCRASY": "the mingling of several gods into one personality [n THEOCRASIES]\n",
  "THEOCRAT": "a divine or deified ruler [n -S]\n",
  "THEOCRATIC": "relating to a theocrat, also THEOCRATICAL [adj THEOCRATICALLY]\n",
  "THEOCRATICAL": "relating to a theocrat, also THEOCRATIC [adj THEOCRATICALLY]\n",
  "THEOCRATICALLY": "THEOCRATICAL, relating to a theocrat, also THEOCRATIC [adv]\n",
  "THEOCRATS": "THEOCRAT, a divine or deified ruler [n]\n",
  "THEODICEAN": "practising theodicy, defense of God's goodness and omnipotence in view of the existence of evil [adj] / a practitioner of theodicy [n -S]\n",
  "THEODICEANS": "THEODICEAN, a practitioner of theodicy [n]\n",
  "THEODICIES": "THEODICY, a defence of God's goodness as against the existence of evil [n]\n",
  "THEODICY": "a defence of God's goodness as against the existence of evil [n THEODICIES]\n",
  "THEODOLITE": "a surveying instrument for measuring angles [n -S]\n",
  "THEODOLITES": "THEODOLITE, a surveying instrument for measuring angles [n]\n",
  "THEODOLITIC": "relating to a theodolite [adj]\n",
  "THEOGONIC": "accounting for the origin or presence of gods, also THEOGONICAL [adj]\n",
  "THEOGONICAL": "accounting for the origin or presence of gods, also THEOGONIC [adj]\n",
  "THEOGONIES": "THEOGONY, an account of the origin of the gods [n]\n",
  "THEOGONIST": "a writer on theogony [n -S]\n",
  "THEOGONISTS": "THEOGONIST, a writer on theogony [n]\n",
  "THEOGONY": "an account of the origin of the gods [n THEOGONIES]\n",
  "THEOLOG": "a theologian, also THEOLOGUE [n -S]\n",
  "THEOLOGASTER": "a petty or shallow theologian [n -S]\n",
  "THEOLOGASTERS": "THEOLOGASTER, a petty or shallow theologian [n]\n",
  "THEOLOGATE": "a seminary for RC priests [n -S]\n",
  "THEOLOGATES": "THEOLOGATE, a seminary for RC priests [n]\n",
  "THEOLOGER": "a theologian [n -S]\n",
  "THEOLOGERS": "THEOLOGER, a theologian [n]\n",
  "THEOLOGIAN": "a specialist in theology [n -S]\n",
  "THEOLOGIANS": "THEOLOGIAN, a specialist in theology [n]\n",
  "THEOLOGIC": "of or relating to theology, also THEOLOGICAL [adj THEOLOGICALLY]\n",
  "THEOLOGICAL": "of or relating to theology, also THEOLOGIC [adj THEOLOGICALLY]\n",
  "THEOLOGICALLY": "THEOLOGICAL, of or relating to theology, also THEOLOGIC [adv]\n",
  "THEOLOGIES": "THEOLOGY, the study of religion [n]\n",
  "THEOLOGISATION": "the process of theologising, also THEOLOGIZATION [n -S]\n",
  "THEOLOGISATIONS": "THEOLOGISATION, the process of theologising, also THEOLOGIZATION [n]\n",
  "THEOLOGISE": "to make theological, also THEOLOGIZE [v THEOLOGISED, THEOLOGISING, THEOLOGISES]\n",
  "THEOLOGISED": "THEOLOGISE, to make theological, also THEOLOGIZE [v]\n",
  "THEOLOGISER": "one who theologises, also THEOLOGIZER [n -S]\n",
  "THEOLOGISERS": "THEOLOGISER, one who theologises, also THEOLOGIZER [n]\n",
  "THEOLOGISES": "THEOLOGISE, to make theological, also THEOLOGIZE [v]\n",
  "THEOLOGISING": "THEOLOGISE, to make theological, also THEOLOGIZE [v]\n",
  "THEOLOGIST": "a theologian [n -S]\n",
  "THEOLOGISTS": "THEOLOGIST, a theologian [n]\n",
  "THEOLOGIZATION": "the process of theologizing, also THEOLOGISATION [n -S]\n",
  "THEOLOGIZATIONS": "THEOLOGIZATION, the process of theologizing, also THEOLOGISATION [n]\n",
  "THEOLOGIZE": "to make theological, also THEOLOGISE [v THEOLOGIZED, THEOLOGIZING, THEOLOGIZES]\n",
  "THEOLOGIZED": "THEOLOGIZE, to make theological, also THEOLOGISE [v]\n",
  "THEOLOGIZER": "one who theologizes, also THEOLOGISER [n -S]\n",
  "THEOLOGIZERS": "THEOLOGIZER, one who theologizes, also THEOLOGISER [n]\n",
  "THEOLOGIZES": "THEOLOGIZE, to make theological, also THEOLOGISE [v]\n",
  "THEOLOGIZING": "THEOLOGIZE, to make theological, also THEOLOGISE [v]\n",
  "THEOLOGOUMENA": "THEOLOGOUMENON, theological statement as opposed to divine one [n]\n",
  "THEOLOGOUMENON": "theological statement as opposed to divine one [n THEOLOGOUMENA]\n",
  "THEOLOGS": "THEOLOG, a theologian, also THEOLOGUE [n]\n",
  "THEOLOGUE": "a theologian, also THEOLOG [n -S]\n",
  "THEOLOGUES": "THEOLOGUE, a theologian, also THEOLOG [n]\n",
  "THEOLOGY": "the study of religion [n THEOLOGIES]\n",
  "THEOMACHIES": "THEOMACHY, homeric strife or battle among the gods [n]\n",
  "THEOMACHIST": "one who fights the gods, opposes the divine will [n -S]\n",
  "THEOMACHISTS": "THEOMACHIST, one who fights the gods, opposes the divine will [n]\n",
  "THEOMACHY": "homeric strife or battle among the gods [n THEOMACHIES]\n",
  "THEOMANCIES": "THEOMANCY, divination by means of oracles [n]\n",
  "THEOMANCY": "divination by means of oracles [n THEOMANCIES]\n",
  "THEOMANIA": "the belief that one is God or specially chosen by God on a mission [n -S]\n",
  "THEOMANIAC": "one suffering from theomania, the belief that one is a god [n -S]\n",
  "THEOMANIACS": "THEOMANIAC, one suffering from theomania, the belief that one is a god [n]\n",
  "THEOMANIAS": "THEOMANIA, the belief that one is God or specially chosen by God on a mission [n]\n",
  "THEOMANTIC": "relating to theomancy, divination by means of oracles [adj]\n",
  "THEOMORPHIC": "resembling a god or having godlike qualities [adj]\n",
  "THEOMORPHISM": "the concept of man as having the form of a god [n -S]\n",
  "THEOMORPHISMS": "THEOMORPHISM, the concept of man as having the form of a god [n]\n",
  "THEONOMIES": "THEONOMY, rule by a god [n]\n",
  "THEONOMOUS": "relating to theonomy [adj]\n",
  "THEONOMY": "rule by a god [n THEONOMIES]\n",
  "THEOPATHETIC": "relating to theopathy, also THEOPATHIC [adj]\n",
  "THEOPATHIC": "relating to theopathy, also THEOPATHETIC [adj]\n",
  "THEOPATHIES": "THEOPATHY, emotional experience brought on by religious belief [n]\n",
  "THEOPATHY": "emotional experience brought on by religious belief [n THEOPATHIES]\n",
  "THEOPHAGIES": "THEOPHAGY, the sacramental consumption of a god [n]\n",
  "THEOPHAGOUS": "relating to theophagy, the sacramental consumption of a god [adj]\n",
  "THEOPHAGY": "the sacramental consumption of a god [n THEOPHAGIES]\n",
  "THEOPHANIC": "of or pertaining to a theophany, also THEOPHANOUS [adj]\n",
  "THEOPHANIES": "THEOPHANY, the manifestation or appearance of a god to people [n]\n",
  "THEOPHANOUS": "of or pertaining to a theophany, also THEOPHANIC [adj]\n",
  "THEOPHANY": "the manifestation or appearance of a god to people [n THEOPHANIES]\n",
  "THEOPHOBIA": "fear of God [n -S]\n",
  "THEOPHOBIAC": "one with an extreme fear of God, also THEOPHOBIST [n -S]\n",
  "THEOPHOBIACS": "THEOPHOBIAC, one with an extreme fear of God, also THEOPHOBIST [n]\n",
  "THEOPHOBIAS": "THEOPHOBIA, fear of God [n]\n",
  "THEOPHOBIST": "one with an extreme fear of God, also THEOPHOBIAC [n -S]\n",
  "THEOPHOBISTS": "THEOPHOBIST, one with an extreme fear of God, also THEOPHOBIAC [n]\n",
  "THEOPHORIC": "derived from or bearing the name of a god [adj]\n",
  "THEOPHYLLINE": "an isomer of theobromine found in tea, used in medicine [n -S]\n",
  "THEOPHYLLINES": "THEOPHYLLINE, an isomer of theobromine found in tea, used in medicine [n]\n",
  "THEOPNEUST": "divinely inspired, also THEOPNEUSTIC [adj]\n",
  "THEOPNEUSTIC": "divinely inspired, also THEOPNEUST [adj]\n",
  "THEOPNEUSTIES": "THEOPNEUSTY, divine inspiration, esp. one that enables someone to reveal divine truths [n]\n",
  "THEOPNEUSTY": "divine inspiration, esp. one that enables someone to reveal divine truths [n THEOPNEUSTIES]\n",
  "THEORBIST": "one who plays on a theorbo, a double-necked lute [n -S]\n",
  "THEORBISTS": "THEORBIST, one who plays on a theorbo, a double-necked lute [n]\n",
  "THEORBO": "(Italian) a double-necked lute, aka chitarrone [n -S]\n",
  "THEORBOS": "THEORBO, (Italian) a double-necked lute, aka chitarrone [n]\n",
  "THEOREM": "an established but not self-evident principle [n -S]\n",
  "THEOREMATIC": "of or like a theorem, also THEOREMATICAL, THEOREMIC [adj THEOREMATICALLY]\n",
  "THEOREMATICAL": "relating to theorems, also THEOREMATIC, THEOREMIC [adj THEOREMATICALLY]\n",
  "THEOREMATICALLY": "THEOREMATICAL, relating to theorems, also THEOREMATIC, THEOREMIC [adv]\n",
  "THEOREMATIST": "one who creates theorems [n -S]\n",
  "THEOREMATISTS": "THEOREMATIST, one who creates theorems [n]\n",
  "THEOREMIC": "of or like a theorem, also THEOREMATIC, THEOREMATICAL [adj]\n",
  "THEOREMS": "THEOREM, an established but not self-evident principle [n]\n",
  "THEORETIC": "relating to theory [adj THEORETICALLY] / the theoretical side of a subject; theory as opposed to practice [n -S]\n",
  "THEORETICAL": "relating to or having the character of theory [adj THEORETICALLY]\n",
  "THEORETICALLY": "THEORETICAL, relating to or having the character of theory [adv]\n",
  "THEORETICIAN": "a theorist [n -S]\n",
  "THEORETICIANS": "THEORETICIAN, a theorist [n]\n",
  "THEORETICS": "THEORETIC, the theoretical side of a subject; theory as opposed to practice [n]\n",
  "THEORIC": "(Shakespeare) theory, speculation, also THEORIQUE [n -S]\n",
  "THEORICS": "THEORIC, (Shakespeare) theory, speculation, also THEORIQUE [n]\n",
  "THEORIES": "THEORY, a group of propositions used to explain a class of phenomena [n]\n",
  "THEORIQUE": "(Shakespeare) theory, speculation, also THEORIC [n -S]\n",
  "THEORIQUES": "THEORIQUE, (Shakespeare) theory, speculation, also THEORIC [n]\n",
  "THEORISATION": "the formation of theories, also THEORIZATION [n -S]\n",
  "THEORISATIONS": "THEORISATION, the formation of theories, also THEORIZATION [n]\n",
  "THEORISE": "to form theories, also THEORIZE [v THEORISED, THEORISING, THEORISES]\n",
  "THEORISED": "THEORISE, to form theories, also THEORIZE [v]\n",
  "THEORISER": "one who theorises, also THEORIZER [n -S]\n",
  "THEORISERS": "THEORISER, one who theorises, also THEORIZER [n]\n",
  "THEORISES": "THEORISE, to form theories, also THEORIZE [v]\n",
  "THEORISING": "THEORISE, to form theories, also THEORIZE [v]\n",
  "THEORIST": "one who theorizes [n -S]\n",
  "THEORISTS": "THEORIST, one who theorizes [n]\n",
  "THEORIZATION": "the formation of theories, also THEORISATION [n -S]\n",
  "THEORIZATIONS": "THEORIZATION, the formation of theories, also THEORISATION [n]\n",
  "THEORIZE": "to form theories, also THEORISE [v THEORIZED, THEORIZING, THEORIZES]\n",
  "THEORIZED": "THEORIZE, to form theories, also THEORISE [v]\n",
  "THEORIZER": "one who theorizes, also THEORISER [n -S]\n",
  "THEORIZERS": "THEORIZER, one who theorizes, also THEORISER [n]\n",
  "THEORIZES": "THEORIZE, to form theories, also THEORISE [v]\n",
  "THEORIZING": "THEORIZE, to form theories, also THEORISE [v]\n",
  "THEORY": "a group of propositions used to explain a class of phenomena [n THEORIES]\n",
  "THEOSOPH": "a believer in theosophy, immediate divine illumination or wisdom, also THEOSOPHER, THEOSOPHIST [n -S]\n",
  "THEOSOPHER": "a believer in theosophy, immediate divine illumination or wisdom, also THEOSOPH, THEOSOPHIST [n -S]\n",
  "THEOSOPHERS": "THEOSOPHER, a believer in theosophy, immediate divine illumination or wisdom, also THEOSOPH, THEOSOPHIST [n]\n",
  "THEOSOPHIC": "relating to theosophy, also THEOSOPHICAL [adj THEOSOPHICALLY]\n",
  "THEOSOPHICAL": "relating to theosophy, also THEOSOPHIC [adj THEOSOPHICALLY]\n",
  "THEOSOPHICALLY": "THEOSOPHICAL, relating to theosophy, also THEOSOPHIC [adv]\n",
  "THEOSOPHIES": "THEOSOPHY, immediate divine illumination or wisdom [n]\n",
  "THEOSOPHISE": "to practise theosophy, also THEOSOPHIZE [v THEOSOPHISED, THEOSOPHISING, THEOSOPHISES]\n",
  "THEOSOPHISED": "THEOSOPHISE, to practise theosophy, also THEOSOPHIZE [v]\n",
  "THEOSOPHISES": "THEOSOPHISE, to practise theosophy, also THEOSOPHIZE [v]\n",
  "THEOSOPHISING": "THEOSOPHISE, to practise theosophy, also THEOSOPHIZE [v]\n",
  "THEOSOPHISM": "theosophical tenets [n -S]\n",
  "THEOSOPHISMS": "THEOSOPHISM, theosophical tenets [n]\n",
  "THEOSOPHIST": "a believer in theosophy, immediate divine illumination or wisdom, also THEOSOPH, THEOSOPHER [n -S]\n",
  "THEOSOPHISTICAL": "theosophical; sophistical in theology [adj]\n",
  "THEOSOPHISTS": "THEOSOPHIST, a believer in theosophy, immediate divine illumination or wisdom, also THEOSOPH, THEOSOPHER [n]\n",
  "THEOSOPHIZE": "to practise theosophy, also THEOSOPHISE [v THEOSOPHIZED, THEOSOPHIZING, THEOSOPHIZES]\n",
  "THEOSOPHIZED": "THEOSOPHIZE, to practise theosophy, also THEOSOPHISE [v]\n",
  "THEOSOPHIZES": "THEOSOPHIZE, to practise theosophy, also THEOSOPHISE [v]\n",
  "THEOSOPHIZING": "THEOSOPHIZE, to practise theosophy, also THEOSOPHISE [v]\n",
  "THEOSOPHS": "THEOSOPH, a believer in theosophy, immediate divine illumination or wisdom, also THEOSOPHER, THEOSOPHIST [n]\n",
  "THEOSOPHY": "immediate divine illumination or wisdom [n THEOSOPHIES]\n",
  "THEOTECHNIC": "relating to theotechny, the use of the gods as primary moving force in a poem or play [adj]\n",
  "THEOTECHNIES": "THEOTECHNY, the use of the gods as a primary moving force in a poem or play [n]\n",
  "THEOTECHNY": "the use of the gods as a primary moving force in a poem or play [n THEOTECHNIES]\n",
  "THEOTOKOI": "THEOTOKOS, (Greek) a title given to the Virgin Mary as the bearer of God [n]\n",
  "THEOTOKOS": "(Greek) a title given to the Virgin Mary as the bearer of God [n THEOTOKOI]\n",
  "THEOW": "(Old English) a slave, a thrall [n -S]\n",
  "THEOWS": "THEOW, (Old English) a slave, a thrall [n]\n",
  "THERALITE": "a holocrystalline igneous rock composed of plagioclase, nephelite and augite [n -S]\n",
  "THERALITES": "THERALITE, a holocrystalline igneous rock composed of plagioclase, nephelite and augite [n]\n",
  "THERAPEUSES": "THERAPEUSIS, that part of medicine concerned with the treatment and cure of diseases [n]\n",
  "THERAPEUSIS": "that part of medicine concerned with the treatment and cure of diseases [n THERAPEUSES]\n",
  "THERAPEUTIC": "related to the healing arts, also THERAPEUTICAL [adj THERAPEUTICALLY]\n",
  "THERAPEUTICAL": "related to the healing arts, also THERAPEUTIC [adj THERAPEUTICALLY]\n",
  "THERAPEUTICALLY": "THERAPEUTICAL, related to the healing arts, also THERAPEUTIC [adv]\n",
  "THERAPEUTICS": "that part of medicine concerned with the treatment and cure of diseases [n]\n",
  "THERAPEUTIST": "a person skilled in therapeutics [n -S]\n",
  "THERAPEUTISTS": "THERAPEUTIST, a person skilled in therapeutics [n]\n",
  "THERAPIES": "THERAPY, the treatment of illness or disability [n]\n",
  "THERAPISE": "to subject to psychological therapy, also THERAPIZE [v THERAPISED, THERAPISING, THERAPISES]\n",
  "THERAPISED": "THERAPISE, to subject to psychological therapy, also THERAPIZE [v]\n",
  "THERAPISES": "THERAPISE, to subject to psychological therapy, also THERAPIZE [v]\n",
  "THERAPISING": "THERAPISE, to subject to psychological therapy, also THERAPIZE [v]\n",
  "THERAPIST": "one who practises therapy [n -S]\n",
  "THERAPISTS": "THERAPIST, one who practises therapy [n]\n",
  "THERAPIZE": "to subject to psychological therapy, also THERAPISE [v THERAPIZED, THERAPIZING, THERAPIZES]\n",
  "THERAPIZED": "THERAPIZE, to subject to psychological therapy, also THERAPISE [v]\n",
  "THERAPIZES": "THERAPIZE, to subject to psychological therapy, also THERAPISE [v]\n",
  "THERAPIZING": "THERAPIZE, to subject to psychological therapy, also THERAPISE [v]\n",
  "THERAPSID": "one of a group of Permian and Jurassic reptiles considered to be direct ancestors of mammals [n -S]\n",
  "THERAPSIDS": "THERAPSID, one of a group of Permian and Jurassic reptiles considered to be direct ancestors of mammals [n]\n",
  "THERAPY": "the treatment of illness or disability [n THERAPIES]\n",
  "THERBLIG": "a unit of work for quantifying industrial operations [n -S]\n",
  "THERBLIGS": "THERBLIG, a unit of work for quantifying industrial operations [n]\n",
  "THERE": "that place [n -S]\n",
  "THEREABOUT": "about or near that place, also THEREABOUTS [adv]\n",
  "THEREABOUTS": "about or near that place, also THEREABOUT [adv]\n",
  "THEREAFTER": "after that [interj]\n",
  "THEREAGAINST": "against that [adv]\n",
  "THEREAMONG": "among that or those [adv]\n",
  "THEREANENT": "(Scots) concerning that matter [adv]\n",
  "THEREAT": "at that place or time [adv]\n",
  "THEREAWAY": "in that direction [adv]\n",
  "THEREBESIDE": "beside that [adv]\n",
  "THEREBY": "by that means [adv]\n",
  "THEREFOR": "for that [adv]\n",
  "THEREFORE": "for that reason [adv]\n",
  "THEREFROM": "from that [adv]\n",
  "THEREIN": "in that place [adv]\n",
  "THEREINAFTER": "in the following part of that matter (as writing, document, or speech) [adv]\n",
  "THEREINBEFORE": "in the preceding part of that writing or document [adv]\n",
  "THEREINTO": "into that or it [adv]\n",
  "THEREMIN": "an electronic musical instrument [n -S]\n",
  "THEREMINS": "THEREMIN, an electronic musical instrument [n]\n",
  "THERENESS": "the quality of being there [n -ES]\n",
  "THERENESSES": "THERENESS, the quality of being there [n]\n",
  "THEREOF": "of that [adv]\n",
  "THEREON": "on that [adv]\n",
  "THEREOUT": "out of that [adv]\n",
  "THERES": "THERE, that place [n]\n",
  "THERETHROUGH": "through that; by that means [adv]\n",
  "THERETO": "to that [adv]\n",
  "THERETOFORE": "up to that time [adv]\n",
  "THEREUNDER": "under that [adv]\n",
  "THEREUNTO": "unto that or this; thereto; besides [adv]\n",
  "THEREUPON": "at which point [adv]\n",
  "THEREWITH": "thereupon; forthwith [adv]\n",
  "THEREWITHAL": "(archaic) besides, together with [adv]\n",
  "THEREWITHIN": "within that [interj]\n",
  "THERIAC": "(archaic) an antidote to venomous bites, originally made of various ingredients including viper flesh mixed with honey, also THERIACA [n -S]\n",
  "THERIACA": "(archaic) an antidote to venomous bites, originally made of various ingredients including viper flesh mixed with honey, also THERIAC [n -S]\n",
  "THERIACAL": "of or pertaining to theriac; medicinal [adj]\n",
  "THERIACAS": "THERIACA, (archaic) an antidote to venomous bites, originally made of various ingredients including viper flesh mixed with honey, also THERIAC [n]\n",
  "THERIACS": "THERIAC, (archaic) an antidote to venomous bites, originally made of various ingredients including viper flesh mixed with honey, also THERIACA [n]\n",
  "THERIAN": "belonging to the subclass comprising marsupials and placentals [adj] / a therian mammal [n -S]\n",
  "THERIANS": "THERIAN, a therian mammal [n]\n",
  "THERIANTHROPIC": "combining human and animal forms [adj]\n",
  "THERIANTHROPISM": "the representation or worship of therianthropic forms or gods [n]\n",
  "THERIOLATRIES": "THERIOLATRY, animal-worship [n]\n",
  "THERIOLATRY": "animal-worship [n THERIOLATRIES]\n",
  "THERIOMORPH": "an animal form in art [n -S]\n",
  "THERIOMORPHIC": "having the form of a beast, also THERIOMORPHOUS [adj]\n",
  "THERIOMORPHISM": "the belief that gods exist in animal form [n -S]\n",
  "THERIOMORPHISMS": "THERIOMORPHISM, the belief that gods exist in animal form [n]\n",
  "THERIOMORPHOSES": "THERIOMORPHOSIS, transformation into a beast [n]\n",
  "THERIOMORPHOSIS": "transformation into a beast [n THERIOMORPHOSES]\n",
  "THERIOMORPHOUS": "having the form of a beast, also THERIOMORPHIC [adj]\n",
  "THERIOMORPHS": "THERIOMORPH, an animal form in art [n]\n",
  "THERM": "a unit of quantity of heat equal to 100,000 British thermal units, also THERME [n -S]\n",
  "THERMAE": "(Latin) hot springs or baths, esp. in ancient Rome [n]\n",
  "THERMAESTHESIA": "sensitivity to various degrees of heat and cold, also THERMESTHESIA [n -S]\n",
  "THERMAESTHESIAS": "THERMAESTHESIA, sensitivity to various degrees of heat and cold, also THERMESTHESIA [n]\n",
  "THERMAL": "relating to heat [adj THERMALLY] / a rising current of warm air used by e.g. gliders or birds of prey [n -S]\n",
  "THERMALISATION": "the act of thermalising, also THERMALIZATION [n -S]\n",
  "THERMALISATIONS": "THERMALISATION, the act of thermalising, also THERMALIZATION [n]\n",
  "THERMALISE": "to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALIZE [v THERMALISED, THERMALISING, THERMALISES]\n",
  "THERMALISED": "THERMALISE, to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALIZE [v]\n",
  "THERMALISES": "THERMALISE, to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALIZE [v]\n",
  "THERMALISING": "THERMALISE, to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALIZE [v]\n",
  "THERMALIZATION": "the act of thermalizing, also THERMALISATION [n -S]\n",
  "THERMALIZATIONS": "THERMALIZATION, the act of thermalizing, also THERMALISATION [n]\n",
  "THERMALIZE": "to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALISE [v THERMALIZED, THERMALIZING, THERMALIZES]\n",
  "THERMALIZED": "THERMALIZE, to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALISE [v]\n",
  "THERMALIZES": "THERMALIZE, to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALISE [v]\n",
  "THERMALIZING": "THERMALIZE, to reduce the kinetic energy and speed of fast neutrons in a reactor, also THERMALISE [v]\n",
  "THERMALLY": "THERMAL, relating to heat [adv]\n",
  "THERMALS": "THERMAL, a rising current of warm air used by e.g. gliders or birds of prey [n]\n",
  "THERME": "a unit of quantity of heat equal to 100,000 British thermal units, also THERM [n -S]\n",
  "THERMEL": "a device for temperature measurement [n -S]\n",
  "THERMELS": "THERMEL, a device for temperature measurement [n]\n",
  "THERMES": "THERME, a unit of quantity of heat equal to 100,000 British thermal units, also THERM [n]\n",
  "THERMESTHESIA": "sensitivity to various degrees of heat and cold, also THERMAESTHESIA [n -S]\n",
  "THERMESTHESIAS": "THERMESTHESIA, sensitivity to various degrees of heat and cold, also THERMAESTHESIA [n]\n",
  "THERMETTE": "(tradename) a device, used outdoors, for boiling water rapidly [n -S]\n",
  "THERMETTES": "THERMETTE, (tradename) a device, used outdoors, for boiling water rapidly [n]\n",
  "THERMIC": "of or by heat, also THERMICAL [adj THERMICALLY]\n",
  "THERMICAL": "of or by heat, also THERMIC [adj THERMICALLY]\n",
  "THERMICALLY": "THERMICAL, of or by heat, also THERMIC [adv]\n",
  "THERMIDOR": "a method of preparing lobsters, the flesh being mixed with a cream sauce seasoned with mustard, and served in the shell [n -S]\n",
  "THERMIDORS": "THERMIDOR, a method of preparing lobsters, the flesh being mixed with a cream sauce seasoned with mustard, and served in the shell [n]\n",
  "THERMION": "an ion emitted by a heated body [n -S]\n",
  "THERMIONIC": "relating to a thermion [adj]\n",
  "THERMIONICS": "physics dealing with thermionic phenomena [n]\n",
  "THERMIONS": "THERMION, an ion emitted by a heated body [n]\n",
  "THERMISTOR": "a semiconductor, a mixture of certain oxides with finely divided copper in which the resistance is very sensitive to changes of temperature [n -S]\n",
  "THERMISTORS": "THERMISTOR, a semiconductor, a mixture of certain oxides with finely divided copper in which the resistance is very sensitive to changes of temperature [n]\n",
  "THERMIT": "a metallic mixture that produces intense heat when ignited, also THERMITE [n -S]\n",
  "THERMITE": "a metallic mixture that produces intense heat when ignited, also THERMIT [n -S]\n",
  "THERMITES": "THERMITE, a metallic mixture that produces intense heat when ignited, also THERMIT [n]\n",
  "THERMITS": "THERMIT, a metallic mixture that produces intense heat when ignited, also THERMITE [n]\n",
  "THERMOBALANCE": "an analytical balance that measures weight changes when matter is heated [n -S]\n",
  "THERMOBALANCES": "THERMOBALANCE, an analytical balance that measures weight changes when matter is heated [n]\n",
  "THERMOBARIC": "of a weapon, using a combination of heat and pressure to create a blast more powerful than that of conventional explosives [adj]\n",
  "THERMOBAROGRAPH": "a device that simultaneously records the temperature and pressure of the atmosphere [n]\n",
  "THERMOBAROMETER": "an apparatus that provides an accurate measurement of pressure by observation of the change in the boiling point of a fluid [n]\n",
  "THERMOCHEMICAL": "relating to thermochemistry [adj]\n",
  "THERMOCHEMIST": "one who studies thermochemistry [n -S]\n",
  "THERMOCHEMISTRY": "a branch of chemistry that deals with the interrelation of heat with chemical reaction or physical change of state [n]\n",
  "THERMOCHEMISTS": "THERMOCHEMIST, one who studies thermochemistry [n]\n",
  "THERMOCHROMIC": "relating to thermochromism [adj]\n",
  "THERMOCHROMIES": "THERMOCHROMY, a phenomenon in which certain dyes made from liquid crystals change colour reversibly when their temperature is change, also THERMOCHROMISM [n]\n",
  "THERMOCHROMISM": "a phenomenon in which certain dyes made from liquid crystals change colour reversibly when their temperature is change, also THERMOCHROMY [n -S]\n",
  "THERMOCHROMISMS": "THERMOCHROMISM, a phenomenon in which certain dyes made from liquid crystals change colour reversibly when their temperature is change, also THERMOCHROMY [n]\n",
  "THERMOCHROMY": "a phenomenon in which certain dyes made from liquid crystals change colour reversibly when their temperature is change, also THERMOCHROMISM [n THERMOCHROMIES]\n",
  "THERMOCLINE": "in lakes, a region of rapidly changing temperature, found between the epilimnion and the hypolimnion [n -S]\n",
  "THERMOCLINES": "THERMOCLINE, in lakes, a region of rapidly changing temperature, found between the epilimnion and the hypolimnion [n]\n",
  "THERMOCOUPLE": "a pair of different metals in contact giving a thermoelectric current [n -S]\n",
  "THERMOCOUPLES": "THERMOCOUPLE, a pair of different metals in contact giving a thermoelectric current [n]\n",
  "THERMODURIC": "resistant to high temperatures [adj]\n",
  "THERMODYNAMIC": "of or relating to thermodynamics, also THERMODYNAMICAL [adj]\n",
  "THERMODYNAMICAL": "of or relating to thermodynamics, also THERMODYNAMIC [adj]\n",
  "THERMODYNAMICS": "physics that deals with the mechanical action or relations of heat [n]\n",
  "THERMOELECTRIC": "relating to electricity developed by bodies at different temperatures [adj]\n",
  "THERMOELECTRON": "an electron emitted at high temperature, such as one produced in a thermionic valve [n -S]\n",
  "THERMOELECTRONS": "THERMOELECTRON, an electron emitted at high temperature, such as one produced in a thermionic valve [n]\n",
  "THERMOELEMENT": "a device for measuring small currents consisting of a wire heating element and a thermocouple in electrical contact with it [n -S]\n",
  "THERMOELEMENTS": "THERMOELEMENT, a device for measuring small currents consisting of a wire heating element and a thermocouple in electrical contact with it [n]\n",
  "THERMOFORM": "to give a final shape to plastics by heat and pressure [v -ED, -ING, -S]\n",
  "THERMOFORMABLE": "capable of being thermoformed [adj]\n",
  "THERMOFORMED": "THERMOFORM, to give a final shape to plastics by heat and pressure [v]\n",
  "THERMOFORMING": "THERMOFORM, to give a final shape to plastics by heat and pressure [v]\n",
  "THERMOFORMS": "THERMOFORM, to give a final shape to plastics by heat and pressure [v]\n",
  "THERMOGENESES": "THERMOGENESIS, the production of heat [n]\n",
  "THERMOGENESIS": "the production of heat [n THERMOGENESES]\n",
  "THERMOGENETIC": "producing heat, also THERMOGENIC [adj]\n",
  "THERMOGENIC": "producing heat, also THERMOGENETIC [adj]\n",
  "THERMOGENOUS": "relating to thermogenesis, the production of heat [adj]\n",
  "THERMOGRAM": "a thermograph record of temperature [n -S]\n",
  "THERMOGRAMS": "THERMOGRAM, a thermograph record of temperature [n]\n",
  "THERMOGRAPH": "an instrument for recording changes in temperature [n -S]\n",
  "THERMOGRAPHER": "one who uses a thermograph, an instrument for recording changes in temperature [n -S]\n",
  "THERMOGRAPHERS": "THERMOGRAPHER, one who uses a thermograph, an instrument for recording changes in temperature [n]\n",
  "THERMOGRAPHIC": "relating to thermography [adj]\n",
  "THERMOGRAPHIES": "THERMOGRAPHY, a process of writing or printing involving the use of heat [n]\n",
  "THERMOGRAPHS": "THERMOGRAPH, an instrument for recording changes in temperature [n]\n",
  "THERMOGRAPHY": "a process of writing or printing involving the use of heat [n THERMOGRAPHIES]\n",
  "THERMOHALINE": "involving both temperature and salinity [adj]\n",
  "THERMOJUNCTION": "a junction of two dissimilar conductors used to produce a thermoelectric current [n -S]\n",
  "THERMOJUNCTIONS": "THERMOJUNCTION, a junction of two dissimilar conductors used to produce a thermoelectric current [n]\n",
  "THERMOLABILE": "easily decomposed by heat [adj]\n",
  "THERMOLABILITY": "the state of being thermolabile, easily decomposed by heat [n]\n",
  "THERMOLOGIES": "THERMOLOGY, the study of heat [n]\n",
  "THERMOLOGY": "the study of heat [n THERMOLOGIES]\n",
  "THERMOLYSES": "THERMOLYSIS, decomposition caused by heat [n]\n",
  "THERMOLYSIS": "decomposition caused by heat [n THERMOLYSES]\n",
  "THERMOLYTIC": "relating to thermolysis, decomposition caused by heat [adj]\n",
  "THERMOMAGNETIC": "of or relating to the effects of heat upon the magnetic properties of substances or to the effects of a magnetic field upon thermal conduction [adj]\n",
  "THERMOMETER": "an instrument for determining temperature [n -S]\n",
  "THERMOMETERS": "THERMOMETER, an instrument for determining temperature [n]\n",
  "THERMOMETRIC": "relating to the measurement of temperature, also THERMOMETRICAL [adj]\n",
  "THERMOMETRICAL": "relating to the measurement of temperature, also THERMOMETRIC [adj]\n",
  "THERMOMETRIES": "THERMOMETRY, the measurement of temperature [n]\n",
  "THERMOMETRY": "the measurement of temperature [n THERMOMETRIES]\n",
  "THERMOMOTOR": "an engine that produces force from the expansion of a heated fluid [n -S]\n",
  "THERMOMOTORS": "THERMOMOTOR, an engine that produces force from the expansion of a heated fluid [n]\n",
  "THERMONASTIES": "THERMONASTY, nastic movement in response to heat or temperature change [n]\n",
  "THERMONASTY": "nastic movement in response to heat or temperature change [n THERMONASTIES]\n",
  "THERMONUCLEAR": "of, relating to, or employing transformations in the nuclei of atoms of low atomic weight (as hydrogen) that require a very high temperature for their inception (as in the hydrogen bomb or in the sun) [adj]\n",
  "THERMOPERIODIC": "relating to thermoperiodism, the effect on an organism of rhythmic temperature variations [adj]\n",
  "THERMOPERIODISM": "the effect on an organism of rhythmic temperature variations [n]\n",
  "THERMOPHIL": "requiring, or thriving best in, high temperatures [adj] / a bacteria, plant etc. requiring or thriving in high temperatures, also THERMOPHILE, THERMOPHILIC, THERMOPHILOUS [n -S]\n",
  "THERMOPHILE": "requiring, or thriving best in, high temperatures [adj] / a bacteria, plant etc. requiring or thriving in high temperatures, also THERMOPHIL, THERMOPHILIC, THERMOPHILOUS [n -S]\n",
  "THERMOPHILES": "THERMOPHILE, a bacteria, plant etc. requiring or thriving in high temperatures, also THERMOPHIL, THERMOPHILIC, THERMOPHILOUS [n]\n",
  "THERMOPHILIC": "of plants etc. requiring or thriving in high temperatures, also THERMOPHIL, THERMOPHILE, THERMOPHILOUS [adj]\n",
  "THERMOPHILOUS": "of plants etc. requiring or thriving in high temperatures, also THERMOPHIL, THERMOPHILE, THERMOPHILIC [adj]\n",
  "THERMOPHILS": "THERMOPHIL, a bacteria, plant etc. requiring or thriving in high temperatures, also THERMOPHILE, THERMOPHILIC, THERMOPHILOUS [n]\n",
  "THERMOPHYLLOUS": "having leaves only in the warmer part of the year, deciduous [adj]\n",
  "THERMOPILE": "an instrument measuring minute changes in temperature [n -S]\n",
  "THERMOPILES": "THERMOPILE, an instrument measuring minute changes in temperature [n]\n",
  "THERMOPLASTIC": "capable of softening or fusing when heated and of hardening again when cooled [adj] / a plastic with these properties [n -S]\n",
  "THERMOPLASTICS": "THERMOPLASTIC, a plastic with these properties [n]\n",
  "THERMORECEPTOR": "a sensory end organ that is stimulated by heat or cold [n -S]\n",
  "THERMORECEPTORS": "THERMORECEPTOR, a sensory end organ that is stimulated by heat or cold [n]\n",
  "THERMOREGULATE": "to regulate by means of heat [v THERMOREGULATED, THERMOREGULATES]\n",
  "THERMOREGULATED": "THERMOREGULATE, to regulate by means of heat [v]\n",
  "THERMOREGULATES": "THERMOREGULATE, to regulate by means of heat [v]\n",
  "THERMOREGULATOR": "a device, such as a thermostat, for the regulation of temperature [n]\n",
  "THERMOREMANENCE": "the state of being thermoremanent [n]\n",
  "THERMOREMANENT": "relating to magnetic remanence (as in a rock cooled from a molten state or in a baked clay object containing magnetic minerals) that indicates the strength and direction of the earth's magnetic field at a former time [adj]\n",
  "THERMOS": "(tradename) a container used to keep food or drink hot or cold [n -ES]\n",
  "THERMOSCOPE": "an instrument indicating a change in temperature [n -S]\n",
  "THERMOSCOPES": "THERMOSCOPE, an instrument indicating a change in temperature [n]\n",
  "THERMOSCOPIC": "indicating, or sensitive to, temperature changes, also THERMOSCOPICAL [adj]\n",
  "THERMOSCOPICAL": "indicating, or sensitive to, temperature changes, also THERMOSCOPIC [adj]\n",
  "THERMOSES": "THERMOS, (tradename) a container used to keep food or drink hot or cold [n]\n",
  "THERMOSET": "of resin or plastic, to set permanently after melting and moulding [v THERMOSET, THERMOSETTING, THERMOSETS]\n",
  "THERMOSETS": "THERMOSET, of resin or plastic, to set permanently after melting and moulding [v]\n",
  "THERMOSETTING": "THERMOSET, of resin or plastic, to set permanently after melting and moulding [v]\n",
  "THERMOSIPHON": "a method of circulating a cooling liquid through a system by using the slight difference in density between the hot and cool parts [n -S]\n",
  "THERMOSIPHONS": "THERMOSIPHON, a method of circulating a cooling liquid through a system by using the slight difference in density between the hot and cool parts [n]\n",
  "THERMOSPHERE": "the outermost layer of the atmosphere [n -S]\n",
  "THERMOSPHERES": "THERMOSPHERE, the outermost layer of the atmosphere [n]\n",
  "THERMOSPHERIC": "relating to thermosphere [adj]\n",
  "THERMOSTABILITY": "the state of being thermostable [n]\n",
  "THERMOSTABLE": "stable when heated [adj]\n",
  "THERMOSTAT": "to provide with or control the temperature of by a thermostat, a device for keeping temperature stead [v THERMOSTATED or THERMOSTATTED, THERMOSTATING or THERMOSTATTING, THERMOSTATS]\n",
  "THERMOSTATED": "THERMOSTAT, to provide with or control the temperature of by a thermostat, a device for keeping temperature stead [v]\n",
  "THERMOSTATIC": "relating to thermal equilibrium [adj]\n",
  "THERMOSTATICS": "the branch of science concerned with thermal equilibrium [n]\n",
  "THERMOSTATING": "THERMOSTAT, to provide with or control the temperature of by a thermostat, a device for keeping temperature stead [v]\n",
  "THERMOSTATS": "THERMOSTAT, to provide with or control the temperature of by a thermostat, a device for keeping temperature stead [v]\n",
  "THERMOSTATTED": "THERMOSTAT, to provide with or control the temperature of by a thermostat, a device for keeping temperature stead [v]\n",
  "THERMOSTATTING": "THERMOSTAT, to provide with or control the temperature of by a thermostat, a device for keeping temperature stead [v]\n",
  "THERMOTACTIC": "of or showing thermotaxis, also THERMOTAXIC [adj]\n",
  "THERMOTAXES": "THERMOTAXIS, movement influenced or controlled by heat [n]\n",
  "THERMOTAXIC": "of or showing thermotaxis, also THERMOTACTIC [adj]\n",
  "THERMOTAXIS": "movement influenced or controlled by heat [n THERMOTAXES]\n",
  "THERMOTENSILE": "of or relating to tensile strength in so far as it is affected by temperature [adj]\n",
  "THERMOTHERAPIES": "THERMOTHERAPY, the treatment of a part of the body by heat [n]\n",
  "THERMOTHERAPY": "the treatment of a part of the body by heat [n THERMOTHERAPIES]\n",
  "THERMOTIC": "of or due to heat, also THERMOTICAL [adj]\n",
  "THERMOTICAL": "of or due to heat, also THERMOTIC [adj]\n",
  "THERMOTICS": "the science of heat [n]\n",
  "THERMOTOLERANT": "able to endure high temperatures but not growing well under such conditions [adj]\n",
  "THERMOTROPIC": "bending towards or away from a heat source [adj] / a thermotropic plant [n -S]\n",
  "THERMOTROPICS": "THERMOTROPIC, a thermotropic plant [n]\n",
  "THERMOTROPISM": "the growth of organism as influenced by heat [n -S]\n",
  "THERMOTROPISMS": "THERMOTROPISM, the growth of organism as influenced by heat [n]\n",
  "THERMS": "THERM, a unit of quantity of heat equal to 100,000 British thermal units, also THERME [n]\n",
  "THEROID": "resembling a beast [adj]\n",
  "THEROLOGIES": "THEROLOGY, the study of wild mammals [n]\n",
  "THEROLOGY": "the study of wild mammals [n THEROLOGIES]\n",
  "THEROPHYTE": "a plant that overwinters as a seed [n -S]\n",
  "THEROPHYTES": "THEROPHYTE, a plant that overwinters as a seed [n]\n",
  "THEROPOD": "a carnivorous dinosaur with small forelimbs (e.g. tyrannosaurus), also THEROPODAN [n -S]\n",
  "THEROPODAN": "a carnivorous dinosaur with small forelimbs (e.g. a tyrannosaurus), also THEROPOD [n -S]\n",
  "THEROPODANS": "THEROPODAN, a carnivorous dinosaur with small forelimbs (e.g. a tyrannosaurus), also THEROPOD [n]\n",
  "THEROPODS": "THEROPOD, a carnivorous dinosaur with small forelimbs (e.g. tyrannosaurus), also THEROPODAN [n]\n",
  "THERSITICAL": "scurrilous; foulmouthed; grossly abusive [adj]\n",
  "THESAURAL": "relating to a thesaurus [adj]\n",
  "THESAURI": "THESAURUS, (Latin) a storehouse of knowledge; a dictionary of synonyms [n]\n",
  "THESAURUS": "(Latin) a storehouse of knowledge; a dictionary of synonyms [n THESAURI or THESAURUSES]\n",
  "THESAURUSES": "THESAURUS, (Latin) a storehouse of knowledge; a dictionary of synonyms [n]\n",
  "THESE": "THIS, the person or thing just mentioned [pron]\n",
  "THESES": "THESIS, a proposition put forward for discussion [n]\n",
  "THESIS": "a proposition put forward for discussion [n THESES]\n",
  "THESMOTHETE": "a lawgiver [n -S]\n",
  "THESMOTHETES": "THESMOTHETE, a lawgiver [n]\n",
  "THESP": "a thespian, a member of the acting profession [n -S]\n",
  "THESPIAN": "an actor or actress [n -S]\n",
  "THESPIANS": "THESPIAN, an actor or actress [n]\n",
  "THESPS": "THESP, a thespian, a member of the acting profession [n]\n",
  "THETA": "(Greek) a letter of the Greek alphabet corresponding to th in English [n -S]\n",
  "THETAS": "THETA, (Greek) a letter of the Greek alphabet corresponding to th in English [n]\n",
  "THETCH": "(Spenser) to thatch [v -ED, -ING, -ES]\n",
  "THETCHED": "THETCH, (Spenser) to thatch [v]\n",
  "THETCHES": "THETCH, (Spenser) to thatch [v]\n",
  "THETCHING": "THETCH, (Spenser) to thatch [v]\n",
  "THETE": "(Greek) in ancient Greece, a serf; a poor freeman under Solon's constitution [n -S]\n",
  "THETES": "THETE, (Greek) in ancient Greece, a serf; a poor freeman under Solon's constitution [n]\n",
  "THETHER": "(Spenser) thither [adv]\n",
  "THETIC": "positively asserting, bearing the thesis, also THETICAL [adj THETICALLY]\n",
  "THETICAL": "positively asserting, bearing the thesis, also THETIC [adj THETICALLY]\n",
  "THETICALLY": "THETICAL, positively asserting, bearing the thesis, also THETIC [adv]\n",
  "THETRI": "a currency unit of Georgia, also TETRI [n -S]\n",
  "THETRIS": "THETRI, a currency unit of Georgia, also TETRI [n]\n",
  "THEURGIC": "of or pertaining to theurgy; magical, also THEURGICAL [adj THEURGICALLY]\n",
  "THEURGICAL": "of or pertaining to theurgy; magical, also THEURGIC [adj THEURGICALLY]\n",
  "THEURGICALLY": "THEURGICAL, of or pertaining to theurgy; magical, also THEURGIC [adv]\n",
  "THEURGIES": "THEURGY, magic or miracles by the agency of good spirits [n]\n",
  "THEURGIST": "a believer in theurgy, magic performed with the aid of beneficent spirits [n -S]\n",
  "THEURGISTS": "THEURGIST, a believer in theurgy, magic performed with the aid of beneficent spirits [n]\n",
  "THEURGY": "magic or miracles by the agency of good spirits [n THEURGIES]\n",
  "THEW": "a well-developed muscle [n THEWS or THEWES]\n",
  "THEWED": "having thews [adj]\n",
  "THEWES": "THEW, a well-developed muscle [n]\n",
  "THEWIER": "THEWY, having strong or large thews [adj]\n",
  "THEWIEST": "THEWY, having strong or large thews [adj]\n",
  "THEWLESS": "weak, without thews, also THOWLESS [adj]\n",
  "THEWS": "THEW, a well-developed muscle [n]\n",
  "THEWY": "having strong or large thews [adj THEWIER, THEWIEST]\n",
  "THEY": "the 3d person plural pronoun in the nominative case [pron]\n",
  "THIABENDAZOLE": "a drug used in the control of parasitic nematode worms and fungus infections and as an agricultural fungicide [n -S]\n",
  "THIABENDAZOLES": "THIABENDAZOLE, a drug used in the control of parasitic nematode worms and fungus infections and as an agricultural fungicide [n]\n",
  "THIAMIN": "vitamin B1, found in seeds, grains, beans etc., also THIAMINE [n -S]\n",
  "THIAMINASE": "an enzyme that catalyses the breakdown of thiamine [n -S]\n",
  "THIAMINASES": "THIAMINASE, an enzyme that catalyses the breakdown of thiamine [n]\n",
  "THIAMINE": "vitamin B1, found in seeds, grains, beans etc., also THIAMIN [n -S]\n",
  "THIAMINES": "THIAMINE, vitamin B1, found in seeds, grains, beans etc., also THIAMIN [n]\n",
  "THIAMINS": "THIAMIN, vitamin B1, found in seeds, grains, beans etc., also THIAMINE [n]\n",
  "THIASUS": "(Greek) a group of worshippers gathered to dance in praise of gods [n -ES]\n",
  "THIASUSES": "THIASUS, (Greek) a group of worshippers gathered to dance in praise of gods [n]\n",
  "THIAZIDE": "a drug used to treat high blood pressure [n -S]\n",
  "THIAZIDES": "THIAZIDE, a drug used to treat high blood pressure [n]\n",
  "THIAZIN": "any of a group of organic compounds containing four carbon atoms, one sulphur and one nitrogen atom, also THIAZINE [n -S]\n",
  "THIAZINE": "any of a group of organic compounds containing four carbon atoms, one sulphur and one nitrogen atom, also THIAZIN [n -S]\n",
  "THIAZINES": "THIAZINE, any of a group of organic compounds containing four carbon atoms, one sulphur and one nitrogen atom, also THIAZIN [n]\n",
  "THIAZINS": "THIAZIN, any of a group of organic compounds containing four carbon atoms, one sulphur and one nitrogen atom, also THIAZINE [n]\n",
  "THIAZOL": "a heterocyclic compound that contains both sulfur and nitrogen, also THIAZOLE [n -S]\n",
  "THIAZOLE": "a heterocyclic compound that contains both sulfur and nitrogen, also THIAZOL [n -S]\n",
  "THIAZOLES": "THIAZOLE, a heterocyclic compound that contains both sulfur and nitrogen, also THIAZOL [n]\n",
  "THIAZOLS": "THIAZOL, a heterocyclic compound that contains both sulfur and nitrogen, also THIAZOLE [n]\n",
  "THIBET": "a fabric made of coarse goat's hair [n -S]\n",
  "THIBETS": "THIBET, a fabric made of coarse goat's hair [n]\n",
  "THIBLE": "a porridge-stick, also THIVEL [n -S]\n",
  "THIBLES": "THIBLE, a porridge-stick, also THIVEL [n]\n",
  "THICK": "having a great distance in measurement from surface to surface in the lesser dimension [adj THICKER, THICKEST, THICKLY] / (Spenser) to make thick [v -ED, -ING, -S]\n",
  "THICKED": "THICK, (Spenser) to make thick [v]\n",
  "THICKEN": "to make thick [v -ED, -ING, -S]\n",
  "THICKENED": "THICKEN, to make thick [v]\n",
  "THICKENER": "an agent used for thickening esp. soups etc. [n -S]\n",
  "THICKENERS": "THICKENER, an agent used for thickening esp. soups etc. [n]\n",
  "THICKENING": "something added to a liquid to thicken it [n -S]\n",
  "THICKENINGS": "THICKENING, something added to a liquid to thicken it [n]\n",
  "THICKENS": "THICKEN, to make thick [v]\n",
  "THICKER": "THICK, having a great distance in measurement from surface to surface in the lesser dimension [adj]\n",
  "THICKEST": "THICK, having a great distance in measurement from surface to surface in the lesser dimension [adj]\n",
  "THICKET": "a dense growth of trees or shrubs [n -S]\n",
  "THICKETED": "having thickets, densely wooded [adj]\n",
  "THICKETIER": "THICKETY, having the nature of a thicket [adj]\n",
  "THICKETIEST": "THICKETY, having the nature of a thicket [adj]\n",
  "THICKETS": "THICKET, a dense growth of trees or shrubs [n]\n",
  "THICKETY": "having the nature of a thicket [adj THICKETIER, THICKETIEST]\n",
  "THICKHEAD": "a thickheaded or stupid person; any bird of an Australian family related to flycatchers [n -S]\n",
  "THICKHEADED": "stupid [adj]\n",
  "THICKHEADEDNESS": "the state of being thickheaded [n]\n",
  "THICKHEADS": "THICKHEAD, a thickheaded or stupid person; any bird of an Australian family related to flycatchers [n]\n",
  "THICKIE": "a stupid person, also THICKO, THICKY [n -S]\n",
  "THICKIES": "THICKIE, a stupid person, also THICKO, THICKY [n]\n",
  "THICKING": "THICK, (Spenser) to make thick [v]\n",
  "THICKISH": "somewhat thick [adj]\n",
  "THICKLEAF": "any of various succulent plants of the genus Crassula [n THICKLEAVES]\n",
  "THICKLEAVES": "THICKLEAF, any of various succulent plants of the genus Crassula [n]\n",
  "THICKLY": "THICK, having a great distance in measurement from surface to surface in the lesser dimension [adv]\n",
  "THICKNESS": "the state of being thick [n -ES]\n",
  "THICKNESSES": "THICKNESS, the state of being thick [n]\n",
  "THICKO": "(colloquial) a stupid person, also THICKY, THICKIE [n -S or -ES]\n",
  "THICKOES": "THICKO, (colloquial) a stupid person, also THICKY, THICKIE [n]\n",
  "THICKOS": "THICKO, (colloquial) a stupid person, also THICKY, THICKIE [n]\n",
  "THICKS": "THICK, (Spenser) to make thick [v]\n",
  "THICKSET": "having a short thick body [adj] / one of thickset build [n -S]\n",
  "THICKSETS": "THICKSET, one of thickset build [n]\n",
  "THICKSKIN": "a coarse, gross person; a person void of sensibility or sensitiveness [n -S]\n",
  "THICKSKINS": "THICKSKIN, a coarse, gross person; a person void of sensibility or sensitiveness [n]\n",
  "THICKY": "(colloquial) a stupid person, also THICKO, THICKIE [n THICKIES]\n",
  "THIEF": "one that steals [n THIEVES]\n",
  "THIEFLIKE": "like a thief [adj]\n",
  "THIEVE": "to steal [v THIEVED, THIEVING, THIEVES]\n",
  "THIEVED": "THIEVE, to steal [v]\n",
  "THIEVERIES": "THIEVERY, the act of stealing [n]\n",
  "THIEVERY": "the act of stealing [n THIEVERIES]\n",
  "THIEVES": "THIEVE, to steal [v]\n",
  "THIEVING": "the act of stealing [n -S]\n",
  "THIEVINGS": "THIEVING, the act of stealing [n]\n",
  "THIEVISH": "given to stealing [adj THIEVISHLY]\n",
  "THIEVISHLY": "THIEVISH, given to stealing [adv]\n",
  "THIEVISHNESS": "the state of being thievish [n -ES]\n",
  "THIEVISHNESSES": "THIEVISHNESS, the state of being thievish [n]\n",
  "THIG": "(Scots) to beg; to live on alms [v THIGGED or THIGGIT, THIGGING, THIGS]\n",
  "THIGGED": "THIG, (Scots) to beg; to live on alms [v]\n",
  "THIGGER": "one who thigs, a beggar [n -S]\n",
  "THIGGERS": "THIGGER, one who thigs, a beggar [n]\n",
  "THIGGING": "the act of begging [n -S]\n",
  "THIGGINGS": "THIGGING, the act of begging [n]\n",
  "THIGGIT": "THIG, (Scots) to beg; to live on alms [v]\n",
  "THIGH": "a part of the leg from knee to hip [n -S]\n",
  "THIGHBONE": "the bone of the leg between the hip joint and the knee, the femur [n -S]\n",
  "THIGHBONES": "THIGHBONE, the bone of the leg between the hip joint and the knee, the femur [n]\n",
  "THIGHED": "having a thigh [adj]\n",
  "THIGHS": "THIGH, a part of the leg from knee to hip [n]\n",
  "THIGMOTACTIC": "showing thigmotaxis [adj]\n",
  "THIGMOTAXES": "THIGMOTAXIS, the movement of a plant towards or away from an object [n]\n",
  "THIGMOTAXIS": "the movement of a plant towards or away from an object [n THIGMOTAXES]\n",
  "THIGMOTROPIC": "showing thigmotropism, i.e. response to direct contact with a surface [adj]\n",
  "THIGMOTROPISM": "the response of an organism to direct contact with a surface, e.g. a creeping plant that twines itself around a support [n -S]\n",
  "THIGMOTROPISMS": "THIGMOTROPISM, the response of an organism to direct contact with a surface, e.g. a creeping plant that twines itself around a support [n]\n",
  "THIGS": "THIG, (Scots) to beg; to live on alms [v]\n",
  "THILK": "(dialect) the same [adj]\n",
  "THILL": "the shaft of a vehicle [n -S]\n",
  "THILLER": "the horse which goes between the thills, or shafts, of a carriage and supports them [n -S]\n",
  "THILLERS": "THILLER, the horse which goes between the thills, or shafts, of a carriage and supports them [n]\n",
  "THILLS": "THILL, the shaft of a vehicle [n]\n",
  "THIMBLE": "to wear a cap on the finger when sewing [v THIMBLED, THIMBLING, THIMBLES]\n",
  "THIMBLEBERRIES": "THIMBLEBERRY, any of several American raspberries or blackberries having thimble-shaped fruit [n]\n",
  "THIMBLEBERRY": "any of several American raspberries or blackberries having thimble-shaped fruit [n THIMBLEBERRIES]\n",
  "THIMBLED": "THIMBLE, to wear a cap on the finger when sewing [v]\n",
  "THIMBLEFUL": "the contents of a thimble [n THIMBLEFULS or THIMBLESFUL]\n",
  "THIMBLEFULS": "THIMBLEFUL, the contents of a thimble [n]\n",
  "THIMBLERIG": "a sleight-of-hand trick played with three small cups, shaped like thimbles, and a small ball or little pea [n -S] / to cheat by trickery [v THIMBLERIGGED, THIMBLERIGGING, THIMBLERIGS]\n",
  "THIMBLERIGGED": "THIMBLERIG, to cheat by trickery [v]\n",
  "THIMBLERIGGER": "one who thimblerigs [n -S]\n",
  "THIMBLERIGGERS": "THIMBLERIGGER, one who thimblerigs [n]\n",
  "THIMBLERIGGING": "the act of thimblerigging [n -S]\n",
  "THIMBLERIGGINGS": "THIMBLERIGGING, the act of thimblerigging [n]\n",
  "THIMBLERIGS": "THIMBLERIG, to cheat by trickery [v]\n",
  "THIMBLES": "THIMBLE, to wear a cap on the finger when sewing [v]\n",
  "THIMBLESFUL": "THIMBLEFUL, the contents of a thimble [n]\n",
  "THIMBLEWEED": "any of various anemones with cylindrical seed heads [n -S]\n",
  "THIMBLEWEEDS": "THIMBLEWEED, any of various anemones with cylindrical seed heads [n]\n",
  "THIMBLEWIT": "a silly or dimwitted person; a dunce [n -S]\n",
  "THIMBLEWITS": "THIMBLEWIT, a silly or dimwitted person; a dunce [n]\n",
  "THIMBLEWITTED": "silly, dimwitted [adj]\n",
  "THIMBLING": "THIMBLE, to wear a cap on the finger when sewing [v]\n",
  "THIMEROSAL": "a cream-coloured crystalline water-soluble powder, used on the skin to treat minor abrasions [n -S]\n",
  "THIMEROSALS": "THIMEROSAL, a cream-coloured crystalline water-soluble powder, used on the skin to treat minor abrasions [n]\n",
  "THIN": "not fat [adj THINNER, THINNEST, THINLY] / to make thin [v THINNED, THINNING, THINS]\n",
  "THINCLAD": "a runner on a track team [n -S]\n",
  "THINCLADS": "THINCLAD, a runner on a track team [n]\n",
  "THINDOWN": "a lessening of the number of atomic particles in the air [n -S]\n",
  "THINDOWNS": "THINDOWN, a lessening of the number of atomic particles in the air [n]\n",
  "THINE": "a possessive form of the pronoun thou [pron]\n",
  "THING": "an inanimate object [n -S]\n",
  "THINGAMABOB": "a whatsit [n -S]\n",
  "THINGAMABOBS": "THINGAMABOB, a whatsit [n]\n",
  "THINGAMAJIG": "a whatsit [n -S]\n",
  "THINGAMAJIGS": "THINGAMAJIG, a whatsit [n]\n",
  "THINGAMIES": "THINGAMY, a term used for an object or person used when the correct name cannot come to mind [n]\n",
  "THINGAMY": "a term used for an object or person used when the correct name cannot come to mind [n THINGAMIES]\n",
  "THINGAMYBOB": "a whatsit, also THINGAMY, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n -S]\n",
  "THINGAMYBOBS": "THINGAMYBOB, a whatsit, also THINGAMY, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n]\n",
  "THINGAMYJIG": "a whatsit, also THINGAMY, THINGAMYBOB, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n -S]\n",
  "THINGAMYJIGS": "THINGAMYJIG, a whatsit, also THINGAMY, THINGAMYBOB, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n]\n",
  "THINGHOOD": "the state of being a thing [n -S]\n",
  "THINGHOODS": "THINGHOOD, the state of being a thing [n]\n",
  "THINGIER": "THINGY, real, actual [adj]\n",
  "THINGIES": "THINGY, a thing, a whatsit [n]\n",
  "THINGIEST": "THINGY, real, actual [adj]\n",
  "THINGINESS": "reality, objectivity, also THINGLINESS [n -ES]\n",
  "THINGINESSES": "THINGINESS, reality, objectivity, also THINGLINESS [n]\n",
  "THINGLINESS": "reality, objectivity, also THINGINESS [n -ES]\n",
  "THINGLINESSES": "THINGLINESS, reality, objectivity, also THINGINESS [n]\n",
  "THINGNESS": "the quality of being a thing [n -ES]\n",
  "THINGNESSES": "THINGNESS, the quality of being a thing [n]\n",
  "THINGO": "(Australian slang) an object whose name is unknown or temporarily forgotten [n -S]\n",
  "THINGOS": "THINGO, (Australian slang) an object whose name is unknown or temporarily forgotten [n]\n",
  "THINGS": "THING, an inanimate object [n]\n",
  "THINGUMABOB": "a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n -S]\n",
  "THINGUMABOBS": "THINGUMABOB, a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n]\n",
  "THINGUMAJIG": "a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n -S]\n",
  "THINGUMAJIGS": "THINGUMAJIG, a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMBOB, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n]\n",
  "THINGUMBOB": "a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n -S]\n",
  "THINGUMBOBS": "THINGUMBOB, a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMMY, THINGUMMYBOB, THINGUMMYJIG [n]\n",
  "THINGUMMIES": "THINGUMMY, a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMYBOB, THINGUMMYJIG [n]\n",
  "THINGUMMY": "a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMYBOB, THINGUMMYJIG [n THINGUMMIES]\n",
  "THINGUMMYBOB": "a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYJIG [n -S]\n",
  "THINGUMMYBOBS": "THINGUMMYBOB, a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYJIG [n]\n",
  "THINGUMMYJIG": "a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB [n -S]\n",
  "THINGUMMYJIGS": "THINGUMMYJIG, a whatsit, also THINGAMY, THINGAMYBOB, THINGAMYJIG, THINGUMABOB, THINGUMAJIG, THINGUMBOB, THINGUMMY, THINGUMMYBOB [n]\n",
  "THINGY": "real, actual [adj THINGIER, THINGIEST] / a thing, a whatsit [n THINGIES]\n",
  "THINK": "to formulate in the mind [v THOUGHT, THINKING, THINKS]\n",
  "THINKABLE": "capable of being thought [adj THINKABLY]\n",
  "THINKABLENESS": "the state of being thinkable [n -ES]\n",
  "THINKABLENESSES": "THINKABLENESS, the state of being thinkable [n]\n",
  "THINKABLY": "THINKABLE, capable of being thought [adv]\n",
  "THINKER": "one that thinks [n -S]\n",
  "THINKERS": "THINKER, one that thinks [n]\n",
  "THINKING": "an opinion of judgement [n -S]\n",
  "THINKINGLY": "THINKING [adv]\n",
  "THINKINGNESS": "the state of being thinking [n -ES]\n",
  "THINKINGNESSES": "THINKINGNESS, the state of being thinking [n]\n",
  "THINKINGS": "THINKING, an opinion of judgement [n]\n",
  "THINKPIECE": "a journalistic piece designed to provoke thought [n -S]\n",
  "THINKPIECES": "THINKPIECE, a journalistic piece designed to provoke thought [n]\n",
  "THINKS": "THINK, to formulate in the mind [v]\n",
  "THINLY": "THIN, not fat [adv]\n",
  "THINNED": "THIN, to make thin [v]\n",
  "THINNER": "a preparation used to thin e.g. paint [n -S]\n",
  "THINNERS": "THINNER, a preparation used to thin e.g. paint [n]\n",
  "THINNESS": "the state of being thin [n -ES]\n",
  "THINNESSES": "THINNESS, the state of being thin [n]\n",
  "THINNEST": "THIN, not fat [adj]\n",
  "THINNING": "the act of thinning [n -S]\n",
  "THINNINGS": "THINNING, the act of thinning [n]\n",
  "THINNISH": "somewhat thin [adj]\n",
  "THINS": "THIN, to make thin [v]\n",
  "THIO": "of compounds, containing sulphur [adj]\n",
  "THIOALCOHOL": "another name for a thiol [n -S]\n",
  "THIOALCOHOLS": "THIOALCOHOL, another name for a thiol [n]\n",
  "THIOBACILLI": "THIOBACILLUS, any of several rod-shaped bacteria that derive energy from the oxidation of sulphur or sulphur compounds [n]\n",
  "THIOBACILLUS": "any of several rod-shaped bacteria that derive energy from the oxidation of sulphur or sulphur compounds [n THIOBACILLI]\n",
  "THIOBARBITURATE": "a salt of thiobarbituric acid similar in effect to a barbiturate [n]\n",
  "THIOCARBAMIDE": "another name for thiourea [n -S]\n",
  "THIOCARBAMIDES": "THIOCARBAMIDE, another name for thiourea [n]\n",
  "THIOCYANATE": "a salt of thiocyanic acid [n -S]\n",
  "THIOCYANATES": "THIOCYANATE, a salt of thiocyanic acid [n]\n",
  "THIOCYANIC": "as in thiocyanic acid, the parent acid of thiocyanates [adj]\n",
  "THIODIGLYCOL": "a chemical compound soluble in e.g. water and alcohol used e.g. as an industrial cleaning agent [n -S]\n",
  "THIODIGLYCOLS": "THIODIGLYCOL, a chemical compound soluble in e.g. water and alcohol used e.g. as an industrial cleaning agent [n]\n",
  "THIOFURAN": "a five-membered heterocyclic compound with sulphur, aka thiophen [n -S]\n",
  "THIOFURANS": "THIOFURAN, a five-membered heterocyclic compound with sulphur, aka thiophen [n]\n",
  "THIOL": "a sulphur compound [n -S]\n",
  "THIOLIC": "relating to thiol, a chemical compound, mercaptan [adj]\n",
  "THIOLS": "THIOL, a sulphur compound [n]\n",
  "THIONATE": "a sulphur compound [n -S]\n",
  "THIONATES": "THIONATE, a sulphur compound [n]\n",
  "THIONIC": "pertaining to or containing sulphur, as in thionic acid [adj]\n",
  "THIONIN": "a violet dye, also THIONINE [n -S]\n",
  "THIONINE": "a violet dye, also THIONIN [n -S]\n",
  "THIONINES": "THIONINE, a violet dye, also THIONIN [n]\n",
  "THIONINS": "THIONIN, a violet dye, also THIONINE [n]\n",
  "THIONYL": "a compound containing the group -SO [n -S]\n",
  "THIONYLS": "THIONYL, a compound containing the group -SO [n]\n",
  "THIOPENTAL": "a truth drug, aka Pentothal [n -S]\n",
  "THIOPENTALS": "THIOPENTAL, a truth drug, aka Pentothal [n]\n",
  "THIOPENTONE": "an intravenous anaesthetic [n -S]\n",
  "THIOPENTONES": "THIOPENTONE, an intravenous anaesthetic [n]\n",
  "THIOPHEN": "a type of sulphur compound [n -S]\n",
  "THIOPHENE": "a five-membered heterocyclic compound with sulphur, also THIOPHEN [n -S]\n",
  "THIOPHENES": "THIOPHENE, a five-membered heterocyclic compound with sulphur, also THIOPHEN [n]\n",
  "THIOPHENS": "THIOPHEN, a type of sulphur compound [n]\n",
  "THIOPHIL": "of bacteria, having an affinity for sulphur [adj]\n",
  "THIORIDAZINE": "a phenothiazine tranquillizer used in the form of its hydrochloride for relief of anxiety states [n -S]\n",
  "THIORIDAZINES": "THIORIDAZINE, a phenothiazine tranquillizer used in the form of its hydrochloride for relief of anxiety states [n]\n",
  "THIOSINAMINE": "a white crystalline bitter-tasting compound with a slight garlic-like odour, occurring in mustard oil and used in organic synthesis [n -S]\n",
  "THIOSINAMINES": "THIOSINAMINE, a white crystalline bitter-tasting compound with a slight garlic-like odour, occurring in mustard oil and used in organic synthesis [n]\n",
  "THIOSULFATE": "any salt of thiosulphuric acid, also THIOSULPHATE [n -S]\n",
  "THIOSULFATES": "THIOSULFATE, any salt of thiosulphuric acid, also THIOSULPHATE [n]\n",
  "THIOSULFURIC": "as in thiosulfuric acid, an unstable acid known only in solutions and in the form of its salts [adj]\n",
  "THIOSULPHATE": "any salt of thiosulphuric acid, also THIOSULFATE [n -S]\n",
  "THIOSULPHATES": "THIOSULPHATE, any salt of thiosulphuric acid, also THIOSULFATE [n]\n",
  "THIOSULPHURIC": "as in thiosulphuric acid, sulphuric acid in which one atom of oxygen is replaced by sulphur [adj]\n",
  "THIOTEPA": "a sulfur compound, used as an antineoplastic [n -S]\n",
  "THIOTEPAS": "THIOTEPA, a sulfur compound, used as an antineoplastic [n]\n",
  "THIOURACIL": "a derivative of thiourea that interferes with the production of thyroid hormones [n -S]\n",
  "THIOURACILS": "THIOURACIL, a derivative of thiourea that interferes with the production of thyroid hormones [n]\n",
  "THIOUREA": "urea with its oxygen replaced by sulphur [n -S]\n",
  "THIOUREAS": "THIOUREA, urea with its oxygen replaced by sulphur [n]\n",
  "THIR": "(Scots) those [adj]\n",
  "THIRAM": "an insecticide [n -S]\n",
  "THIRAMS": "THIRAM, an insecticide [n]\n",
  "THIRD": "number three in sequence [adj THIRDLY] / to divide by three [v -ED, -ING, -S]\n",
  "THIRDBOROUGH": "(historical) an under-constable [n -S]\n",
  "THIRDBOROUGHS": "THIRDBOROUGH, (historical) an under-constable [n]\n",
  "THIRDED": "THIRD, to divide by three [v]\n",
  "THIRDHAND": "received at two removes [adj]\n",
  "THIRDING": "a third part [n -S]\n",
  "THIRDINGS": "THIRDING, a third part [n]\n",
  "THIRDLY": "THIRD, number three in sequence [adv]\n",
  "THIRDS": "THIRD, to divide by three [v]\n",
  "THIRDSMAN": "a mediator [n THIRDSMEN]\n",
  "THIRDSMEN": "THIRDSMAN, a mediator [n]\n",
  "THIRDSTREAM": "music combining jazz and classical elements [n -S]\n",
  "THIRDSTREAMS": "THIRDSTREAM, music combining jazz and classical elements [n]\n",
  "THIRL": "to vibrate, thrill, also DIRL, TIRL [v -ED, -ING, -S]\n",
  "THIRLAGE": "(Scots) an obligation for feudal tenants to grind grain at a certain mill [n -S]\n",
  "THIRLAGES": "THIRLAGE, (Scots) an obligation for feudal tenants to grind grain at a certain mill [n]\n",
  "THIRLED": "THIRL, to vibrate, thrill, also DIRL, TIRL [v]\n",
  "THIRLING": "THIRL, to vibrate, thrill, also DIRL, TIRL [v]\n",
  "THIRLS": "THIRL, to vibrate, thrill, also DIRL, TIRL [v]\n",
  "THIRST": "to have a need to drink [v -ED, -ING, -S]\n",
  "THIRSTED": "THIRST, to have a need to drink [v]\n",
  "THIRSTER": "one who thirsts [n -S]\n",
  "THIRSTERS": "THIRSTER, one who thirsts [n]\n",
  "THIRSTFUL": "thirsty [adj]\n",
  "THIRSTIER": "THIRSTY, feeling a need to drink, also THRISTY [adj]\n",
  "THIRSTIEST": "THIRSTY, feeling a need to drink, also THRISTY [adj]\n",
  "THIRSTILY": "THIRSTY, feeling a need to drink, also THRISTY [adv]\n",
  "THIRSTINESS": "the state of being thirsty [n -ES]\n",
  "THIRSTINESSES": "THIRSTINESS, the state of being thirsty [n]\n",
  "THIRSTING": "THIRST, to have a need to drink [v]\n",
  "THIRSTLESS": "without thirst [adj]\n",
  "THIRSTS": "THIRST, to have a need to drink [v]\n",
  "THIRSTY": "feeling a need to drink, also THRISTY [adj THIRSTIER, THIRSTIEST, THIRSTILY]\n",
  "THIRTEEN": "a number, three and ten [n -S]\n",
  "THIRTEENS": "THIRTEEN, a number, three and ten [n]\n",
  "THIRTEENTH": "number thirteen in sequence [adj THIRTEENTHLY] / a thirteenth part of [n -S]\n",
  "THIRTEENTHLY": "THIRTEENTH, number thirteen in sequence [adv]\n",
  "THIRTEENTHS": "THIRTEENTH, a thirteenth part of [n]\n",
  "THIRTIES": "THIRTY, a number [n]\n",
  "THIRTIETH": "the ordinal of thirty [adj] / one of thirty equal parts [n -S]\n",
  "THIRTIETHS": "THIRTIETH, one of thirty equal parts [n]\n",
  "THIRTY": "a number [n THIRTIES]\n",
  "THIRTYFOLD": "multiplied by thirty [adv] / thirty times over [adj]\n",
  "THIRTYISH": "about thirty (in age) [adj]\n",
  "THIRTYSOMETHING": "a little over thirty [adj]\n",
  "THIS": "the person or thing just mentioned [pron THESE]\n",
  "THISAWAY": "(colloquial) this way [adv]\n",
  "THISNESS": "the quality of being this [n -ES]\n",
  "THISNESSES": "THISNESS, the quality of being this [n]\n",
  "THISTLE": "a prickly composite plant with pink, white, yellow but usually purple flower-heads, also THRISSEL, THRISTLE [n -S]\n",
  "THISTLEDOWN": "the typically plumose pappus from the ripe flower head of a thistle [n -S]\n",
  "THISTLEDOWNS": "THISTLEDOWN, the typically plumose pappus from the ripe flower head of a thistle [n]\n",
  "THISTLES": "THISTLE, a prickly composite plant with pink, white, yellow but usually purple flower-heads, also THRISSEL, THRISTLE [n]\n",
  "THISTLIER": "THISTLY, full of thistles [adj]\n",
  "THISTLIEST": "THISTLY, full of thistles [adj]\n",
  "THISTLY": "full of thistles [adj THISTLIER, THISTLIEST]\n",
  "THITHER": "in that direction, also THETHER [adv]\n",
  "THITHERTO": "to that point; so far [adv]\n",
  "THITHERWARD": "in that direction, also THITHERWARDS [adv]\n",
  "THITHERWARDS": "in that direction, also THITHERWARD [adv]\n",
  "THIVEL": "a porridge-stick, also THIBLE [n -S]\n",
  "THIVELS": "THIVEL, a porridge-stick, also THIBLE [n]\n",
  "THIXOTROPE": "a thixotropic substance [n -S]\n",
  "THIXOTROPES": "THIXOTROPE, a thixotropic substance [n]\n",
  "THIXOTROPIC": "of or showing, thixotropy; (of paints) nondrip [adj]\n",
  "THIXOTROPIES": "THIXOTROPY, the property of certain gels of becoming fluid when agitated and of reverting back to a gel when left to stand [n]\n",
  "THIXOTROPY": "the property of certain gels of becoming fluid when agitated and of reverting back to a gel when left to stand [n THIXOTROPIES]\n",
  "THLIPSES": "THLIPSIS, (Greek) constriction, compression [n]\n",
  "THLIPSIS": "(Greek) constriction, compression [n THLIPSES]\n",
  "THO": "(Spenser) those [adj]\n",
  "THOFT": "a rowing-bench [n -S]\n",
  "THOFTS": "THOFT, a rowing-bench [n]\n",
  "THOLE": "to endure, bear [v THOLED, THOLING, THOLES]\n",
  "THOLED": "THOLE, to endure, bear [v]\n",
  "THOLEIITE": "a basaltic rock rich in aluminum [n -S]\n",
  "THOLEIITES": "THOLEIITE, a basaltic rock rich in aluminum [n]\n",
  "THOLEIITIC": "of or like tholeiite, a basaltic rock rich in aluminum [adj]\n",
  "THOLEPIN": "a pin that serves as an oarlock [n -S]\n",
  "THOLEPINS": "THOLEPIN, a pin that serves as an oarlock [n]\n",
  "THOLES": "THOLE, to endure, bear [v]\n",
  "THOLI": "THOLUS, (Greek) a round building, a cupola, also THOLOS [n]\n",
  "THOLING": "THOLE, to endure, bear [v]\n",
  "THOLOBATE": "the substructure of a dome or cupola [n -S]\n",
  "THOLOBATES": "THOLOBATE, the substructure of a dome or cupola [n]\n",
  "THOLOI": "THOLOS, (Greek) a circular, underground tomb [n]\n",
  "THOLOS": "(Greek) a circular, underground tomb [n THOLOI]\n",
  "THOLUS": "(Greek) a round building, a cupola, also THOLOS [n THOLI]\n",
  "THON": "(Scots) yon [adj]\n",
  "THONDER": "(Scots) yonder [adj]\n",
  "THONG": "to flog with a whip [v -ED, -ING, -S]\n",
  "THONGED": "THONG, to flog with a whip [v]\n",
  "THONGIER": "THONGY, resembling an item of clothing made from a strip of cloth [adj]\n",
  "THONGIEST": "THONGY, resembling an item of clothing made from a strip of cloth [adj]\n",
  "THONGING": "THONG, to flog with a whip [v]\n",
  "THONGS": "THONG, to flog with a whip [v]\n",
  "THONGY": "resembling an item of clothing made from a strip of cloth [adj THONGIER, THONGIEST]\n",
  "THORACAL": "relating to a thorax [adj]\n",
  "THORACENTESES": "THORACENTESIS, surgery performed to draw off fluid from the pleural cavity, also THORACOCENTESIS [n]\n",
  "THORACENTESIS": "surgery performed to draw off fluid from the pleural cavity, also THORACOCENTESIS [n THORACENTESES]\n",
  "THORACES": "THORAX, (Greek) the part of the body between the neck and the abdomen [n]\n",
  "THORACIC": "of or pertaining to the thorax, or chest, also THORACAL [adj THORACICALLY]\n",
  "THORACICALLY": "THORACIC, of or pertaining to the thorax, or chest, also THORACAL [adv]\n",
  "THORACOCENTESES": "THORACOCENTESIS, surgery performed to draw off fluid from the pleural cavity, usually using a hollow needle inserted through the wall of the chest, also THORACENTESIS [n]\n",
  "THORACOCENTESIS": "surgery performed to draw off fluid from the pleural cavity, usually using a hollow needle inserted through the wall of the chest, also THORACENTESIS [n THORACOCENTESES]\n",
  "THORACOPLASTIES": "THORACOPLASTY, surgery to collapse a diseased lung by removing selected portions of the ribs [n]\n",
  "THORACOPLASTY": "surgery to collapse a diseased lung by removing selected portions of the ribs [n THORACOPLASTIES]\n",
  "THORACOSCOPE": "an instrument for viewing the thorax and chest wall [n -S]\n",
  "THORACOSCOPES": "THORACOSCOPE, an instrument for viewing the thorax and chest wall [n]\n",
  "THORACOSTOMIES": "THORACOSTOMY, the construction of an artificial opening in the chest, usually to draw off fluid or release a buildup of air [n]\n",
  "THORACOSTOMY": "the construction of an artificial opening in the chest, usually to draw off fluid or release a buildup of air [n THORACOSTOMIES]\n",
  "THORACOTOMIES": "THORACOTOMY, surgical incision of the chest wall [n]\n",
  "THORACOTOMY": "surgical incision of the chest wall [n THORACOTOMIES]\n",
  "THORAX": "(Greek) the part of the body between the neck and the abdomen [n THORAXES or THORACES]\n",
  "THORAXES": "THORAX, (Greek) the part of the body between the neck and the abdomen [n]\n",
  "THORIA": "an oxide of thorium [n -S]\n",
  "THORIANITE": "a strongly radioactive mineral that is an oxide of thorium [n -S]\n",
  "THORIANITES": "THORIANITE, a strongly radioactive mineral that is an oxide of thorium [n]\n",
  "THORIAS": "THORIA, an oxide of thorium [n]\n",
  "THORIC": "of or pertaining to thorium [adj]\n",
  "THORITE": "a silicate of thorium [n -S]\n",
  "THORITES": "THORITE, a silicate of thorium [n]\n",
  "THORIUM": "a radioactive metallic element [n -S]\n",
  "THORIUMS": "THORIUM, a radioactive metallic element [n]\n",
  "THORN": "to prick with a sharp projection on a plant [v -ED, -ING, -S]\n",
  "THORNBACK": "a kind of skate having thornlike spines on its back, aka roker [n -S]\n",
  "THORNBACKS": "THORNBACK, a kind of skate having thornlike spines on its back, aka roker [n]\n",
  "THORNBILL": "any one of several species of small, brilliantly colored American birds, which have a long, slender, sharp bill [n -S]\n",
  "THORNBILLS": "THORNBILL, any one of several species of small, brilliantly colored American birds, which have a long, slender, sharp bill [n]\n",
  "THORNBIRD": "any of several tropical birds of the genus Phacellodomus that construct large globe-shaped nests [n -S]\n",
  "THORNBIRDS": "THORNBIRD, any of several tropical birds of the genus Phacellodomus that construct large globe-shaped nests [n]\n",
  "THORNBUSH": "a bush bearing thorns [n -ES]\n",
  "THORNBUSHES": "THORNBUSH, a bush bearing thorns [n]\n",
  "THORNED": "THORN, to prick with a sharp projection on a plant [v]\n",
  "THORNHEDGE": "a hedge of hawthorn [n -S]\n",
  "THORNHEDGES": "THORNHEDGE, a hedge of hawthorn [n]\n",
  "THORNIER": "THORNY, full of thorns [adj]\n",
  "THORNIEST": "THORNY, full of thorns [adj]\n",
  "THORNILY": "THORNY, full of thorns [adv]\n",
  "THORNINESS": "the state of being thorny [n -ES]\n",
  "THORNINESSES": "THORNINESS, the state of being thorny [n]\n",
  "THORNING": "THORN, to prick with a sharp projection on a plant [v]\n",
  "THORNLESS": "without thorns [adj]\n",
  "THORNLIKE": "like a thorn [adj]\n",
  "THORNPROOF": "proof against thorns [adj]\n",
  "THORNPROOFS": "garments that resist penetration by thorns [n]\n",
  "THORNS": "THORN, to prick with a sharp projection on a plant [v]\n",
  "THORNSET": "beset with thorns [adj]\n",
  "THORNTAIL": "a tropical American hummingbird with bright green plumage [n -S]\n",
  "THORNTAILS": "THORNTAIL, a tropical American hummingbird with bright green plumage [n]\n",
  "THORNTREE": "any tree bearing thorns [n -S]\n",
  "THORNTREES": "THORNTREE, any tree bearing thorns [n]\n",
  "THORNY": "full of thorns [adj THORNIER, THORNIEST, THORNILY]\n",
  "THORO": "thorough [adj]\n",
  "THORON": "the radioactive isotope of radon given off by the decomposition of thorium [n -S]\n",
  "THORONS": "THORON, the radioactive isotope of radon given off by the decomposition of thorium [n]\n",
  "THOROUGH": "complete, also THORO [adj THOROUGHER, THOROUGHEST, THOROUGHLY] / a manmade channel; a drainage ditch [n -S]\n",
  "THOROUGHBASS": "esp. in baroque music, a bass part underlying a piece [n -ES]\n",
  "THOROUGHBASSES": "THOROUGHBASS, esp. in baroque music, a bass part underlying a piece [n]\n",
  "THOROUGHBRACE": "any of several leather straps supporting the body of a carriage and serving as springs [n -S]\n",
  "THOROUGHBRACED": "fitted with a thoroughbrace [adj]\n",
  "THOROUGHBRACES": "THOROUGHBRACE, any of several leather straps supporting the body of a carriage and serving as springs [n]\n",
  "THOROUGHBRED": "bred from a dam and sire of the best blood [adj] / a horse so bred [n -S]\n",
  "THOROUGHBREDS": "THOROUGHBRED, a horse so bred [n]\n",
  "THOROUGHER": "THOROUGH, complete, also THORO [adj]\n",
  "THOROUGHEST": "THOROUGH, complete, also THORO [adj]\n",
  "THOROUGHFARE": "a through road [n -S]\n",
  "THOROUGHFARES": "THOROUGHFARE, a through road [n]\n",
  "THOROUGHGOING": "marked by thoroughness or zeal [adj THOROUGHGOINGLY]\n",
  "THOROUGHGOINGLY": "THOROUGHGOING, marked by thoroughness or zeal [adv]\n",
  "THOROUGHLY": "THOROUGH, complete, also THORO [adv]\n",
  "THOROUGHNESS": "the state of being thorough [n -ES]\n",
  "THOROUGHNESSES": "THOROUGHNESS, the state of being thorough [n]\n",
  "THOROUGHPACED": "of a horse, showing performing ability in all paces [adj]\n",
  "THOROUGHPIN": "a swelling of horses' hocks [n -S]\n",
  "THOROUGHPINS": "THOROUGHPIN, a swelling of horses' hocks [n]\n",
  "THOROUGHS": "THOROUGH, a manmade channel; a drainage ditch [n]\n",
  "THOROUGHWAX": "the plant hare's-ear, from the stem seeming to 'wax' (i.e. grow) through the leaves [n -ES]\n",
  "THOROUGHWAXES": "THOROUGHWAX, the plant hare's-ear, from the stem seeming to 'wax' (i.e. grow) through the leaves [n]\n",
  "THOROUGHWORT": "a wild flower with perfoliate leaves [n -S]\n",
  "THOROUGHWORTS": "THOROUGHWORT, a wild flower with perfoliate leaves [n]\n",
  "THORP": "(archaic) a group of houses in the country, a small village, also THORPE [n -S]\n",
  "THORPE": "(archaic) a group of houses in the country, a small village, also THORP [n -S]\n",
  "THORPES": "THORPE, (archaic) a group of houses in the country, a small village, also THORP [n]\n",
  "THORPS": "THORP, (archaic) a group of houses in the country, a small village, also THORPE [n]\n",
  "THOSE": "THAT, the one indicated [pron]\n",
  "THOTHER": "(Spenser) the other [adj]\n",
  "THOU": "to address as thou [v -ED, -ING, -S]\n",
  "THOUED": "THOU, to address as thou [v]\n",
  "THOUGH": "despite the fact that [conj]\n",
  "THOUGHT": "a product of thinking [n -S]\n",
  "THOUGHTCAST": "a mode of thought [n -S]\n",
  "THOUGHTCASTS": "THOUGHTCAST, a mode of thought [n]\n",
  "THOUGHTED": "having thoughts [adj]\n",
  "THOUGHTEN": "(Shakespeare) firm in belief, assured [adj]\n",
  "THOUGHTFUL": "absorbed in thought [adj THOUGHTFULLY]\n",
  "THOUGHTFULLY": "THOUGHTFUL, absorbed in thought [adv]\n",
  "THOUGHTFULNESS": "the state of being thoughtful [n]\n",
  "THOUGHTLESS": "insufficiently alert [adj THOUGHTLESSLY]\n",
  "THOUGHTLESSLY": "THOUGHTLESS, insufficiently alert [adv]\n",
  "THOUGHTLESSNESS": "the state of being thoughtless [n]\n",
  "THOUGHTS": "THOUGHT, a product of thinking [n]\n",
  "THOUGHTWAY": "a way of thinking that is characteristic of a particular group or culture [n -S]\n",
  "THOUGHTWAYS": "THOUGHTWAY, a way of thinking that is characteristic of a particular group or culture [n]\n",
  "THOUING": "THOU, to address as thou [v]\n",
  "THOUS": "THOU, to address as thou [v]\n",
  "THOUSAND": "a number, ten hundreds [n -S]\n",
  "THOUSANDFOLD": "multiplied by a thousand [adj] / a thousand times as much [n -S]\n",
  "THOUSANDFOLDS": "THOUSANDFOLD, a thousand times as much [n]\n",
  "THOUSANDS": "THOUSAND, a number, ten hundreds [n]\n",
  "THOUSANDTH": "one part in a thousand [n -S]\n",
  "THOUSANDTHS": "THOUSANDTH, one part in a thousand [n]\n",
  "THOWEL": "an oar pin, also THOWL [n -S]\n",
  "THOWELS": "THOWEL, an oar pin, also THOWL [n]\n",
  "THOWL": "an oar pin, also THOWEL [n -S]\n",
  "THOWLESS": "(Scots) pithless, listless, also THEWLESS [adj]\n",
  "THOWLS": "THOWL, an oar pin, also THOWEL [n]\n",
  "THRAE": "(Scots) from, also FRAE [prep]\n",
  "THRAIPING": "(dialect) a thrashing [n -S]\n",
  "THRAIPINGS": "THRAIPING, (dialect) a thrashing [n]\n",
  "THRALDOM": "servitude, also THRALLDOM [n -S]\n",
  "THRALDOMS": "THRALDOM, servitude, also THRALLDOM [n]\n",
  "THRALL": "to enslave [v -ED, -ING, -S]\n",
  "THRALLDOM": "servitude, also THRALDOM [n -S]\n",
  "THRALLDOMS": "THRALLDOM, servitude, also THRALDOM [n]\n",
  "THRALLED": "THRALL, to enslave [v]\n",
  "THRALLING": "THRALL, to enslave [v]\n",
  "THRALLS": "THRALL, to enslave [v]\n",
  "THRANG": "(Scots) to throng [v -ED, -ING, -S]\n",
  "THRANGED": "THRANG, (Scots) to throng [v]\n",
  "THRANGING": "THRANG, (Scots) to throng [v]\n",
  "THRANGS": "THRANG, (Scots) to throng [v]\n",
  "THRAPPLE": "(Scots) to throttle, strangle, also THROPPLE [v THRAPPLED, THRAPPLING, THRAPPLES]\n",
  "THRAPPLED": "THRAPPLE, (Scots) to throttle, strangle, also THROPPLE [v]\n",
  "THRAPPLES": "THRAPPLE, (Scots) to throttle, strangle, also THROPPLE [v]\n",
  "THRAPPLING": "THRAPPLE, (Scots) to throttle, strangle, also THROPPLE [v]\n",
  "THRASH": "to beat [v -ED, -ING, -ES]\n",
  "THRASHED": "THRASH, to beat [v]\n",
  "THRASHER": "any of several American birds of the mockingbird family, also THRESHER [n -S]\n",
  "THRASHERS": "THRASHER, any of several American birds of the mockingbird family, also THRESHER [n]\n",
  "THRASHES": "THRASH, to beat [v]\n",
  "THRASHIER": "THRASHY, characteristic of a style of fast, loud, punk rock music [adj]\n",
  "THRASHIEST": "THRASHY, characteristic of a style of fast, loud, punk rock music [adj]\n",
  "THRASHING": "a beating [n -S]\n",
  "THRASHINGS": "THRASHING, a beating [n]\n",
  "THRASHY": "characteristic of a style of fast, loud, punk rock music [adj THRASHIER, THRASHIEST]\n",
  "THRASONIC": "given to or marked by boasting and bragging, also THRASONICAL [adj THRASONICALLY]\n",
  "THRASONICAL": "given to or marked by boasting and bragging, also THRASONIC [adj THRASONICALLY]\n",
  "THRASONICALLY": "THRASONICAL, given to or marked by boasting and bragging, also THRASONIC [adv]\n",
  "THRAVE": "(Scots) a collective noun for a number of sheaves of corn, two stooks of twelves sheaves each, also THREAVE [n -S]\n",
  "THRAVES": "THRAVE, (Scots) a collective noun for a number of sheaves of corn, two stooks of twelves sheaves each, also THREAVE [n]\n",
  "THRAW": "(Scots) to turn, twist [v -ED, -ING, -S]\n",
  "THRAWARD": "(Scots) froward, obstinate, also THRAWART [adj]\n",
  "THRAWART": "(Scots) froward, obstinate, also THRAWARD [adj]\n",
  "THRAWED": "THRAW, (Scots) to turn, twist [v]\n",
  "THRAWING": "THRAW, (Scots) to turn, twist [v]\n",
  "THRAWN": "(Scots) obstinate; twisted, wry [adj THRAWNLY]\n",
  "THRAWNLY": "THRAWN, (Scots) obstinate; twisted, wry [adv]\n",
  "THRAWS": "THRAW, (Scots) to turn, twist [v]\n",
  "THREAD": "to pass cotton through [v -ED, -ING, -S]\n",
  "THREADBARE": "having the nap worn off so that the thread shows [adj THREADBARER, THREADBAREST]\n",
  "THREADBARENESS": "the state of being threadbare [n]\n",
  "THREADBARER": "THREADBARE, having the nap worn off so that the thread shows [adj]\n",
  "THREADBAREST": "THREADBARE, having the nap worn off so that the thread shows [adj]\n",
  "THREADED": "THREAD, to pass cotton through [v]\n",
  "THREADEN": "(Shakespeare) made of thread [adj]\n",
  "THREADER": "a person who or thing which threads something [n -S]\n",
  "THREADERS": "THREADER, a person who or thing which threads something [n]\n",
  "THREADFIN": "any small, spiny-finned tropical fish of the family Polynemidae, with five threads on its pectoral fins [n -S]\n",
  "THREADFINS": "THREADFIN, any small, spiny-finned tropical fish of the family Polynemidae, with five threads on its pectoral fins [n]\n",
  "THREADIER": "THREADY, resembling a thread [adj]\n",
  "THREADIEST": "THREADY, resembling a thread [adj]\n",
  "THREADINESS": "the state of being thready [n -ES]\n",
  "THREADINESSES": "THREADINESS, the state of being thready [n]\n",
  "THREADING": "THREAD, to pass cotton through [v]\n",
  "THREADLESS": "without a thread [adj]\n",
  "THREADLIKE": "like thread [adj]\n",
  "THREADMAKER": "one who makes thread [n -S]\n",
  "THREADMAKERS": "THREADMAKER, one who makes thread [n]\n",
  "THREADS": "THREAD, to pass cotton through [v]\n",
  "THREADWORM": "any long, slender nematode worm, esp. the pinworm and filaria [n -S]\n",
  "THREADWORMS": "THREADWORM, any long, slender nematode worm, esp. the pinworm and filaria [n]\n",
  "THREADY": "resembling a thread [adj THREADIER, THREADIEST]\n",
  "THREAP": "(Scots) to dispute, also THREEP [v THREAPED, THREAPIT, THREAPING, THREAPS]\n",
  "THREAPED": "THREAP, (Scots) to dispute, also THREEP [v]\n",
  "THREAPER": "one who threaps, also THREEPER [n -S]\n",
  "THREAPERS": "THREAPER, one who threaps, also THREEPER [n]\n",
  "THREAPING": "THREAP, (Scots) to dispute, also THREEP [v]\n",
  "THREAPIT": "THREAP, (Scots) to dispute, also THREEP [v]\n",
  "THREAPS": "THREAP, (Scots) to dispute, also THREEP [v]\n",
  "THREAT": "to intimidate, also THREATEN [v -ED, -ING, -S]\n",
  "THREATED": "THREAT, to intimidate, also THREATEN [v]\n",
  "THREATEN": "to intimidate, also THREAT [v -ED, -ING, -S]\n",
  "THREATENED": "THREATEN, to intimidate, also THREAT [v]\n",
  "THREATENER": "one who threatens [n -S]\n",
  "THREATENERS": "THREATENER, one who threatens [n]\n",
  "THREATENING": "ominous [adj THREATENINGLY] / the act of threatening [n -S]\n",
  "THREATENINGLY": "THREATENING, ominous [adv]\n",
  "THREATENINGS": "THREATENING, the act of threatening [n]\n",
  "THREATENS": "THREATEN, to intimidate, also THREAT [v]\n",
  "THREATFUL": "full of threats; having a menacing appearance [adj]\n",
  "THREATING": "THREAT, to intimidate, also THREATEN [v]\n",
  "THREATS": "THREAT, to intimidate, also THREATEN [v]\n",
  "THREAVE": "(Scots) a collective noun for a number of sheaves of corn, two stooks of twelves sheaves each, also THRAVE [n -S]\n",
  "THREAVES": "THREAVE, (Scots) a collective noun for a number of sheaves of corn, two stooks of twelves sheaves each, also THRAVE [n]\n",
  "THREE": "a number, three ones [n -S]\n",
  "THREEFOLD": "multiplied by three [adj]\n",
  "THREEFOLDNESS": "the state of being threefold [n -ES]\n",
  "THREEFOLDNESSES": "THREEFOLDNESS, the state of being threefold [n]\n",
  "THREENESS": "the quality of being three [n -ES]\n",
  "THREENESSES": "THREENESS, the quality of being three [n]\n",
  "THREEP": "(Scots) to dispute, also THREAP [v THREEPED, THREEPIT, THREEPING, THREEPS]\n",
  "THREEPEAT": "to win a sporting trophy on three consecutive occasions [v -ED, -ING, -S]\n",
  "THREEPEATED": "THREEPEAT, to win a sporting trophy on three consecutive occasions [v]\n",
  "THREEPEATING": "THREEPEAT, to win a sporting trophy on three consecutive occasions [v]\n",
  "THREEPEATS": "THREEPEAT, to win a sporting trophy on three consecutive occasions [v]\n",
  "THREEPED": "THREEP, (Scots) to dispute, also THREAP [v]\n",
  "THREEPENCE": "a coin worth three pence, also THREEPENNY, THRUPPENCE, THRUPPENNY [n -S]\n",
  "THREEPENCES": "THREEPENCE, a coin worth three pence, also THREEPENNY, THRUPPENCE, THRUPPENNY [n]\n",
  "THREEPENCEWORTH": "goods to the value of threepence, also THREEPENNYWORTH [n]\n",
  "THREEPENNIES": "THREEPENNY, a coin worth three pennies, also THREEPENCE, THRUPPENCE, THRUPPENNY [n]\n",
  "THREEPENNY": "a coin worth three pennies, also THREEPENCE, THRUPPENCE, THRUPPENNY [n THREEPENNIES]\n",
  "THREEPENNYWORTH": "goods to the value of threepence, also THREEPENCEWORTH [n]\n",
  "THREEPER": "one who threeps, also THREAPER [n -S]\n",
  "THREEPERS": "THREEPER, one who threeps, also THREAPER [n]\n",
  "THREEPING": "THREEP, (Scots) to dispute, also THREAP [v]\n",
  "THREEPIT": "THREEP, (Scots) to dispute, also THREAP [v]\n",
  "THREEPS": "THREEP, (Scots) to dispute, also THREAP [v]\n",
  "THREEQUEL": "a film, play, book etc. that is a sequel to a first sequel [n -S]\n",
  "THREEQUELS": "THREEQUEL, a film, play, book etc. that is a sequel to a first sequel [n]\n",
  "THREES": "THREE, a number, three ones [n]\n",
  "THREESCORE": "three times twenty [n -S]\n",
  "THREESCORES": "THREESCORE, three times twenty [n]\n",
  "THREESOME": "a set of three [n -S]\n",
  "THREESOMES": "THREESOME, a set of three [n]\n",
  "THREMMATOLOGIES": "THREMMATOLOGY, the science of breeding domestic animals and plants [n]\n",
  "THREMMATOLOGY": "the science of breeding domestic animals and plants [n THREMMATOLOGIES]\n",
  "THRENE": "(Shakespeare) an ode for the dead, also THRENOS [n -S]\n",
  "THRENES": "THRENE, (Shakespeare) an ode for the dead, also THRENOS [n]\n",
  "THRENETIC": "of or like a threnody, an ode of lamentation, also THRENETICAL, THRENODIAL, THRENODIC [adj]\n",
  "THRENETICAL": "of or like a threnody, an ode of lamentation, also THRENETIC, THRENODIAL, THRENODIC [adj]\n",
  "THRENODE": "(Greek) a song of lamentation, also THRENODY [n -S]\n",
  "THRENODES": "THRENODE, (Greek) a song of lamentation, also THRENODY [n]\n",
  "THRENODIAL": "of or like a threnody, a song of lamentation for the dead, also THRENETIC, THRENETICAL, THRENODIC [adj]\n",
  "THRENODIC": "like a threnody, mournful, also THRENETIC, THRENETICAL, THRENODIAL [adj]\n",
  "THRENODIES": "THRENODY, (Greek) a song of lamentation, also THRENODE [n]\n",
  "THRENODIST": "one who composes, delivers, or utters, a threnode, or threnody [n -S]\n",
  "THRENODISTS": "THRENODIST, one who composes, delivers, or utters, a threnode, or threnody [n]\n",
  "THRENODY": "(Greek) a song of lamentation, also THRENODE [n THRENODIES]\n",
  "THRENOS": "(Shakespeare) an ode for the dead, also THRENE [n -ES]\n",
  "THRENOSES": "THRENOS, (Shakespeare) an ode for the dead, also THRENE [n]\n",
  "THREONINE": "an essential amino acid [n -S]\n",
  "THREONINES": "THREONINE, an essential amino acid [n]\n",
  "THRESH": "to separate grain or seeds [v -ED, -ING, -ES]\n",
  "THRESHED": "THRESH, to separate grain or seeds [v]\n",
  "THRESHEL": "a flail [n -S]\n",
  "THRESHELS": "THRESHEL, a flail [n]\n",
  "THRESHER": "any of several American birds of the mockingbird family, also THRASHER [n -S]\n",
  "THRESHERS": "THRESHER, any of several American birds of the mockingbird family, also THRASHER [n]\n",
  "THRESHES": "THRESH, to separate grain or seeds [v]\n",
  "THRESHING": "the act of threshing [n -S]\n",
  "THRESHINGS": "THRESHING, the act of threshing [n]\n",
  "THRESHOLD": "the sill of a house door; the place or point of entering [n -S]\n",
  "THRESHOLDS": "THRESHOLD, the sill of a house door; the place or point of entering [n]\n",
  "THRETTIES": "THRETTY, (dialect) thirty [n]\n",
  "THRETTY": "(dialect) thirty [n THRETTIES]\n",
  "THREW": "THROW, to fling in the air [v]\n",
  "THRICE": "three times [adv]\n",
  "THRID": "(Spenser) to thread [v THRIDDED, THRIDDING, THRIDS]\n",
  "THRIDACE": "lettuce juice [n -S]\n",
  "THRIDACES": "THRIDACE, lettuce juice [n]\n",
  "THRIDDED": "THRID, (Spenser) to thread [v]\n",
  "THRIDDING": "THRID, (Spenser) to thread [v]\n",
  "THRIDS": "THRID, (Spenser) to thread [v]\n",
  "THRIFT": "frugality or economy [n -S]\n",
  "THRIFTIER": "THRIFTY, frugal [adj]\n",
  "THRIFTIEST": "THRIFTY, frugal [adj]\n",
  "THRIFTILY": "THRIFTY, frugal [adv]\n",
  "THRIFTINESS": "the state of being thrifty [n -ES]\n",
  "THRIFTINESSES": "THRIFTINESS, the state of being thrifty [n]\n",
  "THRIFTLESS": "lacking usefulness or worth [adj THRIFTLESSLY]\n",
  "THRIFTLESSLY": "THRIFTLESS, lacking usefulness or worth [adv]\n",
  "THRIFTLESSNESS": "THRIFTLESS, lacking usefulness or worth [n]\n",
  "THRIFTS": "THRIFT, frugality or economy [n]\n",
  "THRIFTY": "frugal [adj THRIFTIER, THRIFTIEST, THRIFTILY]\n",
  "THRILL": "to excite greatly [v -ED, -ING, -S]\n",
  "THRILLANT": "(Spenser) piercing [adj]\n",
  "THRILLED": "THRILL, to excite greatly [v]\n",
  "THRILLER": "one that thrills [n -S]\n",
  "THRILLERS": "THRILLER, one that thrills [n]\n",
  "THRILLIER": "THRILLY, full of thrills [adj]\n",
  "THRILLIEST": "THRILLY, full of thrills [adj]\n",
  "THRILLING": "THRILL, to excite greatly [v]\n",
  "THRILLINGLY": "THRILLING, THRILL, to excite greatly [adv]\n",
  "THRILLINGNESS": "the state of being thrilling [n -ES]\n",
  "THRILLINGNESSES": "THRILLINGNESS, the state of being thrilling [n]\n",
  "THRILLS": "THRILL, to excite greatly [v]\n",
  "THRILLY": "full of thrills [adj THRILLIER, THRILLIEST]\n",
  "THRIMSA": "(Old English) an Anglo-Saxon gold coin, also THRYMSA [n -S]\n",
  "THRIMSAS": "THRIMSA, (Old English) an Anglo-Saxon gold coin, also THRYMSA [n]\n",
  "THRIP": "in pre-decimal coinage, a threepenny bit [n -S]\n",
  "THRIPS": "(Greek) any insect of the order Thysanoptera, esp. a minute black insect of the genus Thrips [n -ES]\n",
  "THRIPSES": "THRIPS, (Greek) any insect of the order Thysanoptera, esp. a minute black insect of the genus Thrips [n]\n",
  "THRISSEL": "(Scots) a thistle, also THRISTLE [n -S]\n",
  "THRISSELS": "THRISSEL, (Scots) a thistle, also THRISTLE [n]\n",
  "THRIST": "(Spenser) to thirst [v -ED, -ING, -S]\n",
  "THRISTED": "THRIST, (Spenser) to thirst [v]\n",
  "THRISTING": "THRIST, (Spenser) to thirst [v]\n",
  "THRISTLE": "(Scots) thistle, also THRISSEL [n -S]\n",
  "THRISTLES": "THRISTLE, (Scots) thistle, also THRISSEL [n]\n",
  "THRISTS": "THRIST, (Spenser) to thirst [v]\n",
  "THRISTY": "(Spenser) thirsty [adj]\n",
  "THRIVE": "to grow vigorously [v THROVE or THRIVED, THRIVEN, THRIVING, THRIVES]\n",
  "THRIVED": "THRIVE, to grow vigorously [v]\n",
  "THRIVELESS": "not thriving or prospering [adj]\n",
  "THRIVEN": "THRIVE, to grow vigorously [v]\n",
  "THRIVER": "one who thrives [n -S]\n",
  "THRIVERS": "THRIVER, one who thrives [n]\n",
  "THRIVES": "THRIVE, to grow vigorously [v]\n",
  "THRIVING": "flourishing [adj THRIVINGLY] / the act of thriving [n -S]\n",
  "THRIVINGLY": "THRIVING, flourishing [adv]\n",
  "THRIVINGNESS": "the state of being thriving [n -ES]\n",
  "THRIVINGNESSES": "THRIVINGNESS, the state of being thriving [n]\n",
  "THRIVINGS": "THRIVING, the act of thriving [n]\n",
  "THRO": "(archaic) through [prep]\n",
  "THROAT": "to utter in a hoarse voice [v -ED, -ING, -S]\n",
  "THROATED": "THROAT, to utter in a hoarse voice [v]\n",
  "THROATIER": "THROATY, of a voice, vocal sound, etc., produced or modified in the throat, guttural [adj]\n",
  "THROATIEST": "THROATY, of a voice, vocal sound, etc., produced or modified in the throat, guttural [adj]\n",
  "THROATILY": "THROATY, of a voice, vocal sound, etc., produced or modified in the throat, guttural [adv]\n",
  "THROATINESS": "the state of being throaty [n -ES]\n",
  "THROATINESSES": "THROATINESS, the state of being throaty [n]\n",
  "THROATING": "THROAT, to utter in a hoarse voice [v]\n",
  "THROATLASH": "a strap used to fasten a horse's bridle, also THROATLATCH [n -ES]\n",
  "THROATLASHES": "THROATLASH, a strap used to fasten a horse's bridle, also THROATLATCH [n]\n",
  "THROATLATCH": "a strap used to fasten a horse's bridle, also THROATLASH [n -ES]\n",
  "THROATLATCHES": "THROATLATCH, a strap used to fasten a horse's bridle, also THROATLASH [n]\n",
  "THROATS": "THROAT, to utter in a hoarse voice [v]\n",
  "THROATWORT": "a plant formerly considered a remedy for sore throats because of its throat-shaped corolla [n -S]\n",
  "THROATWORTS": "THROATWORT, a plant formerly considered a remedy for sore throats because of its throat-shaped corolla [n]\n",
  "THROATY": "of a voice, vocal sound, etc., produced or modified in the throat, guttural [adj THROATIER, THROATIEST, THROATILY]\n",
  "THROB": "to pulsate [v THROBBED, THROBBING, THROBS]\n",
  "THROBBED": "THROB, to pulsate [v]\n",
  "THROBBER": "one who throbs [n -S]\n",
  "THROBBERS": "THROBBER, one who throbs [n]\n",
  "THROBBING": "pulsating [adj THROBBINGLY] / the act of throbbing [n -S]\n",
  "THROBBINGLY": "THROBBING, pulsating [adv]\n",
  "THROBBINGS": "THROBBING, the act of throbbing [n]\n",
  "THROBLESS": "without a throb [adj]\n",
  "THROBS": "THROB, to pulsate [v]\n",
  "THROE": "to suffer violent spasms of pain [v THROED, THROEING, THROES]\n",
  "THROED": "THROE, to suffer violent spasms of pain [v]\n",
  "THROEING": "THROE, to suffer violent spasms of pain [v]\n",
  "THROES": "THROE, to suffer violent spasms of pain [v]\n",
  "THROMBI": "THROMBUS, (Greek) a clot occluding a blood vessel [n]\n",
  "THROMBIN": "an enzyme that causes the blood to clot [n -S]\n",
  "THROMBINS": "THROMBIN, an enzyme that causes the blood to clot [n]\n",
  "THROMBOCYTE": "a platelet [n -S]\n",
  "THROMBOCYTES": "THROMBOCYTE, a platelet [n]\n",
  "THROMBOCYTIC": "relating to a thrombocyte [adj]\n",
  "THROMBOEMBOLIC": "relating to thromboembolism [adj]\n",
  "THROMBOEMBOLISM": "the blocking of a blood vessel by a particle that has broken away from a blood clot at its site of formation [n]\n",
  "THROMBOGEN": "a protein present in blood that is essential for the formation of thrombin [n -S]\n",
  "THROMBOGENS": "THROMBOGEN, a protein present in blood that is essential for the formation of thrombin [n]\n",
  "THROMBOKINASE": "an enzyme active in the clotting of blood, aka thromboplastin [n -S]\n",
  "THROMBOKINASES": "THROMBOKINASE, an enzyme active in the clotting of blood, aka thromboplastin [n]\n",
  "THROMBOLYSES": "THROMBOLYSIS, the breaking up of a blood clot [n]\n",
  "THROMBOLYSIS": "the breaking up of a blood clot [n THROMBOLYSES]\n",
  "THROMBOLYTIC": "dissolving clots [adj] / a thrombolytic drug [n -S]\n",
  "THROMBOLYTICS": "THROMBOLYTIC, a thrombolytic drug [n]\n",
  "THROMBOPHILIA": "combined inflammation and thrombosis of a vein [n -S]\n",
  "THROMBOPHILIAS": "THROMBOPHILIA, combined inflammation and thrombosis of a vein [n]\n",
  "THROMBOPLASTIC": "initiating or accelerating the clotting of blood [adj]\n",
  "THROMBOPLASTIN": "a complex enzyme found esp. in platelets that functions in the conversion of prothrombin into thrombin in the clotting of blood [n -S]\n",
  "THROMBOPLASTINS": "THROMBOPLASTIN, a complex enzyme found esp. in platelets that functions in the conversion of prothrombin into thrombin in the clotting of blood [n]\n",
  "THROMBOSE": "to cause thrombosis in [v THROMBOSED, THROMBOSING, THROMBOSES]\n",
  "THROMBOSED": "THROMBOSE, to cause thrombosis in [v]\n",
  "THROMBOSES": "THROMBOSIS, clotting of blood in a vessel during life [n]\n",
  "THROMBOSING": "THROMBOSE, to cause thrombosis in [v]\n",
  "THROMBOSIS": "clotting of blood in a vessel during life [n THROMBOSES]\n",
  "THROMBOTIC": "relating to thrombosis [adj]\n",
  "THROMBOXANE": "any of several compounds formed from prostaglandin endoperoxides which, when released from blood platelets, induce platelet aggregation and arterial constriction [n -S]\n",
  "THROMBOXANES": "THROMBOXANE, any of several compounds formed from prostaglandin endoperoxides which, when released from blood platelets, induce platelet aggregation and arterial constriction [n]\n",
  "THROMBUS": "(Greek) a clot occluding a blood vessel [n THROMBI]\n",
  "THRONE": "to sit on a royal chair [v THRONED, THRONING, THRONES]\n",
  "THRONED": "THRONE, to sit on a royal chair [v]\n",
  "THRONELESS": "having no throne [adj]\n",
  "THRONES": "THRONE, to sit on a royal chair [v]\n",
  "THRONG": "to crowd into [v -ED, -ING, -S]\n",
  "THRONGED": "THRONG, to crowd into [v]\n",
  "THRONGFUL": "thronged [adj]\n",
  "THRONGING": "the act of thronging [n -S]\n",
  "THRONGINGS": "THRONGING, the act of thronging [n]\n",
  "THRONGS": "THRONG, to crowd into [v]\n",
  "THRONING": "THRONE, to sit on a royal chair [v]\n",
  "THRONNER": "(dialect) a person good at doing odd jobs [n -S]\n",
  "THRONNERS": "THRONNER, (dialect) a person good at doing odd jobs [n]\n",
  "THROPPLE": "(Scots) to throttle, strangle, also THRAPPLE [v THROPPLED, THROPPLING, THROPPLES]\n",
  "THROPPLED": "THROPPLE, (Scots) to throttle, strangle, also THRAPPLE [v]\n",
  "THROPPLES": "THROPPLE, (Scots) to throttle, strangle, also THRAPPLE [v]\n",
  "THROPPLING": "THROPPLE, (Scots) to throttle, strangle, also THRAPPLE [v]\n",
  "THROSTLE": "the song-thrush [n -S]\n",
  "THROSTLES": "THROSTLE, the song-thrush [n]\n",
  "THROTTLE": "to to choke by pressure at the windpipe [v THROTTLED, THROTTLING, THROTTLES]\n",
  "THROTTLEABLE": "capable of having the thrust varied [adj]\n",
  "THROTTLED": "THROTTLE, to to choke by pressure at the windpipe [v]\n",
  "THROTTLEHOLD": "a vicious, strangling, or stultifying control [n -S]\n",
  "THROTTLEHOLDS": "THROTTLEHOLD, a vicious, strangling, or stultifying control [n]\n",
  "THROTTLER": "one who, or that which, throttles [n -S]\n",
  "THROTTLERS": "THROTTLER, one who, or that which, throttles [n]\n",
  "THROTTLES": "THROTTLE, to to choke by pressure at the windpipe [v]\n",
  "THROTTLING": "the act of throttling [n -S]\n",
  "THROTTLINGS": "THROTTLING, the act of throttling [n]\n",
  "THROUGH": "by way of [prep]\n",
  "THROUGHFARE": "(Shakespeare) a thoroughfare [n -S]\n",
  "THROUGHFARES": "THROUGHFARE, (Shakespeare) a thoroughfare [n]\n",
  "THROUGHGAUN": "(Scots) a scolding [n -S]\n",
  "THROUGHGAUNS": "THROUGHGAUN, (Scots) a scolding [n]\n",
  "THROUGHITHER": "in confusion, also THROUGHOTHER [adv]\n",
  "THROUGHLY": "(archaic) far through [adv]\n",
  "THROUGHOTHER": "in confusion, also THROUGHITHER [adv]\n",
  "THROUGHOUT": "in or to every part [adv]\n",
  "THROUGHPUT": "the amount of raw material processed in a given time, also THRUPUT [n -S]\n",
  "THROUGHPUTS": "THROUGHPUT, the amount of raw material processed in a given time, also THRUPUT [n]\n",
  "THROUGHWAY": "(US) a motorway, also THRUWAY [n -S]\n",
  "THROUGHWAYS": "THROUGHWAY, (US) a motorway, also THRUWAY [n]\n",
  "THROVE": "THRIVE, to grow vigorously [v]\n",
  "THROW": "to fling in the air [v THREW, THROWN, THROWING, THROWS]\n",
  "THROWABLE": "capable of being throw [adj]\n",
  "THROWAWAY": "a line, or a joke, that an actor purposely delivers casually or without emphasis [n -S]\n",
  "THROWAWAYS": "THROWAWAY, a line, or a joke, that an actor purposely delivers casually or without emphasis [n]\n",
  "THROWBACK": "a reversion (e.g. to an earlier developmental type) [n -S]\n",
  "THROWBACKS": "THROWBACK, a reversion (e.g. to an earlier developmental type) [n]\n",
  "THROWDOWN": "a challenge, esp. to a physical or artistic competition [n -S]\n",
  "THROWDOWNS": "THROWDOWN, a challenge, esp. to a physical or artistic competition [n]\n",
  "THROWE": "(Shakespeare) a throe [n -S]\n",
  "THROWER": "one that throws [n -S]\n",
  "THROWERS": "THROWER, one that throws [n]\n",
  "THROWES": "THROWE, (Shakespeare) a throe [n]\n",
  "THROWING": "the act of throwing [n -S]\n",
  "THROWINGS": "THROWING, the act of throwing [n]\n",
  "THROWN": "THROW, to fling in the air [v]\n",
  "THROWOVER": "a piece of material that is placed over an object to provide decoration, protection, or warmth [n -S]\n",
  "THROWOVERS": "THROWOVER, a piece of material that is placed over an object to provide decoration, protection, or warmth [n]\n",
  "THROWS": "THROW, to fling in the air [v]\n",
  "THROWSTER": "one who throws or twists silk [n -S]\n",
  "THROWSTERS": "THROWSTER, one who throws or twists silk [n]\n",
  "THRU": "(archaic) through [prep]\n",
  "THRUM": "to play a stringed instrument monotonously [v THRUMMED, THRUMMING, THRUMS]\n",
  "THRUMMED": "THRUM, to play a stringed instrument monotonously [v]\n",
  "THRUMMER": "one that thrums, strums rhythmically and monotonously [n -S]\n",
  "THRUMMERS": "THRUMMER, one that thrums, strums rhythmically and monotonously [n]\n",
  "THRUMMIER": "THRUMMY, made of or like thrums, that is, ends of the warp threads in a loom, left unwoven and remaining attached to the loom when the web is cut off [adj]\n",
  "THRUMMIEST": "THRUMMY, made of or like thrums, that is, ends of the warp threads in a loom, left unwoven and remaining attached to the loom when the web is cut off [adj]\n",
  "THRUMMING": "humming, droning [adj THRUMMINGLY] / the act of thrumming [n -S]\n",
  "THRUMMINGLY": "THRUMMING, humming, droning [adv]\n",
  "THRUMMINGS": "THRUMMING, the act of thrumming [n]\n",
  "THRUMMY": "made of or like thrums, that is, ends of the warp threads in a loom, left unwoven and remaining attached to the loom when the web is cut off [adj THRUMMIER, THRUMMIEST]\n",
  "THRUMS": "THRUM, to play a stringed instrument monotonously [v]\n",
  "THRUPENNIES": "THRUPENNY, a twelve-sided British coin, obsolete since 1972 [n]\n",
  "THRUPENNY": "a twelve-sided British coin, obsolete since 1972 [n THRUPENNIES]\n",
  "THRUPPENCE": "threepence, also THREEPENCE, THREEPENNY, THRUPPENNY [n -S]\n",
  "THRUPPENCES": "THRUPPENCE, threepence, also THREEPENCE, THREEPENNY, THRUPPENNY [n]\n",
  "THRUPPENNIES": "THRUPPENNY, threepence, as in thruppenny bit, also THREEPENCE, THREEPENNY, THRUPPENCE [n]\n",
  "THRUPPENNY": "threepence, as in thruppenny bit, also THREEPENCE, THREEPENNY, THRUPPENCE [n THRUPPENNIES]\n",
  "THRUPUT": "the amount of raw material processed within a given time [n -S]\n",
  "THRUPUTS": "THRUPUT, the amount of raw material processed within a given time [n]\n",
  "THRUSH": "a songbird [n -ES]\n",
  "THRUSHES": "THRUSH, a songbird [n]\n",
  "THRUSHLIKE": "like a thrush [adj]\n",
  "THRUST": "to push forcibly [v -ED, -ING, -S]\n",
  "THRUSTED": "THRUST, to push forcibly [v]\n",
  "THRUSTER": "one that thrusts, also THRUSTOR [n -S]\n",
  "THRUSTERS": "THRUSTER, one that thrusts, also THRUSTOR [n]\n",
  "THRUSTFUL": "pushy, assertive [adj]\n",
  "THRUSTING": "the act of thrusting [n -S]\n",
  "THRUSTINGS": "THRUSTING, the act of thrusting [n]\n",
  "THRUSTOR": "one that thrusts, also THRUSTER [n -S]\n",
  "THRUSTORS": "THRUSTOR, one that thrusts, also THRUSTER [n]\n",
  "THRUSTS": "THRUST, to push forcibly [v]\n",
  "THRUTCH": "(dialect) to press, thrust, shove [v -ED, -ING, -ES]\n",
  "THRUTCHED": "THRUTCH, (dialect) to press, thrust, shove [v]\n",
  "THRUTCHES": "THRUTCH, (dialect) to press, thrust, shove [v]\n",
  "THRUTCHING": "THRUTCH, (dialect) to press, thrust, shove [v]\n",
  "THRUWAY": "(US) a motorway, also THROUGHWAY [n -S]\n",
  "THRUWAYS": "THRUWAY, (US) a motorway, also THROUGHWAY [n]\n",
  "THRYMSA": "(Old English) an Anglo-Saxon gold coin, also THRIMSA [n -S]\n",
  "THRYMSAS": "THRYMSA, (Old English) an Anglo-Saxon gold coin, also THRIMSA [n]\n",
  "THUD": "to make a dull, heavy sound [v THUDDED, THUDDING, THUDS]\n",
  "THUDDED": "THUD, to make a dull, heavy sound [v]\n",
  "THUDDING": "a dull percussive sound [n -S]\n",
  "THUDDINGLY": "THUDDING [adv]\n",
  "THUDDINGS": "THUDDING, a dull percussive sound [n]\n",
  "THUDS": "THUD, to make a dull, heavy sound [v]\n",
  "THUG": "a brutal ruffian [n -S]\n",
  "THUGGEE": "(Hindi) murder and robbery by thugs, also THAGI [n -S]\n",
  "THUGGEES": "THUGGEE, (Hindi) murder and robbery by thugs, also THAGI [n]\n",
  "THUGGERIES": "THUGGERY, thuggish behaviour [n]\n",
  "THUGGERY": "thuggish behaviour [n THUGGERIES]\n",
  "THUGGISH": "characteristic of a thug [adj]\n",
  "THUGGISM": "the practices of Indian thugs [n -S]\n",
  "THUGGISMS": "THUGGISM, the practices of Indian thugs [n]\n",
  "THUGGO": "(colloquial) a thug, ruffian [n -S]\n",
  "THUGGOS": "THUGGO, (colloquial) a thug, ruffian [n]\n",
  "THUGS": "THUG, a brutal ruffian [n]\n",
  "THUJA": "(Greek) a genus of evergreen trees, thickly branched, with scalelike leaves, also THUYA [n -S]\n",
  "THUJAS": "THUJA, (Greek) a genus of evergreen trees, thickly branched, with scalelike leaves, also THUYA [n]\n",
  "THULIA": "an oxide of thulium [n -S]\n",
  "THULIAS": "THULIA, an oxide of thulium [n]\n",
  "THULITE": "a red zoisite found in Norway [n -S]\n",
  "THULITES": "THULITE, a red zoisite found in Norway [n]\n",
  "THULIUM": "a rare metallic chemical element of the lanthanide series [n -S]\n",
  "THULIUMS": "THULIUM, a rare metallic chemical element of the lanthanide series [n]\n",
  "THUMB": "to leaf through with the short, thick digit of the hand [v -ED, -ING, -S]\n",
  "THUMBED": "THUMB, to leaf through with the short, thick digit of the hand [v]\n",
  "THUMBHOLE": "a hole to insert the thumb in [n -S]\n",
  "THUMBHOLES": "THUMBHOLE, a hole to insert the thumb in [n]\n",
  "THUMBIER": "THUMBY, like thumbs, clumsy [adj]\n",
  "THUMBIEST": "THUMBY, like thumbs, clumsy [adj]\n",
  "THUMBIKINS": "(Scots) an instrument of torture for compressing the thumb; a thumbscrew, also THUMBKIN [n]\n",
  "THUMBING": "THUMB, to leaf through with the short, thick digit of the hand [v]\n",
  "THUMBKIN": "(Scots) an instrument of torture for compressing the thumb; a thumbscrew, also THUMBIKINS [n -S]\n",
  "THUMBKINS": "THUMBKIN, (Scots) an instrument of torture for compressing the thumb; a thumbscrew, also THUMBIKINS [n]\n",
  "THUMBLESS": "without a thumb [adj]\n",
  "THUMBLIKE": "like a thumb [adj]\n",
  "THUMBLING": "a diminutive being, a dwarf [n -S]\n",
  "THUMBLINGS": "THUMBLING, a diminutive being, a dwarf [n]\n",
  "THUMBNAIL": "the nail of the thumb; a sketch as small as a thumbnail [n -S]\n",
  "THUMBNAILS": "THUMBNAIL, the nail of the thumb; a sketch as small as a thumbnail [n]\n",
  "THUMBNUT": "a nut that is turned by the thumb and fingers [n -S]\n",
  "THUMBNUTS": "THUMBNUT, a nut that is turned by the thumb and fingers [n]\n",
  "THUMBPIECE": "a piece that is pressed by the thumb or receives the thumb [n -S]\n",
  "THUMBPIECES": "THUMBPIECE, a piece that is pressed by the thumb or receives the thumb [n]\n",
  "THUMBPOT": "a very small flowerpot [n -S]\n",
  "THUMBPOTS": "THUMBPOT, a very small flowerpot [n]\n",
  "THUMBPRINT": "an impression made by the thumb [n -S]\n",
  "THUMBPRINTS": "THUMBPRINT, an impression made by the thumb [n]\n",
  "THUMBS": "THUMB, to leaf through with the short, thick digit of the hand [v]\n",
  "THUMBSCREW": "an instrument of torture for compressing the thumb by a screw [n -S]\n",
  "THUMBSCREWS": "THUMBSCREW, an instrument of torture for compressing the thumb by a screw [n]\n",
  "THUMBSTALL": "a covering or sheath for the thumb [n -S]\n",
  "THUMBSTALLS": "THUMBSTALL, a covering or sheath for the thumb [n]\n",
  "THUMBTACK": "a broad-headed tack [n -S] / to fasten with a thumbtack [v -ED, -ING, -S]\n",
  "THUMBTACKED": "THUMBTACK, to fasten with a thumbtack [v]\n",
  "THUMBTACKING": "THUMBTACK, to fasten with a thumbtack [v]\n",
  "THUMBTACKS": "THUMBTACK, to fasten with a thumbtack [v]\n",
  "THUMBWHEEL": "a control for various devices consisting of a partially exposed wheel that can be turned by a finger [n -S]\n",
  "THUMBWHEELS": "THUMBWHEEL, a control for various devices consisting of a partially exposed wheel that can be turned by a finger [n]\n",
  "THUMBY": "like thumbs, clumsy [adj THUMBIER, THUMBIEST]\n",
  "THUMP": "to beat with a heavy blow [v -ED, -ING, -S]\n",
  "THUMPED": "THUMP, to beat with a heavy blow [v]\n",
  "THUMPER": "a strikingly big thing of its kind, esp. a blatant or gross lie [n -S]\n",
  "THUMPERS": "THUMPER, a strikingly big thing of its kind, esp. a blatant or gross lie [n]\n",
  "THUMPING": "THUMP, to beat with a heavy blow [v]\n",
  "THUMPINGLY": "THUMPING, THUMP, to beat with a heavy blow [adv]\n",
  "THUMPS": "THUMP, to beat with a heavy blow [v]\n",
  "THUNBERGIA": "(Swedish) any of a genus of evergreen climbing plants [n -S]\n",
  "THUNBERGIAS": "THUNBERGIA, (Swedish) any of a genus of evergreen climbing plants [n]\n",
  "THUNDER": "to produce a loud, resounding sound [v THUNDERED or (obsolete) YTHUNDERED, THUNDERING, THUNDERS]\n",
  "THUNDERBIRD": "in North American Indian lore, a huge bird personifying thunder and lightning [n -S]\n",
  "THUNDERBIRDS": "THUNDERBIRD, in North American Indian lore, a huge bird personifying thunder and lightning [n]\n",
  "THUNDERBOLT": "a flash of lightning conceived as a bolt hurled from the heavens [n -S]\n",
  "THUNDERBOLTS": "THUNDERBOLT, a flash of lightning conceived as a bolt hurled from the heavens [n]\n",
  "THUNDERBOX": "(slang) a chamber-box enclosed in a box or stool [n -ES]\n",
  "THUNDERBOXES": "THUNDERBOX, (slang) a chamber-box enclosed in a box or stool [n]\n",
  "THUNDERCLAP": "a clap of thunder [n -S]\n",
  "THUNDERCLAPS": "THUNDERCLAP, a clap of thunder [n]\n",
  "THUNDERCLOUD": "a cloud charged with electricity and producing lightning and thunder [n -S]\n",
  "THUNDERCLOUDS": "THUNDERCLOUD, a cloud charged with electricity and producing lightning and thunder [n]\n",
  "THUNDERED": "THUNDER, to produce a loud, resounding sound [v]\n",
  "THUNDERER": "a thing that makes a noise like thunder; specifically a bullroarer [n -S]\n",
  "THUNDERERS": "THUNDERER, a thing that makes a noise like thunder; specifically a bullroarer [n]\n",
  "THUNDERFLASH": "a container, such as a blank shell, filled with explosive powder, which makes a flash and a loud explosion when detonated [n -ES]\n",
  "THUNDERFLASHES": "THUNDERFLASH, a container, such as a blank shell, filled with explosive powder, which makes a flash and a loud explosion when detonated [n]\n",
  "THUNDERHEAD": "a thunder cloud [n -S]\n",
  "THUNDERHEADS": "THUNDERHEAD, a thunder cloud [n]\n",
  "THUNDERIER": "THUNDERY, indicative of thunder [adj]\n",
  "THUNDERIEST": "THUNDERY, indicative of thunder [adj]\n",
  "THUNDERING": "resounding [adj THUNDERINGLY] / the act of thundering [n -S]\n",
  "THUNDERINGLY": "THUNDERING, resounding [adv]\n",
  "THUNDERINGS": "THUNDERING, the act of thundering [n]\n",
  "THUNDERLESS": "without thunder [adj]\n",
  "THUNDEROUS": "sounding like thunder, also THUNDROUS [adj THUNDEROUSLY]\n",
  "THUNDEROUSLY": "THUNDEROUS, sounding like thunder, also THUNDROUS [adv]\n",
  "THUNDEROUSNESS": "the state of being thunderous [n]\n",
  "THUNDERS": "THUNDER, to produce a loud, resounding sound [v]\n",
  "THUNDERSHOWER": "a shower accompanied by lightning and thunder [n -S]\n",
  "THUNDERSHOWERS": "THUNDERSHOWER, a shower accompanied by lightning and thunder [n]\n",
  "THUNDERSTONE": "(Shakespeare) a thunderbolt [n -S]\n",
  "THUNDERSTONES": "THUNDERSTONE, (Shakespeare) a thunderbolt [n]\n",
  "THUNDERSTORM": "a storm featuring thunder [n -S]\n",
  "THUNDERSTORMS": "THUNDERSTORM, a storm featuring thunder [n]\n",
  "THUNDERSTRICKEN": "THUNDERSTRIKE, to strike dumb [v]\n",
  "THUNDERSTRIKE": "to strike dumb [v THUNDERSTRUCK, THUNDERSTRICKEN, THUNDERSTRIKING, THUNDERSTRIKES]\n",
  "THUNDERSTRIKES": "THUNDERSTRIKE, to strike dumb [v]\n",
  "THUNDERSTRIKING": "THUNDERSTRIKE, to strike dumb [v]\n",
  "THUNDERSTROKE": "a stroke of or as if of lightning with the attendant thunder [n -S]\n",
  "THUNDERSTROKES": "THUNDERSTROKE, a stroke of or as if of lightning with the attendant thunder [n]\n",
  "THUNDERSTRUCK": "THUNDERSTRIKE, to strike dumb [v]\n",
  "THUNDERY": "indicative of thunder [adj THUNDERIER, THUNDERIEST]\n",
  "THUNDROUS": "sounding like thunder, also THUNDEROUS [adj]\n",
  "THUNK": "to make a sudden, muffled sound [v -ED, -ING, -S]\n",
  "THUNKED": "THUNK, to make a sudden, muffled sound [v]\n",
  "THUNKING": "THUNK, to make a sudden, muffled sound [v]\n",
  "THUNKS": "THUNK, to make a sudden, muffled sound [v]\n",
  "THURIBLE": "a censer [n -S]\n",
  "THURIBLES": "THURIBLE, a censer [n]\n",
  "THURIFER": "an altar boy or acolyte who carries a thurible [n -S]\n",
  "THURIFEROUS": "incense-bearing [adj]\n",
  "THURIFERS": "THURIFER, an altar boy or acolyte who carries a thurible [n]\n",
  "THURIFICATION": "purification by use of a thurifer, a censer [n -S]\n",
  "THURIFICATIONS": "THURIFICATION, purification by use of a thurifer, a censer [n]\n",
  "THURIFIED": "THURIFY, to perfume with incense [v]\n",
  "THURIFIES": "THURIFY, to perfume with incense [v]\n",
  "THURIFY": "to perfume with incense [v THURIFIED, THURIFYING, THURIFIES]\n",
  "THURIFYING": "THURIFY, to perfume with incense [v]\n",
  "THURL": "the hip joint in cattle [n -S]\n",
  "THURLS": "THURL, the hip joint in cattle [n]\n",
  "THUS": "in such a way [adv THUSLY] / frankincense [n -ES]\n",
  "THUSES": "THUS, frankincense [n]\n",
  "THUSLY": "in this manner [adv]\n",
  "THUSNESS": "the state of being thus [n -ES]\n",
  "THUSNESSES": "THUSNESS, the state of being thus [n]\n",
  "THUSWISE": "in this manner [adv]\n",
  "THUYA": "(Greek) an evergreen tree or shrub, thickly branched, with scalelike leaves, also THUJA [n -S]\n",
  "THUYAS": "THUYA, (Greek) an evergreen tree or shrub, thickly branched, with scalelike leaves, also THUJA [n]\n",
  "THWACK": "to strike with something flat [v -ED, -ING, -S]\n",
  "THWACKED": "THWACK, to strike with something flat [v]\n",
  "THWACKER": "one who thwacks [n -S]\n",
  "THWACKERS": "THWACKER, one who thwacks [n]\n",
  "THWACKING": "the act of thwacking [n -S]\n",
  "THWACKINGS": "THWACKING, the act of thwacking [n]\n",
  "THWACKS": "THWACK, to strike with something flat [v]\n",
  "THWAITE": "(Old Norse) a piece of reclaimed wasteland [n -S]\n",
  "THWAITES": "THWAITE, (Old Norse) a piece of reclaimed wasteland [n]\n",
  "THWART": "cross-grained [adj THWARTLY] / to cross the path of, obstruct [v -ED, -ING, -S]\n",
  "THWARTED": "THWART, to cross the path of, obstruct [v]\n",
  "THWARTEDLY": "THWARTED, THWART, to cross the path of, obstruct [adv]\n",
  "THWARTER": "one who thwarts [n -S]\n",
  "THWARTERS": "THWARTER, one who thwarts [n]\n",
  "THWARTING": "obstructive [adj THWARTINGLY] / the act of thwarting [n -S]\n",
  "THWARTINGLY": "THWARTING, obstructive [adv]\n",
  "THWARTINGS": "THWARTING, the act of thwarting [n]\n",
  "THWARTLY": "THWART, cross-grained [adv]\n",
  "THWARTS": "THWART, to cross the path of, obstruct [v]\n",
  "THWARTSHIP": "across the ship, also ATHWARTSHIPS, THWARTSHIPS [adv]\n",
  "THWARTSHIPS": "across the ship, also ATHWARTSHIPS, THWARTSHIP [adv]\n",
  "THWARTWAYS": "crosswise; from side to side, also THWARTWISE [adv]\n",
  "THWARTWISE": "crosswise; from side to side, also THWARTWAYS [adv]\n",
  "THY": "possessive form of thou [pron]\n",
  "THYINE": "in biblical translations and allusions, of or pertaining to (the wood of) the thuya [adj]\n",
  "THYLACINE": "the Tasmanian wolf [n -S]\n",
  "THYLACINES": "THYLACINE, the Tasmanian wolf [n]\n",
  "THYLAKOID": "any of a membranous disk of lamellae within plant chloroplasts [n -S]\n",
  "THYLAKOIDS": "THYLAKOID, any of a membranous disk of lamellae within plant chloroplasts [n]\n",
  "THYLOSE": "an ingrowth from a neighbouring cell through a pit into a vessel, also THYLOSIS, TYLOSIS [n -S]\n",
  "THYLOSES": "THYLOSE, an ingrowth from a neighbouring cell through a pit into a vessel, also THYLOSIS, TYLOSIS [n]\n",
  "THYLOSIS": "an ingrowth from a neighbouring cell through a pit into a vessel, also THYLOSE, TYLOSIS [n THYLOSES]\n",
  "THYME": "any member of the labiate genus Thymus [n -S]\n",
  "THYMECTOMIES": "THYMECTOMY, surgical removal of the thymus [n]\n",
  "THYMECTOMISE": "to perform a thymectomy, also THYMECTOMIZE [v THYMECTOMISED, THYMECTOMISING, THYMECTOMISES]\n",
  "THYMECTOMISED": "THYMECTOMISE, to perform a thymectomy, also THYMECTOMIZE [v]\n",
  "THYMECTOMISES": "THYMECTOMISE, to perform a thymectomy, also THYMECTOMIZE [v]\n",
  "THYMECTOMISING": "THYMECTOMISE, to perform a thymectomy, also THYMECTOMIZE [v]\n",
  "THYMECTOMIZE": "to perform a thymectomy, also THYMECTOMISE [v THYMECTOMIZED, THYMECTOMIZING, THYMECTOMIZES]\n",
  "THYMECTOMIZED": "THYMECTOMIZE, to perform a thymectomy, also THYMECTOMISE [v]\n",
  "THYMECTOMIZES": "THYMECTOMIZE, to perform a thymectomy, also THYMECTOMISE [v]\n",
  "THYMECTOMIZING": "THYMECTOMIZE, to perform a thymectomy, also THYMECTOMISE [v]\n",
  "THYMECTOMY": "surgical removal of the thymus [n THYMECTOMIES]\n",
  "THYMELAEACEOUS": "of the Thymelaeaceae, the family of trees and shrubs with simple leaves and tough bark to which spurge laurel belongs [adj]\n",
  "THYMES": "THYME, any member of the labiate genus Thymus [n]\n",
  "THYMEY": "abounding in thyme, also THYMY [adj THYMIER, THYMIEST]\n",
  "THYMI": "THYMUS, (Greek) a ductless gland in the neck, producing white blood cells [n]\n",
  "THYMIC": "of or pertaining to the thymus gland [adj]\n",
  "THYMIDINE": "a nucleoside of thymine, found in DNA [n -S]\n",
  "THYMIDINES": "THYMIDINE, a nucleoside of thymine, found in DNA [n]\n",
  "THYMIDYLIC": "as in thymidylic acid, a nucleotide composed of a phosphoric acid ester of thymidine, present in most DNA [adj]\n",
  "THYMIER": "THYMEY, abounding in thyme, also THYMY [adj]\n",
  "THYMIEST": "THYMEY, abounding in thyme, also THYMY [adj]\n",
  "THYMINE": "one of the four bases in DNA [n -S]\n",
  "THYMINES": "THYMINE, one of the four bases in DNA [n]\n",
  "THYMOCYTE": "a lymphocyte found in the thymus [n -S]\n",
  "THYMOCYTES": "THYMOCYTE, a lymphocyte found in the thymus [n]\n",
  "THYMOL": "an antiseptic phenol obtained from oil of thyme [n -S]\n",
  "THYMOLS": "THYMOL, an antiseptic phenol obtained from oil of thyme [n]\n",
  "THYMOMA": "a tumour arising from thymus tissue [n THYMOMAS or THYMOMATA]\n",
  "THYMOMAS": "THYMOMA, a tumour arising from thymus tissue [n]\n",
  "THYMOMATA": "THYMOMA, a tumour arising from thymus tissue [n]\n",
  "THYMOSIN": "a hormone secreted by the thymus [n -S]\n",
  "THYMOSINS": "THYMOSIN, a hormone secreted by the thymus [n]\n",
  "THYMUS": "(Greek) a ductless gland in the neck, producing white blood cells [n THYMI or THYMUSES]\n",
  "THYMUSES": "THYMUS, (Greek) a ductless gland in the neck, producing white blood cells [n]\n",
  "THYMY": "abounding in thyme, also THYMEY [adj THYMIER, THYMIEST]\n",
  "THYRATRON": "a gas-filled valve with a heated cathode, able to carry very high currents [n -S]\n",
  "THYRATRONS": "THYRATRON, a gas-filled valve with a heated cathode, able to carry very high currents [n]\n",
  "THYREOID": "a shield-shaped bone [n -S]\n",
  "THYREOIDS": "THYREOID, a shield-shaped bone [n]\n",
  "THYRISTOR": "a thyratron-like solid-state semiconductor device [n -S]\n",
  "THYRISTORS": "THYRISTOR, a thyratron-like solid-state semiconductor device [n]\n",
  "THYROCALCITONIN": "a hormone secreted by the thyroid gland, controlling the rate of bone destruction [n]\n",
  "THYROGLOBULIN": "an iodine-containing protein of the thyroid gland that is the precursor of thyroxine and triiodothyronine [n -S]\n",
  "THYROGLOBULINS": "THYROGLOBULIN, an iodine-containing protein of the thyroid gland that is the precursor of thyroxine and triiodothyronine [n]\n",
  "THYROID": "a ductless gland in the neck [n -S]\n",
  "THYROIDAL": "relating to the thyroid gland [adj]\n",
  "THYROIDECTOMIES": "THYROIDECTOMY, the surgical removal of the thyroid gland [n]\n",
  "THYROIDECTOMY": "the surgical removal of the thyroid gland [n THYROIDECTOMIES]\n",
  "THYROIDITIDES": "THYROIDITIS, inflammation of the thyroid [n]\n",
  "THYROIDITIS": "inflammation of the thyroid [n THYROIDITIDES or THYROIDITISES]\n",
  "THYROIDITISES": "THYROIDITIS, inflammation of the thyroid [n]\n",
  "THYROIDS": "THYROID, a ductless gland in the neck [n]\n",
  "THYROTOXICOSES": "THYROTOXICOSIS, hyperthyroidism with goitre and exophthalmia, Graves' disease [n]\n",
  "THYROTOXICOSIS": "hyperthyroidism with goitre and exophthalmia, Graves' disease [n THYROTOXICOSES]\n",
  "THYROTROPHIC": "exerting or characterized by a direct influence on the secretory activity of the thyroid gland, also THYROTROPIC [adj]\n",
  "THYROTROPHIN": "a hormone, produced in the anterior lobe of the pituitary gland, which stimulates the thyroid, also THYROTROPIN [n -S]\n",
  "THYROTROPHINS": "THYROTROPHIN, a hormone, produced in the anterior lobe of the pituitary gland, which stimulates the thyroid, also THYROTROPIN [n]\n",
  "THYROTROPIC": "exerting or characterized by a direct influence on the secretory activity of the thyroid gland, also THYROTROPHIC [adj]\n",
  "THYROTROPIN": "a hormone, produced in the anterior lobe of the pituitary gland, which stimulates the thyroid, also THYROTROPHIN [n -S]\n",
  "THYROTROPINS": "THYROTROPIN, a hormone, produced in the anterior lobe of the pituitary gland, which stimulates the thyroid, also THYROTROPHIN [n]\n",
  "THYROXIN": "an iodine compound, a hormone forming the active principle of the thyroid gland, also THYROXINE [n -S]\n",
  "THYROXINE": "an iodine compound, a hormone forming the active principle of the thyroid gland, also THYROXIN [n -S]\n",
  "THYROXINES": "THYROXINE, an iodine compound, a hormone forming the active principle of the thyroid gland, also THYROXIN [n]\n",
  "THYROXINS": "THYROXIN, an iodine compound, a hormone forming the active principle of the thyroid gland, also THYROXINE [n]\n",
  "THYRSE": "(Greek) a type of flower cluster, also THYRSUS [n -S]\n",
  "THYRSES": "THYRSE, (Greek) a type of flower cluster, also THYRSUS [n]\n",
  "THYRSI": "THYRSUS, (Greek) a type of flower cluster, also THYRSE [n]\n",
  "THYRSOID": "having the form of a thyrsus, also THYRSOIDAL [adj]\n",
  "THYRSOIDAL": "having the form of a thyrsus, also THYRSOID [adj]\n",
  "THYRSUS": "(Greek) a type of flower cluster, also THYRSE [n THYRSI]\n",
  "THYSANOPTEROUS": "belonging to the Thysanoptera, an order of insects with fringed wings, some of which are serious pests to fruit, such as thrips [adj]\n",
  "THYSANURAN": "a member of the bristletails, an order of small wingless insects with abdominal appendages [n -S]\n",
  "THYSANURANS": "THYSANURAN, a member of the bristletails, an order of small wingless insects with abdominal appendages [n]\n",
  "THYSANUROUS": "relating to a thysanuran, a bristletail [adj]\n",
  "THYSELF": "yourself [pron]\n",
  "TI": "the seventh tone of the diatonic musical scale [n -S]\n",
  "TIAN": "a vegetable gratin baked in an earthenware dish [n -S]\n",
  "TIANS": "TIAN, a vegetable gratin baked in an earthenware dish [n]\n",
  "TIAR": "a three-tiered crown, also TIARA [n -S]\n",
  "TIARA": "a three-tiered crown, also TIAR [n -S]\n",
  "TIARAED": "wearing a tiara [adj]\n",
  "TIARAS": "TIARA, a three-tiered crown, also TIAR [n]\n",
  "TIARS": "TIAR, a three-tiered crown, also TIARA [n]\n",
  "TIBIA": "(Latin) the part of the leg below the knee [n TIBIAS or TIBIAE]\n",
  "TIBIAE": "TIBIA, (Latin) the part of the leg below the knee [n]\n",
  "TIBIAL": "pertaining to the tibia [adj]\n",
  "TIBIALES": "TIBIALIS, a muscle in the calf of the leg [n]\n",
  "TIBIALIS": "a muscle in the calf of the leg [n TIBIALES]\n",
  "TIBIAS": "TIBIA, (Latin) the part of the leg below the knee [n]\n",
  "TIBIOFIBULA": "a bone esp. in frogs and toads that is formed by a fusion of the tibia and fibula [n TIBIOFIBULAE or TIBIOFIBULAS]\n",
  "TIBIOFIBULAE": "TIBIOFIBULA, a bone esp. in frogs and toads that is formed by a fusion of the tibia and fibula [n]\n",
  "TIBIOFIBULAS": "TIBIOFIBULA, a bone esp. in frogs and toads that is formed by a fusion of the tibia and fibula [n]\n",
  "TIBIOTARSI": "TIBIOTARSUS, in birds, a bone formed by the fusion of the tibia and some of the tarsals [n]\n",
  "TIBIOTARSUS": "in birds, a bone formed by the fusion of the tibia and some of the tarsals [n TIBIOTARSI]\n",
  "TIBOUCHINA": "a plant of the Tibouchina genus of shrubs, with purple flowers [n -S]\n",
  "TIBOUCHINAS": "TIBOUCHINA, a plant of the Tibouchina genus of shrubs, with purple flowers [n]\n",
  "TIC": "to twitch [v TICCED, TICCING, TICS]\n",
  "TICAL": "(Portuguese) a former Thai unit of weight [n -S]\n",
  "TICALS": "TICAL, (Portuguese) a former Thai unit of weight [n]\n",
  "TICCA": "(Hindi) hired [adj]\n",
  "TICCED": "TIC, to twitch [v]\n",
  "TICCING": "TIC, to twitch [v]\n",
  "TICE": "(Shakespeare) to entice [v TICED, TICING, TICES]\n",
  "TICED": "TICE, (Shakespeare) to entice [v]\n",
  "TICES": "TICE, (Shakespeare) to entice [v]\n",
  "TICH": "a small person, also TITCH [n -ES]\n",
  "TICHES": "TICH, a small person, also TITCH [n]\n",
  "TICHIER": "TICHY, very small, also TITCHIE, TITCHY [adj]\n",
  "TICHIEST": "TICHY, very small, also TITCHIE, TITCHY [adj]\n",
  "TICHORRHINE": "a fossil woolly rhinoceros with a bony nasal septum [n -S]\n",
  "TICHORRHINES": "TICHORRHINE, a fossil woolly rhinoceros with a bony nasal septum [n]\n",
  "TICHY": "very small, also TITCHIE, TITCHY [adj TICHIER, TICHIEST]\n",
  "TICING": "TICE, (Shakespeare) to entice [v]\n",
  "TICK": "to make a sound like a clock [v -ED, -ING, -S]\n",
  "TICKED": "TICK, to make a sound like a clock [v]\n",
  "TICKEN": "a strong linen or cotton fabric used for mattress and pillow cases, also TICKING [n -S]\n",
  "TICKENS": "TICKEN, a strong linen or cotton fabric used for mattress and pillow cases, also TICKING [n]\n",
  "TICKER": "(slang) the heart [n -S]\n",
  "TICKERS": "TICKER, (slang) the heart [n]\n",
  "TICKET": "to label [v -ED, -ING, -S]\n",
  "TICKETED": "TICKET, to label [v]\n",
  "TICKETING": "making tickets [n -S]\n",
  "TICKETINGS": "TICKETING, making tickets [n]\n",
  "TICKETLESS": "without a ticket [adj]\n",
  "TICKETS": "TICKET, to label [v]\n",
  "TICKETTYBOO": "fine, satisfactory [adj]\n",
  "TICKEY": "a former South African coin, a threepenny bit, also TICKY [n -S]\n",
  "TICKEYS": "TICKEY, a former South African coin, a threepenny bit, also TICKY [n]\n",
  "TICKIES": "TICKY, a former South African coin, also TICKEY [n]\n",
  "TICKING": "a strong linen or cotton fabric used for mattress and pillow cases, also TICKEN [n -S]\n",
  "TICKINGS": "TICKING, a strong linen or cotton fabric used for mattress and pillow cases, also TICKEN [n]\n",
  "TICKLACE": "(Canadian) in Newfoundland, a kittiwake, also TICKLEASS [n -S]\n",
  "TICKLACES": "TICKLACE, (Canadian) in Newfoundland, a kittiwake, also TICKLEASS [n]\n",
  "TICKLE": "to excite with a pleasant thrill [v TICKLED, TICKLING, TICKLES]\n",
  "TICKLEASS": "(Canadian) in Newfoundland, a kittiwake, also TICKLACE [n -ES]\n",
  "TICKLEASSES": "TICKLEASS, (Canadian) in Newfoundland, a kittiwake, also TICKLACE [n]\n",
  "TICKLED": "TICKLE, to excite with a pleasant thrill [v]\n",
  "TICKLER": "someone or something which tickles; a cane [n -S]\n",
  "TICKLERS": "TICKLER, someone or something which tickles; a cane [n]\n",
  "TICKLES": "TICKLE, to excite with a pleasant thrill [v]\n",
  "TICKLIER": "TICKLY, easily tickled [adj]\n",
  "TICKLIEST": "TICKLY, easily tickled [adj]\n",
  "TICKLING": "the act of tickling [n -S]\n",
  "TICKLINGS": "TICKLING, the act of tickling [n]\n",
  "TICKLISH": "sensitive to tickling [adj TICKLISHLY]\n",
  "TICKLISHLY": "TICKLISH, sensitive to tickling [adv]\n",
  "TICKLISHNESS": "the state of being ticklish [n -ES]\n",
  "TICKLISHNESSES": "TICKLISHNESS, the state of being ticklish [n]\n",
  "TICKLY": "easily tickled [adj TICKLIER, TICKLIEST]\n",
  "TICKS": "TICK, to make a sound like a clock [v]\n",
  "TICKSEED": "a flowering plant [n -S]\n",
  "TICKSEEDS": "TICKSEED, a flowering plant [n]\n",
  "TICKTACK": "to use arm signals for bookmaker information, also TICTAC, TICTOC, TICKTOCK [v -ED, -ING, -S]\n",
  "TICKTACKED": "TICKTACK, to use arm signals for bookmaker information, also TICTAC, TICTOC, TICKTOCK [v]\n",
  "TICKTACKING": "TICKTACK, to use arm signals for bookmaker information, also TICTAC, TICTOC, TICKTOCK [v]\n",
  "TICKTACKS": "TICKTACK, to use arm signals for bookmaker information, also TICTAC, TICTOC, TICKTOCK [v]\n",
  "TICKTACKTOE": "the game of noughts and crosses [n -S]\n",
  "TICKTACKTOES": "TICKTACKTOE, the game of noughts and crosses [n]\n",
  "TICKTOCK": "to make the sound of a clock, also TICTAC, TICKTACK, TICTOC [v -ED, -ING, -S]\n",
  "TICKTOCKED": "TICKTOCK, to make the sound of a clock, also TICTAC, TICKTACK, TICTOC [v]\n",
  "TICKTOCKING": "TICKTOCK, to make the sound of a clock, also TICTAC, TICKTACK, TICTOC [v]\n",
  "TICKTOCKS": "TICKTOCK, to make the sound of a clock, also TICTAC, TICKTACK, TICTOC [v]\n",
  "TICKY": "a former South African coin, also TICKEY [n TICKIES]\n",
  "TICS": "TIC, to twitch [v]\n",
  "TICTAC": "to use arm signals for bookmaker information, also TICKTACK, TICTOC, TICKTOCK [v TICTACKED, TICTACKING, TICTACS]\n",
  "TICTACKED": "TICTAC, to use arm signals for bookmaker information, also TICKTACK, TICTOC, TICKTOCK [v]\n",
  "TICTACKING": "TICTAC, to use arm signals for bookmaker information, also TICKTACK, TICTOC, TICKTOCK [v]\n",
  "TICTACS": "TICTAC, to use arm signals for bookmaker information, also TICKTACK, TICTOC, TICKTOCK [v]\n",
  "TICTOC": "to make the sound of a clock, also TICTAC, TICKTACK, TICKTOCK [v TICTOCKED, TICTOCKING, TICTOCS]\n",
  "TICTOCKED": "TICTOC, to make the sound of a clock, also TICTAC, TICKTACK, TICKTOCK [v]\n",
  "TICTOCKING": "TICTOC, to make the sound of a clock, also TICTAC, TICKTACK, TICKTOCK [v]\n",
  "TICTOCS": "TICTOC, to make the sound of a clock, also TICTAC, TICKTACK, TICKTOCK [v]\n",
  "TID": "(Scots) a mood, state of mind [n -S]\n",
  "TIDAL": "pertaining to tides [adj TIDALLY]\n",
  "TIDALLY": "TIDAL, pertaining to tides [adv]\n",
  "TIDBIT": "a choice bit of food, also TITBIT [n -S]\n",
  "TIDBITS": "TIDBIT, a choice bit of food, also TITBIT [n]\n",
  "TIDDIER": "TIDDY, very small [adj]\n",
  "TIDDIES": "TIDDY, the four of trumps at the game of gleek [n]\n",
  "TIDDIEST": "TIDDY, very small [adj]\n",
  "TIDDLE": "to use with tenderness; to fondle [v TIDDLED, TIDDLING, TIDDLES]\n",
  "TIDDLED": "TIDDLE, to use with tenderness; to fondle [v]\n",
  "TIDDLEDYWINK": "a game in which one attempts to flip a small disc into a cup by pressing its edge with a bigger one, also TIDDLEYWINK, TIDDLYWINK [n -S]\n",
  "TIDDLEDYWINKS": "TIDDLEDYWINK, a game in which one attempts to flip a small disc into a cup by pressing its edge with a bigger one, also TIDDLEYWINK, TIDDLYWINK [n]\n",
  "TIDDLER": "a small fish [n -S]\n",
  "TIDDLERS": "TIDDLER, a small fish [n]\n",
  "TIDDLES": "TIDDLE, to use with tenderness; to fondle [v]\n",
  "TIDDLEY": "slightly drunk, also TIDDLY [adj TIDDLIER, TIDDLIEST] / an alcoholic drink [n -S]\n",
  "TIDDLEYS": "TIDDLEY, an alcoholic drink [n]\n",
  "TIDDLEYWINK": "any of the discs used in the game of tiddlywinks, also TIDDLEDYWINK, TIDDLYWINK [n -S]\n",
  "TIDDLEYWINKS": "TIDDLEDYWINK, a game in which one attempts to flip a small disc into a cup by pressing its edge with a bigger one, also TIDDLEYWINK, TIDDLYWINK [n]\n",
  "TIDDLIER": "TIDDLY, slightly drunk [adj]\n",
  "TIDDLIES": "TIDDLY, an alcoholic drink, also TIDDLEY [n]\n",
  "TIDDLIEST": "TIDDLY, slightly drunk [adj]\n",
  "TIDDLING": "TIDDLE, to use with tenderness; to fondle [v]\n",
  "TIDDLY": "an alcoholic drink, also TIDDLEY [n TIDDLIES] / slightly drunk [adj TIDDLIER, TIDDLIEST]\n",
  "TIDDLYWINK": "a game in which one attempts to flip a small disc into a cup by pressing its edge with a bigger one, also TIDDLEDYWINK, TIDDLEYWINK [n -S]\n",
  "TIDDLYWINKS": "TIDDLYWINK, a game in which one attempts to flip a small disc into a cup by pressing its edge with a bigger one, also TIDDLEDYWINK, TIDDLEYWINK [n]\n",
  "TIDDY": "very small [adj TIDDIER, TIDDIEST] / the four of trumps at the game of gleek [n TIDDIES]\n",
  "TIDE": "to flow like the rise and fall of the ocean's waters [v TIDED, TIDING, TIDES]\n",
  "TIDED": "TIDE, to flow like the rise and fall of the ocean's waters [v]\n",
  "TIDELAND": "land covered and uncovered by the tide [n -S]\n",
  "TIDELANDS": "TIDELAND, land covered and uncovered by the tide [n]\n",
  "TIDELESS": "without a tide [adj]\n",
  "TIDELIKE": "like a tide [adj]\n",
  "TIDELINE": "the edge of the tide [n -S]\n",
  "TIDELINES": "TIDELINE, the edge of the tide [n]\n",
  "TIDEMARK": "a mark showing the highest or lowest points of a tide [n -S]\n",
  "TIDEMARKS": "TIDEMARK, a mark showing the highest or lowest points of a tide [n]\n",
  "TIDEMILL": "a mill moved by tidewater [n -S]\n",
  "TIDEMILLS": "TIDEMILL, a mill moved by tidewater [n]\n",
  "TIDERIP": "disturbed sea due to currents [n -S]\n",
  "TIDERIPS": "TIDERIP, disturbed sea due to currents [n]\n",
  "TIDES": "TIDE, to flow like the rise and fall of the ocean's waters [v]\n",
  "TIDESMAN": "a customhouse officer who goes on board of a merchant ship to secure payment of the duties [n TIDESMEN]\n",
  "TIDESMEN": "TIDESMAN, a customhouse officer who goes on board of a merchant ship to secure payment of the duties [n]\n",
  "TIDEWAITER": "(formerly) a customs officer who boarded and inspected incoming ships [n -S]\n",
  "TIDEWAITERS": "TIDEWAITER, (formerly) a customs officer who boarded and inspected incoming ships [n]\n",
  "TIDEWATER": "water brought by the tide [n -S]\n",
  "TIDEWATERS": "TIDEWATER, water brought by the tide [n]\n",
  "TIDEWAVE": "a tide regarded as a wave passing round the earth [n -S]\n",
  "TIDEWAVES": "TIDEWAVE, a tide regarded as a wave passing round the earth [n]\n",
  "TIDEWAY": "a channel in which the tide sets [n -S]\n",
  "TIDEWAYS": "TIDEWAY, a channel in which the tide sets [n]\n",
  "TIDIED": "TIDY, to make tidy [v]\n",
  "TIDIER": "one who tidies [n -S]\n",
  "TIDIERS": "TIDIER, one who tidies [n]\n",
  "TIDIES": "TIDY, to make tidy [v]\n",
  "TIDIEST": "TIDY, in good order [adj]\n",
  "TIDILY": "TIDY, in good order [adv]\n",
  "TIDINESS": "the state of being tidy [n -ES]\n",
  "TIDINESSES": "TIDINESS, the state of being tidy [n]\n",
  "TIDING": "a piece of news [n -S]\n",
  "TIDINGS": "TIDING, a piece of news [n]\n",
  "TIDIVATE": "to smarten up [v TIDIVATED, TIDIVATING, TIDIVATES]\n",
  "TIDIVATED": "TIDIVATE, to smarten up [v]\n",
  "TIDIVATES": "TIDIVATE, to smarten up [v]\n",
  "TIDIVATING": "TIDIVATE, to smarten up [v]\n",
  "TIDIVATION": "(slang) smartening up, also TITIVATION, TITTIVATION [n -S]\n",
  "TIDIVATIONS": "TIDIVATION, (slang) smartening up, also TITIVATION, TITTIVATION [n]\n",
  "TIDS": "TID, (Scots) a mood, state of mind [n]\n",
  "TIDY": "in good order [adj TIDIER, TIDIEST, TIDILY] / to make tidy [v TIDIED, TIDYING, TIDIES]\n",
  "TIDYING": "TIDY, to make tidy [v]\n",
  "TIDYTIPS": "a California composite plant, the flower of which has yellow rays tipped with white [n TIDYTIPS]\n",
  "TIE": "to fasten [v TIED, TIEING or TYING, TIES]\n",
  "TIEBACK": "a loop for holding a curtain to one side [n -S]\n",
  "TIEBACKS": "TIEBACK, a loop for holding a curtain to one side [n]\n",
  "TIEBREAK": "a contest to select a winner from among contestants with a tied score [n -S]\n",
  "TIEBREAKER": "a deciding game in a set at tennis [n -S]\n",
  "TIEBREAKERS": "TIEBREAKER, a deciding game in a set at tennis [n]\n",
  "TIEBREAKS": "TIEBREAK, a contest to select a winner from among contestants with a tied score [n]\n",
  "TIECLASP": "a clasp for securing a necktie [n -S]\n",
  "TIECLASPS": "TIECLASP, a clasp for securing a necktie [n]\n",
  "TIED": "TIE, to fasten [v]\n",
  "TIEING": "TIE, to fasten [v]\n",
  "TIELESS": "without a necktie [adj]\n",
  "TIEMANNITE": "a kind of mineral, mercuric selenide [n -S]\n",
  "TIEMANNITES": "TIEMANNITE, a kind of mineral, mercuric selenide [n]\n",
  "TIEPIN": "a pin for holding a necktie [n -S]\n",
  "TIEPINS": "TIEPIN, a pin for holding a necktie [n]\n",
  "TIER": "to arrange in rows [v -ED, -ING, -S]\n",
  "TIERCE": "a period for prayer and devotion, also TERCE [n -S]\n",
  "TIERCED": "divided into three equal parts [adj]\n",
  "TIERCEL": "a male hawk, also TARCEL, TARSAL, TARSEL, TASSELL, TERCEL [n -S]\n",
  "TIERCELET": "the male of various falcons, esp. of the peregrine, also TERCELET [n -S]\n",
  "TIERCELETS": "TIERCELET, the male of various falcons, esp. of the peregrine, also TERCELET [n]\n",
  "TIERCELS": "TIERCEL, a male hawk, also TARCEL, TARSAL, TARSEL, TASSELL, TERCEL [n]\n",
  "TIERCERON": "a subordinate rib springing from the intersection of two other ribs [n -S]\n",
  "TIERCERONS": "TIERCERON, a subordinate rib springing from the intersection of two other ribs [n]\n",
  "TIERCES": "TIERCE, a period for prayer and devotion, also TERCE [n]\n",
  "TIERCET": "(Italian) a triplet of lines that rhyme together or are connected with adjacent rhymes, also TERCET, TERZETTA [n -S]\n",
  "TIERCETS": "TIERCET, (Italian) a triplet of lines that rhyme together or are connected with adjacent rhymes, also TERCET, TERZETTA [n]\n",
  "TIERED": "TIER, to arrange in rows [v]\n",
  "TIERING": "TIER, to arrange in rows [v]\n",
  "TIERS": "TIER, to arrange in rows [v]\n",
  "TIES": "TIE, to fasten [v]\n",
  "TIETAC": "a tie clip, also TIETACK [n -S]\n",
  "TIETACK": "a tie clip, also TIETAC [n -S]\n",
  "TIETACKS": "TIETACK, a tie clip, also TIETAC [n]\n",
  "TIETACS": "TIETAC, a tie clip, also TIETACK [n]\n",
  "TIFF": "to have a petty quarrel [v -ED, -ING, -S]\n",
  "TIFFANIES": "TIFFANY, a thin, mesh fabric [n]\n",
  "TIFFANY": "a thin, mesh fabric [n TIFFANIES]\n",
  "TIFFED": "TIFF, to have a petty quarrel [v]\n",
  "TIFFIN": "to take lunch [v -ED, -ING, -S]\n",
  "TIFFINED": "TIFFIN, to take lunch [v]\n",
  "TIFFING": "lunch; a light meal, also TIFFIN [n -S]\n",
  "TIFFINGS": "TIFFING, lunch; a light meal, also TIFFIN [n]\n",
  "TIFFINING": "TIFFIN, to take lunch [v]\n",
  "TIFFINS": "TIFFIN, to take lunch [v]\n",
  "TIFFS": "TIFF, to have a petty quarrel [v]\n",
  "TIFO": "an elaborate organized display performed by supporters during a football match [n -S]\n",
  "TIFOS": "TIFO, an elaborate organized display performed by supporters during a football match [n]\n",
  "TIFOSI": "TIFOSO, (Italian) a fan or devotee of some sport [n]\n",
  "TIFOSO": "(Italian) a fan or devotee of some sport [n TIFOSI or TIFOSOS]\n",
  "TIFOSOS": "TIFOSO, (Italian) a fan or devotee of some sport [n]\n",
  "TIFT": "(Scots) to quarrel, be in a huff [v -ED, -ING, -S]\n",
  "TIFTED": "TIFT, (Scots) to quarrel, be in a huff [v]\n",
  "TIFTING": "TIFT, (Scots) to quarrel, be in a huff [v]\n",
  "TIFTS": "TIFT, (Scots) to quarrel, be in a huff [v]\n",
  "TIG": "to touch [v TIGGED, TIGGING, TIGS]\n",
  "TIGE": "(French) the shaft of a column [n -S]\n",
  "TIGER": "a fierce, striped Asiatic animal [n -S]\n",
  "TIGEREYE": "a gemstone, a golden brown striped form of quartz [n -S]\n",
  "TIGEREYES": "TIGEREYE, a gemstone, a golden brown striped form of quartz [n]\n",
  "TIGERIER": "TIGERY, like a tiger [adj]\n",
  "TIGERIEST": "TIGERY, like a tiger [adj]\n",
  "TIGERISH": "like a tiger [adj TIGERISHLY]\n",
  "TIGERISHLY": "TIGERISH, like a tiger [adv]\n",
  "TIGERISHNESS": "the state of being tigerish [n -ES]\n",
  "TIGERISHNESSES": "TIGERISHNESS, the state of being tigerish [n]\n",
  "TIGERISM": "swagger [n -S]\n",
  "TIGERISMS": "TIGERISM, swagger [n]\n",
  "TIGERLIER": "TIGERLY, having the manner of a tiger [adj]\n",
  "TIGERLIEST": "TIGERLY, having the manner of a tiger [adj]\n",
  "TIGERLIKE": "like a tiger [adj]\n",
  "TIGERLY": "having the manner of a tiger [adj TIGERLIER, TIGERLIEST]\n",
  "TIGERS": "TIGER, a fierce, striped Asiatic animal [n]\n",
  "TIGERWOOD": "any of several showy black-striped woods used in cabinetmaking [n -S]\n",
  "TIGERWOODS": "TIGERWOOD, any of several showy black-striped woods used in cabinetmaking [n]\n",
  "TIGERY": "like a tiger [adj TIGERIER, TIGERIEST]\n",
  "TIGES": "TIGE, (French) the shaft of a column [n]\n",
  "TIGGED": "TIG, to touch [v]\n",
  "TIGGER": "to damage (electronic equipment) beyond repair, esp. as a result of tinkering [v -ED, -ING, -S]\n",
  "TIGGERED": "TIGGER, to damage (electronic equipment) beyond repair, esp. as a result of tinkering [v]\n",
  "TIGGERING": "TIGGER, to damage (electronic equipment) beyond repair, esp. as a result of tinkering [v]\n",
  "TIGGERS": "TIGGER, to damage (electronic equipment) beyond repair, esp. as a result of tinkering [v]\n",
  "TIGGING": "TIG, to touch [v]\n",
  "TIGGYWINKLE": "(dialect) a hedgehog [n -S]\n",
  "TIGGYWINKLES": "TIGGYWINKLE, (dialect) a hedgehog [n]\n",
  "TIGHT": "firmly or closely fixed in place [adj TIGHTER, TIGHTEST, TIGHTLY]\n",
  "TIGHTASS": "(colloquial) an inhibited or excessively self-controlled person [n -ES]\n",
  "TIGHTASSED": "inhibited or excessively self-controlled [adj]\n",
  "TIGHTASSES": "TIGHTASS, (colloquial) an inhibited or excessively self-controlled person [n]\n",
  "TIGHTEN": "to make tight [v -ED, -ING, -S]\n",
  "TIGHTENED": "TIGHTEN, to make tight [v]\n",
  "TIGHTENER": "something that serves to tighten [n -S]\n",
  "TIGHTENERS": "TIGHTENER, something that serves to tighten [n]\n",
  "TIGHTENING": "the act of making tight [n -S]\n",
  "TIGHTENINGS": "TIGHTENING, the act of making tight [n]\n",
  "TIGHTENS": "TIGHTEN, to make tight [v]\n",
  "TIGHTER": "TIGHT, firmly or closely fixed in place [adj]\n",
  "TIGHTEST": "TIGHT, firmly or closely fixed in place [adj]\n",
  "TIGHTFISTED": "reluctant to part with money [adj]\n",
  "TIGHTFISTEDNESS": "the state of being tightfisted [n]\n",
  "TIGHTISH": "somewhat tight [adj TIGHTISHLY]\n",
  "TIGHTISHLY": "TIGHTISH, somewhat tight [adv]\n",
  "TIGHTKNIT": "closely integrated [adj]\n",
  "TIGHTLY": "TIGHT, firmly or closely fixed in place [adv]\n",
  "TIGHTNESS": "the state of being tight [n -ES]\n",
  "TIGHTNESSES": "TIGHTNESS, the state of being tight [n]\n",
  "TIGHTROPE": "a taut rope or wire on which feats of balancing and acrobatics are performed [n -S]\n",
  "TIGHTROPES": "TIGHTROPE, a taut rope or wire on which feats of balancing and acrobatics are performed [n]\n",
  "TIGHTS": "a close-fitting garment [n]\n",
  "TIGHTWAD": "a stingy person [n -S]\n",
  "TIGHTWADS": "TIGHTWAD, a stingy person [n]\n",
  "TIGHTWIRE": "a wire tightrope [n -S]\n",
  "TIGHTWIRES": "TIGHTWIRE, a wire tightrope [n]\n",
  "TIGLIC": "as in tiglic acid [adj]\n",
  "TIGLON": "the offspring of a male tiger and a female lion, also TIGON [n -S]\n",
  "TIGLONS": "TIGLON, the offspring of a male tiger and a female lion, also TIGON [n]\n",
  "TIGNON": "a piece of cloth worn as a headdress in Louisiana [n -S]\n",
  "TIGNONS": "TIGNON, a piece of cloth worn as a headdress in Louisiana [n]\n",
  "TIGON": "the offspring of a male tiger and a female lion, also TIGLON [n -S]\n",
  "TIGONS": "TIGON, the offspring of a male tiger and a female lion, also TIGLON [n]\n",
  "TIGRESS": "a female tiger [n -ES]\n",
  "TIGRESSES": "TIGRESS, a female tiger [n]\n",
  "TIGRIDIA": "a tropical American plant with colourful flowers [n -S]\n",
  "TIGRIDIAS": "TIGRIDIA, a tropical American plant with colourful flowers [n]\n",
  "TIGRINE": "like a tiger [adj]\n",
  "TIGRISH": "resembling a tiger, also TIGERISH [adj TIGRISHLY]\n",
  "TIGRISHLY": "TIGRISH, resembling a tiger, also TIGERISH [adv]\n",
  "TIGRISHNESS": "the quality of being like a tiger [n -ES]\n",
  "TIGRISHNESSES": "TIGRISHNESS, the quality of being like a tiger [n]\n",
  "TIGROID": "like a tiger [adj]\n",
  "TIGS": "TIG, to touch [v]\n",
  "TIK": "(South African) the drug methamphetamine in crystal form [n -S]\n",
  "TIKA": "(Hindi) a red mark or pendant on the forehead of Hindu women, originally of religious significance but now also worn for ornament, also TILAK [n -S]\n",
  "TIKANGA": "(Maori) usage or custom [n -S]\n",
  "TIKANGAS": "TIKANGA, (Maori) usage or custom [n]\n",
  "TIKAS": "TIKA, (Hindi) a red mark or pendant on the forehead of Hindu women, originally of religious significance but now also worn for ornament, also TILAK [n]\n",
  "TIKE": "a dog, a cur, also TYKE [n -S]\n",
  "TIKES": "TIKE, a dog, a cur, also TYKE [n]\n",
  "TIKI": "(Maori) to take a scenic tour round an area [v TIKIED, TIKIING, TIKIS]\n",
  "TIKIED": "TIKI, (Maori) to take a scenic tour round an area [v]\n",
  "TIKIING": "TIKI, (Maori) to take a scenic tour round an area [v]\n",
  "TIKINAGAN": "(Native American) a thin board to which an infant is strapped so that it can be transported on its mother's back [n -S]\n",
  "TIKINAGANS": "TIKINAGAN, (Native American) a thin board to which an infant is strapped so that it can be transported on its mother's back [n]\n",
  "TIKIS": "TIKI, (Maori) to take a scenic tour round an area [v]\n",
  "TIKKA": "(Hindi) a dish of meat or vegetables marinated in yoghurt and spices [n -S]\n",
  "TIKKAS": "TIKKA, (Hindi) a dish of meat or vegetables marinated in yoghurt and spices [n]\n",
  "TIKOLOSHE": "(Zulu) in Bantu folklore, a hairy malevolent dwarflike creature with supernatural powers, also TOKOLOSHE, TOKOLOSHI [n -S]\n",
  "TIKOLOSHES": "TIKOLOSHE, (Zulu) in Bantu folklore, a hairy malevolent dwarflike creature with supernatural powers, also TOKOLOSHE, TOKOLOSHI [n]\n",
  "TIKS": "TIK, (South African) the drug methamphetamine in crystal form [n]\n",
  "TIKTAALIK": "(Inuit) any of a genus of extinct lobe-finned fish from the late Devonian period [n -S]\n",
  "TIKTAALIKS": "TIKTAALIK, (Inuit) any of a genus of extinct lobe-finned fish from the late Devonian period [n]\n",
  "TIL": "the sesame plant, also TEEL [n -S]\n",
  "TILAK": "(Hindi) a red mark or pendant on the forehead of Hindu women, originally of religious significance but now also worn for ornament, also TIKA [n -S]\n",
  "TILAKS": "TILAK, (Hindi) a red mark or pendant on the forehead of Hindu women, originally of religious significance but now also worn for ornament, also TIKA [n]\n",
  "TILAPIA": "any member of an African freshwater fish genus [n -S]\n",
  "TILAPIAS": "TILAPIA, any member of an African freshwater fish genus [n]\n",
  "TILBURIES": "TILBURY, a carriage having two wheels [n]\n",
  "TILBURY": "a carriage having two wheels [n TILBURIES]\n",
  "TILDE": "(Spanish) the diacritical sign used over n in Spanish to indicate the sound ny [n -S]\n",
  "TILDES": "TILDE, (Spanish) the diacritical sign used over n in Spanish to indicate the sound ny [n]\n",
  "TILE": "to cover with thin slabs of baked clay [v TILED, TILING, TILES]\n",
  "TILED": "TILE, to cover with thin slabs of baked clay [v]\n",
  "TILEFISH": "a marine food fish [n -ES]\n",
  "TILEFISHES": "TILEFISH, a marine food fish [n]\n",
  "TILELIKE": "like a tile [adj]\n",
  "TILER": "a maker or layer of tiles, also TYLER [n -S]\n",
  "TILERIES": "TILERY, a tile factory [n]\n",
  "TILERS": "TILER, a maker or layer of tiles, also TYLER [n]\n",
  "TILERY": "a tile factory [n TILERIES]\n",
  "TILES": "TILE, to cover with thin slabs of baked clay [v]\n",
  "TILIACEOUS": "belonging to the linden family [adj]\n",
  "TILING": "a surface of tiles [n -S]\n",
  "TILINGS": "TILING, a surface of tiles [n]\n",
  "TILL": "to prepare land for crops by ploughing [v -ED, -ING, -S]\n",
  "TILLABLE": "able to be tilled [adj]\n",
  "TILLAGE": "the operation of tilling, preparing land for seed [n -S]\n",
  "TILLAGES": "TILLAGE, the operation of tilling, preparing land for seed [n]\n",
  "TILLANDSIA": "(Swedish) any plant of the mainly epiphytic tropical American genus Tillandsia of the pineapple family [n -S]\n",
  "TILLANDSIAS": "TILLANDSIA, (Swedish) any plant of the mainly epiphytic tropical American genus Tillandsia of the pineapple family [n]\n",
  "TILLED": "TILL, to prepare land for crops by ploughing [v]\n",
  "TILLER": "to put forth stems from a root, also TELLAR, TELLER [v -ED, -ING, -S]\n",
  "TILLERED": "TILLER, to put forth stems from a root, also TELLAR, TELLER [v]\n",
  "TILLERING": "the production of a shoot from a tree-stump [n -S]\n",
  "TILLERINGS": "TILLERING, the production of a shoot from a tree-stump [n]\n",
  "TILLERLESS": "without a tiller [adj]\n",
  "TILLERMAN": "one who operates a tiller [n TILLERMEN]\n",
  "TILLERMEN": "TILLERMAN, one who operates a tiller [n]\n",
  "TILLERS": "TILLER, to put forth stems from a root, also TELLAR, TELLER [v]\n",
  "TILLICUM": "(Native American) a friend [n -S]\n",
  "TILLICUMS": "TILLICUM, (Native American) a friend [n]\n",
  "TILLIER": "TILLY, of or like till, a stiff impervious clay [adj]\n",
  "TILLIEST": "TILLY, of or like till, a stiff impervious clay [adj]\n",
  "TILLING": "cultivation [n -S]\n",
  "TILLINGS": "TILLING, cultivation [n]\n",
  "TILLITE": "a stiff impervious clay [n -S]\n",
  "TILLITES": "TILLITE, a stiff impervious clay [n]\n",
  "TILLS": "TILL, to prepare land for crops by ploughing [v]\n",
  "TILLY": "of or like till, a stiff impervious clay [adj TILLIER, TILLIEST]\n",
  "TILS": "TIL, the sesame plant, also TEEL [n]\n",
  "TILT": "to cause to slant [v -ED, -ING, -S]\n",
  "TILTABLE": "able to be tilted [adj]\n",
  "TILTED": "TILT, to cause to slant [v]\n",
  "TILTER": "one who tilts, or jousts [n -S]\n",
  "TILTERS": "TILTER, one who tilts, or jousts [n]\n",
  "TILTH": "cultivated land [n -S]\n",
  "TILTHS": "TILTH, cultivated land [n]\n",
  "TILTING": "the act of leaning [n -S]\n",
  "TILTINGS": "TILTING, the act of leaning [n]\n",
  "TILTMETER": "an instrument for measuring tilting of earth's surface [n -S]\n",
  "TILTMETERS": "TILTMETER, an instrument for measuring tilting of earth's surface [n]\n",
  "TILTROTOR": "an aircraft with rotors that can be tilted [n -S]\n",
  "TILTROTORS": "TILTROTOR, an aircraft with rotors that can be tilted [n]\n",
  "TILTS": "TILT, to cause to slant [v]\n",
  "TILTYARD": "an area for jousting [n -S]\n",
  "TILTYARDS": "TILTYARD, an area for jousting [n]\n",
  "TIMARAU": "(Tagalog) a small buffalo of the Philippines, also TAMARAU, TAMARAO [n -S]\n",
  "TIMARAUS": "TIMARAU, (Tagalog) a small buffalo of the Philippines, also TAMARAU, TAMARAO [n]\n",
  "TIMARIOT": "(historical) a Turkish feudal militiaman [n -S]\n",
  "TIMARIOTS": "TIMARIOT, (historical) a Turkish feudal militiaman [n]\n",
  "TIMBAL": "(archaic) a kind of kettledrum, also TYMBAL [n -S]\n",
  "TIMBALE": "(French) a dish of meat, fish etc. cooked in a cup-shaped mould or shell [n -S]\n",
  "TIMBALES": "TIMBALE, (French) a dish of meat, fish etc. cooked in a cup-shaped mould or shell [n]\n",
  "TIMBALS": "TIMBAL, (archaic) a kind of kettledrum, also TYMBAL [n]\n",
  "TIMBER": "to furnish with wood [v -ED, -ING, -S]\n",
  "TIMBERDOODLE": "the North American woodcock [n -S]\n",
  "TIMBERDOODLES": "TIMBERDOODLE, the North American woodcock [n]\n",
  "TIMBERED": "TIMBER, to furnish with wood [v]\n",
  "TIMBERHEAD": "top end of ship's timber used above the gunwale [n -S]\n",
  "TIMBERHEADS": "TIMBERHEAD, top end of ship's timber used above the gunwale [n]\n",
  "TIMBERIER": "TIMBERY, like timber [adj]\n",
  "TIMBERIEST": "TIMBERY, like timber [adj]\n",
  "TIMBERING": "timber collectively; work in timber [n -S]\n",
  "TIMBERINGS": "TIMBERING, timber collectively; work in timber [n]\n",
  "TIMBERLAND": "(US) land covered with trees used for timber [n -S]\n",
  "TIMBERLANDS": "TIMBERLAND, (US) land covered with trees used for timber [n]\n",
  "TIMBERLINE": "the upper limit of timber trees on a mountain [n -S]\n",
  "TIMBERLINES": "TIMBERLINE, the upper limit of timber trees on a mountain [n]\n",
  "TIMBERMAN": "a man employed in placing supports of timber in a mine [n TIMBERMEN]\n",
  "TIMBERMEN": "TIMBERMAN, a man employed in placing supports of timber in a mine [n]\n",
  "TIMBERS": "TIMBER, to furnish with wood [v]\n",
  "TIMBERWORK": "work made of timbers [n -S]\n",
  "TIMBERWORKS": "TIMBERWORK, work made of timbers [n]\n",
  "TIMBERY": "like timber [adj TIMBERIER, TIMBERIEST]\n",
  "TIMBERYARD": "a yard where wood is stored [n -S]\n",
  "TIMBERYARDS": "TIMBERYARD, a yard where wood is stored [n]\n",
  "TIMBO": "a South American climbing plant [n -S]\n",
  "TIMBOS": "TIMBO, a South American climbing plant [n]\n",
  "TIMBRAL": "relating to timbre [adj]\n",
  "TIMBRE": "the quality given to a sound by its overtones, also TAMBER [n -S]\n",
  "TIMBREL": "(historical) an Oriental tabor or tambourine [n -S]\n",
  "TIMBRELLED": "sung to the accompaniment of the timbrel [adj]\n",
  "TIMBRELS": "TIMBREL, (historical) an Oriental tabor or tambourine [n]\n",
  "TIMBRES": "TIMBRE, the quality given to a sound by its overtones, also TAMBER [n]\n",
  "TIMBROLOGIES": "TIMBROLOGY, the study of postage stamps [n]\n",
  "TIMBROLOGIST": "a collector of stamps [n -S]\n",
  "TIMBROLOGISTS": "TIMBROLOGIST, a collector of stamps [n]\n",
  "TIMBROLOGY": "the study of postage stamps [n TIMBROLOGIES]\n",
  "TIMBROMANIA": "a craze for stamp collecting [n -S]\n",
  "TIMBROMANIAC": "an avid stamp collector [n -S]\n",
  "TIMBROMANIACS": "TIMBROMANIAC, an avid stamp collector [n]\n",
  "TIMBROMANIAS": "TIMBROMANIA, a craze for stamp collecting [n]\n",
  "TIMBROPHILIES": "TIMBROPHILY, the love of stamps [n]\n",
  "TIMBROPHILIST": "a stamp-collector [n -S]\n",
  "TIMBROPHILISTS": "TIMBROPHILIST, a stamp-collector [n]\n",
  "TIMBROPHILY": "the love of stamps [n TIMBROPHILIES]\n",
  "TIME": "to reckon the speed or duration of [v TIMED, TIMING, TIMES]\n",
  "TIMEBOMB": "a (literal or figurative) bomb designed to go off at a later time [n -S]\n",
  "TIMEBOMBS": "TIMEBOMB, a (literal or figurative) bomb designed to go off at a later time [n]\n",
  "TIMECARD": "a card for recording an employee's time of arrival and departure [n -S]\n",
  "TIMECARDS": "TIMECARD, a card for recording an employee's time of arrival and departure [n]\n",
  "TIMED": "TIME, to reckon the speed or duration of [v]\n",
  "TIMEFRAME": "a limited or restricted period of time [n -S]\n",
  "TIMEFRAMES": "TIMEFRAME, a limited or restricted period of time [n]\n",
  "TIMEKEEPER": "a timepiece [n -S]\n",
  "TIMEKEEPERS": "TIMEKEEPER, a timepiece [n]\n",
  "TIMEKEEPING": "keeping punctual time [n -S]\n",
  "TIMEKEEPINGS": "TIMEKEEPING, keeping punctual time [n]\n",
  "TIMELESS": "having no beginning or end [adj TIMELESSLY]\n",
  "TIMELESSLY": "TIMELESS, having no beginning or end [adv]\n",
  "TIMELESSNESS": "the state of being timeless [n -ES]\n",
  "TIMELESSNESSES": "TIMELESSNESS, the state of being timeless [n]\n",
  "TIMELIER": "TIMELY, occurring at the right moment [adj]\n",
  "TIMELIEST": "TIMELY, occurring at the right moment [adj]\n",
  "TIMELINE": "a schedule of events [n -S]\n",
  "TIMELINES": "TIMELINE, a schedule of events [n]\n",
  "TIMELINESS": "the state of being timely [n -ES]\n",
  "TIMELINESSES": "TIMELINESS, the state of being timely [n]\n",
  "TIMELY": "occurring at the right moment [adj TIMELIER, TIMELIEST]\n",
  "TIMENOGUY": "a rope stretched from place to place on a ship; a makeshift [n -S]\n",
  "TIMENOGUYS": "TIMENOGUY, a rope stretched from place to place on a ship; a makeshift [n]\n",
  "TIMEOUS": "timely; seasonable, also TIMOUS [adj]\n",
  "TIMEOUSLY": "TIMEOUS, timely; seasonable, also TIMOUS [adv]\n",
  "TIMEOUT": "a brief suspension of activity [n -S]\n",
  "TIMEOUTS": "TIMEOUT, a brief suspension of activity [n]\n",
  "TIMEPASS": "to pass time [v -ED, -ING, -ES]\n",
  "TIMEPASSED": "TIMEPASS, to pass time [v]\n",
  "TIMEPASSES": "TIMEPASS, to pass time [v]\n",
  "TIMEPASSING": "TIMEPASS, to pass time [v]\n",
  "TIMEPIECE": "any kind of clock [n -S]\n",
  "TIMEPIECES": "TIMEPIECE, any kind of clock [n]\n",
  "TIMEPLEASER": "(Shakespeare) a timeserver [n -S]\n",
  "TIMEPLEASERS": "TIMEPLEASER, (Shakespeare) a timeserver [n]\n",
  "TIMER": "one that times [n -S]\n",
  "TIMERS": "TIMER, one that times [n]\n",
  "TIMES": "TIME, to reckon the speed or duration of [v]\n",
  "TIMESAVER": "something that saves time [n -S]\n",
  "TIMESAVERS": "TIMESAVER, something that saves time [n]\n",
  "TIMESAVING": "that saves time e.g. of a device [adj]\n",
  "TIMESCALE": "the period within which something happens or is to happen [n -S]\n",
  "TIMESCALES": "TIMESCALE, the period within which something happens or is to happen [n]\n",
  "TIMESERVER": "a person who cynically or servilely suits his or her opinions to the times or those in authority for the time [n -S]\n",
  "TIMESERVERS": "TIMESERVER, a person who cynically or servilely suits his or her opinions to the times or those in authority for the time [n]\n",
  "TIMESERVING": "the behavior or practice of a timeserver [n -S]\n",
  "TIMESERVINGS": "TIMESERVING, the behavior or practice of a timeserver [n]\n",
  "TIMESHARE": "the time-sharing of property, etc.; such a property [n -S]\n",
  "TIMESHARES": "TIMESHARE, the time-sharing of property, etc.; such a property [n]\n",
  "TIMESHIFT": "to enable (a television programme) to be viewed at a time later than that of its original broadcast [v -ED, -ING, -S]\n",
  "TIMESHIFTED": "TIMESHIFT, to enable (a television programme) to be viewed at a time later than that of its original broadcast [v]\n",
  "TIMESHIFTING": "TIMESHIFT, to enable (a television programme) to be viewed at a time later than that of its original broadcast [v]\n",
  "TIMESHIFTS": "TIMESHIFT, to enable (a television programme) to be viewed at a time later than that of its original broadcast [v]\n",
  "TIMESTAMP": "(of a computer) to add a record of the time of an event or transaction to (data) [v -ED, -ING, -S]\n",
  "TIMESTAMPED": "TIMESTAMP, (of a computer) to add a record of the time of an event or transaction to (data) [v]\n",
  "TIMESTAMPING": "TIMESTAMP, (of a computer) to add a record of the time of an event or transaction to (data) [v]\n",
  "TIMESTAMPS": "TIMESTAMP, (of a computer) to add a record of the time of an event or transaction to (data) [v]\n",
  "TIMETABLE": "to draw up a schedule of events for [v TIMETABLED, TIMETABLING, TIMETABLES]\n",
  "TIMETABLED": "TIMETABLE, to draw up a schedule of events for [v]\n",
  "TIMETABLES": "TIMETABLE, to draw up a schedule of events for [v]\n",
  "TIMETABLING": "the act of prescribing a timetable [n -S]\n",
  "TIMETABLINGS": "TIMETABLING, the act of prescribing a timetable [n]\n",
  "TIMEWORK": "work paid for by the hour or day [n -S]\n",
  "TIMEWORKER": "one who does timework [n -S]\n",
  "TIMEWORKERS": "TIMEWORKER, one who does timework [n]\n",
  "TIMEWORKS": "TIMEWORK, work paid for by the hour or day [n]\n",
  "TIMEWORN": "showing the effects of long use or wear [adj]\n",
  "TIMID": "lacking courage or self-confidence [adj TIMIDER, TIMIDEST, TIMIDLY]\n",
  "TIMIDER": "TIMID, lacking courage or self-confidence [adj]\n",
  "TIMIDEST": "TIMID, lacking courage or self-confidence [adj]\n",
  "TIMIDITIES": "TIMIDITY, the quality of being timid [n]\n",
  "TIMIDITY": "the quality of being timid [n TIMIDITIES]\n",
  "TIMIDLY": "TIMID, lacking courage or self-confidence [adv]\n",
  "TIMIDNESS": "the state of being timid [n -ES]\n",
  "TIMIDNESSES": "TIMIDNESS, the state of being timid [n]\n",
  "TIMING": "the selection of the right moment [n -S]\n",
  "TIMINGS": "TIMING, the selection of the right moment [n]\n",
  "TIMIST": "a performer who keeps good time [n -S]\n",
  "TIMISTS": "TIMIST, a performer who keeps good time [n]\n",
  "TIMOCRACIES": "TIMOCRACY, a state in which possession of property is required for participation in government [n]\n",
  "TIMOCRACY": "a state in which possession of property is required for participation in government [n TIMOCRACIES]\n",
  "TIMOCRATIC": "relating to timocracy, also TIMOCRATICAL [adj]\n",
  "TIMOCRATICAL": "relating to timocracy, also TIMOCRATIC [adj]\n",
  "TIMOLOL": "a relaxant medicine used to treat blood pressure [n -S]\n",
  "TIMOLOLS": "TIMOLOL, a relaxant medicine used to treat blood pressure [n]\n",
  "TIMON": "(obsolete) a helm [n -S]\n",
  "TIMONEER": "a helmsman [n -S]\n",
  "TIMONEERS": "TIMONEER, a helmsman [n]\n",
  "TIMONS": "TIMON, (obsolete) a helm [n]\n",
  "TIMOROUS": "of a timid disposition, fearful [adj TIMOROUSLY]\n",
  "TIMOROUSLY": "TIMOROUS, of a timid disposition, fearful [adv]\n",
  "TIMOROUSNESS": "the quality of being timorous [n -ES]\n",
  "TIMOROUSNESSES": "TIMOROUSNESS, the quality of being timorous [n]\n",
  "TIMORSOME": "(dialect) easily frightened [adj]\n",
  "TIMOTHIES": "TIMOTHY, a European grass [n]\n",
  "TIMOTHY": "a European grass [n TIMOTHIES]\n",
  "TIMOUS": "timely; seasonable, also TIMEOUS [adj TIMOUSLY]\n",
  "TIMOUSLY": "TIMOUS, timely; seasonable, also TIMEOUS [adv]\n",
  "TIMPANA": "a traditional Maltese baked pasta and pastry dish [n -S]\n",
  "TIMPANAS": "TIMPANA, a traditional Maltese baked pasta and pastry dish [n]\n",
  "TIMPANI": "TIMPANO, (Italian) a kettledrum, also TYMPANO [n]\n",
  "TIMPANIST": "one who plays the timpani, also TYMPANIST [n -S]\n",
  "TIMPANISTS": "TIMPANIST, one who plays the timpani, also TYMPANIST [n]\n",
  "TIMPANO": "(Italian) a kettledrum, also TYMPANO [n TIMPANI]\n",
  "TIMPANUM": "(Latin) the space between an arch and the lintel of a portal, also TYMPANUM [n TIMPANA or TIMPANUMS]\n",
  "TIMPANUMS": "TIMPANUM, (Latin) the space between an arch and the lintel of a portal, also TYMPANUM [n]\n",
  "TIMPS": "(colloquial) timpani, small drums [n]\n",
  "TIN": "to coat with a metallic element [v TINNED, TINNING, TINS]\n",
  "TINA": "(slang) crystal meth [n -S]\n",
  "TINAJA": "(Spanish) a large earthenware jar used in Spain for storing wine [n -S]\n",
  "TINAJAS": "TINAJA, (Spanish) a large earthenware jar used in Spain for storing wine [n]\n",
  "TINAMOU": "(Caribbean) a South American game bird [n -S]\n",
  "TINAMOUS": "TINAMOU, (Caribbean) a South American game bird [n]\n",
  "TINAS": "TINA, (slang) crystal meth [n]\n",
  "TINCAL": "(Malay) a crude native borax, formerly imported from Tibet [n -S]\n",
  "TINCALS": "TINCAL, (Malay) a crude native borax, formerly imported from Tibet [n]\n",
  "TINCHEL": "(Gaelic) a circle of men who close in round a herd of deer [n -S]\n",
  "TINCHELS": "TINCHEL, (Gaelic) a circle of men who close in round a herd of deer [n]\n",
  "TINCT": "to stain, dye [v -ED, -ING, -S]\n",
  "TINCTED": "TINCT, to stain, dye [v]\n",
  "TINCTING": "TINCT, to stain, dye [v]\n",
  "TINCTORIAL": "of or relating to dyeing [adj TINCTORIALLY]\n",
  "TINCTORIALLY": "TINCTORIAL, of or relating to dyeing [adv]\n",
  "TINCTS": "TINCT, to stain, dye [v]\n",
  "TINCTURE": "to colour with a tincture [v TINCTURED, TINCTURING, TINCTURES]\n",
  "TINCTURED": "TINCTURE, to colour with a tincture [v]\n",
  "TINCTURES": "TINCTURE, to colour with a tincture [v]\n",
  "TINCTURING": "TINCTURE, to colour with a tincture [v]\n",
  "TIND": "to kindle, also TEEND [v TINDED, TYND or TYNDE, TINDING, TINDS]\n",
  "TINDAL": "(Malayalam) a petty officer of lascars [n -S]\n",
  "TINDALS": "TINDAL, (Malayalam) a petty officer of lascars [n]\n",
  "TINDED": "TIND, to kindle, also TEEND [v]\n",
  "TINDER": "dry inflammable matter [n -S]\n",
  "TINDERBOX": "a box for holding tinder [n -ES]\n",
  "TINDERBOXES": "TINDERBOX, a box for holding tinder [n]\n",
  "TINDERIER": "TINDERY, like tinder [adj]\n",
  "TINDERIEST": "TINDERY, like tinder [adj]\n",
  "TINDERS": "TINDER, dry inflammable matter [n]\n",
  "TINDERY": "like tinder [adj TINDERIER, TINDERIEST]\n",
  "TINDING": "TIND, to kindle, also TEEND [v]\n",
  "TINDS": "TIND, to kindle, also TEEND [v]\n",
  "TINE": "(Scots) to lose, also TYNE [v TINED, TINING, TINES]\n",
  "TINEA": "(Latin) a fungous skin disease [n -S]\n",
  "TINEAL": "relating to tinea, a name applied to various skin diseases, esp. ringworm [adj]\n",
  "TINEAS": "TINEA, (Latin) a fungous skin disease [n]\n",
  "TINED": "TINE, (Scots) to lose, also TYNE [v]\n",
  "TINEID": "one of a family of moths [n -S]\n",
  "TINEIDS": "TINEID, one of a family of moths [n]\n",
  "TINES": "TINE, (Scots) to lose, also TYNE [v]\n",
  "TINFOIL": "a thin metal sheeting [n -S]\n",
  "TINFOILS": "TINFOIL, a thin metal sheeting [n]\n",
  "TINFUL": "as much as a tin can hold [n -S]\n",
  "TINFULS": "TINFUL, as much as a tin can hold [n]\n",
  "TING": "to emit a high-pitched metallic sound [v -ED, -ING, -S]\n",
  "TINGE": "to colour slightly [v TINGED, TINGEING, TINGES]\n",
  "TINGED": "TINGE, to colour slightly [v]\n",
  "TINGEING": "TINGE, to colour slightly [v]\n",
  "TINGES": "TINGE, to colour slightly [v]\n",
  "TINGING": "TING, to emit a high-pitched metallic sound [v]\n",
  "TINGLE": "to cause a prickly, stinging sensation [v TINGLED, TINGLING, TINGLES]\n",
  "TINGLED": "TINGLE, to cause a prickly, stinging sensation [v]\n",
  "TINGLER": "a thing which causes tingling, esp. a smarting blow [n -S]\n",
  "TINGLERS": "TINGLER, a thing which causes tingling, esp. a smarting blow [n]\n",
  "TINGLES": "TINGLE, to cause a prickly, stinging sensation [v]\n",
  "TINGLIER": "TINGLY, tingling [adj]\n",
  "TINGLIEST": "TINGLY, tingling [adj]\n",
  "TINGLING": "mildly stinging [adj TINGLINGLY] / the act of tingling [n -S]\n",
  "TINGLINGLY": "TINGLING, mildly stinging [adv]\n",
  "TINGLINGS": "TINGLING, the act of tingling [n]\n",
  "TINGLISH": "thrilling [adj]\n",
  "TINGLY": "tingling [adj TINGLIER, TINGLIEST]\n",
  "TINGS": "TING, to emit a high-pitched metallic sound [v]\n",
  "TINGUAITE": "a fine-grained igneous rock composed essentially of feldspar, nepheline and aegirine [n -S]\n",
  "TINGUAITES": "TINGUAITE, a fine-grained igneous rock composed essentially of feldspar, nepheline and aegirine [n]\n",
  "TINHORN": "a showily pretentious person [n -S]\n",
  "TINHORNS": "TINHORN, a showily pretentious person [n]\n",
  "TINIER": "TINY, very small [adj]\n",
  "TINIES": "TINY, a small child [n]\n",
  "TINIEST": "TINY, very small [adj]\n",
  "TINILY": "TINY, very small [adv]\n",
  "TININESS": "the quality of being tiny [n -ES]\n",
  "TININESSES": "TININESS, the quality of being tiny [n]\n",
  "TINING": "TINE, (Scots) to lose, also TYNE [v]\n",
  "TINK": "to make a sharp, shrill noise; to tinkle [v -ED, -ING, -S]\n",
  "TINKED": "TINK, to make a sharp, shrill noise; to tinkle [v]\n",
  "TINKER": "to repair shoddily [v -ED, -ING, -S]\n",
  "TINKERED": "TINKER, to repair shoddily [v]\n",
  "TINKERER": "one who tinkers [n -S]\n",
  "TINKERERS": "TINKERER, one who tinkers [n]\n",
  "TINKERING": "the act of tinkering [n -S]\n",
  "TINKERINGS": "TINKERING, the act of tinkering [n]\n",
  "TINKERMAN": "a football manager or coach who continually experiments by changing the personnel or formation of a team from game to game [n TINKERMEN]\n",
  "TINKERMEN": "TINKERMAN, a football manager or coach who continually experiments by changing the personnel or formation of a team from game to game [n]\n",
  "TINKERS": "TINKER, to repair shoddily [v]\n",
  "TINKERTOY": "(tradename) a child's construction set [n -S]\n",
  "TINKERTOYS": "TINKERTOY, (tradename) a child's construction set [n]\n",
  "TINKING": "TINK, to make a sharp, shrill noise; to tinkle [v]\n",
  "TINKLE": "to make sharp, metallic sounds [v TINKLED, TINKLING, TINKLES]\n",
  "TINKLED": "TINKLE, to make sharp, metallic sounds [v]\n",
  "TINKLER": "an itinerant mender of kettles, pans, etc., also TINKER [n -S]\n",
  "TINKLERS": "TINKLER, an itinerant mender of kettles, pans, etc., also TINKER [n]\n",
  "TINKLES": "TINKLE, to make sharp, metallic sounds [v]\n",
  "TINKLIER": "TINKLY, producing a tinkling sound [adj]\n",
  "TINKLIEST": "TINKLY, producing a tinkling sound [adj]\n",
  "TINKLING": "the sound of something that tinkles [n -S]\n",
  "TINKLINGLY": "TINKLING [adv]\n",
  "TINKLINGS": "TINKLING, the sound of something that tinkles [n]\n",
  "TINKLY": "producing a tinkling sound [adj TINKLIER, TINKLIEST]\n",
  "TINKS": "TINK, to make a sharp, shrill noise; to tinkle [v]\n",
  "TINLIKE": "like tin [adj]\n",
  "TINMAN": "a worker in tin; a dresser of tin ore [n TINMEN]\n",
  "TINMEN": "TINMAN, a worker in tin; a dresser of tin ore [n]\n",
  "TINNED": "TIN, to coat with a metallic element [v]\n",
  "TINNER": "a tin miner [n -S]\n",
  "TINNERS": "TINNER, a tin miner [n]\n",
  "TINNIE": "a mug made of tinplate; a can of beer, also TINNY [n -S]\n",
  "TINNIER": "TINNY, making a noise like tin [adj]\n",
  "TINNIES": "TINNIE, a mug made of tinplate; a can of beer, also TINNY [n]\n",
  "TINNIEST": "TINNY, making a noise like tin [adj]\n",
  "TINNILY": "TINNY, making a noise like tin [adv]\n",
  "TINNINESS": "the state of being tinny [n -ES]\n",
  "TINNINESSES": "TINNINESS, the state of being tinny [n]\n",
  "TINNING": "the act of covering with tin [n -S]\n",
  "TINNINGS": "TINNING, the act of covering with tin [n]\n",
  "TINNITUS": "(Latin) a ringing sound in the ear [n -ES]\n",
  "TINNITUSES": "TINNITUS, (Latin) a ringing sound in the ear [n]\n",
  "TINNY": "making a noise like tin [adj TINNIER, TINNIEST, TINNILY] / a mug made of tinplate; a can of beer, also TINNIE [n TINNIES]\n",
  "TINPLATE": "to coat with tin [v TINPLATED, TINPLATING, TINPLATES]\n",
  "TINPLATED": "TINPLATE, to coat with tin [v]\n",
  "TINPLATES": "TINPLATE, to coat with tin [v]\n",
  "TINPLATING": "TINPLATE, to coat with tin [v]\n",
  "TINPOT": "the pot of molten tin into which a sheet of iron is dipped in the manufacture of tin plate [n -S]\n",
  "TINPOTS": "TINPOT, the pot of molten tin into which a sheet of iron is dipped in the manufacture of tin plate [n]\n",
  "TINS": "TIN, to coat with a metallic element [v]\n",
  "TINSEL": "to give a showy appearance to [v TINSELED or TINSELLED, TINSELING or TINSELLING, TINSELS]\n",
  "TINSELED": "TINSEL, to give a showy appearance to [v]\n",
  "TINSELIER": "TINSELY, of or like tinsel, also TINSELLY [adj]\n",
  "TINSELIEST": "TINSELY, of or like tinsel, also TINSELLY [adj]\n",
  "TINSELING": "TINSEL, to give a showy appearance to [v]\n",
  "TINSELLED": "TINSEL, to give a showy appearance to [v]\n",
  "TINSELLIER": "TINSELLY, of or like tinsel, also TINSELY [adj]\n",
  "TINSELLIEST": "TINSELLY, of or like tinsel, also TINSELY [adj]\n",
  "TINSELLING": "TINSEL, to give a showy appearance to [v]\n",
  "TINSELLY": "of or like tinsel, also TINSELY [adj TINSELLIER, TINSELLIEST]\n",
  "TINSELRIES": "TINSELRY, tawdry material [n]\n",
  "TINSELRY": "tawdry material [n TINSELRIES]\n",
  "TINSELS": "TINSEL, to give a showy appearance to [v]\n",
  "TINSELY": "of or like tinsel, also TINSELLY [adj TINSELIER, TINSELIEST]\n",
  "TINSEY": "(obsolete dialect) tinsel [n -S]\n",
  "TINSEYS": "TINSEY, (obsolete dialect) tinsel [n]\n",
  "TINSMITH": "one who works with tin [n -S]\n",
  "TINSMITHING": "the craft of the tinsmith [n -S]\n",
  "TINSMITHINGS": "TINSMITHING, the craft of the tinsmith [n]\n",
  "TINSMITHS": "TINSMITH, one who works with tin [n]\n",
  "TINSNIPS": "a pair of hand shears for cutting tin etc. [n]\n",
  "TINSTONE": "an ore of tin, cassiterite [n -S]\n",
  "TINSTONES": "TINSTONE, an ore of tin, cassiterite [n]\n",
  "TINT": "to colour slightly [v -ED, -ING, -S]\n",
  "TINTACK": "a tack coated with tin [n -S]\n",
  "TINTACKS": "TINTACK, a tack coated with tin [n]\n",
  "TINTED": "TINT, to colour slightly [v]\n",
  "TINTER": "a person or thing that tints [n -S]\n",
  "TINTERS": "TINTER, a person or thing that tints [n]\n",
  "TINTIER": "TINTY, unevenly tinted [adj]\n",
  "TINTIEST": "TINTY, unevenly tinted [adj]\n",
  "TINTINESS": "the state of being tinted [n -ES]\n",
  "TINTINESSES": "TINTINESS, the state of being tinted [n]\n",
  "TINTING": "the process of one that tints [n -S]\n",
  "TINTINGS": "TINTING, the process of one that tints [n]\n",
  "TINTINNABULA": "TINTINNABULUM, a usually high-pitched bell; a bell-rattle [n]\n",
  "TINTINNABULANT": "ringing, like a bell, also TINTINNABULAR, TINTINNABULARY [adj]\n",
  "TINTINNABULAR": "ringing, like a bell, also TINTINNABULANT, TINTINNABULARY [adj]\n",
  "TINTINNABULARY": "ringing, like a bell, also TINTINNABULANT, TINTINNABULAR [adj]\n",
  "TINTINNABULATE": "to ring; to tinkle [v TINTINNABULATED, TINTINNABULATES]\n",
  "TINTINNABULATED": "TINTINNABULATE, to ring; to tinkle [v]\n",
  "TINTINNABULATES": "TINTINNABULATE, to ring; to tinkle [v]\n",
  "TINTINNABULOUS": "relating to bell-ringing [adj]\n",
  "TINTINNABULUM": "a usually high-pitched bell; a bell-rattle [n TINTINNABULA]\n",
  "TINTLESS": "lacking colour [adj]\n",
  "TINTOMETER": "another name for colorimeter, an instrument for measuring and determining color [n -S]\n",
  "TINTOMETERS": "TINTOMETER, another name for colorimeter, an instrument for measuring and determining color [n]\n",
  "TINTOOKIE": "(Australian slang) a fawning or servile person [n -S]\n",
  "TINTOOKIES": "TINTOOKIE, (Australian slang) a fawning or servile person [n]\n",
  "TINTS": "TINT, to colour slightly [v]\n",
  "TINTY": "unevenly tinted [adj TINTIER, TINTIEST]\n",
  "TINTYPE": "a colloquial name for ferrotype, a photographic picture taken on an iron plate by a collodion process [n -S]\n",
  "TINTYPES": "TINTYPE, a colloquial name for ferrotype, a photographic picture taken on an iron plate by a collodion process [n]\n",
  "TINWARE": "articles made of tinplate [n -S]\n",
  "TINWARES": "TINWARE, articles made of tinplate [n]\n",
  "TINWORK": "something made of tin [n -S]\n",
  "TINWORKS": "TINWORK, something made of tin [n]\n",
  "TINY": "very small [adj TINIER, TINIEST, TINILY] / a small child [n TINIES]\n",
  "TIP": "to give a gratuity [v TIPPED or (obsolete) TIPT, TIPPING, TIPS]\n",
  "TIPCART": "a cart so constructed that the body can be easily tipped, in order to dump the load [n -S]\n",
  "TIPCARTS": "TIPCART, a cart so constructed that the body can be easily tipped, in order to dump the load [n]\n",
  "TIPCAT": "a game in which a small piece of wood pointed at both ends, called a cat, is tipped, or struck with a stick or bat, so as to fly into the air [n -S]\n",
  "TIPCATS": "TIPCAT, a game in which a small piece of wood pointed at both ends, called a cat, is tipped, or struck with a stick or bat, so as to fly into the air [n]\n",
  "TIPI": "(Native American) a conical tent, also TEEPEE, TEPEE [n -S]\n",
  "TIPIS": "TIPI, (Native American) a conical tent, also TEEPEE, TEPEE [n]\n",
  "TIPLESS": "having no point [adj]\n",
  "TIPOFF": "a piece of information, esp. leading to an arrest [n -S]\n",
  "TIPOFFS": "TIPOFF, a piece of information, esp. leading to an arrest [n]\n",
  "TIPPABLE": "capable of being tipped [adj]\n",
  "TIPPED": "TIP, to give a gratuity [v]\n",
  "TIPPEE": "a person who receives a tip about e.g. share prices [n -S]\n",
  "TIPPEES": "TIPPEE, a person who receives a tip about e.g. share prices [n]\n",
  "TIPPER": "one who tips [n -S]\n",
  "TIPPERS": "TIPPER, one who tips [n]\n",
  "TIPPET": "a long narrow piece of cloth formerly attached to a hood or sleeve, or worn loose around the neck [n -S]\n",
  "TIPPETS": "TIPPET, a long narrow piece of cloth formerly attached to a hood or sleeve, or worn loose around the neck [n]\n",
  "TIPPIER": "TIPPY, (slang) in the height of fashion [adj]\n",
  "TIPPIEST": "TIPPY, (slang) in the height of fashion [adj]\n",
  "TIPPING": "the act of tipping [n -S]\n",
  "TIPPINGS": "TIPPING, the act of tipping [n]\n",
  "TIPPLE": "to drink alcoholic beverages [v TIPPLED, TIPPLING, TIPPLES]\n",
  "TIPPLED": "TIPPLE, to drink alcoholic beverages [v]\n",
  "TIPPLER": "one who tipples, drinks alcohol constantly in small quantities [n -S]\n",
  "TIPPLERS": "TIPPLER, one who tipples, drinks alcohol constantly in small quantities [n]\n",
  "TIPPLES": "TIPPLE, to drink alcoholic beverages [v]\n",
  "TIPPLING": "TIPPLE, to drink alcoholic beverages [v]\n",
  "TIPPY": "(slang) in the height of fashion [adj TIPPIER, TIPPIEST]\n",
  "TIPPYTOE": "to walk on the tips of one's toes, also TIPTOE [v TIPPYTOED, TIPPYTOEING, TIPPYTOES]\n",
  "TIPPYTOED": "TIPPYTOE, to walk on the tips of one's toes, also TIPTOE [v]\n",
  "TIPPYTOEING": "TIPPYTOE, to walk on the tips of one's toes, also TIPTOE [v]\n",
  "TIPPYTOES": "TIPPYTOE, to walk on the tips of one's toes, also TIPTOE [v]\n",
  "TIPS": "TIP, to give a gratuity [v]\n",
  "TIPSHEET": "a publication with tips for betting on races or investing in stocks [n -S]\n",
  "TIPSHEETS": "TIPSHEET, a publication with tips for betting on races or investing in stocks [n]\n",
  "TIPSIER": "TIPSY, slightly drunk [adj]\n",
  "TIPSIEST": "TIPSY, slightly drunk [adj]\n",
  "TIPSIFIED": "TIPSIFY, to make tipsy [v]\n",
  "TIPSIFIES": "TIPSIFY, to make tipsy [v]\n",
  "TIPSIFY": "to make tipsy [v TIPSIFIED, TIPSIFYING, TIPSIFIES]\n",
  "TIPSIFYING": "TIPSIFY, to make tipsy [v]\n",
  "TIPSILY": "TIPSY, slightly drunk [adv]\n",
  "TIPSINESS": "the state of being tipsy [n -ES]\n",
  "TIPSINESSES": "TIPSINESS, the state of being tipsy [n]\n",
  "TIPSTAFF": "an attendant in a law court [n TIPSTAFFS or TIPSTAVES]\n",
  "TIPSTAFFS": "TIPSTAFF, an attendant in a law court [n]\n",
  "TIPSTAVES": "TIPSTAFF, an attendant in a law court [n]\n",
  "TIPSTER": "one who sells information to gamblers [n -S]\n",
  "TIPSTERS": "TIPSTER, one who sells information to gamblers [n]\n",
  "TIPSTOCK": "a part of a gun [n -S]\n",
  "TIPSTOCKS": "TIPSTOCK, a part of a gun [n]\n",
  "TIPSY": "slightly drunk [adj TIPSIER, TIPSIEST, TIPSILY]\n",
  "TIPT": "TIP, to give a gratuity [v]\n",
  "TIPTOE": "to walk on the tips of one's toes, also TIPPYTOE [v TIPTOED, TIPTOEING, TIPTOES]\n",
  "TIPTOED": "TIPTOE, to walk on the tips of one's toes, also TIPPYTOE [v]\n",
  "TIPTOEING": "TIPTOE, to walk on the tips of one's toes, also TIPPYTOE [v]\n",
  "TIPTOES": "TIPTOE, to walk on the tips of one's toes, also TIPPYTOE [v]\n",
  "TIPTOP": "the highest point [n -S]\n",
  "TIPTOPS": "TIPTOP, the highest point [n]\n",
  "TIPTRONIC": "a type of gearbox that has both manual and automatic options [n -S]\n",
  "TIPTRONICS": "TIPTRONIC, a type of gearbox that has both manual and automatic options [n]\n",
  "TIPULA": "(Latin) a cranefly [n -S]\n",
  "TIPULAS": "TIPULA, (Latin) a cranefly [n]\n",
  "TIPUNA": "(Maori) an ancestor, also TUPUNA [n -S]\n",
  "TIPUNAS": "TIPUNA, (Maori) an ancestor, also TUPUNA [n]\n",
  "TIRADE": "(French) a long vehement or angry harangue [n -S]\n",
  "TIRADES": "TIRADE, (French) a long vehement or angry harangue [n]\n",
  "TIRAGE": "drawing wine from a barrel before bottling [n -S]\n",
  "TIRAGES": "TIRAGE, drawing wine from a barrel before bottling [n]\n",
  "TIRAILLEUR": "(French) a skirmisher; a sharpshooter [n -S]\n",
  "TIRAILLEURS": "TIRAILLEUR, (French) a skirmisher; a sharpshooter [n]\n",
  "TIRAMISU": "(Italian) a dessert made with pieces of sponge soaked in coffee and marsala, layered with mascarpone and chocolate [n -S]\n",
  "TIRAMISUS": "TIRAMISU, (Italian) a dessert made with pieces of sponge soaked in coffee and marsala, layered with mascarpone and chocolate [n]\n",
  "TIRASSE": "(French) a pedal-coupler in an organ [n -S]\n",
  "TIRASSES": "TIRASSE, (French) a pedal-coupler in an organ [n]\n",
  "TIRE": "to grow tired [v TIRED, TIRING, TIRES]\n",
  "TIRED": "fatigued [adj TIREDER, TIREDEST, TIREDLY]\n",
  "TIREDER": "TIRED, fatigued [adj]\n",
  "TIREDEST": "TIRED, fatigued [adj]\n",
  "TIREDLY": "TIRED, fatigued [adv]\n",
  "TIREDNESS": "the state of being tired [n -ES]\n",
  "TIREDNESSES": "TIREDNESS, the state of being tired [n]\n",
  "TIRELESS": "seemingly incapable of tiring [adj TIRELESSLY]\n",
  "TIRELESSLY": "TIRELESS, seemingly incapable of tiring [adv]\n",
  "TIRELESSNESS": "the state of being tireless [n -ES]\n",
  "TIRELESSNESSES": "TIRELESSNESS, the state of being tireless [n]\n",
  "TIRELING": "a tired animal [n -S]\n",
  "TIRELINGS": "TIRELING, a tired animal [n]\n",
  "TIREMAKER": "one who makes tires [n -S]\n",
  "TIREMAKERS": "TIREMAKER, one who makes tires [n]\n",
  "TIRES": "TIRE, to grow tired [v]\n",
  "TIRESOME": "tedious [adj TIRESOMELY]\n",
  "TIRESOMELY": "TIRESOME, tedious [adv]\n",
  "TIRESOMENESS": "the state of being tiresome [n -ES]\n",
  "TIRESOMENESSES": "TIRESOMENESS, the state of being tiresome [n]\n",
  "TIREWOMAN": "a lady's maid [n TIREWOMEN]\n",
  "TIREWOMEN": "TIREWOMAN, a lady's maid [n]\n",
  "TIRING": "in falconry, a bony or tough portion of meat given to a bird to pull at for exercise [n -S]\n",
  "TIRINGS": "TIRING, in falconry, a bony or tough portion of meat given to a bird to pull at for exercise [n]\n",
  "TIRITI": "(Maori) a treaty, especially the Treaty of Waitangi [n -S]\n",
  "TIRITIS": "TIRITI, (Maori) a treaty, especially the Treaty of Waitangi [n]\n",
  "TIRL": "(Scots) to turn; to rattle, also DIRL, THIRL [v -ED, -ING, -S]\n",
  "TIRLED": "TIRL, (Scots) to turn; to rattle, also DIRL, THIRL [v]\n",
  "TIRLING": "TIRL, (Scots) to turn; to rattle, also DIRL, THIRL [v]\n",
  "TIRLS": "TIRL, (Scots) to turn; to rattle, also DIRL, THIRL [v]\n",
  "TIRO": "(Latin) a beginner or novice, also TYRO [n TIROS or TIROES]\n",
  "TIROCINIUM": "early training; first experience [n -S]\n",
  "TIROCINIUMS": "TIROCINIUM, early training; first experience [n]\n",
  "TIROES": "TIRO, (Latin) a beginner or novice, also TYRO [n]\n",
  "TIRONIC": "resembling a tiro, also TYRONIC [adj]\n",
  "TIROS": "TIRO, (Latin) a beginner or novice, also TYRO [n]\n",
  "TIRR": "(Scots) to strip [v -ED, -ING, -S]\n",
  "TIRRED": "TIRR, (Scots) to strip [v]\n",
  "TIRRING": "TIRR, (Scots) to strip [v]\n",
  "TIRRIT": "(Shakespeare) Mistress Quickly's word for alarm, fright [n -S]\n",
  "TIRRITS": "TIRRIT, (Shakespeare) Mistress Quickly's word for alarm, fright [n]\n",
  "TIRRIVEE": "(Scots) a tantrum, a commotion, also TIRRIVIE [n -S]\n",
  "TIRRIVEES": "TIRRIVEE, (Scots) a tantrum, a commotion, also TIRRIVIE [n]\n",
  "TIRRIVIE": "(Scots) a tantrum, a commotion, also TIRRIVEE [n -S]\n",
  "TIRRIVIES": "TIRRIVIE, (Scots) a tantrum, a commotion, also TIRRIVEE [n]\n",
  "TIRRS": "TIRR, (Scots) to strip [v]\n",
  "TIS": "TI, the seventh tone of the diatonic musical scale [n]\n",
  "TISANE": "an infusion of herbs or barley, also PTISAN [n -S]\n",
  "TISANES": "TISANE, an infusion of herbs or barley, also PTISAN [n]\n",
  "TISICK": "(Shakespeare) a cough [n -S]\n",
  "TISICKS": "TISICK, (Shakespeare) a cough [n]\n",
  "TISSUAL": "pertaining to tissue [adj]\n",
  "TISSUE": "to weave into a fine, sheer fabric [v TISSUED, TISSUING, TISSUES]\n",
  "TISSUED": "TISSUE, to weave into a fine, sheer fabric [v]\n",
  "TISSUES": "TISSUE, to weave into a fine, sheer fabric [v]\n",
  "TISSUEY": "of or like tissue [adj TISSUIER, TISSUIEST]\n",
  "TISSUIER": "TISSUEY, of or like tissue [adj]\n",
  "TISSUIEST": "TISSUEY, of or like tissue [adj]\n",
  "TISSUING": "TISSUE, to weave into a fine, sheer fabric [v]\n",
  "TISSULAR": "pertaining to structural material [adj]\n",
  "TISWAS": "a tizzy, a state of confusion, also TIZWAS [n -ES]\n",
  "TISWASES": "TISWAS, a tizzy, a state of confusion, also TIZWAS [n]\n",
  "TIT": "to tug [v TITTED, TITTING, TITS]\n",
  "TITAN": "a person of great size [n -S]\n",
  "TITANATE": "a salt of titanic acid [n -S]\n",
  "TITANATES": "TITANATE, a salt of titanic acid [n]\n",
  "TITANESS": "a female titan [n -ES]\n",
  "TITANESSES": "TITANESS, a female titan [n]\n",
  "TITANIA": "a mineral, an oxide of titanium [n -S]\n",
  "TITANIAS": "TITANIA, a mineral, an oxide of titanium [n]\n",
  "TITANIC": "having great magnitude, force, or power [adj TITANICALLY]\n",
  "TITANICALLY": "TITANIC, having great magnitude, force, or power [adv]\n",
  "TITANIFEROUS": "bearing titanium [adj]\n",
  "TITANIS": "an ostrichlike prehistoric North American bird [n -ES]\n",
  "TITANISES": "TITANIS, an ostrichlike prehistoric North American bird [n]\n",
  "TITANISM": "a spirit of revolt or defiance against social conventions [n -S]\n",
  "TITANISMS": "TITANISM, a spirit of revolt or defiance against social conventions [n]\n",
  "TITANITE": "a brown, green or yellow monoclinic mineral, calcium silicate and titanate, aka sphene [n -S]\n",
  "TITANITES": "TITANITE, a brown, green or yellow monoclinic mineral, calcium silicate and titanate, aka sphene [n]\n",
  "TITANIUM": "a metallic element [n -S]\n",
  "TITANIUMS": "TITANIUM, a metallic element [n]\n",
  "TITANOSAUR": "a very large dinosaur [n -S]\n",
  "TITANOSAURS": "TITANOSAUR, a very large dinosaur [n]\n",
  "TITANOTHERE": "any of various very large extinct horselike perissodactyl mammals [n -S]\n",
  "TITANOTHERES": "TITANOTHERE, any of various very large extinct horselike perissodactyl mammals [n]\n",
  "TITANOUS": "of trivalent titanium [adj]\n",
  "TITANS": "TITAN, a person of great size [n]\n",
  "TITARAKURA": "(Maori) a small freshwater fish of New Zealand [n -S]\n",
  "TITARAKURAS": "TITARAKURA, (Maori) a small freshwater fish of New Zealand [n]\n",
  "TITBIT": "a choice bit of food, also TIDBIT [n -S]\n",
  "TITBITS": "TITBIT, a choice bit of food, also TIDBIT [n]\n",
  "TITCH": "a small person, also TICH [n -ES]\n",
  "TITCHES": "TITCH, a small person, also TICH [n]\n",
  "TITCHIE": "very small, also TICHY, TITCHY [adj TITCHIER, TITCHIEST]\n",
  "TITCHIER": "TITCHY, very small, also TICHY, TITCHIE [adj]\n",
  "TITCHIEST": "TITCHY, very small, also TICHY, TITCHIE [adj]\n",
  "TITCHY": "very small, also TICHY, TITCHIE [adj TITCHIER, TITCHIEST]\n",
  "TITE": "(obsolete) promptly, at once, also TYTE [adj TITELY]\n",
  "TITELY": "TITE, (obsolete) promptly, at once, also TYTE [adv]\n",
  "TITER": "the concentration of a solution as determined by titration, also TITRE [n -S]\n",
  "TITERS": "TITER, the concentration of a solution as determined by titration, also TITRE [n]\n",
  "TITFER": "(slang) cockney rhyming slang for a hat [n -S]\n",
  "TITFERS": "TITFER, (slang) cockney rhyming slang for a hat [n]\n",
  "TITHABLE": "subject to the payment of tithes [adj]\n",
  "TITHE": "to pay a tenth part used as a small tax, also TYTHE [v TITHED, TITHING, TITHES]\n",
  "TITHED": "TITHE, to pay a tenth part used as a small tax, also TYTHE [v]\n",
  "TITHER": "one who collects tithes [n -S]\n",
  "TITHERS": "TITHER, one who collects tithes [n]\n",
  "TITHES": "TITHE, to pay a tenth part used as a small tax, also TYTHE [v]\n",
  "TITHING": "a tax comprising a tenth of produce [n -S]\n",
  "TITHINGMAN": "the chief man of a tithing; one elected to preside over the tithing [n TITHINGMEN]\n",
  "TITHINGMEN": "TITHINGMAN, the chief man of a tithing; one elected to preside over the tithing [n]\n",
  "TITHINGS": "TITHING, a tax comprising a tenth of produce [n]\n",
  "TITHONIA": "a tall herb [n -S]\n",
  "TITHONIAS": "TITHONIA, a tall herb [n]\n",
  "TITI": "a small South American monkey [n -S]\n",
  "TITIAN": "a reddish-brown colour [n -S]\n",
  "TITIANS": "TITIAN, a reddish-brown colour [n]\n",
  "TITILLATE": "to tickle or touch lightly; to pleasantly stimulate [v TITILLATED, TITILLATING, TITILLATES]\n",
  "TITILLATED": "TITILLATE, to tickle or touch lightly; to pleasantly stimulate [v]\n",
  "TITILLATES": "TITILLATE, to tickle or touch lightly; to pleasantly stimulate [v]\n",
  "TITILLATING": "TITILLATE, to tickle or touch lightly; to pleasantly stimulate [v]\n",
  "TITILLATINGLY": "TITILLATING, TITILLATE, to tickle or touch lightly; to pleasantly stimulate [adv]\n",
  "TITILLATION": "the act of titillating [n -S]\n",
  "TITILLATIONS": "TITILLATION, the act of titillating [n]\n",
  "TITILLATIVE": "serving to titillate [adj]\n",
  "TITILLATOR": "one who titillates [n -S]\n",
  "TITILLATORS": "TITILLATOR, one who titillates [n]\n",
  "TITIPOUNAMU": "(Maori) a kind of wren, aka rifleman [n -S]\n",
  "TITIPOUNAMUS": "TITIPOUNAMU, (Maori) a kind of wren, aka rifleman [n]\n",
  "TITIS": "TITI, a small South American monkey [n]\n",
  "TITIVATE": "to spruce up or adorn, also TIDIVATE, TITTIVATE [v TITIVATED, TITIVATING, TITIVATES]\n",
  "TITIVATED": "TITIVATE, to spruce up or adorn, also TIDIVATE, TITTIVATE [v]\n",
  "TITIVATES": "TITIVATE, to spruce up or adorn, also TIDIVATE, TITTIVATE [v]\n",
  "TITIVATING": "TITIVATE, to spruce up or adorn, also TIDIVATE, TITTIVATE [v]\n",
  "TITIVATION": "(slang) smartening up, also TIDIVATION, TITTIVATION [n -S]\n",
  "TITIVATIONS": "TITIVATION, (slang) smartening up, also TIDIVATION, TITTIVATION [n]\n",
  "TITIVATOR": "one who titivates, also TITTIVATOR [n -S]\n",
  "TITIVATORS": "TITIVATOR, one who titivates, also TITTIVATOR [n]\n",
  "TITLARK": "a pipit, esp. the meadow pipit [n -S]\n",
  "TITLARKS": "TITLARK, a pipit, esp. the meadow pipit [n]\n",
  "TITLE": "to designate or give a name to [v TITLED, TITLING, TITLES]\n",
  "TITLED": "TITLE, to designate or give a name to [v]\n",
  "TITLEHOLDER": "one that holds a title [n -S]\n",
  "TITLEHOLDERS": "TITLEHOLDER, one that holds a title [n]\n",
  "TITLEHOLDING": "holding a title [adj]\n",
  "TITLELESS": "not having a title or name; without legitimate title [adj]\n",
  "TITLER": "a writer of titles; a claimant [n -S]\n",
  "TITLERS": "TITLER, a writer of titles; a claimant [n]\n",
  "TITLES": "TITLE, to designate or give a name to [v]\n",
  "TITLIKE": "like a tit [adj]\n",
  "TITLING": "any of various tits, pipits, and similar small birds, esp. a dunnock [n -S]\n",
  "TITLINGS": "TITLING, any of various tits, pipits, and similar small birds, esp. a dunnock [n]\n",
  "TITLIST": "a sports champion [n -S]\n",
  "TITLISTS": "TITLIST, a sports champion [n]\n",
  "TITMAN": "the smallest of a litter of pigs [n TITMEN]\n",
  "TITMEN": "TITMAN, the smallest of a litter of pigs [n]\n",
  "TITMICE": "TITMOUSE, any of various small birds of the tit genus, also TITMOSE [n]\n",
  "TITMOSE": "(Spenser) a titmouse [n TITMICE]\n",
  "TITMOUSE": "any of various small birds of the tit genus, also TITMOSE [n TITMICE]\n",
  "TITOKI": "(Maori) a New Zealand tree [n -S]\n",
  "TITOKIS": "TITOKI, (Maori) a New Zealand tree [n]\n",
  "TITRABLE": "capable of being titrated [adj]\n",
  "TITRANT": "the reagent used in titration [n -S]\n",
  "TITRANTS": "TITRANT, the reagent used in titration [n]\n",
  "TITRATABLE": "that can be titrated [adj]\n",
  "TITRATE": "to measure the strength of a solution [v TITRATED, TITRATING, TITRATES]\n",
  "TITRATED": "TITRATE, to measure the strength of a solution [v]\n",
  "TITRATES": "TITRATE, to measure the strength of a solution [v]\n",
  "TITRATING": "TITRATE, to measure the strength of a solution [v]\n",
  "TITRATION": "the addition of a solution from a graduated vessel to a known volume of a second solution until the chemical reaction is just completed [n -S]\n",
  "TITRATIONS": "TITRATION, the addition of a solution from a graduated vessel to a known volume of a second solution until the chemical reaction is just completed [n]\n",
  "TITRATOR": "one who titrates [n -S]\n",
  "TITRATORS": "TITRATOR, one who titrates [n]\n",
  "TITRE": "the strength of a chemical solution, also TITER [n -S]\n",
  "TITRES": "TITRE, the strength of a chemical solution, also TITER [n]\n",
  "TITRIMETRIC": "employing or determined by titration [adj]\n",
  "TITS": "TIT, to tug [v]\n",
  "TITTED": "TIT, to tug [v]\n",
  "TITTER": "to utter a restrained, nervous laugh [v -ED, -ING, -S]\n",
  "TITTERED": "TITTER, to utter a restrained, nervous laugh [v]\n",
  "TITTERER": "one that titters [n -S]\n",
  "TITTERERS": "TITTERER, one that titters [n]\n",
  "TITTERING": "the act of tittering [n -S]\n",
  "TITTERINGLY": "TITTERING [adv]\n",
  "TITTERINGS": "TITTERING, the act of tittering [n]\n",
  "TITTERS": "TITTER, to utter a restrained, nervous laugh [v]\n",
  "TITTIE": "(Scots) a sister, also TITTY [n -S]\n",
  "TITTIES": "TITTY, (Scots) a sister, also TITTIE [n]\n",
  "TITTING": "TIT, to tug [v]\n",
  "TITTISH": "(slang) like a teat; contemptible [adj]\n",
  "TITTIVATE": "to spruce up or adorn, also TIDIVATE, TITIVATE [v TITTIVATED, TITTIVATING, TITTIVATES]\n",
  "TITTIVATED": "TITTIVATE, to spruce up or adorn, also TIDIVATE, TITIVATE [v]\n",
  "TITTIVATES": "TITTIVATE, to spruce up or adorn, also TIDIVATE, TITIVATE [v]\n",
  "TITTIVATING": "TITTIVATE, to spruce up or adorn, also TIDIVATE, TITIVATE [v]\n",
  "TITTIVATION": "(slang) smartening up, also TIDIVATION, TITIVATION [n -S]\n",
  "TITTIVATIONS": "TITTIVATION, (slang) smartening up, also TIDIVATION, TITIVATION [n]\n",
  "TITTIVATOR": "one who titivates, also TITIVATOR [n -S]\n",
  "TITTIVATORS": "TITTIVATOR, one who titivates, also TITIVATOR [n]\n",
  "TITTLE": "to whisper, talk [v TITTLED, TITTLING, TITTLES]\n",
  "TITTLEBAT": "the three-spined stickleback [n -S]\n",
  "TITTLEBATS": "TITTLEBAT, the three-spined stickleback [n]\n",
  "TITTLED": "TITTLE, to whisper, talk [v]\n",
  "TITTLES": "TITTLE, to whisper, talk [v]\n",
  "TITTLING": "TITTLE, to whisper, talk [v]\n",
  "TITTUP": "to prance, skip about gaily [v TITTUPED or TITTUPPED, TITTUPING or TITTUPPING, TITTUPS]\n",
  "TITTUPED": "TITTUP, to prance, skip about gaily [v]\n",
  "TITTUPIER": "TITTUPY, gay, lively, unsteady, also TITTUPPY, TITUPY [adj]\n",
  "TITTUPIEST": "TITTUPY, gay, lively, unsteady, also TITTUPPY, TITUPY [adj]\n",
  "TITTUPING": "TITTUP, to prance, skip about gaily [v]\n",
  "TITTUPPED": "TITTUP, to prance, skip about gaily [v]\n",
  "TITTUPPIER": "TITTUPPY, gay, lively, unsteady, also TITTUPY, TITUPY [adj]\n",
  "TITTUPPIEST": "TITTUPPY, gay, lively, unsteady, also TITTUPY, TITUPY [adj]\n",
  "TITTUPPING": "TITTUP, to prance, skip about gaily [v]\n",
  "TITTUPPY": "gay, lively, unsteady, also TITTUPY, TITUPY [adj TITTUPPIER, TITTUPPIEST]\n",
  "TITTUPS": "TITTUP, to prance, skip about gaily [v]\n",
  "TITTUPY": "gay, lively, unsteady, also TITTUPPY, TITUPY [adj TITTUPIER, TITTUPIEST]\n",
  "TITTY": "(Scots) a sister, also TITTIE [n TITTIES]\n",
  "TITUBANCIES": "TITUBANCY, staggering [n]\n",
  "TITUBANCY": "staggering [n TITUBANCIES]\n",
  "TITUBANT": "staggering [adj]\n",
  "TITUBATE": "to stagger [v TITUBATED, TITUBATING, TITUBATES]\n",
  "TITUBATED": "TITUBATE, to stagger [v]\n",
  "TITUBATES": "TITUBATE, to stagger [v]\n",
  "TITUBATING": "TITUBATE, to stagger [v]\n",
  "TITUBATION": "a nervous condition marked by staggering [n -S]\n",
  "TITUBATIONS": "TITUBATION, a nervous condition marked by staggering [n]\n",
  "TITULAR": "relating to title [adj TITULARLY] / one who has a title, or enjoys a title without possessing the office [n -S]\n",
  "TITULARIES": "TITULARY, one who holds a title, also TITULAR [n]\n",
  "TITULARITIES": "TITULARITY, the state of being titular [n]\n",
  "TITULARITY": "the state of being titular [n TITULARITIES]\n",
  "TITULARLY": "TITULAR, relating to title [adv]\n",
  "TITULARS": "TITULAR, one who has a title, or enjoys a title without possessing the office [n]\n",
  "TITULARY": "one who holds a title, also TITULAR [n TITULARIES]\n",
  "TITULE": "to give a title to [v TITULED, TITULING, TITULES]\n",
  "TITULED": "TITULE, to give a title to [v]\n",
  "TITULES": "TITULE, to give a title to [v]\n",
  "TITULI": "TITULUS, a sign on a cross giving a crucified person's name and crime [n]\n",
  "TITULING": "TITULE, to give a title to [v]\n",
  "TITULUS": "a sign on a cross giving a crucified person's name and crime [n TITULI]\n",
  "TITUP": "to prance [v TITUPPED or TITUPED, TITUPPING or TITUPING, TITUPS]\n",
  "TITUPED": "TITUP, to prance [v]\n",
  "TITUPIER": "TITUPY, gay, lively, unsteady, also TITTUPPY, TITTUPY [adj]\n",
  "TITUPIEST": "TITUPY, gay, lively, unsteady, also TITTUPPY, TITTUPY [adj]\n",
  "TITUPING": "TITUP, to prance [v]\n",
  "TITUPPED": "TITUP, to prance [v]\n",
  "TITUPPING": "TITUP, to prance [v]\n",
  "TITUPS": "TITUP, to prance [v]\n",
  "TITUPY": "gay, lively, unsteady, also TITTUPPY, TITTUPY [adj TITUPIER, TITUPIEST]\n",
  "TIVY": "with great speed [adv]\n",
  "TIX": "(slang) tickets [n]\n",
  "TIYIN": "a monetary unit of Uzbekistan [n -S]\n",
  "TIYINS": "TIYIN, a monetary unit of Uzbekistan [n]\n",
  "TIYN": "a monetary unit of Kazakhstan [n -S]\n",
  "TIYNS": "TIYN, a monetary unit of Kazakhstan [n]\n",
  "TIZ": "a state of confusion, also TIZZ, TIZZY [n -ES]\n",
  "TIZES": "TIZ, a state of confusion, also TIZZ, TIZZY [n]\n",
  "TIZWAS": "a tizzy, a state of confusion, also TISWAS [n -ES]\n",
  "TIZWASES": "TIZWAS, a tizzy, a state of confusion, also TISWAS [n]\n",
  "TIZZ": "(colloquial) a state of agitation, also TIZ, TIZZY [n TIZZES]\n",
  "TIZZES": "TIZZ, (colloquial) a state of agitation, also TIZ, TIZZY [n]\n",
  "TIZZIES": "TIZZY, (colloquial) a state of agitation, also TIZ, TIZZ [n]\n",
  "TIZZY": "(colloquial) a state of agitation, also TIZ, TIZZ [n TIZZIES]\n",
  "TJANTING": "(Indonesian) a small tool used for applying hot wax to fabric in batik [n -S]\n",
  "TJANTINGS": "TJANTING, (Indonesian) a small tool used for applying hot wax to fabric in batik [n]\n",
  "TMESES": "TMESIS, (Greek) the splitting of a word with other words [n]\n",
  "TMESIS": "(Greek) the splitting of a word with other words [n TMESES]\n",
  "TO": "in the direction of [prep]\n",
  "TOAD": "any anuran amphibian of the class Bufonidae [n -S]\n",
  "TOADEATER": "a sycophant, also TOADY [n -S]\n",
  "TOADEATERS": "TOADEATER, a sycophant, also TOADY [n]\n",
  "TOADFISH": "a toadlike marine fish [n -ES]\n",
  "TOADFISHES": "TOADFISH, a toadlike marine fish [n]\n",
  "TOADFLAX": "a plant of the figwort family, resembling a snapdragon [n -ES]\n",
  "TOADFLAXES": "TOADFLAX, a plant of the figwort family, resembling a snapdragon [n]\n",
  "TOADGRASS": "a kind of low rush, also TOADRUSH [n -ES]\n",
  "TOADGRASSES": "TOADGRASS, a kind of low rush, also TOADRUSH [n]\n",
  "TOADIED": "TOADY, to fawn on or flatter [v]\n",
  "TOADIES": "TOADY, to fawn on or flatter [v]\n",
  "TOADISH": "like a toad [adj]\n",
  "TOADLESS": "having no toads [adj]\n",
  "TOADLET": "a small toad [n -S]\n",
  "TOADLETS": "TOADLET, a small toad [n]\n",
  "TOADLIKE": "like a toad [adj]\n",
  "TOADRUSH": "a kind of low rush, also TOADGRASS [n -ES]\n",
  "TOADRUSHES": "TOADRUSH, a kind of low rush, also TOADGRASS [n]\n",
  "TOADS": "TOAD, any anuran amphibian of the class Bufonidae [n]\n",
  "TOADSTONE": "any stone or stonelike concretion believed to be formed in a toad and to have magic powers [n -S]\n",
  "TOADSTONES": "TOADSTONE, any stone or stonelike concretion believed to be formed in a toad and to have magic powers [n]\n",
  "TOADSTOOL": "any of several spore-producing, poisonous, umbrella-shaped fungi [n -S]\n",
  "TOADSTOOLS": "TOADSTOOL, any of several spore-producing, poisonous, umbrella-shaped fungi [n]\n",
  "TOADY": "to fawn on or flatter [v TOADIED, TOADYING, TOADIES]\n",
  "TOADYING": "acting sycophantically [n -S]\n",
  "TOADYINGS": "TOADYING, acting sycophantically [n]\n",
  "TOADYISH": "characteristic of one who toadies [adj]\n",
  "TOADYISM": "toadyish behaviour [n -S]\n",
  "TOADYISMS": "TOADYISM, toadyish behaviour [n]\n",
  "TOAST": "to brown by exposing to heat [v -ED, -ING, -S]\n",
  "TOASTED": "TOAST, to brown by exposing to heat [v]\n",
  "TOASTER": "a device for toasting [n -S]\n",
  "TOASTERS": "TOASTER, a device for toasting [n]\n",
  "TOASTIE": "(colloquial) a toasted sandwich, also TOASTY [n -S]\n",
  "TOASTIER": "TOASTY, like toast, comfortably warm [adj]\n",
  "TOASTIES": "TOASTIE, (colloquial) a toasted sandwich, also TOASTY [n]\n",
  "TOASTIEST": "TOASTY, like toast, comfortably warm [adj]\n",
  "TOASTING": "the act of toasting [n -S]\n",
  "TOASTINGS": "TOASTING, the act of toasting [n]\n",
  "TOASTMASTER": "one who presides at a banquet and introduces the after-dinner speakers [n -S]\n",
  "TOASTMASTERS": "TOASTMASTER, one who presides at a banquet and introduces the after-dinner speakers [n]\n",
  "TOASTMISTRESS": "a woman who acts as toastmaster [n -ES]\n",
  "TOASTMISTRESSES": "TOASTMISTRESS, a woman who acts as toastmaster [n]\n",
  "TOASTS": "TOAST, to brown by exposing to heat [v]\n",
  "TOASTY": "like toast, comfortably warm [adj TOASTIER, TOASTIEST] / a toasted sandwich, also TOASTIE [n TOASTIES]\n",
  "TOAZE": "(Shakespeare) to tease out, draw out, also TEASE, TEAZE, TOSE, TOZE [v TOAZED, TOAZING, TOAZES]\n",
  "TOAZED": "TOAZE, (Shakespeare) to tease out, draw out, also TEASE, TEAZE, TOSE, TOZE [v]\n",
  "TOAZES": "TOAZE, (Shakespeare) to tease out, draw out, also TEASE, TEAZE, TOSE, TOZE [v]\n",
  "TOAZING": "TOAZE, (Shakespeare) to tease out, draw out, also TEASE, TEAZE, TOSE, TOZE [v]\n",
  "TOBACCANALIAN": "(facetious) a smoker [n -S]\n",
  "TOBACCANALIANS": "TOBACCANALIAN, (facetious) a smoker [n]\n",
  "TOBACCO": "an annual herb cultivated for its leaves [n -ES or -S]\n",
  "TOBACCOES": "TOBACCO, an annual herb cultivated for its leaves [n]\n",
  "TOBACCOLESS": "without tobacco [adj]\n",
  "TOBACCONIST": "a dealer in tobacco esp. at retail [n -S]\n",
  "TOBACCONISTS": "TOBACCONIST, a dealer in tobacco esp. at retail [n]\n",
  "TOBACCOS": "TOBACCO, an annual herb cultivated for its leaves [n]\n",
  "TOBIES": "TOBY, in thieves' slang, the road [n]\n",
  "TOBOGGAN": "a kind of sledge, also TABOGGAN, TARBOGGIN, TOBOGGIN [n -S] / to sledge by toboggan [v -ED, -ING, -S]\n",
  "TOBOGGANED": "TOBOGGAN, to sledge by toboggan [v]\n",
  "TOBOGGANER": "one who uses a toboggan, also TOBOGGANIST [n -S]\n",
  "TOBOGGANERS": "TOBOGGANER, one who uses a toboggan, also TOBOGGANIST [n]\n",
  "TOBOGGANING": "the sport of sledging by toboggan [n -S]\n",
  "TOBOGGANINGS": "TOBOGGANING, the sport of sledging by toboggan [n]\n",
  "TOBOGGANIST": "one who uses a toboggan, also TOBOGGANER [n -S]\n",
  "TOBOGGANISTS": "TOBOGGANIST, one who uses a toboggan, also TOBOGGANER [n]\n",
  "TOBOGGANS": "TOBOGGAN, to sledge by toboggan [v]\n",
  "TOBOGGIN": "a kind of sledge, also TABOGGAN, TARBOGGIN, TOBOGGAN [n -S] / to travel by toboggin [v -ED, -ING, -S]\n",
  "TOBOGGINED": "TOBOGGIN, to travel by toboggin [v]\n",
  "TOBOGGINING": "TOBOGGIN, to travel by toboggin [v]\n",
  "TOBOGGINS": "TOBOGGIN, to travel by toboggin [v]\n",
  "TOBY": "in thieves' slang, the road [n TOBIES]\n",
  "TOC": "telecommunications code for the letter T [n -S]\n",
  "TOCCATA": "(Italian) a quick, fantasia-like musical composition [n TOCCATAS or TOCCATE]\n",
  "TOCCATAS": "TOCCATA, (Italian) a quick, fantasia-like musical composition [n]\n",
  "TOCCATE": "TOCCATA, (Italian) a quick, fantasia-like musical composition [n]\n",
  "TOCCATELLA": "a short toccata [n -S]\n",
  "TOCCATELLAS": "TOCCATELLA, a short toccata [n]\n",
  "TOCCATINA": "a short toccata, a quick, fantasia-like musical composition [n -S]\n",
  "TOCCATINAS": "TOCCATINA, a short toccata, a quick, fantasia-like musical composition [n]\n",
  "TOCHER": "(Gaelic) to dower [v -ED, -ING, -S]\n",
  "TOCHERED": "TOCHER, (Gaelic) to dower [v]\n",
  "TOCHERING": "TOCHER, (Gaelic) to dower [v]\n",
  "TOCHERLESS": "without a tocher, a dowry [adj]\n",
  "TOCHERS": "TOCHER, (Gaelic) to dower [v]\n",
  "TOCK": "to make the sound of a clock [v -ED, -ING, -S]\n",
  "TOCKED": "TOCK, to make the sound of a clock [v]\n",
  "TOCKIER": "TOCKY, muddy [adj]\n",
  "TOCKIEST": "TOCKY, muddy [adj]\n",
  "TOCKING": "TOCK, to make the sound of a clock [v]\n",
  "TOCKLEY": "(vulgar Australian slang) the penis [n -S]\n",
  "TOCKLEYS": "TOCKLEY, (vulgar Australian slang) the penis [n]\n",
  "TOCKS": "TOCK, to make the sound of a clock [v]\n",
  "TOCKY": "muddy [adj TOCKIER, TOCKIEST]\n",
  "TOCO": "punishment, also TOKO [n -S]\n",
  "TOCOLOGIES": "TOCOLOGY, a branch of medicine dealing with childbirth, also TOKOLOGY [n]\n",
  "TOCOLOGY": "a branch of medicine dealing with childbirth, also TOKOLOGY [n TOCOLOGIES]\n",
  "TOCOPHEROL": "vitamin E, found in wheatgerm, egg yolk etc. [n -S]\n",
  "TOCOPHEROLS": "TOCOPHEROL, vitamin E, found in wheatgerm, egg yolk etc. [n]\n",
  "TOCOPHOBIA": "an abnormal fear of giving birth or becoming pregnant [n -S]\n",
  "TOCOPHOBIAS": "TOCOPHOBIA, an abnormal fear of giving birth or becoming pregnant [n]\n",
  "TOCOS": "TOCO, punishment, also TOKO [n]\n",
  "TOCS": "TOC, telecommunications code for the letter T [n]\n",
  "TOCSIN": "an alarm sounded on a bell [n -S]\n",
  "TOCSINS": "TOCSIN, an alarm sounded on a bell [n]\n",
  "TOD": "a weight used in the wool trade, usually 28 pounds or 2 stone [n -S] / to yield a tod [v TODDED, TODDING, TODS]\n",
  "TODAY": "the present day [n -S]\n",
  "TODAYS": "TODAY, the present day [n]\n",
  "TODDE": "(Spenser) a bush esp. of ivy [n -S]\n",
  "TODDED": "TOD, to yield a tod [v]\n",
  "TODDES": "TODDE, (Spenser) a bush esp. of ivy [n]\n",
  "TODDIES": "TODDY, (Hindi) the fermented sap of various palm trees [n]\n",
  "TODDING": "TOD, to yield a tod [v]\n",
  "TODDLE": "to walk unsteadily [v TODDLED, TODDLING, TODDLES]\n",
  "TODDLED": "TODDLE, to walk unsteadily [v]\n",
  "TODDLER": "a young child [n -S]\n",
  "TODDLERHOOD": "the state of being a toddler [n -S]\n",
  "TODDLERHOODS": "TODDLERHOOD, the state of being a toddler [n]\n",
  "TODDLERS": "TODDLER, a young child [n]\n",
  "TODDLES": "TODDLE, to walk unsteadily [v]\n",
  "TODDLING": "TODDLE, to walk unsteadily [v]\n",
  "TODDY": "(Hindi) the fermented sap of various palm trees [n TODDIES]\n",
  "TODGER": "(vulgar slang) the penis [n -S]\n",
  "TODGERS": "TODGER, (vulgar slang) the penis [n]\n",
  "TODIES": "TODY, a small West Indian insectivorous bird [n]\n",
  "TODS": "TOD, a weight used in the wool trade, usually 28 pounds or 2 stone [n]\n",
  "TODY": "a small West Indian insectivorous bird [n TODIES]\n",
  "TOE": "to touch with projecting members of the foot [v TOED, TOEING, TOES]\n",
  "TOEA": "a monetary unit of Papua New Guinea [n -S]\n",
  "TOEAS": "TOEA, a monetary unit of Papua New Guinea [n]\n",
  "TOEBIE": "(South African) a sandwich [n -S]\n",
  "TOEBIES": "TOEBIE, (South African) a sandwich [n]\n",
  "TOECAP": "a covering for the front of a boot or shoe [n -S]\n",
  "TOECAPS": "TOECAP, a covering for the front of a boot or shoe [n]\n",
  "TOECLIP": "an attachment to a bicycle pedal that holds the toe and thus the foot, firm [n -S]\n",
  "TOECLIPS": "TOECLIP, an attachment to a bicycle pedal that holds the toe and thus the foot, firm [n]\n",
  "TOED": "TOE, to touch with projecting members of the foot [v]\n",
  "TOEHOLD": "a space that fits a toe in climbing [n -S]\n",
  "TOEHOLDS": "TOEHOLD, a space that fits a toe in climbing [n]\n",
  "TOEIER": "TOEY, (Australian slang) nervous, edgy [adj]\n",
  "TOEIEST": "TOEY, (Australian slang) nervous, edgy [adj]\n",
  "TOEING": "TOE, to touch with projecting members of the foot [v]\n",
  "TOELESS": "having no toes [adj]\n",
  "TOELIKE": "like a toe [adj]\n",
  "TOENAIL": "to fasten with obliquely driven nails [v -ED, -ING, -S]\n",
  "TOENAILED": "TOENAIL, to fasten with obliquely driven nails [v]\n",
  "TOENAILING": "TOENAIL, to fasten with obliquely driven nails [v]\n",
  "TOENAILS": "TOENAIL, to fasten with obliquely driven nails [v]\n",
  "TOEPIECE": "a piece on a shoe designed to cover the toes [n -S]\n",
  "TOEPIECES": "TOEPIECE, a piece on a shoe designed to cover the toes [n]\n",
  "TOEPLATE": "a metal tab attached to the tip of a shoe [n -S]\n",
  "TOEPLATES": "TOEPLATE, a metal tab attached to the tip of a shoe [n]\n",
  "TOERAG": "a tramp, a despicable person, also TOERAGGER [n -S]\n",
  "TOERAGGER": "a tramp; a despicable person, also TOERAG [n -S]\n",
  "TOERAGGERS": "TOERAGGER, a tramp; a despicable person, also TOERAG [n]\n",
  "TOERAGS": "TOERAG, a tramp, a despicable person, also TOERAGGER [n]\n",
  "TOES": "TOE, to touch with projecting members of the foot [v]\n",
  "TOESHOE": "a dance shoe designed for dancing on the toes [n -S]\n",
  "TOESHOES": "TOESHOE, a dance shoe designed for dancing on the toes [n]\n",
  "TOETOE": "(Maori) a tall reedlike grass of New Zealand, also TOITOI [n -S]\n",
  "TOETOES": "TOETOE, (Maori) a tall reedlike grass of New Zealand, also TOITOI [n]\n",
  "TOEY": "(Australian slang) nervous, edgy [adj TOEIER, TOEIEST]\n",
  "TOFF": "a dandy [n -S]\n",
  "TOFFEE": "a hard-baked chewy sweet, made of sugar and butter, also TAFFY, TOFFY [n -S]\n",
  "TOFFEES": "TOFFEE, a hard-baked chewy sweet, made of sugar and butter, also TAFFY, TOFFY [n]\n",
  "TOFFIER": "TOFFY, like a toff, posh [adj]\n",
  "TOFFIES": "TOFFY, a toffee, also TAFFY, TOFFEE [n]\n",
  "TOFFIEST": "TOFFY, like a toff, posh [adj]\n",
  "TOFFISH": "like a toff; posh [adj]\n",
  "TOFFISHNESS": "the state of being toffish [n -ES]\n",
  "TOFFISHNESSES": "TOFFISHNESS, the state of being toffish [n]\n",
  "TOFFS": "TOFF, a dandy [n]\n",
  "TOFFY": "like a toff, posh [adj TOFFIER, TOFFIEST] / a toffee, also TAFFY, TOFFEE [n TOFFIES]\n",
  "TOFORE": "(Shakespeare) before [adv]\n",
  "TOFT": "a homestead; a hillock [n -S]\n",
  "TOFTS": "TOFT, a homestead; a hillock [n]\n",
  "TOFU": "(Japanese) a soft Oriental cheese made from soybean milk [n -S]\n",
  "TOFUS": "TOFU, (Japanese) a soft Oriental cheese made from soybean milk [n]\n",
  "TOFUTTI": "(tradename) any of a variety of nondairy, soya-based food products [n -S]\n",
  "TOFUTTIS": "TOFUTTI, (tradename) any of a variety of nondairy, soya-based food products [n]\n",
  "TOG": "to clothe [v TOGGED, TOGGING, TOGS]\n",
  "TOGA": "(Latin) a garment worn in ancient Rome [n TOGAS or TOGAE]\n",
  "TOGAE": "TOGA, (Latin) a garment worn in ancient Rome [n]\n",
  "TOGAED": "(Shakespeare) wearing a toga [adj]\n",
  "TOGAS": "TOGA, (Latin) a garment worn in ancient Rome [n]\n",
  "TOGATE": "(Shakespeare) wearing a toga, also TOGAED, TOGATED, TOGED [adj]\n",
  "TOGATED": "(Shakespeare) wearing a toga, also TOGAED, TOGATE, TOGED [adj]\n",
  "TOGAVIRUS": "one of a family of viruses [n -ES]\n",
  "TOGAVIRUSES": "TOGAVIRUS, one of a family of viruses [n]\n",
  "TOGE": "(obsolete) a toga [n -S]\n",
  "TOGED": "(Shakespeare) clad in a toga [adj]\n",
  "TOGES": "TOGE, (obsolete) a toga [n]\n",
  "TOGETHER": "into a union or relationship, also THEGITHER [adj]\n",
  "TOGETHERNESS": "the state of being together [n -ES]\n",
  "TOGETHERNESSES": "TOGETHERNESS, the state of being together [n]\n",
  "TOGGED": "TOG, to clothe [v]\n",
  "TOGGER": "(colloquial) to play football [v -ED, -ING, -S]\n",
  "TOGGERED": "TOGGER, (colloquial) to play football [v]\n",
  "TOGGERIES": "TOGGERY, clothes; garments; as, fishing toggery [n]\n",
  "TOGGERING": "TOGGER, (colloquial) to play football [v]\n",
  "TOGGERS": "TOGGER, (colloquial) to play football [v]\n",
  "TOGGERY": "clothes; garments; as, fishing toggery [n TOGGERIES]\n",
  "TOGGING": "TOG, to clothe [v]\n",
  "TOGGLE": "to fasten with a type of short rod [v TOGGLED, TOGGLING, TOGGLES]\n",
  "TOGGLED": "TOGGLE, to fasten with a type of short rod [v]\n",
  "TOGGLER": "one who toggles [n -S]\n",
  "TOGGLERS": "TOGGLER, one who toggles [n]\n",
  "TOGGLES": "TOGGLE, to fasten with a type of short rod [v]\n",
  "TOGGLING": "TOGGLE, to fasten with a type of short rod [v]\n",
  "TOGROG": "(Mongolian) a Mongolian monetary unit, also TUGHRIK, TUGRIK [n -S]\n",
  "TOGROGS": "TOGROG, (Mongolian) a Mongolian monetary unit, also TUGHRIK, TUGRIK [n]\n",
  "TOGS": "TOG, to clothe [v]\n",
  "TOGUE": "(Native American) the Great Lake char or trout, a gigantic salmonid of North America [n -S]\n",
  "TOGUES": "TOGUE, (Native American) the Great Lake char or trout, a gigantic salmonid of North America [n]\n",
  "TOHEROA": "(Maori) a kind of New Zealand shellfish [n -S]\n",
  "TOHEROAS": "TOHEROA, (Maori) a kind of New Zealand shellfish [n]\n",
  "TOHO": "a call to pointers or setters to stop [n -S]\n",
  "TOHOS": "TOHO, a call to pointers or setters to stop [n]\n",
  "TOHUNGA": "(Maori) a priest, a wise man with healing powers [n -S]\n",
  "TOHUNGAS": "TOHUNGA, (Maori) a priest, a wise man with healing powers [n]\n",
  "TOIL": "to work hard [v -ED, -ING, -S]\n",
  "TOILE": "(French) a thin dress material [n -S]\n",
  "TOILED": "TOIL, to work hard [v]\n",
  "TOILER": "one that toils [n -S]\n",
  "TOILERS": "TOILER, one that toils [n]\n",
  "TOILES": "TOILE, (French) a thin dress material [n]\n",
  "TOILET": "to dress and groom oneself [v -ED, -ING, -S]\n",
  "TOILETED": "TOILET, to dress and groom oneself [v]\n",
  "TOILETING": "the act of performing one's toilet [n -S]\n",
  "TOILETINGS": "TOILETING, the act of performing one's toilet [n]\n",
  "TOILETRIES": "TOILETRY, an article used in dressing and grooming [n]\n",
  "TOILETRY": "an article used in dressing and grooming [n TOILETRIES]\n",
  "TOILETS": "TOILET, to dress and groom oneself [v]\n",
  "TOILETTE": "(French) the act of washing, dressing, arranging the hair, etc. [n -S]\n",
  "TOILETTES": "TOILETTE, (French) the act of washing, dressing, arranging the hair, etc. [n]\n",
  "TOILFUL": "producing or involving much toil; laborious [adj TOILFULLY]\n",
  "TOILFULLY": "TOILFUL, producing or involving much toil; laborious [adv]\n",
  "TOILFULNESS": "the state of being toilful [n -ES]\n",
  "TOILFULNESSES": "TOILFULNESS, the state of being toilful [n]\n",
  "TOILINET": "a kind of woollen cloth, silk and cotton warp, also TOILINETTE [n -S]\n",
  "TOILINETS": "TOILINET, a kind of woollen cloth, silk and cotton warp, also TOILINETTE [n]\n",
  "TOILINETTE": "a kind of woollen cloth, silk and cotton warp, also TOILINET [n -S]\n",
  "TOILINETTES": "TOILINETTE, a kind of woollen cloth, silk and cotton warp, also TOILINET [n]\n",
  "TOILING": "the act of toiling [n -S]\n",
  "TOILINGS": "TOILING, the act of toiling [n]\n",
  "TOILLESS": "without toil [adj]\n",
  "TOILS": "TOIL, to work hard [v]\n",
  "TOILSOME": "demanding much exertion, also TOYLESOME, TOYLSOM [adj TOILSOMELY]\n",
  "TOILSOMELY": "TOILSOME, demanding much exertion, also TOYLESOME, TOYLSOM [adv]\n",
  "TOILSOMENESS": "the state of being toilsome [n -ES]\n",
  "TOILSOMENESSES": "TOILSOMENESS, the state of being toilsome [n]\n",
  "TOILWORN": "worn down by toil [adj]\n",
  "TOING": "as in toing and froing [n -S]\n",
  "TOINGS": "TOING, as in toing and froing [n]\n",
  "TOISE": "(French) an old measure of length in France, containing six French feet [n -S]\n",
  "TOISEACH": "(Irish) a Celtic nobleman, also TOISECH, TOSHACH [n -S]\n",
  "TOISEACHS": "TOISEACH, (Irish) a Celtic nobleman, also TOISECH, TOSHACH [n]\n",
  "TOISECH": "(Irish) a Celtic nobleman, also TOISEACH, TOSHACH [n -S]\n",
  "TOISECHS": "TOISECH, (Irish) a Celtic nobleman, also TOISEACH, TOSHACH [n]\n",
  "TOISES": "TOISE, (French) an old measure of length in France, containing six French feet [n]\n",
  "TOISON": "(French) a fleece [n -S]\n",
  "TOISONS": "TOISON, (French) a fleece [n]\n",
  "TOIT": "to saunter [v -ED, -ING, -S]\n",
  "TOITED": "TOIT, to saunter [v]\n",
  "TOITING": "TOIT, to saunter [v]\n",
  "TOITOI": "(Maori) a tall reedlike grass of New Zealand, also TOETOE [n -S]\n",
  "TOITOIS": "TOITOI, (Maori) a tall reedlike grass of New Zealand, also TOETOE [n]\n",
  "TOITS": "TOIT, to saunter [v]\n",
  "TOKAMAK": "(Russian) a toroidal device used in fusion, also TOKOMAK [n -S]\n",
  "TOKAMAKS": "TOKAMAK, (Russian) a toroidal device used in fusion, also TOKOMAK [n]\n",
  "TOKAY": "a large gecko of southern Asia and Indonesia [n -S]\n",
  "TOKAYS": "TOKAY, a large gecko of southern Asia and Indonesia [n]\n",
  "TOKE": "to puff a marijuana cigarette [v TOKED, TOKING, TOKES]\n",
  "TOKED": "TOKE, to puff a marijuana cigarette [v]\n",
  "TOKEN": "to be a sign or mark of [v -ED, -ING, -S]\n",
  "TOKENED": "TOKEN, to be a sign or mark of [v]\n",
  "TOKENING": "TOKEN, to be a sign or mark of [v]\n",
  "TOKENISM": "the policy of making only a superficial effort [n -S]\n",
  "TOKENISMS": "TOKENISM, the policy of making only a superficial effort [n]\n",
  "TOKENISTIC": "relating to tokenism [adj]\n",
  "TOKENS": "TOKEN, to be a sign or mark of [v]\n",
  "TOKER": "one that tokes, puffs [n -S]\n",
  "TOKERS": "TOKER, one that tokes, puffs [n]\n",
  "TOKES": "TOKE, to puff a marijuana cigarette [v]\n",
  "TOKING": "TOKE, to puff a marijuana cigarette [v]\n",
  "TOKO": "punishment, also TOCO [n -S]\n",
  "TOKOLOGIES": "TOKOLOGY, a branch of medicine dealing with childbirth, also TOCOLOGY [n]\n",
  "TOKOLOGY": "a branch of medicine dealing with childbirth, also TOCOLOGY [n TOKOLOGIES]\n",
  "TOKOLOSHE": "(Zulu) in Bantu folklore, a hairy malevolent dwarflike creature with supernatural powers, also TIKOLOSHE, TOKOLOSHI [n -S]\n",
  "TOKOLOSHES": "TOKOLOSHE, (Zulu) in Bantu folklore, a hairy malevolent dwarflike creature with supernatural powers, also TIKOLOSHE, TOKOLOSHI [n]\n",
  "TOKOLOSHI": "(Zulu) in Bantu folklore, a hairy malevolent dwarflike creature with supernatural powers, also TIKOLOSHE, TOKOLOSHE [n -S]\n",
  "TOKOLOSHIS": "TOKOLOSHI, (Zulu) in Bantu folklore, a hairy malevolent dwarflike creature with supernatural powers, also TIKOLOSHE, TOKOLOSHE [n]\n",
  "TOKOMAK": "(Russian) a toroidal device used in fusion, also TOKAMAK [n -S]\n",
  "TOKOMAKS": "TOKOMAK, (Russian) a toroidal device used in fusion, also TOKAMAK [n]\n",
  "TOKONOMA": "(Japanese) a small alcove in a Japanese house [n -S]\n",
  "TOKONOMAS": "TOKONOMA, (Japanese) a small alcove in a Japanese house [n]\n",
  "TOKOPHOBIA": "an abnormal fear of giving birth or becoming pregnant [n -S]\n",
  "TOKOPHOBIAS": "TOKOPHOBIA, an abnormal fear of giving birth or becoming pregnant [n]\n",
  "TOKOS": "TOKO, punishment, also TOCO [n]\n",
  "TOKOTOKO": "(Maori) a ceremonial carved walking stick [n -S]\n",
  "TOKOTOKOS": "TOKOTOKO, (Maori) a ceremonial carved walking stick [n]\n",
  "TOKTOKKIE": "(South African) a large South African beetle [n -S]\n",
  "TOKTOKKIES": "TOKTOKKIE, (South African) a large South African beetle [n]\n",
  "TOLA": "(Hindi) an Indian unit of weight [n -S]\n",
  "TOLAN": "a white crystalline derivative of acetylene, also TOLANE [n -S]\n",
  "TOLANE": "a white crystalline derivative of acetylene, also TOLAN [n -S]\n",
  "TOLANES": "TOLANE, a white crystalline derivative of acetylene, also TOLAN [n]\n",
  "TOLANS": "TOLAN, a white crystalline derivative of acetylene, also TOLANE [n]\n",
  "TOLAR": "(Slovene) the standard monetary unit of Slovenia [n TOLARS or TOLARJEV or TOLARJI]\n",
  "TOLARJEV": "TOLAR, (Slovene) the standard monetary unit of Slovenia [n]\n",
  "TOLARJI": "TOLAR, (Slovene) the standard monetary unit of Slovenia [n]\n",
  "TOLARS": "TOLAR, (Slovene) the standard monetary unit of Slovenia [n]\n",
  "TOLAS": "TOLA, (Hindi) an Indian unit of weight [n]\n",
  "TOLBOOTH": "(Scots) a town hall, a prison, also TOLLBOOTH [n -S]\n",
  "TOLBOOTHS": "TOLBOOTH, (Scots) a town hall, a prison, also TOLLBOOTH [n]\n",
  "TOLBUTAMIDE": "a sulfonylurea used in the treatment of diabetes [n -S]\n",
  "TOLBUTAMIDES": "TOLBUTAMIDE, a sulfonylurea used in the treatment of diabetes [n]\n",
  "TOLD": "TELL, to inform [v]\n",
  "TOLE": "to lure or decoy [v TOLED, TOLING, TOLES]\n",
  "TOLED": "TOLE, to lure or decoy [v]\n",
  "TOLEDO": "(Spanish) a sword or sword blade made at Toledo in Spain [n -S]\n",
  "TOLEDOS": "TOLEDO, (Spanish) a sword or sword blade made at Toledo in Spain [n]\n",
  "TOLERABILITIES": "TOLERABILITY, the state of being tolerable [n]\n",
  "TOLERABILITY": "the state of being tolerable [n TOLERABILITIES]\n",
  "TOLERABLE": "that can be tolerated [adj TOLERABLY]\n",
  "TOLERABLENESS": "the state of being tolerable [n -ES]\n",
  "TOLERABLENESSES": "TOLERABLENESS, the state of being tolerable [n]\n",
  "TOLERABLY": "TOLERABLE, that can be tolerated [adv]\n",
  "TOLERANCE": "the state of being tolerant [n -S]\n",
  "TOLERANCES": "TOLERANCE, the state of being tolerant [n]\n",
  "TOLERANT": "inclined to tolerate [adj TOLERANTLY]\n",
  "TOLERANTLY": "TOLERANT, inclined to tolerate [adv]\n",
  "TOLERATE": "to endure with patience [v TOLERATED, TOLERATING, TOLERATES]\n",
  "TOLERATED": "TOLERATE, to endure with patience [v]\n",
  "TOLERATES": "TOLERATE, to endure with patience [v]\n",
  "TOLERATING": "TOLERATE, to endure with patience [v]\n",
  "TOLERATION": "the act or practice of tolerating something [n -S]\n",
  "TOLERATIONISM": "the policy of tolerance [n -S]\n",
  "TOLERATIONISMS": "TOLERATIONISM, the policy of tolerance [n]\n",
  "TOLERATIONIST": "a believer in tolerationism [n -S]\n",
  "TOLERATIONISTS": "TOLERATIONIST, a believer in tolerationism [n]\n",
  "TOLERATIONS": "TOLERATION, the act or practice of tolerating something [n]\n",
  "TOLERATIVE": "relating to toleration [adj]\n",
  "TOLERATOR": "one who tolerates [n -S]\n",
  "TOLERATORS": "TOLERATOR, one who tolerates [n]\n",
  "TOLES": "TOLE, to lure or decoy [v]\n",
  "TOLEWARE": "articles made of tole, painted lacquer [n -S]\n",
  "TOLEWARES": "TOLEWARE, articles made of tole, painted lacquer [n]\n",
  "TOLIDIN": "a type of organic compound, also TOLIDINE [n -S]\n",
  "TOLIDINE": "a type of organic compound, also TOLIDIN [n -S]\n",
  "TOLIDINES": "TOLIDINE, a type of organic compound, also TOLIDIN [n]\n",
  "TOLIDINS": "TOLIDIN, a type of organic compound, also TOLIDINE [n]\n",
  "TOLING": "the act of toling, luring [n -S]\n",
  "TOLINGS": "TOLING, the act of toling, luring [n]\n",
  "TOLL": "to sound, as a large bell does, esp. with slow, measured strokes [v -ED, -ING, -S]\n",
  "TOLLABLE": "subject to toll [adj]\n",
  "TOLLAGE": "payment of toll; also, the amount or quantity paid as toll [n -S]\n",
  "TOLLAGES": "TOLLAGE, payment of toll; also, the amount or quantity paid as toll [n]\n",
  "TOLLBAR": "a movable bar across a road to stop travellers passing before they have paid a toll [n -S]\n",
  "TOLLBARS": "TOLLBAR, a movable bar across a road to stop travellers passing before they have paid a toll [n]\n",
  "TOLLBOOTH": "(Scots) a town hall, a prison, also TOLBOOTH [n -S]\n",
  "TOLLBOOTHS": "TOLLBOOTH, (Scots) a town hall, a prison, also TOLBOOTH [n]\n",
  "TOLLBRIDGE": "a bridge where tolls are collected [n -S]\n",
  "TOLLBRIDGES": "TOLLBRIDGE, a bridge where tolls are collected [n]\n",
  "TOLLDISH": "a grain measure dish for toll [n -ES]\n",
  "TOLLDISHES": "TOLLDISH, a grain measure dish for toll [n]\n",
  "TOLLED": "TOLL, to sound, as a large bell does, esp. with slow, measured strokes [v]\n",
  "TOLLER": "a collector of tolls [n -S]\n",
  "TOLLERS": "TOLLER, a collector of tolls [n]\n",
  "TOLLEY": "in the game of marbles, a marble fired at others to drive them from the central ring [n -S]\n",
  "TOLLEYS": "TOLLEY, in the game of marbles, a marble fired at others to drive them from the central ring [n]\n",
  "TOLLGATE": "to block a business deal pending the payment of a bribe [v TOLLGATED, TOLLGATING, TOLLGATES]\n",
  "TOLLGATED": "TOLLGATE, to block a business deal pending the payment of a bribe [v]\n",
  "TOLLGATES": "TOLLGATE, to block a business deal pending the payment of a bribe [v]\n",
  "TOLLGATING": "TOLLGATE, to block a business deal pending the payment of a bribe [v]\n",
  "TOLLHOUSE": "a house occupied by a receiver of tolls [n -S]\n",
  "TOLLHOUSES": "TOLLHOUSE, a house occupied by a receiver of tolls [n]\n",
  "TOLLIE": "a castrated calf, also TOLLY [n -S]\n",
  "TOLLIES": "TOLLIE, a castrated calf, also TOLLY [n]\n",
  "TOLLING": "the action of tolling e.g. a bell [n -S]\n",
  "TOLLINGS": "TOLLING, the action of tolling e.g. a bell [n]\n",
  "TOLLKEEPER": "a person whose job is to collect tolls at a bridge, road etc. where a charge is made [n -S]\n",
  "TOLLKEEPERS": "TOLLKEEPER, a person whose job is to collect tolls at a bridge, road etc. where a charge is made [n]\n",
  "TOLLMAN": "one who receives or collects toll; a toll gatherer [n TOLLMEN]\n",
  "TOLLMEN": "TOLLMAN, one who receives or collects toll; a toll gatherer [n]\n",
  "TOLLS": "TOLL, to sound, as a large bell does, esp. with slow, measured strokes [v]\n",
  "TOLLWAY": "a road on which tolls are collected [n -S]\n",
  "TOLLWAYS": "TOLLWAY, a road on which tolls are collected [n]\n",
  "TOLLY": "a castrated calf, also TOLLIE [n TOLLIES]\n",
  "TOLSEL": "a merchants' meeting place, also TOLSEY, TOLZEY [n -S]\n",
  "TOLSELS": "TOLSEL, a merchants' meeting place, also TOLSEY, TOLZEY [n]\n",
  "TOLSEY": "a merchants' meeting place, also TOLSEL, TOLZEY [n -S]\n",
  "TOLSEYS": "TOLSEY, a merchants' meeting place, also TOLSEL, TOLZEY [n]\n",
  "TOLT": "a kind of writ in Old English law [n -S]\n",
  "TOLTER": "(dialect) to flounder about [v -ED, -ING, -S]\n",
  "TOLTERED": "TOLTER, (dialect) to flounder about [v]\n",
  "TOLTERING": "TOLTER, (dialect) to flounder about [v]\n",
  "TOLTERS": "TOLTER, (dialect) to flounder about [v]\n",
  "TOLTS": "TOLT, a kind of writ in Old English law [n]\n",
  "TOLU": "a fragrant balsam said to have been first brought from Santiago de Tolu, in New Granada [n -S]\n",
  "TOLUATE": "a salt of any one of the toluic acids [n -S]\n",
  "TOLUATES": "TOLUATE, a salt of any one of the toluic acids [n]\n",
  "TOLUENE": "a solvent derived from coal tar, also TOLUOL, TOLUOLE [n -S]\n",
  "TOLUENES": "TOLUENE, a solvent derived from coal tar, also TOLUOL, TOLUOLE [n]\n",
  "TOLUIC": "containing toluene [adj]\n",
  "TOLUID": "a derivative of glycocoll, also TOLUIDE, TOLUIDIN [n -S]\n",
  "TOLUIDE": "a derivative of glycocoll, also TOLUID, TOLUIDIN [n -S]\n",
  "TOLUIDES": "TOLUIDE, a derivative of glycocoll, also TOLUID, TOLUIDIN [n]\n",
  "TOLUIDIDE": "a chemical deriving from toluene [n -S]\n",
  "TOLUIDIDES": "TOLUIDIDE, a chemical deriving from toluene [n]\n",
  "TOLUIDIN": "any one of three amido derivatives of toluene analogous to aniline, also TOLUIDINE [n -S]\n",
  "TOLUIDINE": "any one of three amido derivatives of toluene analogous to aniline, also TOLUIDIN [n -S]\n",
  "TOLUIDINES": "TOLUIDINE, any one of three amido derivatives of toluene analogous to aniline, also TOLUIDIN [n]\n",
  "TOLUIDINS": "TOLUIDIN, any one of three amido derivatives of toluene analogous to aniline, also TOLUIDINE [n]\n",
  "TOLUIDS": "TOLUID, a derivative of glycocoll, also TOLUIDE, TOLUIDIN [n]\n",
  "TOLUOL": "a solvent derived from coal tar, also TOLUENE, TOLUOLE [n -S]\n",
  "TOLUOLE": "a solvent derived from coal tar, also TOLUENE, TOLUOL [n -S]\n",
  "TOLUOLES": "TOLUOLE, a solvent derived from coal tar, also TOLUENE, TOLUOL [n]\n",
  "TOLUOLS": "TOLUOL, a solvent derived from coal tar, also TOLUENE, TOLUOLE [n]\n",
  "TOLUS": "TOLU, a fragrant balsam said to have been first brought from Santiago de Tolu, in New Granada [n]\n",
  "TOLUYL": "a chemical radical derived from toluic acid, also TOLYL [n -S]\n",
  "TOLUYLS": "TOLUYL, a chemical radical derived from toluic acid, also TOLYL [n]\n",
  "TOLYL": "a chemical radical derived from toluic acid, also TOLUYL [n -S]\n",
  "TOLYLS": "TOLYL, a chemical radical derived from toluic acid, also TOLUYL [n]\n",
  "TOLZEY": "a merchants' meeting place, also TOLSEL, TOLSEY [n -S]\n",
  "TOLZEYS": "TOLZEY, a merchants' meeting place, also TOLSEL, TOLSEY [n]\n",
  "TOM": "to engage in prostitution [v TOMMED, TOMMING, TOMS]\n",
  "TOMAHAWK": "(Native American) to strike with a short axe [v -ED, -ING, -S]\n",
  "TOMAHAWKED": "TOMAHAWK, (Native American) to strike with a short axe [v]\n",
  "TOMAHAWKING": "TOMAHAWK, (Native American) to strike with a short axe [v]\n",
  "TOMAHAWKS": "TOMAHAWK, (Native American) to strike with a short axe [v]\n",
  "TOMALLEY": "(Caribbean) the liver of the lobster, which makes a green sauce when cooked [n -S]\n",
  "TOMALLEYS": "TOMALLEY, (Caribbean) the liver of the lobster, which makes a green sauce when cooked [n]\n",
  "TOMAN": "(Persian) a former Persian gold coin and money of account, nominally worth 10,000 dinars [n -S]\n",
  "TOMANS": "TOMAN, (Persian) a former Persian gold coin and money of account, nominally worth 10,000 dinars [n]\n",
  "TOMATILLO": "(Spanish) a plant of the nightshade family, native to Mexico [n -ES or -S]\n",
  "TOMATILLOES": "TOMATILLO, (Spanish) a plant of the nightshade family, native to Mexico [n]\n",
  "TOMATILLOS": "TOMATILLO, (Spanish) a plant of the nightshade family, native to Mexico [n]\n",
  "TOMATO": "the edible fruit of a plant [n -ES]\n",
  "TOMATOES": "TOMATO, the edible fruit of a plant [n]\n",
  "TOMATOEY": "resembling the tomato [adj TOMATOIER, TOMATOIEST]\n",
  "TOMATOIER": "TOMATOEY, resembling the tomato [adj]\n",
  "TOMATOIEST": "TOMATOEY, resembling the tomato [adj]\n",
  "TOMB": "to place in a burial vault [v -ED, -ING, -S]\n",
  "TOMBAC": "(Malay) an alloy of copper and zinc, also TAMBAC, TAMBAK, TOMBACK, TOMBAK [n -S]\n",
  "TOMBACK": "(Malay) an alloy of copper and zinc, also TOMBAC, TAMBAC, TAMBAK, TOMBAK [n -S]\n",
  "TOMBACKS": "TOMBACK, (Malay) an alloy of copper and zinc, also TOMBAC, TAMBAC, TAMBAK, TOMBAK [n]\n",
  "TOMBACS": "TOMBAC, (Malay) an alloy of copper and zinc, also TAMBAC, TAMBAK, TOMBACK, TOMBAK [n]\n",
  "TOMBAK": "(Malay) an alloy of copper and zinc, also TAMBAC, TAMBAK, TOMBAC, TOMBACK [n -S]\n",
  "TOMBAKS": "TOMBAK, (Malay) an alloy of copper and zinc, also TAMBAC, TAMBAK, TOMBAC, TOMBACK [n]\n",
  "TOMBAL": "pertaining to a tomb, also TOMBIC [adj]\n",
  "TOMBED": "TOMB, to place in a burial vault [v]\n",
  "TOMBIC": "pertaining to a tomb, also TOMBAL [adj]\n",
  "TOMBING": "TOMB, to place in a burial vault [v]\n",
  "TOMBLESS": "without a tomb [adj]\n",
  "TOMBLIKE": "like a tomb [adj]\n",
  "TOMBOC": "a Javanese long-handled weapon [n -S]\n",
  "TOMBOCS": "TOMBOC, a Javanese long-handled weapon [n]\n",
  "TOMBOLA": "(Italian) a gambling game [n -S]\n",
  "TOMBOLAS": "TOMBOLA, (Italian) a gambling game [n]\n",
  "TOMBOLO": "(Italian) a sandbar connecting an island to the mainland [n -S]\n",
  "TOMBOLOS": "TOMBOLO, (Italian) a sandbar connecting an island to the mainland [n]\n",
  "TOMBOY": "a girl who acts like a boy [n -S]\n",
  "TOMBOYISH": "like a tomboy [adj TOMBOYISHLY]\n",
  "TOMBOYISHLY": "TOMBOYISH, like a tomboy [adv]\n",
  "TOMBOYISHNESS": "the state of being tomboyish [n -ES]\n",
  "TOMBOYISHNESSES": "TOMBOYISHNESS, the state of being tomboyish [n]\n",
  "TOMBOYS": "TOMBOY, a girl who acts like a boy [n]\n",
  "TOMBS": "TOMB, to place in a burial vault [v]\n",
  "TOMBSTONE": "a stone erected over a grave, to preserve the memory of the deceased [n -S]\n",
  "TOMBSTONES": "TOMBSTONE, a stone erected over a grave, to preserve the memory of the deceased [n]\n",
  "TOMBSTONING": "(slang) the activity of diving off cliffs into the sea [n -S]\n",
  "TOMBSTONINGS": "TOMBSTONING, (slang) the activity of diving off cliffs into the sea [n]\n",
  "TOMCAT": "to engage in sexually promiscuous behaviour (a male) [v TOMCATTED, TOMCATTING, TOMCATS]\n",
  "TOMCATS": "TOMCAT, to engage in sexually promiscuous behaviour (a male) [v]\n",
  "TOMCATTED": "TOMCAT, to engage in sexually promiscuous behaviour (a male) [v]\n",
  "TOMCATTING": "engaging in sexually promiscuous behaviour [n -S]\n",
  "TOMCATTINGS": "TOMCATTING, engaging in sexually promiscuous behaviour [n]\n",
  "TOMCOD": "a kind of cod, also TOMMYCOD [n -S]\n",
  "TOMCODS": "TOMCOD, a kind of cod, also TOMMYCOD [n]\n",
  "TOME": "a large, usually scholarly, book or volume [n -S]\n",
  "TOMENTA": "TOMENTUM, (Latin) the closely matted hair or downy nap covering the leaves or stems of some plants [n]\n",
  "TOMENTOSE": "bearing thickly matted hair or fur, also TOMENTOUS [adj]\n",
  "TOMENTOUS": "bearing thickly matted hair or fur, also TOMENTOSE [adj]\n",
  "TOMENTUM": "(Latin) the closely matted hair or downy nap covering the leaves or stems of some plants [n TOMENTA]\n",
  "TOMES": "TOME, a large, usually scholarly, book or volume [n]\n",
  "TOMFOOL": "to play the fool [v -ED, -ING, -S]\n",
  "TOMFOOLED": "TOMFOOL, to play the fool [v]\n",
  "TOMFOOLERIES": "TOMFOOLERY, playful or foolish behavior [n]\n",
  "TOMFOOLERY": "playful or foolish behavior [n TOMFOOLERIES]\n",
  "TOMFOOLING": "TOMFOOL, to play the fool [v]\n",
  "TOMFOOLISH": "foolish [adj]\n",
  "TOMFOOLISHNESS": "the state of being tomfoolish [n]\n",
  "TOMFOOLS": "TOMFOOL, to play the fool [v]\n",
  "TOMIA": "TOMIUM, (Greek) the cutting edge of a bird's bill [n]\n",
  "TOMIAL": "relating to the tomium, the cutting edge of a bird's bill [adj]\n",
  "TOMIUM": "(Greek) the cutting edge of a bird's bill [n TOMIA]\n",
  "TOMMED": "TOM, to engage in prostitution [v]\n",
  "TOMMIED": "TOMMY, to oppress by the truck system [v]\n",
  "TOMMIES": "TOMMY, to oppress by the truck system [v]\n",
  "TOMMING": "TOM, to engage in prostitution [v]\n",
  "TOMMY": "to oppress by the truck system [v TOMMIED, TOMMYING, TOMMIES]\n",
  "TOMMYCOD": "a kind of cod, also TOMCOD [n -S]\n",
  "TOMMYCODS": "TOMMYCOD, a kind of cod, also TOMCOD [n]\n",
  "TOMMYING": "TOMMY, to oppress by the truck system [v]\n",
  "TOMMYROT": "nonsense [n -S]\n",
  "TOMMYROTS": "TOMMYROT, nonsense [n]\n",
  "TOMO": "(Maori) a shaft formed by the action of water on volcanic or limestone rock [n -S]\n",
  "TOMOGRAM": "a photograph made with X rays [n -S]\n",
  "TOMOGRAMS": "TOMOGRAM, a photograph made with X rays [n]\n",
  "TOMOGRAPH": "an instrument for viewing a section of an object using X-rays [n -S]\n",
  "TOMOGRAPHIC": "relating to tomography [adj]\n",
  "TOMOGRAPHIES": "TOMOGRAPHY, X-ray photography in which parts of body in front of, or behind, the part under examination are not shown [n]\n",
  "TOMOGRAPHS": "TOMOGRAPH, an instrument for viewing a section of an object using X-rays [n]\n",
  "TOMOGRAPHY": "X-ray photography in which parts of body in front of, or behind, the part under examination are not shown [n TOMOGRAPHIES]\n",
  "TOMORROW": "the day following today [n -S]\n",
  "TOMORROWS": "TOMORROW, the day following today [n]\n",
  "TOMOS": "TOMO, (Maori) a shaft formed by the action of water on volcanic or limestone rock [n]\n",
  "TOMPION": "(French) a protective plug placed in mouth of gun or cannon, also TAMPION [n -S]\n",
  "TOMPIONS": "TOMPION, (French) a protective plug placed in mouth of gun or cannon, also TAMPION [n]\n",
  "TOMPON": "(French) a plug in a wound to staunch flow of blood [n -S] / to plug with a tompon, also TAMPON [v -ED, -ING, -S]\n",
  "TOMPONED": "TOMPON, to plug with a tompon, also TAMPON [v]\n",
  "TOMPONING": "TOMPON, to plug with a tompon, also TAMPON [v]\n",
  "TOMPONS": "TOMPON, to plug with a tompon, also TAMPON [v]\n",
  "TOMPOT": "as in tompot blenny, a variety of blenny with tentacles over its eyes [adj]\n",
  "TOMS": "TOM, to engage in prostitution [v]\n",
  "TOMTIT": "a small bird, e.g. a titmouse [n -S]\n",
  "TOMTITS": "TOMTIT, a small bird, e.g. a titmouse [n]\n",
  "TON": "a unit of weight [n -S]\n",
  "TONAL": "pertaining to tone [adj]\n",
  "TONALITE": "a coarse rock [n -S]\n",
  "TONALITES": "TONALITE, a coarse rock [n]\n",
  "TONALITIC": "of or like tonalite, a coarse-grained igneous rock [adj]\n",
  "TONALITIES": "TONALITY, the sum of relations between the tones or notes of a scale or key [n]\n",
  "TONALITIVE": "relating to tonality [adj]\n",
  "TONALITY": "the sum of relations between the tones or notes of a scale or key [n TONALITIES]\n",
  "TONALLY": "TONAL, pertaining to tone [adv]\n",
  "TONANT": "thundering [adj]\n",
  "TONDI": "TONDO, (Italian) a circular painting or relief carving [n]\n",
  "TONDINI": "TONDINO, (Italian) a circular moulding [n]\n",
  "TONDINO": "(Italian) a circular moulding [n TONDINOS or TONDINI]\n",
  "TONDINOS": "TONDINO, (Italian) a circular moulding [n]\n",
  "TONDO": "(Italian) a circular painting or relief carving [n TONDI or TONDOS]\n",
  "TONDOS": "TONDO, (Italian) a circular painting or relief carving [n]\n",
  "TONE": "to give a particular tone to [v TONED, TONING, TONES]\n",
  "TONEARM": "the pivoted part of a record player that holds the needle [n -S]\n",
  "TONEARMS": "TONEARM, the pivoted part of a record player that holds the needle [n]\n",
  "TONED": "TONE, to give a particular tone to [v]\n",
  "TONELESS": "without tone [adj TONELESSLY]\n",
  "TONELESSLY": "TONELESS, without tone [adv]\n",
  "TONELESSNESS": "the state of being toneless [n -ES]\n",
  "TONELESSNESSES": "TONELESSNESS, the state of being toneless [n]\n",
  "TONEME": "in a tone language, a phoneme that can be distinguished from another only by its tone intonation [n -S]\n",
  "TONEMES": "TONEME, in a tone language, a phoneme that can be distinguished from another only by its tone intonation [n]\n",
  "TONEMIC": "relating to a toneme [adj]\n",
  "TONEPAD": "an electronic device that allows data to be input into a computer from a distance [n -S]\n",
  "TONEPADS": "TONEPAD, an electronic device that allows data to be input into a computer from a distance [n]\n",
  "TONER": "fine powdered pigment used in xerography [n -S]\n",
  "TONERS": "TONER, fine powdered pigment used in xerography [n]\n",
  "TONES": "TONE, to give a particular tone to [v]\n",
  "TONETIC": "of or relating to tonal pronunciation or languages [adj TONETICALLY]\n",
  "TONETICALLY": "TONETIC, of or relating to tonal pronunciation or languages [adv]\n",
  "TONETICS": "the phonetic study of tone in language [n]\n",
  "TONETTE": "a simple flute [n -S]\n",
  "TONETTES": "TONETTE, a simple flute [n]\n",
  "TONEY": "high-toned, fashionable, also TONY [adj TONIER, TONIEST]\n",
  "TONG": "to lift with tongs, a grasping device [v -ED, -ING, -S]\n",
  "TONGA": "(Hindi) a light two-wheeled Indian vehicle [n -S]\n",
  "TONGAS": "TONGA, (Hindi) a light two-wheeled Indian vehicle [n]\n",
  "TONGED": "TONG, to lift with tongs, a grasping device [v]\n",
  "TONGER": "a person who gathers oysters with oyster-tongs [n -S]\n",
  "TONGERS": "TONGER, a person who gathers oysters with oyster-tongs [n]\n",
  "TONGING": "TONG, to lift with tongs, a grasping device [v]\n",
  "TONGMAN": "(Chinese) a member of a Chinese tong, also TONGSTER [n TONGMEN]\n",
  "TONGMEN": "TONGMAN, (Chinese) a member of a Chinese tong, also TONGSTER [n]\n",
  "TONGS": "TONG, to lift with tongs, a grasping device [v]\n",
  "TONGSTER": "(Chinese) a member of a Chinese tong, also TONGMAN [n -S]\n",
  "TONGSTERS": "TONGSTER, (Chinese) a member of a Chinese tong, also TONGMAN [n]\n",
  "TONGUE": "to touch with the fleshy organ of the mouth [v TONGUED, TONGUING, TONGUES]\n",
  "TONGUED": "TONGUE, to touch with the fleshy organ of the mouth [v]\n",
  "TONGUELESS": "having no tongue [adj]\n",
  "TONGUELET": "a little tongue [n -S]\n",
  "TONGUELETS": "TONGUELET, a little tongue [n]\n",
  "TONGUELIKE": "like a tongue [adj]\n",
  "TONGUES": "TONGUE, to touch with the fleshy organ of the mouth [v]\n",
  "TONGUESTER": "one who uses his tongue; a gossip [n -S]\n",
  "TONGUESTERS": "TONGUESTER, one who uses his tongue; a gossip [n]\n",
  "TONGUING": "the use of the tongue in playing a wind instrument [n -S]\n",
  "TONGUINGS": "TONGUING, the use of the tongue in playing a wind instrument [n]\n",
  "TONIC": "invigorating [adj TONICALLY] / something that invigorates or refreshes [n -S]\n",
  "TONICALLY": "TONIC, invigorating [adv]\n",
  "TONICITIES": "TONICITY, normal, healthy bodily condition [n]\n",
  "TONICITY": "normal, healthy bodily condition [n TONICITIES]\n",
  "TONICS": "TONIC, something that invigorates or refreshes [n]\n",
  "TONIER": "TONY, high-toned, also TONEY [adj]\n",
  "TONIES": "TONY, (obsolete) a simpleton [n]\n",
  "TONIEST": "TONY, high-toned, also TONEY [adj]\n",
  "TONIFIED": "TONIFY, to give tone to [v]\n",
  "TONIFIES": "TONIFY, to give tone to [v]\n",
  "TONIFY": "to give tone to [v TONIFIED, TONIFYING, TONIFIES]\n",
  "TONIFYING": "TONIFY, to give tone to [v]\n",
  "TONIGHT": "the present night [n -S]\n",
  "TONIGHTS": "TONIGHT, the present night [n]\n",
  "TONING": "a quality or character of sound [n -S]\n",
  "TONINGS": "TONING, a quality or character of sound [n]\n",
  "TONISH": "modish; fashionable, also TONNISH [adj TONISHLY]\n",
  "TONISHLY": "TONISH, modish; fashionable, also TONNISH [adv]\n",
  "TONISHNESS": "the state of being tonish, modish, also TONNISHNESS [n -ES]\n",
  "TONISHNESSES": "TONISHNESS, the state of being tonish, modish, also TONNISHNESS [n]\n",
  "TONITE": "a blasting explosive [n -S]\n",
  "TONITES": "TONITE, a blasting explosive [n]\n",
  "TONK": "(Australian slang) to hit e.g. a cricket-ball into the air [v -ED, -ING, -S]\n",
  "TONKA": "(Tupi) as in tonka bean, a tall leguminous African tree with fragrant black almond-shaped seeds [adj]\n",
  "TONKED": "TONK, (Australian slang) to hit e.g. a cricket-ball into the air [v]\n",
  "TONKER": "one who tonks, hits e.g. a cricket-ball into the air [n -S]\n",
  "TONKERS": "TONKER, one who tonks, hits e.g. a cricket-ball into the air [n]\n",
  "TONKING": "TONK, (Australian slang) to hit e.g. a cricket-ball into the air [v]\n",
  "TONKS": "TONK, (Australian slang) to hit e.g. a cricket-ball into the air [v]\n",
  "TONLET": "a set of overlapping strips on armour skirt [n -S]\n",
  "TONLETS": "TONLET, a set of overlapping strips on armour skirt [n]\n",
  "TONNAG": "(Gaelic) a shawl with a shaped neck and side fastening [n -S]\n",
  "TONNAGE": "total weight in tons, also TUNNAGE [n -S]\n",
  "TONNAGES": "TONNAGE, total weight in tons, also TUNNAGE [n]\n",
  "TONNAGS": "TONNAG, (Gaelic) a shawl with a shaped neck and side fastening [n]\n",
  "TONNE": "(French) the preferred name for a metric ton, a unit of weight equal to 1000 kilograms [n -S]\n",
  "TONNEAU": "(French) the rear extension of the body of a car [n TONNEAUX or TONNEAUS]\n",
  "TONNEAUS": "TONNEAU, (French) the rear extension of the body of a car [n]\n",
  "TONNEAUX": "TONNEAU, (French) the rear extension of the body of a car [n]\n",
  "TONNELL": "(obsolete) a tunnel [n -S]\n",
  "TONNELLS": "TONNELL, (obsolete) a tunnel [n]\n",
  "TONNER": "an object having a specified tonnage [n -S]\n",
  "TONNERS": "TONNER, an object having a specified tonnage [n]\n",
  "TONNES": "TONNE, (French) the preferred name for a metric ton, a unit of weight equal to 1000 kilograms [n]\n",
  "TONNISH": "modish; fashionable, also TONISH [adj TONNISHLY]\n",
  "TONNISHLY": "TONNISH, modish; fashionable, also TONISH [adv]\n",
  "TONNISHNESS": "the state of being tonnish, modish, also TONISHNESS [n -ES]\n",
  "TONNISHNESSES": "TONNISHNESS, the state of being tonnish, modish, also TONISHNESS [n]\n",
  "TONOMETER": "an instrument used to measure the pitch of musical tones [n -S]\n",
  "TONOMETERS": "TONOMETER, an instrument used to measure the pitch of musical tones [n]\n",
  "TONOMETRIC": "relating to a tonometer, an instrument used to measure the pitch of musical tones [adj]\n",
  "TONOMETRIES": "TONOMETRY, the act of measuring with a tonometer, an instrument used to measure the pitch of musical tones [n]\n",
  "TONOMETRY": "the act of measuring with a tonometer, an instrument used to measure the pitch of musical tones [n TONOMETRIES]\n",
  "TONOPLAST": "a semipermeable membrane surrounding a plant vacuole [n -S]\n",
  "TONOPLASTS": "TONOPLAST, a semipermeable membrane surrounding a plant vacuole [n]\n",
  "TONS": "TON, a unit of weight [n]\n",
  "TONSIL": "a lymphoid organ [n -S]\n",
  "TONSILAR": "relating to the tonsils, also TONSILLAR, TONSILLARY [adj]\n",
  "TONSILITIS": "inflammation of the tonsils, also TONSILLITIS [n -ES]\n",
  "TONSILITISES": "TONSILITIS, inflammation of the tonsils, also TONSILLITIS [n]\n",
  "TONSILLAR": "relating to the tonsils, also TONSILAR, TONSILLARY [adj]\n",
  "TONSILLARY": "relating to the tonsils, also TONSILAR, TONSILLAR [adj]\n",
  "TONSILLECTOMIES": "TONSILLECTOMY, the surgical removal of the tonsils [n]\n",
  "TONSILLECTOMY": "the surgical removal of the tonsils [n TONSILLECTOMIES]\n",
  "TONSILLITIC": "relating to tonsillitis [adj]\n",
  "TONSILLITIDES": "TONSILLITIS, inflammation of the tonsils, also TONSILITIS [n]\n",
  "TONSILLITIS": "inflammation of the tonsils, also TONSILITIS [n TONSILLITIDES or TONSILLITISES]\n",
  "TONSILLITISES": "TONSILLITIS, inflammation of the tonsils, also TONSILITIS [n]\n",
  "TONSILLOTOMIES": "TONSILLOTOMY, the surgical removal of the tonsils [n]\n",
  "TONSILLOTOMY": "the surgical removal of the tonsils [n TONSILLOTOMIES]\n",
  "TONSILS": "TONSIL, a lymphoid organ [n]\n",
  "TONSOR": "(Latin) a barber [n -S]\n",
  "TONSORIAL": "relating to a barber or a barber's work [adj]\n",
  "TONSORS": "TONSOR, (Latin) a barber [n]\n",
  "TONSURE": "to shave the head of [v TONSURED, TONSURING, TONSURES]\n",
  "TONSURED": "TONSURE, to shave the head of [v]\n",
  "TONSURES": "TONSURE, to shave the head of [v]\n",
  "TONSURING": "TONSURE, to shave the head of [v]\n",
  "TONTINE": "a form of collective life insurance [n -S]\n",
  "TONTINER": "the receiver of an annuity [n -S]\n",
  "TONTINERS": "TONTINER, the receiver of an annuity [n]\n",
  "TONTINES": "TONTINE, a form of collective life insurance [n]\n",
  "TONUS": "(Greek) the normal state of tension in muscle tissue, also TONICITY [n -ES]\n",
  "TONUSES": "TONUS, (Greek) the normal state of tension in muscle tissue, also TONICITY [n]\n",
  "TONY": "high-toned, also TONEY [adj TONIER, TONIEST] / (obsolete) a simpleton [n TONIES]\n",
  "TOO": "in addition [adv]\n",
  "TOOART": "(Native Australian) a strong-timbered eucalyptus, also TEWART, TUART [n -S]\n",
  "TOOARTS": "TOOART, (Native Australian) a strong-timbered eucalyptus, also TEWART, TUART [n]\n",
  "TOODLE": "to toot softly, also TOOTLE [v TOODLED, TOODLING, TOODLES]\n",
  "TOODLED": "TOODLE, to toot softly, also TOOTLE [v]\n",
  "TOODLES": "TOODLE, to toot softly, also TOOTLE [v]\n",
  "TOODLING": "TOODLE, to toot softly, also TOOTLE [v]\n",
  "TOOK": "TAKE, to seize possession [v]\n",
  "TOOL": "to use an implement for manual work [v -ED, -ING, -S]\n",
  "TOOLBAG": "a container for tools [n -S]\n",
  "TOOLBAGS": "TOOLBAG, a container for tools [n]\n",
  "TOOLBAR": "a bar with a list of utilities [n -S]\n",
  "TOOLBARS": "TOOLBAR, a bar with a list of utilities [n]\n",
  "TOOLBOX": "a box for tools [n -ES]\n",
  "TOOLBOXES": "TOOLBOX, a box for tools [n]\n",
  "TOOLCASE": "a case for tools [n -S]\n",
  "TOOLCASES": "TOOLCASE, a case for tools [n]\n",
  "TOOLCHEST": "a chest for holding tools [n -S]\n",
  "TOOLCHESTS": "TOOLCHEST, a chest for holding tools [n]\n",
  "TOOLED": "TOOL, to use an implement for manual work [v]\n",
  "TOOLER": "a person who tools the covers of books [n -S]\n",
  "TOOLERS": "TOOLER, a person who tools the covers of books [n]\n",
  "TOOLHEAD": "a part of a machine [n -S]\n",
  "TOOLHEADS": "TOOLHEAD, a part of a machine [n]\n",
  "TOOLHOLDER": "a holder for tools [n -S]\n",
  "TOOLHOLDERS": "TOOLHOLDER, a holder for tools [n]\n",
  "TOOLHOUSE": "a place where tools are stored [n -S]\n",
  "TOOLHOUSES": "TOOLHOUSE, a place where tools are stored [n]\n",
  "TOOLIE": "(Australian slang) in Australia, an adult who gatecrashes the Schoolies Week celebrations, especially one who makes sexual advances towards students [n -S]\n",
  "TOOLIES": "TOOLIE, (Australian slang) in Australia, an adult who gatecrashes the Schoolies Week celebrations, especially one who makes sexual advances towards students [n]\n",
  "TOOLING": "ornamentation done with tools [n -S]\n",
  "TOOLINGS": "TOOLING, ornamentation done with tools [n]\n",
  "TOOLKIT": "a set of tools [n -S]\n",
  "TOOLKITS": "TOOLKIT, a set of tools [n]\n",
  "TOOLLESS": "without tools [adj]\n",
  "TOOLMAKER": "one who makes tools [n -S]\n",
  "TOOLMAKERS": "TOOLMAKER, one who makes tools [n]\n",
  "TOOLMAKING": "the action, process, or art of making tools [n -S]\n",
  "TOOLMAKINGS": "TOOLMAKING, the action, process, or art of making tools [n]\n",
  "TOOLMAN": "a man who works with tools [n TOOLMEN]\n",
  "TOOLMEN": "TOOLMAN, a man who works with tools [n]\n",
  "TOOLPUSH": "a worker who directs the drilling on an oil rig [n -ES]\n",
  "TOOLPUSHER": "a supervisor of drilling operations at an oil well [n -S]\n",
  "TOOLPUSHERS": "TOOLPUSHER, a supervisor of drilling operations at an oil well [n]\n",
  "TOOLPUSHES": "TOOLPUSH, a worker who directs the drilling on an oil rig [n]\n",
  "TOOLROOM": "a room where tools are stored [n -S]\n",
  "TOOLROOMS": "TOOLROOM, a room where tools are stored [n]\n",
  "TOOLS": "TOOL, to use an implement for manual work [v]\n",
  "TOOLSET": "a group of related tools in a computer application [n -S]\n",
  "TOOLSETS": "TOOLSET, a group of related tools in a computer application [n]\n",
  "TOOLSHED": "a shed where tools are stored [n -S]\n",
  "TOOLSHEDS": "TOOLSHED, a shed where tools are stored [n]\n",
  "TOOLTIP": "a box on a computer screen containing supplementary information that appears when a particular feature is used [n -S]\n",
  "TOOLTIPS": "TOOLTIP, a box on a computer screen containing supplementary information that appears when a particular feature is used [n]\n",
  "TOOM": "(Scots) empty [adj TOOMER, TOOMEST] / to empty [v -ED, -ING, -S]\n",
  "TOOMED": "TOOM, to empty [v]\n",
  "TOOMER": "TOOM, (Scots) empty [adj]\n",
  "TOOMEST": "TOOM, (Scots) empty [adj]\n",
  "TOOMING": "TOOM, to empty [v]\n",
  "TOOMS": "TOOM, to empty [v]\n",
  "TOON": "(Hindi) an Indian tree of the mahogany family [n -S]\n",
  "TOONIE": "(Canadian) a Canadian two-dollar coin, also TWONIE, TWOONIE [n -S]\n",
  "TOONIES": "TOONIE, (Canadian) a Canadian two-dollar coin, also TWONIE, TWOONIE [n]\n",
  "TOONS": "TOON, (Hindi) an Indian tree of the mahogany family [n]\n",
  "TOORIE": "(Scots) a small heap, a knob of hair, also TOURIE [n -S]\n",
  "TOORIES": "TOORIE, (Scots) a small heap, a knob of hair, also TOURIE [n]\n",
  "TOOSHIE": "(Australian slang) angry, upset [adj TOOSHIER, TOOSHIEST]\n",
  "TOOSHIER": "TOOSHIE, (Australian slang) angry, upset [adj]\n",
  "TOOSHIEST": "TOOSHIE, (Australian slang) angry, upset [adj]\n",
  "TOOT": "to sound a horn [v -ED, -ING, -S]\n",
  "TOOTED": "TOOT, to sound a horn [v]\n",
  "TOOTER": "one who toots; one who plays upon a pipe or horn [n -S]\n",
  "TOOTERS": "TOOTER, one who toots; one who plays upon a pipe or horn [n]\n",
  "TOOTH": "one of the hard bone-like enamel-coated structures embedded in the jawbones [n TEETH] / to provide with teeth; to cut into teeth [v -ED, -ING, -S]\n",
  "TOOTHACHE": "a pain in a tooth [n -S]\n",
  "TOOTHACHES": "TOOTHACHE, a pain in a tooth [n]\n",
  "TOOTHBRUSH": "a brush for cleaning the teeth [n -ES]\n",
  "TOOTHBRUSHES": "TOOTHBRUSH, a brush for cleaning the teeth [n]\n",
  "TOOTHBRUSHING": "the action of using a toothbrush to clean teeth [n -S]\n",
  "TOOTHBRUSHINGS": "TOOTHBRUSHING, the action of using a toothbrush to clean teeth [n]\n",
  "TOOTHCOMB": "a fine-toothed comb [n -S]\n",
  "TOOTHCOMBS": "TOOTHCOMB, a fine-toothed comb [n]\n",
  "TOOTHED": "TOOTH, to provide with teeth; to cut into teeth [v]\n",
  "TOOTHFISH": "the Chilean sea bass [n -ES]\n",
  "TOOTHFISHES": "TOOTHFISH, the Chilean sea bass [n]\n",
  "TOOTHFUL": "a small drink of spirits [n -S]\n",
  "TOOTHFULS": "TOOTHFUL, a small drink of spirits [n]\n",
  "TOOTHIER": "TOOTHY, having prominent teeth [adj]\n",
  "TOOTHIEST": "TOOTHY, having prominent teeth [adj]\n",
  "TOOTHILY": "TOOTHY, having prominent teeth [adv]\n",
  "TOOTHINESS": "the state of being toothy [n -ES]\n",
  "TOOTHINESSES": "TOOTHINESS, the state of being toothy [n]\n",
  "TOOTHING": "using bluetooth via mobile phone to proposition for sex [n -S]\n",
  "TOOTHINGS": "TOOTHING, using bluetooth via mobile phone to proposition for sex [n]\n",
  "TOOTHLESS": "without teeth [adj]\n",
  "TOOTHLIKE": "like a tooth [adj]\n",
  "TOOTHPASTE": "a paste for cleaning the teeth [n -S]\n",
  "TOOTHPASTES": "TOOTHPASTE, a paste for cleaning the teeth [n]\n",
  "TOOTHPICK": "an instrument for picking shreds of food from between the teeth [n -S]\n",
  "TOOTHPICKS": "TOOTHPICK, an instrument for picking shreds of food from between the teeth [n]\n",
  "TOOTHS": "TOOTH, to provide with teeth; to cut into teeth [v]\n",
  "TOOTHSHELL": "any species of Dentalium and allied genera having a tooth-shaped shell [n -S]\n",
  "TOOTHSHELLS": "TOOTHSHELL, any species of Dentalium and allied genera having a tooth-shaped shell [n]\n",
  "TOOTHSOME": "attractive; palatable [adj TOOTHSOMELY]\n",
  "TOOTHSOMELY": "TOOTHSOME, attractive; palatable [adv]\n",
  "TOOTHSOMENESS": "the state of being toothsome [n -ES]\n",
  "TOOTHSOMENESSES": "TOOTHSOMENESS, the state of being toothsome [n]\n",
  "TOOTHWASH": "a liquid preparation for cleaning the teeth [n -ES]\n",
  "TOOTHWASHES": "TOOTHWASH, a liquid preparation for cleaning the teeth [n]\n",
  "TOOTHWORT": "a plant whose roots are fancied to resemble teeth, as certain plants of the genus Lathraea, and various species of Dentaria [n -S]\n",
  "TOOTHWORTS": "TOOTHWORT, a plant whose roots are fancied to resemble teeth, as certain plants of the genus Lathraea, and various species of Dentaria [n]\n",
  "TOOTHY": "having prominent teeth [adj TOOTHIER, TOOTHIEST, TOOTHILY]\n",
  "TOOTING": "TOOT, to sound a horn [v]\n",
  "TOOTLE": "to go along casually, esp. by car; to make feeble sounds on the flute, also TOODLE [v TOOTLED, TOOTLING, TOOTLES]\n",
  "TOOTLED": "TOOTLE, to go along casually, esp. by car; to make feeble sounds on the flute, also TOODLE [v]\n",
  "TOOTLER": "one who tootles [n -S]\n",
  "TOOTLERS": "TOOTLER, one who tootles [n]\n",
  "TOOTLES": "TOOTLE, to go along casually, esp. by car; to make feeble sounds on the flute, also TOODLE [v]\n",
  "TOOTLING": "TOOTLE, to go along casually, esp. by car; to make feeble sounds on the flute, also TOODLE [v]\n",
  "TOOTS": "(Scots) to tut [v TOOTSED, TOOTSING, TOOTSES]\n",
  "TOOTSED": "TOOTS, (Scots) to tut [v]\n",
  "TOOTSES": "TOOTS, (Scots) to tut [v]\n",
  "TOOTSIE": "a foot, also TOOTSY [n -S]\n",
  "TOOTSIES": "TOOTSY, (US) a sweetheart, also TOOTSIE [n]\n",
  "TOOTSING": "TOOTS, (Scots) to tut [v]\n",
  "TOOTSY": "(US) a sweetheart, also TOOTSIE [n TOOTSIES]\n",
  "TOP": "to cut off the highest point [v TOPPED, TOPPING, TOPS]\n",
  "TOPAGNOSES": "TOPAGNOSIS, a symptom of disease of or damage to the brain in which a person cannot identify a part of the body that has been touched, also TOPAGNOSIA [n]\n",
  "TOPAGNOSIA": "a symptom of disease of or damage to the brain in which a person cannot identify a part of the body that has been touched, also TOPAGNOSIS [n -S]\n",
  "TOPAGNOSIAS": "TOPAGNOSIA, a symptom of disease of or damage to the brain in which a person cannot identify a part of the body that has been touched, also TOPAGNOSIS [n]\n",
  "TOPAGNOSIS": "a symptom of disease of or damage to the brain in which a person cannot identify a part of the body that has been touched, also TOPAGNOSIA [n TOPAGNOSES]\n",
  "TOPALGIA": "pain in a particular spot [n -S]\n",
  "TOPALGIAS": "TOPALGIA, pain in a particular spot [n]\n",
  "TOPARCH": "(Greek) a ruler of a district [n -S]\n",
  "TOPARCHIES": "TOPARCHY, the territory of a toparch [n]\n",
  "TOPARCHS": "TOPARCH, (Greek) a ruler of a district [n]\n",
  "TOPARCHY": "the territory of a toparch [n TOPARCHIES]\n",
  "TOPAZ": "(Greek) a precious stone, a silicate of aluminium and fluorine [n -ES]\n",
  "TOPAZES": "TOPAZ, (Greek) a precious stone, a silicate of aluminium and fluorine [n]\n",
  "TOPAZINE": "like topaz [adj]\n",
  "TOPAZOLITE": "a topaz-yellow variety of garnet [n -S]\n",
  "TOPAZOLITES": "TOPAZOLITE, a topaz-yellow variety of garnet [n]\n",
  "TOPCOAT": "a lightweight overcoat [n -S]\n",
  "TOPCOATS": "TOPCOAT, a lightweight overcoat [n]\n",
  "TOPCROSS": "a cross between a purebred male and inferior female stock [n -ES]\n",
  "TOPCROSSES": "TOPCROSS, a cross between a purebred male and inferior female stock [n]\n",
  "TOPDRESSING": "an application of fertiliser to soil [n -S]\n",
  "TOPDRESSINGS": "TOPDRESSING, an application of fertiliser to soil [n]\n",
  "TOPE": "to drink liquor to excess [v TOPED, TOPING, TOPES]\n",
  "TOPECTOMIES": "TOPECTOMY, (obsolete) the excision of the top part of the cerebral cortex as a cure for mental illness [n]\n",
  "TOPECTOMY": "(obsolete) the excision of the top part of the cerebral cortex as a cure for mental illness [n TOPECTOMIES]\n",
  "TOPED": "TOPE, to drink liquor to excess [v]\n",
  "TOPEE": "(Hindi) a tropical pith helmet, also TOPI [n -S]\n",
  "TOPEES": "TOPEE, (Hindi) a tropical pith helmet, also TOPI [n]\n",
  "TOPEK": "(Inuit) an animal-skin tent, also TUPEK, TUPIK [n -S]\n",
  "TOPEKS": "TOPEK, (Inuit) an animal-skin tent, also TUPEK, TUPIK [n]\n",
  "TOPER": "a drunkard [n -S]\n",
  "TOPERS": "TOPER, a drunkard [n]\n",
  "TOPES": "TOPE, to drink liquor to excess [v]\n",
  "TOPFLIGHT": "superior, topnotch [adj]\n",
  "TOPFUL": "full to the top, also TOPFULL [adj]\n",
  "TOPFULL": "(Shakespeare) full to the top [adj]\n",
  "TOPGALLANT": "the mast or sail above the topmast and below the royal mast [n -S]\n",
  "TOPGALLANTS": "TOPGALLANT, the mast or sail above the topmast and below the royal mast [n]\n",
  "TOPH": "a porous limestone, also TUFA, TOPHE [n -S]\n",
  "TOPHACEOUS": "gritty [adj]\n",
  "TOPHE": "a rock made of fine volcanic detritus, also TOPH, TUFA [n -S]\n",
  "TOPHES": "TOPHE, a rock made of fine volcanic detritus, also TOPH, TUFA [n]\n",
  "TOPHI": "TOPHUS, (Latin) a deposit of urates in the tissue around a joint [n]\n",
  "TOPHS": "TOPH, a porous limestone, also TUFA, TOPHE [n]\n",
  "TOPHUS": "(Latin) a deposit of urates in the tissue around a joint [n TOPHI]\n",
  "TOPI": "(Hindi) a tropical pith helmet, also TOPEE [n -S]\n",
  "TOPIARIAN": "of or pertaining to the ornamental cutting and trimming of trees, hedges, etc. [adj]\n",
  "TOPIARIES": "TOPIARY, the art of trimming shrubs into shape [n]\n",
  "TOPIARIST": "one who practises topiary [n -S]\n",
  "TOPIARISTS": "TOPIARIST, one who practises topiary [n]\n",
  "TOPIARY": "the art of trimming shrubs into shape [n TOPIARIES]\n",
  "TOPIC": "a subject of discourse [n -S]\n",
  "TOPICAL": "relating to a topic [adj TOPICALLY] / a postage stamp forming part of a set or collection with designs connected with the same subject [n -S]\n",
  "TOPICALITIES": "TOPICALITY, the state of being topical [n]\n",
  "TOPICALITY": "the state of being topical [n TOPICALITIES]\n",
  "TOPICALLY": "TOPICAL, relating to a topic [adv]\n",
  "TOPICALS": "TOPICAL, a postage stamp forming part of a set or collection with designs connected with the same subject [n]\n",
  "TOPICS": "TOPIC, a subject of discourse [n]\n",
  "TOPING": "TOPE, to drink liquor to excess [v]\n",
  "TOPIS": "TOPI, (Hindi) a tropical pith helmet, also TOPEE [n]\n",
  "TOPKICK": "a first sergeant [n -S]\n",
  "TOPKICKS": "TOPKICK, a first sergeant [n]\n",
  "TOPKNOT": "an ornament for the hair [n -S]\n",
  "TOPKNOTS": "TOPKNOT, an ornament for the hair [n]\n",
  "TOPKNOTTED": "having a topknot [adj]\n",
  "TOPLESS": "without a top [adj]\n",
  "TOPLESSNESS": "the state of being topless [n -ES]\n",
  "TOPLESSNESSES": "TOPLESSNESS, the state of being topless [n]\n",
  "TOPLINE": "to feature in a headline [v TOPLINED, TOPLINING, TOPLINES]\n",
  "TOPLINED": "TOPLINE, to feature in a headline [v]\n",
  "TOPLINER": "a star [n -S]\n",
  "TOPLINERS": "TOPLINER, a star [n]\n",
  "TOPLINES": "TOPLINE, to feature in a headline [v]\n",
  "TOPLINING": "TOPLINE, to feature in a headline [v]\n",
  "TOPLOFTICAL": "high and mighty; haughty, also TOPLOFTY [adj]\n",
  "TOPLOFTIER": "TOPLOFTY, high and mighty, haughty, also TOPLOFTICAL [adj]\n",
  "TOPLOFTIEST": "TOPLOFTY, high and mighty, haughty, also TOPLOFTICAL [adj]\n",
  "TOPLOFTILY": "TOPLOFTY, high and mighty, haughty, also TOPLOFTICAL [adv]\n",
  "TOPLOFTINESS": "the state of being toplofty, high and mighty [n -ES]\n",
  "TOPLOFTINESSES": "TOPLOFTINESS, the state of being toplofty, high and mighty [n]\n",
  "TOPLOFTY": "high and mighty, haughty, also TOPLOFTICAL [adj TOPLOFTIER, TOPLOFTIEST, TOPLOFTILY]\n",
  "TOPMAKER": "one who makes tops [n -S]\n",
  "TOPMAKERS": "TOPMAKER, one who makes tops [n]\n",
  "TOPMAKING": "the making of toy tops [n -S]\n",
  "TOPMAKINGS": "TOPMAKING, the making of toy tops [n]\n",
  "TOPMAN": "a seaman in the top sail [n TOPMEN]\n",
  "TOPMAST": "a mast of a ship [n -S]\n",
  "TOPMASTS": "TOPMAST, a mast of a ship [n]\n",
  "TOPMEN": "TOPMAN, a seaman in the top sail [n]\n",
  "TOPMINNOW": "a small, surface feeding soft-rayed fish [n -S]\n",
  "TOPMINNOWS": "TOPMINNOW, a small, surface feeding soft-rayed fish [n]\n",
  "TOPMOST": "highest [adj]\n",
  "TOPNOTCH": "excellent [adj]\n",
  "TOPNOTCHER": "crude oil after some of its lighter constituents have been removed by distillation [n -S]\n",
  "TOPNOTCHERS": "TOPNOTCHER, crude oil after some of its lighter constituents have been removed by distillation [n]\n",
  "TOPO": "(colloquial) a picture of mountain with climbing routes superimposed on it [n -S]\n",
  "TOPOCENTRIC": "relating to, measured from, or as if observed from a particular point on the earth's surface [adj]\n",
  "TOPOCHEMISTRIES": "TOPOCHEMISTRY, the study of reactions that only occur at specific regions in a system [n]\n",
  "TOPOCHEMISTRY": "the study of reactions that only occur at specific regions in a system [n TOPOCHEMISTRIES]\n",
  "TOPOGRAPH": "a type of X-ray photograph [n -S]\n",
  "TOPOGRAPHER": "a specialist in topography [n -S]\n",
  "TOPOGRAPHERS": "TOPOGRAPHER, a specialist in topography [n]\n",
  "TOPOGRAPHIC": "relating to topography, also TOPOGRAPHICAL [adj TOPOGRAPHICALLY]\n",
  "TOPOGRAPHICAL": "relating to topography, also TOPOGRAPHIC [adj TOPOGRAPHICALLY]\n",
  "TOPOGRAPHICALLY": "TOPOGRAPHICAL, relating to topography, also TOPOGRAPHIC [adv]\n",
  "TOPOGRAPHIES": "TOPOGRAPHY, the detailed study, description or features of a limited area, district, etc. [n]\n",
  "TOPOGRAPHS": "TOPOGRAPH, a type of X-ray photograph [n]\n",
  "TOPOGRAPHY": "the detailed study, description or features of a limited area, district, etc. [n TOPOGRAPHIES]\n",
  "TOPOI": "TOPOS, (Greek) a stock theme or topic [n]\n",
  "TOPOISOMERASE": "any of a class of enzymes that reduce supercoiling in DNA by breaking and rejoining one or both strands of the DNA molecule [n -S]\n",
  "TOPOISOMERASES": "TOPOISOMERASE, any of a class of enzymes that reduce supercoiling in DNA by breaking and rejoining one or both strands of the DNA molecule [n]\n",
  "TOPOLOGIC": "relating to topology, also TOPOLOGICAL [adj TOPOLOGICALLY]\n",
  "TOPOLOGICAL": "relating to topology, also TOPOLOGIC [adj TOPOLOGICALLY]\n",
  "TOPOLOGICALLY": "TOPOLOGICAL, relating to topology, also TOPOLOGIC [adv]\n",
  "TOPOLOGIES": "TOPOLOGY, the branch of mathematics that deals with those properties of figures and surfaces which are independent of size and shape [n]\n",
  "TOPOLOGIST": "one who studies topology [n -S]\n",
  "TOPOLOGISTS": "TOPOLOGIST, one who studies topology [n]\n",
  "TOPOLOGY": "the branch of mathematics that deals with those properties of figures and surfaces which are independent of size and shape [n TOPOLOGIES]\n",
  "TOPOMETRIES": "TOPOMETRY, the measurement of the surface features of a region [n]\n",
  "TOPOMETRY": "the measurement of the surface features of a region [n TOPOMETRIES]\n",
  "TOPONYM": "(Greek) a word derived from the name of a place e.g. Waterloo [n -S]\n",
  "TOPONYMAL": "relating to toponymy, the study of place-names, also TOPONYMIC, TOPONYMICAL [adj]\n",
  "TOPONYMIC": "relating to toponymy, the study of place-names, also TOPONYMAL, TOPONYMICAL [adj]\n",
  "TOPONYMICAL": "related to toponymy, the study of place-names, also TOPONYMAL, TOPONYMIC [adj]\n",
  "TOPONYMICS": "the study of place-names [n]\n",
  "TOPONYMIES": "TOPONYMY, the study of toponyms [n]\n",
  "TOPONYMIST": "one who studies toponymy, the study of place-names [n -S]\n",
  "TOPONYMISTS": "TOPONYMIST, one who studies toponymy, the study of place-names [n]\n",
  "TOPONYMS": "TOPONYM, (Greek) a word derived from the name of a place e.g. Waterloo [n]\n",
  "TOPONYMY": "the study of toponyms [n TOPONYMIES]\n",
  "TOPOPHILIA": "great love or affection for a particular place [n -S]\n",
  "TOPOPHILIAS": "TOPOPHILIA, great love or affection for a particular place [n]\n",
  "TOPOS": "(Greek) a stock theme or topic [n TOPOI]\n",
  "TOPOTYPE": "a specimen selected from a locality typical of a species [n -S]\n",
  "TOPOTYPES": "TOPOTYPE, a specimen selected from a locality typical of a species [n]\n",
  "TOPPED": "TOP, to cut off the highest point [v]\n",
  "TOPPER": "(slang) a top hat [n -S]\n",
  "TOPPERS": "TOPPER, (slang) a top hat [n]\n",
  "TOPPIER": "TOPPY, of audio reproduction, dominated by high-frequency sounds [adj]\n",
  "TOPPIEST": "TOPPY, of audio reproduction, dominated by high-frequency sounds [adj]\n",
  "TOPPING": "excellent [adj TOPPINGLY] / something that forms a top [n -S]\n",
  "TOPPINGLY": "TOPPING, excellent [adv]\n",
  "TOPPINGS": "TOPPING, something that forms a top [n]\n",
  "TOPPLE": "to fall forward [v TOPPLED, TOPPLING, TOPPLES]\n",
  "TOPPLED": "TOPPLE, to fall forward [v]\n",
  "TOPPLES": "TOPPLE, to fall forward [v]\n",
  "TOPPLING": "TOPPLE, to fall forward [v]\n",
  "TOPPY": "of audio reproduction, dominated by high-frequency sounds [adj TOPPIER, TOPPIEST]\n",
  "TOPRAIL": "a top rail of e.g. an article of furniture [n -S]\n",
  "TOPRAILS": "TOPRAIL, a top rail of e.g. an article of furniture [n]\n",
  "TOPS": "TOP, to cut off the highest point [v]\n",
  "TOPSAIL": "a ship's sail above the lowermost sail [n -S]\n",
  "TOPSAILS": "TOPSAIL, a ship's sail above the lowermost sail [n]\n",
  "TOPSCORE": "to be the highest scorer in a sports match [v TOPSCORED, TOPSCORING, TOPSCORES]\n",
  "TOPSCORED": "TOPSCORE, to be the highest scorer in a sports match [v]\n",
  "TOPSCORES": "TOPSCORE, to be the highest scorer in a sports match [v]\n",
  "TOPSCORING": "TOPSCORE, to be the highest scorer in a sports match [v]\n",
  "TOPSIDE": "the upper portion of a ship [n -S]\n",
  "TOPSIDER": "one who is at the highest level of authority [n -S]\n",
  "TOPSIDERS": "TOPSIDER, one who is at the highest level of authority [n]\n",
  "TOPSIDES": "TOPSIDE, the upper portion of a ship [n]\n",
  "TOPSMAN": "the chief drover of those who drive a herd of cattle [n TOPSMEN]\n",
  "TOPSMEN": "TOPSMAN, the chief drover of those who drive a herd of cattle [n]\n",
  "TOPSOIL": "to remove the surface layer of soil from [v -ED, -ING, -S]\n",
  "TOPSOILED": "TOPSOIL, to remove the surface layer of soil from [v]\n",
  "TOPSOILING": "the act of covering with topsoil [n -S]\n",
  "TOPSOILINGS": "TOPSOILING, the act of covering with topsoil [n]\n",
  "TOPSOILS": "TOPSOIL, to remove the surface layer of soil from [v]\n",
  "TOPSPIN": "a forward spin imparted to a ball [n -S]\n",
  "TOPSPINS": "TOPSPIN, a forward spin imparted to a ball [n]\n",
  "TOPSTITCH": "to make a line of stitches on the outside of a garment close to a seam [v -ED, -ING, -ES]\n",
  "TOPSTITCHED": "TOPSTITCH, to make a line of stitches on the outside of a garment close to a seam [v]\n",
  "TOPSTITCHES": "TOPSTITCH, to make a line of stitches on the outside of a garment close to a seam [v]\n",
  "TOPSTITCHING": "TOPSTITCH, to make a line of stitches on the outside of a garment close to a seam [v]\n",
  "TOPSTONE": "the stone at the top of a structure [n -S]\n",
  "TOPSTONES": "TOPSTONE, the stone at the top of a structure [n]\n",
  "TOPWATER": "floating on or near the top of the water [adj]\n",
  "TOPWORK": "to graft scions of another variety of plant on the main branches of [v -ED, -ING, -S]\n",
  "TOPWORKED": "TOPWORK, to graft scions of another variety of plant on the main branches of [v]\n",
  "TOPWORKING": "TOPWORK, to graft scions of another variety of plant on the main branches of [v]\n",
  "TOPWORKS": "TOPWORK, to graft scions of another variety of plant on the main branches of [v]\n",
  "TOQUE": "(French) a close-fitting woman's hat, also TOQUET [n -S]\n",
  "TOQUES": "TOQUE, (French) a close-fitting woman's hat, also TOQUET [n]\n",
  "TOQUET": "(French) a kind of cap worn in the 16th century, also TOQUE [n -S]\n",
  "TOQUETS": "TOQUET, (French) a kind of cap worn in the 16th century, also TOQUE [n]\n",
  "TOQUILLA": "(Spanish) a South American palmlike tree; a fibre obtained from its leaves [n -S]\n",
  "TOQUILLAS": "TOQUILLA, (Spanish) a South American palmlike tree; a fibre obtained from its leaves [n]\n",
  "TOR": "a high, craggy hill [n -S]\n",
  "TORA": "(Hebrew) the body of Jewish law and learning, including sacred literature and oral tradition, also TORAH [n -S]\n",
  "TORAH": "(Hebrew) the body of Jewish law, also TORA [n TORAHS or TOROT or TOROTH]\n",
  "TORAHS": "TORAH, (Hebrew) the body of Jewish law, also TORA [n]\n",
  "TORAN": "(Hindi) in the Indian subcontinent, a sacred Buddhist gateway, also TORANA [n -S]\n",
  "TORANA": "(Hindi) in the Indian subcontinent, a sacred Buddhist gateway, also TORAN [n -S]\n",
  "TORANAS": "TORANA, (Hindi) in the Indian subcontinent, a sacred Buddhist gateway, also TORAN [n]\n",
  "TORANS": "TORAN, (Hindi) in the Indian subcontinent, a sacred Buddhist gateway, also TORANA [n]\n",
  "TORAS": "TORA, (Hebrew) the body of Jewish law and learning, including sacred literature and oral tradition, also TORAH [n]\n",
  "TORBANITE": "a shale, almost a coal, once mined for oil at Torbane Hill in Scotland [n -S]\n",
  "TORBANITES": "TORBANITE, a shale, almost a coal, once mined for oil at Torbane Hill in Scotland [n]\n",
  "TORBERNITE": "a bright-green radioactive hydrous phosphate of copper and uranium [n -S]\n",
  "TORBERNITES": "TORBERNITE, a bright-green radioactive hydrous phosphate of copper and uranium [n]\n",
  "TORC": "a necklace or armband in the form of a twisted metal band [n -S]\n",
  "TORCH": "to set on fire [v -ED, -ING, -ES]\n",
  "TORCHABLE": "that can be torched [adj]\n",
  "TORCHBEARER": "one that carries a torch [n -S]\n",
  "TORCHBEARERS": "TORCHBEARER, one that carries a torch [n]\n",
  "TORCHED": "TORCH, to set on fire [v]\n",
  "TORCHER": "(Shakespeare) a light-giver [n -S]\n",
  "TORCHERE": "(French) a tall ornamental candlestick or lampstand [n -S]\n",
  "TORCHERES": "TORCHERE, (French) a tall ornamental candlestick or lampstand [n]\n",
  "TORCHERS": "TORCHER, (Shakespeare) a light-giver [n]\n",
  "TORCHES": "TORCH, to set on fire [v]\n",
  "TORCHIER": "(French) a floor lamp with bowl for reflecting light upwards, also TORCHIERE [n -S]\n",
  "TORCHIERE": "(French) a floor lamp with bowl for reflecting light upwards, also TORCHIER [n -S]\n",
  "TORCHIERES": "TORCHIERE, (French) a floor lamp with bowl for reflecting light upwards, also TORCHIER [n]\n",
  "TORCHIERS": "TORCHIER, (French) a floor lamp with bowl for reflecting light upwards, also TORCHIERE [n]\n",
  "TORCHIEST": "TORCHY, characteristic of a torch song [adj]\n",
  "TORCHING": "the act of setting alight [n -S]\n",
  "TORCHINGS": "TORCHING, the act of setting alight [n]\n",
  "TORCHLIGHT": "light given by torches [n -S]\n",
  "TORCHLIGHTS": "TORCHLIGHT, light given by torches [n]\n",
  "TORCHLIKE": "like a torch [adj]\n",
  "TORCHLIT": "lit by torches [adj]\n",
  "TORCHON": "(French) a duster or dishcloth; coarse lace or paper [n -S]\n",
  "TORCHONS": "TORCHON, (French) a duster or dishcloth; coarse lace or paper [n]\n",
  "TORCHWOOD": "the inflammable wood of certain trees; also, the trees themselves [n -S]\n",
  "TORCHWOODS": "TORCHWOOD, the inflammable wood of certain trees; also, the trees themselves [n]\n",
  "TORCHY": "characteristic of a torch song [adj TORCHIER, TORCHIEST]\n",
  "TORCS": "TORC, a necklace or armband in the form of a twisted metal band [n]\n",
  "TORCULAR": "a tourniquet [n -S]\n",
  "TORCULARS": "TORCULAR, a tourniquet [n]\n",
  "TORDION": "(French) a Renaissance dance similar to but slower than a galliard, also TURDION [n -S]\n",
  "TORDIONS": "TORDION, (French) a Renaissance dance similar to but slower than a galliard, also TURDION [n]\n",
  "TORE": "a surface described by rotation of conic section about a line [n -S]\n",
  "TOREADOR": "(Spanish) the old name for a torero, a bullfighter, esp. on horseback [n -S]\n",
  "TOREADORS": "TOREADOR, (Spanish) the old name for a torero, a bullfighter, esp. on horseback [n]\n",
  "TORERO": "(Spanish) a bullfighter on foot [n -S]\n",
  "TOREROS": "TORERO, (Spanish) a bullfighter on foot [n]\n",
  "TORES": "TORE, a surface described by rotation of conic section about a line [n]\n",
  "TOREUTIC": "of metal, chased or embossed [adj]\n",
  "TOREUTICS": "artistic work in metal, producing by chasing and embossing [n]\n",
  "TORGOCH": "(Welsh) a red-bellied form of the char found in certain Welsh lakes, aka saibling [n -S]\n",
  "TORGOCHS": "TORGOCH, (Welsh) a red-bellied form of the char found in certain Welsh lakes, aka saibling [n]\n",
  "TORI": "TORUS, (Latin) a large convex moulding [n]\n",
  "TORIC": "having the form of a torus, a rounded swelling [adj] / a torus, a rounded swelling [n -S]\n",
  "TORICS": "TORIC, a torus, a rounded swelling [n]\n",
  "TORIES": "TORY, a political conservative [n]\n",
  "TORII": "(Japanese) a Shinto temple gateway [n TORII]\n",
  "TORMENT": "to harass or torture [v -ED, -ING, -S]\n",
  "TORMENTA": "TORMENTUM, (Latin) a missile hurler [n]\n",
  "TORMENTED": "TORMENT, to harass or torture [v]\n",
  "TORMENTEDLY": "TORMENTED, TORMENT, to harass or torture [adv]\n",
  "TORMENTER": "one who torments, also TORMENTOR [n -S]\n",
  "TORMENTERS": "TORMENTER, one who torments, also TORMENTOR [n]\n",
  "TORMENTIL": "a small potentilla of heaths and moors having four-petalled yellow flowers and strongly astringent roots [n -S]\n",
  "TORMENTILS": "TORMENTIL, a small potentilla of heaths and moors having four-petalled yellow flowers and strongly astringent roots [n]\n",
  "TORMENTING": "inflicting great bodily or mental suffering [adj TORMENTINGLY] / the act of tormenting [n -S]\n",
  "TORMENTINGLY": "TORMENTING, inflicting great bodily or mental suffering [adv]\n",
  "TORMENTINGS": "TORMENTING, the act of tormenting [n]\n",
  "TORMENTOR": "one who torments, also TORMENTER [n -S]\n",
  "TORMENTORS": "TORMENTOR, one who torments, also TORMENTER [n]\n",
  "TORMENTS": "TORMENT, to harass or torture [v]\n",
  "TORMENTUM": "(Latin) a missile hurler [n TORMENTUMS or TORMENTA]\n",
  "TORMENTUMS": "TORMENTUM, (Latin) a missile hurler [n]\n",
  "TORMINA": "(Latin) acute, colicky pains [n]\n",
  "TORMINAL": "relating to tormina, the gripes [adj]\n",
  "TORMINOUS": "affected with tormina; griping [adj]\n",
  "TORN": "TEAR, to weep [v]\n",
  "TORNADE": "a storm with very strong whirling winds, also TORNADO [n -S]\n",
  "TORNADES": "TORNADE, a storm with very strong whirling winds, also TORNADO [n]\n",
  "TORNADIC": "relating to a tornado [adj]\n",
  "TORNADO": "(Spanish) a violent storm over a limited area, with whirling winds, a cyclone, also TORNADE [n -ES or -S]\n",
  "TORNADOES": "TORNADO, (Spanish) a violent storm over a limited area, with whirling winds, a cyclone, also TORNADE [n]\n",
  "TORNADOS": "TORNADO, (Spanish) a violent storm over a limited area, with whirling winds, a cyclone, also TORNADE [n]\n",
  "TORNILLO": "(Spanish) a flowering shrub, aka screwbean [n -S]\n",
  "TORNILLOS": "TORNILLO, (Spanish) a flowering shrub, aka screwbean [n]\n",
  "TORO": "(Spanish) a bull [n -S]\n",
  "TOROID": "anything shaped like a doughnut or anchor-ring [n -S]\n",
  "TOROIDAL": "like a toroid, shaped like a doughnut or anchor-ring [adj TOROIDALLY]\n",
  "TOROIDALLY": "TOROIDAL, like a toroid, shaped like a doughnut or anchor-ring [adv]\n",
  "TOROIDS": "TOROID, anything shaped like a doughnut or anchor-ring [n]\n",
  "TOROS": "TORO, (Spanish) a bull [n]\n",
  "TOROSE": "cylindrical and swollen at intervals, also TOROUS [adj]\n",
  "TOROSITIES": "TOROSITY, the state of being torose, swelling [n]\n",
  "TOROSITY": "the state of being torose, swelling [n TOROSITIES]\n",
  "TOROT": "TORAH, (Hebrew) the body of Jewish law, also TORA [n]\n",
  "TOROTH": "TORAH, (Hebrew) the body of Jewish law, also TORA [n]\n",
  "TOROUS": "cylindrical and swollen at intervals, also TOROSE [adj]\n",
  "TORPEDINOUS": "numbing [adj]\n",
  "TORPEDO": "a self-propelled submarine missile, usually cigar-shaped, designed to explode on impact with a target [n TORPEDOES] / to attack with a torpedo [v TORPEDOED, TORPEDOING, TORPEDOES or TORPEDOS]\n",
  "TORPEDOED": "TORPEDO, to attack with a torpedo [v]\n",
  "TORPEDOER": "one who torpedoes [n -S]\n",
  "TORPEDOERS": "TORPEDOER, one who torpedoes [n]\n",
  "TORPEDOES": "TORPEDO, a self-propelled submarine missile, usually cigar-shaped, designed to explode on impact with a target [n]\n",
  "TORPEDOING": "TORPEDO, to attack with a torpedo [v]\n",
  "TORPEDOIST": "one whose job is to fire torpedoes [n -S]\n",
  "TORPEDOISTS": "TORPEDOIST, one whose job is to fire torpedoes [n]\n",
  "TORPEDOS": "TORPEDO, to attack with a torpedo [v]\n",
  "TORPEFIED": "TORPEFY, to make numb or torpid [v]\n",
  "TORPEFIES": "TORPEFY, to make numb or torpid [v]\n",
  "TORPEFY": "to make numb or torpid [v TORPEFIED, TORPEFYING, TORPEFIES]\n",
  "TORPEFYING": "TORPEFY, to make numb or torpid [v]\n",
  "TORPESCENCE": "becoming numb or torpid [n -S]\n",
  "TORPESCENCES": "TORPESCENCE, becoming numb or torpid [n]\n",
  "TORPESCENT": "becoming numb or torpid [adj]\n",
  "TORPID": "numb, lethargic [adj TORPIDLY] / at Oxford, the second boat of a college [n -S]\n",
  "TORPIDITIES": "TORPIDITY, numbness, sluggishness [n]\n",
  "TORPIDITY": "numbness, sluggishness [n TORPIDITIES]\n",
  "TORPIDLY": "TORPID, numb, lethargic [adv]\n",
  "TORPIDNESS": "the state of being torpid [n -ES]\n",
  "TORPIDNESSES": "TORPIDNESS, the state of being torpid [n]\n",
  "TORPIDS": "TORPID, at Oxford, the second boat of a college [n]\n",
  "TORPITUDE": "torpidness [n -S]\n",
  "TORPITUDES": "TORPITUDE, torpidness [n]\n",
  "TORPOR": "(Latin) mental or physical inactivity [n -S]\n",
  "TORPORIFIC": "causing dullness or numbness [adj]\n",
  "TORPORS": "TORPOR, (Latin) mental or physical inactivity [n]\n",
  "TORQUATE": "with a distinctive ring (e.g. of feathers or a different colour) round the neck, also TORQUATED [adj]\n",
  "TORQUATED": "with a distinctive ring (e.g. of feathers or a different colour) round the neck, also TORQUATE [adj]\n",
  "TORQUE": "to cause to twist [v TORQUED, TORQUING, TORQUES]\n",
  "TORQUED": "TORQUE, to cause to twist [v]\n",
  "TORQUER": "something that produces torque [n -S]\n",
  "TORQUERS": "TORQUER, something that produces torque [n]\n",
  "TORQUES": "a ring of fur or feathers round an animal's neck [n -ES]\n",
  "TORQUESES": "TORQUES, a ring of fur or feathers round an animal's neck [n]\n",
  "TORQUEY": "providing force to cause rotation [adj TORQUIER, TORQUIEST]\n",
  "TORQUIER": "TORQUEY, providing force to cause rotation [adj]\n",
  "TORQUIEST": "TORQUEY, providing force to cause rotation [adj]\n",
  "TORQUING": "TORQUE, to cause to twist [v]\n",
  "TORR": "a unit of pressure equal to 1/760 of standard atmospheric pressure [n -S]\n",
  "TORREFACTION": "the act of torrefying [n -S]\n",
  "TORREFACTIONS": "TORREFACTION, the act of torrefying [n]\n",
  "TORREFIED": "TORREFY, to subject to intense heat, also TORRIFY [v]\n",
  "TORREFIES": "TORREFY, to subject to intense heat, also TORRIFY [v]\n",
  "TORREFY": "to subject to intense heat, also TORRIFY [v TORREFIED, TORREFYING, TORREFIES]\n",
  "TORREFYING": "TORREFY, to subject to intense heat, also TORRIFY [v]\n",
  "TORRENT": "a rapid stream of water [n -S]\n",
  "TORRENTIAL": "resembling a torrent, also TORRENTUOUS [adj TORRENTIALLY]\n",
  "TORRENTIALITIES": "TORRENTIALITY, the state of being torrential [n]\n",
  "TORRENTIALITY": "the state of being torrential [n TORRENTIALITIES]\n",
  "TORRENTIALLY": "TORRENTIAL, resembling a torrent, also TORRENTUOUS [adv]\n",
  "TORRENTS": "TORRENT, a rapid stream of water [n]\n",
  "TORRENTUOUS": "torrential, also TORRENTIAL [adj]\n",
  "TORRET": "a metal ring on a harness through which the reins pass, also TERRET, TERRIT [n -S]\n",
  "TORRETS": "TORRET, a metal ring on a harness through which the reins pass, also TERRET, TERRIT [n]\n",
  "TORRID": "extremely hot [adj TORRIDER, TORRIDEST, TORRIDLY]\n",
  "TORRIDER": "TORRID, extremely hot [adj]\n",
  "TORRIDEST": "TORRID, extremely hot [adj]\n",
  "TORRIDITIES": "TORRIDITY, torridness [n]\n",
  "TORRIDITY": "torridness [n TORRIDITIES]\n",
  "TORRIDLY": "TORRID, extremely hot [adv]\n",
  "TORRIDNESS": "the state of being torrid [n -ES]\n",
  "TORRIDNESSES": "TORRIDNESS, the state of being torrid [n]\n",
  "TORRIFIED": "TORRIFY, to subject to intense heat, also TORREFY [v]\n",
  "TORRIFIES": "TORRIFY, to subject to intense heat, also TORREFY [v]\n",
  "TORRIFY": "to subject to intense heat, also TORREFY [v TORRIFIED, TORRIFYING, TORRIFIES]\n",
  "TORRIFYING": "TORRIFY, to subject to intense heat, also TORREFY [v]\n",
  "TORRS": "TORR, a unit of pressure equal to 1/760 of standard atmospheric pressure [n]\n",
  "TORS": "TOR, a high, craggy hill [n]\n",
  "TORSADE": "an ornament on a hat like a twisted cord [n -S]\n",
  "TORSADES": "TORSADE, an ornament on a hat like a twisted cord [n]\n",
  "TORSE": "(French) a heraldic wreath [n -S]\n",
  "TORSEL": "a plate supporting a beam in a brick wall [n -S]\n",
  "TORSELS": "TORSEL, a plate supporting a beam in a brick wall [n]\n",
  "TORSES": "TORSE, (French) a heraldic wreath [n]\n",
  "TORSI": "TORSO, (Italian) the trunk of the human body [n]\n",
  "TORSIBILITIES": "TORSIBILITY, the ability to be twisted or subjected to torsion [n]\n",
  "TORSIBILITY": "the ability to be twisted or subjected to torsion [n TORSIBILITIES]\n",
  "TORSIOGRAPH": "an instrument for recording torsional vibrations on an object [n -S]\n",
  "TORSIOGRAPHS": "TORSIOGRAPH, an instrument for recording torsional vibrations on an object [n]\n",
  "TORSION": "the act of twisting [n -S]\n",
  "TORSIONAL": "of or pertaining to torsion [adj TORSIONALLY]\n",
  "TORSIONALLY": "TORSIONAL, of or pertaining to torsion [adv]\n",
  "TORSIONS": "TORSION, the act of twisting [n]\n",
  "TORSIVE": "twisted [adj]\n",
  "TORSK": "(Norwegian) a marine food fish, aka cusk [n -S]\n",
  "TORSKS": "TORSK, (Norwegian) a marine food fish, aka cusk [n]\n",
  "TORSO": "(Italian) the trunk of the human body [n TORSOS or TORSI]\n",
  "TORSOS": "TORSO, (Italian) the trunk of the human body [n]\n",
  "TORT": "a civil wrong [n -S]\n",
  "TORTA": "in mining, a flat circular pile of silver ore [n -S]\n",
  "TORTAS": "TORTA, in mining, a flat circular pile of silver ore [n]\n",
  "TORTE": "(German) a rich cake made of many eggs, little flour, and usually containing nuts [n TORTEN or TORTES]\n",
  "TORTELLI": "(Italian) small pasta parcels stuffed with meat, cheese or vegetables, also TORTELLINI [n -S]\n",
  "TORTELLINI": "(Italian) small stuffed pasta dumplings, also TORTELLI [n -S]\n",
  "TORTELLINIS": "TORTELLINI, (Italian) small stuffed pasta dumplings, also TORTELLI [n]\n",
  "TORTELLIS": "TORTELLI, (Italian) small pasta parcels stuffed with meat, cheese or vegetables, also TORTELLINI [n]\n",
  "TORTEN": "TORTE, (German) a rich cake made of many eggs, little flour, and usually containing nuts [n]\n",
  "TORTES": "TORTE, (German) a rich cake made of many eggs, little flour, and usually containing nuts [n]\n",
  "TORTFEASOR": "a person guilty of tort, a wrongful act, damage, or injury done willfully [n -S]\n",
  "TORTFEASORS": "TORTFEASOR, a person guilty of tort, a wrongful act, damage, or injury done willfully [n]\n",
  "TORTICOLLAR": "relating to torticollis, wry neck [adj]\n",
  "TORTICOLLIS": "a condition in which the neck is permanently twisted and head held at an unusual angle [n -ES]\n",
  "TORTICOLLISES": "TORTICOLLIS, a condition in which the neck is permanently twisted and head held at an unusual angle [n]\n",
  "TORTIE": "(short for) tortoiseshell [n -S]\n",
  "TORTIES": "TORTIE, (short for) tortoiseshell [n]\n",
  "TORTILE": "twisted [adj]\n",
  "TORTILITIES": "TORTILITY, the state of being tortile, twisted, or wreathed [n]\n",
  "TORTILITY": "the state of being tortile, twisted, or wreathed [n TORTILITIES]\n",
  "TORTILLA": "(Spanish) an unleavened cake, as of maize flour, baked on a heated iron or stone [n -S]\n",
  "TORTILLAS": "TORTILLA, (Spanish) an unleavened cake, as of maize flour, baked on a heated iron or stone [n]\n",
  "TORTILLON": "a short sharply-pointed stick of cork or rolled leather, used in drawing and shading [n -S]\n",
  "TORTILLONS": "TORTILLON, a short sharply-pointed stick of cork or rolled leather, used in drawing and shading [n]\n",
  "TORTIOUS": "of the nature of a tort [adj TORTIOUSLY]\n",
  "TORTIOUSLY": "TORTIOUS, of the nature of a tort [adv]\n",
  "TORTIVE": "(Shakespeare) turned awry [adj]\n",
  "TORTOISE": "any reptile having the body enclosed in a bony shell [n -S]\n",
  "TORTOISES": "TORTOISE, any reptile having the body enclosed in a bony shell [n]\n",
  "TORTOISESHELL": "the mottled horny substance of the shell of the hawksbill turtle used esp. formerly in inlaying and in making various ornamental articles [n -S]\n",
  "TORTOISESHELLS": "TORTOISESHELL, the mottled horny substance of the shell of the hawksbill turtle used esp. formerly in inlaying and in making various ornamental articles [n]\n",
  "TORTONI": "(Italian) a rich ice-cream flavoured with wine and containing chopped fruit [n -S]\n",
  "TORTONIS": "TORTONI, (Italian) a rich ice-cream flavoured with wine and containing chopped fruit [n]\n",
  "TORTRICES": "TORTRIX, a kind of small moth [n]\n",
  "TORTRICID": "any moth of the family Tortricidae [n -S]\n",
  "TORTRICIDS": "TORTRICID, any moth of the family Tortricidae [n]\n",
  "TORTRIX": "a kind of small moth [n TORTRIXES or TORTRICES]\n",
  "TORTRIXES": "TORTRIX, a kind of small moth [n]\n",
  "TORTS": "TORT, a civil wrong [n]\n",
  "TORTUOSITIES": "TORTUOSITY, the state of being tortuous [n]\n",
  "TORTUOSITY": "the state of being tortuous [n TORTUOSITIES]\n",
  "TORTUOUS": "marked by turns or bends [adj TORTUOUSLY]\n",
  "TORTUOUSLY": "TORTUOUS, marked by turns or bends [adv]\n",
  "TORTUOUSNESS": "the state of being tortuous [n -ES]\n",
  "TORTUOUSNESSES": "TORTUOUSNESS, the state of being tortuous [n]\n",
  "TORTURE": "to subject to severe physical pain [v TORTURED, TORTURING, TORTURES]\n",
  "TORTURED": "TORTURE, to subject to severe physical pain [v]\n",
  "TORTUREDLY": "TORTURED, TORTURE, to subject to severe physical pain [adv]\n",
  "TORTURER": "one that tortures [n -S]\n",
  "TORTURERS": "TORTURER, one that tortures [n]\n",
  "TORTURES": "TORTURE, to subject to severe physical pain [v]\n",
  "TORTURESOME": "torturous [adj]\n",
  "TORTURING": "causing severe physical pain [adj TORTURINGLY] / the act of torturing [n -S]\n",
  "TORTURINGLY": "TORTURING, causing severe physical pain [adv]\n",
  "TORTURINGS": "TORTURING, the act of torturing [n]\n",
  "TORTUROUS": "involving, or pertaining to, torture [adj TORTUROUSLY]\n",
  "TORTUROUSLY": "TORTUROUS, involving, or pertaining to, torture [adv]\n",
  "TORULA": "(Latin) a yeastlike microorganism [n TORULAE or TORULAS]\n",
  "TORULAE": "TORULA, (Latin) a yeastlike microorganism [n]\n",
  "TORULAS": "TORULA, (Latin) a yeastlike microorganism [n]\n",
  "TORULI": "TORULUS, (Latin) the socket of an insect's antenna [n]\n",
  "TORULIN": "a vitamin in yeast [n -S]\n",
  "TORULINS": "TORULIN, a vitamin in yeast [n]\n",
  "TORULOSE": "with small swellings at intervals [adj]\n",
  "TORULOSES": "TORULOSIS, an infection by a member of the Torula genus affecting the nervous system [n]\n",
  "TORULOSIS": "an infection by a member of the Torula genus affecting the nervous system [n TORULOSES]\n",
  "TORULUS": "(Latin) the socket of an insect's antenna [n TORULI]\n",
  "TORUS": "(Latin) a large convex moulding [n TORI or TORUSES]\n",
  "TORUSES": "TORUS, (Latin) a large convex moulding [n]\n",
  "TORY": "a political conservative [n TORIES]\n",
  "TOSA": "(Japanese) a breed of heavily built, smooth-haired dog [n -S]\n",
  "TOSAS": "TOSA, (Japanese) a breed of heavily built, smooth-haired dog [n]\n",
  "TOSE": "(Scots) to tease out, draw out, also TEASE, TEAZE, TOAZE, TOZE [v TOSED, TOSING, TOSES]\n",
  "TOSED": "TOSE, (Scots) to tease out, draw out, also TEASE, TEAZE, TOAZE, TOZE [v]\n",
  "TOSES": "TOSE, (Scots) to tease out, draw out, also TEASE, TEAZE, TOAZE, TOZE [v]\n",
  "TOSH": "to trim [v -ED, -ING, -ES]\n",
  "TOSHACH": "(Irish) a Celtic nobleman, also TOISEACH, TOISECH [n -S]\n",
  "TOSHACHS": "TOSHACH, (Irish) a Celtic nobleman, also TOISEACH, TOISECH [n]\n",
  "TOSHED": "TOSH, to trim [v]\n",
  "TOSHER": "(colloquial) a noncollegiate student [n -S]\n",
  "TOSHERS": "TOSHER, (colloquial) a noncollegiate student [n]\n",
  "TOSHES": "TOSH, to trim [v]\n",
  "TOSHIER": "TOSHY, full of twaddle [adj]\n",
  "TOSHIEST": "TOSHY, full of twaddle [adj]\n",
  "TOSHING": "TOSH, to trim [v]\n",
  "TOSHY": "full of twaddle [adj TOSHIER, TOSHIEST]\n",
  "TOSING": "TOSE, (Scots) to tease out, draw out, also TEASE, TEAZE, TOAZE, TOZE [v]\n",
  "TOSS": "to throw lightly [v TOSSED or (obsolete) TOST or YTOST, TOSSING, TOSSES]\n",
  "TOSSED": "TOSS, to throw lightly [v]\n",
  "TOSSEN": "(Spenser) to toss [v]\n",
  "TOSSER": "(slang) an unpleasant or despicable person [n -S]\n",
  "TOSSERS": "TOSSER, (slang) an unpleasant or despicable person [n]\n",
  "TOSSES": "TOSS, to throw lightly [v]\n",
  "TOSSICATED": "(dialect) fuddled, perplexed, also TOSTICATED [adj]\n",
  "TOSSIER": "TOSSY, tossing the head, as in scorn or pride [adj]\n",
  "TOSSIEST": "TOSSY, tossing the head, as in scorn or pride [adj]\n",
  "TOSSILY": "TOSSY, tossing the head, as in scorn or pride [adv]\n",
  "TOSSING": "the act of tossing [n -S]\n",
  "TOSSINGS": "TOSSING, the act of tossing [n]\n",
  "TOSSPOT": "a toper, a drunkard [n -S]\n",
  "TOSSPOTS": "TOSSPOT, a toper, a drunkard [n]\n",
  "TOSSUP": "an even choice or chance [n -S]\n",
  "TOSSUPS": "TOSSUP, an even choice or chance [n]\n",
  "TOSSY": "tossing the head, as in scorn or pride [adj TOSSIER, TOSSIEST, TOSSILY]\n",
  "TOST": "TOSS, to throw lightly [v]\n",
  "TOSTADA": "(Spanish) a tortilla fried until crisp with a savoury topping, also TOSTADO [n -S]\n",
  "TOSTADAS": "TOSTADA, (Spanish) a tortilla fried until crisp with a savoury topping, also TOSTADO [n]\n",
  "TOSTADO": "(Spanish) a tortilla fried until crisp with a savoury topping, also TOSTADA [n -S]\n",
  "TOSTADOS": "TOSTADO, (Spanish) a tortilla fried until crisp with a savoury topping, also TOSTADA [n]\n",
  "TOSTICATED": "(dialect) fuddled, perplexed, also TOSSICATED [adj]\n",
  "TOSTICATION": "perplexity [n -S]\n",
  "TOSTICATIONS": "TOSTICATION, perplexity [n]\n",
  "TOSTONE": "(Spanish) a Mexican dish of fried plantains [n -S]\n",
  "TOSTONES": "TOSTONE, (Spanish) a Mexican dish of fried plantains [n]\n",
  "TOT": "to total [v TOTTED, TOTTING, TOTS]\n",
  "TOTABLE": "capable of being toted, also TOTEABLE [adj]\n",
  "TOTAL": "whole [adj TOTALLY] / to amount to [v TOTALLED or TOTALED, TOTALLING or TOTALING, TOTALS]\n",
  "TOTALED": "TOTAL, to amount to [v]\n",
  "TOTALING": "TOTAL, to amount to [v]\n",
  "TOTALISATION": "the act of totalising, also TOTALIZATION [n -S]\n",
  "TOTALISATIONS": "TOTALISATION, the act of totalising, also TOTALIZATION [n]\n",
  "TOTALISATOR": "an automatic betting machine, also TOTALIZATOR [n -S]\n",
  "TOTALISATORS": "TOTALISATOR, an automatic betting machine, also TOTALIZATOR [n]\n",
  "TOTALISE": "to make complete, also TOTALIZE [v TOTALISED, TOTALISING, TOTALISES]\n",
  "TOTALISED": "TOTALISE, to make complete, also TOTALIZE [v]\n",
  "TOTALISER": "a system of betting in which the total amount staked is divided among the winners in proportion to the size of their stake, also TOTALIZER [n -S]\n",
  "TOTALISERS": "TOTALISER, a system of betting in which the total amount staked is divided among the winners in proportion to the size of their stake, also TOTALIZER [n]\n",
  "TOTALISES": "TOTALISE, to make complete, also TOTALIZE [v]\n",
  "TOTALISING": "TOTALISE, to make complete, also TOTALIZE [v]\n",
  "TOTALISM": "centralized control by an autocratic authority [n -S]\n",
  "TOTALISMS": "TOTALISM, centralized control by an autocratic authority [n]\n",
  "TOTALIST": "one who tends to regard things as a unified whole [n -S]\n",
  "TOTALISTIC": "relating to centralized control by an autocratic authority [adj]\n",
  "TOTALISTS": "TOTALIST, one who tends to regard things as a unified whole [n]\n",
  "TOTALITARIAN": "an advocate or practitioner of totalitarianism [n -S]\n",
  "TOTALITARIANISE": "to make totalitarian, also TOTALITARIANIZE [v]\n",
  "TOTALITARIANISM": "centralized control by an autocratic authority [n]\n",
  "TOTALITARIANIZE": "to make totalitarian, also TOTALITARIANISE [v]\n",
  "TOTALITARIANS": "TOTALITARIAN, an advocate or practitioner of totalitarianism [n]\n",
  "TOTALITIES": "TOTALITY, the state of being complete [n]\n",
  "TOTALITY": "the state of being complete [n TOTALITIES]\n",
  "TOTALIZATION": "the act of totalizing, also TOTALISATION [n -S]\n",
  "TOTALIZATIONS": "TOTALIZATION, the act of totalizing, also TOTALISATION [n]\n",
  "TOTALIZATOR": "an automatic betting machine, also TOTALISATOR [n -S]\n",
  "TOTALIZATORS": "TOTALIZATOR, an automatic betting machine, also TOTALISATOR [n]\n",
  "TOTALIZE": "to make complete, also TOTALISE [v TOTALIZED, TOTALIZING, TOTALIZES]\n",
  "TOTALIZED": "TOTALIZE, to make complete, also TOTALISE [v]\n",
  "TOTALIZER": "a system of betting in which the total amount staked is divided among the winners in proportion to the size of their stake, also TOTALISER [n -S]\n",
  "TOTALIZERS": "TOTALIZER, a system of betting in which the total amount staked is divided among the winners in proportion to the size of their stake, also TOTALISER [n]\n",
  "TOTALIZES": "TOTALIZE, to make complete, also TOTALISE [v]\n",
  "TOTALIZING": "TOTALIZE, to make complete, also TOTALISE [v]\n",
  "TOTALLED": "TOTAL, to amount to [v]\n",
  "TOTALLING": "TOTAL, to amount to [v]\n",
  "TOTALLY": "TOTAL, whole [adv]\n",
  "TOTALS": "TOTAL, to amount to [v]\n",
  "TOTANUS": "(Italian) the redshank [n -ES]\n",
  "TOTANUSES": "TOTANUS, (Italian) the redshank [n]\n",
  "TOTAQUINE": "a mixture of quinine and alkaloids used as an antimalarial [n -S]\n",
  "TOTAQUINES": "TOTAQUINE, a mixture of quinine and alkaloids used as an antimalarial [n]\n",
  "TOTARA": "(Maori) a New Zealand timber tree, with reddish wood, mahogany pine [n -S]\n",
  "TOTARAS": "TOTARA, (Maori) a New Zealand timber tree, with reddish wood, mahogany pine [n]\n",
  "TOTE": "to carry by hand [v TOTED, TOTING, TOTES]\n",
  "TOTEABLE": "capable of being toted, also TOTABLE [adj]\n",
  "TOTED": "TOTE, to carry by hand [v]\n",
  "TOTEM": "(Native American) the symbol of a family, clan or tribe [n -S]\n",
  "TOTEMIC": "of or pertaining to a totem, or totemism [adj TOTEMICALLY]\n",
  "TOTEMICALLY": "TOTEMIC, of or pertaining to a totem, or totemism [adv]\n",
  "TOTEMISM": "a system of tribal division according to totems [n -S]\n",
  "TOTEMISMS": "TOTEMISM, a system of tribal division according to totems [n]\n",
  "TOTEMIST": "a specialist in totemism, also TOTEMITE [n -S]\n",
  "TOTEMISTIC": "relating to totemism [adj]\n",
  "TOTEMISTS": "TOTEMIST, a specialist in totemism, also TOTEMITE [n]\n",
  "TOTEMITE": "a specialist in totemism, also TOTEMIST [n -S]\n",
  "TOTEMITES": "TOTEMITE, a specialist in totemism, also TOTEMIST [n]\n",
  "TOTEMS": "TOTEM, (Native American) the symbol of a family, clan or tribe [n]\n",
  "TOTER": "one who totes [n -S]\n",
  "TOTERS": "TOTER, one who totes [n]\n",
  "TOTES": "TOTE, to carry by hand [v]\n",
  "TOTHER": "(archaic) the other [n -S]\n",
  "TOTHERS": "TOTHER, (archaic) the other [n]\n",
  "TOTIENT": "the number of totitives of a number, i.e. numbers less than and prime to it [n -S]\n",
  "TOTIENTS": "TOTIENT, the number of totitives of a number, i.e. numbers less than and prime to it [n]\n",
  "TOTING": "TOTE, to carry by hand [v]\n",
  "TOTIPALMATE": "having webbing between each toe, as in pelicans and gannets [adj]\n",
  "TOTIPALMATION": "the state of being totipalmate, having webbing between each toe [n -S]\n",
  "TOTIPALMATIONS": "TOTIPALMATION, the state of being totipalmate, having webbing between each toe [n]\n",
  "TOTIPOTENCIES": "TOTIPOTENCY, the state of being totipotent, capable of development into a complete organ or embryo [n]\n",
  "TOTIPOTENCY": "the state of being totipotent, capable of development into a complete organ or embryo [n TOTIPOTENCIES]\n",
  "TOTIPOTENT": "capable of development into a complete organ or embryo [adj]\n",
  "TOTITIVE": "a number less than another and prime to it [n -S]\n",
  "TOTITIVES": "TOTITIVE, a number less than another and prime to it [n]\n",
  "TOTS": "TOT, to total [v]\n",
  "TOTTED": "TOT, to total [v]\n",
  "TOTTER": "to walk unsteadily [v -ED, -ING, -S]\n",
  "TOTTERED": "TOTTER, to walk unsteadily [v]\n",
  "TOTTERER": "one who totters [n -S]\n",
  "TOTTERERS": "TOTTERER, one who totters [n]\n",
  "TOTTERIER": "TOTTERY, shaky [adj]\n",
  "TOTTERIEST": "TOTTERY, shaky [adj]\n",
  "TOTTERING": "unsteady [adj TOTTERINGLY] / the act of tottering [n -S]\n",
  "TOTTERINGLY": "TOTTERING, unsteady [adv]\n",
  "TOTTERINGS": "TOTTERING, the act of tottering [n]\n",
  "TOTTERS": "TOTTER, to walk unsteadily [v]\n",
  "TOTTERY": "shaky [adj TOTTERIER, TOTTERIEST]\n",
  "TOTTIE": "a woman or small child, also TOTTY [n -S]\n",
  "TOTTIER": "TOTTY, unsteady; tottery [adj]\n",
  "TOTTIES": "TOTTIE, a woman or small child, also TOTTY [n]\n",
  "TOTTIEST": "TOTTY, unsteady; tottery [adj]\n",
  "TOTTING": "the recycling of refuse [n -S]\n",
  "TOTTINGS": "TOTTING, the recycling of refuse [n]\n",
  "TOTTRING": "(Shakespeare) hanging in rag [adj]\n",
  "TOTTY": "unsteady; tottery [adj TOTTIER, TOTTIEST] / a woman or small child, also TOTTIE [n TOTTIES]\n",
  "TOUCAN": "(Tupi) a tropical bird with a large bill [n -S]\n",
  "TOUCANET": "a smaller kind of toucan [n -S]\n",
  "TOUCANETS": "TOUCANET, a smaller kind of toucan [n]\n",
  "TOUCANS": "TOUCAN, (Tupi) a tropical bird with a large bill [n]\n",
  "TOUCH": "to come into contact with [v -ED, -ING, -ES]\n",
  "TOUCHABLE": "capable of being touched [adj TOUCHABLY]\n",
  "TOUCHABLENESS": "the state of being touchable [n -ES]\n",
  "TOUCHABLENESSES": "TOUCHABLENESS, the state of being touchable [n]\n",
  "TOUCHABLY": "TOUCHABLE, capable of being touched [adv]\n",
  "TOUCHBACK": "a play in which the ball is dead on or behind a team's own goal line, having been put across the line by an opponent but actually put down by a member of that team [n -S]\n",
  "TOUCHBACKS": "TOUCHBACK, a play in which the ball is dead on or behind a team's own goal line, having been put across the line by an opponent but actually put down by a member of that team [n]\n",
  "TOUCHDOWN": "an act of touching the ground behind the opposing side's goal with the ball while it is held in the hands, to score points [n -S]\n",
  "TOUCHDOWNS": "TOUCHDOWN, an act of touching the ground behind the opposing side's goal with the ball while it is held in the hands, to score points [n]\n",
  "TOUCHE": "(French) a call acknowledging a hit in fencing [n -S]\n",
  "TOUCHED": "TOUCH, to come into contact with [v]\n",
  "TOUCHER": "one who touches [n -S]\n",
  "TOUCHERS": "TOUCHER, one who touches [n]\n",
  "TOUCHES": "TOUCH, to come into contact with [v]\n",
  "TOUCHHOLE": "the vent of a cannon or other firearm, by which fire is communicated to the powder of the charge [n -S]\n",
  "TOUCHHOLES": "TOUCHHOLE, the vent of a cannon or other firearm, by which fire is communicated to the powder of the charge [n]\n",
  "TOUCHIER": "TOUCHY, quick to take offence [adj]\n",
  "TOUCHIEST": "TOUCHY, quick to take offence [adj]\n",
  "TOUCHILY": "TOUCHY, quick to take offence [adv]\n",
  "TOUCHINESS": "the state of being touchy [n -ES]\n",
  "TOUCHINESSES": "TOUCHINESS, the state of being touchy [n]\n",
  "TOUCHING": "moving, affecting [adj TOUCHINGLY] / the act of touching [n -S]\n",
  "TOUCHINGLY": "TOUCHING, moving, affecting [adv]\n",
  "TOUCHINGNESS": "the state of being touching [n -ES]\n",
  "TOUCHINGNESSES": "TOUCHINGNESS, the state of being touching [n]\n",
  "TOUCHINGS": "TOUCHING, the act of touching [n]\n",
  "TOUCHLESS": "without touch [adj]\n",
  "TOUCHLINE": "either of the lines marking the side boundary in football, etc. [n -S]\n",
  "TOUCHLINES": "TOUCHLINE, either of the lines marking the side boundary in football, etc. [n]\n",
  "TOUCHMARK": "the maker's official stamp on pewter [n -S]\n",
  "TOUCHMARKS": "TOUCHMARK, the maker's official stamp on pewter [n]\n",
  "TOUCHPAD": "a keypad sensitized to finger movement or pressure [n -S]\n",
  "TOUCHPADS": "TOUCHPAD, a keypad sensitized to finger movement or pressure [n]\n",
  "TOUCHPAPER": "paper soaked in saltpetre and used for firing gunpowder [n -S]\n",
  "TOUCHPAPERS": "TOUCHPAPER, paper soaked in saltpetre and used for firing gunpowder [n]\n",
  "TOUCHSCREEN": "a computer screen operated by touch [n -S]\n",
  "TOUCHSCREENS": "TOUCHSCREEN, a computer screen operated by touch [n]\n",
  "TOUCHSTONE": "a highly siliceous (usually black) stone or other stone for testing gold or silver by the colour of the mark each makes on it; (figurative) a criterion, a standard [n -S]\n",
  "TOUCHSTONES": "TOUCHSTONE, a highly siliceous (usually black) stone or other stone for testing gold or silver by the colour of the mark each makes on it; (figurative) a criterion, a standard [n]\n",
  "TOUCHTONE": "(tradename) a phone having a push-button rather than a dial [n -S]\n",
  "TOUCHTONES": "TOUCHTONE, (tradename) a phone having a push-button rather than a dial [n]\n",
  "TOUCHUP": "the act of finishing by adding minor improvements [n -S]\n",
  "TOUCHUPS": "TOUCHUP, the act of finishing by adding minor improvements [n]\n",
  "TOUCHWOOD": "wood so decayed as to serve for tinder [n -S]\n",
  "TOUCHWOODS": "TOUCHWOOD, wood so decayed as to serve for tinder [n]\n",
  "TOUCHY": "quick to take offence [adj TOUCHIER, TOUCHIEST, TOUCHILY]\n",
  "TOUGH": "hard, durable [adj TOUGHER, TOUGHEST, TOUGHLY] / to endure [v -ED, -ING, -S]\n",
  "TOUGHED": "TOUGH, to endure [v]\n",
  "TOUGHEN": "to make tough [v -ED, -ING, -S]\n",
  "TOUGHENED": "TOUGHEN, to make tough [v]\n",
  "TOUGHENER": "something that toughens [n -S]\n",
  "TOUGHENERS": "TOUGHENER, something that toughens [n]\n",
  "TOUGHENING": "the act of toughening [n -S]\n",
  "TOUGHENINGS": "TOUGHENING, the act of toughening [n]\n",
  "TOUGHENS": "TOUGHEN, to make tough [v]\n",
  "TOUGHER": "TOUGH, hard, durable [adj]\n",
  "TOUGHEST": "TOUGH, hard, durable [adj]\n",
  "TOUGHIE": "a tough person, also TOUGHY [n -S]\n",
  "TOUGHIES": "TOUGHY, a tough person, also TOUGHIE [n]\n",
  "TOUGHING": "TOUGH, to endure [v]\n",
  "TOUGHISH": "somewhat tough [adj]\n",
  "TOUGHLY": "TOUGH, hard, durable [adv]\n",
  "TOUGHNESS": "the state of being tough [n -ES]\n",
  "TOUGHNESSES": "TOUGHNESS, the state of being tough [n]\n",
  "TOUGHS": "TOUGH, to endure [v]\n",
  "TOUGHY": "a tough person, also TOUGHIE [n TOUGHIES]\n",
  "TOUK": "(Scots) to tap, drum [v -ED, -ING, -S]\n",
  "TOUKED": "TOUK, (Scots) to tap, drum [v]\n",
  "TOUKING": "TOUK, (Scots) to tap, drum [v]\n",
  "TOUKS": "TOUK, (Scots) to tap, drum [v]\n",
  "TOULADI": "(Native American) a lake trout of North America, aka togue, also TULADI [n -S]\n",
  "TOULADIS": "TOULADI, (Native American) a lake trout of North America, aka togue, also TULADI [n]\n",
  "TOUN": "(Scots) a town [n -S]\n",
  "TOUNS": "TOUN, (Scots) a town [n]\n",
  "TOUPEE": "(French) a hairpiece worn to cover a bald spot, also TOUPET [n -S]\n",
  "TOUPEED": "having a toupee [adj]\n",
  "TOUPEES": "TOUPEE, (French) a hairpiece worn to cover a bald spot, also TOUPET [n]\n",
  "TOUPET": "(French) a hairpiece worn to cover a bald spot, also TOUPEE [n -S]\n",
  "TOUPETS": "TOUPET, (French) a hairpiece worn to cover a bald spot, also TOUPEE [n]\n",
  "TOUPIE": "a round boneless smoked ham [n -S]\n",
  "TOUPIES": "TOUPIE, a round boneless smoked ham [n]\n",
  "TOUR": "to travel from place to place [v -ED, -ING, -S]\n",
  "TOURACO": "an African bird, also TURACO, TURACOU [n -S]\n",
  "TOURACOS": "TOURACO, an African bird, also TURACO, TURACOU [n]\n",
  "TOURBILLION": "(French) a whirlwind; any whirling object, also TOURBILLON [n -S]\n",
  "TOURBILLIONS": "TOURBILLION, (French) a whirlwind; any whirling object, also TOURBILLON [n]\n",
  "TOURBILLON": "(French) a whirlwind; any whirling object, also TOURBILLION [n -S]\n",
  "TOURBILLONS": "TOURBILLON, (French) a whirlwind; any whirling object, also TOURBILLION [n]\n",
  "TOURED": "TOUR, to travel from place to place [v]\n",
  "TOURER": "a large, open automobile [n -S]\n",
  "TOURERS": "TOURER, a large, open automobile [n]\n",
  "TOURIE": "(Scots) a small heap, a knob of hair, also TOORIE [n -S]\n",
  "TOURIES": "TOURIE, (Scots) a small heap, a knob of hair, also TOORIE [n]\n",
  "TOURING": "cross-country skiing for pleasure [n -S]\n",
  "TOURINGS": "TOURING, cross-country skiing for pleasure [n]\n",
  "TOURISM": "the practice of touring for pleasure [n -S]\n",
  "TOURISMS": "TOURISM, the practice of touring for pleasure [n]\n",
  "TOURIST": "one who tours for pleasure [n -S]\n",
  "TOURISTA": "(Spanish) intestinal sickness affecting a tourist in a foreign country, also TURISTA [n -S]\n",
  "TOURISTAS": "TOURISTA, (Spanish) intestinal sickness affecting a tourist in a foreign country, also TURISTA [n]\n",
  "TOURISTED": "busy with tourists [adj]\n",
  "TOURISTIC": "relating to tourism [adj TOURISTICALLY]\n",
  "TOURISTICALLY": "TOURISTIC, relating to tourism [adv]\n",
  "TOURISTIER": "TOURISTY, like a tourist [adj]\n",
  "TOURISTIEST": "TOURISTY, like a tourist [adj]\n",
  "TOURISTS": "TOURIST, one who tours for pleasure [n]\n",
  "TOURISTY": "like a tourist [adj TOURISTIER, TOURISTIEST]\n",
  "TOURMALINE": "(French) a brittle boron aluminosilicate mineral with a glassy lustre, occurring as prismatic crystals of the trigonal system [n -S]\n",
  "TOURMALINES": "TOURMALINE, (French) a brittle boron aluminosilicate mineral with a glassy lustre, occurring as prismatic crystals of the trigonal system [n]\n",
  "TOURMALINIC": "of or like a tourmaline [adj]\n",
  "TOURNAMENT": "a series of games to determine a winner or winning team by elimination [n -S]\n",
  "TOURNAMENTS": "TOURNAMENT, a series of games to determine a winner or winning team by elimination [n]\n",
  "TOURNEDOS": "(French) a thick round beef fillet [n TOURNEDOS]\n",
  "TOURNEY": "to compete in a tournament [v -ED, -ING, -S]\n",
  "TOURNEYED": "TOURNEY, to compete in a tournament [v]\n",
  "TOURNEYER": "one who takes part in a tourney [n -S]\n",
  "TOURNEYERS": "TOURNEYER, one who takes part in a tourney [n]\n",
  "TOURNEYING": "TOURNEY, to compete in a tournament [v]\n",
  "TOURNEYS": "TOURNEY, to compete in a tournament [v]\n",
  "TOURNIQUET": "(French) a device to stop bleeding, as a bandage twisted tight by a stick, etc. [n -S]\n",
  "TOURNIQUETS": "TOURNIQUET, (French) a device to stop bleeding, as a bandage twisted tight by a stick, etc. [n]\n",
  "TOURNURE": "(French) graceful manner or bearing, deportment [n -S]\n",
  "TOURNURES": "TOURNURE, (French) graceful manner or bearing, deportment [n]\n",
  "TOURS": "TOUR, to travel from place to place [v]\n",
  "TOURTIERE": "(Canadian) a type of meat pie [n -S]\n",
  "TOURTIERES": "TOURTIERE, (Canadian) a type of meat pie [n]\n",
  "TOUSE": "to dishevel, rumple, also TOUSLE, TOUZE, TOUZLE, TOWSE, TOWZE [v TOUSED, TOUSING, TOUSES]\n",
  "TOUSED": "TOUSE, to dishevel, rumple, also TOUSLE, TOUZE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUSER": "one who touses, also TOWSER [n -S]\n",
  "TOUSERS": "TOUSER, one who touses, also TOWSER [n]\n",
  "TOUSES": "TOUSE, to dishevel, rumple, also TOUSLE, TOUZE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUSIER": "TOUSY, shaggy, unkempt, also TOUZY, TOWSY, TOWZY [adj]\n",
  "TOUSIEST": "TOUSY, shaggy, unkempt, also TOUZY, TOWSY, TOWZY [adj]\n",
  "TOUSING": "the act of tousing [n -S]\n",
  "TOUSINGS": "TOUSING, the act of tousing [n]\n",
  "TOUSLE": "to dishevel, rumple, also TOUSE, TOUZE, TOUZLE, TOWSE, TOWZE [v TOUSLED, TOUSLING, TOUSLES]\n",
  "TOUSLED": "TOUSLE, to dishevel, rumple, also TOUSE, TOUZE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUSLES": "TOUSLE, to dishevel, rumple, also TOUSE, TOUZE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUSLING": "TOUSLE, to dishevel, rumple, also TOUSE, TOUZE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUSTIE": "(Scott) irascible [adj TOUSTIER, TOUSTIEST]\n",
  "TOUSTIER": "TOUSTIE, (Scott) irascible [adj]\n",
  "TOUSTIEST": "TOUSTIE, (Scott) irascible [adj]\n",
  "TOUSY": "shaggy, unkempt, also TOUZY, TOWSY, TOWZY [adj TOUSIER, TOUSIEST]\n",
  "TOUT": "to solicit brazenly [v -ED, -ING, -S]\n",
  "TOUTED": "TOUT, to solicit brazenly [v]\n",
  "TOUTER": "one who seeks customers, as for an inn, a public conveyance, shops, and the like [n -S]\n",
  "TOUTERS": "TOUTER, one who seeks customers, as for an inn, a public conveyance, shops, and the like [n]\n",
  "TOUTIE": "(Scots) petulant [adj TOUTIER, TOUTIEST]\n",
  "TOUTIER": "TOUTIE, (Scots) petulant [adj]\n",
  "TOUTIEST": "TOUTIE, (Scots) petulant [adj]\n",
  "TOUTING": "TOUT, to solicit brazenly [v]\n",
  "TOUTON": "a deep-fried round of bread dough [n -S]\n",
  "TOUTONS": "TOUTON, a deep-fried round of bread dough [n]\n",
  "TOUTS": "TOUT, to solicit brazenly [v]\n",
  "TOUZE": "to dishevel, rumple, also TOUSE, TOUSLE, TOUZLE, TOWSE, TOWZE [v TOUZED, TOUZING, TOUZES]\n",
  "TOUZED": "TOUZE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUZES": "TOUZE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUZIER": "TOUZY, shaggy, unkempt, also TOUSY, TOWSY, TOWZY [adj]\n",
  "TOUZIEST": "TOUZY, shaggy, unkempt, also TOUSY, TOWSY, TOWZY [adj]\n",
  "TOUZING": "TOUZE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZLE, TOWSE, TOWZE [v]\n",
  "TOUZLE": "to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOWSE, TOWZE [v TOUZLED, TOUZLING, TOUZLES]\n",
  "TOUZLED": "TOUZLE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOWSE, TOWZE [v]\n",
  "TOUZLES": "TOUZLE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOWSE, TOWZE [v]\n",
  "TOUZLING": "TOUZLE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOWSE, TOWZE [v]\n",
  "TOUZY": "shaggy, unkempt, also TOUSY, TOWSY, TOWZY [adj TOUZIER, TOUZIEST]\n",
  "TOVARICH": "(Russian) friend, comrade, also TOVARISCH, TOVARISH [n -ES]\n",
  "TOVARICHES": "TOVARICH, (Russian) friend, comrade, also TOVARISCH, TOVARISH [n]\n",
  "TOVARISCH": "(Russian) friend, comrade, also TOVARICH, TOVARISH [n -ES]\n",
  "TOVARISCHES": "TOVARISCH, (Russian) friend, comrade, also TOVARICH, TOVARISH [n]\n",
  "TOVARISH": "(Russian) friend, comrade, also TOVARICH, TOVARISCH [n -ES]\n",
  "TOVARISHES": "TOVARISH, (Russian) friend, comrade, also TOVARICH, TOVARISCH [n]\n",
  "TOW": "to pull by means of a chain or rope [v -ED, -ING, -S]\n",
  "TOWABLE": "able to be towed [adj]\n",
  "TOWAGE": "the price paid for towing [n -S]\n",
  "TOWAGES": "TOWAGE, the price paid for towing [n]\n",
  "TOWARD": "in the direction of, also TOWARDS [adj]\n",
  "TOWARDLINESS": "the state of being towardly [n -ES]\n",
  "TOWARDLINESSES": "TOWARDLINESS, the state of being towardly [n]\n",
  "TOWARDLY": "(archaic) favourable, promising [adj]\n",
  "TOWARDNESS": "the state of being toward [n -ES]\n",
  "TOWARDNESSES": "TOWARDNESS, the state of being toward [n]\n",
  "TOWARDS": "in the direction of, also TOWARD [prep]\n",
  "TOWAWAY": "the act of towing away a vehicle [n -S]\n",
  "TOWAWAYS": "TOWAWAY, the act of towing away a vehicle [n]\n",
  "TOWBAR": "a metal bar used for towing [n -S]\n",
  "TOWBARS": "TOWBAR, a metal bar used for towing [n]\n",
  "TOWBOAT": "a vessel constructed for being towed, as a canal boat [n -S]\n",
  "TOWBOATS": "TOWBOAT, a vessel constructed for being towed, as a canal boat [n]\n",
  "TOWED": "TOW, to pull by means of a chain or rope [v]\n",
  "TOWEL": "to wipe with an absorbent cloth [v TOWELED or TOWELLED, TOWELING or TOWELLING, TOWELS]\n",
  "TOWELED": "TOWEL, to wipe with an absorbent cloth [v]\n",
  "TOWELETTE": "a small usually premoistened piece of material e.g. for cleaning the hands [n -S]\n",
  "TOWELETTES": "TOWELETTE, a small usually premoistened piece of material e.g. for cleaning the hands [n]\n",
  "TOWELHEAD": "(offensive) a person of Arab descent [n -S]\n",
  "TOWELHEADS": "TOWELHEAD, (offensive) a person of Arab descent [n]\n",
  "TOWELING": "material used for towels, also TOWELLING [n -S]\n",
  "TOWELINGS": "TOWELING, material used for towels, also TOWELLING [n]\n",
  "TOWELLED": "TOWEL, to wipe with an absorbent cloth [v]\n",
  "TOWELLING": "material for towels [n -S]\n",
  "TOWELLINGS": "TOWELLING, material for towels [n]\n",
  "TOWELS": "TOWEL, to wipe with an absorbent cloth [v]\n",
  "TOWER": "to rise to a great height [v -ED, -ING, -S]\n",
  "TOWERED": "TOWER, to rise to a great height [v]\n",
  "TOWERIER": "TOWERY, very tall [adj]\n",
  "TOWERIEST": "TOWERY, very tall [adj]\n",
  "TOWERING": "TOWER, to rise to a great height [v]\n",
  "TOWERINGLY": "TOWERING, TOWER, to rise to a great height [adv]\n",
  "TOWERLESS": "without a tower [adj]\n",
  "TOWERLIKE": "like a tower [adj]\n",
  "TOWERS": "TOWER, to rise to a great height [v]\n",
  "TOWERY": "very tall [adj TOWERIER, TOWERIEST]\n",
  "TOWHEAD": "a head of light blond hair [n -S]\n",
  "TOWHEADED": "with light-coloured hair [adj]\n",
  "TOWHEADS": "TOWHEAD, a head of light blond hair [n]\n",
  "TOWHEE": "any of several buntings of the genus Pipilo, of brush and woodland in North America [n -S]\n",
  "TOWHEES": "TOWHEE, any of several buntings of the genus Pipilo, of brush and woodland in North America [n]\n",
  "TOWIE": "a form of contact bridge for three players [n -S]\n",
  "TOWIER": "TOWY, pertaining to tow, prepared fibres of flax, hemp etc. [adj]\n",
  "TOWIES": "TOWIE, a form of contact bridge for three players [n]\n",
  "TOWIEST": "TOWY, pertaining to tow, prepared fibres of flax, hemp etc. [adj]\n",
  "TOWING": "the act of towing [n -S]\n",
  "TOWINGS": "TOWING, the act of towing [n]\n",
  "TOWKAY": "(Chinese) sir, master [n -S]\n",
  "TOWKAYS": "TOWKAY, (Chinese) sir, master [n]\n",
  "TOWLINE": "a line used for towing [n -S]\n",
  "TOWLINES": "TOWLINE, a line used for towing [n]\n",
  "TOWMON": "(Scots) a twelvemonth, also TOWMOND, TOWMONT [n -S]\n",
  "TOWMOND": "(Scots) a twelvemonth, also TOWMON, TOWMONT [n -S]\n",
  "TOWMONDS": "TOWMOND, (Scots) a twelvemonth, also TOWMON, TOWMONT [n]\n",
  "TOWMONS": "TOWMON, (Scots) a twelvemonth, also TOWMOND, TOWMONT [n]\n",
  "TOWMONT": "(Scots) a twelvemonth, also TOWMON, TOWMOND [n -S]\n",
  "TOWMONTS": "TOWMONT, (Scots) a twelvemonth, also TOWMON, TOWMOND [n]\n",
  "TOWN": "an urban centre of population [n -S]\n",
  "TOWNEE": "a town-dweller, also TOWNIE [n -S]\n",
  "TOWNEES": "TOWNEE, a town-dweller, also TOWNIE [n]\n",
  "TOWNFOLK": "the people of a town, also TOWNSFOLK [n]\n",
  "TOWNHALL": "as in townhall clock, the name of a small flowering plant, moschatel [adj]\n",
  "TOWNHOME": "one of a series of contiguous houses of two or three stories [n -S]\n",
  "TOWNHOMES": "TOWNHOME, one of a series of contiguous houses of two or three stories [n]\n",
  "TOWNHOUSE": "(Scots) a town hall [n -S]\n",
  "TOWNHOUSES": "TOWNHOUSE, (Scots) a town hall [n]\n",
  "TOWNIE": "a town-dweller, also TOWNEE [n -S]\n",
  "TOWNIER": "TOWNY, belonging to the town [adj]\n",
  "TOWNIES": "TOWNIE, a town-dweller, also TOWNEE [n]\n",
  "TOWNIEST": "TOWNY, belonging to the town [adj]\n",
  "TOWNISH": "characteristic of a town [adj]\n",
  "TOWNLAND": "esp. in Ireland, a division of land of varying extent; a township [n -S]\n",
  "TOWNLANDS": "TOWNLAND, esp. in Ireland, a division of land of varying extent; a township [n]\n",
  "TOWNLESS": "having no towns [adj]\n",
  "TOWNLET": "a small town, also TOWNLING [n -S]\n",
  "TOWNLETS": "TOWNLET, a small town, also TOWNLING [n]\n",
  "TOWNLIER": "TOWNLY, townish [adj]\n",
  "TOWNLIEST": "TOWNLY, townish [adj]\n",
  "TOWNLING": "a town dweller [n -S]\n",
  "TOWNLINGS": "TOWNLING, a town dweller [n]\n",
  "TOWNLY": "townish [adj TOWNLIER, TOWNLIEST]\n",
  "TOWNS": "TOWN, an urban centre of population [n]\n",
  "TOWNSCAPE": "to design a town [v TOWNSCAPED, TOWNSCAPING, TOWNSCAPES]\n",
  "TOWNSCAPED": "TOWNSCAPE, to design a town [v]\n",
  "TOWNSCAPES": "TOWNSCAPE, to design a town [v]\n",
  "TOWNSCAPING": "the act of designing a town [n -S]\n",
  "TOWNSCAPINGS": "TOWNSCAPING, the act of designing a town [n]\n",
  "TOWNSFOLK": "the people of a town, also TOWNFOLK [n -S]\n",
  "TOWNSFOLKS": "TOWNSFOLK, the people of a town, also TOWNFOLK [n]\n",
  "TOWNSHIP": "(South African) an urban settlement inhabited by poor black people [n -S]\n",
  "TOWNSHIPS": "TOWNSHIP, (South African) an urban settlement inhabited by poor black people [n]\n",
  "TOWNSITE": "the site of a town [n -S]\n",
  "TOWNSITES": "TOWNSITE, the site of a town [n]\n",
  "TOWNSKIP": "(Dickens) a city urchin [n -S]\n",
  "TOWNSKIPS": "TOWNSKIP, (Dickens) a city urchin [n]\n",
  "TOWNSMAN": "a resident of a town [n TOWNSMEN]\n",
  "TOWNSMEN": "TOWNSMAN, a resident of a town [n]\n",
  "TOWNSPEOPLE": "the inhabitants of a town or city [n -S]\n",
  "TOWNSPEOPLES": "TOWNSPEOPLE, the inhabitants of a town or city [n]\n",
  "TOWNSWOMAN": "a woman who is a native or resident of a town or city [n TOWNSWOMEN]\n",
  "TOWNSWOMEN": "TOWNSWOMAN, a woman who is a native or resident of a town or city [n]\n",
  "TOWNWARD": "in the direction of the town [adv]\n",
  "TOWNWEAR": "clothes suitable for town [n -S]\n",
  "TOWNWEARS": "TOWNWEAR, clothes suitable for town [n]\n",
  "TOWNY": "belonging to the town [adj TOWNIER, TOWNIEST]\n",
  "TOWPATH": "a path along a river where animals draw boats [n -S]\n",
  "TOWPATHS": "TOWPATH, a path along a river where animals draw boats [n]\n",
  "TOWPLANE": "an airplane that tows gliders [n -S]\n",
  "TOWPLANES": "TOWPLANE, an airplane that tows gliders [n]\n",
  "TOWROPE": "a rope used in towing [n -S]\n",
  "TOWROPES": "TOWROPE, a rope used in towing [n]\n",
  "TOWS": "TOW, to pull by means of a chain or rope [v]\n",
  "TOWSACK": "a sack made of a coarse fabric [n -S]\n",
  "TOWSACKS": "TOWSACK, a sack made of a coarse fabric [n]\n",
  "TOWSE": "to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWZE [v TOWSED, TOWSING, TOWSES]\n",
  "TOWSED": "TOWSE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWZE [v]\n",
  "TOWSER": "one who towses, also TOUSER [n -S]\n",
  "TOWSERS": "TOWSER, one who towses, also TOUSER [n]\n",
  "TOWSES": "TOWSE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWZE [v]\n",
  "TOWSIER": "TOWSY, shaggy, unkempt, also TOUSY, TOUZY, TOWZY [adj]\n",
  "TOWSIEST": "TOWSY, shaggy, unkempt, also TOUSY, TOUZY, TOWZY [adj]\n",
  "TOWSING": "TOWSE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWZE [v]\n",
  "TOWSY": "shaggy, unkempt, also TOUSY, TOUZY, TOWZY [adj TOWSIER, TOWSIEST]\n",
  "TOWT": "(Scots) to pout, sulk [v -ED, -ING, -S]\n",
  "TOWTED": "TOWT, (Scots) to pout, sulk [v]\n",
  "TOWTING": "TOWT, (Scots) to pout, sulk [v]\n",
  "TOWTS": "TOWT, (Scots) to pout, sulk [v]\n",
  "TOWY": "pertaining to tow, prepared fibres of flax, hemp etc. [adj TOWIER, TOWIEST]\n",
  "TOWZE": "to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWSE [v TOWZED, TOWZING, TOWZES]\n",
  "TOWZED": "TOWZE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWSE [v]\n",
  "TOWZES": "TOWZE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWSE [v]\n",
  "TOWZIER": "TOWZY, shaggy, unkempt, also TOUSY, TOUZY, TOWSY [adj]\n",
  "TOWZIEST": "TOWZY, shaggy, unkempt, also TOUSY, TOUZY, TOWSY [adj]\n",
  "TOWZING": "TOWZE, to dishevel, rumple, also TOUSE, TOUSLE, TOUZE, TOUZLE, TOWSE [v]\n",
  "TOWZY": "shaggy, unkempt, also TOUSY, TOUZY, TOWSY [adj TOWZIER, TOWZIEST]\n",
  "TOXAEMIA": "the condition of having toxins in the blood, also TOXEMIA [n -S]\n",
  "TOXAEMIAS": "TOXAEMIA, the condition of having toxins in the blood, also TOXEMIA [n]\n",
  "TOXAEMIC": "relating to toxaemia, blood poisoning due to toxins in blood, also TOXEMIC [adj]\n",
  "TOXALBUMIN": "any of a group of toxic albumins that occur in certain plants, such as toadstools, and in snake venom [n -S]\n",
  "TOXALBUMINS": "TOXALBUMIN, any of a group of toxic albumins that occur in certain plants, such as toadstools, and in snake venom [n]\n",
  "TOXAPHENE": "chlorinated camphene used as an insecticide [n -S]\n",
  "TOXAPHENES": "TOXAPHENE, chlorinated camphene used as an insecticide [n]\n",
  "TOXEMIA": "blood poisoning due to toxins in blood, also TOXAEMIA [n -S]\n",
  "TOXEMIAS": "TOXEMIA, blood poisoning due to toxins in blood, also TOXAEMIA [n]\n",
  "TOXEMIC": "relating to toxemia, blood poisoning due to toxins in blood, also TOXAEMIC [adj]\n",
  "TOXIC": "of or pertaining to poison, also TOXICAL [adj TOXICALLY] / a poison [n -S]\n",
  "TOXICAL": "of or pertaining to poison, also TOXIC [adj TOXICALLY]\n",
  "TOXICALLY": "TOXICAL, of or pertaining to poison, also TOXIC [adv]\n",
  "TOXICANT": "a poisonous substance [n -S]\n",
  "TOXICANTS": "TOXICANT, a poisonous substance [n]\n",
  "TOXICATION": "the state of being toxic [n -S]\n",
  "TOXICATIONS": "TOXICATION, the state of being toxic [n]\n",
  "TOXICITIES": "TOXICITY, the state of being toxic [n]\n",
  "TOXICITY": "the state of being toxic [n TOXICITIES]\n",
  "TOXICOGENIC": "producing or produced by poisons [adj]\n",
  "TOXICOLOGIC": "of or relating to toxicology, the study of poisons, also TOXICOLOGICAL [adj TOXICOLOGICALLY]\n",
  "TOXICOLOGICAL": "of or relating to toxicology, the study of poisons, also TOXICOLOGIC [adj TOXICOLOGICALLY]\n",
  "TOXICOLOGICALLY": "TOXICOLOGICAL, of or relating to toxicology, the study of poisons, also TOXICOLOGIC [adv]\n",
  "TOXICOLOGIES": "TOXICOLOGY, the science which treats of poisons, their effects, antidotes, and recognition [n]\n",
  "TOXICOLOGIST": "an expert in toxicology [n -S]\n",
  "TOXICOLOGISTS": "TOXICOLOGIST, an expert in toxicology [n]\n",
  "TOXICOLOGY": "the science which treats of poisons, their effects, antidotes, and recognition [n TOXICOLOGIES]\n",
  "TOXICOMANIA": "a morbid craving for poisons [n -S]\n",
  "TOXICOMANIAS": "TOXICOMANIA, a morbid craving for poisons [n]\n",
  "TOXICOPHAGOUS": "eating poison, also TOXIPHAGOUS [adj]\n",
  "TOXICOPHOBIA": "the morbid fear of poisoning, also TOXIPHOBIA [n -S]\n",
  "TOXICOPHOBIAS": "TOXICOPHOBIA, the morbid fear of poisoning, also TOXIPHOBIA [n]\n",
  "TOXICOSES": "TOXICOSIS, a pathological condition caused by a poison or toxin [n]\n",
  "TOXICOSIS": "a pathological condition caused by a poison or toxin [n TOXICOSES]\n",
  "TOXICS": "TOXIC, a poison [n]\n",
  "TOXIGENIC": "producing toxic substances and agents [adj]\n",
  "TOXIGENICITIES": "TOXIGENICITY, the state of being toxigenic [n]\n",
  "TOXIGENICITY": "the state of being toxigenic [n TOXIGENICITIES]\n",
  "TOXIN": "a poisonous product formed by pathogenic bacteria, as a toxic proteid or poisonous ptomaine, also TOXINE [n -S]\n",
  "TOXINE": "a poisonous product formed by pathogenic bacteria, as a toxic proteid or poisonous ptomaine, also TOXIN [n -S]\n",
  "TOXINES": "TOXINE, a poisonous product formed by pathogenic bacteria, as a toxic proteid or poisonous ptomaine, also TOXIN [n]\n",
  "TOXINS": "TOXIN, a poisonous product formed by pathogenic bacteria, as a toxic proteid or poisonous ptomaine, also TOXINE [n]\n",
  "TOXIPHAGOUS": "eating poison, also TOXICOPHAGOUS [adj]\n",
  "TOXIPHOBIA": "the morbid fear of poisoning, also TOXICOPHOBIA [n -S]\n",
  "TOXIPHOBIAC": "one who suffers from toxiphobia, fear of poison or being poisoned [n -S]\n",
  "TOXIPHOBIACS": "TOXIPHOBIAC, one who suffers from toxiphobia, fear of poison or being poisoned [n]\n",
  "TOXIPHOBIAS": "TOXIPHOBIA, the morbid fear of poisoning, also TOXICOPHOBIA [n]\n",
  "TOXOCARA": "a kind of parasitic worm found in the intestines of dogs and cats [n -S]\n",
  "TOXOCARAL": "related to toxocara [adj]\n",
  "TOXOCARAS": "TOXOCARA, a kind of parasitic worm found in the intestines of dogs and cats [n]\n",
  "TOXOCARIASES": "TOXOCARIASIS, a disease caused by parasitic worms [n]\n",
  "TOXOCARIASIS": "a disease caused by parasitic worms [n TOXOCARIASES]\n",
  "TOXOID": "a toxin treated to reduce toxicity and used in immunisation [n -S]\n",
  "TOXOIDS": "TOXOID, a toxin treated to reduce toxicity and used in immunisation [n]\n",
  "TOXOPHILIES": "TOXOPHILY, the sport of archery [n]\n",
  "TOXOPHILITE": "one fond of or expert at archery [n -S]\n",
  "TOXOPHILITES": "TOXOPHILITE, one fond of or expert at archery [n]\n",
  "TOXOPHILITIC": "related to archery [adj]\n",
  "TOXOPHILY": "the sport of archery [n TOXOPHILIES]\n",
  "TOXOPLASMA": "a genus of microorganisms causing infections in domestic cats and humans [n -S]\n",
  "TOXOPLASMAS": "TOXOPLASMA, a genus of microorganisms causing infections in domestic cats and humans [n]\n",
  "TOXOPLASMIC": "relating to toxoplasma [adj]\n",
  "TOXOPLASMOSES": "TOXOPLASMOSIS, an infection of animals (esp. the domestic cat) and humans by microorganisms, prob protozoa, of the genus Toxoplasma [n]\n",
  "TOXOPLASMOSIS": "an infection of animals (esp. the domestic cat) and humans by microorganisms, prob protozoa, of the genus Toxoplasma [n TOXOPLASMOSES]\n",
  "TOY": "to amuse oneself with a child's plaything [v -ED, -ING, -S]\n",
  "TOYBOX": "a box for toys [n -ES]\n",
  "TOYBOXES": "TOYBOX, a box for toys [n]\n",
  "TOYCHEST": "a chest for toys [n -S]\n",
  "TOYCHESTS": "TOYCHEST, a chest for toys [n]\n",
  "TOYED": "TOY, to amuse oneself with a child's plaything [v]\n",
  "TOYER": "one who toys, a trifler [n -S]\n",
  "TOYERS": "TOYER, one who toys, a trifler [n]\n",
  "TOYETIC": "(of a film or television programme) having the potential to generate consumer interest in associated merchandise, such as toys, computer games etc. [adj]\n",
  "TOYING": "the act of toying [n -S]\n",
  "TOYINGS": "TOYING, the act of toying [n]\n",
  "TOYISH": "sportive; trifling; wanton, also TOYSOME [adj TOYISHLY]\n",
  "TOYISHLY": "TOYISH, sportive; trifling; wanton, also TOYSOME [adv]\n",
  "TOYISHNESS": "the state of being toyish [n -ES]\n",
  "TOYISHNESSES": "TOYISHNESS, the state of being toyish [n]\n",
  "TOYLAND": "the toy industry [n -S]\n",
  "TOYLANDS": "TOYLAND, the toy industry [n]\n",
  "TOYLESOME": "(Spenser) toilsome, also TOYLSOM [adj]\n",
  "TOYLESS": "without toys [adj]\n",
  "TOYLIKE": "like toys [adj]\n",
  "TOYLSOM": "(Spenser) toilsome, also TOYLESOME [adj]\n",
  "TOYMAN": "a seller of toys [n TOYMEN]\n",
  "TOYMEN": "TOYMAN, a seller of toys [n]\n",
  "TOYO": "a smooth straw used for making hats [n -S]\n",
  "TOYON": "(Spanish) an ornamental evergreen shrub [n -S]\n",
  "TOYONS": "TOYON, (Spanish) an ornamental evergreen shrub [n]\n",
  "TOYOS": "TOYO, a smooth straw used for making hats [n]\n",
  "TOYS": "TOY, to amuse oneself with a child's plaything [v]\n",
  "TOYSHOP": "a shop where toys are sold [n -S]\n",
  "TOYSHOPS": "TOYSHOP, a shop where toys are sold [n]\n",
  "TOYSOME": "sportive; trifling; wanton, also TOYISH [adj]\n",
  "TOYTOWN": "a small model of a town [n -S]\n",
  "TOYTOWNS": "TOYTOWN, a small model of a town [n]\n",
  "TOYWOMAN": "a woman who sells toys [n TOYWOMEN]\n",
  "TOYWOMEN": "TOYWOMAN, a woman who sells toys [n]\n",
  "TOZE": "to tease out, draw out, also TEASE, TEAZE, TOAZE, TOSE [v TOZED, TOZING, TOZES]\n",
  "TOZED": "TOZE, to tease out, draw out, also TEASE, TEAZE, TOAZE, TOSE [v]\n",
  "TOZES": "TOZE, to tease out, draw out, also TEASE, TEAZE, TOAZE, TOSE [v]\n",
  "TOZIE": "(Scots) a shawl made from a goat's inner coat [n -S]\n",
  "TOZIES": "TOZIE, (Scots) a shawl made from a goat's inner coat [n]\n",
  "TOZING": "TOZE, to tease out, draw out, also TEASE, TEAZE, TOAZE, TOSE [v]\n",
  "TRABEATE": "built of horizontal beams, not arches and vaults, also TRABEATED [adj]\n",
  "TRABEATED": "built of horizontal beams, not arches and vaults, also TRABEATE [adj]\n",
  "TRABEATION": "a construct of horizontal beams [n -S]\n",
  "TRABEATIONS": "TRABEATION, a construct of horizontal beams [n]\n",
  "TRABECULA": "(Latin) a rodlike structure running across a cavity and giving it internal support [n TRABECULAE or TRABECULAS]\n",
  "TRABECULAE": "TRABECULA, (Latin) a rodlike structure running across a cavity and giving it internal support [n]\n",
  "TRABECULAR": "having trabeculae, transversely barred, also TRABECULATE, TRABECULATED [adj]\n",
  "TRABECULAS": "TRABECULA, (Latin) a rodlike structure running across a cavity and giving it internal support [n]\n",
  "TRABECULATE": "having trabeculae, transversely barred, also TRABECULAR, TRABECULATED [adj]\n",
  "TRABECULATED": "having trabeculae, transversely barred, also TRABECULAR, TRABECULATE [adj]\n",
  "TRABS": "(Liverpool dialect) sports footwear, training shoes [n]\n",
  "TRACASSERIE": "(French) a state of disturbance or annoyance [n -S]\n",
  "TRACASSERIES": "TRACASSERIE, (French) a state of disturbance or annoyance [n]\n",
  "TRACE": "to follow the course of [v TRACED, TRACING, TRACES]\n",
  "TRACEABILITIES": "TRACEABILITY, the state of being traceable [n]\n",
  "TRACEABILITY": "the state of being traceable [n TRACEABILITIES]\n",
  "TRACEABLE": "that can be traced [adj TRACEABLY]\n",
  "TRACEABLENESS": "the state of being traceable [n -ES]\n",
  "TRACEABLENESSES": "TRACEABLENESS, the state of being traceable [n]\n",
  "TRACEABLY": "TRACEABLE, that can be traced [adv]\n",
  "TRACED": "TRACE, to follow the course of [v]\n",
  "TRACELESS": "without trace [adj TRACELESSLY]\n",
  "TRACELESSLY": "TRACELESS, without trace [adv]\n",
  "TRACER": "a kind of ammunition [n -S]\n",
  "TRACERIED": "with tracery [adj]\n",
  "TRACERIES": "TRACERY, ornamental work of interlaced lines [n]\n",
  "TRACERS": "TRACER, a kind of ammunition [n]\n",
  "TRACERY": "ornamental work of interlaced lines [n TRACERIES]\n",
  "TRACES": "TRACE, to follow the course of [v]\n",
  "TRACEUR": "(French) a participant in parkour, the sport of running in urban areas performing gymnastics on manmade objects [n -S]\n",
  "TRACEURS": "TRACEUR, (French) a participant in parkour, the sport of running in urban areas performing gymnastics on manmade objects [n]\n",
  "TRACHEA": "(Greek) the passage conveying air to the lungs [n TRACHEAS or TRACHEAE]\n",
  "TRACHEAE": "TRACHEA, (Greek) the passage conveying air to the lungs [n]\n",
  "TRACHEAL": "relating to the trachea [adj]\n",
  "TRACHEARIAN": "belonging to the Trachearia, mites and ticks [adj] / a member of the Trachearia [n -S]\n",
  "TRACHEARIANS": "TRACHEARIAN, a member of the Trachearia [n]\n",
  "TRACHEARIES": "TRACHEARY, a tracheary animal [n]\n",
  "TRACHEARY": "breathing by means of tracheae [adj] / a tracheary animal [n TRACHEARIES]\n",
  "TRACHEAS": "TRACHEA, (Greek) the passage conveying air to the lungs [n]\n",
  "TRACHEATE": "breathing by means of tracheae [adj] / an animal that breathes by means of tracheae [n -S]\n",
  "TRACHEATED": "having a trachea [adj]\n",
  "TRACHEATES": "TRACHEATE, an animal that breathes by means of tracheae [n]\n",
  "TRACHEID": "a long tubelike but closed cell in xylem, also TRACHEIDE [n -S]\n",
  "TRACHEIDAL": "of or like a tracheid, a long tubelike but closed cell in xylem [adj]\n",
  "TRACHEIDE": "a long tubelike but closed cell in xylem, also TRACHEID [n -S]\n",
  "TRACHEIDES": "TRACHEIDE, a long tubelike but closed cell in xylem, also TRACHEID [n]\n",
  "TRACHEIDS": "TRACHEID, a long tubelike but closed cell in xylem, also TRACHEIDE [n]\n",
  "TRACHEITIDES": "TRACHEITIS, inflammation of the trachea, or windpipe, also TRACHITIS [n]\n",
  "TRACHEITIS": "inflammation of the trachea, or windpipe, also TRACHITIS [n TRACHEITIDES or TRACHEITISES]\n",
  "TRACHEITISES": "TRACHEITIS, inflammation of the trachea, or windpipe, also TRACHITIS [n]\n",
  "TRACHELATE": "having a neck [adj]\n",
  "TRACHEOLAR": "of or like a tracheole, one of the minute delicate endings of a branched trachea of an insect [adj]\n",
  "TRACHEOLE": "one of the minute delicate endings of a branched trachea of an insect [n -S]\n",
  "TRACHEOLES": "TRACHEOLE, one of the minute delicate endings of a branched trachea of an insect [n]\n",
  "TRACHEOPHYTE": "any member of the clade of plants possessing vascular tissue; a vascular plant [n -S]\n",
  "TRACHEOPHYTES": "TRACHEOPHYTE, any member of the clade of plants possessing vascular tissue; a vascular plant [n]\n",
  "TRACHEOSCOPIES": "TRACHEOSCOPY, inspection of the trachea [n]\n",
  "TRACHEOSCOPY": "inspection of the trachea [n TRACHEOSCOPIES]\n",
  "TRACHEOSTOMIES": "TRACHEOSTOMY, a surgical incision into the windpipe, to relieve choking, also TRACHEOTOMY [n]\n",
  "TRACHEOSTOMY": "a surgical incision into the windpipe, to relieve choking, also TRACHEOTOMY [n TRACHEOSTOMIES]\n",
  "TRACHEOTOMIES": "TRACHEOTOMY, a surgical incision into the windpipe, to relieve choking, also TRACHEOSTOMY [n]\n",
  "TRACHEOTOMY": "a surgical incision into the windpipe, to relieve choking, also TRACHEOSTOMY [n TRACHEOTOMIES]\n",
  "TRACHINUS": "any member of the weever genus of fish [n -ES]\n",
  "TRACHINUSES": "TRACHINUS, any member of the weever genus of fish [n]\n",
  "TRACHITIS": "inflammation of the trachea, also TRACHEITIS [n -ES]\n",
  "TRACHITISES": "TRACHITIS, inflammation of the trachea, also TRACHEITIS [n]\n",
  "TRACHLE": "to draggle, also TRAUCHLE [v TRACHLED, TRACHLING, TRACHLES]\n",
  "TRACHLED": "TRACHLE, to draggle, also TRAUCHLE [v]\n",
  "TRACHLES": "TRACHLE, to draggle, also TRAUCHLE [v]\n",
  "TRACHLING": "TRACHLE, to draggle, also TRAUCHLE [v]\n",
  "TRACHOMA": "an eye-disease, a chronic form of conjunctivitis [n -S]\n",
  "TRACHOMAS": "TRACHOMA, an eye-disease, a chronic form of conjunctivitis [n]\n",
  "TRACHOMATOUS": "relating to trachoma [adj]\n",
  "TRACHYPTERUS": "any member of the dealfish genus Trachypterus [n -ES]\n",
  "TRACHYPTERUSES": "TRACHYPTERUS, any member of the dealfish genus Trachypterus [n]\n",
  "TRACHYTE": "a light-coloured igneous rock [n -S]\n",
  "TRACHYTES": "TRACHYTE, a light-coloured igneous rock [n]\n",
  "TRACHYTIC": "of, pertaining to, or resembling, trachyte, an igneous rock [adj]\n",
  "TRACHYTOID": "resembling trachyte [adj]\n",
  "TRACING": "something that is traced [n -S]\n",
  "TRACINGS": "TRACING, something that is traced [n]\n",
  "TRACK": "to follow the marks of an animal or vehicle [v -ED, -ING, -S]\n",
  "TRACKABLE": "that can be tracked [adj]\n",
  "TRACKAGE": "the track system of a railroad [n -S]\n",
  "TRACKAGES": "TRACKAGE, the track system of a railroad [n]\n",
  "TRACKBALL": "a spherical ball mounted in a box structure that can be used to control a computer cursor, also TRACKERBALL [n -S]\n",
  "TRACKBALLS": "TRACKBALL, a spherical ball mounted in a box structure that can be used to control a computer cursor, also TRACKERBALL [n]\n",
  "TRACKBED": "the foundations of a railway track [n -S]\n",
  "TRACKBEDS": "TRACKBED, the foundations of a railway track [n]\n",
  "TRACKED": "TRACK, to follow the marks of an animal or vehicle [v]\n",
  "TRACKER": "one who tracks [n -S]\n",
  "TRACKERBALL": "a spherical ball that can be rotated with the palm of the hand causing the cursor to move around the screen, also TRACKBALL [n -S]\n",
  "TRACKERBALLS": "TRACKERBALL, a spherical ball that can be rotated with the palm of the hand causing the cursor to move around the screen, also TRACKBALL [n]\n",
  "TRACKERS": "TRACKER, one who tracks [n]\n",
  "TRACKIE": "(of a garment) originally constituting part of a tracksuit [adj]\n",
  "TRACKIES": "(colloquial) a tracksuit [n]\n",
  "TRACKING": "the placement of students within a curriculum [n -S]\n",
  "TRACKINGS": "TRACKING, the placement of students within a curriculum [n]\n",
  "TRACKLAYER": "one who lays tracks [n -S]\n",
  "TRACKLAYERS": "TRACKLAYER, one who lays tracks [n]\n",
  "TRACKLAYING": "the laying of tracks on a railway line [n -S]\n",
  "TRACKLAYINGS": "TRACKLAYING, the laying of tracks on a railway line [n]\n",
  "TRACKLEMENT": "(dialect) a condiment, accompaniment, etc., to food [n -S]\n",
  "TRACKLEMENTS": "TRACKLEMENT, (dialect) a condiment, accompaniment, etc., to food [n]\n",
  "TRACKLESS": "without a track [adj TRACKLESSLY]\n",
  "TRACKLESSLY": "TRACKLESS, without a track [adv]\n",
  "TRACKLESSNESS": "the state of being trackless [n -ES]\n",
  "TRACKLESSNESSES": "TRACKLESSNESS, the state of being trackless [n]\n",
  "TRACKMAN": "a railroad worker [n TRACKMEN]\n",
  "TRACKMEN": "TRACKMAN, a railroad worker [n]\n",
  "TRACKPAD": "part of a laptop computer functioning like a mouse, also TOUCHPAD [n -S]\n",
  "TRACKPADS": "TRACKPAD, part of a laptop computer functioning like a mouse, also TOUCHPAD [n]\n",
  "TRACKROAD": "a towpath [n -S]\n",
  "TRACKROADS": "TRACKROAD, a towpath [n]\n",
  "TRACKS": "TRACK, to follow the marks of an animal or vehicle [v]\n",
  "TRACKSIDE": "the side of a (racing) track [n -S]\n",
  "TRACKSIDES": "TRACKSIDE, the side of a (racing) track [n]\n",
  "TRACKSUIT": "a loose warm suit intended to be worn by athletes when warming up or training [n -S]\n",
  "TRACKSUITS": "TRACKSUIT, a loose warm suit intended to be worn by athletes when warming up or training [n]\n",
  "TRACKWALKER": "a worker employed to walk over and inspect a section of railroad tracks [n -S]\n",
  "TRACKWALKERS": "TRACKWALKER, a worker employed to walk over and inspect a section of railroad tracks [n]\n",
  "TRACKWAY": "a trodden path [n -S]\n",
  "TRACKWAYS": "TRACKWAY, a trodden path [n]\n",
  "TRACT": "(Spenser) to trace, track [v -ED, -ING, -S]\n",
  "TRACTABILITIES": "TRACTABILITY, the state of being tractable, also TRACTABLENESS [n]\n",
  "TRACTABILITY": "the state of being tractable, also TRACTABLENESS [n TRACTABILITIES]\n",
  "TRACTABLE": "docile, easily managed [adj TRACTABLY]\n",
  "TRACTABLENESS": "the state of being tractable, also TRACTABILITY [n -ES]\n",
  "TRACTABLENESSES": "TRACTABLENESS, the state of being tractable, also TRACTABILITY [n]\n",
  "TRACTABLY": "TRACTABLE, docile, easily managed [adv]\n",
  "TRACTARIAN": "a writer of tracts, also TRACTATOR [n -S]\n",
  "TRACTARIANS": "TRACTARIAN, a writer of tracts, also TRACTATOR [n]\n",
  "TRACTATE": "a formal, systematic, written account of a subject, also TREATISE [n -S]\n",
  "TRACTATES": "TRACTATE, a formal, systematic, written account of a subject, also TREATISE [n]\n",
  "TRACTATOR": "a writer of tracts, also TRACTARIAN [n -S]\n",
  "TRACTATORS": "TRACTATOR, a writer of tracts, also TRACTARIAN [n]\n",
  "TRACTED": "TRACT, (Spenser) to trace, track [v]\n",
  "TRACTILE": "capable of being drawn out in length [adj]\n",
  "TRACTILITIES": "TRACTILITY, the state of being tractile [n]\n",
  "TRACTILITY": "the state of being tractile [n TRACTILITIES]\n",
  "TRACTING": "TRACT, (Spenser) to trace, track [v]\n",
  "TRACTION": "the act of drawing or pulling [n -S]\n",
  "TRACTIONAL": "relating to traction [adj]\n",
  "TRACTIONS": "TRACTION, the act of drawing or pulling [n]\n",
  "TRACTIVE": "relating to traction [adj]\n",
  "TRACTOR": "a motor vehicle used for farming [n -S]\n",
  "TRACTORATION": "(historical) the use of metal bars to give relief to diseased parts of the body [n -S]\n",
  "TRACTORATIONS": "TRACTORATION, (historical) the use of metal bars to give relief to diseased parts of the body [n]\n",
  "TRACTORFEED": "the automatic movement of a continuous roll of edge-perforated paper through the platen of the printer [n -S]\n",
  "TRACTORFEEDS": "TRACTORFEED, the automatic movement of a continuous roll of edge-perforated paper through the platen of the printer [n]\n",
  "TRACTORS": "TRACTOR, a motor vehicle used for farming [n]\n",
  "TRACTRICES": "TRACTRIX, a type of mathematical curve [n]\n",
  "TRACTRIX": "a type of mathematical curve [n TRACTRICES]\n",
  "TRACTS": "TRACT, (Spenser) to trace, track [v]\n",
  "TRACTUS": "(Latin) a psalm sung instead of the Alleluia in Lent [n -ES]\n",
  "TRACTUSES": "TRACTUS, (Latin) a psalm sung instead of the Alleluia in Lent [n]\n",
  "TRAD": "(short for) traditional (jazz) [n -S]\n",
  "TRADABLE": "able to be traded [adj]\n",
  "TRADE": "to have dealing with [v TRADED, TRADING, TRADES]\n",
  "TRADEABLE": "that can be traded, also TRADABLE [adj]\n",
  "TRADECRAFT": "skill or expertise in the practice of a trade [n -S]\n",
  "TRADECRAFTS": "TRADECRAFT, skill or expertise in the practice of a trade [n]\n",
  "TRADED": "TRADE, to have dealing with [v]\n",
  "TRADEFUL": "(Spenser) busy in traffic [adj]\n",
  "TRADELESS": "having no trade or traffic [adj]\n",
  "TRADEMARK": "any name or distinctive device warranting goods for sale as the production of any individual or firm [n -S] / to mark with a trademark [v -ED, -ING, -S]\n",
  "TRADEMARKED": "TRADEMARK, to mark with a trademark [v]\n",
  "TRADEMARKING": "TRADEMARK, to mark with a trademark [v]\n",
  "TRADEMARKS": "TRADEMARK, to mark with a trademark [v]\n",
  "TRADENAME": "a name serving as a trademark [n -S]\n",
  "TRADENAMES": "TRADENAME, a name serving as a trademark [n]\n",
  "TRADEOFF": "a giving up of one thing in return for another [n -S]\n",
  "TRADEOFFS": "TRADEOFF, a giving up of one thing in return for another [n]\n",
  "TRADER": "one who trades [n -S]\n",
  "TRADERS": "TRADER, one who trades [n]\n",
  "TRADERSHIP": "the occupation of trader [n -S]\n",
  "TRADERSHIPS": "TRADERSHIP, the occupation of trader [n]\n",
  "TRADES": "TRADE, to have dealing with [v]\n",
  "TRADESCANTIA": "any plant of the American Tradescantia genus, with attractive, often variegated foliage, aka spiderwort [n -S]\n",
  "TRADESCANTIAS": "TRADESCANTIA, any plant of the American Tradescantia genus, with attractive, often variegated foliage, aka spiderwort [n]\n",
  "TRADESFOLK": "people employed in trade [n -S]\n",
  "TRADESFOLKS": "TRADESFOLK, people employed in trade [n]\n",
  "TRADESMAN": "one who makes a living from trade [n TRADESMEN]\n",
  "TRADESMANLIKE": "like a tradesman [adj]\n",
  "TRADESMEN": "TRADESMAN, one who makes a living from trade [n]\n",
  "TRADESPEOPLE": "people engaged in trade [n -S]\n",
  "TRADESPEOPLES": "TRADESPEOPLE, people engaged in trade [n]\n",
  "TRADESPERSON": "a man or woman in trade [n TRADESPEOPLE or TRADESPERSONS]\n",
  "TRADESPERSONS": "TRADESPERSON, a man or woman in trade [n]\n",
  "TRADESWOMAN": "a woman employed in trade [n TRADESWOMEN]\n",
  "TRADESWOMEN": "TRADESWOMAN, a woman employed in trade [n]\n",
  "TRADIE": "(Australian slang) a tradesman or tradeswoman [n -S]\n",
  "TRADIES": "TRADIE, (Australian slang) a tradesman or tradeswoman [n]\n",
  "TRADING": "the act of trading [n -S]\n",
  "TRADINGS": "TRADING, the act of trading [n]\n",
  "TRADITION": "the passing from generation to generation of tales, beliefs, practices, etc. [n -S]\n",
  "TRADITIONAL": "relating to or derived from tradition [adj TRADITIONALLY]\n",
  "TRADITIONALISE": "to make traditionalise, also TRADITIONALIZE [v TRADITIONALISED, TRADITIONALISES]\n",
  "TRADITIONALISED": "TRADITIONALISE, to make traditionalise, also TRADITIONALIZE [v]\n",
  "TRADITIONALISES": "TRADITIONALISE, to make traditionalise, also TRADITIONALIZE [v]\n",
  "TRADITIONALISM": "adherence to the doctrines or practices of a tradition [n -S]\n",
  "TRADITIONALISMS": "TRADITIONALISM, adherence to the doctrines or practices of a tradition [n]\n",
  "TRADITIONALIST": "an upholder of traditionalism [n -S]\n",
  "TRADITIONALISTS": "TRADITIONALIST, an upholder of traditionalism [n]\n",
  "TRADITIONALITY": "the state of being traditional [n]\n",
  "TRADITIONALIZE": "to make traditional, also TRADITIONALISE [v TRADITIONALIZED, TRADITIONALIZES]\n",
  "TRADITIONALIZED": "TRADITIONALIZE, to make traditional, also TRADITIONALISE [v]\n",
  "TRADITIONALIZES": "TRADITIONALIZE, to make traditional, also TRADITIONALISE [v]\n",
  "TRADITIONALLY": "TRADITIONAL, relating to or derived from tradition [adv]\n",
  "TRADITIONARILY": "TRADITIONARY, traditional [adv]\n",
  "TRADITIONARY": "traditional [adj TRADITIONARILY]\n",
  "TRADITIONER": "a person who adheres to tradition, also TRADITIONIST [n -S]\n",
  "TRADITIONERS": "TRADITIONER, a person who adheres to tradition, also TRADITIONIST [n]\n",
  "TRADITIONIST": "a person who adheres to tradition, also TRADITIONER [n -S]\n",
  "TRADITIONISTS": "TRADITIONIST, a person who adheres to tradition, also TRADITIONER [n]\n",
  "TRADITIONLESS": "without tradition [adj]\n",
  "TRADITIONS": "TRADITION, the passing from generation to generation of tales, beliefs, practices, etc. [n]\n",
  "TRADITIVE": "traditional [adj]\n",
  "TRADITOR": "an early Christian who surrendered sacred books and vessels or betrayed fellow-Christians in times of persecution to save his or her own life [n TRADITORS or TRADITORES]\n",
  "TRADITORES": "TRADITOR, an early Christian who surrendered sacred books and vessels or betrayed fellow-Christians in times of persecution to save his or her own life [n]\n",
  "TRADITORS": "TRADITOR, an early Christian who surrendered sacred books and vessels or betrayed fellow-Christians in times of persecution to save his or her own life [n]\n",
  "TRADS": "TRAD, (short for) traditional (jazz) [n]\n",
  "TRADUCE": "to defame [v TRADUCED, TRADUCING, TRADUCES]\n",
  "TRADUCED": "TRADUCE, to defame [v]\n",
  "TRADUCEMENT": "slander [n -S]\n",
  "TRADUCEMENTS": "TRADUCEMENT, slander [n]\n",
  "TRADUCER": "one who traduces [n -S]\n",
  "TRADUCERS": "TRADUCER, one who traduces [n]\n",
  "TRADUCES": "TRADUCE, to defame [v]\n",
  "TRADUCIAN": "a believer in traducianism [n -S]\n",
  "TRADUCIANISM": "the theory that the soul is transmitted to a child in the act of generation or concomitantly with its body [n -S]\n",
  "TRADUCIANISMS": "TRADUCIANISM, the theory that the soul is transmitted to a child in the act of generation or concomitantly with its body [n]\n",
  "TRADUCIANIST": "a believer in traducianism [n -S]\n",
  "TRADUCIANISTIC": "relating to traducianism [adj]\n",
  "TRADUCIANISTS": "TRADUCIANIST, a believer in traducianism [n]\n",
  "TRADUCIANS": "TRADUCIAN, a believer in traducianism [n]\n",
  "TRADUCIBLE": "capable of being derived or propagated [adj]\n",
  "TRADUCING": "maligning [adj TRADUCINGLY] / the act of traducing [n -S]\n",
  "TRADUCINGLY": "TRADUCING, maligning [adv]\n",
  "TRADUCINGS": "TRADUCING, the act of traducing [n]\n",
  "TRADUCTION": "transmission from one to another [n -S]\n",
  "TRADUCTIONS": "TRADUCTION, transmission from one to another [n]\n",
  "TRADUCTIVE": "transmitted [adj]\n",
  "TRAFFIC": "to engage in buying or selling [v TRAFFICKED, TRAFFICKING, TRAFFICS]\n",
  "TRAFFICABILITY": "the quality of a terrain that permits passage (as of vehicles and troops) [n]\n",
  "TRAFFICABLE": "that can be trafficked [adj]\n",
  "TRAFFICATOR": "formerly, a movable pointer raised or lowered by the driver of a vehicle to warn of a change of direction [n -S]\n",
  "TRAFFICATORS": "TRAFFICATOR, formerly, a movable pointer raised or lowered by the driver of a vehicle to warn of a change of direction [n]\n",
  "TRAFFICKED": "TRAFFIC, to engage in buying or selling [v]\n",
  "TRAFFICKER": "one who traffics [n -S]\n",
  "TRAFFICKERS": "TRAFFICKER, one who traffics [n]\n",
  "TRAFFICKIER": "TRAFFICKY, busy with traffic [adj]\n",
  "TRAFFICKIEST": "TRAFFICKY, busy with traffic [adj]\n",
  "TRAFFICKING": "engaging in buying and selling [n -S]\n",
  "TRAFFICKINGS": "TRAFFICKING, engaging in buying and selling [n]\n",
  "TRAFFICKY": "busy with traffic [adj TRAFFICKIER, TRAFFICKIEST]\n",
  "TRAFFICLESS": "without traffic [adj]\n",
  "TRAFFICS": "TRAFFIC, to engage in buying or selling [v]\n",
  "TRAGACANTH": "a gum used in pharmacy and as a vehicle for dye in calico-printing [n -S]\n",
  "TRAGACANTHS": "TRAGACANTH, a gum used in pharmacy and as a vehicle for dye in calico-printing [n]\n",
  "TRAGAL": "relating to the tragus, the little flap of cartilage that projects over the hole in one's ear [adj]\n",
  "TRAGEDIAN": "a writer or actor of tragedy [n -S]\n",
  "TRAGEDIANS": "TRAGEDIAN, a writer or actor of tragedy [n]\n",
  "TRAGEDIENNE": "(French) a female tragic actor [n -S]\n",
  "TRAGEDIENNES": "TRAGEDIENNE, (French) a female tragic actor [n]\n",
  "TRAGEDIES": "TRAGEDY, a disastrous event [n]\n",
  "TRAGEDY": "a disastrous event [n TRAGEDIES]\n",
  "TRAGELAPH": "(Greek) a fabulous animal, part goat, part stag [n -S]\n",
  "TRAGELAPHINE": "relating to the tragelaph, a kind of African antelope [adj]\n",
  "TRAGELAPHS": "TRAGELAPH, (Greek) a fabulous animal, part goat, part stag [n]\n",
  "TRAGI": "TRAGUS, (Greek) a part of the external opening of the ear [n]\n",
  "TRAGIC": "very sad [adj TRAGICALLY] / the element of the drama that produces tragedy [n -S]\n",
  "TRAGICAL": "of the nature of a tragedy [adj TRAGICALLY]\n",
  "TRAGICALLY": "TRAGICAL, of the nature of a tragedy [adv]\n",
  "TRAGICALNESS": "the state of being tragical [n -ES]\n",
  "TRAGICALNESSES": "TRAGICALNESS, the state of being tragical [n]\n",
  "TRAGICOMEDIES": "TRAGICOMEDY, a drama or a situation blending tragic and comic elements [n]\n",
  "TRAGICOMEDY": "a drama or a situation blending tragic and comic elements [n TRAGICOMEDIES]\n",
  "TRAGICOMIC": "part tragic, part comic, also TRAGICOMICAL [adj TRAGICOMICALLY]\n",
  "TRAGICOMICAL": "part tragic, part comic, also TRAGICOMIC [adj TRAGICOMICALLY]\n",
  "TRAGICOMICALLY": "TRAGICOMICAL, part tragic, part comic, also TRAGICOMIC [adv]\n",
  "TRAGICS": "TRAGIC, the element of the drama that produces tragedy [n]\n",
  "TRAGOPAN": "(Greek) a kind of Asian pheasant [n -S]\n",
  "TRAGOPANS": "TRAGOPAN, (Greek) a kind of Asian pheasant [n]\n",
  "TRAGULE": "(Greek) a small deerlike mammal, aka chevrotain [n -S]\n",
  "TRAGULES": "TRAGULE, (Greek) a small deerlike mammal, aka chevrotain [n]\n",
  "TRAGULINE": "of or like a tragule, a small deerlike mammal [adj]\n",
  "TRAGUS": "(Greek) a part of the external opening of the ear [n TRAGI]\n",
  "TRAHISON": "(French) treachery; treason [n -S]\n",
  "TRAHISONS": "TRAHISON, (French) treachery; treason [n]\n",
  "TRAIK": "(Scots) to make one's way wearily; to get lost [v TRAIKED, TRAIKIT, TRAIKING, TRAIKS]\n",
  "TRAIKED": "TRAIK, (Scots) to make one's way wearily; to get lost [v]\n",
  "TRAIKING": "TRAIK, (Scots) to make one's way wearily; to get lost [v]\n",
  "TRAIKIT": "(Scots) worn out [adj]\n",
  "TRAIKS": "TRAIK, (Scots) to make one's way wearily; to get lost [v]\n",
  "TRAIL": "to draw along behind [v -ED, -ING, -S]\n",
  "TRAILABLE": "that can be trailed [adj]\n",
  "TRAILBASTON": "(historical) a ruffian or brigand in 14th century England [n -S]\n",
  "TRAILBASTONS": "TRAILBASTON, (historical) a ruffian or brigand in 14th century England [n]\n",
  "TRAILBLAZER": "one that blazes a trail to guide others [n -S]\n",
  "TRAILBLAZERS": "TRAILBLAZER, one that blazes a trail to guide others [n]\n",
  "TRAILBLAZING": "making or pointing a new way [n -S]\n",
  "TRAILBLAZINGS": "TRAILBLAZING, making or pointing a new way [n]\n",
  "TRAILBREAKER": "a trailblazer [n -S]\n",
  "TRAILBREAKERS": "TRAILBREAKER, a trailblazer [n]\n",
  "TRAILED": "TRAIL, to draw along behind [v]\n",
  "TRAILER": "to transport by a vehicle drawn by another [v -ED, -ING, -S]\n",
  "TRAILERABLE": "that can be trailered [adj]\n",
  "TRAILERED": "TRAILER, to transport by a vehicle drawn by another [v]\n",
  "TRAILERING": "the act of transporting by trailer [n -S]\n",
  "TRAILERINGS": "TRAILERING, the act of transporting by trailer [n]\n",
  "TRAILERIST": "a person travelling or vacationing with a trailer [n -S]\n",
  "TRAILERISTS": "TRAILERIST, a person travelling or vacationing with a trailer [n]\n",
  "TRAILERITE": "a person living in a mobile home [n -S]\n",
  "TRAILERITES": "TRAILERITE, a person living in a mobile home [n]\n",
  "TRAILERS": "TRAILER, to transport by a vehicle drawn by another [v]\n",
  "TRAILHEAD": "the terminus of a cattle trail [n -S]\n",
  "TRAILHEADS": "TRAILHEAD, the terminus of a cattle trail [n]\n",
  "TRAILING": "TRAIL, to draw along behind [v]\n",
  "TRAILINGLY": "TRAILING, TRAIL, to draw along behind [adv]\n",
  "TRAILLESS": "without a trail [adj]\n",
  "TRAILS": "TRAIL, to draw along behind [v]\n",
  "TRAILSIDE": "relating to or situated at the side of a trail [adj]\n",
  "TRAIN": "to instruct systematically, also TRAYNE [v -ED, -ING, -S]\n",
  "TRAINABILITIES": "TRAINABILITY, the state of being trainable [n]\n",
  "TRAINABILITY": "the state of being trainable [n TRAINABILITIES]\n",
  "TRAINABLE": "capable of being trained or educated; as, boys trainable to virtue [adj]\n",
  "TRAINBAND": "(historical) a band of citizens from the 16th to the 18th century trained to bear arms [n -S]\n",
  "TRAINBANDS": "TRAINBAND, (historical) a band of citizens from the 16th to the 18th century trained to bear arms [n]\n",
  "TRAINBEARER": "an attendant who holds up the train of a robe or gown [n -S]\n",
  "TRAINBEARERS": "TRAINBEARER, an attendant who holds up the train of a robe or gown [n]\n",
  "TRAINED": "TRAIN, to instruct systematically, also TRAYNE [v]\n",
  "TRAINEE": "one who receives training [n -S]\n",
  "TRAINEES": "TRAINEE, one who receives training [n]\n",
  "TRAINEESHIP": "the state of being a trainee [n -S]\n",
  "TRAINEESHIPS": "TRAINEESHIP, the state of being a trainee [n]\n",
  "TRAINER": "a soft running shoe, usually laced, with a thick sole, used in training or for general casual wear [n -S]\n",
  "TRAINERS": "TRAINER, a soft running shoe, usually laced, with a thick sole, used in training or for general casual wear [n]\n",
  "TRAINFUL": "as much as a railway train can hold [n -S]\n",
  "TRAINFULS": "TRAINFUL, as much as a railway train can hold [n]\n",
  "TRAINING": "systematic instruction [n -S]\n",
  "TRAININGS": "TRAINING, systematic instruction [n]\n",
  "TRAINLESS": "without a train [adj]\n",
  "TRAINLOAD": "what a train can carry [n -S]\n",
  "TRAINLOADS": "TRAINLOAD, what a train can carry [n]\n",
  "TRAINMAN": "a railroad employee [n TRAINMEN]\n",
  "TRAINMEN": "TRAINMAN, a railroad employee [n]\n",
  "TRAINS": "TRAIN, to instruct systematically, also TRAYNE [v]\n",
  "TRAINSPOTTER": "a train-watching enthusiast [n -S]\n",
  "TRAINSPOTTERISH": "obsessed with trivial details, esp. of a subject generally considered uninteresting [adj]\n",
  "TRAINSPOTTERS": "TRAINSPOTTER, a train-watching enthusiast [n]\n",
  "TRAINWAY": "a railway [n -S]\n",
  "TRAINWAYS": "TRAINWAY, a railway [n]\n",
  "TRAIPSE": "to walk wearily, also TRAPE, TRAPES, TRAPSE [v TRAIPSED, TRAIPSING, TRAIPSES]\n",
  "TRAIPSED": "TRAIPSE, to walk wearily, also TRAPE, TRAPES, TRAPSE [v]\n",
  "TRAIPSES": "TRAIPSE, to walk wearily, also TRAPE, TRAPES, TRAPSE [v]\n",
  "TRAIPSING": "the act of traipsing [n -S]\n",
  "TRAIPSINGS": "TRAIPSING, the act of traipsing [n]\n",
  "TRAIT": "(French) a characteristic or distinguishing feature [n -S]\n",
  "TRAITOR": "one who betrays another [n -S]\n",
  "TRAITORESS": "a female traitor, also TRAITRESS [n -ES]\n",
  "TRAITORESSES": "TRAITORESS, a female traitor, also TRAITRESS [n]\n",
  "TRAITORHOOD": "the state of being a traitor [n -S]\n",
  "TRAITORHOODS": "TRAITORHOOD, the state of being a traitor [n]\n",
  "TRAITORISM": "being a traitor [n -S]\n",
  "TRAITORISMS": "TRAITORISM, being a traitor [n]\n",
  "TRAITORLY": "(Shakespeare) traitorous [adj]\n",
  "TRAITOROUS": "guilty or capable of treason [adj TRAITOROUSLY]\n",
  "TRAITOROUSLY": "TRAITOROUS, guilty or capable of treason [adv]\n",
  "TRAITOROUSNESS": "the state of being traitorous [n]\n",
  "TRAITORS": "TRAITOR, one who betrays another [n]\n",
  "TRAITORSHIP": "the state of being a traitor [n -S]\n",
  "TRAITORSHIPS": "TRAITORSHIP, the state of being a traitor [n]\n",
  "TRAITRESS": "a female traitor, also TRAITORESS [n -ES]\n",
  "TRAITRESSES": "TRAITRESS, a female traitor, also TRAITORESS [n]\n",
  "TRAITS": "TRAIT, (French) a characteristic or distinguishing feature [n]\n",
  "TRAJECT": "to transmit [v -ED, -ING, -S]\n",
  "TRAJECTED": "TRAJECT, to transmit [v]\n",
  "TRAJECTILE": "relating to trajectory [adj]\n",
  "TRAJECTING": "TRAJECT, to transmit [v]\n",
  "TRAJECTION": "the act of trajecting [n -S]\n",
  "TRAJECTIONS": "TRAJECTION, the act of trajecting [n]\n",
  "TRAJECTORIES": "TRAJECTORY, the curve that a body (as a planet or comet in its orbit or a rocket) describes in space [n]\n",
  "TRAJECTORY": "the curve that a body (as a planet or comet in its orbit or a rocket) describes in space [n TRAJECTORIES]\n",
  "TRAJECTS": "TRAJECT, to transmit [v]\n",
  "TRALATICIOUS": "traditional, handed down from generation to generation, also TRALATITIOUS [adj]\n",
  "TRALATITIOUS": "traditional, handed down from generation to generation, also TRALATICIOUS [adj]\n",
  "TRAM": "to travel by tramcar [v TRAMMED, TRAMMING, TRAMS]\n",
  "TRAMCAR": "a streetcar [n -S]\n",
  "TRAMCARS": "TRAMCAR, a streetcar [n]\n",
  "TRAMEL": "(US) to hinder, also TRAMELL, TRAMMEL [v TRAMELED or TRAMELLED, TRAMELING or TRAMELLING, TRAMELS]\n",
  "TRAMELED": "TRAMEL, (US) to hinder, also TRAMELL, TRAMMEL [v]\n",
  "TRAMELING": "TRAMEL, (US) to hinder, also TRAMELL, TRAMMEL [v]\n",
  "TRAMELL": "to hinder, also TRAMEL, TRAMMEL [v -ED, -ING, -S]\n",
  "TRAMELLED": "TRAMELL, to hinder, also TRAMEL, TRAMMEL [v]\n",
  "TRAMELLING": "TRAMELL, to hinder, also TRAMEL, TRAMMEL [v]\n",
  "TRAMELLS": "TRAMELL, to hinder, also TRAMEL, TRAMMEL [v]\n",
  "TRAMELS": "TRAMEL, (US) to hinder, also TRAMELL, TRAMMEL [v]\n",
  "TRAMLESS": "without a tramcar [adj]\n",
  "TRAMLINE": "a line for a tram [n -S]\n",
  "TRAMLINED": "running, or as if running, in tramlines, rigid, inflexible [adj]\n",
  "TRAMLINES": "TRAMLINE, a line for a tram [n]\n",
  "TRAMMED": "TRAM, to travel by tramcar [v]\n",
  "TRAMMEL": "to hinder, also TRAMEL, TRAMELL [v TRAMMELLED, TRAMMELLING, TRAMMELS]\n",
  "TRAMMELED": "TRAMMEL, to hinder, also TRAMEL, TRAMELL [v]\n",
  "TRAMMELER": "one who trammels [n -S]\n",
  "TRAMMELERS": "TRAMMELER, one who trammels [n]\n",
  "TRAMMELING": "TRAMMEL, to hinder, also TRAMEL, TRAMELL [v]\n",
  "TRAMMELLED": "TRAMMEL, to hinder, also TRAMEL, TRAMELL [v]\n",
  "TRAMMELLER": "one who trammels [n -S]\n",
  "TRAMMELLERS": "TRAMMELLER, one who trammels [n]\n",
  "TRAMMELLING": "TRAMMEL, to hinder, also TRAMEL, TRAMELL [v]\n",
  "TRAMMELS": "TRAMMEL, to hinder, also TRAMEL, TRAMELL [v]\n",
  "TRAMMIE": "(Australian) a tram driver [n -S]\n",
  "TRAMMIES": "TRAMMIE, (Australian) a tram driver [n]\n",
  "TRAMMING": "TRAM, to travel by tramcar [v]\n",
  "TRAMONTANA": "(Italian) a cold north wind in Italy, also TRAMONTANE, TRANSMONTANE [n -S]\n",
  "TRAMONTANAS": "TRAMONTANA, (Italian) a cold north wind in Italy, also TRAMONTANE, TRANSMONTANE [n]\n",
  "TRAMONTANE": "(Italian) a cold north wind in Italy, also TRAMONTANA, TRANSMONTANE [n -S]\n",
  "TRAMONTANES": "TRAMONTANE, (Italian) a cold north wind in Italy, also TRAMONTANA, TRANSMONTANE [n]\n",
  "TRAMP": "to tread heavily [v -ED, -ING, -S]\n",
  "TRAMPED": "TRAMP, to tread heavily [v]\n",
  "TRAMPER": "one who tramps, a vagrant [n -S]\n",
  "TRAMPERS": "TRAMPER, one who tramps, a vagrant [n]\n",
  "TRAMPET": "a small trampoline, also TRAMPETTE [n -S]\n",
  "TRAMPETS": "TRAMPET, a small trampoline, also TRAMPETTE [n]\n",
  "TRAMPETTE": "a small trampoline, also TRAMPET [n -S]\n",
  "TRAMPETTES": "TRAMPETTE, a small trampoline, also TRAMPET [n]\n",
  "TRAMPIER": "TRAMPY, having the characteristics of a vagrant [adj]\n",
  "TRAMPIEST": "TRAMPY, having the characteristics of a vagrant [adj]\n",
  "TRAMPING": "the act of tramping [n -S]\n",
  "TRAMPINGS": "TRAMPING, the act of tramping [n]\n",
  "TRAMPISH": "like a tramp or vagabond [adj]\n",
  "TRAMPLE": "to tread roughly over [v TRAMPLED, TRAMPLING, TRAMPLES]\n",
  "TRAMPLED": "TRAMPLE, to tread roughly over [v]\n",
  "TRAMPLER": "one who tramples [n -S]\n",
  "TRAMPLERS": "TRAMPLER, one who tramples [n]\n",
  "TRAMPLES": "TRAMPLE, to tread roughly over [v]\n",
  "TRAMPLING": "the act of trampling [n -S]\n",
  "TRAMPLINGS": "TRAMPLING, the act of trampling [n]\n",
  "TRAMPOLIN": "a springy mat for bouncing on, also TRAMPOLINE [n -S]\n",
  "TRAMPOLINE": "(tradename) a springy mat for bouncing on, also TRAMPOLIN [n -S] / to use a trampoline [v TRAMPOLINED, TRAMPOLINING, TRAMPOLINES]\n",
  "TRAMPOLINED": "TRAMPOLINE, to use a trampoline [v]\n",
  "TRAMPOLINER": "one who uses a trampoline, also TRAMPOLINIST [n -S]\n",
  "TRAMPOLINERS": "TRAMPOLINER, one who uses a trampoline, also TRAMPOLINIST [n]\n",
  "TRAMPOLINES": "TRAMPOLINE, to use a trampoline [v]\n",
  "TRAMPOLINING": "the sport of using a trampoline [n -S]\n",
  "TRAMPOLININGS": "TRAMPOLINING, the sport of using a trampoline [n]\n",
  "TRAMPOLINIST": "one who uses a trampoline, also TRAMPOLINER [n -S]\n",
  "TRAMPOLINISTS": "TRAMPOLINIST, one who uses a trampoline, also TRAMPOLINER [n]\n",
  "TRAMPOLINS": "TRAMPOLIN, a springy mat for bouncing on, also TRAMPOLINE [n]\n",
  "TRAMPS": "TRAMP, to tread heavily [v]\n",
  "TRAMPY": "having the characteristics of a vagrant [adj TRAMPIER, TRAMPIEST]\n",
  "TRAMROAD": "a track with sunken wooden, stone or metal rails [n -S]\n",
  "TRAMROADS": "TRAMROAD, a track with sunken wooden, stone or metal rails [n]\n",
  "TRAMS": "TRAM, to travel by tramcar [v]\n",
  "TRAMWAY": "a route for a tram [n -S]\n",
  "TRAMWAYS": "TRAMWAY, a route for a tram [n]\n",
  "TRANCE": "to put into a semiconscious state [v TRANCED, TRANCING, TRANCES]\n",
  "TRANCED": "TRANCE, to put into a semiconscious state [v]\n",
  "TRANCEDLY": "TRANCED, TRANCE, to put into a semiconscious state [adv]\n",
  "TRANCELIKE": "lIke a trance [adj]\n",
  "TRANCES": "TRANCE, to put into a semiconscious state [v]\n",
  "TRANCEY": "(of music, etc.) creating a hypnotic effect [adj TRANCIER, TRANCIEST]\n",
  "TRANCHE": "(French) a slice or block of money or shares [n -S]\n",
  "TRANCHES": "TRANCHE, (French) a slice or block of money or shares [n]\n",
  "TRANCHET": "(French) a chisel-shaped flint implement of some Mesolithic and neolithic cultures [n -S]\n",
  "TRANCHETS": "TRANCHET, (French) a chisel-shaped flint implement of some Mesolithic and neolithic cultures [n]\n",
  "TRANCIER": "TRANCEY, (of music, etc.) creating a hypnotic effect [adj]\n",
  "TRANCIEST": "TRANCEY, (of music, etc.) creating a hypnotic effect [adj]\n",
  "TRANCING": "TRANCE, to put into a semiconscious state [v]\n",
  "TRANECT": "(Shakespeare) a ferry [n -S]\n",
  "TRANECTS": "TRANECT, (Shakespeare) a ferry [n]\n",
  "TRANGAM": "a showy or worthless article [n -S]\n",
  "TRANGAMS": "TRANGAM, a showy or worthless article [n]\n",
  "TRANGLE": "in heraldry, a diminutive of the fesse [n -S]\n",
  "TRANGLES": "TRANGLE, in heraldry, a diminutive of the fesse [n]\n",
  "TRANK": "(short for) to tranquillize [v -ED, -ING, -S]\n",
  "TRANKED": "TRANK, (short for) to tranquillize [v]\n",
  "TRANKING": "TRANK, (short for) to tranquillize [v]\n",
  "TRANKS": "TRANK, (short for) to tranquillize [v]\n",
  "TRANKUM": "(Scott) a trinket, also TRINKUM [n -S]\n",
  "TRANKUMS": "TRANKUM, (Scott) a trinket, also TRINKUM [n]\n",
  "TRANNIE": "(colloquial) transistor, also TRANNY [n -S]\n",
  "TRANNIES": "TRANNY, (colloquial) a transistor, also TRANNIE [n]\n",
  "TRANNY": "(colloquial) a transistor, also TRANNIE [n TRANNIES]\n",
  "TRANQ": "(short for) tranquilliser, also TRANK [n -S]\n",
  "TRANQS": "TRANQ, (short for) tranquilliser, also TRANK [n]\n",
  "TRANQUIL": "calm, peaceful [adj TRANQUILER or TRANQUILLER, TRANQUILEST or TRANQUILLEST, TRANQUILLY]\n",
  "TRANQUILER": "TRANQUIL, calm, peaceful [adj]\n",
  "TRANQUILEST": "TRANQUIL, calm, peaceful [adj]\n",
  "TRANQUILISATION": "the process of tranquilising, also TRANQUILIZATION [n]\n",
  "TRANQUILISE": "to make tranquil, also TRANQUILIZE, TRANQUILLISE, TRANQUILLIZE [v TRANQUILISED, TRANQUILISING, TRANQUILISES]\n",
  "TRANQUILISED": "TRANQUILISE, to make tranquil, also TRANQUILIZE, TRANQUILLISE, TRANQUILLIZE [v]\n",
  "TRANQUILISER": "a drug that has a tranquillising effect, also TRANQUILIZER, TRANQUILLISER, TRANQUILLIZER [n -S]\n",
  "TRANQUILISERS": "TRANQUILISER, a drug that has a tranquillising effect, also TRANQUILIZER, TRANQUILLISER, TRANQUILLIZER [n]\n",
  "TRANQUILISES": "TRANQUILISE, to make tranquil, also TRANQUILIZE, TRANQUILLISE, TRANQUILLIZE [v]\n",
  "TRANQUILISING": "TRANQUILISE, to make tranquil, also TRANQUILIZE, TRANQUILLISE, TRANQUILLIZE [v]\n",
  "TRANQUILISINGLY": "TRANQUILISING, TRANQUILISE, to make tranquil, also TRANQUILIZE, TRANQUILLISE, TRANQUILLIZE [adv]\n",
  "TRANQUILITIES": "TRANQUILITY, the state of being tranquil, also TRANQUILLITY [n]\n",
  "TRANQUILITY": "the state of being tranquil, also TRANQUILLITY [n TRANQUILITIES]\n",
  "TRANQUILIZATION": "the process of tranquilizing, also TRANQUILISATION [n]\n",
  "TRANQUILIZE": "to make tranquil or calm, also TRANQUILISE, TRANQUILLISE, TRANQUILLIZE [v TRANQUILIZED, TRANQUILIZING, TRANQUILIZES]\n",
  "TRANQUILIZED": "TRANQUILIZE, to make tranquil or calm, also TRANQUILISE, TRANQUILLISE, TRANQUILLIZE [v]\n",
  "TRANQUILIZER": "a drug that has a tranquillising effect, also TRANQUILISER, TRANQUILLISER, TRANQUILLIZER [n -S]\n",
  "TRANQUILIZERS": "TRANQUILIZER, a drug that has a tranquillising effect, also TRANQUILISER, TRANQUILLISER, TRANQUILLIZER [n]\n",
  "TRANQUILIZES": "TRANQUILIZE, to make tranquil or calm, also TRANQUILISE, TRANQUILLISE, TRANQUILLIZE [v]\n",
  "TRANQUILIZING": "TRANQUILIZE, to make tranquil or calm, also TRANQUILISE, TRANQUILLISE, TRANQUILLIZE [v]\n",
  "TRANQUILIZINGLY": "TRANQUILIZING, TRANQUILIZE, to make tranquil or calm, also TRANQUILISE, TRANQUILLISE, TRANQUILLIZE [adv]\n",
  "TRANQUILLER": "TRANQUIL, calm, peaceful [adj]\n",
  "TRANQUILLEST": "TRANQUIL, calm, peaceful [adj]\n",
  "TRANQUILLISE": "to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLIZE [v TRANQUILLISED, TRANQUILLISING, TRANQUILLISES]\n",
  "TRANQUILLISED": "TRANQUILLISE, to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLIZE [v]\n",
  "TRANQUILLISER": "a drug that has a tranquillising effect, also TRANQUILISER, TRANQUILIZER, TRANQUILLIZER [n -S]\n",
  "TRANQUILLISERS": "TRANQUILLISER, a drug that has a tranquillising effect, also TRANQUILISER, TRANQUILIZER, TRANQUILLIZER [n]\n",
  "TRANQUILLISES": "TRANQUILLISE, to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLIZE [v]\n",
  "TRANQUILLISING": "TRANQUILLISE, to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLIZE [v]\n",
  "TRANQUILLITIES": "TRANQUILLITY, the state of being tranquil, also TRANQUILITY [n]\n",
  "TRANQUILLITY": "the state of being tranquil, also TRANQUILITY [n TRANQUILLITIES]\n",
  "TRANQUILLIZE": "to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLISE [v TRANQUILLIZED, TRANQUILLIZING, TRANQUILLIZES]\n",
  "TRANQUILLIZED": "TRANQUILLIZE, to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLISE [v]\n",
  "TRANQUILLIZER": "a drug that has a tranquillising effect, also TRANQUILISER, TRANQUILIZER, TRANQUILLISER [n -S]\n",
  "TRANQUILLIZERS": "TRANQUILLIZER, a drug that has a tranquillising effect, also TRANQUILISER, TRANQUILIZER, TRANQUILLISER [n]\n",
  "TRANQUILLIZES": "TRANQUILLIZE, to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLISE [v]\n",
  "TRANQUILLIZING": "TRANQUILLIZE, to make tranquil, also TRANQUILISE, TRANQUILIZE, TRANQUILLISE [v]\n",
  "TRANQUILLY": "TRANQUIL, calm, peaceful [adv]\n",
  "TRANQUILNESS": "the state of being tranquil [n -ES]\n",
  "TRANQUILNESSES": "TRANQUILNESS, the state of being tranquil [n]\n",
  "TRANS": "of an isomer, having two identical groups of atoms on opposite sides of a bond [adj]\n",
  "TRANSACT": "to carry out [v -ED, -ING, -S]\n",
  "TRANSACTED": "TRANSACT, to carry out [v]\n",
  "TRANSACTING": "TRANSACT, to carry out [v]\n",
  "TRANSACTINIDE": "an element with atomic weight higher than those of the actinide series [n -S]\n",
  "TRANSACTINIDES": "TRANSACTINIDE, an element with atomic weight higher than those of the actinide series [n]\n",
  "TRANSACTION": "something transacted [n -S]\n",
  "TRANSACTIONAL": "of the nature of a transaction [adj TRANSACTIONALLY]\n",
  "TRANSACTIONALLY": "TRANSACTIONAL, of the nature of a transaction [adv]\n",
  "TRANSACTIONS": "TRANSACTION, something transacted [n]\n",
  "TRANSACTOR": "one who transacts [n -S]\n",
  "TRANSACTORS": "TRANSACTOR, one who transacts [n]\n",
  "TRANSACTS": "TRANSACT, to carry out [v]\n",
  "TRANSALPINE": "an inhabitant of the region beyond the Alps [n -S]\n",
  "TRANSALPINES": "TRANSALPINE, an inhabitant of the region beyond the Alps [n]\n",
  "TRANSAMINASE": "an enzyme promoting transamination [n -S]\n",
  "TRANSAMINASES": "TRANSAMINASE, an enzyme promoting transamination [n]\n",
  "TRANSAMINATION": "the conversion of a keto acid to an amino acid [n -S]\n",
  "TRANSAMINATIONS": "TRANSAMINATION, the conversion of a keto acid to an amino acid [n]\n",
  "TRANSANDEAN": "beyond, or crossing, the Andes, also TRANSANDINE [adj]\n",
  "TRANSANDINE": "beyond, or crossing, the Andes, also TRANSANDEAN [adj]\n",
  "TRANSATLANTIC": "crossing or extending across the Atlantic Ocean [adj]\n",
  "TRANSAXLE": "a driving axle and differential gearbox forming an integral unit [n -S]\n",
  "TRANSAXLES": "TRANSAXLE, a driving axle and differential gearbox forming an integral unit [n]\n",
  "TRANSCALENCIES": "TRANSCALENCY, perviousness to heat [n]\n",
  "TRANSCALENCY": "perviousness to heat [n TRANSCALENCIES]\n",
  "TRANSCALENT": "pervious to or allowing the passage of heat [adj]\n",
  "TRANSCAUCASIAN": "of the region beyond the Caucasus mountains in Georgia [adj]\n",
  "TRANSCEIVER": "a radio transmitterreceiver that uses many of the same components for both transmission and reception [n -S]\n",
  "TRANSCEIVERS": "TRANSCEIVER, a radio transmitterreceiver that uses many of the same components for both transmission and reception [n]\n",
  "TRANSCEND": "to surpass; to exceed [v -ED, -ING, -S]\n",
  "TRANSCENDED": "TRANSCEND, to surpass; to exceed [v]\n",
  "TRANSCENDENCE": "the state of being transcendent, also TRANSCENDENCY [n -S]\n",
  "TRANSCENDENCES": "TRANSCENDENCE, the state of being transcendent, also TRANSCENDENCY [n]\n",
  "TRANSCENDENCIES": "TRANSCENDENCY, transcendence, also TRANSCENDENCE [n]\n",
  "TRANSCENDENCY": "transcendence, also TRANSCENDENCE [n TRANSCENDENCIES]\n",
  "TRANSCENDENT": "exceeding usual limits [adj TRANSCENDENTLY] / a transcendent thing [n -S]\n",
  "TRANSCENDENTAL": "transcending [adj] / a transcendental number [n -S]\n",
  "TRANSCENDENTALS": "TRANSCENDENTAL, a transcendental number [n]\n",
  "TRANSCENDENTLY": "TRANSCENDENT, exceeding usual limits [adv]\n",
  "TRANSCENDENTS": "TRANSCENDENT, a transcendent thing [n]\n",
  "TRANSCENDING": "TRANSCEND, to surpass; to exceed [v]\n",
  "TRANSCENDINGLY": "TRANSCENDING, TRANSCEND, to surpass; to exceed [adv]\n",
  "TRANSCENDS": "TRANSCEND, to surpass; to exceed [v]\n",
  "TRANSCODE": "to convert data from one digital format to another [v TRANSCODED, TRANSCODING, TRANSCODES]\n",
  "TRANSCODED": "TRANSCODE, to convert data from one digital format to another [v]\n",
  "TRANSCODER": "a technology, such as a software package, used to transfer data from one format to another [n -S]\n",
  "TRANSCODERS": "TRANSCODER, a technology, such as a software package, used to transfer data from one format to another [n]\n",
  "TRANSCODES": "TRANSCODE, to convert data from one digital format to another [v]\n",
  "TRANSCODING": "TRANSCODE, to convert data from one digital format to another [v]\n",
  "TRANSCRANIAL": "across the cranium [adj]\n",
  "TRANSCRIBABLE": "that can be transcribed [adj]\n",
  "TRANSCRIBE": "to make a written copy of [v TRANSCRIBED, TRANSCRIBING, TRANSCRIBES]\n",
  "TRANSCRIBED": "TRANSCRIBE, to make a written copy of [v]\n",
  "TRANSCRIBER": "one who transcribes [n -S]\n",
  "TRANSCRIBERS": "TRANSCRIBER, one who transcribes [n]\n",
  "TRANSCRIBES": "TRANSCRIBE, to make a written copy of [v]\n",
  "TRANSCRIBING": "TRANSCRIBE, to make a written copy of [v]\n",
  "TRANSCRIPT": "a written, printed, or typed copy [n -S]\n",
  "TRANSCRIPTASE": "the enzyme that brings about transcription [n -S]\n",
  "TRANSCRIPTASES": "TRANSCRIPTASE, the enzyme that brings about transcription [n]\n",
  "TRANSCRIPTION": "the act of transcribing [n -S]\n",
  "TRANSCRIPTIONAL": "relating to transcription [adj]\n",
  "TRANSCRIPTIONS": "TRANSCRIPTION, the act of transcribing [n]\n",
  "TRANSCRIPTIVE": "relating to transcription [adj TRANSCRIPTIVELY]\n",
  "TRANSCRIPTIVELY": "TRANSCRIPTIVE, relating to transcription [adv]\n",
  "TRANSCRIPTOME": "a collection of all the messenger RNA in a particular cell [n -S]\n",
  "TRANSCRIPTOMES": "TRANSCRIPTOME, a collection of all the messenger RNA in a particular cell [n]\n",
  "TRANSCRIPTS": "TRANSCRIPT, a written, printed, or typed copy [n]\n",
  "TRANSCULTURAL": "involving, encompassing, or extending across two or more cultures [adj]\n",
  "TRANSCURRENT": "running across, transverse [adj]\n",
  "TRANSCUTANEOUS": "passing, entering, or made by penetration through the skin [adj]\n",
  "TRANSDERMAL": "relating to, being, or supplying a medication in a form for absorption through the skin into the bloodstream [adj]\n",
  "TRANSDUCE": "to convert (energy, a message) into another form [v TRANSDUCED, TRANSDUCING, TRANSDUCES]\n",
  "TRANSDUCED": "TRANSDUCE, to convert (energy, a message) into another form [v]\n",
  "TRANSDUCER": "an electronic device transmitting received energy in a different form [n -S]\n",
  "TRANSDUCERS": "TRANSDUCER, an electronic device transmitting received energy in a different form [n]\n",
  "TRANSDUCES": "TRANSDUCE, to convert (energy, a message) into another form [v]\n",
  "TRANSDUCING": "TRANSDUCE, to convert (energy, a message) into another form [v]\n",
  "TRANSDUCTANT": "an agent that effects transduction [n -S]\n",
  "TRANSDUCTANTS": "TRANSDUCTANT, an agent that effects transduction [n]\n",
  "TRANSDUCTION": "the transfer of genetic material from one bacterial cell to another by a bacteriophage [n -S]\n",
  "TRANSDUCTIONAL": "relating to transduction [adj]\n",
  "TRANSDUCTIONS": "TRANSDUCTION, the transfer of genetic material from one bacterial cell to another by a bacteriophage [n]\n",
  "TRANSDUCTOR": "an arrangement of windings on a laminated core or cores, part of a device for amplifying current [n -S]\n",
  "TRANSDUCTORS": "TRANSDUCTOR, an arrangement of windings on a laminated core or cores, part of a device for amplifying current [n]\n",
  "TRANSE": "a through passage [n -S]\n",
  "TRANSECT": "to cut across [v -ED, -ING, -S]\n",
  "TRANSECTED": "TRANSECT, to cut across [v]\n",
  "TRANSECTING": "TRANSECT, to cut across [v]\n",
  "TRANSECTION": "a cutting across [n -S]\n",
  "TRANSECTIONS": "TRANSECTION, a cutting across [n]\n",
  "TRANSECTS": "TRANSECT, to cut across [v]\n",
  "TRANSENNA": "(Latin) a screen enclosing a shrine [n -S]\n",
  "TRANSENNAS": "TRANSENNA, (Latin) a screen enclosing a shrine [n]\n",
  "TRANSEPT": "the part of a church at right angles to the nave [n -S]\n",
  "TRANSEPTAL": "of or like a transept, the part of a church off to one side of main structure [adj]\n",
  "TRANSEPTATE": "divided by transverse septa [adj]\n",
  "TRANSEPTED": "having a transept [adj]\n",
  "TRANSEPTS": "TRANSEPT, the part of a church at right angles to the nave [n]\n",
  "TRANSES": "TRANSE, a through passage [n]\n",
  "TRANSEUNT": "(Latin) (of a mental process) producing an effect outside the mind [adj]\n",
  "TRANSEXUAL": "a person anatomically of one sex but having a strong desire to adopt the physical characteristics and role of a member of the opposite sex, also TRANSSEXUAL [n -S]\n",
  "TRANSEXUALISM": "a strong desire to change sex [n -S]\n",
  "TRANSEXUALISMS": "TRANSEXUALISM, a strong desire to change sex [n]\n",
  "TRANSEXUALITIES": "TRANSEXUALITY, the state of being transsexual, also TRANSSEXUALITY [n]\n",
  "TRANSEXUALITY": "the state of being transsexual, also TRANSSEXUALITY [n TRANSEXUALITIES]\n",
  "TRANSEXUALS": "TRANSEXUAL, a person anatomically of one sex but having a strong desire to adopt the physical characteristics and role of a member of the opposite sex, also TRANSSEXUAL [n]\n",
  "TRANSFARD": "(Spenser) transferred [v]\n",
  "TRANSFECT": "to cause transfection in, the infection of a cell with pure viral nucleic acid [v -ED, -ING, -S]\n",
  "TRANSFECTED": "TRANSFECT, to cause transfection in, the infection of a cell with pure viral nucleic acid [v]\n",
  "TRANSFECTING": "TRANSFECT, to cause transfection in, the infection of a cell with pure viral nucleic acid [v]\n",
  "TRANSFECTION": "the infection of a cell with pure viral nucleic acid [n -S]\n",
  "TRANSFECTIONS": "TRANSFECTION, the infection of a cell with pure viral nucleic acid [n]\n",
  "TRANSFECTS": "TRANSFECT, to cause transfection in, the infection of a cell with pure viral nucleic acid [v]\n",
  "TRANSFER": "to move from one place to another [v TRANSFERRED, TRANSFERRING, TRANSFERS]\n",
  "TRANSFERABILITY": "the state of being transferable [n]\n",
  "TRANSFERABLE": "that can be transferred, also TRANSFERRABLE, TRANSFERRIBLE [adj]\n",
  "TRANSFERAL": "the act of transfer, also TRANSFERRAL [n -S]\n",
  "TRANSFERALS": "TRANSFERAL, the act of transfer, also TRANSFERRAL [n]\n",
  "TRANSFERASE": "an enzyme that promotes transfer of a group from one molecule to another [n -S]\n",
  "TRANSFERASES": "TRANSFERASE, an enzyme that promotes transfer of a group from one molecule to another [n]\n",
  "TRANSFEREE": "the person to whom a transfer in made [n -S]\n",
  "TRANSFEREES": "TRANSFEREE, the person to whom a transfer in made [n]\n",
  "TRANSFERENCE": "an act, process, or instance of transferring [n -S]\n",
  "TRANSFERENCES": "TRANSFERENCE, an act, process, or instance of transferring [n]\n",
  "TRANSFERENTIAL": "relating to transference [adj]\n",
  "TRANSFEROR": "one who transfers [n -S]\n",
  "TRANSFERORS": "TRANSFEROR, one who transfers [n]\n",
  "TRANSFERRABLE": "that can be transferred, also TRANSFERABLE, TRANSFERRIBLE [adj]\n",
  "TRANSFERRAL": "the act of transfer, also TRANSFERAL [n -S]\n",
  "TRANSFERRALS": "TRANSFERRAL, the act of transfer, also TRANSFERAL [n]\n",
  "TRANSFERRED": "TRANSFER, to move from one place to another [v]\n",
  "TRANSFERRER": "one who transfers [n -S]\n",
  "TRANSFERRERS": "TRANSFERRER, one who transfers [n]\n",
  "TRANSFERRIBLE": "that can be transferred, also TRANSFERABLE, TRANSFERRABLE [adj]\n",
  "TRANSFERRIN": "a beta globulin in blood plasma capable of combining with ferric ions and transporting iron in the body [n -S]\n",
  "TRANSFERRING": "TRANSFER, to move from one place to another [v]\n",
  "TRANSFERRINS": "TRANSFERRIN, a beta globulin in blood plasma capable of combining with ferric ions and transporting iron in the body [n]\n",
  "TRANSFERS": "TRANSFER, to move from one place to another [v]\n",
  "TRANSFIGURATION": "a change in form or appearance [n]\n",
  "TRANSFIGURE": "to give a new and typically exalted or spiritual appearance to [v TRANSFIGURED, TRANSFIGURING, TRANSFIGURES]\n",
  "TRANSFIGURED": "TRANSFIGURE, to give a new and typically exalted or spiritual appearance to [v]\n",
  "TRANSFIGUREMENT": "the act of transfiguring [n]\n",
  "TRANSFIGURES": "TRANSFIGURE, to give a new and typically exalted or spiritual appearance to [v]\n",
  "TRANSFIGURING": "TRANSFIGURE, to give a new and typically exalted or spiritual appearance to [v]\n",
  "TRANSFINITE": "going beyond or surpassing any finite number, group, or magnitude [adj]\n",
  "TRANSFIX": "to impale [v -ED, -ING, -ES]\n",
  "TRANSFIXED": "TRANSFIX, to impale [v]\n",
  "TRANSFIXES": "TRANSFIX, to impale [v]\n",
  "TRANSFIXING": "TRANSFIX, to impale [v]\n",
  "TRANSFIXION": "the act of transfixing [n -S]\n",
  "TRANSFIXIONS": "TRANSFIXION, the act of transfixing [n]\n",
  "TRANSFIXT": "TRANSFIX, to impale [v]\n",
  "TRANSFORM": "to change into another form [v -ED, -ING, -S]\n",
  "TRANSFORMABLE": "capable of being transformed [adj]\n",
  "TRANSFORMATION": "an act, process, or instance of transforming or being transformed [n -S]\n",
  "TRANSFORMATIONS": "TRANSFORMATION, an act, process, or instance of transforming or being transformed [n]\n",
  "TRANSFORMATIVE": "having the power to transform [adj]\n",
  "TRANSFORMED": "TRANSFORM, to change into another form [v]\n",
  "TRANSFORMER": "one that transforms [n -S]\n",
  "TRANSFORMERS": "TRANSFORMER, one that transforms [n]\n",
  "TRANSFORMING": "the act of transforming [n -S]\n",
  "TRANSFORMINGS": "TRANSFORMING, the act of transforming [n]\n",
  "TRANSFORMISM": "the theory of the mutability of species [n -S]\n",
  "TRANSFORMISMS": "TRANSFORMISM, the theory of the mutability of species [n]\n",
  "TRANSFORMIST": "a proponent of transformism [n -S]\n",
  "TRANSFORMISTIC": "serving to transform [adj]\n",
  "TRANSFORMISTS": "TRANSFORMIST, a proponent of transformism [n]\n",
  "TRANSFORMS": "TRANSFORM, to change into another form [v]\n",
  "TRANSFUSABLE": "that can be transfused, also TRANSFUSIBLE [adj]\n",
  "TRANSFUSE": "to pour out into another vessel; to transfer (e.g. blood) to another's veins [v TRANSFUSED, TRANSFUSING, TRANSFUSES]\n",
  "TRANSFUSED": "TRANSFUSE, to pour out into another vessel; to transfer (e.g. blood) to another's veins [v]\n",
  "TRANSFUSER": "one who transfuses [n -S]\n",
  "TRANSFUSERS": "TRANSFUSER, one who transfuses [n]\n",
  "TRANSFUSES": "TRANSFUSE, to pour out into another vessel; to transfer (e.g. blood) to another's veins [v]\n",
  "TRANSFUSIBLE": "that can be transfused, also TRANSFUSABLE [adj]\n",
  "TRANSFUSING": "TRANSFUSE, to pour out into another vessel; to transfer (e.g. blood) to another's veins [v]\n",
  "TRANSFUSION": "the act of transfusing esp. blood [n -S]\n",
  "TRANSFUSIONAL": "relating to transfusion [adj]\n",
  "TRANSFUSIONIST": "a doctor who performs transfusions [n -S]\n",
  "TRANSFUSIONISTS": "TRANSFUSIONIST, a doctor who performs transfusions [n]\n",
  "TRANSFUSIONS": "TRANSFUSION, the act of transfusing esp. blood [n]\n",
  "TRANSFUSIVE": "tending or having power to transfuse [adj TRANSFUSIVELY]\n",
  "TRANSFUSIVELY": "TRANSFUSIVE, tending or having power to transfuse [adv]\n",
  "TRANSGENDER": "one who transcends traditional gender boundaries and corresponding sexual norms [n -S]\n",
  "TRANSGENDERED": "transcending traditional gender boundaries and corresponding sexual norms [adj]\n",
  "TRANSGENDERS": "TRANSGENDER, one who transcends traditional gender boundaries and corresponding sexual norms [n]\n",
  "TRANSGENE": "a gene that is transferred from an organism of one species to an organism of another species by genetic engineering [n -S]\n",
  "TRANSGENES": "TRANSGENE, a gene that is transferred from an organism of one species to an organism of another species by genetic engineering [n]\n",
  "TRANSGENESES": "TRANSGENESIS, the creation of transgenic animals or plants [n]\n",
  "TRANSGENESIS": "the creation of transgenic animals or plants [n TRANSGENESES]\n",
  "TRANSGENIC": "of, pertaining to, or designating an organism containing genetic material into which DNA from an unrelated organism has been artificially introduced [adj]\n",
  "TRANSGENICS": "the branch of biology concerned with transgenic organisms [n]\n",
  "TRANSGRESS": "to violate a command or law [v -ED, -ING, -ES]\n",
  "TRANSGRESSED": "TRANSGRESS, to violate a command or law [v]\n",
  "TRANSGRESSES": "TRANSGRESS, to violate a command or law [v]\n",
  "TRANSGRESSING": "TRANSGRESS, to violate a command or law [v]\n",
  "TRANSGRESSION": "an act of transgressing [n -S]\n",
  "TRANSGRESSIONAL": "related to transgression [adj]\n",
  "TRANSGRESSIONS": "TRANSGRESSION, an act of transgressing [n]\n",
  "TRANSGRESSIVE": "of the nature of a transgression [adj TRANSGRESSIVELY]\n",
  "TRANSGRESSIVELY": "TRANSGRESSIVE, of the nature of a transgression [adv]\n",
  "TRANSGRESSOR": "one who transgresses [n -S]\n",
  "TRANSGRESSORS": "TRANSGRESSOR, one who transgresses [n]\n",
  "TRANSHIP": "to transfer from one conveyance to another [v TRANSHIPPED, TRANSHIPPING, TRANSHIPS]\n",
  "TRANSHIPMENT": "the act of transhipping [n -S]\n",
  "TRANSHIPMENTS": "TRANSHIPMENT, the act of transhipping [n]\n",
  "TRANSHIPPED": "TRANSHIP, to transfer from one conveyance to another [v]\n",
  "TRANSHIPPER": "one who tranships, also TRANSSHIPPER [n -S]\n",
  "TRANSHIPPERS": "TRANSHIPPER, one who tranships, also TRANSSHIPPER [n]\n",
  "TRANSHIPPING": "transfer from one ship to another [n -S]\n",
  "TRANSHIPPINGS": "TRANSHIPPING, transfer from one ship to another [n]\n",
  "TRANSHIPS": "TRANSHIP, to transfer from one conveyance to another [v]\n",
  "TRANSHISTORICAL": "transcending historical bounds [adj]\n",
  "TRANSHUMANCE": "the movement of livestock and herders to different pasturage with the changing of the seasons [n -S]\n",
  "TRANSHUMANCES": "TRANSHUMANCE, the movement of livestock and herders to different pasturage with the changing of the seasons [n]\n",
  "TRANSHUMANT": "passing from winter to summer pastures [adj] / one who moves from winter to summer pastures [n -S]\n",
  "TRANSHUMANTS": "TRANSHUMANT, one who moves from winter to summer pastures [n]\n",
  "TRANSHUME": "to move (cattle) to summer pastures or winter quarters [v TRANSHUMED, TRANSHUMING, TRANSHUMES]\n",
  "TRANSHUMED": "TRANSHUME, to move (cattle) to summer pastures or winter quarters [v]\n",
  "TRANSHUMES": "TRANSHUME, to move (cattle) to summer pastures or winter quarters [v]\n",
  "TRANSHUMING": "TRANSHUME, to move (cattle) to summer pastures or winter quarters [v]\n",
  "TRANSIENCE": "the state of being transient, also TRANSIENCY [n -S]\n",
  "TRANSIENCES": "TRANSIENCE, the state of being transient, also TRANSIENCY [n]\n",
  "TRANSIENCIES": "TRANSIENCY, the state of being transient, also TRANSIENCE [n]\n",
  "TRANSIENCY": "the state of being transient, also TRANSIENCE [n TRANSIENCIES]\n",
  "TRANSIENT": "not lasting long [adj TRANSIENTLY] / a transient thing or being [n -S]\n",
  "TRANSIENTLY": "TRANSIENT, not lasting long [adv]\n",
  "TRANSIENTNESS": "the state of being transient [n -ES]\n",
  "TRANSIENTNESSES": "TRANSIENTNESS, the state of being transient [n]\n",
  "TRANSIENTS": "TRANSIENT, a transient thing or being [n]\n",
  "TRANSILIENCE": "the state of being transilient, also TRANSILIENCY [n -S]\n",
  "TRANSILIENCES": "TRANSILIENCE, the state of being transilient, also TRANSILIENCY [n]\n",
  "TRANSILIENCIES": "TRANSILIENCY, the state of being transilient, leaping or passing across, also TRANSILIENCE [n]\n",
  "TRANSILIENCY": "the state of being transilient, leaping or passing across, also TRANSILIENCE [n TRANSILIENCIES]\n",
  "TRANSILIENT": "leaping or passing across [adj]\n",
  "TRANSILLUMINATE": "to pass light through, esp. through body for medical examination [v]\n",
  "TRANSIRE": "(Latin) a customs warrant [n -S]\n",
  "TRANSIRES": "TRANSIRE, (Latin) a customs warrant [n]\n",
  "TRANSISTHMIAN": "across an isthmus [adj]\n",
  "TRANSISTOR": "a three-electrode semiconductor device, able to perform many functions of multielectrode valves [n -S]\n",
  "TRANSISTORISE": "to fit with or convert to use transistors, also TRANSISTORIZE [v TRANSISTORISED, TRANSISTORISING, TRANSISTORISES]\n",
  "TRANSISTORISED": "TRANSISTORISE, to fit with or convert to use transistors, also TRANSISTORIZE [v]\n",
  "TRANSISTORISES": "TRANSISTORISE, to fit with or convert to use transistors, also TRANSISTORIZE [v]\n",
  "TRANSISTORISING": "TRANSISTORISE, to fit with or convert to use transistors, also TRANSISTORIZE [v]\n",
  "TRANSISTORIZE": "to fit with or convert to use transistors, also TRANSISTORISE [v TRANSISTORIZED, TRANSISTORIZING, TRANSISTORIZES]\n",
  "TRANSISTORIZED": "TRANSISTORIZE, to fit with or convert to use transistors, also TRANSISTORISE [v]\n",
  "TRANSISTORIZES": "TRANSISTORIZE, to fit with or convert to use transistors, also TRANSISTORISE [v]\n",
  "TRANSISTORIZING": "TRANSISTORIZE, to fit with or convert to use transistors, also TRANSISTORISE [v]\n",
  "TRANSISTORS": "TRANSISTOR, a three-electrode semiconductor device, able to perform many functions of multielectrode valves [n]\n",
  "TRANSIT": "to pass across or through [v -ED, -ING, -S]\n",
  "TRANSITABLE": "capable of being transited [adj]\n",
  "TRANSITED": "TRANSIT, to pass across or through [v]\n",
  "TRANSITING": "TRANSIT, to pass across or through [v]\n",
  "TRANSITION": "to effect a change [v -ED, -ING, -S]\n",
  "TRANSITIONAL": "marking a transition [adj TRANSITIONALLY] / in architecture, a transitional form [n -S]\n",
  "TRANSITIONALLY": "TRANSITIONAL, marking a transition [adv]\n",
  "TRANSITIONALS": "TRANSITIONAL, in architecture, a transitional form [n]\n",
  "TRANSITIONARY": "in the nature of a transition [adj]\n",
  "TRANSITIONED": "TRANSITION, to effect a change [v]\n",
  "TRANSITIONING": "TRANSITION, to effect a change [v]\n",
  "TRANSITIONS": "TRANSITION, to effect a change [v]\n",
  "TRANSITIVE": "taking a direct object [adj TRANSITIVELY] / a verb taking a direct object [n -S]\n",
  "TRANSITIVELY": "TRANSITIVE, taking a direct object [adv]\n",
  "TRANSITIVENESS": "the state of being transitive [n]\n",
  "TRANSITIVES": "TRANSITIVE, a verb taking a direct object [n]\n",
  "TRANSITIVITIES": "TRANSITIVITY, the state of being transitive [n]\n",
  "TRANSITIVITY": "the state of being transitive [n TRANSITIVITIES]\n",
  "TRANSITORILY": "TRANSITORY, not lasting long [adv]\n",
  "TRANSITORINESS": "the state of being transitory [n]\n",
  "TRANSITORY": "not lasting long [adj TRANSITORILY]\n",
  "TRANSITS": "TRANSIT, to pass across or through [v]\n",
  "TRANSLATABILITY": "the state of being translatable [n]\n",
  "TRANSLATABLE": "capable of being translated [adj]\n",
  "TRANSLATE": "to render into another language [v TRANSLATED, TRANSLATING, TRANSLATES]\n",
  "TRANSLATED": "TRANSLATE, to render into another language [v]\n",
  "TRANSLATES": "TRANSLATE, to render into another language [v]\n",
  "TRANSLATING": "TRANSLATE, to render into another language [v]\n",
  "TRANSLATION": "a rendering from one language into another [n -S]\n",
  "TRANSLATIONAL": "relating to translation [adj TRANSLATIONALLY]\n",
  "TRANSLATIONALLY": "TRANSLATIONAL, relating to translation [adv]\n",
  "TRANSLATIONS": "TRANSLATION, a rendering from one language into another [n]\n",
  "TRANSLATIVE": "a tense or case indicating process of change or movement through [n -S]\n",
  "TRANSLATIVES": "TRANSLATIVE, a tense or case indicating process of change or movement through [n]\n",
  "TRANSLATOR": "one who translates [n -S]\n",
  "TRANSLATORIAL": "relating to a translator [adj]\n",
  "TRANSLATORS": "TRANSLATOR, one who translates [n]\n",
  "TRANSLATORY": "of, relating to, or involving uniform motion in one direction [adj]\n",
  "TRANSLEITHAN": "beyond the river Leitha, once in part the boundary between Austria and Hungary; hence, Hungarian [adj]\n",
  "TRANSLITERATE": "to represent or spell in the characters of another alphabet [v TRANSLITERATED, TRANSLITERATING, TRANSLITERATES]\n",
  "TRANSLITERATED": "TRANSLITERATE, to represent or spell in the characters of another alphabet [v]\n",
  "TRANSLITERATES": "TRANSLITERATE, to represent or spell in the characters of another alphabet [v]\n",
  "TRANSLITERATING": "TRANSLITERATE, to represent or spell in the characters of another alphabet [v]\n",
  "TRANSLITERATION": "the act of transliterating [n]\n",
  "TRANSLITERATOR": "one who transliterates [n -S]\n",
  "TRANSLITERATORS": "TRANSLITERATOR, one who transliterates [n]\n",
  "TRANSLOCATE": "to change location [v TRANSLOCATED, TRANSLOCATING, TRANSLOCATES]\n",
  "TRANSLOCATED": "TRANSLOCATE, to change location [v]\n",
  "TRANSLOCATES": "TRANSLOCATE, to change location [v]\n",
  "TRANSLOCATING": "TRANSLOCATE, to change location [v]\n",
  "TRANSLOCATION": "the act, process, or an instance of changing location or position [n -S]\n",
  "TRANSLOCATIONS": "TRANSLOCATION, the act, process, or an instance of changing location or position [n]\n",
  "TRANSLUCENCE": "the state of being translucent, also TRANSLUCENCY [n -S]\n",
  "TRANSLUCENCES": "TRANSLUCENCE, the state of being translucent, also TRANSLUCENCY [n]\n",
  "TRANSLUCENCIES": "TRANSLUCENCY, the state of being translucent, also TRANSLUCENCE [n]\n",
  "TRANSLUCENCY": "the state of being translucent, also TRANSLUCENCE [n TRANSLUCENCIES]\n",
  "TRANSLUCENT": "imperfectly transparent, also TRANSLUCID [adj TRANSLUCENTLY]\n",
  "TRANSLUCENTLY": "TRANSLUCENT, imperfectly transparent, also TRANSLUCID [adv]\n",
  "TRANSLUCID": "translucent, also TRANSLUCENT [adj]\n",
  "TRANSLUCIDITIES": "TRANSLUCIDITY, the quality of being translucid [n]\n",
  "TRANSLUCIDITY": "the quality of being translucid [n TRANSLUCIDITIES]\n",
  "TRANSLUMENAL": "(of a surgical procedure) performed within a blood vessel, duct, or cavity, also TRANSLUMINAL [adj]\n",
  "TRANSLUMINAL": "(of a surgical procedure) performed within a blood vessel, duct, or cavity, also TRANSLUMENAL [adj]\n",
  "TRANSLUNAR": "of or relating to the region beyond the moon's orbit, also TRANSLUNARY [adj]\n",
  "TRANSLUNARY": "of or relating to the region beyond the moon's orbit, also TRANSLUNAR [adj]\n",
  "TRANSMAN": "a transgender or transsexual man [n TRANSMEN]\n",
  "TRANSMANCHE": "(French) relating to the tunnel under the English Channel [adj]\n",
  "TRANSMARINE": "across or beyond the sea [adj]\n",
  "TRANSMEMBRANE": "taking place or existing across a membrane [adj]\n",
  "TRANSMEN": "TRANSMAN, a transgender or transsexual man [n]\n",
  "TRANSMEW": "(Spenser) to transmute, change to another form or substance, also TRANSMOVE [v -ED, -ING, -S]\n",
  "TRANSMEWED": "TRANSMEW, (Spenser) to transmute, change to another form or substance, also TRANSMOVE [v]\n",
  "TRANSMEWING": "TRANSMEW, (Spenser) to transmute, change to another form or substance, also TRANSMOVE [v]\n",
  "TRANSMEWS": "TRANSMEW, (Spenser) to transmute, change to another form or substance, also TRANSMOVE [v]\n",
  "TRANSMIGRANT": "a migrant passing through a country on the way to another in which he or she means to settle [n -S]\n",
  "TRANSMIGRANTS": "TRANSMIGRANT, a migrant passing through a country on the way to another in which he or she means to settle [n]\n",
  "TRANSMIGRATE": "to pass from one body or place into another [v TRANSMIGRATED, TRANSMIGRATING, TRANSMIGRATES]\n",
  "TRANSMIGRATED": "TRANSMIGRATE, to pass from one body or place into another [v]\n",
  "TRANSMIGRATES": "TRANSMIGRATE, to pass from one body or place into another [v]\n",
  "TRANSMIGRATING": "TRANSMIGRATE, to pass from one body or place into another [v]\n",
  "TRANSMIGRATION": "passing from one body or place into another [n -S]\n",
  "TRANSMIGRATIONS": "TRANSMIGRATION, passing from one body or place into another [n]\n",
  "TRANSMIGRATIVE": "passing from one body or place into another [adj]\n",
  "TRANSMIGRATOR": "one who transmigrates [n -S]\n",
  "TRANSMIGRATORS": "TRANSMIGRATOR, one who transmigrates [n]\n",
  "TRANSMIGRATORY": "relating to transmigration [adj]\n",
  "TRANSMISSIBLE": "capable of being transmitted [adj]\n",
  "TRANSMISSION": "an act, process, or instance of transmitting [n -S]\n",
  "TRANSMISSIONAL": "relating to transmission [adj]\n",
  "TRANSMISSIONS": "TRANSMISSION, an act, process, or instance of transmitting [n]\n",
  "TRANSMISSIVE": "relating to transmission [adj TRANSMISSIVELY]\n",
  "TRANSMISSIVELY": "TRANSMISSIVE, relating to transmission [adv]\n",
  "TRANSMISSIVITY": "the state of being transmissive [n]\n",
  "TRANSMISSOMETER": "an instrument for measuring transmission of light through a fluid [n]\n",
  "TRANSMIT": "to send from one place to another [v TRANSMITTED, TRANSMITTING, TRANSMITS]\n",
  "TRANSMITS": "TRANSMIT, to send from one place to another [v]\n",
  "TRANSMITTABLE": "that can be transmitted, also TRANSMITTIBLE [adj]\n",
  "TRANSMITTAL": "the act of transmitting [n -S]\n",
  "TRANSMITTALS": "TRANSMITTAL, the act of transmitting [n]\n",
  "TRANSMITTANCE": "the act of transmitting [n -S]\n",
  "TRANSMITTANCES": "TRANSMITTANCE, the act of transmitting [n]\n",
  "TRANSMITTANCIES": "TRANSMITTANCY, a measure of the extent to which a solution transmits radiation [n]\n",
  "TRANSMITTANCY": "a measure of the extent to which a solution transmits radiation [n TRANSMITTANCIES]\n",
  "TRANSMITTED": "TRANSMIT, to send from one place to another [v]\n",
  "TRANSMITTER": "one that transmits [n -S]\n",
  "TRANSMITTERS": "TRANSMITTER, one that transmits [n]\n",
  "TRANSMITTIBLE": "that can be transmitted, also TRANSMITTABLE [adj]\n",
  "TRANSMITTING": "TRANSMIT, to send from one place to another [v]\n",
  "TRANSMITTIVITY": "the ability to be transmitted [n]\n",
  "TRANSMOGRIFIED": "TRANSMOGRIFY, to change or alter greatly and often with grotesque or humorous effect [v]\n",
  "TRANSMOGRIFIES": "TRANSMOGRIFY, to change or alter greatly and often with grotesque or humorous effect [v]\n",
  "TRANSMOGRIFY": "to change or alter greatly and often with grotesque or humorous effect [v TRANSMOGRIFIED, TRANSMOGRIFYING, TRANSMOGRIFIES]\n",
  "TRANSMOGRIFYING": "TRANSMOGRIFY, to change or alter greatly and often with grotesque or humorous effect [v]\n",
  "TRANSMONTANE": "(Italian) a cold north wind in Italy, also TRAMONTANA, TRAMONTANE [n -S]\n",
  "TRANSMONTANES": "TRANSMONTANE, (Italian) a cold north wind in Italy, also TRAMONTANA, TRAMONTANE [n]\n",
  "TRANSMOUNTAIN": "crossing or extending over or through a mountain [adj]\n",
  "TRANSMOVE": "(Spenser) to transmute, also TRANSMEW [v TRANSMOVED, TRANSMOVING, TRANSMOVES]\n",
  "TRANSMOVED": "TRANSMOVE, (Spenser) to transmute, also TRANSMEW [v]\n",
  "TRANSMOVES": "TRANSMOVE, (Spenser) to transmute, also TRANSMEW [v]\n",
  "TRANSMOVING": "TRANSMOVE, (Spenser) to transmute, also TRANSMEW [v]\n",
  "TRANSMUNDANE": "not belonging to this world, out of, beyond, this world [adj]\n",
  "TRANSMUTABILITY": "the quality of being transmutable [n]\n",
  "TRANSMUTABLE": "capable of being transmuted [adj TRANSMUTABLY]\n",
  "TRANSMUTABLY": "TRANSMUTABLE, capable of being transmuted [adv]\n",
  "TRANSMUTATION": "an act of transmuting [n -S]\n",
  "TRANSMUTATIONAL": "like a transmutation [adj]\n",
  "TRANSMUTATIONS": "TRANSMUTATION, an act of transmuting [n]\n",
  "TRANSMUTATIVE": "having power to transmute [adj]\n",
  "TRANSMUTE": "to change to another form or substance, also TRANSMEW, TRANSMOVE [v TRANSMUTED, TRANSMUTING, TRANSMUTES]\n",
  "TRANSMUTED": "TRANSMUTE, to change to another form or substance, also TRANSMEW, TRANSMOVE [v]\n",
  "TRANSMUTER": "one who transmutes [n -S]\n",
  "TRANSMUTERS": "TRANSMUTER, one who transmutes [n]\n",
  "TRANSMUTES": "TRANSMUTE, to change to another form or substance, also TRANSMEW, TRANSMOVE [v]\n",
  "TRANSMUTING": "TRANSMUTE, to change to another form or substance, also TRANSMEW, TRANSMOVE [v]\n",
  "TRANSNATIONAL": "extending or going beyond national boundaries [adj]\n",
  "TRANSNATURAL": "being above or beyond nature [adj]\n",
  "TRANSOCEANIC": "lying or dwelling beyond the ocean [adj]\n",
  "TRANSOM": "a small window above a door [n -S]\n",
  "TRANSOMED": "having a transom [adj]\n",
  "TRANSOMS": "TRANSOM, a small window above a door [n]\n",
  "TRANSONIC": "relating to the range of speeds close to that of sound [adj]\n",
  "TRANSONICS": "the range of speeds close to that sound [n]\n",
  "TRANSPACIFIC": "crossing or extending across the Pacific Ocean [adj]\n",
  "TRANSPADANE": "on the other (i.e. the north) side of the river Po [adj]\n",
  "TRANSPARENCE": "the state of being transparent, also TRANSPARENCY [n -S]\n",
  "TRANSPARENCES": "TRANSPARENCE, the state of being transparent, also TRANSPARENCY [n]\n",
  "TRANSPARENCIES": "TRANSPARENCY, the state of being transparent, also TRANSPARENCE [n]\n",
  "TRANSPARENCY": "the state of being transparent, also TRANSPARENCE [n TRANSPARENCIES]\n",
  "TRANSPARENT": "able to be seen through [adj TRANSPARENTLY]\n",
  "TRANSPARENTISE": "to make transparent, also TRANSPARENTIZE [v TRANSPARENTISED, TRANSPARENTISES]\n",
  "TRANSPARENTISED": "TRANSPARENTISE, to make transparent, also TRANSPARENTIZE [v]\n",
  "TRANSPARENTISES": "TRANSPARENTISE, to make transparent, also TRANSPARENTIZE [v]\n",
  "TRANSPARENTIZE": "to make transparent, also TRANSPARENTISE [v TRANSPARENTIZED, TRANSPARENTIZES]\n",
  "TRANSPARENTIZED": "TRANSPARENTIZE, to make transparent, also TRANSPARENTISE [v]\n",
  "TRANSPARENTIZES": "TRANSPARENTIZE, to make transparent, also TRANSPARENTISE [v]\n",
  "TRANSPARENTLY": "TRANSPARENT, able to be seen through [adv]\n",
  "TRANSPARENTNESS": "the state of being transparent [n]\n",
  "TRANSPERSON": "a transgender or transsexual person [n -S]\n",
  "TRANSPERSONAL": "extending or going beyond the personal or individual [adj]\n",
  "TRANSPERSONS": "TRANSPERSON, a transgender or transsexual person [n]\n",
  "TRANSPHOBIA": "intense hatred or fear of transgender people [n -S]\n",
  "TRANSPHOBIAS": "TRANSPHOBIA, intense hatred or fear of transgender people [n]\n",
  "TRANSPHOBIC": "showing intense hatred or fear of transgender people [adj]\n",
  "TRANSPICUOUS": "easily understood or seen through [adj TRANSPICUOUSLY]\n",
  "TRANSPICUOUSLY": "TRANSPICUOUS, easily understood or seen through [adv]\n",
  "TRANSPIERCE": "to pierce through [v TRANSPIERCED, TRANSPIERCING, TRANSPIERCES]\n",
  "TRANSPIERCED": "TRANSPIERCE, to pierce through [v]\n",
  "TRANSPIERCES": "TRANSPIERCE, to pierce through [v]\n",
  "TRANSPIERCING": "TRANSPIERCE, to pierce through [v]\n",
  "TRANSPIRABLE": "capable of transpiring [adj]\n",
  "TRANSPIRATION": "the act of transpiring [n -S]\n",
  "TRANSPIRATIONAL": "relating to transpiration, also TRANSPIRATORY [adj]\n",
  "TRANSPIRATIONS": "TRANSPIRATION, the act of transpiring [n]\n",
  "TRANSPIRATORY": "relating to transpiration, also TRANSPIRATIONAL [adj]\n",
  "TRANSPIRE": "to give off as vapour; to exhale; to emit through the skin [v TRANSPIRED, TRANSPIRING, TRANSPIRES]\n",
  "TRANSPIRED": "TRANSPIRE, to give off as vapour; to exhale; to emit through the skin [v]\n",
  "TRANSPIRES": "TRANSPIRE, to give off as vapour; to exhale; to emit through the skin [v]\n",
  "TRANSPIRING": "TRANSPIRE, to give off as vapour; to exhale; to emit through the skin [v]\n",
  "TRANSPLACENTAL": "passing through or occurring by way of the placenta [adj]\n",
  "TRANSPLANT": "to lift and reset (a plant) in another soil or situation [v -ED, -ING, -S]\n",
  "TRANSPLANTABLE": "capable of being transplanted [adj]\n",
  "TRANSPLANTATION": "the act of transplanting [n]\n",
  "TRANSPLANTED": "TRANSPLANT, to lift and reset (a plant) in another soil or situation [v]\n",
  "TRANSPLANTER": "one who transplants [n -S]\n",
  "TRANSPLANTERS": "TRANSPLANTER, one who transplants [n]\n",
  "TRANSPLANTING": "the act of transplanting [n -S]\n",
  "TRANSPLANTINGS": "TRANSPLANTING, the act of transplanting [n]\n",
  "TRANSPLANTS": "TRANSPLANT, to lift and reset (a plant) in another soil or situation [v]\n",
  "TRANSPOLAR": "across the poles [adj]\n",
  "TRANSPONDER": "a type of radio or radar transmitter-receiver that transmits signals automatically when it receives predetermined signals, also TRANSPONDOR [n -S]\n",
  "TRANSPONDERS": "TRANSPONDER, a type of radio or radar transmitter-receiver that transmits signals automatically when it receives predetermined signals, also TRANSPONDOR [n]\n",
  "TRANSPONDOR": "a type of radio or radar transmitter-receiver that transmits signals automatically when it receives predetermined signals, also TRANSPONDER [n -S]\n",
  "TRANSPONDORS": "TRANSPONDOR, a type of radio or radar transmitter-receiver that transmits signals automatically when it receives predetermined signals, also TRANSPONDER [n]\n",
  "TRANSPONTINE": "situated on the far side of a bridge, esp. situated on the south side of the Thames River in London [adj]\n",
  "TRANSPORT": "carriage or conveyance of goods or people from one place to another [n -S] / to convey [v -ED, -ING, -S]\n",
  "TRANSPORTABLE": "capable of being transported [adj]\n",
  "TRANSPORTAL": "the act of transporting [n -S]\n",
  "TRANSPORTALS": "TRANSPORTAL, the act of transporting [n]\n",
  "TRANSPORTANCE": "(Shakespeare) conveyance, transport [n -S]\n",
  "TRANSPORTANCES": "TRANSPORTANCE, (Shakespeare) conveyance, transport [n]\n",
  "TRANSPORTATION": "an act, process, or instance of transporting or being transported [n -S]\n",
  "TRANSPORTATIONS": "TRANSPORTATION, an act, process, or instance of transporting or being transported [n]\n",
  "TRANSPORTED": "TRANSPORT, to convey [v]\n",
  "TRANSPORTEDLY": "TRANSPORTED, TRANSPORT, to convey [adv]\n",
  "TRANSPORTEDNESS": "the state of being transported [n]\n",
  "TRANSPORTER": "one that transports [n -S]\n",
  "TRANSPORTERS": "TRANSPORTER, one that transports [n]\n",
  "TRANSPORTING": "engrossing [adj TRANSPORTINGLY] / the act of transporting [n -S]\n",
  "TRANSPORTINGLY": "TRANSPORTING, engrossing [adv]\n",
  "TRANSPORTINGS": "TRANSPORTING, the act of transporting [n]\n",
  "TRANSPORTIVE": "tending or having power to transport [adj]\n",
  "TRANSPORTS": "TRANSPORT, to convey [v]\n",
  "TRANSPOSABILITY": "the quality of being transposable [n]\n",
  "TRANSPOSABLE": "capable of being transposed [adj]\n",
  "TRANSPOSAL": "the act of transposing, or the state of being transposed [n -S]\n",
  "TRANSPOSALS": "TRANSPOSAL, the act of transposing, or the state of being transposed [n]\n",
  "TRANSPOSE": "to change the order or position of [v TRANSPOSED, TRANSPOSING, TRANSPOSES]\n",
  "TRANSPOSED": "TRANSPOSE, to change the order or position of [v]\n",
  "TRANSPOSER": "one who transposes [n -S]\n",
  "TRANSPOSERS": "TRANSPOSER, one who transposes [n]\n",
  "TRANSPOSES": "TRANSPOSE, to change the order or position of [v]\n",
  "TRANSPOSING": "the act of transposition [n -S]\n",
  "TRANSPOSINGS": "TRANSPOSING, the act of transposition [n]\n",
  "TRANSPOSITION": "an act, process, or instance of transposing or being transposed [n -S]\n",
  "TRANSPOSITIONAL": "relating to transposition, also TRANSPOSITIVE [adj]\n",
  "TRANSPOSITIONS": "TRANSPOSITION, an act, process, or instance of transposing or being transposed [n]\n",
  "TRANSPOSITIVE": "relating to transposition, also TRANSPOSITIONAL [adj]\n",
  "TRANSPOSON": "a sequence of DNA capable of moving to different sites in a chromosome [n -S]\n",
  "TRANSPOSONS": "TRANSPOSON, a sequence of DNA capable of moving to different sites in a chromosome [n]\n",
  "TRANSPUTER": "a special computer chip able to process in parallel rather than sequentially [n -S]\n",
  "TRANSPUTERS": "TRANSPUTER, a special computer chip able to process in parallel rather than sequentially [n]\n",
  "TRANSSEXUAL": "a person anatomically of one sex but having a strong desire to adopt the physical characteristics and role of a member of the opposite sex, also TRANSEXUAL [n -S]\n",
  "TRANSSEXUALISM": "the state of being a transsexual [n -S]\n",
  "TRANSSEXUALISMS": "TRANSSEXUALISM, the state of being a transsexual [n]\n",
  "TRANSSEXUALITY": "the state of being transsexual, also TRANSEXUALITY [n]\n",
  "TRANSSEXUALS": "TRANSSEXUAL, a person anatomically of one sex but having a strong desire to adopt the physical characteristics and role of a member of the opposite sex, also TRANSEXUAL [n]\n",
  "TRANSSHAPE": "to change into another shape [v TRANSSHAPED, TRANSSHAPING, TRANSSHAPES]\n",
  "TRANSSHAPED": "TRANSSHAPE, to change into another shape [v]\n",
  "TRANSSHAPES": "TRANSSHAPE, to change into another shape [v]\n",
  "TRANSSHAPING": "TRANSSHAPE, to change into another shape [v]\n",
  "TRANSSHIP": "to transfer from one ship to another, also TRANSHIP [v TRANSSHIPPED, TRANSSHIPPING, TRANSSHIPS]\n",
  "TRANSSHIPMENT": "the act of transshipping [n -S]\n",
  "TRANSSHIPMENTS": "TRANSSHIPMENT, the act of transshipping [n]\n",
  "TRANSSHIPPED": "TRANSSHIP, to transfer from one ship to another, also TRANSHIP [v]\n",
  "TRANSSHIPPER": "one who transships, also TRANSHIPPER [n -S]\n",
  "TRANSSHIPPERS": "TRANSSHIPPER, one who transships, also TRANSHIPPER [n]\n",
  "TRANSSHIPPING": "transfer from one ship to another [n -S]\n",
  "TRANSSHIPPINGS": "TRANSSHIPPING, transfer from one ship to another [n]\n",
  "TRANSSHIPS": "TRANSSHIP, to transfer from one ship to another, also TRANSHIP [v]\n",
  "TRANSSONIC": "relating to the range of speeds close to that sound [adj]\n",
  "TRANSTHORACIC": "done or made by way of the thoracic cavity [adj]\n",
  "TRANSUBSTANTIAL": "changed or capable of being changed from one substance to another [adj]\n",
  "TRANSUDATE": "a substance that transudes e.g. a fluid that pases through a membrane or the walls of a blood vessel [n -S]\n",
  "TRANSUDATES": "TRANSUDATE, a substance that transudes e.g. a fluid that pases through a membrane or the walls of a blood vessel [n]\n",
  "TRANSUDATION": "the act of transuding [n -S]\n",
  "TRANSUDATIONS": "TRANSUDATION, the act of transuding [n]\n",
  "TRANSUDATORY": "relating to transudation [adj]\n",
  "TRANSUDE": "to pass through a membrane [v TRANSUDED, TRANSUDING, TRANSUDES]\n",
  "TRANSUDED": "TRANSUDE, to pass through a membrane [v]\n",
  "TRANSUDES": "TRANSUDE, to pass through a membrane [v]\n",
  "TRANSUDING": "TRANSUDE, to pass through a membrane [v]\n",
  "TRANSUME": "(obsolete) to transcribe officially [v TRANSUMED, TRANSUMING, TRANSUMES]\n",
  "TRANSUMED": "TRANSUME, (obsolete) to transcribe officially [v]\n",
  "TRANSUMES": "TRANSUME, (obsolete) to transcribe officially [v]\n",
  "TRANSUMING": "TRANSUME, (obsolete) to transcribe officially [v]\n",
  "TRANSUMPT": "a copy, a transcript; esp. of a legal document [n -S]\n",
  "TRANSUMPTION": "transcription; metaphor; translation [n -S]\n",
  "TRANSUMPTIONS": "TRANSUMPTION, transcription; metaphor; translation [n]\n",
  "TRANSUMPTIVE": "transferred; metaphorical [adj]\n",
  "TRANSUMPTS": "TRANSUMPT, a copy, a transcript; esp. of a legal document [n]\n",
  "TRANSURANIAN": "of an element, having an atomic number greater than that of uranium, also TRANSURANIUM [adj]\n",
  "TRANSURANIC": "any chemical element having atomic number beyond uranium (92), not occurring in nature but artificially produced by bombardment of atoms [n -S]\n",
  "TRANSURANICS": "TRANSURANIC, any chemical element having atomic number beyond uranium (92), not occurring in nature but artificially produced by bombardment of atoms [n]\n",
  "TRANSURANIUM": "of an element, having an atomic number greater than that of uranium, also TRANSURANIAN [adj]\n",
  "TRANSURETHRAL": "carried out via the urethra [adj]\n",
  "TRANSVAGINAL": "across the vagina [adj]\n",
  "TRANSVALUATE": "to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUE [v TRANSVALUATED, TRANSVALUATING, TRANSVALUATES]\n",
  "TRANSVALUATED": "TRANSVALUATE, to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUE [v]\n",
  "TRANSVALUATES": "TRANSVALUATE, to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUE [v]\n",
  "TRANSVALUATING": "TRANSVALUATE, to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUE [v]\n",
  "TRANSVALUATION": "the act of transvaluing [n -S]\n",
  "TRANSVALUATIONS": "TRANSVALUATION, the act of transvaluing [n]\n",
  "TRANSVALUE": "to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUATE [v TRANSVALUED, TRANSVALUING, TRANSVALUES]\n",
  "TRANSVALUED": "TRANSVALUE, to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUATE [v]\n",
  "TRANSVALUER": "one who transvalues [n -S]\n",
  "TRANSVALUERS": "TRANSVALUER, one who transvalues [n]\n",
  "TRANSVALUES": "TRANSVALUE, to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUATE [v]\n",
  "TRANSVALUING": "TRANSVALUE, to reestimate the value of, esp. on a basis differing from the accepted standard, also TRANSVALUATE [v]\n",
  "TRANSVERSAL": "transverse [adj TRANSVERSALLY] / a line that intersects a system of lines [n -S]\n",
  "TRANSVERSALITY": "the state of being transversal [n]\n",
  "TRANSVERSALLY": "TRANSVERSAL, transverse [adv]\n",
  "TRANSVERSALS": "TRANSVERSAL, a line that intersects a system of lines [n]\n",
  "TRANSVERSE": "crossways [adj TRANSVERSELY] / to cross, traverse [v TRANSVERSED, TRANSVERSING, TRANSVERSES]\n",
  "TRANSVERSED": "TRANSVERSE, to cross, traverse [v]\n",
  "TRANSVERSELY": "TRANSVERSE, crossways [adv]\n",
  "TRANSVERSENESS": "the state of being transverse [n]\n",
  "TRANSVERSES": "TRANSVERSE, to cross, traverse [v]\n",
  "TRANSVERSING": "TRANSVERSE, to cross, traverse [v]\n",
  "TRANSVERSION": "the act of making transverse [n -S]\n",
  "TRANSVERSIONS": "TRANSVERSION, the act of making transverse [n]\n",
  "TRANSVERTER": "a piece of equipment attached to a radio transceiver to enable it to transmit and receive on additional frequencies [n -S]\n",
  "TRANSVERTERS": "TRANSVERTER, a piece of equipment attached to a radio transceiver to enable it to transmit and receive on additional frequencies [n]\n",
  "TRANSVEST": "to disguise; wear clothes of another, esp. of other sex [v -ED, -ING, -S]\n",
  "TRANSVESTED": "TRANSVEST, to disguise; wear clothes of another, esp. of other sex [v]\n",
  "TRANSVESTIC": "relating to transvestism [adj]\n",
  "TRANSVESTING": "TRANSVEST, to disguise; wear clothes of another, esp. of other sex [v]\n",
  "TRANSVESTISM": "dressing oneself in clothes of the opposite sex [n -S]\n",
  "TRANSVESTISMS": "TRANSVESTISM, dressing oneself in clothes of the opposite sex [n]\n",
  "TRANSVESTIST": "one who dresses in the clothes of the opposite sex, also TRANSVESTITE [n -S]\n",
  "TRANSVESTISTS": "TRANSVESTIST, one who dresses in the clothes of the opposite sex, also TRANSVESTITE [n]\n",
  "TRANSVESTITE": "one who dresses in the clothes of the opposite sex, also TRANSVESTIST [n -S]\n",
  "TRANSVESTITES": "TRANSVESTITE, one who dresses in the clothes of the opposite sex, also TRANSVESTIST [n]\n",
  "TRANSVESTITISM": "cross-dressing [n -S]\n",
  "TRANSVESTITISMS": "TRANSVESTITISM, cross-dressing [n]\n",
  "TRANSVESTS": "TRANSVEST, to disguise; wear clothes of another, esp. of other sex [v]\n",
  "TRANSWOMAN": "a transgender or transsexual woman [n TRANSWOMEN]\n",
  "TRANSWOMEN": "TRANSWOMAN, a transgender or transsexual woman [n]\n",
  "TRANT": "to traffic in an itinerant manner; to peddle [v -ED, -ING, -S]\n",
  "TRANTED": "TRANT, to traffic in an itinerant manner; to peddle [v]\n",
  "TRANTER": "one who trants; a peddler; a carrier [n -S]\n",
  "TRANTERS": "TRANTER, one who trants; a peddler; a carrier [n]\n",
  "TRANTING": "TRANT, to traffic in an itinerant manner; to peddle [v]\n",
  "TRANTS": "TRANT, to traffic in an itinerant manner; to peddle [v]\n",
  "TRAP": "to catch in a snare [v TRAPPED or (obsolete) TRAPT, TRAPPING, TRAPS]\n",
  "TRAPAN": "to operate on with a surgical saw, also TREPAN, TREPHINE [v TRAPANNED, TRAPANNING, TRAPANS]\n",
  "TRAPANNED": "TRAPAN, to operate on with a surgical saw, also TREPAN, TREPHINE [v]\n",
  "TRAPANNER": "one who trapans [n -S]\n",
  "TRAPANNERS": "TRAPANNER, one who trapans [n]\n",
  "TRAPANNING": "TRAPAN, to operate on with a surgical saw, also TREPAN, TREPHINE [v]\n",
  "TRAPANS": "TRAPAN, to operate on with a surgical saw, also TREPAN, TREPHINE [v]\n",
  "TRAPBALL": "a type of ball game [n -S]\n",
  "TRAPBALLS": "TRAPBALL, a type of ball game [n]\n",
  "TRAPDOOR": "a door set in a floor or ceiling, flush with the surface [n -S]\n",
  "TRAPDOORS": "TRAPDOOR, a door set in a floor or ceiling, flush with the surface [n]\n",
  "TRAPE": "to walk in an aimless manner, also TRAIPSE, TRAPES, TRAPSE [v TRAPED, TRAPING, TRAPES]\n",
  "TRAPED": "TRAPE, to walk in an aimless manner, also TRAIPSE, TRAPES, TRAPSE [v]\n",
  "TRAPES": "to walk in an aimless manner, also TRAIPSE, TRAPE [v -ED, -ING, -ES]\n",
  "TRAPESED": "TRAPES, to walk in an aimless manner, also TRAIPSE, TRAPE [v]\n",
  "TRAPESES": "TRAPES, to walk in an aimless manner, also TRAIPSE, TRAPE [v]\n",
  "TRAPESING": "the act of trapesing [n -S]\n",
  "TRAPESINGS": "TRAPESING, the act of trapesing [n]\n",
  "TRAPEZE": "to perform on a gymnastic apparatus [v TRAPEZED, TRAPEZING, TRAPEZES]\n",
  "TRAPEZED": "TRAPEZE, to perform on a gymnastic apparatus [v]\n",
  "TRAPEZES": "TRAPEZE, to perform on a gymnastic apparatus [v]\n",
  "TRAPEZIA": "TRAPEZIUM, (Greek) any quadrilateral that is not a parallelogram [n]\n",
  "TRAPEZIAL": "like a trapezium [adj]\n",
  "TRAPEZIFORM": "in the form of a trapezoid quadrilateral with no sides parallel [adj]\n",
  "TRAPEZII": "TRAPEZIUS, (Latin) either of two, flat large muscles running from the base of the occiput to the middle of the back [n]\n",
  "TRAPEZING": "TRAPEZE, to perform on a gymnastic apparatus [v]\n",
  "TRAPEZIST": "one who performs on a trapeze [n -S]\n",
  "TRAPEZISTS": "TRAPEZIST, one who performs on a trapeze [n]\n",
  "TRAPEZIUM": "(Greek) any quadrilateral that is not a parallelogram [n TRAPEZIUMS or TRAPEZIA]\n",
  "TRAPEZIUMS": "TRAPEZIUM, (Greek) any quadrilateral that is not a parallelogram [n]\n",
  "TRAPEZIUS": "(Latin) either of two, flat large muscles running from the base of the occiput to the middle of the back [n TRAPEZIUSES or TRAPEZII]\n",
  "TRAPEZIUSES": "TRAPEZIUS, (Latin) either of two, flat large muscles running from the base of the occiput to the middle of the back [n]\n",
  "TRAPEZOHEDRA": "TRAPEZOHEDRON, a crystalline form whose faces are trapeziums [n]\n",
  "TRAPEZOHEDRAL": "having the shape of a trapezohedron [adj]\n",
  "TRAPEZOHEDRON": "a crystalline form whose faces are trapeziums [n TRAPEZOHEDRA or TRAPEZOHEDRONS]\n",
  "TRAPEZOHEDRONS": "TRAPEZOHEDRON, a crystalline form whose faces are trapeziums [n]\n",
  "TRAPEZOID": "trapeze-shaped [adj] / a wrist bone at the base of the index finger [n -S]\n",
  "TRAPEZOIDAL": "in the form of a trapezium [adj]\n",
  "TRAPEZOIDS": "TRAPEZOID, a wrist bone at the base of the index finger [n]\n",
  "TRAPFALL": "a trapdoor that gives way beneath the feet; a pitfall [n -S]\n",
  "TRAPFALLS": "TRAPFALL, a trapdoor that gives way beneath the feet; a pitfall [n]\n",
  "TRAPING": "TRAPE, to walk in an aimless manner, also TRAIPSE, TRAPES, TRAPSE [v]\n",
  "TRAPLIKE": "like a trap [adj]\n",
  "TRAPLINE": "a series of traps [n -S]\n",
  "TRAPLINES": "TRAPLINE, a series of traps [n]\n",
  "TRAPNEST": "to determine the productivity of hens by a type of nest [v -ED, -ING, -S]\n",
  "TRAPNESTED": "TRAPNEST, to determine the productivity of hens by a type of nest [v]\n",
  "TRAPNESTING": "TRAPNEST, to determine the productivity of hens by a type of nest [v]\n",
  "TRAPNESTS": "TRAPNEST, to determine the productivity of hens by a type of nest [v]\n",
  "TRAPPEAN": "pertaining to traprock, also TRAPPOSE, TRAPPOUS [adj]\n",
  "TRAPPED": "TRAP, to catch in a snare [v]\n",
  "TRAPPER": "one that traps [n -S]\n",
  "TRAPPERS": "TRAPPER, one that traps [n]\n",
  "TRAPPIER": "TRAPPY, full of traps [adj]\n",
  "TRAPPIEST": "TRAPPY, full of traps [adj]\n",
  "TRAPPINESS": "the quality of being trappy, full of traps [n -ES]\n",
  "TRAPPINESSES": "TRAPPINESS, the quality of being trappy, full of traps [n]\n",
  "TRAPPING": "a covering for a horse [n -S]\n",
  "TRAPPINGS": "TRAPPING, a covering for a horse [n]\n",
  "TRAPPOSE": "pertaining to traprock, also TRAPPEAN, TRAPPOUS [adj]\n",
  "TRAPPOUS": "pertaining to traprock, also TRAPPEAN, TRAPPOSE [adj]\n",
  "TRAPPY": "full of traps [adj TRAPPIER, TRAPPIEST]\n",
  "TRAPROCK": "any fine-grained columnar igneous rock esp. basalt [n -S]\n",
  "TRAPROCKS": "TRAPROCK, any fine-grained columnar igneous rock esp. basalt [n]\n",
  "TRAPS": "TRAP, to catch in a snare [v]\n",
  "TRAPSE": "to walk in an aimless manner, also TRAIPSE, TRAPE, TRAPES [v TRAPSED, TRAPSING, TRAPSES]\n",
  "TRAPSED": "TRAPSE, to walk in an aimless manner, also TRAIPSE, TRAPE, TRAPES [v]\n",
  "TRAPSES": "TRAPSE, to walk in an aimless manner, also TRAIPSE, TRAPE, TRAPES [v]\n",
  "TRAPSHOOTER": "a person who engages in trapshooting [n -S]\n",
  "TRAPSHOOTERS": "TRAPSHOOTER, a person who engages in trapshooting [n]\n",
  "TRAPSHOOTING": "the sport of shooting from traps [n -S]\n",
  "TRAPSHOOTINGS": "TRAPSHOOTING, the sport of shooting from traps [n]\n",
  "TRAPSING": "TRAPSE, to walk in an aimless manner, also TRAIPSE, TRAPE, TRAPES [v]\n",
  "TRAPT": "TRAP, to catch in a snare [v]\n",
  "TRAPUNTO": "(Italian) a decorative quilted design [n -S]\n",
  "TRAPUNTOS": "TRAPUNTO, (Italian) a decorative quilted design [n]\n",
  "TRASH": "to wreck or vandalize [v -ED, -ING, -ES]\n",
  "TRASHCAN": "a rubbish bin [n -S]\n",
  "TRASHCANS": "TRASHCAN, a rubbish bin [n]\n",
  "TRASHED": "TRASH, to wreck or vandalize [v]\n",
  "TRASHER": "one that destroys or damages [n -S]\n",
  "TRASHERIES": "TRASHERY, rubbish [n]\n",
  "TRASHERS": "TRASHER, one that destroys or damages [n]\n",
  "TRASHERY": "rubbish [n TRASHERIES]\n",
  "TRASHES": "TRASH, to wreck or vandalize [v]\n",
  "TRASHIER": "TRASHY, rubbishy [adj]\n",
  "TRASHIEST": "TRASHY, rubbishy [adj]\n",
  "TRASHILY": "TRASHY, rubbishy [adv]\n",
  "TRASHINESS": "the state of being trashy [n -ES]\n",
  "TRASHINESSES": "TRASHINESS, the state of being trashy [n]\n",
  "TRASHING": "TRASH, to wreck or vandalize [v]\n",
  "TRASHMAN": "a person who removes garbage [n TRASHMEN]\n",
  "TRASHMEN": "TRASHMAN, a person who removes garbage [n]\n",
  "TRASHTRIE": "(Scots) trash [n -S]\n",
  "TRASHTRIES": "TRASHTRIE, (Scots) trash [n]\n",
  "TRASHY": "rubbishy [adj TRASHIER, TRASHIEST, TRASHILY]\n",
  "TRASS": "(Dutch) an earthy volcanic tuff used as a hydraulic cement, also TARRAS, TERRAS [n -ES]\n",
  "TRASSES": "TRASS, (Dutch) an earthy volcanic tuff used as a hydraulic cement, also TARRAS, TERRAS [n]\n",
  "TRAT": "(short for) a trattoria, an Italian restaurant, also TRATT [n -S]\n",
  "TRATS": "TRAT, (short for) a trattoria, an Italian restaurant, also TRATT [n]\n",
  "TRATT": "(short for) a trattoria, an Italian restaurant, also TRAT [n -S]\n",
  "TRATTORIA": "(Italian) an Italian restaurant [n TRATTORIE or TRATTORIAS]\n",
  "TRATTORIAS": "TRATTORIA, (Italian) an Italian restaurant [n]\n",
  "TRATTORIE": "TRATTORIA, (Italian) an Italian restaurant [n]\n",
  "TRATTS": "TRATT, (short for) a trattoria, an Italian restaurant, also TRAT [n]\n",
  "TRAUCHLE": "to draggle, also TRACHLE [v TRAUCHLED, TRAUCHLING, TRAUCHLES]\n",
  "TRAUCHLED": "TRAUCHLE, to draggle, also TRACHLE [v]\n",
  "TRAUCHLES": "TRAUCHLE, to draggle, also TRACHLE [v]\n",
  "TRAUCHLING": "TRAUCHLE, to draggle, also TRACHLE [v]\n",
  "TRAUMA": "(Greek) a severe emotional shock [n TRAUMAS or TRAUMATA]\n",
  "TRAUMAS": "TRAUMA, (Greek) a severe emotional shock [n]\n",
  "TRAUMATA": "TRAUMA, (Greek) a severe emotional shock [n]\n",
  "TRAUMATIC": "relating to, resulting from, or causing wounds [adj TRAUMATICALLY]\n",
  "TRAUMATICALLY": "TRAUMATIC, relating to, resulting from, or causing wounds [adv]\n",
  "TRAUMATISATION": "the act of traumatising, also TRAUMATIZATION [n -S]\n",
  "TRAUMATISATIONS": "TRAUMATISATION, the act of traumatising, also TRAUMATIZATION [n]\n",
  "TRAUMATISE": "to inflict a trauma upon, also TRAUMATIZE [v TRAUMATISED, TRAUMATISING, TRAUMATISES]\n",
  "TRAUMATISED": "TRAUMATISE, to inflict a trauma upon, also TRAUMATIZE [v]\n",
  "TRAUMATISES": "TRAUMATISE, to inflict a trauma upon, also TRAUMATIZE [v]\n",
  "TRAUMATISING": "TRAUMATISE, to inflict a trauma upon, also TRAUMATIZE [v]\n",
  "TRAUMATISM": "a condition caused by a wound, shock [n -S]\n",
  "TRAUMATISMS": "TRAUMATISM, a condition caused by a wound, shock [n]\n",
  "TRAUMATIZATION": "the act of traumatizing, also TRAUMATISATION [n -S]\n",
  "TRAUMATIZATIONS": "TRAUMATIZATION, the act of traumatizing, also TRAUMATISATION [n]\n",
  "TRAUMATIZE": "to inflict a trauma upon, also TRAUMATISE [v TRAUMATIZED, TRAUMATIZING, TRAUMATIZES]\n",
  "TRAUMATIZED": "TRAUMATIZE, to inflict a trauma upon, also TRAUMATISE [v]\n",
  "TRAUMATIZES": "TRAUMATIZE, to inflict a trauma upon, also TRAUMATISE [v]\n",
  "TRAUMATIZING": "TRAUMATIZE, to inflict a trauma upon, also TRAUMATISE [v]\n",
  "TRAUMATOLOGICAL": "relating to traumatology, the study of wounds and their effects [adj]\n",
  "TRAUMATOLOGIES": "TRAUMATOLOGY, the study of wounds and their effects [n]\n",
  "TRAUMATOLOGY": "the study of wounds and their effects [n TRAUMATOLOGIES]\n",
  "TRAUMATONASTIES": "TRAUMATONASTY, a nastic movement after wounding [n]\n",
  "TRAUMATONASTY": "a nastic movement after wounding [n TRAUMATONASTIES]\n",
  "TRAVAIL": "to toil [v -ED, -ING, -S]\n",
  "TRAVAILED": "TRAVAIL, to toil [v]\n",
  "TRAVAILING": "TRAVAIL, to toil [v]\n",
  "TRAVAILS": "TRAVAIL, to toil [v]\n",
  "TRAVE": "a crossbeam or space between crossbeams [n -S]\n",
  "TRAVEL": "to go from one place to another [v TRAVELED or TRAVELLED, TRAVELING or TRAVELLING, TRAVELS]\n",
  "TRAVELATOR": "a moving footpath for pedestrians, also TRAVOLATOR [n -S]\n",
  "TRAVELATORS": "TRAVELATOR, a moving footpath for pedestrians, also TRAVOLATOR [n]\n",
  "TRAVELED": "TRAVEL, to go from one place to another [v]\n",
  "TRAVELER": "one who travels, also TRAVELLER [n -S]\n",
  "TRAVELERS": "TRAVELER, one who travels, also TRAVELLER [n]\n",
  "TRAVELING": "the act of travel [n -S]\n",
  "TRAVELINGS": "TRAVELING, the act of travel [n]\n",
  "TRAVELLED": "TRAVEL, to go from one place to another [v]\n",
  "TRAVELLER": "one who travels, also TRAVELER [n -S]\n",
  "TRAVELLERS": "TRAVELLER, one who travels, also TRAVELER [n]\n",
  "TRAVELLING": "the act of travelling [n -S]\n",
  "TRAVELLINGS": "TRAVELLING, the act of travelling [n]\n",
  "TRAVELOG": "a film, talk etc. on travel, also TRAVELOGUE [n -S]\n",
  "TRAVELOGS": "TRAVELOG, a film, talk etc. on travel, also TRAVELOGUE [n]\n",
  "TRAVELOGUE": "a film, talk etc. on travel, also TRAVELOG [n -S]\n",
  "TRAVELOGUES": "TRAVELOGUE, a film, talk etc. on travel, also TRAVELOG [n]\n",
  "TRAVELS": "TRAVEL, to go from one place to another [v]\n",
  "TRAVERSABLE": "that can be traversed [adj]\n",
  "TRAVERSAL": "the action of traversing [n -S]\n",
  "TRAVERSALS": "TRAVERSAL, the action of traversing [n]\n",
  "TRAVERSE": "to cross or pass through [v TRAVERSED, TRAVERSING, TRAVERSES]\n",
  "TRAVERSED": "TRAVERSE, to cross or pass through [v]\n",
  "TRAVERSER": "one who traverses [n -S]\n",
  "TRAVERSERS": "TRAVERSER, one who traverses [n]\n",
  "TRAVERSES": "TRAVERSE, to cross or pass through [v]\n",
  "TRAVERSING": "the act of traversing [n -S]\n",
  "TRAVERSINGS": "TRAVERSING, the act of traversing [n]\n",
  "TRAVERTIN": "(Italian) a pale limestone deposited from solution, e.g. from springs, also TRAVERTINE [n -S]\n",
  "TRAVERTINE": "(Italian) a pale limestone deposited from solution, e.g. from springs, also TRAVERTIN [n -S]\n",
  "TRAVERTINES": "TRAVERTINE, (Italian) a pale limestone deposited from solution, e.g. from springs, also TRAVERTIN [n]\n",
  "TRAVERTINS": "TRAVERTIN, (Italian) a pale limestone deposited from solution, e.g. from springs, also TRAVERTINE [n]\n",
  "TRAVES": "TRAVE, a crossbeam or space between crossbeams [n]\n",
  "TRAVESTIED": "TRAVESTY, to parody [v]\n",
  "TRAVESTIES": "TRAVESTY, to parody [v]\n",
  "TRAVESTY": "to parody [v TRAVESTIED, TRAVESTYING, TRAVESTIES]\n",
  "TRAVESTYING": "TRAVESTY, to parody [v]\n",
  "TRAVIS": "a stall partition; a stall, also TREVIS, TREVISS [n -ES]\n",
  "TRAVISES": "TRAVIS, a stall partition; a stall, also TREVIS, TREVISS [n]\n",
  "TRAVOIS": "a kind of North American Indian sledge, also TRAVOISE [n -ES]\n",
  "TRAVOISE": "a type of sled, also TRAVOIS [n -S]\n",
  "TRAVOISES": "TRAVOIS, a kind of North American Indian sledge, also TRAVOISE [n]\n",
  "TRAVOLATOR": "a moving footpath for pedestrians, also TRAVELATOR [n -S]\n",
  "TRAVOLATORS": "TRAVOLATOR, a moving footpath for pedestrians, also TRAVELATOR [n]\n",
  "TRAWL": "to fish by dragging a net along the bottom of the sea [v -ED, -ING, -S]\n",
  "TRAWLED": "TRAWL, to fish by dragging a net along the bottom of the sea [v]\n",
  "TRAWLER": "a vessel used for trawling [n -S]\n",
  "TRAWLERMAN": "one who works in a trawler [n TRAWLERMEN]\n",
  "TRAWLERMEN": "TRAWLERMAN, one who works in a trawler [n]\n",
  "TRAWLERS": "TRAWLER, a vessel used for trawling [n]\n",
  "TRAWLEY": "a small truck for transporting material [n -S]\n",
  "TRAWLEYS": "TRAWLEY, a small truck for transporting material [n]\n",
  "TRAWLING": "the act of trawling [n -S]\n",
  "TRAWLINGS": "TRAWLING, the act of trawling [n]\n",
  "TRAWLNET": "a large net used in trawling [n -S]\n",
  "TRAWLNETS": "TRAWLNET, a large net used in trawling [n]\n",
  "TRAWLS": "TRAWL, to fish by dragging a net along the bottom of the sea [v]\n",
  "TRAY": "the three in cards or dice, also TREY, TREZ [n -S]\n",
  "TRAYBAKE": "a cake, pie, confection, etc. baked in a shallow rectangular container before division into portions [n -S]\n",
  "TRAYBAKES": "TRAYBAKE, a cake, pie, confection, etc. baked in a shallow rectangular container before division into portions [n]\n",
  "TRAYBIT": "(Australian slang) a threepenny bit, also TREYBIT [n -S]\n",
  "TRAYBITS": "TRAYBIT, (Australian slang) a threepenny bit, also TREYBIT [n]\n",
  "TRAYCLOTH": "a cloth for covering a tray [n -S]\n",
  "TRAYCLOTHS": "TRAYCLOTH, a cloth for covering a tray [n]\n",
  "TRAYF": "(Yiddish) not prepared according to Jewish law, also TEREFA, TEREFAH, TREF, TREFA, TREFAH, TREIF, TREIFA, TREYF, TREYFA [adj]\n",
  "TRAYFUL": "as much as a tray can hold [n -S]\n",
  "TRAYFULS": "TRAYFUL, as much as a tray can hold [n]\n",
  "TRAYMOBILE": "(Australian) a small table on casters used for conveying food, drink, etc. [n -S]\n",
  "TRAYMOBILES": "TRAYMOBILE, (Australian) a small table on casters used for conveying food, drink, etc. [n]\n",
  "TRAYNE": "(Spenser) to train, to undergo instruction [v TRAYNED, TRAYNING, TRAYNES]\n",
  "TRAYNED": "TRAYNE, (Spenser) to train, to undergo instruction [v]\n",
  "TRAYNES": "TRAYNE, (Spenser) to train, to undergo instruction [v]\n",
  "TRAYNING": "TRAYNE, (Spenser) to train, to undergo instruction [v]\n",
  "TRAYS": "TRAY, the three in cards or dice, also TREY, TREZ [n]\n",
  "TRAZODONE": "a drug used to treat depression [n -S]\n",
  "TRAZODONES": "TRAZODONE, a drug used to treat depression [n]\n",
  "TREACHER": "(obsolete) a traitor; a deceiver, also TREACHERER, TREACHOUR [n -S]\n",
  "TREACHERER": "(obsolete) a traitor; a deceiver, also TREACHER, TREACHOUR [n -S]\n",
  "TREACHERERS": "TREACHERER, (obsolete) a traitor; a deceiver, also TREACHER, TREACHOUR [n]\n",
  "TREACHERIES": "TREACHERY, betrayal, readiness to betray [n]\n",
  "TREACHEROUS": "characterized by treachery [adj TREACHEROUSLY]\n",
  "TREACHEROUSLY": "TREACHEROUS, characterized by treachery [adv]\n",
  "TREACHEROUSNESS": "the state of being treacherous [n]\n",
  "TREACHERS": "TREACHER, (obsolete) a traitor; a deceiver, also TREACHERER, TREACHOUR [n]\n",
  "TREACHERY": "betrayal, readiness to betray [n TREACHERIES]\n",
  "TREACHETOUR": "(Spenser) a traitor, a deceiver [n -S]\n",
  "TREACHETOURS": "TREACHETOUR, (Spenser) a traitor, a deceiver [n]\n",
  "TREACHOUR": "(obsolete) a traitor, also TREACHER, TREACHERER [n -S]\n",
  "TREACHOURS": "TREACHOUR, (obsolete) a traitor, also TREACHER, TREACHERER [n]\n",
  "TREACLE": "to smear with molasses [v TREACLED, TREACLING, TREACLES]\n",
  "TREACLED": "TREACLE, to smear with molasses [v]\n",
  "TREACLES": "TREACLE, to smear with molasses [v]\n",
  "TREACLIER": "TREACLY, thick and sweet like treacle [adj]\n",
  "TREACLIEST": "TREACLY, thick and sweet like treacle [adj]\n",
  "TREACLINESS": "the state of being treacly [n -ES]\n",
  "TREACLINESSES": "TREACLINESS, the state of being treacly [n]\n",
  "TREACLING": "TREACLE, to smear with molasses [v]\n",
  "TREACLY": "thick and sweet like treacle [adj TREACLIER, TREACLIEST]\n",
  "TREAD": "to walk on, over, or along [v TROD or (obsolete) TRODE, TRODDEN, TREADING, TREADS] / to add tread to a tyre [v TREADED, TREADING, TREADS]\n",
  "TREADED": "TREAD, to walk on, over, or along [v]\n",
  "TREADER": "one who treads [n -S]\n",
  "TREADERS": "TREADER, one who treads [n]\n",
  "TREADING": "the act of treading [n -S]\n",
  "TREADINGS": "TREADING, the act of treading [n]\n",
  "TREADLE": "to work by a foot pedal, also TREDDLE [v TREADLED, TREADLING, TREADLES]\n",
  "TREADLED": "TREADLE, to work by a foot pedal, also TREDDLE [v]\n",
  "TREADLER": "one who works a treadle [n -S]\n",
  "TREADLERS": "TREADLER, one who works a treadle [n]\n",
  "TREADLES": "TREADLE, to work by a foot pedal, also TREDDLE [v]\n",
  "TREADLESS": "without tread, e.g. of a tyre [adj]\n",
  "TREADLING": "the act of treadling [n -S]\n",
  "TREADLINGS": "TREADLING, the act of treadling [n]\n",
  "TREADMILL": "a machine with a continuously moving surface of adjustable speed used for exercising on by running or walking [n -S]\n",
  "TREADMILLS": "TREADMILL, a machine with a continuously moving surface of adjustable speed used for exercising on by running or walking [n]\n",
  "TREADS": "TREAD, to walk on, over, or along [v]\n",
  "TREADWHEEL": "a wheel or cylinder turned by treading outside or inside; a treadmill [n -S]\n",
  "TREADWHEELS": "TREADWHEEL, a wheel or cylinder turned by treading outside or inside; a treadmill [n]\n",
  "TREAGUE": "(Spenser) a truce [n -S]\n",
  "TREAGUES": "TREAGUE, (Spenser) a truce [n]\n",
  "TREASON": "betrayal of one's country [n -S]\n",
  "TREASONABLE": "of the nature of treason [adj TREASONABLY]\n",
  "TREASONABLENESS": "the state of being treasonable [n]\n",
  "TREASONABLY": "TREASONABLE, of the nature of treason [adv]\n",
  "TREASONOUS": "treasonable [adj]\n",
  "TREASONS": "TREASON, betrayal of one's country [n]\n",
  "TREASURABLE": "worthy of being treasured [adj]\n",
  "TREASURE": "to value highly [v TREASURED, TREASURING, TREASURES]\n",
  "TREASURED": "TREASURE, to value highly [v]\n",
  "TREASURELESS": "without treasure [adj]\n",
  "TREASURER": "a person who is in charge of a treasure or treasury [n -S]\n",
  "TREASURERS": "TREASURER, a person who is in charge of a treasure or treasury [n]\n",
  "TREASURERSHIP": "the office of treasurer [n -S]\n",
  "TREASURERSHIPS": "TREASURERSHIP, the office of treasurer [n]\n",
  "TREASURES": "TREASURE, to value highly [v]\n",
  "TREASURIES": "TREASURY, a place where treasures are deposited [n]\n",
  "TREASURING": "TREASURE, to value highly [v]\n",
  "TREASURY": "a place where treasures are deposited [n TREASURIES]\n",
  "TREAT": "to deal with [v -ED, -ING, -S]\n",
  "TREATABILITIES": "TREATABILITY, the state of being treatable [n]\n",
  "TREATABILITY": "the state of being treatable [n TREATABILITIES]\n",
  "TREATABLE": "that can be treated [adj]\n",
  "TREATED": "TREAT, to deal with [v]\n",
  "TREATER": "one who treats [n -S]\n",
  "TREATERS": "TREATER, one who treats [n]\n",
  "TREATIES": "TREATY, a formal agreement between countries [n]\n",
  "TREATING": "the act of treating [n -S]\n",
  "TREATINGS": "TREATING, the act of treating [n]\n",
  "TREATISE": "a formal and systematic written account of a subject [n -S]\n",
  "TREATISES": "TREATISE, a formal and systematic written account of a subject [n]\n",
  "TREATMENT": "the act or manner of treating [n -S]\n",
  "TREATMENTS": "TREATMENT, the act or manner of treating [n]\n",
  "TREATS": "TREAT, to deal with [v]\n",
  "TREATY": "a formal agreement between countries [n TREATIES]\n",
  "TREATYLESS": "without a treaty [adj]\n",
  "TREBBIANO": "a grape used to make wine [n -S]\n",
  "TREBBIANOS": "TREBBIANO, a grape used to make wine [n]\n",
  "TREBLE": "threefold [adj TREBLY] / to triple [v TREBLED, TREBLING, TREBLES]\n",
  "TREBLED": "TREBLE, to triple [v]\n",
  "TREBLENESS": "the state of being treble [n -ES]\n",
  "TREBLENESSES": "TREBLENESS, the state of being treble [n]\n",
  "TREBLES": "TREBLE, to triple [v]\n",
  "TREBLIER": "TREBLY, of a sound, having much treble [adj]\n",
  "TREBLIEST": "TREBLY, of a sound, having much treble [adj]\n",
  "TREBLING": "the act of multiplying by three [n -S]\n",
  "TREBLINGS": "TREBLING, the act of multiplying by three [n]\n",
  "TREBLY": "of a sound, having much treble [adj TREBLIER, TREBLIEST]\n",
  "TREBUCHET": "(historical) a medieval siege engine for launching stones, also TREBUCKET [n -S]\n",
  "TREBUCHETS": "TREBUCHET, (historical) a medieval siege engine for launching stones, also TREBUCKET [n]\n",
  "TREBUCKET": "a medieval siege engine for launching stones, also TREBUCHET [n -S]\n",
  "TREBUCKETS": "TREBUCKET, a medieval siege engine for launching stones, also TREBUCHET [n]\n",
  "TRECENTIST": "a writer or artist of the thirteenth century [n -S]\n",
  "TRECENTISTS": "TRECENTIST, a writer or artist of the thirteenth century [n]\n",
  "TRECENTO": "(Italian) the 14th century, esp. with reference to Italian art, literature, etc. [n -S]\n",
  "TRECENTOS": "TRECENTO, (Italian) the 14th century, esp. with reference to Italian art, literature, etc. [n]\n",
  "TRECK": "to go on a journey, also TREK [v -ED, -ING, -S]\n",
  "TRECKED": "TRECK, to go on a journey, also TREK [v]\n",
  "TRECKING": "TRECK, to go on a journey, also TREK [v]\n",
  "TRECKS": "TRECK, to go on a journey, also TREK [v]\n",
  "TREDDLE": "to work by a foot pedal, also TREADLE [v TREDDLED, TREDDLING, TREDDLES]\n",
  "TREDDLED": "TREDDLE, to work by a foot pedal, also TREADLE [v]\n",
  "TREDDLES": "TREDDLE, to work by a foot pedal, also TREADLE [v]\n",
  "TREDDLING": "TREDDLE, to work by a foot pedal, also TREADLE [v]\n",
  "TREDECILLION": "ten to the power of 42 [n -S]\n",
  "TREDECILLIONS": "TREDECILLION, ten to the power of 42 [n]\n",
  "TREDILLE": "a card game for three, also TREDRILLE [n -S]\n",
  "TREDILLES": "TREDILLE, a card game for three, also TREDRILLE [n]\n",
  "TREDRILLE": "a card game for three, also TREDILLE [n -S]\n",
  "TREDRILLES": "TREDRILLE, a card game for three, also TREDILLE [n]\n",
  "TREE": "a tall, woody plant [n -S] / to drive up a tree [v TREED, TREEING, TREES]\n",
  "TREED": "TREE, to drive up a tree [v]\n",
  "TREEHOPPER": "a kind of leaping insect [n -S]\n",
  "TREEHOPPERS": "TREEHOPPER, a kind of leaping insect [n]\n",
  "TREEHOUSE": "a house built in a tree [n -S]\n",
  "TREEHOUSES": "TREEHOUSE, a house built in a tree [n]\n",
  "TREEING": "TREE, to drive up a tree [v]\n",
  "TREELAWN": "the strip of lawn between the street and pavement [n -S]\n",
  "TREELAWNS": "TREELAWN, the strip of lawn between the street and pavement [n]\n",
  "TREELESS": "without trees [adj]\n",
  "TREELESSNESS": "the state of being treeless [n -ES]\n",
  "TREELESSNESSES": "TREELESSNESS, the state of being treeless [n]\n",
  "TREELIKE": "like a tree [adj]\n",
  "TREELINE": "the line marking the altitude above which trees will not grow [n -S]\n",
  "TREELINES": "TREELINE, the line marking the altitude above which trees will not grow [n]\n",
  "TREEN": "cups, dishes etc. made of wood, also TREENWARE [n -S]\n",
  "TREENAIL": "a wooden peg used to fasten timber, also TRENAIL, TRUNNEL [n -S]\n",
  "TREENAILS": "TREENAIL, a wooden peg used to fasten timber, also TRENAIL, TRUNNEL [n]\n",
  "TREENS": "TREEN, cups, dishes etc. made of wood, also TREENWARE [n]\n",
  "TREENWARE": "cups, dishes etc. made of wood, also TREEN [n -S]\n",
  "TREENWARES": "TREENWARE, cups, dishes etc. made of wood, also TREEN [n]\n",
  "TREES": "TREE, to drive up a tree [v]\n",
  "TREESHIP": "existence as a tree [n -S]\n",
  "TREESHIPS": "TREESHIP, existence as a tree [n]\n",
  "TREETOP": "the top of a tree [n -S]\n",
  "TREETOPS": "TREETOP, the top of a tree [n]\n",
  "TREEWARE": "printed materials as opposed to electronic text [n -S]\n",
  "TREEWARES": "TREEWARE, printed materials as opposed to electronic text [n]\n",
  "TREEWAX": "a wax secreted by a certain insect, used as a floor wax, aka Chinese wax [n -ES]\n",
  "TREEWAXES": "TREEWAX, a wax secreted by a certain insect, used as a floor wax, aka Chinese wax [n]\n",
  "TREF": "(Hebrew) in the Jewish religion, forbidden as food, not kosher, also TEREFA, TEREFAH, TRAYF, TREFA, TREFAH, TREIF, TREIFA, TREYF, TREYFA [adj]\n",
  "TREFA": "(Hebrew) in the Jewish religion, forbidden as food, not kosher, also TEREFA, TEREFAH, TRAYF, TREF, TREFAH, TREIF, TREIFA, TREYF, TREYFA [adj]\n",
  "TREFAH": "(Hebrew) in the Jewish religion, forbidden as food, not kosher, also TEREFA, TEREFAH, TRAYF, TREF, TREFA, TREIF, TREIFA, TREYF, TREYFA [adj]\n",
  "TREFOIL": "a plant having three-lobed leaves, also TRIFOLY [n -S]\n",
  "TREFOILED": "adorned with trefoils [adj]\n",
  "TREFOILS": "TREFOIL, a plant having three-lobed leaves, also TRIFOLY [n]\n",
  "TREGETOUR": "(archaic) a juggling magician [n -S]\n",
  "TREGETOURS": "TREGETOUR, (archaic) a juggling magician [n]\n",
  "TREGGINGS": "thick close-fitting leggings [n]\n",
  "TREHALA": "(Turkish) a sweet substance obtained from the cocoons of a Middle Eastern weevil and used as a sugar substitute [n -S]\n",
  "TREHALAS": "TREHALA, (Turkish) a sweet substance obtained from the cocoons of a Middle Eastern weevil and used as a sugar substitute [n]\n",
  "TREHALOSE": "a disaccharide originally obtained from trehala and found in fungi, yeasts, etc. [n -S]\n",
  "TREHALOSES": "TREHALOSE, a disaccharide originally obtained from trehala and found in fungi, yeasts, etc. [n]\n",
  "TREIF": "(Yiddish) in the Jewish religion, forbidden as food, not kosher, also TEREFA, TEREFAH, TRAYF, TREF, TREFA, TREFAH, TREIFA, TREYF, TREYFA [adj]\n",
  "TREIFA": "(Yiddish) in the Jewish religion, forbidden as food, not kosher, also TEREFA, TEREFAH, TRAYF, TREF, TREFA, TREFAH, TREIF, TREYF, TREYFA [adj]\n",
  "TREILLAGE": "(French) trelliswork [n -S]\n",
  "TREILLAGED": "fitted with treillage, trelliswork [adj]\n",
  "TREILLAGES": "TREILLAGE, (French) trelliswork [n]\n",
  "TREILLE": "(French) a trellis [n -S]\n",
  "TREILLES": "TREILLE, (French) a trellis [n]\n",
  "TREK": "to go on a journey, also TRECK [v TREKKED, TREKKING, TREKS]\n",
  "TREKKED": "TREK, to go on a journey, also TRECK [v]\n",
  "TREKKER": "one who treks [n -S]\n",
  "TREKKERS": "TREKKER, one who treks [n]\n",
  "TREKKING": "as in pony trekking, an excursion with a pony [n -S]\n",
  "TREKKINGS": "TREKKING, as in pony trekking, an excursion with a pony [n]\n",
  "TREKS": "TREK, to go on a journey, also TRECK [v]\n",
  "TREKSCHUIT": "(Dutch) a towed canalboat [n -S]\n",
  "TREKSCHUITS": "TREKSCHUIT, (Dutch) a towed canalboat [n]\n",
  "TRELLIS": "to supply with a frame for climbing plants [v -ED, -ING, -ES]\n",
  "TRELLISED": "TRELLIS, to supply with a frame for climbing plants [v]\n",
  "TRELLISES": "TRELLIS, to supply with a frame for climbing plants [v]\n",
  "TRELLISING": "TRELLIS, to supply with a frame for climbing plants [v]\n",
  "TRELLISWORK": "latticework [n -S]\n",
  "TRELLISWORKS": "TRELLISWORK, latticework [n]\n",
  "TREM": "an electric guitar lever for producing a tremolo [n -S]\n",
  "TREMA": "(Greek) a diaeresis, two dots placed as a mark of separate pronunciation over a vowel-letter [n -S]\n",
  "TREMAS": "TREMA, (Greek) a diaeresis, two dots placed as a mark of separate pronunciation over a vowel-letter [n]\n",
  "TREMATIC": "of the gill-slits [adj]\n",
  "TREMATODE": "a kind of parasitic flatworm, also TREMATOID [n -S]\n",
  "TREMATODES": "TREMATODE, a kind of parasitic flatworm, also TREMATOID [n]\n",
  "TREMATOID": "a kind of parasitic flatworm, also TREMATODE [n -S]\n",
  "TREMATOIDS": "TREMATOID, a kind of parasitic flatworm, also TREMATODE [n]\n",
  "TREMBLANT": "in jewellery, having the stones set on spring, to give a trembling effect [adj]\n",
  "TREMBLE": "to shake involuntarily [v TREMBLED, TREMBLING, TREMBLES]\n",
  "TREMBLED": "TREMBLE, to shake involuntarily [v]\n",
  "TREMBLEMENT": "the act of trembling [n -S]\n",
  "TREMBLEMENTS": "TREMBLEMENT, the act of trembling [n]\n",
  "TREMBLER": "a West Indian bird of the family Mimidae [n -S]\n",
  "TREMBLERS": "TREMBLER, a West Indian bird of the family Mimidae [n]\n",
  "TREMBLES": "TREMBLE, to shake involuntarily [v]\n",
  "TREMBLIER": "TREMBLY, tremulous [adj]\n",
  "TREMBLIEST": "TREMBLY, tremulous [adj]\n",
  "TREMBLING": "shaking involuntarily [adj TREMBLINGLY] / the act of trembling [n -S]\n",
  "TREMBLINGLY": "TREMBLING, shaking involuntarily [adv]\n",
  "TREMBLINGS": "TREMBLING, the act of trembling [n]\n",
  "TREMBLOR": "an earth tremor, also TEMBLOR [n -S]\n",
  "TREMBLORS": "TREMBLOR, an earth tremor, also TEMBLOR [n]\n",
  "TREMBLY": "tremulous [adj TREMBLIER, TREMBLIEST]\n",
  "TREMENDOUS": "awe-inspiring; huge [adj TREMENDOUSLY]\n",
  "TREMENDOUSLY": "TREMENDOUS, awe-inspiring; huge [adv]\n",
  "TREMENDOUSNESS": "the state of being tremendous [n]\n",
  "TREMIE": "(French) a hopper-like device for laying concrete underwater [n -S]\n",
  "TREMIES": "TREMIE, (French) a hopper-like device for laying concrete underwater [n]\n",
  "TREMOLANDI": "TREMOLANDO, (Italian) a vibrating, quavering musical effect [n]\n",
  "TREMOLANDO": "(Italian) a vibrating, quavering musical effect [n TREMOLANDOS or TREMOLANDI]\n",
  "TREMOLANDOS": "TREMOLANDO, (Italian) a vibrating, quavering musical effect [n]\n",
  "TREMOLANT": "(Italian) a vibrating, quavering musical effect, also TREMOLO [n -S]\n",
  "TREMOLANTS": "TREMOLANT, (Italian) a vibrating, quavering musical effect, also TREMOLO [n]\n",
  "TREMOLITE": "a white variety of amphibole, or hornblende, occurring in long, bladelike crystals, and coarsely fibrous masses [n -S]\n",
  "TREMOLITES": "TREMOLITE, a white variety of amphibole, or hornblende, occurring in long, bladelike crystals, and coarsely fibrous masses [n]\n",
  "TREMOLITIC": "of or like tremolite, a white variety of amphibole [adj]\n",
  "TREMOLO": "(Italian) a vibrating, quavering musical effect, also TREMOLANT [n -S]\n",
  "TREMOLOS": "TREMOLO, (Italian) a vibrating, quavering musical effect, also TREMOLANT [n]\n",
  "TREMOR": "to quiver, shake [v -ED, -ING, -S]\n",
  "TREMORED": "TREMOR, to quiver, shake [v]\n",
  "TREMORING": "TREMOR, to quiver, shake [v]\n",
  "TREMORLESS": "without a tremor [adj]\n",
  "TREMOROUS": "given to tremors [adj]\n",
  "TREMORS": "TREMOR, to quiver, shake [v]\n",
  "TREMS": "TREM, an electric guitar lever for producing a tremolo [n]\n",
  "TREMULANT": "tremulous [adj] / a device in an organ or electronic instrument for producing a tremolo effect [n -S]\n",
  "TREMULANTS": "TREMULANT, a device in an organ or electronic instrument for producing a tremolo effect [n]\n",
  "TREMULATE": "to sound with a tremolo effect [v TREMULATED, TREMULATING, TREMULATES]\n",
  "TREMULATED": "TREMULATE, to sound with a tremolo effect [v]\n",
  "TREMULATES": "TREMULATE, to sound with a tremolo effect [v]\n",
  "TREMULATING": "TREMULATE, to sound with a tremolo effect [v]\n",
  "TREMULOUS": "trembling; quivering [adj TREMULOUSLY]\n",
  "TREMULOUSLY": "TREMULOUS, trembling; quivering [adv]\n",
  "TREMULOUSNESS": "the state of being tremulous [n -ES]\n",
  "TREMULOUSNESSES": "TREMULOUSNESS, the state of being tremulous [n]\n",
  "TRENAIL": "a wooden peg used to fasten timber, also TREENAIL, TRUNNEL [n -S]\n",
  "TRENAILS": "TRENAIL, a wooden peg used to fasten timber, also TREENAIL, TRUNNEL [n]\n",
  "TRENCH": "to dig a long, narrow ditch [v -ED, -ING, -ES]\n",
  "TRENCHANCIES": "TRENCHANCY, the quality of being trenchant [n]\n",
  "TRENCHANCY": "the quality of being trenchant [n TRENCHANCIES]\n",
  "TRENCHAND": "(Spenser) trenchant [adj]\n",
  "TRENCHANT": "incisive, vigorous, also TRENCHAND [adj TRENCHANTLY]\n",
  "TRENCHANTLY": "TRENCHANT, incisive, vigorous, also TRENCHAND [adv]\n",
  "TRENCHARD": "at St Andrews University, a trencher cap [n -S]\n",
  "TRENCHARDS": "TRENCHARD, at St Andrews University, a trencher cap [n]\n",
  "TRENCHED": "TRENCH, to dig a long, narrow ditch [v]\n",
  "TRENCHER": "a wooden platter for serving food [n -S]\n",
  "TRENCHERMAN": "a hearty eater [n TRENCHERMEN]\n",
  "TRENCHERMEN": "TRENCHERMAN, a hearty eater [n]\n",
  "TRENCHERS": "TRENCHER, a wooden platter for serving food [n]\n",
  "TRENCHES": "TRENCH, to dig a long, narrow ditch [v]\n",
  "TRENCHING": "TRENCH, to dig a long, narrow ditch [v]\n",
  "TREND": "to have a tendency for [v -ED, -ING, -S]\n",
  "TRENDED": "TREND, to have a tendency for [v]\n",
  "TRENDIER": "TRENDY, fashionable [adj]\n",
  "TRENDIES": "TRENDY, one who is trendy [n]\n",
  "TRENDIEST": "TRENDY, fashionable [adj]\n",
  "TRENDIFIED": "TRENDIFY, to make something trendy [v]\n",
  "TRENDIFIES": "TRENDIFY, to make something trendy [v]\n",
  "TRENDIFY": "to make something trendy [v TRENDIFIED, TRENDIFYING, TRENDIFIES]\n",
  "TRENDIFYING": "TRENDIFY, to make something trendy [v]\n",
  "TRENDILY": "TRENDY, fashionable [adv]\n",
  "TRENDINESS": "the state of being trendy [n -ES]\n",
  "TRENDINESSES": "TRENDINESS, the state of being trendy [n]\n",
  "TRENDING": "TREND, to have a tendency for [v]\n",
  "TRENDOID": "a trendy person [n -S]\n",
  "TRENDOIDS": "TRENDOID, a trendy person [n]\n",
  "TRENDS": "TREND, to have a tendency for [v]\n",
  "TRENDSETTER": "one that sets a trend [n -S]\n",
  "TRENDSETTERS": "TRENDSETTER, one that sets a trend [n]\n",
  "TRENDSETTING": "the setting of a trend [n -S]\n",
  "TRENDSETTINGS": "TRENDSETTING, the setting of a trend [n]\n",
  "TRENDY": "fashionable [adj TRENDIER, TRENDIEST, TRENDILY] / one who is trendy [n TRENDIES]\n",
  "TRENDYISM": "being trendy [n -S]\n",
  "TRENDYISMS": "TRENDYISM, being trendy [n]\n",
  "TRENISE": "(French) the fourth movement of a quadrille [n -S]\n",
  "TRENISES": "TRENISE, (French) the fourth movement of a quadrille [n]\n",
  "TRENTAL": "a series of thirty requiem masses [n -S]\n",
  "TRENTALS": "TRENTAL, a series of thirty requiem masses [n]\n",
  "TREPAN": "to cut holes in the skull with a surgical saw, also TRAPAN, TREPHINE [v TREPANNED, TREPANNING, TREPANS]\n",
  "TREPANATION": "a surgical cutting open of the skull, also TREPHINATION [n -S]\n",
  "TREPANATIONS": "TREPANATION, a surgical cutting open of the skull, also TREPHINATION [n]\n",
  "TREPANG": "(Malay) a sea cucumber eaten as a Chinese or Japanese delicacy [n -S]\n",
  "TREPANGS": "TREPANG, (Malay) a sea cucumber eaten as a Chinese or Japanese delicacy [n]\n",
  "TREPANNED": "TREPAN, to cut holes in the skull with a surgical saw, also TRAPAN, TREPHINE [v]\n",
  "TREPANNER": "one who trepans [n -S]\n",
  "TREPANNERS": "TREPANNER, one who trepans [n]\n",
  "TREPANNING": "a surgical cutting open of the skull [n -S]\n",
  "TREPANNINGS": "TREPANNING, a surgical cutting open of the skull [n]\n",
  "TREPANS": "TREPAN, to cut holes in the skull with a surgical saw, also TRAPAN, TREPHINE [v]\n",
  "TREPHINATION": "a surgical cutting open of the skull, also TREPANATION [n -S]\n",
  "TREPHINATIONS": "TREPHINATION, a surgical cutting open of the skull, also TREPANATION [n]\n",
  "TREPHINE": "to cut holes in the skull with a surgical saw, also TREPAN, TRAPAN [v TREPHINED, TREPHINING, TREPHINES]\n",
  "TREPHINED": "TREPHINE, to cut holes in the skull with a surgical saw, also TREPAN, TRAPAN [v]\n",
  "TREPHINER": "a surgeon who uses a trephine [n -S]\n",
  "TREPHINERS": "TREPHINER, a surgeon who uses a trephine [n]\n",
  "TREPHINES": "TREPHINE, to cut holes in the skull with a surgical saw, also TREPAN, TRAPAN [v]\n",
  "TREPHINING": "a surgical cutting open of the skull [n -S]\n",
  "TREPHININGS": "TREPHINING, a surgical cutting open of the skull [n]\n",
  "TREPID": "quaking [adj]\n",
  "TREPIDANT": "in a state of alarmed agitation [adj]\n",
  "TREPIDATION": "timorous uncertain agitation [n -S]\n",
  "TREPIDATIONS": "TREPIDATION, timorous uncertain agitation [n]\n",
  "TREPIDATORY": "causing trepidation, trembling; alarmed agitation [adj]\n",
  "TREPONEMA": "a kind of bacterium, a spirochaete, that causes syphilis, also TREPONEME [n TREPONEMAS or TREPONEMATA]\n",
  "TREPONEMAL": "of or like a treponema, a kind of bacterium [adj]\n",
  "TREPONEMAS": "TREPONEMA, a kind of bacterium, a spirochaete, that causes syphilis, also TREPONEME [n]\n",
  "TREPONEMATA": "TREPONEMA, a kind of bacterium, a spirochaete, that causes syphilis, also TREPONEME [n]\n",
  "TREPONEMATOSES": "TREPONEMATOSIS, infection with or disease caused by treponemata [n]\n",
  "TREPONEMATOSIS": "infection with or disease caused by treponemata [n TREPONEMATOSES]\n",
  "TREPONEMATOUS": "of or like a treponema, a kind of bacterium, a spirochaete, that causes syphilis [adj]\n",
  "TREPONEME": "a kind of bacterium, a spirochaete, that causes syphilis, also TREPONEMA [n -S]\n",
  "TREPONEMES": "TREPONEME, a kind of bacterium, a spirochaete, that causes syphilis, also TREPONEMA [n]\n",
  "TRES": "(French) very [adv]\n",
  "TRESPASS": "to enter unlawfully on the premises of another [v -ED, -ING, -ES]\n",
  "TRESPASSED": "TRESPASS, to enter unlawfully on the premises of another [v]\n",
  "TRESPASSER": "one who trespasses [n -S]\n",
  "TRESPASSERS": "TRESPASSER, one who trespasses [n]\n",
  "TRESPASSES": "TRESPASS, to enter unlawfully on the premises of another [v]\n",
  "TRESPASSING": "TRESPASS, to enter unlawfully on the premises of another [v]\n",
  "TRESS": "to form into long locks of hair [v -ED, -ING, -ES]\n",
  "TRESSED": "TRESS, to form into long locks of hair [v]\n",
  "TRESSEL": "a support consisting of a horizontal beam and sloping legs, also TREST, TRESTLE [n -S]\n",
  "TRESSELS": "TRESSEL, a support consisting of a horizontal beam and sloping legs, also TREST, TRESTLE [n]\n",
  "TRESSES": "TRESS, to form into long locks of hair [v]\n",
  "TRESSIER": "TRESSY, abounding in tresses [adj]\n",
  "TRESSIEST": "TRESSY, abounding in tresses [adj]\n",
  "TRESSING": "TRESS, to form into long locks of hair [v]\n",
  "TRESSOUR": "a type of heraldic design, like plaited lilies, also TRESSURE [n -S]\n",
  "TRESSOURS": "TRESSOUR, a type of heraldic design, like plaited lilies, also TRESSURE [n]\n",
  "TRESSURE": "a type of heraldic design, like plaited lilies, also TRESSOUR [n -S]\n",
  "TRESSURED": "provided or bound with a tressure [adj]\n",
  "TRESSURES": "TRESSURE, a type of heraldic design, like plaited lilies, also TRESSOUR [n]\n",
  "TRESSY": "abounding in tresses [adj TRESSIER, TRESSIEST]\n",
  "TREST": "(dialect) a trestle, also TRESSEL [n -S]\n",
  "TRESTLE": "a framework for supporting a bridge, also TRESSEL [n -S]\n",
  "TRESTLES": "TRESTLE, a framework for supporting a bridge, also TRESSEL [n]\n",
  "TRESTLETREE": "either of a pair of fore-and-aft timbers fixed horizontally on opposite sides of a lower masthead to support an upper mast [n -S]\n",
  "TRESTLETREES": "TRESTLETREE, either of a pair of fore-and-aft timbers fixed horizontally on opposite sides of a lower masthead to support an upper mast [n]\n",
  "TRESTLEWORK": "a system of connected trestles supporting a structure (as a railroad bridge) [n -S]\n",
  "TRESTLEWORKS": "TRESTLEWORK, a system of connected trestles supporting a structure (as a railroad bridge) [n]\n",
  "TRESTS": "TREST, (dialect) a trestle, also TRESSEL [n]\n",
  "TRET": "(historical) an allowance paid to purchasers for waste in transport [n -S]\n",
  "TRETINOIN": "a synthetic form of vitamin A used as a drug to treat certain skin conditions [n -S]\n",
  "TRETINOINS": "TRETINOIN, a synthetic form of vitamin A used as a drug to treat certain skin conditions [n]\n",
  "TRETS": "TRET, (historical) an allowance paid to purchasers for waste in transport [n]\n",
  "TREVALLIES": "TREVALLY, a fish [n]\n",
  "TREVALLY": "a fish [n TREVALLIES or TREVALLYS]\n",
  "TREVALLYS": "TREVALLY, a fish [n]\n",
  "TREVET": "a small stand with three legs, also TRIVET [n -S]\n",
  "TREVETS": "TREVET, a small stand with three legs, also TRIVET [n]\n",
  "TREVIS": "a stall, also TRAVIS, TREVISS [n -ES]\n",
  "TREVISES": "TREVIS, a stall, also TRAVIS, TREVISS [n]\n",
  "TREVISS": "a stall, also TRAVIS, TREVIS [n -ES]\n",
  "TREVISSES": "TREVISS, a stall, also TRAVIS, TREVIS [n]\n",
  "TREW": "(obsolete) true [adj]\n",
  "TREWS": "full-length trousers worn by Scot regiments; close-cut tartan drawers sometimes worn under the kilt in Highland dress, also TROOZ, TROUSE [n]\n",
  "TREWSMAN": "a wearer of trousers [n TREWSMEN]\n",
  "TREWSMEN": "TREWSMAN, a wearer of trousers [n]\n",
  "TREY": "the three in cards or dice, also TRAY, TREZ [n -S]\n",
  "TREYBIT": "a threepenny piece, also TRAYBIT [n -S]\n",
  "TREYBITS": "TREYBIT, a threepenny piece, also TRAYBIT [n]\n",
  "TREYF": "(Yiddish) not prepared according to Jewish law, also TEREFA, TEREFAH, TRAYF, TREF, TREFA, TREFAH, TREIF, TREIFA, TREYFA [adj]\n",
  "TREYFA": "(Hebrew) in the Jewish religion, forbidden as food, not kosher, also TEREFA, TEREFAH, TRAYF, TREF, TREFA, TREFAH, TREIF, TREIFA, TREYF [adj]\n",
  "TREYS": "TREY, the three in cards or dice, also TRAY, TREZ [n]\n",
  "TREZ": "the three in cards or dice, also TRAY, TREY [n -ES]\n",
  "TREZES": "TREZ, the three in cards or dice, also TRAY, TREY [n]\n",
  "TRIABLE": "subject to judicial examination [adj]\n",
  "TRIABLENESS": "the state of being triable [n -ES]\n",
  "TRIABLENESSES": "TRIABLENESS, the state of being triable [n]\n",
  "TRIAC": "an electronic device used to control power [n -S]\n",
  "TRIACETATE": "a kind of textile fibre [n -S]\n",
  "TRIACETATES": "TRIACETATE, a kind of textile fibre [n]\n",
  "TRIACID": "a type of acid compound [n -S]\n",
  "TRIACIDS": "TRIACID, a type of acid compound [n]\n",
  "TRIACONTER": "(historical) a Greek galley with thirty oars [n -S]\n",
  "TRIACONTERS": "TRIACONTER, (historical) a Greek galley with thirty oars [n]\n",
  "TRIACS": "TRIAC, an electronic device used to control power [n]\n",
  "TRIACT": "three-rayed, also TRIACTINAL, TRIACTINE [adj] / a three-rayed sponge spicule [n -S]\n",
  "TRIACTINAL": "three-rayed, also TRIACT, TRIACTINE [adj]\n",
  "TRIACTINE": "three-rayed, also TRIACT, TRIACTINAL [adj]\n",
  "TRIACTOR": "a wager whereby the bettor must pick the first three places in the correct order [n -S]\n",
  "TRIACTORS": "TRIACTOR, a wager whereby the bettor must pick the first three places in the correct order [n]\n",
  "TRIACTS": "TRIACT, a three-rayed sponge spicule [n]\n",
  "TRIAD": "a group of three [n -S]\n",
  "TRIADELPHOUS": "with three bundles of stamens [adj]\n",
  "TRIADIC": "having the characteristics of a triad [adj TRIADICALLY] / a triadic substance, such as boron [n -S]\n",
  "TRIADICALLY": "TRIADIC, having the characteristics of a triad [adv]\n",
  "TRIADICS": "TRIADIC, a triadic substance, such as boron [n]\n",
  "TRIADISM": "the state of being a triad [n -S]\n",
  "TRIADISMS": "TRIADISM, the state of being a triad [n]\n",
  "TRIADIST": "a composer of triads [n -S]\n",
  "TRIADISTS": "TRIADIST, a composer of triads [n]\n",
  "TRIADS": "TRIAD, a group of three [n]\n",
  "TRIAGE": "(French) a system of giving battlefield treatment to those who will survive only with help [n -S] / to practise triage [v TRIAGED, TRIAGING, TRIAGES]\n",
  "TRIAGED": "TRIAGE, to practise triage [v]\n",
  "TRIAGES": "TRIAGE, to practise triage [v]\n",
  "TRIAGING": "TRIAGE, to practise triage [v]\n",
  "TRIAL": "to make a judicial examination of [v TRIALED or TRIALLED, TRIALING or TRIALLING, TRIALS]\n",
  "TRIALED": "TRIAL, to make a judicial examination of [v]\n",
  "TRIALING": "TRIAL, to make a judicial examination of [v]\n",
  "TRIALISM": "the doctrine of the existence of body, soul and spirit in man [n -S]\n",
  "TRIALISMS": "TRIALISM, the doctrine of the existence of body, soul and spirit in man [n]\n",
  "TRIALIST": "a person taking part in a trial or test, also TRIALLIST [n -S]\n",
  "TRIALISTS": "TRIALIST, a person taking part in a trial or test, also TRIALLIST [n]\n",
  "TRIALITIES": "TRIALITY, the body, soul and spirit in man [n]\n",
  "TRIALITY": "the body, soul and spirit in man [n TRIALITIES]\n",
  "TRIALLED": "TRIAL, to make a judicial examination of [v]\n",
  "TRIALLING": "the act of making a trial [n -S]\n",
  "TRIALLINGS": "TRIALLING, the act of making a trial [n]\n",
  "TRIALLIST": "a person taking part in a trial or test, also TRIALIST [n -S]\n",
  "TRIALLISTS": "TRIALLIST, a person taking part in a trial or test, also TRIALIST [n]\n",
  "TRIALOGUE": "a discourse or colloquy by three persons [n -S]\n",
  "TRIALOGUES": "TRIALOGUE, a discourse or colloquy by three persons [n]\n",
  "TRIALS": "TRIAL, to make a judicial examination of [v]\n",
  "TRIALWARE": "computer software that can be used without charge for a limited evaluation period [n -S]\n",
  "TRIALWARES": "TRIALWARE, computer software that can be used without charge for a limited evaluation period [n]\n",
  "TRIAMCINOLONE": "a glucocorticoid drug used esp. in treating skin disorders, asthma, and allergic rhinitis [n -S]\n",
  "TRIAMCINOLONES": "TRIAMCINOLONE, a glucocorticoid drug used esp. in treating skin disorders, asthma, and allergic rhinitis [n]\n",
  "TRIANDRIAN": "of or pertaining to the Triandria; having three distinct and equal stamens in the same flower, also TRIANDROUS [adj]\n",
  "TRIANDROUS": "of or pertaining to the Triandria; having three distinct and equal stamens in the same flower, also TRIANDRIAN [adj]\n",
  "TRIANGLE": "a polygon having three sides [n -S]\n",
  "TRIANGLED": "having a triangle [adj]\n",
  "TRIANGLES": "TRIANGLE, a polygon having three sides [n]\n",
  "TRIANGULAR": "having the form of a triangle [adj TRIANGULARLY]\n",
  "TRIANGULARITIES": "TRIANGULARITY, the state of being triangular [n]\n",
  "TRIANGULARITY": "the state of being triangular [n TRIANGULARITIES]\n",
  "TRIANGULARLY": "TRIANGULAR, having the form of a triangle [adv]\n",
  "TRIANGULATE": "triagular [adj TRIANGULATELY] / to survey, map, or determine by triangulation [v TRIANGULATED, TRIANGULATING, TRIANGULATES]\n",
  "TRIANGULATED": "TRIANGULATE, to survey, map, or determine by triangulation [v]\n",
  "TRIANGULATELY": "TRIANGULATE, triagular [adv]\n",
  "TRIANGULATES": "TRIANGULATE, to survey, map, or determine by triangulation [v]\n",
  "TRIANGULATING": "TRIANGULATE, to survey, map, or determine by triangulation [v]\n",
  "TRIANGULATION": "in geology, a method of locating an epicenter by determining how far it lies from three widely separated seismographs [n -S]\n",
  "TRIANGULATIONS": "TRIANGULATION, in geology, a method of locating an epicenter by determining how far it lies from three widely separated seismographs [n]\n",
  "TRIAPSAL": "having three apses, also TRIAPSIDAL [adj]\n",
  "TRIAPSIDAL": "having three apses, also TRIAPSAL [adj]\n",
  "TRIARCH": "a ruler of a triarchy [n -S]\n",
  "TRIARCHIES": "TRIARCHY, a government by three persons [n]\n",
  "TRIARCHS": "TRIARCH, a ruler of a triarchy [n]\n",
  "TRIARCHY": "a government by three persons [n TRIARCHIES]\n",
  "TRIASSIC": "relating to the first period of the Mesozoic era [adj]\n",
  "TRIATHLETE": "an athlete who competes in a triathlon [n -S]\n",
  "TRIATHLETES": "TRIATHLETE, an athlete who competes in a triathlon [n]\n",
  "TRIATHLON": "a sporting contest consisting of three events held without a break between each, usually swimming, cycling and running [n -S]\n",
  "TRIATHLONS": "TRIATHLON, a sporting contest consisting of three events held without a break between each, usually swimming, cycling and running [n]\n",
  "TRIATIC": "a rope joining adjacent mastheads [n -S]\n",
  "TRIATICS": "TRIATIC, a rope joining adjacent mastheads [n]\n",
  "TRIATOMIC": "having three atoms [adj TRIATOMICALLY]\n",
  "TRIATOMICALLY": "TRIATOMIC, having three atoms [adv]\n",
  "TRIAXIAL": "a sponge spicule with three axes, also TRIAXON [n -S]\n",
  "TRIAXIALITIES": "TRIAXIALITY, the state of being triaxial [n]\n",
  "TRIAXIALITY": "the state of being triaxial [n TRIAXIALITIES]\n",
  "TRIAXIALS": "TRIAXIAL, a sponge spicule with three axes, also TRIAXON [n]\n",
  "TRIAXON": "a sponge spicule with three axes, also TRIAXIAL [n -S]\n",
  "TRIAXONS": "TRIAXON, a sponge spicule with three axes, also TRIAXIAL [n]\n",
  "TRIAZIN": "a nitrogen compound used in herbicides, also TRIAZINE [n -S]\n",
  "TRIAZINE": "a nitrogen compound used in herbicides, also TRIAZIN [n -S]\n",
  "TRIAZINES": "TRIAZINE, a nitrogen compound used in herbicides, also TRIAZIN [n]\n",
  "TRIAZINS": "TRIAZIN, a nitrogen compound used in herbicides, also TRIAZINE [n]\n",
  "TRIAZOLE": "any compound whose molecule contains a ring of three nitrogen and two carbon atoms [n -S]\n",
  "TRIAZOLES": "TRIAZOLE, any compound whose molecule contains a ring of three nitrogen and two carbon atoms [n]\n",
  "TRIAZOLIC": "relating to triazole, any compound whose molecule contains a ring of three nitrogen and two carbon atoms [adj]\n",
  "TRIBADE": "(French) a female homosexual; a lesbian [n -S]\n",
  "TRIBADES": "TRIBADE, (French) a female homosexual; a lesbian [n]\n",
  "TRIBADIC": "relating to tribadism, lesbianism [adj]\n",
  "TRIBADIES": "TRIBADY, lesbianism, also TRIBADISM [n]\n",
  "TRIBADISM": "lesbianism, also TRIBADY [n -S]\n",
  "TRIBADISMS": "TRIBADISM, lesbianism, also TRIBADY [n]\n",
  "TRIBADY": "lesbianism, also TRIBADISM [n TRIBADIES]\n",
  "TRIBAL": "pertaining to a tribe [adj TRIBALLY] / a member of an aboriginal tribe of India [n -S]\n",
  "TRIBALISM": "the state of existing in tribes; loyalty to one's tribe [n -S]\n",
  "TRIBALISMS": "TRIBALISM, the state of existing in tribes; loyalty to one's tribe [n]\n",
  "TRIBALIST": "a believer in tribalism [n -S]\n",
  "TRIBALISTIC": "like a tribalist [adj]\n",
  "TRIBALISTS": "TRIBALIST, a believer in tribalism [n]\n",
  "TRIBALLY": "TRIBAL, pertaining to a tribe [adv]\n",
  "TRIBALS": "TRIBAL, a member of an aboriginal tribe of India [n]\n",
  "TRIBASIC": "having three replaceable hydrogen atoms [adj]\n",
  "TRIBBLE": "a horizontal frame with wires for drying paper [n -S]\n",
  "TRIBBLES": "TRIBBLE, a horizontal frame with wires for drying paper [n]\n",
  "TRIBE": "a group of people with common ancestry, language and culture [n -S]\n",
  "TRIBELESS": "without a tribe [adj]\n",
  "TRIBES": "TRIBE, a group of people with common ancestry, language and culture [n]\n",
  "TRIBESMAN": "a male member of a tribe [n TRIBESMEN]\n",
  "TRIBESMEN": "TRIBESMAN, a male member of a tribe [n]\n",
  "TRIBESPEOPLE": "members of a tribe [n]\n",
  "TRIBESWOMAN": "a female member of a tribe [n TRIBESWOMEN]\n",
  "TRIBESWOMEN": "TRIBESWOMAN, a female member of a tribe [n]\n",
  "TRIBLET": "a tapering mandrel on which ring-nuts etc. are forged [n -S]\n",
  "TRIBLETS": "TRIBLET, a tapering mandrel on which ring-nuts etc. are forged [n]\n",
  "TRIBOELECTRIC": "of electricity generated by friction [adj]\n",
  "TRIBOLOGICAL": "relating to tribology [adj]\n",
  "TRIBOLOGIES": "TRIBOLOGY, the study of interacting surfaces in relative motion and associated issues, such as friction, lubrication, and wear [n]\n",
  "TRIBOLOGIST": "a student of tribology [n -S]\n",
  "TRIBOLOGISTS": "TRIBOLOGIST, a student of tribology [n]\n",
  "TRIBOLOGY": "the study of interacting surfaces in relative motion and associated issues, such as friction, lubrication, and wear [n TRIBOLOGIES]\n",
  "TRIBOMETER": "an instrument used to measure friction [n -S]\n",
  "TRIBOMETERS": "TRIBOMETER, an instrument used to measure friction [n]\n",
  "TRIBRACH": "a poetic foot of three short syllables [n -S]\n",
  "TRIBRACHIAL": "of or like a tribrach, also TRIBRACHIC [adj]\n",
  "TRIBRACHIC": "of or like a tribrach, also TRIBRACHIAL [adj]\n",
  "TRIBRACHS": "TRIBRACH, a poetic foot of three short syllables [n]\n",
  "TRIBROMOETHANOL": "a soluble white crystalline compound with a slight aromatic odour, used as a general anaesthetic [n]\n",
  "TRIBROMOMETHANE": "another name for bromoform, a bromine compound analogous to chloroform [n]\n",
  "TRIBULATE": "to cause to endure tribulation [v TRIBULATED, TRIBULATING, TRIBULATES]\n",
  "TRIBULATED": "TRIBULATE, to cause to endure tribulation [v]\n",
  "TRIBULATES": "TRIBULATE, to cause to endure tribulation [v]\n",
  "TRIBULATING": "TRIBULATE, to cause to endure tribulation [v]\n",
  "TRIBULATION": "distress or suffering resulting from oppression or persecution [n -S]\n",
  "TRIBULATIONS": "TRIBULATION, distress or suffering resulting from oppression or persecution [n]\n",
  "TRIBUNAL": "a court of justice [n -S]\n",
  "TRIBUNALS": "TRIBUNAL, a court of justice [n]\n",
  "TRIBUNARY": "relating to a tribune [adj]\n",
  "TRIBUNATE": "the office of a tribune [n -S]\n",
  "TRIBUNATES": "TRIBUNATE, the office of a tribune [n]\n",
  "TRIBUNE": "an ancient Roman official; specifically (a) a magistrate appointed to protect the interests and rights of the plebeians; (b) a legionary officer [n -S]\n",
  "TRIBUNES": "TRIBUNE, an ancient Roman official; specifically (a) a magistrate appointed to protect the interests and rights of the plebeians; (b) a legionary officer [n]\n",
  "TRIBUNESHIP": "the office of tribune [n -S]\n",
  "TRIBUNESHIPS": "TRIBUNESHIP, the office of tribune [n]\n",
  "TRIBUNICIAL": "relating to a tribunate, also TRIBUNICIAN, TRIBUNITIAL, TRIBUNITIAN [adj]\n",
  "TRIBUNICIAN": "relating to a tribunate, also TRIBUNICIAL, TRIBUNITIAL, TRIBUNITIAN [adj]\n",
  "TRIBUNITIAL": "relating to a tribunate, also TRIBUNICIAL, TRIBUNICIAN, TRIBUNITIAN [adj]\n",
  "TRIBUNITIAN": "relating to a tribunate, also TRIBUNICIAL, TRIBUNICIAN, TRIBUNITIAL [adj]\n",
  "TRIBUTARIES": "TRIBUTARY, a river that joins another river [n]\n",
  "TRIBUTARILY": "TRIBUTARY, paying tribute [adv]\n",
  "TRIBUTARINESS": "the state of being a tributary [n -ES]\n",
  "TRIBUTARINESSES": "TRIBUTARINESS, the state of being a tributary [n]\n",
  "TRIBUTARY": "paying tribute [adj TRIBUTARILY] / a river that joins another river [n TRIBUTARIES]\n",
  "TRIBUTE": "a testimony or gift in gratitude or respect [n -S]\n",
  "TRIBUTER": "a miner who works for a certain portion of the ore, or its value [n -S]\n",
  "TRIBUTERS": "TRIBUTER, a miner who works for a certain portion of the ore, or its value [n]\n",
  "TRIBUTES": "TRIBUTE, a testimony or gift in gratitude or respect [n]\n",
  "TRICAMERAL": "having three chambers [adj]\n",
  "TRICAR": "a three-wheeled car [n -S]\n",
  "TRICARBOXYLIC": "containing three carboxyl groups in the molecule [adj]\n",
  "TRICARPELLARY": "of or with three carpels [adj]\n",
  "TRICARS": "TRICAR, a three-wheeled car [n]\n",
  "TRICE": "to haul up with a rope [v TRICED, TRICING, TRICES]\n",
  "TRICED": "TRICE, to haul up with a rope [v]\n",
  "TRICENTENARIES": "TRICENTENARY, a three-hundred year anniversary, or the celebrations for it, also TERCENTENARY [n]\n",
  "TRICENTENARY": "a three-hundred year anniversary, or the celebrations for it, also TERCENTENARY [n TRICENTENARIES]\n",
  "TRICENTENNIAL": "a three-hundred year anniversary [n -S]\n",
  "TRICENTENNIALS": "TRICENTENNIAL, a three-hundred year anniversary [n]\n",
  "TRICEP": "an arm muscle, also TRICEPS [n -S]\n",
  "TRICEPHALOUS": "having three heads [adj]\n",
  "TRICEPS": "(Latin) an arm muscle, also TRICEP [n -ES]\n",
  "TRICEPSES": "TRICEPS, (Latin) an arm muscle, also TRICEP [n]\n",
  "TRICERATOPS": "a kind of dinosaur [n -ES]\n",
  "TRICERATOPSES": "TRICERATOPS, a kind of dinosaur [n]\n",
  "TRICERION": "a three-branched candlestick [n -S]\n",
  "TRICERIONS": "TRICERION, a three-branched candlestick [n]\n",
  "TRICES": "TRICE, to haul up with a rope [v]\n",
  "TRICHIASES": "TRICHIASIS, a disease of the eye, in which the eyelashes, being turned in upon the eyeball, produce constant irritation by the motion of the lids [n]\n",
  "TRICHIASIS": "a disease of the eye, in which the eyelashes, being turned in upon the eyeball, produce constant irritation by the motion of the lids [n TRICHIASES]\n",
  "TRICHINA": "(Greek) a type of nematode worm parasitic in rat, pig, and man [n TRICHINAE or TRICHINAS]\n",
  "TRICHINAE": "TRICHINA, (Greek) a type of nematode worm parasitic in rat, pig, and man [n]\n",
  "TRICHINAL": "relating to a trichina, a small, slender nematoid worm [adj]\n",
  "TRICHINAS": "TRICHINA, (Greek) a type of nematode worm parasitic in rat, pig, and man [n]\n",
  "TRICHINELLA": "a kind of parasite causing infection [n -S]\n",
  "TRICHINELLAE": "TRICHINELLA, a kind of parasite causing infection [n]\n",
  "TRICHINELLAS": "TRICHINELLA, a kind of parasite causing infection [n]\n",
  "TRICHINIASES": "TRICHINIASIS, a disease caused by trichinae [n]\n",
  "TRICHINIASIS": "a disease caused by trichinae [n TRICHINIASES]\n",
  "TRICHINISATION": "the process of trichinising, also TRICHINIZATION [n -S]\n",
  "TRICHINISATIONS": "TRICHINISATION, the process of trichinising, also TRICHINIZATION [n]\n",
  "TRICHINISE": "to infest with trichinae, a small, slender nematoid worm, also TRICHINIZE, TRICHINOSE [v TRICHINISED, TRICHINISING, TRICHINISES]\n",
  "TRICHINISED": "TRICHINISE, to infest with trichinae, a small, slender nematoid worm, also TRICHINIZE, TRICHINOSE [v]\n",
  "TRICHINISES": "TRICHINISE, to infest with trichinae, a small, slender nematoid worm, also TRICHINIZE, TRICHINOSE [v]\n",
  "TRICHINISING": "TRICHINISE, to infest with trichinae, a small, slender nematoid worm, also TRICHINIZE, TRICHINOSE [v]\n",
  "TRICHINIZATION": "the process of trichinizing, also TRICHINISATION [n -S]\n",
  "TRICHINIZATIONS": "TRICHINIZATION, the process of trichinizing, also TRICHINISATION [n]\n",
  "TRICHINIZE": "to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINOSE [v TRICHINIZED, TRICHINIZING, TRICHINIZES]\n",
  "TRICHINIZED": "TRICHINIZE, to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINOSE [v]\n",
  "TRICHINIZES": "TRICHINIZE, to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINOSE [v]\n",
  "TRICHINIZING": "TRICHINIZE, to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINOSE [v]\n",
  "TRICHINOSE": "to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINIZE [v TRICHINOSED, TRICHINOSING, TRICHINOSES]\n",
  "TRICHINOSED": "TRICHINOSE, to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINIZE [v]\n",
  "TRICHINOSES": "TRICHINOSE, to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINIZE [v]\n",
  "TRICHINOSING": "TRICHINOSE, to infest with trichinae, a small, slender nematoid worm, also TRICHINISE, TRICHINIZE [v]\n",
  "TRICHINOSIS": "a disease due to eating pork infested with a certain kind of nematode worm [n TRICHINOSES]\n",
  "TRICHINOTIC": "relating to trichinosis, also TRICHINOUS [adj]\n",
  "TRICHINOUS": "relating to trichinosis, also TRICHINOTIC [adj]\n",
  "TRICHITE": "a kind of crystallite resembling a bunch of hairs, common in obsidian [n -S]\n",
  "TRICHITES": "TRICHITE, a kind of crystallite resembling a bunch of hairs, common in obsidian [n]\n",
  "TRICHITIC": "relating to a trichite, a kind of crystallite resembling a bunch of hairs, common in obsidian [adj]\n",
  "TRICHLORACETIC": "as in trichloracetic acid [adj]\n",
  "TRICHLORFON": "a crystalline compound used esp. as an insecticide, also TRICHLORPHON [n -S]\n",
  "TRICHLORFONS": "TRICHLORFON, a crystalline compound used esp. as an insecticide, also TRICHLORPHON [n]\n",
  "TRICHLORIDE": "any compound that contains three chlorine atoms per molecule [n -S]\n",
  "TRICHLORIDES": "TRICHLORIDE, any compound that contains three chlorine atoms per molecule [n]\n",
  "TRICHLOROACETIC": "as in trichloroacetic acid [adj]\n",
  "TRICHLOROETHANE": "a volatile nonflammable colourless liquid with low toxicity used for cleaning electrical apparatus and as a solvent [n]\n",
  "TRICHLORPHON": "a crystalline compound used as an insecticide, also TRICHLORFON [n -S]\n",
  "TRICHLORPHONS": "TRICHLORPHON, a crystalline compound used as an insecticide, also TRICHLORFON [n]\n",
  "TRICHOBACTERIA": "filamentous bacteria [n]\n",
  "TRICHOCYST": "a lasso cell [n -S]\n",
  "TRICHOCYSTIC": "of or like a trichocyst, a lasso cell [adj]\n",
  "TRICHOCYSTS": "TRICHOCYST, a lasso cell [n]\n",
  "TRICHOGYNE": "the slender, hairlike cell which receives the fertilizing particles, or antherozoids, in red seaweeds [n -S]\n",
  "TRICHOGYNES": "TRICHOGYNE, the slender, hairlike cell which receives the fertilizing particles, or antherozoids, in red seaweeds [n]\n",
  "TRICHOGYNIAL": "of or like a trichogyne, also TRICHOGYNIC [adj]\n",
  "TRICHOGYNIC": "of or like a trichogyne, also TRICHOGYNIAL [adj]\n",
  "TRICHOID": "hairlike [adj]\n",
  "TRICHOLOGICAL": "related to trichology [adj]\n",
  "TRICHOLOGIES": "TRICHOLOGY, the study of hair and its disorders [n]\n",
  "TRICHOLOGIST": "a person who specializes in hair and scalp care [n -S]\n",
  "TRICHOLOGISTS": "TRICHOLOGIST, a person who specializes in hair and scalp care [n]\n",
  "TRICHOLOGY": "the study of hair and its disorders [n TRICHOLOGIES]\n",
  "TRICHOME": "a hairlike outgrowth [n -S]\n",
  "TRICHOMES": "TRICHOME, a hairlike outgrowth [n]\n",
  "TRICHOMIC": "relating to a trichome, a plant hair or outgrowth from the epidermis [adj]\n",
  "TRICHOMONACIDAL": "relating to a trichomonacide, an agent used to destroy trichomonads [adj]\n",
  "TRICHOMONACIDE": "an agent used to destroy trichomonads [n -S]\n",
  "TRICHOMONACIDES": "TRICHOMONACIDE, an agent used to destroy trichomonads [n]\n",
  "TRICHOMONAD": "any of various flagellate protozoans occurring in the digestive and urogenital tracts of vertebrates [n -S]\n",
  "TRICHOMONADAL": "of or like a trichomonad, a kind of flagellate protozoans, also TRICHOMONAL [adj]\n",
  "TRICHOMONADS": "TRICHOMONAD, any of various flagellate protozoans occurring in the digestive and urogenital tracts of vertebrates [n]\n",
  "TRICHOMONAL": "of or like a trichomonad, a kind of flagellate protozoans, also TRICHOMONADAL [adj]\n",
  "TRICHOMONIASES": "TRICHOMONIASIS, infection with or disease caused by trichomonads [n]\n",
  "TRICHOMONIASIS": "infection with or disease caused by trichomonads [n TRICHOMONIASES]\n",
  "TRICHOPHYTON": "any fungus of the genus Trichophyton, causing ringworm [n -S]\n",
  "TRICHOPHYTONS": "TRICHOPHYTON, any fungus of the genus Trichophyton, causing ringworm [n]\n",
  "TRICHOPHYTOSES": "TRICHOPHYTOSIS, ringworm caused by Trichophyton [n]\n",
  "TRICHOPHYTOSIS": "ringworm caused by Trichophyton [n TRICHOPHYTOSES]\n",
  "TRICHOPTERAN": "any member of the Trichoptera, caddis flies [n -S]\n",
  "TRICHOPTERANS": "TRICHOPTERAN, any member of the Trichoptera, caddis flies [n]\n",
  "TRICHOPTERIST": "someone who studies the caddis flies [n -S]\n",
  "TRICHOPTERISTS": "TRICHOPTERIST, someone who studies the caddis flies [n]\n",
  "TRICHOPTEROUS": "relating to the Trichoptera, caddis flies [adj]\n",
  "TRICHORD": "an instrument, such as a lyre or harp, having three strings [n -S]\n",
  "TRICHORDS": "TRICHORD, an instrument, such as a lyre or harp, having three strings [n]\n",
  "TRICHOSES": "TRICHOSIS, arrangement, distribution or disorder of hair [n]\n",
  "TRICHOSIS": "arrangement, distribution or disorder of hair [n TRICHOSES]\n",
  "TRICHOTHECENE": "any of several mycotoxins produced by various fungi [n -S]\n",
  "TRICHOTHECENES": "TRICHOTHECENE, any of several mycotoxins produced by various fungi [n]\n",
  "TRICHOTOMIC": "relating to trichotomy, division into three parts or categories [adj]\n",
  "TRICHOTOMIES": "TRICHOTOMY, division into three parts or categories [n]\n",
  "TRICHOTOMISE": "to divide into three, also TRICHOTOMIZE [v TRICHOTOMISED, TRICHOTOMISING, TRICHOTOMISES]\n",
  "TRICHOTOMISED": "TRICHOTOMISE, to divide into three, also TRICHOTOMIZE [v]\n",
  "TRICHOTOMISES": "TRICHOTOMISE, to divide into three, also TRICHOTOMIZE [v]\n",
  "TRICHOTOMISING": "TRICHOTOMISE, to divide into three, also TRICHOTOMIZE [v]\n",
  "TRICHOTOMIZE": "to divide into three, also TRICHOTOMISE [v TRICHOTOMIZED, TRICHOTOMIZING, TRICHOTOMIZES]\n",
  "TRICHOTOMIZED": "TRICHOTOMIZE, to divide into three, also TRICHOTOMISE [v]\n",
  "TRICHOTOMIZES": "TRICHOTOMIZE, to divide into three, also TRICHOTOMISE [v]\n",
  "TRICHOTOMIZING": "TRICHOTOMIZE, to divide into three, also TRICHOTOMISE [v]\n",
  "TRICHOTOMOUS": "divided into three parts [adj TRICHOTOMOUSLY]\n",
  "TRICHOTOMOUSLY": "TRICHOTOMOUS, divided into three parts [adv]\n",
  "TRICHOTOMY": "division into three parts or categories [n TRICHOTOMIES]\n",
  "TRICHROIC": "exhibiting trichroism; pleochroic [adj]\n",
  "TRICHROISM": "the quality possessed by some crystals of presenting different colors in three different directions [n -S]\n",
  "TRICHROISMS": "TRICHROISM, the quality possessed by some crystals of presenting different colors in three different directions [n]\n",
  "TRICHROMAT": "someone who has normal colour vision [n -S]\n",
  "TRICHROMATIC": "pertaining to or in three colors; having normal color vision, also TRICHROME [adj]\n",
  "TRICHROMATISM": "use of the three primary colors for color reproduction; normal color vision [n -S]\n",
  "TRICHROMATISMS": "TRICHROMATISM, use of the three primary colors for color reproduction; normal color vision [n]\n",
  "TRICHROMATS": "TRICHROMAT, someone who has normal colour vision [n]\n",
  "TRICHROME": "pertaining to or in three colors; having normal color vision, also TRICHROMATIC [adj]\n",
  "TRICHROMIC": "having normal colour vision [adj] / one with normal colour vision [n -S]\n",
  "TRICHROMICS": "TRICHROMIC, one with normal colour vision [n]\n",
  "TRICHRONOUS": "trisemic [adj]\n",
  "TRICHURIASES": "TRICHURIASIS, infection of the large intestine with the whipworm Trichuris trichiura, resulting in anaemia, weakness, etc. [n]\n",
  "TRICHURIASIS": "infection of the large intestine with the whipworm Trichuris trichiura, resulting in anaemia, weakness, etc. [n TRICHURIASES]\n",
  "TRICING": "TRICE, to haul up with a rope [v]\n",
  "TRICITIES": "TRICITY, an area that comprises three adjoining cities [n]\n",
  "TRICITY": "an area that comprises three adjoining cities [n TRICITIES]\n",
  "TRICK": "to deceive [v -ED, -ING, -S]\n",
  "TRICKED": "TRICK, to deceive [v]\n",
  "TRICKER": "one who plays tricks [n -S]\n",
  "TRICKERIES": "TRICKERY, deception [n]\n",
  "TRICKERS": "TRICKER, one who plays tricks [n]\n",
  "TRICKERY": "deception [n TRICKERIES]\n",
  "TRICKIE": "characterized by deception, also TRICKY [adj TRICKIER, TRICKIEST]\n",
  "TRICKIER": "TRICKIE, characterized by deception, also TRICKY [adj]\n",
  "TRICKIEST": "TRICKIE, characterized by deception, also TRICKY [adj]\n",
  "TRICKILY": "TRICKY, characterized by deception, also TRICKIE [adv]\n",
  "TRICKINESS": "the state of being tricky [n -ES]\n",
  "TRICKINESSES": "TRICKINESS, the state of being tricky [n]\n",
  "TRICKING": "the act of tricking [n -S]\n",
  "TRICKINGS": "TRICKING, the act of tricking [n]\n",
  "TRICKISH": "given to tricks [adj]\n",
  "TRICKISHLY": "TRICKISH, given to tricks [adv]\n",
  "TRICKISHNESS": "the state of being trickish [n -ES]\n",
  "TRICKISHNESSES": "TRICKISHNESS, the state of being trickish [n]\n",
  "TRICKLE": "to run slowly in a small stream [v TRICKLED, TRICKLING, TRICKLES]\n",
  "TRICKLED": "TRICKLE, to run slowly in a small stream [v]\n",
  "TRICKLES": "TRICKLE, to run slowly in a small stream [v]\n",
  "TRICKLESS": "without tricks [adj]\n",
  "TRICKLET": "a little trickle [n -S]\n",
  "TRICKLETS": "TRICKLET, a little trickle [n]\n",
  "TRICKLIER": "TRICKLY, marked by trickling [adj]\n",
  "TRICKLIEST": "TRICKLY, marked by trickling [adj]\n",
  "TRICKLING": "in small drops [adj TRICKLINGLY] / the act of trickling [n -S]\n",
  "TRICKLINGLY": "TRICKLING, in small drops [adv]\n",
  "TRICKLINGS": "TRICKLING, the act of trickling [n]\n",
  "TRICKLY": "marked by trickling [adj TRICKLIER, TRICKLIEST]\n",
  "TRICKS": "TRICK, to deceive [v]\n",
  "TRICKSIER": "TRICKSY, mischievous [adj]\n",
  "TRICKSIEST": "TRICKSY, mischievous [adj]\n",
  "TRICKSILY": "TRICKSY, mischievous [adv]\n",
  "TRICKSINESS": "the state of being tricksy [n -ES]\n",
  "TRICKSINESSES": "TRICKSINESS, the state of being tricksy [n]\n",
  "TRICKSOME": "full of tricks [adj]\n",
  "TRICKSTER": "one who plays tricks [n -S]\n",
  "TRICKSTERING": "playing tricks [n -S]\n",
  "TRICKSTERINGS": "TRICKSTERING, playing tricks [n]\n",
  "TRICKSTERS": "TRICKSTER, one who plays tricks [n]\n",
  "TRICKSY": "mischievous [adj TRICKSIER, TRICKSIEST, TRICKSILY]\n",
  "TRICKTRACK": "a form of backgammon in which pegs as well as pieces are used, also TRICTRAC [n -S]\n",
  "TRICKTRACKS": "TRICKTRACK, a form of backgammon in which pegs as well as pieces are used, also TRICTRAC [n]\n",
  "TRICKY": "characterized by deception, also TRICKIE [adj TRICKIER, TRICKIEST, TRICKILY]\n",
  "TRICLAD": "an aquatic flatworm [n -S]\n",
  "TRICLADS": "TRICLAD, an aquatic flatworm [n]\n",
  "TRICLINIA": "TRICLINIUM, (Latin) a couch for reclining at meals, extending round three sides of a table, and usually in three parts [n]\n",
  "TRICLINIC": "of crystals, having, or characterized by, three unequal axes intersecting at oblique angles [adj]\n",
  "TRICLINIUM": "(Latin) a couch for reclining at meals, extending round three sides of a table, and usually in three parts [n TRICLINIA]\n",
  "TRICLOSAN": "a drug used to treat skin infections [n -S]\n",
  "TRICLOSANS": "TRICLOSAN, a drug used to treat skin infections [n]\n",
  "TRICOLETTE": "a silk or rayon knitted fabric [n -S]\n",
  "TRICOLETTES": "TRICOLETTE, a silk or rayon knitted fabric [n]\n",
  "TRICOLOR": "(French) a flag of three colours; esp. the French national flag of blue, white, and red vertical stripes, also TRICOLOUR [n -S]\n",
  "TRICOLORED": "having three colors, also TRICOLOURED [adj]\n",
  "TRICOLORS": "TRICOLOR, (French) a flag of three colours; esp. the French national flag of blue, white, and red vertical stripes, also TRICOLOUR [n]\n",
  "TRICOLOUR": "a flag of three colours; esp. the French national flag of blue, white, and red vertical stripes, also TRICOLOR [n -S]\n",
  "TRICOLOURED": "having three colours, also TRICOLORED [adj]\n",
  "TRICOLOURS": "TRICOLOUR, a flag of three colours; esp. the French national flag of blue, white, and red vertical stripes, also TRICOLOR [n]\n",
  "TRICONSONANTAL": "having three consonants, also TRICONSONANTIC [adj]\n",
  "TRICONSONANTIC": "having three consonants, also TRICONSONANTAL [adj]\n",
  "TRICORN": "a hat with the brim turned up on three sides, also TRICORNE [n -S]\n",
  "TRICORNE": "a hat with the brim turned up on three sides, also TRICORN [n -S]\n",
  "TRICORNERED": "having three corners [adj]\n",
  "TRICORNES": "TRICORNE, a hat with the brim turned up on three sides, also TRICORN [n]\n",
  "TRICORNS": "TRICORN, a hat with the brim turned up on three sides, also TRICORNE [n]\n",
  "TRICORPORATE": "having three bodies and one head, also TRICORPORATED [adj]\n",
  "TRICORPORATED": "having three bodies and one head, also TRICORPORATE [adj]\n",
  "TRICOSTATE": "three-ribbed; having three ribs from the base [adj]\n",
  "TRICOT": "(French) a plain knitted silk or woollen fabric [n -S]\n",
  "TRICOTEUSE": "(French) in the French Revolution, a woman who attended executions and knitted [n -S]\n",
  "TRICOTEUSES": "TRICOTEUSE, (French) in the French Revolution, a woman who attended executions and knitted [n]\n",
  "TRICOTINE": "a double-twilled worsted fabric [n -S]\n",
  "TRICOTINES": "TRICOTINE, a double-twilled worsted fabric [n]\n",
  "TRICOTS": "TRICOT, (French) a plain knitted silk or woollen fabric [n]\n",
  "TRICROTIC": "of (a tracing of) the pulse, showing three undulations for each beat of the heart, also TRICROTOUS [adj]\n",
  "TRICROTISM": "that condition of the arterial pulse in which there is a triple beat [n -S]\n",
  "TRICROTISMS": "TRICROTISM, that condition of the arterial pulse in which there is a triple beat [n]\n",
  "TRICROTOUS": "of (a tracing of) the pulse, showing three undulations for each beat of the heart, also TRICROTIC [adj]\n",
  "TRICTRAC": "a form of backgammon in which pegs as well as pieces are used, also TRICKTRACK [n -S]\n",
  "TRICTRACS": "TRICTRAC, a form of backgammon in which pegs as well as pieces are used, also TRICKTRACK [n]\n",
  "TRICUSPID": "having three cusps, or points, also TRICUSPIDAL, TRICUSPIDATE [adj] / a tricuspid tooth [n -S]\n",
  "TRICUSPIDAL": "having three cusps, or points; as, a tricuspidal molar, also TRICUSPID, TRICUSPIDATE [adj]\n",
  "TRICUSPIDATE": "having three cusps, or points; as, a tricuspidate molar, also TRICUSPID, TRICUSPIDAL [adj]\n",
  "TRICUSPIDS": "TRICUSPID, a tricuspid tooth [n]\n",
  "TRICYCLE": "to ride a bike with three wheels [v TRICYCLED, TRICYCLING, TRICYCLES]\n",
  "TRICYCLED": "TRICYCLE, to ride a bike with three wheels [v]\n",
  "TRICYCLER": "one who rides a tricycle [n -S]\n",
  "TRICYCLERS": "TRICYCLER, one who rides a tricycle [n]\n",
  "TRICYCLES": "TRICYCLE, to ride a bike with three wheels [v]\n",
  "TRICYCLIC": "of a chemical compound, having three rings in its molecular structure [adj] / a tricyclic drug, used as an antidepressant [n -S]\n",
  "TRICYCLICS": "TRICYCLIC, a tricyclic drug, used as an antidepressant [n]\n",
  "TRICYCLING": "travelling by tricycle [n -S]\n",
  "TRICYCLINGS": "TRICYCLING, travelling by tricycle [n]\n",
  "TRICYCLIST": "one who rides a tricycle [n -S]\n",
  "TRICYCLISTS": "TRICYCLIST, one who rides a tricycle [n]\n",
  "TRIDACNA": "(Greek) a giant clam [n -S]\n",
  "TRIDACNAS": "TRIDACNA, (Greek) a giant clam [n]\n",
  "TRIDACTYL": "having three fingers or toes, also TRIDACTYLOUS [adj]\n",
  "TRIDACTYLOUS": "having three fingers or toes, also TRIDACTYL [adj]\n",
  "TRIDARN": "(Welsh) a Welsh dresser having three tiers [n -S]\n",
  "TRIDARNS": "TRIDARN, (Welsh) a Welsh dresser having three tiers [n]\n",
  "TRIDE": "TRY, to attempt [v]\n",
  "TRIDENT": "a spear with three prongs [n -S]\n",
  "TRIDENTAL": "having three prongs, also TRIDENTATE, TRIDENTED [adj]\n",
  "TRIDENTATE": "having three prongs, also TRIDENTAL, TRIDENTED [adj]\n",
  "TRIDENTED": "having three prongs, also TRIDENTAL, TRIDENTATE [adj]\n",
  "TRIDENTS": "TRIDENT, a spear with three prongs [n]\n",
  "TRIDIMENSIONAL": "of, relating to, or concerned with three dimensions [adj]\n",
  "TRIDOMINIA": "TRIDOMINIUM, (Latin) threefold rule [n]\n",
  "TRIDOMINIUM": "(Latin) threefold rule [n TRIDOMINIA or TRIDOMINIUMS]\n",
  "TRIDOMINIUMS": "TRIDOMINIUM, (Latin) threefold rule [n]\n",
  "TRIDUAN": "lasting three days [adj]\n",
  "TRIDUUM": "(Latin) a period of three days of prayer preceding Roman Catholic feasts [n -S]\n",
  "TRIDUUMS": "TRIDUUM, (Latin) a period of three days of prayer preceding Roman Catholic feasts [n]\n",
  "TRIDYMITE": "an orthorhombic form of silica, in hexagonal scales, often combined in threes [n -S]\n",
  "TRIDYMITES": "TRIDYMITE, an orthorhombic form of silica, in hexagonal scales, often combined in threes [n]\n",
  "TRIE": "(Spenser) to try [v TRIED, TRYING, TRIES]\n",
  "TRIECIOUS": "having male, female and hermaphrodite flowers on different plants, also TRIOECIOUS [adj]\n",
  "TRIED": "TRIE, (Spenser) to try [v]\n",
  "TRIELLA": "(Australian) a bet nominating the winners of three specified horse races [n -S]\n",
  "TRIELLAS": "TRIELLA, (Australian) a bet nominating the winners of three specified horse races [n]\n",
  "TRIENE": "a type of chemical compound [n -S]\n",
  "TRIENES": "TRIENE, a type of chemical compound [n]\n",
  "TRIENNIA": "TRIENNIUM, (Latin) a period of three years [n]\n",
  "TRIENNIAL": "continuing for three years [adj TRIENNIALLY] / a three-year anniversary [n -S]\n",
  "TRIENNIALLY": "TRIENNIAL, continuing for three years [adv]\n",
  "TRIENNIALS": "TRIENNIAL, a three-year anniversary [n]\n",
  "TRIENNIUM": "(Latin) a period of three years [n TRIENNIUMS or TRIENNIA]\n",
  "TRIENNIUMS": "TRIENNIUM, (Latin) a period of three years [n]\n",
  "TRIENS": "(Latin) a coin of ancient Rome [n TRIENTES]\n",
  "TRIENTES": "TRIENS, (Latin) a coin of ancient Rome [n]\n",
  "TRIER": "one who tries, also TRIOR, TRYER [n -S]\n",
  "TRIERARCH": "(Greek) the captain of a Greek trireme; an Athenian who outfitted and maintained a trireme as part of his civic duty [n -S]\n",
  "TRIERARCHAL": "relating to a trierarch [adj]\n",
  "TRIERARCHIES": "TRIERARCHY, the civic obligation to fit out ships [n]\n",
  "TRIERARCHS": "TRIERARCH, (Greek) the captain of a Greek trireme; an Athenian who outfitted and maintained a trireme as part of his civic duty [n]\n",
  "TRIERARCHY": "the civic obligation to fit out ships [n TRIERARCHIES]\n",
  "TRIERS": "TRIER, one who tries, also TRIOR, TRYER [n]\n",
  "TRIES": "TRIE, (Spenser) to try [v]\n",
  "TRIETERIC": "occurring in alternate years [adj]\n",
  "TRIETHIODIDE": "as in gallamine triethiodide, a neuromuscular blocking agent used in anaesthesia [n -S]\n",
  "TRIETHIODIDES": "TRIETHIODIDE, as in gallamine triethiodide, a neuromuscular blocking agent used in anaesthesia [n]\n",
  "TRIETHYL": "containing three ethyl groups [adj]\n",
  "TRIETHYLAMINE": "an oily liquid corresponding to ammonia with ethyl replacing all the hydrogen [n -S]\n",
  "TRIETHYLAMINES": "TRIETHYLAMINE, an oily liquid corresponding to ammonia with ethyl replacing all the hydrogen [n]\n",
  "TRIFACIAL": "threefold and relating to the face [adj] / the trifacial nerve, the trigeminal nerve [n -S]\n",
  "TRIFACIALS": "TRIFACIAL, the trifacial nerve, the trigeminal nerve [n]\n",
  "TRIFARIOUS": "facing three ways [adj]\n",
  "TRIFECTA": "(Spanish) a wager whereby the bettor must pick the first three places in the correct order [n -S]\n",
  "TRIFECTAS": "TRIFECTA, (Spanish) a wager whereby the bettor must pick the first three places in the correct order [n]\n",
  "TRIFF": "(slang) terrific, excellent, also TRIFFIC [adj TRIFFER, TRIFFEST]\n",
  "TRIFFER": "TRIFF, (slang) terrific, excellent, also TRIFFIC [adj]\n",
  "TRIFFEST": "TRIFF, (slang) terrific, excellent, also TRIFFIC [adj]\n",
  "TRIFFIC": "(slang) terrific, excellent, also TRIFF [adj]\n",
  "TRIFFID": "a monstrous fictional plant [n -S]\n",
  "TRIFFIDIAN": "like a triffid, a monstrous (fictional) plant, also TRIFFIDY [adj]\n",
  "TRIFFIDIER": "TRIFFIDY, like a triffid, a monstrous (fictional) plant, also TRIFFIDIAN [adj]\n",
  "TRIFFIDIEST": "TRIFFIDY, like a triffid, a monstrous (fictional) plant, also TRIFFIDIAN [adj]\n",
  "TRIFFIDS": "TRIFFID, a monstrous fictional plant [n]\n",
  "TRIFFIDY": "like a triffid, a monstrous (fictional) plant, also TRIFFIDIAN [adj TRIFFIDIER, TRIFFIDIEST]\n",
  "TRIFID": "divided into three parts [adj]\n",
  "TRIFLE": "to waste time [v TRIFLED, TRIFLING, TRIFLES]\n",
  "TRIFLED": "TRIFLE, to waste time [v]\n",
  "TRIFLER": "one who trifles [n -S]\n",
  "TRIFLERS": "TRIFLER, one who trifles [n]\n",
  "TRIFLES": "TRIFLE, to waste time [v]\n",
  "TRIFLING": "trivial [adj TRIFLINGLY] / the act of wasting time [n -S]\n",
  "TRIFLINGLY": "TRIFLING, trivial [adv]\n",
  "TRIFLINGNESS": "the state of being trifling [n -ES]\n",
  "TRIFLINGNESSES": "TRIFLINGNESS, the state of being trifling [n]\n",
  "TRIFLINGS": "TRIFLING, the act of wasting time [n]\n",
  "TRIFLUOPERAZINE": "a tranquilizer chiefly used to treat psychotic conditions and esp. schizophrenia [n]\n",
  "TRIFLURALIN": "a herbicide used in the control of weeds [n -S]\n",
  "TRIFLURALINS": "TRIFLURALIN, a herbicide used in the control of weeds [n]\n",
  "TRIFOCAL": "of a lens, giving near, intermediate and far vision [adj] / a trifocal lens [n -S]\n",
  "TRIFOCALS": "TRIFOCAL, a trifocal lens [n]\n",
  "TRIFOLD": "having three parts [adj]\n",
  "TRIFOLIA": "TRIFOLIUM, (Latin) any leguminous plant of the large genus Trifolium, characterized by trifoliate leaves [n]\n",
  "TRIFOLIATE": "having three leaves or leaflets, also TRIFOLIATED [adj]\n",
  "TRIFOLIATED": "having three leaves or leaflets, also TRIFOLIATE [adj]\n",
  "TRIFOLIES": "TRIFOLY, a plant having three-lobed leaves, also TREFOIL [n]\n",
  "TRIFOLIOLATE": "of a compound leaf with three radial leaflets [adj]\n",
  "TRIFOLIUM": "(Latin) any leguminous plant of the large genus Trifolium, characterized by trifoliate leaves [n TRIFOLIA or TRIFOLIUMS]\n",
  "TRIFOLIUMS": "TRIFOLIUM, (Latin) any leguminous plant of the large genus Trifolium, characterized by trifoliate leaves [n]\n",
  "TRIFOLY": "a plant having three-lobed leaves, also TREFOIL [n TRIFOLIES]\n",
  "TRIFORIA": "TRIFORIUM, a gallery in a church [n]\n",
  "TRIFORIAL": "relating to a triforium [adj]\n",
  "TRIFORIUM": "a gallery in a church [n TRIFORIA]\n",
  "TRIFORM": "having three forms [adj]\n",
  "TRIFORMED": "having a triple form, also TRIFORM [adj]\n",
  "TRIFURCATE": "divided into three forks [adj] / to divide into three forks [v TRIFURCATED, TRIFURCATING, TRIFURCATES]\n",
  "TRIFURCATED": "TRIFURCATE, to divide into three forks [v]\n",
  "TRIFURCATES": "TRIFURCATE, to divide into three forks [v]\n",
  "TRIFURCATING": "TRIFURCATE, to divide into three forks [v]\n",
  "TRIFURCATION": "the state of being divided into three forks [n -S]\n",
  "TRIFURCATIONS": "TRIFURCATION, the state of being divided into three forks [n]\n",
  "TRIG": "(Scots) trim, neat [adj TRIGGER, TRIGGEST, TRIGLY] / to make something trig [v TRIGGED, TRIGGING, TRIGS]\n",
  "TRIGAMIES": "TRIGAMY, having three legal spouses [n]\n",
  "TRIGAMIST": "one who has been married three times; also, one who has three husbands or three wives at the same time [n -S]\n",
  "TRIGAMISTS": "TRIGAMIST, one who has been married three times; also, one who has three husbands or three wives at the same time [n]\n",
  "TRIGAMOUS": "of the nature of, involving or living in trigamy [adj]\n",
  "TRIGAMY": "having three legal spouses [n TRIGAMIES]\n",
  "TRIGEMINAL": "threefold; three-branched [adj] / a trigeminal nerve [n -S]\n",
  "TRIGEMINALS": "TRIGEMINAL, a trigeminal nerve [n]\n",
  "TRIGEMINI": "TRIGEMINUS, the trigeminal nerve [n]\n",
  "TRIGEMINUS": "the trigeminal nerve [n TRIGEMINI]\n",
  "TRIGGED": "TRIG, to make something trig [v]\n",
  "TRIGGER": "to set in action [v -ED, -ING, -S]\n",
  "TRIGGERED": "TRIGGER, to set in action [v]\n",
  "TRIGGERFISH": "a kind of fish, with a large spine on the dorsal fin which can be locked upright by a second smaller spine [n -ES]\n",
  "TRIGGERFISHES": "TRIGGERFISH, a kind of fish, with a large spine on the dorsal fin which can be locked upright by a second smaller spine [n]\n",
  "TRIGGERING": "TRIGGER, to set in action [v]\n",
  "TRIGGERLESS": "without a trigger [adj]\n",
  "TRIGGERMAN": "a gangster's bodyguard [n TRIGGERMEN]\n",
  "TRIGGERMEN": "TRIGGERMAN, a gangster's bodyguard [n]\n",
  "TRIGGERS": "TRIGGER, to set in action [v]\n",
  "TRIGGEST": "TRIG, (Scots) trim, neat [adj]\n",
  "TRIGGING": "TRIG, to make something trig [v]\n",
  "TRIGLOT": "a book written in three languages [n -S]\n",
  "TRIGLOTS": "TRIGLOT, a book written in three languages [n]\n",
  "TRIGLY": "TRIG, (Scots) trim, neat [adv]\n",
  "TRIGLYCERIDE": "any of a group of commonly occurring fats [n -S]\n",
  "TRIGLYCERIDES": "TRIGLYCERIDE, any of a group of commonly occurring fats [n]\n",
  "TRIGLYPH": "an architectural ornament [n -S]\n",
  "TRIGLYPHIC": "of or like a triglyph, also TRIGLYPHICAL [adj]\n",
  "TRIGLYPHICAL": "of or like a triglyph, also TRIGLYPHIC [adj]\n",
  "TRIGLYPHS": "TRIGLYPH, an architectural ornament [n]\n",
  "TRIGNESS": "(Scots) neatness [n -ES]\n",
  "TRIGNESSES": "TRIGNESS, (Scots) neatness [n]\n",
  "TRIGO": "a kind of wheat [n -S]\n",
  "TRIGON": "a figure having three angles; a triangle [n -S]\n",
  "TRIGONAL": "pertaining to or having three angles, also TRIGONIC [adj TRIGONALLY]\n",
  "TRIGONALLY": "TRIGONAL, pertaining to or having three angles, also TRIGONIC [adv]\n",
  "TRIGONIC": "pertaining to or having three angles, also TRIGONAL [adj]\n",
  "TRIGONOMETER": "instrument for solving triangles [n -S]\n",
  "TRIGONOMETERS": "TRIGONOMETER, instrument for solving triangles [n]\n",
  "TRIGONOMETRIC": "relating to trigonometry, also TRIGONOMETRICAL [adj]\n",
  "TRIGONOMETRICAL": "relating to trigonometry, also TRIGONOMETRIC [adj]\n",
  "TRIGONOMETRIES": "TRIGONOMETRY, the study of the properties of triangles and trigonometric functions and of their applications [n]\n",
  "TRIGONOMETRY": "the study of the properties of triangles and trigonometric functions and of their applications [n TRIGONOMETRIES]\n",
  "TRIGONOUS": "having a triangular cross-section [adj]\n",
  "TRIGONS": "TRIGON, a figure having three angles; a triangle [n]\n",
  "TRIGOS": "TRIGO, a kind of wheat [n]\n",
  "TRIGRAM": "a cluster of three successive letters [n -S]\n",
  "TRIGRAMMATIC": "relating to a trigram, also TRIGRAMMIC [adj]\n",
  "TRIGRAMMIC": "relating to a trigram, also TRIGRAMMATIC [adj]\n",
  "TRIGRAMS": "TRIGRAM, a cluster of three successive letters [n]\n",
  "TRIGRAPH": "a combination of three letters for one sound [n -S]\n",
  "TRIGRAPHIC": "of three letters, having one sound [adj]\n",
  "TRIGRAPHS": "TRIGRAPH, a combination of three letters for one sound [n]\n",
  "TRIGS": "TRIG, to make something trig [v]\n",
  "TRIGYNIAN": "having three pistils or styles, also TRIGYNOUS [adj]\n",
  "TRIGYNOUS": "having three pistils or styles, also TRIGYNIAN [adj]\n",
  "TRIHALOMETHANE": "any of various derivatives of methane such as chloroform, that have three halogen atoms per molecule and are formed esp. during the chlorination of drinking water [n -S]\n",
  "TRIHALOMETHANES": "TRIHALOMETHANE, any of various derivatives of methane such as chloroform, that have three halogen atoms per molecule and are formed esp. during the chlorination of drinking water [n]\n",
  "TRIHEDRA": "TRIHEDRON, a solid figure with three plane surfaces meeting at a point [n]\n",
  "TRIHEDRAL": "a solid having three sides or faces; thus, a trihedral angle is a solid angle bounded by three plane angles [n -S]\n",
  "TRIHEDRALS": "TRIHEDRAL, a solid having three sides or faces; thus, a trihedral angle is a solid angle bounded by three plane angles [n]\n",
  "TRIHEDRON": "a solid figure with three plane surfaces meeting at a point [n TRIHEDRONS or TRIHEDRA]\n",
  "TRIHEDRONS": "TRIHEDRON, a solid figure with three plane surfaces meeting at a point [n]\n",
  "TRIHYBRID": "a hybrid differing from its parents in three independently heritable characteristics [n -S]\n",
  "TRIHYBRIDS": "TRIHYBRID, a hybrid differing from its parents in three independently heritable characteristics [n]\n",
  "TRIHYDRATE": "a substance that contains three molecules of water [n -S]\n",
  "TRIHYDRATED": "like a trihydrate [adj]\n",
  "TRIHYDRATES": "TRIHYDRATE, a substance that contains three molecules of water [n]\n",
  "TRIHYDRIC": "having three hydroxyl groups [adj]\n",
  "TRIHYDROXY": "having three hydroxyl groups [adj]\n",
  "TRIIODOMETHANE": "another name for iodoform [n -S]\n",
  "TRIIODOMETHANES": "TRIIODOMETHANE, another name for iodoform [n]\n",
  "TRIJET": "an aeroplane powered by three jet engines [n -S]\n",
  "TRIJETS": "TRIJET, an aeroplane powered by three jet engines [n]\n",
  "TRIJUGATE": "in three pairs, also TRIJUGOUS [adj]\n",
  "TRIJUGOUS": "in three pairs, also TRIJUGATE [adj]\n",
  "TRIKE": "(colloquial) a tricycle, also TRYKE [n -S]\n",
  "TRIKES": "TRIKE, (colloquial) a tricycle, also TRYKE [n]\n",
  "TRILATERAL": "having three sides [adj TRILATERALLY] / a figure with three sides [n -S]\n",
  "TRILATERALISM": "the state of being trilateral, having three parties [n -S]\n",
  "TRILATERALISMS": "TRILATERALISM, the state of being trilateral, having three parties [n]\n",
  "TRILATERALIST": "a supporter of trilateralism [n -S]\n",
  "TRILATERALISTS": "TRILATERALIST, a supporter of trilateralism [n]\n",
  "TRILATERALLY": "TRILATERAL, having three sides [adv]\n",
  "TRILATERALS": "TRILATERAL, a figure with three sides [n]\n",
  "TRILATERATION": "a technique involving the measurement of selected sides of a triangulation network, for mapmaking, surveying, etc. [n -S]\n",
  "TRILATERATIONS": "TRILATERATION, a technique involving the measurement of selected sides of a triangulation network, for mapmaking, surveying, etc. [n]\n",
  "TRILBIED": "wearing a trilby [adj]\n",
  "TRILBIES": "TRILBY, a soft felt hat [n]\n",
  "TRILBY": "a soft felt hat [n TRILBIES or TRILBYS]\n",
  "TRILBYS": "TRILBY, a soft felt hat [n]\n",
  "TRILD": "TRILL, to play with a tremulous sound [v]\n",
  "TRILEMMA": "a dilemma-like position offering three choices [n -S]\n",
  "TRILEMMAS": "TRILEMMA, a dilemma-like position offering three choices [n]\n",
  "TRILINEAR": "of, pertaining to, or included by, three lines; as, trilinear coordinates [adj]\n",
  "TRILINEATE": "marked with three lines [adj]\n",
  "TRILINGUAL": "pertaining to, in or speaking three languages [adj TRILINGUALLY]\n",
  "TRILINGUALISM": "the state of being trilingual [n -S]\n",
  "TRILINGUALISMS": "TRILINGUALISM, the state of being trilingual [n]\n",
  "TRILINGUALLY": "TRILINGUAL, pertaining to, in or speaking three languages [adv]\n",
  "TRILITERAL": "consisting of three letters [adj] / a word with three letters [n -S]\n",
  "TRILITERALISM": "the state of being triliteral, consisting of three letters [n -S]\n",
  "TRILITERALISMS": "TRILITERALISM, the state of being triliteral, consisting of three letters [n]\n",
  "TRILITERALS": "TRILITERAL, a word with three letters [n]\n",
  "TRILITH": "(Greek) a stone monument of two upright and one transverse slab, also TRILITHON [n -S]\n",
  "TRILITHIC": "pertaining to a trilith [adj]\n",
  "TRILITHON": "(Greek) a stone monument of two upright and one transverse slab, also TRILITH [n -S]\n",
  "TRILITHONS": "TRILITHON, (Greek) a stone monument of two upright and one transverse slab, also TRILITH [n]\n",
  "TRILITHS": "TRILITH, (Greek) a stone monument of two upright and one transverse slab, also TRILITHON [n]\n",
  "TRILL": "to play with a tremulous sound [v TRILLED or (Spenser) TRILD, TRILLING, TRILLS]\n",
  "TRILLED": "TRILL, to play with a tremulous sound [v]\n",
  "TRILLER": "a kind of tropical bird [n -S]\n",
  "TRILLERS": "TRILLER, a kind of tropical bird [n]\n",
  "TRILLING": "one child of triplets [n -S]\n",
  "TRILLINGS": "TRILLING, one child of triplets [n]\n",
  "TRILLION": "a number, a million million [n -S]\n",
  "TRILLIONAIRE": "one whose wealth exceeds a trillion pounds [n -S]\n",
  "TRILLIONAIRES": "TRILLIONAIRE, one whose wealth exceeds a trillion pounds [n]\n",
  "TRILLIONS": "TRILLION, a number, a million million [n]\n",
  "TRILLIONTH": "number trillion in sequence [adj] / a trillionth part [n -S]\n",
  "TRILLIONTHS": "TRILLIONTH, a trillionth part [n]\n",
  "TRILLIUM": "a three-leaved plant of the lily family [n -S]\n",
  "TRILLIUMS": "TRILLIUM, a three-leaved plant of the lily family [n]\n",
  "TRILLO": "(Italian) a rapid alternation of two notes a tone or semitone apart, commonly ending with a turn, also TRILL [n -ES]\n",
  "TRILLOES": "TRILLO, (Italian) a rapid alternation of two notes a tone or semitone apart, commonly ending with a turn, also TRILL [n]\n",
  "TRILLS": "TRILL, to play with a tremulous sound [v]\n",
  "TRILOBAL": "having three lobes, also TRILOBED [adj]\n",
  "TRILOBATE": "having three lobes, also TRILOBATED [adj]\n",
  "TRILOBATED": "having three lobes, also TRILOBATE [adj]\n",
  "TRILOBE": "something that has three lobes [n -S]\n",
  "TRILOBED": "having three lobes [adj]\n",
  "TRILOBES": "TRILOBE, something that has three lobes [n]\n",
  "TRILOBITE": "any one of numerous species of extinct arthropods belonging to the order Trilobita [n -S]\n",
  "TRILOBITES": "TRILOBITE, any one of numerous species of extinct arthropods belonging to the order Trilobita [n]\n",
  "TRILOBITIC": "of, pertaining to or containing, trilobites; as, trilobitic rocks [adj]\n",
  "TRILOCULAR": "having three cells or cavities; as, a trilocular heart [adj]\n",
  "TRILOGIES": "TRILOGY, a group of three related literary works [n]\n",
  "TRILOGY": "a group of three related literary works [n TRILOGIES]\n",
  "TRIM": "neat [adj TRIMMER, TRIMMEST, TRIMLY] / to cut neatly [v TRIMMED, TRIMMING, TRIMS]\n",
  "TRIMARAN": "a sailing vessel [n -S]\n",
  "TRIMARANS": "TRIMARAN, a sailing vessel [n]\n",
  "TRIMER": "a substance in which molecules are formed from three molecules of a monomer [n -S]\n",
  "TRIMERIC": "of a chemical compound, having the same empirical formula but a molecular mass three times as great [adj]\n",
  "TRIMERISM": "the state of being a trimer [n -S]\n",
  "TRIMERISMS": "TRIMERISM, the state of being a trimer [n]\n",
  "TRIMEROUS": "of a flower, having the parts, esp. the petals or sepals, in threes [adj]\n",
  "TRIMERS": "TRIMER, a substance in which molecules are formed from three molecules of a monomer [n]\n",
  "TRIMESTER": "three months, an academic term [n -S]\n",
  "TRIMESTERS": "TRIMESTER, three months, an academic term [n]\n",
  "TRIMESTRAL": "relating to a trimester, a period of three months, also TRIMESTRIAL [adj]\n",
  "TRIMESTRIAL": "relating to a trimester, a period of three months, also TRIMESTRAL [adj]\n",
  "TRIMETER": "a verse of three metrical feet [n -S]\n",
  "TRIMETERS": "TRIMETER, a verse of three metrical feet [n]\n",
  "TRIMETHADIONE": "a crystalline compound with a bitter taste and camphor-like odour, used in the treatment of epilepsy [n -S]\n",
  "TRIMETHADIONES": "TRIMETHADIONE, a crystalline compound with a bitter taste and camphor-like odour, used in the treatment of epilepsy [n]\n",
  "TRIMETHOPRIM": "a synthetic antibacterial and antimalarial drug used alone or in combination with sulfamethoxazole [n -S]\n",
  "TRIMETHOPRIMS": "TRIMETHOPRIM, a synthetic antibacterial and antimalarial drug used alone or in combination with sulfamethoxazole [n]\n",
  "TRIMETHYL": "a prefix or combining form (also used adjectively) indicating the presence of three methyl groups [adj]\n",
  "TRIMETHYLAMINE": "a gas obtainable from herring-brine, corresponding to ammonia with methyl replacing all the hydrogen [n -S]\n",
  "TRIMETHYLAMINES": "TRIMETHYLAMINE, a gas obtainable from herring-brine, corresponding to ammonia with methyl replacing all the hydrogen [n]\n",
  "TRIMETHYLENE": "another name for cyclopropane [n -S]\n",
  "TRIMETHYLENES": "TRIMETHYLENE, another name for cyclopropane [n]\n",
  "TRIMETRIC": "relating to a trimeter, a verse of three measures, also TRIMETRICAL [adj]\n",
  "TRIMETRICAL": "relating to a trimeter, a verse of three measures, also TRIMETRIC [adj]\n",
  "TRIMETROGON": "a technique of aerial photography using three cameras, which increases the range and detail of the coverage [n -S]\n",
  "TRIMETROGONS": "TRIMETROGON, a technique of aerial photography using three cameras, which increases the range and detail of the coverage [n]\n",
  "TRIMIX": "a mixture of nitrogen, helium and oxygen, used by deep-sea divers [n -ES]\n",
  "TRIMIXES": "TRIMIX, a mixture of nitrogen, helium and oxygen, used by deep-sea divers [n]\n",
  "TRIMLY": "TRIM, neat [adv]\n",
  "TRIMMED": "TRIM, to cut neatly [v]\n",
  "TRIMMER": "one that trims, a politician that constantly changes his views [n -S]\n",
  "TRIMMERS": "TRIMMER, one that trims, a politician that constantly changes his views [n]\n",
  "TRIMMEST": "TRIM, neat [adj]\n",
  "TRIMMING": "something added as a decoration [n -S]\n",
  "TRIMMINGLY": "TRIMMING [adv]\n",
  "TRIMMINGS": "TRIMMING, something added as a decoration [n]\n",
  "TRIMNESS": "the state of being trim [n -ES]\n",
  "TRIMNESSES": "TRIMNESS, the state of being trim [n]\n",
  "TRIMOLECULAR": "formed from or involving three molecules [adj]\n",
  "TRIMONTHLY": "every three months [adj]\n",
  "TRIMORPH": "a substance existing in three forms [n -S]\n",
  "TRIMORPHIC": "having three forms, also TRIMORPHOUS [adj]\n",
  "TRIMORPHISM": "the property of crystallizing in three forms [n -S]\n",
  "TRIMORPHISMS": "TRIMORPHISM, the property of crystallizing in three forms [n]\n",
  "TRIMORPHOUS": "having three forms, also TRIMORPHIC [adj]\n",
  "TRIMORPHS": "TRIMORPH, a substance existing in three forms [n]\n",
  "TRIMOTOR": "an aeroplane powered by three engines [n -S]\n",
  "TRIMOTORS": "TRIMOTOR, an aeroplane powered by three engines [n]\n",
  "TRIMPHONE": "(tradename) a phone designed in the 1960s [n -S]\n",
  "TRIMPHONES": "TRIMPHONE, (tradename) a phone designed in the 1960s [n]\n",
  "TRIMPOT": "a small instrument for adjusting resistance or voltage [n -S]\n",
  "TRIMPOTS": "TRIMPOT, a small instrument for adjusting resistance or voltage [n]\n",
  "TRIMS": "TRIM, to cut neatly [v]\n",
  "TRIMTAB": "a tab on an aircraft or boat [n -S]\n",
  "TRIMTABS": "TRIMTAB, a tab on an aircraft or boat [n]\n",
  "TRIN": "a triplet by birth [n -S]\n",
  "TRINACRIAN": "three-pointed, with three extremities [adj]\n",
  "TRINACRIFORM": "three-pronged [adj]\n",
  "TRINAL": "having three parts [adj]\n",
  "TRINARY": "consisting of three parts [adj]\n",
  "TRINDLE": "to propel by causing to rotate, also TRUNDLE [v TRINDLED, TRINDLING, TRINDLES]\n",
  "TRINDLED": "TRINDLE, to propel by causing to rotate, also TRUNDLE [v]\n",
  "TRINDLES": "TRINDLE, to propel by causing to rotate, also TRUNDLE [v]\n",
  "TRINDLING": "TRINDLE, to propel by causing to rotate, also TRUNDLE [v]\n",
  "TRINE": "to place in a particular astrological position [v TRINED, TRINING, TRINES]\n",
  "TRINED": "TRINE, to place in a particular astrological position [v]\n",
  "TRINES": "TRINE, to place in a particular astrological position [v]\n",
  "TRINGLE": "a curtain-rod for a bedstead [n -S]\n",
  "TRINGLES": "TRINGLE, a curtain-rod for a bedstead [n]\n",
  "TRINING": "TRINE, to place in a particular astrological position [v]\n",
  "TRINISCOPE": "a cathode-ray tube for colour television [n -S]\n",
  "TRINISCOPES": "TRINISCOPE, a cathode-ray tube for colour television [n]\n",
  "TRINITARIAN": "one who believes in the Trinity [n -S]\n",
  "TRINITARIANS": "TRINITARIAN, one who believes in the Trinity [n]\n",
  "TRINITIES": "TRINITY, a group of three [n]\n",
  "TRINITRATE": "a nitrate with three nitrate groups in the molecule [n -S]\n",
  "TRINITRATES": "TRINITRATE, a nitrate with three nitrate groups in the molecule [n]\n",
  "TRINITRIN": "glyceryl trinitrate, used to treat angina pectoris [n -S]\n",
  "TRINITRINS": "TRINITRIN, glyceryl trinitrate, used to treat angina pectoris [n]\n",
  "TRINITROBENZENE": "a benzene compound [n]\n",
  "TRINITROCRESOL": "a yellow crystalline highly explosive compound [n -S]\n",
  "TRINITROCRESOLS": "TRINITROCRESOL, a yellow crystalline highly explosive compound [n]\n",
  "TRINITROPHENOL": "a similar derivative of phenol, esp. picric acid [n -S]\n",
  "TRINITROPHENOLS": "TRINITROPHENOL, a similar derivative of phenol, esp. picric acid [n]\n",
  "TRINITROTOLUENE": "a powerful explosive, commonly called TNT, also TRINITROTOLUOL [n]\n",
  "TRINITROTOLUOL": "a powerful explosive, commonly called TNT, also TRINITROTOLUENE [n -S]\n",
  "TRINITROTOLUOLS": "TRINITROTOLUOL, a powerful explosive, commonly called TNT, also TRINITROTOLUENE [n]\n",
  "TRINITY": "a group of three [n TRINITIES]\n",
  "TRINKET": "to have underhand dealings [v -ED, -ING, -S]\n",
  "TRINKETED": "TRINKET, to have underhand dealings [v]\n",
  "TRINKETER": "(obsolete) an intriguer [n -S]\n",
  "TRINKETERS": "TRINKETER, (obsolete) an intriguer [n]\n",
  "TRINKETING": "secret or underhand dealings [n -S]\n",
  "TRINKETINGS": "TRINKETING, secret or underhand dealings [n]\n",
  "TRINKETRIES": "TRINKETRY, trinkets, collectively [n]\n",
  "TRINKETRY": "trinkets, collectively [n TRINKETRIES]\n",
  "TRINKETS": "TRINKET, to have underhand dealings [v]\n",
  "TRINKUM": "a trinket, also TRANKUM [n -S]\n",
  "TRINKUMS": "TRINKUM, a trinket, also TRANKUM [n]\n",
  "TRINOCULAR": "relating to a binocular microscope equipped with a lens for photographic recording [adj]\n",
  "TRINODAL": "having three nodes [adj]\n",
  "TRINOMIAL": "of three terms joined by + or - [adj TRINOMIALLY] / a trinomial expression [n -S]\n",
  "TRINOMIALISM": "the system of naming by three terms [n -S]\n",
  "TRINOMIALISMS": "TRINOMIALISM, the system of naming by three terms [n]\n",
  "TRINOMIALIST": "a proponent of trinomialism [n -S]\n",
  "TRINOMIALISTS": "TRINOMIALIST, a proponent of trinomialism [n]\n",
  "TRINOMIALLY": "TRINOMIAL, of three terms joined by + or - [adv]\n",
  "TRINOMIALS": "TRINOMIAL, a trinomial expression [n]\n",
  "TRINS": "TRIN, a triplet by birth [n]\n",
  "TRINUCLEOTIDE": "a nucleotide consisting of three mononucleotides in combination [n -S]\n",
  "TRINUCLEOTIDES": "TRINUCLEOTIDE, a nucleotide consisting of three mononucleotides in combination [n]\n",
  "TRIO": "(Italian) a group of three [n -S]\n",
  "TRIODE": "a type of electron tube [n -S]\n",
  "TRIODES": "TRIODE, a type of electron tube [n]\n",
  "TRIOECIOUS": "having male, female and hermaphrodite flowers on different plants, also TRIECIOUS [adj]\n",
  "TRIOL": "a chemical compound containing three hydroxyl group [n -S]\n",
  "TRIOLEIN": "a glyceride of oleic acid, also OLEIN, OLEINE, ELAIN [n -S]\n",
  "TRIOLEINS": "TRIOLEIN, a glyceride of oleic acid, also OLEIN, OLEINE, ELAIN [n]\n",
  "TRIOLET": "a short poem of fixed form [n -S]\n",
  "TRIOLETS": "TRIOLET, a short poem of fixed form [n]\n",
  "TRIOLS": "TRIOL, a chemical compound containing three hydroxyl group [n]\n",
  "TRIONES": "(Latin) the seven stars of the Plough [n]\n",
  "TRIONYM": "a trinomial name or expression [n -S]\n",
  "TRIONYMAL": "relating to a trionym [adj]\n",
  "TRIONYMS": "TRIONYM, a trinomial name or expression [n]\n",
  "TRIOR": "(obsolete) a trier, also TRIER, TRYER [n -S]\n",
  "TRIORS": "TRIOR, (obsolete) a trier, also TRIER, TRYER [n]\n",
  "TRIOS": "TRIO, (Italian) a group of three [n]\n",
  "TRIOSE": "a simple sugar [n -S]\n",
  "TRIOSES": "TRIOSE, a simple sugar [n]\n",
  "TRIOXID": "an oxide containing three atoms of oxygen; as, sulphur trioxide, also TRIOXIDE [n -S]\n",
  "TRIOXIDE": "an oxide containing three atoms of oxygen; as, sulphur trioxide, also TRIOXID [n -S]\n",
  "TRIOXIDES": "TRIOXIDE, an oxide containing three atoms of oxygen; as, sulphur trioxide, also TRIOXID [n]\n",
  "TRIOXIDS": "TRIOXID, an oxide containing three atoms of oxygen; as, sulphur trioxide, also TRIOXIDE [n]\n",
  "TRIOXOBORIC": "designating a type of acid [adj]\n",
  "TRIOXYGEN": "a technical name for oxygen [n -S]\n",
  "TRIOXYGENS": "TRIOXYGEN, a technical name for oxygen [n]\n",
  "TRIP": "to stumble [v TRIPPED, TRIPPING, TRIPS]\n",
  "TRIPACK": "a type of film pack [n -S]\n",
  "TRIPACKS": "TRIPACK, a type of film pack [n]\n",
  "TRIPALMITIN": "another name for palmitin, a glyceride of palmitic acid [n -S]\n",
  "TRIPALMITINS": "TRIPALMITIN, another name for palmitin, a glyceride of palmitic acid [n]\n",
  "TRIPART": "divided into three parts [adj]\n",
  "TRIPARTISM": "an established system of dialogue between three related groups [n -S]\n",
  "TRIPARTISMS": "TRIPARTISM, an established system of dialogue between three related groups [n]\n",
  "TRIPARTITE": "in three parts; between three parties or States [adj TRIPARTITELY]\n",
  "TRIPARTITELY": "TRIPARTITE, in three parts; between three parties or States [adv]\n",
  "TRIPARTITION": "division into three parts [n -S]\n",
  "TRIPARTITIONS": "TRIPARTITION, division into three parts [n]\n",
  "TRIPE": "a part of the stomach of a ruminant used as food [n -S]\n",
  "TRIPEDAL": "having three feet [adj]\n",
  "TRIPEHOUND": "(slang) a newspaper reporter [n -S]\n",
  "TRIPEHOUNDS": "TRIPEHOUND, (slang) a newspaper reporter [n]\n",
  "TRIPERIES": "TRIPERY, a place that sells or processes tripe [n]\n",
  "TRIPERSONAL": "consisting of three persons [adj]\n",
  "TRIPERSONALISM": "belief in the Trinity [n -S]\n",
  "TRIPERSONALISMS": "TRIPERSONALISM, belief in the Trinity [n]\n",
  "TRIPERSONALIST": "one who believes in the Trinity [n -S]\n",
  "TRIPERSONALISTS": "TRIPERSONALIST, one who believes in the Trinity [n]\n",
  "TRIPERSONALITY": "the state of being tripersonal, consisting of three persons [n]\n",
  "TRIPERY": "a place that sells or processes tripe [n TRIPERIES]\n",
  "TRIPES": "TRIPE, a part of the stomach of a ruminant used as food [n]\n",
  "TRIPETALOUS": "three-petalled [adj]\n",
  "TRIPEY": "of or like tripe, worthless, also TRIPY [adj TRIPIER, TRIPIEST]\n",
  "TRIPHAMMER": "a power hammer that is raised or tilted by a cam and allowed to fall under gravity [n -S]\n",
  "TRIPHAMMERS": "TRIPHAMMER, a power hammer that is raised or tilted by a cam and allowed to fall under gravity [n]\n",
  "TRIPHASE": "having three phases [adj]\n",
  "TRIPHENYLAMINE": "a crystalline compound corresponding to ammonia with all the hydrogen replaced by phenyl [n -S]\n",
  "TRIPHENYLAMINES": "TRIPHENYLAMINE, a crystalline compound corresponding to ammonia with all the hydrogen replaced by phenyl [n]\n",
  "TRIPHIBIOUS": "of military operations, taking place on land, in water and in air [adj]\n",
  "TRIPHONE": "a shorthand sign representing a triphthongal sound [n -S]\n",
  "TRIPHONES": "TRIPHONE, a shorthand sign representing a triphthongal sound [n]\n",
  "TRIPHOSPHATE": "a salt or acid that contains three phosphate groups [n -S]\n",
  "TRIPHOSPHATES": "TRIPHOSPHATE, a salt or acid that contains three phosphate groups [n]\n",
  "TRIPHTHONG": "three vowel sounds pronounced as one [n -S]\n",
  "TRIPHTHONGAL": "relating to triphthong [adj]\n",
  "TRIPHTHONGS": "TRIPHTHONG, three vowel sounds pronounced as one [n]\n",
  "TRIPHYLITE": "a bluish-grey rare mineral that consists of lithium iron phosphate in orthorhombic crystalline form and occurs in pegmatites [n -S]\n",
  "TRIPHYLITES": "TRIPHYLITE, a bluish-grey rare mineral that consists of lithium iron phosphate in orthorhombic crystalline form and occurs in pegmatites [n]\n",
  "TRIPHYLLOUS": "three-leaved [adj]\n",
  "TRIPIER": "TRIPY, like tripe, worthless, also TRIPEY [adj]\n",
  "TRIPIEST": "TRIPY, like tripe, worthless, also TRIPEY [adj]\n",
  "TRIPINNATE": "three times pinnate [adj TRIPINNATELY]\n",
  "TRIPINNATELY": "TRIPINNATE, three times pinnate [adv]\n",
  "TRIPITAKA": "(Pali) the whole body of the northern Buddhist canonical writings [n -S]\n",
  "TRIPITAKAS": "TRIPITAKA, (Pali) the whole body of the northern Buddhist canonical writings [n]\n",
  "TRIPLANE": "a plane with three wings [n -S]\n",
  "TRIPLANES": "TRIPLANE, a plane with three wings [n]\n",
  "TRIPLE": "to make three times as great [v TRIPLED, TRIPLING, TRIPLES]\n",
  "TRIPLED": "TRIPLE, to make three times as great [v]\n",
  "TRIPLENESS": "the state of being triple [n -ES]\n",
  "TRIPLENESSES": "TRIPLENESS, the state of being triple [n]\n",
  "TRIPLES": "TRIPLE, to make three times as great [v]\n",
  "TRIPLET": "a group of three of one kind [n -S]\n",
  "TRIPLETAIL": "a large marine bony fish, common on the southern and middle coasts of the United States [n -S]\n",
  "TRIPLETAILS": "TRIPLETAIL, a large marine bony fish, common on the southern and middle coasts of the United States [n]\n",
  "TRIPLETS": "TRIPLET, a group of three of one kind [n]\n",
  "TRIPLEX": "to provide something in triplicate [v -ED, -ING, -ES]\n",
  "TRIPLEXED": "TRIPLEX, to provide something in triplicate [v]\n",
  "TRIPLEXES": "TRIPLEX, to provide something in triplicate [v]\n",
  "TRIPLEXING": "TRIPLEX, to provide something in triplicate [v]\n",
  "TRIPLICATE": "to make triple or threefold [v TRIPLICATED, TRIPLICATING, TRIPLICATES]\n",
  "TRIPLICATED": "TRIPLICATE, to make triple or threefold [v]\n",
  "TRIPLICATES": "TRIPLICATE, to make triple or threefold [v]\n",
  "TRIPLICATING": "TRIPLICATE, to make triple or threefold [v]\n",
  "TRIPLICATION": "the act of copying in triplicate [n -S]\n",
  "TRIPLICATIONS": "TRIPLICATION, the act of copying in triplicate [n]\n",
  "TRIPLICITIES": "TRIPLICITY, the state of being triple [n]\n",
  "TRIPLICITY": "the state of being triple [n TRIPLICITIES]\n",
  "TRIPLIED": "TRIPLY, (Scots) in Scots law, to reply to a duply [v]\n",
  "TRIPLIES": "TRIPLY, (Scots) in Scots law, to reply to a duply [v]\n",
  "TRIPLING": "the act of tripling [n -S]\n",
  "TRIPLINGS": "TRIPLING, the act of tripling [n]\n",
  "TRIPLITE": "a fluorine-phosphorus compound of iron and manganese, of a dark brown color, generally with a fibrous, massive structure [n -S]\n",
  "TRIPLITES": "TRIPLITE, a fluorine-phosphorus compound of iron and manganese, of a dark brown color, generally with a fibrous, massive structure [n]\n",
  "TRIPLOBLASTIC": "having an ectoderm, mesoderm, and endoderm, as in most animal groups other than coelenterates [adj]\n",
  "TRIPLOID": "a cell having three times the haploid number of chromosomes [n -S]\n",
  "TRIPLOIDIES": "TRIPLOIDY, the condition of being triploid [n]\n",
  "TRIPLOIDS": "TRIPLOID, a cell having three times the haploid number of chromosomes [n]\n",
  "TRIPLOIDY": "the condition of being triploid [n TRIPLOIDIES]\n",
  "TRIPLY": "(Scots) in Scots law, to reply to a duply [v TRIPLIED, TRIPLYING, TRIPLIES]\n",
  "TRIPLYING": "TRIPLY, (Scots) in Scots law, to reply to a duply [v]\n",
  "TRIPMAN": "a man hired to work on a trip [n TRIPMEN]\n",
  "TRIPMEN": "TRIPMAN, a man hired to work on a trip [n]\n",
  "TRIPMETER": "an instrument on a vehicle that shows the distance travelled on a particular trip [n -S]\n",
  "TRIPMETERS": "TRIPMETER, an instrument on a vehicle that shows the distance travelled on a particular trip [n]\n",
  "TRIPOD": "(Greek) a stand with three legs, also TRIPOS [n -S]\n",
  "TRIPODAL": "having three legs [adj]\n",
  "TRIPODIC": "relating to a tripod, also TRIPODAL [adj]\n",
  "TRIPODIES": "TRIPODY, (Greek) a verse of three metrical feet [n]\n",
  "TRIPODS": "TRIPOD, (Greek) a stand with three legs, also TRIPOS [n]\n",
  "TRIPODY": "(Greek) a verse of three metrical feet [n TRIPODIES]\n",
  "TRIPOLI": "an earthy substance originally brought from Tripoli, used in polishing stones and metals, aka diatomite [n -S]\n",
  "TRIPOLIS": "TRIPOLI, an earthy substance originally brought from Tripoli, used in polishing stones and metals, aka diatomite [n]\n",
  "TRIPOS": "(Latin) a final honors examination at Cambridge university, originally in Mathematics [n -ES]\n",
  "TRIPOSES": "TRIPOS, (Latin) a final honors examination at Cambridge university, originally in Mathematics [n]\n",
  "TRIPPANT": "tripping [adj]\n",
  "TRIPPED": "TRIP, to stumble [v]\n",
  "TRIPPER": "one who goes on trips [n -S]\n",
  "TRIPPERIER": "TRIPPERY, like a (vulgar) tripper [adj]\n",
  "TRIPPERIEST": "TRIPPERY, like a (vulgar) tripper [adj]\n",
  "TRIPPERISH": "of or like a vulgar, noisy tripper [adj]\n",
  "TRIPPERS": "TRIPPER, one who goes on trips [n]\n",
  "TRIPPERY": "like a (vulgar) tripper [adj TRIPPERIER, TRIPPERIEST]\n",
  "TRIPPET": "a trivet which strikes another mechanism regularly [n -S]\n",
  "TRIPPETS": "TRIPPET, a trivet which strikes another mechanism regularly [n]\n",
  "TRIPPIER": "TRIPPY, suggesting a trip on psychedelic drugs [adj]\n",
  "TRIPPIEST": "TRIPPY, suggesting a trip on psychedelic drugs [adj]\n",
  "TRIPPING": "the act of one that trips [n -S]\n",
  "TRIPPINGLY": "TRIPPING [adv]\n",
  "TRIPPINGS": "TRIPPING, the act of one that trips [n]\n",
  "TRIPPLE": "(South African) a horse's ambling canter, between a fast walk and a trot [n -S] / to proceed at this pace [v TRIPPLED, TRIPPLING, TRIPPLES]\n",
  "TRIPPLED": "TRIPPLE, to proceed at this pace [v]\n",
  "TRIPPLER": "(South African) a horse that tripples, proceeds at a pace between a walk and a trot [n -S]\n",
  "TRIPPLERS": "TRIPPLER, (South African) a horse that tripples, proceeds at a pace between a walk and a trot [n]\n",
  "TRIPPLES": "TRIPPLE, to proceed at this pace [v]\n",
  "TRIPPLING": "TRIPPLE, to proceed at this pace [v]\n",
  "TRIPPY": "suggesting a trip on psychedelic drugs [adj TRIPPIER, TRIPPIEST]\n",
  "TRIPS": "TRIP, to stumble [v]\n",
  "TRIPSES": "TRIPSIS, (Greek) pulverization [n]\n",
  "TRIPSIS": "(Greek) pulverization [n TRIPSES]\n",
  "TRIPTAN": "a drug for treating migraine attacks [n -S]\n",
  "TRIPTANE": "trimethyl butane, a powerful aviation fuel [n -S]\n",
  "TRIPTANES": "TRIPTANE, trimethyl butane, a powerful aviation fuel [n]\n",
  "TRIPTANS": "TRIPTAN, a drug for treating migraine attacks [n]\n",
  "TRIPTEROUS": "three-winged [adj]\n",
  "TRIPTOTE": "a noun that has three grammatical cases only [n -S]\n",
  "TRIPTOTES": "TRIPTOTE, a noun that has three grammatical cases only [n]\n",
  "TRIPTYCA": "a painting in three parts, esp. altar piece with one central and two hinged side panels, also TRIPTYCH [n -S]\n",
  "TRIPTYCAS": "TRIPTYCA, a painting in three parts, esp. altar piece with one central and two hinged side panels, also TRIPTYCH [n]\n",
  "TRIPTYCH": "a painting in three parts, esp. an altar piece with one central and two hinged side panels, also TRIPTYCA [n -S]\n",
  "TRIPTYCHS": "TRIPTYCH, a painting in three parts, esp. an altar piece with one central and two hinged side panels, also TRIPTYCA [n]\n",
  "TRIPTYQUE": "(French) an international pass for a motorcar [n -S]\n",
  "TRIPTYQUES": "TRIPTYQUE, (French) an international pass for a motorcar [n]\n",
  "TRIPUDIA": "TRIPUDIUM, (Latin) an ancient Roman religious dance in triple time [n]\n",
  "TRIPUDIARY": "of or pertaining to the tripudium [adj]\n",
  "TRIPUDIATE": "to dance for joy; to exult; to stamp [v TRIPUDIATED, TRIPUDIATING, TRIPUDIATES]\n",
  "TRIPUDIATED": "TRIPUDIATE, to dance for joy; to exult; to stamp [v]\n",
  "TRIPUDIATES": "TRIPUDIATE, to dance for joy; to exult; to stamp [v]\n",
  "TRIPUDIATING": "TRIPUDIATE, to dance for joy; to exult; to stamp [v]\n",
  "TRIPUDIATION": "dancing for joy [n -S]\n",
  "TRIPUDIATIONS": "TRIPUDIATION, dancing for joy [n]\n",
  "TRIPUDIUM": "(Latin) an ancient Roman religious dance in triple time [n TRIPUDIA]\n",
  "TRIPWIRE": "a low-placed hidden wire [n -S]\n",
  "TRIPWIRES": "TRIPWIRE, a low-placed hidden wire [n]\n",
  "TRIPY": "like tripe, worthless, also TRIPEY [adj TRIPIER, TRIPIEST]\n",
  "TRIQUETRA": "(Latin) a symmetrical triangular ornament formed of three interlaced arcs or lobes [n TRIQUETRAE or TRIQUETRAS]\n",
  "TRIQUETRAE": "TRIQUETRA, (Latin) a symmetrical triangular ornament formed of three interlaced arcs or lobes [n]\n",
  "TRIQUETRAL": "triangular; three-edged with concave faces, also TRIQUETROUS [adj]\n",
  "TRIQUETRAS": "TRIQUETRA, (Latin) a symmetrical triangular ornament formed of three interlaced arcs or lobes [n]\n",
  "TRIQUETROUS": "triangular; three-edged with concave faces, also TRIQUETRAL [adj TRIQUETROUSLY]\n",
  "TRIQUETROUSLY": "TRIQUETROUS, triangular; three-edged with concave faces, also TRIQUETRAL [adv]\n",
  "TRIQUETRUM": "one of the bones of the carpus [n TRIQUETRA]\n",
  "TRIRADIAL": "three-rayed, also TRIRADIATE [adj]\n",
  "TRIRADIATE": "three-rayed, also TRIRADIAL [adj TRIRADIATELY]\n",
  "TRIRADIATELY": "TRIRADIATE, three-rayed, also TRIRADIAL [adv]\n",
  "TRIREME": "(Latin) an ancient Greek or Roman warship [n -S]\n",
  "TRIREMES": "TRIREME, (Latin) an ancient Greek or Roman warship [n]\n",
  "TRISACCHARIDE": "a sugar that yields on complete hydrolysis three monosaccharide molecules [n -S]\n",
  "TRISACCHARIDES": "TRISACCHARIDE, a sugar that yields on complete hydrolysis three monosaccharide molecules [n]\n",
  "TRISAGION": "an ancient hymn consisting of the words 'O Holy God, holy and mighty, holy and immortal, have mercy on us'; loosely, the Tersanctus [n -S]\n",
  "TRISAGIONS": "TRISAGION, an ancient hymn consisting of the words 'O Holy God, holy and mighty, holy and immortal, have mercy on us'; loosely, the Tersanctus [n]\n",
  "TRISCELE": "a figure consisting of three radiating curves or legs, also TRISKELE, TRISKELION [n -S]\n",
  "TRISCELES": "TRISCELE, a figure consisting of three radiating curves or legs, also TRISKELE, TRISKELION [n]\n",
  "TRISECT": "to divide into three equal parts [v -ED, -ING, -S]\n",
  "TRISECTED": "TRISECT, to divide into three equal parts [v]\n",
  "TRISECTING": "TRISECT, to divide into three equal parts [v]\n",
  "TRISECTION": "the act of trisecting [n -S]\n",
  "TRISECTIONS": "TRISECTION, the act of trisecting [n]\n",
  "TRISECTOR": "one who trisects [n -S]\n",
  "TRISECTORS": "TRISECTOR, one who trisects [n]\n",
  "TRISECTRICES": "TRISECTRIX, a certain curve of a polar equation [n]\n",
  "TRISECTRIX": "a certain curve of a polar equation [n TRISECTRICES]\n",
  "TRISECTS": "TRISECT, to divide into three equal parts [v]\n",
  "TRISEME": "(Greek) a type of metrical foot [n -S]\n",
  "TRISEMES": "TRISEME, (Greek) a type of metrical foot [n]\n",
  "TRISEMIC": "relating to a triseme, a foot containing three short syllables [adj]\n",
  "TRISERIAL": "arranged in three rows or series [adj]\n",
  "TRISHAW": "a three-wheeled taxi bike [n -S]\n",
  "TRISHAWS": "TRISHAW, a three-wheeled taxi bike [n]\n",
  "TRISKELE": "a figure consisting of three radiating curves or legs, also TRISCELE, TRISKELION [n -S]\n",
  "TRISKELES": "TRISKELE, a figure consisting of three radiating curves or legs, also TRISCELE, TRISKELION [n]\n",
  "TRISKELIA": "TRISKELION, a figure consisting of three radiating curves or legs, also TRISCELE, TRISKELE [n]\n",
  "TRISKELION": "a figure consisting of three radiating curves or legs, also TRISCELE, TRISKELE [n TRISKELIONS or TRISKELIA]\n",
  "TRISKELIONS": "TRISKELION, a figure consisting of three radiating curves or legs, also TRISCELE, TRISKELE [n]\n",
  "TRISMIC": "relating to trismus, lockjaw [adj]\n",
  "TRISMUS": "(Latin) a tetanic spasm of the muscles of the jaw, aka lockjaw [n -ES]\n",
  "TRISMUSES": "TRISMUS, (Latin) a tetanic spasm of the muscles of the jaw, aka lockjaw [n]\n",
  "TRISOCTAHEDRA": "TRISOCTAHEDRON, a solid figure having 24 congruent faces and an octahedron as a base [n]\n",
  "TRISOCTAHEDRAL": "having the form of a trisoctahedron [adj]\n",
  "TRISOCTAHEDRON": "a solid figure having 24 congruent faces and an octahedron as a base [n TRISOCTAHEDRA or TRISOCTAHEDRONS]\n",
  "TRISOCTAHEDRONS": "TRISOCTAHEDRON, a solid figure having 24 congruent faces and an octahedron as a base [n]\n",
  "TRISODIUM": "containing three sodium atoms [adj]\n",
  "TRISOME": "a chromosome that occurs three times in a cell instead of twice, also TRISOMIC [n -S]\n",
  "TRISOMES": "TRISOME, a chromosome that occurs three times in a cell instead of twice, also TRISOMIC [n]\n",
  "TRISOMIC": "a chromosome that occurs three times in a cell instead of two, also TRISOME [n -S]\n",
  "TRISOMICS": "TRISOMIC, a chromosome that occurs three times in a cell instead of two, also TRISOME [n]\n",
  "TRISOMIES": "TRISOMY, the condition of being a trisome [n]\n",
  "TRISOMY": "the condition of being a trisome [n TRISOMIES]\n",
  "TRIST": "(archaic) sad, also TRISTE, TRISTFUL [adj]\n",
  "TRISTATE": "pertaining to an area made up of three adjoining states [adj]\n",
  "TRISTE": "(archaic) sad, also TRIST, TRISTFUL [adj]\n",
  "TRISTEARIN": "another name for stearin, also STEARIN, STEARINE [n -S]\n",
  "TRISTEARINS": "TRISTEARIN, another name for stearin, also STEARIN, STEARINE [n]\n",
  "TRISTESSE": "(French) melancholy [n -S]\n",
  "TRISTESSES": "TRISTESSE, (French) melancholy [n]\n",
  "TRISTEZA": "(Portuguese) a disease of citrus trees [n -S]\n",
  "TRISTEZAS": "TRISTEZA, (Portuguese) a disease of citrus trees [n]\n",
  "TRISTFUL": "(Shakespeare) sad, mournful, also TRIST, TRISTE [adj TRISTFULLY]\n",
  "TRISTFULLY": "TRISTFUL, (Shakespeare) sad, mournful, also TRIST, TRISTE [adv]\n",
  "TRISTFULNESS": "the state of being tristful [n -ES]\n",
  "TRISTFULNESSES": "TRISTFULNESS, the state of being tristful [n]\n",
  "TRISTICH": "a stanza of three lines [n -S]\n",
  "TRISTICHIC": "relating to a tristich, a stanza of three lines [adj]\n",
  "TRISTICHOUS": "in or having three rows [adj]\n",
  "TRISTICHS": "TRISTICH, a stanza of three lines [n]\n",
  "TRISTIMULUS": "as in tristimulus values, amounts of each of three colour primaries that must be combined to form an objective colour match with a sample [adj]\n",
  "TRISUBSTITUTED": "having three substituent atoms or groups in the molecule [adj]\n",
  "TRISUL": "(Sanskrit) the trident of Siva, also TRISULA [n -S]\n",
  "TRISULA": "(Sanskrit) the trident of Siva, also TRISUL [n -S]\n",
  "TRISULAS": "TRISULA, (Sanskrit) the trident of Siva, also TRISUL [n]\n",
  "TRISULCATE": "having three ridges or forks [adj]\n",
  "TRISULFIDE": "a sulphide with three atoms of sulphur to the molecule, also TRISULPHIDE [n -S]\n",
  "TRISULFIDES": "TRISULFIDE, a sulphide with three atoms of sulphur to the molecule, also TRISULPHIDE [n]\n",
  "TRISULPHIDE": "a sulphide with three atoms of sulphur to the molecule, also TRISULFIDE [n -S]\n",
  "TRISULPHIDES": "TRISULPHIDE, a sulphide with three atoms of sulphur to the molecule, also TRISULFIDE [n]\n",
  "TRISULS": "TRISUL, (Sanskrit) the trident of Siva, also TRISULA [n]\n",
  "TRISYLLABIC": "having three syllables, also TRISYLLABICAL [adj TRISYLLABICALLY]\n",
  "TRISYLLABICAL": "having three syllables, also TRISYLLABIC [adj TRISYLLABICALLY]\n",
  "TRISYLLABICALLY": "TRISYLLABICAL, having three syllables, also TRISYLLABIC [adv]\n",
  "TRISYLLABLE": "a word with three syllables [n -S]\n",
  "TRISYLLABLES": "TRISYLLABLE, a word with three syllables [n]\n",
  "TRITAGONIST": "in Greek drama, the actor who plays the role third in importance in a play [n -S]\n",
  "TRITAGONISTS": "TRITAGONIST, in Greek drama, the actor who plays the role third in importance in a play [n]\n",
  "TRITANOPE": "one suffering from tritanopia, the inability to distinguish the colour blue [n -S]\n",
  "TRITANOPES": "TRITANOPE, one suffering from tritanopia, the inability to distinguish the colour blue [n]\n",
  "TRITANOPIA": "the inability to distinguish properly between blue and yellow [n -S]\n",
  "TRITANOPIAS": "TRITANOPIA, the inability to distinguish properly between blue and yellow [n]\n",
  "TRITANOPIC": "relating to tritanopia, the inability to distinguish properly between blue and yellow [adj]\n",
  "TRITE": "banal, commonplace [adj TRITER, TRITEST, TRITELY] / in Greek music, the third string of the lyre [n -S]\n",
  "TRITELY": "TRITE, banal, commonplace [adv]\n",
  "TRITENESS": "the state of being trite [n -ES]\n",
  "TRITENESSES": "TRITENESS, the state of being trite [n]\n",
  "TRITER": "TRITE, banal, commonplace [adj]\n",
  "TRITERNATE": "thrice ternate, i.e. ternate with each division ternate, and each again ternate [adj]\n",
  "TRITES": "TRITE, in Greek music, the third string of the lyre [n]\n",
  "TRITEST": "TRITE, banal, commonplace [adj]\n",
  "TRITHEISM": "the belief that the members of the Trinity are separate gods [n -S]\n",
  "TRITHEISMS": "TRITHEISM, the belief that the members of the Trinity are separate gods [n]\n",
  "TRITHEIST": "one believing that the members of Trinity are three separate gods [n -S]\n",
  "TRITHEISTIC": "relating to tritheism, also TRITHEISTICAL [adj]\n",
  "TRITHEISTICAL": "relating to tritheism, also TRITHEISTIC [adj]\n",
  "TRITHEISTS": "TRITHEIST, one believing that the members of Trinity are three separate gods [n]\n",
  "TRITHING": "an administrative division in England [n -S]\n",
  "TRITHINGS": "TRITHING, an administrative division in England [n]\n",
  "TRITHIONATE": "a salt of trithionic acid [n -S]\n",
  "TRITHIONATES": "TRITHIONATE, a salt of trithionic acid [n]\n",
  "TRITHIONIC": "designating a certain thionic acid [adj]\n",
  "TRITIATE": "to replace atoms by tritium [v TRITIATED, TRITIATING, TRITIATES]\n",
  "TRITIATED": "TRITIATE, to replace atoms by tritium [v]\n",
  "TRITIATES": "TRITIATE, to replace atoms by tritium [v]\n",
  "TRITIATING": "TRITIATE, to replace atoms by tritium [v]\n",
  "TRITIATION": "the act of tritiating [n -S]\n",
  "TRITIATIONS": "TRITIATION, the act of tritiating [n]\n",
  "TRITICAL": "trite; common [adj TRITICALLY]\n",
  "TRITICALE": "a hybrid of wheat and rye [n -S]\n",
  "TRITICALES": "TRITICALE, a hybrid of wheat and rye [n]\n",
  "TRITICALLY": "TRITICAL, trite; common [adv]\n",
  "TRITICALNESS": "the state of being tritical, trite [n -ES]\n",
  "TRITICALNESSES": "TRITICALNESS, the state of being tritical, trite [n]\n",
  "TRITICEOUS": "wheat-like [adj]\n",
  "TRITICISM": "a trite remark [n -S]\n",
  "TRITICISMS": "TRITICISM, a trite remark [n]\n",
  "TRITICUM": "(Latin) a genus of grasses including the various species of wheat [n -S]\n",
  "TRITICUMS": "TRITICUM, (Latin) a genus of grasses including the various species of wheat [n]\n",
  "TRITIDE": "a compound of tritium [n -S]\n",
  "TRITIDES": "TRITIDE, a compound of tritium [n]\n",
  "TRITIUM": "an isotope of hydrogen [n -S]\n",
  "TRITIUMS": "TRITIUM, an isotope of hydrogen [n]\n",
  "TRITOMA": "a flowering African plant, aka kniphofia [n -S]\n",
  "TRITOMAS": "TRITOMA, a flowering African plant, aka kniphofia [n]\n",
  "TRITON": "a kind of marine mollusk [n -S]\n",
  "TRITONE": "a musical interval of three whole tones [n -S]\n",
  "TRITONES": "TRITONE, a musical interval of three whole tones [n]\n",
  "TRITONIA": "a South African iridaceous plant [n -S]\n",
  "TRITONIAS": "TRITONIA, a South African iridaceous plant [n]\n",
  "TRITONS": "TRITON, a kind of marine mollusk [n]\n",
  "TRITUBERCULAR": "having three tubercles or cusps, also TRITUBERCULATE [adj]\n",
  "TRITUBERCULATE": "having three tubercles or cusps, also TRITUBERCULAR [adj]\n",
  "TRITUBERCULIES": "TRITUBERCULY, the state of being tritubercular, having three tubercles or cusps [n]\n",
  "TRITUBERCULISM": "the state of being tritubercular [n -S]\n",
  "TRITUBERCULISMS": "TRITUBERCULISM, the state of being tritubercular [n]\n",
  "TRITUBERCULY": "the state of being tritubercular, having three tubercles or cusps [n TRITUBERCULIES]\n",
  "TRITURABLE": "capable of being triturated [adj]\n",
  "TRITURATE": "to crush or grind to a fine powder [v TRITURATED, TRITURATING, TRITURATES]\n",
  "TRITURATED": "TRITURATE, to crush or grind to a fine powder [v]\n",
  "TRITURATES": "TRITURATE, to crush or grind to a fine powder [v]\n",
  "TRITURATING": "TRITURATE, to crush or grind to a fine powder [v]\n",
  "TRITURATION": "the act of triturating [n -S]\n",
  "TRITURATIONS": "TRITURATION, the act of triturating [n]\n",
  "TRITURATOR": "an apparatus for triturating [n -S]\n",
  "TRITURATORS": "TRITURATOR, an apparatus for triturating [n]\n",
  "TRIUMPH": "to be victorious [v -ED, -ING, -S]\n",
  "TRIUMPHAL": "relating to triumph [adj] / (Milton) a token of victory [n -S]\n",
  "TRIUMPHALISM": "belief in the superiority of one particular religious creed [n -S]\n",
  "TRIUMPHALISMS": "TRIUMPHALISM, belief in the superiority of one particular religious creed [n]\n",
  "TRIUMPHALIST": "one who engages in triumphalism [n -S]\n",
  "TRIUMPHALISTS": "TRIUMPHALIST, one who engages in triumphalism [n]\n",
  "TRIUMPHALS": "TRIUMPHAL, (Milton) a token of victory [n]\n",
  "TRIUMPHANT": "victorious, conquering [adj TRIUMPHANTLY]\n",
  "TRIUMPHANTLY": "TRIUMPHANT, victorious, conquering [adv]\n",
  "TRIUMPHED": "TRIUMPH, to be victorious [v]\n",
  "TRIUMPHER": "one who was honored with a triumph; a victor [n -S]\n",
  "TRIUMPHERIES": "TRIUMPHERY, (Shakespeare) a triumvir [n]\n",
  "TRIUMPHERS": "TRIUMPHER, one who was honored with a triumph; a victor [n]\n",
  "TRIUMPHERY": "(Shakespeare) a triumvir [n TRIUMPHERIES]\n",
  "TRIUMPHING": "the act of triumphing [n -S]\n",
  "TRIUMPHINGS": "TRIUMPHING, the act of triumphing [n]\n",
  "TRIUMPHS": "TRIUMPH, to be victorious [v]\n",
  "TRIUMVIR": "(Latin) one of a ruling body of three in ancient Rome [n TRIUMVIRS or TRIUMVIRI]\n",
  "TRIUMVIRAL": "of a like a triumvir [adj]\n",
  "TRIUMVIRATE": "a body of triumvirs [n -S]\n",
  "TRIUMVIRATES": "TRIUMVIRATE, a body of triumvirs [n]\n",
  "TRIUMVIRI": "TRIUMVIR, (Latin) one of a ruling body of three in ancient Rome [n]\n",
  "TRIUMVIRIES": "TRIUMVIRY, (obsolete) a triumvirate [n]\n",
  "TRIUMVIRS": "TRIUMVIR, (Latin) one of a ruling body of three in ancient Rome [n]\n",
  "TRIUMVIRY": "(obsolete) a triumvirate [n TRIUMVIRIES]\n",
  "TRIUNE": "a trinity, also TRIUNITY [n -S]\n",
  "TRIUNES": "TRIUNE, a trinity, also TRIUNITY [n]\n",
  "TRIUNITIES": "TRIUNITY, a trinity, also TRIUNE [n]\n",
  "TRIUNITY": "a trinity, also TRIUNE [n TRIUNITIES]\n",
  "TRIVALENCE": "the state of being trivalent, also TERVALENCY, TRIVALENCY [n -S]\n",
  "TRIVALENCES": "TRIVALENCE, the state of being trivalent, also TERVALENCY, TRIVALENCY [n]\n",
  "TRIVALENCIES": "TRIVALENCY, the state of being trivalent, also TERVALENCY, TRIVALENCE [n]\n",
  "TRIVALENCY": "the state of being trivalent, also TERVALENCY, TRIVALENCE [n TRIVALENCIES]\n",
  "TRIVALENT": "having a valency of three [adj]\n",
  "TRIVALVE": "a type of shell with three valves [n -S]\n",
  "TRIVALVED": "having three valves [adj]\n",
  "TRIVALVES": "TRIVALVE, a type of shell with three valves [n]\n",
  "TRIVALVULAR": "having three valves [adj]\n",
  "TRIVET": "a small stand with three legs, also TREVET [n -S]\n",
  "TRIVETS": "TRIVET, a small stand with three legs, also TREVET [n]\n",
  "TRIVIA": "TRIVIUM, (Latin) a group of studies in medieval schools [n]\n",
  "TRIVIAL": "insignificant [adj TRIVIALLY]\n",
  "TRIVIALISATION": "the act of trivialising, also TRIVIALIZATION [n -S]\n",
  "TRIVIALISATIONS": "TRIVIALISATION, the act of trivialising, also TRIVIALIZATION [n]\n",
  "TRIVIALISE": "to make trivial, also TRIVIALIZE [v TRIVIALISED, TRIVIALISING, TRIVIALISES]\n",
  "TRIVIALISED": "TRIVIALISE, to make trivial, also TRIVIALIZE [v]\n",
  "TRIVIALISES": "TRIVIALISE, to make trivial, also TRIVIALIZE [v]\n",
  "TRIVIALISING": "TRIVIALISE, to make trivial, also TRIVIALIZE [v]\n",
  "TRIVIALISM": "a trivial matter or method [n -S]\n",
  "TRIVIALISMS": "TRIVIALISM, a trivial matter or method [n]\n",
  "TRIVIALIST": "a maker of trivial remarks etc. [n -S]\n",
  "TRIVIALISTS": "TRIVIALIST, a maker of trivial remarks etc. [n]\n",
  "TRIVIALITIES": "TRIVIALITY, the state of being trivia [n]\n",
  "TRIVIALITY": "the state of being trivia [n TRIVIALITIES]\n",
  "TRIVIALIZATION": "the act of trivializing, also TRIVIALISATION [n -S]\n",
  "TRIVIALIZATIONS": "TRIVIALIZATION, the act of trivializing, also TRIVIALISATION [n]\n",
  "TRIVIALIZE": "to make trivial, also TRIVIALISE [v TRIVIALIZED, TRIVIALIZING, TRIVIALIZES]\n",
  "TRIVIALIZED": "TRIVIALIZE, to make trivial, also TRIVIALISE [v]\n",
  "TRIVIALIZES": "TRIVIALIZE, to make trivial, also TRIVIALISE [v]\n",
  "TRIVIALIZING": "TRIVIALIZE, to make trivial, also TRIVIALISE [v]\n",
  "TRIVIALLY": "TRIVIAL, insignificant [adv]\n",
  "TRIVIALNESS": "the state of being trivial [n -ES]\n",
  "TRIVIALNESSES": "TRIVIALNESS, the state of being trivial [n]\n",
  "TRIVIUM": "(Latin) a group of studies in medieval schools [n TRIVIUMS or TRIVIA]\n",
  "TRIVIUMS": "TRIVIUM, (Latin) a group of studies in medieval schools [n]\n",
  "TRIWEEKLIES": "TRIWEEKLY, a publication appearing three times a week or every three weeks [n]\n",
  "TRIWEEKLY": "occurring or appearing three times a week or every three weeks [adj] / a publication appearing three times a week or every three weeks [n TRIWEEKLIES]\n",
  "TRIZONAL": "having three zones [adj]\n",
  "TRIZONE": "a country formed of three zones [n -S]\n",
  "TRIZONES": "TRIZONE, a country formed of three zones [n]\n",
  "TROAD": "(Spenser) a track, path, also TROADE, TROD, TRODE [n -S]\n",
  "TROADE": "(Spenser) a track, path, also TROAD, TROD, TRODE [n -S]\n",
  "TROADES": "TROADE, (Spenser) a track, path, also TROAD, TROD, TRODE [n]\n",
  "TROADS": "TROAD, (Spenser) a track, path, also TROADE, TROD, TRODE [n]\n",
  "TROAK": "(Scots) to barter, also TROCK, TROKE [v -ED, -ING, -S]\n",
  "TROAKED": "TROAK, (Scots) to barter, also TROCK, TROKE [v]\n",
  "TROAKING": "TROAK, (Scots) to barter, also TROCK, TROKE [v]\n",
  "TROAKS": "TROAK, (Scots) to barter, also TROCK, TROKE [v]\n",
  "TROAT": "to bellow like a roaring buck [v -ED, -ING, -S]\n",
  "TROATED": "TROAT, to bellow like a roaring buck [v]\n",
  "TROATING": "TROAT, to bellow like a roaring buck [v]\n",
  "TROATS": "TROAT, to bellow like a roaring buck [v]\n",
  "TROCAR": "a surgical instrument, a kind of stylet, also TROCHAR [n -S]\n",
  "TROCARS": "TROCAR, a surgical instrument, a kind of stylet, also TROCHAR [n]\n",
  "TROCHAIC": "of or like a trochee, in prosody, a foot of one long syllable, one short [adj TROCHAICALLY] / a trochaic verse [n -S]\n",
  "TROCHAICALLY": "TROCHAIC, of or like a trochee, in prosody, a foot of one long syllable, one short [adv]\n",
  "TROCHAICS": "TROCHAIC, a trochaic verse [n]\n",
  "TROCHAL": "shaped like a wheel [adj]\n",
  "TROCHANTER": "a rough eminence on the thigh bone to which muscles are attached [n -S]\n",
  "TROCHANTERAL": "of or like a trochanter, a rough eminence on the thigh bone to which muscles are attached, also TROCHANTERIC [adj]\n",
  "TROCHANTERIC": "of or like a trochanter, a rough eminence on the thigh bone to which muscles are attached, also TROCHANTERAL [adj]\n",
  "TROCHANTERS": "TROCHANTER, a rough eminence on the thigh bone to which muscles are attached [n]\n",
  "TROCHAR": "a surgical instrument, a kind of stylet, also TROCAR [n -S]\n",
  "TROCHARS": "TROCHAR, a surgical instrument, a kind of stylet, also TROCAR [n]\n",
  "TROCHE": "a medicinal lozenge, also TROCHISCUS, TROCHISK [n -S]\n",
  "TROCHEAMETER": "a hodometer, also TROCHOMETER [n -S]\n",
  "TROCHEAMETERS": "TROCHEAMETER, a hodometer, also TROCHOMETER [n]\n",
  "TROCHEE": "(Greek) a type of metrical foot, also TROCHAIC [n -S]\n",
  "TROCHEES": "TROCHEE, (Greek) a type of metrical foot, also TROCHAIC [n]\n",
  "TROCHELMINTH": "any invertebrate of the former taxonomic group Trochelminthes, which included the rotifers and gastrotrichs [n -S]\n",
  "TROCHELMINTHS": "TROCHELMINTH, any invertebrate of the former taxonomic group Trochelminthes, which included the rotifers and gastrotrichs [n]\n",
  "TROCHES": "TROCHE, a medicinal lozenge, also TROCHISCUS, TROCHISK [n]\n",
  "TROCHI": "TROCHUS, (Greek) a genus of gastropods, the top-shells [n]\n",
  "TROCHIL": "(Greek) an African bird, aka crocodile bird, also TROCHILUS [n -S]\n",
  "TROCHILI": "TROCHILUS, (Greek) an African bird, also TROCHIL [n]\n",
  "TROCHILIC": "of or relating to rotatory motion [adj]\n",
  "TROCHILS": "TROCHIL, (Greek) an African bird, aka crocodile bird, also TROCHILUS [n]\n",
  "TROCHILUS": "(Greek) an African bird, also TROCHIL [n TROCHILUSES or TROCHILI]\n",
  "TROCHILUSES": "TROCHILUS, (Greek) an African bird, also TROCHIL [n]\n",
  "TROCHISCI": "TROCHISCUS, a kind of tablet or lozenge, also TROCHE, TROCHISK [n]\n",
  "TROCHISCUS": "a kind of tablet or lozenge, also TROCHE, TROCHISK [n TROCHISCI or TROCHISCUSES]\n",
  "TROCHISCUSES": "TROCHISCUS, a kind of tablet or lozenge, also TROCHE, TROCHISK [n]\n",
  "TROCHISK": "a medicinal lozenge, also TROCHE, TROCHISCUS [n -S]\n",
  "TROCHISKS": "TROCHISK, a medicinal lozenge, also TROCHE, TROCHISCUS [n]\n",
  "TROCHITE": "a wheel-like joint of the stem of a fossil crinoid [n -S]\n",
  "TROCHITES": "TROCHITE, a wheel-like joint of the stem of a fossil crinoid [n]\n",
  "TROCHLEA": "(Latin) a pulley-like structure through which a tendon passes [n TROCHLEAS or TROCHLEAE]\n",
  "TROCHLEAE": "TROCHLEA, (Latin) a pulley-like structure through which a tendon passes [n]\n",
  "TROCHLEAR": "the trochlear (pulley-shaped) muscle of the eye [n -S]\n",
  "TROCHLEARS": "TROCHLEAR, the trochlear (pulley-shaped) muscle of the eye [n]\n",
  "TROCHLEAS": "TROCHLEA, (Latin) a pulley-like structure through which a tendon passes [n]\n",
  "TROCHOID": "a geometric curve traced by a fixed point in plane of a circle [n -S]\n",
  "TROCHOIDAL": "of or pertaining to a trochoid [adj TROCHOIDALLY]\n",
  "TROCHOIDALLY": "TROCHOIDAL, of or pertaining to a trochoid [adv]\n",
  "TROCHOIDS": "TROCHOID, a geometric curve traced by a fixed point in plane of a circle [n]\n",
  "TROCHOMETER": "a hodometer, also TROCHEAMETER [n -S]\n",
  "TROCHOMETERS": "TROCHOMETER, a hodometer, also TROCHEAMETER [n]\n",
  "TROCHOPHORE": "a free-swimming pelagic form of many invertebrates, also TROCHOSPHERE [n -S]\n",
  "TROCHOPHORES": "TROCHOPHORE, a free-swimming pelagic form of many invertebrates, also TROCHOSPHERE [n]\n",
  "TROCHOSPHERE": "a free-swimming pelagic form of many invertebrates, also TROCHOPHORE [n -S]\n",
  "TROCHOSPHERES": "TROCHOSPHERE, a free-swimming pelagic form of many invertebrates, also TROCHOPHORE [n]\n",
  "TROCHOTRON": "a trochoidal magnetron, high-frequency counting tube which deflects a beam on to radially disposed electrodes [n -S]\n",
  "TROCHOTRONS": "TROCHOTRON, a trochoidal magnetron, high-frequency counting tube which deflects a beam on to radially disposed electrodes [n]\n",
  "TROCHUS": "(Greek) a genus of gastropods, the top-shells [n TROCHI or TROCHUSES]\n",
  "TROCHUSES": "TROCHUS, (Greek) a genus of gastropods, the top-shells [n]\n",
  "TROCK": "(Scots) to barter, also TROAK, TROKE [v -ED, -ING, -S]\n",
  "TROCKED": "TROCK, (Scots) to barter, also TROAK, TROKE [v]\n",
  "TROCKEN": "(German) of wine, dry [adj]\n",
  "TROCKING": "TROCK, (Scots) to barter, also TROAK, TROKE [v]\n",
  "TROCKS": "TROCK, (Scots) to barter, also TROAK, TROKE [v]\n",
  "TROCTOLITE": "a coarse-grained basic igneous rock composed of feldspar speckled with olivine, aka troutstone [n -S]\n",
  "TROCTOLITES": "TROCTOLITE, a coarse-grained basic igneous rock composed of feldspar speckled with olivine, aka troutstone [n]\n",
  "TROD": "(obsolete) a track, path, also TROAD, TROADE, TRODE [n -S]\n",
  "TRODDEN": "TREAD, to walk on, over, or along [v]\n",
  "TRODE": "(Spenser) a track, path, also TROAD, TROADE, TROD [n -S]\n",
  "TRODES": "TRODE, (Spenser) a track, path, also TROAD, TROADE, TROD [n]\n",
  "TRODS": "TROD, (obsolete) a track, path, also TROAD, TROADE, TRODE [n]\n",
  "TROELIE": "(Tupi) an Amazonian palm tree, aka bussu; its immense leaf, used for thatching, also TROELY, TROOLIE [n -S]\n",
  "TROELIES": "TROELY, (Tupi) a leaf of the bussu palm, also TROELIE, TROOLIE [n]\n",
  "TROELY": "(Tupi) a leaf of the bussu palm, also TROELIE, TROOLIE [n TROELIES]\n",
  "TROFFER": "a fixture for fluorescent lighting [n -S]\n",
  "TROFFERS": "TROFFER, a fixture for fluorescent lighting [n]\n",
  "TROG": "to walk wearily [v TROGGED, TROGGING, TROGS]\n",
  "TROGGED": "TROG, to walk wearily [v]\n",
  "TROGGING": "TROG, to walk wearily [v]\n",
  "TROGGS": "(Scots) by my troth [interj]\n",
  "TROGLODYTE": "a member of any of various peoples (as in antiquity) who lived or were reputed to live chiefly in caves [n -S]\n",
  "TROGLODYTES": "TROGLODYTE, a member of any of various peoples (as in antiquity) who lived or were reputed to live chiefly in caves [n]\n",
  "TROGLODYTIC": "cave-dwelling, also TROGLODYTICAL [adj]\n",
  "TROGLODYTICAL": "cave-dwelling, also TROGLODYTIC [adj]\n",
  "TROGLODYTISM": "the practice of living in caves [n -S]\n",
  "TROGLODYTISMS": "TROGLODYTISM, the practice of living in caves [n]\n",
  "TROGON": "(Greek) any of numerous species of tropical birds belonging to the family Trogonidae, noted for their brilliant colors [n -S]\n",
  "TROGONS": "TROGON, (Greek) any of numerous species of tropical birds belonging to the family Trogonidae, noted for their brilliant colors [n]\n",
  "TROGS": "TROG, to walk wearily [v]\n",
  "TROIKA": "(Russian) a carriage drawn by three horses [n -S]\n",
  "TROIKAS": "TROIKA, (Russian) a carriage drawn by three horses [n]\n",
  "TROILISM": "sexual activity between three people (of two different sexes) [n -S]\n",
  "TROILISMS": "TROILISM, sexual activity between three people (of two different sexes) [n]\n",
  "TROILIST": "one who engages in troilism, sexual activity between three people [n -S]\n",
  "TROILISTS": "TROILIST, one who engages in troilism, sexual activity between three people [n]\n",
  "TROILITE": "a mineral, native ferrous sulphide, found in meteorites [n -S]\n",
  "TROILITES": "TROILITE, a mineral, native ferrous sulphide, found in meteorites [n]\n",
  "TROILUS": "a large American butterfly [n -ES]\n",
  "TROILUSES": "TROILUS, a large American butterfly [n]\n",
  "TROIS": "(French) the number three [n TROIS]\n",
  "TROJAN": "a computer program that gets access to a computer or system by appearing to be harmless, but is designed to do something damaging [n -S]\n",
  "TROJANS": "TROJAN, a computer program that gets access to a computer or system by appearing to be harmless, but is designed to do something damaging [n]\n",
  "TROKE": "(Scots) to barter, also TROAK, TROCK [v TROKED, TROKING, TROKES]\n",
  "TROKED": "TROKE, (Scots) to barter, also TROAK, TROCK [v]\n",
  "TROKES": "TROKE, (Scots) to barter, also TROAK, TROCK [v]\n",
  "TROKING": "TROKE, (Scots) to barter, also TROAK, TROCK [v]\n",
  "TROLAND": "a unit of measurement of retinal response to light [n -S]\n",
  "TROLANDS": "TROLAND, a unit of measurement of retinal response to light [n]\n",
  "TROLL": "to fish with a slowly trailing line [v -ED, -ING, -S]\n",
  "TROLLED": "TROLL, to fish with a slowly trailing line [v]\n",
  "TROLLER": "a person who trolls, esp. in fishing; a fishing boat used for trolling a line [n -S]\n",
  "TROLLERS": "TROLLER, a person who trolls, esp. in fishing; a fishing boat used for trolling a line [n]\n",
  "TROLLEY": "to travel by streetcar, also TROLLY [v -ED, -ING, -S]\n",
  "TROLLEYBUS": "a bus running on an overhead electric wire [n TROLLEYBUSES or TROLLEYBUSSES]\n",
  "TROLLEYBUSES": "TROLLEYBUS, a bus running on an overhead electric wire [n]\n",
  "TROLLEYBUSSES": "TROLLEYBUS, a bus running on an overhead electric wire [n]\n",
  "TROLLEYED": "TROLLEY, to travel by streetcar, also TROLLY [v]\n",
  "TROLLEYING": "TROLLEY, to travel by streetcar, also TROLLY [v]\n",
  "TROLLEYS": "TROLLEY, to travel by streetcar, also TROLLY [v]\n",
  "TROLLIED": "TROLLY, to travel by streetcar, also TROLLEY [v]\n",
  "TROLLIES": "TROLLY, to travel by streetcar, also TROLLEY [v]\n",
  "TROLLING": "fishing by drawing bait along in the water [n -S]\n",
  "TROLLINGS": "TROLLING, fishing by drawing bait along in the water [n]\n",
  "TROLLISH": "resembling a troll [adj]\n",
  "TROLLIUS": "the globeflower [n -ES]\n",
  "TROLLIUSES": "TROLLIUS, the globeflower [n]\n",
  "TROLLOP": "a promiscuous woman [n -S] / to act or dress like a trollop [v -ED, -ING, -S]\n",
  "TROLLOPED": "TROLLOP, to act or dress like a trollop [v]\n",
  "TROLLOPEE": "(historical) a kind of loose dress for women [n -S]\n",
  "TROLLOPEES": "TROLLOPEE, (historical) a kind of loose dress for women [n]\n",
  "TROLLOPIER": "TROLLOPY, like a trollop [adj]\n",
  "TROLLOPIEST": "TROLLOPY, like a trollop [adj]\n",
  "TROLLOPING": "TROLLOP, to act or dress like a trollop [v]\n",
  "TROLLOPISH": "like a trollop [adj]\n",
  "TROLLOPS": "TROLLOP, to act or dress like a trollop [v]\n",
  "TROLLOPY": "like a trollop [adj TROLLOPIER, TROLLOPIEST]\n",
  "TROLLS": "TROLL, to fish with a slowly trailing line [v]\n",
  "TROLLY": "to travel by streetcar, also TROLLEY [v TROLLIED, TROLLYING, TROLLIES]\n",
  "TROLLYING": "TROLLY, to travel by streetcar, also TROLLEY [v]\n",
  "TROMBICULID": "any member of the mite family [n -S]\n",
  "TROMBICULIDS": "TROMBICULID, any member of the mite family [n]\n",
  "TROMBIDIASES": "TROMBIDIASIS, infestation with mites of the family Trombiculidae [n]\n",
  "TROMBIDIASIS": "infestation with mites of the family Trombiculidae [n TROMBIDIASES]\n",
  "TROMBONE": "a brass wind instrument [n -S]\n",
  "TROMBONES": "TROMBONE, a brass wind instrument [n]\n",
  "TROMBONIST": "one who plays the trombone [n -S]\n",
  "TROMBONISTS": "TROMBONIST, one who plays the trombone [n]\n",
  "TROMINO": "a flat, three-sided shape [n TROMINOS or TROMINOES]\n",
  "TROMINOES": "TROMINO, a flat, three-sided shape [n]\n",
  "TROMINOS": "TROMINO, a flat, three-sided shape [n]\n",
  "TROMMEL": "(German) a revolving sieve for cleaning or sizing minerals [n -S]\n",
  "TROMMELS": "TROMMEL, (German) a revolving sieve for cleaning or sizing minerals [n]\n",
  "TROMOMETER": "an instrument for detecting or measuring faint tremors caused by an earthquake [n -S]\n",
  "TROMOMETERS": "TROMOMETER, an instrument for detecting or measuring faint tremors caused by an earthquake [n]\n",
  "TROMOMETRIC": "relating to a tromometer, an instrument for measuring slight earthquake shocks [adj]\n",
  "TROMP": "to apply heavy foot pressure to something; to tread heavily [v -ED, -ING, -S]\n",
  "TROMPE": "(French) an apparatus for producing a blast of air in a furnace by means of falling water [n -S]\n",
  "TROMPED": "TROMP, to apply heavy foot pressure to something; to tread heavily [v]\n",
  "TROMPES": "TROMPE, (French) an apparatus for producing a blast of air in a furnace by means of falling water [n]\n",
  "TROMPING": "TROMP, to apply heavy foot pressure to something; to tread heavily [v]\n",
  "TROMPS": "TROMP, to apply heavy foot pressure to something; to tread heavily [v]\n",
  "TRON": "(Scots) a public weighing-machine for weighing produce in the marketplace of a city or burgh, also TRONE [n -S]\n",
  "TRONA": "(Swedish) a native hydrated double salt of sodium carbonate and sodium bicarbonate, aka urao [n -S]\n",
  "TRONAS": "TRONA, (Swedish) a native hydrated double salt of sodium carbonate and sodium bicarbonate, aka urao [n]\n",
  "TRONC": "(French) a collection of tips to be divided out among waiters [n -S]\n",
  "TRONCS": "TRONC, (French) a collection of tips to be divided out among waiters [n]\n",
  "TRONE": "(Scots) a public weighing-machine for weighing produce in the marketplace of a city or burgh, also TRON [n -S]\n",
  "TRONES": "TRONE, (Scots) a public weighing-machine for weighing produce in the marketplace of a city or burgh, also TRON [n]\n",
  "TRONK": "(South African) jail [n -S]\n",
  "TRONKS": "TRONK, (South African) jail [n]\n",
  "TRONS": "TRON, (Scots) a public weighing-machine for weighing produce in the marketplace of a city or burgh, also TRONE [n]\n",
  "TROOLIE": "(Tupi) an Amazonian palm tree, aka bussu; its immense leaf, also TROELIE, TROELY [n -S]\n",
  "TROOLIES": "TROOLIE, (Tupi) an Amazonian palm tree, aka bussu; its immense leaf, also TROELIE, TROELY [n]\n",
  "TROOP": "to move in a crowd [v -ED, -ING, -S]\n",
  "TROOPED": "TROOP, to move in a crowd [v]\n",
  "TROOPER": "a cavalryman [n -S]\n",
  "TROOPERS": "TROOPER, a cavalryman [n]\n",
  "TROOPIAL": "any of various American orioles, also TROUPIAL [n -S]\n",
  "TROOPIALS": "TROOPIAL, any of various American orioles, also TROUPIAL [n]\n",
  "TROOPING": "TROOP, to move in a crowd [v]\n",
  "TROOPS": "TROOP, to move in a crowd [v]\n",
  "TROOPSHIP": "a ship for carrying troops [n -S]\n",
  "TROOPSHIPS": "TROOPSHIP, a ship for carrying troops [n]\n",
  "TROOSTITE": "a reddish or greyish variety of willemite [n -S]\n",
  "TROOSTITES": "TROOSTITE, a reddish or greyish variety of willemite [n]\n",
  "TROOZ": "(Scots) close-cut tartan drawers sometimes worn under the kilt in Highland dress, also TREWS, TROUSE [n]\n",
  "TROP": "(French) too much [adv]\n",
  "TROPAEOLA": "TROPAEOLUM, a genus of South American trailing plants [n]\n",
  "TROPAEOLIN": "any of a group of dyes of complex structure, also TROPEOLIN [n -S]\n",
  "TROPAEOLINS": "TROPAEOLIN, any of a group of dyes of complex structure, also TROPEOLIN [n]\n",
  "TROPAEOLUM": "a genus of South American trailing plants [n TROPAEOLA or TROPAEOLUMS]\n",
  "TROPAEOLUMS": "TROPAEOLUM, a genus of South American trailing plants [n]\n",
  "TROPARIA": "TROPARION, (Greek) in the Greek Church, a stanza or short hymn [n]\n",
  "TROPARION": "(Greek) in the Greek Church, a stanza or short hymn [n TROPARIA or TROPARIONS]\n",
  "TROPARIONS": "TROPARION, (Greek) in the Greek Church, a stanza or short hymn [n]\n",
  "TROPE": "to provide with a metaphor [v TROPED, TROPING, TROPES]\n",
  "TROPED": "TROPE, to provide with a metaphor [v]\n",
  "TROPEOLIN": "any of a group of dyes of complex structure, also TROPAEOLIN [n -S]\n",
  "TROPEOLINS": "TROPEOLIN, any of a group of dyes of complex structure, also TROPAEOLIN [n]\n",
  "TROPES": "TROPE, to provide with a metaphor [v]\n",
  "TROPHALLACTIC": "relating to trophallaxis, mutual exchange of nutriment in symbiosis [adj]\n",
  "TROPHALLAXES": "TROPHALLAXIS, mutual exchange of nutriment in symbiosis [n]\n",
  "TROPHALLAXIS": "mutual exchange of nutriment in symbiosis [n TROPHALLAXES]\n",
  "TROPHESIAL": "relating to trophesy, a state of diseased nutrition due to disorder of the trophic action of the nerves [adj]\n",
  "TROPHESIES": "TROPHESY, a state of diseased nutrition due to disorder of the trophic action of the nerves [n]\n",
  "TROPHESY": "a state of diseased nutrition due to disorder of the trophic action of the nerves [n TROPHESIES]\n",
  "TROPHI": "(Greek) the mouthparts of an insect [n]\n",
  "TROPHIC": "pertaining to nutrition [adj TROPHICALLY]\n",
  "TROPHICALLY": "TROPHIC, pertaining to nutrition [adv]\n",
  "TROPHIED": "TROPHY, to honour with a symbol of victory [v]\n",
  "TROPHIES": "TROPHY, to honour with a symbol of victory [v]\n",
  "TROPHOBIOSES": "TROPHOBIOSIS, exchange of nutriment in symbiotic relationship [n]\n",
  "TROPHOBIOSIS": "exchange of nutriment in symbiotic relationship [n TROPHOBIOSES]\n",
  "TROPHOBIOTIC": "relating to trophobiosis, mutual exchange of nutriment in symbiosis [adj]\n",
  "TROPHOBLAST": "the outermost layer of cells in the morula that attaches the fertilized ovum to the uterine wall and acts as a nutritive pathway [n -S]\n",
  "TROPHOBLASTIC": "of or like a trophoblast [adj]\n",
  "TROPHOBLASTS": "TROPHOBLAST, the outermost layer of cells in the morula that attaches the fertilized ovum to the uterine wall and acts as a nutritive pathway [n]\n",
  "TROPHOLOGIES": "TROPHOLOGY, the study of nutrition [n]\n",
  "TROPHOLOGY": "the study of nutrition [n TROPHOLOGIES]\n",
  "TROPHONEUROSES": "TROPHONEUROSIS, a state of deranged nutrition owing to disorder of the trophic action of the nerves [n]\n",
  "TROPHONEUROSIS": "a state of deranged nutrition owing to disorder of the trophic action of the nerves [n TROPHONEUROSES]\n",
  "TROPHOPLASM": "the nutritive substance of cell [n -S]\n",
  "TROPHOPLASMS": "TROPHOPLASM, the nutritive substance of cell [n]\n",
  "TROPHOTACTIC": "relating to trophotaxis, chemotaxis and chemotropism where the stimulating substance is food [adj]\n",
  "TROPHOTAXES": "TROPHOTAXIS, chemotaxis and chemotropism where the stimulating substance is food [n]\n",
  "TROPHOTAXIS": "chemotaxis and chemotropism where the stimulating substance is food [n TROPHOTAXES]\n",
  "TROPHOTROPIC": "related to trophotropism, direction of growth by nutritional factors [adj]\n",
  "TROPHOTROPISM": "direction of growth by nutritional factors [n -S]\n",
  "TROPHOTROPISMS": "TROPHOTROPISM, direction of growth by nutritional factors [n]\n",
  "TROPHOZOITE": "in Protozoa, the trophic phase of an adult [n -S]\n",
  "TROPHOZOITES": "TROPHOZOITE, in Protozoa, the trophic phase of an adult [n]\n",
  "TROPHY": "to honour with a symbol of victory [v TROPHIED, TROPHYING, TROPHIES]\n",
  "TROPHYING": "TROPHY, to honour with a symbol of victory [v]\n",
  "TROPIC": "of the tropics [adj TROPICALLY] / either of two circles of the celestial sphere on each side of the equator [n -S]\n",
  "TROPICAL": "related to the tropics [adj TROPICALLY] / a tropical thing or place [n -S]\n",
  "TROPICALISATION": "the process of tropicalising, also TROPICALIZATION [n]\n",
  "TROPICALISE": "to make tropical, also TROPICALIZE [v TROPICALISED, TROPICALISING, TROPICALISES]\n",
  "TROPICALISED": "TROPICALISE, to make tropical, also TROPICALIZE [v]\n",
  "TROPICALISES": "TROPICALISE, to make tropical, also TROPICALIZE [v]\n",
  "TROPICALISING": "TROPICALISE, to make tropical, also TROPICALIZE [v]\n",
  "TROPICALITIES": "TROPICALITY, the state of being tropical [n]\n",
  "TROPICALITY": "the state of being tropical [n TROPICALITIES]\n",
  "TROPICALIZATION": "the process of tropicalizing, also TROPICALISATION [n]\n",
  "TROPICALIZE": "to make tropical, also TROPICALISE [v TROPICALIZED, TROPICALIZING, TROPICALIZES]\n",
  "TROPICALIZED": "TROPICALIZE, to make tropical, also TROPICALISE [v]\n",
  "TROPICALIZES": "TROPICALIZE, to make tropical, also TROPICALISE [v]\n",
  "TROPICALIZING": "TROPICALIZE, to make tropical, also TROPICALISE [v]\n",
  "TROPICALLY": "TROPICAL, related to the tropics [adv]\n",
  "TROPICALS": "TROPICAL, a tropical thing or place [n]\n",
  "TROPICBIRD": "any aquatic bird of the tropical family Phaethontidae, having long slender tail feathers and a white plumage with black markings [n -S]\n",
  "TROPICBIRDS": "TROPICBIRD, any aquatic bird of the tropical family Phaethontidae, having long slender tail feathers and a white plumage with black markings [n]\n",
  "TROPICS": "TROPIC, either of two circles of the celestial sphere on each side of the equator [n]\n",
  "TROPIN": "a poisonous alkaloid, also TROPINE [n -S]\n",
  "TROPINE": "a poisonous alkaloid, also TROPIN [n -S]\n",
  "TROPINES": "TROPINE, a poisonous alkaloid, also TROPIN [n]\n",
  "TROPING": "TROPE, to provide with a metaphor [v]\n",
  "TROPINS": "TROPIN, a poisonous alkaloid, also TROPINE [n]\n",
  "TROPISM": "the response of an organism to an external stimulus [n -S]\n",
  "TROPISMATIC": "relating to tropism [adj]\n",
  "TROPISMS": "TROPISM, the response of an organism to an external stimulus [n]\n",
  "TROPIST": "a user of tropes [n -S]\n",
  "TROPISTIC": "relating to a tropism, a tendency to react to stimuli in a specific manner [adj]\n",
  "TROPISTS": "TROPIST, a user of tropes [n]\n",
  "TROPOCOLLAGEN": "a subunit of collagen fibrils consisting of three polypeptide strands arranged in a helix [n -S]\n",
  "TROPOCOLLAGENS": "TROPOCOLLAGEN, a subunit of collagen fibrils consisting of three polypeptide strands arranged in a helix [n]\n",
  "TROPOLOGIC": "characterized by tropes or figures of speech, also TROPOLOGICAL [adj TROPOLOGICALLY]\n",
  "TROPOLOGICAL": "characterized by tropes or figures of speech, also TROPOLOGIC [adj TROPOLOGICALLY]\n",
  "TROPOLOGICALLY": "TROPOLOGICAL, characterized by tropes or figures of speech, also TROPOLOGIC [adv]\n",
  "TROPOLOGIES": "TROPOLOGY, the use of metaphors in writing or speaking [n]\n",
  "TROPOLOGY": "the use of metaphors in writing or speaking [n TROPOLOGIES]\n",
  "TROPOMYOSIN": "a filamentous protein which controls the interaction of actin and myosin in muscle fibres [n -S]\n",
  "TROPOMYOSINS": "TROPOMYOSIN, a filamentous protein which controls the interaction of actin and myosin in muscle fibres [n]\n",
  "TROPONIN": "a protein of muscle [n -S]\n",
  "TROPONINS": "TROPONIN, a protein of muscle [n]\n",
  "TROPOPAUSE": "the level of the atmosphere where the troposphere ends and stratosphere begins [n -S]\n",
  "TROPOPAUSES": "TROPOPAUSE, the level of the atmosphere where the troposphere ends and stratosphere begins [n]\n",
  "TROPOPHILOUS": "flourishing in seasonal extremes of climate [adj]\n",
  "TROPOPHYTE": "a plant adapted to alterations of moisture and drought [n -S]\n",
  "TROPOPHYTES": "TROPOPHYTE, a plant adapted to alterations of moisture and drought [n]\n",
  "TROPOPHYTIC": "of or like a tropophyte, a plant adapted to alterations of moisture and drought [adj]\n",
  "TROPOSCATTER": "the propagation of radio waves by using irregularities in the troposphere to scatter the signals beamed up by means of high-powered UHF transmitters and parabolic antennas [n -S]\n",
  "TROPOSCATTERS": "TROPOSCATTER, the propagation of radio waves by using irregularities in the troposphere to scatter the signals beamed up by means of high-powered UHF transmitters and parabolic antennas [n]\n",
  "TROPOSPHERE": "a region of the atmosphere from 25,000 feet to 55,000 feet, the boundary between the upper troposphere and the lower stratosphere [n -S]\n",
  "TROPOSPHERES": "TROPOSPHERE, a region of the atmosphere from 25,000 feet to 55,000 feet, the boundary between the upper troposphere and the lower stratosphere [n]\n",
  "TROPOSPHERIC": "relating to the troposphere [adj]\n",
  "TROPOTAXES": "TROPOTAXIS, a taxis in which an organism orients itself by the simultaneous comparison of stimuli of different intensity operating on different end organs [n]\n",
  "TROPOTAXIS": "a taxis in which an organism orients itself by the simultaneous comparison of stimuli of different intensity operating on different end organs [n TROPOTAXES]\n",
  "TROPPO": "(Italian) in music, too much [adv]\n",
  "TROSSERS": "(obsolete) trousers, also STROSSERS, TROUSERS, TROWSERS [n]\n",
  "TROT": "to proceed at a pace between walking and running [v TROTTED, TROTTING, TROTS]\n",
  "TROTH": "(Shakespeare) to promise to marry, also BETROTH [v -ED, -ING, -S]\n",
  "TROTHED": "TROTH, (Shakespeare) to promise to marry, also BETROTH [v]\n",
  "TROTHFUL": "faithful [adj]\n",
  "TROTHING": "TROTH, (Shakespeare) to promise to marry, also BETROTH [v]\n",
  "TROTHLESS": "faithless, false [adj]\n",
  "TROTHPLIGHT": "(archaic) betrothal [n -S] / to betroth [v -ED, -ING, -S]\n",
  "TROTHPLIGHTED": "TROTHPLIGHT, to betroth [v]\n",
  "TROTHPLIGHTING": "TROTHPLIGHT, to betroth [v]\n",
  "TROTHPLIGHTS": "TROTHPLIGHT, to betroth [v]\n",
  "TROTHS": "TROTH, (Shakespeare) to promise to marry, also BETROTH [v]\n",
  "TROTLINE": "a strong fishing line [n -S]\n",
  "TROTLINES": "TROTLINE, a strong fishing line [n]\n",
  "TROTS": "TROT, to proceed at a pace between walking and running [v]\n",
  "TROTTED": "TROT, to proceed at a pace between walking and running [v]\n",
  "TROTTER": "a foot, esp. of a sheep or pig [n -S]\n",
  "TROTTERS": "TROTTER, a foot, esp. of a sheep or pig [n]\n",
  "TROTTING": "the sport of racing for trotting horses pulling a two-wheeled vehicle and driver [n -S]\n",
  "TROTTINGS": "TROTTING, the sport of racing for trotting horses pulling a two-wheeled vehicle and driver [n]\n",
  "TROTTOIR": "(French) pavement [n -S]\n",
  "TROTTOIRS": "TROTTOIR, (French) pavement [n]\n",
  "TROTYL": "an explosive, aka trinitrotoluene [n -S]\n",
  "TROTYLS": "TROTYL, an explosive, aka trinitrotoluene [n]\n",
  "TROU": "(short for) trousers [n]\n",
  "TROUBADOUR": "(French) any of a class of poet-musicians flourishing esp. in southern France and northern Italy during the 11th, 12th, and 13th centuries [n -S]\n",
  "TROUBADOURS": "TROUBADOUR, (French) any of a class of poet-musicians flourishing esp. in southern France and northern Italy during the 11th, 12th, and 13th centuries [n]\n",
  "TROUBLE": "to distress [v TROUBLED, TROUBLING, TROUBLES]\n",
  "TROUBLED": "TROUBLE, to distress [v]\n",
  "TROUBLEDLY": "TROUBLED, TROUBLE, to distress [adv]\n",
  "TROUBLEFREE": "free of trouble [adj]\n",
  "TROUBLEMAKER": "a person who consciously or unconsciously causes trouble [n -S]\n",
  "TROUBLEMAKERS": "TROUBLEMAKER, a person who consciously or unconsciously causes trouble [n]\n",
  "TROUBLEMAKING": "the act of making trouble [n -S]\n",
  "TROUBLEMAKINGS": "TROUBLEMAKING, the act of making trouble [n]\n",
  "TROUBLER": "something or someone that troubles [n -S]\n",
  "TROUBLERS": "TROUBLER, something or someone that troubles [n]\n",
  "TROUBLES": "TROUBLE, to distress [v]\n",
  "TROUBLESHOOT": "to solve problems [v TROUBLESHOT, TROUBLESHOOTING, TROUBLESHOOTS]\n",
  "TROUBLESHOOTER": "a skilled worker employed to locate trouble and make repairs in machinery and technical equipment [n -S]\n",
  "TROUBLESHOOTERS": "TROUBLESHOOTER, a skilled worker employed to locate trouble and make repairs in machinery and technical equipment [n]\n",
  "TROUBLESHOOTING": "TROUBLESHOOT, to solve problems [v]\n",
  "TROUBLESHOOTS": "TROUBLESHOOT, to solve problems [v]\n",
  "TROUBLESHOT": "TROUBLESHOOT, to solve problems [v]\n",
  "TROUBLESOME": "causing trouble [adj TROUBLESOMELY]\n",
  "TROUBLESOMELY": "TROUBLESOME, causing trouble [adv]\n",
  "TROUBLESOMENESS": "the state of being troublesome [n]\n",
  "TROUBLING": "the act of troubling [n -S]\n",
  "TROUBLINGS": "TROUBLING, the act of troubling [n]\n",
  "TROUBLOUS": "(archaic) troublesome [adj TROUBLOUSLY]\n",
  "TROUBLOUSLY": "TROUBLOUS, (archaic) troublesome [adv]\n",
  "TROUBLOUSNESS": "the state of being troublous [n -ES]\n",
  "TROUBLOUSNESSES": "TROUBLOUSNESS, the state of being troublous [n]\n",
  "TROUCH": "(dialect) rubbish, junk [n -ES]\n",
  "TROUCHES": "TROUCH, (dialect) rubbish, junk [n]\n",
  "TROUGH": "a long narrow container for feeding animals [n -S] / to eat greedily [v -ED, -ING, -S]\n",
  "TROUGHED": "TROUGH, to eat greedily [v]\n",
  "TROUGHING": "the act of consuming greedily [n -S]\n",
  "TROUGHINGS": "TROUGHING, the act of consuming greedily [n]\n",
  "TROUGHLIKE": "like a trough [adj]\n",
  "TROUGHS": "TROUGH, to eat greedily [v]\n",
  "TROULE": "(Milton) to roll, trundle [v TROULED, TROULING, TROULES]\n",
  "TROULED": "TROULE, (Milton) to roll, trundle [v]\n",
  "TROULES": "TROULE, (Milton) to roll, trundle [v]\n",
  "TROULING": "TROULE, (Milton) to roll, trundle [v]\n",
  "TROUNCE": "to beat severely [v TROUNCED, TROUNCING, TROUNCES]\n",
  "TROUNCED": "TROUNCE, to beat severely [v]\n",
  "TROUNCER": "one who trounces [n -S]\n",
  "TROUNCERS": "TROUNCER, one who trounces [n]\n",
  "TROUNCES": "TROUNCE, to beat severely [v]\n",
  "TROUNCING": "the act of trouncing [n -S]\n",
  "TROUNCINGS": "TROUNCING, the act of trouncing [n]\n",
  "TROUPE": "(French) to tour with a theatrical company [v TROUPED, TROUPING, TROUPES]\n",
  "TROUPED": "TROUPE, (French) to tour with a theatrical company [v]\n",
  "TROUPER": "a member of a theatrical company [n -S]\n",
  "TROUPERS": "TROUPER, a member of a theatrical company [n]\n",
  "TROUPES": "TROUPE, (French) to tour with a theatrical company [v]\n",
  "TROUPIAL": "any of various American orioles, also TROOPIAL [n -S]\n",
  "TROUPIALS": "TROUPIAL, any of various American orioles, also TROOPIAL [n]\n",
  "TROUPING": "TROUPE, (French) to tour with a theatrical company [v]\n",
  "TROUSE": "(archaic) Irish close-fitting trews, also TREWS, TROOZ [n -S]\n",
  "TROUSER": "to appropriate or pocket money [v -ED, -ING, -S]\n",
  "TROUSERED": "TROUSER, to appropriate or pocket money [v]\n",
  "TROUSERING": "any cloth suitable for trousers [n -S]\n",
  "TROUSERINGS": "TROUSERING, any cloth suitable for trousers [n]\n",
  "TROUSERLESS": "without trousers [adj]\n",
  "TROUSERS": "a garment worn on the lower part of the body with a loose tubular branch for each leg, also STROSSERS, TROSSERS, TROWSERS [n]\n",
  "TROUSES": "TROUSE, (archaic) Irish close-fitting trews, also TREWS, TROOZ [n]\n",
  "TROUSSEAU": "(French) clothes collected by a bride for her marriage [n TROUSSEAUS or TROUSSEAUX]\n",
  "TROUSSEAUS": "TROUSSEAU, (French) clothes collected by a bride for her marriage [n]\n",
  "TROUSSEAUX": "TROUSSEAU, (French) clothes collected by a bride for her marriage [n]\n",
  "TROUT": "a freshwater fish [n -S]\n",
  "TROUTER": "a trout fisherman [n -S]\n",
  "TROUTERS": "TROUTER, a trout fisherman [n]\n",
  "TROUTFUL": "full of trout [adj]\n",
  "TROUTIER": "TROUTY, containing trout [adj]\n",
  "TROUTIEST": "TROUTY, containing trout [adj]\n",
  "TROUTING": "trout-fishing [n -S]\n",
  "TROUTINGS": "TROUTING, trout-fishing [n]\n",
  "TROUTLESS": "without trout [adj]\n",
  "TROUTLET": "a little trout, also TROUTLING [n -S]\n",
  "TROUTLETS": "TROUTLET, a little trout, also TROUTLING [n]\n",
  "TROUTLIKE": "like a trout [adj]\n",
  "TROUTLING": "a little trout, also TROUTLET [n -S]\n",
  "TROUTLINGS": "TROUTLING, a little trout, also TROUTLET [n]\n",
  "TROUTS": "TROUT, a freshwater fish [n]\n",
  "TROUTSTONE": "a coarse-grained basic igneous rock composed of feldspar speckled with olivine, aka troctolite [n -S]\n",
  "TROUTSTONES": "TROUTSTONE, a coarse-grained basic igneous rock composed of feldspar speckled with olivine, aka troctolite [n]\n",
  "TROUTY": "containing trout [adj TROUTIER, TROUTIEST]\n",
  "TROUVAILLE": "(French) a fortunate find [n -S]\n",
  "TROUVAILLES": "TROUVAILLE, (French) a fortunate find [n]\n",
  "TROUVERE": "(French) one of a school of poets who flourished in northern France from the eleventh to the fourteenth century, also TROUVEUR [n -S]\n",
  "TROUVERES": "TROUVERE, (French) one of a school of poets who flourished in northern France from the eleventh to the fourteenth century, also TROUVEUR [n]\n",
  "TROUVEUR": "(French) one of a school of poets who flourished in northern France from the eleventh to the fourteenth century, also TROUVERE [n -S]\n",
  "TROUVEURS": "TROUVEUR, (French) one of a school of poets who flourished in northern France from the eleventh to the fourteenth century, also TROUVERE [n]\n",
  "TROVE": "a valuable discovery [n -S]\n",
  "TROVER": "a type of legal action [n -S]\n",
  "TROVERS": "TROVER, a type of legal action [n]\n",
  "TROVES": "TROVE, a valuable discovery [n]\n",
  "TROW": "(archaic) to believe [v -ED, -ING, -S]\n",
  "TROWED": "TROW, (archaic) to believe [v]\n",
  "TROWEL": "to smooth with a tool with a flat blade [v TROWELED or TROWELLED, TROWELING or TROWELLING, TROWELS]\n",
  "TROWELED": "TROWEL, to smooth with a tool with a flat blade [v]\n",
  "TROWELER": "one who trowels, also TROWELLER [n -S]\n",
  "TROWELERS": "TROWELER, one who trowels, also TROWELLER [n]\n",
  "TROWELING": "TROWEL, to smooth with a tool with a flat blade [v]\n",
  "TROWELLED": "TROWEL, to smooth with a tool with a flat blade [v]\n",
  "TROWELLER": "one who trowels, also TROWELER [n -S]\n",
  "TROWELLERS": "TROWELLER, one who trowels, also TROWELER [n]\n",
  "TROWELLING": "TROWEL, to smooth with a tool with a flat blade [v]\n",
  "TROWELS": "TROWEL, to smooth with a tool with a flat blade [v]\n",
  "TROWING": "TROW, (archaic) to believe [v]\n",
  "TROWS": "TROW, (archaic) to believe [v]\n",
  "TROWSERS": "(archaic) trousers, also STROSSERS, TROSSERS, TROUSERS [n]\n",
  "TROWTH": "(US) truth, also TROTH [n -S]\n",
  "TROWTHS": "TROWTH, (US) truth, also TROTH [n]\n",
  "TROY": "a system of weights [n -S]\n",
  "TROYS": "TROY, a system of weights [n]\n",
  "TRUANCIES": "TRUANCY, an act of truanting, also TRUANTRY [n]\n",
  "TRUANCY": "an act of truanting, also TRUANTRY [n TRUANCIES]\n",
  "TRUANT": "an absentee from school [n -S] / to be absent from school for no valid reason [v -ED, -ING, -S]\n",
  "TRUANTED": "TRUANT, to be absent from school for no valid reason [v]\n",
  "TRUANTING": "the act of staying out of school without permission [n -S]\n",
  "TRUANTINGS": "TRUANTING, the act of staying out of school without permission [n]\n",
  "TRUANTLY": "like a truant [adv]\n",
  "TRUANTRIES": "TRUANTRY, an act of truanting, also TRUANCY [n]\n",
  "TRUANTRY": "an act of truanting, also TRUANCY [n TRUANTRIES]\n",
  "TRUANTS": "TRUANT, to be absent from school for no valid reason [v]\n",
  "TRUANTSHIP": "the conduct of a truant [n -S]\n",
  "TRUANTSHIPS": "TRUANTSHIP, the conduct of a truant [n]\n",
  "TRUCAGE": "(French) the faking of works of art, also TRUQUAGE [n -S]\n",
  "TRUCAGES": "TRUCAGE, (French) the faking of works of art, also TRUQUAGE [n]\n",
  "TRUCE": "to suspend hostilities by mutual agreement [v TRUCED, TRUCING, TRUCES]\n",
  "TRUCED": "TRUCE, to suspend hostilities by mutual agreement [v]\n",
  "TRUCELESS": "without a truce; not forbearing [adj]\n",
  "TRUCES": "TRUCE, to suspend hostilities by mutual agreement [v]\n",
  "TRUCHMAN": "an interpreter [n TRUCHMEN or TRUCHMANS]\n",
  "TRUCHMANS": "TRUCHMAN, an interpreter [n]\n",
  "TRUCHMEN": "TRUCHMAN, an interpreter [n]\n",
  "TRUCIAL": "bound by a truce [adj]\n",
  "TRUCING": "TRUCE, to suspend hostilities by mutual agreement [v]\n",
  "TRUCK": "to transport in a large vehicle for carrying goods [v -ED, -ING, -S]\n",
  "TRUCKABLE": "that can be conveyed by truck [adj]\n",
  "TRUCKAGE": "transportation of goods by trucks, also TRUCKING [n -S]\n",
  "TRUCKAGES": "TRUCKAGE, transportation of goods by trucks, also TRUCKING [n]\n",
  "TRUCKED": "TRUCK, to transport in a large vehicle for carrying goods [v]\n",
  "TRUCKER": "a truck driver, also TRUCKIE, TRUCKMAN [n -S]\n",
  "TRUCKERS": "TRUCKER, a truck driver, also TRUCKIE, TRUCKMAN [n]\n",
  "TRUCKFUL": "as much as a truck can hold [n -S]\n",
  "TRUCKFULS": "TRUCKFUL, as much as a truck can hold [n]\n",
  "TRUCKIE": "(Australian slang) a truck driver, also TRUCKER, TRUCKMAN [n -S]\n",
  "TRUCKIES": "TRUCKIE, (Australian slang) a truck driver, also TRUCKER, TRUCKMAN [n]\n",
  "TRUCKING": "transportation of goods by trucks, also TRUCKAGE [n -S]\n",
  "TRUCKINGS": "TRUCKING, transportation of goods by trucks, also TRUCKAGE [n]\n",
  "TRUCKLE": "to yield weakly [v TRUCKLED, TRUCKLING, TRUCKLES]\n",
  "TRUCKLED": "TRUCKLE, to yield weakly [v]\n",
  "TRUCKLER": "one who truckles, or yields servilely to the will of another [n -S]\n",
  "TRUCKLERS": "TRUCKLER, one who truckles, or yields servilely to the will of another [n]\n",
  "TRUCKLES": "TRUCKLE, to yield weakly [v]\n",
  "TRUCKLINE": "a transportation line using trucks [n -S]\n",
  "TRUCKLINES": "TRUCKLINE, a transportation line using trucks [n]\n",
  "TRUCKLING": "acting in a subservient manner [n -S]\n",
  "TRUCKLINGS": "TRUCKLING, acting in a subservient manner [n]\n",
  "TRUCKLOAD": "the contents of a truck [n -S]\n",
  "TRUCKLOADS": "TRUCKLOAD, the contents of a truck [n]\n",
  "TRUCKMAN": "a truck driver, also TRUCKER, TRUCKIE [n TRUCKMEN]\n",
  "TRUCKMASTER": "an officer in charge of trade with American Indians esp. among the early settlers [n -S]\n",
  "TRUCKMASTERS": "TRUCKMASTER, an officer in charge of trade with American Indians esp. among the early settlers [n]\n",
  "TRUCKMEN": "TRUCKMAN, a truck driver, also TRUCKER, TRUCKIE [n]\n",
  "TRUCKS": "TRUCK, to transport in a large vehicle for carrying goods [v]\n",
  "TRUCKSTOP": "a place providing fuel, oil and service facilities for truck drivers [n -S]\n",
  "TRUCKSTOPS": "TRUCKSTOP, a place providing fuel, oil and service facilities for truck drivers [n]\n",
  "TRUCULENCE": "the state of being truculent, aggressive and discourteous, also TRUCULENCY [n -S]\n",
  "TRUCULENCES": "TRUCULENCE, the state of being truculent, aggressive and discourteous, also TRUCULENCY [n]\n",
  "TRUCULENCIES": "TRUCULENCY, the state of being truculent, also TRUCULENCE [n]\n",
  "TRUCULENCY": "the state of being truculent, also TRUCULENCE [n TRUCULENCIES]\n",
  "TRUCULENT": "aggressive and discourteous [adj TRUCULENTLY]\n",
  "TRUCULENTLY": "TRUCULENT, aggressive and discourteous [adv]\n",
  "TRUDGE": "to walk tiredly [v TRUDGED, TRUDGING, TRUDGES]\n",
  "TRUDGED": "TRUDGE, to walk tiredly [v]\n",
  "TRUDGEN": "a swimming stroke, also TRUDGEON [n -S]\n",
  "TRUDGENS": "TRUDGEN, a swimming stroke, also TRUDGEON [n]\n",
  "TRUDGEON": "a swimming stroke, also TRUDGEN [n -S]\n",
  "TRUDGEONS": "TRUDGEON, a swimming stroke, also TRUDGEN [n]\n",
  "TRUDGER": "one who trudges [n -S]\n",
  "TRUDGERS": "TRUDGER, one who trudges [n]\n",
  "TRUDGES": "TRUDGE, to walk tiredly [v]\n",
  "TRUDGING": "the act of walking wearily [n -S]\n",
  "TRUDGINGS": "TRUDGING, the act of walking wearily [n]\n",
  "TRUE": "corresponding to fact, also TREW [adj TRUER, TRUEST, TRULY] / to make true [v TRUED, TRUEING or TRUING, TRUES]\n",
  "TRUEBLUE": "a person of unwavering loyalty [n -S]\n",
  "TRUEBLUES": "TRUEBLUE, a person of unwavering loyalty [n]\n",
  "TRUEBORN": "genuinely such by birth [adj]\n",
  "TRUEBRED": "denoting a thoroughbred [adj]\n",
  "TRUED": "TRUE, to make true [v]\n",
  "TRUEHEARTED": "faithful, loyal [adj]\n",
  "TRUEHEARTEDNESS": "the state of being truehearted [n]\n",
  "TRUEING": "TRUE, to make true [v]\n",
  "TRUELOVE": "a sweetheart [n -S]\n",
  "TRUELOVES": "TRUELOVE, a sweetheart [n]\n",
  "TRUEMAN": "(archaic) an honest man [n TRUEMEN]\n",
  "TRUEMEN": "TRUEMAN, (archaic) an honest man [n]\n",
  "TRUENESS": "the quality of being true [n -ES]\n",
  "TRUENESSES": "TRUENESS, the quality of being true [n]\n",
  "TRUEPENNIES": "TRUEPENNY, (Shakespeare) an honest fellow [n]\n",
  "TRUEPENNY": "(Shakespeare) an honest fellow [n TRUEPENNIES]\n",
  "TRUER": "TRUE, corresponding to fact, also TREW [adj]\n",
  "TRUES": "TRUE, to make true [v]\n",
  "TRUEST": "TRUE, corresponding to fact, also TREW [adj]\n",
  "TRUFFE": "(French) a truffle, an edible fungus [n -S]\n",
  "TRUFFES": "TRUFFE, (French) a truffle, an edible fungus [n]\n",
  "TRUFFLE": "an edible fungus, also TRUFFE [n -S] / to hunt or root for truffles [v TRUFFLED, TRUFFLING, TRUFFLES]\n",
  "TRUFFLED": "TRUFFLE, to hunt or root for truffles [v]\n",
  "TRUFFLES": "TRUFFLE, to hunt or root for truffles [v]\n",
  "TRUFFLING": "the act of gathering truffles [n -S]\n",
  "TRUFFLINGS": "TRUFFLING, the act of gathering truffles [n]\n",
  "TRUG": "a shallow wooden basket with a handle, used for carrying flowers or fruit [n -S]\n",
  "TRUGO": "(Australian) a game similar to croquet [n -S]\n",
  "TRUGOS": "TRUGO, (Australian) a game similar to croquet [n]\n",
  "TRUGS": "TRUG, a shallow wooden basket with a handle, used for carrying flowers or fruit [n]\n",
  "TRUING": "TRUE, to make true [v]\n",
  "TRUISM": "an obvious truth [n -S]\n",
  "TRUISMS": "TRUISM, an obvious truth [n]\n",
  "TRUISTIC": "having the nature of a truism, an undoubted or self-evident truth [adj]\n",
  "TRULL": "(archaic) a harlot [n -S]\n",
  "TRULLS": "TRULL, (archaic) a harlot [n]\n",
  "TRULY": "TRUE, corresponding to fact, also TREW [adv]\n",
  "TRUMEAU": "(French) a column supporting part of a doorway [n TRUMEAUX]\n",
  "TRUMEAUX": "TRUMEAU, (French) a column supporting part of a doorway [n]\n",
  "TRUMP": "a card of a suit that ranks higher than any card of any other suit [n -S] / to outdo [v -ED, -ING, -S]\n",
  "TRUMPED": "TRUMP, to outdo [v]\n",
  "TRUMPERIES": "TRUMPERY, worthless finery [n]\n",
  "TRUMPERY": "worthless finery [n TRUMPERIES]\n",
  "TRUMPET": "to sound on a brass wind instrument [v -ED, -ING, -S]\n",
  "TRUMPETED": "TRUMPET, to sound on a brass wind instrument [v]\n",
  "TRUMPETER": "one who plays the trumpet [n -S]\n",
  "TRUMPETERS": "TRUMPETER, one who plays the trumpet [n]\n",
  "TRUMPETING": "the act of trumpeting [n -S]\n",
  "TRUMPETINGS": "TRUMPETING, the act of trumpeting [n]\n",
  "TRUMPETLIKE": "resembling a trumpet [adj]\n",
  "TRUMPETS": "TRUMPET, to sound on a brass wind instrument [v]\n",
  "TRUMPETWEED": "any of various eupatorium plants of the US [n -S]\n",
  "TRUMPETWEEDS": "TRUMPETWEED, any of various eupatorium plants of the US [n]\n",
  "TRUMPING": "the act of trumping [n -S]\n",
  "TRUMPINGS": "TRUMPING, the act of trumping [n]\n",
  "TRUMPLESS": "without a trump [adj]\n",
  "TRUMPS": "TRUMP, to outdo [v]\n",
  "TRUNCAL": "relating to the trunk [adj]\n",
  "TRUNCATE": "appearing as if cut off [adj TRUNCATELY] / to cut off [v TRUNCATED, TRUNCATING, TRUNCATES]\n",
  "TRUNCATED": "TRUNCATE, to cut off [v]\n",
  "TRUNCATELY": "TRUNCATE, appearing as if cut off [adv]\n",
  "TRUNCATES": "TRUNCATE, to cut off [v]\n",
  "TRUNCATING": "the act of cutting short [n -S]\n",
  "TRUNCATINGS": "TRUNCATING, the act of cutting short [n]\n",
  "TRUNCATION": "the act of truncating [n -S]\n",
  "TRUNCATIONS": "TRUNCATION, the act of truncating [n]\n",
  "TRUNCHEON": "a club carried by a police officer [n -S] / to strike with a truncheon [v -ED, -ING, -S]\n",
  "TRUNCHEONED": "TRUNCHEON, to strike with a truncheon [v]\n",
  "TRUNCHEONER": "(Shakespeare) a person armed with a truncheon [n -S]\n",
  "TRUNCHEONERS": "TRUNCHEONER, (Shakespeare) a person armed with a truncheon [n]\n",
  "TRUNCHEONING": "TRUNCHEON, to strike with a truncheon [v]\n",
  "TRUNCHEONS": "TRUNCHEON, to strike with a truncheon [v]\n",
  "TRUNDLE": "to propel by causing to rotate, also TRINDLE [v TRUNDLED, TRUNDLING, TRUNDLES]\n",
  "TRUNDLED": "TRUNDLE, to propel by causing to rotate, also TRINDLE [v]\n",
  "TRUNDLER": "(New Zealand) a golf bag or shopping trolley [n -S]\n",
  "TRUNDLERS": "TRUNDLER, (New Zealand) a golf bag or shopping trolley [n]\n",
  "TRUNDLES": "TRUNDLE, to propel by causing to rotate, also TRINDLE [v]\n",
  "TRUNDLING": "TRUNDLE, to propel by causing to rotate, also TRINDLE [v]\n",
  "TRUNK": "the main stem of a tree [n -S]\n",
  "TRUNKED": "having a trunk [adj]\n",
  "TRUNKFISH": "any fish of the genus Ostracion, aka boxfish, that has a boxlike bony covering enveloping its entire body [n -ES]\n",
  "TRUNKFISHES": "TRUNKFISH, any fish of the genus Ostracion, aka boxfish, that has a boxlike bony covering enveloping its entire body [n]\n",
  "TRUNKFUL": "as much as a storage box can hold [n -S]\n",
  "TRUNKFULS": "TRUNKFUL, as much as a storage box can hold [n]\n",
  "TRUNKING": "a system of sharing radio channels [n -S]\n",
  "TRUNKINGS": "TRUNKING, a system of sharing radio channels [n]\n",
  "TRUNKLESS": "without a trunk [adj]\n",
  "TRUNKLIKE": "like a trunk [adj]\n",
  "TRUNKS": "TRUNK, the main stem of a tree [n]\n",
  "TRUNKSLEEVE": "(Shakespeare) a puffed sleeve [n -S]\n",
  "TRUNKSLEEVES": "TRUNKSLEEVE, (Shakespeare) a puffed sleeve [n]\n",
  "TRUNKWORK": "(Shakespeare) clandestine visiting in a trunk [n -S]\n",
  "TRUNKWORKS": "TRUNKWORK, (Shakespeare) clandestine visiting in a trunk [n]\n",
  "TRUNNEL": "a wooden peg used to fasten timber, also TREENAIL, TRENAIL [n -S]\n",
  "TRUNNELS": "TRUNNEL, a wooden peg used to fasten timber, also TREENAIL, TRENAIL [n]\n",
  "TRUNNION": "a pivot on which something can be rotated [n -S]\n",
  "TRUNNIONED": "provided with trunnions; as, the trunnioned cylinder of an oscillating steam engine [adj]\n",
  "TRUNNIONS": "TRUNNION, a pivot on which something can be rotated [n]\n",
  "TRUQUAGE": "(French) the faking of works of art, also TRUCAGE [n -S]\n",
  "TRUQUAGES": "TRUQUAGE, (French) the faking of works of art, also TRUCAGE [n]\n",
  "TRUQUEUR": "(French) one who engages in trucage, the faking of works of art [n -S]\n",
  "TRUQUEURS": "TRUQUEUR, (French) one who engages in trucage, the faking of works of art [n]\n",
  "TRUSS": "to secure tightly [v -ED, -ING, -ES]\n",
  "TRUSSED": "TRUSS, to secure tightly [v]\n",
  "TRUSSER": "a person who or machine which trusses hay or straw [n -S]\n",
  "TRUSSERS": "TRUSSER, a person who or machine which trusses hay or straw [n]\n",
  "TRUSSES": "TRUSS, to secure tightly [v]\n",
  "TRUSSING": "the framework of a structure [n -S]\n",
  "TRUSSINGS": "TRUSSING, the framework of a structure [n]\n",
  "TRUST": "to place confidence in [v -ED, -ING, -S]\n",
  "TRUSTABILITIES": "TRUSTABILITY, the state of being trustable [n]\n",
  "TRUSTABILITY": "the state of being trustable [n TRUSTABILITIES]\n",
  "TRUSTABLE": "that can be trusted [adj]\n",
  "TRUSTAFARIAN": "an affluent young person who adopts a bohemian lifestyle and unkempt appearance [n -S]\n",
  "TRUSTAFARIANS": "TRUSTAFARIAN, an affluent young person who adopts a bohemian lifestyle and unkempt appearance [n]\n",
  "TRUSTBUSTER": "a person who works for or achieves the breakup of business trusts, e.g. by legislation [n -S]\n",
  "TRUSTBUSTERS": "TRUSTBUSTER, a person who works for or achieves the breakup of business trusts, e.g. by legislation [n]\n",
  "TRUSTBUSTING": "the dissolution of corporate trusts [n -S]\n",
  "TRUSTBUSTINGS": "TRUSTBUSTING, the dissolution of corporate trusts [n]\n",
  "TRUSTED": "TRUST, to place confidence in [v]\n",
  "TRUSTEE": "to entrust to an administrator [v TRUSTEED, TRUSTEEING, TRUSTEES]\n",
  "TRUSTEED": "TRUSTEE, to entrust to an administrator [v]\n",
  "TRUSTEEING": "TRUSTEE, to entrust to an administrator [v]\n",
  "TRUSTEES": "TRUSTEE, to entrust to an administrator [v]\n",
  "TRUSTEESHIP": "the office of trustee [n -S]\n",
  "TRUSTEESHIPS": "TRUSTEESHIP, the office of trustee [n]\n",
  "TRUSTER": "one who trusts [n -S]\n",
  "TRUSTERS": "TRUSTER, one who trusts [n]\n",
  "TRUSTFUL": "trusting [adj TRUSTFULLY]\n",
  "TRUSTFULLY": "TRUSTFUL, trusting [adv]\n",
  "TRUSTFULNESS": "the state of being trustful [n -ES]\n",
  "TRUSTFULNESSES": "TRUSTFULNESS, the state of being trustful [n]\n",
  "TRUSTIER": "TRUSTY, worthy of trust [adj]\n",
  "TRUSTIES": "TRUSTY, one worthy of trust [n]\n",
  "TRUSTIEST": "TRUSTY, worthy of trust [adj]\n",
  "TRUSTILY": "TRUSTY, worthy of trust [adv]\n",
  "TRUSTINESS": "the state of being trusty [n -ES]\n",
  "TRUSTINESSES": "TRUSTINESS, the state of being trusty [n]\n",
  "TRUSTING": "TRUST, to place confidence in [v]\n",
  "TRUSTINGLY": "TRUSTING, TRUST, to place confidence in [adv]\n",
  "TRUSTINGNESS": "the state of being trusting [n -ES]\n",
  "TRUSTINGNESSES": "TRUSTINGNESS, the state of being trusting [n]\n",
  "TRUSTLESS": "that may not be trusted; not worthy of trust [adj TRUSTLESSLY]\n",
  "TRUSTLESSLY": "TRUSTLESS, that may not be trusted; not worthy of trust [adv]\n",
  "TRUSTLESSNESS": "the state of being trustless [n -ES]\n",
  "TRUSTLESSNESSES": "TRUSTLESSNESS, the state of being trustless [n]\n",
  "TRUSTOR": "one who trustees his property [n -S]\n",
  "TRUSTORS": "TRUSTOR, one who trustees his property [n]\n",
  "TRUSTS": "TRUST, to place confidence in [v]\n",
  "TRUSTWORTHIER": "TRUSTWORTHY, worthy of confidence [adj]\n",
  "TRUSTWORTHIEST": "TRUSTWORTHY, worthy of confidence [adj]\n",
  "TRUSTWORTHILY": "TRUSTWORTHY, worthy of confidence [adv]\n",
  "TRUSTWORTHINESS": "the state of being trustworthy [n]\n",
  "TRUSTWORTHY": "worthy of confidence [adj TRUSTWORTHIER, TRUSTWORTHIEST; TRUSTWORTHILY]\n",
  "TRUSTY": "worthy of trust [adj TRUSTIER, TRUSTIEST, TRUSTILY] / one worthy of trust [n TRUSTIES]\n",
  "TRUTH": "conformity to fact or reality [n -S]\n",
  "TRUTHER": "a person who does not believe the official account of the 9/11 attacks on the US and who seeks to uncover the supposed truth about the events of that day [n -S]\n",
  "TRUTHERS": "TRUTHER, a person who does not believe the official account of the 9/11 attacks on the US and who seeks to uncover the supposed truth about the events of that day [n]\n",
  "TRUTHFUL": "telling the truth [adj TRUTHFULLY]\n",
  "TRUTHFULLY": "TRUTHFUL, telling the truth [adv]\n",
  "TRUTHFULNESS": "the state of being truthful [n -ES]\n",
  "TRUTHFULNESSES": "TRUTHFULNESS, the state of being truthful [n]\n",
  "TRUTHIER": "TRUTHY, characterized by truth [adj]\n",
  "TRUTHIEST": "TRUTHY, characterized by truth [adj]\n",
  "TRUTHINESS": "the quality of being considered to be true because of what the believer wishes or feels, regardless of the facts [n -ES]\n",
  "TRUTHINESSES": "TRUTHINESS, the quality of being considered to be true because of what the believer wishes or feels, regardless of the facts [n]\n",
  "TRUTHLESS": "devoid of truth; dishonest [adj]\n",
  "TRUTHLESSNESS": "the state of being truthless [n -ES]\n",
  "TRUTHLESSNESSES": "TRUTHLESSNESS, the state of being truthless [n]\n",
  "TRUTHLIKE": "like truth [adj]\n",
  "TRUTHS": "TRUTH, conformity to fact or reality [n]\n",
  "TRUTHY": "characterized by truth [adj TRUTHIER, TRUTHIEST]\n",
  "TRY": "to attempt [v TRIED or (obsolete) TRIDE, TRYING, TRIES]\n",
  "TRYE": "(Spenser) choice, purified, also TRIE [adj]\n",
  "TRYER": "one who tries, also TRIER, TRIOR [n -S]\n",
  "TRYERS": "TRYER, one who tries, also TRIER, TRIOR [n]\n",
  "TRYING": "demanding, annoying [adj TRYINGLY] / the act of trying [n -S]\n",
  "TRYINGLY": "TRYING, demanding, annoying [adv]\n",
  "TRYINGNESS": "the state of being trying [n -ES]\n",
  "TRYINGNESSES": "TRYINGNESS, the state of being trying [n]\n",
  "TRYINGS": "TRYING, the act of trying [n]\n",
  "TRYKE": "a tricycle, also TRIKE [n -S]\n",
  "TRYKES": "TRYKE, a tricycle, also TRIKE [n]\n",
  "TRYMA": "(Greek) a kind of nutlike fruit, such as walnut [n TRYMATA]\n",
  "TRYMATA": "TRYMA, (Greek) a kind of nutlike fruit, such as walnut [n]\n",
  "TRYOUT": "a test of ability [n -S]\n",
  "TRYOUTS": "TRYOUT, a test of ability [n]\n",
  "TRYP": "(short for) a trypanosome, a parasite causing sleeping sickness [n -S]\n",
  "TRYPAFLAVINE": "another name for acriflavine [n -S]\n",
  "TRYPAFLAVINES": "TRYPAFLAVINE, another name for acriflavine [n]\n",
  "TRYPAN": "as in trypan blue, a blue dye obtained from tolidine [adj]\n",
  "TRYPANOCIDAL": "relating to a trypanocide, a drug that kills trypanosomes [adj]\n",
  "TRYPANOCIDE": "a drug that kills trypanosomes [n -S]\n",
  "TRYPANOCIDES": "TRYPANOCIDE, a drug that kills trypanosomes [n]\n",
  "TRYPANOSOMAL": "of or like a trypanosome, also TRYPANOSOMIC [adj]\n",
  "TRYPANOSOME": "a parasite causing sleeping sickness [n -S]\n",
  "TRYPANOSOMES": "TRYPANOSOME, a parasite causing sleeping sickness [n]\n",
  "TRYPANOSOMIASES": "TRYPANOSOMIASIS, infection with or disease caused by trypanosomes [n]\n",
  "TRYPANOSOMIASIS": "infection with or disease caused by trypanosomes [n TRYPANOSOMIASES]\n",
  "TRYPANOSOMIC": "of or like a trypanosome, also TRYPANOSOMAL [adj]\n",
  "TRYPARSAMIDE": "a synthetic crystalline compound of arsenic used in the treatment of trypanosomal and other protozoan infections [n -S]\n",
  "TRYPARSAMIDES": "TRYPARSAMIDE, a synthetic crystalline compound of arsenic used in the treatment of trypanosomal and other protozoan infections [n]\n",
  "TRYPS": "TRYP, (short for) a trypanosome, a parasite causing sleeping sickness [n]\n",
  "TRYPSIN": "an enzyme secreted by the pancreas [n -S]\n",
  "TRYPSINOGEN": "the inactive substance from which trypsin is formed in the duodenum [n -S]\n",
  "TRYPSINOGENS": "TRYPSINOGEN, the inactive substance from which trypsin is formed in the duodenum [n]\n",
  "TRYPSINS": "TRYPSIN, an enzyme secreted by the pancreas [n]\n",
  "TRYPTAMINE": "a crystalline amine derived from tryptophan [n -S]\n",
  "TRYPTAMINES": "TRYPTAMINE, a crystalline amine derived from tryptophan [n]\n",
  "TRYPTIC": "relating to trypsin, an enzyme secreted by the pancreas [adj]\n",
  "TRYPTOPHAN": "an essential amino acid, also TRYPTOPHANE [n -S]\n",
  "TRYPTOPHANE": "an essential amino acid, also TRYPTOPHAN [n -S]\n",
  "TRYPTOPHANES": "TRYPTOPHANE, an essential amino acid, also TRYPTOPHAN [n]\n",
  "TRYPTOPHANS": "TRYPTOPHAN, an essential amino acid, also TRYPTOPHANE [n]\n",
  "TRYSAIL": "a ship's sail bent to a gaff and hoisted on a lower mast [n -S]\n",
  "TRYSAILS": "TRYSAIL, a ship's sail bent to a gaff and hoisted on a lower mast [n]\n",
  "TRYST": "to make an appointment with [v -ED, -ING, -S]\n",
  "TRYSTE": "a market [n -S]\n",
  "TRYSTED": "TRYST, to make an appointment with [v]\n",
  "TRYSTER": "one who makes an appointment, or tryst [n -S]\n",
  "TRYSTERS": "TRYSTER, one who makes an appointment, or tryst [n]\n",
  "TRYSTES": "TRYSTE, a market [n]\n",
  "TRYSTING": "TRYST, to make an appointment with [v]\n",
  "TRYSTS": "TRYST, to make an appointment with [v]\n",
  "TRYWORKS": "a type of furnace [n]\n",
  "TSADDIK": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n TSADDIKS or TSADDIKIM]\n",
  "TSADDIKIM": "TSADDIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TSADDIKS": "TSADDIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TSADDIQ": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n TSADDIQS or TSADDIQIM]\n",
  "TSADDIQIM": "TSADDIQ, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TSADDIQS": "TSADDIQ, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TSADE": "(Hebrew) a Hebrew letter, also SADE, SADHE, SADI, TSADI, TZADDI [n -S]\n",
  "TSADES": "TSADE, (Hebrew) a Hebrew letter, also SADE, SADHE, SADI, TSADI, TZADDI [n]\n",
  "TSADI": "(Hebrew) a Hebrew letter, also SADE, SADHE, SADI, TSADE, TZADDI [n -S]\n",
  "TSADIK": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n -S]\n",
  "TSADIKS": "TSADIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TZADDIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TSADIS": "TSADI, (Hebrew) a Hebrew letter, also SADE, SADHE, SADI, TSADE, TZADDI [n]\n",
  "TSAMBA": "(Tibetan) a Tibetan barley dish [n -S]\n",
  "TSAMBAS": "TSAMBA, (Tibetan) a Tibetan barley dish [n]\n",
  "TSANTSA": "(Shuari) among the Jivaro, the shrunken head of an enemy kept as a trophy [n -S]\n",
  "TSANTSAS": "TSANTSA, (Shuari) among the Jivaro, the shrunken head of an enemy kept as a trophy [n]\n",
  "TSAR": "(Russian) a ruler, emperor, also CZAR, KSAR, TZAR [n -S]\n",
  "TSARDOM": "the domain of a czar, also TZARDOM, CZARDOM [n -S]\n",
  "TSARDOMS": "TSARDOM, the domain of a czar, also TZARDOM, CZARDOM [n]\n",
  "TSAREVICH": "(Russian) the wife of a tsar, also CZAREVICH [n -ES]\n",
  "TSAREVICHES": "TSAREVICH, (Russian) the wife of a tsar, also CZAREVICH [n]\n",
  "TSAREVITCH": "(Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "TSAREVITCHES": "TSAREVITCH, (Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n]\n",
  "TSAREVNA": "(Russian) the daughter of a tsar, also CZAREVNA, TZAREVNA [n -S]\n",
  "TSAREVNAS": "TSAREVNA, (Russian) the daughter of a tsar, also CZAREVNA, TZAREVNA [n]\n",
  "TSARINA": "(Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n -S]\n",
  "TSARINAS": "TSARINA, (Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARITSA, TSARITZA, TZARINA, TZARITZA [n]\n",
  "TSARISM": "government by a tsar, also CZARISM, TZARISM [n -S]\n",
  "TSARISMS": "TSARISM, government by a tsar, also CZARISM, TZARISM [n]\n",
  "TSARIST": "a supporter of tsarism, also CZARIST, TZARIST [n -S]\n",
  "TSARISTS": "TSARIST, a supporter of tsarism, also CZARIST, TZARIST [n]\n",
  "TSARITSA": "(Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITZA, TZARINA, TZARITZA [n -S]\n",
  "TSARITSAS": "TSARITSA, (Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITZA, TZARINA, TZARITZA [n]\n",
  "TSARITZA": "(Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITSA, TZARINA, TZARITZA [n -S]\n",
  "TSARITZAS": "TSARITZA, (Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITSA, TZARINA, TZARITZA [n]\n",
  "TSARS": "TSAR, (Russian) a ruler, emperor, also CZAR, KSAR, TZAR [n]\n",
  "TSATSKE": "(Yiddish) a knickknack, a cheap trinket, also CHACHKA, CHATCHKA, CHATCHKE, TCHOTCHKE [n -S]\n",
  "TSATSKES": "TSATSKE, (Yiddish) a knickknack, a cheap trinket, also CHACHKA, CHATCHKA, CHATCHKE, TCHOTCHKE [n]\n",
  "TSCHERNOSEM": "(Russian) a very fertile soil of subhumid steppe, also CHERNOZEM [n -S]\n",
  "TSCHERNOSEMS": "TSCHERNOSEM, (Russian) a very fertile soil of subhumid steppe, also CHERNOZEM [n]\n",
  "TSESAREVICH": "(Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "TSESAREVICHES": "TSESAREVICH, (Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVITCH, TSESAREWICH, TSESAREWITCH [n]\n",
  "TSESAREVITCH": "(Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREWICH, TSESAREWITCH [n -ES]\n",
  "TSESAREVITCHES": "TSESAREVITCH, (Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREWICH, TSESAREWITCH [n]\n",
  "TSESAREVNA": "(Russian) the wife of a tsar's eldest son, also CESAREVNA [n -S]\n",
  "TSESAREVNAS": "TSESAREVNA, (Russian) the wife of a tsar's eldest son, also CESAREVNA [n]\n",
  "TSESAREWICH": "(Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWITCH [n -ES]\n",
  "TSESAREWICHES": "TSESAREWICH, (Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWITCH [n]\n",
  "TSESAREWITCH": "(Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH [n -ES]\n",
  "TSESAREWITCHES": "TSESAREWITCH, (Russian) the eldest son of a tsar, heir to the tsardom, also CESAREVICH, CESAREVITCH, CESAREWICH, CESAREWITCH, TSAREVITCH, TSESAREVICH, TSESAREVITCH, TSESAREWICH [n]\n",
  "TSESSEBE": "(Setswana) a kind of African antelope, also SASSABY [n -S]\n",
  "TSESSEBES": "TSESSEBE, (Setswana) a kind of African antelope, also SASSABY [n]\n",
  "TSETSE": "(Setswana) a small fly that transmits trypanosome parasites, also TZETSE, TZETZE [n -S]\n",
  "TSETSES": "TSETSE, (Setswana) a small fly that transmits trypanosome parasites, also TZETSE, TZETZE [n]\n",
  "TSIGANE": "(Hungarian) a gypsy, also TZIGANE, TZIGANY, ZIGAN [n -S]\n",
  "TSIGANES": "TSIGANE, (Hungarian) a gypsy, also TZIGANE, TZIGANY, ZIGAN [n]\n",
  "TSIMMES": "(Yiddish) a sweetened stew of vegetables, fruit and meat, also TZIMMES [n TSIMMES]\n",
  "TSITSITH": "(Hebrew) the tassels on the four corners of a Jewish prayer shawl, also TZITZIS, TZITZIT, TZITZITH, ZIZIT, ZIZITH [n]\n",
  "TSK": "to utter an exclamation of annoyance, also TSKTSK [v -ED, -ING, -S]\n",
  "TSKED": "TSK, to utter an exclamation of annoyance, also TSKTSK [v]\n",
  "TSKING": "TSK, to utter an exclamation of annoyance, also TSKTSK [v]\n",
  "TSKS": "TSK, to utter an exclamation of annoyance, also TSKTSK [v]\n",
  "TSKTSK": "to utter an exclamation of annoyance, also TSK [v -ED, -ING, -S]\n",
  "TSKTSKED": "TSKTSK, to utter an exclamation of annoyance, also TSK [v]\n",
  "TSKTSKING": "TSKTSK, to utter an exclamation of annoyance, also TSK [v]\n",
  "TSKTSKS": "TSKTSK, to utter an exclamation of annoyance, also TSK [v]\n",
  "TSOORIS": "(Yiddish) grief, woe, also TSORES, TSORIS, TSORRISS, TSOURIS, TSURIS, TZURIS [n TSOORIS]\n",
  "TSORES": "(Yiddish) grief, woe, also TSOORIS, TSORIS, TSORRISS, TSOURIS, TSURIS, TZURIS [n]\n",
  "TSORIS": "(Yiddish) grief, woe, also TSOORIS, TSORES, TSORRISS, TSOURIS, TSURIS, TZURIS [n]\n",
  "TSORRISS": "(Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSOURIS, TSURIS, TZURIS [n]\n",
  "TSOTSI": "(South African) a member of a black South African street gang; a young hooligan [n -S]\n",
  "TSOTSIS": "TSOTSI, (South African) a member of a black South African street gang; a young hooligan [n]\n",
  "TSOTSITAAL": "(South African) the street slang used by tsotsis [n -S]\n",
  "TSOTSITAALS": "TSOTSITAAL, (South African) the street slang used by tsotsis [n]\n",
  "TSOURIS": "(Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSORRISS, TSURIS, TZURIS [n]\n",
  "TSOURISES": "TSOURIS, (Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSORRISS, TSURIS, TZURIS [n]\n",
  "TSUBA": "(Japanese) a metal plate at the top of a Japanese scabbard, serving as a sword-guard [n -S]\n",
  "TSUBAS": "TSUBA, (Japanese) a metal plate at the top of a Japanese scabbard, serving as a sword-guard [n]\n",
  "TSUBO": "(Japanese) a unit of area [n -S]\n",
  "TSUBOS": "TSUBO, (Japanese) a unit of area [n]\n",
  "TSUNAMI": "(Japanese) a great sea wave produced by submarine earth movement or volcanic eruption [n -S]\n",
  "TSUNAMIC": "relating to a tsunami, a great sea wave produced by submarine earth movement or volcanic eruption [adj]\n",
  "TSUNAMIGENIC": "producing a tsunami or tsunamis [adj]\n",
  "TSUNAMIS": "TSUNAMI, (Japanese) a great sea wave produced by submarine earth movement or volcanic eruption [n]\n",
  "TSURIS": "(Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSORRISS, TSOURIS, TZURIS [n -ES]\n",
  "TSURISES": "TSURIS, (Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSORRISS, TSOURIS, TZURIS [n]\n",
  "TSUTSUGAMUSHI": "(Japanese) any of various rickettsial disease, including scrub typhus [n -S]\n",
  "TSUTSUGAMUSHIS": "TSUTSUGAMUSHI, (Japanese) any of various rickettsial disease, including scrub typhus [n]\n",
  "TSUTSUMU": "(Japanese) the art of wrapping articles in a harmonious way [n -S]\n",
  "TSUTSUMUS": "TSUTSUMU, (Japanese) the art of wrapping articles in a harmonious way [n]\n",
  "TUAN": "(Native Australian) an Australian marsupial, aka wambenger or brush-tailed phascogale [n -S]\n",
  "TUANS": "TUAN, (Native Australian) an Australian marsupial, aka wambenger or brush-tailed phascogale [n]\n",
  "TUART": "(Native Australian) a strong-timbered eucalyptus, also TEWART, TOOART [n -S]\n",
  "TUARTS": "TUART, (Native Australian) a strong-timbered eucalyptus, also TEWART, TOOART [n]\n",
  "TUATARA": "(Maori) a primitive reptile found in New Zealand, of the genus Hatteria, also TUATERA [n -S]\n",
  "TUATARAS": "TUATARA, (Maori) a primitive reptile found in New Zealand, of the genus Hatteria, also TUATERA [n]\n",
  "TUATERA": "(Maori) a primitive reptile found in New Zealand, of the genus Hatteria, also TUATARA [n -S]\n",
  "TUATERAS": "TUATERA, (Maori) a primitive reptile found in New Zealand, of the genus Hatteria, also TUATARA [n]\n",
  "TUATH": "(Irish) a tribe, people [n -S]\n",
  "TUATHS": "TUATH, (Irish) a tribe, people [n]\n",
  "TUATUA": "(Maori) an edible marine bivalve mollusc of New Zealand [n -S]\n",
  "TUATUAS": "TUATUA, (Maori) an edible marine bivalve mollusc of New Zealand [n]\n",
  "TUB": "to wash in a large receptacle [v TUBBED, TUBBING, TUBS]\n",
  "TUBA": "(Latin) a brass wind instrument [n TUBAS or TUBAE]\n",
  "TUBAE": "TUBA, (Latin) a brass wind instrument [n]\n",
  "TUBAGE": "the insertion of a tube [n -S]\n",
  "TUBAGES": "TUBAGE, the insertion of a tube [n]\n",
  "TUBAIST": "a tuba player, also TUBIST [n -S]\n",
  "TUBAISTS": "TUBAIST, a tuba player, also TUBIST [n]\n",
  "TUBAL": "in the form of a tube, also TUBAR, TUBATE, TUBULAR [adj]\n",
  "TUBAR": "in the form of a tube, also TUBAL, TUBATE, TUBULAR [adj]\n",
  "TUBAS": "TUBA, (Latin) a brass wind instrument [n]\n",
  "TUBATE": "in the form of a tube, also TUBAL, TUBAR, TUBULAR [adj]\n",
  "TUBBABLE": "suitable for washing in a tub [adj]\n",
  "TUBBED": "TUB, to wash in a large receptacle [v]\n",
  "TUBBER": "one who tubs i.e. takes baths [n -S]\n",
  "TUBBERS": "TUBBER, one who tubs i.e. takes baths [n]\n",
  "TUBBIER": "TUBBY, corpulent, also TUBBISH [adj]\n",
  "TUBBIEST": "TUBBY, corpulent, also TUBBISH [adj]\n",
  "TUBBINESS": "the state of being tubby [n -ES]\n",
  "TUBBINESSES": "TUBBINESS, the state of being tubby [n]\n",
  "TUBBING": "material for making tubs [n -S]\n",
  "TUBBINGS": "TUBBING, material for making tubs [n]\n",
  "TUBBISH": "round and fat, also TUBBY [adj]\n",
  "TUBBY": "corpulent, also TUBBISH [adj TUBBIER, TUBBIEST]\n",
  "TUBE": "to fit with a long hollow pipe [v TUBED, TUBING, TUBES]\n",
  "TUBECTOMIES": "TUBECTOMY, the surgical cutting or removal of the Fallopian tubes [n]\n",
  "TUBECTOMY": "the surgical cutting or removal of the Fallopian tubes [n TUBECTOMIES]\n",
  "TUBED": "TUBE, to fit with a long hollow pipe [v]\n",
  "TUBEFUL": "as much as a tube can hold [n -S]\n",
  "TUBEFULS": "TUBEFUL, as much as a tube can hold [n]\n",
  "TUBELESS": "without a tube [adj]\n",
  "TUBELIKE": "like a tube [adj]\n",
  "TUBENOSE": "a bird with tubular nostrils [n -S]\n",
  "TUBENOSES": "TUBENOSE, a bird with tubular nostrils [n]\n",
  "TUBER": "an underground stem which has been modified for storage of nutrients, such as a potato [n -S]\n",
  "TUBERACEOUS": "belonging to the Tuberaceae, edible fungi including truffles [adj]\n",
  "TUBERCLE": "a small tuber, protuberance or swelling, also TUBERCULE [n -S]\n",
  "TUBERCLED": "having tubercles [adj]\n",
  "TUBERCLES": "TUBERCLE, a small tuber, protuberance or swelling, also TUBERCULE [n]\n",
  "TUBERCULA": "TUBERCULUM, a tubercle [n]\n",
  "TUBERCULAR": "affected with tubercles [adj TUBERCULARLY] / someone affected with tubercles [n -S]\n",
  "TUBERCULARLY": "TUBERCULAR, affected with tubercles [adv]\n",
  "TUBERCULARS": "TUBERCULAR, someone affected with tubercles [n]\n",
  "TUBERCULATE": "bearing tubercles, knobbly projections or excrescences, also TUBERCULATED [adj TUBERCULATELY]\n",
  "TUBERCULATED": "bearing tubercles, knobbly projections or excrescences, also TUBERCULATE [adj]\n",
  "TUBERCULATELY": "TUBERCULATE, bearing tubercles, knobbly projections or excrescences, also TUBERCULATED [adv]\n",
  "TUBERCULATION": "the formation of tubercles [n -S]\n",
  "TUBERCULATIONS": "TUBERCULATION, the formation of tubercles [n]\n",
  "TUBERCULE": "a small tuber, protuberance or swelling, also TUBERCLE [n -S]\n",
  "TUBERCULES": "TUBERCULE, a small tuber, protuberance or swelling, also TUBERCLE [n]\n",
  "TUBERCULIN": "a fluid containing the products formed by the growth of the tubercle bacillus in a suitable culture medium [n -S]\n",
  "TUBERCULINS": "TUBERCULIN, a fluid containing the products formed by the growth of the tubercle bacillus in a suitable culture medium [n]\n",
  "TUBERCULISATION": "the process of tuberculising, also TUBERCULIZATION [n]\n",
  "TUBERCULISE": "to infect with tuberculosis, also TUBERCULIZE [v TUBERCULISED, TUBERCULISING, TUBERCULISES]\n",
  "TUBERCULISED": "TUBERCULISE, to infect with tuberculosis, also TUBERCULIZE [v]\n",
  "TUBERCULISES": "TUBERCULISE, to infect with tuberculosis, also TUBERCULIZE [v]\n",
  "TUBERCULISING": "TUBERCULISE, to infect with tuberculosis, also TUBERCULIZE [v]\n",
  "TUBERCULIZATION": "the process of tuberculizing, also TUBERCULISATION [n]\n",
  "TUBERCULIZE": "to infect with tuberculosis, also TUBERCULISE [v TUBERCULIZED, TUBERCULIZING, TUBERCULIZES]\n",
  "TUBERCULIZED": "TUBERCULIZE, to infect with tuberculosis, also TUBERCULISE [v]\n",
  "TUBERCULIZES": "TUBERCULIZE, to infect with tuberculosis, also TUBERCULISE [v]\n",
  "TUBERCULIZING": "TUBERCULIZE, to infect with tuberculosis, also TUBERCULISE [v]\n",
  "TUBERCULOID": "resembling tuberculosis esp. in the presence of tubercles [adj]\n",
  "TUBERCULOMA": "a slow-growing, circumscribed tuberculous lesion [n TUBERCULOMAS or TUBERCULOMATA]\n",
  "TUBERCULOMAS": "TUBERCULOMA, a slow-growing, circumscribed tuberculous lesion [n]\n",
  "TUBERCULOMATA": "TUBERCULOMA, a slow-growing, circumscribed tuberculous lesion [n]\n",
  "TUBERCULOSE": "tuberculous, also TUBERCULOSED, TUBERCULOUS [adj]\n",
  "TUBERCULOSED": "tuberculous, also TUBERCULOSE, TUBERCULOUS [adj]\n",
  "TUBERCULOSES": "TUBERCULOSIS, consumption or phthisis, a disease caused by the tubercle bacillus [n]\n",
  "TUBERCULOSIS": "consumption or phthisis, a disease caused by the tubercle bacillus [n TUBERCULOSES]\n",
  "TUBERCULOUS": "relating to tubercles, also TUBERCULOSE, TUBERCULOSED [adj TUBERCULOUSLY]\n",
  "TUBERCULOUSLY": "TUBERCULOUS, relating to tubercles, also TUBERCULOSE, TUBERCULOSED [adv]\n",
  "TUBERCULUM": "a tubercle [n TUBERCULA]\n",
  "TUBERIFEROUS": "bearing tubers [adj]\n",
  "TUBERIFORM": "shaped like a lump or protuberance [adj]\n",
  "TUBEROID": "a thickened or fleshy root resembling a tuber [n -S]\n",
  "TUBEROIDS": "TUBEROID, a thickened or fleshy root resembling a tuber [n]\n",
  "TUBEROSE": "a Mexican amaryllid with fragrant, creamy-white flowers [n -S]\n",
  "TUBEROSES": "TUBEROSE, a Mexican amaryllid with fragrant, creamy-white flowers [n]\n",
  "TUBEROSITIES": "TUBEROSITY, the state of being tuberous [n]\n",
  "TUBEROSITY": "the state of being tuberous [n TUBEROSITIES]\n",
  "TUBEROUS": "having tubers; knobbed [adj]\n",
  "TUBERS": "TUBER, an underground stem which has been modified for storage of nutrients, such as a potato [n]\n",
  "TUBES": "TUBE, to fit with a long hollow pipe [v]\n",
  "TUBEWELL": "a water well in which a long steel tube is bored into an underground aquifer [n -S]\n",
  "TUBEWELLS": "TUBEWELL, a water well in which a long steel tube is bored into an underground aquifer [n]\n",
  "TUBEWORK": "tubing [n -S]\n",
  "TUBEWORKS": "TUBEWORK, tubing [n]\n",
  "TUBEWORM": "a marine worm that builds and lives in a tube [n -S]\n",
  "TUBEWORMS": "TUBEWORM, a marine worm that builds and lives in a tube [n]\n",
  "TUBFAST": "(Shakespeare) the treatment of venereal disease by fasting and sweating in a hot tub [n -S]\n",
  "TUBFASTS": "TUBFAST, (Shakespeare) the treatment of venereal disease by fasting and sweating in a hot tub [n]\n",
  "TUBFISH": "the gurnard fish [n -ES]\n",
  "TUBFISHES": "TUBFISH, the gurnard fish [n]\n",
  "TUBFUL": "as much as a tub can hold [n -S]\n",
  "TUBFULS": "TUBFUL, as much as a tub can hold [n]\n",
  "TUBICOLAR": "inhabiting a tube, also TUBICOLOUS [adj]\n",
  "TUBICOLE": "a creature inhabiting a tube [n -S]\n",
  "TUBICOLES": "TUBICOLE, a creature inhabiting a tube [n]\n",
  "TUBICOLOUS": "inhabiting a tube, also TUBICOLAR [adj]\n",
  "TUBIFEX": "a freshwater tubicolous worm used as bait [n -ES]\n",
  "TUBIFEXES": "TUBIFEX, a freshwater tubicolous worm used as bait [n]\n",
  "TUBIFICID": "a tubifex, a freshwater tubicolous worm used as bait [n -S]\n",
  "TUBIFICIDS": "TUBIFICID, a tubifex, a freshwater tubicolous worm used as bait [n]\n",
  "TUBIFLOROUS": "having tubular flowers [adj]\n",
  "TUBIFORM": "shaped like a tube, also TUBULAR, TUBAR, TUBATE, TUBULOSE, TUBULOUS [adj]\n",
  "TUBING": "material in the form of a slim pipe [n -S]\n",
  "TUBINGS": "TUBING, material in the form of a slim pipe [n]\n",
  "TUBIST": "a tuba player, also TUBAIST [n -S]\n",
  "TUBISTS": "TUBIST, a tuba player, also TUBAIST [n]\n",
  "TUBLIKE": "like a tub [adj]\n",
  "TUBOCURARINE": "a toxic alkaloid obtained from the stem of a South American vine [n -S]\n",
  "TUBOCURARINES": "TUBOCURARINE, a toxic alkaloid obtained from the stem of a South American vine [n]\n",
  "TUBOPLASTIES": "TUBOPLASTY, the surgical repair of a Fallopian tube [n]\n",
  "TUBOPLASTY": "the surgical repair of a Fallopian tube [n TUBOPLASTIES]\n",
  "TUBS": "TUB, to wash in a large receptacle [v]\n",
  "TUBULAR": "in the form of a tube, also TUBAL, TUBAR, TUBATE [adj TUBULARLY] / a completely enclosed bicycle tire [n -S]\n",
  "TUBULARIAN": "any hydroid belonging to the suborder Tubularida [n -S]\n",
  "TUBULARIANS": "TUBULARIAN, any hydroid belonging to the suborder Tubularida [n]\n",
  "TUBULARITIES": "TUBULARITY, the state of being tubular [n]\n",
  "TUBULARITY": "the state of being tubular [n TUBULARITIES]\n",
  "TUBULARLY": "TUBULAR, in the form of a tube, also TUBAL, TUBAR, TUBATE [adv]\n",
  "TUBULARS": "TUBULAR, a completely enclosed bicycle tire [n]\n",
  "TUBULATE": "to form into a tube [v TUBULATED, TUBULATING, TUBULATES]\n",
  "TUBULATED": "TUBULATE, to form into a tube [v]\n",
  "TUBULATES": "TUBULATE, to form into a tube [v]\n",
  "TUBULATING": "TUBULATE, to form into a tube [v]\n",
  "TUBULATION": "the act of shaping or making a tube [n -S]\n",
  "TUBULATIONS": "TUBULATION, the act of shaping or making a tube [n]\n",
  "TUBULATOR": "one who tubulates [n -S]\n",
  "TUBULATORS": "TUBULATOR, one who tubulates [n]\n",
  "TUBULATURE": "tubes collectively [n -S]\n",
  "TUBULATURES": "TUBULATURE, tubes collectively [n]\n",
  "TUBULE": "a small tube [n -S]\n",
  "TUBULES": "TUBULE, a small tube [n]\n",
  "TUBULIFLORAL": "having tubular-shaped flowers, also TUBULIFLOROUS [adj]\n",
  "TUBULIFLOROUS": "having tubular-shaped flowers, also TUBULIFLORAL [adj]\n",
  "TUBULIN": "a globular protein [n -S]\n",
  "TUBULINS": "TUBULIN, a globular protein [n]\n",
  "TUBULOSE": "shaped like a tube, also TUBULAR, TUBAR, TUBATE, TUBIFORM, TUBULOUS [adj]\n",
  "TUBULOUS": "shaped like a tube, also TUBULAR, TUBAR, TUBATE, TUBIFORM, TUBULOSE [adj TUBULOUSLY]\n",
  "TUBULOUSLY": "TUBULOUS, shaped like a tube, also TUBULAR, TUBAR, TUBATE, TUBIFORM, TUBULOSE [adv]\n",
  "TUBULURE": "a short tubular opening [n -S]\n",
  "TUBULURES": "TUBULURE, a short tubular opening [n]\n",
  "TUCHIS": "(Yiddish) the buttocks, also TUCHUS, TUSH, TUSHIE, TUSHY [n -ES]\n",
  "TUCHISES": "TUCHIS, (Yiddish) the buttocks, also TUCHUS, TUSH, TUSHIE, TUSHY [n]\n",
  "TUCHUN": "(Chinese) a Chinese military governor [n -S]\n",
  "TUCHUNS": "TUCHUN, (Chinese) a Chinese military governor [n]\n",
  "TUCHUS": "(Yiddish) the buttocks, also TUCHIS, TUSH, TUSHIE, TUSHY [n -ES]\n",
  "TUCHUSES": "TUCHUS, (Yiddish) the buttocks, also TUCHIS, TUSH, TUSHIE, TUSHY [n]\n",
  "TUCK": "to fold under [v -ED, -ING, -S]\n",
  "TUCKAHOE": "(Native American) an edible fungus of the United States [n -S]\n",
  "TUCKAHOES": "TUCKAHOE, (Native American) an edible fungus of the United States [n]\n",
  "TUCKAMORE": "(Canadian) a stunted tree or bush, especially a spruce or juniper, with creeping roots and interlacing branches [n -S]\n",
  "TUCKAMORES": "TUCKAMORE, (Canadian) a stunted tree or bush, especially a spruce or juniper, with creeping roots and interlacing branches [n]\n",
  "TUCKBOX": "a box used for carrying and storing food, esp. one taken to boarding school [n -ES]\n",
  "TUCKBOXES": "TUCKBOX, a box used for carrying and storing food, esp. one taken to boarding school [n]\n",
  "TUCKED": "TUCK, to fold under [v]\n",
  "TUCKER": "to tire out [v -ED, -ING, -S]\n",
  "TUCKERBAG": "a bag used to carry food in the bush or by jolly swagmen [n -S]\n",
  "TUCKERBAGS": "TUCKERBAG, a bag used to carry food in the bush or by jolly swagmen [n]\n",
  "TUCKERBOX": "(Australian) a box for carrying food in [n -ES]\n",
  "TUCKERBOXES": "TUCKERBOX, (Australian) a box for carrying food in [n]\n",
  "TUCKERED": "TUCKER, to tire out [v]\n",
  "TUCKERING": "TUCKER, to tire out [v]\n",
  "TUCKERS": "TUCKER, to tire out [v]\n",
  "TUCKET": "(archaic) a fanfare on a trumpet [n -S]\n",
  "TUCKETS": "TUCKET, (archaic) a fanfare on a trumpet [n]\n",
  "TUCKING": "a collection of tucks [n -S]\n",
  "TUCKINGS": "TUCKING, a collection of tucks [n]\n",
  "TUCKS": "TUCK, to fold under [v]\n",
  "TUCKSHOP": "a confectioner's shop [n -S]\n",
  "TUCKSHOPS": "TUCKSHOP, a confectioner's shop [n]\n",
  "TUCOTUCO": "a South American rodent of mole-like habits, also TUCUTUCO, TUCUTUCU [n -S]\n",
  "TUCOTUCOS": "TUCOTUCO, a South American rodent of mole-like habits, also TUCUTUCO, TUCUTUCU [n]\n",
  "TUCUTUCO": "a South American rodent of mole-like habits, also TUCOTUCO, TUCUTUCU [n -S]\n",
  "TUCUTUCOS": "TUCUTUCO, a South American rodent of mole-like habits, also TUCOTUCO, TUCUTUCU [n]\n",
  "TUCUTUCU": "a South American rodent of mole-like habits, also TUCOTUCO, TUCUTUCO [n -S]\n",
  "TUCUTUCUS": "TUCUTUCU, a South American rodent of mole-like habits, also TUCOTUCO, TUCUTUCO [n]\n",
  "TUFA": "(Italian) a rock made of fine volcanic detritus, also CALCTUFA, TOPH, TOPHE [n -S]\n",
  "TUFACEOUS": "consisting of, or resembling, tufa [adj]\n",
  "TUFAS": "TUFA, (Italian) a rock made of fine volcanic detritus, also CALCTUFA, TOPH, TOPHE [n]\n",
  "TUFF": "a general term for all consolidated pyroclastic rock, also CALCTUFF [n -S]\n",
  "TUFFACEOUS": "of or like tuff [adj]\n",
  "TUFFE": "(Shakespeare) a tuft [n -S]\n",
  "TUFFES": "TUFFE, (Shakespeare) a tuft [n]\n",
  "TUFFET": "a clump of grass [n -S]\n",
  "TUFFETS": "TUFFET, a clump of grass [n]\n",
  "TUFFS": "TUFF, a general term for all consolidated pyroclastic rock, also CALCTUFF [n]\n",
  "TUFFTAFFETA": "(obsolete) a taffeta with a tufted pile, also TUFFTAFFETY, TUFTAFFETA, TUFTAFFETY [n -S]\n",
  "TUFFTAFFETAS": "TUFFTAFFETA, (obsolete) a taffeta with a tufted pile, also TUFFTAFFETY, TUFTAFFETA, TUFTAFFETY [n]\n",
  "TUFFTAFFETIES": "TUFFTAFFETY, (obsolete) a taffeta with a tufted pile, also TUFFTAFFETA, TUFTAFFETA, TUFTAFFETY [n]\n",
  "TUFFTAFFETY": "(obsolete) a taffeta with a tufted pile, also TUFFTAFFETA, TUFTAFFETA, TUFTAFFETY [n TUFFTAFFETIES]\n",
  "TUFOLI": "(Italian) a large macaroni shell [n -S]\n",
  "TUFOLIS": "TUFOLI, (Italian) a large macaroni shell [n]\n",
  "TUFT": "to form into a bunched cluster [v -ED, -ING, -S]\n",
  "TUFTAFFETA": "(archaic) a taffeta with a tufted pile, also TUFFTAFFETA, TUFFTAFFETY, TUFTAFFETY [n -S]\n",
  "TUFTAFFETAS": "TUFTAFFETA, (archaic) a taffeta with a tufted pile, also TUFFTAFFETA, TUFFTAFFETY, TUFTAFFETY [n]\n",
  "TUFTAFFETIES": "TUFTAFFETY, (archaic) a taffeta with a tufted pile, also TUFFTAFFETA, TUFFTAFFETY, TUFTAFFETA [n]\n",
  "TUFTAFFETY": "(archaic) a taffeta with a tufted pile, also TUFFTAFFETA, TUFFTAFFETY, TUFTAFFETA [n TUFTAFFETIES]\n",
  "TUFTED": "TUFT, to form into a bunched cluster [v]\n",
  "TUFTER": "a hound that drives deer out of cover [n -S]\n",
  "TUFTERS": "TUFTER, a hound that drives deer out of cover [n]\n",
  "TUFTIER": "TUFTY, abounding in tufts [adj]\n",
  "TUFTIEST": "TUFTY, abounding in tufts [adj]\n",
  "TUFTILY": "TUFTY, abounding in tufts [adv]\n",
  "TUFTING": "the act of decorating with tufts [n -S]\n",
  "TUFTINGS": "TUFTING, the act of decorating with tufts [n]\n",
  "TUFTS": "TUFT, to form into a bunched cluster [v]\n",
  "TUFTY": "abounding in tufts [adj TUFTIER, TUFTIEST, TUFTILY]\n",
  "TUG": "to pull with force [v TUGGED, TUGGING, TUGS]\n",
  "TUGBOAT": "a boat that tows other boats [n -S]\n",
  "TUGBOATS": "TUGBOAT, a boat that tows other boats [n]\n",
  "TUGGED": "TUG, to pull with force [v]\n",
  "TUGGER": "one who tugs, esp. in a tug of war [n -S]\n",
  "TUGGERS": "TUGGER, one who tugs, esp. in a tug of war [n]\n",
  "TUGGING": "pulling forcibly [adj TUGGINGLY] / the act of tugging [n -S]\n",
  "TUGGINGLY": "TUGGING, pulling forcibly [adv]\n",
  "TUGGINGS": "TUGGING, the act of tugging [n]\n",
  "TUGHRA": "(Turkish) an ornamental monogram incorporating the name and title of the Sultan, also TUGRA [n -S]\n",
  "TUGHRAS": "TUGHRA, (Turkish) an ornamental monogram incorporating the name and title of the Sultan, also TUGRA [n]\n",
  "TUGHRIK": "(Mongolian) a Mongolian monetary unit, also TOGROG, TUGRIK [n -S]\n",
  "TUGHRIKS": "TUGHRIK, (Mongolian) a Mongolian monetary unit, also TOGROG, TUGRIK [n]\n",
  "TUGLESS": "being without a rope or chain to pull [adj]\n",
  "TUGRA": "(Turkish) an ornamental monogram incorporating the name and title of the Sultan, also TUGHRA [n -S]\n",
  "TUGRAS": "TUGRA, (Turkish) an ornamental monogram incorporating the name and title of the Sultan, also TUGHRA [n]\n",
  "TUGRIK": "(Mongolian) a Mongolian monetary unit, also TOGROG, TUGHRIK [n -S]\n",
  "TUGRIKS": "TUGRIK, (Mongolian) a Mongolian monetary unit, also TOGROG, TUGHRIK [n]\n",
  "TUGS": "TUG, to pull with force [v]\n",
  "TUI": "(Maori) a New Zealand bird, a honey guide [n -S]\n",
  "TUILE": "(French) a thin cookie made with almonds [n -S]\n",
  "TUILES": "TUILE, (French) a thin cookie made with almonds [n]\n",
  "TUILLE": "(French) armour plate hanging below the tasses [n -S]\n",
  "TUILLES": "TUILLE, (French) armour plate hanging below the tasses [n]\n",
  "TUILLETTE": "(French) a small tuille, a piece of armour plate hanging below the tasses [n -S]\n",
  "TUILLETTES": "TUILLETTE, (French) a small tuille, a piece of armour plate hanging below the tasses [n]\n",
  "TUILYIE": "(Scots) to struggle, brawl, also TUILZIE [v TUILYIED, TUILYIEING, TUILYIES]\n",
  "TUILYIED": "TUILYIE, (Scots) to struggle, brawl, also TUILZIE [v]\n",
  "TUILYIEING": "TUILYIE, (Scots) to struggle, brawl, also TUILZIE [v]\n",
  "TUILYIES": "TUILYIE, (Scots) to struggle, brawl, also TUILZIE [v]\n",
  "TUILZIE": "(Scots) to struggle, brawl, also TUILYIE [v TUILZIED, TUILZIEING, TUILZIES]\n",
  "TUILZIED": "TUILZIE, (Scots) to struggle, brawl, also TUILYIE [v]\n",
  "TUILZIEING": "TUILZIE, (Scots) to struggle, brawl, also TUILYIE [v]\n",
  "TUILZIES": "TUILZIE, (Scots) to struggle, brawl, also TUILYIE [v]\n",
  "TUINA": "(Chinese) a Chinese therapeutic massage system [n -S]\n",
  "TUINAS": "TUINA, (Chinese) a Chinese therapeutic massage system [n]\n",
  "TUIS": "TUI, (Maori) a New Zealand bird, a honey guide [n]\n",
  "TUISM": "the theory that individuals have a second or other self [n -S]\n",
  "TUISMS": "TUISM, the theory that individuals have a second or other self [n]\n",
  "TUITION": "a fee for instruction [n -S]\n",
  "TUITIONAL": "relating to tuition [adj]\n",
  "TUITIONARY": "of or pertaining to tuition [adj]\n",
  "TUITIONS": "TUITION, a fee for instruction [n]\n",
  "TUKTOO": "(Inuit) a caribou, also TUKTU [n -S]\n",
  "TUKTOOS": "TUKTOO, (Inuit) a caribou, also TUKTU [n]\n",
  "TUKTU": "(Inuit) a caribou, also TUKTOO [n -S]\n",
  "TUKTUS": "TUKTU, (Inuit) a caribou, also TUKTOO [n]\n",
  "TULADI": "(Native American) a lake trout of North America, aka togue, also TOULADI [n -S]\n",
  "TULADIS": "TULADI, (Native American) a lake trout of North America, aka togue, also TOULADI [n]\n",
  "TULARAEMIA": "a disease of rodents caused by a bacterium, and transmissible to humans, also TULAREMIA [n -S]\n",
  "TULARAEMIAS": "TULARAEMIA, a disease of rodents caused by a bacterium, and transmissible to humans, also TULAREMIA [n]\n",
  "TULARAEMIC": "relating to tularaemia, a disease of rodents caused by a bacterium, and transmissible to humans, also TULAREMIC [adj]\n",
  "TULAREMIA": "a disease of rodents caused by a bacterium, and transmissible to humans, also TULARAEMIA [n -S]\n",
  "TULAREMIAS": "TULAREMIA, a disease of rodents caused by a bacterium, and transmissible to humans, also TULARAEMIA [n]\n",
  "TULAREMIC": "relating to tularemia, a disease of rodents caused by a bacterium, also TULARAEMIC [adj]\n",
  "TULBAN": "(obsolete) a turban, also TULIPANT, TURBAN, TURBAND, TURBANT, TURBOND, TURRIBANT [n -S]\n",
  "TULBANS": "TULBAN, (obsolete) a turban, also TULIPANT, TURBAN, TURBAND, TURBANT, TURBOND, TURRIBANT [n]\n",
  "TULCHAN": "(Gaelic) a calf's skin set beside a cow to make her give milk freely [n -S]\n",
  "TULCHANS": "TULCHAN, (Gaelic) a calf's skin set beside a cow to make her give milk freely [n]\n",
  "TULE": "(Nahuatl) a large American bulrush [n -S]\n",
  "TULES": "TULE, (Nahuatl) a large American bulrush [n]\n",
  "TULIP": "any plant or flower of the bulbous liliaceous genus Tulipa, with showy, usually solitary, flowers [n -S]\n",
  "TULIPANT": "(obsolete) a turban, also TULBAN, TURBAN, TURBAND, TURBANT, TURBOND, TURRIBANT [n -S]\n",
  "TULIPANTS": "TULIPANT, (obsolete) a turban, also TULBAN, TURBAN, TURBAND, TURBANT, TURBOND, TURRIBANT [n]\n",
  "TULIPLIKE": "like a tulip [adj]\n",
  "TULIPOMANIA": "an obsession with tulips [n -S]\n",
  "TULIPOMANIAS": "TULIPOMANIA, an obsession with tulips [n]\n",
  "TULIPS": "TULIP, any plant or flower of the bulbous liliaceous genus Tulipa, with showy, usually solitary, flowers [n]\n",
  "TULIPWOOD": "the beautiful rose-colored striped wood of a Brazilian tree, much used by cabinetmakers for inlaying [n -S]\n",
  "TULIPWOODS": "TULIPWOOD, the beautiful rose-colored striped wood of a Brazilian tree, much used by cabinetmakers for inlaying [n]\n",
  "TULLE": "(French) a sheer and delicate thin silk [n -S]\n",
  "TULLES": "TULLE, (French) a sheer and delicate thin silk [n]\n",
  "TULLIBEE": "(Native American) a whitefish found in the Great Lakes of North America [n -S]\n",
  "TULLIBEES": "TULLIBEE, (Native American) a whitefish found in the Great Lakes of North America [n]\n",
  "TULPA": "(Tibetan) a being or object created by willpower and visualization techniques [n -S]\n",
  "TULPAS": "TULPA, (Tibetan) a being or object created by willpower and visualization techniques [n]\n",
  "TULSI": "(Hindi) a type of basil, a sacred plant in Hindu belief [n -S]\n",
  "TULSIS": "TULSI, (Hindi) a type of basil, a sacred plant in Hindu belief [n]\n",
  "TULWAR": "(Hindi) an Indian sabre [n -S]\n",
  "TULWARS": "TULWAR, (Hindi) an Indian sabre [n]\n",
  "TUM": "(colloquial) the stomach, also TUMMY [n -S]\n",
  "TUMATAKURU": "(Maori) a native thorny shrub of New Zealand, aka Wild Irishman [n -S]\n",
  "TUMATAKURUS": "TUMATAKURU, (Maori) a native thorny shrub of New Zealand, aka Wild Irishman [n]\n",
  "TUMBLE": "to roll head over heels [v TUMBLED, TUMBLING, TUMBLES]\n",
  "TUMBLEBUG": "a dung beetle, that rolls up balls of dung for protection and nourishment of young [n -S]\n",
  "TUMBLEBUGS": "TUMBLEBUG, a dung beetle, that rolls up balls of dung for protection and nourishment of young [n]\n",
  "TUMBLED": "TUMBLE, to roll head over heels [v]\n",
  "TUMBLEDOWN": "dilapidated [adj]\n",
  "TUMBLEHOME": "the inward curvature of the upper parts of the sides of a vessel at or near the stern [n -S]\n",
  "TUMBLEHOMES": "TUMBLEHOME, the inward curvature of the upper parts of the sides of a vessel at or near the stern [n]\n",
  "TUMBLER": "a drinking-glass [n -S]\n",
  "TUMBLERFUL": "as much as a tumbler will hold [n TUMBLERFULS or TUMBLERSFUL]\n",
  "TUMBLERFULS": "TUMBLERFUL, as much as a tumbler will hold [n]\n",
  "TUMBLERS": "TUMBLER, a drinking-glass [n]\n",
  "TUMBLERSFUL": "TUMBLERFUL, as much as a tumbler will hold [n]\n",
  "TUMBLES": "TUMBLE, to roll head over heels [v]\n",
  "TUMBLESET": "a somersault [n -S]\n",
  "TUMBLESETS": "TUMBLESET, a somersault [n]\n",
  "TUMBLEWEED": "a type of plant that snaps off above the root, curls into a ball, and is blown about in the wind [n -S]\n",
  "TUMBLEWEEDS": "TUMBLEWEED, a type of plant that snaps off above the root, curls into a ball, and is blown about in the wind [n]\n",
  "TUMBLING": "the sport of gymnastics [n -S]\n",
  "TUMBLINGS": "TUMBLING, the sport of gymnastics [n]\n",
  "TUMBREL": "a type of cart, also TUMBRIL [n -S]\n",
  "TUMBRELS": "TUMBREL, a type of cart, also TUMBRIL [n]\n",
  "TUMBRIL": "a type of cart, also TUMBREL [n -S]\n",
  "TUMBRILS": "TUMBRIL, a type of cart, also TUMBREL [n]\n",
  "TUMEFACIENT": "causing swelling [adj]\n",
  "TUMEFACTION": "swelling [n -S]\n",
  "TUMEFACTIONS": "TUMEFACTION, swelling [n]\n",
  "TUMEFIED": "TUMEFY, to swell [v]\n",
  "TUMEFIES": "TUMEFY, to swell [v]\n",
  "TUMEFY": "to swell [v TUMEFIED, TUMEFYING, TUMEFIES]\n",
  "TUMEFYING": "TUMEFY, to swell [v]\n",
  "TUMESCE": "to swell [v TUMESCED, TUMESCING, TUMESCES]\n",
  "TUMESCED": "TUMESCE, to swell [v]\n",
  "TUMESCENCE": "swelling [n -S]\n",
  "TUMESCENCES": "TUMESCENCE, swelling [n]\n",
  "TUMESCENT": "tending to swell [adj TUMESCENTLY]\n",
  "TUMESCENTLY": "TUMESCENT, tending to swell [adv]\n",
  "TUMESCES": "TUMESCE, to swell [v]\n",
  "TUMESCING": "TUMESCE, to swell [v]\n",
  "TUMID": "swollen [adj TUMIDLY]\n",
  "TUMIDITIES": "TUMIDITY, the state of being tumid, swollen [n]\n",
  "TUMIDITY": "the state of being tumid, swollen [n TUMIDITIES]\n",
  "TUMIDLY": "TUMID, swollen [adv]\n",
  "TUMIDNESS": "the state of being tumid, swollen [n -ES]\n",
  "TUMIDNESSES": "TUMIDNESS, the state of being tumid, swollen [n]\n",
  "TUMMIES": "TUMMY, (colloquial) the stomach, also TUM [n]\n",
  "TUMMLER": "(Yiddish) one, such as a social director or entertainer, who encourages guest or audience participation [n -S]\n",
  "TUMMLERS": "TUMMLER, (Yiddish) one, such as a social director or entertainer, who encourages guest or audience participation [n]\n",
  "TUMMY": "(colloquial) the stomach, also TUM [n TUMMIES]\n",
  "TUMOR": "(US) an abnormal swelling or enlargement, now esp. a new growth of cells in the body without inflammation, also TUMOUR [n -S]\n",
  "TUMORAL": "relating to a tumor [adj]\n",
  "TUMORGENIC": "producing tumors, also TUMORIGENIC [adj]\n",
  "TUMORGENICITIES": "TUMORGENICITY, the state of being tumorgenic, giving rise to tumors [n]\n",
  "TUMORGENICITY": "the state of being tumorgenic, giving rise to tumors [n TUMORGENICITIES]\n",
  "TUMORIGENESES": "TUMORIGENESIS, the causing or production of tumours [n]\n",
  "TUMORIGENESIS": "the causing or production of tumours [n TUMORIGENESES]\n",
  "TUMORIGENIC": "producing tumors, also TUMORGENIC [adj]\n",
  "TUMORIGENICITY": "the state of being tumorigenic [n]\n",
  "TUMORLIKE": "like a tumor [adj]\n",
  "TUMOROUS": "having the nature of a tumor [adj]\n",
  "TUMORS": "TUMOR, (US) an abnormal swelling or enlargement, now esp. a new growth of cells in the body without inflammation, also TUMOUR [n]\n",
  "TUMOUR": "an abnormal swelling or enlargement, now esp. a new growth of cells in the body without inflammation, also TUMOR [n -S]\n",
  "TUMOURS": "TUMOUR, an abnormal swelling or enlargement, now esp. a new growth of cells in the body without inflammation, also TUMOR [n]\n",
  "TUMP": "to drag [v -ED, -ING, -S]\n",
  "TUMPED": "TUMP, to drag [v]\n",
  "TUMPHIES": "TUMPHY, (Scots) a blockhead [n]\n",
  "TUMPHY": "(Scots) a blockhead [n TUMPHIES]\n",
  "TUMPIER": "TUMPY, hummocky [adj]\n",
  "TUMPIEST": "TUMPY, hummocky [adj]\n",
  "TUMPING": "TUMP, to drag [v]\n",
  "TUMPLINE": "a strap for supporting a load on the back [n -S]\n",
  "TUMPLINES": "TUMPLINE, a strap for supporting a load on the back [n]\n",
  "TUMPS": "TUMP, to drag [v]\n",
  "TUMPY": "hummocky [adj TUMPIER, TUMPIEST]\n",
  "TUMS": "TUM, (colloquial) the stomach, also TUMMY [n]\n",
  "TUMSHIE": "(Scots) a turnip [n -S]\n",
  "TUMSHIES": "TUMSHIE, (Scots) a turnip [n]\n",
  "TUMULAR": "of or like a tumulus, also TUMULARY [adj]\n",
  "TUMULARY": "of or like a tumulus, also TUMULAR [adj]\n",
  "TUMULI": "TUMULUS, (Latin) a mound over a grave [n]\n",
  "TUMULOSE": "full of mounds, also TUMULOUS [adj]\n",
  "TUMULOSITIES": "TUMULOSITY, the state of being tumulose, full of small hills or mounds [n]\n",
  "TUMULOSITY": "the state of being tumulose, full of small hills or mounds [n TUMULOSITIES]\n",
  "TUMULOUS": "full of mounds, also TUMULOSE [adj]\n",
  "TUMULT": "to make a great din and commotion [v -ED, -ING, -S]\n",
  "TUMULTED": "TUMULT, to make a great din and commotion [v]\n",
  "TUMULTING": "TUMULT, to make a great din and commotion [v]\n",
  "TUMULTS": "TUMULT, to make a great din and commotion [v]\n",
  "TUMULTUARY": "chaotic; haphazard [adj]\n",
  "TUMULTUATE": "(archaic) to make a tumult [v TUMULTUATED, TUMULTUATING, TUMULTUATES]\n",
  "TUMULTUATED": "TUMULTUATE, (archaic) to make a tumult [v]\n",
  "TUMULTUATES": "TUMULTUATE, (archaic) to make a tumult [v]\n",
  "TUMULTUATING": "TUMULTUATE, (archaic) to make a tumult [v]\n",
  "TUMULTUATION": "(archaic) a tumult [n -S]\n",
  "TUMULTUATIONS": "TUMULTUATION, (archaic) a tumult [n]\n",
  "TUMULTUOUS": "full of tumult [adj TUMULTUOUSLY]\n",
  "TUMULTUOUSLY": "TUMULTUOUS, full of tumult [adv]\n",
  "TUMULTUOUSNESS": "the state of being tumultuous [n]\n",
  "TUMULUS": "(Latin) a mound over a grave [n TUMULUSES or TUMULI]\n",
  "TUMULUSES": "TUMULUS, (Latin) a mound over a grave [n]\n",
  "TUN": "to store in a large cask [v TUNNED, TUNNING, TUNS]\n",
  "TUNA": "a marine food fish [n -S]\n",
  "TUNABILITIES": "TUNABILITY, being able to be tuned [n]\n",
  "TUNABILITY": "being able to be tuned [n TUNABILITIES]\n",
  "TUNABLE": "capable of being tuned, also TUNEABLE [adj TUNABLY]\n",
  "TUNABLENESS": "the quality of being tunable [n -ES]\n",
  "TUNABLENESSES": "TUNABLENESS, the quality of being tunable [n]\n",
  "TUNABLY": "TUNABLE, capable of being tuned, also TUNEABLE [adv]\n",
  "TUNAS": "TUNA, a marine food fish [n]\n",
  "TUNBELLIED": "having a tunbelly, a potbelly [adj]\n",
  "TUNBELLIES": "TUNBELLY, a potbelly [n]\n",
  "TUNBELLY": "a potbelly [n TUNBELLIES]\n",
  "TUND": "(archaic) to beat, thump [v -ED, -ING, -S]\n",
  "TUNDED": "TUND, (archaic) to beat, thump [v]\n",
  "TUNDING": "TUND, (archaic) to beat, thump [v]\n",
  "TUNDISH": "(Shakespeare) a wooden funnel [n -ES]\n",
  "TUNDISHES": "TUNDISH, (Shakespeare) a wooden funnel [n]\n",
  "TUNDRA": "a level, treeless expanse of arctic land [n -S]\n",
  "TUNDRAS": "TUNDRA, a level, treeless expanse of arctic land [n]\n",
  "TUNDS": "TUND, (archaic) to beat, thump [v]\n",
  "TUNDUN": "(Native Australian) an Australian bullroarer, also TURNDUN [n -S]\n",
  "TUNDUNS": "TUNDUN, (Native Australian) an Australian bullroarer, also TURNDUN [n]\n",
  "TUNE": "to adjust to a proper pitch [v TUNED, TUNING, TUNES]\n",
  "TUNEABLE": "capable of being tuned, also TUNABLE [adj TUNEABLY]\n",
  "TUNEABLY": "TUNEABLE, capable of being tuned, also TUNABLE [adv]\n",
  "TUNEAGE": "(a piece of) recorded music that one likes [n -S]\n",
  "TUNEAGES": "TUNEAGE, (a piece of) recorded music that one likes [n]\n",
  "TUNED": "TUNE, to adjust to a proper pitch [v]\n",
  "TUNEFUL": "melodious [adj TUNEFULLY]\n",
  "TUNEFULLY": "TUNEFUL, melodious [adv]\n",
  "TUNEFULNESS": "the state of being tuneful [n -ES]\n",
  "TUNEFULNESSES": "TUNEFULNESS, the state of being tuneful [n]\n",
  "TUNELESS": "without a tune [adj TUNELESSLY]\n",
  "TUNELESSLY": "TUNELESS, without a tune [adv]\n",
  "TUNELESSNESS": "the state of being tuneless [n -ES]\n",
  "TUNELESSNESSES": "TUNELESSNESS, the state of being tuneless [n]\n",
  "TUNER": "one who tunes e.g. pianos [n -S]\n",
  "TUNERS": "TUNER, one who tunes e.g. pianos [n]\n",
  "TUNES": "TUNE, to adjust to a proper pitch [v]\n",
  "TUNESMITH": "a songwriter or composer of light music [n -S]\n",
  "TUNESMITHS": "TUNESMITH, a songwriter or composer of light music [n]\n",
  "TUNEUP": "an adjustment to insure efficient operation [n -S]\n",
  "TUNEUPS": "TUNEUP, an adjustment to insure efficient operation [n]\n",
  "TUNG": "(Chinese) a kind of Chinese tree [n -S]\n",
  "TUNGS": "TUNG, (Chinese) a kind of Chinese tree [n]\n",
  "TUNGSTATE": "a salt of tungstic acid [n -S]\n",
  "TUNGSTATES": "TUNGSTATE, a salt of tungstic acid [n]\n",
  "TUNGSTEN": "a metallic element [n -S]\n",
  "TUNGSTENS": "TUNGSTEN, a metallic element [n]\n",
  "TUNGSTIC": "of or pertaining to tungsten, as tungstic oxide [adj]\n",
  "TUNGSTITE": "a yellow earthy mineral, tungsten oxide [n -S]\n",
  "TUNGSTITES": "TUNGSTITE, a yellow earthy mineral, tungsten oxide [n]\n",
  "TUNGSTOUS": "containing tungsten in a low valence state [adj]\n",
  "TUNIC": "a loose-fitting shirt-like garment [n -S]\n",
  "TUNICA": "(Latin) an enclosing membrane or layer of tissue [n TUNICAE]\n",
  "TUNICAE": "TUNICA, (Latin) an enclosing membrane or layer of tissue [n]\n",
  "TUNICATE": "a small marine animal [n -S]\n",
  "TUNICATED": "having the form of a tunicate [adj]\n",
  "TUNICATES": "TUNICATE, a small marine animal [n]\n",
  "TUNICIN": "a gelatinous substance found in the tests of tunicates [n -S]\n",
  "TUNICINS": "TUNICIN, a gelatinous substance found in the tests of tunicates [n]\n",
  "TUNICKED": "wearing a tunic [adj]\n",
  "TUNICLE": "a short ecclesiastical vestment worn by a bishop or subdeacon [n -S]\n",
  "TUNICLES": "TUNICLE, a short ecclesiastical vestment worn by a bishop or subdeacon [n]\n",
  "TUNICS": "TUNIC, a loose-fitting shirt-like garment [n]\n",
  "TUNIER": "TUNY, tuneful, esp. in a superficial way [adj]\n",
  "TUNIEST": "TUNY, tuneful, esp. in a superficial way [adj]\n",
  "TUNING": "the way in which a musical instrument is tuned [n -S]\n",
  "TUNINGS": "TUNING, the way in which a musical instrument is tuned [n]\n",
  "TUNKET": "hell, used as an interjection (probably a euphemism for Tophet) [n -S]\n",
  "TUNKETS": "TUNKET, hell, used as an interjection (probably a euphemism for Tophet) [n]\n",
  "TUNNAGE": "a tax of so much a tun on imported wines [n -S]\n",
  "TUNNAGES": "TUNNAGE, a tax of so much a tun on imported wines [n]\n",
  "TUNNED": "TUN, to store in a large cask [v]\n",
  "TUNNEL": "an underground passageway [n -S] / to dig a tunnel [v TUNNELED or TUNNELLED, TUNNELING or TUNNELLING, TUNNELS]\n",
  "TUNNELED": "TUNNEL, to dig a tunnel [v]\n",
  "TUNNELER": "one who tunnels, also TUNNELLER [n -S]\n",
  "TUNNELERS": "TUNNELER, one who tunnels, also TUNNELLER [n]\n",
  "TUNNELING": "the act of making a tunnel [n -S]\n",
  "TUNNELINGS": "TUNNELING, the act of making a tunnel [n]\n",
  "TUNNELLED": "TUNNEL, to dig a tunnel [v]\n",
  "TUNNELLER": "one who tunnels, also TUNNELER [n -S]\n",
  "TUNNELLERS": "TUNNELLER, one who tunnels, also TUNNELER [n]\n",
  "TUNNELLIKE": "like a tunnel [adj]\n",
  "TUNNELLING": "the act of tunnelling [n -S]\n",
  "TUNNELLINGS": "TUNNELLING, the act of tunnelling [n]\n",
  "TUNNELS": "TUNNEL, to dig a tunnel [v]\n",
  "TUNNIES": "TUNNY, a tuna fish [n]\n",
  "TUNNING": "the act of tunning [n -S]\n",
  "TUNNINGS": "TUNNING, the act of tunning [n]\n",
  "TUNNY": "a tuna fish [n TUNNIES]\n",
  "TUNS": "TUN, to store in a large cask [v]\n",
  "TUNY": "tuneful, esp. in a superficial way [adj TUNIER, TUNIEST]\n",
  "TUP": "to copulate with a ewe [v TUPPED, TUPPING, TUPS]\n",
  "TUPEK": "(Inuit) an Inuit animal-skin tent, also TOPEK, TUPIK [n -S]\n",
  "TUPEKS": "TUPEK, (Inuit) an Inuit animal-skin tent, also TOPEK, TUPIK [n]\n",
  "TUPELO": "(Native American) a North American tree of the dogwood family, having brilliant, glossy foliage and acid red berries [n -S]\n",
  "TUPELOS": "TUPELO, (Native American) a North American tree of the dogwood family, having brilliant, glossy foliage and acid red berries [n]\n",
  "TUPIK": "(Inuit) an Inuit animal-skin tent, also TOPEK, TUPEK [n -S]\n",
  "TUPIKS": "TUPIK, (Inuit) an Inuit animal-skin tent, also TOPEK, TUPEK [n]\n",
  "TUPLE": "in computing, a row of values in a relational database [n -S]\n",
  "TUPLES": "TUPLE, in computing, a row of values in a relational database [n]\n",
  "TUPPED": "TUP, to copulate with a ewe [v]\n",
  "TUPPENCE": "a coin worth two pence, also TWOPENCE [n -S]\n",
  "TUPPENCES": "TUPPENCE, a coin worth two pence, also TWOPENCE [n]\n",
  "TUPPENNIES": "TUPPENNY, two pennies, also TWOPENNY [n]\n",
  "TUPPENNY": "two pennies, also TWOPENNY [n TUPPENNIES]\n",
  "TUPPING": "copulation of ram with ewe [n -S]\n",
  "TUPPINGS": "TUPPING, copulation of ram with ewe [n]\n",
  "TUPS": "TUP, to copulate with a ewe [v]\n",
  "TUPTOWING": "working at Greek conjugation [n -S]\n",
  "TUPTOWINGS": "TUPTOWING, working at Greek conjugation [n]\n",
  "TUPUNA": "(Maori) an ancestor, also TIPUNA [n -S]\n",
  "TUPUNAS": "TUPUNA, (Maori) an ancestor, also TIPUNA [n]\n",
  "TUQUE": "(Canadian) a knitted, cylindrical woollen cap with tapered ends that is worn with one end tucked into the other [n -S]\n",
  "TUQUES": "TUQUE, (Canadian) a knitted, cylindrical woollen cap with tapered ends that is worn with one end tucked into the other [n]\n",
  "TURACIN": "a red or crimson pigment obtained from certain feathers of several species of turacou [n -S]\n",
  "TURACINS": "TURACIN, a red or crimson pigment obtained from certain feathers of several species of turacou [n]\n",
  "TURACO": "an African bird, also TOURACO, TURACOU [n -S]\n",
  "TURACOS": "TURACO, an African bird, also TOURACO, TURACOU [n]\n",
  "TURACOU": "an African bird, also TOURACO, TURACO [n -S]\n",
  "TURACOUS": "TURACOU, an African bird, also TOURACO, TURACO [n]\n",
  "TURACOVERDIN": "an iron-based pigment in turaco feathers, the only pure green pigment found in birds [n -S]\n",
  "TURACOVERDINS": "TURACOVERDIN, an iron-based pigment in turaco feathers, the only pure green pigment found in birds [n]\n",
  "TURANGAWAEWAE": "(Maori) the area that is a person's home [n -S]\n",
  "TURANGAWAEWAES": "TURANGAWAEWAE, (Maori) the area that is a person's home [n]\n",
  "TURBAN": "(Turkish) a man's headdress, consisting of a length of cotton or silk wrapped round the head or a cap, worn esp. by Muslims and Sikhs, also TULBAN, TULIPANT, TURBAND, TURBANT, TURBOND, TURRIBANT [n -S]\n",
  "TURBAND": "(Shakespeare) a turban [n -S]\n",
  "TURBANDS": "TURBAND, (Shakespeare) a turban [n]\n",
  "TURBANED": "wearing a turban, also TURBANNED [adj]\n",
  "TURBANNED": "wearing a turban, also TURBANED [adj]\n",
  "TURBANS": "TURBAN, (Turkish) a man's headdress, consisting of a length of cotton or silk wrapped round the head or a cap, worn esp. by Muslims and Sikhs, also TULBAN, TULIPANT, TURBAND, TURBANT, TURBOND, TURRIBANT [n]\n",
  "TURBANT": "(Milton) a turban [n -S]\n",
  "TURBANTS": "TURBANT, (Milton) a turban [n]\n",
  "TURBARIES": "TURBARY, a place where peat can be dug [n]\n",
  "TURBARY": "a place where peat can be dug [n TURBARIES]\n",
  "TURBELLARIAN": "a kind of flatworm [n -S]\n",
  "TURBELLARIANS": "TURBELLARIAN, a kind of flatworm [n]\n",
  "TURBETH": "a medicinal plant root, also TURPETH, TURBITH [n -S]\n",
  "TURBETHS": "TURBETH, a medicinal plant root, also TURPETH, TURBITH [n]\n",
  "TURBID": "thick or opaque with/as if with sediment [adj]\n",
  "TURBIDIMETER": "an instrument for measuring the turbidity of liquids [n -S]\n",
  "TURBIDIMETERS": "TURBIDIMETER, an instrument for measuring the turbidity of liquids [n]\n",
  "TURBIDIMETRIC": "relating to measurement by turbidimeter, an instrument for measuring the turbidity of liquids [adj]\n",
  "TURBIDIMETRIES": "TURBIDIMETRY, measurement by turbidimeter, an instrument for measuring the turbidity of liquids [n]\n",
  "TURBIDIMETRY": "measurement by turbidimeter, an instrument for measuring the turbidity of liquids [n TURBIDIMETRIES]\n",
  "TURBIDITE": "the sediment deposited by a turbidity current [n -S]\n",
  "TURBIDITES": "TURBIDITE, the sediment deposited by a turbidity current [n]\n",
  "TURBIDITIES": "TURBIDITY, muddiness [n]\n",
  "TURBIDITY": "muddiness [n TURBIDITIES]\n",
  "TURBIDLY": "TURBID, thick or opaque with/as if with sediment [adv]\n",
  "TURBIDNESS": "the state of being turbid [n -ES]\n",
  "TURBIDNESSES": "TURBIDNESS, the state of being turbid [n]\n",
  "TURBINACIOUS": "(Scott) of the smell of whiskey, peaty [adj]\n",
  "TURBINAL": "scroll-like, also TURBINATE, TURBINATED [adj] / a scroll-like bone of the nose, also TURBINATE [n -S]\n",
  "TURBINALS": "TURBINAL, a scroll-like bone of the nose, also TURBINATE [n]\n",
  "TURBINATE": "scroll-like, also TURBINAL [adj] / a scroll-like bone of the nose [n -S]\n",
  "TURBINATED": "scroll-like, also TURBINATE [adj]\n",
  "TURBINATES": "TURBINATE, a scroll-like bone of the nose [n]\n",
  "TURBINATION": "being shaped like a turbinate, a scroll [n -S]\n",
  "TURBINATIONS": "TURBINATION, being shaped like a turbinate, a scroll [n]\n",
  "TURBINE": "a type of engine, also TURBO [n -S]\n",
  "TURBINED": "driven by a turbine [adj]\n",
  "TURBINES": "TURBINE, a type of engine, also TURBO [n]\n",
  "TURBIT": "a kind of domestic pigeon [n -S]\n",
  "TURBITH": "a medicinal plant root, also TURPETH, TURBETH [n -S]\n",
  "TURBITHS": "TURBITH, a medicinal plant root, also TURPETH, TURBETH [n]\n",
  "TURBITS": "TURBIT, a kind of domestic pigeon [n]\n",
  "TURBO": "(Latin) a type of engine, also TURBINE [n -S]\n",
  "TURBOCAR": "a car powered by a gas turbine [n -S]\n",
  "TURBOCARS": "TURBOCAR, a car powered by a gas turbine [n]\n",
  "TURBOCHARGED": "equipped with a turbocharger [adj]\n",
  "TURBOCHARGER": "a centrifugal blower driven by exhaust gas turbines and used to supercharge an engine [n -S]\n",
  "TURBOCHARGERS": "TURBOCHARGER, a centrifugal blower driven by exhaust gas turbines and used to supercharge an engine [n]\n",
  "TURBOCHARGING": "the act of fitting with a turbocharger [n -S]\n",
  "TURBOCHARGINGS": "TURBOCHARGING, the act of fitting with a turbocharger [n]\n",
  "TURBOELECTRIC": "using or being a turbine generator that produces electricity usually for motive power [adj]\n",
  "TURBOFAN": "a type of jet engine [n -S]\n",
  "TURBOFANS": "TURBOFAN, a type of jet engine [n]\n",
  "TURBOGENERATOR": "an electric generator driven by a turbine [n -S]\n",
  "TURBOGENERATORS": "TURBOGENERATOR, an electric generator driven by a turbine [n]\n",
  "TURBOJET": "a type of jet engine [n -S]\n",
  "TURBOJETS": "TURBOJET, a type of jet engine [n]\n",
  "TURBOMACHINERY": "machinery consisting of, incorporating, or constituting a turbine [n]\n",
  "TURBOND": "(Shakespeare) a turban [n -S]\n",
  "TURBONDS": "TURBOND, (Shakespeare) a turban [n]\n",
  "TURBOPROP": "a jet engine in which the turbine is coupled to a propeller [n -S]\n",
  "TURBOPROPS": "TURBOPROP, a jet engine in which the turbine is coupled to a propeller [n]\n",
  "TURBOS": "TURBO, (Latin) a type of engine, also TURBINE [n]\n",
  "TURBOSHAFT": "a kind of gas turbine engine [n -S]\n",
  "TURBOSHAFTS": "TURBOSHAFT, a kind of gas turbine engine [n]\n",
  "TURBOT": "a large flatfish with bony tubercles [n -S]\n",
  "TURBOTS": "TURBOT, a large flatfish with bony tubercles [n]\n",
  "TURBULATOR": "a device which creates turbulence [n -S]\n",
  "TURBULATORS": "TURBULATOR, a device which creates turbulence [n]\n",
  "TURBULENCE": "the state of being turbulent, also TURBULENCY [n -S]\n",
  "TURBULENCES": "TURBULENCE, the state of being turbulent, also TURBULENCY [n]\n",
  "TURBULENCIES": "TURBULENCY, the state of being turbulent, also TURBULENCE [n]\n",
  "TURBULENCY": "the state of being turbulent, also TURBULENCE [n TURBULENCIES]\n",
  "TURBULENT": "tumultuous, violently disturbed [adj TURBULENTLY]\n",
  "TURBULENTLY": "TURBULENT, tumultuous, violently disturbed [adv]\n",
  "TURCOPOLE": "(Modern Greek) a light-armed soldier of the Knights of St John of Jerusalem [n -S]\n",
  "TURCOPOLES": "TURCOPOLE, (Modern Greek) a light-armed soldier of the Knights of St John of Jerusalem [n]\n",
  "TURCOPOLIER": "a turcopole commander, always an Englishman [n -S]\n",
  "TURCOPOLIERS": "TURCOPOLIER, a turcopole commander, always an Englishman [n]\n",
  "TURD": "(vulgar) a piece of dung [n -S]\n",
  "TURDINE": "belonging to a family of singing birds [adj]\n",
  "TURDION": "(French) a Renaissance dance similar to but slower than a galliard, also TORDION [n -S]\n",
  "TURDIONS": "TURDION, (French) a Renaissance dance similar to but slower than a galliard, also TORDION [n]\n",
  "TURDOID": "thrush-like [adj]\n",
  "TURDS": "TURD, (vulgar) a piece of dung [n]\n",
  "TURDUCKEN": "a dish consisting of a partially deboned turkey stuffed with a deboned duck, which itself is stuffed with a small deboned chicken [n -S]\n",
  "TURDUCKENS": "TURDUCKEN, a dish consisting of a partially deboned turkey stuffed with a deboned duck, which itself is stuffed with a small deboned chicken [n]\n",
  "TUREEN": "a large vessel for holding e.g. soup, also TERREEN [n -S]\n",
  "TUREENS": "TUREEN, a large vessel for holding e.g. soup, also TERREEN [n]\n",
  "TURF": "a surface layer of earth containing a dense growth of grass and its roots, also TERF, TERFE [n TURVES] / to cover with turf [v -ED, -ING, -S]\n",
  "TURFED": "TURF, to cover with turf [v]\n",
  "TURFEN": "(archaic) made of turf [adj]\n",
  "TURFGRASS": "grass grown for lawns [n -ES]\n",
  "TURFGRASSES": "TURFGRASS, grass grown for lawns [n]\n",
  "TURFIER": "TURFY, covered with turf [adj]\n",
  "TURFIEST": "TURFY, covered with turf [adj]\n",
  "TURFINESS": "the state of being turfy [n -ES]\n",
  "TURFINESSES": "TURFINESS, the state of being turfy [n]\n",
  "TURFING": "the act of turfing [n -S]\n",
  "TURFINGS": "TURFING, the act of turfing [n]\n",
  "TURFITE": "a devotee of horse racing [n -S]\n",
  "TURFITES": "TURFITE, a devotee of horse racing [n]\n",
  "TURFLESS": "having no turf [adj]\n",
  "TURFLIKE": "like turf [adj]\n",
  "TURFMAN": "a person who is devoted to horse racing [n TURFMEN]\n",
  "TURFMEN": "TURFMAN, a person who is devoted to horse racing [n]\n",
  "TURFS": "TURF, to cover with turf [v]\n",
  "TURFSKI": "a type of ski [n -S]\n",
  "TURFSKIING": "skiing using turfskis [n -S]\n",
  "TURFSKIINGS": "TURFSKIING, skiing using turfskis [n]\n",
  "TURFSKIS": "TURFSKI, a type of ski [n]\n",
  "TURFY": "covered with turf [adj TURFIER, TURFIEST]\n",
  "TURGENCIES": "TURGENCY, the state of being turgid, also TURGOR [n]\n",
  "TURGENCY": "the state of being turgid, also TURGOR [n TURGENCIES]\n",
  "TURGENT": "(obsolete) turgid [adj TURGENTLY]\n",
  "TURGENTLY": "TURGENT, (obsolete) turgid [adv]\n",
  "TURGESCENCE": "the act or process of swelling, also TURGESCENCY [n -S]\n",
  "TURGESCENCES": "TURGESCENCE, the act or process of swelling, also TURGESCENCY [n]\n",
  "TURGESCENCIES": "TURGESCENCY, the act or process of swelling, also TURGESCENCE [n]\n",
  "TURGESCENCY": "the act or process of swelling, also TURGESCENCE [n TURGESCENCIES]\n",
  "TURGESCENT": "becoming turgid or inflated [adj]\n",
  "TURGID": "swollen, inflated, also TURGENT [adj TURGIDER, TURGIDEST, TURGIDLY]\n",
  "TURGIDER": "TURGID, swollen, inflated, also TURGENT [adj]\n",
  "TURGIDEST": "TURGID, swollen, inflated, also TURGENT [adj]\n",
  "TURGIDITIES": "TURGIDITY, the state of being turgid [n]\n",
  "TURGIDITY": "the state of being turgid [n TURGIDITIES]\n",
  "TURGIDLY": "TURGID, swollen, inflated, also TURGENT [adv]\n",
  "TURGIDNESS": "the state of being turgid [n -ES]\n",
  "TURGIDNESSES": "TURGIDNESS, the state of being turgid [n]\n",
  "TURGITE": "an iron ore [n -S]\n",
  "TURGITES": "TURGITE, an iron ore [n]\n",
  "TURGOR": "(Latin) the state of being turgid, also TURGENCY [n -S]\n",
  "TURGORS": "TURGOR, (Latin) the state of being turgid, also TURGENCY [n]\n",
  "TURION": "(French) an underground bud, growing up into a new stem [n -S]\n",
  "TURIONS": "TURION, (French) an underground bud, growing up into a new stem [n]\n",
  "TURISTA": "(Spanish) intestinal sickness affecting a tourist in a foreign country, also TOURISTA [n -S]\n",
  "TURISTAS": "TURISTA, (Spanish) intestinal sickness affecting a tourist in a foreign country, also TOURISTA [n]\n",
  "TURK": "a young dynamic person [n -S]\n",
  "TURKEY": "a large American bird [n -S]\n",
  "TURKEYS": "TURKEY, a large American bird [n]\n",
  "TURKIES": "(Shakespeare) turquoise [n -ES]\n",
  "TURKIESES": "TURKIES, (Shakespeare) turquoise [n]\n",
  "TURKIS": "(Milton) turquoise [n -ES]\n",
  "TURKISES": "TURKIS, (Milton) turquoise [n]\n",
  "TURKOIS": "(archaic) turquoise [n -ES]\n",
  "TURKOISES": "TURKOIS, (archaic) turquoise [n]\n",
  "TURKS": "TURK, a young dynamic person [n]\n",
  "TURLOUGH": "(Irish) a pond that dries up in summer [n -S]\n",
  "TURLOUGHS": "TURLOUGH, (Irish) a pond that dries up in summer [n]\n",
  "TURM": "a troop, also TURME [n -S]\n",
  "TURME": "a troop, also TURM [n -S]\n",
  "TURMERIC": "a spice used in Indian cooking [n -S]\n",
  "TURMERICS": "TURMERIC, a spice used in Indian cooking [n]\n",
  "TURMES": "TURME, a troop, also TURM [n]\n",
  "TURMOIL": "to cause a commotion [v -ED, -ING, -S]\n",
  "TURMOILED": "TURMOIL, to cause a commotion [v]\n",
  "TURMOILING": "TURMOIL, to cause a commotion [v]\n",
  "TURMOILS": "TURMOIL, to cause a commotion [v]\n",
  "TURMS": "TURM, a troop, also TURME [n]\n",
  "TURN": "to change direction, rotate [v -ED, -ING, -S]\n",
  "TURNABLE": "able to be turned [adj]\n",
  "TURNABOUT": "a change in fortunes [n -S]\n",
  "TURNABOUTS": "TURNABOUT, a change in fortunes [n]\n",
  "TURNAGAIN": "(archaic) a refrain [n -S]\n",
  "TURNAGAINS": "TURNAGAIN, (archaic) a refrain [n]\n",
  "TURNAROUND": "a change in fortunes [n -S]\n",
  "TURNAROUNDS": "TURNAROUND, a change in fortunes [n]\n",
  "TURNBACK": "a part of a garment etc. that can be turned back [n -S]\n",
  "TURNBACKS": "TURNBACK, a part of a garment etc. that can be turned back [n]\n",
  "TURNBROACH": "a turnspit [n -ES]\n",
  "TURNBROACHES": "TURNBROACH, a turnspit [n]\n",
  "TURNBUCKLE": "a coupling with screw threads for adjusting tension [n -S]\n",
  "TURNBUCKLES": "TURNBUCKLE, a coupling with screw threads for adjusting tension [n]\n",
  "TURNCOAT": "a traitor [n -S]\n",
  "TURNCOATS": "TURNCOAT, a traitor [n]\n",
  "TURNCOCK": "a valve for regulating water flow [n -S]\n",
  "TURNCOCKS": "TURNCOCK, a valve for regulating water flow [n]\n",
  "TURNDOWN": "a rejection [n -S]\n",
  "TURNDOWNS": "TURNDOWN, a rejection [n]\n",
  "TURNDUN": "(Native Australian) an Australian bullroarer, also TUNDUN [n -S]\n",
  "TURNDUNS": "TURNDUN, (Native Australian) an Australian bullroarer, also TUNDUN [n]\n",
  "TURNED": "TURN, to change direction, rotate [v]\n",
  "TURNER": "one who turns wood on a lathe [n -S]\n",
  "TURNERIES": "TURNERY, the shaping of articles on a lathe [n]\n",
  "TURNERS": "TURNER, one who turns wood on a lathe [n]\n",
  "TURNERY": "the shaping of articles on a lathe [n TURNERIES]\n",
  "TURNHALL": "a building where gymnasts practice [n -S]\n",
  "TURNHALLS": "TURNHALL, a building where gymnasts practice [n]\n",
  "TURNING": "a rotation about an axis [n -S]\n",
  "TURNINGS": "TURNING, a rotation about an axis [n]\n",
  "TURNIP": "to plant with an edible plant root [v -ED, -ING, -S]\n",
  "TURNIPED": "TURNIP, to plant with an edible plant root [v]\n",
  "TURNIPIER": "TURNIPY, like a turnip [adj]\n",
  "TURNIPIEST": "TURNIPY, like a turnip [adj]\n",
  "TURNIPING": "TURNIP, to plant with an edible plant root [v]\n",
  "TURNIPS": "TURNIP, to plant with an edible plant root [v]\n",
  "TURNIPY": "like a turnip [adj TURNIPIER, TURNIPIEST]\n",
  "TURNKEY": "a person who has charge of a prison's keys [n -S]\n",
  "TURNKEYS": "TURNKEY, a person who has charge of a prison's keys [n]\n",
  "TURNOFF": "a road that branches off a larger one [n -S]\n",
  "TURNOFFS": "TURNOFF, a road that branches off a larger one [n]\n",
  "TURNON": "something that arouses interest [n -S]\n",
  "TURNONS": "TURNON, something that arouses interest [n]\n",
  "TURNOUT": "an assemblage of people [n -S]\n",
  "TURNOUTS": "TURNOUT, an assemblage of people [n]\n",
  "TURNOVER": "a small pie made by folding over the crust [n -S]\n",
  "TURNOVERS": "TURNOVER, a small pie made by folding over the crust [n]\n",
  "TURNPIKE": "a toll gate on a motorway [n -S]\n",
  "TURNPIKES": "TURNPIKE, a toll gate on a motorway [n]\n",
  "TURNROUND": "a change in fortunes [n -S]\n",
  "TURNROUNDS": "TURNROUND, a change in fortunes [n]\n",
  "TURNS": "TURN, to change direction, rotate [v]\n",
  "TURNSKIN": "(archaic) a werewolf [n -S]\n",
  "TURNSKINS": "TURNSKIN, (archaic) a werewolf [n]\n",
  "TURNSOLE": "heliotrope; so named because its flowers are supposed to turn toward the sun [n -S]\n",
  "TURNSOLES": "TURNSOLE, heliotrope; so named because its flowers are supposed to turn toward the sun [n]\n",
  "TURNSPIT": "a person who turns a roasting spit [n -S]\n",
  "TURNSPITS": "TURNSPIT, a person who turns a roasting spit [n]\n",
  "TURNSTILE": "a revolving frame that allows one person to pass at a time [n -S]\n",
  "TURNSTILES": "TURNSTILE, a revolving frame that allows one person to pass at a time [n]\n",
  "TURNSTONE": "any of various species of limicoline birds, allied to the plovers [n -S]\n",
  "TURNSTONES": "TURNSTONE, any of various species of limicoline birds, allied to the plovers [n]\n",
  "TURNT": "(US slang) intoxicated, excited [adj]\n",
  "TURNTABLE": "a rotating table, platform, disc or pair of rings [n -S]\n",
  "TURNTABLES": "TURNTABLE, a rotating table, platform, disc or pair of rings [n]\n",
  "TURNTABLIST": "a DJ who is skilled in using turntables to obtain distinctive effects from records [n -S]\n",
  "TURNTABLISTS": "TURNTABLIST, a DJ who is skilled in using turntables to obtain distinctive effects from records [n]\n",
  "TURNUP": "a part of a garment that is turned up [n -S]\n",
  "TURNUPS": "TURNUP, a part of a garment that is turned up [n]\n",
  "TURNVEREIN": "a club of turners or gymnasts [n -S]\n",
  "TURNVEREINS": "TURNVEREIN, a club of turners or gymnasts [n]\n",
  "TUROPHILE": "a connoisseur of cheese [n -S]\n",
  "TUROPHILES": "TUROPHILE, a connoisseur of cheese [n]\n",
  "TURPENTINE": "to treat or smear with turpentine, a viscous resin, originally that of the terebinth tree, now generally of conifers [v TURPENTINED, TURPENTINING, TURPENTINES]\n",
  "TURPENTINED": "TURPENTINE, to treat or smear with turpentine, a viscous resin, originally that of the terebinth tree, now generally of conifers [v]\n",
  "TURPENTINES": "TURPENTINE, to treat or smear with turpentine, a viscous resin, originally that of the terebinth tree, now generally of conifers [v]\n",
  "TURPENTINIER": "TURPENTINY, like turpentine [adj]\n",
  "TURPENTINIEST": "TURPENTINY, like turpentine [adj]\n",
  "TURPENTINING": "TURPENTINE, to treat or smear with turpentine, a viscous resin, originally that of the terebinth tree, now generally of conifers [v]\n",
  "TURPENTINY": "like turpentine [adj TURPENTINIER, TURPENTINIEST]\n",
  "TURPETH": "a medicinal plant root, also TURBETH, TURBITH [n -S]\n",
  "TURPETHS": "TURPETH, a medicinal plant root, also TURBETH, TURBITH [n]\n",
  "TURPITUDE": "inherent baseness, depravity [n -S]\n",
  "TURPITUDES": "TURPITUDE, inherent baseness, depravity [n]\n",
  "TURPS": "(short for) turpentine [n TURPS]\n",
  "TURQUOIS": "a hydrous phosphate of alumina containing a little copper, having a blue, or bluish green, color, also TURKIES, TURKIS, TURKOIS, TURQUOISE [n -ES]\n",
  "TURQUOISE": "a hydrous phosphate of alumina containing a little copper, having a blue, or bluish green, color, also TURKIES, TURKIS, TURKOIS, TURQUOIS [n -S]\n",
  "TURQUOISES": "TURQUOIS, a hydrous phosphate of alumina containing a little copper, having a blue, or bluish green, color, also TURKIES, TURKIS, TURKOIS, TURQUOISE [n]\n",
  "TURR": "(Canadian) a Newfoundland name for the guillemot [n -S]\n",
  "TURRET": "a small tower [n -S]\n",
  "TURRETED": "having a turret [adj]\n",
  "TURRETS": "TURRET, a small tower [n]\n",
  "TURRIBANT": "(Spenser) a turban [n -S]\n",
  "TURRIBANTS": "TURRIBANT, (Spenser) a turban [n]\n",
  "TURRICAL": "like a turret [adj]\n",
  "TURRICULATE": "turreted; formed in a long spiral, also TURRICULATED [adj]\n",
  "TURRICULATED": "turreted; formed in a long spiral, also TURRICULATE [adj]\n",
  "TURRS": "TURR, (Canadian) a Newfoundland name for the guillemot [n]\n",
  "TURTLE": "any of various aquatic chelonian reptiles [n -S] / to hunt or catch turtles [v TURTLED, TURTLING, TURTLES]\n",
  "TURTLEBACK": "a structure over a ship's bows or stern [n -S]\n",
  "TURTLEBACKS": "TURTLEBACK, a structure over a ship's bows or stern [n]\n",
  "TURTLED": "TURTLE, to hunt or catch turtles [v]\n",
  "TURTLEDOVE": "a bird of the dove family [n -S]\n",
  "TURTLEDOVES": "TURTLEDOVE, a bird of the dove family [n]\n",
  "TURTLEHEAD": "an American perennial herb with white flowers shaped like the head of a turtle [n -S]\n",
  "TURTLEHEADS": "TURTLEHEAD, an American perennial herb with white flowers shaped like the head of a turtle [n]\n",
  "TURTLENECK": "a style of neck for a sweater [n -S]\n",
  "TURTLENECKED": "having a turtleneck [adj]\n",
  "TURTLENECKS": "TURTLENECK, a style of neck for a sweater [n]\n",
  "TURTLER": "one who catches turtles or tortoises [n -S]\n",
  "TURTLERS": "TURTLER, one who catches turtles or tortoises [n]\n",
  "TURTLES": "TURTLE, to hunt or catch turtles [v]\n",
  "TURTLING": "the hunting of turtles [n -S]\n",
  "TURTLINGS": "TURTLING, the hunting of turtles [n]\n",
  "TURVES": "TURF, a surface layer of earth containing a dense growth of grass and its roots, also TERF, TERFE [n]\n",
  "TUSCHE": "(German) a black substance used for drawing in lithography and as a resist in etching and silkscreen work [n -S]\n",
  "TUSCHES": "TUSCHE, (German) a black substance used for drawing in lithography and as a resist in etching and silkscreen work [n]\n",
  "TUSH": "to gore with a long, pointed prominent tooth, also TUSK [v -ED, -ING, -ES]\n",
  "TUSHED": "TUSH, to gore with a long, pointed prominent tooth, also TUSK [v]\n",
  "TUSHERIES": "TUSHERY, a style of period novel [n]\n",
  "TUSHERY": "a style of period novel [n TUSHERIES]\n",
  "TUSHES": "TUSH, to gore with a long, pointed prominent tooth, also TUSK [v]\n",
  "TUSHIE": "(Yiddish) the bottom, the buttocks, also TUCHIS, TUCHUS, TUSH, TUSHY [n -S]\n",
  "TUSHIES": "TUSHY, (Yiddish) the bottom, the buttocks, also TUCHIS, TUCHUS, TUSH, TUSHIE [n]\n",
  "TUSHING": "TUSH, to gore with a long, pointed prominent tooth, also TUSK [v]\n",
  "TUSHKAR": "(Old Norse) a turf-spade, also TUSHKER, TUSKAR, TUSKER, TWISCAR [n -S]\n",
  "TUSHKARS": "TUSHKAR, (Old Norse) a turf-spade, also TUSHKER, TUSKAR, TUSKER, TWISCAR [n]\n",
  "TUSHKER": "(Old Norse) a turf-spade, also TUSHKAR, TUSKAR, TUSKER, TWISCAR [n -S]\n",
  "TUSHKERS": "TUSHKER, (Old Norse) a turf-spade, also TUSHKAR, TUSKAR, TUSKER, TWISCAR [n]\n",
  "TUSHY": "(Yiddish) the bottom, the buttocks, also TUCHIS, TUCHUS, TUSH, TUSHIE [n TUSHIES]\n",
  "TUSK": "to gore with a long, pointed prominent tooth, also TUSH [v -ED, -ING, -S]\n",
  "TUSKAR": "(Old Norse) a turf-spade, also TUSHKAR, TUSHKER, TUSKER, TWISCAR [n -S]\n",
  "TUSKARS": "TUSKAR, (Old Norse) a turf-spade, also TUSHKAR, TUSHKER, TUSKER, TWISCAR [n]\n",
  "TUSKED": "TUSK, to gore with a long, pointed prominent tooth, also TUSH [v]\n",
  "TUSKER": "(Old Norse) a turf-spade, also TUSHKAR, TUSHKER, TUSKAR, TWISCAR [n -S]\n",
  "TUSKERS": "TUSKER, (Old Norse) a turf-spade, also TUSHKAR, TUSHKER, TUSKAR, TWISCAR [n]\n",
  "TUSKIER": "TUSKY, having prominent tusks [adj]\n",
  "TUSKIEST": "TUSKY, having prominent tusks [adj]\n",
  "TUSKING": "the act of piercing with tusks [n -S]\n",
  "TUSKINGS": "TUSKING, the act of piercing with tusks [n]\n",
  "TUSKLESS": "without tusks [adj]\n",
  "TUSKLIKE": "like a tusk [adj]\n",
  "TUSKS": "TUSK, to gore with a long, pointed prominent tooth, also TUSH [v]\n",
  "TUSKY": "having prominent tusks [adj TUSKIER, TUSKIEST]\n",
  "TUSSAC": "as in tussac grass, a kind of grass [adj]\n",
  "TUSSAH": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSORE, TUSSUR [n -S]\n",
  "TUSSAHS": "TUSSAH, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSORE, TUSSUR [n]\n",
  "TUSSAL": "relating to a cough, also TUSSIVE [adj]\n",
  "TUSSAR": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSEH, TUSSER, TUSSOR, TUSSORE, TUSSUR [n -S]\n",
  "TUSSARS": "TUSSAR, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSEH, TUSSER, TUSSOR, TUSSORE, TUSSUR [n]\n",
  "TUSSEH": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSER, TUSSOR, TUSSORE, TUSSUR [n -S]\n",
  "TUSSEHS": "TUSSEH, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSER, TUSSOR, TUSSORE, TUSSUR [n]\n",
  "TUSSER": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSOR, TUSSORE, TUSSUR [n -S]\n",
  "TUSSERS": "TUSSER, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSOR, TUSSORE, TUSSUR [n]\n",
  "TUSSES": "TUSSIS, (Latin) a cough [n]\n",
  "TUSSIS": "(Latin) a cough [n TUSSISES or TUSSES]\n",
  "TUSSISES": "TUSSIS, (Latin) a cough [n]\n",
  "TUSSIVE": "relating to a cough, also TUSSAL [adj]\n",
  "TUSSLE": "to struggle [v TUSSLED, TUSSLING, TUSSLES]\n",
  "TUSSLED": "TUSSLE, to struggle [v]\n",
  "TUSSLES": "TUSSLE, to struggle [v]\n",
  "TUSSLING": "TUSSLE, to struggle [v]\n",
  "TUSSOCK": "a clump of grass, also TUSSUCK [n -S]\n",
  "TUSSOCKED": "having tussocks [adj]\n",
  "TUSSOCKIER": "TUSSOCKY, full of tussocks [adj]\n",
  "TUSSOCKIEST": "TUSSOCKY, full of tussocks [adj]\n",
  "TUSSOCKS": "TUSSOCK, a clump of grass, also TUSSUCK [n]\n",
  "TUSSOCKY": "full of tussocks [adj TUSSOCKIER, TUSSOCKIEST]\n",
  "TUSSOR": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSORE, TUSSUR [n -S]\n",
  "TUSSORE": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSUR [n -S]\n",
  "TUSSORES": "TUSSORE, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSUR [n]\n",
  "TUSSORS": "TUSSOR, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSORE, TUSSUR [n]\n",
  "TUSSUCK": "a clump of grass, also TUSSOCK [n -S]\n",
  "TUSSUCKS": "TUSSUCK, a clump of grass, also TUSSOCK [n]\n",
  "TUSSUR": "(Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSORE [n -S]\n",
  "TUSSURS": "TUSSUR, (Hindi) a fawn-coloured silk made from wild Indian silkworms, also TASAR, TUSSAH, TUSSAR, TUSSEH, TUSSER, TUSSOR, TUSSORE [n]\n",
  "TUT": "to utter an exclamation of impatience [v TUTTED, TUTTING, TUTS]\n",
  "TUTANIA": "a type of Britannia metal [n -S]\n",
  "TUTANIAS": "TUTANIA, a type of Britannia metal [n]\n",
  "TUTEE": "one who is being tutored [n -S]\n",
  "TUTEES": "TUTEE, one who is being tutored [n]\n",
  "TUTELAGE": "the act of tutoring, also TUTORAGE [n -S]\n",
  "TUTELAGES": "TUTELAGE, the act of tutoring, also TUTORAGE [n]\n",
  "TUTELAR": "one who has the power to protect, also TUTELARY [n -S]\n",
  "TUTELARIES": "TUTELARY, one who has the power to protect, also TUTELAR [n]\n",
  "TUTELARS": "TUTELAR, one who has the power to protect, also TUTELARY [n]\n",
  "TUTELARY": "one who has the power to protect, also TUTELAR [n TUTELARIES]\n",
  "TUTENAG": "(Marathi) an alloy of zinc, copper etc. [n -S]\n",
  "TUTENAGS": "TUTENAG, (Marathi) an alloy of zinc, copper etc. [n]\n",
  "TUTIORISM": "the doctrine that one should take the safer moral course [n -S]\n",
  "TUTIORISMS": "TUTIORISM, the doctrine that one should take the safer moral course [n]\n",
  "TUTIORIST": "an adherent of tutiorism, the doctrine that one should take the safer moral course [n -S]\n",
  "TUTIORISTS": "TUTIORIST, an adherent of tutiorism, the doctrine that one should take the safer moral course [n]\n",
  "TUTMAN": "one who does piecework [n TUTMEN]\n",
  "TUTMEN": "TUTMAN, one who does piecework [n]\n",
  "TUTOR": "to instruct privately [v -ED, -ING, -S]\n",
  "TUTORAGE": "the act of tutoring, also TUTELAGE [n -S]\n",
  "TUTORAGES": "TUTORAGE, the act of tutoring, also TUTELAGE [n]\n",
  "TUTORED": "TUTOR, to instruct privately [v]\n",
  "TUTORESS": "(archaic) a female tutor, also TUTRESS, TUTRIX [n -ES]\n",
  "TUTORESSES": "TUTORESS, (archaic) a female tutor, also TUTRESS, TUTRIX [n]\n",
  "TUTORIAL": "relating to a tutor [adj TUTORIALLY] / a session with a tutor [n -S]\n",
  "TUTORIALLY": "TUTORIAL, relating to a tutor [adv]\n",
  "TUTORIALS": "TUTORIAL, a session with a tutor [n]\n",
  "TUTORING": "the act of tutoring [n -S]\n",
  "TUTORINGS": "TUTORING, the act of tutoring [n]\n",
  "TUTORISE": "to tutor, also TUTORIZE [v TUTORISED, TUTORISING, TUTORISES]\n",
  "TUTORISED": "TUTORISE, to tutor, also TUTORIZE [v]\n",
  "TUTORISES": "TUTORISE, to tutor, also TUTORIZE [v]\n",
  "TUTORISING": "TUTORISE, to tutor, also TUTORIZE [v]\n",
  "TUTORISM": "the act of tutoring [n -S]\n",
  "TUTORISMS": "TUTORISM, the act of tutoring [n]\n",
  "TUTORIZE": "to tutor, also TUTORISE [v TUTORIZED, TUTORIZING, TUTORIZES]\n",
  "TUTORIZED": "TUTORIZE, to tutor, also TUTORISE [v]\n",
  "TUTORIZES": "TUTORIZE, to tutor, also TUTORISE [v]\n",
  "TUTORIZING": "TUTORIZE, to tutor, also TUTORISE [v]\n",
  "TUTORS": "TUTOR, to instruct privately [v]\n",
  "TUTORSHIP": "the position of tutor [n -S]\n",
  "TUTORSHIPS": "TUTORSHIP, the position of tutor [n]\n",
  "TUTOYED": "TUTOYER, (French) to address familiarly [v]\n",
  "TUTOYER": "(French) to address familiarly [v TUTOYED or TUTOYERED, TUTOYERING, TUTOYERS]\n",
  "TUTOYERED": "TUTOYER, (French) to address familiarly [v]\n",
  "TUTOYERING": "TUTOYER, (French) to address familiarly [v]\n",
  "TUTOYERS": "TUTOYER, (French) to address familiarly [v]\n",
  "TUTRESS": "(archaic) a female tutor, also TUTORESS, TUTRIX [n -ES]\n",
  "TUTRESSES": "TUTRESS, (archaic) a female tutor, also TUTORESS, TUTRIX [n]\n",
  "TUTRICES": "TUTRIX, (obsolete) a female tutor, also TUTORESS, TUTRESS [n]\n",
  "TUTRIX": "(obsolete) a female tutor, also TUTORESS, TUTRESS [n TUTRICES or TUTRIXES]\n",
  "TUTRIXES": "TUTRIX, (obsolete) a female tutor, also TUTORESS, TUTRESS [n]\n",
  "TUTS": "(Scots) to say tut, also TUT [v -ED, -ING, -ES]\n",
  "TUTSAN": "any of several plants credited with healing properties [n -S]\n",
  "TUTSANS": "TUTSAN, any of several plants credited with healing properties [n]\n",
  "TUTSED": "TUTS, (Scots) to say tut, also TUT [v]\n",
  "TUTSES": "TUTS, (Scots) to say tut, also TUT [v]\n",
  "TUTSING": "TUTS, (Scots) to say tut, also TUT [v]\n",
  "TUTTED": "TUT, to utter an exclamation of impatience [v]\n",
  "TUTTI": "(Italian) a direction for all the singers or players to perform together [n -S]\n",
  "TUTTIES": "TUTTY, an impure zinc oxide [n]\n",
  "TUTTING": "the act of tutting [n -S]\n",
  "TUTTINGS": "TUTTING, the act of tutting [n]\n",
  "TUTTIS": "TUTTI, (Italian) a direction for all the singers or players to perform together [n]\n",
  "TUTTY": "an impure zinc oxide [n TUTTIES]\n",
  "TUTU": "(French) a ballerina's short stiff skirt [n -S]\n",
  "TUTUED": "wearing a tutu [adj]\n",
  "TUTUS": "TUTU, (French) a ballerina's short stiff skirt [n]\n",
  "TUTWORK": "piecework [n -S]\n",
  "TUTWORKER": "one who does tutwork, piecework [n -S]\n",
  "TUTWORKERS": "TUTWORKER, one who does tutwork, piecework [n]\n",
  "TUTWORKMAN": "one who does tutwork, piecework [n TUTWORKMEN]\n",
  "TUTWORKMEN": "TUTWORKMAN, one who does tutwork, piecework [n]\n",
  "TUTWORKS": "TUTWORK, piecework [n]\n",
  "TUX": "(short for) tuxedo, a dinner jacket [n -ES]\n",
  "TUXEDO": "a man's semiformal dinner coat [n -ES or -S]\n",
  "TUXEDOED": "dressed in a tuxedo [adj]\n",
  "TUXEDOES": "TUXEDO, a man's semiformal dinner coat [n]\n",
  "TUXEDOS": "TUXEDO, a man's semiformal dinner coat [n]\n",
  "TUXES": "TUX, (short for) tuxedo, a dinner jacket [n]\n",
  "TUYER": "a pipe through which air is forced into a blast furnace, also TUYERE, TWEER, TWIER, TWYER, TWYERE [n -S]\n",
  "TUYERE": "(French) a pipe through which air is forced into a blast furnace, also TUYER, TWEER, TWIER, TWYER, TWYERE [n -S]\n",
  "TUYERES": "TUYERE, (French) a pipe through which air is forced into a blast furnace, also TUYER, TWEER, TWIER, TWYER, TWYERE [n]\n",
  "TUYERS": "TUYER, a pipe through which air is forced into a blast furnace, also TUYERE, TWEER, TWIER, TWYER, TWYERE [n]\n",
  "TUZZ": "a tuft [n -ES]\n",
  "TUZZES": "TUZZ, a tuft [n]\n",
  "TWA": "(Scots) two, also TWAE, TWAY [n -S]\n",
  "TWADDLE": "to talk foolishly, also TWATTLE [v TWADDLED, TWADDLING, TWADDLES]\n",
  "TWADDLED": "TWADDLE, to talk foolishly, also TWATTLE [v]\n",
  "TWADDLER": "one who talks twaddle [n -S]\n",
  "TWADDLERS": "TWADDLER, one who talks twaddle [n]\n",
  "TWADDLES": "TWADDLE, to talk foolishly, also TWATTLE [v]\n",
  "TWADDLIER": "TWADDLY, boringly [adj]\n",
  "TWADDLIEST": "TWADDLY, boringly [adj]\n",
  "TWADDLING": "the act of twaddling [n -S]\n",
  "TWADDLINGS": "TWADDLING, the act of twaddling [n]\n",
  "TWADDLY": "boringly [adj TWADDLIER, TWADDLIEST]\n",
  "TWAE": "(Scots) two, also TWA, TWAY [n -S]\n",
  "TWAES": "TWAE, (Scots) two, also TWA, TWAY [n]\n",
  "TWAFALD": "(Scots) twofold [adj]\n",
  "TWAIN": "(archaic) a set of two [n -S]\n",
  "TWAINS": "TWAIN, (archaic) a set of two [n]\n",
  "TWAITE": "a fish, a kind of shad [n -S]\n",
  "TWAITES": "TWAITE, a fish, a kind of shad [n]\n",
  "TWAL": "(Scots) twelve [n -S]\n",
  "TWALPENNIES": "TWALPENNY, (Scots) an old shilling [n]\n",
  "TWALPENNY": "(Scots) an old shilling [n TWALPENNIES]\n",
  "TWALS": "TWAL, (Scots) twelve [n]\n",
  "TWANG": "to make a sharp, vibrating sound, also TWANGLE [v -ED, -ING, -S]\n",
  "TWANGED": "TWANG, to make a sharp, vibrating sound, also TWANGLE [v]\n",
  "TWANGER": "a person playing a stringed instrument [n -S]\n",
  "TWANGERS": "TWANGER, a person playing a stringed instrument [n]\n",
  "TWANGIER": "TWANGY, twanging [adj]\n",
  "TWANGIEST": "TWANGY, twanging [adj]\n",
  "TWANGING": "making a twanging sound [adj TWANGINGLY] / the act of twanging [n -S]\n",
  "TWANGINGLY": "TWANGING, making a twanging sound [adv]\n",
  "TWANGINGS": "TWANGING, the act of twanging [n]\n",
  "TWANGLE": "to make a sharp, vibrating sound, also TWANG [v TWANGLED, TWANGLING, TWANGLES]\n",
  "TWANGLED": "TWANGLE, to make a sharp, vibrating sound, also TWANG [v]\n",
  "TWANGLER": "one who twangles [n -S]\n",
  "TWANGLERS": "TWANGLER, one who twangles [n]\n",
  "TWANGLES": "TWANGLE, to make a sharp, vibrating sound, also TWANG [v]\n",
  "TWANGLING": "making a twangling sound [adj TWANGLINGLY] / the act of twangling [n -S]\n",
  "TWANGLINGLY": "TWANGLING, making a twangling sound [adv]\n",
  "TWANGLINGS": "TWANGLING, the act of twangling [n]\n",
  "TWANGS": "TWANG, to make a sharp, vibrating sound, also TWANGLE [v]\n",
  "TWANGY": "twanging [adj TWANGIER, TWANGIEST]\n",
  "TWANK": "to make a short twanging sound [v -ED, -ING, -S]\n",
  "TWANKAY": "(Chinese) a variety of green tea, also TWANKY [n -S]\n",
  "TWANKAYS": "TWANKAY, (Chinese) a variety of green tea, also TWANKY [n]\n",
  "TWANKED": "TWANK, to make a short twanging sound [v]\n",
  "TWANKIES": "TWANKY, (Chinese) a variety of green tea, also TWANKAY [n]\n",
  "TWANKING": "TWANK, to make a short twanging sound [v]\n",
  "TWANKS": "TWANK, to make a short twanging sound [v]\n",
  "TWANKY": "(Chinese) a variety of green tea, also TWANKAY [n TWANKIES]\n",
  "TWAS": "TWA, (Scots) two, also TWAE, TWAY [n]\n",
  "TWASOME": "(Scots) a twosome [n -S]\n",
  "TWASOMES": "TWASOME, (Scots) a twosome [n]\n",
  "TWAT": "(slang) to strike violently [v TWATTED, TWATTING, TWATS]\n",
  "TWATS": "TWAT, (slang) to strike violently [v]\n",
  "TWATTED": "TWAT, (slang) to strike violently [v]\n",
  "TWATTING": "TWAT, (slang) to strike violently [v]\n",
  "TWATTLE": "to talk foolishly, also TWADDLE [v TWATTLED, TWATTLING, TWATTLES]\n",
  "TWATTLED": "TWATTLE, to talk foolishly, also TWADDLE [v]\n",
  "TWATTLER": "one who twattles [n -S]\n",
  "TWATTLERS": "TWATTLER, one who twattles [n]\n",
  "TWATTLES": "TWATTLE, to talk foolishly, also TWADDLE [v]\n",
  "TWATTLING": "idle talk, prating [n -S]\n",
  "TWATTLINGS": "TWATTLING, idle talk, prating [n]\n",
  "TWAY": "(Scots) two, also TWA, TWAE [n -S]\n",
  "TWAYBLADE": "any one of several orchidaceous plants which have only two leaves [n -S]\n",
  "TWAYBLADES": "TWAYBLADE, any one of several orchidaceous plants which have only two leaves [n]\n",
  "TWAYS": "TWAY, (Scots) two, also TWA, TWAE [n]\n",
  "TWEAK": "to pinch and twist sharply [v -ED, -ING, -S]\n",
  "TWEAKED": "TWEAK, to pinch and twist sharply [v]\n",
  "TWEAKER": "a small screwdriver used for fine adjustments [n -S]\n",
  "TWEAKERS": "TWEAKER, a small screwdriver used for fine adjustments [n]\n",
  "TWEAKIER": "TWEAKY, twitchy [adj]\n",
  "TWEAKIEST": "TWEAKY, twitchy [adj]\n",
  "TWEAKING": "the act of tweaking [n -S]\n",
  "TWEAKINGS": "TWEAKING, the act of tweaking [n]\n",
  "TWEAKS": "TWEAK, to pinch and twist sharply [v]\n",
  "TWEAKY": "twitchy [adj TWEAKIER, TWEAKIEST]\n",
  "TWEE": "affectedly cute or quaint [adj TWEER, TWEEST, TWEELY]\n",
  "TWEED": "a coarse woollen fabric [n -S]\n",
  "TWEEDIER": "TWEEDY, of a refined, traditional, upscale character [adj]\n",
  "TWEEDIEST": "TWEEDY, of a refined, traditional, upscale character [adj]\n",
  "TWEEDILY": "TWEEDY, of a refined, traditional, upscale character [adv]\n",
  "TWEEDINESS": "the state of being tweedy [n -ES]\n",
  "TWEEDINESSES": "TWEEDINESS, the state of being tweedy [n]\n",
  "TWEEDLE": "to perform casually on a musical instrument [v TWEEDLED, TWEEDLING, TWEEDLES]\n",
  "TWEEDLED": "TWEEDLE, to perform casually on a musical instrument [v]\n",
  "TWEEDLEDEE": "(Scots) to tweedle on a fiddle [v TWEEDLEDEED, TWEEDLEDEEING, TWEEDLEDEES]\n",
  "TWEEDLEDEED": "TWEEDLEDEE, (Scots) to tweedle on a fiddle [v]\n",
  "TWEEDLEDEEING": "TWEEDLEDEE, (Scots) to tweedle on a fiddle [v]\n",
  "TWEEDLEDEES": "TWEEDLEDEE, (Scots) to tweedle on a fiddle [v]\n",
  "TWEEDLER": "one who tweedles [n -S]\n",
  "TWEEDLERS": "TWEEDLER, one who tweedles [n]\n",
  "TWEEDLES": "TWEEDLE, to perform casually on a musical instrument [v]\n",
  "TWEEDLING": "TWEEDLE, to perform casually on a musical instrument [v]\n",
  "TWEEDS": "TWEED, a coarse woollen fabric [n]\n",
  "TWEEDY": "of a refined, traditional, upscale character [adj TWEEDIER, TWEEDIEST, TWEEDILY]\n",
  "TWEEL": "(Scots) to weave with a twill [v -ED, -ING, -S]\n",
  "TWEELED": "TWEEL, (Scots) to weave with a twill [v]\n",
  "TWEELING": "TWEEL, (Scots) to weave with a twill [v]\n",
  "TWEELS": "TWEEL, (Scots) to weave with a twill [v]\n",
  "TWEELY": "TWEE, affectedly cute or quaint [adv]\n",
  "TWEEN": "a preteen, between childhood and teenage [n -S]\n",
  "TWEENAGE": "having the characteristics of a tweenager [adj]\n",
  "TWEENAGER": "a child of approximately eight to fourteen years of age, also TWEENER [n -S]\n",
  "TWEENAGERS": "TWEENAGER, a child of approximately eight to fourteen years of age, also TWEENER [n]\n",
  "TWEENER": "a player having some but not all of the qualifications for two or more positions [n -S]\n",
  "TWEENERS": "TWEENER, a player having some but not all of the qualifications for two or more positions [n]\n",
  "TWEENESS": "the state of being affectedly cute [n -ES]\n",
  "TWEENESSES": "TWEENESS, the state of being affectedly cute [n]\n",
  "TWEENIE": "(colloquial) a between-maid, also TWEENY [n -S]\n",
  "TWEENIES": "TWEENY, (colloquial) a between-maid, also TWEENIE [n]\n",
  "TWEENS": "TWEEN, a preteen, between childhood and teenage [n]\n",
  "TWEENY": "(colloquial) a between-maid, also TWEENIE [n TWEENIES]\n",
  "TWEEP": "one who uses Twitter [n -S]\n",
  "TWEEPLE": "people who communicate via the Twitter website [n]\n",
  "TWEEPS": "TWEEP, one who uses Twitter [n]\n",
  "TWEER": "(obsolete) to peer [v -ED, -ING, -S]\n",
  "TWEERED": "TWEER, (obsolete) to peer [v]\n",
  "TWEERING": "TWEER, (obsolete) to peer [v]\n",
  "TWEERS": "TWEER, (obsolete) to peer [v]\n",
  "TWEEST": "TWEE, affectedly cute or quaint [adj]\n",
  "TWEET": "to make a sound like a bird [v -ED, -ING, -S]\n",
  "TWEETABLE": "(of a message) short enough to be posted on the Twitter website [adj]\n",
  "TWEETED": "TWEET, to make a sound like a bird [v]\n",
  "TWEETER": "a loudspeaker made for high-pitched sounds [n -S]\n",
  "TWEETERS": "TWEETER, a loudspeaker made for high-pitched sounds [n]\n",
  "TWEETING": "TWEET, to make a sound like a bird [v]\n",
  "TWEETS": "TWEET, to make a sound like a bird [v]\n",
  "TWEETUP": "an online meeting of individuals arranged on the social networking website Twitter [n -S]\n",
  "TWEETUPS": "TWEETUP, an online meeting of individuals arranged on the social networking website Twitter [n]\n",
  "TWEEZE": "to pluck with a tweezer [v TWEEZED, TWEEZING, TWEEZES]\n",
  "TWEEZED": "TWEEZE, to pluck with a tweezer [v]\n",
  "TWEEZER": "a pincerlike tool [n -S]\n",
  "TWEEZERS": "TWEEZER, a pincerlike tool [n]\n",
  "TWEEZES": "TWEEZE, to pluck with a tweezer [v]\n",
  "TWEEZING": "TWEEZE, to pluck with a tweezer [v]\n",
  "TWELFTH": "twelfth in sequence [adj TWELFTHLY] / a twelfth part of [n -S]\n",
  "TWELFTHLY": "TWELFTH, twelfth in sequence [adv]\n",
  "TWELFTHS": "TWELFTH, a twelfth part of [n]\n",
  "TWELVE": "a number, two and ten [n -S]\n",
  "TWELVEFOLD": "twelve in number [adj]\n",
  "TWELVEMO": "a paper size, aka duodecimo [n -S]\n",
  "TWELVEMONTH": "a period of twelve months [n -S]\n",
  "TWELVEMONTHS": "TWELVEMONTH, a period of twelve months [n]\n",
  "TWELVEMOS": "TWELVEMO, a paper size, aka duodecimo [n]\n",
  "TWELVES": "TWELVE, a number, two and ten [n]\n",
  "TWENTIES": "TWENTY, a number [n]\n",
  "TWENTIETH": "number twenty in sequence [adj] / one of twenty equal parts [n -S]\n",
  "TWENTIETHS": "TWENTIETH, one of twenty equal parts [n]\n",
  "TWENTY": "a number [n TWENTIES]\n",
  "TWENTYFOLD": "multiplied by a twenty [adj] / twenty times as much [n -S]\n",
  "TWENTYFOLDS": "TWENTYFOLD, twenty times as much [n]\n",
  "TWENTYISH": "about twenty esp. in age [adj]\n",
  "TWERK": "to thrust the hips up and down from a squatting position [v -ED, -ING, -S]\n",
  "TWERKED": "TWERK, to thrust the hips up and down from a squatting position [v]\n",
  "TWERKING": "the act of thrusting the hips up and down from a squatting position [n -S]\n",
  "TWERKINGS": "TWERKING, the act of thrusting the hips up and down from a squatting position [n]\n",
  "TWERKS": "TWERK, to thrust the hips up and down from a squatting position [v]\n",
  "TWERP": "a small, impudent person, also TWIRP [n -S]\n",
  "TWERPIER": "TWERPY, like a twerp, also TWIRPY [adj]\n",
  "TWERPIEST": "TWERPY, like a twerp, also TWIRPY [adj]\n",
  "TWERPS": "TWERP, a small, impudent person, also TWIRP [n]\n",
  "TWERPY": "like a twerp, also TWIRPY [adj TWERPIER, TWERPIEST]\n",
  "TWIBIL": "a battleaxe with two cutting edges, also TWIBILL [n -S]\n",
  "TWIBILL": "a battleaxe with two cutting edges, also TWIBIL [n -S]\n",
  "TWIBILLS": "TWIBILL, a battleaxe with two cutting edges, also TWIBIL [n]\n",
  "TWIBILS": "TWIBIL, a battleaxe with two cutting edges, also TWIBILL [n]\n",
  "TWICE": "two times [adv]\n",
  "TWICER": "(Australian slang) a compositor and pressman [n -S]\n",
  "TWICERS": "TWICER, (Australian slang) a compositor and pressman [n]\n",
  "TWICHILD": "a person in his or her second childhood [n TWICHILDREN]\n",
  "TWICHILDREN": "TWICHILD, a person in his or her second childhood [n]\n",
  "TWIDDLE": "to play idly with something [v TWIDDLED, TWIDDLING, TWIDDLES]\n",
  "TWIDDLED": "TWIDDLE, to play idly with something [v]\n",
  "TWIDDLER": "one who twiddles [n -S]\n",
  "TWIDDLERS": "TWIDDLER, one who twiddles [n]\n",
  "TWIDDLES": "TWIDDLE, to play idly with something [v]\n",
  "TWIDDLIER": "TWIDDLY, having many turns [adj]\n",
  "TWIDDLIEST": "TWIDDLY, having many turns [adj]\n",
  "TWIDDLING": "the act of twiddling [n -S]\n",
  "TWIDDLINGS": "TWIDDLING, the act of twiddling [n]\n",
  "TWIDDLY": "having many turns [adj TWIDDLIER, TWIDDLIEST]\n",
  "TWIER": "a pipe through which air is forced into a blast furnace, also TUYERE, TUYER, TWEER, TWYER, TWYERE [n -S]\n",
  "TWIERS": "TWIER, a pipe through which air is forced into a blast furnace, also TUYERE, TUYER, TWEER, TWYER, TWYERE [n]\n",
  "TWIFOLD": "twofold, also TWAFALD, TWOFOLD, TWYFOLD [adj]\n",
  "TWIFORKED": "bifurcate [adj]\n",
  "TWIFORMED": "having two forms [adj]\n",
  "TWIG": "to observe, understand [v TWIGGED, TWIGGING, TWIGS]\n",
  "TWIGGED": "TWIG, to observe, understand [v]\n",
  "TWIGGEN": "(Shakespeare) made of twigs, wicker [adj]\n",
  "TWIGGER": "a wanton [n -S]\n",
  "TWIGGERS": "TWIGGER, a wanton [n]\n",
  "TWIGGIER": "TWIGGY, twiglike, full of twigs [adj]\n",
  "TWIGGIEST": "TWIGGY, twiglike, full of twigs [adj]\n",
  "TWIGGING": "TWIG, to observe, understand [v]\n",
  "TWIGGY": "twiglike, full of twigs [adj TWIGGIER, TWIGGIEST]\n",
  "TWIGHT": "(Spenser) to twit, upbraid [v -ED, -ING, -S]\n",
  "TWIGHTED": "TWIGHT, (Spenser) to twit, upbraid [v]\n",
  "TWIGHTING": "TWIGHT, (Spenser) to twit, upbraid [v]\n",
  "TWIGHTS": "TWIGHT, (Spenser) to twit, upbraid [v]\n",
  "TWIGLESS": "without twigs [adj]\n",
  "TWIGLET": "a small twig [n -S]\n",
  "TWIGLETS": "TWIGLET, a small twig [n]\n",
  "TWIGLIKE": "like a twig [adj]\n",
  "TWIGLOO": "a makeshift shelter made from branches [n -S]\n",
  "TWIGLOOS": "TWIGLOO, a makeshift shelter made from branches [n]\n",
  "TWIGS": "TWIG, to observe, understand [v]\n",
  "TWIGSOME": "composed of many twigs [adj]\n",
  "TWILIGHT": "the time between sunset and night [n -S] / to light imperfectly or faintly; to make twilit [v TWILIGHTED or TWILIT, TWILIGHTING, TWILIGHTS]\n",
  "TWILIGHTED": "TWILIGHT, to light imperfectly or faintly; to make twilit [v]\n",
  "TWILIGHTING": "TWILIGHT, to light imperfectly or faintly; to make twilit [v]\n",
  "TWILIGHTS": "TWILIGHT, to light imperfectly or faintly; to make twilit [v]\n",
  "TWILIT": "lit by twilight [adj]\n",
  "TWILL": "to weave with a diagonal pattern [v -ED, -ING, -S]\n",
  "TWILLED": "TWILL, to weave with a diagonal pattern [v]\n",
  "TWILLIES": "TWILLY, a willowing machine [n]\n",
  "TWILLING": "a twilled fabric [n -S]\n",
  "TWILLINGS": "TWILLING, a twilled fabric [n]\n",
  "TWILLS": "TWILL, to weave with a diagonal pattern [v]\n",
  "TWILLY": "a willowing machine [n TWILLIES]\n",
  "TWILT": "to quilt [v -ED, -ING, -S]\n",
  "TWILTED": "TWILT, to quilt [v]\n",
  "TWILTING": "TWILT, to quilt [v]\n",
  "TWILTS": "TWILT, to quilt [v]\n",
  "TWIN": "to bring together in close association [v TWINNED, TWINNING, TWINS]\n",
  "TWINBERRIES": "TWINBERRY, a shrubby North American honeysuckle [n]\n",
  "TWINBERRY": "a shrubby North American honeysuckle [n TWINBERRIES]\n",
  "TWINBORN": "born at the same birth [adj]\n",
  "TWINE": "to entangle together [v TWINED, TWINING, TWINES]\n",
  "TWINED": "TWINE, to entangle together [v]\n",
  "TWINER": "a twining plant [n -S]\n",
  "TWINERS": "TWINER, a twining plant [n]\n",
  "TWINES": "TWINE, to entangle together [v]\n",
  "TWINFLOWER": "a North American plant of the genus Linnaea [n -S]\n",
  "TWINFLOWERS": "TWINFLOWER, a North American plant of the genus Linnaea [n]\n",
  "TWINGE": "to affect with a sharp pain [v TWINGED, TWINGEING or TWINGING, TWINGES]\n",
  "TWINGED": "TWINGE, to affect with a sharp pain [v]\n",
  "TWINGEING": "TWINGE, to affect with a sharp pain [v]\n",
  "TWINGES": "TWINGE, to affect with a sharp pain [v]\n",
  "TWINGING": "TWINGE, to affect with a sharp pain [v]\n",
  "TWINIER": "TWINY, resembling strong string [adj]\n",
  "TWINIEST": "TWINY, resembling strong string [adj]\n",
  "TWINIGHT": "of a baseball game, in two parts [adj]\n",
  "TWINING": "winding, coiling [adj TWININGLY] / the act of twining [n -S]\n",
  "TWININGLY": "TWINING, winding, coiling [adv]\n",
  "TWININGS": "TWINING, the act of twining [n]\n",
  "TWINJET": "an aircraft with two jet engines [n -S]\n",
  "TWINJETS": "TWINJET, an aircraft with two jet engines [n]\n",
  "TWINK": "to blink [v -ED, -ING, -S]\n",
  "TWINKED": "TWINK, to blink [v]\n",
  "TWINKIE": "(tradename) a stereotypically brainless person, also TWINKY [n -S]\n",
  "TWINKIES": "TWINKIE, (tradename) a stereotypically brainless person, also TWINKY [n]\n",
  "TWINKING": "TWINK, to blink [v]\n",
  "TWINKLE": "to shine with a flickering light [v TWINKLED, TWINKLING, TWINKLES]\n",
  "TWINKLED": "TWINKLE, to shine with a flickering light [v]\n",
  "TWINKLER": "one who, or that which, twinkles [n -S]\n",
  "TWINKLERS": "TWINKLER, one who, or that which, twinkles [n]\n",
  "TWINKLES": "TWINKLE, to shine with a flickering light [v]\n",
  "TWINKLIER": "TWINKLY, given to twinkling [adj]\n",
  "TWINKLIEST": "TWINKLY, given to twinkling [adj]\n",
  "TWINKLING": "the act of twinkling [n -S]\n",
  "TWINKLINGS": "TWINKLING, the act of twinkling [n]\n",
  "TWINKLY": "given to twinkling [adj TWINKLIER, TWINKLIEST]\n",
  "TWINKS": "TWINK, to blink [v]\n",
  "TWINKY": "(tradename) a stereotypically brainless person, also TWINKIE [n TWINKIES]\n",
  "TWINLING": "a young or little twin, esp. a twin lamb [n -S]\n",
  "TWINLINGS": "TWINLING, a young or little twin, esp. a twin lamb [n]\n",
  "TWINNED": "TWIN, to bring together in close association [v]\n",
  "TWINNING": "the bearing of two children at the same birth [n -S]\n",
  "TWINNINGS": "TWINNING, the bearing of two children at the same birth [n]\n",
  "TWINS": "TWIN, to bring together in close association [v]\n",
  "TWINSET": "a matching jumper and cardigan [n -S]\n",
  "TWINSETS": "TWINSET, a matching jumper and cardigan [n]\n",
  "TWINSHIP": "a close association [n -S]\n",
  "TWINSHIPS": "TWINSHIP, a close association [n]\n",
  "TWINTER": "(Scots) a two-year old sheep or other animal [n -S]\n",
  "TWINTERS": "TWINTER, (Scots) a two-year old sheep or other animal [n]\n",
  "TWINY": "resembling strong string [adj TWINIER, TWINIEST]\n",
  "TWIRE": "(Shakespeare) to peep, twinkle [v TWIRED, TWIRING, TWIRES]\n",
  "TWIRED": "TWIRE, (Shakespeare) to peep, twinkle [v]\n",
  "TWIRES": "TWIRE, (Shakespeare) to peep, twinkle [v]\n",
  "TWIRING": "TWIRE, (Shakespeare) to peep, twinkle [v]\n",
  "TWIRL": "to rotate rapidly [v -ED, -ING, -S]\n",
  "TWIRLED": "TWIRL, to rotate rapidly [v]\n",
  "TWIRLER": "a person who or thing which twirls [n -S]\n",
  "TWIRLERS": "TWIRLER, a person who or thing which twirls [n]\n",
  "TWIRLIER": "TWIRLY, curved [adj]\n",
  "TWIRLIEST": "TWIRLY, curved [adj]\n",
  "TWIRLING": "TWIRL, to rotate rapidly [v]\n",
  "TWIRLS": "TWIRL, to rotate rapidly [v]\n",
  "TWIRLY": "curved [adj TWIRLIER, TWIRLIEST]\n",
  "TWIRP": "a small impudent person, also TWERP [n -S]\n",
  "TWIRPIER": "TWIRPY, like a twirp, also TWERPY [adj]\n",
  "TWIRPIEST": "TWIRPY, like a twirp, also TWERPY [adj]\n",
  "TWIRPS": "TWIRP, a small impudent person, also TWERP [n]\n",
  "TWIRPY": "like a twirp, also TWERPY [adj TWIRPIER, TWIRPIEST]\n",
  "TWISCAR": "(Old Norse) a turf-spade, also TUSHKAR, TUSHKER, TUSKAR, TUSKER [n -S]\n",
  "TWISCARS": "TWISCAR, (Old Norse) a turf-spade, also TUSHKAR, TUSHKER, TUSKAR, TUSKER [n]\n",
  "TWIST": "to force around [v -ED, -ING, -S]\n",
  "TWISTABILITIES": "TWISTABILITY, the quality of being twistable [n]\n",
  "TWISTABILITY": "the quality of being twistable [n TWISTABILITIES]\n",
  "TWISTABLE": "that can be twisted [adj]\n",
  "TWISTED": "TWIST, to force around [v]\n",
  "TWISTER": "(colloquial) a tornado [n -S]\n",
  "TWISTERS": "TWISTER, (colloquial) a tornado [n]\n",
  "TWISTIER": "TWISTY, full of curves [adj]\n",
  "TWISTIEST": "TWISTY, full of curves [adj]\n",
  "TWISTING": "a form of trickery used in selling life insurance [n -S]\n",
  "TWISTINGS": "TWISTING, a form of trickery used in selling life insurance [n]\n",
  "TWISTOR": "a complex variable representing space-time coordinates [n -S]\n",
  "TWISTORS": "TWISTOR, a complex variable representing space-time coordinates [n]\n",
  "TWISTS": "TWIST, to force around [v]\n",
  "TWISTY": "full of curves [adj TWISTIER, TWISTIEST]\n",
  "TWIT": "to upbraid, taunt [v TWITTED, TWITTING, TWITS]\n",
  "TWITCH": "to move spasmodically [v -ED, -ING, -ES]\n",
  "TWITCHED": "TWITCH, to move spasmodically [v]\n",
  "TWITCHER": "one that twitches [n -S]\n",
  "TWITCHERS": "TWITCHER, one that twitches [n]\n",
  "TWITCHES": "TWITCH, to move spasmodically [v]\n",
  "TWITCHIER": "TWITCHY, given to twitching [adj]\n",
  "TWITCHIEST": "TWITCHY, given to twitching [adj]\n",
  "TWITCHILY": "TWITCHY, given to twitching [adv]\n",
  "TWITCHING": "the act of twitching [n -S]\n",
  "TWITCHINGS": "TWITCHING, the act of twitching [n]\n",
  "TWITCHY": "given to twitching [adj TWITCHIER, TWITCHIEST, TWITCHILY]\n",
  "TWITE": "the mountain linnet, a North European finch with streaked brown plumage [n -S]\n",
  "TWITES": "TWITE, the mountain linnet, a North European finch with streaked brown plumage [n]\n",
  "TWITS": "TWIT, to upbraid, taunt [v]\n",
  "TWITTED": "TWIT, to upbraid, taunt [v]\n",
  "TWITTEN": "a narrow lane between two walls or hedges [n -S]\n",
  "TWITTENS": "TWITTEN, a narrow lane between two walls or hedges [n]\n",
  "TWITTER": "to chirp [v -ED, -ING, -S]\n",
  "TWITTERATI": "influential commentators who use the Twitter website [n]\n",
  "TWITTERED": "TWITTER, to chirp [v]\n",
  "TWITTERER": "one who twitters [n -S]\n",
  "TWITTERERS": "TWITTERER, one who twitters [n]\n",
  "TWITTERIER": "TWITTERY, given to twittering [adj]\n",
  "TWITTERIEST": "TWITTERY, given to twittering [adj]\n",
  "TWITTERING": "a succession of chirping sounds [n -S]\n",
  "TWITTERINGLY": "TWITTERING [adv]\n",
  "TWITTERINGS": "TWITTERING, a succession of chirping sounds [n]\n",
  "TWITTERS": "TWITTER, to chirp [v]\n",
  "TWITTERY": "given to twittering [adj TWITTERIER, TWITTERIEST]\n",
  "TWITTING": "the act of twitting, upbraiding [n -S]\n",
  "TWITTINGLY": "TWITTING [adv]\n",
  "TWITTINGS": "TWITTING, the act of twitting, upbraiding [n]\n",
  "TWITTISH": "silly, foolish [adj]\n",
  "TWIXT": "between, also BETWIXT [prep]\n",
  "TWIZZLE": "to twirl, spin [v TWIZZLED, TWIZZLING, TWIZZLES]\n",
  "TWIZZLED": "TWIZZLE, to twirl, spin [v]\n",
  "TWIZZLES": "TWIZZLE, to twirl, spin [v]\n",
  "TWIZZLING": "TWIZZLE, to twirl, spin [v]\n",
  "TWO": "the next whole number after one [n -S]\n",
  "TWOCCER": "a person who takes (a car) without the owner's consent, also TWOCKER [n -S]\n",
  "TWOCCERS": "TWOCCER, a person who takes (a car) without the owner's consent, also TWOCKER [n]\n",
  "TWOCCING": "the offence of taking (a car) without the owner's consent, also TWOCKING [n -S]\n",
  "TWOCCINGS": "TWOCCING, the offence of taking (a car) without the owner's consent, also TWOCKING [n]\n",
  "TWOCKER": "a person who takes a car without the owner's consent, also TWOCCER [n -S]\n",
  "TWOCKERS": "TWOCKER, a person who takes a car without the owner's consent, also TWOCCER [n]\n",
  "TWOCKING": "the offence of taking (a car) without the owner's consent, also TWOCCING [n -S]\n",
  "TWOCKINGS": "TWOCKING, the offence of taking (a car) without the owner's consent, also TWOCCING [n]\n",
  "TWOER": "(colloquial) anything that counts as two or scores two [n -S]\n",
  "TWOERS": "TWOER, (colloquial) anything that counts as two or scores two [n]\n",
  "TWOFER": "something that is sold at the rate of two for the price of one [n -S]\n",
  "TWOFERS": "TWOFER, something that is sold at the rate of two for the price of one [n]\n",
  "TWOFOLD": "an amount twice as great as a given unit, also TWAFALD, TWIFOLD, TWYFOLD [n -S]\n",
  "TWOFOLDNESS": "the state of being twofold [n -ES]\n",
  "TWOFOLDNESSES": "TWOFOLDNESS, the state of being twofold [n]\n",
  "TWOFOLDS": "TWOFOLD, an amount twice as great as a given unit, also TWAFALD, TWIFOLD, TWYFOLD [n]\n",
  "TWONESS": "the state of being two [n -ES]\n",
  "TWONESSES": "TWONESS, the state of being two [n]\n",
  "TWONIE": "(Canadian) a Canadian two-dollar coin, also TOONIE, TWOONIE [n -S]\n",
  "TWONIES": "TWONIE, (Canadian) a Canadian two-dollar coin, also TOONIE, TWOONIE [n]\n",
  "TWOONIE": "(Canadian) a Canadian two-dollar coin, also TOONIE, TWONIE [n -S]\n",
  "TWOONIES": "TWOONIE, (Canadian) a Canadian two-dollar coin, also TOONIE, TWONIE [n]\n",
  "TWOPENCE": "a British coin worth two pennies [n -S]\n",
  "TWOPENCES": "TWOPENCE, a British coin worth two pennies [n]\n",
  "TWOPENCEWORTH": "goods to the value of twopence [n -S]\n",
  "TWOPENCEWORTHS": "TWOPENCEWORTH, goods to the value of twopence [n]\n",
  "TWOPENNIES": "TWOPENNY, two pennies, also TUPPENNY [n]\n",
  "TWOPENNY": "two pennies, also TUPPENNY [n TWOPENNIES]\n",
  "TWOS": "TWO, the next whole number after one [n]\n",
  "TWOSEATER": "a car or other vehicle with two seats [n -S]\n",
  "TWOSEATERS": "TWOSEATER, a car or other vehicle with two seats [n]\n",
  "TWOSOME": "a pair of two [n -S]\n",
  "TWOSOMES": "TWOSOME, a pair of two [n]\n",
  "TWOSTROKE": "denoting a kind of engine [adj]\n",
  "TWP": "(Welsh) dimwitted or stupid [adj]\n",
  "TWYER": "a pipe through which air is forced into a blast furnace, also TUYERE, TUYER, TWEER, TWIER, TWYERE [n -S]\n",
  "TWYERE": "a pipe through which air is forced into a blast furnace, also TUYERE, TUYER, TWEER, TWIER, TWYER [n -S]\n",
  "TWYERES": "TWYERE, a pipe through which air is forced into a blast furnace, also TUYERE, TUYER, TWEER, TWIER, TWYER [n]\n",
  "TWYERS": "TWYER, a pipe through which air is forced into a blast furnace, also TUYERE, TUYER, TWEER, TWIER, TWYERE [n]\n",
  "TWYFOLD": "twofold, also TWAFALD, TWIFOLD, TWOFOLD [adj]\n",
  "TYCHISM": "the theory that objective account must be taken of the element of chance in philosophical etc. reasoning [n -S]\n",
  "TYCHISMS": "TYCHISM, the theory that objective account must be taken of the element of chance in philosophical etc. reasoning [n]\n",
  "TYCOON": "a wealthy and powerful business person [n -S]\n",
  "TYCOONATE": "the shogunate, the office or dignity of a shogun, a hereditary military governor of Japan [n -S]\n",
  "TYCOONATES": "TYCOONATE, the shogunate, the office or dignity of a shogun, a hereditary military governor of Japan [n]\n",
  "TYCOONERIES": "TYCOONERY, the state of being a tycoon [n]\n",
  "TYCOONERY": "the state of being a tycoon [n TYCOONERIES]\n",
  "TYCOONS": "TYCOON, a wealthy and powerful business person [n]\n",
  "TYDE": "(Spenser) tied [v]\n",
  "TYE": "to wash in a trough [v TYED, TYEING, TYES]\n",
  "TYED": "TYE, to wash in a trough [v]\n",
  "TYEE": "a food fish [n -S]\n",
  "TYEES": "TYEE, a food fish [n]\n",
  "TYEING": "TYE, to wash in a trough [v]\n",
  "TYER": "one who ties [n -S]\n",
  "TYERS": "TYER, one who ties [n]\n",
  "TYES": "TYE, to wash in a trough [v]\n",
  "TYG": "an old drinking-cup with two or more handles [n -S]\n",
  "TYGS": "TYG, an old drinking-cup with two or more handles [n]\n",
  "TYIN": "a monetary unit of Kyrgyzstan, also TYIYN [n TYIN]\n",
  "TYING": "TIE, to fasten [v]\n",
  "TYIYN": "a monetary unit in Kyrgyzstan and Uzbekistan, also TYIN [n -S]\n",
  "TYIYNS": "TYIYN, a monetary unit in Kyrgyzstan and Uzbekistan, also TYIN [n]\n",
  "TYKE": "a small child, also TIKE [n -S]\n",
  "TYKES": "TYKE, a small child, also TIKE [n]\n",
  "TYKISH": "like a tyke [adj]\n",
  "TYLECTOMIES": "TYLECTOMY, the surgical removal of a lump, esp. in the breast, aka lumpectomy [n]\n",
  "TYLECTOMY": "the surgical removal of a lump, esp. in the breast, aka lumpectomy [n TYLECTOMIES]\n",
  "TYLER": "a maker or layer of tiles, also TILER [n -S]\n",
  "TYLERS": "TYLER, a maker or layer of tiles, also TILER [n]\n",
  "TYLOPOD": "ungulates with padded toes [n -S]\n",
  "TYLOPODS": "TYLOPOD, ungulates with padded toes [n]\n",
  "TYLOSES": "TYLOSIS, (Greek) an ingrowth from a neighbouring cell through a pit into a vessel, also THYLOSE, THYLOSIS [n]\n",
  "TYLOSIN": "an antibiotic [n -S]\n",
  "TYLOSINS": "TYLOSIN, an antibiotic [n]\n",
  "TYLOSIS": "(Greek) an ingrowth from a neighbouring cell through a pit into a vessel, also THYLOSE, THYLOSIS [n TYLOSES]\n",
  "TYLOTE": "a cylindrical sponge [n -S]\n",
  "TYLOTES": "TYLOTE, a cylindrical sponge [n]\n",
  "TYMBAL": "(archaic) a kind of kettledrum, also TIMBAL [n -S]\n",
  "TYMBALS": "TYMBAL, (archaic) a kind of kettledrum, also TIMBAL [n]\n",
  "TYMP": "the plate on a blast-furnace [n -S]\n",
  "TYMPAN": "a drum [n -S]\n",
  "TYMPANA": "TYMPANUM, (Latin) the cavity of the middle ear, also TIMPANUM [n]\n",
  "TYMPANAL": "tympanic [adj]\n",
  "TYMPANI": "TYMPANO, a kettledrum, also TIMPANO [n]\n",
  "TYMPANIC": "like a tympanum or drum, also TYMPANAL [adj] / a bone of the ear [n -S]\n",
  "TYMPANICS": "TYMPANIC, a bone of the ear [n]\n",
  "TYMPANIES": "TYMPANY, a swelling of the abdomen [n]\n",
  "TYMPANIFORM": "drumlike; shaped like a drum [adj]\n",
  "TYMPANIST": "one who plays the tympani, also TIMPANIST [n -S]\n",
  "TYMPANISTS": "TYMPANIST, one who plays the tympani, also TIMPANIST [n]\n",
  "TYMPANITES": "the distention of the abdomen by flatulence, also TYMPANY [n -ES]\n",
  "TYMPANITESES": "TYMPANITES, the distention of the abdomen by flatulence, also TYMPANY [n]\n",
  "TYMPANITIC": "pertaining to, or affected with, tympanites [adj]\n",
  "TYMPANITIS": "inflammation of the lining membrane of the middle ear [n -ES]\n",
  "TYMPANITISES": "TYMPANITIS, inflammation of the lining membrane of the middle ear [n]\n",
  "TYMPANO": "a kettledrum, also TIMPANO [n TYMPANI]\n",
  "TYMPANS": "TYMPAN, a drum [n]\n",
  "TYMPANUM": "(Latin) the cavity of the middle ear, also TIMPANUM [n TYMPANUMS or TYMPANA]\n",
  "TYMPANUMS": "TYMPANUM, (Latin) the cavity of the middle ear, also TIMPANUM [n]\n",
  "TYMPANY": "a swelling of the abdomen [n TYMPANIES]\n",
  "TYMPS": "TYMP, the plate on a blast-furnace [n]\n",
  "TYND": "TIND, to kindle, also TEEND [v]\n",
  "TYNDALLIMETRIES": "TYNDALLIMETRY, the determination of the concentration of suspended material in a liquid by measuring the amount of light scattered [n]\n",
  "TYNDALLIMETRY": "the determination of the concentration of suspended material in a liquid by measuring the amount of light scattered [n TYNDALLIMETRIES]\n",
  "TYNDE": "TIND, to kindle, also TEEND [v]\n",
  "TYNE": "(Scots) to lose, also TINE [v TYNED, TYNING, TYNES]\n",
  "TYNED": "TYNE, (Scots) to lose, also TINE [v]\n",
  "TYNES": "TYNE, (Scots) to lose, also TINE [v]\n",
  "TYNING": "TYNE, (Scots) to lose, also TINE [v]\n",
  "TYPABLE": "that can be typed, also TYPEABLE [adj]\n",
  "TYPAL": "relating to a type, typical [adj]\n",
  "TYPE": "to print with a typewriter [v TYPED, TYPING, TYPES]\n",
  "TYPEABLE": "that can be typed, also TYPABLE [adj]\n",
  "TYPEBAR": "a part of a typewriter [n -S]\n",
  "TYPEBARS": "TYPEBAR, a part of a typewriter [n]\n",
  "TYPECASE": "a tray for holding printing type [n -S]\n",
  "TYPECASES": "TYPECASE, a tray for holding printing type [n]\n",
  "TYPECAST": "to cast continually as the same type of character [v TYPECAST, TYPECASTING, TYPECASTS]\n",
  "TYPECASTER": "one who typecasts [n -S]\n",
  "TYPECASTERS": "TYPECASTER, one who typecasts [n]\n",
  "TYPECASTING": "the act of casting someone in a standardised role [n -S]\n",
  "TYPECASTINGS": "TYPECASTING, the act of casting someone in a standardised role [n]\n",
  "TYPECASTS": "TYPECAST, to cast continually as the same type of character [v]\n",
  "TYPED": "TYPE, to print with a typewriter [v]\n",
  "TYPEFACE": "the face of printing type [n -S]\n",
  "TYPEFACES": "TYPEFACE, the face of printing type [n]\n",
  "TYPEFOUNDER": "someone who founds or casts printers' type [n -S]\n",
  "TYPEFOUNDERS": "TYPEFOUNDER, someone who founds or casts printers' type [n]\n",
  "TYPEFOUNDING": "the casting of printers' type [n -S]\n",
  "TYPEFOUNDINGS": "TYPEFOUNDING, the casting of printers' type [n]\n",
  "TYPEFOUNDRIES": "TYPEFOUNDRY, a place where type is cast [n]\n",
  "TYPEFOUNDRY": "a place where type is cast [n TYPEFOUNDRIES]\n",
  "TYPES": "TYPE, to print with a typewriter [v]\n",
  "TYPESCRIPT": "a typewritten manuscript [n -S]\n",
  "TYPESCRIPTS": "TYPESCRIPT, a typewritten manuscript [n]\n",
  "TYPESET": "to set in type [v TYPESET, TYPESETTING, TYPESETS]\n",
  "TYPESETS": "TYPESET, to set in type [v]\n",
  "TYPESETTER": "one whose job is to set type [n -S]\n",
  "TYPESETTERS": "TYPESETTER, one whose job is to set type [n]\n",
  "TYPESETTING": "the act of setting type [n -S]\n",
  "TYPESETTINGS": "TYPESETTING, the act of setting type [n]\n",
  "TYPESTYLE": "a style of type [n -S]\n",
  "TYPESTYLES": "TYPESTYLE, a style of type [n]\n",
  "TYPEWRITE": "to write on a typewriter [v TYPEWROTE, TYPEWRITTEN, TYPEWRITING, TYPEWRITES]\n",
  "TYPEWRITER": "a machine, usually with a keyboard, for printing as a substitute for handwriting [n -S]\n",
  "TYPEWRITERS": "TYPEWRITER, a machine, usually with a keyboard, for printing as a substitute for handwriting [n]\n",
  "TYPEWRITES": "TYPEWRITE, to write on a typewriter [v]\n",
  "TYPEWRITING": "the act of using a typewriter [n -S]\n",
  "TYPEWRITINGS": "TYPEWRITING, the act of using a typewriter [n]\n",
  "TYPEWRITTEN": "TYPEWRITE, to write on a typewriter [v]\n",
  "TYPEWROTE": "TYPEWRITE, to write on a typewriter [v]\n",
  "TYPEY": "conforming to the strict characteristics of a group, also TYPY [adj TYPIER, TYPIEST]\n",
  "TYPHACEOUS": "relating to the reed-mace genus, Typha [adj]\n",
  "TYPHLITIC": "relating to typhlitis, inflammation of the caecum [adj]\n",
  "TYPHLITIS": "inflammation of the caecum [n -ES]\n",
  "TYPHLITISES": "TYPHLITIS, inflammation of the caecum [n]\n",
  "TYPHLOLOGIES": "TYPHLOLOGY, the study of blindness and the blind [n]\n",
  "TYPHLOLOGY": "the study of blindness and the blind [n TYPHLOLOGIES]\n",
  "TYPHLOSOLE": "a fold of the wall which projects into the cavity of the intestine in bivalve mollusks, certain annelids, starfishes, and some other animals [n -S]\n",
  "TYPHLOSOLES": "TYPHLOSOLE, a fold of the wall which projects into the cavity of the intestine in bivalve mollusks, certain annelids, starfishes, and some other animals [n]\n",
  "TYPHOGENIC": "causing typhus or typhoid fever [adj]\n",
  "TYPHOID": "an infectious disease [n -S]\n",
  "TYPHOIDAL": "relating to typhoid [adj]\n",
  "TYPHOIDIN": "a culture of dead typhoid bacillus for injection into the skin as a test for typhoid fever [n -S]\n",
  "TYPHOIDINS": "TYPHOIDIN, a culture of dead typhoid bacillus for injection into the skin as a test for typhoid fever [n]\n",
  "TYPHOIDS": "TYPHOID, an infectious disease [n]\n",
  "TYPHON": "(Greek) a whirlwind [n -S]\n",
  "TYPHONIAN": "relating to a whirlwind [adj]\n",
  "TYPHONIC": "relating to a typhoon [adj]\n",
  "TYPHONS": "TYPHON, (Greek) a whirlwind [n]\n",
  "TYPHOON": "(Chinese) a tropical hurricane [n -S]\n",
  "TYPHOONS": "TYPHOON, (Chinese) a tropical hurricane [n]\n",
  "TYPHOSE": "of or pertaining to typhus, also TYPHOUS [adj]\n",
  "TYPHOUS": "of or pertaining to typhus, also TYPHOSE [adj]\n",
  "TYPHUS": "any of a group of acute infectious fevers caused by rickettsiae [n -ES]\n",
  "TYPHUSES": "TYPHUS, any of a group of acute infectious fevers caused by rickettsiae [n]\n",
  "TYPIC": "relating to a type, also TYPICAL [adj TYPICALLY]\n",
  "TYPICAL": "representative of a type, also TYPIC [adj TYPICALLY]\n",
  "TYPICALITIES": "TYPICALITY, the state of being typical, also TYPICALNESS [n]\n",
  "TYPICALITY": "the state of being typical, also TYPICALNESS [n TYPICALITIES]\n",
  "TYPICALLY": "TYPICAL, representative of a type, also TYPIC [adv]\n",
  "TYPICALNESS": "the state of being typical, also TYPICALITY [n -ES]\n",
  "TYPICALNESSES": "TYPICALNESS, the state of being typical, also TYPICALITY [n]\n",
  "TYPIER": "TYPY, conforming to the strict characteristics of a group, also TYPEY [adj]\n",
  "TYPIEST": "TYPY, conforming to the strict characteristics of a group, also TYPEY [adj]\n",
  "TYPIFICATION": "the act of typifying [n -S]\n",
  "TYPIFICATIONS": "TYPIFICATION, the act of typifying [n]\n",
  "TYPIFIED": "TYPIFY, to serve as a typical example [v]\n",
  "TYPIFIER": "one who, or that which, typifies [n -S]\n",
  "TYPIFIERS": "TYPIFIER, one who, or that which, typifies [n]\n",
  "TYPIFIES": "TYPIFY, to serve as a typical example [v]\n",
  "TYPIFY": "to serve as a typical example [v TYPIFIED, TYPIFYING, TYPIFIES]\n",
  "TYPIFYING": "TYPIFY, to serve as a typical example [v]\n",
  "TYPING": "the act of typing [n -S]\n",
  "TYPINGS": "TYPING, the act of typing [n]\n",
  "TYPIST": "one who types [n -S]\n",
  "TYPISTS": "TYPIST, one who types [n]\n",
  "TYPO": "a typographical error [n -S]\n",
  "TYPOGRAPH": "to produce stamps by letterpress [v -ED, -ING, -S]\n",
  "TYPOGRAPHED": "TYPOGRAPH, to produce stamps by letterpress [v]\n",
  "TYPOGRAPHER": "one who designs type [n -S]\n",
  "TYPOGRAPHERS": "TYPOGRAPHER, one who designs type [n]\n",
  "TYPOGRAPHIA": "matter relating to printing or printers [n]\n",
  "TYPOGRAPHIC": "relating to typography, the art of printing or using type, also TYPOGRAPHICAL [adj TYPOGRAPHICALLY]\n",
  "TYPOGRAPHICAL": "relating to typography, the art of printing or using type, also TYPOGRAPHIC [adj TYPOGRAPHICALLY]\n",
  "TYPOGRAPHICALLY": "TYPOGRAPHICAL, relating to typography, the art of printing or using type, also TYPOGRAPHIC [adv]\n",
  "TYPOGRAPHIES": "TYPOGRAPHY, the art of printing or using type [n]\n",
  "TYPOGRAPHING": "TYPOGRAPH, to produce stamps by letterpress [v]\n",
  "TYPOGRAPHIST": "one who does typography [n -S]\n",
  "TYPOGRAPHISTS": "TYPOGRAPHIST, one who does typography [n]\n",
  "TYPOGRAPHS": "TYPOGRAPH, to produce stamps by letterpress [v]\n",
  "TYPOGRAPHY": "the art of printing or using type [n TYPOGRAPHIES]\n",
  "TYPOLOGIC": "relating to typology, also TYPOLOGICAL [adj TYPOLOGICALLY]\n",
  "TYPOLOGICAL": "relating to typology, also TYPOLOGIC [adj TYPOLOGICALLY]\n",
  "TYPOLOGICALLY": "TYPOLOGICAL, relating to typology, also TYPOLOGIC [adv]\n",
  "TYPOLOGIES": "TYPOLOGY, the study of classification according to type [n]\n",
  "TYPOLOGIST": "a student of typology [n -S]\n",
  "TYPOLOGISTS": "TYPOLOGIST, a student of typology [n]\n",
  "TYPOLOGY": "the study of classification according to type [n TYPOLOGIES]\n",
  "TYPOMANIA": "the overwhelming urge to see one's name in print [n -S]\n",
  "TYPOMANIAS": "TYPOMANIA, the overwhelming urge to see one's name in print [n]\n",
  "TYPOS": "TYPO, a typographical error [n]\n",
  "TYPOTHETAE": "printers collectively; used in the names of organized associations, as of master printers [n]\n",
  "TYPP": "a unit of yarn size [n -S]\n",
  "TYPPS": "TYPP, a unit of yarn size [n]\n",
  "TYPTO": "to work at Greek grammar [v -ED, -ING, -S]\n",
  "TYPTOED": "TYPTO, to work at Greek grammar [v]\n",
  "TYPTOING": "TYPTO, to work at Greek grammar [v]\n",
  "TYPTOS": "TYPTO, to work at Greek grammar [v]\n",
  "TYPY": "conforming to the strict characteristics of a group, also TYPEY [adj TYPIER, TYPIEST]\n",
  "TYRAMINE": "a colourless crystalline amine found in cheese, ergot etc. [n -S]\n",
  "TYRAMINES": "TYRAMINE, a colourless crystalline amine found in cheese, ergot etc. [n]\n",
  "TYRAN": "to play the oppressor, also TYRANNE, TYRANT [v -ED, -ING, -S]\n",
  "TYRANED": "TYRAN, to play the oppressor, also TYRANNE, TYRANT [v]\n",
  "TYRANING": "TYRAN, to play the oppressor, also TYRANNE, TYRANT [v]\n",
  "TYRANNE": "to play the oppressor, also TYRAN, TYRANT [v TYRANNED, TYRANNING, TYRANNES]\n",
  "TYRANNED": "TYRANNE, to play the oppressor, also TYRAN, TYRANT [v]\n",
  "TYRANNES": "TYRANNE, to play the oppressor, also TYRAN, TYRANT [v]\n",
  "TYRANNESS": "(archaic) a female tyrant [n -ES]\n",
  "TYRANNESSES": "TYRANNESS, (archaic) a female tyrant [n]\n",
  "TYRANNIC": "like a tyrant, also TYRANNICAL [adj TYRANNICALLY]\n",
  "TYRANNICAL": "like a tyrant, also TYRANNIC [adj TYRANNICALLY]\n",
  "TYRANNICALLY": "TYRANNICAL, like a tyrant, also TYRANNIC [adv]\n",
  "TYRANNICALNESS": "TYRANNICAL, like a tyrant, also TYRANNIC [n]\n",
  "TYRANNICIDAL": "relating to tyrannicide [adj]\n",
  "TYRANNICIDE": "the killing or killer of a tyrant [n -S]\n",
  "TYRANNICIDES": "TYRANNICIDE, the killing or killer of a tyrant [n]\n",
  "TYRANNIES": "TYRANNY, the rule of a tyrant [n]\n",
  "TYRANNING": "TYRANNE, to play the oppressor, also TYRAN, TYRANT [v]\n",
  "TYRANNIS": "(Greek) an illegal regime [n -ES]\n",
  "TYRANNISE": "to act like a tyrant towards, also TYRANNIZE [v TYRANNISED, TYRANNISING, TYRANNISES]\n",
  "TYRANNISED": "TYRANNISE, to act like a tyrant towards, also TYRANNIZE [v]\n",
  "TYRANNISER": "one who tyrannises, also TYRANNIZER [n -S]\n",
  "TYRANNISERS": "TYRANNISER, one who tyrannises, also TYRANNIZER [n]\n",
  "TYRANNISES": "TYRANNIS, (Greek) an illegal regime [n]\n",
  "TYRANNISING": "TYRANNISE, to act like a tyrant towards, also TYRANNIZE [v]\n",
  "TYRANNIZE": "to act like a tyrant towards, also TYRANNISE [v TYRANNIZED, TYRANNIZING, TYRANNIZES]\n",
  "TYRANNIZED": "TYRANNIZE, to act like a tyrant towards, also TYRANNISE [v]\n",
  "TYRANNIZER": "one who tyrannizes, also TYRANNISER [n -S]\n",
  "TYRANNIZERS": "TYRANNIZER, one who tyrannizes, also TYRANNISER [n]\n",
  "TYRANNIZES": "TYRANNIZE, to act like a tyrant towards, also TYRANNISE [v]\n",
  "TYRANNIZING": "TYRANNIZE, to act like a tyrant towards, also TYRANNISE [v]\n",
  "TYRANNOSAUR": "a large carnivorous lizard-hipped dinosaur, common during the Cretaceous period, also TYRANNOSAURUS [n -S]\n",
  "TYRANNOSAURS": "TYRANNOSAUR, a large carnivorous lizard-hipped dinosaur, common during the Cretaceous period, also TYRANNOSAURUS [n]\n",
  "TYRANNOSAURUS": "a large carnivorous lizard-hipped dinosaur, common during the Cretaceous period, also TYRANNOSAUR [n -ES]\n",
  "TYRANNOSAURUSES": "TYRANNOSAURUS, a large carnivorous lizard-hipped dinosaur, common during the Cretaceous period, also TYRANNOSAUR [n]\n",
  "TYRANNOUS": "like a tyrant [adj TYRANNOUSLY]\n",
  "TYRANNOUSLY": "TYRANNOUS, like a tyrant [adv]\n",
  "TYRANNOUSNESS": "the state of being tyrannous [n -ES]\n",
  "TYRANNOUSNESSES": "TYRANNOUSNESS, the state of being tyrannous [n]\n",
  "TYRANNY": "the rule of a tyrant [n TYRANNIES]\n",
  "TYRANS": "TYRAN, to play the oppressor, also TYRANNE, TYRANT [v]\n",
  "TYRANT": "to play the oppressor, also TYRAN, TYRANNE [v -ED, -ING, -S]\n",
  "TYRANTED": "TYRANT, to play the oppressor, also TYRAN, TYRANNE [v]\n",
  "TYRANTING": "TYRANT, to play the oppressor, also TYRAN, TYRANNE [v]\n",
  "TYRANTS": "TYRANT, to play the oppressor, also TYRAN, TYRANNE [v]\n",
  "TYRE": "to supply a covering for a wheel [v TYRED, TYRING, TYRES]\n",
  "TYRED": "TYRE, to supply a covering for a wheel [v]\n",
  "TYRELESS": "without tyres [adj]\n",
  "TYREMAKER": "one who makes tyres [n -S]\n",
  "TYREMAKERS": "TYREMAKER, one who makes tyres [n]\n",
  "TYRES": "TYRE, to supply a covering for a wheel [v]\n",
  "TYRING": "TYRE, to supply a covering for a wheel [v]\n",
  "TYRO": "(Latin) a beginner or novice, also TIRO [n TYROS or TYROES or TYRONES]\n",
  "TYROCIDIN": "a basic polypeptide antibiotic produced by a soil bacillus, also TYROCIDINE [n -S]\n",
  "TYROCIDINE": "a basic polypeptide antibiotic produced by a soil bacillus, also TYROCIDIN [n -S]\n",
  "TYROCIDINES": "TYROCIDINE, a basic polypeptide antibiotic produced by a soil bacillus, also TYROCIDIN [n]\n",
  "TYROCIDINS": "TYROCIDIN, a basic polypeptide antibiotic produced by a soil bacillus, also TYROCIDINE [n]\n",
  "TYROES": "TYRO, (Latin) a beginner or novice, also TIRO [n]\n",
  "TYROGLYPHID": "a mite of the genus Tyroglyphus, including the cheesemite and the flour-mite [n -S]\n",
  "TYROGLYPHIDS": "TYROGLYPHID, a mite of the genus Tyroglyphus, including the cheesemite and the flour-mite [n]\n",
  "TYRONES": "TYRO, (Latin) a beginner or novice, also TIRO [n]\n",
  "TYRONIC": "resembling a tyro, also TIRONIC [adj]\n",
  "TYROPITA": "(Modern Greek) a Greek cheese pie, also TYROPITTA [n -S]\n",
  "TYROPITAS": "TYROPITA, (Modern Greek) a Greek cheese pie, also TYROPITTA [n]\n",
  "TYROPITTA": "(Modern Greek) a Greek cheese pie, also TYROPITA [n -S]\n",
  "TYROPITTAS": "TYROPITTA, (Modern Greek) a Greek cheese pie, also TYROPITA [n]\n",
  "TYROS": "TYRO, (Latin) a beginner or novice, also TIRO [n]\n",
  "TYROSINASE": "an enzyme found in plants and animals [n -S]\n",
  "TYROSINASES": "TYROSINASE, an enzyme found in plants and animals [n]\n",
  "TYROSINE": "an amino acid formed by decomposition of proteins, first obtained from cheese [n -S]\n",
  "TYROSINES": "TYROSINE, an amino acid formed by decomposition of proteins, first obtained from cheese [n]\n",
  "TYROTHRICIN": "an antibiotic mixture consisting chiefly of tyrocidine and gramicidin and used topically especially against gram-positive bacteria [n -S]\n",
  "TYROTHRICINS": "TYROTHRICIN, an antibiotic mixture consisting chiefly of tyrocidine and gramicidin and used topically especially against gram-positive bacteria [n]\n",
  "TYSTIE": "an Orkney and Shetland name for the black guillemot [n -S]\n",
  "TYSTIES": "TYSTIE, an Orkney and Shetland name for the black guillemot [n]\n",
  "TYTE": "(obsolete) promptly, at once, also TITE [adv]\n",
  "TYTHE": "to pay a tenth part used as a small tax, also TITHE [v TYTHED, TYTHING, TYTHES]\n",
  "TYTHED": "TYTHE, to pay a tenth part used as a small tax, also TITHE [v]\n",
  "TYTHES": "TYTHE, to pay a tenth part used as a small tax, also TITHE [v]\n",
  "TYTHING": "TYTHE, to pay a tenth part used as a small tax, also TITHE [v]\n",
  "TZADDI": "(Hebrew) a Hebrew letter, also SADE, SADHE, SADI, TSADE, TSADI [n -S]\n",
  "TZADDIK": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n TZADDIKS or TZADDIKIM]\n",
  "TZADDIKIM": "TZADDIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TZADDIKS": "TZADDIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIQ, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TZADDIQ": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADIK, ZADDICK, ZADDIK [n TZADDIQS or TZADDIQIM]\n",
  "TZADDIQIM": "TZADDIQ, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TZADDIQS": "TZADDIQ, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADIK, ZADDICK, ZADDIK [n]\n",
  "TZADDIS": "TZADDI, (Hebrew) a Hebrew letter, also SADE, SADHE, SADI, TSADE, TSADI [n]\n",
  "TZADIK": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, ZADDICK, ZADDIK [n -S]\n",
  "TZADIKS": "TZADIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, ZADDICK, ZADDIK [n]\n",
  "TZAR": "(Russian) a ruler, emperor, also CZAR, KSAR, TSAR [n -S]\n",
  "TZARDOM": "the domain of a czar, also TSARDOM, CZARDOM [n -S]\n",
  "TZARDOMS": "TZARDOM, the domain of a czar, also TSARDOM, CZARDOM [n]\n",
  "TZAREVNA": "(Russian) the proper title for the daughter of a czar, also CZAREVNA, TSAREVNA [n -S]\n",
  "TZAREVNAS": "TZAREVNA, (Russian) the proper title for the daughter of a czar, also CZAREVNA, TSAREVNA [n]\n",
  "TZARINA": "(Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARITZA [n -S]\n",
  "TZARINAS": "TZARINA, (Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARITZA [n]\n",
  "TZARISM": "government by a tsar, also CZARISM, TSARISM [n -S]\n",
  "TZARISMS": "TZARISM, government by a tsar, also CZARISM, TSARISM [n]\n",
  "TZARIST": "a supporter of tsarism, also CZARIST, TSARIST [n -S]\n",
  "TZARISTS": "TZARIST, a supporter of tsarism, also CZARIST, TSARIST [n]\n",
  "TZARITZA": "(Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARINA [n -S]\n",
  "TZARITZAS": "TZARITZA, (Russian) the empress of Russia, also CZARINA, CZARITSA, CZARITZA, TSARINA, TSARITSA, TSARITZA, TZARINA [n]\n",
  "TZARS": "TZAR, (Russian) a ruler, emperor, also CZAR, KSAR, TSAR [n]\n",
  "TZATZIKI": "(Modern Greek) a Greek dish made of yoghurt and finely sliced or chopped cucumber flavoured with garlic etc. [n -S]\n",
  "TZATZIKIS": "TZATZIKI, (Modern Greek) a Greek dish made of yoghurt and finely sliced or chopped cucumber flavoured with garlic etc. [n]\n",
  "TZEDAKAH": "(Hebrew) charitable giving as a moral obligation among Jews [n -S]\n",
  "TZEDAKAHS": "TZEDAKAH, (Hebrew) charitable giving as a moral obligation among Jews [n]\n",
  "TZETSE": "(Setswana) a small fly that transmits trypanosome parasites, also TSETSE, TZETZE [n -S]\n",
  "TZETSES": "TZETSE, (Setswana) a small fly that transmits trypanosome parasites, also TSETSE, TZETZE [n]\n",
  "TZETZE": "(Setswana) a small fly that transmits trypanosome parasites, also TSETSE, TZETSE [n -S]\n",
  "TZETZES": "TZETZE, (Setswana) a small fly that transmits trypanosome parasites, also TSETSE, TZETSE [n]\n",
  "TZIGANE": "(Hungarian) a gypsy, also TSIGANE, TZIGANY, ZIGAN [n -S]\n",
  "TZIGANES": "TZIGANE, (Hungarian) a gypsy, also TSIGANE, TZIGANY, ZIGAN [n]\n",
  "TZIGANIES": "TZIGANY, (Hungarian) a gypsy, also TSIGANE, TZIGANE, ZIGAN [n]\n",
  "TZIGANY": "(Hungarian) a gypsy, also TSIGANE, TZIGANE, ZIGAN [n TZIGANIES]\n",
  "TZIMMES": "(Yiddish) a sweetened stew of vegetables, fruit and meat, also TSIMMES [n TZIMMES]\n",
  "TZITZIS": "(Hebrew) the tassels on the four corners of a Jewish prayer shawl, also TSITSITH, TZITZIT, TZITZITH, ZIZIT, ZIZITH [n]\n",
  "TZITZIT": "(Hebrew) the tassels on the four corners of a Jewish prayer shawl, also TSITSITH, TZITZIS, TZITZITH, ZIZIT, ZIZITH [n]\n",
  "TZITZITH": "(Hebrew) the tassels on the four corners of a Jewish prayer shawl, also TSITSITH, TZITZIS, TZITZIT, ZIZIT, ZIZITH [n]\n",
  "TZURIS": "(Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSORRISS, TSOURIS, TSURIS [n -ES]\n",
  "TZURISES": "TZURIS, (Yiddish) grief, woe, also TSOORIS, TSORES, TSORIS, TSORRISS, TSOURIS, TSURIS [n]\n",
  "UAKARI": "(Tupi) a short-tailed, longhaired monkey, also OUAKARI [n -S]\n",
  "UAKARIS": "UAKARI, (Tupi) a short-tailed, longhaired monkey, also OUAKARI [n]\n",
  "UBEROUS": "abounding in milk [adj]\n",
  "UBERSEXUAL": "a male who is similar to a metrosexual but displays the traditional manly qualities such as confidence, strength etc. [n -S]\n",
  "UBERSEXUALS": "UBERSEXUAL, a male who is similar to a metrosexual but displays the traditional manly qualities such as confidence, strength etc. [n]\n",
  "UBERTIES": "UBERTY, fruitfulness [n]\n",
  "UBERTY": "fruitfulness [n UBERTIES]\n",
  "UBIETIES": "UBIETY, the state of having a definite location [n]\n",
  "UBIETY": "the state of having a definite location [n UBIETIES]\n",
  "UBIQUARIAN": "ubiquitous [adj]\n",
  "UBIQUE": "(Latin) everywhere [adv]\n",
  "UBIQUINONE": "a quinine used involved in the transfer of electrons during cell respiration [n -S]\n",
  "UBIQUINONES": "UBIQUINONE, a quinine used involved in the transfer of electrons during cell respiration [n]\n",
  "UBIQUITARIAN": "one who believes that Christ's body is everywhere, not just in the Eucharist [n -S]\n",
  "UBIQUITARIANISM": "the Lutheran doctrine that holds that Christ is no more present in the elements of the Eucharist than elsewhere, as he is present in all places at all times [n]\n",
  "UBIQUITARIANS": "UBIQUITARIAN, one who believes that Christ's body is everywhere, not just in the Eucharist [n]\n",
  "UBIQUITARY": "being everywhere at once, also UBIQUITOUS [adj]\n",
  "UBIQUITIES": "UBIQUITY, the state of being everywhere at the same time [n]\n",
  "UBIQUITIN": "a type of polypeptide [n -S]\n",
  "UBIQUITINATION": "the process of making ubiquitous [n -S]\n",
  "UBIQUITINATIONS": "UBIQUITINATION, the process of making ubiquitous [n]\n",
  "UBIQUITINS": "UBIQUITIN, a type of polypeptide [n]\n",
  "UBIQUITOUS": "being everywhere at once, also UBIQUITARY [adj UBIQUITOUSLY]\n",
  "UBIQUITOUSLY": "UBIQUITOUS, being everywhere at once, also UBIQUITARY [adv]\n",
  "UBIQUITOUSNESS": "UBIQUITOUS, being everywhere at once, also UBIQUITARY [n]\n",
  "UBIQUITY": "the state of being everywhere at the same time [n UBIQUITIES]\n",
  "UBUNTU": "(Xhosa) a quality of humanity and compassion [n -S]\n",
  "UBUNTUS": "UBUNTU, (Xhosa) a quality of humanity and compassion [n]\n",
  "UCKERS": "a form of the game ludo, played in the Navy [n]\n",
  "UDAL": "a Scottish estate held by the old native form of freehold tenure without feudal superior, also ODAL [n -S]\n",
  "UDALLER": "a holder of an udal estate, also ODALLER [n -S]\n",
  "UDALLERS": "UDALLER, a holder of an udal estate, also ODALLER [n]\n",
  "UDALS": "UDAL, a Scottish estate held by the old native form of freehold tenure without feudal superior, also ODAL [n]\n",
  "UDDER": "a mammary gland [n -S]\n",
  "UDDERED": "having an udder [adj]\n",
  "UDDERFUL": "the contents of a full udder [n -S]\n",
  "UDDERFULS": "UDDERFUL, the contents of a full udder [n]\n",
  "UDDERLESS": "destitute or deprived of an udder [adj]\n",
  "UDDERS": "UDDER, a mammary gland [n]\n",
  "UDO": "(Japanese) a Japanese species of aralia [n -S]\n",
  "UDOMETER": "a rain gauge [n -S]\n",
  "UDOMETERS": "UDOMETER, a rain gauge [n]\n",
  "UDOMETRIC": "related to the measurement of rain [adj]\n",
  "UDOMETRIES": "UDOMETRY, the measurement of rain [n]\n",
  "UDOMETRY": "the measurement of rain [n UDOMETRIES]\n",
  "UDON": "(Japanese) in Japanese cooking, large noodles of wheat flour [n -S]\n",
  "UDONS": "UDON, (Japanese) in Japanese cooking, large noodles of wheat flour [n]\n",
  "UDOS": "UDO, (Japanese) a Japanese species of aralia [n]\n",
  "UDS": "(archaic) an old interjection meaning 'God Save' [interj]\n",
  "UEY": "(Australian slang) a U-turn [n -S]\n",
  "UEYS": "UEY, (Australian slang) a U-turn [n]\n",
  "UFO": "an unidentified flying object [n -S]\n",
  "UFOLOGICAL": "relating to ufology [adj]\n",
  "UFOLOGIES": "UFOLOGY, the study of unidentified flying objects [n]\n",
  "UFOLOGIST": "one interested in ufos [n -S]\n",
  "UFOLOGISTS": "UFOLOGIST, one interested in ufos [n]\n",
  "UFOLOGY": "the study of unidentified flying objects [n UFOLOGIES]\n",
  "UFOS": "UFO, an unidentified flying object [n]\n",
  "UG": "to arouse loathing in [v UGGED, UGGING, UGS]\n",
  "UGALI": "(Swahili) an African type of stiff porridge [n -S]\n",
  "UGALIS": "UGALI, (Swahili) an African type of stiff porridge [n]\n",
  "UGGED": "UG, to arouse loathing in [v]\n",
  "UGGING": "UG, to arouse loathing in [v]\n",
  "UGH": "the sound of a cough or grunt [n -S]\n",
  "UGHS": "UGH, the sound of a cough or grunt [n]\n",
  "UGLIED": "UGLY, to make ugly [v]\n",
  "UGLIER": "UGLY, not beautiful [adj]\n",
  "UGLIES": "UGLY, to make ugly [v]\n",
  "UGLIEST": "UGLY, not beautiful [adj]\n",
  "UGLIFICATION": "the act of uglifying [n -S]\n",
  "UGLIFICATIONS": "UGLIFICATION, the act of uglifying [n]\n",
  "UGLIFIED": "UGLIFY, to make ugly [v]\n",
  "UGLIFIER": "something or someone that uglifies [n -S]\n",
  "UGLIFIERS": "UGLIFIER, something or someone that uglifies [n]\n",
  "UGLIFIES": "UGLIFY, to make ugly [v]\n",
  "UGLIFY": "to make ugly [v UGLIFIED, UGLIFYING, UGLIFIES]\n",
  "UGLIFYING": "UGLIFY, to make ugly [v]\n",
  "UGLILY": "UGLY, not beautiful [adv]\n",
  "UGLINESS": "the state of being ugly [n -ES]\n",
  "UGLINESSES": "UGLINESS, the state of being ugly [n]\n",
  "UGLY": "not beautiful [adj UGLIER, UGLIEST, UGLILY] / to make ugly [v UGLIED, UGLYING, UGLIES]\n",
  "UGLYING": "UGLY, to make ugly [v]\n",
  "UGS": "UG, to arouse loathing in [v]\n",
  "UGSOME": "(obsolete) frightful, loathsome [adj]\n",
  "UGSOMENESS": "(obsolete) the state of being ugsome, frightful, loathsome [n -ES]\n",
  "UGSOMENESSES": "UGSOMENESS, (obsolete) the state of being ugsome, frightful, loathsome [n]\n",
  "UH": "used to express hesitation [interj]\n",
  "UHLAN": "(German) a light cavalryman in semi-oriental uniform; a Prussian lancer, also ULAN [n -S]\n",
  "UHLANS": "UHLAN, (German) a light cavalryman in semi-oriental uniform; a Prussian lancer, also ULAN [n]\n",
  "UHURU": "(Swahili) freedom, national independence [n -S]\n",
  "UHURUS": "UHURU, (Swahili) freedom, national independence [n]\n",
  "UILLEAN": "(Irish) as in uillean pipes, a kind of bagpipes developed in Ireland and operated by squeezing bellows under the arm, also UILLEANN [adj]\n",
  "UILLEANN": "(Irish) as in uilleann pipes, a kind of bagpipes developed in Ireland and operated by squeezing bellows under the arm, also UILLEAN [adj]\n",
  "UINTAHITE": "a tar-like asphalt found in the Uinta valley, Utah, also UINTAITE [n -S]\n",
  "UINTAHITES": "UINTAHITE, a tar-like asphalt found in the Uinta valley, Utah, also UINTAITE [n]\n",
  "UINTAITE": "a tar-like asphalt found in the Uinta valley, Utah, also UINTAHITE [n -S]\n",
  "UINTAITES": "UINTAITE, a tar-like asphalt found in the Uinta valley, Utah, also UINTAHITE [n]\n",
  "UINTATHERE": "any animal of the genus Uintatherium, gigantic fossil ungulates [n -S]\n",
  "UINTATHERES": "UINTATHERE, any animal of the genus Uintatherium, gigantic fossil ungulates [n]\n",
  "UITLANDER": "(South African) in South Africa, a foreigner, esp. a Briton in the Transvaal, also OUTLANDER [n -S]\n",
  "UITLANDERS": "UITLANDER, (South African) in South Africa, a foreigner, esp. a Briton in the Transvaal, also OUTLANDER [n]\n",
  "UJAMAA": "(Swahili) in Tanzania, a form of village community resembling the Israeli kibbutz [n -S]\n",
  "UJAMAAS": "UJAMAA, (Swahili) in Tanzania, a form of village community resembling the Israeli kibbutz [n]\n",
  "UKASE": "(Russian) a proclamation by a Russian emperor or government having the force of law [n -S]\n",
  "UKASES": "UKASE, (Russian) a proclamation by a Russian emperor or government having the force of law [n]\n",
  "UKE": "(short for) ukelele, a small guitar-like instrument [n -S]\n",
  "UKELELE": "(Hawaiian) a small guitar-like instrument, also UKE, UKULELE [n -S]\n",
  "UKELELES": "UKELELE, (Hawaiian) a small guitar-like instrument, also UKE, UKULELE [n]\n",
  "UKES": "UKE, (short for) ukelele, a small guitar-like instrument [n]\n",
  "UKULELE": "(Hawaiian) a small guitar-like instrument, also UKELELE, UKE [n -S]\n",
  "UKULELES": "UKULELE, (Hawaiian) a small guitar-like instrument, also UKELELE, UKE [n]\n",
  "ULAMA": "(Arabic) the body of professional theologians, expounders of the law, in a Muslim country, also ULEMA [n -S]\n",
  "ULAMAS": "ULAMA, (Arabic) the body of professional theologians, expounders of the law, in a Muslim country, also ULEMA [n]\n",
  "ULAN": "(German) a light cavalryman in semi-oriental uniform; a Prussian lancer, also UHLAN [n -S]\n",
  "ULANS": "ULAN, (German) a light cavalryman in semi-oriental uniform; a Prussian lancer, also UHLAN [n]\n",
  "ULCER": "to affect with a type of lesion, also ULCERATE [v -ED, -ING, -S]\n",
  "ULCERATE": "to affect with a type of lesion, also ULCER [v ULCERATED, ULCERATING, ULCERATES]\n",
  "ULCERATED": "ULCERATE, to affect with a type of lesion, also ULCER [v]\n",
  "ULCERATES": "ULCERATE, to affect with a type of lesion, also ULCER [v]\n",
  "ULCERATING": "ULCERATE, to affect with a type of lesion, also ULCER [v]\n",
  "ULCERATION": "the process of becoming ulcerated [n -S]\n",
  "ULCERATIONS": "ULCERATION, the process of becoming ulcerated [n]\n",
  "ULCERATIVE": "related to ulcers [adj]\n",
  "ULCERED": "ULCER, to affect with a type of lesion, also ULCERATE [v]\n",
  "ULCERING": "ULCER, to affect with a type of lesion, also ULCERATE [v]\n",
  "ULCEROGENIC": "tending to produce or develop into ulcers or ulceration [adj]\n",
  "ULCEROUS": "being affected with an ulcer [adj ULCEROUSLY]\n",
  "ULCEROUSLY": "ULCEROUS, being affected with an ulcer [adv]\n",
  "ULCEROUSNESS": "the state of being ulcerous [n -ES]\n",
  "ULCEROUSNESSES": "ULCEROUSNESS, the state of being ulcerous [n]\n",
  "ULCERS": "ULCER, to affect with a type of lesion, also ULCERATE [v]\n",
  "ULE": "a Central American rubber tree, also HULE [n -S]\n",
  "ULEMA": "(Arabic) the body of professional theologians, expounders of the law, in a Muslim country, also ULAMA [n -S]\n",
  "ULEMAS": "ULEMA, (Arabic) the body of professional theologians, expounders of the law, in a Muslim country, also ULAMA [n]\n",
  "ULES": "ULE, a Central American rubber tree, also HULE [n]\n",
  "ULEX": "(Latin) any plant of the gorse genus Ulex [n ULEXES or ULICES]\n",
  "ULEXES": "ULEX, (Latin) any plant of the gorse genus Ulex [n]\n",
  "ULEXITE": "a hydrous borate of lime and soda occurring in white rounded crystalline masses [n -S]\n",
  "ULEXITES": "ULEXITE, a hydrous borate of lime and soda occurring in white rounded crystalline masses [n]\n",
  "ULICES": "ULEX, (Latin) any plant of the gorse genus Ulex [n]\n",
  "ULICON": "(Native American) the north Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULIKON [n -S]\n",
  "ULICONS": "ULICON, (Native American) the north Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULIKON [n]\n",
  "ULIGINOSE": "slimy; oozy; growing in swampy places, also ULIGINOUS [adj]\n",
  "ULIGINOUS": "slimy; oozy; growing in swampy places, also ULIGINOSE [adj]\n",
  "ULIKON": "(Native American) the north Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON [n -S]\n",
  "ULIKONS": "ULIKON, (Native American) the north Pacific candlefish, also EULACHAN, EULACHON, OOLACHAN, OOLAKAN, OOLICHAN, OULACHON, OULAKAN, ULICON [n]\n",
  "ULITIS": "inflammation of the gums [n -ES]\n",
  "ULITISES": "ULITIS, inflammation of the gums [n]\n",
  "ULLAGE": "to reckon the leakage or evaporation of [v ULLAGED, ULLAGING, ULLAGES]\n",
  "ULLAGED": "ULLAGE, to reckon the leakage or evaporation of [v]\n",
  "ULLAGES": "ULLAGE, to reckon the leakage or evaporation of [v]\n",
  "ULLAGING": "ULLAGE, to reckon the leakage or evaporation of [v]\n",
  "ULLING": "the making good of ullage [n -S]\n",
  "ULLINGS": "ULLING, the making good of ullage [n]\n",
  "ULMACEOUS": "of or like elms [adj]\n",
  "ULMIN": "a brown amorphous substance found in decaying vegetation [n -S]\n",
  "ULMINS": "ULMIN, a brown amorphous substance found in decaying vegetation [n]\n",
  "ULNA": "(Latin) the inner and larger of the two bones of the forearm [n ULNAS or ULNAE]\n",
  "ULNAD": "toward the ulna, the inner and larger of the two bones of the forearm [adj]\n",
  "ULNAE": "ULNA, (Latin) the inner and larger of the two bones of the forearm [n]\n",
  "ULNAR": "pertaining to the ulna, the inner and larger of the two bones of the forearm [adj]\n",
  "ULNARE": "(Latin) one of the bones or cartilages of the carpus, which articulates with the ulna and corresponds to the cuneiform in man [n ULNARIA]\n",
  "ULNARIA": "ULNARE, (Latin) one of the bones or cartilages of the carpus, which articulates with the ulna and corresponds to the cuneiform in man [n]\n",
  "ULNAS": "ULNA, (Latin) the inner and larger of the two bones of the forearm [n]\n",
  "ULOSES": "ULOSIS, (Greek) scar formation [n]\n",
  "ULOSIS": "(Greek) scar formation [n ULOSES]\n",
  "ULOTRICHIES": "ULOTRICHY, the state of being woolly-haired [n]\n",
  "ULOTRICHOUS": "having wooly or crisply curling hair [adj]\n",
  "ULOTRICHY": "the state of being woolly-haired [n ULOTRICHIES]\n",
  "ULPAN": "(Hebrew) a school in Israel for teaching Hebrew [n ULPANIM]\n",
  "ULPANIM": "ULPAN, (Hebrew) a school in Israel for teaching Hebrew [n]\n",
  "ULSTER": "a long, loose overcoat [n -S]\n",
  "ULSTERED": "wearing an ulster [adj]\n",
  "ULSTERETTE": "a light ulster [n -S]\n",
  "ULSTERETTES": "ULSTERETTE, a light ulster [n]\n",
  "ULSTERS": "ULSTER, a long, loose overcoat [n]\n",
  "ULTERIOR": "(Latin) of e.g. a motive, beyond what is stated or apparent [adj]\n",
  "ULTERIORLY": "ULTERIOR, (Latin) of e.g. a motive, beyond what is stated or apparent [adv]\n",
  "ULTIMA": "(Latin) the last syllable of a word [n -S]\n",
  "ULTIMACIES": "ULTIMACY, the state of being ultimate [n]\n",
  "ULTIMACY": "the state of being ultimate [n ULTIMACIES]\n",
  "ULTIMAS": "ULTIMA, (Latin) the last syllable of a word [n]\n",
  "ULTIMATA": "ULTIMATUM, (Latin) a last offer, or demand [n]\n",
  "ULTIMATE": "final [adj ULTIMATELY] / to bring or come to an end; to finish [v ULTIMATED, ULTIMATING, ULTIMATES]\n",
  "ULTIMATED": "ULTIMATE, to bring or come to an end; to finish [v]\n",
  "ULTIMATELY": "ULTIMATE, final [adv]\n",
  "ULTIMATENESS": "the state of being ultimate [n -ES]\n",
  "ULTIMATENESSES": "ULTIMATENESS, the state of being ultimate [n]\n",
  "ULTIMATES": "ULTIMATE, to bring or come to an end; to finish [v]\n",
  "ULTIMATING": "ULTIMATE, to bring or come to an end; to finish [v]\n",
  "ULTIMATUM": "(Latin) a last offer, or demand [n ULTIMATUMS or ULTIMATA]\n",
  "ULTIMATUMS": "ULTIMATUM, (Latin) a last offer, or demand [n]\n",
  "ULTIMO": "(Latin) of or occurring in the preceding month [adj]\n",
  "ULTIMOGENITURE": "inheritance by the youngest child [n -S]\n",
  "ULTIMOGENITURES": "ULTIMOGENITURE, inheritance by the youngest child [n]\n",
  "ULTION": "(obsolete) vengeance [n -S]\n",
  "ULTIONS": "ULTION, (obsolete) vengeance [n]\n",
  "ULTISOL": "a reddish-yellow acid soil [n -S]\n",
  "ULTISOLS": "ULTISOL, a reddish-yellow acid soil [n]\n",
  "ULTRA": "(Latin) an advocate of extreme measures, also ULTRAIST [n -S]\n",
  "ULTRABASIC": "very poor in silica [adj] / a rock very poor in silica [n -S]\n",
  "ULTRABASICS": "ULTRABASIC, a rock very poor in silica [n]\n",
  "ULTRACAREFUL": "very very careful [adj]\n",
  "ULTRACASUAL": "very casual [adj]\n",
  "ULTRACAUTIOUS": "extremely cautious [adj]\n",
  "ULTRACENTRIFUGE": "to subject to the action of an ultracentrifuge, a very high-speed type of centrifuge [v]\n",
  "ULTRACHIC": "very very chic [adj]\n",
  "ULTRACIVILISED": "extremely civilised, also ULTRACIVILIZED [adj]\n",
  "ULTRACIVILIZED": "extremely civilized, also ULTRACIVILISED [adj]\n",
  "ULTRACLEAN": "very very clean [adj]\n",
  "ULTRACOLD": "very very cold [adj]\n",
  "ULTRACOMMERCIAL": "extremely commercial [adj]\n",
  "ULTRACOMPACT": "extremely compact [adj]\n",
  "ULTRACOMPETENT": "extremely competent [adj]\n",
  "ULTRACONVENIENT": "extremely convenient [adj]\n",
  "ULTRACOOL": "very very cool [adj]\n",
  "ULTRACREPIDATE": "to criticize beyond sphere of one's knowledge [v ULTRACREPIDATED, ULTRACREPIDATES]\n",
  "ULTRACREPIDATED": "ULTRACREPIDATE, to criticize beyond sphere of one's knowledge [v]\n",
  "ULTRACREPIDATES": "ULTRACREPIDATE, to criticize beyond sphere of one's knowledge [v]\n",
  "ULTRACRITICAL": "extremely critical [adj]\n",
  "ULTRADEMOCRATIC": "extremely democratic [adj]\n",
  "ULTRADENSE": "very very dense [adj]\n",
  "ULTRADISTANCE": "of running events, over an extreme distance [adj]\n",
  "ULTRADISTANT": "extremely distant [adj]\n",
  "ULTRADRIER": "ULTRADRY, very very dry [adj]\n",
  "ULTRADRIEST": "ULTRADRY, very very dry [adj]\n",
  "ULTRADRY": "very very dry [adj ULTRADRIER or ULTRADRYER, ULTRADRIEST or ULTRADRYEST]\n",
  "ULTRADRYER": "ULTRADRY, very very dry [adj]\n",
  "ULTRADRYEST": "ULTRADRY, very very dry [adj]\n",
  "ULTRAEFFICIENT": "extremely efficient [adj]\n",
  "ULTRAENERGETIC": "extremely energetic [adj]\n",
  "ULTRAEXCLUSIVE": "extremely exclusive [adj]\n",
  "ULTRAFAMILIAR": "extremely familiar [adj]\n",
  "ULTRAFAST": "very fast [adj]\n",
  "ULTRAFASTIDIOUS": "extremely fastidious [adj]\n",
  "ULTRAFEMININE": "extremely feminine [adj]\n",
  "ULTRAFICHE": "a sheet of microfilm the same size as a microfiche but with a greater number of microcopied records on it [n -S]\n",
  "ULTRAFICHES": "ULTRAFICHE, a sheet of microfilm the same size as a microfiche but with a greater number of microcopied records on it [n]\n",
  "ULTRAFILTER": "an extremely fine filter which retains particles as fine as large molecules [n -S] / to pass through an ultrafilter [v -ED, -ING, -S]\n",
  "ULTRAFILTERED": "ULTRAFILTER, to pass through an ultrafilter [v]\n",
  "ULTRAFILTERING": "ULTRAFILTER, to pass through an ultrafilter [v]\n",
  "ULTRAFILTERS": "ULTRAFILTER, to pass through an ultrafilter [v]\n",
  "ULTRAFILTRATE": "a substance that has passed through an ultrafilter [n -S]\n",
  "ULTRAFILTRATES": "ULTRAFILTRATE, a substance that has passed through an ultrafilter [n]\n",
  "ULTRAFILTRATION": "filtration through a medium (as a semipermeable capillary wall) which allows small molecules (as of water) to pass but holds back larger ones (as of protein) [n]\n",
  "ULTRAFINE": "very very fine [adj]\n",
  "ULTRAGLAMOROUS": "extremely glamorous [adj]\n",
  "ULTRAHAZARDOUS": "extremely hazardous [adj]\n",
  "ULTRAHEAT": "to heat to very high temperatures, as used for sterilisation [v -ED, -ING, -S]\n",
  "ULTRAHEATED": "ULTRAHEAT, to heat to very high temperatures, as used for sterilisation [v]\n",
  "ULTRAHEATING": "ULTRAHEAT, to heat to very high temperatures, as used for sterilisation [v]\n",
  "ULTRAHEATS": "ULTRAHEAT, to heat to very high temperatures, as used for sterilisation [v]\n",
  "ULTRAHEAVIER": "ULTRAHEAVY, very very heavy [adj]\n",
  "ULTRAHEAVIEST": "ULTRAHEAVY, very very heavy [adj]\n",
  "ULTRAHEAVY": "very very heavy [adj ULTRAHEAVIER, ULTRAHEAVIEST]\n",
  "ULTRAHIGH": "very very high [adj]\n",
  "ULTRAHIP": "extremely hip [adj]\n",
  "ULTRAHOT": "extremely hot [adj]\n",
  "ULTRAHUMAN": "beyond human [adj]\n",
  "ULTRAISM": "advocacy of extreme measures [n -S]\n",
  "ULTRAISMS": "ULTRAISM, advocacy of extreme measures [n]\n",
  "ULTRAIST": "an advocate of extreme measures, also ULTRA [n -S]\n",
  "ULTRAISTIC": "relating to ultraism, the principles of those who advocate extreme measures, as radical reform, and the like [adj]\n",
  "ULTRAISTS": "ULTRAIST, an advocate of extreme measures, also ULTRA [n]\n",
  "ULTRALARGE": "very very large [adj]\n",
  "ULTRALEFT": "the very far left in politics [n -S]\n",
  "ULTRALEFTISM": "support of the extreme left [n -S]\n",
  "ULTRALEFTISMS": "ULTRALEFTISM, support of the extreme left [n]\n",
  "ULTRALEFTIST": "one who supports the extreme Left [n -S]\n",
  "ULTRALEFTISTS": "ULTRALEFTIST, one who supports the extreme Left [n]\n",
  "ULTRALEFTS": "ULTRALEFT, the very far left in politics [n]\n",
  "ULTRALIBERAL": "one who is extremely liberal in politics [n -S]\n",
  "ULTRALIBERALISM": "extreme liberalism [n]\n",
  "ULTRALIBERALS": "ULTRALIBERAL, one who is extremely liberal in politics [n]\n",
  "ULTRALIGHT": "a very light aircraft [n -S]\n",
  "ULTRALIGHTS": "ULTRALIGHT, a very light aircraft [n]\n",
  "ULTRALOW": "extremely low [adj]\n",
  "ULTRAMAFIC": "of rocks, very mafic [adj]\n",
  "ULTRAMARATHON": "a footrace longer than a marathon [n -S]\n",
  "ULTRAMARATHONER": "one who runs an ultramarathon, a footrace longer than a marathon [n]\n",
  "ULTRAMARATHONS": "ULTRAMARATHON, a footrace longer than a marathon [n]\n",
  "ULTRAMARINE": "a greenish-blue color or pigment [n -S]\n",
  "ULTRAMARINES": "ULTRAMARINE, a greenish-blue color or pigment [n]\n",
  "ULTRAMASCULINE": "extremely masculine [adj]\n",
  "ULTRAMICRO": "smaller than micro e.g. ultramicrochemistry, dealing with minute quantities [adj]\n",
  "ULTRAMICROMETER": "a micrometer for measuring extremely small distances [n]\n",
  "ULTRAMICROSCOPE": "an instrument for viewing extremely small objects [n]\n",
  "ULTRAMICROSCOPY": "microscopy using an ultramicroscope [n]\n",
  "ULTRAMICROTOME": "a microtome for cutting extremely thin sections for electron microscopy [n -S]\n",
  "ULTRAMICROTOMES": "ULTRAMICROTOME, a microtome for cutting extremely thin sections for electron microscopy [n]\n",
  "ULTRAMICROTOMY": "the use of an ultramicrotome [n]\n",
  "ULTRAMILITANT": "one who is exceptionally militant [n -S]\n",
  "ULTRAMILITANTS": "ULTRAMILITANT, one who is exceptionally militant [n]\n",
  "ULTRAMINIATURE": "extremely miniature [adj]\n",
  "ULTRAMODERN": "very very modern [adj]\n",
  "ULTRAMODERNISM": "an artistic movement beyond modernism [n -S]\n",
  "ULTRAMODERNISMS": "ULTRAMODERNISM, an artistic movement beyond modernism [n]\n",
  "ULTRAMODERNIST": "one who practises ultramodernism [n -S]\n",
  "ULTRAMODERNISTS": "ULTRAMODERNIST, one who practises ultramodernism [n]\n",
  "ULTRAMONTANE": "beyond (i.e. south of) the Alps; supporting the supremacy of the Pope [adj] / one who supports the supremacy of the Pope [n -S]\n",
  "ULTRAMONTANES": "ULTRAMONTANE, one who supports the supremacy of the Pope [n]\n",
  "ULTRAMONTANISM": "the act of supporting the supremacy of the Pope [n -S]\n",
  "ULTRAMONTANISMS": "ULTRAMONTANISM, the act of supporting the supremacy of the Pope [n]\n",
  "ULTRAMONTANIST": "one who lives beyond the mountains [n -S]\n",
  "ULTRAMONTANISTS": "ULTRAMONTANIST, one who lives beyond the mountains [n]\n",
  "ULTRAMUNDANE": "situated beyond the world, or beyond the limits of the solar system [adj]\n",
  "ULTRANATIONAL": "beyond national [adj]\n",
  "ULTRAORTHODOX": "extremely orthodox [adj]\n",
  "ULTRAPATRIOTIC": "extremely patriotic [adj]\n",
  "ULTRAPHYSICAL": "extremely physical [adj]\n",
  "ULTRAPOSH": "very very posh [adj]\n",
  "ULTRAPOWERFUL": "very very powerful [adj]\n",
  "ULTRAPRACTICAL": "extremely practical [adj]\n",
  "ULTRAPRECISE": "extremely precise [adj]\n",
  "ULTRAPRECISION": "extreme precision [n -S]\n",
  "ULTRAPRECISIONS": "ULTRAPRECISION, extreme precision [n]\n",
  "ULTRAPURE": "very very pure [adj]\n",
  "ULTRAQUIET": "very very quiet [adj]\n",
  "ULTRARADICAL": "extremely radical [adj] / one who is extremely radical [n -S]\n",
  "ULTRARADICALS": "ULTRARADICAL, one who is extremely radical [n]\n",
  "ULTRARAPID": "very very rapid [adj]\n",
  "ULTRARARE": "very very rare [adj]\n",
  "ULTRARAREFIED": "exceptionally rarefied [adj]\n",
  "ULTRARATIONAL": "extremely rational [adj]\n",
  "ULTRAREALISM": "extreme realism [n -S]\n",
  "ULTRAREALISMS": "ULTRAREALISM, extreme realism [n]\n",
  "ULTRAREALIST": "a proponent of ultrarealism [n -S]\n",
  "ULTRAREALISTIC": "extremely realistic [adj]\n",
  "ULTRAREALISTS": "ULTRAREALIST, a proponent of ultrarealism [n]\n",
  "ULTRARED": "a part of the visible spectrum, also INFRARED [n -S]\n",
  "ULTRAREDS": "ULTRARED, a part of the visible spectrum, also INFRARED [n]\n",
  "ULTRAREFINED": "extremely refined [adj]\n",
  "ULTRARELIABLE": "extremely reliable [adj]\n",
  "ULTRARICH": "very very rich [adj]\n",
  "ULTRARIGHT": "in politics, the far right [n -S]\n",
  "ULTRARIGHTISM": "adherence to extreme right-wing policies [n -S]\n",
  "ULTRARIGHTISMS": "ULTRARIGHTISM, adherence to extreme right-wing policies [n]\n",
  "ULTRARIGHTIST": "an extreme conservative [n -S]\n",
  "ULTRARIGHTISTS": "ULTRARIGHTIST, an extreme conservative [n]\n",
  "ULTRARIGHTS": "ULTRARIGHT, in politics, the far right [n]\n",
  "ULTRAROMANTIC": "extremely romantic [adj]\n",
  "ULTRAROYALIST": "an extreme royalist [n -S]\n",
  "ULTRAROYALISTS": "ULTRAROYALIST, an extreme royalist [n]\n",
  "ULTRAS": "ULTRA, (Latin) an advocate of extreme measures, also ULTRAIST [n]\n",
  "ULTRASAFE": "very very safe [adj]\n",
  "ULTRASECRET": "extremely secret [adj]\n",
  "ULTRASENSITIVE": "extremely sensitive [adj]\n",
  "ULTRASENSUAL": "extremely sensual [adj]\n",
  "ULTRASERIOUS": "extremely serious [adj]\n",
  "ULTRASHARP": "very very sharp [adj]\n",
  "ULTRASHORT": "very very short [adj]\n",
  "ULTRASIMPLE": "extremely simple [adj]\n",
  "ULTRASLICK": "very very slick [adj]\n",
  "ULTRASLOW": "very very slow [adj]\n",
  "ULTRASMALL": "very very small [adj]\n",
  "ULTRASMART": "very very smart [adj]\n",
  "ULTRASMOOTH": "very very smooth [adj]\n",
  "ULTRASOFT": "very very soft [adj]\n",
  "ULTRASONIC": "denoting airwaves or vibrations with frequencies higher than those audible to the human ear [adj ULTRASONICALLY]\n",
  "ULTRASONICALLY": "ULTRASONIC, denoting airwaves or vibrations with frequencies higher than those audible to the human ear [adv]\n",
  "ULTRASONICS": "the study and use of ultrasonic waves [n]\n",
  "ULTRASONOGRAPHY": "the use of ultrasound [n]\n",
  "ULTRASOUND": "vibrations of the same physical nature as sound but with frequencies above the range of human hearing [n -S]\n",
  "ULTRASOUNDS": "ULTRASOUND, vibrations of the same physical nature as sound but with frequencies above the range of human hearing [n]\n",
  "ULTRASTRUCTURAL": "relating to ultrastructure [adj]\n",
  "ULTRASTRUCTURE": "biological structure and esp. fine structure, as of a cell, not visible through an ordinary microscope [n -S]\n",
  "ULTRASTRUCTURES": "ULTRASTRUCTURE, biological structure and esp. fine structure, as of a cell, not visible through an ordinary microscope [n]\n",
  "ULTRATHIN": "very very thin [adj]\n",
  "ULTRATINIER": "ULTRATINY, very very tiny [adj]\n",
  "ULTRATINIEST": "ULTRATINY, very very tiny [adj]\n",
  "ULTRATINY": "very very tiny [adj ULTRATINIER, ULTRATINIEST]\n",
  "ULTRAVACUA": "ULTRAVACUUM, an extreme vacuum [n]\n",
  "ULTRAVACUUM": "an extreme vacuum [n ULTRAVACUA or ULTRAVACUUMS]\n",
  "ULTRAVACUUMS": "ULTRAVACUUM, an extreme vacuum [n]\n",
  "ULTRAVIOLENCE": "extreme violence [n -S]\n",
  "ULTRAVIOLENCES": "ULTRAVIOLENCE, extreme violence [n]\n",
  "ULTRAVIOLENT": "extremely violent [adj]\n",
  "ULTRAVIOLET": "the part of the spectrum beyond the visible spectrum at its violet end [n -S]\n",
  "ULTRAVIOLETS": "ULTRAVIOLET, the part of the spectrum beyond the visible spectrum at its violet end [n]\n",
  "ULTRAVIRILE": "very very virile [adj]\n",
  "ULTRAVIRILITIES": "ULTRAVIRILITY, the state of being ultravirile [n]\n",
  "ULTRAVIRILITY": "the state of being ultravirile [n ULTRAVIRILITIES]\n",
  "ULTRAVIRUS": "a virus small enough to pass through the finest filter [n -ES]\n",
  "ULTRAVIRUSES": "ULTRAVIRUS, a virus small enough to pass through the finest filter [n]\n",
  "ULTRAWIDE": "very very wide [adj]\n",
  "ULTRAWIDEBAND": "a very broad bandwidth [n -S]\n",
  "ULTRAWIDEBANDS": "ULTRAWIDEBAND, a very broad bandwidth [n]\n",
  "ULTRONEOUS": "spontaneous, voluntary [adj ULTRONEOUSLY]\n",
  "ULTRONEOUSLY": "ULTRONEOUS, spontaneous, voluntary [adv]\n",
  "ULTRONEOUSNESS": "the state of being ultroneous, spontaneous [n]\n",
  "ULU": "(Inuit) an Inuit knife [n -S]\n",
  "ULULANT": "howling [adj]\n",
  "ULULATE": "to lament loudly and shrilly [v ULULATED, ULULATING, ULULATES]\n",
  "ULULATED": "ULULATE, to lament loudly and shrilly [v]\n",
  "ULULATES": "ULULATE, to lament loudly and shrilly [v]\n",
  "ULULATING": "ULULATE, to lament loudly and shrilly [v]\n",
  "ULULATION": "a howling [n -S]\n",
  "ULULATIONS": "ULULATION, a howling [n]\n",
  "ULUS": "ULU, (Inuit) an Inuit knife [n]\n",
  "ULVA": "(Latin) a genus of thin papery bright green seaweeds including the kinds called sea lettuce [n -S]\n",
  "ULVAS": "ULVA, (Latin) a genus of thin papery bright green seaweeds including the kinds called sea lettuce [n]\n",
  "ULYIE": "(Scots) oil, also ULZIE [n -S]\n",
  "ULYIES": "ULYIE, (Scots) oil, also ULZIE [n]\n",
  "ULZIE": "(Scots) oil, also ULYIE [n -S]\n",
  "ULZIES": "ULZIE, (Scots) oil, also ULYIE [n]\n",
  "UM": "to express doubt or hesitation, also UMM [v UMMED, UMMING, UMS]\n",
  "UMAMI": "(Japanese) a savoury flavour, the taste of monosodium glutamate [n -S]\n",
  "UMAMIS": "UMAMI, (Japanese) a savoury flavour, the taste of monosodium glutamate [n]\n",
  "UMANGITE": "a mineral consisting of copper selenide [n -S]\n",
  "UMANGITES": "UMANGITE, a mineral consisting of copper selenide [n]\n",
  "UMBEL": "a type of flower cluster [n -S]\n",
  "UMBELED": "having umbels, also UMBELLED [adj]\n",
  "UMBELLAR": "of or pertaining to an umbel; having the form of an umbel [adj]\n",
  "UMBELLATE": "having umbels, also UMBELLATED [adj UMBELLATELY]\n",
  "UMBELLATED": "having umbels, also UMBELLATE [adj]\n",
  "UMBELLATELY": "UMBELLATE, having umbels, also UMBELLATED [adv]\n",
  "UMBELLED": "having umbels, also UMBELED [adj]\n",
  "UMBELLET": "a small or partial umbel [n -S]\n",
  "UMBELLETS": "UMBELLET, a small or partial umbel [n]\n",
  "UMBELLIFER": "a plant producing an umbel or umbels [n -S]\n",
  "UMBELLIFEROUS": "bearing umbels [adj]\n",
  "UMBELLIFERS": "UMBELLIFER, a plant producing an umbel or umbels [n]\n",
  "UMBELLULATE": "shaped like an umbellule, a partial umbel [adj]\n",
  "UMBELLULE": "a partial umbel, also UMBELULE [n -S]\n",
  "UMBELLULES": "UMBELLULE, a partial umbel, also UMBELULE [n]\n",
  "UMBELS": "UMBEL, a type of flower cluster [n]\n",
  "UMBELULE": "a secondary umbel, also UMBELLULE [n -S]\n",
  "UMBELULES": "UMBELULE, a secondary umbel, also UMBELLULE [n]\n",
  "UMBER": "to colour with a brown pigment [v -ED, -ING, -S]\n",
  "UMBERED": "UMBER, to colour with a brown pigment [v]\n",
  "UMBERIER": "UMBERY, of or pertaining to umber; like umber; as, umbery gold [adj]\n",
  "UMBERIEST": "UMBERY, of or pertaining to umber; like umber; as, umbery gold [adj]\n",
  "UMBERING": "UMBER, to colour with a brown pigment [v]\n",
  "UMBERS": "UMBER, to colour with a brown pigment [v]\n",
  "UMBERY": "of or pertaining to umber; like umber; as, umbery gold [adj UMBERIER, UMBERIEST]\n",
  "UMBILICAL": "of or pertaining to the navel [adj UMBILICALLY] / the umbilical cord [n -S]\n",
  "UMBILICALLY": "UMBILICAL, of or pertaining to the navel [adv]\n",
  "UMBILICALS": "UMBILICAL, the umbilical cord [n]\n",
  "UMBILICATE": "having an umbilicus, also UMBILICATED [adj]\n",
  "UMBILICATED": "having an umbilicus, also UMBILICATE [adj]\n",
  "UMBILICATION": "the state of being umbilicate [n -S]\n",
  "UMBILICATIONS": "UMBILICATION, the state of being umbilicate [n]\n",
  "UMBILICI": "UMBILICUS, (Latin) the navel [n]\n",
  "UMBILICUS": "(Latin) the navel [n UMBILICUSES or UMBILICI]\n",
  "UMBILICUSES": "UMBILICUS, (Latin) the navel [n]\n",
  "UMBILIFORM": "shaped like an umbilicus [adj]\n",
  "UMBLE": "as in umble pie, a pie made from the heart, entrails etc. of a deer [n -S]\n",
  "UMBLES": "a deer's entrails, also NOMBLES, NUMBLES [n]\n",
  "UMBO": "(Latin) the rounded elevation at the centre of a shield [n UMBOS or UMBONES]\n",
  "UMBONAL": "of or like an umbo, the boss of a shield, also UMBONIC [adj]\n",
  "UMBONATE": "of the nature of an umbo [adj]\n",
  "UMBONATION": "the state of being umbonate, having a central boss [n -S]\n",
  "UMBONATIONS": "UMBONATION, the state of being umbonate, having a central boss [n]\n",
  "UMBONES": "UMBO, (Latin) the rounded elevation at the centre of a shield [n]\n",
  "UMBONIC": "of or like an umbo, the boss of a shield, also UMBONAL [adj]\n",
  "UMBOS": "UMBO, (Latin) the rounded elevation at the centre of a shield [n]\n",
  "UMBRA": "(Latin) a shadow [n UMBRAE or UMBRAS]\n",
  "UMBRACULA": "UMBRACULUM, (Latin) an umbrella or umbrella-like structure [n]\n",
  "UMBRACULATE": "overshadowed by an umbraculum [adj]\n",
  "UMBRACULIFORM": "shaped like an umbrella [adj]\n",
  "UMBRACULUM": "(Latin) an umbrella or umbrella-like structure [n UMBRACULA]\n",
  "UMBRAE": "UMBRA, (Latin) a shadow [n]\n",
  "UMBRAGE": "to offend [v UMBRAGED, UMBRAGING, UMBRAGES]\n",
  "UMBRAGED": "UMBRAGE, to offend [v]\n",
  "UMBRAGEOUS": "shady [adj UMBRAGEOUSLY]\n",
  "UMBRAGEOUSLY": "UMBRAGEOUS, shady [adv]\n",
  "UMBRAGEOUSNESS": "the state of being umbrageous [n]\n",
  "UMBRAGES": "UMBRAGE, to offend [v]\n",
  "UMBRAGING": "UMBRAGE, to offend [v]\n",
  "UMBRAL": "of or like an umbra, a shadow [adj]\n",
  "UMBRAS": "UMBRA, (Latin) a shadow [n]\n",
  "UMBRATED": "faintly traced [adj]\n",
  "UMBRATIC": "of or pertaining to the shade or darkness, also UMBRATICAL [adj]\n",
  "UMBRATICAL": "of or pertaining to the shade or darkness, also UMBRATIC [adj]\n",
  "UMBRATILE": "a person who spends his or her time in the shade or shadows [n -S]\n",
  "UMBRATILES": "UMBRATILE, a person who spends his or her time in the shade or shadows [n]\n",
  "UMBRATILOUS": "shadowy, giving shade, also UMBRATILE [adj]\n",
  "UMBRE": "the hammerhead, a brown bird related to the storks, also UMBRETTE [n -S]\n",
  "UMBREL": "(Spenser) the visor of a helmet, also UMBRERE, UMBRIERE, UMBRIL [n -S]\n",
  "UMBRELLA": "to provide with a portable shelter against rain or sun [v -ED, -ING, -S]\n",
  "UMBRELLAED": "UMBRELLA, to provide with a portable shelter against rain or sun [v]\n",
  "UMBRELLAING": "UMBRELLA, to provide with a portable shelter against rain or sun [v]\n",
  "UMBRELLAS": "UMBRELLA, to provide with a portable shelter against rain or sun [v]\n",
  "UMBRELLO": "(obsolete) an umbrella [n UMBRELLOES or UMBRELLOS]\n",
  "UMBRELLOES": "UMBRELLO, (obsolete) an umbrella [n]\n",
  "UMBRELLOS": "UMBRELLO, (obsolete) an umbrella [n]\n",
  "UMBRELS": "UMBREL, (Spenser) the visor of a helmet, also UMBRERE, UMBRIERE, UMBRIL [n]\n",
  "UMBRERE": "(Spenser) the visor of a helmet, also UMBREL, UMBRIERE, UMBRIL [n -S]\n",
  "UMBRERES": "UMBRERE, (Spenser) the visor of a helmet, also UMBREL, UMBRIERE, UMBRIL [n]\n",
  "UMBRES": "UMBRE, the hammerhead, a brown bird related to the storks, also UMBRETTE [n]\n",
  "UMBRETTE": "the hammerhead, a brown bird related to the storks, also UMBRE [n -S]\n",
  "UMBRETTES": "UMBRETTE, the hammerhead, a brown bird related to the storks, also UMBRE [n]\n",
  "UMBRIERE": "(Spenser) the visor of a helmet, also UMBREL, UMBRERE, UMBRIL [n -S]\n",
  "UMBRIERES": "UMBRIERE, (Spenser) the visor of a helmet, also UMBREL, UMBRERE, UMBRIL [n]\n",
  "UMBRIFEROUS": "giving or bearing shade [adj]\n",
  "UMBRIL": "(Spenser) the visor of a helmet, also UMBREL, UMBRERE, UMBRIERE [n -S]\n",
  "UMBRILS": "UMBRIL, (Spenser) the visor of a helmet, also UMBREL, UMBRERE, UMBRIERE [n]\n",
  "UMBROSE": "shade-giving; dusky, also UMBROUS [adj]\n",
  "UMBROUS": "shade-giving; dusky, also UMBROSE [adj]\n",
  "UME": "(Japanese) a fleshy yellow fruit, similar to an apricot but having a sour flavour, used mainly to make drinks, preserves, and sauces [n -S]\n",
  "UMEBOSHI": "(Japanese) a pickled ume fruit, having a distinctive sour and salty flavour [n -S]\n",
  "UMEBOSHIS": "UMEBOSHI, (Japanese) a pickled ume fruit, having a distinctive sour and salty flavour [n]\n",
  "UMES": "UME, (Japanese) a fleshy yellow fruit, similar to an apricot but having a sour flavour, used mainly to make drinks, preserves, and sauces [n]\n",
  "UMFAZI": "(South African) an African married woman [n -S]\n",
  "UMFAZIS": "UMFAZI, (South African) an African married woman [n]\n",
  "UMIAC": "(Inuit) an Inuit canoe, also OOMIAC, OOMIACK, OOMIAK, UMIACK, UMIAK, UMIAQ [n -S]\n",
  "UMIACK": "(Inuit) an Eskimo canoe, also OOMIAC, OOMIACK, OOMIAK, UMIAC, UMIAK, UMIAQ [n -S]\n",
  "UMIACKS": "UMIACK, (Inuit) an Eskimo canoe, also OOMIAC, OOMIACK, OOMIAK, UMIAC, UMIAK, UMIAQ [n]\n",
  "UMIACS": "UMIAC, (Inuit) an Inuit canoe, also OOMIAC, OOMIACK, OOMIAK, UMIACK, UMIAK, UMIAQ [n]\n",
  "UMIAK": "(Inuit) an Inuit canoe, also OOMIAC, OOMIACK, OOMIAK, UMIAC, UMIACK, UMIAQ [n -S]\n",
  "UMIAKS": "UMIAK, (Inuit) an Inuit canoe, also OOMIAC, OOMIACK, OOMIAK, UMIAC, UMIACK, UMIAQ [n]\n",
  "UMIAQ": "(Inuit) an Eskimo canoe, also OOMIAC, OOMIACK, OOMIAK, UMIAC, UMIACK, UMIAK [n -S]\n",
  "UMIAQS": "UMIAQ, (Inuit) an Eskimo canoe, also OOMIAC, OOMIACK, OOMIAK, UMIAC, UMIACK, UMIAK [n]\n",
  "UMLAUT": "(German) a diacritical sign placed over a vowel [n -S] / to place an umlaut over [v -ED, -ING, -S]\n",
  "UMLAUTED": "UMLAUT, to place an umlaut over [v]\n",
  "UMLAUTING": "UMLAUT, to place an umlaut over [v]\n",
  "UMLAUTS": "UMLAUT, to place an umlaut over [v]\n",
  "UMLUNGU": "(South African) a white man, esp. used as a term of address [n -S]\n",
  "UMLUNGUS": "UMLUNGU, (South African) a white man, esp. used as a term of address [n]\n",
  "UMM": "an interjection expressing doubt or hesitation, also UM [interj]\n",
  "UMMA": "(Arabic) the body of Muslim believers considered as one community, also UMMAH [n -S]\n",
  "UMMAH": "(Arabic) the body of Muslim believers considered as one community, also UMMA [n -S]\n",
  "UMMAHS": "UMMAH, (Arabic) the body of Muslim believers considered as one community, also UMMA [n]\n",
  "UMMAS": "UMMA, (Arabic) the body of Muslim believers considered as one community, also UMMAH [n]\n",
  "UMMED": "UM, to express doubt or hesitation, also UMM [v]\n",
  "UMMING": "UM, to express doubt or hesitation, also UMM [v]\n",
  "UMP": "(short for) to umpire [v -ED, -ING, -S]\n",
  "UMPED": "UMP, (short for) to umpire [v]\n",
  "UMPH": "oomph, energy [n -S]\n",
  "UMPHS": "UMPH, oomph, energy [n]\n",
  "UMPIE": "(Australian slang) an umpire, also UMPY [n -S]\n",
  "UMPIES": "UMPY, (Australian slang) an umpire, also UMPIE [n]\n",
  "UMPING": "UMP, (short for) to umpire [v]\n",
  "UMPIRAGE": "the function of an umpire [n -S]\n",
  "UMPIRAGES": "UMPIRAGE, the function of an umpire [n]\n",
  "UMPIRE": "to rule on the plays in a game [v UMPIRED, UMPIRING, UMPIRES]\n",
  "UMPIRED": "UMPIRE, to rule on the plays in a game [v]\n",
  "UMPIRES": "UMPIRE, to rule on the plays in a game [v]\n",
  "UMPIRESHIP": "umpirage; arbitrament [n -S]\n",
  "UMPIRESHIPS": "UMPIRESHIP, umpirage; arbitrament [n]\n",
  "UMPIRING": "UMPIRE, to rule on the plays in a game [v]\n",
  "UMPS": "UMP, (short for) to umpire [v]\n",
  "UMPTEEN": "denoting an indefinitely large number, also UMPTY [adj]\n",
  "UMPTEENTH": "the ordinal of umpteen [adj] / an indefinitely large number in a sequence, also UMPTIETH, UMTEENTH [n -S]\n",
  "UMPTEENTHS": "UMPTEENTH, an indefinitely large number in a sequence, also UMPTIETH, UMTEENTH [n]\n",
  "UMPTIER": "UMPTY, designating an indefinitely large number, also UMPTEEN [adj]\n",
  "UMPTIEST": "UMPTY, designating an indefinitely large number, also UMPTEEN [adj]\n",
  "UMPTIETH": "denoting an indefinitely large number in a sequence, also UMPTEENTH, UMTEENTH [adj]\n",
  "UMPTY": "designating an indefinitely large number, also UMPTEEN [adj UMPTIER, UMPTIEST]\n",
  "UMPY": "(Australian slang) an umpire, also UMPIE [n UMPIES]\n",
  "UMQUHILE": "(Scots) some time ago; formerly, also UMWHILE [adv]\n",
  "UMRA": "a lesser pilgrimage to Mecca made separately or at the same time as the hajj, and consisting of a number of devotional rituals performed within the city, also UMRAH [n -S]\n",
  "UMRAH": "a lesser pilgrimage to Mecca made separately or at the same time as the hajj, and consisting of a number of devotional rituals performed within the city, also UMRA [n -S]\n",
  "UMRAHS": "UMRAH, a lesser pilgrimage to Mecca made separately or at the same time as the hajj, and consisting of a number of devotional rituals performed within the city, also UMRA [n]\n",
  "UMRAS": "UMRA, a lesser pilgrimage to Mecca made separately or at the same time as the hajj, and consisting of a number of devotional rituals performed within the city, also UMRAH [n]\n",
  "UMS": "UM, to express doubt or hesitation, also UMM [v]\n",
  "UMTEENTH": "denoting an indefinitely large number in a sequence, also UMPTEENTH, UMPTIETH [adj]\n",
  "UMU": "(Maori) a type of Maori oven, aka hangi [n -S]\n",
  "UMUS": "UMU, (Maori) a type of Maori oven, aka hangi [n]\n",
  "UMWELT": "(German) environmental factors collectively, as affecting the behaviour of an animal or individual [n -S]\n",
  "UMWELTS": "UMWELT, (German) environmental factors collectively, as affecting the behaviour of an animal or individual [n]\n",
  "UMWHILE": "(Scots) some time ago; formerly, also UMQUHILE [adv]\n",
  "UN": "(dialect) a spelling of 'one' intended to reflect a dialectal or informal pronunciation [n -S]\n",
  "UNABASHED": "not abashed [adj UNABASHEDLY]\n",
  "UNABASHEDLY": "UNABASHED, not abashed [adv]\n",
  "UNABATED": "not made less in degree [adj UNABATEDLY]\n",
  "UNABATEDLY": "UNABATED, not made less in degree [adv]\n",
  "UNABATING": "not abating [adj]\n",
  "UNABBREVIATED": "not abbreviated [adj]\n",
  "UNABETTED": "not abetted [adj]\n",
  "UNABIDING": "not abiding [adj]\n",
  "UNABJURED": "not abjured [adj]\n",
  "UNABLE": "not able, also UNHABLE [adj]\n",
  "UNABOLISHED": "not abolished [adj]\n",
  "UNABORTED": "not aborted [adj]\n",
  "UNABRADED": "not abraded [adj]\n",
  "UNABRIDGED": "not abridged [adj]\n",
  "UNABROGATED": "not abrogated [adj]\n",
  "UNABSOLVED": "not absolved [adj]\n",
  "UNABSORBED": "not absorbed [adj]\n",
  "UNABSORBENT": "not absorbent [adj]\n",
  "UNABUSED": "not abused [adj]\n",
  "UNABUSIVE": "not abusive [adj]\n",
  "UNACADEMIC": "not academic [adj UNACADEMICALLY]\n",
  "UNACADEMICALLY": "UNACADEMIC, not academic [adv]\n",
  "UNACCENTED": "not accented [adj]\n",
  "UNACCENTUATED": "not accentuated [adj]\n",
  "UNACCEPTABILITY": "the state of being unacceptable [n]\n",
  "UNACCEPTABLE": "not acceptable [adj UNACCEPTABLY]\n",
  "UNACCEPTABLY": "UNACCEPTABLE, not acceptable [adv]\n",
  "UNACCEPTANCE": "lack of acceptance [n -S]\n",
  "UNACCEPTANCES": "UNACCEPTANCE, lack of acceptance [n]\n",
  "UNACCEPTED": "not accepted [adj]\n",
  "UNACCLIMATED": "not acclimated [adj]\n",
  "UNACCLIMATISED": "not acclimatised, also UNACCLIMATIZED [adj]\n",
  "UNACCLIMATIZED": "not acclimatized, also UNACCLIMATISED [adj]\n",
  "UNACCOMMODATED": "not accommodated [adj]\n",
  "UNACCOMMODATING": "not accommodating [adj]\n",
  "UNACCOMPANIED": "not accompanied [adj]\n",
  "UNACCOMPLISHED": "not accomplished [adj]\n",
  "UNACCOUNTABLE": "not to be accounted for [adj UNACCOUNTABLY]\n",
  "UNACCOUNTABLY": "UNACCOUNTABLE, not to be accounted for [adv]\n",
  "UNACCOUNTED": "not accounted [adj]\n",
  "UNACCREDITED": "not accredited [adj]\n",
  "UNACCRUED": "not accrued [adj]\n",
  "UNACCULTURATED": "not acculturated [adj]\n",
  "UNACCUSABLE": "that cannot be accused [adj UNACCUSABLY]\n",
  "UNACCUSABLY": "UNACCUSABLE, that cannot be accused [adv]\n",
  "UNACCUSED": "not accused [adj]\n",
  "UNACCUSTOMED": "not customary [adj UNACCUSTOMEDLY]\n",
  "UNACCUSTOMEDLY": "UNACCUSTOMED, not customary [adv]\n",
  "UNACERBIC": "not acerbic [adj]\n",
  "UNACHIEVABLE": "that cannot be achieved [adj]\n",
  "UNACHIEVED": "not achieved [adj]\n",
  "UNACHING": "not aching [adj]\n",
  "UNACIDIC": "not acidic [adj]\n",
  "UNACKNOWLEDGED": "not acknowledged [adj]\n",
  "UNACQUAINT": "to deprive (a person) of awareness or acquaintance [v -ED, -ING, -S]\n",
  "UNACQUAINTANCE": "lack of acquaintance [n -S]\n",
  "UNACQUAINTANCES": "UNACQUAINTANCE, lack of acquaintance [n]\n",
  "UNACQUAINTED": "not acquainted [adj]\n",
  "UNACQUAINTING": "UNACQUAINT, to deprive (a person) of awareness or acquaintance [v]\n",
  "UNACQUAINTS": "UNACQUAINT, to deprive (a person) of awareness or acquaintance [v]\n",
  "UNACTABLE": "that cannot be acted [adj]\n",
  "UNACTED": "not acted [adj]\n",
  "UNACTIVE": "to make (a person) inactive [v UNACTIVED, UNACTIVING, UNACTIVES]\n",
  "UNACTIVED": "UNACTIVE, to make (a person) inactive [v]\n",
  "UNACTIVES": "UNACTIVE, to make (a person) inactive [v]\n",
  "UNACTIVING": "UNACTIVE, to make (a person) inactive [v]\n",
  "UNACTORISH": "not like an actor [adj]\n",
  "UNACTUATED": "not actuated [adj]\n",
  "UNADAPTABLE": "not adaptable [adj]\n",
  "UNADAPTED": "not adapted [adj]\n",
  "UNADDED": "not added [adj]\n",
  "UNADDRESSED": "not having an address [adj]\n",
  "UNADEPT": "not adept [adj UNADEPTLY] / a person who is not adept or skilled [n -S]\n",
  "UNADEPTLY": "UNADEPT, not adept [adv]\n",
  "UNADEPTS": "UNADEPT, a person who is not adept or skilled [n]\n",
  "UNADJUDICATED": "not adjudicated [adj]\n",
  "UNADJUSTED": "not adjusted [adj]\n",
  "UNADMIRED": "not admired [adj]\n",
  "UNADMIRING": "not admiring [adj]\n",
  "UNADMITTED": "not admitted [adj]\n",
  "UNADMONISHED": "not admonished [adj]\n",
  "UNADOPTABLE": "not adoptable [adj]\n",
  "UNADOPTED": "not adopted [adj]\n",
  "UNADORED": "not adored [adj]\n",
  "UNADORNED": "not adorned [adj]\n",
  "UNADULT": "not adult [adj]\n",
  "UNADULTERATE": "not adulterated, also UNADULTERATED [adj]\n",
  "UNADULTERATED": "not adulterated, also UNADULTERATE [adj UNADULTERATEDLY]\n",
  "UNADULTERATEDLY": "UNADULTERATED, not adulterated, also UNADULTERATE [adv]\n",
  "UNADVENTROUS": "(Milton) unadventurous, also UNADVENTUROUS [adj]\n",
  "UNADVENTUROUS": "not adventurous, also UNADVENTROUS [adj]\n",
  "UNADVENTUROUSLY": "UNADVENTUROUS, not adventurous, also UNADVENTROUS [adv]\n",
  "UNADVERTISED": "not advertised, also UNADVERTIZED [adj]\n",
  "UNADVERTIZED": "not advertized, also UNADVERTISED [adj]\n",
  "UNADVISABLE": "not advisable [adj UNADVISABLY]\n",
  "UNADVISABLENESS": "the state of being unadvisable [n]\n",
  "UNADVISABLY": "UNADVISABLE, not advisable [adv]\n",
  "UNADVISED": "ill advised [adj UNADVISEDLY]\n",
  "UNADVISEDLY": "UNADVISED, ill advised [adv]\n",
  "UNADVISEDNESS": "the state of being unadvised [n -ES]\n",
  "UNADVISEDNESSES": "UNADVISEDNESS, the state of being unadvised [n]\n",
  "UNAESTHETIC": "not aesthetic, also UNESTHETIC [adj]\n",
  "UNAFFECTED": "not affected [adj UNAFFECTEDLY]\n",
  "UNAFFECTEDLY": "UNAFFECTED, not affected [adv]\n",
  "UNAFFECTEDNESS": "the state of being unaffected [n]\n",
  "UNAFFECTING": "not affecting [adj]\n",
  "UNAFFECTIONATE": "not affectionate [adj]\n",
  "UNAFFILIATED": "not affiliated [adj]\n",
  "UNAFFLUENT": "not affluent [adj]\n",
  "UNAFFORDABLE": "not affordable [adj]\n",
  "UNAFRAID": "not afraid [adj]\n",
  "UNAGED": "not aged [adj]\n",
  "UNAGEING": "not ageing, also UNAGING [adj]\n",
  "UNAGGRESSIVE": "not aggressive [adj]\n",
  "UNAGILE": "not agile [adj]\n",
  "UNAGING": "not aging, also UNAGEING [adj]\n",
  "UNAGREEABLE": "not agreeable [adj]\n",
  "UNAGREED": "not agreed [adj]\n",
  "UNAI": "(Tupi) a two-toed sloth, also UNAU [n -S]\n",
  "UNAIDABLE": "incapable of being aided, also INAIDABLE [adj]\n",
  "UNAIDED": "without aid [adj]\n",
  "UNAIDEDLY": "UNAIDED, without aid [adv]\n",
  "UNAIMED": "without aim [adj]\n",
  "UNAIRED": "not aired [adj]\n",
  "UNAIS": "UNAI, (Tupi) a two-toed sloth, also UNAU [n]\n",
  "UNAKIN": "not akin [adj]\n",
  "UNAKING": "(Shakespeare) unaching [adj]\n",
  "UNAKITE": "an igneous rock [n -S]\n",
  "UNAKITES": "UNAKITE, an igneous rock [n]\n",
  "UNALARMED": "not alarmed [adj]\n",
  "UNALERTED": "not alerted [adj]\n",
  "UNALIENABLE": "not alienable, also INALIENABLE [adj UNALIENABLY]\n",
  "UNALIENABLY": "UNALIENABLE, not alienable, also INALIENABLE [adv]\n",
  "UNALIENATED": "not alienated [adj]\n",
  "UNALIGNED": "not aligned [adj]\n",
  "UNALIKE": "not alike [adj]\n",
  "UNALIST": "a person who believes in one supreme God, a monist [n -S]\n",
  "UNALISTS": "UNALIST, a person who believes in one supreme God, a monist [n]\n",
  "UNALIVE": "lacking in vitality [adj]\n",
  "UNALLAYED": "not allayed [adj]\n",
  "UNALLEGED": "not alleged [adj]\n",
  "UNALLEVIATED": "not alleviated [adj]\n",
  "UNALLIED": "not allied [adj]\n",
  "UNALLOCATED": "not allocated [adj]\n",
  "UNALLOTTED": "not allotted [adj]\n",
  "UNALLOWABLE": "not allowable [adj]\n",
  "UNALLOWED": "not allowed [adj]\n",
  "UNALLOYED": "not alloyed [adj]\n",
  "UNALLURING": "not alluring [adj]\n",
  "UNALTERABILITY": "the state of being unalterable [n]\n",
  "UNALTERABLE": "that cannot be altered [adj UNALTERABLY]\n",
  "UNALTERABLENESS": "the state of being unalterable [n]\n",
  "UNALTERABLY": "UNALTERABLE, that cannot be altered [adv]\n",
  "UNALTERED": "not altered [adj]\n",
  "UNALTERING": "not changing [adj]\n",
  "UNAMASSED": "not amassed [adj]\n",
  "UNAMAZED": "not amazed [adj]\n",
  "UNAMBIGUOUS": "not ambiguous [adj UNAMBIGUOUSLY]\n",
  "UNAMBIGUOUSLY": "UNAMBIGUOUS, not ambiguous [adv]\n",
  "UNAMBITIOUS": "not ambitious [adj UNAMBITIOUSLY]\n",
  "UNAMBITIOUSLY": "UNAMBITIOUS, not ambitious [adv]\n",
  "UNAMBIVALENT": "not ambivalent [adj UNAMBIVALENTLY]\n",
  "UNAMBIVALENTLY": "UNAMBIVALENT, not ambivalent [adv]\n",
  "UNAMENABLE": "not amenable [adj]\n",
  "UNAMENDABLE": "not amendable [adj]\n",
  "UNAMENDED": "not amended [adj]\n",
  "UNAMERCED": "not subject to a fine [adj]\n",
  "UNAMIABILITIES": "UNAMIABILITY, the quality of being unamiable [n]\n",
  "UNAMIABILITY": "the quality of being unamiable [n UNAMIABILITIES]\n",
  "UNAMIABLE": "not amiable; morose [adj]\n",
  "UNAMIABLENESS": "the state of being unamiable [n -ES]\n",
  "UNAMIABLENESSES": "UNAMIABLENESS, the state of being unamiable [n]\n",
  "UNAMORTISED": "not amortised [adj]\n",
  "UNAMORTIZED": "not amortized [adj]\n",
  "UNAMPLIFIED": "not amplified [adj]\n",
  "UNAMUSABLE": "not able to be amused [adj]\n",
  "UNAMUSED": "not amused [adj]\n",
  "UNAMUSING": "not amusing [adj UNAMUSINGLY]\n",
  "UNAMUSINGLY": "UNAMUSING, not amusing [adv]\n",
  "UNANAESTHETISED": "not anaesthetised, also UNANAESTHETIZED [adj]\n",
  "UNANAESTHETIZED": "not anaesthetized, also UNANAESTHETISED [adj]\n",
  "UNANALYSABLE": "not analysable, also UNANALYZABLE [adj]\n",
  "UNANALYSED": "not analysed, also UNANALYZED [adj]\n",
  "UNANALYTIC": "not analytic, also UNANALYTICAL [adj]\n",
  "UNANALYTICAL": "not analytical, also UNANALYTIC [adj]\n",
  "UNANALYZABLE": "not analyzable, also UNANALYSABLE [adj]\n",
  "UNANALYZED": "not analyzed, also UNANALYSED [adj]\n",
  "UNANCHOR": "to loose from anchorage [v -ED, -ING, -S]\n",
  "UNANCHORED": "UNANCHOR, to loose from anchorage [v]\n",
  "UNANCHORING": "UNANCHOR, to loose from anchorage [v]\n",
  "UNANCHORS": "UNANCHOR, to loose from anchorage [v]\n",
  "UNANELED": "without extreme unction, also UNNANELD [adj]\n",
  "UNANESTHETISED": "not anesthetised, also UNANESTHETIZED [adj]\n",
  "UNANESTHETIZED": "not anesthetised, also UNANESTHETISED [adj]\n",
  "UNANIMATED": "not animated [adj]\n",
  "UNANIMITIES": "UNANIMITY, the state of being unanimous [n]\n",
  "UNANIMITY": "the state of being unanimous [n UNANIMITIES]\n",
  "UNANIMOUS": "of one mind [adj UNANIMOUSLY]\n",
  "UNANIMOUSLY": "UNANIMOUS, of one mind [adv]\n",
  "UNANIMOUSNESS": "UNANIMOUS, of one mind [n]\n",
  "UNANIMOUSNESSES": "UNANIMOUSNESS, UNANIMOUS, of one mind [n]\n",
  "UNANNEALED": "not annealed [adj]\n",
  "UNANNEXED": "not annexed [adj]\n",
  "UNANNOTATED": "not annotated [adj]\n",
  "UNANNOUNCED": "not announced [adj]\n",
  "UNANNOYED": "not annoyed [adj]\n",
  "UNANSWERABILITY": "the state of being unanswerable [n]\n",
  "UNANSWERABLE": "not capable of being answered [adj UNANSWERABLY]\n",
  "UNANSWERABLY": "UNANSWERABLE, not capable of being answered [adv]\n",
  "UNANSWERED": "not answered [adj]\n",
  "UNANTICIPATED": "not anticipated [adj UNANTICIPATEDLY]\n",
  "UNANTICIPATEDLY": "UNANTICIPATED, not anticipated [adv]\n",
  "UNANXIOUS": "not anxious [adj]\n",
  "UNAPOLOGETIC": "not apologetic [adj]\n",
  "UNAPOLOGISING": "not apologising, also UNAPOLOGIZING [adj]\n",
  "UNAPOLOGIZING": "not apologizing, also UNAPOLOGISING [adj]\n",
  "UNAPOSTOLIC": "not apostolical, also UNAPOSTOLICAL [adj UNAPOSTOLICALLY]\n",
  "UNAPOSTOLICAL": "not apostolical, also UNAPOSTOLIC [adj UNAPOSTOLICALLY]\n",
  "UNAPOSTOLICALLY": "UNAPOSTOLICAL, not apostolical, also UNAPOSTOLIC [adv]\n",
  "UNAPPALLED": "not appalled [adj]\n",
  "UNAPPAREL": "to divest of clothing; to strip [v UNAPPARELLED, UNAPPARELLING, UNAPPARELS]\n",
  "UNAPPARELLED": "UNAPPAREL, to divest of clothing; to strip [v]\n",
  "UNAPPARELLING": "UNAPPAREL, to divest of clothing; to strip [v]\n",
  "UNAPPARELS": "UNAPPAREL, to divest of clothing; to strip [v]\n",
  "UNAPPARENT": "not apparent [adj]\n",
  "UNAPPEALABLE": "not appealable [adj UNAPPEALABLY]\n",
  "UNAPPEALABLY": "UNAPPEALABLE, not appealable [adv]\n",
  "UNAPPEALING": "not appealing [adj UNAPPEALINGLY]\n",
  "UNAPPEALINGLY": "UNAPPEALING, not appealing [adv]\n",
  "UNAPPEASABLE": "not to be appeased, also INAPPEASABLE [adj UNAPPEASABLY]\n",
  "UNAPPEASABLY": "UNAPPEASABLE, not to be appeased, also INAPPEASABLE [adv]\n",
  "UNAPPEASED": "not appeased [adj]\n",
  "UNAPPETISING": "not appetising [adj]\n",
  "UNAPPETISINGLY": "UNAPPETISING, not appetising [adv]\n",
  "UNAPPETIZING": "not appetizing [adj UNAPPETIZINGLY]\n",
  "UNAPPETIZINGLY": "UNAPPETIZING, not appetizing [adv]\n",
  "UNAPPLAUSIVE": "not applausive [adj]\n",
  "UNAPPLICABLE": "not applicable [adj]\n",
  "UNAPPLIED": "not applied [adj]\n",
  "UNAPPOINTED": "not appointed [adj]\n",
  "UNAPPRECIATED": "not appreciated [adj]\n",
  "UNAPPRECIATION": "failure to appreciate something [n -S]\n",
  "UNAPPRECIATIONS": "UNAPPRECIATION, failure to appreciate something [n]\n",
  "UNAPPRECIATIVE": "not appreciative [adj]\n",
  "UNAPPREHENDED": "not apprehended [adj]\n",
  "UNAPPREHENSIBLE": "not apprehensible [adj]\n",
  "UNAPPREHENSIVE": "not apprehensive [adj]\n",
  "UNAPPRISED": "not apprised [adj]\n",
  "UNAPPROACHABLE": "not approachable [adj UNAPPROACHABLY]\n",
  "UNAPPROACHABLY": "UNAPPROACHABLE, not approachable [adv]\n",
  "UNAPPROACHED": "not approached [adj]\n",
  "UNAPPROPRIATE": "to remove from private ownership and return to public ownership [v UNAPPROPRIATED, UNAPPROPRIATING, UNAPPROPRIATES]\n",
  "UNAPPROPRIATED": "not appropriated [adj]\n",
  "UNAPPROPRIATES": "UNAPPROPRIATE, to remove from private ownership and return to public ownership [v]\n",
  "UNAPPROPRIATING": "UNAPPROPRIATE, to remove from private ownership and return to public ownership [v]\n",
  "UNAPPROVED": "not approved [adj]\n",
  "UNAPPROVING": "not approving [adj UNAPPROVINGLY]\n",
  "UNAPPROVINGLY": "UNAPPROVING, not approving [adv]\n",
  "UNAPT": "unfit or unqualified, also INAPT, INEPT [adj]\n",
  "UNAPTLY": "UNAPT, unfit or unqualified, also INAPT, INEPT [adv]\n",
  "UNAPTNESS": "the state of not being apt [n -ES]\n",
  "UNAPTNESSES": "UNAPTNESS, the state of not being apt [n]\n",
  "UNARCHED": "not arched [adj]\n",
  "UNARGUABLE": "that cannot be disputed [adj UNARGUABLY]\n",
  "UNARGUABLY": "UNARGUABLE, that cannot be disputed [adv]\n",
  "UNARGUED": "not argued [adj]\n",
  "UNARISEN": "not arisen [adj]\n",
  "UNARM": "to deprive of arms [v -ED, -ING, -S]\n",
  "UNARMED": "UNARM, to deprive of arms [v]\n",
  "UNARMING": "UNARM, to deprive of arms [v]\n",
  "UNARMORED": "not armored, also UNARMOURED [adj]\n",
  "UNARMOURED": "not armoured, also UNARMORED [adj]\n",
  "UNARMS": "UNARM, to deprive of arms [v]\n",
  "UNAROUSED": "not aroused [adj]\n",
  "UNARRANGED": "not arranged [adj]\n",
  "UNARRAYED": "not arrayed [adj]\n",
  "UNARROGANT": "not arrogant [adj]\n",
  "UNARTFUL": "lacking art or skill; artless [adj UNARTFULLY]\n",
  "UNARTFULLY": "UNARTFUL, lacking art or skill; artless [adv]\n",
  "UNARTICULATE": "not articulate, also INARTICULATE [adj]\n",
  "UNARTICULATED": "not articulated [adj]\n",
  "UNARTIFICIAL": "not artificial [adj UNARTIFICIALLY]\n",
  "UNARTIFICIALLY": "UNARTIFICIAL, not artificial [adv]\n",
  "UNARTISTIC": "not artistic [adj]\n",
  "UNARTISTLIKE": "not like an artist [adj]\n",
  "UNARY": "consisting of a single element [adj]\n",
  "UNASCENDABLE": "not capable of being ascended, also UNASCENDIBLE [adj]\n",
  "UNASCENDED": "not ascended [adj]\n",
  "UNASCENDIBLE": "not capable of being ascended, also UNASCENDABLE [adj]\n",
  "UNASCERTAINABLE": "not ascertainable [adj]\n",
  "UNASCERTAINED": "not ascertained [adj]\n",
  "UNASHAMED": "not ashamed [adj UNASHAMEDLY]\n",
  "UNASHAMEDLY": "UNASHAMED, not ashamed [adv]\n",
  "UNASHAMEDNESS": "the state of being unashamed [n -ES]\n",
  "UNASHAMEDNESSES": "UNASHAMEDNESS, the state of being unashamed [n]\n",
  "UNASKED": "not asked [adj]\n",
  "UNASPIRATED": "not aspirated [adj]\n",
  "UNASPIRING": "not aspiring [adj UNASPIRINGLY]\n",
  "UNASPIRINGLY": "UNASPIRING, not aspiring [adv]\n",
  "UNASPIRINGNESS": "the state of being unaspiring [n]\n",
  "UNASSAILABILITY": "the state of being unassailable [n]\n",
  "UNASSAILABLE": "not assailable [adj UNASSAILABLY]\n",
  "UNASSAILABLY": "UNASSAILABLE, not assailable [adv]\n",
  "UNASSAILED": "not assailed [adj]\n",
  "UNASSAYED": "not assayed, not attempted [adj]\n",
  "UNASSEMBLED": "not assembled [adj]\n",
  "UNASSERTIVE": "not assertive [adj UNASSERTIVELY]\n",
  "UNASSERTIVELY": "UNASSERTIVE, not assertive [adv]\n",
  "UNASSIGNABLE": "not assignable [adj]\n",
  "UNASSIGNED": "not assigned [adj]\n",
  "UNASSIMILABLE": "not assimilable [adj]\n",
  "UNASSIMILATED": "not assimilated [adj]\n",
  "UNASSISTED": "not assisted [adj UNASSISTEDLY]\n",
  "UNASSISTEDLY": "UNASSISTED, not assisted [adv]\n",
  "UNASSISTING": "not assisting [adj]\n",
  "UNASSOCIATED": "not associated [adj]\n",
  "UNASSUAGEABLE": "not capable of being assuaged [adj]\n",
  "UNASSUAGED": "not assuaged [adj]\n",
  "UNASSUMED": "not assumed [adj]\n",
  "UNASSUMING": "not assuming [adj UNASSUMINGLY]\n",
  "UNASSUMINGLY": "UNASSUMING, not assuming [adv]\n",
  "UNASSUMINGNESS": "the state of being unassuming [n]\n",
  "UNASSURED": "not assured [adj]\n",
  "UNATHLETIC": "not athletic [adj]\n",
  "UNATONABLE": "not capable of being atoned [adj]\n",
  "UNATONED": "not atoned [adj]\n",
  "UNATTACHED": "not assigned or committed (as to a particular task, organization, or person) [adj]\n",
  "UNATTAINABLE": "not attainable [adj UNATTAINABLY]\n",
  "UNATTAINABLY": "UNATTAINABLE, not attainable [adv]\n",
  "UNATTAINTED": "not attainted [adj]\n",
  "UNATTEMPTED": "not attempted [adj]\n",
  "UNATTENDED": "not attended [adj]\n",
  "UNATTENDING": "not attending [adj]\n",
  "UNATTENTIVE": "not attentive [adj]\n",
  "UNATTENUATED": "not attenuated [adj]\n",
  "UNATTESTED": "not attested [adj]\n",
  "UNATTIRED": "not attired [adj]\n",
  "UNATTRACTIVE": "not attractive [adj UNATTRACTIVELY]\n",
  "UNATTRACTIVELY": "UNATTRACTIVE, not attractive [adv]\n",
  "UNATTRIBUTABLE": "not attributable [adj]\n",
  "UNATTRIBUTED": "not attributed [adj]\n",
  "UNATTUNED": "not attuned [adj]\n",
  "UNAU": "(Tupi) a two-toed sloth, also UNAI [n -S]\n",
  "UNAUDITED": "not audited [adj]\n",
  "UNAUGMENTED": "not augmented [adj]\n",
  "UNAUS": "UNAU, (Tupi) a two-toed sloth, also UNAI [n]\n",
  "UNAUSPICIOUS": "(Shakespeare) inauspicious [adj]\n",
  "UNAUTHENTIC": "not authentic [adj]\n",
  "UNAUTHENTICATED": "not authenticated [adj]\n",
  "UNAUTHENTICITY": "a lack of authenticity [n]\n",
  "UNAUTHORISED": "not authorised, also UNAUTHORIZED [adj]\n",
  "UNAUTHORITATIVE": "not authoritative [adj]\n",
  "UNAUTHORIZED": "not authorized, also UNAUTHORISED [adj]\n",
  "UNAUTOMATED": "not automated [adj]\n",
  "UNAVAILABILITY": "the quality of being unavailable [n]\n",
  "UNAVAILABLE": "not available [adj UNAVAILABLY]\n",
  "UNAVAILABLENESS": "the state of being unavailable [n]\n",
  "UNAVAILABLY": "UNAVAILABLE, not available [adv]\n",
  "UNAVAILING": "not availing [adj UNAVAILINGLY]\n",
  "UNAVAILINGLY": "UNAVAILING, not availing [adv]\n",
  "UNAVAILINGNESS": "UNAVAILING, not availing [n]\n",
  "UNAVENGED": "not avenged [adj]\n",
  "UNAVERAGE": "not average [adj]\n",
  "UNAVERTABLE": "that cannot be averted, also UNAVERTIBLE [adj]\n",
  "UNAVERTED": "not averted [adj]\n",
  "UNAVERTIBLE": "that cannot be averted, also UNAVERTABLE [adj]\n",
  "UNAVOIDABILITY": "the quality of being unavoidable [n]\n",
  "UNAVOIDABLE": "that cannot be avoided [adj UNAVOIDABLY]\n",
  "UNAVOIDABLENESS": "the state of being unavoidable [n]\n",
  "UNAVOIDABLY": "UNAVOIDABLE, that cannot be avoided [adv]\n",
  "UNAVOIDED": "unavoidable [adj]\n",
  "UNAVOWED": "not avowed [adj UNAVOWEDLY]\n",
  "UNAVOWEDLY": "UNAVOWED, not avowed [adv]\n",
  "UNAWAKE": "not awake [adj]\n",
  "UNAWAKED": "not awakened [adj]\n",
  "UNAWAKENED": "not awakened [adj]\n",
  "UNAWAKENING": "not awakening [adj]\n",
  "UNAWARDED": "not awarded [adj]\n",
  "UNAWARE": "not aware, also UNAWARES, UNWARE, UNWARES [adj UNAWARELY]\n",
  "UNAWARELY": "UNAWARE, not aware, also UNAWARES, UNWARE, UNWARES [adv]\n",
  "UNAWARENESS": "the state of being unaware [n -ES]\n",
  "UNAWARENESSES": "UNAWARENESS, the state of being unaware [n]\n",
  "UNAWARES": "without warning, also UNAWARE, UNWARE, UNWARES [adv]\n",
  "UNAWED": "not awed [adj]\n",
  "UNAWESOME": "not awesome [adj]\n",
  "UNAXED": "not axed [adj]\n",
  "UNBACKED": "not backed [adj]\n",
  "UNBAFFLED": "not baffled [adj]\n",
  "UNBAG": "to let out of a bag [v UNBAGGED, UNBAGGING, UNBAGS]\n",
  "UNBAGGED": "UNBAG, to let out of a bag [v]\n",
  "UNBAGGING": "UNBAG, to let out of a bag [v]\n",
  "UNBAGS": "UNBAG, to let out of a bag [v]\n",
  "UNBAILABLE": "that cannot be bailed [adj]\n",
  "UNBAITED": "not baited [adj]\n",
  "UNBAKED": "not baked [adj]\n",
  "UNBALANCE": "to cause to lose balance [v UNBALANCED, UNBALANCING, UNBALANCES]\n",
  "UNBALANCED": "UNBALANCE, to cause to lose balance [v]\n",
  "UNBALANCES": "UNBALANCE, to cause to lose balance [v]\n",
  "UNBALANCING": "UNBALANCE, to cause to lose balance [v]\n",
  "UNBALE": "to loosen from a compressed bundle [v UNBALED, UNBALING, UNBALES]\n",
  "UNBALED": "UNBALE, to loosen from a compressed bundle [v]\n",
  "UNBALES": "UNBALE, to loosen from a compressed bundle [v]\n",
  "UNBALING": "UNBALE, to loosen from a compressed bundle [v]\n",
  "UNBALLASTED": "not loaded with ballast [adj]\n",
  "UNBAN": "to remove a prohibition against [v UNBANNED, UNBANNING, UNBANS]\n",
  "UNBANDAGE": "to take a bandage off [v UNBANDAGED, UNBANDAGING, UNBANDAGES]\n",
  "UNBANDAGED": "UNBANDAGE, to take a bandage off [v]\n",
  "UNBANDAGES": "UNBANDAGE, to take a bandage off [v]\n",
  "UNBANDAGING": "UNBANDAGE, to take a bandage off [v]\n",
  "UNBANDED": "not banded [adj]\n",
  "UNBANKED": "not deposited [adj]\n",
  "UNBANNED": "UNBAN, to remove a prohibition against [v]\n",
  "UNBANNING": "the act of reversing a ban [n -S]\n",
  "UNBANNINGS": "UNBANNING, the act of reversing a ban [n]\n",
  "UNBANS": "UNBAN, to remove a prohibition against [v]\n",
  "UNBAPTISE": "to undo the effects of baptism, also UNBAPTIZE [v UNBAPTISED, UNBAPTISING, UNBAPTISES]\n",
  "UNBAPTISED": "UNBAPTISE, to undo the effects of baptism, also UNBAPTIZE [v]\n",
  "UNBAPTISES": "UNBAPTISE, to undo the effects of baptism, also UNBAPTIZE [v]\n",
  "UNBAPTISING": "UNBAPTISE, to undo the effects of baptism, also UNBAPTIZE [v]\n",
  "UNBAPTIZE": "to undo the effects of baptism, also UNBAPTISE [v UNBAPTIZED, UNBAPTIZING, UNBAPTIZES]\n",
  "UNBAPTIZED": "UNBAPTIZE, to undo the effects of baptism, also UNBAPTISE [v]\n",
  "UNBAPTIZES": "UNBAPTIZE, to undo the effects of baptism, also UNBAPTISE [v]\n",
  "UNBAPTIZING": "UNBAPTIZE, to undo the effects of baptism, also UNBAPTISE [v]\n",
  "UNBAR": "to become unbarred [v UNBARRED, UNBARRING, UNBARS]\n",
  "UNBARBED": "not barbed [adj]\n",
  "UNBARBERED": "not barbered [adj]\n",
  "UNBARE": "to lay bare [v UNBARED, UNBARING, UNBARES]\n",
  "UNBARED": "UNBARE, to lay bare [v]\n",
  "UNBARES": "UNBARE, to lay bare [v]\n",
  "UNBARING": "UNBARE, to lay bare [v]\n",
  "UNBARK": "to strip of bark [v -ED, -ING, -S]\n",
  "UNBARKED": "UNBARK, to strip of bark [v]\n",
  "UNBARKING": "UNBARK, to strip of bark [v]\n",
  "UNBARKS": "UNBARK, to strip of bark [v]\n",
  "UNBARRED": "UNBAR, to become unbarred [v]\n",
  "UNBARRICADE": "to remove a barricade from [v UNBARRICADED, UNBARRICADING, UNBARRICADES]\n",
  "UNBARRICADED": "UNBARRICADE, to remove a barricade from [v]\n",
  "UNBARRICADES": "UNBARRICADE, to remove a barricade from [v]\n",
  "UNBARRICADING": "UNBARRICADE, to remove a barricade from [v]\n",
  "UNBARRING": "UNBAR, to become unbarred [v]\n",
  "UNBARS": "UNBAR, to become unbarred [v]\n",
  "UNBASED": "not based [adj]\n",
  "UNBASHFUL": "not bashful or modest [adj]\n",
  "UNBASTED": "not basted [adj]\n",
  "UNBATED": "undiminished [adj]\n",
  "UNBATHED": "not bathed [adj]\n",
  "UNBATTERED": "not battered [adj]\n",
  "UNBE": "to cease to have being [v UNBEEN, UNBEING]\n",
  "UNBEAR": "to free from the pressure of a rein [v UNBORE or UNBEARED, UNBORNE, UNBEARING, UNBEARS]\n",
  "UNBEARABLE": "that cannot be borne [adj UNBEARABLY]\n",
  "UNBEARABLENESS": "the state of being unbearable [n]\n",
  "UNBEARABLY": "UNBEARABLE, that cannot be borne [adv]\n",
  "UNBEARDED": "not having a beard [adj]\n",
  "UNBEARED": "UNBEAR, to free from the pressure of a rein [v]\n",
  "UNBEARING": "UNBEAR, to free from the pressure of a rein [v]\n",
  "UNBEARS": "UNBEAR, to free from the pressure of a rein [v]\n",
  "UNBEATABLE": "that cannot be beaten [adj UNBEATABLY]\n",
  "UNBEATABLY": "UNBEATABLE, that cannot be beaten [adv]\n",
  "UNBEATEN": "not beaten [adj]\n",
  "UNBEAUTIFUL": "not beautiful [adj UNBEAUTIFULLY]\n",
  "UNBEAUTIFULLY": "UNBEAUTIFUL, not beautiful [adv]\n",
  "UNBEAVERED": "(archaic) without a beaver or hat [adj]\n",
  "UNBECOMING": "not becoming [adj UNBECOMINGLY] / the transition from existence to nonexistence [n -S]\n",
  "UNBECOMINGLY": "UNBECOMING, not becoming [adv]\n",
  "UNBECOMINGNESS": "the state of being unbecoming [n]\n",
  "UNBECOMINGS": "UNBECOMING, the transition from existence to nonexistence [n]\n",
  "UNBED": "to rouse from bed [v UNBEDDED, UNBEDDING, UNBEDS]\n",
  "UNBEDDED": "UNBED, to rouse from bed [v]\n",
  "UNBEDDING": "UNBED, to rouse from bed [v]\n",
  "UNBEDIMMED": "not made dim [adj]\n",
  "UNBEDINNED": "not filled with din [adj]\n",
  "UNBEDS": "UNBED, to rouse from bed [v]\n",
  "UNBEEN": "UNBE, to cease to have being [v]\n",
  "UNBEFITTING": "not befitting [adj]\n",
  "UNBEFRIENDED": "not befriended [adj]\n",
  "UNBEGET": "to undo the begetting of [v UNBEGOT, UNBEGOTTEN, UNBEGETTING, UNBEGETS]\n",
  "UNBEGETS": "UNBEGET, to undo the begetting of [v]\n",
  "UNBEGETTING": "UNBEGET, to undo the begetting of [v]\n",
  "UNBEGGED": "not entreated [adj]\n",
  "UNBEGINNING": "not beginning [adj]\n",
  "UNBEGOT": "UNBEGET, to undo the begetting of [v]\n",
  "UNBEGOTTEN": "UNBEGET, to undo the begetting of [v]\n",
  "UNBEGUILE": "to set free from the influence of guile; to undeceive [v UNBEGUILED, UNBEGUILING, UNBEGUILES]\n",
  "UNBEGUILED": "UNBEGUILE, to set free from the influence of guile; to undeceive [v]\n",
  "UNBEGUILES": "UNBEGUILE, to set free from the influence of guile; to undeceive [v]\n",
  "UNBEGUILING": "UNBEGUILE, to set free from the influence of guile; to undeceive [v]\n",
  "UNBEGUN": "not yet begun [adj]\n",
  "UNBEHOLDEN": "not beholden [adj]\n",
  "UNBEING": "a state of not being [n -S]\n",
  "UNBEINGS": "UNBEING, a state of not being [n]\n",
  "UNBEKNOWN": "unknown [adj] / without the knowledge of, unobserved by, also UNBEKNOWNST [adv]\n",
  "UNBEKNOWNST": "unknown [adj] / without the knowledge of, unobserved by, also UNBEKNOWN [adv]\n",
  "UNBELIEF": "lack of belief [n -S]\n",
  "UNBELIEFS": "UNBELIEF, lack of belief [n]\n",
  "UNBELIEVABILITY": "the quality of being unbelievable [n]\n",
  "UNBELIEVABLE": "too improbable for belief [adj UNBELIEVABLY]\n",
  "UNBELIEVABLY": "UNBELIEVABLE, too improbable for belief [adv]\n",
  "UNBELIEVE": "to disbelieve; to cease to believe [v UNBELIEVED, UNBELIEVING, UNBELIEVES]\n",
  "UNBELIEVED": "UNBELIEVE, to disbelieve; to cease to believe [v]\n",
  "UNBELIEVER": "one that does not believe in a particular religious faith [n -S]\n",
  "UNBELIEVERS": "UNBELIEVER, one that does not believe in a particular religious faith [n]\n",
  "UNBELIEVES": "UNBELIEVE, to disbelieve; to cease to believe [v]\n",
  "UNBELIEVING": "UNBELIEVE, to disbelieve; to cease to believe [v]\n",
  "UNBELIEVINGLY": "UNBELIEVING, UNBELIEVE, to disbelieve; to cease to believe [adv]\n",
  "UNBELIEVINGNESS": "the state of being unbelieving [n]\n",
  "UNBELLIGERENT": "not belligerent [adj]\n",
  "UNBELOVED": "not beloved [adj]\n",
  "UNBELT": "to remove the belt of [v -ED, -ING, -S]\n",
  "UNBELTED": "UNBELT, to remove the belt of [v]\n",
  "UNBELTING": "UNBELT, to remove the belt of [v]\n",
  "UNBELTS": "UNBELT, to remove the belt of [v]\n",
  "UNBEMUSED": "not bemused [adj]\n",
  "UNBEND": "to relax [v UNBENDED, UNBENT, UNBENDING, UNBENDS]\n",
  "UNBENDABLE": "not capable of bending [adj]\n",
  "UNBENDED": "UNBEND, to relax [v]\n",
  "UNBENDING": "stern, uncompromising [adj UNBENDINGLY] / the act of unbending [n -S]\n",
  "UNBENDINGLY": "UNBENDING, stern, uncompromising [adv]\n",
  "UNBENDINGNESS": "the state of being unbending [n -ES]\n",
  "UNBENDINGNESSES": "UNBENDINGNESS, the state of being unbending [n]\n",
  "UNBENDINGS": "UNBENDING, the act of unbending [n]\n",
  "UNBENDS": "UNBEND, to relax [v]\n",
  "UNBENEFICED": "not possessed of a benefice [adj]\n",
  "UNBENEFICIAL": "not beneficial [adj]\n",
  "UNBENEFITED": "not benefited, also UNBENEFITTED [adj]\n",
  "UNBENEFITTED": "(US) (of a job) not accompanied by benefits such as paid leave or medical insurance, also UNBENEFITED [adj]\n",
  "UNBENIGHTED": "not benighted [adj]\n",
  "UNBENIGN": "not benign [adj UNBENIGNLY]\n",
  "UNBENIGNANT": "not benignant [adj]\n",
  "UNBENIGNLY": "UNBENIGN, not benign [adv]\n",
  "UNBENT": "UNBEND, to relax [v]\n",
  "UNBEREFT": "not bereft [adj]\n",
  "UNBERUFEN": "(German) an exclamation to avert ill luck following boasting [interj]\n",
  "UNBESEEM": "to misbecome [v -ED, -ING, -S]\n",
  "UNBESEEMED": "UNBESEEM, to misbecome [v]\n",
  "UNBESEEMING": "UNBESEEM, to misbecome [v]\n",
  "UNBESEEMINGLY": "UNBESEEMING, UNBESEEM, to misbecome [adv]\n",
  "UNBESEEMS": "UNBESEEM, to misbecome [v]\n",
  "UNBESOUGHT": "not looked for [adj]\n",
  "UNBESPEAK": "to unsay; hence, to annul or cancel [v UNBESPOKE, UNBESPOKEN, UNBESPEAKING, UNBESPEAKS]\n",
  "UNBESPEAKING": "UNBESPEAK, to unsay; hence, to annul or cancel [v]\n",
  "UNBESPEAKS": "UNBESPEAK, to unsay; hence, to annul or cancel [v]\n",
  "UNBESPOKE": "UNBESPEAK, to unsay; hence, to annul or cancel [v]\n",
  "UNBESPOKEN": "UNBESPEAK, to unsay; hence, to annul or cancel [v]\n",
  "UNBESTOWED": "not bestowed [adj]\n",
  "UNBETRAYED": "not betrayed [adj]\n",
  "UNBETTERABLE": "that cannot be bettered [adj]\n",
  "UNBETTERED": "not bettered [adj]\n",
  "UNBEWAILED": "not bewailed [adj]\n",
  "UNBIAS": "to free from bias [v UNBIASED or UNBIASSED, UNBIASING or UNBIASSING, UNBIASES or UNBIASSES]\n",
  "UNBIASED": "UNBIAS, to free from bias [v]\n",
  "UNBIASEDLY": "UNBIASED, UNBIAS, to free from bias [adv]\n",
  "UNBIASEDNESS": "the state of being unbiased, also UNBIASSEDNESS [n -ES]\n",
  "UNBIASEDNESSES": "UNBIASEDNESS, the state of being unbiased, also UNBIASSEDNESS [n]\n",
  "UNBIASES": "UNBIAS, to free from bias [v]\n",
  "UNBIASING": "the act of freeing from bias [n -S]\n",
  "UNBIASINGS": "UNBIASING, the act of freeing from bias [n]\n",
  "UNBIASSED": "UNBIAS, to free from bias [v]\n",
  "UNBIASSEDLY": "UNBIASSED, UNBIAS, to free from bias [adv]\n",
  "UNBIASSEDNESS": "the state of being unbiassed, also UNBIASEDNESS [n -ES]\n",
  "UNBIASSEDNESSES": "UNBIASSEDNESS, the state of being unbiassed, also UNBIASEDNESS [n]\n",
  "UNBIASSES": "UNBIAS, to free from bias [v]\n",
  "UNBIASSING": "the removal of bias [n -S]\n",
  "UNBIASSINGS": "UNBIASSING, the removal of bias [n]\n",
  "UNBIBLICAL": "contrary to or unsanctioned by the Bible [adj]\n",
  "UNBID": "not bid or commanded, also UNBIDDEN [adj]\n",
  "UNBIDDEN": "not bid or commanded, also UNBID [adj]\n",
  "UNBIGOTED": "not bigoted [adj]\n",
  "UNBILLED": "not billed [adj]\n",
  "UNBIND": "to free from bindings [v UNBOUND, UNBINDING, UNBINDS]\n",
  "UNBINDING": "the act of unbinding [n -S]\n",
  "UNBINDINGS": "UNBINDING, the act of unbinding [n]\n",
  "UNBINDS": "UNBIND, to free from bindings [v]\n",
  "UNBIRTHDAY": "a day other than one's birthday [n -S]\n",
  "UNBIRTHDAYS": "UNBIRTHDAY, a day other than one's birthday [n]\n",
  "UNBISHOP": "to deprive of the status of bishop [v -ED, -ING, -S]\n",
  "UNBISHOPED": "UNBISHOP, to deprive of the status of bishop [v]\n",
  "UNBISHOPING": "UNBISHOP, to deprive of the status of bishop [v]\n",
  "UNBISHOPS": "UNBISHOP, to deprive of the status of bishop [v]\n",
  "UNBITT": "(nautical) to uncoil or unfasten (a cable) from the bitts [v -ED, -ING, -S]\n",
  "UNBITTED": "UNBITT, (nautical) to uncoil or unfasten (a cable) from the bitts [v]\n",
  "UNBITTEN": "not bitten [adj]\n",
  "UNBITTER": "not bitter [adj]\n",
  "UNBITTING": "UNBITT, (nautical) to uncoil or unfasten (a cable) from the bitts [v]\n",
  "UNBITTS": "UNBITT, (nautical) to uncoil or unfasten (a cable) from the bitts [v]\n",
  "UNBLAMABLE": "that cannot be blamed, also UNBLAMEABLE [adj UNBLAMABLY]\n",
  "UNBLAMABLY": "UNBLAMABLE, that cannot be blamed, also UNBLAMEABLE [adv]\n",
  "UNBLAMEABLE": "that cannot be blamed, also UNBLAMABLE [adj UNBLAMEABLY]\n",
  "UNBLAMEABLY": "UNBLAMEABLE, that cannot be blamed, also UNBLAMABLE [adv]\n",
  "UNBLAMED": "not blamed [adj]\n",
  "UNBLEACHED": "not bleached [adj]\n",
  "UNBLEMISHED": "not blemished [adj]\n",
  "UNBLENCHED": "(Milton) unflinching [adj]\n",
  "UNBLENCHING": "not blenching [adj]\n",
  "UNBLENDED": "not blended, also UNBLENT [adj]\n",
  "UNBLENT": "not blent [adj]\n",
  "UNBLESS": "to deprive of blessing [v UNBLESSED or UNBLEST, UNBLESSING, UNBLESSES]\n",
  "UNBLESSED": "UNBLESS, to deprive of blessing [v]\n",
  "UNBLESSEDNESS": "the state of being unblessed [n -ES]\n",
  "UNBLESSEDNESSES": "UNBLESSEDNESS, the state of being unblessed [n]\n",
  "UNBLESSES": "UNBLESS, to deprive of blessing [v]\n",
  "UNBLESSING": "UNBLESS, to deprive of blessing [v]\n",
  "UNBLEST": "not blest [adj]\n",
  "UNBLIND": "to free from blindness [v -ED, -ING, -S]\n",
  "UNBLINDED": "UNBLIND, to free from blindness [v]\n",
  "UNBLINDFOLD": "to remove a blindfold from [v -ED, -ING, -S]\n",
  "UNBLINDFOLDED": "UNBLINDFOLD, to remove a blindfold from [v]\n",
  "UNBLINDFOLDING": "UNBLINDFOLD, to remove a blindfold from [v]\n",
  "UNBLINDFOLDS": "UNBLINDFOLD, to remove a blindfold from [v]\n",
  "UNBLINDING": "UNBLIND, to free from blindness [v]\n",
  "UNBLINDS": "UNBLIND, to free from blindness [v]\n",
  "UNBLINKING": "not blinking [adj UNBLINKINGLY]\n",
  "UNBLINKINGLY": "UNBLINKING, not blinking [adv]\n",
  "UNBLISSFUL": "not blissful [adj]\n",
  "UNBLOCK": "to free from blockage [v -ED, -ING, -S]\n",
  "UNBLOCKED": "UNBLOCK, to free from blockage [v]\n",
  "UNBLOCKING": "UNBLOCK, to free from blockage [v]\n",
  "UNBLOCKS": "UNBLOCK, to free from blockage [v]\n",
  "UNBLOODED": "not blooded [adj]\n",
  "UNBLOODIED": "not bloodied [adj]\n",
  "UNBLOODIER": "UNBLOODY, not bloody [adj]\n",
  "UNBLOODIEST": "UNBLOODY, not bloody [adj]\n",
  "UNBLOODY": "not bloody [adj UNBLOODIER, UNBLOODIEST]\n",
  "UNBLOTTED": "not blotted [adj]\n",
  "UNBLOWED": "(Shakespeare) not blown, still in the bud, also UNBLOWN [adj]\n",
  "UNBLOWN": "not blown, still in the bud, also UNBLOWED [adj]\n",
  "UNBLUNTED": "not blunted [adj]\n",
  "UNBLURRED": "not blurred [adj]\n",
  "UNBLUSHING": "not blushing [adj UNBLUSHINGLY]\n",
  "UNBLUSHINGLY": "UNBLUSHING, not blushing [adv]\n",
  "UNBLUSHINGNESS": "the state of being unblushing [n]\n",
  "UNBOARDED": "not boarded [adj]\n",
  "UNBOASTFUL": "not boastful [adj]\n",
  "UNBOBBED": "not bobbed [adj]\n",
  "UNBODIED": "having no body [adj]\n",
  "UNBODING": "not expecting [adj]\n",
  "UNBOILED": "not boiled [adj]\n",
  "UNBOLT": "to undo a bolt [v -ED, -ING, -S]\n",
  "UNBOLTED": "UNBOLT, to undo a bolt [v]\n",
  "UNBOLTING": "UNBOLT, to undo a bolt [v]\n",
  "UNBOLTS": "UNBOLT, to undo a bolt [v]\n",
  "UNBONDED": "not bonded [adj]\n",
  "UNBONE": "to remove the bones of [v UNBONED, UNBONING, UNBONES]\n",
  "UNBONED": "UNBONE, to remove the bones of [v]\n",
  "UNBONES": "UNBONE, to remove the bones of [v]\n",
  "UNBONING": "UNBONE, to remove the bones of [v]\n",
  "UNBONNET": "to uncover the head [v -ED, -ING, -S]\n",
  "UNBONNETED": "UNBONNET, to uncover the head [v]\n",
  "UNBONNETING": "UNBONNET, to uncover the head [v]\n",
  "UNBONNETS": "UNBONNET, to uncover the head [v]\n",
  "UNBOOKED": "not entered in a book [adj]\n",
  "UNBOOKISH": "not bookish [adj]\n",
  "UNBOOT": "to take off the boots [v -ED, -ING, -S]\n",
  "UNBOOTED": "UNBOOT, to take off the boots [v]\n",
  "UNBOOTING": "UNBOOT, to take off the boots [v]\n",
  "UNBOOTS": "UNBOOT, to take off the boots [v]\n",
  "UNBORE": "UNBEAR, to free from the pressure of a rein [v]\n",
  "UNBORN": "not yet born [adj]\n",
  "UNBORNE": "UNBEAR, to free from the pressure of a rein [v]\n",
  "UNBORROWED": "not borrowed [adj]\n",
  "UNBOSOM": "to pour out; to tell freely [v -ED, -ING, -S]\n",
  "UNBOSOMED": "UNBOSOM, to pour out; to tell freely [v]\n",
  "UNBOSOMER": "one who unbosoms, or discloses [n -S]\n",
  "UNBOSOMERS": "UNBOSOMER, one who unbosoms, or discloses [n]\n",
  "UNBOSOMING": "UNBOSOM, to pour out; to tell freely [v]\n",
  "UNBOSOMS": "UNBOSOM, to pour out; to tell freely [v]\n",
  "UNBOTTLE": "to release from or as if from a bottle [v UNBOTTLED, UNBOTTLING, UNBOTTLES]\n",
  "UNBOTTLED": "UNBOTTLE, to release from or as if from a bottle [v]\n",
  "UNBOTTLES": "UNBOTTLE, to release from or as if from a bottle [v]\n",
  "UNBOTTLING": "UNBOTTLE, to release from or as if from a bottle [v]\n",
  "UNBOTTOMED": "deprived of a bottom [adj]\n",
  "UNBOUGHT": "obtained without buying [adj]\n",
  "UNBOUNCIER": "UNBOUNCY, not bouncy [adj]\n",
  "UNBOUNCIEST": "UNBOUNCY, not bouncy [adj]\n",
  "UNBOUNCY": "not bouncy [adj UNBOUNCIER, UNBOUNCIEST]\n",
  "UNBOUND": "UNBIND, to free from bindings [v]\n",
  "UNBOUNDED": "not bounded [adj UNBOUNDEDLY]\n",
  "UNBOUNDEDLY": "UNBOUNDED, not bounded [adv]\n",
  "UNBOUNDEDNESS": "the state of being unbounded [n -ES]\n",
  "UNBOUNDEDNESSES": "UNBOUNDEDNESS, the state of being unbounded [n]\n",
  "UNBOWDLERISED": "not bowdlerised, also UNBOWDLERIZED [adj]\n",
  "UNBOWDLERIZED": "not bowdlerized, also UNBOWDLERISED [adj]\n",
  "UNBOWED": "not bowed [adj]\n",
  "UNBOWING": "not bowing [adj]\n",
  "UNBOX": "to remove from a box [v -ED, -ING, -ES]\n",
  "UNBOXED": "UNBOX, to remove from a box [v]\n",
  "UNBOXES": "UNBOX, to remove from a box [v]\n",
  "UNBOXING": "UNBOX, to remove from a box [v]\n",
  "UNBRACE": "to free from braces [v UNBRACED, UNBRACING, UNBRACES]\n",
  "UNBRACED": "UNBRACE, to free from braces [v]\n",
  "UNBRACES": "UNBRACE, to free from braces [v]\n",
  "UNBRACING": "UNBRACE, to free from braces [v]\n",
  "UNBRACKETED": "not bracketed [adj]\n",
  "UNBRAID": "to separate the strands of [v -ED, -ING, -S]\n",
  "UNBRAIDED": "UNBRAID, to separate the strands of [v]\n",
  "UNBRAIDING": "UNBRAID, to separate the strands of [v]\n",
  "UNBRAIDS": "UNBRAID, to separate the strands of [v]\n",
  "UNBRAKE": "to release a brake [v UNBRAKED, UNBRAKING, UNBRAKES]\n",
  "UNBRAKED": "UNBRAKE, to release a brake [v]\n",
  "UNBRAKES": "UNBRAKE, to release a brake [v]\n",
  "UNBRAKING": "UNBRAKE, to release a brake [v]\n",
  "UNBRANCHED": "not branched [adj]\n",
  "UNBRANDED": "not branded [adj]\n",
  "UNBRASTE": "(Spenser) not braced; with clothing unfastened, also UNBRACED [adj]\n",
  "UNBREACHABLE": "that cannot be breached [adj]\n",
  "UNBREACHED": "not breached [adj]\n",
  "UNBREAKABLE": "not breakable [adj]\n",
  "UNBREATHABLE": "not fit for being breathed [adj]\n",
  "UNBREATHED": "out of breath [adj]\n",
  "UNBREATHING": "not breathing [adj]\n",
  "UNBRED": "not bred [adj]\n",
  "UNBREECH": "to remove the breeches of [v -ED, -ING, -ES]\n",
  "UNBREECHED": "UNBREECH, to remove the breeches of [v]\n",
  "UNBREECHES": "UNBREECH, to remove the breeches of [v]\n",
  "UNBREECHING": "UNBREECH, to remove the breeches of [v]\n",
  "UNBRIBABLE": "not bribable [adj]\n",
  "UNBRIDGEABLE": "that cannot be bridged [adj]\n",
  "UNBRIDGED": "not bridged [adj]\n",
  "UNBRIDLE": "to set loose [v UNBRIDLED, UNBRIDLING, UNBRIDLES]\n",
  "UNBRIDLED": "UNBRIDLE, to set loose [v]\n",
  "UNBRIDLEDLY": "UNBRIDLED, UNBRIDLE, to set loose [adv]\n",
  "UNBRIDLEDNESS": "the state of being unbridled [n -ES]\n",
  "UNBRIDLEDNESSES": "UNBRIDLEDNESS, the state of being unbridled [n]\n",
  "UNBRIDLES": "UNBRIDLE, to set loose [v]\n",
  "UNBRIDLING": "UNBRIDLE, to set loose [v]\n",
  "UNBRIEFED": "not briefed [adj]\n",
  "UNBRIGHT": "not bright [adj]\n",
  "UNBRILLIANT": "not brilliant [adj]\n",
  "UNBRIZZED": "(Scott) unbruised [adj]\n",
  "UNBROILED": "not broiled [adj]\n",
  "UNBROKE": "(archaic) unbroken [adj]\n",
  "UNBROKEN": "not broken, also UNBROKE [adj UNBROKENLY]\n",
  "UNBROKENLY": "UNBROKEN, not broken, also UNBROKE [adv]\n",
  "UNBROKENNESS": "the state of being unbroken [n -ES]\n",
  "UNBROKENNESSES": "UNBROKENNESS, the state of being unbroken [n]\n",
  "UNBROTHERLIKE": "not like a brother [adj]\n",
  "UNBROTHERLY": "not brotherly [adj]\n",
  "UNBROWNED": "not browned [adj]\n",
  "UNBRUISED": "not bruised, also UNBRIZZED, UNBRUSED [adj]\n",
  "UNBRUSED": "(Shakespeare) unbruised [adj]\n",
  "UNBRUSHED": "not brushed [adj]\n",
  "UNBUCKLE": "to undo a buckle [v UNBUCKLED, UNBUCKLING, UNBUCKLES]\n",
  "UNBUCKLED": "UNBUCKLE, to undo a buckle [v]\n",
  "UNBUCKLES": "UNBUCKLE, to undo a buckle [v]\n",
  "UNBUCKLING": "UNBUCKLE, to undo a buckle [v]\n",
  "UNBUDDED": "not yet in bud [adj]\n",
  "UNBUDGEABLE": "that cannot be budged [adj UNBUDGEABLY]\n",
  "UNBUDGEABLY": "UNBUDGEABLE, that cannot be budged [adv]\n",
  "UNBUDGETED": "not budgeted for [adj]\n",
  "UNBUDGING": "not budging [adj UNBUDGINGLY]\n",
  "UNBUDGINGLY": "UNBUDGING, not budging [adv]\n",
  "UNBUFFERED": "not buffered [adj]\n",
  "UNBUILD": "to demolish; to raze [v UNBUILT, UNBUILDING, UNBUILDS]\n",
  "UNBUILDABLE": "that cannot be built [adj]\n",
  "UNBUILDING": "UNBUILD, to demolish; to raze [v]\n",
  "UNBUILDS": "UNBUILD, to demolish; to raze [v]\n",
  "UNBUILT": "UNBUILD, to demolish; to raze [v]\n",
  "UNBULKIER": "UNBULKY, not bulky [adj]\n",
  "UNBULKIEST": "UNBULKY, not bulky [adj]\n",
  "UNBULKY": "not bulky [adj UNBULKIER, UNBULKIEST]\n",
  "UNBUNDLE": "to price separately [v UNBUNDLED, UNBUNDLING, UNBUNDLES]\n",
  "UNBUNDLED": "UNBUNDLE, to price separately [v]\n",
  "UNBUNDLER": "one who unbundles [n -S]\n",
  "UNBUNDLERS": "UNBUNDLER, one who unbundles [n]\n",
  "UNBUNDLES": "UNBUNDLE, to price separately [v]\n",
  "UNBUNDLING": "the act of unbundling, dividing a business corporation into separate companies [n -S]\n",
  "UNBUNDLINGS": "UNBUNDLING, the act of unbundling, dividing a business corporation into separate companies [n]\n",
  "UNBURDEN": "to free from a burden, also UNBURTHEN [v -ED, -ING, -S]\n",
  "UNBURDENED": "UNBURDEN, to free from a burden, also UNBURTHEN [v]\n",
  "UNBURDENING": "UNBURDEN, to free from a burden, also UNBURTHEN [v]\n",
  "UNBURDENS": "UNBURDEN, to free from a burden, also UNBURTHEN [v]\n",
  "UNBUREAUCRATIC": "not bureaucratic [adj]\n",
  "UNBURIED": "UNBURY, to disinter; to exhume [v]\n",
  "UNBURIES": "UNBURY, to disinter; to exhume [v]\n",
  "UNBURNABLE": "that cannot be burned [adj]\n",
  "UNBURNED": "not burned [adj]\n",
  "UNBURNISHED": "not burnished [adj]\n",
  "UNBURNT": "not burnt [adj]\n",
  "UNBURROW": "to bring out of a burrow [v -ED, -ING, -S]\n",
  "UNBURROWED": "UNBURROW, to bring out of a burrow [v]\n",
  "UNBURROWING": "UNBURROW, to bring out of a burrow [v]\n",
  "UNBURROWS": "UNBURROW, to bring out of a burrow [v]\n",
  "UNBURTHEN": "(archaic) to unburden; to unload [v -ED, -ING, -S]\n",
  "UNBURTHENED": "UNBURTHEN, (archaic) to unburden; to unload [v]\n",
  "UNBURTHENING": "UNBURTHEN, (archaic) to unburden; to unload [v]\n",
  "UNBURTHENS": "UNBURTHEN, (archaic) to unburden; to unload [v]\n",
  "UNBURY": "to disinter; to exhume [v UNBURIED, UNBURYING, UNBURIES]\n",
  "UNBURYING": "UNBURY, to disinter; to exhume [v]\n",
  "UNBUSIED": "UNBUSY, to make less busy [v]\n",
  "UNBUSIER": "UNBUSY, not busy [adj]\n",
  "UNBUSIES": "UNBUSY, to make less busy [v]\n",
  "UNBUSIEST": "UNBUSY, not busy [adj]\n",
  "UNBUSINESSLIKE": "not businesslike [adj]\n",
  "UNBUSTED": "not burst [adj]\n",
  "UNBUSY": "not busy [adj UNBUSIER, UNBUSIEST] / to make less busy [v UNBUSIED, UNBUSYING, UNBUSIES]\n",
  "UNBUSYING": "UNBUSY, to make less busy [v]\n",
  "UNBUTTERED": "not buttered [adj]\n",
  "UNBUTTON": "to unfasten the buttons of [v -ED, -ING, -S]\n",
  "UNBUTTONED": "UNBUTTON, to unfasten the buttons of [v]\n",
  "UNBUTTONING": "UNBUTTON, to unfasten the buttons of [v]\n",
  "UNBUTTONS": "UNBUTTON, to unfasten the buttons of [v]\n",
  "UNCAGE": "to release from a cage [v UNCAGED, UNCAGING, UNCAGES]\n",
  "UNCAGED": "UNCAGE, to release from a cage [v]\n",
  "UNCAGES": "UNCAGE, to release from a cage [v]\n",
  "UNCAGING": "UNCAGE, to release from a cage [v]\n",
  "UNCAKE": "to break up a block of compacted matter [v UNCAKED, UNCAKING, UNCAKES]\n",
  "UNCAKED": "UNCAKE, to break up a block of compacted matter [v]\n",
  "UNCAKES": "UNCAKE, to break up a block of compacted matter [v]\n",
  "UNCAKING": "UNCAKE, to break up a block of compacted matter [v]\n",
  "UNCALCIFIED": "not calcified [adj]\n",
  "UNCALCINED": "not calcined [adj]\n",
  "UNCALCULATED": "not planned or thought out beforehand [adj]\n",
  "UNCALCULATING": "not based on or marked by calculation [adj]\n",
  "UNCALIBRATED": "not calibrated [adj]\n",
  "UNCALLED": "not called [adj]\n",
  "UNCALLOUSED": "not calloused [adj]\n",
  "UNCANCELED": "not canceled, also UNCANCELLED [adj]\n",
  "UNCANCELLED": "not cancelled, also UNCANCELED [adj]\n",
  "UNCANDID": "not candid [adj UNCANDIDLY]\n",
  "UNCANDIDLY": "UNCANDID, not candid [adv]\n",
  "UNCANDIDNESS": "the state of being uncandid [n -ES]\n",
  "UNCANDIDNESSES": "UNCANDIDNESS, the state of being uncandid [n]\n",
  "UNCANDLED": "not candled [adj]\n",
  "UNCANDOR": "a lack of candor, also UNCANDOUR [n -S]\n",
  "UNCANDORS": "UNCANDOR, a lack of candor, also UNCANDOUR [n]\n",
  "UNCANDOUR": "a lack of candour, also UNCANDOR [n -S]\n",
  "UNCANDOURS": "UNCANDOUR, a lack of candour, also UNCANDOR [n]\n",
  "UNCANNED": "not canned [adj]\n",
  "UNCANNIER": "UNCANNY, strange and inexplicable [adj]\n",
  "UNCANNIEST": "UNCANNY, strange and inexplicable [adj]\n",
  "UNCANNILY": "UNCANNY, strange and inexplicable [adv]\n",
  "UNCANNINESS": "the state of being uncanny [n -ES]\n",
  "UNCANNINESSES": "UNCANNINESS, the state of being uncanny [n]\n",
  "UNCANNY": "strange and inexplicable [adj UNCANNIER, UNCANNIEST, UNCANNILY]\n",
  "UNCANONIC": "not canonical, also UNCANONICAL [adj]\n",
  "UNCANONICAL": "not canonical, also UNCANONIC [adj]\n",
  "UNCANONICALNESS": "the state of being uncanonical [n]\n",
  "UNCANONISE": "to deprive of canonical authority, also UNCANONIZE [v UNCANONISED, UNCANONISING, UNCANONISES]\n",
  "UNCANONISED": "UNCANONISE, to deprive of canonical authority, also UNCANONIZE [v]\n",
  "UNCANONISES": "UNCANONISE, to deprive of canonical authority, also UNCANONIZE [v]\n",
  "UNCANONISING": "UNCANONISE, to deprive of canonical authority, also UNCANONIZE [v]\n",
  "UNCANONIZE": "to deprive of canonical authority, also UNCANONISE [v UNCANONIZED, UNCANONIZING, UNCANONIZES]\n",
  "UNCANONIZED": "UNCANONIZE, to deprive of canonical authority, also UNCANONISE [v]\n",
  "UNCANONIZES": "UNCANONIZE, to deprive of canonical authority, also UNCANONISE [v]\n",
  "UNCANONIZING": "UNCANONIZE, to deprive of canonical authority, also UNCANONISE [v]\n",
  "UNCAP": "to remove the cap from [v UNCAPPED, UNCAPPING, UNCAPS]\n",
  "UNCAPABLE": "(Shakespeare) incapable [adj]\n",
  "UNCAPE": "(Shakespeare) to throw off the hounds [v UNCAPED, UNCAPING, UNCAPES]\n",
  "UNCAPED": "UNCAPE, (Shakespeare) to throw off the hounds [v]\n",
  "UNCAPES": "UNCAPE, (Shakespeare) to throw off the hounds [v]\n",
  "UNCAPING": "UNCAPE, (Shakespeare) to throw off the hounds [v]\n",
  "UNCAPITALISED": "not capitalised, also UNCAPITALIZED [adj]\n",
  "UNCAPITALIZED": "not capitalized, also UNCAPITALISED [adj]\n",
  "UNCAPPED": "UNCAP, to remove the cap from [v]\n",
  "UNCAPPING": "UNCAP, to remove the cap from [v]\n",
  "UNCAPS": "UNCAP, to remove the cap from [v]\n",
  "UNCAPSIZABLE": "not capsizable [adj]\n",
  "UNCAPTIONED": "not captioned [adj]\n",
  "UNCAPTIVATED": "not captivated [adj]\n",
  "UNCAPTURABLE": "that cannot be captured [adj]\n",
  "UNCARDED": "not carded [adj]\n",
  "UNCARED": "not cared (for) [adj]\n",
  "UNCAREFUL": "not careful [adj]\n",
  "UNCARING": "without concern [adj]\n",
  "UNCARPETED": "not carpeted [adj]\n",
  "UNCART": "to take off a cart [v -ED, -ING, -S]\n",
  "UNCARTED": "UNCART, to take off a cart [v]\n",
  "UNCARTING": "UNCART, to take off a cart [v]\n",
  "UNCARTS": "UNCART, to take off a cart [v]\n",
  "UNCARVED": "not carved [adj]\n",
  "UNCASE": "to remove from a case [v UNCASED, UNCASING, UNCASES]\n",
  "UNCASED": "UNCASE, to remove from a case [v]\n",
  "UNCASES": "UNCASE, to remove from a case [v]\n",
  "UNCASHED": "not surrendered for cash [adj]\n",
  "UNCASING": "UNCASE, to remove from a case [v]\n",
  "UNCASKED": "not put in a cask [adj]\n",
  "UNCAST": "to undo the process of casting; to take back a cast [v -ED, -ING, -S]\n",
  "UNCASTED": "UNCAST, to undo the process of casting; to take back a cast [v]\n",
  "UNCASTING": "UNCAST, to undo the process of casting; to take back a cast [v]\n",
  "UNCASTRATED": "not castrated [adj]\n",
  "UNCASTS": "UNCAST, to undo the process of casting; to take back a cast [v]\n",
  "UNCATALOGED": "not cataloged, also UNCATALOGUED [adj]\n",
  "UNCATALOGUED": "not catalogued, also UNCATALOGED [adj]\n",
  "UNCATCHABLE": "not catchable [adj]\n",
  "UNCATCHIER": "UNCATCHY, not catchy [adj]\n",
  "UNCATCHIEST": "UNCATCHY, not catchy [adj]\n",
  "UNCATCHY": "not catchy [adj UNCATCHIER, UNCATCHIEST]\n",
  "UNCATE": "hooked [adj]\n",
  "UNCATEGORISABLE": "not able to be categorised, also UNCATEGORIZABLE [adj]\n",
  "UNCATEGORIZABLE": "not able to be categorized, also UNCATEGORISABLE [adj]\n",
  "UNCATERED": "not catered [adj]\n",
  "UNCAUGHT": "not caught [adj]\n",
  "UNCAUSED": "not caused [adj]\n",
  "UNCE": "(Scots) an ounce [n -S]\n",
  "UNCEASING": "not ceasing [adj UNCEASINGLY]\n",
  "UNCEASINGLY": "UNCEASING, not ceasing [adv]\n",
  "UNCEASINGNESS": "the state of being unceasing [n -ES]\n",
  "UNCEASINGNESSES": "UNCEASINGNESS, the state of being unceasing [n]\n",
  "UNCEDED": "not ceded [adj]\n",
  "UNCELEBRATED": "not formally honored or commemorated [adj]\n",
  "UNCENSORED": "not censored [adj]\n",
  "UNCENSORIOUS": "not censorious [adj]\n",
  "UNCENSURED": "not censured [adj]\n",
  "UNCEREBRAL": "not cerebral [adj]\n",
  "UNCEREMONIOUS": "not ceremonious [adj UNCEREMONIOUSLY]\n",
  "UNCEREMONIOUSLY": "UNCEREMONIOUS, not ceremonious [adv]\n",
  "UNCERTAIN": "not certain, also INCERTAIN [adj UNCERTAINLY]\n",
  "UNCERTAINLY": "UNCERTAIN, not certain, also INCERTAIN [adv]\n",
  "UNCERTAINNESS": "the state of being uncertain [n -ES]\n",
  "UNCERTAINNESSES": "UNCERTAINNESS, the state of being uncertain [n]\n",
  "UNCERTAINTIES": "UNCERTAINTY, the state of being uncertain, also INCERTAINTY [n]\n",
  "UNCERTAINTY": "the state of being uncertain, also INCERTAINTY [n UNCERTAINTIES]\n",
  "UNCERTIFICATED": "not certificated [adj]\n",
  "UNCERTIFIED": "not certified [adj]\n",
  "UNCES": "UNCE, (Scots) an ounce [n]\n",
  "UNCESSANT": "(Milton) incessant [adj]\n",
  "UNCHAIN": "to free from a chain [v -ED, -ING, -S]\n",
  "UNCHAINED": "UNCHAIN, to free from a chain [v]\n",
  "UNCHAINING": "UNCHAIN, to free from a chain [v]\n",
  "UNCHAINS": "UNCHAIN, to free from a chain [v]\n",
  "UNCHAIR": "to remove from a chairmanship [v -ED, -ING, -S]\n",
  "UNCHAIRED": "UNCHAIR, to remove from a chairmanship [v]\n",
  "UNCHAIRING": "UNCHAIR, to remove from a chairmanship [v]\n",
  "UNCHAIRS": "UNCHAIR, to remove from a chairmanship [v]\n",
  "UNCHALLENGEABLE": "not challengeable [adj UNCHALLENGEABLY]\n",
  "UNCHALLENGEABLY": "UNCHALLENGEABLE, not challengeable [adv]\n",
  "UNCHALLENGED": "not challenged [adj]\n",
  "UNCHALLENGING": "not challenging [adj]\n",
  "UNCHANCIER": "UNCHANCY, unlucky, spooky [adj]\n",
  "UNCHANCIEST": "UNCHANCY, unlucky, spooky [adj]\n",
  "UNCHANCY": "unlucky, spooky [adj UNCHANCIER, UNCHANCIEST]\n",
  "UNCHANGEABILITY": "the state of being unchangeable [n]\n",
  "UNCHANGEABLE": "not changing or to be changed [adj UNCHANGEABLY]\n",
  "UNCHANGEABLY": "UNCHANGEABLE, not changing or to be changed [adv]\n",
  "UNCHANGED": "not changed [adj]\n",
  "UNCHANGING": "not changing [adj UNCHANGINGLY]\n",
  "UNCHANGINGLY": "UNCHANGING, not changing [adv]\n",
  "UNCHANGINGNESS": "the state of being unchanging [n]\n",
  "UNCHANNELED": "not channeled, also UNCHANNELLED [adj]\n",
  "UNCHANNELLED": "not channelled, also UNCHANNELED [adj]\n",
  "UNCHAPERONED": "not chaperoned [adj]\n",
  "UNCHARGE": "to free from a charge or load; to unload [v UNCHARGED, UNCHARGING, UNCHARGES]\n",
  "UNCHARGED": "UNCHARGE, to free from a charge or load; to unload [v]\n",
  "UNCHARGES": "UNCHARGE, to free from a charge or load; to unload [v]\n",
  "UNCHARGING": "UNCHARGE, to free from a charge or load; to unload [v]\n",
  "UNCHARIER": "UNCHARY, not chary [adj]\n",
  "UNCHARIEST": "UNCHARY, not chary [adj]\n",
  "UNCHARISMATIC": "not charismatic [adj]\n",
  "UNCHARITABLE": "lacking in charity [adj UNCHARITABLY]\n",
  "UNCHARITABLY": "UNCHARITABLE, lacking in charity [adv]\n",
  "UNCHARITIES": "UNCHARITY, uncharitableness [n]\n",
  "UNCHARITY": "uncharitableness [n UNCHARITIES]\n",
  "UNCHARM": "to free from a spell [v -ED, -ING, -S]\n",
  "UNCHARMED": "UNCHARM, to free from a spell [v]\n",
  "UNCHARMING": "UNCHARM, to free from a spell [v]\n",
  "UNCHARMS": "UNCHARM, to free from a spell [v]\n",
  "UNCHARNEL": "to remove from a charnel house; to raise from the grave [v UNCHARNELLED, UNCHARNELLING, UNCHARNELS]\n",
  "UNCHARNELLED": "UNCHARNEL, to remove from a charnel house; to raise from the grave [v]\n",
  "UNCHARNELLING": "UNCHARNEL, to remove from a charnel house; to raise from the grave [v]\n",
  "UNCHARNELS": "UNCHARNEL, to remove from a charnel house; to raise from the grave [v]\n",
  "UNCHARRED": "not charred [adj]\n",
  "UNCHARTED": "not charted [adj]\n",
  "UNCHARTERED": "not chartered [adj]\n",
  "UNCHARY": "not chary [adj UNCHARIER, UNCHARIEST]\n",
  "UNCHASTE": "not chaste [adj UNCHASTER, UNCHASTEST, UNCHASTELY]\n",
  "UNCHASTELY": "UNCHASTE, not chaste [adv]\n",
  "UNCHASTENED": "not chastened [adj]\n",
  "UNCHASTENESS": "the state of being unchaste [n -ES]\n",
  "UNCHASTENESSES": "UNCHASTENESS, the state of being unchaste [n]\n",
  "UNCHASTER": "UNCHASTE, not chaste [adj]\n",
  "UNCHASTEST": "UNCHASTE, not chaste [adj]\n",
  "UNCHASTISABLE": "not able to be chastised, also UNCHASTIZABLE [adj]\n",
  "UNCHASTISED": "not chastised, also UNCHASTIZED [adj]\n",
  "UNCHASTITIES": "UNCHASTITY, the state of being unchaste [n]\n",
  "UNCHASTITY": "the state of being unchaste [n UNCHASTITIES]\n",
  "UNCHASTIZABLE": "not able to be chastized, also UNCHASTISABLE [adj]\n",
  "UNCHASTIZED": "not chastized, also UNCHASTISED [adj]\n",
  "UNCHAUVINISTIC": "not chauvinistic [adj]\n",
  "UNCHECK": "(Shakespeare) to fail to check [v -ED, -ING, -S]\n",
  "UNCHECKABLE": "that cannot be checked [adj]\n",
  "UNCHECKED": "UNCHECK, (Shakespeare) to fail to check [v]\n",
  "UNCHECKING": "UNCHECK, (Shakespeare) to fail to check [v]\n",
  "UNCHECKS": "UNCHECK, (Shakespeare) to fail to check [v]\n",
  "UNCHEERED": "not cheered [adj]\n",
  "UNCHEERFUL": "not cheerful [adj UNCHEERFULLY]\n",
  "UNCHEERFULLY": "UNCHEERFUL, not cheerful [adv]\n",
  "UNCHEERFULNESS": "the state of being uncheerful [n]\n",
  "UNCHEWABLE": "not chewable [adj]\n",
  "UNCHEWED": "not chewed [adj]\n",
  "UNCHIC": "not chic [adj]\n",
  "UNCHICLY": "not chicly [adv]\n",
  "UNCHILD": "(Shakespeare) to change from being a child [v -ED, -ING, -S]\n",
  "UNCHILDED": "UNCHILD, (Shakespeare) to change from being a child [v]\n",
  "UNCHILDING": "UNCHILD, (Shakespeare) to change from being a child [v]\n",
  "UNCHILDLIKE": "not like a child [adj]\n",
  "UNCHILDS": "UNCHILD, (Shakespeare) to change from being a child [v]\n",
  "UNCHILLED": "not chilled [adj]\n",
  "UNCHIVALROUS": "not chivalrous [adj UNCHIVALROUSLY]\n",
  "UNCHIVALROUSLY": "UNCHIVALROUS, not chivalrous [adv]\n",
  "UNCHLORINATED": "not chlorinated [adj]\n",
  "UNCHOKE": "to free from obstruction [v UNCHOKED, UNCHOKING, UNCHOKES]\n",
  "UNCHOKED": "UNCHOKE, to free from obstruction [v]\n",
  "UNCHOKES": "UNCHOKE, to free from obstruction [v]\n",
  "UNCHOKING": "UNCHOKE, to free from obstruction [v]\n",
  "UNCHOREOGRAPHED": "not choreographed [adj]\n",
  "UNCHOSEN": "not chosen [adj]\n",
  "UNCHRISOM": "(Lamb) unchristened [adj]\n",
  "UNCHRISTEN": "to render unchristian [v -ED, -ING, -S]\n",
  "UNCHRISTENED": "UNCHRISTEN, to render unchristian [v]\n",
  "UNCHRISTENING": "UNCHRISTEN, to render unchristian [v]\n",
  "UNCHRISTENS": "UNCHRISTEN, to render unchristian [v]\n",
  "UNCHRISTIAN": "not of the Christian faith [adj UNCHRISTIANLY] / to make unchristian [v -ED, -ING, -S]\n",
  "UNCHRISTIANED": "UNCHRISTIAN, to make unchristian [v]\n",
  "UNCHRISTIANING": "UNCHRISTIAN, to make unchristian [v]\n",
  "UNCHRISTIANISE": "to make unchristian, also UNCHRISTIANIZE [v UNCHRISTIANISED, UNCHRISTIANISES]\n",
  "UNCHRISTIANISED": "UNCHRISTIANISE, to make unchristian, also UNCHRISTIANIZE [v]\n",
  "UNCHRISTIANISES": "UNCHRISTIANISE, to make unchristian, also UNCHRISTIANIZE [v]\n",
  "UNCHRISTIANIZE": "to make unchristian, also UNCHRISTIANISE [v UNCHRISTIANIZED, UNCHRISTIANIZES]\n",
  "UNCHRISTIANIZED": "UNCHRISTIANIZE, to make unchristian, also UNCHRISTIANISE [v]\n",
  "UNCHRISTIANIZES": "UNCHRISTIANIZE, to make unchristian, also UNCHRISTIANISE [v]\n",
  "UNCHRISTIANLIKE": "not like a Christian [adj]\n",
  "UNCHRISTIANLY": "UNCHRISTIAN, not of the Christian faith [adv]\n",
  "UNCHRISTIANS": "UNCHRISTIAN, to make unchristian [v]\n",
  "UNCHRONICLED": "not chronicled [adj]\n",
  "UNCHRONOLOGICAL": "not chronological [adj]\n",
  "UNCHURCH": "to expel from a church [v -ED, -ING, -ES]\n",
  "UNCHURCHED": "UNCHURCH, to expel from a church [v]\n",
  "UNCHURCHES": "UNCHURCH, to expel from a church [v]\n",
  "UNCHURCHING": "UNCHURCH, to expel from a church [v]\n",
  "UNCHURCHLY": "not churchly [adj]\n",
  "UNCI": "UNCUS, (Latin) a hook-shaped anatomical part [n]\n",
  "UNCIA": "(Latin) an ancient Roman coin, so called because it was an ounce of silver [n UNCIAE]\n",
  "UNCIAE": "UNCIA, (Latin) an ancient Roman coin, so called because it was an ounce of silver [n]\n",
  "UNCIAL": "a form of writing used in Latin and Greek manuscripts [n -S] / in uncial form [adj UNCIALLY]\n",
  "UNCIALLY": "UNCIAL, in uncial form [adv]\n",
  "UNCIALS": "UNCIAL, a form of writing used in Latin and Greek manuscripts [n]\n",
  "UNCIFORM": "a bone of the wrist [n -S]\n",
  "UNCIFORMS": "UNCIFORM, a bone of the wrist [n]\n",
  "UNCILIATED": "without cilia [adj]\n",
  "UNCINAL": "bent at the end like a hook, also UNCINATE [adj]\n",
  "UNCINARIA": "hookworm [n -S]\n",
  "UNCINARIAS": "UNCINARIA, hookworm [n]\n",
  "UNCINARIASES": "UNCINARIASIS, infestation of the small intestine by hookworm [n]\n",
  "UNCINARIASIS": "infestation of the small intestine by hookworm [n UNCINARIASES]\n",
  "UNCINATE": "bent at the end like a hook, also UNCINAL [adj]\n",
  "UNCINATED": "hooked at the end, also UNCINATE [adj]\n",
  "UNCINEMATIC": "not related to the cinema [adj]\n",
  "UNCINI": "UNCINUS, (Latin) a hooklet, a marginal tooth of a mollusc's radula [n]\n",
  "UNCINUS": "(Latin) a hooklet, a marginal tooth of a mollusc's radula [n UNCINI]\n",
  "UNCIPHER": "(obsolete) to decipher [v -ED, -ING, -S]\n",
  "UNCIPHERED": "UNCIPHER, (obsolete) to decipher [v]\n",
  "UNCIPHERING": "UNCIPHER, (obsolete) to decipher [v]\n",
  "UNCIPHERS": "UNCIPHER, (obsolete) to decipher [v]\n",
  "UNCIRCULATED": "not circulated [adj]\n",
  "UNCIRCUMCISED": "not circumcised [adj]\n",
  "UNCIRCUMCISION": "the state of not being circumcised [n -S]\n",
  "UNCIRCUMCISIONS": "UNCIRCUMCISION, the state of not being circumcised [n]\n",
  "UNCIRCUMSCRIBED": "not circumscribed [adj]\n",
  "UNCITED": "not cited [adj]\n",
  "UNCIVIL": "not civil, also INCIVIL [adj UNCIVILLY]\n",
  "UNCIVILISED": "not civilised, also UNCIVILIZED [adj UNCIVILISEDLY]\n",
  "UNCIVILISEDLY": "UNCIVILISED, not civilised, also UNCIVILIZED [adv]\n",
  "UNCIVILISEDNESS": "the state of being uncivilised [n]\n",
  "UNCIVILITIES": "UNCIVILITY, the state of being not civil, also INCIVILITY [n]\n",
  "UNCIVILITY": "the state of being not civil, also INCIVILITY [n UNCIVILITIES]\n",
  "UNCIVILIZED": "not civilised, also UNCIVILISED [adj UNCIVILIZEDLY]\n",
  "UNCIVILIZEDLY": "UNCIVILIZED, not civilised, also UNCIVILISED [adv]\n",
  "UNCIVILIZEDNESS": "the state of being uncivilized [n]\n",
  "UNCIVILLY": "UNCIVIL, not civil, also INCIVIL [adv]\n",
  "UNCIVILNESS": "the state of being uncivil [n -ES]\n",
  "UNCIVILNESSES": "UNCIVILNESS, the state of being uncivil [n]\n",
  "UNCLAD": "UNCLOTHE, to divest of clothing [v]\n",
  "UNCLAIMED": "not claimed [adj]\n",
  "UNCLAMP": "to free from a clamp [v -ED, -ING, -S]\n",
  "UNCLAMPED": "UNCLAMP, to free from a clamp [v]\n",
  "UNCLAMPING": "UNCLAMP, to free from a clamp [v]\n",
  "UNCLAMPS": "UNCLAMP, to free from a clamp [v]\n",
  "UNCLARIFIED": "not clarified [adj]\n",
  "UNCLARITIES": "UNCLARITY, a lack of clarity [n]\n",
  "UNCLARITY": "a lack of clarity [n UNCLARITIES]\n",
  "UNCLASP": "to free from a clasp [v -ED, -ING, -S]\n",
  "UNCLASPED": "UNCLASP, to free from a clasp [v]\n",
  "UNCLASPING": "UNCLASP, to free from a clasp [v]\n",
  "UNCLASPS": "UNCLASP, to free from a clasp [v]\n",
  "UNCLASSED": "without class divisions; unclassified [adj]\n",
  "UNCLASSICAL": "not classical [adj]\n",
  "UNCLASSIER": "UNCLASSY, not classy [adj]\n",
  "UNCLASSIEST": "UNCLASSY, not classy [adj]\n",
  "UNCLASSIFIABLE": "not classifiable [adj]\n",
  "UNCLASSIFIED": "not placed or belonging in a class [adj]\n",
  "UNCLASSY": "not classy [adj UNCLASSIER, UNCLASSIEST]\n",
  "UNCLAWED": "not clawed [adj]\n",
  "UNCLE": "to address as uncle [v UNCLED, UNCLING, UNCLES]\n",
  "UNCLEAN": "not clean [adj UNCLEANER, UNCLEANEST, UNCLEANLY]\n",
  "UNCLEANED": "not cleaned [adj]\n",
  "UNCLEANER": "UNCLEAN, not clean [adj]\n",
  "UNCLEANEST": "UNCLEAN, not clean [adj]\n",
  "UNCLEANLIER": "UNCLEANLY, not clean in person or habits [adj]\n",
  "UNCLEANLIEST": "UNCLEANLY, not clean in person or habits [adj]\n",
  "UNCLEANLINESS": "the state of being uncleanly [n -ES]\n",
  "UNCLEANLINESSES": "UNCLEANLINESS, the state of being uncleanly [n]\n",
  "UNCLEANLY": "not clean in person or habits [adj UNCLEANLIER, UNCLEANLIEST]\n",
  "UNCLEANNESS": "the state of being unclean [n -ES]\n",
  "UNCLEANNESSES": "UNCLEANNESS, the state of being unclean [n]\n",
  "UNCLEANSED": "not cleansed [adj]\n",
  "UNCLEAR": "not clear [adj UNCLEARER, UNCLEAREST, UNCLEARLY]\n",
  "UNCLEARED": "not cleared [adj]\n",
  "UNCLEARER": "UNCLEAR, not clear [adj]\n",
  "UNCLEAREST": "UNCLEAR, not clear [adj]\n",
  "UNCLEARLY": "UNCLEAR, not clear [adv]\n",
  "UNCLEARNESS": "the state of being unclear [n -ES]\n",
  "UNCLEARNESSES": "UNCLEARNESS, the state of being unclear [n]\n",
  "UNCLED": "UNCLE, to address as uncle [v]\n",
  "UNCLEFT": "not cleft [adj]\n",
  "UNCLENCH": "to open from a clenched position, also UNCLINCH [v -ED, -ING, -ES]\n",
  "UNCLENCHED": "UNCLENCH, to open from a clenched position, also UNCLINCH [v]\n",
  "UNCLENCHES": "UNCLENCH, to open from a clenched position, also UNCLINCH [v]\n",
  "UNCLENCHING": "UNCLENCH, to open from a clenched position, also UNCLINCH [v]\n",
  "UNCLERICAL": "not clerical [adj]\n",
  "UNCLES": "UNCLE, to address as uncle [v]\n",
  "UNCLESHIP": "the office or position of an uncle [n -S]\n",
  "UNCLESHIPS": "UNCLESHIP, the office or position of an uncle [n]\n",
  "UNCLEW": "(archaic) to unravel, undo [v -ED, -ING, -S]\n",
  "UNCLEWED": "UNCLEW, (archaic) to unravel, undo [v]\n",
  "UNCLEWING": "UNCLEW, (archaic) to unravel, undo [v]\n",
  "UNCLEWS": "UNCLEW, (archaic) to unravel, undo [v]\n",
  "UNCLICHED": "not cliched [adj]\n",
  "UNCLIMBABLE": "not able to be climbed [adj]\n",
  "UNCLIMBABLENESS": "the state of being unclimbable [n]\n",
  "UNCLIMBED": "not climbed [adj]\n",
  "UNCLINCH": "to open from a clenched position, also UNCLENCH [v -ED, -ING, -ES]\n",
  "UNCLINCHED": "UNCLINCH, to open from a clenched position, also UNCLENCH [v]\n",
  "UNCLINCHES": "UNCLINCH, to open from a clenched position, also UNCLENCH [v]\n",
  "UNCLINCHING": "UNCLINCH, to open from a clenched position, also UNCLENCH [v]\n",
  "UNCLING": "UNCLE, to address as uncle [v]\n",
  "UNCLIP": "to remove a fastening device [v UNCLIPPED, UNCLIPPING, UNCLIPS]\n",
  "UNCLIPPED": "UNCLIP, to remove a fastening device [v]\n",
  "UNCLIPPING": "UNCLIP, to remove a fastening device [v]\n",
  "UNCLIPS": "UNCLIP, to remove a fastening device [v]\n",
  "UNCLIPT": "unclipped [adj]\n",
  "UNCLOAK": "to remove a cloak from [v -ED, -ING, -S]\n",
  "UNCLOAKED": "UNCLOAK, to remove a cloak from [v]\n",
  "UNCLOAKING": "UNCLOAK, to remove a cloak from [v]\n",
  "UNCLOAKS": "UNCLOAK, to remove a cloak from [v]\n",
  "UNCLOG": "to free from obstruction [v UNCLOGGED, UNCLOGGING, UNCLOGS]\n",
  "UNCLOGGED": "UNCLOG, to free from obstruction [v]\n",
  "UNCLOGGING": "UNCLOG, to free from obstruction [v]\n",
  "UNCLOGS": "UNCLOG, to free from obstruction [v]\n",
  "UNCLOISTER": "to release from a cloister [v -ED, -ING, -S]\n",
  "UNCLOISTERED": "UNCLOISTER, to release from a cloister [v]\n",
  "UNCLOISTERING": "UNCLOISTER, to release from a cloister [v]\n",
  "UNCLOISTERS": "UNCLOISTER, to release from a cloister [v]\n",
  "UNCLONED": "not cloned [adj]\n",
  "UNCLOSE": "to open [v UNCLOSED, UNCLOSING, UNCLOSES]\n",
  "UNCLOSED": "UNCLOSE, to open [v]\n",
  "UNCLOSES": "UNCLOSE, to open [v]\n",
  "UNCLOSING": "UNCLOSE, to open [v]\n",
  "UNCLOTHE": "to divest of clothing [v UNCLOTHED or UNCLAD, UNCLOTHING, UNCLOTHES]\n",
  "UNCLOTHED": "UNCLOTHE, to divest of clothing [v]\n",
  "UNCLOTHES": "UNCLOTHE, to divest of clothing [v]\n",
  "UNCLOTHING": "UNCLOTHE, to divest of clothing [v]\n",
  "UNCLOUD": "to free from clouds [v -ED, -ING, -S]\n",
  "UNCLOUDED": "UNCLOUD, to free from clouds [v]\n",
  "UNCLOUDEDLY": "UNCLOUDED, UNCLOUD, to free from clouds [adv]\n",
  "UNCLOUDEDNESS": "the state of being unclouded [n -ES]\n",
  "UNCLOUDEDNESSES": "UNCLOUDEDNESS, the state of being unclouded [n]\n",
  "UNCLOUDIER": "UNCLOUDY, not cloudy [adj]\n",
  "UNCLOUDIEST": "UNCLOUDY, not cloudy [adj]\n",
  "UNCLOUDING": "UNCLOUD, to free from clouds [v]\n",
  "UNCLOUDS": "UNCLOUD, to free from clouds [v]\n",
  "UNCLOUDY": "not cloudy [adj UNCLOUDIER, UNCLOUDIEST]\n",
  "UNCLOVEN": "not cloven [adj]\n",
  "UNCLOYED": "not cloyed [adj]\n",
  "UNCLOYING": "not cloying [adj]\n",
  "UNCLUBABLE": "unsociable, not suitable for taking to a club, also UNCLUBBABLE [adj]\n",
  "UNCLUBBABLE": "unsociable, not suitable for taking to a club, also UNCLUBABLE [adj]\n",
  "UNCLUTCH": "to release from a clutch [v -ED, -ING, -ES]\n",
  "UNCLUTCHED": "UNCLUTCH, to release from a clutch [v]\n",
  "UNCLUTCHES": "UNCLUTCH, to release from a clutch [v]\n",
  "UNCLUTCHING": "UNCLUTCH, to release from a clutch [v]\n",
  "UNCLUTTER": "to rid of clutter [v -ED, -ING, -S]\n",
  "UNCLUTTERED": "UNCLUTTER, to rid of clutter [v]\n",
  "UNCLUTTERING": "UNCLUTTER, to rid of clutter [v]\n",
  "UNCLUTTERS": "UNCLUTTER, to rid of clutter [v]\n",
  "UNCO": "(Scots) strange; foreign; extraordinary [adj UNCOER, UNCOEST] / a stranger, a piece of news [n -ES or -S]\n",
  "UNCOALESCE": "to disintegrate, come apart [v UNCOALESCED, UNCOALESCING, UNCOALESCES]\n",
  "UNCOALESCED": "UNCOALESCE, to disintegrate, come apart [v]\n",
  "UNCOALESCES": "UNCOALESCE, to disintegrate, come apart [v]\n",
  "UNCOALESCING": "UNCOALESCE, to disintegrate, come apart [v]\n",
  "UNCOATED": "not coated [adj]\n",
  "UNCOATING": "the action of releasing viral nucleic acid from a virus or exposing the interior of a virus enough to facilitate replication by stripping away the outer layers of the viral coat [n -S]\n",
  "UNCOATINGS": "UNCOATING, the action of releasing viral nucleic acid from a virus or exposing the interior of a virus enough to facilitate replication by stripping away the outer layers of the viral coat [n]\n",
  "UNCOBBLED": "not cobbled [adj]\n",
  "UNCOCK": "to remove from a cocked position [v -ED, -ING, -S]\n",
  "UNCOCKED": "UNCOCK, to remove from a cocked position [v]\n",
  "UNCOCKING": "UNCOCK, to remove from a cocked position [v]\n",
  "UNCOCKS": "UNCOCK, to remove from a cocked position [v]\n",
  "UNCODED": "not coded [adj]\n",
  "UNCODIFIED": "not codified [adj]\n",
  "UNCOER": "UNCO, (Scots) strange; foreign; extraordinary [adj]\n",
  "UNCOERCED": "not coerced [adj]\n",
  "UNCOERCIVE": "not coercive [adj UNCOERCIVELY]\n",
  "UNCOERCIVELY": "UNCOERCIVE, not coercive [adv]\n",
  "UNCOES": "UNCO, a stranger, a piece of news [n]\n",
  "UNCOEST": "UNCO, (Scots) strange; foreign; extraordinary [adj]\n",
  "UNCOFFIN": "to remove from a coffin [v -ED, -ING, -S]\n",
  "UNCOFFINED": "UNCOFFIN, to remove from a coffin [v]\n",
  "UNCOFFINING": "UNCOFFIN, to remove from a coffin [v]\n",
  "UNCOFFINS": "UNCOFFIN, to remove from a coffin [v]\n",
  "UNCOIL": "to release from a coiled position [v -ED, -ING, -S]\n",
  "UNCOILED": "UNCOIL, to release from a coiled position [v]\n",
  "UNCOILING": "UNCOIL, to release from a coiled position [v]\n",
  "UNCOILS": "UNCOIL, to release from a coiled position [v]\n",
  "UNCOINED": "not coined, also UNCOYNED [adj]\n",
  "UNCOLLECTABLE": "not collectable [adj]\n",
  "UNCOLLECTABLES": "things that are not collectable [n]\n",
  "UNCOLLECTED": "not collected [adj]\n",
  "UNCOLLECTIBLE": "not collectible [adj]\n",
  "UNCOLLECTIBLES": "things that are not collectible [n]\n",
  "UNCOLORED": "not colored, also UNCOLOURED [adj]\n",
  "UNCOLOURED": "not coloured, also UNCOLORED [adj]\n",
  "UNCOLT": "(Shakespeare) to unhorse [v -ED, -ING, -S]\n",
  "UNCOLTED": "UNCOLT, (Shakespeare) to unhorse [v]\n",
  "UNCOLTING": "UNCOLT, (Shakespeare) to unhorse [v]\n",
  "UNCOLTS": "UNCOLT, (Shakespeare) to unhorse [v]\n",
  "UNCOMATABLE": "inaccessible; out of reach, also UNCOMEATABLE [adj]\n",
  "UNCOMBATIVE": "not combative [adj]\n",
  "UNCOMBED": "not combed [adj]\n",
  "UNCOMBINE": "(Dickens) to separate [v UNCOMBINED, UNCOMBINING, UNCOMBINES]\n",
  "UNCOMBINED": "UNCOMBINE, (Dickens) to separate [v]\n",
  "UNCOMBINES": "UNCOMBINE, (Dickens) to separate [v]\n",
  "UNCOMBINING": "UNCOMBINE, (Dickens) to separate [v]\n",
  "UNCOMEATABLE": "inaccessible; out of reach, also UNCOMATABLE [adj]\n",
  "UNCOMELIER": "UNCOMELY, not comely [adj]\n",
  "UNCOMELIEST": "UNCOMELY, not comely [adj]\n",
  "UNCOMELINESS": "the state of being uncomely [n -ES]\n",
  "UNCOMELINESSES": "UNCOMELINESS, the state of being uncomely [n]\n",
  "UNCOMELY": "not comely [adj UNCOMELIER, UNCOMELIEST]\n",
  "UNCOMFIER": "UNCOMFY, (colloquial) not comfortable [adj]\n",
  "UNCOMFIEST": "UNCOMFY, (colloquial) not comfortable [adj]\n",
  "UNCOMFORTABLE": "causing discomfort or annoyance [adj UNCOMFORTABLY]\n",
  "UNCOMFORTABLY": "UNCOMFORTABLE, causing discomfort or annoyance [adv]\n",
  "UNCOMFORTED": "not comforted [adj]\n",
  "UNCOMFY": "(colloquial) not comfortable [adj UNCOMFIER, UNCOMFIEST]\n",
  "UNCOMIC": "not funny [adj]\n",
  "UNCOMMENDABLE": "that cannot be commended [adj UNCOMMENDABLY]\n",
  "UNCOMMENDABLY": "UNCOMMENDABLE, that cannot be commended [adv]\n",
  "UNCOMMENDED": "not commended [adj]\n",
  "UNCOMMERCIAL": "not engaged in or related to commerce [adj]\n",
  "UNCOMMITTED": "not committed [adj]\n",
  "UNCOMMON": "not common [adj UNCOMMONER, UNCOMMONEST, UNCOMMONLY]\n",
  "UNCOMMONER": "UNCOMMON, not common [adj]\n",
  "UNCOMMONEST": "UNCOMMON, not common [adj]\n",
  "UNCOMMONLY": "UNCOMMON, not common [adv]\n",
  "UNCOMMONNESS": "the state of being uncommon [n -ES]\n",
  "UNCOMMONNESSES": "UNCOMMONNESS, the state of being uncommon [n]\n",
  "UNCOMMUNICABLE": "incommunicable [adj]\n",
  "UNCOMMUNICATED": "not communicated [adj]\n",
  "UNCOMMUNICATIVE": "not disposed to talk or impart information, also INCOMMUNICATIVE [adj]\n",
  "UNCOMMUTED": "not commuted [adj]\n",
  "UNCOMPACTED": "not compacted [adj]\n",
  "UNCOMPANIED": "unaccompanied [adj]\n",
  "UNCOMPANIONABLE": "not companionable [adj]\n",
  "UNCOMPANIONED": "not companioned [adj]\n",
  "UNCOMPASSIONATE": "not compassionate [adj]\n",
  "UNCOMPELLED": "not compelled [adj]\n",
  "UNCOMPELLING": "not compelling [adj]\n",
  "UNCOMPENSATED": "not compensated [adj]\n",
  "UNCOMPETITIVE": "not competitive [adj]\n",
  "UNCOMPLACENT": "not complacent [adj]\n",
  "UNCOMPLAINING": "not complaining [adj UNCOMPLAININGLY]\n",
  "UNCOMPLAININGLY": "UNCOMPLAINING, not complaining [adv]\n",
  "UNCOMPLAISANT": "not complaisant [adj UNCOMPLAISANTLY]\n",
  "UNCOMPLAISANTLY": "UNCOMPLAISANT, not complaisant [adv]\n",
  "UNCOMPLETED": "not completed [adj]\n",
  "UNCOMPLIANT": "not compliant [adj]\n",
  "UNCOMPLICATED": "not complicated by something outside itself [adj]\n",
  "UNCOMPLIMENTARY": "not complimentary [adj]\n",
  "UNCOMPLYING": "not complying [adj]\n",
  "UNCOMPOSABLE": "that cannot be composed [adj]\n",
  "UNCOMPOUNDED": "not compounded [adj]\n",
  "UNCOMPREHENDED": "not comprehended [adj]\n",
  "UNCOMPREHENDING": "not comprehending [adj]\n",
  "UNCOMPREHENSIVE": "not comprehensive [adj]\n",
  "UNCOMPROMISABLE": "not able to be compromised [adj]\n",
  "UNCOMPROMISING": "not making or accepting a compromise [adj]\n",
  "UNCOMPUTERISED": "not computerised, also UNCOMPUTERIZED [adj]\n",
  "UNCOMPUTERIZED": "not computerized, also UNCOMPUTERISED [adj]\n",
  "UNCONCEALABLE": "not concealable [adj]\n",
  "UNCONCEALED": "not concealed [adj]\n",
  "UNCONCEALING": "not concealing [adj]\n",
  "UNCONCEIVABLE": "not conceivable, also INCONCEIVABLE [adj UNCONCEIVABLY]\n",
  "UNCONCEIVABLY": "UNCONCEIVABLE, not conceivable, also INCONCEIVABLE [adv]\n",
  "UNCONCEIVED": "not conceived [adj]\n",
  "UNCONCERN": "lack of concern [n -S]\n",
  "UNCONCERNED": "not involved [adj UNCONCERNEDLY]\n",
  "UNCONCERNEDLY": "UNCONCERNED, not involved [adv]\n",
  "UNCONCERNEDNESS": "the state of being unconcerned [n]\n",
  "UNCONCERNING": "not concerning [adj]\n",
  "UNCONCERNMENT": "not concernment [n -S]\n",
  "UNCONCERNMENTS": "UNCONCERNMENT, not concernment [n]\n",
  "UNCONCERNS": "UNCONCERN, lack of concern [n]\n",
  "UNCONCERTED": "not concerted [adj]\n",
  "UNCONCILIATORY": "not conciliatory [adj]\n",
  "UNCONCLUSIVE": "not conclusive [adj]\n",
  "UNCONCOCTED": "not concocted [adj]\n",
  "UNCONDITIONAL": "not conditional or limited [adj UNCONDITIONALLY]\n",
  "UNCONDITIONALLY": "UNCONDITIONAL, not conditional or limited [adv]\n",
  "UNCONDITIONED": "not subject to conditions or limitations [adj]\n",
  "UNCONDUCIVE": "not conducive [adj]\n",
  "UNCONFEDERATED": "not confederated [adj]\n",
  "UNCONFESSED": "not having been confessed [adj]\n",
  "UNCONFINABLE": "not confinable [adj]\n",
  "UNCONFINE": "to free from confinement [v UNCONFINED, UNCONFINING, UNCONFINES]\n",
  "UNCONFINED": "UNCONFINE, to free from confinement [v]\n",
  "UNCONFINEDLY": "UNCONFINED, UNCONFINE, to free from confinement [adv]\n",
  "UNCONFINES": "UNCONFINE, to free from confinement [v]\n",
  "UNCONFINING": "UNCONFINE, to free from confinement [v]\n",
  "UNCONFIRMED": "not confirmed [adj]\n",
  "UNCONFORM": "(Milton) unlike [adj]\n",
  "UNCONFORMABLE": "not conforming [adj UNCONFORMABLY]\n",
  "UNCONFORMABLY": "UNCONFORMABLE, not conforming [adv]\n",
  "UNCONFORMING": "not conforming [adj]\n",
  "UNCONFORMITIES": "UNCONFORMITY, a buried erosion surface separating two rock masses [n]\n",
  "UNCONFORMITY": "a buried erosion surface separating two rock masses [n UNCONFORMITIES]\n",
  "UNCONFOUNDED": "not confounded [adj]\n",
  "UNCONFUSE": "to remove the confusion from [v UNCONFUSED, UNCONFUSING, UNCONFUSES]\n",
  "UNCONFUSED": "UNCONFUSE, to remove the confusion from [v]\n",
  "UNCONFUSEDLY": "UNCONFUSED, UNCONFUSE, to remove the confusion from [adv]\n",
  "UNCONFUSES": "UNCONFUSE, to remove the confusion from [v]\n",
  "UNCONFUSING": "UNCONFUSE, to remove the confusion from [v]\n",
  "UNCONGEAL": "to thaw; to become liquid again [v -ED, -ING, -S]\n",
  "UNCONGEALED": "UNCONGEAL, to thaw; to become liquid again [v]\n",
  "UNCONGEALING": "UNCONGEAL, to thaw; to become liquid again [v]\n",
  "UNCONGEALS": "UNCONGEAL, to thaw; to become liquid again [v]\n",
  "UNCONGENIAL": "not sympathetic or compatible [adj]\n",
  "UNCONGENIALITY": "the state of being uncongenial [n]\n",
  "UNCONJECTURED": "not conjectured [adj]\n",
  "UNCONJUGAL": "(Milton) not conjugal [adj]\n",
  "UNCONJUGATED": "not conjugated [adj]\n",
  "UNCONJUNCTIVE": "(Milton) impossible to be joined [adj]\n",
  "UNCONNECTED": "not connected [adj UNCONNECTEDLY]\n",
  "UNCONNECTEDLY": "UNCONNECTED, not connected [adv]\n",
  "UNCONNECTEDNESS": "the state of being unconnected [n]\n",
  "UNCONNIVING": "(Milton) refusing indulgence [adj]\n",
  "UNCONQUERABLE": "incapable of being conquered [adj UNCONQUERABLY]\n",
  "UNCONQUERABLY": "UNCONQUERABLE, incapable of being conquered [adv]\n",
  "UNCONQUERED": "not conquered [adj]\n",
  "UNCONSCIENTIOUS": "not conscientious [adj]\n",
  "UNCONSCIONABLE": "showing no regard for conscience; excessive [adj UNCONSCIONABLY]\n",
  "UNCONSCIONABLY": "UNCONSCIONABLE, showing no regard for conscience; excessive [adv]\n",
  "UNCONSCIOUS": "not conscious, also INCONSCIOUS [adj UNCONSCIOUSLY] / the part of mental life that does not ordinarily enter the individual's awareness yet may influence behavior and perception or be revealed (as in slips of the tongue or in dreams) [n -ES]\n",
  "UNCONSCIOUSES": "UNCONSCIOUS, the part of mental life that does not ordinarily enter the individual's awareness yet may influence behavior and perception or be revealed (as in slips of the tongue or in dreams) [n]\n",
  "UNCONSCIOUSLY": "UNCONSCIOUS, not conscious, also INCONSCIOUS [adv]\n",
  "UNCONSCIOUSNESS": "the state of being unconscious [n]\n",
  "UNCONSECRATE": "to undo the consecration of [v UNCONSECRATED, UNCONSECRATING, UNCONSECRATES]\n",
  "UNCONSECRATED": "not consecrated [adj]\n",
  "UNCONSECRATES": "UNCONSECRATE, to undo the consecration of [v]\n",
  "UNCONSECRATING": "UNCONSECRATE, to undo the consecration of [v]\n",
  "UNCONSENTANEOUS": "not in agreement [adj]\n",
  "UNCONSENTING": "not consenting [adj]\n",
  "UNCONSIDERED": "not considered or worth consideration [adj]\n",
  "UNCONSIDERING": "not considering [adj]\n",
  "UNCONSOLED": "not consoled [adj]\n",
  "UNCONSOLIDATED": "loosely arranged [adj]\n",
  "UNCONSTANT": "(Shakespeare) inconstant, also INCONSTANT [adj]\n",
  "UNCONSTRAINABLE": "not constrainable [adj]\n",
  "UNCONSTRAINED": "not constrained [adj UNCONSTRAINEDLY]\n",
  "UNCONSTRAINEDLY": "UNCONSTRAINED, not constrained [adv]\n",
  "UNCONSTRAINT": "freedom from constraint [n -S]\n",
  "UNCONSTRAINTS": "UNCONSTRAINT, freedom from constraint [n]\n",
  "UNCONSTRICTED": "not constricted [adj]\n",
  "UNCONSTRUCTED": "manufactured without added material for padding, stiffening, or shape retention [adj]\n",
  "UNCONSTRUCTIVE": "not constructive [adj]\n",
  "UNCONSUMED": "not consumed [adj]\n",
  "UNCONSUMMATED": "not consummated [adj]\n",
  "UNCONTAINABLE": "not containable [adj]\n",
  "UNCONTAMINATED": "not contaminated [adj]\n",
  "UNCONTEMNED": "(Shakespeare) not despised [adj]\n",
  "UNCONTEMPLATED": "not contemplated [adj]\n",
  "UNCONTEMPORARY": "not contemporary [adj]\n",
  "UNCONTENTIOUS": "not contentious [adj]\n",
  "UNCONTESTABLE": "not contestable [adj]\n",
  "UNCONTESTED": "not contested [adj]\n",
  "UNCONTRACTED": "not contracted [adj]\n",
  "UNCONTRADICTED": "not contradicted [adj]\n",
  "UNCONTRIVED": "not contrived [adj]\n",
  "UNCONTROLLABLE": "incapable of being controlled, also INCONTROLLABLE [adj UNCONTROLLABLY]\n",
  "UNCONTROLLABLY": "UNCONTROLLABLE, incapable of being controlled, also INCONTROLLABLE [adv]\n",
  "UNCONTROLLED": "not controlled [adj UNCONTROLLEDLY]\n",
  "UNCONTROLLEDLY": "UNCONTROLLED, not controlled [adv]\n",
  "UNCONTROVERSIAL": "not controversial [adj]\n",
  "UNCONTROVERTED": "not controverted [adj]\n",
  "UNCONVENTIONAL": "not conventional [adj]\n",
  "UNCONVERSABLE": "not conversable [adj]\n",
  "UNCONVERSANT": "not conversant [adj]\n",
  "UNCONVERTED": "not converted [adj]\n",
  "UNCONVERTIBLE": "not convertible [adj]\n",
  "UNCONVICTED": "not convicted [adj]\n",
  "UNCONVINCED": "not convinced [adj]\n",
  "UNCONVINCING": "not convincing [adj UNCONVINCINGLY]\n",
  "UNCONVINCINGLY": "UNCONVINCING, not convincing [adv]\n",
  "UNCONVOYED": "not convoyed [adj]\n",
  "UNCOOKED": "not cooked [adj]\n",
  "UNCOOL": "not cool [adj]\n",
  "UNCOOLED": "not cooled [adj]\n",
  "UNCOOPERATIVE": "not cooperative [adj UNCOOPERATIVELY]\n",
  "UNCOOPERATIVELY": "UNCOOPERATIVE, not cooperative [adv]\n",
  "UNCOORDINATED": "not coordinated [adj]\n",
  "UNCOPE": "to unmuzzle or unsew the mouth (of a ferret) [v UNCOPED, UNCOPING, UNCOPES]\n",
  "UNCOPED": "UNCOPE, to unmuzzle or unsew the mouth (of a ferret) [v]\n",
  "UNCOPES": "UNCOPE, to unmuzzle or unsew the mouth (of a ferret) [v]\n",
  "UNCOPING": "UNCOPE, to unmuzzle or unsew the mouth (of a ferret) [v]\n",
  "UNCOPYRIGHTABLE": "not copyrightable [adj]\n",
  "UNCOQUETTISH": "not coquettish [adj]\n",
  "UNCORD": "to free from cords [v -ED, -ING, -S]\n",
  "UNCORDED": "UNCORD, to free from cords [v]\n",
  "UNCORDIAL": "not cordial [adj]\n",
  "UNCORDING": "UNCORD, to free from cords [v]\n",
  "UNCORDS": "UNCORD, to free from cords [v]\n",
  "UNCORK": "to draw the cork [v -ED, -ING, -S]\n",
  "UNCORKED": "UNCORK, to draw the cork [v]\n",
  "UNCORKING": "UNCORK, to draw the cork [v]\n",
  "UNCORKS": "UNCORK, to draw the cork [v]\n",
  "UNCORRECTABLE": "not correctable [adj]\n",
  "UNCORRECTED": "not corrected [adj]\n",
  "UNCORRELATED": "not correlated [adj]\n",
  "UNCORROBORATED": "not corroborated [adj]\n",
  "UNCORRUPT": "not corrupt, also INCORRUPT [adj]\n",
  "UNCORRUPTED": "not corrupted [adj]\n",
  "UNCORSETED": "not wearing a corset [adj]\n",
  "UNCOS": "UNCO, a stranger, a piece of news [n]\n",
  "UNCOSTLIER": "UNCOSTLY, not costly [adj]\n",
  "UNCOSTLIEST": "UNCOSTLY, not costly [adj]\n",
  "UNCOSTLY": "not costly [adj UNCOSTLIER, UNCOSTLIEST]\n",
  "UNCOUNSELLED": "not counselled [adj]\n",
  "UNCOUNTABLE": "not countable [adj]\n",
  "UNCOUNTED": "not counted, countless [adj]\n",
  "UNCOUPLE": "to disconnect [v UNCOUPLED, UNCOUPLING, UNCOUPLES]\n",
  "UNCOUPLED": "UNCOUPLE, to disconnect [v]\n",
  "UNCOUPLER": "a device for uncoupling [n -S]\n",
  "UNCOUPLERS": "UNCOUPLER, a device for uncoupling [n]\n",
  "UNCOUPLES": "UNCOUPLE, to disconnect [v]\n",
  "UNCOUPLING": "UNCOUPLE, to disconnect [v]\n",
  "UNCOURAGEOUS": "not courageous [adj]\n",
  "UNCOURTEOUS": "not courteous [adj]\n",
  "UNCOURTLIER": "UNCOURTLY, not courtly [adj]\n",
  "UNCOURTLIEST": "UNCOURTLY, not courtly [adj]\n",
  "UNCOURTLINESS": "the state of being uncourtly [n -ES]\n",
  "UNCOURTLINESSES": "UNCOURTLINESS, the state of being uncourtly [n]\n",
  "UNCOURTLY": "not courtly [adj UNCOURTLIER, UNCOURTLIEST]\n",
  "UNCOUTH": "uncultured [adj UNCOUTHER, UNCOUTHEST, UNCOUTHLY]\n",
  "UNCOUTHER": "UNCOUTH, uncultured [adj]\n",
  "UNCOUTHEST": "UNCOUTH, uncultured [adj]\n",
  "UNCOUTHLY": "UNCOUTH, uncultured [adv]\n",
  "UNCOUTHNESS": "the state of being uncouth [n -ES]\n",
  "UNCOUTHNESSES": "UNCOUTHNESS, the state of being uncouth [n]\n",
  "UNCOVENANTED": "not covenanted [adj]\n",
  "UNCOVER": "to remove the covering [v -ED, -ING, -S]\n",
  "UNCOVERED": "UNCOVER, to remove the covering [v]\n",
  "UNCOVERING": "UNCOVER, to remove the covering [v]\n",
  "UNCOVERS": "UNCOVER, to remove the covering [v]\n",
  "UNCOWL": "to remove the cowl from [v -ED, -ING, -S]\n",
  "UNCOWLED": "UNCOWL, to remove the cowl from [v]\n",
  "UNCOWLING": "UNCOWL, to remove the cowl from [v]\n",
  "UNCOWLS": "UNCOWL, to remove the cowl from [v]\n",
  "UNCOY": "not coy [adj]\n",
  "UNCOYNED": "(Shakespeare) uncoined [adj]\n",
  "UNCRACKED": "not cracked [adj]\n",
  "UNCRATE": "to remove from a crate [v UNCRATED, UNCRATING, UNCRATES]\n",
  "UNCRATED": "UNCRATE, to remove from a crate [v]\n",
  "UNCRATES": "UNCRATE, to remove from a crate [v]\n",
  "UNCRATING": "UNCRATE, to remove from a crate [v]\n",
  "UNCRAZIER": "UNCRAZY, not crazy [adj]\n",
  "UNCRAZIEST": "UNCRAZY, not crazy [adj]\n",
  "UNCRAZY": "not crazy [adj UNCRAZIER, UNCRAZIEST]\n",
  "UNCREASED": "not creased [adj]\n",
  "UNCREATE": "to deprive of existence [v UNCREATED, UNCREATING, UNCREATES]\n",
  "UNCREATED": "UNCREATE, to deprive of existence [v]\n",
  "UNCREATEDNESS": "the state of being uncreated [n -ES]\n",
  "UNCREATEDNESSES": "UNCREATEDNESS, the state of being uncreated [n]\n",
  "UNCREATES": "UNCREATE, to deprive of existence [v]\n",
  "UNCREATING": "UNCREATE, to deprive of existence [v]\n",
  "UNCREATIVE": "not creative [adj]\n",
  "UNCREDENTIALED": "not having credentials [adj]\n",
  "UNCREDIBLE": "(obsolete) incredible [adj]\n",
  "UNCREDITABLE": "(obsolete) discreditable, also DISCREDITABLE [adj]\n",
  "UNCREDITED": "not credited [adj]\n",
  "UNCREWED": "not crewed [adj]\n",
  "UNCRIPPLED": "not crippled [adj]\n",
  "UNCRITICAL": "not critical [adj UNCRITICALLY]\n",
  "UNCRITICALLY": "UNCRITICAL, not critical [adv]\n",
  "UNCROPPED": "not cropped [adj]\n",
  "UNCROSS": "to change from a crossed position [v -ED, -ING, -ES]\n",
  "UNCROSSABLE": "that cannot be crossed [adj]\n",
  "UNCROSSED": "UNCROSS, to change from a crossed position [v]\n",
  "UNCROSSES": "UNCROSS, to change from a crossed position [v]\n",
  "UNCROSSING": "UNCROSS, to change from a crossed position [v]\n",
  "UNCROWDED": "not crowded [adj]\n",
  "UNCROWN": "to deprive of a crown [v -ED, -ING, -S]\n",
  "UNCROWNED": "UNCROWN, to deprive of a crown [v]\n",
  "UNCROWNING": "UNCROWN, to deprive of a crown [v]\n",
  "UNCROWNS": "UNCROWN, to deprive of a crown [v]\n",
  "UNCRUDDED": "(Spenser) uncurdled [adj]\n",
  "UNCRUMPLE": "to smooth out, remove the crumpling from [v UNCRUMPLED, UNCRUMPLING, UNCRUMPLES]\n",
  "UNCRUMPLED": "UNCRUMPLE, to smooth out, remove the crumpling from [v]\n",
  "UNCRUMPLES": "UNCRUMPLE, to smooth out, remove the crumpling from [v]\n",
  "UNCRUMPLING": "UNCRUMPLE, to smooth out, remove the crumpling from [v]\n",
  "UNCRUSHABLE": "not crushable [adj]\n",
  "UNCRUSHED": "not crushed [adj]\n",
  "UNCRYSTALLISED": "not crystallised, also UNCRYSTALLIZED [adj]\n",
  "UNCRYSTALLIZED": "not crystallized, also UNCRYSTALLISED [adj]\n",
  "UNCTION": "anointing as a rite of consecration or healing [n -S]\n",
  "UNCTIONLESS": "without unction [adj]\n",
  "UNCTIONS": "UNCTION, anointing as a rite of consecration or healing [n]\n",
  "UNCTUOSITIES": "UNCTUOSITY, the state of being unctuous [n]\n",
  "UNCTUOSITY": "the state of being unctuous [n UNCTUOSITIES]\n",
  "UNCTUOUS": "fatty, oily; marked by a smug, ingratiating and false earnestness [adj UNCTUOUSLY]\n",
  "UNCTUOUSLY": "UNCTUOUS, fatty, oily; marked by a smug, ingratiating and false earnestness [adv]\n",
  "UNCTUOUSNESS": "the state of being unctuous [n -ES]\n",
  "UNCTUOUSNESSES": "UNCTUOUSNESS, the state of being unctuous [n]\n",
  "UNCUCKOLDED": "not cuckolded [adj]\n",
  "UNCUFF": "to remove handcuffs from [v -ED, -ING, -S]\n",
  "UNCUFFED": "UNCUFF, to remove handcuffs from [v]\n",
  "UNCUFFING": "UNCUFF, to remove handcuffs from [v]\n",
  "UNCUFFS": "UNCUFF, to remove handcuffs from [v]\n",
  "UNCULLED": "not culled [adj]\n",
  "UNCULTIVABLE": "not cultivable [adj]\n",
  "UNCULTIVATABLE": "not cultivatable [adj]\n",
  "UNCULTIVATED": "not cultivated [adj]\n",
  "UNCULTURED": "not cultured [adj]\n",
  "UNCUMBERED": "not cumbered [adj]\n",
  "UNCURABLE": "(Shakespeare) not curable, also INCURABLE [adj UNCURABLY]\n",
  "UNCURABLY": "UNCURABLE, (Shakespeare) not curable, also INCURABLE [adv]\n",
  "UNCURB": "to remove restraints from [v -ED, -ING, -S]\n",
  "UNCURBABLE": "not capable of being curbed [adj]\n",
  "UNCURBED": "UNCURB, to remove restraints from [v]\n",
  "UNCURBING": "UNCURB, to remove restraints from [v]\n",
  "UNCURBS": "UNCURB, to remove restraints from [v]\n",
  "UNCURDLED": "not curdled [adj]\n",
  "UNCURED": "not cured [adj]\n",
  "UNCURIOUS": "not curious, also INCURIOUS [adj]\n",
  "UNCURL": "to straighten the curls of [v -ED, -ING, -S]\n",
  "UNCURLED": "UNCURL, to straighten the curls of [v]\n",
  "UNCURLING": "UNCURL, to straighten the curls of [v]\n",
  "UNCURLS": "UNCURL, to straighten the curls of [v]\n",
  "UNCURRENT": "not current e.g. uncurrent notes [adj]\n",
  "UNCURSE": "to free from a curse [v UNCURSED, UNCURSING, UNCURSES]\n",
  "UNCURSED": "UNCURSE, to free from a curse [v]\n",
  "UNCURSES": "UNCURSE, to free from a curse [v]\n",
  "UNCURSING": "UNCURSE, to free from a curse [v]\n",
  "UNCURTAILED": "not curtailed [adj]\n",
  "UNCURTAIN": "to remove a curtain from; to reveal [v -ED, -ING, -S]\n",
  "UNCURTAINED": "UNCURTAIN, to remove a curtain from; to reveal [v]\n",
  "UNCURTAINING": "UNCURTAIN, to remove a curtain from; to reveal [v]\n",
  "UNCURTAINS": "UNCURTAIN, to remove a curtain from; to reveal [v]\n",
  "UNCURVED": "not curved [adj]\n",
  "UNCUS": "(Latin) a hook-shaped anatomical part [n UNCI]\n",
  "UNCUSTOMARILY": "UNCUSTOMARY, not customary [adv]\n",
  "UNCUSTOMARY": "not customary [adj UNCUSTOMARILY]\n",
  "UNCUSTOMED": "not liable to or not having paid duty or customs [adj]\n",
  "UNCUT": "not cut [adj]\n",
  "UNCUTE": "not cute [adj]\n",
  "UNCYNICAL": "not cynical [adj UNCYNICALLY]\n",
  "UNCYNICALLY": "UNCYNICAL, not cynical [adv]\n",
  "UNDAM": "to free water from a dam [v UNDAMMED, UNDAMMING, UNDAMS]\n",
  "UNDAMAGED": "not damaged [adj]\n",
  "UNDAMMED": "UNDAM, to free water from a dam [v]\n",
  "UNDAMMING": "UNDAM, to free water from a dam [v]\n",
  "UNDAMNED": "not damned [adj]\n",
  "UNDAMPED": "not damped [adj]\n",
  "UNDAMS": "UNDAM, to free water from a dam [v]\n",
  "UNDANCEABLE": "that cannot be danced [adj]\n",
  "UNDARING": "not daring [adj]\n",
  "UNDASHED": "not dashed, e.g. of hopes [adj]\n",
  "UNDATABLE": "not datable [adj]\n",
  "UNDATE": "to remove a date from [v UNDATED, UNDATING, UNDATES]\n",
  "UNDATED": "UNDATE, to remove a date from [v]\n",
  "UNDATES": "UNDATE, to remove a date from [v]\n",
  "UNDATING": "UNDATE, to remove a date from [v]\n",
  "UNDAUNTABLE": "that cannot be daunted [adj]\n",
  "UNDAUNTED": "not daunted [adj UNDAUNTEDLY]\n",
  "UNDAUNTEDLY": "UNDAUNTED, not daunted [adv]\n",
  "UNDAUNTEDNESS": "the state of being undaunted [n -ES]\n",
  "UNDAUNTEDNESSES": "UNDAUNTEDNESS, the state of being undaunted [n]\n",
  "UNDAUNTING": "not daunting [adj]\n",
  "UNDAWNING": "not yet dawning [adj]\n",
  "UNDAZZLE": "to recover from being dazed [v UNDAZZLED, UNDAZZLING, UNDAZZLES]\n",
  "UNDAZZLED": "UNDAZZLE, to recover from being dazed [v]\n",
  "UNDAZZLES": "UNDAZZLE, to recover from being dazed [v]\n",
  "UNDAZZLING": "UNDAZZLE, to recover from being dazed [v]\n",
  "UNDE": "in heraldry, wavy, also OUNDY, UNDEE, UNDY [adj]\n",
  "UNDEAD": "a vampire [n UNDEAD]\n",
  "UNDEAF": "(Shakespeare) to free from deafness [v -ED, -ING, -S]\n",
  "UNDEAFED": "UNDEAF, (Shakespeare) to free from deafness [v]\n",
  "UNDEAFING": "UNDEAF, (Shakespeare) to free from deafness [v]\n",
  "UNDEAFS": "UNDEAF, (Shakespeare) to free from deafness [v]\n",
  "UNDEALT": "not dealt [adj]\n",
  "UNDEAR": "not dear [adj]\n",
  "UNDEBARRED": "not debarred [adj]\n",
  "UNDEBASED": "not debased [adj]\n",
  "UNDEBATABLE": "that cannot be debated [adj UNDEBATABLY]\n",
  "UNDEBATABLY": "UNDEBATABLE, that cannot be debated [adv]\n",
  "UNDEBATED": "not debated [adj]\n",
  "UNDEBAUCHED": "not debauched [adj]\n",
  "UNDECADENT": "not decadent [adj]\n",
  "UNDECAGON": "a polygon having eleven sides [n -S]\n",
  "UNDECAGONS": "UNDECAGON, a polygon having eleven sides [n]\n",
  "UNDECAYED": "not decayed [adj]\n",
  "UNDECEIVABLE": "not deceivable [adj]\n",
  "UNDECEIVE": "to free from deception [v UNDECEIVED, UNDECEIVING, UNDECEIVES]\n",
  "UNDECEIVED": "UNDECEIVE, to free from deception [v]\n",
  "UNDECEIVER": "one who undeceives [n -S]\n",
  "UNDECEIVERS": "UNDECEIVER, one who undeceives [n]\n",
  "UNDECEIVES": "UNDECEIVE, to free from deception [v]\n",
  "UNDECEIVING": "UNDECEIVE, to free from deception [v]\n",
  "UNDECENT": "not decent, also INDECENT [adj]\n",
  "UNDECIDABILITY": "the quality of being undecidable [n]\n",
  "UNDECIDABLE": "not decidable [adj]\n",
  "UNDECIDED": "not decided [adj UNDECIDEDLY] / one who is not decided [n -S]\n",
  "UNDECIDEDLY": "UNDECIDED, not decided [adv]\n",
  "UNDECIDEDNESS": "the state of being undecided [n -ES]\n",
  "UNDECIDEDNESSES": "UNDECIDEDNESS, the state of being undecided [n]\n",
  "UNDECIDEDS": "UNDECIDED, one who is not decided [n]\n",
  "UNDECILLION": "a large number - a one followed by either 36 or 66 zeroes [n -S]\n",
  "UNDECILLIONS": "UNDECILLION, a large number - a one followed by either 36 or 66 zeroes [n]\n",
  "UNDECIMAL": "based on the number eleven [adj]\n",
  "UNDECIMOLE": "a group of eleven notes, in the time of eight [n -S]\n",
  "UNDECIMOLES": "UNDECIMOLE, a group of eleven notes, in the time of eight [n]\n",
  "UNDECIPHERABLE": "not decipherable [adj]\n",
  "UNDECIPHERED": "not deciphered [adj]\n",
  "UNDECISIVE": "indecisive [adj]\n",
  "UNDECK": "to rid or ornaments [v -ED, -ING, -S]\n",
  "UNDECKED": "UNDECK, to rid or ornaments [v]\n",
  "UNDECKING": "UNDECK, to rid or ornaments [v]\n",
  "UNDECKS": "UNDECK, to rid or ornaments [v]\n",
  "UNDECLARED": "not declared [adj]\n",
  "UNDECLINING": "not declining [adj]\n",
  "UNDECOMPOSABLE": "not decomposable [adj]\n",
  "UNDECOMPOSED": "not decomposed [adj]\n",
  "UNDECORATED": "not decorated [adj]\n",
  "UNDEDICATED": "not dedicated [adj]\n",
  "UNDEE": "in heraldry, wavy, also OUNDY, UNDE, UNDY [adj]\n",
  "UNDEEDED": "(Shakespeare) unused in any action [adj]\n",
  "UNDEFACED": "not defaced [adj]\n",
  "UNDEFEATABLE": "not able to be defeated [adj]\n",
  "UNDEFEATED": "not defeated [adj]\n",
  "UNDEFENDED": "not defended [adj]\n",
  "UNDEFIDE": "(Spenser) not defied [adj]\n",
  "UNDEFIED": "not defied [adj]\n",
  "UNDEFILED": "not defiled [adj]\n",
  "UNDEFINABLE": "not definable, also INDEFINABLE [adj]\n",
  "UNDEFINED": "not defined [adj]\n",
  "UNDEFOLIATED": "not defoliated [adj]\n",
  "UNDEFORMED": "not deformed [adj]\n",
  "UNDEIFIED": "UNDEIFY, to deprive of the nature of a god [v]\n",
  "UNDEIFIES": "UNDEIFY, to deprive of the nature of a god [v]\n",
  "UNDEIFY": "to deprive of the nature of a god [v UNDEIFIED, UNDEIFYING, UNDEIFIES]\n",
  "UNDEIFYING": "UNDEIFY, to deprive of the nature of a god [v]\n",
  "UNDELAYED": "not delayed [adj]\n",
  "UNDELAYING": "not delaying [adj]\n",
  "UNDELECTABLE": "not delectable [adj]\n",
  "UNDELEGATED": "not delegated [adj]\n",
  "UNDELETE": "to undo the deletion of a computer file [v UNDELETED, UNDELETING, UNDELETES]\n",
  "UNDELETED": "UNDELETE, to undo the deletion of a computer file [v]\n",
  "UNDELETES": "UNDELETE, to undo the deletion of a computer file [v]\n",
  "UNDELETING": "UNDELETE, to undo the deletion of a computer file [v]\n",
  "UNDELIBERATE": "not deliberate [adj]\n",
  "UNDELIGHT": "lack of delight [n -S]\n",
  "UNDELIGHTED": "not delighted [adj]\n",
  "UNDELIGHTFUL": "not delightful [adj]\n",
  "UNDELIGHTS": "UNDELIGHT, lack of delight [n]\n",
  "UNDELIVERABLE": "not deliverable [adj]\n",
  "UNDELIVERED": "not delivered [adj]\n",
  "UNDELUDED": "not deluded [adj]\n",
  "UNDEMANDING": "not making demands [adj]\n",
  "UNDEMARCATED": "not demarcated [adj]\n",
  "UNDEMOCRATIC": "not democratic [adj]\n",
  "UNDEMONSTRABLE": "not demonstrable [adj]\n",
  "UNDEMONSTRATED": "not demonstrated [adj]\n",
  "UNDEMONSTRATIVE": "restrained in expression of feeling [adj]\n",
  "UNDENIABLE": "that cannot be denied [adj UNDENIABLY]\n",
  "UNDENIABLENESS": "the state of being undeniable [n]\n",
  "UNDENIABLY": "UNDENIABLE, that cannot be denied [adv]\n",
  "UNDENIED": "not denied [adj]\n",
  "UNDENTED": "not dented [adj]\n",
  "UNDEPENDABLE": "not dependable [adj]\n",
  "UNDEPENDING": "(obsolete) independent [adj]\n",
  "UNDEPLORED": "not deplored [adj]\n",
  "UNDEPRAVED": "not depraved [adj]\n",
  "UNDEPRECIATED": "not depreciated [adj]\n",
  "UNDEPRESSED": "not depressed [adj]\n",
  "UNDEPRIVED": "not deprived [adj]\n",
  "UNDER": "in a lower position than [prep]\n",
  "UNDERACHIEVE": "to achieve less than one's potential [v UNDERACHIEVED, UNDERACHIEVING, UNDERACHIEVES]\n",
  "UNDERACHIEVED": "UNDERACHIEVE, to achieve less than one's potential [v]\n",
  "UNDERACHIEVER": "one that fails to attain a predicted level of achievement or does not do as well as expected [n -S]\n",
  "UNDERACHIEVERS": "UNDERACHIEVER, one that fails to attain a predicted level of achievement or does not do as well as expected [n]\n",
  "UNDERACHIEVES": "UNDERACHIEVE, to achieve less than one's potential [v]\n",
  "UNDERACHIEVING": "UNDERACHIEVE, to achieve less than one's potential [v]\n",
  "UNDERACT": "to act subtly and with restraint [v -ED, -ING, -S]\n",
  "UNDERACTED": "UNDERACT, to act subtly and with restraint [v]\n",
  "UNDERACTING": "UNDERACT, to act subtly and with restraint [v]\n",
  "UNDERACTION": "subordinate action [n -S]\n",
  "UNDERACTIONS": "UNDERACTION, subordinate action [n]\n",
  "UNDERACTIVE": "characterized by an abnormally low level of activity [adj]\n",
  "UNDERACTIVITIES": "UNDERACTIVITY, the state of being underactive [n]\n",
  "UNDERACTIVITY": "the state of being underactive [n UNDERACTIVITIES]\n",
  "UNDERACTOR": "a subordinate actor [n -S]\n",
  "UNDERACTORS": "UNDERACTOR, a subordinate actor [n]\n",
  "UNDERACTS": "UNDERACT, to act subtly and with restraint [v]\n",
  "UNDERAGE": "not yet of the required age [adj] / one who is underage [n -S]\n",
  "UNDERAGED": "not adult [adj]\n",
  "UNDERAGENT": "a subordinate agent [n -S]\n",
  "UNDERAGENTS": "UNDERAGENT, a subordinate agent [n]\n",
  "UNDERAGES": "UNDERAGE, one who is underage [n]\n",
  "UNDERARM": "the underside of the arm, the armpit [n -S]\n",
  "UNDERARMS": "UNDERARM, the underside of the arm, the armpit [n]\n",
  "UNDERATE": "UNDEREAT, to eat an insufficient amount [v]\n",
  "UNDERBAKE": "to bake insufficiently [v UNDERBAKED, UNDERBAKING, UNDERBAKES]\n",
  "UNDERBAKED": "UNDERBAKE, to bake insufficiently [v]\n",
  "UNDERBAKES": "UNDERBAKE, to bake insufficiently [v]\n",
  "UNDERBAKING": "UNDERBAKE, to bake insufficiently [v]\n",
  "UNDERBEAR": "(obsolete) to support; to endure [v UNDERBORE, UNDERBORNE, UNDERBEARING, UNDERBEARS]\n",
  "UNDERBEARER": "(dialect) someone who helps to carry a coffin [n -S]\n",
  "UNDERBEARERS": "UNDERBEARER, (dialect) someone who helps to carry a coffin [n]\n",
  "UNDERBEARING": "the act of underbearing [n -S]\n",
  "UNDERBEARINGS": "UNDERBEARING, the act of underbearing [n]\n",
  "UNDERBEARS": "UNDERBEAR, (obsolete) to support; to endure [v]\n",
  "UNDERBELLIES": "UNDERBELLY, the undersurface of a body or of something suggesting a body [n]\n",
  "UNDERBELLY": "the undersurface of a body or of something suggesting a body [n UNDERBELLIES]\n",
  "UNDERBID": "to bid lower than [v UNDERBID, UNDERBIDDING, UNDERBIDS]\n",
  "UNDERBIDDER": "one who underbids [n -S]\n",
  "UNDERBIDDERS": "UNDERBIDDER, one who underbids [n]\n",
  "UNDERBIDDING": "UNDERBID, to bid lower than [v]\n",
  "UNDERBIDS": "UNDERBID, to bid lower than [v]\n",
  "UNDERBIT": "UNDERBITE, to bite insufficiently with acid, as in etching [v]\n",
  "UNDERBITE": "to bite insufficiently with acid, as in etching [v UNDERBIT, UNDERBITTEN, UNDERBITING, UNDERBITES]\n",
  "UNDERBITES": "UNDERBITE, to bite insufficiently with acid, as in etching [v]\n",
  "UNDERBITING": "UNDERBITE, to bite insufficiently with acid, as in etching [v]\n",
  "UNDERBITTEN": "UNDERBITE, to bite insufficiently with acid, as in etching [v]\n",
  "UNDERBLANKET": "a blanket for use under another blanket [n -S]\n",
  "UNDERBLANKETS": "UNDERBLANKET, a blanket for use under another blanket [n]\n",
  "UNDERBODIES": "UNDERBODY, the underside of a motor vehicle [n]\n",
  "UNDERBODY": "the underside of a motor vehicle [n UNDERBODIES]\n",
  "UNDERBORE": "UNDERBEAR, (obsolete) to support; to endure [v]\n",
  "UNDERBORNE": "UNDERBEAR, (obsolete) to support; to endure [v]\n",
  "UNDERBOSS": "an under-manager [n -ES]\n",
  "UNDERBOSSES": "UNDERBOSS, an under-manager [n]\n",
  "UNDERBOUGH": "a lower branch of a tree [n -S]\n",
  "UNDERBOUGHS": "UNDERBOUGH, a lower branch of a tree [n]\n",
  "UNDERBOUGHT": "UNDERBUY, to buy at a lower price than [v]\n",
  "UNDERBREATH": "subdued voice; rumour [n -S]\n",
  "UNDERBREATHS": "UNDERBREATH, subdued voice; rumour [n]\n",
  "UNDERBRED": "of inferior breeding or manners [adj]\n",
  "UNDERBREEDING": "lack of breeding [n -S]\n",
  "UNDERBREEDINGS": "UNDERBREEDING, lack of breeding [n]\n",
  "UNDERBRIDGE": "a bridge carrying a road or railway [n -S]\n",
  "UNDERBRIDGES": "UNDERBRIDGE, a bridge carrying a road or railway [n]\n",
  "UNDERBRIM": "a facing on the underside of a hat brim [n -S]\n",
  "UNDERBRIMS": "UNDERBRIM, a facing on the underside of a hat brim [n]\n",
  "UNDERBRUSH": "shrubs, small trees, and the like, in a wood or forest, growing beneath large trees [n -ES] / to clear of underbrush [v -ED, -ING, -ES]\n",
  "UNDERBRUSHED": "UNDERBRUSH, to clear of underbrush [v]\n",
  "UNDERBRUSHES": "UNDERBRUSH, shrubs, small trees, and the like, in a wood or forest, growing beneath large trees [n]\n",
  "UNDERBRUSHING": "UNDERBRUSH, to clear of underbrush [v]\n",
  "UNDERBUD": "to bud from beneath [v UNDERBUDDED, UNDERBUDDING, UNDERBUDS]\n",
  "UNDERBUDDED": "UNDERBUD, to bud from beneath [v]\n",
  "UNDERBUDDING": "UNDERBUD, to bud from beneath [v]\n",
  "UNDERBUDGET": "to allow too low a budget [v -ED, -ING, -S]\n",
  "UNDERBUDGETED": "UNDERBUDGET, to allow too low a budget [v]\n",
  "UNDERBUDGETING": "UNDERBUDGET, to allow too low a budget [v]\n",
  "UNDERBUDGETS": "UNDERBUDGET, to allow too low a budget [v]\n",
  "UNDERBUDS": "UNDERBUD, to bud from beneath [v]\n",
  "UNDERBUILD": "to build under in support; to build too little [v UNDERBUILT, UNDERBUILDING, UNDERBUILDS]\n",
  "UNDERBUILDER": "a subordinate or assistant builder [n -S]\n",
  "UNDERBUILDERS": "UNDERBUILDER, a subordinate or assistant builder [n]\n",
  "UNDERBUILDING": "UNDERBUILD, to build under in support; to build too little [v]\n",
  "UNDERBUILDS": "UNDERBUILD, to build under in support; to build too little [v]\n",
  "UNDERBUILT": "UNDERBUILD, to build under in support; to build too little [v]\n",
  "UNDERBURNT": "insufficiently burnt [adj]\n",
  "UNDERBUSH": "underbrush, shrubs, small trees, and the like [n -ES] / to clear of underbrush [v -ED, -ING, -ES]\n",
  "UNDERBUSHED": "UNDERBUSH, to clear of underbrush [v]\n",
  "UNDERBUSHES": "UNDERBUSH, to clear of underbrush [v]\n",
  "UNDERBUSHING": "UNDERBUSH, to clear of underbrush [v]\n",
  "UNDERBUY": "to buy at a lower price than [v UNDERBOUGHT, UNDERBUYING, UNDERBUYS]\n",
  "UNDERBUYING": "UNDERBUY, to buy at a lower price than [v]\n",
  "UNDERBUYS": "UNDERBUY, to buy at a lower price than [v]\n",
  "UNDERCAPITALISE": "to capitalise insufficiently, also UNDERCAPITALIZE [v]\n",
  "UNDERCAPITALIZE": "to capitalize insufficiently, also UNDERCAPITALISE [v]\n",
  "UNDERCARD": "in boxing, a programme of matches supporting the main event [n -S]\n",
  "UNDERCARDS": "UNDERCARD, in boxing, a programme of matches supporting the main event [n]\n",
  "UNDERCARRIAGE": "a supporting framework or underside (as of an automobile) [n -S]\n",
  "UNDERCARRIAGES": "UNDERCARRIAGE, a supporting framework or underside (as of an automobile) [n]\n",
  "UNDERCART": "(colloquial) an aircraft's landing-gear, the undercarriage [n -S]\n",
  "UNDERCARTS": "UNDERCART, (colloquial) an aircraft's landing-gear, the undercarriage [n]\n",
  "UNDERCAST": "an air-passage crossing under a road in a mine [n -S]\n",
  "UNDERCASTS": "UNDERCAST, an air-passage crossing under a road in a mine [n]\n",
  "UNDERCHARGE": "to charge too little [v UNDERCHARGED, UNDERCHARGING, UNDERCHARGES]\n",
  "UNDERCHARGED": "UNDERCHARGE, to charge too little [v]\n",
  "UNDERCHARGES": "UNDERCHARGE, to charge too little [v]\n",
  "UNDERCHARGING": "UNDERCHARGE, to charge too little [v]\n",
  "UNDERCLAD": "insufficiently clothed [adj]\n",
  "UNDERCLASS": "the lowest social stratum usually made up of disadvantaged minority groups [n -ES]\n",
  "UNDERCLASSES": "UNDERCLASS, the lowest social stratum usually made up of disadvantaged minority groups [n]\n",
  "UNDERCLASSMAN": "a member of the freshman or sophomore class in a school or college [n UNDERCLASSMEN]\n",
  "UNDERCLASSMEN": "UNDERCLASSMAN, a member of the freshman or sophomore class in a school or college [n]\n",
  "UNDERCLAY": "a stratum of clay lying beneath a coal bed, often containing the roots of coal plants [n -S]\n",
  "UNDERCLAYS": "UNDERCLAY, a stratum of clay lying beneath a coal bed, often containing the roots of coal plants [n]\n",
  "UNDERCLIFF": "a subordinate cliff on a shore, consisting of material that has fallen from the higher cliff above [n -S]\n",
  "UNDERCLIFFS": "UNDERCLIFF, a subordinate cliff on a shore, consisting of material that has fallen from the higher cliff above [n]\n",
  "UNDERCLOTHE": "to clothe insufficiently [v UNDERCLOTHED, UNDERCLOTHING, UNDERCLOTHES]\n",
  "UNDERCLOTHED": "UNDERCLOTHE, to clothe insufficiently [v]\n",
  "UNDERCLOTHES": "clothes worn under one's outer clothing [n]\n",
  "UNDERCLOTHING": "clothes worn under others, esp. those next to the skin [n -S]\n",
  "UNDERCLOTHINGS": "UNDERCLOTHING, clothes worn under others, esp. those next to the skin [n]\n",
  "UNDERCLUB": "in golf, to hit with a club that has too great loft to achieve the required distance [v UNDERCLUBBED, UNDERCLUBBING, UNDERCLUBS]\n",
  "UNDERCLUBBED": "UNDERCLUB, in golf, to hit with a club that has too great loft to achieve the required distance [v]\n",
  "UNDERCLUBBING": "UNDERCLUB, in golf, to hit with a club that has too great loft to achieve the required distance [v]\n",
  "UNDERCLUBS": "UNDERCLUB, in golf, to hit with a club that has too great loft to achieve the required distance [v]\n",
  "UNDERCOAT": "a coat worn under another; an underlayer of fur, or paint [n -S] / to apply an undercoat of paint [v -ED, -ING, -S]\n",
  "UNDERCOATED": "UNDERCOAT, to apply an undercoat of paint [v]\n",
  "UNDERCOATING": "an undercoat of paint [n -S]\n",
  "UNDERCOATINGS": "UNDERCOATING, an undercoat of paint [n]\n",
  "UNDERCOATS": "UNDERCOAT, a coat worn under another; an underlayer of fur, or paint [n]\n",
  "UNDERCOOK": "to cook insufficiently or to a lesser extent than usual [v -ED, -ING, -S]\n",
  "UNDERCOOKED": "UNDERCOOK, to cook insufficiently or to a lesser extent than usual [v]\n",
  "UNDERCOOKING": "UNDERCOOK, to cook insufficiently or to a lesser extent than usual [v]\n",
  "UNDERCOOKS": "UNDERCOOK, to cook insufficiently or to a lesser extent than usual [v]\n",
  "UNDERCOOL": "to cool insufficiently [v -ED, -ING, -S]\n",
  "UNDERCOOLED": "UNDERCOOL, to cool insufficiently [v]\n",
  "UNDERCOOLING": "UNDERCOOL, to cool insufficiently [v]\n",
  "UNDERCOOLS": "UNDERCOOL, to cool insufficiently [v]\n",
  "UNDERCOUNT": "to miscount by counting too few [v -ED, -ING, -S]\n",
  "UNDERCOUNTED": "UNDERCOUNT, to miscount by counting too few [v]\n",
  "UNDERCOUNTING": "UNDERCOUNT, to miscount by counting too few [v]\n",
  "UNDERCOUNTS": "UNDERCOUNT, to miscount by counting too few [v]\n",
  "UNDERCOVER": "clandestine [adj]\n",
  "UNDERCOVERT": "a covert of undergrowth [n -S]\n",
  "UNDERCOVERTS": "UNDERCOVERT, a covert of undergrowth [n]\n",
  "UNDERCRACKERS": "(slang) underwear [n]\n",
  "UNDERCREST": "(Shakespeare) to bear like a crest [v -ED, -ING, -S]\n",
  "UNDERCRESTED": "UNDERCREST, (Shakespeare) to bear like a crest [v]\n",
  "UNDERCRESTING": "UNDERCREST, (Shakespeare) to bear like a crest [v]\n",
  "UNDERCRESTS": "UNDERCREST, (Shakespeare) to bear like a crest [v]\n",
  "UNDERCROFT": "an underground room or vault, esp. under a church [n -S]\n",
  "UNDERCROFTS": "UNDERCROFT, an underground room or vault, esp. under a church [n]\n",
  "UNDERCURRENT": "a current below the upper currents or surface [n -S]\n",
  "UNDERCURRENTS": "UNDERCURRENT, a current below the upper currents or surface [n]\n",
  "UNDERCUT": "to cut under [v UNDERCUT, UNDERCUTTING, UNDERCUTS]\n",
  "UNDERCUTS": "UNDERCUT, to cut under [v]\n",
  "UNDERCUTTING": "UNDERCUT, to cut under [v]\n",
  "UNDERDAKS": "(Australian slang) underpants [n]\n",
  "UNDERDAMPER": "in a type of upright piano, a damper positioned below the hammers [n -S]\n",
  "UNDERDAMPERS": "UNDERDAMPER, in a type of upright piano, a damper positioned below the hammers [n]\n",
  "UNDERDECK": "a lower deck on a ship [n -S]\n",
  "UNDERDECKS": "UNDERDECK, a lower deck on a ship [n]\n",
  "UNDERDELIVER": "to fail to achieve what has been expected or promised [v -ED, -ING, -S]\n",
  "UNDERDELIVERED": "UNDERDELIVER, to fail to achieve what has been expected or promised [v]\n",
  "UNDERDELIVERING": "UNDERDELIVER, to fail to achieve what has been expected or promised [v]\n",
  "UNDERDELIVERS": "UNDERDELIVER, to fail to achieve what has been expected or promised [v]\n",
  "UNDERDEVELOP": "to develop insufficiently [v -ED, -ING, -S]\n",
  "UNDERDEVELOPED": "UNDERDEVELOP, to develop insufficiently [v]\n",
  "UNDERDEVELOPING": "UNDERDEVELOP, to develop insufficiently [v]\n",
  "UNDERDEVELOPS": "UNDERDEVELOP, to develop insufficiently [v]\n",
  "UNDERDID": "UNDERDO, to do insufficiently [v]\n",
  "UNDERDO": "to do insufficiently [v UNDERDID, UNDERDONE, UNDERDOING, UNDERDOES]\n",
  "UNDERDOER": "one who underdoes; a shirker [n -S]\n",
  "UNDERDOERS": "UNDERDOER, one who underdoes; a shirker [n]\n",
  "UNDERDOES": "UNDERDO, to do insufficiently [v]\n",
  "UNDERDOG": "one who is expected to lose [n -S]\n",
  "UNDERDOGS": "UNDERDOG, one who is expected to lose [n]\n",
  "UNDERDOING": "UNDERDO, to do insufficiently [v]\n",
  "UNDERDONE": "UNDERDO, to do insufficiently [v]\n",
  "UNDERDOSE": "to give an insufficient dose to [v UNDERDOSED, UNDERDOSING, UNDERDOSES]\n",
  "UNDERDOSED": "UNDERDOSE, to give an insufficient dose to [v]\n",
  "UNDERDOSES": "UNDERDOSE, to give an insufficient dose to [v]\n",
  "UNDERDOSING": "UNDERDOSE, to give an insufficient dose to [v]\n",
  "UNDERDRAIN": "to drain by deep underground ditches [v -ED, -ING, -S]\n",
  "UNDERDRAINAGE": "insufficient drainage [n -S]\n",
  "UNDERDRAINAGES": "UNDERDRAINAGE, insufficient drainage [n]\n",
  "UNDERDRAINED": "UNDERDRAIN, to drain by deep underground ditches [v]\n",
  "UNDERDRAINING": "UNDERDRAIN, to drain by deep underground ditches [v]\n",
  "UNDERDRAINS": "UNDERDRAIN, to drain by deep underground ditches [v]\n",
  "UNDERDRAW": "to draw or describe with moderation or reticence [v UNDERDREW, UNDERDRAWN, UNDERDRAWING, UNDERDRAWS]\n",
  "UNDERDRAWERS": "an article of underwear for the lower body [n]\n",
  "UNDERDRAWING": "the act of underdrawing [n -S]\n",
  "UNDERDRAWINGS": "UNDERDRAWING, the act of underdrawing [n]\n",
  "UNDERDRAWN": "UNDERDRAW, to draw or describe with moderation or reticence [v]\n",
  "UNDERDRAWS": "UNDERDRAW, to draw or describe with moderation or reticence [v]\n",
  "UNDERDRESS": "to dress inadequately [v -ED, -ING, -ES]\n",
  "UNDERDRESSED": "UNDERDRESS, to dress inadequately [v]\n",
  "UNDERDRESSES": "UNDERDRESS, to dress inadequately [v]\n",
  "UNDERDRESSING": "UNDERDRESS, to dress inadequately [v]\n",
  "UNDERDREW": "UNDERDRAW, to draw or describe with moderation or reticence [v]\n",
  "UNDERDRIVE": "a gear which transmits to the driving shaft a speed less than engine speed [n -S]\n",
  "UNDERDRIVES": "UNDERDRIVE, a gear which transmits to the driving shaft a speed less than engine speed [n]\n",
  "UNDEREARTH": "the soil found beneath the surface of something [n -S]\n",
  "UNDEREARTHS": "UNDEREARTH, the soil found beneath the surface of something [n]\n",
  "UNDEREAT": "to eat an insufficient amount [v UNDERATE, UNDEREATEN, UNDEREATING, UNDEREATS]\n",
  "UNDEREATEN": "UNDEREAT, to eat an insufficient amount [v]\n",
  "UNDEREATING": "UNDEREAT, to eat an insufficient amount [v]\n",
  "UNDEREATS": "UNDEREAT, to eat an insufficient amount [v]\n",
  "UNDEREDUCATED": "poorly educated [adj]\n",
  "UNDEREMPHASES": "UNDEREMPHASIS, less emphasis than is possible or desirable [n]\n",
  "UNDEREMPHASIS": "less emphasis than is possible or desirable [n UNDEREMPHASES]\n",
  "UNDEREMPHASISE": "to emphasise insufficiently, also UNDEREMPHASIZE [v UNDEREMPHASISED, UNDEREMPHASISES]\n",
  "UNDEREMPHASISED": "UNDEREMPHASISE, to emphasise insufficiently, also UNDEREMPHASIZE [v]\n",
  "UNDEREMPHASISES": "UNDEREMPHASISE, to emphasise insufficiently, also UNDEREMPHASIZE [v]\n",
  "UNDEREMPHASIZE": "to emphasise insufficiently, also UNDEREMPHASISE [v UNDEREMPHASIZED, UNDEREMPHASIZES]\n",
  "UNDEREMPHASIZED": "UNDEREMPHASIZE, to emphasise insufficiently, also UNDEREMPHASISE [v]\n",
  "UNDEREMPHASIZES": "UNDEREMPHASIZE, to emphasise insufficiently, also UNDEREMPHASISE [v]\n",
  "UNDEREMPLOYED": "having less than full-time, regular, or adequate employment [adj]\n",
  "UNDEREMPLOYMENT": "the condition in which people in a labor force are employed at less than full-time or regular jobs or at jobs inadequate with respect to their training or economic needs [n]\n",
  "UNDERESTIMATE": "to estimate as being less than the actual size, quantity, or number [v UNDERESTIMATED, UNDERESTIMATING, UNDERESTIMATES]\n",
  "UNDERESTIMATED": "UNDERESTIMATE, to estimate as being less than the actual size, quantity, or number [v]\n",
  "UNDERESTIMATES": "UNDERESTIMATE, to estimate as being less than the actual size, quantity, or number [v]\n",
  "UNDERESTIMATING": "UNDERESTIMATE, to estimate as being less than the actual size, quantity, or number [v]\n",
  "UNDERESTIMATION": "the act of underestimating [n]\n",
  "UNDEREXPLOIT": "to make insufficient use of [v -ED, -ING, -S]\n",
  "UNDEREXPLOITED": "UNDEREXPLOIT, to make insufficient use of [v]\n",
  "UNDEREXPLOITING": "UNDEREXPLOIT, to make insufficient use of [v]\n",
  "UNDEREXPLOITS": "UNDEREXPLOIT, to make insufficient use of [v]\n",
  "UNDEREXPOSE": "to expose insufficiently [v UNDEREXPOSED, UNDEREXPOSING, UNDEREXPOSES]\n",
  "UNDEREXPOSED": "UNDEREXPOSE, to expose insufficiently [v]\n",
  "UNDEREXPOSES": "UNDEREXPOSE, to expose insufficiently [v]\n",
  "UNDEREXPOSING": "UNDEREXPOSE, to expose insufficiently [v]\n",
  "UNDEREXPOSURE": "insufficient exposure [n -S]\n",
  "UNDEREXPOSURES": "UNDEREXPOSURE, insufficient exposure [n]\n",
  "UNDERFED": "fed an insufficient amount [adj]\n",
  "UNDERFEED": "to feed inadequately [v UNDERFED, UNDERFEEDING, UNDERFEEDS]\n",
  "UNDERFEEDING": "the act of feeding inadequately [n -S]\n",
  "UNDERFEEDINGS": "UNDERFEEDING, the act of feeding inadequately [n]\n",
  "UNDERFEEDS": "UNDERFEED, to feed inadequately [v]\n",
  "UNDERFELT": "an underlayer of felt used in carpeting [n -S]\n",
  "UNDERFELTS": "UNDERFELT, an underlayer of felt used in carpeting [n]\n",
  "UNDERFINANCED": "inadequately financed [adj]\n",
  "UNDERFINISHED": "of cattle and sheep, having too little finish [adj]\n",
  "UNDERFIRE": "to fire or bake insufficiently [v UNDERFIRED, UNDERFIRING, UNDERFIRES]\n",
  "UNDERFIRED": "UNDERFIRE, to fire or bake insufficiently [v]\n",
  "UNDERFIRES": "UNDERFIRE, to fire or bake insufficiently [v]\n",
  "UNDERFIRING": "UNDERFIRE, to fire or bake insufficiently [v]\n",
  "UNDERFISH": "to fish insufficiently [v -ED, -ING, -ES]\n",
  "UNDERFISHED": "UNDERFISH, to fish insufficiently [v]\n",
  "UNDERFISHES": "UNDERFISH, to fish insufficiently [v]\n",
  "UNDERFISHING": "UNDERFISH, to fish insufficiently [v]\n",
  "UNDERFLOOR": "situated underneath a floor e.g. heating [adj]\n",
  "UNDERFLOW": "an undercurrent [n -S]\n",
  "UNDERFLOWS": "UNDERFLOW, an undercurrent [n]\n",
  "UNDERFONG": "(Spenser) to undertake [v -ED, -ING, -S]\n",
  "UNDERFONGED": "UNDERFONG, (Spenser) to undertake [v]\n",
  "UNDERFONGING": "UNDERFONG, (Spenser) to undertake [v]\n",
  "UNDERFONGS": "UNDERFONG, (Spenser) to undertake [v]\n",
  "UNDERFOOT": "to underpin [v -ED, -ING, -S]\n",
  "UNDERFOOTED": "UNDERFOOT, to underpin [v]\n",
  "UNDERFOOTING": "UNDERFOOT, to underpin [v]\n",
  "UNDERFOOTS": "UNDERFOOT, to underpin [v]\n",
  "UNDERFULFIL": "to fail to fulfil completely, also UNDERFULFILL [v UNDERFULFILLED, UNDERFULFILLING, UNDERFULFILS]\n",
  "UNDERFULFILL": "to fall short of satisfaction, also UNDERFULFIL [v -ED, -ING, -S]\n",
  "UNDERFULFILLED": "not fully fulfilled [adj]\n",
  "UNDERFULFILLING": "UNDERFULFIL, to fail to fulfil completely, also UNDERFULFILL [v]\n",
  "UNDERFULFILLS": "UNDERFULFILL, to fall short of satisfaction, also UNDERFULFIL [v]\n",
  "UNDERFULFILS": "UNDERFULFIL, to fail to fulfil completely, also UNDERFULFILL [v]\n",
  "UNDERFUND": "to fund inadequately [v -ED, -ING, -S]\n",
  "UNDERFUNDED": "UNDERFUND, to fund inadequately [v]\n",
  "UNDERFUNDING": "a deficiency in funding [n -S]\n",
  "UNDERFUNDINGS": "UNDERFUNDING, a deficiency in funding [n]\n",
  "UNDERFUNDS": "UNDERFUND, to fund inadequately [v]\n",
  "UNDERFUR": "the thick, soft fur beneath the outer coat of certain mammals [n -S]\n",
  "UNDERFURS": "UNDERFUR, the thick, soft fur beneath the outer coat of certain mammals [n]\n",
  "UNDERGARMENT": "any article of clothing worn under another, esp. that worn next to the skin [n -S]\n",
  "UNDERGARMENTS": "UNDERGARMENT, any article of clothing worn under another, esp. that worn next to the skin [n]\n",
  "UNDERGIRD": "to form the basis or foundation of, to support from below [v UNDERGIRDED, UNDERGIRT, UNDERGIRDING, UNDERGIRDS]\n",
  "UNDERGIRDED": "UNDERGIRD, to form the basis or foundation of, to support from below [v]\n",
  "UNDERGIRDING": "UNDERGIRD, to form the basis or foundation of, to support from below [v]\n",
  "UNDERGIRDS": "UNDERGIRD, to form the basis or foundation of, to support from below [v]\n",
  "UNDERGIRT": "UNDERGIRD, to form the basis or foundation of, to support from below [v]\n",
  "UNDERGLAZE": "in pottery, a glaze put on before the main glaze [n -S]\n",
  "UNDERGLAZES": "UNDERGLAZE, in pottery, a glaze put on before the main glaze [n]\n",
  "UNDERGO": "to be subjected to [v UNDERWENT, UNDERGONE, UNDERGOING, UNDERGOES]\n",
  "UNDERGOD": "a lesser god [n -S]\n",
  "UNDERGODS": "UNDERGOD, a lesser god [n]\n",
  "UNDERGOER": "one who undergoes [n -S]\n",
  "UNDERGOERS": "UNDERGOER, one who undergoes [n]\n",
  "UNDERGOES": "UNDERGO, to be subjected to [v]\n",
  "UNDERGOING": "UNDERGO, to be subjected to [v]\n",
  "UNDERGONE": "UNDERGO, to be subjected to [v]\n",
  "UNDERGOWN": "a gown worn under another, or under some other article of dress [n -S]\n",
  "UNDERGOWNS": "UNDERGOWN, a gown worn under another, or under some other article of dress [n]\n",
  "UNDERGRAD": "an undergraduate [n -S]\n",
  "UNDERGRADS": "UNDERGRAD, an undergraduate [n]\n",
  "UNDERGRADUATE": "a student at a college or university who has not received a first and esp. a bachelor's degree [n -S]\n",
  "UNDERGRADUATES": "UNDERGRADUATE, a student at a college or university who has not received a first and esp. a bachelor's degree [n]\n",
  "UNDERGRADUETTE": "a female undergraduate [n -S]\n",
  "UNDERGRADUETTES": "UNDERGRADUETTE, a female undergraduate [n]\n",
  "UNDERGROUND": "a subterranean space or channel [n -S]\n",
  "UNDERGROUNDER": "a member of the underground [n -S]\n",
  "UNDERGROUNDERS": "UNDERGROUNDER, a member of the underground [n]\n",
  "UNDERGROUNDS": "UNDERGROUND, a subterranean space or channel [n]\n",
  "UNDERGROVE": "a grove of shrubs or low trees under taller ones [n -S]\n",
  "UNDERGROVES": "UNDERGROVE, a grove of shrubs or low trees under taller ones [n]\n",
  "UNDERGROWN": "of small stature; not grown to a full height or size [adj]\n",
  "UNDERGROWTH": "low growth on the floor of a forest including seedlings and saplings, shrubs, and herbs [n -S]\n",
  "UNDERGROWTHS": "UNDERGROWTH, low growth on the floor of a forest including seedlings and saplings, shrubs, and herbs [n]\n",
  "UNDERHAIR": "an inner layer of hair [n -S]\n",
  "UNDERHAIRS": "UNDERHAIR, an inner layer of hair [n]\n",
  "UNDERHAND": "to throw a ball underhand in eg cricket [v -ED, -ING, -S]\n",
  "UNDERHANDED": "devious [adj UNDERHANDEDLY]\n",
  "UNDERHANDEDLY": "UNDERHANDED, devious [adv]\n",
  "UNDERHANDEDNESS": "the state of being underhanded [n]\n",
  "UNDERHANDING": "UNDERHAND, to throw a ball underhand in eg cricket [v]\n",
  "UNDERHANDS": "UNDERHAND, to throw a ball underhand in eg cricket [v]\n",
  "UNDERHEAT": "to heat insufficiently [v -ED, -ING, -S]\n",
  "UNDERHEATED": "UNDERHEAT, to heat insufficiently [v]\n",
  "UNDERHEATING": "UNDERHEAT, to heat insufficiently [v]\n",
  "UNDERHEATS": "UNDERHEAT, to heat insufficiently [v]\n",
  "UNDERHONEST": "(Shakespeare) not quite honest [adj]\n",
  "UNDERHUNG": "of a sliding door, resting on a track at the bottom, instead of being suspended [adj]\n",
  "UNDERINFLATED": "not sufficiently inflated [adj]\n",
  "UNDERINFLATION": "the state of being insufficiently inflated [n -S]\n",
  "UNDERINFLATIONS": "UNDERINFLATION, the state of being insufficiently inflated [n]\n",
  "UNDERINSURE": "to insure insufficiently [v UNDERINSURED, UNDERINSURING, UNDERINSURES]\n",
  "UNDERINSURED": "UNDERINSURE, to insure insufficiently [v]\n",
  "UNDERINSURES": "UNDERINSURE, to insure insufficiently [v]\n",
  "UNDERINSURING": "UNDERINSURE, to insure insufficiently [v]\n",
  "UNDERINVEST": "to invest insufficient funds [v -ED, -ING, -S]\n",
  "UNDERINVESTED": "UNDERINVEST, to invest insufficient funds [v]\n",
  "UNDERINVESTING": "UNDERINVEST, to invest insufficient funds [v]\n",
  "UNDERINVESTMENT": "an insufficient amount of investment [n]\n",
  "UNDERINVESTS": "UNDERINVEST, to invest insufficient funds [v]\n",
  "UNDERIVED": "not derived [adj]\n",
  "UNDERJAW": "the lower jaw [n -S]\n",
  "UNDERJAWED": "with a heavy or underhung underjaw [adj]\n",
  "UNDERJAWS": "UNDERJAW, the lower jaw [n]\n",
  "UNDERKEEP": "(Spenser) to keep under; to suppress [v UNDERKEPT, UNDERKEEPING, UNDERKEEPS]\n",
  "UNDERKEEPER": "a subordinate keeper [n -S]\n",
  "UNDERKEEPERS": "UNDERKEEPER, a subordinate keeper [n]\n",
  "UNDERKEEPING": "UNDERKEEP, (Spenser) to keep under; to suppress [v]\n",
  "UNDERKEEPS": "UNDERKEEP, (Spenser) to keep under; to suppress [v]\n",
  "UNDERKEPT": "UNDERKEEP, (Spenser) to keep under; to suppress [v]\n",
  "UNDERKILL": "less force than is needed to defeat an enemy [n -S]\n",
  "UNDERKILLS": "UNDERKILL, less force than is needed to defeat an enemy [n]\n",
  "UNDERKING": "a sub-king [n -S]\n",
  "UNDERKINGDOM": "a subkingdom [n -S]\n",
  "UNDERKINGDOMS": "UNDERKINGDOM, a subkingdom [n]\n",
  "UNDERKINGS": "UNDERKING, a sub-king [n]\n",
  "UNDERLAID": "UNDERLAY, to place under [v]\n",
  "UNDERLAIN": "UNDERLIE, to lie under [v]\n",
  "UNDERLAP": "to extend partly under [v UNDERLAPPED, UNDERLAPPING, UNDERLAPS]\n",
  "UNDERLAPPED": "UNDERLAP, to extend partly under [v]\n",
  "UNDERLAPPING": "UNDERLAP, to extend partly under [v]\n",
  "UNDERLAPS": "UNDERLAP, to extend partly under [v]\n",
  "UNDERLAY": "to place under [v UNDERLAID, UNDERLAYING, UNDERLAYS]\n",
  "UNDERLAYER": "a lower layer [n -S]\n",
  "UNDERLAYERS": "UNDERLAYER, a lower layer [n]\n",
  "UNDERLAYING": "UNDERLAY, to place under [v]\n",
  "UNDERLAYMENT": "the act of underlaying [n -S]\n",
  "UNDERLAYMENTS": "UNDERLAYMENT, the act of underlaying [n]\n",
  "UNDERLAYS": "UNDERLAY, to place under [v]\n",
  "UNDERLEAF": "in liverworts, any of the leaves forming a row on the underside of the stem [n UNDERLEAVES]\n",
  "UNDERLEASE": "to sublease [v UNDERLEASED, UNDERLEASING, UNDERLEASES]\n",
  "UNDERLEASED": "UNDERLEASE, to sublease [v]\n",
  "UNDERLEASES": "UNDERLEASE, to sublease [v]\n",
  "UNDERLEASING": "UNDERLEASE, to sublease [v]\n",
  "UNDERLEAVES": "UNDERLEAF, in liverworts, any of the leaves forming a row on the underside of the stem [n]\n",
  "UNDERLET": "to lease at less than the usual value [v UNDERLET, UNDERLETTING, UNDERLETS]\n",
  "UNDERLETS": "UNDERLET, to lease at less than the usual value [v]\n",
  "UNDERLETTER": "one who underlets [n -S]\n",
  "UNDERLETTERS": "UNDERLETTER, one who underlets [n]\n",
  "UNDERLETTING": "the act of letting for less than the proper value [n -S]\n",
  "UNDERLETTINGS": "UNDERLETTING, the act of letting for less than the proper value [n]\n",
  "UNDERLEVERAGED": "insufficiently leveraged [adj]\n",
  "UNDERLIE": "to lie under [v UNDERLAY, UNDERLAIN, UNDERLYING, UNDERLIES]\n",
  "UNDERLIER": "one who underlies [n -S]\n",
  "UNDERLIERS": "UNDERLIER, one who underlies [n]\n",
  "UNDERLIES": "UNDERLIE, to lie under [v]\n",
  "UNDERLINE": "to draw a line under [v UNDERLINED, UNDERLINING, UNDERLINES]\n",
  "UNDERLINED": "UNDERLINE, to draw a line under [v]\n",
  "UNDERLINEN": "(archaic) underclothing [n -S]\n",
  "UNDERLINENS": "UNDERLINEN, (archaic) underclothing [n]\n",
  "UNDERLINES": "UNDERLINE, to draw a line under [v]\n",
  "UNDERLING": "a subordinate [n -S]\n",
  "UNDERLINGS": "UNDERLING, a subordinate [n]\n",
  "UNDERLINING": "the act of drawing a line under [n -S]\n",
  "UNDERLININGS": "UNDERLINING, the act of drawing a line under [n]\n",
  "UNDERLIP": "the lower lip [n -S]\n",
  "UNDERLIPS": "UNDERLIP, the lower lip [n]\n",
  "UNDERLIT": "lacking adequate light [adj]\n",
  "UNDERLOAD": "to load insufficiently [v -ED, -ING, -S]\n",
  "UNDERLOADED": "UNDERLOAD, to load insufficiently [v]\n",
  "UNDERLOADING": "UNDERLOAD, to load insufficiently [v]\n",
  "UNDERLOADS": "UNDERLOAD, to load insufficiently [v]\n",
  "UNDERLOOKER": "a mine manager's assistant, also UNDERVIEWER [n -S]\n",
  "UNDERLOOKERS": "UNDERLOOKER, a mine manager's assistant, also UNDERVIEWER [n]\n",
  "UNDERLYING": "UNDERLIE, to lie under [v]\n",
  "UNDERLYINGLY": "UNDERLYING, UNDERLIE, to lie under [adv]\n",
  "UNDERMAN": "to use too few workers [v UNDERMANNED, UNDERMANNING, UNDERMANS] / an inferior man [n UNDERMEN]\n",
  "UNDERMANNED": "UNDERMAN, to use too few workers [v]\n",
  "UNDERMANNING": "the state of not having enough employees [n -S]\n",
  "UNDERMANNINGS": "UNDERMANNING, the state of not having enough employees [n]\n",
  "UNDERMANS": "UNDERMAN, to use too few workers [v]\n",
  "UNDERMASTED": "having insufficient masts [adj]\n",
  "UNDERMEANING": "a hidden meaning [n -S]\n",
  "UNDERMEANINGS": "UNDERMEANING, a hidden meaning [n]\n",
  "UNDERMEN": "UNDERMAN, an inferior man [n]\n",
  "UNDERMENTIONED": "mentioned below [adj]\n",
  "UNDERMINDE": "(Spenser) to undermine [v UNDERMINDED, UNDERMINDING, UNDERMINDES]\n",
  "UNDERMINDED": "UNDERMINDE, (Spenser) to undermine [v]\n",
  "UNDERMINDES": "UNDERMINDE, (Spenser) to undermine [v]\n",
  "UNDERMINDING": "UNDERMINDE, (Spenser) to undermine [v]\n",
  "UNDERMINE": "to dig beneath (e.g. a wall) in order to make it fall, also UNDERMINDE [v UNDERMINED, UNDERMINING, UNDERMINES]\n",
  "UNDERMINED": "UNDERMINE, to dig beneath (e.g. a wall) in order to make it fall, also UNDERMINDE [v]\n",
  "UNDERMINER": "one who undermines [n -S]\n",
  "UNDERMINERS": "UNDERMINER, one who undermines [n]\n",
  "UNDERMINES": "UNDERMINE, to dig beneath (e.g. a wall) in order to make it fall, also UNDERMINDE [v]\n",
  "UNDERMINING": "the act of mining from beneath [n -S]\n",
  "UNDERMININGS": "UNDERMINING, the act of mining from beneath [n]\n",
  "UNDERMOST": "lowest, as in place, rank, or condition [adj]\n",
  "UNDERN": "(obsolete) originally the third hour of the day, about nine a.m.; later, a light meal taken in the afternoon [n -S]\n",
  "UNDERNAMED": "named below [adj]\n",
  "UNDERNEATH": "beneath [adj] / the under part or side [n -S]\n",
  "UNDERNEATHS": "UNDERNEATH, the under part or side [n]\n",
  "UNDERNICENESS": "lack of niceness or delicacy [n -ES]\n",
  "UNDERNICENESSES": "UNDERNICENESS, lack of niceness or delicacy [n]\n",
  "UNDERNOTE": "a subdued note; an undertone [n -S] / to note below [v UNDERNOTED, UNDERNOTING, UNDERNOTES]\n",
  "UNDERNOTED": "UNDERNOTE, to note below [v]\n",
  "UNDERNOTES": "UNDERNOTE, to note below [v]\n",
  "UNDERNOTING": "UNDERNOTE, to note below [v]\n",
  "UNDERNOURISH": "to nourish insufficiently [v -ED, -ING, -ES]\n",
  "UNDERNOURISHED": "UNDERNOURISH, to nourish insufficiently [v]\n",
  "UNDERNOURISHES": "UNDERNOURISH, to nourish insufficiently [v]\n",
  "UNDERNOURISHING": "UNDERNOURISH, to nourish insufficiently [v]\n",
  "UNDERNS": "UNDERN, (obsolete) originally the third hour of the day, about nine a.m.; later, a light meal taken in the afternoon [n]\n",
  "UNDERNTIME": "(obsolete) the time of the midday meal, also UNDERTIME [n -S]\n",
  "UNDERNTIMES": "UNDERNTIME, (obsolete) the time of the midday meal, also UNDERTIME [n]\n",
  "UNDERNUTRITION": "deficient bodily nutrition due to inadequate food intake or faulty assimilation [n -S]\n",
  "UNDERNUTRITIONS": "UNDERNUTRITION, deficient bodily nutrition due to inadequate food intake or faulty assimilation [n]\n",
  "UNDEROCCUPIED": "insufficiently occupied [adj]\n",
  "UNDERPAD": "a layer of soft foam laid under carpeting [n -S]\n",
  "UNDERPADS": "UNDERPAD, a layer of soft foam laid under carpeting [n]\n",
  "UNDERPAID": "UNDERPAY, to pay less than is deserved [v]\n",
  "UNDERPAINTING": "preliminary painting [n -S]\n",
  "UNDERPAINTINGS": "UNDERPAINTING, preliminary painting [n]\n",
  "UNDERPANTS": "a usually short undergarment for the lower torso [n]\n",
  "UNDERPART": "a subordinate part [n -S]\n",
  "UNDERPARTS": "UNDERPART, a subordinate part [n]\n",
  "UNDERPASS": "a road passing under another road or a railway etc. [n -ES]\n",
  "UNDERPASSES": "UNDERPASS, a road passing under another road or a railway etc. [n]\n",
  "UNDERPASSION": "an underlying or subconscious passion [n -S]\n",
  "UNDERPASSIONS": "UNDERPASSION, an underlying or subconscious passion [n]\n",
  "UNDERPAY": "to pay less than is deserved [v UNDERPAID, UNDERPAYING, UNDERPAYS]\n",
  "UNDERPAYING": "UNDERPAY, to pay less than is deserved [v]\n",
  "UNDERPAYMENT": "an insufficient payment [n -S]\n",
  "UNDERPAYMENTS": "UNDERPAYMENT, an insufficient payment [n]\n",
  "UNDERPAYS": "UNDERPAY, to pay less than is deserved [v]\n",
  "UNDERPEEP": "(Shakespeare) to peep under [v -ED, -ING, -S]\n",
  "UNDERPEEPED": "UNDERPEEP, (Shakespeare) to peep under [v]\n",
  "UNDERPEEPING": "UNDERPEEP, (Shakespeare) to peep under [v]\n",
  "UNDERPEEPS": "UNDERPEEP, (Shakespeare) to peep under [v]\n",
  "UNDERPEOPLED": "underpopulated [adj]\n",
  "UNDERPERFORM": "to perform insufficiently [v -ED, -ING, -S]\n",
  "UNDERPERFORMED": "UNDERPERFORM, to perform insufficiently [v]\n",
  "UNDERPERFORMING": "UNDERPERFORM, to perform insufficiently [v]\n",
  "UNDERPERFORMS": "UNDERPERFORM, to perform insufficiently [v]\n",
  "UNDERPIN": "to support from below [v UNDERPINNED, UNDERPINNING, UNDERPINS]\n",
  "UNDERPINNED": "UNDERPIN, to support from below [v]\n",
  "UNDERPINNING": "the act of underpinning [n -S]\n",
  "UNDERPINNINGS": "UNDERPINNING, the act of underpinning [n]\n",
  "UNDERPINS": "UNDERPIN, to support from below [v]\n",
  "UNDERPITCH": "as in underpitch vault [adj]\n",
  "UNDERPLANT": "to plant smaller trees in between taller ones [v -ED, -ING, -S]\n",
  "UNDERPLANTED": "UNDERPLANT, to plant smaller trees in between taller ones [v]\n",
  "UNDERPLANTING": "UNDERPLANT, to plant smaller trees in between taller ones [v]\n",
  "UNDERPLANTS": "UNDERPLANT, to plant smaller trees in between taller ones [v]\n",
  "UNDERPLAY": "to play down, understate [v -ED, -ING, -S]\n",
  "UNDERPLAYED": "UNDERPLAY, to play down, understate [v]\n",
  "UNDERPLAYING": "UNDERPLAY, to play down, understate [v]\n",
  "UNDERPLAYS": "UNDERPLAY, to play down, understate [v]\n",
  "UNDERPLOT": "a series of events in a play, proceeding collaterally with the main story, and subservient to it [n -S]\n",
  "UNDERPLOTS": "UNDERPLOT, a series of events in a play, proceeding collaterally with the main story, and subservient to it [n]\n",
  "UNDERPOPULATED": "having a lower density of population than is normal or desirable [adj]\n",
  "UNDERPOWERED": "driven by an engine of insufficient power [adj]\n",
  "UNDERPRAISE": "to praise insufficiently [v UNDERPRAISED, UNDERPRAISING, UNDERPRAISES]\n",
  "UNDERPRAISED": "UNDERPRAISE, to praise insufficiently [v]\n",
  "UNDERPRAISES": "UNDERPRAISE, to praise insufficiently [v]\n",
  "UNDERPRAISING": "UNDERPRAISE, to praise insufficiently [v]\n",
  "UNDERPREPARED": "inadequately prepared [adj]\n",
  "UNDERPRICE": "to price below the real value [v UNDERPRICED, UNDERPRICING, UNDERPRICES]\n",
  "UNDERPRICED": "UNDERPRICE, to price below the real value [v]\n",
  "UNDERPRICES": "UNDERPRICE, to price below the real value [v]\n",
  "UNDERPRICING": "the act of charging too low a price [n -S]\n",
  "UNDERPRICINGS": "UNDERPRICING, the act of charging too low a price [n]\n",
  "UNDERPRISE": "(obsolete) to value too little [v UNDERPRISED, UNDERPRISING, UNDERPRISES]\n",
  "UNDERPRISED": "UNDERPRISE, (obsolete) to value too little [v]\n",
  "UNDERPRISES": "UNDERPRISE, (obsolete) to value too little [v]\n",
  "UNDERPRISING": "UNDERPRISE, (obsolete) to value too little [v]\n",
  "UNDERPRIVILEGED": "deprived through social or economic condition of some of the fundamental rights of all members of a civilized society [adj]\n",
  "UNDERPRIZE": "to value too little [v UNDERPRIZED, UNDERPRIZING, UNDERPRIZES]\n",
  "UNDERPRIZED": "UNDERPRIZE, to value too little [v]\n",
  "UNDERPRIZES": "UNDERPRIZE, to value too little [v]\n",
  "UNDERPRIZING": "UNDERPRIZE, to value too little [v]\n",
  "UNDERPRODUCE": "to produce less than the expected amount [v UNDERPRODUCED, UNDERPRODUCING, UNDERPRODUCES]\n",
  "UNDERPRODUCED": "UNDERPRODUCE, to produce less than the expected amount [v]\n",
  "UNDERPRODUCES": "UNDERPRODUCE, to produce less than the expected amount [v]\n",
  "UNDERPRODUCING": "UNDERPRODUCE, to produce less than the expected amount [v]\n",
  "UNDERPRODUCTION": "the production of less than enough to satisfy the demand or of less than the usual amount [n]\n",
  "UNDERPROOF": "containing less alcohol than proof spirit [adj]\n",
  "UNDERPROP": "to prop from beneath [v UNDERPROPPED, UNDERPROPPING, UNDERPROPS]\n",
  "UNDERPROPPED": "UNDERPROP, to prop from beneath [v]\n",
  "UNDERPROPPER": "one who underprops [n -S]\n",
  "UNDERPROPPERS": "UNDERPROPPER, one who underprops [n]\n",
  "UNDERPROPPING": "UNDERPROP, to prop from beneath [v]\n",
  "UNDERPROPS": "UNDERPROP, to prop from beneath [v]\n",
  "UNDERPUBLICISED": "insufficiently publicised, also UNDERPUBLICIZED [adj]\n",
  "UNDERPUBLICIZED": "insufficiently publicized, also UNDERPUBLICISED [adj]\n",
  "UNDERQUALIFIED": "insufficiently qualified [adj]\n",
  "UNDERQUOTE": "to offer at a price lower than [v UNDERQUOTED, UNDERQUOTING, UNDERQUOTES]\n",
  "UNDERQUOTED": "UNDERQUOTE, to offer at a price lower than [v]\n",
  "UNDERQUOTES": "UNDERQUOTE, to offer at a price lower than [v]\n",
  "UNDERQUOTING": "UNDERQUOTE, to offer at a price lower than [v]\n",
  "UNDERRAN": "UNDERRUN, to pass or extend under [v]\n",
  "UNDERRATE": "to rate too low [v UNDERRATED, UNDERRATING, UNDERRATES]\n",
  "UNDERRATED": "UNDERRATE, to rate too low [v]\n",
  "UNDERRATES": "UNDERRATE, to rate too low [v]\n",
  "UNDERRATING": "UNDERRATE, to rate too low [v]\n",
  "UNDERREACT": "to react with less than appropriate force or intensity [v -ED, -ING, -S]\n",
  "UNDERREACTED": "UNDERREACT, to react with less than appropriate force or intensity [v]\n",
  "UNDERREACTING": "UNDERREACT, to react with less than appropriate force or intensity [v]\n",
  "UNDERREACTION": "a less intense reaction than is expected or appropriate [n -S]\n",
  "UNDERREACTIONS": "UNDERREACTION, a less intense reaction than is expected or appropriate [n]\n",
  "UNDERREACTS": "UNDERREACT, to react with less than appropriate force or intensity [v]\n",
  "UNDERREPORT": "to report inadequately [v -ED, -ING, -S]\n",
  "UNDERREPORTED": "UNDERREPORT, to report inadequately [v]\n",
  "UNDERREPORTING": "UNDERREPORT, to report inadequately [v]\n",
  "UNDERREPORTS": "UNDERREPORT, to report inadequately [v]\n",
  "UNDERRIPE": "insufficiently ripe [adj]\n",
  "UNDERRUN": "to pass or extend under [v UNDERRAN, UNDERRUN, UNDERRUNNING, UNDERRUNS]\n",
  "UNDERRUNNING": "the act of underrunning [n -S]\n",
  "UNDERRUNNINGS": "UNDERRUNNING, the act of underrunning [n]\n",
  "UNDERRUNS": "UNDERRUN, to pass or extend under [v]\n",
  "UNDERSAID": "UNDERSAY, to say in answer [v]\n",
  "UNDERSATURATED": "less than normally or adequately saturated [adj]\n",
  "UNDERSAY": "to say in answer [v UNDERSAID, UNDERSAYING, UNDERSAYS]\n",
  "UNDERSAYING": "UNDERSAY, to say in answer [v]\n",
  "UNDERSAYS": "UNDERSAY, to say in answer [v]\n",
  "UNDERSCORE": "to draw a line under [v UNDERSCORED, UNDERSCORING, UNDERSCORES]\n",
  "UNDERSCORED": "UNDERSCORE, to draw a line under [v]\n",
  "UNDERSCORES": "UNDERSCORE, to draw a line under [v]\n",
  "UNDERSCORING": "the act of attributing too low a score to [n -S]\n",
  "UNDERSCORINGS": "UNDERSCORING, the act of attributing too low a score to [n]\n",
  "UNDERSCRUB": "bushes etc. [n -S]\n",
  "UNDERSCRUBS": "UNDERSCRUB, bushes etc. [n]\n",
  "UNDERSEA": "below the sea, also UNDERSEAS [adj]\n",
  "UNDERSEAL": "to coat parts of the underbody of a vehicle with a protective coating [v -ED, -ING, -S]\n",
  "UNDERSEALED": "UNDERSEAL, to coat parts of the underbody of a vehicle with a protective coating [v]\n",
  "UNDERSEALING": "coating parts of the underbody of a vehicle with a protective coating [n -S]\n",
  "UNDERSEALINGS": "UNDERSEALING, coating parts of the underbody of a vehicle with a protective coating [n]\n",
  "UNDERSEALS": "UNDERSEAL, to coat parts of the underbody of a vehicle with a protective coating [v]\n",
  "UNDERSEAS": "below the sea, also UNDERSEA [adv]\n",
  "UNDERSECRETARY": "a secretary immediately subordinate to a principal secretary [n]\n",
  "UNDERSELF": "the subconscious self [n UNDERSELVES]\n",
  "UNDERSELL": "to sell too cheap [v UNDERSOLD, UNDERSELLING, UNDERSELLS]\n",
  "UNDERSELLER": "one who undersells [n -S]\n",
  "UNDERSELLERS": "UNDERSELLER, one who undersells [n]\n",
  "UNDERSELLING": "UNDERSELL, to sell too cheap [v]\n",
  "UNDERSELLS": "UNDERSELL, to sell too cheap [v]\n",
  "UNDERSELVES": "UNDERSELF, the subconscious self [n]\n",
  "UNDERSENSE": "a deeper sense; a subconscious sense [n -S]\n",
  "UNDERSENSES": "UNDERSENSE, a deeper sense; a subconscious sense [n]\n",
  "UNDERSERVED": "provided with inadequate service [adj]\n",
  "UNDERSET": "to prop or support [v UNDERSET, UNDERSETTING, UNDERSET]\n",
  "UNDERSETS": "UNDERSET, to prop or support [v]\n",
  "UNDERSETTING": "UNDERSET, to prop or support [v]\n",
  "UNDERSEXED": "deficient in sexual desire [adj]\n",
  "UNDERSHAPEN": "(Tennyson) imperfectly formed [adj]\n",
  "UNDERSHERIFF": "one below the rank of sheriff [n -S]\n",
  "UNDERSHERIFFS": "UNDERSHERIFF, one below the rank of sheriff [n]\n",
  "UNDERSHIRT": "an undergarment worn under a shirt [n -S]\n",
  "UNDERSHIRTED": "wearing an undershirt [adj]\n",
  "UNDERSHIRTS": "UNDERSHIRT, an undergarment worn under a shirt [n]\n",
  "UNDERSHOOT": "to fail to reach by falling short [v UNDERSHOT, UNDERSHOOTING, UNDERSHOOTS]\n",
  "UNDERSHOOTING": "UNDERSHOOT, to fail to reach by falling short [v]\n",
  "UNDERSHOOTS": "UNDERSHOOT, to fail to reach by falling short [v]\n",
  "UNDERSHORTS": "underpants for men or boys [n]\n",
  "UNDERSHOT": "UNDERSHOOT, to fail to reach by falling short [v]\n",
  "UNDERSHRUB": "a shrub smaller than the usual shrub [n -S]\n",
  "UNDERSHRUBS": "UNDERSHRUB, a shrub smaller than the usual shrub [n]\n",
  "UNDERSIDE": "the underneath [n -S]\n",
  "UNDERSIDES": "UNDERSIDE, the underneath [n]\n",
  "UNDERSIGN": "to write one's name at the foot or end of, as a letter or any legal instrument [v -ED, -ING, -S]\n",
  "UNDERSIGNED": "UNDERSIGN, to write one's name at the foot or end of, as a letter or any legal instrument [v]\n",
  "UNDERSIGNING": "UNDERSIGN, to write one's name at the foot or end of, as a letter or any legal instrument [v]\n",
  "UNDERSIGNS": "UNDERSIGN, to write one's name at the foot or end of, as a letter or any legal instrument [v]\n",
  "UNDERSIZE": "below the usual size, also UNDERSIZED [adj]\n",
  "UNDERSIZED": "below the usual size, also UNDERSIZE [adj]\n",
  "UNDERSKIES": "UNDERSKY, a lower sky [n]\n",
  "UNDERSKINKER": "(Shakespeare) an assistant tapster [n -S]\n",
  "UNDERSKINKERS": "UNDERSKINKER, (Shakespeare) an assistant tapster [n]\n",
  "UNDERSKIRT": "a petticoat [n -S]\n",
  "UNDERSKIRTS": "UNDERSKIRT, a petticoat [n]\n",
  "UNDERSKY": "a lower sky [n UNDERSKIES]\n",
  "UNDERSLEEVE": "a sleeve underneath another sleeve [n -S]\n",
  "UNDERSLEEVES": "UNDERSLEEVE, a sleeve underneath another sleeve [n]\n",
  "UNDERSLUNG": "suspended below the axles [adj]\n",
  "UNDERSOIL": "the soil beneath the surface; subsoil [n -S]\n",
  "UNDERSOILS": "UNDERSOIL, the soil beneath the surface; subsoil [n]\n",
  "UNDERSOLD": "UNDERSELL, to sell too cheap [v]\n",
  "UNDERSONG": "(archaic) the burden of a song; the refrain [n -S]\n",
  "UNDERSONGS": "UNDERSONG, (archaic) the burden of a song; the refrain [n]\n",
  "UNDERSOW": "to sow land already seeded with a later-growing crop [v -ED, -ING, -S]\n",
  "UNDERSOWED": "UNDERSOW, to sow land already seeded with a later-growing crop [v]\n",
  "UNDERSOWING": "UNDERSOW, to sow land already seeded with a later-growing crop [v]\n",
  "UNDERSOWN": "UNDERSOW, to sow land already seeded with a later-growing crop [v]\n",
  "UNDERSOWS": "UNDERSOW, to sow land already seeded with a later-growing crop [v]\n",
  "UNDERSPEND": "to spend less than [v UNDERSPENT, UNDERSPENDING, UNDERSPENDS]\n",
  "UNDERSPENDING": "the act of not spending enough [n -S]\n",
  "UNDERSPENDINGS": "UNDERSPENDING, the act of not spending enough [n]\n",
  "UNDERSPENDS": "UNDERSPEND, to spend less than [v]\n",
  "UNDERSPENT": "UNDERSPEND, to spend less than [v]\n",
  "UNDERSPIN": "a kind of spin in table tennis [n -S]\n",
  "UNDERSPINS": "UNDERSPIN, a kind of spin in table tennis [n]\n",
  "UNDERSTAFFED": "inadequately staffed [adj]\n",
  "UNDERSTAFFING": "inadequate staffing [n -S]\n",
  "UNDERSTAFFINGS": "UNDERSTAFFING, inadequate staffing [n]\n",
  "UNDERSTAND": "to grasp the meaning of [v UNDERSTOOD or (archaic) UNDERSTANDED, UNDERSTANDING, UNDERSTANDS]\n",
  "UNDERSTANDABLE": "capable of being understood [adj UNDERSTANDABLY]\n",
  "UNDERSTANDABLY": "UNDERSTANDABLE, capable of being understood [adv]\n",
  "UNDERSTANDED": "UNDERSTAND, to grasp the meaning of [v]\n",
  "UNDERSTANDER": "one who understands [n -S]\n",
  "UNDERSTANDERS": "UNDERSTANDER, one who understands [n]\n",
  "UNDERSTANDING": "a mental grasp [n -S]\n",
  "UNDERSTANDINGLY": "UNDERSTANDING [adv]\n",
  "UNDERSTANDINGS": "UNDERSTANDING, a mental grasp [n]\n",
  "UNDERSTANDS": "UNDERSTAND, to grasp the meaning of [v]\n",
  "UNDERSTATE": "to represent as less than is the case [v UNDERSTATED, UNDERSTATING, UNDERSTATES]\n",
  "UNDERSTATED": "UNDERSTATE, to represent as less than is the case [v]\n",
  "UNDERSTATEDLY": "UNDERSTATED, UNDERSTATE, to represent as less than is the case [adv]\n",
  "UNDERSTATEMENT": "the act of understating [n -S]\n",
  "UNDERSTATEMENTS": "UNDERSTATEMENT, the act of understating [n]\n",
  "UNDERSTATES": "UNDERSTATE, to represent as less than is the case [v]\n",
  "UNDERSTATING": "UNDERSTATE, to represent as less than is the case [v]\n",
  "UNDERSTEER": "to turn less sharply than the driver intends [v -ED, -ING, -S]\n",
  "UNDERSTEERED": "UNDERSTEER, to turn less sharply than the driver intends [v]\n",
  "UNDERSTEERING": "UNDERSTEER, to turn less sharply than the driver intends [v]\n",
  "UNDERSTEERS": "UNDERSTEER, to turn less sharply than the driver intends [v]\n",
  "UNDERSTOCK": "to supply insufficiently with stock [v -ED, -ING, -S]\n",
  "UNDERSTOCKED": "UNDERSTOCK, to supply insufficiently with stock [v]\n",
  "UNDERSTOCKING": "UNDERSTOCK, to supply insufficiently with stock [v]\n",
  "UNDERSTOCKS": "UNDERSTOCK, to supply insufficiently with stock [v]\n",
  "UNDERSTOOD": "UNDERSTAND, to grasp the meaning of [v]\n",
  "UNDERSTOREY": "the smaller trees and bushes forming a lower level beneath the forest canopy, also UNDERSTORY [n -S]\n",
  "UNDERSTOREYS": "UNDERSTOREY, the smaller trees and bushes forming a lower level beneath the forest canopy, also UNDERSTORY [n]\n",
  "UNDERSTORIES": "UNDERSTORY, the smaller trees and bushes forming a lower level beneath the forest canopy, also UNDERSTOREY [n]\n",
  "UNDERSTORY": "the smaller trees and bushes forming a lower level beneath the forest canopy, also UNDERSTOREY [n UNDERSTORIES]\n",
  "UNDERSTRAPPER": "an inferior agent; an underling [n -S]\n",
  "UNDERSTRAPPERS": "UNDERSTRAPPER, an inferior agent; an underling [n]\n",
  "UNDERSTRAPPING": "subordinate [adj]\n",
  "UNDERSTRATA": "UNDERSTRATUM, a stratum under another stratum [n]\n",
  "UNDERSTRATUM": "a stratum under another stratum [n UNDERSTRATA or UNDERSTRATUMS]\n",
  "UNDERSTRATUMS": "UNDERSTRATUM, a stratum under another stratum [n]\n",
  "UNDERSTRENGTH": "deficient in strength [adj]\n",
  "UNDERSTUDIED": "UNDERSTUDY, to act another's part or take over another's duties [v]\n",
  "UNDERSTUDIES": "UNDERSTUDY, to act another's part or take over another's duties [v]\n",
  "UNDERSTUDY": "to act another's part or take over another's duties [v UNDERSTUDIED, UNDERSTUDYING, UNDERSTUDIES]\n",
  "UNDERSTUDYING": "UNDERSTUDY, to act another's part or take over another's duties [v]\n",
  "UNDERSUBSCRIBED": "insufficiently subscribed [adj]\n",
  "UNDERSUPPLIED": "UNDERSUPPLY, to supply too little [v]\n",
  "UNDERSUPPLIES": "UNDERSUPPLY, to supply too little [v]\n",
  "UNDERSUPPLY": "to supply too little [v UNDERSUPPLIED, UNDERSUPPLYING, UNDERSUPPLIES]\n",
  "UNDERSUPPLYING": "UNDERSUPPLY, to supply too little [v]\n",
  "UNDERSURFACE": "an underside [n -S]\n",
  "UNDERSURFACES": "UNDERSURFACE, an underside [n]\n",
  "UNDERTAKABLE": "that can be undertaken [adj]\n",
  "UNDERTAKE": "to attempt [v UNDERTOOK, UNDERTAKEN, UNDERTAKING, UNDERTAKES]\n",
  "UNDERTAKEN": "UNDERTAKE, to attempt [v]\n",
  "UNDERTAKER": "one that undertakes [n -S]\n",
  "UNDERTAKERS": "UNDERTAKER, one that undertakes [n]\n",
  "UNDERTAKES": "UNDERTAKE, to attempt [v]\n",
  "UNDERTAKING": "an enterprise [n -S]\n",
  "UNDERTAKINGS": "UNDERTAKING, an enterprise [n]\n",
  "UNDERTANE": "(Spenser) undertaken [v]\n",
  "UNDERTAX": "to tax less than the usual amount [v -ED, -ING, -ES]\n",
  "UNDERTAXED": "UNDERTAX, to tax less than the usual amount [v]\n",
  "UNDERTAXES": "UNDERTAX, to tax less than the usual amount [v]\n",
  "UNDERTAXING": "UNDERTAX, to tax less than the usual amount [v]\n",
  "UNDERTENANCIES": "UNDERTENANCY, a subsidiary tenancy [n]\n",
  "UNDERTENANCY": "a subsidiary tenancy [n UNDERTENANCIES]\n",
  "UNDERTENANT": "a subordinate tenant [n -S]\n",
  "UNDERTENANTS": "UNDERTENANT, a subordinate tenant [n]\n",
  "UNDERTHINGS": "underwear [n]\n",
  "UNDERTHIRST": "(Wordsworth) an underlying or subconscious thirst [n -S]\n",
  "UNDERTHIRSTS": "UNDERTHIRST, (Wordsworth) an underlying or subconscious thirst [n]\n",
  "UNDERTHRUST": "to insert (a faulted rock mass) into position under a passive rock mass [v UNDERTHRUST, UNDERTHRUSTING, UNDERTHRUSTS]\n",
  "UNDERTHRUSTING": "UNDERTHRUST, to insert (a faulted rock mass) into position under a passive rock mass [v]\n",
  "UNDERTHRUSTS": "UNDERTHRUST, to insert (a faulted rock mass) into position under a passive rock mass [v]\n",
  "UNDERTIME": "(Spenser) the time of the midday meal, also UNDERNTIME [n -S]\n",
  "UNDERTIMED": "of a photograph, underexposed [adj]\n",
  "UNDERTIMES": "UNDERTIME, (Spenser) the time of the midday meal, also UNDERNTIME [n]\n",
  "UNDERTINT": "a tint underlying another tint [n -S]\n",
  "UNDERTINTS": "UNDERTINT, a tint underlying another tint [n]\n",
  "UNDERTONE": "a subdued tone of voice, sound, colour, etc. [n -S]\n",
  "UNDERTONED": "in an undertone; lacking in tone [adj]\n",
  "UNDERTONES": "UNDERTONE, a subdued tone of voice, sound, colour, etc. [n]\n",
  "UNDERTOOK": "UNDERTAKE, to attempt [v]\n",
  "UNDERTOW": "the seaward pull of receding waves breaking on a shore [n -S]\n",
  "UNDERTOWS": "UNDERTOW, the seaward pull of receding waves breaking on a shore [n]\n",
  "UNDERTRICK": "in bridge, a trick short of the number declared [n -S]\n",
  "UNDERTRICKS": "UNDERTRICK, in bridge, a trick short of the number declared [n]\n",
  "UNDERTRUMP": "to play a lower trump on a trick to which a higher trump has already been played [v -ED, -ING, -S]\n",
  "UNDERTRUMPED": "UNDERTRUMP, to play a lower trump on a trick to which a higher trump has already been played [v]\n",
  "UNDERTRUMPING": "UNDERTRUMP, to play a lower trump on a trick to which a higher trump has already been played [v]\n",
  "UNDERTRUMPS": "UNDERTRUMP, to play a lower trump on a trick to which a higher trump has already been played [v]\n",
  "UNDERUSE": "to not use to the fullest extent [v UNDERUSED, UNDERUSING, UNDERUSES]\n",
  "UNDERUSED": "UNDERUSE, to not use to the fullest extent [v]\n",
  "UNDERUSES": "UNDERUSE, to not use to the fullest extent [v]\n",
  "UNDERUSING": "UNDERUSE, to not use to the fullest extent [v]\n",
  "UNDERUTILISE": "to utilize less than fully, also UNDERUTILIZE [v UNDERUTILISED, UNDERUTILISING, UNDERUTILISES]\n",
  "UNDERUTILISED": "UNDERUTILISE, to utilize less than fully, also UNDERUTILIZE [v]\n",
  "UNDERUTILISES": "UNDERUTILISE, to utilize less than fully, also UNDERUTILIZE [v]\n",
  "UNDERUTILISING": "UNDERUTILISE, to utilize less than fully, also UNDERUTILIZE [v]\n",
  "UNDERUTILIZE": "to utilize less than fully, also UNDERUTILISE [v UNDERUTILIZED, UNDERUTILIZING, UNDERUTILIZES]\n",
  "UNDERUTILIZED": "UNDERUTILIZE, to utilize less than fully, also UNDERUTILISE [v]\n",
  "UNDERUTILIZES": "UNDERUTILIZE, to utilize less than fully, also UNDERUTILISE [v]\n",
  "UNDERUTILIZING": "UNDERUTILIZE, to utilize less than fully, also UNDERUTILISE [v]\n",
  "UNDERVALUATION": "the act of undervaluing [n -S]\n",
  "UNDERVALUATIONS": "UNDERVALUATION, the act of undervaluing [n]\n",
  "UNDERVALUE": "to value below the real worth [v UNDERVALUED, UNDERVALUING, UNDERVALUES]\n",
  "UNDERVALUED": "UNDERVALUE, to value below the real worth [v]\n",
  "UNDERVALUER": "one who undervalues [n -S]\n",
  "UNDERVALUERS": "UNDERVALUER, one who undervalues [n]\n",
  "UNDERVALUES": "UNDERVALUE, to value below the real worth [v]\n",
  "UNDERVALUING": "UNDERVALUE, to value below the real worth [v]\n",
  "UNDERVEST": "an undershirt [n -S]\n",
  "UNDERVESTS": "UNDERVEST, an undershirt [n]\n",
  "UNDERVIEWER": "a mine manager's assistant, also UNDERLOOKER [n -S]\n",
  "UNDERVIEWERS": "UNDERVIEWER, a mine manager's assistant, also UNDERLOOKER [n]\n",
  "UNDERVOICE": "a subdued voice [n -S]\n",
  "UNDERVOICES": "UNDERVOICE, a subdued voice [n]\n",
  "UNDERVOTE": "a vote cast but invalid [n -S]\n",
  "UNDERVOTES": "UNDERVOTE, a vote cast but invalid [n]\n",
  "UNDERWATER": "below the water [adj] / underground water [n -S]\n",
  "UNDERWATERS": "UNDERWATER, underground water [n]\n",
  "UNDERWAY": "in progress [adv]\n",
  "UNDERWEAR": "clothes worn under one's outer clothes, esp. next to the skin [n -S]\n",
  "UNDERWEARS": "UNDERWEAR, clothes worn under one's outer clothes, esp. next to the skin [n]\n",
  "UNDERWEIGHT": "weight below normal, average, or requisite weight [n -S]\n",
  "UNDERWEIGHTS": "UNDERWEIGHT, weight below normal, average, or requisite weight [n]\n",
  "UNDERWENT": "UNDERGO, to be subjected to [v]\n",
  "UNDERWHELM": "to fail to impress [v -ED, -ING, -S]\n",
  "UNDERWHELMED": "UNDERWHELM, to fail to impress [v]\n",
  "UNDERWHELMING": "UNDERWHELM, to fail to impress [v]\n",
  "UNDERWHELMS": "UNDERWHELM, to fail to impress [v]\n",
  "UNDERWING": "the underneath of a bird's wing [n -S]\n",
  "UNDERWINGS": "UNDERWING, the underneath of a bird's wing [n]\n",
  "UNDERWIRE": "to support with wire underneath [v UNDERWIRED, UNDERWIRING, UNDERWIRES]\n",
  "UNDERWIRED": "of a bra etc., having shape provided by a thin strip of metal [adj]\n",
  "UNDERWIRES": "UNDERWIRE, to support with wire underneath [v]\n",
  "UNDERWIRING": "support with wire underneath [n -S]\n",
  "UNDERWIRINGS": "UNDERWIRING, support with wire underneath [n]\n",
  "UNDERWIT": "inferior wit [n -S]\n",
  "UNDERWITS": "UNDERWIT, inferior wit [n]\n",
  "UNDERWOOD": "small trees or shrubs, coppice-wood or brushwood, growing beneath higher timber trees [n -S]\n",
  "UNDERWOODS": "UNDERWOOD, small trees or shrubs, coppice-wood or brushwood, growing beneath higher timber trees [n]\n",
  "UNDERWOOL": "the underneath part of a sheep's fleece [n -S]\n",
  "UNDERWOOLS": "UNDERWOOL, the underneath part of a sheep's fleece [n]\n",
  "UNDERWORK": "to work insufficiently hard [v UNDERWORKED or (Shakespeare) UNDERWROUGHT, UNDERWORKING, UNDERWORKS]\n",
  "UNDERWORKED": "UNDERWORK, to work insufficiently hard [v]\n",
  "UNDERWORKER": "a subordinate worker [n -S]\n",
  "UNDERWORKERS": "UNDERWORKER, a subordinate worker [n]\n",
  "UNDERWORKING": "UNDERWORK, to work insufficiently hard [v]\n",
  "UNDERWORKS": "UNDERWORK, to work insufficiently hard [v]\n",
  "UNDERWORLD": "the place of departed souls [n -S]\n",
  "UNDERWORLDS": "UNDERWORLD, the place of departed souls [n]\n",
  "UNDERWRITE": "to write under or at the end of something else [v UNDERWROTE, UNDERWRITTEN, UNDERWRITING, UNDERWRITES]\n",
  "UNDERWRITER": "one that underwrites [n -S]\n",
  "UNDERWRITERS": "UNDERWRITER, one that underwrites [n]\n",
  "UNDERWRITES": "UNDERWRITE, to write under or at the end of something else [v]\n",
  "UNDERWRITING": "the act of underwriting [n -S]\n",
  "UNDERWRITINGS": "UNDERWRITING, the act of underwriting [n]\n",
  "UNDERWRITTEN": "UNDERWRITE, to write under or at the end of something else [v]\n",
  "UNDERWROTE": "UNDERWRITE, to write under or at the end of something else [v]\n",
  "UNDERWROUGHT": "(Shakespeare) insufficiently wrought [adj]\n",
  "UNDESCENDABLE": "that cannot be descended, also UNDESCENDIBLE [adj]\n",
  "UNDESCENDED": "retained within the inguinal region rather than descending into the scrotum [adj]\n",
  "UNDESCENDIBLE": "that cannot be descended, also UNDESCENDABLE [adj]\n",
  "UNDESCRIBABLE": "not describable [adj]\n",
  "UNDESCRIBED": "not described [adj]\n",
  "UNDESCRIED": "not descried [adj]\n",
  "UNDESERT": "a lack of merit [n -S]\n",
  "UNDESERTS": "UNDESERT, a lack of merit [n]\n",
  "UNDESERVE": "to fail to deserve [v UNDESERVED, UNDESERVING, UNDESERVES]\n",
  "UNDESERVED": "UNDESERVE, to fail to deserve [v]\n",
  "UNDESERVEDLY": "UNDESERVED, UNDESERVE, to fail to deserve [adv]\n",
  "UNDESERVEDNESS": "the state of being undeserved [n]\n",
  "UNDESERVER": "(Shakespeare) one who is not deserving [n -S]\n",
  "UNDESERVERS": "UNDESERVER, (Shakespeare) one who is not deserving [n]\n",
  "UNDESERVES": "UNDESERVE, to fail to deserve [v]\n",
  "UNDESERVING": "not deserving [adj UNDESERVINGLY]\n",
  "UNDESERVINGLY": "UNDESERVING, not deserving [adv]\n",
  "UNDESIGNATED": "not designated [adj]\n",
  "UNDESIGNED": "not designed [adj UNDESIGNEDLY]\n",
  "UNDESIGNEDLY": "UNDESIGNED, not designed [adv]\n",
  "UNDESIGNEDNESS": "the state of being undesigned [n]\n",
  "UNDESIGNING": "having no ulterior or fraudulent purpose [adj]\n",
  "UNDESIRABILITY": "the state of being undesirable [n]\n",
  "UNDESIRABLE": "not desirable [adj UNDESIRABLY] / an undesirable person [n -S]\n",
  "UNDESIRABLENESS": "the state of being undesirable [n]\n",
  "UNDESIRABLES": "UNDESIRABLE, an undesirable person [n]\n",
  "UNDESIRABLY": "UNDESIRABLE, not desirable [adv]\n",
  "UNDESIRED": "not desired [adj]\n",
  "UNDESIRING": "not desiring [adj]\n",
  "UNDESIROUS": "not desirous [adj]\n",
  "UNDESPAIRING": "not despairing [adj UNDESPAIRINGLY]\n",
  "UNDESPAIRINGLY": "UNDESPAIRING, not despairing [adv]\n",
  "UNDESPATCHED": "not despatched [adj]\n",
  "UNDESPOILED": "not despoiled [adj]\n",
  "UNDESTROYED": "not destroyed [adj]\n",
  "UNDETECTABLE": "not detectable [adj]\n",
  "UNDETECTED": "not detected [adj]\n",
  "UNDETERMINABLE": "not determinable [adj]\n",
  "UNDETERMINATE": "not determinate [adj]\n",
  "UNDETERMINATION": "lack of determination [n]\n",
  "UNDETERMINED": "not determined [adj]\n",
  "UNDETERRED": "not deterred [adj]\n",
  "UNDEVELOPED": "not developed [adj]\n",
  "UNDEVIATING": "keeping a true course [adj UNDEVIATINGLY]\n",
  "UNDEVIATINGLY": "UNDEVIATING, keeping a true course [adv]\n",
  "UNDEVOUT": "not devout, also INDEVOUT [adj]\n",
  "UNDIAGNOSABLE": "not diagnosable [adj]\n",
  "UNDIAGNOSED": "not diagnosed [adj]\n",
  "UNDIALECTICAL": "not dialectical [adj]\n",
  "UNDID": "UNDO, to bring to ruin [v]\n",
  "UNDIDACTIC": "not didactic [adj]\n",
  "UNDIES": "women's underclothing [n]\n",
  "UNDIFFERENCED": "not differenced [adj]\n",
  "UNDIGESTED": "not digested [adj]\n",
  "UNDIGESTIBLE": "not digestible, also INDIGESTIBLE [adj]\n",
  "UNDIGHT": "(Spenser) to undo, take off [v UNDIGHT, UNDIGHTING, UNDIGHTS]\n",
  "UNDIGHTING": "UNDIGHT, (Spenser) to undo, take off [v]\n",
  "UNDIGHTS": "UNDIGHT, (Spenser) to undo, take off [v]\n",
  "UNDIGNIFIED": "not dignified [adj]\n",
  "UNDIGNIFIES": "UNDIGNIFY, to deprive of dignify [v]\n",
  "UNDIGNIFY": "to deprive of dignify [v UNDIGNIFIED, UNDIGNIFYING, UNDIGNIFIES]\n",
  "UNDIGNIFYING": "UNDIGNIFY, to deprive of dignify [v]\n",
  "UNDILUTED": "not diluted [adj]\n",
  "UNDIMINISHABLE": "not diminishable [adj]\n",
  "UNDIMINISHED": "not diminished [adj]\n",
  "UNDIMMED": "not dimmed [adj]\n",
  "UNDINE": "a female water spirit, also ONDINE [n -S]\n",
  "UNDINES": "UNDINE, a female water spirit, also ONDINE [n]\n",
  "UNDINISM": "a preoccupation with water [n -S]\n",
  "UNDINISMS": "UNDINISM, a preoccupation with water [n]\n",
  "UNDINTED": "not dinted [adj]\n",
  "UNDIPLOMATIC": "not diplomatic [adj]\n",
  "UNDIPPED": "unbaptised [adj]\n",
  "UNDIRECTED": "not directed [adj]\n",
  "UNDISAPPOINTING": "not disappointing [adj]\n",
  "UNDISCERNED": "not discerned [adj UNDISCERNEDLY]\n",
  "UNDISCERNEDLY": "UNDISCERNED, not discerned [adv]\n",
  "UNDISCERNIBLE": "incapable of being discerned [adj UNDISCERNIBLY]\n",
  "UNDISCERNIBLY": "UNDISCERNIBLE, incapable of being discerned [adv]\n",
  "UNDISCERNING": "lack of discernment [n -S]\n",
  "UNDISCERNINGS": "UNDISCERNING, lack of discernment [n]\n",
  "UNDISCHARGED": "not discharged [adj]\n",
  "UNDISCIPLINABLE": "not disciplinable [adj]\n",
  "UNDISCIPLINE": "lack of discipline, also INDISCIPLINE [n -S]\n",
  "UNDISCIPLINED": "not disciplined [adj]\n",
  "UNDISCIPLINES": "UNDISCIPLINE, lack of discipline, also INDISCIPLINE [n]\n",
  "UNDISCLOSED": "not disclosed [adj]\n",
  "UNDISCOMFITED": "not discomfited [adj]\n",
  "UNDISCORDANT": "not discordant [adj]\n",
  "UNDISCORDING": "(Milton) not discordant [adj]\n",
  "UNDISCOURAGED": "not discouraged [adj]\n",
  "UNDISCOVERABLE": "not discoverable [adj UNDISCOVERABLY]\n",
  "UNDISCOVERABLY": "UNDISCOVERABLE, not discoverable [adv]\n",
  "UNDISCOVERED": "not discovered [adj]\n",
  "UNDISCUSSABLE": "that cannot be discussed, also UNDISCUSSIBLE [adj]\n",
  "UNDISCUSSED": "not discussed [adj]\n",
  "UNDISCUSSIBLE": "that cannot be discussed, also UNDISCUSSABLE [adj]\n",
  "UNDISGUISABLE": "not disguisable [adj]\n",
  "UNDISGUISED": "not disguised or concealed [adj UNDISGUISEDLY]\n",
  "UNDISGUISEDLY": "UNDISGUISED, not disguised or concealed [adv]\n",
  "UNDISHONOURED": "not dishonoured [adj]\n",
  "UNDISMANTLED": "not dismantled [adj]\n",
  "UNDISMAYED": "not dismayed [adj]\n",
  "UNDISORDERED": "not disordered [adj]\n",
  "UNDISPATCHED": "not dispatched [adj]\n",
  "UNDISPENSED": "not dispensed [adj]\n",
  "UNDISPOSED": "not disposed [adj]\n",
  "UNDISPUTABLE": "not disputable [adj]\n",
  "UNDISPUTED": "not disputed [adj UNDISPUTEDLY]\n",
  "UNDISPUTEDLY": "UNDISPUTED, not disputed [adv]\n",
  "UNDISSEMBLED": "not dissembled [adj]\n",
  "UNDISSOCIATED": "not electrolytically dissociated [adj]\n",
  "UNDISSOLVED": "not dissolved [adj]\n",
  "UNDISSOLVING": "not dissolving [adj]\n",
  "UNDISTEMPERED": "not distempered [adj]\n",
  "UNDISTILLED": "not distilled [adj]\n",
  "UNDISTINCTIVE": "not distinctive [adj]\n",
  "UNDISTINGUISHED": "not distinguished [adj]\n",
  "UNDISTORTED": "not distorted [adj]\n",
  "UNDISTRACTED": "not distracted [adj UNDISTRACTEDLY]\n",
  "UNDISTRACTEDLY": "UNDISTRACTED, not distracted [adv]\n",
  "UNDISTRACTING": "not distracting [adj]\n",
  "UNDISTRIBUTED": "not distributed [adj]\n",
  "UNDISTURBED": "not disturbed [adj UNDISTURBEDLY]\n",
  "UNDISTURBEDLY": "UNDISTURBED, not disturbed [adv]\n",
  "UNDISTURBING": "not disturbing [adj]\n",
  "UNDIVERSIFIED": "not diversified [adj]\n",
  "UNDIVERTED": "not diverted [adj]\n",
  "UNDIVERTING": "not diverting [adj]\n",
  "UNDIVESTED": "not divested [adj UNDIVESTEDLY]\n",
  "UNDIVESTEDLY": "UNDIVESTED, not divested [adv]\n",
  "UNDIVIDABLE": "that cannot be divided [adj]\n",
  "UNDIVIDED": "not divided [adj UNDIVIDEDLY]\n",
  "UNDIVIDEDLY": "UNDIVIDED, not divided [adv]\n",
  "UNDIVIDEDNESS": "the state of being undivided [n -ES]\n",
  "UNDIVIDEDNESSES": "UNDIVIDEDNESS, the state of being undivided [n]\n",
  "UNDIVINE": "not divine [adj]\n",
  "UNDIVORCED": "not divorced [adj]\n",
  "UNDIVULGED": "not divulged [adj]\n",
  "UNDO": "a computer feature that allows the user to reverse the effect of the last action [n -S] / to bring to ruin [v UNDID, UNDONE, UNDOING, UNDOES]\n",
  "UNDOABLE": "not able to be done [adj]\n",
  "UNDOCILE": "not docile, also INDOCILE [adj]\n",
  "UNDOCK": "to move away from a dock [v -ED, -ING, -S]\n",
  "UNDOCKED": "UNDOCK, to move away from a dock [v]\n",
  "UNDOCKING": "UNDOCK, to move away from a dock [v]\n",
  "UNDOCKS": "UNDOCK, to move away from a dock [v]\n",
  "UNDOCTORED": "not doctored [adj]\n",
  "UNDOCTRINAIRE": "a person who does not subscribe to a particular doctrine or theory; a free thinker [n -S]\n",
  "UNDOCTRINAIRES": "UNDOCTRINAIRE, a person who does not subscribe to a particular doctrine or theory; a free thinker [n]\n",
  "UNDOCUMENTED": "not documented [adj]\n",
  "UNDOER": "one who undoes [n -S]\n",
  "UNDOERS": "UNDOER, one who undoes [n]\n",
  "UNDOES": "UNDO, to bring to ruin [v]\n",
  "UNDOGMATIC": "not dogmatic [adj UNDOGMATICALLY]\n",
  "UNDOGMATICALLY": "UNDOGMATIC, not dogmatic [adv]\n",
  "UNDOING": "the reversal of what has been done [n -S]\n",
  "UNDOINGS": "UNDOING, the reversal of what has been done [n]\n",
  "UNDOMESTIC": "not domestic [adj]\n",
  "UNDOMESTICATE": "to make not domesticated [v UNDOMESTICATED, UNDOMESTICATING, UNDOMESTICATES]\n",
  "UNDOMESTICATED": "UNDOMESTICATE, to make not domesticated [v]\n",
  "UNDOMESTICATES": "UNDOMESTICATE, to make not domesticated [v]\n",
  "UNDOMESTICATING": "UNDOMESTICATE, to make not domesticated [v]\n",
  "UNDONE": "UNDO, to bring to ruin [v]\n",
  "UNDOOMED": "not doomed [adj]\n",
  "UNDOS": "UNDO, a computer feature that allows the user to reverse the effect of the last action [n]\n",
  "UNDOTTED": "not dotted [adj]\n",
  "UNDOUBLE": "to change from a state of being doubled [v UNDOUBLED, UNDOUBLING, UNDOUBLES]\n",
  "UNDOUBLED": "UNDOUBLE, to change from a state of being doubled [v]\n",
  "UNDOUBLES": "UNDOUBLE, to change from a state of being doubled [v]\n",
  "UNDOUBLING": "UNDOUBLE, to change from a state of being doubled [v]\n",
  "UNDOUBTABLE": "that cannot be doubted [adj]\n",
  "UNDOUBTED": "not doubted [adj UNDOUBTEDLY]\n",
  "UNDOUBTEDLY": "UNDOUBTED, not doubted [adv]\n",
  "UNDOUBTFUL": "not doubtful [adj]\n",
  "UNDOUBTING": "not doubting [adj UNDOUBTINGLY]\n",
  "UNDOUBTINGLY": "UNDOUBTING, not doubting [adv]\n",
  "UNDOWERED": "not dowered [adj]\n",
  "UNDRAINABLE": "that cannot be drained [adj]\n",
  "UNDRAINED": "not drained [adj]\n",
  "UNDRAMATIC": "lacking dramatic force or quality [adj UNDRAMATICALLY]\n",
  "UNDRAMATICALLY": "UNDRAMATIC, lacking dramatic force or quality [adv]\n",
  "UNDRAMATISED": "not dramatised, also UNDRAMATIZED [adj]\n",
  "UNDRAMATIZED": "not dramatized, also UNDRAMATISED [adj]\n",
  "UNDRAPE": "to strip of drapery [v UNDRAPED, UNDRAPING, UNDRAPES]\n",
  "UNDRAPED": "UNDRAPE, to strip of drapery [v]\n",
  "UNDRAPES": "UNDRAPE, to strip of drapery [v]\n",
  "UNDRAPING": "UNDRAPE, to strip of drapery [v]\n",
  "UNDRAW": "to draw open [v UNDREW, UNDRAWN, UNDRAWING, UNDRAWS]\n",
  "UNDRAWING": "UNDRAW, to draw open [v]\n",
  "UNDRAWN": "UNDRAW, to draw open [v]\n",
  "UNDRAWS": "UNDRAW, to draw open [v]\n",
  "UNDREADED": "not dreaded [adj]\n",
  "UNDREADING": "of or related to the unravelling of hair dreadlocks [adj]\n",
  "UNDREAMED": "not dreamed of, also UNDREAMT [adj]\n",
  "UNDREAMING": "not dreaming [adj]\n",
  "UNDREAMT": "not dreamed about [adj]\n",
  "UNDRESS": "to take off clothing [v UNDRESSED, UNDREST, UNDRESSING, UNDRESSES]\n",
  "UNDRESSED": "UNDRESS, to take off clothing [v]\n",
  "UNDRESSES": "UNDRESS, to take off clothing [v]\n",
  "UNDRESSING": "the act of undressing [n -S]\n",
  "UNDRESSINGS": "UNDRESSING, the act of undressing [n]\n",
  "UNDREST": "UNDRESS, to take off clothing [v]\n",
  "UNDREW": "UNDRAW, to draw open [v]\n",
  "UNDRIED": "not dried [adj]\n",
  "UNDRILLED": "not drilled [adj]\n",
  "UNDRINKABLE": "unsuitable or unpleasant to drink [adj]\n",
  "UNDRIVEABLE": "that cannot be driven [adj]\n",
  "UNDRIVEN": "not driven [adj]\n",
  "UNDROOPING": "not drooping [adj]\n",
  "UNDROSSIER": "UNDROSSY, not drossy [adj]\n",
  "UNDROSSIEST": "UNDROSSY, not drossy [adj]\n",
  "UNDROSSY": "not drossy [adj UNDROSSIER, UNDROSSIEST]\n",
  "UNDROWNED": "not drowned [adj]\n",
  "UNDRUNK": "not swallowed [adj]\n",
  "UNDUBBED": "not dubbed [adj]\n",
  "UNDUE": "exceeding what is appropriate or normal [adj UNDULY]\n",
  "UNDUG": "not dug [adj]\n",
  "UNDULANCE": "the state of being undulant, also UNDULANCY [n -S]\n",
  "UNDULANCES": "UNDULANCE, the state of being undulant, also UNDULANCY [n]\n",
  "UNDULANCIES": "UNDULANCY, the state of being undulant, also UNDULANCE [n]\n",
  "UNDULANCY": "the state of being undulant, also UNDULANCE [n UNDULANCIES]\n",
  "UNDULANT": "rising and falling in waves, also UNDULAR [adj]\n",
  "UNDULAR": "undulating, wavy, also UNDULANT [adj]\n",
  "UNDULATE": "wavy [adj UNDULATELY] / to move with a wavelike motion [v UNDULATED, UNDULATING, UNDULATES]\n",
  "UNDULATED": "UNDULATE, to move with a wavelike motion [v]\n",
  "UNDULATELY": "UNDULATE, wavy [adv]\n",
  "UNDULATES": "UNDULATE, to move with a wavelike motion [v]\n",
  "UNDULATING": "UNDULATE, to move with a wavelike motion [v]\n",
  "UNDULATINGLY": "UNDULATING, UNDULATE, to move with a wavelike motion [adv]\n",
  "UNDULATION": "a rising and falling in waves [n -S]\n",
  "UNDULATIONIST": "someone who holds the undulatory theory of light [n -S]\n",
  "UNDULATIONISTS": "UNDULATIONIST, someone who holds the undulatory theory of light [n]\n",
  "UNDULATIONS": "UNDULATION, a rising and falling in waves [n]\n",
  "UNDULATOR": "one that undulates [n -S]\n",
  "UNDULATORS": "UNDULATOR, one that undulates [n]\n",
  "UNDULATORY": "moving in the manner of undulations, or waves [adj]\n",
  "UNDULLED": "not dulled [adj]\n",
  "UNDULOSE": "undulating, wavy, also UNDULOUS [adj]\n",
  "UNDULOUS": "undulating, wavy, also UNDULOSE [adj]\n",
  "UNDULY": "UNDUE, exceeding what is appropriate or normal [adv]\n",
  "UNDUPLICATED": "not duplicated [adj]\n",
  "UNDUTEOUS": "not duteous [adj]\n",
  "UNDUTIFUL": "not dutiful [adj UNDUTIFULLY]\n",
  "UNDUTIFULLY": "UNDUTIFUL, not dutiful [adv]\n",
  "UNDUTIFULNESS": "the state of being undutiful [n -ES]\n",
  "UNDUTIFULNESSES": "UNDUTIFULNESS, the state of being undutiful [n]\n",
  "UNDY": "wavy, also OUNDY, UNDE, UNDEE [adj]\n",
  "UNDYED": "not dyed [adj]\n",
  "UNDYING": "not subject to death [adj UNDYINGLY]\n",
  "UNDYINGLY": "UNDYING, not subject to death [adv]\n",
  "UNDYINGNESS": "the state being undying [n -ES]\n",
  "UNDYINGNESSES": "UNDYINGNESS, the state being undying [n]\n",
  "UNDYNAMIC": "not dynamic [adj]\n",
  "UNEAGER": "not eager [adj UNEAGERLY]\n",
  "UNEAGERLY": "UNEAGER, not eager [adv]\n",
  "UNEARED": "not eared [adj]\n",
  "UNEARMARKED": "not earmarked [adj]\n",
  "UNEARNED": "not earned [adj]\n",
  "UNEARTH": "to dig up [v -ED, -ING, -S]\n",
  "UNEARTHED": "UNEARTH, to dig up [v]\n",
  "UNEARTHING": "UNEARTH, to dig up [v]\n",
  "UNEARTHLIER": "UNEARTHLY, not belonging to the earth, eerie [adj]\n",
  "UNEARTHLIEST": "UNEARTHLY, not belonging to the earth, eerie [adj]\n",
  "UNEARTHLINESS": "the state of being unearthly [n -ES]\n",
  "UNEARTHLINESSES": "UNEARTHLINESS, the state of being unearthly [n]\n",
  "UNEARTHLY": "not belonging to the earth, eerie [adj UNEARTHLIER, UNEARTHLIEST]\n",
  "UNEARTHS": "UNEARTH, to dig up [v]\n",
  "UNEASE": "mental or physical discomfort [n -S]\n",
  "UNEASES": "UNEASE, mental or physical discomfort [n]\n",
  "UNEASIER": "UNEASY, marked by mental or physical discomfort [adj]\n",
  "UNEASIEST": "UNEASY, marked by mental or physical discomfort [adj]\n",
  "UNEASILY": "UNEASY, marked by mental or physical discomfort [adv]\n",
  "UNEASINESS": "the state of being uneasy [n -ES]\n",
  "UNEASINESSES": "UNEASINESS, the state of being uneasy [n]\n",
  "UNEASY": "marked by mental or physical discomfort [adj UNEASIER, UNEASIEST, UNEASILY]\n",
  "UNEATABLE": "that cannot be eaten [adj]\n",
  "UNEATABLENESS": "UNEATABLE, that cannot be eaten [n]\n",
  "UNEATABLENESSES": "UNEATABLENESS, UNEATABLE, that cannot be eaten [n]\n",
  "UNEATEN": "not eaten [adj]\n",
  "UNEATH": "(archaic) with difficulty, hardly, also UNEATHES, UNETH, UNNETHES [adv]\n",
  "UNEATHES": "(archaic) with difficulty, hardly, also UNEATH, UNETH, UNNETHES [adv]\n",
  "UNECCENTRIC": "not eccentric [adj]\n",
  "UNECLIPSED": "not eclipsed [adj]\n",
  "UNECOLOGICAL": "not ecological [adj]\n",
  "UNECONOMIC": "not economically practicable, also UNECONOMICAL [adj]\n",
  "UNECONOMICAL": "not economically practicable, also UNECONOMIC [adj]\n",
  "UNEDGE": "to blunt [v UNEDGED, UNEDGING, UNEDGES]\n",
  "UNEDGED": "UNEDGE, to blunt [v]\n",
  "UNEDGES": "UNEDGE, to blunt [v]\n",
  "UNEDGING": "UNEDGE, to blunt [v]\n",
  "UNEDIBLE": "not suitable for eating, also INEDIBLE [adj]\n",
  "UNEDIFYING": "not edifying [adj]\n",
  "UNEDITED": "not edited, also INEDITED [adj]\n",
  "UNEDUCABLE": "not educable [adj]\n",
  "UNEDUCATED": "not educated [adj]\n",
  "UNEFFACED": "not effaced [adj]\n",
  "UNEFFECTED": "not effected [adj]\n",
  "UNELABORATE": "not elaborate [adj]\n",
  "UNELABORATED": "not elaborated [adj]\n",
  "UNELATED": "not elated [adj]\n",
  "UNELECTABLE": "not electable [adj]\n",
  "UNELECTED": "not elected [adj]\n",
  "UNELECTRIFIED": "not electrified [adj]\n",
  "UNEMBARRASSED": "not embarrassed [adj]\n",
  "UNEMBELLISHED": "not embellished [adj]\n",
  "UNEMBITTERED": "not embittered [adj]\n",
  "UNEMBODIED": "free from a corporeal body; disembodied; as, unembodied spirits [adj]\n",
  "UNEMOTIONAL": "not emotional [adj UNEMOTIONALLY]\n",
  "UNEMOTIONALLY": "UNEMOTIONAL, not emotional [adv]\n",
  "UNEMOTIONED": "without emotion [adj]\n",
  "UNEMPHASISED": "not emphasized, also UNEMPHASIZED [adj]\n",
  "UNEMPHASIZED": "not emphasized, also UNEMPHASISED [adj]\n",
  "UNEMPHATIC": "not emphatic [adj UNEMPHATICALLY]\n",
  "UNEMPHATICALLY": "UNEMPHATIC, not emphatic [adv]\n",
  "UNEMPIRICAL": "not empirical [adj]\n",
  "UNEMPLOYABILITY": "the state of being unemployable [n]\n",
  "UNEMPLOYABLE": "not acceptable for employment [adj] / one not acceptable for employment [n -S]\n",
  "UNEMPLOYABLES": "UNEMPLOYABLE, one not acceptable for employment [n]\n",
  "UNEMPLOYED": "not employed [adj] / one who is unemployed [n -S]\n",
  "UNEMPLOYEDS": "UNEMPLOYED, one who is unemployed [n]\n",
  "UNEMPLOYMENT": "the state of being unemployed [n -S]\n",
  "UNEMPLOYMENTS": "UNEMPLOYMENT, the state of being unemployed [n]\n",
  "UNEMPTIED": "not emptied [adj]\n",
  "UNENCHANTED": "not enchanted [adj]\n",
  "UNENCLOSED": "not enclosed, also UNINCLOSED [adj]\n",
  "UNENCOURAGING": "not encouraging [adj]\n",
  "UNENCUMBERED": "free of encumbrance [adj]\n",
  "UNENDANGERED": "not endangered [adj]\n",
  "UNENDEARED": "not endeared [adj]\n",
  "UNENDEARING": "not endearing [adj]\n",
  "UNENDED": "not ended [adj]\n",
  "UNENDING": "not ending [adj UNENDINGLY]\n",
  "UNENDINGLY": "UNENDING, not ending [adv]\n",
  "UNENDINGNESS": "the state of being unending [n -ES]\n",
  "UNENDINGNESSES": "UNENDINGNESS, the state of being unending [n]\n",
  "UNENDOWED": "not endowed [adj]\n",
  "UNENDURABLE": "that cannot be endured [adj UNENDURABLY]\n",
  "UNENDURABLENESS": "the state of being unendurable [n]\n",
  "UNENDURABLY": "UNENDURABLE, that cannot be endured [adv]\n",
  "UNENFORCEABLE": "not enforceable [adj]\n",
  "UNENFORCED": "not enforced [adj]\n",
  "UNENGAGED": "not engaged [adj]\n",
  "UNENJOYABLE": "not enjoyable [adj]\n",
  "UNENJOYED": "not enjoyed [adj]\n",
  "UNENLARGED": "not enlarged [adj]\n",
  "UNENLIGHTENED": "not enlightened [adj]\n",
  "UNENLIGHTENING": "not enlightening [adj]\n",
  "UNENQUIRING": "not enquiring [adj]\n",
  "UNENRICHED": "not enriched [adj]\n",
  "UNENSLAVED": "not enslaved [adj]\n",
  "UNENSURED": "not ensured [adj]\n",
  "UNENTAILED": "not entailed [adj]\n",
  "UNENTERED": "not entered [adj]\n",
  "UNENTERPRISING": "not enterprising [adj]\n",
  "UNENTERTAINED": "not entertained [adj]\n",
  "UNENTERTAINING": "not entertaining [adj]\n",
  "UNENTHRALLED": "not enthralled [adj]\n",
  "UNENTHUSIASTIC": "not enthusiastic [adj]\n",
  "UNENTITLED": "not entitled [adj]\n",
  "UNENVIABLE": "not enviable [adj UNENVIABLY]\n",
  "UNENVIABLY": "UNENVIABLE, not enviable [adv]\n",
  "UNENVIED": "not envied [adj]\n",
  "UNENVIOUS": "not envious [adj]\n",
  "UNENVYING": "not envying [adj]\n",
  "UNEQUABLE": "not equable, also INEQUABLE [adj]\n",
  "UNEQUAL": "not equal [adj UNEQUALLY] / one who is not an equal [n -S]\n",
  "UNEQUALED": "not equalled, also UNEQUALLED [adj]\n",
  "UNEQUALLED": "not equalled, also UNEQUALED [adj]\n",
  "UNEQUALLY": "UNEQUAL, not equal [adv]\n",
  "UNEQUALS": "UNEQUAL, one who is not an equal [n]\n",
  "UNEQUIPPED": "not equipped [adj]\n",
  "UNEQUITABLE": "not equitable, also INEQUITABLE [adj]\n",
  "UNEQUIVOCABLE": "leaving no doubt, also UNEQUIVOCAL [adj]\n",
  "UNEQUIVOCABLY": "without equivocation [adv]\n",
  "UNEQUIVOCAL": "leaving no doubt, also UNEQUIVOCABLE [adj UNEQUIVOCALLY]\n",
  "UNEQUIVOCALLY": "UNEQUIVOCAL, leaving no doubt, also UNEQUIVOCABLE [adv]\n",
  "UNEQUIVOCALNESS": "the state of being unequivocal [n]\n",
  "UNERASABLE": "that cannot be erased [adj]\n",
  "UNERASED": "not erased [adj]\n",
  "UNEROTIC": "not erotic [adj]\n",
  "UNERRING": "not erring [adj UNERRINGLY]\n",
  "UNERRINGLY": "UNERRING, not erring [adv]\n",
  "UNERRINGNESS": "the state of being unerring [n -ES]\n",
  "UNERRINGNESSES": "UNERRINGNESS, the state of being unerring [n]\n",
  "UNERUPTED": "of a volcano, that has not erupted [adj]\n",
  "UNESCAPABLE": "not escapable [adj]\n",
  "UNESCORTED": "not escorted [adj]\n",
  "UNESPIED": "not espied [adj]\n",
  "UNESSAYED": "not essayed [adj]\n",
  "UNESSENCE": "to deprive of essence or being [v UNESSENCED, UNESSENCING, UNESSENCES]\n",
  "UNESSENCED": "UNESSENCE, to deprive of essence or being [v]\n",
  "UNESSENCES": "UNESSENCE, to deprive of essence or being [v]\n",
  "UNESSENCING": "UNESSENCE, to deprive of essence or being [v]\n",
  "UNESSENTIAL": "not essential [adj UNESSENTIALLY] / something not essential [n -S]\n",
  "UNESSENTIALLY": "UNESSENTIAL, not essential [adv]\n",
  "UNESSENTIALS": "UNESSENTIAL, something not essential [n]\n",
  "UNESTABLISHED": "not established [adj]\n",
  "UNESTHETIC": "(US) unaesthetic, also UNAESTHETIC [adj]\n",
  "UNETH": "(archaic) with difficulty, hardly, also UNEATH, UNEATHES, UNNETHES [adv]\n",
  "UNETHICAL": "not ethical [adj UNETHICALLY]\n",
  "UNETHICALLY": "UNETHICAL, not ethical [adv]\n",
  "UNEVADED": "not evaded [adj]\n",
  "UNEVALUATED": "not evaluated [adj]\n",
  "UNEVANGELICAL": "not evangelical [adj]\n",
  "UNEVEN": "not even [adj UNEVENER, UNEVENEST, UNEVENLY]\n",
  "UNEVENER": "UNEVEN, not even [adj]\n",
  "UNEVENEST": "UNEVEN, not even [adj]\n",
  "UNEVENLY": "UNEVEN, not even [adv]\n",
  "UNEVENNESS": "the state of being uneven [n -ES]\n",
  "UNEVENNESSES": "UNEVENNESS, the state of being uneven [n]\n",
  "UNEVENTFUL": "marked by no noteworthy or untoward incidents [adj UNEVENTFULLY]\n",
  "UNEVENTFULLY": "UNEVENTFUL, marked by no noteworthy or untoward incidents [adv]\n",
  "UNEVENTFULNESS": "the state of being uneventful [n]\n",
  "UNEVIDENCED": "not evidenced [adj]\n",
  "UNEVOLVED": "not evolved [adj]\n",
  "UNEXACTING": "not exacting [adj]\n",
  "UNEXAGGERATED": "not exaggerated [adj]\n",
  "UNEXALTED": "not exalted [adj]\n",
  "UNEXAMINED": "not examined [adj]\n",
  "UNEXAMPLED": "having no example or similar case; being without precedent [adj]\n",
  "UNEXCAVATED": "not excavated [adj]\n",
  "UNEXCELLED": "not excelled [adj]\n",
  "UNEXCEPTIONABLE": "not open to objection or criticism [adj UNEXCEPTIONABLY]\n",
  "UNEXCEPTIONABLY": "UNEXCEPTIONABLE, not open to objection or criticism [adv]\n",
  "UNEXCEPTIONAL": "not out of the ordinary [adj UNEXCEPTIONALLY]\n",
  "UNEXCEPTIONALLY": "UNEXCEPTIONAL, not out of the ordinary [adv]\n",
  "UNEXCITABLE": "not excitable [adj]\n",
  "UNEXCITED": "not excited [adj]\n",
  "UNEXCITING": "not exciting [adj]\n",
  "UNEXCLUDED": "not excluded [adj]\n",
  "UNEXCLUSIVE": "not exclusive [adj UNEXCLUSIVELY]\n",
  "UNEXCLUSIVELY": "UNEXCLUSIVE, not exclusive [adv]\n",
  "UNEXCUSED": "not excused [adj]\n",
  "UNEXECUTED": "not executed [adj]\n",
  "UNEXEMPLIFIED": "not exemplified [adj]\n",
  "UNEXERCISED": "having terms that are not implemented [adj]\n",
  "UNEXHAUSTED": "not exhausted, also INEXHAUSTED [adj]\n",
  "UNEXOTIC": "not exotic [adj]\n",
  "UNEXPANDED": "not expanded [adj]\n",
  "UNEXPECTANT": "not expectant [adj]\n",
  "UNEXPECTED": "not expected [adj UNEXPECTEDLY]\n",
  "UNEXPECTEDLY": "UNEXPECTED, not expected [adv]\n",
  "UNEXPECTEDNESS": "the state of being unexpected [n]\n",
  "UNEXPENDED": "not expended [adj]\n",
  "UNEXPENSIVE": "not expensive, also INEXPENSIVE [adj UNEXPENSIVELY]\n",
  "UNEXPENSIVELY": "UNEXPENSIVE, not expensive, also INEXPENSIVE [adv]\n",
  "UNEXPERIENCED": "not experienced, also INEXPERIENCED [adj]\n",
  "UNEXPERIENT": "(Shakespeare) inexperienced [adj]\n",
  "UNEXPERT": "not expert, also INEXPERT [adj]\n",
  "UNEXPIATED": "not expiated [adj]\n",
  "UNEXPIRED": "not expired [adj]\n",
  "UNEXPLAINABLE": "not explainable [adj]\n",
  "UNEXPLAINED": "not explained [adj]\n",
  "UNEXPLODED": "not exploded [adj]\n",
  "UNEXPLOITED": "not exploited or developed [adj]\n",
  "UNEXPLORED": "not explored [adj]\n",
  "UNEXPOSED": "not exposed [adj]\n",
  "UNEXPRESSED": "not expressed [adj]\n",
  "UNEXPRESSIBLE": "not expressible [adj]\n",
  "UNEXPRESSIVE": "not expressive [adj]\n",
  "UNEXPUGNABLE": "not expugnable [adj]\n",
  "UNEXPURGATED": "not expurgated [adj]\n",
  "UNEXTENDED": "not extended [adj]\n",
  "UNEXTENUATED": "not extenuated [adj]\n",
  "UNEXTINCT": "not extinct [adj]\n",
  "UNEXTINGUISHED": "not extinguished [adj]\n",
  "UNEXTRAORDINARY": "not extraordinary [adj]\n",
  "UNEXTREME": "not extreme [adj]\n",
  "UNEYED": "unseen [adj]\n",
  "UNFABLED": "not fabled [adj]\n",
  "UNFACETED": "not faceted [adj]\n",
  "UNFACT": "a fact that must not be acknowledged [n -S]\n",
  "UNFACTS": "UNFACT, a fact that must not be acknowledged [n]\n",
  "UNFADABLE": "not subject to fading [adj]\n",
  "UNFADED": "not faded [adj]\n",
  "UNFADING": "not fading [adj UNFADINGLY]\n",
  "UNFADINGLY": "UNFADING, not fading [adv]\n",
  "UNFADINGNESS": "the state of being unfading [n -ES]\n",
  "UNFADINGNESSES": "UNFADINGNESS, the state of being unfading [n]\n",
  "UNFAILING": "not failing, reliable [adj UNFAILINGLY]\n",
  "UNFAILINGLY": "UNFAILING, not failing, reliable [adv]\n",
  "UNFAILINGNESS": "the state of being unfailing [n -ES]\n",
  "UNFAILINGNESSES": "UNFAILINGNESS, the state of being unfailing [n]\n",
  "UNFAIR": "not fair [adj UNFAIRER, UNFAIREST, UNFAIRLY] / (Shakespeare) to deprive of beauty [v -ED, -ING, -S]\n",
  "UNFAIRED": "UNFAIR, (Shakespeare) to deprive of beauty [v]\n",
  "UNFAIRER": "UNFAIR, not fair [adj]\n",
  "UNFAIREST": "UNFAIR, not fair [adj]\n",
  "UNFAIRING": "UNFAIR, (Shakespeare) to deprive of beauty [v]\n",
  "UNFAIRLY": "UNFAIR, not fair [adv]\n",
  "UNFAIRNESS": "the state of being unfair [n -ES]\n",
  "UNFAIRNESSES": "UNFAIRNESS, the state of being unfair [n]\n",
  "UNFAIRS": "UNFAIR, (Shakespeare) to deprive of beauty [v]\n",
  "UNFAITH": "a lack of faith [n -S]\n",
  "UNFAITHFUL": "not faithful [adj UNFAITHFULLY]\n",
  "UNFAITHFULLY": "UNFAITHFUL, not faithful [adv]\n",
  "UNFAITHFULNESS": "the state of being unfaithful [n]\n",
  "UNFAITHS": "UNFAITH, a lack of faith [n]\n",
  "UNFAKED": "not faked [adj]\n",
  "UNFALLEN": "not fallen [adj]\n",
  "UNFALLIBLE": "(Shakespeare) infallible [adj]\n",
  "UNFALSIFIABLE": "not capable of being proved false [adj]\n",
  "UNFALTERING": "not wavering or weakening [adj UNFALTERINGLY]\n",
  "UNFALTERINGLY": "UNFALTERING, not wavering or weakening [adv]\n",
  "UNFAMED": "not famed [adj]\n",
  "UNFAMILIAR": "not familiar [adj UNFAMILIARLY]\n",
  "UNFAMILIARITIES": "UNFAMILIARITY, the state of being unfamiliar [n]\n",
  "UNFAMILIARITY": "the state of being unfamiliar [n UNFAMILIARITIES]\n",
  "UNFAMILIARLY": "UNFAMILIAR, not familiar [adv]\n",
  "UNFAMOUS": "not famous [adj]\n",
  "UNFANCIED": "(esp. of a sportsperson, team, etc.) thought unlikely to win or succeed [adj]\n",
  "UNFANCIER": "UNFANCY, not fancy [adj]\n",
  "UNFANCIEST": "UNFANCY, not fancy [adj]\n",
  "UNFANCY": "not fancy [adj UNFANCIER, UNFANCIEST]\n",
  "UNFANNED": "not fanned [adj]\n",
  "UNFASHIONABLE": "not in keeping with the current fashion [adj UNFASHIONABLY]\n",
  "UNFASHIONABLY": "UNFASHIONABLE, not in keeping with the current fashion [adv]\n",
  "UNFASHIONED": "not excavated [adj]\n",
  "UNFASTEN": "to release from a fastening [v -ED, -ING, -S]\n",
  "UNFASTENED": "UNFASTEN, to release from a fastening [v]\n",
  "UNFASTENING": "UNFASTEN, to release from a fastening [v]\n",
  "UNFASTENS": "UNFASTEN, to release from a fastening [v]\n",
  "UNFASTIDIOUS": "not fastidious [adj]\n",
  "UNFATHERED": "having no father [adj]\n",
  "UNFATHERLIER": "UNFATHERLY, not fatherly [adj]\n",
  "UNFATHERLIEST": "UNFATHERLY, not fatherly [adj]\n",
  "UNFATHERLY": "not fatherly [adj UNFATHERLIER, UNFATHERLIEST]\n",
  "UNFATHOMABLE": "not capable of being fathomed [adj UNFATHOMABLY]\n",
  "UNFATHOMABLY": "UNFATHOMABLE, not capable of being fathomed [adv]\n",
  "UNFATHOMED": "not fathomed [adj]\n",
  "UNFAULTIER": "UNFAULTY, not faulty [adj]\n",
  "UNFAULTIEST": "UNFAULTY, not faulty [adj]\n",
  "UNFAULTY": "not faulty [adj UNFAULTIER, UNFAULTIEST]\n",
  "UNFAVORABLE": "not favorable [adj UNFAVORABLY]\n",
  "UNFAVORABLENESS": "the state of being unfavorable [n]\n",
  "UNFAVORABLY": "UNFAVORABLE, not favorable [adv]\n",
  "UNFAVORED": "not favored, also UNFAVOURED [adj]\n",
  "UNFAVORITE": "not favourite [adj]\n",
  "UNFAVOURABLE": "not favourable [adj UNFAVOURABLY]\n",
  "UNFAVOURABLY": "UNFAVOURABLE, not favourable [adv]\n",
  "UNFAVOURED": "not favoured, also UNFAVORED [adj]\n",
  "UNFAVOURITE": "not favourite or favoured [adj]\n",
  "UNFAZABLE": "not capable of being fazed [adj]\n",
  "UNFAZED": "not fazed [adj]\n",
  "UNFEARED": "not feared [adj]\n",
  "UNFEARFUL": "not fearful [adj UNFEARFULLY]\n",
  "UNFEARFULLY": "UNFEARFUL, not fearful [adv]\n",
  "UNFEARING": "not fearing [adj]\n",
  "UNFEASIBLE": "not feasible, also INFEASIBLE [adj]\n",
  "UNFEATHERED": "not feathered [adj]\n",
  "UNFEATURED": "wanting regular features; deformed [adj]\n",
  "UNFED": "not fed [adj]\n",
  "UNFEED": "not retained by a fee, unpaid [adj]\n",
  "UNFEELING": "not feeling [adj UNFEELINGLY]\n",
  "UNFEELINGLY": "UNFEELING, not feeling [adv]\n",
  "UNFEELINGNESS": "the state of being unfeeling [n -ES]\n",
  "UNFEELINGNESSES": "UNFEELINGNESS, the state of being unfeeling [n]\n",
  "UNFEIGNED": "not feigned; not counterfeit [adj UNFEIGNEDLY]\n",
  "UNFEIGNEDLY": "UNFEIGNED, not feigned; not counterfeit [adv]\n",
  "UNFEIGNEDNESS": "the state of being unfeigned [n -ES]\n",
  "UNFEIGNEDNESSES": "UNFEIGNEDNESS, the state of being unfeigned [n]\n",
  "UNFEIGNING": "not feigning [adj]\n",
  "UNFELLED": "not felled [adj]\n",
  "UNFELLOWED": "being without a fellow [adj]\n",
  "UNFELT": "not felt [adj]\n",
  "UNFELTED": "not felted [adj]\n",
  "UNFEMININE": "not feminine [adj]\n",
  "UNFENCE": "to remove a fence [v UNFENCED, UNFENCING, UNFENCES]\n",
  "UNFENCED": "UNFENCE, to remove a fence [v]\n",
  "UNFENCES": "UNFENCE, to remove a fence [v]\n",
  "UNFENCING": "UNFENCE, to remove a fence [v]\n",
  "UNFERMENTED": "not fermented [adj]\n",
  "UNFERTILE": "not fertile, also INFERTILE [adj]\n",
  "UNFERTILISED": "not fertilised, also UNFERTILIZED [adj]\n",
  "UNFERTILIZED": "not fertilized, also UNFERTILISED [adj]\n",
  "UNFETTER": "to free from fetters [v -ED, -ING, -S]\n",
  "UNFETTERED": "UNFETTER, to free from fetters [v]\n",
  "UNFETTERING": "UNFETTER, to free from fetters [v]\n",
  "UNFETTERS": "UNFETTER, to free from fetters [v]\n",
  "UNFEUDAL": "not marked by social attitudes [adj]\n",
  "UNFEUDALISE": "to deprive of a feudal character, also UNFEUDALIZE [v UNFEUDALISED, UNFEUDALISING, UNFEUDALISES]\n",
  "UNFEUDALISED": "UNFEUDALISE, to deprive of a feudal character, also UNFEUDALIZE [v]\n",
  "UNFEUDALISES": "UNFEUDALISE, to deprive of a feudal character, also UNFEUDALIZE [v]\n",
  "UNFEUDALISING": "UNFEUDALISE, to deprive of a feudal character, also UNFEUDALIZE [v]\n",
  "UNFEUDALIZE": "to deprive of a feudal character, also UNFEUDALISE [v UNFEUDALIZED, UNFEUDALIZING, UNFEUDALIZES]\n",
  "UNFEUDALIZED": "UNFEUDALIZE, to deprive of a feudal character, also UNFEUDALISE [v]\n",
  "UNFEUDALIZES": "UNFEUDALIZE, to deprive of a feudal character, also UNFEUDALISE [v]\n",
  "UNFEUDALIZING": "UNFEUDALIZE, to deprive of a feudal character, also UNFEUDALISE [v]\n",
  "UNFEUED": "not feued [adj]\n",
  "UNFIGURED": "not figured [adj]\n",
  "UNFILDE": "(Spenser) not rubbed with a file [adj]\n",
  "UNFILED": "not filed [adj]\n",
  "UNFILIAL": "not filial [adj UNFILIALLY]\n",
  "UNFILIALLY": "UNFILIAL, not filial [adv]\n",
  "UNFILLABLE": "not fillable [adj]\n",
  "UNFILLED": "not filled [adj]\n",
  "UNFILLETED": "not filleted [adj]\n",
  "UNFILMED": "not filmed [adj]\n",
  "UNFILTERABLE": "not filterable [adj]\n",
  "UNFILTERED": "not filtered [adj]\n",
  "UNFILTRABLE": "that cannot be filtered [adj]\n",
  "UNFINDABLE": "that cannot be found [adj]\n",
  "UNFINE": "not fine [adj]\n",
  "UNFINISHED": "not finished [adj]\n",
  "UNFINISHING": "(Milton) the leaving unfinished [n -S]\n",
  "UNFINISHINGS": "UNFINISHING, (Milton) the leaving unfinished [n]\n",
  "UNFIRED": "not fired [adj]\n",
  "UNFIRM": "not firm [adj]\n",
  "UNFISHED": "not fished [adj]\n",
  "UNFIT": "not fit [adj UNFITTER, UNFITTEST, UNFITLY] / to make unfit [v UNFITTED, UNFITTING, UNFITS]\n",
  "UNFITLY": "UNFIT, not fit [adv]\n",
  "UNFITNESS": "the state of being unfit [n -ES]\n",
  "UNFITNESSES": "UNFITNESS, the state of being unfit [n]\n",
  "UNFITS": "UNFIT, to make unfit [v]\n",
  "UNFITTED": "UNFIT, to make unfit [v]\n",
  "UNFITTEDNESS": "the state of being unfitted [n -ES]\n",
  "UNFITTEDNESSES": "UNFITTEDNESS, the state of being unfitted [n]\n",
  "UNFITTER": "UNFIT, not fit [adj]\n",
  "UNFITTEST": "UNFIT, not fit [adj]\n",
  "UNFITTING": "UNFIT, to make unfit [v]\n",
  "UNFITTINGLY": "UNFITTING, UNFIT, to make unfit [adv]\n",
  "UNFIX": "to unfasten [v UNFIXED, UNFIXT or UNFIXED, UNFIXING, UNFIXES]\n",
  "UNFIXED": "UNFIX, to unfasten [v]\n",
  "UNFIXEDNESS": "the state of not being fixed [n -ES]\n",
  "UNFIXEDNESSES": "UNFIXEDNESS, the state of not being fixed [n]\n",
  "UNFIXES": "UNFIX, to unfasten [v]\n",
  "UNFIXING": "UNFIX, to unfasten [v]\n",
  "UNFIXITIES": "UNFIXITY, the state of not being fixed [n]\n",
  "UNFIXITY": "the state of not being fixed [n UNFIXITIES]\n",
  "UNFIXT": "UNFIX, to unfasten [v]\n",
  "UNFLAGGING": "not flagging [adj UNFLAGGINGLY]\n",
  "UNFLAGGINGLY": "UNFLAGGING, not flagging [adv]\n",
  "UNFLAMBOYANT": "not flamboyant [adj]\n",
  "UNFLAPPABILITY": "the state of being unflappable [n]\n",
  "UNFLAPPABLE": "imperturbable [adj UNFLAPPABLY]\n",
  "UNFLAPPABLENESS": "the state of being unflappable [n]\n",
  "UNFLAPPABLY": "UNFLAPPABLE, imperturbable [adv]\n",
  "UNFLAPPED": "not flapped [adj]\n",
  "UNFLASHIER": "UNFLASHY, not flashy [adj]\n",
  "UNFLASHIEST": "UNFLASHY, not flashy [adj]\n",
  "UNFLASHY": "not flashy [adj UNFLASHIER, UNFLASHIEST]\n",
  "UNFLATTERING": "not flattering [adj UNFLATTERINGLY]\n",
  "UNFLATTERINGLY": "UNFLATTERING, not flattering [adv]\n",
  "UNFLAVORED": "not flavored, also UNFLAVOURED [adj]\n",
  "UNFLAVOURED": "not flavoured, also UNFLAVORED [adj]\n",
  "UNFLAWED": "without flaw [adj]\n",
  "UNFLEDGED": "not fledged [adj]\n",
  "UNFLESH": "to remove the flesh from [v -ED, -ING, -ES]\n",
  "UNFLESHED": "UNFLESH, to remove the flesh from [v]\n",
  "UNFLESHES": "UNFLESH, to remove the flesh from [v]\n",
  "UNFLESHING": "UNFLESH, to remove the flesh from [v]\n",
  "UNFLESHLIER": "UNFLESHLY, not pertaining to the flesh; spiritual [adj]\n",
  "UNFLESHLIEST": "UNFLESHLY, not pertaining to the flesh; spiritual [adj]\n",
  "UNFLESHLY": "not pertaining to the flesh; spiritual [adj UNFLESHLIER, UNFLESHLIEST]\n",
  "UNFLEXED": "not flexed [adj]\n",
  "UNFLINCHING": "not flinching or shrinking [adj UNFLINCHINGLY]\n",
  "UNFLINCHINGLY": "UNFLINCHING, not flinching or shrinking [adv]\n",
  "UNFLOORED": "without a floor [adj]\n",
  "UNFLUSH": "to lose colour [v -ED, -ING, -ES]\n",
  "UNFLUSHED": "UNFLUSH, to lose colour [v]\n",
  "UNFLUSHES": "UNFLUSH, to lose colour [v]\n",
  "UNFLUSHING": "UNFLUSH, to lose colour [v]\n",
  "UNFLUSTERED": "not flustered [adj]\n",
  "UNFLUTED": "not fluted [adj]\n",
  "UNFLYABLE": "that cannot be flown [adj]\n",
  "UNFOCUSED": "not focused, also UNFOCUSSED [adj]\n",
  "UNFOCUSSED": "not focussed, also UNFOCUSED [adj]\n",
  "UNFOILED": "not foiled [adj]\n",
  "UNFOLD": "to open something that is folded [v -ED, -ING, -S]\n",
  "UNFOLDED": "UNFOLD, to open something that is folded [v]\n",
  "UNFOLDER": "one who unfolds [n -S]\n",
  "UNFOLDERS": "UNFOLDER, one who unfolds [n]\n",
  "UNFOLDING": "the act of unfolding [n -S]\n",
  "UNFOLDINGS": "UNFOLDING, the act of unfolding [n]\n",
  "UNFOLDMENT": "the act of unfolding, or the state of being unfolded [n -S]\n",
  "UNFOLDMENTS": "UNFOLDMENT, the act of unfolding, or the state of being unfolded [n]\n",
  "UNFOLDS": "UNFOLD, to open something that is folded [v]\n",
  "UNFOLLOW": "to decline to receive messages from (a person who is posting on a social media site) [v -ED, -ING, -S]\n",
  "UNFOLLOWED": "UNFOLLOW, to decline to receive messages from (a person who is posting on a social media site) [v]\n",
  "UNFOLLOWING": "UNFOLLOW, to decline to receive messages from (a person who is posting on a social media site) [v]\n",
  "UNFOLLOWS": "UNFOLLOW, to decline to receive messages from (a person who is posting on a social media site) [v]\n",
  "UNFOND": "not fond [adj UNFONDLY]\n",
  "UNFONDLY": "UNFOND, not fond [adv]\n",
  "UNFOOL": "to undeceive [v -ED, -ING, -S]\n",
  "UNFOOLED": "UNFOOL, to undeceive [v]\n",
  "UNFOOLING": "UNFOOL, to undeceive [v]\n",
  "UNFOOLS": "UNFOOL, to undeceive [v]\n",
  "UNFOOTED": "untrodden [adj]\n",
  "UNFORBID": "(Milton) not forbidden [adj]\n",
  "UNFORBIDDEN": "not forbidden [adj]\n",
  "UNFORCED": "not forced [adj UNFORCEDLY]\n",
  "UNFORCEDLY": "UNFORCED, not forced [adv]\n",
  "UNFORCIBLE": "that cannot be forced [adj]\n",
  "UNFORDABLE": "that cannot be forded [adj]\n",
  "UNFOREBODING": "not foreboding [adj]\n",
  "UNFOREKNOWABLE": "not foreknowable [adj]\n",
  "UNFOREKNOWN": "not foreknown [adj]\n",
  "UNFORESEEABLE": "not foreseeable [adj]\n",
  "UNFORESEEING": "not foreseeing [adj]\n",
  "UNFORESEEN": "not foreseen [adj]\n",
  "UNFORESKINNED": "(Milton) circumcised [adj]\n",
  "UNFORESTED": "not forested [adj]\n",
  "UNFORETOLD": "not foretold [adj]\n",
  "UNFOREWARNED": "not forewarned [adj]\n",
  "UNFORFEITED": "not forfeited [adj]\n",
  "UNFORGED": "not forged [adj]\n",
  "UNFORGETTABLE": "incapable of being forgotten [adj UNFORGETTABLY]\n",
  "UNFORGETTABLY": "UNFORGETTABLE, incapable of being forgotten [adv]\n",
  "UNFORGIVABLE": "not forgivable [adj UNFORGIVABLY]\n",
  "UNFORGIVABLY": "UNFORGIVABLE, not forgivable [adv]\n",
  "UNFORGIVEN": "not forgiven [adj]\n",
  "UNFORGIVENESS": "the state of being unforgiving, also UNFORGIVINGNESS [n -ES]\n",
  "UNFORGIVENESSES": "UNFORGIVENESS, the state of being unforgiving, also UNFORGIVINGNESS [n]\n",
  "UNFORGIVING": "unwilling or unable to forgive [adj]\n",
  "UNFORGIVINGNESS": "the state of being unforgiving, also UNFORGIVENESS [n]\n",
  "UNFORGOT": "not forgotten, also UNFORGOTTEN [adj]\n",
  "UNFORGOTTEN": "not forgotten, also UNFORGOT [adj]\n",
  "UNFORKED": "not forked [adj]\n",
  "UNFORM": "to unmake [v -ED, -ING, -S]\n",
  "UNFORMAL": "not formal, also INFORMAL [adj]\n",
  "UNFORMALISED": "not formalised, also UNFORMALIZED [adj]\n",
  "UNFORMALIZED": "not formalized, also UNFORMALISED [adj]\n",
  "UNFORMATTED": "not formatted [adj]\n",
  "UNFORMED": "UNFORM, to unmake [v]\n",
  "UNFORMIDABLE": "not formidable [adj]\n",
  "UNFORMING": "UNFORM, to unmake [v]\n",
  "UNFORMS": "UNFORM, to unmake [v]\n",
  "UNFORMULATED": "not formulated [adj]\n",
  "UNFORSAKEN": "not forsaken [adj]\n",
  "UNFORTHCOMING": "not forthcoming [adj]\n",
  "UNFORTIFIED": "not fortified [adj]\n",
  "UNFORTUNATE": "not fortunate [adj UNFORTUNATELY] / an unfortunate person [n -S]\n",
  "UNFORTUNATELY": "UNFORTUNATE, not fortunate [adv]\n",
  "UNFORTUNATENESS": "the state of being unfortunate [n]\n",
  "UNFORTUNATES": "UNFORTUNATE, an unfortunate person [n]\n",
  "UNFORTUNE": "(archaic) ill-fortune [n -S]\n",
  "UNFORTUNED": "without a fortune [adj]\n",
  "UNFORTUNES": "UNFORTUNE, (archaic) ill-fortune [n]\n",
  "UNFOSSILIFEROUS": "not fossiliferous [adj]\n",
  "UNFOSSILISED": "not fossilised, also UNFOSSILIZED [adj]\n",
  "UNFOSSILIZED": "not fossilized, also UNFOSSILISED [adj]\n",
  "UNFOSTERED": "not fostered [adj]\n",
  "UNFOUGHT": "not fought [adj]\n",
  "UNFOUGHTEN": "(archaic) without having been fought e.g. the army departed unfoughten [adj]\n",
  "UNFOUND": "not found [adj]\n",
  "UNFOUNDED": "not founded [adj UNFOUNDEDLY]\n",
  "UNFOUNDEDLY": "UNFOUNDED, not founded [adv]\n",
  "UNFOUNDEDNESS": "the state of being unfounded [n -ES]\n",
  "UNFOUNDEDNESSES": "UNFOUNDEDNESS, the state of being unfounded [n]\n",
  "UNFRAMED": "not framed [adj]\n",
  "UNFRANCHISED": "not franchised [adj]\n",
  "UNFRANKED": "not franked esp. of a postage stamp [adj]\n",
  "UNFRAUGHT": "to unload [v -ED, -ING, -S]\n",
  "UNFRAUGHTED": "UNFRAUGHT, to unload [v]\n",
  "UNFRAUGHTING": "UNFRAUGHT, to unload [v]\n",
  "UNFRAUGHTS": "UNFRAUGHT, to unload [v]\n",
  "UNFREE": "to deprive of freedom [v UNFREED, UNFREEING, UNFREES]\n",
  "UNFREED": "UNFREE, to deprive of freedom [v]\n",
  "UNFREEDOM": "lack of freedom [n -S]\n",
  "UNFREEDOMS": "UNFREEDOM, lack of freedom [n]\n",
  "UNFREEING": "UNFREE, to deprive of freedom [v]\n",
  "UNFREEMAN": "someone who does not have the freedom of a corporation [n UNFREEMEN]\n",
  "UNFREEMEN": "UNFREEMAN, someone who does not have the freedom of a corporation [n]\n",
  "UNFREES": "UNFREE, to deprive of freedom [v]\n",
  "UNFREEZE": "to cause to thaw [v UNFROZE, UNFROZEN, UNFREEZING, UNFREEZES]\n",
  "UNFREEZES": "UNFREEZE, to cause to thaw [v]\n",
  "UNFREEZING": "a thawing, a release of assets [n -S]\n",
  "UNFREEZINGS": "UNFREEZING, a thawing, a release of assets [n]\n",
  "UNFREQUENT": "not frequent, also INFREQUENT [adj UNFREQUENTLY] / to stop frequenting [v -ED, -ING, -S]\n",
  "UNFREQUENTED": "not often visited or traveled over [adj]\n",
  "UNFREQUENTING": "UNFREQUENT, to stop frequenting [v]\n",
  "UNFREQUENTLY": "UNFREQUENT, not frequent, also INFREQUENT [adv]\n",
  "UNFREQUENTS": "UNFREQUENT, to stop frequenting [v]\n",
  "UNFRETTED": "not eaten away; not worried [adj]\n",
  "UNFRIEND": "to remove someone from one's online circle of friends [v -ED, -ING, -S]\n",
  "UNFRIENDED": "having no friends [adj]\n",
  "UNFRIENDEDNESS": "the state of being unfriended [n]\n",
  "UNFRIENDING": "UNFRIEND, to remove someone from one's online circle of friends [v]\n",
  "UNFRIENDLIER": "UNFRIENDLY, not friendly [adj]\n",
  "UNFRIENDLIEST": "UNFRIENDLY, not friendly [adj]\n",
  "UNFRIENDLILY": "UNFRIENDLY, not friendly [adv]\n",
  "UNFRIENDLINESS": "the state of being unfriendly [n]\n",
  "UNFRIENDLY": "not friendly [adj UNFRIENDLIER, UNFRIENDLIEST, UNFRIENDLILY]\n",
  "UNFRIENDS": "UNFRIEND, to remove someone from one's online circle of friends [v]\n",
  "UNFRIENDSHIP": "(archaic) unfriendliness [n -S]\n",
  "UNFRIENDSHIPS": "UNFRIENDSHIP, (archaic) unfriendliness [n]\n",
  "UNFRIGHTED": "(archaic) not frightened [adj]\n",
  "UNFRIGHTENED": "not frightened [adj]\n",
  "UNFRIVOLOUS": "not frivolous [adj]\n",
  "UNFROCK": "to divest of ecclesiastical authority, also DEFROCK [v -ED, -ING, -S]\n",
  "UNFROCKED": "UNFROCK, to divest of ecclesiastical authority, also DEFROCK [v]\n",
  "UNFROCKING": "UNFROCK, to divest of ecclesiastical authority, also DEFROCK [v]\n",
  "UNFROCKS": "UNFROCK, to divest of ecclesiastical authority, also DEFROCK [v]\n",
  "UNFROZE": "UNFREEZE, to cause to thaw [v]\n",
  "UNFROZEN": "UNFREEZE, to cause to thaw [v]\n",
  "UNFRUCTUOUS": "not fructuous [adj]\n",
  "UNFRUITFUL": "not fruitful [adj UNFRUITFULLY]\n",
  "UNFRUITFULLY": "UNFRUITFUL, not fruitful [adv]\n",
  "UNFRUITFULNESS": "the state of being unfruitful [n]\n",
  "UNFUELLED": "not fuelled [adj]\n",
  "UNFULFILLABLE": "not capable of being fulfilled [adj]\n",
  "UNFULFILLED": "not fulfilled [adj]\n",
  "UNFULFILLING": "not fulfilling [adj]\n",
  "UNFUMED": "not fumigated [adj]\n",
  "UNFUNDED": "not funded [adj]\n",
  "UNFUNNIER": "UNFUNNY, not funny [adj]\n",
  "UNFUNNIEST": "UNFUNNY, not funny [adj]\n",
  "UNFUNNILY": "UNFUNNY, not funny [adv]\n",
  "UNFUNNY": "not funny [adj UNFUNNIER, UNFUNNIEST]\n",
  "UNFURL": "to unroll [v -ED, -ING, -S]\n",
  "UNFURLED": "UNFURL, to unroll [v]\n",
  "UNFURLING": "UNFURL, to unroll [v]\n",
  "UNFURLS": "UNFURL, to unroll [v]\n",
  "UNFURNISH": "to strip of furniture or provisions [v -ED, -ING, -ES]\n",
  "UNFURNISHED": "UNFURNISH, to strip of furniture or provisions [v]\n",
  "UNFURNISHES": "UNFURNISH, to strip of furniture or provisions [v]\n",
  "UNFURNISHING": "UNFURNISH, to strip of furniture or provisions [v]\n",
  "UNFURRED": "without fur [adj]\n",
  "UNFURROWED": "not furrowed [adj]\n",
  "UNFUSED": "not fused [adj]\n",
  "UNFUSSED": "not fussed [adj]\n",
  "UNFUSSIER": "UNFUSSY, not fussy [adj]\n",
  "UNFUSSIEST": "UNFUSSY, not fussy [adj]\n",
  "UNFUSSILY": "UNFUSSY, not fussy [adv]\n",
  "UNFUSSY": "not fussy [adj UNFUSSIER, UNFUSSIEST, UNFUSSILY]\n",
  "UNGAG": "to remove a gag [v UNGAGGED, UNGAGGING, UNGAGS]\n",
  "UNGAGGED": "UNGAG, to remove a gag [v]\n",
  "UNGAGGING": "UNGAG, to remove a gag [v]\n",
  "UNGAGS": "UNGAG, to remove a gag [v]\n",
  "UNGAIN": "(dialect) awkward, uncouth, also UNGAINLY [adj]\n",
  "UNGAINFUL": "not gainful [adj]\n",
  "UNGAINLIER": "UNGAINLY, clumsy, also UNGAIN [adj]\n",
  "UNGAINLIEST": "UNGAINLY, clumsy, also UNGAIN [adj]\n",
  "UNGAINLINESS": "the state of being ungainly [n -ES]\n",
  "UNGAINLINESSES": "UNGAINLINESS, the state of being ungainly [n]\n",
  "UNGAINLY": "clumsy, also UNGAIN [adj UNGAINLIER, UNGAINLIEST]\n",
  "UNGAINSAID": "without contradiction [adj]\n",
  "UNGAINSAYABLE": "that cannot be gainsaid [adj]\n",
  "UNGALLANT": "not gallant [adj UNGALLANTLY]\n",
  "UNGALLANTLY": "UNGALLANT, not gallant [adv]\n",
  "UNGALLED": "not galled [adj]\n",
  "UNGARBED": "not garbed [adj]\n",
  "UNGARBLED": "not garbled [adj]\n",
  "UNGARMENTED": "not wearing garments [adj]\n",
  "UNGARNERED": "not garnered [adj]\n",
  "UNGARNISHED": "not garnished [adj]\n",
  "UNGARTERED": "not wearing garters [adj]\n",
  "UNGATED": "not gated [adj]\n",
  "UNGATHERED": "not gathered [adj]\n",
  "UNGAUGED": "not gauged [adj]\n",
  "UNGAZED": "not gazed (at or upon) [adj]\n",
  "UNGAZING": "not gazing [adj]\n",
  "UNGEAR": "to unharness [v -ED, -ING, -S]\n",
  "UNGEARED": "UNGEAR, to unharness [v]\n",
  "UNGEARING": "UNGEAR, to unharness [v]\n",
  "UNGEARS": "UNGEAR, to unharness [v]\n",
  "UNGELDED": "not gelded [adj]\n",
  "UNGENEROSITIES": "UNGENEROSITY, lack of generosity [n]\n",
  "UNGENEROSITY": "lack of generosity [n UNGENEROSITIES]\n",
  "UNGENEROUS": "not generous [adj UNGENEROUSLY]\n",
  "UNGENEROUSLY": "UNGENEROUS, not generous [adv]\n",
  "UNGENIAL": "not genial [adj]\n",
  "UNGENITURED": "(Shakespeare) without means of generation, or not produced by ordinary generation [adj]\n",
  "UNGENTEEL": "not genteel [adj UNGENTEELLY]\n",
  "UNGENTEELLY": "UNGENTEEL, not genteel [adv]\n",
  "UNGENTILITIES": "UNGENTILITY, lack of gentility [n]\n",
  "UNGENTILITY": "lack of gentility [n UNGENTILITIES]\n",
  "UNGENTLE": "not gentle [adj UNGENTLER, UNGENTLEST; UNGENTLY]\n",
  "UNGENTLEMANLIER": "UNGENTLEMANLY, not like a gentleman [adj]\n",
  "UNGENTLEMANLIKE": "not like a gentleman [adj]\n",
  "UNGENTLEMANLY": "not like a gentleman [adj UNGENTLEMANLIER]\n",
  "UNGENTLENESS": "the state of being ungentle [n -ES]\n",
  "UNGENTLENESSES": "UNGENTLENESS, the state of being ungentle [n]\n",
  "UNGENTLER": "UNGENTLE, not gentle [adj]\n",
  "UNGENTLEST": "UNGENTLE, not gentle [adj]\n",
  "UNGENTLY": "UNGENTLE, not gentle [adv]\n",
  "UNGENTRIFIED": "not gentrified [adj]\n",
  "UNGENUINE": "not genuine [adj]\n",
  "UNGENUINENESS": "the state of being ungenuine [n -ES]\n",
  "UNGENUINENESSES": "UNGENUINENESS, the state of being ungenuine [n]\n",
  "UNGERMANE": "not germane [adj]\n",
  "UNGERMINATED": "not germinated [adj]\n",
  "UNGET": "to deny the begetting of [v UNGOT, UNGOTTEN, UNGETTING, UNGETS]\n",
  "UNGETATABLE": "not getatable [adj]\n",
  "UNGETS": "UNGET, to deny the begetting of [v]\n",
  "UNGETTING": "UNGET, to deny the begetting of [v]\n",
  "UNGHOSTED": "not ghostwritten [adj]\n",
  "UNGHOSTLIER": "UNGHOSTLY, not ghostly [adj]\n",
  "UNGHOSTLIEST": "UNGHOSTLY, not ghostly [adj]\n",
  "UNGHOSTLY": "not ghostly [adj UNGHOSTLIER, UNGHOSTLIEST]\n",
  "UNGIFTED": "not gifted [adj]\n",
  "UNGILD": "to remove the gilding from [v UNGILDED, UNGILT, UNGILDING, UNGILDS]\n",
  "UNGILDED": "UNGILD, to remove the gilding from [v]\n",
  "UNGILDING": "UNGILD, to remove the gilding from [v]\n",
  "UNGILDS": "UNGILD, to remove the gilding from [v]\n",
  "UNGILT": "not gilt [adj]\n",
  "UNGIMMICKY": "not gimmicky [adj]\n",
  "UNGIRD": "to remove a belt from [v UNGIRDED or UNGIRT, UNGIRDING, UNGIRDS]\n",
  "UNGIRDED": "UNGIRD, to remove a belt from [v]\n",
  "UNGIRDING": "UNGIRD, to remove a belt from [v]\n",
  "UNGIRDS": "UNGIRD, to remove a belt from [v]\n",
  "UNGIRT": "UNGIRD, to remove a belt from [v]\n",
  "UNGIRTH": "to free from a girth [v -ED, -ING, -S]\n",
  "UNGIRTHED": "UNGIRTH, to free from a girth [v]\n",
  "UNGIRTHING": "UNGIRTH, to free from a girth [v]\n",
  "UNGIRTHS": "UNGIRTH, to free from a girth [v]\n",
  "UNGIVING": "not giving [adj]\n",
  "UNGLACIATED": "not glaciated [adj]\n",
  "UNGLAD": "not glad [adj]\n",
  "UNGLAMORISED": "not glamorised, also UNGLAMORIZED [adj]\n",
  "UNGLAMORIZED": "not glamorized, also UNGLAMORISED [adj]\n",
  "UNGLAMOROUS": "not glamorous [adj]\n",
  "UNGLAZED": "not glazed [adj]\n",
  "UNGLITZIER": "UNGLITZY, not glitzy [adj]\n",
  "UNGLITZIEST": "UNGLITZY, not glitzy [adj]\n",
  "UNGLITZY": "not glitzy [adj UNGLITZIER, UNGLITZIEST]\n",
  "UNGLOSSED": "not glossed [adj]\n",
  "UNGLOVE": "to uncover by removing a glove [v UNGLOVED, UNGLOVING, UNGLOVES]\n",
  "UNGLOVED": "UNGLOVE, to uncover by removing a glove [v]\n",
  "UNGLOVES": "UNGLOVE, to uncover by removing a glove [v]\n",
  "UNGLOVING": "UNGLOVE, to uncover by removing a glove [v]\n",
  "UNGLUE": "to release from a state of being glued [v UNGLUED, UNGLUING, UNGLUES]\n",
  "UNGLUED": "UNGLUE, to release from a state of being glued [v]\n",
  "UNGLUES": "UNGLUE, to release from a state of being glued [v]\n",
  "UNGLUING": "UNGLUE, to release from a state of being glued [v]\n",
  "UNGOD": "to deprive of divinity; to undeify [v UNGODDED, UNGODDING, UNGODS]\n",
  "UNGODDED": "UNGOD, to deprive of divinity; to undeify [v]\n",
  "UNGODDING": "UNGOD, to deprive of divinity; to undeify [v]\n",
  "UNGODLIER": "UNGODLY, not godly [adj]\n",
  "UNGODLIEST": "UNGODLY, not godly [adj]\n",
  "UNGODLIKE": "not like a god [adj]\n",
  "UNGODLILY": "UNGODLY, not godly [adv]\n",
  "UNGODLINESS": "the state of being ungodly [n -ES]\n",
  "UNGODLINESSES": "UNGODLINESS, the state of being ungodly [n]\n",
  "UNGODLY": "not godly [adj UNGODLIER, UNGODLIEST, UNGODLILY]\n",
  "UNGODS": "UNGOD, to deprive of divinity; to undeify [v]\n",
  "UNGORD": "(Shakespeare) unwounded, also UNGORED [adj]\n",
  "UNGORED": "unwounded, also UNGORD [adj]\n",
  "UNGORGED": "not sated [adj]\n",
  "UNGOT": "UNGET, to deny the begetting of [v]\n",
  "UNGOTTEN": "UNGET, to deny the begetting of [v]\n",
  "UNGOVERNABLE": "not capable of being governed [adj UNGOVERNABLY]\n",
  "UNGOVERNABLY": "UNGOVERNABLE, not capable of being governed [adv]\n",
  "UNGOVERNED": "not governed [adj]\n",
  "UNGOWN": "to strip of a gown [v -ED, -ING, -S]\n",
  "UNGOWNED": "UNGOWN, to strip of a gown [v]\n",
  "UNGOWNING": "UNGOWN, to strip of a gown [v]\n",
  "UNGOWNS": "UNGOWN, to strip of a gown [v]\n",
  "UNGRACED": "not graced [adj]\n",
  "UNGRACEFUL": "not graceful [adj UNGRACEFULLY]\n",
  "UNGRACEFULLY": "UNGRACEFUL, not graceful [adv]\n",
  "UNGRACEFULNESS": "the state of being ungraceful [n]\n",
  "UNGRACIOUS": "not courteous [adj UNGRACIOUSLY]\n",
  "UNGRACIOUSLY": "UNGRACIOUS, not courteous [adv]\n",
  "UNGRACIOUSNESS": "the state of being ungracious [n]\n",
  "UNGRADED": "not graded [adj]\n",
  "UNGRAMMATIC": "not following rules of grammar, also UNGRAMMATICAL [adj UNGRAMMATICALLY]\n",
  "UNGRAMMATICAL": "not following rules of grammar, also UNGRAMMATIC [adj UNGRAMMATICALLY]\n",
  "UNGRAMMATICALLY": "UNGRAMMATICAL, not following rules of grammar, also UNGRAMMATIC [adv]\n",
  "UNGRASPABLE": "not capable of being grasped [adj]\n",
  "UNGRASSED": "not grown with grass [adj]\n",
  "UNGRATEFUL": "showing no gratitude, also INGRATEFUL [adj UNGRATEFULLY]\n",
  "UNGRATEFULLY": "UNGRATEFUL, showing no gratitude, also INGRATEFUL [adv]\n",
  "UNGRATEFULNESS": "the state of being ungrateful [n]\n",
  "UNGRATIFIED": "not gratified [adj]\n",
  "UNGRAVELY": "(Shakespeare) possibly means not gravelly [adj]\n",
  "UNGRAZED": "not grazed [adj]\n",
  "UNGREASED": "not greased [adj]\n",
  "UNGREEDIER": "UNGREEDY, not greedy [adj]\n",
  "UNGREEDIEST": "UNGREEDY, not greedy [adj]\n",
  "UNGREEDY": "not greedy [adj UNGREEDIER, UNGREEDIEST]\n",
  "UNGREEN": "not green [adj UNGREENER, UNGREENEST]\n",
  "UNGREENER": "UNGREEN, not green [adj]\n",
  "UNGREENEST": "UNGREEN, not green [adj]\n",
  "UNGROOMED": "not groomed [adj]\n",
  "UNGROUND": "not ground [adj]\n",
  "UNGROUNDED": "not grounded [adj UNGROUNDEDLY]\n",
  "UNGROUNDEDLY": "UNGROUNDED, not grounded [adv]\n",
  "UNGROUNDEDNESS": "the state of being ungrounded [n]\n",
  "UNGROUP": "to separate from a group [v -ED, -ING, -S]\n",
  "UNGROUPED": "not grouped [adj]\n",
  "UNGROUPING": "UNGROUP, to separate from a group [v]\n",
  "UNGROUPS": "UNGROUP, to separate from a group [v]\n",
  "UNGROWN": "not grown [adj]\n",
  "UNGRUDGED": "not grudged [adj]\n",
  "UNGRUDGING": "being without envy or reluctance [adj UNGRUDGINGLY]\n",
  "UNGRUDGINGLY": "UNGRUDGING, being without envy or reluctance [adv]\n",
  "UNGUAL": "of or bearing a claw, hoof, or talon [adj]\n",
  "UNGUARD": "to leave unprotected [v -ED, -ING, -S]\n",
  "UNGUARDED": "UNGUARD, to leave unprotected [v]\n",
  "UNGUARDEDLY": "UNGUARDED, UNGUARD, to leave unprotected [adv]\n",
  "UNGUARDEDNESS": "the state of being unguarded [n -ES]\n",
  "UNGUARDEDNESSES": "UNGUARDEDNESS, the state of being unguarded [n]\n",
  "UNGUARDING": "UNGUARD, to leave unprotected [v]\n",
  "UNGUARDS": "UNGUARD, to leave unprotected [v]\n",
  "UNGUENT": "(Latin) an ointment [n -S]\n",
  "UNGUENTA": "UNGUENTUM, (Latin) an ointment [n]\n",
  "UNGUENTARIA": "UNGUENTARIUM, a vessel for holding unguents [n]\n",
  "UNGUENTARIES": "UNGUENTARY, one who makes or sells unguents [n]\n",
  "UNGUENTARIUM": "a vessel for holding unguents [n UNGUENTARIA]\n",
  "UNGUENTARY": "of or relating to unguents [adj] / one who makes or sells unguents [n UNGUENTARIES]\n",
  "UNGUENTS": "UNGUENT, (Latin) an ointment [n]\n",
  "UNGUENTUM": "(Latin) an ointment [n UNGUENTA]\n",
  "UNGUERDONED": "not guerdoned [adj]\n",
  "UNGUES": "UNGUIS, (Latin) a nail, claw or hoof, also UNGULA [n]\n",
  "UNGUESSABLE": "not capable of being guessed [adj]\n",
  "UNGUESSED": "not guessed [adj]\n",
  "UNGUICULATE": "having claws or nails, also UNGUICULATED [adj] / an animal having claws or nails [n -S]\n",
  "UNGUICULATED": "clawed, clawlike, also UNGUICULATE [adj]\n",
  "UNGUICULATES": "UNGUICULATE, an animal having claws or nails [n]\n",
  "UNGUIDED": "not guided [adj]\n",
  "UNGUIFORM": "shaped like a claw [adj]\n",
  "UNGUILTIER": "UNGUILTY, not guilty [adj]\n",
  "UNGUILTIEST": "UNGUILTY, not guilty [adj]\n",
  "UNGUILTY": "not guilty [adj UNGUILTIER, UNGUILTIEST]\n",
  "UNGUINOUS": "fatty, greasy [adj]\n",
  "UNGUIS": "(Latin) a nail, claw or hoof, also UNGULA [n UNGUES]\n",
  "UNGULA": "(Latin) a nail, claw or hoof, also UNGUIS [n UNGULAE]\n",
  "UNGULAE": "UNGULA, (Latin) a nail, claw or hoof, also UNGUIS [n]\n",
  "UNGULAR": "of or like an ungula, a hoof, claw, or talon [adj]\n",
  "UNGULATE": "a hoofed mammal [n -S]\n",
  "UNGULATES": "UNGULATE, a hoofed mammal [n]\n",
  "UNGULED": "in heraldry, with claws or hoofs tinctured specially [adj]\n",
  "UNGULIGRADE": "walking on hoofs [adj]\n",
  "UNGUM": "to free from gum [v UNGUMMED, UNGUMMING, UNGUMS]\n",
  "UNGUMMED": "UNGUM, to free from gum [v]\n",
  "UNGUMMING": "UNGUM, to free from gum [v]\n",
  "UNGUMS": "UNGUM, to free from gum [v]\n",
  "UNGYVE": "to remove the fetters from [v UNGYVED, UNGYVING, UNGYVES]\n",
  "UNGYVED": "UNGYVE, to remove the fetters from [v]\n",
  "UNGYVES": "UNGYVE, to remove the fetters from [v]\n",
  "UNGYVING": "UNGYVE, to remove the fetters from [v]\n",
  "UNHABITABLE": "not habitable [adj]\n",
  "UNHABITUATED": "not habituated [adj]\n",
  "UNHABLE": "(obsolete) unable [adj]\n",
  "UNHACKED": "not hacked [adj]\n",
  "UNHACKNEYED": "not hackneyed [adj]\n",
  "UNHAILED": "not hailed [adj]\n",
  "UNHAIR": "to remove the hair from [v -ED, -ING, -S]\n",
  "UNHAIRED": "UNHAIR, to remove the hair from [v]\n",
  "UNHAIRER": "one who unhairs [n -S]\n",
  "UNHAIRERS": "UNHAIRER, one who unhairs [n]\n",
  "UNHAIRING": "UNHAIR, to remove the hair from [v]\n",
  "UNHAIRS": "UNHAIR, to remove the hair from [v]\n",
  "UNHALLOW": "to profane [v -ED, -ING, -S]\n",
  "UNHALLOWED": "UNHALLOW, to profane [v]\n",
  "UNHALLOWING": "UNHALLOW, to profane [v]\n",
  "UNHALLOWS": "UNHALLOW, to profane [v]\n",
  "UNHALSED": "(Scott) unsaluted [adj]\n",
  "UNHALVED": "not halved [adj]\n",
  "UNHAMPERED": "not hampered [adj]\n",
  "UNHAND": "to remove the hand from [v -ED, -ING, -S]\n",
  "UNHANDED": "UNHAND, to remove the hand from [v]\n",
  "UNHANDIER": "UNHANDY, clumsy, awkward [adj]\n",
  "UNHANDIEST": "UNHANDY, clumsy, awkward [adj]\n",
  "UNHANDILY": "UNHANDY, clumsy, awkward [adv]\n",
  "UNHANDINESS": "the state of being unhandy [n -ES]\n",
  "UNHANDINESSES": "UNHANDINESS, the state of being unhandy [n]\n",
  "UNHANDING": "UNHAND, to remove the hand from [v]\n",
  "UNHANDLED": "not handled [adj]\n",
  "UNHANDS": "UNHAND, to remove the hand from [v]\n",
  "UNHANDSELLED": "not handselled [adj]\n",
  "UNHANDSOME": "not handsome [adj UNHANDSOMELY]\n",
  "UNHANDSOMELY": "UNHANDSOME, not handsome [adv]\n",
  "UNHANDSOMENESS": "the state of being unhandsome [n]\n",
  "UNHANDY": "clumsy, awkward [adj UNHANDIER, UNHANDIEST, UNHANDILY]\n",
  "UNHANG": "to detach from a hanging support [v UNHANGED, UNHUNG, UNHANGING, UNHANGS]\n",
  "UNHANGED": "UNHANG, to detach from a hanging support [v]\n",
  "UNHANGING": "UNHANG, to detach from a hanging support [v]\n",
  "UNHANGS": "UNHANG, to detach from a hanging support [v]\n",
  "UNHAPPEN": "to become as though never having happened [v -ED, -ING, -S]\n",
  "UNHAPPENED": "UNHAPPEN, to become as though never having happened [v]\n",
  "UNHAPPENING": "something that is not a happening [n -S]\n",
  "UNHAPPENINGS": "UNHAPPENING, something that is not a happening [n]\n",
  "UNHAPPENS": "UNHAPPEN, to become as though never having happened [v]\n",
  "UNHAPPIED": "UNHAPPY, (Shakespeare) to make unhappy [v]\n",
  "UNHAPPIER": "UNHAPPY, not happy [adj]\n",
  "UNHAPPIES": "UNHAPPY, (Shakespeare) to make unhappy [v]\n",
  "UNHAPPIEST": "UNHAPPY, not happy [adj]\n",
  "UNHAPPILY": "UNHAPPY, not happy [adv]\n",
  "UNHAPPINESS": "the state of being unhappy [n -ES]\n",
  "UNHAPPINESSES": "UNHAPPINESS, the state of being unhappy [n]\n",
  "UNHAPPY": "not happy [adj UNHAPPIER, UNHAPPIEST, UNHAPPILY] / (Shakespeare) to make unhappy [v UNHAPPIED, UNHAPPYING, UNHAPPIES]\n",
  "UNHAPPYING": "UNHAPPY, (Shakespeare) to make unhappy [v]\n",
  "UNHARBOUR": "to dislodge from shelter [v -ED, -ING, -S]\n",
  "UNHARBOURED": "UNHARBOUR, to dislodge from shelter [v]\n",
  "UNHARBOURING": "UNHARBOUR, to dislodge from shelter [v]\n",
  "UNHARBOURS": "UNHARBOUR, to dislodge from shelter [v]\n",
  "UNHARDENED": "not hardened [adj]\n",
  "UNHARDIER": "UNHARDY, not hardy [adj]\n",
  "UNHARDIEST": "UNHARDY, not hardy [adj]\n",
  "UNHARDY": "not hardy [adj UNHARDIER, UNHARDIEST]\n",
  "UNHARMED": "not harmed [adj]\n",
  "UNHARMFUL": "not harmful [adj UNHARMFULLY]\n",
  "UNHARMFULLY": "UNHARMFUL, not harmful [adv]\n",
  "UNHARMING": "harmless [adj]\n",
  "UNHARMONIOUS": "not harmonious [adj]\n",
  "UNHARNESS": "to release from a harness [v -ED, -ING, -ES]\n",
  "UNHARNESSED": "UNHARNESS, to release from a harness [v]\n",
  "UNHARNESSES": "UNHARNESS, to release from a harness [v]\n",
  "UNHARNESSING": "UNHARNESS, to release from a harness [v]\n",
  "UNHARRIED": "not harried [adj]\n",
  "UNHARVESTED": "not harvested [adj]\n",
  "UNHASP": "to unfasten a hasp [v -ED, -ING, -S]\n",
  "UNHASPED": "UNHASP, to unfasten a hasp [v]\n",
  "UNHASPING": "UNHASP, to unfasten a hasp [v]\n",
  "UNHASPS": "UNHASP, to unfasten a hasp [v]\n",
  "UNHASTIER": "UNHASTY, not hasty [adj]\n",
  "UNHASTIEST": "UNHASTY, not hasty [adj]\n",
  "UNHASTING": "not in haste [adj]\n",
  "UNHASTY": "not hasty [adj UNHASTIER, UNHASTIEST]\n",
  "UNHAT": "to remove a hat [v UNHATTED, UNHATTING, UNHATS]\n",
  "UNHATCHED": "not hatched [adj]\n",
  "UNHATS": "UNHAT, to remove a hat [v]\n",
  "UNHATTED": "UNHAT, to remove a hat [v]\n",
  "UNHATTING": "the act of removing a hat [n -S]\n",
  "UNHATTINGS": "UNHATTING, the act of removing a hat [n]\n",
  "UNHAUNTED": "not haunted [adj]\n",
  "UNHAZARDED": "not hazarded [adj]\n",
  "UNHAZARDOUS": "not hazardous [adj]\n",
  "UNHEAD": "to decapitate [v -ED, -ING, -S]\n",
  "UNHEADED": "UNHEAD, to decapitate [v]\n",
  "UNHEADING": "UNHEAD, to decapitate [v]\n",
  "UNHEADS": "UNHEAD, to decapitate [v]\n",
  "UNHEAL": "(Spenser) to discover, disclose, also UNHELE [v -ED, -ING, -S]\n",
  "UNHEALABLE": "not healable [adj]\n",
  "UNHEALED": "UNHEAL, (Spenser) to discover, disclose, also UNHELE [v]\n",
  "UNHEALING": "UNHEAL, (Spenser) to discover, disclose, also UNHELE [v]\n",
  "UNHEALS": "UNHEAL, (Spenser) to discover, disclose, also UNHELE [v]\n",
  "UNHEALTH": "ill-health [n -S]\n",
  "UNHEALTHFUL": "not healthful [adj UNHEALTHFULLY]\n",
  "UNHEALTHFULLY": "UNHEALTHFUL, not healthful [adv]\n",
  "UNHEALTHFULNESS": "the state of being unhealthful [n]\n",
  "UNHEALTHIER": "UNHEALTHY, not healthy [adj]\n",
  "UNHEALTHIEST": "UNHEALTHY, not healthy [adj]\n",
  "UNHEALTHILY": "UNHEALTHY, not healthy [adv]\n",
  "UNHEALTHINESS": "the state of being unhealthy [n -ES]\n",
  "UNHEALTHINESSES": "UNHEALTHINESS, the state of being unhealthy [n]\n",
  "UNHEALTHS": "UNHEALTH, ill-health [n]\n",
  "UNHEALTHY": "not healthy [adj UNHEALTHIER, UNHEALTHIEST, UNHEALTHILY]\n",
  "UNHEARD": "not heard [adj]\n",
  "UNHEARSE": "to remove from a hearse [v UNHEARSED or (Spenser) UNHERST, UNHEARSING, UNHEARSES]\n",
  "UNHEARSED": "UNHEARSE, to remove from a hearse [v]\n",
  "UNHEARSES": "UNHEARSE, to remove from a hearse [v]\n",
  "UNHEARSING": "UNHEARSE, to remove from a hearse [v]\n",
  "UNHEART": "(Shakespeare) to dishearten [v -ED, -ING, -S]\n",
  "UNHEARTED": "UNHEART, (Shakespeare) to dishearten [v]\n",
  "UNHEARTING": "UNHEART, (Shakespeare) to dishearten [v]\n",
  "UNHEARTS": "UNHEART, (Shakespeare) to dishearten [v]\n",
  "UNHEATED": "not heated [adj]\n",
  "UNHEDGED": "not hedged [adj]\n",
  "UNHEEDED": "not heeded [adj UNHEEDEDLY]\n",
  "UNHEEDEDLY": "UNHEEDED, not heeded [adv]\n",
  "UNHEEDFUL": "not heedful [adj UNHEEDFULLY]\n",
  "UNHEEDFULLY": "UNHEEDFUL, not heedful [adv]\n",
  "UNHEEDIER": "UNHEEDY, incautious; heedless [adj]\n",
  "UNHEEDIEST": "UNHEEDY, incautious; heedless [adj]\n",
  "UNHEEDILY": "UNHEEDY, incautious; heedless [adv]\n",
  "UNHEEDING": "not heeding [adj UNHEEDINGLY]\n",
  "UNHEEDINGLY": "UNHEEDING, not heeding [adv]\n",
  "UNHEEDY": "incautious; heedless [adj UNHEEDIER, UNHEEDIEST, UNHEEDILY]\n",
  "UNHELE": "(Spenser) to uncover, disclose, also UNHEAL [v UNHELED, UNHELING, UNHELES]\n",
  "UNHELED": "UNHELE, (Spenser) to uncover, disclose, also UNHEAL [v]\n",
  "UNHELES": "UNHELE, (Spenser) to uncover, disclose, also UNHEAL [v]\n",
  "UNHELING": "UNHELE, (Spenser) to uncover, disclose, also UNHEAL [v]\n",
  "UNHELM": "to remove the helmet of [v -ED, -ING, -S]\n",
  "UNHELMED": "UNHELM, to remove the helmet of [v]\n",
  "UNHELMETED": "not fitted with a helmet [adj]\n",
  "UNHELMING": "UNHELM, to remove the helmet of [v]\n",
  "UNHELMS": "UNHELM, to remove the helmet of [v]\n",
  "UNHELPABLE": "not helpable [adj]\n",
  "UNHELPED": "not helped [adj]\n",
  "UNHELPFUL": "not helpful [adj UNHELPFULLY]\n",
  "UNHELPFULLY": "UNHELPFUL, not helpful [adv]\n",
  "UNHELPFULNESS": "the quality of being unhelpful [n -ES]\n",
  "UNHELPFULNESSES": "UNHELPFULNESS, the quality of being unhelpful [n]\n",
  "UNHEMMED": "not hemmed [adj]\n",
  "UNHEPPEN": "(dialect) clumsy [adj]\n",
  "UNHERALDED": "not heralded [adj]\n",
  "UNHEROIC": "not heroic, also UNHEROICAL [adj UNHEROICALLY]\n",
  "UNHEROICAL": "not heroic, also UNHEROIC [adj UNHEROICALLY]\n",
  "UNHEROICALLY": "UNHEROICAL, not heroic, also UNHEROIC [adv]\n",
  "UNHERST": "UNHEARSE, to remove from a hearse [v]\n",
  "UNHESITATING": "not hesitating [adj UNHESITATINGLY]\n",
  "UNHESITATINGLY": "UNHESITATING, not hesitating [adv]\n",
  "UNHEWN": "not hewn [adj]\n",
  "UNHIDDEN": "not hidden [adj]\n",
  "UNHIDEBOUND": "(Milton) not having a skin confining the body [adj]\n",
  "UNHINDERED": "not hindered [adj]\n",
  "UNHINGE": "to remove from hinges [v UNHINGED, UNHINGING, UNHINGES]\n",
  "UNHINGED": "UNHINGE, to remove from hinges [v]\n",
  "UNHINGEMENT": "the state of being unhinged [n -S]\n",
  "UNHINGEMENTS": "UNHINGEMENT, the state of being unhinged [n]\n",
  "UNHINGES": "UNHINGE, to remove from hinges [v]\n",
  "UNHINGING": "UNHINGE, to remove from hinges [v]\n",
  "UNHIP": "(slang) square, not trendy [adj UNHIPPER, UNHIPPEST]\n",
  "UNHIPPER": "UNHIP, (slang) square, not trendy [adj]\n",
  "UNHIPPEST": "UNHIP, (slang) square, not trendy [adj]\n",
  "UNHIRABLE": "not hirable [adj]\n",
  "UNHIRED": "not hired [adj]\n",
  "UNHISTORIC": "not historic [adj]\n",
  "UNHISTORICAL": "not historical [adj]\n",
  "UNHITCH": "to free from being hitched [v -ED, -ING, -ES]\n",
  "UNHITCHED": "UNHITCH, to free from being hitched [v]\n",
  "UNHITCHES": "UNHITCH, to free from being hitched [v]\n",
  "UNHITCHING": "UNHITCH, to free from being hitched [v]\n",
  "UNHIVE": "to drive from a hive [v UNHIVED, UNHIVING, UNHIVES]\n",
  "UNHIVED": "UNHIVE, to drive from a hive [v]\n",
  "UNHIVES": "UNHIVE, to drive from a hive [v]\n",
  "UNHIVING": "UNHIVE, to drive from a hive [v]\n",
  "UNHOARD": "to take from a hoard [v -ED, -ING, -S]\n",
  "UNHOARDED": "UNHOARD, to take from a hoard [v]\n",
  "UNHOARDING": "UNHOARD, to take from a hoard [v]\n",
  "UNHOARDS": "UNHOARD, to take from a hoard [v]\n",
  "UNHOLIER": "UNHOLY, not holy [adj]\n",
  "UNHOLIEST": "UNHOLY, not holy [adj]\n",
  "UNHOLILY": "UNHOLY, not holy [adv]\n",
  "UNHOLINESS": "the state of being unholy [n -ES]\n",
  "UNHOLINESSES": "UNHOLINESS, the state of being unholy [n]\n",
  "UNHOLPEN": "not helped [adj]\n",
  "UNHOLSTER": "to remove from a holster [v -ED, -ING, -S]\n",
  "UNHOLSTERED": "UNHOLSTER, to remove from a holster [v]\n",
  "UNHOLSTERING": "UNHOLSTER, to remove from a holster [v]\n",
  "UNHOLSTERS": "UNHOLSTER, to remove from a holster [v]\n",
  "UNHOLY": "not holy [adj UNHOLIER, UNHOLIEST, UNHOLILY]\n",
  "UNHOMELIER": "UNHOMELY, not homely [adj]\n",
  "UNHOMELIEST": "UNHOMELY, not homely [adj]\n",
  "UNHOMELIKE": "not homelike [adj]\n",
  "UNHOMELY": "not homely [adj UNHOMELIER, UNHOMELIEST]\n",
  "UNHOMOGENISED": "not homogenised, also UNHOMOGENIZED [adj]\n",
  "UNHOMOGENIZED": "not homogenized, also UNHOMOGENISED [adj]\n",
  "UNHONEST": "dishonest [adj]\n",
  "UNHONORED": "not honored, also UNHONOURED [adj]\n",
  "UNHONOURED": "not honoured, also UNHONORED [adj]\n",
  "UNHOOD": "to remove a hood from [v -ED, -ING, -S]\n",
  "UNHOODED": "UNHOOD, to remove a hood from [v]\n",
  "UNHOODING": "UNHOOD, to remove a hood from [v]\n",
  "UNHOODS": "UNHOOD, to remove a hood from [v]\n",
  "UNHOOK": "to remove from a hook [v -ED, -ING, -S]\n",
  "UNHOOKED": "UNHOOK, to remove from a hook [v]\n",
  "UNHOOKING": "UNHOOK, to remove from a hook [v]\n",
  "UNHOOKS": "UNHOOK, to remove from a hook [v]\n",
  "UNHOOP": "to remove hoops from [v -ED, -ING, -S]\n",
  "UNHOOPED": "UNHOOP, to remove hoops from [v]\n",
  "UNHOOPING": "UNHOOP, to remove hoops from [v]\n",
  "UNHOOPS": "UNHOOP, to remove hoops from [v]\n",
  "UNHOPED": "not hoped for [adj]\n",
  "UNHOPEFUL": "not hopeful [adj UNHOPEFULLY]\n",
  "UNHOPEFULLY": "UNHOPEFUL, not hopeful [adv]\n",
  "UNHORSE": "to cause to fall from a horse [v UNHORSED, UNHORSING, UNHORSES]\n",
  "UNHORSED": "UNHORSE, to cause to fall from a horse [v]\n",
  "UNHORSES": "UNHORSE, to cause to fall from a horse [v]\n",
  "UNHORSING": "UNHORSE, to cause to fall from a horse [v]\n",
  "UNHOSPITABLE": "not hospitable, also INHOSPITABLE [adj]\n",
  "UNHOSTILE": "not hostile [adj]\n",
  "UNHOUSE": "to deprive of a protective shelter [v UNHOUSED, UNHOUSING, UNHOUSES]\n",
  "UNHOUSED": "UNHOUSE, to deprive of a protective shelter [v]\n",
  "UNHOUSELED": "not houseled, i.e. not having received the Eucharist shortly before death, also UNHOUZZLED [adj]\n",
  "UNHOUSES": "UNHOUSE, to deprive of a protective shelter [v]\n",
  "UNHOUSING": "UNHOUSE, to deprive of a protective shelter [v]\n",
  "UNHOUZZLED": "(Shakespeare) not having received the sacrament, also UNHOUSELED [adj]\n",
  "UNHUMAN": "not human [adj UNHUMANLY]\n",
  "UNHUMANISE": "to render inhuman or barbarous, also UNHUMANIZE [v UNHUMANISED, UNHUMANISING, UNHUMANISES]\n",
  "UNHUMANISED": "UNHUMANISE, to render inhuman or barbarous, also UNHUMANIZE [v]\n",
  "UNHUMANISES": "UNHUMANISE, to render inhuman or barbarous, also UNHUMANIZE [v]\n",
  "UNHUMANISING": "UNHUMANISE, to render inhuman or barbarous, also UNHUMANIZE [v]\n",
  "UNHUMANIZE": "to render inhuman or barbarous, also UNHUMANISE [v UNHUMANIZED, UNHUMANIZING, UNHUMANIZES]\n",
  "UNHUMANIZED": "UNHUMANIZE, to render inhuman or barbarous, also UNHUMANISE [v]\n",
  "UNHUMANIZES": "UNHUMANIZE, to render inhuman or barbarous, also UNHUMANISE [v]\n",
  "UNHUMANIZING": "UNHUMANIZE, to render inhuman or barbarous, also UNHUMANISE [v]\n",
  "UNHUMANLY": "UNHUMAN, not human [adv]\n",
  "UNHUMBLED": "not humbled [adj]\n",
  "UNHUMOROUS": "not humorous [adj]\n",
  "UNHUNG": "not hung [adj]\n",
  "UNHUNTED": "not hunted [adj]\n",
  "UNHURRIED": "not hurried [adj UNHURRIEDLY]\n",
  "UNHURRIEDLY": "UNHURRIED, not hurried [adv]\n",
  "UNHURRYING": "not hurrying [adj]\n",
  "UNHURT": "not hurt [adj]\n",
  "UNHURTFUL": "not hurtful [adj UNHURTFULLY]\n",
  "UNHURTFULLY": "UNHURTFUL, not hurtful [adv]\n",
  "UNHURTFULNESS": "the state of being unhurtful [n -ES]\n",
  "UNHURTFULNESSES": "UNHURTFULNESS, the state of being unhurtful [n]\n",
  "UNHUSBANDED": "not husbanded [adj]\n",
  "UNHUSK": "to remove the husks from [v -ED, -ING, -S]\n",
  "UNHUSKED": "UNHUSK, to remove the husks from [v]\n",
  "UNHUSKING": "UNHUSK, to remove the husks from [v]\n",
  "UNHUSKS": "UNHUSK, to remove the husks from [v]\n",
  "UNHYDROLYSED": "not hydrolysed, also UNHYDROLYZED [adj]\n",
  "UNHYDROLYZED": "not hydrolyzed, also UNHYDROLYSED [adj]\n",
  "UNHYGIENIC": "not hygienic [adj]\n",
  "UNHYPHENATED": "not hyphenated [adj]\n",
  "UNHYSTERICAL": "not hysterical [adj UNHYSTERICALLY]\n",
  "UNHYSTERICALLY": "UNHYSTERICAL, not hysterical [adv]\n",
  "UNI": "(short for) university [n -S]\n",
  "UNIALGAL": "pertaining to a single algal cell [adj]\n",
  "UNIAXIAL": "having one axis [adj UNIAXIALLY]\n",
  "UNIAXIALLY": "UNIAXIAL, having one axis [adv]\n",
  "UNIBODIES": "UNIBODY, a single moulded unit that forms the bodywork and chassis of a vehicle [n]\n",
  "UNIBODY": "a single moulded unit that forms the bodywork and chassis of a vehicle [n UNIBODIES]\n",
  "UNIBROW": "a derogatory word for eyebrows that meet, also MONOBROW [n -S]\n",
  "UNIBROWS": "UNIBROW, a derogatory word for eyebrows that meet, also MONOBROW [n]\n",
  "UNICA": "UNICUM, a unique example or specimen [n]\n",
  "UNICAMERAL": "of a legislative assembly, having, or consisting of, a single chamber [adj UNICAMERALLY]\n",
  "UNICAMERALISM": "the state of being unicameral, having, or consisting of, a single chamber [n -S]\n",
  "UNICAMERALISMS": "UNICAMERALISM, the state of being unicameral, having, or consisting of, a single chamber [n]\n",
  "UNICAMERALIST": "a supporter of unicameralism [n -S]\n",
  "UNICAMERALISTS": "UNICAMERALIST, a supporter of unicameralism [n]\n",
  "UNICAMERALLY": "UNICAMERAL, of a legislative assembly, having, or consisting of, a single chamber [adv]\n",
  "UNICED": "not iced [adj]\n",
  "UNICELLULAR": "having or consisting of a single cell [adj]\n",
  "UNICELLULARITY": "the state of being unicellular [n]\n",
  "UNICENTRAL": "having a single center of growth [adj]\n",
  "UNICITIES": "UNICITY, uniqueness, oneness [n]\n",
  "UNICITY": "uniqueness, oneness [n UNICITIES]\n",
  "UNICOLOR": "having one colour, also UNICOLOUR [adj]\n",
  "UNICOLORATE": "of one uniform colour, also UNICOLORED, UNICOLOROUS, UNICOLOURED [adj]\n",
  "UNICOLORED": "of one colour, also UNICOLORATE, UNICOLOROUS, UNICOLOURED [adj]\n",
  "UNICOLOROUS": "of one uniform colour, also UNICOLORATE, UNICOLORED, UNICOLOURED [adj]\n",
  "UNICOLOUR": "having one colour, also UNICOLOR, UNICOLORED, UNICOLOURED [adj]\n",
  "UNICOLOURED": "of one uniform colour, also UNICOLORATE, UNICOLORED, UNICOLOROUS [adj]\n",
  "UNICOM": "a designated radio frequency for communications at some airports [n -S]\n",
  "UNICOMS": "UNICOM, a designated radio frequency for communications at some airports [n]\n",
  "UNICORN": "a mythical horselike creature [n -S]\n",
  "UNICORNS": "UNICORN, a mythical horselike creature [n]\n",
  "UNICOSTATE": "of a leaf, having a single rib or strong nerve running upward from the base [adj]\n",
  "UNICUM": "a unique example or specimen [n UNICA]\n",
  "UNICYCLE": "a one-wheeled vehicle [n -S] / to ride a unicycle [v UNICYCLED, UNICYCLING, UNICYCLES]\n",
  "UNICYCLED": "UNICYCLE, to ride a unicycle [v]\n",
  "UNICYCLES": "UNICYCLE, to ride a unicycle [v]\n",
  "UNICYCLING": "UNICYCLE, to ride a unicycle [v]\n",
  "UNICYCLIST": "one who rides a unicycle [n -S]\n",
  "UNICYCLISTS": "UNICYCLIST, one who rides a unicycle [n]\n",
  "UNIDEAED": "lacking ideas [adj]\n",
  "UNIDEAL": "not ideal [adj]\n",
  "UNIDEALISM": "the state of not being ideal [n -S]\n",
  "UNIDEALISMS": "UNIDEALISM, the state of not being ideal [n]\n",
  "UNIDEALISTIC": "not idealistic [adj]\n",
  "UNIDENTIFIABLE": "not identifiable [adj]\n",
  "UNIDENTIFIED": "not identified [adj]\n",
  "UNIDEOLOGICAL": "not ideological [adj]\n",
  "UNIDIMENSIONAL": "one-dimensional [adj]\n",
  "UNIDIOMATIC": "not idiomatic [adj UNIDIOMATICALLY]\n",
  "UNIDIOMATICALLY": "UNIDIOMATIC, not idiomatic [adv]\n",
  "UNIDIRECTIONAL": "involving, functioning, moving, or responsive in a single direction [adj]\n",
  "UNIFACE": "a coin having a design on only one side [n -S]\n",
  "UNIFACES": "UNIFACE, a coin having a design on only one side [n]\n",
  "UNIFIABLE": "that can be unified [adj]\n",
  "UNIFIC": "unifying [adj]\n",
  "UNIFICATION": "the act of unifying [n -S]\n",
  "UNIFICATIONS": "UNIFICATION, the act of unifying [n]\n",
  "UNIFIED": "UNIFY, to make into a coherent whole [v]\n",
  "UNIFIER": "something or someone that unifies [n -S]\n",
  "UNIFIERS": "UNIFIER, something or someone that unifies [n]\n",
  "UNIFIES": "UNIFY, to make into a coherent whole [v]\n",
  "UNIFILAR": "having only one thread, wire or fibre [adj]\n",
  "UNIFLOROUS": "bearing one flower only; as, a uniflorous peduncle [adj]\n",
  "UNIFOLIATE": "with one leaf only [adj]\n",
  "UNIFOLIOLATE": "of a compound leaf reduced to a single leaflet [adj]\n",
  "UNIFORM": "consistent [adj UNIFORMER, UNIFORMEST, UNIFORMLY] / to dress in uniform [v -ED, -ING, -S]\n",
  "UNIFORMED": "UNIFORM, to dress in uniform [v]\n",
  "UNIFORMER": "UNIFORM, consistent [adj]\n",
  "UNIFORMEST": "UNIFORM, consistent [adj]\n",
  "UNIFORMING": "UNIFORM, to dress in uniform [v]\n",
  "UNIFORMITARIAN": "one who believes that geological changes etc. can be explained by gradual processes rather than catastrophic events [n -S]\n",
  "UNIFORMITARIANS": "UNIFORMITARIAN, one who believes that geological changes etc. can be explained by gradual processes rather than catastrophic events [n]\n",
  "UNIFORMITIES": "UNIFORMITY, the state of being uniform [n]\n",
  "UNIFORMITY": "the state of being uniform [n UNIFORMITIES]\n",
  "UNIFORMLY": "UNIFORM, consistent [adv]\n",
  "UNIFORMNESS": "the state of being uniform [n -ES]\n",
  "UNIFORMNESSES": "UNIFORMNESS, the state of being uniform [n]\n",
  "UNIFORMS": "UNIFORM, to dress in uniform [v]\n",
  "UNIFY": "to make into a coherent whole [v UNIFIED, UNIFYING, UNIFIES]\n",
  "UNIFYING": "the act of making one [n -S]\n",
  "UNIFYINGS": "UNIFYING, the act of making one [n]\n",
  "UNIGENITURE": "the state or fact of being the only begotten [n -S]\n",
  "UNIGENITURES": "UNIGENITURE, the state or fact of being the only begotten [n]\n",
  "UNIGNITED": "not ignited [adj]\n",
  "UNIGNORABLE": "not capable of being ignored [adj]\n",
  "UNIJUGATE": "of a compound leaf, having only pair of leaflets [adj]\n",
  "UNILABIATE": "having one lip only; as, a unilabiate corolla [adj]\n",
  "UNILATERAL": "one-sided [adj UNILATERALLY]\n",
  "UNILATERALISM": "the state of being unilateral, also UNILATERALITY [n -S]\n",
  "UNILATERALISMS": "UNILATERALISM, the state of being unilateral, also UNILATERALITY [n]\n",
  "UNILATERALIST": "a supporter of unilateralism [n -S]\n",
  "UNILATERALISTS": "UNILATERALIST, a supporter of unilateralism [n]\n",
  "UNILATERALITIES": "UNILATERALITY, the state of being unilateral, also UNILATERALISM [n]\n",
  "UNILATERALITY": "the state of being unilateral, also UNILATERALISM [n UNILATERALITIES]\n",
  "UNILATERALLY": "UNILATERAL, one-sided [adv]\n",
  "UNILINEAL": "tracing descent through the paternal or maternal line only [adj]\n",
  "UNILINEAR": "developing in or involving a series of stages [adj]\n",
  "UNILINGUAL": "in one language only [adj] / someone speaking language only [n -S]\n",
  "UNILINGUALISM": "the state of being unilingual [n -S]\n",
  "UNILINGUALISMS": "UNILINGUALISM, the state of being unilingual [n]\n",
  "UNILINGUALIST": "a supporter of unilingualism [n -S]\n",
  "UNILINGUALISTS": "UNILINGUALIST, a supporter of unilingualism [n]\n",
  "UNILINGUALS": "UNILINGUAL, someone speaking language only [n]\n",
  "UNILITERAL": "consisting of one letter only; as, a uniliteral word or sign [adj]\n",
  "UNILLUMED": "not illuminated [adj]\n",
  "UNILLUMINATED": "not illuminated [adj]\n",
  "UNILLUMINATING": "not illuminating [adj]\n",
  "UNILLUMINED": "not illumined [adj]\n",
  "UNILLUSIONED": "free from illusion [adj]\n",
  "UNILLUSTRATED": "not illustrated [adj]\n",
  "UNILOBAR": "having one lobe, also UNILOBED [adj]\n",
  "UNILOBED": "having one lobe, also UNILOBAR [adj]\n",
  "UNILOBULAR": "having one lobule [adj]\n",
  "UNILOCULAR": "with a single cavity [adj]\n",
  "UNIMAGINABLE": "not imaginable or comprehensible [adj UNIMAGINABLY]\n",
  "UNIMAGINABLY": "UNIMAGINABLE, not imaginable or comprehensible [adv]\n",
  "UNIMAGINATIVE": "not imaginative [adj UNIMAGINATIVELY]\n",
  "UNIMAGINATIVELY": "UNIMAGINATIVE, not imaginative [adv]\n",
  "UNIMAGINED": "not imagined [adj]\n",
  "UNIMBUED": "not imbued [adj]\n",
  "UNIMMORTAL": "not immortal [adj]\n",
  "UNIMMUNISED": "not immunised, also UNIMMUNIZED [adj]\n",
  "UNIMMUNIZED": "not immunized, also UNIMMUNISED [adj]\n",
  "UNIMODAL": "having or involving one mode [adj]\n",
  "UNIMOLECULAR": "consisting of one molecule only [adj]\n",
  "UNIMPAIRED": "not impaired [adj]\n",
  "UNIMPARTED": "not imparted [adj]\n",
  "UNIMPASSIONED": "not impassioned [adj]\n",
  "UNIMPEACHABLE": "not impeachable [adj UNIMPEACHABLY]\n",
  "UNIMPEACHABLY": "UNIMPEACHABLE, not impeachable [adv]\n",
  "UNIMPEACHED": "not impeached [adj]\n",
  "UNIMPEDED": "not impeded [adj UNIMPEDEDLY]\n",
  "UNIMPEDEDLY": "UNIMPEDED, not impeded [adv]\n",
  "UNIMPLORED": "not implored [adj]\n",
  "UNIMPORTANCE": "lack of importance [n -S]\n",
  "UNIMPORTANCES": "UNIMPORTANCE, lack of importance [n]\n",
  "UNIMPORTANT": "not important [adj]\n",
  "UNIMPORTUNED": "not importuned [adj]\n",
  "UNIMPOSED": "not imposed [adj]\n",
  "UNIMPOSING": "not imposing [adj]\n",
  "UNIMPREGNATED": "not impregnated [adj]\n",
  "UNIMPRESSED": "not impressed [adj]\n",
  "UNIMPRESSIBLE": "not impressible [adj]\n",
  "UNIMPRESSIVE": "not impressive [adj]\n",
  "UNIMPRISONED": "not imprisoned [adj]\n",
  "UNIMPROVED": "not improved [adj]\n",
  "UNIMPUGNABLE": "not impugnable [adj]\n",
  "UNINAUGURATED": "not inaugurated [adj]\n",
  "UNINCHANTED": "(Milton) unenchanted [adj]\n",
  "UNINCITED": "not incited [adj]\n",
  "UNINCLOSED": "not enclosed, also UNENCLOSED [adj]\n",
  "UNINCORPORATED": "not incorporated [adj]\n",
  "UNINCUMBERED": "not incumbered [adj]\n",
  "UNINDEARED": "(Milton) not endeared [adj]\n",
  "UNINDENTED": "not indented [adj]\n",
  "UNINDEXED": "not indexed [adj]\n",
  "UNINDICTED": "not indicted [adj]\n",
  "UNINFECTED": "not infected [adj]\n",
  "UNINFLAMED": "not inflamed [adj]\n",
  "UNINFLAMMABLE": "not inflammable [adj]\n",
  "UNINFLATED": "not inflated [adj]\n",
  "UNINFLECTED": "not inflected [adj]\n",
  "UNINFLUENCED": "not influenced [adj]\n",
  "UNINFLUENTIAL": "not influential [adj]\n",
  "UNINFORCEABLE": "not capable of being enforced [adj]\n",
  "UNINFORCED": "not enforced [adj]\n",
  "UNINFORMATIVE": "not informative [adj UNINFORMATIVELY]\n",
  "UNINFORMATIVELY": "UNINFORMATIVE, not informative [adv]\n",
  "UNINFORMED": "not informed [adj]\n",
  "UNINFORMING": "not informing [adj]\n",
  "UNINGRATIATING": "not ingratiating [adj]\n",
  "UNINHABITABLE": "not inhabitable [adj]\n",
  "UNINHABITED": "not inhabited [adj]\n",
  "UNINHIBITED": "free from inhibition [adj UNINHIBITEDLY]\n",
  "UNINHIBITEDLY": "UNINHIBITED, free from inhibition [adv]\n",
  "UNINHIBITEDNESS": "the state of being uninhibited [n]\n",
  "UNINITIATE": "one who is not an initiate [n -S]\n",
  "UNINITIATED": "not initiated [adj]\n",
  "UNINITIATES": "UNINITIATE, one who is not an initiate [n]\n",
  "UNINJURED": "not injured [adj]\n",
  "UNINOCULATED": "not inoculated [adj]\n",
  "UNINQUIRING": "not inquiring [adj]\n",
  "UNINQUISITIVE": "not inquisitive [adj]\n",
  "UNINSCRIBED": "not inscribed [adj]\n",
  "UNINSPECTED": "not inspected [adj]\n",
  "UNINSPIRED": "not inspired [adj]\n",
  "UNINSPIRING": "not inspiring [adj]\n",
  "UNINSTAL": "to reverse a previous installation, also UNINSTALL [v UNINSTALLED, UNINSTALLING, UNINSTALS]\n",
  "UNINSTALL": "to remove a program from a storage device, also UNINSTAL [v -ED, -ING, -S]\n",
  "UNINSTALLED": "UNINSTALL, to remove a program from a storage device, also UNINSTAL [v]\n",
  "UNINSTALLING": "UNINSTALL, to remove a program from a storage device, also UNINSTAL [v]\n",
  "UNINSTALLS": "UNINSTALL, to remove a program from a storage device, also UNINSTAL [v]\n",
  "UNINSTALS": "UNINSTAL, to reverse a previous installation, also UNINSTALL [v]\n",
  "UNINSTRUCTED": "not instructed [adj]\n",
  "UNINSTRUCTIVE": "not instructive [adj]\n",
  "UNINSULATED": "not insulated [adj]\n",
  "UNINSURABLE": "not capable of being insured [adj]\n",
  "UNINSURED": "not insured [adj] / one who is not insured [n -S]\n",
  "UNINSUREDS": "UNINSURED, one who is not insured [n]\n",
  "UNINTEGRATED": "not integrated [adj]\n",
  "UNINTELLECTUAL": "not intellectual [adj]\n",
  "UNINTELLIGENCE": "a lack of intelligence [n -S]\n",
  "UNINTELLIGENCES": "UNINTELLIGENCE, a lack of intelligence [n]\n",
  "UNINTELLIGENT": "not intelligent [adj UNINTELLIGENTLY]\n",
  "UNINTELLIGENTLY": "UNINTELLIGENT, not intelligent [adv]\n",
  "UNINTELLIGIBLE": "not intelligible [adj UNINTELLIGIBLY]\n",
  "UNINTELLIGIBLY": "UNINTELLIGIBLE, not intelligible [adv]\n",
  "UNINTENDED": "not intended [adj]\n",
  "UNINTENTIONAL": "not intentional [adj UNINTENTIONALLY]\n",
  "UNINTENTIONALLY": "UNINTENTIONAL, not intentional [adv]\n",
  "UNINTEREST": "lack of interest [n -S]\n",
  "UNINTERESTED": "not interested [adj UNINTERESTEDLY]\n",
  "UNINTERESTEDLY": "UNINTERESTED, not interested [adv]\n",
  "UNINTERESTING": "not interesting [adj UNINTERESTINGLY]\n",
  "UNINTERESTINGLY": "UNINTERESTING, not interesting [adv]\n",
  "UNINTERESTS": "UNINTEREST, lack of interest [n]\n",
  "UNINTERMITTED": "not intermitted [adj UNINTERMITTEDLY]\n",
  "UNINTERMITTEDLY": "UNINTERMITTED, not intermitted [adv]\n",
  "UNINTERMITTING": "not intermitting [adj]\n",
  "UNINTERPRETABLE": "not interpretable [adj]\n",
  "UNINTERPRETED": "not interpreted [adj]\n",
  "UNINTERRUPTED": "not interrupted [adj UNINTERRUPTEDLY]\n",
  "UNINTERRUPTEDLY": "UNINTERRUPTED, not interrupted [adv]\n",
  "UNINTIMIDATED": "not intimidated [adj]\n",
  "UNINTOXICATING": "not intoxicating [adj]\n",
  "UNINTRODUCED": "not introduced [adj]\n",
  "UNINUCLEAR": "having one nucleus [adj]\n",
  "UNINUCLEATE": "having a single nucleus [adj]\n",
  "UNINURED": "not inured [adj]\n",
  "UNINVENTIVE": "not inventive [adj]\n",
  "UNINVESTED": "not invested [adj]\n",
  "UNINVIDIOUS": "not invidious [adj]\n",
  "UNINVITED": "not invited [adj]\n",
  "UNINVITING": "not inviting [adj]\n",
  "UNINVOKED": "not invoked [adj]\n",
  "UNINVOLVED": "not involved [adj]\n",
  "UNION": "the state of being united [n -S]\n",
  "UNIONISATION": "the act of forming a union, also UNIONIZATION [n -S]\n",
  "UNIONISATIONS": "UNIONISATION, the act of forming a union, also UNIONIZATION [n]\n",
  "UNIONISE": "to form into a union, also UNIONIZE [v UNIONISED, UNIONISING, UNIONISES]\n",
  "UNIONISED": "UNIONISE, to form into a union, also UNIONIZE [v]\n",
  "UNIONISER": "one who unionises, also UNIONIZER [n -S]\n",
  "UNIONISERS": "UNIONISER, one who unionises, also UNIONIZER [n]\n",
  "UNIONISES": "UNIONISE, to form into a union, also UNIONIZE [v]\n",
  "UNIONISING": "UNIONISE, to form into a union, also UNIONIZE [v]\n",
  "UNIONISM": "the principle of forming a union [n -S]\n",
  "UNIONISMS": "UNIONISM, the principle of forming a union [n]\n",
  "UNIONIST": "one who believes in political union [n -S]\n",
  "UNIONISTIC": "relating to unionism [adj]\n",
  "UNIONISTS": "UNIONIST, one who believes in political union [n]\n",
  "UNIONIZATION": "the act of forming a union, also UNIONISATION [n -S]\n",
  "UNIONIZATIONS": "UNIONIZATION, the act of forming a union, also UNIONISATION [n]\n",
  "UNIONIZE": "to form into a union, also UNIONISE [v UNIONIZED, UNIONIZING, UNIONIZES]\n",
  "UNIONIZED": "UNIONIZE, to form into a union, also UNIONISE [v]\n",
  "UNIONIZER": "one who unionizes, also UNIONISER [n -S]\n",
  "UNIONIZERS": "UNIONIZER, one who unionizes, also UNIONISER [n]\n",
  "UNIONIZES": "UNIONIZE, to form into a union, also UNIONISE [v]\n",
  "UNIONIZING": "UNIONIZE, to form into a union, also UNIONISE [v]\n",
  "UNIONS": "UNION, the state of being united [n]\n",
  "UNIPARENTAL": "derived from a single parent [adj UNIPARENTALLY]\n",
  "UNIPARENTALLY": "UNIPARENTAL, derived from a single parent [adv]\n",
  "UNIPAROUS": "producing only one offspring at birth [adj]\n",
  "UNIPARTITE": "having one part [adj]\n",
  "UNIPED": "a one-footed person or animal [n -S]\n",
  "UNIPEDS": "UNIPED, a one-footed person or animal [n]\n",
  "UNIPERSONAL": "existing as only one person [adj]\n",
  "UNIPERSONALITY": "the state of being unipersonal, existing as only one person [n]\n",
  "UNIPLANAR": "lying in one plane [adj]\n",
  "UNIPOD": "a one-legged support [n -S]\n",
  "UNIPODS": "UNIPOD, a one-legged support [n]\n",
  "UNIPOLAR": "showing only one kind of polarity [adj]\n",
  "UNIPOLARITIES": "UNIPOLARITY, the state of being unipolar [n]\n",
  "UNIPOLARITY": "the state of being unipolar [n UNIPOLARITIES]\n",
  "UNIPOTENT": "able to form only one part of a cell [adj]\n",
  "UNIQUE": "having no other of its kind [adj UNIQUER, UNIQUEST, UNIQUELY] / anything that is unique [n -S]\n",
  "UNIQUELY": "UNIQUE, having no other of its kind [adv]\n",
  "UNIQUENESS": "the state of being unique [n -ES]\n",
  "UNIQUENESSES": "UNIQUENESS, the state of being unique [n]\n",
  "UNIQUER": "UNIQUE, having no other of its kind [adj]\n",
  "UNIQUES": "UNIQUE, anything that is unique [n]\n",
  "UNIQUEST": "UNIQUE, having no other of its kind [adj]\n",
  "UNIRAMOSE": "esp. of the appendages of crustaceans, consisting of a single branch, also UNIRAMOUS [adj]\n",
  "UNIRAMOUS": "esp. of the appendages of crustaceans, consisting of a single branch, also UNIRAMOSE [adj]\n",
  "UNIRONED": "not ironed [adj]\n",
  "UNIRONIC": "not ironic [adj UNIRONICALLY]\n",
  "UNIRONICALLY": "UNIRONIC, not ironic [adv]\n",
  "UNIRRADIATED": "not irradiated [adj]\n",
  "UNIRRIGATED": "not irrigated [adj]\n",
  "UNIS": "UNI, (short for) university [n]\n",
  "UNISEPTATE": "having only one partition or septum, a uniseptate fruit [adj]\n",
  "UNISERIAL": "having only one row or series [adj UNISERIALLY]\n",
  "UNISERIALLY": "UNISERIAL, having only one row or series [adv]\n",
  "UNISERIATE": "having one line or series; uniserial [adj UNISERIATELY]\n",
  "UNISERIATELY": "UNISERIATE, having one line or series; uniserial [adv]\n",
  "UNISEX": "the condition of not being distinguishable as to sex [n -ES]\n",
  "UNISEXES": "UNISEX, the condition of not being distinguishable as to sex [n]\n",
  "UNISEXUAL": "of one sex only, as plants which have the male and female flowers on separate individual [adj UNISEXUALLY]\n",
  "UNISEXUALITIES": "UNISEXUALITY, the state of being unisexual [n]\n",
  "UNISEXUALITY": "the state of being unisexual [n UNISEXUALITIES]\n",
  "UNISEXUALLY": "UNISEXUAL, of one sex only, as plants which have the male and female flowers on separate individual [adv]\n",
  "UNISIZE": "made to fit all sizes [adj]\n",
  "UNISON": "complete agreement [n -S]\n",
  "UNISONAL": "being in unison, also UNISONANT, UNISONOUS [adj UNISONALLY]\n",
  "UNISONALLY": "UNISONAL, being in unison, also UNISONANT, UNISONOUS [adv]\n",
  "UNISONANCE": "accordance of sounds [n -S]\n",
  "UNISONANCES": "UNISONANCE, accordance of sounds [n]\n",
  "UNISONANT": "being in unison, also UNISONAL, UNISONOUS [adj]\n",
  "UNISONOUS": "being in unison, also UNISONAL, UNISONANT [adj]\n",
  "UNISONS": "UNISON, complete agreement [n]\n",
  "UNISSUED": "not issued [adj]\n",
  "UNIT": "a specific quantity used as a standard of measurement [n -S]\n",
  "UNITAGE": "amount in units [n -S]\n",
  "UNITAGES": "UNITAGE, amount in units [n]\n",
  "UNITAL": "relating to a unit [adj]\n",
  "UNITARD": "a leotard that also covers the legs [n -S]\n",
  "UNITARDS": "UNITARD, a leotard that also covers the legs [n]\n",
  "UNITARIAN": "one who denies the doctrine of the Trinity, believing that God exists only in one person [n -S]\n",
  "UNITARIANISM": "belief in unity or union [n -S]\n",
  "UNITARIANISMS": "UNITARIANISM, belief in unity or union [n]\n",
  "UNITARIANS": "UNITARIAN, one who denies the doctrine of the Trinity, believing that God exists only in one person [n]\n",
  "UNITARILY": "UNITARY, of the nature of a unit; having the separate existence or individual character of a unit [adv]\n",
  "UNITARITIES": "UNITARITY, the quality of being unitary, forming a single or uniform entity [n]\n",
  "UNITARITY": "the quality of being unitary, forming a single or uniform entity [n UNITARITIES]\n",
  "UNITARY": "of the nature of a unit; having the separate existence or individual character of a unit [adj UNITARILY]\n",
  "UNITE": "to join together [v UNITED, UNITING, UNITES]\n",
  "UNITED": "UNITE, to join together [v]\n",
  "UNITEDLY": "UNITED, UNITE, to join together [adv]\n",
  "UNITEDNESS": "the state of being united [n -ES]\n",
  "UNITEDNESSES": "UNITEDNESS, the state of being united [n]\n",
  "UNITER": "one who unites [n -S]\n",
  "UNITERS": "UNITER, one who unites [n]\n",
  "UNITES": "UNITE, to join together [v]\n",
  "UNITHOLDER": "one having a unit of securities in a unit trust [n -S]\n",
  "UNITHOLDERS": "UNITHOLDER, one having a unit of securities in a unit trust [n]\n",
  "UNITIES": "UNITY, the state of being one single entity [n]\n",
  "UNITING": "the state of uniting [n -S]\n",
  "UNITINGS": "UNITING, the state of uniting [n]\n",
  "UNITION": "conjunction [n -S]\n",
  "UNITIONS": "UNITION, conjunction [n]\n",
  "UNITISATION": "the act of unitising, also UNITIZATION [n -S]\n",
  "UNITISATIONS": "UNITISATION, the act of unitising, also UNITIZATION [n]\n",
  "UNITISE": "to divide into units, also UNITIZE [v UNITISED, UNITISING, UNITISES]\n",
  "UNITISED": "UNITISE, to divide into units, also UNITIZE [v]\n",
  "UNITISER": "one who unitises, also UNITIZER [n -S]\n",
  "UNITISERS": "UNITISER, one who unitises, also UNITIZER [n]\n",
  "UNITISES": "UNITISE, to divide into units, also UNITIZE [v]\n",
  "UNITISING": "UNITISE, to divide into units, also UNITIZE [v]\n",
  "UNITIVE": "serving to unite [adj UNITIVELY]\n",
  "UNITIVELY": "UNITIVE, serving to unite [adv]\n",
  "UNITIZATION": "the act of unitizing, also UNITISATION [n -S]\n",
  "UNITIZATIONS": "UNITIZATION, the act of unitizing, also UNITISATION [n]\n",
  "UNITIZE": "to divide into units, also UNITISE [v UNITIZED, UNITIZING, UNITIZES]\n",
  "UNITIZED": "UNITIZE, to divide into units, also UNITISE [v]\n",
  "UNITIZER": "one who unitizes, also UNITISER [n -S]\n",
  "UNITIZERS": "UNITIZER, one who unitizes, also UNITISER [n]\n",
  "UNITIZES": "UNITIZE, to divide into units, also UNITISE [v]\n",
  "UNITIZING": "UNITIZE, to divide into units, also UNITISE [v]\n",
  "UNITRUST": "a type of annuity trust [n -S]\n",
  "UNITRUSTS": "UNITRUST, a type of annuity trust [n]\n",
  "UNITS": "UNIT, a specific quantity used as a standard of measurement [n]\n",
  "UNITY": "the state of being one single entity [n UNITIES]\n",
  "UNIVALENCE": "the state of being univalent, also UNIVALENCY [n -S]\n",
  "UNIVALENCES": "UNIVALENCE, the state of being univalent, also UNIVALENCY [n]\n",
  "UNIVALENCIES": "UNIVALENCY, the state of being univalent, also UNIVALENCE [n]\n",
  "UNIVALENCY": "the state of being univalent, also UNIVALENCE [n UNIVALENCIES]\n",
  "UNIVALENT": "having a valency of one, capable of combining with one atom of hydrogen or its equivalent [adj] / a univalent radical [n -S]\n",
  "UNIVALENTS": "UNIVALENT, a univalent radical [n]\n",
  "UNIVALVE": "a mollusk having a single shell [n -S]\n",
  "UNIVALVED": "having a single-piece shell [adj]\n",
  "UNIVALVES": "UNIVALVE, a mollusk having a single shell [n]\n",
  "UNIVALVULAR": "having only one valve [adj]\n",
  "UNIVARIANT": "having one degree of freedom [adj]\n",
  "UNIVARIATE": "of a distribution, having one variate only [adj]\n",
  "UNIVERSAL": "of the universe; comprehending, affecting, the whole world [adj UNIVERSALLY] / something universally true [n -S]\n",
  "UNIVERSALISABLE": "capable of being universalized, also UNIVERSALIZABLE [adj]\n",
  "UNIVERSALISE": "to make universal, also UNIVERSALIZE [v UNIVERSALISED, UNIVERSALISING, UNIVERSALISES]\n",
  "UNIVERSALISED": "UNIVERSALISE, to make universal, also UNIVERSALIZE [v]\n",
  "UNIVERSALISES": "UNIVERSALISE, to make universal, also UNIVERSALIZE [v]\n",
  "UNIVERSALISING": "UNIVERSALISE, to make universal, also UNIVERSALIZE [v]\n",
  "UNIVERSALISM": "belief in universal salvation [n -S]\n",
  "UNIVERSALISMS": "UNIVERSALISM, belief in universal salvation [n]\n",
  "UNIVERSALIST": "a believer in universal salvation [n -S]\n",
  "UNIVERSALISTIC": "of or relating to the whole [adj]\n",
  "UNIVERSALISTS": "UNIVERSALIST, a believer in universal salvation [n]\n",
  "UNIVERSALITIES": "UNIVERSALITY, the state of being universal [n]\n",
  "UNIVERSALITY": "the state of being universal [n UNIVERSALITIES]\n",
  "UNIVERSALIZABLE": "capable of being universalized, also UNIVERSALISABLE [adj]\n",
  "UNIVERSALIZE": "to make universal, also UNIVERSALISE [v UNIVERSALIZED, UNIVERSALIZING, UNIVERSALIZES]\n",
  "UNIVERSALIZED": "UNIVERSALIZE, to make universal, also UNIVERSALISE [v]\n",
  "UNIVERSALIZES": "UNIVERSALIZE, to make universal, also UNIVERSALISE [v]\n",
  "UNIVERSALIZING": "UNIVERSALIZE, to make universal, also UNIVERSALISE [v]\n",
  "UNIVERSALLY": "UNIVERSAL, of the universe; comprehending, affecting, the whole world [adv]\n",
  "UNIVERSALNESS": "the state of being universal [n -ES]\n",
  "UNIVERSALNESSES": "UNIVERSALNESS, the state of being universal [n]\n",
  "UNIVERSALS": "UNIVERSAL, something universally true [n]\n",
  "UNIVERSE": "the totality of all existing things [n -S]\n",
  "UNIVERSES": "UNIVERSE, the totality of all existing things [n]\n",
  "UNIVERSITARIAN": "belonging to a university [adj]\n",
  "UNIVERSITIES": "UNIVERSITY, an institution of higher learning providing facilities for teaching and research and authorized to grant academic degrees [n]\n",
  "UNIVERSITY": "an institution of higher learning providing facilities for teaching and research and authorized to grant academic degrees [n UNIVERSITIES]\n",
  "UNIVOCAL": "having only one meaning [adj UNIVOCALLY] / a word with only one meaning [n -S]\n",
  "UNIVOCALLY": "UNIVOCAL, having only one meaning [adv]\n",
  "UNIVOCALS": "UNIVOCAL, a word with only one meaning [n]\n",
  "UNIVOLTINE": "having one brood a year [adj]\n",
  "UNJADED": "not jaded [adj]\n",
  "UNJAM": "to free from jamming [v UNJAMMED, UNJAMMING, UNJAMS]\n",
  "UNJAMMED": "UNJAM, to free from jamming [v]\n",
  "UNJAMMING": "UNJAM, to free from jamming [v]\n",
  "UNJAMS": "UNJAM, to free from jamming [v]\n",
  "UNJAUNDICED": "not jaundiced [adj]\n",
  "UNJEALOUS": "not jealous [adj]\n",
  "UNJOINED": "not joined [adj]\n",
  "UNJOINT": "to separate at a juncture [v -ED, -ING, -S]\n",
  "UNJOINTED": "UNJOINT, to separate at a juncture [v]\n",
  "UNJOINTING": "UNJOINT, to separate at a juncture [v]\n",
  "UNJOINTS": "UNJOINT, to separate at a juncture [v]\n",
  "UNJOYFUL": "not joyful [adj]\n",
  "UNJOYOUS": "not joyous [adj]\n",
  "UNJUDGED": "not judged [adj]\n",
  "UNJUST": "not just [adj UNJUSTER, UNJUSTEST, UNJUSTLY]\n",
  "UNJUSTER": "UNJUST, not just [adj]\n",
  "UNJUSTEST": "UNJUST, not just [adj]\n",
  "UNJUSTIFIABLE": "not justifiable [adj UNJUSTIFIABLY]\n",
  "UNJUSTIFIABLY": "UNJUSTIFIABLE, not justifiable [adv]\n",
  "UNJUSTIFIED": "not justified [adj]\n",
  "UNJUSTLY": "UNJUST, not just [adv]\n",
  "UNJUSTNESS": "the state of being unjust [n -ES]\n",
  "UNJUSTNESSES": "UNJUSTNESS, the state of being unjust [n]\n",
  "UNKED": "odd; strange; uncouth, also UNKET, UNKID [adj]\n",
  "UNKEELED": "not keeled [adj]\n",
  "UNKEMPT": "untidy [adj UNKEMPTLY]\n",
  "UNKEMPTLY": "UNKEMPT, untidy [adv]\n",
  "UNKEMPTNESS": "the state of being unkempt [n -ES]\n",
  "UNKEMPTNESSES": "UNKEMPTNESS, the state of being unkempt [n]\n",
  "UNKEND": "unknown; strange, also UNKENNED, UNKENT [adj]\n",
  "UNKENNED": "unknown, strange, also UNKEND, UNKENT [adj]\n",
  "UNKENNEL": "to release from a kennel [v UNKENNELED or UNKENNELLED, UNKENNELING or UNKENNELLING, UNKENNELS]\n",
  "UNKENNELED": "UNKENNEL, to release from a kennel [v]\n",
  "UNKENNELING": "UNKENNEL, to release from a kennel [v]\n",
  "UNKENNELLED": "UNKENNEL, to release from a kennel [v]\n",
  "UNKENNELLING": "UNKENNEL, to release from a kennel [v]\n",
  "UNKENNELS": "UNKENNEL, to release from a kennel [v]\n",
  "UNKENT": "unknown; strange, also UNKEND, UNKENNED [adj]\n",
  "UNKEPT": "not kept [adj]\n",
  "UNKET": "odd; strange; uncouth, also UNKED, UNKID [adj]\n",
  "UNKID": "odd; strange; uncouth, also UNKED, UNKET [adj]\n",
  "UNKIND": "not kind [adj UNKINDER, UNKINDEST, UNKINDLY]\n",
  "UNKINDER": "UNKIND, not kind [adj]\n",
  "UNKINDEST": "UNKIND, not kind [adj]\n",
  "UNKINDLED": "not kindled [adj]\n",
  "UNKINDLIER": "UNKINDLY, UNKIND, not kind [adv]\n",
  "UNKINDLIEST": "UNKINDLY, UNKIND, not kind [adv]\n",
  "UNKINDLINESS": "the state of being unkindly [n -ES]\n",
  "UNKINDLINESSES": "UNKINDLINESS, the state of being unkindly [n]\n",
  "UNKINDLY": "UNKIND, not kind [adv]\n",
  "UNKINDNESS": "the state of being unkind [n -ES]\n",
  "UNKINDNESSES": "UNKINDNESS, the state of being unkind [n]\n",
  "UNKING": "to deprive of a king [v -ED, -ING, -S]\n",
  "UNKINGED": "UNKING, to deprive of a king [v]\n",
  "UNKINGING": "UNKING, to deprive of a king [v]\n",
  "UNKINGLIER": "UNKINGLY, not kingly [adj]\n",
  "UNKINGLIEST": "UNKINGLY, not kingly [adj]\n",
  "UNKINGLIKE": "not like a king [adj]\n",
  "UNKINGLY": "not kingly [adj UNKINGLIER, UNKINGLIEST]\n",
  "UNKINGS": "UNKING, to deprive of a king [v]\n",
  "UNKINK": "to remove curls from [v -ED, -ING, -S]\n",
  "UNKINKED": "UNKINK, to remove curls from [v]\n",
  "UNKINKING": "UNKINK, to remove curls from [v]\n",
  "UNKINKS": "UNKINK, to remove curls from [v]\n",
  "UNKISS": "(Shakespeare) to cancel or annul what was done or sealed by a kiss [v UNKISSED, UNKISSING, UNKISSES]\n",
  "UNKISSED": "UNKISS, (Shakespeare) to cancel or annul what was done or sealed by a kiss [v]\n",
  "UNKISSES": "UNKISS, (Shakespeare) to cancel or annul what was done or sealed by a kiss [v]\n",
  "UNKISSING": "UNKISS, (Shakespeare) to cancel or annul what was done or sealed by a kiss [v]\n",
  "UNKNELLED": "without tolling [adj]\n",
  "UNKNIGHT": "to divest of knighthood [v -ED, -ING, -S]\n",
  "UNKNIGHTED": "UNKNIGHT, to divest of knighthood [v]\n",
  "UNKNIGHTING": "UNKNIGHT, to divest of knighthood [v]\n",
  "UNKNIGHTLIER": "UNKNIGHTLY, not knightly [adj]\n",
  "UNKNIGHTLIEST": "UNKNIGHTLY, not knightly [adj]\n",
  "UNKNIGHTLINESS": "the state of being unknightly [n]\n",
  "UNKNIGHTLY": "not knightly [adj UNKNIGHTLIER, UNKNIGHTLIEST]\n",
  "UNKNIGHTS": "UNKNIGHT, to divest of knighthood [v]\n",
  "UNKNIT": "to undo or unravel what is knitted together [v UNKNITTED, UNKNITTING, UNKNITS]\n",
  "UNKNITS": "UNKNIT, to undo or unravel what is knitted together [v]\n",
  "UNKNITTED": "UNKNIT, to undo or unravel what is knitted together [v]\n",
  "UNKNITTING": "UNKNIT, to undo or unravel what is knitted together [v]\n",
  "UNKNOT": "to undo a knot in [v UNKNOTTED, UNKNOTTING, UNKNOTS]\n",
  "UNKNOTS": "UNKNOT, to undo a knot in [v]\n",
  "UNKNOTTED": "UNKNOT, to undo a knot in [v]\n",
  "UNKNOTTING": "UNKNOT, to undo a knot in [v]\n",
  "UNKNOWABILITIES": "UNKNOWABILITY, the state of being unknowable [n]\n",
  "UNKNOWABILITY": "the state of being unknowable [n UNKNOWABILITIES]\n",
  "UNKNOWABLE": "that cannot be known [adj UNKNOWABLY] / something that cannot be known [n -S]\n",
  "UNKNOWABLENESS": "UNKNOWABLE, that cannot be known [n]\n",
  "UNKNOWABLES": "UNKNOWABLE, something that cannot be known [n]\n",
  "UNKNOWABLY": "UNKNOWABLE, that cannot be known [adv]\n",
  "UNKNOWING": "ignorant, unaware [adj UNKNOWINGLY] / a state of not knowing [n -S]\n",
  "UNKNOWINGLY": "UNKNOWING, ignorant, unaware [adv]\n",
  "UNKNOWINGNESS": "the state of being unknowing [n -ES]\n",
  "UNKNOWINGNESSES": "UNKNOWINGNESS, the state of being unknowing [n]\n",
  "UNKNOWINGS": "UNKNOWING, a state of not knowing [n]\n",
  "UNKNOWLEDGEABLE": "not knowledgeable [adj]\n",
  "UNKNOWN": "something that is not known [n -S]\n",
  "UNKNOWNNESS": "the state of being unknown [n -ES]\n",
  "UNKNOWNNESSES": "UNKNOWNNESS, the state of being unknown [n]\n",
  "UNKNOWNS": "UNKNOWN, something that is not known [n]\n",
  "UNKOSHER": "not kosher [adj]\n",
  "UNLABELED": "(US) not labelled, also UNLABELLED [adj]\n",
  "UNLABELLED": "not labelled, also UNLABELED [adj]\n",
  "UNLABORED": "not laboured, also UNLABOURED [adj]\n",
  "UNLABORING": "not laboring [adj]\n",
  "UNLABORIOUS": "not laborious [adj]\n",
  "UNLABOURED": "not laboured, also UNLABORED [adj]\n",
  "UNLABOURING": "not labouring [adj]\n",
  "UNLACE": "to unfasten the laces of [v UNLACED or (Spenser) UNLAST, UNLASTE, UNLACING, UNLACES]\n",
  "UNLACED": "UNLACE, to unfasten the laces of [v]\n",
  "UNLACES": "UNLACE, to unfasten the laces of [v]\n",
  "UNLACING": "UNLACE, to unfasten the laces of [v]\n",
  "UNLADE": "to unload [v UNLADED, UNLADEN, UNLADING, UNLADES]\n",
  "UNLADED": "UNLADE, to unload [v]\n",
  "UNLADEN": "UNLADE, to unload [v]\n",
  "UNLADES": "UNLADE, to unload [v]\n",
  "UNLADING": "the act of unlading [n -S]\n",
  "UNLADINGS": "UNLADING, the act of unlading [n]\n",
  "UNLADYLIKE": "not ladylike [adj]\n",
  "UNLAID": "UNLAY, to untwist [v]\n",
  "UNLAMENTED": "not lamented [adj]\n",
  "UNLASH": "to untie the binding of [v -ED, -ING, -ES]\n",
  "UNLASHED": "UNLASH, to untie the binding of [v]\n",
  "UNLASHES": "UNLASH, to untie the binding of [v]\n",
  "UNLASHING": "UNLASH, to untie the binding of [v]\n",
  "UNLAST": "UNLACE, to unfasten the laces of [v]\n",
  "UNLASTE": "UNLACE, to unfasten the laces of [v]\n",
  "UNLATCH": "to undo a fastening on a door or gate [v -ED, -ING, -ES]\n",
  "UNLATCHED": "UNLATCH, to undo a fastening on a door or gate [v]\n",
  "UNLATCHES": "UNLATCH, to undo a fastening on a door or gate [v]\n",
  "UNLATCHING": "UNLATCH, to undo a fastening on a door or gate [v]\n",
  "UNLAUNDERED": "not laundered [adj]\n",
  "UNLAW": "to deprive of the authority or character of law [v -ED, -ING, -S]\n",
  "UNLAWED": "UNLAW, to deprive of the authority or character of law [v]\n",
  "UNLAWFUL": "not lawful [adj UNLAWFULLY]\n",
  "UNLAWFULLY": "UNLAWFUL, not lawful [adv]\n",
  "UNLAWFULNESS": "the state of being unlawful [n -ES]\n",
  "UNLAWFULNESSES": "UNLAWFULNESS, the state of being unlawful [n]\n",
  "UNLAWING": "UNLAW, to deprive of the authority or character of law [v]\n",
  "UNLAWS": "UNLAW, to deprive of the authority or character of law [v]\n",
  "UNLAY": "to untwist [v UNLAID, UNLAYING, UNLAYS]\n",
  "UNLAYING": "UNLAY, to untwist [v]\n",
  "UNLAYS": "UNLAY, to untwist [v]\n",
  "UNLEAD": "to remove the lead from [v -ED, -ING, -S]\n",
  "UNLEADED": "a product containing no lead [n -S]\n",
  "UNLEADEDS": "UNLEADED, a product containing no lead [n]\n",
  "UNLEADING": "UNLEAD, to remove the lead from [v]\n",
  "UNLEADS": "UNLEAD, to remove the lead from [v]\n",
  "UNLEAL": "(archaic) unfaithful [adj]\n",
  "UNLEARN": "to put out of one's memory [v UNLEARNED, UNLEARNT, UNLEARNING, UNLEARNS]\n",
  "UNLEARNABLE": "not learnable [adj]\n",
  "UNLEARNED": "UNLEARN, to put out of one's memory [v]\n",
  "UNLEARNEDLY": "UNLEARNED, UNLEARN, to put out of one's memory [adv]\n",
  "UNLEARNEDNESS": "the state of being unlearned [n -ES]\n",
  "UNLEARNEDNESSES": "UNLEARNEDNESS, the state of being unlearned [n]\n",
  "UNLEARNING": "UNLEARN, to put out of one's memory [v]\n",
  "UNLEARNS": "UNLEARN, to put out of one's memory [v]\n",
  "UNLEARNT": "UNLEARN, to put out of one's memory [v]\n",
  "UNLEASED": "not leased [adj]\n",
  "UNLEASH": "to free from a leash [v -ED, -ING, -ES]\n",
  "UNLEASHED": "UNLEASH, to free from a leash [v]\n",
  "UNLEASHES": "UNLEASH, to free from a leash [v]\n",
  "UNLEASHING": "UNLEASH, to free from a leash [v]\n",
  "UNLEAVENED": "not leavened [adj]\n",
  "UNLED": "not led [adj]\n",
  "UNLEISURED": "not having leisure [adj]\n",
  "UNLEISURELY": "not leisurely [adj]\n",
  "UNLESS": "except on the condition that [conj]\n",
  "UNLESSONED": "not educated [adj]\n",
  "UNLET": "not letted (of a property), also UNLETTED [adj]\n",
  "UNLETHAL": "not lethal [adj]\n",
  "UNLETTABLE": "that cannot be let [adj]\n",
  "UNLETTED": "not letted (of a property), also UNLET [adj]\n",
  "UNLETTERED": "lacking facility in reading and writing [adj]\n",
  "UNLEVEL": "to make uneven or no longer level [v UNLEVELED or UNLEVELLED, UNLEVELING or UNLEVELLING, UNLEVELS]\n",
  "UNLEVELED": "UNLEVEL, to make uneven or no longer level [v]\n",
  "UNLEVELING": "UNLEVEL, to make uneven or no longer level [v]\n",
  "UNLEVELLED": "UNLEVEL, to make uneven or no longer level [v]\n",
  "UNLEVELLING": "UNLEVEL, to make uneven or no longer level [v]\n",
  "UNLEVELS": "UNLEVEL, to make uneven or no longer level [v]\n",
  "UNLEVIED": "not levied [adj]\n",
  "UNLIBERATED": "not liberated [adj]\n",
  "UNLIBIDINOUS": "not libidinous [adj]\n",
  "UNLICENSED": "not licensed [adj]\n",
  "UNLICH": "(Spenser) unlike [adj]\n",
  "UNLICKED": "not licked [adj]\n",
  "UNLID": "to take the lid off [v UNLIDDED, UNLIDDING, UNLIDS]\n",
  "UNLIDDED": "UNLID, to take the lid off [v]\n",
  "UNLIDDING": "UNLID, to take the lid off [v]\n",
  "UNLIDS": "UNLID, to take the lid off [v]\n",
  "UNLIFELIKE": "not lifelike [adj]\n",
  "UNLIGHTED": "not lighted [adj]\n",
  "UNLIGHTENED": "not lightened [adj]\n",
  "UNLIGHTSOME": "(Milton) without light [adj]\n",
  "UNLIKABLE": "not capable of being liked, also UNLIKEABLE [adj]\n",
  "UNLIKE": "not like, also UNLICH [adj] / something unlike [n -S]\n",
  "UNLIKEABLE": "not capable of being liked, also UNLIKABLE [adj]\n",
  "UNLIKED": "not liked [adj]\n",
  "UNLIKELIER": "UNLIKELY, not likely [adj]\n",
  "UNLIKELIEST": "UNLIKELY, not likely [adj]\n",
  "UNLIKELIHOOD": "the state of being unlikely [n -S]\n",
  "UNLIKELIHOODS": "UNLIKELIHOOD, the state of being unlikely [n]\n",
  "UNLIKELINESS": "the state of being unlikely [n -ES]\n",
  "UNLIKELINESSES": "UNLIKELINESS, the state of being unlikely [n]\n",
  "UNLIKELY": "not likely [adj UNLIKELIER, UNLIKELIEST]\n",
  "UNLIKENESS": "lack of resemblance [n -ES]\n",
  "UNLIKENESSES": "UNLIKENESS, lack of resemblance [n]\n",
  "UNLIKES": "UNLIKE, something unlike [n]\n",
  "UNLIMBER": "to prepare for action [v -ED, -ING, -S]\n",
  "UNLIMBERED": "UNLIMBER, to prepare for action [v]\n",
  "UNLIMBERING": "UNLIMBER, to prepare for action [v]\n",
  "UNLIMBERS": "UNLIMBER, to prepare for action [v]\n",
  "UNLIME": "to free from lime [v UNLIMED, UNLIMING, UNLIMES]\n",
  "UNLIMED": "UNLIME, to free from lime [v]\n",
  "UNLIMES": "UNLIME, to free from lime [v]\n",
  "UNLIMING": "UNLIME, to free from lime [v]\n",
  "UNLIMITED": "not limited [adj UNLIMITEDLY]\n",
  "UNLIMITEDLY": "UNLIMITED, not limited [adv]\n",
  "UNLIMITEDNESS": "the state of being unlimited [n -ES]\n",
  "UNLIMITEDNESSES": "UNLIMITEDNESS, the state of being unlimited [n]\n",
  "UNLINE": "to remove the lining [v UNLINED, UNLINING, UNLINES]\n",
  "UNLINEAL": "not lineal [adj]\n",
  "UNLINED": "UNLINE, to remove the lining [v]\n",
  "UNLINES": "UNLINE, to remove the lining [v]\n",
  "UNLINING": "UNLINE, to remove the lining [v]\n",
  "UNLINK": "to unfasten the connecting devices [v -ED, -ING, -S]\n",
  "UNLINKED": "UNLINK, to unfasten the connecting devices [v]\n",
  "UNLINKING": "UNLINK, to unfasten the connecting devices [v]\n",
  "UNLINKS": "UNLINK, to unfasten the connecting devices [v]\n",
  "UNLIQUEFIED": "not liquefied [adj]\n",
  "UNLIQUIDATED": "not liquidated [adj]\n",
  "UNLIQUORED": "(Milton) not in liquor, sober [adj]\n",
  "UNLISTED": "not listed [adj]\n",
  "UNLISTENABLE": "not listenable [adj]\n",
  "UNLISTENED": "not listened to [adj]\n",
  "UNLISTENING": "not listening [adj]\n",
  "UNLIT": "not lit [adj]\n",
  "UNLITERARY": "not literary [adj]\n",
  "UNLIVABLE": "not capable of being lived, also UNLIVEABLE [adj]\n",
  "UNLIVE": "to live so as to make amends for [v UNLIVED, UNLIVING, UNLIVES]\n",
  "UNLIVEABLE": "not capable of being lived, also UNLIVABLE [adj]\n",
  "UNLIVED": "UNLIVE, to live so as to make amends for [v]\n",
  "UNLIVELIER": "UNLIVELY, not lively [adj]\n",
  "UNLIVELIEST": "UNLIVELY, not lively [adj]\n",
  "UNLIVELINESS": "the state of being unlively [n -ES]\n",
  "UNLIVELINESSES": "UNLIVELINESS, the state of being unlively [n]\n",
  "UNLIVELY": "not lively [adj UNLIVELIER, UNLIVELIEST]\n",
  "UNLIVES": "UNLIVE, to live so as to make amends for [v]\n",
  "UNLIVING": "UNLIVE, to live so as to make amends for [v]\n",
  "UNLOAD": "to remove cargo from [v -ED, -ING, -S]\n",
  "UNLOADED": "UNLOAD, to remove cargo from [v]\n",
  "UNLOADER": "one who unloads [n -S]\n",
  "UNLOADERS": "UNLOADER, one who unloads [n]\n",
  "UNLOADING": "the act of unloading [n -S]\n",
  "UNLOADINGS": "UNLOADING, the act of unloading [n]\n",
  "UNLOADS": "UNLOAD, to remove cargo from [v]\n",
  "UNLOBED": "not lobed [adj]\n",
  "UNLOCALISED": "not localised, also UNLOCALIZED [adj]\n",
  "UNLOCALIZED": "not localized, also UNLOCALISED [adj]\n",
  "UNLOCATED": "not located or placed; not fixed in a place [adj]\n",
  "UNLOCK": "to unfasten the lock of [v -ED, -ING, -S]\n",
  "UNLOCKABLE": "not lockable [adj]\n",
  "UNLOCKED": "UNLOCK, to unfasten the lock of [v]\n",
  "UNLOCKING": "UNLOCK, to unfasten the lock of [v]\n",
  "UNLOCKS": "UNLOCK, to unfasten the lock of [v]\n",
  "UNLOGICAL": "not logical, also ILLOGICAL [adj]\n",
  "UNLOOKED": "not looked [adj]\n",
  "UNLOOSE": "to set free, also UNLOOSEN [v UNLOOSED, UNLOOSING, UNLOOSES]\n",
  "UNLOOSED": "UNLOOSE, to set free, also UNLOOSEN [v]\n",
  "UNLOOSEN": "to set free, also UNLOOSE [v -ED, -ING, -S]\n",
  "UNLOOSENED": "UNLOOSEN, to set free, also UNLOOSE [v]\n",
  "UNLOOSENING": "UNLOOSEN, to set free, also UNLOOSE [v]\n",
  "UNLOOSENS": "UNLOOSEN, to set free, also UNLOOSE [v]\n",
  "UNLOOSES": "UNLOOSE, to set free, also UNLOOSEN [v]\n",
  "UNLOOSING": "UNLOOSE, to set free, also UNLOOSEN [v]\n",
  "UNLOPPED": "not lopped [adj]\n",
  "UNLORD": "to strip of the dignity of a lord [v -ED, -ING, -S]\n",
  "UNLORDED": "UNLORD, to strip of the dignity of a lord [v]\n",
  "UNLORDING": "UNLORD, to strip of the dignity of a lord [v]\n",
  "UNLORDLIER": "UNLORDLY, not lordly [adj]\n",
  "UNLORDLIEST": "UNLORDLY, not lordly [adj]\n",
  "UNLORDLY": "not lordly [adj UNLORDLIER, UNLORDLIEST]\n",
  "UNLORDS": "UNLORD, to strip of the dignity of a lord [v]\n",
  "UNLOSABLE": "that cannot be lost [adj]\n",
  "UNLOST": "not lost [adj]\n",
  "UNLOVABLE": "not capable of being loved, also UNLOVEABLE [adj]\n",
  "UNLOVE": "to cease to love [v UNLOVED, UNLOVING, UNLOVES]\n",
  "UNLOVEABLE": "not capable of being loved, also UNLOVABLE [adj]\n",
  "UNLOVED": "UNLOVE, to cease to love [v]\n",
  "UNLOVELIER": "UNLOVELY, not lovely [adj]\n",
  "UNLOVELIEST": "UNLOVELY, not lovely [adj]\n",
  "UNLOVELINESS": "the state of being unlovely [n -ES]\n",
  "UNLOVELINESSES": "UNLOVELINESS, the state of being unlovely [n]\n",
  "UNLOVELY": "not lovely [adj UNLOVELIER, UNLOVELIEST]\n",
  "UNLOVERLIKE": "not like a lover [adj]\n",
  "UNLOVES": "UNLOVE, to cease to love [v]\n",
  "UNLOVING": "UNLOVE, to cease to love [v]\n",
  "UNLOVINGLY": "UNLOVING, UNLOVE, to cease to love [adv]\n",
  "UNLOVINGNESS": "the state of being unloving [n -ES]\n",
  "UNLOVINGNESSES": "UNLOVINGNESS, the state of being unloving [n]\n",
  "UNLUCKIER": "UNLUCKY, not lucky [adj]\n",
  "UNLUCKIEST": "UNLUCKY, not lucky [adj]\n",
  "UNLUCKILY": "UNLUCKY, not lucky [adv]\n",
  "UNLUCKINESS": "the state of being unlucky [n -ES]\n",
  "UNLUCKINESSES": "UNLUCKINESS, the state of being unlucky [n]\n",
  "UNLUCKY": "not lucky [adj UNLUCKIER, UNLUCKIEST, UNLUCKILY]\n",
  "UNLUXURIANT": "not luxuriant [adj]\n",
  "UNLUXURIOUS": "not luxurious [adj]\n",
  "UNLYRICAL": "not lyrical [adj]\n",
  "UNMACADAMISED": "not macadamised, also UNMACADAMIZED [adj]\n",
  "UNMACADAMIZED": "not macadamized, also UNMACADAMISED [adj]\n",
  "UNMACHO": "not macho [adj]\n",
  "UNMADE": "UNMAKE, to destroy [v]\n",
  "UNMAGNIFIED": "not magnified [adj]\n",
  "UNMAIDENLY": "not like a maiden [adj]\n",
  "UNMAILABLE": "that cannot be sent by mail [adj]\n",
  "UNMAILED": "not sent by mail [adj]\n",
  "UNMAIMED": "not maimed [adj]\n",
  "UNMAINTAINABLE": "not maintainable [adj]\n",
  "UNMAINTAINED": "not maintained [adj]\n",
  "UNMAKABLE": "that cannot be made [adj]\n",
  "UNMAKE": "to destroy [v UNMADE, UNMAKING, UNMAKES]\n",
  "UNMAKER": "one who unmakes [n -S]\n",
  "UNMAKERS": "UNMAKER, one who unmakes [n]\n",
  "UNMAKES": "UNMAKE, to destroy [v]\n",
  "UNMAKING": "the act of undoing [n -S]\n",
  "UNMAKINGS": "UNMAKING, the act of undoing [n]\n",
  "UNMALICIOUS": "not malicious [adj UNMALICIOUSLY]\n",
  "UNMALICIOUSLY": "UNMALICIOUS, not malicious [adv]\n",
  "UNMALLEABILITY": "the quality of being unmalleable [n]\n",
  "UNMALLEABLE": "not malleable [adj]\n",
  "UNMAN": "to deprive of courage [v UNMANNED, UNMANNING, UNMANS]\n",
  "UNMANACLE": "to free from manacles [v UNMANACLED, UNMANACLING, UNMANACLES]\n",
  "UNMANACLED": "UNMANACLE, to free from manacles [v]\n",
  "UNMANACLES": "UNMANACLE, to free from manacles [v]\n",
  "UNMANACLING": "UNMANACLE, to free from manacles [v]\n",
  "UNMANAGEABLE": "not capable of being managed [adj UNMANAGEABLY]\n",
  "UNMANAGEABLY": "UNMANAGEABLE, not capable of being managed [adv]\n",
  "UNMANAGED": "not managed [adj]\n",
  "UNMANFUL": "not manful [adj UNMANFULLY]\n",
  "UNMANFULLY": "UNMANFUL, not manful [adv]\n",
  "UNMANIPULATED": "not manipulated [adj]\n",
  "UNMANLIER": "UNMANLY, not manly [adj]\n",
  "UNMANLIEST": "UNMANLY, not manly [adj]\n",
  "UNMANLIKE": "not like a man [adj]\n",
  "UNMANLINESS": "the state of being unmanly [n -ES]\n",
  "UNMANLINESSES": "UNMANLINESS, the state of being unmanly [n]\n",
  "UNMANLY": "not manly [adj UNMANLIER, UNMANLIEST]\n",
  "UNMANNED": "UNMAN, to deprive of courage [v]\n",
  "UNMANNERED": "marked by a lack of good manners [adj UNMANNEREDLY]\n",
  "UNMANNEREDLY": "UNMANNERED, marked by a lack of good manners [adv]\n",
  "UNMANNERLIER": "UNMANNERLY, not mannerly [adj]\n",
  "UNMANNERLIEST": "UNMANNERLY, not mannerly [adj]\n",
  "UNMANNERLINESS": "the state of being unmannerly [n]\n",
  "UNMANNERLY": "not mannerly [adj UNMANNERLIER, UNMANNERLIEST]\n",
  "UNMANNING": "UNMAN, to deprive of courage [v]\n",
  "UNMANNISH": "not mannish [adj]\n",
  "UNMANS": "UNMAN, to deprive of courage [v]\n",
  "UNMANTLE": "to remove the mantle from [v UNMANTLED, UNMANTLING, UNMANTLES]\n",
  "UNMANTLED": "UNMANTLE, to remove the mantle from [v]\n",
  "UNMANTLES": "UNMANTLE, to remove the mantle from [v]\n",
  "UNMANTLING": "UNMANTLE, to remove the mantle from [v]\n",
  "UNMANUFACTURED": "not manufactured [adj]\n",
  "UNMANURED": "not having had manure applied [adj]\n",
  "UNMAPPED": "not mapped [adj]\n",
  "UNMARD": "(Spenser) unmarred [adj]\n",
  "UNMARKED": "not marked [adj]\n",
  "UNMARKETABLE": "not marketable [adj]\n",
  "UNMARRED": "not marred [adj]\n",
  "UNMARRIABLE": "(obsolete) unmarriageable [adj]\n",
  "UNMARRIAGEABLE": "not marriageable [adj]\n",
  "UNMARRIED": "not married [adj] / one who is unmarried [n -S]\n",
  "UNMARRIEDS": "UNMARRIED, one who is unmarried [n]\n",
  "UNMARRIES": "UNMARRY, to dissolve the marriage of [v]\n",
  "UNMARRY": "to dissolve the marriage of [v UNMARRIED, UNMARRYING, UNMARRIES]\n",
  "UNMARRYING": "UNMARRY, to dissolve the marriage of [v]\n",
  "UNMASCULINE": "not masculine [adj]\n",
  "UNMASK": "to remove a mask from [v -ED, -ING, -S]\n",
  "UNMASKED": "UNMASK, to remove a mask from [v]\n",
  "UNMASKER": "one who unmasks [n -S]\n",
  "UNMASKERS": "UNMASKER, one who unmasks [n]\n",
  "UNMASKING": "the act of unmasking [n -S]\n",
  "UNMASKINGS": "UNMASKING, the act of unmasking [n]\n",
  "UNMASKS": "UNMASK, to remove a mask from [v]\n",
  "UNMASTERED": "not mastered [adj]\n",
  "UNMATCHABLE": "not matchable [adj]\n",
  "UNMATCHED": "not matched [adj]\n",
  "UNMATCHING": "not matching [adj]\n",
  "UNMATED": "not mated [adj]\n",
  "UNMATERIAL": "not material; immaterial [adj]\n",
  "UNMATERIALISED": "not materialised, also UNMATERIALIZED [adj]\n",
  "UNMATERIALIZED": "not materialized, also UNMATERIALISED [adj]\n",
  "UNMATERNAL": "not maternal [adj]\n",
  "UNMATHEMATICAL": "not mathematical [adj]\n",
  "UNMATRICULATED": "not matriculated [adj]\n",
  "UNMATTED": "not matted [adj]\n",
  "UNMATURED": "not matured [adj]\n",
  "UNMEANING": "having no meaning or signification; as, unmeaning words [adj UNMEANINGLY]\n",
  "UNMEANINGLY": "UNMEANING, having no meaning or signification; as, unmeaning words [adv]\n",
  "UNMEANINGNESS": "the state of being unmeaning [n -ES]\n",
  "UNMEANINGNESSES": "UNMEANINGNESS, the state of being unmeaning [n]\n",
  "UNMEANT": "not meant [adj]\n",
  "UNMEASURABLE": "not capable of being measured [adj UNMEASURABLY]\n",
  "UNMEASURABLY": "UNMEASURABLE, not capable of being measured [adv]\n",
  "UNMEASURED": "not limited or known by measurement [adj UNMEASUREDLY]\n",
  "UNMEASUREDLY": "UNMEASURED, not limited or known by measurement [adv]\n",
  "UNMECHANIC": "(archaic) unmechanical [adj]\n",
  "UNMECHANICAL": "not mechanical [adj]\n",
  "UNMECHANISE": "(Sterne) to disorganise, also UNMECHANIZE [v UNMECHANISED, UNMECHANISING, UNMECHANISES]\n",
  "UNMECHANISED": "UNMECHANISE, (Sterne) to disorganise, also UNMECHANIZE [v]\n",
  "UNMECHANISES": "UNMECHANISE, (Sterne) to disorganise, also UNMECHANIZE [v]\n",
  "UNMECHANISING": "UNMECHANISE, (Sterne) to disorganise, also UNMECHANIZE [v]\n",
  "UNMECHANIZE": "(Sterne) to disorganise, also UNMECHANISE [v UNMECHANIZED, UNMECHANIZING, UNMECHANIZES]\n",
  "UNMECHANIZED": "UNMECHANIZE, (Sterne) to disorganise, also UNMECHANISE [v]\n",
  "UNMECHANIZES": "UNMECHANIZE, (Sterne) to disorganise, also UNMECHANISE [v]\n",
  "UNMECHANIZING": "UNMECHANIZE, (Sterne) to disorganise, also UNMECHANISE [v]\n",
  "UNMEDIATED": "not mediated [adj]\n",
  "UNMEDICATED": "not medicated [adj]\n",
  "UNMEDICINABLE": "not medicinable [adj]\n",
  "UNMEDITATED": "not meditated [adj]\n",
  "UNMEEK": "not meek [adj]\n",
  "UNMEET": "not suitable [adj UNMEETLY]\n",
  "UNMEETLY": "UNMEET, not suitable [adv]\n",
  "UNMEETNESS": "unsuitability [n -ES]\n",
  "UNMEETNESSES": "UNMEETNESS, unsuitability [n]\n",
  "UNMELLOW": "not mellow [adj]\n",
  "UNMELLOWED": "not mellowed [adj]\n",
  "UNMELODIOUS": "not melodious [adj]\n",
  "UNMELODIOUSNESS": "the state of being unmelodious [n]\n",
  "UNMELTED": "not melted [adj]\n",
  "UNMEMORABLE": "not memorable [adj UNMEMORABLY]\n",
  "UNMEMORABLY": "UNMEMORABLE, not memorable [adv]\n",
  "UNMENDED": "not mended [adj]\n",
  "UNMENTIONABLE": "that cannot be mentioned [adj UNMENTIONABLY]\n",
  "UNMENTIONABLES": "(colloquial) underwear [n]\n",
  "UNMENTIONABLY": "UNMENTIONABLE, that cannot be mentioned [adv]\n",
  "UNMENTIONED": "not mentioned [adj]\n",
  "UNMERCENARY": "not mercenary [adj]\n",
  "UNMERCHANTABLE": "not merchantable [adj]\n",
  "UNMERCIFUL": "not merciful [adj UNMERCIFULLY]\n",
  "UNMERCIFULLY": "UNMERCIFUL, not merciful [adv]\n",
  "UNMERCIFULNESS": "the state of being unmerciful [n]\n",
  "UNMERITABLE": "(Shakespeare) undeserving [adj]\n",
  "UNMERITED": "not merited [adj UNMERITEDLY]\n",
  "UNMERITEDLY": "UNMERITED, not merited [adv]\n",
  "UNMERITING": "undeserving [adj]\n",
  "UNMERRIER": "UNMERRY, not merry [adj]\n",
  "UNMERRIEST": "UNMERRY, not merry [adj]\n",
  "UNMERRY": "not merry [adj UNMERRIER, UNMERRIEST]\n",
  "UNMESH": "to disentangle [v -ED, -ING, -ES]\n",
  "UNMESHED": "UNMESH, to disentangle [v]\n",
  "UNMESHES": "UNMESH, to disentangle [v]\n",
  "UNMESHING": "UNMESH, to disentangle [v]\n",
  "UNMET": "not met [adj]\n",
  "UNMETABOLISED": "not metabolised, also UNMETABOLIZED [adj]\n",
  "UNMETABOLIZED": "not metabolized, also UNMETABOLISED [adj]\n",
  "UNMETALLED": "not metalled [adj]\n",
  "UNMETAPHORICAL": "not metaphorical [adj]\n",
  "UNMETAPHYSICAL": "not metaphysical [adj]\n",
  "UNMETED": "not meted [adj]\n",
  "UNMETERED": "not metered [adj]\n",
  "UNMETHODICAL": "not methodical [adj]\n",
  "UNMETHODISED": "not methodised, also UNMETHODIZED [adj]\n",
  "UNMETHODIZED": "not methodized, also UNMETHODISED [adj]\n",
  "UNMETRICAL": "not metrical [adj]\n",
  "UNMEW": "to release from confinement or restraint [v -ED, -ING, -S]\n",
  "UNMEWED": "UNMEW, to release from confinement or restraint [v]\n",
  "UNMEWING": "UNMEW, to release from confinement or restraint [v]\n",
  "UNMEWS": "UNMEW, to release from confinement or restraint [v]\n",
  "UNMILITARY": "not military [adj]\n",
  "UNMILKED": "not milked [adj]\n",
  "UNMILLED": "not milled [adj]\n",
  "UNMINDED": "not minded [adj]\n",
  "UNMINDFUL": "not mindful [adj UNMINDFULLY]\n",
  "UNMINDFULLY": "UNMINDFUL, not mindful [adv]\n",
  "UNMINDFULNESS": "the state of being unmindful [n -ES]\n",
  "UNMINDFULNESSES": "UNMINDFULNESS, the state of being unmindful [n]\n",
  "UNMINED": "not yet mined [adj]\n",
  "UNMINGLE": "to separate things that are mixed [v UNMINGLED, UNMINGLING, UNMINGLES]\n",
  "UNMINGLED": "UNMINGLE, to separate things that are mixed [v]\n",
  "UNMINGLES": "UNMINGLE, to separate things that are mixed [v]\n",
  "UNMINGLING": "UNMINGLE, to separate things that are mixed [v]\n",
  "UNMINISTERIAL": "not ministerial [adj]\n",
  "UNMIRACULOUS": "not miraculous [adj]\n",
  "UNMIRIER": "UNMIRY, not miry [adj]\n",
  "UNMIRIEST": "UNMIRY, not miry [adj]\n",
  "UNMIRY": "not miry [adj UNMIRIER, UNMIRIEST]\n",
  "UNMISSABLE": "that cannot be missed [adj]\n",
  "UNMISSED": "not missed [adj]\n",
  "UNMISTAKABLE": "not capable of being mistaken or misunderstood, also UNMISTAKEABLE [adj UNMISTAKABLY]\n",
  "UNMISTAKABLY": "UNMISTAKABLE, not capable of being mistaken or misunderstood, also UNMISTAKEABLE [adv]\n",
  "UNMISTAKEABLE": "that cannot be mistaken, also UNMISTAKABLE [adj UNMISTAKEABLY]\n",
  "UNMISTAKEABLY": "UNMISTAKEABLE, that cannot be mistaken, also UNMISTAKABLE [adv]\n",
  "UNMISTRUSTFUL": "not mistrustful [adj]\n",
  "UNMITER": "to depose from the rank of bishop, also UNMITRE [v -ED, -ING, -S]\n",
  "UNMITERED": "UNMITER, to depose from the rank of bishop, also UNMITRE [v]\n",
  "UNMITERING": "UNMITER, to depose from the rank of bishop, also UNMITRE [v]\n",
  "UNMITERS": "UNMITER, to depose from the rank of bishop, also UNMITRE [v]\n",
  "UNMITIGABLE": "that cannot be mitigated [adj UNMITIGABLY]\n",
  "UNMITIGABLY": "UNMITIGABLE, that cannot be mitigated [adv]\n",
  "UNMITIGATED": "not lessened [adj UNMITIGATEDLY]\n",
  "UNMITIGATEDLY": "UNMITIGATED, not lessened [adv]\n",
  "UNMITIGATEDNESS": "the state of being unmitigated [n]\n",
  "UNMITRE": "to depose from the rank of bishop, also UNMITER [v UNMITRED, UNMITRING, UNMITRES]\n",
  "UNMITRED": "UNMITRE, to depose from the rank of bishop, also UNMITER [v]\n",
  "UNMITRES": "UNMITRE, to depose from the rank of bishop, also UNMITER [v]\n",
  "UNMITRING": "UNMITRE, to depose from the rank of bishop, also UNMITER [v]\n",
  "UNMIX": "to separate from a mixture [v UNMIXED, UNMIXT, UNMIXING, UNMIXES]\n",
  "UNMIXABLE": "that cannot be mixed [adj]\n",
  "UNMIXED": "UNMIX, to separate from a mixture [v]\n",
  "UNMIXEDLY": "UNMIXED, UNMIX, to separate from a mixture [adv]\n",
  "UNMIXES": "UNMIX, to separate from a mixture [v]\n",
  "UNMIXING": "UNMIX, to separate from a mixture [v]\n",
  "UNMIXT": "UNMIX, to separate from a mixture [v]\n",
  "UNMOANED": "not lamented [adj]\n",
  "UNMODERATED": "not moderated [adj]\n",
  "UNMODERNISED": "not modernised, also UNMODERNIZED [adj]\n",
  "UNMODERNIZED": "not modernized, also UNMODERNISED [adj]\n",
  "UNMODIFIABLE": "not modifiable [adj]\n",
  "UNMODIFIED": "not modified [adj]\n",
  "UNMODISH": "not modish [adj]\n",
  "UNMODULATED": "not modulated [adj]\n",
  "UNMOISTENED": "not moistened [adj]\n",
  "UNMOLD": "to change the form of; to reduce from any form, also UNMOULD [v -ED, -ING, -S]\n",
  "UNMOLDED": "UNMOLD, to change the form of; to reduce from any form, also UNMOULD [v]\n",
  "UNMOLDING": "UNMOLD, to change the form of; to reduce from any form, also UNMOULD [v]\n",
  "UNMOLDS": "UNMOLD, to change the form of; to reduce from any form, also UNMOULD [v]\n",
  "UNMOLESTED": "not molested [adj]\n",
  "UNMOLTEN": "not molten [adj]\n",
  "UNMONEYED": "without money, also UNMONIED [adj]\n",
  "UNMONIED": "without money, also UNMONEYED [adj]\n",
  "UNMONITORED": "not monitored [adj]\n",
  "UNMOOR": "to release from moorings [v -ED, -ING, -S]\n",
  "UNMOORED": "UNMOOR, to release from moorings [v]\n",
  "UNMOORING": "UNMOOR, to release from moorings [v]\n",
  "UNMOORS": "UNMOOR, to release from moorings [v]\n",
  "UNMORAL": "lacking a sense of right and wrong [adj UNMORALLY]\n",
  "UNMORALISED": "not moralised upon, also UNMORALIZED [adj]\n",
  "UNMORALISING": "not moralising, also UNMORALIZING [adj]\n",
  "UNMORALITIES": "UNMORALITY, immorality [n]\n",
  "UNMORALITY": "immorality [n UNMORALITIES]\n",
  "UNMORALIZED": "not moralised upon, also UNMORALISED [adj]\n",
  "UNMORALIZING": "not moralizing, also UNMORALISING [adj]\n",
  "UNMORALLY": "UNMORAL, lacking a sense of right and wrong [adv]\n",
  "UNMORTGAGED": "not mortgaged [adj]\n",
  "UNMORTIFIED": "not mortified [adj]\n",
  "UNMORTISE": "to release from mortise [v UNMORTISED, UNMORTISING, UNMORTISES]\n",
  "UNMORTISED": "not mortised [adj]\n",
  "UNMORTISES": "UNMORTISE, to release from mortise [v]\n",
  "UNMORTISING": "UNMORTISE, to release from mortise [v]\n",
  "UNMOTHERLIER": "UNMOTHERLY, not motherly [adj]\n",
  "UNMOTHERLIEST": "UNMOTHERLY, not motherly [adj]\n",
  "UNMOTHERLY": "not motherly [adj UNMOTHERLIER, UNMOTHERLIEST]\n",
  "UNMOTIVATED": "not motivated [adj]\n",
  "UNMOTIVED": "without a motive [adj]\n",
  "UNMOULD": "to change the form of; to reduce from any form, also UNMOLD [v -ED, -ING, -S]\n",
  "UNMOULDED": "UNMOULD, to change the form of; to reduce from any form, also UNMOLD [v]\n",
  "UNMOULDING": "UNMOULD, to change the form of; to reduce from any form, also UNMOLD [v]\n",
  "UNMOULDS": "UNMOULD, to change the form of; to reduce from any form, also UNMOLD [v]\n",
  "UNMOUNT": "to dismount [v -ED, -ING, -S]\n",
  "UNMOUNTED": "UNMOUNT, to dismount [v]\n",
  "UNMOUNTING": "UNMOUNT, to dismount [v]\n",
  "UNMOUNTS": "UNMOUNT, to dismount [v]\n",
  "UNMOURNED": "not mourned [adj]\n",
  "UNMOVABLE": "that cannot be moved, also UNMOVEABLE [adj UNMOVABLY]\n",
  "UNMOVABLY": "UNMOVABLE, that cannot be moved, also UNMOVEABLE [adv]\n",
  "UNMOVEABLE": "that cannot be moved, also UNMOVABLE [adj UNMOVEABLY]\n",
  "UNMOVEABLY": "UNMOVEABLE, that cannot be moved, also UNMOVABLE [adv]\n",
  "UNMOVED": "not moved [adj UNMOVEDLY]\n",
  "UNMOVEDLY": "UNMOVED, not moved [adv]\n",
  "UNMOVING": "not moving [adj]\n",
  "UNMOWN": "not mown [adj]\n",
  "UNMUFFLE": "to free from something that muffles [v UNMUFFLED, UNMUFFLING, UNMUFFLES]\n",
  "UNMUFFLED": "UNMUFFLE, to free from something that muffles [v]\n",
  "UNMUFFLES": "UNMUFFLE, to free from something that muffles [v]\n",
  "UNMUFFLING": "UNMUFFLE, to free from something that muffles [v]\n",
  "UNMUNITIONED": "not munitioned [adj]\n",
  "UNMURMURING": "not murmuring [adj UNMURMURINGLY]\n",
  "UNMURMURINGLY": "UNMURMURING, not murmuring [adv]\n",
  "UNMUSICAL": "not musical [adj UNMUSICALLY]\n",
  "UNMUSICALLY": "UNMUSICAL, not musical [adv]\n",
  "UNMUSICALNESS": "UNMUSICAL, not musical [n]\n",
  "UNMUSICALNESSES": "UNMUSICALNESS, UNMUSICAL, not musical [n]\n",
  "UNMUTILATED": "not mutilated [adj]\n",
  "UNMUZZLE": "to remove a muzzle from [v UNMUZZLED, UNMUZZLING, UNMUZZLES]\n",
  "UNMUZZLED": "UNMUZZLE, to remove a muzzle from [v]\n",
  "UNMUZZLES": "UNMUZZLE, to remove a muzzle from [v]\n",
  "UNMUZZLING": "the act of removing a muzzle [n -S]\n",
  "UNMUZZLINGS": "UNMUZZLING, the act of removing a muzzle [n]\n",
  "UNMYELINATED": "lacking a myelin sheath [adj]\n",
  "UNNAIL": "to remove the nails from [v -ED, -ING, -S]\n",
  "UNNAILED": "UNNAIL, to remove the nails from [v]\n",
  "UNNAILING": "UNNAIL, to remove the nails from [v]\n",
  "UNNAILS": "UNNAIL, to remove the nails from [v]\n",
  "UNNAMABLE": "not capable of being named, also UNNAMEABLE [adj]\n",
  "UNNAMEABLE": "not capable of being named, also UNNAMABLE [adj]\n",
  "UNNAMED": "not named [adj]\n",
  "UNNANELD": "(Shakespeare) without extreme unction, also UNANELED [adj]\n",
  "UNNATIVE": "to no longer be a native or inhabitant of a place or country [v UNNATIVED, UNNATIVING, UNNATIVES]\n",
  "UNNATIVED": "UNNATIVE, to no longer be a native or inhabitant of a place or country [v]\n",
  "UNNATIVES": "UNNATIVE, to no longer be a native or inhabitant of a place or country [v]\n",
  "UNNATIVING": "UNNATIVE, to no longer be a native or inhabitant of a place or country [v]\n",
  "UNNATURAL": "not natural [adj UNNATURALLY]\n",
  "UNNATURALISE": "to undo the naturalisation of, also UNNATURALIZE [v UNNATURALISED, UNNATURALISING, UNNATURALISES]\n",
  "UNNATURALISED": "UNNATURALISE, to undo the naturalisation of, also UNNATURALIZE [v]\n",
  "UNNATURALISES": "UNNATURALISE, to undo the naturalisation of, also UNNATURALIZE [v]\n",
  "UNNATURALISING": "UNNATURALISE, to undo the naturalisation of, also UNNATURALIZE [v]\n",
  "UNNATURALIZE": "to undo the naturalisation of, also UNNATURALISE [v UNNATURALIZED, UNNATURALIZING, UNNATURALIZES]\n",
  "UNNATURALIZED": "UNNATURALIZE, to undo the naturalisation of, also UNNATURALISE [v]\n",
  "UNNATURALIZES": "UNNATURALIZE, to undo the naturalisation of, also UNNATURALISE [v]\n",
  "UNNATURALIZING": "UNNATURALIZE, to undo the naturalisation of, also UNNATURALISE [v]\n",
  "UNNATURALLY": "UNNATURAL, not natural [adv]\n",
  "UNNATURALNESS": "the state of being unnatural [n -ES]\n",
  "UNNATURALNESSES": "UNNATURALNESS, the state of being unnatural [n]\n",
  "UNNAVIGABLE": "not navigable [adj]\n",
  "UNNAVIGATED": "not navigated [adj]\n",
  "UNNEATH": "(dialect) underneath, also ANEATH, BENEATH, NEATH [prep]\n",
  "UNNECESSARILY": "UNNECESSARY, not necessary [adv]\n",
  "UNNECESSARINESS": "the state of being unnecessary [n]\n",
  "UNNECESSARY": "not necessary [adj UNNECESSARILY]\n",
  "UNNEEDED": "not needed [adj]\n",
  "UNNEEDFUL": "not needful [adj UNNEEDFULLY]\n",
  "UNNEEDFULLY": "UNNEEDFUL, not needful [adv]\n",
  "UNNEGOTIABLE": "not negotiable [adj]\n",
  "UNNEIGHBORED": "without neighbors, also UNNEIGHBOURED [adj]\n",
  "UNNEIGHBORLY": "not neighborly, also UNNEIGHBOURLY [adj]\n",
  "UNNEIGHBOURED": "without neighbours, also UNNEIGHBORED [adj]\n",
  "UNNEIGHBOURLY": "not like a neighbour, also UNNEIGHBORLY [adj]\n",
  "UNNERVE": "to deprive of courage [v UNNERVED, UNNERVING, UNNERVES]\n",
  "UNNERVED": "UNNERVE, to deprive of courage [v]\n",
  "UNNERVES": "UNNERVE, to deprive of courage [v]\n",
  "UNNERVING": "UNNERVE, to deprive of courage [v]\n",
  "UNNERVINGLY": "UNNERVING, UNNERVE, to deprive of courage [adv]\n",
  "UNNEST": "to turn out of a nest [v -ED, -ING, -S]\n",
  "UNNESTED": "UNNEST, to turn out of a nest [v]\n",
  "UNNESTING": "UNNEST, to turn out of a nest [v]\n",
  "UNNESTS": "UNNEST, to turn out of a nest [v]\n",
  "UNNETHES": "(archaic) with difficulty, hardly, also UNEATH, UNEATHES, UNETH [adv]\n",
  "UNNETTED": "not in a net [adj]\n",
  "UNNEUROTIC": "not neurotic [adj]\n",
  "UNNEWSWORTHIER": "UNNEWSWORTHY, not newsworthy [adj]\n",
  "UNNEWSWORTHIEST": "UNNEWSWORTHY, not newsworthy [adj]\n",
  "UNNEWSWORTHY": "not newsworthy [adj UNNEWSWORTHIER, UNNEWSWORTHIEST]\n",
  "UNNILHEXIUM": "a chemical element, aka seaborgium [n -S]\n",
  "UNNILHEXIUMS": "UNNILHEXIUM, a chemical element, aka seaborgium [n]\n",
  "UNNILPENTIUM": "a former name of the transuranic element dubnium [n -S]\n",
  "UNNILPENTIUMS": "UNNILPENTIUM, a former name of the transuranic element dubnium [n]\n",
  "UNNILQUADIUM": "a former name of the transuranic element rutherfordium [n -S]\n",
  "UNNILQUADIUMS": "UNNILQUADIUM, a former name of the transuranic element rutherfordium [n]\n",
  "UNNILSEPTIUM": "a former name of the transuranic element bohrium [n -S]\n",
  "UNNILSEPTIUMS": "UNNILSEPTIUM, a former name of the transuranic element bohrium [n]\n",
  "UNNOBLE": "to deprive of nobility [v UNNOBLED, UNNOBLING, UNNOBLES]\n",
  "UNNOBLED": "UNNOBLE, to deprive of nobility [v]\n",
  "UNNOBLES": "UNNOBLE, to deprive of nobility [v]\n",
  "UNNOBLING": "UNNOBLE, to deprive of nobility [v]\n",
  "UNNOISIER": "UNNOISY, not noisy [adj]\n",
  "UNNOISIEST": "UNNOISY, not noisy [adj]\n",
  "UNNOISY": "not noisy [adj UNNOISIER, UNNOISIEST]\n",
  "UNNOTED": "not noted [adj]\n",
  "UNNOTICEABLE": "not capable of being noticed [adj UNNOTICEABLY]\n",
  "UNNOTICEABLY": "UNNOTICEABLE, not capable of being noticed [adv]\n",
  "UNNOTICED": "not noticed [adj]\n",
  "UNNOTICING": "not noticing [adj]\n",
  "UNNOURISHED": "not nourished [adj]\n",
  "UNNOURISHING": "not nourishing [adj]\n",
  "UNNUANCED": "not nuanced [adj]\n",
  "UNNUMBERED": "uncounted, innumerable [adj]\n",
  "UNNURTURED": "not nurtured [adj]\n",
  "UNOAKED": "(of wine) not fermented in an oak cask [adj]\n",
  "UNOBEDIENT": "disobedient [adj]\n",
  "UNOBEYED": "not obeyed [adj]\n",
  "UNOBJECTIONABLE": "not objectionable [adj UNOBJECTIONABLY]\n",
  "UNOBJECTIONABLY": "UNOBJECTIONABLE, not objectionable [adv]\n",
  "UNOBLIGING": "not obliging [adj]\n",
  "UNOBNOXIOUS": "not obnoxious [adj]\n",
  "UNOBSCURED": "not obscured [adj]\n",
  "UNOBSERVABLE": "something that cannot be observed [n -S]\n",
  "UNOBSERVABLES": "UNOBSERVABLE, something that cannot be observed [n]\n",
  "UNOBSERVANCE": "lack of observance [n -S]\n",
  "UNOBSERVANCES": "UNOBSERVANCE, lack of observance [n]\n",
  "UNOBSERVANT": "not observant [adj]\n",
  "UNOBSERVED": "not observed [adj UNOBSERVEDLY]\n",
  "UNOBSERVEDLY": "UNOBSERVED, not observed [adv]\n",
  "UNOBSERVING": "not observing [adj]\n",
  "UNOBSTRUCTED": "not obstructed [adj]\n",
  "UNOBSTRUCTIVE": "not obstructive [adj]\n",
  "UNOBTAINABLE": "not obtainable [adj]\n",
  "UNOBTAINED": "not obtained [adj]\n",
  "UNOBTRUSIVE": "not obtrusive, also INOBTRUSIVE [adj UNOBTRUSIVELY]\n",
  "UNOBTRUSIVELY": "UNOBTRUSIVE, not obtrusive, also INOBTRUSIVE [adv]\n",
  "UNOBTRUSIVENESS": "the state of being unobtrusive [n]\n",
  "UNOBVIOUS": "not obvious [adj]\n",
  "UNOCCUPIED": "not occupied [adj]\n",
  "UNOFFENDED": "not offended [adj]\n",
  "UNOFFENDING": "not offending [adj]\n",
  "UNOFFENSIVE": "not offensive, also INOFFENSIVE [adj]\n",
  "UNOFFERED": "not offered [adj]\n",
  "UNOFFICERED": "without an officer [adj]\n",
  "UNOFFICIAL": "not official [adj UNOFFICIALLY]\n",
  "UNOFFICIALLY": "UNOFFICIAL, not official [adv]\n",
  "UNOFFICIOUS": "not officious [adj]\n",
  "UNOFTEN": "seldom [adv]\n",
  "UNOILED": "not oiled [adj]\n",
  "UNOPEN": "not open [adj]\n",
  "UNOPENABLE": "not openable [adj]\n",
  "UNOPENED": "not opened [adj]\n",
  "UNOPERATIVE": "not operative [adj]\n",
  "UNOPPOSED": "not opposed [adj]\n",
  "UNOPPOSING": "not opposing [adj]\n",
  "UNOPPRESSIVE": "not oppressive [adj]\n",
  "UNORDAINED": "not ordained [adj]\n",
  "UNORDER": "to countermand [v -ED, -ING, -S]\n",
  "UNORDERED": "UNORDER, to countermand [v]\n",
  "UNORDERING": "UNORDER, to countermand [v]\n",
  "UNORDERLY": "not orderly [adj]\n",
  "UNORDERS": "UNORDER, to countermand [v]\n",
  "UNORDINARY": "not ordinary [adj]\n",
  "UNORGANISED": "not organised [adj]\n",
  "UNORGANIZED": "not organized [adj]\n",
  "UNORIGINAL": "somehtign that is not an original [n -S]\n",
  "UNORIGINALITIES": "UNORIGINALITY, lack of originality [n]\n",
  "UNORIGINALITY": "lack of originality [n UNORIGINALITIES]\n",
  "UNORIGINALS": "UNORIGINAL, somehtign that is not an original [n]\n",
  "UNORIGINATE": "not originated [adj]\n",
  "UNORIGINATED": "not originated [adj]\n",
  "UNORNAMENTAL": "not ornamental [adj]\n",
  "UNORNAMENTED": "not ornamented [adj]\n",
  "UNORNATE": "not ornate [adj]\n",
  "UNORTHODOX": "not orthodox [adj UNORTHODOXLY]\n",
  "UNORTHODOXIES": "UNORTHODOXY, the state of being unorthodox [n]\n",
  "UNORTHODOXLY": "UNORTHODOX, not orthodox [adv]\n",
  "UNORTHODOXY": "the state of being unorthodox [n UNORTHODOXIES]\n",
  "UNOSSIFIED": "destitute of a bony structure [adj]\n",
  "UNOSTENTATIOUS": "not ostentatious [adj]\n",
  "UNOVERCOME": "not overcome [adj]\n",
  "UNOVERTHROWN": "not overthrown [adj]\n",
  "UNOWED": "not due [adj]\n",
  "UNOWNED": "not owned [adj]\n",
  "UNOXIDISED": "not oxidised, also UNOXIDIZED [adj]\n",
  "UNOXIDIZED": "not oxidized, also UNOXIDISED [adj]\n",
  "UNOXYGENATED": "not oxygenated [adj]\n",
  "UNPACED": "without a pacesetter [adj]\n",
  "UNPACIFIED": "not pacified [adj]\n",
  "UNPACK": "to remove the contents of [v -ED, -ING, -S]\n",
  "UNPACKED": "UNPACK, to remove the contents of [v]\n",
  "UNPACKER": "one that unpacks [n -S]\n",
  "UNPACKERS": "UNPACKER, one that unpacks [n]\n",
  "UNPACKING": "the act of unpacking [n -S]\n",
  "UNPACKINGS": "UNPACKING, the act of unpacking [n]\n",
  "UNPACKS": "UNPACK, to remove the contents of [v]\n",
  "UNPADDED": "not padded [adj]\n",
  "UNPAGED": "having no page numbers [adj]\n",
  "UNPAID": "UNPAY, to make good, do away by payment [v]\n",
  "UNPAINED": "not pained [adj]\n",
  "UNPAINFUL": "not painful [adj]\n",
  "UNPAINT": "to remove the paint from [v -ED, -ING, -S]\n",
  "UNPAINTABLE": "not capable of being painted [adj]\n",
  "UNPAINTED": "UNPAINT, to remove the paint from [v]\n",
  "UNPAINTING": "UNPAINT, to remove the paint from [v]\n",
  "UNPAINTS": "UNPAINT, to remove the paint from [v]\n",
  "UNPAIRED": "not paired [adj]\n",
  "UNPALATABILITY": "the state of being unpalatable [n]\n",
  "UNPALATABLE": "not palatable [adj UNPALATABLY]\n",
  "UNPALATABLY": "UNPALATABLE, not palatable [adv]\n",
  "UNPALSIED": "not palsied [adj]\n",
  "UNPAMPERED": "not pampered [adj]\n",
  "UNPANEL": "to unsaddle, also UNPANNEL [v UNPANELLED, UNPANELLING, UNPANELS]\n",
  "UNPANELLED": "UNPANEL, to unsaddle, also UNPANNEL [v]\n",
  "UNPANELLING": "UNPANEL, to unsaddle, also UNPANNEL [v]\n",
  "UNPANELS": "UNPANEL, to unsaddle, also UNPANNEL [v]\n",
  "UNPANGED": "without pangs [adj]\n",
  "UNPANNEL": "to unsaddle, also UNPANEL [v UNPANNELLED, UNPANNELLING, UNPANNELS]\n",
  "UNPANNELLED": "UNPANNEL, to unsaddle, also UNPANEL [v]\n",
  "UNPANNELLING": "UNPANNEL, to unsaddle, also UNPANEL [v]\n",
  "UNPANNELS": "UNPANNEL, to unsaddle, also UNPANEL [v]\n",
  "UNPAPER": "to remove paper from [v -ED, -ING, -S]\n",
  "UNPAPERED": "UNPAPER, to remove paper from [v]\n",
  "UNPAPERING": "UNPAPER, to remove paper from [v]\n",
  "UNPAPERS": "UNPAPER, to remove paper from [v]\n",
  "UNPARADISE": "to deprive of happiness like that of paradise [v UNPARADISED, UNPARADISING, UNPARADISES]\n",
  "UNPARADISED": "UNPARADISE, to deprive of happiness like that of paradise [v]\n",
  "UNPARADISES": "UNPARADISE, to deprive of happiness like that of paradise [v]\n",
  "UNPARADISING": "UNPARADISE, to deprive of happiness like that of paradise [v]\n",
  "UNPARAGONED": "unmatched [adj]\n",
  "UNPARALLEL": "not parallel [adj]\n",
  "UNPARALLELED": "having no parallel [adj]\n",
  "UNPARASITISED": "not parasitised, also UNPARASITIZED [adj]\n",
  "UNPARASITIZED": "not parasitized, also UNPARASITISED [adj]\n",
  "UNPARDONABLE": "not pardonable [adj UNPARDONABLY]\n",
  "UNPARDONABLY": "UNPARDONABLE, not pardonable [adv]\n",
  "UNPARDONED": "not pardoned [adj]\n",
  "UNPARDONING": "not pardoning [adj]\n",
  "UNPARED": "of fruit, not having the skin removed [adj]\n",
  "UNPARENTAL": "not parental [adj]\n",
  "UNPARENTED": "having no parent, or no acknowledged parent [adj]\n",
  "UNPARLIAMENTARY": "contrary to the practice of parliamentary bodies [adj]\n",
  "UNPARTED": "not parted [adj]\n",
  "UNPARTIAL": "impartial [adj]\n",
  "UNPASSABLE": "impassable [adj]\n",
  "UNPASSABLENESS": "the state of being unpassable [n]\n",
  "UNPASSIONATE": "not passionate [adj]\n",
  "UNPASSIONED": "without passions [adj]\n",
  "UNPASTEURISED": "not pasteurised, also UNPASTEURIZED [adj]\n",
  "UNPASTEURIZED": "not pasteurized, also UNPASTEURISED [adj]\n",
  "UNPASTORAL": "not pastoral [adj]\n",
  "UNPASTURED": "not pastured [adj]\n",
  "UNPATCHED": "not patched [adj]\n",
  "UNPATENTABLE": "not patentable [adj]\n",
  "UNPATENTED": "not patented [adj]\n",
  "UNPATHED": "not pathed [adj]\n",
  "UNPATHETIC": "not pathetic [adj]\n",
  "UNPATHWAYED": "without paths [adj]\n",
  "UNPATRIOTIC": "not patriotic [adj UNPATRIOTICALLY]\n",
  "UNPATRIOTICALLY": "UNPATRIOTIC, not patriotic [adv]\n",
  "UNPATRONISED": "not patronised, also UNPATRONIZED [adj]\n",
  "UNPATRONIZED": "not patronized, also UNPATRONISED [adj]\n",
  "UNPATTERNED": "not patterned [adj]\n",
  "UNPAVED": "not paved [adj]\n",
  "UNPAVILIONED": "not pavilioned [adj]\n",
  "UNPAY": "to make good, do away by payment [v UNPAID, UNPAYING, UNPAYS]\n",
  "UNPAYABLE": "that cannot be payed [adj]\n",
  "UNPAYING": "UNPAY, to make good, do away by payment [v]\n",
  "UNPAYS": "UNPAY, to make good, do away by payment [v]\n",
  "UNPEACEABLE": "not peaceable [adj]\n",
  "UNPEACEABLENESS": "the state of being unpeaceable [n]\n",
  "UNPEACEFUL": "not peaceful [adj UNPEACEFULLY]\n",
  "UNPEACEFULLY": "UNPEACEFUL, not peaceful [adv]\n",
  "UNPEDANTIC": "not pedantic [adj]\n",
  "UNPEDIGREED": "without a pedigree [adj]\n",
  "UNPEELED": "not peeled [adj]\n",
  "UNPEERABLE": "incapable of having a peer, or equal [adj]\n",
  "UNPEERED": "unequalled [adj]\n",
  "UNPEG": "to remove the pegs from [v UNPEGGED, UNPEGGING, UNPEGS]\n",
  "UNPEGGED": "UNPEG, to remove the pegs from [v]\n",
  "UNPEGGING": "UNPEG, to remove the pegs from [v]\n",
  "UNPEGS": "UNPEG, to remove the pegs from [v]\n",
  "UNPEN": "to release from confinement [v UNPENNED, UNPENT, UNPENNING, UNPENS]\n",
  "UNPENNED": "UNPEN, to release from confinement [v]\n",
  "UNPENNIED": "without pennies [adj]\n",
  "UNPENNING": "UNPEN, to release from confinement [v]\n",
  "UNPENS": "UNPEN, to release from confinement [v]\n",
  "UNPENSIONED": "without a pension [adj]\n",
  "UNPENT": "UNPEN, to release from confinement [v]\n",
  "UNPEOPLE": "to remove people from [v UNPEOPLED, UNPEOPLING, UNPEOPLES]\n",
  "UNPEOPLED": "UNPEOPLE, to remove people from [v]\n",
  "UNPEOPLES": "UNPEOPLE, to remove people from [v]\n",
  "UNPEOPLING": "UNPEOPLE, to remove people from [v]\n",
  "UNPEPPERED": "not peppered [adj]\n",
  "UNPERCEIVABLE": "that cannot be perceived [adj UNPERCEIVABLY]\n",
  "UNPERCEIVABLY": "UNPERCEIVABLE, that cannot be perceived [adv]\n",
  "UNPERCEIVED": "not perceived [adj UNPERCEIVEDLY]\n",
  "UNPERCEIVEDLY": "UNPERCEIVED, not perceived [adv]\n",
  "UNPERCEPTIVE": "not perceptive [adj]\n",
  "UNPERCH": "to drive from a perch [v -ED, -ING, -ES]\n",
  "UNPERCHED": "UNPERCH, to drive from a perch [v]\n",
  "UNPERCHES": "UNPERCH, to drive from a perch [v]\n",
  "UNPERCHING": "UNPERCH, to drive from a perch [v]\n",
  "UNPERFECT": "not perfect, also IMPERFECT [adj UNPERFECTLY]\n",
  "UNPERFECTED": "not perfected [adj]\n",
  "UNPERFECTION": "(obsolete) imperfection [n -S]\n",
  "UNPERFECTIONS": "UNPERFECTION, (obsolete) imperfection [n]\n",
  "UNPERFECTLY": "UNPERFECT, not perfect, also IMPERFECT [adv]\n",
  "UNPERFECTNESS": "the state of being unperfect [n -ES]\n",
  "UNPERFECTNESSES": "UNPERFECTNESS, the state of being unperfect [n]\n",
  "UNPERFORATED": "not perforated [adj]\n",
  "UNPERFORMABLE": "not performable [adj]\n",
  "UNPERFORMED": "not performed [adj]\n",
  "UNPERFORMING": "not performing [adj]\n",
  "UNPERFUMED": "not perfumed [adj]\n",
  "UNPERILOUS": "not perilous [adj]\n",
  "UNPERISHABLE": "not perishable [adj]\n",
  "UNPERISHED": "not perished [adj]\n",
  "UNPERISHING": "not perishing [adj]\n",
  "UNPERJURED": "not perjured [adj]\n",
  "UNPERPETRATED": "not perpetrated [adj]\n",
  "UNPERPLEX": "to free from perplexity [v -ED, -ING, -ES]\n",
  "UNPERPLEXED": "UNPERPLEX, to free from perplexity [v]\n",
  "UNPERPLEXES": "UNPERPLEX, to free from perplexity [v]\n",
  "UNPERPLEXING": "UNPERPLEX, to free from perplexity [v]\n",
  "UNPERSECUTED": "not persecuted [adj]\n",
  "UNPERSON": "a nonperson [n -S] / to make someone into an unperson [v -ED, -ING, -S]\n",
  "UNPERSONED": "UNPERSON, to make someone into an unperson [v]\n",
  "UNPERSONING": "UNPERSON, to make someone into an unperson [v]\n",
  "UNPERSONS": "UNPERSON, to make someone into an unperson [v]\n",
  "UNPERSUADABLE": "not persuadable [adj]\n",
  "UNPERSUADED": "not persuaded [adj]\n",
  "UNPERSUASIVE": "not persuasive [adj]\n",
  "UNPERTURBED": "not perturbed [adj]\n",
  "UNPERVERT": "to free from perversion [v -ED, -ING, -S]\n",
  "UNPERVERTED": "UNPERVERT, to free from perversion [v]\n",
  "UNPERVERTING": "UNPERVERT, to free from perversion [v]\n",
  "UNPERVERTS": "UNPERVERT, to free from perversion [v]\n",
  "UNPHILOSOPHIC": "not philosophic, also UNPHILOSOPHICAL [adj]\n",
  "UNPHILOSOPHICAL": "not philosophical, also UNPHILOSOPHIC [adj]\n",
  "UNPHONETIC": "not phonetic [adj]\n",
  "UNPICK": "to remove the stitches from [v -ED, -ING, -S]\n",
  "UNPICKABLE": "that cannot be picked [adj]\n",
  "UNPICKED": "UNPICK, to remove the stitches from [v]\n",
  "UNPICKING": "UNPICK, to remove the stitches from [v]\n",
  "UNPICKS": "UNPICK, to remove the stitches from [v]\n",
  "UNPICTURESQUE": "not picturesque [adj]\n",
  "UNPIERCED": "not pierced [adj]\n",
  "UNPIGMENTED": "not pigmented [adj]\n",
  "UNPILE": "to disentangle from a pile [v UNPILED, UNPILING, UNPILES]\n",
  "UNPILED": "UNPILE, to disentangle from a pile [v]\n",
  "UNPILES": "UNPILE, to disentangle from a pile [v]\n",
  "UNPILING": "UNPILE, to disentangle from a pile [v]\n",
  "UNPILLARED": "not pillared [adj]\n",
  "UNPILLOWED": "not pillowed [adj]\n",
  "UNPILOTED": "not piloted [adj]\n",
  "UNPIN": "to remove the pins from [v UNPINNED, UNPINNING, UNPINS]\n",
  "UNPINKED": "(Shakespeare) not pinked, i.e. not ornamented with punched holes, also UNPINKT [adj]\n",
  "UNPINKT": "(Shakespeare) not pinked, i.e. not ornamented with punched holes, also UNPINKED [adj]\n",
  "UNPINNED": "UNPIN, to remove the pins from [v]\n",
  "UNPINNING": "UNPIN, to remove the pins from [v]\n",
  "UNPINS": "UNPIN, to remove the pins from [v]\n",
  "UNPITIED": "not pitied [adj]\n",
  "UNPITIFUL": "not pitiful [adj UNPITIFULLY]\n",
  "UNPITIFULLY": "UNPITIFUL, not pitiful [adv]\n",
  "UNPITIFULNESS": "the state of being unpitiful [n -ES]\n",
  "UNPITIFULNESSES": "UNPITIFULNESS, the state of being unpitiful [n]\n",
  "UNPITTED": "not pitted [adj]\n",
  "UNPITYING": "not pitying [adj UNPITYINGLY]\n",
  "UNPITYINGLY": "UNPITYING, not pitying [adv]\n",
  "UNPLACE": "to displace [v UNPLACED, UNPLACING, UNPLACES]\n",
  "UNPLACED": "UNPLACE, to displace [v]\n",
  "UNPLACES": "UNPLACE, to displace [v]\n",
  "UNPLACING": "UNPLACE, to displace [v]\n",
  "UNPLAGUED": "not plagued [adj]\n",
  "UNPLAINED": "(Spenser) not lamented [adj]\n",
  "UNPLAIT": "to undo the plaits of [v -ED, -ING, -S]\n",
  "UNPLAITED": "UNPLAIT, to undo the plaits of [v]\n",
  "UNPLAITING": "UNPLAIT, to undo the plaits of [v]\n",
  "UNPLAITS": "UNPLAIT, to undo the plaits of [v]\n",
  "UNPLANKED": "not fitted with planks [adj]\n",
  "UNPLANNED": "not planned [adj]\n",
  "UNPLANTED": "not planted [adj]\n",
  "UNPLASTERED": "not plastered [adj]\n",
  "UNPLASTICISED": "not plasticised, also UNPLASTICIZED [adj]\n",
  "UNPLASTICIZED": "not plasticized, also UNPLASTICISED [adj]\n",
  "UNPLAUSIBLE": "not plausible, also IMPLAUSIBLE [adj UNPLAUSIBLY]\n",
  "UNPLAUSIBLY": "UNPLAUSIBLE, not plausible, also IMPLAUSIBLE [adv]\n",
  "UNPLAUSIVE": "not approving; disapproving [adj]\n",
  "UNPLAYABLE": "not playable [adj]\n",
  "UNPLAYED": "not played [adj]\n",
  "UNPLEASANT": "not pleasant [adj UNPLEASANTLY]\n",
  "UNPLEASANTLY": "UNPLEASANT, not pleasant [adv]\n",
  "UNPLEASANTNESS": "the state of being unpleasant [n]\n",
  "UNPLEASANTRIES": "UNPLEASANTRY, not a pleasantry [n]\n",
  "UNPLEASANTRY": "not a pleasantry [n UNPLEASANTRIES]\n",
  "UNPLEASED": "not pleased [adj]\n",
  "UNPLEASING": "not pleasing [adj UNPLEASINGLY]\n",
  "UNPLEASINGLY": "UNPLEASING, not pleasing [adv]\n",
  "UNPLEASURABLE": "not pleasurable [adj UNPLEASURABLY]\n",
  "UNPLEASURABLY": "UNPLEASURABLE, not pleasurable [adv]\n",
  "UNPLEATED": "not pleated [adj]\n",
  "UNPLEDGED": "not pledged [adj]\n",
  "UNPLIABLE": "not pliable [adj UNPLIABLY]\n",
  "UNPLIABLY": "UNPLIABLE, not pliable [adv]\n",
  "UNPLIANT": "not pliant [adj]\n",
  "UNPLOUGHED": "not ploughed [adj]\n",
  "UNPLOWED": "not plowed [adj]\n",
  "UNPLUCKED": "not plucked [adj]\n",
  "UNPLUG": "to take a plug out [v UNPLUGGED, UNPLUGGING, UNPLUGS]\n",
  "UNPLUGGED": "UNPLUG, to take a plug out [v]\n",
  "UNPLUGGING": "UNPLUG, to take a plug out [v]\n",
  "UNPLUGS": "UNPLUG, to take a plug out [v]\n",
  "UNPLUMB": "to remove lead from [v -ED, -ING, -S]\n",
  "UNPLUMBED": "UNPLUMB, to remove lead from [v]\n",
  "UNPLUMBING": "UNPLUMB, to remove lead from [v]\n",
  "UNPLUMBS": "UNPLUMB, to remove lead from [v]\n",
  "UNPLUME": "to strip of feathers [v UNPLUMED, UNPLUMING, UNPLUMES]\n",
  "UNPLUMED": "UNPLUME, to strip of feathers [v]\n",
  "UNPLUMES": "UNPLUME, to strip of feathers [v]\n",
  "UNPLUMING": "UNPLUME, to strip of feathers [v]\n",
  "UNPOETIC": "not poetic [adj UNPOETICALLY]\n",
  "UNPOETICAL": "not poetical [adj UNPOETICALLY]\n",
  "UNPOETICALLY": "UNPOETICAL, not poetical [adv]\n",
  "UNPOETICALNESS": "the state of being unpoetical [n]\n",
  "UNPOINTED": "not pointed [adj]\n",
  "UNPOISED": "not poised [adj]\n",
  "UNPOISON": "to rid of poison [v -ED, -ING, -S]\n",
  "UNPOISONED": "UNPOISON, to rid of poison [v]\n",
  "UNPOISONING": "UNPOISON, to rid of poison [v]\n",
  "UNPOISONS": "UNPOISON, to rid of poison [v]\n",
  "UNPOLARISABLE": "not polarisable, also UNPOLARIZABLE [adj]\n",
  "UNPOLARISED": "not polarised [adj]\n",
  "UNPOLARIZABLE": "not polarizable, also UNPOLARISABLE [adj]\n",
  "UNPOLARIZED": "not polarized [adj]\n",
  "UNPOLICED": "not policed [adj]\n",
  "UNPOLICIED": "not having civil polity, or a regular form of government [adj]\n",
  "UNPOLISH": "to remove polish from [v -ED, -ING, -ES]\n",
  "UNPOLISHABLE": "not polishable [adj]\n",
  "UNPOLISHED": "UNPOLISH, to remove polish from [v]\n",
  "UNPOLISHES": "UNPOLISH, to remove polish from [v]\n",
  "UNPOLISHING": "UNPOLISH, to remove polish from [v]\n",
  "UNPOLITE": "not polite [adj UNPOLITELY]\n",
  "UNPOLITELY": "UNPOLITE, not polite [adv]\n",
  "UNPOLITENESS": "the state of being unpolite [n -ES]\n",
  "UNPOLITENESSES": "UNPOLITENESS, the state of being unpolite [n]\n",
  "UNPOLITIC": "not politic, also IMPOLITIC, IMPOLITICAL [adj]\n",
  "UNPOLITICAL": "not political [adj]\n",
  "UNPOLLED": "not polled [adj]\n",
  "UNPOLLUTED": "not polluted [adj]\n",
  "UNPOPE": "to divest of popedom [v UNPOPED, UNPOPING, UNPOPES]\n",
  "UNPOPED": "UNPOPE, to divest of popedom [v]\n",
  "UNPOPES": "UNPOPE, to divest of popedom [v]\n",
  "UNPOPING": "UNPOPE, to divest of popedom [v]\n",
  "UNPOPULAR": "not popular [adj UNPOPULARLY]\n",
  "UNPOPULARITIES": "UNPOPULARITY, the state of being unpopular [n]\n",
  "UNPOPULARITY": "the state of being unpopular [n UNPOPULARITIES]\n",
  "UNPOPULARLY": "UNPOPULAR, not popular [adv]\n",
  "UNPOPULATED": "not populated [adj]\n",
  "UNPOPULOUS": "not populous [adj]\n",
  "UNPORTIONED": "without a portion [adj]\n",
  "UNPOSED": "not posed [adj]\n",
  "UNPOSSESSED": "not possessed [adj]\n",
  "UNPOSSESSING": "(Shakespeare) without possessions [adj]\n",
  "UNPOSSIBLE": "impossible [adj]\n",
  "UNPOSTED": "not posted [adj]\n",
  "UNPOTABLE": "not potable, undrinkable [adj]\n",
  "UNPOTTED": "not potted [adj]\n",
  "UNPOURED": "not poured [adj]\n",
  "UNPOWDERED": "not powdered [adj]\n",
  "UNPOWERED": "not powered [adj]\n",
  "UNPRACTICABLE": "not practicable [adj]\n",
  "UNPRACTICAL": "not practical [adj UNPRACTICALLY]\n",
  "UNPRACTICALITY": "not practicality [n]\n",
  "UNPRACTICALLY": "UNPRACTICAL, not practical [adv]\n",
  "UNPRACTICALNESS": "the state of being unpractical [n]\n",
  "UNPRACTICED": "not practiced, also UNPRACTISED [adj]\n",
  "UNPRACTISED": "not practised, also UNPRACTICED [adj]\n",
  "UNPRACTISEDNESS": "the state of being unpractised [n]\n",
  "UNPRAISE": "to deprive of praise [v UNPRAISED, UNPRAISING, UNPRAISES]\n",
  "UNPRAISED": "UNPRAISE, to deprive of praise [v]\n",
  "UNPRAISES": "UNPRAISE, to deprive of praise [v]\n",
  "UNPRAISEWORTHY": "not praiseworthy [adj]\n",
  "UNPRAISING": "UNPRAISE, to deprive of praise [v]\n",
  "UNPRAY": "to revoke the praying of [v -ED, -ING, -S]\n",
  "UNPRAYED": "UNPRAY, to revoke the praying of [v]\n",
  "UNPRAYING": "UNPRAY, to revoke the praying of [v]\n",
  "UNPRAYS": "UNPRAY, to revoke the praying of [v]\n",
  "UNPREACH": "to recant in preaching [v -ED, -ING, -ES]\n",
  "UNPREACHED": "UNPREACH, to recant in preaching [v]\n",
  "UNPREACHES": "UNPREACH, to recant in preaching [v]\n",
  "UNPREACHING": "UNPREACH, to recant in preaching [v]\n",
  "UNPRECEDENTED": "having no precedent [adj UNPRECEDENTEDLY]\n",
  "UNPRECEDENTEDLY": "UNPRECEDENTED, having no precedent [adv]\n",
  "UNPRECISE": "not precise, also IMPRECISE [adj]\n",
  "UNPREDESTINED": "not predestined [adj]\n",
  "UNPREDICT": "(Milton) to retract or falsify a previous prediction [v -ED, -ING, -S]\n",
  "UNPREDICTABLE": "that cannot be predicted [adj UNPREDICTABLY] / something that cannot be predicted [n -S]\n",
  "UNPREDICTABLES": "UNPREDICTABLE, something that cannot be predicted [n]\n",
  "UNPREDICTABLY": "UNPREDICTABLE, that cannot be predicted [adv]\n",
  "UNPREDICTED": "UNPREDICT, (Milton) to retract or falsify a previous prediction [v]\n",
  "UNPREDICTING": "UNPREDICT, (Milton) to retract or falsify a previous prediction [v]\n",
  "UNPREDICTS": "UNPREDICT, (Milton) to retract or falsify a previous prediction [v]\n",
  "UNPREFERRED": "not preferred [adj]\n",
  "UNPREGNANT": "(Shakespeare) stupid [adj]\n",
  "UNPREJUDICED": "not prejudiced [adj UNPREJUDICEDLY]\n",
  "UNPREJUDICEDLY": "UNPREJUDICED, not prejudiced [adv]\n",
  "UNPRELATICAL": "not prelatical [adj]\n",
  "UNPREMEDITABLE": "that cannot be premeditated [adj]\n",
  "UNPREMEDITATED": "not premeditated [adj]\n",
  "UNPREMEDITATION": "a lack of premeditation [n]\n",
  "UNPREOCCUPIED": "not preoccupied [adj]\n",
  "UNPREPARE": "to make unprepared [v UNPREPARED, UNPREPARING, UNPREPARES]\n",
  "UNPREPARED": "UNPREPARE, to make unprepared [v]\n",
  "UNPREPAREDLY": "UNPREPARED, UNPREPARE, to make unprepared [adv]\n",
  "UNPREPAREDNESS": "a lack of preparedness [n]\n",
  "UNPREPARES": "UNPREPARE, to make unprepared [v]\n",
  "UNPREPARING": "UNPREPARE, to make unprepared [v]\n",
  "UNPREPOSSESSED": "not prepossessed [adj]\n",
  "UNPREPOSSESSING": "not creating a favourable impression [adj]\n",
  "UNPRESCRIBED": "not prescribed [adj]\n",
  "UNPRESENTABLE": "not presentable [adj]\n",
  "UNPRESSED": "not pressed [adj]\n",
  "UNPRESSURED": "not pressured [adj]\n",
  "UNPRESSURISED": "not pressurised, also UNPRESSURIZED [adj]\n",
  "UNPRESSURIZED": "not pressurized, also UNPRESSURISED [adj]\n",
  "UNPRESUMING": "modest, not presuming [adj]\n",
  "UNPRESUMPTUOUS": "not presumptuous [adj]\n",
  "UNPRETENDING": "unpretentious [adj UNPRETENDINGLY]\n",
  "UNPRETENDINGLY": "UNPRETENDING, unpretentious [adv]\n",
  "UNPRETENTIOUS": "free from pretension [adj UNPRETENTIOUSLY]\n",
  "UNPRETENTIOUSLY": "UNPRETENTIOUS, free from pretension [adv]\n",
  "UNPRETTIER": "UNPRETTY, not pretty [adj]\n",
  "UNPRETTIEST": "UNPRETTY, not pretty [adj]\n",
  "UNPRETTINESS": "the state of being unpretty [n -ES]\n",
  "UNPRETTINESSES": "UNPRETTINESS, the state of being unpretty [n]\n",
  "UNPRETTY": "not pretty [adj UNPRETTIER, UNPRETTIEST]\n",
  "UNPREVAILING": "not prevailing [adj]\n",
  "UNPREVENTABLE": "not preventable [adj]\n",
  "UNPREVENTED": "not prevented [adj]\n",
  "UNPRICED": "not priced [adj]\n",
  "UNPRIEST": "to divest of priesthood [v -ED, -ING, -S]\n",
  "UNPRIESTED": "UNPRIEST, to divest of priesthood [v]\n",
  "UNPRIESTING": "UNPRIEST, to divest of priesthood [v]\n",
  "UNPRIESTLIER": "UNPRIESTLY, not like a priest [adj]\n",
  "UNPRIESTLIEST": "UNPRIESTLY, not like a priest [adj]\n",
  "UNPRIESTLY": "not like a priest [adj UNPRIESTLIER, UNPRIESTLIEST]\n",
  "UNPRIESTS": "UNPRIEST, to divest of priesthood [v]\n",
  "UNPRIMED": "not primed [adj]\n",
  "UNPRINCELIER": "UNPRINCELY, not princely [adj]\n",
  "UNPRINCELIEST": "UNPRINCELY, not princely [adj]\n",
  "UNPRINCELY": "not princely [adj UNPRINCELIER, UNPRINCELIEST]\n",
  "UNPRINCIPLED": "lacking moral principles [adj]\n",
  "UNPRINTABLE": "that cannot be printed [adj UNPRINTABLY]\n",
  "UNPRINTABLENESS": "the state of being unprintable [n]\n",
  "UNPRINTABLY": "UNPRINTABLE, that cannot be printed [adv]\n",
  "UNPRINTED": "not printed [adj]\n",
  "UNPRISABLE": "that cannot be prised [adj]\n",
  "UNPRISON": "to release from prison [v -ED, -ING, -S]\n",
  "UNPRISONED": "UNPRISON, to release from prison [v]\n",
  "UNPRISONING": "UNPRISON, to release from prison [v]\n",
  "UNPRISONS": "UNPRISON, to release from prison [v]\n",
  "UNPRIVILEGED": "not privileged [adj]\n",
  "UNPRIZABLE": "(Shakespeare) worthless [adj]\n",
  "UNPRIZED": "not prized [adj]\n",
  "UNPROBED": "not probed [adj]\n",
  "UNPROBLEMATIC": "not problematic [adj]\n",
  "UNPROCEDURAL": "not procedural [adj]\n",
  "UNPROCESSED": "not processed [adj]\n",
  "UNPROCLAIMED": "not proclaimed [adj]\n",
  "UNPROCURABLE": "not procurable [adj]\n",
  "UNPRODUCED": "not produced [adj]\n",
  "UNPRODUCTIVE": "not productive [adj UNPRODUCTIVELY]\n",
  "UNPRODUCTIVELY": "UNPRODUCTIVE, not productive [adv]\n",
  "UNPRODUCTIVITY": "not productivity [n]\n",
  "UNPROFANED": "not profaned [adj]\n",
  "UNPROFESSED": "not professed [adj]\n",
  "UNPROFESSIONAL": "one who is not professional [n -S]\n",
  "UNPROFESSIONALS": "UNPROFESSIONAL, one who is not professional [n]\n",
  "UNPROFITABILITY": "the quality of being unprofitable [n]\n",
  "UNPROFITABLE": "not profitable [adj UNPROFITABLY]\n",
  "UNPROFITABLY": "UNPROFITABLE, not profitable [adv]\n",
  "UNPROFITED": "profitless [adj]\n",
  "UNPROFITING": "the lack of profit or gain [n -S]\n",
  "UNPROFITINGS": "UNPROFITING, the lack of profit or gain [n]\n",
  "UNPROGRAMMABLE": "not programmable [adj]\n",
  "UNPROGRAMMED": "not programmed [adj]\n",
  "UNPROGRESSIVE": "not progressive [adj UNPROGRESSIVELY]\n",
  "UNPROGRESSIVELY": "UNPROGRESSIVE, not progressive [adv]\n",
  "UNPROHIBITED": "not prohibited [adj]\n",
  "UNPROJECTED": "not projected [adj]\n",
  "UNPROLIFIC": "not prolific [adj]\n",
  "UNPROMISED": "not promised [adj]\n",
  "UNPROMISING": "appearing unlikely to prove worthwhile or result favorably [adj UNPROMISINGLY]\n",
  "UNPROMISINGLY": "UNPROMISING, appearing unlikely to prove worthwhile or result favorably [adv]\n",
  "UNPROMPTED": "not prompted [adj]\n",
  "UNPRONOUNCEABLE": "not pronounceable [adj]\n",
  "UNPRONOUNCED": "not pronounced [adj]\n",
  "UNPROP": "to remove the props from [v UNPROPPED, UNPROPPING, UNPROPS]\n",
  "UNPROPER": "improper [adj UNPROPERLY]\n",
  "UNPROPERLY": "UNPROPER, improper [adv]\n",
  "UNPROPERTIED": "not propertied [adj]\n",
  "UNPROPHETIC": "not prophetic, also UNPROPHETICAL [adj]\n",
  "UNPROPHETICAL": "not prophetical, also UNPROPHETIC [adj]\n",
  "UNPROPITIOUS": "not propitious [adj UNPROPITIOUSLY]\n",
  "UNPROPITIOUSLY": "UNPROPITIOUS, not propitious [adv]\n",
  "UNPROPORTIONATE": "not proportionate [adj]\n",
  "UNPROPORTIONED": "not proportioned [adj]\n",
  "UNPROPOSED": "not proposed [adj]\n",
  "UNPROPPED": "UNPROP, to remove the props from [v]\n",
  "UNPROPPING": "UNPROP, to remove the props from [v]\n",
  "UNPROPS": "UNPROP, to remove the props from [v]\n",
  "UNPROSPEROUS": "not prosperous [adj UNPROSPEROUSLY]\n",
  "UNPROSPEROUSLY": "UNPROSPEROUS, not prosperous [adv]\n",
  "UNPROTECTED": "lacking protection or defense [adj]\n",
  "UNPROTECTEDNESS": "the state of being unprotected [n]\n",
  "UNPROTESTANTISE": "to convert from Protestantism, also UNPROTESTANTIZE [v]\n",
  "UNPROTESTANTIZE": "to convert from Protestantism, also UNPROTESTANTISE [v]\n",
  "UNPROTESTED": "without a protest [adj]\n",
  "UNPROTESTING": "not protesting [adj]\n",
  "UNPROVABLE": "not provable [adj]\n",
  "UNPROVED": "not proved [adj]\n",
  "UNPROVEN": "not proven [adj]\n",
  "UNPROVIDE": "(Shakespeare) to deprive of necessary provision [v UNPROVIDED, UNPROVIDING, UNPROVIDES]\n",
  "UNPROVIDED": "UNPROVIDE, (Shakespeare) to deprive of necessary provision [v]\n",
  "UNPROVIDEDLY": "UNPROVIDED, UNPROVIDE, (Shakespeare) to deprive of necessary provision [adv]\n",
  "UNPROVIDENT": "(Shakespeare) improvident [adj]\n",
  "UNPROVIDES": "UNPROVIDE, (Shakespeare) to deprive of necessary provision [v]\n",
  "UNPROVIDING": "UNPROVIDE, (Shakespeare) to deprive of necessary provision [v]\n",
  "UNPROVISIONED": "not provisioned [adj]\n",
  "UNPROVOCATIVE": "not provocative [adj]\n",
  "UNPROVOKE": "(Shakespeare) to counteract the provocation of [v UNPROVOKED, UNPROVOKING, UNPROVOKES]\n",
  "UNPROVOKED": "UNPROVOKE, (Shakespeare) to counteract the provocation of [v]\n",
  "UNPROVOKEDLY": "UNPROVOKED, UNPROVOKE, (Shakespeare) to counteract the provocation of [adv]\n",
  "UNPROVOKES": "UNPROVOKE, (Shakespeare) to counteract the provocation of [v]\n",
  "UNPROVOKING": "UNPROVOKE, (Shakespeare) to counteract the provocation of [v]\n",
  "UNPRUNED": "not pruned [adj]\n",
  "UNPUBLICISED": "not publicised, also UNPUBLICIZED [adj]\n",
  "UNPUBLICIZED": "not publicized, also UNPUBLICISED [adj]\n",
  "UNPUBLISHABLE": "that cannot be published [adj]\n",
  "UNPUBLISHED": "not published [adj]\n",
  "UNPUCKER": "to remove the wrinkles from [v -ED, -ING, -S]\n",
  "UNPUCKERED": "UNPUCKER, to remove the wrinkles from [v]\n",
  "UNPUCKERING": "UNPUCKER, to remove the wrinkles from [v]\n",
  "UNPUCKERS": "UNPUCKER, to remove the wrinkles from [v]\n",
  "UNPULLED": "not pulled [adj]\n",
  "UNPUNCTUAL": "not punctual [adj]\n",
  "UNPUNCTUALITIES": "UNPUNCTUALITY, lack of punctuality [n]\n",
  "UNPUNCTUALITY": "lack of punctuality [n UNPUNCTUALITIES]\n",
  "UNPUNCTUATED": "not punctuated [adj]\n",
  "UNPUNISHABLE": "not able to be punished [adj UNPUNISHABLY]\n",
  "UNPUNISHABLY": "UNPUNISHABLE, not able to be punished [adv]\n",
  "UNPUNISHED": "not punished [adj]\n",
  "UNPURCHASABLE": "that cannot be purchased, also UNPURCHASEABLE [adj]\n",
  "UNPURCHASEABLE": "that cannot be purchased, also UNPURCHASABLE [adj]\n",
  "UNPURCHASED": "not purchased [adj]\n",
  "UNPURE": "not pure, also IMPURE [adj UNPURELY]\n",
  "UNPURELY": "UNPURE, not pure, also IMPURE [adv]\n",
  "UNPURGED": "not purged [adj]\n",
  "UNPURIFIED": "not purified [adj]\n",
  "UNPURPOSED": "without a purpose [adj]\n",
  "UNPURSE": "to relax the lips from a pursed state [v UNPURSED, UNPURSING, UNPURSES]\n",
  "UNPURSED": "UNPURSE, to relax the lips from a pursed state [v]\n",
  "UNPURSES": "UNPURSE, to relax the lips from a pursed state [v]\n",
  "UNPURSING": "UNPURSE, to relax the lips from a pursed state [v]\n",
  "UNPURSUED": "not pursued [adj]\n",
  "UNPURVAIDE": "(Spenser) not purveyed, not provided with, also UNPURVEYED [adj]\n",
  "UNPURVEYED": "not purveyed, not provided with, also UNPURVAIDE [adj]\n",
  "UNPUTDOWNABLE": "of a book, that one cannot stop reading once started [adj]\n",
  "UNPUZZLE": "to work out the obscured meaning of [v UNPUZZLED, UNPUZZLING, UNPUZZLES]\n",
  "UNPUZZLED": "UNPUZZLE, to work out the obscured meaning of [v]\n",
  "UNPUZZLES": "UNPUZZLE, to work out the obscured meaning of [v]\n",
  "UNPUZZLING": "UNPUZZLE, to work out the obscured meaning of [v]\n",
  "UNQUAKING": "not quaking [adj]\n",
  "UNQUALIFIABLE": "not qualifiable [adj]\n",
  "UNQUALIFIED": "UNQUALIFY, to disqualify; to unfit [v]\n",
  "UNQUALIFIEDLY": "UNQUALIFIED, UNQUALIFY, to disqualify; to unfit [adv]\n",
  "UNQUALIFIEDNESS": "the state of being unqualified [n]\n",
  "UNQUALIFIES": "UNQUALIFY, to disqualify; to unfit [v]\n",
  "UNQUALIFY": "to disqualify; to unfit [v UNQUALIFIED, UNQUALIFYING, UNQUALIFIES]\n",
  "UNQUALIFYING": "UNQUALIFY, to disqualify; to unfit [v]\n",
  "UNQUALITED": "(Shakespeare) bereft of qualities, also UNQUALITIED [adj]\n",
  "UNQUALITIED": "(Shakespeare) bereft of qualities, also UNQUALITED [adj]\n",
  "UNQUANTIFIABLE": "not quantifiable [adj]\n",
  "UNQUANTIFIED": "not quantified [adj]\n",
  "UNQUANTISED": "not quantised, also UNQUANTIZED [adj]\n",
  "UNQUANTIZED": "not quantized, also UNQUANTISED [adj]\n",
  "UNQUARRIED": "not quarried [adj]\n",
  "UNQUEEN": "to deprive of a queen [v -ED, -ING, -S]\n",
  "UNQUEENED": "UNQUEEN, to deprive of a queen [v]\n",
  "UNQUEENING": "UNQUEEN, to deprive of a queen [v]\n",
  "UNQUEENLIER": "UNQUEENLY, not queenly [adj]\n",
  "UNQUEENLIEST": "UNQUEENLY, not queenly [adj]\n",
  "UNQUEENLIKE": "not like a queen [adj]\n",
  "UNQUEENLY": "not queenly [adj UNQUEENLIER, UNQUEENLIEST]\n",
  "UNQUEENS": "UNQUEEN, to deprive of a queen [v]\n",
  "UNQUELLED": "not quelled [adj]\n",
  "UNQUENCHABLE": "not able to be quenched [adj UNQUENCHABLY]\n",
  "UNQUENCHABLY": "UNQUENCHABLE, not able to be quenched [adv]\n",
  "UNQUENCHED": "not quenched [adj]\n",
  "UNQUESTIONABLE": "not open to question [adj UNQUESTIONABLY]\n",
  "UNQUESTIONABLY": "UNQUESTIONABLE, not open to question [adv]\n",
  "UNQUESTIONED": "not questioned [adj]\n",
  "UNQUESTIONING": "not questioning [adj UNQUESTIONINGLY]\n",
  "UNQUESTIONINGLY": "UNQUESTIONING, not questioning [adv]\n",
  "UNQUICKENED": "not quickened [adj]\n",
  "UNQUIET": "not quiet, restless [adj UNQUIETER, UNQUIETEST, UNQUIETLY] / to disturb [v -ED, -ING, -S]\n",
  "UNQUIETED": "UNQUIET, to disturb [v]\n",
  "UNQUIETER": "UNQUIET, not quiet, restless [adj]\n",
  "UNQUIETEST": "UNQUIET, not quiet, restless [adj]\n",
  "UNQUIETING": "UNQUIET, to disturb [v]\n",
  "UNQUIETLY": "UNQUIET, not quiet, restless [adv]\n",
  "UNQUIETNESS": "the state of being unquiet [n -ES]\n",
  "UNQUIETNESSES": "UNQUIETNESS, the state of being unquiet [n]\n",
  "UNQUIETS": "UNQUIET, to disturb [v]\n",
  "UNQUOTABLE": "not quotable [adj]\n",
  "UNQUOTE": "to close a quotation [v UNQUOTED, UNQUOTING, UNQUOTES]\n",
  "UNQUOTED": "UNQUOTE, to close a quotation [v]\n",
  "UNQUOTES": "UNQUOTE, to close a quotation [v]\n",
  "UNQUOTING": "UNQUOTE, to close a quotation [v]\n",
  "UNRACED": "not raced [adj]\n",
  "UNRACKED": "not strained [adj]\n",
  "UNRAISED": "not raised [adj]\n",
  "UNRAKE": "to uncover by raking [v UNRAKED, UNRAKING, UNRAKES]\n",
  "UNRAKED": "UNRAKE, to uncover by raking [v]\n",
  "UNRAKES": "UNRAKE, to uncover by raking [v]\n",
  "UNRAKING": "UNRAKE, to uncover by raking [v]\n",
  "UNRANKED": "not ranked [adj]\n",
  "UNRANSOMED": "not ransomed [adj]\n",
  "UNRATED": "not rated [adj]\n",
  "UNRATIFIED": "not ratified [adj]\n",
  "UNRAVAGED": "not ravaged [adj]\n",
  "UNRAVEL": "to separate the threads of [v UNRAVELED or UNRAVELLED, UNRAVELING or UNRAVELLING, UNRAVELS]\n",
  "UNRAVELED": "UNRAVEL, to separate the threads of [v]\n",
  "UNRAVELING": "UNRAVEL, to separate the threads of [v]\n",
  "UNRAVELLED": "UNRAVEL, to separate the threads of [v]\n",
  "UNRAVELLER": "one who unravels [n -S]\n",
  "UNRAVELLERS": "UNRAVELLER, one who unravels [n]\n",
  "UNRAVELLING": "the act of unravelling [n -S]\n",
  "UNRAVELLINGS": "UNRAVELLING, the act of unravelling [n]\n",
  "UNRAVELMENT": "the state of being unravelled [n -S]\n",
  "UNRAVELMENTS": "UNRAVELMENT, the state of being unravelled [n]\n",
  "UNRAVELS": "UNRAVEL, to separate the threads of [v]\n",
  "UNRAVISHED": "not ravished [adj]\n",
  "UNRAZED": "not razed [adj]\n",
  "UNRAZORED": "not shaven [adj]\n",
  "UNREACHABLE": "that cannot be reached [adj]\n",
  "UNREACHED": "not reached [adj]\n",
  "UNREACTIVE": "not reactive [adj]\n",
  "UNREAD": "not read [adj]\n",
  "UNREADABILITIES": "UNREADABILITY, the quality of being unreadable [n]\n",
  "UNREADABILITY": "the quality of being unreadable [n UNREADABILITIES]\n",
  "UNREADABLE": "that cannot be read [adj UNREADABLY]\n",
  "UNREADABLENESS": "the state of being unreadable [n]\n",
  "UNREADABLY": "UNREADABLE, that cannot be read [adv]\n",
  "UNREADIER": "UNREADY, not ready, also UNREDY [adj]\n",
  "UNREADIEST": "UNREADY, not ready, also UNREDY [adj]\n",
  "UNREADILY": "UNREADY, not ready, also UNREDY [adv]\n",
  "UNREADINESS": "the state of being unready [n -ES]\n",
  "UNREADINESSES": "UNREADINESS, the state of being unready [n]\n",
  "UNREADY": "not ready, also UNREDY [adj UNREADIER, UNREADIEST, UNREADILY]\n",
  "UNREAL": "not real [adj UNREALLY]\n",
  "UNREALISABLE": "not realisable, also UNREALIZABLE [adj]\n",
  "UNREALISE": "to divest of reality, also UNREALIZE [v UNREALISED, UNREALISING, UNREALISES]\n",
  "UNREALISED": "UNREALISE, to divest of reality, also UNREALIZE [v]\n",
  "UNREALISES": "UNREALISE, to divest of reality, also UNREALIZE [v]\n",
  "UNREALISING": "UNREALISE, to divest of reality, also UNREALIZE [v]\n",
  "UNREALISM": "lack of realism [n -S]\n",
  "UNREALISMS": "UNREALISM, lack of realism [n]\n",
  "UNREALISTIC": "not realistic [adj UNREALISTICALLY]\n",
  "UNREALISTICALLY": "UNREALISTIC, not realistic [adv]\n",
  "UNREALITIES": "UNREALITY, the state of being unreal [n]\n",
  "UNREALITY": "the state of being unreal [n UNREALITIES]\n",
  "UNREALIZABLE": "not realizable, also UNREALISABLE [adj]\n",
  "UNREALIZE": "to divest of reality, also UNREALISE [v UNREALIZED, UNREALIZING, UNREALIZES]\n",
  "UNREALIZED": "UNREALIZE, to divest of reality, also UNREALISE [v]\n",
  "UNREALIZES": "UNREALIZE, to divest of reality, also UNREALISE [v]\n",
  "UNREALIZING": "UNREALIZE, to divest of reality, also UNREALISE [v]\n",
  "UNREALLY": "not really [adv]\n",
  "UNREAPED": "not reaped [adj]\n",
  "UNREASON": "to disrupt the sanity of [v -ED, -ING, -S]\n",
  "UNREASONABLE": "not governed by or acting according to reason [adj UNREASONABLY]\n",
  "UNREASONABLY": "UNREASONABLE, not governed by or acting according to reason [adv]\n",
  "UNREASONED": "UNREASON, to disrupt the sanity of [v]\n",
  "UNREASONING": "UNREASON, to disrupt the sanity of [v]\n",
  "UNREASONINGLY": "UNREASONING, UNREASON, to disrupt the sanity of [adv]\n",
  "UNREASONS": "UNREASON, to disrupt the sanity of [v]\n",
  "UNREAVE": "to unwind; to disentangle [v UNREAVED, UNROVE, UNROVEN, UNREAVING, UNREAVES]\n",
  "UNREAVED": "UNREAVE, to unwind; to disentangle [v]\n",
  "UNREAVES": "UNREAVE, to unwind; to disentangle [v]\n",
  "UNREAVING": "UNREAVE, to unwind; to disentangle [v]\n",
  "UNREBATED": "not subject to a rebate [adj]\n",
  "UNREBUKED": "not rebuked [adj]\n",
  "UNRECALLABLE": "not recallable [adj]\n",
  "UNRECALLED": "not recalled [adj]\n",
  "UNRECALLING": "(Shakespeare) impossible to undo, not to be recalled [adj]\n",
  "UNRECAPTURABLE": "that cannot be recaptured [adj]\n",
  "UNRECEIPTED": "without a receipt [adj]\n",
  "UNRECEIVED": "not received [adj]\n",
  "UNRECEPTIVE": "not receptive [adj]\n",
  "UNRECIPROCATED": "not reciprocated [adj]\n",
  "UNRECKED": "not regarded [adj]\n",
  "UNRECKONABLE": "that cannot be reckoned [adj]\n",
  "UNRECKONED": "not reckoned [adj]\n",
  "UNRECLAIMABLE": "that cannot be reclaimed [adj UNRECLAIMABLY]\n",
  "UNRECLAIMABLY": "UNRECLAIMABLE, that cannot be reclaimed [adv]\n",
  "UNRECLAIMED": "not reclaimed [adj]\n",
  "UNRECOGNISABLE": "not recognisable, also UNRECOGNIZABLE [adj UNRECOGNISABLY]\n",
  "UNRECOGNISABLY": "UNRECOGNISABLE, not recognisable, also UNRECOGNIZABLE [adv]\n",
  "UNRECOGNISED": "not recognised [adj]\n",
  "UNRECOGNISING": "not recognising [adj]\n",
  "UNRECOGNIZABLE": "not recognizable, also UNRECOGNISABLE [adj UNRECOGNIZABLY]\n",
  "UNRECOGNIZABLY": "UNRECOGNIZABLE, not recognizable, also UNRECOGNISABLE [adv]\n",
  "UNRECOGNIZED": "not recognized [adj]\n",
  "UNRECOGNIZING": "not recognizing [adj]\n",
  "UNRECOLLECTED": "not recollected [adj]\n",
  "UNRECOMMENDABLE": "not recommendable [adj]\n",
  "UNRECOMMENDED": "not recommended [adj]\n",
  "UNRECOMPENSED": "not recompensed [adj]\n",
  "UNRECONCILABLE": "not reconcilable [adj UNRECONCILABLY]\n",
  "UNRECONCILABLY": "UNRECONCILABLE, not reconcilable [adv]\n",
  "UNRECONCILED": "not reconciled [adj]\n",
  "UNRECONCILIABLE": "(Shakespeare) unreconcilable [adj]\n",
  "UNRECONSTRUCTED": "not reconciled to some political, economic, or social change [adj]\n",
  "UNRECORDED": "not recorded [adj]\n",
  "UNRECOUNTED": "not recounted [adj]\n",
  "UNRECOVERABLE": "that cannot be recovered [adj UNRECOVERABLY]\n",
  "UNRECOVERABLY": "UNRECOVERABLE, that cannot be recovered [adv]\n",
  "UNRECOVERED": "not recovered [adj]\n",
  "UNRECTIFIED": "not rectified [adj]\n",
  "UNRECURING": "(Shakespeare) incurable [adj]\n",
  "UNRECYCLABLE": "something that is not recyclable [n -S]\n",
  "UNRECYCLABLES": "UNRECYCLABLE, something that is not recyclable [n]\n",
  "UNRED": "(Spenser) unread, in the sense of not reckoned up [adj]\n",
  "UNREDEEMABLE": "not redeemable [adj]\n",
  "UNREDEEMED": "not redeemed [adj]\n",
  "UNREDRESSED": "not redressed [adj]\n",
  "UNREDREST": "not redressed, without compensation [adj]\n",
  "UNREDUCED": "not reduced [adj]\n",
  "UNREDUCIBLE": "not reducible [adj]\n",
  "UNREDY": "(obsolete) unready [adj]\n",
  "UNREEL": "to unwind from a reel [v -ED, -ING, -S]\n",
  "UNREELED": "UNREEL, to unwind from a reel [v]\n",
  "UNREELER": "one who unreels [n -S]\n",
  "UNREELERS": "UNREELER, one who unreels [n]\n",
  "UNREELING": "UNREEL, to unwind from a reel [v]\n",
  "UNREELS": "UNREEL, to unwind from a reel [v]\n",
  "UNREEVE": "to withdraw a rope from an opening [v UNROVE or UNREEVED, UNROVEN, UNREEVING, UNREEVES]\n",
  "UNREEVED": "UNREEVE, to withdraw a rope from an opening [v]\n",
  "UNREEVES": "UNREEVE, to withdraw a rope from an opening [v]\n",
  "UNREEVING": "UNREEVE, to withdraw a rope from an opening [v]\n",
  "UNREFINED": "not refined [adj]\n",
  "UNREFLECTED": "not reflected [adj]\n",
  "UNREFLECTING": "not reflecting [adj UNREFLECTINGLY]\n",
  "UNREFLECTINGLY": "UNREFLECTING, not reflecting [adv]\n",
  "UNREFLECTIVE": "not reflective [adj UNREFLECTIVELY]\n",
  "UNREFLECTIVELY": "UNREFLECTIVE, not reflective [adv]\n",
  "UNREFORMABLE": "not reformable [adj]\n",
  "UNREFORMED": "not reformed [adj]\n",
  "UNREFRACTED": "not refracted [adj]\n",
  "UNREFRESHED": "not refreshed [adj]\n",
  "UNREFRESHING": "not refreshing [adj]\n",
  "UNREFRIGERATED": "not refrigerated [adj]\n",
  "UNREFUTED": "not refuted [adj]\n",
  "UNREGARDED": "not regarded [adj]\n",
  "UNREGARDING": "not regarding [adj]\n",
  "UNREGENERACIES": "UNREGENERACY, the state of being unregenerate [n]\n",
  "UNREGENERACY": "the state of being unregenerate [n UNREGENERACIES]\n",
  "UNREGENERATE": "not regenerate [adj UNREGENERATELY] / an unregenerate person [n -S]\n",
  "UNREGENERATED": "not regenerated [adj]\n",
  "UNREGENERATELY": "UNREGENERATE, not regenerate [adv]\n",
  "UNREGENERATES": "UNREGENERATE, an unregenerate person [n]\n",
  "UNREGIMENTED": "not regimented [adj]\n",
  "UNREGISTERED": "not registered [adj]\n",
  "UNREGRETTED": "not regretted [adj]\n",
  "UNREGULATED": "not regulated [adj]\n",
  "UNREHEARSED": "not rehearsed [adj]\n",
  "UNREIN": "to give rein to [v -ED, -ING, -S]\n",
  "UNREINED": "UNREIN, to give rein to [v]\n",
  "UNREINFORCED": "not reinforced [adj]\n",
  "UNREINING": "UNREIN, to give rein to [v]\n",
  "UNREINS": "UNREIN, to give rein to [v]\n",
  "UNREJOICED": "not rejoiced over [adj]\n",
  "UNREJOICING": "not rejoicing [adj]\n",
  "UNRELATED": "not related [adj]\n",
  "UNRELATIVE": "not relative [adj]\n",
  "UNRELAXED": "not relaxed [adj]\n",
  "UNRELEASED": "not released [adj]\n",
  "UNRELENTING": "not softening or yielding in determination [adj UNRELENTINGLY]\n",
  "UNRELENTINGLY": "UNRELENTING, not softening or yielding in determination [adv]\n",
  "UNRELENTINGNESS": "the state of being unrelenting [n]\n",
  "UNRELENTOR": "(Keats) someone who does not relent [n -S]\n",
  "UNRELENTORS": "UNRELENTOR, (Keats) someone who does not relent [n]\n",
  "UNRELIABILITIES": "UNRELIABILITY, the quality of being unreliable [n]\n",
  "UNRELIABILITY": "the quality of being unreliable [n UNRELIABILITIES]\n",
  "UNRELIABLE": "not reliable [adj UNRELIABLY]\n",
  "UNRELIABLENESS": "the state of being unreliable [n]\n",
  "UNRELIABLY": "UNRELIABLE, not reliable [adv]\n",
  "UNRELIEVABLE": "not relievable [adj]\n",
  "UNRELIEVED": "not relieved [adj UNRELIEVEDLY]\n",
  "UNRELIEVEDLY": "UNRELIEVED, not relieved [adv]\n",
  "UNRELIGIOUS": "not religious [adj UNRELIGIOUSLY]\n",
  "UNRELIGIOUSLY": "UNRELIGIOUS, not religious [adv]\n",
  "UNRELISHED": "not relished [adj]\n",
  "UNRELUCTANT": "not reluctant [adj]\n",
  "UNREMAINING": "not remaining [adj]\n",
  "UNREMARKABLE": "not remarkable [adj UNREMARKABLY]\n",
  "UNREMARKABLY": "UNREMARKABLE, not remarkable [adv]\n",
  "UNREMARKED": "not remarked [adj]\n",
  "UNREMEDIED": "not remedied [adj]\n",
  "UNREMEMBERED": "not remembered [adj]\n",
  "UNREMEMBERING": "not remembering [adj]\n",
  "UNREMINISCENT": "not reminiscent [adj]\n",
  "UNREMITTED": "not remitted [adj UNREMITTEDLY]\n",
  "UNREMITTEDLY": "UNREMITTED, not remitted [adv]\n",
  "UNREMITTENT": "not remittent [adj UNREMITTENTLY]\n",
  "UNREMITTENTLY": "UNREMITTENT, not remittent [adv]\n",
  "UNREMITTING": "not remitting [adj UNREMITTINGLY]\n",
  "UNREMITTINGLY": "UNREMITTING, not remitting [adv]\n",
  "UNREMITTINGNESS": "the state of being unremitting [n]\n",
  "UNREMORSEFUL": "not remorseful [adj UNREMORSEFULLY]\n",
  "UNREMORSEFULLY": "UNREMORSEFUL, not remorseful [adv]\n",
  "UNREMORSELESS": "not remorseless [adj]\n",
  "UNREMOVABLE": "that cannot be removed [adj]\n",
  "UNREMOVED": "not removed [adj]\n",
  "UNREMUNERATIVE": "not remunerative [adj]\n",
  "UNRENDERED": "not rendered [adj]\n",
  "UNRENEWED": "not renewed [adj]\n",
  "UNRENOWNED": "not renowned [adj]\n",
  "UNRENT": "not torn [adj]\n",
  "UNRENTED": "not rented [adj]\n",
  "UNREPAID": "not repaid [adj]\n",
  "UNREPAIR": "a lack of repair [n -S]\n",
  "UNREPAIRABLE": "not repairable [adj]\n",
  "UNREPAIRED": "not repaired [adj]\n",
  "UNREPAIRS": "UNREPAIR, a lack of repair [n]\n",
  "UNREPEALABLE": "not repealable [adj]\n",
  "UNREPEALED": "not repealed [adj]\n",
  "UNREPEATABLE": "not repeatable [adj]\n",
  "UNREPEATED": "not repeated [adj]\n",
  "UNREPELLED": "not repelled [adj]\n",
  "UNREPENTANCE": "lack of repentance [n -S]\n",
  "UNREPENTANCES": "UNREPENTANCE, lack of repentance [n]\n",
  "UNREPENTANT": "not repentant [adj UNREPENTANTLY]\n",
  "UNREPENTANTLY": "UNREPENTANT, not repentant [adv]\n",
  "UNREPENTED": "not repented [adj]\n",
  "UNREPENTING": "not repenting [adj UNREPENTINGLY]\n",
  "UNREPENTINGLY": "UNREPENTING, not repenting [adv]\n",
  "UNREPINING": "not repining [adj UNREPININGLY]\n",
  "UNREPININGLY": "UNREPINING, not repining [adv]\n",
  "UNREPLACEABLE": "not replaceable [adj]\n",
  "UNREPLENISHED": "not replenished [adj]\n",
  "UNREPORTABLE": "not reportable [adj]\n",
  "UNREPORTED": "not reported [adj]\n",
  "UNREPOSEFUL": "not reposeful [adj]\n",
  "UNREPOSING": "not resting [adj]\n",
  "UNREPRESENTED": "not represented [adj]\n",
  "UNREPRESSED": "not repressed [adj]\n",
  "UNREPRIEVABLE": "not reprievable [adj]\n",
  "UNREPRIEVED": "not reprieved [adj]\n",
  "UNREPRIMANDED": "not reprimanded [adj]\n",
  "UNREPROACHED": "not reproached [adj]\n",
  "UNREPROACHFUL": "not reproachful [adj]\n",
  "UNREPROACHING": "not reproaching [adj]\n",
  "UNREPRODUCIBLE": "not reproducible [adj]\n",
  "UNREPROVABLE": "not reprovable [adj]\n",
  "UNREPROVED": "not reproved [adj]\n",
  "UNREPROVING": "not reproving [adj]\n",
  "UNREPUGNANT": "not repugnant [adj]\n",
  "UNREPULSABLE": "that cannot be repulsed [adj]\n",
  "UNREQUESTED": "not requested [adj]\n",
  "UNREQUIRED": "not required [adj]\n",
  "UNREQUISITE": "not requisite [adj]\n",
  "UNREQUITED": "not requited [adj UNREQUITEDLY]\n",
  "UNREQUITEDLY": "UNREQUITED, not requited [adv]\n",
  "UNRESCINDED": "not rescinded [adj]\n",
  "UNRESENTED": "not resented [adj]\n",
  "UNRESENTFUL": "not resentful [adj]\n",
  "UNRESENTING": "not resenting [adj]\n",
  "UNRESERVE": "absence of reserve, frankness [n -S]\n",
  "UNRESERVED": "not reserved, unrestrained [adj UNRESERVEDLY]\n",
  "UNRESERVEDLY": "UNRESERVED, not reserved, unrestrained [adv]\n",
  "UNRESERVEDNESS": "the state of being unreserved [n]\n",
  "UNRESERVES": "UNRESERVE, absence of reserve, frankness [n]\n",
  "UNRESISTANT": "not resistant [adj]\n",
  "UNRESISTED": "not resisted; unopposed [adj]\n",
  "UNRESISTIBLE": "not resistible [adj]\n",
  "UNRESISTING": "not resisting [adj UNRESISTINGLY]\n",
  "UNRESISTINGLY": "UNRESISTING, not resisting [adv]\n",
  "UNRESOLVABLE": "not resolvable [adj]\n",
  "UNRESOLVED": "not resolved [adj]\n",
  "UNRESOLVEDNESS": "the state of being unresolved [n]\n",
  "UNRESPECTABLE": "one who is not respectable [n -S]\n",
  "UNRESPECTABLES": "UNRESPECTABLE, one who is not respectable [n]\n",
  "UNRESPECTED": "not respected [adj]\n",
  "UNRESPECTIVE": "indiscriminate [adj]\n",
  "UNRESPITED": "(Milton) without respite or pause [adj]\n",
  "UNRESPONSIVE": "not responsive [adj UNRESPONSIVELY]\n",
  "UNRESPONSIVELY": "UNRESPONSIVE, not responsive [adv]\n",
  "UNREST": "a disturbed or uneasy state [n -S]\n",
  "UNRESTED": "not rested [adj]\n",
  "UNRESTFUL": "not restful [adj]\n",
  "UNRESTFULNESS": "the state of being unrestful [n -ES]\n",
  "UNRESTFULNESSES": "UNRESTFULNESS, the state of being unrestful [n]\n",
  "UNRESTING": "not resting [adj UNRESTINGLY]\n",
  "UNRESTINGLY": "UNRESTING, not resting [adv]\n",
  "UNRESTINGNESS": "the state of being unresting [n -ES]\n",
  "UNRESTINGNESSES": "UNRESTINGNESS, the state of being unresting [n]\n",
  "UNRESTORED": "not restored [adj]\n",
  "UNRESTRAINABLE": "not restrainable [adj]\n",
  "UNRESTRAINED": "not restrained [adj UNRESTRAINEDLY]\n",
  "UNRESTRAINEDLY": "UNRESTRAINED, not restrained [adv]\n",
  "UNRESTRAINT": "freedom from or lack of restraint [n -S]\n",
  "UNRESTRAINTS": "UNRESTRAINT, freedom from or lack of restraint [n]\n",
  "UNRESTRICTED": "not restricted [adj]\n",
  "UNRESTRICTEDLY": "UNRESTRICTED, not restricted [adv]\n",
  "UNRESTS": "UNREST, a disturbed or uneasy state [n]\n",
  "UNRETARDED": "not retarded [adj]\n",
  "UNRETENTIVE": "not retentive [adj]\n",
  "UNRETIRE": "to return to work after having taken retirement [v UNRETIRED, UNRETIRING, UNRETIRES]\n",
  "UNRETIRED": "UNRETIRE, to return to work after having taken retirement [v]\n",
  "UNRETIRES": "UNRETIRE, to return to work after having taken retirement [v]\n",
  "UNRETIRING": "UNRETIRE, to return to work after having taken retirement [v]\n",
  "UNRETOUCHED": "not retouched [adj]\n",
  "UNRETURNABLE": "not returnable [adj]\n",
  "UNRETURNED": "not returned [adj]\n",
  "UNRETURNING": "not returning [adj UNRETURNINGLY]\n",
  "UNRETURNINGLY": "UNRETURNING, not returning [adv]\n",
  "UNREVEALABLE": "not revealable [adj]\n",
  "UNREVEALED": "not revealed [adj]\n",
  "UNREVEALING": "not revealing [adj]\n",
  "UNREVENGED": "not revenged [adj]\n",
  "UNREVENGEFUL": "not revengeful [adj]\n",
  "UNREVEREND": "not reverend [adj]\n",
  "UNREVERENT": "irreverent [adj]\n",
  "UNREVERSED": "not reversed [adj]\n",
  "UNREVERTED": "not turned back [adj]\n",
  "UNREVIEWABLE": "not reviewable [adj]\n",
  "UNREVIEWED": "not reviewed [adj]\n",
  "UNREVISED": "not revised [adj]\n",
  "UNREVOKED": "not revoked [adj]\n",
  "UNREVOLUTIONARY": "not revolutionary [adj]\n",
  "UNREWARDED": "not rewarded [adj UNREWARDEDLY]\n",
  "UNREWARDEDLY": "UNREWARDED, not rewarded [adv]\n",
  "UNREWARDING": "not rewarding [adj]\n",
  "UNRHETORICAL": "not rhetorical [adj]\n",
  "UNRHYMED": "not rhymed [adj]\n",
  "UNRHYTHMIC": "not rhythmic, also UNRHYTHMICAL [adj UNRHYTHMICALLY]\n",
  "UNRHYTHMICAL": "not rhythmical, also UNRHYTHMIC [adj UNRHYTHMICALLY]\n",
  "UNRHYTHMICALLY": "UNRHYTHMICAL, not rhythmical, also UNRHYTHMIC [adv]\n",
  "UNRIBBED": "not ribbed [adj]\n",
  "UNRID": "(archaic) unridden [adj]\n",
  "UNRIDABLE": "that cannot be ridden, also UNRIDEABLE [adj]\n",
  "UNRIDDEN": "not ridden [adj]\n",
  "UNRIDDLE": "to work out a riddle [v UNRIDDLED, UNRIDDLING, UNRIDDLES]\n",
  "UNRIDDLEABLE": "undecipherable [adj]\n",
  "UNRIDDLED": "UNRIDDLE, to work out a riddle [v]\n",
  "UNRIDDLER": "one who unriddles [n -S]\n",
  "UNRIDDLERS": "UNRIDDLER, one who unriddles [n]\n",
  "UNRIDDLES": "UNRIDDLE, to work out a riddle [v]\n",
  "UNRIDDLING": "UNRIDDLE, to work out a riddle [v]\n",
  "UNRIDEABLE": "that cannot be ridden, also UNRIDABLE [adj]\n",
  "UNRIDGED": "not ridged [adj]\n",
  "UNRIFLED": "not rifled [adj]\n",
  "UNRIG": "to divest of rigging [v UNRIGGED, UNRIGGING, UNRIGS]\n",
  "UNRIGGED": "UNRIG, to divest of rigging [v]\n",
  "UNRIGGING": "UNRIG, to divest of rigging [v]\n",
  "UNRIGHT": "to wrong or to make wrong [v -ED, -ING, -S]\n",
  "UNRIGHTED": "UNRIGHT, to wrong or to make wrong [v]\n",
  "UNRIGHTEOUS": "not righteous [adj UNRIGHTEOUSLY]\n",
  "UNRIGHTEOUSLY": "UNRIGHTEOUS, not righteous [adv]\n",
  "UNRIGHTEOUSNESS": "the state of being unrighteous [n]\n",
  "UNRIGHTFUL": "not rightful [adj UNRIGHTFULLY]\n",
  "UNRIGHTFULLY": "UNRIGHTFUL, not rightful [adv]\n",
  "UNRIGHTFULNESS": "the state of being unrightful [n]\n",
  "UNRIGHTING": "UNRIGHT, to wrong or to make wrong [v]\n",
  "UNRIGHTS": "UNRIGHT, to wrong or to make wrong [v]\n",
  "UNRIGS": "UNRIG, to divest of rigging [v]\n",
  "UNRIMED": "not rhymed, also UNRHYMED [adj]\n",
  "UNRINGED": "not ringed [adj]\n",
  "UNRINSED": "not rinsed [adj]\n",
  "UNRIP": "to rip open [v UNRIPPED, UNRIPPING, UNRIPS]\n",
  "UNRIPE": "not mature enough [adj UNRIPER, UNRIPEST, UNRIPELY]\n",
  "UNRIPELY": "UNRIPE, not mature enough [adv]\n",
  "UNRIPENED": "not ripened [adj]\n",
  "UNRIPENESS": "the state of being unripe [n -ES]\n",
  "UNRIPENESSES": "UNRIPENESS, the state of being unripe [n]\n",
  "UNRIPER": "UNRIPE, not mature enough [adj]\n",
  "UNRIPEST": "UNRIPE, not mature enough [adj]\n",
  "UNRIPPED": "UNRIP, to rip open [v]\n",
  "UNRIPPING": "the act of unripping [n -S]\n",
  "UNRIPPINGS": "UNRIPPING, the act of unripping [n]\n",
  "UNRIPS": "UNRIP, to rip open [v]\n",
  "UNRISEN": "not risen [adj]\n",
  "UNRIVALED": "without a rival, also UNRIVALLED [adj]\n",
  "UNRIVALLED": "without a rival, also UNRIVALED [adj]\n",
  "UNRIVEN": "not riven [adj]\n",
  "UNRIVET": "to take out, or loose, the rivets of; as, to unrivet boiler plates [v UNRIVETED or UNRIVETTED, UNRIVETING or UNRIVETTING, UNRIVETS]\n",
  "UNRIVETED": "UNRIVET, to take out, or loose, the rivets of; as, to unrivet boiler plates [v]\n",
  "UNRIVETING": "UNRIVET, to take out, or loose, the rivets of; as, to unrivet boiler plates [v]\n",
  "UNRIVETS": "UNRIVET, to take out, or loose, the rivets of; as, to unrivet boiler plates [v]\n",
  "UNRIVETTED": "UNRIVET, to take out, or loose, the rivets of; as, to unrivet boiler plates [v]\n",
  "UNRIVETTING": "UNRIVET, to take out, or loose, the rivets of; as, to unrivet boiler plates [v]\n",
  "UNROADWORTHY": "not roadworthy [adj]\n",
  "UNROASTED": "not roasted [adj]\n",
  "UNROBE": "to take off a robe [v UNROBED, UNROBING, UNROBES]\n",
  "UNROBED": "UNROBE, to take off a robe [v]\n",
  "UNROBES": "UNROBE, to take off a robe [v]\n",
  "UNROBING": "UNROBE, to take off a robe [v]\n",
  "UNROLL": "to open something that is rolled up [v -ED, -ING, -S]\n",
  "UNROLLED": "UNROLL, to open something that is rolled up [v]\n",
  "UNROLLING": "UNROLL, to open something that is rolled up [v]\n",
  "UNROLLS": "UNROLL, to open something that is rolled up [v]\n",
  "UNROMANISED": "not romanised, also UNROMANIZED [adj]\n",
  "UNROMANIZED": "not romanized, also UNROMANISED [adj]\n",
  "UNROMANTIC": "not romantic, also UNROMANTICAL [adj UNROMANTICALLY]\n",
  "UNROMANTICAL": "not romantic, also UNROMANTIC [adj UNROMANTICALLY]\n",
  "UNROMANTICALLY": "UNROMANTICAL, not romantic, also UNROMANTIC [adv]\n",
  "UNROMANTICISED": "not romanticised, also UNROMANTICIZED [adj]\n",
  "UNROMANTICIZED": "not romanticized, also UNROMANTICISED [adj]\n",
  "UNROOF": "to remove the roof [v -ED, -ING, -S]\n",
  "UNROOFED": "UNROOF, to remove the roof [v]\n",
  "UNROOFING": "UNROOF, to remove the roof [v]\n",
  "UNROOFS": "UNROOF, to remove the roof [v]\n",
  "UNROOST": "(Shakespeare) to drive from a roost [v -ED, -ING, -S]\n",
  "UNROOSTED": "UNROOST, (Shakespeare) to drive from a roost [v]\n",
  "UNROOSTING": "UNROOST, (Shakespeare) to drive from a roost [v]\n",
  "UNROOSTS": "UNROOST, (Shakespeare) to drive from a roost [v]\n",
  "UNROOT": "to tear up by the roots [v -ED, -ING, -S]\n",
  "UNROOTED": "UNROOT, to tear up by the roots [v]\n",
  "UNROOTING": "UNROOT, to tear up by the roots [v]\n",
  "UNROOTS": "UNROOT, to tear up by the roots [v]\n",
  "UNROPE": "to loose from a rope [v UNROPED, UNROPING, UNROPES]\n",
  "UNROPED": "UNROPE, to loose from a rope [v]\n",
  "UNROPES": "UNROPE, to loose from a rope [v]\n",
  "UNROPING": "UNROPE, to loose from a rope [v]\n",
  "UNROSINED": "not coated with rosin [adj]\n",
  "UNROTTED": "not rotted [adj]\n",
  "UNROTTEN": "not rotten [adj]\n",
  "UNROUGED": "not rouged [adj]\n",
  "UNROUGH": "not rough, beardless, also UNRUFFE [adj]\n",
  "UNROUND": "to articulate without rounding the lips [v -ED, -ING, -S]\n",
  "UNROUNDED": "UNROUND, to articulate without rounding the lips [v]\n",
  "UNROUNDING": "UNROUND, to articulate without rounding the lips [v]\n",
  "UNROUNDS": "UNROUND, to articulate without rounding the lips [v]\n",
  "UNROUSED": "not roused [adj]\n",
  "UNROVE": "UNREEVE, to withdraw a rope from an opening [v]\n",
  "UNROVEN": "UNREEVE, to withdraw a rope from an opening [v]\n",
  "UNROYAL": "not royal [adj UNROYALLY]\n",
  "UNROYALLY": "UNROYAL, not royal [adv]\n",
  "UNRUBBED": "not rubbed [adj]\n",
  "UNRUDE": "not rude [adj]\n",
  "UNRUFFABLE": "(Dickens) imperturbable [adj]\n",
  "UNRUFFE": "(Shakespeare) beardless, also UNROUGH [adj]\n",
  "UNRUFFLE": "to recover from ruffling [v UNRUFFLED, UNRUFFLING, UNRUFFLES]\n",
  "UNRUFFLED": "UNRUFFLE, to recover from ruffling [v]\n",
  "UNRUFFLEDNESS": "the state of being unruffled [n -ES]\n",
  "UNRUFFLEDNESSES": "UNRUFFLEDNESS, the state of being unruffled [n]\n",
  "UNRUFFLES": "UNRUFFLE, to recover from ruffling [v]\n",
  "UNRUFFLING": "UNRUFFLE, to recover from ruffling [v]\n",
  "UNRULE": "absence of government, anarchy [n -S]\n",
  "UNRULED": "not ruled [adj]\n",
  "UNRULES": "UNRULE, absence of government, anarchy [n]\n",
  "UNRULIER": "UNRULY, difficult to control [adj]\n",
  "UNRULIEST": "UNRULY, difficult to control [adj]\n",
  "UNRULIMENT": "(Spenser) unruliness [n -S]\n",
  "UNRULIMENTS": "UNRULIMENT, (Spenser) unruliness [n]\n",
  "UNRULINESS": "the state of being unruly [n -ES]\n",
  "UNRULINESSES": "UNRULINESS, the state of being unruly [n]\n",
  "UNRULY": "difficult to control [adj UNRULIER, UNRULIEST]\n",
  "UNRUMPLED": "not rumpled [adj]\n",
  "UNRUPTURED": "not ruptured [adj]\n",
  "UNRUSHED": "not rushed [adj]\n",
  "UNRUSTED": "not rusted [adj]\n",
  "UNS": "UN, (dialect) a spelling of 'one' intended to reflect a dialectal or informal pronunciation [n]\n",
  "UNSADDLE": "to remove the saddle from [v UNSADDLED, UNSADDLING, UNSADDLES]\n",
  "UNSADDLED": "UNSADDLE, to remove the saddle from [v]\n",
  "UNSADDLES": "UNSADDLE, to remove the saddle from [v]\n",
  "UNSADDLING": "UNSADDLE, to remove the saddle from [v]\n",
  "UNSAFE": "not safe [adj UNSAFER, UNSAFEST, UNSAFELY]\n",
  "UNSAFELY": "UNSAFE, not safe [adv]\n",
  "UNSAFENESS": "the state of being unsafe [n -ES]\n",
  "UNSAFENESSES": "UNSAFENESS, the state of being unsafe [n]\n",
  "UNSAFER": "UNSAFE, not safe [adj]\n",
  "UNSAFEST": "UNSAFE, not safe [adj]\n",
  "UNSAFETIES": "UNSAFETY, lack of safety [n]\n",
  "UNSAFETY": "lack of safety [n UNSAFETIES]\n",
  "UNSAID": "UNSAY, to retract something said [v]\n",
  "UNSAILED": "unnavigated [adj]\n",
  "UNSAILORLIKE": "not like or befitting a sailor [adj]\n",
  "UNSAINED": "unblessed [adj]\n",
  "UNSAINT": "to divest of saintliness [v -ED, -ING, -S]\n",
  "UNSAINTED": "UNSAINT, to divest of saintliness [v]\n",
  "UNSAINTING": "UNSAINT, to divest of saintliness [v]\n",
  "UNSAINTLIER": "UNSAINTLY, not like a saint [adj]\n",
  "UNSAINTLIEST": "UNSAINTLY, not like a saint [adj]\n",
  "UNSAINTLINESS": "the state of being unsaintly [n -ES]\n",
  "UNSAINTLINESSES": "UNSAINTLINESS, the state of being unsaintly [n]\n",
  "UNSAINTLY": "not like a saint [adj UNSAINTLIER, UNSAINTLIEST]\n",
  "UNSAINTS": "UNSAINT, to divest of saintliness [v]\n",
  "UNSALABILITIES": "UNSALABILITY, the quality of being unsalable [n]\n",
  "UNSALABILITY": "the quality of being unsalable [n UNSALABILITIES]\n",
  "UNSALABLE": "that cannot be sold, also UNSALEABLE [adj UNSALABLY]\n",
  "UNSALABLY": "UNSALABLE, that cannot be sold, also UNSALEABLE [adv]\n",
  "UNSALARIED": "not receiving a salary [adj]\n",
  "UNSALEABILITIES": "UNSALEABILITY, the quality of being unsaleable [n]\n",
  "UNSALEABILITY": "the quality of being unsaleable [n UNSALEABILITIES]\n",
  "UNSALEABLE": "not saleable, also UNSALABLE [adj UNSALEABLY]\n",
  "UNSALEABLY": "UNSALEABLE, not saleable, also UNSALABLE [adv]\n",
  "UNSALTED": "not salted [adj]\n",
  "UNSALUTED": "not saluted [adj]\n",
  "UNSALVAGEABLE": "not salvageable [adj]\n",
  "UNSAMPLED": "not sampled [adj]\n",
  "UNSANCTIFIED": "not sanctified [adj]\n",
  "UNSANCTIFIES": "UNSANCTIFY, to remove the sanctity from [v]\n",
  "UNSANCTIFY": "to remove the sanctity from [v UNSANCTIFIED, UNSANCTIFYING, UNSANCTIFIES]\n",
  "UNSANCTIFYING": "UNSANCTIFY, to remove the sanctity from [v]\n",
  "UNSANCTIONED": "not sanctioned [adj]\n",
  "UNSANDALLED": "not wearing sandals [adj]\n",
  "UNSANITARY": "not sanitary [adj]\n",
  "UNSAPPED": "not sapped [adj]\n",
  "UNSASHED": "not sashed [adj]\n",
  "UNSATABLE": "that cannot be sated [adj]\n",
  "UNSATED": "not sated [adj]\n",
  "UNSATIABLE": "insatiable [adj]\n",
  "UNSATIATE": "not satiated, also UNSATIATED [adj]\n",
  "UNSATIATED": "not satiated, also UNSATIATE [adj]\n",
  "UNSATIATING": "not satiating [adj]\n",
  "UNSATING": "not sating [adj]\n",
  "UNSATIRICAL": "not satirical [adj]\n",
  "UNSATISFACTION": "lack of satisfaction [n -S]\n",
  "UNSATISFACTIONS": "UNSATISFACTION, lack of satisfaction [n]\n",
  "UNSATISFACTORY": "not satisfactory [adj]\n",
  "UNSATISFIABLE": "not satisfiable [adj]\n",
  "UNSATISFIED": "not satisfied [adj]\n",
  "UNSATISFIEDNESS": "the state of being unsatisfied [n]\n",
  "UNSATISFYING": "not satisfying [adj]\n",
  "UNSATURATE": "an unsaturated chemical compound [n -S]\n",
  "UNSATURATED": "not saturated [adj]\n",
  "UNSATURATES": "UNSATURATE, an unsaturated chemical compound [n]\n",
  "UNSATURATION": "absence of saturation [n -S]\n",
  "UNSATURATIONS": "UNSATURATION, absence of saturation [n]\n",
  "UNSAVED": "not saved [adj]\n",
  "UNSAVORIER": "UNSAVORY, not savory, also UNSAVOURY [adj]\n",
  "UNSAVORIEST": "UNSAVORY, not savory, also UNSAVOURY [adj]\n",
  "UNSAVORILY": "UNSAVORY, not savory, also UNSAVOURY [adv]\n",
  "UNSAVORINESS": "the state of being unsavory [n -ES]\n",
  "UNSAVORINESSES": "UNSAVORINESS, the state of being unsavory [n]\n",
  "UNSAVORY": "not savory, also UNSAVOURY [adj UNSAVORIER, UNSAVORIEST; UNSAVORILY]\n",
  "UNSAVOURIER": "UNSAVOURY, not savoury, also UNSAVORY [adj]\n",
  "UNSAVOURIEST": "UNSAVOURY, not savoury, also UNSAVORY [adj]\n",
  "UNSAVOURILY": "UNSAVOURY, not savoury, also UNSAVORY [adv]\n",
  "UNSAVOURINESS": "the state of being unsavoury [n -ES]\n",
  "UNSAVOURINESSES": "UNSAVOURINESS, the state of being unsavoury [n]\n",
  "UNSAVOURY": "not savoury, also UNSAVORY [adj UNSAVOURIER, UNSAVOURIEST; UNSAVOURILY]\n",
  "UNSAW": "UNSEE, to fail to see [v]\n",
  "UNSAWED": "not sawed [adj]\n",
  "UNSAWN": "not sawn [adj]\n",
  "UNSAY": "to retract something said [v UNSAID, UNSAYING, UNSAYS]\n",
  "UNSAYABLE": "that cannot be said [adj] / something that cannot be said [n -S]\n",
  "UNSAYABLES": "UNSAYABLE, something that cannot be said [n]\n",
  "UNSAYING": "UNSAY, to retract something said [v]\n",
  "UNSAYS": "UNSAY, to retract something said [v]\n",
  "UNSCABBARD": "to withdraw e.g. a sword from a scabbard [v -ED, -ING, -S]\n",
  "UNSCABBARDED": "UNSCABBARD, to withdraw e.g. a sword from a scabbard [v]\n",
  "UNSCABBARDING": "UNSCABBARD, to withdraw e.g. a sword from a scabbard [v]\n",
  "UNSCABBARDS": "UNSCABBARD, to withdraw e.g. a sword from a scabbard [v]\n",
  "UNSCALABLE": "not scalable [adj]\n",
  "UNSCALE": "to remove the scales from [v UNSCALED, UNSCALING, UNSCALES]\n",
  "UNSCALED": "UNSCALE, to remove the scales from [v]\n",
  "UNSCALES": "UNSCALE, to remove the scales from [v]\n",
  "UNSCALING": "UNSCALE, to remove the scales from [v]\n",
  "UNSCANNED": "not scanned as verse [adj]\n",
  "UNSCARIER": "UNSCARY, not scary [adj]\n",
  "UNSCARIEST": "UNSCARY, not scary [adj]\n",
  "UNSCARRED": "not scarred [adj]\n",
  "UNSCARY": "not scary [adj UNSCARIER, UNSCARIEST]\n",
  "UNSCATHED": "not scathed [adj]\n",
  "UNSCAVENGERED": "not scavengered [adj]\n",
  "UNSCENTED": "not scented [adj]\n",
  "UNSCEPTRED": "having no sceptre [adj]\n",
  "UNSCHEDULED": "not scheduled [adj]\n",
  "UNSCHOLARLIKE": "not like a scholar [adj]\n",
  "UNSCHOLARLY": "not scholarly [adj]\n",
  "UNSCHOOLED": "not schooled [adj]\n",
  "UNSCIENTIFIC": "not scientific [adj]\n",
  "UNSCISSORED": "not scissored [adj]\n",
  "UNSCORCHED": "not scorched [adj]\n",
  "UNSCOTTIFIED": "not made Scottish [adj]\n",
  "UNSCOURED": "not scoured [adj]\n",
  "UNSCRAMBLE": "to separate (as a conglomeration or tangle) into original components [v UNSCRAMBLED, UNSCRAMBLING, UNSCRAMBLES]\n",
  "UNSCRAMBLED": "UNSCRAMBLE, to separate (as a conglomeration or tangle) into original components [v]\n",
  "UNSCRAMBLER": "one who unscrambles [n -S]\n",
  "UNSCRAMBLERS": "UNSCRAMBLER, one who unscrambles [n]\n",
  "UNSCRAMBLES": "UNSCRAMBLE, to separate (as a conglomeration or tangle) into original components [v]\n",
  "UNSCRAMBLING": "UNSCRAMBLE, to separate (as a conglomeration or tangle) into original components [v]\n",
  "UNSCRATCHED": "not scratched [adj]\n",
  "UNSCREENED": "not screened [adj]\n",
  "UNSCREW": "to remove the screws from [v -ED, -ING, -S]\n",
  "UNSCREWED": "UNSCREW, to remove the screws from [v]\n",
  "UNSCREWING": "UNSCREW, to remove the screws from [v]\n",
  "UNSCREWS": "UNSCREW, to remove the screws from [v]\n",
  "UNSCRIPTED": "not following a prepared script [adj]\n",
  "UNSCRIPTURAL": "not scriptural [adj UNSCRIPTURALLY]\n",
  "UNSCRIPTURALLY": "UNSCRIPTURAL, not scriptural [adv]\n",
  "UNSCRUPLED": "unscrupulous [adj]\n",
  "UNSCRUPULOSITY": "lack of scrupulosity [n]\n",
  "UNSCRUPULOUS": "not scrupulous [adj UNSCRUPULOUSLY]\n",
  "UNSCRUPULOUSLY": "UNSCRUPULOUS, not scrupulous [adv]\n",
  "UNSCRUTINISED": "not scrutinised, also UNSCRUTINIZED [adj]\n",
  "UNSCRUTINIZED": "not scrutinized, also UNSCRUTINISED [adj]\n",
  "UNSCULPTURED": "not sculptured [adj]\n",
  "UNSCYTHED": "not scythed [adj]\n",
  "UNSEAL": "to break the seal of [v -ED, -ING, -S]\n",
  "UNSEALABLE": "that cannot be sealed [adj]\n",
  "UNSEALED": "UNSEAL, to break the seal of [v]\n",
  "UNSEALING": "UNSEAL, to break the seal of [v]\n",
  "UNSEALS": "UNSEAL, to break the seal of [v]\n",
  "UNSEAM": "to open the seams of [v -ED, -ING, -S]\n",
  "UNSEAMED": "UNSEAM, to open the seams of [v]\n",
  "UNSEAMING": "UNSEAM, to open the seams of [v]\n",
  "UNSEAMS": "UNSEAM, to open the seams of [v]\n",
  "UNSEARCHABLE": "not capable of being searched or explored [adj UNSEARCHABLY] / a thing which is not able to be searched for [n -S]\n",
  "UNSEARCHABLES": "UNSEARCHABLE, a thing which is not able to be searched for [n]\n",
  "UNSEARCHABLY": "UNSEARCHABLE, not capable of being searched or explored [adv]\n",
  "UNSEARCHED": "not searched [adj]\n",
  "UNSEARED": "not seared [adj]\n",
  "UNSEASON": "(Spenser) to affect disagreeably [v -ED, -ING, -S]\n",
  "UNSEASONABLE": "occurring at other than the proper time [adj UNSEASONABLY]\n",
  "UNSEASONABLY": "UNSEASONABLE, occurring at other than the proper time [adv]\n",
  "UNSEASONED": "UNSEASON, (Spenser) to affect disagreeably [v]\n",
  "UNSEASONEDNESS": "the state of being unseasoned [n]\n",
  "UNSEASONING": "UNSEASON, (Spenser) to affect disagreeably [v]\n",
  "UNSEASONS": "UNSEASON, (Spenser) to affect disagreeably [v]\n",
  "UNSEAT": "to remove from a seat [v -ED, -ING, -S]\n",
  "UNSEATED": "UNSEAT, to remove from a seat [v]\n",
  "UNSEATING": "UNSEAT, to remove from a seat [v]\n",
  "UNSEATS": "UNSEAT, to remove from a seat [v]\n",
  "UNSEAWORTHINESS": "the state of being unseaworthy [n]\n",
  "UNSEAWORTHY": "not good enough to be used on the sea [adj]\n",
  "UNSECONDED": "not seconded [adj]\n",
  "UNSECRET": "(Shakespeare) to inform or make aware [v -ED, -ING, -S]\n",
  "UNSECRETED": "UNSECRET, (Shakespeare) to inform or make aware [v]\n",
  "UNSECRETING": "UNSECRET, (Shakespeare) to inform or make aware [v]\n",
  "UNSECRETS": "UNSECRET, (Shakespeare) to inform or make aware [v]\n",
  "UNSECTARIAN": "someone who is not sectarian [n -S]\n",
  "UNSECTARIANISM": "lack of sectarianism [n -S]\n",
  "UNSECTARIANISMS": "UNSECTARIANISM, lack of sectarianism [n]\n",
  "UNSECTARIANS": "UNSECTARIAN, someone who is not sectarian [n]\n",
  "UNSECULAR": "not secular [adj]\n",
  "UNSECURED": "not secured [adj]\n",
  "UNSEDUCED": "not seduced [adj]\n",
  "UNSEE": "to fail to see [v UNSAW, UNSEEN, UNSEEING, UNSEES]\n",
  "UNSEEABLE": "that cannot be seen [adj]\n",
  "UNSEEDED": "not seeded [adj]\n",
  "UNSEEING": "UNSEE, to fail to see [v]\n",
  "UNSEEL": "to unstitch a hawk's eyelids [v -ED, -ING, -S]\n",
  "UNSEELED": "UNSEEL, to unstitch a hawk's eyelids [v]\n",
  "UNSEELIE": "evil malevolent fairies [n]\n",
  "UNSEELING": "UNSEEL, to unstitch a hawk's eyelids [v]\n",
  "UNSEELS": "UNSEEL, to unstitch a hawk's eyelids [v]\n",
  "UNSEEMING": "(Shakespeare) a not seeming [n -S]\n",
  "UNSEEMINGS": "UNSEEMING, (Shakespeare) a not seeming [n]\n",
  "UNSEEMLIER": "UNSEEMLY, not seemly [adj]\n",
  "UNSEEMLIEST": "UNSEEMLY, not seemly [adj]\n",
  "UNSEEMLINESS": "the state of being unseemly [n -ES]\n",
  "UNSEEMLINESSES": "UNSEEMLINESS, the state of being unseemly [n]\n",
  "UNSEEMLY": "not seemly [adj UNSEEMLIER, UNSEEMLIEST]\n",
  "UNSEEN": "an unprepared passage for translation [n -S]\n",
  "UNSEENS": "UNSEEN, an unprepared passage for translation [n]\n",
  "UNSEES": "UNSEE, to fail to see [v]\n",
  "UNSEGMENTED": "not segmented [adj]\n",
  "UNSEGREGATED": "not segregated [adj]\n",
  "UNSEISABLE": "that cannot be possessed by seisin [adj]\n",
  "UNSEIZABLE": "not able to be seized [adj]\n",
  "UNSEIZED": "not seized [adj]\n",
  "UNSELDOM": "not seldom [adv]\n",
  "UNSELECTED": "not selected [adj]\n",
  "UNSELECTIVE": "not marked by selection [adj UNSELECTIVELY]\n",
  "UNSELECTIVELY": "UNSELECTIVE, not marked by selection [adv]\n",
  "UNSELF": "altruism, impartiality [n UNSELVES] / to deprive of the self [v -ED, -ING, -S]\n",
  "UNSELFCONSCIOUS": "not conscious of oneself [adj]\n",
  "UNSELFED": "UNSELF, to deprive of the self [v]\n",
  "UNSELFING": "UNSELF, to deprive of the self [v]\n",
  "UNSELFISH": "not selfish [adj UNSELFISHLY]\n",
  "UNSELFISHLY": "UNSELFISH, not selfish [adv]\n",
  "UNSELFISHNESS": "the state of being unselfish [n -ES]\n",
  "UNSELFISHNESSES": "UNSELFISHNESS, the state of being unselfish [n]\n",
  "UNSELFS": "UNSELF, to deprive of the self [v]\n",
  "UNSELL": "to speak disparagingly about [v UNSOLD, UNSELLING, UNSELLS]\n",
  "UNSELLABLE": "not sellable [adj]\n",
  "UNSELLING": "UNSELL, to speak disparagingly about [v]\n",
  "UNSELLS": "UNSELL, to speak disparagingly about [v]\n",
  "UNSELVES": "UNSELF, altruism, impartiality [n]\n",
  "UNSEMINARIED": "(Shakespeare) without means of generation, deprived of semen or seed [adj]\n",
  "UNSENSATIONAL": "not sensational [adj]\n",
  "UNSENSE": "to deprive of sense [v UNSENSED, UNSENSING, UNSENSES]\n",
  "UNSENSED": "UNSENSE, to deprive of sense [v]\n",
  "UNSENSES": "UNSENSE, to deprive of sense [v]\n",
  "UNSENSIBLE": "insensible [adj UNSENSIBLY]\n",
  "UNSENSIBLY": "UNSENSIBLE, insensible [adv]\n",
  "UNSENSING": "UNSENSE, to deprive of sense [v]\n",
  "UNSENSITISED": "not sensitised, also UNSENSITIZED [adj]\n",
  "UNSENSITIVE": "not sensitive, also INSENSITIVE [adj]\n",
  "UNSENSITIZED": "not sensitized, also UNSENSITISED [adj]\n",
  "UNSENSUALISE": "to free from the dominion of the senses, also UNSENSUALIZE [v UNSENSUALISED, UNSENSUALISING, UNSENSUALISES]\n",
  "UNSENSUALISED": "UNSENSUALISE, to free from the dominion of the senses, also UNSENSUALIZE [v]\n",
  "UNSENSUALISES": "UNSENSUALISE, to free from the dominion of the senses, also UNSENSUALIZE [v]\n",
  "UNSENSUALISING": "UNSENSUALISE, to free from the dominion of the senses, also UNSENSUALIZE [v]\n",
  "UNSENSUALIZE": "to free from the dominion of the senses, also UNSENSUALISE [v UNSENSUALIZED, UNSENSUALIZING, UNSENSUALIZES]\n",
  "UNSENSUALIZED": "UNSENSUALIZE, to free from the dominion of the senses, also UNSENSUALISE [v]\n",
  "UNSENSUALIZES": "UNSENSUALIZE, to free from the dominion of the senses, also UNSENSUALISE [v]\n",
  "UNSENSUALIZING": "UNSENSUALIZE, to free from the dominion of the senses, also UNSENSUALISE [v]\n",
  "UNSENT": "not sent [adj]\n",
  "UNSENTENCED": "not sentenced [adj]\n",
  "UNSENTIMENTAL": "not sentimental [adj]\n",
  "UNSEPARABLE": "(Shakespeare) inseparable, also INSEPARABLE [adj]\n",
  "UNSEPARATED": "not separate [adj]\n",
  "UNSEPULCHRED": "not sepulchred [adj]\n",
  "UNSERIOUS": "not serious [adj]\n",
  "UNSERIOUSNESS": "the state of being unserious [n -ES]\n",
  "UNSERIOUSNESSES": "UNSERIOUSNESS, the state of being unserious [n]\n",
  "UNSERVED": "not served [adj]\n",
  "UNSERVICEABLE": "not capable of being employed for their proper purpose [adj]\n",
  "UNSET": "to undo the setting of [v UNSET, UNSETTING, UNSETS]\n",
  "UNSETS": "UNSET, to undo the setting of [v]\n",
  "UNSETTING": "UNSET, to undo the setting of [v]\n",
  "UNSETTLE": "to make unstable [v UNSETTLED, UNSETTLING, UNSETTLES]\n",
  "UNSETTLED": "UNSETTLE, to make unstable [v]\n",
  "UNSETTLEDLY": "UNSETTLED, UNSETTLE, to make unstable [adv]\n",
  "UNSETTLEDNESS": "the state of being unsettled [n -ES]\n",
  "UNSETTLEDNESSES": "UNSETTLEDNESS, the state of being unsettled [n]\n",
  "UNSETTLEMENT": "an act, process, or instance of unsettling [n -S]\n",
  "UNSETTLEMENTS": "UNSETTLEMENT, an act, process, or instance of unsettling [n]\n",
  "UNSETTLES": "UNSETTLE, to make unstable [v]\n",
  "UNSETTLING": "disconcerting [adj UNSETTLINGLY] / the act of unsettling [n -S]\n",
  "UNSETTLINGLY": "UNSETTLING, disconcerting [adv]\n",
  "UNSETTLINGS": "UNSETTLING, the act of unsettling [n]\n",
  "UNSEVERED": "not severed [adj]\n",
  "UNSEW": "to undo the sewing of [v UNSEWED, UNSEWN, UNSEWING, UNSEWS]\n",
  "UNSEWED": "UNSEW, to undo the sewing of [v]\n",
  "UNSEWING": "UNSEW, to undo the sewing of [v]\n",
  "UNSEWN": "UNSEW, to undo the sewing of [v]\n",
  "UNSEWS": "UNSEW, to undo the sewing of [v]\n",
  "UNSEX": "to deprive of sexual power [v -ED, -ING, -ES]\n",
  "UNSEXED": "UNSEX, to deprive of sexual power [v]\n",
  "UNSEXES": "UNSEX, to deprive of sexual power [v]\n",
  "UNSEXIER": "UNSEXY, not sexy [adj]\n",
  "UNSEXIEST": "UNSEXY, not sexy [adj]\n",
  "UNSEXILY": "UNSEXY, not sexy [adv]\n",
  "UNSEXING": "UNSEX, to deprive of sexual power [v]\n",
  "UNSEXIST": "not sexist [adj]\n",
  "UNSEXUAL": "not sexual [adj]\n",
  "UNSEXY": "not sexy [adj UNSEXIER, UNSEXIEST; UNSEXILY]\n",
  "UNSHACKLE": "to release from shackles [v UNSHACKLED, UNSHACKLING, UNSHACKLES]\n",
  "UNSHACKLED": "UNSHACKLE, to release from shackles [v]\n",
  "UNSHACKLES": "UNSHACKLE, to release from shackles [v]\n",
  "UNSHACKLING": "UNSHACKLE, to release from shackles [v]\n",
  "UNSHADED": "not shaded [adj]\n",
  "UNSHADOW": "to remove from shadow, clear of shadow [v -ED, -ING, -S]\n",
  "UNSHADOWABLE": "that cannot be shadowed [adj]\n",
  "UNSHADOWED": "UNSHADOW, to remove from shadow, clear of shadow [v]\n",
  "UNSHADOWING": "UNSHADOW, to remove from shadow, clear of shadow [v]\n",
  "UNSHADOWS": "UNSHADOW, to remove from shadow, clear of shadow [v]\n",
  "UNSHAKABLE": "that cannot be shaken, also UNSHAKEABLE [adj UNSHAKABLY]\n",
  "UNSHAKABLENESS": "the state of being unshakable [n]\n",
  "UNSHAKABLY": "UNSHAKABLE, that cannot be shaken, also UNSHAKEABLE [adv]\n",
  "UNSHAKEABLE": "that cannot be shaken, also UNSHAKABLE [adj UNSHAKEABLY]\n",
  "UNSHAKEABLENESS": "the state of being unshakeable [n]\n",
  "UNSHAKEABLY": "UNSHAKEABLE, that cannot be shaken, also UNSHAKABLE [adv]\n",
  "UNSHAKED": "(Shakespeare) unshaken [adj]\n",
  "UNSHAKEN": "not shaken [adj UNSHAKENLY]\n",
  "UNSHAKENLY": "UNSHAKEN, not shaken [adv]\n",
  "UNSHALE": "to strip the shale, or husk, from, also UNSHELL [v UNSHALED, UNSHALING, UNSHALES]\n",
  "UNSHALED": "UNSHALE, to strip the shale, or husk, from, also UNSHELL [v]\n",
  "UNSHALES": "UNSHALE, to strip the shale, or husk, from, also UNSHELL [v]\n",
  "UNSHALING": "UNSHALE, to strip the shale, or husk, from, also UNSHELL [v]\n",
  "UNSHAMED": "not shamed [adj]\n",
  "UNSHAPE": "to deprive of shape, undo [v UNSHAPED, UNSHAPEN, UNSHAPING, UNSHAPES]\n",
  "UNSHAPED": "UNSHAPE, to deprive of shape, undo [v]\n",
  "UNSHAPELIER": "UNSHAPELY, not shapely [adj]\n",
  "UNSHAPELIEST": "UNSHAPELY, not shapely [adj]\n",
  "UNSHAPELY": "not shapely [adj UNSHAPELIER, UNSHAPELIEST]\n",
  "UNSHAPEN": "UNSHAPE, to deprive of shape, undo [v]\n",
  "UNSHAPES": "UNSHAPE, to deprive of shape, undo [v]\n",
  "UNSHAPING": "UNSHAPE, to deprive of shape, undo [v]\n",
  "UNSHARED": "not shared [adj]\n",
  "UNSHARP": "not sharp [adj]\n",
  "UNSHARPENED": "not sharpened [adj]\n",
  "UNSHAVED": "not shaved, also UNSHAVEN [adj]\n",
  "UNSHAVEN": "not shaven, also UNSHAVED [adj]\n",
  "UNSHEATHE": "to remove from a sheath [v UNSHEATHED, UNSHEATHING, UNSHEATHES]\n",
  "UNSHEATHED": "UNSHEATHE, to remove from a sheath [v]\n",
  "UNSHEATHES": "UNSHEATHE, to remove from a sheath [v]\n",
  "UNSHEATHING": "UNSHEATHE, to remove from a sheath [v]\n",
  "UNSHED": "not shed [adj]\n",
  "UNSHELL": "to strip the shell from; to take out of the shell, also UNSHALE [v -ED, -ING, -S]\n",
  "UNSHELLED": "UNSHELL, to strip the shell from; to take out of the shell, also UNSHALE [v]\n",
  "UNSHELLING": "UNSHELL, to strip the shell from; to take out of the shell, also UNSHALE [v]\n",
  "UNSHELLS": "UNSHELL, to strip the shell from; to take out of the shell, also UNSHALE [v]\n",
  "UNSHELTERED": "not sheltered [adj]\n",
  "UNSHENT": "(archaic) not disgraced [adj]\n",
  "UNSHEWN": "(archaic) not shown [adj]\n",
  "UNSHIELDED": "not shielded [adj]\n",
  "UNSHIFT": "to release the shift key on a typewriter [v -ED, -ING, -S]\n",
  "UNSHIFTED": "UNSHIFT, to release the shift key on a typewriter [v]\n",
  "UNSHIFTING": "UNSHIFT, to release the shift key on a typewriter [v]\n",
  "UNSHIFTS": "UNSHIFT, to release the shift key on a typewriter [v]\n",
  "UNSHINGLED": "not shingled [adj]\n",
  "UNSHIP": "to unload from a ship [v UNSHIPPED, UNSHIPPING, UNSHIPS]\n",
  "UNSHIPPED": "UNSHIP, to unload from a ship [v]\n",
  "UNSHIPPING": "UNSHIP, to unload from a ship [v]\n",
  "UNSHIPS": "UNSHIP, to unload from a ship [v]\n",
  "UNSHIRTED": "not wearing a shirt [adj]\n",
  "UNSHOCKABLE": "not capable of being shocked [adj]\n",
  "UNSHOCKED": "not shocked [adj]\n",
  "UNSHOD": "not shod [adj]\n",
  "UNSHOE": "to strip of shoes [v UNSHOED, UNSHOD, UNSHOEING, UNSHOES]\n",
  "UNSHOED": "UNSHOE, to strip of shoes [v]\n",
  "UNSHOEING": "UNSHOE, to strip of shoes [v]\n",
  "UNSHOES": "UNSHOE, to strip of shoes [v]\n",
  "UNSHOOT": "(Shakespeare) to revoke the shouting of by a contrary shout, also UNSHOUT [v -ED, -ING, -S]\n",
  "UNSHOOTED": "UNSHOOT, (Shakespeare) to revoke the shouting of by a contrary shout, also UNSHOUT [v]\n",
  "UNSHOOTING": "UNSHOOT, (Shakespeare) to revoke the shouting of by a contrary shout, also UNSHOUT [v]\n",
  "UNSHOOTS": "UNSHOOT, (Shakespeare) to revoke the shouting of by a contrary shout, also UNSHOUT [v]\n",
  "UNSHORN": "not shorn [adj]\n",
  "UNSHOT": "to remove shot from [v UNSHOTTED, UNSHOTTING, UNSHOTS]\n",
  "UNSHOTS": "UNSHOT, to remove shot from [v]\n",
  "UNSHOTTED": "UNSHOT, to remove shot from [v]\n",
  "UNSHOTTING": "UNSHOT, to remove shot from [v]\n",
  "UNSHOUT": "to make a contrary shout, also UNSHOOT [v -ED, -ING, -S]\n",
  "UNSHOUTED": "UNSHOUT, to make a contrary shout, also UNSHOOT [v]\n",
  "UNSHOUTING": "UNSHOUT, to make a contrary shout, also UNSHOOT [v]\n",
  "UNSHOUTS": "UNSHOUT, to make a contrary shout, also UNSHOOT [v]\n",
  "UNSHOWERED": "not watered by showers [adj]\n",
  "UNSHOWIER": "UNSHOWY, not showy [adj]\n",
  "UNSHOWIEST": "UNSHOWY, not showy [adj]\n",
  "UNSHOWN": "not shown, also UNSHEWN [adj]\n",
  "UNSHOWY": "not showy [adj UNSHOWIER, UNSHOWIEST]\n",
  "UNSHRINKABLE": "not shrinkable [adj]\n",
  "UNSHRINKING": "not shrinking [adj UNSHRINKINGLY]\n",
  "UNSHRINKINGLY": "UNSHRINKING, not shrinking [adv]\n",
  "UNSHRIVED": "not shriven, also UNSHRIVEN [adj]\n",
  "UNSHRIVEN": "not shriven, also UNSHRIVED [adj]\n",
  "UNSHROUD": "to remove the shroud from; to uncover [v -ED, -ING, -S]\n",
  "UNSHROUDED": "UNSHROUD, to remove the shroud from; to uncover [v]\n",
  "UNSHROUDING": "UNSHROUD, to remove the shroud from; to uncover [v]\n",
  "UNSHROUDS": "UNSHROUD, to remove the shroud from; to uncover [v]\n",
  "UNSHRUBBED": "being without shrubs, also UNSHRUBD [adj]\n",
  "UNSHRUBD": "(Shakespeare) without shrubs, also UNSHRUBBED [adj]\n",
  "UNSHRUNK": "not shrunk [adj]\n",
  "UNSHUNNABLE": "(Shakespeare) unavoidable [adj]\n",
  "UNSHUNNED": "not shunned [adj]\n",
  "UNSHUT": "to open, or throw open [v UNSHUT, UNSHUTTING, UNSHUTS]\n",
  "UNSHUTS": "UNSHUT, to open, or throw open [v]\n",
  "UNSHUTTER": "to open or remove the shutters of [v -ED, -ING, -S]\n",
  "UNSHUTTERED": "UNSHUTTER, to open or remove the shutters of [v]\n",
  "UNSHUTTERING": "UNSHUTTER, to open or remove the shutters of [v]\n",
  "UNSHUTTERS": "UNSHUTTER, to open or remove the shutters of [v]\n",
  "UNSHUTTING": "UNSHUT, to open, or throw open [v]\n",
  "UNSICKER": "(Scots) insecure, unsafe [adj]\n",
  "UNSICKLED": "not cut with a sickle [adj]\n",
  "UNSIFTED": "not sifted [adj]\n",
  "UNSIGHING": "not sighing [adj]\n",
  "UNSIGHT": "to prevent from seeing [v -ED, -ING, -S]\n",
  "UNSIGHTED": "UNSIGHT, to prevent from seeing [v]\n",
  "UNSIGHTEDLY": "UNSIGHTED, UNSIGHT, to prevent from seeing [adv]\n",
  "UNSIGHTING": "UNSIGHT, to prevent from seeing [v]\n",
  "UNSIGHTLIER": "UNSIGHTLY, unpleasant to look at [adj]\n",
  "UNSIGHTLIEST": "UNSIGHTLY, unpleasant to look at [adj]\n",
  "UNSIGHTLINESS": "the state of being unsightly [n -ES]\n",
  "UNSIGHTLINESSES": "UNSIGHTLINESS, the state of being unsightly [n]\n",
  "UNSIGHTLY": "unpleasant to look at [adj UNSIGHTLIER, UNSIGHTLIEST]\n",
  "UNSIGHTS": "UNSIGHT, to prevent from seeing [v]\n",
  "UNSIGNED": "not signed [adj]\n",
  "UNSILENT": "not silent [adj]\n",
  "UNSIMILAR": "not similar [adj]\n",
  "UNSINEW": "to take the strength from [v -ED, -ING, -S]\n",
  "UNSINEWED": "UNSINEW, to take the strength from [v]\n",
  "UNSINEWING": "UNSINEW, to take the strength from [v]\n",
  "UNSINEWS": "UNSINEW, to take the strength from [v]\n",
  "UNSINFUL": "not sinful [adj]\n",
  "UNSINKABLE": "not sinkable [adj]\n",
  "UNSINNOWED": "(Shakespeare) unsinewed [adj]\n",
  "UNSISTERED": "without a sister [adj]\n",
  "UNSISTERLINESS": "the state of being unsisterly [n]\n",
  "UNSISTERLY": "not sisterly [adj]\n",
  "UNSISTING": "(Shakespeare) variously explained as unassisting, unresisting, insisting, unresting [adj]\n",
  "UNSIZABLE": "(obsolete) extraordinarily big, also UNSIZEABLE [adj]\n",
  "UNSIZEABLE": "(obsolete) extraordinarily big, also UNSIZABLE [adj]\n",
  "UNSIZED": "not sized [adj]\n",
  "UNSKILFUL": "not skilful, also UNSKILLFUL [adj UNSKILFULLY]\n",
  "UNSKILFULLY": "UNSKILFUL, not skilful, also UNSKILLFUL [adv]\n",
  "UNSKILFULNESS": "the state of being unskilful [n -ES]\n",
  "UNSKILFULNESSES": "UNSKILFULNESS, the state of being unskilful [n]\n",
  "UNSKILLED": "not skilled [adj]\n",
  "UNSKILLFUL": "not skillful, also UNSKILFUL [adj UNSKILLFULLY]\n",
  "UNSKILLFULLY": "UNSKILLFUL, not skillful, also UNSKILFUL [adv]\n",
  "UNSKILLFULNESS": "the state of being unskillful [n]\n",
  "UNSKIMMED": "not skimmed e.g. of milk [adj]\n",
  "UNSKINNED": "not skinned [adj]\n",
  "UNSLAIN": "not slain [adj]\n",
  "UNSLAKABLE": "that cannot be slaked [adj]\n",
  "UNSLAKED": "not slaked [adj]\n",
  "UNSLEEPING": "the absence of sleep [n -S]\n",
  "UNSLEEPINGS": "UNSLEEPING, the absence of sleep [n]\n",
  "UNSLICED": "not sliced [adj]\n",
  "UNSLICK": "not slick [adj]\n",
  "UNSLING": "to remove from a slung position [v UNSLUNG, UNSLINGING, UNSLINGS]\n",
  "UNSLINGING": "UNSLING, to remove from a slung position [v]\n",
  "UNSLINGS": "UNSLING, to remove from a slung position [v]\n",
  "UNSLIPPING": "not slipping [adj]\n",
  "UNSLUICE": "to let flow [v UNSLUICED, UNSLUICING, UNSLUICES]\n",
  "UNSLUICED": "UNSLUICE, to let flow [v]\n",
  "UNSLUICES": "UNSLUICE, to let flow [v]\n",
  "UNSLUICING": "UNSLUICE, to let flow [v]\n",
  "UNSLUMBERING": "not slumbering [adj]\n",
  "UNSLUMBROUS": "not slumbrous [adj]\n",
  "UNSLUNG": "UNSLING, to remove from a slung position [v]\n",
  "UNSMART": "not smart [adj]\n",
  "UNSMILING": "not smiling [adj UNSMILINGLY]\n",
  "UNSMILINGLY": "UNSMILING, not smiling [adv]\n",
  "UNSMIRCHED": "not smirched [adj]\n",
  "UNSMITTEN": "not smitten, also UNSMOTE [adj]\n",
  "UNSMOKABLE": "not capable of being smoked [adj]\n",
  "UNSMOKED": "not smoked [adj]\n",
  "UNSMOOTH": "to make not smooth [v -ED, -ING, -S]\n",
  "UNSMOOTHED": "UNSMOOTH, to make not smooth [v]\n",
  "UNSMOOTHING": "UNSMOOTH, to make not smooth [v]\n",
  "UNSMOOTHS": "UNSMOOTH, to make not smooth [v]\n",
  "UNSMOTE": "(archaic) unsmitten [adj]\n",
  "UNSMOTHERABLE": "that cannot be smothered [adj]\n",
  "UNSNAG": "to free of snags [v UNSNAGGED, UNSNAGGING, UNSNAGS]\n",
  "UNSNAGGED": "UNSNAG, to free of snags [v]\n",
  "UNSNAGGING": "UNSNAG, to free of snags [v]\n",
  "UNSNAGS": "UNSNAG, to free of snags [v]\n",
  "UNSNAP": "to undo the snaps of [v UNSNAPPED, UNSNAPPING, UNSNAPS]\n",
  "UNSNAPPED": "UNSNAP, to undo the snaps of [v]\n",
  "UNSNAPPING": "UNSNAP, to undo the snaps of [v]\n",
  "UNSNAPS": "UNSNAP, to undo the snaps of [v]\n",
  "UNSNARL": "to disentangle [v -ED, -ING, -S]\n",
  "UNSNARLED": "UNSNARL, to disentangle [v]\n",
  "UNSNARLING": "UNSNARL, to disentangle [v]\n",
  "UNSNARLS": "UNSNARL, to disentangle [v]\n",
  "UNSNECK": "to undo the sneck of [v -ED, -ING, -S]\n",
  "UNSNECKED": "UNSNECK, to undo the sneck of [v]\n",
  "UNSNECKING": "UNSNECK, to undo the sneck of [v]\n",
  "UNSNECKS": "UNSNECK, to undo the sneck of [v]\n",
  "UNSNUFFED": "not snuffed [adj]\n",
  "UNSOAKED": "not soaked [adj]\n",
  "UNSOAPED": "not soaped [adj]\n",
  "UNSOBER": "not sober [adj UNSOBERLY] / to make unregulated or unrefined in manners [v -ED, -ING, -S]\n",
  "UNSOBERED": "UNSOBER, to make unregulated or unrefined in manners [v]\n",
  "UNSOBERING": "UNSOBER, to make unregulated or unrefined in manners [v]\n",
  "UNSOBERLY": "UNSOBER, not sober [adv]\n",
  "UNSOBERS": "UNSOBER, to make unregulated or unrefined in manners [v]\n",
  "UNSOCIABILITIES": "UNSOCIABILITY, the state of being unsociable [n]\n",
  "UNSOCIABILITY": "the state of being unsociable [n UNSOCIABILITIES]\n",
  "UNSOCIABLE": "not sociable [adj UNSOCIABLY]\n",
  "UNSOCIABLENESS": "the state of being unsociable [n]\n",
  "UNSOCIABLY": "UNSOCIABLE, not sociable [adv]\n",
  "UNSOCIAL": "not social [adj UNSOCIALLY]\n",
  "UNSOCIALISED": "not socialised, also UNSOCIALIZED [adj]\n",
  "UNSOCIALISM": "being unsocial [n -S]\n",
  "UNSOCIALISMS": "UNSOCIALISM, being unsocial [n]\n",
  "UNSOCIALITIES": "UNSOCIALITY, the state of being unsocial [n]\n",
  "UNSOCIALITY": "the state of being unsocial [n UNSOCIALITIES]\n",
  "UNSOCIALIZED": "not socialized, also UNSOCIALISED [adj]\n",
  "UNSOCIALLY": "UNSOCIAL, not social [adv]\n",
  "UNSOCKET": "to take out of the socket [v -ED, -ING, -S]\n",
  "UNSOCKETED": "UNSOCKET, to take out of the socket [v]\n",
  "UNSOCKETING": "UNSOCKET, to take out of the socket [v]\n",
  "UNSOCKETS": "UNSOCKET, to take out of the socket [v]\n",
  "UNSOD": "not boiled, not sodden, also UNSODDEN [adj]\n",
  "UNSODDEN": "not sodden [adj]\n",
  "UNSOFT": "(Spenser) not softly [adj]\n",
  "UNSOFTENED": "not softened [adj]\n",
  "UNSOFTENING": "not softening [adj]\n",
  "UNSOILED": "not soiled [adj]\n",
  "UNSOLACED": "not solaced [adj]\n",
  "UNSOLD": "not sold [adj]\n",
  "UNSOLDER": "to separate from being soldered [v -ED, -ING, -S]\n",
  "UNSOLDERED": "UNSOLDER, to separate from being soldered [v]\n",
  "UNSOLDERING": "UNSOLDER, to separate from being soldered [v]\n",
  "UNSOLDERS": "UNSOLDER, to separate from being soldered [v]\n",
  "UNSOLDIERLIKE": "not like a soldier [adj]\n",
  "UNSOLDIERLY": "not soldierly [adj]\n",
  "UNSOLEMN": "not solemn [adj]\n",
  "UNSOLICITED": "not solicited [adj]\n",
  "UNSOLICITOUS": "not solicitous [adj]\n",
  "UNSOLID": "not solid [adj UNSOLIDLY]\n",
  "UNSOLIDITIES": "UNSOLIDITY, a lack of solidity [n]\n",
  "UNSOLIDITY": "a lack of solidity [n UNSOLIDITIES]\n",
  "UNSOLIDLY": "UNSOLID, not solid [adv]\n",
  "UNSOLVABLE": "not solvable [adj]\n",
  "UNSOLVED": "not solved [adj]\n",
  "UNSONCY": "(Scots) unlucky, also UNSONSIE, UNSONSY [adj]\n",
  "UNSONSIE": "(Scots) unlucky, also UNSONCY, UNSONSY [adj]\n",
  "UNSONSIER": "UNSONSY, (Scots) unlucky, also UNSONCY, UNSONSIE [adj]\n",
  "UNSONSIEST": "UNSONSY, (Scots) unlucky, also UNSONCY, UNSONSIE [adj]\n",
  "UNSONSY": "(Scots) unlucky, also UNSONCY, UNSONSIE [adj UNSONSIER, UNSONSIEST]\n",
  "UNSOOTE": "(Spenser) unsweet [adj]\n",
  "UNSOOTHED": "not soothed [adj]\n",
  "UNSOPHISTICATE": "not sophisticate [adj]\n",
  "UNSOPHISTICATED": "not sophisticated [adj]\n",
  "UNSORTED": "not sorted [adj]\n",
  "UNSOUGHT": "not sought [adj]\n",
  "UNSOUL": "to deprive of spirit [v -ED, -ING, -S]\n",
  "UNSOULED": "UNSOUL, to deprive of spirit [v]\n",
  "UNSOULING": "UNSOUL, to deprive of spirit [v]\n",
  "UNSOULS": "UNSOUL, to deprive of spirit [v]\n",
  "UNSOUND": "not sound [adj UNSOUNDER, UNSOUNDEST, UNSOUNDLY]\n",
  "UNSOUNDABLE": "not soundable [adj]\n",
  "UNSOUNDED": "not sounded [adj]\n",
  "UNSOUNDER": "UNSOUND, not sound [adj]\n",
  "UNSOUNDEST": "UNSOUND, not sound [adj]\n",
  "UNSOUNDLY": "UNSOUND, not sound [adv]\n",
  "UNSOUNDNESS": "the state of being unsound [n -ES]\n",
  "UNSOUNDNESSES": "UNSOUNDNESS, the state of being unsound [n]\n",
  "UNSOURCED": "having no (authenticated) source [adj]\n",
  "UNSOURED": "not soured [adj]\n",
  "UNSOWED": "not sowed, e.g. of a field, also UNSOWN [adj]\n",
  "UNSOWN": "not sown, also UNSOWED [adj]\n",
  "UNSPAR": "to withdraw a spa from [v UNSPARRED, UNSPARRING, UNSPARS]\n",
  "UNSPARED": "not treated with mildness; not saved from destruction, ruin, death, or the like [adj]\n",
  "UNSPARING": "not sparing [adj UNSPARINGLY]\n",
  "UNSPARINGLY": "UNSPARING, not sparing [adv]\n",
  "UNSPARINGNESS": "the state of being unsparing [n -ES]\n",
  "UNSPARINGNESSES": "UNSPARINGNESS, the state of being unsparing [n]\n",
  "UNSPARRED": "UNSPAR, to withdraw a spa from [v]\n",
  "UNSPARRING": "UNSPAR, to withdraw a spa from [v]\n",
  "UNSPARS": "UNSPAR, to withdraw a spa from [v]\n",
  "UNSPEAK": "(Shakespeare) to retract [v UNSPOKE, UNSPOKEN, UNSPEAKING, UNSPEAKS]\n",
  "UNSPEAKABLE": "that cannot be spoken [adj UNSPEAKABLY]\n",
  "UNSPEAKABLENESS": "the state of being unspeakable [n]\n",
  "UNSPEAKABLY": "UNSPEAKABLE, that cannot be spoken [adv]\n",
  "UNSPEAKING": "UNSPEAK, (Shakespeare) to retract [v]\n",
  "UNSPEAKS": "UNSPEAK, (Shakespeare) to retract [v]\n",
  "UNSPECIALISED": "not specialised, also UNSPECIALIZED [adj]\n",
  "UNSPECIALIZED": "not specialized, also UNSPECIALISED [adj]\n",
  "UNSPECIFIABLE": "not specifiable [adj]\n",
  "UNSPECIFIC": "not specific [adj UNSPECIFICALLY]\n",
  "UNSPECIFICALLY": "UNSPECIFIC, not specific [adv]\n",
  "UNSPECIFIED": "not specified [adj]\n",
  "UNSPECTACLED": "not wearing spectacles [adj]\n",
  "UNSPECTACULAR": "not spectacular [adj]\n",
  "UNSPECULATIVE": "not speculative [adj]\n",
  "UNSPED": "unaccomplished [adj]\n",
  "UNSPELL": "to free from a spell [v -ED, -ING, -S]\n",
  "UNSPELLED": "UNSPELL, to free from a spell [v]\n",
  "UNSPELLING": "UNSPELL, to free from a spell [v]\n",
  "UNSPELLS": "UNSPELL, to free from a spell [v]\n",
  "UNSPENT": "not spent [adj]\n",
  "UNSPHERE": "to remove from a sphere [v UNSPHERED, UNSPHERING, UNSPHERES]\n",
  "UNSPHERED": "UNSPHERE, to remove from a sphere [v]\n",
  "UNSPHERES": "UNSPHERE, to remove from a sphere [v]\n",
  "UNSPHERING": "UNSPHERE, to remove from a sphere [v]\n",
  "UNSPIDE": "(Spenser) unspied, unobserved [adj]\n",
  "UNSPIED": "unobserved [adj]\n",
  "UNSPILLED": "not spilled, also UNSPILT [adj]\n",
  "UNSPILT": "not spilt, also UNSPILLED [adj]\n",
  "UNSPIRITED": "not spirited [adj]\n",
  "UNSPIRITUAL": "not spiritual [adj UNSPIRITUALLY]\n",
  "UNSPIRITUALISE": "to make unspiritual, also UNSPIRITUALIZE [v UNSPIRITUALISED, UNSPIRITUALISES]\n",
  "UNSPIRITUALISED": "UNSPIRITUALISE, to make unspiritual, also UNSPIRITUALIZE [v]\n",
  "UNSPIRITUALISES": "UNSPIRITUALISE, to make unspiritual, also UNSPIRITUALIZE [v]\n",
  "UNSPIRITUALIZE": "to make unspiritual, also UNSPIRITUALISE [v UNSPIRITUALIZED, UNSPIRITUALIZES]\n",
  "UNSPIRITUALIZED": "UNSPIRITUALIZE, to make unspiritual, also UNSPIRITUALISE [v]\n",
  "UNSPIRITUALIZES": "UNSPIRITUALIZE, to make unspiritual, also UNSPIRITUALISE [v]\n",
  "UNSPIRITUALLY": "UNSPIRITUAL, not spiritual [adv]\n",
  "UNSPLINTERABLE": "not capable of being splintered [adj]\n",
  "UNSPLIT": "not split [adj]\n",
  "UNSPOILED": "not spoiled, also UNSPOILT [adj]\n",
  "UNSPOILT": "not spoilt [adj]\n",
  "UNSPOKE": "UNSPEAK, (Shakespeare) to retract [v]\n",
  "UNSPOKEN": "UNSPEAK, (Shakespeare) to retract [v]\n",
  "UNSPOOL": "to unwind from a small cylinder [v -ED, -ING, -S]\n",
  "UNSPOOLED": "UNSPOOL, to unwind from a small cylinder [v]\n",
  "UNSPOOLING": "UNSPOOL, to unwind from a small cylinder [v]\n",
  "UNSPOOLS": "UNSPOOL, to unwind from a small cylinder [v]\n",
  "UNSPORTING": "not sporting [adj]\n",
  "UNSPORTSMANLIKE": "not characteristic of or exhibiting good sportsmanship [adj]\n",
  "UNSPOTTED": "not spotted; free from spot or stain [adj]\n",
  "UNSPOTTEDNESS": "the state of being unspotted [n -ES]\n",
  "UNSPOTTEDNESSES": "UNSPOTTEDNESS, the state of being unspotted [n]\n",
  "UNSPRAYED": "not sprayed, e.g. of crops [adj]\n",
  "UNSPRINKLED": "not sprinkled [adj]\n",
  "UNSPRUNG": "not sprung [adj]\n",
  "UNSPUN": "not spun [adj]\n",
  "UNSQUARED": "not squared [adj]\n",
  "UNSTABLE": "not stable, also INSTABLE [adj UNSTABLER, UNSTABLEST, UNSTABLY]\n",
  "UNSTABLENESS": "the state of being unstable [n -ES]\n",
  "UNSTABLENESSES": "UNSTABLENESS, the state of being unstable [n]\n",
  "UNSTABLER": "UNSTABLE, not stable, also INSTABLE [adj]\n",
  "UNSTABLEST": "UNSTABLE, not stable, also INSTABLE [adj]\n",
  "UNSTABLY": "UNSTABLE, not stable, also INSTABLE [adv]\n",
  "UNSTACK": "to remove from a stack [v -ED, -ING, -S]\n",
  "UNSTACKED": "UNSTACK, to remove from a stack [v]\n",
  "UNSTACKING": "UNSTACK, to remove from a stack [v]\n",
  "UNSTACKS": "UNSTACK, to remove from a stack [v]\n",
  "UNSTAGED": "not staged [adj]\n",
  "UNSTAID": "not staid [adj]\n",
  "UNSTAIDNESS": "the state of being unstaid [n -ES]\n",
  "UNSTAIDNESSES": "UNSTAIDNESS, the state of being unstaid [n]\n",
  "UNSTAINABLE": "that cannot be stained [adj]\n",
  "UNSTAINED": "not stained [adj]\n",
  "UNSTALKED": "not having a stalk [adj]\n",
  "UNSTAMPED": "not stamped [adj]\n",
  "UNSTANCHABLE": "not stanchable [adj]\n",
  "UNSTANCHED": "not stanched [adj]\n",
  "UNSTANDARDISED": "not standardised, also UNSTANDARDIZED [adj]\n",
  "UNSTANDARDIZED": "not standardized, also UNSTANDARDISED [adj]\n",
  "UNSTARCH": "to free from starch [v -ED, -ING, -ES]\n",
  "UNSTARCHED": "UNSTARCH, to free from starch [v]\n",
  "UNSTARCHES": "UNSTARCH, to free from starch [v]\n",
  "UNSTARCHING": "UNSTARCH, to free from starch [v]\n",
  "UNSTARRED": "not starred [adj]\n",
  "UNSTARRIER": "UNSTARRY, not starry [adj]\n",
  "UNSTARRIEST": "UNSTARRY, not starry [adj]\n",
  "UNSTARRY": "not starry [adj UNSTARRIER, UNSTARRIEST]\n",
  "UNSTARTLING": "not startling [adj]\n",
  "UNSTATE": "(Shakespeare) to deprive of state or dignity [v UNSTATED, UNSTATING, UNSTATES]\n",
  "UNSTATED": "UNSTATE, (Shakespeare) to deprive of state or dignity [v]\n",
  "UNSTATES": "UNSTATE, (Shakespeare) to deprive of state or dignity [v]\n",
  "UNSTATESMANLIKE": "not like a statesman [adj]\n",
  "UNSTATING": "UNSTATE, (Shakespeare) to deprive of state or dignity [v]\n",
  "UNSTATUTABLE": "contrary to statute [adj UNSTATUTABLY]\n",
  "UNSTATUTABLY": "UNSTATUTABLE, contrary to statute [adv]\n",
  "UNSTAUNCHABLE": "not staunchable [adj]\n",
  "UNSTAUNCHED": "not staunched [adj]\n",
  "UNSTAYED": "not secured with ropes or wires [adj]\n",
  "UNSTAYING": "not staying [adj]\n",
  "UNSTEADFAST": "not steadfast [adj UNSTEADFASTLY]\n",
  "UNSTEADFASTLY": "UNSTEADFAST, not steadfast [adv]\n",
  "UNSTEADFASTNESS": "the state of being unsteadfast [n]\n",
  "UNSTEADIED": "UNSTEADY, to make unsteady [v]\n",
  "UNSTEADIER": "UNSTEADY, not steady [adj]\n",
  "UNSTEADIES": "UNSTEADY, to make unsteady [v]\n",
  "UNSTEADIEST": "UNSTEADY, not steady [adj]\n",
  "UNSTEADILY": "UNSTEADY, not steady [adv]\n",
  "UNSTEADINESS": "the state of being unsteady [n -ES]\n",
  "UNSTEADINESSES": "UNSTEADINESS, the state of being unsteady [n]\n",
  "UNSTEADY": "not steady [adj UNSTEADIER, UNSTEADIEST, UNSTEADILY] / to make unsteady [v UNSTEADIED, UNSTEADYING, UNSTEADIES]\n",
  "UNSTEADYING": "UNSTEADY, to make unsteady [v]\n",
  "UNSTEEL": "to disarm; to soften [v -ED, -ING, -S]\n",
  "UNSTEELED": "UNSTEEL, to disarm; to soften [v]\n",
  "UNSTEELING": "UNSTEEL, to disarm; to soften [v]\n",
  "UNSTEELS": "UNSTEEL, to disarm; to soften [v]\n",
  "UNSTEMMED": "not stemmed [adj]\n",
  "UNSTEP": "to remove from a socket [v UNSTEPPED, UNSTEPPING, UNSTEPS]\n",
  "UNSTEPPED": "UNSTEP, to remove from a socket [v]\n",
  "UNSTEPPING": "UNSTEP, to remove from a socket [v]\n",
  "UNSTEPS": "UNSTEP, to remove from a socket [v]\n",
  "UNSTERCORATED": "not manured [adj]\n",
  "UNSTEREOTYPED": "not stereotyped [adj]\n",
  "UNSTERILE": "not sterile [adj]\n",
  "UNSTERILISED": "not unsterilised, also UNSTERILIZED [adj]\n",
  "UNSTERILIZED": "not unsterilized, also UNSTERILISED [adj]\n",
  "UNSTICK": "to disjoin [v UNSTUCK, UNSTICKING, UNSTICKS]\n",
  "UNSTICKING": "UNSTICK, to disjoin [v]\n",
  "UNSTICKS": "UNSTICK, to disjoin [v]\n",
  "UNSTIFFEN": "to make not stiff [v -ED, -ING, -S]\n",
  "UNSTIFFENED": "UNSTIFFEN, to make not stiff [v]\n",
  "UNSTIFFENING": "UNSTIFFEN, to make not stiff [v]\n",
  "UNSTIFFENS": "UNSTIFFEN, to make not stiff [v]\n",
  "UNSTIFLED": "not stifled [adj]\n",
  "UNSTIGMATISED": "not stigmatised, also UNSTIGMATIZED [adj]\n",
  "UNSTIGMATIZED": "not stigmatized, also UNSTIGMATISED [adj]\n",
  "UNSTILLED": "not stilled [adj]\n",
  "UNSTIMULATED": "not stimulated [adj]\n",
  "UNSTINTED": "not stinted [adj]\n",
  "UNSTINTING": "not restricting or holding back [adj UNSTINTINGLY]\n",
  "UNSTINTINGLY": "UNSTINTING, not restricting or holding back [adv]\n",
  "UNSTIRRED": "not stirred [adj]\n",
  "UNSTITCH": "to remove the stitches from [v -ED, -ING, -ES]\n",
  "UNSTITCHED": "UNSTITCH, to remove the stitches from [v]\n",
  "UNSTITCHES": "UNSTITCH, to remove the stitches from [v]\n",
  "UNSTITCHING": "UNSTITCH, to remove the stitches from [v]\n",
  "UNSTOCK": "to deplete of stock [v -ED, -ING, -S]\n",
  "UNSTOCKED": "UNSTOCK, to deplete of stock [v]\n",
  "UNSTOCKING": "UNSTOCK, to deplete of stock [v]\n",
  "UNSTOCKINGED": "not stockinged [adj]\n",
  "UNSTOCKS": "UNSTOCK, to deplete of stock [v]\n",
  "UNSTONED": "not stoned [adj]\n",
  "UNSTOOPING": "not stooping [adj]\n",
  "UNSTOP": "to remove a stopper from [v UNSTOPPED, UNSTOPPING, UNSTOPS]\n",
  "UNSTOPPABLE": "that cannot be stopped [adj UNSTOPPABLY]\n",
  "UNSTOPPABLY": "UNSTOPPABLE, that cannot be stopped [adv]\n",
  "UNSTOPPED": "UNSTOP, to remove a stopper from [v]\n",
  "UNSTOPPER": "to take the stopper from [v -ED, -ING, -S]\n",
  "UNSTOPPERED": "UNSTOPPER, to take the stopper from [v]\n",
  "UNSTOPPERING": "UNSTOPPER, to take the stopper from [v]\n",
  "UNSTOPPERS": "UNSTOPPER, to take the stopper from [v]\n",
  "UNSTOPPING": "UNSTOP, to remove a stopper from [v]\n",
  "UNSTOPS": "UNSTOP, to remove a stopper from [v]\n",
  "UNSTOW": "to empty of contents [v -ED, -ING, -S]\n",
  "UNSTOWED": "UNSTOW, to empty of contents [v]\n",
  "UNSTOWING": "UNSTOW, to empty of contents [v]\n",
  "UNSTOWS": "UNSTOW, to empty of contents [v]\n",
  "UNSTRAINED": "not strained [adj]\n",
  "UNSTRAP": "to remove a strap from [v UNSTRAPPED, UNSTRAPPING, UNSTRAPS]\n",
  "UNSTRAPPED": "UNSTRAP, to remove a strap from [v]\n",
  "UNSTRAPPING": "UNSTRAP, to remove a strap from [v]\n",
  "UNSTRAPS": "UNSTRAP, to remove a strap from [v]\n",
  "UNSTRATIFIED": "not stratified [adj]\n",
  "UNSTREAMED": "not streamed [adj]\n",
  "UNSTRENGTHENED": "not strengthened [adj]\n",
  "UNSTRESS": "to become less stressed [v -ED, -ING, -ES]\n",
  "UNSTRESSED": "not bearing a stress or accent [adj]\n",
  "UNSTRESSES": "UNSTRESS, to become less stressed [v]\n",
  "UNSTRESSING": "UNSTRESS, to become less stressed [v]\n",
  "UNSTRIATED": "nonstriated; unstriped [adj]\n",
  "UNSTRING": "to remove from a string [v UNSTRUNG or UNSTRINGED, UNSTRINGING, UNSTRINGS]\n",
  "UNSTRINGED": "UNSTRING, to remove from a string [v]\n",
  "UNSTRINGING": "UNSTRING, to remove from a string [v]\n",
  "UNSTRINGS": "UNSTRING, to remove from a string [v]\n",
  "UNSTRIP": "(dialect) to strip [v UNSTRIPPED, UNSTRIPPING, UNSTRIPS]\n",
  "UNSTRIPED": "not striped [adj]\n",
  "UNSTRIPPED": "UNSTRIP, (dialect) to strip [v]\n",
  "UNSTRIPPING": "UNSTRIP, (dialect) to strip [v]\n",
  "UNSTRIPS": "UNSTRIP, (dialect) to strip [v]\n",
  "UNSTRUCK": "not struck [adj]\n",
  "UNSTRUCTURED": "lacking structure or organization [adj]\n",
  "UNSTRUNG": "UNSTRING, to remove from a string [v]\n",
  "UNSTUCK": "UNSTICK, to disjoin [v]\n",
  "UNSTUDIED": "not studied [adj]\n",
  "UNSTUFFED": "not stuffed, also UNSTUFT [adj]\n",
  "UNSTUFFIER": "UNSTUFFY, not stuffy [adj]\n",
  "UNSTUFFIEST": "UNSTUFFY, not stuffy [adj]\n",
  "UNSTUFFY": "not stuffy [adj UNSTUFFIER, UNSTUFFIEST]\n",
  "UNSTUFT": "(Shakespeare) unstuffed [adj]\n",
  "UNSTUNG": "not stung [adj]\n",
  "UNSTYLISH": "not stylish [adj]\n",
  "UNSUBDUABLE": "that cannot be subdued [adj]\n",
  "UNSUBDUED": "not subdued [adj]\n",
  "UNSUBJECT": "to remove from subjugation [v -ED, -ING, -S]\n",
  "UNSUBJECTED": "UNSUBJECT, to remove from subjugation [v]\n",
  "UNSUBJECTING": "UNSUBJECT, to remove from subjugation [v]\n",
  "UNSUBJECTS": "UNSUBJECT, to remove from subjugation [v]\n",
  "UNSUBLIMATED": "not sublimated [adj]\n",
  "UNSUBLIMED": "not sublimed [adj]\n",
  "UNSUBMERGED": "not submerged [adj]\n",
  "UNSUBMISSIVE": "not submissive [adj]\n",
  "UNSUBMITTING": "not submitting [adj]\n",
  "UNSUBSCRIBE": "to terminate one's subscription [v UNSUBSCRIBED, UNSUBSCRIBING, UNSUBSCRIBES]\n",
  "UNSUBSCRIBED": "not subscribed [adj]\n",
  "UNSUBSCRIBER": "one who cancels a subscription [n -S]\n",
  "UNSUBSCRIBERS": "UNSUBSCRIBER, one who cancels a subscription [n]\n",
  "UNSUBSCRIBES": "UNSUBSCRIBE, to terminate one's subscription [v]\n",
  "UNSUBSCRIBING": "UNSUBSCRIBE, to terminate one's subscription [v]\n",
  "UNSUBSIDISED": "not subsidised, also UNSUBSIDIZED [adj]\n",
  "UNSUBSIDIZED": "not subsidized, also UNSUBSIDISED [adj]\n",
  "UNSUBSTANTIAL": "not substantial [adj UNSUBSTANTIALLY]\n",
  "UNSUBSTANTIALLY": "UNSUBSTANTIAL, not substantial [adv]\n",
  "UNSUBSTANTIATED": "not substantiated [adj]\n",
  "UNSUBTLE": "not subtle [adj UNSUBTLER, UNSUBTLEST; UNSUBTLY]\n",
  "UNSUBTLER": "UNSUBTLE, not subtle [adj]\n",
  "UNSUBTLEST": "UNSUBTLE, not subtle [adj]\n",
  "UNSUBTLY": "UNSUBTLE, not subtle [adv]\n",
  "UNSUCCEEDED": "without a successor [adj]\n",
  "UNSUCCESS": "lack of success, failure [n -ES]\n",
  "UNSUCCESSES": "UNSUCCESS, lack of success, failure [n]\n",
  "UNSUCCESSFUL": "not successful [adj UNSUCCESSFULLY]\n",
  "UNSUCCESSFULLY": "UNSUCCESSFUL, not successful [adv]\n",
  "UNSUCCESSIVE": "not successive [adj]\n",
  "UNSUCCOURED": "not succoured [adj]\n",
  "UNSUCKED": "not sucked [adj]\n",
  "UNSUFFERABLE": "(obsolete) insufferable, also INSUFFERABLE [adj]\n",
  "UNSUFFICIENT": "(obsolete) insufficient, also INSUFFICIENT [adj]\n",
  "UNSUIT": "to make unsuitable [v -ED, -ING, -S]\n",
  "UNSUITABILITIES": "UNSUITABILITY, the quality of being unsuitable [n]\n",
  "UNSUITABILITY": "the quality of being unsuitable [n UNSUITABILITIES]\n",
  "UNSUITABLE": "not suitable [adj UNSUITABLY]\n",
  "UNSUITABLENESS": "a lack of suitableness [n]\n",
  "UNSUITABLY": "UNSUITABLE, not suitable [adv]\n",
  "UNSUITED": "UNSUIT, to make unsuitable [v]\n",
  "UNSUITING": "UNSUIT, to make unsuitable [v]\n",
  "UNSUITS": "UNSUIT, to make unsuitable [v]\n",
  "UNSULLIED": "not sullied [adj]\n",
  "UNSUMMED": "unaccounted [adj]\n",
  "UNSUMMERED": "not possessing the characteristics of summer [adj]\n",
  "UNSUMMONED": "not summoned [adj]\n",
  "UNSUNG": "not sung [adj]\n",
  "UNSUNK": "not sunk [adj]\n",
  "UNSUNNED": "not exposed to sun [adj]\n",
  "UNSUNNIER": "UNSUNNY, not sunny [adj]\n",
  "UNSUNNIEST": "UNSUNNY, not sunny [adj]\n",
  "UNSUNNY": "not sunny [adj UNSUNNIER, UNSUNNIEST]\n",
  "UNSUPERFLUOUS": "(Milton) not superfluous [adj]\n",
  "UNSUPERVISED": "not supervised [adj]\n",
  "UNSUPPLE": "not supple [adj]\n",
  "UNSUPPLENESS": "the state of being unsupple [n -ES]\n",
  "UNSUPPLENESSES": "UNSUPPLENESS, the state of being unsupple [n]\n",
  "UNSUPPLIED": "not supplied [adj]\n",
  "UNSUPPORTABLE": "not supportable [adj]\n",
  "UNSUPPORTED": "not supported [adj UNSUPPORTEDLY]\n",
  "UNSUPPORTEDLY": "UNSUPPORTED, not supported [adv]\n",
  "UNSUPPOSABLE": "not supposable [adj]\n",
  "UNSUPPRESSED": "not suppressed [adj]\n",
  "UNSURE": "not sure [adj UNSURER, UNSUREST, UNSURELY]\n",
  "UNSURED": "(Shakespeare) not made sure [adj]\n",
  "UNSURELY": "UNSURE, not sure [adv]\n",
  "UNSURER": "UNSURE, not sure [adj]\n",
  "UNSUREST": "UNSURE, not sure [adj]\n",
  "UNSURFACED": "not surfaced [adj]\n",
  "UNSURMISED": "not surmised [adj]\n",
  "UNSURMOUNTABLE": "not surmountable [adj]\n",
  "UNSURPASSABLE": "that cannot be surpassed [adj UNSURPASSABLY]\n",
  "UNSURPASSABLY": "UNSURPASSABLE, that cannot be surpassed [adv]\n",
  "UNSURPASSED": "not surpassed [adj]\n",
  "UNSURPRISED": "not surprised [adj]\n",
  "UNSURPRISING": "not surprising or unexpected [adj UNSURPRISINGLY]\n",
  "UNSURPRISINGLY": "UNSURPRISING, not surprising or unexpected [adv]\n",
  "UNSURVEYED": "not surveyed [adj]\n",
  "UNSUSCEPTIBLE": "not susceptible [adj]\n",
  "UNSUSPECT": "(Milton) not subject to suspicion [adj]\n",
  "UNSUSPECTED": "not suspected [adj UNSUSPECTEDLY]\n",
  "UNSUSPECTEDLY": "UNSUSPECTED, not suspected [adv]\n",
  "UNSUSPECTEDNESS": "the state of being unsuspected [n]\n",
  "UNSUSPECTING": "not suspecting [adj UNSUSPECTINGLY]\n",
  "UNSUSPECTINGLY": "UNSUSPECTING, not suspecting [adv]\n",
  "UNSUSPENDED": "not suspended [adj]\n",
  "UNSUSPICION": "a lack of suspicion [n -S]\n",
  "UNSUSPICIONS": "UNSUSPICION, a lack of suspicion [n]\n",
  "UNSUSPICIOUS": "not suspicious [adj UNSUSPICIOUSLY]\n",
  "UNSUSPICIOUSLY": "UNSUSPICIOUS, not suspicious [adv]\n",
  "UNSUSTAINABLE": "not sustainable [adj UNSUSTAINABLY]\n",
  "UNSUSTAINABLY": "UNSUSTAINABLE, not sustainable [adv]\n",
  "UNSUSTAINED": "not sustained [adj]\n",
  "UNSUSTAINING": "not sustaining [adj]\n",
  "UNSWADDLE": "to take a swaddle from; to unswathe [v UNSWADDLED, UNSWADDLING, UNSWADDLES]\n",
  "UNSWADDLED": "UNSWADDLE, to take a swaddle from; to unswathe [v]\n",
  "UNSWADDLES": "UNSWADDLE, to take a swaddle from; to unswathe [v]\n",
  "UNSWADDLING": "UNSWADDLE, to take a swaddle from; to unswathe [v]\n",
  "UNSWALLOWED": "not swallowed [adj]\n",
  "UNSWATHE": "to unbind, unwrap [v UNSWATHED, UNSWATHING, UNSWATHES]\n",
  "UNSWATHED": "UNSWATHE, to unbind, unwrap [v]\n",
  "UNSWATHES": "UNSWATHE, to unbind, unwrap [v]\n",
  "UNSWATHING": "UNSWATHE, to unbind, unwrap [v]\n",
  "UNSWAYABLE": "(Shakespeare) not capable of being swayed [adj]\n",
  "UNSWAYED": "not swayed [adj]\n",
  "UNSWEAR": "to retract something sworn [v UNSWORE, UNSWORN, UNSWEARING, UNSWEARS]\n",
  "UNSWEARING": "the act of recanting [n -S]\n",
  "UNSWEARINGS": "UNSWEARING, the act of recanting [n]\n",
  "UNSWEARS": "UNSWEAR, to retract something sworn [v]\n",
  "UNSWEET": "not sweet [adj]\n",
  "UNSWEETENED": "not sweetened [adj]\n",
  "UNSWEPT": "not swept [adj]\n",
  "UNSWERVING": "not swerving or turning aside [adj UNSWERVINGLY]\n",
  "UNSWERVINGLY": "UNSWERVING, not swerving or turning aside [adv]\n",
  "UNSWOLLEN": "not swollen [adj]\n",
  "UNSWORE": "UNSWEAR, to retract something sworn [v]\n",
  "UNSWORN": "UNSWEAR, to retract something sworn [v]\n",
  "UNSYLLABLED": "not uttered in syllables [adj]\n",
  "UNSYMMETRICAL": "not symmetrical [adj UNSYMMETRICALLY]\n",
  "UNSYMMETRICALLY": "UNSYMMETRICAL, not symmetrical [adv]\n",
  "UNSYMMETRIES": "UNSYMMETRY, a lack of symmetry [n]\n",
  "UNSYMMETRISED": "not symmetrised, also UNSYMMETRIZED [adj]\n",
  "UNSYMMETRIZED": "not symmetrized, also UNSYMMETRISED [adj]\n",
  "UNSYMMETRY": "a lack of symmetry [n UNSYMMETRIES]\n",
  "UNSYMPATHETIC": "not sympathetic [adj]\n",
  "UNSYMPATHIES": "UNSYMPATHY, absence of sympathy [n]\n",
  "UNSYMPATHISING": "not sympathising, also UNSYMPATHIZING [adj]\n",
  "UNSYMPATHIZING": "not sympathizing, also UNSYMPATHISING [adj]\n",
  "UNSYMPATHY": "absence of sympathy [n UNSYMPATHIES]\n",
  "UNSYNCHRONISED": "not synchronised, also UNSYNCHRONIZED [adj]\n",
  "UNSYNCHRONIZED": "not synchronized, also UNSYNCHRONISED [adj]\n",
  "UNSYSTEMATIC": "not systematic, also UNSYSTEMATICAL [adj]\n",
  "UNSYSTEMATICAL": "not systematical, also UNSYSTEMATIC [adj]\n",
  "UNSYSTEMATISED": "not systematised, also UNSYSTEMATIZED [adj]\n",
  "UNSYSTEMATIZED": "not systematized, also UNSYSTEMATISED [adj]\n",
  "UNSYSTEMIC": "not systemic [adj]\n",
  "UNTACK": "to remove a tack from [v -ED, -ING, -S]\n",
  "UNTACKED": "UNTACK, to remove a tack from [v]\n",
  "UNTACKING": "UNTACK, to remove a tack from [v]\n",
  "UNTACKLE": "to free from tackle [v UNTACKLED, UNTACKLING, UNTACKLES]\n",
  "UNTACKLED": "UNTACKLE, to free from tackle [v]\n",
  "UNTACKLES": "UNTACKLE, to free from tackle [v]\n",
  "UNTACKLING": "UNTACKLE, to free from tackle [v]\n",
  "UNTACKS": "UNTACK, to remove a tack from [v]\n",
  "UNTACTFUL": "not tactful [adj]\n",
  "UNTAGGED": "not tagged [adj]\n",
  "UNTAILED": "not tailed [adj]\n",
  "UNTAILORED": "not tailored [adj]\n",
  "UNTAINTED": "not tainted [adj UNTAINTEDLY]\n",
  "UNTAINTEDLY": "UNTAINTED, not tainted [adv]\n",
  "UNTAINTEDNESS": "the state of being untainted [n -ES]\n",
  "UNTAINTEDNESSES": "UNTAINTEDNESS, the state of being untainted [n]\n",
  "UNTAINTING": "not causing taint [adj]\n",
  "UNTAKEN": "not taken [adj]\n",
  "UNTALENTED": "not talented [adj]\n",
  "UNTAMABLE": "not tamable, also UNTAMEABLE [adj UNTAMABLY]\n",
  "UNTAMABLENESS": "the state of being untamable, also UNTAMEABLENESS [n -ES]\n",
  "UNTAMABLENESSES": "UNTAMABLENESS, the state of being untamable, also UNTAMEABLENESS [n]\n",
  "UNTAMABLY": "UNTAMABLE, not tamable, also UNTAMEABLE [adv]\n",
  "UNTAME": "to make untame [v UNTAMED, UNTAMING, UNTAMES]\n",
  "UNTAMEABLE": "that cannot be tamed, also UNTAMABLE [adj UNTAMEABLY]\n",
  "UNTAMEABLENESS": "the state of being untameable, also UNTAMABLENESS [n]\n",
  "UNTAMEABLY": "UNTAMEABLE, that cannot be tamed, also UNTAMABLE [adv]\n",
  "UNTAMED": "UNTAME, to make untame [v]\n",
  "UNTAMEDNESS": "the state of being untamed [n -ES]\n",
  "UNTAMEDNESSES": "UNTAMEDNESS, the state of being untamed [n]\n",
  "UNTAMES": "UNTAME, to make untame [v]\n",
  "UNTAMING": "UNTAME, to make untame [v]\n",
  "UNTANGIBLE": "not tangible, also INTANGIBLE [adj]\n",
  "UNTANGLE": "to free from tangles [v UNTANGLED, UNTANGLING, UNTANGLES]\n",
  "UNTANGLED": "UNTANGLE, to free from tangles [v]\n",
  "UNTANGLES": "UNTANGLE, to free from tangles [v]\n",
  "UNTANGLING": "UNTANGLE, to free from tangles [v]\n",
  "UNTANNED": "not tanned [adj]\n",
  "UNTAPPED": "not tapped [adj]\n",
  "UNTARNISHED": "not tarnished [adj]\n",
  "UNTARRED": "not tarred e.g. of a road surface [adj]\n",
  "UNTASTED": "not tasted [adj]\n",
  "UNTASTEFUL": "not tasteful [adj]\n",
  "UNTAUGHT": "UNTEACH, to cause to unlearn something [v]\n",
  "UNTAX": "to remit a tax on [v -ED, -ING, -ES]\n",
  "UNTAXABLE": "not taxable [adj]\n",
  "UNTAXED": "UNTAX, to remit a tax on [v]\n",
  "UNTAXES": "UNTAX, to remit a tax on [v]\n",
  "UNTAXING": "UNTAX, to remit a tax on [v]\n",
  "UNTEACH": "to cause to unlearn something [v UNTAUGHT, UNTEACHING, UNTEACHES]\n",
  "UNTEACHABLE": "not capable of being taught [adj]\n",
  "UNTEACHABLENESS": "the state of being unteachable [n]\n",
  "UNTEACHES": "UNTEACH, to cause to unlearn something [v]\n",
  "UNTEACHING": "UNTEACH, to cause to unlearn something [v]\n",
  "UNTEAM": "to unyoke a team from [v -ED, -ING, -S]\n",
  "UNTEAMED": "UNTEAM, to unyoke a team from [v]\n",
  "UNTEAMING": "UNTEAM, to unyoke a team from [v]\n",
  "UNTEAMS": "UNTEAM, to unyoke a team from [v]\n",
  "UNTEARABLE": "not tearable [adj]\n",
  "UNTECHNICAL": "not technical [adj]\n",
  "UNTELLABLE": "not tellable [adj]\n",
  "UNTEMPER": "to destroy the temper of [v -ED, -ING, -S]\n",
  "UNTEMPERED": "UNTEMPER, to destroy the temper of [v]\n",
  "UNTEMPERING": "UNTEMPER, to destroy the temper of [v]\n",
  "UNTEMPERS": "UNTEMPER, to destroy the temper of [v]\n",
  "UNTEMPTED": "not tempted [adj]\n",
  "UNTENABILITIES": "UNTENABILITY, the state of being untenable [n]\n",
  "UNTENABILITY": "the state of being untenable [n UNTENABILITIES]\n",
  "UNTENABLE": "not tenable, also INTENABLE, INTENIBLE [adj UNTENABLY]\n",
  "UNTENABLENESS": "UNTENABLE, not tenable, also INTENABLE, INTENIBLE [n]\n",
  "UNTENABLENESSES": "UNTENABLENESS, UNTENABLE, not tenable, also INTENABLE, INTENIBLE [n]\n",
  "UNTENABLY": "UNTENABLE, not tenable, also INTENABLE, INTENIBLE [adv]\n",
  "UNTENANT": "to deprive of a tenant [v -ED, -ING, -S]\n",
  "UNTENANTABLE": "not tenantable [adj]\n",
  "UNTENANTED": "UNTENANT, to deprive of a tenant [v]\n",
  "UNTENANTING": "UNTENANT, to deprive of a tenant [v]\n",
  "UNTENANTS": "UNTENANT, to deprive of a tenant [v]\n",
  "UNTENDED": "not tended [adj]\n",
  "UNTENDER": "not tender [adj UNTENDERLY]\n",
  "UNTENDERED": "not tendered [adj]\n",
  "UNTENDERLY": "UNTENDER, not tender [adv]\n",
  "UNTENT": "to remove from a tent [v -ED, -ING, -S]\n",
  "UNTENTED": "UNTENT, to remove from a tent [v]\n",
  "UNTENTIER": "UNTENTY, (Scots) careless [adj]\n",
  "UNTENTIEST": "UNTENTY, (Scots) careless [adj]\n",
  "UNTENTING": "UNTENT, to remove from a tent [v]\n",
  "UNTENTS": "UNTENT, to remove from a tent [v]\n",
  "UNTENTY": "(Scots) careless [adj UNTENTIER, UNTENTIEST]\n",
  "UNTENURED": "not having tenure [adj]\n",
  "UNTERMINATED": "not terminated [adj]\n",
  "UNTERRESTRIAL": "not terrestrial [adj]\n",
  "UNTERRIFIED": "not terrified [adj]\n",
  "UNTERRIFYING": "not terrifying [adj]\n",
  "UNTESTABLE": "not testable [adj]\n",
  "UNTESTED": "not tested [adj]\n",
  "UNTETHER": "to free from a tether [v -ED, -ING, -S]\n",
  "UNTETHERED": "UNTETHER, to free from a tether [v]\n",
  "UNTETHERING": "UNTETHER, to free from a tether [v]\n",
  "UNTETHERS": "UNTETHER, to free from a tether [v]\n",
  "UNTHANKED": "not thanked [adj]\n",
  "UNTHANKFUL": "not thankful [adj UNTHANKFULLY]\n",
  "UNTHANKFULLY": "UNTHANKFUL, not thankful [adv]\n",
  "UNTHANKFULNESS": "the state of being unthankful [n]\n",
  "UNTHATCH": "to strip of thatch [v -ED, -ING, -ES]\n",
  "UNTHATCHED": "UNTHATCH, to strip of thatch [v]\n",
  "UNTHATCHES": "UNTHATCH, to strip of thatch [v]\n",
  "UNTHATCHING": "UNTHATCH, to strip of thatch [v]\n",
  "UNTHAW": "to cause to melt [v -ED, -ING, -S]\n",
  "UNTHAWED": "UNTHAW, to cause to melt [v]\n",
  "UNTHAWING": "UNTHAW, to cause to melt [v]\n",
  "UNTHAWS": "UNTHAW, to cause to melt [v]\n",
  "UNTHEOLOGICAL": "not theological [adj]\n",
  "UNTHEORETICAL": "not theoretical [adj]\n",
  "UNTHICKENED": "not thickened [adj]\n",
  "UNTHINK": "to dismiss from the mind [v UNTHOUGHT, UNTHINKING, UNTHINKS]\n",
  "UNTHINKABILITY": "the state of being unthinkable [n]\n",
  "UNTHINKABLE": "that cannot be thought [adj UNTHINKABLY]\n",
  "UNTHINKABLENESS": "the state of being unthinkable [n]\n",
  "UNTHINKABLY": "UNTHINKABLE, that cannot be thought [adv]\n",
  "UNTHINKING": "UNTHINK, to dismiss from the mind [v]\n",
  "UNTHINKINGLY": "UNTHINKING, UNTHINK, to dismiss from the mind [adv]\n",
  "UNTHINKINGNESS": "the state of being unthinking [n]\n",
  "UNTHINKS": "UNTHINK, to dismiss from the mind [v]\n",
  "UNTHOROUGH": "not thorough [adj]\n",
  "UNTHOUGHT": "UNTHINK, to dismiss from the mind [v]\n",
  "UNTHOUGHTFUL": "not thoughtful [adj UNTHOUGHTFULLY]\n",
  "UNTHOUGHTFULLY": "UNTHOUGHTFUL, not thoughtful [adv]\n",
  "UNTHREAD": "to remove the thread from [v -ED, -ING, -S]\n",
  "UNTHREADED": "UNTHREAD, to remove the thread from [v]\n",
  "UNTHREADING": "UNTHREAD, to remove the thread from [v]\n",
  "UNTHREADS": "UNTHREAD, to remove the thread from [v]\n",
  "UNTHREATENED": "not threatened [adj]\n",
  "UNTHREATENING": "not threatening [adj]\n",
  "UNTHRESHED": "not threshed [adj]\n",
  "UNTHRIFT": "a spendthrift [n -S]\n",
  "UNTHRIFTIER": "UNTHRIFTY, not thrifty [adj]\n",
  "UNTHRIFTIEST": "UNTHRIFTY, not thrifty [adj]\n",
  "UNTHRIFTIHEAD": "(archaic) thriftlessness [n -S]\n",
  "UNTHRIFTIHEADS": "UNTHRIFTIHEAD, (archaic) thriftlessness [n]\n",
  "UNTHRIFTILY": "UNTHRIFTY, not thrifty [adv]\n",
  "UNTHRIFTINESS": "the state of being unthrifty [n -ES]\n",
  "UNTHRIFTINESSES": "UNTHRIFTINESS, the state of being unthrifty [n]\n",
  "UNTHRIFTS": "UNTHRIFT, a spendthrift [n]\n",
  "UNTHRIFTY": "not thrifty [adj UNTHRIFTIER, UNTHRIFTIEST, UNTHRIFTILY]\n",
  "UNTHRIFTYHEAD": "(Spenser) unthriftiness, also UNTHRIFTYHED [n -S]\n",
  "UNTHRIFTYHEADS": "UNTHRIFTYHEAD, (Spenser) unthriftiness, also UNTHRIFTYHED [n]\n",
  "UNTHRIFTYHED": "(Spenser) unthriftiness, also UNTHRIFTYHEAD [n -S]\n",
  "UNTHRIFTYHEDS": "UNTHRIFTYHED, (Spenser) unthriftiness, also UNTHRIFTYHEAD [n]\n",
  "UNTHRONE": "to remove from a throne [v UNTHRONED, UNTHRONING, UNTHRONES]\n",
  "UNTHRONED": "UNTHRONE, to remove from a throne [v]\n",
  "UNTHRONES": "UNTHRONE, to remove from a throne [v]\n",
  "UNTHRONING": "UNTHRONE, to remove from a throne [v]\n",
  "UNTIDIED": "UNTIDY, to make untidy [v]\n",
  "UNTIDIER": "UNTIDY, not tidy [adj]\n",
  "UNTIDIES": "UNTIDY, to make untidy [v]\n",
  "UNTIDIEST": "UNTIDY, not tidy [adj]\n",
  "UNTIDILY": "UNTIDY, not tidy [adv]\n",
  "UNTIDINESS": "the state of being untidy [n -ES]\n",
  "UNTIDINESSES": "UNTIDINESS, the state of being untidy [n]\n",
  "UNTIDY": "not tidy [adj UNTIDIER, UNTIDIEST, UNTIDILY] / to make untidy [v UNTIDIED, UNTIDYING, UNTIDIES]\n",
  "UNTIDYING": "UNTIDY, to make untidy [v]\n",
  "UNTIE": "to free from something that ties [v UNTIED, UNTYING or UNTIEING, UNTIES]\n",
  "UNTIED": "UNTIE, to free from something that ties [v]\n",
  "UNTIEING": "UNTIE, to free from something that ties [v]\n",
  "UNTIES": "UNTIE, to free from something that ties [v]\n",
  "UNTIL": "up to the time of [prep]\n",
  "UNTILE": "to strip of tiles [v UNTILED, UNTILING, UNTILES]\n",
  "UNTILED": "UNTILE, to strip of tiles [v]\n",
  "UNTILES": "UNTILE, to strip of tiles [v]\n",
  "UNTILING": "UNTILE, to strip of tiles [v]\n",
  "UNTILLABLE": "that cannot be tilled [adj]\n",
  "UNTILLED": "not tilled [adj]\n",
  "UNTILTED": "not tilted [adj]\n",
  "UNTIMBERED": "not timbered [adj]\n",
  "UNTIMED": "not timed [adj]\n",
  "UNTIMELIER": "UNTIMELY, not timely [adj]\n",
  "UNTIMELIEST": "UNTIMELY, not timely [adj]\n",
  "UNTIMELINESS": "the state of being untimely [n -ES]\n",
  "UNTIMELINESSES": "UNTIMELINESS, the state of being untimely [n]\n",
  "UNTIMELY": "not timely [adj UNTIMELIER, UNTIMELIEST]\n",
  "UNTIMEOUS": "untimely [adj UNTIMEOUSLY]\n",
  "UNTIMEOUSLY": "UNTIMEOUS, untimely [adv]\n",
  "UNTIN": "to take the tin from [v UNTINNED, UNTINNING, UNTINS]\n",
  "UNTINCTURED": "not tinctured [adj]\n",
  "UNTINGED": "not tinged [adj]\n",
  "UNTINNED": "UNTIN, to take the tin from [v]\n",
  "UNTINNING": "UNTIN, to take the tin from [v]\n",
  "UNTINS": "UNTIN, to take the tin from [v]\n",
  "UNTIPPED": "without a tip e.g. of cigarettes [adj]\n",
  "UNTIRABLE": "that cannot be tired out, also UNTYREABLE [adj]\n",
  "UNTIRED": "not tired [adj]\n",
  "UNTIRING": "not tiring [adj UNTIRINGLY]\n",
  "UNTIRINGLY": "UNTIRING, not tiring [adv]\n",
  "UNTITLED": "not titled [adj]\n",
  "UNTO": "to [prep]\n",
  "UNTOCHERED": "without a tocher or dowry [adj]\n",
  "UNTOGETHER": "not together [adj]\n",
  "UNTOILING": "not toiling [adj]\n",
  "UNTOLD": "not told [adj]\n",
  "UNTOMB": "to remove from a tomb [v -ED, -ING, -S]\n",
  "UNTOMBED": "UNTOMB, to remove from a tomb [v]\n",
  "UNTOMBING": "UNTOMB, to remove from a tomb [v]\n",
  "UNTOMBS": "UNTOMB, to remove from a tomb [v]\n",
  "UNTONED": "not toned [adj]\n",
  "UNTOOLED": "not tooled [adj]\n",
  "UNTOOTHED": "not toothed [adj]\n",
  "UNTORMENTED": "not tormented [adj]\n",
  "UNTORN": "not torn [adj]\n",
  "UNTORTURED": "not tortured [adj]\n",
  "UNTOUCHABILITY": "the state of being untouchable [n]\n",
  "UNTOUCHABLE": "not to be touched [adj] / one that is untouchable, esp. a Hindu of very low caste [n -S]\n",
  "UNTOUCHABLES": "UNTOUCHABLE, one that is untouchable, esp. a Hindu of very low caste [n]\n",
  "UNTOUCHED": "not touched [adj]\n",
  "UNTOWARD": "not appropriate [adj UNTOWARDLY]\n",
  "UNTOWARDLINESS": "the state of being untowardly [n]\n",
  "UNTOWARDLY": "UNTOWARD, not appropriate [adv]\n",
  "UNTOWARDNESS": "the state of being untoward [n -ES]\n",
  "UNTOWARDNESSES": "UNTOWARDNESS, the state of being untoward [n]\n",
  "UNTRACE": "to loose from traces [v UNTRACED, UNTRACING, UNTRACES]\n",
  "UNTRACEABLE": "not traceable [adj]\n",
  "UNTRACED": "UNTRACE, to loose from traces [v]\n",
  "UNTRACES": "UNTRACE, to loose from traces [v]\n",
  "UNTRACING": "UNTRACE, to loose from traces [v]\n",
  "UNTRACK": "to remove from a track, change course [v -ED, -ING, -S]\n",
  "UNTRACKED": "UNTRACK, to remove from a track, change course [v]\n",
  "UNTRACKING": "UNTRACK, to remove from a track, change course [v]\n",
  "UNTRACKS": "UNTRACK, to remove from a track, change course [v]\n",
  "UNTRACTABLE": "unmanageable, also INTRACTABLE [adj]\n",
  "UNTRACTABLENESS": "the state of being untractable [n]\n",
  "UNTRADED": "unfrequented [adj]\n",
  "UNTRADITIONAL": "not traditional [adj UNTRADITIONALLY]\n",
  "UNTRADITIONALLY": "UNTRADITIONAL, not traditional [adv]\n",
  "UNTRAINED": "not trained [adj]\n",
  "UNTRAMMELED": "not trammeled, also UNTRAMMELLED [adj]\n",
  "UNTRAMMELLED": "not trammeled, also UNTRAMMELED [adj]\n",
  "UNTRAMPLED": "not trampled [adj]\n",
  "UNTRANQUIL": "not tranquil [adj]\n",
  "UNTRANSFERABLE": "not transferable, also UNTRANSFERRABLE [adj]\n",
  "UNTRANSFERRABLE": "not transferrable, also UNTRANSFERABLE [adj]\n",
  "UNTRANSFORMED": "not transformed [adj]\n",
  "UNTRANSLATABLE": "not translatable [adj UNTRANSLATABLY]\n",
  "UNTRANSLATABLY": "UNTRANSLATABLE, not translatable [adv]\n",
  "UNTRANSLATED": "not translated [adj]\n",
  "UNTRANSMIGRATED": "not transmigrated [adj]\n",
  "UNTRANSMISSIBLE": "not transmissible [adj]\n",
  "UNTRANSMITTED": "not transmitted [adj]\n",
  "UNTRANSMUTABLE": "not transmutable [adj]\n",
  "UNTRANSMUTED": "not transmuted [adj]\n",
  "UNTRANSPARENT": "not transparent [adj]\n",
  "UNTRAPPED": "not trapped [adj]\n",
  "UNTRAVELED": "not having travelled, also UNTRAVELLED [adj]\n",
  "UNTRAVELLED": "not having travelled, also UNTRAVELED [adj]\n",
  "UNTRAVERSABLE": "not traversable [adj]\n",
  "UNTRAVERSED": "not traversed [adj]\n",
  "UNTREAD": "(Shakespeare) to tread back; to retrace [v UNTROD or UNTREADED, UNTRODDEN, UNTREADING, UNTREADS]\n",
  "UNTREADED": "UNTREAD, (Shakespeare) to tread back; to retrace [v]\n",
  "UNTREADING": "UNTREAD, (Shakespeare) to tread back; to retrace [v]\n",
  "UNTREADS": "UNTREAD, (Shakespeare) to tread back; to retrace [v]\n",
  "UNTREASURE": "to despoil [v UNTREASURED, UNTREASURING, UNTREASURES]\n",
  "UNTREASURED": "UNTREASURE, to despoil [v]\n",
  "UNTREASURES": "UNTREASURE, to despoil [v]\n",
  "UNTREASURING": "UNTREASURE, to despoil [v]\n",
  "UNTREATABLE": "that cannot be treated [adj]\n",
  "UNTREATED": "not treated [adj]\n",
  "UNTREMBLING": "not trembling [adj UNTREMBLINGLY]\n",
  "UNTREMBLINGLY": "UNTREMBLING, not trembling [adv]\n",
  "UNTREMENDOUS": "not tremendous [adj]\n",
  "UNTREMULOUS": "not tremulous [adj]\n",
  "UNTRENCHED": "without trenches [adj]\n",
  "UNTRENDIER": "UNTRENDY, not trendy [adj]\n",
  "UNTRENDIEST": "UNTRENDY, not trendy [adj]\n",
  "UNTRENDY": "not trendy [adj UNTRENDIER, UNTRENDIEST]\n",
  "UNTRESPASSING": "not trespassing [adj]\n",
  "UNTRESSED": "not tied up in tresses [adj]\n",
  "UNTRIDE": "(Shakespeare) not tried, not ventured on [adj]\n",
  "UNTRIED": "not tried [adj]\n",
  "UNTRIM": "to strip of trimming [v UNTRIMMED, UNTRIMMING, UNTRIMS]\n",
  "UNTRIMMED": "UNTRIM, to strip of trimming [v]\n",
  "UNTRIMMING": "UNTRIM, to strip of trimming [v]\n",
  "UNTRIMS": "UNTRIM, to strip of trimming [v]\n",
  "UNTROD": "UNTREAD, (Shakespeare) to tread back; to retrace [v]\n",
  "UNTRODDEN": "UNTREAD, (Shakespeare) to tread back; to retrace [v]\n",
  "UNTROUBLED": "not troubled [adj UNTROUBLEDLY]\n",
  "UNTROUBLEDLY": "UNTROUBLED, not troubled [adv]\n",
  "UNTRUE": "not true [adj UNTRUER, UNTRUEST, UNTRULY]\n",
  "UNTRUENESS": "the state of being untrue [n -ES]\n",
  "UNTRUENESSES": "UNTRUENESS, the state of being untrue [n]\n",
  "UNTRUER": "UNTRUE, not true [adj]\n",
  "UNTRUEST": "UNTRUE, not true [adj]\n",
  "UNTRUISM": "untrue platitude [n -S]\n",
  "UNTRUISMS": "UNTRUISM, untrue platitude [n]\n",
  "UNTRULY": "UNTRUE, not true [adv]\n",
  "UNTRUSS": "to free from a truss [v -ED, -ING, -ES]\n",
  "UNTRUSSED": "UNTRUSS, to free from a truss [v]\n",
  "UNTRUSSER": "one who untrussed persons for the purpose of flogging them; a public whipper [n -S]\n",
  "UNTRUSSERS": "UNTRUSSER, one who untrussed persons for the purpose of flogging them; a public whipper [n]\n",
  "UNTRUSSES": "UNTRUSS, to free from a truss [v]\n",
  "UNTRUSSING": "the act of untrussing [n -S]\n",
  "UNTRUSSINGS": "UNTRUSSING, the act of untrussing [n]\n",
  "UNTRUST": "lack of trust [n -S]\n",
  "UNTRUSTED": "not trusted [adj]\n",
  "UNTRUSTFUL": "not trustful or trusting [adj]\n",
  "UNTRUSTIER": "UNTRUSTY, not trusty [adj]\n",
  "UNTRUSTIEST": "UNTRUSTY, not trusty [adj]\n",
  "UNTRUSTINESS": "(obsolete) the state of being untrusty [n -ES]\n",
  "UNTRUSTINESSES": "UNTRUSTINESS, (obsolete) the state of being untrusty [n]\n",
  "UNTRUSTING": "not trusting [adj]\n",
  "UNTRUSTS": "UNTRUST, lack of trust [n]\n",
  "UNTRUSTWORTHILY": "UNTRUSTWORTHY, not trustworthy [adv]\n",
  "UNTRUSTWORTHY": "not trustworthy [adj UNTRUSTWORTHILY]\n",
  "UNTRUSTY": "not trusty [adj UNTRUSTIER, UNTRUSTIEST]\n",
  "UNTRUTH": "something that is untrue [n -S]\n",
  "UNTRUTHFUL": "not containing or telling the truth [adj UNTRUTHFULLY]\n",
  "UNTRUTHFULLY": "UNTRUTHFUL, not containing or telling the truth [adv]\n",
  "UNTRUTHFULNESS": "the state of being untruthful [n]\n",
  "UNTRUTHS": "UNTRUTH, something that is untrue [n]\n",
  "UNTUCK": "to release from being tucked up [v -ED, -ING, -S]\n",
  "UNTUCKED": "UNTUCK, to release from being tucked up [v]\n",
  "UNTUCKERED": "not having a tucker on [adj]\n",
  "UNTUCKING": "UNTUCK, to release from being tucked up [v]\n",
  "UNTUCKS": "UNTUCK, to release from being tucked up [v]\n",
  "UNTUFTED": "not tufted [adj]\n",
  "UNTUMBLED": "not tumbled [adj]\n",
  "UNTUMULTUOUS": "not tumultuous [adj]\n",
  "UNTUNABLE": "that cannot be tuned, also UNTUNEABLE [adj UNTUNABLY]\n",
  "UNTUNABLENESS": "the state of being untunable [n -ES]\n",
  "UNTUNABLENESSES": "UNTUNABLENESS, the state of being untunable [n]\n",
  "UNTUNABLY": "UNTUNABLE, that cannot be tuned, also UNTUNEABLE [adv]\n",
  "UNTUNE": "to put out of tune [v UNTUNED, UNTUNING, UNTUNES]\n",
  "UNTUNEABLE": "that cannot be tuned, also UNTUNABLE [adj]\n",
  "UNTUNED": "UNTUNE, to put out of tune [v]\n",
  "UNTUNEFUL": "not tuneful [adj UNTUNEFULLY]\n",
  "UNTUNEFULLY": "UNTUNEFUL, not tuneful [adv]\n",
  "UNTUNEFULNESS": "the state of being untuneful [n -ES]\n",
  "UNTUNEFULNESSES": "UNTUNEFULNESS, the state of being untuneful [n]\n",
  "UNTUNES": "UNTUNE, to put out of tune [v]\n",
  "UNTUNING": "UNTUNE, to put out of tune [v]\n",
  "UNTURBID": "not turbid [adj]\n",
  "UNTURF": "to strip of turf [v -ED, -ING, -S]\n",
  "UNTURFED": "UNTURF, to strip of turf [v]\n",
  "UNTURFING": "UNTURF, to strip of turf [v]\n",
  "UNTURFS": "UNTURF, to strip of turf [v]\n",
  "UNTURN": "to turn backwards [v -ED, -ING, -S]\n",
  "UNTURNABLE": "that cannot be turned [adj]\n",
  "UNTURNED": "UNTURN, to turn backwards [v]\n",
  "UNTURNING": "UNTURN, to turn backwards [v]\n",
  "UNTURNS": "UNTURN, to turn backwards [v]\n",
  "UNTUTORED": "not tutored [adj]\n",
  "UNTWILLED": "not twilled [adj]\n",
  "UNTWINE": "to separate twisted or tangled parts [v UNTWINED, UNTWINING, UNTWINES]\n",
  "UNTWINED": "UNTWINE, to separate twisted or tangled parts [v]\n",
  "UNTWINES": "UNTWINE, to separate twisted or tangled parts [v]\n",
  "UNTWINING": "UNTWINE, to separate twisted or tangled parts [v]\n",
  "UNTWIST": "to untwine [v -ED, -ING, -S]\n",
  "UNTWISTED": "UNTWIST, to untwine [v]\n",
  "UNTWISTING": "the act of untwisting [n -S]\n",
  "UNTWISTINGS": "UNTWISTING, the act of untwisting [n]\n",
  "UNTWISTS": "UNTWIST, to untwine [v]\n",
  "UNTYING": "the act of untying [n -S]\n",
  "UNTYINGS": "UNTYING, the act of untying [n]\n",
  "UNTYPABLE": "that cannot be typed [adj]\n",
  "UNTYPICAL": "not typical [adj UNTYPICALLY]\n",
  "UNTYPICALLY": "UNTYPICAL, not typical [adv]\n",
  "UNTYREABLE": "(Shakespeare) untirable [adj]\n",
  "UNUNBIUM": "a synthetic chemical element [n -S]\n",
  "UNUNBIUMS": "UNUNBIUM, a synthetic chemical element [n]\n",
  "UNUNITED": "not united [adj]\n",
  "UNUNUNIUM": "a chemical element [n -S]\n",
  "UNUNUNIUMS": "UNUNUNIUM, a chemical element [n]\n",
  "UNUPLIFTED": "not uplifted [adj]\n",
  "UNURGED": "not urged [adj]\n",
  "UNUSABLE": "not usable [adj UNUSABLY]\n",
  "UNUSABLY": "UNUSABLE, not usable [adv]\n",
  "UNUSED": "not used [adj]\n",
  "UNUSEFUL": "not useful [adj UNUSEFULLY]\n",
  "UNUSEFULLY": "UNUSEFUL, not useful [adv]\n",
  "UNUSEFULNESS": "the state of being unuseful [n -ES]\n",
  "UNUSEFULNESSES": "UNUSEFULNESS, the state of being unuseful [n]\n",
  "UNUSHERED": "not ushered [adj]\n",
  "UNUSUAL": "not usual [adj UNUSUALLY]\n",
  "UNUSUALLY": "UNUSUAL, not usual [adv]\n",
  "UNUSUALNESS": "the state of being unusual [n -ES]\n",
  "UNUSUALNESSES": "UNUSUALNESS, the state of being unusual [n]\n",
  "UNUTILISED": "not utilised, also UNUTILIZED [adj]\n",
  "UNUTILIZED": "not utilized, also UNUTILISED [adj]\n",
  "UNUTTERABLE": "that cannot be uttered, also INUTTERABLE [adj UNUTTERABLY] / something that cannot be uttered [n -S]\n",
  "UNUTTERABLENESS": "the state of being unutterable [n]\n",
  "UNUTTERABLES": "UNUTTERABLE, something that cannot be uttered [n]\n",
  "UNUTTERABLY": "UNUTTERABLE, that cannot be uttered, also INUTTERABLE [adv]\n",
  "UNUTTERED": "not uttered [adj]\n",
  "UNVACCINATED": "not vaccinated [adj]\n",
  "UNVAIL": "(obsolete) to unveil, also UNVAILE [v -ED, -ING, -S]\n",
  "UNVAILE": "(obsolete) to unveil, also UNVAIL [v UNVAILED, UNVAILING, UNVAILES]\n",
  "UNVAILED": "UNVAILE, (obsolete) to unveil, also UNVAIL [v]\n",
  "UNVAILES": "UNVAILE, (obsolete) to unveil, also UNVAIL [v]\n",
  "UNVAILING": "UNVAILE, (obsolete) to unveil, also UNVAIL [v]\n",
  "UNVAILS": "UNVAIL, (obsolete) to unveil, also UNVAILE [v]\n",
  "UNVALUABLE": "not valuable [adj]\n",
  "UNVALUED": "not valued [adj]\n",
  "UNVANQUISHABLE": "not vanquishable [adj]\n",
  "UNVANQUISHED": "not vanquished [adj]\n",
  "UNVARIABLE": "that cannot be varied, also INVARIABLE [adj]\n",
  "UNVARIED": "not varied [adj]\n",
  "UNVARIEGATED": "not variegated [adj]\n",
  "UNVARNISHED": "not adorned or glossed [adj]\n",
  "UNVARYING": "not varying [adj UNVARYINGLY]\n",
  "UNVARYINGLY": "UNVARYING, not varying [adv]\n",
  "UNVEIL": "to remove a covering from [v -ED, -ING, -S]\n",
  "UNVEILED": "UNVEIL, to remove a covering from [v]\n",
  "UNVEILER": "one who removes a veil [n -S]\n",
  "UNVEILERS": "UNVEILER, one who removes a veil [n]\n",
  "UNVEILING": "the act of unveiling [n -S]\n",
  "UNVEILINGS": "UNVEILING, the act of unveiling [n]\n",
  "UNVEILS": "UNVEIL, to remove a covering from [v]\n",
  "UNVEINED": "not veined [adj]\n",
  "UNVENDIBLE": "that cannot be sold [adj]\n",
  "UNVENERABLE": "not venerable [adj]\n",
  "UNVENTED": "not vented [adj]\n",
  "UNVENTILATED": "not ventilated [adj]\n",
  "UNVERACIOUS": "not veracious [adj]\n",
  "UNVERACITIES": "UNVERACITY, want of veracity [n]\n",
  "UNVERACITY": "want of veracity [n UNVERACITIES]\n",
  "UNVERBALISED": "not verbalised, also UNVERBALIZED [adj]\n",
  "UNVERBALIZED": "not verbalized, also UNVERBALISED [adj]\n",
  "UNVERIFIABILITY": "the quality of being unverifiable [n]\n",
  "UNVERIFIABLE": "not verifiable [adj]\n",
  "UNVERIFIED": "not verified [adj]\n",
  "UNVERSED": "not versed [adj]\n",
  "UNVESTED": "not vested [adj]\n",
  "UNVETTED": "not vetted [adj]\n",
  "UNVEXED": "not vexed, also UNVEXT [adj]\n",
  "UNVEXT": "not vexed, also UNVEXED [adj]\n",
  "UNVIABLE": "not viable, also INVIABLE [adj]\n",
  "UNVIEWED": "not viewed [adj]\n",
  "UNVIOLATED": "not violated [adj]\n",
  "UNVIRTUE": "lack of virtue [n -S]\n",
  "UNVIRTUES": "UNVIRTUE, lack of virtue [n]\n",
  "UNVIRTUOUS": "not virtuous [adj UNVIRTUOUSLY]\n",
  "UNVIRTUOUSLY": "UNVIRTUOUS, not virtuous [adv]\n",
  "UNVISITABLE": "that cannot be visited [adj]\n",
  "UNVISITED": "not visited [adj]\n",
  "UNVISOR": "to open the visor of, also UNVIZARD [v -ED, -ING, -S]\n",
  "UNVISORED": "UNVISOR, to open the visor of, also UNVIZARD [v]\n",
  "UNVISORING": "UNVISOR, to open the visor of, also UNVIZARD [v]\n",
  "UNVISORS": "UNVISOR, to open the visor of, also UNVIZARD [v]\n",
  "UNVITAL": "not vital, also INVITAL [adj]\n",
  "UNVITIATED": "not vitiated [adj]\n",
  "UNVITRIFIABLE": "not vitrifiable [adj]\n",
  "UNVITRIFIED": "not vitrified [adj]\n",
  "UNVIZARD": "to open the visor of, also UNVISOR [v -ED, -ING, -S]\n",
  "UNVIZARDED": "UNVIZARD, to open the visor of, also UNVISOR [v]\n",
  "UNVIZARDING": "UNVIZARD, to open the visor of, also UNVISOR [v]\n",
  "UNVIZARDS": "UNVIZARD, to open the visor of, also UNVISOR [v]\n",
  "UNVOCAL": "not vocal [adj]\n",
  "UNVOCALISED": "not vocalised, also UNVOCALIZED [adj]\n",
  "UNVOCALIZED": "not vocalized, also UNVOCALISED [adj]\n",
  "UNVOICE": "to deprive of voice [v UNVOICED, UNVOICING, UNVOICES]\n",
  "UNVOICED": "UNVOICE, to deprive of voice [v]\n",
  "UNVOICES": "UNVOICE, to deprive of voice [v]\n",
  "UNVOICING": "change to a voiceless sound [n -S]\n",
  "UNVOICINGS": "UNVOICING, change to a voiceless sound [n]\n",
  "UNVOYAGEABLE": "not voyageable [adj]\n",
  "UNVULGAR": "not vulgar [adj]\n",
  "UNVULGARISE": "to make not vulgar, also UNVULGARIZE [v UNVULGARISED, UNVULGARISING, UNVULGARISES]\n",
  "UNVULGARISED": "UNVULGARISE, to make not vulgar, also UNVULGARIZE [v]\n",
  "UNVULGARISES": "UNVULGARISE, to make not vulgar, also UNVULGARIZE [v]\n",
  "UNVULGARISING": "UNVULGARISE, to make not vulgar, also UNVULGARIZE [v]\n",
  "UNVULGARIZE": "to make not vulgar, also UNVULGARISE [v UNVULGARIZED, UNVULGARIZING, UNVULGARIZES]\n",
  "UNVULGARIZED": "UNVULGARIZE, to make not vulgar, also UNVULGARISE [v]\n",
  "UNVULGARIZES": "UNVULGARIZE, to make not vulgar, also UNVULGARISE [v]\n",
  "UNVULGARIZING": "UNVULGARIZE, to make not vulgar, also UNVULGARISE [v]\n",
  "UNVULNERABLE": "(Shakespeare) invulnerable [adj]\n",
  "UNWAGED": "not receiving a wage [adj]\n",
  "UNWAISTED": "not waisted [adj]\n",
  "UNWAKED": "not waked, also UNWAKENED [adj]\n",
  "UNWAKENED": "not wakened, also UNWAKED [adj]\n",
  "UNWALLED": "not walled [adj]\n",
  "UNWANDERING": "not wandering [adj]\n",
  "UNWANING": "not waning [adj]\n",
  "UNWANTED": "not wanted [adj]\n",
  "UNWARDED": "not warded [adj]\n",
  "UNWARE": "unwarily, unawares, also UNAWARE, UNAWARES, UNWARES [adj UNWARELY]\n",
  "UNWARELY": "(obsolete) unwarily [adv]\n",
  "UNWARENESS": "(archaic) unwariness, also UNWARINESS [n -ES]\n",
  "UNWARENESSES": "UNWARENESS, (archaic) unwariness, also UNWARINESS [n]\n",
  "UNWARES": "(archaic) unwary, unaware, also UNAWARE, UNAWARES, UNWARE [adv]\n",
  "UNWARIE": "(Spenser) unwary [adj]\n",
  "UNWARIER": "UNWARIE, (Spenser) unwary [adj]\n",
  "UNWARIEST": "UNWARIE, (Spenser) unwary [adj]\n",
  "UNWARILY": "UNWARY, not wary, also UNWARIE [adv]\n",
  "UNWARINESS": "the state of being unwary, also UNWARENESS [n -ES]\n",
  "UNWARINESSES": "UNWARINESS, the state of being unwary, also UNWARENESS [n]\n",
  "UNWARLIKE": "not warlike [adj]\n",
  "UNWARMED": "not warmed [adj]\n",
  "UNWARNED": "not warned [adj]\n",
  "UNWARPED": "not warped [adj]\n",
  "UNWARRANTABLE": "not justifiable [adj UNWARRANTABLY]\n",
  "UNWARRANTABLY": "UNWARRANTABLE, not justifiable [adv]\n",
  "UNWARRANTED": "not warranted [adj UNWARRANTEDLY]\n",
  "UNWARRANTEDLY": "UNWARRANTED, not warranted [adv]\n",
  "UNWARY": "not wary, also UNWARIE [adj UNWARIER, UNWARIEST, UNWARILY]\n",
  "UNWASHED": "(colloquial) the lower classes [n -S]\n",
  "UNWASHEDNESS": "the state of being unwashed [n -ES]\n",
  "UNWASHEDNESSES": "UNWASHEDNESS, the state of being unwashed [n]\n",
  "UNWASHEDS": "UNWASHED, (colloquial) the lower classes [n]\n",
  "UNWASHEN": "not washed [adj]\n",
  "UNWASTED": "not wasted [adj]\n",
  "UNWASTING": "not wasting [adj]\n",
  "UNWATCHABLE": "not suitable or fit for watching [adj]\n",
  "UNWATCHED": "not watched [adj]\n",
  "UNWATCHFUL": "not watchful [adj UNWATCHFULLY]\n",
  "UNWATCHFULLY": "UNWATCHFUL, not watchful [adv]\n",
  "UNWATCHFULNESS": "the state of being unwatchful [n]\n",
  "UNWATER": "to drain, esp. a mine [v -ED, -ING, -S]\n",
  "UNWATERED": "UNWATER, to drain, esp. a mine [v]\n",
  "UNWATERING": "UNWATER, to drain, esp. a mine [v]\n",
  "UNWATERS": "UNWATER, to drain, esp. a mine [v]\n",
  "UNWATERY": "not watery [adj]\n",
  "UNWAVERING": "not wavering [adj UNWAVERINGLY]\n",
  "UNWAVERINGLY": "UNWAVERING, not wavering [adv]\n",
  "UNWAXED": "not waxed [adj]\n",
  "UNWAYED": "(obsolete) not used to travel; as, colts that are unwayed [adj]\n",
  "UNWEAKENED": "not weakened [adj]\n",
  "UNWEAL": "(obsolete) affliction [n -S]\n",
  "UNWEALS": "UNWEAL, (obsolete) affliction [n]\n",
  "UNWEANED": "not weaned [adj]\n",
  "UNWEAPON": "to disarm [v -ED, -ING, -S]\n",
  "UNWEAPONED": "UNWEAPON, to disarm [v]\n",
  "UNWEAPONING": "UNWEAPON, to disarm [v]\n",
  "UNWEAPONS": "UNWEAPON, to disarm [v]\n",
  "UNWEARABLE": "something that is not wearable [n -S]\n",
  "UNWEARABLES": "UNWEARABLE, something that is not wearable [n]\n",
  "UNWEARIABLE": "that cannot be wearied [adj UNWEARIABLY]\n",
  "UNWEARIABLY": "UNWEARIABLE, that cannot be wearied [adv]\n",
  "UNWEARIED": "not wearied [adj UNWEARIEDLY]\n",
  "UNWEARIEDLY": "UNWEARIED, not wearied [adv]\n",
  "UNWEARIEDNESS": "the state of being unwearied [n -ES]\n",
  "UNWEARIEDNESSES": "UNWEARIEDNESS, the state of being unwearied [n]\n",
  "UNWEARIER": "UNWEARY, not weary [adj]\n",
  "UNWEARIES": "UNWEARY, to cause weariness to cease [v]\n",
  "UNWEARIEST": "UNWEARY, not weary [adj]\n",
  "UNWEARY": "not weary [adj UNWEARIER, UNWEARIEST] / to cause weariness to cease [v UNWEARIED, UNWEARYING, UNWEARIES]\n",
  "UNWEARYING": "not growing weary [adj UNWEARYINGLY]\n",
  "UNWEARYINGLY": "UNWEARYING, not growing weary [adv]\n",
  "UNWEATHERED": "not weathered [adj]\n",
  "UNWEAVE": "to undo something woven [v UNWOVE, UNWOVEN, UNWEAVING, UNWEAVES]\n",
  "UNWEAVES": "UNWEAVE, to undo something woven [v]\n",
  "UNWEAVING": "UNWEAVE, to undo something woven [v]\n",
  "UNWEBBED": "not webbed [adj]\n",
  "UNWED": "not wed, also UNWEDDED [adj]\n",
  "UNWEDDED": "not wedded, also UNWED [adj]\n",
  "UNWEDGABLE": "(Shakespeare) that cannot be split into wedges, also UNWEDGEABLE [adj]\n",
  "UNWEDGEABLE": "that cannot be split into wedges, also UNWEDGABLE [adj]\n",
  "UNWEEDED": "not weeded [adj]\n",
  "UNWEENED": "unexpected [adj]\n",
  "UNWEETING": "(archaic) unwitting [adj UNWEETINGLY]\n",
  "UNWEETINGLY": "UNWEETING, (archaic) unwitting [adv]\n",
  "UNWEIGHED": "not weighed; not pondered or considered; as, an unweighed statement [adj]\n",
  "UNWEIGHING": "(Shakespeare) thoughtless, inconsiderate [adj]\n",
  "UNWEIGHT": "to reduce the weight of [v -ED, -ING, -S]\n",
  "UNWEIGHTED": "UNWEIGHT, to reduce the weight of [v]\n",
  "UNWEIGHTING": "the act of removing weight from [n -S]\n",
  "UNWEIGHTINGS": "UNWEIGHTING, the act of removing weight from [n]\n",
  "UNWEIGHTS": "UNWEIGHT, to reduce the weight of [v]\n",
  "UNWELCOME": "not welcome [adj UNWELCOMELY]\n",
  "UNWELCOMED": "not welcomed [adj]\n",
  "UNWELCOMELY": "UNWELCOME, not welcome [adv]\n",
  "UNWELCOMENESS": "the state of being unwelcome [n -ES]\n",
  "UNWELCOMENESSES": "UNWELCOMENESS, the state of being unwelcome [n]\n",
  "UNWELCOMING": "not welcoming [adj]\n",
  "UNWELDED": "not welded [adj]\n",
  "UNWELDY": "(Spenser) unwieldy, also UNWIELDLY [adj]\n",
  "UNWELL": "not well [adj]\n",
  "UNWELLNESS": "the state of being unwell [n -ES]\n",
  "UNWELLNESSES": "UNWELLNESS, the state of being unwell [n]\n",
  "UNWEPT": "not wept [adj]\n",
  "UNWESTERNISED": "not westernised, also UNWESTERNIZED [adj]\n",
  "UNWESTERNIZED": "not westernized, also UNWESTERNISED [adj]\n",
  "UNWET": "not wet [adj]\n",
  "UNWETTED": "not wetted [adj]\n",
  "UNWHIPPED": "not whipped, also UNWHIPT [adj]\n",
  "UNWHIPT": "(obsolete) not whipped, also UNWHIPPED [adj]\n",
  "UNWHISTLEABLE": "not whistleable [adj]\n",
  "UNWHITE": "not white [adj]\n",
  "UNWHOLESOME": "not wholesome [adj UNWHOLESOMELY]\n",
  "UNWHOLESOMELY": "UNWHOLESOME, not wholesome [adv]\n",
  "UNWHOLESOMENESS": "the state of being unwholesome [n]\n",
  "UNWIELDIER": "UNWIELDY, not wieldy [adj]\n",
  "UNWIELDIEST": "UNWIELDY, not wieldy [adj]\n",
  "UNWIELDILY": "UNWIELDY, not wieldy [adv]\n",
  "UNWIELDINESS": "the state of being unwieldy [n -ES]\n",
  "UNWIELDINESSES": "UNWIELDINESS, the state of being unwieldy [n]\n",
  "UNWIELDLILY": "UNWIELDLY, unwieldy, also UNWELDY, UNWIELDY [adv]\n",
  "UNWIELDLINESS": "the state of being unwieldy [n -ES]\n",
  "UNWIELDLINESSES": "UNWIELDLINESS, the state of being unwieldy [n]\n",
  "UNWIELDLY": "unwieldy, also UNWELDY, UNWIELDY [adj UNWIELDLILY]\n",
  "UNWIELDY": "not wieldy [adj UNWIELDIER, UNWIELDIEST, UNWIELDILY]\n",
  "UNWIFELIER": "UNWIFELY, not wifely [adj]\n",
  "UNWIFELIEST": "UNWIFELY, not wifely [adj]\n",
  "UNWIFELIKE": "not like a wife [adj]\n",
  "UNWIFELY": "not wifely [adj UNWIFELIER, UNWIFELIEST]\n",
  "UNWIGGED": "not wigged [adj]\n",
  "UNWILFUL": "not wilful [adj]\n",
  "UNWILL": "to deprive of will [v -ED, -ING, -S]\n",
  "UNWILLED": "UNWILL, to deprive of will [v]\n",
  "UNWILLING": "not willing [adj UNWILLINGLY]\n",
  "UNWILLINGLY": "UNWILLING, not willing [adv]\n",
  "UNWILLINGNESS": "the state of being unwilling [n -ES]\n",
  "UNWILLINGNESSES": "UNWILLINGNESS, the state of being unwilling [n]\n",
  "UNWILLS": "UNWILL, to deprive of will [v]\n",
  "UNWIND": "to reverse the winding of [v UNWOUND, UNWINDING, UNWINDS]\n",
  "UNWINDABLE": "that can be unwound [adj]\n",
  "UNWINDER": "one who unwinds [n -S]\n",
  "UNWINDERS": "UNWINDER, one who unwinds [n]\n",
  "UNWINDING": "the act of unwinding [n -S]\n",
  "UNWINDINGS": "UNWINDING, the act of unwinding [n]\n",
  "UNWINDS": "UNWIND, to reverse the winding of [v]\n",
  "UNWINGED": "not winged [adj]\n",
  "UNWINKING": "not winking [adj UNWINKINGLY]\n",
  "UNWINKINGLY": "UNWINKING, not winking [adv]\n",
  "UNWINNABLE": "not winnable [adj]\n",
  "UNWINNOWED": "not winnowed [adj]\n",
  "UNWIPED": "not wiped [adj]\n",
  "UNWIRE": "to take the wire from [v UNWIRED, UNWIRING, UNWIRES]\n",
  "UNWIRED": "UNWIRE, to take the wire from [v]\n",
  "UNWIRES": "UNWIRE, to take the wire from [v]\n",
  "UNWIRING": "UNWIRE, to take the wire from [v]\n",
  "UNWISDOM": "lack of wisdom [n -S]\n",
  "UNWISDOMS": "UNWISDOM, lack of wisdom [n]\n",
  "UNWISE": "not wise [adj UNWISER, UNWISEST, UNWISELY]\n",
  "UNWISELY": "UNWISE, not wise [adv]\n",
  "UNWISENESS": "the state of being unwise [n -ES]\n",
  "UNWISENESSES": "UNWISENESS, the state of being unwise [n]\n",
  "UNWISER": "UNWISE, not wise [adj]\n",
  "UNWISEST": "UNWISE, not wise [adj]\n",
  "UNWISH": "(Shakespeare) to wish not to be [v -ED, -ING, -ES]\n",
  "UNWISHED": "UNWISH, (Shakespeare) to wish not to be [v]\n",
  "UNWISHES": "UNWISH, (Shakespeare) to wish not to be [v]\n",
  "UNWISHFUL": "not wishful [adj]\n",
  "UNWISHING": "UNWISH, (Shakespeare) to wish not to be [v]\n",
  "UNWIST": "(archaic) not known [adj]\n",
  "UNWIT": "(Shakespeare) to deprive of wit [v UNWITTED, UNWITTING, UNWITS]\n",
  "UNWITCH": "to free from witchcraft [v -ED, -ING, -ES]\n",
  "UNWITCHED": "UNWITCH, to free from witchcraft [v]\n",
  "UNWITCHES": "UNWITCH, to free from witchcraft [v]\n",
  "UNWITCHING": "UNWITCH, to free from witchcraft [v]\n",
  "UNWITHDRAWING": "liberal; lavish [adj]\n",
  "UNWITHERED": "not withered [adj]\n",
  "UNWITHERING": "not withering [adj]\n",
  "UNWITHHELD": "not withheld, also UNWITHHOLDEN [adj]\n",
  "UNWITHHOLDEN": "not withholden, also UNWITHHELD [adj]\n",
  "UNWITHHOLDING": "not withholding [adj]\n",
  "UNWITHSTOOD": "not withstood [adj]\n",
  "UNWITNESSED": "not witnessed [adj]\n",
  "UNWITS": "UNWIT, (Shakespeare) to deprive of wit [v]\n",
  "UNWITTED": "UNWIT, (Shakespeare) to deprive of wit [v]\n",
  "UNWITTIER": "UNWITTY, not witty [adj]\n",
  "UNWITTIEST": "UNWITTY, not witty [adj]\n",
  "UNWITTILY": "UNWITTY, not witty [adv]\n",
  "UNWITTING": "without knowledge, also UNWEETING [adj UNWITTINGLY]\n",
  "UNWITTINGLY": "UNWITTING, without knowledge, also UNWEETING [adv]\n",
  "UNWITTINGNESS": "the state of being unwitting [n -ES]\n",
  "UNWITTINGNESSES": "UNWITTINGNESS, the state of being unwitting [n]\n",
  "UNWITTY": "not witty [adj UNWITTIER, UNWITTIEST, UNWITTILY]\n",
  "UNWIVE": "to deprive of a wife [v UNWIVED, UNWIVING, UNWIVES]\n",
  "UNWIVED": "UNWIVE, to deprive of a wife [v]\n",
  "UNWIVES": "UNWIVE, to deprive of a wife [v]\n",
  "UNWIVING": "UNWIVE, to deprive of a wife [v]\n",
  "UNWOMAN": "to make unwomanly [v -ED, -ING, -S]\n",
  "UNWOMANED": "UNWOMAN, to make unwomanly [v]\n",
  "UNWOMANING": "UNWOMAN, to make unwomanly [v]\n",
  "UNWOMANLIER": "UNWOMANLY, not proper to a woman [adj]\n",
  "UNWOMANLIEST": "UNWOMANLY, not proper to a woman [adj]\n",
  "UNWOMANLINESS": "the state of being unwomanly [n -ES]\n",
  "UNWOMANLINESSES": "UNWOMANLINESS, the state of being unwomanly [n]\n",
  "UNWOMANLY": "not proper to a woman [adj UNWOMANLIER, UNWOMANLIEST]\n",
  "UNWOMANS": "UNWOMAN, to make unwomanly [v]\n",
  "UNWON": "not won [adj]\n",
  "UNWONT": "unaccustomed, also UNWONTED [adj]\n",
  "UNWONTED": "unaccustomed, also UNWONT [adj UNWONTEDLY]\n",
  "UNWONTEDLY": "UNWONTED, unaccustomed, also UNWONT [adv]\n",
  "UNWONTEDNESS": "the state of being unwonted [n -ES]\n",
  "UNWONTEDNESSES": "UNWONTEDNESS, the state of being unwonted [n]\n",
  "UNWOODED": "not wooded [adj]\n",
  "UNWOOED": "not wooed [adj]\n",
  "UNWORDED": "speechless [adj]\n",
  "UNWORK": "to undo or destroy, as work previously done [v UNWORKED or UNWROUGHT, UNWORKING, UNWORKS]\n",
  "UNWORKABILITIES": "UNWORKABILITY, the quality of being unworkable [n]\n",
  "UNWORKABILITY": "the quality of being unworkable [n UNWORKABILITIES]\n",
  "UNWORKABLE": "not workable [adj]\n",
  "UNWORKED": "UNWORK, to undo or destroy, as work previously done [v]\n",
  "UNWORKING": "UNWORK, to undo or destroy, as work previously done [v]\n",
  "UNWORKMANLIKE": "not workmanlike [adj]\n",
  "UNWORKS": "UNWORK, to undo or destroy, as work previously done [v]\n",
  "UNWORLDLIER": "UNWORLDLY, not belonging to this world [adj]\n",
  "UNWORLDLIEST": "UNWORLDLY, not belonging to this world [adj]\n",
  "UNWORLDLINESS": "the state of being unworldly [n -ES]\n",
  "UNWORLDLINESSES": "UNWORLDLINESS, the state of being unworldly [n]\n",
  "UNWORLDLY": "not belonging to this world [adj UNWORLDLIER, UNWORLDLIEST]\n",
  "UNWORMED": "of a dog, not wormed i.e. not having had the worm, or lytta, under the tongue cut out [adj]\n",
  "UNWORN": "not worn [adj]\n",
  "UNWORRIED": "not worried [adj]\n",
  "UNWORSHIPFUL": "not worshipful [adj]\n",
  "UNWORSHIPPED": "not worshipped [adj]\n",
  "UNWORTH": "lack of worth [n -S]\n",
  "UNWORTHIER": "UNWORTHY, not worthy [adj]\n",
  "UNWORTHIES": "UNWORTHY, one who is not worthy [n]\n",
  "UNWORTHIEST": "UNWORTHY, not worthy [adj]\n",
  "UNWORTHILY": "UNWORTHY, not worthy [adv]\n",
  "UNWORTHINESS": "the state of being unworthy [n -ES]\n",
  "UNWORTHINESSES": "UNWORTHINESS, the state of being unworthy [n]\n",
  "UNWORTHS": "UNWORTH, lack of worth [n]\n",
  "UNWORTHY": "not worthy [adj UNWORTHIER, UNWORTHIEST, UNWORTHILY] / one who is not worthy [n UNWORTHIES]\n",
  "UNWOUND": "UNWIND, to reverse the winding of [v]\n",
  "UNWOUNDABLE": "not woundable [adj]\n",
  "UNWOUNDED": "not wounded [adj]\n",
  "UNWOVE": "UNWEAVE, to undo something woven [v]\n",
  "UNWOVEN": "UNWEAVE, to undo something woven [v]\n",
  "UNWRAP": "to remove the wrapping of [v UNWRAPPED, UNWRAPPING, UNWRAPS]\n",
  "UNWRAPPED": "UNWRAP, to remove the wrapping of [v]\n",
  "UNWRAPPING": "UNWRAP, to remove the wrapping of [v]\n",
  "UNWRAPS": "UNWRAP, to remove the wrapping of [v]\n",
  "UNWREAKED": "not wreaked [adj]\n",
  "UNWREATHE": "to take out of a wreathed condition [v UNWREATHED, UNWREATHING, UNWREATHES]\n",
  "UNWREATHED": "UNWREATHE, to take out of a wreathed condition [v]\n",
  "UNWREATHES": "UNWREATHE, to take out of a wreathed condition [v]\n",
  "UNWREATHING": "UNWREATHE, to take out of a wreathed condition [v]\n",
  "UNWRINKLE": "to reduce from a wrinkled state [v UNWRINKLED, UNWRINKLING, UNWRINKLES]\n",
  "UNWRINKLED": "UNWRINKLE, to reduce from a wrinkled state [v]\n",
  "UNWRINKLES": "UNWRINKLE, to reduce from a wrinkled state [v]\n",
  "UNWRINKLING": "UNWRINKLE, to reduce from a wrinkled state [v]\n",
  "UNWRITE": "to undo the writing of [v UNWROTE, UNWRITTEN, UNWRITING, UNWRITES]\n",
  "UNWRITES": "UNWRITE, to undo the writing of [v]\n",
  "UNWRITING": "UNWRITE, to undo the writing of [v]\n",
  "UNWRITTEN": "UNWRITE, to undo the writing of [v]\n",
  "UNWROTE": "UNWRITE, to undo the writing of [v]\n",
  "UNWROUGHT": "UNWORK, to undo or destroy, as work previously done [v]\n",
  "UNWRUNG": "not wrung [adj]\n",
  "UNYEANED": "not yeaned [adj]\n",
  "UNYIELDED": "not yielded [adj]\n",
  "UNYIELDING": "characterized by firmness or obduracy [adj UNYIELDINGLY]\n",
  "UNYIELDINGLY": "UNYIELDING, characterized by firmness or obduracy [adv]\n",
  "UNYIELDINGNESS": "the state of being unyielding [n]\n",
  "UNYOKE": "to free from a yoke [v UNYOKED, UNYOKING, UNYOKES]\n",
  "UNYOKED": "UNYOKE, to free from a yoke [v]\n",
  "UNYOKES": "UNYOKE, to free from a yoke [v]\n",
  "UNYOKING": "UNYOKE, to free from a yoke [v]\n",
  "UNYOUNG": "not young [adj]\n",
  "UNZEALOUS": "not zealous [adj]\n",
  "UNZIP": "to open the zipper of [v UNZIPPED, UNZIPPING, UNZIPS]\n",
  "UNZIPPED": "UNZIP, to open the zipper of [v]\n",
  "UNZIPPING": "UNZIP, to open the zipper of [v]\n",
  "UNZIPS": "UNZIP, to open the zipper of [v]\n",
  "UNZONED": "not zoned [adj]\n",
  "UP": "to raise [v UPPED, UPPING, UPS]\n",
  "UPADAISY": "an expression of reassurance to someone who has fallen over, also UPSADAISY [interj]\n",
  "UPAITHRIC": "roofless; open to the sky (usually intentionally, so as to see the stars), also HUPAITHRIC, HYPAETHRAL, HYPETHRAL [adj]\n",
  "UPALONG": "a location away from a person or place [n -S]\n",
  "UPALONGS": "UPALONG, a location away from a person or place [n]\n",
  "UPAS": "(Malay) an Asian tree with a poisonous drip [n -ES]\n",
  "UPASES": "UPAS, (Malay) an Asian tree with a poisonous drip [n]\n",
  "UPBEAR": "to raise aloft [v UPBORE, UPBORNE, UPBEARING, UPBEARS]\n",
  "UPBEARER": "one who bears up [n -S]\n",
  "UPBEARERS": "UPBEARER, one who bears up [n]\n",
  "UPBEARING": "UPBEAR, to raise aloft [v]\n",
  "UPBEARS": "UPBEAR, to raise aloft [v]\n",
  "UPBEAT": "an unaccented beat in a musical measure [n -S]\n",
  "UPBEATS": "UPBEAT, an unaccented beat in a musical measure [n]\n",
  "UPBIND": "to bind completely [v UPBOUND, (Spenser) UPBOUNDEN, UPBINDING, UPBINDS]\n",
  "UPBINDING": "UPBIND, to bind completely [v]\n",
  "UPBINDS": "UPBIND, to bind completely [v]\n",
  "UPBLEW": "UPBLOW, to blow up [v]\n",
  "UPBLOW": "to blow up [v UPBLEW, UPBLOWN, UPBLOWING, UPBLOWS]\n",
  "UPBLOWING": "UPBLOW, to blow up [v]\n",
  "UPBLOWN": "UPBLOW, to blow up [v]\n",
  "UPBLOWS": "UPBLOW, to blow up [v]\n",
  "UPBOIL": "to boil up [v -ED, -ING, -S]\n",
  "UPBOILED": "UPBOIL, to boil up [v]\n",
  "UPBOILING": "UPBOIL, to boil up [v]\n",
  "UPBOILS": "UPBOIL, to boil up [v]\n",
  "UPBORE": "UPBEAR, to raise aloft [v]\n",
  "UPBORNE": "UPBEAR, to raise aloft [v]\n",
  "UPBOUND": "UPBIND, to bind completely [v]\n",
  "UPBOUNDEN": "UPBIND, to bind completely [v]\n",
  "UPBOW": "a type of stroke in playing a bowed instrument [n -S]\n",
  "UPBOWS": "UPBOW, a type of stroke in playing a bowed instrument [n]\n",
  "UPBRAID": "to reproach severely, also UPBRAY [v -ED, -ING, -S]\n",
  "UPBRAIDED": "UPBRAID, to reproach severely, also UPBRAY [v]\n",
  "UPBRAIDER": "one who upbraids [n -S]\n",
  "UPBRAIDERS": "UPBRAIDER, one who upbraids [n]\n",
  "UPBRAIDING": "reproachful [adj UPBRAIDINGLY] / the act of upbraiding [n -S]\n",
  "UPBRAIDINGLY": "UPBRAIDING, reproachful [adv]\n",
  "UPBRAIDINGS": "UPBRAIDING, the act of upbraiding [n]\n",
  "UPBRAIDS": "UPBRAID, to reproach severely, also UPBRAY [v]\n",
  "UPBRAST": "UPBURST, to burst upwards [v]\n",
  "UPBRAY": "(Spenser) to upbraid [v -ED, -ING, -S]\n",
  "UPBRAYED": "UPBRAY, (Spenser) to upbraid [v]\n",
  "UPBRAYING": "UPBRAY, (Spenser) to upbraid [v]\n",
  "UPBRAYS": "UPBRAY, (Spenser) to upbraid [v]\n",
  "UPBREAK": "to break out [v UPBROKE, UPBROKEN, UPBREAKING, UPBREAKS]\n",
  "UPBREAKING": "UPBREAK, to break out [v]\n",
  "UPBREAKS": "UPBREAK, to break out [v]\n",
  "UPBRING": "to bring up [v UPBROUGHT, UPBRINGING, UPBRINGS]\n",
  "UPBRINGING": "the way a child is brought up [n -S]\n",
  "UPBRINGINGS": "UPBRINGING, the way a child is brought up [n]\n",
  "UPBRINGS": "UPBRING, to bring up [v]\n",
  "UPBROKE": "UPBREAK, to break out [v]\n",
  "UPBROKEN": "UPBREAK, to break out [v]\n",
  "UPBROUGHT": "UPBRING, to bring up [v]\n",
  "UPBUILD": "to build up [v UPBUILT, UPBUILDING, UPBUILDS]\n",
  "UPBUILDER": "one who upbuilds [n -S]\n",
  "UPBUILDERS": "UPBUILDER, one who upbuilds [n]\n",
  "UPBUILDING": "development; edification [n -S]\n",
  "UPBUILDINGS": "UPBUILDING, development; edification [n]\n",
  "UPBUILDS": "UPBUILD, to build up [v]\n",
  "UPBUILT": "UPBUILD, to build up [v]\n",
  "UPBUOYANCE": "the act of buoying up [n -S]\n",
  "UPBUOYANCES": "UPBUOYANCE, the act of buoying up [n]\n",
  "UPBURNING": "flaming upwards [adj]\n",
  "UPBURST": "to burst upwards [v UPBURST or (Spenser) UPBRAST, UPBURSTING, UPBURSTS]\n",
  "UPBURSTING": "UPBURST, to burst upwards [v]\n",
  "UPBURSTS": "UPBURST, to burst upwards [v]\n",
  "UPBY": "a little further on, also UPBYE [adv]\n",
  "UPBYE": "a little further on, also UPBY [adv]\n",
  "UPCAST": "to cast up [v UPCAST, UPCASTING, UPCASTS]\n",
  "UPCASTING": "UPCAST, to cast up [v]\n",
  "UPCASTS": "UPCAST, to cast up [v]\n",
  "UPCATCH": "to catch up [v UPCAUGHT, UPCATCHING, UPCATCHES]\n",
  "UPCATCHES": "UPCATCH, to catch up [v]\n",
  "UPCATCHING": "UPCATCH, to catch up [v]\n",
  "UPCAUGHT": "UPCATCH, to catch up [v]\n",
  "UPCHEER": "to encourage [v -ED, -ING, -S]\n",
  "UPCHEERED": "UPCHEER, to encourage [v]\n",
  "UPCHEERING": "UPCHEER, to encourage [v]\n",
  "UPCHEERS": "UPCHEER, to encourage [v]\n",
  "UPCHUCK": "to vomit [v -ED, -ING, -S]\n",
  "UPCHUCKED": "UPCHUCK, to vomit [v]\n",
  "UPCHUCKING": "UPCHUCK, to vomit [v]\n",
  "UPCHUCKS": "UPCHUCK, to vomit [v]\n",
  "UPCLIMB": "to climb up [v -ED, -ING, -S]\n",
  "UPCLIMBED": "UPCLIMB, to climb up [v]\n",
  "UPCLIMBING": "UPCLIMB, to climb up [v]\n",
  "UPCLIMBS": "UPCLIMB, to climb up [v]\n",
  "UPCLOSE": "to close up [v UPCLOSED, UPCLOSING, UPCLOSES]\n",
  "UPCLOSED": "UPCLOSE, to close up [v]\n",
  "UPCLOSES": "UPCLOSE, to close up [v]\n",
  "UPCLOSING": "UPCLOSE, to close up [v]\n",
  "UPCOAST": "up the coast [adv]\n",
  "UPCOIL": "to coil up [v -ED, -ING, -S]\n",
  "UPCOILED": "UPCOIL, to coil up [v]\n",
  "UPCOILING": "UPCOIL, to coil up [v]\n",
  "UPCOILS": "UPCOIL, to coil up [v]\n",
  "UPCOME": "produce, outcome [n -S]\n",
  "UPCOMES": "UPCOME, produce, outcome [n]\n",
  "UPCOMING": "about to happen [adv]\n",
  "UPCOUNTRIES": "UPCOUNTRY, the interior of a country [n]\n",
  "UPCOUNTRY": "of or in the interior of a country [adj] / the interior of a country [n UPCOUNTRIES]\n",
  "UPCOURT": "in basketball, in a direction towards the basket, also DOWNCOURT [adj]\n",
  "UPCURL": "to curl up [v -ED, -ING, -S]\n",
  "UPCURLED": "UPCURL, to curl up [v]\n",
  "UPCURLING": "UPCURL, to curl up [v]\n",
  "UPCURLS": "UPCURL, to curl up [v]\n",
  "UPCURVE": "to curve upward [v UPCURVED, UPCURVING, UPCURVES]\n",
  "UPCURVED": "UPCURVE, to curve upward [v]\n",
  "UPCURVES": "UPCURVE, to curve upward [v]\n",
  "UPCURVING": "UPCURVE, to curve upward [v]\n",
  "UPCYCLE": "to recycle waste products into something of higher value than the original materials [v UPCYCLED, UPCYCLING, UPCYCLES]\n",
  "UPCYCLED": "UPCYCLE, to recycle waste products into something of higher value than the original materials [v]\n",
  "UPCYCLES": "UPCYCLE, to recycle waste products into something of higher value than the original materials [v]\n",
  "UPCYCLING": "UPCYCLE, to recycle waste products into something of higher value than the original materials [v]\n",
  "UPDART": "to dart up [v -ED, -ING, -S]\n",
  "UPDARTED": "UPDART, to dart up [v]\n",
  "UPDARTING": "UPDART, to dart up [v]\n",
  "UPDARTS": "UPDART, to dart up [v]\n",
  "UPDATABLE": "capable of being updated, also UPDATEABLE [adj]\n",
  "UPDATE": "to bring up to date [v UPDATED, UPDATING, UPDATES]\n",
  "UPDATEABLE": "capable of being updated, also UPDATABLE [adj]\n",
  "UPDATED": "UPDATE, to bring up to date [v]\n",
  "UPDATER": "one who updates [n -S]\n",
  "UPDATERS": "UPDATER, one who updates [n]\n",
  "UPDATES": "UPDATE, to bring up to date [v]\n",
  "UPDATING": "UPDATE, to bring up to date [v]\n",
  "UPDIVE": "to spring upward [v UPDIVED, UPDOVE, UPDIVING, UPDIVES]\n",
  "UPDIVED": "UPDIVE, to spring upward [v]\n",
  "UPDIVES": "UPDIVE, to spring upward [v]\n",
  "UPDIVING": "UPDIVE, to spring upward [v]\n",
  "UPDO": "an upswept hairdo [n -S]\n",
  "UPDOMING": "the upward deformation of a rock mass into a dome shape [n -S]\n",
  "UPDOMINGS": "UPDOMING, the upward deformation of a rock mass into a dome shape [n]\n",
  "UPDOS": "UPDO, an upswept hairdo [n]\n",
  "UPDOVE": "UPDIVE, to spring upward [v]\n",
  "UPDRAFT": "an upwards movement of air, also UPDRAUGHT [n -S]\n",
  "UPDRAFTS": "UPDRAFT, an upwards movement of air, also UPDRAUGHT [n]\n",
  "UPDRAG": "to drag upward [v UPDRAGGED, UPDRAGGING, UPDRAGS]\n",
  "UPDRAGGED": "UPDRAG, to drag upward [v]\n",
  "UPDRAGGING": "the act of dragging up [n -S]\n",
  "UPDRAGGINGS": "UPDRAGGING, the act of dragging up [n]\n",
  "UPDRAGS": "UPDRAG, to drag upward [v]\n",
  "UPDRAUGHT": "an upwards movement of air, also UPDRAFT [n -S]\n",
  "UPDRAUGHTS": "UPDRAUGHT, an upwards movement of air, also UPDRAFT [n]\n",
  "UPDRAW": "to draw up [v UPDREW, UPDRAWN, UPDRAWING, UPDRAWS]\n",
  "UPDRAWING": "UPDRAW, to draw up [v]\n",
  "UPDRAWN": "UPDRAW, to draw up [v]\n",
  "UPDRAWS": "UPDRAW, to draw up [v]\n",
  "UPDREW": "UPDRAW, to draw up [v]\n",
  "UPDRIED": "UPDRY, to dry completely [v]\n",
  "UPDRIES": "UPDRY, to dry completely [v]\n",
  "UPDRY": "to dry completely [v UPDRIED, UPDRYING, UPDRIES]\n",
  "UPDRYING": "UPDRY, to dry completely [v]\n",
  "UPEND": "to turn upside down [v -ED, -ING, -S]\n",
  "UPENDED": "UPEND, to turn upside down [v]\n",
  "UPENDING": "UPEND, to turn upside down [v]\n",
  "UPENDS": "UPEND, to turn upside down [v]\n",
  "UPFIELD": "towards the play area where the offensive team is going [adv]\n",
  "UPFILL": "to fill up [v -ED, -ING, -S]\n",
  "UPFILLED": "UPFILL, to fill up [v]\n",
  "UPFILLING": "the act of filling up [n -S]\n",
  "UPFILLINGS": "UPFILLING, the act of filling up [n]\n",
  "UPFILLS": "UPFILL, to fill up [v]\n",
  "UPFLASHING": "flashing up [adj]\n",
  "UPFLING": "to fling up [v UPFLUNG, UPFLINGING, UPFLINGS]\n",
  "UPFLINGING": "UPFLING, to fling up [v]\n",
  "UPFLINGS": "UPFLING, to fling up [v]\n",
  "UPFLOW": "to flow up [v -ED, -ING, -S]\n",
  "UPFLOWED": "UPFLOW, to flow up [v]\n",
  "UPFLOWING": "UPFLOW, to flow up [v]\n",
  "UPFLOWS": "UPFLOW, to flow up [v]\n",
  "UPFLUNG": "UPFLING, to fling up [v]\n",
  "UPFOLD": "to fold up [v -ED, -ING, -S]\n",
  "UPFOLDED": "UPFOLD, to fold up [v]\n",
  "UPFOLDING": "UPFOLD, to fold up [v]\n",
  "UPFOLDS": "UPFOLD, to fold up [v]\n",
  "UPFOLLOW": "(Keats) to follow [v -ED, -ING, -S]\n",
  "UPFOLLOWED": "UPFOLLOW, (Keats) to follow [v]\n",
  "UPFOLLOWING": "UPFOLLOW, (Keats) to follow [v]\n",
  "UPFOLLOWS": "UPFOLLOW, (Keats) to follow [v]\n",
  "UPFRONT": "honest, candid [adj]\n",
  "UPFURL": "to roll up [v -ED, -ING, -S]\n",
  "UPFURLED": "UPFURL, to roll up [v]\n",
  "UPFURLING": "UPFURL, to roll up [v]\n",
  "UPFURLS": "UPFURL, to roll up [v]\n",
  "UPGANG": "(Scots) ascent [n -S]\n",
  "UPGANGS": "UPGANG, (Scots) ascent [n]\n",
  "UPGATHER": "to gather up [v -ED, -ING, -S]\n",
  "UPGATHERED": "UPGATHER, to gather up [v]\n",
  "UPGATHERING": "UPGATHER, to gather up [v]\n",
  "UPGATHERS": "UPGATHER, to gather up [v]\n",
  "UPGAZE": "to gaze up [v UPGAZED, UPGAZING, UPGAZES]\n",
  "UPGAZED": "UPGAZE, to gaze up [v]\n",
  "UPGAZES": "UPGAZE, to gaze up [v]\n",
  "UPGAZING": "UPGAZE, to gaze up [v]\n",
  "UPGIRD": "to gird completely [v UPGIRDED, UPGIRT, UPGIRDING, UPGIRDS]\n",
  "UPGIRDED": "UPGIRD, to gird completely [v]\n",
  "UPGIRDING": "UPGIRD, to gird completely [v]\n",
  "UPGIRDS": "UPGIRD, to gird completely [v]\n",
  "UPGIRT": "to gird completely, also UPGIRD [v -ED, -ING, -S]\n",
  "UPGIRTED": "UPGIRT, to gird completely, also UPGIRD [v]\n",
  "UPGIRTING": "UPGIRT, to gird completely, also UPGIRD [v]\n",
  "UPGIRTS": "UPGIRT, to gird completely, also UPGIRD [v]\n",
  "UPGO": "to go up [v UPWENT, UPGONE, UPGOING, UPGOES]\n",
  "UPGOES": "UPGO, to go up [v]\n",
  "UPGOING": "the act of going up [n -S]\n",
  "UPGOINGS": "UPGOING, the act of going up [n]\n",
  "UPGONE": "UPGO, to go up [v]\n",
  "UPGRADABILITIES": "UPGRADABILITY, the state of being upgradable [n]\n",
  "UPGRADABILITY": "the state of being upgradable [n UPGRADABILITIES]\n",
  "UPGRADABLE": "that can be upgraded e.g. of computer equipment, also UPGRADEABLE [adj]\n",
  "UPGRADATION": "the act of upgrading [n -S]\n",
  "UPGRADATIONS": "UPGRADATION, the act of upgrading [n]\n",
  "UPGRADE": "to raise to a higher standard [v UPGRADED, UPGRADING, UPGRADES]\n",
  "UPGRADEABILITY": "the state of being upgradeable, also UPGRADABILITY [n]\n",
  "UPGRADEABLE": "that can be upgraded e.g. of computer equipment, also UPGRADABLE [adj]\n",
  "UPGRADED": "UPGRADE, to raise to a higher standard [v]\n",
  "UPGRADER": "one who upgrades [n -S]\n",
  "UPGRADERS": "UPGRADER, one who upgrades [n]\n",
  "UPGRADES": "UPGRADE, to raise to a higher standard [v]\n",
  "UPGRADING": "UPGRADE, to raise to a higher standard [v]\n",
  "UPGREW": "UPGROW, to grow up [v]\n",
  "UPGROW": "to grow up [v UPGREW, UPGROWN, UPGROWING, UPGROWS]\n",
  "UPGROWING": "the act of upgrowing [n -S]\n",
  "UPGROWINGS": "UPGROWING, the act of upgrowing [n]\n",
  "UPGROWN": "UPGROW, to grow up [v]\n",
  "UPGROWS": "UPGROW, to grow up [v]\n",
  "UPGROWTH": "the process of growing up [n -S]\n",
  "UPGROWTHS": "UPGROWTH, the process of growing up [n]\n",
  "UPGUSH": "to gush up [v -ED, -ING, -ES]\n",
  "UPGUSHED": "UPGUSH, to gush up [v]\n",
  "UPGUSHES": "UPGUSH, to gush up [v]\n",
  "UPGUSHING": "UPGUSH, to gush up [v]\n",
  "UPHAND": "lifted by hand [adj]\n",
  "UPHANG": "to hang up [v UPHUNG, UPHANGING, UPHANGS]\n",
  "UPHANGING": "UPHANG, to hang up [v]\n",
  "UPHANGS": "UPHANG, to hang up [v]\n",
  "UPHAUD": "(Scots) to maintain, warrant [v UPHAUD, UPHUDDEN, UPHAUDING, UPHAUDS]\n",
  "UPHAUDING": "UPHAUD, (Scots) to maintain, warrant [v]\n",
  "UPHAUDS": "UPHAUD, (Scots) to maintain, warrant [v]\n",
  "UPHEAP": "to heap up [v -ED, -ING, -S]\n",
  "UPHEAPED": "UPHEAP, to heap up [v]\n",
  "UPHEAPING": "the act of heaping up [n -S]\n",
  "UPHEAPINGS": "UPHEAPING, the act of heaping up [n]\n",
  "UPHEAPS": "UPHEAP, to heap up [v]\n",
  "UPHEAVAL": "the act of upheaving [n -S]\n",
  "UPHEAVALS": "UPHEAVAL, the act of upheaving [n]\n",
  "UPHEAVE": "to heave up [v UPHEAVED, UPHOVE, UPHEAVING, UPHEAVES]\n",
  "UPHEAVED": "UPHEAVE, to heave up [v]\n",
  "UPHEAVER": "one who upheaves [n -S]\n",
  "UPHEAVERS": "UPHEAVER, one who upheaves [n]\n",
  "UPHEAVES": "UPHEAVE, to heave up [v]\n",
  "UPHEAVING": "UPHEAVE, to heave up [v]\n",
  "UPHELD": "UPHOLD, to hold aloft [v]\n",
  "UPHILD": "UPHOLD, to hold aloft [v]\n",
  "UPHILL": "an upward slope [n -S]\n",
  "UPHILLS": "UPHILL, an upward slope [n]\n",
  "UPHILLWARD": "(Milton) in an uphill direction [adv]\n",
  "UPHOARD": "to hoard up, also UPHOORD [v -ED, -ING, -S]\n",
  "UPHOARDED": "UPHOARD, to hoard up, also UPHOORD [v]\n",
  "UPHOARDING": "UPHOARD, to hoard up, also UPHOORD [v]\n",
  "UPHOARDS": "UPHOARD, to hoard up, also UPHOORD [v]\n",
  "UPHOIST": "to hoist up [v -ED, -ING, -S]\n",
  "UPHOISTED": "UPHOIST, to hoist up [v]\n",
  "UPHOISTING": "UPHOIST, to hoist up [v]\n",
  "UPHOISTS": "UPHOIST, to hoist up [v]\n",
  "UPHOLD": "to hold aloft [v UPHELD or (Spenser) UPHILD, UPHOLDING, UPHOLDS]\n",
  "UPHOLDER": "one who upholds [n -S]\n",
  "UPHOLDERS": "UPHOLDER, one who upholds [n]\n",
  "UPHOLDING": "the act of upholding [n -S]\n",
  "UPHOLDINGS": "UPHOLDING, the act of upholding [n]\n",
  "UPHOLDS": "UPHOLD, to hold aloft [v]\n",
  "UPHOLSTER": "to provide with stuffing, springs, covers, etc. [v -ED, -ING, -S]\n",
  "UPHOLSTERED": "UPHOLSTER, to provide with stuffing, springs, covers, etc. [v]\n",
  "UPHOLSTERER": "one who upholsters [n -S]\n",
  "UPHOLSTERERS": "UPHOLSTERER, one who upholsters [n]\n",
  "UPHOLSTERIES": "UPHOLSTERY, material used to make a soft covering esp. for a seat [n]\n",
  "UPHOLSTERING": "UPHOLSTER, to provide with stuffing, springs, covers, etc. [v]\n",
  "UPHOLSTERS": "UPHOLSTER, to provide with stuffing, springs, covers, etc. [v]\n",
  "UPHOLSTERY": "material used to make a soft covering esp. for a seat [n UPHOLSTERIES]\n",
  "UPHOLSTRESS": "a female upholsterer [n -ES]\n",
  "UPHOLSTRESSES": "UPHOLSTRESS, a female upholsterer [n]\n",
  "UPHOORD": "(Shakespeare) to hoard up [v -ED, -ING, -S]\n",
  "UPHOORDED": "UPHOORD, (Shakespeare) to hoard up [v]\n",
  "UPHOORDING": "UPHOORD, (Shakespeare) to hoard up [v]\n",
  "UPHOORDS": "UPHOORD, (Shakespeare) to hoard up [v]\n",
  "UPHOVE": "UPHEAVE, to heave up [v]\n",
  "UPHROE": "(Dutch) a block or long slat of wood, perforated for the passage of the crowfoot, or cords by which an awning is held up, also EUPHROE [n -S]\n",
  "UPHROES": "UPHROE, (Dutch) a block or long slat of wood, perforated for the passage of the crowfoot, or cords by which an awning is held up, also EUPHROE [n]\n",
  "UPHUDDEN": "UPHAUD, (Scots) to maintain, warrant [v]\n",
  "UPHUNG": "UPHANG, to hang up [v]\n",
  "UPHURL": "to hurl up [v -ED, -ING, -S]\n",
  "UPHURLED": "UPHURL, to hurl up [v]\n",
  "UPHURLING": "UPHURL, to hurl up [v]\n",
  "UPHURLS": "UPHURL, to hurl up [v]\n",
  "UPJET": "to spout up [v UPJETTED, UPJETTING, UPJETS]\n",
  "UPJETS": "UPJET, to spout up [v]\n",
  "UPJETTED": "UPJET, to spout up [v]\n",
  "UPJETTING": "UPJET, to spout up [v]\n",
  "UPKEEP": "the cost of maintaining something in good condition [n -S]\n",
  "UPKEEPS": "UPKEEP, the cost of maintaining something in good condition [n]\n",
  "UPKNIT": "to reconcile [v UPKNITTED, UPKNITTING, UPKNITS]\n",
  "UPKNITS": "UPKNIT, to reconcile [v]\n",
  "UPKNITTED": "UPKNIT, to reconcile [v]\n",
  "UPKNITTING": "UPKNIT, to reconcile [v]\n",
  "UPLAID": "UPLAY, to hoard [v]\n",
  "UPLAND": "the higher land of a region [n -S]\n",
  "UPLANDER": "an inhabitant of an upland [n -S]\n",
  "UPLANDERS": "UPLANDER, an inhabitant of an upland [n]\n",
  "UPLANDISH": "(obsolete) rustic, rural [adj]\n",
  "UPLANDS": "UPLAND, the higher land of a region [n]\n",
  "UPLAY": "to hoard [v UPLAID, UPLAYING, UPLAYS]\n",
  "UPLAYING": "UPLAY, to hoard [v]\n",
  "UPLAYS": "UPLAY, to hoard [v]\n",
  "UPLEAD": "to lead up [v UPLED, UPLEADING, UPLEADS]\n",
  "UPLEADING": "UPLEAD, to lead up [v]\n",
  "UPLEADS": "UPLEAD, to lead up [v]\n",
  "UPLEAN": "to rest one's weight [v UPLEANED, UPLEANT, UPLEANING, UPLEANS]\n",
  "UPLEANED": "UPLEAN, to rest one's weight [v]\n",
  "UPLEANING": "UPLEAN, to rest one's weight [v]\n",
  "UPLEANS": "UPLEAN, to rest one's weight [v]\n",
  "UPLEANT": "UPLEAN, to rest one's weight [v]\n",
  "UPLEAP": "to leap up [v UPLEAPED, UPLEAPT, UPLEAPING, UPLEAPS]\n",
  "UPLEAPED": "UPLEAP, to leap up [v]\n",
  "UPLEAPING": "UPLEAP, to leap up [v]\n",
  "UPLEAPS": "UPLEAP, to leap up [v]\n",
  "UPLEAPT": "UPLEAP, to leap up [v]\n",
  "UPLED": "UPLEAD, to lead up [v]\n",
  "UPLIFT": "to lift up [v -ED, -ING, -S]\n",
  "UPLIFTED": "UPLIFT, to lift up [v]\n",
  "UPLIFTER": "one who uplifts [n -S]\n",
  "UPLIFTERS": "UPLIFTER, one who uplifts [n]\n",
  "UPLIFTING": "inspiring [adj UPLIFTINGLY] / the act of uplifting [n -S]\n",
  "UPLIFTINGLY": "UPLIFTING, inspiring [adv]\n",
  "UPLIFTINGS": "UPLIFTING, the act of uplifting [n]\n",
  "UPLIFTS": "UPLIFT, to lift up [v]\n",
  "UPLIGHT": "to light to a higher brightness [v UPLIGHTED, UPLIT, UPLIGHTING, UPLIGHTS]\n",
  "UPLIGHTED": "UPLIGHT, to light to a higher brightness [v]\n",
  "UPLIGHTER": "a light-fitting that throws light upwards [n -S]\n",
  "UPLIGHTERS": "UPLIGHTER, a light-fitting that throws light upwards [n]\n",
  "UPLIGHTING": "lighting to a higher degree [n -S]\n",
  "UPLIGHTINGS": "UPLIGHTING, lighting to a higher degree [n]\n",
  "UPLIGHTS": "UPLIGHT, to light to a higher brightness [v]\n",
  "UPLINK": "a communications channel to a spacecraft [n -S] / to send by uplink [v -ED, -ING, -S]\n",
  "UPLINKED": "UPLINK, to send by uplink [v]\n",
  "UPLINKING": "the act of transmitting by uplink [n -S]\n",
  "UPLINKINGS": "UPLINKING, the act of transmitting by uplink [n]\n",
  "UPLINKS": "UPLINK, a communications channel to a spacecraft [n]\n",
  "UPLIT": "UPLIGHT, to light to a higher brightness [v]\n",
  "UPLOAD": "to transfer information to a larger computer [v -ED, -ING, -S]\n",
  "UPLOADED": "UPLOAD, to transfer information to a larger computer [v]\n",
  "UPLOADING": "UPLOAD, to transfer information to a larger computer [v]\n",
  "UPLOADS": "UPLOAD, to transfer information to a larger computer [v]\n",
  "UPLOCK": "to lock up [v -ED, -ING, -S]\n",
  "UPLOCKED": "UPLOCK, to lock up [v]\n",
  "UPLOCKING": "UPLOCK, to lock up [v]\n",
  "UPLOCKS": "UPLOCK, to lock up [v]\n",
  "UPLOOK": "to look up [v -ED, -ING, -S]\n",
  "UPLOOKED": "UPLOOK, to look up [v]\n",
  "UPLOOKING": "UPLOOK, to look up [v]\n",
  "UPLOOKS": "UPLOOK, to look up [v]\n",
  "UPLYING": "pertaining to upland, elevated [adj]\n",
  "UPMADE": "UPMAKE, to arrange galley proofs in page mode [v]\n",
  "UPMAKE": "to arrange galley proofs in page mode [v UPMADE, UPMAKING, UPMAKES]\n",
  "UPMAKER": "one who makes up galley proofs arranged in page mode [n -S]\n",
  "UPMAKERS": "UPMAKER, one who makes up galley proofs arranged in page mode [n]\n",
  "UPMAKES": "UPMAKE [n]\n",
  "UPMAKING": "the process of making up galley proofs arranged in page mode [n -S]\n",
  "UPMAKINGS": "UPMAKING, the process of making up galley proofs arranged in page mode [n]\n",
  "UPMANSHIP": "the art of gaining some kind of advantage over others [n -S]\n",
  "UPMANSHIPS": "UPMANSHIP, the art of gaining some kind of advantage over others [n]\n",
  "UPMARKET": "to make more upmarket, higher in price or quality [v -ED, -ING, -S]\n",
  "UPMARKETED": "UPMARKET, to make more upmarket, higher in price or quality [v]\n",
  "UPMARKETING": "UPMARKET, to make more upmarket, higher in price or quality [v]\n",
  "UPMARKETS": "UPMARKET, to make more upmarket, higher in price or quality [v]\n",
  "UPMOST": "highest, also UPPERMOST [adj]\n",
  "UPO": "upon [prep]\n",
  "UPON": "on [prep]\n",
  "UPPED": "UP, to raise [v]\n",
  "UPPER": "the part of a boot or shoe above the sole [n -S]\n",
  "UPPERCASE": "in capitals [n -S] / to convert to uppercase [v UPPERCASED, UPPERCASING, UPPERCASES]\n",
  "UPPERCASED": "UPPERCASE, to convert to uppercase [v]\n",
  "UPPERCASES": "UPPERCASE, to convert to uppercase [v]\n",
  "UPPERCASING": "UPPERCASE, to convert to uppercase [v]\n",
  "UPPERCLASSMAN": "a member of the junior or senior class in a school or college [n UPPERCLASSMEN]\n",
  "UPPERCLASSMEN": "UPPERCLASSMAN, a member of the junior or senior class in a school or college [n]\n",
  "UPPERCUT": "to strike an upward blow [v UPPERCUT, UPPERCUTTING, UPPERCUTS]\n",
  "UPPERCUTS": "UPPERCUT, to strike an upward blow [v]\n",
  "UPPERCUTTING": "UPPERCUT, to strike an upward blow [v]\n",
  "UPPERMOST": "in the top position, also UPMOST [adj]\n",
  "UPPERPART": "the upper part of something [n -S]\n",
  "UPPERPARTS": "UPPERPART, the upper part of something [n]\n",
  "UPPERS": "UPPER, the part of a boot or shoe above the sole [n]\n",
  "UPPERWORKS": "the upper part of a structure (of a ship above the load-line) [n]\n",
  "UPPILE": "to pile up [v UPPILED, UPPILING, UPPILES]\n",
  "UPPILED": "UPPILE, to pile up [v]\n",
  "UPPILES": "UPPILE, to pile up [v]\n",
  "UPPILING": "UPPILE, to pile up [v]\n",
  "UPPING": "the process of marking young swans for identification purposes [n -S]\n",
  "UPPINGS": "UPPING, the process of marking young swans for identification purposes [n]\n",
  "UPPISH": "putting on airs of superiority [adj UPPISHLY]\n",
  "UPPISHLY": "UPPISH, putting on airs of superiority [adv]\n",
  "UPPISHNESS": "the state of being uppish [n -ES]\n",
  "UPPISHNESSES": "UPPISHNESS, the state of being uppish [n]\n",
  "UPPITIER": "UPPITY, conceited, haughty [adj]\n",
  "UPPITIEST": "UPPITY, conceited, haughty [adj]\n",
  "UPPITINESS": "the state of being uppity, also UPPITYNESS [n -ES]\n",
  "UPPITINESSES": "UPPITINESS, the state of being uppity, also UPPITYNESS [n]\n",
  "UPPITY": "conceited, haughty [adj UPPITIER, UPPITIEST]\n",
  "UPPITYNESS": "the state of being uppity, also UPPITINESS [n -ES]\n",
  "UPPITYNESSES": "UPPITYNESS, the state of being uppity, also UPPITINESS [n]\n",
  "UPPROP": "to prop up [v UPPROPPED, UPPROPPING, UPPROPS]\n",
  "UPPROPPED": "UPPROP, to prop up [v]\n",
  "UPPROPPING": "UPPROP, to prop up [v]\n",
  "UPPROPS": "UPPROP, to prop up [v]\n",
  "UPRAISE": "to raise up [v UPRAISED, UPRAISING, UPRAISES]\n",
  "UPRAISED": "UPRAISE, to raise up [v]\n",
  "UPRAISER": "one who upraises [n -S]\n",
  "UPRAISERS": "UPRAISER, one who upraises [n]\n",
  "UPRAISES": "UPRAISE, to raise up [v]\n",
  "UPRAISING": "UPRAISE, to raise up [v]\n",
  "UPRAN": "UPRUN, to run up [v]\n",
  "UPRATE": "to improve the power output of an engine [v UPRATED, UPRATING, UPRATES]\n",
  "UPRATED": "UPRATE, to improve the power output of an engine [v]\n",
  "UPRATES": "UPRATE, to improve the power output of an engine [v]\n",
  "UPRATING": "UPRATE, to improve the power output of an engine [v]\n",
  "UPREACH": "to reach up [v -ED, -ING, -ES]\n",
  "UPREACHED": "UPREACH, to reach up [v]\n",
  "UPREACHES": "UPREACH, to reach up [v]\n",
  "UPREACHING": "UPREACH, to reach up [v]\n",
  "UPREAR": "to raise; to erect [v -ED, -ING, -S]\n",
  "UPREARED": "UPREAR, to raise; to erect [v]\n",
  "UPREARING": "UPREAR, to raise; to erect [v]\n",
  "UPREARS": "UPREAR, to raise; to erect [v]\n",
  "UPREST": "(Shelley) a rising, also UPRISING, UPRIST [n -S]\n",
  "UPRESTS": "UPREST, (Shelley) a rising, also UPRISING, UPRIST [n]\n",
  "UPRIGHT": "vertical [adj UPRIGHTLY] / to raise or restore to an upright position [v -ED, -ING, -S]\n",
  "UPRIGHTED": "UPRIGHT, to raise or restore to an upright position [v]\n",
  "UPRIGHTEOUSLY": "(Shakespeare) with moral right [adv]\n",
  "UPRIGHTING": "UPRIGHT, to raise or restore to an upright position [v]\n",
  "UPRIGHTLY": "UPRIGHT, vertical [adv]\n",
  "UPRIGHTNESS": "the state of being upright [n -ES]\n",
  "UPRIGHTNESSES": "UPRIGHTNESS, the state of being upright [n]\n",
  "UPRIGHTS": "UPRIGHT, to raise or restore to an upright position [v]\n",
  "UPRISAL": "the act of uprising [n -S]\n",
  "UPRISALS": "UPRISAL, the act of uprising [n]\n",
  "UPRISE": "to rise up [v UPROSE, UPRISEN, UPRISING, UPRISES]\n",
  "UPRISEN": "UPRISE, to rise up [v]\n",
  "UPRISER": "one who rises up [n -S]\n",
  "UPRISERS": "UPRISER, one who rises up [n]\n",
  "UPRISES": "UPRISE, to rise up [v]\n",
  "UPRISING": "a revolt, an UPREST, UPRIST [n -S]\n",
  "UPRISINGS": "UPRISING, a revolt, an UPREST, UPRIST [n]\n",
  "UPRIST": "a revolt, also UPREST, UPRISING [n -S]\n",
  "UPRISTS": "UPRIST, a revolt, also UPREST, UPRISING [n]\n",
  "UPRIVER": "an area lying toward the source of a river [n -S]\n",
  "UPRIVERS": "UPRIVER, an area lying toward the source of a river [n]\n",
  "UPROAR": "a tumult, a commotion [n -S] / (Shakespeare) to throw into uproar or confusion [v -ED, -ING, -S]\n",
  "UPROARED": "UPROAR, (Shakespeare) to throw into uproar or confusion [v]\n",
  "UPROARING": "UPROAR, (Shakespeare) to throw into uproar or confusion [v]\n",
  "UPROARIOUS": "marked by uproar [adj UPROARIOUSLY]\n",
  "UPROARIOUSLY": "UPROARIOUS, marked by uproar [adv]\n",
  "UPROARIOUSNESS": "the state of being uproarious [n]\n",
  "UPROARS": "UPROAR, (Shakespeare) to throw into uproar or confusion [v]\n",
  "UPROLL": "to roll upward [v -ED, -ING, -S]\n",
  "UPROLLED": "UPROLL, to roll upward [v]\n",
  "UPROLLING": "UPROLL, to roll upward [v]\n",
  "UPROLLS": "UPROLL, to roll upward [v]\n",
  "UPROOT": "to pull up by the roots [v -ED, -ING, -S]\n",
  "UPROOTAL": "the act of uprooting [n -S]\n",
  "UPROOTALS": "UPROOTAL, the act of uprooting [n]\n",
  "UPROOTED": "UPROOT, to pull up by the roots [v]\n",
  "UPROOTEDNESS": "the state of being uprooted [n -ES]\n",
  "UPROOTEDNESSES": "UPROOTEDNESS, the state of being uprooted [n]\n",
  "UPROOTER": "one who uproots [n -S]\n",
  "UPROOTERS": "UPROOTER, one who uproots [n]\n",
  "UPROOTING": "the act of uprooting [n -S]\n",
  "UPROOTINGS": "UPROOTING, the act of uprooting [n]\n",
  "UPROOTS": "UPROOT, to pull up by the roots [v]\n",
  "UPROSE": "UPRISE, to rise up [v]\n",
  "UPROUSE": "to rouse up [v UPROUSED, UPROUSING, UPROUSES]\n",
  "UPROUSED": "UPROUSE, to rouse up [v]\n",
  "UPROUSES": "UPROUSE, to rouse up [v]\n",
  "UPROUSING": "UPROUSE, to rouse up [v]\n",
  "UPRUN": "to run up [v UPRAN, UPRUN, UPRUNNING, UPRUNS]\n",
  "UPRUNNING": "UPRUN, to run up [v]\n",
  "UPRUNS": "UPRUN, to run up [v]\n",
  "UPRUSH": "to rush up [v -ED, -ING, -ES]\n",
  "UPRUSHED": "UPRUSH, to rush up [v]\n",
  "UPRUSHES": "UPRUSH, to rush up [v]\n",
  "UPRUSHING": "UPRUSH, to rush up [v]\n",
  "UPRYST": "(Spenser) rises up [v]\n",
  "UPS": "UP, to raise [v]\n",
  "UPSADAISY": "an expression of reassurance to someone who has fallen over, also UPADAISY [interj]\n",
  "UPSCALE": "to appeal to wealthy customers [v UPSCALED, UPSCALING, UPSCALES]\n",
  "UPSCALED": "UPSCALE, to appeal to wealthy customers [v]\n",
  "UPSCALES": "UPSCALE, to appeal to wealthy customers [v]\n",
  "UPSCALING": "UPSCALE, to appeal to wealthy customers [v]\n",
  "UPSEE": "(obsolete) a carousal, also UPSEY, UPSY [n -S]\n",
  "UPSEES": "UPSEE, (obsolete) a carousal, also UPSEY, UPSY [n]\n",
  "UPSELL": "to attempt to persuade a customer to purchase more expensive items, upgrades, or other add-ons in an attempt to make a more profitable sale [v UPSOLD, UPSELLING, UPSELLS]\n",
  "UPSELLING": "UPSELL, to attempt to persuade a customer to purchase more expensive items, upgrades, or other add-ons in an attempt to make a more profitable sale [v]\n",
  "UPSELLS": "UPSELL, to attempt to persuade a customer to purchase more expensive items, upgrades, or other add-ons in an attempt to make a more profitable sale [v]\n",
  "UPSEND": "to send upward [v UPSENT, UPSENDING, UPSENDS]\n",
  "UPSENDING": "UPSEND, to send upward [v]\n",
  "UPSENDS": "UPSEND, to send upward [v]\n",
  "UPSENT": "UPSEND, to send upward [v]\n",
  "UPSET": "to overturn [v UPSET, UPSETTING, UPSETS]\n",
  "UPSETS": "UPSET, to overturn [v]\n",
  "UPSETTABLE": "that can be upset [adj]\n",
  "UPSETTER": "one who upsets [n -S]\n",
  "UPSETTERS": "UPSETTER, one who upsets [n]\n",
  "UPSETTING": "causing upset [adj UPSETTINGLY] / overturning, overthrow [n -S]\n",
  "UPSETTINGLY": "UPSETTING, causing upset [adv]\n",
  "UPSETTINGS": "UPSETTING, overturning, overthrow [n]\n",
  "UPSEY": "(obsolete) a carousal, also UPSEE, UPSY [n -S]\n",
  "UPSEYS": "UPSEY, (obsolete) a carousal, also UPSEE, UPSY [n]\n",
  "UPSHIFT": "to shift an automotive vehicle into a higher gear [v -ED, -ING, -S]\n",
  "UPSHIFTED": "UPSHIFT, to shift an automotive vehicle into a higher gear [v]\n",
  "UPSHIFTING": "UPSHIFT, to shift an automotive vehicle into a higher gear [v]\n",
  "UPSHIFTS": "UPSHIFT, to shift an automotive vehicle into a higher gear [v]\n",
  "UPSHOOT": "to shoot upwards [v UPSHOT, UPSHOOTING, UPSHOOTS]\n",
  "UPSHOOTING": "UPSHOOT, to shoot upwards [v]\n",
  "UPSHOOTS": "UPSHOOT, to shoot upwards [v]\n",
  "UPSHOT": "the final result [n -S]\n",
  "UPSHOTS": "UPSHOT, the final result [n]\n",
  "UPSIDE": "a positive aspect [n -S]\n",
  "UPSIDEOWNE": "(Spenser) upside down [adj]\n",
  "UPSIDES": "UPSIDE, a positive aspect [n]\n",
  "UPSIES": "UPSY, (obsolete) a carousal, also UPSEE, UPSEY [n]\n",
  "UPSILON": "(Greek) a Greek letter, also YPSILON [n -S]\n",
  "UPSILONS": "UPSILON, (Greek) a Greek letter, also YPSILON [n]\n",
  "UPSITTING": "a sitting up of a woman after her confinement, to receive and entertain her friends [n -S]\n",
  "UPSITTINGS": "UPSITTING, a sitting up of a woman after her confinement, to receive and entertain her friends [n]\n",
  "UPSIZE": "to increase in size [v UPSIZED, UPSIZING, UPSIZES]\n",
  "UPSIZED": "UPSIZE, to increase in size [v]\n",
  "UPSIZES": "UPSIZE, to increase in size [v]\n",
  "UPSIZING": "UPSIZE, to increase in size [v]\n",
  "UPSKILL": "to improve a person's skills [v -ED, -ING, -S]\n",
  "UPSKILLED": "UPSKILL, to improve a person's skills [v]\n",
  "UPSKILLING": "UPSKILL, to improve a person's skills [v]\n",
  "UPSKILLS": "UPSKILL, to improve a person's skills [v]\n",
  "UPSKIRT": "a photograph taken, usually surreptitiously, of a woman sitting or standing with her legs open in such a way that her underwear is exposed [n -S]\n",
  "UPSKIRTING": "the practice of taking photographs underneath a woman\u0012s skirt or dress without consent [n -S]\n",
  "UPSKIRTINGS": "UPSKIRTING, the practice of taking photographs underneath a woman\u0012s skirt or dress without consent [n]\n",
  "UPSKIRTS": "UPSKIRT, a photograph taken, usually surreptitiously, of a woman sitting or standing with her legs open in such a way that her underwear is exposed [n]\n",
  "UPSLOPE": "an upward slope [n -S]\n",
  "UPSLOPES": "UPSLOPE, an upward slope [n]\n",
  "UPSOAR": "to soar upward [v -ED, -ING, -S]\n",
  "UPSOARED": "UPSOAR, to soar upward [v]\n",
  "UPSOARING": "UPSOAR, to soar upward [v]\n",
  "UPSOARS": "UPSOAR, to soar upward [v]\n",
  "UPSOLD": "UPSELL, to attempt to persuade a customer to purchase more expensive items, upgrades, or other add-ons in an attempt to make a more profitable sale [v]\n",
  "UPSPAKE": "UPSPEAK, to speak up [v]\n",
  "UPSPEAK": "to speak up [v UPSPOKE or UPSPAKE, UPSPOKEN, UPSPEAKING, UPSPEAKS]\n",
  "UPSPEAKING": "UPSPEAK, to speak up [v]\n",
  "UPSPEAKS": "UPSPEAK, to speak up [v]\n",
  "UPSPEAR": "to shoot up like a spear [v -ED, -ING, -S]\n",
  "UPSPEARED": "UPSPEAR, to shoot up like a spear [v]\n",
  "UPSPEARING": "UPSPEAR, to shoot up like a spear [v]\n",
  "UPSPEARS": "UPSPEAR, to shoot up like a spear [v]\n",
  "UPSPOKE": "UPSPEAK, to speak up [v]\n",
  "UPSPOKEN": "UPSPEAK, to speak up [v]\n",
  "UPSPRANG": "UPSPRING, to spring up [v]\n",
  "UPSPRING": "to spring up [v UPSPRANG, UPSPRUNG, UPSPRINGING, UPSPRINGS]\n",
  "UPSPRINGING": "UPSPRING, to spring up [v]\n",
  "UPSPRINGS": "UPSPRING, to spring up [v]\n",
  "UPSPRUNG": "UPSPRING, to spring up [v]\n",
  "UPSTAGE": "to outdo theatrically [v UPSTAGED, UPSTAGING, UPSTAGES]\n",
  "UPSTAGED": "UPSTAGE, to outdo theatrically [v]\n",
  "UPSTAGER": "one who upstages [n -S]\n",
  "UPSTAGERS": "UPSTAGER, one who upstages [n]\n",
  "UPSTAGES": "UPSTAGE, to outdo theatrically [v]\n",
  "UPSTAGING": "UPSTAGE, to outdo theatrically [v]\n",
  "UPSTAIR": "pertaining to an upper floor [adj]\n",
  "UPSTAIRS": "up the stairs [adv] / the part of a building above the ground floor [n]\n",
  "UPSTAND": "to stand up on one's feet [v UPSTOOD, UPSTANDING, UPSTANDS]\n",
  "UPSTANDING": "UPSTAND, to stand up on one's feet [v]\n",
  "UPSTANDINGNESS": "the state of being upstanding [n]\n",
  "UPSTANDS": "UPSTAND, to stand up on one's feet [v]\n",
  "UPSTARE": "to stare upward [v UPSTARED, UPSTARING, UPSTARES]\n",
  "UPSTARED": "UPSTARE, to stare upward [v]\n",
  "UPSTARES": "UPSTARE, to stare upward [v]\n",
  "UPSTARING": "UPSTARE, to stare upward [v]\n",
  "UPSTART": "to start up suddenly [v -ED, -ING, -S]\n",
  "UPSTARTED": "UPSTART, to start up suddenly [v]\n",
  "UPSTARTING": "UPSTART, to start up suddenly [v]\n",
  "UPSTARTS": "UPSTART, to start up suddenly [v]\n",
  "UPSTATE": "the northern region of a state [n -S]\n",
  "UPSTATER": "an inhabitant of an upstate region [n -S]\n",
  "UPSTATERS": "UPSTATER, an inhabitant of an upstate region [n]\n",
  "UPSTATES": "UPSTATE, the northern region of a state [n]\n",
  "UPSTAY": "to sustain [v -ED, -ING, -S]\n",
  "UPSTAYED": "UPSTAY, to sustain [v]\n",
  "UPSTAYING": "UPSTAY, to sustain [v]\n",
  "UPSTAYS": "UPSTAY, to sustain [v]\n",
  "UPSTEP": "to step up [v UPSTEPPED, UPSTEPPING, UPSTEPS]\n",
  "UPSTEPPED": "UPSTEP, to step up [v]\n",
  "UPSTEPPING": "the act of stepping up [n -S]\n",
  "UPSTEPPINGS": "UPSTEPPING, the act of stepping up [n]\n",
  "UPSTEPS": "UPSTEP, to step up [v]\n",
  "UPSTIR": "to stir up [v UPSTIRRED, UPSTIRRING, UPSTIRS]\n",
  "UPSTIRRED": "UPSTIR, to stir up [v]\n",
  "UPSTIRRING": "UPSTIR, to stir up [v]\n",
  "UPSTIRS": "UPSTIR, to stir up [v]\n",
  "UPSTOOD": "UPSTAND, to stand up on one's feet [v]\n",
  "UPSTREAM": "to stream up [v -ED, -ING, -S]\n",
  "UPSTREAMED": "UPSTREAM, to stream up [v]\n",
  "UPSTREAMING": "UPSTREAM, to stream up [v]\n",
  "UPSTREAMS": "UPSTREAM, to stream up [v]\n",
  "UPSTRETCHED": "of the arms, raised or stretched upwards [adj]\n",
  "UPSTROKE": "an upward stroke [n -S]\n",
  "UPSTROKES": "UPSTROKE, an upward stroke [n]\n",
  "UPSURGE": "to surge up [v UPSURGED, UPSURGING, UPSURGES]\n",
  "UPSURGED": "UPSURGE, to surge up [v]\n",
  "UPSURGENCE": "the state of surging up e.g. an upsurgence of emotion [n -S]\n",
  "UPSURGENCES": "UPSURGENCE, the state of surging up e.g. an upsurgence of emotion [n]\n",
  "UPSURGES": "UPSURGE, to surge up [v]\n",
  "UPSURGING": "UPSURGE, to surge up [v]\n",
  "UPSWARM": "(archaic) to rise or send upwards in a swarm [v -ED, -ING, -S]\n",
  "UPSWARMED": "UPSWARM, (archaic) to rise or send upwards in a swarm [v]\n",
  "UPSWARMING": "UPSWARM, (archaic) to rise or send upwards in a swarm [v]\n",
  "UPSWARMS": "UPSWARM, (archaic) to rise or send upwards in a swarm [v]\n",
  "UPSWAY": "to swing up [v -ED, -ING, -S]\n",
  "UPSWAYED": "UPSWAY, to swing up [v]\n",
  "UPSWAYING": "UPSWAY, to swing up [v]\n",
  "UPSWAYS": "UPSWAY, to swing up [v]\n",
  "UPSWEEP": "to sweep upward [v UPSWEPT, UPSWEEPING, UPSWEEPS]\n",
  "UPSWEEPING": "UPSWEEP, to sweep upward [v]\n",
  "UPSWEEPS": "UPSWEEP, to sweep upward [v]\n",
  "UPSWELL": "to swell up [v -ED, -ING, -S]\n",
  "UPSWELLED": "UPSWELL, to swell up [v]\n",
  "UPSWELLING": "UPSWELL, to swell up [v]\n",
  "UPSWELLS": "UPSWELL, to swell up [v]\n",
  "UPSWEPT": "UPSWEEP, to sweep upward [v]\n",
  "UPSWING": "to swing upward [v UPSWUNG, UPSWINGING, UPSWINGS]\n",
  "UPSWINGING": "UPSWING, to swing upward [v]\n",
  "UPSWINGS": "UPSWING, to swing upward [v]\n",
  "UPSWOLLEN": "UPSWELL, to swell up [v]\n",
  "UPSWUNG": "UPSWING, to swing upward [v]\n",
  "UPSY": "(obsolete) a carousal, also UPSEE, UPSEY [n UPSIES]\n",
  "UPTA": "(Australian slang) of poor quality, also UPTER [adj]\n",
  "UPTAK": "(Scots) uptake, as in gleg in the uptak [n -S]\n",
  "UPTAKE": "to take up [v UPTOOK, UPTAKEN, UPTAKING, UPTAKES]\n",
  "UPTAKEN": "UPTAKE, to take up [v]\n",
  "UPTAKES": "UPTAKE, to take up [v]\n",
  "UPTAKING": "UPTAKE, to take up [v]\n",
  "UPTAKS": "UPTAK, (Scots) uptake, as in gleg in the uptak [n]\n",
  "UPTALK": "to end a declarative sentence with a rising intonation [v -ED, -ING, -S]\n",
  "UPTALKED": "UPTALK, to end a declarative sentence with a rising intonation [v]\n",
  "UPTALKING": "the practice of speaking with a rising intonation at the end of each statement, as if one were asking a question [n -S]\n",
  "UPTALKINGS": "UPTALKING, the practice of speaking with a rising intonation at the end of each statement, as if one were asking a question [n]\n",
  "UPTALKS": "UPTALK, to end a declarative sentence with a rising intonation [v]\n",
  "UPTEAR": "to tear out by the roots [v UPTORE, UPTORN, UPTEARING, UPTEARS]\n",
  "UPTEARING": "UPTEAR, to tear out by the roots [v]\n",
  "UPTEARS": "UPTEAR, to tear out by the roots [v]\n",
  "UPTEMPO": "a fast or lively tempo [n -S]\n",
  "UPTEMPOS": "UPTEMPO, a fast or lively tempo [n]\n",
  "UPTER": "(Australian slang) of poor quality, also UPTA [adj]\n",
  "UPTHREW": "UPTHROW, to throw upward [v]\n",
  "UPTHROW": "to throw upward [v UPTHREW, UPTHROWN, UPTHROWING, UPTHROWS]\n",
  "UPTHROWING": "UPTHROW, to throw upward [v]\n",
  "UPTHROWN": "UPTHROW, to throw upward [v]\n",
  "UPTHROWS": "UPTHROW, to throw upward [v]\n",
  "UPTHRUST": "to thrust up [v UPTHRUST or UPTHRUSTED, UPTHRUSTING, UPTHRUSTS]\n",
  "UPTHRUSTED": "UPTHRUST, to thrust up [v]\n",
  "UPTHRUSTING": "UPTHRUST, to thrust up [v]\n",
  "UPTHRUSTS": "UPTHRUST, to thrust up [v]\n",
  "UPTHUNDER": "to send up a noise like thunder [v -ED, -ING, -S]\n",
  "UPTHUNDERED": "UPTHUNDER, to send up a noise like thunder [v]\n",
  "UPTHUNDERING": "UPTHUNDER, to send up a noise like thunder [v]\n",
  "UPTHUNDERS": "UPTHUNDER, to send up a noise like thunder [v]\n",
  "UPTICK": "an increase or rise [n -S]\n",
  "UPTICKS": "UPTICK, an increase or rise [n]\n",
  "UPTIE": "to tie up [v UPTIED, UPTYING, UPTIES]\n",
  "UPTIED": "UPTIE, to tie up [v]\n",
  "UPTIES": "UPTIE, to tie up [v]\n",
  "UPTIGHT": "tense; straitlaced [adj UPTIGHTER, UPTIGHTEST]\n",
  "UPTIGHTER": "UPTIGHT, tense; straitlaced [adj]\n",
  "UPTIGHTEST": "UPTIGHT, tense; straitlaced [adj]\n",
  "UPTIGHTNESS": "the state of being uptight [n -ES]\n",
  "UPTIGHTNESSES": "UPTIGHTNESS, the state of being uptight [n]\n",
  "UPTILT": "to tilt upward [v -ED, -ING, -S]\n",
  "UPTILTED": "UPTILT, to tilt upward [v]\n",
  "UPTILTING": "UPTILT, to tilt upward [v]\n",
  "UPTILTS": "UPTILT, to tilt upward [v]\n",
  "UPTIME": "the time during which machinery is functioning [n -S]\n",
  "UPTIMES": "UPTIME, the time during which machinery is functioning [n]\n",
  "UPTITLING": "the practise of conferring grandiose titles on employees doing relatively menial jobs [n -S]\n",
  "UPTITLINGS": "UPTITLING, the practise of conferring grandiose titles on employees doing relatively menial jobs [n]\n",
  "UPTOOK": "UPTAKE, to take up [v]\n",
  "UPTORE": "UPTEAR, to tear out by the roots [v]\n",
  "UPTORN": "UPTEAR, to tear out by the roots [v]\n",
  "UPTOSS": "to toss upward [v -ED, -ING, -ES]\n",
  "UPTOSSED": "UPTOSS, to toss upward [v]\n",
  "UPTOSSES": "UPTOSS, to toss upward [v]\n",
  "UPTOSSING": "UPTOSS, to toss upward [v]\n",
  "UPTOWN": "the upper part of a city [n -S]\n",
  "UPTOWNER": "one who lives uptown [n -S]\n",
  "UPTOWNERS": "UPTOWNER, one who lives uptown [n]\n",
  "UPTOWNS": "UPTOWN, the upper part of a city [n]\n",
  "UPTRAIN": "(obsolete) to train up, educate [v -ED, -ING, -S]\n",
  "UPTRAINED": "UPTRAIN, (obsolete) to train up, educate [v]\n",
  "UPTRAINING": "UPTRAIN, (obsolete) to train up, educate [v]\n",
  "UPTRAINS": "UPTRAIN, (obsolete) to train up, educate [v]\n",
  "UPTREND": "a tendency toward growth [n -S]\n",
  "UPTRENDS": "UPTREND, a tendency toward growth [n]\n",
  "UPTRILLED": "(Coleridge) trilled high [adj]\n",
  "UPTURN": "to turn up or over [v -ED, -ING, -S]\n",
  "UPTURNED": "UPTURN, to turn up or over [v]\n",
  "UPTURNING": "the act of turning upwards [n -S]\n",
  "UPTURNINGS": "UPTURNING, the act of turning upwards [n]\n",
  "UPTURNS": "UPTURN, to turn up or over [v]\n",
  "UPTYING": "UPTIE, to tie up [v]\n",
  "UPVALUATION": "the act of upvaluing [n -S]\n",
  "UPVALUATIONS": "UPVALUATION, the act of upvaluing [n]\n",
  "UPVALUE": "to increase the value of [v UPVALUED, UPVALUING, UPVALUES]\n",
  "UPVALUED": "UPVALUE, to increase the value of [v]\n",
  "UPVALUES": "UPVALUE, to increase the value of [v]\n",
  "UPVALUING": "UPVALUE, to increase the value of [v]\n",
  "UPVOTE": "to register approval of (a post) on social media [v UPVOTED, UPVOTING, UPVOTES]\n",
  "UPVOTED": "UPVOTE, to register approval of (a post) on social media [v]\n",
  "UPVOTES": "UPVOTE, to register approval of (a post) on social media [v]\n",
  "UPVOTING": "UPVOTE, to register approval of (a post) on social media [v]\n",
  "UPWAFT": "to waft upward [v -ED, -ING, -S]\n",
  "UPWAFTED": "UPWAFT, to waft upward [v]\n",
  "UPWAFTING": "UPWAFT, to waft upward [v]\n",
  "UPWAFTS": "UPWAFT, to waft upward [v]\n",
  "UPWARD": "toward a higher place or position, also UPWARDS [adj]\n",
  "UPWARDLY": "UPWARD, toward a higher place or position, also UPWARDS [adv]\n",
  "UPWARDNESS": "the state of being upward [n -ES]\n",
  "UPWARDNESSES": "UPWARDNESS, the state of being upward [n]\n",
  "UPWARDS": "in an upward direction, also UPWARD [adv]\n",
  "UPWELL": "to well up [v -ED, -ING, -S]\n",
  "UPWELLED": "UPWELL, to well up [v]\n",
  "UPWELLING": "a welling up; the rising to the surface of nutriment-bearing water from the depths of the ocean [n -S]\n",
  "UPWELLINGS": "UPWELLING, a welling up; the rising to the surface of nutriment-bearing water from the depths of the ocean [n]\n",
  "UPWELLS": "UPWELL, to well up [v]\n",
  "UPWENT": "UPGO, to go up [v]\n",
  "UPWHIRL": "to whirl up [v -ED, -ING, -S]\n",
  "UPWHIRLED": "UPWHIRL, to whirl up [v]\n",
  "UPWHIRLING": "UPWHIRL, to whirl up [v]\n",
  "UPWHIRLS": "UPWHIRL, to whirl up [v]\n",
  "UPWIND": "to wind up [v UPWOUND, UPWINDING, UPWINDS]\n",
  "UPWINDING": "UPWIND, to wind up [v]\n",
  "UPWINDS": "UPWIND, to wind up [v]\n",
  "UPWOUND": "UPWIND, to wind up [v]\n",
  "UPWRAP": "an anticline [n -S]\n",
  "UPWRAPS": "UPWRAP, an anticline [n]\n",
  "UPWROUGHT": "wrought up [adj]\n",
  "UR": "expressing hesitation [interj]\n",
  "URACHI": "URACHUS, (Greek) a cord or band of fibrous tissue extending from the bladder to the umbilicus [n]\n",
  "URACHUS": "(Greek) a cord or band of fibrous tissue extending from the bladder to the umbilicus [n URACHUSES or URACHI]\n",
  "URACHUSES": "URACHUS, (Greek) a cord or band of fibrous tissue extending from the bladder to the umbilicus [n]\n",
  "URACIL": "a form of pyrimidine present in living tissue as a base of RNA [n -S]\n",
  "URACILS": "URACIL, a form of pyrimidine present in living tissue as a base of RNA [n]\n",
  "URAEI": "URAEUS, (Greek) an Egyptian symbol of kingship, a rearing cobra worn on the king's forehead or crown [n]\n",
  "URAEMIA": "the retention of waste materials normally excreted, also UREMIA, URINEMIA [n -S]\n",
  "URAEMIAS": "URAEMIA, the retention of waste materials normally excreted, also UREMIA, URINEMIA [n]\n",
  "URAEMIC": "relating to uraemia, retention of waste materials normally excreted, also UREMIC [adj]\n",
  "URAEUS": "(Greek) an Egyptian symbol of kingship, a rearing cobra worn on the king's forehead or crown [n URAEI or URAEUSES]\n",
  "URAEUSES": "URAEUS, (Greek) an Egyptian symbol of kingship, a rearing cobra worn on the king's forehead or crown [n]\n",
  "URALI": "(Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n -S]\n",
  "URALIS": "URALI, (Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URARI, WOORALI, WOORARA, WOORARI, WOURALI [n]\n",
  "URALITE": "an altered mineral, hornblende after augite [n -S]\n",
  "URALITES": "URALITE, an altered mineral, hornblende after augite [n]\n",
  "URALITIC": "pertaining to uralite, a hornblende mineral [adj]\n",
  "URALITISATION": "the process of uralitising, also URALITIZATION [n -S]\n",
  "URALITISATIONS": "URALITISATION, the process of uralitising, also URALITIZATION [n]\n",
  "URALITISE": "to turn into uralite, also URALITIZE [v URALITISED, URALITISING, URALITISES]\n",
  "URALITISED": "URALITISE, to turn into uralite, also URALITIZE [v]\n",
  "URALITISES": "URALITISE, to turn into uralite, also URALITIZE [v]\n",
  "URALITISING": "URALITISE, to turn into uralite, also URALITIZE [v]\n",
  "URALITIZATION": "the process of uralitizing, also URALITISATION [n -S]\n",
  "URALITIZATIONS": "URALITIZATION, the process of uralitizing, also URALITISATION [n]\n",
  "URALITIZE": "to turn into uralite, also URALITISE [v URALITIZED, URALITIZING, URALITIZES]\n",
  "URALITIZED": "URALITIZE, to turn into uralite, also URALITISE [v]\n",
  "URALITIZES": "URALITIZE, to turn into uralite, also URALITISE [v]\n",
  "URALITIZING": "URALITIZE, to turn into uralite, also URALITISE [v]\n",
  "URANALYSES": "URANALYSIS, analysis of urine e.g. to detect disease, also URINALYSIS [n]\n",
  "URANALYSIS": "analysis of urine e.g. to detect disease, also URINALYSIS [n URANALYSES]\n",
  "URANIA": "uranium dioxide [n -S]\n",
  "URANIAN": "heavenly; of the heavens [adj]\n",
  "URANIAS": "URANIA, uranium dioxide [n]\n",
  "URANIC": "of uranium in higher valency [adj]\n",
  "URANIDE": "a radioactive element, also URANIUM [n -S]\n",
  "URANIDES": "URANIDE, a radioactive element, also URANIUM [n]\n",
  "URANIN": "an alkaline salt of fluorescein, obtained as a brownish red substance, used as a dye [n -S]\n",
  "URANINITE": "uranium dioxide, the major ore of uranium, found most frequently in botryoidal form as pitchblende [n -S]\n",
  "URANINITES": "URANINITE, uranium dioxide, the major ore of uranium, found most frequently in botryoidal form as pitchblende [n]\n",
  "URANINS": "URANIN, an alkaline salt of fluorescein, obtained as a brownish red substance, used as a dye [n]\n",
  "URANISCI": "URANISCUS, (Greek) the roof of the mouth [n]\n",
  "URANISCUS": "(Greek) the roof of the mouth [n URANISCI]\n",
  "URANISM": "male homosexuality [n -S]\n",
  "URANISMS": "URANISM, male homosexuality [n]\n",
  "URANITE": "a mineral, aka autunite or torbernite [n -S]\n",
  "URANITES": "URANITE, a mineral, aka autunite or torbernite [n]\n",
  "URANITIC": "of or pertaining to the mineral uranite [adj]\n",
  "URANIUM": "a radioactive element, also URANIDE [n -S]\n",
  "URANIUMS": "URANIUM, a radioactive element, also URANIDE [n]\n",
  "URANOGRAPHER": "one who maps the constellations [n -S]\n",
  "URANOGRAPHERS": "URANOGRAPHER, one who maps the constellations [n]\n",
  "URANOGRAPHIC": "relating to uranography, descriptive astronomy and mapping, also URANOGRAPHICAL [adj]\n",
  "URANOGRAPHICAL": "relating to uranography, descriptive astronomy and mapping, also URANOGRAPHIC [adj]\n",
  "URANOGRAPHIES": "URANOGRAPHY, descriptive astronomy and mapping [n]\n",
  "URANOGRAPHIST": "one who practises uranography, descriptive astronomy and mapping [n -S]\n",
  "URANOGRAPHISTS": "URANOGRAPHIST, one who practises uranography, descriptive astronomy and mapping [n]\n",
  "URANOGRAPHY": "descriptive astronomy and mapping [n URANOGRAPHIES]\n",
  "URANOLOGIES": "URANOLOGY, the study of the heavens [n]\n",
  "URANOLOGY": "the study of the heavens [n URANOLOGIES]\n",
  "URANOMETRIES": "URANOMETRY, a chart or catalogue of fixed stars, esp. of stars visible to the naked eye [n]\n",
  "URANOMETRY": "a chart or catalogue of fixed stars, esp. of stars visible to the naked eye [n URANOMETRIES]\n",
  "URANOPLASTIES": "URANOPLASTY, plastic surgery of the palate [n]\n",
  "URANOPLASTY": "plastic surgery of the palate [n URANOPLASTIES]\n",
  "URANOUS": "of uranium in lower valency [adj]\n",
  "URANYL": "the radical UO2, present in some compounds of uranium [n -S]\n",
  "URANYLIC": "relating to uranyl, uranium oxide [adj]\n",
  "URANYLS": "URANYL, the radical UO2, present in some compounds of uranium [n]\n",
  "URAO": "(Spanish) a salt of sodium carbonate and sodium bicarbonate, aka trona, occurring esp. as an evaporite [n -S]\n",
  "URAOS": "URAO, (Spanish) a salt of sodium carbonate and sodium bicarbonate, aka trona, occurring esp. as an evaporite [n]\n",
  "URARE": "(Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARA, CURARE, CURARI [n -S]\n",
  "URARES": "URARE, (Caribbean) a paralysing poison extracted from the bark of certain South American trees, also CURARA, CURARE, CURARI [n]\n",
  "URARI": "(Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, WOORALI, WOORARA, WOORARI, WOURALI [n -S]\n",
  "URARIS": "URARI, (Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, WOORALI, WOORARA, WOORARI, WOURALI [n]\n",
  "URASE": "an enzyme that converts urea to a salt, also UREASE [n -S]\n",
  "URASES": "URASE, an enzyme that converts urea to a salt, also UREASE [n]\n",
  "URATE": "a salt of uric acid, found in e.g. bird droppings [n -S]\n",
  "URATES": "URATE, a salt of uric acid, found in e.g. bird droppings [n]\n",
  "URATIC": "of or containing urates; as, uratic calculi [adj]\n",
  "URB": "an urban area [n -S]\n",
  "URBAN": "pertaining to a city [adj]\n",
  "URBANE": "refined and elegant [adj URBANER, URBANEST, URBANELY]\n",
  "URBANELY": "URBANE, refined and elegant [adv]\n",
  "URBANENESS": "the state of being urbane [n -ES]\n",
  "URBANENESSES": "URBANENESS, the state of being urbane [n]\n",
  "URBANER": "URBANE, refined and elegant [adj]\n",
  "URBANEST": "URBANE, refined and elegant [adj]\n",
  "URBANISATION": "an increase of people moving to urban areas, also URBANIZATION [n -S]\n",
  "URBANISATIONS": "URBANISATION, an increase of people moving to urban areas, also URBANIZATION [n]\n",
  "URBANISE": "to cause to take on urban characteristics, also URBANIZE [v URBANISED, URBANISING, URBANISES]\n",
  "URBANISED": "URBANISE, to cause to take on urban characteristics, also URBANIZE [v]\n",
  "URBANISES": "URBANISE, to cause to take on urban characteristics, also URBANIZE [v]\n",
  "URBANISING": "URBANISE, to cause to take on urban characteristics, also URBANIZE [v]\n",
  "URBANISM": "the lifestyle of city dwellers [n -S]\n",
  "URBANISMS": "URBANISM, the lifestyle of city dwellers [n]\n",
  "URBANIST": "a specialist in city planning [n -S]\n",
  "URBANISTIC": "relating to the planning and development of towns [adj URBANISTICALLY]\n",
  "URBANISTICALLY": "URBANISTIC, relating to the planning and development of towns [adv]\n",
  "URBANISTS": "URBANIST, a specialist in city planning [n]\n",
  "URBANITE": "one who lives in a city [n -S]\n",
  "URBANITES": "URBANITE, one who lives in a city [n]\n",
  "URBANITIES": "URBANITY, the quality of being urban [n]\n",
  "URBANITY": "the quality of being urban [n URBANITIES]\n",
  "URBANIZATION": "an increase of people moving to urban areas, also URBANISATION [n -S]\n",
  "URBANIZATIONS": "URBANIZATION, an increase of people moving to urban areas, also URBANISATION [n]\n",
  "URBANIZE": "to cause to take on urban characteristics, also URBANISE [v URBANIZED, URBANIZING, URBANIZES]\n",
  "URBANIZED": "URBANIZE, to cause to take on urban characteristics, also URBANISE [v]\n",
  "URBANIZES": "URBANIZE, to cause to take on urban characteristics, also URBANISE [v]\n",
  "URBANIZING": "URBANIZE, to cause to take on urban characteristics, also URBANISE [v]\n",
  "URBANOLOGIES": "URBANOLOGY, the study of cities [n]\n",
  "URBANOLOGIST": "one who studies towns [n -S]\n",
  "URBANOLOGISTS": "URBANOLOGIST, one who studies towns [n]\n",
  "URBANOLOGY": "the study of cities [n URBANOLOGIES]\n",
  "URBEX": "(short for) urban exploration, a recreational activity in which people explore derelict urban structures such as abandoned sewers or underground railways [n -ES]\n",
  "URBEXES": "URBEX, (short for) urban exploration, a recreational activity in which people explore derelict urban structures such as abandoned sewers or underground railways [n]\n",
  "URBIA": "(Latin) cities collectively [n -S]\n",
  "URBIAS": "URBIA, (Latin) cities collectively [n]\n",
  "URBS": "URB, an urban area [n]\n",
  "URCEOLATE": "shaped like a pitcher [adj]\n",
  "URCEOLI": "URCEOLUS, (Latin) a pitcher-shaped structure, as the tube in which some rotifers live [n]\n",
  "URCEOLUS": "(Latin) a pitcher-shaped structure, as the tube in which some rotifers live [n URCEOLUSES or URCEOLI]\n",
  "URCEOLUSES": "URCEOLUS, (Latin) a pitcher-shaped structure, as the tube in which some rotifers live [n]\n",
  "URCHIN": "a mischievous boy [n -S]\n",
  "URCHINS": "URCHIN, a mischievous boy [n]\n",
  "URD": "an annual bean grown in India [n -S]\n",
  "URDE": "in heraldry, pointed, with a pattern of points, also URDEE, URDY [adj]\n",
  "URDEE": "in heraldry, pointed, with a pattern of points, also URDE, URDY [adj]\n",
  "URDS": "URD, an annual bean grown in India [n]\n",
  "URDY": "in heraldry, pointed, with a pattern of points, also URDE, URDEE [adj]\n",
  "URE": "(obsolete) an extinct wild ox [n -S]\n",
  "UREA": "a substance found in mammalian urine, the chief form in which nitrogenous waste is excreted [n -S]\n",
  "UREAL": "relating to urea, also UREIC [adj]\n",
  "UREAS": "UREA, a substance found in mammalian urine, the chief form in which nitrogenous waste is excreted [n]\n",
  "UREASE": "an enzyme that converts urea to a salt, also URASE [n -S]\n",
  "UREASES": "UREASE, an enzyme that converts urea to a salt, also URASE [n]\n",
  "UREDIA": "UREDIUM, a spore-producing organ of certain fungi, also UREDINIUM [n]\n",
  "UREDIAL": "relating to an uredium, a pustule producing and containing uredospores [adj]\n",
  "UREDINE": "relating to uredo, a rust in plants [adj]\n",
  "UREDINES": "UREDO, (Latin) rust in plants [n]\n",
  "UREDINIA": "UREDINIUM, a uredosorus, a sorus or pustule in which urediniospores are formed, also UREDIUM [n]\n",
  "UREDINIAL": "of or like uredines, rust-fungi [adj]\n",
  "UREDINIOSPORE": "the thin-walled summer spore which is produced during the so-called Uredo stage of certain rusts, also UREDIOSPORE, UREDOSPORE [n -S]\n",
  "UREDINIOSPORES": "UREDINIOSPORE, the thin-walled summer spore which is produced during the so-called Uredo stage of certain rusts, also UREDIOSPORE, UREDOSPORE [n]\n",
  "UREDINIUM": "a uredosorus, a sorus or pustule in which urediniospores are formed, also UREDIUM [n UREDINIA or UREDINIUMS]\n",
  "UREDINIUMS": "UREDINIUM, a uredosorus, a sorus or pustule in which urediniospores are formed, also UREDIUM [n]\n",
  "UREDINOUS": "containing uredines, rust spores [adj]\n",
  "UREDIOSPORE": "the thin-walled summer spore which is produced during the so-called Uredo stage of certain rusts, also UREDINIOSPORE, UREDOSPORE [n -S]\n",
  "UREDIOSPORES": "UREDIOSPORE, the thin-walled summer spore which is produced during the so-called Uredo stage of certain rusts, also UREDINIOSPORE, UREDOSPORE [n]\n",
  "UREDIUM": "a spore-producing organ of certain fungi, also UREDINIUM [n UREDIA]\n",
  "UREDO": "(Latin) rust in plants [n UREDOS or UREDINES]\n",
  "UREDOS": "UREDO, (Latin) rust in plants [n]\n",
  "UREDOSORI": "UREDOSORUS, a pustule producing and containing uredospores [n]\n",
  "UREDOSORUS": "a pustule producing and containing uredospores [n UREDOSORI]\n",
  "UREDOSPORE": "the thin-walled summer spore which is produced during the so-called Uredo stage of certain rusts, also UREDINIOSPORE, UREDIOSPORE [n -S]\n",
  "UREDOSPORES": "UREDOSPORE, the thin-walled summer spore which is produced during the so-called Uredo stage of certain rusts, also UREDINIOSPORE, UREDIOSPORE [n]\n",
  "UREIC": "relating to urea, also UREAL [adj]\n",
  "UREIDE": "any one of the many complex derivatives of urea [n -S]\n",
  "UREIDES": "UREIDE, any one of the many complex derivatives of urea [n]\n",
  "UREMIA": "the retention of waste materials normally excreted, also URAEMIA, URINEMIA [n -S]\n",
  "UREMIAS": "UREMIA, the retention of waste materials normally excreted, also URAEMIA, URINEMIA [n]\n",
  "UREMIC": "relating to uremia, retention of waste materials normally excreted, also URAEMIC [adj]\n",
  "URENA": "(Malay) any plant of the tropical genus Urena of the marrow family [n -S]\n",
  "URENAS": "URENA, (Malay) any plant of the tropical genus Urena of the marrow family [n]\n",
  "URENT": "burning [adj]\n",
  "UREOTELIC": "eliminating unneeded nitrogen in the form of urea [adj]\n",
  "UREOTELISM": "the state of being ureotelic, excreting nitrogen in the form of urea [n -S]\n",
  "UREOTELISMS": "UREOTELISM, the state of being ureotelic, excreting nitrogen in the form of urea [n]\n",
  "URES": "URE, (obsolete) an extinct wild ox [n]\n",
  "URESES": "URESIS, (Greek) urination [n]\n",
  "URESIS": "(Greek) urination [n URESES]\n",
  "URETER": "(Greek) a duct that conveys urine from the kidney to the bladder [n -S]\n",
  "URETERAL": "relating to the ureter, a tube from kidney to bladder, also URETERIC [adj]\n",
  "URETERIC": "relating to the ureter, a tube from kidney to bladder, also URETERAL [adj]\n",
  "URETERITIS": "inflammation of the ureter [n -ES]\n",
  "URETERITISES": "URETERITIS, inflammation of the ureter [n]\n",
  "URETERS": "URETER, (Greek) a duct that conveys urine from the kidney to the bladder [n]\n",
  "URETHAN": "a crystalline ether, used as an anaesthetic and pesticide, also URETHANE [n -S]\n",
  "URETHANE": "a crystalline ether, used as an anaesthetic and pesticide, also URETHAN [n -S] / to coat with urethane [v URETHANED, URETHANING, URETHANES]\n",
  "URETHANED": "URETHANE, to coat with urethane [v]\n",
  "URETHANES": "URETHANE, to coat with urethane [v]\n",
  "URETHANING": "URETHANE, to coat with urethane [v]\n",
  "URETHANS": "URETHAN, a crystalline ether, used as an anaesthetic and pesticide, also URETHANE [n]\n",
  "URETHRA": "(Greek) the duct through which urine is discharged from the bladder [n URETHRAS or URETHRAE]\n",
  "URETHRAE": "URETHRA, (Greek) the duct through which urine is discharged from the bladder [n]\n",
  "URETHRAL": "pertaining to the urethra [adj]\n",
  "URETHRAS": "URETHRA, (Greek) the duct through which urine is discharged from the bladder [n]\n",
  "URETHRITIC": "relating to urethritis, inflammation of the urethra [adj]\n",
  "URETHRITIDES": "URETHRITIS, inflammation of the urethra [n]\n",
  "URETHRITIS": "inflammation of the urethra [n URETHRITIDES or URETHRITISES]\n",
  "URETHRITISES": "URETHRITIS, inflammation of the urethra [n]\n",
  "URETHROSCOPE": "an instrument for viewing the interior of the urethra [n -S]\n",
  "URETHROSCOPES": "URETHROSCOPE, an instrument for viewing the interior of the urethra [n]\n",
  "URETHROSCOPIC": "relating to urethroscopy [adj]\n",
  "URETHROSCOPIES": "URETHROSCOPY, medical examination of the urethra [n]\n",
  "URETHROSCOPY": "medical examination of the urethra [n URETHROSCOPIES]\n",
  "URETIC": "pertaining to urine [adj]\n",
  "URGE": "to drive forward [v URGED, URGING, URGES]\n",
  "URGED": "URGE, to drive forward [v]\n",
  "URGENCE": "(archaic) urgency [n -S]\n",
  "URGENCES": "URGENCE, (archaic) urgency [n]\n",
  "URGENCIES": "URGENCY, a strong urgency or drive [n]\n",
  "URGENCY": "a strong urgency or drive [n URGENCIES]\n",
  "URGENT": "requiring immediate attention [adj URGENTLY]\n",
  "URGENTLY": "URGENT, requiring immediate attention [adv]\n",
  "URGER": "one who urges [n -S]\n",
  "URGERS": "URGER, one who urges [n]\n",
  "URGES": "URGE, to drive forward [v]\n",
  "URGING": "urgent [adj URGINGLY] / the act of urging [n -S]\n",
  "URGINGLY": "URGING, urgent [adv]\n",
  "URGINGS": "URGING, the act of urging [n]\n",
  "URIAL": "(Punjabi) a wild sheep of central Asia, that has a reddish coat and long curved horns, also OORIAL [n -S]\n",
  "URIALS": "URIAL, (Punjabi) a wild sheep of central Asia, that has a reddish coat and long curved horns, also OORIAL [n]\n",
  "URIC": "pertaining to urine [adj]\n",
  "URICASE": "an enzyme occurring in the liver and kidneys [n -S]\n",
  "URICASES": "URICASE, an enzyme occurring in the liver and kidneys [n]\n",
  "URICOSURIC": "promoting the excretion of uric acid [adj]\n",
  "URICOTELIC": "eliminating excess nitrogen as uric acid [adj]\n",
  "URICOTELISM": "the state of being uricotelic [n -S]\n",
  "URICOTELISMS": "URICOTELISM, the state of being uricotelic [n]\n",
  "URIDINE": "a pyrimidine nucleoside based on uracil and ribose [n -S]\n",
  "URIDINES": "URIDINE, a pyrimidine nucleoside based on uracil and ribose [n]\n",
  "URIDYLIC": "as in uridylic acid [adj]\n",
  "URINAL": "a sanitary fitting, usually plumbed into a wall, for the use of men when urinating [n -S]\n",
  "URINALS": "URINAL, a sanitary fitting, usually plumbed into a wall, for the use of men when urinating [n]\n",
  "URINALYSES": "URINALYSIS, analysis of urine e.g. to detect disease, also URANALYSIS [n]\n",
  "URINALYSIS": "analysis of urine e.g. to detect disease, also URANALYSIS [n URINALYSES]\n",
  "URINANT": "diving head downward [adj]\n",
  "URINARIES": "URINARY, (obsolete) a reservoir for the collection of urine for e.g. manure [n]\n",
  "URINARY": "(obsolete) a reservoir for the collection of urine for e.g. manure [n URINARIES]\n",
  "URINATE": "to discharge urine [v URINATED, URINATING, URINATES]\n",
  "URINATED": "URINATE, to discharge urine [v]\n",
  "URINATES": "URINATE, to discharge urine [v]\n",
  "URINATING": "URINATE, to discharge urine [v]\n",
  "URINATION": "the act of voiding urine [n -S]\n",
  "URINATIONS": "URINATION, the act of voiding urine [n]\n",
  "URINATIVE": "provoking the flow of urine [adj]\n",
  "URINATOR": "one who dives under water in search of something, as for pearls [n -S]\n",
  "URINATORS": "URINATOR, one who dives under water in search of something, as for pearls [n]\n",
  "URINE": "to discharge a liquid containing body wastes [v URINED, URINING, URINES]\n",
  "URINED": "URINE, to discharge a liquid containing body wastes [v]\n",
  "URINEMIA": "an abnormal condition of the blood, also UREMIA, URAEMIA [n -S]\n",
  "URINEMIAS": "URINEMIA, an abnormal condition of the blood, also UREMIA, URAEMIA [n]\n",
  "URINEMIC": "relating to urinemia, retention of waste materials normally excreted [adj]\n",
  "URINES": "URINE, to discharge a liquid containing body wastes [v]\n",
  "URINIFEROUS": "bearing urine [adj]\n",
  "URINING": "URINE, to discharge a liquid containing body wastes [v]\n",
  "URINIPAROUS": "producing urine [adj]\n",
  "URINOGENITAL": "relating to the area holding the genitals and urinary tract, also UROGENITAL [adj]\n",
  "URINOLOGIES": "URINOLOGY, the study of urine or the urinary tract, also OUROLOGY, UROLOGY [n]\n",
  "URINOLOGY": "the study of urine or the urinary tract, also OUROLOGY, UROLOGY [n URINOLOGIES]\n",
  "URINOMETER": "an instrument for measuring the specific gravity of urine [n -S]\n",
  "URINOMETERS": "URINOMETER, an instrument for measuring the specific gravity of urine [n]\n",
  "URINOSCOPIES": "URINOSCOPY, the diagnosis of diseases by inspection of urine [n]\n",
  "URINOSCOPY": "the diagnosis of diseases by inspection of urine [n URINOSCOPIES]\n",
  "URINOSE": "of or pertaining to urine, also URINOUS [adj]\n",
  "URINOUS": "of or pertaining to urine, also URINOSE [adj]\n",
  "URITE": "an abdominal segment in insects [n -S]\n",
  "URITES": "URITE, an abdominal segment in insects [n]\n",
  "URMAN": "(Russian) swampy pine forest [n -S]\n",
  "URMANS": "URMAN, (Russian) swampy pine forest [n]\n",
  "URN": "a vase for the ashes of the dead [n -S] / to place in an urn [v -ED, -ING, -S]\n",
  "URNAL": "pertaining to an urn [adj]\n",
  "URNED": "URN, to place in an urn [v]\n",
  "URNFIELD": "a late Bronze Age cemetery containing funerary urns [n -S]\n",
  "URNFIELDS": "URNFIELD, a late Bronze Age cemetery containing funerary urns [n]\n",
  "URNFUL": "as much as an urn can hold [n -S]\n",
  "URNFULS": "URNFUL, as much as an urn can hold [n]\n",
  "URNING": "a male homosexual [n -S]\n",
  "URNINGS": "URNING, a male homosexual [n]\n",
  "URNLIKE": "like an urn [adj]\n",
  "URNS": "URN, to place in an urn [v]\n",
  "UROBILIN": "a brown pigment in faeces and sometimes urine [n -S]\n",
  "UROBILINOGEN": "any of a group of colourless tetrapyrrole compounds produced by the reduction of bilirubin [n -S]\n",
  "UROBILINOGENS": "UROBILINOGEN, any of a group of colourless tetrapyrrole compounds produced by the reduction of bilirubin [n]\n",
  "UROBILINS": "UROBILIN, a brown pigment in faeces and sometimes urine [n]\n",
  "UROBORIC": "of or like a uroboros, a circular symbol of a dragon or snake swallowing its own tail [adj]\n",
  "UROBOROS": "a representation of a serpent with its tail in its mouth, symbolizing completion, totality, endlessness, etc., also OUROBOROS [n -ES]\n",
  "UROBOROSES": "UROBOROS, a representation of a serpent with its tail in its mouth, symbolizing completion, totality, endlessness, etc., also OUROBOROS [n]\n",
  "UROCHORD": "a rodlike structure in certain lower vertebrates [n -S]\n",
  "UROCHORDAL": "of or pertaining to the Urochorda, tunicates [adj]\n",
  "UROCHORDATE": "a member of the Urochordata, tunicates [n -S]\n",
  "UROCHORDATES": "UROCHORDATE, a member of the Urochordata, tunicates [n]\n",
  "UROCHORDS": "UROCHORD, a rodlike structure in certain lower vertebrates [n]\n",
  "UROCHROME": "an amorphous yellow pigment found in urine [n -S]\n",
  "UROCHROMES": "UROCHROME, an amorphous yellow pigment found in urine [n]\n",
  "URODELAN": "a member of the Urodela, newts and salamanders [n -S]\n",
  "URODELANS": "URODELAN, a member of the Urodela, newts and salamanders [n]\n",
  "URODELE": "one of the Urodela, tailless amphibians, including newts and salamanders [n -S]\n",
  "URODELES": "URODELE, one of the Urodela, tailless amphibians, including newts and salamanders [n]\n",
  "URODELOUS": "of or like urodeles, newts and salamanders [adj]\n",
  "URODYNAMICS": "the study and measurement of the flow of urine in the urinary tract [n]\n",
  "UROGENITAL": "the area holding the genitals and urinary tract, also URINOGENITAL [n -S]\n",
  "UROGENITALS": "UROGENITAL, the area holding the genitals and urinary tract, also URINOGENITAL [n]\n",
  "UROGENOUS": "producing or produced in urine [adj]\n",
  "UROGRAM": "an X-ray of part of the urinary tract [n -S]\n",
  "UROGRAMS": "UROGRAM, an X-ray of part of the urinary tract [n]\n",
  "UROGRAPHIC": "relating to urography, radiological examination of the urinary tract [adj]\n",
  "UROGRAPHIES": "UROGRAPHY, radiological examination of the urinary tract [n]\n",
  "UROGRAPHY": "radiological examination of the urinary tract [n UROGRAPHIES]\n",
  "UROKINASE": "a drug that dissolves intravascular blood clots [n -S]\n",
  "UROKINASES": "UROKINASE, a drug that dissolves intravascular blood clots [n]\n",
  "UROLAGNIA": "sexual arousal caused by, or associated with, urine or the urination [n -S]\n",
  "UROLAGNIAS": "UROLAGNIA, sexual arousal caused by, or associated with, urine or the urination [n]\n",
  "UROLITH": "a small stone or calculus in the urinary tract [n -S]\n",
  "UROLITHIASES": "UROLITHIASIS, formation of kidney stones [n]\n",
  "UROLITHIASIS": "formation of kidney stones [n UROLITHIASES]\n",
  "UROLITHIC": "of or like a urolith, a calculus in the urinary tract [adj]\n",
  "UROLITHS": "UROLITH, a small stone or calculus in the urinary tract [n]\n",
  "UROLOGIC": "relating to urology, the study of urine, also UROLOGICAL [adj]\n",
  "UROLOGICAL": "relating to urology, the study of urine, also UROLOGIC [adj]\n",
  "UROLOGIES": "UROLOGY, the study of urine or the urinary tract, also OUROLOGY, URINOLOGY [n]\n",
  "UROLOGIST": "one versed in urology, the study of urine [n -S]\n",
  "UROLOGISTS": "UROLOGIST, one versed in urology, the study of urine [n]\n",
  "UROLOGY": "the study of urine or the urinary tract, also OUROLOGY, URINOLOGY [n UROLOGIES]\n",
  "UROMERE": "any one of the abdominal segments of an arthropod [n -S]\n",
  "UROMERES": "UROMERE, any one of the abdominal segments of an arthropod [n]\n",
  "UROPOD": "any one of the abdominal appendages of a crustacean, esp. one of the posterior ones [n -S]\n",
  "UROPODAL": "of or pertaining to a uropod, any one of the abdominal appendages of a crustacean [adj]\n",
  "UROPODOUS": "of or pertaining to a uropod, any one of the abdominal appendages of a crustacean [adj]\n",
  "UROPODS": "UROPOD, any one of the abdominal appendages of a crustacean, esp. one of the posterior ones [n]\n",
  "UROPOIESES": "UROPOIESIS, the formation of urine [n]\n",
  "UROPOIESIS": "the formation of urine [n UROPOIESES]\n",
  "UROPYGIA": "UROPYGIUM, the rump of a bird which supports the tail feathers [n]\n",
  "UROPYGIAL": "of or pertaining to the uropygium, or prominence at the base of the tail feathers, in birds [adj]\n",
  "UROPYGIUM": "the rump of a bird which supports the tail feathers [n UROPYGIUMS or UROPYGIA]\n",
  "UROPYGIUMS": "UROPYGIUM, the rump of a bird which supports the tail feathers [n]\n",
  "UROSCOPIC": "relating to uroscopy, the diagnostic examination of urine [adj]\n",
  "UROSCOPIES": "UROSCOPY, the diagnosis of diseases by inspection of urine, also OUROSCOPY [n]\n",
  "UROSCOPIST": "one who carries out a uroscopy, the diagnosis of diseases by inspection of urine [n -S]\n",
  "UROSCOPISTS": "UROSCOPIST, one who carries out a uroscopy, the diagnosis of diseases by inspection of urine [n]\n",
  "UROSCOPY": "the diagnosis of diseases by inspection of urine, also OUROSCOPY [n UROSCOPIES]\n",
  "UROSES": "UROSIS, disease of the urinary organs [n]\n",
  "UROSIS": "disease of the urinary organs [n UROSES]\n",
  "UROSOME": "the abdomen, or post-abdomen, of arthropods [n -S]\n",
  "UROSOMES": "UROSOME, the abdomen, or post-abdomen, of arthropods [n]\n",
  "UROSTEGE": "(Greek) a snake's ventral tail-plate [n -S]\n",
  "UROSTEGES": "UROSTEGE, (Greek) a snake's ventral tail-plate [n]\n",
  "UROSTEGITE": "a snake's ventral tail-plate [n -S]\n",
  "UROSTEGITES": "UROSTEGITE, a snake's ventral tail-plate [n]\n",
  "UROSTHENIC": "having a tail designed for propulsion [adj]\n",
  "UROSTOMIES": "UROSTOMY, an artificial passage for urine [n]\n",
  "UROSTOMY": "an artificial passage for urine [n UROSTOMIES]\n",
  "UROSTYLE": "a part of the vertebral column of frogs and toads [n -S]\n",
  "UROSTYLES": "UROSTYLE, a part of the vertebral column of frogs and toads [n]\n",
  "URP": "(slang) to vomit [v -ED, -ING, -S]\n",
  "URPED": "URP, (slang) to vomit [v]\n",
  "URPING": "URP, (slang) to vomit [v]\n",
  "URPS": "URP, (slang) to vomit [v]\n",
  "URSA": "(Latin) a female bear [n URSAE]\n",
  "URSAE": "URSA, (Latin) a female bear [n]\n",
  "URSID": "a meteor [n -S]\n",
  "URSIDS": "URSID, a meteor [n]\n",
  "URSIFORM": "having the form of a bear [adj]\n",
  "URSINE": "of or pertaining to a bear [adj]\n",
  "URSON": "(French) the Canadian porcupine [n -S]\n",
  "URSONS": "URSON, (French) the Canadian porcupine [n]\n",
  "URTEXT": "(German) the original or earliest version of a text, such as a musical composition or literary work [n URTEXTE or URTEXTS]\n",
  "URTEXTE": "URTEXT, (German) the original or earliest version of a text, such as a musical composition or literary work [n]\n",
  "URTEXTS": "URTEXT, (German) the original or earliest version of a text, such as a musical composition or literary work [n]\n",
  "URTICA": "(Latin) any plant of the nettle genus [n -S]\n",
  "URTICACEOUS": "pertaining to or like nettles [adj]\n",
  "URTICANT": "a substance that causes stinging or itching [n -S]\n",
  "URTICANTS": "URTICANT, a substance that causes stinging or itching [n]\n",
  "URTICARIA": "nettle rash, hives [n -S]\n",
  "URTICARIAL": "relating to urticaria, nettle rash [adj]\n",
  "URTICARIAS": "URTICARIA, nettle rash, hives [n]\n",
  "URTICARIOUS": "related to urticaria [adj]\n",
  "URTICAS": "URTICA, (Latin) any plant of the nettle genus [n]\n",
  "URTICATE": "to cause to itch or sting [v URTICATED, URTICATING, URTICATES]\n",
  "URTICATED": "URTICATE, to cause to itch or sting [v]\n",
  "URTICATES": "URTICATE, to cause to itch or sting [v]\n",
  "URTICATING": "URTICATE, to cause to itch or sting [v]\n",
  "URTICATION": "the act of whipping or stinging with nettles, sometimes used in the treatment of paralysis [n -S]\n",
  "URTICATIONS": "URTICATION, the act of whipping or stinging with nettles, sometimes used in the treatment of paralysis [n]\n",
  "URUBU": "(Tupi) the American black vulture [n -S]\n",
  "URUBUS": "URUBU, (Tupi) the American black vulture [n]\n",
  "URUS": "an extinct bovine mammal, aka ure or aurochs [n -ES]\n",
  "URUSES": "URUS, an extinct bovine mammal, aka ure or aurochs [n]\n",
  "URUSHIOL": "(Japanese) a poisonous and irritant oily liquid present in poison ivy and the lacquer tree [n -S]\n",
  "URUSHIOLS": "URUSHIOL, (Japanese) a poisonous and irritant oily liquid present in poison ivy and the lacquer tree [n]\n",
  "URVA": "(Nepali) the crab-eating mongoose of SE Asia [n -S]\n",
  "URVAS": "URVA, (Nepali) the crab-eating mongoose of SE Asia [n]\n",
  "US": "the objective case of the first person plural pronoun [pron]\n",
  "USABILITIES": "USABILITY, the state of being usable, also USEABILITY [n]\n",
  "USABILITY": "the state of being usable, also USEABILITY [n USABILITIES]\n",
  "USABLE": "that can be used, also USEABLE [adj USABLY]\n",
  "USABLENESS": "the state of being usable, also USEABLENESS [n -ES]\n",
  "USABLENESSES": "USABLENESS, the state of being usable, also USEABLENESS [n]\n",
  "USABLY": "USABLE, that can be used, also USEABLE [adv]\n",
  "USAGE": "a generally accepted practice or procedure, also USANCE, USAUNCE [n -S]\n",
  "USAGER": "someone who has the use of anything in trust for another [n -S]\n",
  "USAGERS": "USAGER, someone who has the use of anything in trust for another [n]\n",
  "USAGES": "USAGE, a generally accepted practice or procedure, also USANCE, USAUNCE [n]\n",
  "USANCE": "a generally accepted practice or procedure, also USAGE, USAUNCE [n -S]\n",
  "USANCES": "USANCE, a generally accepted practice or procedure, also USAGE, USAUNCE [n]\n",
  "USAUNCE": "a generally accepted practice or procedure, also USAGE, USANCE [n -S]\n",
  "USAUNCES": "USAUNCE, a generally accepted practice or procedure, also USAGE, USANCE [n]\n",
  "USE": "to put into service [v USED, USING, USES]\n",
  "USEABILITIES": "USEABILITY, the state of being usable, also USABILITY [n]\n",
  "USEABILITY": "the state of being usable, also USABILITY [n USEABILITIES]\n",
  "USEABLE": "that can be used, also USABLE [adj USEABLY]\n",
  "USEABLENESS": "the state of being useable, also USABLENESS [n -ES]\n",
  "USEABLENESSES": "USEABLENESS, the state of being useable, also USABLENESS [n]\n",
  "USEABLY": "USEABLE, that can be used, also USABLE [adv]\n",
  "USED": "USE, to put into service [v]\n",
  "USEFUL": "serving a purpose [adj USEFULLY] / (Australian) an odd job man [n -S]\n",
  "USEFULLY": "USEFUL, serving a purpose [adv]\n",
  "USEFULNESS": "the state of being useful [n -ES]\n",
  "USEFULNESSES": "USEFULNESS, the state of being useful [n]\n",
  "USEFULS": "USEFUL, (Australian) an odd job man [n]\n",
  "USELESS": "serving no purpose [adj USELESSLY]\n",
  "USELESSLY": "USELESS, serving no purpose [adv]\n",
  "USELESSNESS": "the state of being useless [n -ES]\n",
  "USELESSNESSES": "USELESSNESS, the state of being useless [n]\n",
  "USER": "one that uses [n -S]\n",
  "USERNAME": "an identifying sequence of characters used for logging onto a computer system [n -S]\n",
  "USERNAMES": "USERNAME, an identifying sequence of characters used for logging onto a computer system [n]\n",
  "USERS": "USER, one that uses [n]\n",
  "USES": "USE, to put into service [v]\n",
  "USHER": "to escort people to seats [v -ED, -ING, -S]\n",
  "USHERED": "USHER, to escort people to seats [v]\n",
  "USHERESS": "a female usher [n -ES]\n",
  "USHERESSES": "USHERESS, a female usher [n]\n",
  "USHERETTE": "a female usher, also USHERESS [n -S]\n",
  "USHERETTES": "USHERETTE, a female usher, also USHERESS [n]\n",
  "USHERING": "the act of ushering [n -S]\n",
  "USHERINGS": "USHERING, the act of ushering [n]\n",
  "USHERS": "USHER, to escort people to seats [v]\n",
  "USHERSHIP": "the office of an usher [n -S]\n",
  "USHERSHIPS": "USHERSHIP, the office of an usher [n]\n",
  "USING": "USE, to put into service [v]\n",
  "USNEA": "(Persian) a genus of lichens [n -S]\n",
  "USNEAS": "USNEA, (Persian) a genus of lichens [n]\n",
  "USQUABAE": "(Gaelic) whiskey, also USQUE, USQUEBAE, USQUEBAUGH [n -S]\n",
  "USQUABAES": "USQUABAE, (Gaelic) whiskey, also USQUE, USQUEBAE, USQUEBAUGH [n]\n",
  "USQUE": "(Gaelic) whiskey, also USQUABAE, USQUEBAE, USQUEBAUGH [n -S]\n",
  "USQUEBAE": "(Gaelic) whiskey, also USQUABAE, USQUE, USQUEBAUGH [n -S]\n",
  "USQUEBAES": "USQUEBAE, (Gaelic) whiskey, also USQUABAE, USQUE, USQUEBAUGH [n]\n",
  "USQUEBAUGH": "(Gaelic) whiskey, also USQUABAE, USQUE, USQUEBAE [n -S]\n",
  "USQUEBAUGHS": "USQUEBAUGH, (Gaelic) whiskey, also USQUABAE, USQUE, USQUEBAE [n]\n",
  "USQUES": "USQUE, (Gaelic) whiskey, also USQUABAE, USQUEBAE, USQUEBAUGH [n]\n",
  "USTILAGINEOUS": "relating to a genus of basidiomycetous fungi, of the family Ustilaginaceae, also USTILAGINOUS [adj]\n",
  "USTILAGINOUS": "relating to a genus of basidiomycetous fungi, of the family Ustilaginaceae, also USTILAGINEOUS [adj]\n",
  "USTION": "(obsolete) the act of burning, or the state of being burned [n -S]\n",
  "USTIONS": "USTION, (obsolete) the act of burning, or the state of being burned [n]\n",
  "USTULATE": "to give a charred appearance to [v USTULATED, USTULATING, USTULATES]\n",
  "USTULATED": "USTULATE, to give a charred appearance to [v]\n",
  "USTULATES": "USTULATE, to give a charred appearance to [v]\n",
  "USTULATING": "USTULATE, to give a charred appearance to [v]\n",
  "USTULATION": "burning; roasting [n -S]\n",
  "USTULATIONS": "USTULATION, burning; roasting [n]\n",
  "USUAL": "customary [adj USUALLY] / one's normal habit, drink etc. [n -S]\n",
  "USUALLY": "USUAL, customary [adv]\n",
  "USUALNESS": "the state of being usual [n -ES]\n",
  "USUALNESSES": "USUALNESS, the state of being usual [n]\n",
  "USUALS": "USUAL, one's normal habit, drink etc. [n]\n",
  "USUCAPIENT": "a person who claims and holds by usucapion, the acquisition of a property through long usage [n -S]\n",
  "USUCAPIENTS": "USUCAPIENT, a person who claims and holds by usucapion, the acquisition of a property through long usage [n]\n",
  "USUCAPION": "the acquisition of a property through long usage, also USUCAPTION [n -S]\n",
  "USUCAPIONS": "USUCAPION, the acquisition of a property through long usage, also USUCAPTION [n]\n",
  "USUCAPT": "to acquire by long possession [v -ED, -ING, -S]\n",
  "USUCAPTED": "USUCAPT, to acquire by long possession [v]\n",
  "USUCAPTIBLE": "relating to usucaption [adj]\n",
  "USUCAPTING": "USUCAPT, to acquire by long possession [v]\n",
  "USUCAPTION": "the acquisition of a property through long usage, also USUCAPION [n -S]\n",
  "USUCAPTIONS": "USUCAPTION, the acquisition of a property through long usage, also USUCAPION [n]\n",
  "USUCAPTS": "USUCAPT, to acquire by long possession [v]\n",
  "USUFRUCT": "the legal right of using and enjoying the fruits or profits of something belonging to another [n -S] / to exercise this right [v -ED, -ING, -S]\n",
  "USUFRUCTED": "USUFRUCT, to exercise this right [v]\n",
  "USUFRUCTING": "USUFRUCT, to exercise this right [v]\n",
  "USUFRUCTS": "USUFRUCT, to exercise this right [v]\n",
  "USUFRUCTUARIES": "USUFRUCTUARY, a person who has the use or enjoyment of something, esp. property [n]\n",
  "USUFRUCTUARY": "a person who has the use or enjoyment of something, esp. property [n USUFRUCTUARIES]\n",
  "USURE": "(obsolete) to practise usuring [v USURED, USURING, USURES]\n",
  "USURED": "USURE, (obsolete) to practise usuring [v]\n",
  "USURER": "one who lives by usury [n -S]\n",
  "USURERS": "USURER, one who lives by usury [n]\n",
  "USURES": "USURE, (obsolete) to practise usuring [v]\n",
  "USURESS": "a female money lender [n -ES]\n",
  "USURESSES": "USURESS, a female money lender [n]\n",
  "USURIES": "USURY, the lending of money at an exorbitant interest rate [n]\n",
  "USURING": "USURE, (obsolete) to practise usuring [v]\n",
  "USURIOUS": "practising usury, also USUROUS [adj USURIOUSLY]\n",
  "USURIOUSLY": "USURIOUS, practising usury, also USUROUS [adv]\n",
  "USURIOUSNESS": "the state of being usurious [n -ES]\n",
  "USURIOUSNESSES": "USURIOUSNESS, the state of being usurious [n]\n",
  "USUROUS": "(obsolete) relating to usury, also USURIOUS [adj]\n",
  "USURP": "to seize and hold without legal authority [v -ED, -ING, -S]\n",
  "USURPATION": "the act of usurping [n -S]\n",
  "USURPATIONS": "USURPATION, the act of usurping [n]\n",
  "USURPATIVE": "relating to usurpation [adj]\n",
  "USURPATORY": "marked by usurpation; usurping [adj]\n",
  "USURPATURE": "usurpation [n -S]\n",
  "USURPATURES": "USURPATURE, usurpation [n]\n",
  "USURPED": "USURP, to seize and hold without legal authority [v]\n",
  "USURPEDLY": "USURPED, USURP, to seize and hold without legal authority [adv]\n",
  "USURPER": "one who usurps [n -S]\n",
  "USURPERS": "USURPER, one who usurps [n]\n",
  "USURPING": "taking possession unjustly [adj USURPINGLY] / the act of usurping [n -S]\n",
  "USURPINGLY": "USURPING, taking possession unjustly [adv]\n",
  "USURPINGS": "USURPING, the act of usurping [n]\n",
  "USURPS": "USURP, to seize and hold without legal authority [v]\n",
  "USURY": "the lending of money at an exorbitant interest rate [n USURIES]\n",
  "USWARD": "(archaic) towards us, in our direction, also USWARDS [adv]\n",
  "USWARDS": "(archaic) towards us, in our direction, also USWARD [adv]\n",
  "UT": "the musical tone C [n -S]\n",
  "UTA": "any of a genus of large lizards [n -S]\n",
  "UTAS": "(obsolete) the seventh day after a festival [n -ES]\n",
  "UTASES": "UTAS, (obsolete) the seventh day after a festival [n]\n",
  "UTE": "(Australian slang) a utility vehicle, a small truck [n -S]\n",
  "UTENSIL": "a useful implement [n -S]\n",
  "UTENSILS": "UTENSIL, a useful implement [n]\n",
  "UTERECTOMIES": "UTERECTOMY, the surgical removal of the womb, aka hysterectomy [n]\n",
  "UTERECTOMY": "the surgical removal of the womb, aka hysterectomy [n UTERECTOMIES]\n",
  "UTERI": "UTERUS, (Latin) an organ of female mammals [n]\n",
  "UTERINE": "pertaining to the uterus [adj]\n",
  "UTERITIS": "inflammation of the womb [n -ES]\n",
  "UTERITISES": "UTERITIS, inflammation of the womb [n]\n",
  "UTEROGESTATION": "gestation in the womb [n -S]\n",
  "UTEROGESTATIONS": "UTEROGESTATION, gestation in the womb [n]\n",
  "UTEROTOMIES": "UTEROTOMY, surgical removal of the womb [n]\n",
  "UTEROTOMY": "surgical removal of the womb [n UTEROTOMIES]\n",
  "UTERUS": "(Latin) an organ of female mammals [n UTERUSES or UTERI]\n",
  "UTERUSES": "UTERUS, (Latin) an organ of female mammals [n]\n",
  "UTES": "UTE, (Australian slang) a utility vehicle, a small truck [n]\n",
  "UTILE": "an African hardwood tree, a species of mahogany [n -S]\n",
  "UTILES": "UTILE, an African hardwood tree, a species of mahogany [n]\n",
  "UTILIDOR": "(Canadian) an insulated system of pipes for use in arctic regions [n -S]\n",
  "UTILIDORS": "UTILIDOR, (Canadian) an insulated system of pipes for use in arctic regions [n]\n",
  "UTILISABLE": "that can be utilised, also UTILIZABLE [adj]\n",
  "UTILISATION": "the act of utilising, also UTILIZATION [n -S]\n",
  "UTILISATIONS": "UTILISATION, the act of utilising, also UTILIZATION [n]\n",
  "UTILISE": "to make use of, also UTILIZE [v UTILISED, UTILISING, UTILISES]\n",
  "UTILISED": "UTILISE, to make use of, also UTILIZE [v]\n",
  "UTILISER": "one who utilises, also UTILIZER [n -S]\n",
  "UTILISERS": "UTILISER, one who utilises, also UTILIZER [n]\n",
  "UTILISES": "UTILISE, to make use of, also UTILIZE [v]\n",
  "UTILISING": "UTILISE, to make use of, also UTILIZE [v]\n",
  "UTILITARIAN": "an advocate or adherent of utilitarianism [n -S]\n",
  "UTILITARIANISE": "to make utilitarian, also UTILITARIANIZE [v UTILITARIANISED, UTILITARIANISES]\n",
  "UTILITARIANISED": "UTILITARIANISE, to make utilitarian, also UTILITARIANIZE [v]\n",
  "UTILITARIANISES": "UTILITARIANISE, to make utilitarian, also UTILITARIANIZE [v]\n",
  "UTILITARIANISM": "the belief that utility of actions determines moral value [n -S]\n",
  "UTILITARIANISMS": "UTILITARIANISM, the belief that utility of actions determines moral value [n]\n",
  "UTILITARIANIZE": "to make utilitarian, also UTILITARIANISE [v UTILITARIANIZED, UTILITARIANIZES]\n",
  "UTILITARIANIZED": "UTILITARIANIZE, to make utilitarian, also UTILITARIANISE [v]\n",
  "UTILITARIANIZES": "UTILITARIANIZE, to make utilitarian, also UTILITARIANISE [v]\n",
  "UTILITARIANS": "UTILITARIAN, an advocate or adherent of utilitarianism [n]\n",
  "UTILITIES": "UTILITY, the quality of being useful [n]\n",
  "UTILITY": "the quality of being useful [n UTILITIES]\n",
  "UTILIZABLE": "that can be utilized, also UTILISABLE [adj]\n",
  "UTILIZATION": "the act of utilizing, also UTILISATION [n -S]\n",
  "UTILIZATIONS": "UTILIZATION, the act of utilizing, also UTILISATION [n]\n",
  "UTILIZE": "to make use of, also UTILISE [v UTILIZED, UTILIZING, UTILIZES]\n",
  "UTILIZED": "UTILIZE, to make use of, also UTILISE [v]\n",
  "UTILIZER": "one who utilizes, also UTILISER [n -S]\n",
  "UTILIZERS": "UTILIZER, one who utilizes, also UTILISER [n]\n",
  "UTILIZES": "UTILIZE, to make use of, also UTILISE [v]\n",
  "UTILIZING": "UTILIZE, to make use of, also UTILISE [v]\n",
  "UTIS": "(Shakespeare) clamour, din [n -ES]\n",
  "UTISES": "UTIS, (Shakespeare) clamour, din [n]\n",
  "UTMOST": "the greatest degree or amount, also UTTERMOST [n -S]\n",
  "UTMOSTS": "UTMOST, the greatest degree or amount, also UTTERMOST [n]\n",
  "UTOPIA": "any real or imaginary state or place believed to be ideal [n -S]\n",
  "UTOPIAN": "one who believes in Utopia, also UTOPIAST, UTOPIST [n -S]\n",
  "UTOPIANISE": "to make Utopian, also UTOPIANIZE [v UTOPIANISED, UTOPIANISING, UTOPIANISES]\n",
  "UTOPIANISED": "UTOPIANISE, to make Utopian, also UTOPIANIZE [v]\n",
  "UTOPIANISER": "one who utopianises, also UTOPIANIZER [n -S]\n",
  "UTOPIANISERS": "UTOPIANISER, one who utopianises, also UTOPIANIZER [n]\n",
  "UTOPIANISES": "UTOPIANISE, to make Utopian, also UTOPIANIZE [v]\n",
  "UTOPIANISING": "UTOPIANISE, to make Utopian, also UTOPIANIZE [v]\n",
  "UTOPIANISM": "the ideas, views, aims, etc., of a Utopian [n -S]\n",
  "UTOPIANISMS": "UTOPIANISM, the ideas, views, aims, etc., of a Utopian [n]\n",
  "UTOPIANIZE": "to make Utopian, also UTOPIANISE [v UTOPIANIZED, UTOPIANIZING, UTOPIANIZES]\n",
  "UTOPIANIZED": "UTOPIANIZE, to make Utopian, also UTOPIANISE [v]\n",
  "UTOPIANIZER": "one who utopianizes, also UTOPIANISER [n -S]\n",
  "UTOPIANIZERS": "UTOPIANIZER, one who utopianizes, also UTOPIANISER [n]\n",
  "UTOPIANIZES": "UTOPIANIZE, to make Utopian, also UTOPIANISE [v]\n",
  "UTOPIANIZING": "UTOPIANIZE, to make Utopian, also UTOPIANISE [v]\n",
  "UTOPIANS": "UTOPIAN, one who believes in Utopia, also UTOPIAST, UTOPIST [n]\n",
  "UTOPIAS": "UTOPIA, any real or imaginary state or place believed to be ideal [n]\n",
  "UTOPIAST": "one who believes in utopia, also UTOPIAN, UTOPIST [n -S]\n",
  "UTOPIASTS": "UTOPIAST, one who believes in utopia, also UTOPIAN, UTOPIST [n]\n",
  "UTOPISM": "the ideals or principles of a utopian [n -S]\n",
  "UTOPISMS": "UTOPISM, the ideals or principles of a utopian [n]\n",
  "UTOPIST": "one who believes in utopism, the establishment of a utopia, also UTOPIAN, UTOPIAST [n -S]\n",
  "UTOPISTIC": "of or like a utopist, a believer in Utopia [adj]\n",
  "UTOPISTS": "UTOPIST, one who believes in utopism, the establishment of a utopia, also UTOPIAN, UTOPIAST [n]\n",
  "UTRICLE": "a saclike cavity in the inner ear, also UTRICULUS [n -S]\n",
  "UTRICLES": "UTRICLE, a saclike cavity in the inner ear, also UTRICULUS [n]\n",
  "UTRICULAR": "like or having a utricle, also UTRICULATE [adj]\n",
  "UTRICULARIA": "any plant of the bladderwort genus Utricularia [n -S]\n",
  "UTRICULARIAS": "UTRICULARIA, any plant of the bladderwort genus Utricularia [n]\n",
  "UTRICULATE": "like or having a utricle, also UTRICULAR [adj]\n",
  "UTRICULI": "UTRICULUS, (Latin) a saclike cavity in the inner ear, also UTRICLE [n]\n",
  "UTRICULITIS": "inflammation of the inner ear [n -ES]\n",
  "UTRICULITISES": "UTRICULITIS, inflammation of the inner ear [n]\n",
  "UTRICULUS": "(Latin) a saclike cavity in the inner ear, also UTRICLE [n UTRICULI]\n",
  "UTS": "UT, the musical tone C [n]\n",
  "UTTER": "complete [adj UTTERER, UTTEREST, UTTERLY] / to give audible expression to [v -ED, -ING, -S]\n",
  "UTTERABLE": "capable of being uttered [adj]\n",
  "UTTERABLENESS": "the state of being utterable [n -ES]\n",
  "UTTERABLENESSES": "UTTERABLENESS, the state of being utterable [n]\n",
  "UTTERANCE": "the act of uttering [n -S]\n",
  "UTTERANCES": "UTTERANCE, the act of uttering [n]\n",
  "UTTERED": "UTTER, to give audible expression to [v]\n",
  "UTTERER": "one who utters [n -S]\n",
  "UTTERERS": "UTTERER, one who utters [n]\n",
  "UTTEREST": "UTTER, complete [adj]\n",
  "UTTERING": "the circulation of counterfeit notes [n -S]\n",
  "UTTERINGS": "UTTERING, the circulation of counterfeit notes [n]\n",
  "UTTERLESS": "incapable of being uttered [adj]\n",
  "UTTERLY": "UTTER, complete [adv]\n",
  "UTTERMOST": "the greatest degree or amount, also UTMOST [n -S]\n",
  "UTTERMOSTS": "UTTERMOST, the greatest degree or amount, also UTMOST [n]\n",
  "UTTERNESS": "the state of being utter [n -ES]\n",
  "UTTERNESSES": "UTTERNESS, the state of being utter [n]\n",
  "UTTERS": "UTTER, to give audible expression to [v]\n",
  "UTU": "(Maori) a settlement of a debt [n -S]\n",
  "UTUS": "UTU, (Maori) a settlement of a debt [n]\n",
  "UVA": "a grape or grapelike berry [n UVAE or UVAS]\n",
  "UVAE": "UVA, a grape or grapelike berry [n]\n",
  "UVAROVITE": "(Russian) a green lime-chrome garnet [n -S]\n",
  "UVAROVITES": "UVAROVITE, (Russian) a green lime-chrome garnet [n]\n",
  "UVAS": "UVA, a grape or grapelike berry [n]\n",
  "UVEA": "the posterior pigment-bearing layer of the pupil of the eye [n -S]\n",
  "UVEAL": "relating to the uvea, the posterior pigment-bearing layer of the pupil of the eye [adj]\n",
  "UVEAS": "UVEA, the posterior pigment-bearing layer of the pupil of the eye [n]\n",
  "UVEITIC": "pertaining to the uvea, the posterior pigment-bearing layer of the pupil of the eye [adj]\n",
  "UVEITIS": "inflammation of the uvea [n -ES]\n",
  "UVEITISES": "UVEITIS, inflammation of the uvea [n]\n",
  "UVEOUS": "pertaining to the uvea [adj]\n",
  "UVULA": "(Latin) the pendent fleshy portion of the soft palate [n UVULAS or UVULAE]\n",
  "UVULAE": "UVULA, (Latin) the pendent fleshy portion of the soft palate [n]\n",
  "UVULAR": "relating to the uvula [adj UVULARLY] / a sound produced by use of the uvula [n -S]\n",
  "UVULARLY": "UVULAR, relating to the uvula [adv]\n",
  "UVULARS": "UVULAR, a sound produced by use of the uvula [n]\n",
  "UVULAS": "UVULA, (Latin) the pendent fleshy portion of the soft palate [n]\n",
  "UVULITIS": "inflammation of the uvula [n -ES]\n",
  "UVULITISES": "UVULITIS, inflammation of the uvula [n]\n",
  "UXORIAL": "of or relating to a wife [adj UXORIALLY]\n",
  "UXORIALLY": "UXORIAL, of or relating to a wife [adv]\n",
  "UXORICIDAL": "of or pertaining to uxoricide [adj]\n",
  "UXORICIDE": "the murder of a wife by her husband [n -S]\n",
  "UXORICIDES": "UXORICIDE, the murder of a wife by her husband [n]\n",
  "UXORILOCAL": "living in or near the wife's home or community after marriage [adj]\n",
  "UXORIOUS": "excessively submissive or devoted to one's wife [adj UXORIOUSLY]\n",
  "UXORIOUSLY": "UXORIOUS, excessively submissive or devoted to one's wife [adv]\n",
  "UXORIOUSNESS": "the state of being uxorious [n -ES]\n",
  "UXORIOUSNESSES": "UXORIOUSNESS, the state of being uxorious [n]\n",
  "VAC": "to clean with a vacuum cleaner [v VACKED, VACKING, VACS]\n",
  "VACANCE": "the state of being vacant, also VACANCY [n -S]\n",
  "VACANCES": "VACANCE, the state of being vacant, also VACANCY [n]\n",
  "VACANCIES": "VACANCY, the state of being vacant, also VACANCE [n]\n",
  "VACANCY": "the state of being vacant, also VACANCE [n VACANCIES]\n",
  "VACANT": "empty [adj VACANTLY]\n",
  "VACANTLY": "VACANT, empty [adv]\n",
  "VACANTNESS": "the state of being vacant [n -ES]\n",
  "VACANTNESSES": "VACANTNESS, the state of being vacant [n]\n",
  "VACATABLE": "that can be vacated [adj]\n",
  "VACATE": "to make vacant [v VACATED, VACATING, VACATES]\n",
  "VACATED": "VACATE, to make vacant [v]\n",
  "VACATES": "VACATE, to make vacant [v]\n",
  "VACATING": "VACATE, to make vacant [v]\n",
  "VACATION": "to take a holiday [v -ED, -ING, -S]\n",
  "VACATIONED": "VACATION, to take a holiday [v]\n",
  "VACATIONER": "one who takes a vacation, also VACATIONIST [n -S]\n",
  "VACATIONERS": "VACATIONER, one who takes a vacation, also VACATIONIST [n]\n",
  "VACATIONING": "VACATION, to take a holiday [v]\n",
  "VACATIONIST": "one who takes a vacation, also VACATIONER [n -S]\n",
  "VACATIONISTS": "VACATIONIST, one who takes a vacation, also VACATIONER [n]\n",
  "VACATIONLAND": "an area with recreational attractions and facilities for vacationers [n -S]\n",
  "VACATIONLANDS": "VACATIONLAND, an area with recreational attractions and facilities for vacationers [n]\n",
  "VACATIONLESS": "without a vacation [adj]\n",
  "VACATIONS": "VACATION, to take a holiday [v]\n",
  "VACATUR": "(Latin) the act of annulling in law [n -S]\n",
  "VACATURS": "VACATUR, (Latin) the act of annulling in law [n]\n",
  "VACCINA": "(Latin) cowpox, also VACCINIA [n -S]\n",
  "VACCINAL": "of or pertaining to vaccinia or vaccination [adj]\n",
  "VACCINAS": "VACCINA, (Latin) cowpox, also VACCINIA [n]\n",
  "VACCINATE": "to inoculate with a vaccine [v VACCINATED, VACCINATING, VACCINATES]\n",
  "VACCINATED": "VACCINATE, to inoculate with a vaccine [v]\n",
  "VACCINATES": "VACCINATE, to inoculate with a vaccine [v]\n",
  "VACCINATING": "VACCINATE, to inoculate with a vaccine [v]\n",
  "VACCINATION": "the act of vaccinating [n -S]\n",
  "VACCINATIONS": "VACCINATION, the act of vaccinating [n]\n",
  "VACCINATOR": "one who vaccinates [n -S]\n",
  "VACCINATORS": "VACCINATOR, one who vaccinates [n]\n",
  "VACCINATORY": "relating to vaccination [adj]\n",
  "VACCINE": "a preparation given to produce immunity to a specific disease [n -S]\n",
  "VACCINEE": "one that is vaccinated [n -S]\n",
  "VACCINEES": "VACCINEE, one that is vaccinated [n]\n",
  "VACCINES": "VACCINE, a preparation given to produce immunity to a specific disease [n]\n",
  "VACCINIA": "(Latin) cowpox, also VACCINA [n -S]\n",
  "VACCINIAL": "of or like vaccinia, cowpox [adj]\n",
  "VACCINIAS": "VACCINIA, (Latin) cowpox, also VACCINA [n]\n",
  "VACCINIUM": "(Latin) a genus of ericaceous shrubs including the various kinds of blueberries and the true cranberries [n -S]\n",
  "VACCINIUMS": "VACCINIUM, (Latin) a genus of ericaceous shrubs including the various kinds of blueberries and the true cranberries [n]\n",
  "VACHERIN": "(French) a kind of cake, layered with Chantilly cream [n -S]\n",
  "VACHERINS": "VACHERIN, (French) a kind of cake, layered with Chantilly cream [n]\n",
  "VACILLANT": "vacillating; wavering [adj]\n",
  "VACILLATE": "to fluctuate in opinion or resolution [v VACILLATED, VACILLATING, VACILLATES]\n",
  "VACILLATED": "VACILLATE, to fluctuate in opinion or resolution [v]\n",
  "VACILLATES": "VACILLATE, to fluctuate in opinion or resolution [v]\n",
  "VACILLATING": "VACILLATE, to fluctuate in opinion or resolution [v]\n",
  "VACILLATINGLY": "VACILLATING, VACILLATE, to fluctuate in opinion or resolution [adv]\n",
  "VACILLATION": "an act or instance of vacillating [n -S]\n",
  "VACILLATIONS": "VACILLATION, an act or instance of vacillating [n]\n",
  "VACILLATOR": "one who vacillates [n -S]\n",
  "VACILLATORS": "VACILLATOR, one who vacillates [n]\n",
  "VACILLATORY": "wavering [adj]\n",
  "VACKED": "VAC, to clean with a vacuum cleaner [v]\n",
  "VACKING": "VAC, to clean with a vacuum cleaner [v]\n",
  "VACS": "VAC, to clean with a vacuum cleaner [v]\n",
  "VACUA": "VACUUM, (Latin) a space completely empty of matter [n]\n",
  "VACUATE": "(obsolete) to make void, or empty, also EVACUATE [v VACUATED, VACUATING, VACUATES]\n",
  "VACUATED": "VACUATE, (obsolete) to make void, or empty, also EVACUATE [v]\n",
  "VACUATES": "VACUATE, (obsolete) to make void, or empty, also EVACUATE [v]\n",
  "VACUATING": "VACUATE, (obsolete) to make void, or empty, also EVACUATE [v]\n",
  "VACUATION": "the act of emptying [n -S]\n",
  "VACUATIONS": "VACUATION, the act of emptying [n]\n",
  "VACUIST": "one who thinks there are empty spaces in nature [n -S]\n",
  "VACUISTS": "VACUIST, one who thinks there are empty spaces in nature [n]\n",
  "VACUITIES": "VACUITY, an empty space [n]\n",
  "VACUITY": "an empty space [n VACUITIES]\n",
  "VACUOLAR": "relating to a vacuole, a cellular cavity [adj]\n",
  "VACUOLATE": "having vacuoles, also VACUOLATED [adj]\n",
  "VACUOLATED": "having vacuoles, also VACUOLATE [adj]\n",
  "VACUOLATION": "the development or formation of vacuoles [n -S]\n",
  "VACUOLATIONS": "VACUOLATION, the development or formation of vacuoles [n]\n",
  "VACUOLE": "a small cavity in organic tissue [n -S]\n",
  "VACUOLES": "VACUOLE, a small cavity in organic tissue [n]\n",
  "VACUOLISATION": "the act of producing vacuoles, also VACUOLIZATION [n -S]\n",
  "VACUOLISATIONS": "VACUOLISATION, the act of producing vacuoles, also VACUOLIZATION [n]\n",
  "VACUOLIZATION": "the act of producing vacuoles, also VACUOLISATION [n -S]\n",
  "VACUOLIZATIONS": "VACUOLIZATION, the act of producing vacuoles, also VACUOLISATION [n]\n",
  "VACUOUS": "empty [adj VACUOUSLY]\n",
  "VACUOUSLY": "VACUOUS, empty [adv]\n",
  "VACUOUSNESS": "the state of being vacuous [n -ES]\n",
  "VACUOUSNESSES": "VACUOUSNESS, the state of being vacuous [n]\n",
  "VACUUM": "(Latin) a space completely empty of matter [n VACUUMS or VACUA] / to operate a cleaner that uses suction [v -ED, -ING, -S]\n",
  "VACUUMED": "VACUUM, to operate a cleaner that uses suction [v]\n",
  "VACUUMING": "VACUUM, to operate a cleaner that uses suction [v]\n",
  "VACUUMS": "VACUUM, to operate a cleaner that uses suction [v]\n",
  "VADE": "(Shakespeare) to pass away [v VADED, VADING, VADES]\n",
  "VADED": "VADE, (Shakespeare) to pass away [v]\n",
  "VADES": "VADE, (Shakespeare) to pass away [v]\n",
  "VADING": "VADE, (Shakespeare) to pass away [v]\n",
  "VADOSE": "located above the permanent groundwater level [adj]\n",
  "VAE": "in Orkney or Shetland, a bay or creek, also VOE [n -S]\n",
  "VAES": "VAE, in Orkney or Shetland, a bay or creek, also VOE [n]\n",
  "VAG": "(Australian slang) to arrest someone for vagrancy [v VAGGED, VAGGING, VAGS]\n",
  "VAGABOND": "to live like a vagrant [v -ED, -ING, -S]\n",
  "VAGABONDAGE": "the state of being a vagabond [n -S]\n",
  "VAGABONDAGES": "VAGABONDAGE, the state of being a vagabond [n]\n",
  "VAGABONDED": "VAGABOND, to live like a vagrant [v]\n",
  "VAGABONDING": "VAGABOND, to live like a vagrant [v]\n",
  "VAGABONDISE": "to go about as a vagabond, also VAGABONDIZE [v VAGABONDISED, VAGABONDISING, VAGABONDISES]\n",
  "VAGABONDISED": "VAGABONDISE, to go about as a vagabond, also VAGABONDIZE [v]\n",
  "VAGABONDISES": "VAGABONDISE, to go about as a vagabond, also VAGABONDIZE [v]\n",
  "VAGABONDISH": "like a vagabond [adj]\n",
  "VAGABONDISING": "VAGABONDISE, to go about as a vagabond, also VAGABONDIZE [v]\n",
  "VAGABONDISM": "being a vagabond [n -S]\n",
  "VAGABONDISMS": "VAGABONDISM, being a vagabond [n]\n",
  "VAGABONDIZE": "to go about as a vagabond, also VAGABONDISE [v VAGABONDIZED, VAGABONDIZING, VAGABONDIZES]\n",
  "VAGABONDIZED": "VAGABONDIZE, to go about as a vagabond, also VAGABONDISE [v]\n",
  "VAGABONDIZES": "VAGABONDIZE, to go about as a vagabond, also VAGABONDISE [v]\n",
  "VAGABONDIZING": "VAGABONDIZE, to go about as a vagabond, also VAGABONDISE [v]\n",
  "VAGABONDS": "VAGABOND, to live like a vagrant [v]\n",
  "VAGAL": "pertaining to the vagus nerve [adj VAGALLY]\n",
  "VAGALLY": "VAGAL, pertaining to the vagus nerve [adv]\n",
  "VAGARIES": "VAGARY, a whim, also FEGARY [n]\n",
  "VAGARIOUS": "erratic in behaviour or direction [adj VAGARIOUSLY]\n",
  "VAGARIOUSLY": "VAGARIOUS, erratic in behaviour or direction [adv]\n",
  "VAGARISH": "showing vagaries [adj]\n",
  "VAGARY": "a whim, also FEGARY [n VAGARIES]\n",
  "VAGGED": "VAG, (Australian slang) to arrest someone for vagrancy [v]\n",
  "VAGGING": "VAG, (Australian slang) to arrest someone for vagrancy [v]\n",
  "VAGI": "VAGUS, (Latin) the tenth and last cranial nerve, going to larynx and pharynx [n]\n",
  "VAGILE": "free to move about [adj]\n",
  "VAGILITIES": "VAGILITY, freedom of movement [n]\n",
  "VAGILITY": "freedom of movement [n VAGILITIES]\n",
  "VAGINA": "(Latin) the passage leading from the uterus to the vulva [n VAGINAS or VAGINAE]\n",
  "VAGINAE": "VAGINA, (Latin) the passage leading from the uterus to the vulva [n]\n",
  "VAGINAL": "pertaining to the vagina [adj VAGINALLY]\n",
  "VAGINALLY": "VAGINAL, pertaining to the vagina [adv]\n",
  "VAGINANT": "sheathing [adj]\n",
  "VAGINAS": "VAGINA, (Latin) the passage leading from the uterus to the vulva [n]\n",
  "VAGINATE": "invested with, or as if with, a sheath, also VAGINATED [adj]\n",
  "VAGINATED": "invested with, or as if with, a sheath, also VAGINATE [adj]\n",
  "VAGINECTOMIES": "VAGINECTOMY, surgical excision of the vagina [n]\n",
  "VAGINECTOMY": "surgical excision of the vagina [n VAGINECTOMIES]\n",
  "VAGINICOLINE": "living in a sheath, also VAGINICOLOUS [adj]\n",
  "VAGINICOLOUS": "living in a sheath, also VAGINICOLINE [adj]\n",
  "VAGINISMUS": "a painful spasmodic contraction of the vagina, often rendering copulation impossible [n -ES]\n",
  "VAGINISMUSES": "VAGINISMUS, a painful spasmodic contraction of the vagina, often rendering copulation impossible [n]\n",
  "VAGINITIDES": "VAGINITIS, inflammation of the vagina [n]\n",
  "VAGINITIS": "inflammation of the vagina [n VAGINITIDES or VAGINITISES]\n",
  "VAGINITISES": "VAGINITIS, inflammation of the vagina [n]\n",
  "VAGINOSES": "VAGINOSIS, a bacterial vaginal infection [n]\n",
  "VAGINOSIS": "a bacterial vaginal infection [n VAGINOSES]\n",
  "VAGINULA": "(Latin) a little sheath, also VAGINULE [n VAGINULAE]\n",
  "VAGINULAE": "VAGINULA, (Latin) a little sheath, also VAGINULE [n]\n",
  "VAGINULE": "a little sheath, also VAGINULA [n -S]\n",
  "VAGINULES": "VAGINULE, a little sheath, also VAGINULA [n]\n",
  "VAGITUS": "(Latin) a cry or wail [n -ES]\n",
  "VAGITUSES": "VAGITUS, (Latin) a cry or wail [n]\n",
  "VAGOTOMIES": "VAGOTOMY, surgical division of the vagus nerve [n]\n",
  "VAGOTOMY": "surgical division of the vagus nerve [n VAGOTOMIES]\n",
  "VAGOTONIA": "pathological overactivity of the vagus nerve [n -S]\n",
  "VAGOTONIAS": "VAGOTONIA, pathological overactivity of the vagus nerve [n]\n",
  "VAGOTONIC": "relating to vagotonia, pathological overactivity of the vagus nerve [adj]\n",
  "VAGOTROPIC": "of a drug, affecting the activity of the vagus nerve [adj]\n",
  "VAGRANCIES": "VAGRANCY, the state of being a vagrant [n]\n",
  "VAGRANCY": "the state of being a vagrant [n VAGRANCIES]\n",
  "VAGRANT": "wandering, also VAGROM [adj VAGRANTLY] / a wanderer with no apparent means of support [n -S]\n",
  "VAGRANTLY": "VAGRANT, wandering, also VAGROM [adv]\n",
  "VAGRANTNESS": "the state of being vagrant [n -ES]\n",
  "VAGRANTNESSES": "VAGRANTNESS, the state of being vagrant [n]\n",
  "VAGRANTS": "VAGRANT, a wanderer with no apparent means of support [n]\n",
  "VAGROM": "(Shakespeare) vagrant [adj]\n",
  "VAGS": "VAG, (Australian slang) to arrest someone for vagrancy [v]\n",
  "VAGUE": "indeterminate [adj VAGUER, VAGUEST, VAGUELY] / to be vague [v VAGUED, VAGUING, VAGUES]\n",
  "VAGUED": "VAGUE, to be vague [v]\n",
  "VAGUELY": "VAGUE, indeterminate [adv]\n",
  "VAGUENESS": "the state of being vague [n -ES]\n",
  "VAGUENESSES": "VAGUENESS, the state of being vague [n]\n",
  "VAGUER": "VAGUE, indeterminate [adj]\n",
  "VAGUES": "VAGUE, to be vague [v]\n",
  "VAGUEST": "VAGUE, indeterminate [adj]\n",
  "VAGUING": "VAGUE, to be vague [v]\n",
  "VAGUISH": "somewhat vague [adj]\n",
  "VAGUS": "(Latin) the tenth and last cranial nerve, going to larynx and pharynx [n VAGI]\n",
  "VAHANA": "(Sanskrit) a vehicle in Indian myth [n -S]\n",
  "VAHANAS": "VAHANA, (Sanskrit) a vehicle in Indian myth [n]\n",
  "VAHINE": "(Tahitian) a woman [n -S]\n",
  "VAHINES": "VAHINE, (Tahitian) a woman [n]\n",
  "VAIL": "(archaic) to lower, doff, let down [v -ED, -ING, -S]\n",
  "VAILED": "VAIL, (archaic) to lower, doff, let down [v]\n",
  "VAILING": "VAIL, (archaic) to lower, doff, let down [v]\n",
  "VAILS": "VAIL, (archaic) to lower, doff, let down [v]\n",
  "VAIN": "filled with undue admiration for oneself [adj VAINER, VAINEST, VAINLY]\n",
  "VAINER": "VAIN, filled with undue admiration for oneself [adj]\n",
  "VAINESSE": "(Spenser) vanity, futility, also VAINNESS [n -S]\n",
  "VAINESSES": "VAINESSE, (Spenser) vanity, futility, also VAINNESS [n]\n",
  "VAINEST": "VAIN, filled with undue admiration for oneself [adj]\n",
  "VAINGLORIED": "VAINGLORY, to boast vainly [v]\n",
  "VAINGLORIES": "VAINGLORY, excessive pride, esp. in one's achievements or abilities [n]\n",
  "VAINGLORIOUS": "marked by vainglory, excessive pride, esp. in one's achievements or abilities [adj VAINGLORIOUSLY]\n",
  "VAINGLORIOUSLY": "VAINGLORIOUS, marked by vainglory, excessive pride, esp. in one's achievements or abilities [adv]\n",
  "VAINGLORY": "excessive pride, esp. in one's achievements or abilities [n VAINGLORIES] / to boast vainly [v VAINGLORIED, VAINGLORYING, VAINGLORIES]\n",
  "VAINGLORYING": "VAINGLORY, to boast vainly [v]\n",
  "VAINLY": "VAIN, filled with undue admiration for oneself [adv]\n",
  "VAINNESS": "the state of being vain [n -ES]\n",
  "VAINNESSES": "VAINNESS, the state of being vain [n]\n",
  "VAIR": "squirrel fur, much used in medieval times, to line and trim robes [n -S]\n",
  "VAIRE": "charged or variegated with vair, squirrel fur, also VAIRY, VERREY, VERRY [adj]\n",
  "VAIRIER": "VAIRY, charged or variegated with vair, squirrel fur, also VAIRE, VERREY, VERRY [adj]\n",
  "VAIRIEST": "VAIRY, charged or variegated with vair, squirrel fur, also VAIRE, VERREY, VERRY [adj]\n",
  "VAIRS": "VAIR, squirrel fur, much used in medieval times, to line and trim robes [n]\n",
  "VAIRY": "charged or variegated with vair, squirrel fur, also VAIRE, VERREY, VERRY [adj VAIRIER, VAIRIEST]\n",
  "VAIVODE": "(Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VOIVODE, WAIVODE, WAIWODE, WAYWODE, WOIWODE [n -S]\n",
  "VAIVODES": "VAIVODE, (Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VOIVODE, WAIVODE, WAIWODE, WAYWODE, WOIWODE [n]\n",
  "VAIVODESHIP": "the office of vaivode [n -S]\n",
  "VAIVODESHIPS": "VAIVODESHIP, the office of vaivode [n]\n",
  "VAJAZZLE": "to adorn the female pubis with glittery spangles [v VAJAZZLED, VAJAZZLING, VAJAZZLES]\n",
  "VAJAZZLED": "VAJAZZLE, to adorn the female pubis with glittery spangles [v]\n",
  "VAJAZZLES": "VAJAZZLE, to adorn the female pubis with glittery spangles [v]\n",
  "VAJAZZLING": "the practice of adorning the female pubis with glittery spangles [n -S]\n",
  "VAJAZZLINGS": "VAJAZZLING, the practice of adorning the female pubis with glittery spangles [n]\n",
  "VAKAS": "(Armenian) a kind of mantle worn by priests in the Armenian church, also VAKASS [n -ES]\n",
  "VAKASES": "VAKAS, (Armenian) a kind of mantle worn by priests in the Armenian church, also VAKASS [n]\n",
  "VAKASS": "(Armenian) a priest's cloak with a metal breastplate, inscribed on which are the names of the twelve apostles, also VAKAS [n -ES]\n",
  "VAKASSES": "VAKASS, (Armenian) a priest's cloak with a metal breastplate, inscribed on which are the names of the twelve apostles, also VAKAS [n]\n",
  "VAKEEL": "(Hindi) a native lawyer in India, also VAKIL [n -S]\n",
  "VAKEELS": "VAKEEL, (Hindi) a native lawyer in India, also VAKIL [n]\n",
  "VAKIL": "(Hindi) a native lawyer in India, also VAKEEL [n -S]\n",
  "VAKILS": "VAKIL, (Hindi) a native lawyer in India, also VAKEEL [n]\n",
  "VALANCE": "a drapery hung along the edge of a bed, table or canopy [n -S] / to drape with a valance [v VALANCED, VALANCING, VALANCES]\n",
  "VALANCED": "VALANCE, to drape with a valance [v]\n",
  "VALANCES": "VALANCE, to drape with a valance [v]\n",
  "VALANCING": "VALANCE, to drape with a valance [v]\n",
  "VALE": "a broad valley [n -S]\n",
  "VALEDICTION": "bidding farewell [n -S]\n",
  "VALEDICTIONS": "VALEDICTION, bidding farewell [n]\n",
  "VALEDICTORIAN": "one who bids farewell, e.g. in the US on leaving school [n -S]\n",
  "VALEDICTORIANS": "VALEDICTORIAN, one who bids farewell, e.g. in the US on leaving school [n]\n",
  "VALEDICTORIES": "VALEDICTORY, a farewell [n]\n",
  "VALEDICTORY": "of or relating to a valediction, expressing or containing a farewell [adj] / a farewell [n VALEDICTORIES]\n",
  "VALENCE": "a chemical bond, also VALENCY [n -S]\n",
  "VALENCES": "VALENCE, a chemical bond, also VALENCY [n]\n",
  "VALENCIA": "a kind of woven fabric for waistcoats [n -S]\n",
  "VALENCIAS": "VALENCIA, a kind of woven fabric for waistcoats [n]\n",
  "VALENCIES": "VALENCY, a chemical bond, also VALENCE [n]\n",
  "VALENCY": "a chemical bond, also VALENCE [n VALENCIES]\n",
  "VALENTINE": "a sweetheart [n -S]\n",
  "VALENTINES": "VALENTINE, a sweetheart [n]\n",
  "VALERATE": "a salt of valeric acid [n -S]\n",
  "VALERATES": "VALERATE, a salt of valeric acid [n]\n",
  "VALERIAN": "a perennial herb [n -S]\n",
  "VALERIANACEOUS": "belonging to the valerian family [adj]\n",
  "VALERIANS": "VALERIAN, a perennial herb [n]\n",
  "VALERIC": "as in valeric acid, a fatty acid [adj]\n",
  "VALES": "VALE, a broad valley [n]\n",
  "VALET": "to act as a personal servant to [v -ED, -ING, -S]\n",
  "VALETA": "(Spanish) a kind of dance in waltz time, also VELETA [n -S]\n",
  "VALETAS": "VALETA, (Spanish) a kind of dance in waltz time, also VELETA [n]\n",
  "VALETE": "(Latin) a farewell, as address to more than one person [n -S]\n",
  "VALETED": "VALET, to act as a personal servant to [v]\n",
  "VALETES": "VALETE, (Latin) a farewell, as address to more than one person [n]\n",
  "VALETING": "the act of being a valet [n -S]\n",
  "VALETINGS": "VALETING, the act of being a valet [n]\n",
  "VALETS": "VALET, to act as a personal servant to [v]\n",
  "VALETUDINARIAN": "a person of weak or sickly constitution [n -S]\n",
  "VALETUDINARIANS": "VALETUDINARIAN, a person of weak or sickly constitution [n]\n",
  "VALETUDINARIES": "VALETUDINARY, a valetudinarian [n]\n",
  "VALETUDINARY": "a valetudinarian [n VALETUDINARIES]\n",
  "VALGOID": "pertaining to valgus, clubfoot, also VALGOUS [adj]\n",
  "VALGOUS": "pertaining to valgus, clubfoot, also VALGOID [adj]\n",
  "VALGUS": "(Latin) the position of a joint that is abnormally turned outward [n -ES]\n",
  "VALGUSES": "VALGUS, (Latin) the position of a joint that is abnormally turned outward [n]\n",
  "VALI": "(Turkish) a governor, esp. of a vilayet, also WALI [n -S]\n",
  "VALIANCE": "courage, also VALOR, VALIANCY, VALOUR [n -S]\n",
  "VALIANCES": "VALIANCE, courage, also VALOR, VALIANCY, VALOUR [n]\n",
  "VALIANCIES": "VALIANCY, valour, also VALIANCE [n]\n",
  "VALIANCY": "valour, also VALIANCE [n VALIANCIES]\n",
  "VALIANT": "brave [adj VALIANTLY] / (obsolete) a valiant person [n -S]\n",
  "VALIANTLY": "VALIANT, brave [adv]\n",
  "VALIANTNESS": "the state of being valiant [n -ES]\n",
  "VALIANTNESSES": "VALIANTNESS, the state of being valiant [n]\n",
  "VALIANTS": "VALIANT, (obsolete) a valiant person [n]\n",
  "VALID": "sound, legally adequate [adj VALIDER, VALIDEST, VALIDLY]\n",
  "VALIDATE": "to give legal force to [v VALIDATED, VALIDATING, VALIDATES]\n",
  "VALIDATED": "VALIDATE, to give legal force to [v]\n",
  "VALIDATES": "VALIDATE, to give legal force to [v]\n",
  "VALIDATING": "VALIDATE, to give legal force to [v]\n",
  "VALIDATION": "an act of validating [n -S]\n",
  "VALIDATIONS": "VALIDATION, an act of validating [n]\n",
  "VALIDATOR": "one who validates [n -S]\n",
  "VALIDATORS": "VALIDATOR, one who validates [n]\n",
  "VALIDATORY": "relating to validation [adj]\n",
  "VALIDER": "VALID, sound, legally adequate [adj]\n",
  "VALIDEST": "VALID, sound, legally adequate [adj]\n",
  "VALIDITIES": "VALIDITY, the state of being valid [n]\n",
  "VALIDITY": "the state of being valid [n VALIDITIES]\n",
  "VALIDLY": "VALID, sound, legally adequate [adv]\n",
  "VALIDNESS": "the state of being valid [n -ES]\n",
  "VALIDNESSES": "VALIDNESS, the state of being valid [n]\n",
  "VALINE": "an amino acid, essential to health and growth in humans and vertebrate animals [n -S]\n",
  "VALINES": "VALINE, an amino acid, essential to health and growth in humans and vertebrate animals [n]\n",
  "VALIS": "VALI, (Turkish) a governor, esp. of a vilayet, also WALI [n]\n",
  "VALISE": "(French) an overnight travelling-bag, also WALISE [n -S]\n",
  "VALISES": "VALISE, (French) an overnight travelling-bag, also WALISE [n]\n",
  "VALIUM": "as in valium picnic, a day on the New York Stock Exchange when business is slow [n -S]\n",
  "VALIUMS": "VALIUM, as in valium picnic, a day on the New York Stock Exchange when business is slow [n]\n",
  "VALKYR": "(Old Norse) a maiden in Norse mythology, also VALKYRIE, WALKYRIE [n -S]\n",
  "VALKYRIE": "(Old Norse) a maiden in Norse mythology, also VALKYR, WALKYRIE [n -S]\n",
  "VALKYRIES": "VALKYRIE, (Old Norse) a maiden in Norse mythology, also VALKYR, WALKYRIE [n]\n",
  "VALKYRS": "VALKYR, (Old Norse) a maiden in Norse mythology, also VALKYRIE, WALKYRIE [n]\n",
  "VALLAR": "(Latin) a Roman circular gold crown which was awarded to the first soldier who broke into the enemy's camp, also VALLARY [n -S]\n",
  "VALLARIES": "VALLARY, (Latin) a Roman circular gold crown which was awarded to the first soldier who broke into the enemy's camp, also VALLAR [n]\n",
  "VALLARS": "VALLAR, (Latin) a Roman circular gold crown which was awarded to the first soldier who broke into the enemy's camp, also VALLARY [n]\n",
  "VALLARY": "(Latin) a Roman circular gold crown which was awarded to the first soldier who broke into the enemy's camp, also VALLAR [n VALLARIES]\n",
  "VALLATE": "having a raised rim or rampart [adj]\n",
  "VALLATION": "the act of building fortifications [n -S]\n",
  "VALLATIONS": "VALLATION, the act of building fortifications [n]\n",
  "VALLECULA": "(Latin) a groove or furrow [n VALLECULAE or VALLECULAS]\n",
  "VALLECULAE": "VALLECULA, (Latin) a groove or furrow [n]\n",
  "VALLECULAR": "pertaining to or like a vallecula, a groove [adj]\n",
  "VALLECULAS": "VALLECULA, (Latin) a groove or furrow [n]\n",
  "VALLECULATE": "shaped like a vallecula [adj]\n",
  "VALLEY": "a depression of the earth's surface [n -S]\n",
  "VALLEYED": "having valleys [adj]\n",
  "VALLEYS": "VALLEY, a depression of the earth's surface [n]\n",
  "VALLHUND": "(Swedish) a Swedish breed of dog [n -S]\n",
  "VALLHUNDS": "VALLHUND, (Swedish) a Swedish breed of dog [n]\n",
  "VALLONIA": "(Italian) a tanning material, made from the acorns of a Levantine oak, also VALONEA, VALONIA [n -S]\n",
  "VALLONIAS": "VALLONIA, (Italian) a tanning material, made from the acorns of a Levantine oak, also VALONEA, VALONIA [n]\n",
  "VALLUM": "(Latin) a rampart; a wall of earth thrown up from a ditch [n -S]\n",
  "VALLUMS": "VALLUM, (Latin) a rampart; a wall of earth thrown up from a ditch [n]\n",
  "VALONEA": "(Italian) a tanning material, made from the acorns of a Levantine oak, also VALLONIA, VALONIA [n -S]\n",
  "VALONEAS": "VALONEA, (Italian) a tanning material, made from the acorns of a Levantine oak, also VALLONIA, VALONIA [n]\n",
  "VALONIA": "(Italian) a tanning material, made from the acorns of a Levantine oak, also VALLONIA, VALONEA [n -S]\n",
  "VALONIAS": "VALONIA, (Italian) a tanning material, made from the acorns of a Levantine oak, also VALLONIA, VALONEA [n]\n",
  "VALOR": "(US) valour [n -S]\n",
  "VALORISATION": "the fixing of prices, esp. by a policy imposed by a government or controlling body, also VALORIZATION [n -S]\n",
  "VALORISATIONS": "VALORISATION, the fixing of prices, esp. by a policy imposed by a government or controlling body, also VALORIZATION [n]\n",
  "VALORISE": "to establish and maintain the price of by government action, also VALORIZE [v VALORISED, VALORISING, VALORISES]\n",
  "VALORISED": "VALORISE, to establish and maintain the price of by government action, also VALORIZE [v]\n",
  "VALORISES": "VALORISE, to establish and maintain the price of by government action, also VALORIZE [v]\n",
  "VALORISING": "VALORISE, to establish and maintain the price of by government action, also VALORIZE [v]\n",
  "VALORIZATION": "the fixing of prices, esp. by a policy imposed by a government or controlling body, also VALORISATION [n -S]\n",
  "VALORIZATIONS": "VALORIZATION, the fixing of prices, esp. by a policy imposed by a government or controlling body, also VALORISATION [n]\n",
  "VALORIZE": "to establish and maintain the price of by government action, also VALORISE [v VALORIZED, VALORIZING, VALORIZES]\n",
  "VALORIZED": "VALORIZE, to establish and maintain the price of by government action, also VALORISE [v]\n",
  "VALORIZES": "VALORIZE, to establish and maintain the price of by government action, also VALORISE [v]\n",
  "VALORIZING": "VALORIZE, to establish and maintain the price of by government action, also VALORISE [v]\n",
  "VALOROUS": "courageous [adj VALOROUSLY]\n",
  "VALOROUSLY": "VALOROUS, courageous [adv]\n",
  "VALORS": "VALOR, (US) valour [n]\n",
  "VALOUR": "courage, also VALOR [n -S]\n",
  "VALOURS": "VALOUR, courage, also VALOR [n]\n",
  "VALPOLICELLA": "a red or rose wine made in the Val Policella district [n -S]\n",
  "VALPOLICELLAS": "VALPOLICELLA, a red or rose wine made in the Val Policella district [n]\n",
  "VALPROATE": "a salt of valproic acid [n -S]\n",
  "VALPROATES": "VALPROATE, a salt of valproic acid [n]\n",
  "VALPROIC": "as in valproic acid, used to treat seizures [adj]\n",
  "VALSE": "(French) to waltz [v VALSED, VALSING, VALSES]\n",
  "VALSED": "VALSE, (French) to waltz [v]\n",
  "VALSES": "VALSE, (French) to waltz [v]\n",
  "VALSING": "VALSE, (French) to waltz [v]\n",
  "VALUABLE": "having value [adj VALUABLY] / a possession of value [n -S]\n",
  "VALUABLENESS": "the state of being valuable [n -ES]\n",
  "VALUABLENESSES": "VALUABLENESS, the state of being valuable [n]\n",
  "VALUABLES": "VALUABLE, a possession of value [n]\n",
  "VALUABLY": "VALUABLE, having value [adv]\n",
  "VALUATE": "to appraise, evaluate [v VALUATED, VALUATING, VALUATES]\n",
  "VALUATED": "VALUATE, to appraise, evaluate [v]\n",
  "VALUATES": "VALUATE, to appraise, evaluate [v]\n",
  "VALUATING": "VALUATE, to appraise, evaluate [v]\n",
  "VALUATION": "the act of valuing [n -S]\n",
  "VALUATIONAL": "relating to valuation [adj VALUATIONALLY]\n",
  "VALUATIONALLY": "VALUATIONAL, relating to valuation [adv]\n",
  "VALUATIONS": "VALUATION, the act of valuing [n]\n",
  "VALUATOR": "an appraiser, also EVALUATOR [n -S]\n",
  "VALUATORS": "VALUATOR, an appraiser, also EVALUATOR [n]\n",
  "VALUE": "to estimate the worth of [v VALUED, VALUING, VALUES]\n",
  "VALUED": "VALUE, to estimate the worth of [v]\n",
  "VALUELESS": "without value [adj]\n",
  "VALUELESSNESS": "the state of being valueless [n -ES]\n",
  "VALUELESSNESSES": "VALUELESSNESS, the state of being valueless [n]\n",
  "VALUER": "one that values [n -S]\n",
  "VALUERS": "VALUER, one that values [n]\n",
  "VALUES": "VALUE, to estimate the worth of [v]\n",
  "VALUING": "VALUE, to estimate the worth of [v]\n",
  "VALUTA": "(Italian) the comparative value of a currency [n -S]\n",
  "VALUTAS": "VALUTA, (Italian) the comparative value of a currency [n]\n",
  "VALVAL": "pertaining to a valve, also VALVAR [adj]\n",
  "VALVAR": "pertaining to a valve, also VALVAL [adj]\n",
  "VALVASSOR": "a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VAVASOR, VAVASOUR, VAVASSOR [n -S]\n",
  "VALVASSORS": "VALVASSOR, a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VAVASOR, VAVASOUR, VAVASSOR [n]\n",
  "VALVATE": "having valves [adj]\n",
  "VALVE": "to provide with a device for controlling the flow of a liquid or gas [v VALVED, VALVING, VALVES]\n",
  "VALVED": "VALVE, to provide with a device for controlling the flow of a liquid or gas [v]\n",
  "VALVELESS": "without valves [adj]\n",
  "VALVELET": "a small valve [n -S]\n",
  "VALVELETS": "VALVELET, a small valve [n]\n",
  "VALVELIKE": "like a valve [adj]\n",
  "VALVES": "VALVE, to provide with a device for controlling the flow of a liquid or gas [v]\n",
  "VALVING": "VALVE, to provide with a device for controlling the flow of a liquid or gas [v]\n",
  "VALVULA": "(Latin) a small valve, also VALVULE [n VALVULAE]\n",
  "VALVULAE": "VALVULA, (Latin) a small valve, also VALVULE [n]\n",
  "VALVULAR": "pertaining to a valve [adj]\n",
  "VALVULE": "a small valve, also VALVULA [n -S]\n",
  "VALVULES": "VALVULE, a small valve, also VALVULA [n]\n",
  "VALVULITIS": "inflammation of a valve, esp. a cardiac valve [n -ES]\n",
  "VALVULITISES": "VALVULITIS, inflammation of a valve, esp. a cardiac valve [n]\n",
  "VAMBRACE": "(historical) a piece of armour designed to protect the arm from the elbow to the wrist, also VANTBRACE, VANTBRASS [n -S]\n",
  "VAMBRACED": "(historical) wearing a vambrace, a piece of armour designed to protect the arm from the elbow to the wrist [adj]\n",
  "VAMBRACES": "VAMBRACE, (historical) a piece of armour designed to protect the arm from the elbow to the wrist, also VANTBRACE, VANTBRASS [n]\n",
  "VAMOOSE": "to leave quickly, also VAMOSE [v VAMOOSED, VAMOOSING, VAMOOSES]\n",
  "VAMOOSED": "VAMOOSE, to leave quickly, also VAMOSE [v]\n",
  "VAMOOSES": "VAMOOSE, to leave quickly, also VAMOSE [v]\n",
  "VAMOOSING": "VAMOOSE, to leave quickly, also VAMOSE [v]\n",
  "VAMOSE": "to leave quickly, also VAMOOSE [v VAMOSED, VAMOSING, VAMOSES]\n",
  "VAMOSED": "VAMOSE, to leave quickly, also VAMOOSE [v]\n",
  "VAMOSES": "VAMOSE, to leave quickly, also VAMOOSE [v]\n",
  "VAMOSING": "VAMOSE, to leave quickly, also VAMOOSE [v]\n",
  "VAMP": "to repair or patch [v -ED, -ING, -S]\n",
  "VAMPED": "VAMP, to repair or patch [v]\n",
  "VAMPER": "one who vamps; one who pieces an old thing with something new [n -S]\n",
  "VAMPERS": "VAMPER, one who vamps; one who pieces an old thing with something new [n]\n",
  "VAMPIER": "VAMPY, like a vamp, also VAMPISH [adj]\n",
  "VAMPIEST": "VAMPY, like a vamp, also VAMPISH [adj]\n",
  "VAMPING": "the patching of something [n -S]\n",
  "VAMPINGS": "VAMPING, the patching of something [n]\n",
  "VAMPIRE": "to prey upon [v VAMPIRED, VAMPIRING, VAMPIRES]\n",
  "VAMPIRED": "VAMPIRE, to prey upon [v]\n",
  "VAMPIRES": "VAMPIRE, to prey upon [v]\n",
  "VAMPIRIC": "like a vampire [adj]\n",
  "VAMPIRING": "VAMPIRE, to prey upon [v]\n",
  "VAMPIRISE": "to play the vampire, also VAMPIRIZE [v VAMPIRISED, VAMPIRISING, VAMPIRISES]\n",
  "VAMPIRISED": "VAMPIRISE, to play the vampire, also VAMPIRIZE [v]\n",
  "VAMPIRISES": "VAMPIRISE, to play the vampire, also VAMPIRIZE [v]\n",
  "VAMPIRISH": "like a vampire [adj]\n",
  "VAMPIRISING": "VAMPIRISE, to play the vampire, also VAMPIRIZE [v]\n",
  "VAMPIRISM": "the practice of a vampire [n -S]\n",
  "VAMPIRISMS": "VAMPIRISM, the practice of a vampire [n]\n",
  "VAMPIRIZE": "to play the vampire, also VAMPIRISE [v VAMPIRIZED, VAMPIRIZING, VAMPIRIZES]\n",
  "VAMPIRIZED": "VAMPIRIZE, to play the vampire, also VAMPIRISE [v]\n",
  "VAMPIRIZES": "VAMPIRIZE, to play the vampire, also VAMPIRISE [v]\n",
  "VAMPIRIZING": "VAMPIRIZE, to play the vampire, also VAMPIRISE [v]\n",
  "VAMPISH": "like a vamp, sultry, seductive, also VAMPY [adj VAMPISHLY]\n",
  "VAMPISHLY": "VAMPISH, like a vamp, sultry, seductive, also VAMPY [adv]\n",
  "VAMPLATE": "a hand guard [n -S]\n",
  "VAMPLATES": "VAMPLATE, a hand guard [n]\n",
  "VAMPS": "VAMP, to repair or patch [v]\n",
  "VAMPY": "like a vamp, also VAMPISH [adj VAMPIER, VAMPIEST]\n",
  "VAN": "to transport in a type of motor vehicle [v VANNED, VANNING, VANS]\n",
  "VANADATE": "a salt of vanadic acid, also VANADIATE [n -S]\n",
  "VANADATES": "VANADATE, a salt of vanadic acid, also VANADIATE [n]\n",
  "VANADIATE": "a salt of vanadic acid, also VANADATE [n -S]\n",
  "VANADIATES": "VANADIATE, a salt of vanadic acid, also VANADATE [n]\n",
  "VANADIC": "pertaining to vanadium, also VANADOUS [adj]\n",
  "VANADINITE": "a mineral consisting of lead vanadate with a small proportion of lead chloride [n -S]\n",
  "VANADINITES": "VANADINITE, a mineral consisting of lead vanadate with a small proportion of lead chloride [n]\n",
  "VANADIUM": "a silvery metallic element [n -S]\n",
  "VANADIUMS": "VANADIUM, a silvery metallic element [n]\n",
  "VANADOUS": "pertaining to vanadium, also VANADIC [adj]\n",
  "VANASPATI": "(Sanskrit) a hydrogenated vegetable fat used as a butter substitute [n -S]\n",
  "VANASPATIS": "VANASPATI, (Sanskrit) a hydrogenated vegetable fat used as a butter substitute [n]\n",
  "VANCOMYCIN": "an antibiotic drug obtained from the bacterium Streptomyces orientalis, used against bacteria that are resistant to other antibiotics [n -S]\n",
  "VANCOMYCINS": "VANCOMYCIN, an antibiotic drug obtained from the bacterium Streptomyces orientalis, used against bacteria that are resistant to other antibiotics [n]\n",
  "VANDA": "(Hindi) a kind of tropical orchid [n -S]\n",
  "VANDAL": "one who destroys or defaces property [n -S]\n",
  "VANDALIC": "resembling the Vandals in barbarism and destructiveness [adj]\n",
  "VANDALISATION": "the act of vandalising, also VANDALIZATION [n -S]\n",
  "VANDALISATIONS": "VANDALISATION, the act of vandalising, also VANDALIZATION [n]\n",
  "VANDALISE": "to deal with or treat in a vandalistic manner, also VANDALIZE [v VANDALISED, VANDALISING, VANDALISES]\n",
  "VANDALISED": "VANDALISE, to deal with or treat in a vandalistic manner, also VANDALIZE [v]\n",
  "VANDALISES": "VANDALISE, to deal with or treat in a vandalistic manner, also VANDALIZE [v]\n",
  "VANDALISH": "like a vandal [adj]\n",
  "VANDALISING": "VANDALISE, to deal with or treat in a vandalistic manner, also VANDALIZE [v]\n",
  "VANDALISM": "wanton damage [n -S]\n",
  "VANDALISMS": "VANDALISM, wanton damage [n]\n",
  "VANDALISTIC": "of or relating to vandalism [adj]\n",
  "VANDALIZATION": "the act of vandalizing, also VANDALISATION [n -S]\n",
  "VANDALIZATIONS": "VANDALIZATION, the act of vandalizing, also VANDALISATION [n]\n",
  "VANDALIZE": "to deal with or treat in a vandalistic manner, also VANDALISE [v VANDALIZED, VANDALIZING, VANDALIZES]\n",
  "VANDALIZED": "VANDALIZE, to deal with or treat in a vandalistic manner, also VANDALISE [v]\n",
  "VANDALIZES": "VANDALIZE, to deal with or treat in a vandalistic manner, also VANDALISE [v]\n",
  "VANDALIZING": "VANDALIZE, to deal with or treat in a vandalistic manner, also VANDALISE [v]\n",
  "VANDALS": "VANDAL, one who destroys or defaces property [n]\n",
  "VANDAS": "VANDA, (Hindi) a kind of tropical orchid [n]\n",
  "VANDYKE": "to notch or zigzag [v VANDYKED, VANDYKING, VANDYKES]\n",
  "VANDYKED": "VANDYKE, to notch or zigzag [v]\n",
  "VANDYKES": "VANDYKE, to notch or zigzag [v]\n",
  "VANDYKING": "VANDYKE, to notch or zigzag [v]\n",
  "VANE": "a device for showing the direction of the wind [n -S]\n",
  "VANED": "having a vane [adj]\n",
  "VANELESS": "without a vane [adj]\n",
  "VANES": "VANE, a device for showing the direction of the wind [n]\n",
  "VANESSA": "(Greek) a butterfly of the red admiral genus Vanessa, also VANESSID [n -S]\n",
  "VANESSAS": "VANESSA, (Greek) a butterfly of the red admiral genus Vanessa, also VANESSID [n]\n",
  "VANESSID": "a butterfly of the red admiral genus Vanessa, also VANESSA [n -S]\n",
  "VANESSIDS": "VANESSID, a butterfly of the red admiral genus Vanessa, also VANESSA [n]\n",
  "VANG": "a guy-rope to steady a gaff [n -S]\n",
  "VANGS": "VANG, a guy-rope to steady a gaff [n]\n",
  "VANGUARD": "the forefront of a movement, also VANT [n -S]\n",
  "VANGUARDISM": "the condition of being or practice of positioning oneself as or within the vanguard of a movement, esp. political [n -S]\n",
  "VANGUARDISMS": "VANGUARDISM, the condition of being or practice of positioning oneself as or within the vanguard of a movement, esp. political [n]\n",
  "VANGUARDIST": "a practitioner of vanguardism [n -S]\n",
  "VANGUARDISTS": "VANGUARDIST, a practitioner of vanguardism [n]\n",
  "VANGUARDS": "VANGUARD, the forefront of a movement, also VANT [n]\n",
  "VANILLA": "(Spanish) a fragrant substance obtained from dried vanilla pods [n -S]\n",
  "VANILLAS": "VANILLA, (Spanish) a fragrant substance obtained from dried vanilla pods [n]\n",
  "VANILLIC": "pertaining to, or derived from, vanilla [adj]\n",
  "VANILLIN": "a white crystalline aldehyde having a burning taste and characteristic odor of vanilla, extracted from vanilla pods [n -S]\n",
  "VANILLINS": "VANILLIN, a white crystalline aldehyde having a burning taste and characteristic odor of vanilla, extracted from vanilla pods [n]\n",
  "VANISH": "to disappear, also EVANISH [v -ED, -ING, -ES]\n",
  "VANISHED": "VANISH, to disappear, also EVANISH [v]\n",
  "VANISHER": "one who vanishes [n -S]\n",
  "VANISHERS": "VANISHER, one who vanishes [n]\n",
  "VANISHES": "VANISH, to disappear, also EVANISH [v]\n",
  "VANISHING": "disappearing [adj VANISHINGLY] / the act of vanishing [n -S]\n",
  "VANISHINGLY": "VANISHING, disappearing [adv]\n",
  "VANISHINGS": "VANISHING, the act of vanishing [n]\n",
  "VANISHMENT": "a vanishing [n -S]\n",
  "VANISHMENTS": "VANISHMENT, a vanishing [n]\n",
  "VANITAS": "(Latin) a 17th century Dutch still life painting featuring a memento mori etc. [n -ES]\n",
  "VANITASES": "VANITAS, (Latin) a 17th century Dutch still life painting featuring a memento mori etc. [n]\n",
  "VANITIED": "full of vanity [adj]\n",
  "VANITIES": "VANITY, inflated pride in oneself [n]\n",
  "VANITORIES": "VANITORY, a combined dressing table and basin [n]\n",
  "VANITORY": "a combined dressing table and basin [n VANITORIES]\n",
  "VANITY": "inflated pride in oneself [n VANITIES]\n",
  "VANLIKE": "like a van [adj]\n",
  "VANLOAD": "the quantity that a van can carry [n -S]\n",
  "VANLOADS": "VANLOAD, the quantity that a van can carry [n]\n",
  "VANMAN": "a man who drives a van [n VANMEN]\n",
  "VANMEN": "VANMAN, a man who drives a van [n]\n",
  "VANNED": "VAN, to transport in a type of motor vehicle [v]\n",
  "VANNER": "a person who owns a van [n -S]\n",
  "VANNERS": "VANNER, a person who owns a van [n]\n",
  "VANNING": "a process by which ores are washed on a shovel, or in a vanner [n -S]\n",
  "VANNINGS": "VANNING, a process by which ores are washed on a shovel, or in a vanner [n]\n",
  "VANPOOL": "an arrangement whereby several commuters travel in one van [n -S]\n",
  "VANPOOLING": "the practice of sharing a van [n -S]\n",
  "VANPOOLINGS": "VANPOOLING, the practice of sharing a van [n]\n",
  "VANPOOLS": "VANPOOL, an arrangement whereby several commuters travel in one van [n]\n",
  "VANQUISH": "to defeat in battle [v -ED, -ING, -ES]\n",
  "VANQUISHABLE": "able to be vanquished [adj]\n",
  "VANQUISHED": "VANQUISH, to defeat in battle [v]\n",
  "VANQUISHER": "one who vanquishes [n -S]\n",
  "VANQUISHERS": "VANQUISHER, one who vanquishes [n]\n",
  "VANQUISHES": "VANQUISH, to defeat in battle [v]\n",
  "VANQUISHING": "VANQUISH, to defeat in battle [v]\n",
  "VANQUISHMENT": "the act of vanquishing [n -S]\n",
  "VANQUISHMENTS": "VANQUISHMENT, the act of vanquishing [n]\n",
  "VANS": "VAN, to transport in a type of motor vehicle [v]\n",
  "VANT": "(Shakespeare) van, vanguard [n -S]\n",
  "VANTAGE": "(Spenser) to benefit [v VANTAGED, VANTAGING, VANTAGES]\n",
  "VANTAGED": "VANTAGE, (Spenser) to benefit [v]\n",
  "VANTAGELESS": "without vantage [adj]\n",
  "VANTAGES": "VANTAGE, (Spenser) to benefit [v]\n",
  "VANTAGING": "VANTAGE, (Spenser) to benefit [v]\n",
  "VANTBRACE": "(historical) a piece of armour designed to protect the arm from the elbow to the wrist, also VAMBRACE, VANTBRASS [n -S]\n",
  "VANTBRACES": "VANTBRACE, (historical) a piece of armour designed to protect the arm from the elbow to the wrist, also VAMBRACE, VANTBRASS [n]\n",
  "VANTBRASS": "(Milton) armour for the forearm, also VAMBRACE, VANTBRACE [n -ES]\n",
  "VANTBRASSES": "VANTBRASS, (Milton) armour for the forearm, also VAMBRACE, VANTBRACE [n]\n",
  "VANTS": "VANT, (Shakespeare) van, vanguard [n]\n",
  "VANWARD": "located in the van, advanced [adj]\n",
  "VAPE": "to inhale nicotine vapour (from an electronic cigarette) [v VAPED, VAPING, VAPES]\n",
  "VAPED": "VAPE, to inhale nicotine vapour (from an electronic cigarette) [v]\n",
  "VAPER": "one who vapes, inhales nicotine vapour from an electronic cigarette [n -S]\n",
  "VAPERS": "VAPER, one who vapes, inhales nicotine vapour from an electronic cigarette [n]\n",
  "VAPES": "VAPE, to inhale nicotine vapour (from an electronic cigarette) [v]\n",
  "VAPID": "empty [adj VAPIDER, VAPIDEST, VAPIDLY]\n",
  "VAPIDER": "VAPID, empty [adj]\n",
  "VAPIDEST": "VAPID, empty [adj]\n",
  "VAPIDITIES": "VAPIDITY, the state of being vapid [n]\n",
  "VAPIDITY": "the state of being vapid [n VAPIDITIES]\n",
  "VAPIDLY": "VAPID, empty [adv]\n",
  "VAPIDNESS": "the state of being vapid [n -ES]\n",
  "VAPIDNESSES": "VAPIDNESS, the state of being vapid [n]\n",
  "VAPING": "the practice of inhaling nicotine vapour (from an electronic cigarette) [n -S]\n",
  "VAPINGS": "VAPING, the practice of inhaling nicotine vapour (from an electronic cigarette) [n]\n",
  "VAPOR": "mist, fume or smoke [n -S] / to turn into vapor, also VAPOUR [v -ED, -ING, -S]\n",
  "VAPORABILITIES": "VAPORABILITY, the capacity to be vaporised, also VAPOURABILITY [n]\n",
  "VAPORABILITY": "the capacity to be vaporised, also VAPOURABILITY [n VAPORABILITIES]\n",
  "VAPORABLE": "that can be vaporized, also VAPORIZABLE, VAPOURABLE [adj]\n",
  "VAPORED": "VAPOR, to turn into vapor, also VAPOUR [v]\n",
  "VAPORER": "one that vapors, also VAPOURER [n -S]\n",
  "VAPORERS": "VAPORER, one that vapors, also VAPOURER [n]\n",
  "VAPORESCENCE": "becoming vapour [n -S]\n",
  "VAPORESCENCES": "VAPORESCENCE, becoming vapour [n]\n",
  "VAPORESCENT": "forming vapor [adj]\n",
  "VAPORETTI": "VAPORETTO, (Italian) a motorboat serving as a canal bus in Venice [n]\n",
  "VAPORETTO": "(Italian) a motorboat serving as a canal bus in Venice [n VAPORETTOS or VAPORETTI]\n",
  "VAPORETTOS": "VAPORETTO, (Italian) a motorboat serving as a canal bus in Venice [n]\n",
  "VAPORIER": "VAPORY, full of vapors; vaporous, also VAPOURY [adj]\n",
  "VAPORIEST": "VAPORY, full of vapors; vaporous, also VAPOURY [adj]\n",
  "VAPORIFIC": "vaporizing [adj]\n",
  "VAPORIFORM": "existing in a vaporous form or state [adj]\n",
  "VAPORIMETER": "instrument for measuring vapour pressure [n -S]\n",
  "VAPORIMETERS": "VAPORIMETER, instrument for measuring vapour pressure [n]\n",
  "VAPORING": "boastful talk [n -S]\n",
  "VAPORINGS": "VAPORING, boastful talk [n]\n",
  "VAPORISABLE": "capable of being vaporised [adj]\n",
  "VAPORISATION": "the act of vaporising, also VAPORIZATION [n -S]\n",
  "VAPORISATIONS": "VAPORISATION, the act of vaporising, also VAPORIZATION [n]\n",
  "VAPORISE": "to turn into vapor, also VAPORIZE [v VAPORISED, VAPORISING, VAPORISES]\n",
  "VAPORISED": "VAPORISE, to turn into vapor, also VAPORIZE [v]\n",
  "VAPORISER": "something that vaporises, also VAPORIZER [n -S]\n",
  "VAPORISERS": "VAPORISER, something that vaporises, also VAPORIZER [n]\n",
  "VAPORISES": "VAPORISE, to turn into vapor, also VAPORIZE [v]\n",
  "VAPORISH": "resembling or suggestive of vapours, also VAPOURISH [adj]\n",
  "VAPORISHNESS": "the state of being vaporish [n -ES]\n",
  "VAPORISHNESSES": "VAPORISHNESS, the state of being vaporish [n]\n",
  "VAPORISING": "VAPORISE, to turn into vapor, also VAPORIZE [v]\n",
  "VAPORIZABLE": "that can be vaporized, also VAPORABLE, VAPOURABLE [adj]\n",
  "VAPORIZATION": "the act of vaporizing, also VAPORISATION [n -S]\n",
  "VAPORIZATIONS": "VAPORIZATION, the act of vaporizing, also VAPORISATION [n]\n",
  "VAPORIZE": "to turn into vapor, also VAPORISE [v VAPORIZED, VAPORIZING, VAPORIZES]\n",
  "VAPORIZED": "VAPORIZE, to turn into vapor, also VAPORISE [v]\n",
  "VAPORIZER": "something that vaporises, also VAPORISER [n -S]\n",
  "VAPORIZERS": "VAPORIZER, something that vaporises, also VAPORISER [n]\n",
  "VAPORIZES": "VAPORIZE, to turn into vapor, also VAPORISE [v]\n",
  "VAPORIZING": "VAPORIZE, to turn into vapor, also VAPORISE [v]\n",
  "VAPORLESS": "without vapor, also VAPOURLESS [adj]\n",
  "VAPORLIKE": "like vapor [adj]\n",
  "VAPOROSITIES": "VAPOROSITY, the state of being vaporous [n]\n",
  "VAPOROSITY": "the state of being vaporous [n VAPOROSITIES]\n",
  "VAPOROUS": "like vapour, also VAPOUROUS [adj]\n",
  "VAPOROUSLY": "VAPOROUS, like vapour, also VAPOUROUS [adv]\n",
  "VAPOROUSNESS": "the state of being vaporous [n -ES]\n",
  "VAPOROUSNESSES": "VAPOROUSNESS, the state of being vaporous [n]\n",
  "VAPORS": "VAPOR, mist, fume or smoke [n]\n",
  "VAPORWARE": "a computer-related product that has been widely advertised but has not and may never become available, also VAPOURWARE [n -S]\n",
  "VAPORWARES": "VAPORWARE, a computer-related product that has been widely advertised but has not and may never become available, also VAPOURWARE [n]\n",
  "VAPORY": "full of vapors; vaporous, also VAPOURY [adj VAPORIER, VAPORIEST]\n",
  "VAPOUR": "mist, fume or smoke [n -S] / to turn into vapour, also VAPOR [v -ED, -ING, -S]\n",
  "VAPOURABILITIES": "VAPOURABILITY, the capacity to be vaporised, also VAPORABILITY [n]\n",
  "VAPOURABILITY": "the capacity to be vaporised, also VAPORABILITY [n VAPOURABILITIES]\n",
  "VAPOURABLE": "that can be vaporized, also VAPORABLE, VAPORIZABLE [adj]\n",
  "VAPOURED": "VAPOUR, to turn into vapour, also VAPOR [v]\n",
  "VAPOURER": "one that vapours, also VAPORER [n -S]\n",
  "VAPOURERS": "VAPOURER, one that vapours, also VAPORER [n]\n",
  "VAPOURIER": "VAPOURY, full of vapour; affected with the vapours, also VAPORY [adj]\n",
  "VAPOURIEST": "VAPOURY, full of vapour; affected with the vapours, also VAPORY [adj]\n",
  "VAPOURING": "vaporous [adj VAPOURINGLY] / the act of vapouring [n -S]\n",
  "VAPOURINGLY": "VAPOURING, vaporous [adv]\n",
  "VAPOURINGS": "VAPOURING, the act of vapouring [n]\n",
  "VAPOURISH": "resembling or suggestive of vapours, also VAPORISH [adj]\n",
  "VAPOURISHNESS": "the state of being vapourish [n -ES]\n",
  "VAPOURISHNESSES": "VAPOURISHNESS, the state of being vapourish [n]\n",
  "VAPOURLESS": "without vapour, also VAPORLESS [adj]\n",
  "VAPOUROUS": "like vapour, also VAPOROUS [adj]\n",
  "VAPOURS": "VAPOUR, to turn into vapour, also VAPOR [v]\n",
  "VAPOURWARE": "a computer-related product that has been widely advertised but has not and may never become available, also VAPORWARE [n -S]\n",
  "VAPOURWARES": "VAPOURWARE, a computer-related product that has been widely advertised but has not and may never become available, also VAPORWARE [n]\n",
  "VAPOURY": "full of vapour; affected with the vapours, also VAPORY [adj VAPOURIER, VAPOURIEST]\n",
  "VAPULATE": "to flog; to be flogged [v VAPULATED, VAPULATING, VAPULATES]\n",
  "VAPULATED": "VAPULATE, to flog; to be flogged [v]\n",
  "VAPULATES": "VAPULATE, to flog; to be flogged [v]\n",
  "VAPULATING": "VAPULATE, to flog; to be flogged [v]\n",
  "VAPULATION": "the act of beating or whipping [n -S]\n",
  "VAPULATIONS": "VAPULATION, the act of beating or whipping [n]\n",
  "VAQUERO": "(Spanish) one who has charge of cattle, horses, etc. [n -S]\n",
  "VAQUEROS": "VAQUERO, (Spanish) one who has charge of cattle, horses, etc. [n]\n",
  "VAR": "a unit of reactive power [n -S]\n",
  "VARA": "(Spanish) a Spanish American linear measure, also VARE [n -S]\n",
  "VARACTOR": "a two-electrode semiconductor device [n -S]\n",
  "VARACTORS": "VARACTOR, a two-electrode semiconductor device [n]\n",
  "VARAN": "(Arabic) a monitor lizard [n -S]\n",
  "VARANS": "VARAN, (Arabic) a monitor lizard [n]\n",
  "VARAS": "VARA, (Spanish) a Spanish American linear measure, also VARE [n]\n",
  "VARDIES": "VARDY, (archaic) an opinion, verdict [n]\n",
  "VARDY": "(archaic) an opinion, verdict [n VARDIES]\n",
  "VARE": "(Spanish) a Spanish American linear measure, also VARA [n -S]\n",
  "VAREC": "a kind of seaweed, aka kelp, also VARECH, VRAIC [n -S]\n",
  "VARECH": "a kind of seaweed, aka kelp, also VAREC, VRAIC [n -S]\n",
  "VARECHS": "VARECH, a kind of seaweed, aka kelp, also VAREC, VRAIC [n]\n",
  "VARECS": "VAREC, a kind of seaweed, aka kelp, also VARECH, VRAIC [n]\n",
  "VARENYKY": "(Russian) Ukrainian stuffed dumplings [n]\n",
  "VARES": "VARE, (Spanish) a Spanish American linear measure, also VARA [n]\n",
  "VAREUSE": "(French) a kind of loose jacket [n -S]\n",
  "VAREUSES": "VAREUSE, (French) a kind of loose jacket [n]\n",
  "VARGUENO": "(Spanish) a cabinet or desk of a kind made at Vargas near Toledo [n -S]\n",
  "VARGUENOS": "VARGUENO, (Spanish) a cabinet or desk of a kind made at Vargas near Toledo [n]\n",
  "VARIA": "(Latin) a literary miscellany [n -S]\n",
  "VARIABILITIES": "VARIABILITY, the state of being variable [n]\n",
  "VARIABILITY": "the state of being variable [n VARIABILITIES]\n",
  "VARIABLE": "liable to vary [adj VARIABLY] / something that varies [n -S]\n",
  "VARIABLENESS": "the state of being variable [n -ES]\n",
  "VARIABLENESSES": "VARIABLENESS, the state of being variable [n]\n",
  "VARIABLES": "VARIABLE, something that varies [n]\n",
  "VARIABLY": "VARIABLE, liable to vary [adv]\n",
  "VARIANCE": "a deviation or alteration [n -S]\n",
  "VARIANCES": "VARIANCE, a deviation or alteration [n]\n",
  "VARIANT": "something that differs from a standard or type [n -S]\n",
  "VARIANTS": "VARIANT, something that differs from a standard or type [n]\n",
  "VARIAS": "VARIA, (Latin) a literary miscellany [n]\n",
  "VARIATE": "to change, vary [v VARIATED, VARIATING, VARIATES]\n",
  "VARIATED": "VARIATE, to change, vary [v]\n",
  "VARIATES": "VARIATE, to change, vary [v]\n",
  "VARIATING": "VARIATE, to change, vary [v]\n",
  "VARIATION": "a varying, change [n -S]\n",
  "VARIATIONAL": "relating to variation, also VARIATIVE [adj VARIATIONALLY]\n",
  "VARIATIONALLY": "VARIATIONAL, relating to variation, also VARIATIVE [adv]\n",
  "VARIATIONIST": "a composer of variations; a person who attaches importance to variation [n -S]\n",
  "VARIATIONISTS": "VARIATIONIST, a composer of variations; a person who attaches importance to variation [n]\n",
  "VARIATIONS": "VARIATION, a varying, change [n]\n",
  "VARIATIVE": "relating to variation, also VARIATIONAL [adj]\n",
  "VARICEAL": "of or relating to a varix [adj]\n",
  "VARICELLA": "(Latin) chickenpox [n -S]\n",
  "VARICELLAR": "of or like varicella, chickenpox [adj]\n",
  "VARICELLAS": "VARICELLA, (Latin) chickenpox [n]\n",
  "VARICELLATE": "of certain shells, marked on the surface with small ridges [adj]\n",
  "VARICELLOID": "resembling varicella, chicken pox [adj]\n",
  "VARICELLOUS": "relating to varicella, chicken pox [adj]\n",
  "VARICES": "VARIX, (Latin) a varicose vein [n]\n",
  "VARICOCELE": "a varicose enlargement of the veins of the spermatic cord; also, a like enlargement of the veins of the scrotum [n -S]\n",
  "VARICOCELES": "VARICOCELE, a varicose enlargement of the veins of the spermatic cord; also, a like enlargement of the veins of the scrotum [n]\n",
  "VARICOID": "resembling a swollen vein [adj]\n",
  "VARICOLORED": "of different colours, also VARICOLOURED [adj]\n",
  "VARICOLOURED": "of different colours, also VARICOLORED [adj]\n",
  "VARICOSE": "swollen, esp. in irregular lumps and twists, also VARICOSED [adj]\n",
  "VARICOSED": "having varicose veins, also VARICOSE [adj]\n",
  "VARICOSES": "VARICOSIS, any condition characterized by distention of the veins [n]\n",
  "VARICOSIS": "any condition characterized by distention of the veins [n VARICOSES]\n",
  "VARICOSITIES": "VARICOSITY, the state of being varicose [n]\n",
  "VARICOSITY": "the state of being varicose [n VARICOSITIES]\n",
  "VARICOTOMIES": "VARICOTOMY, an incision into a varicose vein [n]\n",
  "VARICOTOMY": "an incision into a varicose vein [n VARICOTOMIES]\n",
  "VARIED": "VARY, to make different [v]\n",
  "VARIEDLY": "VARIED, VARY, to make different [adv]\n",
  "VARIEDNESS": "the state of being varied [n -ES]\n",
  "VARIEDNESSES": "VARIEDNESS, the state of being varied [n]\n",
  "VARIEGATE": "to pattern with multicolour patches [v VARIEGATED, VARIEGATING, VARIEGATES]\n",
  "VARIEGATED": "VARIEGATE, to pattern with multicolour patches [v]\n",
  "VARIEGATES": "VARIEGATE, to pattern with multicolour patches [v]\n",
  "VARIEGATING": "VARIEGATE, to pattern with multicolour patches [v]\n",
  "VARIEGATION": "the act of variegating [n -S]\n",
  "VARIEGATIONS": "VARIEGATION, the act of variegating [n]\n",
  "VARIEGATOR": "something or someone that variegates [n -S]\n",
  "VARIEGATORS": "VARIEGATOR, something or someone that variegates [n]\n",
  "VARIER": "a wanderer; one who strays in search of variety [n -S]\n",
  "VARIERS": "VARIER, a wanderer; one who strays in search of variety [n]\n",
  "VARIES": "VARY, to make different [v]\n",
  "VARIETAL": "of or having the character of a variety [adj VARIETALLY] / a wine from a single variety of grape [n -S]\n",
  "VARIETALLY": "VARIETAL, of or having the character of a variety [adv]\n",
  "VARIETALS": "VARIETAL, a wine from a single variety of grape [n]\n",
  "VARIETIES": "VARIETY, diversity [n]\n",
  "VARIETY": "diversity [n VARIETIES]\n",
  "VARIFOCAL": "of spectacles, having differing focal lengths [n -S]\n",
  "VARIFOCALS": "VARIFOCAL, of spectacles, having differing focal lengths [n]\n",
  "VARIFORM": "having various forms [adj VARIFORMLY]\n",
  "VARIFORMLY": "VARIFORM, having various forms [adv]\n",
  "VARIOLA": "(Latin) smallpox [n -S]\n",
  "VARIOLAR": "of or like variola, smallpox [adj]\n",
  "VARIOLAS": "VARIOLA, (Latin) smallpox [n]\n",
  "VARIOLATE": "to inoculate with smallpox [v VARIOLATED, VARIOLATING, VARIOLATES]\n",
  "VARIOLATED": "VARIOLATE, to inoculate with smallpox [v]\n",
  "VARIOLATES": "VARIOLATE, to inoculate with smallpox [v]\n",
  "VARIOLATING": "VARIOLATE, to inoculate with smallpox [v]\n",
  "VARIOLATION": "inoculation with smallpox [n -S]\n",
  "VARIOLATIONS": "VARIOLATION, inoculation with smallpox [n]\n",
  "VARIOLATOR": "a person who carries out variolation [n -S]\n",
  "VARIOLATORS": "VARIOLATOR, a person who carries out variolation [n]\n",
  "VARIOLE": "a small depression resembling a pockmark [n -S]\n",
  "VARIOLES": "VARIOLE, a small depression resembling a pockmark [n]\n",
  "VARIOLISATION": "inoculation with smallpox virus, also VARIOLIZATION [n -S]\n",
  "VARIOLISATIONS": "VARIOLISATION, inoculation with smallpox virus, also VARIOLIZATION [n]\n",
  "VARIOLITE": "a kind of diorite or diabase containing imbedded whitish spherules, which give the rock a spotted appearance [n -S]\n",
  "VARIOLITES": "VARIOLITE, a kind of diorite or diabase containing imbedded whitish spherules, which give the rock a spotted appearance [n]\n",
  "VARIOLITIC": "of or like variolite [adj]\n",
  "VARIOLIZATION": "inoculation with smallpox virus, also VARIOLISATION [n -S]\n",
  "VARIOLIZATIONS": "VARIOLIZATION, inoculation with smallpox virus, also VARIOLISATION [n]\n",
  "VARIOLOID": "a disease resembling variola, smallpox [n -S]\n",
  "VARIOLOIDS": "VARIOLOID, a disease resembling variola, smallpox [n]\n",
  "VARIOLOUS": "of or pertaining to the smallpox [adj]\n",
  "VARIOMETER": "an instrument for measuring variations in magnetic force [n -S]\n",
  "VARIOMETERS": "VARIOMETER, an instrument for measuring variations in magnetic force [n]\n",
  "VARIORUM": "(Latin) an edition of a text that includes the notes of earlier scholars or editors [n -S]\n",
  "VARIORUMS": "VARIORUM, (Latin) an edition of a text that includes the notes of earlier scholars or editors [n]\n",
  "VARIOUS": "of diverse kinds [adj VARIOUSLY]\n",
  "VARIOUSLY": "VARIOUS, of diverse kinds [adv]\n",
  "VARIOUSNESS": "the state of being various [n -ES]\n",
  "VARIOUSNESSES": "VARIOUSNESS, the state of being various [n]\n",
  "VARISCITE": "an apple-green mineral, a hydrous phosphate of alumina [n -S]\n",
  "VARISCITES": "VARISCITE, an apple-green mineral, a hydrous phosphate of alumina [n]\n",
  "VARISIZED": "in various sizes [adj]\n",
  "VARISTOR": "a semiconductor with resistance varying in accordance with voltage [n -S]\n",
  "VARISTORS": "VARISTOR, a semiconductor with resistance varying in accordance with voltage [n]\n",
  "VARITYPE": "to produce copy on a special typewriter [v VARITYPED, VARITYPING, VARITYPES]\n",
  "VARITYPED": "VARITYPE, to produce copy on a special typewriter [v]\n",
  "VARITYPES": "VARITYPE, to produce copy on a special typewriter [v]\n",
  "VARITYPING": "VARITYPE, to produce copy on a special typewriter [v]\n",
  "VARITYPIST": "one who uses a Varityper machine, a typewriter with variable type [n -S]\n",
  "VARITYPISTS": "VARITYPIST, one who uses a Varityper machine, a typewriter with variable type [n]\n",
  "VARIX": "(Latin) a varicose vein [n VARICES]\n",
  "VARLET": "(archaic) a servant, valet, also VARLETTO [n -S]\n",
  "VARLETESS": "a female varlet [n -ES]\n",
  "VARLETESSES": "VARLETESS, a female varlet [n]\n",
  "VARLETRIES": "VARLETRY, (Shakespeare) a group of common people [n]\n",
  "VARLETRY": "(Shakespeare) a group of common people [n VARLETRIES]\n",
  "VARLETS": "VARLET, (archaic) a servant, valet, also VARLETTO [n]\n",
  "VARLETTO": "(Shakespeare) sham Italian for a varlet [n -S]\n",
  "VARLETTOS": "VARLETTO, (Shakespeare) sham Italian for a varlet [n]\n",
  "VARMENT": "(dialect) a pest, vermin, also VARMINT [n -S]\n",
  "VARMENTS": "VARMENT, (dialect) a pest, vermin, also VARMINT [n]\n",
  "VARMINT": "an animal considered to be a pest, vermin, also VARMENT [n -S]\n",
  "VARMINTS": "VARMINT, an animal considered to be a pest, vermin, also VARMENT [n]\n",
  "VARNA": "(Sanskrit) any of the four great Hindu castes [n -S]\n",
  "VARNAS": "VARNA, (Sanskrit) any of the four great Hindu castes [n]\n",
  "VARNISH": "to give a glossy appearance to [v -ED, -ING, -ES]\n",
  "VARNISHED": "VARNISH, to give a glossy appearance to [v]\n",
  "VARNISHER": "one who varnishes [n -S]\n",
  "VARNISHERS": "VARNISHER, one who varnishes [n]\n",
  "VARNISHES": "VARNISH, to give a glossy appearance to [v]\n",
  "VARNISHIER": "VARNISHY, like varnish [adj]\n",
  "VARNISHIEST": "VARNISHY, like varnish [adj]\n",
  "VARNISHING": "the act of varnishing [n -S]\n",
  "VARNISHINGS": "VARNISHING, the act of varnishing [n]\n",
  "VARNISHY": "like varnish [adj VARNISHIER, VARNISHIEST]\n",
  "VAROOM": "to run an engine at high speed, also VROOM [v -ED, -ING, -S]\n",
  "VAROOMED": "VAROOM, to run an engine at high speed, also VROOM [v]\n",
  "VAROOMING": "VAROOM, to run an engine at high speed, also VROOM [v]\n",
  "VAROOMS": "VAROOM, to run an engine at high speed, also VROOM [v]\n",
  "VARROA": "(Latin) an Asiatic mite which paralyses and kills the honeybee [n -S]\n",
  "VARROAS": "VARROA, (Latin) an Asiatic mite which paralyses and kills the honeybee [n]\n",
  "VARS": "VAR, a unit of reactive power [n]\n",
  "VARSAL": "(colloquial) universal [adj]\n",
  "VARSITIES": "VARSITY, (colloquial) university [n]\n",
  "VARSITY": "(colloquial) university [n VARSITIES]\n",
  "VARSOVIENNE": "(French) a polka-like Polish dance [n -S]\n",
  "VARSOVIENNES": "VARSOVIENNE, (French) a polka-like Polish dance [n]\n",
  "VARTABED": "a member of an Armenian order of clergy [n -S]\n",
  "VARTABEDS": "VARTABED, a member of an Armenian order of clergy [n]\n",
  "VARUS": "(Latin) a malformation of a bone or joint [n -ES]\n",
  "VARUSES": "VARUS, (Latin) a malformation of a bone or joint [n]\n",
  "VARVE": "a seasonal layer of sediment deposited in still water, used in establishing Ice Age chronology [n -S]\n",
  "VARVED": "having a varve deposit [adj]\n",
  "VARVEL": "a ring for a hawk's jess, also VERVEL [n -S]\n",
  "VARVELLED": "having varvels, also VERVELLED [adj]\n",
  "VARVELS": "VARVEL, a ring for a hawk's jess, also VERVEL [n]\n",
  "VARVES": "VARVE, a seasonal layer of sediment deposited in still water, used in establishing Ice Age chronology [n]\n",
  "VARY": "to make different [v VARIED, VARYING, VARIES]\n",
  "VARYING": "the act of varying [n -S]\n",
  "VARYINGLY": "VARYING [adv]\n",
  "VARYINGS": "VARYING, the act of varying [n]\n",
  "VAS": "(Latin) an anatomical duct [n VASA]\n",
  "VASA": "VAS, (Latin) an anatomical duct [n]\n",
  "VASAL": "of or like a vas, a vessel, tube or duct carrying liquid [adj]\n",
  "VASCULA": "VASCULUM, (Latin) a box used to hold plant specimens [n]\n",
  "VASCULAR": "pertaining to ducts that convey body fluids [adj]\n",
  "VASCULARISATION": "the process of becoming vascular, also VASCULARIZATION [n]\n",
  "VASCULARISE": "to cause to become vascular, also VASCULARIZE [v VASCULARISED, VASCULARISING, VASCULARISES]\n",
  "VASCULARISED": "VASCULARISE, to cause to become vascular, also VASCULARIZE [v]\n",
  "VASCULARISES": "VASCULARISE, to cause to become vascular, also VASCULARIZE [v]\n",
  "VASCULARISING": "VASCULARISE, to cause to become vascular, also VASCULARIZE [v]\n",
  "VASCULARITIES": "VASCULARITY, the state of being vascular [n]\n",
  "VASCULARITY": "the state of being vascular [n VASCULARITIES]\n",
  "VASCULARIZATION": "the process of becoming vascular, also VASCULARISATION [n]\n",
  "VASCULARIZE": "to cause to become vascular, also VASCULARISE [v VASCULARIZED, VASCULARIZING, VASCULARIZES]\n",
  "VASCULARIZED": "VASCULARIZE, to cause to become vascular, also VASCULARISE [v]\n",
  "VASCULARIZES": "VASCULARIZE, to cause to become vascular, also VASCULARISE [v]\n",
  "VASCULARIZING": "VASCULARIZE, to cause to become vascular, also VASCULARISE [v]\n",
  "VASCULARLY": "VASCULAR, pertaining to ducts that convey body fluids [adv]\n",
  "VASCULATURE": "the arrangement of blood vessels [n -S]\n",
  "VASCULATURES": "VASCULATURE, the arrangement of blood vessels [n]\n",
  "VASCULIFORM": "shaped like a small vase or flowerpot [adj]\n",
  "VASCULITIDES": "VASCULITIS, inflammation of a blood or lymph vessel [n]\n",
  "VASCULITIS": "inflammation of a blood or lymph vessel [n VASCULITIDES or VASCULITISES]\n",
  "VASCULITISES": "VASCULITIS, inflammation of a blood or lymph vessel [n]\n",
  "VASCULUM": "(Latin) a box used to hold plant specimens [n VASCULUMS or VASCULA]\n",
  "VASCULUMS": "VASCULUM, (Latin) a box used to hold plant specimens [n]\n",
  "VASE": "a container used for holding flowers [n -S]\n",
  "VASECTOMIES": "VASECTOMY, the excision of part or all of the vas deferens, esp. in order to produce sterility [n]\n",
  "VASECTOMISE": "to perform a vasectomy on, also VASECTOMIZE [v VASECTOMISED, VASECTOMISING, VASECTOMISES]\n",
  "VASECTOMISED": "VASECTOMISE, to perform a vasectomy on, also VASECTOMIZE [v]\n",
  "VASECTOMISES": "VASECTOMISE, to perform a vasectomy on, also VASECTOMIZE [v]\n",
  "VASECTOMISING": "VASECTOMISE, to perform a vasectomy on, also VASECTOMIZE [v]\n",
  "VASECTOMIZE": "to perform a vasectomy on, also VASECTOMISE [v VASECTOMIZED, VASECTOMIZING, VASECTOMIZES]\n",
  "VASECTOMIZED": "VASECTOMIZE, to perform a vasectomy on, also VASECTOMISE [v]\n",
  "VASECTOMIZES": "VASECTOMIZE, to perform a vasectomy on, also VASECTOMISE [v]\n",
  "VASECTOMIZING": "VASECTOMIZE, to perform a vasectomy on, also VASECTOMISE [v]\n",
  "VASECTOMY": "the excision of part or all of the vas deferens, esp. in order to produce sterility [n VASECTOMIES]\n",
  "VASEFUL": "the contents of a vase [n -S]\n",
  "VASEFULS": "VASEFUL, the contents of a vase [n]\n",
  "VASELIKE": "like a vase [adj]\n",
  "VASELINE": "to cover or smear with a translucent gelatinous substance obtained from petroleum [v VASELINED, VASELINING, VASELINES]\n",
  "VASELINED": "VASELINE, to cover or smear with a translucent gelatinous substance obtained from petroleum [v]\n",
  "VASELINES": "VASELINE, to cover or smear with a translucent gelatinous substance obtained from petroleum [v]\n",
  "VASELINING": "VASELINE, to cover or smear with a translucent gelatinous substance obtained from petroleum [v]\n",
  "VASES": "VASE, a container used for holding flowers [n]\n",
  "VASIFORM": "having the form of a vase [adj]\n",
  "VASOACTIVE": "affecting blood vessels [adj]\n",
  "VASOACTIVITIES": "VASOACTIVITY, the state of being vasoactive [n]\n",
  "VASOACTIVITY": "the state of being vasoactive [n VASOACTIVITIES]\n",
  "VASOCONSTRICTOR": "an agent (as a sympathetic nerve fiber or a drug) that induces or initiates vasoconstriction [n]\n",
  "VASODILATATION": "dilatation of blood vessels, also VASODILATION [n -S]\n",
  "VASODILATATIONS": "VASODILATATION, dilatation of blood vessels, also VASODILATION [n]\n",
  "VASODILATATORY": "relating to vasodilatation [adj]\n",
  "VASODILATION": "the dilatation of blood vessels, also VASODILATATION [n -S]\n",
  "VASODILATIONS": "VASODILATION, the dilatation of blood vessels, also VASODILATATION [n]\n",
  "VASODILATOR": "a nerve or drug that causes vasodilatation [n -S]\n",
  "VASODILATORS": "VASODILATOR, a nerve or drug that causes vasodilatation [n]\n",
  "VASODILATORY": "relating to a vasodilator, a nerve or drug that causes vasodilatation [adj]\n",
  "VASOINHIBITOR": "any of a group of drugs that reduce or inhibit the action of the vasomotor nerves [n -S]\n",
  "VASOINHIBITORS": "VASOINHIBITOR, any of a group of drugs that reduce or inhibit the action of the vasomotor nerves [n]\n",
  "VASOINHIBITORY": "serving to inhibit the action of the vasomotor nerves [adj]\n",
  "VASOMOTOR": "causing constriction or expansion of blood vessels [adj]\n",
  "VASOPRESSIN": "a pituitary hormone that raises blood pressure, regulates kidney secretion, etc. [n -S]\n",
  "VASOPRESSINS": "VASOPRESSIN, a pituitary hormone that raises blood pressure, regulates kidney secretion, etc. [n]\n",
  "VASOPRESSOR": "a drug causing a rise in blood pressure by exerting a vasoconstrictor effect [n -S]\n",
  "VASOPRESSORS": "VASOPRESSOR, a drug causing a rise in blood pressure by exerting a vasoconstrictor effect [n]\n",
  "VASOSPASM": "a sharp and often persistent spasm of a blood vessel resulting in reduced caliber and flow [n -S]\n",
  "VASOSPASMS": "VASOSPASM, a sharp and often persistent spasm of a blood vessel resulting in reduced caliber and flow [n]\n",
  "VASOSPASTIC": "relating to vasospasm, a sharp spasm of a blood vessel [adj]\n",
  "VASOTOCIN": "a polypeptide pituitary hormone [n -S]\n",
  "VASOTOCINS": "VASOTOCIN, a polypeptide pituitary hormone [n]\n",
  "VASOTOMIES": "VASOTOMY, a surgical cutting of the vas deferens [n]\n",
  "VASOTOMY": "a surgical cutting of the vas deferens [n VASOTOMIES]\n",
  "VASOVAGAL": "of or relating to both vascular or vagal factors [adj]\n",
  "VASSAIL": "(Scott) a vessel, also VESSAIL [n -S]\n",
  "VASSAILS": "VASSAIL, (Scott) a vessel, also VESSAIL [n]\n",
  "VASSAL": "a dependent, a retainer [n -S] / to subject [v VASSALLED, VASSALLING, VASSALS]\n",
  "VASSALAGE": "the state of being a vassal, or feudatory [n -S]\n",
  "VASSALAGES": "VASSALAGE, the state of being a vassal, or feudatory [n]\n",
  "VASSALESS": "a female vassal [n -ES]\n",
  "VASSALESSES": "VASSALESS, a female vassal [n]\n",
  "VASSALISE": "to reduce to the status of a vassal, also VASSALIZE [v VASSALISED, VASSALISING, VASSALISES]\n",
  "VASSALISED": "VASSALISE, to reduce to the status of a vassal, also VASSALIZE [v]\n",
  "VASSALISES": "VASSALISE, to reduce to the status of a vassal, also VASSALIZE [v]\n",
  "VASSALISING": "VASSALISE, to reduce to the status of a vassal, also VASSALIZE [v]\n",
  "VASSALIZE": "to reduce to the status of a vassal, also VASSALISE [v VASSALIZED, VASSALIZING, VASSALIZES]\n",
  "VASSALIZED": "VASSALIZE, to reduce to the status of a vassal, also VASSALISE [v]\n",
  "VASSALIZES": "VASSALIZE, to reduce to the status of a vassal, also VASSALISE [v]\n",
  "VASSALIZING": "VASSALIZE, to reduce to the status of a vassal, also VASSALISE [v]\n",
  "VASSALLED": "VASSAL, to subject [v]\n",
  "VASSALLING": "VASSAL, to subject [v]\n",
  "VASSALRIES": "VASSALRY, vassals collectively [n]\n",
  "VASSALRY": "vassals collectively [n VASSALRIES]\n",
  "VASSALS": "VASSAL, to subject [v]\n",
  "VAST": "huge [adj VASTER, VASTEST, VASTLY] / a vastness [n -S]\n",
  "VASTER": "VAST, huge [adj]\n",
  "VASTEST": "VAST, huge [adj]\n",
  "VASTIDITIES": "VASTIDITY, immensity [n]\n",
  "VASTIDITY": "immensity [n VASTIDITIES]\n",
  "VASTIER": "VASTY, (archaic) vast; immense [adj]\n",
  "VASTIEST": "VASTY, (archaic) vast; immense [adj]\n",
  "VASTITIES": "VASTITY, vastness, also VASTITUDE, VASTNESS [n]\n",
  "VASTITUDE": "vastness, also VASTITY, VASTNESS [n -S]\n",
  "VASTITUDES": "VASTITUDE, vastness, also VASTITY, VASTNESS [n]\n",
  "VASTITY": "vastness, also VASTITUDE, VASTNESS [n VASTITIES]\n",
  "VASTLY": "VAST, huge [adv]\n",
  "VASTNESS": "the state of being vast, also VASTITUDE, VASTITY [n -ES]\n",
  "VASTNESSES": "VASTNESS, the state of being vast, also VASTITUDE, VASTITY [n]\n",
  "VASTS": "VAST, a vastness [n]\n",
  "VASTY": "(archaic) vast; immense [adj VASTIER, VASTIEST]\n",
  "VAT": "to put into a large container for holding liquids [v VATTED, VATTING, VATS]\n",
  "VATABLE": "liable to VAT (value added tax) [adj]\n",
  "VATFUL": "as much as a vat can hold [n -S]\n",
  "VATFULS": "VATFUL, as much as a vat can hold [n]\n",
  "VATIC": "pertaining to a prophet, also VATICAL [adj]\n",
  "VATICAL": "pertaining to a prophet, also VATIC [adj]\n",
  "VATICIDE": "the killing of a prophet [n -S]\n",
  "VATICIDES": "VATICIDE, the killing of a prophet [n]\n",
  "VATICINAL": "of or pertaining to prophecy [adj]\n",
  "VATICINATE": "to prophesy, predict [v VATICINATED, VATICINATING, VATICINATES]\n",
  "VATICINATED": "VATICINATE, to prophesy, predict [v]\n",
  "VATICINATES": "VATICINATE, to prophesy, predict [v]\n",
  "VATICINATING": "VATICINATE, to prophesy, predict [v]\n",
  "VATICINATION": "prophecy [n -S]\n",
  "VATICINATIONS": "VATICINATION, prophecy [n]\n",
  "VATICINATOR": "a prophet [n -S]\n",
  "VATICINATORS": "VATICINATOR, a prophet [n]\n",
  "VATICINATORY": "relating to prophecy [adj]\n",
  "VATMAN": "an employee of the Customs and Excise Board responsible for collecting VAT [n VATMEN]\n",
  "VATMEN": "VATMAN, an employee of the Customs and Excise Board responsible for collecting VAT [n]\n",
  "VATS": "VAT, to put into a large container for holding liquids [v]\n",
  "VATTED": "VAT, to put into a large container for holding liquids [v]\n",
  "VATTER": "one who uses a vat [n -S]\n",
  "VATTERS": "VATTER, one who uses a vat [n]\n",
  "VATTING": "VAT, to put into a large container for holding liquids [v]\n",
  "VATU": "a monetary unit of Vanuatu [n -S]\n",
  "VATUS": "VATU, a monetary unit of Vanuatu [n]\n",
  "VAU": "the sixth letter of the Hebrew alphabet, also VAV, VAW [n -S]\n",
  "VAUCH": "(dialect) to move fast [v VAUCHED, VAUCHING, VAUCHES]\n",
  "VAUCHED": "VAUCH, (dialect) to move fast [v]\n",
  "VAUCHES": "VAUCH, (dialect) to move fast [v]\n",
  "VAUCHING": "VAUCH, (dialect) to move fast [v]\n",
  "VAUDEVILLE": "theatrical entertainment featuring a variety of acts such as songs, dances, comedy, acrobatics, magic, pantomime, etc. [n -S]\n",
  "VAUDEVILLEAN": "a performer or writer of vaudeville, also VAUDEVILLIAN [n -S]\n",
  "VAUDEVILLEANS": "VAUDEVILLEAN, a performer or writer of vaudeville, also VAUDEVILLIAN [n]\n",
  "VAUDEVILLES": "VAUDEVILLE, theatrical entertainment featuring a variety of acts such as songs, dances, comedy, acrobatics, magic, pantomime, etc. [n]\n",
  "VAUDEVILLIAN": "a performer or writer of vaudeville, also VAUDEVILLEAN [n -S]\n",
  "VAUDEVILLIANS": "VAUDEVILLIAN, a performer or writer of vaudeville, also VAUDEVILLEAN [n]\n",
  "VAUDEVILLIST": "a performer or writer of vaudeville [n -S]\n",
  "VAUDEVILLISTS": "VAUDEVILLIST, a performer or writer of vaudeville [n]\n",
  "VAUDOO": "West Indian black magic, also VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n -S]\n",
  "VAUDOOS": "VAUDOO, West Indian black magic, also VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n]\n",
  "VAUDOUX": "West Indian black magic, also VAUDOO, VODOU, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n VAUDOUX]\n",
  "VAULT": "to leap over, also VAUT, VAUTE, VAWTE [v -ED, -ING, -S]\n",
  "VAULTAGE": "a cavern, also VAUNTAGE [n -S]\n",
  "VAULTAGES": "VAULTAGE, a cavern, also VAUNTAGE [n]\n",
  "VAULTED": "VAULT, to leap over, also VAUT, VAUTE, VAWTE [v]\n",
  "VAULTER": "one who vaults [n -S]\n",
  "VAULTERS": "VAULTER, one who vaults [n]\n",
  "VAULTIER": "VAULTY, (Shakespeare) like a vault [adj]\n",
  "VAULTIEST": "VAULTY, (Shakespeare) like a vault [adj]\n",
  "VAULTING": "the act of vaulting [n -S]\n",
  "VAULTINGLY": "VAULTING [adv]\n",
  "VAULTINGS": "VAULTING, the act of vaulting [n]\n",
  "VAULTLIKE": "like a vault [adj]\n",
  "VAULTS": "VAULT, to leap over, also VAUT, VAUTE, VAWTE [v]\n",
  "VAULTY": "(Shakespeare) like a vault [adj VAULTIER, VAULTIEST]\n",
  "VAUNCE": "(Spenser) to advance [v VAUNCED, VAUNCING, VAUNCES]\n",
  "VAUNCED": "VAUNCE, (Spenser) to advance [v]\n",
  "VAUNCES": "VAUNCE, (Spenser) to advance [v]\n",
  "VAUNCING": "VAUNCE, (Spenser) to advance [v]\n",
  "VAUNT": "to boast [v -ED, -ING, -S]\n",
  "VAUNTAGE": "(Spenser) vantage [n -S]\n",
  "VAUNTAGES": "VAUNTAGE, (Spenser) vantage [n]\n",
  "VAUNTED": "VAUNT, to boast [v]\n",
  "VAUNTER": "one who boasts, vaunts [n -S]\n",
  "VAUNTERIES": "VAUNTERY, (archaic) vaunting, boasting [n]\n",
  "VAUNTERS": "VAUNTER, one who boasts, vaunts [n]\n",
  "VAUNTERY": "(archaic) vaunting, boasting [n VAUNTERIES]\n",
  "VAUNTFUL": "given to vaunting or boasting [adj]\n",
  "VAUNTIE": "boastful, also VAUNTY, VAWNTIE [adj VAUNTIER, VAUNTIEST]\n",
  "VAUNTIER": "VAUNTY, boastful, also VAUNTIE, VAWNTIE [adj]\n",
  "VAUNTIEST": "VAUNTY, boastful, also VAUNTIE, VAWNTIE [adj]\n",
  "VAUNTING": "boastful [adj VAUNTINGLY] / the act of vaunting [n -S]\n",
  "VAUNTINGLY": "VAUNTING, boastful [adv]\n",
  "VAUNTINGS": "VAUNTING, the act of vaunting [n]\n",
  "VAUNTS": "VAUNT, to boast [v]\n",
  "VAUNTY": "boastful, also VAUNTIE, VAWNTIE [adj VAUNTIER, VAUNTIEST]\n",
  "VAURIEN": "(French) a good-for-nothing [n -S]\n",
  "VAURIENS": "VAURIEN, (French) a good-for-nothing [n]\n",
  "VAUS": "VAU, the sixth letter of the Hebrew alphabet, also VAV, VAW [n]\n",
  "VAUT": "(obsolete) to vault, also VAUTE, VAWTE [v -ED, -ING, -S]\n",
  "VAUTE": "(obsolete) to vault, also VAUT, VAWTE [v VAUTED, VAUTING, VAUTES]\n",
  "VAUTED": "VAUTE, (obsolete) to vault, also VAUT, VAWTE [v]\n",
  "VAUTES": "VAUTE, (obsolete) to vault, also VAUT, VAWTE [v]\n",
  "VAUTING": "VAUTE, (obsolete) to vault, also VAUT, VAWTE [v]\n",
  "VAUTS": "VAUT, (obsolete) to vault, also VAUTE, VAWTE [v]\n",
  "VAV": "(Hebrew) a letter of the Hebrew alphabet, also VAW [n -S]\n",
  "VAVASOR": "a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VALVASSOR, VAVASOUR, VAVASSOR [n -S]\n",
  "VAVASORIES": "VAVASORY, the tenure or lands of a vavasor [n]\n",
  "VAVASORS": "VAVASOR, a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VALVASSOR, VAVASOUR, VAVASSOR [n]\n",
  "VAVASORY": "the tenure or lands of a vavasor [n VAVASORIES]\n",
  "VAVASOUR": "a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VALVASSOR, VAVASOR, VAVASSOR [n -S]\n",
  "VAVASOURS": "VAVASOUR, a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VALVASSOR, VAVASOR, VAVASSOR [n]\n",
  "VAVASSOR": "a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VALVASSOR, VAVASOR, VAVASOUR [n -S]\n",
  "VAVASSORS": "VAVASSOR, a knight, noble etc. with vassals under him who is himself the vassal of a greater noble, also VALVASSOR, VAVASOR, VAVASOUR [n]\n",
  "VAVS": "VAV, (Hebrew) a letter of the Hebrew alphabet, also VAW [n]\n",
  "VAW": "(Hebrew) a letter of the Hebrew alphabet, also VAV [n -S]\n",
  "VAWARD": "(Shakespeare) the foremost part [n -S]\n",
  "VAWARDS": "VAWARD, (Shakespeare) the foremost part [n]\n",
  "VAWNTIE": "boastful, also VAUNTIE, VAUNTY [adj VAWNTIER, VAWNTIEST]\n",
  "VAWNTIER": "VAWNTIE, boastful, also VAUNTIE, VAUNTY [adj]\n",
  "VAWNTIEST": "VAWNTIE, boastful, also VAUNTIE, VAUNTY [adj]\n",
  "VAWS": "VAW, (Hebrew) a letter of the Hebrew alphabet, also VAV [n]\n",
  "VAWTE": "(obsolete) to vault, also VAUT, VAUTE [v VAWTED, VAWTING, VAWTES]\n",
  "VAWTED": "VAWTE, (obsolete) to vault, also VAUT, VAUTE [v]\n",
  "VAWTES": "VAWTE, (obsolete) to vault, also VAUT, VAUTE [v]\n",
  "VAWTING": "VAWTE, (obsolete) to vault, also VAUT, VAUTE [v]\n",
  "VAX": "(short for) vaccination or vaccine [n -ES]\n",
  "VAXES": "VAX, (short for) vaccination or vaccine [n]\n",
  "VEAL": "the meat of a calf [n -S]\n",
  "VEALE": "(Spenser) to veil, also VELE [v VEALED, VEALING, VEALES]\n",
  "VEALED": "VEALE, (Spenser) to veil, also VELE [v]\n",
  "VEALER": "a calf raised for food [n -S]\n",
  "VEALERS": "VEALER, a calf raised for food [n]\n",
  "VEALES": "VEALE, (Spenser) to veil, also VELE [v]\n",
  "VEALIER": "VEALY, resembling veal or a calf; (figurative) characterized by youthful immaturity [adj]\n",
  "VEALIEST": "VEALY, resembling veal or a calf; (figurative) characterized by youthful immaturity [adj]\n",
  "VEALING": "VEALE, (Spenser) to veil, also VELE [v]\n",
  "VEALS": "VEAL, the meat of a calf [n]\n",
  "VEALY": "resembling veal or a calf; (figurative) characterized by youthful immaturity [adj VEALIER, VEALIEST]\n",
  "VECTOGRAPH": "a picture giving a special effect when viewed through three-dimensional spectacles [n -S]\n",
  "VECTOGRAPHS": "VECTOGRAPH, a picture giving a special effect when viewed through three-dimensional spectacles [n]\n",
  "VECTOR": "to guide in flight by means of radioed directions [v -ED, -ING, -S]\n",
  "VECTORED": "VECTOR, to guide in flight by means of radioed directions [v]\n",
  "VECTORIAL": "of or like a vector [adj VECTORIALLY]\n",
  "VECTORIALLY": "VECTORIAL, of or like a vector [adv]\n",
  "VECTORING": "directing an aircraft in flight to the required destination [n -S]\n",
  "VECTORINGS": "VECTORING, directing an aircraft in flight to the required destination [n]\n",
  "VECTORISATION": "the process of vectorising, also VECTORIZATION [n -S]\n",
  "VECTORISATIONS": "VECTORISATION, the process of vectorising, also VECTORIZATION [n]\n",
  "VECTORISE": "to make into a vector, also VECTORIZE [v VECTORISED, VECTORISING, VECTORISES]\n",
  "VECTORISED": "VECTORISE, to make into a vector, also VECTORIZE [v]\n",
  "VECTORISES": "VECTORISE, to make into a vector, also VECTORIZE [v]\n",
  "VECTORISING": "VECTORISE, to make into a vector, also VECTORIZE [v]\n",
  "VECTORIZATION": "the process of vectorizing, also VECTORISATION [n -S]\n",
  "VECTORIZATIONS": "VECTORIZATION, the process of vectorizing, also VECTORISATION [n]\n",
  "VECTORIZE": "to make into a vector, also VECTORISE [v VECTORIZED, VECTORIZING, VECTORIZES]\n",
  "VECTORIZED": "VECTORIZE, to make into a vector, also VECTORISE [v]\n",
  "VECTORIZES": "VECTORIZE, to make into a vector, also VECTORISE [v]\n",
  "VECTORIZING": "VECTORIZE, to make into a vector, also VECTORISE [v]\n",
  "VECTORS": "VECTOR, to guide in flight by means of radioed directions [v]\n",
  "VECTORSCOPE": "an instrument that displays the phase and amplitude of an applied signal, e.g. of the chrominance signal in colour television [n -S]\n",
  "VECTORSCOPES": "VECTORSCOPE, an instrument that displays the phase and amplitude of an applied signal, e.g. of the chrominance signal in colour television [n]\n",
  "VEDALIA": "an Australian ladybird [n -S]\n",
  "VEDALIAS": "VEDALIA, an Australian ladybird [n]\n",
  "VEDETTE": "(French) a mounted sentry stationed to watch for enemy, also VIDETTE [n -S]\n",
  "VEDETTES": "VEDETTE, (French) a mounted sentry stationed to watch for enemy, also VIDETTE [n]\n",
  "VEDUTA": "(Italian) a panoramic view of a town [n VEDUTE or VEDUTAS]\n",
  "VEDUTAS": "VEDUTA, (Italian) a panoramic view of a town [n]\n",
  "VEDUTE": "VEDUTA, (Italian) a panoramic view of a town [n]\n",
  "VEDUTISTA": "(Italian) a painter of vedute, panoramic views of towns [n VEDUTISTI or or VEDUTISTE or VEDUTISTAS]\n",
  "VEDUTISTAS": "VEDUTISTA, (Italian) a painter of vedute, panoramic views of towns [n]\n",
  "VEDUTISTE": "VEDUTISTA, (Italian) a painter of vedute, panoramic views of towns [n]\n",
  "VEDUTISTI": "VEDUTISTA, (Italian) a painter of vedute, panoramic views of towns [n]\n",
  "VEE": "the letter V [n -S]\n",
  "VEEJAY": "an announcer on a programme of music videos [n -S]\n",
  "VEEJAYS": "VEEJAY, an announcer on a programme of music videos [n]\n",
  "VEENA": "(Sanskrit) an Indian stringed instrument, also VINA [n -S]\n",
  "VEENAS": "VEENA, (Sanskrit) an Indian stringed instrument, also VINA [n]\n",
  "VEEP": "(US colloquial) a vice-president, also VEEPEE [n -S]\n",
  "VEEPEE": "(US colloquial) a vice-president, also VEEP [n -S]\n",
  "VEEPEES": "VEEPEE, (US colloquial) a vice-president, also VEEP [n]\n",
  "VEEPS": "VEEP, (US colloquial) a vice-president, also VEEPEE [n]\n",
  "VEER": "to change direction [v -ED, -ING, -S]\n",
  "VEERED": "VEER, to change direction [v]\n",
  "VEERIES": "VEERY, an American thrush, common in the northern United States and Canada [n]\n",
  "VEERING": "changing direction [adj VEERINGLY] / the act of veering [n -S]\n",
  "VEERINGLY": "VEERING, changing direction [adv]\n",
  "VEERINGS": "VEERING, the act of veering [n]\n",
  "VEERS": "VEER, to change direction [v]\n",
  "VEERY": "an American thrush, common in the northern United States and Canada [n VEERIES]\n",
  "VEES": "VEE, the letter V [n]\n",
  "VEG": "a vegetable [n VEGES or VEGGES] / to laze about [v VEGGED, VEGGING, VEGES]\n",
  "VEGA": "(Spanish) a low fertile plain; a tobacco field [n -S]\n",
  "VEGAN": "one who refrains from consuming (or using) animal products [n -S]\n",
  "VEGANIC": "relating to manuring with material which is purely vegetable organic [adj]\n",
  "VEGANISM": "the practice of eating only plant products [n -S]\n",
  "VEGANISMS": "VEGANISM, the practice of eating only plant products [n]\n",
  "VEGANS": "VEGAN, one who refrains from consuming (or using) animal products [n]\n",
  "VEGAS": "VEGA, (Spanish) a low fertile plain; a tobacco field [n]\n",
  "VEGEBURGER": "a burger with vegetables rather than meat, also VEGGIEBURGER [n -S]\n",
  "VEGEBURGERS": "VEGEBURGER, a burger with vegetables rather than meat, also VEGGIEBURGER [n]\n",
  "VEGELATE": "a kind of chocolate made from vegetable fat and cocoa fat [n -S]\n",
  "VEGELATES": "VEGELATE, a kind of chocolate made from vegetable fat and cocoa fat [n]\n",
  "VEGEMITE": "(colloquial) a child [n -S]\n",
  "VEGEMITES": "VEGEMITE, (colloquial) a child [n]\n",
  "VEGES": "VEG, a vegetable [n]\n",
  "VEGETABLE": "a plant or part of one used for food, other than those considered to be fruits [n -S] / of the nature of a vegetable [adj VEGETABLY]\n",
  "VEGETABLES": "VEGETABLE, a plant or part of one used for food, other than those considered to be fruits [n]\n",
  "VEGETABLIER": "VEGETABLY [adj]\n",
  "VEGETABLIEST": "VEGETABLY [adj]\n",
  "VEGETABLY": "having the nature of a vegetable [adv VEGETABLIER, VEGETABLIEST]\n",
  "VEGETAL": "of or pertaining to vegetables, or the vegetable kingdom [adj VEGETALLY] / a plant or vegetable [n -S]\n",
  "VEGETALLY": "VEGETAL, of or pertaining to vegetables, or the vegetable kingdom [adv]\n",
  "VEGETALS": "VEGETAL, a plant or vegetable [n]\n",
  "VEGETANT": "characteristic of plant life [adj]\n",
  "VEGETARIAN": "one who believes in or practices vegetarianism [n -S]\n",
  "VEGETARIANISM": "the theory or practice of living on a vegetarian diet [n -S]\n",
  "VEGETARIANISMS": "VEGETARIANISM, the theory or practice of living on a vegetarian diet [n]\n",
  "VEGETARIANS": "VEGETARIAN, one who believes in or practices vegetarianism [n]\n",
  "VEGETATE": "to live an inactive or dull life [v VEGETATED, VEGETATING, VEGETATES]\n",
  "VEGETATED": "VEGETATE, to live an inactive or dull life [v]\n",
  "VEGETATES": "VEGETATE, to live an inactive or dull life [v]\n",
  "VEGETATING": "living like a vegetable [n -S]\n",
  "VEGETATINGS": "VEGETATING, living like a vegetable [n]\n",
  "VEGETATION": "the total aggregation of plant communities within an area [n -S]\n",
  "VEGETATIONAL": "relating to vegetation [adj]\n",
  "VEGETATIONS": "VEGETATION, the total aggregation of plant communities within an area [n]\n",
  "VEGETATIOUS": "relating to vegetation [adj]\n",
  "VEGETATIVE": "growing, as plants; reproducing by vegetative organs rather than special structures [adj VEGETATIVELY]\n",
  "VEGETATIVELY": "VEGETATIVE, growing, as plants; reproducing by vegetative organs rather than special structures [adv]\n",
  "VEGETATIVENESS": "the state of being vegetative [n]\n",
  "VEGETE": "vigorous, active [adj]\n",
  "VEGETIST": "one that eats only plant products, also VEGAN [n -S]\n",
  "VEGETISTS": "VEGETIST, one that eats only plant products, also VEGAN [n]\n",
  "VEGETIVE": "(Shakespeare) a plant [n -S]\n",
  "VEGETIVES": "VEGETIVE, (Shakespeare) a plant [n]\n",
  "VEGGED": "VEG, to laze about [v]\n",
  "VEGGES": "VEG, to laze about [v]\n",
  "VEGGIE": "(colloq.) vegetarian [adj VEGGIER, VEGGIEST] / a vegetarian, also VEGIE, VEGO [n VEGGIES]\n",
  "VEGGIEBURGER": "a burger with vegetables rather than meat, also VEGEBURGER [n -S]\n",
  "VEGGIEBURGERS": "VEGGIEBURGER, a burger with vegetables rather than meat, also VEGEBURGER [n]\n",
  "VEGGIER": "VEGGIE, (colloq.) vegetarian [adj]\n",
  "VEGGIES": "VEGGIE, a vegetarian, also VEGIE, VEGO [n]\n",
  "VEGGIEST": "VEGGIE, (colloq.) vegetarian [adj]\n",
  "VEGGING": "VEG, to laze about [v]\n",
  "VEGIE": "(colloq.) of school subjects, trivial, not taxing, also VEGGIE [adj VEGIER, VEGIEST / a vegetarian, also VEGO [n -S]\n",
  "VEGIER": "VEGIE, (colloq.) of school subjects, trivial, not taxing, also VEGGIE [adj]\n",
  "VEGIES": "VEGIE, a vegetarian, also VEGO [n]\n",
  "VEGIEST": "VEGIE, (colloq.) of school subjects, trivial, not taxing, also VEGGIE [adj]\n",
  "VEGO": "(Australian slang) a vegetarian, also VEGGIE, VEGIE [n -S]\n",
  "VEGOS": "VEGO, (Australian slang) a vegetarian, also VEGGIE, VEGIE [n]\n",
  "VEHEMENCE": "urgency, forcefulness, also VEHEMENCY [n -S]\n",
  "VEHEMENCES": "VEHEMENCE, urgency, forcefulness, also VEHEMENCY [n]\n",
  "VEHEMENCIES": "VEHEMENCY, urgency, forcefulness, also VEHEMENCE [n]\n",
  "VEHEMENCY": "urgency, forcefulness, also VEHEMENCE [n VEHEMENCIES]\n",
  "VEHEMENT": "ardent [adj VEHEMENTLY]\n",
  "VEHEMENTLY": "VEHEMENT, ardent [adv]\n",
  "VEHICLE": "a device used as a means of conveyance [n -S]\n",
  "VEHICLES": "VEHICLE, a device used as a means of conveyance [n]\n",
  "VEHICULAR": "of or pertaining to a vehicle [adj]\n",
  "VEHM": "(German) a mediaeval German court, also FEHM [n VEHME]\n",
  "VEHME": "VEHM, (German) a mediaeval German court, also FEHM [n]\n",
  "VEHMIC": "relating to a vehm, a mediaeval German court, also FEHMIC, VEHMIQUE [adj]\n",
  "VEHMIQUE": "relating to a vehm, a mediaeval German court, also FEHMIC, VEHMIC [adj]\n",
  "VEIL": "a covering of fine fabric for the head, face, or both, also VEALE, VELE [n -S] / to cover with a veil [v -ED, -ING, -S]\n",
  "VEILED": "VEIL, to cover with a veil [v]\n",
  "VEILEDLY": "VEILED, VEIL, to cover with a veil [adv]\n",
  "VEILER": "one who veils [n -S]\n",
  "VEILERS": "VEILER, one who veils [n]\n",
  "VEILIER": "VEILY, like a veil, diaphanous [adj]\n",
  "VEILIEST": "VEILY, like a veil, diaphanous [adj]\n",
  "VEILING": "material for making veils [n -S]\n",
  "VEILINGS": "VEILING, material for making veils [n]\n",
  "VEILLESS": "without a veil [adj]\n",
  "VEILLEUSE": "(French) a small, highly-decorated nightlight [n -S]\n",
  "VEILLEUSES": "VEILLEUSE, (French) a small, highly-decorated nightlight [n]\n",
  "VEILLIKE": "like a veil [adj]\n",
  "VEILS": "VEIL, to cover with a veil [v]\n",
  "VEILY": "like a veil, diaphanous [adj VEILIER, VEILIEST]\n",
  "VEIN": "to fill with tubular blood vessels [v -ED, -ING, -S]\n",
  "VEINAL": "pertaining to the veins [adj]\n",
  "VEINED": "VEIN, to fill with tubular blood vessels [v]\n",
  "VEINER": "a tool used in wood carving [n -S]\n",
  "VEINERS": "VEINER, a tool used in wood carving [n]\n",
  "VEINIER": "VEINY, full of veins, also VEINOUS, VENOSE [adj]\n",
  "VEINIEST": "VEINY, full of veins, also VEINOUS, VENOSE [adj]\n",
  "VEINING": "a network of veins [n -S]\n",
  "VEININGS": "VEINING, a network of veins [n]\n",
  "VEINLESS": "without veins [adj]\n",
  "VEINLET": "a small vein, also VEINULE, VEINULET, VENULE [n -S]\n",
  "VEINLETS": "VEINLET, a small vein, also VEINULE, VEINULET, VENULE [n]\n",
  "VEINLIKE": "like a vein [adj]\n",
  "VEINOUS": "full of veins, also VEINY, VENOSE [adj]\n",
  "VEINS": "VEIN, to fill with tubular blood vessels [v]\n",
  "VEINSTONE": "gangue, also VEINSTUFF [n -S]\n",
  "VEINSTONES": "VEINSTONE, gangue, also VEINSTUFF [n]\n",
  "VEINSTUFF": "gangue, also VEINSTONE [n -S]\n",
  "VEINSTUFFS": "VEINSTUFF, gangue, also VEINSTONE [n]\n",
  "VEINULE": "a small vein, also VEINLET, VEINULET, VENULE [n -S]\n",
  "VEINULES": "VEINULE, a small vein, also VEINLET, VEINULET, VENULE [n]\n",
  "VEINULET": "a small veinule, also VEINLET, VEINULE, VENULE [n -S]\n",
  "VEINULETS": "VEINULET, a small veinule, also VEINLET, VEINULE, VENULE [n]\n",
  "VEINY": "full of veins, also VEINOUS, VENOSE [adj VEINIER, VEINIEST]\n",
  "VELA": "VELUM, (Latin) a thin membranous covering or partition, also VELAMEN [n]\n",
  "VELAMEN": "(Latin) a thin membranous covering or partition, also VELUM [n VELAMINA]\n",
  "VELAMINA": "VELAMEN, (Latin) a thin membranous covering or partition, also VELUM [n]\n",
  "VELAR": "a sound produced by the back of the tongue [n -S]\n",
  "VELARIA": "VELARIUM, (Latin) an awning over an ancient Roman theatre [n]\n",
  "VELARIC": "pertaining to the velar [adj]\n",
  "VELARISATION": "the pronunciation of a word with the back of the tongue touching the soft palate, also VELARIZATION [n -S]\n",
  "VELARISATIONS": "VELARISATION, the pronunciation of a word with the back of the tongue touching the soft palate, also VELARIZATION [n]\n",
  "VELARISE": "to pronounce with the back of the tongue, also VELARIZE [v VELARISED, VELARISING, VELARISES]\n",
  "VELARISED": "VELARISE, to pronounce with the back of the tongue, also VELARIZE [v]\n",
  "VELARISES": "VELARISE, to pronounce with the back of the tongue, also VELARIZE [v]\n",
  "VELARISING": "VELARISE, to pronounce with the back of the tongue, also VELARIZE [v]\n",
  "VELARIUM": "(Latin) an awning over an ancient Roman theatre [n VELARIA]\n",
  "VELARIZATION": "the pronunciation of a word with the back of the tongue touching the soft palate, also VELARISATION [n -S]\n",
  "VELARIZATIONS": "VELARIZATION, the pronunciation of a word with the back of the tongue touching the soft palate, also VELARISATION [n]\n",
  "VELARIZE": "to pronounce with the back of the tongue, also VELARISE [v VELARIZED, VELARIZING, VELARIZES]\n",
  "VELARIZED": "VELARIZE, to pronounce with the back of the tongue, also VELARISE [v]\n",
  "VELARIZES": "VELARIZE, to pronounce with the back of the tongue, also VELARISE [v]\n",
  "VELARIZING": "VELARIZE, to pronounce with the back of the tongue, also VELARISE [v]\n",
  "VELARS": "VELAR, a sound produced by the back of the tongue [n]\n",
  "VELATE": "having a velum, a veil or integument, also VELATED [adj]\n",
  "VELATED": "having a velum, a veil or integument, also VELATE [adj]\n",
  "VELATURA": "(Italian) a method of glazing a painting by rubbing with the hand [n -S]\n",
  "VELATURAS": "VELATURA, (Italian) a method of glazing a painting by rubbing with the hand [n]\n",
  "VELCRO": "(tradename) a closure consisting of a piece of fabric of small hooks that sticks to a corresponding fabric of small loops [n -S]\n",
  "VELCROS": "VELCRO, (tradename) a closure consisting of a piece of fabric of small hooks that sticks to a corresponding fabric of small loops [n]\n",
  "VELD": "(South African) open grassland, also VELDT [n -S]\n",
  "VELDS": "VELD, (South African) open grassland, also VELDT [n]\n",
  "VELDSCHOEN": "(South African) a shoe made of rawhide, also VELDSKOEN, VELSKOEN [n -S]\n",
  "VELDSCHOENS": "VELDSCHOEN, (South African) a shoe made of rawhide, also VELDSKOEN, VELSKOEN [n]\n",
  "VELDSKOEN": "(South African) a shoe made of rawhide, also VELDSCHOEN, VELSKOEN [n -S]\n",
  "VELDSKOENS": "VELDSKOEN, (South African) a shoe made of rawhide, also VELDSCHOEN, VELSKOEN [n]\n",
  "VELDT": "(South African) open grassland, also VELD [n -S]\n",
  "VELDTS": "VELDT, (South African) open grassland, also VELD [n]\n",
  "VELE": "(Spenser) a veil, also VEALE [n -S]\n",
  "VELES": "VELE, (Spenser) a veil, also VEALE [n]\n",
  "VELETA": "(Spanish) a kind of dance in waltz time, also VALETA [n -S]\n",
  "VELETAS": "VELETA, (Spanish) a kind of dance in waltz time, also VALETA [n]\n",
  "VELIGER": "(Latin) a mollusc larva with a velum [n -S]\n",
  "VELIGERS": "VELIGER, (Latin) a mollusc larva with a velum [n]\n",
  "VELITATION": "a minor dispute; a skirmish [n -S]\n",
  "VELITATIONS": "VELITATION, a minor dispute; a skirmish [n]\n",
  "VELITES": "(Latin) foot-soldiers of ancient Rome [n]\n",
  "VELL": "the fourth stomach of a calf [n -S]\n",
  "VELLEITIES": "VELLEITY, a very low degree of desire [n]\n",
  "VELLEITY": "a very low degree of desire [n VELLEITIES]\n",
  "VELLENAGE": "(Spenser) the state of being a villein, also VILLAINAGE, VILLANAGE, VILLEINAGE, VILLENAGE [n -S]\n",
  "VELLENAGES": "VELLENAGE, (Spenser) the state of being a villein, also VILLAINAGE, VILLANAGE, VILLEINAGE, VILLENAGE [n]\n",
  "VELLET": "(Spenser) velvet [n -S]\n",
  "VELLETS": "VELLET, (Spenser) velvet [n]\n",
  "VELLICATE": "to twitch, pluck [v VELLICATED, VELLICATING, VELLICATES]\n",
  "VELLICATED": "VELLICATE, to twitch, pluck [v]\n",
  "VELLICATES": "VELLICATE, to twitch, pluck [v]\n",
  "VELLICATING": "VELLICATE, to twitch, pluck [v]\n",
  "VELLICATION": "the action of pulling or twitching, also VILLICATION [n -S]\n",
  "VELLICATIONS": "VELLICATION, the action of pulling or twitching, also VILLICATION [n]\n",
  "VELLICATIVE": "relating to vellication, the action of pulling or twitching [adj]\n",
  "VELLON": "(Spanish) a copper and silver alloy used in Spanish coinage [n -S]\n",
  "VELLONS": "VELLON, (Spanish) a copper and silver alloy used in Spanish coinage [n]\n",
  "VELLS": "VELL, the fourth stomach of a calf [n]\n",
  "VELLUM": "calf or lamb gut or skin prepared for writing on; parchment [n -S]\n",
  "VELLUMS": "VELLUM, calf or lamb gut or skin prepared for writing on; parchment [n]\n",
  "VELLUS": "as in vellus hair, short fine hair covering the human body, also VILLUS [adj]\n",
  "VELOCE": "(Italian) rapidly [adv]\n",
  "VELOCIMETER": "an instrument for measuring velocity [n -S]\n",
  "VELOCIMETERS": "VELOCIMETER, an instrument for measuring velocity [n]\n",
  "VELOCIMETRIES": "VELOCIMETRY, measurement by means of a velocimeter [n]\n",
  "VELOCIMETRY": "measurement by means of a velocimeter [n VELOCIMETRIES]\n",
  "VELOCIPEDE": "an early form of bicycle, originally one propelled by the feet on the ground [n -S] / to travel by velocipede [v VELOCIPEDED, VELOCIPEDING, VELOCIPEDES]\n",
  "VELOCIPEDEAN": "one who rides a velocipede, an early form of bicycle, also VELOCIPEDER, VELOCIPEDIAN, VELOCIPEDIST [n -S]\n",
  "VELOCIPEDEANS": "VELOCIPEDEAN, one who rides a velocipede, an early form of bicycle, also VELOCIPEDER, VELOCIPEDIAN, VELOCIPEDIST [n]\n",
  "VELOCIPEDED": "VELOCIPEDE, to travel by velocipede [v]\n",
  "VELOCIPEDER": "one who rides a velocipede, an early form of bicycle, also VELOCIPEDEAN, VELOCIPEDIAN, VELOCIPEDIST [n -S]\n",
  "VELOCIPEDERS": "VELOCIPEDER, one who rides a velocipede, an early form of bicycle, also VELOCIPEDEAN, VELOCIPEDIAN, VELOCIPEDIST [n]\n",
  "VELOCIPEDES": "VELOCIPEDE, to travel by velocipede [v]\n",
  "VELOCIPEDIAN": "one who rides a velocipede, an early form of bicycle, also VELOCIPEDEAN, VELOCIPEDER, VELOCIPEDIST [n -S]\n",
  "VELOCIPEDIANS": "VELOCIPEDIAN, one who rides a velocipede, an early form of bicycle, also VELOCIPEDEAN, VELOCIPEDER, VELOCIPEDIST [n]\n",
  "VELOCIPEDING": "VELOCIPEDE, to travel by velocipede [v]\n",
  "VELOCIPEDIST": "one who rides a velocipede, an early form of bicycle, also VELOCIPEDEAN, VELOCIPEDER, VELOCIPEDIAN [n -S]\n",
  "VELOCIPEDISTS": "VELOCIPEDIST, one who rides a velocipede, an early form of bicycle, also VELOCIPEDEAN, VELOCIPEDER, VELOCIPEDIAN [n]\n",
  "VELOCIRAPTOR": "a small bipedal Cretaceous dinosaur with a long narrow head and a sickle-like claw on each hind foot [n -S]\n",
  "VELOCIRAPTORS": "VELOCIRAPTOR, a small bipedal Cretaceous dinosaur with a long narrow head and a sickle-like claw on each hind foot [n]\n",
  "VELOCITIES": "VELOCITY, rapidity of motion [n]\n",
  "VELOCITY": "rapidity of motion [n VELOCITIES]\n",
  "VELODROME": "an area for cycling races [n -S]\n",
  "VELODROMES": "VELODROME, an area for cycling races [n]\n",
  "VELOUR": "(French) a fabric resembling velvet, also VELVERET [n -S]\n",
  "VELOURS": "(French) a woollen stuff with velvetlike pile, also VELOUR, VELURE [n]\n",
  "VELOUTE": "(French) a kind of sauce prepared from a white stock of chicken etc. [n -S]\n",
  "VELOUTES": "VELOUTE, (French) a kind of sauce prepared from a white stock of chicken etc. [n]\n",
  "VELOUTINE": "velvety corded wool [n -S]\n",
  "VELOUTINES": "VELOUTINE, velvety corded wool [n]\n",
  "VELSKOEN": "(South African) a shoe made of rawhide, also VELDSCHOEN, VELDSKOEN [n -S]\n",
  "VELSKOENS": "VELSKOEN, (South African) a shoe made of rawhide, also VELDSCHOEN, VELDSKOEN [n]\n",
  "VELUM": "(Latin) a thin membranous covering or partition, also VELAMEN [n VELA]\n",
  "VELURE": "(Shakespeare) to smooth with a velvet or silk pad, as a hat [v VELURED, VELURING, VELURES]\n",
  "VELURED": "VELURE, (Shakespeare) to smooth with a velvet or silk pad, as a hat [v]\n",
  "VELURES": "VELURE, (Shakespeare) to smooth with a velvet or silk pad, as a hat [v]\n",
  "VELURING": "VELURE, (Shakespeare) to smooth with a velvet or silk pad, as a hat [v]\n",
  "VELUTINOUS": "velvety, covered with dense, soft, silky hairs [adj]\n",
  "VELVERET": "a kind of velvet having a cotton backing [n -S]\n",
  "VELVERETS": "VELVERET, a kind of velvet having a cotton backing [n]\n",
  "VELVET": "a silk, cotton, etc. fabric with a soft close-cut pile, also VELLET [n -S] / to cover with velvet [v -ED, -ING, -S]\n",
  "VELVETED": "having the plush of velvet [adj]\n",
  "VELVETEEN": "a kind of cloth, usually cotton, made in imitation of velvet [n -S]\n",
  "VELVETEENED": "made of velveteen, a kind of cloth [adj]\n",
  "VELVETEENS": "VELVETEEN, a kind of cloth, usually cotton, made in imitation of velvet [n]\n",
  "VELVETIER": "VELVETY, having the plush of velvet [adj]\n",
  "VELVETIEST": "VELVETY, having the plush of velvet [adj]\n",
  "VELVETINESS": "the state of being velvety [n -ES]\n",
  "VELVETINESSES": "VELVETINESS, the state of being velvety [n]\n",
  "VELVETING": "velvet material [n -S]\n",
  "VELVETINGS": "VELVETING, velvet material [n]\n",
  "VELVETLIKE": "like velvet [adj]\n",
  "VELVETS": "VELVET, to cover with velvet [v]\n",
  "VELVETY": "having the plush of velvet [adj VELVETIER, VELVETIEST]\n",
  "VENA": "(Latin) a vein [n VENAE]\n",
  "VENAE": "VENA, (Latin) a vein [n]\n",
  "VENAL": "open to bribery [adj VENALLY]\n",
  "VENALITIES": "VENALITY, the state of being venal, or purchasable [n]\n",
  "VENALITY": "the state of being venal, or purchasable [n VENALITIES]\n",
  "VENALLY": "VENAL, open to bribery [adv]\n",
  "VENATIC": "related to hunting, also VENATICAL [adj VENATICALLY]\n",
  "VENATICAL": "related to hunting, also VENATIC [adj VENATICALLY]\n",
  "VENATICALLY": "VENATICAL, related to hunting, also VENATIC [adv]\n",
  "VENATION": "the arrangement and pattern of veins in a leaf [n -S]\n",
  "VENATIONAL": "of or like venation [adj]\n",
  "VENATIONS": "VENATION, the arrangement and pattern of veins in a leaf [n]\n",
  "VENATOR": "(Latin) a huntsman [n -S]\n",
  "VENATORIAL": "or or pertaining to hunting [adj]\n",
  "VENATORS": "VENATOR, (Latin) a huntsman [n]\n",
  "VEND": "to sell [v -ED, -ING, -S]\n",
  "VENDABLE": "that can be vended [adj] / something that can be vended, also VENDIBLE [n -S]\n",
  "VENDABLES": "VENDABLE, something that can be vended, also VENDIBLE [n]\n",
  "VENDACE": "a whitefish, found in Scottish lochs, also VENDIS, VENDISS [n -S]\n",
  "VENDACES": "VENDACE, a whitefish, found in Scottish lochs, also VENDIS, VENDISS [n]\n",
  "VENDAGE": "the grape harvest, also VENDANGE [n -S]\n",
  "VENDAGES": "VENDAGE, the grape harvest, also VENDANGE [n]\n",
  "VENDANGE": "the grape harvest, also VENDAGE [n -S]\n",
  "VENDANGES": "VENDANGE, the grape harvest, also VENDAGE [n]\n",
  "VENDED": "VEND, to sell [v]\n",
  "VENDEE": "the person to whom a thing is vended [n -S]\n",
  "VENDEES": "VENDEE, the person to whom a thing is vended [n]\n",
  "VENDER": "a seller, also VENDOR [n -S]\n",
  "VENDERS": "VENDER, a seller, also VENDOR [n]\n",
  "VENDETTA": "(Italian) a blood feud between two families [n -S]\n",
  "VENDETTAS": "VENDETTA, (Italian) a blood feud between two families [n]\n",
  "VENDETTIST": "one who carries on a vendetta [n -S]\n",
  "VENDETTISTS": "VENDETTIST, one who carries on a vendetta [n]\n",
  "VENDEUSE": "(French) a saleswoman [n -S]\n",
  "VENDEUSES": "VENDEUSE, (French) a saleswoman [n]\n",
  "VENDIBILITIES": "VENDIBILITY, the state of being vendible [n]\n",
  "VENDIBILITY": "the state of being vendible [n VENDIBILITIES]\n",
  "VENDIBLE": "that can be vended [adj VENDIBLY] / something that can be vended, also VENDABLE [n -S]\n",
  "VENDIBLENESS": "the state of being vendible [n -ES]\n",
  "VENDIBLENESSES": "VENDIBLENESS, the state of being vendible [n]\n",
  "VENDIBLES": "VENDIBLE, something that can be vended, also VENDABLE [n]\n",
  "VENDIBLY": "VENDIBLE, that can be vended [adv]\n",
  "VENDING": "the act of selling goods for a living [n -S]\n",
  "VENDINGS": "VENDING, the act of selling goods for a living [n]\n",
  "VENDIS": "a whitefish, found in Scottish lochs, also VENDACE, VENDISS [n -ES]\n",
  "VENDISES": "VENDIS, a whitefish, found in Scottish lochs, also VENDACE, VENDISS [n]\n",
  "VENDISS": "a whitefish, found in Scottish lochs, also VENDACE, VENDIS [n -ES]\n",
  "VENDISSES": "VENDISS, a whitefish, found in Scottish lochs, also VENDACE, VENDIS [n]\n",
  "VENDITATION": "offering for sale [n -S]\n",
  "VENDITATIONS": "VENDITATION, offering for sale [n]\n",
  "VENDITION": "a sale [n -S]\n",
  "VENDITIONS": "VENDITION, a sale [n]\n",
  "VENDOR": "a seller, also VENDER [n -S]\n",
  "VENDORS": "VENDOR, a seller, also VENDER [n]\n",
  "VENDS": "VEND, to sell [v]\n",
  "VENDU": "(Canadian) derogatory for a Quebecois who is viewed as having sold out or become assimilated to English-Canadian society [n -S]\n",
  "VENDUE": "(Dutch) a public sale; an auction [n -S]\n",
  "VENDUES": "VENDUE, (Dutch) a public sale; an auction [n]\n",
  "VENDUS": "VENDU, (Canadian) derogatory for a Quebecois who is viewed as having sold out or become assimilated to English-Canadian society [n]\n",
  "VENEER": "to overlay with thin layers of material [v -ED, -ING, -S]\n",
  "VENEERED": "VENEER, to overlay with thin layers of material [v]\n",
  "VENEERER": "one who veneers [n -S]\n",
  "VENEERERS": "VENEERER, one who veneers [n]\n",
  "VENEERING": "an overlay with a thin sheet of fine wood or other material [n -S]\n",
  "VENEERINGS": "VENEERING, an overlay with a thin sheet of fine wood or other material [n]\n",
  "VENEERS": "VENEER, to overlay with thin layers of material [v]\n",
  "VENEFIC": "acting by poison or potions or by sorcery, also VENEFICAL, VENEFICIOUS, VENEFICOUS [adj VENEFICALLY]\n",
  "VENEFICAL": "acting by poison or potions or by sorcery, also VENEFIC, VENEFICIOUS, VENEFICOUS [adj VENEFICALLY]\n",
  "VENEFICALLY": "VENEFICAL, acting by poison or potions or by sorcery, also VENEFIC, VENEFICIOUS, VENEFICOUS [adv]\n",
  "VENEFICIOUS": "acting by poison or potions or by sorcery, also VENEFIC, VENEFICAL, VENEFICOUS [adj VENEFICIOUSLY]\n",
  "VENEFICIOUSLY": "VENEFICIOUS, acting by poison or potions or by sorcery, also VENEFIC, VENEFICAL, VENEFICOUS [adv]\n",
  "VENEFICOUS": "acting by poison or potions or by sorcery, also VENEFIC, VENEFICAL, VENEFICIOUS [adj VENEFICOUSLY]\n",
  "VENEFICOUSLY": "VENEFICOUS, acting by poison or potions or by sorcery, also VENEFIC, VENEFICAL, VENEFICIOUS [adv]\n",
  "VENENATE": "to poison [v VENENATED, VENENATING, VENENATES]\n",
  "VENENATED": "VENENATE, to poison [v]\n",
  "VENENATES": "VENENATE, to poison [v]\n",
  "VENENATING": "VENENATE, to poison [v]\n",
  "VENENE": "medicine from snake venom [n -S]\n",
  "VENENES": "VENENE, medicine from snake venom [n]\n",
  "VENENOSE": "poisonous [adj]\n",
  "VENEPUNCTURE": "the puncturing of a vein with a hypodermic needle, to draw off a sample of blood, also VENIPUNCTURE [n -S]\n",
  "VENEPUNCTURES": "VENEPUNCTURE, the puncturing of a vein with a hypodermic needle, to draw off a sample of blood, also VENIPUNCTURE [n]\n",
  "VENERABILITIES": "VENERABILITY, the state of being venerable [n]\n",
  "VENERABILITY": "the state of being venerable [n VENERABILITIES]\n",
  "VENERABLE": "worthy of reverence [adj VENERABLY] / a title of respect [n -S]\n",
  "VENERABLENESS": "the state of being venerable [n -ES]\n",
  "VENERABLENESSES": "VENERABLENESS, the state of being venerable [n]\n",
  "VENERABLES": "VENERABLE, a title of respect [n]\n",
  "VENERABLY": "VENERABLE, worthy of reverence [adv]\n",
  "VENERATE": "to revere [v VENERATED, VENERATING, VENERATES]\n",
  "VENERATED": "VENERATE, to revere [v]\n",
  "VENERATES": "VENERATE, to revere [v]\n",
  "VENERATING": "VENERATE, to revere [v]\n",
  "VENERATION": "the act of venerating [n -S]\n",
  "VENERATIONAL": "relating to veneration [adj]\n",
  "VENERATIONS": "VENERATION, the act of venerating [n]\n",
  "VENERATIVE": "of or relating to veneration or worship [adj]\n",
  "VENERATIVENESS": "the state of being worthy of veneration [n]\n",
  "VENERATOR": "one who venerates [n -S]\n",
  "VENERATORS": "VENERATOR, one who venerates [n]\n",
  "VENEREAL": "relating to sexual desire or intercourse, also VENEREAN, VENEREOUS [adj VENEREALLY]\n",
  "VENEREALLY": "VENEREAL, relating to sexual desire or intercourse, also VENEREAN, VENEREOUS [adv]\n",
  "VENEREAN": "a person addicted to sexual intercourse [n -S]\n",
  "VENEREANS": "VENEREAN, a person addicted to sexual intercourse [n]\n",
  "VENEREOLOGICAL": "related to venereology, the study of venereal disease [adj]\n",
  "VENEREOLOGIES": "VENEREOLOGY, the study of venereal disease [n]\n",
  "VENEREOLOGIST": "one who studies venereal diseases [n -S]\n",
  "VENEREOLOGISTS": "VENEREOLOGIST, one who studies venereal diseases [n]\n",
  "VENEREOLOGY": "the study of venereal disease [n VENEREOLOGIES]\n",
  "VENEREOUS": "venereal; exciting lust, also VENEREAL, VENEREAN [adj]\n",
  "VENERER": "a gamekeeper [n -S]\n",
  "VENERERS": "VENERER, a gamekeeper [n]\n",
  "VENERIES": "VENERY, (archaic) the pursuit of sexual gratification; hunting [n]\n",
  "VENERY": "(archaic) the pursuit of sexual gratification; hunting [n VENERIES]\n",
  "VENESECTION": "the act of opening a vein in bloodletting [n -S]\n",
  "VENESECTIONS": "VENESECTION, the act of opening a vein in bloodletting [n]\n",
  "VENETIAN": "one of the tapes that join the slats of a Venetian blind [n -S]\n",
  "VENETIANS": "VENETIAN, one of the tapes that join the slats of a Venetian blind [n]\n",
  "VENEWE": "(Shakespeare) a venue, also VENEY [n -S]\n",
  "VENEWES": "VENEWE, (Shakespeare) a venue, also VENEY [n]\n",
  "VENEY": "(Shakespeare) a venue, also VENEWE [n -S]\n",
  "VENEYS": "VENEY, (Shakespeare) a venue, also VENEWE [n]\n",
  "VENGE": "(Shakespeare) to avenge [v VENGED, VENGING, VENGES]\n",
  "VENGEABLE": "revengeful; deserving revenge [adj VENGEABLY]\n",
  "VENGEABLY": "VENGEABLE, revengeful; deserving revenge [adv]\n",
  "VENGEANCE": "revenge [n -S]\n",
  "VENGEANCES": "VENGEANCE, revenge [n]\n",
  "VENGED": "VENGE, (Shakespeare) to avenge [v]\n",
  "VENGEFUL": "seeking to avenge, also AVENGEFUL [adj VENGEFULLY]\n",
  "VENGEFULLY": "VENGEFUL, seeking to avenge, also AVENGEFUL [adv]\n",
  "VENGEFULNESS": "the state of being vengeful [n -ES]\n",
  "VENGEFULNESSES": "VENGEFULNESS, the state of being vengeful [n]\n",
  "VENGEMENT": "(Spenser) revenge, also REVENGEMENT [n -S]\n",
  "VENGEMENTS": "VENGEMENT, (Spenser) revenge, also REVENGEMENT [n]\n",
  "VENGER": "(Spenser) an avenger [n -S]\n",
  "VENGERS": "VENGER, (Spenser) an avenger [n]\n",
  "VENGES": "VENGE, (Shakespeare) to avenge [v]\n",
  "VENGING": "VENGE, (Shakespeare) to avenge [v]\n",
  "VENIAL": "easily excused or forgiven [adj VENIALLY]\n",
  "VENIALITIES": "VENIALITY, pardonableness of offence [n]\n",
  "VENIALITY": "pardonableness of offence [n VENIALITIES]\n",
  "VENIALLY": "VENIAL, easily excused or forgiven [adv]\n",
  "VENIALNESS": "the state of being venial [n -ES]\n",
  "VENIALNESSES": "VENIALNESS, the state of being venial [n]\n",
  "VENIDIUM": "a plant native to South Africa with yellow or cream flowers, aka Cape Daisy [n -S]\n",
  "VENIDIUMS": "VENIDIUM, a plant native to South Africa with yellow or cream flowers, aka Cape Daisy [n]\n",
  "VENIN": "any of various toxic substances in venom, also VENINE [n -S]\n",
  "VENINE": "any of various toxic substances in venom, also VENIN [n -S]\n",
  "VENINES": "VENINE, any of various toxic substances in venom, also VENIN [n]\n",
  "VENINS": "VENIN, any of various toxic substances in venom, also VENINE [n]\n",
  "VENIPUNCTURE": "the puncturing of a vein with a hypodermic needle, to draw off a sample of blood, also VENEPUNCTURE [n -S]\n",
  "VENIPUNCTURES": "VENIPUNCTURE, the puncturing of a vein with a hypodermic needle, to draw off a sample of blood, also VENEPUNCTURE [n]\n",
  "VENIRE": "(Latin) a type of judicial writ concerning jurors [n -S]\n",
  "VENIREMAN": "a person summoned by venire as a prospective juror [n VENIREMEN]\n",
  "VENIREMEN": "VENIREMAN, a person summoned by venire as a prospective juror [n]\n",
  "VENIRES": "VENIRE, (Latin) a type of judicial writ concerning jurors [n]\n",
  "VENISECTION": "surgical incision into a vein [n -S]\n",
  "VENISECTIONS": "VENISECTION, surgical incision into a vein [n]\n",
  "VENISON": "the edible flesh of a deer [n -S]\n",
  "VENISONS": "VENISON, the edible flesh of a deer [n]\n",
  "VENITE": "(Latin) the 95th psalm [n -S]\n",
  "VENITES": "VENITE, (Latin) the 95th psalm [n]\n",
  "VENNEL": "(Scots) a lane [n -S]\n",
  "VENNELS": "VENNEL, (Scots) a lane [n]\n",
  "VENOGRAM": "an X-ray of a vein [n -S]\n",
  "VENOGRAMS": "VENOGRAM, an X-ray of a vein [n]\n",
  "VENOGRAPHIC": "relating to venography, radiography of a vein after injection of a contrast medium, also VENOGRAPHICAL [adj]\n",
  "VENOGRAPHICAL": "relating to venography, radiography of a vein after injection of a contrast medium, also VENOGRAPHIC [adj]\n",
  "VENOGRAPHIES": "VENOGRAPHY, radiography of a vein after injection of a contrast medium [n]\n",
  "VENOGRAPHY": "radiography of a vein after injection of a contrast medium [n VENOGRAPHIES]\n",
  "VENOLOGIES": "VENOLOGY, the study of veins [n]\n",
  "VENOLOGY": "the study of veins [n VENOLOGIES]\n",
  "VENOM": "to inject with a poisonous secretion [v -ED, -ING, -S]\n",
  "VENOMED": "VENOM, to inject with a poisonous secretion [v]\n",
  "VENOMER": "(archaic) a poisoner [n -S]\n",
  "VENOMERS": "VENOMER, (archaic) a poisoner [n]\n",
  "VENOMING": "VENOM, to inject with a poisonous secretion [v]\n",
  "VENOMLESS": "without venom [adj]\n",
  "VENOMOUS": "poisonous [adj VENOMOUSLY]\n",
  "VENOMOUSLY": "VENOMOUS, poisonous [adv]\n",
  "VENOMOUSNESS": "the state of being venomous [n -ES]\n",
  "VENOMOUSNESSES": "VENOMOUSNESS, the state of being venomous [n]\n",
  "VENOMS": "VENOM, to inject with a poisonous secretion [v]\n",
  "VENOSCLEROSES": "VENOSCLEROSIS, sclerosis of the veins [n]\n",
  "VENOSCLEROSIS": "sclerosis of the veins [n VENOSCLEROSES]\n",
  "VENOSE": "with very marked veins, also VEINOUS [adj]\n",
  "VENOSITIES": "VENOSITY, the state of being venous, pertaining to the veins [n]\n",
  "VENOSITY": "the state of being venous, pertaining to the veins [n VENOSITIES]\n",
  "VENOUS": "full of veins, also VENOSE [adj VENOUSLY]\n",
  "VENOUSLY": "VENOUS, full of veins, also VENOSE [adv]\n",
  "VENOUSNESS": "the state of being venous [n -ES]\n",
  "VENOUSNESSES": "VENOUSNESS, the state of being venous [n]\n",
  "VENT": "to provide with an opening [v -ED, -ING, -S]\n",
  "VENTAGE": "(Shakespeare) a fingerhole, as in a flute, also VENTIGE [n -S]\n",
  "VENTAGES": "VENTAGE, (Shakespeare) a fingerhole, as in a flute, also VENTIGE [n]\n",
  "VENTAIL": "the movable front to a helmet, also AVENTAIL, AVENTAILE, VENTAILE, VENTAYLE [n -S]\n",
  "VENTAILE": "(Spenser) the movable front to a helmet, also AVENTAIL, AVENTAILE, VENTAIL, VENTAYLE [n -S]\n",
  "VENTAILES": "VENTAILE, (Spenser) the movable front to a helmet, also AVENTAIL, AVENTAILE, VENTAIL, VENTAYLE [n]\n",
  "VENTAILS": "VENTAIL, the movable front to a helmet, also AVENTAIL, AVENTAILE, VENTAILE, VENTAYLE [n]\n",
  "VENTANA": "(Spanish) a window [n -S]\n",
  "VENTANAS": "VENTANA, (Spanish) a window [n]\n",
  "VENTAYLE": "(Spenser) the movable front to a helmet, also AVENTAIL, AVENTAILE, VENTAIL, VENTAILE [n -S]\n",
  "VENTAYLES": "VENTAYLE, (Spenser) the movable front to a helmet, also AVENTAIL, AVENTAILE, VENTAIL, VENTAILE [n]\n",
  "VENTED": "VENT, to provide with an opening [v]\n",
  "VENTER": "(obsolete) a person who utters or publishes [n -S]\n",
  "VENTERS": "VENTER, (obsolete) a person who utters or publishes [n]\n",
  "VENTIDUCT": "a ventilating pipe or passage [n -S]\n",
  "VENTIDUCTS": "VENTIDUCT, a ventilating pipe or passage [n]\n",
  "VENTIFACT": "a stone polished by windblown sand [n -S]\n",
  "VENTIFACTS": "VENTIFACT, a stone polished by windblown sand [n]\n",
  "VENTIGE": "(Shakespeare) a fingerhole, as in a flute, also VENTAGE [n -S]\n",
  "VENTIGES": "VENTIGE, (Shakespeare) a fingerhole, as in a flute, also VENTAGE [n]\n",
  "VENTIL": "a valve in wind instruments [n -S]\n",
  "VENTILABLE": "that can be ventilated [adj]\n",
  "VENTILATE": "to supply with air [v VENTILATED, VENTILATING, VENTILATES]\n",
  "VENTILATED": "VENTILATE, to supply with air [v]\n",
  "VENTILATES": "VENTILATE, to supply with air [v]\n",
  "VENTILATING": "VENTILATE, to supply with air [v]\n",
  "VENTILATION": "the act of ventilating [n -S]\n",
  "VENTILATIONS": "VENTILATION, the act of ventilating [n]\n",
  "VENTILATIVE": "relating to ventilation [adj]\n",
  "VENTILATOR": "one that ventilates [n -S]\n",
  "VENTILATORS": "VENTILATOR, one that ventilates [n]\n",
  "VENTILATORY": "of, relating to, or provided with ventilation [adj]\n",
  "VENTILS": "VENTIL, a valve in wind instruments [n]\n",
  "VENTING": "the act of venting [n -S]\n",
  "VENTINGS": "VENTING, the act of venting [n]\n",
  "VENTLESS": "without a vent [adj]\n",
  "VENTOSE": "an apparatus sometimes used to assist the delivery of a baby, consisting of a cup which is attached to the fetal head by suction, also VENTOUSE [n -S]\n",
  "VENTOSES": "VENTOSE, an apparatus sometimes used to assist the delivery of a baby, consisting of a cup which is attached to the fetal head by suction, also VENTOUSE [n]\n",
  "VENTOSITIES": "VENTOSITY, the state of being ventose; hence, vainglory; pride [n]\n",
  "VENTOSITY": "the state of being ventose; hence, vainglory; pride [n VENTOSITIES]\n",
  "VENTOUSE": "an apparatus sometimes used to assist the delivery of a baby, consisting of a cup which is attached to the fetal head by suction, also VENTOSE [n -S]\n",
  "VENTOUSES": "VENTOUSE, an apparatus sometimes used to assist the delivery of a baby, consisting of a cup which is attached to the fetal head by suction, also VENTOSE [n]\n",
  "VENTRAL": "pertaining to the underside or the belly [adj VENTRALLY] / a ventral fin [n -S]\n",
  "VENTRALLY": "VENTRAL, pertaining to the underside or the belly [adv]\n",
  "VENTRALS": "VENTRAL, a ventral fin [n]\n",
  "VENTRE": "(obsolete) to venture [v VENTRED, VENTRING, VENTRES]\n",
  "VENTRED": "VENTRE, (obsolete) to venture [v]\n",
  "VENTRES": "VENTRE, (obsolete) to venture [v]\n",
  "VENTRICLE": "either of the two muscular lower chambers of the heart, which pump the blood to the arteries and through the body, also VENTRICULE, VENTRICULUS [n -S]\n",
  "VENTRICLES": "VENTRICLE, either of the two muscular lower chambers of the heart, which pump the blood to the arteries and through the body, also VENTRICULE, VENTRICULUS [n]\n",
  "VENTRICOSE": "distended or swollen in the middle, also VENTRICOUS [adj]\n",
  "VENTRICOSITIES": "VENTRICOSITY, the state of being ventricose, distended or swollen in the middle [n]\n",
  "VENTRICOSITY": "the state of being ventricose, distended or swollen in the middle [n VENTRICOSITIES]\n",
  "VENTRICOUS": "distended or swollen in the middle, also VENTRICOSE [adj]\n",
  "VENTRICULAR": "of, relating to, or being a ventricle [adj]\n",
  "VENTRICULE": "a ventricle, also VENTRICULUS [n -S]\n",
  "VENTRICULES": "VENTRICULE, a ventricle, also VENTRICULUS [n]\n",
  "VENTRICULI": "VENTRICULUS, a ventricle, also VENTRICULE [n]\n",
  "VENTRICULUS": "a ventricle, also VENTRICULE [n VENTRICULI]\n",
  "VENTRILOQUAL": "related to ventriloquy, also VENTRILOQUIAL [adj]\n",
  "VENTRILOQUIAL": "relating to ventriloquism, also VENTRILOQUAL [adj VENTRILOQUIALLY]\n",
  "VENTRILOQUIALLY": "VENTRILOQUIAL, relating to ventriloquism, also VENTRILOQUAL [adv]\n",
  "VENTRILOQUIES": "VENTRILOQUY, the production of the voice in such a way that the sound seems to come from a source other than the vocal organs of the speaker, also VENTRILOQUISM [n]\n",
  "VENTRILOQUISE": "to project the voice, also VENTRILOQUIZE [v VENTRILOQUISED, VENTRILOQUISING, VENTRILOQUISES]\n",
  "VENTRILOQUISED": "VENTRILOQUISE, to project the voice, also VENTRILOQUIZE [v]\n",
  "VENTRILOQUISES": "VENTRILOQUISE, to project the voice, also VENTRILOQUIZE [v]\n",
  "VENTRILOQUISING": "VENTRILOQUISE, to project the voice, also VENTRILOQUIZE [v]\n",
  "VENTRILOQUISM": "the production of the voice in such a way that the sound seems to come from a source other than the vocal organs of the speaker, also VENTRILOQUY [n -S]\n",
  "VENTRILOQUISMS": "VENTRILOQUISM, the production of the voice in such a way that the sound seems to come from a source other than the vocal organs of the speaker, also VENTRILOQUY [n]\n",
  "VENTRILOQUIST": "one who uses or is skilled in ventriloquism [n -S]\n",
  "VENTRILOQUISTIC": "relating to ventriloquism [adj]\n",
  "VENTRILOQUISTS": "VENTRILOQUIST, one who uses or is skilled in ventriloquism [n]\n",
  "VENTRILOQUIZE": "to use ventriloquism, also VENTRILOQUISE [v VENTRILOQUIZED, VENTRILOQUIZING, VENTRILOQUIZES]\n",
  "VENTRILOQUIZED": "VENTRILOQUIZE, to use ventriloquism, also VENTRILOQUISE [v]\n",
  "VENTRILOQUIZES": "VENTRILOQUIZE, to use ventriloquism, also VENTRILOQUISE [v]\n",
  "VENTRILOQUIZING": "VENTRILOQUIZE, to use ventriloquism, also VENTRILOQUISE [v]\n",
  "VENTRILOQUOUS": "related to ventriloquy [adj]\n",
  "VENTRILOQUY": "the production of the voice in such a way that the sound seems to come from a source other than the vocal organs of the speaker, also VENTRILOQUISM [n VENTRILOQUIES]\n",
  "VENTRING": "(Milton) an enterprise [n -S]\n",
  "VENTRINGS": "VENTRING, (Milton) an enterprise [n]\n",
  "VENTRIPOTENT": "taking a greedy delight in eating [adj]\n",
  "VENTROLATERAL": "ventral and lateral [adj]\n",
  "VENTROMEDIAL": "ventral and medial [adj]\n",
  "VENTROUS": "(Spenser) adventurous, also VENTUROUS [adj]\n",
  "VENTS": "VENT, to provide with an opening [v]\n",
  "VENTURE": "to risk, also VENTRE [v VENTURED, VENTURING, VENTURES]\n",
  "VENTURED": "VENTURE, to risk, also VENTRE [v]\n",
  "VENTURER": "one who ventures [n -S]\n",
  "VENTURERS": "VENTURER, one who ventures [n]\n",
  "VENTURES": "VENTURE, to risk, also VENTRE [v]\n",
  "VENTURESOME": "involving risk [adj VENTURESOMELY]\n",
  "VENTURESOMELY": "VENTURESOME, involving risk [adv]\n",
  "VENTURESOMENESS": "the state of being venturesome [n]\n",
  "VENTURI": "(Italian) a device for measuring the flow of a fluid [n -S]\n",
  "VENTURING": "adventuresome [adj VENTURINGLY] / the act of venture [n -S]\n",
  "VENTURINGLY": "VENTURING [adv]\n",
  "VENTURINGS": "VENTURING, the act of venture [n]\n",
  "VENTURIS": "VENTURI, (Italian) a device for measuring the flow of a fluid [n]\n",
  "VENTUROUS": "venturesome; adventurous, also VENTROUS [adj VENTUROUSLY]\n",
  "VENTUROUSLY": "VENTUROUS, venturesome; adventurous, also VENTROUS [adv]\n",
  "VENTUROUSNESS": "the state of being venturous [n -ES]\n",
  "VENTUROUSNESSES": "VENTUROUSNESS, the state of being venturous [n]\n",
  "VENUE": "the chosen location for an event, also VENEWE, VENEY [n -S]\n",
  "VENUES": "VENUE, the chosen location for an event, also VENEWE, VENEY [n]\n",
  "VENULAR": "like a venule, a small vein [adj]\n",
  "VENULE": "a small vein, also VEINLET, VEINULE, VEINULET [n -S]\n",
  "VENULES": "VENULE, a small vein, also VEINLET, VEINULE, VEINULET [n]\n",
  "VENULOSE": "full of venules, or small veins, also VENULOUS [adj]\n",
  "VENULOUS": "full of venules, or small veins, also VENULOSE [adj]\n",
  "VENUS": "(Latin) one of a genus of lamellibranch molluscs [n -ES]\n",
  "VENUSES": "VENUS, (Latin) one of a genus of lamellibranch molluscs [n]\n",
  "VENVILLE": "a form of tenure in parishes around Dartmoor [n -S]\n",
  "VENVILLES": "VENVILLE, a form of tenure in parishes around Dartmoor [n]\n",
  "VERA": "very, also VERRA [adj]\n",
  "VERACIOUS": "truthful; exact [adj VERACIOUSLY]\n",
  "VERACIOUSLY": "VERACIOUS, truthful; exact [adv]\n",
  "VERACIOUSNESS": "the state of being veracious [n -ES]\n",
  "VERACIOUSNESSES": "VERACIOUSNESS, the state of being veracious [n]\n",
  "VERACITIES": "VERACITY, conformity to truth [n]\n",
  "VERACITY": "conformity to truth [n VERACITIES]\n",
  "VERANDA": "(Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDAH, VIRANDA, VIRANDO [n -S]\n",
  "VERANDAED": "having a veranda, also VERANDAHED [adj]\n",
  "VERANDAH": "(Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDA, VIRANDA, VIRANDO [n -S]\n",
  "VERANDAHED": "having a verandah, also VERANDAED [adj]\n",
  "VERANDAHS": "VERANDAH, (Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDA, VIRANDA, VIRANDO [n]\n",
  "VERANDAS": "VERANDA, (Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDAH, VIRANDA, VIRANDO [n]\n",
  "VERAPAMIL": "a calcium channel blocker [n -S]\n",
  "VERAPAMILS": "VERAPAMIL, a calcium channel blocker [n]\n",
  "VERATRIA": "(Latin) a poisonous mixture of alkaloids, also VERATRIN, VERATRINE [n -S]\n",
  "VERATRIAS": "VERATRIA, (Latin) a poisonous mixture of alkaloids, also VERATRIN, VERATRINE [n]\n",
  "VERATRIDINE": "a poisonous alkaloid occurring esp. in sabadilla seed [n -S]\n",
  "VERATRIDINES": "VERATRIDINE, a poisonous alkaloid occurring esp. in sabadilla seed [n]\n",
  "VERATRIN": "(Latin) a poisonous mixture of alkaloids, also VERATRIA, VERATRINE [n -S]\n",
  "VERATRINE": "an alkaloid or mixture of alkaloids obtained from white hellebore rhizomes, sabadilla, etc., also VERATRIA, VERATRIN [n -S]\n",
  "VERATRINES": "VERATRINE, an alkaloid or mixture of alkaloids obtained from white hellebore rhizomes, sabadilla, etc., also VERATRIA, VERATRIN [n]\n",
  "VERATRINS": "VERATRIN, (Latin) a poisonous mixture of alkaloids, also VERATRIA, VERATRINE [n]\n",
  "VERATRUM": "(Latin) a genus of coarse liliaceous herbs having very poisonous qualities [n -S]\n",
  "VERATRUMS": "VERATRUM, (Latin) a genus of coarse liliaceous herbs having very poisonous qualities [n]\n",
  "VERB": "a part of speech that signifies action [n -S]\n",
  "VERBAL": "in words [adj VERBALLY] / to take a police statement [v VERBALLED, VERBALLING, VERBALS]\n",
  "VERBALISATION": "the act of verbalising, also VERBALIZATION [n -S]\n",
  "VERBALISATIONS": "VERBALISATION, the act of verbalising, also VERBALIZATION [n]\n",
  "VERBALISE": "to put into words, also VERBALIZE [v VERBALISED, VERBALISING, VERBALISES]\n",
  "VERBALISED": "VERBALISE, to put into words, also VERBALIZE [v]\n",
  "VERBALISER": "one who verbalises, also VERBALIZER [n -S]\n",
  "VERBALISERS": "VERBALISER, one who verbalises, also VERBALIZER [n]\n",
  "VERBALISES": "VERBALISE, to put into words, also VERBALIZE [v]\n",
  "VERBALISING": "VERBALISE, to put into words, also VERBALIZE [v]\n",
  "VERBALISM": "undue attention to words alone [n -S]\n",
  "VERBALISMS": "VERBALISM, undue attention to words alone [n]\n",
  "VERBALIST": "a person dealing in or concentrating on mere words rather than reality or meaning [n -S]\n",
  "VERBALISTIC": "of or like a verbalist [adj]\n",
  "VERBALISTS": "VERBALIST, a person dealing in or concentrating on mere words rather than reality or meaning [n]\n",
  "VERBALITIES": "VERBALITY, the state of being verbal [n]\n",
  "VERBALITY": "the state of being verbal [n VERBALITIES]\n",
  "VERBALIZATION": "the act of verbalizing, also VERBALISATION [n -S]\n",
  "VERBALIZATIONS": "VERBALIZATION, the act of verbalizing, also VERBALISATION [n]\n",
  "VERBALIZE": "to put into words, also VERBALISE [v VERBALIZED, VERBALIZING, VERBALIZES]\n",
  "VERBALIZED": "VERBALIZE, to put into words, also VERBALISE [v]\n",
  "VERBALIZER": "one who verbalizes, also VERBALISER [n -S]\n",
  "VERBALIZERS": "VERBALIZER, one who verbalizes, also VERBALISER [n]\n",
  "VERBALIZES": "VERBALIZE, to put into words, also VERBALISE [v]\n",
  "VERBALIZING": "VERBALIZE, to put into words, also VERBALISE [v]\n",
  "VERBALLED": "VERBAL, to take a police statement [v]\n",
  "VERBALLING": "VERBAL, to take a police statement [v]\n",
  "VERBALLY": "VERBAL, in words [adv]\n",
  "VERBALS": "VERBAL, to take a police statement [v]\n",
  "VERBARIAN": "a coiner of words [n -S]\n",
  "VERBARIANS": "VERBARIAN, a coiner of words [n]\n",
  "VERBASCUM": "another name for the flower mullein [n -S]\n",
  "VERBASCUMS": "VERBASCUM, another name for the flower mullein [n]\n",
  "VERBATIM": "(Latin) word for word [adj]\n",
  "VERBENA": "(Latin) a plant of the vervain genus [n -S]\n",
  "VERBENACEOUS": "belonging to the verbena family [adj]\n",
  "VERBENAS": "VERBENA, (Latin) a plant of the vervain genus [n]\n",
  "VERBERATE": "(archaic) to beat [v VERBERATED, VERBERATING, VERBERATES]\n",
  "VERBERATED": "VERBERATE, (archaic) to beat [v]\n",
  "VERBERATES": "VERBERATE, (archaic) to beat [v]\n",
  "VERBERATING": "VERBERATE, (archaic) to beat [v]\n",
  "VERBERATION": "(archaic) the act of verberating, beating [n -S]\n",
  "VERBERATIONS": "VERBERATION, (archaic) the act of verberating, beating [n]\n",
  "VERBIAGE": "a profusion of words usually of little or obscure content [n -S]\n",
  "VERBIAGES": "VERBIAGE, a profusion of words usually of little or obscure content [n]\n",
  "VERBICIDE": "destruction of the meaning of a word [n -S]\n",
  "VERBICIDES": "VERBICIDE, destruction of the meaning of a word [n]\n",
  "VERBID": "a nonfinite part of a verb [n -S]\n",
  "VERBIDS": "VERBID, a nonfinite part of a verb [n]\n",
  "VERBIFICATION": "conversion into a verb [n -S]\n",
  "VERBIFICATIONS": "VERBIFICATION, conversion into a verb [n]\n",
  "VERBIFIED": "VERBIFY, to use as a verb [v]\n",
  "VERBIFIES": "VERBIFY, to use as a verb [v]\n",
  "VERBIFY": "to use as a verb [v VERBIFIED, VERBIFYING, VERBIFIES]\n",
  "VERBIFYING": "VERBIFY, to use as a verb [v]\n",
  "VERBIGERATE": "to continually repeat a word or phrase, usually unconsciously [v VERBIGERATED, VERBIGERATING, VERBIGERATES]\n",
  "VERBIGERATED": "VERBIGERATE, to continually repeat a word or phrase, usually unconsciously [v]\n",
  "VERBIGERATES": "VERBIGERATE, to continually repeat a word or phrase, usually unconsciously [v]\n",
  "VERBIGERATING": "VERBIGERATE, to continually repeat a word or phrase, usually unconsciously [v]\n",
  "VERBIGERATION": "the obsessive repetition of stereotyped phrases [n -S]\n",
  "VERBIGERATIONS": "VERBIGERATION, the obsessive repetition of stereotyped phrases [n]\n",
  "VERBILE": "one whose mental imagery consists of words [n -S]\n",
  "VERBILES": "VERBILE, one whose mental imagery consists of words [n]\n",
  "VERBING": "the use of nouns as verbs [n -S]\n",
  "VERBINGS": "VERBING, the use of nouns as verbs [n]\n",
  "VERBLESS": "without a verb [adj]\n",
  "VERBOSE": "wordy [adj VERBOSER, VERBOSEST, VERBOSELY]\n",
  "VERBOSELY": "VERBOSE, wordy [adv]\n",
  "VERBOSENESS": "the state of being verbose [n -ES]\n",
  "VERBOSENESSES": "VERBOSENESS, the state of being verbose [n]\n",
  "VERBOSER": "VERBOSE, wordy [adj]\n",
  "VERBOSEST": "VERBOSE, wordy [adj]\n",
  "VERBOSITIES": "VERBOSITY, the state of being verbose [n]\n",
  "VERBOSITY": "the state of being verbose [n VERBOSITIES]\n",
  "VERBOTEN": "(German) forbidden [adj]\n",
  "VERBS": "VERB, a part of speech that signifies action [n]\n",
  "VERD": "as in verd antique, a dark green mottled impure variety of serpentine [adj]\n",
  "VERDANCIES": "VERDANCY, the state of being verdant [n]\n",
  "VERDANCY": "the state of being verdant [n VERDANCIES]\n",
  "VERDANT": "green with vegetation [adj VERDANTLY]\n",
  "VERDANTLY": "VERDANT, green with vegetation [adv]\n",
  "VERDELHO": "(Portuguese) a white grape originally growing in Madeira; a white wine made from this [n -S]\n",
  "VERDELHOS": "VERDELHO, (Portuguese) a white grape originally growing in Madeira; a white wine made from this [n]\n",
  "VERDERER": "(historical) an officer in charge of the royal forests in England, also VERDEROR [n -S]\n",
  "VERDERERS": "VERDERER, (historical) an officer in charge of the royal forests in England, also VERDEROR [n]\n",
  "VERDEROR": "an officer in charge of the royal forests in England, also VERDERER [n -S]\n",
  "VERDERORS": "VERDEROR, an officer in charge of the royal forests in England, also VERDERER [n]\n",
  "VERDET": "copper acetate [n -S]\n",
  "VERDETS": "VERDET, copper acetate [n]\n",
  "VERDICT": "the decision of a jury at the end of a legal proceeding [n -S]\n",
  "VERDICTS": "VERDICT, the decision of a jury at the end of a legal proceeding [n]\n",
  "VERDIGRIS": "a green or bluish deposit esp. of copper carbonates formed on copper, brass, or bronze surfaces, also VERDITER [n -ES] / to coat with verdigris [v -ED,-ING, -ES]\n",
  "VERDIGRISED": "VERDIGRIS, to coat with verdigris [v]\n",
  "VERDIGRISES": "VERDIGRIS, to coat with verdigris [v]\n",
  "VERDIGRISING": "VERDIGRIS, to coat with verdigris [v]\n",
  "VERDIN": "a small yellow-headed bird of Lower California, allied to the titmice [n -S]\n",
  "VERDINS": "VERDIN, a small yellow-headed bird of Lower California, allied to the titmice [n]\n",
  "VERDIT": "(Spenser) a verdict [n -S]\n",
  "VERDITE": "green mica [n -S]\n",
  "VERDITER": "(archaic) a greenish copper coating, verdigris, also VERDIGRIS [n -S]\n",
  "VERDITERS": "VERDITER, (archaic) a greenish copper coating, verdigris, also VERDIGRIS [n]\n",
  "VERDITES": "VERDITE, green mica [n]\n",
  "VERDITS": "VERDIT, (Spenser) a verdict [n]\n",
  "VERDOY": "(French) in heraldry, a floral ornament [n -S]\n",
  "VERDOYS": "VERDOY, (French) in heraldry, a floral ornament [n]\n",
  "VERDURE": "green vegetation [n -S]\n",
  "VERDURED": "having green vegetation [adj]\n",
  "VERDURELESS": "without verdure [adj]\n",
  "VERDURES": "VERDURE, green vegetation [n]\n",
  "VERDUROUS": "green with growth [adj]\n",
  "VERECUND": "(Latin) shy, coy, bashful [adj]\n",
  "VERGE": "to come near [v VERGED, VERGING, VERGES]\n",
  "VERGEBOARD": "a board projecting from a roof gable, aka bargeboard [n -S]\n",
  "VERGEBOARDS": "VERGEBOARD, a board projecting from a roof gable, aka bargeboard [n]\n",
  "VERGED": "VERGE, to come near [v]\n",
  "VERGENCE": "the simultaneous turning of both eyes either inwards or outwards when changing focus, also VERGENCY [n -S]\n",
  "VERGENCES": "VERGENCE, the simultaneous turning of both eyes either inwards or outwards when changing focus, also VERGENCY [n]\n",
  "VERGENCIES": "VERGENCY, the act of verging or approaching, also VERGENCE [n]\n",
  "VERGENCY": "the act of verging or approaching, also VERGENCE [n VERGENCIES]\n",
  "VERGER": "a church official, also VIRGER [n -S]\n",
  "VERGERS": "VERGER, a church official, also VIRGER [n]\n",
  "VERGERSHIP": "the office of verger [n -S]\n",
  "VERGERSHIPS": "VERGERSHIP, the office of verger [n]\n",
  "VERGES": "VERGE, to come near [v]\n",
  "VERGING": "VERGE, to come near [v]\n",
  "VERGLAS": "(French) a film of ice on rock [n -ES]\n",
  "VERGLASES": "VERGLAS, (French) a film of ice on rock [n]\n",
  "VERIDIC": "truthful; corresponding to reality, also VERIDICAL [adj VERIDICALLY]\n",
  "VERIDICAL": "truthful; corresponding to reality, also VERIDIC [adj VERIDICALLY]\n",
  "VERIDICALITIES": "VERIDICALITY, the state of being veridical, truthful [n]\n",
  "VERIDICALITY": "the state of being veridical, truthful [n VERIDICALITIES]\n",
  "VERIDICALLY": "VERIDICAL, truthful; corresponding to reality, also VERIDIC [adv]\n",
  "VERIDICOUS": "truthful [adj]\n",
  "VERIER": "VERY, absolute [adj]\n",
  "VERIEST": "VERY, absolute [adj]\n",
  "VERIFIABILITIES": "VERIFIABILITY, the state of being verifiable [n]\n",
  "VERIFIABILITY": "the state of being verifiable [n VERIFIABILITIES]\n",
  "VERIFIABLE": "that can be verified [adj VERIFIABLY]\n",
  "VERIFIABLENESS": "the state of being verifiable [n]\n",
  "VERIFIABLY": "VERIFIABLE, that can be verified [adv]\n",
  "VERIFICATION": "the act of verifying [n -S]\n",
  "VERIFICATIONS": "VERIFICATION, the act of verifying [n]\n",
  "VERIFICATIVE": "serving to verify, also VERIFICATORY [adj]\n",
  "VERIFICATORY": "serving to verify, also VERIFICATIVE [adj]\n",
  "VERIFIED": "VERIFY, to prove to be true [v]\n",
  "VERIFIER": "one who verifies [n -S]\n",
  "VERIFIERS": "VERIFIER, one who verifies [n]\n",
  "VERIFIES": "VERIFY, to prove to be true [v]\n",
  "VERIFY": "to prove to be true [v VERIFIED, VERIFYING, VERIFIES]\n",
  "VERIFYING": "VERIFY, to prove to be true [v]\n",
  "VERILY": "in truth [adv]\n",
  "VERISIMILAR": "seeming real or true [adj VERISIMILARLY]\n",
  "VERISIMILARLY": "VERISIMILAR, seeming real or true [adv]\n",
  "VERISIMILITIES": "VERISIMILITY, (obsolete) verisimilitude [n]\n",
  "VERISIMILITUDE": "the state of being verisimilar, having the appearance of truth [n -S]\n",
  "VERISIMILITUDES": "VERISIMILITUDE, the state of being verisimilar, having the appearance of truth [n]\n",
  "VERISIMILITY": "(obsolete) verisimilitude [n VERISIMILITIES]\n",
  "VERISIMILOUS": "having the appearance of truth [adj]\n",
  "VERISM": "realism in art or literature, also VERISMO [n -S]\n",
  "VERISMO": "(Italian) realism in art or literature, also VERISM [n -S]\n",
  "VERISMOS": "VERISMO, (Italian) realism in art or literature, also VERISM [n]\n",
  "VERISMS": "VERISM, realism in art or literature, also VERISMO [n]\n",
  "VERIST": "an adherent of verism, an artistic preference for the everyday over the legendary [n -S]\n",
  "VERISTIC": "relating to verism, an artistic preference for the everyday over the legendary [adj]\n",
  "VERISTS": "VERIST, an adherent of verism, an artistic preference for the everyday over the legendary [n]\n",
  "VERITABLE": "true [adj VERITABLY]\n",
  "VERITABLENESS": "the state of being veritable [n -ES]\n",
  "VERITABLENESSES": "VERITABLENESS, the state of being veritable [n]\n",
  "VERITABLY": "VERITABLE, true [adv]\n",
  "VERITAS": "(Latin) truth [n VERITATES]\n",
  "VERITATES": "VERITAS, (Latin) truth [n]\n",
  "VERITE": "(French) reality, truth, as in cinema verite [n -S]\n",
  "VERITES": "VERITE, (French) reality, truth, as in cinema verite [n]\n",
  "VERITIES": "VERITY, truth [n]\n",
  "VERITY": "truth [n VERITIES]\n",
  "VERJUICE": "the sour juice of crab apples or of unripe fruit (as grapes or apples), also VERJUS [n -S] / to make sour with verjuice [v VERJUICED, VERJUICING, VERJUICES]\n",
  "VERJUICED": "VERJUICE, to make sour with verjuice [v]\n",
  "VERJUICES": "VERJUICE, to make sour with verjuice [v]\n",
  "VERJUICING": "VERJUICE, to make sour with verjuice [v]\n",
  "VERJUS": "the sour juice of crab apples or of unripe fruit (as grapes or apples), also VERJUICE [n -ES]\n",
  "VERJUSES": "VERJUS, the sour juice of crab apples or of unripe fruit (as grapes or apples), also VERJUICE [n]\n",
  "VERKLEMPT": "overcome with emotion, choked up [adj]\n",
  "VERKRAMP": "(South African) in South Africa, narrow-minded and illiberal esp. towards black and coloured people, also VERKRAMPTE [adj]\n",
  "VERKRAMPTE": "(South African) one who is narrow-minded and illiberal esp. towards black and coloured people [n -S]\n",
  "VERKRAMPTES": "VERKRAMPTE, (South African) one who is narrow-minded and illiberal esp. towards black and coloured people [n]\n",
  "VERLAN": "(French) a variety of French slang using back-to-front words and Arab words [n -S]\n",
  "VERLANS": "VERLAN, (French) a variety of French slang using back-to-front words and Arab words [n]\n",
  "VERLIG": "(South African) politically liberal, also VERLIGTE [adj]\n",
  "VERLIGTE": "(South African) liberal, politically enlightened, also VERLIG [adj] / a liberal [n -S]\n",
  "VERLIGTES": "VERLIGTE, a liberal [n]\n",
  "VERMAL": "relating to a vermis, a worm or wormlike structure [adj]\n",
  "VERMEIL": "to colour red, also VERMIL [v VERMEILLED, VERMEILLING, VERMEILS]\n",
  "VERMEILED": "VERMEIL, to colour red, also VERMIL [v]\n",
  "VERMEILING": "VERMEIL, to colour red, also VERMIL [v]\n",
  "VERMEILLE": "to make crimson [v VERMEILLED, VERMEILLING, VERMEILLES]\n",
  "VERMEILLED": "VERMEIL, to colour red, also VERMIL [v]\n",
  "VERMEILLES": "VERMEILLE, to make crimson [v]\n",
  "VERMEILLING": "VERMEIL, to colour red, also VERMIL [v]\n",
  "VERMEILS": "VERMEIL, to colour red, also VERMIL [v]\n",
  "VERMELL": "(Spenser) vermilion [n -S]\n",
  "VERMELLS": "VERMELL, (Spenser) vermilion [n]\n",
  "VERMES": "VERMIS, (Latin) a wormlike structure; esp (more fully vermis cerebelli) the median part of the cerebellum, between the two hemispheres [n]\n",
  "VERMIAN": "pertaining to worms [adj]\n",
  "VERMICELLI": "(Italian) a very slender type of pasta [n -S]\n",
  "VERMICELLIS": "VERMICELLI, (Italian) a very slender type of pasta [n]\n",
  "VERMICIDAL": "suitable for killing worms [adj]\n",
  "VERMICIDE": "a substance that kills worms [n -S]\n",
  "VERMICIDES": "VERMICIDE, a substance that kills worms [n]\n",
  "VERMICULAR": "resembling a worm in form or motion [adj]\n",
  "VERMICULARLY": "VERMICULAR, resembling a worm in form or motion [adv]\n",
  "VERMICULATE": "to decorate in a manner reminiscent of a mass of curly worms [v VERMICULATED, VERMICULATING, VERMICULATES]\n",
  "VERMICULATED": "VERMICULATE, to decorate in a manner reminiscent of a mass of curly worms [v]\n",
  "VERMICULATES": "VERMICULATE, to decorate in a manner reminiscent of a mass of curly worms [v]\n",
  "VERMICULATING": "VERMICULATE, to decorate in a manner reminiscent of a mass of curly worms [v]\n",
  "VERMICULATION": "wormlike markings [n -S]\n",
  "VERMICULATIONS": "VERMICULATION, wormlike markings [n]\n",
  "VERMICULE": "a small worm or insect larva; also, a wormlike body [n -S]\n",
  "VERMICULES": "VERMICULE, a small worm or insect larva; also, a wormlike body [n]\n",
  "VERMICULITE": "an altered form of mica that expands greatly at high-temperature, forming a water-absorbent substance used in seed-planting [n -S]\n",
  "VERMICULITES": "VERMICULITE, an altered form of mica that expands greatly at high-temperature, forming a water-absorbent substance used in seed-planting [n]\n",
  "VERMICULOUS": "wormy [adj]\n",
  "VERMICULTURE": "the farming of earthworms, esp. as bait for fishing [n -S]\n",
  "VERMICULTURES": "VERMICULTURE, the farming of earthworms, esp. as bait for fishing [n]\n",
  "VERMIFORM": "having the form of a worm e.g. vermiform appendix [adj]\n",
  "VERMIFUGAL": "serving to expel worms [adj]\n",
  "VERMIFUGE": "a medicine or substance that expels worms from animal bodies [n -S]\n",
  "VERMIFUGES": "VERMIFUGE, a medicine or substance that expels worms from animal bodies [n]\n",
  "VERMIL": "to colour red, also VERMEIL, VERMEILLE [v VERMILLED, VERMILLING, VERMILS]\n",
  "VERMILIES": "VERMILY, (Spenser) vermilion, also VERMEIL, VERMEILLE, VERMELL, VERMIL, VERMILION, VERMILLION [n]\n",
  "VERMILION": "bright red [adj] / a bright red colour VERMEIL, VERMEILLE, VERMELL, VERMIL, VERMILLION, VERMILY [n -S] / to make vermilion [v -ED, -ING, -S]\n",
  "VERMILIONED": "VERMILION, to make vermilion [v]\n",
  "VERMILIONING": "VERMILION, to make vermilion [v]\n",
  "VERMILIONS": "VERMILION, to make vermilion [v]\n",
  "VERMILLED": "VERMIL, to colour red, also VERMEIL, VERMEILLE [v]\n",
  "VERMILLING": "VERMIL, to colour red, also VERMEIL, VERMEILLE [v]\n",
  "VERMILLION": "bright red [adj] / a bright red colour, also VERMEIL, VERMEILLE, VERMELL, VERMIL, VERMILION, VERMILY [n -S]\n",
  "VERMILLIONS": "VERMILLION, a bright red colour, also VERMEIL, VERMEILLE, VERMELL, VERMIL, VERMILION, VERMILY [n]\n",
  "VERMILS": "VERMIL, to colour red, also VERMEIL, VERMEILLE [v]\n",
  "VERMILY": "(Spenser) vermilion, also VERMEIL, VERMEILLE, VERMELL, VERMIL, VERMILION, VERMILLION [n VERMILIES]\n",
  "VERMIN": "troublesome animals or birds [n -S]\n",
  "VERMINATE": "to breed vermin [v VERMINATED, VERMINATING, VERMINATES]\n",
  "VERMINATED": "VERMINATE, to breed vermin [v]\n",
  "VERMINATES": "VERMINATE, to breed vermin [v]\n",
  "VERMINATING": "VERMINATE, to breed vermin [v]\n",
  "VERMINATION": "worm infestation; worm breeding [n -S]\n",
  "VERMINATIONS": "VERMINATION, worm infestation; worm breeding [n]\n",
  "VERMINED": "infested with vermin, also VERMINY [adj]\n",
  "VERMINIER": "VERMINY, full of vermin [adj]\n",
  "VERMINIEST": "VERMINY, full of vermin [adj]\n",
  "VERMINOUS": "full of vermin [adj VERMINOUSLY]\n",
  "VERMINOUSLY": "VERMINOUS, full of vermin [adv]\n",
  "VERMINOUSNESS": "the state of being verminous [n -ES]\n",
  "VERMINOUSNESSES": "VERMINOUSNESS, the state of being verminous [n]\n",
  "VERMINS": "VERMIN, troublesome animals or birds [n]\n",
  "VERMINY": "full of vermin [adj VERMINIER, VERMINIEST]\n",
  "VERMIS": "(Latin) a wormlike structure; esp (more fully vermis cerebelli) the median part of the cerebellum, between the two hemispheres [n VERMES]\n",
  "VERMIVOROUS": "eating worms [adj]\n",
  "VERMOULU": "(French) eaten by worms [adj]\n",
  "VERMOUTH": "(French) a drink with a white wine base, flavoured with wormwood and other herbs, also VERMUTH [n -S]\n",
  "VERMOUTHS": "VERMOUTH, (French) a drink with a white wine base, flavoured with wormwood and other herbs, also VERMUTH [n]\n",
  "VERMUTH": "(French) a drink with a white wine base, flavoured with wormwood and other herbs, also VERMOUTH [n -S]\n",
  "VERMUTHS": "VERMUTH, (French) a drink with a white wine base, flavoured with wormwood and other herbs, also VERMOUTH [n]\n",
  "VERNACLE": "a handkerchief bearing the image of Christ's face, also VERNICLE, VERONICA [n -S]\n",
  "VERNACLES": "VERNACLE, a handkerchief bearing the image of Christ's face, also VERNICLE, VERONICA [n]\n",
  "VERNACULAR": "indigenous, native, spoken by the people of the country or of one's own country [adj VERNACULARLY] / a vernacular language, expression, or mode of expression [n -S]\n",
  "VERNACULARISE": "to make vernacular, also VERNACULARIZE [v VERNACULARISED, VERNACULARISING, VERNACULARISES]\n",
  "VERNACULARISED": "VERNACULARISE, to make vernacular, also VERNACULARIZE [v]\n",
  "VERNACULARISES": "VERNACULARISE, to make vernacular, also VERNACULARIZE [v]\n",
  "VERNACULARISING": "VERNACULARISE, to make vernacular, also VERNACULARIZE [v]\n",
  "VERNACULARISM": "a vernacular word or idiom [n -S]\n",
  "VERNACULARISMS": "VERNACULARISM, a vernacular word or idiom [n]\n",
  "VERNACULARIST": "a user of the vernacular [n -S]\n",
  "VERNACULARISTS": "VERNACULARIST, a user of the vernacular [n]\n",
  "VERNACULARITIES": "VERNACULARITY, the state of being vernacular [n]\n",
  "VERNACULARITY": "the state of being vernacular [n VERNACULARITIES]\n",
  "VERNACULARIZE": "to make vernacular, also VERNACULARISE [v VERNACULARIZED, VERNACULARIZING, VERNACULARIZES]\n",
  "VERNACULARIZED": "VERNACULARIZE, to make vernacular, also VERNACULARISE [v]\n",
  "VERNACULARIZES": "VERNACULARIZE, to make vernacular, also VERNACULARISE [v]\n",
  "VERNACULARIZING": "VERNACULARIZE, to make vernacular, also VERNACULARISE [v]\n",
  "VERNACULARLY": "VERNACULAR, indigenous, native, spoken by the people of the country or of one's own country [adv]\n",
  "VERNACULARS": "VERNACULAR, a vernacular language, expression, or mode of expression [n]\n",
  "VERNAL": "pertaining to spring [adj VERNALLY]\n",
  "VERNALISATION": "subjecting seeds to low temperatures to hasten plant development, also VERNALIZATION [n -S]\n",
  "VERNALISATIONS": "VERNALISATION, subjecting seeds to low temperatures to hasten plant development, also VERNALIZATION [n]\n",
  "VERNALISE": "to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALIZE [v VERNALISED, VERNALISING, VERNALISES]\n",
  "VERNALISED": "VERNALISE, to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALIZE [v]\n",
  "VERNALISES": "VERNALISE, to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALIZE [v]\n",
  "VERNALISING": "VERNALISE, to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALIZE [v]\n",
  "VERNALITIES": "VERNALITY, the quality of being vernal, springlike [n]\n",
  "VERNALITY": "the quality of being vernal, springlike [n VERNALITIES]\n",
  "VERNALIZATION": "subjecting seeds to low temperatures to hasten plant development, also VERNALISATION [n -S]\n",
  "VERNALIZATIONS": "VERNALIZATION, subjecting seeds to low temperatures to hasten plant development, also VERNALISATION [n]\n",
  "VERNALIZE": "to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALISE [v VERNALIZED, VERNALIZING, VERNALIZES]\n",
  "VERNALIZED": "VERNALIZE, to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALISE [v]\n",
  "VERNALIZES": "VERNALIZE, to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALISE [v]\n",
  "VERNALIZING": "VERNALIZE, to cause (plants) to come to early maturity, esp. by chilling seeds, bulbs etc., also VERNALISE [v]\n",
  "VERNALLY": "VERNAL, pertaining to spring [adv]\n",
  "VERNANT": "sprouting in spring [adj]\n",
  "VERNATION": "the arrangement of the leaves within the leaf bud [n -S]\n",
  "VERNATIONS": "VERNATION, the arrangement of the leaves within the leaf bud [n]\n",
  "VERNICLE": "a handkerchief bearing the image of Christ's face, also VERNACLE, VERONICA [n -S]\n",
  "VERNICLES": "VERNICLE, a handkerchief bearing the image of Christ's face, also VERNACLE, VERONICA [n]\n",
  "VERNIER": "(French) an auxiliary scale that gives fractional readings [n -S]\n",
  "VERNIERS": "VERNIER, (French) an auxiliary scale that gives fractional readings [n]\n",
  "VERNISSAGE": "(French) a private showing or preview of an art collection [n -S]\n",
  "VERNISSAGES": "VERNISSAGE, (French) a private showing or preview of an art collection [n]\n",
  "VERNIX": "(Latin) a fatty substance covering the skin of a fetus [n -ES]\n",
  "VERNIXES": "VERNIX, (Latin) a fatty substance covering the skin of a fetus [n]\n",
  "VERONAL": "a barbitone [n -S]\n",
  "VERONALS": "VERONAL, a barbitone [n]\n",
  "VERONICA": "a handkerchief bearing the image of Christ's face, also VERNICLE, VERNACLE [n -S]\n",
  "VERONICAS": "VERONICA, a handkerchief bearing the image of Christ's face, also VERNICLE, VERNACLE [n]\n",
  "VERONIQUE": "(French) served with white grapes e.g. sole veronique [adj]\n",
  "VERQUERE": "(Dutch) a form of backgammon, also VERQUIRE [n -S]\n",
  "VERQUERES": "VERQUERE, (Dutch) a form of backgammon, also VERQUIRE [n]\n",
  "VERQUIRE": "a form of backgammon, also VERQUERE [n -S]\n",
  "VERQUIRES": "VERQUIRE, a form of backgammon, also VERQUERE [n]\n",
  "VERRA": "(Scots) very, also VERA [adj]\n",
  "VERREL": "a band placed around the end of a stick (as a pool cue) for reinforcement, also FERREL, FERRULE, VIRL [n -S]\n",
  "VERRELS": "VERREL, a band placed around the end of a stick (as a pool cue) for reinforcement, also FERREL, FERRULE, VIRL [n]\n",
  "VERREY": "charged or variegated with vair, squirrel fur, also VAIRE, VAIRY, VERRY [adj]\n",
  "VERRINE": "an appetiser or dessert consisting of layers of different food presented in a glass [n -S]\n",
  "VERRINES": "VERRINE, an appetiser or dessert consisting of layers of different food presented in a glass [n]\n",
  "VERRUCA": "(Latin) a plantar wart [n VERRUCAE or VERRUCAS]\n",
  "VERRUCAE": "VERRUCA, (Latin) a plantar wart [n]\n",
  "VERRUCAS": "VERRUCA, (Latin) a plantar wart [n]\n",
  "VERRUCIFORM": "shaped like a wart; wartlike [adj]\n",
  "VERRUCOSE": "covered with warty elevations, also VERRUCOUS [adj]\n",
  "VERRUCOSITIES": "VERRUCOSITY, the state of being verrucose, covered with warty elevations [n]\n",
  "VERRUCOSITY": "the state of being verrucose, covered with warty elevations [n VERRUCOSITIES]\n",
  "VERRUCOUS": "covered with warty elevations, also VERRUCOSE [adj]\n",
  "VERRUGA": "(Spanish) a fever with warty tumours, endemic in Peru [n -S]\n",
  "VERRUGAS": "VERRUGA, (Spanish) a fever with warty tumours, endemic in Peru [n]\n",
  "VERRY": "charged or variegated with vair, squirrel fur, also VAIRE, VAIRY, VERREY [adj]\n",
  "VERS": "(French) verse [n]\n",
  "VERSABILITIES": "VERSABILITY, (obsolete) aptness to be turned around [n]\n",
  "VERSABILITY": "(obsolete) aptness to be turned around [n VERSABILITIES]\n",
  "VERSAL": "an ornamental letter at the beginning of a section, e.g. in an illuminated manuscript [n -S]\n",
  "VERSALS": "VERSAL, an ornamental letter at the beginning of a section, e.g. in an illuminated manuscript [n]\n",
  "VERSANT": "the slope of a mountain chain [n -S]\n",
  "VERSANTS": "VERSANT, the slope of a mountain chain [n]\n",
  "VERSATILE": "turning easily from one thing to another [adj VERSATILELY]\n",
  "VERSATILELY": "VERSATILE, turning easily from one thing to another [adv]\n",
  "VERSATILENESS": "the state of being versatile [n -ES]\n",
  "VERSATILENESSES": "VERSATILENESS, the state of being versatile [n]\n",
  "VERSATILITIES": "VERSATILITY, the state of being versatile [n]\n",
  "VERSATILITY": "the state of being versatile [n VERSATILITIES]\n",
  "VERSE": "to write in a poetic form [v VERSED, VERSING, VERSES]\n",
  "VERSED": "VERSE, to write in a poetic form [v]\n",
  "VERSELET": "a little verse [n -S]\n",
  "VERSELETS": "VERSELET, a little verse [n]\n",
  "VERSEMAN": "one who writes verses, an inferior poet [n VERSEMEN]\n",
  "VERSEMEN": "VERSEMAN, one who writes verses, an inferior poet [n]\n",
  "VERSER": "a versifier [n -S]\n",
  "VERSERS": "VERSER, a versifier [n]\n",
  "VERSES": "VERSE, to write in a poetic form [v]\n",
  "VERSET": "a short line of metrical writing, also VERSICLE [n -S]\n",
  "VERSETS": "VERSET, a short line of metrical writing, also VERSICLE [n]\n",
  "VERSICLE": "a short verse in a church service normally followed by response [n -S]\n",
  "VERSICLES": "VERSICLE, a short verse in a church service normally followed by response [n]\n",
  "VERSICOLOR": "of variable or various colours, also VERSICOLORED, VERSICOLOUR, VERSICOLOURED [adj]\n",
  "VERSICOLORED": "of variable or various colours, also VERSICOLOR, VERSICOLOUR, VERSICOLOURED [adj]\n",
  "VERSICOLOUR": "of variable or various colours, also VERSICOLOR, VERSICOLORED, VERSICOLOURED [adj]\n",
  "VERSICOLOURED": "of variable or various colours, also VERSICOLOR, VERSICOLORED, VERSICOLOUR [adj]\n",
  "VERSICULAR": "of or in verse [adj]\n",
  "VERSIFICATION": "the making of verses [n -S]\n",
  "VERSIFICATIONS": "VERSIFICATION, the making of verses [n]\n",
  "VERSIFICATOR": "a maker of verses, also VERSIFIER [n -S]\n",
  "VERSIFICATORS": "VERSIFICATOR, a maker of verses, also VERSIFIER [n]\n",
  "VERSIFIED": "VERSIFY, to change from prose into metrical form [v]\n",
  "VERSIFIER": "a maker of verses, also VERSIFICATOR [n -S]\n",
  "VERSIFIERS": "VERSIFIER, a maker of verses, also VERSIFICATOR [n]\n",
  "VERSIFIES": "VERSIFY, to change from prose into metrical form [v]\n",
  "VERSIFORM": "varying in form [adj]\n",
  "VERSIFY": "to change from prose into metrical form [v VERSIFIED, VERSIFYING, VERSIFIES]\n",
  "VERSIFYING": "VERSIFY, to change from prose into metrical form [v]\n",
  "VERSIN": "a versed sine, a trigonometric function of an angle, also VERSINE [n -S]\n",
  "VERSINE": "a versed sine, a trigonometric function of an angle, also VERSIN [n -S]\n",
  "VERSINES": "VERSINE, a versed sine, a trigonometric function of an angle, also VERSIN [n]\n",
  "VERSING": "the composing of verse [n -S]\n",
  "VERSINGS": "VERSING, the composing of verse [n]\n",
  "VERSINS": "VERSIN, a versed sine, a trigonometric function of an angle, also VERSINE [n]\n",
  "VERSION": "to create a new account or description from a particular point of view [v -ED, -ING, -S]\n",
  "VERSIONAL": "relating to a version [adj]\n",
  "VERSIONED": "VERSION, to create a new account or description from a particular point of view [v]\n",
  "VERSIONER": "the producer of a version [n -S]\n",
  "VERSIONERS": "VERSIONER, the producer of a version [n]\n",
  "VERSIONING": "the adaptation of classical literary texts for films [n -S]\n",
  "VERSIONINGS": "VERSIONING, the adaptation of classical literary texts for films [n]\n",
  "VERSIONIST": "the producer of a version [n -S]\n",
  "VERSIONISTS": "VERSIONIST, the producer of a version [n]\n",
  "VERSIONS": "VERSION, to create a new account or description from a particular point of view [v]\n",
  "VERSLIBRIST": "one who writes free verse, also VERSLIBRISTE [n -S]\n",
  "VERSLIBRISTE": "a writer of free verse, also VERSLIBRIST [n -S]\n",
  "VERSLIBRISTES": "VERSLIBRISTE, a writer of free verse, also VERSLIBRIST [n]\n",
  "VERSLIBRISTS": "VERSLIBRIST, one who writes free verse, also VERSLIBRISTE [n]\n",
  "VERSO": "(Latin) the reverse, or left-hand, page of a book or a folded sheet of paper [n -S]\n",
  "VERSOS": "VERSO, (Latin) the reverse, or left-hand, page of a book or a folded sheet of paper [n]\n",
  "VERST": "(Russian) a unit of distance equal to approximately 2/3 of a mile, also VERSTE [n -S]\n",
  "VERSTE": "(Russian) a unit of distance equal to approximately 2/3 of a mile, also VERST [n -S]\n",
  "VERSTES": "VERSTE, (Russian) a unit of distance equal to approximately 2/3 of a mile, also VERST [n]\n",
  "VERSTS": "VERST, (Russian) a unit of distance equal to approximately 2/3 of a mile, also VERSTE [n]\n",
  "VERSUS": "(Latin) against; in contrast to [prep]\n",
  "VERSUTE": "crafty; wily [adj]\n",
  "VERT": "(colloquial) to become a convert [v -ED, -ING, -S]\n",
  "VERTEBRA": "(Latin) a component of the vertebral column, or backbone, found in vertebrates [n VERTEBRAE or VERTEBRAS]\n",
  "VERTEBRAE": "VERTEBRA, (Latin) a component of the vertebral column, or backbone, found in vertebrates [n]\n",
  "VERTEBRAL": "of or like a vertebra [adj VERTEBRALLY]\n",
  "VERTEBRALLY": "VERTEBRAL, of or like a vertebra [adv]\n",
  "VERTEBRAS": "VERTEBRA, (Latin) a component of the vertebral column, or backbone, found in vertebrates [n]\n",
  "VERTEBRATE": "a backboned animal, one belonging to the subphylum Vertebrata, including fishes, amphibians, reptiles, birds and mammals [n -S]\n",
  "VERTEBRATED": "having a backbone [adj]\n",
  "VERTEBRATES": "VERTEBRATE, a backboned animal, one belonging to the subphylum Vertebrata, including fishes, amphibians, reptiles, birds and mammals [n]\n",
  "VERTEBRATION": "division into vertebrae [n -S]\n",
  "VERTEBRATIONS": "VERTEBRATION, division into vertebrae [n]\n",
  "VERTED": "VERT, (colloquial) to become a convert [v]\n",
  "VERTEX": "(Latin) the highest point of something [n VERTEXES or VERTICES]\n",
  "VERTEXES": "VERTEX, (Latin) the highest point of something [n]\n",
  "VERTICAL": "upright [adj VERTICALLY] / a vertical line [n -S]\n",
  "VERTICALITIES": "VERTICALITY, the state of being vertical [n]\n",
  "VERTICALITY": "the state of being vertical [n VERTICALITIES]\n",
  "VERTICALLY": "VERTICAL, upright [adv]\n",
  "VERTICALNESS": "the state of being vertical [n -ES]\n",
  "VERTICALNESSES": "VERTICALNESS, the state of being vertical [n]\n",
  "VERTICALS": "VERTICAL, a vertical line [n]\n",
  "VERTICES": "VERTEX, (Latin) the highest point of something [n]\n",
  "VERTICIL": "(Latin) a circular arrangement of similar parts, a whorl [n -S]\n",
  "VERTICILLASTER": "an inflorescence so condensed as to look like a whorl [n -S]\n",
  "VERTICILLASTERS": "VERTICILLASTER, an inflorescence so condensed as to look like a whorl [n]\n",
  "VERTICILLATE": "whorled, also VERTICILLATED [adj VERTICILLATELY]\n",
  "VERTICILLATED": "whorled, also VERTICILLATE [adj]\n",
  "VERTICILLATELY": "VERTICILLATE, whorled, also VERTICILLATED [adv]\n",
  "VERTICILLATION": "the state of being verticillate, whorled [n -S]\n",
  "VERTICILLATIONS": "VERTICILLATION, the state of being verticillate, whorled [n]\n",
  "VERTICILLIUM": "a fungus some species of which cause plant disease [n -S]\n",
  "VERTICILLIUMS": "VERTICILLIUM, a fungus some species of which cause plant disease [n]\n",
  "VERTICILS": "VERTICIL, (Latin) a circular arrangement of similar parts, a whorl [n]\n",
  "VERTICITIES": "VERTICITY, the power of turning [n]\n",
  "VERTICITY": "the power of turning [n VERTICITIES]\n",
  "VERTIGINES": "VERTIGO, (Latin) dizziness [n]\n",
  "VERTIGINOUS": "causing or tending to cause dizziness [adj VERTIGINOUSLY]\n",
  "VERTIGINOUSLY": "VERTIGINOUS, causing or tending to cause dizziness [adv]\n",
  "VERTIGINOUSNESS": "the state of being vertiginous [n]\n",
  "VERTIGO": "(Latin) dizziness [n VERTIGINES or VERTIGOES or VERTIGOS]\n",
  "VERTIGOES": "VERTIGO, (Latin) dizziness [n]\n",
  "VERTIGOS": "VERTIGO, (Latin) dizziness [n]\n",
  "VERTING": "VERT, (colloquial) to become a convert [v]\n",
  "VERTIPORT": "an airport designed for vertical takeoff and landing [n -S]\n",
  "VERTIPORTS": "VERTIPORT, an airport designed for vertical takeoff and landing [n]\n",
  "VERTISOL": "a type of clayey soil [n -S]\n",
  "VERTISOLS": "VERTISOL, a type of clayey soil [n]\n",
  "VERTS": "VERT, (colloquial) to become a convert [v]\n",
  "VERTU": "a love or taste for the fine arts, also VIRTU [n -S]\n",
  "VERTUE": "moral excellence, also VIRTUE [n -S]\n",
  "VERTUES": "VERTUE, moral excellence, also VIRTUE [n]\n",
  "VERTUOUS": "(Spenser) possessing virtue or power, also VIRTUOUS [adj]\n",
  "VERTUS": "VERTU, a love or taste for the fine arts, also VIRTU [n]\n",
  "VERUMONTANA": "VERUMONTANUM, a ridge on the male urethra where the duct conveying prostatic fluid, sperm and other fluids enters it [n]\n",
  "VERUMONTANUM": "a ridge on the male urethra where the duct conveying prostatic fluid, sperm and other fluids enters it [n VERUMONTANA or VERUMONTANUMS]\n",
  "VERUMONTANUMS": "VERUMONTANUM, a ridge on the male urethra where the duct conveying prostatic fluid, sperm and other fluids enters it [n]\n",
  "VERVAIN": "a wild verbena, believed to have magical powers, also VERVEN [n -S]\n",
  "VERVAINS": "VERVAIN, a wild verbena, believed to have magical powers, also VERVEN [n]\n",
  "VERVE": "the state of being lively, vivacity [n -S]\n",
  "VERVEL": "a ring for a hawk's jess, also VARVEL [n -S]\n",
  "VERVELLED": "having vervels, rings for a hawk's jess, also VARVELLED [adj]\n",
  "VERVELS": "VERVEL, a ring for a hawk's jess, also VARVEL [n]\n",
  "VERVEN": "(Spenser) vervain, the flower [n -S]\n",
  "VERVENS": "VERVEN, (Spenser) vervain, the flower [n]\n",
  "VERVES": "VERVE, the state of being lively, vivacity [n]\n",
  "VERVET": "(French) a small, long-tailed African monkey [n -S]\n",
  "VERVETS": "VERVET, (French) a small, long-tailed African monkey [n]\n",
  "VERY": "absolute [adj VERIER, VERIEST, VERILY]\n",
  "VESICA": "(Latin) a bladder, esp. a urinary bladder [n VESICAE or VESICAS]\n",
  "VESICAE": "VESICA, (Latin) a bladder, esp. a urinary bladder [n]\n",
  "VESICAL": "pertaining to the bladder [adj]\n",
  "VESICANT": "any agent that induces blistering [n -S]\n",
  "VESICANTS": "VESICANT, any agent that induces blistering [n]\n",
  "VESICAS": "VESICA, (Latin) a bladder, esp. a urinary bladder [n]\n",
  "VESICATE": "to blister [v VESICATED, VESICATING, VESICATES]\n",
  "VESICATED": "VESICATE, to blister [v]\n",
  "VESICATES": "VESICATE, to blister [v]\n",
  "VESICATING": "VESICATE, to blister [v]\n",
  "VESICATION": "the process of vesicating, or of raising blisters [n -S]\n",
  "VESICATIONS": "VESICATION, the process of vesicating, or of raising blisters [n]\n",
  "VESICATORIES": "VESICATORY, anything that causes blister, also VESICANT [n]\n",
  "VESICATORY": "blistering [adj] / anything that causes blister, also VESICANT [n VESICATORIES]\n",
  "VESICLE": "a small blister or bladder, also VESICULA [n -S]\n",
  "VESICLES": "VESICLE, a small blister or bladder, also VESICULA [n]\n",
  "VESICULA": "(Latin) a small blister or bladder, also VESICLE [n VESICULAE]\n",
  "VESICULAE": "VESICULA, (Latin) a small blister or bladder, also VESICLE [n]\n",
  "VESICULAR": "having vesicles e.g. of a rock [adj VESICULARLY]\n",
  "VESICULARITIES": "VESICULARITY, the state of being vesicular [n]\n",
  "VESICULARITY": "the state of being vesicular [n VESICULARITIES]\n",
  "VESICULARLY": "VESICULAR, having vesicles e.g. of a rock [adv]\n",
  "VESICULATE": "to become vesicular [v VESICULATED, VESICULATING, VESICULATES]\n",
  "VESICULATED": "VESICULATE, to become vesicular [v]\n",
  "VESICULATES": "VESICULATE, to become vesicular [v]\n",
  "VESICULATING": "VESICULATE, to become vesicular [v]\n",
  "VESICULATION": "the formation of vesicles [n -S]\n",
  "VESICULATIONS": "VESICULATION, the formation of vesicles [n]\n",
  "VESICULOSE": "in the form of a vesicula, a small blister [adj]\n",
  "VESPA": "(Latin) a genus of Hymenoptera including the common wasps and hornets [n -S]\n",
  "VESPAS": "VESPA, (Latin) a genus of Hymenoptera including the common wasps and hornets [n]\n",
  "VESPER": "(Latin) an evening service, prayer or song [n -S]\n",
  "VESPERAL": "an office-book containing the psalms, canticles, anthems, etc. used at vespers [n -S]\n",
  "VESPERALS": "VESPERAL, an office-book containing the psalms, canticles, anthems, etc. used at vespers [n]\n",
  "VESPERS": "VESPER, (Latin) an evening service, prayer or song [n]\n",
  "VESPERTILIAN": "like a bat [adj]\n",
  "VESPERTILIONID": "belonging to the Vespertilionidae family of insect-eating bats [adj] / a member of the Vespertilionidae [n -S]\n",
  "VESPERTILIONIDS": "VESPERTILIONID, a member of the Vespertilionidae [n]\n",
  "VESPERTILIONINE": "of, relating to, or belonging to the Vespertilionidae, a family of common and widespread bats [adj]\n",
  "VESPERTINAL": "of or pertaining to the evening, also VESPERTINE [adj]\n",
  "VESPERTINE": "of or pertaining to the evening, also VESPERTINAL [adj]\n",
  "VESPIARIES": "VESPIARY, a nest of wasps [n]\n",
  "VESPIARY": "a nest of wasps [n VESPIARIES]\n",
  "VESPID": "(Latin) a social wasp [n -S]\n",
  "VESPIDS": "VESPID, (Latin) a social wasp [n]\n",
  "VESPINE": "of wasps; wasplike, also VESPOID [adj]\n",
  "VESPOID": "of wasps; wasplike, also VESPINE [adj]\n",
  "VESSAIL": "(Scott) a vessel, also VASSAIL [n -S]\n",
  "VESSAILS": "VESSAIL, (Scott) a vessel, also VASSAIL [n]\n",
  "VESSEL": "a craft for travelling on water [n -S]\n",
  "VESSELED": "having a vessel [adj]\n",
  "VESSELS": "VESSEL, a craft for travelling on water [n]\n",
  "VEST": "to place authority in [v -ED, -ING, -S]\n",
  "VESTA": "(Latin) a kind of short wooden or wax match [n -S]\n",
  "VESTAL": "(Latin) one of the Roman patrician virgins consecrated to Vesta, goddess of the hearth [n -S] / relating to a vestal [adj VESTALLY]\n",
  "VESTALLY": "VESTAL, relating to a vestal [adv]\n",
  "VESTALS": "VESTAL, (Latin) one of the Roman patrician virgins consecrated to Vesta, goddess of the hearth [n]\n",
  "VESTAS": "VESTA, (Latin) a kind of short wooden or wax match [n]\n",
  "VESTED": "VEST, to place authority in [v]\n",
  "VESTEE": "a garment worn under a woman's jacket or blouse [n -S]\n",
  "VESTEES": "VESTEE, a garment worn under a woman's jacket or blouse [n]\n",
  "VESTIARIES": "VESTIARY, a dressing room [n]\n",
  "VESTIARY": "a dressing room [n VESTIARIES]\n",
  "VESTIBULA": "VESTIBULUM, (Latin) a cavity into which, in certain bryozoans, the esophagus and anus open [n]\n",
  "VESTIBULAR": "of or pertaining to a vestibule [adj]\n",
  "VESTIBULE": "an entrance-hall [n -S] / to provide (a railway carriage) with vestibules; to link by means of vestibules [v VESTIBULED, VESTIBULING, VESTIBULES]\n",
  "VESTIBULED": "VESTIBULE, to provide (a railway carriage) with vestibules; to link by means of vestibules [v]\n",
  "VESTIBULES": "VESTIBULE, to provide (a railway carriage) with vestibules; to link by means of vestibules [v]\n",
  "VESTIBULING": "VESTIBULE, to provide (a railway carriage) with vestibules; to link by means of vestibules [v]\n",
  "VESTIBULITIS": "inflammation of the labyrinth and cochlea of the inner ear, causing vertigo, ataxia and deafness [n -ES]\n",
  "VESTIBULITISES": "VESTIBULITIS, inflammation of the labyrinth and cochlea of the inner ear, causing vertigo, ataxia and deafness [n]\n",
  "VESTIBULUM": "(Latin) a cavity into which, in certain bryozoans, the esophagus and anus open [n VESTIBULA]\n",
  "VESTIGE": "a visible sign of something that is no longer in existence [n -S]\n",
  "VESTIGES": "VESTIGE, a visible sign of something that is no longer in existence [n]\n",
  "VESTIGIA": "VESTIGIUM, (Latin) a trace, a vestige [n]\n",
  "VESTIGIAL": "of or like a vestige [adj VESTIGIALLY]\n",
  "VESTIGIALLY": "VESTIGIAL, of or like a vestige [adv]\n",
  "VESTIGIUM": "(Latin) a trace, a vestige [n VESTIGIA]\n",
  "VESTIMENT": "(obsolete) vestment, garb [n -S]\n",
  "VESTIMENTAL": "of or like a vestiment, also VESTIMENTARY [adj]\n",
  "VESTIMENTARY": "of or like a vestiment, also VESTIMENTAL [adj]\n",
  "VESTIMENTS": "VESTIMENT, (obsolete) vestment, garb [n]\n",
  "VESTING": "the act of placing authority in [n -S]\n",
  "VESTINGS": "VESTING, the act of placing authority in [n]\n",
  "VESTITURE": "clothes [n -S]\n",
  "VESTITURES": "VESTITURE, clothes [n]\n",
  "VESTLESS": "without a vest [adj]\n",
  "VESTLIKE": "resembling a short sleeveless garment [adj]\n",
  "VESTMENT": "a ceremonial garment of the clergy, also VESTIMENT [n -S]\n",
  "VESTMENTAL": "relating to a vestment [adj]\n",
  "VESTMENTED": "wearing a vestment [adj]\n",
  "VESTMENTS": "VESTMENT, a ceremonial garment of the clergy, also VESTIMENT [n]\n",
  "VESTRAL": "relating to a vestry [adj]\n",
  "VESTRIES": "VESTRY, a room in which vestments are kept, also REVESTRY [n]\n",
  "VESTRY": "a room in which vestments are kept, also REVESTRY [n VESTRIES]\n",
  "VESTRYMAN": "a member of a vestry [n VESTRYMEN]\n",
  "VESTRYMEN": "VESTRYMAN, a member of a vestry [n]\n",
  "VESTS": "VEST, to place authority in [v]\n",
  "VESTURAL": "relating to vesture, clothing [adj]\n",
  "VESTURE": "clothing, esp. ecclesiastical; anything that covers or cloaks [n -S] / (archaic) to clothe [v VESTURED, VESTURING, VESTURES]\n",
  "VESTURED": "VESTURE, (archaic) to clothe [v]\n",
  "VESTURER": "a person responsible for care of clerical vestments and for other church duties [n -S]\n",
  "VESTURERS": "VESTURER, a person responsible for care of clerical vestments and for other church duties [n]\n",
  "VESTURES": "VESTURE, (archaic) to clothe [v]\n",
  "VESTURING": "VESTURE, (archaic) to clothe [v]\n",
  "VESUVIAN": "a smoker's slow-burning match [n -S]\n",
  "VESUVIANITE": "a silicate of calcium, magnesium, and aluminium, aka idocrase, occurring as brown, yellow, or green crystals or masses in metamorphosed limestones [n -S]\n",
  "VESUVIANITES": "VESUVIANITE, a silicate of calcium, magnesium, and aluminium, aka idocrase, occurring as brown, yellow, or green crystals or masses in metamorphosed limestones [n]\n",
  "VESUVIANS": "VESUVIAN, a smoker's slow-burning match [n]\n",
  "VET": "to treat animals medically [v VETTED, VETTING, VETS]\n",
  "VETCH": "any of a number of leguminous flowers [n -ES]\n",
  "VETCHES": "VETCH, any of a number of leguminous flowers [n]\n",
  "VETCHIER": "VETCHY, covered with vetches [adj]\n",
  "VETCHIEST": "VETCHY, covered with vetches [adj]\n",
  "VETCHLING": "any small leguminous plant of the genus Lathyrus [n -S]\n",
  "VETCHLINGS": "VETCHLING, any small leguminous plant of the genus Lathyrus [n]\n",
  "VETCHY": "covered with vetches [adj VETCHIER, VETCHIEST]\n",
  "VETERAN": "a former member of the armed forces [n -S]\n",
  "VETERANS": "VETERAN, a former member of the armed forces [n]\n",
  "VETERINARIAN": "a person qualified and authorized to practice veterinary medicine [n -S]\n",
  "VETERINARIANS": "VETERINARIAN, a person qualified and authorized to practice veterinary medicine [n]\n",
  "VETERINARIES": "VETERINARY, a person trained in the treatment of diseases of domestic animals [n]\n",
  "VETERINARY": "a person trained in the treatment of diseases of domestic animals [n VETERINARIES]\n",
  "VETIVER": "(Tamil) an East Indian grass; also, its fragrant roots which are much used for making mats and screens [n -S]\n",
  "VETIVERS": "VETIVER, (Tamil) an East Indian grass; also, its fragrant roots which are much used for making mats and screens [n]\n",
  "VETIVERT": "(Tamil) the essential oil of the vetiver, an East Indian grass [n -S]\n",
  "VETIVERTS": "VETIVERT, (Tamil) the essential oil of the vetiver, an East Indian grass [n]\n",
  "VETKOEK": "(South African) a deep-fried cake, similar to a doughnut [n -S]\n",
  "VETKOEKS": "VETKOEK, (South African) a deep-fried cake, similar to a doughnut [n]\n",
  "VETO": "(Latin) to forbid or prevent authoritatively [v -ED, -ING, -ES]\n",
  "VETOED": "VETO, (Latin) to forbid or prevent authoritatively [v]\n",
  "VETOER": "one who vetoes [n -S]\n",
  "VETOERS": "VETOER, one who vetoes [n]\n",
  "VETOES": "VETO, (Latin) to forbid or prevent authoritatively [v]\n",
  "VETOING": "VETO, (Latin) to forbid or prevent authoritatively [v]\n",
  "VETOLESS": "not exercising a veto [adj]\n",
  "VETS": "VET, to treat animals medically [v]\n",
  "VETTED": "VET, to treat animals medically [v]\n",
  "VETTER": "one that evaluates something for approval [n -S]\n",
  "VETTERS": "VETTER, one that evaluates something for approval [n]\n",
  "VETTING": "as in positive vetting, the process of security clearance [n -S]\n",
  "VETTINGS": "VETTING, as in positive vetting, the process of security clearance [n]\n",
  "VETTURA": "(Italian) a carriage, cab or car [n -S]\n",
  "VETTURAS": "VETTURA, (Italian) a carriage, cab or car [n]\n",
  "VETTURINI": "VETTURINO, (Italian) one who lets or drives a vettura [n]\n",
  "VETTURINO": "(Italian) one who lets or drives a vettura [n VETTURINI or VETTURINOS]\n",
  "VETTURINOS": "VETTURINO, (Italian) one who lets or drives a vettura [n]\n",
  "VEX": "to distress or annoy [v VEXED or (obsolete) VEXT, VEXING, VEXES]\n",
  "VEXATION": "a cause of trouble [n -S]\n",
  "VEXATIONS": "VEXATION, a cause of trouble [n]\n",
  "VEXATIOUS": "causing vexation [adj VEXATIOUSLY]\n",
  "VEXATIOUSLY": "VEXATIOUS, causing vexation [adv]\n",
  "VEXATIOUSNESS": "the state of being vexatious [n -ES]\n",
  "VEXATIOUSNESSES": "VEXATIOUSNESS, the state of being vexatious [n]\n",
  "VEXATORY": "causing annoyance [adj]\n",
  "VEXED": "VEX, to distress or annoy [v]\n",
  "VEXEDLY": "VEXED, VEX, to distress or annoy [adv]\n",
  "VEXEDNESS": "the state of being vexed [n -ES]\n",
  "VEXEDNESSES": "VEXEDNESS, the state of being vexed [n]\n",
  "VEXER": "one who vexes [n -S]\n",
  "VEXERS": "VEXER, one who vexes [n]\n",
  "VEXES": "VEX, to distress or annoy [v]\n",
  "VEXIL": "the web or vane of a feather, also VEXILLUM [n -S]\n",
  "VEXILLA": "VEXILLUM, (Latin) the web or vane of a feather, also VEXIL [n]\n",
  "VEXILLAR": "of or like a vexillum, the vane of a feather, also VEXILLATE [adj]\n",
  "VEXILLARIES": "VEXILLARY, a standard-bearer [n]\n",
  "VEXILLARY": "a standard-bearer [n VEXILLARIES]\n",
  "VEXILLATE": "of or like a vexillum, the vane of a feather, also VEXILLAR [adj]\n",
  "VEXILLATION": "a company under one vexillum [n -S]\n",
  "VEXILLATIONS": "VEXILLATION, a company under one vexillum [n]\n",
  "VEXILLOLOGIC": "relating to vexillology, the study of flags, also VEXILLOLOGICAL [adj]\n",
  "VEXILLOLOGICAL": "relating to vexillology, the study of flags, also VEXILLOLOGIC [adj]\n",
  "VEXILLOLOGIES": "VEXILLOLOGY, the study of flags [n]\n",
  "VEXILLOLOGIST": "one who studies flags [n -S]\n",
  "VEXILLOLOGISTS": "VEXILLOLOGIST, one who studies flags [n]\n",
  "VEXILLOLOGY": "the study of flags [n VEXILLOLOGIES]\n",
  "VEXILLUM": "(Latin) the web or vane of a feather, also VEXIL [n VEXILLA]\n",
  "VEXILS": "VEXIL, the web or vane of a feather, also VEXILLUM [n]\n",
  "VEXING": "annoying [adj VEXINGLY] / the act of vexing [n -S]\n",
  "VEXINGLY": "VEXING, annoying [adv]\n",
  "VEXINGNESS": "the state of being vexing [n -ES]\n",
  "VEXINGNESSES": "VEXINGNESS, the state of being vexing [n]\n",
  "VEXINGS": "VEXING, the act of vexing [n]\n",
  "VEXT": "VEX, to distress or annoy [v]\n",
  "VEZIR": "(Arabic) a minister in various Muslim states, also PHEAZAR, VISIER, VIZIER, VIZIR, WAZIR, WIZIER [n -S]\n",
  "VEZIRS": "VEZIR, (Arabic) a minister in various Muslim states, also PHEAZAR, VISIER, VIZIER, VIZIR, WAZIR, WIZIER [n]\n",
  "VIA": "(Latin) a way [n VIAS or VIAE]\n",
  "VIABILITIES": "VIABILITY, the state of being viable [n]\n",
  "VIABILITY": "the state of being viable [n VIABILITIES]\n",
  "VIABLE": "capable of living [adj VIABLY]\n",
  "VIABLY": "VIABLE, capable of living [adv]\n",
  "VIADUCT": "a structure carrying a road or railway over a valley, etc. [n -S]\n",
  "VIADUCTS": "VIADUCT, a structure carrying a road or railway over a valley, etc. [n]\n",
  "VIAE": "VIA, (Latin) a way [n]\n",
  "VIAL": "to put in a small container for liquids [v VIALLED or VIALED, VIALLING or VIALING, VIALS]\n",
  "VIALED": "VIAL, to put in a small container for liquids [v]\n",
  "VIALFUL": "as much as a vial can hold [n -S]\n",
  "VIALFULS": "VIALFUL, as much as a vial can hold [n]\n",
  "VIALING": "VIAL, to put in a small container for liquids [v]\n",
  "VIALLED": "VIAL, to put in a small container for liquids [v]\n",
  "VIALLING": "VIAL, to put in a small container for liquids [v]\n",
  "VIALS": "VIAL, to put in a small container for liquids [v]\n",
  "VIAMETER": "a device for measuring distance travelled [n -S]\n",
  "VIAMETERS": "VIAMETER, a device for measuring distance travelled [n]\n",
  "VIAND": "an item of food; esp. a choice or tasty dish [n -S]\n",
  "VIANDS": "VIAND, an item of food; esp. a choice or tasty dish [n]\n",
  "VIAS": "VIA, (Latin) a way [n]\n",
  "VIATIC": "pertaining to travelling, also VIATICAL [adj]\n",
  "VIATICA": "VIATICUM, (Latin) an allowance for travelling expenses [n]\n",
  "VIATICAL": "pertaining to travelling, also VIATIC [adj]\n",
  "VIATICALS": "baggage [n]\n",
  "VIATICUM": "(Latin) an allowance for travelling expenses [n VIATICUMS or VIATICA]\n",
  "VIATICUMS": "VIATICUM, (Latin) an allowance for travelling expenses [n]\n",
  "VIATOR": "(Latin) a traveller [n VIATORS or VIATORES]\n",
  "VIATORES": "VIATOR, (Latin) a traveller [n]\n",
  "VIATORIAL": "travelling [adj]\n",
  "VIATORS": "VIATOR, (Latin) a traveller [n]\n",
  "VIBE": "(colloquial) a vibration [n -S]\n",
  "VIBES": "VIBE, (colloquial) a vibration [n]\n",
  "VIBEX": "(Latin) a streak under the skin due to extravasation of blood [n VIBICES]\n",
  "VIBEY": "lively, vibrant [adj VIBIER, VIBIEST]\n",
  "VIBICES": "VIBEX, (Latin) a streak under the skin due to extravasation of blood [n]\n",
  "VIBIER": "VIBEY, lively, vibrant [adj]\n",
  "VIBIEST": "VIBEY, lively, vibrant [adj]\n",
  "VIBIST": "(colloquial) a person who plays the vibraphone [n -S]\n",
  "VIBISTS": "VIBIST, (colloquial) a person who plays the vibraphone [n]\n",
  "VIBRACULA": "VIBRACULUM, (Latin) one of the movable, slender, spinelike organs or parts with which certain bryozoans are furnished [n]\n",
  "VIBRACULAR": "of or like a vibraculum, one of the movable, slender, spinelike organs or parts with which certain bryozoans are furnished, also VIBRACULOID [adj]\n",
  "VIBRACULARIA": "VIBRACULARIUM, a long bristle, a modified zooid, in some Polyzoa [n]\n",
  "VIBRACULARIUM": "a long bristle, a modified zooid, in some Polyzoa [n VIBRACULARIA]\n",
  "VIBRACULOID": "of or like a vibraculum, one of the movable, slender, spinelike organs or parts with which certain bryozoans are furnished, also VIBRACULAR [adj]\n",
  "VIBRACULUM": "(Latin) one of the movable, slender, spinelike organs or parts with which certain bryozoans are furnished [n VIBRACULA]\n",
  "VIBRAHARP": "an instrument having metal bars under which are electrically-operated resonators, played by striking the bars with small hammers, also VIBRAPHONE [n -S]\n",
  "VIBRAHARPIST": "one who plays the vibraharp [n -S]\n",
  "VIBRAHARPISTS": "VIBRAHARPIST, one who plays the vibraharp [n]\n",
  "VIBRAHARPS": "VIBRAHARP, an instrument having metal bars under which are electrically-operated resonators, played by striking the bars with small hammers, also VIBRAPHONE [n]\n",
  "VIBRANCE": "the state of being vibrant, also VIBRANCY [n -S]\n",
  "VIBRANCES": "VIBRANCE, the state of being vibrant, also VIBRANCY [n]\n",
  "VIBRANCIES": "VIBRANCY, the state of being vibrant, also VIBRANCE [n]\n",
  "VIBRANCY": "the state of being vibrant, also VIBRANCE [n VIBRANCIES]\n",
  "VIBRANT": "vibrating, resonant [adj VIBRANTLY] / a sonant, a voiced sound [n -S]\n",
  "VIBRANTLY": "VIBRANT, vibrating, resonant [adv]\n",
  "VIBRANTS": "VIBRANT, a sonant, a voiced sound [n]\n",
  "VIBRAPHONE": "an instrument having metal bars under which are electrically-operated resonators, played by striking the bars with small hammers, also VIBRAHARP [n -S]\n",
  "VIBRAPHONES": "VIBRAPHONE, an instrument having metal bars under which are electrically-operated resonators, played by striking the bars with small hammers, also VIBRAHARP [n]\n",
  "VIBRAPHONIST": "one who plays the vibraphone [n -S]\n",
  "VIBRAPHONISTS": "VIBRAPHONIST, one who plays the vibraphone [n]\n",
  "VIBRATE": "to move back and forward rapidly [v VIBRATED, VIBRATING, VIBRATES]\n",
  "VIBRATED": "VIBRATE, to move back and forward rapidly [v]\n",
  "VIBRATES": "VIBRATE, to move back and forward rapidly [v]\n",
  "VIBRATILE": "capable of vibratory motion, also VIBRATIVE, VIBRATORY [adj]\n",
  "VIBRATILITIES": "VIBRATILITY, the quality of being vibratile, capable of vibratory motion [n]\n",
  "VIBRATILITY": "the quality of being vibratile, capable of vibratory motion [n VIBRATILITIES]\n",
  "VIBRATING": "VIBRATE, to move back and forward rapidly [v]\n",
  "VIBRATINGLY": "VIBRATING, VIBRATE, to move back and forward rapidly [adv]\n",
  "VIBRATION": "a vibrating [n -S]\n",
  "VIBRATIONAL": "related to vibration [adj]\n",
  "VIBRATIONLESS": "without vibration [adj]\n",
  "VIBRATIONS": "VIBRATION, a vibrating [n]\n",
  "VIBRATIUNCLE": "a small vibration [n -S]\n",
  "VIBRATIUNCLES": "VIBRATIUNCLE, a small vibration [n]\n",
  "VIBRATIVE": "consisting in, or causing, vibration, also VIBRATILE, VIBRATORY [adj]\n",
  "VIBRATO": "(Italian) a tremulous or pulsating musical effect [n -S]\n",
  "VIBRATOLESS": "without vibrato [adj]\n",
  "VIBRATOR": "a type of dildo that can be made to vibrate [n -S]\n",
  "VIBRATORS": "VIBRATOR, a type of dildo that can be made to vibrate [n]\n",
  "VIBRATORY": "consisting in, or causing, vibration, also VIBRATILE, VIBRATIVE [adj]\n",
  "VIBRATOS": "VIBRATO, (Italian) a tremulous or pulsating musical effect [n]\n",
  "VIBRIO": "a bacterium with a slight spiral curve, also VIBRION [n -S]\n",
  "VIBRIOID": "of or like a vibrio, a genus of rod-shaped motile bacteria [adj]\n",
  "VIBRION": "a bacterium with a slight spiral curve, also VIBRIO [n -S]\n",
  "VIBRIONIC": "of or like a vibrio, a genus of motile bacteria [adj]\n",
  "VIBRIONS": "VIBRION, a bacterium with a slight spiral curve, also VIBRIO [n]\n",
  "VIBRIOS": "VIBRIO, a bacterium with a slight spiral curve, also VIBRION [n]\n",
  "VIBRIOSES": "VIBRIOSIS, infection with vibrionic bacteria [n]\n",
  "VIBRIOSIS": "infection with vibrionic bacteria [n VIBRIOSES]\n",
  "VIBRISSA": "(Latin) a sensitive whisker on animal's face [n VIBRISSAE]\n",
  "VIBRISSAE": "VIBRISSA, (Latin) a sensitive whisker on animal's face [n]\n",
  "VIBRISSAL": "like a vibrissa, a sensitive whisker on an animal's face [adj]\n",
  "VIBROFLOTATION": "a process for compacting sand [n -S]\n",
  "VIBROFLOTATIONS": "VIBROFLOTATION, a process for compacting sand [n]\n",
  "VIBROGRAPH": "an instrument for recording vibrations [n -S]\n",
  "VIBROGRAPHS": "VIBROGRAPH, an instrument for recording vibrations [n]\n",
  "VIBROMETER": "an instrument for measuring vibrations [n -S]\n",
  "VIBROMETERS": "VIBROMETER, an instrument for measuring vibrations [n]\n",
  "VIBRONIC": "caused by electronic vibration [adj]\n",
  "VIBS": "(colloquial) shoes with Vibram soles, used esp. for climbing [n]\n",
  "VIBURNUM": "(Latin) a kind of shrub or tree including the guelder-rose [n -S]\n",
  "VIBURNUMS": "VIBURNUM, (Latin) a kind of shrub or tree including the guelder-rose [n]\n",
  "VICAR": "a church official [n -S]\n",
  "VICARAGE": "the habitation of a vicar [n -S]\n",
  "VICARAGES": "VICARAGE, the habitation of a vicar [n]\n",
  "VICARATE": "the office or authority of a vicar, also VICARIATE [n -S]\n",
  "VICARATES": "VICARATE, the office or authority of a vicar, also VICARIATE [n]\n",
  "VICARESS": "a vicar's wife [n -ES]\n",
  "VICARESSES": "VICARESS, a vicar's wife [n]\n",
  "VICARIAL": "of or pertaining to a vicar or vicars [adj]\n",
  "VICARIANCE": "fragmentation of the environment, e.g. by plate tectonic splitting, as opposed to dispersal as a mechanism for biological evolution [n -S]\n",
  "VICARIANCES": "VICARIANCE, fragmentation of the environment, e.g. by plate tectonic splitting, as opposed to dispersal as a mechanism for biological evolution [n]\n",
  "VICARIANT": "a species, variety, etc., of plant or animal forming the counterpart in one area or on one soil to a closely related form native to another area [n -S]\n",
  "VICARIANTS": "VICARIANT, a species, variety, etc., of plant or animal forming the counterpart in one area or on one soil to a closely related form native to another area [n]\n",
  "VICARIATE": "the office or authority of a vicar, also VICARATE [n -S]\n",
  "VICARIATES": "VICARIATE, the office or authority of a vicar, also VICARATE [n]\n",
  "VICARIES": "VICARY, a vicarship [n]\n",
  "VICARIOUS": "characteristic of feelings or emotions felt or shared imaginatively through the feelings or emotions of another person [adj VICARIOUSLY]\n",
  "VICARIOUSLY": "VICARIOUS, characteristic of feelings or emotions felt or shared imaginatively through the feelings or emotions of another person [adv]\n",
  "VICARIOUSNESS": "the state of being vicarious [n -ES]\n",
  "VICARIOUSNESSES": "VICARIOUSNESS, the state of being vicarious [n]\n",
  "VICARLIER": "VICARLY, like a vicar [adj]\n",
  "VICARLIEST": "VICARLY, like a vicar [adj]\n",
  "VICARLY": "like a vicar [adj VICARLIER, VICARLIEST]\n",
  "VICARS": "VICAR, a church official [n]\n",
  "VICARSHIP": "the office or dignity of a vicar [n -S]\n",
  "VICARSHIPS": "VICARSHIP, the office or dignity of a vicar [n]\n",
  "VICARY": "a vicarship [n VICARIES]\n",
  "VICE": "to grip with a special tool [v VICED, VICING, VICES]\n",
  "VICED": "VICE, to grip with a special tool [v]\n",
  "VICEGERAL": "relating to a viceroy [adj]\n",
  "VICEGERENCIES": "VICEGERENCY, the office of viceregent [n]\n",
  "VICEGERENCY": "the office of viceregent [n VICEGERENCIES]\n",
  "VICEGERENT": "acting in place of another; having delegated authority [adj] / one ruling in place of another [n -S]\n",
  "VICEGERENTS": "VICEGERENT, one ruling in place of another [n]\n",
  "VICELESS": "having no immoral habits [adj]\n",
  "VICELIKE": "held very firmly as in a vice [adj]\n",
  "VICENARY": "pertaining to the number twenty [adj]\n",
  "VICENNIAL": "occurring every twenty years [adj]\n",
  "VICEREGAL": "of a viceroy, of a governor-general [adj VICEREGALLY]\n",
  "VICEREGALLY": "VICEREGAL, of a viceroy, of a governor-general [adv]\n",
  "VICEREGENT": "a substitute for a regent [n -S]\n",
  "VICEREGENTS": "VICEREGENT, a substitute for a regent [n]\n",
  "VICEREINE": "(French) the wife of a viceroy [n -S]\n",
  "VICEREINES": "VICEREINE, (French) the wife of a viceroy [n]\n",
  "VICEROY": "one who rules as the representative of a sovereign [n -S]\n",
  "VICEROYALTIES": "VICEROYALTY, the office of viceroy, also VICEROYSHIP [n]\n",
  "VICEROYALTY": "the office of viceroy, also VICEROYSHIP [n VICEROYALTIES]\n",
  "VICEROYS": "VICEROY, one who rules as the representative of a sovereign [n]\n",
  "VICEROYSHIP": "the office of viceroy, also VICEROYALTY [n -S]\n",
  "VICEROYSHIPS": "VICEROYSHIP, the office of viceroy, also VICEROYALTY [n]\n",
  "VICES": "VICE, to grip with a special tool [v]\n",
  "VICESIMAL": "based on the number twenty, also VICENARY, VIGESIMAL [adj]\n",
  "VICHIES": "VICHY, a type of mineral water [n]\n",
  "VICHY": "a type of mineral water [n VICHIES]\n",
  "VICHYSSOIS": "(French) of the Vichyite government [adj]\n",
  "VICHYSSOISE": "(French) a soup made with potatoes, leeks, and cream, and usually served cold [n -S]\n",
  "VICHYSSOISES": "VICHYSSOISE, (French) a soup made with potatoes, leeks, and cream, and usually served cold [n]\n",
  "VICIATE": "(obsolete) to impair the quality of, spoil, also VITIATE [v VICIATED, VICIATING, VICIATES]\n",
  "VICIATED": "VICIATE, (obsolete) to impair the quality of, spoil, also VITIATE [v]\n",
  "VICIATES": "VICIATE, (obsolete) to impair the quality of, spoil, also VITIATE [v]\n",
  "VICIATING": "VICIATE, (obsolete) to impair the quality of, spoil, also VITIATE [v]\n",
  "VICINAGE": "the region near or about a place, also VICINITY [n -S]\n",
  "VICINAGES": "VICINAGE, the region near or about a place, also VICINITY [n]\n",
  "VICINAL": "neighboring; local [adj]\n",
  "VICING": "VICE, to grip with a special tool [v]\n",
  "VICINITIES": "VICINITY, the region near or about a place, also VICINAGE [n]\n",
  "VICINITY": "the region near or about a place, also VICINAGE [n VICINITIES]\n",
  "VICIOSITIES": "VICIOSITY, the state or character of being guilty of or devoted to vice or immorality, also VITIOSITY [n]\n",
  "VICIOSITY": "the state or character of being guilty of or devoted to vice or immorality, also VITIOSITY [n VICIOSITIES]\n",
  "VICIOUS": "dangerously aggressive [adj VICIOUSLY]\n",
  "VICIOUSLY": "VICIOUS, dangerously aggressive [adv]\n",
  "VICIOUSNESS": "the state of being vicious [n -ES]\n",
  "VICIOUSNESSES": "VICIOUSNESS, the state of being vicious [n]\n",
  "VICISSITUDE": "a change of circumstances affecting one's life [n -S]\n",
  "VICISSITUDES": "VICISSITUDE, a change of circumstances affecting one's life [n]\n",
  "VICISSITUDINARY": "of or like a vicissitude [adj]\n",
  "VICISSITUDINOUS": "full of, or subject to, changes esp. in fortune [adj]\n",
  "VICOMTE": "(French) in France, a noble equal in rank to a viscount [n -S]\n",
  "VICOMTES": "VICOMTE, (French) in France, a noble equal in rank to a viscount [n]\n",
  "VICOMTESSE": "(French) a female vicomte [n -S]\n",
  "VICOMTESSES": "VICOMTESSE, (French) a female vicomte [n]\n",
  "VICTIM": "one who suffers from a destructive or injurious action [n -S]\n",
  "VICTIMHOOD": "the state of being a victim [n -S]\n",
  "VICTIMHOODS": "VICTIMHOOD, the state of being a victim [n]\n",
  "VICTIMISATION": "the act of victimising, also VICTIMIZATION [n -S]\n",
  "VICTIMISATIONS": "VICTIMISATION, the act of victimising, also VICTIMIZATION [n]\n",
  "VICTIMISE": "to make a victim of, also VICTIMIZE [v VICTIMISED, VICTIMISING, VICTIMISES]\n",
  "VICTIMISED": "VICTIMISE, to make a victim of, also VICTIMIZE [v]\n",
  "VICTIMISER": "one who victimises, also VICTIMIZER [n -S]\n",
  "VICTIMISERS": "VICTIMISER, one who victimises, also VICTIMIZER [n]\n",
  "VICTIMISES": "VICTIMISE, to make a victim of, also VICTIMIZE [v]\n",
  "VICTIMISING": "VICTIMISE, to make a victim of, also VICTIMIZE [v]\n",
  "VICTIMIZATION": "the act of victimizing, also VICTIMISATION [n -S]\n",
  "VICTIMIZATIONS": "VICTIMIZATION, the act of victimizing, also VICTIMISATION [n]\n",
  "VICTIMIZE": "to make a victim of, also VICTIMISE [v VICTIMIZED, VICTIMIZING, VICTIMIZES]\n",
  "VICTIMIZED": "VICTIMIZE, to make a victim of, also VICTIMISE [v]\n",
  "VICTIMIZER": "one who victimises, also VICTIMISER [n -S]\n",
  "VICTIMIZERS": "VICTIMIZER, one who victimises, also VICTIMISER [n]\n",
  "VICTIMIZES": "VICTIMIZE, to make a victim of, also VICTIMISE [v]\n",
  "VICTIMIZING": "VICTIMIZE, to make a victim of, also VICTIMISE [v]\n",
  "VICTIMLESS": "having no victim [adj]\n",
  "VICTIMOLOGIES": "VICTIMOLOGY, the study of victims [n]\n",
  "VICTIMOLOGIST": "one who studies victimology [n -S]\n",
  "VICTIMOLOGISTS": "VICTIMOLOGIST, one who studies victimology [n]\n",
  "VICTIMOLOGY": "the study of victims [n VICTIMOLOGIES]\n",
  "VICTIMS": "VICTIM, one who suffers from a destructive or injurious action [n]\n",
  "VICTOR": "one who defeats an adversary [n -S]\n",
  "VICTORESS": "(obsolete) a female victor, also VICTRESS, VICTRIX [n -ES]\n",
  "VICTORESSES": "VICTORESS, (obsolete) a female victor, also VICTRESS, VICTRIX [n]\n",
  "VICTORIA": "a kind of light carriage [n -S]\n",
  "VICTORIANA": "bricabrac and other characteristic possessions or creations of the Victorian age [n -S]\n",
  "VICTORIANAS": "VICTORIANA, bricabrac and other characteristic possessions or creations of the Victorian age [n]\n",
  "VICTORIAS": "VICTORIA, a kind of light carriage [n]\n",
  "VICTORIES": "VICTORY, a successful outcome in a contest or struggle [n]\n",
  "VICTORINE": "(French) a woman's fur tippet [n -S]\n",
  "VICTORINES": "VICTORINE, (French) a woman's fur tippet [n]\n",
  "VICTORIOUS": "having won a victory [adj VICTORIOUSLY]\n",
  "VICTORIOUSLY": "VICTORIOUS, having won a victory [adv]\n",
  "VICTORIOUSNESS": "the state of being victorious [n]\n",
  "VICTORS": "VICTOR, one who defeats an adversary [n]\n",
  "VICTORY": "a successful outcome in a contest or struggle [n VICTORIES]\n",
  "VICTORYLESS": "without a victory [adj]\n",
  "VICTRESS": "a female victor, also VICTORESS, VICTRIX [n -ES]\n",
  "VICTRESSES": "VICTRESS, a female victor, also VICTORESS, VICTRIX [n]\n",
  "VICTRIX": "(Latin) a female victor, also VICTORESS, VICTRESS [n -ES]\n",
  "VICTRIXES": "VICTRIX, (Latin) a female victor, also VICTORESS, VICTRESS [n]\n",
  "VICTROLA": "(tradename) a type of gramophone [n -S]\n",
  "VICTROLAS": "VICTROLA, (tradename) a type of gramophone [n]\n",
  "VICTUAL": "to provide with food, also VITTLE [v VICTUALLED or VICTUALED, VICTUALLING or VICTUALING, VICTUALS]\n",
  "VICTUALAGE": "provisions, also VICTUALLAGE [n -S]\n",
  "VICTUALAGES": "VICTUALAGE, provisions, also VICTUALLAGE [n]\n",
  "VICTUALED": "VICTUAL, to provide with food, also VITTLE [v]\n",
  "VICTUALER": "one who furnishes victuals, also VICTUALLER [n -S]\n",
  "VICTUALERS": "VICTUALER, one who furnishes victuals, also VICTUALLER [n]\n",
  "VICTUALING": "VICTUAL, to provide with food, also VITTLE [v]\n",
  "VICTUALLAGE": "provisions, also VICTUALAGE [n -S]\n",
  "VICTUALLAGES": "VICTUALLAGE, provisions, also VICTUALAGE [n]\n",
  "VICTUALLED": "VICTUAL, to provide with food, also VITTLE [v]\n",
  "VICTUALLER": "one who furnishes victuals, also VICTUALER [n -S]\n",
  "VICTUALLERS": "VICTUALLER, one who furnishes victuals, also VICTUALER [n]\n",
  "VICTUALLESS": "without victuals [adj]\n",
  "VICTUALLING": "VICTUAL, to provide with food, also VITTLE [v]\n",
  "VICTUALS": "VICTUAL, to provide with food, also VITTLE [v]\n",
  "VICUGNA": "(Quechua) a wild wool-bearing llama-like animal of the Andes, also VICUNA [n -S]\n",
  "VICUGNAS": "VICUGNA, (Quechua) a wild wool-bearing llama-like animal of the Andes, also VICUNA [n]\n",
  "VICUNA": "(Quechua) a wild wool-bearing llama-like animal of the Andes, also VICUGNA [n -S]\n",
  "VICUNAS": "VICUNA, (Quechua) a wild wool-bearing llama-like animal of the Andes, also VICUGNA [n]\n",
  "VID": "(short for) video [n -S]\n",
  "VIDALIA": "a sweet onion from Vidalia, Georgia [n -S]\n",
  "VIDALIAS": "VIDALIA, a sweet onion from Vidalia, Georgia [n]\n",
  "VIDAME": "in French feudal jurisprudence, the deputy of a bishop in temporal affairs; a minor noble [n -S]\n",
  "VIDAMES": "VIDAME, in French feudal jurisprudence, the deputy of a bishop in temporal affairs; a minor noble [n]\n",
  "VIDE": "(Latin) see, consult, refer [v]\n",
  "VIDELICET": "(Latin) that is to say, namely [v]\n",
  "VIDENDA": "VIDENDUM, things to be seen [n]\n",
  "VIDENDUM": "things to be seen [n VIDENDA]\n",
  "VIDEO": "to make a video recording [v -ED, -ING, -S]\n",
  "VIDEOCAM": "a camera for taking video [n -S]\n",
  "VIDEOCAMS": "VIDEOCAM, a camera for taking video [n]\n",
  "VIDEOCASSETTE": "a case containing videotape for use with a vcr [n -S]\n",
  "VIDEOCASSETTES": "VIDEOCASSETTE, a case containing videotape for use with a vcr [n]\n",
  "VIDEOCONFERENCE": "a conference held by video [n]\n",
  "VIDEODISC": "a compact disk on which video is stored, also VIDEODISK [n -S]\n",
  "VIDEODISCS": "VIDEODISC, a compact disk on which video is stored, also VIDEODISK [n]\n",
  "VIDEODISK": "a compact disk on which video is stored, also VIDEODISC [n -S]\n",
  "VIDEODISKS": "VIDEODISK, a compact disk on which video is stored, also VIDEODISC [n]\n",
  "VIDEOED": "VIDEO, to make a video recording [v]\n",
  "VIDEOFIT": "a type of identikit picture put together on television [n -S]\n",
  "VIDEOFITS": "VIDEOFIT, a type of identikit picture put together on television [n]\n",
  "VIDEOGRAM": "a commercial video film [n -S]\n",
  "VIDEOGRAMS": "VIDEOGRAM, a commercial video film [n]\n",
  "VIDEOGRAPHER": "a practitioner of videography [n -S]\n",
  "VIDEOGRAPHERS": "VIDEOGRAPHER, a practitioner of videography [n]\n",
  "VIDEOGRAPHIES": "VIDEOGRAPHY, the art of using a video camera [n]\n",
  "VIDEOGRAPHY": "the art of using a video camera [n VIDEOGRAPHIES]\n",
  "VIDEOING": "VIDEO, to make a video recording [v]\n",
  "VIDEOLAND": "television as a medium or industry [n -S]\n",
  "VIDEOLANDS": "VIDEOLAND, television as a medium or industry [n]\n",
  "VIDEOPHILE": "a lover of videos [n -S]\n",
  "VIDEOPHILES": "VIDEOPHILE, a lover of videos [n]\n",
  "VIDEOPHONE": "a telephone equipped for transmission of video as well as audio signals so that users can see each other [n -S]\n",
  "VIDEOPHONES": "VIDEOPHONE, a telephone equipped for transmission of video as well as audio signals so that users can see each other [n]\n",
  "VIDEOPHONIC": "related to a videophone [adj]\n",
  "VIDEOS": "VIDEO, to make a video recording [v]\n",
  "VIDEOTAPE": "magnetic tape for recording visual images [n -S] / to record on videotape [v VIDEOTAPED, VIDEOTAPING, VIDEOTAPES]\n",
  "VIDEOTAPED": "VIDEOTAPE, to record on videotape [v]\n",
  "VIDEOTAPES": "VIDEOTAPE, to record on videotape [v]\n",
  "VIDEOTAPING": "VIDEOTAPE, to record on videotape [v]\n",
  "VIDEOTELEPHONE": "a telephone with accompanying means of transmitting a picture of each speaker [n -S]\n",
  "VIDEOTELEPHONES": "VIDEOTELEPHONE, a telephone with accompanying means of transmitting a picture of each speaker [n]\n",
  "VIDEOTEX": "an electronic system for transmitting data [n -ES]\n",
  "VIDEOTEXES": "VIDEOTEX, an electronic system for transmitting data [n]\n",
  "VIDEOTEXT": "a system used to display information on a television screen, also VIDEOTEX [n -S]\n",
  "VIDEOTEXTS": "VIDEOTEXT, a system used to display information on a television screen, also VIDEOTEX [n]\n",
  "VIDEOTHEQUE": "a cinema in which videos are shown [n -S]\n",
  "VIDEOTHEQUES": "VIDEOTHEQUE, a cinema in which videos are shown [n]\n",
  "VIDETTE": "(French) a mounted sentry stationed to watch for enemy, also VEDETTE [n -S]\n",
  "VIDETTES": "VIDETTE, (French) a mounted sentry stationed to watch for enemy, also VEDETTE [n]\n",
  "VIDICON": "a type of television camera tube [n -S]\n",
  "VIDICONS": "VIDICON, a type of television camera tube [n]\n",
  "VIDIMUS": "(Latin) an attested copy; inspection of accounts [n -ES]\n",
  "VIDIMUSES": "VIDIMUS, (Latin) an attested copy; inspection of accounts [n]\n",
  "VIDIOT": "a habitual undiscriminating viewer of television [n -S]\n",
  "VIDIOTS": "VIDIOT, a habitual undiscriminating viewer of television [n]\n",
  "VIDS": "VID, (short for) video [n]\n",
  "VIDSCREEN": "a video screen [n -S]\n",
  "VIDSCREENS": "VIDSCREEN, a video screen [n]\n",
  "VIDUAGE": "(Latin) widowhood; widows collectively [n -S]\n",
  "VIDUAGES": "VIDUAGE, (Latin) widowhood; widows collectively [n]\n",
  "VIDUAL": "pertaining to viduage, widowhood [adj]\n",
  "VIDUITIES": "VIDUITY, the state of being a widow [n]\n",
  "VIDUITY": "the state of being a widow [n VIDUITIES]\n",
  "VIDUOUS": "widowed; empty [adj]\n",
  "VIE": "to contend in rivalry [v VIED, VYING, VIES]\n",
  "VIED": "VIE, to contend in rivalry [v]\n",
  "VIELLE": "(French) a hurdy-gurdy, a stringed instrument played by a wheel [n -S]\n",
  "VIELLES": "VIELLE, (French) a hurdy-gurdy, a stringed instrument played by a wheel [n]\n",
  "VIENNA": "associated with Vienna, as in vienna steak [adj]\n",
  "VIER": "one who vies [n -S]\n",
  "VIERS": "VIER, one who vies [n]\n",
  "VIES": "VIE, to contend in rivalry [v]\n",
  "VIEW": "to look at [v -ED, -ING, -S]\n",
  "VIEWABLE": "able to be viewed [adj]\n",
  "VIEWBOOK": "a promotional booklet with pictures published by a college or university [n -S]\n",
  "VIEWBOOKS": "VIEWBOOK, a promotional booklet with pictures published by a college or university [n]\n",
  "VIEWDATA": "a communications system by which information can be received and requested by a telephone line, and shown on a video display unit [n -S]\n",
  "VIEWDATAS": "VIEWDATA, a communications system by which information can be received and requested by a telephone line, and shown on a video display unit [n]\n",
  "VIEWED": "VIEW, to look at [v]\n",
  "VIEWER": "one that views [n -S]\n",
  "VIEWERS": "VIEWER, one that views [n]\n",
  "VIEWERSHIP": "a programme's viewers taken collectively [n -S]\n",
  "VIEWERSHIPS": "VIEWERSHIP, a programme's viewers taken collectively [n]\n",
  "VIEWFINDER": "a device on a camera for showing the area of the subject to be included in the picture [n -S]\n",
  "VIEWFINDERS": "VIEWFINDER, a device on a camera for showing the area of the subject to be included in the picture [n]\n",
  "VIEWIER": "VIEWY, showy; having views that are considered odd [adj]\n",
  "VIEWIEST": "VIEWY, showy; having views that are considered odd [adj]\n",
  "VIEWINESS": "the state of being viewy, or of having unpractical views [n -ES]\n",
  "VIEWINESSES": "VIEWINESS, the state of being viewy, or of having unpractical views [n]\n",
  "VIEWING": "the act of seeing, watching or looking [n -S]\n",
  "VIEWINGS": "VIEWING, the act of seeing, watching or looking [n]\n",
  "VIEWLESS": "having no opinions [adj VIEWLESSLY]\n",
  "VIEWLESSLY": "VIEWLESS, having no opinions [adv]\n",
  "VIEWLY": "(dialect) pleasing to look at [adj]\n",
  "VIEWPHONE": "a phone that enables the caller to be seen as well as listened to [n -S]\n",
  "VIEWPHONES": "VIEWPHONE, a phone that enables the caller to be seen as well as listened to [n]\n",
  "VIEWPOINT": "a place offering a good view [n -S]\n",
  "VIEWPOINTS": "VIEWPOINT, a place offering a good view [n]\n",
  "VIEWPORT": "a framed area on a computer display for viewing information [n -S]\n",
  "VIEWPORTS": "VIEWPORT, a framed area on a computer display for viewing information [n]\n",
  "VIEWS": "VIEW, to look at [v]\n",
  "VIEWSHED": "the natural environment visible from a viewing point [n -S]\n",
  "VIEWSHEDS": "VIEWSHED, the natural environment visible from a viewing point [n]\n",
  "VIEWY": "showy; having views that are considered odd [adj VIEWIER, VIEWIEST]\n",
  "VIFDA": "in Shetland, meat hung and dried without salt, also VIVDA [n -S]\n",
  "VIFDAS": "VIFDA, in Shetland, meat hung and dried without salt, also VIVDA [n]\n",
  "VIFF": "to change direction abruptly of a VTOL aircraft [v -ED, -ING, -S]\n",
  "VIFFED": "VIFF, to change direction abruptly of a VTOL aircraft [v]\n",
  "VIFFING": "VIFF, to change direction abruptly of a VTOL aircraft [v]\n",
  "VIFFS": "VIFF, to change direction abruptly of a VTOL aircraft [v]\n",
  "VIG": "(short for) a vigorish, a charge paid to a bookie on a bet [n -S]\n",
  "VIGA": "(Spanish) a ceiling beam [n -S]\n",
  "VIGAS": "VIGA, (Spanish) a ceiling beam [n]\n",
  "VIGESIMAL": "based on the number twenty, also VICENARY, VICESIMAL [adj]\n",
  "VIGIA": "(Spanish) a danger warning on a chart [n -S]\n",
  "VIGIAS": "VIGIA, (Spanish) a danger warning on a chart [n]\n",
  "VIGIL": "a period of watchfulness maintained during normal sleeping hours [n -S]\n",
  "VIGILANCE": "the state of being vigilant [n -S]\n",
  "VIGILANCES": "VIGILANCE, the state of being vigilant [n]\n",
  "VIGILANT": "watchful [adj VIGILANTLY]\n",
  "VIGILANTE": "(Spanish) any person executing summary justice in the absence or breakdown of legally constituted law enforcement bodies [n -S]\n",
  "VIGILANTES": "VIGILANTE, (Spanish) any person executing summary justice in the absence or breakdown of legally constituted law enforcement bodies [n]\n",
  "VIGILANTISM": "acting as a vigilante [n -S]\n",
  "VIGILANTISMS": "VIGILANTISM, acting as a vigilante [n]\n",
  "VIGILANTLY": "VIGILANT, watchful [adv]\n",
  "VIGILANTNESS": "the state of being vigilant [n -ES]\n",
  "VIGILANTNESSES": "VIGILANTNESS, the state of being vigilant [n]\n",
  "VIGILS": "VIGIL, a period of watchfulness maintained during normal sleeping hours [n]\n",
  "VIGINTILLION": "ten to the power of 63 [n -S]\n",
  "VIGINTILLIONS": "VIGINTILLION, ten to the power of 63 [n]\n",
  "VIGNERON": "(French) a vine-grower [n -S]\n",
  "VIGNERONS": "VIGNERON, (French) a vine-grower [n]\n",
  "VIGNETTE": "(French) a small, ornamental illustration without frame or with background shaded off; a slight portrait or character sketch [n -S] / to make a vignette of [v VIGNETTED, VIGNETTING, VIGNETTES]\n",
  "VIGNETTED": "VIGNETTE, to make a vignette of [v]\n",
  "VIGNETTER": "one who makes vignettes, also VIGNETTIST [n -S]\n",
  "VIGNETTERS": "VIGNETTER, one who makes vignettes, also VIGNETTIST [n]\n",
  "VIGNETTES": "VIGNETTE, to make a vignette of [v]\n",
  "VIGNETTING": "the art of making vignettes [n -S]\n",
  "VIGNETTINGS": "VIGNETTING, the art of making vignettes [n]\n",
  "VIGNETTIST": "one who paints vignettes, also VIGNETTER [n -S]\n",
  "VIGNETTISTS": "VIGNETTIST, one who paints vignettes, also VIGNETTER [n]\n",
  "VIGOR": "active strength or force, also VIGOUR [n -S]\n",
  "VIGORISH": "(Yiddish) the percentage of a gambler's winnings taken by the bookie [n -ES]\n",
  "VIGORISHES": "VIGORISH, (Yiddish) the percentage of a gambler's winnings taken by the bookie [n]\n",
  "VIGORO": "(Australian) an Australian game for women, with elements of baseball and cricket, played with a soft rubber ball [n -S]\n",
  "VIGOROS": "VIGORO, (Australian) an Australian game for women, with elements of baseball and cricket, played with a soft rubber ball [n]\n",
  "VIGOROSO": "(Italian) in music, with energy and force [adj]\n",
  "VIGOROUS": "full of vigor [adj VIGOROUSLY]\n",
  "VIGOROUSLY": "VIGOROUS, full of vigor [adv]\n",
  "VIGOROUSNESS": "the state of being vigorous [n -ES]\n",
  "VIGOROUSNESSES": "VIGOROUSNESS, the state of being vigorous [n]\n",
  "VIGORS": "VIGOR, active strength or force, also VIGOUR [n]\n",
  "VIGOUR": "active strength or force, also VIGOR [n -S]\n",
  "VIGOURS": "VIGOUR, active strength or force, also VIGOR [n]\n",
  "VIGS": "VIG, (short for) a vigorish, a charge paid to a bookie on a bet [n]\n",
  "VIHARA": "(Sanskrit) a Buddhist or Jain temple or precinct [n -S]\n",
  "VIHARAS": "VIHARA, (Sanskrit) a Buddhist or Jain temple or precinct [n]\n",
  "VIHUELA": "(Spanish) an old Spanish musical instrument related to the guitar [n -S]\n",
  "VIHUELAS": "VIHUELA, (Spanish) an old Spanish musical instrument related to the guitar [n]\n",
  "VIKING": "an aggressive sea-raider, a pirate [n -S]\n",
  "VIKINGISM": "the practice of being a viking [n -S]\n",
  "VIKINGISMS": "VIKINGISM, the practice of being a viking [n]\n",
  "VIKINGS": "VIKING, an aggressive sea-raider, a pirate [n]\n",
  "VILAYET": "(Turkish) one of the chief administrative divisions or provinces of the Ottoman Empire [n -S]\n",
  "VILAYETS": "VILAYET, (Turkish) one of the chief administrative divisions or provinces of the Ottoman Empire [n]\n",
  "VILD": "(Spenser) vile, also VILDE [adj VILDLY]\n",
  "VILDE": "(Spenser) vile, also VILD [adj]\n",
  "VILDLY": "VILD, (Spenser) vile, also VILDE [adv]\n",
  "VILDNESS": "(Spenser) the state of being vile, also VILENESS [n -ES]\n",
  "VILDNESSES": "VILDNESS, (Spenser) the state of being vile, also VILENESS [n]\n",
  "VILE": "odious [adj VILER, VILEST, VILELY]\n",
  "VILELY": "VILE, odious [adv]\n",
  "VILENESS": "the state of being vile, also VILDNESS [n -ES]\n",
  "VILENESSES": "VILENESS, the state of being vile, also VILDNESS [n]\n",
  "VILER": "VILE, odious [adj]\n",
  "VILEST": "VILE, odious [adj]\n",
  "VILIACO": "(obsolete) a coward, also VILIAGO, VILLAGIO, VILLIACO, VILLIAGO [n -ES or -S]\n",
  "VILIACOES": "VILIACO, (obsolete) a coward, also VILIAGO, VILLAGIO, VILLIACO, VILLIAGO [n]\n",
  "VILIACOS": "VILIACO, (obsolete) a coward, also VILIAGO, VILLAGIO, VILLIACO, VILLIAGO [n]\n",
  "VILIAGO": "(obsolete) a coward, also VILIACO, VILLAGIO, VILLIACO, VILLIAGO [n -ES or -S]\n",
  "VILIAGOES": "VILIAGO, (obsolete) a coward, also VILIACO, VILLAGIO, VILLIACO, VILLIAGO [n]\n",
  "VILIAGOS": "VILIAGO, (obsolete) a coward, also VILIACO, VILLAGIO, VILLIACO, VILLIAGO [n]\n",
  "VILIFICATION": "the act of vilifying [n -S]\n",
  "VILIFICATIONS": "VILIFICATION, the act of vilifying [n]\n",
  "VILIFIED": "VILIFY, to slander; degrade [v]\n",
  "VILIFIER": "one who vilifies [n -S]\n",
  "VILIFIERS": "VILIFIER, one who vilifies [n]\n",
  "VILIFIES": "VILIFY, to slander; degrade [v]\n",
  "VILIFY": "to slander; degrade [v VILIFIED, VILIFYING, VILIFIES]\n",
  "VILIFYING": "VILIFY, to slander; degrade [v]\n",
  "VILIPEND": "(Latin) to treat as of small worth; to contemn, disparage [v -ED, -ING, -S]\n",
  "VILIPENDED": "VILIPEND, (Latin) to treat as of small worth; to contemn, disparage [v]\n",
  "VILIPENDER": "one who vilipends, treats with contempt [n -S]\n",
  "VILIPENDERS": "VILIPENDER, one who vilipends, treats with contempt [n]\n",
  "VILIPENDING": "VILIPEND, (Latin) to treat as of small worth; to contemn, disparage [v]\n",
  "VILIPENDS": "VILIPEND, (Latin) to treat as of small worth; to contemn, disparage [v]\n",
  "VILL": "a township, or feudal territorial unit [n -S]\n",
  "VILLA": "(Latin) a country house or farmhouse with subsidiary buildings; a detached house of some size [n VILLAS or VILLAE]\n",
  "VILLADOM": "villas collectively [n -S]\n",
  "VILLADOMS": "VILLADOM, villas collectively [n]\n",
  "VILLAE": "VILLA, (Latin) a country house or farmhouse with subsidiary buildings; a detached house of some size [n]\n",
  "VILLAGE": "a small community in a rural area [n -S]\n",
  "VILLAGER": "one who lives in a village [n -S]\n",
  "VILLAGERIES": "VILLAGERY, villages; a district of villages, also VILLAGREE [n]\n",
  "VILLAGERS": "VILLAGER, one who lives in a village [n]\n",
  "VILLAGERY": "villages; a district of villages, also VILLAGREE [n VILLAGERIES]\n",
  "VILLAGES": "VILLAGE, a small community in a rural area [n]\n",
  "VILLAGEY": "pertaining to or characteristic of a village [adj VILLAGIER, VILLAGIEST]\n",
  "VILLAGIER": "VILLAGEY, pertaining to or characteristic of a village [adj]\n",
  "VILLAGIEST": "VILLAGEY, pertaining to or characteristic of a village [adj]\n",
  "VILLAGIO": "(Scott) a coward, also VILIACO, VILIAGO, VILLIACO, VILLIAGO [n -ES or -S]\n",
  "VILLAGIOES": "VILLAGIO, (Scott) a coward, also VILIACO, VILIAGO, VILLIACO, VILLIAGO [n]\n",
  "VILLAGIOS": "VILLAGIO, (Scott) a coward, also VILIACO, VILIAGO, VILLIACO, VILLIAGO [n]\n",
  "VILLAGISATION": "the process of making into a village, also VILLAGIZATION [n -S]\n",
  "VILLAGISATIONS": "VILLAGISATION, the process of making into a village, also VILLAGIZATION [n]\n",
  "VILLAGIZATION": "the process of making into a village, also VILLAGISATION [n -S]\n",
  "VILLAGIZATIONS": "VILLAGIZATION, the process of making into a village, also VILLAGISATION [n]\n",
  "VILLAGREE": "(Shakespeare) villagery, villages collectively, also VILLAGERY [n -S]\n",
  "VILLAGREES": "VILLAGREE, (Shakespeare) villagery, villages collectively, also VILLAGERY [n]\n",
  "VILLAIN": "a malevolent evildoer, also VILLAN [n -S]\n",
  "VILLAINAGE": "the state of being a villein, also VELLENAGE, VILLANAGE, VILLEINAGE, VILLENAGE [n -S]\n",
  "VILLAINAGES": "VILLAINAGE, the state of being a villein, also VELLENAGE, VILLANAGE, VILLEINAGE, VILLENAGE [n]\n",
  "VILLAINESS": "a woman who is a villain [n -ES]\n",
  "VILLAINESSES": "VILLAINESS, a woman who is a villain [n]\n",
  "VILLAINIES": "VILLAINY, conduct characteristic of a villain, also VILLANY [n]\n",
  "VILLAINOUS": "like a villain, also VILLANOUS [adj VILLAINOUSLY]\n",
  "VILLAINOUSLY": "VILLAINOUS, like a villain, also VILLANOUS [adv]\n",
  "VILLAINOUSNESS": "the state of being villainous [n]\n",
  "VILLAINS": "VILLAIN, a malevolent evildoer, also VILLAN [n]\n",
  "VILLAINY": "conduct characteristic of a villain, also VILLANY [n VILLAINIES]\n",
  "VILLAN": "a malevolent evildoer, also VILLAIN [n -S]\n",
  "VILLANAGE": "the state of being a villein, also VELLENAGE, VILLAINAGE, VILLEINAGE, VILLENAGE [n -S]\n",
  "VILLANAGES": "VILLANAGE, the state of being a villein, also VELLENAGE, VILLAINAGE, VILLEINAGE, VILLENAGE [n]\n",
  "VILLANELLA": "an old rustic dance, accompanied with singing [n VILLANELLE or VILLANELLAS]\n",
  "VILLANELLAS": "VILLANELLA, an old rustic dance, accompanied with singing [n]\n",
  "VILLANELLE": "(French) a poem consisting of five tercets and a quatrain [n -S]\n",
  "VILLANELLES": "VILLANELLE, (French) a poem consisting of five tercets and a quatrain [n]\n",
  "VILLANIES": "VILLANY, conduct characteristic of a villain, also VILLAINY [n]\n",
  "VILLANOUS": "villainous, also VILLAINOUS [adj VILLANOUSLY]\n",
  "VILLANOUSLY": "VILLANOUS, villainous, also VILLAINOUS [adv]\n",
  "VILLANS": "VILLAN, a malevolent evildoer, also VILLAIN [n]\n",
  "VILLANY": "conduct characteristic of a villain, also VILLAINY [n VILLANIES]\n",
  "VILLAR": "pertaining to a manor or village [adj]\n",
  "VILLAS": "VILLA, (Latin) a country house or farmhouse with subsidiary buildings; a detached house of some size [n]\n",
  "VILLATIC": "(Milton) of or relating to a farmyard or village [adj]\n",
  "VILLEGGIATURA": "(Italian) a stay in the country [n -S]\n",
  "VILLEGGIATURAS": "VILLEGGIATURA, (Italian) a stay in the country [n]\n",
  "VILLEIN": "(historical) a free villager; a serf [n -S]\n",
  "VILLEINAGE": "the state of being a villein, also VELLENAGE, VILLAINAGE, VILLANAGE, VILLENAGE [n -S]\n",
  "VILLEINAGES": "VILLEINAGE, the state of being a villein, also VELLENAGE, VILLAINAGE, VILLANAGE, VILLENAGE [n]\n",
  "VILLEINS": "VILLEIN, (historical) a free villager; a serf [n]\n",
  "VILLENAGE": "the state of being a villein, also VELLENAGE, VILLAINAGE, VILLANAGE, VILLEINAGE [n -S]\n",
  "VILLENAGES": "VILLENAGE, the state of being a villein, also VELLENAGE, VILLAINAGE, VILLANAGE, VILLEINAGE [n]\n",
  "VILLI": "VILLUS, (Latin) soft velvety hair or fur, also VELLUS [n]\n",
  "VILLIACO": "(Shakespeare) a coward, also VILIACO, VILIAGO, VILLAGIO, VILLIAGO [n -ES or -S]\n",
  "VILLIACOES": "VILLIACO, (Shakespeare) a coward, also VILIACO, VILIAGO, VILLAGIO, VILLIAGO [n]\n",
  "VILLIACOS": "VILLIACO, (Shakespeare) a coward, also VILIACO, VILIAGO, VILLAGIO, VILLIAGO [n]\n",
  "VILLIAGO": "(Shakespeare) a coward, also VILIACO, VILIAGO, VILLAGIO, VILLIACO [n -ES or -S]\n",
  "VILLIAGOES": "VILLIAGO, (Shakespeare) a coward, also VILIACO, VILIAGO, VILLAGIO, VILLIACO [n]\n",
  "VILLIAGOS": "VILLIAGO, (Shakespeare) a coward, also VILIACO, VILIAGO, VILLAGIO, VILLIACO [n]\n",
  "VILLICATION": "(Smollett) intended as a Scots pronunciation of vellication [n -S]\n",
  "VILLICATIONS": "VILLICATION, (Smollett) intended as a Scots pronunciation of vellication [n]\n",
  "VILLIFORM": "of the form or shape of velvet [adj]\n",
  "VILLOSE": "abounding in, or covered with, fine hairs, or a woolly substance, also VILLOUS [adj]\n",
  "VILLOSITIES": "VILLOSITY, the state of being villous, abounding in, or covered with, fine hairs [n]\n",
  "VILLOSITY": "the state of being villous, abounding in, or covered with, fine hairs [n VILLOSITIES]\n",
  "VILLOUS": "abounding in, or covered with, fine hairs, or a woolly substance, also VILLOSE [adj VILLOUSLY]\n",
  "VILLOUSLY": "VILLOUS, abounding in, or covered with, fine hairs, or a woolly substance, also VILLOSE [adv]\n",
  "VILLS": "VILL, a township, or feudal territorial unit [n]\n",
  "VILLUS": "(Latin) soft velvety hair or fur, also VELLUS [n VILLI]\n",
  "VIM": "energy, vigour [n -S]\n",
  "VIMANA": "(Sanskrit) in the Indian subcontinent, the central tower enclosing the shrine in a temple [n -S]\n",
  "VIMANAS": "VIMANA, (Sanskrit) in the Indian subcontinent, the central tower enclosing the shrine in a temple [n]\n",
  "VIMEN": "(Latin) a long branch of a plant [n VIMINA]\n",
  "VIMINA": "VIMEN, (Latin) a long branch of a plant [n]\n",
  "VIMINAL": "of or pertaining to twigs [adj]\n",
  "VIMINEOUS": "made of wicker [adj]\n",
  "VIMS": "VIM, energy, vigour [n]\n",
  "VIN": "(French) wine [n -S]\n",
  "VINA": "(Sanskrit) an Indian stringed instrument, also VEENA [n -S]\n",
  "VINACEOUS": "of the colour of red wine [adj]\n",
  "VINAIGRETTE": "(French) a salad dressing of oil and wine vinegar with seasoning; a bottle for aromatic vinegar or smelling salts, also VINEGARETTE, VINEGARRETTE [n -S]\n",
  "VINAIGRETTES": "VINAIGRETTE, (French) a salad dressing of oil and wine vinegar with seasoning; a bottle for aromatic vinegar or smelling salts, also VINEGARETTE, VINEGARRETTE [n]\n",
  "VINAL": "a synthetic textile fibre [n -S]\n",
  "VINALS": "VINAL, a synthetic textile fibre [n]\n",
  "VINAS": "VINA, (Sanskrit) an Indian stringed instrument, also VEENA [n]\n",
  "VINASSE": "(French) a residue left after the distillation of liquor [n -S]\n",
  "VINASSES": "VINASSE, (French) a residue left after the distillation of liquor [n]\n",
  "VINBLASTINE": "a cytotoxic alkaloid obtained from the Madagascar periwinkle, and used to treat lymphomas and other cancers [n -S]\n",
  "VINBLASTINES": "VINBLASTINE, a cytotoxic alkaloid obtained from the Madagascar periwinkle, and used to treat lymphomas and other cancers [n]\n",
  "VINCA": "(Latin) a genus of plant, including periwinkle [n -S]\n",
  "VINCAS": "VINCA, (Latin) a genus of plant, including periwinkle [n]\n",
  "VINCIBILITIES": "VINCIBILITY, the state of being vincible, also VINCIBLENESS [n]\n",
  "VINCIBILITY": "the state of being vincible, also VINCIBLENESS [n VINCIBILITIES]\n",
  "VINCIBLE": "capable of being conquered [adj]\n",
  "VINCIBLENESS": "the state of being vincible, also VINCIBILITY [n -ES]\n",
  "VINCIBLENESSES": "VINCIBLENESS, the state of being vincible, also VINCIBILITY [n]\n",
  "VINCIBLY": "VINCIBLE, capable of being conquered [adv]\n",
  "VINCRISTINE": "a cytotoxic alkaloid obtained from the Madagascar periwinkle and used to treat acute leukaemia and other cancers [n -S]\n",
  "VINCRISTINES": "VINCRISTINE, a cytotoxic alkaloid obtained from the Madagascar periwinkle and used to treat acute leukaemia and other cancers [n]\n",
  "VINCULA": "VINCULUM, (Latin) a horizontal line placed above a part of an equation, etc., equivalent to brackets [n]\n",
  "VINCULAR": "of or like a vinculum, a unifying bond [adj]\n",
  "VINCULUM": "(Latin) a horizontal line placed above a part of an equation, etc., equivalent to brackets [n VINCULA or VINCULUMS]\n",
  "VINCULUMS": "VINCULUM, (Latin) a horizontal line placed above a part of an equation, etc., equivalent to brackets [n]\n",
  "VINDALOO": "(Portuguese) a curried dish made with meat, garlic and wine [n -S]\n",
  "VINDALOOS": "VINDALOO, (Portuguese) a curried dish made with meat, garlic and wine [n]\n",
  "VINDEMIAL": "(archaic) pertaining to the vintage [adj]\n",
  "VINDEMIATE": "(archaic) to gather grapes or other fruit [v VINDEMIATED, VINDEMIATING, VINDEMIATES]\n",
  "VINDEMIATED": "VINDEMIATE, (archaic) to gather grapes or other fruit [v]\n",
  "VINDEMIATES": "VINDEMIATE, (archaic) to gather grapes or other fruit [v]\n",
  "VINDEMIATING": "VINDEMIATE, (archaic) to gather grapes or other fruit [v]\n",
  "VINDICABILITIES": "VINDICABILITY, the quality of being vindicable [n]\n",
  "VINDICABILITY": "the quality of being vindicable [n VINDICABILITIES]\n",
  "VINDICABLE": "capable of being vindicated [adj]\n",
  "VINDICATE": "to justify, to clear of criticism [v VINDICATED, VINDICATING, VINDICATES]\n",
  "VINDICATED": "VINDICATE, to justify, to clear of criticism [v]\n",
  "VINDICATES": "VINDICATE, to justify, to clear of criticism [v]\n",
  "VINDICATING": "VINDICATE, to justify, to clear of criticism [v]\n",
  "VINDICATION": "an act of vindicating [n -S]\n",
  "VINDICATIONS": "VINDICATION, an act of vindicating [n]\n",
  "VINDICATIVE": "tending to vindicate [adj]\n",
  "VINDICATIVENESS": "the state of being vindicative [n]\n",
  "VINDICATOR": "one who vindicates [n -S]\n",
  "VINDICATORILY": "VINDICATORY, serving or tending to vindicate [adv]\n",
  "VINDICATORS": "VINDICATOR, one who vindicates [n]\n",
  "VINDICATORY": "serving or tending to vindicate [adj VINDICATORILY]\n",
  "VINDICATRESS": "a female vindicator [n -ES]\n",
  "VINDICATRESSES": "VINDICATRESS, a female vindicator [n]\n",
  "VINDICTIVE": "disposed to seek revenge [adj VINDICTIVELY]\n",
  "VINDICTIVELY": "VINDICTIVE, disposed to seek revenge [adv]\n",
  "VINDICTIVENESS": "VINDICTIVE, disposed to seek revenge [n]\n",
  "VINE": "to remove vines from e.g. vines and pods from (peas) [v VINED, VINING, VINES]\n",
  "VINEAL": "pertaining to wine, also VINOUS [adj]\n",
  "VINED": "VINE, to remove vines from e.g. vines and pods from (peas) [v]\n",
  "VINEDRESSER": "a person who trims and cultivates vines [n -S]\n",
  "VINEDRESSERS": "VINEDRESSER, a person who trims and cultivates vines [n]\n",
  "VINEGAR": "to treat with a sour liquid used as a condiment or preservative [v -ED, -ING, -S]\n",
  "VINEGARED": "VINEGAR, to treat with a sour liquid used as a condiment or preservative [v]\n",
  "VINEGARETTE": "a bottle for aromatic vinegar or smelling salts, also VINAIGRETTE, VINEGARRETTE [n -S]\n",
  "VINEGARETTES": "VINEGARETTE, a bottle for aromatic vinegar or smelling salts, also VINAIGRETTE, VINEGARRETTE [n]\n",
  "VINEGARIER": "VINEGARY, tasting of vinegar [adj]\n",
  "VINEGARIEST": "VINEGARY, tasting of vinegar [adj]\n",
  "VINEGARING": "VINEGAR, to treat with a sour liquid used as a condiment or preservative [v]\n",
  "VINEGARISH": "like vinegar [adj]\n",
  "VINEGARRETTE": "a small decorative bottle or box with a perforated top, used for holding smelling salts, etc., also VINAIGRETTE, VINEGARETTE [n -S]\n",
  "VINEGARRETTES": "VINEGARRETTE, a small decorative bottle or box with a perforated top, used for holding smelling salts, etc., also VINAIGRETTE, VINEGARETTE [n]\n",
  "VINEGARROON": "a large whip scorpion, named from the odor that it emits when alarmed [n -S]\n",
  "VINEGARROONS": "VINEGARROON, a large whip scorpion, named from the odor that it emits when alarmed [n]\n",
  "VINEGARS": "VINEGAR, to treat with a sour liquid used as a condiment or preservative [v]\n",
  "VINEGARY": "tasting of vinegar [adj VINEGARIER, VINEGARIEST]\n",
  "VINELESS": "with no vine [adj]\n",
  "VINELIKE": "like a vine [adj]\n",
  "VINER": "a wine grower [n -S]\n",
  "VINERIES": "VINERY, a place in which grapevines are grown [n]\n",
  "VINERS": "VINER, a wine grower [n]\n",
  "VINERY": "a place in which grapevines are grown [n VINERIES]\n",
  "VINES": "VINE, to remove vines from e.g. vines and pods from (peas) [v]\n",
  "VINEW": "to become mouldy [v -ED, -ING, -S]\n",
  "VINEWED": "VINEW, to become mouldy [v]\n",
  "VINEWING": "VINEW, to become mouldy [v]\n",
  "VINEWS": "VINEW, to become mouldy [v]\n",
  "VINEYARD": "an area planted with grapevines [n -S]\n",
  "VINEYARDIST": "one who owns a vineyard [n -S]\n",
  "VINEYARDISTS": "VINEYARDIST, one who owns a vineyard [n]\n",
  "VINEYARDS": "VINEYARD, an area planted with grapevines [n]\n",
  "VINIC": "derived from wine [adj]\n",
  "VINICULTURAL": "relating to viniculture, vine-growing [adj]\n",
  "VINICULTURE": "vine-growing, also VITICULTURE [n -S]\n",
  "VINICULTURES": "VINICULTURE, vine-growing, also VITICULTURE [n]\n",
  "VINICULTURIST": "one who practises viniculture, vine-growing [n -S]\n",
  "VINICULTURISTS": "VINICULTURIST, one who practises viniculture, vine-growing [n]\n",
  "VINIER": "VINY, of or pertaining to vines [adj]\n",
  "VINIEST": "VINY, of or pertaining to vines [adj]\n",
  "VINIFERA": "a European grape [n -S]\n",
  "VINIFERAS": "VINIFERA, a European grape [n]\n",
  "VINIFEROUS": "wine-producing [adj]\n",
  "VINIFICATION": "the process of fermenting wine [n -S]\n",
  "VINIFICATIONS": "VINIFICATION, the process of fermenting wine [n]\n",
  "VINIFICATOR": "a condensing device that collects the alcoholic vapour produced by the fermentation [n -S]\n",
  "VINIFICATORS": "VINIFICATOR, a condensing device that collects the alcoholic vapour produced by the fermentation [n]\n",
  "VINIFIED": "VINIFY, to convert into wine by fermentation [v]\n",
  "VINIFIES": "VINIFY, to convert into wine by fermentation [v]\n",
  "VINIFY": "to convert into wine by fermentation [v VINIFIED, VINIFYING, VINIFIES]\n",
  "VINIFYING": "VINIFY, to convert into wine by fermentation [v]\n",
  "VINING": "VINE, to remove vines from e.g. vines and pods from (peas) [v]\n",
  "VINO": "(slang) wine [n -S]\n",
  "VINOLENT": "addicted to wine [adj]\n",
  "VINOLOGIES": "VINOLOGY, the study of vines [n]\n",
  "VINOLOGIST": "a student of vinology, the scientific study of vines [n -S]\n",
  "VINOLOGISTS": "VINOLOGIST, a student of vinology, the scientific study of vines [n]\n",
  "VINOLOGY": "the study of vines [n VINOLOGIES]\n",
  "VINOS": "VINO, (slang) wine [n]\n",
  "VINOSITIES": "VINOSITY, the character of a wine [n]\n",
  "VINOSITY": "the character of a wine [n VINOSITIES]\n",
  "VINOUS": "pertaining to or like wine; fond of wine [adj VINOUSLY]\n",
  "VINOUSLY": "VINOUS, pertaining to or like wine; fond of wine [adv]\n",
  "VINS": "VIN, (French) wine [n]\n",
  "VINT": "to strip of grapes, also VINTAGE [v -ED, -ING, -S]\n",
  "VINTAGE": "to strip of grapes, also VINT [v VINTAGED, VINTAGING, VINTAGES]\n",
  "VINTAGED": "VINTAGE, to strip of grapes, also VINT [v]\n",
  "VINTAGER": "one that harvests wine grapes [n -S]\n",
  "VINTAGERS": "VINTAGER, one that harvests wine grapes [n]\n",
  "VINTAGES": "VINTAGE, to strip of grapes, also VINT [v]\n",
  "VINTAGING": "gathering grapes [n -S]\n",
  "VINTAGINGS": "VINTAGING, gathering grapes [n]\n",
  "VINTED": "VINT, to strip of grapes, also VINTAGE [v]\n",
  "VINTING": "VINT, to strip of grapes, also VINTAGE [v]\n",
  "VINTNER": "a wine merchant [n -S]\n",
  "VINTNERS": "VINTNER, a wine merchant [n]\n",
  "VINTRIES": "VINTRY, a place where wine is sold [n]\n",
  "VINTRY": "a place where wine is sold [n VINTRIES]\n",
  "VINTS": "VINT, to strip of grapes, also VINTAGE [v]\n",
  "VINY": "of or pertaining to vines [adj VINIER, VINIEST]\n",
  "VINYL": "a type of plastic [n -S]\n",
  "VINYLCYANIDE": "another name for acrylonitrile, a compound used in making synthetic fibres [n -S]\n",
  "VINYLCYANIDES": "VINYLCYANIDE, another name for acrylonitrile, a compound used in making synthetic fibres [n]\n",
  "VINYLIC": "of or like vinyl [adj]\n",
  "VINYLIDENE": "a bivalent radical, a compound of carbon and hydrogen [n -S]\n",
  "VINYLIDENES": "VINYLIDENE, a bivalent radical, a compound of carbon and hydrogen [n]\n",
  "VINYLS": "VINYL, a type of plastic [n]\n",
  "VIOL": "any member of a class of stringed instruments, forerunners of the violin class [n -S]\n",
  "VIOLA": "a tenor fiddle, slightly bigger than the violin, tuned a fifth lower [n -S]\n",
  "VIOLABILITIES": "VIOLABILITY, the capacity to be violated [n]\n",
  "VIOLABILITY": "the capacity to be violated [n VIOLABILITIES]\n",
  "VIOLABLE": "capable of being violated [adj VIOLABLY]\n",
  "VIOLABLENESS": "the state of being violable [n -ES]\n",
  "VIOLABLENESSES": "VIOLABLENESS, the state of being violable [n]\n",
  "VIOLABLY": "VIOLABLE, capable of being violated [adv]\n",
  "VIOLACEOUS": "violet-coloured [adj]\n",
  "VIOLAS": "VIOLA, a tenor fiddle, slightly bigger than the violin, tuned a fifth lower [n]\n",
  "VIOLATE": "to fail to observe duly, to abuse [v VIOLATED, VIOLATING, VIOLATES]\n",
  "VIOLATED": "VIOLATE, to fail to observe duly, to abuse [v]\n",
  "VIOLATER": "one who violates, also VIOLATOR [n -S]\n",
  "VIOLATERS": "VIOLATER, one who violates, also VIOLATOR [n]\n",
  "VIOLATES": "VIOLATE, to fail to observe duly, to abuse [v]\n",
  "VIOLATING": "VIOLATE, to fail to observe duly, to abuse [v]\n",
  "VIOLATION": "the act of violating [n -S]\n",
  "VIOLATIONS": "VIOLATION, the act of violating [n]\n",
  "VIOLATIVE": "violating, or tending to violate [adj]\n",
  "VIOLATOR": "one who violates, also VIOLATER [n -S]\n",
  "VIOLATORS": "VIOLATOR, one who violates, also VIOLATER [n]\n",
  "VIOLD": "(Milton) vialled, put in a vial [adj]\n",
  "VIOLENCE": "a violent action [n -S]\n",
  "VIOLENCES": "VIOLENCE, a violent action [n]\n",
  "VIOLENT": "intensely forcible [adj VIOLENTLY] / (obsolete) to force [v -ED, -ING, -S]\n",
  "VIOLENTED": "VIOLENT, (obsolete) to force [v]\n",
  "VIOLENTING": "VIOLENT, (obsolete) to force [v]\n",
  "VIOLENTLY": "VIOLENT, intensely forcible [adv]\n",
  "VIOLENTS": "VIOLENT, (obsolete) to force [v]\n",
  "VIOLER": "a viol player, a fiddler [n -S]\n",
  "VIOLERS": "VIOLER, a viol player, a fiddler [n]\n",
  "VIOLET": "any plant or flower of the genus Viola [n -S]\n",
  "VIOLETS": "VIOLET, any plant or flower of the genus Viola [n]\n",
  "VIOLIN": "the smallest of the modern stringed instrument [n -S]\n",
  "VIOLINIST": "one who plays the violin [n -S]\n",
  "VIOLINISTIC": "of or like a violinist [adj VIOLINISTICALLY]\n",
  "VIOLINISTICALLY": "VIOLINISTIC, of or like a violinist [adv]\n",
  "VIOLINISTS": "VIOLINIST, one who plays the violin [n]\n",
  "VIOLINS": "VIOLIN, the smallest of the modern stringed instrument [n]\n",
  "VIOLIST": "one who plays the viola [n -S]\n",
  "VIOLISTS": "VIOLIST, one who plays the viola [n]\n",
  "VIOLONCELLI": "VIOLONCELLO, (Italian) a musical instrument, aka cello [n]\n",
  "VIOLONCELLIST": "one who plays the violoncello [n -S]\n",
  "VIOLONCELLISTS": "VIOLONCELLIST, one who plays the violoncello [n]\n",
  "VIOLONCELLO": "(Italian) a musical instrument, aka cello [n VIOLONCELLI or VIOLONCELLOS]\n",
  "VIOLONCELLOS": "VIOLONCELLO, (Italian) a musical instrument, aka cello [n]\n",
  "VIOLONE": "(Italian) a double-bass viol [n -S]\n",
  "VIOLONES": "VIOLONE, (Italian) a double-bass viol [n]\n",
  "VIOLS": "VIOL, any member of a class of stringed instruments, forerunners of the violin class [n]\n",
  "VIOMYCIN": "a drug used in the treatment of TB [n -S]\n",
  "VIOMYCINS": "VIOMYCIN, a drug used in the treatment of TB [n]\n",
  "VIOSTEROL": "a type of vitamin [n -S]\n",
  "VIOSTEROLS": "VIOSTEROL, a type of vitamin [n]\n",
  "VIPASSANA": "(Sanskrit) meditative practice in Buddhism, aimed at obtaining a true metaphysical picture of reality, which means dissolving the stable categories of substance and self in favour of the evanescent [n -S]\n",
  "VIPASSANAS": "VIPASSANA, (Sanskrit) meditative practice in Buddhism, aimed at obtaining a true metaphysical picture of reality, which means dissolving the stable categories of substance and self in favour of the evanescent [n]\n",
  "VIPER": "a venomous snake [n -S]\n",
  "VIPERFISH": "a predatory deep-sea fish [n -ES]\n",
  "VIPERFISHES": "VIPERFISH, a predatory deep-sea fish [n]\n",
  "VIPERIFORM": "shaped like a snake or viper [adj]\n",
  "VIPERINE": "of or pertaining to a viper or vipers [adj]\n",
  "VIPERISH": "like a viper [adj VIPERISHLY]\n",
  "VIPERISHLY": "VIPERISH, like a viper [adv]\n",
  "VIPERLIKE": "like a viper [adj]\n",
  "VIPEROUS": "having the qualities of a viper; venomous [adj]\n",
  "VIPEROUSLY": "VIPEROUS, having the qualities of a viper; venomous [adv]\n",
  "VIPERS": "VIPER, a venomous snake [n]\n",
  "VIRAEMIA": "(Latin) the presence of viral particles in the blood, also VIREMIA [n -S]\n",
  "VIRAEMIAS": "VIRAEMIA, (Latin) the presence of viral particles in the blood, also VIREMIA [n]\n",
  "VIRAEMIC": "pertaining to viraemia, also VIREMIC [adj]\n",
  "VIRAGINIAN": "of or pertaining to a virago, also VIRAGINOUS [adj]\n",
  "VIRAGINOUS": "of or pertaining to a virago, also VIRAGINIAN [adj]\n",
  "VIRAGO": "(Latin) a noisy, domineering woman [n -ES or -S]\n",
  "VIRAGOES": "VIRAGO, (Latin) a noisy, domineering woman [n]\n",
  "VIRAGOISH": "like a virago, a loud overbearing woman, a termagant [adj]\n",
  "VIRAGOS": "VIRAGO, (Latin) a noisy, domineering woman [n]\n",
  "VIRAL": "relating to or caused by a virus [adj VIRALLY] / a sales promotion carried out by viral marketing [n -S]\n",
  "VIRALITIES": "VIRALITY, the state of being viral [n]\n",
  "VIRALITY": "the state of being viral [n VIRALITIES]\n",
  "VIRALLY": "VIRAL, relating to or caused by a virus [adv]\n",
  "VIRALS": "VIRAL, a sales promotion carried out by viral marketing [n]\n",
  "VIRANDA": "(Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDA, VERANDAH, VIRANDO [n -S]\n",
  "VIRANDAS": "VIRANDA, (Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDA, VERANDAH, VIRANDO [n]\n",
  "VIRANDO": "(Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDA, VERANDAH, VIRANDA [n -S]\n",
  "VIRANDOS": "VIRANDO, (Hindi) a roofed gallery, terrace, or open portico along the front or side of a building, also VERANDA, VERANDAH, VIRANDA [n]\n",
  "VIRE": "to transfer funds by virement [v VIRED, VIRING, VIRES]\n",
  "VIRED": "VIRE, to transfer funds by virement [v]\n",
  "VIRELAI": "(French) an old French lyric form in two-rhymed stanzas of short lines, also VIRELAY [n -S]\n",
  "VIRELAIS": "VIRELAI, (French) an old French lyric form in two-rhymed stanzas of short lines, also VIRELAY [n]\n",
  "VIRELAY": "(French) an old French lyric form in two-rhymed stanzas of short lines, also VIRELAI [n -S]\n",
  "VIRELAYS": "VIRELAY, (French) an old French lyric form in two-rhymed stanzas of short lines, also VIRELAI [n]\n",
  "VIREMENT": "(French) in accounting, an authorised transfer of a surplus to balance a deficit under another heading [n -S]\n",
  "VIREMENTS": "VIREMENT, (French) in accounting, an authorised transfer of a surplus to balance a deficit under another heading [n]\n",
  "VIREMIA": "(Latin) the presence of viral particles in the blood, also VIRAEMIA [n -S]\n",
  "VIREMIAS": "VIREMIA, (Latin) the presence of viral particles in the blood, also VIRAEMIA [n]\n",
  "VIREMIC": "pertaining to viraemia, also VIRAEMIC [adj]\n",
  "VIRENT": "(archaic) green; not withered [adj]\n",
  "VIREO": "any one of numerous species of American singing birds, aka greenlet [n -S]\n",
  "VIREONINE": "a bird of the vireo family [n -S]\n",
  "VIREONINES": "VIREONINE, a bird of the vireo family [n]\n",
  "VIREOS": "VIREO, any one of numerous species of American singing birds, aka greenlet [n]\n",
  "VIRES": "VIRE, to transfer funds by virement [v]\n",
  "VIRESCENCE": "the act or state of becoming green through the formation of chlorophyll [n -S]\n",
  "VIRESCENCES": "VIRESCENCE, the act or state of becoming green through the formation of chlorophyll [n]\n",
  "VIRESCENT": "becoming green [adj]\n",
  "VIRETOT": "(Scott) rush, dash, gad [n -S]\n",
  "VIRETOTS": "VIRETOT, (Scott) rush, dash, gad [n]\n",
  "VIRGA": "(Latin) a trail of water-drops coming from cloud but not reaching the ground as precipitation [n VIRGAE or VIRGAS]\n",
  "VIRGAE": "VIRGA, (Latin) a trail of water-drops coming from cloud but not reaching the ground as precipitation [n]\n",
  "VIRGAS": "VIRGA, (Latin) a trail of water-drops coming from cloud but not reaching the ground as precipitation [n]\n",
  "VIRGATE": "an early English land measure [n -S]\n",
  "VIRGATES": "VIRGATE, an early English land measure [n]\n",
  "VIRGE": "(obsolete) verge [n -S]\n",
  "VIRGER": "(obsolete) a verger (still the accepted spelling at St Paul's) [n -S]\n",
  "VIRGERS": "VIRGER, (obsolete) a verger (still the accepted spelling at St Paul's) [n]\n",
  "VIRGES": "VIRGE, (obsolete) verge [n]\n",
  "VIRGIN": "chaste [adj VIRGINLY] / (Shakespeare) to continue chaste [v -ED, -ING, -S]\n",
  "VIRGINAL": "like a virgin [adj VIRGINALLY] / (Shakespeare) to play on the virginal, a kind of mediaeval harp [v VIRGINALLED, VIRGINALLING, VIRGINALS]\n",
  "VIRGINALIST": "one who plays on a virginal [n -S]\n",
  "VIRGINALISTS": "VIRGINALIST, one who plays on a virginal [n]\n",
  "VIRGINALLED": "VIRGINAL, (Shakespeare) to play on the virginal, a kind of mediaeval harp [v]\n",
  "VIRGINALLING": "VIRGINAL, (Shakespeare) to play on the virginal, a kind of mediaeval harp [v]\n",
  "VIRGINALLY": "VIRGINAL, like a virgin [adv]\n",
  "VIRGINALS": "VIRGINAL, (Shakespeare) to play on the virginal, a kind of mediaeval harp [v]\n",
  "VIRGINED": "VIRGIN, (Shakespeare) to continue chaste [v]\n",
  "VIRGINHOOD": "virginity [n -S]\n",
  "VIRGINHOODS": "VIRGINHOOD, virginity [n]\n",
  "VIRGINIA": "a type of tobacco grown originally in Virginia [n -S]\n",
  "VIRGINIAS": "VIRGINIA, a type of tobacco grown originally in Virginia [n]\n",
  "VIRGINING": "VIRGIN, (Shakespeare) to continue chaste [v]\n",
  "VIRGINITIES": "VIRGINITY, the state of being virgin [n]\n",
  "VIRGINITY": "the state of being virgin [n VIRGINITIES]\n",
  "VIRGINIUM": "a name proposed for chemical element no 87, now called francium [n -S]\n",
  "VIRGINIUMS": "VIRGINIUM, a name proposed for chemical element no 87, now called francium [n]\n",
  "VIRGINLY": "VIRGIN, chaste [adv]\n",
  "VIRGINS": "VIRGIN, (Shakespeare) to continue chaste [v]\n",
  "VIRGULATE": "shaped like a little twig or rod [adj]\n",
  "VIRGULE": "(French) a diagonal printing mark used to separate alternatives [n -S]\n",
  "VIRGULES": "VIRGULE, (French) a diagonal printing mark used to separate alternatives [n]\n",
  "VIRICIDAL": "relating to a viricide, a substance that destroys a virus, also VIRUCIDAL [adj]\n",
  "VIRICIDE": "a substance that destroys viruses, also VIRUCIDE [n -S]\n",
  "VIRICIDES": "VIRICIDE, a substance that destroys viruses, also VIRUCIDE [n]\n",
  "VIRID": "bright green [adj]\n",
  "VIRIDESCENCE": "turning green [n -S]\n",
  "VIRIDESCENCES": "VIRIDESCENCE, turning green [n]\n",
  "VIRIDESCENT": "greenish [adj]\n",
  "VIRIDIAN": "a greenish-blue pigment [n -S]\n",
  "VIRIDIANS": "VIRIDIAN, a greenish-blue pigment [n]\n",
  "VIRIDITE": "a green decomposition product in rocks [n -S]\n",
  "VIRIDITES": "VIRIDITE, a green decomposition product in rocks [n]\n",
  "VIRIDITIES": "VIRIDITY, the state of being virid, bright green [n]\n",
  "VIRIDITY": "the state of being virid, bright green [n VIRIDITIES]\n",
  "VIRILE": "having masculine vigour [adj VIRILELY]\n",
  "VIRILELY": "VIRILE, having masculine vigour [adv]\n",
  "VIRILESCENCE": "development of male character in the female [n -S]\n",
  "VIRILESCENCES": "VIRILESCENCE, development of male character in the female [n]\n",
  "VIRILESCENT": "showing virilescence, development of male character in the female [adj]\n",
  "VIRILISATION": "the development of male sexual characteristics in the female, also VIRILIZATION [n -S]\n",
  "VIRILISATIONS": "VIRILISATION, the development of male sexual characteristics in the female, also VIRILIZATION [n]\n",
  "VIRILISE": "to introduce male characteristics in (a female), also VIRILIZE [v VIRILISED, VIRILISING, VIRILISES]\n",
  "VIRILISED": "VIRILISE, to introduce male characteristics in (a female), also VIRILIZE [v]\n",
  "VIRILISES": "VIRILISE, to introduce male characteristics in (a female), also VIRILIZE [v]\n",
  "VIRILISING": "VIRILISE, to introduce male characteristics in (a female), also VIRILIZE [v]\n",
  "VIRILISM": "the development of male sex characteristics in a female [n -S]\n",
  "VIRILISMS": "VIRILISM, the development of male sex characteristics in a female [n]\n",
  "VIRILITIES": "VIRILITY, the state of being virile [n]\n",
  "VIRILITY": "the state of being virile [n VIRILITIES]\n",
  "VIRILIZATION": "the development of male sexual characteristics in the female, also VIRILISATION [n -S]\n",
  "VIRILIZATIONS": "VIRILIZATION, the development of male sexual characteristics in the female, also VIRILISATION [n]\n",
  "VIRILIZE": "to introduce male characteristics in (a female), also VIRILISE [v VIRILIZED, VIRILIZING, VIRILIZES]\n",
  "VIRILIZED": "VIRILIZE, to introduce male characteristics in (a female), also VIRILISE [v]\n",
  "VIRILIZES": "VIRILIZE, to introduce male characteristics in (a female), also VIRILISE [v]\n",
  "VIRILIZING": "VIRILIZE, to introduce male characteristics in (a female), also VIRILISE [v]\n",
  "VIRILOCAL": "living with one's husband's family [adj]\n",
  "VIRING": "VIRE, to transfer funds by virement [v]\n",
  "VIRINO": "a hypothetical particle said to be the cause of BSE [n -S]\n",
  "VIRINOS": "VIRINO, a hypothetical particle said to be the cause of BSE [n]\n",
  "VIRION": "a virus particle in its mature, infectious state [n -S]\n",
  "VIRIONS": "VIRION, a virus particle in its mature, infectious state [n]\n",
  "VIRL": "(Scots) a ferrule [n -S]\n",
  "VIRLS": "VIRL, (Scots) a ferrule [n]\n",
  "VIROGENE": "a virus-forming gene [n -S]\n",
  "VIROGENES": "VIROGENE, a virus-forming gene [n]\n",
  "VIROID": "a viruslike plant pathogen [n -S]\n",
  "VIROIDS": "VIROID, a viruslike plant pathogen [n]\n",
  "VIROLOGIC": "relating to virology, the study of viruses, also VIROLOGICAL [adj VIROLOGICALLY]\n",
  "VIROLOGICAL": "relating to virology, the study of viruses, also VIROLOGIC [adj VIROLOGICALLY]\n",
  "VIROLOGICALLY": "VIROLOGICAL, relating to virology, the study of viruses, also VIROLOGIC [adv]\n",
  "VIROLOGIES": "VIROLOGY, the study of viruses [n]\n",
  "VIROLOGIST": "a student of virology [n -S]\n",
  "VIROLOGISTS": "VIROLOGIST, a student of virology [n]\n",
  "VIROLOGY": "the study of viruses [n VIROLOGIES]\n",
  "VIROSE": "poisonous; foul, also VIROUS [adj]\n",
  "VIROSES": "VIROSIS, infection with a virus [n]\n",
  "VIROSIS": "infection with a virus [n VIROSES]\n",
  "VIROUS": "poisonous, foul, also VIROSE [adj]\n",
  "VIRTU": "(French) a love or taste for the fine arts, also VERTU [n -S]\n",
  "VIRTUAL": "having the effect but not the actual form of what is specified [adj VIRTUALLY]\n",
  "VIRTUALISATION": "the process of creating an artificial computer-generated version of (something) which functions as if it were real, also VIRTUALIZATION [n -S]\n",
  "VIRTUALISATIONS": "VIRTUALISATION, the process of creating an artificial computer-generated version of (something) which functions as if it were real, also VIRTUALIZATION [n]\n",
  "VIRTUALISE": "to make virtual, also VIRTUALIZE [v VIRTUALISED, VIRTUALISING, VIRTUALISES]\n",
  "VIRTUALISED": "VIRTUALISE, to make virtual, also VIRTUALIZE [v]\n",
  "VIRTUALISES": "VIRTUALISE, to make virtual, also VIRTUALIZE [v]\n",
  "VIRTUALISING": "VIRTUALISE, to make virtual, also VIRTUALIZE [v]\n",
  "VIRTUALISM": "the doctrine of Christ's virtual presence in the Eucharist [n -S]\n",
  "VIRTUALISMS": "VIRTUALISM, the doctrine of Christ's virtual presence in the Eucharist [n]\n",
  "VIRTUALIST": "one who believes in virtualism, the doctrine of Christ's virtual presence in the Eucharist [n -S]\n",
  "VIRTUALISTS": "VIRTUALIST, one who believes in virtualism, the doctrine of Christ's virtual presence in the Eucharist [n]\n",
  "VIRTUALITIES": "VIRTUALITY, the state of being virtual [n]\n",
  "VIRTUALITY": "the state of being virtual [n VIRTUALITIES]\n",
  "VIRTUALIZATION": "the process of creating an artificial computer-generated version of (something) which functions as if it were real, also VIRTUALISATION [n -S]\n",
  "VIRTUALIZATIONS": "VIRTUALIZATION, the process of creating an artificial computer-generated version of (something) which functions as if it were real, also VIRTUALISATION [n]\n",
  "VIRTUALIZE": "to make virtual, also VIRTUALISE [v VIRTUALIZED, VIRTUALIZING, VIRTUALIZES]\n",
  "VIRTUALIZED": "VIRTUALIZE, to make virtual, also VIRTUALISE [v]\n",
  "VIRTUALIZES": "VIRTUALIZE, to make virtual, also VIRTUALISE [v]\n",
  "VIRTUALIZING": "VIRTUALIZE, to make virtual, also VIRTUALISE [v]\n",
  "VIRTUALLY": "VIRTUAL, having the effect but not the actual form of what is specified [adv]\n",
  "VIRTUE": "moral excellence, also VERTUE [n -S]\n",
  "VIRTUELESS": "destitute of virtue [adj]\n",
  "VIRTUES": "VIRTUE, moral excellence, also VERTUE [n]\n",
  "VIRTUOSA": "(Italian) a female virtuoso [n VIRTUOSE or VIRTUOSAS]\n",
  "VIRTUOSAS": "VIRTUOSA, (Italian) a female virtuoso [n]\n",
  "VIRTUOSE": "VIRTUOSA, (Italian) a female virtuoso [n]\n",
  "VIRTUOSI": "VIRTUOSO, (Italian) a highly skilled artistic performer [n]\n",
  "VIRTUOSIC": "exhibiting the qualities of a virtuoso [adj]\n",
  "VIRTUOSITIES": "VIRTUOSITY, exceptional technical skill in music or other fine art [n]\n",
  "VIRTUOSITY": "exceptional technical skill in music or other fine art [n VIRTUOSITIES]\n",
  "VIRTUOSO": "(Italian) a highly skilled artistic performer [n VIRTUOSOS or VIRTUOSI]\n",
  "VIRTUOSOS": "VIRTUOSO, (Italian) a highly skilled artistic performer [n]\n",
  "VIRTUOSOSHIP": "being a virtuoso [n -S]\n",
  "VIRTUOSOSHIPS": "VIRTUOSOSHIP, being a virtuoso [n]\n",
  "VIRTUOUS": "characterized by virtue, also VERTUOUS [adj VIRTUOUSLY]\n",
  "VIRTUOUSLY": "VIRTUOUS, characterized by virtue, also VERTUOUS [adv]\n",
  "VIRTUOUSNESS": "the state of being virtuous [n -ES]\n",
  "VIRTUOUSNESSES": "VIRTUOUSNESS, the state of being virtuous [n]\n",
  "VIRTUS": "VIRTU, (French) a love or taste for the fine arts, also VERTU [n]\n",
  "VIRUCIDAL": "relating to a virucide, a substance that destroys a virus, also VIRICIDAL [adj]\n",
  "VIRUCIDE": "a substance that destroys viruses, also VIRICIDE [n -S]\n",
  "VIRUCIDES": "VIRUCIDE, a substance that destroys viruses, also VIRICIDE [n]\n",
  "VIRULENCE": "the state of being virulent, also VIRULENCY [n -S]\n",
  "VIRULENCES": "VIRULENCE, the state of being virulent, also VIRULENCY [n]\n",
  "VIRULENCIES": "VIRULENCY, the state of being virulent, also VIRULENCE [n]\n",
  "VIRULENCY": "the state of being virulent, also VIRULENCE [n VIRULENCIES]\n",
  "VIRULENT": "extremely poisonous [adj VIRULENTLY]\n",
  "VIRULENTLY": "VIRULENT, extremely poisonous [adv]\n",
  "VIRULIFEROUS": "containing, producing, or conveying an agent of infection and esp. a virus [adj]\n",
  "VIRUS": "(Latin) a pathogenic agent, usually a protein-coated particle of RNA or DNA, capable of increasing rapidly inside a living cell [n -ES]\n",
  "VIRUSES": "VIRUS, (Latin) a pathogenic agent, usually a protein-coated particle of RNA or DNA, capable of increasing rapidly inside a living cell [n]\n",
  "VIRUSLIKE": "like a virus [adj]\n",
  "VIRUSOID": "a particle of RNA associated with some plant viruses [n -S]\n",
  "VIRUSOIDS": "VIRUSOID, a particle of RNA associated with some plant viruses [n]\n",
  "VIS": "(Latin) force [n VIRES]\n",
  "VISA": "to stamp with an official endorsement [v VISAED or VISEED, VISAING, VISAS]\n",
  "VISAED": "VISA, to stamp with an official endorsement [v]\n",
  "VISAGE": "the face of facial expression of a person [n -S]\n",
  "VISAGED": "having a visage [adj]\n",
  "VISAGES": "VISAGE, the face of facial expression of a person [n]\n",
  "VISAGIST": "an expert in facial makeup [n -S]\n",
  "VISAGISTE": "an expert in facial makeup, also VISAGIST [n -S]\n",
  "VISAGISTES": "VISAGISTE, an expert in facial makeup, also VISAGIST [n]\n",
  "VISAGISTS": "VISAGIST, an expert in facial makeup [n]\n",
  "VISAING": "VISA, to stamp with an official endorsement [v]\n",
  "VISARD": "a mask or visor, also VIZARD [n -S]\n",
  "VISARDS": "VISARD, a mask or visor, also VIZARD [n]\n",
  "VISAS": "VISA, to stamp with an official endorsement [v]\n",
  "VISCACHA": "(Quechua) a gregarious burrowing South American rodent related to the chinchilla, also BISCACHA, BIZCACHA, VIZCACHA [n -S]\n",
  "VISCACHAS": "VISCACHA, (Quechua) a gregarious burrowing South American rodent related to the chinchilla, also BISCACHA, BIZCACHA, VIZCACHA [n]\n",
  "VISCACHERA": "(Spanish) a settlement of viscachas, a gregarious burrowing South American rodent [n -S]\n",
  "VISCACHERAS": "VISCACHERA, (Spanish) a settlement of viscachas, a gregarious burrowing South American rodent [n]\n",
  "VISCARIA": "any plant of the genus Viscaria [n -S]\n",
  "VISCARIAS": "VISCARIA, any plant of the genus Viscaria [n]\n",
  "VISCERA": "VISCUS, (Latin) one of the organs, as the brain, heart, or stomach, in the great cavities of the body of an animal [n]\n",
  "VISCERAL": "pertaining to the internal organs [adj VISCERALLY]\n",
  "VISCERALLY": "VISCERAL, pertaining to the internal organs [adv]\n",
  "VISCERATE": "to deprive of the viscera, or entrails, also EVISCERATE [v VISCERATED, VISCERATING, VISCERATES]\n",
  "VISCERATED": "VISCERATE, to deprive of the viscera, or entrails, also EVISCERATE [v]\n",
  "VISCERATES": "VISCERATE, to deprive of the viscera, or entrails, also EVISCERATE [v]\n",
  "VISCERATING": "VISCERATE, to deprive of the viscera, or entrails, also EVISCERATE [v]\n",
  "VISCEROMOTOR": "relating to or controlling movements of the viscera [adj]\n",
  "VISCEROPTOSES": "VISCEROPTOSIS, an abnormally low position of the intestines in the abdominal cavity [n]\n",
  "VISCEROPTOSIS": "an abnormally low position of the intestines in the abdominal cavity [n VISCEROPTOSES]\n",
  "VISCEROTONIA": "a pattern of temperament associated with the endomorphic body type, extravert, sociable and fond of bodily comforts [n -S]\n",
  "VISCEROTONIAS": "VISCEROTONIA, a pattern of temperament associated with the endomorphic body type, extravert, sociable and fond of bodily comforts [n]\n",
  "VISCEROTONIC": "in psychology, having a sociable, comfort-loving temperament associated with endomorphy [adj]\n",
  "VISCID": "thick and adhesive [adj VISCIDLY]\n",
  "VISCIDITIES": "VISCIDITY, the state of being viscid [n]\n",
  "VISCIDITY": "the state of being viscid [n VISCIDITIES]\n",
  "VISCIDLY": "VISCID, thick and adhesive [adv]\n",
  "VISCIDNESS": "the state of being viscid [n -ES]\n",
  "VISCIDNESSES": "VISCIDNESS, the state of being viscid [n]\n",
  "VISCIN": "the sticky substance present in the fruits of mistletoe, used in birdlime [n -S]\n",
  "VISCINS": "VISCIN, the sticky substance present in the fruits of mistletoe, used in birdlime [n]\n",
  "VISCOELASTIC": "having appreciable and conjoint viscous and elastic properties [adj]\n",
  "VISCOELASTICITY": "the state of being viscoelastic [n]\n",
  "VISCOID": "somewhat viscid, also VISCOIDAL [adj]\n",
  "VISCOIDAL": "somewhat viscid, also VISCOID [adj]\n",
  "VISCOMETER": "an instrument for measuring viscosity, also VISCOSIMETER [n -S]\n",
  "VISCOMETERS": "VISCOMETER, an instrument for measuring viscosity, also VISCOSIMETER [n]\n",
  "VISCOMETRIC": "relating to viscometry, the measurement of viscosity, also VISCOMETRICAL [adj]\n",
  "VISCOMETRICAL": "relating to viscometry, the measurement of viscosity, also VISCOMETRIC [adj]\n",
  "VISCOMETRIES": "VISCOMETRY, the measurement of viscosity, also VISCOSIMETRY [n]\n",
  "VISCOMETRY": "the measurement of viscosity, also VISCOSIMETRY [n VISCOMETRIES]\n",
  "VISCOSE": "the sodium salt of cellulose xanthate, used in the manufacture of viscose rayon [n -S]\n",
  "VISCOSES": "VISCOSE, the sodium salt of cellulose xanthate, used in the manufacture of viscose rayon [n]\n",
  "VISCOSIMETER": "an instrument for measuring viscosity, also VISCOMETER [n -S]\n",
  "VISCOSIMETERS": "VISCOSIMETER, an instrument for measuring viscosity, also VISCOMETER [n]\n",
  "VISCOSIMETRIC": "relating to measurement by viscosimeter, an instrument for measuring viscosity, also VISCOSIMETRICAL [adj]\n",
  "VISCOSIMETRICAL": "relating to measurement by viscosimeter, an instrument for measuring viscosity, also VISCOSIMETRIC [adj]\n",
  "VISCOSIMETRIES": "VISCOSIMETRY, the measurement of viscosity, also VISCOMETRY [n]\n",
  "VISCOSIMETRY": "the measurement of viscosity, also VISCOMETRY [n VISCOSIMETRIES]\n",
  "VISCOSITIES": "VISCOSITY, the quality of being viscous [n]\n",
  "VISCOSITY": "the quality of being viscous [n VISCOSITIES]\n",
  "VISCOUNT": "a British or Irish nobleman ranking between an earl and a baron [n -S]\n",
  "VISCOUNTCIES": "VISCOUNTCY, the rank or office of a viscount, also VISCOUNTY [n]\n",
  "VISCOUNTCY": "the rank or office of a viscount, also VISCOUNTY [n VISCOUNTCIES]\n",
  "VISCOUNTESS": "the wife or widow of a viscount [n -ES]\n",
  "VISCOUNTESSES": "VISCOUNTESS, the wife or widow of a viscount [n]\n",
  "VISCOUNTIES": "VISCOUNTY, the rank or office of a viscount, also VISCOUNTCY [n]\n",
  "VISCOUNTS": "VISCOUNT, a British or Irish nobleman ranking between an earl and a baron [n]\n",
  "VISCOUNTSHIP": "the office of viscount [n -S]\n",
  "VISCOUNTSHIPS": "VISCOUNTSHIP, the office of viscount [n]\n",
  "VISCOUNTY": "the rank or office of a viscount, also VISCOUNTCY [n VISCOUNTIES]\n",
  "VISCOUS": "adhesive or sticky, and having a ropy or glutinous consistency, also VISCOSE [adj VISCOUSLY]\n",
  "VISCOUSLY": "VISCOUS, adhesive or sticky, and having a ropy or glutinous consistency, also VISCOSE [adv]\n",
  "VISCOUSNESS": "the state of being viscous [n -ES]\n",
  "VISCOUSNESSES": "VISCOUSNESS, the state of being viscous [n]\n",
  "VISCUM": "(Latin) a genus of parasitic shrubs, including the mistletoe [n -S]\n",
  "VISCUMS": "VISCUM, (Latin) a genus of parasitic shrubs, including the mistletoe [n]\n",
  "VISCUS": "(Latin) one of the organs, as the brain, heart, or stomach, in the great cavities of the body of an animal [n VISCERA]\n",
  "VISE": "to hold in a clamping device [v VISED, VISING, VISES] / to provide with a visa [v VISEED, VISEING, VISES]\n",
  "VISED": "VISE, to hold in a clamping device [v]\n",
  "VISEED": "VISA, to stamp with an official endorsement [v]\n",
  "VISEING": "VISE, to hold in a clamping device [v]\n",
  "VISELIKE": "like a vise [adj]\n",
  "VISES": "VISE, to hold in a clamping device [v]\n",
  "VISHING": "the practise of making VOIP telephone calls in an attempt to elicit confidential information for financial gain (from voice phishing) [n -S]\n",
  "VISHINGS": "VISHING, the practise of making VOIP telephone calls in an attempt to elicit confidential information for financial gain (from voice phishing) [n]\n",
  "VISIBILITIES": "VISIBILITY, the state of being visible [n]\n",
  "VISIBILITY": "the state of being visible [n VISIBILITIES]\n",
  "VISIBLE": "able to be seen [adj VISIBLY] / a visible thing [n -S]\n",
  "VISIBLENESS": "the state of being visible [n -ES]\n",
  "VISIBLENESSES": "VISIBLENESS, the state of being visible [n]\n",
  "VISIBLES": "VISIBLE, a visible thing [n]\n",
  "VISIBLY": "VISIBLE, able to be seen [adv]\n",
  "VISIE": "(Scots) to take a close look, also VIZY, VIZZIE [v VISIED, VISIEING, VISIES]\n",
  "VISIED": "VISIE, (Scots) to take a close look, also VIZY, VIZZIE [v]\n",
  "VISIEING": "VISIE, (Scots) to take a close look, also VIZY, VIZZIE [v]\n",
  "VISIER": "(Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VIZIER, VIZIR, WAZIR, WIZIER [n -S]\n",
  "VISIERS": "VISIER, (Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VIZIER, VIZIR, WAZIR, WIZIER [n]\n",
  "VISIES": "VISIE, (Scots) to take a close look, also VIZY, VIZZIE [v]\n",
  "VISILE": "a person who learns by visual image [n -S]\n",
  "VISILES": "VISILE, a person who learns by visual image [n]\n",
  "VISING": "VISE, to hold in a clamping device [v]\n",
  "VISIOGENIC": "suitable for transmission by television [adj]\n",
  "VISION": "the act or faculty of seeing [n -S] / to see, perceive [v -ED, -ING, -S]\n",
  "VISIONAL": "imaginary [adj VISIONALLY]\n",
  "VISIONALLY": "VISIONAL, imaginary [adv]\n",
  "VISIONARIES": "VISIONARY, a person of imagination or foresight, also VISIONER, VISIONIST [n]\n",
  "VISIONARINESS": "the state of being visionary [n -ES]\n",
  "VISIONARINESSES": "VISIONARINESS, the state of being visionary [n]\n",
  "VISIONARY": "a person of imagination or foresight, also VISIONER, VISIONIST [n VISIONARIES]\n",
  "VISIONED": "VISION, to see, perceive [v]\n",
  "VISIONER": "a person who sees visions [n -S]\n",
  "VISIONERS": "VISIONER, a person who sees visions [n]\n",
  "VISIONING": "the act of seeing visions [n -S]\n",
  "VISIONINGS": "VISIONING, the act of seeing visions [n]\n",
  "VISIONIST": "a visionary, also VISIONARY, VISIONER [n -S]\n",
  "VISIONISTS": "VISIONIST, a visionary, also VISIONARY, VISIONER [n]\n",
  "VISIONLESS": "destitute of vision; sightless [adj]\n",
  "VISIONS": "VISION, to see, perceive [v]\n",
  "VISIOPHONE": "a videophone [n -S]\n",
  "VISIOPHONES": "VISIOPHONE, a videophone [n]\n",
  "VISIT": "to call upon someone [v -ED, -ING, -S]\n",
  "VISITABLE": "capable of being visited; worth visiting [adj]\n",
  "VISITANT": "someone who calls in to see you, also VISITOR, VISITER [n -S]\n",
  "VISITANTS": "VISITANT, someone who calls in to see you, also VISITOR, VISITER [n]\n",
  "VISITATION": "a visit [n -S]\n",
  "VISITATIONAL": "relating to visitation [adj]\n",
  "VISITATIONS": "VISITATION, a visit [n]\n",
  "VISITATIVE": "relating to visitation [adj]\n",
  "VISITATOR": "an official visitor [n -S]\n",
  "VISITATORIAL": "of or relating to visitation or to a judicial visitor or superintendent [adj]\n",
  "VISITATORS": "VISITATOR, an official visitor [n]\n",
  "VISITE": "(French) a light cape or short cloak of silk or lace worn by women in summer [n -S]\n",
  "VISITED": "VISIT, to call upon someone [v]\n",
  "VISITEE": "the person to whom a visit is made [n -S]\n",
  "VISITEES": "VISITEE, the person to whom a visit is made [n]\n",
  "VISITER": "someone who calls in to see you, also VISITOR, VISITANT [n -S]\n",
  "VISITERS": "VISITER, someone who calls in to see you, also VISITOR, VISITANT [n]\n",
  "VISITES": "VISITE, (French) a light cape or short cloak of silk or lace worn by women in summer [n]\n",
  "VISITING": "the act of paying a visit [n -S]\n",
  "VISITINGS": "VISITING, the act of paying a visit [n]\n",
  "VISITOR": "someone who calls in to see you, also VISITANT, VISITER [n -S]\n",
  "VISITORIAL": "of or like a visitor [adj]\n",
  "VISITORS": "VISITOR, someone who calls in to see you, also VISITANT, VISITER [n]\n",
  "VISITRESS": "a female visitor [n -ES]\n",
  "VISITRESSES": "VISITRESS, a female visitor [n]\n",
  "VISITS": "VISIT, to call upon someone [v]\n",
  "VISIVE": "of or pertaining to sight; able to see or be seen [adj]\n",
  "VISNE": "the chosen location for an event, also VENUE, VENEWE, VENEY [n -S]\n",
  "VISNES": "VISNE, the chosen location for an event, also VENUE, VENEWE, VENEY [n]\n",
  "VISNOMIE": "the act of judging character from appearance, also VISNOMY [n -S]\n",
  "VISNOMIES": "VISNOMY, the act of judging character from appearance, also VISNOMIE [n]\n",
  "VISNOMY": "the act of judging character from appearance, also VISNOMIE [n VISNOMIES]\n",
  "VISON": "(French) the American mink [n -S]\n",
  "VISONS": "VISON, (French) the American mink [n]\n",
  "VISOR": "to provide with a projecting brim, also VIZOR [v -ED, -ING, -S]\n",
  "VISORED": "VISOR, to provide with a projecting brim, also VIZOR [v]\n",
  "VISORING": "VISOR, to provide with a projecting brim, also VIZOR [v]\n",
  "VISORLESS": "without a visor, also VIZORLESS [adj]\n",
  "VISORS": "VISOR, to provide with a projecting brim, also VIZOR [v]\n",
  "VISTA": "(Italian) a view, prospect, also VISTO [n -S] / to make into, or see into, vistas [v -ED, -ING, -S]\n",
  "VISTAED": "VISTA, to make into, or see into, vistas [v]\n",
  "VISTAING": "VISTA, to make into, or see into, vistas [v]\n",
  "VISTAL": "pertaining to a vista [adj]\n",
  "VISTALESS": "without a vista [adj]\n",
  "VISTAS": "VISTA, to make into, or see into, vistas [v]\n",
  "VISTO": "(obsolete) a vista, a prospect [n -S]\n",
  "VISTOS": "VISTO, (obsolete) a vista, a prospect [n]\n",
  "VISUAL": "related to sight [adj VISUALLY] / something visual [n -S]\n",
  "VISUALISATION": "the formation of mental visual images, also VISUALIZATION [n -S]\n",
  "VISUALISATIONS": "VISUALISATION, the formation of mental visual images, also VISUALIZATION [n]\n",
  "VISUALISE": "to call up a clear visual image, also VISUALIZE [v VISUALISED, VISUALISING, VISUALISES]\n",
  "VISUALISED": "VISUALISE, to call up a clear visual image, also VISUALIZE [v]\n",
  "VISUALISER": "one who visualises, also VISUALIZER [n -S]\n",
  "VISUALISERS": "VISUALISER, one who visualises, also VISUALIZER [n]\n",
  "VISUALISES": "VISUALISE, to call up a clear visual image, also VISUALIZE [v]\n",
  "VISUALISING": "VISUALISE, to call up a clear visual image, also VISUALIZE [v]\n",
  "VISUALIST": "a visualizer, a visile [n -S]\n",
  "VISUALISTS": "VISUALIST, a visualizer, a visile [n]\n",
  "VISUALITIES": "VISUALITY, (Carlyle) the state of being visible to the mind [n]\n",
  "VISUALITY": "(Carlyle) the state of being visible to the mind [n VISUALITIES]\n",
  "VISUALIZATION": "the formation of mental visual images, also VISUALISATION [n -S]\n",
  "VISUALIZATIONS": "VISUALIZATION, the formation of mental visual images, also VISUALISATION [n]\n",
  "VISUALIZE": "to call up a clear visual image, also VISUALISE [v VISUALIZED, VISUALIZING, VISUALIZES]\n",
  "VISUALIZED": "VISUALIZE, to call up a clear visual image, also VISUALISE [v]\n",
  "VISUALIZER": "one who visualizes, also VISUALISER [n -S]\n",
  "VISUALIZERS": "VISUALIZER, one who visualizes, also VISUALISER [n]\n",
  "VISUALIZES": "VISUALIZE, to call up a clear visual image, also VISUALISE [v]\n",
  "VISUALIZING": "VISUALIZE, to call up a clear visual image, also VISUALISE [v]\n",
  "VISUALLY": "VISUAL, related to sight [adv]\n",
  "VISUALS": "VISUAL, something visual [n]\n",
  "VITA": "(Latin) life [n VITAE or VITAS]\n",
  "VITACEOUS": "of a family of flowering plants that includes the grapevine [adj]\n",
  "VITAE": "VITA, (Latin) life [n]\n",
  "VITAL": "necessary to life [adj VITALLY] / an interior organ vital for life [n -S]\n",
  "VITALISATION": "the act of making vital, also VITALIZATION [n -S]\n",
  "VITALISATIONS": "VITALISATION, the act of making vital, also VITALIZATION [n]\n",
  "VITALISE": "to give life to, also VITALIZE [v VITALISED, VITALISING, VITALISES]\n",
  "VITALISED": "VITALISE, to give life to, also VITALIZE [v]\n",
  "VITALISER": "something that vitalises, a tonic, also VITALIZER [n -S]\n",
  "VITALISERS": "VITALISER, something that vitalises, a tonic, also VITALIZER [n]\n",
  "VITALISES": "VITALISE, to give life to, also VITALIZE [v]\n",
  "VITALISING": "VITALISE, to give life to, also VITALIZE [v]\n",
  "VITALISM": "the philosophical doctrine that life processes are not entirely explicable, or bound, by scientific laws [n -S]\n",
  "VITALISMS": "VITALISM, the philosophical doctrine that life processes are not entirely explicable, or bound, by scientific laws [n]\n",
  "VITALIST": "one who holds to the doctrine of vitalism [n -S]\n",
  "VITALISTIC": "pertaining to vitalism [adj VITALISTICALLY]\n",
  "VITALISTICALLY": "VITALISTIC, pertaining to vitalism [adv]\n",
  "VITALISTS": "VITALIST, one who holds to the doctrine of vitalism [n]\n",
  "VITALITIES": "VITALITY, exuberant physical strength or mental vigor [n]\n",
  "VITALITY": "exuberant physical strength or mental vigor [n VITALITIES]\n",
  "VITALIZATION": "the act of making vital, also VITALISATION [n -S]\n",
  "VITALIZATIONS": "VITALIZATION, the act of making vital, also VITALISATION [n]\n",
  "VITALIZE": "to give life to, also VITALISE [v VITALIZED, VITALIZING, VITALIZES]\n",
  "VITALIZED": "VITALIZE, to give life to, also VITALISE [v]\n",
  "VITALIZER": "something that vitalises, a tonic, also VITALISER [n -S]\n",
  "VITALIZERS": "VITALIZER, something that vitalises, a tonic, also VITALISER [n]\n",
  "VITALIZES": "VITALIZE, to give life to, also VITALISE [v]\n",
  "VITALIZING": "VITALIZE, to give life to, also VITALISE [v]\n",
  "VITALLY": "VITAL, necessary to life [adv]\n",
  "VITALNESS": "the state of being vital [n -ES]\n",
  "VITALNESSES": "VITALNESS, the state of being vital [n]\n",
  "VITALS": "vital organs [n]\n",
  "VITAMER": "a type of chemical compound [n -S]\n",
  "VITAMERS": "VITAMER, a type of chemical compound [n]\n",
  "VITAMIN": "an organic substance essential to proper nutrition, also VITAMINE [n -S]\n",
  "VITAMINE": "an organic substance essential to proper nutrition, also VITAMIN [n -S]\n",
  "VITAMINES": "VITAMINE, an organic substance essential to proper nutrition, also VITAMIN [n]\n",
  "VITAMINIC": "relating to a vitamin [adj]\n",
  "VITAMINISE": "to add vitamins to e.g. a food, also VITAMINIZE [v VITAMINISED, VITAMINISING, VITAMINISES]\n",
  "VITAMINISED": "VITAMINISE, to add vitamins to e.g. a food, also VITAMINIZE [v]\n",
  "VITAMINISES": "VITAMINISE, to add vitamins to e.g. a food, also VITAMINIZE [v]\n",
  "VITAMINISING": "VITAMINISE, to add vitamins to e.g. a food, also VITAMINIZE [v]\n",
  "VITAMINIZE": "to add vitamins to e.g. a food, also VITAMINISE [v VITAMINIZED, VITAMINIZING, VITAMINIZES]\n",
  "VITAMINIZED": "VITAMINIZE, to add vitamins to e.g. a food, also VITAMINISE [v]\n",
  "VITAMINIZES": "VITAMINIZE, to add vitamins to e.g. a food, also VITAMINISE [v]\n",
  "VITAMINIZING": "VITAMINIZE, to add vitamins to e.g. a food, also VITAMINISE [v]\n",
  "VITAMINS": "VITAMIN, an organic substance essential to proper nutrition, also VITAMINE [n]\n",
  "VITAS": "VITA, (Latin) life [n]\n",
  "VITASCOPE": "a moving picture projector [n -S]\n",
  "VITASCOPES": "VITASCOPE, a moving picture projector [n]\n",
  "VITATIVE": "concerned with the preservation of life [adj]\n",
  "VITATIVENESS": "the state of being vitative [n -ES]\n",
  "VITATIVENESSES": "VITATIVENESS, the state of being vitative [n]\n",
  "VITE": "(French) quickly [adv]\n",
  "VITELLARIES": "VITELLARY, the location within an egg where the yolk is formed, also VITELLUS [n]\n",
  "VITELLARY": "the location within an egg where the yolk is formed, also VITELLUS [n VITELLARIES]\n",
  "VITELLI": "VITELLUS, (Latin) the yolk of an egg [n]\n",
  "VITELLICLE": "a yolk-sac [n -S]\n",
  "VITELLICLES": "VITELLICLE, a yolk-sac [n]\n",
  "VITELLIGENOUS": "producing yolk [adj]\n",
  "VITELLIN": "a protein found in egg yolk [n -S]\n",
  "VITELLINE": "a vitellus, a membrane surrounding the yolk of an egg [n -S]\n",
  "VITELLINES": "VITELLINE, a vitellus, a membrane surrounding the yolk of an egg [n]\n",
  "VITELLINS": "VITELLIN, a protein found in egg yolk [n]\n",
  "VITELLOGENESES": "VITELLOGENESIS, yolk formation [n]\n",
  "VITELLOGENESIS": "yolk formation [n VITELLOGENESES]\n",
  "VITELLOGENIC": "producing or stimulating the formation of yolk [adj]\n",
  "VITELLUS": "(Latin) the yolk of an egg [n VITELLUSES or VITELLI]\n",
  "VITELLUSES": "VITELLUS, (Latin) the yolk of an egg [n]\n",
  "VITESSE": "(French) speed [n -S]\n",
  "VITESSES": "VITESSE, (French) speed [n]\n",
  "VITEX": "(Latin) any of various shrubs and small trees of the verbena family [n -ES]\n",
  "VITEXES": "VITEX, (Latin) any of various shrubs and small trees of the verbena family [n]\n",
  "VITIABLE": "able to be impaired [adj]\n",
  "VITIATE": "to impair the quality of, also VICIATE [v VITIATED, VITIATING, VITIATES]\n",
  "VITIATED": "VITIATE, to impair the quality of, also VICIATE [v]\n",
  "VITIATES": "VITIATE, to impair the quality of, also VICIATE [v]\n",
  "VITIATING": "VITIATE, to impair the quality of, also VICIATE [v]\n",
  "VITIATION": "spoiling, impairment [n -S]\n",
  "VITIATIONS": "VITIATION, spoiling, impairment [n]\n",
  "VITIATOR": "one who vitiates [n -S]\n",
  "VITIATORS": "VITIATOR, one who vitiates [n]\n",
  "VITICETA": "VITICETUM, a plantation of vines [n]\n",
  "VITICETUM": "a plantation of vines [n VITICETUMS or VITICETA]\n",
  "VITICETUMS": "VITICETUM, a plantation of vines [n]\n",
  "VITICIDE": "a vine pest [n -S]\n",
  "VITICIDES": "VITICIDE, a vine pest [n]\n",
  "VITICOLOUS": "living on vines [adj]\n",
  "VITICULTURAL": "relating to viticulture [adj VITICULTURALLY]\n",
  "VITICULTURALLY": "VITICULTURAL, relating to viticulture [adv]\n",
  "VITICULTURE": "vine-growing, also VINICULTURE [n -S]\n",
  "VITICULTURER": "one who grows vines [n -S]\n",
  "VITICULTURERS": "VITICULTURER, one who grows vines [n]\n",
  "VITICULTURES": "VITICULTURE, vine-growing, also VINICULTURE [n]\n",
  "VITICULTURIST": "one who practises viticulture [n -S]\n",
  "VITICULTURISTS": "VITICULTURIST, one who practises viticulture [n]\n",
  "VITIFEROUS": "bearing vines [adj]\n",
  "VITILIGO": "(Latin) a rare skin disease consisting in the development of smooth, milk-white spots upon various parts of the body [n -S]\n",
  "VITILIGOS": "VITILIGO, (Latin) a rare skin disease consisting in the development of smooth, milk-white spots upon various parts of the body [n]\n",
  "VITILITIGATE": "to be particularly quarrelsome [v VITILITIGATED, VITILITIGATING, VITILITIGATES]\n",
  "VITILITIGATED": "VITILITIGATE, to be particularly quarrelsome [v]\n",
  "VITILITIGATES": "VITILITIGATE, to be particularly quarrelsome [v]\n",
  "VITILITIGATING": "VITILITIGATE, to be particularly quarrelsome [v]\n",
  "VITILITIGATION": "vexatious wrangling [n -S]\n",
  "VITILITIGATIONS": "VITILITIGATION, vexatious wrangling [n]\n",
  "VITIOSITIES": "VITIOSITY, the state or character of being guilty of or devoted to vice or immorality, also VICIOSITY [n]\n",
  "VITIOSITY": "the state or character of being guilty of or devoted to vice or immorality, also VICIOSITY [n VITIOSITIES]\n",
  "VITIOUS": "vicious in the specific legal sense of impaired, nullified by a flaw [adj]\n",
  "VITRAGE": "(French) a thin curtain for windows or glazed doors [n -S]\n",
  "VITRAGES": "VITRAGE, (French) a thin curtain for windows or glazed doors [n]\n",
  "VITRAIL": "(French) stained glass [n VITRAUX]\n",
  "VITRAILLED": "fitted with vitrail, stained glass [adj]\n",
  "VITRAILLIST": "a maker of glass, esp. stained glass [n -S]\n",
  "VITRAILLISTS": "VITRAILLIST, a maker of glass, esp. stained glass [n]\n",
  "VITRAIN": "a separable constituent of bright coal [n -S]\n",
  "VITRAINS": "VITRAIN, a separable constituent of bright coal [n]\n",
  "VITRAUX": "VITRAIL, (French) stained glass [n]\n",
  "VITRECTOMIES": "VITRECTOMY, the surgical removal of the vitreous humor from the eyeball [n]\n",
  "VITRECTOMY": "the surgical removal of the vitreous humor from the eyeball [n VITRECTOMIES]\n",
  "VITREORETINAL": "as in vitreoretinal traction, friction on the internal limiting membrane of the retina of the eye by adherent vitreous fibrils in vitreous humour detachment [adj]\n",
  "VITREOSITIES": "VITREOSITY, the state of being vitreous [n]\n",
  "VITREOSITY": "the state of being vitreous [n VITREOSITIES]\n",
  "VITREOUS": "glassy [adj VITREOUSLY] / the jelly that fills the eyeball [n -ES]\n",
  "VITREOUSES": "VITREOUS, the jelly that fills the eyeball [n]\n",
  "VITREOUSLY": "VITREOUS, glassy [adv]\n",
  "VITREOUSNESS": "the state of being vitreous [n -ES]\n",
  "VITREOUSNESSES": "VITREOUSNESS, the state of being vitreous [n]\n",
  "VITRESCENCE": "the state of being vitrescent, tending to become glass [n -S]\n",
  "VITRESCENCES": "VITRESCENCE, the state of being vitrescent, tending to become glass [n]\n",
  "VITRESCENT": "tending to become glass [adj]\n",
  "VITRESCIBILITY": "the state of being vitrescible, forming a viscous, glassy layer when subjected to heat [n]\n",
  "VITRESCIBLE": "having the quality of forming a viscous, glassy layer when subjected to heat [adj]\n",
  "VITREUM": "(Latin) a vitreous humour of the eye [n -S]\n",
  "VITREUMS": "VITREUM, (Latin) a vitreous humour of the eye [n]\n",
  "VITRIC": "pertaining to glass [adj]\n",
  "VITRICS": "the art of making or decorating glass articles [n]\n",
  "VITRIFACTION": "the process of converting into glass, also VITRIFICATION [n -S]\n",
  "VITRIFACTIONS": "VITRIFACTION, the process of converting into glass, also VITRIFICATION [n]\n",
  "VITRIFACTURE": "glassblowing [n -S]\n",
  "VITRIFACTURES": "VITRIFACTURE, glassblowing [n]\n",
  "VITRIFIABILITY": "the quality of being vitrifiable [n]\n",
  "VITRIFIABLE": "that can be vitrified [adj]\n",
  "VITRIFICATION": "the process of converting into glass, also VITRIFACTION [n -S]\n",
  "VITRIFICATIONS": "VITRIFICATION, the process of converting into glass, also VITRIFACTION [n]\n",
  "VITRIFIED": "VITRIFY, to convert into glass [v]\n",
  "VITRIFIES": "VITRIFY, to convert into glass [v]\n",
  "VITRIFORM": "of the form or shape of glass [adj]\n",
  "VITRIFY": "to convert into glass [v VITRIFIED, VITRIFYING, VITRIFIES]\n",
  "VITRIFYING": "VITRIFY, to convert into glass [v]\n",
  "VITRINE": "a glass showcase for art objects [n -S]\n",
  "VITRINES": "VITRINE, a glass showcase for art objects [n]\n",
  "VITRIOL": "to treat with sulfuric acid [v VITRIOLED or VITRIOLLED, VITRIOLING or VITRIOLLING, VITRIOLS]\n",
  "VITRIOLATE": "to convert into, or change to, a vitriol [v VITRIOLATED, VITRIOLATING, VITRIOLATES]\n",
  "VITRIOLATED": "VITRIOLATE, to convert into, or change to, a vitriol [v]\n",
  "VITRIOLATES": "VITRIOLATE, to convert into, or change to, a vitriol [v]\n",
  "VITRIOLATING": "VITRIOLATE, to convert into, or change to, a vitriol [v]\n",
  "VITRIOLATION": "conversion into or treatment with vitriol [n -S]\n",
  "VITRIOLATIONS": "VITRIOLATION, conversion into or treatment with vitriol [n]\n",
  "VITRIOLED": "VITRIOL, to treat with sulfuric acid [v]\n",
  "VITRIOLIC": "caustic or hostile [adj]\n",
  "VITRIOLING": "VITRIOL, to treat with sulfuric acid [v]\n",
  "VITRIOLISATION": "the process of vitriolising, also VITRIOLIZATION [n -S]\n",
  "VITRIOLISATIONS": "VITRIOLISATION, the process of vitriolising, also VITRIOLIZATION [n]\n",
  "VITRIOLISE": "to treat with vitriol, also VITRIOLIZE [v VITRIOLISED, VITRIOLISING, VITRIOLISES]\n",
  "VITRIOLISED": "VITRIOLISE, to treat with vitriol, also VITRIOLIZE [v]\n",
  "VITRIOLISES": "VITRIOLISE, to treat with vitriol, also VITRIOLIZE [v]\n",
  "VITRIOLISING": "VITRIOLISE, to treat with vitriol, also VITRIOLIZE [v]\n",
  "VITRIOLIZATION": "the process of vitriolizing, also VITRIOLISATION [n -S]\n",
  "VITRIOLIZATIONS": "VITRIOLIZATION, the process of vitriolizing, also VITRIOLISATION [n]\n",
  "VITRIOLIZE": "to treat with vitriol, also VITRIOLISE [v VITRIOLIZED, VITRIOLIZING, VITRIOLIZES]\n",
  "VITRIOLIZED": "VITRIOLIZE, to treat with vitriol, also VITRIOLISE [v]\n",
  "VITRIOLIZES": "VITRIOLIZE, to treat with vitriol, also VITRIOLISE [v]\n",
  "VITRIOLIZING": "VITRIOLIZE, to treat with vitriol, also VITRIOLISE [v]\n",
  "VITRIOLLED": "VITRIOL, to treat with sulfuric acid [v]\n",
  "VITRIOLLING": "VITRIOL, to treat with sulfuric acid [v]\n",
  "VITRIOLS": "VITRIOL, to treat with sulfuric acid [v]\n",
  "VITRO": "relating to a test tube, as in in vitro [adj]\n",
  "VITTA": "(Latin) a leather strap on a soldier's suit of armour [n VITTAE]\n",
  "VITTAE": "VITTA, (Latin) a leather strap on a soldier's suit of armour [n]\n",
  "VITTATE": "marked or striped with vittae, bands or stripes of colour [adj]\n",
  "VITTLE": "(dialect) to provide with food, also VICTUAL [v VITTLED, VITTLING, VITTLES]\n",
  "VITTLED": "VITTLE, (dialect) to provide with food, also VICTUAL [v]\n",
  "VITTLES": "VITTLE, (dialect) to provide with food, also VICTUAL [v]\n",
  "VITTLING": "VITTLE, (dialect) to provide with food, also VICTUAL [v]\n",
  "VITULAR": "pertaining to a calf, also VITULINE [adj]\n",
  "VITULINE": "pertaining to a calf, also VITULAR [adj]\n",
  "VITUPERABLE": "deserving vituperation [adj]\n",
  "VITUPERATE": "to abuse or censure severely or abusively [v VITUPERATED, VITUPERATING, VITUPERATES]\n",
  "VITUPERATED": "VITUPERATE, to abuse or censure severely or abusively [v]\n",
  "VITUPERATES": "VITUPERATE, to abuse or censure severely or abusively [v]\n",
  "VITUPERATING": "VITUPERATE, to abuse or censure severely or abusively [v]\n",
  "VITUPERATION": "abuse, rejection [n -S]\n",
  "VITUPERATIONS": "VITUPERATION, abuse, rejection [n]\n",
  "VITUPERATIVE": "uttering or given to censure, also VITUPERATORY [adj VITUPERATIVELY]\n",
  "VITUPERATIVELY": "VITUPERATIVE, uttering or given to censure, also VITUPERATORY [adv]\n",
  "VITUPERATOR": "one who vituperates [n -S]\n",
  "VITUPERATORS": "VITUPERATOR, one who vituperates [n]\n",
  "VITUPERATORY": "uttering or given to censure, also VITUPERATIVE [adj]\n",
  "VIVA": "(Italian) to examine orally [v -ED, -ING, -S]\n",
  "VIVACE": "(Italian) a musical passage played in a brisk, spirited manner [n -S]\n",
  "VIVACES": "VIVACE, (Italian) a musical passage played in a brisk, spirited manner [n]\n",
  "VIVACIOUS": "lively [adj VIVACIOUSLY]\n",
  "VIVACIOUSLY": "VIVACIOUS, lively [adv]\n",
  "VIVACIOUSNESS": "the state of being vivacious [n -ES]\n",
  "VIVACIOUSNESSES": "VIVACIOUSNESS, the state of being vivacious [n]\n",
  "VIVACISSIMO": "(Italian) in a very lively manner [adv]\n",
  "VIVACITIES": "VIVACITY, the state of being vivacious, lively [n]\n",
  "VIVACITY": "the state of being vivacious, lively [n VIVACITIES]\n",
  "VIVAED": "VIVA, (Italian) to examine orally [v]\n",
  "VIVAING": "VIVA, (Italian) to examine orally [v]\n",
  "VIVAMENTE": "(Italian) in a lively manner [adv]\n",
  "VIVANDIER": "(French) a (male) attendant on a regiment, who sells provisions [n -S]\n",
  "VIVANDIERE": "(French) a (female) attendant on a regiment, who sells provisions [n -S]\n",
  "VIVANDIERES": "VIVANDIERE, (French) a (female) attendant on a regiment, who sells provisions [n]\n",
  "VIVANDIERS": "VIVANDIER, (French) a (male) attendant on a regiment, who sells provisions [n]\n",
  "VIVARIA": "VIVARIUM, (Latin) a place for raising and keeping live animals, also VIVARY [n]\n",
  "VIVARIES": "VIVARY, a place for raising and keeping live animals, also VIVARIUM [n]\n",
  "VIVARIUM": "(Latin) a place for raising and keeping live animals, also VIVARY [n VIVARIUMS or VIVARIA]\n",
  "VIVARIUMS": "VIVARIUM, (Latin) a place for raising and keeping live animals, also VIVARY [n]\n",
  "VIVARY": "a place for raising and keeping live animals, also VIVARIUM [n VIVARIES]\n",
  "VIVAS": "VIVA, (Italian) to examine orally [v]\n",
  "VIVAT": "(Latin) an expression of enthusiastic approval [n -S]\n",
  "VIVATS": "VIVAT, (Latin) an expression of enthusiastic approval [n]\n",
  "VIVDA": "in Shetland, meat hung and dried without salt, also VIFDA [n -S]\n",
  "VIVDAS": "VIVDA, in Shetland, meat hung and dried without salt, also VIFDA [n]\n",
  "VIVE": "(Scots) lively, forcible [adj VIVELY]\n",
  "VIVELY": "lively [adv]\n",
  "VIVENCIES": "VIVENCY, vitality [n]\n",
  "VIVENCY": "vitality [n VIVENCIES]\n",
  "VIVER": "(dialect) a fishpond [n -S]\n",
  "VIVERRA": "(Latin) a member of the ferret or civet family, also VIVERRID, VIVERRINE [n -S]\n",
  "VIVERRAS": "VIVERRA, (Latin) a member of the ferret or civet family, also VIVERRID, VIVERRINE [n]\n",
  "VIVERRID": "(Latin) a member of the ferret or civet family, also VIVERRA, VIVERRINE [n -S]\n",
  "VIVERRIDS": "VIVERRID, (Latin) a member of the ferret or civet family, also VIVERRA, VIVERRINE [n]\n",
  "VIVERRINE": "a member of the ferret or civet family, also VIVERRA, VIVERRID [n -S]\n",
  "VIVERRINES": "VIVERRINE, a member of the ferret or civet family, also VIVERRA, VIVERRID [n]\n",
  "VIVERS": "(Scots) food; eatables, also VIVRES [n]\n",
  "VIVES": "a disease of horses [n VIVES]\n",
  "VIVIANITE": "ferrous phosphate, blue by oxidation, often found coating fossil fishes and bones [n -S]\n",
  "VIVIANITES": "VIVIANITE, ferrous phosphate, blue by oxidation, often found coating fossil fishes and bones [n]\n",
  "VIVID": "strikingly bright or intense [adj VIVIDER, VIVIDEST, VIVIDLY]\n",
  "VIVIDER": "VIVID, strikingly bright or intense [adj]\n",
  "VIVIDEST": "VIVID, strikingly bright or intense [adj]\n",
  "VIVIDITIES": "VIVIDITY, the state of being vivid [n]\n",
  "VIVIDITY": "the state of being vivid [n VIVIDITIES]\n",
  "VIVIDLY": "VIVID, strikingly bright or intense [adv]\n",
  "VIVIDNESS": "the state of being vivid [n -ES]\n",
  "VIVIDNESSES": "VIVIDNESS, the state of being vivid [n]\n",
  "VIVIFIC": "vivifying [adj]\n",
  "VIVIFICATION": "the act of vivifying [n -S]\n",
  "VIVIFICATIONS": "VIVIFICATION, the act of vivifying [n]\n",
  "VIVIFIED": "VIVIFY, to give life to [v]\n",
  "VIVIFIER": "one who vivifies [n -S]\n",
  "VIVIFIERS": "VIVIFIER, one who vivifies [n]\n",
  "VIVIFIES": "VIVIFY, to give life to [v]\n",
  "VIVIFY": "to give life to [v VIVIFIED, VIVIFYING, VIVIFIES]\n",
  "VIVIFYING": "VIVIFY, to give life to [v]\n",
  "VIVIPARA": "(Latin) animals that bring forth living young [n]\n",
  "VIVIPARIES": "VIVIPARY, plants that germinate from a seed still on the parent plant [n]\n",
  "VIVIPARISM": "the bringing forth of live young [n -S]\n",
  "VIVIPARISMS": "VIVIPARISM, the bringing forth of live young [n]\n",
  "VIVIPARITIES": "VIVIPARITY, the state of being viviparous [n]\n",
  "VIVIPARITY": "the state of being viviparous [n VIVIPARITIES]\n",
  "VIVIPAROUS": "producing live young [adj VIVIPAROUSLY]\n",
  "VIVIPAROUSLY": "VIVIPAROUS, producing live young [adv]\n",
  "VIVIPAROUSNESS": "the state of being viviparous [n]\n",
  "VIVIPARY": "plants that germinate from a seed still on the parent plant [n VIVIPARIES]\n",
  "VIVISECT": "to dissect the living body of [v -ED, -ING, -S]\n",
  "VIVISECTED": "VIVISECT, to dissect the living body of [v]\n",
  "VIVISECTING": "VIVISECT, to dissect the living body of [v]\n",
  "VIVISECTION": "the cutting of or operation on a living animal usually for physiological or pathological investigation [n -S]\n",
  "VIVISECTIONAL": "relating to vivisection [adj VIVISECTIONALLY]\n",
  "VIVISECTIONALLY": "VIVISECTIONAL, relating to vivisection [adv]\n",
  "VIVISECTIONIST": "one who practises vivisection [n -S]\n",
  "VIVISECTIONISTS": "VIVISECTIONIST, one who practises vivisection [n]\n",
  "VIVISECTIONS": "VIVISECTION, the cutting of or operation on a living animal usually for physiological or pathological investigation [n]\n",
  "VIVISECTIVE": "relating to vivisection [adj]\n",
  "VIVISECTOR": "one who vivisects [n -S]\n",
  "VIVISECTORIA": "VIVISECTORIUM, a place for vivisection [n]\n",
  "VIVISECTORIUM": "a place for vivisection [n VIVISECTORIA or VIVISECTORIUMS]\n",
  "VIVISECTORIUMS": "VIVISECTORIUM, a place for vivisection [n]\n",
  "VIVISECTORS": "VIVISECTOR, one who vivisects [n]\n",
  "VIVISECTS": "VIVISECT, to dissect the living body of [v]\n",
  "VIVISEPULTURE": "the practice of burying people alive [n -S]\n",
  "VIVISEPULTURES": "VIVISEPULTURE, the practice of burying people alive [n]\n",
  "VIVO": "(Italian) lively [adv]\n",
  "VIVRES": "(Scots) food; eatables, also VIVERS [n]\n",
  "VIXEN": "a shrewish woman [n -S]\n",
  "VIXENISH": "bad-tempered, snarling [adj VIXENISHLY]\n",
  "VIXENISHLY": "VIXENISH, bad-tempered, snarling [adv]\n",
  "VIXENISHNESS": "the state of being vixenish [n -ES]\n",
  "VIXENISHNESSES": "VIXENISHNESS, the state of being vixenish [n]\n",
  "VIXENLY": "snarling [adj]\n",
  "VIXENS": "VIXEN, a shrewish woman [n]\n",
  "VIZAMENT": "(Shakespeare) advisement, also ADVISEMENT, AVISEMENT [n -S]\n",
  "VIZAMENTS": "VIZAMENT, (Shakespeare) advisement, also ADVISEMENT, AVISEMENT [n]\n",
  "VIZARD": "to mask or disguise [v -ED, -ING, -S]\n",
  "VIZARDED": "VIZARD, to mask or disguise [v]\n",
  "VIZARDING": "VIZARD, to mask or disguise [v]\n",
  "VIZARDS": "VIZARD, to mask or disguise [v]\n",
  "VIZCACHA": "(Quechua) a gregarious burrowing South American rodent related to the chinchilla, also BISCACHA, BIZCACHA, VISCACHA [n -S]\n",
  "VIZCACHAS": "VIZCACHA, (Quechua) a gregarious burrowing South American rodent related to the chinchilla, also BISCACHA, BIZCACHA, VISCACHA [n]\n",
  "VIZIED": "VIZY, (Scots) to take a close look, also VISIE, VIZZIE [v]\n",
  "VIZIER": "(Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIR, WAZIR, WIZIER [n -S]\n",
  "VIZIERATE": "the office, dignity, or authority of a vizier [n -S]\n",
  "VIZIERATES": "VIZIERATE, the office, dignity, or authority of a vizier [n]\n",
  "VIZIERIAL": "of or like a vizier, a minister in various Muslim states, also VIZIRIAL [adj]\n",
  "VIZIERS": "VIZIER, (Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIR, WAZIR, WIZIER [n]\n",
  "VIZIERSHIP": "the office of vizier [n -S]\n",
  "VIZIERSHIPS": "VIZIERSHIP, the office of vizier [n]\n",
  "VIZIES": "VIZY, (Scots) to take a close look, also VISIE, VIZZIE [v]\n",
  "VIZIR": "(Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIER, WAZIR, WIZIER [n -S]\n",
  "VIZIRATE": "(Arabic) the office of a vizir [n -S]\n",
  "VIZIRATES": "VIZIRATE, (Arabic) the office of a vizir [n]\n",
  "VIZIRIAL": "of or like a vizir, a minister in various Muslim states, also VIZIERIAL [adj]\n",
  "VIZIRS": "VIZIR, (Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIER, WAZIR, WIZIER [n]\n",
  "VIZIRSHIP": "the office of vizir [n -S]\n",
  "VIZIRSHIPS": "VIZIRSHIP, the office of vizir [n]\n",
  "VIZOR": "to provide with a projecting brim, also VISOR [v -ED, -ING, -S]\n",
  "VIZORED": "VIZOR, to provide with a projecting brim, also VISOR [v]\n",
  "VIZORING": "VIZOR, to provide with a projecting brim, also VISOR [v]\n",
  "VIZORLESS": "without a vizor, also VISORLESS [adj]\n",
  "VIZORS": "VIZOR, to provide with a projecting brim, also VISOR [v]\n",
  "VIZSLA": "(Hungarian) a Hungarian breed of hunting dog [n -S]\n",
  "VIZSLAS": "VIZSLA, (Hungarian) a Hungarian breed of hunting dog [n]\n",
  "VIZY": "(Scots) to take a close look, also VISIE, VIZZIE [v VIZIED, VIZYING, VIZIES]\n",
  "VIZYING": "VIZY, (Scots) to take a close look, also VISIE, VIZZIE [v]\n",
  "VIZZIE": "(Scots) to take a close look, also VISIE, VIZY [v VIZZIED, VIZZIEING, VIZZIES]\n",
  "VIZZIED": "VIZZIE, (Scots) to take a close look, also VISIE, VIZY [v]\n",
  "VIZZIEING": "VIZZIE, (Scots) to take a close look, also VISIE, VIZY [v]\n",
  "VIZZIES": "VIZZIE, (Scots) to take a close look, also VISIE, VIZY [v]\n",
  "VLEI": "(South African) low-lying ground where a shallow lake forms in the wet season, also VLY [n -S]\n",
  "VLEIS": "VLEI, (South African) low-lying ground where a shallow lake forms in the wet season, also VLY [n]\n",
  "VLIES": "VLY, (South African) low-lying ground where a shallow lake forms in the wet season, also VLEI [n]\n",
  "VLOG": "to keep a video blog [v VLOGGED, VLOGGING, VLOGS]\n",
  "VLOGGED": "VLOG, to keep a video blog [v]\n",
  "VLOGGER": "one who keeps a vlog, a video blog [n -S]\n",
  "VLOGGERS": "VLOGGER, one who keeps a vlog, a video blog [n]\n",
  "VLOGGING": "the act of keeping a vlog, a video blog [n -S]\n",
  "VLOGGINGS": "VLOGGING, the act of keeping a vlog, a video blog [n]\n",
  "VLOGS": "VLOG, to keep a video blog [v]\n",
  "VLY": "(South African) low-lying ground where a shallow lake forms in the wet season, also VLEI [n VLIES]\n",
  "VOAR": "(Orkney) spring, seedtime [n -S]\n",
  "VOARS": "VOAR, (Orkney) spring, seedtime [n]\n",
  "VOCAB": "(short for) vocabulary [n -S]\n",
  "VOCABLE": "capable of being uttered [adj VOCABLY] / a word, or single sound of a word [n -S]\n",
  "VOCABLES": "VOCABLE, a word, or single sound of a word [n]\n",
  "VOCABLY": "VOCABLE, capable of being uttered [adv]\n",
  "VOCABS": "VOCAB, (short for) vocabulary [n]\n",
  "VOCABULAR": "of or concerning words [adj]\n",
  "VOCABULARIAN": "a person much, or too much, concerned with words [n -S]\n",
  "VOCABULARIANS": "VOCABULARIAN, a person much, or too much, concerned with words [n]\n",
  "VOCABULARIED": "having a vocabulary [adj]\n",
  "VOCABULARIES": "VOCABULARY, a list or collection of words or of words and phrases usually alphabetically arranged and explained or defined [n]\n",
  "VOCABULARY": "a list or collection of words or of words and phrases usually alphabetically arranged and explained or defined [n VOCABULARIES]\n",
  "VOCABULIST": "the writer or maker of a vocabulary; a lexicographer [n -S]\n",
  "VOCABULISTS": "VOCABULIST, the writer or maker of a vocabulary; a lexicographer [n]\n",
  "VOCAL": "uttered by the voice, also VOCULAR [adj VOCALLY] / a sound uttered by the voice [n -S]\n",
  "VOCALESE": "a type of singing in which the singer improvises words to familiar instrumental solos [n -S]\n",
  "VOCALESES": "VOCALESE, a type of singing in which the singer improvises words to familiar instrumental solos [n]\n",
  "VOCALIC": "of or pertaining to vowel sounds [adj VOCALICALLY] / a vowel sound [n -S]\n",
  "VOCALICALLY": "VOCALIC, of or pertaining to vowel sounds [adv]\n",
  "VOCALICS": "VOCALIC, a vowel sound [n]\n",
  "VOCALION": "a musical instrument resembling a harmonium [n -S]\n",
  "VOCALIONS": "VOCALION, a musical instrument resembling a harmonium [n]\n",
  "VOCALISATION": "the act of making vocal, also VOCALIZATION [n -S]\n",
  "VOCALISATIONS": "VOCALISATION, the act of making vocal, also VOCALIZATION [n]\n",
  "VOCALISE": "to produce with the voice, also VOCALIZE [v VOCALISED, VOCALISING, VOCALISES]\n",
  "VOCALISED": "VOCALISE, to produce with the voice, also VOCALIZE [v]\n",
  "VOCALISER": "one who vocalises, also VOCALIZER [n -S]\n",
  "VOCALISERS": "VOCALISER, one who vocalises, also VOCALIZER [n]\n",
  "VOCALISES": "VOCALISE, to produce with the voice, also VOCALIZE [v]\n",
  "VOCALISING": "VOCALISE, to produce with the voice, also VOCALIZE [v]\n",
  "VOCALISM": "the exercise of the vocal organs [n -S]\n",
  "VOCALISMS": "VOCALISM, the exercise of the vocal organs [n]\n",
  "VOCALIST": "a singer, as opposed to an instrumentalist [n -S]\n",
  "VOCALISTS": "VOCALIST, a singer, as opposed to an instrumentalist [n]\n",
  "VOCALITIES": "VOCALITY, the possession or exercise of vocal powers [n]\n",
  "VOCALITY": "the possession or exercise of vocal powers [n VOCALITIES]\n",
  "VOCALIZATION": "the act of making vocal, also VOCALISATION [n -S]\n",
  "VOCALIZATIONS": "VOCALIZATION, the act of making vocal, also VOCALISATION [n]\n",
  "VOCALIZE": "to produce with the voice, also VOCALISE [v VOCALIZED, VOCALIZING, VOCALIZES]\n",
  "VOCALIZED": "VOCALIZE, to produce with the voice, also VOCALISE [v]\n",
  "VOCALIZER": "one who vocalizes, also VOCALISER [n -S]\n",
  "VOCALIZERS": "VOCALIZER, one who vocalizes, also VOCALISER [n]\n",
  "VOCALIZES": "VOCALIZE, to produce with the voice, also VOCALISE [v]\n",
  "VOCALIZING": "VOCALIZE, to produce with the voice, also VOCALISE [v]\n",
  "VOCALLY": "with the voice [adv]\n",
  "VOCALNESS": "the quality of being vocal [n -ES]\n",
  "VOCALNESSES": "VOCALNESS, the quality of being vocal [n]\n",
  "VOCALS": "VOCAL, a sound uttered by the voice [n]\n",
  "VOCATION": "one's profession, business or occupation [n -S]\n",
  "VOCATIONAL": "relating to a vocation [adj VOCATIONALLY]\n",
  "VOCATIONALISM": "emphasis on vocational training in education [n -S]\n",
  "VOCATIONALISMS": "VOCATIONALISM, emphasis on vocational training in education [n]\n",
  "VOCATIONALIST": "an exponent of vocationalism [n -S]\n",
  "VOCATIONALISTS": "VOCATIONALIST, an exponent of vocationalism [n]\n",
  "VOCATIONALLY": "VOCATIONAL, relating to a vocation [adv]\n",
  "VOCATIONS": "VOCATION, one's profession, business or occupation [n]\n",
  "VOCATIVE": "relating to the act of calling [adj VOCATIVELY] / a grammatical case indicating calling or personal address [n -S]\n",
  "VOCATIVELY": "VOCATIVE, relating to the act of calling [adv]\n",
  "VOCATIVES": "VOCATIVE, a grammatical case indicating calling or personal address [n]\n",
  "VOCES": "VOX, (Latin) a voice [n]\n",
  "VOCICULTURAL": "of or pertaining to voice training [adj]\n",
  "VOCIFERANCE": "clamour [n -S]\n",
  "VOCIFERANCES": "VOCIFERANCE, clamour [n]\n",
  "VOCIFERANT": "clamorous [adj] / a vociferant person [n -S]\n",
  "VOCIFERANTS": "VOCIFERANT, a vociferant person [n]\n",
  "VOCIFERATE": "to cry out with a loud voice; to bawl [v VOCIFERATED, VOCIFERATING, VOCIFERATES]\n",
  "VOCIFERATED": "VOCIFERATE, to cry out with a loud voice; to bawl [v]\n",
  "VOCIFERATES": "VOCIFERATE, to cry out with a loud voice; to bawl [v]\n",
  "VOCIFERATING": "VOCIFERATE, to cry out with a loud voice; to bawl [v]\n",
  "VOCIFERATION": "the act of vociferating [n -S]\n",
  "VOCIFERATIONS": "VOCIFERATION, the act of vociferating [n]\n",
  "VOCIFERATOR": "one who vociferates [n -S]\n",
  "VOCIFERATORS": "VOCIFERATOR, one who vociferates [n]\n",
  "VOCIFEROSITIES": "VOCIFEROSITY, the state of being vociferous [n]\n",
  "VOCIFEROSITY": "the state of being vociferous [n VOCIFEROSITIES]\n",
  "VOCIFEROUS": "marked by or given to vehement insistent outcry [adj VOCIFEROUSLY]\n",
  "VOCIFEROUSLY": "VOCIFEROUS, marked by or given to vehement insistent outcry [adv]\n",
  "VOCIFEROUSNESS": "the state of being vociferous [n]\n",
  "VOCODER": "an electronic device used in transmitting speech signals [n -S]\n",
  "VOCODERED": "processed or synthesized by a vocoder [adj]\n",
  "VOCODERS": "VOCODER, an electronic device used in transmitting speech signals [n]\n",
  "VOCULAR": "vocal [adj]\n",
  "VOCULE": "a slight vowel sound completing the articulation of certain consonants [n -S]\n",
  "VOCULES": "VOCULE, a slight vowel sound completing the articulation of certain consonants [n]\n",
  "VODCAST": "to broadcast by a video podcast [v -ED, -ING, -S]\n",
  "VODCASTED": "VODCAST, to broadcast by a video podcast [v]\n",
  "VODCASTER": "one who makes vodcasts [n -S]\n",
  "VODCASTERS": "VODCASTER, one who makes vodcasts [n]\n",
  "VODCASTING": "the creation and provision of video files for download to a computer, MP3 player, etc. [n -S]\n",
  "VODCASTINGS": "VODCASTING, the creation and provision of video files for download to a computer, MP3 player, etc. [n]\n",
  "VODCASTS": "VODCAST, to broadcast by a video podcast [v]\n",
  "VODDIES": "VODDY, (colloquial) vodka [n]\n",
  "VODDY": "(colloquial) vodka [n VODDIES]\n",
  "VODKA": "(Russian) an alcoholic drink originating in Russia, made from grain, potatoes etc. [n -S]\n",
  "VODKAS": "VODKA, (Russian) an alcoholic drink originating in Russia, made from grain, potatoes etc. [n]\n",
  "VODOU": "West Indian black magic, also VAUDOO, VAUDOUX, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n -S]\n",
  "VODOUN": "West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n -S]\n",
  "VODOUNS": "VODOUN, West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n]\n",
  "VODOUS": "VODOU, West Indian black magic, also VAUDOO, VAUDOUX, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n]\n",
  "VODUN": "West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n -S]\n",
  "VODUNS": "VODUN, West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VOODOO, VOUDON, VOUDOU, VOUDOUN [n]\n",
  "VOE": "in Orkney or Shetland, a bay or creek, also VAE [n -S]\n",
  "VOEMA": "(South African) vigour [n -S]\n",
  "VOEMAS": "VOEMA, (South African) vigour [n]\n",
  "VOERTSAK": "(South African) offensive, expressing rejection, also VOERTSEK, VOETSAK, VOETSEK [interj]\n",
  "VOERTSEK": "(South African) offensive, expressing rejection, also VOERTSAK, VOETSAK, VOETSEK [interj]\n",
  "VOES": "VOE, in Orkney or Shetland, a bay or creek, also VAE [n]\n",
  "VOETGANGER": "(Dutch) a locust before its wings grow [n -S]\n",
  "VOETGANGERS": "VOETGANGER, (Dutch) a locust before its wings grow [n]\n",
  "VOETSAK": "(South African) offensive, expressing rejection, also VOERTSAK, VOERTSEK, VOETSEK [interj]\n",
  "VOETSEK": "(South African) offensive, expressing rejection, also VOERTSEK, VOERTSAK, VOETSAK [interj]\n",
  "VOETSTOETS": "(South African) denoting a sale in which the vendor is freed from all responsibility for the condition of the goods being sold, also VOETSTOOTS [adj]\n",
  "VOETSTOOTS": "(South African) denoting a sale in which the vendor is freed from all responsibility for the condition of the goods being sold, also VOETSTOETS [adj]\n",
  "VOG": "air pollution caused by volcanic dust [n -S]\n",
  "VOGIE": "(Scots) vain, proud; merry, cheerful [adj VOGIER, VOGIEST]\n",
  "VOGIER": "VOGIE, (Scots) vain, proud; merry, cheerful [adj]\n",
  "VOGIEST": "VOGIE, (Scots) vain, proud; merry, cheerful [adj]\n",
  "VOGS": "VOG, air pollution caused by volcanic dust [n]\n",
  "VOGUE": "to perform to pop music a stylized dance [v VOGUED, VOGUEING or VOGUING, VOGUES]\n",
  "VOGUED": "VOGUE, to perform to pop music a stylized dance [v]\n",
  "VOGUEING": "performing to pop music, also VOGUING [n -S]\n",
  "VOGUEINGS": "VOGUEING, performing to pop music, also VOGUING [n]\n",
  "VOGUER": "one who vogues, performs to pop music a stylized dance [n -S]\n",
  "VOGUERS": "VOGUER, one who vogues, performs to pop music a stylized dance [n]\n",
  "VOGUES": "VOGUE, to perform to pop music a stylized dance [v]\n",
  "VOGUEY": "in vogue [adj VOGUIER, VOGUIEST]\n",
  "VOGUIER": "VOGUEY, in vogue [adj]\n",
  "VOGUIEST": "VOGUEY, in vogue [adj]\n",
  "VOGUING": "performing to pop music, also VOGUEING [n -S]\n",
  "VOGUINGS": "VOGUING, performing to pop music, also VOGUEING [n]\n",
  "VOGUISH": "fashionable [adj VOGUISHLY]\n",
  "VOGUISHLY": "VOGUISH, fashionable [adv]\n",
  "VOGUISHNESS": "the state of being in vogue [n -ES]\n",
  "VOGUISHNESSES": "VOGUISHNESS, the state of being in vogue [n]\n",
  "VOICE": "to express or utter [v VOICED, VOICING, VOICES]\n",
  "VOICED": "VOICE, to express or utter [v]\n",
  "VOICEFUL": "having a voice; vocal [adj]\n",
  "VOICEFULNESS": "the state of being voiceful [n -ES]\n",
  "VOICEFULNESSES": "VOICEFULNESS, the state of being voiceful [n]\n",
  "VOICELESS": "without a voice [adj VOICELESSLY]\n",
  "VOICELESSLY": "VOICELESS, without a voice [adv]\n",
  "VOICELESSNESS": "the state of being voiceless [n -ES]\n",
  "VOICELESSNESSES": "VOICELESSNESS, the state of being voiceless [n]\n",
  "VOICEMAIL": "the facility of leaving recorded messages by telephone [n -S]\n",
  "VOICEMAILS": "VOICEMAIL, the facility of leaving recorded messages by telephone [n]\n",
  "VOICEOVER": "a spoken commentary by an unseen narrator on film [n -S]\n",
  "VOICEOVERS": "VOICEOVER, a spoken commentary by an unseen narrator on film [n]\n",
  "VOICEPRINT": "an electronically recorded visual representation of speech [n -S]\n",
  "VOICEPRINTS": "VOICEPRINT, an electronically recorded visual representation of speech [n]\n",
  "VOICER": "one who voices [n -S]\n",
  "VOICERS": "VOICER, one who voices [n]\n",
  "VOICES": "VOICE, to express or utter [v]\n",
  "VOICING": "the regulation of the tone of organ pipes [n -S]\n",
  "VOICINGS": "VOICING, the regulation of the tone of organ pipes [n]\n",
  "VOID": "to nullify of legal force or effect [v -ED, -ING, -S]\n",
  "VOIDABLE": "able to be voided [adj]\n",
  "VOIDABLENESS": "the state of being voidable [n -ES]\n",
  "VOIDABLENESSES": "VOIDABLENESS, the state of being voidable [n]\n",
  "VOIDANCE": "the act of voiding [n -S]\n",
  "VOIDANCES": "VOIDANCE, the act of voiding [n]\n",
  "VOIDED": "VOID, to nullify of legal force or effect [v]\n",
  "VOIDEE": "(historical) wine and light food taken before going to bed [n -S]\n",
  "VOIDEES": "VOIDEE, (historical) wine and light food taken before going to bed [n]\n",
  "VOIDER": "one who voids [n -S]\n",
  "VOIDERS": "VOIDER, one who voids [n]\n",
  "VOIDING": "the act of voiding [n -S]\n",
  "VOIDINGS": "VOIDING, the act of voiding [n]\n",
  "VOIDNESS": "the state of being void [n -ES]\n",
  "VOIDNESSES": "VOIDNESS, the state of being void [n]\n",
  "VOIDS": "VOID, to nullify of legal force or effect [v]\n",
  "VOILA": "(French) there it is [interj]\n",
  "VOILE": "(French) a thin semitransparent material [n -S]\n",
  "VOILES": "VOILE, (French) a thin semitransparent material [n]\n",
  "VOIP": "a system for converting analogue signals to digital so that telephone calls may be made over the internet (Voice Over Internet Protocol) [n -S]\n",
  "VOIPS": "VOIP, a system for converting analogue signals to digital so that telephone calls may be made over the internet (Voice Over Internet Protocol) [n]\n",
  "VOISINAGE": "(obsolete) a neighbourhood [n -S]\n",
  "VOISINAGES": "VOISINAGE, (obsolete) a neighbourhood [n]\n",
  "VOITURE": "(French) a carriage [n -S]\n",
  "VOITURES": "VOITURE, (French) a carriage [n]\n",
  "VOITURIER": "(French) the driver of a carriage or coach [n -S]\n",
  "VOITURIERS": "VOITURIER, (French) the driver of a carriage or coach [n]\n",
  "VOIVODE": "(Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, WAIVODE, WAIWODE, WAYWODE, WOIWODE [n -S]\n",
  "VOIVODES": "VOIVODE, (Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, WAIVODE, WAIWODE, WAYWODE, WOIWODE [n]\n",
  "VOIVODESHIP": "the office of voivode [n -S]\n",
  "VOIVODESHIPS": "VOIVODESHIP, the office of voivode [n]\n",
  "VOL": "in heraldry, two wings displayed and conjoined [n -S]\n",
  "VOLA": "(Latin) the hollow of a hand or foot [n VOLAE]\n",
  "VOLABLE": "(Shakespeare) nimblewitted [adj]\n",
  "VOLAE": "VOLA, (Latin) the hollow of a hand or foot [n]\n",
  "VOLAGE": "(French) giddy; flighty; fickle [adj]\n",
  "VOLANT": "capable of flight; of a heraldic bird, having the wings extended as if in flight [adj]\n",
  "VOLANTE": "(Spanish) a two-wheeled horse vehicle [n -S]\n",
  "VOLANTES": "VOLANTE, (Spanish) a two-wheeled horse vehicle [n]\n",
  "VOLAR": "pertaining to the palm or sole [adj]\n",
  "VOLARIES": "VOLARY, an aviary [n]\n",
  "VOLARY": "an aviary [n VOLARIES]\n",
  "VOLATIC": "a creature with wings [n -S]\n",
  "VOLATICS": "VOLATIC, a creature with wings [n]\n",
  "VOLATILE": "readily vaporizable at a relatively low temperature [adj] / a winged creature [n -S]\n",
  "VOLATILENESS": "the state of being volatile [n -ES]\n",
  "VOLATILENESSES": "VOLATILENESS, the state of being volatile [n]\n",
  "VOLATILES": "VOLATILE, a winged creature [n]\n",
  "VOLATILISABLE": "capable of being volatilised, also VOLATILIZABLE [adj]\n",
  "VOLATILISATION": "the act of volatilising, also VOLATILIZATION [n -S]\n",
  "VOLATILISATIONS": "VOLATILISATION, the act of volatilising, also VOLATILIZATION [n]\n",
  "VOLATILISE": "to make volatile, also VOLATILIZE [v VOLATILISED, VOLATILISING, VOLATILISES]\n",
  "VOLATILISED": "VOLATILISE, to make volatile, also VOLATILIZE [v]\n",
  "VOLATILISES": "VOLATILISE, to make volatile, also VOLATILIZE [v]\n",
  "VOLATILISING": "VOLATILISE, to make volatile, also VOLATILIZE [v]\n",
  "VOLATILITIES": "VOLATILITY, the state of being volatile [n]\n",
  "VOLATILITY": "the state of being volatile [n VOLATILITIES]\n",
  "VOLATILIZABLE": "capable of being volatilized, also VOLATILISABLE [adj]\n",
  "VOLATILIZATION": "the act of volatilizing, also VOLATILISATION [n -S]\n",
  "VOLATILIZATIONS": "VOLATILIZATION, the act of volatilizing, also VOLATILISATION [n]\n",
  "VOLATILIZE": "to make volatile, also VOLATILISE [v VOLATILIZED, VOLATILIZING, VOLATILIZES]\n",
  "VOLATILIZED": "VOLATILIZE, to make volatile, also VOLATILISE [v]\n",
  "VOLATILIZES": "VOLATILIZE, to make volatile, also VOLATILISE [v]\n",
  "VOLATILIZING": "VOLATILIZE, to make volatile, also VOLATILISE [v]\n",
  "VOLCANIAN": "relating to a volcanic eruption, esp. one that discharges gases and ash but little or no lava, also VULCANIAN [adj]\n",
  "VOLCANIC": "of or like a volcano, also VULCANIC [adj VOLCANICALLY] / a volcanic rock [n -S]\n",
  "VOLCANICALLY": "VOLCANIC, of or like a volcano, also VULCANIC [adv]\n",
  "VOLCANICITIES": "VOLCANICITY, the state of being volcanic, also VULCANICITY [n]\n",
  "VOLCANICITY": "the state of being volcanic, also VULCANICITY [n VOLCANICITIES]\n",
  "VOLCANICS": "VOLCANIC, a volcanic rock [n]\n",
  "VOLCANISATION": "the process of volcanising, also VOLCANIZATION [n -S]\n",
  "VOLCANISATIONS": "VOLCANISATION, the process of volcanising, also VOLCANIZATION [n]\n",
  "VOLCANISE": "to subject to the action of volcanic heat, also VOLCANIZE [v VOLCANISED, VOLCANISING, VOLCANISES]\n",
  "VOLCANISED": "VOLCANISE, to subject to the action of volcanic heat, also VOLCANIZE [v]\n",
  "VOLCANISES": "VOLCANISE, to subject to the action of volcanic heat, also VOLCANIZE [v]\n",
  "VOLCANISING": "VOLCANISE, to subject to the action of volcanic heat, also VOLCANIZE [v]\n",
  "VOLCANISM": "volcanic power or action, also VULCANISM [n -S]\n",
  "VOLCANISMS": "VOLCANISM, volcanic power or action, also VULCANISM [n]\n",
  "VOLCANIST": "one versed in the history and phenomena of volcanoes, also VULCANIST [n -S]\n",
  "VOLCANISTS": "VOLCANIST, one versed in the history and phenomena of volcanoes, also VULCANIST [n]\n",
  "VOLCANIZATION": "the process of volcanizing, also VOLCANISATION [n -S]\n",
  "VOLCANIZATIONS": "VOLCANIZATION, the process of volcanizing, also VOLCANISATION [n]\n",
  "VOLCANIZE": "to subject to the action of volcanic heat, also VOLCANISE [v VOLCANIZED, VOLCANIZING, VOLCANIZES]\n",
  "VOLCANIZED": "VOLCANIZE, to subject to the action of volcanic heat, also VOLCANISE [v]\n",
  "VOLCANIZES": "VOLCANIZE, to subject to the action of volcanic heat, also VOLCANISE [v]\n",
  "VOLCANIZING": "VOLCANIZE, to subject to the action of volcanic heat, also VOLCANISE [v]\n",
  "VOLCANO": "(Italian) a centre of eruption of subterranean matter [n -ES or -S]\n",
  "VOLCANOES": "VOLCANO, (Italian) a centre of eruption of subterranean matter [n]\n",
  "VOLCANOLOGIC": "relating to volcanology, also VOLCANOLOGICAL, VULCANOLOGIC, VULCANOLOGICAL [adj]\n",
  "VOLCANOLOGICAL": "relating to volcanology, also VOLCANOLOGIC, VULCANOLOGIC, VULCANOLOGICAL [adj]\n",
  "VOLCANOLOGIES": "VOLCANOLOGY, the study of volcanoes, also VULCANOLOGY [n]\n",
  "VOLCANOLOGIST": "one who studies volcanology, also VULCANOLOGIST [n -S]\n",
  "VOLCANOLOGISTS": "VOLCANOLOGIST, one who studies volcanology, also VULCANOLOGIST [n]\n",
  "VOLCANOLOGY": "the study of volcanoes, also VULCANOLOGY [n VOLCANOLOGIES]\n",
  "VOLCANOS": "VOLCANO, (Italian) a centre of eruption of subterranean matter [n]\n",
  "VOLE": "to win all tricks in a card game [v VOLED, VOLING, VOLES]\n",
  "VOLED": "VOLE, to win all tricks in a card game [v]\n",
  "VOLELIKE": "like a vole [adj]\n",
  "VOLENS": "(Latin) consenting to the risk of injury [adv]\n",
  "VOLERIES": "VOLERY, a large bird cage [n]\n",
  "VOLERY": "a large bird cage [n VOLERIES]\n",
  "VOLES": "VOLE, to win all tricks in a card game [v]\n",
  "VOLET": "a short veil worn at the back of the head [n -S]\n",
  "VOLETS": "VOLET, a short veil worn at the back of the head [n]\n",
  "VOLING": "VOLE, to win all tricks in a card game [v]\n",
  "VOLITANT": "capable of flying [adj]\n",
  "VOLITATE": "to fly about, flutter [v VOLITATED, VOLITATING, VOLITATES]\n",
  "VOLITATED": "VOLITATE, to fly about, flutter [v]\n",
  "VOLITATES": "VOLITATE, to fly about, flutter [v]\n",
  "VOLITATING": "VOLITATE, to fly about, flutter [v]\n",
  "VOLITATION": "flying, flight [n -S]\n",
  "VOLITATIONAL": "of or like volitation, flying [adj]\n",
  "VOLITATIONS": "VOLITATION, flying, flight [n]\n",
  "VOLITIENT": "willing [adj]\n",
  "VOLITION": "the power of choosing or determining [n -S]\n",
  "VOLITIONAL": "relating to volition, also VOLITIONARY [adj VOLITIONALLY]\n",
  "VOLITIONALLY": "VOLITIONAL, relating to volition, also VOLITIONARY [adv]\n",
  "VOLITIONARY": "relating to volition, also VOLITIONAL [adj]\n",
  "VOLITIONLESS": "without volition [adj]\n",
  "VOLITIONS": "VOLITION, the power of choosing or determining [n]\n",
  "VOLITIVE": "a desiderative verb [n -S]\n",
  "VOLITIVES": "VOLITIVE, a desiderative verb [n]\n",
  "VOLITORIAL": "able to fly [adj]\n",
  "VOLK": "(South African) the Afrikaaner people [n -S]\n",
  "VOLKS": "VOLK, (South African) the Afrikaaner people [n]\n",
  "VOLKSLIED": "(German) a popular song, or national air [n VOLKSLIEDER]\n",
  "VOLKSLIEDER": "VOLKSLIED, (German) a popular song, or national air [n]\n",
  "VOLKSRAAD": "(South African) a legislative assembly, esp. (with cap.) that of the Transvaal or Orange Free State [n -S]\n",
  "VOLKSRAADS": "VOLKSRAAD, (South African) a legislative assembly, esp. (with cap.) that of the Transvaal or Orange Free State [n]\n",
  "VOLLEY": "to return a ball before it touches the ground [v -ED, -ING, -S]\n",
  "VOLLEYBALL": "a game played by volleying an inflated ball over a net [n -S]\n",
  "VOLLEYBALLS": "VOLLEYBALL, a game played by volleying an inflated ball over a net [n]\n",
  "VOLLEYED": "VOLLEY, to return a ball before it touches the ground [v]\n",
  "VOLLEYER": "one who volleys e.g. in tennis [n -S]\n",
  "VOLLEYERS": "VOLLEYER, one who volleys e.g. in tennis [n]\n",
  "VOLLEYING": "VOLLEY, to return a ball before it touches the ground [v]\n",
  "VOLLEYS": "VOLLEY, to return a ball before it touches the ground [v]\n",
  "VOLOST": "(Russian) a local government district in Russia [n -S]\n",
  "VOLOSTS": "VOLOST, (Russian) a local government district in Russia [n]\n",
  "VOLPINO": "(Italian) a small Italian dog with long straight hair [n -S]\n",
  "VOLPINOS": "VOLPINO, (Italian) a small Italian dog with long straight hair [n]\n",
  "VOLPLANE": "to glide in an aeroplane [v VOLPLANED, VOLPLANING, VOLPLANES]\n",
  "VOLPLANED": "VOLPLANE, to glide in an aeroplane [v]\n",
  "VOLPLANES": "VOLPLANE, to glide in an aeroplane [v]\n",
  "VOLPLANING": "VOLPLANE, to glide in an aeroplane [v]\n",
  "VOLS": "VOL, in heraldry, two wings displayed and conjoined [n]\n",
  "VOLT": "to make a sudden leap [v -ED, -ING, -S]\n",
  "VOLTA": "(Italian) a lively dance for couples in 3/4 time, in which each partner lifts the other clear of the ground in turn, also LAVOLT, LAVOLTA [n VOLTE]\n",
  "VOLTAGE": "electromotive force expressed in volts [n -S]\n",
  "VOLTAGES": "VOLTAGE, electromotive force expressed in volts [n]\n",
  "VOLTAIC": "of electricity, generated by chemical action [adj]\n",
  "VOLTAISM": "electricity produced by chemical action [n -S]\n",
  "VOLTAISMS": "VOLTAISM, electricity produced by chemical action [n]\n",
  "VOLTAMETER": "an instrument for measuring electrical current indirectly [n -S]\n",
  "VOLTAMETERS": "VOLTAMETER, an instrument for measuring electrical current indirectly [n]\n",
  "VOLTAMETRIC": "relating to a voltameter, an instrument for measuring electrical current indirectly [adj]\n",
  "VOLTAMMETER": "a dual-purpose instrument that can measure both potential difference and electric current, usually in volts and amperes respectively [n -S]\n",
  "VOLTAMMETERS": "VOLTAMMETER, a dual-purpose instrument that can measure both potential difference and electric current, usually in volts and amperes respectively [n]\n",
  "VOLTE": "(Italian) a fencing movement [n -S]\n",
  "VOLTED": "VOLT, to make a sudden leap [v]\n",
  "VOLTES": "VOLTE, (Italian) a fencing movement [n]\n",
  "VOLTI": "(Italian) a direction to musicians to turn the page [n -S]\n",
  "VOLTIGEUR": "(French) a lightly armed skirmisher [n -S]\n",
  "VOLTIGEURS": "VOLTIGEUR, (French) a lightly armed skirmisher [n]\n",
  "VOLTING": "VOLT, to make a sudden leap [v]\n",
  "VOLTINISM": "the number of broods typically produced per year by a population of a particular insect species [n -S]\n",
  "VOLTINISMS": "VOLTINISM, the number of broods typically produced per year by a population of a particular insect species [n]\n",
  "VOLTIS": "VOLTI, (Italian) a direction to musicians to turn the page [n]\n",
  "VOLTMETER": "an instrument for measuring electrical potential [n -S]\n",
  "VOLTMETERS": "VOLTMETER, an instrument for measuring electrical potential [n]\n",
  "VOLTS": "VOLT, to make a sudden leap [v]\n",
  "VOLUBIL": "(Milton) flowing smoothly, voluble [adj]\n",
  "VOLUBILITIES": "VOLUBILITY, the state of being voluble [n]\n",
  "VOLUBILITY": "the state of being voluble [n VOLUBILITIES]\n",
  "VOLUBLE": "fluent in speech; too fluent or glib, also VOLUBIL [adj VOLUBLY]\n",
  "VOLUBLENESS": "the state of being voluble [n -ES]\n",
  "VOLUBLENESSES": "VOLUBLENESS, the state of being voluble [n]\n",
  "VOLUBLY": "VOLUBLE, fluent in speech; too fluent or glib, also VOLUBIL [adv]\n",
  "VOLUCRINE": "of or pertaining to birds; birdlike [adj]\n",
  "VOLUME": "to send or give out in large quantities [v VOLUMED, VOLUMING, VOLUMES]\n",
  "VOLUMED": "VOLUME, to send or give out in large quantities [v]\n",
  "VOLUMENOMETER": "an instrument for measuring the volume of a solid [n -S]\n",
  "VOLUMENOMETERS": "VOLUMENOMETER, an instrument for measuring the volume of a solid [n]\n",
  "VOLUMES": "VOLUME, to send or give out in large quantities [v]\n",
  "VOLUMETER": "an instrument for measuring the volume of a liquid or gas [n -S]\n",
  "VOLUMETERS": "VOLUMETER, an instrument for measuring the volume of a liquid or gas [n]\n",
  "VOLUMETRIC": "of or pertaining to volumetry, the measurement of volume, also VOLUMETRICAL [adj VOLUMETRICALLY]\n",
  "VOLUMETRICAL": "of or pertaining to volumetry, the measurement of volume, also VOLUMETRIC [adj VOLUMETRICALLY]\n",
  "VOLUMETRICALLY": "VOLUMETRICAL, of or pertaining to volumetry, the measurement of volume, also VOLUMETRIC [adv]\n",
  "VOLUMETRIES": "VOLUMETRY, the act of measuring by volume [n]\n",
  "VOLUMETRY": "the act of measuring by volume [n VOLUMETRIES]\n",
  "VOLUMINAL": "pertaining to volume or cubic capacity [adj]\n",
  "VOLUMING": "VOLUME, to send or give out in large quantities [v]\n",
  "VOLUMINOSITIES": "VOLUMINOSITY, the state of being voluminous [n]\n",
  "VOLUMINOSITY": "the state of being voluminous [n VOLUMINOSITIES]\n",
  "VOLUMINOUS": "bulky, filling much space [adj VOLUMINOUSLY]\n",
  "VOLUMINOUSLY": "VOLUMINOUS, bulky, filling much space [adv]\n",
  "VOLUMINOUSNESS": "the state of being voluminous [n]\n",
  "VOLUMISE": "to give extra body to hair, also VOLUMIZE [v VOLUMISED, VOLUMISING, VOLUMISES]\n",
  "VOLUMISED": "VOLUMISE, to give extra body to hair, also VOLUMIZE [v]\n",
  "VOLUMISER": "an agent used to give extra body to hair [n -S]\n",
  "VOLUMISERS": "VOLUMISER, an agent used to give extra body to hair [n]\n",
  "VOLUMISES": "VOLUMISE, to give extra body to hair, also VOLUMIZE [v]\n",
  "VOLUMISING": "VOLUMISE, to give extra body to hair, also VOLUMIZE [v]\n",
  "VOLUMIST": "an author [n -S]\n",
  "VOLUMISTS": "VOLUMIST, an author [n]\n",
  "VOLUMIZE": "to give extra body to hair, also VOLUMISE [v VOLUMIZED, VOLUMIZING, VOLUMIZES]\n",
  "VOLUMIZED": "VOLUMIZE, to give extra body to hair, also VOLUMISE [v]\n",
  "VOLUMIZER": "an agent used to give extra body to hair, also VOLUMISER [n -S]\n",
  "VOLUMIZERS": "VOLUMIZER, an agent used to give extra body to hair, also VOLUMISER [n]\n",
  "VOLUMIZES": "VOLUMIZE, to give extra body to hair, also VOLUMISE [v]\n",
  "VOLUMIZING": "VOLUMIZE, to give extra body to hair, also VOLUMISE [v]\n",
  "VOLUMOMETER": "an instrument for measuring the volume of a solid body by the quantity of fluid it displaces [n -S]\n",
  "VOLUMOMETERS": "VOLUMOMETER, an instrument for measuring the volume of a solid body by the quantity of fluid it displaces [n]\n",
  "VOLUNTARIES": "VOLUNTARY, music added to a piece at the will of the performer [n]\n",
  "VOLUNTARILY": "VOLUNTARY, not compulsory [adv]\n",
  "VOLUNTARINESS": "the state of being voluntary [n -ES]\n",
  "VOLUNTARINESSES": "VOLUNTARINESS, the state of being voluntary [n]\n",
  "VOLUNTARISM": "the philosophical doctrine that the will dominates the intellect [n -S]\n",
  "VOLUNTARISMS": "VOLUNTARISM, the philosophical doctrine that the will dominates the intellect [n]\n",
  "VOLUNTARIST": "an adherent of voluntarism [n -S]\n",
  "VOLUNTARISTIC": "relating to voluntarism, the philosophical doctrine that the will dominates the intellect [adj]\n",
  "VOLUNTARISTS": "VOLUNTARIST, an adherent of voluntarism [n]\n",
  "VOLUNTARY": "not compulsory [adj VOLUNTARILY] / music added to a piece at the will of the performer [n VOLUNTARIES]\n",
  "VOLUNTARYISM": "the principle or practice of reliance on voluntary action, not coercion [n -S]\n",
  "VOLUNTARYISMS": "VOLUNTARYISM, the principle or practice of reliance on voluntary action, not coercion [n]\n",
  "VOLUNTARYIST": "a believer in voluntaryism [n -S]\n",
  "VOLUNTARYISTS": "VOLUNTARYIST, a believer in voluntaryism [n]\n",
  "VOLUNTATIVE": "a verb form expressing a desire to perform the action denoted by the verb [n -S]\n",
  "VOLUNTATIVES": "VOLUNTATIVE, a verb form expressing a desire to perform the action denoted by the verb [n]\n",
  "VOLUNTEER": "to offer one's services [v -ED, -ING, -S]\n",
  "VOLUNTEERED": "VOLUNTEER, to offer one's services [v]\n",
  "VOLUNTEERING": "VOLUNTEER, to offer one's services [v]\n",
  "VOLUNTEERISM": "the use of volunteers in educational and social work in a community [n -S]\n",
  "VOLUNTEERISMS": "VOLUNTEERISM, the use of volunteers in educational and social work in a community [n]\n",
  "VOLUNTEERS": "VOLUNTEER, to offer one's services [v]\n",
  "VOLUNTOURISM": "tourism in which travellers do voluntary work to help communities or the environment in the places they are visiting [n -S]\n",
  "VOLUNTOURISMS": "VOLUNTOURISM, tourism in which travellers do voluntary work to help communities or the environment in the places they are visiting [n]\n",
  "VOLUPTUARIES": "VOLUPTUARY, a sensualist; a person fond of luxury [n]\n",
  "VOLUPTUARY": "a sensualist; a person fond of luxury [n VOLUPTUARIES]\n",
  "VOLUPTUOSITIES": "VOLUPTUOSITY, (obsolete) voluptuousness [n]\n",
  "VOLUPTUOSITY": "(obsolete) voluptuousness [n VOLUPTUOSITIES]\n",
  "VOLUPTUOUS": "given up to luxury; sensuous [adj VOLUPTUOUSLY]\n",
  "VOLUPTUOUSLY": "VOLUPTUOUS, given up to luxury; sensuous [adv]\n",
  "VOLUPTUOUSNESS": "the state of being voluptuous [n]\n",
  "VOLUSPA": "(Old Norse) a sibyl or prophetess [n -S]\n",
  "VOLUSPAS": "VOLUSPA, (Old Norse) a sibyl or prophetess [n]\n",
  "VOLUTATION": "the action of rolling [n -S]\n",
  "VOLUTATIONS": "VOLUTATION, the action of rolling [n]\n",
  "VOLUTE": "any marine shell of the genus Voluta or related genera, allied to the whelks [n -S]\n",
  "VOLUTED": "having a volute [adj]\n",
  "VOLUTES": "VOLUTE, any marine shell of the genus Voluta or related genera, allied to the whelks [n]\n",
  "VOLUTIN": "a substance found in granular form in the cytoplasm of various cells [n -S]\n",
  "VOLUTINS": "VOLUTIN, a substance found in granular form in the cytoplasm of various cells [n]\n",
  "VOLUTION": "a revolving movement [n -S]\n",
  "VOLUTIONS": "VOLUTION, a revolving movement [n]\n",
  "VOLUTOID": "like a volute [adj]\n",
  "VOLVA": "(Latin) a sac that encloses certain immature mushrooms [n VOLVAS or VOLVAE]\n",
  "VOLVAE": "VOLVA, (Latin) a sac that encloses certain immature mushrooms [n]\n",
  "VOLVAS": "VOLVA, (Latin) a sac that encloses certain immature mushrooms [n]\n",
  "VOLVATE": "having a volva, a saclike envelope of certain fungi, which bursts open as the plant develops [adj]\n",
  "VOLVE": "(obsolete) to turn over and over; to ponder [v VOLVED, VOLVING, VOLVES]\n",
  "VOLVED": "VOLVE, (obsolete) to turn over and over; to ponder [v]\n",
  "VOLVES": "VOLVE, (obsolete) to turn over and over; to ponder [v]\n",
  "VOLVING": "VOLVE, (obsolete) to turn over and over; to ponder [v]\n",
  "VOLVOX": "(Latin) any of a genus of freshwater protozoa [n -ES]\n",
  "VOLVOXES": "VOLVOX, (Latin) any of a genus of freshwater protozoa [n]\n",
  "VOLVULI": "VOLVULUS, (Latin) a twisting of the intestine that causes obstruction [n]\n",
  "VOLVULUS": "(Latin) a twisting of the intestine that causes obstruction [n VOLVULUSES or VOLVULI]\n",
  "VOLVULUSES": "VOLVULUS, (Latin) a twisting of the intestine that causes obstruction [n]\n",
  "VOM": "(short for) to vomit [v VOMMED, VOMMING, VOMS]\n",
  "VOMER": "(Latin) any of various bones resembling a ploughshare in shape [n -S]\n",
  "VOMERINE": "of or pertaining to the vomer, a bone, or one of a pair of bones, beneath the ethmoid region of the skull [adj]\n",
  "VOMERONASAL": "relating to the vomer and the nasal cavity [adj]\n",
  "VOMERS": "VOMER, (Latin) any of various bones resembling a ploughshare in shape [n]\n",
  "VOMICA": "(Latin) a cavity in the body containing pus [n VOMICAS or VOMICAE]\n",
  "VOMICAE": "VOMICA, (Latin) a cavity in the body containing pus [n]\n",
  "VOMICAS": "VOMICA, (Latin) a cavity in the body containing pus [n]\n",
  "VOMIT": "to eject the contents of the stomach through the mouth [v -ED, -ING, -S]\n",
  "VOMITED": "VOMIT, to eject the contents of the stomach through the mouth [v]\n",
  "VOMITER": "one who vomits [n -S]\n",
  "VOMITERS": "VOMITER, one who vomits [n]\n",
  "VOMITIER": "VOMITY, resembling or smelling of vomit [adj]\n",
  "VOMITIEST": "VOMITY, resembling or smelling of vomit [adj]\n",
  "VOMITING": "the act of vomiting [n -S]\n",
  "VOMITINGS": "VOMITING, the act of vomiting [n]\n",
  "VOMITIVE": "a substance causing the ejection of matter from the stomach; an emetic [n -S]\n",
  "VOMITIVES": "VOMITIVE, a substance causing the ejection of matter from the stomach; an emetic [n]\n",
  "VOMITO": "(Spanish) a form of yellow fever [n -S]\n",
  "VOMITORIA": "VOMITORIUM, (Latin) an opening in a large building by which a crowd is let out, also VOMITORY [n]\n",
  "VOMITORIES": "VOMITORY, an opening in a large building by which a crowd is let out, also VOMITORIUM [n]\n",
  "VOMITORIUM": "(Latin) an opening in a large building by which a crowd is let out, also VOMITORY [n VOMITORIA]\n",
  "VOMITORY": "an opening in a large building by which a crowd is let out, also VOMITORIUM [n VOMITORIES]\n",
  "VOMITOS": "VOMITO, (Spanish) a form of yellow fever [n]\n",
  "VOMITOUS": "pertaining to vomiting [adj]\n",
  "VOMITS": "VOMIT, to eject the contents of the stomach through the mouth [v]\n",
  "VOMITURITION": "violent retching [n -S]\n",
  "VOMITURITIONS": "VOMITURITION, violent retching [n]\n",
  "VOMITUS": "(Latin) matter vomited [n -ES]\n",
  "VOMITUSES": "VOMITUS, (Latin) matter vomited [n]\n",
  "VOMITY": "resembling or smelling of vomit [adj VOMITIER, VOMITIEST]\n",
  "VOMMED": "VOM, (short for) to vomit [v]\n",
  "VOMMING": "VOM, (short for) to vomit [v]\n",
  "VOMS": "VOM, (short for) to vomit [v]\n",
  "VONGOLE": "(Italian) in Italian cooking, small clams [n]\n",
  "VOODOO": "West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOUDON, VOUDOU, VOUDOUN [n -S] / to bewitch by voodoo, also VOUDOU [v -ED, -ING, -S]\n",
  "VOODOOED": "VOODOO, to bewitch by voodoo, also VOUDOU [v]\n",
  "VOODOOING": "VOODOO, to bewitch by voodoo, also VOUDOU [v]\n",
  "VOODOOISM": "the belief in or practice of voodoo [n -S]\n",
  "VOODOOISMS": "VOODOOISM, the belief in or practice of voodoo [n]\n",
  "VOODOOIST": "a practitioner of voodoo [n -S]\n",
  "VOODOOISTIC": "relating to voodoo [adj]\n",
  "VOODOOISTS": "VOODOOIST, a practitioner of voodoo [n]\n",
  "VOODOOS": "VOODOO, West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOUDON, VOUDOU, VOUDOUN [n]\n",
  "VOORKAMER": "(South African) a front room, esp. of a farmhouse [n -S]\n",
  "VOORKAMERS": "VOORKAMER, (South African) a front room, esp. of a farmhouse [n]\n",
  "VOORSKOT": "(South African) advance payment made to a farmer for crops [n -S]\n",
  "VOORSKOTS": "VOORSKOT, (South African) advance payment made to a farmer for crops [n]\n",
  "VOORTREKKER": "(South African) one of the Dutch farmers from Cape Colony who took part in the Great Trek into the Transvaal in 1836 [n -S]\n",
  "VOORTREKKERS": "VOORTREKKER, (South African) one of the Dutch farmers from Cape Colony who took part in the Great Trek into the Transvaal in 1836 [n]\n",
  "VOR": "(Shakespeare) to warn [v VORRED, VORRING, VORS]\n",
  "VORACIOUS": "greedy [adj VORACIOUSLY]\n",
  "VORACIOUSLY": "VORACIOUS, greedy [adv]\n",
  "VORACIOUSNESS": "the state of being voracious [n -ES]\n",
  "VORACIOUSNESSES": "VORACIOUSNESS, the state of being voracious [n]\n",
  "VORACITIES": "VORACITY, greed [n]\n",
  "VORACITY": "greed [n VORACITIES]\n",
  "VORAGINOUS": "relating to a vorago or whirlpool [adj]\n",
  "VORAGO": "(Latin) a gulf [n -ES or -S]\n",
  "VORAGOES": "VORAGO, (Latin) a gulf [n]\n",
  "VORAGOS": "VORAGO, (Latin) a gulf [n]\n",
  "VORANT": "devouring [adj]\n",
  "VORLAGE": "(German) the position of a skier leaning forward from the ankles, usually without lifting the heels from the skis [n -S]\n",
  "VORLAGES": "VORLAGE, (German) the position of a skier leaning forward from the ankles, usually without lifting the heels from the skis [n]\n",
  "VORPAL": "a nonsense word coined by Lewis Carroll to describe a sword [adj]\n",
  "VORRED": "VOR, (Shakespeare) to warn [v]\n",
  "VORRING": "VOR, (Shakespeare) to warn [v]\n",
  "VORS": "VOR, (Shakespeare) to warn [v]\n",
  "VORTEX": "(Latin) a whirling mass of fluid [n VORTEXES or VORTICES]\n",
  "VORTEXES": "VORTEX, (Latin) a whirling mass of fluid [n]\n",
  "VORTICAL": "like a vortex, whirling, also VORTICOSE, VORTICULAR, VORTIGINOUS [adj VORTICALLY]\n",
  "VORTICALLY": "VORTICAL, like a vortex, whirling, also VORTICOSE, VORTICULAR, VORTIGINOUS [adv]\n",
  "VORTICELLA": "a sessile protozoan of the genus Vorticella, which has a long contractile stalk and a ciliated body shaped like an inverted bell [n VORTICELLAE or VORTICELLAS]\n",
  "VORTICELLAE": "VORTICELLA, a sessile protozoan of the genus Vorticella, which has a long contractile stalk and a ciliated body shaped like an inverted bell [n]\n",
  "VORTICELLAS": "VORTICELLA, a sessile protozoan of the genus Vorticella, which has a long contractile stalk and a ciliated body shaped like an inverted bell [n]\n",
  "VORTICES": "VORTEX, (Latin) a whirling mass of fluid [n]\n",
  "VORTICISM": "a British movement in the arts, deriving from futurism [n -S]\n",
  "VORTICISMS": "VORTICISM, a British movement in the arts, deriving from futurism [n]\n",
  "VORTICIST": "a painter who expresses complexity of machinery through art [n -S]\n",
  "VORTICISTS": "VORTICIST, a painter who expresses complexity of machinery through art [n]\n",
  "VORTICITIES": "VORTICITY, the amount of vortical motion in a fluid [n]\n",
  "VORTICITY": "the amount of vortical motion in a fluid [n VORTICITIES]\n",
  "VORTICOSE": "like a vortex, whirling, also VORTICAL, VORTICULAR, VORTIGINOUS [adj]\n",
  "VORTICULAR": "like a vortex, whirling, also VORTICAL, VORTICOSE, VORTIGINOUS [adj]\n",
  "VORTIGINOUS": "like a vortex, whirling, also VORTICAL, VORTICOSE, VORTICULAR [adj]\n",
  "VOSTRO": "as in vostro account, a bank account held by a foreign bank with a British bank [adj]\n",
  "VOTABLE": "capable of being voted on, also VOTEABLE [adj]\n",
  "VOTARESS": "a female votary, also VOTRESS [n -ES]\n",
  "VOTARESSES": "VOTARESS, a female votary, also VOTRESS [n]\n",
  "VOTARIES": "VOTARY, a person who is bound by religious vows, also VOTARIST [n]\n",
  "VOTARIST": "a person who is bound by religious vows, also VOTARY [n -S]\n",
  "VOTARISTS": "VOTARIST, a person who is bound by religious vows, also VOTARY [n]\n",
  "VOTARY": "a person who is bound by religious vows, also VOTARIST [n VOTARIES]\n",
  "VOTE": "to express an opinion [v VOTED, VOTING, VOTES]\n",
  "VOTEABLE": "capable of being voted on, also VOTABLE [adj]\n",
  "VOTED": "VOTE, to express an opinion [v]\n",
  "VOTEEN": "(Irish) a devotee [n -S]\n",
  "VOTEENS": "VOTEEN, (Irish) a devotee [n]\n",
  "VOTELESS": "without a vote [adj]\n",
  "VOTER": "one who votes [n -S]\n",
  "VOTERS": "VOTER, one who votes [n]\n",
  "VOTES": "VOTE, to express an opinion [v]\n",
  "VOTING": "casting a vote [n -S]\n",
  "VOTINGS": "VOTING, casting a vote [n]\n",
  "VOTIVE": "performed in fulfilment of a vow [adj VOTIVELY] / a votive offering [n -S]\n",
  "VOTIVELY": "VOTIVE, performed in fulfilment of a vow [adv]\n",
  "VOTIVENESS": "the state of being votive [n -ES]\n",
  "VOTIVENESSES": "VOTIVENESS, the state of being votive [n]\n",
  "VOTIVES": "VOTIVE, a votive offering [n]\n",
  "VOTRESS": "a female votary, also VOTARESS [n -ES]\n",
  "VOTRESSES": "VOTRESS, a female votary, also VOTARESS [n]\n",
  "VOUCH": "to give one's personal guarantee [v -ED, -ING, -ES]\n",
  "VOUCHED": "VOUCH, to give one's personal guarantee [v]\n",
  "VOUCHEE": "one for whom another vouches [n -S]\n",
  "VOUCHEES": "VOUCHEE, one for whom another vouches [n]\n",
  "VOUCHER": "to establish the authenticity of [v -ED, -ING, -S]\n",
  "VOUCHERED": "VOUCHER, to establish the authenticity of [v]\n",
  "VOUCHERING": "VOUCHER, to establish the authenticity of [v]\n",
  "VOUCHERS": "VOUCHER, to establish the authenticity of [v]\n",
  "VOUCHES": "VOUCH, to give one's personal guarantee [v]\n",
  "VOUCHING": "VOUCH, to give one's personal guarantee [v]\n",
  "VOUCHSAFE": "to grant as a privilege or special favor, also VOUTSAFE [v VOUCHSAFED, VOUCHSAFING, VOUCHSAFES]\n",
  "VOUCHSAFED": "VOUCHSAFE, to grant as a privilege or special favor, also VOUTSAFE [v]\n",
  "VOUCHSAFEMENT": "the act of vouchsafing [n -S]\n",
  "VOUCHSAFEMENTS": "VOUCHSAFEMENT, the act of vouchsafing [n]\n",
  "VOUCHSAFES": "VOUCHSAFE, to grant as a privilege or special favor, also VOUTSAFE [v]\n",
  "VOUCHSAFING": "the act of granting as a privilege or special favour [n -S]\n",
  "VOUCHSAFINGS": "VOUCHSAFING, the act of granting as a privilege or special favour [n]\n",
  "VOUDON": "West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDOU, VOUDOUN [n -S]\n",
  "VOUDONS": "VOUDON, West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDOU, VOUDOUN [n]\n",
  "VOUDOU": "West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDON, VOUDOUN [n -S] / to bewitch by voodou, also VOODOO [v -ED, -ING, -S]\n",
  "VOUDOUED": "VOUDOU, to bewitch by voodou, also VOODOO [v]\n",
  "VOUDOUING": "VOUDOU, to bewitch by voodou, also VOODOO [v]\n",
  "VOUDOUN": "West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU [n -S]\n",
  "VOUDOUNS": "VOUDOUN, West Indian black magic, also VAUDOO, VAUDOUX, VODOU, VODOUN, VODUN, VOODOO, VOUDON, VOUDOU [n]\n",
  "VOUDOUS": "VOUDOU, to bewitch by voodou, also VOODOO [v]\n",
  "VOUGE": "a weapon carried by foot-soldiers in the 14th century, consisting of a blade on a staff, also VOULGE [n -S]\n",
  "VOUGES": "VOUGE, a weapon carried by foot-soldiers in the 14th century, consisting of a blade on a staff, also VOULGE [n]\n",
  "VOULGE": "a weapon carried by foot-soldiers in the 14th century, consisting of a blade on a staff, also VOUGE [n -S]\n",
  "VOULGES": "VOULGE, a weapon carried by foot-soldiers in the 14th century, consisting of a blade on a staff, also VOUGE [n]\n",
  "VOULU": "(French) willed, deliberate, contrived [adj]\n",
  "VOUSSOIR": "(French) one of the wedge-shaped pieces forming an arch or vault [n -S] / to construct with a voussoir [v -ED, -ING, -S]\n",
  "VOUSSOIRED": "VOUSSOIR, to construct with a voussoir [v]\n",
  "VOUSSOIRING": "VOUSSOIR, to construct with a voussoir [v]\n",
  "VOUSSOIRS": "VOUSSOIR, (French) one of the wedge-shaped pieces forming an arch or vault [n]\n",
  "VOUTSAFE": "(Milton) to vouchsafe [v VOUTSAFED, VOUTSAFING, VOUTSAFES]\n",
  "VOUTSAFED": "VOUTSAFE, (Milton) to vouchsafe [v]\n",
  "VOUTSAFES": "VOUTSAFE, (Milton) to vouchsafe [v]\n",
  "VOUTSAFING": "VOUTSAFE, (Milton) to vouchsafe [v]\n",
  "VOUVRAY": "(French) a French white wine [n -S]\n",
  "VOUVRAYS": "VOUVRAY, (French) a French white wine [n]\n",
  "VOW": "to make a solemn promise [v -ED, -ING, -S]\n",
  "VOWED": "VOW, to make a solemn promise [v]\n",
  "VOWEL": "a speech-sound produced by the unimpeded passage of the breath [n -S] / to use as a speech sound [v VOWELLED, VOWELLING, VOWELS]\n",
  "VOWELED": "having vowels [adj]\n",
  "VOWELISATION": "the process of vowelising, also VOWELIZATION [n -S]\n",
  "VOWELISATIONS": "VOWELISATION, the process of vowelising, also VOWELIZATION [n]\n",
  "VOWELISE": "to use as a vowel, also VOWELIZE [v VOWELISED, VOWELISING, VOWELISES]\n",
  "VOWELISED": "VOWELISE, to use as a vowel, also VOWELIZE [v]\n",
  "VOWELISES": "VOWELISE, to use as a vowel, also VOWELIZE [v]\n",
  "VOWELISING": "VOWELISE, to use as a vowel, also VOWELIZE [v]\n",
  "VOWELIZATION": "the process of vowelizing, also VOWELISATION [n -S]\n",
  "VOWELIZATIONS": "VOWELIZATION, the process of vowelizing, also VOWELISATION [n]\n",
  "VOWELIZE": "to use as a vowel, also VOWELISE [v VOWELIZED, VOWELIZING, VOWELIZES]\n",
  "VOWELIZED": "VOWELIZE, to use as a vowel, also VOWELISE [v]\n",
  "VOWELIZES": "VOWELIZE, to use as a vowel, also VOWELISE [v]\n",
  "VOWELIZING": "VOWELIZE, to use as a vowel, also VOWELISE [v]\n",
  "VOWELLED": "VOWEL, to use as a speech sound [v]\n",
  "VOWELLESS": "without vowels [adj]\n",
  "VOWELLIER": "VOWELLY, full of vowels [adj]\n",
  "VOWELLIEST": "VOWELLY, full of vowels [adj]\n",
  "VOWELLING": "VOWEL, to use as a speech sound [v]\n",
  "VOWELLY": "full of vowels [adj VOWELLIER, VOWELLIEST]\n",
  "VOWELS": "VOWEL, to use as a speech sound [v]\n",
  "VOWER": "one who makes a vow [n -S]\n",
  "VOWERS": "VOWER, one who makes a vow [n]\n",
  "VOWESS": "(historical) a woman who has taken a vow; a nun [n -ES]\n",
  "VOWESSES": "VOWESS, (historical) a woman who has taken a vow; a nun [n]\n",
  "VOWING": "VOW, to make a solemn promise [v]\n",
  "VOWLESS": "having made no vow [adj]\n",
  "VOWS": "VOW, to make a solemn promise [v]\n",
  "VOX": "(Latin) a voice [n VOCES]\n",
  "VOXEL": "a three dimensional equivalent to a pixel (a point in a computer image) [n -S]\n",
  "VOXELS": "VOXEL, a three dimensional equivalent to a pixel (a point in a computer image) [n]\n",
  "VOYAGE": "to travel [v VOYAGED, VOYAGING, VOYAGES]\n",
  "VOYAGEABLE": "that may be sailed over, as water or air [adj]\n",
  "VOYAGED": "VOYAGE, to travel [v]\n",
  "VOYAGER": "one who voyages [n -S]\n",
  "VOYAGERS": "VOYAGER, one who voyages [n]\n",
  "VOYAGES": "VOYAGE, to travel [v]\n",
  "VOYAGEUR": "(Canadian) an employee of a fur company who transports goods [n -S]\n",
  "VOYAGEURS": "VOYAGEUR, (Canadian) an employee of a fur company who transports goods [n]\n",
  "VOYAGING": "the act of making a voyage [n -S]\n",
  "VOYAGINGS": "VOYAGING, the act of making a voyage [n]\n",
  "VOYEUR": "(French) one who seeks sexual gratification by viewing sexual objects [n -S]\n",
  "VOYEURISM": "the derivation of gratification from surreptitiously watching sexual acts or objects [n -S]\n",
  "VOYEURISMS": "VOYEURISM, the derivation of gratification from surreptitiously watching sexual acts or objects [n]\n",
  "VOYEURISTIC": "like a voyeur [adj VOYEURISTICALLY]\n",
  "VOYEURISTICALLY": "VOYEURISTIC, like a voyeur [adv]\n",
  "VOYEURS": "VOYEUR, (French) one who seeks sexual gratification by viewing sexual objects [n]\n",
  "VOZHD": "(Russian) a supreme leader in Russia [n -S]\n",
  "VOZHDS": "VOZHD, (Russian) a supreme leader in Russia [n]\n",
  "VRAIC": "a kind of seaweed, aka kelp, also VAREC, VARECH [n -S]\n",
  "VRAICKER": "a gatherer of vraic, a kind of seaweed in Channel Isles [n -S]\n",
  "VRAICKERS": "VRAICKER, a gatherer of vraic, a kind of seaweed in Channel Isles [n]\n",
  "VRAICKING": "the gathering of vraic [n -S]\n",
  "VRAICKINGS": "VRAICKING, the gathering of vraic [n]\n",
  "VRAICS": "VRAIC, a kind of seaweed, aka kelp, also VAREC, VARECH [n]\n",
  "VRAISEMBLANCE": "verisimilitude [n -S]\n",
  "VRAISEMBLANCES": "VRAISEMBLANCE, verisimilitude [n]\n",
  "VRIL": "electric fluid represented as the common origin of the forces in matter [n -S]\n",
  "VRILS": "VRIL, electric fluid represented as the common origin of the forces in matter [n]\n",
  "VROOM": "to run an engine at high speed, also VAROOM [v -ED, -ING, -S]\n",
  "VROOMED": "VROOM, to run an engine at high speed, also VAROOM [v]\n",
  "VROOMING": "VROOM, to run an engine at high speed, also VAROOM [v]\n",
  "VROOMS": "VROOM, to run an engine at high speed, also VAROOM [v]\n",
  "VROT": "(South African) rotten [adj]\n",
  "VROU": "(South African) a woman, esp. a married woman, also FROW, VROUW, VROW [n -S]\n",
  "VROUS": "VROU, (South African) a woman, esp. a married woman, also FROW, VROUW, VROW [n]\n",
  "VROUW": "(Dutch) a woman, goodwife, also FROW, VROU, VROW [n -S]\n",
  "VROUWS": "VROUW, (Dutch) a woman, goodwife, also FROW, VROU, VROW [n]\n",
  "VROW": "(Dutch) a woman, goodwife, also FROW, VROU, VROUW [n -S]\n",
  "VROWS": "VROW, (Dutch) a woman, goodwife, also FROW, VROU, VROUW [n]\n",
  "VRYSTATER": "(South African) a native inhabitant of the Free State, esp. one who is White [n -S]\n",
  "VRYSTATERS": "VRYSTATER, (South African) a native inhabitant of the Free State, esp. one who is White [n]\n",
  "VUG": "a small cavity in a rock, also VUGG, VUGH [n -S]\n",
  "VUGG": "a small cavity in a rock, also VUG, VUGH [n -S]\n",
  "VUGGIER": "VUGGY, abounding in vugs, also VUGHY [adj]\n",
  "VUGGIEST": "VUGGY, abounding in vugs, also VUGHY [adj]\n",
  "VUGGS": "VUGG, a small cavity in a rock, also VUG, VUGH [n]\n",
  "VUGGY": "abounding in vugs, also VUGHY [adj VUGGIER, VUGGIEST]\n",
  "VUGH": "a small cavity in a rock, also VUG, VUGG [n -S]\n",
  "VUGHIER": "VUGHY, abounding in vugs, also VUGGY [adj]\n",
  "VUGHIEST": "VUGHY, abounding in vugs, also VUGGY [adj]\n",
  "VUGHS": "VUGH, a small cavity in a rock, also VUG, VUGG [n]\n",
  "VUGHY": "abounding in vugs, also VUGGY [adj VUGHIER, VUGHIEST]\n",
  "VUGS": "VUG, a small cavity in a rock, also VUGG, VUGH [n]\n",
  "VUGULAR": "pertaining to vugs [adj]\n",
  "VULCAN": "(Latin) a blacksmith or ironworker [n -S]\n",
  "VULCANIAN": "relating to a volcanic eruption, esp. one that discharges gases and ash but little or no lava, also VOLCANIAN [adj]\n",
  "VULCANIC": "of or like a volcano, also VOLCANIC [adj]\n",
  "VULCANICITIES": "VULCANICITY, the state of being vulcanic, also VOLCANICITY [n]\n",
  "VULCANICITY": "the state of being vulcanic, also VOLCANICITY [n VULCANICITIES]\n",
  "VULCANISABLE": "that can be vulcanised, also VULCANIZABLE [adj]\n",
  "VULCANISATE": "a vulcanized product, also VULCANIZATE [n -S]\n",
  "VULCANISATES": "VULCANISATE, a vulcanized product, also VULCANIZATE [n]\n",
  "VULCANISATION": "the process of treating crude or synthetic rubber or similar plastic material chemically to give it useful properties (as elasticity, strength, and stability), also VULCANIZATION [n -S]\n",
  "VULCANISATIONS": "VULCANISATION, the process of treating crude or synthetic rubber or similar plastic material chemically to give it useful properties (as elasticity, strength, and stability), also VULCANIZATION [n]\n",
  "VULCANISE": "to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANIZE [v VULCANISED, VULCANISING, VULCANISES]\n",
  "VULCANISED": "VULCANISE, to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANIZE [v]\n",
  "VULCANISER": "an apparatus for vulcanizing caoutchouc, also VULCANIZER [n -S]\n",
  "VULCANISERS": "VULCANISER, an apparatus for vulcanizing caoutchouc, also VULCANIZER [n]\n",
  "VULCANISES": "VULCANISE, to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANIZE [v]\n",
  "VULCANISING": "VULCANISE, to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANIZE [v]\n",
  "VULCANISM": "volcanic power or action, also VOLCANISM [n -S]\n",
  "VULCANISMS": "VULCANISM, volcanic power or action, also VOLCANISM [n]\n",
  "VULCANIST": "one versed in the history and phenomena of volcanoes, also VOLCANIST [n -S]\n",
  "VULCANISTS": "VULCANIST, one versed in the history and phenomena of volcanoes, also VOLCANIST [n]\n",
  "VULCANITE": "hard rubber produced by vulcanizing with a large proportion of sulphur [n -S]\n",
  "VULCANITES": "VULCANITE, hard rubber produced by vulcanizing with a large proportion of sulphur [n]\n",
  "VULCANIZABLE": "that can be vulcanized, also VULCANISABLE [adj]\n",
  "VULCANIZATE": "a vulcanized product, also VULCANISATE [n -S]\n",
  "VULCANIZATES": "VULCANIZATE, a vulcanized product, also VULCANISATE [n]\n",
  "VULCANIZATION": "the process of treating crude or synthetic rubber or similar plastic material chemically to give it useful properties (as elasticity, strength, and stability), also VULCANISATION [n -S]\n",
  "VULCANIZATIONS": "VULCANIZATION, the process of treating crude or synthetic rubber or similar plastic material chemically to give it useful properties (as elasticity, strength, and stability), also VULCANISATION [n]\n",
  "VULCANIZE": "to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANISE [v VULCANIZED, VULCANIZING, VULCANIZES]\n",
  "VULCANIZED": "VULCANIZE, to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANISE [v]\n",
  "VULCANIZER": "an apparatus for vulcanizing caoutchouc, also VULCANISER [n -S]\n",
  "VULCANIZERS": "VULCANIZER, an apparatus for vulcanizing caoutchouc, also VULCANISER [n]\n",
  "VULCANIZES": "VULCANIZE, to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANISE [v]\n",
  "VULCANIZING": "VULCANIZE, to change the properties of, as caoutchouc, or India rubber, by the process of vulcanization, also VULCANISE [v]\n",
  "VULCANOLOGIC": "relating to vulcanology, also VOLCANOLOGIC, VOLCANOLOGICAL, VULCANOLOGICAL [adj]\n",
  "VULCANOLOGICAL": "relating to vulcanology, also VOLCANOLOGIC, VOLCANOLOGICAL, VULCANOLOGIC [adj]\n",
  "VULCANOLOGIES": "VULCANOLOGY, the study of volcanoes, also VOLCANOLOGY [n]\n",
  "VULCANOLOGIST": "one who studies vulcanology, also VOLCANOLOGIST [n -S]\n",
  "VULCANOLOGISTS": "VULCANOLOGIST, one who studies vulcanology, also VOLCANOLOGIST [n]\n",
  "VULCANOLOGY": "the study of volcanoes, also VOLCANOLOGY [n VULCANOLOGIES]\n",
  "VULCANS": "VULCAN, (Latin) a blacksmith or ironworker [n]\n",
  "VULGAR": "common [adj VULGARER, VULGAREST, VULGARLY] / the common people; one of the unrefined [n -S]\n",
  "VULGARER": "VULGAR, common [adj]\n",
  "VULGAREST": "VULGAR, common [adj]\n",
  "VULGARIAN": "a vulgar person; one who has vulgar ideas [n -S]\n",
  "VULGARIANS": "VULGARIAN, a vulgar person; one who has vulgar ideas [n]\n",
  "VULGARISATION": "the act of vulgarising, also VULGARIZATION [n -S]\n",
  "VULGARISATIONS": "VULGARISATION, the act of vulgarising, also VULGARIZATION [n]\n",
  "VULGARISE": "to make vulgar, or common, also VULGARIZE [v VULGARISED, VULGARISING, VULGARISES]\n",
  "VULGARISED": "VULGARISE, to make vulgar, or common, also VULGARIZE [v]\n",
  "VULGARISER": "one who vulgarises, also VULGARIZER [n -S]\n",
  "VULGARISERS": "VULGARISER, one who vulgarises, also VULGARIZER [n]\n",
  "VULGARISES": "VULGARISE, to make vulgar, or common, also VULGARIZE [v]\n",
  "VULGARISING": "VULGARISE, to make vulgar, or common, also VULGARIZE [v]\n",
  "VULGARISM": "a coarse, substandard or obscene expression [n -S]\n",
  "VULGARISMS": "VULGARISM, a coarse, substandard or obscene expression [n]\n",
  "VULGARITIES": "VULGARITY, the state of being vulgar [n]\n",
  "VULGARITY": "the state of being vulgar [n VULGARITIES]\n",
  "VULGARIZATION": "the act of vulgarizing, also VULGARISATION [n -S]\n",
  "VULGARIZATIONS": "VULGARIZATION, the act of vulgarizing, also VULGARISATION [n]\n",
  "VULGARIZE": "to make vulgar, or common, also VULGARISE [v VULGARIZED, VULGARIZING, VULGARIZES]\n",
  "VULGARIZED": "VULGARIZE, to make vulgar, or common, also VULGARISE [v]\n",
  "VULGARIZER": "one who vulgarizes, also VULGARISER [n -S]\n",
  "VULGARIZERS": "VULGARIZER, one who vulgarizes, also VULGARISER [n]\n",
  "VULGARIZES": "VULGARIZE, to make vulgar, or common, also VULGARISE [v]\n",
  "VULGARIZING": "VULGARIZE, to make vulgar, or common, also VULGARISE [v]\n",
  "VULGARLY": "VULGAR, common [adv]\n",
  "VULGARS": "VULGAR, the common people; one of the unrefined [n]\n",
  "VULGATE": "the common speech of a people [n -S]\n",
  "VULGATES": "VULGATE, the common speech of a people [n]\n",
  "VULGO": "(Latin) commonly, popularly [adv]\n",
  "VULGUS": "(Latin) the common people; a schoolboy Latin composition [n -ES]\n",
  "VULGUSES": "VULGUS, (Latin) the common people; a schoolboy Latin composition [n]\n",
  "VULN": "to wound; pierce with a weapon [v -ED, -ING, -S]\n",
  "VULNED": "VULN, to wound; pierce with a weapon [v]\n",
  "VULNERABILITIES": "VULNERABILITY, the state of being vulnerable [n]\n",
  "VULNERABILITY": "the state of being vulnerable [n VULNERABILITIES]\n",
  "VULNERABLE": "that can be hurt [adj VULNERABLY]\n",
  "VULNERABLENESS": "the state of being vulnerable [n]\n",
  "VULNERABLY": "VULNERABLE, that can be hurt [adv]\n",
  "VULNERARIES": "VULNERARY, a vulnerary preparation, plant, or drug [n]\n",
  "VULNERARY": "useful in healing wounds [adj] / a vulnerary preparation, plant, or drug [n VULNERARIES]\n",
  "VULNERATE": "(obsolete) to wound [v VULNERATED, VULNERATING, VULNERATES]\n",
  "VULNERATED": "VULNERATE, (obsolete) to wound [v]\n",
  "VULNERATES": "VULNERATE, (obsolete) to wound [v]\n",
  "VULNERATING": "VULNERATE, (obsolete) to wound [v]\n",
  "VULNERATION": "(obsolete) a wound [n -S]\n",
  "VULNERATIONS": "VULNERATION, (obsolete) a wound [n]\n",
  "VULNING": "VULN, to wound; pierce with a weapon [v]\n",
  "VULNS": "VULN, to wound; pierce with a weapon [v]\n",
  "VULPECULAR": "resembling or characteristic of a fox [adj]\n",
  "VULPICIDE": "the killing of a fox [n -S]\n",
  "VULPICIDES": "VULPICIDE, the killing of a fox [n]\n",
  "VULPINE": "pertaining to a fox [adj]\n",
  "VULPINISM": "foxlike cunning [n -S]\n",
  "VULPINISMS": "VULPINISM, foxlike cunning [n]\n",
  "VULPINITE": "a granular scaly form of the mineral anhydrite [n -S]\n",
  "VULPINITES": "VULPINITE, a granular scaly form of the mineral anhydrite [n]\n",
  "VULSELLA": "(Latin) forceps with clawed blade [n VULSELLAE]\n",
  "VULSELLAE": "VULSELLA, (Latin) forceps with clawed blade [n]\n",
  "VULSELLUM": "(Latin) a forceps with toothed or clawed blades, also VULSELLA [n VULSELLA]\n",
  "VULTURE": "a bird of prey [n -S]\n",
  "VULTURES": "VULTURE, a bird of prey [n]\n",
  "VULTURINE": "like a vulture; rapacious, also VULTURISH, VULTUROUS [adj]\n",
  "VULTURISH": "like a vulture; rapacious, also VULTURINE, VULTUROUS [adj]\n",
  "VULTURISM": "(Carlyle) the state of being like a vulture; rapacity [n -S]\n",
  "VULTURISMS": "VULTURISM, (Carlyle) the state of being like a vulture; rapacity [n]\n",
  "VULTURN": "(obsolete) the Australian brush turkey [n -S]\n",
  "VULTURNS": "VULTURN, (obsolete) the Australian brush turkey [n]\n",
  "VULTUROUS": "like a vulture; rapacious, also VULTURINE, VULTURISH [adj]\n",
  "VULVA": "(Latin) the external genital organs of a female [n VULVAS or VULVAE]\n",
  "VULVAE": "VULVA, (Latin) the external genital organs of a female [n]\n",
  "VULVAL": "relating to the vulva, also VULVAR [adj]\n",
  "VULVAR": "relating to the vulva, also VULVAL [adj]\n",
  "VULVAS": "VULVA, (Latin) the external genital organs of a female [n]\n",
  "VULVATE": "shaped like a vulva, the external genital of a female animal [adj]\n",
  "VULVIFORM": "shaped like a vulva, the external genital of a female animal [adj]\n",
  "VULVITIS": "inflammation of the vulva [n -ES]\n",
  "VULVITISES": "VULVITIS, inflammation of the vulva [n]\n",
  "VULVOVAGINAL": "relating to the area of the vulva and vagina [adj]\n",
  "VULVOVAGINITIS": "coincident inflammation of the vulva and vagina [n]\n",
  "VUM": "to vow [v VUMMED, VUMMING, VUMS]\n",
  "VUMMED": "VUM, to vow [v]\n",
  "VUMMING": "VUM, to vow [v]\n",
  "VUMS": "VUM, to vow [v]\n",
  "VUTTIER": "VUTTY, (dialect) dirty [adj]\n",
  "VUTTIEST": "VUTTY, (dialect) dirty [adj]\n",
  "VUTTY": "(dialect) dirty [adj VUTTIER, VUTTIEST]\n",
  "VUVUZELA": "(Zulu) a plastic trumpet blown by football fans [n -S]\n",
  "VUVUZELAS": "VUVUZELA, (Zulu) a plastic trumpet blown by football fans [n]\n",
  "VYING": "contending [adj VYINGLY] / the act of vying [n -S]\n",
  "VYINGLY": "VYING, contending [adv]\n",
  "VYINGS": "VYING, the act of vying [n]\n",
  "WAAC": "a member of the Women's Auxiliary Army Corps [n -S]\n",
  "WAACS": "WAAC, a member of the Women's Auxiliary Army Corps [n]\n",
  "WAAH": "an interjection used to express wailing [interj]\n",
  "WAB": "the interdigital skin web on certain animals, also WEB [n -S]\n",
  "WABAIN": "(Somali) a poisonous alkaloid, also OUABAIN [n -S]\n",
  "WABAINS": "WABAIN, (Somali) a poisonous alkaloid, also OUABAIN [n]\n",
  "WABBIT": "(Scots) exhausted, tired out [adj]\n",
  "WABBLE": "to wobble [v WABBLED, WABBLING, WABBLES]\n",
  "WABBLED": "WABBLE, to wobble [v]\n",
  "WABBLER": "(obsolete) one who wabbles, also WOBBLER [n -S]\n",
  "WABBLERS": "WABBLER, (obsolete) one who wabbles, also WOBBLER [n]\n",
  "WABBLES": "WABBLE, to wobble [v]\n",
  "WABBLIER": "WABBLY, wobbly [adj]\n",
  "WABBLIEST": "WABBLY, wobbly [adj]\n",
  "WABBLING": "WABBLE, to wobble [v]\n",
  "WABBLY": "wobbly [adj WABBLIER, WABBLIEST]\n",
  "WABOOM": "(South African) a South African tree with tough wood used for making wagon wheels, also WAGENBOOM [n -S]\n",
  "WABOOMS": "WABOOM, (South African) a South African tree with tough wood used for making wagon wheels, also WAGENBOOM [n]\n",
  "WABS": "WAB, the interdigital skin web on certain animals, also WEB [n]\n",
  "WABSTER": "(Scots) a weaver, also WEBSTER [n -S]\n",
  "WABSTERS": "WABSTER, (Scots) a weaver, also WEBSTER [n]\n",
  "WACK": "crazy, also WACKY [adj WACKER, WACKEST] / an eccentric, mad, or crazy person; a crackpot, also WACKO, WHACKO [n -S]\n",
  "WACKE": "(German) an old name for a decomposed basalt, also GRAYWACKE, GREYWACKE [n -S]\n",
  "WACKED": "(colloquial) intoxicated, exhausted [adj]\n",
  "WACKER": "(slang) mate, pal [n -S]\n",
  "WACKERS": "WACKER, (slang) mate, pal [n]\n",
  "WACKES": "WACKE, (German) an old name for a decomposed basalt, also GRAYWACKE, GREYWACKE [n]\n",
  "WACKEST": "WACK, crazy, also WACKY [adj]\n",
  "WACKIER": "WACKY, eccentric, also WHACKY [adj]\n",
  "WACKIEST": "WACKY, eccentric, also WHACKY [adj]\n",
  "WACKILY": "WACKY, eccentric, also WHACKY [adv]\n",
  "WACKINESS": "the state of being wacky [n -ES]\n",
  "WACKINESSES": "WACKINESS, the state of being wacky [n]\n",
  "WACKO": "a mad or eccentric person, also WACK, WHACKO [n -ES or -S]\n",
  "WACKOES": "WACKO, a mad or eccentric person, also WACK, WHACKO [n]\n",
  "WACKOS": "WACKO, a mad or eccentric person, also WACK, WHACKO [n]\n",
  "WACKS": "WACK, an eccentric, mad, or crazy person; a crackpot, also WACKO, WHACKO [n]\n",
  "WACKY": "eccentric, also WHACKY [adj WACKIER, WACKIEST, WACKILY]\n",
  "WACONDA": "(Native American) a supernatural force in Sioux belief, also WAHCONDA, WAKANDA [n -S]\n",
  "WACONDAS": "WACONDA, (Native American) a supernatural force in Sioux belief, also WAHCONDA, WAKANDA [n]\n",
  "WAD": "to form into a pad [v WADDED, WADDING, WADS]\n",
  "WADABLE": "capable of being passed through by wading, also WADEABLE [adj]\n",
  "WADD": "an earthy ore of manganese, also WADT [n -S]\n",
  "WADDED": "WAD, to form into a pad [v]\n",
  "WADDER": "an implement for wadding a gun [n -S]\n",
  "WADDERS": "WADDER, an implement for wadding a gun [n]\n",
  "WADDIE": "(Native Australian) a kind of war-club used by Australian aborigines, also WADDY [n -S]\n",
  "WADDIED": "WADDY, (Native Australian) to strike with a kind of war-club used by Australian aborigines [v]\n",
  "WADDIES": "WADDY, (Native Australian) to strike with a kind of war-club used by Australian aborigines [v]\n",
  "WADDING": "a mass of soft material [n -S]\n",
  "WADDINGS": "WADDING, a mass of soft material [n]\n",
  "WADDLE": "to walk with short, swaying steps [v WADDLED, WADDLING, WADDLES]\n",
  "WADDLED": "WADDLE, to walk with short, swaying steps [v]\n",
  "WADDLER": "one who waddles [n -S]\n",
  "WADDLERS": "WADDLER, one who waddles [n]\n",
  "WADDLES": "WADDLE, to walk with short, swaying steps [v]\n",
  "WADDLIER": "WADDLY, having a waddling gait [adj]\n",
  "WADDLIEST": "WADDLY, having a waddling gait [adj]\n",
  "WADDLING": "WADDLE, to walk with short, swaying steps [v]\n",
  "WADDLY": "having a waddling gait [adj WADDLIER, WADDLIEST]\n",
  "WADDS": "WADD, an earthy ore of manganese, also WADT [n]\n",
  "WADDY": "(Native Australian) to strike with a kind of war-club used by Australian aborigines [v WADDIED, WADDYING, WADDIES]\n",
  "WADDYING": "WADDY, (Native Australian) to strike with a kind of war-club used by Australian aborigines [v]\n",
  "WADE": "to walk through water [v WADED, WADING, WADES]\n",
  "WADEABLE": "capable of being passed through by wading, also WADABLE [adj]\n",
  "WADED": "WADE, to walk through water [v]\n",
  "WADER": "one that wades [n -S]\n",
  "WADERS": "WADER, one that wades [n]\n",
  "WADES": "WADE, to walk through water [v]\n",
  "WADGE": "a large or roughly-cut portion, also WODGE [n -S]\n",
  "WADGES": "WADGE, a large or roughly-cut portion, also WODGE [n]\n",
  "WADI": "(Arabic) the dry bed of a torrent; a river valley, also WADY [n -S]\n",
  "WADIES": "WADY, (Arabic) the dry bed of a torrent; a river valley, also WADI [n]\n",
  "WADING": "the act of wading [n -S]\n",
  "WADINGS": "WADING, the act of wading [n]\n",
  "WADIS": "WADI, (Arabic) the dry bed of a torrent; a river valley, also WADY [n]\n",
  "WADMAAL": "(Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMEL, WADMOL, WADMOLL [n -S]\n",
  "WADMAALS": "WADMAAL, (Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMEL, WADMOL, WADMOLL [n]\n",
  "WADMAL": "(Old Norse) a thick, coarse woollen cloth, also WADMAAL, WADMEL, WADMOL, WADMOLL [n -S]\n",
  "WADMALS": "WADMAL, (Old Norse) a thick, coarse woollen cloth, also WADMAAL, WADMEL, WADMOL, WADMOLL [n]\n",
  "WADMEL": "(Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMAAL, WADMOL, WADMOLL [n -S]\n",
  "WADMELS": "WADMEL, (Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMAAL, WADMOL, WADMOLL [n]\n",
  "WADMOL": "(Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMAAL, WADMEL, WADMOLL [n -S]\n",
  "WADMOLL": "(Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMAAL, WADMEL, WADMOL [n -S]\n",
  "WADMOLLS": "WADMOLL, (Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMAAL, WADMEL, WADMOL [n]\n",
  "WADMOLS": "WADMOL, (Old Norse) a thick, coarse woollen cloth, also WADMAL, WADMAAL, WADMEL, WADMOLL [n]\n",
  "WADS": "WAD, to form into a pad [v]\n",
  "WADSET": "(Scots) to pawn or mortgage, also WADSETT [v WADSETTED, WADSETTING, WADSETS]\n",
  "WADSETS": "WADSET, (Scots) to pawn or mortgage, also WADSETT [v]\n",
  "WADSETT": "(Scots) to pawn or mortgage, also WADSET [v -ED, -ING, -S]\n",
  "WADSETTED": "WADSETT, (Scots) to pawn or mortgage, also WADSET [v]\n",
  "WADSETTER": "(Scots) one who holds by a wadset [n -S]\n",
  "WADSETTERS": "WADSETTER, (Scots) one who holds by a wadset [n]\n",
  "WADSETTING": "WADSETT, (Scots) to pawn or mortgage, also WADSET [v]\n",
  "WADSETTS": "WADSETT, (Scots) to pawn or mortgage, also WADSET [v]\n",
  "WADT": "an earthy ore of manganese, also WADD [n -S]\n",
  "WADTS": "WADT, an earthy ore of manganese, also WADD [n]\n",
  "WADY": "(Arabic) the dry bed of a torrent; a river valley, also WADI [n WADIES]\n",
  "WAE": "(Scots) woe [n -S]\n",
  "WAEFUL": "(Scots) woeful, also WAESOME, WOESOME, WOFUL [adj]\n",
  "WAENESS": "sadness, also WOENESS [n -ES]\n",
  "WAENESSES": "WAENESS, sadness, also WOENESS [n]\n",
  "WAES": "WAE, (Scots) woe [n]\n",
  "WAESOME": "woeful, also WOESOME [adj]\n",
  "WAESUCK": "(Scots) interjection used to express pity, alas, also WAESUCKS [interj]\n",
  "WAESUCKS": "(Scots) interjection used to express pity, alas, also WAESUCK [interj]\n",
  "WAFER": "to fasten with an adhesive strip [v -ED, -ING, -S]\n",
  "WAFERED": "WAFER, to fasten with an adhesive strip [v]\n",
  "WAFERIER": "WAFERY, thin, wafer-like [adj]\n",
  "WAFERIEST": "WAFERY, thin, wafer-like [adj]\n",
  "WAFERING": "WAFER, to fasten with an adhesive strip [v]\n",
  "WAFERS": "WAFER, to fasten with an adhesive strip [v]\n",
  "WAFERY": "thin, wafer-like [adj WAFERIER, WAFERIEST]\n",
  "WAFF": "(dialect) to bark, also WAUGH [v -ED, -ING, -S]\n",
  "WAFFED": "WAFF, (dialect) to bark, also WAUGH [v]\n",
  "WAFFIE": "(Scots) a vagabond [n -S]\n",
  "WAFFIES": "WAFFIE, (Scots) a vagabond [n]\n",
  "WAFFING": "WAFF, (dialect) to bark, also WAUGH [v]\n",
  "WAFFLE": "to talk vaguely [v WAFFLED, WAFFLING, WAFFLES]\n",
  "WAFFLED": "WAFFLE, to talk vaguely [v]\n",
  "WAFFLER": "one who waffles [n -S]\n",
  "WAFFLERS": "WAFFLER, one who waffles [n]\n",
  "WAFFLES": "WAFFLE, to talk vaguely [v]\n",
  "WAFFLESTOMPER": "a hiking boot with a lug sole [n -S]\n",
  "WAFFLESTOMPERS": "WAFFLESTOMPER, a hiking boot with a lug sole [n]\n",
  "WAFFLIER": "WAFFLY, given to waffling [adj]\n",
  "WAFFLIEST": "WAFFLY, given to waffling [adj]\n",
  "WAFFLING": "talking at length to little purpose [n -S]\n",
  "WAFFLINGS": "WAFFLING, talking at length to little purpose [n]\n",
  "WAFFLY": "given to waffling [adj WAFFLIER, WAFFLIEST]\n",
  "WAFFS": "WAFF, (dialect) to bark, also WAUGH [v]\n",
  "WAFT": "to carry lightly in the air [v -ED, -ING, -S]\n",
  "WAFTAGE": "the act of wafting [n -S]\n",
  "WAFTAGES": "WAFTAGE, the act of wafting [n]\n",
  "WAFTED": "WAFT, to carry lightly in the air [v]\n",
  "WAFTER": "an armed vessel employed as a convoy [n -S]\n",
  "WAFTERS": "WAFTER, an armed vessel employed as a convoy [n]\n",
  "WAFTING": "the act of wafting [n -S]\n",
  "WAFTINGS": "WAFTING, the act of wafting [n]\n",
  "WAFTS": "WAFT, to carry lightly in the air [v]\n",
  "WAFTURE": "(Shakespeare) waving, beckoning [n -S]\n",
  "WAFTURES": "WAFTURE, (Shakespeare) waving, beckoning [n]\n",
  "WAG": "to move from side to side, also WAGGLE [v WAGGED, WAGGING, WAGS]\n",
  "WAGE": "to engage in or carry on [v WAGED, WAGING, WAGES]\n",
  "WAGED": "WAGE, to engage in or carry on [v]\n",
  "WAGELESS": "unpaid [adj]\n",
  "WAGELESSNESS": "the state of being wageless [n -ES]\n",
  "WAGELESSNESSES": "WAGELESSNESS, the state of being wageless [n]\n",
  "WAGENBOOM": "(South African) a South African tree with tough wood used for making wagon wheels, also WABOOM [n -S]\n",
  "WAGENBOOMS": "WAGENBOOM, (South African) a South African tree with tough wood used for making wagon wheels, also WABOOM [n]\n",
  "WAGER": "to make a bet [v -ED, -ING, -S]\n",
  "WAGERED": "WAGER, to make a bet [v]\n",
  "WAGERER": "one who makes a bet [n -S]\n",
  "WAGERERS": "WAGERER, one who makes a bet [n]\n",
  "WAGERING": "the act of making a wager [n -S]\n",
  "WAGERINGS": "WAGERING, the act of making a wager [n]\n",
  "WAGERS": "WAGER, to make a bet [v]\n",
  "WAGES": "WAGE, to engage in or carry on [v]\n",
  "WAGEWORKER": "one who works for a wage [n -S]\n",
  "WAGEWORKERS": "WAGEWORKER, one who works for a wage [n]\n",
  "WAGGA": "(Australian) a blanket or bed covering made out of sacks stitched together [n -S]\n",
  "WAGGAS": "WAGGA, (Australian) a blanket or bed covering made out of sacks stitched together [n]\n",
  "WAGGED": "WAG, to move from side to side, also WAGGLE [v]\n",
  "WAGGER": "a wastepaper basket [n -S]\n",
  "WAGGERIES": "WAGGERY, mischievous behaviour [n]\n",
  "WAGGERS": "WAGGER, a wastepaper basket [n]\n",
  "WAGGERY": "mischievous behaviour [n WAGGERIES]\n",
  "WAGGING": "WAG, to move from side to side, also WAGGLE [v]\n",
  "WAGGISH": "drolly humorous [adj WAGGISHLY]\n",
  "WAGGISHLY": "WAGGISH, drolly humorous [adv]\n",
  "WAGGISHNESS": "the state of being waggish [n -ES]\n",
  "WAGGISHNESSES": "WAGGISHNESS, the state of being waggish [n]\n",
  "WAGGLE": "to wag, move from side to side [v WAGGLED, WAGGLING, WAGGLES]\n",
  "WAGGLED": "WAGGLE, to wag, move from side to side [v]\n",
  "WAGGLER": "a fishing float with the line attached below [n -S]\n",
  "WAGGLERS": "WAGGLER, a fishing float with the line attached below [n]\n",
  "WAGGLES": "WAGGLE, to wag, move from side to side [v]\n",
  "WAGGLIER": "WAGGLY, waggling [adj]\n",
  "WAGGLIEST": "WAGGLY, waggling [adj]\n",
  "WAGGLING": "WAGGLE, to wag, move from side to side [v]\n",
  "WAGGLINGLY": "WAGGLING, WAGGLE, to wag, move from side to side [adv]\n",
  "WAGGLY": "waggling [adj WAGGLIER, WAGGLIEST]\n",
  "WAGGON": "to transport in a four wheeled horse-drawn vehicle, also WAGON [v -ED, -ING, -S]\n",
  "WAGGONED": "WAGGON, to transport in a four wheeled horse-drawn vehicle, also WAGON [v]\n",
  "WAGGONER": "one who drives a waggon, also WAGONER [n -S]\n",
  "WAGGONERS": "WAGGONER, one who drives a waggon, also WAGONER [n]\n",
  "WAGGONETTE": "a carriage with one crosswise seat in front, two seats in back, also WAGONETTE [n -S]\n",
  "WAGGONETTES": "WAGGONETTE, a carriage with one crosswise seat in front, two seats in back, also WAGONETTE [n]\n",
  "WAGGONING": "WAGGON, to transport in a four wheeled horse-drawn vehicle, also WAGON [v]\n",
  "WAGGONLESS": "without a waggon, also WAGONLESS [adj]\n",
  "WAGGONLOAD": "the contents of a full wagon, also WAGONLOAD [n -S]\n",
  "WAGGONLOADS": "WAGGONLOAD, the contents of a full wagon, also WAGONLOAD [n]\n",
  "WAGGONS": "WAGGON, to transport in a four wheeled horse-drawn vehicle, also WAGON [v]\n",
  "WAGHALTER": "a felon likely to swing from the gallows [n -S]\n",
  "WAGHALTERS": "WAGHALTER, a felon likely to swing from the gallows [n]\n",
  "WAGING": "WAGE, to engage in or carry on [v]\n",
  "WAGMOIRE": "(Spenser) a quagmire [n -S]\n",
  "WAGMOIRES": "WAGMOIRE, (Spenser) a quagmire [n]\n",
  "WAGON": "to transport in a four wheeled horse-drawn vehicle, also WAGGON [v -ED, -ING, -S]\n",
  "WAGONAGE": "money paid for carriage or conveyance in wagon [n -S]\n",
  "WAGONAGES": "WAGONAGE, money paid for carriage or conveyance in wagon [n]\n",
  "WAGONED": "WAGON, to transport in a four wheeled horse-drawn vehicle, also WAGGON [v]\n",
  "WAGONER": "one who drives a waggon, also WAGGONER [n -S]\n",
  "WAGONERS": "WAGONER, one who drives a waggon, also WAGGONER [n]\n",
  "WAGONETTE": "a carriage with one crosswise seat in front, two seats in back, also WAGGONETTE [n -S]\n",
  "WAGONETTES": "WAGONETTE, a carriage with one crosswise seat in front, two seats in back, also WAGGONETTE [n]\n",
  "WAGONFUL": "as much as a wagon can hold [n -S]\n",
  "WAGONFULS": "WAGONFUL, as much as a wagon can hold [n]\n",
  "WAGONING": "WAGON, to transport in a four wheeled horse-drawn vehicle, also WAGGON [v]\n",
  "WAGONLESS": "without a wagon, also WAGGONLESS [adj]\n",
  "WAGONLOAD": "the contents of a full wagon, also WAGGONLOAD [n -S]\n",
  "WAGONLOADS": "WAGONLOAD, the contents of a full wagon, also WAGGONLOAD [n]\n",
  "WAGONS": "WAGON, to transport in a four wheeled horse-drawn vehicle, also WAGGON [v]\n",
  "WAGONWRIGHT": "one who makes wagons [n -S]\n",
  "WAGONWRIGHTS": "WAGONWRIGHT, one who makes wagons [n]\n",
  "WAGS": "WAG, to move from side to side, also WAGGLE [v]\n",
  "WAGSOME": "waggish [adj]\n",
  "WAGTAIL": "a bird noted for its habit of wagging its long tail [n -S]\n",
  "WAGTAILS": "WAGTAIL, a bird noted for its habit of wagging its long tail [n]\n",
  "WAGYU": "(Japanese) a Japanese breed of beef cattle [n -S]\n",
  "WAGYUS": "WAGYU, (Japanese) a Japanese breed of beef cattle [n]\n",
  "WAHCONDA": "(Native American) a supernatural force in Sioux belief, also WACONDA, WAKANDA [n -S]\n",
  "WAHCONDAS": "WAHCONDA, (Native American) a supernatural force in Sioux belief, also WACONDA, WAKANDA [n]\n",
  "WAHINE": "(Maori) a Maori woman [n -S]\n",
  "WAHINES": "WAHINE, (Maori) a Maori woman [n]\n",
  "WAHOO": "(Native American) the burning bush, an ornamental shrub with scarlet-coated seeds [n -S]\n",
  "WAHOOS": "WAHOO, (Native American) the burning bush, an ornamental shrub with scarlet-coated seeds [n]\n",
  "WAI": "(Maori) water [n -S]\n",
  "WAIATA": "(Maori) a Maori song [n -S]\n",
  "WAIATAS": "WAIATA, (Maori) a Maori song [n]\n",
  "WAID": "(obsolete) weighed, also WAIDE [v]\n",
  "WAIDE": "WEIGH, to determine the weight of [v]\n",
  "WAIF": "a neglected, abandoned or orphaned child, also WAIFT, WEFTE [n -S] / to cast up as a waif [v -ED, -ING, -S]\n",
  "WAIFED": "WAIF, to cast up as a waif [v]\n",
  "WAIFING": "WAIF, to cast up as a waif [v]\n",
  "WAIFISH": "like a waif [adj]\n",
  "WAIFLIKE": "resembling a homeless child [adj]\n",
  "WAIFS": "WAIF, to cast up as a waif [v]\n",
  "WAIFT": "(Spenser) a phantom, a waif, also WEFTE [n -S]\n",
  "WAIFTS": "WAIFT, (Spenser) a phantom, a waif, also WEFTE [n]\n",
  "WAIL": "to utter a long, mournful cry [v -ED, -ING, -S]\n",
  "WAILED": "WAIL, to utter a long, mournful cry [v]\n",
  "WAILER": "one who wails [n -S]\n",
  "WAILERS": "WAILER, one who wails [n]\n",
  "WAILFUL": "sorrowful; mournful [adj WAILFULLY]\n",
  "WAILFULLY": "WAILFUL, sorrowful; mournful [adv]\n",
  "WAILING": "making a wailing sound [adj WAILINGLY] / the act of wailing [n -S]\n",
  "WAILINGLY": "WAILING, making a wailing sound [adv]\n",
  "WAILINGS": "WAILING, the act of wailing [n]\n",
  "WAILS": "WAIL, to utter a long, mournful cry [v]\n",
  "WAILSOME": "wailful [adj]\n",
  "WAIN": "a farm wagon [n -S] / (obsolete) to carry, convey [v -ED, -ING, -S]\n",
  "WAINAGE": "land under cultivation [n -S]\n",
  "WAINAGES": "WAINAGE, land under cultivation [n]\n",
  "WAINED": "WAIN, (obsolete) to carry, convey [v]\n",
  "WAINING": "WAIN, (obsolete) to carry, convey [v]\n",
  "WAINS": "WAIN, (obsolete) to carry, convey [v]\n",
  "WAINSCOT": "to cover with wooden panelling [v WAINSCOTTED or WAINSCOTED, WAINSCOTTING or WAINSCOTING, WAINSCOTS]\n",
  "WAINSCOTED": "WAINSCOT, to cover with wooden panelling [v]\n",
  "WAINSCOTING": "oak panelling, also WAINSCOTTING [n -S]\n",
  "WAINSCOTINGS": "WAINSCOTING, oak panelling, also WAINSCOTTING [n]\n",
  "WAINSCOTS": "WAINSCOT, to cover with wooden panelling [v]\n",
  "WAINSCOTTED": "WAINSCOT, to cover with wooden panelling [v]\n",
  "WAINSCOTTING": "oak panelling, also WAINSCOTING [n -S]\n",
  "WAINSCOTTINGS": "WAINSCOTTING, oak panelling, also WAINSCOTING [n]\n",
  "WAINWRIGHT": "a maker or repairer of carts [n -S]\n",
  "WAINWRIGHTS": "WAINWRIGHT, a maker or repairer of carts [n]\n",
  "WAIR": "to spend [v -ED, -ING, -S]\n",
  "WAIRED": "WAIR, to spend [v]\n",
  "WAIRING": "WAIR, to spend [v]\n",
  "WAIRS": "WAIR, to spend [v]\n",
  "WAIRSH": "tasteless, insipid, also WERSH [adj WAIRSHER, WAIRSHEST]\n",
  "WAIRSHER": "WAIRSH, tasteless, insipid, also WERSH [adj]\n",
  "WAIRSHEST": "WAIRSH, tasteless, insipid, also WERSH [adj]\n",
  "WAIRUA": "(Maori) one's spirit which leaves when dreaming or dying [n -S]\n",
  "WAIRUAS": "WAIRUA, (Maori) one's spirit which leaves when dreaming or dying [n]\n",
  "WAIS": "WAI, (Maori) water [n]\n",
  "WAIST": "the narrowest part of the human trunk [n -S]\n",
  "WAISTBAND": "the strip of fabric in a garment that fits round the waist [n -S]\n",
  "WAISTBANDS": "WAISTBAND, the strip of fabric in a garment that fits round the waist [n]\n",
  "WAISTBELT": "a belt worn round the waist e.g. for carrying money [n -S]\n",
  "WAISTBELTS": "WAISTBELT, a belt worn round the waist e.g. for carrying money [n]\n",
  "WAISTCLOTH": "a cloth or wrapper worn about the waist; by extension, such a garment worn about the hips and passing between the thighs [n -S]\n",
  "WAISTCLOTHS": "WAISTCLOTH, a cloth or wrapper worn about the waist; by extension, such a garment worn about the hips and passing between the thighs [n]\n",
  "WAISTCOAT": "a garment, plain or ornamental, reaching to or below the waist and now sleeveless, worn by men at different periods under doublet, coat, jacket etc., also WESKIT [n -S]\n",
  "WAISTCOATED": "wearing a waistcoat [adj]\n",
  "WAISTCOATEER": "(obsolete) a strumpet [n -S]\n",
  "WAISTCOATEERS": "WAISTCOATEER, (obsolete) a strumpet [n]\n",
  "WAISTCOATING": "material for men's waistcoats, esp. of a fancy pattern [n -S]\n",
  "WAISTCOATINGS": "WAISTCOATING, material for men's waistcoats, esp. of a fancy pattern [n]\n",
  "WAISTCOATS": "WAISTCOAT, a garment, plain or ornamental, reaching to or below the waist and now sleeveless, worn by men at different periods under doublet, coat, jacket etc., also WESKIT [n]\n",
  "WAISTED": "having a waist [adj]\n",
  "WAISTER": "a seaman stationed in the middle of the ship [n -S]\n",
  "WAISTERS": "WAISTER, a seaman stationed in the middle of the ship [n]\n",
  "WAISTING": "dressmaking material [n -S]\n",
  "WAISTINGS": "WAISTING, dressmaking material [n]\n",
  "WAISTLESS": "without a waist [adj]\n",
  "WAISTLINE": "a line thought of as marking the waist, but not fixed by anatomy in women's fashions [n -S]\n",
  "WAISTLINES": "WAISTLINE, a line thought of as marking the waist, but not fixed by anatomy in women's fashions [n]\n",
  "WAISTS": "WAIST, the narrowest part of the human trunk [n]\n",
  "WAIT": "to remain in readiness [v -ED, -ING, -S]\n",
  "WAITE": "(Spenser) to wait [v WAITED, WAITING, WAITES]\n",
  "WAITED": "WAITE, (Spenser) to wait [v]\n",
  "WAITER": "one who serves at table [n -S] / to serve at table [v -ED, -ING, -S]\n",
  "WAITERAGE": "service by a waiter [n -S]\n",
  "WAITERAGES": "WAITERAGE, service by a waiter [n]\n",
  "WAITERED": "WAITER, to serve at table [v]\n",
  "WAITERHOOD": "the state of being a waiter [n -S]\n",
  "WAITERHOODS": "WAITERHOOD, the state of being a waiter [n]\n",
  "WAITERING": "the job of being a waiter [n -S]\n",
  "WAITERINGS": "WAITERING, the job of being a waiter [n]\n",
  "WAITERS": "WAITER, one who serves at table [n]\n",
  "WAITES": "WAITE, (Spenser) to wait [v]\n",
  "WAITING": "relating to, or suitable for waiting [adj WAITINGLY] / attendance, service, e.g. in a restaurant [n -S]\n",
  "WAITINGLY": "WAITING, relating to, or suitable for waiting [adv]\n",
  "WAITINGS": "WAITING, attendance, service, e.g. in a restaurant [n]\n",
  "WAITLIST": "to put on a list of persons waiting [v -ED, -ING, -S]\n",
  "WAITLISTED": "WAITLIST, to put on a list of persons waiting [v]\n",
  "WAITLISTING": "WAITLIST, to put on a list of persons waiting [v]\n",
  "WAITLISTS": "WAITLIST, to put on a list of persons waiting [v]\n",
  "WAITPEOPLE": "WAITPERSON, a waiter of either sex [n]\n",
  "WAITPERSON": "a waiter of either sex [n WAITPERSONS or WAITPEOPLE]\n",
  "WAITPERSONS": "WAITPERSON, a waiter of either sex [n]\n",
  "WAITRESS": "to serve as a female waiter [v -ED, -ING, -ES]\n",
  "WAITRESSED": "WAITRESS, to serve as a female waiter [v]\n",
  "WAITRESSES": "WAITRESS, to serve as a female waiter [v]\n",
  "WAITRESSING": "working as a waitress [n -S]\n",
  "WAITRESSINGS": "WAITRESSING, working as a waitress [n]\n",
  "WAITRON": "a server in a restaurant [n -S]\n",
  "WAITRONS": "WAITRON, a server in a restaurant [n]\n",
  "WAITS": "WAIT, to remain in readiness [v]\n",
  "WAITSTAFF": "waiters and waitresses collectively [n -S]\n",
  "WAITSTAFFS": "WAITSTAFF, waiters and waitresses collectively [n]\n",
  "WAIVE": "to refrain from claiming [v WAIVED, WAIVING, WAIVES]\n",
  "WAIVED": "WAIVE, to refrain from claiming [v]\n",
  "WAIVER": "the act of waiving something [n -S]\n",
  "WAIVERS": "WAIVER, the act of waiving something [n]\n",
  "WAIVES": "WAIVE, to refrain from claiming [v]\n",
  "WAIVING": "WAIVE, to refrain from claiming [v]\n",
  "WAIVODE": "(Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIWODE, WAYWODE, WOIWODE [n -S]\n",
  "WAIVODES": "WAIVODE, (Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIWODE, WAYWODE, WOIWODE [n]\n",
  "WAIWODE": "(Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIVODE, WAYWODE, WOIWODE [n -S]\n",
  "WAIWODES": "WAIWODE, (Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIVODE, WAYWODE, WOIWODE [n]\n",
  "WAKA": "(Japanese) a Japanese verse-form [n -S]\n",
  "WAKAME": "(Japanese) an edible seaweed that can be soaked and used as a salad vegetable, also WAKANE [n -S]\n",
  "WAKAMES": "WAKAME, (Japanese) an edible seaweed that can be soaked and used as a salad vegetable, also WAKANE [n]\n",
  "WAKANDA": "(Native American) a supernatural force in Sioux belief, also WACONDA, WAHCONDA [n -S]\n",
  "WAKANDAS": "WAKANDA, (Native American) a supernatural force in Sioux belief, also WACONDA, WAHCONDA [n]\n",
  "WAKANE": "(Japanese) an edible seaweed that can be soaked and used as a salad vegetable, also WAKAME [n -S]\n",
  "WAKANES": "WAKANE, (Japanese) an edible seaweed that can be soaked and used as a salad vegetable, also WAKAME [n]\n",
  "WAKAS": "WAKA, (Japanese) a Japanese verse-form [n]\n",
  "WAKE": "to rouse from sleep [v WOKE or (archaic) WAKED, WOKEN, WAKING, WAKES]\n",
  "WAKEBOARD": "to ride a short, very broad water ski while being towed by a motorboat [v -ED, -ING, -S]\n",
  "WAKEBOARDED": "WAKEBOARD, to ride a short, very broad water ski while being towed by a motorboat [v]\n",
  "WAKEBOARDER": "one who practises wakeboarding [n -S]\n",
  "WAKEBOARDERS": "WAKEBOARDER, one who practises wakeboarding [n]\n",
  "WAKEBOARDING": "a sport similar to waterskiing in which the participant is towed behind a motorboat while riding on a board like a short surfboard [n -S]\n",
  "WAKEBOARDINGS": "WAKEBOARDING, a sport similar to waterskiing in which the participant is towed behind a motorboat while riding on a board like a short surfboard [n]\n",
  "WAKEBOARDS": "WAKEBOARD, to ride a short, very broad water ski while being towed by a motorboat [v]\n",
  "WAKED": "WAKE, to rouse from sleep [v]\n",
  "WAKEFUL": "not sleeping [adj WAKEFULLY]\n",
  "WAKEFULLY": "WAKEFUL, not sleeping [adv]\n",
  "WAKEFULNESS": "the state of being wakeful [n -ES]\n",
  "WAKEFULNESSES": "WAKEFULNESS, the state of being wakeful [n]\n",
  "WAKELESS": "unbroken sleep [adj]\n",
  "WAKEMAN": "(archaic) a watchman [n WAKEMEN]\n",
  "WAKEMEN": "WAKEMAN, (archaic) a watchman [n]\n",
  "WAKEN": "to wake [v -ED, -ING, -S]\n",
  "WAKENED": "WAKEN, to wake [v]\n",
  "WAKENER": "one that wakens, also WAKER [n -S]\n",
  "WAKENERS": "WAKENER, one that wakens, also WAKER [n]\n",
  "WAKENING": "the act of wakening [n -S]\n",
  "WAKENINGS": "WAKENING, the act of wakening [n]\n",
  "WAKENS": "WAKEN, to wake [v]\n",
  "WAKER": "one that wakens, also WAKENER [n -S]\n",
  "WAKERIFE": "(Scots) wakeful, vigilant, also WAUKRIFE [adj]\n",
  "WAKERS": "WAKER, one that wakens, also WAKENER [n]\n",
  "WAKES": "WAKE, to rouse from sleep [v]\n",
  "WAKF": "(Arabic) the donation of land, property or money for charitable or pious purposes, also WAQF [n -S]\n",
  "WAKFS": "WAKF, (Arabic) the donation of land, property or money for charitable or pious purposes, also WAQF [n]\n",
  "WAKIKI": "(Melanesian) shell money [n -S]\n",
  "WAKIKIS": "WAKIKI, (Melanesian) shell money [n]\n",
  "WAKING": "the act of waking [n -S]\n",
  "WAKINGS": "WAKING, the act of waking [n]\n",
  "WALD": "(Scots) wild mignonette [n -S]\n",
  "WALDFLUTE": "(German) an organ flute stop of 4 feet in length [n -S]\n",
  "WALDFLUTES": "WALDFLUTE, (German) an organ flute stop of 4 feet in length [n]\n",
  "WALDGRAVE": "(German) a former German title of count; a head forest ranger, also WILDGRAVE [n -S]\n",
  "WALDGRAVES": "WALDGRAVE, (German) a former German title of count; a head forest ranger, also WILDGRAVE [n]\n",
  "WALDGRAVINE": "(German) the wife of a waldgrave [n -S]\n",
  "WALDGRAVINES": "WALDGRAVINE, (German) the wife of a waldgrave [n]\n",
  "WALDHORN": "(German) a French valveless hunting horn [n -S]\n",
  "WALDHORNS": "WALDHORN, (German) a French valveless hunting horn [n]\n",
  "WALDO": "a gadget for manipulating objects remotely [n -S or -ES]\n",
  "WALDOES": "WALDO, a gadget for manipulating objects remotely [n]\n",
  "WALDOS": "WALDO, a gadget for manipulating objects remotely [n]\n",
  "WALDRAPP": "(German) the hermit ibis of North Africa and the Middle East [n -S]\n",
  "WALDRAPPS": "WALDRAPP, (German) the hermit ibis of North Africa and the Middle East [n]\n",
  "WALDS": "WALD, (Scots) wild mignonette [n]\n",
  "WALDSTERBEN": "(German) disease and death in forest trees and vegetation as a result of atmospheric pollution [n -S]\n",
  "WALDSTERBENS": "WALDSTERBEN, (German) disease and death in forest trees and vegetation as a result of atmospheric pollution [n]\n",
  "WALE": "to mark with welts [v WALED, WALING, WALES]\n",
  "WALED": "WALE, to mark with welts [v]\n",
  "WALER": "in India, an Australian-bred saddle-horse [n -S]\n",
  "WALERS": "WALER, in India, an Australian-bred saddle-horse [n]\n",
  "WALES": "WALE, to mark with welts [v]\n",
  "WALI": "(Turkish) a governor, esp. of a vilayet, also VALI [n -S]\n",
  "WALIE": "sturdy [adj]\n",
  "WALIER": "WALY, (Scots) fine, excellent [adj]\n",
  "WALIES": "WALY, a fine thing [n]\n",
  "WALIEST": "WALY, (Scots) fine, excellent [adj]\n",
  "WALING": "WALE, to mark with welts [v]\n",
  "WALIS": "WALI, (Turkish) a governor, esp. of a vilayet, also VALI [n]\n",
  "WALISE": "(Scots) a valise [n -S]\n",
  "WALISES": "WALISE, (Scots) a valise [n]\n",
  "WALK": "to advance on foot [v -ED, -ING, -S]\n",
  "WALKABLE": "able to be walked [adj]\n",
  "WALKABOUT": "(Australian) a period of wandering in the bush by an Australian Aborigine [n -S]\n",
  "WALKABOUTS": "WALKABOUT, (Australian) a period of wandering in the bush by an Australian Aborigine [n]\n",
  "WALKATHON": "a marathon walking event [n -S]\n",
  "WALKATHONS": "WALKATHON, a marathon walking event [n]\n",
  "WALKAWAY": "an easy victory [n -S]\n",
  "WALKAWAYS": "WALKAWAY, an easy victory [n]\n",
  "WALKED": "WALK, to advance on foot [v]\n",
  "WALKER": "one who walks [n -S]\n",
  "WALKERS": "WALKER, one who walks [n]\n",
  "WALKIES": "as in 'go walkies' [n]\n",
  "WALKING": "the act of walking [n -S]\n",
  "WALKINGS": "WALKING, the act of walking [n]\n",
  "WALKINGSTICK": "a stick used for walking [n -S]\n",
  "WALKINGSTICKS": "WALKINGSTICK, a stick used for walking [n]\n",
  "WALKMILL": "a fulling-mill, also WAUKMILL, WAULKMILL [n -S]\n",
  "WALKMILLS": "WALKMILL, a fulling-mill, also WAUKMILL, WAULKMILL [n]\n",
  "WALKOUT": "a strike by workers [n -S]\n",
  "WALKOUTS": "WALKOUT, a strike by workers [n]\n",
  "WALKOVER": "a race involving only one horse and jockey [n -S]\n",
  "WALKOVERS": "WALKOVER, a race involving only one horse and jockey [n]\n",
  "WALKS": "WALK, to advance on foot [v]\n",
  "WALKSHORTS": "(New Zealand) smart shorts for men [n]\n",
  "WALKUP": "an apartment house with no lift [n -S]\n",
  "WALKUPS": "WALKUP, an apartment house with no lift [n]\n",
  "WALKWAY": "a pedestrian route [n -S]\n",
  "WALKWAYS": "WALKWAY, a pedestrian route [n]\n",
  "WALKYRIE": "(Old Norse) in Norse mythology, a maiden who chooses the slain, also VALKYRIE, VALKYR [n -S]\n",
  "WALKYRIES": "WALKYRIE, (Old Norse) in Norse mythology, a maiden who chooses the slain, also VALKYRIE, VALKYR [n]\n",
  "WALL": "to enclose in an upright structure [v -ED, -ING, -S]\n",
  "WALLA": "(Hindi) a person employed in a specific type of work, also WALLAH [n -S]\n",
  "WALLABA": "a leguminous tree of Demerara, with pinnate leaves and clusters of red flowers [n -S]\n",
  "WALLABAS": "WALLABA, a leguminous tree of Demerara, with pinnate leaves and clusters of red flowers [n]\n",
  "WALLABIES": "WALLABY, (Native Australian) any of a number of small marsupials of the family Macropodidae [n]\n",
  "WALLABY": "(Native Australian) any of a number of small marsupials of the family Macropodidae [n WALLABIES]\n",
  "WALLAH": "(Hindi) a person who is associated with a particular work or who performs a particular duty or service - usually used in combination, also WALLA [n -S]\n",
  "WALLAHS": "WALLAH, (Hindi) a person who is associated with a particular work or who performs a particular duty or service - usually used in combination, also WALLA [n]\n",
  "WALLAROO": "(Native Australian) any of several large types of kangaroo, aka euro [n -S]\n",
  "WALLAROOS": "WALLAROO, (Native Australian) any of several large types of kangaroo, aka euro [n]\n",
  "WALLAS": "WALLA, (Hindi) a person employed in a specific type of work, also WALLAH [n]\n",
  "WALLBOARD": "building board, board for lining walls [n -S]\n",
  "WALLBOARDS": "WALLBOARD, building board, board for lining walls [n]\n",
  "WALLCHART": "a chart of information, statistics, etc., displayed on a wall [n -S]\n",
  "WALLCHARTS": "WALLCHART, a chart of information, statistics, etc., displayed on a wall [n]\n",
  "WALLCLIMBER": "a glass-walled elevator whose shaft is on the exterior wall of a building [n -S]\n",
  "WALLCLIMBERS": "WALLCLIMBER, a glass-walled elevator whose shaft is on the exterior wall of a building [n]\n",
  "WALLCOVERING": "a covering for a wall [n -S]\n",
  "WALLCOVERINGS": "WALLCOVERING, a covering for a wall [n]\n",
  "WALLED": "WALL, to enclose in an upright structure [v]\n",
  "WALLER": "a builder of walls [n -S]\n",
  "WALLERS": "WALLER, a builder of walls [n]\n",
  "WALLET": "a small, flat folding case for the pocket [n -S]\n",
  "WALLETS": "WALLET, a small, flat folding case for the pocket [n]\n",
  "WALLEY": "a type of jump in figure skating [n -S]\n",
  "WALLEYE": "an eye in which the iris is pale or whitish, also WATCHEYE [n -S]\n",
  "WALLEYED": "having a walleye [adj]\n",
  "WALLEYES": "WALLEYE, an eye in which the iris is pale or whitish, also WATCHEYE [n]\n",
  "WALLEYS": "WALLEY, a type of jump in figure skating [n]\n",
  "WALLFISH": "a snail [n -ES]\n",
  "WALLFISHES": "WALLFISH, a snail [n]\n",
  "WALLFLOWER": "a yellowish-red flower found esp. on old walls [n -S]\n",
  "WALLFLOWERS": "WALLFLOWER, a yellowish-red flower found esp. on old walls [n]\n",
  "WALLIE": "an idiot or imbecile, also WALLY [n -S]\n",
  "WALLIER": "WALLY, (Scots) fine, excellent, also WALY [adj]\n",
  "WALLIES": "WALLY, an idiot or imbecile, also WALLIE [n]\n",
  "WALLIEST": "WALLY, (Scots) fine, excellent, also WALY [adj]\n",
  "WALLING": "walls collectively [n -S]\n",
  "WALLINGS": "WALLING, walls collectively [n]\n",
  "WALLOP": "to beat soundly [v -ED, -ING, -S]\n",
  "WALLOPED": "WALLOP, to beat soundly [v]\n",
  "WALLOPER": "(colloquial) anything strikingly big of its kind [n -S]\n",
  "WALLOPERS": "WALLOPER, (colloquial) anything strikingly big of its kind [n]\n",
  "WALLOPING": "a beating [n -S]\n",
  "WALLOPINGS": "WALLOPING, a beating [n]\n",
  "WALLOPS": "WALLOP, to beat soundly [v]\n",
  "WALLOW": "to roll about [v -ED, -ING, -S]\n",
  "WALLOWED": "WALLOW, to roll about [v]\n",
  "WALLOWER": "one that rolls about [n -S]\n",
  "WALLOWERS": "WALLOWER, one that rolls about [n]\n",
  "WALLOWING": "the act of wallowing [n -S]\n",
  "WALLOWINGS": "WALLOWING, the act of wallowing [n]\n",
  "WALLOWS": "WALLOW, to roll about [v]\n",
  "WALLPAPER": "paper used to cover a wall [n -S] / to cover with wallpaper [v -ED, -ING, -S]\n",
  "WALLPAPERED": "WALLPAPER, to cover with wallpaper [v]\n",
  "WALLPAPERING": "WALLPAPER, to cover with wallpaper [v]\n",
  "WALLPAPERS": "WALLPAPER, to cover with wallpaper [v]\n",
  "WALLPEPPER": "a small Eurasian crassulaceous plant, having creeping stems, yellow flowers, and acrid-tasting leaves [n -S]\n",
  "WALLPEPPERS": "WALLPEPPER, a small Eurasian crassulaceous plant, having creeping stems, yellow flowers, and acrid-tasting leaves [n]\n",
  "WALLPOSTER": "in China, a bulletin or political message painted in large characters on walls [n -S]\n",
  "WALLPOSTERS": "WALLPOSTER, in China, a bulletin or political message painted in large characters on walls [n]\n",
  "WALLS": "WALL, to enclose in an upright structure [v]\n",
  "WALLSEND": "coal of a certain quality and size; originally coal dug at Wallsend [n -S]\n",
  "WALLSENDS": "WALLSEND, coal of a certain quality and size; originally coal dug at Wallsend [n]\n",
  "WALLWORT": "a dwarf elder [n -S]\n",
  "WALLWORTS": "WALLWORT, a dwarf elder [n]\n",
  "WALLY": "(Scots) fine, excellent, also WALY [adj WALLIER, WALLIEST] / an idiot or imbecile, also WALLIE [n WALLIES]\n",
  "WALLYBALL": "a ball game played on court [n -S]\n",
  "WALLYBALLS": "WALLYBALL, a ball game played on court [n]\n",
  "WALLYDRAG": "(Scots) a feeble, imperfectly developed, or slovenly creature, also WALLYDRAIGLE [n -S]\n",
  "WALLYDRAGS": "WALLYDRAG, (Scots) a feeble, imperfectly developed, or slovenly creature, also WALLYDRAIGLE [n]\n",
  "WALLYDRAIGLE": "(Scots) a feeble, imperfectly developed, or slovenly creature, also WALLYDRAG [n -S]\n",
  "WALLYDRAIGLES": "WALLYDRAIGLE, (Scots) a feeble, imperfectly developed, or slovenly creature, also WALLYDRAG [n]\n",
  "WALNUT": "a tree or its nut [n -S]\n",
  "WALNUTS": "WALNUT, a tree or its nut [n]\n",
  "WALNUTWOOD": "the wood of the walnut tree [n -S]\n",
  "WALNUTWOODS": "WALNUTWOOD, the wood of the walnut tree [n]\n",
  "WALRUS": "(Dutch) a large aquatic carnivorous mammal [n -ES]\n",
  "WALRUSES": "WALRUS, (Dutch) a large aquatic carnivorous mammal [n]\n",
  "WALTIER": "WALTY, inclined to tip over or lean [adj]\n",
  "WALTIEST": "WALTY, inclined to tip over or lean [adj]\n",
  "WALTY": "inclined to tip over or lean [adj WALTIER, WALTIEST]\n",
  "WALTZ": "to dance in three-four time [v -ED, -ING, -ES]\n",
  "WALTZED": "WALTZ, to dance in three-four time [v]\n",
  "WALTZER": "one who waltzes [n -S]\n",
  "WALTZERS": "WALTZER, one who waltzes [n]\n",
  "WALTZES": "WALTZ, to dance in three-four time [v]\n",
  "WALTZING": "the act of waltzing [n -S]\n",
  "WALTZINGS": "WALTZING, the act of waltzing [n]\n",
  "WALTZLIKE": "like a waltz [adj]\n",
  "WALY": "(Scots) fine, excellent [adj WALIER, WALIEST] / a fine thing [n WALIES]\n",
  "WAMBENGER": "(Native Australian) a small Australian marsupial, aka tuan or phascogale [n -S]\n",
  "WAMBENGERS": "WAMBENGER, (Native Australian) a small Australian marsupial, aka tuan or phascogale [n]\n",
  "WAMBLE": "to move unsteadily [v WAMBLED, WAMBLING, WAMBLES]\n",
  "WAMBLED": "WAMBLE, to move unsteadily [v]\n",
  "WAMBLES": "WAMBLE, to move unsteadily [v]\n",
  "WAMBLIER": "WAMBLY, affected with, or causing, sickness; unsteady [adj]\n",
  "WAMBLIEST": "WAMBLY, affected with, or causing, sickness; unsteady [adj]\n",
  "WAMBLINESS": "the state of being wambly, unsteady [n -ES]\n",
  "WAMBLINESSES": "WAMBLINESS, the state of being wambly, unsteady [n]\n",
  "WAMBLING": "moving unsteadily [adj WAMBLINGLY] / the act of wambling [n -S]\n",
  "WAMBLINGLY": "WAMBLING, moving unsteadily [adv]\n",
  "WAMBLINGS": "WAMBLING, the act of wambling [n]\n",
  "WAMBLY": "affected with, or causing, sickness; unsteady [adj WAMBLIER, WAMBLIEST]\n",
  "WAME": "(dialect) a womb, also WEAMB, WEM, WEMB [n -S]\n",
  "WAMED": "having a wame, womb [adj]\n",
  "WAMEFOU": "a bellyful, also WAMEFUL [n -S]\n",
  "WAMEFOUS": "WAMEFOU, a bellyful, also WAMEFUL [n]\n",
  "WAMEFUL": "a bellyful, also WAMEFOU [n -S]\n",
  "WAMEFULS": "WAMEFUL, a bellyful, also WAMEFOU [n]\n",
  "WAMES": "WAME, (dialect) a womb, also WEAMB, WEM, WEMB [n]\n",
  "WAMMUL": "(dialect) a dog [n -S]\n",
  "WAMMULS": "WAMMUL, (dialect) a dog [n]\n",
  "WAMMUS": "(Dutch) a kind of cardigan or strong jacket buttoned at the neck or wrists, also WAMPUS, WAMUS [n -ES]\n",
  "WAMMUSES": "WAMMUS, (Dutch) a kind of cardigan or strong jacket buttoned at the neck or wrists, also WAMPUS, WAMUS [n]\n",
  "WAMPEE": "(Chinese) an edible Asiatic fruit about the size of a large grape, with a hard yellow rind [n -S]\n",
  "WAMPEES": "WAMPEE, (Chinese) an edible Asiatic fruit about the size of a large grape, with a hard yellow rind [n]\n",
  "WAMPISH": "(Scott) to brandish, flourish [v -ED, -ING, -ES]\n",
  "WAMPISHED": "WAMPISH, (Scott) to brandish, flourish [v]\n",
  "WAMPISHES": "WAMPISH, (Scott) to brandish, flourish [v]\n",
  "WAMPISHING": "WAMPISH, (Scott) to brandish, flourish [v]\n",
  "WAMPUM": "(Native American) beads made from shells, used as money etc., also WAMPUMPEAG [n -S]\n",
  "WAMPUMPEAG": "(Native American) beads made from shells, used as money etc., also WAMPUM [n -S]\n",
  "WAMPUMPEAGS": "WAMPUMPEAG, (Native American) beads made from shells, used as money etc., also WAMPUM [n]\n",
  "WAMPUMS": "WAMPUM, (Native American) beads made from shells, used as money etc., also WAMPUMPEAG [n]\n",
  "WAMPUS": "(Dutch) a kind of cardigan or strong jacket buttoned at the neck or wrists, also WAMMUS, WAMUS [n -ES]\n",
  "WAMPUSES": "WAMPUS, (Dutch) a kind of cardigan or strong jacket buttoned at the neck or wrists, also WAMMUS, WAMUS [n]\n",
  "WAMUS": "(Dutch) a kind of cardigan or strong jacket buttoned at the neck or wrists, also WAMMUS, WAMPUS [n -ES]\n",
  "WAMUSES": "WAMUS, (Dutch) a kind of cardigan or strong jacket buttoned at the neck or wrists, also WAMMUS, WAMPUS [n]\n",
  "WAN": "pale [adj WANNER, WANNEST, WANLY] / to make or become wan [v WANNED, WANNING, WANS]\n",
  "WANCHANCIE": "(Scots) unlucky, dangerous, uncanny, also WANCHANCY [adj]\n",
  "WANCHANCY": "(Scots) unlucky, dangerous, uncanny, also WANCHANCIE [adj]\n",
  "WAND": "a slender rod [n -S]\n",
  "WANDER": "to move about with no destination or purpose [v -ED, -ING, -S]\n",
  "WANDERED": "WANDER, to move about with no destination or purpose [v]\n",
  "WANDERER": "one who wanders [n -S]\n",
  "WANDERERS": "WANDERER, one who wanders [n]\n",
  "WANDERING": "moving about with no destination or purpose [adj WANDERINGLY] / the act of wandering [n -S]\n",
  "WANDERINGLY": "WANDERING, moving about with no destination or purpose [adv]\n",
  "WANDERINGS": "WANDERING, the act of wandering [n]\n",
  "WANDERLUST": "(German) an urge to travel from place to place [n -S]\n",
  "WANDERLUSTS": "WANDERLUST, (German) an urge to travel from place to place [n]\n",
  "WANDEROO": "(Sinhalese) a long-tailed monkey, native to the Malabar coast of India [n -S]\n",
  "WANDEROOS": "WANDEROO, (Sinhalese) a long-tailed monkey, native to the Malabar coast of India [n]\n",
  "WANDERS": "WANDER, to move about with no destination or purpose [v]\n",
  "WANDLE": "(dialect) supple, pliant, nimble, also WANLE, WANNEL [adj] / to walk haltingly [v WANDLED, WANDLING, WANDLES]\n",
  "WANDLED": "WANDLE, to walk haltingly [v]\n",
  "WANDLES": "WANDLE, to walk haltingly [v]\n",
  "WANDLIKE": "like a wand [adj]\n",
  "WANDLING": "WANDLE, to walk haltingly [v]\n",
  "WANDOO": "(Native Australian) an Australian hardwood tree [n -S]\n",
  "WANDOOS": "WANDOO, (Native Australian) an Australian hardwood tree [n]\n",
  "WANDS": "WAND, a slender rod [n]\n",
  "WANE": "to decrease in size [v WANED, WANING, WANES]\n",
  "WANED": "WANE, to decrease in size [v]\n",
  "WANES": "WANE, to decrease in size [v]\n",
  "WANEY": "waning in some parts, also WANY [adj WANIER, WANIEST]\n",
  "WANG": "a leather thong [n -S]\n",
  "WANGAN": "(Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGUN, WANIGAN, WANNIGAN [n -S]\n",
  "WANGANS": "WANGAN, (Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGUN, WANIGAN, WANNIGAN [n]\n",
  "WANGLE": "to obtain by craft [v WANGLED, WANGLING, WANGLES]\n",
  "WANGLED": "WANGLE, to obtain by craft [v]\n",
  "WANGLER": "one who wangles [n -S]\n",
  "WANGLERS": "WANGLER, one who wangles [n]\n",
  "WANGLES": "WANGLE, to obtain by craft [v]\n",
  "WANGLING": "the act of wangling [n -S]\n",
  "WANGLINGS": "WANGLING, the act of wangling [n]\n",
  "WANGS": "WANG, a leather thong [n]\n",
  "WANGUN": "(Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGAN, WANIGAN, WANNIGAN [n -S]\n",
  "WANGUNS": "WANGUN, (Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGAN, WANIGAN, WANNIGAN [n]\n",
  "WANHOPE": "(obsolete) despair [n -S]\n",
  "WANHOPES": "WANHOPE, (obsolete) despair [n]\n",
  "WANIER": "WANY, waning in some parts, also WANEY [adj]\n",
  "WANIEST": "WANY, waning in some parts, also WANEY [adj]\n",
  "WANIGAN": "(Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGAN, WANGUN, WANNIGAN [n -S]\n",
  "WANIGANS": "WANIGAN, (Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGAN, WANGUN, WANNIGAN [n]\n",
  "WANING": "the act of waning [n -S]\n",
  "WANINGS": "WANING, the act of waning [n]\n",
  "WANION": "(Shakespeare) a word of uncertain signification, used only in the phrase with a wanion, apparently equivalent to with a vengeance, with a plague, or with misfortune, also WANNION [n -S]\n",
  "WANIONS": "WANION, (Shakespeare) a word of uncertain signification, used only in the phrase with a wanion, apparently equivalent to with a vengeance, with a plague, or with misfortune, also WANNION [n]\n",
  "WANK": "(vulgar) to masturbate [v -ED, -ING, -S]\n",
  "WANKED": "WANK, (vulgar) to masturbate [v]\n",
  "WANKER": "one who masturbates [n -S]\n",
  "WANKERS": "WANKER, one who masturbates [n]\n",
  "WANKIER": "WANKY, (vulgar) contemptible [adj]\n",
  "WANKIEST": "WANKY, (vulgar) contemptible [adj]\n",
  "WANKING": "WANK, (vulgar) to masturbate [v]\n",
  "WANKLE": "unstable or unsteady [adj]\n",
  "WANKS": "WANK, (vulgar) to masturbate [v]\n",
  "WANKSTA": "(vulgar colloquial) a person who acts and dresses like a gangster but is not involved in crime [n -S]\n",
  "WANKSTAS": "WANKSTA, (vulgar colloquial) a person who acts and dresses like a gangster but is not involved in crime [n]\n",
  "WANKY": "(vulgar) contemptible [adj WANKIER, WANKIEST]\n",
  "WANLE": "(dialect) supple, pliant, nimble, also WANDLE, WANNEL [adj]\n",
  "WANLY": "WAN, pale [adv]\n",
  "WANNA": "(colloquial) want to [v]\n",
  "WANNABE": "someone who tries to be associated with an admired person or set of people, also WANNABEE [n -S]\n",
  "WANNABEE": "someone who tries to be associated with an admired person or set of people, also WANNABE [n -S]\n",
  "WANNABEES": "WANNABEE, someone who tries to be associated with an admired person or set of people, also WANNABE [n]\n",
  "WANNABES": "WANNABE, someone who tries to be associated with an admired person or set of people, also WANNABEE [n]\n",
  "WANNED": "WAN, to make or become wan [v]\n",
  "WANNEL": "(dialect) supple, pliant, nimble, also WANDLE, WANLE [adj]\n",
  "WANNER": "WAN, pale [adj]\n",
  "WANNESS": "the state of being wan [n -ES]\n",
  "WANNESSES": "WANNESS, the state of being wan [n]\n",
  "WANNEST": "WAN, pale [adj]\n",
  "WANNIGAN": "(Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGAN, WANGUN, WANIGAN [n -S]\n",
  "WANNIGANS": "WANNIGAN, (Native American) in a lumber camp, a chest for supplies, or the pay office, also WANGAN, WANGUN, WANIGAN [n]\n",
  "WANNING": "WAN, to make or become wan [v]\n",
  "WANNION": "(Shakespeare) a word of uncertain signification, used only in the phrase with a wanion, apparently equivalent to with a vengeance, with a plague, or with misfortune, also WANION [n -S]\n",
  "WANNIONS": "WANNION, (Shakespeare) a word of uncertain signification, used only in the phrase with a wanion, apparently equivalent to with a vengeance, with a plague, or with misfortune, also WANION [n]\n",
  "WANNISH": "somewhat wan [adj]\n",
  "WANRESTFUL": "(Scots) restless [adj]\n",
  "WANS": "WAN, to make or become wan [v]\n",
  "WANT": "to have a desire for [v -ED, -ING, -S]\n",
  "WANTAGE": "a deficiency; a shortage [n -S]\n",
  "WANTAGES": "WANTAGE, a deficiency; a shortage [n]\n",
  "WANTAWAY": "a footballer who wants to transfer to another club [n -S]\n",
  "WANTAWAYS": "WANTAWAY, a footballer who wants to transfer to another club [n]\n",
  "WANTED": "WANT, to have a desire for [v]\n",
  "WANTER": "one who wants [n -S]\n",
  "WANTERS": "WANTER, one who wants [n]\n",
  "WANTHILL": "(dialect) a mole [n -S]\n",
  "WANTHILLS": "WANTHILL, (dialect) a mole [n]\n",
  "WANTHRIVEN": "(Scots) stunted, ill-grown [adj]\n",
  "WANTIES": "WANTY, a surcingle, or strap of leather, used for binding a load upon the back of a beast [n]\n",
  "WANTING": "WANT, to have a desire for [v]\n",
  "WANTON": "thoughtlessly cruel [adj WANTONER, WANTONEST, WANTONLY] / to behave in a wanton fashion [v -ED, -ING, -S]\n",
  "WANTONED": "WANTON, to behave in a wanton fashion [v]\n",
  "WANTONER": "one who wantons [n -S]\n",
  "WANTONERS": "WANTONER, one who wantons [n]\n",
  "WANTONEST": "WANTON, thoughtlessly cruel [adj]\n",
  "WANTONING": "WANTON, to behave in a wanton fashion [v]\n",
  "WANTONISE": "(archaic) to play the wanton, also WANTONIZE [v WANTONISED, WANTONISING, WANTONISES]\n",
  "WANTONISED": "WANTONISE, (archaic) to play the wanton, also WANTONIZE [v]\n",
  "WANTONISES": "WANTONISE, (archaic) to play the wanton, also WANTONIZE [v]\n",
  "WANTONISING": "WANTONISE, (archaic) to play the wanton, also WANTONIZE [v]\n",
  "WANTONIZE": "(archaic) to play the wanton, also WANTONISE [v WANTONIZED, WANTONIZING, WANTONIZES]\n",
  "WANTONIZED": "WANTONIZE, (archaic) to play the wanton, also WANTONISE [v]\n",
  "WANTONIZES": "WANTONIZE, (archaic) to play the wanton, also WANTONISE [v]\n",
  "WANTONIZING": "WANTONIZE, (archaic) to play the wanton, also WANTONISE [v]\n",
  "WANTONLY": "WANTON, thoughtlessly cruel [adv]\n",
  "WANTONNESS": "the state of being wanton [n -ES]\n",
  "WANTONNESSES": "WANTONNESS, the state of being wanton [n]\n",
  "WANTONS": "WANTON, to behave in a wanton fashion [v]\n",
  "WANTS": "WANT, to have a desire for [v]\n",
  "WANTY": "a surcingle, or strap of leather, used for binding a load upon the back of a beast [n WANTIES]\n",
  "WANWORDIER": "WANWORDY, (Scots) worthless, unworthy [adj]\n",
  "WANWORDIEST": "WANWORDY, (Scots) worthless, unworthy [adj]\n",
  "WANWORDY": "(Scots) worthless, unworthy [adj WANWORDIER, WANWORDIEST]\n",
  "WANWORTH": "(Scots) a very low price, a bargain [n -S]\n",
  "WANWORTHS": "WANWORTH, (Scots) a very low price, a bargain [n]\n",
  "WANY": "waning in some parts, also WANEY [adj WANIER, WANIEST]\n",
  "WANZE": "(obsolete) to decrease, waste away [v WANZED, WANZING, WANZES]\n",
  "WANZED": "WANZE, (obsolete) to decrease, waste away [v]\n",
  "WANZES": "WANZE, (obsolete) to decrease, waste away [v]\n",
  "WANZING": "WANZE, (obsolete) to decrease, waste away [v]\n",
  "WAP": "to throw or pull quickly [v WAPPED, WAPPING, WAPS]\n",
  "WAPENSCHAW": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n -S]\n",
  "WAPENSCHAWS": "WAPENSCHAW, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n]\n",
  "WAPENSHAW": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n -S]\n",
  "WAPENSHAWS": "WAPENSHAW, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n]\n",
  "WAPENTAKE": "(Old English) an archaic subdivision of certain counties [n -S]\n",
  "WAPENTAKES": "WAPENTAKE, (Old English) an archaic subdivision of certain counties [n]\n",
  "WAPINSCHAW": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n -S]\n",
  "WAPINSCHAWS": "WAPINSCHAW, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n]\n",
  "WAPINSHAW": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n -S]\n",
  "WAPINSHAWS": "WAPINSHAW, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPPENSCHAW, WAPPENSHAW, WAPPENSHAWING [n]\n",
  "WAPITI": "(Native American) a species of large deer native to North America [n -S]\n",
  "WAPITIS": "WAPITI, (Native American) a species of large deer native to North America [n]\n",
  "WAPPED": "WAP, to throw or pull quickly [v]\n",
  "WAPPEND": "(Shakespeare) fatigued, tired [adj]\n",
  "WAPPENSCHAW": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSHAW, WAPPENSHAWING [n -S]\n",
  "WAPPENSCHAWING": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSHAW, WAPPENSHAWING [n -S]\n",
  "WAPPENSCHAWINGS": "WAPPENSCHAWING, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSHAW, WAPPENSHAWING [n]\n",
  "WAPPENSCHAWS": "WAPPENSCHAW, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSHAW, WAPPENSHAWING [n]\n",
  "WAPPENSHAW": "(Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAWING [n -S]\n",
  "WAPPENSHAWING": "(Scots) a gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field when required, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW [n -S]\n",
  "WAPPENSHAWINGS": "WAPPENSHAWING, (Scots) a gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field when required, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAW [n]\n",
  "WAPPENSHAWS": "WAPPENSHAW, (Scots) a periodical gathering of the people within an area for the purpose of seeing that each man was armed according to his rank, and ready to take the field, also WAPENSCHAW, WAPENSHAW, WAPINSCHAW, WAPINSHAW, WAPPENSCHAW, WAPPENSHAWING [n]\n",
  "WAPPER": "to cause to shake; to tremble; to totter [v -ED, -ING, -S]\n",
  "WAPPERED": "WAPPER, to cause to shake; to tremble; to totter [v]\n",
  "WAPPERING": "WAPPER, to cause to shake; to tremble; to totter [v]\n",
  "WAPPERS": "WAPPER, to cause to shake; to tremble; to totter [v]\n",
  "WAPPING": "WAP, to throw or pull quickly [v]\n",
  "WAPS": "WAP, to throw or pull quickly [v]\n",
  "WAQF": "(Arabic) the donation of land, property or money for charitable or pious purposes, also WAKF [n -S]\n",
  "WAQFS": "WAQF, (Arabic) the donation of land, property or money for charitable or pious purposes, also WAKF [n]\n",
  "WAR": "to engage in armed conflict [v WARRED, WARRING, WARS]\n",
  "WARAGI": "a Ugandan alcoholic drink made from bananas [n -S]\n",
  "WARAGIS": "WARAGI, a Ugandan alcoholic drink made from bananas [n]\n",
  "WARATAH": "(Native Australian) any of a genus of Australian proteaceous shrubs with very showy flowers [n -S]\n",
  "WARATAHS": "WARATAH, (Native Australian) any of a genus of Australian proteaceous shrubs with very showy flowers [n]\n",
  "WARB": "(Australian slang) a dirty or insignificant person [n -S]\n",
  "WARBIER": "WARBY, (Australian slang) worn out, decrepit [adj]\n",
  "WARBIEST": "WARBY, (Australian slang) worn out, decrepit [adj]\n",
  "WARBIRD": "a vintage military aircraft, no longer in active use [n -S]\n",
  "WARBIRDS": "WARBIRD, a vintage military aircraft, no longer in active use [n]\n",
  "WARBLE": "to sing with melodic embellishments [v WARBLED, WARBLING, WARBLES]\n",
  "WARBLED": "WARBLE, to sing with melodic embellishments [v]\n",
  "WARBLER": "someone who warbles [n -S]\n",
  "WARBLERS": "WARBLER, someone who warbles [n]\n",
  "WARBLES": "WARBLE, to sing with melodic embellishments [v]\n",
  "WARBLIER": "WARBLY, voiced in a trilling or quavering manner [adj]\n",
  "WARBLIEST": "WARBLY, voiced in a trilling or quavering manner [adj]\n",
  "WARBLING": "making a warbling sound [adj WARBLINGLY] / the act of warbling [n -S]\n",
  "WARBLINGLY": "WARBLING, making a warbling sound [adv]\n",
  "WARBLINGS": "WARBLING, the act of warbling [n]\n",
  "WARBLY": "voiced in a trilling or quavering manner [adj WARBLIER, WARBLIEST]\n",
  "WARBONNET": "a headdress worn by members of certain North American Indian tribes [n -S]\n",
  "WARBONNETS": "WARBONNET, a headdress worn by members of certain North American Indian tribes [n]\n",
  "WARBOT": "any robot or unmanned vehicle or device designed for and used in warfare [n -S]\n",
  "WARBOTS": "WARBOT, any robot or unmanned vehicle or device designed for and used in warfare [n]\n",
  "WARBS": "WARB, (Australian slang) a dirty or insignificant person [n]\n",
  "WARBY": "(Australian slang) worn out, decrepit [adj WARBIER, WARBIEST]\n",
  "WARCHALKER": "one who engages in warchalking, the activity of drawing chalk symbols in public places in order to indicate the location of wireless Internet access points [n -S]\n",
  "WARCHALKERS": "WARCHALKER, one who engages in warchalking, the activity of drawing chalk symbols in public places in order to indicate the location of wireless Internet access points [n]\n",
  "WARCHALKING": "the activity of drawing chalk symbols in public places in order to indicate the location of wireless Internet access points [n -S]\n",
  "WARCHALKINGS": "WARCHALKING, the activity of drawing chalk symbols in public places in order to indicate the location of wireless Internet access points [n]\n",
  "WARCRAFT": "the art of war [n -S]\n",
  "WARCRAFTS": "WARCRAFT, the art of war [n]\n",
  "WARD": "to turn aside [v -ED, -ING, -S]\n",
  "WARDCORN": "a payment in corn [n -S]\n",
  "WARDCORNS": "WARDCORN, a payment in corn [n]\n",
  "WARDED": "WARD, to turn aside [v]\n",
  "WARDEN": "someone who guards or keeps under supervision people, animals, buildings, precious objects, etc. [n -S] / to guard as a warden [v -ED, -ING, -S]\n",
  "WARDENED": "WARDEN, to guard as a warden [v]\n",
  "WARDENING": "WARDEN, to guard as a warden [v]\n",
  "WARDENRIES": "WARDENRY, the office of a warden [n]\n",
  "WARDENRY": "the office of a warden [n WARDENRIES]\n",
  "WARDENS": "WARDEN, to guard as a warden [v]\n",
  "WARDENSHIP": "the office or jurisdiction of a warden [n -S]\n",
  "WARDENSHIPS": "WARDENSHIP, the office or jurisdiction of a warden [n]\n",
  "WARDER": "someone who guards or supervises; a prison officer in charge of prisoners in a jail [n -S] / to guard as a warder [v -ED, -ING, -S]\n",
  "WARDERED": "WARDER, to guard as a warder [v]\n",
  "WARDERING": "WARDER, to guard as a warder [v]\n",
  "WARDERS": "WARDER, to guard as a warder [v]\n",
  "WARDERSHIP": "the office of warder [n -S]\n",
  "WARDERSHIPS": "WARDERSHIP, the office of warder [n]\n",
  "WARDIAN": "as in wardian case, a type of glass case for displaying orchids etc. [adj]\n",
  "WARDING": "the act of keeping guard [n -S]\n",
  "WARDINGS": "WARDING, the act of keeping guard [n]\n",
  "WARDLESS": "without a ward [adj]\n",
  "WARDMOTE": "a meeting of a ward or a court of a ward [n -S]\n",
  "WARDMOTES": "WARDMOTE, a meeting of a ward or a court of a ward [n]\n",
  "WARDOG": "a dog used in war; an old warrior [n -S]\n",
  "WARDOGS": "WARDOG, a dog used in war; an old warrior [n]\n",
  "WARDRESS": "a female warden [n -ES]\n",
  "WARDRESSES": "WARDRESS, a female warden [n]\n",
  "WARDROBE": "a large cupboard for clothes, also WARDROP [n -S] / to keep in a wardrobe [v WARDROBED, WARDROBING, WARDROBES]\n",
  "WARDROBED": "WARDROBE, to keep in a wardrobe [v]\n",
  "WARDROBER": "(historical) a household official in charge of a royal or noble wardrobe [n -S]\n",
  "WARDROBERS": "WARDROBER, (historical) a household official in charge of a royal or noble wardrobe [n]\n",
  "WARDROBES": "WARDROBE, a large cupboard for clothes, also WARDROP [n]\n",
  "WARDROBING": "WARDROBE, to keep in a wardrobe [v]\n",
  "WARDROOM": "an officer's mess-room on a warship [n -S]\n",
  "WARDROOMS": "WARDROOM, an officer's mess-room on a warship [n]\n",
  "WARDROP": "(Milton) a wardrobe [n -S]\n",
  "WARDROPS": "WARDROP, (Milton) a wardrobe [n]\n",
  "WARDS": "WARD, to turn aside [v]\n",
  "WARDSHIP": "the office of a guardian [n -S]\n",
  "WARDSHIPS": "WARDSHIP, the office of a guardian [n]\n",
  "WARE": "to beware of [v WARED, WARING, WARES]\n",
  "WARED": "WARE, to beware of [v]\n",
  "WAREHOU": "(Maori) any of several edible New Zealand fish [n -S]\n",
  "WAREHOUS": "WAREHOU, (Maori) any of several edible New Zealand fish [n]\n",
  "WAREHOUSE": "a building or room for storing goods [n -S] / to store in a warehouse [v WAREHOUSED, WAREHOUSING, WAREHOUSES]\n",
  "WAREHOUSED": "WAREHOUSE, to store in a warehouse [v]\n",
  "WAREHOUSEMAN": "a person who manages or works in a warehouse [n WAREHOUSEMEN]\n",
  "WAREHOUSEMEN": "WAREHOUSEMAN, a person who manages or works in a warehouse [n]\n",
  "WAREHOUSER": "a warehouseman [n -S]\n",
  "WAREHOUSERS": "WAREHOUSER, a warehouseman [n]\n",
  "WAREHOUSES": "WAREHOUSE, to store in a warehouse [v]\n",
  "WAREHOUSING": "storage in a warehouse [n -S]\n",
  "WAREHOUSINGS": "WAREHOUSING, storage in a warehouse [n]\n",
  "WARELESS": "(archaic) unwary; incautious [adj]\n",
  "WAREROOM": "a room for the display of goods [n -S]\n",
  "WAREROOMS": "WAREROOM, a room for the display of goods [n]\n",
  "WARES": "WARE, to beware of [v]\n",
  "WAREZ": "illegally copied computer software which has had its protection codes deactivated [n]\n",
  "WARFARE": "to wage war [v WARFARED, WARFARING, WARFARES]\n",
  "WARFARED": "WARFARE, to wage war [v]\n",
  "WARFARER": "one engaged in warfare [n -S]\n",
  "WARFARERS": "WARFARER, one engaged in warfare [n]\n",
  "WARFARES": "WARFARE, to wage war [v]\n",
  "WARFARIN": "a rat poison [n -S]\n",
  "WARFARING": "the business of waging war [n -S]\n",
  "WARFARINGS": "WARFARING, the business of waging war [n]\n",
  "WARFARINS": "WARFARIN, a rat poison [n]\n",
  "WARGAME": "to engage in simulated military conflicts [v WARGAMED, WARGAMING, WARGAMES]\n",
  "WARGAMED": "WARGAME, to engage in simulated military conflicts [v]\n",
  "WARGAMER": "one who practises wargaming [n -S]\n",
  "WARGAMERS": "WARGAMER, one who practises wargaming [n]\n",
  "WARGAMES": "WARGAME, to engage in simulated military conflicts [v]\n",
  "WARGAMING": "engaging in simulated military conflicts [n -S]\n",
  "WARGAMINGS": "WARGAMING, engaging in simulated military conflicts [n]\n",
  "WARHABLE": "(Spenser) fit for war [adj]\n",
  "WARHEAD": "the explosive part of a missile [n -S]\n",
  "WARHEADS": "WARHEAD, the explosive part of a missile [n]\n",
  "WARHORSE": "a horse used in battle [n -S]\n",
  "WARHORSES": "WARHORSE, a horse used in battle [n]\n",
  "WARIBASHI": "(Japanese) a pair of chopsticks in the form of a single sliver of wood ready scored for splitting in two [n -S]\n",
  "WARIBASHIS": "WARIBASHI, (Japanese) a pair of chopsticks in the form of a single sliver of wood ready scored for splitting in two [n]\n",
  "WARIER": "WARY, cautious [adj]\n",
  "WARIEST": "WARY, cautious [adj]\n",
  "WARILY": "WARY, cautious [adv]\n",
  "WARIMENT": "(Spenser) wariness [n -S]\n",
  "WARIMENTS": "WARIMENT, (Spenser) wariness [n]\n",
  "WARINESS": "the state of being wary [n -ES]\n",
  "WARINESSES": "WARINESS, the state of being wary [n]\n",
  "WARING": "WARE, to beware of [v]\n",
  "WARISON": "(obsolete) a bugle call to attack [n -S]\n",
  "WARISONS": "WARISON, (obsolete) a bugle call to attack [n]\n",
  "WARK": "(Scots) to work [v -ED, -ING, -S]\n",
  "WARKED": "WARK, (Scots) to work [v]\n",
  "WARKING": "WARK, (Scots) to work [v]\n",
  "WARKS": "WARK, (Scots) to work [v]\n",
  "WARLESS": "free from war [adj]\n",
  "WARLIKE": "pertaining to war [adj]\n",
  "WARLIKENESS": "the state of being warlike [n -ES]\n",
  "WARLIKENESSES": "WARLIKENESS, the state of being warlike [n]\n",
  "WARLING": "(obsolete) someone disliked [n -S]\n",
  "WARLINGS": "WARLING, (obsolete) someone disliked [n]\n",
  "WARLOCK": "a sorcerer [n -S]\n",
  "WARLOCKRIES": "WARLOCKRY, sorcery [n]\n",
  "WARLOCKRY": "sorcery [n WARLOCKRIES]\n",
  "WARLOCKS": "WARLOCK, a sorcerer [n]\n",
  "WARLORD": "a military leader [n -S]\n",
  "WARLORDISM": "a system of rule by warlords [n -S]\n",
  "WARLORDISMS": "WARLORDISM, a system of rule by warlords [n]\n",
  "WARLORDS": "WARLORD, a military leader [n]\n",
  "WARM": "moderately hot [adj WARMER, WARMEST, WARMLY] / to make warm [v -ED, -ING, -S]\n",
  "WARMAKER": "one who makes war [n -S]\n",
  "WARMAKERS": "WARMAKER, one who makes war [n]\n",
  "WARMAN": "a warrior [n WARMEN]\n",
  "WARMBLOOD": "one of a race of horses developed from pedigree bloodlines from native American mares [n -S]\n",
  "WARMBLOODS": "WARMBLOOD, one of a race of horses developed from pedigree bloodlines from native American mares [n]\n",
  "WARMED": "WARM, to make warm [v]\n",
  "WARMEN": "WARMAN, a warrior [n]\n",
  "WARMER": "something that warms [n -S]\n",
  "WARMERS": "WARMER, something that warms [n]\n",
  "WARMEST": "WARM, moderately hot [adj]\n",
  "WARMHEARTED": "marked by ready affection, cordiality, generosity, or sympathy [adj]\n",
  "WARMHEARTEDNESS": "the state of being warmhearted [n]\n",
  "WARMING": "the action of making warm [n -S]\n",
  "WARMINGS": "WARMING, the action of making warm [n]\n",
  "WARMISH": "somewhat warm [adj]\n",
  "WARMIST": "a person, esp. a scientist, who believes in global warming and the greenhouse effect [n -S]\n",
  "WARMISTS": "WARMIST, a person, esp. a scientist, who believes in global warming and the greenhouse effect [n]\n",
  "WARMLY": "WARM, moderately hot [adv]\n",
  "WARMNESS": "the state of being warm [n -ES]\n",
  "WARMNESSES": "WARMNESS, the state of being warm [n]\n",
  "WARMONGER": "one who delights in making war [n -S]\n",
  "WARMONGERING": "the making of war [n -S]\n",
  "WARMONGERINGS": "WARMONGERING, the making of war [n]\n",
  "WARMONGERS": "WARMONGER, one who delights in making war [n]\n",
  "WARMOUTH": "an American freshwater bream [n -S]\n",
  "WARMOUTHS": "WARMOUTH, an American freshwater bream [n]\n",
  "WARMS": "WARM, to make warm [v]\n",
  "WARMTH": "warmness [n -S]\n",
  "WARMTHS": "WARMTH, warmness [n]\n",
  "WARMUP": "a sportsman's pretraining routine [n -S]\n",
  "WARMUPS": "WARMUP, a sportsman's pretraining routine [n]\n",
  "WARN": "to notify in advance [v -ED, -ING, -S]\n",
  "WARNED": "WARN, to notify in advance [v]\n",
  "WARNER": "one who warns [n -S]\n",
  "WARNERS": "WARNER, one who warns [n]\n",
  "WARNING": "giving a warning [adj WARNINGLY] / the act of warning [n -S]\n",
  "WARNINGLY": "WARNING, giving a warning [adv]\n",
  "WARNINGS": "WARNING, the act of warning [n]\n",
  "WARNS": "WARN, to notify in advance [v]\n",
  "WARP": "to twist out of shape [v -ED, -ING, -S]\n",
  "WARPAGE": "the act of warping [n -S]\n",
  "WARPAGES": "WARPAGE, the act of warping [n]\n",
  "WARPAINT": "paint used to decorate the face and body before battle [n -S]\n",
  "WARPAINTS": "WARPAINT, paint used to decorate the face and body before battle [n]\n",
  "WARPATH": "the path followed on a military expedition [n -S]\n",
  "WARPATHS": "WARPATH, the path followed on a military expedition [n]\n",
  "WARPED": "WARP, to twist out of shape [v]\n",
  "WARPER": "one who, or that which, warps [n -S]\n",
  "WARPERS": "WARPER, one who, or that which, warps [n]\n",
  "WARPING": "the act of warping [n -S]\n",
  "WARPINGS": "WARPING, the act of warping [n]\n",
  "WARPLANE": "an aeroplane armed for combat [n -S]\n",
  "WARPLANES": "WARPLANE, an aeroplane armed for combat [n]\n",
  "WARPOWER": "the power to make war [n -S]\n",
  "WARPOWERS": "WARPOWER, the power to make war [n]\n",
  "WARPS": "WARP, to twist out of shape [v]\n",
  "WARPWISE": "in a vertical direction [adv]\n",
  "WARRAGAL": "(Native Australian) the Australian wild dog, the dingo, also WARRAGLE, WARRAGUL, WARRIGAL [n -S]\n",
  "WARRAGALS": "WARRAGAL, (Native Australian) the Australian wild dog, the dingo, also WARRAGLE, WARRAGUL, WARRIGAL [n]\n",
  "WARRAGLE": "(Native Australian) the Australian wild dog, the dingo, also WARRAGAL, WARRAGUL, WARRIGAL [n -S]\n",
  "WARRAGLES": "WARRAGLE, (Native Australian) the Australian wild dog, the dingo, also WARRAGAL, WARRAGUL, WARRIGAL [n]\n",
  "WARRAGUL": "(Native Australian) the Australian wild dog, the dingo, also WARRAGAL, WARRAGLE, WARRIGAL [n -S]\n",
  "WARRAGULS": "WARRAGUL, (Native Australian) the Australian wild dog, the dingo, also WARRAGAL, WARRAGLE, WARRIGAL [n]\n",
  "WARRAN": "(obsolete) to warrant, also WARRAND [v -ED, -ING, -S]\n",
  "WARRAND": "(obsolete) to warrant, also WARRAN [v -ED, -ING, -S]\n",
  "WARRANDED": "WARRAND, (obsolete) to warrant, also WARRAN [v]\n",
  "WARRANDICE": "a guarantee; a clause in a deed by which the grantor binds himself or herself to make good to the grantee the right conveyed [n -S]\n",
  "WARRANDICES": "WARRANDICE, a guarantee; a clause in a deed by which the grantor binds himself or herself to make good to the grantee the right conveyed [n]\n",
  "WARRANDING": "WARRAND, (obsolete) to warrant, also WARRAN [v]\n",
  "WARRANDS": "WARRAND, (obsolete) to warrant, also WARRAN [v]\n",
  "WARRANED": "WARRAN, (obsolete) to warrant, also WARRAND [v]\n",
  "WARRANING": "WARRAN, (obsolete) to warrant, also WARRAND [v]\n",
  "WARRANS": "WARRAN, (obsolete) to warrant, also WARRAND [v]\n",
  "WARRANT": "to give authority to, also WARRAN, WARRAND [v -ED, -ING, -S]\n",
  "WARRANTABILITY": "the quality of being warrantable [n]\n",
  "WARRANTABLE": "that can be warranted [adj]\n",
  "WARRANTABLENESS": "the state of being warrantable [n]\n",
  "WARRANTABLY": "WARRANTABLE, that can be warranted [adv]\n",
  "WARRANTED": "WARRANT, to give authority to, also WARRAN, WARRAND [v]\n",
  "WARRANTEE": "the person to whom a warrant or warranty is made [n -S]\n",
  "WARRANTEES": "WARRANTEE, the person to whom a warrant or warranty is made [n]\n",
  "WARRANTER": "one who warrants, also WARRANTOR [n -S]\n",
  "WARRANTERS": "WARRANTER, one who warrants, also WARRANTOR [n]\n",
  "WARRANTIED": "WARRANTY, to guarantee [v]\n",
  "WARRANTIES": "WARRANTY, to guarantee [v]\n",
  "WARRANTING": "the act of warranting [n -S]\n",
  "WARRANTINGS": "WARRANTING, the act of warranting [n]\n",
  "WARRANTISE": "(archaic) to guarantee the security of (land) to a person, also WARRANTIZE [v WARRANTISED, WARRANTISING, WARRANTISES]\n",
  "WARRANTISED": "WARRANTISE, (archaic) to guarantee the security of (land) to a person, also WARRANTIZE [v]\n",
  "WARRANTISES": "WARRANTISE, (archaic) to guarantee the security of (land) to a person, also WARRANTIZE [v]\n",
  "WARRANTISING": "WARRANTISE, (archaic) to guarantee the security of (land) to a person, also WARRANTIZE [v]\n",
  "WARRANTIZE": "to guarantee the security of (land) to a person, also WARRANTISE [v WARRANTIZED, WARRANTIZING, WARRANTIZES]\n",
  "WARRANTIZED": "WARRANTIZE, to guarantee the security of (land) to a person, also WARRANTISE [v]\n",
  "WARRANTIZES": "WARRANTIZE, to guarantee the security of (land) to a person, also WARRANTISE [v]\n",
  "WARRANTIZING": "WARRANTIZE, to guarantee the security of (land) to a person, also WARRANTISE [v]\n",
  "WARRANTLESS": "without a warrant [adj]\n",
  "WARRANTOR": "one who warrants, also WARRANTER [n -S]\n",
  "WARRANTORS": "WARRANTOR, one who warrants, also WARRANTER [n]\n",
  "WARRANTS": "WARRANT, to give authority to, also WARRAN, WARRAND [v]\n",
  "WARRANTY": "the act of warranting [n WARRANTIES] / to guarantee [v WARRANTIED, WARRANTYING, WARRANTIES]\n",
  "WARRANTYING": "WARRANTY, to guarantee [v]\n",
  "WARRAY": "(obsolete) to make war on, also WARREY [v -ED, -ING, -S]\n",
  "WARRAYED": "WARRAY, (obsolete) to make war on, also WARREY [v]\n",
  "WARRAYING": "WARRAY, (obsolete) to make war on, also WARREY [v]\n",
  "WARRAYS": "WARRAY, (obsolete) to make war on, also WARREY [v]\n",
  "WARRE": "(Spenser) worse [adj]\n",
  "WARRED": "WAR, to engage in armed conflict [v]\n",
  "WARREN": "a rabbit's home [n -S]\n",
  "WARRENER": "the keeper of a warren [n -S]\n",
  "WARRENERS": "WARRENER, the keeper of a warren [n]\n",
  "WARRENS": "WARREN, a rabbit's home [n]\n",
  "WARREY": "(obsolete) to make war on, also WARRAY [v -ED, -ING, -S]\n",
  "WARREYED": "WARREY, (obsolete) to make war on, also WARRAY [v]\n",
  "WARREYING": "WARREY, (obsolete) to make war on, also WARRAY [v]\n",
  "WARREYS": "WARREY, (obsolete) to make war on, also WARRAY [v]\n",
  "WARRIGAL": "(Native Australian) the Australian wild dog, the dingo, also WARRAGAL, WARRAGLE, WARRAGUL [n -S]\n",
  "WARRIGALS": "WARRIGAL, (Native Australian) the Australian wild dog, the dingo, also WARRAGAL, WARRAGLE, WARRAGUL [n]\n",
  "WARRING": "WAR, to engage in armed conflict [v]\n",
  "WARRIOR": "a soldier experienced in warfare [n -S]\n",
  "WARRIORESS": "a female warrior [n -ES]\n",
  "WARRIORESSES": "WARRIORESS, a female warrior [n]\n",
  "WARRIORS": "WARRIOR, a soldier experienced in warfare [n]\n",
  "WARRISON": "(obsolete) reward, punishment [n -S]\n",
  "WARRISONS": "WARRISON, (obsolete) reward, punishment [n]\n",
  "WARS": "WAR, to engage in armed conflict [v]\n",
  "WARSAW": "a marine fish, the black grouper of the southern coasts of the United States [n -S]\n",
  "WARSAWS": "WARSAW, a marine fish, the black grouper of the southern coasts of the United States [n]\n",
  "WARSHIP": "a ship armed for combat [n -S]\n",
  "WARSHIPS": "WARSHIP, a ship armed for combat [n]\n",
  "WARSLE": "to wrestle, also RASSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v WARSLED, WARSLING, WARSLES]\n",
  "WARSLED": "WARSLE, to wrestle, also RASSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WARSLER": "one who takes part in hand to hand contests, also WRESTLER, WARSTLER [n -S]\n",
  "WARSLERS": "WARSLER, one who takes part in hand to hand contests, also WRESTLER, WARSTLER [n]\n",
  "WARSLES": "WARSLE, to wrestle, also RASSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WARSLING": "WARSLE, to wrestle, also RASSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WARST": "(Scots) worst, also WAURST [adj]\n",
  "WARSTLE": "to wrestle, also RASSLE, WARSLE, WRASSLE, WRASTLE, WRAXLE [v WARSTLED, WARSTLING, WARSTLES]\n",
  "WARSTLED": "WARSTLE, to wrestle, also RASSLE, WARSLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WARSTLER": "one who takes part in hand to hand contests, also WRESTLER, WARSLER [n -S]\n",
  "WARSTLERS": "WARSTLER, one who takes part in hand to hand contests, also WRESTLER, WARSLER [n]\n",
  "WARSTLES": "WARSTLE, to wrestle, also RASSLE, WARSLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WARSTLING": "WARSTLE, to wrestle, also RASSLE, WARSLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WART": "a hard growth on the skin [n -S]\n",
  "WARTED": "having a wart [adj]\n",
  "WARTHOG": "an African wild hog [n -S]\n",
  "WARTHOGS": "WARTHOG, an African wild hog [n]\n",
  "WARTIER": "WARTY, covered with warts [adj]\n",
  "WARTIEST": "WARTY, covered with warts [adj]\n",
  "WARTIME": "a time of war [n -S]\n",
  "WARTIMES": "WARTIME, a time of war [n]\n",
  "WARTLESS": "without warts [adj]\n",
  "WARTLIKE": "like a wart [adj]\n",
  "WARTS": "WART, a hard growth on the skin [n]\n",
  "WARTWEED": "any of a family of lichens having warty thalluses [n -S]\n",
  "WARTWEEDS": "WARTWEED, any of a family of lichens having warty thalluses [n]\n",
  "WARTWORT": "a kind of spurge, the juice of which was thought to be a cure for warts [n -S]\n",
  "WARTWORTS": "WARTWORT, a kind of spurge, the juice of which was thought to be a cure for warts [n]\n",
  "WARTY": "covered with warts [adj WARTIER, WARTIEST]\n",
  "WARWOLF": "a mediaeval siege engine [n WARWOLVES]\n",
  "WARWOLVES": "WARWOLF, a mediaeval siege engine [n]\n",
  "WARWORK": "work done during the war [n -S]\n",
  "WARWORKS": "WARWORK, work done during the war [n]\n",
  "WARWORN": "worn with military service; as, a warworn soldier [adj]\n",
  "WARY": "cautious [adj WARIER, WARIEST, WARILY]\n",
  "WARZONE": "a region of armed conflict [n -S]\n",
  "WARZONES": "WARZONE, a region of armed conflict [n]\n",
  "WAS": "BE, to exist [v]\n",
  "WASABI": "(Japanese) horseradish, much used in Japanese cooking as a condiment [n -S]\n",
  "WASABIS": "WASABI, (Japanese) horseradish, much used in Japanese cooking as a condiment [n]\n",
  "WASE": "a small bundle of hay or straw for resting one's head [n -S]\n",
  "WASES": "WASE, a small bundle of hay or straw for resting one's head [n]\n",
  "WASH": "to cleanse in liquid [v WASHED, (obsolete) WASHEN, WASHING, WASHES]\n",
  "WASHABILITIES": "WASHABILITY, the quality of being washable [n]\n",
  "WASHABILITY": "the quality of being washable [n WASHABILITIES]\n",
  "WASHABLE": "something that can be washed [n -S]\n",
  "WASHABLES": "WASHABLE, something that can be washed [n]\n",
  "WASHATERIA": "a laundrette, also WASHETERIA [n -S]\n",
  "WASHATERIAS": "WASHATERIA, a laundrette, also WASHETERIA [n]\n",
  "WASHAWAY": "an erosion of the earth's surface due to running water [n -S]\n",
  "WASHAWAYS": "WASHAWAY, an erosion of the earth's surface due to running water [n]\n",
  "WASHBAG": "a small bag for carrying toiletries when travelling [n -S]\n",
  "WASHBAGS": "WASHBAG, a small bag for carrying toiletries when travelling [n]\n",
  "WASHBALL": "a ball of toilet-soap [n -S]\n",
  "WASHBALLS": "WASHBALL, a ball of toilet-soap [n]\n",
  "WASHBASIN": "a basin to wash one's hands and face in [n -S]\n",
  "WASHBASINS": "WASHBASIN, a basin to wash one's hands and face in [n]\n",
  "WASHBOARD": "a broad thin plank along a ship's gunwale to keep out sea water [n -S]\n",
  "WASHBOARDS": "WASHBOARD, a broad thin plank along a ship's gunwale to keep out sea water [n]\n",
  "WASHBOWL": "a bowl used for washing items [n -S]\n",
  "WASHBOWLS": "WASHBOWL, a bowl used for washing items [n]\n",
  "WASHCLOTH": "a piece of cloth used in washing, a dishcloth [n -S]\n",
  "WASHCLOTHS": "WASHCLOTH, a piece of cloth used in washing, a dishcloth [n]\n",
  "WASHDAY": "a day on which one washes clothes [n -S]\n",
  "WASHDAYS": "WASHDAY, a day on which one washes clothes [n]\n",
  "WASHDOWN": "the act of washing (oneself or something) down [n -S]\n",
  "WASHDOWNS": "WASHDOWN, the act of washing (oneself or something) down [n]\n",
  "WASHED": "WASH, to cleanse in liquid [v]\n",
  "WASHEN": "WASH, to cleanse in liquid [v]\n",
  "WASHER": "to fit with a washer or small valve [v -ED, -ING, -S]\n",
  "WASHERED": "WASHER, to fit with a washer or small valve [v]\n",
  "WASHERIES": "WASHERY, a washhouse [n]\n",
  "WASHERING": "WASHER, to fit with a washer or small valve [v]\n",
  "WASHERMAN": "a man who washes clothes, esp. for hire, or for others [n WASHERMEN]\n",
  "WASHERMEN": "WASHERMAN, a man who washes clothes, esp. for hire, or for others [n]\n",
  "WASHERS": "WASHER, to fit with a washer or small valve [v]\n",
  "WASHERWOMAN": "a woman whose occupation is washing clothes, also WASHWOMAN [n WASHERWOMEN]\n",
  "WASHERWOMEN": "WASHERWOMAN, a woman whose occupation is washing clothes, also WASHWOMAN [n]\n",
  "WASHERY": "a washhouse [n WASHERIES]\n",
  "WASHES": "WASH, to cleanse in liquid [v]\n",
  "WASHETERIA": "a laundrette, also WASHATERIA [n -S]\n",
  "WASHETERIAS": "WASHETERIA, a laundrette, also WASHATERIA [n]\n",
  "WASHFAST": "that can be washed without losing colour or dye [adj]\n",
  "WASHHAND": "as in washhand basin [adj]\n",
  "WASHHOUSE": "an outbuilding for washing, esp. one for washing clothes [n -S]\n",
  "WASHHOUSES": "WASHHOUSE, an outbuilding for washing, esp. one for washing clothes [n]\n",
  "WASHIER": "WASHY, watery, damp [adj]\n",
  "WASHIEST": "WASHY, watery, damp [adj]\n",
  "WASHILY": "overly diluted [adv]\n",
  "WASHIN": "design of the leading edge of an aircraft wing a little higher [n -S]\n",
  "WASHINESS": "the state of being washy [n -ES]\n",
  "WASHINESSES": "WASHINESS, the state of being washy [n]\n",
  "WASHING": "articles washed or to be washed [n -S]\n",
  "WASHINGS": "WASHING, articles washed or to be washed [n]\n",
  "WASHINGTONIA": "another name for the sequoia [n -S]\n",
  "WASHINGTONIAS": "WASHINGTONIA, another name for the sequoia [n]\n",
  "WASHINS": "WASHIN, design of the leading edge of an aircraft wing a little higher [n]\n",
  "WASHLAND": "an area of land flooded by a river [n -S]\n",
  "WASHLANDS": "WASHLAND, an area of land flooded by a river [n]\n",
  "WASHOUT": "an erosion of earth by water [n -S]\n",
  "WASHOUTS": "WASHOUT, an erosion of earth by water [n]\n",
  "WASHPOT": "a vessel for washing [n -S]\n",
  "WASHPOTS": "WASHPOT, a vessel for washing [n]\n",
  "WASHRAG": "(US) a facecloth, a flannel [n -S]\n",
  "WASHRAGS": "WASHRAG, (US) a facecloth, a flannel [n]\n",
  "WASHROOM": "a room, esp. in a factory or office block, in which lavatories, washbasins, etc., are situated [n -S]\n",
  "WASHROOMS": "WASHROOM, a room, esp. in a factory or office block, in which lavatories, washbasins, etc., are situated [n]\n",
  "WASHSTAND": "a stand holding a washbowl [n -S]\n",
  "WASHSTANDS": "WASHSTAND, a stand holding a washbowl [n]\n",
  "WASHTUB": "a tub used for washing clothes [n -S]\n",
  "WASHTUBS": "WASHTUB, a tub used for washing clothes [n]\n",
  "WASHUP": "the act of washing clean [n -S]\n",
  "WASHUPS": "WASHUP, the act of washing clean [n]\n",
  "WASHWIPE": "a mechanism for washing [n -S]\n",
  "WASHWIPES": "WASHWIPE, a mechanism for washing [n]\n",
  "WASHWOMAN": "a woman who does laundry, also WASHERWOMAN [n WASHWOMEN]\n",
  "WASHWOMEN": "WASHWOMAN, a woman who does laundry, also WASHERWOMAN [n]\n",
  "WASHY": "watery, damp [adj WASHIER, WASHIEST, WASHILY]\n",
  "WASM": "an obsolete belief; an out-of-fashion 'ism' [n -S]\n",
  "WASMS": "WASM, an obsolete belief; an out-of-fashion 'ism' [n]\n",
  "WASP": "a stinging insect [n -S]\n",
  "WASPIE": "a ladies' corset [n -S]\n",
  "WASPIER": "WASPY, like a wasp, waspish [adj]\n",
  "WASPIES": "WASPIE, a ladies' corset [n]\n",
  "WASPIEST": "WASPY, like a wasp, waspish [adj]\n",
  "WASPILY": "WASPY, like a wasp, waspish [adv]\n",
  "WASPINESS": "the state of being waspy [n -ES]\n",
  "WASPINESSES": "WASPINESS, the state of being waspy [n]\n",
  "WASPISH": "like a wasp; acid-tongued [adj WASPISHLY]\n",
  "WASPISHLY": "WASPISH, like a wasp; acid-tongued [adv]\n",
  "WASPISHNESS": "the state of being waspish [n -ES]\n",
  "WASPISHNESSES": "WASPISHNESS, the state of being waspish [n]\n",
  "WASPLIKE": "like a wasp [adj]\n",
  "WASPNEST": "the nest of a wasp [n -S]\n",
  "WASPNESTS": "WASPNEST, the nest of a wasp [n]\n",
  "WASPS": "WASP, a stinging insect [n]\n",
  "WASPY": "like a wasp, waspish [adj WASPIER, WASPIEST, WASPILY]\n",
  "WASSAIL": "to go carolling or carousing [v -ED, -ING, -S]\n",
  "WASSAILED": "WASSAIL, to go carolling or carousing [v]\n",
  "WASSAILER": "one who wassails [n -S]\n",
  "WASSAILERS": "WASSAILER, one who wassails [n]\n",
  "WASSAILING": "(historical) the holding of a wassail [n -S]\n",
  "WASSAILINGS": "WASSAILING, (historical) the holding of a wassail [n]\n",
  "WASSAILRIES": "WASSAILRY, the act of wassailing [n]\n",
  "WASSAILRY": "the act of wassailing [n WASSAILRIES]\n",
  "WASSAILS": "WASSAIL, to go carolling or carousing [v]\n",
  "WASSERMAN": "(German) a man-shaped sea monster [n WASSERMEN]\n",
  "WASSERMEN": "WASSERMAN, (German) a man-shaped sea monster [n]\n",
  "WASSUP": "(colloquial) what's up [interj]\n",
  "WAST": "(US) west [n -S]\n",
  "WASTABLE": "capable of being wasted [adj]\n",
  "WASTAGE": "something that is wasted [n -S]\n",
  "WASTAGES": "WASTAGE, something that is wasted [n]\n",
  "WASTE": "to consume lavishly or thoughtlessly, also WAST [v WASTED, WASTING, WASTES]\n",
  "WASTEBASKET": "a basket or bin for holding discarded paper and other rubbish [n -S]\n",
  "WASTEBASKETS": "WASTEBASKET, a basket or bin for holding discarded paper and other rubbish [n]\n",
  "WASTEBIN": "a rubbish bin [n -S]\n",
  "WASTEBINS": "WASTEBIN, a rubbish bin [n]\n",
  "WASTED": "WASTE, to consume lavishly or thoughtlessly, also WAST [v]\n",
  "WASTEFUL": "tending to waste, also WASTFULL [adj WASTEFULLY]\n",
  "WASTEFULLY": "WASTEFUL, tending to waste, also WASTFULL [adv]\n",
  "WASTEFULNESS": "the state of being wasteful [n -ES]\n",
  "WASTEFULNESSES": "WASTEFULNESS, the state of being wasteful [n]\n",
  "WASTEL": "bread made from the finest flour [n -S]\n",
  "WASTELAND": "a desolate, barren area [n -S]\n",
  "WASTELANDS": "WASTELAND, a desolate, barren area [n]\n",
  "WASTELOT": "an unused lot of land in a built-up area [n -S]\n",
  "WASTELOTS": "WASTELOT, an unused lot of land in a built-up area [n]\n",
  "WASTELS": "WASTEL, bread made from the finest flour [n]\n",
  "WASTENESS": "the state of being waste, also WASTNESS [n -ES]\n",
  "WASTENESSES": "WASTENESS, the state of being waste, also WASTNESS [n]\n",
  "WASTEPAPER": "paper discarded as used, superfluous, or not fit for use [n -S]\n",
  "WASTEPAPERS": "WASTEPAPER, paper discarded as used, superfluous, or not fit for use [n]\n",
  "WASTER": "(Scots) to spend prodigally [v -ED, -ING, -S]\n",
  "WASTERED": "WASTER, (Scots) to spend prodigally [v]\n",
  "WASTERFUL": "(Scots) extravagant [adj WASTERFULLY]\n",
  "WASTERFULLY": "WASTERFUL, (Scots) extravagant [adv]\n",
  "WASTERFULNESS": "the state of being wasterful [n -ES]\n",
  "WASTERFULNESSES": "WASTERFULNESS, the state of being wasterful [n]\n",
  "WASTERIE": "reckless extravagance, also WASTERY, WASTRIE, WASTRY [n -S]\n",
  "WASTERIES": "WASTERIE, reckless extravagance, also WASTERY, WASTRIE, WASTRY [n]\n",
  "WASTERING": "WASTER, (Scots) to spend prodigally [v]\n",
  "WASTERS": "WASTER, (Scots) to spend prodigally [v]\n",
  "WASTERY": "reckless extravagance, also WASTERIE, WASTRIE, WASTRY [n WASTERIES]\n",
  "WASTES": "WASTE, to consume lavishly or thoughtlessly, also WAST [v]\n",
  "WASTEWATER": "waste water [n -S]\n",
  "WASTEWATERS": "WASTEWATER, waste water [n]\n",
  "WASTEWAY": "a channel for excess water [n -S]\n",
  "WASTEWAYS": "WASTEWAY, a channel for excess water [n]\n",
  "WASTEWEIR": "a sluiceway or passage for superfluous water in a reservoir, to prevent too great pressure on the dam, aka a spillway [n -S]\n",
  "WASTEWEIRS": "WASTEWEIR, a sluiceway or passage for superfluous water in a reservoir, to prevent too great pressure on the dam, aka a spillway [n]\n",
  "WASTFULL": "(obsolete) wasteful [adj]\n",
  "WASTING": "of an illness etc., causing emaciation, destructive of body tissues [adj WASTINGLY] / the act of wasting [n -S]\n",
  "WASTINGLY": "WASTING, of an illness etc., causing emaciation, destructive of body tissues [adv]\n",
  "WASTINGS": "WASTING, the act of wasting [n]\n",
  "WASTNESS": "(obsolete) the state of being waste, also WASTENESS [n -ES]\n",
  "WASTNESSES": "WASTNESS, (obsolete) the state of being waste, also WASTENESS [n]\n",
  "WASTREL": "a wasteful person, a spendthrift [n -S]\n",
  "WASTRELS": "WASTREL, a wasteful person, a spendthrift [n]\n",
  "WASTRIE": "reckless extravagance, also WASTERIE, WASTERY, WASTRY [n -S]\n",
  "WASTRIES": "WASTRY, reckless extravagance, also WASTERIE, WASTERY, WASTRIE [n]\n",
  "WASTRIFE": "(Scots) wastefulness [n -S]\n",
  "WASTRIFES": "WASTRIFE, (Scots) wastefulness [n]\n",
  "WASTRY": "reckless extravagance, also WASTERIE, WASTERY, WASTRIE [n WASTRIES]\n",
  "WASTS": "WAST, (US) west [n]\n",
  "WAT": "wet [adj WATTER, WATTEST] / a Thai Buddhist temple or monastery [n -S]\n",
  "WATAP": "(Native American) a fibre or thread made by some North American Indian peoples from the split roots of conifers, esp. white spruce, also WATAPE, WATTAPE [n -S]\n",
  "WATAPE": "(Native American) a fibre or thread made by some North American Indian peoples from the split roots of conifers, esp. white spruce, also WATAP, WATTAPE [n -S]\n",
  "WATAPES": "WATAPE, (Native American) a fibre or thread made by some North American Indian peoples from the split roots of conifers, esp. white spruce, also WATAP, WATTAPE [n]\n",
  "WATAPS": "WATAP, (Native American) a fibre or thread made by some North American Indian peoples from the split roots of conifers, esp. white spruce, also WATAPE, WATTAPE [n]\n",
  "WATCH": "to keep in view [v -ED, -ING, -ES]\n",
  "WATCHA": "(colloquial) what are you, used as a greeting, also WHATCHA, WOTCHA, WOTCHER [interj]\n",
  "WATCHABLE": "worth watching [adj] / something worth watching [n -S]\n",
  "WATCHABLES": "WATCHABLE, something worth watching [n]\n",
  "WATCHBAND": "a band on which a watch is worn [n -S]\n",
  "WATCHBANDS": "WATCHBAND, a band on which a watch is worn [n]\n",
  "WATCHBOX": "a sentry box [n -ES]\n",
  "WATCHBOXES": "WATCHBOX, a sentry box [n]\n",
  "WATCHCASE": "the case housing the mechanism of a watch [n -S]\n",
  "WATCHCASES": "WATCHCASE, the case housing the mechanism of a watch [n]\n",
  "WATCHCRIES": "WATCHCRY, a password [n]\n",
  "WATCHCRY": "a password [n WATCHCRIES]\n",
  "WATCHDOG": "one who keeps a lookout [n -S] / to act as a watchdog for [v WATCHDOGGED, WATCHDOGGING, WATCHDOGS]\n",
  "WATCHDOGGED": "WATCHDOG, to act as a watchdog for [v]\n",
  "WATCHDOGGING": "acting as a watchdog [n -S]\n",
  "WATCHDOGGINGS": "WATCHDOGGING, acting as a watchdog [n]\n",
  "WATCHDOGS": "WATCHDOG, to act as a watchdog for [v]\n",
  "WATCHED": "WATCH, to keep in view [v]\n",
  "WATCHER": "one who watches [n -S]\n",
  "WATCHERS": "WATCHER, one who watches [n]\n",
  "WATCHES": "WATCH, to keep in view [v]\n",
  "WATCHET": "(archaic) a pale blue material [n -S]\n",
  "WATCHETS": "WATCHET, (archaic) a pale blue material [n]\n",
  "WATCHEYE": "an eye in which the iris is pale or whitish, also WALLEYE [n -S]\n",
  "WATCHEYES": "WATCHEYE, an eye in which the iris is pale or whitish, also WALLEYE [n]\n",
  "WATCHFUL": "closely observant or alert [adj WATCHFULLY]\n",
  "WATCHFULLY": "WATCHFUL, closely observant or alert [adv]\n",
  "WATCHFULNESS": "the state of being watchful [n -ES]\n",
  "WATCHFULNESSES": "WATCHFULNESS, the state of being watchful [n]\n",
  "WATCHGLASS": "a small dish used for holding small amounts of a solution [n -ES]\n",
  "WATCHGLASSES": "WATCHGLASS, a small dish used for holding small amounts of a solution [n]\n",
  "WATCHGUARD": "a chain or strap used to attach a watch to the clothing [n -S]\n",
  "WATCHGUARDS": "WATCHGUARD, a chain or strap used to attach a watch to the clothing [n]\n",
  "WATCHING": "WATCH, to keep in view [v]\n",
  "WATCHLIST": "a list of things to be monitored [n -S]\n",
  "WATCHLISTS": "WATCHLIST, a list of things to be monitored [n]\n",
  "WATCHMAKER": "one that makes or repairs watches or clocks [n -S]\n",
  "WATCHMAKERS": "WATCHMAKER, one that makes or repairs watches or clocks [n]\n",
  "WATCHMAKING": "the profession of making watches [n -S]\n",
  "WATCHMAKINGS": "WATCHMAKING, the profession of making watches [n]\n",
  "WATCHMAN": "a man employed to stand guard [n WATCHMEN]\n",
  "WATCHMEN": "WATCHMAN, a man employed to stand guard [n]\n",
  "WATCHOUT": "the act of keeping a look out for something [n -S]\n",
  "WATCHOUTS": "WATCHOUT, the act of keeping a look out for something [n]\n",
  "WATCHSPRING": "the spring of a watch [n -S]\n",
  "WATCHSPRINGS": "WATCHSPRING, the spring of a watch [n]\n",
  "WATCHSTRAP": "the strap of a watch [n -S]\n",
  "WATCHSTRAPS": "WATCHSTRAP, the strap of a watch [n]\n",
  "WATCHTOWER": "a tower for a lookout [n -S]\n",
  "WATCHTOWERS": "WATCHTOWER, a tower for a lookout [n]\n",
  "WATCHWORD": "the password to be given to a watch or sentry [n -S]\n",
  "WATCHWORDS": "WATCHWORD, the password to be given to a watch or sentry [n]\n",
  "WATE": "(Scots) 3rd person of wit, to know [v]\n",
  "WATER": "to sprinkle with a transparent, odourless, tasteless liquid [v -ED, -ING, -S]\n",
  "WATERAGE": "conveyance of goods by water [n -S]\n",
  "WATERAGES": "WATERAGE, conveyance of goods by water [n]\n",
  "WATERBED": "a bed filled with water [n -S]\n",
  "WATERBEDS": "WATERBED, a bed filled with water [n]\n",
  "WATERBIRD": "a bird that leaves on or near water [n -S]\n",
  "WATERBIRDS": "WATERBIRD, a bird that leaves on or near water [n]\n",
  "WATERBOARDING": "a form of torture in which the victim is immobilized and has water poured on his or her face, producing a severe gag reflex, to simulate drowning [n -S]\n",
  "WATERBOARDINGS": "WATERBOARDING, a form of torture in which the victim is immobilized and has water poured on his or her face, producing a severe gag reflex, to simulate drowning [n]\n",
  "WATERBORNE": "supported, carried, or transmitted by water [adj]\n",
  "WATERBRAIN": "a disease of sheep, aka gid [n -S]\n",
  "WATERBRAINS": "WATERBRAIN, a disease of sheep, aka gid [n]\n",
  "WATERBUCK": "any of several kinds of antelope, native to Central Africa [n -S]\n",
  "WATERBUCKS": "WATERBUCK, any of several kinds of antelope, native to Central Africa [n]\n",
  "WATERBUS": "a large motorboat for carrying passengers [n WATERBUSES or WATERBUSSES]\n",
  "WATERBUSES": "WATERBUS, a large motorboat for carrying passengers [n]\n",
  "WATERBUSSES": "WATERBUS, a large motorboat for carrying passengers [n]\n",
  "WATERCOLOR": "a pigment diluted with water and gum (or other substance) instead of oil; a painting done in this, also WATERCOLOUR [n -S]\n",
  "WATERCOLORIST": "an artist who paints in watercolour, also WATERCOLOURIST [n -S]\n",
  "WATERCOLORISTS": "WATERCOLORIST, an artist who paints in watercolour, also WATERCOLOURIST [n]\n",
  "WATERCOLORS": "WATERCOLOR, a pigment diluted with water and gum (or other substance) instead of oil; a painting done in this, also WATERCOLOUR [n]\n",
  "WATERCOLOUR": "a pigment diluted with water and gum (or other substance) instead of oil; a painting done in this, also WATERCOLOR [n -S]\n",
  "WATERCOLOURIST": "an artist who works with watercolour, also WATERCOLORIST [n -S]\n",
  "WATERCOLOURISTS": "WATERCOLOURIST, an artist who works with watercolour, also WATERCOLORIST [n]\n",
  "WATERCOLOURS": "WATERCOLOUR, a pigment diluted with water and gum (or other substance) instead of oil; a painting done in this, also WATERCOLOR [n]\n",
  "WATERCOOLER": "a device for dispensing refrigerated drinking water [n -S]\n",
  "WATERCOOLERS": "WATERCOOLER, a device for dispensing refrigerated drinking water [n]\n",
  "WATERCOURSE": "a natural or artificial channel through which water flows [n -S]\n",
  "WATERCOURSES": "WATERCOURSE, a natural or artificial channel through which water flows [n]\n",
  "WATERCRAFT": "a boat; boats collectively [n -S]\n",
  "WATERCRAFTS": "WATERCRAFT, a boat; boats collectively [n]\n",
  "WATERCRESS": "any of several aquatic or semiaquatic cresses [n -ES]\n",
  "WATERCRESSES": "WATERCRESS, any of several aquatic or semiaquatic cresses [n]\n",
  "WATERDOG": "a large salamander [n -S]\n",
  "WATERDOGS": "WATERDOG, a large salamander [n]\n",
  "WATERDRIVE": "the use of water pressure to drive things [n -S]\n",
  "WATERDRIVES": "WATERDRIVE, the use of water pressure to drive things [n]\n",
  "WATERED": "WATER, to sprinkle with a transparent, odourless, tasteless liquid [v]\n",
  "WATERER": "a device for watering [n -S]\n",
  "WATERERS": "WATERER, a device for watering [n]\n",
  "WATERFALL": "a fall or perpendicular descent of a body of water [n -S]\n",
  "WATERFALLS": "WATERFALL, a fall or perpendicular descent of a body of water [n]\n",
  "WATERFINDER": "one who finds subterranean springs or supplies of water by means of a divining-rod; a dowser [n -S]\n",
  "WATERFINDERS": "WATERFINDER, one who finds subterranean springs or supplies of water by means of a divining-rod; a dowser [n]\n",
  "WATERFLOOD": "a flood of water; an inundation [n -S] / to inject water to maintain pressure in a reservoir and to drive the oil etc. towards the production wells [v -ED, -ING, -S]\n",
  "WATERFLOODED": "WATERFLOOD, to inject water to maintain pressure in a reservoir and to drive the oil etc. towards the production wells [v]\n",
  "WATERFLOODING": "the practice, in oil, gas or petroleum production, of injecting water to maintain pressure in a reservoir and to drive the oil, etc. towards the production wells [n -S]\n",
  "WATERFLOODINGS": "WATERFLOODING, the practice, in oil, gas or petroleum production, of injecting water to maintain pressure in a reservoir and to drive the oil, etc. towards the production wells [n]\n",
  "WATERFLOODS": "WATERFLOOD, a flood of water; an inundation [n]\n",
  "WATERFOWL": "any bird that frequents the water [n -S]\n",
  "WATERFOWLER": "one who hunts waterfowl [n -S]\n",
  "WATERFOWLERS": "WATERFOWLER, one who hunts waterfowl [n]\n",
  "WATERFOWLING": "the sport of shooting waterfowl [n -S]\n",
  "WATERFOWLINGS": "WATERFOWLING, the sport of shooting waterfowl [n]\n",
  "WATERFOWLS": "WATERFOWL, any bird that frequents the water [n]\n",
  "WATERFRONT": "land with buildings, or a section of a town fronting or abutting on a body of water [n -S]\n",
  "WATERFRONTS": "WATERFRONT, land with buildings, or a section of a town fronting or abutting on a body of water [n]\n",
  "WATERGATE": "a gate of a town or castle opening on to a lake, river, or sea [n -S]\n",
  "WATERGATES": "WATERGATE, a gate of a town or castle opening on to a lake, river, or sea [n]\n",
  "WATERGLASS": "a water clock; an instrument for making observations underwater [n -ES]\n",
  "WATERGLASSES": "WATERGLASS, a water clock; an instrument for making observations underwater [n]\n",
  "WATERHEAD": "the source of a river [n -S]\n",
  "WATERHEADS": "WATERHEAD, the source of a river [n]\n",
  "WATERHEN": "the gallinule or moorhen [n -S]\n",
  "WATERHENS": "WATERHEN, the gallinule or moorhen [n]\n",
  "WATERHOLE": "a hollow or depression in which water collects [n -S]\n",
  "WATERHOLES": "WATERHOLE, a hollow or depression in which water collects [n]\n",
  "WATERIER": "WATERY, like water [adj]\n",
  "WATERIEST": "WATERY, like water [adj]\n",
  "WATERILY": "WATERY, like water [adv]\n",
  "WATERINESS": "the state of being watery [n -ES]\n",
  "WATERINESSES": "WATERINESS, the state of being watery [n]\n",
  "WATERING": "the act of watering [n -S]\n",
  "WATERINGS": "WATERING, the act of watering [n]\n",
  "WATERISH": "somewhat watery [adj]\n",
  "WATERISHNESS": "the state of being waterish [n -ES]\n",
  "WATERISHNESSES": "WATERISHNESS, the state of being waterish [n]\n",
  "WATERJET": "a stream of water forced through a small opening [n -S]\n",
  "WATERJETS": "WATERJET, a stream of water forced through a small opening [n]\n",
  "WATERLEAF": "any plant of the American genus Hydrophyllum, herbs having white or pale blue bell-shaped flowers [n WATERLEAFS or WATERLEAVES]\n",
  "WATERLEAFS": "WATERLEAF, any plant of the American genus Hydrophyllum, herbs having white or pale blue bell-shaped flowers [n]\n",
  "WATERLEAVES": "WATERLEAF, any plant of the American genus Hydrophyllum, herbs having white or pale blue bell-shaped flowers [n]\n",
  "WATERLESS": "without water [adj]\n",
  "WATERLESSNESS": "the state of being waterless [n -ES]\n",
  "WATERLESSNESSES": "WATERLESSNESS, the state of being waterless [n]\n",
  "WATERLILIES": "WATERLILY, a name commonly given to the different species of Nymphaea and Nuphar [n]\n",
  "WATERLILY": "a name commonly given to the different species of Nymphaea and Nuphar [n WATERLILIES]\n",
  "WATERLINE": "any of several lines on a ship to which it is submerged under different conditions of loading [n -S]\n",
  "WATERLINES": "WATERLINE, any of several lines on a ship to which it is submerged under different conditions of loading [n]\n",
  "WATERLOG": "to soak with water [v WATERLOGGED, WATERLOGGING, WATERLOGS]\n",
  "WATERLOGGED": "WATERLOG, to soak with water [v]\n",
  "WATERLOGGING": "saturation with water [n -S]\n",
  "WATERLOGGINGS": "WATERLOGGING, saturation with water [n]\n",
  "WATERLOGS": "WATERLOG, to soak with water [v]\n",
  "WATERLOO": "a decisive defeat [n -S]\n",
  "WATERLOOS": "WATERLOO, a decisive defeat [n]\n",
  "WATERMAN": "a boatman or ferryman [n WATERMEN]\n",
  "WATERMANSHIP": "the business, skill, or art of a waterman [n -S]\n",
  "WATERMANSHIPS": "WATERMANSHIP, the business, skill, or art of a waterman [n]\n",
  "WATERMARK": "a distinguishing mark in paper [n -S] / to mark with a watermark [v -ED, -ING, -S]\n",
  "WATERMARKED": "WATERMARK, to mark with a watermark [v]\n",
  "WATERMARKING": "WATERMARK, to mark with a watermark [v]\n",
  "WATERMARKS": "WATERMARK, to mark with a watermark [v]\n",
  "WATERMELON": "a type of melon [n -S]\n",
  "WATERMELONS": "WATERMELON, a type of melon [n]\n",
  "WATERMEN": "WATERMAN, a boatman or ferryman [n]\n",
  "WATERMILL": "a mill driven by water [n -S]\n",
  "WATERMILLS": "WATERMILL, a mill driven by water [n]\n",
  "WATERPOWER": "the power of water employed to move machinery [n -S]\n",
  "WATERPOWERS": "WATERPOWER, the power of water employed to move machinery [n]\n",
  "WATERPOX": "chickenpox [n -ES]\n",
  "WATERPOXES": "WATERPOX, chickenpox [n]\n",
  "WATERPROOF": "proof against water [n -S] / to make waterproof [v -ED, -ING, -S]\n",
  "WATERPROOFED": "WATERPROOF, to make waterproof [v]\n",
  "WATERPROOFER": "one who waterproofs [n -S]\n",
  "WATERPROOFERS": "WATERPROOFER, one who waterproofs [n]\n",
  "WATERPROOFING": "the act of making waterproof; material that does this [n -S]\n",
  "WATERPROOFINGS": "WATERPROOFING, the act of making waterproof; material that does this [n]\n",
  "WATERPROOFNESS": "the state of being waterproof [n]\n",
  "WATERPROOFS": "WATERPROOF, to make waterproof [v]\n",
  "WATERQUAKE": "a seismic disturbance affecting the sea [n -S]\n",
  "WATERQUAKES": "WATERQUAKE, a seismic disturbance affecting the sea [n]\n",
  "WATERS": "WATER, to sprinkle with a transparent, odourless, tasteless liquid [v]\n",
  "WATERSCAPE": "a sea view [n -S]\n",
  "WATERSCAPES": "WATERSCAPE, a sea view [n]\n",
  "WATERSHED": "the area which a river and its tributaries drain [n -S]\n",
  "WATERSHEDS": "WATERSHED, the area which a river and its tributaries drain [n]\n",
  "WATERSIDE": "the edge of a sea, lake, etc., a shore [n -S]\n",
  "WATERSIDER": "(Australian) a wharf labourer [n -S]\n",
  "WATERSIDERS": "WATERSIDER, (Australian) a wharf labourer [n]\n",
  "WATERSIDES": "WATERSIDE, the edge of a sea, lake, etc., a shore [n]\n",
  "WATERSKI": "a ski for skiing on water [n -S]\n",
  "WATERSKIING": "the sport of skiing on water [n -S]\n",
  "WATERSKIINGS": "WATERSKIING, the sport of skiing on water [n]\n",
  "WATERSKIS": "WATERSKI, a ski for skiing on water [n]\n",
  "WATERSMEET": "the confluence of two streams [n -S]\n",
  "WATERSMEETS": "WATERSMEET, the confluence of two streams [n]\n",
  "WATERSPOUT": "a disturbance at sea like a very small tornado, a revolving column of cloud, mist or spray [n -S]\n",
  "WATERSPOUTS": "WATERSPOUT, a disturbance at sea like a very small tornado, a revolving column of cloud, mist or spray [n]\n",
  "WATERTHRUSH": "a species of American warbler [n -ES]\n",
  "WATERTHRUSHES": "WATERTHRUSH, a species of American warbler [n]\n",
  "WATERTIGHT": "so well-sealed as not to admit water or let it escape [adj]\n",
  "WATERTIGHTNESS": "the state of being watertight [n]\n",
  "WATERWAY": "a navigable body of water [n -S]\n",
  "WATERWAYS": "WATERWAY, a navigable body of water [n]\n",
  "WATERWEED": "any plant with very small flowers and leaves growing in ponds, etc. esp. anacharis [n -S]\n",
  "WATERWEEDS": "WATERWEED, any plant with very small flowers and leaves growing in ponds, etc. esp. anacharis [n]\n",
  "WATERWHEEL": "a wheel made to rotate by direct action of water [n -S]\n",
  "WATERWHEELS": "WATERWHEEL, a wheel made to rotate by direct action of water [n]\n",
  "WATERWORK": "a piece of fabric painted to resemble a tapestry [n -S]\n",
  "WATERWORKS": "WATERWORK, a piece of fabric painted to resemble a tapestry [n]\n",
  "WATERWORN": "worn smooth by water [adj]\n",
  "WATERY": "like water [adj WATERIER, WATERIEST, WATERILY]\n",
  "WATERZOOI": "a stew of fish or chicken and vegetables in a seasoned stock thickened with cream and egg yolks [n -S]\n",
  "WATERZOOIS": "WATERZOOI, a stew of fish or chicken and vegetables in a seasoned stock thickened with cream and egg yolks [n]\n",
  "WATS": "WAT, a Thai Buddhist temple or monastery [n]\n",
  "WATT": "the SI unit of power, equal to a rate of working of one joule per second [n -S]\n",
  "WATTAGE": "an amount of power expressed in watts [n -S]\n",
  "WATTAGES": "WATTAGE, an amount of power expressed in watts [n]\n",
  "WATTAPE": "(Native American) a fibre or thread made by some North American Indian peoples from the split roots of conifers, esp. white spruce, also WATAP, WATAPE [n -S]\n",
  "WATTAPES": "WATTAPE, (Native American) a fibre or thread made by some North American Indian peoples from the split roots of conifers, esp. white spruce, also WATAP, WATAPE [n]\n",
  "WATTER": "WAT, wet [adj]\n",
  "WATTEST": "WAT, wet [adj]\n",
  "WATTHOUR": "a unit of energy [n -S]\n",
  "WATTHOURS": "WATTHOUR, a unit of energy [n]\n",
  "WATTLE": "material for fences, roofs, etc., in the form of rods and branches, etc. [n -S] / to construct with wattle [v WATTLED, WATTLING, WATTLES]\n",
  "WATTLEBARK": "the bark of various acacias, used for tanning [n -S]\n",
  "WATTLEBARKS": "WATTLEBARK, the bark of various acacias, used for tanning [n]\n",
  "WATTLEBIRD": "any one of several species of the honey eater bird [n -S]\n",
  "WATTLEBIRDS": "WATTLEBIRD, any one of several species of the honey eater bird [n]\n",
  "WATTLED": "WATTLE, to construct with wattle [v]\n",
  "WATTLES": "WATTLE, to construct with wattle [v]\n",
  "WATTLESS": "denoting a type of electric current [adj]\n",
  "WATTLEWORK": "wickerwork [n -S]\n",
  "WATTLEWORKS": "WATTLEWORK, wickerwork [n]\n",
  "WATTLING": "the act of making wattles by interweaving twigs etc. [n -S]\n",
  "WATTLINGS": "WATTLING, the act of making wattles by interweaving twigs etc. [n]\n",
  "WATTMETER": "an instrument for measuring electrical power [n -S]\n",
  "WATTMETERS": "WATTMETER, an instrument for measuring electrical power [n]\n",
  "WATTS": "WATT, the SI unit of power, equal to a rate of working of one joule per second [n]\n",
  "WAUCHT": "(Scots) to drink in large draughts, also WAUGHT [v -ED, -ING, -S]\n",
  "WAUCHTED": "WAUCHT, (Scots) to drink in large draughts, also WAUGHT [v]\n",
  "WAUCHTING": "WAUCHT, (Scots) to drink in large draughts, also WAUGHT [v]\n",
  "WAUCHTS": "WAUCHT, (Scots) to drink in large draughts, also WAUGHT [v]\n",
  "WAUFF": "(Scots) to wave [v -ED, -ING, -S]\n",
  "WAUFFED": "WAUFF, (Scots) to wave [v]\n",
  "WAUFFING": "WAUFF, (Scots) to wave [v]\n",
  "WAUFFS": "WAUFF, (Scots) to wave [v]\n",
  "WAUGH": "to bark, also WAFF [v -ED, -ING, -S]\n",
  "WAUGHED": "WAUGH, to bark, also WAFF [v]\n",
  "WAUGHING": "WAUGH, to bark, also WAFF [v]\n",
  "WAUGHS": "WAUGH, to bark, also WAFF [v]\n",
  "WAUGHT": "(Scots) to drink in large draughts, also WAUCHT [v -ED, -ING, -S]\n",
  "WAUGHTED": "WAUGHT, (Scots) to drink in large draughts, also WAUCHT [v]\n",
  "WAUGHTING": "WAUGHT, (Scots) to drink in large draughts, also WAUCHT [v]\n",
  "WAUGHTS": "WAUGHT, (Scots) to drink in large draughts, also WAUCHT [v]\n",
  "WAUK": "to full (cloth), also WAULK [v -ED, -ING, -S]\n",
  "WAUKED": "WAUK, to full (cloth), also WAULK [v]\n",
  "WAUKER": "a fuller of cloth, also WAULKER [n -S]\n",
  "WAUKERS": "WAUKER, a fuller of cloth, also WAULKER [n]\n",
  "WAUKING": "WAUK, to full (cloth), also WAULK [v]\n",
  "WAUKMILL": "a fulling-mill, also WALKMILL, WAULKMILL [n -S]\n",
  "WAUKMILLS": "WAUKMILL, a fulling-mill, also WALKMILL, WAULKMILL [n]\n",
  "WAUKRIFE": "(Scots) wakeful, vigilant, also WAKERIFE [adj]\n",
  "WAUKS": "WAUK, to full (cloth), also WAULK [v]\n",
  "WAUL": "to cry like a cat, also WAWL, WRAWL [v -ED, -ING, -S]\n",
  "WAULED": "WAUL, to cry like a cat, also WAWL, WRAWL [v]\n",
  "WAULING": "the act of crying like a cat, also WAWLING [n -S]\n",
  "WAULINGS": "WAULING, the act of crying like a cat, also WAWLING [n]\n",
  "WAULK": "to full (cloth), also WAUK [v -ED, -ING, -S]\n",
  "WAULKED": "WAULK, to full (cloth), also WAUK [v]\n",
  "WAULKER": "a fuller of cloth, also WAUKER [n -S]\n",
  "WAULKERS": "WAULKER, a fuller of cloth, also WAUKER [n]\n",
  "WAULKING": "WAULK, to full (cloth), also WAUK [v]\n",
  "WAULKMILL": "a fulling-mill, also WALKMILL, WAUKMILL [n -S]\n",
  "WAULKMILLS": "WAULKMILL, a fulling-mill, also WALKMILL, WAUKMILL [n]\n",
  "WAULKS": "WAULK, to full (cloth), also WAUK [v]\n",
  "WAULS": "WAUL, to cry like a cat, also WAWL, WRAWL [v]\n",
  "WAUR": "(Scots) worse, also WARRE [adj] / to defeat, to worst [v -ED, -ING, -S]\n",
  "WAURED": "WAUR, to defeat, to worst [v]\n",
  "WAURING": "WAUR, to defeat, to worst [v]\n",
  "WAURS": "WAUR, to defeat, to worst [v]\n",
  "WAURST": "(Scots) worst, also WARST [adj]\n",
  "WAVE": "to flutter back and forth [v WAVED, WAVING, WAVES]\n",
  "WAVEBAND": "a range of radio frequencies [n -S]\n",
  "WAVEBANDS": "WAVEBAND, a range of radio frequencies [n]\n",
  "WAVED": "WAVE, to flutter back and forth [v]\n",
  "WAVEFORM": "a type of mathematical graph [n -S]\n",
  "WAVEFORMS": "WAVEFORM, a type of mathematical graph [n]\n",
  "WAVEFRONT": "in a propagating vibratory disturbance, the continuous locus of points which are in the same phase of vibration [n -S]\n",
  "WAVEFRONTS": "WAVEFRONT, in a propagating vibratory disturbance, the continuous locus of points which are in the same phase of vibration [n]\n",
  "WAVEGUIDE": "in electronics, a hollow metal conductor through which high-frequency energy can be propagated efficiently [n -S]\n",
  "WAVEGUIDES": "WAVEGUIDE, in electronics, a hollow metal conductor through which high-frequency energy can be propagated efficiently [n]\n",
  "WAVELENGTH": "the distance in the line of advance of a wave from any one point to the next point of corresponding phase [n -S]\n",
  "WAVELENGTHS": "WAVELENGTH, the distance in the line of advance of a wave from any one point to the next point of corresponding phase [n]\n",
  "WAVELESS": "having no waves [adj WAVELESSLY]\n",
  "WAVELESSLY": "WAVELESS, having no waves [adv]\n",
  "WAVELET": "a small wave [n -S]\n",
  "WAVELETS": "WAVELET, a small wave [n]\n",
  "WAVELIKE": "resembling a wave [adj]\n",
  "WAVELLITE": "hydrated phosphate of aluminium, occurring commonly in flattened globular aggregates [n -S]\n",
  "WAVELLITES": "WAVELLITE, hydrated phosphate of aluminium, occurring commonly in flattened globular aggregates [n]\n",
  "WAVEMETER": "an instrument for measuring wavelengths [n -S]\n",
  "WAVEMETERS": "WAVEMETER, an instrument for measuring wavelengths [n]\n",
  "WAVEOFF": "the act of denying landing rights to an aircraft [n -S]\n",
  "WAVEOFFS": "WAVEOFF, the act of denying landing rights to an aircraft [n]\n",
  "WAVER": "to move to and fro [v -ED, -ING, -S]\n",
  "WAVERED": "WAVER, to move to and fro [v]\n",
  "WAVERER": "one who wavers [n -S]\n",
  "WAVERERS": "WAVERER, one who wavers [n]\n",
  "WAVERIER": "WAVERY, unsteady [adj]\n",
  "WAVERIEST": "WAVERY, unsteady [adj]\n",
  "WAVERING": "vacillating [adj WAVERINGLY] / the act of wavering [n -S]\n",
  "WAVERINGLY": "WAVERING, vacillating [adv]\n",
  "WAVERINGNESS": "the state of being wavering [n -ES]\n",
  "WAVERINGNESSES": "WAVERINGNESS, the state of being wavering [n]\n",
  "WAVERINGS": "WAVERING, the act of wavering [n]\n",
  "WAVEROUS": "unsteady [adj]\n",
  "WAVERS": "WAVER, to move to and fro [v]\n",
  "WAVERY": "unsteady [adj WAVERIER, WAVERIEST]\n",
  "WAVES": "WAVE, to flutter back and forth [v]\n",
  "WAVESHAPE": "a graph showing the variation in amplitude of any signal propagated as a wave [n -S]\n",
  "WAVESHAPES": "WAVESHAPE, a graph showing the variation in amplitude of any signal propagated as a wave [n]\n",
  "WAVESON": "goods floating after a shipwreck [n -S]\n",
  "WAVESONS": "WAVESON, goods floating after a shipwreck [n]\n",
  "WAVETABLE": "a collection of digitized samples of recorded sound stored as sound waves [n -S]\n",
  "WAVETABLES": "WAVETABLE, a collection of digitized samples of recorded sound stored as sound waves [n]\n",
  "WAVEY": "(Canadian) the snow goose, also WAVY [n -S]\n",
  "WAVEYS": "WAVEY, (Canadian) the snow goose, also WAVY [n]\n",
  "WAVICLE": "a subatomic particle that can act like both a wave and a particle [n -S]\n",
  "WAVICLES": "WAVICLE, a subatomic particle that can act like both a wave and a particle [n]\n",
  "WAVIER": "WAVY, having waves [adj]\n",
  "WAVIES": "WAVY, the snow goose, also WAVEY [n]\n",
  "WAVIEST": "WAVY, having waves [adj]\n",
  "WAVILY": "WAVY, having waves [adv]\n",
  "WAVINESS": "the state of being wavy [n -ES]\n",
  "WAVINESSES": "WAVINESS, the state of being wavy [n]\n",
  "WAVING": "the act of waving [n -S]\n",
  "WAVINGS": "WAVING, the act of waving [n]\n",
  "WAVY": "having waves [adj WAVIER, WAVIEST] / the snow goose, also WAVEY [n WAVIES]\n",
  "WAW": "(Scott) a wave, also WAWE [n -S]\n",
  "WAWA": "(Native American) to speak [v -ED, -ING, -S]\n",
  "WAWAED": "WAWA, (Native American) to speak [v]\n",
  "WAWAING": "WAWA, (Native American) to speak [v]\n",
  "WAWAS": "WAWA, (Native American) to speak [v]\n",
  "WAWE": "(Spenser) a wave, also WAW [n -S]\n",
  "WAWES": "WAWE, (Spenser) a wave, also WAW [n]\n",
  "WAWL": "to cry like a cat, also WAUL, WRAWL [v -ED, -ING, -S]\n",
  "WAWLED": "WAWL, to cry like a cat, also WAUL, WRAWL [v]\n",
  "WAWLING": "the act of crying like a cat, also WAULING [n -S]\n",
  "WAWLINGS": "WAWLING, the act of crying like a cat, also WAULING [n]\n",
  "WAWLS": "WAWL, to cry like a cat, also WAUL, WRAWL [v]\n",
  "WAWS": "WAW, (Scott) a wave, also WAWE [n]\n",
  "WAX": "a fatty substance [n -ES] / to treat with wax [v -ED, -ING, -ES] / to grow larger, also WEX, WEXE [v WAXED or (obsolete) WOX or WOXEN, WAXING, WAXES]\n",
  "WAXABLE": "able to be waxed [adj]\n",
  "WAXBERRIES": "WAXBERRY, a berry [n]\n",
  "WAXBERRY": "a berry [n WAXBERRIES]\n",
  "WAXBILL": "any of numerous small finch-like birds of the African genus Estrilda, whose bills have a waxy appearance [n -S]\n",
  "WAXBILLS": "WAXBILL, any of numerous small finch-like birds of the African genus Estrilda, whose bills have a waxy appearance [n]\n",
  "WAXCLOTH": "oilcloth, linoleum [n -S]\n",
  "WAXCLOTHS": "WAXCLOTH, oilcloth, linoleum [n]\n",
  "WAXED": "WAX, to treat with wax [v]\n",
  "WAXEN": "made of wax; resembling wax [adj]\n",
  "WAXER": "one who waxes [n -S]\n",
  "WAXERS": "WAXER, one who waxes [n]\n",
  "WAXES": "WAX, to treat with wax [v]\n",
  "WAXEYE": "a small New Zealand bird with a white circle round its eye, aka tauhou [n -S]\n",
  "WAXEYES": "WAXEYE, a small New Zealand bird with a white circle round its eye, aka tauhou [n]\n",
  "WAXFLOWER": "any of various plants with waxy flowers [n -S]\n",
  "WAXFLOWERS": "WAXFLOWER, any of various plants with waxy flowers [n]\n",
  "WAXIER": "WAXY, like wax [adj]\n",
  "WAXIEST": "WAXY, like wax [adj]\n",
  "WAXILY": "WAXY, like wax [adv]\n",
  "WAXINESS": "the quality of being waxy [n -ES]\n",
  "WAXINESSES": "WAXINESS, the quality of being waxy [n]\n",
  "WAXING": "the act of one that waxes [n -S]\n",
  "WAXINGS": "WAXING, the act of one that waxes [n]\n",
  "WAXLIKE": "resembling wax [adj]\n",
  "WAXPLANT": "any of several plants of the genus Hoya, with clusters of waxy white or pink flowers [n -S]\n",
  "WAXPLANTS": "WAXPLANT, any of several plants of the genus Hoya, with clusters of waxy white or pink flowers [n]\n",
  "WAXWEED": "an annual herb [n -S]\n",
  "WAXWEEDS": "WAXWEED, an annual herb [n]\n",
  "WAXWING": "a member of a genus of passerine birds, which have red waxlike tips to the inner wing feathers [n -S]\n",
  "WAXWINGS": "WAXWING, a member of a genus of passerine birds, which have red waxlike tips to the inner wing feathers [n]\n",
  "WAXWORK": "an effigy in wax [n -S]\n",
  "WAXWORKER": "one who works in wax [n -S]\n",
  "WAXWORKERS": "WAXWORKER, one who works in wax [n]\n",
  "WAXWORKS": "WAXWORK, an effigy in wax [n]\n",
  "WAXWORM": "a moth that infests beehives [n -S]\n",
  "WAXWORMS": "WAXWORM, a moth that infests beehives [n]\n",
  "WAXY": "like wax [adj WAXIER, WAXIEST, WAXILY]\n",
  "WAY": "(Spenser) to weigh, esteem [v -ED, -ING, -S]\n",
  "WAYANG": "(Javanese) a type of Indonesian theatre featuring puppets or human dancers [n -S]\n",
  "WAYANGS": "WAYANG, (Javanese) a type of Indonesian theatre featuring puppets or human dancers [n]\n",
  "WAYBACK": "the area in the back of a vehicle [n -S]\n",
  "WAYBACKS": "WAYBACK, the area in the back of a vehicle [n]\n",
  "WAYBILL": "a list of goods for shipping [n -S]\n",
  "WAYBILLS": "WAYBILL, a list of goods for shipping [n]\n",
  "WAYBOARD": "a thin geological seam separating larger strata, also WEIGHBOARD [n -S]\n",
  "WAYBOARDS": "WAYBOARD, a thin geological seam separating larger strata, also WEIGHBOARD [n]\n",
  "WAYBREAD": "the common dooryard plantain [n -S]\n",
  "WAYBREADS": "WAYBREAD, the common dooryard plantain [n]\n",
  "WAYED": "WAY, (Spenser) to weigh, esteem [v]\n",
  "WAYFARE": "(archaic) to fare on one's way [v WAYFARED, WAYFARING, WAYFARES]\n",
  "WAYFARED": "WAYFARE, (archaic) to fare on one's way [v]\n",
  "WAYFARER": "a traveller [n -S]\n",
  "WAYFARERS": "WAYFARER, a traveller [n]\n",
  "WAYFARES": "WAYFARE, (archaic) to fare on one's way [v]\n",
  "WAYFARING": "travelling [n -S]\n",
  "WAYFARINGS": "WAYFARING, travelling [n]\n",
  "WAYGOING": "(Scots) a departing [n -S]\n",
  "WAYGOINGS": "WAYGOING, (Scots) a departing [n]\n",
  "WAYGONE": "exhausted by travel [adj]\n",
  "WAYGOOSE": "an annual employees' dinner or outing, also WAYZGOOSE [n -S]\n",
  "WAYGOOSES": "WAYGOOSE, an annual employees' dinner or outing, also WAYZGOOSE [n]\n",
  "WAYING": "WAY, (Spenser) to weigh, esteem [v]\n",
  "WAYLAID": "WAYLAY, to ambush [v]\n",
  "WAYLAY": "to ambush [v WAYLAID, WAYLAYING, WAYLAYS]\n",
  "WAYLAYER": "one who waylays [n -S]\n",
  "WAYLAYERS": "WAYLAYER, one who waylays [n]\n",
  "WAYLAYING": "WAYLAY, to ambush [v]\n",
  "WAYLAYS": "WAYLAY, to ambush [v]\n",
  "WAYLEAVE": "permission to pass over property [n -S]\n",
  "WAYLEAVES": "WAYLEAVE, permission to pass over property [n]\n",
  "WAYLEGGO": "(New Zealand) a shepherd's call to his dog [interj]\n",
  "WAYLESS": "having no path [adj]\n",
  "WAYMARK": "a mark showing the way [n -S] / to mark with a waymark [v -ED, -ING, -S]\n",
  "WAYMARKED": "WAYMARK, to mark with a waymark [v]\n",
  "WAYMARKING": "WAYMARK, to mark with a waymark [v]\n",
  "WAYMARKS": "WAYMARK, to mark with a waymark [v]\n",
  "WAYMENT": "(Spenser) to lament, grieve [v -ED, -ING, -S]\n",
  "WAYMENTED": "WAYMENT, (Spenser) to lament, grieve [v]\n",
  "WAYMENTING": "WAYMENT, (Spenser) to lament, grieve [v]\n",
  "WAYMENTS": "WAYMENT, (Spenser) to lament, grieve [v]\n",
  "WAYPOINT": "a point between major points on a route [n -S]\n",
  "WAYPOINTS": "WAYPOINT, a point between major points on a route [n]\n",
  "WAYPOST": "a guidepost [n -S]\n",
  "WAYPOSTS": "WAYPOST, a guidepost [n]\n",
  "WAYS": "WAY, (Spenser) to weigh, esteem [v]\n",
  "WAYSIDE": "the side of the road [n -S]\n",
  "WAYSIDES": "WAYSIDE, the side of the road [n]\n",
  "WAYWARD": "wilful [adj WAYWARDLY]\n",
  "WAYWARDLY": "WAYWARD, wilful [adv]\n",
  "WAYWARDNESS": "the state of being wayward [n -ES]\n",
  "WAYWARDNESSES": "WAYWARDNESS, the state of being wayward [n]\n",
  "WAYWISER": "an instrument for measuring distance travelled [n -S]\n",
  "WAYWISERS": "WAYWISER, an instrument for measuring distance travelled [n]\n",
  "WAYWODE": "(Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIVODE, WAIWODE, WOIWODE [n -S]\n",
  "WAYWODES": "WAYWODE, (Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIVODE, WAIWODE, WOIWODE [n]\n",
  "WAYWORN": "fatigued by travel [adj]\n",
  "WAYZGOOSE": "an annual employees' dinner or outing, also WAYGOOSE [n -S]\n",
  "WAYZGOOSES": "WAYZGOOSE, an annual employees' dinner or outing, also WAYGOOSE [n]\n",
  "WAZ": "(dialect) to urinate, also WAZZ [v WAZZED, WAZZING, WAZZES]\n",
  "WAZIR": "(Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIER, VIZIR, WIZIER [n -S]\n",
  "WAZIRS": "WAZIR, (Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIER, VIZIR, WIZIER [n]\n",
  "WAZOO": "(slang) a person's bottom [n -S]\n",
  "WAZOOS": "WAZOO, (slang) a person's bottom [n]\n",
  "WAZZ": "(dialect) to urinate, also WAZ [v -ED, -ING, -ES]\n",
  "WAZZED": "WAZZ, (dialect) to urinate, also WAZ [v]\n",
  "WAZZES": "WAZZ, (dialect) to urinate, also WAZ [v]\n",
  "WAZZING": "WAZZ, (dialect) to urinate, also WAZ [v]\n",
  "WAZZOCK": "(dialect) a pathetic person [n -S]\n",
  "WAZZOCKS": "WAZZOCK, (dialect) a pathetic person [n]\n",
  "WE": "the first person plural pronoun [pron]\n",
  "WEAK": "feeble [adj WEAKER, WEAKEST, WEAKLY]\n",
  "WEAKEN": "to make weak [v -ED, -ING, -S]\n",
  "WEAKENED": "WEAKEN, to make weak [v]\n",
  "WEAKENER": "something or someone that weakens [n -S]\n",
  "WEAKENERS": "WEAKENER, something or someone that weakens [n]\n",
  "WEAKENING": "the act of making weak [n -S]\n",
  "WEAKENINGS": "WEAKENING, the act of making weak [n]\n",
  "WEAKENS": "WEAKEN, to make weak [v]\n",
  "WEAKER": "WEAK, feeble [adj]\n",
  "WEAKEST": "WEAK, feeble [adj]\n",
  "WEAKFISH": "(Dutch) a kind of fish caught off the Atlantic coast of North America, aka seatrout [n -ES]\n",
  "WEAKFISHES": "WEAKFISH, (Dutch) a kind of fish caught off the Atlantic coast of North America, aka seatrout [n]\n",
  "WEAKHEARTED": "feeble, fainthearted [adj]\n",
  "WEAKISH": "somewhat weak [adj WEAKISHLY]\n",
  "WEAKISHLY": "WEAKISH, somewhat weak [adv]\n",
  "WEAKISHNESS": "the state of being weakish [n -ES]\n",
  "WEAKISHNESSES": "WEAKISHNESS, the state of being weakish [n]\n",
  "WEAKLIER": "WEAKLY, weak and sickly [adj]\n",
  "WEAKLIEST": "WEAKLY, weak and sickly [adj]\n",
  "WEAKLINESS": "the state of being weakly [n -ES]\n",
  "WEAKLINESSES": "WEAKLINESS, the state of being weakly [n]\n",
  "WEAKLING": "a weak person [n -S]\n",
  "WEAKLINGS": "WEAKLING, a weak person [n]\n",
  "WEAKLY": "weak and sickly [adj WEAKLIER, WEAKLIEST]\n",
  "WEAKNESS": "the state of being weak [n -ES]\n",
  "WEAKNESSES": "WEAKNESS, the state of being weak [n]\n",
  "WEAKON": "a subatomic particle [n -S]\n",
  "WEAKONS": "WEAKON, a subatomic particle [n]\n",
  "WEAKSIDE": "someone's weak point, the side on which they are most liable to temptation [n -S]\n",
  "WEAKSIDES": "WEAKSIDE, someone's weak point, the side on which they are most liable to temptation [n]\n",
  "WEAL": "a ridge on the skin formed by a blow, also WALE, WHEAL [n -S]\n",
  "WEALD": "a woodland [n -S]\n",
  "WEALDS": "WEALD, a woodland [n]\n",
  "WEALS": "WEAL, a ridge on the skin formed by a blow, also WALE, WHEAL [n]\n",
  "WEALSMAN": "(Shakespeare) a statesman; a politician [n WEALSMEN]\n",
  "WEALSMEN": "WEALSMAN, (Shakespeare) a statesman; a politician [n]\n",
  "WEALTH": "valuable possessions [n -S]\n",
  "WEALTHIER": "WEALTHY, rich [adj]\n",
  "WEALTHIEST": "WEALTHY, rich [adj]\n",
  "WEALTHILY": "WEALTHY, rich [adv]\n",
  "WEALTHINESS": "the state of being wealthy [n -ES]\n",
  "WEALTHINESSES": "WEALTHINESS, the state of being wealthy [n]\n",
  "WEALTHLESS": "without wealth [adj]\n",
  "WEALTHS": "WEALTH, valuable possessions [n]\n",
  "WEALTHY": "rich [adj WEALTHIER, WEALTHIEST, WEALTHILY]\n",
  "WEAMB": "(dialect) a womb, also WAME, WEM, WEMB [n -S]\n",
  "WEAMBS": "WEAMB, (dialect) a womb, also WAME, WEM, WEMB [n]\n",
  "WEAN": "to take off mother's milk [v -ED, -ING, -S]\n",
  "WEANED": "WEAN, to take off mother's milk [v]\n",
  "WEANEL": "(Spenser) a weanling, also EANLING, YEANLING [n -S]\n",
  "WEANELS": "WEANEL, (Spenser) a weanling, also EANLING, YEANLING [n]\n",
  "WEANER": "a calf, lamb, or pig weaned during the current year [n -S]\n",
  "WEANERS": "WEANER, a calf, lamb, or pig weaned during the current year [n]\n",
  "WEANING": "an act of weaning [n -S]\n",
  "WEANINGS": "WEANING, an act of weaning [n]\n",
  "WEANLING": "an animal that is undergoing the process of weaning, also EANLING, WEANEL, YEANLING [n -S]\n",
  "WEANLINGS": "WEANLING, an animal that is undergoing the process of weaning, also EANLING, WEANEL, YEANLING [n]\n",
  "WEANS": "WEAN, to take off mother's milk [v]\n",
  "WEAPON": "to supply with an instrument of offence or defence [v -ED, -ING, -S]\n",
  "WEAPONED": "WEAPON, to supply with an instrument of offence or defence [v]\n",
  "WEAPONEER": "to design weapons, especially nuclear weapons [v -ED, -ING, -S]\n",
  "WEAPONEERED": "WEAPONEER, to design weapons, especially nuclear weapons [v]\n",
  "WEAPONEERING": "the act of fitting out with weapons [n -S]\n",
  "WEAPONEERINGS": "WEAPONEERING, the act of fitting out with weapons [n]\n",
  "WEAPONEERS": "WEAPONEER, to design weapons, especially nuclear weapons [v]\n",
  "WEAPONING": "WEAPON, to supply with an instrument of offence or defence [v]\n",
  "WEAPONISE": "to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONIZE [v WEAPONISED, WEAPONISING, WEAPONISES]\n",
  "WEAPONISED": "WEAPONISE, to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONIZE [v]\n",
  "WEAPONISES": "WEAPONISE, to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONIZE [v]\n",
  "WEAPONISING": "WEAPONISE, to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONIZE [v]\n",
  "WEAPONIZE": "to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONISE [v WEAPONIZED, WEAPONIZING, WEAPONIZES]\n",
  "WEAPONIZED": "WEAPONIZE, to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONISE [v]\n",
  "WEAPONIZES": "WEAPONIZE, to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONISE [v]\n",
  "WEAPONIZING": "WEAPONIZE, to adapt a chemical, bacillus etc. for use as a weapon, also WEAPONISE [v]\n",
  "WEAPONLESS": "lacking weapons [adj]\n",
  "WEAPONRIES": "WEAPONRY, weapons collectively [n]\n",
  "WEAPONRY": "weapons collectively [n WEAPONRIES]\n",
  "WEAPONS": "WEAPON, to supply with an instrument of offence or defence [v]\n",
  "WEAR": "to turn a ship's stern to windward to alter its course [v WEARED, WEARING, WEARS] / to put on clothes [v WORE, WORN, WEARING, WEARS]\n",
  "WEARABILITIES": "WEARABILITY, the ability to be worn [n]\n",
  "WEARABILITY": "the ability to be worn [n WEARABILITIES]\n",
  "WEARABLE": "a garment [n -S]\n",
  "WEARABLES": "WEARABLE, a garment [n]\n",
  "WEARED": "WEAR, to turn a ship's stern to windward to alter its course [v]\n",
  "WEARER": "one who is dressed [n -S]\n",
  "WEARERS": "WEARER, one who is dressed [n]\n",
  "WEARIED": "WEARY, to make tired [v]\n",
  "WEARIER": "WEARY, tired [adj]\n",
  "WEARIES": "WEARY, to make tired [v]\n",
  "WEARIEST": "WEARY, tired [adj]\n",
  "WEARIFUL": "wearisome [adj WEARIFULLY]\n",
  "WEARIFULLY": "WEARIFUL, wearisome [adv]\n",
  "WEARIFULNESS": "the state of being weariful [n -ES]\n",
  "WEARIFULNESSES": "WEARIFULNESS, the state of being weariful [n]\n",
  "WEARILESS": "incapable of being wearied [adj WEARILESSLY]\n",
  "WEARILESSLY": "WEARILESS, incapable of being wearied [adv]\n",
  "WEARILY": "WEARY, tired [adv]\n",
  "WEARINESS": "the state of being weary [n -ES]\n",
  "WEARINESSES": "WEARINESS, the state of being weary [n]\n",
  "WEARING": "tiring [adj WEARINGLY] / the act of wearing [n -S]\n",
  "WEARINGLY": "WEARING, tiring [adv]\n",
  "WEARINGS": "WEARING, the act of wearing [n]\n",
  "WEARISH": "tasteless [adj]\n",
  "WEARISOME": "tiresome, also WEARIFUL [adj]\n",
  "WEARISOMELY": "WEARISOME, tiresome, also WEARIFUL [adv]\n",
  "WEARISOMENESS": "the state of being wearisome [n -ES]\n",
  "WEARISOMENESSES": "WEARISOMENESS, the state of being wearisome [n]\n",
  "WEARPROOF": "proof against wear [adj]\n",
  "WEARS": "WEAR, to turn a ship's stern to windward to alter its course [v]\n",
  "WEARY": "tired [adj WEARIER, WEARIEST, WEARILY] / to make tired [v WEARIED, WEARYING, WEARIES]\n",
  "WEARYING": "WEARY, to make tired [v]\n",
  "WEARYINGLY": "WEARYING, WEARY, to make tired [adv]\n",
  "WEASAND": "(Old English) the windpipe, also WEASON, WEAZAND, WESAND, WESSAND, WEZAND [n -S]\n",
  "WEASANDS": "WEASAND, (Old English) the windpipe, also WEASON, WEAZAND, WESAND, WESSAND, WEZAND [n]\n",
  "WEASEL": "to act evasively [v WEASELED or WEASELLED, WEASELING or WEASELLING, WEASELS]\n",
  "WEASELED": "WEASEL, to act evasively [v]\n",
  "WEASELER": "one who acts evasively [n -S]\n",
  "WEASELERS": "WEASELER, one who acts evasively [n]\n",
  "WEASELIER": "WEASELY, like a weasel, shifty, also WEASELLY [adj]\n",
  "WEASELIEST": "WEASELY, like a weasel, shifty, also WEASELLY [adj]\n",
  "WEASELING": "WEASEL, to act evasively [v]\n",
  "WEASELLED": "WEASEL, to act evasively [v]\n",
  "WEASELLER": "one who weasels, also WEASELER [n -S]\n",
  "WEASELLERS": "WEASELLER, one who weasels, also WEASELER [n]\n",
  "WEASELLIER": "WEASELLY, like a weasel, shifty, also WEASELY [adj]\n",
  "WEASELLIEST": "WEASELLY, like a weasel, shifty, also WEASELY [adj]\n",
  "WEASELLING": "WEASEL, to act evasively [v]\n",
  "WEASELLY": "like a weasel, shifty, also WEASELY [adj WEASELLIER, WEASELLIEST]\n",
  "WEASELS": "WEASEL, to act evasively [v]\n",
  "WEASELY": "like a weasel, shifty, also WEASELLY [adj WEASELIER, WEASELIEST]\n",
  "WEASON": "(Old English) the windpipe, also WEASAND, WEAZAND, WESAND, WESSAND, WEZAND [n -S]\n",
  "WEASONS": "WEASON, (Old English) the windpipe, also WEASAND, WEAZAND, WESAND, WESSAND, WEZAND [n]\n",
  "WEATHER": "to expose to atmospheric conditions [v -ED, -ING, -S]\n",
  "WEATHERABILITY": "capability of withstanding the weathering process [n]\n",
  "WEATHERABLE": "that can be weathered [adj]\n",
  "WEATHERBOARD": "a board shaped so as to shed water [n -S] / to fit such a board [v -ED, -ING, -S]\n",
  "WEATHERBOARDED": "WEATHERBOARD, to fit such a board [v]\n",
  "WEATHERBOARDING": "WEATHERBOARD, to fit such a board [v]\n",
  "WEATHERBOARDS": "WEATHERBOARD, a board shaped so as to shed water [n]\n",
  "WEATHERCAST": "a weather forecast esp. on radio or television [n -S]\n",
  "WEATHERCASTER": "a weather forecaster esp. on radio or television [n -S]\n",
  "WEATHERCASTERS": "WEATHERCASTER, a weather forecaster esp. on radio or television [n]\n",
  "WEATHERCASTS": "WEATHERCAST, a weather forecast esp. on radio or television [n]\n",
  "WEATHERCLOTH": "a protecting tarpaulin on deck [n -S]\n",
  "WEATHERCLOTHS": "WEATHERCLOTH, a protecting tarpaulin on deck [n]\n",
  "WEATHERCOCK": "a weather vane often in the figure of a cock mounted so as to turn freely with the wind and show its direction [n -S] / to serve as a weathercock for [v -ED, -ING, -S]\n",
  "WEATHERCOCKED": "WEATHERCOCK, to serve as a weathercock for [v]\n",
  "WEATHERCOCKING": "WEATHERCOCK, to serve as a weathercock for [v]\n",
  "WEATHERCOCKS": "WEATHERCOCK, a weather vane often in the figure of a cock mounted so as to turn freely with the wind and show its direction [n]\n",
  "WEATHERED": "WEATHER, to expose to atmospheric conditions [v]\n",
  "WEATHERER": "one who weathers [n -S]\n",
  "WEATHERERS": "WEATHERER, one who weathers [n]\n",
  "WEATHERGIRL": "a girl who announces the weather forecast [n -S]\n",
  "WEATHERGIRLS": "WEATHERGIRL, a girl who announces the weather forecast [n]\n",
  "WEATHERGLASS": "a glass or instrument that indicates the changes of the weather [n -ES]\n",
  "WEATHERGLASSES": "WEATHERGLASS, a glass or instrument that indicates the changes of the weather [n]\n",
  "WEATHERING": "the action of the elements in altering the form, colour, texture or composition of rocks [n -S]\n",
  "WEATHERINGS": "WEATHERING, the action of the elements in altering the form, colour, texture or composition of rocks [n]\n",
  "WEATHERISATION": "the act of weatherising, also WEATHERIZATION [n -S]\n",
  "WEATHERISATIONS": "WEATHERISATION, the act of weatherising, also WEATHERIZATION [n]\n",
  "WEATHERISE": "to make (a fabric) weatherproof, also WEATHERIZE [v WEATHERISED, WEATHERISING, WEATHERISES]\n",
  "WEATHERISED": "WEATHERISE, to make (a fabric) weatherproof, also WEATHERIZE [v]\n",
  "WEATHERISES": "WEATHERISE, to make (a fabric) weatherproof, also WEATHERIZE [v]\n",
  "WEATHERISING": "WEATHERISE, to make (a fabric) weatherproof, also WEATHERIZE [v]\n",
  "WEATHERIZATION": "the act of weatherizing, also WEATHERISATION [n -S]\n",
  "WEATHERIZATIONS": "WEATHERIZATION, the act of weatherizing, also WEATHERISATION [n]\n",
  "WEATHERIZE": "to make (a fabric) weatherproof, also WEATHERISE [v WEATHERIZED, WEATHERIZING, WEATHERIZES]\n",
  "WEATHERIZED": "WEATHERIZE, to make (a fabric) weatherproof, also WEATHERISE [v]\n",
  "WEATHERIZES": "WEATHERIZE, to make (a fabric) weatherproof, also WEATHERISE [v]\n",
  "WEATHERIZING": "WEATHERIZE, to make (a fabric) weatherproof, also WEATHERISE [v]\n",
  "WEATHERLIER": "WEATHERLY, able to sail close to the wind with little leeway [adj]\n",
  "WEATHERLIEST": "WEATHERLY, able to sail close to the wind with little leeway [adj]\n",
  "WEATHERLINESS": "the state of being weatherly [n -ES]\n",
  "WEATHERLINESSES": "WEATHERLINESS, the state of being weatherly [n]\n",
  "WEATHERLY": "able to sail close to the wind with little leeway [adj WEATHERLIER, WEATHERLIEST]\n",
  "WEATHERMAN": "one who reports and forecasts the weather [n WEATHERMEN]\n",
  "WEATHERMEN": "WEATHERMAN, one who reports and forecasts the weather [n]\n",
  "WEATHERMOST": "furthest to windward [adj]\n",
  "WEATHEROMETER": "an instrument for measuring weather-resisting properties of paint [n -S]\n",
  "WEATHEROMETERS": "WEATHEROMETER, an instrument for measuring weather-resisting properties of paint [n]\n",
  "WEATHERPERSON": "a person who reports and forecasts the weather [n -S]\n",
  "WEATHERPERSONS": "WEATHERPERSON, a person who reports and forecasts the weather [n]\n",
  "WEATHERPROOF": "proof against the weather [n -S] / to make able to withstand exposure to weather without damage or loss of function [v -ED, -ING, -S]\n",
  "WEATHERPROOFED": "WEATHERPROOF, to make able to withstand exposure to weather without damage or loss of function [v]\n",
  "WEATHERPROOFING": "WEATHERPROOF, to make able to withstand exposure to weather without damage or loss of function [v]\n",
  "WEATHERPROOFS": "WEATHERPROOF, to make able to withstand exposure to weather without damage or loss of function [v]\n",
  "WEATHERS": "WEATHER, to expose to atmospheric conditions [v]\n",
  "WEATHERWOMAN": "a woman who delivers the weather forecast [n WEATHERWOMEN]\n",
  "WEATHERWOMEN": "WEATHERWOMAN, a woman who delivers the weather forecast [n]\n",
  "WEATHERWORN": "worn by exposure to the weather [adj]\n",
  "WEAVE": "to form by crossing threads [v WOVE or WEAVED, WOVEN, WEAVING, WEAVES]\n",
  "WEAVED": "WEAVE, to form by crossing threads [v]\n",
  "WEAVER": "one that weaves [n -S]\n",
  "WEAVERBIRD": "a weaver finch [n -S]\n",
  "WEAVERBIRDS": "WEAVERBIRD, a weaver finch [n]\n",
  "WEAVERS": "WEAVER, one that weaves [n]\n",
  "WEAVES": "WEAVE, to form by crossing threads [v]\n",
  "WEAVING": "the act of making cloth [n -S]\n",
  "WEAVINGS": "WEAVING, the act of making cloth [n]\n",
  "WEAZAND": "(Old English) the windpipe, also WEASAND, WEASON, WESAND, WESSAND, WEZAND, WIZZEN [n -S]\n",
  "WEAZANDS": "WEAZAND, (Old English) the windpipe, also WEASAND, WEASON, WESAND, WESSAND, WEZAND, WIZZEN [n]\n",
  "WEAZEN": "to become dry and shrivelled, also WIZEN [v -ED, -ING, -S]\n",
  "WEAZENED": "WEAZEN, to become dry and shrivelled, also WIZEN [v]\n",
  "WEAZENING": "WEAZEN, to become dry and shrivelled, also WIZEN [v]\n",
  "WEAZENS": "WEAZEN, to become dry and shrivelled, also WIZEN [v]\n",
  "WEB": "to provide fine structure spun by a spider [v WEBBED, WEBBING, WEBS]\n",
  "WEBAPP": "an application program that is accessed on the internet [n -S]\n",
  "WEBAPPS": "WEBAPP, an application program that is accessed on the internet [n]\n",
  "WEBBED": "WEB, to provide fine structure spun by a spider [v]\n",
  "WEBBIE": "a person very familiar with the World Wide Web [n -S]\n",
  "WEBBIER": "WEBBY, resembling a web [adj]\n",
  "WEBBIES": "WEBBIE, a person very familiar with the World Wide Web [n]\n",
  "WEBBIEST": "WEBBY, resembling a web [adj]\n",
  "WEBBING": "woven strips of fibre [n -S]\n",
  "WEBBINGS": "WEBBING, woven strips of fibre [n]\n",
  "WEBBY": "resembling a web [adj WEBBIER, WEBBIEST]\n",
  "WEBCAM": "a camera used for transmitting live images over the World Wide Web [n -S]\n",
  "WEBCAMS": "WEBCAM, a camera used for transmitting live images over the World Wide Web [n]\n",
  "WEBCAST": "to transmit sound and images via the World Wide Web [v -ED, -ING, -S]\n",
  "WEBCASTED": "WEBCAST, to transmit sound and images via the World Wide Web [v]\n",
  "WEBCASTER": "one who broadcasts over the Internet [n -S]\n",
  "WEBCASTERS": "WEBCASTER, one who broadcasts over the Internet [n]\n",
  "WEBCASTING": "broadcasting over the Internet [n -S]\n",
  "WEBCASTINGS": "WEBCASTING, broadcasting over the Internet [n]\n",
  "WEBCASTS": "WEBCAST, to transmit sound and images via the World Wide Web [v]\n",
  "WEBCHAT": "to communicate in real time over the Internet [v WEBCHATTED, WEBCHATTING, WEBCHATS]\n",
  "WEBCHATS": "WEBCHAT, to communicate in real time over the Internet [v]\n",
  "WEBCHATTED": "WEBCHAT, to communicate in real time over the Internet [v]\n",
  "WEBCHATTING": "WEBCHAT, to communicate in real time over the Internet [v]\n",
  "WEBER": "a unit of magnetic flux [n -S]\n",
  "WEBERS": "WEBER, a unit of magnetic flux [n]\n",
  "WEBFED": "pertaining to a type of printing press [adj]\n",
  "WEBFEET": "WEBFOOT, a foot with the toes joined [n]\n",
  "WEBFOOT": "a foot with the toes joined [n WEBFEET]\n",
  "WEBFOOTED": "having webbed feet [adj]\n",
  "WEBHEAD": "a devoted user of the Web [n -S]\n",
  "WEBHEADS": "WEBHEAD, a devoted user of the Web [n]\n",
  "WEBIFIED": "WEBIFY, to put a piece of (possibly already existing) material on the Web [v]\n",
  "WEBIFIES": "WEBIFY, to put a piece of (possibly already existing) material on the Web [v]\n",
  "WEBIFY": "to put a piece of (possibly already existing) material on the Web [v WEBIFIED, WEBIFYING, WEBIFIES]\n",
  "WEBIFYING": "WEBIFY, to put a piece of (possibly already existing) material on the Web [v]\n",
  "WEBINAR": "a seminar via the World Wide Web [n -S]\n",
  "WEBINARS": "WEBINAR, a seminar via the World Wide Web [n]\n",
  "WEBISODE": "a short episode which airs initially as an Internet download or stream as opposed to first airing on broadcast or cable television [n -S]\n",
  "WEBISODES": "WEBISODE, a short episode which airs initially as an Internet download or stream as opposed to first airing on broadcast or cable television [n]\n",
  "WEBLESS": "having no webs [adj]\n",
  "WEBLIKE": "resembling a web [adj]\n",
  "WEBLIOGRAPHIES": "WEBLIOGRAPHY, a list of items published on the internet, esp. one indicating sources used in the preparation of a book or academic paper [n]\n",
  "WEBLIOGRAPHY": "a list of items published on the internet, esp. one indicating sources used in the preparation of a book or academic paper [n WEBLIOGRAPHIES]\n",
  "WEBLISH": "very abbreviated English as used in email, texting etc. [n -ES]\n",
  "WEBLISHES": "WEBLISH, very abbreviated English as used in email, texting etc. [n]\n",
  "WEBLOG": "a website that contains an online personal journal [n -S]\n",
  "WEBLOGGER": "one who keeps a weblog, a Web journal [n -S]\n",
  "WEBLOGGERS": "WEBLOGGER, one who keeps a weblog, a Web journal [n]\n",
  "WEBLOGGING": "the act of keeping a weblog [n -S]\n",
  "WEBLOGGINGS": "WEBLOGGING, the act of keeping a weblog [n]\n",
  "WEBLOGS": "WEBLOG, a website that contains an online personal journal [n]\n",
  "WEBMAIL": "a way of accessing email via a web page [n -S]\n",
  "WEBMAILS": "WEBMAIL, a way of accessing email via a web page [n]\n",
  "WEBMASTER": "a person responsible for the maintenance of a website [n -S]\n",
  "WEBMASTERS": "WEBMASTER, a person responsible for the maintenance of a website [n]\n",
  "WEBPAGE": "a single document on the World Wide Web [n -S]\n",
  "WEBPAGES": "WEBPAGE, a single document on the World Wide Web [n]\n",
  "WEBRING": "a collection of websites from around the Internet joined together in a circular structure [n -S]\n",
  "WEBRINGS": "WEBRING, a collection of websites from around the Internet joined together in a circular structure [n]\n",
  "WEBS": "WEB, to provide fine structure spun by a spider [v]\n",
  "WEBSITE": "a location on the Internet [n -S]\n",
  "WEBSITES": "WEBSITE, a location on the Internet [n]\n",
  "WEBSPACE": "storage space on a web server [n -S]\n",
  "WEBSPACES": "WEBSPACE, storage space on a web server [n]\n",
  "WEBSTER": "(obsolete) a weaver, also WABSTER [n -S]\n",
  "WEBSTERS": "WEBSTER, (obsolete) a weaver, also WABSTER [n]\n",
  "WEBWHEEL": "a wheel formed from one piece of material [n -S]\n",
  "WEBWHEELS": "WEBWHEEL, a wheel formed from one piece of material [n]\n",
  "WEBWORK": "a weblike pattern or structure [n -S]\n",
  "WEBWORKS": "WEBWORK, a weblike pattern or structure [n]\n",
  "WEBWORM": "a web-spinning caterpillar [n -S]\n",
  "WEBWORMS": "WEBWORM, a web-spinning caterpillar [n]\n",
  "WEBZINE": "a magazine published on the Internet [n -S]\n",
  "WEBZINES": "WEBZINE, a magazine published on the Internet [n]\n",
  "WECHT": "(Scots) to winnow [v -ED, -ING, -S]\n",
  "WECHTED": "WECHT, (Scots) to winnow [v]\n",
  "WECHTING": "WECHT, (Scots) to winnow [v]\n",
  "WECHTS": "WECHT, (Scots) to winnow [v]\n",
  "WED": "to marry [v WEDDED, WEDDING, WEDS]\n",
  "WEDDED": "WED, to marry [v]\n",
  "WEDDER": "(dialect) to weather [v -ED, -ING, -S]\n",
  "WEDDERED": "WEDDER, (dialect) to weather [v]\n",
  "WEDDERING": "WEDDER, (dialect) to weather [v]\n",
  "WEDDERS": "WEDDER, (dialect) to weather [v]\n",
  "WEDDING": "a marriage ceremony [n -S]\n",
  "WEDDINGS": "WEDDING, a marriage ceremony [n]\n",
  "WEDEL": "(German) to ski in a swiveling motion with skis close together, also WEDELN [v -ED, -ING, -S]\n",
  "WEDELED": "WEDEL, (German) to ski in a swiveling motion with skis close together, also WEDELN [v]\n",
  "WEDELING": "WEDEL, (German) to ski in a swiveling motion with skis close together, also WEDELN [v]\n",
  "WEDELN": "(German) to ski in a swiveling motion with skis close together, also WEDEL [v -ED, -ING, -S]\n",
  "WEDELNED": "WEDELN, (German) to ski in a swiveling motion with skis close together, also WEDEL [v]\n",
  "WEDELNING": "WEDELN, (German) to ski in a swiveling motion with skis close together, also WEDEL [v]\n",
  "WEDELNS": "WEDELN, (German) to ski in a swiveling motion with skis close together, also WEDEL [v]\n",
  "WEDELS": "WEDEL, (German) to ski in a swiveling motion with skis close together, also WEDELN [v]\n",
  "WEDGE": "to force apart with wood or metal [v WEDGED, WEDGING, WEDGES]\n",
  "WEDGED": "WEDGE, to force apart with wood or metal [v]\n",
  "WEDGELIKE": "like a wedge [adj]\n",
  "WEDGES": "WEDGE, to force apart with wood or metal [v]\n",
  "WEDGEWISE": "in the manner of a wedge [adv]\n",
  "WEDGIE": "a type of woman's shoe [n -S]\n",
  "WEDGIER": "WEDGY, resembling a wedge [adj]\n",
  "WEDGIES": "WEDGIE, a type of woman's shoe [n]\n",
  "WEDGIEST": "WEDGY, resembling a wedge [adj]\n",
  "WEDGING": "a method of joining timber [n -S]\n",
  "WEDGINGS": "WEDGING, a method of joining timber [n]\n",
  "WEDGY": "resembling a wedge [adj WEDGIER, WEDGIEST]\n",
  "WEDLOCK": "the married state [n -S]\n",
  "WEDLOCKS": "WEDLOCK, the married state [n]\n",
  "WEDS": "WED, to marry [v]\n",
  "WEE": "small [adj WEER, WEEST] / to urinate [v WEED, WEEING, WEES]\n",
  "WEED": "to remove unwanted plants [v -ED, -ING, -S]\n",
  "WEEDBED": "an area of a body of water having lots of weeds [n -S]\n",
  "WEEDBEDS": "WEEDBED, an area of a body of water having lots of weeds [n]\n",
  "WEEDED": "WEED, to remove unwanted plants [v]\n",
  "WEEDER": "one who weeds [n -S]\n",
  "WEEDERIES": "WEEDERY, a place full of weeds [n]\n",
  "WEEDERS": "WEEDER, one who weeds [n]\n",
  "WEEDERY": "a place full of weeds [n WEEDERIES]\n",
  "WEEDHEAD": "a person who uses a lot of marijuana [n -S]\n",
  "WEEDHEADS": "WEEDHEAD, a person who uses a lot of marijuana [n]\n",
  "WEEDICIDE": "something that kills weeds [n -S]\n",
  "WEEDICIDES": "WEEDICIDE, something that kills weeds [n]\n",
  "WEEDIER": "WEEDY, resembling weeds [adj]\n",
  "WEEDIEST": "WEEDY, resembling weeds [adj]\n",
  "WEEDILY": "WEEDY, resembling weeds [adv]\n",
  "WEEDINESS": "the state of being weedy [n -ES]\n",
  "WEEDINESSES": "WEEDINESS, the state of being weedy [n]\n",
  "WEEDING": "the task of weeding [n -S]\n",
  "WEEDINGS": "WEEDING, the task of weeding [n]\n",
  "WEEDKILLER": "a chemical preparation or other substance for killing weeds [n -S]\n",
  "WEEDKILLERS": "WEEDKILLER, a chemical preparation or other substance for killing weeds [n]\n",
  "WEEDLESS": "having no weeds [adj]\n",
  "WEEDLIKE": "resembling a weed [adj]\n",
  "WEEDLINE": "the edge of a weedbed [n -S]\n",
  "WEEDLINES": "WEEDLINE, the edge of a weedbed [n]\n",
  "WEEDS": "WEED, to remove unwanted plants [v]\n",
  "WEEDY": "resembling weeds [adj WEEDIER, WEEDIEST, WEEDILY]\n",
  "WEEING": "WEE, to urinate [v]\n",
  "WEEJUNS": "moccasin-style shoes for casual wear [n]\n",
  "WEEK": "a period of seven days [n -S]\n",
  "WEEKDAY": "usually any day from Monday to Friday [n -S]\n",
  "WEEKDAYS": "WEEKDAY, usually any day from Monday to Friday [n]\n",
  "WEEKE": "(Spenser) a wick [n -S]\n",
  "WEEKEND": "to take a holiday on Saturday or Sunday [v -ED, -ING, -S]\n",
  "WEEKENDED": "WEEKEND, to take a holiday on Saturday or Sunday [v]\n",
  "WEEKENDER": "one who spends the weekend away from home; a weekend bag [n -S]\n",
  "WEEKENDERS": "WEEKENDER, one who spends the weekend away from home; a weekend bag [n]\n",
  "WEEKENDING": "the act of spending a weekend [n -S]\n",
  "WEEKENDINGS": "WEEKENDING, the act of spending a weekend [n]\n",
  "WEEKENDS": "WEEKEND, to take a holiday on Saturday or Sunday [v]\n",
  "WEEKES": "WEEKE, (Spenser) a wick [n]\n",
  "WEEKLIES": "WEEKLY, a publication issued once a week [n]\n",
  "WEEKLONG": "continuing for a week [adj]\n",
  "WEEKLY": "a publication issued once a week [n WEEKLIES]\n",
  "WEEKNIGHT": "the evening or night of a weekday [n -S]\n",
  "WEEKNIGHTS": "WEEKNIGHT, the evening or night of a weekday [n]\n",
  "WEEKS": "WEEK, a period of seven days [n]\n",
  "WEEL": "a whirlpool; a fish-trap, also WEIL, WIEL [n -S]\n",
  "WEELDLESSE": "(Spenser) unmanageable [adj]\n",
  "WEELS": "WEEL, a whirlpool; a fish-trap, also WEIL, WIEL [n]\n",
  "WEEM": "(Gaelic) a subterranean dwelling [n -S]\n",
  "WEEMS": "WEEM, (Gaelic) a subterranean dwelling [n]\n",
  "WEEN": "(archaic) to think; to imagine [v -ED, -ING, -S]\n",
  "WEENED": "WEEN, (archaic) to think; to imagine [v]\n",
  "WEENIE": "a frankfurter, a small smoked beef or pork sausage, also WEENY, WEINER, WIENER, WIENERWURST, WIENIE [n -S]\n",
  "WEENIER": "WEENY, very small [adj]\n",
  "WEENIES": "WEENY, a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEINER, WIENER, WIENERWURST, WIENIE [n]\n",
  "WEENIEST": "WEENY, very small [adj]\n",
  "WEENING": "WEEN, (archaic) to think; to imagine [v]\n",
  "WEENS": "WEEN, (archaic) to think; to imagine [v]\n",
  "WEENSIER": "WEENSY, tiny [adj]\n",
  "WEENSIEST": "WEENSY, tiny [adj]\n",
  "WEENSY": "tiny [adj WEENSIER, WEENSIEST]\n",
  "WEENY": "very small [adj WEENIER, WEENIEST] / a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEINER, WIENER, WIENERWURST, WIENIE [n WEENIES]\n",
  "WEEP": "to shed tears (salty liquid) from the eyes [v WEPT, WEEPING, WEEPS]\n",
  "WEEPER": "one who weeps [n -S]\n",
  "WEEPERS": "WEEPER, one who weeps [n]\n",
  "WEEPHOLE": "a hole in a wall through which water escapes [n -S]\n",
  "WEEPHOLES": "WEEPHOLE, a hole in a wall through which water escapes [n]\n",
  "WEEPIE": "a highly emotional film, also WEEPY [n -S]\n",
  "WEEPIER": "WEEPY, tending to weep [adj]\n",
  "WEEPIES": "WEEPIE, a highly emotional film, also WEEPY [n]\n",
  "WEEPIEST": "WEEPY, tending to weep [adj]\n",
  "WEEPILY": "WEEPY, tending to weep [adv]\n",
  "WEEPINESS": "the state of being weepy [n -ES]\n",
  "WEEPINESSES": "WEEPINESS, the state of being weepy [n]\n",
  "WEEPING": "tearful [adj WEEPINGLY] / the act of weeping [n -S]\n",
  "WEEPINGLY": "WEEPING, tearful [adv]\n",
  "WEEPINGS": "WEEPING, the act of weeping [n]\n",
  "WEEPS": "WEEP, to shed tears (salty liquid) from the eyes [v]\n",
  "WEEPY": "tending to weep [adj WEEPIER, WEEPIEST, WEEPILY] / a sentimental film or book, also WEEPIE [n WEEPIES]\n",
  "WEER": "WEE, small [adj]\n",
  "WEES": "WEE, to urinate [v]\n",
  "WEEST": "WEE, small [adj]\n",
  "WEET": "wet [adj WEETER, WEETEST] / (archaic) to know [v -ED, -ING, -S]\n",
  "WEETE": "(Shakespeare) a present tense form of wit, to know [v]\n",
  "WEETED": "WEET, (archaic) to know [v]\n",
  "WEETEN": "(Spenser) to know [v]\n",
  "WEETER": "WEET, wet [adj]\n",
  "WEETEST": "WEET, wet [adj]\n",
  "WEETING": "WEET, (archaic) to know [v]\n",
  "WEETINGLY": "WEETING, WEET, (archaic) to know [adv]\n",
  "WEETLESS": "(obsolete) unknowing [adj]\n",
  "WEETS": "WEET, (archaic) to know [v]\n",
  "WEEVER": "any one of several species of edible marine fishes with numerous strong, sharp spines [n -S]\n",
  "WEEVERS": "WEEVER, any one of several species of edible marine fishes with numerous strong, sharp spines [n]\n",
  "WEEVIL": "a popular name for various beetles, esp. one that lives in flour [n -S]\n",
  "WEEVILED": "infested by weevils, also WEEVILLED [adj]\n",
  "WEEVILIER": "WEEVILY, full of weevils, also WEEVILLY [adj]\n",
  "WEEVILIEST": "WEEVILY, full of weevils, also WEEVILLY [adj]\n",
  "WEEVILLED": "infested by weevils, also WEEVILED [adj]\n",
  "WEEVILLIER": "WEEVILLY, full of weevils, also WEEVILY [adj]\n",
  "WEEVILLIEST": "WEEVILLY, full of weevils, also WEEVILY [adj]\n",
  "WEEVILLY": "full of weevils, also WEEVILY [adj WEEVILLIER, WEEVILLIEST]\n",
  "WEEVILS": "WEEVIL, a popular name for various beetles, esp. one that lives in flour [n]\n",
  "WEEVILY": "full of weevils, also WEEVILLY [adj WEEVILIER, WEEVILIEST]\n",
  "WEEWEE": "(colloquial) to urinate [v WEEWEED, WEEWEEING, WEEWEES]\n",
  "WEEWEED": "WEEWEE, (colloquial) to urinate [v]\n",
  "WEEWEEING": "WEEWEE, (colloquial) to urinate [v]\n",
  "WEEWEES": "WEEWEE, (colloquial) to urinate [v]\n",
  "WEFT": "to weave fabric [v -ED, -ING, -S]\n",
  "WEFTAGE": "texture [n -S]\n",
  "WEFTAGES": "WEFTAGE, texture [n]\n",
  "WEFTE": "(Spenser) a waif, a castaway, also WAIFT [n -S]\n",
  "WEFTED": "WEFT, to weave fabric [v]\n",
  "WEFTES": "WEFTE, (Spenser) a waif, a castaway, also WAIFT [n]\n",
  "WEFTING": "WEFT, to weave fabric [v]\n",
  "WEFTS": "WEFT, to weave fabric [v]\n",
  "WEFTWISE": "in a horizontal direction [adv]\n",
  "WEID": "(Scots) any sudden illness, cold or relapse with febrile symptoms [n -S]\n",
  "WEIDS": "WEID, (Scots) any sudden illness, cold or relapse with febrile symptoms [n]\n",
  "WEIGELA": "a hardy garden shrub belonging to the honeysuckle family, also WEIGELIA [n -S]\n",
  "WEIGELAS": "WEIGELA, a hardy garden shrub belonging to the honeysuckle family, also WEIGELIA [n]\n",
  "WEIGELIA": "a hardy garden shrub belonging to the honeysuckle family, also WEIGELA [n -S]\n",
  "WEIGELIAS": "WEIGELIA, a hardy garden shrub belonging to the honeysuckle family, also WEIGELA [n]\n",
  "WEIGH": "to determine the weight of [v -ED, -ING, -S]\n",
  "WEIGHABLE": "capable of being weighed [adj]\n",
  "WEIGHAGE": "the rate paid for weighing of goods [n -S]\n",
  "WEIGHAGES": "WEIGHAGE, the rate paid for weighing of goods [n]\n",
  "WEIGHBOARD": "a thin geological seam separating larger strata, also WAYBOARD [n -S]\n",
  "WEIGHBOARDS": "WEIGHBOARD, a thin geological seam separating larger strata, also WAYBOARD [n]\n",
  "WEIGHBRIDGE": "a machine for weighing vehicles with their loads [n -S]\n",
  "WEIGHBRIDGES": "WEIGHBRIDGE, a machine for weighing vehicles with their loads [n]\n",
  "WEIGHED": "WEIGH, to determine the weight of [v]\n",
  "WEIGHER": "one who weighs [n -S]\n",
  "WEIGHERS": "WEIGHER, one who weighs [n]\n",
  "WEIGHING": "a weighing allowance [n -S]\n",
  "WEIGHINGS": "WEIGHING, a weighing allowance [n]\n",
  "WEIGHMAN": "one who weighs goods [n WEIGHMEN]\n",
  "WEIGHMEN": "WEIGHMAN, one who weighs goods [n]\n",
  "WEIGHS": "WEIGH, to determine the weight of [v]\n",
  "WEIGHT": "to add heaviness to [v -ED, -ING, -S]\n",
  "WEIGHTAGE": "a weighting [n -S]\n",
  "WEIGHTAGES": "WEIGHTAGE, a weighting [n]\n",
  "WEIGHTED": "WEIGHT, to add heaviness to [v]\n",
  "WEIGHTER": "one that weights [n -S]\n",
  "WEIGHTERS": "WEIGHTER, one that weights [n]\n",
  "WEIGHTIER": "WEIGHTY, heavy, ponderous [adj]\n",
  "WEIGHTIEST": "WEIGHTY, heavy, ponderous [adj]\n",
  "WEIGHTILY": "WEIGHTY, heavy, ponderous [adv]\n",
  "WEIGHTINESS": "the state of being weighty [n -ES]\n",
  "WEIGHTINESSES": "WEIGHTINESS, the state of being weighty [n]\n",
  "WEIGHTING": "the act of weighting [n -S]\n",
  "WEIGHTINGS": "WEIGHTING, the act of weighting [n]\n",
  "WEIGHTLESS": "having little weight [adj WEIGHTLESSLY]\n",
  "WEIGHTLESSLY": "WEIGHTLESS, having little weight [adv]\n",
  "WEIGHTLESSNESS": "the state of being weightless [n]\n",
  "WEIGHTLIFTER": "one who practises the sport of weightlifting [n -S]\n",
  "WEIGHTLIFTERS": "WEIGHTLIFTER, one who practises the sport of weightlifting [n]\n",
  "WEIGHTLIFTING": "the sport of lifting weights competitively [n -S]\n",
  "WEIGHTLIFTINGS": "WEIGHTLIFTING, the sport of lifting weights competitively [n]\n",
  "WEIGHTS": "WEIGHT, to add heaviness to [v]\n",
  "WEIGHTY": "heavy, ponderous [adj WEIGHTIER, WEIGHTIEST, WEIGHTILY]\n",
  "WEIL": "a whirlpool, also WEEL, WIEL [n -S]\n",
  "WEILS": "WEIL, a whirlpool, also WEEL, WIEL [n]\n",
  "WEIMARANER": "(German) a breed of grey shorthaired gun dogs [n -S]\n",
  "WEIMARANERS": "WEIMARANER, (German) a breed of grey shorthaired gun dogs [n]\n",
  "WEINER": "(German) a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEENY, WIENER, WIENERWURST, WIENIE [n -S]\n",
  "WEINERS": "WEINER, (German) a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEENY, WIENER, WIENERWURST, WIENIE [n]\n",
  "WEIR": "to wear [v -ED, -ING, -S]\n",
  "WEIRD": "eerily strange, also WEYARD, WEYWARD [adj WEIRDER, WEIRDEST, WEIRDLY] / (Scots) to destine, to doom [v -ED, -ING, -S]\n",
  "WEIRDED": "WEIRD, (Scots) to destine, to doom [v]\n",
  "WEIRDER": "WEIRD, eerily strange, also WEYARD, WEYWARD [adj]\n",
  "WEIRDEST": "WEIRD, eerily strange, also WEYARD, WEYWARD [adj]\n",
  "WEIRDIE": "a very strange person, also WEIRDO, WEIRDY [n -S]\n",
  "WEIRDIES": "WEIRDY, a very strange person, also WEIRDIE, WEIRDO [n]\n",
  "WEIRDING": "WEIRD, (Scots) to destine, to doom [v]\n",
  "WEIRDLY": "WEIRD, eerily strange, also WEYARD, WEYWARD [adv]\n",
  "WEIRDNESS": "the state of being weird [n -ES]\n",
  "WEIRDNESSES": "WEIRDNESS, the state of being weird [n]\n",
  "WEIRDO": "a very strange person, also WEIRDIE, WEIRDY [n -ES or -S]\n",
  "WEIRDOES": "WEIRDO, a very strange person, also WEIRDIE, WEIRDY [n]\n",
  "WEIRDOS": "WEIRDO, a very strange person, also WEIRDIE, WEIRDY [n]\n",
  "WEIRDS": "WEIRD, (Scots) to destine, to doom [v]\n",
  "WEIRDY": "a very strange person, also WEIRDIE, WEIRDO [n WEIRDIES]\n",
  "WEIRED": "WEIR, to wear [v]\n",
  "WEIRING": "WEIR, to wear [v]\n",
  "WEIRS": "WEIR, to wear [v]\n",
  "WEISE": "(Scots) to guide in a certain direction, also WEIZE [v WEISED, WEISING, WEISES]\n",
  "WEISED": "WEISE, (Scots) to guide in a certain direction, also WEIZE [v]\n",
  "WEISENHEIMER": "(US) a smart aleck, also WISENHEIMER [n -S]\n",
  "WEISENHEIMERS": "WEISENHEIMER, (US) a smart aleck, also WISENHEIMER [n]\n",
  "WEISES": "WEISE, (Scots) to guide in a certain direction, also WEIZE [v]\n",
  "WEISING": "WEISE, (Scots) to guide in a certain direction, also WEIZE [v]\n",
  "WEIZE": "(Scots) to guide in a certain direction, also WEISE [v WEIZED, WEIZING, WEIZES]\n",
  "WEIZED": "WEIZE, (Scots) to guide in a certain direction, also WEISE [v]\n",
  "WEIZES": "WEIZE, (Scots) to guide in a certain direction, also WEISE [v]\n",
  "WEIZING": "WEIZE, (Scots) to guide in a certain direction, also WEISE [v]\n",
  "WEKA": "(Maori) a flightless rail of New Zealand [n -S]\n",
  "WEKAS": "WEKA, (Maori) a flightless rail of New Zealand [n]\n",
  "WELAWAY": "(archaic) alas, also WELLADAY, WELLADAYS, WELLAWAY, WELLAWAYS [interj]\n",
  "WELCH": "to fail to pay a debt, also WELSH [v -ED, -ING, -ES]\n",
  "WELCHED": "WELCH, to fail to pay a debt, also WELSH [v]\n",
  "WELCHER": "one who welches, also WELSHER [n -S]\n",
  "WELCHERS": "WELCHER, one who welches, also WELSHER [n]\n",
  "WELCHES": "WELCH, to fail to pay a debt, also WELSH [v]\n",
  "WELCHING": "WELCH, to fail to pay a debt, also WELSH [v]\n",
  "WELCOME": "received with gladness [adj WELCOMELY] / to greet cordially [v WELCOMED, WELCOMING, WELCOMES]\n",
  "WELCOMED": "WELCOME, to greet cordially [v]\n",
  "WELCOMELY": "WELCOME, received with gladness [adv]\n",
  "WELCOMENESS": "the state of being welcome [n -ES]\n",
  "WELCOMENESSES": "WELCOMENESS, the state of being welcome [n]\n",
  "WELCOMER": "one who welcomes [n -S]\n",
  "WELCOMERS": "WELCOMER, one who welcomes [n]\n",
  "WELCOMES": "WELCOME, to greet cordially [v]\n",
  "WELCOMING": "WELCOME, to greet cordially [v]\n",
  "WELCOMINGLY": "WELCOMING, WELCOME, to greet cordially [adv]\n",
  "WELD": "to join by fusing [v -ED, -ING, -S]\n",
  "WELDABILITIES": "WELDABILITY, the quality of being weldable [n]\n",
  "WELDABILITY": "the quality of being weldable [n WELDABILITIES]\n",
  "WELDABLE": "able to be welded [adj]\n",
  "WELDED": "WELD, to join by fusing [v]\n",
  "WELDER": "one that welds, also WELDOR [n -S]\n",
  "WELDERS": "WELDER, one that welds, also WELDOR [n]\n",
  "WELDING": "the act of welding [n -S]\n",
  "WELDINGS": "WELDING, the act of welding [n]\n",
  "WELDLESS": "having no welded joints [adj]\n",
  "WELDMENT": "a unit composed of welded pieces [n -S]\n",
  "WELDMENTS": "WELDMENT, a unit composed of welded pieces [n]\n",
  "WELDMESH": "a type of metal fencing consisting of wire mesh reinforced by welding [n -ES]\n",
  "WELDMESHES": "WELDMESH, a type of metal fencing consisting of wire mesh reinforced by welding [n]\n",
  "WELDOR": "one that welds, also WELDER [n -S]\n",
  "WELDORS": "WELDOR, one that welds, also WELDER [n]\n",
  "WELDS": "WELD, to join by fusing [v]\n",
  "WELFARE": "general wellbeing [n -S]\n",
  "WELFARES": "WELFARE, general wellbeing [n]\n",
  "WELFARISM": "the social policies characteristic of a welfare state [n -S]\n",
  "WELFARISMS": "WELFARISM, the social policies characteristic of a welfare state [n]\n",
  "WELFARIST": "an adherent of the social policies characteristic of a welfare state [n -S]\n",
  "WELFARISTIC": "relating to welfarism [adj]\n",
  "WELFARISTS": "WELFARIST, an adherent of the social policies characteristic of a welfare state [n]\n",
  "WELFARITE": "(US) a person who is on welfare [n -S]\n",
  "WELFARITES": "WELFARITE, (US) a person who is on welfare [n]\n",
  "WELK": "(Scott) to twist about [v WELKED or (Shakespeare) WELKT, WELKING, WELKS]\n",
  "WELKE": "(Spenser) to wither, shrivel [v WELKED, WELKING, WELKES]\n",
  "WELKED": "WELKE, (Spenser) to wither, shrivel [v]\n",
  "WELKES": "WELKE, (Spenser) to wither, shrivel [v]\n",
  "WELKIN": "(Old English) the sky [n -S]\n",
  "WELKING": "WELKE, (Spenser) to wither, shrivel [v]\n",
  "WELKINS": "WELKIN, (Old English) the sky [n]\n",
  "WELKS": "WELK, (Scott) to twist about [v]\n",
  "WELKT": "(Shakespeare) twisted [adj]\n",
  "WELL": "to rise to the surface and flow forth [v -ED, -ING, -S]\n",
  "WELLADAY": "(archaic) alas, also WELAWAY, WELLADAYS, WELLAWAY, WELLAWAYS [interj]\n",
  "WELLADAYS": "(archaic) alas, also WELAWAY, WELLADAY, WELLAWAY, WELLAWAYS [interj]\n",
  "WELLANEAR": "(archaic) alas [interj]\n",
  "WELLAWAY": "(archaic) alas, also WELAWAY, WELLADAY, WELLADAYS, WELLAWAYS [interj]\n",
  "WELLAWAYS": "alas, also WELAWAY, WELLADAY, WELLADAYS, WELLAWAY [interj]\n",
  "WELLBEING": "a state of being well [n -S]\n",
  "WELLBEINGS": "WELLBEING, a state of being well [n]\n",
  "WELLBORN": "of good birth or ancestry [adj]\n",
  "WELLCURB": "the stone ring around a well [n -S]\n",
  "WELLCURBS": "WELLCURB, the stone ring around a well [n]\n",
  "WELLDOER": "a doer of good deeds [n -S]\n",
  "WELLDOERS": "WELLDOER, a doer of good deeds [n]\n",
  "WELLED": "WELL, to rise to the surface and flow forth [v]\n",
  "WELLHEAD": "the source of a spring or stream [n -S]\n",
  "WELLHEADS": "WELLHEAD, the source of a spring or stream [n]\n",
  "WELLHOLE": "the shaft of a well [n -S]\n",
  "WELLHOLES": "WELLHOLE, the shaft of a well [n]\n",
  "WELLHOUSE": "a structure above a well, housing the windlass [n -S]\n",
  "WELLHOUSES": "WELLHOUSE, a structure above a well, housing the windlass [n]\n",
  "WELLIE": "(colloquial) a wellington boot, also WELLY [n -S]\n",
  "WELLIES": "WELLIE, (colloquial) a wellington boot, also WELLY [n]\n",
  "WELLING": "an outpouring [n -S]\n",
  "WELLINGS": "WELLING, an outpouring [n]\n",
  "WELLINGTON": "a type of waterproof boot [n -S]\n",
  "WELLINGTONIA": "a tree of the genus Sequoia [n -S]\n",
  "WELLINGTONIAS": "WELLINGTONIA, a tree of the genus Sequoia [n]\n",
  "WELLINGTONS": "WELLINGTON, a type of waterproof boot [n]\n",
  "WELLNESS": "the state of being well [n -ES]\n",
  "WELLNESSES": "WELLNESS, the state of being well [n]\n",
  "WELLS": "WELL, to rise to the surface and flow forth [v]\n",
  "WELLSITE": "the site of a well [n -S]\n",
  "WELLSITES": "WELLSITE, the site of a well [n]\n",
  "WELLSPRING": "a fountain; a spring; a source of continual supply [n -S]\n",
  "WELLSPRINGS": "WELLSPRING, a fountain; a spring; a source of continual supply [n]\n",
  "WELLY": "(colloquial) a wellington boot, also WELLIE [n WELLIES]\n",
  "WELS": "(German) a large fish, the American giant catfish, introduced into European rivers, aka SHEATFISH [n WELS]\n",
  "WELSH": "to fail to pay a debt, also WELCH [v -ED, -ING, -ES]\n",
  "WELSHED": "WELSH, to fail to pay a debt, also WELCH [v]\n",
  "WELSHER": "one who welches, also WELCHER [n -S]\n",
  "WELSHERS": "WELSHER, one who welches, also WELCHER [n]\n",
  "WELSHES": "WELSH, to fail to pay a debt, also WELCH [v]\n",
  "WELSHING": "WELSH, to fail to pay a debt, also WELCH [v]\n",
  "WELT": "to mark with ridges [v -ED, -ING, -S]\n",
  "WELTANSCHAUUNG": "(German) a comprehensive conception or apprehension of the world, esp. from a specific standpoint [n -S]\n",
  "WELTANSCHAUUNGS": "WELTANSCHAUUNG, (German) a comprehensive conception or apprehension of the world, esp. from a specific standpoint [n]\n",
  "WELTED": "WELT, to mark with ridges [v]\n",
  "WELTER": "to roll about [v -ED, -ING, -S]\n",
  "WELTERED": "WELTER, to roll about [v]\n",
  "WELTERING": "WELTER, to roll about [v]\n",
  "WELTERS": "WELTER, to roll about [v]\n",
  "WELTERWEIGHT": "a weight division in boxing [n -S]\n",
  "WELTERWEIGHTS": "WELTERWEIGHT, a weight division in boxing [n]\n",
  "WELTING": "a beating [n -S]\n",
  "WELTINGS": "WELTING, a beating [n]\n",
  "WELTS": "WELT, to mark with ridges [v]\n",
  "WELTSCHMERZ": "(German) mental depression or apathy caused by comparison of the actual state of the world with an ideal state [n -ES]\n",
  "WELTSCHMERZES": "WELTSCHMERZ, (German) mental depression or apathy caused by comparison of the actual state of the world with an ideal state [n]\n",
  "WELWITSCHIA": "a plant of a SW African genus of one species, with one pair of leaves that grow indefinitely [n -S]\n",
  "WELWITSCHIAS": "WELWITSCHIA, a plant of a SW African genus of one species, with one pair of leaves that grow indefinitely [n]\n",
  "WEM": "(archaic) the womb or belly, also WAME, WEAMB, WEMB [n -S]\n",
  "WEMB": "(dialect) womb, also WAME, WEAMB, WEM [n -S]\n",
  "WEMBS": "WEMB, (dialect) womb, also WAME, WEAMB, WEM [n]\n",
  "WEMS": "WEM, (archaic) the womb or belly, also WAME, WEAMB, WEMB [n]\n",
  "WEN": "a benign tumor of the skin [n -S]\n",
  "WENA": "(South African) you [pron]\n",
  "WENCH": "to consort with prostitutes [v -ED, -ING, -ES]\n",
  "WENCHED": "WENCH, to consort with prostitutes [v]\n",
  "WENCHER": "one who wenches; a lewd man [n -S]\n",
  "WENCHERS": "WENCHER, one who wenches; a lewd man [n]\n",
  "WENCHES": "WENCH, to consort with prostitutes [v]\n",
  "WENCHING": "WENCH, to consort with prostitutes [v]\n",
  "WEND": "to proceed along [v -ED, -ING, -S]\n",
  "WENDED": "WEND, to proceed along [v]\n",
  "WENDIGO": "(Native American) a mythical monster among some North American Indian tribes, that eats human flesh, also WINDIGO [n -ES or -S]\n",
  "WENDIGOES": "WENDIGO, (Native American) a mythical monster among some North American Indian tribes, that eats human flesh, also WINDIGO [n]\n",
  "WENDIGOS": "WENDIGO, (Native American) a mythical monster among some North American Indian tribes, that eats human flesh, also WINDIGO [n]\n",
  "WENDING": "WEND, to proceed along [v]\n",
  "WENDS": "WEND, to proceed along [v]\n",
  "WENGE": "a hardwood tree found in central and West Africa, with dark brown heartwood [n -S]\n",
  "WENGES": "WENGE, a hardwood tree found in central and West Africa, with dark brown heartwood [n]\n",
  "WENNIER": "WENNY, resembling a wen, also WENNISH [adj]\n",
  "WENNIEST": "WENNY, resembling a wen, also WENNISH [adj]\n",
  "WENNISH": "resembling a wen, also WENNY [adj]\n",
  "WENNY": "resembling a wen, also WENNISH [adj WENNIER, WENNIEST]\n",
  "WENS": "WEN, a benign tumor of the skin [n]\n",
  "WENSLEYDALE": "a kind of cheese [n -S]\n",
  "WENSLEYDALES": "WENSLEYDALE, a kind of cheese [n]\n",
  "WENT": "(Spenser) a path, a journey [n -S]\n",
  "WENTLETRAP": "(Dutch) any of a genus of gasteropod molluscs, having a spiral shell with many deep whorls [n -S]\n",
  "WENTLETRAPS": "WENTLETRAP, (Dutch) any of a genus of gasteropod molluscs, having a spiral shell with many deep whorls [n]\n",
  "WENTS": "WENT, (Spenser) a path, a journey [n]\n",
  "WEPT": "WEEP, to shed tears (salty liquid) from the eyes [v]\n",
  "WERE": "BE, to exist [v]\n",
  "WEREGILD": "(Old English) a price paid for taking a man's life, also WERGELD, WERGELT, WERGILD [n -S]\n",
  "WEREGILDS": "WEREGILD, (Old English) a price paid for taking a man's life, also WERGELD, WERGELT, WERGILD [n]\n",
  "WEREWOLF": "a person who supposedly changes into a wolf, also WERWOLF [n WEREWOLVES]\n",
  "WEREWOLFERIES": "WEREWOLFERY, the state of being a werewolf [n]\n",
  "WEREWOLFERY": "the state of being a werewolf [n WEREWOLFERIES]\n",
  "WEREWOLFISH": "like a werewolf, also WERWOLFISH [adj]\n",
  "WEREWOLFISM": "the state of being a werewolf [n -S]\n",
  "WEREWOLFISMS": "WEREWOLFISM, the state of being a werewolf [n]\n",
  "WEREWOLVES": "WEREWOLF, a person who supposedly changes into a wolf, also WERWOLF [n]\n",
  "WERGELD": "(Old English) a price paid for taking a man's life, also WEREGILD, WERGELT, WERGILD [n -S]\n",
  "WERGELDS": "WERGELD, (Old English) a price paid for taking a man's life, also WEREGILD, WERGELT, WERGILD [n]\n",
  "WERGELT": "(Old English) a price paid for taking a man's life, also WEREGILD, WERGELD, WERGILD [n -S]\n",
  "WERGELTS": "WERGELT, (Old English) a price paid for taking a man's life, also WEREGILD, WERGELD, WERGILD [n]\n",
  "WERGILD": "(Old English) a price paid for taking a man's life, also WEREGILD, WERGELD, WERGELT [n -S]\n",
  "WERGILDS": "WERGILD, (Old English) a price paid for taking a man's life, also WEREGILD, WERGELD, WERGELT [n]\n",
  "WERNERITE": "the common grayish or white variety of scapolite [n -S]\n",
  "WERNERITES": "WERNERITE, the common grayish or white variety of scapolite [n]\n",
  "WERO": "(Maori) a challenge made by an armed Maori warrior to a visitor to a marae [n -S]\n",
  "WEROS": "WERO, (Maori) a challenge made by an armed Maori warrior to a visitor to a marae [n]\n",
  "WERRIS": "(Australian slang) urination, rhyming slang for Werris Creek, a leak [n -ES]\n",
  "WERRISES": "WERRIS, (Australian slang) urination, rhyming slang for Werris Creek, a leak [n]\n",
  "WERSH": "(Scots) tasteless, insipid, also WAIRSH [adj WERSHER, WERSHEST]\n",
  "WERSHER": "WERSH, (Scots) tasteless, insipid, also WAIRSH [adj]\n",
  "WERSHEST": "WERSH, (Scots) tasteless, insipid, also WAIRSH [adj]\n",
  "WERT": "BE, to exist [v]\n",
  "WERWOLF": "a person who supposedly changes into a wolf, also WEREWOLF [n WERWOLVES]\n",
  "WERWOLFISH": "like a werwolf, also WEREWOLFISH [adj]\n",
  "WERWOLVES": "WERWOLF, a person who supposedly changes into a wolf, also WEREWOLF [n]\n",
  "WESAND": "(Spenser) the windpipe, also WEASAND, WEASON, WEAZAND, WESSAND, WEZAND, WIZZEN [n -S]\n",
  "WESANDS": "WESAND, (Spenser) the windpipe, also WEASAND, WEASON, WEAZAND, WESSAND, WEZAND, WIZZEN [n]\n",
  "WESKIT": "(colloquial) a waistcoat [n -S]\n",
  "WESKITS": "WESKIT, (colloquial) a waistcoat [n]\n",
  "WESSAND": "(Old English) the windpipe, also WEASAND, WEASON, WEAZAND, WESAND, WEZAND, WIZZEN [n -S]\n",
  "WESSANDS": "WESSAND, (Old English) the windpipe, also WEASAND, WEASON, WEAZAND, WESAND, WEZAND, WIZZEN [n]\n",
  "WEST": "a part of the compass, also WAST [n -S] / to move towards the west, also WESTER [v -ED, -ING, -S]\n",
  "WESTABOUT": "towards the west [adj]\n",
  "WESTBOUND": "heading in a westerly direction [adj]\n",
  "WESTED": "WEST, to move towards the west, also WESTER [v]\n",
  "WESTER": "to move towards the west, also WEST [v -ED, -ING, -S]\n",
  "WESTERED": "WESTER, to move towards the west, also WEST [v]\n",
  "WESTERING": "motion towards the west [n -S]\n",
  "WESTERINGS": "WESTERING, motion towards the west [n]\n",
  "WESTERLIES": "WESTERLY, a wind from the west [n]\n",
  "WESTERLINESS": "the state of being westerly [n -ES]\n",
  "WESTERLINESSES": "WESTERLINESS, the state of being westerly [n]\n",
  "WESTERLY": "a wind from the west [n WESTERLIES]\n",
  "WESTERN": "a film, book etc. concerned with life in the early west of the USA [n -S]\n",
  "WESTERNER": "one who lives in or comes from the west [n -S]\n",
  "WESTERNERS": "WESTERNER, one who lives in or comes from the west [n]\n",
  "WESTERNISATION": "conversion to or adoption of western traditions or techniques, also WESTERNIZATION [n -S]\n",
  "WESTERNISATIONS": "WESTERNISATION, conversion to or adoption of western traditions or techniques, also WESTERNIZATION [n]\n",
  "WESTERNISE": "to make western, also WESTERNIZE [v WESTERNISED, WESTERNISING, WESTERNISES]\n",
  "WESTERNISED": "WESTERNISE, to make western, also WESTERNIZE [v]\n",
  "WESTERNISES": "WESTERNISE, to make western, also WESTERNIZE [v]\n",
  "WESTERNISING": "WESTERNISE, to make western, also WESTERNIZE [v]\n",
  "WESTERNISM": "an idiom or other characteristic of western people [n -S]\n",
  "WESTERNISMS": "WESTERNISM, an idiom or other characteristic of western people [n]\n",
  "WESTERNIZATION": "conversion to or adoption of western traditions or techniques, also WESTERNISATION [n -S]\n",
  "WESTERNIZATIONS": "WESTERNIZATION, conversion to or adoption of western traditions or techniques, also WESTERNISATION [n]\n",
  "WESTERNIZE": "to make western, also WESTERNISE [v WESTERNIZED, WESTERNIZING, WESTERNIZES]\n",
  "WESTERNIZED": "WESTERNIZE, to make western, also WESTERNISE [v]\n",
  "WESTERNIZES": "WESTERNIZE, to make western, also WESTERNISE [v]\n",
  "WESTERNIZING": "WESTERNIZE, to make western, also WESTERNISE [v]\n",
  "WESTERNMOST": "most to the west [adj]\n",
  "WESTERNS": "WESTERN, a film, book etc. concerned with life in the early west of the USA [n]\n",
  "WESTERS": "WESTER, to move towards the west, also WEST [v]\n",
  "WESTIE": "(Australian slang) a young working-class person from the western suburbs of Sydney [n -S]\n",
  "WESTIES": "WESTIE, (Australian slang) a young working-class person from the western suburbs of Sydney [n]\n",
  "WESTING": "a motion towards the west [n -S]\n",
  "WESTINGS": "WESTING, a motion towards the west [n]\n",
  "WESTLIN": "(Scots) towards the west, also WESTLINS [adj]\n",
  "WESTLINS": "(Scots) to or in the west, also WESTLIN [adv]\n",
  "WESTMOST": "farthest west [adj]\n",
  "WESTS": "WEST, to move towards the west, also WESTER [v]\n",
  "WESTWARD": "in a westerly direction, also WESTWARDS [adv WESTWARDLY]\n",
  "WESTWARDLY": "in a westward direction [adv]\n",
  "WESTWARDS": "in a westerly direction, also WESTWARD [adv]\n",
  "WET": "not dry [adj WETTER, WETTEST, WETLY] / to make wet [v WETTED, WETTING, WETS]\n",
  "WETA": "(Maori) a large New Zealand grasshopper [n -S]\n",
  "WETAS": "WETA, (Maori) a large New Zealand grasshopper [n]\n",
  "WETBACK": "someone illegally entering the USA by swimming the Rio Grande [n -S]\n",
  "WETBACKS": "WETBACK, someone illegally entering the USA by swimming the Rio Grande [n]\n",
  "WETHER": "a castrated ram [n -S]\n",
  "WETHERS": "WETHER, a castrated ram [n]\n",
  "WETLAND": "marshy land [n -S]\n",
  "WETLANDS": "WETLAND, marshy land [n]\n",
  "WETLY": "WET, not dry [adv]\n",
  "WETNESS": "the state of being wet [n -ES]\n",
  "WETNESSES": "WETNESS, the state of being wet [n]\n",
  "WETPROOF": "waterproof [adj]\n",
  "WETS": "WET, to make wet [v]\n",
  "WETSUIT": "a close-fitting rubberlike suit worn in cold water by skin divers [n -S]\n",
  "WETSUITS": "WETSUIT, a close-fitting rubberlike suit worn in cold water by skin divers [n]\n",
  "WETTABILITIES": "WETTABILITY, the ability to be wetted [n]\n",
  "WETTABILITY": "the ability to be wetted [n WETTABILITIES]\n",
  "WETTABLE": "capable of being wetted [adj]\n",
  "WETTED": "WET, to make wet [v]\n",
  "WETTER": "something that wets [n -S]\n",
  "WETTERS": "WETTER, something that wets [n]\n",
  "WETTEST": "WET, not dry [adj]\n",
  "WETTIE": "(New Zealand) a wetsuit [n -S]\n",
  "WETTIES": "WETTIE, (New Zealand) a wetsuit [n]\n",
  "WETTING": "a liquid used for moisturising [n -S]\n",
  "WETTINGS": "WETTING, a liquid used for moisturising [n]\n",
  "WETTISH": "somewhat wet [adj]\n",
  "WETWARE": "the living human brain, viewed as part of a computer system [n -S]\n",
  "WETWARES": "WETWARE, the living human brain, viewed as part of a computer system [n]\n",
  "WEX": "(obsolete) to wax, grow, also WEXE [v WEXED, WEXING, WEXES]\n",
  "WEXE": "(obsolete) to wax, grow, also WEX [v WEXED, WEXING, WEXES]\n",
  "WEXED": "WEX, (obsolete) to wax, grow, also WEXE [v]\n",
  "WEXES": "WEX, (obsolete) to wax, grow, also WEXE [v]\n",
  "WEXING": "WEX, (obsolete) to wax, grow, also WEXE [v]\n",
  "WEY": "a measure or weight for dry goods [n -S]\n",
  "WEYARD": "(Shakespeare) weird, also WEYWARD [adj]\n",
  "WEYS": "WEY, a measure or weight for dry goods [n]\n",
  "WEYWARD": "(Shakespeare) weird, also WEYARD [adj]\n",
  "WEZAND": "(obsolete) the windpipe, also WEASAND, WEASON, WEAZAND, WESAND, WESSAND, WIZZEN [n -S]\n",
  "WEZANDS": "WEZAND, (obsolete) the windpipe, also WEASAND, WEASON, WEAZAND, WESAND, WESSAND, WIZZEN [n]\n",
  "WHA": "(Scots) who, also WHAE [pron]\n",
  "WHACK": "to strike sharply [v -ED, -ING, -S]\n",
  "WHACKED": "WHACK, to strike sharply [v]\n",
  "WHACKER": "(Australian slang) a likeable funny fool, also WACKER [n -S]\n",
  "WHACKERS": "WHACKER, (Australian slang) a likeable funny fool, also WACKER [n]\n",
  "WHACKIER": "WHACKY, eccentric, also WACKY [adj]\n",
  "WHACKIEST": "WHACKY, eccentric, also WACKY [adj]\n",
  "WHACKING": "a beating [n -S]\n",
  "WHACKINGS": "WHACKING, a beating [n]\n",
  "WHACKO": "an eccentric person, also WACK, WACKO [n -ES or -S]\n",
  "WHACKOES": "WHACKO, an eccentric person, also WACK, WACKO [n]\n",
  "WHACKOS": "WHACKO, an eccentric person, also WACK, WACKO [n]\n",
  "WHACKS": "WHACK, to strike sharply [v]\n",
  "WHACKY": "eccentric, also WACKY [adj WHACKIER, WHACKIEST]\n",
  "WHAE": "(Scots) who, also WHA [pron]\n",
  "WHAIKORERO": "(Maori) formal speechmaking as forming part of the ceremonies at a marae [n -S]\n",
  "WHAIKOREROS": "WHAIKORERO, (Maori) formal speechmaking as forming part of the ceremonies at a marae [n]\n",
  "WHAISLE": "(Scots) to wheeze, also WHAIZLE [v WHAISLED, WHAISLING, WHAISLES]\n",
  "WHAISLED": "WHAISLE, (Scots) to wheeze, also WHAIZLE [v]\n",
  "WHAISLES": "WHAISLE, (Scots) to wheeze, also WHAIZLE [v]\n",
  "WHAISLING": "WHAISLE, (Scots) to wheeze, also WHAIZLE [v]\n",
  "WHAIZLE": "(Scots) to wheeze, also WHAISLE [v WHAIZLED, WHAIZLING, WHAIZLES]\n",
  "WHAIZLED": "WHAIZLE, (Scots) to wheeze, also WHAISLE [v]\n",
  "WHAIZLES": "WHAIZLE, (Scots) to wheeze, also WHAISLE [v]\n",
  "WHAIZLING": "WHAIZLE, (Scots) to wheeze, also WHAISLE [v]\n",
  "WHAKAIRO": "(Maori) the art of carving [n -S]\n",
  "WHAKAIROS": "WHAKAIRO, (Maori) the art of carving [n]\n",
  "WHAKAPAPA": "(Maori) a family tree [n -S]\n",
  "WHAKAPAPAS": "WHAKAPAPA, (Maori) a family tree [n]\n",
  "WHALE": "any of an order of cetaceous mammals [n -S] / to hunt whales [v WHALED, WHALING, WHALES]\n",
  "WHALEBACK": "a kind of steamboat used on the Great Lakes to carry grain, etc. having a rounded upper deck [n -S]\n",
  "WHALEBACKS": "WHALEBACK, a kind of steamboat used on the Great Lakes to carry grain, etc. having a rounded upper deck [n]\n",
  "WHALEBOAT": "a boat used for catching whales [n -S]\n",
  "WHALEBOATS": "WHALEBOAT, a boat used for catching whales [n]\n",
  "WHALEBONE": "a light flexible substance consisting of the baleen plates of whales [n -S]\n",
  "WHALEBONES": "WHALEBONE, a light flexible substance consisting of the baleen plates of whales [n]\n",
  "WHALED": "WHALE, to hunt whales [v]\n",
  "WHALELIKE": "like a whale [adj]\n",
  "WHALEMAN": "a whaler [n WHALEMEN]\n",
  "WHALEMEN": "WHALEMAN, a whaler [n]\n",
  "WHALER": "a person who hunts whales [n -S]\n",
  "WHALERIES": "WHALERY, whaling [n]\n",
  "WHALERS": "WHALER, a person who hunts whales [n]\n",
  "WHALERY": "whaling [n WHALERIES]\n",
  "WHALES": "WHALE, to hunt whales [v]\n",
  "WHALING": "the business of catching whales [n -S]\n",
  "WHALINGS": "WHALING, the business of catching whales [n]\n",
  "WHALLY": "(Spenser) walleyed, showing the whites of the eye [adj]\n",
  "WHAM": "to hit with a loud impact [v WHAMMED, WHAMMING, WHAMS]\n",
  "WHAMMED": "WHAM, to hit with a loud impact [v]\n",
  "WHAMMIES": "WHAMMY, (colloquial) a malevolent spell or influence [n]\n",
  "WHAMMING": "WHAM, to hit with a loud impact [v]\n",
  "WHAMMO": "impressive verve, also WHAMO [n -S]\n",
  "WHAMMOS": "WHAMMO, impressive verve, also WHAMO [n]\n",
  "WHAMMY": "(colloquial) a malevolent spell or influence [n WHAMMIES]\n",
  "WHAMO": "whammo [interj]\n",
  "WHAMPLE": "(Scots) a blow [n -S]\n",
  "WHAMPLES": "WHAMPLE, (Scots) a blow [n]\n",
  "WHAMS": "WHAM, to hit with a loud impact [v]\n",
  "WHANAU": "(Maori) a family, especially an extended one [n -S]\n",
  "WHANAUS": "WHANAU, (Maori) a family, especially an extended one [n]\n",
  "WHANG": "to beat with a whip [v -ED, -ING, -S]\n",
  "WHANGAM": "(Goldsmith) an imaginary animal [n -S]\n",
  "WHANGAMS": "WHANGAM, (Goldsmith) an imaginary animal [n]\n",
  "WHANGED": "WHANG, to beat with a whip [v]\n",
  "WHANGEE": "(Chinese) a kind of grass related to the bamboo; a cane made from the stem of this [n -S]\n",
  "WHANGEES": "WHANGEE, (Chinese) a kind of grass related to the bamboo; a cane made from the stem of this [n]\n",
  "WHANGING": "WHANG, to beat with a whip [v]\n",
  "WHANGS": "WHANG, to beat with a whip [v]\n",
  "WHAP": "to strike forcibly, also WHOP [v WHAPPED, WHAPPING, WHAPS]\n",
  "WHAPPED": "WHAP, to strike forcibly, also WHOP [v]\n",
  "WHAPPER": "something unusually large, also WHOPPER [n -S]\n",
  "WHAPPERS": "WHAPPER, something unusually large, also WHOPPER [n]\n",
  "WHAPPING": "WHAP, to strike forcibly, also WHOP [v]\n",
  "WHAPS": "WHAP, to strike forcibly, also WHOP [v]\n",
  "WHARE": "(Maori) a house [n -S]\n",
  "WHARENUI": "(Maori) a tall carved building used as a guesthouse, also WHAREPUNI [n -S]\n",
  "WHARENUIS": "WHARENUI, (Maori) a tall carved building used as a guesthouse, also WHAREPUNI [n]\n",
  "WHAREPUNI": "(Maori) a tall carved building used as a guesthouse, also WHARENUI [n -S]\n",
  "WHAREPUNIS": "WHAREPUNI, (Maori) a tall carved building used as a guesthouse, also WHARENUI [n]\n",
  "WHARES": "WHARE, (Maori) a house [n]\n",
  "WHARF": "a landing stage, built esp. along the shore, for loading or unloading vessels [n WHARFS or WHARVES] / to place on a wharf; to strengthen by the building of a wharf [v -ED, -ING, -S]\n",
  "WHARFAGE": "the fee or duty paid for the privilege of using a wharf for loading or unloading goods [n -S]\n",
  "WHARFAGES": "WHARFAGE, the fee or duty paid for the privilege of using a wharf for loading or unloading goods [n]\n",
  "WHARFED": "WHARF, to place on a wharf; to strengthen by the building of a wharf [v]\n",
  "WHARFIE": "(Australian slang) a wharf labourer [n -S]\n",
  "WHARFIES": "WHARFIE, (Australian slang) a wharf labourer [n]\n",
  "WHARFING": "material used for making wharfs [n -S]\n",
  "WHARFINGER": "the keeper or owner of a wharf [n -S]\n",
  "WHARFINGERS": "WHARFINGER, the keeper or owner of a wharf [n]\n",
  "WHARFINGS": "WHARFING, material used for making wharfs [n]\n",
  "WHARFMASTER": "one who controls a wharf [n -S]\n",
  "WHARFMASTERS": "WHARFMASTER, one who controls a wharf [n]\n",
  "WHARFS": "WHARF, to place on a wharf; to strengthen by the building of a wharf [v]\n",
  "WHARVE": "a disc on the lower part of a spindle serving as a flywheel, also WHERVE [n -S]\n",
  "WHARVES": "WHARVE, a disc on the lower part of a spindle serving as a flywheel, also WHERVE [n]\n",
  "WHAT": "the true nature of something [n -S]\n",
  "WHATA": "(Maori) a building on stilts or a raised platform for storing provisions [n -S]\n",
  "WHATABOUTERIES": "WHATABOUTERY, (of two communities in conflict) the practice of repeatedly blaming the other side and referring to events from the past [n]\n",
  "WHATABOUTERY": "(of two communities in conflict) the practice of repeatedly blaming the other side and referring to events from the past [n WHATABOUTERIES]\n",
  "WHATABOUTISM": "(Of two communities in conflict) the practice of repeatedly raising grievances from the past during negotiations [n -S]\n",
  "WHATABOUTISMS": "WHATABOUTISM, (Of two communities in conflict) the practice of repeatedly raising grievances from the past during negotiations [n]\n",
  "WHATABOUTS": "things with which one is occupied [n]\n",
  "WHATAS": "WHATA, (Maori) a building on stilts or a raised platform for storing provisions [n]\n",
  "WHATCHA": "(colloquial) what are you, used as a greeting, also WATCHA, WOTCHA, WOTCHER [interj]\n",
  "WHATCHAMACALLIT": "a whatsit [n]\n",
  "WHATEN": "(dialect) what kind of, also WHATNA, WHATTEN [adj]\n",
  "WHATEVER": "being what it may [adj]\n",
  "WHATEVS": "(slang) whatever [interj]\n",
  "WHATNA": "(dialect) what kind of, also WHATEN, WHATTEN [adj]\n",
  "WHATNESS": "the true nature of something [n -ES]\n",
  "WHATNESSES": "WHATNESS, the true nature of something [n]\n",
  "WHATNOT": "a type of display stand [n -S]\n",
  "WHATNOTS": "WHATNOT, a type of display stand [n]\n",
  "WHATS": "WHAT, the true nature of something [n]\n",
  "WHATSERNAME": "a girl or woman whose name is unknown, temporarily forgotten, or deliberately overlooked, also WHATSHERNAME [n -S]\n",
  "WHATSERNAMES": "WHATSERNAME, a girl or woman whose name is unknown, temporarily forgotten, or deliberately overlooked, also WHATSHERNAME [n]\n",
  "WHATSHERNAME": "a designation for a female whose name one cannot remember, also WHATSERNAME [n -S]\n",
  "WHATSHERNAMES": "WHATSHERNAME, a designation for a female whose name one cannot remember, also WHATSERNAME [n]\n",
  "WHATSHISNAME": "a designation for a male whose name one cannot remember, also WHATSISNAME [n -S]\n",
  "WHATSHISNAMES": "WHATSHISNAME, a designation for a male whose name one cannot remember, also WHATSISNAME [n]\n",
  "WHATSIS": "something whose name is unknown, also WHATSIT [n -ES]\n",
  "WHATSISES": "WHATSIS, something whose name is unknown, also WHATSIT [n]\n",
  "WHATSISNAME": "a man whose name is unknown, temporarily forgotten, or deliberately overlooked, also WHATSHISNAME [n -S]\n",
  "WHATSISNAMES": "WHATSISNAME, a man whose name is unknown, temporarily forgotten, or deliberately overlooked, also WHATSHISNAME [n]\n",
  "WHATSIT": "something whose name is unknown, also WHATSIS [n -S]\n",
  "WHATSITS": "WHATSIT, something whose name is unknown, also WHATSIS [n]\n",
  "WHATSITSNAME": "a designation for a thing whose name one cannot remember [n -S]\n",
  "WHATSITSNAMES": "WHATSITSNAME, a designation for a thing whose name one cannot remember [n]\n",
  "WHATSO": "whatever kind [adj]\n",
  "WHATSOEVER": "whatever [pron]\n",
  "WHATSOMEVER": "(dialect) whatsoever [pron]\n",
  "WHATTEN": "(dialect) what kind of, also WHATEN, WHATNA [adj]\n",
  "WHAUP": "(Scots) a curlew, sometimes great whaup as distinct from little whaup, the whimbrel [n -S]\n",
  "WHAUPS": "WHAUP, (Scots) a curlew, sometimes great whaup as distinct from little whaup, the whimbrel [n]\n",
  "WHAUR": "(Scots) where, also WHEAR, WHEARE [n -S]\n",
  "WHAURS": "WHAUR, (Scots) where, also WHEAR, WHEARE [n]\n",
  "WHEAL": "a raised mark on the skin left by a blow, also WALE, WEAL [n -S]\n",
  "WHEALS": "WHEAL, a raised mark on the skin left by a blow, also WALE, WEAL [n]\n",
  "WHEAR": "(obsolete) where, also WHAUR, WHEARE [conj]\n",
  "WHEARE": "(obsolete) where, also WHAUR, WHEAR [conj]\n",
  "WHEAT": "any cereal grass of the genus Triticum [n -S]\n",
  "WHEATEAR": "any of several birds of the genus Oenanthe, which have black tails and conspicuous white rumps [n -S]\n",
  "WHEATEARS": "WHEATEAR, any of several birds of the genus Oenanthe, which have black tails and conspicuous white rumps [n]\n",
  "WHEATEN": "the golden colour of ripe wheat [n -S]\n",
  "WHEATENS": "WHEATEN, the golden colour of ripe wheat [n]\n",
  "WHEATFIELD": "a field of wheat [n -S]\n",
  "WHEATFIELDS": "WHEATFIELD, a field of wheat [n]\n",
  "WHEATGERM": "the vitamin-rich embryo of the wheat kernel [n -S]\n",
  "WHEATGERMS": "WHEATGERM, the vitamin-rich embryo of the wheat kernel [n]\n",
  "WHEATGRASS": "a young plant of the genus Agropyron, a relative of wheat, popular as a health food [n -ES]\n",
  "WHEATGRASSES": "WHEATGRASS, a young plant of the genus Agropyron, a relative of wheat, popular as a health food [n]\n",
  "WHEATIER": "WHEATY, tasting of wheat [adj]\n",
  "WHEATIEST": "WHEATY, tasting of wheat [adj]\n",
  "WHEATLAND": "land on which wheat is grown [n -S]\n",
  "WHEATLANDS": "WHEATLAND, land on which wheat is grown [n]\n",
  "WHEATLESS": "without wheat [adj]\n",
  "WHEATLIKE": "like wheat [adj]\n",
  "WHEATMEAL": "wheat flour with some of the germ and bran removed [n -S]\n",
  "WHEATMEALS": "WHEATMEAL, wheat flour with some of the germ and bran removed [n]\n",
  "WHEATS": "WHEAT, any cereal grass of the genus Triticum [n]\n",
  "WHEATWORM": "a small nematode worm which attacks the grains of wheat in the ear [n -S]\n",
  "WHEATWORMS": "WHEATWORM, a small nematode worm which attacks the grains of wheat in the ear [n]\n",
  "WHEATY": "tasting of wheat [adj WHEATIER, WHEATIEST]\n",
  "WHEE": "an expression of delight [interj]\n",
  "WHEECH": "(Scots) to move rapidly with a whizzing sound [v -ED, -ING, -S]\n",
  "WHEECHED": "WHEECH, (Scots) to move rapidly with a whizzing sound [v]\n",
  "WHEECHING": "WHEECH, (Scots) to move rapidly with a whizzing sound [v]\n",
  "WHEECHS": "WHEECH, (Scots) to move rapidly with a whizzing sound [v]\n",
  "WHEEDLE": "to entice by soft words, also WHILLY [v WHEEDLED, WHEEDLING, WHEEDLES]\n",
  "WHEEDLED": "WHEEDLE, to entice by soft words, also WHILLY [v]\n",
  "WHEEDLER": "one who wheedles [n -S]\n",
  "WHEEDLERS": "WHEEDLER, one who wheedles [n]\n",
  "WHEEDLES": "WHEEDLE, to entice by soft words, also WHILLY [v]\n",
  "WHEEDLESOME": "coaxing [adj]\n",
  "WHEEDLING": "enticing by soft words or flattery [adj WHEEDLINGLY] / the act of wheedling [n -S]\n",
  "WHEEDLINGLY": "WHEEDLING, enticing by soft words or flattery [adv]\n",
  "WHEEDLINGS": "WHEEDLING, the act of wheedling [n]\n",
  "WHEEL": "to cause to revolve [v -ED, -ING, -S]\n",
  "WHEELBARROW": "a barrow with one wheel in front and two handles and legs behind, also HURLBARROW [n -S] / to transport by wheelbarrow [v -ED, -ING, -S]\n",
  "WHEELBARROWED": "WHEELBARROW, to transport by wheelbarrow [v]\n",
  "WHEELBARROWING": "WHEELBARROW, to transport by wheelbarrow [v]\n",
  "WHEELBARROWS": "WHEELBARROW, a barrow with one wheel in front and two handles and legs behind, also HURLBARROW [n]\n",
  "WHEELBASE": "the distance between the front and rear axles of a vehicle [n -S]\n",
  "WHEELBASES": "WHEELBASE, the distance between the front and rear axles of a vehicle [n]\n",
  "WHEELCHAIR": "a chair mounted on wheels esp. for the use of disabled persons [n -S]\n",
  "WHEELCHAIRS": "WHEELCHAIR, a chair mounted on wheels esp. for the use of disabled persons [n]\n",
  "WHEELED": "WHEEL, to cause to revolve [v]\n",
  "WHEELER": "one who wheels, or turns [n -S]\n",
  "WHEELERS": "WHEELER, one who wheels, or turns [n]\n",
  "WHEELHORSE": "one of the horses next to the wheel in a team [n -S]\n",
  "WHEELHORSES": "WHEELHORSE, one of the horses next to the wheel in a team [n]\n",
  "WHEELHOUSE": "a shelter where a ship's steering wheel is kept [n -S]\n",
  "WHEELHOUSES": "WHEELHOUSE, a shelter where a ship's steering wheel is kept [n]\n",
  "WHEELIE": "a manoeuvre on a bicycle or skateboard [n -S]\n",
  "WHEELIER": "WHEELY, like a wheel [adj]\n",
  "WHEELIES": "WHEELIE, a manoeuvre on a bicycle or skateboard [n]\n",
  "WHEELIEST": "WHEELY, like a wheel [adj]\n",
  "WHEELING": "the condition of a road for vehicles [n -S]\n",
  "WHEELINGS": "WHEELING, the condition of a road for vehicles [n]\n",
  "WHEELLESS": "without wheels [adj]\n",
  "WHEELMAN": "a steersman, also WHEELSMAN [n WHEELMEN]\n",
  "WHEELMEN": "WHEELMAN, a steersman, also WHEELSMAN [n]\n",
  "WHEELS": "WHEEL, to cause to revolve [v]\n",
  "WHEELSMAN": "a steersman, also WHEELMAN [n WHEELSMEN]\n",
  "WHEELSMEN": "WHEELSMAN, a steersman, also WHEELMAN [n]\n",
  "WHEELSPIN": "the rotation of a wheel when it is not achieving any grip or traction on a surface [n -S]\n",
  "WHEELSPINS": "WHEELSPIN, the rotation of a wheel when it is not achieving any grip or traction on a surface [n]\n",
  "WHEELWORK": "a combination of wheels, and their connection, in a machine or mechanism [n -S]\n",
  "WHEELWORKS": "WHEELWORK, a combination of wheels, and their connection, in a machine or mechanism [n]\n",
  "WHEELWRIGHT": "a maker and repairer of wheels and wheeled vehicles [n -S]\n",
  "WHEELWRIGHTS": "WHEELWRIGHT, a maker and repairer of wheels and wheeled vehicles [n]\n",
  "WHEELY": "like a wheel [adj WHEELIER, WHEELIEST]\n",
  "WHEEN": "(Scots) a few, a good many [n -S]\n",
  "WHEENGE": "(Scots) to whinge [v WHEENGED, WHEENGING, WHEENGES]\n",
  "WHEENGED": "WHEENGE, (Scots) to whinge [v]\n",
  "WHEENGES": "WHEENGE, (Scots) to whinge [v]\n",
  "WHEENGING": "WHEENGE, (Scots) to whinge [v]\n",
  "WHEENS": "WHEEN, (Scots) a few, a good many [n]\n",
  "WHEEP": "(Scots) to give a prolonged whistle, also WHEEPLE [v -ED, -ING, -S]\n",
  "WHEEPED": "WHEEP, (Scots) to give a prolonged whistle, also WHEEPLE [v]\n",
  "WHEEPING": "WHEEP, (Scots) to give a prolonged whistle, also WHEEPLE [v]\n",
  "WHEEPLE": "(Scots) to give a prolonged whistle, also WHEEP [v WHEEPLED, WHEEPLING, WHEEPLES]\n",
  "WHEEPLED": "WHEEPLE, (Scots) to give a prolonged whistle, also WHEEP [v]\n",
  "WHEEPLES": "WHEEPLE, (Scots) to give a prolonged whistle, also WHEEP [v]\n",
  "WHEEPLING": "WHEEPLE, (Scots) to give a prolonged whistle, also WHEEP [v]\n",
  "WHEEPS": "WHEEP, (Scots) to give a prolonged whistle, also WHEEPLE [v]\n",
  "WHEESH": "(Scots) to call for silence, also WHEESHT, WHISHT [v -ED, -ING, -ES]\n",
  "WHEESHED": "WHEESH, (Scots) to call for silence, also WHEESHT, WHISHT [v]\n",
  "WHEESHES": "WHEESH, (Scots) to call for silence, also WHEESHT, WHISHT [v]\n",
  "WHEESHING": "WHEESH, (Scots) to call for silence, also WHEESHT, WHISHT [v]\n",
  "WHEESHT": "(Scots) to call for silence, also WHEESH, WHISHT [v -ED, -ING, -S]\n",
  "WHEESHTED": "WHEESHT, (Scots) to call for silence, also WHEESH, WHISHT [v]\n",
  "WHEESHTING": "WHEESHT, (Scots) to call for silence, also WHEESH, WHISHT [v]\n",
  "WHEESHTS": "WHEESHT, (Scots) to call for silence, also WHEESH, WHISHT [v]\n",
  "WHEEZE": "to breathe with a hissing sound, also WHAISLE, WHAIZLE, WHEEZLE [v WHEEZED, WHEEZING, WHEEZES]\n",
  "WHEEZED": "WHEEZE, to breathe with a hissing sound, also WHAISLE, WHAIZLE, WHEEZLE [v]\n",
  "WHEEZER": "one who wheezes [n -S]\n",
  "WHEEZERS": "WHEEZER, one who wheezes [n]\n",
  "WHEEZES": "WHEEZE, to breathe with a hissing sound, also WHAISLE, WHAIZLE, WHEEZLE [v]\n",
  "WHEEZIER": "WHEEZY, given to wheezing [adj]\n",
  "WHEEZIEST": "WHEEZY, given to wheezing [adj]\n",
  "WHEEZILY": "WHEEZY, given to wheezing [adv]\n",
  "WHEEZINESS": "the state of being wheezy [n -ES]\n",
  "WHEEZINESSES": "WHEEZINESS, the state of being wheezy [n]\n",
  "WHEEZING": "breathing with a hissing sound [adj WHEEZINGLY] / the act of wheezing [n -S]\n",
  "WHEEZINGLY": "WHEEZING, breathing with a hissing sound [adv]\n",
  "WHEEZINGS": "WHEEZING, the act of wheezing [n]\n",
  "WHEEZLE": "(Scots) to wheeze, also WHAISLE, WHAIZLE, WHEEZE [v WHEEZLED, WHEEZLING, WHEEZLES]\n",
  "WHEEZLED": "WHEEZLE, (Scots) to wheeze, also WHAISLE, WHAIZLE, WHEEZE [v]\n",
  "WHEEZLES": "WHEEZLE, (Scots) to wheeze, also WHAISLE, WHAIZLE, WHEEZE [v]\n",
  "WHEEZLING": "WHEEZLE, (Scots) to wheeze, also WHAISLE, WHAIZLE, WHEEZE [v]\n",
  "WHEEZY": "given to wheezing [adj WHEEZIER, WHEEZIEST, WHEEZILY]\n",
  "WHEFT": "a flag, ensign, etc., knotted at the centre [n -S]\n",
  "WHEFTS": "WHEFT, a flag, ensign, etc., knotted at the centre [n]\n",
  "WHELK": "a popular name for a number of marine gastropods [n -S]\n",
  "WHELKED": "ridged like a whelk [adj]\n",
  "WHELKIER": "WHELKY, marked with whelks [adj]\n",
  "WHELKIEST": "WHELKY, marked with whelks [adj]\n",
  "WHELKS": "WHELK, a popular name for a number of marine gastropods [n]\n",
  "WHELKY": "marked with whelks [adj WHELKIER, WHELKIEST]\n",
  "WHELM": "(archaic) to cover or engulf completely with usually disastrous effect [v -ED, -ING, -S]\n",
  "WHELMED": "WHELM, (archaic) to cover or engulf completely with usually disastrous effect [v]\n",
  "WHELMING": "WHELM, (archaic) to cover or engulf completely with usually disastrous effect [v]\n",
  "WHELMS": "WHELM, (archaic) to cover or engulf completely with usually disastrous effect [v]\n",
  "WHELP": "to give birth [v -ED, -ING, -S]\n",
  "WHELPED": "WHELP, to give birth [v]\n",
  "WHELPING": "WHELP, to give birth [v]\n",
  "WHELPLESS": "without a whelp [adj]\n",
  "WHELPS": "WHELP, to give birth [v]\n",
  "WHEMMLE": "to overturn; to throw into a state of disorder, also WHOMBLE, WHOMMLE, WHUMMLE [v WHEMMLED, WHEMMLING, WHEMMLES]\n",
  "WHEMMLED": "WHEMMLE, to overturn; to throw into a state of disorder, also WHOMBLE, WHOMMLE, WHUMMLE [v]\n",
  "WHEMMLES": "WHEMMLE, to overturn; to throw into a state of disorder, also WHOMBLE, WHOMMLE, WHUMMLE [v]\n",
  "WHEMMLING": "WHEMMLE, to overturn; to throw into a state of disorder, also WHOMBLE, WHOMMLE, WHUMMLE [v]\n",
  "WHEN": "the time at which something happened [n -S]\n",
  "WHENAS": "at which time [conj]\n",
  "WHENCE": "a place of origin [n -S]\n",
  "WHENCEFORTH": "(Spenser) whence [adv]\n",
  "WHENCES": "WHENCE, a place of origin [n]\n",
  "WHENCESOEVER": "from whatsoever place or source [adv]\n",
  "WHENCEVER": "from whatsoever place [adv]\n",
  "WHENEVER": "at whatever time [adv]\n",
  "WHENS": "WHEN, the time at which something happened [n]\n",
  "WHENSOEVER": "at any time whatever [adv]\n",
  "WHENUA": "(Maori) land [n -S]\n",
  "WHENUAS": "WHENUA, (Maori) land [n]\n",
  "WHENWE": "(South African) a white immigrant from Zimbabwe with rosy memories of the past [n -S]\n",
  "WHENWES": "WHENWE, (South African) a white immigrant from Zimbabwe with rosy memories of the past [n]\n",
  "WHERE": "the place at or in which something is located or occurs, also WHAUR, WHEAR, WHEARE [n WHERES]\n",
  "WHEREABOUT": "one's (approximate) location, also WHEREABOUTS [n]\n",
  "WHEREABOUTS": "one's (approximate) location, also WHEREABOUT [n]\n",
  "WHEREAFTER": "after which [adv]\n",
  "WHEREAGAINST": "(archaic) against which [adv]\n",
  "WHEREAS": "an introduction of a formal document [n -ES]\n",
  "WHEREASES": "WHEREAS, an introduction of a formal document [n]\n",
  "WHEREAT": "at what [adv]\n",
  "WHEREBY": "by which [adv]\n",
  "WHEREFOR": "a reason why, also WHEREFORE [n -S]\n",
  "WHEREFORE": "a reason why, also WHEREFOR [n -S]\n",
  "WHEREFORES": "WHEREFORE, a reason why, also WHEREFOR [n]\n",
  "WHEREFORS": "WHEREFOR, a reason why, also WHEREFORE [n]\n",
  "WHEREFROM": "from where [adv]\n",
  "WHEREIN": "in which place [adv]\n",
  "WHEREINSOEVER": "in whatsoever respect or place [adv]\n",
  "WHEREINTO": "into which; into what [adv]\n",
  "WHERENESS": "the state of having a place [n -ES]\n",
  "WHERENESSES": "WHERENESS, the state of having a place [n]\n",
  "WHEREOF": "of what [adv]\n",
  "WHEREON": "on which [adv]\n",
  "WHEREOUT": "out of which [adv]\n",
  "WHERES": "WHERE, the place at or in which something is located or occurs, also WHAUR, WHEAR, WHEARE [n]\n",
  "WHERESO": "in whatever place, also WHERESOEVER, WHEREVER [adv]\n",
  "WHERESOEVER": "in whatever place, also WHERESO, WHEREVER [adv]\n",
  "WHERETHROUGH": "(archaic) through which; through the agency of [adv]\n",
  "WHERETO": "to what [adv]\n",
  "WHEREUNDER": "under which [adv]\n",
  "WHEREUNTIL": "to what [adv]\n",
  "WHEREUNTO": "whereto, for what purpose [adv]\n",
  "WHEREUPON": "at which point [adv]\n",
  "WHEREVER": "in or to whatever place, also WHERESO, WHERESOEVER [adv]\n",
  "WHEREWITH": "with what [adj] / the means to do something [n -S]\n",
  "WHEREWITHAL": "the means, resources [n -S]\n",
  "WHEREWITHALS": "WHEREWITHAL, the means, resources [n]\n",
  "WHEREWITHS": "WHEREWITH, the means to do something [n]\n",
  "WHERRET": "(obsolete) to give a sharp blow, also WHIRRET [v -ED, -ING, -S]\n",
  "WHERRETED": "WHERRET, (obsolete) to give a sharp blow, also WHIRRET [v]\n",
  "WHERRETING": "WHERRET, (obsolete) to give a sharp blow, also WHIRRET [v]\n",
  "WHERRETS": "WHERRET, (obsolete) to give a sharp blow, also WHIRRET [v]\n",
  "WHERRIED": "WHERRY, to transport in a rowboat [v]\n",
  "WHERRIES": "WHERRY, to transport in a rowboat [v]\n",
  "WHERRIT": "to worry, also WORRIT [v -ED, -ING, -S]\n",
  "WHERRITED": "WHERRIT, to worry, also WORRIT [v]\n",
  "WHERRITING": "WHERRIT, to worry, also WORRIT [v]\n",
  "WHERRITS": "WHERRIT, to worry, also WORRIT [v]\n",
  "WHERRY": "to transport in a rowboat [v WHERRIED, WHERRYING, WHERRIES]\n",
  "WHERRYING": "WHERRY, to transport in a rowboat [v]\n",
  "WHERRYMAN": "a man employed in a wherry, esp. one who rows a wherry [n WHERRYMEN]\n",
  "WHERRYMEN": "WHERRYMAN, a man employed in a wherry, esp. one who rows a wherry [n]\n",
  "WHERVE": "a piece of wood used for spinning thread, also WHARVE [n -S]\n",
  "WHERVES": "WHERVE, a piece of wood used for spinning thread, also WHARVE [n]\n",
  "WHET": "to sharpen by friction [v WHETTED, WHETTING, WHETS]\n",
  "WHETHER": "if it be the case that [conj]\n",
  "WHETS": "WHET, to sharpen by friction [v]\n",
  "WHETSTONE": "a stone for sharpening tools on [n -S]\n",
  "WHETSTONES": "WHETSTONE, a stone for sharpening tools on [n]\n",
  "WHETTED": "WHET, to sharpen by friction [v]\n",
  "WHETTER": "one who, or that which, whets [n -S]\n",
  "WHETTERS": "WHETTER, one who, or that which, whets [n]\n",
  "WHETTING": "WHET, to sharpen by friction [v]\n",
  "WHEUGH": "to utter a sound of astonishment, also WHEW [v -ED, -ING, -S]\n",
  "WHEUGHED": "WHEUGH, to utter a sound of astonishment, also WHEW [v]\n",
  "WHEUGHING": "WHEUGH, to utter a sound of astonishment, also WHEW [v]\n",
  "WHEUGHS": "WHEUGH, to utter a sound of astonishment, also WHEW [v]\n",
  "WHEW": "to utter a sound of astonishment, also WHEUGH [v -ED, -ING, -S]\n",
  "WHEWED": "WHEW, to utter a sound of astonishment, also WHEUGH [v]\n",
  "WHEWELLITE": "a mineral, calcium oxalate [n -S]\n",
  "WHEWELLITES": "WHEWELLITE, a mineral, calcium oxalate [n]\n",
  "WHEWING": "WHEW, to utter a sound of astonishment, also WHEUGH [v]\n",
  "WHEWS": "WHEW, to utter a sound of astonishment, also WHEUGH [v]\n",
  "WHEY": "the watery part of milk [n -S]\n",
  "WHEYEY": "like whey also WHEYISH [adj WHEYIER, WHEYIEST]\n",
  "WHEYFACE": "a pale white face, as from fear [n -S]\n",
  "WHEYFACED": "with a complexion the colour of whey [adj]\n",
  "WHEYFACES": "WHEYFACE, a pale white face, as from fear [n]\n",
  "WHEYIER": "WHEYEY, like whey also WHEYISH [adj]\n",
  "WHEYIEST": "WHEYEY, like whey also WHEYISH [adj]\n",
  "WHEYISH": "somewhat like whey, also WHEYEY [adj]\n",
  "WHEYISHNESS": "the state of being wheyish [n -ES]\n",
  "WHEYISHNESSES": "WHEYISHNESS, the state of being wheyish [n]\n",
  "WHEYLIKE": "resembling whey [adj]\n",
  "WHEYS": "WHEY, the watery part of milk [n]\n",
  "WHICH": "what particular one [pron]\n",
  "WHICHEVER": "any one, no matter which [adj]\n",
  "WHICHSOEVER": "every one that [adj]\n",
  "WHICKER": "to neigh; to bleat [v -ED, -ING, -S]\n",
  "WHICKERED": "WHICKER, to neigh; to bleat [v]\n",
  "WHICKERING": "WHICKER, to neigh; to bleat [v]\n",
  "WHICKERS": "WHICKER, to neigh; to bleat [v]\n",
  "WHID": "(Scots) to move quickly, whiz, also WHIDDER [v WHIDDED, WHIDDING, WHIDS]\n",
  "WHIDAH": "a group of African birds related to the finch, also WHYDA, WHYDAH [n -S]\n",
  "WHIDAHS": "WHIDAH, a group of African birds related to the finch, also WHYDA, WHYDAH [n]\n",
  "WHIDDED": "WHID, (Scots) to move quickly, whiz, also WHIDDER [v]\n",
  "WHIDDER": "(Scots) to whiz, also WHID [v -ED, -ING, -S]\n",
  "WHIDDERED": "WHIDDER, (Scots) to whiz, also WHID [v]\n",
  "WHIDDERING": "WHIDDER, (Scots) to whiz, also WHID [v]\n",
  "WHIDDERS": "WHIDDER, (Scots) to whiz, also WHID [v]\n",
  "WHIDDING": "WHID, (Scots) to move quickly, whiz, also WHIDDER [v]\n",
  "WHIDS": "WHID, (Scots) to move quickly, whiz, also WHIDDER [v]\n",
  "WHIFF": "to blow with slight gusts of air [v -ED, -ING, -S]\n",
  "WHIFFED": "WHIFF, to blow with slight gusts of air [v]\n",
  "WHIFFER": "one that whiffs, fishes with a handline [n -S]\n",
  "WHIFFERS": "WHIFFER, one that whiffs, fishes with a handline [n]\n",
  "WHIFFET": "a paltry person [n -S]\n",
  "WHIFFETS": "WHIFFET, a paltry person [n]\n",
  "WHIFFIER": "WHIFFY, smelly [adj]\n",
  "WHIFFIEST": "WHIFFY, smelly [adj]\n",
  "WHIFFING": "the action of fishing from a boat with a hand line [n -S]\n",
  "WHIFFINGS": "WHIFFING, the action of fishing from a boat with a hand line [n]\n",
  "WHIFFLE": "to blow in puffs [v WHIFFLED, WHIFFLING, WHIFFLES]\n",
  "WHIFFLED": "WHIFFLE, to blow in puffs [v]\n",
  "WHIFFLER": "an official who clears the way for a procession [n -S]\n",
  "WHIFFLERIES": "WHIFFLERY, levity; trifling [n]\n",
  "WHIFFLERS": "WHIFFLER, an official who clears the way for a procession [n]\n",
  "WHIFFLERY": "levity; trifling [n WHIFFLERIES]\n",
  "WHIFFLES": "WHIFFLE, to blow in puffs [v]\n",
  "WHIFFLETREE": "the crosspiece of a carriage to which harnesses are attached, also SINGLETREE, SWINGLETREE, SWINGTREE, WHIPPLETREE [n -S]\n",
  "WHIFFLETREES": "WHIFFLETREE, the crosspiece of a carriage to which harnesses are attached, also SINGLETREE, SWINGLETREE, SWINGTREE, WHIPPLETREE [n]\n",
  "WHIFFLING": "the act of whiffling [n -S]\n",
  "WHIFFLINGS": "WHIFFLING, the act of whiffling [n]\n",
  "WHIFFS": "WHIFF, to blow with slight gusts of air [v]\n",
  "WHIFFY": "smelly [adj WHIFFIER, WHIFFIEST]\n",
  "WHIFT": "(dialect) a breath, a puff [n -S]\n",
  "WHIFTS": "WHIFT, (dialect) a breath, a puff [n]\n",
  "WHIG": "(Scots) to jog along [v WHIGGED, WHIGGING, WHIGS]\n",
  "WHIGGAMORE": "(Scots) a Whig; a cant term applied in contempt to Scotch Presbyterians [n -S]\n",
  "WHIGGAMORES": "WHIGGAMORE, (Scots) a Whig; a cant term applied in contempt to Scotch Presbyterians [n]\n",
  "WHIGGED": "WHIG, (Scots) to jog along [v]\n",
  "WHIGGING": "WHIG, (Scots) to jog along [v]\n",
  "WHIGMALEERIE": "(Scots) a trinket or knickknack; a fantastic ornamentation; a whim, also WHIGMALEERY [n -S]\n",
  "WHIGMALEERIES": "WHIGMALEERIE, (Scots) a trinket or knickknack; a fantastic ornamentation; a whim, also WHIGMALEERY [n]\n",
  "WHIGMALEERY": "(Scots) a trinket or knickknack; a fantastic ornamentation; a whim, also WHIGMALEERIE [n WHIGMALEERIES]\n",
  "WHIGS": "WHIG, (Scots) to jog along [v]\n",
  "WHILE": "to pass time pleasantly [v WHILED, WHILING, WHILES]\n",
  "WHILED": "WHILE, to pass time pleasantly [v]\n",
  "WHILERE": "(archaic) a little while ago [adv]\n",
  "WHILES": "WHILE, to pass time pleasantly [v]\n",
  "WHILEVER": "for as long as [adv] / for as long as [conj]\n",
  "WHILING": "WHILE, to pass time pleasantly [v]\n",
  "WHILK": "(Scots) which [adj]\n",
  "WHILLIED": "WHILLY, (Scots) to wheedle, cajole [v]\n",
  "WHILLIES": "WHILLY, (Scots) to wheedle, cajole [v]\n",
  "WHILLY": "(Scots) to wheedle, cajole [v WHILLIED, WHILLYING, WHILLIES]\n",
  "WHILLYING": "WHILLY, (Scots) to wheedle, cajole [v]\n",
  "WHILLYWHA": "(Scots) to coax, wheedle, cajole, also WHILLYWHAW [v -ED, -ING, -S]\n",
  "WHILLYWHAED": "WHILLYWHA, (Scots) to coax, wheedle, cajole, also WHILLYWHAW [v]\n",
  "WHILLYWHAING": "WHILLYWHA, (Scots) to coax, wheedle, cajole, also WHILLYWHAW [v]\n",
  "WHILLYWHAS": "WHILLYWHA [n]\n",
  "WHILLYWHAW": "(Scots) to coax, wheedle, cajole, also WHILLYWHA [v -ED, -ING, -S]\n",
  "WHILLYWHAWED": "WHILLYWHAW, (Scots) to coax, wheedle, cajole, also WHILLYWHA [v]\n",
  "WHILLYWHAWING": "WHILLYWHAW, (Scots) to coax, wheedle, cajole, also WHILLYWHA [v]\n",
  "WHILLYWHAWS": "WHILLYWHAW, (Scots) to coax, wheedle, cajole, also WHILLYWHA [v]\n",
  "WHILOM": "(archaic) formerly; once; former [adv]\n",
  "WHILST": "as long as [conj]\n",
  "WHIM": "to turn aside [v WHIMMED, WHIMMING, WHIMS]\n",
  "WHIMBERRIES": "WHIMBERRY, the bilberry or whortleberry, so called because it grows on moors among the whins, or furze, also WHINBERRY [n]\n",
  "WHIMBERRY": "the bilberry or whortleberry, so called because it grows on moors among the whins, or furze, also WHINBERRY [n WHIMBERRIES]\n",
  "WHIMBREL": "a bird like a curlew, also WIMBREL [n -S]\n",
  "WHIMBRELS": "WHIMBREL, a bird like a curlew, also WIMBREL [n]\n",
  "WHIMMED": "WHIM, to turn aside [v]\n",
  "WHIMMIER": "WHIMMY, full of whims [adj]\n",
  "WHIMMIEST": "WHIMMY, full of whims [adj]\n",
  "WHIMMING": "WHIM, to turn aside [v]\n",
  "WHIMMY": "full of whims [adj WHIMMIER, WHIMMIEST]\n",
  "WHIMPER": "to cry plaintively [v -ED, -ING, -S]\n",
  "WHIMPERED": "WHIMPER, to cry plaintively [v]\n",
  "WHIMPERER": "one who whimpers [n -S]\n",
  "WHIMPERERS": "WHIMPERER, one who whimpers [n]\n",
  "WHIMPERING": "crying with plaintive, broken sounds [adj WHIMPERINGLY] / the act of whimpering [n -S]\n",
  "WHIMPERINGLY": "WHIMPERING [adv]\n",
  "WHIMPERINGS": "WHIMPERING, the act of whimpering [n]\n",
  "WHIMPERS": "WHIMPER, to cry plaintively [v]\n",
  "WHIMPLE": "to wear a veil in the form of a headdress [v WHIMPLED, WHIMPLING, WHIMPLES]\n",
  "WHIMPLED": "WHIMPLE, to wear a veil in the form of a headdress [v]\n",
  "WHIMPLES": "WHIMPLE, to wear a veil in the form of a headdress [v]\n",
  "WHIMPLING": "WHIMPLE, to wear a veil in the form of a headdress [v]\n",
  "WHIMS": "WHIM, to turn aside [v]\n",
  "WHIMSEY": "delicately fanciful behaviour; gentle fantasy, also WHIMSY [n -S]\n",
  "WHIMSEYS": "WHIMSEY, delicately fanciful behaviour; gentle fantasy, also WHIMSY [n]\n",
  "WHIMSICAL": "full of whims, odd, fantastical [adj WHIMSICALLY]\n",
  "WHIMSICALITIES": "WHIMSICALITY, the state of being whimsical [n]\n",
  "WHIMSICALITY": "the state of being whimsical [n WHIMSICALITIES]\n",
  "WHIMSICALLY": "WHIMSICAL, full of whims, odd, fantastical [adv]\n",
  "WHIMSICALNESS": "the state of being whimsical [n -ES]\n",
  "WHIMSICALNESSES": "WHIMSICALNESS, the state of being whimsical [n]\n",
  "WHIMSIED": "WHIMSY, full of whims [adv]\n",
  "WHIMSIER": "WHIMSY, full of whims [adj]\n",
  "WHIMSIES": "WHIMSY, gentle fantasy, also WHIMSEY [n]\n",
  "WHIMSIEST": "WHIMSY, full of whims [adj]\n",
  "WHIMSILY": "WHIMSY, full of whims [adv]\n",
  "WHIMSINESS": "the state of being whimsical [n -ES]\n",
  "WHIMSINESSES": "WHIMSINESS, the state of being whimsical [n]\n",
  "WHIMSY": "gentle fantasy, also WHIMSEY [n WHIMSIES] / full of whims [adj WHIMSIER, WHIMSIEST, WHIMSILY]\n",
  "WHIN": "gorse, furze [n -S]\n",
  "WHINBERRIES": "WHINBERRY, the bilberry or whortleberry, so called because it grows on moors among the whins, or furze, also WHIMBERRY [n]\n",
  "WHINBERRY": "the bilberry or whortleberry, so called because it grows on moors among the whins, or furze, also WHIMBERRY [n WHINBERRIES]\n",
  "WHINCHAT": "a small brown and buff songbird [n -S]\n",
  "WHINCHATS": "WHINCHAT, a small brown and buff songbird [n]\n",
  "WHINE": "to utter a plaintive, high-pitched sound [v WHINED, WHINING, WHINES]\n",
  "WHINED": "WHINE, to utter a plaintive, high-pitched sound [v]\n",
  "WHINER": "one who whines [n -S]\n",
  "WHINERS": "WHINER, one who whines [n]\n",
  "WHINES": "WHINE, to utter a plaintive, high-pitched sound [v]\n",
  "WHINEY": "tending to whine, also WHINY [adj WHINIER, WHINIEST]\n",
  "WHINGDING": "a lively party, also WINGDING [n -S]\n",
  "WHINGDINGS": "WHINGDING, a lively party, also WINGDING [n]\n",
  "WHINGE": "to complain fretfully, to whine, also WHEENGE, WINGE [v WHINGED, WHINGING or WHINGEING, WHINGES]\n",
  "WHINGED": "WHINGE, to complain fretfully, to whine, also WHEENGE, WINGE [v]\n",
  "WHINGEING": "whining, complaining [adj WHINGEINGLY] / the act of whingeing [n -S]\n",
  "WHINGEINGLY": "in the manner of one who whines [adv]\n",
  "WHINGEINGS": "WHINGEING, the act of whingeing [n]\n",
  "WHINGER": "(historical) a dirk or short sword [n -S]\n",
  "WHINGERS": "WHINGER, (historical) a dirk or short sword [n]\n",
  "WHINGES": "WHINGE, to complain fretfully, to whine, also WHEENGE, WINGE [v]\n",
  "WHINGIER": "WHINGY, complaining [adj]\n",
  "WHINGIEST": "WHINGY, complaining [adj]\n",
  "WHINGING": "WHINGE, to complain fretfully, to whine, also WHEENGE, WINGE [v]\n",
  "WHINGY": "complaining [adj WHINGIER, WHINGIEST]\n",
  "WHINIARD": "(historical) a short sword or dirk, also WHINYARD [n -S]\n",
  "WHINIARDS": "WHINIARD, (historical) a short sword or dirk, also WHINYARD [n]\n",
  "WHINIER": "WHINY, given to whining, also WHINEY [adj]\n",
  "WHINIEST": "WHINY, given to whining, also WHINEY [adj]\n",
  "WHININESS": "the state of being whiny [n -ES]\n",
  "WHININESSES": "WHININESS, the state of being whiny [n]\n",
  "WHINING": "complaining [adj WHININGLY] / the act or sound of whining [n -S]\n",
  "WHININGLY": "WHINING, complaining [adv]\n",
  "WHININGS": "WHINING, the act or sound of whining [n]\n",
  "WHINNIED": "WHINNY, to make a high neighing sound [v]\n",
  "WHINNIER": "WHINNY, abounding in whins [adj]\n",
  "WHINNIES": "WHINNY, to make a high neighing sound [v]\n",
  "WHINNIEST": "WHINNY, abounding in whins [adj]\n",
  "WHINNY": "abounding in whins [adj WHINNIER, WHINNIEST] / to make a high neighing sound [v WHINNIED, WHINNYING, WHINNIES]\n",
  "WHINNYING": "WHINNY, to make a high neighing sound [v]\n",
  "WHINS": "WHIN, gorse, furze [n]\n",
  "WHINSTONE": "a hard and compact rock, also WHUNSTANE [n -S]\n",
  "WHINSTONES": "WHINSTONE, a hard and compact rock, also WHUNSTANE [n]\n",
  "WHINY": "given to whining, also WHINEY [adj WHINIER, WHINIEST]\n",
  "WHINYARD": "(historical) a short sword or dirk, also WHINIARD [n -S]\n",
  "WHINYARDS": "WHINYARD, (historical) a short sword or dirk, also WHINIARD [n]\n",
  "WHIO": "(Maori) a New Zealand mountain duck with blue plumage [n -S]\n",
  "WHIOS": "WHIO, (Maori) a New Zealand mountain duck with blue plumage [n]\n",
  "WHIP": "to strike with a lash [v WHIPT or WHIPPED, WHIPPING, WHIPS]\n",
  "WHIPBIRD": "the coachwhip bird [n -S]\n",
  "WHIPBIRDS": "WHIPBIRD, the coachwhip bird [n]\n",
  "WHIPCAT": "a tailor [n -S]\n",
  "WHIPCATS": "WHIPCAT, a tailor [n]\n",
  "WHIPCORD": "a fabric with bold twill used for making dresses [n -S]\n",
  "WHIPCORDIER": "WHIPCORDY, like whipcord, a fabric with bold twill used for making dresses [adj]\n",
  "WHIPCORDIEST": "WHIPCORDY, like whipcord, a fabric with bold twill used for making dresses [adj]\n",
  "WHIPCORDS": "WHIPCORD, a fabric with bold twill used for making dresses [n]\n",
  "WHIPCORDY": "like whipcord, a fabric with bold twill used for making dresses [adj WHIPCORDIER, WHIPCORDIEST]\n",
  "WHIPCRACK": "a sound made by a whip [n -S]\n",
  "WHIPCRACKS": "WHIPCRACK, a sound made by a whip [n]\n",
  "WHIPJACK": "a whining beggar posing as a sailor [n -S]\n",
  "WHIPJACKS": "WHIPJACK, a whining beggar posing as a sailor [n]\n",
  "WHIPLASH": "to move like a whip [v -ED, -ING, -ES]\n",
  "WHIPLASHED": "WHIPLASH, to move like a whip [v]\n",
  "WHIPLASHES": "WHIPLASH, to move like a whip [v]\n",
  "WHIPLASHING": "WHIPLASH, to move like a whip [v]\n",
  "WHIPLESS": "without a whip [adj]\n",
  "WHIPLIKE": "resembling a whip [adj]\n",
  "WHIPPED": "WHIP, to strike with a lash [v]\n",
  "WHIPPER": "one who whips [n -S]\n",
  "WHIPPERS": "WHIPPER, one who whips [n]\n",
  "WHIPPERSNAPPER": "a small, insignificant, or presumptuous person [n -S]\n",
  "WHIPPERSNAPPERS": "WHIPPERSNAPPER, a small, insignificant, or presumptuous person [n]\n",
  "WHIPPET": "a small swift dog [n -S]\n",
  "WHIPPETING": "the sport of racing whippets [n -S]\n",
  "WHIPPETINGS": "WHIPPETING, the sport of racing whippets [n]\n",
  "WHIPPETS": "WHIPPET, a small swift dog [n]\n",
  "WHIPPIER": "WHIPPY, pliant, supple [adj]\n",
  "WHIPPIEST": "WHIPPY, pliant, supple [adj]\n",
  "WHIPPINESS": "the state of being whippy [n -ES]\n",
  "WHIPPINESSES": "WHIPPINESS, the state of being whippy [n]\n",
  "WHIPPING": "material used to whip [n -S]\n",
  "WHIPPINGS": "WHIPPING, material used to whip [n]\n",
  "WHIPPIT": "a small canister of nitrous oxide [n -S]\n",
  "WHIPPITS": "WHIPPIT, a small canister of nitrous oxide [n]\n",
  "WHIPPLETREE": "the crosspiece of a carriage, plough, etc., which is made so as to swing on a pivot and to which the traces of a harnessed animal are fixed, also SINGLETREE, SWINGLETREE, SWINGTREE, WHIFFLETREE [n -S]\n",
  "WHIPPLETREES": "WHIPPLETREE, the crosspiece of a carriage, plough, etc., which is made so as to swing on a pivot and to which the traces of a harnessed animal are fixed, also SINGLETREE, SWINGLETREE, SWINGTREE, WHIFFLETREE [n]\n",
  "WHIPPOORWILL": "a species of nightjar native to North America, also POORWILL [n -S]\n",
  "WHIPPOORWILLS": "WHIPPOORWILL, a species of nightjar native to North America, also POORWILL [n]\n",
  "WHIPPY": "pliant, supple [adj WHIPPIER, WHIPPIEST]\n",
  "WHIPRAY": "a stingray [n -S]\n",
  "WHIPRAYS": "WHIPRAY, a stingray [n]\n",
  "WHIPS": "WHIP, to strike with a lash [v]\n",
  "WHIPSAW": "to cut with a narrow tapering saw [v WHIPSAWED, WHIPSAWN, WHIPSAWING, WHIPSAWS]\n",
  "WHIPSAWED": "WHIPSAW, to cut with a narrow tapering saw [v]\n",
  "WHIPSAWING": "WHIPSAW, to cut with a narrow tapering saw [v]\n",
  "WHIPSAWN": "WHIPSAW, to cut with a narrow tapering saw [v]\n",
  "WHIPSAWS": "WHIPSAW, to cut with a narrow tapering saw [v]\n",
  "WHIPSNAKE": "a kind of long thin snake [n -S]\n",
  "WHIPSNAKES": "WHIPSNAKE, a kind of long thin snake [n]\n",
  "WHIPSTAFF": "a vertical lever controlling ship's rudder [n -S]\n",
  "WHIPSTAFFS": "WHIPSTAFF, a vertical lever controlling ship's rudder [n]\n",
  "WHIPSTALL": "of an airplane, to stall causing the nose to whip forward and down [v -ED, -ING, -S]\n",
  "WHIPSTALLED": "WHIPSTALL, of an airplane, to stall causing the nose to whip forward and down [v]\n",
  "WHIPSTALLING": "WHIPSTALL, of an airplane, to stall causing the nose to whip forward and down [v]\n",
  "WHIPSTALLS": "WHIPSTALL, of an airplane, to stall causing the nose to whip forward and down [v]\n",
  "WHIPSTER": "(obsolete) a nimble little fellow; a whippersnapper [n -S]\n",
  "WHIPSTERS": "WHIPSTER, (obsolete) a nimble little fellow; a whippersnapper [n]\n",
  "WHIPSTITCH": "a small overcasting stitch [n -ES] / to sew with a whipstitch [v -ED, -ING, -ES]\n",
  "WHIPSTITCHED": "WHIPSTITCH, to sew with a whipstitch [v]\n",
  "WHIPSTITCHES": "WHIPSTITCH, a small overcasting stitch [n]\n",
  "WHIPSTITCHING": "WHIPSTITCH, to sew with a whipstitch [v]\n",
  "WHIPSTOCK": "the rod or handle to which the lash of a whip is fastened [n -S]\n",
  "WHIPSTOCKS": "WHIPSTOCK, the rod or handle to which the lash of a whip is fastened [n]\n",
  "WHIPT": "WHIP, to strike with a lash [v]\n",
  "WHIPTAIL": "a lizard with a long, slender tail [n -S]\n",
  "WHIPTAILED": "having a long slender tail [adj]\n",
  "WHIPTAILS": "WHIPTAIL, a lizard with a long, slender tail [n]\n",
  "WHIPWORM": "a parasitic worm [n -S]\n",
  "WHIPWORMS": "WHIPWORM, a parasitic worm [n]\n",
  "WHIR": "to spin with a humming noise, also WHIRR [v WHIRRED, WHIRRING, WHIRS]\n",
  "WHIRL": "to revolve rapidly [v -ED, -ING, -S]\n",
  "WHIRLABOUT": "anything that whirls around; a whirligig [n -S]\n",
  "WHIRLABOUTS": "WHIRLABOUT, anything that whirls around; a whirligig [n]\n",
  "WHIRLBAT": "an ancient boxing glove loaded with metal, also WHORLBAT [n -S]\n",
  "WHIRLBATS": "WHIRLBAT, an ancient boxing glove loaded with metal, also WHORLBAT [n]\n",
  "WHIRLBLAST": "a whirling blast of wind [n -S]\n",
  "WHIRLBLASTS": "WHIRLBLAST, a whirling blast of wind [n]\n",
  "WHIRLED": "WHIRL, to revolve rapidly [v]\n",
  "WHIRLER": "one who whirls [n -S]\n",
  "WHIRLERS": "WHIRLER, one who whirls [n]\n",
  "WHIRLIER": "WHIRLY, given to whirling [adj]\n",
  "WHIRLIES": "WHIRLY, a small tornado [n]\n",
  "WHIRLIEST": "WHIRLY, given to whirling [adj]\n",
  "WHIRLIGIG": "a child's toy having a whirling motion [n -S]\n",
  "WHIRLIGIGS": "WHIRLIGIG, a child's toy having a whirling motion [n]\n",
  "WHIRLING": "turning rapidly [adj WHIRLINGLY] / the act of whirling [n -S]\n",
  "WHIRLINGLY": "WHIRLING, turning rapidly [adv]\n",
  "WHIRLINGS": "WHIRLING, the act of whirling [n]\n",
  "WHIRLPOOL": "a circular current in a river or sea, produced by opposing tides, winds or currents [n -S]\n",
  "WHIRLPOOLS": "WHIRLPOOL, a circular current in a river or sea, produced by opposing tides, winds or currents [n]\n",
  "WHIRLS": "WHIRL, to revolve rapidly [v]\n",
  "WHIRLWIND": "a small rotating windstorm [n -S]\n",
  "WHIRLWINDS": "WHIRLWIND, a small rotating windstorm [n]\n",
  "WHIRLY": "given to whirling [adj WHIRLIER, WHIRLIEST] / a small tornado [n WHIRLIES]\n",
  "WHIRLYBIRD": "(slang) a helicopter [n -S]\n",
  "WHIRLYBIRDS": "WHIRLYBIRD, (slang) a helicopter [n]\n",
  "WHIRR": "to spin with a humming noise, also WHIR [v -ED, -ING, -S]\n",
  "WHIRRA": "an interjection used to express sorrow, also WIRRA [interj]\n",
  "WHIRRED": "WHIR, to spin with a humming noise, also WHIRR [v]\n",
  "WHIRRET": "to give a sharp blow to, also WHERRET [v -ED, -ING, -S]\n",
  "WHIRRETED": "WHIRRET, to give a sharp blow to, also WHERRET [v]\n",
  "WHIRRETING": "WHIRRET, to give a sharp blow to, also WHERRET [v]\n",
  "WHIRRETS": "WHIRRET, to give a sharp blow to, also WHERRET [v]\n",
  "WHIRRIED": "WHIRRY, to move rapidly [v]\n",
  "WHIRRIER": "WHIRRY, characteristic of a whir [adj]\n",
  "WHIRRIES": "WHIRRY, to move rapidly [v]\n",
  "WHIRRIEST": "WHIRRY, characteristic of a whir [adj]\n",
  "WHIRRING": "the act of turning with a humming noise [n -S]\n",
  "WHIRRINGS": "WHIRRING, the act of turning with a humming noise [n]\n",
  "WHIRRS": "WHIRR, to spin with a humming noise, also WHIR [v]\n",
  "WHIRRY": "characteristic of a whir [adj WHIRRIER, WHIRRIEST] / to move rapidly [v WHIRRIED, WHIRRYING, WHIRRIES]\n",
  "WHIRRYING": "WHIRRY, to move rapidly [v]\n",
  "WHIRS": "WHIR, to spin with a humming noise, also WHIRR [v]\n",
  "WHIRTLE": "a perforated plate through which wire or tubing is drawn, also WORTLE [n -S]\n",
  "WHIRTLES": "WHIRTLE, a perforated plate through which wire or tubing is drawn, also WORTLE [n]\n",
  "WHISH": "to move with a hissing sound [v -ED, -ING, -ES]\n",
  "WHISHED": "WHISH, to move with a hissing sound [v]\n",
  "WHISHES": "WHISH, to move with a hissing sound [v]\n",
  "WHISHING": "WHISH, to move with a hissing sound [v]\n",
  "WHISHT": "(Scots) to keep silent, also WHEESH, WHEESHT [v -ED, -ING, -S]\n",
  "WHISHTED": "WHISHT, (Scots) to keep silent, also WHEESH, WHEESHT [v]\n",
  "WHISHTING": "WHISHT, (Scots) to keep silent, also WHEESH, WHEESHT [v]\n",
  "WHISHTS": "WHISHT, (Scots) to keep silent, also WHEESH, WHEESHT [v]\n",
  "WHISK": "to move quickly [v -ED, -ING, -S]\n",
  "WHISKED": "WHISK, to move quickly [v]\n",
  "WHISKER": "coarse hair on the face [n -S]\n",
  "WHISKERANDO": "a whiskered person, in allusion to Dom Ferolo Whiskerandos in Sheridan's Critic [n -S]\n",
  "WHISKERANDOED": "having whiskers [adj]\n",
  "WHISKERANDOS": "WHISKERANDO, a whiskered person, in allusion to Dom Ferolo Whiskerandos in Sheridan's Critic [n]\n",
  "WHISKERED": "having whiskers [adj]\n",
  "WHISKERIER": "WHISKERY, having whiskers [adj]\n",
  "WHISKERIEST": "WHISKERY, having whiskers [adj]\n",
  "WHISKERS": "WHISKER, coarse hair on the face [n]\n",
  "WHISKERY": "having whiskers [adj WHISKERIER, WHISKERIEST]\n",
  "WHISKET": "a basket; esp. a straw provender basket, also WISKET [n -S]\n",
  "WHISKETS": "WHISKET, a basket; esp. a straw provender basket, also WISKET [n]\n",
  "WHISKEY": "an alcoholic spirit, also WHISKY [n -S]\n",
  "WHISKEYFIED": "intoxicated, also WHISKIFIED [adj]\n",
  "WHISKEYS": "WHISKEY, an alcoholic spirit, also WHISKY [n]\n",
  "WHISKIES": "WHISKY, an alcoholic spirit, also WHISKEY [n]\n",
  "WHISKIFIED": "intoxicated, also WHISKEYFIED [adj]\n",
  "WHISKING": "WHISK, to move quickly [v]\n",
  "WHISKS": "WHISK, to move quickly [v]\n",
  "WHISKY": "an alcoholic spirit, also WHISKEY [n WHISKIES]\n",
  "WHISPER": "to speak softly [v -ED, -ING, -S]\n",
  "WHISPERED": "WHISPER, to speak softly [v]\n",
  "WHISPERER": "one who whispers [n -S]\n",
  "WHISPERERS": "WHISPERER, one who whispers [n]\n",
  "WHISPERIER": "WHISPERY, like a whisper [adj]\n",
  "WHISPERIEST": "WHISPERY, like a whisper [adj]\n",
  "WHISPERING": "speaking softly [adj WHISPERINGLY] / the act of whispering [n -S]\n",
  "WHISPERINGLY": "WHISPERING, speaking softly [adv]\n",
  "WHISPERINGS": "WHISPERING, the act of whispering [n]\n",
  "WHISPEROUSLY": "in a whisper [adv]\n",
  "WHISPERS": "WHISPER, to speak softly [v]\n",
  "WHISPERY": "like a whisper [adj WHISPERIER, WHISPERIEST]\n",
  "WHISS": "to hiss or whistle [v WHISSED, WHISSING, WHISSES]\n",
  "WHISSED": "WHISS, to hiss or whistle [v]\n",
  "WHISSES": "WHISS, to hiss or whistle [v]\n",
  "WHISSING": "WHISS, to hiss or whistle [v]\n",
  "WHIST": "to become silent [v -ED, -ING, -S]\n",
  "WHISTED": "WHIST, to become silent [v]\n",
  "WHISTING": "WHIST, to become silent [v]\n",
  "WHISTLE": "to make a shrill sound [v WHISTLED, WHISTLING, WHISTLES]\n",
  "WHISTLEABLE": "that can be whistled [adj]\n",
  "WHISTLEBLOWING": "the practice of informing on someone or putting a stop to something [n -S]\n",
  "WHISTLEBLOWINGS": "WHISTLEBLOWING, the practice of informing on someone or putting a stop to something [n]\n",
  "WHISTLED": "WHISTLE, to make a shrill sound [v]\n",
  "WHISTLER": "someone or something that whistles [n -S]\n",
  "WHISTLERS": "WHISTLER, someone or something that whistles [n]\n",
  "WHISTLES": "WHISTLE, to make a shrill sound [v]\n",
  "WHISTLING": "of e.g. a wind, making a shrill, clear musical sound [adj WHISTLINGLY] / the act of whistling [n -S]\n",
  "WHISTLINGLY": "WHISTLING, of e.g. a wind, making a shrill, clear musical sound [adv]\n",
  "WHISTLINGS": "WHISTLING, the act of whistling [n]\n",
  "WHISTS": "WHIST, to become silent [v]\n",
  "WHIT": "the smallest particle imaginable, also HAET [n -S]\n",
  "WHITE": "of the color of pure snow [adj WHITER, WHITEST, WHITELY] / to make white, whiten [v WHITED, WHITING, WHITES]\n",
  "WHITEBAIT": "the fry of various species of herring, sprat, etc. [n -S]\n",
  "WHITEBAITS": "WHITEBAIT, the fry of various species of herring, sprat, etc. [n]\n",
  "WHITEBASS": "a silvery food fish of the American Great Lakes region [n -ES]\n",
  "WHITEBASSES": "WHITEBASS, a silvery food fish of the American Great Lakes region [n]\n",
  "WHITEBEAM": "a small tree with leaves white and downy on the underside [n -S]\n",
  "WHITEBEAMS": "WHITEBEAM, a small tree with leaves white and downy on the underside [n]\n",
  "WHITEBEARD": "an old man, a graybeard [n -S]\n",
  "WHITEBEARDS": "WHITEBEARD, an old man, a graybeard [n]\n",
  "WHITEBOARD": "a board, used for teaching or presentation purposes, similar to a blackboard but with a white plastic surface for writing on using felt-tipped pens [n -S]\n",
  "WHITEBOARDS": "WHITEBOARD, a board, used for teaching or presentation purposes, similar to a blackboard but with a white plastic surface for writing on using felt-tipped pens [n]\n",
  "WHITEBOYISM": "the principles of the Whiteboys, an association of Irish peasants [n -S]\n",
  "WHITEBOYISMS": "WHITEBOYISM, the principles of the Whiteboys, an association of Irish peasants [n]\n",
  "WHITECAP": "a wave with a crest of foam [n -S]\n",
  "WHITECAPS": "WHITECAP, a wave with a crest of foam [n]\n",
  "WHITECOAT": "a white-furred seal pup [n -S]\n",
  "WHITECOATS": "WHITECOAT, a white-furred seal pup [n]\n",
  "WHITECOMB": "a fungal disease affecting the combs of certain fowls [n -S]\n",
  "WHITECOMBS": "WHITECOMB, a fungal disease affecting the combs of certain fowls [n]\n",
  "WHITED": "WHITE, to make white, whiten [v]\n",
  "WHITEDAMP": "a mixture of poisonous gases, esp. carbon monoxide, in a mine [n -S]\n",
  "WHITEDAMPS": "WHITEDAMP, a mixture of poisonous gases, esp. carbon monoxide, in a mine [n]\n",
  "WHITEFACE": "white makeup esp. as used by a clown [n -S]\n",
  "WHITEFACES": "WHITEFACE, white makeup esp. as used by a clown [n]\n",
  "WHITEFISH": "a general name for such fish as the whiting, haddock, plaice, cod, sole, menhaden, etc. [n -ES]\n",
  "WHITEFISHES": "WHITEFISH, a general name for such fish as the whiting, haddock, plaice, cod, sole, menhaden, etc. [n]\n",
  "WHITEFLIES": "WHITEFLY, a small, whitish insect [n]\n",
  "WHITEFLY": "a small, whitish insect [n WHITEFLIES]\n",
  "WHITEHEAD": "the blue-winged snow goose [n -S]\n",
  "WHITEHEADS": "WHITEHEAD, the blue-winged snow goose [n]\n",
  "WHITELIST": "to place a name, email address, Web site address, or program on a list of items that are deemed spam- or virus-free [v -ED, -ING, -S]\n",
  "WHITELISTED": "WHITELIST, to place a name, email address, Web site address, or program on a list of items that are deemed spam- or virus-free [v]\n",
  "WHITELISTING": "WHITELIST, to place a name, email address, Web site address, or program on a list of items that are deemed spam- or virus-free [v]\n",
  "WHITELISTS": "WHITELIST, to place a name, email address, Web site address, or program on a list of items that are deemed spam- or virus-free [v]\n",
  "WHITELY": "WHITE, of the color of pure snow [adv]\n",
  "WHITEN": "to make white [v -ED, -ING, -S]\n",
  "WHITENED": "WHITEN, to make white [v]\n",
  "WHITENER": "something that whitens, a bleach [n -S]\n",
  "WHITENERS": "WHITENER, something that whitens, a bleach [n]\n",
  "WHITENESS": "the state of being white [n -ES]\n",
  "WHITENESSES": "WHITENESS, the state of being white [n]\n",
  "WHITENING": "the act of making white [n -S]\n",
  "WHITENINGS": "WHITENING, the act of making white [n]\n",
  "WHITENS": "WHITEN, to make white [v]\n",
  "WHITEOUT": "a condition of zero visibility caused by snow [n -S]\n",
  "WHITEOUTS": "WHITEOUT, a condition of zero visibility caused by snow [n]\n",
  "WHITEPOT": "a Devonshire pudding of sliced rolls, milk, eggs, sugar etc. baked [n -S]\n",
  "WHITEPOTS": "WHITEPOT, a Devonshire pudding of sliced rolls, milk, eggs, sugar etc. baked [n]\n",
  "WHITER": "WHITE, of the color of pure snow [adj]\n",
  "WHITES": "WHITE, to make white, whiten [v]\n",
  "WHITESMITH": "one who works in tinned or galvanized iron, or white iron [n -S]\n",
  "WHITESMITHS": "WHITESMITH, one who works in tinned or galvanized iron, or white iron [n]\n",
  "WHITEST": "WHITE, of the color of pure snow [adj]\n",
  "WHITETAIL": "the Virginia deer [n -S]\n",
  "WHITETAILS": "WHITETAIL, the Virginia deer [n]\n",
  "WHITETHORN": "the hawthorn [n -S]\n",
  "WHITETHORNS": "WHITETHORN, the hawthorn [n]\n",
  "WHITETHROAT": "any of several birds with white on the throat [n -S]\n",
  "WHITETHROATS": "WHITETHROAT, any of several birds with white on the throat [n]\n",
  "WHITEWALL": "the spotted flycatcher, so called from the white color of the underparts [n -S]\n",
  "WHITEWALLS": "WHITEWALL, the spotted flycatcher, so called from the white color of the underparts [n]\n",
  "WHITEWARE": "articles made of white porcelain, pottery or other ceramic material [n -S]\n",
  "WHITEWARES": "WHITEWARE, articles made of white porcelain, pottery or other ceramic material [n]\n",
  "WHITEWASH": "a mixture of lime and water, or whiting, size and water, used for coating walls [n -ES] / to cover with whitewash [v -ED, -ING, -ES]\n",
  "WHITEWASHED": "WHITEWASH, to cover with whitewash [v]\n",
  "WHITEWASHER": "one who whitewashes [n -S]\n",
  "WHITEWASHERS": "WHITEWASHER, one who whitewashes [n]\n",
  "WHITEWASHES": "WHITEWASH, to cover with whitewash [v]\n",
  "WHITEWASHING": "the act of coating with whitewash [n -S]\n",
  "WHITEWASHINGS": "WHITEWASHING, the act of coating with whitewash [n]\n",
  "WHITEWATER": "referring to a stretch of water with a broken foamy surface, as in rapids [adj]\n",
  "WHITEWING": "the chaffinch, so called from the white bands on the wing [n -S]\n",
  "WHITEWINGS": "WHITEWING, the chaffinch, so called from the white bands on the wing [n]\n",
  "WHITEWOOD": "the soft and easily worked wood of the tulip tree, much used in cabinetwork, carriage building, etc. [n -S]\n",
  "WHITEWOODS": "WHITEWOOD, the soft and easily worked wood of the tulip tree, much used in cabinetwork, carriage building, etc. [n]\n",
  "WHITEY": "(offensive) a white person, also WHITY [n -S]\n",
  "WHITEYS": "WHITEY, (offensive) a white person, also WHITY [n]\n",
  "WHITEYWOOD": "a New Zealand tree with smooth pale bark, aka mahoe [n -S]\n",
  "WHITEYWOODS": "WHITEYWOOD, a New Zealand tree with smooth pale bark, aka mahoe [n]\n",
  "WHITHER": "to blow strongly with a roaring sound, also WUTHER [v -ED, -ING, -S]\n",
  "WHITHERED": "WHITHER, to blow strongly with a roaring sound, also WUTHER [v]\n",
  "WHITHERING": "WHITHER, to blow strongly with a roaring sound, also WUTHER [v]\n",
  "WHITHERS": "WHITHER, to blow strongly with a roaring sound, also WUTHER [v]\n",
  "WHITHERSOEVER": "to any place whatsoever [adv]\n",
  "WHITHERWARD": "toward what or which place, also WHITHERWARDS [adv]\n",
  "WHITHERWARDS": "toward what or which place, also WHITHERWARD [adv]\n",
  "WHITIER": "WHITY, whitish, also WHITEY [adj]\n",
  "WHITIES": "WHITY, a white person [n]\n",
  "WHITIEST": "WHITY, whitish, also WHITEY [adj]\n",
  "WHITING": "a gadid food fish which is common off European coasts [n -S]\n",
  "WHITINGS": "WHITING, a gadid food fish which is common off European coasts [n]\n",
  "WHITISH": "somewhat white [adj]\n",
  "WHITISHNESS": "the state of being whitish [n -ES]\n",
  "WHITISHNESSES": "WHITISHNESS, the state of being whitish [n]\n",
  "WHITLEATHER": "leather dressed with alum [n -S]\n",
  "WHITLEATHERS": "WHITLEATHER, leather dressed with alum [n]\n",
  "WHITLING": "a young bull trout [n -S]\n",
  "WHITLINGS": "WHITLING, a young bull trout [n]\n",
  "WHITLOW": "an inflammation of finger or toe [n -S]\n",
  "WHITLOWS": "WHITLOW, an inflammation of finger or toe [n]\n",
  "WHITRACK": "(Scots) a weasel, also WHITRET, WHITRICK, WHITTERICK, WHITTRET [n -S]\n",
  "WHITRACKS": "WHITRACK, (Scots) a weasel, also WHITRET, WHITRICK, WHITTERICK, WHITTRET [n]\n",
  "WHITRET": "(Scots) a weasel, also WHITRACK, WHITRICK, WHITTERICK, WHITTRET [n -S]\n",
  "WHITRETS": "WHITRET, (Scots) a weasel, also WHITRACK, WHITRICK, WHITTERICK, WHITTRET [n]\n",
  "WHITRICK": "a weasel, also WHITRACK, WHITRET, WHITTERICK, WHITTRET [n -S]\n",
  "WHITRICKS": "WHITRICK, a weasel, also WHITRACK, WHITRET, WHITTERICK, WHITTRET [n]\n",
  "WHITS": "WHIT, the smallest particle imaginable, also HAET [n]\n",
  "WHITSTER": "(archaic) a bleacher of cloth and clothing [n -S]\n",
  "WHITSTERS": "WHITSTER, (archaic) a bleacher of cloth and clothing [n]\n",
  "WHITTAW": "(dialect) a saddler or harness-maker; a maker of white leather, also WHITTAWER [n -S]\n",
  "WHITTAWER": "(dialect) a saddler or harness-maker; a maker of white leather, also WHITTAW [n -S]\n",
  "WHITTAWERS": "WHITTAWER, (dialect) a saddler or harness-maker; a maker of white leather, also WHITTAW [n]\n",
  "WHITTAWS": "WHITTAW, (dialect) a saddler or harness-maker; a maker of white leather, also WHITTAWER [n]\n",
  "WHITTER": "to talk or mutter peevishly or ineffectually, also WITTER [v -ED, -ING, -S]\n",
  "WHITTERED": "WHITTER, to talk or mutter peevishly or ineffectually, also WITTER [v]\n",
  "WHITTERICK": "(Scots) a weasel, also WHITRACK, WHITRET, WHITRICK, WHITTRET [n -S]\n",
  "WHITTERICKS": "WHITTERICK, (Scots) a weasel, also WHITRACK, WHITRET, WHITRICK, WHITTRET [n]\n",
  "WHITTERING": "WHITTER, to talk or mutter peevishly or ineffectually, also WITTER [v]\n",
  "WHITTERS": "WHITTER, to talk or mutter peevishly or ineffectually, also WITTER [v]\n",
  "WHITTLE": "to shave or cut bits from [v WHITTLED, WHITTLING, WHITTLES]\n",
  "WHITTLED": "WHITTLE, to shave or cut bits from [v]\n",
  "WHITTLER": "one who whittles [n -S]\n",
  "WHITTLERS": "WHITTLER, one who whittles [n]\n",
  "WHITTLES": "WHITTLE, to shave or cut bits from [v]\n",
  "WHITTLING": "the act of whittling [n -S]\n",
  "WHITTLINGS": "WHITTLING, the act of whittling [n]\n",
  "WHITTRET": "(Scots) a weasel, also WHITRACK, WHITRET, WHITRICK, WHITTERICK [n -S]\n",
  "WHITTRETS": "WHITTRET, (Scots) a weasel, also WHITRACK, WHITRET, WHITRICK, WHITTERICK [n]\n",
  "WHITY": "whitish, also WHITEY [adj WHITIER, WHITIEST] / a white person [n WHITIES]\n",
  "WHIZ": "to move rapidly with a hissing sound, also WHIZZ [v WHIZZED, WHIZZING, WHIZZES]\n",
  "WHIZBANG": "a light shell of high velocity which is heard arriving before the gun's report; a firework resembling this, also WHIZZBANG [n -S]\n",
  "WHIZBANGS": "WHIZBANG, a light shell of high velocity which is heard arriving before the gun's report; a firework resembling this, also WHIZZBANG [n]\n",
  "WHIZZ": "to move rapidly with a hissing sound, also WHIZ [v -ED, -ING, -ES]\n",
  "WHIZZBANG": "a light shell of high velocity which is heard arriving before the gun's report; a firework resembling this, also WHIZBANG [n -S]\n",
  "WHIZZBANGS": "WHIZZBANG, a light shell of high velocity which is heard arriving before the gun's report; a firework resembling this, also WHIZBANG [n]\n",
  "WHIZZED": "WHIZ, to move rapidly with a hissing sound, also WHIZZ [v]\n",
  "WHIZZER": "(slang) a pickpocket [n -S]\n",
  "WHIZZERS": "WHIZZER, (slang) a pickpocket [n]\n",
  "WHIZZES": "WHIZZ, to move rapidly with a hissing sound, also WHIZ [v]\n",
  "WHIZZIER": "WHIZZY, using sophisticated technology to achieve vivid effects, also WHIZZO [adj]\n",
  "WHIZZIEST": "WHIZZY, using sophisticated technology to achieve vivid effects, also WHIZZO [adj]\n",
  "WHIZZING": "the act of whizzing [n -S]\n",
  "WHIZZINGLY": "WHIZZING [adv]\n",
  "WHIZZINGS": "WHIZZING, the act of whizzing [n]\n",
  "WHIZZO": "excellent, impressive, also WHIZZY [adj]\n",
  "WHIZZY": "using sophisticated technology to achieve vivid effects, also WHIZZO [adj WHIZZIER, WHIZZIEST]\n",
  "WHO": "which person [pron]\n",
  "WHOA": "a call to stop, esp. to a horse, also WOAH [interj]\n",
  "WHODUNIT": "a mystery novel, also WHODUNNIT [n -S]\n",
  "WHODUNITRIES": "WHODUNITRY, the genre of whodunit writing, also WHODUNNITRY [n]\n",
  "WHODUNITRY": "the genre of whodunit writing, also WHODUNNITRY [n WHODUNITRIES]\n",
  "WHODUNITS": "WHODUNIT, a mystery novel, also WHODUNNIT [n]\n",
  "WHODUNNIT": "a mystery novel, also WHODUNIT [n -S]\n",
  "WHODUNNITRIES": "WHODUNNITRY, the genre of whodunit writing, also WHODUNITRY [n]\n",
  "WHODUNNITRY": "the genre of whodunit writing, also WHODUNITRY [n WHODUNNITRIES]\n",
  "WHODUNNITS": "WHODUNNIT, a mystery novel, also WHODUNIT [n]\n",
  "WHOEVER": "whatever person [pron]\n",
  "WHOLE": "entire [adj WHOLLY] / all the parts or elements entering into and making up a thing [n -S]\n",
  "WHOLEFOOD": "unprocessed, natural food [n -S]\n",
  "WHOLEFOODS": "WHOLEFOOD, unprocessed, natural food [n]\n",
  "WHOLEGRAIN": "of bread, flour, etc., made from the complete grain, with no parts discarded during manufacture [adj]\n",
  "WHOLEGRAINS": "the whole unprocessed grains of cereals such as wheat and maize [n]\n",
  "WHOLEHEARTED": "completely and sincerely devoted, determined, or enthusiastic [adj WHOLEHEARTEDLY]\n",
  "WHOLEHEARTEDLY": "WHOLEHEARTED, completely and sincerely devoted, determined, or enthusiastic [adv]\n",
  "WHOLEMEAL": "flour made from the whole grain [n -S]\n",
  "WHOLEMEALS": "WHOLEMEAL, flour made from the whole grain [n]\n",
  "WHOLENESS": "the state of being whole [n -ES]\n",
  "WHOLENESSES": "WHOLENESS, the state of being whole [n]\n",
  "WHOLES": "WHOLE, all the parts or elements entering into and making up a thing [n]\n",
  "WHOLESALE": "the sale of goods, usually by the whole piece or large quantity, to a retailer [n -S] / to sell wholesale [v WHOLESALED, WHOLESALING, WHOLESALES]\n",
  "WHOLESALED": "WHOLESALE, to sell wholesale [v]\n",
  "WHOLESALER": "someone who sells by wholesale [n -S]\n",
  "WHOLESALERS": "WHOLESALER, someone who sells by wholesale [n]\n",
  "WHOLESALES": "WHOLESALE, to sell wholesale [v]\n",
  "WHOLESALING": "the act of selling wholesale [n -S]\n",
  "WHOLESALINGS": "WHOLESALING, the act of selling wholesale [n]\n",
  "WHOLESOME": "healthy, whole, also HEALSOME, HOLESOM, HOLESOME [adj WHOLESOMER, WHOLESOMEST, WHOLESOMELY]\n",
  "WHOLESOMELY": "WHOLESOME, healthy, whole, also HEALSOME, HOLESOM, HOLESOME [adv]\n",
  "WHOLESOMENESS": "the state of being wholesome [n -ES]\n",
  "WHOLESOMENESSES": "WHOLESOMENESS, the state of being wholesome [n]\n",
  "WHOLESOMER": "WHOLESOME, healthy, whole, also HEALSOME, HOLESOM, HOLESOME [adj]\n",
  "WHOLESOMEST": "WHOLESOME, healthy, whole, also HEALSOME, HOLESOM, HOLESOME [adj]\n",
  "WHOLESTITCH": "weaving stitch that fills in a pattern [n -ES]\n",
  "WHOLESTITCHES": "WHOLESTITCH, weaving stitch that fills in a pattern [n]\n",
  "WHOLEWHEAT": "wholemeal [adj]\n",
  "WHOLISM": "the philosophical theory that a complex system is more than the sum of its parts, also HOLISM [n -S]\n",
  "WHOLISMS": "WHOLISM, the philosophical theory that a complex system is more than the sum of its parts, also HOLISM [n]\n",
  "WHOLIST": "a believer in wholism, also HOLIST [n -S]\n",
  "WHOLISTIC": "considering the whole e.g. wholistic medicine, also HOLISTIC [adj]\n",
  "WHOLISTS": "WHOLIST, a believer in wholism, also HOLIST [n]\n",
  "WHOLLY": "WHOLE, entire [adv]\n",
  "WHOLPHIN": "a hybrid of a whale and a dolphin [n -S]\n",
  "WHOLPHINS": "WHOLPHIN, a hybrid of a whale and a dolphin [n]\n",
  "WHOM": "the objective case of who [pron]\n",
  "WHOMBLE": "to overturn; to throw into a state of disorder, also WHEMMLE, WHOMMLE, WHUMMLE [v WHOMBLED, WHOMBLING, WHOMBLES]\n",
  "WHOMBLED": "WHOMBLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMMLE, WHUMMLE [v]\n",
  "WHOMBLES": "WHOMBLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMMLE, WHUMMLE [v]\n",
  "WHOMBLING": "WHOMBLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMMLE, WHUMMLE [v]\n",
  "WHOMEVER": "the objective case of whoever [pron]\n",
  "WHOMMLE": "to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHUMMLE [v WHOMMLED, WHOMMLING, WHOMMLES]\n",
  "WHOMMLED": "WHOMMLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHUMMLE [v]\n",
  "WHOMMLES": "WHOMMLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHUMMLE [v]\n",
  "WHOMMLING": "WHOMMLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHUMMLE [v]\n",
  "WHOMP": "to defeat decisively [v -ED, -ING, -S]\n",
  "WHOMPED": "WHOMP, to defeat decisively [v]\n",
  "WHOMPING": "WHOMP, to defeat decisively [v]\n",
  "WHOMPS": "WHOMP, to defeat decisively [v]\n",
  "WHOMSO": "the objective case of whoso [pron]\n",
  "WHOMSOEVER": "the objective of whosoever [pron]\n",
  "WHOOBUB": "(obsolete) a confused sound of many voices, also HUBBUB, HUBBUBOO [n -S]\n",
  "WHOOBUBS": "WHOOBUB, (obsolete) a confused sound of many voices, also HUBBUB, HUBBUBOO [n]\n",
  "WHOOF": "to make a deep snorting sound, also WOOF [v -ED, -ING, -S]\n",
  "WHOOFED": "WHOOF, to make a deep snorting sound, also WOOF [v]\n",
  "WHOOFING": "WHOOF, to make a deep snorting sound, also WOOF [v]\n",
  "WHOOFS": "WHOOF, to make a deep snorting sound, also WOOF [v]\n",
  "WHOOMP": "a sudden loud sound, also WHOOMPH [n -S]\n",
  "WHOOMPH": "a sudden loud sound, also WHOOMP [n -S]\n",
  "WHOOMPHS": "WHOOMPH, a sudden loud sound, also WHOOMP [n]\n",
  "WHOOMPS": "WHOOMP, a sudden loud sound, also WHOOMPH [n]\n",
  "WHOONGA": "a narcotic substance smoked as a recreational drug in some parts of South Africa [n -S]\n",
  "WHOONGAS": "WHOONGA, a narcotic substance smoked as a recreational drug in some parts of South Africa [n]\n",
  "WHOOP": "to utter loud cries [v -ED, -ING, -S]\n",
  "WHOOPED": "WHOOP, to utter loud cries [v]\n",
  "WHOOPEE": "boisterous fun, also WHOOPIE [n -S]\n",
  "WHOOPEES": "WHOOPEE, boisterous fun, also WHOOPIE [n]\n",
  "WHOOPER": "a kind of swan [n -S]\n",
  "WHOOPERS": "WHOOPER, a kind of swan [n]\n",
  "WHOOPIE": "boisterous fun, also WHOOPEE [n -S]\n",
  "WHOOPIES": "WHOOPIE, boisterous fun, also WHOOPEE [n]\n",
  "WHOOPING": "the act of whooping [n -S]\n",
  "WHOOPINGS": "WHOOPING, the act of whooping [n]\n",
  "WHOOPLA": "a noisy commotion [n -S]\n",
  "WHOOPLAS": "WHOOPLA, a noisy commotion [n]\n",
  "WHOOPS": "WHOOP, to utter loud cries [v]\n",
  "WHOOPSIE": "a mess or a turd [n -S]\n",
  "WHOOPSIES": "WHOOPSIE, a mess or a turd [n]\n",
  "WHOOSH": "to move with a hissing sound, also WOOSH [v -ED, -ING, -ES]\n",
  "WHOOSHED": "WHOOSH, to move with a hissing sound, also WOOSH [v]\n",
  "WHOOSHES": "WHOOSH, to move with a hissing sound, also WOOSH [v]\n",
  "WHOOSHING": "WHOOSH, to move with a hissing sound, also WOOSH [v]\n",
  "WHOOSIS": "an object or person whose name is not known, also WHOSIS, WHOSIT [n -ES]\n",
  "WHOOSISES": "WHOOSIS, an object or person whose name is not known, also WHOSIS, WHOSIT [n]\n",
  "WHOOT": "(obsolete) to make a sound like an owl, also HOOT, HOUT [v -ED, -ING, -S]\n",
  "WHOOTED": "WHOOT, (obsolete) to make a sound like an owl, also HOOT, HOUT [v]\n",
  "WHOOTING": "WHOOT, (obsolete) to make a sound like an owl, also HOOT, HOUT [v]\n",
  "WHOOTS": "WHOOT, (obsolete) to make a sound like an owl, also HOOT, HOUT [v]\n",
  "WHOP": "to beat, also WHAP, WOP [v WHOPPED, WHOPPING, WHOPS]\n",
  "WHOPPED": "WHOP, to beat, also WHAP, WOP [v]\n",
  "WHOPPER": "something unusually large, also WHAPPER [n -S]\n",
  "WHOPPERS": "WHOPPER, something unusually large, also WHAPPER [n]\n",
  "WHOPPING": "a thrashing [n -S]\n",
  "WHOPPINGS": "WHOPPING, a thrashing [n]\n",
  "WHOPS": "WHOP, to beat, also WHAP, WOP [v]\n",
  "WHORE": "to consort with prostitutes [v WHORED, WHORING, WHORES]\n",
  "WHORED": "WHORE, to consort with prostitutes [v]\n",
  "WHOREDOM": "prostitution [n -S]\n",
  "WHOREDOMS": "WHOREDOM, prostitution [n]\n",
  "WHOREHOUSE": "a building in which prostitutes are available [n -S]\n",
  "WHOREHOUSES": "WHOREHOUSE, a building in which prostitutes are available [n]\n",
  "WHOREMASTER": "(archaic) one who runs whores [n -S]\n",
  "WHOREMASTERIES": "WHOREMASTERY, the keeping of whores [n]\n",
  "WHOREMASTERLY": "like a whoremaster [adj]\n",
  "WHOREMASTERS": "WHOREMASTER, (archaic) one who runs whores [n]\n",
  "WHOREMASTERY": "the keeping of whores [n WHOREMASTERIES]\n",
  "WHOREMISTRESS": "(archaic) a woman who runs a brothel [n -ES]\n",
  "WHOREMISTRESSES": "WHOREMISTRESS, (archaic) a woman who runs a brothel [n]\n",
  "WHOREMONGER": "a man consorting with whores or given to lechery [n -S]\n",
  "WHOREMONGERIES": "WHOREMONGERY, the business of a whoremonger [n]\n",
  "WHOREMONGERS": "WHOREMONGER, a man consorting with whores or given to lechery [n]\n",
  "WHOREMONGERY": "the business of a whoremonger [n WHOREMONGERIES]\n",
  "WHORES": "WHORE, to consort with prostitutes [v]\n",
  "WHORESON": "(archaic) bastard; whore's son, also HORSON [n -S]\n",
  "WHORESONS": "WHORESON, (archaic) bastard; whore's son, also HORSON [n]\n",
  "WHORING": "the profession of a whore [n -S]\n",
  "WHORINGS": "WHORING, the profession of a whore [n]\n",
  "WHORISH": "like a whore [adj WHORISHLY]\n",
  "WHORISHLY": "WHORISH, like a whore [adv]\n",
  "WHORISHNESS": "the behaviour of a whore [n -ES]\n",
  "WHORISHNESSES": "WHORISHNESS, the behaviour of a whore [n]\n",
  "WHORL": "to move in a twisted or convoluted fashion [v -ED, -ING, -S]\n",
  "WHORLBAT": "an ancient boxing glove loaded with metal, also WHIRLBAT [n -S]\n",
  "WHORLBATS": "WHORLBAT, an ancient boxing glove loaded with metal, also WHIRLBAT [n]\n",
  "WHORLED": "having whorls [adj]\n",
  "WHORLING": "WHORL, to move in a twisted or convoluted fashion [v]\n",
  "WHORLS": "WHORL, to move in a twisted or convoluted fashion [v]\n",
  "WHORT": "a whortleberry, also HURTLEBERRY, WHORTLE, WHORTLEBERRY [n -S]\n",
  "WHORTLE": "a whortleberry, also HURTLEBERRY, WHORT, WHORTLEBERRY [n -S]\n",
  "WHORTLEBERRIES": "WHORTLEBERRY, a widely spread heath plant; its dark blue edible berry, also HURTLEBERRY, WHORT, WHORTLE [n]\n",
  "WHORTLEBERRY": "a widely spread heath plant; its dark blue edible berry, also HURTLEBERRY, WHORT, WHORTLE [n WHORTLEBERRIES]\n",
  "WHORTLES": "WHORTLE, a whortleberry, also HURTLEBERRY, WHORT, WHORTLEBERRY [n]\n",
  "WHORTS": "WHORT, a whortleberry, also HURTLEBERRY, WHORTLE, WHORTLEBERRY [n]\n",
  "WHOSE": "the possessive case of who [adj]\n",
  "WHOSESO": "the possessive of whoso [adj]\n",
  "WHOSESOEVER": "(archaic) of or relating to whomsoever [pron]\n",
  "WHOSEVER": "the possessive case of whoever [pron]\n",
  "WHOSIS": "an object or person whose name is not known, also WHOOSIS, WHOSIT [n -ES]\n",
  "WHOSISES": "WHOSIS, an object or person whose name is not known, also WHOOSIS, WHOSIT [n]\n",
  "WHOSIT": "an object or person whose name is unknown or temporarily forgotten, also WHOOSIS, WHOSIS [n -S]\n",
  "WHOSITS": "WHOSIT, an object or person whose name is unknown or temporarily forgotten, also WHOOSIS, WHOSIS [n]\n",
  "WHOSO": "whosoever [pron]\n",
  "WHOSOEVER": "every one who [pron]\n",
  "WHOT": "(Spenser) hot [adj]\n",
  "WHOW": "(Scots) to impress [v -ED, -ING, -S]\n",
  "WHOWED": "WHOW, (Scots) to impress [v]\n",
  "WHOWING": "WHOW, (Scots) to impress [v]\n",
  "WHOWS": "WHOW, (Scots) to impress [v]\n",
  "WHUMMLE": "to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHOMMLE [v WHUMMLED, WHUMMLING, WHUMMLES]\n",
  "WHUMMLED": "WHUMMLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHOMMLE [v]\n",
  "WHUMMLES": "WHUMMLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHOMMLE [v]\n",
  "WHUMMLING": "WHUMMLE, to overturn; to throw into a state of disorder, also WHEMMLE, WHOMBLE, WHOMMLE [v]\n",
  "WHUMP": "to strike heavily, thump, also WHOMP [v -ED, -ING, -S]\n",
  "WHUMPED": "WHUMP, to strike heavily, thump, also WHOMP [v]\n",
  "WHUMPING": "WHUMP, to strike heavily, thump, also WHOMP [v]\n",
  "WHUMPS": "WHUMP, to strike heavily, thump, also WHOMP [v]\n",
  "WHUNSTANE": "(Scots) a hard and compact rock, also WHINSTONE [n -S]\n",
  "WHUNSTANES": "WHUNSTANE, (Scots) a hard and compact rock, also WHINSTONE [n]\n",
  "WHUP": "to defeat totally [v WHUPPED, WHUPPING, WHUPS]\n",
  "WHUPPED": "WHUP, to defeat totally [v]\n",
  "WHUPPING": "a whipping, a total defeat [n -S]\n",
  "WHUPPINGS": "WHUPPING, a whipping, a total defeat [n]\n",
  "WHUPS": "WHUP, to defeat totally [v]\n",
  "WHY": "the reason or cause of something [n -S]\n",
  "WHYDA": "a group of African birds related to the finch, also WHIDAH, WHYDAH [n -S]\n",
  "WHYDAH": "a group of African birds related to the finch, also WHIDAH, WHYDA [n -S]\n",
  "WHYDAHS": "WHYDAH, a group of African birds related to the finch, also WHIDAH, WHYDA [n]\n",
  "WHYDAS": "WHYDA, a group of African birds related to the finch, also WHIDAH, WHYDAH [n]\n",
  "WHYDUNIT": "a novel or film concerned with motives, as opposed to whodunit, also WHYDUNNIT [n -S]\n",
  "WHYDUNITS": "WHYDUNIT, a novel or film concerned with motives, as opposed to whodunit, also WHYDUNNIT [n]\n",
  "WHYDUNNIT": "a novel or film concerned with motives, as opposed to whodunnit, also WHYDUNIT [n -S]\n",
  "WHYDUNNITS": "WHYDUNNIT, a novel or film concerned with motives, as opposed to whodunnit, also WHYDUNIT [n]\n",
  "WHYEVER": "(colloquial) for whatever reason [adv]\n",
  "WHYS": "WHY, the reason or cause of something [n]\n",
  "WIBBLE": "to wobble, also WABBLE, WOBBLE [v WIBBLED, WIBBLING, WIBBLES]\n",
  "WIBBLED": "WIBBLE, to wobble, also WABBLE, WOBBLE [v]\n",
  "WIBBLES": "WIBBLE, to wobble, also WABBLE, WOBBLE [v]\n",
  "WIBBLING": "WIBBLE, to wobble, also WABBLE, WOBBLE [v]\n",
  "WICCA": "(Old English) the practice of witchcraft [n -S]\n",
  "WICCAN": "one who practices witchcraft [n -S]\n",
  "WICCANS": "WICCAN, one who practices witchcraft [n]\n",
  "WICCAS": "WICCA, (Old English) the practice of witchcraft [n]\n",
  "WICE": "(Scots) wise [adj]\n",
  "WICH": "a tree with pliant branches, as in wych elm, also WYCH [n -ES]\n",
  "WICHES": "WICH, a tree with pliant branches, as in wych elm, also WYCH [n]\n",
  "WICK": "a bundle of loosely twisted fibers in a candle or oil lamp, also WEEKE [n -S]\n",
  "WICKAPE": "(Native American) an American tree, aka leatherwood, also WICOPY [n -S]\n",
  "WICKAPES": "WICKAPE, (Native American) an American tree, aka leatherwood, also WICOPY [n]\n",
  "WICKED": "bad, evil [adj WICKEDER, WICKEDEST, WICKEDLY] / a wicked person [n -S]\n",
  "WICKEDER": "WICKED, bad, evil [adj]\n",
  "WICKEDEST": "WICKED, bad, evil [adj]\n",
  "WICKEDLY": "WICKED, bad, evil [adv]\n",
  "WICKEDNESS": "the state of being wicked [n -ES]\n",
  "WICKEDNESSES": "WICKEDNESS, the state of being wicked [n]\n",
  "WICKEDS": "WICKED, a wicked person [n]\n",
  "WICKEN": "the rowan tree, also WICKY, WITCHEN [n -S]\n",
  "WICKENS": "WICKEN, the rowan tree, also WICKY, WITCHEN [n]\n",
  "WICKER": "a pliant twig or branch [n -S]\n",
  "WICKERED": "made of wicker [adj]\n",
  "WICKERS": "WICKER, a pliant twig or branch [n]\n",
  "WICKERWORK": "basketwork of any kind [n -S]\n",
  "WICKERWORKS": "WICKERWORK, basketwork of any kind [n]\n",
  "WICKET": "a small gate [n -S]\n",
  "WICKETKEEPER": "the fieldsman who stands immediately behind the batsman's wicket and whose object is to stop balls missed by the batsman [n -S]\n",
  "WICKETKEEPERS": "WICKETKEEPER, the fieldsman who stands immediately behind the batsman's wicket and whose object is to stop balls missed by the batsman [n]\n",
  "WICKETS": "WICKET, a small gate [n]\n",
  "WICKIES": "WICKY, the rowan tree, also WICKEN, WITCHEN [n]\n",
  "WICKING": "material for wicks [n -S]\n",
  "WICKINGS": "WICKING, material for wicks [n]\n",
  "WICKIUP": "(Native American) a North American Indian hut constructed with an oval frame and covered with grass or mats, also WICKYUP, WIKIUP [n -S]\n",
  "WICKIUPS": "WICKIUP, (Native American) a North American Indian hut constructed with an oval frame and covered with grass or mats, also WICKYUP, WIKIUP [n]\n",
  "WICKLESS": "without a wick [adj]\n",
  "WICKS": "WICK, a bundle of loosely twisted fibers in a candle or oil lamp, also WEEKE [n]\n",
  "WICKTHING": "(dialect) a creeping animal, such as a woodlouse [n -S]\n",
  "WICKTHINGS": "WICKTHING, (dialect) a creeping animal, such as a woodlouse [n]\n",
  "WICKY": "the rowan tree, also WICKEN, WITCHEN [n WICKIES]\n",
  "WICKYUP": "(Native American) a North American Indian hut constructed with an oval frame and covered with grass or mats, also WICKIUP, WIKIUP [n -S]\n",
  "WICKYUPS": "WICKYUP, (Native American) a North American Indian hut constructed with an oval frame and covered with grass or mats, also WICKIUP, WIKIUP [n]\n",
  "WICOPIES": "WICOPY, (Native American) an American tree, aka leatherwood, also WICKAPE [n]\n",
  "WICOPY": "(Native American) an American tree, aka leatherwood, also WICKAPE [n WICOPIES]\n",
  "WIDDER": "(colloquial) a widow [n -S]\n",
  "WIDDERS": "WIDDER, (colloquial) a widow [n]\n",
  "WIDDERSHINS": "in a left-handed, wrong, or contrary direction; counterclockwise, also WIDERSHINS, WITHERSHINS [adv]\n",
  "WIDDIE": "(Scots) a rope, esp. one made of osiers; a hangman's noose, also WIDDY [n -S]\n",
  "WIDDIES": "WIDDY, (Scots) a rope, esp. one made of osiers; a hangman's noose, also WIDDIE [n]\n",
  "WIDDLE": "a child's word for to urinate [v WIDDLED, WIDDLING, WIDDLES]\n",
  "WIDDLED": "WIDDLE, a child's word for to urinate [v]\n",
  "WIDDLES": "WIDDLE, a child's word for to urinate [v]\n",
  "WIDDLING": "WIDDLE, a child's word for to urinate [v]\n",
  "WIDDY": "(Scots) a rope, esp. one made of osiers; a hangman's noose, also WIDDIE [n WIDDIES]\n",
  "WIDE": "broad [adj WIDER, WIDEST, WIDELY] / a wide ball in cricket [n -S]\n",
  "WIDEAWAKE": "a low wide-brimmed soft felt hat [n -S]\n",
  "WIDEAWAKES": "WIDEAWAKE, a low wide-brimmed soft felt hat [n]\n",
  "WIDEBAND": "a wide bandwidth transmission [n -S]\n",
  "WIDEBANDS": "WIDEBAND, a wide bandwidth transmission [n]\n",
  "WIDEBODIES": "WIDEBODY, an aircraft with a wide body [n]\n",
  "WIDEBODY": "an aircraft with a wide body [n WIDEBODIES]\n",
  "WIDECHAPPED": "(Shakespeare) openmouthed [adj]\n",
  "WIDELY": "WIDE, broad [adv]\n",
  "WIDEMOUTHED": "having a wide mouth [adj]\n",
  "WIDEN": "to make wide or wider [v -ED, -ING, -S]\n",
  "WIDENED": "WIDEN, to make wide or wider [v]\n",
  "WIDENER": "a kind of tool for widening something [n -S]\n",
  "WIDENERS": "WIDENER, a kind of tool for widening something [n]\n",
  "WIDENESS": "the state of being wide [n -ES]\n",
  "WIDENESSES": "WIDENESS, the state of being wide [n]\n",
  "WIDENING": "the act of making wide [n -S]\n",
  "WIDENINGS": "WIDENING, the act of making wide [n]\n",
  "WIDENS": "WIDEN, to make wide or wider [v]\n",
  "WIDEOUT": "a football position [n -S]\n",
  "WIDEOUTS": "WIDEOUT, a football position [n]\n",
  "WIDER": "WIDE, broad [adj]\n",
  "WIDERSHINS": "in a left-handed, wrong, or contrary direction; counterclockwise, also WIDDERSHINS, WITHERSHINS [adv]\n",
  "WIDES": "WIDE, a wide ball in cricket [n]\n",
  "WIDESCREEN": "denoting a cinema format in which the image is projected onto a wide curved screen to give the viewer a greater sense of actuality in the picture [adj]\n",
  "WIDESPREAD": "widely diffused or prevalent [adj]\n",
  "WIDEST": "WIDE, broad [adj]\n",
  "WIDGEON": "a kind of freshwater duck, also WIGEON [n -S]\n",
  "WIDGEONS": "WIDGEON, a kind of freshwater duck, also WIGEON [n]\n",
  "WIDGET": "any small manufactured object [n -S]\n",
  "WIDGETS": "WIDGET, any small manufactured object [n]\n",
  "WIDGIE": "an Australian Teddy girl of the 1950s, the female equivalent of a bodgie [n -S]\n",
  "WIDGIES": "WIDGIE, an Australian Teddy girl of the 1950s, the female equivalent of a bodgie [n]\n",
  "WIDISH": "somewhat wide [adj]\n",
  "WIDOW": "to deprive of a husband [v -ED, -ING, -S]\n",
  "WIDOWBIRD": "another name for the whydah [n -S]\n",
  "WIDOWBIRDS": "WIDOWBIRD, another name for the whydah [n]\n",
  "WIDOWED": "WIDOW, to deprive of a husband [v]\n",
  "WIDOWER": "a man whose wife is dead and has not remarried, also WIDOWMAN [n -S]\n",
  "WIDOWERED": "made into a widower [adj]\n",
  "WIDOWERHOOD": "the fact or state of being a widower [n -S]\n",
  "WIDOWERHOODS": "WIDOWERHOOD, the fact or state of being a widower [n]\n",
  "WIDOWERS": "WIDOWER, a man whose wife is dead and has not remarried, also WIDOWMAN [n]\n",
  "WIDOWHOOD": "the state of being a widow [n -S]\n",
  "WIDOWHOODS": "WIDOWHOOD, the state of being a widow [n]\n",
  "WIDOWING": "WIDOW, to deprive of a husband [v]\n",
  "WIDOWMAN": "a man whose wife is dead, also WIDOWER [n WIDOWMEN]\n",
  "WIDOWMEN": "WIDOWMAN, a man whose wife is dead, also WIDOWER [n]\n",
  "WIDOWS": "WIDOW, to deprive of a husband [v]\n",
  "WIDTH": "the extent from side to side [n -S]\n",
  "WIDTHS": "WIDTH, the extent from side to side [n]\n",
  "WIDTHWAY": "across the width, as distinct from lengthways, also WIDTHWAYS, WIDTHWISE [adj]\n",
  "WIDTHWAYS": "across the width, as distinct from lengthways, also WIDTHWAY, WIDTHWISE [adv]\n",
  "WIDTHWISE": "across the width, as distinct from lengthways, also WIDTHWAY, WIDTHWAYS [adv]\n",
  "WIEL": "a whirlpool, also WEEL, WEIL [n -S]\n",
  "WIELD": "to handle or use effectively [v -ED, -ING, -S]\n",
  "WIELDABLE": "capable of being wielded [adj]\n",
  "WIELDED": "WIELD, to handle or use effectively [v]\n",
  "WIELDER": "one that wields [n -S]\n",
  "WIELDERS": "WIELDER, one that wields [n]\n",
  "WIELDIER": "WIELDY, easily wielded [adj]\n",
  "WIELDIEST": "WIELDY, easily wielded [adj]\n",
  "WIELDINESS": "manageability [n -ES]\n",
  "WIELDINESSES": "WIELDINESS, manageability [n]\n",
  "WIELDING": "WIELD, to handle or use effectively [v]\n",
  "WIELDLESS": "unmanageable [adj]\n",
  "WIELDS": "WIELD, to handle or use effectively [v]\n",
  "WIELDY": "easily wielded [adj WIELDIER, WIELDIEST]\n",
  "WIELS": "WIEL, a whirlpool, also WEEL, WEIL [n]\n",
  "WIENER": "(German) a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEENY, WEINER, WIENERWURST, WIENIE [n -S]\n",
  "WIENERS": "WIENER, (German) a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEENY, WEINER, WIENERWURST, WIENIE [n]\n",
  "WIENERWURST": "(German) a kind of sausage, also WEENIE, WEENY, WEINER, WIENER, WIENIE [n -S]\n",
  "WIENERWURSTS": "WIENERWURST, (German) a kind of sausage, also WEENIE, WEENY, WEINER, WIENER, WIENIE [n]\n",
  "WIENIE": "a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEENY, WEINER, WIENER, WIENERWURST [n -S]\n",
  "WIENIES": "WIENIE, a frankfurter, a small smoked beef or pork sausage, also WEENIE, WEENY, WEINER, WIENER, WIENERWURST [n]\n",
  "WIFE": "a woman who has a husband [n WIVES] / to take to wife [v WIFED, WIFING, WIFES]\n",
  "WIFED": "WIFE, to take to wife [v]\n",
  "WIFEDOM": "the status of a wife, also WIFEHOOD [n -S]\n",
  "WIFEDOMS": "WIFEDOM, the status of a wife, also WIFEHOOD [n]\n",
  "WIFEHOOD": "the status of a wife, also WIFEDOM, WIVEHOOD [n -S]\n",
  "WIFEHOODS": "WIFEHOOD, the status of a wife, also WIFEDOM, WIVEHOOD [n]\n",
  "WIFELESS": "without a wife [adj]\n",
  "WIFELIER": "WIFELY, befitting a wife [adj]\n",
  "WIFELIEST": "WIFELY, befitting a wife [adj]\n",
  "WIFELIKE": "of, pertaining to, or like, a wife [adj]\n",
  "WIFELINESS": "the state of being wifely [n -ES]\n",
  "WIFELINESSES": "WIFELINESS, the state of being wifely [n]\n",
  "WIFELY": "befitting a wife [adj WIFELIER, WIFELIEST]\n",
  "WIFES": "WIFE, to take to wife [v]\n",
  "WIFEY": "an endearment for wife, also WIFIE [n -S]\n",
  "WIFEYS": "WIFEY, an endearment for wife, also WIFIE [n]\n",
  "WIFIE": "an endearment for wife, also WIFEY [n -S]\n",
  "WIFIES": "WIFIE, an endearment for wife, also WIFEY [n]\n",
  "WIFING": "WIFE, to take to wife [v]\n",
  "WIFTIER": "WIFTY, ditsy, amiably eccentric [adj]\n",
  "WIFTIEST": "WIFTY, ditsy, amiably eccentric [adj]\n",
  "WIFTY": "ditsy, amiably eccentric [adj WIFTIER, WIFTIEST]\n",
  "WIG": "an artificial covering of hair for the head [n -S] / to scold; to provide with a wig [v WIGGED, WIGGING, WIGS]\n",
  "WIGAN": "a stiff plain-woven cotton [n -S]\n",
  "WIGANS": "WIGAN, a stiff plain-woven cotton [n]\n",
  "WIGEON": "a kind of freshwater duck, also WIDGEON [n -S]\n",
  "WIGEONS": "WIGEON, a kind of freshwater duck, also WIDGEON [n]\n",
  "WIGGA": "(colloquial) a white youth who adopts Black youth culture, also WIGGER [n -S]\n",
  "WIGGAS": "WIGGA, (colloquial) a white youth who adopts Black youth culture, also WIGGER [n]\n",
  "WIGGED": "WIG, to scold; to provide with a wig [v]\n",
  "WIGGER": "(colloquial) a white youth who adopts Black youth culture, also WIGGA [n -S]\n",
  "WIGGERIES": "WIGGERY, a wig or wigs; false hair [n]\n",
  "WIGGERS": "WIGGER, (colloquial) a white youth who adopts Black youth culture, also WIGGA [n]\n",
  "WIGGERY": "a wig or wigs; false hair [n WIGGERIES]\n",
  "WIGGIER": "WIGGY, crazy [adj]\n",
  "WIGGIEST": "WIGGY, crazy [adj]\n",
  "WIGGING": "a scolding [n -S]\n",
  "WIGGINGS": "WIGGING, a scolding [n]\n",
  "WIGGLE": "to move with short, quick movements from side to side [v WIGGLED, WIGGLING, WIGGLES]\n",
  "WIGGLED": "WIGGLE, to move with short, quick movements from side to side [v]\n",
  "WIGGLER": "one who wiggles [n -S]\n",
  "WIGGLERS": "WIGGLER, one who wiggles [n]\n",
  "WIGGLES": "WIGGLE, to move with short, quick movements from side to side [v]\n",
  "WIGGLIER": "WIGGLY, tending to wiggle [adj]\n",
  "WIGGLIEST": "WIGGLY, tending to wiggle [adj]\n",
  "WIGGLING": "WIGGLE, to move with short, quick movements from side to side [v]\n",
  "WIGGLY": "tending to wiggle [adj WIGGLIER, WIGGLIEST]\n",
  "WIGGY": "crazy [adj WIGGIER, WIGGIEST]\n",
  "WIGHT": "swift, nimble, also WITE, WYTE [adj WIGHTLY] / (Scots) to blame, lay the blame on [v -ED, -ING, -S]\n",
  "WIGHTED": "WIGHT, (Scots) to blame, lay the blame on [v]\n",
  "WIGHTING": "WIGHT, (Scots) to blame, lay the blame on [v]\n",
  "WIGHTLY": "WIGHT, swift, nimble, also WITE, WYTE [adv]\n",
  "WIGHTS": "WIGHT, (Scots) to blame, lay the blame on [v]\n",
  "WIGLESS": "without a wig [adj]\n",
  "WIGLET": "a small wig [n -S]\n",
  "WIGLETS": "WIGLET, a small wig [n]\n",
  "WIGLIKE": "like a wig [adj]\n",
  "WIGMAKER": "one who makes wigs [n -S]\n",
  "WIGMAKERS": "WIGMAKER, one who makes wigs [n]\n",
  "WIGS": "WIG, to scold; to provide with a wig [v]\n",
  "WIGWAG": "to twist about [v WIGWAGGED, WIGWAGGING, WIGWAGS]\n",
  "WIGWAGGED": "WIGWAG, to twist about [v]\n",
  "WIGWAGGER": "one who wigwags, signals with flags [n -S]\n",
  "WIGWAGGERS": "WIGWAGGER, one who wigwags, signals with flags [n]\n",
  "WIGWAGGING": "WIGWAG, to twist about [v]\n",
  "WIGWAGS": "WIGWAG, to twist about [v]\n",
  "WIGWAM": "(Native American) a domed tentlike American Indian dwelling [n -S]\n",
  "WIGWAMS": "WIGWAM, (Native American) a domed tentlike American Indian dwelling [n]\n",
  "WIKI": "a collaborative website with contents editable by users [n -S]\n",
  "WIKIALITIES": "WIKIALITY, information that is assumed to be true because it appears in a wiki-based encyclopaedia [n]\n",
  "WIKIALITY": "information that is assumed to be true because it appears in a wiki-based encyclopaedia [n WIKIALITIES]\n",
  "WIKIS": "WIKI, a collaborative website with contents editable by users [n]\n",
  "WIKITORIAL": "a traditional editorial that can be edited in the fashion of a wiki [n -S]\n",
  "WIKITORIALS": "WIKITORIAL, a traditional editorial that can be edited in the fashion of a wiki [n]\n",
  "WIKIUP": "(Native American) a North American Indian hut constructed with an oval frame and covered with grass or mats, also WICKIUP, WICKYUP [n -S]\n",
  "WIKIUPS": "WIKIUP, (Native American) a North American Indian hut constructed with an oval frame and covered with grass or mats, also WICKIUP, WICKYUP [n]\n",
  "WILCO": "in signalling, an indication of compliance ('I will comply') [adj]\n",
  "WILD": "not tame [adj WILDER, WILDEST, WILDLY] / (obsolete) to wield [v -ED, -ING, -S]\n",
  "WILDCARD": "a symbol used in a database search to represent unspecified characters [n -S]\n",
  "WILDCARDS": "WILDCARD, a symbol used in a database search to represent unspecified characters [n]\n",
  "WILDCAT": "to drill an experimental well in an area of unknown productivity in search of oil, gas, ore, etc. [v WILDCATTED, WILDCATTING, WILDCATS]\n",
  "WILDCATS": "WILDCAT, to drill an experimental well in an area of unknown productivity in search of oil, gas, ore, etc. [v]\n",
  "WILDCATTED": "WILDCAT, to drill an experimental well in an area of unknown productivity in search of oil, gas, ore, etc. [v]\n",
  "WILDCATTER": "one that drills wells in the hope of finding oil in territory not known to be an oil field [n -S]\n",
  "WILDCATTERS": "WILDCATTER, one that drills wells in the hope of finding oil in territory not known to be an oil field [n]\n",
  "WILDCATTING": "the practice of drilling an experimental well in search of oil, gas etc. [n -S]\n",
  "WILDCATTINGS": "WILDCATTING, the practice of drilling an experimental well in search of oil, gas etc. [n]\n",
  "WILDEBEEST": "another name for the gnu [n -S]\n",
  "WILDEBEESTS": "WILDEBEEST, another name for the gnu [n]\n",
  "WILDED": "WILD, (obsolete) to wield [v]\n",
  "WILDER": "to cause to stray [v -ED, -ING, -S]\n",
  "WILDERED": "WILDER, to cause to stray [v]\n",
  "WILDERING": "WILDER, to cause to stray [v]\n",
  "WILDERMENT": "the state of being bewildered [n -S]\n",
  "WILDERMENTS": "WILDERMENT, the state of being bewildered [n]\n",
  "WILDERNESS": "a tract or region uncultivated and uninhabited by human beings [n -ES]\n",
  "WILDERNESSES": "WILDERNESS, a tract or region uncultivated and uninhabited by human beings [n]\n",
  "WILDERS": "WILDER, to cause to stray [v]\n",
  "WILDEST": "WILD, not tame [adj]\n",
  "WILDFIRE": "raging destructive fire [n -S]\n",
  "WILDFIRES": "WILDFIRE, raging destructive fire [n]\n",
  "WILDFLOWER": "any flower growing in the wild [n -S]\n",
  "WILDFLOWERS": "WILDFLOWER, any flower growing in the wild [n]\n",
  "WILDFOWL": "a game bird, esp. a duck or goose [n -S]\n",
  "WILDFOWLER": "one who hunts wildfowl [n -S]\n",
  "WILDFOWLERS": "WILDFOWLER, one who hunts wildfowl [n]\n",
  "WILDFOWLING": "the sport of hunting wildfowl [n -S]\n",
  "WILDFOWLINGS": "WILDFOWLING, the sport of hunting wildfowl [n]\n",
  "WILDFOWLS": "WILDFOWL, a game bird, esp. a duck or goose [n]\n",
  "WILDGRAVE": "(German) a former German title of count; a head forest ranger, also WALDGRAVE [n -S]\n",
  "WILDGRAVES": "WILDGRAVE, (German) a former German title of count; a head forest ranger, also WALDGRAVE [n]\n",
  "WILDING": "that which grows wild, also WILDLING [n -S]\n",
  "WILDINGS": "WILDING, that which grows wild, also WILDLING [n]\n",
  "WILDISH": "somewhat wild [adj]\n",
  "WILDLAND": "uncultivated land [n -S]\n",
  "WILDLANDS": "WILDLAND, uncultivated land [n]\n",
  "WILDLIFE": "wild animals, birds etc. [n -S]\n",
  "WILDLIFES": "WILDLIFE, wild animals, birds etc. [n]\n",
  "WILDLING": "a wild plant or animal, also WILDING [n -S]\n",
  "WILDLINGS": "WILDLING, a wild plant or animal, also WILDING [n]\n",
  "WILDLY": "WILD, not tame [adv]\n",
  "WILDMAN": "a man who lives outside civilization [n WILDMEN]\n",
  "WILDMEN": "WILDMAN, a man who lives outside civilization [n]\n",
  "WILDNESS": "the state of being wild [n -ES]\n",
  "WILDNESSES": "WILDNESS, the state of being wild [n]\n",
  "WILDS": "WILD, (obsolete) to wield [v]\n",
  "WILDWOOD": "natural forest land [n -S]\n",
  "WILDWOODS": "WILDWOOD, natural forest land [n]\n",
  "WILE": "to beguile, also WYLE [v WILED, WILING, WILES]\n",
  "WILED": "WILE, to beguile, also WYLE [v]\n",
  "WILEFUL": "full of wiles [adj]\n",
  "WILES": "WILE, to beguile, also WYLE [v]\n",
  "WILFUL": "bent on having one's own way, also WILLFUL, WILLYARD, WILLYART [adj]\n",
  "WILFULLY": "WILFUL, bent on having one's own way, also WILLFUL, WILLYARD, WILLYART [adv]\n",
  "WILFULNESS": "the state of being wilful, also WILLFULNESS [n -ES]\n",
  "WILFULNESSES": "WILFULNESS, the state of being wilful, also WILLFULNESS [n]\n",
  "WILGA": "(Native Australian) a small white-flowered Australian tree [n -S]\n",
  "WILGAS": "WILGA, (Native Australian) a small white-flowered Australian tree [n]\n",
  "WILI": "in the ballet Giselle, the spirit of a girl who dies before her wedding day [n -S]\n",
  "WILIER": "WILY, crafty [adj]\n",
  "WILIEST": "WILY, crafty [adj]\n",
  "WILILY": "WILY, crafty [adv]\n",
  "WILINESS": "the quality of being wily [n -ES]\n",
  "WILINESSES": "WILINESS, the quality of being wily [n]\n",
  "WILING": "WILE, to beguile, also WYLE [v]\n",
  "WILIS": "WILI, in the ballet Giselle, the spirit of a girl who dies before her wedding day [n]\n",
  "WILJA": "(Native Australian) an Aboriginal shelter or hut, also WILTJA [n -S]\n",
  "WILJAS": "WILJA, (Native Australian) an Aboriginal shelter or hut, also WILTJA [n]\n",
  "WILL": "to decide upon, used as an auxiliary followed by a simple infinitive to express futurity [v WILLED, WILLING, WILLS, past sing 2d person WILLEST, WOULD, WOULDEST, or WOULDST]\n",
  "WILLABLE": "able to will [adj]\n",
  "WILLED": "WILL, to decide upon, used as an auxiliary followed by a simple infinitive to express futurity [v]\n",
  "WILLEMITE": "a silicate of zinc, usually occurring in masses and of a greenish yellow color; also in reddish crystals containing manganese [n -S]\n",
  "WILLEMITES": "WILLEMITE, a silicate of zinc, usually occurring in masses and of a greenish yellow color; also in reddish crystals containing manganese [n]\n",
  "WILLER": "someone who wills [n -S]\n",
  "WILLERS": "WILLER, someone who wills [n]\n",
  "WILLEST": "WILL, to decide upon, used as an auxiliary followed by a simple infinitive to express futurity [v]\n",
  "WILLET": "a large North American snipe [n -S]\n",
  "WILLETS": "WILLET, a large North American snipe [n]\n",
  "WILLEY": "to clean in a willowing-machine, also WILLY [v -ED, -ING, -S]\n",
  "WILLEYED": "WILLEY, to clean in a willowing-machine, also WILLY [v]\n",
  "WILLEYING": "WILLEY, to clean in a willowing-machine, also WILLY [v]\n",
  "WILLEYS": "WILLEY, to clean in a willowing-machine, also WILLY [v]\n",
  "WILLFUL": "bent on having one's own way, also WILFUL, WILLYARD, WILLYART [adj]\n",
  "WILLFULLY": "WILLFUL, bent on having one's own way, also WILFUL, WILLYARD, WILLYART [adv]\n",
  "WILLFULNESS": "the state of being willful, also WILFULNESS [n -ES]\n",
  "WILLFULNESSES": "WILLFULNESS, the state of being willful, also WILFULNESS [n]\n",
  "WILLIAM": "as in sweet william, a flowering plant [n -S]\n",
  "WILLIAMS": "WILLIAM, as in sweet william, a flowering plant [n]\n",
  "WILLIE": "a childish word for the penis [n -S]\n",
  "WILLIED": "WILLY, to clean in a willowing-machine, also WILLEY [v]\n",
  "WILLIES": "WILLY, to clean in a willowing-machine, also WILLEY [v]\n",
  "WILLIEWAUGHT": "(Scots) a deep draught of alcohol [n -S]\n",
  "WILLIEWAUGHTS": "WILLIEWAUGHT, (Scots) a deep draught of alcohol [n]\n",
  "WILLING": "ready to comply [adj WILLINGER, WILLINGEST, WILLINGLY]\n",
  "WILLINGER": "WILLING, ready to comply [adj]\n",
  "WILLINGEST": "WILLING, ready to comply [adj]\n",
  "WILLINGLY": "WILLING, ready to comply [adv]\n",
  "WILLINGNESS": "the state of being willing [n -ES]\n",
  "WILLINGNESSES": "WILLINGNESS, the state of being willing [n]\n",
  "WILLIWAU": "a violent gust of cold wind, also WILLIWAW, WILLYWAW [n -S]\n",
  "WILLIWAUS": "WILLIWAU, a violent gust of cold wind, also WILLIWAW, WILLYWAW [n]\n",
  "WILLIWAW": "a violent gust of cold wind, also WILLIWAU, WILLYWAW [n -S]\n",
  "WILLIWAWS": "WILLIWAW, a violent gust of cold wind, also WILLIWAU, WILLYWAW [n]\n",
  "WILLOW": "to clean textile fibres [v -ED, -ING, -S]\n",
  "WILLOWED": "WILLOW, to clean textile fibres [v]\n",
  "WILLOWER": "one who willows [n -S]\n",
  "WILLOWERS": "WILLOWER, one who willows [n]\n",
  "WILLOWHERB": "a perennial herb of the evening primrose family with willowlike leaves and seeds [n -S]\n",
  "WILLOWHERBS": "WILLOWHERB, a perennial herb of the evening primrose family with willowlike leaves and seeds [n]\n",
  "WILLOWIER": "WILLOWY, slender and graceful [adj]\n",
  "WILLOWIEST": "WILLOWY, slender and graceful [adj]\n",
  "WILLOWING": "WILLOW, to clean textile fibres [v]\n",
  "WILLOWISH": "of the colour of willow leaves [adj]\n",
  "WILLOWLIKE": "like a willow [adj]\n",
  "WILLOWS": "WILLOW, to clean textile fibres [v]\n",
  "WILLOWWARE": "goods e.g. baskets made of willow [n -S]\n",
  "WILLOWWARES": "WILLOWWARE, goods e.g. baskets made of willow [n]\n",
  "WILLOWY": "slender and graceful [adj WILLOWIER, WILLOWIEST]\n",
  "WILLPOWER": "the power of the will [n -S]\n",
  "WILLPOWERS": "WILLPOWER, the power of the will [n]\n",
  "WILLS": "WILL, to decide upon, used as an auxiliary followed by a simple infinitive to express futurity [v]\n",
  "WILLY": "to clean in a willowing-machine, also WILLEY [v WILLIED, WILLYING, WILLIES]\n",
  "WILLYARD": "(Scots) bent on having one's own way, also WILLFUL, WILFUL, WILLYART [adj]\n",
  "WILLYART": "(Scots) bent on having one's own way, also WILLFUL, WILFUL, WILLYARD [adj]\n",
  "WILLYING": "WILLY, to clean in a willowing-machine, also WILLEY [v]\n",
  "WILLYWAW": "a violent gust of cold wind, also WILLIWAU, WILLIWAW [n -S]\n",
  "WILLYWAWS": "WILLYWAW, a violent gust of cold wind, also WILLIWAU, WILLIWAW [n]\n",
  "WILT": "to become limp [v -ED, -ING, -S]\n",
  "WILTED": "WILT, to become limp [v]\n",
  "WILTING": "WILT, to become limp [v]\n",
  "WILTJA": "(Native Australian) an Aboriginal shelter or hut, also WILJA [n -S]\n",
  "WILTJAS": "WILTJA, (Native Australian) an Aboriginal shelter or hut, also WILJA [n]\n",
  "WILTS": "WILT, to become limp [v]\n",
  "WILY": "crafty [adj WILIER, WILIEST, WILILY]\n",
  "WIMBLE": "an instrument for boring holes; a gimlet [n -S] / to bore through with a wimble [v WIMBLED, WIMBLING, WIMBLES]\n",
  "WIMBLED": "WIMBLE, to bore through with a wimble [v]\n",
  "WIMBLES": "WIMBLE, to bore through with a wimble [v]\n",
  "WIMBLING": "WIMBLE, to bore through with a wimble [v]\n",
  "WIMBREL": "a bird like a curlew, also WHIMBREL [n -S]\n",
  "WIMBRELS": "WIMBREL, a bird like a curlew, also WHIMBREL [n]\n",
  "WIMMIN": "an attempt by American feminists to create a word for women without the man element, also WOMYN [n]\n",
  "WIMP": "a timid person [n -S] / to act like a wimp, as in the phrase to wimp out [v -ED, -ING, -S]\n",
  "WIMPED": "WIMP, to act like a wimp, as in the phrase to wimp out [v]\n",
  "WIMPIER": "WIMPY, ineffectual, also WIMPISH [adj]\n",
  "WIMPIEST": "WIMPY, ineffectual, also WIMPISH [adj]\n",
  "WIMPINESS": "the quality of being a wimpy [n -ES]\n",
  "WIMPINESSES": "WIMPINESS, the quality of being a wimpy [n]\n",
  "WIMPING": "WIMP, to act like a wimp, as in the phrase to wimp out [v]\n",
  "WIMPISH": "ineffectual, also WIMPY [adj WIMPISHLY]\n",
  "WIMPISHLY": "WIMPISH, ineffectual, also WIMPY [adv]\n",
  "WIMPISHNESS": "the state of being wimpish [n -ES]\n",
  "WIMPISHNESSES": "WIMPISHNESS, the state of being wimpish [n]\n",
  "WIMPLE": "a cloth covering for head and neck worn by nuns [n -S] / to wrap in a wimple, also WHIMPLE [v WIMPLED, WIMPLING, WIMPLES]\n",
  "WIMPLED": "WIMPLE, to wrap in a wimple, also WHIMPLE [v]\n",
  "WIMPLES": "WIMPLE, to wrap in a wimple, also WHIMPLE [v]\n",
  "WIMPLING": "WIMPLE, to wrap in a wimple, also WHIMPLE [v]\n",
  "WIMPS": "WIMP, to act like a wimp, as in the phrase to wimp out [v]\n",
  "WIMPY": "ineffectual, also WIMPISH [adj WIMPIER, WIMPIEST]\n",
  "WIN": "to gain [v WON, WINNING, WINS] / to winnow [v WINNED, WINNING, WINS]\n",
  "WINCE": "to flinch [v WINCED, WINCING, WINCES]\n",
  "WINCED": "WINCE, to flinch [v]\n",
  "WINCER": "one who winces [n -S]\n",
  "WINCERS": "WINCER, one who winces [n]\n",
  "WINCES": "WINCE, to flinch [v]\n",
  "WINCEY": "plain or twilled cotton, also WINSEY [n -S]\n",
  "WINCEYETTE": "a kind of material used for nightwear etc. [n -S]\n",
  "WINCEYETTES": "WINCEYETTE, a kind of material used for nightwear etc. [n]\n",
  "WINCEYS": "WINCEY, plain or twilled cotton, also WINSEY [n]\n",
  "WINCH": "to raise with a hoist [v -ED, -ING, -ES]\n",
  "WINCHED": "WINCH, to raise with a hoist [v]\n",
  "WINCHER": "one who winches [n -S]\n",
  "WINCHERS": "WINCHER, one who winches [n]\n",
  "WINCHES": "WINCH, to raise with a hoist [v]\n",
  "WINCHESTER": "a large cylindrical bottle with a narrow neck used for transporting chemicals [n -S]\n",
  "WINCHESTERS": "WINCHESTER, a large cylindrical bottle with a narrow neck used for transporting chemicals [n]\n",
  "WINCHING": "WINCH, to raise with a hoist [v]\n",
  "WINCHMAN": "one who operates a winch [n WINCHMEN]\n",
  "WINCHMEN": "WINCHMAN, one who operates a winch [n]\n",
  "WINCING": "the act of making a wince [n -S]\n",
  "WINCINGLY": "WINCING [adv]\n",
  "WINCINGS": "WINCING, the act of making a wince [n]\n",
  "WINCOPIPE": "(obsolete) a little red flower, probably the scarlet pimpernel [n -S]\n",
  "WINCOPIPES": "WINCOPIPE, (obsolete) a little red flower, probably the scarlet pimpernel [n]\n",
  "WIND": "to twist or coil [v WOUND, WINDING, WINDS] / to make out of breath [v WINDED, WINDING, WINDS]\n",
  "WINDABLE": "able to be wound [adj]\n",
  "WINDAC": "a windlass, also WINDAS [n -S]\n",
  "WINDACS": "WINDAC, a windlass, also WINDAS [n]\n",
  "WINDAGE": "the influence of the wind in deflecting a missile [n -S]\n",
  "WINDAGES": "WINDAGE, the influence of the wind in deflecting a missile [n]\n",
  "WINDAS": "a windlass, also WINDAC [n -ES]\n",
  "WINDASES": "WINDAS, a windlass, also WINDAC [n]\n",
  "WINDBAG": "a talkative person [n -S]\n",
  "WINDBAGGERIES": "WINDBAGGERY, being a windbag [n]\n",
  "WINDBAGGERY": "being a windbag [n WINDBAGGERIES]\n",
  "WINDBAGS": "WINDBAG, a talkative person [n]\n",
  "WINDBELL": "a light bell that can be sounded by the wind [n -S]\n",
  "WINDBELLS": "WINDBELL, a light bell that can be sounded by the wind [n]\n",
  "WINDBILL": "a bill of exchange guaranteed by a third party [n -S]\n",
  "WINDBILLS": "WINDBILL, a bill of exchange guaranteed by a third party [n]\n",
  "WINDBLAST": "a blast of wind [n -S]\n",
  "WINDBLASTS": "WINDBLAST, a blast of wind [n]\n",
  "WINDBLOW": "the blowing down of trees by the wind [n -S]\n",
  "WINDBLOWN": "blown down by the wind [adj]\n",
  "WINDBLOWS": "WINDBLOW, the blowing down of trees by the wind [n]\n",
  "WINDBORNE": "carried on the wind e.g. of seeds [adj]\n",
  "WINDBOUND": "hindered from sailing by contrary winds [adj]\n",
  "WINDBREAK": "something serving as a protection against the force of the wind, such as a fence or line of trees [n -S]\n",
  "WINDBREAKER": "(tradename) a type of windproof jacket with elasticated cuffs and waistband [n -S]\n",
  "WINDBREAKERS": "WINDBREAKER, (tradename) a type of windproof jacket with elasticated cuffs and waistband [n]\n",
  "WINDBREAKS": "WINDBREAK, something serving as a protection against the force of the wind, such as a fence or line of trees [n]\n",
  "WINDBURN": "to cause irritation to the skin by wind [v WINDBURNED, WINDBURNT, WINDBURNING, WINDBURNS]\n",
  "WINDBURNED": "WINDBURN, to cause irritation to the skin by wind [v]\n",
  "WINDBURNING": "WINDBURN, to cause irritation to the skin by wind [v]\n",
  "WINDBURNS": "WINDBURN, to cause irritation to the skin by wind [v]\n",
  "WINDBURNT": "WINDBURN, to cause irritation to the skin by wind [v]\n",
  "WINDCHEATER": "a windproof jacket [n -S]\n",
  "WINDCHEATERS": "WINDCHEATER, a windproof jacket [n]\n",
  "WINDCHILL": "the cooling effect that wind has as it blows on a surface [n -S]\n",
  "WINDCHILLS": "WINDCHILL, the cooling effect that wind has as it blows on a surface [n]\n",
  "WINDED": "WIND, to twist or coil [v]\n",
  "WINDER": "(slang) a blow that takes one's breath away [n -S]\n",
  "WINDERS": "WINDER, (slang) a blow that takes one's breath away [n]\n",
  "WINDFALL": "unexpected good fortune [n -S]\n",
  "WINDFALLEN": "blown down by the wind [adj]\n",
  "WINDFALLS": "WINDFALL, unexpected good fortune [n]\n",
  "WINDFLAW": "a gust of wind [n -S]\n",
  "WINDFLAWS": "WINDFLAW, a gust of wind [n]\n",
  "WINDFLOWER": "another name for anemone [n -S]\n",
  "WINDFLOWERS": "WINDFLOWER, another name for anemone [n]\n",
  "WINDGALL": "a swelling around the fetlock joints [n -S]\n",
  "WINDGALLED": "afflicted with windgall [adj]\n",
  "WINDGALLS": "WINDGALL, a swelling around the fetlock joints [n]\n",
  "WINDGUN": "an air gun [n -S]\n",
  "WINDGUNS": "WINDGUN, an air gun [n]\n",
  "WINDHOVER": "the kestrel [n -S]\n",
  "WINDHOVERS": "WINDHOVER, the kestrel [n]\n",
  "WINDIER": "WINDY, related to wind [adj]\n",
  "WINDIEST": "WINDY, related to wind [adj]\n",
  "WINDIGO": "(Native American) a mythical monster among some North American Indian tribes, that eats human flesh, also WENDIGO [n -ES or -S]\n",
  "WINDIGOES": "WINDIGO, (Native American) a mythical monster among some North American Indian tribes, that eats human flesh, also WENDIGO [n]\n",
  "WINDIGOS": "WINDIGO, (Native American) a mythical monster among some North American Indian tribes, that eats human flesh, also WENDIGO [n]\n",
  "WINDILY": "WINDY, related to wind [adv]\n",
  "WINDINESS": "the state of being windy [n -ES]\n",
  "WINDINESSES": "WINDINESS, the state of being windy [n]\n",
  "WINDING": "changing direction, sinuous [adj WINDINGLY] / the act of winding [n -S]\n",
  "WINDINGLY": "WINDING, changing direction, sinuous [adv]\n",
  "WINDINGS": "WINDING, the act of winding [n]\n",
  "WINDJAMMER": "a large merchant sailing ship [n -S]\n",
  "WINDJAMMERS": "WINDJAMMER, a large merchant sailing ship [n]\n",
  "WINDJAMMING": "sailing by windjammer [n -S]\n",
  "WINDJAMMINGS": "WINDJAMMING, sailing by windjammer [n]\n",
  "WINDLASS": "to raise with a hoist [v -ED, -ING, -ES]\n",
  "WINDLASSED": "WINDLASS, to raise with a hoist [v]\n",
  "WINDLASSES": "WINDLASS, to raise with a hoist [v]\n",
  "WINDLASSING": "WINDLASS, to raise with a hoist [v]\n",
  "WINDLE": "to wind yarn, also WINNLE [v WINDLED, WINDLING, WINDLES]\n",
  "WINDLED": "WINDLE, to wind yarn, also WINNLE [v]\n",
  "WINDLES": "WINDLE, to wind yarn, also WINNLE [v]\n",
  "WINDLESS": "without wind [adj WINDLESSLY]\n",
  "WINDLESSLY": "WINDLESS, without wind [adv]\n",
  "WINDLESSNESS": "the state of being windless [n -ES]\n",
  "WINDLESSNESSES": "WINDLESSNESS, the state of being windless [n]\n",
  "WINDLESTRAE": "(Scots) anything light or insubstantial; a feeble person, also WINDLESTRAW [n -S]\n",
  "WINDLESTRAES": "WINDLESTRAE, (Scots) anything light or insubstantial; a feeble person, also WINDLESTRAW [n]\n",
  "WINDLESTRAW": "anything light or insubstantial; feeble person, also WINDLESTRAE [n -S]\n",
  "WINDLESTRAWS": "WINDLESTRAW, anything light or insubstantial; feeble person, also WINDLESTRAE [n]\n",
  "WINDLING": "the act of winding yarn on a windle [n -S]\n",
  "WINDLINGS": "WINDLING, the act of winding yarn on a windle [n]\n",
  "WINDLOAD": "the force on a structure arising from the impact of wind on it [n -S]\n",
  "WINDLOADS": "WINDLOAD, the force on a structure arising from the impact of wind on it [n]\n",
  "WINDMILL": "to rotate from the force of air [v -ED, -ING, -S]\n",
  "WINDMILLED": "WINDMILL, to rotate from the force of air [v]\n",
  "WINDMILLING": "WINDMILL, to rotate from the force of air [v]\n",
  "WINDMILLS": "WINDMILL, to rotate from the force of air [v]\n",
  "WINDOCK": "(Scots) a window, also WINDORE, WINNOCK [n -S]\n",
  "WINDOCKS": "WINDOCK, (Scots) a window, also WINDORE, WINNOCK [n]\n",
  "WINDORE": "(obsolete) a window, also WINDOCK, WINNOCK [n -S]\n",
  "WINDORES": "WINDORE, (obsolete) a window, also WINDOCK, WINNOCK [n]\n",
  "WINDOW": "to provide an opening for air or light [v -ED, -ING, -S]\n",
  "WINDOWED": "WINDOW, to provide an opening for air or light [v]\n",
  "WINDOWIER": "WINDOWY, like a window [adj]\n",
  "WINDOWIEST": "WINDOWY, like a window [adj]\n",
  "WINDOWING": "the act of providing with a window [n -S]\n",
  "WINDOWINGS": "WINDOWING, the act of providing with a window [n]\n",
  "WINDOWLESS": "without windows [adj]\n",
  "WINDOWPANE": "the glass in a window [n -S]\n",
  "WINDOWPANES": "WINDOWPANE, the glass in a window [n]\n",
  "WINDOWS": "WINDOW, to provide an opening for air or light [v]\n",
  "WINDOWSILL": "the horizontal member at the bottom of a window opening [n -S]\n",
  "WINDOWSILLS": "WINDOWSILL, the horizontal member at the bottom of a window opening [n]\n",
  "WINDOWY": "like a window [adj WINDOWIER, WINDOWIEST]\n",
  "WINDPACK": "snow that has been compacted by the wind [n -S]\n",
  "WINDPACKS": "WINDPACK, snow that has been compacted by the wind [n]\n",
  "WINDPIPE": "the trachea [n -S]\n",
  "WINDPIPES": "WINDPIPE, the trachea [n]\n",
  "WINDPROOF": "to make a fabric etc. proof against the wind [v -ED, -ING, -S]\n",
  "WINDPROOFED": "WINDPROOF, to make a fabric etc. proof against the wind [v]\n",
  "WINDPROOFING": "WINDPROOF, to make a fabric etc. proof against the wind [v]\n",
  "WINDPROOFS": "WINDPROOF, to make a fabric etc. proof against the wind [v]\n",
  "WINDRING": "(Shakespeare) winding [adj]\n",
  "WINDROW": "to arrange hay or grain in long rows [v -ED, -ING, -S]\n",
  "WINDROWED": "WINDROW, to arrange hay or grain in long rows [v]\n",
  "WINDROWER": "a machine that puts hay into windrows [n -S]\n",
  "WINDROWERS": "WINDROWER, a machine that puts hay into windrows [n]\n",
  "WINDROWING": "WINDROW, to arrange hay or grain in long rows [v]\n",
  "WINDROWS": "WINDROW, to arrange hay or grain in long rows [v]\n",
  "WINDS": "a small ventilating shaft between two levels of a mine, also WINZE [n -ES]\n",
  "WINDSAIL": "a wide funnel of canvas used to convey a stream of air below deck [n -S]\n",
  "WINDSAILS": "WINDSAIL, a wide funnel of canvas used to convey a stream of air below deck [n]\n",
  "WINDSCREEN": "a screen that protects against the wind [n -S]\n",
  "WINDSCREENS": "WINDSCREEN, a screen that protects against the wind [n]\n",
  "WINDSES": "WINDS, a small ventilating shaft between two levels of a mine, also WINZE [n]\n",
  "WINDSHAKE": "a flaw in wood said to be due to the bending of the tree in the wind [n -S]\n",
  "WINDSHAKES": "WINDSHAKE, a flaw in wood said to be due to the bending of the tree in the wind [n]\n",
  "WINDSHIELD": "a transparent screen (as of glass) in front of the occupants of a vehicle [n -S]\n",
  "WINDSHIELDS": "WINDSHIELD, a transparent screen (as of glass) in front of the occupants of a vehicle [n]\n",
  "WINDSHIP": "a sailing ship [n -S]\n",
  "WINDSHIPS": "WINDSHIP, a sailing ship [n]\n",
  "WINDSLAB": "a crust formed on soft snow by the wind [n -S]\n",
  "WINDSLABS": "WINDSLAB, a crust formed on soft snow by the wind [n]\n",
  "WINDSOCK": "a device on an aerodrome to show the strength of the wind [n -S]\n",
  "WINDSOCKS": "WINDSOCK, a device on an aerodrome to show the strength of the wind [n]\n",
  "WINDSTORM": "a storm of wind [n -S]\n",
  "WINDSTORMS": "WINDSTORM, a storm of wind [n]\n",
  "WINDSUCKER": "a horse that engages in wind-sucking, a harmful habit of horses in which the animal arches its neck and swallows a gulp of air [n -S]\n",
  "WINDSUCKERS": "WINDSUCKER, a horse that engages in wind-sucking, a harmful habit of horses in which the animal arches its neck and swallows a gulp of air [n]\n",
  "WINDSURF": "to sail on a sailboard [v -ED, -ING, -S]\n",
  "WINDSURFED": "WINDSURF, to sail on a sailboard [v]\n",
  "WINDSURFER": "one who practises windsurfing [n -S]\n",
  "WINDSURFERS": "WINDSURFER, one who practises windsurfing [n]\n",
  "WINDSURFING": "the sport of surfing on a sailboard [n -S]\n",
  "WINDSURFINGS": "WINDSURFING, the sport of surfing on a sailboard [n]\n",
  "WINDSURFS": "WINDSURF, to sail on a sailboard [v]\n",
  "WINDSWEPT": "swept by the wind [adj]\n",
  "WINDTHROW": "the blowing over of trees by the wind [n -S]\n",
  "WINDTHROWS": "WINDTHROW, the blowing over of trees by the wind [n]\n",
  "WINDTIGHT": "so tight as to prevent the passing through of wind [adj]\n",
  "WINDUP": "a conclusion [n -S]\n",
  "WINDUPS": "WINDUP, a conclusion [n]\n",
  "WINDWARD": "in the direction of the wind, also WINDWARDS [adv]\n",
  "WINDWARDS": "in the direction of the wind, also WINDWARD [adv]\n",
  "WINDWAY": "a passage for air [n -S]\n",
  "WINDWAYS": "WINDWAY, a passage for air [n]\n",
  "WINDY": "related to wind [adj WINDIER, WINDIEST, WINDILY]\n",
  "WINE": "to provide with fermented juice of the grape [v WINED, WINING, WINES]\n",
  "WINEBERRIES": "WINEBERRY, the red currant [n]\n",
  "WINEBERRY": "the red currant [n WINEBERRIES]\n",
  "WINEBIBBER": "a person who drinks a great deal of wine [n -S]\n",
  "WINEBIBBERS": "WINEBIBBER, a person who drinks a great deal of wine [n]\n",
  "WINEBIBBING": "drinking wine [n -S]\n",
  "WINEBIBBINGS": "WINEBIBBING, drinking wine [n]\n",
  "WINED": "WINE, to provide with fermented juice of the grape [v]\n",
  "WINEGLASS": "a glass for the drinking of wine [n -ES]\n",
  "WINEGLASSES": "WINEGLASS, a glass for the drinking of wine [n]\n",
  "WINEGLASSFUL": "the contents of a wineglass [n -S]\n",
  "WINEGLASSFULS": "WINEGLASSFUL, the contents of a wineglass [n]\n",
  "WINEGROWER": "a person who cultivates a vineyard and makes wine [n -S]\n",
  "WINEGROWERS": "WINEGROWER, a person who cultivates a vineyard and makes wine [n]\n",
  "WINEGROWING": "the growing of grapes to make wine [n -S]\n",
  "WINEGROWINGS": "WINEGROWING, the growing of grapes to make wine [n]\n",
  "WINELESS": "without wine [adj]\n",
  "WINEMAKER": "a maker of wine [n -S]\n",
  "WINEMAKERS": "WINEMAKER, a maker of wine [n]\n",
  "WINEMAKING": "the production of wine [n -S]\n",
  "WINEMAKINGS": "WINEMAKING, the production of wine [n]\n",
  "WINEPRESS": "a machine in which grapes are pressed in the manufacture of wine [n -ES]\n",
  "WINEPRESSES": "WINEPRESS, a machine in which grapes are pressed in the manufacture of wine [n]\n",
  "WINERIES": "WINERY, a place where wine is made [n]\n",
  "WINERY": "a place where wine is made [n WINERIES]\n",
  "WINES": "WINE, to provide with fermented juice of the grape [v]\n",
  "WINESAP": "a red apple with somewhat tart flesh [n -S]\n",
  "WINESAPS": "WINESAP, a red apple with somewhat tart flesh [n]\n",
  "WINESHOP": "a shop where wine is sold [n -S]\n",
  "WINESHOPS": "WINESHOP, a shop where wine is sold [n]\n",
  "WINESKIN": "a goatskin bag for holding wine [n -S]\n",
  "WINESKINS": "WINESKIN, a goatskin bag for holding wine [n]\n",
  "WINESOP": "a food sopped in wine [n -S]\n",
  "WINESOPS": "WINESOP, a food sopped in wine [n]\n",
  "WINEY": "like or tasting of wine, also WINISH, WINY [adj WINIER, WINIEST]\n",
  "WING": "to travel by means of wings [v -ED, -ING, -S]\n",
  "WINGBACK": "a backfield position in football [n -S]\n",
  "WINGBACKS": "WINGBACK, a backfield position in football [n]\n",
  "WINGBEAT": "the motion of a bird's wing [n -S]\n",
  "WINGBEATS": "WINGBEAT, the motion of a bird's wing [n]\n",
  "WINGBOW": "a mark on the wing of a domestic fowl [n -S]\n",
  "WINGBOWS": "WINGBOW, a mark on the wing of a domestic fowl [n]\n",
  "WINGCHAIR": "a chair with forward projections from the back [n -S]\n",
  "WINGCHAIRS": "WINGCHAIR, a chair with forward projections from the back [n]\n",
  "WINGDING": "a lively party, also WHINGDING [n -S]\n",
  "WINGDINGS": "WINGDING, a lively party, also WHINGDING [n]\n",
  "WINGE": "to complain fretfully, also WHEENGE, WHINGE [v WINGED, WINGEING, WINGES]\n",
  "WINGED": "WING, to travel by means of wings [v]\n",
  "WINGEDLY": "SWIFT, rapid [adv]\n",
  "WINGEING": "WINGE, to complain fretfully, also WHEENGE, WHINGE [v]\n",
  "WINGER": "a footballer who plays on the wing [n -S]\n",
  "WINGERS": "WINGER, a footballer who plays on the wing [n]\n",
  "WINGES": "WINGE, to complain fretfully, also WHEENGE, WHINGE [v]\n",
  "WINGIER": "WINGY, having or resembling wings [adj]\n",
  "WINGIEST": "WINGY, having or resembling wings [adj]\n",
  "WINGING": "WING, to travel by means of wings [v]\n",
  "WINGLESS": "without wings [adj]\n",
  "WINGLESSNESS": "the state of being wingless [n -ES]\n",
  "WINGLESSNESSES": "WINGLESSNESS, the state of being wingless [n]\n",
  "WINGLET": "a small wing [n -S]\n",
  "WINGLETS": "WINGLET, a small wing [n]\n",
  "WINGLIKE": "like a wing [adj]\n",
  "WINGMAN": "the pilot behind the leader in a flying formation [n WINGMEN]\n",
  "WINGMEN": "WINGMAN, the pilot behind the leader in a flying formation [n]\n",
  "WINGNUT": "a nut with projections for gripping with the thumb and finger [n -S]\n",
  "WINGNUTS": "WINGNUT, a nut with projections for gripping with the thumb and finger [n]\n",
  "WINGOVER": "a flight manoeuvre [n -S]\n",
  "WINGOVERS": "WINGOVER, a flight manoeuvre [n]\n",
  "WINGS": "WING, to travel by means of wings [v]\n",
  "WINGSPAN": "the distance from the tip of one of a pair of wings to that of the other [n -S]\n",
  "WINGSPANS": "WINGSPAN, the distance from the tip of one of a pair of wings to that of the other [n]\n",
  "WINGSPREAD": "the spread of the wings [n -S]\n",
  "WINGSPREADS": "WINGSPREAD, the spread of the wings [n]\n",
  "WINGSUIT": "a skydiving suit with extra material to slow descent [n -S]\n",
  "WINGSUITS": "WINGSUIT, a skydiving suit with extra material to slow descent [n]\n",
  "WINGTIP": "the end of a wing [n -S]\n",
  "WINGTIPS": "WINGTIP, the end of a wing [n]\n",
  "WINGY": "having or resembling wings [adj WINGIER, WINGIEST]\n",
  "WINIER": "WINEY, like or tasting of wine, also WINISH, WINY [adj]\n",
  "WINIEST": "WINEY, like or tasting of wine, also WINISH, WINY [adj]\n",
  "WINING": "WINE, to provide with fermented juice of the grape [v]\n",
  "WINISH": "having the qualities of wine, also WINEY, WINY [adj]\n",
  "WINK": "to open and close one eye quickly [v -ED, -ING, -S]\n",
  "WINKED": "WINK, to open and close one eye quickly [v]\n",
  "WINKER": "something that winks e.g. a direction indicator [n -S]\n",
  "WINKERS": "WINKER, something that winks e.g. a direction indicator [n]\n",
  "WINKING": "with eyes shut [adj WINKINGLY] / the act of winking [n -S]\n",
  "WINKINGLY": "WINKING, with eyes shut [adv]\n",
  "WINKINGS": "WINKING, the act of winking [n]\n",
  "WINKLE": "to extract or force out [v WINKLED, WINKLING, WINKLES]\n",
  "WINKLED": "WINKLE, to extract or force out [v]\n",
  "WINKLER": "a person who evicts tenants [n -S]\n",
  "WINKLERS": "WINKLER, a person who evicts tenants [n]\n",
  "WINKLES": "WINKLE, to extract or force out [v]\n",
  "WINKLING": "WINKLE, to extract or force out [v]\n",
  "WINKS": "WINK, to open and close one eye quickly [v]\n",
  "WINLESS": "having no wins [adj]\n",
  "WINN": "(slang) a penny [n -S]\n",
  "WINNA": "(Scots) will not [v]\n",
  "WINNABILITIES": "WINNABILITY, the quality of being winnable [n]\n",
  "WINNABILITY": "the quality of being winnable [n WINNABILITIES]\n",
  "WINNABLE": "able to be won [adj]\n",
  "WINNARD": "(dialect) a heron [n -S]\n",
  "WINNARDS": "WINNARD, (dialect) a heron [n]\n",
  "WINNED": "WIN, to gain [v]\n",
  "WINNER": "one that wins [n -S]\n",
  "WINNERS": "WINNER, one that wins [n]\n",
  "WINNING": "captivating, charming [adj WINNINGEST, WINNINGLY] / something won [n -S]\n",
  "WINNINGEST": "winning more often than others of its kind; most successful [adj]\n",
  "WINNINGLY": "WINNING, captivating, charming [adv]\n",
  "WINNINGNESS": "the quality of being winning [n -ES]\n",
  "WINNINGNESSES": "WINNINGNESS, the quality of being winning [n]\n",
  "WINNINGS": "WINNING, something won [n]\n",
  "WINNLE": "(Scots) an appliance for winding yarn, also WINDLE [n -S]\n",
  "WINNLES": "WINNLE, (Scots) an appliance for winding yarn, also WINDLE [n]\n",
  "WINNOCK": "(Scots) a window, also WINDOCK, WINDORE [n -S]\n",
  "WINNOCKS": "WINNOCK, (Scots) a window, also WINDOCK, WINDORE [n]\n",
  "WINNOW": "to separate chaff from grain [v -ED, -ING, -S]\n",
  "WINNOWED": "WINNOW, to separate chaff from grain [v]\n",
  "WINNOWER": "one who winnows [n -S]\n",
  "WINNOWERS": "WINNOWER, one who winnows [n]\n",
  "WINNOWING": "the act of winnowing [n -S]\n",
  "WINNOWINGS": "WINNOWING, the act of winnowing [n]\n",
  "WINNOWS": "WINNOW, to separate chaff from grain [v]\n",
  "WINNS": "WINN, (slang) a penny [n]\n",
  "WINO": "(slang) a down and out who drinks cheap wine [n -ES or -S]\n",
  "WINOES": "WINO, (slang) a down and out who drinks cheap wine [n]\n",
  "WINOS": "WINO, (slang) a down and out who drinks cheap wine [n]\n",
  "WINS": "WIN, to gain [v]\n",
  "WINSEY": "plain or twilled cotton, also WINCEY [n -S]\n",
  "WINSEYS": "WINSEY, plain or twilled cotton, also WINCEY [n]\n",
  "WINSOME": "charming, captivating [adj WINSOMER, WINSOMEST, WINSOMELY]\n",
  "WINSOMELY": "WINSOME, charming, captivating [adv]\n",
  "WINSOMENESS": "the state of being winsome [n -ES]\n",
  "WINSOMENESSES": "WINSOMENESS, the state of being winsome [n]\n",
  "WINSOMER": "WINSOME, charming, captivating [adj]\n",
  "WINSOMEST": "WINSOME, charming, captivating [adj]\n",
  "WINTER": "to pass the coldest season of the year [v -ED, -ING, -S]\n",
  "WINTERBERRIES": "WINTERBERRY, a name given to several shrubs of the genus Ilex, growing in the eastern parts of North America [n]\n",
  "WINTERBERRY": "a name given to several shrubs of the genus Ilex, growing in the eastern parts of North America [n WINTERBERRIES]\n",
  "WINTERBOURNE": "an intermittent spring of water [n -S]\n",
  "WINTERBOURNES": "WINTERBOURNE, an intermittent spring of water [n]\n",
  "WINTERCRESS": "a bitter-tasting yellow-flowered perennial, somewhat resembling mustard [n -ES]\n",
  "WINTERCRESSES": "WINTERCRESS, a bitter-tasting yellow-flowered perennial, somewhat resembling mustard [n]\n",
  "WINTERED": "WINTER, to pass the coldest season of the year [v]\n",
  "WINTERER": "one who spends the winter [n -S]\n",
  "WINTERERS": "WINTERER, one who spends the winter [n]\n",
  "WINTERFED": "WINTERFEED, to feed livestock in winter when the grazing is not rich enough [v]\n",
  "WINTERFEED": "to feed livestock in winter when the grazing is not rich enough [v WINTERFED, WINTERFEEDING, WINTERFEEDS]\n",
  "WINTERFEEDING": "WINTERFEED, to feed livestock in winter when the grazing is not rich enough [v]\n",
  "WINTERFEEDS": "WINTERFEED, to feed livestock in winter when the grazing is not rich enough [v]\n",
  "WINTERGREEN": "any of a genus of evergreen perennial herbs that have basal leaves and racemose flowers [n -S]\n",
  "WINTERGREENS": "WINTERGREEN, any of a genus of evergreen perennial herbs that have basal leaves and racemose flowers [n]\n",
  "WINTERIER": "WINTERY, having the characteristics of winter, also WINTRY, WINTERLY [adj]\n",
  "WINTERIEST": "WINTERY, having the characteristics of winter, also WINTRY, WINTERLY [adj]\n",
  "WINTERINESS": "the state of being wintery [n -ES]\n",
  "WINTERINESSES": "WINTERINESS, the state of being wintery [n]\n",
  "WINTERING": "WINTER, to pass the coldest season of the year [v]\n",
  "WINTERISATION": "the act of winterising, also WINTERIZATION [n -S]\n",
  "WINTERISATIONS": "WINTERISATION, the act of winterising, also WINTERIZATION [n]\n",
  "WINTERISE": "to make suitable for use under wintry conditions, also WINTERIZE [v WINTERISED, WINTERISING, WINTERISES]\n",
  "WINTERISED": "WINTERISE, to make suitable for use under wintry conditions, also WINTERIZE [v]\n",
  "WINTERISES": "WINTERISE, to make suitable for use under wintry conditions, also WINTERIZE [v]\n",
  "WINTERISH": "like winter [adj]\n",
  "WINTERISING": "WINTERISE, to make suitable for use under wintry conditions, also WINTERIZE [v]\n",
  "WINTERIZATION": "the act of winterizing, also WINTERISATION [n -S]\n",
  "WINTERIZATIONS": "WINTERIZATION, the act of winterizing, also WINTERISATION [n]\n",
  "WINTERIZE": "to make suitable for use under wintry conditions, also WINTERISE [v WINTERIZED, WINTERIZING, WINTERIZES]\n",
  "WINTERIZED": "WINTERIZE, to make suitable for use under wintry conditions, also WINTERISE [v]\n",
  "WINTERIZES": "WINTERIZE, to make suitable for use under wintry conditions, also WINTERISE [v]\n",
  "WINTERIZING": "WINTERIZE, to make suitable for use under wintry conditions, also WINTERISE [v]\n",
  "WINTERKILL": "to kill by exposure to cold [v -ED, -ING, -S]\n",
  "WINTERKILLED": "WINTERKILL, to kill by exposure to cold [v]\n",
  "WINTERKILLING": "killing by exposure to cold [n -S]\n",
  "WINTERKILLINGS": "WINTERKILLING, killing by exposure to cold [n]\n",
  "WINTERKILLS": "WINTERKILL, to kill by exposure to cold [v]\n",
  "WINTERLESS": "without a winter [adj]\n",
  "WINTERLIER": "WINTERLY, like winter, cheerless, also WINTERY, WINTRY [adj]\n",
  "WINTERLIEST": "WINTERLY, like winter, cheerless, also WINTERY, WINTRY [adj]\n",
  "WINTERLINESS": "the state of being winterly [n -ES]\n",
  "WINTERLINESSES": "WINTERLINESS, the state of being winterly [n]\n",
  "WINTERLY": "like winter, cheerless, also WINTERY, WINTRY [adj WINTERLIER, WINTERLIEST]\n",
  "WINTERS": "WINTER, to pass the coldest season of the year [v]\n",
  "WINTERTIDE": "(archaic) the time when it is winter [n -S]\n",
  "WINTERTIDES": "WINTERTIDE, (archaic) the time when it is winter [n]\n",
  "WINTERTIME": "the time during which it is winter [n -S]\n",
  "WINTERTIMES": "WINTERTIME, the time during which it is winter [n]\n",
  "WINTERWEIGHT": "of clothes, suitable in weight for wear in the winter; relatively heavy [adj]\n",
  "WINTERY": "having the characteristics of winter, also WINTRY, WINTERLY [adj WINTERIER, WINTERIEST]\n",
  "WINTLE": "(Scots) to stagger [v WINTLED, WINTLING, WINTLES]\n",
  "WINTLED": "WINTLE, (Scots) to stagger [v]\n",
  "WINTLES": "WINTLE, (Scots) to stagger [v]\n",
  "WINTLING": "WINTLE, (Scots) to stagger [v]\n",
  "WINTRIER": "WINTRY, having the characteristics of winter, also WINTERLY, WINTERY [adj]\n",
  "WINTRIEST": "WINTRY, having the characteristics of winter, also WINTERLY, WINTERY [adj]\n",
  "WINTRILY": "WINTRY, having the characteristics of winter, also WINTERLY, WINTERY [adv]\n",
  "WINTRINESS": "the state of being wintry [n -ES]\n",
  "WINTRINESSES": "WINTRINESS, the state of being wintry [n]\n",
  "WINTRY": "having the characteristics of winter, also WINTERLY, WINTERY [adj WINTRIER, WINTRIEST]\n",
  "WINY": "having the qualities of wine, also WINEY, WINISH [adj WINIER, WINIEST]\n",
  "WINZE": "a small ventilating shaft between two levels of a mine, also WINDS [n -S]\n",
  "WINZES": "WINZE, a small ventilating shaft between two levels of a mine, also WINDS [n]\n",
  "WIPE": "to rub lightly to clean or dry [v WIPED, WIPING, WIPES]\n",
  "WIPEABLE": "capable of being wiped [adj]\n",
  "WIPED": "WIPE, to rub lightly to clean or dry [v]\n",
  "WIPEOUT": "a fall from a surfboard [n -S]\n",
  "WIPEOUTS": "WIPEOUT, a fall from a surfboard [n]\n",
  "WIPER": "one that wipes [n -S]\n",
  "WIPERS": "WIPER, one that wipes [n]\n",
  "WIPES": "WIPE, to rub lightly to clean or dry [v]\n",
  "WIPING": "the act of cleaning [n -S]\n",
  "WIPINGS": "WIPING, the act of cleaning [n]\n",
  "WIPPEN": "the part of a piano hammer raised when a note is played [n -S]\n",
  "WIPPENS": "WIPPEN, the part of a piano hammer raised when a note is played [n]\n",
  "WIRABLE": "able to be wired [adj]\n",
  "WIRE": "to fasten with threads of ductile metal [v WIRED, WIRING, WIRES]\n",
  "WIRED": "WIRE, to fasten with threads of ductile metal [v]\n",
  "WIREDRAW": "to draw into wire [v WIREDREW, WIREDRAWN, WIREDRAWING, WIREDRAWS]\n",
  "WIREDRAWER": "one who draws wire [n -S]\n",
  "WIREDRAWERS": "WIREDRAWER, one who draws wire [n]\n",
  "WIREDRAWING": "drawing wire by pulling through successively smaller holes in a hard steel die-block [n -S]\n",
  "WIREDRAWINGS": "WIREDRAWING, drawing wire by pulling through successively smaller holes in a hard steel die-block [n]\n",
  "WIREDRAWN": "WIREDRAW, to draw into wire [v]\n",
  "WIREDRAWS": "WIREDRAW, to draw into wire [v]\n",
  "WIREDREW": "WIREDRAW, to draw into wire [v]\n",
  "WIREFRAME": "a basic visual guide used in interface design to suggest the structure of an interface and relationships between its pages [n -S]\n",
  "WIREFRAMES": "WIREFRAME, a basic visual guide used in interface design to suggest the structure of an interface and relationships between its pages [n]\n",
  "WIREGRASS": "a variety of fine grass [n -ES]\n",
  "WIREGRASSES": "WIREGRASS, a variety of fine grass [n]\n",
  "WIREHAIR": "a breed of terrier [n -S]\n",
  "WIREHAIRED": "having a stiff wiry outer coat of hair [adj]\n",
  "WIREHAIRS": "WIREHAIR, a breed of terrier [n]\n",
  "WIRELESS": "signalling through space without conducting wires [adj WIRELESSLY] / to communicate by radio [v -ED, -ING, -ES]\n",
  "WIRELESSED": "WIRELESS, to communicate by radio [v]\n",
  "WIRELESSES": "WIRELESS, to communicate by radio [v]\n",
  "WIRELESSING": "WIRELESS, to communicate by radio [v]\n",
  "WIRELESSLY": "WIRELESS, signalling through space without conducting wires [adv]\n",
  "WIRELIKE": "like wire [adj]\n",
  "WIRELINE": "a telegraph or telephone line [n -S]\n",
  "WIRELINES": "WIRELINE, a telegraph or telephone line [n]\n",
  "WIREMAN": "one who makes or works with wire [n WIREMEN]\n",
  "WIREMEN": "WIREMAN, one who makes or works with wire [n]\n",
  "WIREPHOTO": "a photograph sent over a wire circuit by electrical means [n -S]\n",
  "WIREPHOTOS": "WIREPHOTO, a photograph sent over a wire circuit by electrical means [n]\n",
  "WIREPULLER": "a person who uses private or secret influence for his own ends [n -S]\n",
  "WIREPULLERS": "WIREPULLER, a person who uses private or secret influence for his own ends [n]\n",
  "WIREPULLING": "the use of private or secret influence for one's own ends [n -S]\n",
  "WIREPULLINGS": "WIREPULLING, the use of private or secret influence for one's own ends [n]\n",
  "WIRER": "one who wires [n -S]\n",
  "WIRERS": "WIRER, one who wires [n]\n",
  "WIRES": "WIRE, to fasten with threads of ductile metal [v]\n",
  "WIRETAP": "to intercept messages secretly with a device [v WIRETAPPED, WIRETAPPING, WIRETAPS]\n",
  "WIRETAPPED": "WIRETAP, to intercept messages secretly with a device [v]\n",
  "WIRETAPPER": "one that taps telephone or telegraph wires [n -S]\n",
  "WIRETAPPERS": "WIRETAPPER, one that taps telephone or telegraph wires [n]\n",
  "WIRETAPPING": "the act of tapping a phone wire so as to listen in to conversations [n -S]\n",
  "WIRETAPPINGS": "WIRETAPPING, the act of tapping a phone wire so as to listen in to conversations [n]\n",
  "WIRETAPS": "WIRETAP, to intercept messages secretly with a device [v]\n",
  "WIREWALKER": "a tightrope walker [n -S]\n",
  "WIREWALKERS": "WIREWALKER, a tightrope walker [n]\n",
  "WIREWAY": "a tube for protecting electric wire [n -S]\n",
  "WIREWAYS": "WIREWAY, a tube for protecting electric wire [n]\n",
  "WIREWORK": "an article made from wire [n -S]\n",
  "WIREWORKER": "one who works with wire [n -S]\n",
  "WIREWORKERS": "WIREWORKER, one who works with wire [n]\n",
  "WIREWORKING": "working in wire [n -S]\n",
  "WIREWORKINGS": "WIREWORKING, working in wire [n]\n",
  "WIREWORKS": "WIREWORK, an article made from wire [n]\n",
  "WIREWORM": "a hard-bodied wormlike larva of the click beetle, destructive to plant roots [n -S]\n",
  "WIREWORMS": "WIREWORM, a hard-bodied wormlike larva of the click beetle, destructive to plant roots [n]\n",
  "WIREWOVE": "designating a very fine quality of writing paper [adj]\n",
  "WIRIER": "WIRY, thin and tough [adj]\n",
  "WIRIEST": "WIRY, thin and tough [adj]\n",
  "WIRILDA": "(Native Australian) an Australian acacia tree [n -S]\n",
  "WIRILDAS": "WIRILDA, (Native Australian) an Australian acacia tree [n]\n",
  "WIRILY": "WIRY, thin and tough [adv]\n",
  "WIRINESS": "the quality of being wiry [n -ES]\n",
  "WIRINESSES": "WIRINESS, the quality of being wiry [n]\n",
  "WIRING": "a system of electric wires [n -S]\n",
  "WIRINGS": "WIRING, a system of electric wires [n]\n",
  "WIRRA": "an interjection expressing sorrow, also WHIRRA [interj]\n",
  "WIRRAH": "(Native Australian) a saltwater fish with bright blue spots [n -S]\n",
  "WIRRAHS": "WIRRAH, (Native Australian) a saltwater fish with bright blue spots [n]\n",
  "WIRRICOW": "(Scots) the devil, a hobgoblin, anything frightening, also WORRICOW, WORRYCOW [n -S]\n",
  "WIRRICOWS": "WIRRICOW, (Scots) the devil, a hobgoblin, anything frightening, also WORRICOW, WORRYCOW [n]\n",
  "WIRY": "thin and tough [adj WIRIER, WIRIEST, WIRILY]\n",
  "WIS": "a sham archaic word for to know, also WIST, WIT, WOT [v]\n",
  "WISARD": "a wizard [n -S]\n",
  "WISARDS": "WISARD, a wizard [n]\n",
  "WISDOM": "the quality of being wise [n -S]\n",
  "WISDOMS": "WISDOM, the quality of being wise [n]\n",
  "WISE": "intelligent [adj WISER, WISEST, WISELY] / (Scots) to guide in a certain direction [v WISED, WISING, WISES]\n",
  "WISEACRE": "a pretentiously wise person, also WISEASS [n -S]\n",
  "WISEACRES": "WISEACRE, a pretentiously wise person, also WISEASS [n]\n",
  "WISEASS": "a pretentiously wise person, also WISEACRE [n -ES]\n",
  "WISEASSES": "WISEASS, a pretentiously wise person, also WISEACRE [n]\n",
  "WISECRACK": "a pungent comment [n -S] / to make a wisecrack [v -ED, -ING, -S]\n",
  "WISECRACKED": "WISECRACK, to make a wisecrack [v]\n",
  "WISECRACKER": "one who wisecracks [n -S]\n",
  "WISECRACKERS": "WISECRACKER, one who wisecracks [n]\n",
  "WISECRACKING": "WISECRACK, to make a wisecrack [v]\n",
  "WISECRACKS": "WISECRACK, to make a wisecrack [v]\n",
  "WISED": "WISE, (Scots) to guide in a certain direction [v]\n",
  "WISEGUY": "a person who wants to seem clever [n -S]\n",
  "WISEGUYS": "WISEGUY, a person who wants to seem clever [n]\n",
  "WISELIER": "WISELY, in a wise manner [adv]\n",
  "WISELIEST": "WISELY, in a wise manner [adv]\n",
  "WISELING": "someone who pretends to be wise [n -S]\n",
  "WISELINGS": "WISELING, someone who pretends to be wise [n]\n",
  "WISELY": "in a wise manner [adv WISELIER, WISELIEST]\n",
  "WISENESS": "wisdom [n -ES]\n",
  "WISENESSES": "WISENESS, wisdom [n]\n",
  "WISENHEIMER": "a smart aleck, also WEISENHEIMER [n -S]\n",
  "WISENHEIMERS": "WISENHEIMER, a smart aleck, also WEISENHEIMER [n]\n",
  "WISENT": "(German) a European bison [n -S]\n",
  "WISENTS": "WISENT, (German) a European bison [n]\n",
  "WISER": "WISE, intelligent [adj]\n",
  "WISES": "WISE, (Scots) to guide in a certain direction [v]\n",
  "WISEST": "WISE, intelligent [adj]\n",
  "WISEWOMAN": "a witch or seeress [n WISEWOMEN]\n",
  "WISEWOMEN": "WISEWOMAN, a witch or seeress [n]\n",
  "WISH": "to desire, also WISS [v -ED, -ING, -ES]\n",
  "WISHA": "(Irish) an interjection expressing surprise [interj]\n",
  "WISHBONE": "the V-shaped bone formed by the fused clavicles of a bird's breast [n -S]\n",
  "WISHBONES": "WISHBONE, the V-shaped bone formed by the fused clavicles of a bird's breast [n]\n",
  "WISHED": "WISH, to desire, also WISS [v]\n",
  "WISHER": "one who wishes [n -S]\n",
  "WISHERS": "WISHER, one who wishes [n]\n",
  "WISHES": "WISH, to desire, also WISS [v]\n",
  "WISHFUL": "desirous [adj WISHFULLY]\n",
  "WISHFULLY": "WISHFUL, desirous [adv]\n",
  "WISHFULNESS": "the state of being wishful [n -ES]\n",
  "WISHFULNESSES": "WISHFULNESS, the state of being wishful [n]\n",
  "WISHING": "the act of wishing [n -S]\n",
  "WISHINGS": "WISHING, the act of wishing [n]\n",
  "WISHLESS": "not wishful [adj]\n",
  "WISHT": "(Scots) an interjection meaning keep silent, also WHEESH, WHEESHT, WHISHT [interj]\n",
  "WISHTONWISH": "(Native American) the whippoorwill [n -ES]\n",
  "WISHTONWISHES": "WISHTONWISH, (Native American) the whippoorwill [n]\n",
  "WISING": "WISE, (Scots) to guide in a certain direction [v]\n",
  "WISKET": "a basket; esp. a straw provender basket, also WHISKET [n -S]\n",
  "WISKETS": "WISKET, a basket; esp. a straw provender basket, also WHISKET [n]\n",
  "WISP": "to twist into a small bundle [v -ED, -ING, -S]\n",
  "WISPED": "WISP, to twist into a small bundle [v]\n",
  "WISPIER": "WISPY, like a wisp, also WISPISH, WISPLIKE [adj]\n",
  "WISPIEST": "WISPY, like a wisp, also WISPISH, WISPLIKE [adj]\n",
  "WISPILY": "WISPY, like a wisp, also WISPISH, WISPLIKE [adv]\n",
  "WISPINESS": "the state of being wispy [n -ES]\n",
  "WISPINESSES": "WISPINESS, the state of being wispy [n]\n",
  "WISPING": "WISP, to twist into a small bundle [v]\n",
  "WISPISH": "resembling a small bundle, also WISPY, WISPLIKE [adj]\n",
  "WISPLIKE": "resembling a small bundle, also WISPY, WISPISH [adj]\n",
  "WISPS": "WISP, to twist into a small bundle [v]\n",
  "WISPY": "like a wisp, also WISPISH, WISPLIKE [adj WISPIER, WISPIEST, WISPILY]\n",
  "WISS": "to wish [v WISSED, WISSING, WISSES]\n",
  "WISSED": "WISS, to wish [v]\n",
  "WISSES": "WISS, to wish [v]\n",
  "WISSING": "WISS, to wish [v]\n",
  "WIST": "(archaic) to know, also WIS, WIT, WOT [v -ED, -ING, -S]\n",
  "WISTARIA": "an ornamental climbing plant, also WISTERIA [n -S]\n",
  "WISTARIAS": "WISTARIA, an ornamental climbing plant, also WISTERIA [n]\n",
  "WISTED": "WIST, (archaic) to know, also WIS, WIT, WOT [v]\n",
  "WISTERIA": "an ornamental climbing plant, also WISTARIA [n -S]\n",
  "WISTERIAS": "WISTERIA, an ornamental climbing plant, also WISTARIA [n]\n",
  "WISTFUL": "yearning [adj WISTFULLY]\n",
  "WISTFULLY": "WISTFUL, yearning [adv]\n",
  "WISTFULNESS": "the state of being wistful [n -ES]\n",
  "WISTFULNESSES": "WISTFULNESS, the state of being wistful [n]\n",
  "WISTING": "WIST, (archaic) to know, also WIS, WIT, WOT [v]\n",
  "WISTITI": "(French) a marmoset, also OUISTITI [n -S]\n",
  "WISTITIS": "WISTITI, (French) a marmoset, also OUISTITI [n]\n",
  "WISTLY": "(Shakespeare) longingly [adv]\n",
  "WISTS": "WIST, (archaic) to know, also WIS, WIT, WOT [v]\n",
  "WIT": "to know [v WIST, WITTING, WITS. present sing 1st person WOT, 2nd WOST or WOTTEST, 3rd WOT or WOTTETH]\n",
  "WITAN": "(Old English) a member of the Anglo-Saxon council, the witenagemot [n -S]\n",
  "WITANS": "WITAN, (Old English) a member of the Anglo-Saxon council, the witenagemot [n]\n",
  "WITBLITS": "(South African) a strong home-distilled alcoholic spirit [n -ES]\n",
  "WITBLITSES": "WITBLITS, (South African) a strong home-distilled alcoholic spirit [n]\n",
  "WITCH": "to bewitch [v -ED, -ING, -ES]\n",
  "WITCHBROOM": "a dense abnormal growth of shoots on a tree or other woody plant, usually caused by parasitic fungi of the genus Taphrina [n -S]\n",
  "WITCHBROOMS": "WITCHBROOM, a dense abnormal growth of shoots on a tree or other woody plant, usually caused by parasitic fungi of the genus Taphrina [n]\n",
  "WITCHCRAFT": "the use of sorcery or magic [n -S]\n",
  "WITCHCRAFTS": "WITCHCRAFT, the use of sorcery or magic [n]\n",
  "WITCHED": "WITCH, to bewitch [v]\n",
  "WITCHEN": "the mountain ash or wych elm, also WICKEN, WICKY [n -S]\n",
  "WITCHENS": "WITCHEN, the mountain ash or wych elm, also WICKEN, WICKY [n]\n",
  "WITCHERIES": "WITCHERY, enchantment; witchcraft [n]\n",
  "WITCHERY": "enchantment; witchcraft [n WITCHERIES]\n",
  "WITCHES": "WITCH, to bewitch [v]\n",
  "WITCHETTIES": "WITCHETTY, (Native Australian) any of the edible grubs of certain moths and longhorn beetles [n]\n",
  "WITCHETTY": "(Native Australian) any of the edible grubs of certain moths and longhorn beetles [n WITCHETTIES]\n",
  "WITCHGRASS": "a North American grass common on cultivated land [n -ES]\n",
  "WITCHGRASSES": "WITCHGRASS, a North American grass common on cultivated land [n]\n",
  "WITCHHOOD": "the state of being a witch [n -S]\n",
  "WITCHHOODS": "WITCHHOOD, the state of being a witch [n]\n",
  "WITCHIER": "WITCHY, malicious [adj]\n",
  "WITCHIEST": "WITCHY, malicious [adj]\n",
  "WITCHING": "suited to witchcraft; weird; fascinating [adj WITCHINGLY] / the act of witching [n -S]\n",
  "WITCHINGLY": "WITCHING, suited to witchcraft; weird; fascinating [adv]\n",
  "WITCHINGS": "WITCHING, the act of witching [n]\n",
  "WITCHKNOT": "a knot in hair supposedly tied by witches [n -S]\n",
  "WITCHKNOTS": "WITCHKNOT, a knot in hair supposedly tied by witches [n]\n",
  "WITCHLIKE": "like a witch [adj]\n",
  "WITCHWEED": "a yellow-flowered plant of the snapdragon family [n -S]\n",
  "WITCHWEEDS": "WITCHWEED, a yellow-flowered plant of the snapdragon family [n]\n",
  "WITCHY": "malicious [adj WITCHIER, WITCHIEST]\n",
  "WITE": "(Scots) to blame, lay the blame on, also WIGHT, WYTE [v WITED, WITING, WITES]\n",
  "WITED": "WITE, (Scots) to blame, lay the blame on, also WIGHT, WYTE [v]\n",
  "WITELESS": "without fault; blameless [adj]\n",
  "WITENAGEMOT": "(Old English) an early English national council, also WITENAGEMOTE [n -S]\n",
  "WITENAGEMOTE": "(Old English) an early English national council, also WITENAGEMOT [n -S]\n",
  "WITENAGEMOTES": "WITENAGEMOTE, (Old English) an early English national council, also WITENAGEMOT [n]\n",
  "WITENAGEMOTS": "WITENAGEMOT, (Old English) an early English national council, also WITENAGEMOTE [n]\n",
  "WITES": "WITE, (Scots) to blame, lay the blame on, also WIGHT, WYTE [v]\n",
  "WITGAT": "(South African) a South African evergreen tree with edible roots used as a coffee substitute when roasted, also WITGATBOOM [n -S]\n",
  "WITGATBOOM": "(South African) a South African evergreen tree with edible roots used as a coffee substitute when roasted, also WITGAT [n -S]\n",
  "WITGATBOOMS": "WITGATBOOM, (South African) a South African evergreen tree with edible roots used as a coffee substitute when roasted, also WITGAT [n]\n",
  "WITGATS": "WITGAT, (South African) a South African evergreen tree with edible roots used as a coffee substitute when roasted, also WITGATBOOM [n]\n",
  "WITH": "a partition between chimney flues [n -S]\n",
  "WITHAL": "in addition [adv]\n",
  "WITHDRAW": "to move away [v WITHDREW, WITHDRAWN, WITHDRAWING, WITHDRAWS]\n",
  "WITHDRAWABLE": "capable of being withdrawn [adj]\n",
  "WITHDRAWAL": "the act of withdrawing [n -S]\n",
  "WITHDRAWALS": "WITHDRAWAL, the act of withdrawing [n]\n",
  "WITHDRAWER": "one who withdraws [n -S]\n",
  "WITHDRAWERS": "WITHDRAWER, one who withdraws [n]\n",
  "WITHDRAWING": "WITHDRAW, to move away [v]\n",
  "WITHDRAWMENT": "the act of withdrawing [n -S]\n",
  "WITHDRAWMENTS": "WITHDRAWMENT, the act of withdrawing [n]\n",
  "WITHDRAWN": "WITHDRAW, to move away [v]\n",
  "WITHDRAWNNESS": "the state of being withdrawn [n -ES]\n",
  "WITHDRAWNNESSES": "WITHDRAWNNESS, the state of being withdrawn [n]\n",
  "WITHDRAWS": "WITHDRAW, to move away [v]\n",
  "WITHDREW": "WITHDRAW, to move away [v]\n",
  "WITHE": "to bind with flexible twigs [v WITHED, WITHING, WITHES]\n",
  "WITHED": "WITHE, to bind with flexible twigs [v]\n",
  "WITHER": "to dry up and wilt [v -ED, -ING, -S]\n",
  "WITHERED": "WITHER, to dry up and wilt [v]\n",
  "WITHEREDNESS": "the state of being withered [n -ES]\n",
  "WITHEREDNESSES": "WITHEREDNESS, the state of being withered [n]\n",
  "WITHERER": "one that withers [n -S]\n",
  "WITHERERS": "WITHERER, one that withers [n]\n",
  "WITHERING": "of criticism, severe [adj WITHERINGLY] / the act of withering [n -S]\n",
  "WITHERINGLY": "WITHERING, of criticism, severe [adv]\n",
  "WITHERINGS": "WITHERING, the act of withering [n]\n",
  "WITHERITE": "barium carbonate occurring in white or gray six-sided twin crystals, and also in columnar or granular masses [n -S]\n",
  "WITHERITES": "WITHERITE, barium carbonate occurring in white or gray six-sided twin crystals, and also in columnar or granular masses [n]\n",
  "WITHEROD": "a North American shrub [n -S]\n",
  "WITHERODS": "WITHEROD, a North American shrub [n]\n",
  "WITHERS": "WITHER, to dry up and wilt [v]\n",
  "WITHERSHINS": "in a left-handed, wrong, or contrary direction; counterclockwise, also WIDDERSHINS, WIDERSHINS [adv]\n",
  "WITHES": "WITHE, to bind with flexible twigs [v]\n",
  "WITHHAULT": "WITHHOLD, to hold back [v]\n",
  "WITHHELD": "WITHHOLD, to hold back [v]\n",
  "WITHHOLD": "to hold back [v WITHHELD or (pseudo-archaic) WITHHAULT, WITHHOLDEN, WITHHOLDING, WITHHOLDS]\n",
  "WITHHOLDEN": "WITHHOLD, to hold back [v]\n",
  "WITHHOLDER": "one who withholds [n -S]\n",
  "WITHHOLDERS": "WITHHOLDER, one who withholds [n]\n",
  "WITHHOLDING": "WITHHOLD, to hold back [v]\n",
  "WITHHOLDMENT": "the act of withholding [n -S]\n",
  "WITHHOLDMENTS": "WITHHOLDMENT, the act of withholding [n]\n",
  "WITHHOLDS": "WITHHOLD, to hold back [v]\n",
  "WITHIER": "WITHY, flexible and tough [adj]\n",
  "WITHIES": "WITHY, a flexible twig [n]\n",
  "WITHIEST": "WITHY, flexible and tough [adj]\n",
  "WITHIN": "an interior place or area [n -S]\n",
  "WITHINDOORS": "indoors [adv]\n",
  "WITHING": "WITHE, to bind with flexible twigs [v]\n",
  "WITHINS": "WITHIN, an interior place or area [n]\n",
  "WITHOUT": "an exterior place [n -S]\n",
  "WITHOUTDOORS": "outdoors [adv]\n",
  "WITHOUTEN": "(archaic) without [prep]\n",
  "WITHOUTS": "WITHOUT, an exterior place [n]\n",
  "WITHS": "WITH, a partition between chimney flues [n]\n",
  "WITHSTAND": "to resist [v WITHSTOOD, WITHSTANDING, WITHSTANDS]\n",
  "WITHSTANDER": "one who withstands [n -S]\n",
  "WITHSTANDERS": "WITHSTANDER, one who withstands [n]\n",
  "WITHSTANDING": "WITHSTAND, to resist [v]\n",
  "WITHSTANDS": "WITHSTAND, to resist [v]\n",
  "WITHSTOOD": "WITHSTAND, to resist [v]\n",
  "WITHWIND": "(dialect) bindweed or other climbing plant, also WITHYWIND [n -S]\n",
  "WITHWINDS": "WITHWIND, (dialect) bindweed or other climbing plant, also WITHYWIND [n]\n",
  "WITHY": "a flexible twig [n WITHIES] / flexible and tough [adj WITHIER, WITHIEST]\n",
  "WITHYWIND": "(dialect) bindweed or other climbing plant, also WITHWIND [n -S]\n",
  "WITHYWINDS": "WITHYWIND, (dialect) bindweed or other climbing plant, also WITHWIND [n]\n",
  "WITING": "WITE, (Scots) to blame, lay the blame on, also WIGHT, WYTE [v]\n",
  "WITLESS": "lacking intelligence [adj WITLESSLY]\n",
  "WITLESSLY": "WITLESS, lacking intelligence [adv]\n",
  "WITLESSNESS": "the state of being witless [n -ES]\n",
  "WITLESSNESSES": "WITLESSNESS, the state of being witless [n]\n",
  "WITLING": "one who considers himself witty [n -S]\n",
  "WITLINGS": "WITLING, one who considers himself witty [n]\n",
  "WITLOOF": "(Dutch) a kind of chicory with white leaves [n -S]\n",
  "WITLOOFS": "WITLOOF, (Dutch) a kind of chicory with white leaves [n]\n",
  "WITNESS": "to have direct knowledge of [v -ED, -ING, -ES]\n",
  "WITNESSABLE": "that can be witnessed [adj]\n",
  "WITNESSED": "WITNESS, to have direct knowledge of [v]\n",
  "WITNESSER": "one who witnesses [n -S]\n",
  "WITNESSERS": "WITNESSER, one who witnesses [n]\n",
  "WITNESSES": "WITNESS, to have direct knowledge of [v]\n",
  "WITNESSING": "WITNESS, to have direct knowledge of [v]\n",
  "WITNEY": "a heavy woollen fabric [n -S]\n",
  "WITNEYS": "WITNEY, a heavy woollen fabric [n]\n",
  "WITS": "WIT, to know [v]\n",
  "WITTED": "having intelligence [adj]\n",
  "WITTER": "to mutter peevishly [v -ED, -ING, -S]\n",
  "WITTERED": "WITTER, to mutter peevishly [v]\n",
  "WITTERING": "WITTER, to mutter peevishly [v]\n",
  "WITTERS": "WITTER, to mutter peevishly [v]\n",
  "WITTICISM": "a witty remark [n -S]\n",
  "WITTICISMS": "WITTICISM, a witty remark [n]\n",
  "WITTIER": "WITTY, possessed of wit, clever [adj]\n",
  "WITTIEST": "WITTY, possessed of wit, clever [adj]\n",
  "WITTILY": "WITTY, possessed of wit, clever [adv]\n",
  "WITTINESS": "the quality of being witty [n -ES]\n",
  "WITTINESSES": "WITTINESS, the quality of being witty [n]\n",
  "WITTING": "cognisant, conscious [adj WITTINGLY] / knowledge, information [n -S]\n",
  "WITTINGLY": "WITTING, cognisant, conscious [adv]\n",
  "WITTINGS": "WITTING, knowledge, information [n]\n",
  "WITTOL": "(archaic) a husband who accepts his wife's infidelity [n -S]\n",
  "WITTOLLY": "(Shakespeare) like a wittol, a husband who accepts his wife's infidelity [adj]\n",
  "WITTOLS": "WITTOL, (archaic) a husband who accepts his wife's infidelity [n]\n",
  "WITTY": "possessed of wit, clever [adj WITTIER, WITTIEST, WITTILY]\n",
  "WITWALL": "the green woodpecker or the greater spotted woodpecker [n -S]\n",
  "WITWALLS": "WITWALL, the green woodpecker or the greater spotted woodpecker [n]\n",
  "WITWANTON": "to engage in irreverent wit [v -ED, -ING, -S]\n",
  "WITWANTONED": "WITWANTON, to engage in irreverent wit [v]\n",
  "WITWANTONING": "WITWANTON, to engage in irreverent wit [v]\n",
  "WITWANTONS": "WITWANTON, to engage in irreverent wit [v]\n",
  "WIVE": "(archaic) to take for a wife; to become the wife of [v WIVED, WIVING, WIVES]\n",
  "WIVED": "WIVE, (archaic) to take for a wife; to become the wife of [v]\n",
  "WIVEHOOD": "(Spenser) wifehood, also WIFEDOM, WIFEHOOD [n -S]\n",
  "WIVEHOODS": "WIVEHOOD, (Spenser) wifehood, also WIFEDOM, WIFEHOOD [n]\n",
  "WIVER": "in heraldry, a dragon with wings, the tail of a snake and two legs, also WIVERN, WYVERN [n -S]\n",
  "WIVERN": "in heraldry, a dragon with wings, the tail of a snake and two legs, also WIVER, WYVERN [n -S]\n",
  "WIVERNS": "WIVERN, in heraldry, a dragon with wings, the tail of a snake and two legs, also WIVER, WYVERN [n]\n",
  "WIVERS": "WIVER, in heraldry, a dragon with wings, the tail of a snake and two legs, also WIVERN, WYVERN [n]\n",
  "WIVES": "WIVE, (archaic) to take for a wife; to become the wife of [v]\n",
  "WIVING": "WIVE, (archaic) to take for a wife; to become the wife of [v]\n",
  "WIZ": "a very skilled person [n WIZES or WIZZES]\n",
  "WIZARD": "very good [adj WIZARDER, WIZARDEST] / a man who practises witchcraft or magic, also WISARD [n -S]\n",
  "WIZARDER": "WIZARD, very good [adj]\n",
  "WIZARDEST": "WIZARD, very good [adj]\n",
  "WIZARDLIER": "WIZARDLY, like a wizard, a man who practises witchcraft or magic [adj]\n",
  "WIZARDLIEST": "WIZARDLY, like a wizard, a man who practises witchcraft or magic [adj]\n",
  "WIZARDLY": "like a wizard, a man who practises witchcraft or magic [adj WIZARDLIER, WIZARDLIEST]\n",
  "WIZARDRIES": "WIZARDRY, sorcery, magic [n]\n",
  "WIZARDRY": "sorcery, magic [n WIZARDRIES]\n",
  "WIZARDS": "WIZARD, a man who practises witchcraft or magic, also WISARD [n]\n",
  "WIZEN": "shrivelled [adj WIZENER, WIZENEST] / to shrivel, also WEAZEN [v -ED, -ING, -S]\n",
  "WIZENED": "WIZEN, to shrivel, also WEAZEN [v]\n",
  "WIZENER": "WIZEN, shrivelled [adj]\n",
  "WIZENEST": "WIZEN, shrivelled [adj]\n",
  "WIZENING": "WIZEN, to shrivel, also WEAZEN [v]\n",
  "WIZENS": "WIZEN, to shrivel, also WEAZEN [v]\n",
  "WIZES": "WIZ, a very skilled person [n]\n",
  "WIZIER": "(Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIER, VIZIR, WAZIR [n -S]\n",
  "WIZIERS": "WIZIER, (Arabic) a minister in various Muslim states, also PHEAZAR, VEZIR, VISIER, VIZIER, VIZIR, WAZIR [n]\n",
  "WIZZEN": "(Old English) the windpipe, also WEASAND, WEASON, WEAZAND, WESAND, WESSAND, WEZAND [n -S]\n",
  "WIZZENS": "WIZZEN, (Old English) the windpipe, also WEASAND, WEASON, WEAZAND, WESAND, WESSAND, WEZAND [n]\n",
  "WIZZES": "WIZ, a very skilled person [n]\n",
  "WO": "(archaic) woe, also WAE [n -S]\n",
  "WOAD": "a broad-leafed plant yielding a blue dye [n -S]\n",
  "WOADED": "dyed blue with woad [adj]\n",
  "WOADS": "WOAD, a broad-leafed plant yielding a blue dye [n]\n",
  "WOADWAX": "dyer's greenweed, also WOADWAXEN, WOODWAX, WOODWAXEN [n -ES]\n",
  "WOADWAXEN": "dyer's greenweed, also WOADWAX, WOODWAX, WOODWAXEN [n -S]\n",
  "WOADWAXENS": "WOADWAXEN, dyer's greenweed, also WOADWAX, WOODWAX, WOODWAXEN [n]\n",
  "WOADWAXES": "WOADWAX, dyer's greenweed, also WOADWAXEN, WOODWAX, WOODWAXEN [n]\n",
  "WOAH": "a call to stop, esp. to a horse, also WHOA [interj]\n",
  "WOALD": "yellow pigment [n -S]\n",
  "WOALDS": "WOALD, yellow pigment [n]\n",
  "WOBBEGONG": "(Native Australian) a carpet shark [n -S]\n",
  "WOBBEGONGS": "WOBBEGONG, (Native Australian) a carpet shark [n]\n",
  "WOBBLE": "to move unsteadily, also WABBLE, WIBBLE [v WOBBLED, WOBBLING, WOBBLES]\n",
  "WOBBLED": "WOBBLE, to move unsteadily, also WABBLE, WIBBLE [v]\n",
  "WOBBLER": "one who wobbles, also WABBLER [n -S]\n",
  "WOBBLERS": "WOBBLER, one who wobbles, also WABBLER [n]\n",
  "WOBBLES": "WOBBLE, to move unsteadily, also WABBLE, WIBBLE [v]\n",
  "WOBBLIER": "WOBBLY, unsteady, also WABBLY [adj]\n",
  "WOBBLIES": "WOBBLY, a fit of nerves or anger [n]\n",
  "WOBBLIEST": "WOBBLY, unsteady, also WABBLY [adj]\n",
  "WOBBLINESS": "the state of being wobbly [n -ES]\n",
  "WOBBLINESSES": "WOBBLINESS, the state of being wobbly [n]\n",
  "WOBBLING": "the act of wobbling [n -S]\n",
  "WOBBLINGS": "WOBBLING, the act of wobbling [n]\n",
  "WOBBLY": "unsteady, also WABBLY [adj WOBBLIER, WOBBLIEST] / a fit of nerves or anger [n WOBBLIES]\n",
  "WOBEGONE": "sad, dejected, also WOEBEGONE [adj]\n",
  "WOCK": "(Chinese) a pan used in Chinese cookery, also WOK [n -S]\n",
  "WOCKS": "WOCK, (Chinese) a pan used in Chinese cookery, also WOK [n]\n",
  "WODGE": "a large or roughly-cut portion, also WADGE [n -S]\n",
  "WODGES": "WODGE, a large or roughly-cut portion, also WADGE [n]\n",
  "WOE": "grief, sadness, also WAE, WO [n -S]\n",
  "WOEBEGONE": "sad, dejected, also WOBEGONE [adj]\n",
  "WOEBEGONENESS": "the state of being woebegone [n -ES]\n",
  "WOEBEGONENESSES": "WOEBEGONENESS, the state of being woebegone [n]\n",
  "WOEFUL": "full of woe, also WAEFUL, WAESOME, WOESOME, WOFUL [adj WOEFULLER, WOEFULLEST, WOEFULLY]\n",
  "WOEFULLER": "WOEFUL, full of woe, also WAEFUL, WAESOME, WOESOME, WOFUL [adj]\n",
  "WOEFULLEST": "WOEFUL, full of woe, also WAEFUL, WAESOME, WOESOME, WOFUL [adj]\n",
  "WOEFULLY": "WOEFUL, full of woe, also WAEFUL, WAESOME, WOESOME, WOFUL [adv]\n",
  "WOEFULNESS": "the state of being woeful, also WOFULNESS [n -ES]\n",
  "WOEFULNESSES": "WOEFULNESS, the state of being woeful, also WOFULNESS [n]\n",
  "WOENESS": "sadness, also WAENESS [n -ES]\n",
  "WOENESSES": "WOENESS, sadness, also WAENESS [n]\n",
  "WOES": "WOE, grief, sadness, also WAE, WO [n]\n",
  "WOESOME": "woeful, also WAEFUL, WAESOME, WOEFUL, WOFUL [adj]\n",
  "WOF": "(Australian slang) a fool, idiot [n -S]\n",
  "WOFS": "WOF, (Australian slang) a fool, idiot [n]\n",
  "WOFUL": "full of grief, also WAEFUL, WAESOME, WOESOME [adj WOFULLER, WOFULLEST, WOFULLY]\n",
  "WOFULLER": "WOFUL, full of grief, also WAEFUL, WAESOME, WOESOME [adj]\n",
  "WOFULLEST": "WOFUL, full of grief, also WAEFUL, WAESOME, WOESOME [adj]\n",
  "WOFULLY": "WOFUL, full of grief, also WAEFUL, WAESOME, WOESOME [adj]\n",
  "WOFULNESS": "the state of being woeful, also WOEFULNESS [n -ES]\n",
  "WOFULNESSES": "WOFULNESS, the state of being woeful, also WOEFULNESS [n]\n",
  "WOG": "(offensive) a nonwhite foreigner [n -S]\n",
  "WOGGISH": "like a wog, offensive word for nonwhite foreigner [adj]\n",
  "WOGGLE": "a scout or guide neckerchief ring [n -S]\n",
  "WOGGLES": "WOGGLE, a scout or guide neckerchief ring [n]\n",
  "WOGS": "WOG, (offensive) a nonwhite foreigner [n]\n",
  "WOIWODE": "(Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIVODE, WAIWODE, WAYWODE [n -S]\n",
  "WOIWODES": "WOIWODE, (Russian) originally the title of a military commander in various Slavonic countries; afterwards applied to governors of towns or provinces, also VAIVODE, VOIVODE, WAIVODE, WAIWODE, WAYWODE [n]\n",
  "WOJUS": "(Irish slang) of a poor quality or low standard [adj]\n",
  "WOK": "(Chinese) a pan used in Chinese cookery, also WOCK [n -S]\n",
  "WOKE": "alert to social and political injustice (esp in the phrase stay woke) [adj WOKER, WOKEST]\n",
  "WOKEN": "WAKE, to rouse from sleep [v]\n",
  "WOKER": "WOKE, alert to social and political injustice (esp in the phrase stay woke) [adj]\n",
  "WOKEST": "WOKE, alert to social and political injustice (esp in the phrase stay woke) [adj]\n",
  "WOKKA": "(Australian) as in wokka board, a piece of fibreboard used as a musical instrument [adj]\n",
  "WOKS": "WOK, (Chinese) a pan used in Chinese cookery, also WOCK [n]\n",
  "WOLD": "an elevated tract of open land [n -S]\n",
  "WOLDS": "WOLD, an elevated tract of open land [n]\n",
  "WOLF": "to devour ravenously [v -ED, -ING, -S] / a carnivorous mammal [n WOLVES]\n",
  "WOLFBERRIES": "WOLFBERRY, an American shrub which bears soft white berries [n]\n",
  "WOLFBERRY": "an American shrub which bears soft white berries [n WOLFBERRIES]\n",
  "WOLFED": "WOLF, to devour ravenously [v]\n",
  "WOLFER": "a hunter of wolves, also WOLVER [n -S]\n",
  "WOLFERS": "WOLFER, a hunter of wolves, also WOLVER [n]\n",
  "WOLFFISH": "a marine fish [n -ES]\n",
  "WOLFFISHES": "WOLFFISH, a marine fish [n]\n",
  "WOLFHOUND": "any of several breeds of a large domestic dog [n -S]\n",
  "WOLFHOUNDS": "WOLFHOUND, any of several breeds of a large domestic dog [n]\n",
  "WOLFING": "the hunting of wolves, also WOLVING [n -S]\n",
  "WOLFINGS": "WOLFING, the hunting of wolves, also WOLVING [n]\n",
  "WOLFISH": "like a wolf, also WOLVISH [adj WOLFISHLY]\n",
  "WOLFISHLY": "WOLFISH, like a wolf, also WOLVISH [adv]\n",
  "WOLFISHNESS": "the state of being wolfish [n -ES]\n",
  "WOLFISHNESSES": "WOLFISHNESS, the state of being wolfish [n]\n",
  "WOLFKIN": "a young wolf [n -S]\n",
  "WOLFKINS": "WOLFKIN, a young wolf [n]\n",
  "WOLFLIKE": "like a wolf [adj]\n",
  "WOLFLING": "a young wolf [n -S]\n",
  "WOLFLINGS": "WOLFLING, a young wolf [n]\n",
  "WOLFRAM": "(German) an alternative name for tungsten [n -S]\n",
  "WOLFRAMITE": "a tungstate of iron and manganese, the chief ore of tungsten [n -S]\n",
  "WOLFRAMITES": "WOLFRAMITE, a tungstate of iron and manganese, the chief ore of tungsten [n]\n",
  "WOLFRAMS": "WOLFRAM, (German) an alternative name for tungsten [n]\n",
  "WOLFS": "WOLF, to devour ravenously [v]\n",
  "WOLFSBANE": "a kind of aconite [n -S]\n",
  "WOLFSBANES": "WOLFSBANE, a kind of aconite [n]\n",
  "WOLFSKIN": "the pelt of a wolf [n -S]\n",
  "WOLFSKINS": "WOLFSKIN, the pelt of a wolf [n]\n",
  "WOLLASTONITE": "a metasilicate of calcium, usually occurring in white to grey fibrous tabular masses and used as a source of rock wool [n -S]\n",
  "WOLLASTONITES": "WOLLASTONITE, a metasilicate of calcium, usually occurring in white to grey fibrous tabular masses and used as a source of rock wool [n]\n",
  "WOLLIES": "WOLLY, a uniformed policeman, esp. a raw young constable [n]\n",
  "WOLLY": "a uniformed policeman, esp. a raw young constable [n WOLLIES]\n",
  "WOLVE": "to hunt for wolves [v WOLVED, WOLVING, WOLVES]\n",
  "WOLVED": "WOLVE, to hunt for wolves [v]\n",
  "WOLVER": "a hunter of wolves, also WOLFER [n -S]\n",
  "WOLVERENE": "a ferocious mustelid of Arctic regions, aka glutton, also WOLVERINE [n -S]\n",
  "WOLVERENES": "WOLVERENE, a ferocious mustelid of Arctic regions, aka glutton, also WOLVERINE [n]\n",
  "WOLVERINE": "a ferocious mustelid of Arctic regions, aka glutton, also WOLVERENE [n -S]\n",
  "WOLVERINES": "WOLVERINE, a ferocious mustelid of Arctic regions, aka glutton, also WOLVERENE [n]\n",
  "WOLVERS": "WOLVER, a hunter of wolves, also WOLFER [n]\n",
  "WOLVES": "WOLF, a carnivorous mammal [n]\n",
  "WOLVING": "the hunting for wolf pelts, also WOLFING [n -S]\n",
  "WOLVINGS": "WOLVING, the hunting for wolf pelts, also WOLFING [n]\n",
  "WOLVISH": "like a wolf, also WOLFISH [adj WOLVISHLY]\n",
  "WOLVISHLY": "WOLVISH, like a wolf, also WOLFISH [adv]\n",
  "WOMAN": "a female [n WOMEN] / to play the part of a woman [v WOMANED or WOMANNED, WOMANING or WOMANNING, WOMANS]\n",
  "WOMANED": "WOMAN, to play the part of a woman [v]\n",
  "WOMANFULLY": "in the manner of a woman [adv]\n",
  "WOMANHOOD": "the state of being a woman [n -S]\n",
  "WOMANHOODS": "WOMANHOOD, the state of being a woman [n]\n",
  "WOMANING": "WOMAN, to play the part of a woman [v]\n",
  "WOMANISE": "to pursue women amorously, also WOMANIZE [v WOMANISED, WOMANISING, WOMANISES]\n",
  "WOMANISED": "WOMANISE, to pursue women amorously, also WOMANIZE [v]\n",
  "WOMANISER": "one who engages in casual sexual encounters with women, also WOMANIZER [n -S]\n",
  "WOMANISERS": "WOMANISER, one who engages in casual sexual encounters with women, also WOMANIZER [n]\n",
  "WOMANISES": "WOMANISE, to pursue women amorously, also WOMANIZE [v]\n",
  "WOMANISH": "feminine [adj WOMANISHLY]\n",
  "WOMANISHLY": "WOMANISH, feminine [adv]\n",
  "WOMANISHNESS": "the state of being womanish [n -ES]\n",
  "WOMANISHNESSES": "WOMANISHNESS, the state of being womanish [n]\n",
  "WOMANISING": "engagement in casual sexual encounters with women, also WOMANIZING [n -S]\n",
  "WOMANISINGS": "WOMANISING, engagement in casual sexual encounters with women, also WOMANIZING [n]\n",
  "WOMANISM": "a belief in or respect for women [n -S]\n",
  "WOMANISMS": "WOMANISM, a belief in or respect for women [n]\n",
  "WOMANIST": "a supporter of womanism, feminism among black women [n -S]\n",
  "WOMANISTS": "WOMANIST, a supporter of womanism, feminism among black women [n]\n",
  "WOMANIZE": "to pursue women amorously, also WOMANISE [v WOMANIZED, WOMANIZING, WOMANIZES]\n",
  "WOMANIZED": "WOMANIZE, to pursue women amorously, also WOMANISE [v]\n",
  "WOMANIZER": "one who engages in casual sexual encounters with women, also WOMANISER [n -S]\n",
  "WOMANIZERS": "WOMANIZER, one who engages in casual sexual encounters with women, also WOMANISER [n]\n",
  "WOMANIZES": "WOMANIZE, to pursue women amorously, also WOMANISE [v]\n",
  "WOMANIZING": "engagement in casual sexual encounters with women, also WOMANISING [n -S]\n",
  "WOMANIZINGS": "WOMANIZING, engagement in casual sexual encounters with women, also WOMANISING [n]\n",
  "WOMANKIND": "women generally, the female sex, also WOMENKIND [n -S]\n",
  "WOMANKINDS": "WOMANKIND, women generally, the female sex, also WOMENKIND [n]\n",
  "WOMANLESS": "without a woman [adj]\n",
  "WOMANLIER": "WOMANLY, like a woman [adj]\n",
  "WOMANLIEST": "WOMANLY, like a woman [adj]\n",
  "WOMANLIKE": "like a woman [adj]\n",
  "WOMANLINESS": "the state of being womanly [n -ES]\n",
  "WOMANLINESSES": "WOMANLINESS, the state of being womanly [n]\n",
  "WOMANLY": "like a woman [adj WOMANLIER, WOMANLIEST]\n",
  "WOMANNED": "WOMAN, to play the part of a woman [v]\n",
  "WOMANNESS": "the state of being a woman [n -ES]\n",
  "WOMANNESSES": "WOMANNESS, the state of being a woman [n]\n",
  "WOMANNING": "WOMAN, to play the part of a woman [v]\n",
  "WOMANPOWER": "women available and prepared for work [n -S]\n",
  "WOMANPOWERS": "WOMANPOWER, women available and prepared for work [n]\n",
  "WOMANS": "WOMAN, to play the part of a woman [v]\n",
  "WOMB": "the uterus, also WAME, WEAMB, WEM, WEMB [n -S] / (Shakespeare) to enclose as in a womb [v -ED, -ING, -S]\n",
  "WOMBAT": "(Native Australian) any of three species of Australian burrowing marsupial [n -S]\n",
  "WOMBATS": "WOMBAT, (Native Australian) any of three species of Australian burrowing marsupial [n]\n",
  "WOMBED": "WOMB, (Shakespeare) to enclose as in a womb [v]\n",
  "WOMBIER": "WOMBY, (Shakespeare) hollow; capacious [adj]\n",
  "WOMBIEST": "WOMBY, (Shakespeare) hollow; capacious [adj]\n",
  "WOMBING": "WOMB, (Shakespeare) to enclose as in a womb [v]\n",
  "WOMBLIKE": "like a womb [adj]\n",
  "WOMBS": "WOMB, (Shakespeare) to enclose as in a womb [v]\n",
  "WOMBY": "(Shakespeare) hollow; capacious [adj WOMBIER, WOMBIEST]\n",
  "WOMEN": "WOMAN, a female [n]\n",
  "WOMENFOLK": "women collectively [n -S]\n",
  "WOMENFOLKS": "WOMENFOLK, women collectively [n]\n",
  "WOMENKIND": "women generally, the female sex, also WOMANKIND [n -S]\n",
  "WOMENKINDS": "WOMENKIND, women generally, the female sex, also WOMANKIND [n]\n",
  "WOMENSWEAR": "clothes suitable for women [n -S]\n",
  "WOMENSWEARS": "WOMENSWEAR, clothes suitable for women [n]\n",
  "WOMERA": "(Native Australian) a stick for launching a spear with greater force, also WOMMERA, WOOMERA, WOOMERANG [n -S]\n",
  "WOMERAS": "WOMERA, (Native Australian) a stick for launching a spear with greater force, also WOMMERA, WOOMERA, WOOMERANG [n]\n",
  "WOMMERA": "(Native Australian) a stick used to propel spears, also WOMERA, WOOMERA [n -S]\n",
  "WOMMERAS": "WOMMERA, (Native Australian) a stick used to propel spears, also WOMERA, WOOMERA [n]\n",
  "WOMMIT": "(English dialect) a foolish person [n -S]\n",
  "WOMMITS": "WOMMIT, (English dialect) a foolish person [n]\n",
  "WOMYN": "an attempt by American feminists to create a word for women without the man element, also WIMMIN [n]\n",
  "WON": "(archaic) to dwell, also WOON [v WONNED, WONNING, WONS]\n",
  "WONDER": "to speculate [v -ED, -ING, -S]\n",
  "WONDERED": "WONDER, to speculate [v]\n",
  "WONDERER": "one who wonders [n -S]\n",
  "WONDERERS": "WONDERER, one who wonders [n]\n",
  "WONDERFUL": "causing wonder; strange, extraordinary [adj WONDERFULLY]\n",
  "WONDERFULLY": "WONDERFUL, causing wonder; strange, extraordinary [adv]\n",
  "WONDERFULNESS": "the state of being wonderful [n -ES]\n",
  "WONDERFULNESSES": "WONDERFULNESS, the state of being wonderful [n]\n",
  "WONDERING": "having a feeling of curiosity or doubt [adj WONDERINGLY] / the act of wondering [n -S]\n",
  "WONDERINGLY": "WONDERING, having a feeling of curiosity or doubt [adv]\n",
  "WONDERINGS": "WONDERING, the act of wondering [n]\n",
  "WONDERKID": "(colloquial) an exceptionally successful young person [n -S]\n",
  "WONDERKIDS": "WONDERKID, (colloquial) an exceptionally successful young person [n]\n",
  "WONDERLAND": "an imaginary place of delicate beauty or magical charm [n -S]\n",
  "WONDERLANDS": "WONDERLAND, an imaginary place of delicate beauty or magical charm [n]\n",
  "WONDERLESS": "without wonders [adj]\n",
  "WONDERMENT": "a cause of or occasion for wonder [n -S]\n",
  "WONDERMENTS": "WONDERMENT, a cause of or occasion for wonder [n]\n",
  "WONDERMONGER": "one who promises miracles [n -S]\n",
  "WONDERMONGERING": "the promising of miracles [n]\n",
  "WONDERMONGERS": "WONDERMONGER, one who promises miracles [n]\n",
  "WONDEROUS": "strange, wonderful, also WONDROUS [adj]\n",
  "WONDERS": "WONDER, to speculate [v]\n",
  "WONDERSTRUCK": "struck with wonder [adj]\n",
  "WONDERWORK": "a prodigy, a miracle [n -S]\n",
  "WONDERWORKS": "WONDERWORK, a prodigy, a miracle [n]\n",
  "WONDRED": "(obsolete) marvellous, wonderful [adj]\n",
  "WONDROUS": "strange, wonderful, also WONDEROUS [adj WONDROUSLY]\n",
  "WONDROUSLY": "WONDROUS, strange, wonderful, also WONDEROUS [adv]\n",
  "WONDROUSNESS": "the state of being wondrous [n -ES]\n",
  "WONDROUSNESSES": "WONDROUSNESS, the state of being wondrous [n]\n",
  "WONGA": "(slang) money [n -S]\n",
  "WONGAS": "WONGA, (slang) money [n]\n",
  "WONGI": "(Native Australian) to talk or chat [v -ED, -ING, -S]\n",
  "WONGIED": "WONGI, (Native Australian) to talk or chat [v]\n",
  "WONGIING": "WONGI, (Native Australian) to talk or chat [v]\n",
  "WONGIS": "WONGI, (Native Australian) to talk or chat [v]\n",
  "WONING": "a dwelling place, also WONNING [n -S]\n",
  "WONINGS": "WONING, a dwelling place, also WONNING [n]\n",
  "WONK": "an expert who studies a subject or issue thoroughly and excessively [n -S]\n",
  "WONKERIES": "WONKERY, the qualities or activities of a wonk [n]\n",
  "WONKERY": "the qualities or activities of a wonk [n WONKERIES]\n",
  "WONKIER": "WONKY, not working properly [adj]\n",
  "WONKIEST": "WONKY, not working properly [adj]\n",
  "WONKILY": "WONKY, not working properly [adv]\n",
  "WONKINESS": "the state of being wonky [n -ES]\n",
  "WONKINESSES": "WONKINESS, the state of being wonky [n]\n",
  "WONKISH": "like a wonk, an overly zealous student [adj]\n",
  "WONKS": "WONK, an expert who studies a subject or issue thoroughly and excessively [n]\n",
  "WONKY": "not working properly [adj WONKIER, WONKIEST, WONKILY]\n",
  "WONNED": "WON, (archaic) to dwell, also WOON [v]\n",
  "WONNER": "(Scots) a wonder [n -S]\n",
  "WONNERS": "WONNER, (Scots) a wonder [n]\n",
  "WONNING": "a dwelling place, also WONING [n -S]\n",
  "WONNINGS": "WONNING, a dwelling place, also WONING [n]\n",
  "WONS": "WON, (archaic) to dwell, also WOON [v]\n",
  "WONT": "to be accustomed [v -ED, -ING, -S]\n",
  "WONTED": "WONT, to be accustomed [v]\n",
  "WONTEDLY": "WONTED, WONT, to be accustomed [adv]\n",
  "WONTEDNESS": "the state of being wonted [n -ES]\n",
  "WONTEDNESSES": "WONTEDNESS, the state of being wonted [n]\n",
  "WONTING": "WONT, to be accustomed [v]\n",
  "WONTLESS": "(archaic) unaccustomed [adj]\n",
  "WONTON": "(Chinese) in Chinese cuisine, a spicy dumpling containing minced pork, esp. served in soup [n -S]\n",
  "WONTONS": "WONTON, (Chinese) in Chinese cuisine, a spicy dumpling containing minced pork, esp. served in soup [n]\n",
  "WONTS": "WONT, to be accustomed [v]\n",
  "WOO": "to court; to seek the support of [v -ED, -ING, -S]\n",
  "WOOABLE": "capable of being wooed [adj]\n",
  "WOOBUT": "a hairy caterpillar, esp. of the tiger moth, also OOBIT, OUBIT, WOUBIT [n -S]\n",
  "WOOBUTS": "WOOBUT, a hairy caterpillar, esp. of the tiger moth, also OOBIT, OUBIT, WOUBIT [n]\n",
  "WOOD": "to cover with trees [v -ED, -ING, -S]\n",
  "WOODBIN": "a container for firewood, also WOODBOX [n -S]\n",
  "WOODBIND": "the honeysuckle, also WOODBINE [n -S]\n",
  "WOODBINDS": "WOODBIND, the honeysuckle, also WOODBINE [n]\n",
  "WOODBINE": "the honeysuckle, also WOODBIND [n -S]\n",
  "WOODBINES": "WOODBINE, the honeysuckle, also WOODBIND [n]\n",
  "WOODBINS": "WOODBIN, a container for firewood, also WOODBOX [n]\n",
  "WOODBLOCK": "a type of flooring [n -S]\n",
  "WOODBLOCKS": "WOODBLOCK, a type of flooring [n]\n",
  "WOODBORER": "any of various beetles the larvae of which bore into and damage wood [n -S]\n",
  "WOODBORERS": "WOODBORER, any of various beetles the larvae of which bore into and damage wood [n]\n",
  "WOODBOX": "a container for firewood, also WOODBIN [n -ES]\n",
  "WOODBOXES": "WOODBOX, a container for firewood, also WOODBIN [n]\n",
  "WOODBURYTYPE": "(tradename) a photomechanical process in which an exposed and developed bichromated film is forced into a metal plate by great pressure, and so forms a matrix for subsequent printing [n -S]\n",
  "WOODBURYTYPES": "WOODBURYTYPE, (tradename) a photomechanical process in which an exposed and developed bichromated film is forced into a metal plate by great pressure, and so forms a matrix for subsequent printing [n]\n",
  "WOODCARVER": "a craftsman who carves wood [n -S]\n",
  "WOODCARVERS": "WOODCARVER, a craftsman who carves wood [n]\n",
  "WOODCARVING": "the art of carving in wood [n -S]\n",
  "WOODCARVINGS": "WOODCARVING, the art of carving in wood [n]\n",
  "WOODCHAT": "a species of shrike, with black-and-white plumage but a red-brown crown, also WOODSHRIKE [n -S]\n",
  "WOODCHATS": "WOODCHAT, a species of shrike, with black-and-white plumage but a red-brown crown, also WOODSHRIKE [n]\n",
  "WOODCHIP": "chipped wood, used e.g. for mulch [n -S]\n",
  "WOODCHIPS": "WOODCHIP, chipped wood, used e.g. for mulch [n]\n",
  "WOODCHOP": "an exhibition of wood-chopping [n -S]\n",
  "WOODCHOPPER": "one engaged in chopping wood and esp. in chopping down trees [n -S]\n",
  "WOODCHOPPERS": "WOODCHOPPER, one engaged in chopping wood and esp. in chopping down trees [n]\n",
  "WOODCHOPS": "WOODCHOP, an exhibition of wood-chopping [n]\n",
  "WOODCHUCK": "(Native American) a common large North American marmot, aka groundhog [n -S]\n",
  "WOODCHUCKS": "WOODCHUCK, (Native American) a common large North American marmot, aka groundhog [n]\n",
  "WOODCOCK": "a genus of birds related to the snipe [n -S]\n",
  "WOODCOCKS": "WOODCOCK, a genus of birds related to the snipe [n]\n",
  "WOODCRAFT": "skill in hunting or life in the woods generally [n -S]\n",
  "WOODCRAFTS": "WOODCRAFT, skill in hunting or life in the woods generally [n]\n",
  "WOODCRAFTSMAN": "a craftsman who works with wood [n WOODCRAFTSMEN]\n",
  "WOODCRAFTSMEN": "WOODCRAFTSMAN, a craftsman who works with wood [n]\n",
  "WOODCUT": "a design cut in relief on a block of wood [n -S]\n",
  "WOODCUTS": "WOODCUT, a design cut in relief on a block of wood [n]\n",
  "WOODCUTTER": "one that cuts wood [n -S]\n",
  "WOODCUTTERS": "WOODCUTTER, one that cuts wood [n]\n",
  "WOODCUTTING": "the action or occupation of cutting wood or timber [n -S]\n",
  "WOODCUTTINGS": "WOODCUTTING, the action or occupation of cutting wood or timber [n]\n",
  "WOODED": "WOOD, to cover with trees [v]\n",
  "WOODEN": "stiff as in wood [adj WOODENER, WOODENEST, WOODENLY] / (Australian slang) to fell or kill a person or animal [v -ED, -ING, -S]\n",
  "WOODENED": "WOODEN, (Australian slang) to fell or kill a person or animal [v]\n",
  "WOODENER": "WOODEN, stiff as in wood [adj]\n",
  "WOODENEST": "WOODEN, stiff as in wood [adj]\n",
  "WOODENHEAD": "(colloquial) a blockhead, a stupid person [n -S]\n",
  "WOODENHEADED": "having a wooden head; dense, stupid [adj]\n",
  "WOODENHEADS": "WOODENHEAD, (colloquial) a blockhead, a stupid person [n]\n",
  "WOODENING": "WOODEN, (Australian slang) to fell or kill a person or animal [v]\n",
  "WOODENLY": "WOODEN, stiff as in wood [adv]\n",
  "WOODENNESS": "the state of being wooden [n -ES]\n",
  "WOODENNESSES": "WOODENNESS, the state of being wooden [n]\n",
  "WOODENS": "WOODEN, (Australian slang) to fell or kill a person or animal [v]\n",
  "WOODENTOP": "a uniformed policeman; a guardsman [n -S]\n",
  "WOODENTOPS": "WOODENTOP, a uniformed policeman; a guardsman [n]\n",
  "WOODENWARE": "ware made of wood [n -S]\n",
  "WOODENWARES": "WOODENWARE, ware made of wood [n]\n",
  "WOODFERN": "an evergreen fern [n -S]\n",
  "WOODFERNS": "WOODFERN, an evergreen fern [n]\n",
  "WOODFREE": "of high-quality paper, made from pulp that has been chemically treated to remove impurities [adj]\n",
  "WOODGRAIN": "grain in wood [n -S]\n",
  "WOODGRAINS": "WOODGRAIN, grain in wood [n]\n",
  "WOODGROUSE": "a kind of bird, the capercailzie [n -S]\n",
  "WOODGROUSES": "WOODGROUSE, a kind of bird, the capercailzie [n]\n",
  "WOODHEN": "the flightless rail of New Zealand, aka weka [n -S]\n",
  "WOODHENS": "WOODHEN, the flightless rail of New Zealand, aka weka [n]\n",
  "WOODHOLE": "a place where wood is stored [n -S]\n",
  "WOODHOLES": "WOODHOLE, a place where wood is stored [n]\n",
  "WOODHORSE": "a sawhorse [n -S]\n",
  "WOODHORSES": "WOODHORSE, a sawhorse [n]\n",
  "WOODHOUSE": "a wild man of the woods, used in heraldry as a supporter, also WOODWOSE [n -S]\n",
  "WOODHOUSES": "WOODHOUSE, a wild man of the woods, used in heraldry as a supporter, also WOODWOSE [n]\n",
  "WOODIE": "a wood-panelled station wagon, also WOODY [n -S]\n",
  "WOODIER": "WOODY, like wood [adj]\n",
  "WOODIES": "WOODY, a wood-paneled station wagon, also WOODIE [n]\n",
  "WOODIEST": "WOODY, like wood [adj]\n",
  "WOODINESS": "the state of being woody [n -ES]\n",
  "WOODINESSES": "WOODINESS, the state of being woody [n]\n",
  "WOODING": "WOOD, to cover with trees [v]\n",
  "WOODLAND": "land covered with trees [n -S]\n",
  "WOODLANDER": "one who lives or works in woodland [n -S]\n",
  "WOODLANDERS": "WOODLANDER, one who lives or works in woodland [n]\n",
  "WOODLANDS": "WOODLAND, land covered with trees [n]\n",
  "WOODLARK": "a kind of lark, smaller than the skylark and having a shorter tail [n -S]\n",
  "WOODLARKS": "WOODLARK, a kind of lark, smaller than the skylark and having a shorter tail [n]\n",
  "WOODLESS": "having no wood [adj]\n",
  "WOODLESSNESS": "the state of being woodless [n -ES]\n",
  "WOODLESSNESSES": "WOODLESSNESS, the state of being woodless [n]\n",
  "WOODLICE": "WOODLOUSE, any small isopod crustacean of the suborder Oniscoidea [n]\n",
  "WOODLORE": "knowledge of the forest [n -S]\n",
  "WOODLORES": "WOODLORE, knowledge of the forest [n]\n",
  "WOODLOT": "an area restricted to the growing of trees [n -S]\n",
  "WOODLOTS": "WOODLOT, an area restricted to the growing of trees [n]\n",
  "WOODLOUSE": "any small isopod crustacean of the suborder Oniscoidea [n WOODLICE]\n",
  "WOODMAN": "one who works or lives in the forest, also WOODSMAN [n WOODMEN]\n",
  "WOODMEAL": "sawdust and other wood waste used as industrial filler [n -S]\n",
  "WOODMEALS": "WOODMEAL, sawdust and other wood waste used as industrial filler [n]\n",
  "WOODMEN": "WOODMAN, one who works or lives in the forest, also WOODSMAN [n]\n",
  "WOODMICE": "WOODMOUSE, a field mouse [n]\n",
  "WOODMOUSE": "a field mouse [n WOODMICE]\n",
  "WOODNESS": "the act of being fierce, madness [n -ES]\n",
  "WOODNESSES": "WOODNESS, the act of being fierce, madness [n]\n",
  "WOODNOTE": "(Milton) a wild musical note, like that of a songbird [n -S]\n",
  "WOODNOTES": "WOODNOTE, (Milton) a wild musical note, like that of a songbird [n]\n",
  "WOODPECKER": "any of a family of birds in the order Picariae, remarkable for modification of the skull and bill enabling the latter to be used to drill holes [n -S]\n",
  "WOODPECKERS": "WOODPECKER, any of a family of birds in the order Picariae, remarkable for modification of the skull and bill enabling the latter to be used to drill holes [n]\n",
  "WOODPILE": "a pile of wood [n -S]\n",
  "WOODPILES": "WOODPILE, a pile of wood [n]\n",
  "WOODPRINT": "a design cut in relief on a block of wood [n -S]\n",
  "WOODPRINTS": "WOODPRINT, a design cut in relief on a block of wood [n]\n",
  "WOODRAT": "another name for the pack-rat [n -S]\n",
  "WOODRATS": "WOODRAT, another name for the pack-rat [n]\n",
  "WOODREEVE": "the overseer of a wood [n -S]\n",
  "WOODREEVES": "WOODREEVE, the overseer of a wood [n]\n",
  "WOODROOF": "a plant with small white flowers, also WOODRUFF [n -S]\n",
  "WOODROOFS": "WOODROOF, a plant with small white flowers, also WOODRUFF [n]\n",
  "WOODRUFF": "a plant with small white flowers, also WOODROOF [n -S]\n",
  "WOODRUFFS": "WOODRUFF, a plant with small white flowers, also WOODROOF [n]\n",
  "WOODRUSH": "a plant that grows in woods [n -ES]\n",
  "WOODRUSHES": "WOODRUSH, a plant that grows in woods [n]\n",
  "WOODS": "WOOD, to cover with trees [v]\n",
  "WOODSCREW": "a tapered screw for fastening pieces of wood [n -S]\n",
  "WOODSCREWS": "WOODSCREW, a tapered screw for fastening pieces of wood [n]\n",
  "WOODSHED": "to practice on a musical instrument [v WOODSHEDDED, WOODSHEDDING, WOODSHEDS]\n",
  "WOODSHEDDED": "WOODSHED, to practice on a musical instrument [v]\n",
  "WOODSHEDDING": "spontaneous or improvised barbershop singing [n -S]\n",
  "WOODSHEDDINGS": "WOODSHEDDING, spontaneous or improvised barbershop singing [n]\n",
  "WOODSHEDS": "WOODSHED, to practice on a musical instrument [v]\n",
  "WOODSHOCK": "a large North American marten with dark brown fur [n -S]\n",
  "WOODSHOCKS": "WOODSHOCK, a large North American marten with dark brown fur [n]\n",
  "WOODSHRIKE": "a species of shrike, with black-and-white plumage but a red-brown crown, also WOODCHAT [n -S]\n",
  "WOODSHRIKES": "WOODSHRIKE, a species of shrike, with black-and-white plumage but a red-brown crown, also WOODCHAT [n]\n",
  "WOODSIA": "a genus of ferns [n -S]\n",
  "WOODSIAS": "WOODSIA, a genus of ferns [n]\n",
  "WOODSIER": "WOODSY, relating to the forest [adj]\n",
  "WOODSIEST": "WOODSY, relating to the forest [adj]\n",
  "WOODSKIN": "an American Indian canoe made of bark [n -S]\n",
  "WOODSKINS": "WOODSKIN, an American Indian canoe made of bark [n]\n",
  "WOODSMAN": "one who works or lives in the forest, also WOODMAN [n WOODSMEN]\n",
  "WOODSMEN": "WOODSMAN, one who works or lives in the forest, also WOODMAN [n]\n",
  "WOODSMOKE": "smoke produced by burning wood [n -S]\n",
  "WOODSMOKES": "WOODSMOKE, smoke produced by burning wood [n]\n",
  "WOODSPITE": "the green woodpecker [n -S]\n",
  "WOODSPITES": "WOODSPITE, the green woodpecker [n]\n",
  "WOODSTONE": "a striped variety of hornstone, resembling wood in appearance [n -S]\n",
  "WOODSTONES": "WOODSTONE, a striped variety of hornstone, resembling wood in appearance [n]\n",
  "WOODSTOVE": "a stove that burns wood [n -S]\n",
  "WOODSTOVES": "WOODSTOVE, a stove that burns wood [n]\n",
  "WOODSWALLOW": "any of the fly-catching Artamidae, related to the shrikes [n -S]\n",
  "WOODSWALLOWS": "WOODSWALLOW, any of the fly-catching Artamidae, related to the shrikes [n]\n",
  "WOODSY": "relating to the forest [adj WOODSIER, WOODSIEST]\n",
  "WOODTHRUSH": "an American bird [n -ES]\n",
  "WOODTHRUSHES": "WOODTHRUSH, an American bird [n]\n",
  "WOODTONE": "a finish that imitates wood [n -S]\n",
  "WOODTONES": "WOODTONE, a finish that imitates wood [n]\n",
  "WOODWALE": "the woodpecker [n -S]\n",
  "WOODWALES": "WOODWALE, the woodpecker [n]\n",
  "WOODWARD": "an officer of the forest, whose duty it was to guard the woods [n -S]\n",
  "WOODWARDS": "WOODWARD, an officer of the forest, whose duty it was to guard the woods [n]\n",
  "WOODWASP": "a large wasplike insect [n -S]\n",
  "WOODWASPS": "WOODWASP, a large wasplike insect [n]\n",
  "WOODWAX": "dyer's greenweed, also WOADWAX, WOADWAXEN, WOODWAXEN [n -ES]\n",
  "WOODWAXEN": "dyer's greenweed, also WOADWAX, WOADWAXEN, WOODWAX [n -S]\n",
  "WOODWAXENS": "WOODWAXEN, dyer's greenweed, also WOADWAX, WOADWAXEN, WOODWAX [n]\n",
  "WOODWAXES": "WOODWAX, dyer's greenweed, also WOADWAX, WOADWAXEN, WOODWAXEN [n]\n",
  "WOODWIND": "any orchestral wind instrument other than the brass instruments [n -S]\n",
  "WOODWINDS": "WOODWIND, any orchestral wind instrument other than the brass instruments [n]\n",
  "WOODWORK": "work made of wood [n -S]\n",
  "WOODWORKER": "one who works with wood [n -S]\n",
  "WOODWORKERS": "WOODWORKER, one who works with wood [n]\n",
  "WOODWORKING": "the process of working wood into a useful or desired form [n -S]\n",
  "WOODWORKINGS": "WOODWORKING, the process of working wood into a useful or desired form [n]\n",
  "WOODWORKS": "WOODWORK, work made of wood [n]\n",
  "WOODWORM": "any of various insect larvae that bore into wooden furniture, beams, etc., esp. the larvae of the furniture beetle and the deathwatch beetle [n -S]\n",
  "WOODWORMS": "WOODWORM, any of various insect larvae that bore into wooden furniture, beams, etc., esp. the larvae of the furniture beetle and the deathwatch beetle [n]\n",
  "WOODWOSE": "a wild man of the woods, used in heraldry as a supporter, also WOODHOUSE [n -S]\n",
  "WOODWOSES": "WOODWOSE, a wild man of the woods, used in heraldry as a supporter, also WOODHOUSE [n]\n",
  "WOODY": "like wood [adj WOODIER, WOODIEST] / a wood-paneled station wagon, also WOODIE [n WOODIES]\n",
  "WOODYARD": "a yard in which wood is cut and stored [n -S]\n",
  "WOODYARDS": "WOODYARD, a yard in which wood is cut and stored [n]\n",
  "WOOED": "WOO, to court; to seek the support of [v]\n",
  "WOOER": "one who woos [n -S]\n",
  "WOOERS": "WOOER, one who woos [n]\n",
  "WOOF": "to bark [v -ED, -ING, -S]\n",
  "WOOFED": "WOOF, to bark [v]\n",
  "WOOFER": "a loudspeaker for low-pitched sounds [n -S]\n",
  "WOOFERS": "WOOFER, a loudspeaker for low-pitched sounds [n]\n",
  "WOOFIER": "WOOFY, dense in texture [adj]\n",
  "WOOFIEST": "WOOFY, dense in texture [adj]\n",
  "WOOFING": "WOOF, to bark [v]\n",
  "WOOFS": "WOOF, to bark [v]\n",
  "WOOFTAH": "(slang) a male homosexual, also WOOFTER [n -S]\n",
  "WOOFTAHS": "WOOFTAH, (slang) a male homosexual, also WOOFTER [n]\n",
  "WOOFTER": "(offensive) a homosexual, also WOOFTAH [n -S]\n",
  "WOOFTERS": "WOOFTER, (offensive) a homosexual, also WOOFTAH [n]\n",
  "WOOFY": "dense in texture [adj WOOFIER, WOOFIEST]\n",
  "WOOHOO": "an exclamation of joy, approval, etc. [interj]\n",
  "WOOING": "seductive [adj WOOINGLY] / the act of wooing [n -S]\n",
  "WOOINGLY": "attractively [adv]\n",
  "WOOINGS": "WOOING, the act of wooing [n]\n",
  "WOOL": "the fleece of sheep or goats [n -S]\n",
  "WOOLD": "to wind a rope or chain around [v -ED, -ING, -S]\n",
  "WOOLDED": "WOOLD, to wind a rope or chain around [v]\n",
  "WOOLDER": "a stick used to tighten the rope in woolding [n -S]\n",
  "WOOLDERS": "WOOLDER, a stick used to tighten the rope in woolding [n]\n",
  "WOOLDING": "the act of winding a rope or chain [n -S]\n",
  "WOOLDINGS": "WOOLDING, the act of winding a rope or chain [n]\n",
  "WOOLDS": "WOOLD, to wind a rope or chain around [v]\n",
  "WOOLED": "having (such) wool; as, a fine-wooled sheep, also WOOLLED [adj]\n",
  "WOOLEN": "a fabric made of wool, also WOOLLEN [n -S]\n",
  "WOOLENS": "WOOLEN, a fabric made of wool, also WOOLLEN [n]\n",
  "WOOLER": "a domestic animal raised for its wool [n -S]\n",
  "WOOLERS": "WOOLER, a domestic animal raised for its wool [n]\n",
  "WOOLFAT": "lanolin [n -S]\n",
  "WOOLFATS": "WOOLFAT, lanolin [n]\n",
  "WOOLFELL": "(archaic) a sheep's skin with the wool still on it [n -S]\n",
  "WOOLFELLS": "WOOLFELL, (archaic) a sheep's skin with the wool still on it [n]\n",
  "WOOLGATHERER": "one who woolgathers [n -S]\n",
  "WOOLGATHERERS": "WOOLGATHERER, one who woolgathers [n]\n",
  "WOOLGATHERING": "indulgence in idle daydreaming [n -S]\n",
  "WOOLGATHERINGS": "WOOLGATHERING, indulgence in idle daydreaming [n]\n",
  "WOOLGROWER": "a person who keeps sheep for their wool [n -S]\n",
  "WOOLGROWERS": "WOOLGROWER, a person who keeps sheep for their wool [n]\n",
  "WOOLGROWING": "keeping sheep for their wool [n -S]\n",
  "WOOLGROWINGS": "WOOLGROWING, keeping sheep for their wool [n]\n",
  "WOOLHAT": "one who works a small farm [n -S]\n",
  "WOOLHATS": "WOOLHAT, one who works a small farm [n]\n",
  "WOOLIE": "a woollen garment, also WOOLLY, WOOLY [n -S]\n",
  "WOOLIER": "WOOLY, having the texture of wool, also WOOLLY [adj]\n",
  "WOOLIES": "WOOLIE, a woollen garment, also WOOLLY, WOOLY [n]\n",
  "WOOLIEST": "WOOLY, having the texture of wool, also WOOLLY [adj]\n",
  "WOOLILY": "WOOLY, having the texture of wool, also WOOLLY [adv]\n",
  "WOOLINESS": "the state of being wooly, also WOOLLINESS [n -ES]\n",
  "WOOLINESSES": "WOOLINESS, the state of being wooly, also WOOLLINESS [n]\n",
  "WOOLLED": "bearing wool [adj]\n",
  "WOOLLEN": "a garment made of wool, also WOOLEN [n -S]\n",
  "WOOLLENS": "WOOLLEN, a garment made of wool, also WOOLEN [n]\n",
  "WOOLLIER": "WOOLLY, like wool [adj]\n",
  "WOOLLIES": "WOOLLY, a woolly item of clothing, also WOOLIE, WOOLY [n]\n",
  "WOOLLIEST": "WOOLLY, like wool [adj]\n",
  "WOOLLIKE": "like wool [adj]\n",
  "WOOLLILY": "WOOLLY, like wool [adv]\n",
  "WOOLLINESS": "the state of being woolly, also WOOLINESS [n -ES]\n",
  "WOOLLINESSES": "WOOLLINESS, the state of being woolly, also WOOLINESS [n]\n",
  "WOOLLY": "like wool [adj WOOLLIER, WOOLLIEST, WOOLLILY] / a woolly item of clothing, also WOOLIE, WOOLY [n WOOLLIES]\n",
  "WOOLLYBACK": "(colloquial) a country bumpkin [n -S]\n",
  "WOOLLYBACKS": "WOOLLYBACK, (colloquial) a country bumpkin [n]\n",
  "WOOLLYBUTT": "a kind of eucalyptus with fibrous bark [n -S]\n",
  "WOOLLYBUTTS": "WOOLLYBUTT, a kind of eucalyptus with fibrous bark [n]\n",
  "WOOLLYFOOT": "as in wood woollyfoot, a kind of fungus [n -S]\n",
  "WOOLLYFOOTS": "WOOLLYFOOT, as in wood woollyfoot, a kind of fungus [n]\n",
  "WOOLMAN": "a dealer in wool [n WOOLMEN]\n",
  "WOOLMEN": "WOOLMAN, a dealer in wool [n]\n",
  "WOOLPACK": "a bag for packing a bale of wool [n -S]\n",
  "WOOLPACKS": "WOOLPACK, a bag for packing a bale of wool [n]\n",
  "WOOLS": "WOOL, the fleece of sheep or goats [n]\n",
  "WOOLSACK": "the seat of the Lord Chancellor in the House of Lords, being a large square sack of wool covered with scarlet [n -S]\n",
  "WOOLSACKS": "WOOLSACK, the seat of the Lord Chancellor in the House of Lords, being a large square sack of wool covered with scarlet [n]\n",
  "WOOLSEY": "(obsolete) a cotton and wool blend [n -S]\n",
  "WOOLSEYS": "WOOLSEY, (obsolete) a cotton and wool blend [n]\n",
  "WOOLSHED": "a large shed for shearing sheep [n -S]\n",
  "WOOLSHEDS": "WOOLSHED, a large shed for shearing sheep [n]\n",
  "WOOLSKIN": "a sheepskin with the wool still on it [n -S]\n",
  "WOOLSKINS": "WOOLSKIN, a sheepskin with the wool still on it [n]\n",
  "WOOLSORTER": "a person who sorts wool according to quality [n -S]\n",
  "WOOLSORTERS": "WOOLSORTER, a person who sorts wool according to quality [n]\n",
  "WOOLWARD": "(obsolete) wearing wool next the skin, esp. as a penance [adj]\n",
  "WOOLWORK": "needlework [n -S]\n",
  "WOOLWORKS": "WOOLWORK, needlework [n]\n",
  "WOOLY": "having the texture of wool, also WOOLLY [adj WOOLIER, WOOLIEST, WOOLILY] / a garment made of wool, also WOOLIE [n WOOLIES]\n",
  "WOOMERA": "(Native Australian) a stick for launching a spear with greater force, also WOMERA, WOMMERA, WOOMERANG [n -S]\n",
  "WOOMERANG": "(Native Australian) a stick for launching a spear with greater force, also WOMERA, WOMMERA, WOOMERA [n -S]\n",
  "WOOMERANGS": "WOOMERANG, (Native Australian) a stick for launching a spear with greater force, also WOMERA, WOMMERA, WOOMERA [n]\n",
  "WOOMERAS": "WOOMERA, (Native Australian) a stick for launching a spear with greater force, also WOMERA, WOMMERA, WOOMERANG [n]\n",
  "WOON": "(Spenser) to dwell, also WON [v -ED, -ING, -S]\n",
  "WOONED": "WOON, (Spenser) to dwell, also WON [v]\n",
  "WOONERF": "(Dutch) a road in the Netherlands primarily for bicyclists and pedestrians [n -S]\n",
  "WOONERFS": "WOONERF, (Dutch) a road in the Netherlands primarily for bicyclists and pedestrians [n]\n",
  "WOONING": "WOON, (Spenser) to dwell, also WON [v]\n",
  "WOONS": "WOON, (Spenser) to dwell, also WON [v]\n",
  "WOOPIE": "a well-off older person, also WOOPY [n -S]\n",
  "WOOPIES": "WOOPIE, a well-off older person, also WOOPY [n]\n",
  "WOOPS": "to vomit [v WOOPSED, WOOPSING, WOOPSES]\n",
  "WOOPSED": "WOOPS, to vomit [v]\n",
  "WOOPSES": "WOOPS, to vomit [v]\n",
  "WOOPSING": "WOOPS, to vomit [v]\n",
  "WOOPY": "a well-off older person, also WOOPIE [n WOOPIES]\n",
  "WOORALI": "(Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORARA, WOORARI, WOURALI [n -S]\n",
  "WOORALIS": "WOORALI, (Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORARA, WOORARI, WOURALI [n]\n",
  "WOORARA": "(Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORALI, WOORARI, WOURALI [n -S]\n",
  "WOORARAS": "WOORARA, (Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORALI, WOORARI, WOURALI [n]\n",
  "WOORARI": "(Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOURALI [n -S]\n",
  "WOORARIS": "WOORARI, (Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOURALI [n]\n",
  "WOOS": "WOO, to court; to seek the support of [v]\n",
  "WOOSE": "a wimp, also WUSS [n -S]\n",
  "WOOSEL": "(Shakespeare) an ouzel, also WOOSELL [n -S]\n",
  "WOOSELL": "(Shakespeare) an ouzel, also WOOSEL [n -S]\n",
  "WOOSELLS": "WOOSELL, (Shakespeare) an ouzel, also WOOSEL [n]\n",
  "WOOSELS": "WOOSEL, (Shakespeare) an ouzel, also WOOSELL [n]\n",
  "WOOSES": "WOOSE, a wimp, also WUSS [n]\n",
  "WOOSH": "to move with a hissing sound, also WHOOSH [v -ED, -ING, -ES]\n",
  "WOOSHED": "WOOSH, to move with a hissing sound, also WHOOSH [v]\n",
  "WOOSHES": "WOOSH, to move with a hissing sound, also WHOOSH [v]\n",
  "WOOSHING": "WOOSH, to move with a hissing sound, also WHOOSH [v]\n",
  "WOOT": "(Shakespeare) wilt (thou) [v]\n",
  "WOOTZ": "a tough sharp steel made in southern India by fusing magnetic iron ore with material containing carbon [n -ES]\n",
  "WOOTZES": "WOOTZ, a tough sharp steel made in southern India by fusing magnetic iron ore with material containing carbon [n]\n",
  "WOOZIER": "WOOZY, slightly drunk or confused [adj]\n",
  "WOOZIEST": "WOOZY, slightly drunk or confused [adj]\n",
  "WOOZILY": "WOOZY, slightly drunk or confused [adv]\n",
  "WOOZINESS": "the state of being woozy [n -ES]\n",
  "WOOZINESSES": "WOOZINESS, the state of being woozy [n]\n",
  "WOOZY": "slightly drunk or confused [adj WOOZIER, WOOZIEST, WOOZILY]\n",
  "WOP": "to thump, also WHAP, WHOP [v WOPPED, WOPPING, WOPS]\n",
  "WOPPED": "WOP, to thump, also WHAP, WHOP [v]\n",
  "WOPPING": "WOP, to thump, also WHAP, WHOP [v]\n",
  "WOPS": "WOP, to thump, also WHAP, WHOP [v]\n",
  "WORCESTER": "a kind of fine wool [n -S]\n",
  "WORCESTERBERRY": "a North American species of gooseberry [n]\n",
  "WORCESTERS": "WORCESTER, a kind of fine wool [n]\n",
  "WORD": "to express in speech sounds [v -ED, -ING, -S]\n",
  "WORDAGE": "the number of words used [n -S]\n",
  "WORDAGES": "WORDAGE, the number of words used [n]\n",
  "WORDBOOK": "a dictionary [n -S]\n",
  "WORDBOOKS": "WORDBOOK, a dictionary [n]\n",
  "WORDBOUND": "unable to find expression in words [adj]\n",
  "WORDBREAK": "point of division in a word that runs onto the next line [n -S]\n",
  "WORDBREAKS": "WORDBREAK, point of division in a word that runs onto the next line [n]\n",
  "WORDCOUNT": "a count of words in a document [n -S]\n",
  "WORDCOUNTS": "WORDCOUNT, a count of words in a document [n]\n",
  "WORDED": "WORD, to express in speech sounds [v]\n",
  "WORDGAME": "a game in which words are used [n -S]\n",
  "WORDGAMES": "WORDGAME, a game in which words are used [n]\n",
  "WORDIE": "a lover of words [n -S]\n",
  "WORDIER": "WORDY, verbose [adj]\n",
  "WORDIES": "WORDIE, a lover of words [n]\n",
  "WORDIEST": "WORDY, verbose [adj]\n",
  "WORDILY": "WORDY, verbose [adv]\n",
  "WORDINESS": "the state of being wordy [n -ES]\n",
  "WORDINESSES": "WORDINESS, the state of being wordy [n]\n",
  "WORDING": "the style of expressing in words [n -S]\n",
  "WORDINGS": "WORDING, the style of expressing in words [n]\n",
  "WORDISH": "(obsolete) wordy, verbose [adj]\n",
  "WORDISHNESS": "verbosity [n -ES]\n",
  "WORDISHNESSES": "WORDISHNESS, verbosity [n]\n",
  "WORDLESS": "without words [adj WORDLESSLY]\n",
  "WORDLESSLY": "WORDLESS, without words [adv]\n",
  "WORDLESSNESS": "the state of being wordless [n -ES]\n",
  "WORDLESSNESSES": "WORDLESSNESS, the state of being wordless [n]\n",
  "WORDLORE": "information about the history of words [n -S]\n",
  "WORDLORES": "WORDLORE, information about the history of words [n]\n",
  "WORDMONGER": "a writer or speaker who uses language pretentiously or carelessly [n -S]\n",
  "WORDMONGERS": "WORDMONGER, a writer or speaker who uses language pretentiously or carelessly [n]\n",
  "WORDPLAY": "a witty exchange of words [n -S]\n",
  "WORDPLAYS": "WORDPLAY, a witty exchange of words [n]\n",
  "WORDS": "WORD, to express in speech sounds [v]\n",
  "WORDSEARCH": "a type of word puzzle [n -ES]\n",
  "WORDSEARCHES": "WORDSEARCH, a type of word puzzle [n]\n",
  "WORDSMITH": "an accomplished user of words [n -S]\n",
  "WORDSMITHERIES": "WORDSMITHERY, the craft of the wordsmith [n]\n",
  "WORDSMITHERY": "the craft of the wordsmith [n WORDSMITHERIES]\n",
  "WORDSMITHS": "WORDSMITH, an accomplished user of words [n]\n",
  "WORDWRAP": "in computing, a function that shifts a word at the end of a line to a new line in order to keep within preset margins [n -S]\n",
  "WORDWRAPS": "WORDWRAP, in computing, a function that shifts a word at the end of a line to a new line in order to keep within preset margins [n]\n",
  "WORDY": "verbose [adj WORDIER, WORDIEST, WORDILY]\n",
  "WORE": "WEAR, to turn a ship's stern to windward to alter its course [v]\n",
  "WORK": "to toil in mind or body [v WORKED or (archaic) WROUGHT, YWROKE, WORKING, WORKS]\n",
  "WORKABILITIES": "WORKABILITY, the quality of being workable [n]\n",
  "WORKABILITY": "the quality of being workable [n WORKABILITIES]\n",
  "WORKABLE": "capable of being done [adj WORKABLY]\n",
  "WORKABLENESS": "the state of being workable [n -ES]\n",
  "WORKABLENESSES": "WORKABLENESS, the state of being workable [n]\n",
  "WORKABLY": "WORKABLE, capable of being done [adv]\n",
  "WORKADAY": "a working day [n -S]\n",
  "WORKADAYS": "WORKADAY, a working day [n]\n",
  "WORKAHOLIC": "one who is excessively fond of work [n -S]\n",
  "WORKAHOLICS": "WORKAHOLIC, one who is excessively fond of work [n]\n",
  "WORKAHOLISM": "excessive industry [n -S]\n",
  "WORKAHOLISMS": "WORKAHOLISM, excessive industry [n]\n",
  "WORKAROUND": "a way of circumventing a difficulty [n -S]\n",
  "WORKAROUNDS": "WORKAROUND, a way of circumventing a difficulty [n]\n",
  "WORKBAG": "a bag for holding work materials, also WORKBOX [n -S]\n",
  "WORKBAGS": "WORKBAG, a bag for holding work materials, also WORKBOX [n]\n",
  "WORKBASKET": "a basket for holding materials for needlework, or the like [n -S]\n",
  "WORKBASKETS": "WORKBASKET, a basket for holding materials for needlework, or the like [n]\n",
  "WORKBENCH": "a bench, often purpose-built, at which a craftsman, mechanic, etc. works [n -ES]\n",
  "WORKBENCHES": "WORKBENCH, a bench, often purpose-built, at which a craftsman, mechanic, etc. works [n]\n",
  "WORKBOAT": "a commercial boat [n -S]\n",
  "WORKBOATS": "WORKBOAT, a commercial boat [n]\n",
  "WORKBOOK": "a student's exercise book [n -S]\n",
  "WORKBOOKS": "WORKBOOK, a student's exercise book [n]\n",
  "WORKBOOT": "a sturdy leather boot for workers [n -S]\n",
  "WORKBOOTS": "WORKBOOT, a sturdy leather boot for workers [n]\n",
  "WORKBOX": "a bag for holding work materials, also WORKBAG [n -ES]\n",
  "WORKBOXES": "WORKBOX, a bag for holding work materials, also WORKBAG [n]\n",
  "WORKDAY": "a day on which work is done [n -S]\n",
  "WORKDAYS": "WORKDAY, a day on which work is done [n]\n",
  "WORKED": "WORK, to toil in mind or body [v]\n",
  "WORKER": "one that works [n -S]\n",
  "WORKERIST": "one who supports worker's rights [n -S]\n",
  "WORKERISTS": "WORKERIST, one who supports worker's rights [n]\n",
  "WORKERLESS": "without workers [adj]\n",
  "WORKERS": "WORKER, one that works [n]\n",
  "WORKFARE": "a welfare programme where recipients perform public service work [n -S]\n",
  "WORKFARES": "WORKFARE, a welfare programme where recipients perform public service work [n]\n",
  "WORKFELLOW": "a companion at work, a workmate [n -S]\n",
  "WORKFELLOWS": "WORKFELLOW, a companion at work, a workmate [n]\n",
  "WORKFLOW": "the amount of work to and from an office or employee [n -S]\n",
  "WORKFLOWS": "WORKFLOW, the amount of work to and from an office or employee [n]\n",
  "WORKFOLK": "working people [n -S]\n",
  "WORKFOLKS": "WORKFOLK, working people [n]\n",
  "WORKFORCE": "the number of workers engaged in a particular industry, factory etc. [n -S]\n",
  "WORKFORCES": "WORKFORCE, the number of workers engaged in a particular industry, factory etc. [n]\n",
  "WORKFUL": "industrious [adj]\n",
  "WORKGIRL": "a young woman employed in manual labour [n -S]\n",
  "WORKGIRLS": "WORKGIRL, a young woman employed in manual labour [n]\n",
  "WORKGROUP": "a group of computer users linked by a network [n -S]\n",
  "WORKGROUPS": "WORKGROUP, a group of computer users linked by a network [n]\n",
  "WORKHORSE": "a horse used in a labouring capacity rather than for racing [n -S]\n",
  "WORKHORSES": "WORKHORSE, a horse used in a labouring capacity rather than for racing [n]\n",
  "WORKHOUR": "any of the hours of the day during which work is done [n -S]\n",
  "WORKHOURS": "WORKHOUR, any of the hours of the day during which work is done [n]\n",
  "WORKHOUSE": "(historical) a place for old people who can no longer support themselves [n -S]\n",
  "WORKHOUSES": "WORKHOUSE, (historical) a place for old people who can no longer support themselves [n]\n",
  "WORKING": "a mining excavation [n -S]\n",
  "WORKINGMAN": "a labouring man; a man who earns his daily support by manual labour [n WORKINGMEN]\n",
  "WORKINGMEN": "WORKINGMAN, a labouring man; a man who earns his daily support by manual labour [n]\n",
  "WORKINGS": "WORKING, a mining excavation [n]\n",
  "WORKINGWOMAN": "a workwoman [n WORKINGWOMEN]\n",
  "WORKINGWOMEN": "WORKINGWOMAN, a workwoman [n]\n",
  "WORKLESS": "unemployed [adj]\n",
  "WORKLESSNESS": "the state of being workless [n -ES]\n",
  "WORKLESSNESSES": "WORKLESSNESS, the state of being workless [n]\n",
  "WORKLOAD": "the amount of work assigned to an individual [n -S]\n",
  "WORKLOADS": "WORKLOAD, the amount of work assigned to an individual [n]\n",
  "WORKMAN": "a male worker [n WORKMEN]\n",
  "WORKMANLIER": "WORKMANLY, in the fashion of a workman [adj]\n",
  "WORKMANLIEST": "WORKMANLY, in the fashion of a workman [adj]\n",
  "WORKMANLIKE": "characterized by the skill and efficiency typical of a good workman [adj]\n",
  "WORKMANLY": "in the fashion of a workman [adj WORKMANLIER, WORKMANLIEST]\n",
  "WORKMANSHIP": "the skill of a workman [n -S]\n",
  "WORKMANSHIPS": "WORKMANSHIP, the skill of a workman [n]\n",
  "WORKMASTER": "the performer of any work; a master workman [n -S]\n",
  "WORKMASTERS": "WORKMASTER, the performer of any work; a master workman [n]\n",
  "WORKMATE": "a fellow worker [n -S]\n",
  "WORKMATES": "WORKMATE, a fellow worker [n]\n",
  "WORKMEN": "WORKMAN, a male worker [n]\n",
  "WORKMISTRESS": "an expert (female) worker or craftsperson, overseer or employer [n -ES]\n",
  "WORKMISTRESSES": "WORKMISTRESS, an expert (female) worker or craftsperson, overseer or employer [n]\n",
  "WORKOUT": "a period of physical exercise [n -S]\n",
  "WORKOUTS": "WORKOUT, a period of physical exercise [n]\n",
  "WORKPEOPLE": "people who work [n]\n",
  "WORKPIECE": "a piece of work in progress [n -S]\n",
  "WORKPIECES": "WORKPIECE, a piece of work in progress [n]\n",
  "WORKPLACE": "a place of work [n -S]\n",
  "WORKPLACES": "WORKPLACE, a place of work [n]\n",
  "WORKPRINT": "an unfinished print of cinema film [n -S]\n",
  "WORKPRINTS": "WORKPRINT, an unfinished print of cinema film [n]\n",
  "WORKROOM": "a room in which work is done, also WORKSHOP [n -S]\n",
  "WORKROOMS": "WORKROOM, a room in which work is done, also WORKSHOP [n]\n",
  "WORKS": "WORK, to toil in mind or body [v]\n",
  "WORKSAFE": "(of an internet link etc.) suitable for viewing in the workplace because of an absence of pornographic content [adj]\n",
  "WORKSHEET": "a paper or form on which to detail work planned or performed [n -S]\n",
  "WORKSHEETS": "WORKSHEET, a paper or form on which to detail work planned or performed [n]\n",
  "WORKSHOP": "a room or building where work is done [n -S] / to hold a workshop [v WORKSHOPPED, WORKSHOPPING, WORKSHOPS]\n",
  "WORKSHOPPED": "WORKSHOP, to hold a workshop [v]\n",
  "WORKSHOPPING": "WORKSHOP, to hold a workshop [v]\n",
  "WORKSHOPS": "WORKSHOP, to hold a workshop [v]\n",
  "WORKSHY": "hating or avoiding work; lazy [adj]\n",
  "WORKSITE": "an area where work takes place [n -S]\n",
  "WORKSITES": "WORKSITE, an area where work takes place [n]\n",
  "WORKSOME": "(Caribbean) industrious [adj]\n",
  "WORKSONG": "a song sung while doing physical work [n -S]\n",
  "WORKSONGS": "WORKSONG, a song sung while doing physical work [n]\n",
  "WORKSPACE": "an area set aside for work [n -S]\n",
  "WORKSPACES": "WORKSPACE, an area set aside for work [n]\n",
  "WORKSTATION": "an area with equipment for the performance of a specialized task usually by a single individual [n -S]\n",
  "WORKSTATIONS": "WORKSTATION, an area with equipment for the performance of a specialized task usually by a single individual [n]\n",
  "WORKSTREAM": "any one of the areas of activity into which a company business may be divided [n -S]\n",
  "WORKSTREAMS": "WORKSTREAM, any one of the areas of activity into which a company business may be divided [n]\n",
  "WORKTABLE": "a table for holding working materials and implements; esp. a small table with drawers and other conveniences for needlework, etc. [n -S]\n",
  "WORKTABLES": "WORKTABLE, a table for holding working materials and implements; esp. a small table with drawers and other conveniences for needlework, etc. [n]\n",
  "WORKTOP": "a surface designed for working on [n -S]\n",
  "WORKTOPS": "WORKTOP, a surface designed for working on [n]\n",
  "WORKUP": "an intensive diagnostic study [n -S]\n",
  "WORKUPS": "WORKUP, an intensive diagnostic study [n]\n",
  "WORKWATCHER": "in horse-racing, a tout [n -S]\n",
  "WORKWATCHERS": "WORKWATCHER, in horse-racing, a tout [n]\n",
  "WORKWEAR": "clothing for work [n -S]\n",
  "WORKWEARS": "WORKWEAR, clothing for work [n]\n",
  "WORKWEEK": "the number of hours worked in a week [n -S]\n",
  "WORKWEEKS": "WORKWEEK, the number of hours worked in a week [n]\n",
  "WORKWOMAN": "a female workman [n WORKWOMEN]\n",
  "WORKWOMEN": "WORKWOMAN, a female workman [n]\n",
  "WORLD": "the earth and all its inhabitants [n -S]\n",
  "WORLDBEAT": "popular music from outside the western mainstream [n -S]\n",
  "WORLDBEATS": "WORLDBEAT, popular music from outside the western mainstream [n]\n",
  "WORLDED": "containing worlds [adj]\n",
  "WORLDER": "one who belongs to a specified class, time, domain, or sphere of activity [n -S]\n",
  "WORLDERS": "WORLDER, one who belongs to a specified class, time, domain, or sphere of activity [n]\n",
  "WORLDIE": "something of world-class quality [n WORLDIES]\n",
  "WORLDIES": "WORLDIE, something of world-class quality [n]\n",
  "WORLDLIER": "WORLDLY, pertaining to the world [adj]\n",
  "WORLDLIEST": "WORLDLY, pertaining to the world [adj]\n",
  "WORLDLINESS": "the state of being worldly [n -ES]\n",
  "WORLDLINESSES": "WORLDLINESS, the state of being worldly [n]\n",
  "WORLDLING": "a person engrossed in concerns of the present world [n -S]\n",
  "WORLDLINGS": "WORLDLING, a person engrossed in concerns of the present world [n]\n",
  "WORLDLY": "pertaining to the world [adj WORLDLIER, WORLDLIEST]\n",
  "WORLDS": "WORLD, the earth and all its inhabitants [n]\n",
  "WORLDSCALE": "the scale of freight rates for oil tankers [n -S]\n",
  "WORLDSCALES": "WORLDSCALE, the scale of freight rates for oil tankers [n]\n",
  "WORLDVIEW": "an outlook on the world or life [n -S]\n",
  "WORLDVIEWS": "WORLDVIEW, an outlook on the world or life [n]\n",
  "WORLDWIDE": "all over the world [adj]\n",
  "WORM": "a small, limbless invertebrate [n -S] / to rid of worms [v -ED, -ING, -S]\n",
  "WORMCAST": "a spiral heap of earth left by a burrowing worm [n -S]\n",
  "WORMCASTS": "WORMCAST, a spiral heap of earth left by a burrowing worm [n]\n",
  "WORMED": "WORM, to rid of worms [v]\n",
  "WORMER": "a screw fixed on the end of a rod, for withdrawing the charge or wad from a muzzle-loading gun [n -S]\n",
  "WORMERIES": "WORMERY, a place in which worms are bred [n]\n",
  "WORMERS": "WORMER, a screw fixed on the end of a rod, for withdrawing the charge or wad from a muzzle-loading gun [n]\n",
  "WORMERY": "a place in which worms are bred [n WORMERIES]\n",
  "WORMFLIES": "WORMFLY, a type of fishing fly [n]\n",
  "WORMFLY": "a type of fishing fly [n WORMFLIES]\n",
  "WORMGEAR": "a gear wheel driven by a worm (a rotating shaft with threads) [n -S]\n",
  "WORMGEARS": "WORMGEAR, a gear wheel driven by a worm (a rotating shaft with threads) [n]\n",
  "WORMHOLE": "a hole dug by a worm [n -S]\n",
  "WORMHOLED": "full of wormholes [adj]\n",
  "WORMHOLES": "WORMHOLE, a hole dug by a worm [n]\n",
  "WORMIER": "WORMY, infested with worms [adj]\n",
  "WORMIEST": "WORMY, infested with worms [adj]\n",
  "WORMIL": "a lump in the skin of an animal's back [n -S]\n",
  "WORMILS": "WORMIL, a lump in the skin of an animal's back [n]\n",
  "WORMINESS": "the state of being wormy [n -ES]\n",
  "WORMINESSES": "WORMINESS, the state of being wormy [n]\n",
  "WORMING": "WORM, to rid of worms [v]\n",
  "WORMISH": "like a worm [adj]\n",
  "WORMLIKE": "resembling a worm [adj]\n",
  "WORMROOT": "a medicinal plant root, also PINKROOT [n -S]\n",
  "WORMROOTS": "WORMROOT, a medicinal plant root, also PINKROOT [n]\n",
  "WORMS": "WORM, to rid of worms [v]\n",
  "WORMSEED": "any one of several plants whose seeds have the property of expelling worms from the stomach and intestines [n -S]\n",
  "WORMSEEDS": "WORMSEED, any one of several plants whose seeds have the property of expelling worms from the stomach and intestines [n]\n",
  "WORMWHEEL": "the wheel of a wormgear [n -S]\n",
  "WORMWHEELS": "WORMWHEEL, the wheel of a wormgear [n]\n",
  "WORMWOOD": "the bitter plant Artemisia absinthium, formerly used as a vermifuge [n -S]\n",
  "WORMWOODS": "WORMWOOD, the bitter plant Artemisia absinthium, formerly used as a vermifuge [n]\n",
  "WORMY": "infested with worms [adj WORMIER, WORMIEST]\n",
  "WORN": "WEAR, to turn a ship's stern to windward to alter its course [v]\n",
  "WORNNESS": "the state of being worn [n -ES]\n",
  "WORNNESSES": "WORNNESS, the state of being worn [n]\n",
  "WORRAL": "(Arabic) an Egyptian fork-tongued lizard, also WORREL [n -S]\n",
  "WORRALS": "WORRAL, (Arabic) an Egyptian fork-tongued lizard, also WORREL [n]\n",
  "WORREL": "(Arabic) an Egyptian fork-tongued lizard, also WORRAL [n -S]\n",
  "WORRELS": "WORREL, (Arabic) an Egyptian fork-tongued lizard, also WORRAL [n]\n",
  "WORRICOW": "(Scots) the devil, a hobgoblin, anything frightening, also WIRRICOW, WORRYCOW [n -S]\n",
  "WORRICOWS": "WORRICOW, (Scots) the devil, a hobgoblin, anything frightening, also WIRRICOW, WORRYCOW [n]\n",
  "WORRIED": "WORRY, to cause to be anxious [v]\n",
  "WORRIEDLY": "WORRIED, WORRY, to cause to be anxious [adv]\n",
  "WORRIER": "one who worries [n -S]\n",
  "WORRIERS": "WORRIER, one who worries [n]\n",
  "WORRIES": "WORRY, to cause to be anxious [v]\n",
  "WORRIMENT": "trouble; anxiety; worry [n -S]\n",
  "WORRIMENTS": "WORRIMENT, trouble; anxiety; worry [n]\n",
  "WORRISOME": "causing worry [adj WORRISOMELY]\n",
  "WORRISOMELY": "WORRISOME, causing worry [adv]\n",
  "WORRISOMENESS": "the state of being worrisome [n -ES]\n",
  "WORRISOMENESSES": "WORRISOMENESS, the state of being worrisome [n]\n",
  "WORRIT": "to worry, also WHERRIT [v -ED, -ING, -S]\n",
  "WORRITED": "WORRIT, to worry, also WHERRIT [v]\n",
  "WORRITING": "WORRIT, to worry, also WHERRIT [v]\n",
  "WORRITS": "WORRIT, to worry, also WHERRIT [v]\n",
  "WORRY": "to cause to be anxious [v WORRIED, WORRYING, WORRIES]\n",
  "WORRYCOW": "(Scots) the devil, a hobgoblin, anything frightening, also WIRRICOW, WORRICOW [n -S]\n",
  "WORRYCOWS": "WORRYCOW, (Scots) the devil, a hobgoblin, anything frightening, also WIRRICOW, WORRICOW [n]\n",
  "WORRYGUTS": "(colloquial) someone who worries a lot [n]\n",
  "WORRYING": "the act of worrying [n -S]\n",
  "WORRYINGLY": "WORRYING [adv]\n",
  "WORRYINGS": "WORRYING, the act of worrying [n]\n",
  "WORRYWART": "a person who worries excessively [n -S]\n",
  "WORRYWARTS": "WORRYWART, a person who worries excessively [n]\n",
  "WORSE": "more bad, also WARRE, WAUR [adj] / (obsolete) to defeat, also WORST [v WORSED, WORSING, WORSES]\n",
  "WORSED": "WORSE, (obsolete) to defeat, also WORST [v]\n",
  "WORSEN": "to become worse [v -ED, -ING, -S]\n",
  "WORSENED": "WORSEN, to become worse [v]\n",
  "WORSENESS": "the state of being worse [n -ES]\n",
  "WORSENESSES": "WORSENESS, the state of being worse [n]\n",
  "WORSENING": "the act of becoming worse [n -S]\n",
  "WORSENINGS": "WORSENING, the act of becoming worse [n]\n",
  "WORSENS": "WORSEN, to become worse [v]\n",
  "WORSER": "worse [adj]\n",
  "WORSES": "WORSE, (obsolete) to defeat, also WORST [v]\n",
  "WORSET": "a woollen yarn, also WORSTED [n -S]\n",
  "WORSETS": "WORSET, a woollen yarn, also WORSTED [n]\n",
  "WORSHIP": "to honour as a divine being [v WORSHIPED or WORSHIPPED, WORSHIPING or WORSHIPPING, WORSHIPS]\n",
  "WORSHIPABLE": "capable of being worshipped [adj]\n",
  "WORSHIPED": "WORSHIP, to honour as a divine being [v]\n",
  "WORSHIPER": "one who worships, also WORSHIPPER [n -S]\n",
  "WORSHIPERS": "WORSHIPER, one who worships, also WORSHIPPER [n]\n",
  "WORSHIPFUL": "entitled to worship [adj WORSHIPFULLY]\n",
  "WORSHIPFULLY": "WORSHIPFUL, entitled to worship [adv]\n",
  "WORSHIPFULNESS": "the state of being worshipful [n]\n",
  "WORSHIPING": "WORSHIP, to honour as a divine being [v]\n",
  "WORSHIPLESS": "without worship [adj]\n",
  "WORSHIPPED": "WORSHIP, to honour as a divine being [v]\n",
  "WORSHIPPER": "one who worships, also WORSHIPER [n -S]\n",
  "WORSHIPPERS": "WORSHIPPER, one who worships, also WORSHIPER [n]\n",
  "WORSHIPPING": "WORSHIP, to honour as a divine being [v]\n",
  "WORSHIPS": "WORSHIP, to honour as a divine being [v]\n",
  "WORSING": "WORSE, (obsolete) to defeat, also WORST [v]\n",
  "WORST": "most bad, also WARST, WAURST [adj] / to defeat, also WORSE [v -ED, -ING, -S]\n",
  "WORSTED": "a woollen yarn, also WORSET [n -S]\n",
  "WORSTEDS": "WORSTED, a woollen yarn, also WORSET [n]\n",
  "WORSTING": "WORST, to defeat, also WORSE [v]\n",
  "WORSTS": "WORST, to defeat, also WORSE [v]\n",
  "WORT": "a plant, herb or vegetable [n -S]\n",
  "WORTH": "to happen, befall [v -ED, -ING, -S]\n",
  "WORTHED": "WORTH, to happen, befall [v]\n",
  "WORTHFUL": "(archaic) full of worth; worthy [adj]\n",
  "WORTHIED": "WORTHY, (obsolete) to make worthy, to honour [v]\n",
  "WORTHIER": "WORTHY, full of worth [adj]\n",
  "WORTHIES": "WORTHY, (obsolete) to make worthy, to honour [v]\n",
  "WORTHIEST": "WORTHY, full of worth [adj]\n",
  "WORTHILY": "WORTHY, full of worth [adv]\n",
  "WORTHINESS": "the state of being worthy [n -ES]\n",
  "WORTHINESSES": "WORTHINESS, the state of being worthy [n]\n",
  "WORTHING": "WORTH, to happen, befall [v]\n",
  "WORTHLESS": "without worth [adj WORTHLESSLY]\n",
  "WORTHLESSLY": "WORTHLESS, without worth [adv]\n",
  "WORTHLESSNESS": "the state of being worthless [n -ES]\n",
  "WORTHLESSNESSES": "WORTHLESSNESS, the state of being worthless [n]\n",
  "WORTHS": "WORTH, to happen, befall [v]\n",
  "WORTHWHILE": "being worth the time or effort spent [adj]\n",
  "WORTHWHILENESS": "the state of being worthwhile [n]\n",
  "WORTHY": "full of worth [adj WORTHIER, WORTHIEST, WORTHILY] / (obsolete) to make worthy, to honour [v WORTHIED, WORTHYING, WORTHIES]\n",
  "WORTHYING": "WORTHY, (obsolete) to make worthy, to honour [v]\n",
  "WORTLE": "a perforated plate through which wire is drawn to make thinner, also WHIRTLE [n -S]\n",
  "WORTLES": "WORTLE, a perforated plate through which wire is drawn to make thinner, also WHIRTLE [n]\n",
  "WORTS": "WORT, a plant, herb or vegetable [n]\n",
  "WOS": "WO, (archaic) woe, also WAE [n]\n",
  "WOSBIRD": "whore's bird, whore's child, a vulgar term of abuse [n -S]\n",
  "WOSBIRDS": "WOSBIRD, whore's bird, whore's child, a vulgar term of abuse [n]\n",
  "WOST": "WIT, to know [v]\n",
  "WOT": "(archaic) to know, also WIS, WIST, WIT [v WOTTETH, WOTTING, WOTTED, WOTTEST, WOTS]\n",
  "WOTCHA": "a greeting, developed from what cheer? how are you, also WATCHA, WHATCHA, WOTCHER [interj]\n",
  "WOTCHER": "a greeting, developed from what cheer? how are you, also WATCHA, WHATCHA, WOTCHA [interj]\n",
  "WOTS": "WOT, (archaic) to know, also WIS, WIST, WIT [v]\n",
  "WOTTED": "WOT, (archaic) to know, also WIS, WIST, WIT [v]\n",
  "WOTTEST": "WIT, to know [v]\n",
  "WOTTETH": "WIT, to know [v]\n",
  "WOTTING": "WOT, (archaic) to know, also WIS, WIST, WIT [v]\n",
  "WOUBIT": "a hairy caterpillar, esp. of the tiger moth, also OOBIT, OUBIT, WOOBUT [n -S]\n",
  "WOUBITS": "WOUBIT, a hairy caterpillar, esp. of the tiger moth, also OOBIT, OUBIT, WOOBUT [n]\n",
  "WOULD": "the desired or intended [n -S]\n",
  "WOULDEST": "(archaic) 2nd person past tense singular of would, also WOULDST [v]\n",
  "WOULDS": "WOULD, the desired or intended [n]\n",
  "WOULDST": "(archaic) 2nd person past tense singular of would, also WOULDEST [v]\n",
  "WOUND": "to inflict an injury upon [v -ED, -ING, -S]\n",
  "WOUNDABLE": "capable of being wounded [adj]\n",
  "WOUNDED": "WOUND, to inflict an injury upon [v]\n",
  "WOUNDEDLY": "WOUNDED, WOUND, to inflict an injury upon [adv]\n",
  "WOUNDER": "one who wounds [n -S]\n",
  "WOUNDERS": "WOUNDER, one who wounds [n]\n",
  "WOUNDIER": "WOUNDY, (archaic) excessive [adj]\n",
  "WOUNDIEST": "WOUNDY, (archaic) excessive [adj]\n",
  "WOUNDILY": "WOUNDY, (archaic) excessive [adv]\n",
  "WOUNDING": "inflicting hurt [adj WOUNDINGLY] / the act of wounding [n -S]\n",
  "WOUNDINGLY": "WOUNDING, inflicting hurt [adv]\n",
  "WOUNDINGS": "WOUNDING, the act of wounding [n]\n",
  "WOUNDLESS": "harmless [adj]\n",
  "WOUNDS": "WOUND, to inflict an injury upon [v]\n",
  "WOUNDWORT": "any of several plants popularly held to have wound-healing properties [n -S]\n",
  "WOUNDWORTS": "WOUNDWORT, any of several plants popularly held to have wound-healing properties [n]\n",
  "WOUNDY": "(archaic) excessive [adj WOUNDIER, WOUNDIEST, WOUNDILY]\n",
  "WOURALI": "(Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOORARI [n -S]\n",
  "WOURALIS": "WOURALI, (Caribbean) the plant yielding curare, also OORALI, OURALI, OURARI, URALI, URARI, WOORALI, WOORARA, WOORARI [n]\n",
  "WOVE": "WEAVE, to form by crossing threads [v]\n",
  "WOVEN": "a woven fabric [n -S]\n",
  "WOVENS": "WOVEN, a woven fabric [n]\n",
  "WOW": "to impress or amaze [v -ED, -ING, -S]\n",
  "WOWED": "WOW, to impress or amaze [v]\n",
  "WOWEE": "an interjection, an intensification of wow [interj]\n",
  "WOWF": "(Scots) crazy [adj WOWFER, WOWFEST]\n",
  "WOWFER": "WOWF, (Scots) crazy [adj]\n",
  "WOWFEST": "WOWF, (Scots) crazy [adj]\n",
  "WOWING": "WOW, to impress or amaze [v]\n",
  "WOWS": "WOW, to impress or amaze [v]\n",
  "WOWSER": "(Australian slang) an obtrusively puritanical person [n -S]\n",
  "WOWSERS": "WOWSER, (Australian slang) an obtrusively puritanical person [n]\n",
  "WOX": "WAX, to treat with wax [v]\n",
  "WOXEN": "WAX, to treat with wax [v]\n",
  "WRACK": "to wreck [v -ED, -ING, -S]\n",
  "WRACKED": "WRACK, to wreck [v]\n",
  "WRACKFUL": "destructive, also WRECKFUL [adj]\n",
  "WRACKING": "WRACK, to wreck [v]\n",
  "WRACKS": "WRACK, to wreck [v]\n",
  "WRAITH": "a visible disembodied spirit [n -S]\n",
  "WRAITHLIKE": "like a wraith [adj]\n",
  "WRAITHS": "WRAITH, a visible disembodied spirit [n]\n",
  "WRANG": "(dialect) to wrong [v -ED, -ING, -S]\n",
  "WRANGED": "WRANG, (dialect) to wrong [v]\n",
  "WRANGING": "WRANG, (dialect) to wrong [v]\n",
  "WRANGLE": "to argue noisily [v WRANGLED, WRANGLING, WRANGLES]\n",
  "WRANGLED": "WRANGLE, to argue noisily [v]\n",
  "WRANGLER": "a cattle-herder, a cowboy [n -S]\n",
  "WRANGLERS": "WRANGLER, a cattle-herder, a cowboy [n]\n",
  "WRANGLERSHIP": "the office of wrangler [n -S]\n",
  "WRANGLERSHIPS": "WRANGLERSHIP, the office of wrangler [n]\n",
  "WRANGLES": "WRANGLE, to argue noisily [v]\n",
  "WRANGLESOME": "quarrelsome [adj]\n",
  "WRANGLING": "the act of wrangling [n -S]\n",
  "WRANGLINGS": "WRANGLING, the act of wrangling [n]\n",
  "WRANGS": "WRANG, (dialect) to wrong [v]\n",
  "WRAP": "to enclose [v WRAPT or WRAPPED, WRAPPING, WRAPS]\n",
  "WRAPAROUND": "an article of clothing that wraps round, also WRAPROUND [n -S]\n",
  "WRAPAROUNDS": "WRAPAROUND, an article of clothing that wraps round, also WRAPROUND [n]\n",
  "WRAPOVER": "a skirt that wraps around the body [n -S]\n",
  "WRAPOVERS": "WRAPOVER, a skirt that wraps around the body [n]\n",
  "WRAPPAGE": "the act of covering [n -S]\n",
  "WRAPPAGES": "WRAPPAGE, the act of covering [n]\n",
  "WRAPPED": "WRAP, to enclose [v]\n",
  "WRAPPER": "to put a covering on [v -ED, -ING, -S]\n",
  "WRAPPERED": "WRAPPER, to put a covering on [v]\n",
  "WRAPPERING": "WRAPPER, to put a covering on [v]\n",
  "WRAPPERS": "WRAPPER, to put a covering on [v]\n",
  "WRAPPING": "a type of cover [n -S]\n",
  "WRAPPINGS": "WRAPPING, a type of cover [n]\n",
  "WRAPROUND": "an article of clothing that wraps round, also WRAPAROUND [n -S]\n",
  "WRAPROUNDS": "WRAPROUND, an article of clothing that wraps round, also WRAPAROUND [n]\n",
  "WRAPS": "WRAP, to enclose [v]\n",
  "WRAPT": "WRAP, to enclose [v]\n",
  "WRASSE": "(Cornish) any of several brightly coloured bony fishes [n -S]\n",
  "WRASSES": "WRASSE, (Cornish) any of several brightly coloured bony fishes [n]\n",
  "WRASSLE": "to wrestle, also RASSLE, WARSLE, WARSTLE, WRASTLE, WRAXLE, WRESTLE [v WRASSLED, WRASSLING, WRASSLES]\n",
  "WRASSLED": "WRASSLE, to wrestle, also RASSLE, WARSLE, WARSTLE, WRASTLE, WRAXLE, WRESTLE [v]\n",
  "WRASSLES": "WRASSLE, to wrestle, also RASSLE, WARSLE, WARSTLE, WRASTLE, WRAXLE, WRESTLE [v]\n",
  "WRASSLING": "WRASSLE, to wrestle, also RASSLE, WARSLE, WARSTLE, WRASTLE, WRAXLE, WRESTLE [v]\n",
  "WRAST": "(obsolete) to wrest, also WREST [v -ED, -ING, -S]\n",
  "WRASTED": "WRAST, (obsolete) to wrest, also WREST [v]\n",
  "WRASTING": "WRAST, (obsolete) to wrest, also WREST [v]\n",
  "WRASTLE": "to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRAXLE, WRESTLE [v WRASTLED, WRASTLING, WRASTLES]\n",
  "WRASTLED": "WRASTLE, to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRAXLE, WRESTLE [v]\n",
  "WRASTLES": "WRASTLE, to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRAXLE, WRESTLE [v]\n",
  "WRASTLING": "WRASTLE, to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRAXLE, WRESTLE [v]\n",
  "WRASTS": "WRAST, (obsolete) to wrest, also WREST [v]\n",
  "WRATE": "WRITE, to form characters on a surface with an instrument [v]\n",
  "WRATH": "(obsolete) to make or become angry [v -ED, -ING, -S]\n",
  "WRATHED": "WRATH, (obsolete) to make or become angry [v]\n",
  "WRATHFUL": "extremely angry, also WROTHFUL [adj WRATHFULLY]\n",
  "WRATHFULLY": "WRATHFUL, extremely angry, also WROTHFUL [adv]\n",
  "WRATHFULNESS": "the state of being wrathful [n -ES]\n",
  "WRATHFULNESSES": "WRATHFULNESS, the state of being wrathful [n]\n",
  "WRATHIER": "WRATHY, inclined to wrath [adj]\n",
  "WRATHIEST": "WRATHY, inclined to wrath [adj]\n",
  "WRATHILY": "WRATHY, inclined to wrath [adv]\n",
  "WRATHINESS": "the state of being wrathy, angry [n -ES]\n",
  "WRATHINESSES": "WRATHINESS, the state of being wrathy, angry [n]\n",
  "WRATHING": "WRATH, (obsolete) to make or become angry [v]\n",
  "WRATHLESS": "free from anger or wrath [adj]\n",
  "WRATHS": "WRATH, (obsolete) to make or become angry [v]\n",
  "WRATHY": "inclined to wrath [adj WRATHIER, WRATHIEST, WRATHILY]\n",
  "WRAWL": "(Spenser) of a cat, to caterwaul, also WAUL, WAWL [v -ED, -ING, -S]\n",
  "WRAWLED": "WRAWL, (Spenser) of a cat, to caterwaul, also WAUL, WAWL [v]\n",
  "WRAWLING": "WRAWL, (Spenser) of a cat, to caterwaul, also WAUL, WAWL [v]\n",
  "WRAWLS": "WRAWL, (Spenser) of a cat, to caterwaul, also WAUL, WAWL [v]\n",
  "WRAXLE": "(dialect) to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRASTLE, WRESTLE [v WRAXLED, WRAXLING, WRAXLES]\n",
  "WRAXLED": "WRAXLE, (dialect) to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRASTLE, WRESTLE [v]\n",
  "WRAXLES": "WRAXLE, (dialect) to wrestle, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRASTLE, WRESTLE [v]\n",
  "WRAXLING": "the act of wrestling [n -S]\n",
  "WRAXLINGS": "WRAXLING, the act of wrestling [n]\n",
  "WREAK": "to effect, bring about [v WREAKED or (obsolete) WROKE, YWROKE, WROKEN, WREAKING, WREAKS]\n",
  "WREAKED": "WREAK, to effect, bring about [v]\n",
  "WREAKER": "(archaic) one who wreaks [n -S]\n",
  "WREAKERS": "WREAKER, (archaic) one who wreaks [n]\n",
  "WREAKFUL": "revengeful [adj]\n",
  "WREAKING": "WREAK, to effect, bring about [v]\n",
  "WREAKLESS": "unpunished [adj]\n",
  "WREAKS": "WREAK, to effect, bring about [v]\n",
  "WREATH": "a garland of flowers [n -S]\n",
  "WREATHE": "to shape into a wreath, also WRETHE [v WREATHED, WREATHING, WREATHES]\n",
  "WREATHED": "WREATHE, to shape into a wreath, also WRETHE [v]\n",
  "WREATHEN": "wreathed [adj]\n",
  "WREATHER": "one who wreathes [n -S]\n",
  "WREATHERS": "WREATHER, one who wreathes [n]\n",
  "WREATHES": "WREATHE, to shape into a wreath, also WRETHE [v]\n",
  "WREATHIER": "WREATHY, like a wreath [adj]\n",
  "WREATHIEST": "WREATHY, like a wreath [adj]\n",
  "WREATHING": "WREATHE, to shape into a wreath, also WRETHE [v]\n",
  "WREATHLESS": "destitute of a wreath [adj]\n",
  "WREATHLIKE": "like a wreath [adj]\n",
  "WREATHS": "WREATH, a garland of flowers [n]\n",
  "WREATHY": "like a wreath [adj WREATHIER, WREATHIEST]\n",
  "WRECK": "to cause the ruin of, also WRACK [v -ED, -ING, -S]\n",
  "WRECKAGE": "the act of wrecking [n -S]\n",
  "WRECKAGES": "WRECKAGE, the act of wrecking [n]\n",
  "WRECKED": "WRECK, to cause the ruin of, also WRACK [v]\n",
  "WRECKER": "one that wrecks [n -S]\n",
  "WRECKERS": "WRECKER, one that wrecks [n]\n",
  "WRECKFISH": "a stone bass [n -ES]\n",
  "WRECKFISHES": "WRECKFISH, a stone bass [n]\n",
  "WRECKFUL": "destructive, also WRACKFUL [adj]\n",
  "WRECKING": "the occupation of salvaging wrecked objects [n -S]\n",
  "WRECKINGS": "WRECKING, the occupation of salvaging wrecked objects [n]\n",
  "WRECKMASTER": "a person taking charge of a disabled ship or train and its cargo or freight [n -S]\n",
  "WRECKMASTERS": "WRECKMASTER, a person taking charge of a disabled ship or train and its cargo or freight [n]\n",
  "WRECKS": "WRECK, to cause the ruin of, also WRACK [v]\n",
  "WREN": "a small songbird [n -S]\n",
  "WRENCH": "to wrest violently [v -ED, -ING, -ES]\n",
  "WRENCHED": "WRENCH, to wrest violently [v]\n",
  "WRENCHER": "one who wrenches [n -S]\n",
  "WRENCHERS": "WRENCHER, one who wrenches [n]\n",
  "WRENCHES": "WRENCH, to wrest violently [v]\n",
  "WRENCHING": "twisting suddenly and forcibly [adj WRENCHINGLY] / the act of wrenching [n -S]\n",
  "WRENCHINGLY": "WRENCHING, twisting suddenly and forcibly [adv]\n",
  "WRENCHINGS": "WRENCHING, the act of wrenching [n]\n",
  "WRENS": "WREN, a small songbird [n]\n",
  "WRENTIT": "a long-tailed North American bird [n -S]\n",
  "WRENTITS": "WRENTIT, a long-tailed North American bird [n]\n",
  "WREST": "to take away by force, also WRAST [v -ED, -ING, -S]\n",
  "WRESTED": "WREST, to take away by force, also WRAST [v]\n",
  "WRESTER": "one who wrests [n -S]\n",
  "WRESTERS": "WRESTER, one who wrests [n]\n",
  "WRESTING": "WREST, to take away by force, also WRAST [v]\n",
  "WRESTLE": "to engage in a type of hand-to-hand contest, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v WRESTLED, WRESTLING, WRESTLES]\n",
  "WRESTLED": "WRESTLE, to engage in a type of hand-to-hand contest, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WRESTLER": "one who takes part in hand to hand contests, also WARSLER, WARSTLER [n -S]\n",
  "WRESTLERS": "WRESTLER, one who takes part in hand to hand contests, also WARSLER, WARSTLER [n]\n",
  "WRESTLES": "WRESTLE, to engage in a type of hand-to-hand contest, also RASSLE, WARSLE, WARSTLE, WRASSLE, WRASTLE, WRAXLE [v]\n",
  "WRESTLING": "the sport of wrestling [n -S]\n",
  "WRESTLINGS": "WRESTLING, the sport of wrestling [n]\n",
  "WRESTS": "WREST, to take away by force, also WRAST [v]\n",
  "WRETCH": "a pitiable person [n -ES]\n",
  "WRETCHED": "miserable [adj WRETCHEDER, WRETCHEDEST, WRETCHEDLY]\n",
  "WRETCHEDER": "WRETCHED, miserable [adj]\n",
  "WRETCHEDEST": "WRETCHED, miserable [adj]\n",
  "WRETCHEDLY": "WRETCHED, miserable [adv]\n",
  "WRETCHEDNESS": "the state of being wretched [n -ES]\n",
  "WRETCHEDNESSES": "WRETCHEDNESS, the state of being wretched [n]\n",
  "WRETCHES": "WRETCH, a pitiable person [n]\n",
  "WRETHE": "(Spenser) to shape into a wreath, to wreathe [v WRETHED, WRETHING, WRETHES]\n",
  "WRETHED": "WRETHE, (Spenser) to shape into a wreath, to wreathe [v]\n",
  "WRETHES": "WRETHE, (Spenser) to shape into a wreath, to wreathe [v]\n",
  "WRETHING": "WRETHE, (Spenser) to shape into a wreath, to wreathe [v]\n",
  "WRICK": "to twist or sprain [v -ED, -ING, -S]\n",
  "WRICKED": "WRICK, to twist or sprain [v]\n",
  "WRICKING": "WRICK, to twist or sprain [v]\n",
  "WRICKS": "WRICK, to twist or sprain [v]\n",
  "WRIED": "WRY, to give a twist to [v]\n",
  "WRIER": "WRY, twisted [adj]\n",
  "WRIES": "WRY, to give a twist to [v]\n",
  "WRIEST": "WRY, twisted [adj]\n",
  "WRIGGLE": "to twist and turn [v WRIGGLED, WRIGGLING, WRIGGLES]\n",
  "WRIGGLED": "WRIGGLE, to twist and turn [v]\n",
  "WRIGGLER": "one who wriggles [n -S]\n",
  "WRIGGLERS": "WRIGGLER, one who wriggles [n]\n",
  "WRIGGLES": "WRIGGLE, to twist and turn [v]\n",
  "WRIGGLIER": "WRIGGLY, wriggling [adj]\n",
  "WRIGGLIEST": "WRIGGLY, wriggling [adj]\n",
  "WRIGGLING": "the act of wriggling [n -S]\n",
  "WRIGGLINGS": "WRIGGLING, the act of wriggling [n]\n",
  "WRIGGLY": "wriggling [adj WRIGGLIER, WRIGGLIEST]\n",
  "WRIGHT": "a maker; a repairer [n -S]\n",
  "WRIGHTS": "WRIGHT, a maker; a repairer [n]\n",
  "WRING": "to twist so as to compress [v WRINGED, WRUNG, WRINGING, WRINGS]\n",
  "WRINGED": "WRING, to twist so as to compress [v]\n",
  "WRINGER": "a machine for forcing water from wet clothes [n -S]\n",
  "WRINGERS": "WRINGER, a machine for forcing water from wet clothes [n]\n",
  "WRINGING": "WRING, to twist so as to compress [v]\n",
  "WRINGS": "WRING, to twist so as to compress [v]\n",
  "WRINKLE": "to crease [v WRINKLED, WRINKLING, WRINKLES]\n",
  "WRINKLED": "WRINKLE, to crease [v]\n",
  "WRINKLELESS": "without wrinkles [adj]\n",
  "WRINKLES": "WRINKLE, to crease [v]\n",
  "WRINKLIE": "(colloquial) an old person, also WRINKLY [n -S]\n",
  "WRINKLIER": "WRINKLY, wrinkled [adj]\n",
  "WRINKLIES": "WRINKLY, an old person [n]\n",
  "WRINKLIEST": "WRINKLY, wrinkled [adj]\n",
  "WRINKLING": "WRINKLE, to crease [v]\n",
  "WRINKLY": "wrinkled [adj WRINKLIER, WRINKLIEST] / an old person [n WRINKLIES]\n",
  "WRIST": "the junction between the hand and forearm [n -S] / in ice-hockey, to sweep the puck alongside the ice before shooting [v -ED, -ING, -S]\n",
  "WRISTBAND": "a band worn round the wrist e.g. to soak up sweat [n -S]\n",
  "WRISTBANDS": "WRISTBAND, a band worn round the wrist e.g. to soak up sweat [n]\n",
  "WRISTED": "WRIST, in ice-hockey, to sweep the puck alongside the ice before shooting [v]\n",
  "WRISTER": "a type of shot in hockey [n -S]\n",
  "WRISTERS": "WRISTER, a type of shot in hockey [n]\n",
  "WRISTIER": "WRISTY, making extensive use of the wrists [adj]\n",
  "WRISTIEST": "WRISTY, making extensive use of the wrists [adj]\n",
  "WRISTING": "WRIST, in ice-hockey, to sweep the puck alongside the ice before shooting [v]\n",
  "WRISTLET": "a wrist band [n -S]\n",
  "WRISTLETS": "WRISTLET, a wrist band [n]\n",
  "WRISTLOCK": "a wrestling hold involving a lock on the wrist [n -S]\n",
  "WRISTLOCKS": "WRISTLOCK, a wrestling hold involving a lock on the wrist [n]\n",
  "WRISTS": "WRIST, the junction between the hand and forearm [n]\n",
  "WRISTWATCH": "a small watch that is attached to a bracelet or strap and is worn around the wrist [n -ES]\n",
  "WRISTWATCHES": "WRISTWATCH, a small watch that is attached to a bracelet or strap and is worn around the wrist [n]\n",
  "WRISTY": "making extensive use of the wrists [adj WRISTIER, WRISTIEST]\n",
  "WRIT": "a written legal order [n -S]\n",
  "WRITABLE": "capable of being expressed in writing [adj]\n",
  "WRITATIVE": "characterized by an inclination to write [adj]\n",
  "WRITE": "to form characters on a surface with an instrument [v WROTE or (obsolete) WRATE or WRIT, WRITTEN, WRITING, WRITES]\n",
  "WRITEABLE": "that can be written, also WRITABLE [adj]\n",
  "WRITEDOWN": "a reduction in the estimated or nominal value of an asset [n -S]\n",
  "WRITEDOWNS": "WRITEDOWN, a reduction in the estimated or nominal value of an asset [n]\n",
  "WRITEOFF": "an uncollectible debt that is cancelled [n -S]\n",
  "WRITEOFFS": "WRITEOFF, an uncollectible debt that is cancelled [n]\n",
  "WRITER": "one that writes [n -S]\n",
  "WRITERESS": "a female writer [n -ES]\n",
  "WRITERESSES": "WRITERESS, a female writer [n]\n",
  "WRITERLIER": "WRITERLY, characteristic of a writer [adj]\n",
  "WRITERLIEST": "WRITERLY, characteristic of a writer [adj]\n",
  "WRITERLY": "characteristic of a writer [adj WRITERLIER, WRITERLIEST]\n",
  "WRITERS": "WRITER, one that writes [n]\n",
  "WRITERSHIP": "the office of a writer [n -S]\n",
  "WRITERSHIPS": "WRITERSHIP, the office of a writer [n]\n",
  "WRITES": "WRITE, to form characters on a surface with an instrument [v]\n",
  "WRITHE": "to squirm or twist in pain [v WRITHED, WRITHING, WRITHES]\n",
  "WRITHED": "WRITHE, to squirm or twist in pain [v]\n",
  "WRITHEN": "(archaic) twisted, convoluted, also WRYTHEN [adj]\n",
  "WRITHER": "one that writhes [n -S]\n",
  "WRITHERS": "WRITHER, one that writhes [n]\n",
  "WRITHES": "WRITHE, to squirm or twist in pain [v]\n",
  "WRITHING": "twisting, squirming [adj WRITHINGLY] / the act of writhing [n -S]\n",
  "WRITHINGLY": "WRITHING, twisting, squirming [adv]\n",
  "WRITHINGS": "WRITHING, the act of writhing [n]\n",
  "WRITHLED": "(archaic) shrivelled [adj]\n",
  "WRITING": "a written composition [n -S]\n",
  "WRITINGS": "WRITING, a written composition [n]\n",
  "WRITS": "WRIT, a written legal order [n]\n",
  "WRITTEN": "WRITE, to form characters on a surface with an instrument [v]\n",
  "WRIZLED": "(Spenser) wrinkled [adj]\n",
  "WROATH": "(Shakespeare) a misfortune [n -S]\n",
  "WROATHS": "WROATH, (Shakespeare) a misfortune [n]\n",
  "WROKE": "WREAK, to effect, bring about [v]\n",
  "WROKEN": "WREAK, to effect, bring about [v]\n",
  "WRONG": "not according to what is right, proper, or correct [adj WRONGER, WRONGEST, WRONGLY] / to treat injuriously or unjustly [v -ED, -ING, -S]\n",
  "WRONGDOER": "one who does wrong [n -S]\n",
  "WRONGDOERS": "WRONGDOER, one who does wrong [n]\n",
  "WRONGDOING": "evil or improper behavior or action [n -S]\n",
  "WRONGDOINGS": "WRONGDOING, evil or improper behavior or action [n]\n",
  "WRONGED": "WRONG, to treat injuriously or unjustly [v]\n",
  "WRONGER": "a person who wrongs another [n -S]\n",
  "WRONGERS": "WRONGER, a person who wrongs another [n]\n",
  "WRONGEST": "WRONG, not according to what is right, proper, or correct [adj]\n",
  "WRONGFUL": "wrong [adj WRONGFULLY]\n",
  "WRONGFULLY": "WRONGFUL, wrong [adv]\n",
  "WRONGFULNESS": "the state of being wrongful [n -ES]\n",
  "WRONGFULNESSES": "WRONGFULNESS, the state of being wrongful [n]\n",
  "WRONGHEADED": "stubborn in adherence to wrong opinion or principles [adj WRONGHEADEDLY]\n",
  "WRONGHEADEDLY": "WRONGHEADED, stubborn in adherence to wrong opinion or principles [adv]\n",
  "WRONGHEADEDNESS": "the state of being wrongheaded [n]\n",
  "WRONGING": "WRONG, to treat injuriously or unjustly [v]\n",
  "WRONGLY": "WRONG, not according to what is right, proper, or correct [adv]\n",
  "WRONGNESS": "the state of being wrong [n -ES]\n",
  "WRONGNESSES": "WRONGNESS, the state of being wrong [n]\n",
  "WRONGOUS": "unjust; wrongful [adj WRONGOUSLY]\n",
  "WRONGOUSLY": "WRONGOUS, unjust; wrongful [adv]\n",
  "WRONGS": "WRONG, to treat injuriously or unjustly [v]\n",
  "WROOT": "(obsolete) to turn up with the snout [v -ED, -ING, -S]\n",
  "WROOTED": "WROOT, (obsolete) to turn up with the snout [v]\n",
  "WROOTING": "WROOT, (obsolete) to turn up with the snout [v]\n",
  "WROOTS": "WROOT, (obsolete) to turn up with the snout [v]\n",
  "WROTE": "WRITE, to form characters on a surface with an instrument [v]\n",
  "WROTH": "wrathful, also WROTHFUL [adj]\n",
  "WROTHFUL": "wrathful, also WROTH [adj]\n",
  "WROUGHT": "WORK, to toil in mind or body [v]\n",
  "WRUNG": "WRING, to twist so as to compress [v]\n",
  "WRY": "twisted [adj WRIER or WRYER, WRIEST or WRYEST] / to give a twist to [v WRIED, WRYING, WRIES]\n",
  "WRYBILL": "a New Zealand bird related to the plovers [n -S]\n",
  "WRYBILLS": "WRYBILL, a New Zealand bird related to the plovers [n]\n",
  "WRYER": "WRY, twisted [adj]\n",
  "WRYEST": "WRY, twisted [adj]\n",
  "WRYING": "WRY, to give a twist to [v]\n",
  "WRYLY": "WRY, twisted [adv]\n",
  "WRYNECK": "either of two birds of the genus Jynx, characterized by their habit of twisting and writhing the neck when disturbed [n -S]\n",
  "WRYNECKS": "WRYNECK, either of two birds of the genus Jynx, characterized by their habit of twisting and writhing the neck when disturbed [n]\n",
  "WRYNESS": "the quality of being wry [n -ES]\n",
  "WRYNESSES": "WRYNESS, the quality of being wry [n]\n",
  "WRYTHEN": "(archaic) twisted, convoluted, also WRITHEN [adj]\n",
  "WUD": "(Scots) to load with wood [v WUDDED, WUDDING, WUDS]\n",
  "WUDDED": "WUD, (Scots) to load with wood [v]\n",
  "WUDDIES": "WUDDY, a large loop at the end of a rope [n]\n",
  "WUDDING": "WUD, (Scots) to load with wood [v]\n",
  "WUDDY": "a large loop at the end of a rope [n WUDDIES]\n",
  "WUDJULA": "(Native Australian) a non-aboriginal person [n -S]\n",
  "WUDJULAS": "WUDJULA, (Native Australian) a non-aboriginal person [n]\n",
  "WUDS": "WUD, (Scots) to load with wood [v]\n",
  "WUDU": "(Arabic) in Islam, ritual washing before daily prayer [n -S]\n",
  "WUDUS": "WUDU, (Arabic) in Islam, ritual washing before daily prayer [n]\n",
  "WUKKAS": "(Australian slang) in the phrase no wukkas, no worries ('no wukking furries') [n]\n",
  "WULFENITE": "a molybdate of lead [n -S]\n",
  "WULFENITES": "WULFENITE, a molybdate of lead [n]\n",
  "WULL": "(dialect) to will [v -ED, -ING, -S]\n",
  "WULLED": "WULL, (dialect) to will [v]\n",
  "WULLING": "WULL, (dialect) to will [v]\n",
  "WULLS": "WULL, (dialect) to will [v]\n",
  "WUNDERKIND": "(German) a child prodigy [n WUNDERKINDER or WUNDERKINDS]\n",
  "WUNDERKINDER": "WUNDERKIND, (German) a child prodigy [n]\n",
  "WUNDERKINDS": "WUNDERKIND, (German) a child prodigy [n]\n",
  "WUNNER": "something that is one of its kind, also ONER [n -S]\n",
  "WUNNERS": "WUNNER, something that is one of its kind, also ONER [n]\n",
  "WURLEY": "(Native Australian) a nest; an aboriginal hut, also WURLIE [n WURLEYS or WURLIES]\n",
  "WURLEYS": "WURLEY, (Native Australian) a nest; an aboriginal hut, also WURLIE [n]\n",
  "WURLIE": "(Native Australian) a nest; an aboriginal hut, also WURLEY [n -S]\n",
  "WURLIES": "WURLIE, (Native Australian) a nest; an aboriginal hut, also WURLEY [n]\n",
  "WURST": "(German) a large sausage [n -S]\n",
  "WURSTS": "WURST, (German) a large sausage [n]\n",
  "WURTZITE": "sulphide of zinc [n -S]\n",
  "WURTZITES": "WURTZITE, sulphide of zinc [n]\n",
  "WURZEL": "(German) a variety of beet [n -S]\n",
  "WURZELS": "WURZEL, (German) a variety of beet [n]\n",
  "WUS": "a Welsh term used in addressing a companion [n -ES]\n",
  "WUSES": "WUS, a Welsh term used in addressing a companion [n]\n",
  "WUSHU": "(Chinese) the Chinese martial arts [n -S]\n",
  "WUSHUS": "WUSHU, (Chinese) the Chinese martial arts [n]\n",
  "WUSS": "a wimp, also WOOSE [n -ES]\n",
  "WUSSES": "WUSS, a wimp, also WOOSE [n]\n",
  "WUSSIER": "WUSSY, wimpish [adj]\n",
  "WUSSIES": "WUSSY, a wimp [n]\n",
  "WUSSIEST": "WUSSY, wimpish [adj]\n",
  "WUSSY": "wimpish [adj WUSSIER, WUSSIEST] / a wimp [n WUSSIES]\n",
  "WUTHER": "to move swiftly or with force, also WHITHER [v -ED, -ING, -S]\n",
  "WUTHERED": "WUTHER, to move swiftly or with force, also WHITHER [v]\n",
  "WUTHERING": "WUTHER, to move swiftly or with force, also WHITHER [v]\n",
  "WUTHERS": "WUTHER, to move swiftly or with force, also WHITHER [v]\n",
  "WUXIA": "(Chinese) a genre of Chinese fiction involving the adventures of sword-wielding heroes [n -S]\n",
  "WUXIAS": "WUXIA, (Chinese) a genre of Chinese fiction involving the adventures of sword-wielding heroes [n]\n",
  "WUZ": "a nonstandard spelling of was, representing dialect or informal pronunciation [v]\n",
  "WUZZLE": "(US) to jumble [v WUZZLED, WUZZLING, WUZZLES]\n",
  "WUZZLED": "WUZZLE, (US) to jumble [v]\n",
  "WUZZLES": "WUZZLE, (US) to jumble [v]\n",
  "WUZZLING": "WUZZLE, (US) to jumble [v]\n",
  "WYANDOTTE": "(Native American) a breed of domestic fowl, of American origin [n -S]\n",
  "WYANDOTTES": "WYANDOTTE, (Native American) a breed of domestic fowl, of American origin [n]\n",
  "WYCH": "a tree with pliant branches, as in wych elm, also WICH [n -ES]\n",
  "WYCHES": "WYCH, a tree with pliant branches, as in wych elm, also WICH [n]\n",
  "WYE": "the letter Y [n -S]\n",
  "WYES": "WYE, the letter Y [n]\n",
  "WYLE": "to beguile, also WILE [v WYLED, WYLING, WYLES]\n",
  "WYLED": "WYLE, to beguile, also WILE [v]\n",
  "WYLES": "WYLE, to beguile, also WILE [v]\n",
  "WYLIECOAT": "(Scots) a flannel undervest or petticoat [n -S]\n",
  "WYLIECOATS": "WYLIECOAT, (Scots) a flannel undervest or petticoat [n]\n",
  "WYLING": "WYLE, to beguile, also WILE [v]\n",
  "WYN": "a rune, having the value of modern English W, also WYNN [n -S]\n",
  "WYND": "a narrow alley [n -S]\n",
  "WYNDS": "WYND, a narrow alley [n]\n",
  "WYNN": "a rune, having the value of modern English W, also WYN [n -S]\n",
  "WYNNS": "WYNN, a rune, having the value of modern English W, also WYN [n]\n",
  "WYNS": "WYN, a rune, having the value of modern English W, also WYNN [n]\n",
  "WYSIWYG": "denoting the text on a computer screen that exactly corresponds to the text on a printout [adj]\n",
  "WYTE": "(Scots) to blame, lay the blame on, also WIGHT, WITE [v WYTED, WYTING, WYTES]\n",
  "WYTED": "WYTE, (Scots) to blame, lay the blame on, also WIGHT, WITE [v]\n",
  "WYTES": "WYTE, (Scots) to blame, lay the blame on, also WIGHT, WITE [v]\n",
  "WYTING": "WYTE, (Scots) to blame, lay the blame on, also WIGHT, WITE [v]\n",
  "WYVERN": "in heraldry, a dragon with wings, the tail of a snake and two legs, also WIVER, WIVERN [n -S]\n",
  "WYVERNS": "WYVERN, in heraldry, a dragon with wings, the tail of a snake and two legs, also WIVER, WIVERN [n]\n",
  "XANTHAM": "a gum produced by the culture fermentation of glucose, used as a stabilizer, also XANTHAN [n -S]\n",
  "XANTHAMS": "XANTHAM, a gum produced by the culture fermentation of glucose, used as a stabilizer, also XANTHAN [n]\n",
  "XANTHAN": "a gum produced by culture fermentation of glucose, used as a stabilizer, also XANTHAM [n -S]\n",
  "XANTHANS": "XANTHAN, a gum produced by culture fermentation of glucose, used as a stabilizer, also XANTHAM [n]\n",
  "XANTHATE": "a salt of xanthic acid [n -S]\n",
  "XANTHATES": "XANTHATE, a salt of xanthic acid [n]\n",
  "XANTHATION": "the formation of a xanthate, a salt of xanthic acid [n -S]\n",
  "XANTHATIONS": "XANTHATION, the formation of a xanthate, a salt of xanthic acid [n]\n",
  "XANTHEIN": "a soluble yellow colouring [n -S]\n",
  "XANTHEINS": "XANTHEIN, a soluble yellow colouring [n]\n",
  "XANTHENE": "a white crystalline compound of carbon, hydrogen and oxygen, from which dyestuffs are derived [n -S]\n",
  "XANTHENES": "XANTHENE, a white crystalline compound of carbon, hydrogen and oxygen, from which dyestuffs are derived [n]\n",
  "XANTHIC": "having a yellow tint [adj]\n",
  "XANTHIN": "a white substance, structurally related to uric acid, found in muscle tissue, the liver and other organs, also XANTHINE [n -S]\n",
  "XANTHINE": "a white substance, structurally related to uric acid, found in muscle tissue, the liver and other organs, also XANTHIN [n -S]\n",
  "XANTHINES": "XANTHINE, a white substance, structurally related to uric acid, found in muscle tissue, the liver and other organs, also XANTHIN [n]\n",
  "XANTHINS": "XANTHIN, a white substance, structurally related to uric acid, found in muscle tissue, the liver and other organs, also XANTHINE [n]\n",
  "XANTHISM": "a condition of skin, fur or feathers in which yellow coloration predominates [n -S]\n",
  "XANTHISMS": "XANTHISM, a condition of skin, fur or feathers in which yellow coloration predominates [n]\n",
  "XANTHOCHROIA": "yellowness of the skin [n -S]\n",
  "XANTHOCHROIAS": "XANTHOCHROIA, yellowness of the skin [n]\n",
  "XANTHOCHROIC": "exhibiting xanthochroism, a condition in which all pigments other than yellow disappear, also XANTHOCHROOUS [adj]\n",
  "XANTHOCHROID": "a blond-haired and blue eyed person with fair white skin [n -S]\n",
  "XANTHOCHROIDS": "XANTHOCHROID, a blond-haired and blue eyed person with fair white skin [n]\n",
  "XANTHOCHROISM": "a condition in which all skin pigments except yellow disappear [n -S]\n",
  "XANTHOCHROISMS": "XANTHOCHROISM, a condition in which all skin pigments except yellow disappear [n]\n",
  "XANTHOCHROMIA": "any yellowish discoloration, esp. of the cerebrospinal fluid [n -S]\n",
  "XANTHOCHROMIAS": "XANTHOCHROMIA, any yellowish discoloration, esp. of the cerebrospinal fluid [n]\n",
  "XANTHOCHROOUS": "exhibiting xanthochroism, a condition in which all pigments other than yellow disappear, also XANTHOCHROIC [adj]\n",
  "XANTHOMA": "a skin disease marked by the development of irregular yellowish patches upon the skin, esp. upon the eyelids [n XANTHOMAS or XANTHOMATA]\n",
  "XANTHOMAS": "XANTHOMA, a skin disease marked by the development of irregular yellowish patches upon the skin, esp. upon the eyelids [n]\n",
  "XANTHOMATA": "XANTHOMA, a skin disease marked by the development of irregular yellowish patches upon the skin, esp. upon the eyelids [n]\n",
  "XANTHOMATOUS": "of or like a xanthoma, a skin disease marked by the development or irregular yellowish patches upon the skin [adj]\n",
  "XANTHOMELANOUS": "applied by Huxley to members of the human race with black hair and yellow or olive skins [adj]\n",
  "XANTHONE": "a ketone analogue of xanthene which forms the basis of various natural pigments [n -S]\n",
  "XANTHONES": "XANTHONE, a ketone analogue of xanthene which forms the basis of various natural pigments [n]\n",
  "XANTHOPHYL": "a yellow carotenoid pigment found with chlorophyll in green plants and in egg yolks, also XANTHOPHYLL [n -S]\n",
  "XANTHOPHYLL": "a yellow carotenoid pigment found with chlorophyll in green plants and in egg yolks, also XANTHOPHYL [n -S]\n",
  "XANTHOPHYLLOUS": "like a xanthophyll, a yellow carotenoid pigment found with chlorophyll in green plants and in egg yolks [adj]\n",
  "XANTHOPHYLLS": "XANTHOPHYLL, a yellow carotenoid pigment found with chlorophyll in green plants and in egg yolks, also XANTHOPHYL [n]\n",
  "XANTHOPHYLS": "XANTHOPHYL, a yellow carotenoid pigment found with chlorophyll in green plants and in egg yolks, also XANTHOPHYLL [n]\n",
  "XANTHOPSIA": "a visual condition where things appear yellow [n -S]\n",
  "XANTHOPSIAS": "XANTHOPSIA, a visual condition where things appear yellow [n]\n",
  "XANTHOPTERIN": "a yellow pigment obtainable from the wings of yellow butterflies and the urine of mammals, also XANTHOPTERINE [n -S]\n",
  "XANTHOPTERINE": "a yellow pigment obtainable from the wings of yellow butterflies and the urine of mammals, also XANTHOPTERIN [n -S]\n",
  "XANTHOPTERINES": "XANTHOPTERINE, a yellow pigment obtainable from the wings of yellow butterflies and the urine of mammals, also XANTHOPTERIN [n]\n",
  "XANTHOPTERINS": "XANTHOPTERIN, a yellow pigment obtainable from the wings of yellow butterflies and the urine of mammals, also XANTHOPTERINE [n]\n",
  "XANTHOUS": "yellow- or red-haired; yellow-skinned [adj]\n",
  "XANTHOXYL": "a plant of a genus of the rue family found in Brazil, in particular the prickly-ash or Hercules club, also ZANTHOXYL, ZANTHOXYLUM [n -S]\n",
  "XANTHOXYLS": "XANTHOXYL, a plant of a genus of the rue family found in Brazil, in particular the prickly-ash or Hercules club, also ZANTHOXYL, ZANTHOXYLUM [n]\n",
  "XEBEC": "a small, three-masted Mediterranean vessel with both square and triangular sails, also ZEBEC, ZEBECK [n -S]\n",
  "XEBECS": "XEBEC, a small, three-masted Mediterranean vessel with both square and triangular sails, also ZEBEC, ZEBECK [n]\n",
  "XED": "crossed out (past tense of verb to x, of which the present participle is x'ing) [v]\n",
  "XENARTHRAL": "having additional facets on the dorsolumbar vertebrae, like sloths, anteaters and armadillos [adj]\n",
  "XENIA": "the effect on a hybrid strain produced by transferring pollen from one strain to the seed of another strain [n -S]\n",
  "XENIAL": "of or concerning hospitality towards guests [adj]\n",
  "XENIAS": "XENIA, the effect on a hybrid strain produced by transferring pollen from one strain to the seed of another strain [n]\n",
  "XENIC": "of a culture medium, growing with unknown other microbiota [adj]\n",
  "XENIUM": "a gift made to a guest or ambassador; any compulsory gift [n XENIA]\n",
  "XENOBIOTIC": "denoting or relating to a substance foreign to or not rightly found in a body [adj] / a xenobiotic substance or item [n -S]\n",
  "XENOBIOTICS": "XENOBIOTIC, a xenobiotic substance or item [n]\n",
  "XENOBLAST": "a type of mineral deposit [n -S]\n",
  "XENOBLASTS": "XENOBLAST, a type of mineral deposit [n]\n",
  "XENOCRYST": "a crystal or mineral grain which has been taken in by magma during its upward flow [n -S]\n",
  "XENOCRYSTS": "XENOCRYST, a crystal or mineral grain which has been taken in by magma during its upward flow [n]\n",
  "XENODIAGNOSES": "XENODIAGNOSIS, the detection of a parasite (as of humans) by feeding a suitable intermediate host (as an insect) on supposedly infected material (as blood) and later examining the host for the parasite [n]\n",
  "XENODIAGNOSIS": "the detection of a parasite (as of humans) by feeding a suitable intermediate host (as an insect) on supposedly infected material (as blood) and later examining the host for the parasite [n XENODIAGNOSES]\n",
  "XENODIAGNOSTIC": "relating to xenodiagnosis [adj]\n",
  "XENODOCHIUM": "a building for the reception of strangers, e.g. a guesthouse in a monastery [n -S]\n",
  "XENODOCHIUMS": "XENODOCHIUM, a building for the reception of strangers, e.g. a guesthouse in a monastery [n]\n",
  "XENOGAMIES": "XENOGAMY, cross-fertilization [n]\n",
  "XENOGAMOUS": "relating to xenogamy, cross-fertilization [adj]\n",
  "XENOGAMY": "cross-fertilization [n XENOGAMIES]\n",
  "XENOGENEIC": "descended from a member of another species [adj]\n",
  "XENOGENESES": "XENOGENESIS, the supposed production of offspring totally different from the parents, also XENOGENY [n]\n",
  "XENOGENESIS": "the supposed production of offspring totally different from the parents, also XENOGENY [n XENOGENESES]\n",
  "XENOGENETIC": "relating to xenogeny, the supposed production of offspring totally different from the parents, also XENOGENIC [adj]\n",
  "XENOGENIC": "relating to xenogeny, the supposed production of offspring totally different from the parents, also XENOGENETIC [adj]\n",
  "XENOGENIES": "XENOGENY, the production of offspring totally different from the parent [n]\n",
  "XENOGENOUS": "due to an outside cause [adj]\n",
  "XENOGENY": "the production of offspring totally different from the parent [n XENOGENIES]\n",
  "XENOGLOSSIA": "a person's knowledge of a language never studied, also XENOGLOSSY [n -S]\n",
  "XENOGLOSSIAS": "XENOGLOSSIA, a person's knowledge of a language never studied, also XENOGLOSSY [n]\n",
  "XENOGLOSSIES": "XENOGLOSSY, a person's knowledge of a language never studied, also XENOGLOSSIA [n]\n",
  "XENOGLOSSY": "a person's knowledge of a language never studied, also XENOGLOSSIA [n XENOGLOSSIES]\n",
  "XENOGRAFT": "a graft of tissue between individuals of different species [n -S]\n",
  "XENOGRAFTS": "XENOGRAFT, a graft of tissue between individuals of different species [n]\n",
  "XENOLITH": "(Greek) a rock fragment foreign to the igneous mass in which it occurs [n -S]\n",
  "XENOLITHIC": "of or like a xenolith, a rock fragment foreign to the igneous mass in which it occurs [adj]\n",
  "XENOLITHS": "XENOLITH, (Greek) a rock fragment foreign to the igneous mass in which it occurs [n]\n",
  "XENOMANIA": "an inordinate attachment to foreign things [n -S]\n",
  "XENOMANIAS": "XENOMANIA, an inordinate attachment to foreign things [n]\n",
  "XENOMENIA": "menstruation from abnormal orifices [n -S]\n",
  "XENOMENIAS": "XENOMENIA, menstruation from abnormal orifices [n]\n",
  "XENOMORPHIC": "having a form not its own [adj XENOMORPHICALLY]\n",
  "XENOMORPHICALLY": "XENOMORPHIC, having a form not its own [adv]\n",
  "XENON": "a heavy inert gas [n -S]\n",
  "XENONS": "XENON, a heavy inert gas [n]\n",
  "XENOPHILE": "one who loves foreigners [n -S]\n",
  "XENOPHILES": "XENOPHILE, one who loves foreigners [n]\n",
  "XENOPHOBE": "one who hates foreigners [n -S]\n",
  "XENOPHOBES": "XENOPHOBE, one who hates foreigners [n]\n",
  "XENOPHOBIA": "fear of foreigners, also XENOPHOBY [n -S]\n",
  "XENOPHOBIAS": "XENOPHOBIA, fear of foreigners, also XENOPHOBY [n]\n",
  "XENOPHOBIC": "being afraid of foreigners [adj XENOPHOBICALLY]\n",
  "XENOPHOBICALLY": "XENOPHOBIC, being afraid of foreigners [adv]\n",
  "XENOPHOBIES": "XENOPHOBY, fear of foreigners, also XENOPHOBIA [n]\n",
  "XENOPHOBY": "fear of foreigners, also XENOPHOBIA [n XENOPHOBIES]\n",
  "XENOPHYA": "(Greek) elements of a shell or skeleton not secreted by the organism itself [n]\n",
  "XENOPLASTIC": "involving or occurring between distantly related individuals [adj]\n",
  "XENOPUS": "a frog native to southern Africa [n -ES]\n",
  "XENOPUSES": "XENOPUS, a frog native to southern Africa [n]\n",
  "XENOTIME": "(Greek) a phosphate of yttrium occurring in yellowish-brown tetragonal crystals [n -S]\n",
  "XENOTIMES": "XENOTIME, (Greek) a phosphate of yttrium occurring in yellowish-brown tetragonal crystals [n]\n",
  "XENOTRANSPLANT": "an operation in which an organ or tissue is transferred from one animal to another of a different species [n -S]\n",
  "XENOTRANSPLANTS": "XENOTRANSPLANT, an operation in which an organ or tissue is transferred from one animal to another of a different species [n]\n",
  "XENOTROPIC": "reproducing or replicating only in cells other than those of the host species [adj]\n",
  "XENURINE": "any armadillo of the genus Xenurus [n -S]\n",
  "XENURINES": "XENURINE, any armadillo of the genus Xenurus [n]\n",
  "XERAFIN": "(Portuguese) a former silver coin of Goa, also SERAFIN, SERAPHIN, XERAPHIN [n -S]\n",
  "XERAFINS": "XERAFIN, (Portuguese) a former silver coin of Goa, also SERAFIN, SERAPHIN, XERAPHIN [n]\n",
  "XERANSES": "XERANSIS, (Greek) a drying up [n]\n",
  "XERANSIS": "(Greek) a drying up [n XERANSES]\n",
  "XERANTHEMUM": "any plant of the Xeranthemum genus of plants of southern Europe, belonging to the thistle family [n -S]\n",
  "XERANTHEMUMS": "XERANTHEMUM, any plant of the Xeranthemum genus of plants of southern Europe, belonging to the thistle family [n]\n",
  "XERANTIC": "relating to xeransis, a drying up [adj]\n",
  "XERAPHIN": "(Portuguese) a former silver coin of Goa, also SERAFIN, SERAPHIN, XERAFIN [n -S]\n",
  "XERAPHINS": "XERAPHIN, (Portuguese) a former silver coin of Goa, also SERAFIN, SERAPHIN, XERAFIN [n]\n",
  "XERARCH": "developing in a dry area [adj]\n",
  "XERASIA": "abnormal dryness of the hair [n -S]\n",
  "XERASIAS": "XERASIA, abnormal dryness of the hair [n]\n",
  "XERIC": "requiring only a small amount of moisture [adj XERICALLY]\n",
  "XERICALLY": "XERIC, requiring only a small amount of moisture [adv]\n",
  "XERISCAPE": "(tradename) to landscape (an arid place) in a way that conserves by using plants that require little water [v XERISCAPED, XERISCAPING, XERISCAPES]\n",
  "XERISCAPED": "XERISCAPE, (tradename) to landscape (an arid place) in a way that conserves by using plants that require little water [v]\n",
  "XERISCAPES": "XERISCAPE, (tradename) to landscape (an arid place) in a way that conserves by using plants that require little water [v]\n",
  "XERISCAPING": "XERISCAPE, (tradename) to landscape (an arid place) in a way that conserves by using plants that require little water [v]\n",
  "XEROCHASIES": "XEROCHASY, dehiscence on drying [n]\n",
  "XEROCHASY": "dehiscence on drying [n XEROCHASIES]\n",
  "XERODERMA": "morbid dryness of skin, ichthyosis, also XERODERMIA [n XERODERMAS or XERODERMAE]\n",
  "XERODERMAE": "XERODERMA, morbid dryness of skin, ichthyosis, also XERODERMIA [n]\n",
  "XERODERMAS": "XERODERMA, morbid dryness of skin, ichthyosis, also XERODERMIA [n]\n",
  "XERODERMATIC": "relating to xeroderma, dryness of skin [adj]\n",
  "XERODERMATOUS": "suffering from xeroderma, morbid dryness of skin [adj]\n",
  "XERODERMIA": "morbid dryness of skin, ichthyosis, also XERODERMA [n -S]\n",
  "XERODERMIAS": "XERODERMIA, morbid dryness of skin, ichthyosis, also XERODERMA [n]\n",
  "XERODERMIC": "dry-skinned [adj]\n",
  "XEROGRAPHER": "one who practises xerography [n -S]\n",
  "XEROGRAPHERS": "XEROGRAPHER, one who practises xerography [n]\n",
  "XEROGRAPHIC": "relating to xerography [adj XEROGRAPHICALLY]\n",
  "XEROGRAPHICALLY": "XEROGRAPHIC, relating to xerography [adv]\n",
  "XEROGRAPHIES": "XEROGRAPHY, a nonchemical photographic process in which the plate is sensitized electrically and developed by dusting with electrically-charged fine powder [n]\n",
  "XEROGRAPHY": "a nonchemical photographic process in which the plate is sensitized electrically and developed by dusting with electrically-charged fine powder [n XEROGRAPHIES]\n",
  "XEROMA": "(Greek) a dry lustreless condition of the conjunctiva, also XEROPHTHALMIA [n XEROMAS or XEROMATA]\n",
  "XEROMAS": "XEROMA, (Greek) a dry lustreless condition of the conjunctiva, also XEROPHTHALMIA [n]\n",
  "XEROMATA": "XEROMA, (Greek) a dry lustreless condition of the conjunctiva, also XEROPHTHALMIA [n]\n",
  "XEROMORPH": "a plant thriving in desert conditions, a xerophyte [n -S]\n",
  "XEROMORPHIC": "of parts of a plant, protected against excessive loss of water by thick cuticles, coatings of hairs and similar structural features, also XEROMORPHOUS [adj]\n",
  "XEROMORPHOUS": "of parts of a plant, protected against excessive loss of water by thick cuticles, coatings of hairs and similar structural features, also XEROMORPHIC [adj]\n",
  "XEROMORPHS": "XEROMORPH, a plant thriving in desert conditions, a xerophyte [n]\n",
  "XEROPHAGIES": "XEROPHAGY, the eating of dry food, esp. food cooked without oil [n]\n",
  "XEROPHAGY": "the eating of dry food, esp. food cooked without oil [n XEROPHAGIES]\n",
  "XEROPHILE": "a plant adapted to dry conditions [n -S]\n",
  "XEROPHILES": "XEROPHILE, a plant adapted to dry conditions [n]\n",
  "XEROPHILIES": "XEROPHILY, adaptation to very dry conditions [n]\n",
  "XEROPHILOUS": "drought loving, particularly pertaining to plants [adj]\n",
  "XEROPHILY": "adaptation to very dry conditions [n XEROPHILIES]\n",
  "XEROPHTHALMIA": "extreme dryness of the conjunctive, thought to stem from a vitamin A deficiency, also XEROMA [n -S]\n",
  "XEROPHTHALMIAS": "XEROPHTHALMIA, extreme dryness of the conjunctive, thought to stem from a vitamin A deficiency, also XEROMA [n]\n",
  "XEROPHTHALMIC": "relating to xerophthalmia [adj]\n",
  "XEROPHYTE": "a plant thriving in desert conditions [n -S]\n",
  "XEROPHYTES": "XEROPHYTE, a plant thriving in desert conditions [n]\n",
  "XEROPHYTIC": "able to withstand drought [adj XEROPHYTICALLY]\n",
  "XEROPHYTICALLY": "XEROPHYTIC, able to withstand drought [adv]\n",
  "XEROPHYTISM": "being a xerophyte [n -S]\n",
  "XEROPHYTISMS": "XEROPHYTISM, being a xerophyte [n]\n",
  "XERORADIOGRAPHY": "radiography used esp. in mammographic screening for breast cancer that produces an image using X-rays in a manner similar to the way an image is produced by light in xerography [n]\n",
  "XEROSERE": "a sequence of ecological communities beginning in a dry area [n -S]\n",
  "XEROSERES": "XEROSERE, a sequence of ecological communities beginning in a dry area [n]\n",
  "XEROSES": "XEROSIS, (Greek) abnormal dryness of body parts, also XEROTES [n]\n",
  "XEROSIS": "(Greek) abnormal dryness of body parts, also XEROTES [n XEROSES]\n",
  "XEROSTOMA": "excessive dryness of the mouth due to insufficient secretions, also XEROSTOMIA [n XEROSTOMAS or XEROSTOMATA]\n",
  "XEROSTOMAS": "XEROSTOMA, excessive dryness of the mouth due to insufficient secretions, also XEROSTOMIA [n]\n",
  "XEROSTOMATA": "XEROSTOMA, excessive dryness of the mouth due to insufficient secretions, also XEROSTOMIA [n]\n",
  "XEROSTOMIA": "excessive dryness of the mouth due to insufficient secretions, also XEROSTOMA [n -S]\n",
  "XEROSTOMIAS": "XEROSTOMIA, excessive dryness of the mouth due to insufficient secretions, also XEROSTOMA [n]\n",
  "XEROTES": "(Greek) abnormal dryness of body parts, also XEROSIS [n XEROTES]\n",
  "XEROTHERMIC": "of a region or climate, both dry and hot; of an animal or plant, living in a xerothermic environment [adj]\n",
  "XEROTIC": "of abnormally dry body tissues [adj]\n",
  "XEROTRIPSES": "XEROTRIPSIS, dry friction [n]\n",
  "XEROTRIPSIS": "dry friction [n XEROTRIPSES]\n",
  "XEROX": "to produce by a xerox copying machine [v -ED, -ING, -ES]\n",
  "XEROXED": "XEROX, to produce by a xerox copying machine [v]\n",
  "XEROXES": "XEROX, to produce by a xerox copying machine [v]\n",
  "XEROXING": "XEROX, to produce by a xerox copying machine [v]\n",
  "XERUS": "an African ground squirrel [n -ES]\n",
  "XERUSES": "XERUS, an African ground squirrel [n]\n",
  "XI": "(Greek) the fourteenth letter of the Greek alphabet [n -S]\n",
  "XIPHIHUMERALIS": "in vertebrates, a muscle leading from the xiphoid cartilage to the humerus [n]\n",
  "XIPHIPLASTRA": "XIPHIPLASTRON, in chelonians, one of the plates forming the plastron, lying posterior to the hypoplastron [n]\n",
  "XIPHIPLASTRAL": "a type of chelonian [n -S]\n",
  "XIPHIPLASTRALS": "XIPHIPLASTRAL, a type of chelonian [n]\n",
  "XIPHIPLASTRON": "in chelonians, one of the plates forming the plastron, lying posterior to the hypoplastron [n XIPHIPLASTRA]\n",
  "XIPHISTERNA": "XIPHISTERNUM, the posterior and smallest of the three divisions of the sternum [n]\n",
  "XIPHISTERNUM": "the posterior and smallest of the three divisions of the sternum [n XIPHISTERNA or XIPHISTERNUMS]\n",
  "XIPHISTERNUMS": "XIPHISTERNUM, the posterior and smallest of the three divisions of the sternum [n]\n",
  "XIPHOID": "swordlike, also XIPHOIDAL [adj] / the xiphoid process or xiphisternum [n -S]\n",
  "XIPHOIDAL": "swordlike, also XIPHOID [adj]\n",
  "XIPHOIDS": "XIPHOID, the xiphoid process or xiphisternum [n]\n",
  "XIPHOPAGI": "XIPHOPAGUS, a set of Siamese twins joined in the region of the xiphoid cartilage [n]\n",
  "XIPHOPAGIC": "relating to a xiphopagus [adj]\n",
  "XIPHOPAGOUS": "like a xiphopagus, a set of Siamese twins joined in the region of the xiphoid cartilage [adj]\n",
  "XIPHOPAGUS": "a set of Siamese twins joined in the region of the xiphoid cartilage [n XIPHOPAGI or XIPHOPAGUSES]\n",
  "XIPHOPAGUSES": "XIPHOPAGUS, a set of Siamese twins joined in the region of the xiphoid cartilage [n]\n",
  "XIPHOPHYLLOUS": "having sword-shaped leaves [adj]\n",
  "XIPHOSURAN": "belonging to the Xiphosura, an order of Arthropoda of which the only survivors are the king crabs [adj] / a member of the Xiphosura [n -S]\n",
  "XIPHOSURANS": "XIPHOSURAN, a member of the Xiphosura [n]\n",
  "XIS": "XI, (Greek) the fourteenth letter of the Greek alphabet [n]\n",
  "XOANA": "XOANON, (Greek) a primitive statue [n]\n",
  "XOANON": "(Greek) a primitive statue [n XOANA]\n",
  "XRAY": "(in international radio communication) a code word for the letter x [n -S]\n",
  "XRAYS": "XRAY, (in international radio communication) a code word for the letter x [n]\n",
  "XU": "the currency of Vietnam, also SAU [n XU]\n",
  "XYLAN": "a substance found in cell walls of plants [n -S]\n",
  "XYLANS": "XYLAN, a substance found in cell walls of plants [n]\n",
  "XYLEM": "(Greek) a woody tissue in trees or plants, also XYLOGEN [n -S]\n",
  "XYLEMS": "XYLEM, (Greek) a woody tissue in trees or plants, also XYLOGEN [n]\n",
  "XYLENE": "a flammable hydrocarbon, also XYLOL [n -S]\n",
  "XYLENES": "XYLENE, a flammable hydrocarbon, also XYLOL [n]\n",
  "XYLENOL": "a synthetic resin derived from xylene [n -S]\n",
  "XYLENOLS": "XYLENOL, a synthetic resin derived from xylene [n]\n",
  "XYLIC": "relating to xylem [adj]\n",
  "XYLIDIN": "any one of six metameric hydrocarbons related to xylene, also XYLIDINE [n -S]\n",
  "XYLIDINE": "any one of six metameric hydrocarbons related to xylene, also XYLIDIN [n -S]\n",
  "XYLIDINES": "XYLIDINE, any one of six metameric hydrocarbons related to xylene, also XYLIDIN [n]\n",
  "XYLIDINS": "XYLIDIN, any one of six metameric hydrocarbons related to xylene, also XYLIDINE [n]\n",
  "XYLITOL": "a sweet crystalline alcohol obtained from xylose [n -S]\n",
  "XYLITOLS": "XYLITOL, a sweet crystalline alcohol obtained from xylose [n]\n",
  "XYLOBALSAMUM": "the dried twigs, or the wood, of the balm of Gilead tree [n -S]\n",
  "XYLOBALSAMUMS": "XYLOBALSAMUM, the dried twigs, or the wood, of the balm of Gilead tree [n]\n",
  "XYLOCARP": "a hard woody fruit [n -S]\n",
  "XYLOCARPOUS": "having woody fruit [adj]\n",
  "XYLOCARPS": "XYLOCARP, a hard woody fruit [n]\n",
  "XYLOCHROME": "a mixture of substances to which the colour of heartwood is due [n -S]\n",
  "XYLOCHROMES": "XYLOCHROME, a mixture of substances to which the colour of heartwood is due [n]\n",
  "XYLOGEN": "(Greek) a woody tissue in trees or plants, also XYLEM [n -S]\n",
  "XYLOGENOUS": "growing on wood [adj]\n",
  "XYLOGENS": "XYLOGEN, (Greek) a woody tissue in trees or plants, also XYLEM [n]\n",
  "XYLOGRAPH": "an engraving on wood, or the impression from such an engraving; a print by xylography [n -S] / to copy by xylograph [v -ED, -ING, -S]\n",
  "XYLOGRAPHED": "XYLOGRAPH, to copy by xylograph [v]\n",
  "XYLOGRAPHER": "one who practises xylography, the art of making engravings on wood [n -S]\n",
  "XYLOGRAPHERS": "XYLOGRAPHER, one who practises xylography, the art of making engravings on wood [n]\n",
  "XYLOGRAPHIC": "relating to xylography, the art of making engravings on wood, also XYLOGRAPHICAL [adj]\n",
  "XYLOGRAPHICAL": "relating to xylography, the art of making engravings on wood, also XYLOGRAPHIC [adj]\n",
  "XYLOGRAPHIES": "XYLOGRAPHY, the art of making engravings on wood, esp. for printing [n]\n",
  "XYLOGRAPHING": "XYLOGRAPH, to copy by xylograph [v]\n",
  "XYLOGRAPHS": "XYLOGRAPH, an engraving on wood, or the impression from such an engraving; a print by xylography [n]\n",
  "XYLOGRAPHY": "the art of making engravings on wood, esp. for printing [n XYLOGRAPHIES]\n",
  "XYLOID": "woody; ligneous [adj]\n",
  "XYLOIDIN": "a substance resembling pyroxylin, obtained by the action of nitric acid on starch, also XYLOIDINE [n -S]\n",
  "XYLOIDINE": "a substance resembling pyroxylin, obtained by the action of nitric acid on starch, also XYLOIDIN [n -S]\n",
  "XYLOIDINES": "XYLOIDINE, a substance resembling pyroxylin, obtained by the action of nitric acid on starch, also XYLOIDIN [n]\n",
  "XYLOIDINS": "XYLOIDIN, a substance resembling pyroxylin, obtained by the action of nitric acid on starch, also XYLOIDINE [n]\n",
  "XYLOL": "a flammable hydrocarbon, also XYLENE [n -S]\n",
  "XYLOLOGIES": "XYLOLOGY, the study of the structure of wood [n]\n",
  "XYLOLOGY": "the study of the structure of wood [n XYLOLOGIES]\n",
  "XYLOLS": "XYLOL, a flammable hydrocarbon, also XYLENE [n]\n",
  "XYLOMA": "a body which forms spurs internally in fungi [n XYLOMAS or XYLOMATA]\n",
  "XYLOMAS": "XYLOMA, a body which forms spurs internally in fungi [n]\n",
  "XYLOMATA": "XYLOMA, a body which forms spurs internally in fungi [n]\n",
  "XYLOMETER": "an instrument for measuring the specific gravity of wood [n -S]\n",
  "XYLOMETERS": "XYLOMETER, an instrument for measuring the specific gravity of wood [n]\n",
  "XYLONIC": "pertaining to an acid obtained by oxidizing xylose [adj]\n",
  "XYLONITE": "a non-thermosetting plastic of the nitrocellulose type, also ZYLONITE [n -S]\n",
  "XYLONITES": "XYLONITE, a non-thermosetting plastic of the nitrocellulose type, also ZYLONITE [n]\n",
  "XYLOPHAGAN": "one of a tribe of beetles whose larvae bore or live in wood [n -S]\n",
  "XYLOPHAGANS": "XYLOPHAGAN, one of a tribe of beetles whose larvae bore or live in wood [n]\n",
  "XYLOPHAGE": "an insect larva, mollusc etc. that eats or bores into wood [n -S]\n",
  "XYLOPHAGES": "XYLOPHAGE, an insect larva, mollusc etc. that eats or bores into wood [n]\n",
  "XYLOPHAGOUS": "wood-eating [adj]\n",
  "XYLOPHILOUS": "fond of wood; living in or on wood [adj]\n",
  "XYLOPHONE": "a musical percussion instrument consisting of a graduated series of wooden bars, usually played by striking with two small round-ended hammers [n -S]\n",
  "XYLOPHONES": "XYLOPHONE, a musical percussion instrument consisting of a graduated series of wooden bars, usually played by striking with two small round-ended hammers [n]\n",
  "XYLOPHONIC": "relating to a xylophone [adj]\n",
  "XYLOPHONIST": "one who plays the xylophone [n -S]\n",
  "XYLOPHONISTS": "XYLOPHONIST, one who plays the xylophone [n]\n",
  "XYLOPYROGRAPHY": "engraving designs on wood with hot poker [n]\n",
  "XYLORIMBA": "a combination of xylophone and marimba [n -S]\n",
  "XYLORIMBAS": "XYLORIMBA, a combination of xylophone and marimba [n]\n",
  "XYLOSE": "a pentose (aldose) which occurs widely in plants, esp. as a constituent of xylan [n -S]\n",
  "XYLOSES": "XYLOSE, a pentose (aldose) which occurs widely in plants, esp. as a constituent of xylan [n]\n",
  "XYLOTOMIES": "XYLOTOMY, the preparation of wood for microscopic examination [n]\n",
  "XYLOTOMIST": "one who carries out xylotomy, the preparation of sections of wood for microscopic examination [n -S]\n",
  "XYLOTOMISTS": "XYLOTOMIST, one who carries out xylotomy, the preparation of sections of wood for microscopic examination [n]\n",
  "XYLOTOMOUS": "of insects, cutting or boring wood [adj]\n",
  "XYLOTOMY": "the preparation of wood for microscopic examination [n XYLOTOMIES]\n",
  "XYLOTYPOGRAPHIC": "relating to, or printed from, wooden type [adj]\n",
  "XYLOTYPOGRAPHY": "printing from wooden type [n]\n",
  "XYLYL": "a chemical compound found in coal-tar [n -S]\n",
  "XYLYLS": "XYLYL, a chemical compound found in coal-tar [n]\n",
  "XYRIDACEOUS": "belonging to the Xyridaceae, a genus of sedge-like flowers [adj]\n",
  "XYST": "(historical) a long covered portico or court used by ancient Greek athletes for exercises, also XYSTOS, XYSTUS [n -S]\n",
  "XYSTER": "(Greek) a surgeon's instrument for scraping bones [n -S]\n",
  "XYSTERS": "XYSTER, (Greek) a surgeon's instrument for scraping bones [n]\n",
  "XYSTI": "XYSTUS, (historical) a long covered portico or court used by ancient Greek athletes for exercises, also XYST, XYSTOS [n]\n",
  "XYSTOI": "XYSTOS, (Greek) a long covered portico or court used by ancient Greek athletes for exercises, also XYST, XYSTUS [n]\n",
  "XYSTOS": "(Greek) a long covered portico or court used by ancient Greek athletes for exercises, also XYST, XYSTUS [n XYSTOI]\n",
  "XYSTS": "XYST, (historical) a long covered portico or court used by ancient Greek athletes for exercises, also XYSTOS, XYSTUS [n]\n",
  "XYSTUS": "(historical) a long covered portico or court used by ancient Greek athletes for exercises, also XYST, XYSTOS [n XYSTI]\n",
  "YA": "an Asian pear [n -S]\n",
  "YAAR": "(Hinglish) friend, man (as a form of address) [n -S]\n",
  "YAARS": "YAAR, (Hinglish) friend, man (as a form of address) [n]\n",
  "YABA": "(colloquial) yet another bloody acronym [n -S]\n",
  "YABAS": "YABA, (colloquial) yet another bloody acronym [n]\n",
  "YABBA": "a methamphetamine, a stimulant drug [n -S]\n",
  "YABBAS": "YABBA, a methamphetamine, a stimulant drug [n]\n",
  "YABBER": "(Native Australian) to talk [v -ED, -ING, -S]\n",
  "YABBERED": "YABBER, (Native Australian) to talk [v]\n",
  "YABBERING": "YABBER, (Native Australian) to talk [v]\n",
  "YABBERS": "YABBER, (Native Australian) to talk [v]\n",
  "YABBIE": "(Native Australian) a small freshwater crayfish, also YABBY [n -S] / to fish for yabbies [v YABBIED, YABBYING, YABBIES]\n",
  "YABBIED": "YABBY, to catch yabbies, also YABBIE [v]\n",
  "YABBIES": "YABBY, to catch yabbies, also YABBIE [v]\n",
  "YABBY": "(Native Australian) a small freshwater crayfish [n YABBIES] / to catch yabbies, also YABBIE [v YABBIED, YABBYING, YABBIES]\n",
  "YABBYING": "YABBY, to catch yabbies, also YABBIE [v]\n",
  "YACCA": "(Australian slang) an Australian plant with a woody stem and stiff grasslike leaves, aka grass tree [n -S]\n",
  "YACCAS": "YACCA, (Australian slang) an Australian plant with a woody stem and stiff grasslike leaves, aka grass tree [n]\n",
  "YACHT": "a vessel propelled by sail or power, used esp. for pleasure cruising, racing, etc. [n -S] / to sail or cruise in a yacht [v -ED, -ING, -S]\n",
  "YACHTED": "YACHT, to sail or cruise in a yacht [v]\n",
  "YACHTER": "one who sails a yacht, also YACHTIE, YACHTMAN, YACHTSMAN [n -S]\n",
  "YACHTERS": "YACHTER, one who sails a yacht, also YACHTIE, YACHTMAN, YACHTSMAN [n]\n",
  "YACHTIE": "(Australian slang) a yachtsman, also YACHTER, YACHTMAN, YACHTSMAN [n -S]\n",
  "YACHTIES": "YACHTIE, (Australian slang) a yachtsman, also YACHTER, YACHTMAN, YACHTSMAN [n]\n",
  "YACHTING": "the sport of sailing or cruising in a yacht [n -S]\n",
  "YACHTINGS": "YACHTING, the sport of sailing or cruising in a yacht [n]\n",
  "YACHTMAN": "one who sails a yacht, also YACHTER, YACHTIE, YACHTSMAN [n YACHTMEN]\n",
  "YACHTMEN": "YACHTMAN, one who sails a yacht, also YACHTER, YACHTIE, YACHTSMAN [n]\n",
  "YACHTS": "YACHT, to sail or cruise in a yacht [v]\n",
  "YACHTSMAN": "one who sails a yacht, also YACHTER, YACHTIE, YACHTMAN [n YACHTSMEN]\n",
  "YACHTSMANSHIP": "the art of sailing a yacht [n -S]\n",
  "YACHTSMANSHIPS": "YACHTSMANSHIP, the art of sailing a yacht [n]\n",
  "YACHTSMEN": "YACHTSMAN, one who sails a yacht, also YACHTER, YACHTIE, YACHTMAN [n]\n",
  "YACHTSWOMAN": "a woman who sails a yacht [n YACHTSWOMEN]\n",
  "YACHTSWOMEN": "YACHTSWOMAN, a woman who sails a yacht [n]\n",
  "YACK": "to talk persistently, also YAK [v -ED, -ING, -S]\n",
  "YACKA": "(Australian slang) an Australian plant with a woody stem and stiff grasslike leaves, aka grass tree [n -S]\n",
  "YACKAS": "YACKA, (Australian slang) an Australian plant with a woody stem and stiff grasslike leaves, aka grass tree [n]\n",
  "YACKED": "YACK, to talk persistently, also YAK [v]\n",
  "YACKER": "(Native Australian) hard work, toil, also YAKKA, YAKKER [n -S]\n",
  "YACKERS": "YACKER, (Native Australian) hard work, toil, also YAKKA, YAKKER [n]\n",
  "YACKING": "YACK, to talk persistently, also YAK [v]\n",
  "YACKS": "YACK, to talk persistently, also YAK [v]\n",
  "YAD": "(Hebrew) a handheld pointer used for reading the Torah [n -S]\n",
  "YADS": "YAD, (Hebrew) a handheld pointer used for reading the Torah [n]\n",
  "YAE": "(Scots) one, also AE [adj]\n",
  "YAFF": "(Scots) to bark, scold, nag, also NYAFF [v -ED, -ING, -S]\n",
  "YAFFED": "YAFF, (Scots) to bark, scold, nag, also NYAFF [v]\n",
  "YAFFING": "YAFF, (Scots) to bark, scold, nag, also NYAFF [v]\n",
  "YAFFINGALE": "the yaffle or green woodpecker [n -S]\n",
  "YAFFINGALES": "YAFFINGALE, the yaffle or green woodpecker [n]\n",
  "YAFFLE": "the green woodpecker [n -S]\n",
  "YAFFLES": "YAFFLE, the green woodpecker [n]\n",
  "YAFFS": "YAFF, (Scots) to bark, scold, nag, also NYAFF [v]\n",
  "YAG": "a type of synthetic garnet containing yttrium and aluminium, used in lasers and as a gem [n -S]\n",
  "YAGE": "a tropical vine of the Amazon region, aka ayahuasca [n -S]\n",
  "YAGER": "(German) a huntsman, also JAEGER, JAGER [n -S]\n",
  "YAGERS": "YAGER, (German) a huntsman, also JAEGER, JAGER [n]\n",
  "YAGES": "YAGE, a tropical vine of the Amazon region, aka ayahuasca [n]\n",
  "YAGGER": "(Scots) a pedlar [n -S]\n",
  "YAGGERS": "YAGGER, (Scots) a pedlar [n]\n",
  "YAGI": "(Japanese) a type of shortwave antenna [n -S]\n",
  "YAGIS": "YAGI, (Japanese) a type of shortwave antenna [n]\n",
  "YAGS": "YAG, a type of synthetic garnet containing yttrium and aluminium, used in lasers and as a gem [n]\n",
  "YAH": "an affected upper-class person [n -S]\n",
  "YAHOO": "in cricket, an exuberant attempt to hit the ball hard, often with disappointing results [n -S]\n",
  "YAHOOISM": "uncouth behaviour [n -S]\n",
  "YAHOOISMS": "YAHOOISM, uncouth behaviour [n]\n",
  "YAHOOS": "YAHOO, in cricket, an exuberant attempt to hit the ball hard, often with disappointing results [n]\n",
  "YAHRZEIT": "(Yiddish) an anniversary of the death of a family member observed by Jews [n -S]\n",
  "YAHRZEITS": "YAHRZEIT, (Yiddish) an anniversary of the death of a family member observed by Jews [n]\n",
  "YAHS": "YAH, an affected upper-class person [n]\n",
  "YAIRD": "a yard, a garden [n -S]\n",
  "YAIRDS": "YAIRD, a yard, a garden [n]\n",
  "YAK": "to talk persistently, also YACK [v YAKKED, YAKKING, YAKS]\n",
  "YAKHDAN": "(Persian) a box used for carrying ice on the back of a pack animal [n -S]\n",
  "YAKHDANS": "YAKHDAN, (Persian) a box used for carrying ice on the back of a pack animal [n]\n",
  "YAKIMONO": "(Japanese) in Japanese cookery, grilled food, a grilled dish [n -S]\n",
  "YAKIMONOS": "YAKIMONO, (Japanese) in Japanese cookery, grilled food, a grilled dish [n]\n",
  "YAKITORI": "(Japanese) bitesize marinated chicken on small skewers [n -S]\n",
  "YAKITORIS": "YAKITORI, (Japanese) bitesize marinated chicken on small skewers [n]\n",
  "YAKKA": "(Native Australian) hard work, toil, also YACKER, YAKKER [n -S]\n",
  "YAKKAS": "YAKKA, (Native Australian) hard work, toil, also YACKER, YAKKER [n]\n",
  "YAKKED": "YAK, to talk persistently, also YACK [v]\n",
  "YAKKER": "(Native Australian) hard work, toil, also YACKER, YAKKA [n -S]\n",
  "YAKKERS": "YAKKER, (Native Australian) hard work, toil, also YACKER, YAKKA [n]\n",
  "YAKKING": "YAK, to talk persistently, also YACK [v]\n",
  "YAKOW": "an animal crossbred from a male yak and a domestic cow [n -S]\n",
  "YAKOWS": "YAKOW, an animal crossbred from a male yak and a domestic cow [n]\n",
  "YAKS": "YAK, to talk persistently, also YACK [v]\n",
  "YAKUZA": "(Japanese) a Japanese gangster [n YAKUZA]\n",
  "YALD": "(Scots) active, nimble, also YAULD [adj]\n",
  "YALE": "a fabulous heraldic beast [n -S]\n",
  "YALES": "YALE, a fabulous heraldic beast [n]\n",
  "YAM": "a sweet potato [n -S]\n",
  "YAMALKA": "(Yiddish) a religious skullcap, also YAMULKA, YARMELKE, YARMULKA, YARMULKE [n -S]\n",
  "YAMALKAS": "YAMALKA, (Yiddish) a religious skullcap, also YAMULKA, YARMELKE, YARMULKA, YARMULKE [n]\n",
  "YAMEN": "(Chinese) the offices and residence of a mandarin, also YAMUN [n -S]\n",
  "YAMENS": "YAMEN, (Chinese) the offices and residence of a mandarin, also YAMUN [n]\n",
  "YAMMER": "to complain peevishly; to howl [v -ED, -ING, -S]\n",
  "YAMMERED": "YAMMER, to complain peevishly; to howl [v]\n",
  "YAMMERER": "one who yammers [n -S]\n",
  "YAMMERERS": "YAMMERER, one who yammers [n]\n",
  "YAMMERING": "peevish complaint [n -S]\n",
  "YAMMERINGS": "YAMMERING, peevish complaint [n]\n",
  "YAMMERS": "YAMMER, to complain peevishly; to howl [v]\n",
  "YAMPIES": "YAMPY, (dialect) a foolish person [n]\n",
  "YAMPY": "(dialect) a foolish person [n YAMPIES]\n",
  "YAMS": "YAM, a sweet potato [n]\n",
  "YAMULKA": "(Yiddish) a religious skullcap, also YAMALKA, YARMELKE, YARMULKA, YARMULKE [n -S]\n",
  "YAMULKAS": "YAMULKA, (Yiddish) a religious skullcap, also YAMALKA, YARMELKE, YARMULKA, YARMULKE [n]\n",
  "YAMUN": "(Chinese) the offices and residence of a mandarin, also YAMEN [n -S]\n",
  "YAMUNS": "YAMUN, (Chinese) the offices and residence of a mandarin, also YAMEN [n]\n",
  "YANG": "(Chinese) a species of Thai timber tree [n -S]\n",
  "YANGS": "YANG, (Chinese) a species of Thai timber tree [n]\n",
  "YANK": "to pull with a jerk [v -ED, -ING, -S]\n",
  "YANKED": "YANK, to pull with a jerk [v]\n",
  "YANKEE": "(in international radio communication) a code word for the letter y [n -S]\n",
  "YANKEES": "YANKEE, (in international radio communication) a code word for the letter y [n]\n",
  "YANKER": "(Scots) a big lie [n -S]\n",
  "YANKERS": "YANKER, (Scots) a big lie [n]\n",
  "YANKIE": "(Scots) a scold; an impudent woman [n -S]\n",
  "YANKIES": "YANKIE, (Scots) a scold; an impudent woman [n]\n",
  "YANKING": "YANK, to pull with a jerk [v]\n",
  "YANKS": "YANK, to pull with a jerk [v]\n",
  "YANQUI": "(Spanish) in Latin America, a North American [n -S]\n",
  "YANQUIS": "YANQUI, (Spanish) in Latin America, a North American [n]\n",
  "YANTRA": "(Sanskrit) a geometrical diagram used in meditation [n -S]\n",
  "YANTRAS": "YANTRA, (Sanskrit) a geometrical diagram used in meditation [n]\n",
  "YAOURT": "(Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YOGHOURT, YOGHURT, YOGOURT, YOGURT [n -S]\n",
  "YAOURTS": "YAOURT, (Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YOGHOURT, YOGHURT, YOGOURT, YOGURT [n]\n",
  "YAP": "to bark shrilly [v YAPPED, YAPPING, YAPS]\n",
  "YAPOCK": "the South American opossum, also YAPOK [n -S]\n",
  "YAPOCKS": "YAPOCK, the South American opossum, also YAPOK [n]\n",
  "YAPOK": "the South American opossum, also YAPOCK [n -S]\n",
  "YAPOKS": "YAPOK, the South American opossum, also YAPOCK [n]\n",
  "YAPON": "a bushy evergreen shrub of the holly genus, also YAUPON, YOUPON, YUPON [n -S]\n",
  "YAPONS": "YAPON, a bushy evergreen shrub of the holly genus, also YAUPON, YOUPON, YUPON [n]\n",
  "YAPP": "a limp leather binding [n -S]\n",
  "YAPPED": "YAP, to bark shrilly [v]\n",
  "YAPPER": "a yappy dog [n -S]\n",
  "YAPPERS": "YAPPER, a yappy dog [n]\n",
  "YAPPIE": "a young aspiring professional; a young affluent parent, also YAPPY [n -S]\n",
  "YAPPIER": "YAPPY, given to yapping [adj]\n",
  "YAPPIES": "YAPPIE, a young aspiring professional; a young affluent parent, also YAPPY [n]\n",
  "YAPPIEST": "YAPPY, given to yapping [adj]\n",
  "YAPPING": "a high-pitched barking [n -S]\n",
  "YAPPINGLY": "YAPPING [adv]\n",
  "YAPPINGS": "YAPPING, a high-pitched barking [n]\n",
  "YAPPS": "YAPP, a limp leather binding [n]\n",
  "YAPPY": "given to yapping [adj YAPPIER, YAPPIEST] / a young aspiring professional; a young affluent parent, also YAPPIE [n YAPPIES]\n",
  "YAPS": "YAP, to bark shrilly [v]\n",
  "YAPSTER": "a dog [n -S]\n",
  "YAPSTERS": "YAPSTER, a dog [n]\n",
  "YAQONA": "(Fijian) a shrub, of the West Pacific islands, aka kava; a narcotic fermented drink made esp. in Fiji from its macerated roots [n -S]\n",
  "YAQONAS": "YAQONA, (Fijian) a shrub, of the West Pacific islands, aka kava; a narcotic fermented drink made esp. in Fiji from its macerated roots [n]\n",
  "YAR": "nimble, also YARE [adj YARER, YAREST]\n",
  "YARAK": "(Persian) of a hawk, a fit condition for hunting [n -S]\n",
  "YARAKS": "YARAK, (Persian) of a hawk, a fit condition for hunting [n]\n",
  "YARBOROUGH": "a type of hand at bridge [n -S]\n",
  "YARBOROUGHS": "YARBOROUGH, a type of hand at bridge [n]\n",
  "YARCO": "(Australian slang) a young working-class person who wears casual sports clothes [n -S]\n",
  "YARCOS": "YARCO, (Australian slang) a young working-class person who wears casual sports clothes [n]\n",
  "YARD": "an enclosed place, esp. near a building [n -S] / to enclose in a yard, also YAIRD [v -ED, -ING, -S]\n",
  "YARDAGE": "the use of an enclosure for livestock at a railway station [n -S]\n",
  "YARDAGES": "YARDAGE, the use of an enclosure for livestock at a railway station [n]\n",
  "YARDANG": "(Turkish) a ridge formed by wind erosion parallel to prevailing winds [n -S]\n",
  "YARDANGS": "YARDANG, (Turkish) a ridge formed by wind erosion parallel to prevailing winds [n]\n",
  "YARDARM": "either end of a ship's spar [n -S]\n",
  "YARDARMS": "YARDARM, either end of a ship's spar [n]\n",
  "YARDBIRD": "an army recruit [n -S]\n",
  "YARDBIRDS": "YARDBIRD, an army recruit [n]\n",
  "YARDED": "YARD, to enclose in a yard, also YAIRD [v]\n",
  "YARDER": "one who yards, drafts animals to a sale yard [n -S]\n",
  "YARDERS": "YARDER, one who yards, drafts animals to a sale yard [n]\n",
  "YARDING": "a group of animals displayed for sale [n -S]\n",
  "YARDINGS": "YARDING, a group of animals displayed for sale [n]\n",
  "YARDLAND": "an English unit of land measure equal to 30 acres [n -S]\n",
  "YARDLANDS": "YARDLAND, an English unit of land measure equal to 30 acres [n]\n",
  "YARDLIGHT": "a strong light suspended on a pole, used to illuminate a farmyard [n -S]\n",
  "YARDLIGHTS": "YARDLIGHT, a strong light suspended on a pole, used to illuminate a farmyard [n]\n",
  "YARDMAN": "a male outdoor worker [n YARDMEN]\n",
  "YARDMASTER": "a person in charge of a marshalling yard [n -S]\n",
  "YARDMASTERS": "YARDMASTER, a person in charge of a marshalling yard [n]\n",
  "YARDMEN": "YARDMAN, a male outdoor worker [n]\n",
  "YARDS": "YARD, to enclose in a yard, also YAIRD [v]\n",
  "YARDSTICK": "a stick three feet long; any standard of measurement, also YARDWAND [n -S]\n",
  "YARDSTICKS": "YARDSTICK, a stick three feet long; any standard of measurement, also YARDWAND [n]\n",
  "YARDWAND": "a stick three feet long; any standard of measurement, also YARDSTICK [n -S]\n",
  "YARDWANDS": "YARDWAND, a stick three feet long; any standard of measurement, also YARDSTICK [n]\n",
  "YARDWORK": "the work of caring for a lawn [n -S]\n",
  "YARDWORKS": "YARDWORK, the work of caring for a lawn [n]\n",
  "YARE": "(archaic) nimble, also YAR [adj YARER, YAREST, YARELY]\n",
  "YARELY": "YARE, (archaic) nimble, also YAR [adv]\n",
  "YARER": "YARE, (archaic) nimble, also YAR [adj]\n",
  "YAREST": "YARE, (archaic) nimble, also YAR [adj]\n",
  "YARFA": "(Old Norse) in Shetland, peaty soil; clayey, sandy or fibrous peat, also YARPHA [n -S]\n",
  "YARFAS": "YARFA, (Old Norse) in Shetland, peaty soil; clayey, sandy or fibrous peat, also YARPHA [n]\n",
  "YARK": "(dialect) to make ready [v -ED, -ING, -S]\n",
  "YARKED": "YARK, (dialect) to make ready [v]\n",
  "YARKING": "YARK, (dialect) to make ready [v]\n",
  "YARKS": "YARK, (dialect) to make ready [v]\n",
  "YARMELKE": "(Yiddish) a religious skullcap, also YAMALKA, YAMULKA, YARMULKA, YARMULKE [n -S]\n",
  "YARMELKES": "YARMELKE, (Yiddish) a religious skullcap, also YAMALKA, YAMULKA, YARMULKA, YARMULKE [n]\n",
  "YARMULKA": "(Yiddish) a religious skullcap, also YAMALKA, YAMULKA, YARMELKE, YARMULKE [n -S]\n",
  "YARMULKAS": "YARMULKA, (Yiddish) a religious skullcap, also YAMALKA, YAMULKA, YARMELKE, YARMULKE [n]\n",
  "YARMULKE": "(Yiddish) a religious skullcap, also YAMALKA, YAMULKA, YARMELKE, YARMULKA [n -S]\n",
  "YARMULKES": "YARMULKE, (Yiddish) a religious skullcap, also YAMALKA, YAMULKA, YARMELKE, YARMULKA [n]\n",
  "YARN": "to tell a long story [v -ED, -ING, -S]\n",
  "YARNED": "YARN, to tell a long story [v]\n",
  "YARNER": "one who tells stories [n -S]\n",
  "YARNERS": "YARNER, one who tells stories [n]\n",
  "YARNING": "YARN, to tell a long story [v]\n",
  "YARNS": "YARN, to tell a long story [v]\n",
  "YARPHA": "(Old Norse) in Shetland, peaty soil; clayey, sandy or fibrous peat, also YARFA [n -S]\n",
  "YARPHAS": "YARPHA, (Old Norse) in Shetland, peaty soil; clayey, sandy or fibrous peat, also YARFA [n]\n",
  "YARR": "to growl or snarl [v -ED, -ING, -S]\n",
  "YARRAMAN": "(Native Australian) a horse [n YARRAMANS or YARRAMEN]\n",
  "YARRAMANS": "YARRAMAN, (Native Australian) a horse [n]\n",
  "YARRAMEN": "YARRAMAN, (Native Australian) a horse [n]\n",
  "YARRAN": "(Native Australian) a small eucalyptus tree [n -S]\n",
  "YARRANS": "YARRAN, (Native Australian) a small eucalyptus tree [n]\n",
  "YARRED": "YARR, to growl or snarl [v]\n",
  "YARRING": "YARR, to growl or snarl [v]\n",
  "YARROW": "a strongly-scented wild flower [n -S]\n",
  "YARROWS": "YARROW, a strongly-scented wild flower [n]\n",
  "YARRS": "YARR, to growl or snarl [v]\n",
  "YARTA": "(Old Norse) heart, used as term of endearment in the Shetlands, also JARTA, YARTO [n -S]\n",
  "YARTAS": "YARTA, (Old Norse) heart, used as term of endearment in the Shetlands, also JARTA, YARTO [n]\n",
  "YARTO": "heart, used as term of endearment in the Shetlands, also JARTA, YARTA [n -S]\n",
  "YARTOS": "YARTO, heart, used as term of endearment in the Shetlands, also JARTA, YARTA [n]\n",
  "YAS": "YA, an Asian pear [n]\n",
  "YASHMAC": "(Arabic) a double Muslim veil leaving only eyes uncovered, also YASHMAK, YASMAK [n -S]\n",
  "YASHMACS": "YASHMAC, (Arabic) a double Muslim veil leaving only eyes uncovered, also YASHMAK, YASMAK [n]\n",
  "YASHMAK": "(Arabic) a double Muslim veil leaving only eyes uncovered, also YASHMAC, YASMAK [n -S]\n",
  "YASHMAKS": "YASHMAK, (Arabic) a double Muslim veil leaving only eyes uncovered, also YASHMAC, YASMAK [n]\n",
  "YASMAK": "(Arabic) a double Muslim veil leaving only eyes uncovered, also YASHMAC, YASHMAK [n -S]\n",
  "YASMAKS": "YASMAK, (Arabic) a double Muslim veil leaving only eyes uncovered, also YASHMAC, YASHMAK [n]\n",
  "YATAGAN": "(Turkish) a Muslim long curved knife, also ATAGHAN, YATAGHAN [n -S]\n",
  "YATAGANS": "YATAGAN, (Turkish) a Muslim long curved knife, also ATAGHAN, YATAGHAN [n]\n",
  "YATAGHAN": "(Turkish) a Muslim long curved knife, also ATAGHAN, YATAGAN [n -S]\n",
  "YATAGHANS": "YATAGHAN, (Turkish) a Muslim long curved knife, also ATAGHAN, YATAGAN [n]\n",
  "YATE": "(Spenser) a gate, also YETT [n -S]\n",
  "YATES": "YATE, (Spenser) a gate, also YETT [n]\n",
  "YATTER": "to talk idly [v -ED, -ING, -S]\n",
  "YATTERED": "YATTER, to talk idly [v]\n",
  "YATTERING": "jabbering [adj YATTERINGLY] / the act of yattering [n -S]\n",
  "YATTERINGLY": "YATTERING, jabbering [adv]\n",
  "YATTERINGS": "YATTERING, the act of yattering [n]\n",
  "YATTERS": "YATTER, to talk idly [v]\n",
  "YAUD": "(Scots) a mare, a jade [n -S]\n",
  "YAUDS": "YAUD, (Scots) a mare, a jade [n]\n",
  "YAULD": "(Scots) active, nimble, also YALD [adj]\n",
  "YAUP": "to yelp or bark, also YAWP [v -ED, -ING, -S]\n",
  "YAUPED": "YAUP, to yelp or bark, also YAWP [v]\n",
  "YAUPER": "one who yaups, yelps or barks, also YAWPER [n -S]\n",
  "YAUPERS": "YAUPER, one who yaups, yelps or barks, also YAWPER [n]\n",
  "YAUPING": "YAUP, to yelp or bark, also YAWP [v]\n",
  "YAUPON": "(Catawba) a bushy evergreen shrub of the holly genus, also YAPON, YOUPON, YUPON [n -S]\n",
  "YAUPONS": "YAUPON, (Catawba) a bushy evergreen shrub of the holly genus, also YAPON, YOUPON, YUPON [n]\n",
  "YAUPS": "YAUP, to yelp or bark, also YAWP [v]\n",
  "YAUTIA": "(Taino) a tropical plant [n -S]\n",
  "YAUTIAS": "YAUTIA, (Taino) a tropical plant [n]\n",
  "YAW": "of e.g. a plane, to move from right to left in a horizontal plane [v -ED, -ING, -S]\n",
  "YAWED": "YAW, of e.g. a plane, to move from right to left in a horizontal plane [v]\n",
  "YAWEY": "pertaining to the disease yaws, also YAWY [adj YAWIER, YAWIEST]\n",
  "YAWIER": "YAWY, pertaining to the disease yaws, also YAWEY [adj]\n",
  "YAWIEST": "YAWY, pertaining to the disease yaws, also YAWEY [adj]\n",
  "YAWING": "YAW, of e.g. a plane, to move from right to left in a horizontal plane [v]\n",
  "YAWL": "to howl [v -ED, -ING, -S]\n",
  "YAWLED": "YAWL, to howl [v]\n",
  "YAWLING": "YAWL, to howl [v]\n",
  "YAWLS": "YAWL, to howl [v]\n",
  "YAWMETER": "an instrument in an aircraft [n -S]\n",
  "YAWMETERS": "YAWMETER, an instrument in an aircraft [n]\n",
  "YAWN": "to open the mouth in a large gape [v -ED, -ING, -S]\n",
  "YAWNED": "YAWN, to open the mouth in a large gape [v]\n",
  "YAWNER": "one who yawns [n -S]\n",
  "YAWNERS": "YAWNER, one who yawns [n]\n",
  "YAWNIER": "YAWNY, full of yawns [adj]\n",
  "YAWNIEST": "YAWNY, full of yawns [adj]\n",
  "YAWNING": "gaping [adj YAWNINGLY] / the act of yawning [n -S]\n",
  "YAWNINGLY": "YAWNING, gaping [adv]\n",
  "YAWNINGS": "YAWNING, the act of yawning [n]\n",
  "YAWNS": "YAWN, to open the mouth in a large gape [v]\n",
  "YAWNSOME": "dull and boring; tiresome [adj]\n",
  "YAWNY": "full of yawns [adj YAWNIER, YAWNIEST]\n",
  "YAWP": "to cry hoarsely or harshly, also YAUP [v -ED, -ING, -S]\n",
  "YAWPED": "YAWP, to cry hoarsely or harshly, also YAUP [v]\n",
  "YAWPER": "one who yawps, cries hoarsely, also YAUPER [n -S]\n",
  "YAWPERS": "YAWPER, one who yawps, cries hoarsely, also YAUPER [n]\n",
  "YAWPING": "the act of yelping [n -S]\n",
  "YAWPINGS": "YAWPING, the act of yelping [n]\n",
  "YAWPS": "YAWP, to cry hoarsely or harshly, also YAUP [v]\n",
  "YAWS": "YAW, of e.g. a plane, to move from right to left in a horizontal plane [v]\n",
  "YAWY": "pertaining to the disease yaws, also YAWEY [adj YAWIER, YAWIEST]\n",
  "YAY": "an affirmative vote, also YEA [n -S]\n",
  "YAYS": "YAY, an affirmative vote, also YEA [n]\n",
  "YBET": "BEAT, to strike repeatedly [v]\n",
  "YBLENT": "BLEND, to mix together [v]\n",
  "YBORE": "BEAR, to endure [v]\n",
  "YBOUND": "BIND, to tie, fasten [v]\n",
  "YBOUNDEN": "BIND, to tie, fasten [v]\n",
  "YBRENT": "BURN, to destroy by fire [v]\n",
  "YCLAD": "CLOTHE, to provide with clothing [v]\n",
  "YCLED": "CLOTHE, to provide with clothing [v]\n",
  "YCLEEPE": "(Spenser) to call by name, also CLEPE [v YCLEEPED, YCLEEPING, YCLEEPES]\n",
  "YCLEEPED": "YCLEEPE, (Spenser) to call by name, also CLEPE [v]\n",
  "YCLEEPES": "YCLEEPE, (Spenser) to call by name, also CLEPE [v]\n",
  "YCLEEPING": "YCLEEPE, (Spenser) to call by name, also CLEPE [v]\n",
  "YCLEPED": "CLEPE, (archaic) to call, name, also CLEEP [v]\n",
  "YCLEPT": "CLEPE, (archaic) to call, name, also CLEEP [v]\n",
  "YCOND": "CON, to study carefully [v]\n",
  "YDRAD": "DREAD, to fear greatly [v]\n",
  "YDRED": "DREAD, to fear greatly [v]\n",
  "YE": "(archaic) you [pron]\n",
  "YEA": "an affirmative vote, also YAY [n -S]\n",
  "YEAD": "(Spenser) to go, proceed, also YEDE, YEED [v YOD or YODE, YEADING, YEADS]\n",
  "YEADING": "YEAD, (Spenser) to go, proceed, also YEDE, YEED [v]\n",
  "YEADS": "YEAD, (Spenser) to go, proceed, also YEDE, YEED [v]\n",
  "YEAH": "an expression of yes, also YEH [n -S]\n",
  "YEAHS": "YEAH, an expression of yes, also YEH [n]\n",
  "YEALDON": "(Scott) fuel, also EILDING, ELDIN, ELDING [n -S]\n",
  "YEALDONS": "YEALDON, (Scott) fuel, also EILDING, ELDIN, ELDING [n]\n",
  "YEALING": "a person of the same age, also YEELIN [n -S]\n",
  "YEALINGS": "YEALING, a person of the same age, also YEELIN [n]\n",
  "YEALM": "to prepare straw for thatching, also YELM [v -ED, -ING, -S]\n",
  "YEALMED": "YEALM, to prepare straw for thatching, also YELM [v]\n",
  "YEALMING": "YEALM, to prepare straw for thatching, also YELM [v]\n",
  "YEALMS": "YEALM, to prepare straw for thatching, also YELM [v]\n",
  "YEAN": "esp. of a sheep, to bring forth young, also EAN [v -ED, -ING, -S]\n",
  "YEANED": "YEAN, esp. of a sheep, to bring forth young, also EAN [v]\n",
  "YEANING": "YEAN, esp. of a sheep, to bring forth young, also EAN [v]\n",
  "YEANLING": "an animal that is undergoing the process of weaning, also EANLING, WEANEL, WEANLING [n -S]\n",
  "YEANLINGS": "YEANLING, an animal that is undergoing the process of weaning, also EANLING, WEANEL, WEANLING [n]\n",
  "YEANS": "YEAN, esp. of a sheep, to bring forth young, also EAN [v]\n",
  "YEAR": "the time taken by the earth to orbit the sun [n -S]\n",
  "YEARBOOK": "a book published annually [n -S]\n",
  "YEARBOOKS": "YEARBOOK, a book published annually [n]\n",
  "YEARD": "(Scots) to bury, also EARD, YERD, YIRD, YIRTH [v -ED, -ING, -S]\n",
  "YEARDED": "YEARD, (Scots) to bury, also EARD, YERD, YIRD, YIRTH [v]\n",
  "YEARDING": "YEARD, (Scots) to bury, also EARD, YERD, YIRD, YIRTH [v]\n",
  "YEARDS": "YEARD, (Scots) to bury, also EARD, YERD, YIRD, YIRTH [v]\n",
  "YEAREND": "the end of the year [n -S]\n",
  "YEARENDS": "YEAREND, the end of the year [n]\n",
  "YEARLIES": "YEARLY, a once a year publication [n]\n",
  "YEARLING": "a horse of either sex during 1 January to 31 December following the year of its birth [n -S]\n",
  "YEARLINGS": "YEARLING, a horse of either sex during 1 January to 31 December following the year of its birth [n]\n",
  "YEARLONG": "lasting a year [adj]\n",
  "YEARLY": "a once a year publication [n YEARLIES]\n",
  "YEARN": "to long for [v -ED, -ING, -S]\n",
  "YEARNED": "YEARN, to long for [v]\n",
  "YEARNER": "one who yearns [n -S]\n",
  "YEARNERS": "YEARNER, one who yearns [n]\n",
  "YEARNING": "longing [adj YEARNINGLY] / a strong or deep desire [n -S]\n",
  "YEARNINGLY": "YEARNING, longing [adv]\n",
  "YEARNINGS": "YEARNING, a strong or deep desire [n]\n",
  "YEARNS": "YEARN, to long for [v]\n",
  "YEARS": "YEAR, the time taken by the earth to orbit the sun [n]\n",
  "YEAS": "YEA, an affirmative vote, also YAY [n]\n",
  "YEASAYER": "a person who (habitually) agrees or assents [n -S]\n",
  "YEASAYERS": "YEASAYER, a person who (habitually) agrees or assents [n]\n",
  "YEAST": "to ferment [v -ED, -ING, -S]\n",
  "YEASTED": "YEAST, to ferment [v]\n",
  "YEASTIER": "YEASTY, like yeast, also YESTY [adj]\n",
  "YEASTIEST": "YEASTY, like yeast, also YESTY [adj]\n",
  "YEASTILY": "YEASTY, like yeast, also YESTY [adv]\n",
  "YEASTINESS": "the state of being yeasty [n -ES]\n",
  "YEASTINESSES": "YEASTINESS, the state of being yeasty [n]\n",
  "YEASTING": "YEAST, to ferment [v]\n",
  "YEASTLESS": "without yeast [adj]\n",
  "YEASTLIKE": "like yeast, frothy [adj]\n",
  "YEASTS": "YEAST, to ferment [v]\n",
  "YEASTY": "like yeast, also YESTY [adj YEASTIER, YEASTIEST, YEASTILY]\n",
  "YEBO": "(South African) yes, I agree [interj]\n",
  "YECCH": "something disgusting [n -S]\n",
  "YECCHS": "YECCH, something disgusting [n]\n",
  "YECH": "something disgusting, also YECCH [n -S]\n",
  "YECHIER": "YECHY, disgusting [adj]\n",
  "YECHIEST": "YECHY, disgusting [adj]\n",
  "YECHS": "YECH, something disgusting, also YECCH [n]\n",
  "YECHY": "disgusting [adj YECHIER, YECHIEST]\n",
  "YEDE": "(Spenser) to go or proceed, also YEAD, YEED [v YOD or YODE, YEDING, YEDES]\n",
  "YEDES": "YEDE, (Spenser) to go or proceed, also YEAD, YEED [v]\n",
  "YEDING": "YEDE, (Spenser) to go or proceed, also YEAD, YEED [v]\n",
  "YEED": "(Spenser) to go or proceed, also YEAD, YEDE [v YOD or YODE, YEEDING, YEEDS]\n",
  "YEEDING": "YEED, (Spenser) to go or proceed, also YEAD, YEDE [v]\n",
  "YEEDS": "YEED, (Spenser) to go or proceed, also YEAD, YEDE [v]\n",
  "YEELIN": "a person of the same age, also YEALING [n -S]\n",
  "YEELINS": "YEELIN, a person of the same age, also YEALING [n]\n",
  "YEESH": "an interjection used to express frustration [interj]\n",
  "YEGG": "a burglar esp. of safes, also YEGGMAN [n -S]\n",
  "YEGGMAN": "a burglar esp. of safes, also YEGG [n YEGGMEN]\n",
  "YEGGMEN": "YEGGMAN, a burglar esp. of safes, also YEGG [n]\n",
  "YEGGS": "YEGG, a burglar esp. of safes, also YEGGMAN [n]\n",
  "YEH": "(colloquial) yes, also YEAH [interj]\n",
  "YELD": "barren, not giving milk [adj]\n",
  "YELDRING": "the yellowhammer, also YELDROCK, YOLDRING, YORLING, YOWLEY [n -S]\n",
  "YELDRINGS": "YELDRING, the yellowhammer, also YELDROCK, YOLDRING, YORLING, YOWLEY [n]\n",
  "YELDROCK": "the yellowhammer, also YELDRING, YOLDRING, YORLING, YOWLEY [n -S]\n",
  "YELDROCKS": "YELDROCK, the yellowhammer, also YELDRING, YOLDRING, YORLING, YOWLEY [n]\n",
  "YELK": "the yellow, fatty part of an egg, also YOLK [n -S]\n",
  "YELKS": "YELK, the yellow, fatty part of an egg, also YOLK [n]\n",
  "YELL": "to cry out loudly [v -ED, -ING, -S]\n",
  "YELLED": "YELL, to cry out loudly [v]\n",
  "YELLER": "one who cries out [n -S]\n",
  "YELLERS": "YELLER, one who cries out [n]\n",
  "YELLING": "the act of crying out [n -S]\n",
  "YELLINGS": "YELLING, the act of crying out [n]\n",
  "YELLOCH": "(Scots) to yell [v -ED, -ING, -S]\n",
  "YELLOCHED": "YELLOCH, (Scots) to yell [v]\n",
  "YELLOCHING": "YELLOCH, (Scots) to yell [v]\n",
  "YELLOCHS": "YELLOCH, (Scots) to yell [v]\n",
  "YELLOW": "of a bright color like that of ripe lemons [adj YELLOWER, YELLOWEST, YELLOWLY] / to make or become yellow [v -ED, -ING, -S]\n",
  "YELLOWBACK": "a cheap sensational novel [n -S]\n",
  "YELLOWBACKS": "YELLOWBACK, a cheap sensational novel [n]\n",
  "YELLOWBARK": "the calisaya tree [n -S]\n",
  "YELLOWBARKS": "YELLOWBARK, the calisaya tree [n]\n",
  "YELLOWBIRD": "the American goldfinch, or thistle bird [n -S]\n",
  "YELLOWBIRDS": "YELLOWBIRD, the American goldfinch, or thistle bird [n]\n",
  "YELLOWCAKE": "uranium oxide [n -S]\n",
  "YELLOWCAKES": "YELLOWCAKE, uranium oxide [n]\n",
  "YELLOWED": "YELLOW, to make or become yellow [v]\n",
  "YELLOWER": "YELLOW, of a bright color like that of ripe lemons [adj]\n",
  "YELLOWEST": "YELLOW, of a bright color like that of ripe lemons [adj]\n",
  "YELLOWFIN": "a kind of tuna with yellowish fins [n -S]\n",
  "YELLOWFINS": "YELLOWFIN, a kind of tuna with yellowish fins [n]\n",
  "YELLOWHAMMER": "a small yellow bird of the finch family [n -S]\n",
  "YELLOWHAMMERS": "YELLOWHAMMER, a small yellow bird of the finch family [n]\n",
  "YELLOWHEAD": "a species of flycatcher found in New Zealand, aka mohua [n -S]\n",
  "YELLOWHEADS": "YELLOWHEAD, a species of flycatcher found in New Zealand, aka mohua [n]\n",
  "YELLOWIER": "YELLOWY, yellowish [adj]\n",
  "YELLOWIEST": "YELLOWY, yellowish [adj]\n",
  "YELLOWING": "YELLOW, to make or become yellow [v]\n",
  "YELLOWISH": "somewhat yellow [adj]\n",
  "YELLOWISHNESS": "the state of being yellowish [n -ES]\n",
  "YELLOWISHNESSES": "YELLOWISHNESS, the state of being yellowish [n]\n",
  "YELLOWLEGS": "any one of several species of long-legged sandpipers, in which the legs are bright yellow [n]\n",
  "YELLOWLY": "YELLOW, of a bright color like that of ripe lemons [adv]\n",
  "YELLOWNESS": "the state of being yellow [n -ES]\n",
  "YELLOWNESSES": "YELLOWNESS, the state of being yellow [n]\n",
  "YELLOWS": "YELLOW, to make or become yellow [v]\n",
  "YELLOWTAIL": "any one of several species of marine carangoid fishes, esteemed as food fish [n -S]\n",
  "YELLOWTAILS": "YELLOWTAIL, any one of several species of marine carangoid fishes, esteemed as food fish [n]\n",
  "YELLOWTHROAT": "any of several largely olive American warblers [n -S]\n",
  "YELLOWTHROATS": "YELLOWTHROAT, any of several largely olive American warblers [n]\n",
  "YELLOWWARE": "pottery made from buff clay and covered with a transparent yellow clay [n -S]\n",
  "YELLOWWARES": "YELLOWWARE, pottery made from buff clay and covered with a transparent yellow clay [n]\n",
  "YELLOWWEED": "any of various yellow-flowered plants, such as the ragwort in Europe and some species of goldenrod in the US [n -S]\n",
  "YELLOWWEEDS": "YELLOWWEED, any of various yellow-flowered plants, such as the ragwort in Europe and some species of goldenrod in the US [n]\n",
  "YELLOWWOOD": "the wood of any one of several different kinds of trees [n -S]\n",
  "YELLOWWOODS": "YELLOWWOOD, the wood of any one of several different kinds of trees [n]\n",
  "YELLOWWORT": "a yellow-flowered plant of the gentian family [n -S]\n",
  "YELLOWWORTS": "YELLOWWORT, a yellow-flowered plant of the gentian family [n]\n",
  "YELLOWY": "yellowish [adj YELLOWIER, YELLOWIEST]\n",
  "YELLS": "YELL, to cry out loudly [v]\n",
  "YELM": "(dialect) to prepare straw for thatching, also YEALM [v -ED, -ING, -S]\n",
  "YELMED": "YELM, (dialect) to prepare straw for thatching, also YEALM [v]\n",
  "YELMING": "YELM, (dialect) to prepare straw for thatching, also YEALM [v]\n",
  "YELMS": "YELM, (dialect) to prepare straw for thatching, also YEALM [v]\n",
  "YELP": "to utter a sharp cry [v -ED, -ING, -S]\n",
  "YELPED": "YELP, to utter a sharp cry [v]\n",
  "YELPER": "one who yelps [n -S]\n",
  "YELPERS": "YELPER, one who yelps [n]\n",
  "YELPING": "the act of yelping [n -S]\n",
  "YELPINGS": "YELPING, the act of yelping [n]\n",
  "YELPS": "YELP, to utter a sharp cry [v]\n",
  "YELT": "(dialect) a young sow, also ELT, GILT [n -S]\n",
  "YELTS": "YELT, (dialect) a young sow, also ELT, GILT [n]\n",
  "YEMMER": "(dialect) an ember [n -S]\n",
  "YEMMERS": "YEMMER, (dialect) an ember [n]\n",
  "YEN": "to desire or yearn [v YENNED, YENNING, YENS]\n",
  "YENNED": "YEN, to desire or yearn [v]\n",
  "YENNING": "YEN, to desire or yearn [v]\n",
  "YENS": "YEN, to desire or yearn [v]\n",
  "YENTA": "(Yiddish) a gossipy woman, esp. one who pries, also YENTE [n -S]\n",
  "YENTAS": "YENTA, (Yiddish) a gossipy woman, esp. one who pries, also YENTE [n]\n",
  "YENTE": "(Yiddish) a gossipy woman, esp. one who pries, also YENTA [n -S]\n",
  "YENTES": "YENTE, (Yiddish) a gossipy woman, esp. one who pries, also YENTA [n]\n",
  "YEOMAN": "a member of a class of small farmers, usually freeholders, the next grade below gentlemen [n YEOMEN]\n",
  "YEOMANLY": "of yeoman rank [adj]\n",
  "YEOMANRIES": "YEOMANRY, a collective body of yeomen [n]\n",
  "YEOMANRY": "a collective body of yeomen [n YEOMANRIES]\n",
  "YEOMEN": "YEOMAN, a member of a class of small farmers, usually freeholders, the next grade below gentlemen [n]\n",
  "YEOW": "an interjection used to express pain or shock [interj]\n",
  "YEP": "(colloquial) yes, also YUP [n -S]\n",
  "YEPS": "YEP, (colloquial) yes, also YUP [n]\n",
  "YER": "(colloquial) your; you [adj]\n",
  "YERBA": "(Spanish) an infusion of the leaves of a South American shrub [n -S]\n",
  "YERBAS": "YERBA, (Spanish) an infusion of the leaves of a South American shrub [n]\n",
  "YERD": "(Scots) to bury, also EARD, YEARD, YIRD, YIRTH [v -ED, -ING, -S]\n",
  "YERDED": "YERD, (Scots) to bury, also EARD, YEARD, YIRD, YIRTH [v]\n",
  "YERDING": "YERD, (Scots) to bury, also EARD, YEARD, YIRD, YIRTH [v]\n",
  "YERDS": "YERD, (Scots) to bury, also EARD, YEARD, YIRD, YIRTH [v]\n",
  "YERK": "to tie with a jerk, also YIRK [v -ED, -ING, -S]\n",
  "YERKED": "YERK, to tie with a jerk, also YIRK [v]\n",
  "YERKING": "YERK, to tie with a jerk, also YIRK [v]\n",
  "YERKS": "YERK, to tie with a jerk, also YIRK [v]\n",
  "YERSINIA": "a bacterium spread by birds and animals, causing plague [n YERSINIAS or YERSINIAE]\n",
  "YERSINIAE": "YERSINIA, a bacterium spread by birds and animals, causing plague [n]\n",
  "YERSINIAS": "YERSINIA, a bacterium spread by birds and animals, causing plague [n]\n",
  "YERSINIOSES": "YERSINIOSIS, an acute infection of the small intestine [n]\n",
  "YERSINIOSIS": "an acute infection of the small intestine [n YERSINIOSES]\n",
  "YES": "an affirmative reply [n YESES or YESSES] / to give an affirmative reply to [v YESSED, YESSING, YESSES]\n",
  "YESES": "YES, to give an affirmative reply to [v]\n",
  "YESHIVA": "(Hebrew) a school for the study of the Jewish scripture, the Talmud, also YESHIVAH [n YESHIVAS or YESHIVOT or YESHIVOTH]\n",
  "YESHIVAH": "(Hebrew) a school for the study of the Jewish scripture, the Talmud, also YESHIVA [n -S]\n",
  "YESHIVAHS": "YESHIVAH, (Hebrew) a school for the study of the Jewish scripture, the Talmud, also YESHIVA [n]\n",
  "YESHIVAS": "YESHIVA, (Hebrew) a school for the study of the Jewish scripture, the Talmud, also YESHIVAH [n]\n",
  "YESHIVOT": "YESHIVA, (Hebrew) a school for the study of the Jewish scripture, the Talmud, also YESHIVAH [n]\n",
  "YESHIVOTH": "YESHIVA, (Hebrew) a school for the study of the Jewish scripture, the Talmud, also YESHIVAH [n]\n",
  "YESK": "(Scots) to hiccup or belch, also YEX [v -ED, -ING, -S]\n",
  "YESKED": "YESK, (Scots) to hiccup or belch, also YEX [v]\n",
  "YESKING": "YESK, (Scots) to hiccup or belch, also YEX [v]\n",
  "YESKS": "YESK, (Scots) to hiccup or belch, also YEX [v]\n",
  "YESSED": "YES, to give an affirmative reply to [v]\n",
  "YESSES": "YES, to give an affirmative reply to [v]\n",
  "YESSING": "YES, to give an affirmative reply to [v]\n",
  "YESSIR": "an interjection used to express assent, also YESSIREE [interj]\n",
  "YESSIREE": "an interjection used to express assent, also YESSIR [interj]\n",
  "YESSUM": "an interjection used to express assent to a woman [interj]\n",
  "YEST": "(obsolete) yeast [n -S]\n",
  "YESTER": "pertaining to yesterday, also YESTERN [adj]\n",
  "YESTERDAY": "on the day immediately before today [adv] / the day immediately before today [n -S]\n",
  "YESTERDAYS": "YESTERDAY, the day immediately before today [n]\n",
  "YESTEREVE": "yesterday evening, also YESTEREVEN, YESTEREVENING, YESTREEN [n -S]\n",
  "YESTEREVEN": "yesterday evening, also YESTEREVE, YESTEREVENING, YESTREEN [n -S]\n",
  "YESTEREVENING": "yesterday evening, also YESTEREVE, YESTEREVEN, YESTREEN [n -S]\n",
  "YESTEREVENINGS": "YESTEREVENING, yesterday evening, also YESTEREVE, YESTEREVEN, YESTREEN [n]\n",
  "YESTEREVENS": "YESTEREVEN, yesterday evening, also YESTEREVE, YESTEREVENING, YESTREEN [n]\n",
  "YESTEREVES": "YESTEREVE, yesterday evening, also YESTEREVEN, YESTEREVENING, YESTREEN [n]\n",
  "YESTERMORN": "yesterday morning [n -S]\n",
  "YESTERMORNING": "yesterday evening or morning [n -S]\n",
  "YESTERMORNINGS": "YESTERMORNING, yesterday evening or morning [n]\n",
  "YESTERMORNS": "YESTERMORN, yesterday morning [n]\n",
  "YESTERN": "pertaining to yesterday, also YESTER [adj]\n",
  "YESTERNIGHT": "(dialect) last night [n -S]\n",
  "YESTERNIGHTS": "YESTERNIGHT, (dialect) last night [n]\n",
  "YESTERYEAR": "last year, or the past in general [n -S]\n",
  "YESTERYEARS": "YESTERYEAR, last year, or the past in general [n]\n",
  "YESTREEN": "the evening of yesterday, also YESTEREVE, YESTEREVEN, YESTEREVENING [n -S]\n",
  "YESTREENS": "YESTREEN, the evening of yesterday, also YESTEREVE, YESTEREVEN, YESTEREVENING [n]\n",
  "YESTS": "YEST, (obsolete) yeast [n]\n",
  "YESTY": "like yeast, also YEASTY [adj]\n",
  "YET": "in addition, besides; nevertheless [adv]\n",
  "YETI": "(Tibetan) the Abominable Snowman [n -S]\n",
  "YETIS": "YETI, (Tibetan) the Abominable Snowman [n]\n",
  "YETT": "(Scots) a gate, door, also YATE [n -S]\n",
  "YETTIE": "(colloquial) a young, entrepreneurial and technology-based person [n -S]\n",
  "YETTIES": "YETTIE, (colloquial) a young, entrepreneurial and technology-based person [n]\n",
  "YETTS": "YETT, (Scots) a gate, door, also YATE [n]\n",
  "YEUK": "(dialect) to itch, also EUK, EWK, YOUK, YUKE [v -ED, -ING, -S]\n",
  "YEUKED": "YEUK, (dialect) to itch, also EUK, EWK, YOUK, YUKE [v]\n",
  "YEUKIER": "YEUKY, itchy [adj]\n",
  "YEUKIEST": "YEUKY, itchy [adj]\n",
  "YEUKING": "YEUK, (dialect) to itch, also EUK, EWK, YOUK, YUKE [v]\n",
  "YEUKS": "YEUK, (dialect) to itch, also EUK, EWK, YOUK, YUKE [v]\n",
  "YEUKY": "itchy [adj YEUKIER, YEUKIEST]\n",
  "YEVE": "(obsolete) to give [v YEVEN, YEVING, YEVES]\n",
  "YEVEN": "YEVE, (obsolete) to give [v]\n",
  "YEVES": "YEVE, (obsolete) to give [v]\n",
  "YEVING": "YEVE, (obsolete) to give [v]\n",
  "YEW": "a type of evergreen tree, also EUGH [n -S]\n",
  "YEWEN": "(archaic) made of yew wood, also EUGHEN, EWGHEN [adj]\n",
  "YEWS": "YEW, a type of evergreen tree, also EUGH [n]\n",
  "YEX": "to hiccup, also YESK [v -ED, -ING, -ES]\n",
  "YEXED": "YEX, to hiccup, also YESK [v]\n",
  "YEXES": "YEX, to hiccup, also YESK [v]\n",
  "YEXING": "YEX, to hiccup, also YESK [v]\n",
  "YEZ": "(colloquial) yes [interj]\n",
  "YFERE": "(obsolete) a friend, comrade, companion, or associate [n -S]\n",
  "YFERES": "YFERE, (obsolete) a friend, comrade, companion, or associate [n]\n",
  "YGLAUNST": "GLANCE, to look quickly [v]\n",
  "YGO": "GO, to move along [v]\n",
  "YGOE": "GO, to move along [v]\n",
  "YIBBLES": "(Scots) perhaps, also ABLINGS, ABLINS, AIBLINS [adv]\n",
  "YICKER": "to utter sharp little cries of an animal, also YIKKER [v -ED, -ING, -S]\n",
  "YICKERED": "YICKER, to utter sharp little cries of an animal, also YIKKER [v]\n",
  "YICKERING": "YICKER, to utter sharp little cries of an animal, also YIKKER [v]\n",
  "YICKERS": "YICKER, to utter sharp little cries of an animal, also YIKKER [v]\n",
  "YID": "(offensive) a Jew [n -S]\n",
  "YIDAKI": "(Native Australian) a long wooden wind instrument played by the Aboriginal people of Arnhem Land [n -S]\n",
  "YIDAKIS": "YIDAKI, (Native Australian) a long wooden wind instrument played by the Aboriginal people of Arnhem Land [n]\n",
  "YIDS": "YID, (offensive) a Jew [n]\n",
  "YIELD": "to give up [v YIELDED or (obsolete) YOLD, YIELDING, YIELDS]\n",
  "YIELDABLE": "disposed to yield or comply [adj]\n",
  "YIELDABLENESS": "the quality of being yieldable [n -ES]\n",
  "YIELDABLENESSES": "YIELDABLENESS, the quality of being yieldable [n]\n",
  "YIELDED": "YIELD, to give up [v]\n",
  "YIELDER": "one who yields [n -S]\n",
  "YIELDERS": "YIELDER, one who yields [n]\n",
  "YIELDING": "giving way, compliant [adj YIELDINGLY] / a giving way [n -S]\n",
  "YIELDINGLY": "YIELDING, giving way, compliant [adv]\n",
  "YIELDINGNESS": "the quality of being yielding [n -ES]\n",
  "YIELDINGNESSES": "YIELDINGNESS, the quality of being yielding [n]\n",
  "YIELDINGS": "YIELDING, a giving way [n]\n",
  "YIELDS": "YIELD, to give up [v]\n",
  "YIKE": "(Australian slang) to squabble, argue [v YIKED, YIKING, YIKES]\n",
  "YIKED": "YIKE, (Australian slang) to squabble, argue [v]\n",
  "YIKES": "YIKE, (Australian slang) to squabble, argue [v]\n",
  "YIKING": "YIKE, (Australian slang) to squabble, argue [v]\n",
  "YIKKER": "to utter sharp little cries of an animal, also YICKER [v -ED, -ING, -S]\n",
  "YIKKERED": "YIKKER, to utter sharp little cries of an animal, also YICKER [v]\n",
  "YIKKERING": "YIKKER, to utter sharp little cries of an animal, also YICKER [v]\n",
  "YIKKERS": "YIKKER, to utter sharp little cries of an animal, also YICKER [v]\n",
  "YILL": "(Scots) to entertain or delight with ale [v -ED, -ING, -S]\n",
  "YILLED": "YILL, (Scots) to entertain or delight with ale [v]\n",
  "YILLING": "YILL, (Scots) to entertain or delight with ale [v]\n",
  "YILLS": "YILL, (Scots) to entertain or delight with ale [v]\n",
  "YIN": "(Scots) one, also ANE [n -S]\n",
  "YINCE": "(Scots) once, also ANCE [adv]\n",
  "YINDIE": "a person in his or her early 30's who combines a lucrative career with nonmainstream tastes [n -S]\n",
  "YINDIES": "YINDIE, a person in his or her early 30's who combines a lucrative career with nonmainstream tastes [n]\n",
  "YINGYANG": "(Chinese) (in Chinese philosophy and religion) two principles, one negative, dark, and feminine (yin) and one positive, bright, and masculine (yang) whose interaction influences the destinies of creatures and things [n -S]\n",
  "YINGYANGS": "YINGYANG, (Chinese) (in Chinese philosophy and religion) two principles, one negative, dark, and feminine (yin) and one positive, bright, and masculine (yang) whose interaction influences the destinies of creatures and things [n]\n",
  "YINS": "YIN, (Scots) one, also ANE [n]\n",
  "YIP": "to utter a short, sudden cry [v YIPPED, YIPPING, YIPS]\n",
  "YIPE": "an interjection expressing fear or surprise, also YIPES [interj]\n",
  "YIPES": "used to express fear or surprise, also YIPE [interj]\n",
  "YIPPED": "YIP, to utter a short, sudden cry [v]\n",
  "YIPPEE": "an exclamation of delight [interj]\n",
  "YIPPER": "a golfer suffering from yips [n -S]\n",
  "YIPPERS": "YIPPER, a golfer suffering from yips [n]\n",
  "YIPPIE": "a member of a radical political group founded in 1967 with ideals based on those of the hippies, also YIPPY [n -S]\n",
  "YIPPIES": "YIPPY, a member of a radical political group founded in 1967 with ideals based on those of the hippies, also YIPPIE [n]\n",
  "YIPPING": "YIP, to utter a short, sudden cry [v]\n",
  "YIPPY": "a member of a radical political group founded in 1967 with ideals based on those of the hippies, also YIPPIE [n YIPPIES]\n",
  "YIPS": "YIP, to utter a short, sudden cry [v]\n",
  "YIRD": "(Scots) to bury, also EARD, YEARD, YERD, YIRTH [v -ED, -ING, -S]\n",
  "YIRDED": "YIRD, (Scots) to bury, also EARD, YEARD, YERD, YIRTH [v]\n",
  "YIRDING": "YIRD, (Scots) to bury, also EARD, YEARD, YERD, YIRTH [v]\n",
  "YIRDS": "YIRD, (Scots) to bury, also EARD, YEARD, YERD, YIRTH [v]\n",
  "YIRK": "to draw tight [v -ED, -ING, -S]\n",
  "YIRKED": "YIRK, to draw tight [v]\n",
  "YIRKING": "YIRK, to draw tight [v]\n",
  "YIRKS": "YIRK, to draw tight [v]\n",
  "YIRR": "to snarl [v -ED, -ING, -S]\n",
  "YIRRED": "YIRR, to snarl [v]\n",
  "YIRRING": "YIRR, to snarl [v]\n",
  "YIRRS": "YIRR, to snarl [v]\n",
  "YIRTH": "(US) earth [n -S]\n",
  "YIRTHS": "YIRTH, (US) earth [n]\n",
  "YITE": "(dialect) the yellowhammer, also YITIE [n -S]\n",
  "YITES": "YITE, (dialect) the yellowhammer, also YITIE [n]\n",
  "YITIE": "(Scots) the yellowhammer, also YITE [n -S]\n",
  "YITIES": "YITIE, (Scots) the yellowhammer, also YITE [n]\n",
  "YITTEN": "(dialect) frightened [adj]\n",
  "YLEM": "a form of matter hypothesized by proponents of the big bang theory to have existed before the formation of the chemical elements [n -S]\n",
  "YLEMS": "YLEM, a form of matter hypothesized by proponents of the big bang theory to have existed before the formation of the chemical elements [n]\n",
  "YLIKE": "(Spenser) alike [adj]\n",
  "YLKE": "(obsolete) ilk [n -S]\n",
  "YLKES": "YLKE, (obsolete) ilk [n]\n",
  "YMOLT": "MELT, to change from a solid to a liquid state by heat [v]\n",
  "YMOLTEN": "MELT, to change from a solid to a liquid state by heat [v]\n",
  "YMPE": "(Spenser) to imp [v YMPT, YMPING, YMPES]\n",
  "YMPES": "YMPE, (Spenser) to imp [v]\n",
  "YMPING": "YMPE, (Spenser) to imp [v]\n",
  "YMPT": "YMPE, (Spenser) to imp [v]\n",
  "YNAMBU": "(Tupi) a South American bird, a large tinamou [n -S]\n",
  "YNAMBUS": "YNAMBU, (Tupi) a South American bird, a large tinamou [n]\n",
  "YO": "an expression of calling for attention [interj]\n",
  "YOB": "a lout, also YOBBO [n -S]\n",
  "YOBBERIES": "YOBBERY, loutish behaviour, also YOBBISM [n]\n",
  "YOBBERY": "loutish behaviour, also YOBBISM [n YOBBERIES]\n",
  "YOBBIER": "YOBBY, resembling a yob [adj]\n",
  "YOBBIEST": "YOBBY, resembling a yob [adj]\n",
  "YOBBISH": "like a yob [adj YOBBISHLY]\n",
  "YOBBISHLY": "YOBBISH, like a yob [adv]\n",
  "YOBBISM": "loutish behaviour, also YOBBERY [n -S]\n",
  "YOBBISMS": "YOBBISM, loutish behaviour, also YOBBERY [n]\n",
  "YOBBO": "(slang) a yob, a hoodlum [n YOBBOS or YOBBOES]\n",
  "YOBBOES": "YOBBO, (slang) a yob, a hoodlum [n]\n",
  "YOBBOS": "YOBBO, (slang) a yob, a hoodlum [n]\n",
  "YOBBY": "resembling a yob [adj YOBBIER, YOBBIEST]\n",
  "YOBS": "YOB, a lout, also YOBBO [n]\n",
  "YOCK": "to laugh boisterously also YOK [v -ED, -ING, -S]\n",
  "YOCKED": "YOCK, to laugh boisterously also YOK [v]\n",
  "YOCKING": "YOCK, to laugh boisterously also YOK [v]\n",
  "YOCKS": "YOCK, to laugh boisterously also YOK [v]\n",
  "YOCTOSECOND": "a very small unit of time [n -S]\n",
  "YOCTOSECONDS": "YOCTOSECOND, a very small unit of time [n]\n",
  "YOD": "(Hebrew) a Hebrew letter, also YODH [n -S]\n",
  "YODE": "YEAD, (Spenser) to go, proceed, also YEDE, YEED [v]\n",
  "YODEL": "(German) to sing with a fluctuating voice, also JODEL, YODLE [v YODELLED or YODELED, YODELLING or YODELING, YODELS]\n",
  "YODELED": "YODEL, (German) to sing with a fluctuating voice, also JODEL, YODLE [v]\n",
  "YODELER": "one who yodels, also YODELLER [n -S]\n",
  "YODELERS": "YODELER, one who yodels, also YODELLER [n]\n",
  "YODELING": "singing that changes rapidly from normal to falsetto, also YODELLING [n -S]\n",
  "YODELINGS": "YODELING, singing that changes rapidly from normal to falsetto, also YODELLING [n]\n",
  "YODELLED": "YODEL, (German) to sing with a fluctuating voice, also JODEL, YODLE [v]\n",
  "YODELLER": "one who yodels, also YODELER [n -S]\n",
  "YODELLERS": "YODELLER, one who yodels, also YODELER [n]\n",
  "YODELLING": "singing that changes rapidly from normal to falsetto, also YODELING [n -S]\n",
  "YODELLINGS": "YODELLING, singing that changes rapidly from normal to falsetto, also YODELING [n]\n",
  "YODELS": "YODEL, (German) to sing with a fluctuating voice, also JODEL, YODLE [v]\n",
  "YODH": "(Hebrew) a Hebrew letter, also YOD [n -S]\n",
  "YODHS": "YODH, (Hebrew) a Hebrew letter, also YOD [n]\n",
  "YODLE": "(German) to sing with a fluctuating voice, also JODEL, YODEL [v YODLED, YODLING, YODLES]\n",
  "YODLED": "YODLE, (German) to sing with a fluctuating voice, also JODEL, YODEL [v]\n",
  "YODLER": "one who yodels, also YODELER, YODELLER [n -S]\n",
  "YODLERS": "YODLER, one who yodels, also YODELER, YODELLER [n]\n",
  "YODLES": "YODLE, (German) to sing with a fluctuating voice, also JODEL, YODEL [v]\n",
  "YODLING": "YODLE, (German) to sing with a fluctuating voice, also JODEL, YODEL [v]\n",
  "YODS": "YOD, (Hebrew) a Hebrew letter, also YODH [n]\n",
  "YOGA": "(Sanskrit) a system of Hindu philosophy [n -S]\n",
  "YOGAS": "YOGA, (Sanskrit) a system of Hindu philosophy [n]\n",
  "YOGEE": "one who practises yoga, also YOGI, YOGIN [n -S]\n",
  "YOGEES": "YOGEE, one who practises yoga, also YOGI, YOGIN [n]\n",
  "YOGH": "the Middle English letter representing a velar or partial fricative [n -S]\n",
  "YOGHOURT": "(Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHURT, YOGOURT, YOGURT [n -S]\n",
  "YOGHOURTS": "YOGHOURT, (Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHURT, YOGOURT, YOGURT [n]\n",
  "YOGHS": "YOGH, the Middle English letter representing a velar or partial fricative [n]\n",
  "YOGHURT": "(Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHOURT, YOGOURT, YOGURT [n -S]\n",
  "YOGHURTS": "YOGHURT, (Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHOURT, YOGOURT, YOGURT [n]\n",
  "YOGI": "(Sanskrit) one who practises yoga, also YOGEE, YOGIN [n -S]\n",
  "YOGIC": "relating to yoga [adj]\n",
  "YOGIN": "one who practices yoga, also YOGEE, YOGI [n -S]\n",
  "YOGINI": "a female yogi [n -S]\n",
  "YOGINIS": "YOGINI, a female yogi [n]\n",
  "YOGINS": "YOGIN, one who practices yoga, also YOGEE, YOGI [n]\n",
  "YOGIS": "YOGI, (Sanskrit) one who practises yoga, also YOGEE, YOGIN [n]\n",
  "YOGISM": "the art of yogi [n -S]\n",
  "YOGISMS": "YOGISM, the art of yogi [n]\n",
  "YOGOURT": "(Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHOURT, YOGHURT, YOGURT [n -S]\n",
  "YOGOURTS": "YOGOURT, (Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHOURT, YOGHURT, YOGURT [n]\n",
  "YOGURT": "(Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHOURT, YOGHURT, YOGOURT [n -S]\n",
  "YOGURTS": "YOGURT, (Turkish) a semisolid, somewhat sour foodstuff, made from milk curdled by the addition of certain bacteria, also YAOURT, YOGHOURT, YOGHURT, YOGOURT [n]\n",
  "YOHIMBE": "(Bantu) a tropical African tree [n -S]\n",
  "YOHIMBES": "YOHIMBE, (Bantu) a tropical African tree [n]\n",
  "YOHIMBINE": "(Bantu) an alkaloid obtained from the bark of a West African tree [n -S]\n",
  "YOHIMBINES": "YOHIMBINE, (Bantu) an alkaloid obtained from the bark of a West African tree [n]\n",
  "YOICK": "to cry out an old foxhunting cry, also YOICKS [v -ED, -ING, -S]\n",
  "YOICKED": "YOICK, to cry out an old foxhunting cry, also YOICKS [v]\n",
  "YOICKING": "YOICK, to cry out an old foxhunting cry, also YOICKS [v]\n",
  "YOICKS": "to cry out an old foxhunting cry, also YOICK [v -ED, -ING, -ES]\n",
  "YOICKSED": "YOICKS, to cry out an old foxhunting cry, also YOICK [v]\n",
  "YOICKSES": "YOICKS, to cry out an old foxhunting cry, also YOICK [v]\n",
  "YOICKSING": "YOICKS, to cry out an old foxhunting cry, also YOICK [v]\n",
  "YOJAN": "(Hindi) in the Indian subcontinent, a measure of distance, also YOJANA [n -S]\n",
  "YOJANA": "(Hindi) in the Indian subcontinent, a measure of distance, also YOJAN [n -S]\n",
  "YOJANAS": "YOJANA, (Hindi) in the Indian subcontinent, a measure of distance, also YOJAN [n]\n",
  "YOJANS": "YOJAN, (Hindi) in the Indian subcontinent, a measure of distance, also YOJANA [n]\n",
  "YOK": "to laugh loudly, also YOCK, YUCK, YUK [v YOKKED, YOKKING, YOKS]\n",
  "YOKE": "to join (animals, slaves) together with a wooden frame [v YOKED, YOKING, YOKES]\n",
  "YOKED": "YOKE, to join (animals, slaves) together with a wooden frame [v]\n",
  "YOKEFELLOW": "a mate; a fellow; esp. a partner in marriage [n -S]\n",
  "YOKEFELLOWS": "YOKEFELLOW, a mate; a fellow; esp. a partner in marriage [n]\n",
  "YOKEL": "a country bumpkin [n -S]\n",
  "YOKELESS": "without a yoke [adj]\n",
  "YOKELISH": "like a country bumpkin [adj]\n",
  "YOKELS": "YOKEL, a country bumpkin [n]\n",
  "YOKEMATE": "a working companion [n -S]\n",
  "YOKEMATES": "YOKEMATE, a working companion [n]\n",
  "YOKER": "to spit [v -ED, -ING, -S]\n",
  "YOKERED": "YOKER, to spit [v]\n",
  "YOKERING": "YOKER, to spit [v]\n",
  "YOKERS": "YOKER, to spit [v]\n",
  "YOKES": "YOKE, to join (animals, slaves) together with a wooden frame [v]\n",
  "YOKING": "(dialect) as much work as is done at one time [n -S]\n",
  "YOKINGS": "YOKING, (dialect) as much work as is done at one time [n]\n",
  "YOKKED": "YOK, to laugh loudly, also YOCK, YUCK, YUK [v]\n",
  "YOKKING": "YOK, to laugh loudly, also YOCK, YUCK, YUK [v]\n",
  "YOKOZUNA": "(Japanese) a champion sumo wrestler [n -S]\n",
  "YOKOZUNAS": "YOKOZUNA, (Japanese) a champion sumo wrestler [n]\n",
  "YOKS": "YOK, to laugh loudly, also YOCK, YUCK, YUK [v]\n",
  "YOKUL": "(Shetlands) yes (literally yes, carl i.e. yes, fellow), also JOKOL [interj]\n",
  "YOLD": "YIELD, to give up [v]\n",
  "YOLDRING": "the yellowhammer, also YELDRING, YELDROCK, YORLING, YOWLEY [n -S]\n",
  "YOLDRINGS": "YOLDRING, the yellowhammer, also YELDRING, YELDROCK, YORLING, YOWLEY [n]\n",
  "YOLK": "the yellow, fatty part of an egg, also YELK [n -S]\n",
  "YOLKED": "having a yolk [adj]\n",
  "YOLKIER": "YOLKY, like yolk [adj]\n",
  "YOLKIEST": "YOLKY, like yolk [adj]\n",
  "YOLKLESS": "having no yolk [adj]\n",
  "YOLKS": "YOLK, the yellow, fatty part of an egg, also YELK [n]\n",
  "YOLKY": "like yolk [adj YOLKIER, YOLKIEST]\n",
  "YOM": "a Jewish day, esp. in a religious context [n YOMIM]\n",
  "YOMIM": "YOM, a Jewish day, esp. in a religious context [n]\n",
  "YOMP": "to march with heavy equipment over difficult terrain; to cover a certain distance in this way [v -ED, -ING, -S]\n",
  "YOMPED": "YOMP, to march with heavy equipment over difficult terrain; to cover a certain distance in this way [v]\n",
  "YOMPING": "YOMP, to march with heavy equipment over difficult terrain; to cover a certain distance in this way [v]\n",
  "YOMPS": "YOMP, to march with heavy equipment over difficult terrain; to cover a certain distance in this way [v]\n",
  "YON": "over there, also THON, THONDER, YOND, YONDER, YONT [adj]\n",
  "YOND": "over there, also THON, THONDER, YON, YONDER, YONT [adv]\n",
  "YONDER": "over there, also THON, THONDER, YON, YOND, YONT [adj] / the distance [n -S]\n",
  "YONDERLY": "(dialect) mentally or emotionally distant; absentminded [adj]\n",
  "YONDERS": "YONDER, the distance [n]\n",
  "YONI": "(Sanskrit) a representation of the female genitals [n -S]\n",
  "YONIC": "pertaining to the yoni [adj]\n",
  "YONIS": "YONI, (Sanskrit) a representation of the female genitals [n]\n",
  "YONKER": "(obsolete) a young person, also YOUNKER [n -S]\n",
  "YONKERS": "YONKER, (obsolete) a young person, also YOUNKER [n]\n",
  "YONKS": "(colloquial) ages, a long time [n]\n",
  "YONNIE": "(Australian slang) a child's word for a stone [n -S]\n",
  "YONNIES": "YONNIE, (Australian slang) a child's word for a stone [n]\n",
  "YONT": "over there, also THON, THONDER, YON, YOND, YONDER [adj]\n",
  "YOOF": "youth, young people [n -S]\n",
  "YOOFS": "YOOF, youth, young people [n]\n",
  "YOOP": "a sobbing sound [n -S]\n",
  "YOOPS": "YOOP, a sobbing sound [n]\n",
  "YOPPER": "a young person employed through a youth employment programme [n -S]\n",
  "YOPPERS": "YOPPER, a young person employed through a youth employment programme [n]\n",
  "YORE": "a long time ago [n -S]\n",
  "YORES": "YORE, a long time ago [n]\n",
  "YORK": "to bowl a batsman with a yorker [v -ED, -ING, -S]\n",
  "YORKED": "YORK, to bowl a batsman with a yorker [v]\n",
  "YORKER": "a kind of delivery in cricket [n -S]\n",
  "YORKERS": "YORKER, a kind of delivery in cricket [n]\n",
  "YORKIE": "a Yorkshire terrier [n -S]\n",
  "YORKIES": "YORKIE, a Yorkshire terrier [n]\n",
  "YORKING": "YORK, to bowl a batsman with a yorker [v]\n",
  "YORKS": "YORK, to bowl a batsman with a yorker [v]\n",
  "YORLING": "as in yellow yorling, a yellowhammer, also YELDRING, YELDROCK, YOLDRING, YOWLEY [n -S]\n",
  "YORLINGS": "YORLING, as in yellow yorling, a yellowhammer, also YELDRING, YELDROCK, YOLDRING, YOWLEY [n]\n",
  "YORP": "(dialect) to shout [v -ED, -ING, -S]\n",
  "YORPED": "YORP, (dialect) to shout [v]\n",
  "YORPING": "YORP, (dialect) to shout [v]\n",
  "YORPS": "YORP, (dialect) to shout [v]\n",
  "YOTTABYTE": "a very large unit of computer memory [n -S]\n",
  "YOTTABYTES": "YOTTABYTE, a very large unit of computer memory [n]\n",
  "YOU": "a pronoun referring to the person being addressed [pron YOUS, YOUSE]\n",
  "YOUK": "(dialect) to itch, also EUK, EWK, YEUK, YUKE [v -ED, -ING, -S]\n",
  "YOUKED": "YOUK, (dialect) to itch, also EUK, EWK, YEUK, YUKE [v]\n",
  "YOUKING": "YOUK, (dialect) to itch, also EUK, EWK, YEUK, YUKE [v]\n",
  "YOUKS": "YOUK, (dialect) to itch, also EUK, EWK, YEUK, YUKE [v]\n",
  "YOUNG": "born recently [adj YOUNGER, YOUNGEST, YOUNGLY] / the young of a species [n -S]\n",
  "YOUNGBERRIES": "YOUNGBERRY, a large reddish-black fruit, a cross between a blackberry and a dewberry [n]\n",
  "YOUNGBERRY": "a large reddish-black fruit, a cross between a blackberry and a dewberry [n YOUNGBERRIES]\n",
  "YOUNGER": "an inferior in age [n -S]\n",
  "YOUNGERS": "YOUNGER, an inferior in age [n]\n",
  "YOUNGEST": "YOUNG, born recently [adj]\n",
  "YOUNGISH": "somewhat young [adj]\n",
  "YOUNGLING": "(archaic) a young person or animal [n -S]\n",
  "YOUNGLINGS": "YOUNGLING, (archaic) a young person or animal [n]\n",
  "YOUNGLY": "in the manner of youth [adv]\n",
  "YOUNGNESS": "the state of being young [n -ES]\n",
  "YOUNGNESSES": "YOUNGNESS, the state of being young [n]\n",
  "YOUNGS": "YOUNG, the young of a species [n]\n",
  "YOUNGSTER": "a young person [n -S]\n",
  "YOUNGSTERS": "YOUNGSTER, a young person [n]\n",
  "YOUNGTH": "(Spenser) youth, also YOUTHHEAD, YOUTHHOOD [n -S]\n",
  "YOUNGTHLY": "(Spenser) youthful, also YOUTHLY, YOUTHSOME, YOUTHY [adj]\n",
  "YOUNGTHS": "YOUNGTH, (Spenser) youth, also YOUTHHEAD, YOUTHHOOD [n]\n",
  "YOUNKER": "(colloquial) a young person, also YONKER [n -S]\n",
  "YOUNKERS": "YOUNKER, (colloquial) a young person, also YONKER [n]\n",
  "YOUPON": "(Catawba) a bushy evergreen shrub of the holly genus, also YAPON, YAUPON, YUPON [n -S]\n",
  "YOUPONS": "YOUPON, (Catawba) a bushy evergreen shrub of the holly genus, also YAPON, YAUPON, YUPON [n]\n",
  "YOUR": "belonging to you [adj]\n",
  "YOURN": "(archaic) yours [pron]\n",
  "YOURS": "a possessive form of the pronoun you, also YOURN [pron]\n",
  "YOURSELF": "a form of the second person pronoun [pron YOURSELVES]\n",
  "YOURSELVES": "YOURSELF, a form of the second person pronoun [pron]\n",
  "YOURT": "(Russian) a Mongolian tent made of felt, also YURT, YURTA [n -S]\n",
  "YOURTS": "YOURT, (Russian) a Mongolian tent made of felt, also YURT, YURTA [n]\n",
  "YOUS": "(colloquial) you when addressing more than one person, also YOUSE [pron]\n",
  "YOUSE": "(colloquial) you when addressing more than one person, also YOUS [pron]\n",
  "YOUTH": "a young person [n -S]\n",
  "YOUTHEN": "to make or grow young [v -ED, -ING, -S]\n",
  "YOUTHENED": "YOUTHEN, to make or grow young [v]\n",
  "YOUTHENING": "YOUTHEN, to make or grow young [v]\n",
  "YOUTHENS": "YOUTHEN, to make or grow young [v]\n",
  "YOUTHFUL": "young [adj YOUTHFULLY]\n",
  "YOUTHFULLY": "YOUTHFUL, young [adv]\n",
  "YOUTHFULNESS": "the state of being youthful [n -ES]\n",
  "YOUTHFULNESSES": "YOUTHFULNESS, the state of being youthful [n]\n",
  "YOUTHHEAD": "(obsolete) youth, also YOUNGTH, YOUTHHOOD [n -S]\n",
  "YOUTHHEADS": "YOUTHHEAD, (obsolete) youth, also YOUNGTH, YOUTHHOOD [n]\n",
  "YOUTHHOOD": "(obsolete) youth, also YOUNGTH, YOUTHHEAD [n -S]\n",
  "YOUTHHOODS": "YOUTHHOOD, (obsolete) youth, also YOUNGTH, YOUTHHEAD [n]\n",
  "YOUTHIER": "YOUTHY, (Scots) young, also YOUNGTHLY, YOUTHLY, YOUTHSOME [adj]\n",
  "YOUTHIEST": "YOUTHY, (Scots) young, also YOUNGTHLY, YOUTHLY, YOUTHSOME [adj]\n",
  "YOUTHLESS": "without youth [adj]\n",
  "YOUTHLY": "(Spenser) youthful, also YOUNGTHLY, YOUTHSOME, YOUTHY [adj]\n",
  "YOUTHQUAKE": "a shift in cultural norms influenced by the values, tastes, and mores of young people [n -S]\n",
  "YOUTHQUAKES": "YOUTHQUAKE, a shift in cultural norms influenced by the values, tastes, and mores of young people [n]\n",
  "YOUTHS": "YOUTH, a young person [n]\n",
  "YOUTHSOME": "(obsolete) youthful, also YOUNGTHLY, YOUTHLY, YOUTHY [adj]\n",
  "YOUTHY": "(Scots) young, also YOUNGTHLY, YOUTHLY, YOUTHSOME [adj YOUTHIER, YOUTHIEST]\n",
  "YOW": "to howl, also YOWL [v -ED, -ING, -S]\n",
  "YOWE": "(Scots) a ewe [n -S]\n",
  "YOWED": "YOW, to howl, also YOWL [v]\n",
  "YOWES": "YOWE, (Scots) a ewe [n]\n",
  "YOWIE": "(Native Australian) a tall apelike monster of SE Australia [n -S]\n",
  "YOWIES": "YOWIE, (Native Australian) a tall apelike monster of SE Australia [n]\n",
  "YOWING": "YOW, to howl, also YOWL [v]\n",
  "YOWL": "to howl, esp. of a wolf, also YOW [v -ED, -ING, -S]\n",
  "YOWLED": "YOWL, to howl, esp. of a wolf, also YOW [v]\n",
  "YOWLER": "one who yowls [n -S]\n",
  "YOWLERS": "YOWLER, one who yowls [n]\n",
  "YOWLEY": "the yellowhammer, also YELDRING, YELDROCK, YOLDRING, YORLING [n -S]\n",
  "YOWLEYS": "YOWLEY, the yellowhammer, also YELDRING, YELDROCK, YOLDRING, YORLING [n]\n",
  "YOWLING": "the act or sound of yowling [n -S]\n",
  "YOWLINGS": "YOWLING, the act or sound of yowling [n]\n",
  "YOWLS": "YOWL, to howl, esp. of a wolf, also YOW [v]\n",
  "YOWS": "YOW, to howl, also YOWL [v]\n",
  "YOWZA": "an interjection used to express surprise [interj]\n",
  "YPERITE": "mustard gas [n -S]\n",
  "YPERITES": "YPERITE, mustard gas [n]\n",
  "YPIGHT": "PITCH, to throw [v]\n",
  "YPLAST": "PLACE, to assign to a position [v]\n",
  "YPLIGHT": "PLIGHT, to make a solemn pledge [v]\n",
  "YPSILIFORM": "shaped like an ypsilon [adj]\n",
  "YPSILOID": "shaped like an upsilon [adj]\n",
  "YPSILON": "(Greek) the twentieth letter of the Greek alphabet, also UPSILON [n -S]\n",
  "YPSILONS": "YPSILON, (Greek) the twentieth letter of the Greek alphabet, also UPSILON [n]\n",
  "YRAPT": "(Spenser) rapt [adj]\n",
  "YRAVISHED": "RAVISH, to seize and carry off by force [v]\n",
  "YRENT": "REND, to tear apart forcibly [v]\n",
  "YRIVD": "RIVE, to tear apart [v]\n",
  "YRNEH": "a unit of reciprocal inductance [n -S]\n",
  "YRNEHS": "YRNEH, a unit of reciprocal inductance [n]\n",
  "YSAME": "(Spenser) together [adj]\n",
  "YSHEND": "(Spenser) to scold, also SHEND [v YSHENT, YSHENDING, YSHENDS]\n",
  "YSHENDING": "YSHEND, (Spenser) to scold, also SHEND [v]\n",
  "YSHENDS": "YSHEND, (Spenser) to scold, also SHEND [v]\n",
  "YSHENT": "YSHEND, (Spenser) to scold, also SHEND [v]\n",
  "YSLAKED": "SLAKE, to quench [v]\n",
  "YTHUNDERED": "(Spenser) struck by a thunderbolt [adj]\n",
  "YTOST": "TOSS, to throw lightly [v]\n",
  "YTTERBIA": "a chemical compound, ytterbium oxide [n -S]\n",
  "YTTERBIAS": "YTTERBIA, a chemical compound, ytterbium oxide [n]\n",
  "YTTERBIC": "pertaining to, or derived from, ytterbium [adj]\n",
  "YTTERBITE": "the mineral gadolinite [n -S]\n",
  "YTTERBITES": "YTTERBITE, the mineral gadolinite [n]\n",
  "YTTERBIUM": "(Swedish) a rare element of the boron group [n -S]\n",
  "YTTERBIUMS": "YTTERBIUM, (Swedish) a rare element of the boron group [n]\n",
  "YTTERBOUS": "containing ytterbium [adj]\n",
  "YTTRIA": "a chemical compound, the oxide of yttrium [n -S]\n",
  "YTTRIAS": "YTTRIA, a chemical compound, the oxide of yttrium [n]\n",
  "YTTRIC": "(Swedish) pertaining to, derived from, or containing, yttrium [adj]\n",
  "YTTRIFEROUS": "(Swedish) of an ore, bearing yttrium [adj]\n",
  "YTTRIOUS": "(Swedish) pertaining to, derived from, or containing, yttrium [adj]\n",
  "YTTRIUM": "(Swedish) a rare earth element [n -S]\n",
  "YTTRIUMS": "YTTRIUM, (Swedish) a rare earth element [n]\n",
  "YU": "(Chinese) a precious jade [n -S]\n",
  "YUAN": "(Chinese) a Chinese monetary unit [n -S]\n",
  "YUANS": "YUAN, (Chinese) a Chinese monetary unit [n]\n",
  "YUCA": "(Caribbean) a Mexican plant of the lily family, also YUCCA [n -S]\n",
  "YUCAS": "YUCA, (Caribbean) a Mexican plant of the lily family, also YUCCA [n]\n",
  "YUCCA": "(Caribbean) a Mexican plant of the lily family, also YUCA [n -S]\n",
  "YUCCAS": "YUCCA, (Caribbean) a Mexican plant of the lily family, also YUCA [n]\n",
  "YUCCH": "an interjection expressing disgust, also YECCH, YECH, YUCH [interj]\n",
  "YUCH": "an interjection expressing disgust, also YECCH, YECH, YUCCH [interj]\n",
  "YUCK": "to laugh loudly, also YOCK, YOK, YUK [v -ED, -ING, -S]\n",
  "YUCKED": "YUCK, to laugh loudly, also YOCK, YOK, YUK [v]\n",
  "YUCKER": "an American bird, the flicker or golden-winged woodpecker [n -S]\n",
  "YUCKERS": "YUCKER, an American bird, the flicker or golden-winged woodpecker [n]\n",
  "YUCKIER": "YUCKY, messy or disgusting [adj]\n",
  "YUCKIEST": "YUCKY, messy or disgusting [adj]\n",
  "YUCKINESS": "the state of being yucky [n -ES]\n",
  "YUCKINESSES": "YUCKINESS, the state of being yucky [n]\n",
  "YUCKING": "YUCK, to laugh loudly, also YOCK, YOK, YUK [v]\n",
  "YUCKO": "(Australian slang) unpleasant [adj]\n",
  "YUCKS": "YUCK, to laugh loudly, also YOCK, YOK, YUK [v]\n",
  "YUCKY": "messy or disgusting [adj YUCKIER, YUCKIEST]\n",
  "YUFT": "(Russian) a kind of Russian leather [n -S]\n",
  "YUFTS": "YUFT, (Russian) a kind of Russian leather [n]\n",
  "YUG": "(Sanskrit) one of the four Hindu ages of the world, also YUGA [n -S]\n",
  "YUGA": "(Sanskrit) one of the four Hindu ages of the world, also YUG [n -S]\n",
  "YUGARIE": "(Native Australian) any of various pipi shellfishes, also EUGARIE [n -S]\n",
  "YUGARIES": "YUGARIE, (Native Australian) any of various pipi shellfishes, also EUGARIE [n]\n",
  "YUGAS": "YUGA, (Sanskrit) one of the four Hindu ages of the world, also YUG [n]\n",
  "YUGS": "YUG, (Sanskrit) one of the four Hindu ages of the world, also YUGA [n]\n",
  "YUK": "to laugh loudly, also YOCK, YOK, YUCK [v YUKKED, YUKKING, YUKS]\n",
  "YUKATA": "(Japanese) a kind of light kimono [n -S]\n",
  "YUKATAS": "YUKATA, (Japanese) a kind of light kimono [n]\n",
  "YUKE": "(dialect) to itch, also EUK, EWK, YEUK, YOUK [v YUKED, YUKING, YUKES]\n",
  "YUKED": "YUKE, (dialect) to itch, also EUK, EWK, YEUK, YOUK [v]\n",
  "YUKES": "YUKE, (dialect) to itch, also EUK, EWK, YEUK, YOUK [v]\n",
  "YUKIER": "YUKY, itchy [adj]\n",
  "YUKIEST": "YUKY, itchy [adj]\n",
  "YUKING": "YUKE, (dialect) to itch, also EUK, EWK, YEUK, YOUK [v]\n",
  "YUKKED": "YUK, to laugh loudly, also YOCK, YOK, YUCK [v]\n",
  "YUKKIER": "YUKKY, disgusting, also YEUKY, YUCKO, YUCKY, YUKY [adj]\n",
  "YUKKIEST": "YUKKY, disgusting, also YEUKY, YUCKO, YUCKY, YUKY [adj]\n",
  "YUKKING": "YUK, to laugh loudly, also YOCK, YOK, YUCK [v]\n",
  "YUKKY": "disgusting, also YEUKY, YUCKO, YUCKY, YUKY [adj YUKKIER, YUKKIEST]\n",
  "YUKO": "(Japanese) in judo, a points penalty [n -S]\n",
  "YUKOS": "YUKO, (Japanese) in judo, a points penalty [n]\n",
  "YUKS": "YUK, to laugh loudly, also YOCK, YOK, YUCK [v]\n",
  "YUKY": "itchy [adj YUKIER, YUKIEST]\n",
  "YULAN": "(Chinese) a kind of magnolia, producing large white flowers [n -S]\n",
  "YULANS": "YULAN, (Chinese) a kind of magnolia, producing large white flowers [n]\n",
  "YULE": "Christmas or Christmastide, also YULETIDE [n -S]\n",
  "YULES": "YULE, Christmas or Christmastide, also YULETIDE [n]\n",
  "YULETIDE": "Christmas or Christmastide, also YULE [n -S]\n",
  "YULETIDES": "YULETIDE, Christmas or Christmastide, also YULE [n]\n",
  "YUM": "an interjection expressing satisfaction [interj]\n",
  "YUMBERRIES": "YUMBERRY, the purple-red edible fruit of an East Asian tree [n]\n",
  "YUMBERRY": "the purple-red edible fruit of an East Asian tree [n YUMBERRIES]\n",
  "YUMMIER": "YUMMY, delicious [adj]\n",
  "YUMMIES": "YUMMY, something delicious [n]\n",
  "YUMMIEST": "YUMMY, delicious [adj]\n",
  "YUMMINESS": "the quality of being yummy [n -ES]\n",
  "YUMMINESSES": "YUMMINESS, the quality of being yummy [n]\n",
  "YUMMO": "(Australian slang) delicious [adj]\n",
  "YUMMY": "delicious [adj YUMMIER, YUMMIEST] / something delicious [n YUMMIES]\n",
  "YUMP": "in rally-driving, to leave the ground when going over a ridge or crest [v -ED, -ING, -S]\n",
  "YUMPED": "YUMP, in rally-driving, to leave the ground when going over a ridge or crest [v]\n",
  "YUMPIE": "a young, upwardly, mobile person [n -S]\n",
  "YUMPIES": "YUMPIE, a young, upwardly, mobile person [n]\n",
  "YUMPING": "YUMP, in rally-driving, to leave the ground when going over a ridge or crest [v]\n",
  "YUMPS": "YUMP, in rally-driving, to leave the ground when going over a ridge or crest [v]\n",
  "YUNX": "(Latin) the wryneck, also JYNX [n -ES]\n",
  "YUNXES": "YUNX, (Latin) the wryneck, also JYNX [n]\n",
  "YUP": "(colloquial) yes, also YEP [n -S]\n",
  "YUPON": "a bushy evergreen shrub of the holly genus, also YAPON, YAUPON, YOUPON [n -S]\n",
  "YUPONS": "YUPON, a bushy evergreen shrub of the holly genus, also YAPON, YAUPON, YOUPON [n]\n",
  "YUPPIE": "a young professional person working in the city, also YUPPY [n -S]\n",
  "YUPPIEDOM": "the state of being a yuppie, also YUPPYDOM [n -S]\n",
  "YUPPIEDOMS": "YUPPIEDOM, the state of being a yuppie, also YUPPYDOM [n]\n",
  "YUPPIEISH": "like a yuppie [adj]\n",
  "YUPPIES": "YUPPIE, a young professional person working in the city, also YUPPY [n]\n",
  "YUPPIFICATION": "the process of conversion into a yuppy [n -S]\n",
  "YUPPIFICATIONS": "YUPPIFICATION, the process of conversion into a yuppy [n]\n",
  "YUPPIFIED": "YUPPIFY, to infuse with the qualities or values of yuppies [v]\n",
  "YUPPIFIES": "YUPPIFY, to infuse with the qualities or values of yuppies [v]\n",
  "YUPPIFY": "to infuse with the qualities or values of yuppies [v YUPPIFIED, YUPPIFYING, YUPPIFIES]\n",
  "YUPPIFYING": "YUPPIFY, to infuse with the qualities or values of yuppies [v]\n",
  "YUPPY": "a young professional person working in the city, also YUPPIE [n YUPPIES]\n",
  "YUPPYDOM": "the state of being a yuppie, also YUPPIEDOM [n -S]\n",
  "YUPPYDOMS": "YUPPYDOM, the state of being a yuppie, also YUPPIEDOM [n]\n",
  "YUPS": "YUP, (colloquial) yes, also YEP [n]\n",
  "YUPSTER": "a hipster with a professional job who seeks to climb the corporate ladder while remaining true to his ideals [n -S]\n",
  "YUPSTERS": "YUPSTER, a hipster with a professional job who seeks to climb the corporate ladder while remaining true to his ideals [n]\n",
  "YURT": "(Russian) a Mongolian felt tent, also YOURT, YURTA [n -S]\n",
  "YURTA": "(Russian) a Mongolian felt tent, also YOURT, YURT [n -S]\n",
  "YURTAS": "YURTA, (Russian) a Mongolian felt tent, also YOURT, YURT [n]\n",
  "YURTS": "YURT, (Russian) a Mongolian felt tent, also YOURT, YURTA [n]\n",
  "YUS": "YU, (Chinese) a precious jade [n]\n",
  "YUTZ": "(Yiddish) a socially inept person [n -ES]\n",
  "YUTZES": "YUTZ, (Yiddish) a socially inept person [n]\n",
  "YUZU": "(Japanese) a type of citrus fruit [n -S]\n",
  "YUZUS": "YUZU, (Japanese) a type of citrus fruit [n]\n",
  "YWIS": "(archaic) certainly, also IWIS [adv]\n",
  "YWROKE": "(Spenser) wrought [v]\n",
  "ZA": "(slang) pizza [n -S]\n",
  "ZABAGLIONE": "(Italian) a rich Italian custard, also ZABAIONE, ZABAJONE [n -S]\n",
  "ZABAGLIONES": "ZABAGLIONE, (Italian) a rich Italian custard, also ZABAIONE, ZABAJONE [n]\n",
  "ZABAIONE": "(Italian) a rich Italian custard, also ZABAGLIONE, ZABAJONE [n -S]\n",
  "ZABAIONES": "ZABAIONE, (Italian) a rich Italian custard, also ZABAGLIONE, ZABAJONE [n]\n",
  "ZABAJONE": "(Italian) a rich Italian custard, also ZABAGLIONE, ZABAIONE [n -S]\n",
  "ZABAJONES": "ZABAJONE, (Italian) a rich Italian custard, also ZABAGLIONE, ZABAIONE [n]\n",
  "ZABETA": "(Arabic) a stated tariff [n -S]\n",
  "ZABETAS": "ZABETA, (Arabic) a stated tariff [n]\n",
  "ZABRA": "(Spanish) a small vessel used off the Spanish coast [n -S]\n",
  "ZABRAS": "ZABRA, (Spanish) a small vessel used off the Spanish coast [n]\n",
  "ZABTIEH": "(Turkish) a Turkish policeman, also ZAPTIAH, ZAPTIEH [n -S]\n",
  "ZABTIEHS": "ZABTIEH, (Turkish) a Turkish policeman, also ZAPTIAH, ZAPTIEH [n]\n",
  "ZACATON": "(Spanish) a type of coarse perennial grass growing in alkaline regions of the southern US, also SACATON [n -S]\n",
  "ZACATONS": "ZACATON, (Spanish) a type of coarse perennial grass growing in alkaline regions of the southern US, also SACATON [n]\n",
  "ZACK": "(Australian slang) sixpence, now a five-cent piece [n -S]\n",
  "ZACKS": "ZACK, (Australian slang) sixpence, now a five-cent piece [n]\n",
  "ZADDICK": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDIK [n -S]\n",
  "ZADDICKS": "ZADDICK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDIK [n]\n",
  "ZADDIK": "(Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK [n ZADDIKS or ZADDIKIM]\n",
  "ZADDIKIM": "ZADDIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK [n]\n",
  "ZADDIKS": "ZADDIK, (Hebrew) in Judaism, a Hasidic leader, or person of extraordinary piety, also TSADDIK, TSADDIQ, TSADIK, TZADDIK, TZADDIQ, TZADIK, ZADDICK [n]\n",
  "ZAFFAR": "(Italian) an impure oxide of cobalt, also ZAFFER, ZAFFIR, ZAFFRE [n -S]\n",
  "ZAFFARS": "ZAFFAR, (Italian) an impure oxide of cobalt, also ZAFFER, ZAFFIR, ZAFFRE [n]\n",
  "ZAFFER": "(Italian) an impure oxide of cobalt, also ZAFFAR, ZAFFIR, ZAFFRE [n -S]\n",
  "ZAFFERS": "ZAFFER, (Italian) an impure oxide of cobalt, also ZAFFAR, ZAFFIR, ZAFFRE [n]\n",
  "ZAFFIR": "(Italian) an impure oxide of cobalt, also ZAFFAR, ZAFFER, ZAFFRE [n -S]\n",
  "ZAFFIRS": "ZAFFIR, (Italian) an impure oxide of cobalt, also ZAFFAR, ZAFFER, ZAFFRE [n]\n",
  "ZAFFRE": "(Italian) an impure oxide of cobalt, also ZAFFAR, ZAFFER, ZAFFIR [n -S]\n",
  "ZAFFRES": "ZAFFRE, (Italian) an impure oxide of cobalt, also ZAFFAR, ZAFFER, ZAFFIR [n]\n",
  "ZAFTIG": "(Yiddish) having a full rounded figure, pleasingly plump, also ZOFTIG [adj]\n",
  "ZAG": "to change course sharply [v ZAGGED, ZAGGING, ZAGS]\n",
  "ZAGGED": "ZAG, to change course sharply [v]\n",
  "ZAGGING": "ZAG, to change course sharply [v]\n",
  "ZAGS": "ZAG, to change course sharply [v]\n",
  "ZAIBATSU": "(Japanese) a powerful, family-controlled Japanese combine [n -S]\n",
  "ZAIBATSUS": "ZAIBATSU, (Japanese) a powerful, family-controlled Japanese combine [n]\n",
  "ZAIDA": "(Yiddish) a grandfather, also ZAIDEH, ZAIDY, ZEDA [n -S]\n",
  "ZAIDAS": "ZAIDA, (Yiddish) a grandfather, also ZAIDEH, ZAIDY, ZEDA [n]\n",
  "ZAIDEH": "(Yiddish) a grandfather, also ZAIDA, ZAIDY, ZEDA [n -S]\n",
  "ZAIDEHS": "ZAIDEH, (Yiddish) a grandfather, also ZAIDA, ZAIDY, ZEDA [n]\n",
  "ZAIDIES": "ZAIDY, (Yiddish) a grandfather, also ZAIDA, ZAIDEH, ZEDA [n]\n",
  "ZAIDY": "(Yiddish) a grandfather, also ZAIDA, ZAIDEH, ZEDA [n ZAIDIES]\n",
  "ZAIKAI": "(Japanese) the business community of Japan [n -S]\n",
  "ZAIKAIS": "ZAIKAI, (Japanese) the business community of Japan [n]\n",
  "ZAIRE": "a monetary unit of central Africa [n -S]\n",
  "ZAIRES": "ZAIRE, a monetary unit of central Africa [n]\n",
  "ZAITECH": "(Japanese) the commercial practice of investing in financial markets to augment a company's normal earnings [n -S]\n",
  "ZAITECHS": "ZAITECH, (Japanese) the commercial practice of investing in financial markets to augment a company's normal earnings [n]\n",
  "ZAKAT": "(Persian) in Islam, a tax payable on certain types of property [n -S]\n",
  "ZAKATS": "ZAKAT, (Persian) in Islam, a tax payable on certain types of property [n]\n",
  "ZAKOUSKA": "(Russian) an hors d'oeuvre; a snack, also ZAKUSKA [n ZAKOUSKI]\n",
  "ZAKOUSKI": "ZAKOUSKA, (Russian) an hors d'oeuvre; a snack, also ZAKUSKA [n]\n",
  "ZAKUSKA": "(Russian) an hors d'oeuvre; a snack, also ZAKOUSKA [n ZAKUSKI]\n",
  "ZAKUSKI": "ZAKUSKA, (Russian) an hors d'oeuvre; a snack, also ZAKOUSKA [n]\n",
  "ZALAMBDODONT": "having molar teeth with V-shaped ridges, as some Insectivora do [adj] / an animal having such teeth [n -S]\n",
  "ZALAMBDODONTS": "ZALAMBDODONT, an animal having such teeth [n]\n",
  "ZAMAN": "(Caribbean) the rain-tree, a member of the mimosa family, also SAMAAN, SAMAN, ZAMANG [n -S]\n",
  "ZAMANG": "(Caribbean) the rain-tree, a member of the mimosa family, also SAMAAN, SAMAN, ZAMAN [n -S]\n",
  "ZAMANGS": "ZAMANG, (Caribbean) the rain-tree, a member of the mimosa family, also SAMAAN, SAMAN, ZAMAN [n]\n",
  "ZAMANS": "ZAMAN, (Caribbean) the rain-tree, a member of the mimosa family, also SAMAAN, SAMAN, ZAMANG [n]\n",
  "ZAMARRA": "(Spanish) a shepherd's sheepskin coat, also ZAMARRO [n -S]\n",
  "ZAMARRAS": "ZAMARRA, (Spanish) a shepherd's sheepskin coat, also ZAMARRO [n]\n",
  "ZAMARRO": "(Spanish) a shepherd's sheepskin coat, also ZAMARRA [n -S]\n",
  "ZAMARROS": "ZAMARRO, (Spanish) a shepherd's sheepskin coat, also ZAMARRA [n]\n",
  "ZAMBO": "(offensive) the offspring of a Negro man and an American Indian woman [n -S]\n",
  "ZAMBOMBA": "(Spanish) a Spanish musical instrument consisting of parchment over a jar [n -S]\n",
  "ZAMBOMBAS": "ZAMBOMBA, (Spanish) a Spanish musical instrument consisting of parchment over a jar [n]\n",
  "ZAMBOORAK": "(Urdu) a small swivel-gun, esp. one mounted on the back of a camel, also ZOMBORUK, ZUMBOORUK [n -S]\n",
  "ZAMBOORAKS": "ZAMBOORAK, (Urdu) a small swivel-gun, esp. one mounted on the back of a camel, also ZOMBORUK, ZUMBOORUK [n]\n",
  "ZAMBOS": "ZAMBO, (offensive) the offspring of a Negro man and an American Indian woman [n]\n",
  "ZAMBUCK": "(New Zealand) a member of the St John's ambulance brigade, esp. one on duty at a sporting event, also ZAMBUK [n -S]\n",
  "ZAMBUCKS": "ZAMBUCK, (New Zealand) a member of the St John's ambulance brigade, esp. one on duty at a sporting event, also ZAMBUK [n]\n",
  "ZAMBUK": "(New Zealand) a member of the St John's ambulance brigade, esp. one on duty at a sporting event, also ZAMBUCK [n -S]\n",
  "ZAMBUKS": "ZAMBUK, (New Zealand) a member of the St John's ambulance brigade, esp. one on duty at a sporting event, also ZAMBUCK [n]\n",
  "ZAMIA": "a genus of cycads [n -S]\n",
  "ZAMIAS": "ZAMIA, a genus of cycads [n]\n",
  "ZAMINDAR": "(Hindi) in India, a type of landowner, also ZEMINDAR [n -S]\n",
  "ZAMINDARI": "(Hindi) the jurisdiction of a zamindar, also ZAMINDARY, ZEMINDARI, ZEMINDARY [n -S]\n",
  "ZAMINDARIES": "ZAMINDARY, (Hindi) the jurisdiction of a zamindar, also ZAMINDARI, ZEMINDARI, ZEMINDARY [n]\n",
  "ZAMINDARIS": "ZAMINDARI, (Hindi) the jurisdiction of a zamindar, also ZAMINDARY, ZEMINDARI, ZEMINDARY [n]\n",
  "ZAMINDARS": "ZAMINDAR, (Hindi) in India, a type of landowner, also ZEMINDAR [n]\n",
  "ZAMINDARY": "(Hindi) the jurisdiction of a zamindar, also ZAMINDARI, ZEMINDARI, ZEMINDARY [n ZAMINDARIES]\n",
  "ZAMOUSE": "(Arabic) a short-horned buffalo [n -S]\n",
  "ZAMOUSES": "ZAMOUSE, (Arabic) a short-horned buffalo [n]\n",
  "ZAMPOGNA": "(Italian) an Italian bagpipe with two drones and two conical chanters, all in one stock [n -S]\n",
  "ZAMPOGNAS": "ZAMPOGNA, (Italian) an Italian bagpipe with two drones and two conical chanters, all in one stock [n]\n",
  "ZAMPONE": "(Italian) a stuffed pigs' trotter sausage [n ZAMPONI]\n",
  "ZAMPONI": "ZAMPONE, (Italian) a stuffed pigs' trotter sausage [n]\n",
  "ZAMZAWED": "(dialect) of tea, stewed in the pot [adj]\n",
  "ZANAMIVIR": "a drug used in the treatment of influenza [n -S]\n",
  "ZANAMIVIRS": "ZANAMIVIR, a drug used in the treatment of influenza [n]\n",
  "ZANANA": "(Urdu) in the Indian subcontinent, the part of a house in which high-caste women are or were secluded, also ZENANA [n -S]\n",
  "ZANANAS": "ZANANA, (Urdu) in the Indian subcontinent, the part of a house in which high-caste women are or were secluded, also ZENANA [n]\n",
  "ZANDER": "(German) a European pike perch allied to the walleye [n -S]\n",
  "ZANDERS": "ZANDER, (German) a European pike perch allied to the walleye [n]\n",
  "ZANELLA": "a mixed twilled umbrella fabric [n -S]\n",
  "ZANELLAS": "ZANELLA, a mixed twilled umbrella fabric [n]\n",
  "ZANIED": "ZANY, (obsolete) to play the zany to [v]\n",
  "ZANIER": "ZANY, comical, clownish [adj]\n",
  "ZANIES": "ZANY, (obsolete) to play the zany to [v]\n",
  "ZANIEST": "ZANY, comical, clownish [adj]\n",
  "ZANILY": "ZANY, comical, clownish [adv]\n",
  "ZANINESS": "comicality [n -ES]\n",
  "ZANINESSES": "ZANINESS, comicality [n]\n",
  "ZANJA": "(Spanish) an irrigation canal in Latin America [n -S]\n",
  "ZANJAS": "ZANJA, (Spanish) an irrigation canal in Latin America [n]\n",
  "ZANJERO": "(Spanish) someone who supervises the distribution of water in irrigation canals [n -S]\n",
  "ZANJEROS": "ZANJERO, (Spanish) someone who supervises the distribution of water in irrigation canals [n]\n",
  "ZANTE": "the wood of the European smoke-tree [n -S]\n",
  "ZANTEDESCHIA": "a plant of the arum family, aka calla lily [n -S]\n",
  "ZANTEDESCHIAS": "ZANTEDESCHIA, a plant of the arum family, aka calla lily [n]\n",
  "ZANTES": "ZANTE, the wood of the European smoke-tree [n]\n",
  "ZANTEWOOD": "the wood of the zante tree [n -S]\n",
  "ZANTEWOODS": "ZANTEWOOD, the wood of the zante tree [n]\n",
  "ZANTHOXYL": "a plant of a genus of the rue family found in Brazil, in particular the prickly-ash or Hercules club, also XANTHOXYL, ZANTHOXYLUM [n -S]\n",
  "ZANTHOXYLS": "ZANTHOXYL, a plant of a genus of the rue family found in Brazil, in particular the prickly-ash or Hercules club, also XANTHOXYL, ZANTHOXYLUM [n]\n",
  "ZANTHOXYLUM": "a plant of a genus of the rue family found in Brazil, in particular the prickly-ash or Hercules club, also XANTHOXYL, ZANTHOXYL [n -S]\n",
  "ZANTHOXYLUMS": "ZANTHOXYLUM, a plant of a genus of the rue family found in Brazil, in particular the prickly-ash or Hercules club, also XANTHOXYL, ZANTHOXYL [n]\n",
  "ZANY": "comical, clownish [adj ZANIER, ZANIEST, ZANILY] / (obsolete) to play the zany to [v ZANIED, ZANYING, ZANIES]\n",
  "ZANYING": "ZANY, (obsolete) to play the zany to [v]\n",
  "ZANYISH": "somewhat zany [adj]\n",
  "ZANYISM": "the state of being a buffoon [n -S]\n",
  "ZANYISMS": "ZANYISM, the state of being a buffoon [n]\n",
  "ZANZA": "(Arabic) an African musical instrument, also SANSA, ZANZE [n -S]\n",
  "ZANZAS": "ZANZA, (Arabic) an African musical instrument, also SANSA, ZANZE [n]\n",
  "ZANZE": "(Arabic) an African musical instrument, also SANSA, ZANZA [n -S]\n",
  "ZANZES": "ZANZE, (Arabic) an African musical instrument, also SANSA, ZANZA [n]\n",
  "ZAP": "to kill or destroy instantaneously [v ZAPPED, ZAPPING, ZAPS]\n",
  "ZAPATA": "denoting a kind of drooping moustache [adj]\n",
  "ZAPATEADO": "(Spanish) a Latin-American dance with rhythmic tapping of the feet [n -S]\n",
  "ZAPATEADOS": "ZAPATEADO, (Spanish) a Latin-American dance with rhythmic tapping of the feet [n]\n",
  "ZAPATEO": "(Spanish) a Spanish dance [n -S]\n",
  "ZAPATEOS": "ZAPATEO, (Spanish) a Spanish dance [n]\n",
  "ZAPOTILLA": "(Spanish) the edible fruit of a Mexican tree, also SAPODILLA, SAPOTA, SAPOTE [n -S]\n",
  "ZAPOTILLAS": "ZAPOTILLA, (Spanish) the edible fruit of a Mexican tree, also SAPODILLA, SAPOTA, SAPOTE [n]\n",
  "ZAPPED": "ZAP, to kill or destroy instantaneously [v]\n",
  "ZAPPER": "a device that zaps [n -S]\n",
  "ZAPPERS": "ZAPPER, a device that zaps [n]\n",
  "ZAPPIER": "ZAPPY, (slang) full of verve [adj]\n",
  "ZAPPIEST": "ZAPPY, (slang) full of verve [adj]\n",
  "ZAPPING": "ZAP, to kill or destroy instantaneously [v]\n",
  "ZAPPY": "(slang) full of verve [adj ZAPPIER, ZAPPIEST]\n",
  "ZAPS": "ZAP, to kill or destroy instantaneously [v]\n",
  "ZAPTIAH": "(Turkish) a Turkish policeman, also ZABTIEH, ZAPTIEH [n -S]\n",
  "ZAPTIAHS": "ZAPTIAH, (Turkish) a Turkish policeman, also ZABTIEH, ZAPTIEH [n]\n",
  "ZAPTIEH": "(Turkish) a Turkish policeman, also ZABTIEH, ZAPTIAH [n -S]\n",
  "ZAPTIEHS": "ZAPTIEH, (Turkish) a Turkish policeman, also ZABTIEH, ZAPTIAH [n]\n",
  "ZARAPE": "(Spanish) a blanket or shawl worn as an outer garment by Spanish Americans, also SARAPE, SERAPE [n -S]\n",
  "ZARAPES": "ZARAPE, (Spanish) a blanket or shawl worn as an outer garment by Spanish Americans, also SARAPE, SERAPE [n]\n",
  "ZARATITE": "a mineral, a hydrous carbonate of nickel [n -S]\n",
  "ZARATITES": "ZARATITE, a mineral, a hydrous carbonate of nickel [n]\n",
  "ZAREBA": "(Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREEBA, ZARIBA, ZEREBA, ZERIBA [n -S]\n",
  "ZAREBAS": "ZAREBA, (Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREEBA, ZARIBA, ZEREBA, ZERIBA [n]\n",
  "ZAREEBA": "(Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREBA, ZARIBA, ZEREBA, ZERIBA [n -S]\n",
  "ZAREEBAS": "ZAREEBA, (Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREBA, ZARIBA, ZEREBA, ZERIBA [n]\n",
  "ZARF": "(Arabic) an ornamental metal holder for a handleless coffee cup, also ZURF [n -S]\n",
  "ZARFS": "ZARF, (Arabic) an ornamental metal holder for a handleless coffee cup, also ZURF [n]\n",
  "ZARI": "(Urdu) a type of thread made of fine gold or silver wire used in traditional Indian and Pakistani garments [n -S]\n",
  "ZARIBA": "(Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREBA, ZAREEBA, ZEREBA, ZERIBA [n -S]\n",
  "ZARIBAS": "ZARIBA, (Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREBA, ZAREEBA, ZEREBA, ZERIBA [n]\n",
  "ZARIS": "ZARI, (Urdu) a type of thread made of fine gold or silver wire used in traditional Indian and Pakistani garments [n]\n",
  "ZARNEC": "(Arabic) a native sulphide of arsenic, also ZARNICH [n -S]\n",
  "ZARNECS": "ZARNEC, (Arabic) a native sulphide of arsenic, also ZARNICH [n]\n",
  "ZARNICH": "(Arabic) a native sulphide of arsenic, also ZARNEC [n -S]\n",
  "ZARNICHS": "ZARNICH, (Arabic) a native sulphide of arsenic, also ZARNEC [n]\n",
  "ZARZUELA": "(Spanish) a traditional Spanish vaudeville show; a fish and shellfish stew [n -S]\n",
  "ZARZUELAS": "ZARZUELA, (Spanish) a traditional Spanish vaudeville show; a fish and shellfish stew [n]\n",
  "ZAS": "ZA, (slang) pizza [n]\n",
  "ZASTRUGA": "(Russian) long parallel ridges of snow that form on windy plains, also SASTRUGA [n ZASTRUGI]\n",
  "ZASTRUGI": "ZASTRUGA, (Russian) long parallel ridges of snow that form on windy plains, also SASTRUGA [n]\n",
  "ZATI": "the bonnet-monkey [n -S]\n",
  "ZATIS": "ZATI, the bonnet-monkey [n]\n",
  "ZAX": "a chopper for trimming slate, also SAX, ZEX [n -ES]\n",
  "ZAXES": "ZAX, a chopper for trimming slate, also SAX, ZEX [n]\n",
  "ZAYIN": "(Hebrew) a Hebrew letter [n -S]\n",
  "ZAYINS": "ZAYIN, (Hebrew) a Hebrew letter [n]\n",
  "ZAZEN": "(Japanese) Zen meditation [n -S]\n",
  "ZAZENS": "ZAZEN, (Japanese) Zen meditation [n]\n",
  "ZE": "used as a gender-neutral third person singular subjective pronoun [pron]\n",
  "ZEA": "part of a cereal plant, once used as a diuretic [n -S]\n",
  "ZEAL": "enthusiasm [n -S]\n",
  "ZEALANT": "a fanatic, also ZEALOT, ZELANT [n -S]\n",
  "ZEALANTS": "ZEALANT, a fanatic, also ZEALOT, ZELANT [n]\n",
  "ZEALFUL": "full of enthusiasm [adj]\n",
  "ZEALLESS": "lacking zeal [adj]\n",
  "ZEALOT": "a fanatic, also ZEALANT, ZELANT [n -S]\n",
  "ZEALOTISM": "the character or conduct of a zealot, also ZEALOTRY [n -S]\n",
  "ZEALOTISMS": "ZEALOTISM, the character or conduct of a zealot, also ZEALOTRY [n]\n",
  "ZEALOTRIES": "ZEALOTRY, the character or conduct of a zealot, also ZEALOTISM [n]\n",
  "ZEALOTRY": "the character or conduct of a zealot, also ZEALOTISM [n ZEALOTRIES]\n",
  "ZEALOTS": "ZEALOT, a fanatic, also ZEALANT, ZELANT [n]\n",
  "ZEALOUS": "filled with zeal [adj ZEALOUSLY]\n",
  "ZEALOUSLY": "ZEALOUS, filled with zeal [adv]\n",
  "ZEALOUSNESS": "the state of being zealous [n -ES]\n",
  "ZEALOUSNESSES": "ZEALOUSNESS, the state of being zealous [n]\n",
  "ZEALS": "ZEAL, enthusiasm [n]\n",
  "ZEAS": "ZEA, part of a cereal plant, once used as a diuretic [n]\n",
  "ZEATIN": "a chemical compound found in maize [n -S]\n",
  "ZEATINS": "ZEATIN, a chemical compound found in maize [n]\n",
  "ZEBEC": "a small, three-masted Mediterranean vessel with both square and triangular sails, also XEBEC, ZEBECK [n -S]\n",
  "ZEBECK": "a small, three-masted Mediterranean vessel with both square and triangular sails, also XEBEC, ZEBEC [n -S]\n",
  "ZEBECKS": "ZEBECK, a small, three-masted Mediterranean vessel with both square and triangular sails, also XEBEC, ZEBEC [n]\n",
  "ZEBECS": "ZEBEC, a small, three-masted Mediterranean vessel with both square and triangular sails, also XEBEC, ZEBECK [n]\n",
  "ZEBRA": "an African mammal related to the horse [n -S]\n",
  "ZEBRAFISH": "a striped tropical fish [n -ES]\n",
  "ZEBRAFISHES": "ZEBRAFISH, a striped tropical fish [n]\n",
  "ZEBRAIC": "like a zebra [adj]\n",
  "ZEBRANO": "a tree having striped wood [n -S]\n",
  "ZEBRANOS": "ZEBRANO, a tree having striped wood [n]\n",
  "ZEBRAS": "ZEBRA, an African mammal related to the horse [n]\n",
  "ZEBRASS": "the offspring of a zebra and an ass [n -ES]\n",
  "ZEBRASSES": "ZEBRASS, the offspring of a zebra and an ass [n]\n",
  "ZEBRAWOOD": "a kind of cabinet wood having beautiful black, brown, and whitish stripes, the timber of a tropical American tree [n -S]\n",
  "ZEBRAWOODS": "ZEBRAWOOD, a kind of cabinet wood having beautiful black, brown, and whitish stripes, the timber of a tropical American tree [n]\n",
  "ZEBRINA": "a trailing or creeping Central American plant [n -S]\n",
  "ZEBRINAS": "ZEBRINA, a trailing or creeping Central American plant [n]\n",
  "ZEBRINE": "a member of the zebra family [n -S]\n",
  "ZEBRINES": "ZEBRINE, a member of the zebra family [n]\n",
  "ZEBRINNIES": "ZEBRINNY, the offspring of a male horse and a female zebra [n]\n",
  "ZEBRINNY": "the offspring of a male horse and a female zebra [n ZEBRINNIES]\n",
  "ZEBROID": "of or like a zebra [adj]\n",
  "ZEBRULA": "the offspring of a male zebra and a female horse, also ZEBRULE [n -S]\n",
  "ZEBRULAS": "ZEBRULA, the offspring of a male zebra and a female horse, also ZEBRULE [n]\n",
  "ZEBRULE": "the offspring of a male zebra and a female horse, also ZEBRULA [n -S]\n",
  "ZEBRULES": "ZEBRULE, the offspring of a male zebra and a female horse, also ZEBRULA [n]\n",
  "ZEBU": "(French) a humped domestic ox [n -S]\n",
  "ZEBUB": "(Arabic) an Ethiopian dipterous insect, also ZIMB [n -S]\n",
  "ZEBUBS": "ZEBUB, (Arabic) an Ethiopian dipterous insect, also ZIMB [n]\n",
  "ZEBUS": "ZEBU, (French) a humped domestic ox [n]\n",
  "ZECCHIN": "(Italian) a former Italian gold coin, also ZECCHINE, ZECCHINO, ZECHIN [n -S]\n",
  "ZECCHINE": "(Italian) a former Italian gold coin, also ZECCHIN, ZECCHINO, ZECHIN [n -S]\n",
  "ZECCHINES": "ZECCHINE, (Italian) a former Italian gold coin, also ZECCHIN, ZECCHINO, ZECHIN [n]\n",
  "ZECCHINI": "ZECCHINO, (Italian) a former Italian gold coin, also ZECCHIN, ZECCHINE, ZECHIN [n]\n",
  "ZECCHINO": "(Italian) a former Italian gold coin, also ZECCHIN, ZECCHINE, ZECHIN [n ZECCHINI or ZECCHINOS]\n",
  "ZECCHINOS": "ZECCHINO, (Italian) a former Italian gold coin, also ZECCHIN, ZECCHINE, ZECHIN [n]\n",
  "ZECCHINS": "ZECCHIN, (Italian) a former Italian gold coin, also ZECCHINE, ZECCHINO, ZECHIN [n]\n",
  "ZECHIN": "(Italian) a former Italian gold coin, also ZECCHIN, ZECCHINE, ZECCHINO [n -S]\n",
  "ZECHINS": "ZECHIN, (Italian) a former Italian gold coin, also ZECCHIN, ZECCHINE, ZECCHINO [n]\n",
  "ZED": "the letter Z, also ZEE [n -S]\n",
  "ZEDA": "(Yiddish) a grandfather, also ZAIDA, ZAIDEH, ZAIDY [n -S]\n",
  "ZEDAS": "ZEDA, (Yiddish) a grandfather, also ZAIDA, ZAIDEH, ZAIDY [n]\n",
  "ZEDOARIES": "ZEDOARY, the medicinal root of a tropical plant [n]\n",
  "ZEDOARY": "the medicinal root of a tropical plant [n ZEDOARIES]\n",
  "ZEDS": "ZED, the letter Z, also ZEE [n]\n",
  "ZEE": "(US) the letter Z, also ZED [n -S]\n",
  "ZEES": "ZEE, (US) the letter Z, also ZED [n]\n",
  "ZEIN": "a protein found in Indian corn [n -S]\n",
  "ZEINS": "ZEIN, a protein found in Indian corn [n]\n",
  "ZEITGEBER": "(German) an environmental cue, such as light, that helps to regulate the biological clock in an organism [n -S]\n",
  "ZEITGEBERS": "ZEITGEBER, (German) an environmental cue, such as light, that helps to regulate the biological clock in an organism [n]\n",
  "ZEITGEIST": "(German) the general intellectual, moral and cultural climate of an era [n -S]\n",
  "ZEITGEISTIER": "ZEITGEISTY, of, relating to, or typical of the zeitgeist [adj]\n",
  "ZEITGEISTIEST": "ZEITGEISTY, of, relating to, or typical of the zeitgeist [adj]\n",
  "ZEITGEISTS": "ZEITGEIST, (German) the general intellectual, moral and cultural climate of an era [n]\n",
  "ZEITGEISTY": "of, relating to, or typical of the zeitgeist [adj ZEITGEISTIER, ZEITGEISTIEST]\n",
  "ZEK": "an inmate of a labour camp in the former USSR [n -S]\n",
  "ZEKS": "ZEK, an inmate of a labour camp in the former USSR [n]\n",
  "ZEL": "(Turkish) an Oriental cymbal [n -S]\n",
  "ZELANT": "a zealot, a religious fanatic, also ZEALANT [n -S]\n",
  "ZELANTS": "ZELANT, a zealot, a religious fanatic, also ZEALANT [n]\n",
  "ZELATOR": "(Latin) a nun whose duty is to keep watch on the behaviour of younger nuns in the convent, also ZELATRICE, ZELATRIX [n -S]\n",
  "ZELATORS": "ZELATOR, (Latin) a nun whose duty is to keep watch on the behaviour of younger nuns in the convent, also ZELATRICE, ZELATRIX [n]\n",
  "ZELATRICE": "(Latin) a nun whose duty is to keep watch on the behaviour of younger nuns in the convent, also ZELATOR, ZELATRIX [n -S]\n",
  "ZELATRICES": "ZELATRIX, (Latin) a nun whose duty is to keep watch on the behaviour of younger nuns in the convent, also ZELATOR, ZELATRICE [n]\n",
  "ZELATRIX": "(Latin) a nun whose duty is to keep watch on the behaviour of younger nuns in the convent, also ZELATOR, ZELATRICE [n ZELATRICES]\n",
  "ZELATRIXES": "ZELATRIX, (Latin) a nun whose duty is to keep watch on the behaviour of younger nuns in the convent, also ZELATOR, ZELATRICE [n]\n",
  "ZELKOVA": "(Japanese) a Japanese tree [n -S]\n",
  "ZELKOVAS": "ZELKOVA, (Japanese) a Japanese tree [n]\n",
  "ZELOPHOBIA": "an irrational fear of jealousy [n -S]\n",
  "ZELOPHOBIAS": "ZELOPHOBIA, an irrational fear of jealousy [n]\n",
  "ZELOPHOBIC": "one who suffers from zelophobia, an irrational fear of jealousy [n -S]\n",
  "ZELOPHOBICS": "ZELOPHOBIC, one who suffers from zelophobia, an irrational fear of jealousy [n]\n",
  "ZELOSO": "(Italian) in music, with fervour [adv]\n",
  "ZELOTYPIA": "(obsolete) jealousy; excessive zeal in carrying out a project [n -S]\n",
  "ZELOTYPIAS": "ZELOTYPIA, (obsolete) jealousy; excessive zeal in carrying out a project [n]\n",
  "ZELS": "ZEL, (Turkish) an Oriental cymbal [n]\n",
  "ZEMINDAR": "(Hindi) in India, a type of landowner, also ZAMINDAR [n -S]\n",
  "ZEMINDARI": "(Hindi) the jurisdiction of a zemindar, also ZAMINDARI, ZAMINDARY, ZEMINDARY [n -S]\n",
  "ZEMINDARIES": "ZEMINDARY, (Hindi) the jurisdiction of a zemindar, also ZAMINDARI, ZAMINDARY, ZEMINDARI [n]\n",
  "ZEMINDARIS": "ZEMINDARI, (Hindi) the jurisdiction of a zemindar, also ZAMINDARI, ZAMINDARY, ZEMINDARY [n]\n",
  "ZEMINDARS": "ZEMINDAR, (Hindi) in India, a type of landowner, also ZAMINDAR [n]\n",
  "ZEMINDARY": "(Hindi) the jurisdiction of a zemindar, also ZAMINDARI, ZAMINDARY, ZEMINDARI [n ZEMINDARIES]\n",
  "ZEMSTVA": "ZEMSTVO, (Russian) an elected local administrative council in Czarist Russia [n]\n",
  "ZEMSTVO": "(Russian) an elected local administrative council in Czarist Russia [n ZEMSTVA or ZEMSTVOS]\n",
  "ZEMSTVOS": "ZEMSTVO, (Russian) an elected local administrative council in Czarist Russia [n]\n",
  "ZEN": "a state of calm attentiveness [n -S]\n",
  "ZENAIDA": "a wild dove [n -S]\n",
  "ZENAIDAS": "ZENAIDA, a wild dove [n]\n",
  "ZENANA": "(Urdu) in the Indian subcontinent, the part of a house in which high-caste women are or were secluded, also ZANANA [n -S]\n",
  "ZENANAS": "ZENANA, (Urdu) in the Indian subcontinent, the part of a house in which high-caste women are or were secluded, also ZANANA [n]\n",
  "ZENDIK": "(Arabic) in the east, one who abstains from magic or practises religion [n -S]\n",
  "ZENDIKS": "ZENDIK, (Arabic) in the east, one who abstains from magic or practises religion [n]\n",
  "ZENDO": "(Japanese) a place where Zen Buddhists study [n -S]\n",
  "ZENDOS": "ZENDO, (Japanese) a place where Zen Buddhists study [n]\n",
  "ZENITH": "the highest point [n -S]\n",
  "ZENITHAL": "of the highest point [adj]\n",
  "ZENITHS": "ZENITH, the highest point [n]\n",
  "ZENS": "ZEN, a state of calm attentiveness [n]\n",
  "ZEOLITE": "any of a larger group of aluminosilicate minerals [n -S]\n",
  "ZEOLITES": "ZEOLITE, any of a larger group of aluminosilicate minerals [n]\n",
  "ZEOLITIC": "of or pertaining to a zeolite [adj]\n",
  "ZEOLITIFORM": "having the form of a zeolite [adj]\n",
  "ZEP": "a long zeppelin shaped sandwich [n -S]\n",
  "ZEPHYR": "(Greek) a gentle breeze [n -S]\n",
  "ZEPHYRS": "ZEPHYR, (Greek) a gentle breeze [n]\n",
  "ZEPPELIN": "(German) a dirigible, cigar-shaped airship of the type designed by Count Zeppelin (c. 1900) [n -S]\n",
  "ZEPPELINS": "ZEPPELIN, (German) a dirigible, cigar-shaped airship of the type designed by Count Zeppelin (c. 1900) [n]\n",
  "ZEPPOLE": "(Italian) an Italian fritter [n ZEPPOLES or ZEPPOLI]\n",
  "ZEPPOLES": "ZEPPOLE, (Italian) an Italian fritter [n]\n",
  "ZEPPOLI": "ZEPPOLE, (Italian) an Italian fritter [n]\n",
  "ZEPS": "ZEP, a long zeppelin shaped sandwich [n]\n",
  "ZEPTOSECOND": "a 10 to the -21 part of a second [n -S]\n",
  "ZEPTOSECONDS": "ZEPTOSECOND, a 10 to the -21 part of a second [n]\n",
  "ZERDA": "(Arabic) a desert fox, aka fennec [n -S]\n",
  "ZERDAS": "ZERDA, (Arabic) a desert fox, aka fennec [n]\n",
  "ZEREBA": "(Arabic) an improvised stockade; esp. one made of thorn bushes, etc., also ZAREBA, ZAREEBA, ZARIBA, ZERIBA [n -S]\n",
  "ZEREBAS": "ZEREBA, (Arabic) an improvised stockade; esp. one made of thorn bushes, etc., also ZAREBA, ZAREEBA, ZARIBA, ZERIBA [n]\n",
  "ZERIBA": "(Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREBA, ZAREEBA, ZARIBA, ZEREBA [n -S]\n",
  "ZERIBAS": "ZERIBA, (Arabic) an improvised stockade, esp. one made of thorn bushes, etc., also ZAREBA, ZAREEBA, ZARIBA, ZEREBA [n]\n",
  "ZERK": "a fitting on a bearing, axle, etc. by which lubricant can be introduced under pressure [n -S]\n",
  "ZERKS": "ZERK, a fitting on a bearing, axle, etc. by which lubricant can be introduced under pressure [n]\n",
  "ZERO": "to set at or adjust to zero [v ZEROED, ZEROING, ZEROES or ZEROS]\n",
  "ZEROED": "ZERO, to set at or adjust to zero [v]\n",
  "ZEROES": "ZERO, to set at or adjust to zero [v]\n",
  "ZEROING": "ZERO, to set at or adjust to zero [v]\n",
  "ZEROS": "ZERO, to set at or adjust to zero [v]\n",
  "ZEROTH": "being numbered zero in a series [adj]\n",
  "ZERUMBET": "(Persian) an East Indian drug, related to cassumunar and zedoary [n -S]\n",
  "ZERUMBETS": "ZERUMBET, (Persian) an East Indian drug, related to cassumunar and zedoary [n]\n",
  "ZEST": "enthusiasm; relish [n -S] / to give zest to [v -ED, -ING, -S]\n",
  "ZESTED": "ZEST, to give zest to [v]\n",
  "ZESTER": "a utensil for peeling citrus rind [n -S]\n",
  "ZESTERS": "ZESTER, a utensil for peeling citrus rind [n]\n",
  "ZESTFUL": "full of zest [adj ZESTFULLY]\n",
  "ZESTFULLY": "ZESTFUL, full of zest [adv]\n",
  "ZESTFULNESS": "the state of being zestful [n -ES]\n",
  "ZESTFULNESSES": "ZESTFULNESS, the state of being zestful [n]\n",
  "ZESTIER": "ZESTY, full of zest [adj]\n",
  "ZESTIEST": "ZESTY, full of zest [adj]\n",
  "ZESTILY": "ZESTY, full of zest [adv]\n",
  "ZESTINESS": "the quality of being zesty [n -ES]\n",
  "ZESTINESSES": "ZESTINESS, the quality of being zesty [n]\n",
  "ZESTING": "ZEST, to give zest to [v]\n",
  "ZESTLESS": "without zest [adj]\n",
  "ZESTS": "ZEST, to give zest to [v]\n",
  "ZESTY": "full of zest [adj ZESTIER, ZESTIEST, ZESTILY]\n",
  "ZETA": "(Greek) a Greek letter [n -S]\n",
  "ZETAS": "ZETA, (Greek) a Greek letter [n]\n",
  "ZETETIC": "(Greek) a search, an enquiry [n -S]\n",
  "ZETETICS": "ZETETIC, (Greek) a search, an enquiry [n]\n",
  "ZETTABYTE": "a unit of computer memory, 10 to the 21 bytes [n -S]\n",
  "ZETTABYTES": "ZETTABYTE, a unit of computer memory, 10 to the 21 bytes [n]\n",
  "ZEUGLODONT": "any of a genus of fossil whales [n -S]\n",
  "ZEUGLODONTS": "ZEUGLODONT, any of a genus of fossil whales [n]\n",
  "ZEUGMA": "(Greek) a figure of speech [n -S]\n",
  "ZEUGMAS": "ZEUGMA, (Greek) a figure of speech [n]\n",
  "ZEUGMATIC": "of or pertaining to zeugma, the literary device of using word to modify two other words with only one of which it is correctly used [adj ZEUGMATICALLY]\n",
  "ZEUGMATICALLY": "ZEUGMATIC, of or pertaining to zeugma, the literary device of using word to modify two other words with only one of which it is correctly used [adv]\n",
  "ZEUXITE": "(Greek) a mineral, ferriferous tourmaline [n -S]\n",
  "ZEUXITES": "ZEUXITE, (Greek) a mineral, ferriferous tourmaline [n]\n",
  "ZEX": "a chopper for trimming slate, also SAX, ZAX [n -ES]\n",
  "ZEXES": "ZEX, a chopper for trimming slate, also SAX, ZAX [n]\n",
  "ZEZE": "(Bantu) a stringed musical instrument of Africa [n -S]\n",
  "ZEZES": "ZEZE, (Bantu) a stringed musical instrument of Africa [n]\n",
  "ZHO": "(Tibetan) a cross between a yak and a cow, also DSO, DZHO, DZO, ZO [n -S]\n",
  "ZHOMO": "(Tibetan) the female of the zho, also DSOMO, JOMO [n -S]\n",
  "ZHOMOS": "ZHOMO, (Tibetan) the female of the zho, also DSOMO, JOMO [n]\n",
  "ZHOOSH": "to make more attractive [v -ED, -ING, -ES]\n",
  "ZHOOSHED": "ZHOOSH, to make more attractive [v]\n",
  "ZHOOSHES": "ZHOOSH, to make more attractive [v]\n",
  "ZHOOSHING": "ZHOOSH, to make more attractive [v]\n",
  "ZHOS": "ZHO, (Tibetan) a cross between a yak and a cow, also DSO, DZHO, DZO, ZO [n]\n",
  "ZIBELINE": "the fur of the sable; a soft woollen material with a lustrous pile, also ZIBELLINE [n -S]\n",
  "ZIBELINES": "ZIBELINE, the fur of the sable; a soft woollen material with a lustrous pile, also ZIBELLINE [n]\n",
  "ZIBELLINE": "the fur of the sable; a soft woollen material with a lustrous pile, also ZIBELINE [n -S]\n",
  "ZIBELLINES": "ZIBELLINE, the fur of the sable; a soft woollen material with a lustrous pile, also ZIBELINE [n]\n",
  "ZIBET": "(Arabic) a civet cat, also ZIBETH [n -S]\n",
  "ZIBETH": "(Arabic) a civet cat, also ZIBET [n -S]\n",
  "ZIBETHS": "ZIBETH, (Arabic) a civet cat, also ZIBET [n]\n",
  "ZIBETS": "ZIBET, (Arabic) a civet cat, also ZIBETH [n]\n",
  "ZIDOVUDINE": "the manufacturer's name for the drug AZT [n -S]\n",
  "ZIDOVUDINES": "ZIDOVUDINE, the manufacturer's name for the drug AZT [n]\n",
  "ZIFF": "(Australian slang) a beard, a goatee [n -S]\n",
  "ZIFFIUS": "(Spenser) a sea-monster, perhaps a swordfish [n -ES]\n",
  "ZIFFIUSES": "ZIFFIUS, (Spenser) a sea-monster, perhaps a swordfish [n]\n",
  "ZIFFS": "ZIFF, (Australian slang) a beard, a goatee [n]\n",
  "ZIG": "to change course sharply [v ZIGGED, ZIGGING, ZIGS]\n",
  "ZIGAN": "(Hungarian) a gypsy, also TSIGANE, TZIGANE, TZIGANY [n -S]\n",
  "ZIGANKA": "(Russian) a Russian country dance [n -S]\n",
  "ZIGANKAS": "ZIGANKA, (Russian) a Russian country dance [n]\n",
  "ZIGANS": "ZIGAN, (Hungarian) a gypsy, also TSIGANE, TZIGANE, TZIGANY [n]\n",
  "ZIGGED": "ZIG, to change course sharply [v]\n",
  "ZIGGING": "ZIG, to change course sharply [v]\n",
  "ZIGGURAT": "a Babylonian temple tower, also ZIKKURAT, ZIKURAT [n -S]\n",
  "ZIGGURATS": "ZIGGURAT, a Babylonian temple tower, also ZIKKURAT, ZIKURAT [n]\n",
  "ZIGS": "ZIG, to change course sharply [v]\n",
  "ZIGZAG": "to turn sharply from side to side [v ZIGZAGGED, ZIGZAGGING, ZIGZAGS]\n",
  "ZIGZAGGED": "ZIGZAG, to turn sharply from side to side [v]\n",
  "ZIGZAGGEDNESS": "the state of being zigzag, also ZIGZAGGERY [n -ES]\n",
  "ZIGZAGGEDNESSES": "ZIGZAGGEDNESS, the state of being zigzag, also ZIGZAGGERY [n]\n",
  "ZIGZAGGER": "one who zigzags [n -S]\n",
  "ZIGZAGGERIES": "ZIGZAGGERY, the state of being zigzag, also ZIGZAGGEDNESS [n]\n",
  "ZIGZAGGERS": "ZIGZAGGER, one who zigzags [n]\n",
  "ZIGZAGGERY": "the state of being zigzag, also ZIGZAGGEDNESS [n ZIGZAGGERIES]\n",
  "ZIGZAGGIER": "ZIGZAGGY, having sharp turns [adj]\n",
  "ZIGZAGGIEST": "ZIGZAGGY, having sharp turns [adj]\n",
  "ZIGZAGGING": "ZIGZAG, to turn sharply from side to side [v]\n",
  "ZIGZAGGY": "having sharp turns [adj ZIGZAGGIER, ZIGZAGGIEST]\n",
  "ZIGZAGS": "ZIGZAG, to turn sharply from side to side [v]\n",
  "ZIKKURAT": "a Babylonian temple tower, also ZIGGURAT, ZIKURAT [n -S]\n",
  "ZIKKURATS": "ZIKKURAT, a Babylonian temple tower, also ZIGGURAT, ZIKURAT [n]\n",
  "ZIKURAT": "a Babylonian temple tower, also ZIGGURAT, ZIKKURAT [n -S]\n",
  "ZIKURATS": "ZIKURAT, a Babylonian temple tower, also ZIGGURAT, ZIKKURAT [n]\n",
  "ZILA": "(Hindi) an administrative district in British India, also ZILLA, ZILLAH [n -S]\n",
  "ZILAS": "ZILA, (Hindi) an administrative district in British India, also ZILLA, ZILLAH [n]\n",
  "ZILCH": "nothing [n -ES]\n",
  "ZILCHES": "ZILCH, nothing [n]\n",
  "ZILL": "one of a pair of finger cymbals [n -S]\n",
  "ZILLA": "(Hindi) an administrative district in British India, also ZILA, ZILLAH [n -S]\n",
  "ZILLAH": "(Hindi) an administrative district in British India, also ZILA, ZILLA [n -S]\n",
  "ZILLAHS": "ZILLAH, (Hindi) an administrative district in British India, also ZILA, ZILLA [n]\n",
  "ZILLAS": "ZILLA, (Hindi) an administrative district in British India, also ZILA, ZILLAH [n]\n",
  "ZILLION": "an extremely large but unspecified number, many millions [n -S]\n",
  "ZILLIONAIRE": "one who possesses zillions of pounds [n -S]\n",
  "ZILLIONAIRES": "ZILLIONAIRE, one who possesses zillions of pounds [n]\n",
  "ZILLIONS": "ZILLION, an extremely large but unspecified number, many millions [n]\n",
  "ZILLIONTH": "the ordinal of zillion [adj] / a zillionth part of something [n -S]\n",
  "ZILLIONTHS": "ZILLIONTH, a zillionth part of something [n]\n",
  "ZILLS": "ZILL, one of a pair of finger cymbals [n]\n",
  "ZIMB": "(Amharic) an Ethiopian dipterous insect, also ZEBUB [n -S]\n",
  "ZIMBI": "(Portuguese) a kind of shell used as money [n -S]\n",
  "ZIMBIS": "ZIMBI, (Portuguese) a kind of shell used as money [n]\n",
  "ZIMBS": "ZIMB, (Amharic) an Ethiopian dipterous insect, also ZEBUB [n]\n",
  "ZIMOCCA": "a type of bath-sponge [n -S]\n",
  "ZIMOCCAS": "ZIMOCCA, a type of bath-sponge [n]\n",
  "ZIN": "(short for) zinfandel, a kind of grape [n -S]\n",
  "ZINC": "to coat with a metallic element [v ZINCKED or ZINCED or ZINKED, ZINCKING or ZINCING or ZINKING, ZINCS]\n",
  "ZINCATE": "a salt of zinc [n -S]\n",
  "ZINCATES": "ZINCATE, a salt of zinc [n]\n",
  "ZINCED": "ZINC, to coat with a metallic element [v]\n",
  "ZINCIC": "pertaining to, containing, or resembling, zinc, also ZINCOID, ZINCOUS [adj]\n",
  "ZINCIER": "ZINCY, of or like zinc, also ZINCKY, ZINKY [adj]\n",
  "ZINCIEST": "ZINCY, of or like zinc, also ZINCKY, ZINKY [adj]\n",
  "ZINCIFEROUS": "bearing zinc, also ZINKIFEROUS [adj]\n",
  "ZINCIFICATION": "the process of coating with zinc, also ZINCKIFICATION, ZINKIFICATION [n -S]\n",
  "ZINCIFICATIONS": "ZINCIFICATION, the process of coating with zinc, also ZINCKIFICATION, ZINKIFICATION [n]\n",
  "ZINCIFIED": "ZINCIFY, to coat with zinc, also ZINCKIFY, ZINKIFY [v]\n",
  "ZINCIFIES": "ZINCIFY, to coat with zinc, also ZINCKIFY, ZINKIFY [v]\n",
  "ZINCIFY": "to coat with zinc, also ZINCKIFY, ZINKIFY [v ZINCIFIED, ZINCIFYING, ZINCIFIES]\n",
  "ZINCIFYING": "ZINCIFY, to coat with zinc, also ZINCKIFY, ZINKIFY [v]\n",
  "ZINCING": "ZINC, to coat with a metallic element [v]\n",
  "ZINCITE": "an oxide of zinc [n -S]\n",
  "ZINCITES": "ZINCITE, an oxide of zinc [n]\n",
  "ZINCKED": "ZINC, to coat with a metallic element [v]\n",
  "ZINCKENITE": "a steel-gray metallic mineral, a sulphide of antimony and lead, also ZINKENITE [n -S]\n",
  "ZINCKENITES": "ZINCKENITE, a steel-gray metallic mineral, a sulphide of antimony and lead, also ZINKENITE [n]\n",
  "ZINCKIER": "ZINCKY, of or like zinc, also ZINCY, ZINKY [adj]\n",
  "ZINCKIEST": "ZINCKY, of or like zinc, also ZINCY, ZINKY [adj]\n",
  "ZINCKIFICATION": "the process of coating with zinc, also ZINCIFICATION, ZINKIFICATION [n -S]\n",
  "ZINCKIFICATIONS": "ZINCKIFICATION, the process of coating with zinc, also ZINCIFICATION, ZINKIFICATION [n]\n",
  "ZINCKIFIED": "ZINCKIFY, to coat with zinc, also ZINCIFY, ZINKIFY [v]\n",
  "ZINCKIFIES": "ZINCKIFY, to coat with zinc, also ZINCIFY, ZINKIFY [v]\n",
  "ZINCKIFY": "to coat with zinc, also ZINCIFY, ZINKIFY [v ZINCKIFIED, ZINCKIFYING, ZINCKIFIES]\n",
  "ZINCKIFYING": "ZINCKIFY, to coat with zinc, also ZINCIFY, ZINKIFY [v]\n",
  "ZINCKING": "ZINC, to coat with a metallic element [v]\n",
  "ZINCKY": "of or like zinc, also ZINCY, ZINKY [adj ZINCKIER, ZINCKIEST]\n",
  "ZINCO": "(short for) a zincograph, a plate or picture produced by zincography [n -S]\n",
  "ZINCODE": "(obsolete) the positive electrode of an electrolytic cell; the anode [n -S]\n",
  "ZINCODES": "ZINCODE, (obsolete) the positive electrode of an electrolytic cell; the anode [n]\n",
  "ZINCOGRAPH": "a plate or picture produced by zincography [n -S]\n",
  "ZINCOGRAPHER": "one who produces zincographs [n -S]\n",
  "ZINCOGRAPHERS": "ZINCOGRAPHER, one who produces zincographs [n]\n",
  "ZINCOGRAPHIC": "relating to zincography, an engraving process in which zinc is covered with wax and etched, also ZINCOGRAPHICAL [adj]\n",
  "ZINCOGRAPHICAL": "relating to zincography, an engraving process in which zinc is covered with wax and etched, also ZINCOGRAPHIC [adj]\n",
  "ZINCOGRAPHIES": "ZINCOGRAPHY, an engraving process in which zinc is covered with wax and etched [n]\n",
  "ZINCOGRAPHS": "ZINCOGRAPH, a plate or picture produced by zincography [n]\n",
  "ZINCOGRAPHY": "an engraving process in which zinc is covered with wax and etched [n ZINCOGRAPHIES]\n",
  "ZINCOID": "like zinc, also ZINCIC, ZINCOUS [adj]\n",
  "ZINCOLYSES": "ZINCOLYSIS, (obsolete) electrolysis [n]\n",
  "ZINCOLYSIS": "(obsolete) electrolysis [n ZINCOLYSES]\n",
  "ZINCOS": "ZINCO, (short for) a zincograph, a plate or picture produced by zincography [n]\n",
  "ZINCOUS": "relating to or like zinc, also ZINCIC, ZINCOID [adj]\n",
  "ZINCS": "ZINC, to coat with a metallic element [v]\n",
  "ZINCY": "of or like zinc, also ZINCKY, ZINKY [adj ZINCIER or ZINCKIER, ZINCIEST or ZINCKIEST]\n",
  "ZINDABAD": "(Hindi) long live, used in slogans [interj]\n",
  "ZINE": "(slang) a magazine for specialist interests, especially a Web-based one [n -S]\n",
  "ZINEB": "an organic fungicide [n -S]\n",
  "ZINEBS": "ZINEB, an organic fungicide [n]\n",
  "ZINES": "ZINE, (slang) a magazine for specialist interests, especially a Web-based one [n]\n",
  "ZINFANDEL": "a black wine-grape of California; the wine produced from this [n -S]\n",
  "ZINFANDELS": "ZINFANDEL, a black wine-grape of California; the wine produced from this [n]\n",
  "ZING": "to move very swiftly, esp. with a high-pitched hum [v -ED, -ING, -S]\n",
  "ZINGANI": "ZINGANO, (Italian) an Italian gypsy, also ZINGARO [n]\n",
  "ZINGANO": "(Italian) an Italian gypsy, also ZINGARO [n ZINGANI]\n",
  "ZINGARA": "(Italian) a (female) gypsy [n ZINGARE]\n",
  "ZINGARE": "ZINGARA, (Italian) a (female) gypsy [n]\n",
  "ZINGARI": "ZINGARO, (Italian) an Italian gypsy, also ZINGANO [n]\n",
  "ZINGARO": "(Italian) an Italian gypsy, also ZINGANO [n ZINGARI]\n",
  "ZINGED": "ZING, to move very swiftly, esp. with a high-pitched hum [v]\n",
  "ZINGEL": "(German) a fish of the perch family, found in the Danube [n -S]\n",
  "ZINGELS": "ZINGEL, (German) a fish of the perch family, found in the Danube [n]\n",
  "ZINGER": "someone or something with zing [n -S]\n",
  "ZINGERS": "ZINGER, someone or something with zing [n]\n",
  "ZINGIBER": "(Latin) a plant of the ginger family [n -S]\n",
  "ZINGIBERACEOUS": "belonging to the zingiber family, also ZINZIBERACEOUS [adj]\n",
  "ZINGIBERS": "ZINGIBER, (Latin) a plant of the ginger family [n]\n",
  "ZINGIER": "ZINGY, full of zest [adj]\n",
  "ZINGIEST": "ZINGY, full of zest [adj]\n",
  "ZINGING": "ZING, to move very swiftly, esp. with a high-pitched hum [v]\n",
  "ZINGS": "ZING, to move very swiftly, esp. with a high-pitched hum [v]\n",
  "ZINGY": "full of zest [adj ZINGIER, ZINGIEST]\n",
  "ZINJANTHROPI": "ZINJANTHROPUS, a type of australopithecine, remains of which were discovered in the Olduvai Gorge in Tanzania in 1959 [n]\n",
  "ZINJANTHROPUS": "a type of australopithecine, remains of which were discovered in the Olduvai Gorge in Tanzania in 1959 [n ZINJANTHROPUSES or ZINJANTHROPI]\n",
  "ZINJANTHROPUSES": "ZINJANTHROPUS, a type of australopithecine, remains of which were discovered in the Olduvai Gorge in Tanzania in 1959 [n]\n",
  "ZINKE": "(German) an old wind instrument, like a cornet [n -S]\n",
  "ZINKED": "ZINC, to coat with a metallic element [v]\n",
  "ZINKENITE": "a steel-gray metallic mineral, a sulphide of antimony and lead, also ZINCKENITE [n -S]\n",
  "ZINKENITES": "ZINKENITE, a steel-gray metallic mineral, a sulphide of antimony and lead, also ZINCKENITE [n]\n",
  "ZINKES": "ZINKE, (German) an old wind instrument, like a cornet [n]\n",
  "ZINKIER": "ZINKY, of or like zinc, also ZINCKY, ZINCY [adj]\n",
  "ZINKIEST": "ZINKY, of or like zinc, also ZINCKY, ZINCY [adj]\n",
  "ZINKIFEROUS": "bearing zinc, also ZINCIFEROUS [adj]\n",
  "ZINKIFICATION": "the process of coating with zinc, also ZINCIFICATION, ZINCKIFICATION [n -S]\n",
  "ZINKIFICATIONS": "ZINKIFICATION, the process of coating with zinc, also ZINCIFICATION, ZINCKIFICATION [n]\n",
  "ZINKIFIED": "ZINKIFY, to coat or impregnate with zinc, also ZINCIFY, ZINCKIFY [v]\n",
  "ZINKIFIES": "ZINKIFY, to coat or impregnate with zinc, also ZINCIFY, ZINCKIFY [v]\n",
  "ZINKIFY": "to coat or impregnate with zinc, also ZINCIFY, ZINCKIFY [v ZINKIFIED, ZINKIFYING, ZINKIFIES]\n",
  "ZINKIFYING": "ZINKIFY, to coat or impregnate with zinc, also ZINCIFY, ZINCKIFY [v]\n",
  "ZINKING": "ZINC, to coat with a metallic element [v]\n",
  "ZINKY": "of or like zinc, also ZINCKY, ZINCY [adj ZINKIER, ZINKIEST]\n",
  "ZINNIA": "a garden flower [n -S]\n",
  "ZINNIAS": "ZINNIA, a garden flower [n]\n",
  "ZINS": "ZIN, (short for) zinfandel, a kind of grape [n]\n",
  "ZINZIBERACEOUS": "belonging to the zingiber family, also ZINGIBERACEOUS [adj]\n",
  "ZIP": "to fasten with a metal fastener with teeth [v ZIPPED, ZIPPING, ZIPS]\n",
  "ZIPLESS": "lacking energy [adj]\n",
  "ZIPLINE": "a mechanism for travelling above the ground by holding a pulley that slides down a taut angled rope, also ZIPWIRE [n -S]\n",
  "ZIPLINES": "ZIPLINE, a mechanism for travelling above the ground by holding a pulley that slides down a taut angled rope, also ZIPWIRE [n]\n",
  "ZIPLOCK": "to seal a plastic bag, esp. by pressing together [v -ED, -ING, -S]\n",
  "ZIPLOCKED": "ZIPLOCK, to seal a plastic bag, esp. by pressing together [v]\n",
  "ZIPLOCKING": "ZIPLOCK, to seal a plastic bag, esp. by pressing together [v]\n",
  "ZIPLOCKS": "ZIPLOCK, to seal a plastic bag, esp. by pressing together [v]\n",
  "ZIPOLA": "nothing [n -S]\n",
  "ZIPOLAS": "ZIPOLA, nothing [n]\n",
  "ZIPPED": "ZIP, to fasten with a metal fastener with teeth [v]\n",
  "ZIPPER": "to close with an interlocking fastener [v -ED, -ING, -S]\n",
  "ZIPPERED": "ZIPPER, to close with an interlocking fastener [v]\n",
  "ZIPPERING": "ZIPPER, to close with an interlocking fastener [v]\n",
  "ZIPPERS": "ZIPPER, to close with an interlocking fastener [v]\n",
  "ZIPPIER": "ZIPPY, full of zip, energy [adj]\n",
  "ZIPPIEST": "ZIPPY, full of zip, energy [adj]\n",
  "ZIPPILY": "ZIPPY, full of zip, energy [adv]\n",
  "ZIPPINESS": "the quality of being zippy [n -ES]\n",
  "ZIPPINESSES": "ZIPPINESS, the quality of being zippy [n]\n",
  "ZIPPING": "ZIP, to fasten with a metal fastener with teeth [v]\n",
  "ZIPPO": "(US slang) nothing, zero [n -S]\n",
  "ZIPPOS": "ZIPPO, (US slang) nothing, zero [n]\n",
  "ZIPPY": "full of zip, energy [adj ZIPPIER, ZIPPIEST, ZIPPILY]\n",
  "ZIPS": "ZIP, to fasten with a metal fastener with teeth [v]\n",
  "ZIPTOP": "having a top that fastens with a zip [adj]\n",
  "ZIPWIRE": "a mechanism for travelling above the ground by holding a pulley that slides down a taut angled rope, also ZIPLINE [n -S]\n",
  "ZIPWIRES": "ZIPWIRE, a mechanism for travelling above the ground by holding a pulley that slides down a taut angled rope, also ZIPLINE [n]\n",
  "ZIRAM": "a white compound used as a fungicidal powder on vegetables and some fruit crops [n -S]\n",
  "ZIRAMS": "ZIRAM, a white compound used as a fungicidal powder on vegetables and some fruit crops [n]\n",
  "ZIRCALLOY": "an alloy of zirconium containing small amounts of tin, chromium, and nickel, used in pressurized-water reactors, also ZIRCALOY [n -S]\n",
  "ZIRCALLOYS": "ZIRCALLOY, an alloy of zirconium containing small amounts of tin, chromium, and nickel, used in pressurized-water reactors, also ZIRCALOY [n]\n",
  "ZIRCALOY": "an alloy of zirconium containing small amounts of tin, chromium, and nickel, used in pressurized-water reactors, also ZIRCALLOY [n -S]\n",
  "ZIRCALOYS": "ZIRCALOY, an alloy of zirconium containing small amounts of tin, chromium, and nickel, used in pressurized-water reactors, also ZIRCALLOY [n]\n",
  "ZIRCON": "(Arabic) a tetragonal mineral, zirconium silicate, of which jacinth and jargoon are varieties [n -S]\n",
  "ZIRCONIA": "an oxide of zirconium [n -S]\n",
  "ZIRCONIAS": "ZIRCONIA, an oxide of zirconium [n]\n",
  "ZIRCONIC": "pertaining to the metallic element zirconium [adj]\n",
  "ZIRCONIUM": "a rare element of the carbon-silicon group [n -S]\n",
  "ZIRCONIUMS": "ZIRCONIUM, a rare element of the carbon-silicon group [n]\n",
  "ZIRCONS": "ZIRCON, (Arabic) a tetragonal mineral, zirconium silicate, of which jacinth and jargoon are varieties [n]\n",
  "ZIT": "a pimple [n -S]\n",
  "ZITE": "(Italian) a type of pasta like macaroni, also ZITI [n]\n",
  "ZITHER": "(German) a stringed instrument, also ZITHERN [n -S]\n",
  "ZITHERIST": "one who plays the zither [n -S]\n",
  "ZITHERISTS": "ZITHERIST, one who plays the zither [n]\n",
  "ZITHERN": "(German) a stringed instrument, also ZITHER [n -S]\n",
  "ZITHERNS": "ZITHERN, (German) a stringed instrument, also ZITHER [n]\n",
  "ZITHERS": "ZITHER, (German) a stringed instrument, also ZITHERN [n]\n",
  "ZITI": "(Italian) a type of pasta like macaroni, also ZITE [n -S]\n",
  "ZITIS": "ZITI, (Italian) a type of pasta like macaroni, also ZITE [n]\n",
  "ZITS": "ZIT, a pimple [n]\n",
  "ZIZ": "to take a nap [v ZIZZED, ZIZZING, ZIZZES]\n",
  "ZIZANIA": "(Greek) a genus of grasses including Indian rice [n -S]\n",
  "ZIZANIAS": "ZIZANIA, (Greek) a genus of grasses including Indian rice [n]\n",
  "ZIZEL": "(German) the ground-squirrel [n -S]\n",
  "ZIZELS": "ZIZEL, (German) the ground-squirrel [n]\n",
  "ZIZIT": "(Hebrew) the tassels on the four corners of a Jewish prayer shawl, also TSITSITH, TZITZIS, TZITZIT, TZITZITH, ZIZITH [n]\n",
  "ZIZITH": "(Hebrew) the tassels on the four corners of a Jewish prayer shawl, also TSITSITH, TZITZIS, TZITZIT, TZITZITH, ZIZIT [n]\n",
  "ZIZYPHUS": "(Latin) a shrub or tree of the buckthorn family, aka the jujube tree [n -ES]\n",
  "ZIZYPHUSES": "ZIZYPHUS, (Latin) a shrub or tree of the buckthorn family, aka the jujube tree [n]\n",
  "ZIZZ": "to snooze, also ZIZ [v -ED, -ING, -ES]\n",
  "ZIZZED": "ZIZZ, to snooze, also ZIZ [v]\n",
  "ZIZZES": "ZIZZ, to snooze, also ZIZ [v]\n",
  "ZIZZING": "ZIZZ, to snooze, also ZIZ [v]\n",
  "ZIZZLE": "to sizzle [v ZIZZLED, ZIZZLING, ZIZZLES]\n",
  "ZIZZLED": "ZIZZLE, to sizzle [v]\n",
  "ZIZZLES": "ZIZZLE, to sizzle [v]\n",
  "ZIZZLING": "ZIZZLE, to sizzle [v]\n",
  "ZLOTE": "ZLOTY, (Polish) a monetary unit of Poland [n]\n",
  "ZLOTIES": "ZLOTY, (Polish) a monetary unit of Poland [n]\n",
  "ZLOTY": "(Polish) a monetary unit of Poland [n ZLOTIES or ZLOTE or ZLOTYCH or ZLOTYS]\n",
  "ZLOTYCH": "ZLOTY, (Polish) a monetary unit of Poland [n]\n",
  "ZLOTYS": "ZLOTY, (Polish) a monetary unit of Poland [n]\n",
  "ZO": "(Tibetan) a cross between a yak and a cow, also DSO, DZHO, DZO, ZHO [n -S]\n",
  "ZOA": "ZOON, the whole product of one fertilized egg [n]\n",
  "ZOAEA": "a larval stage of crabs, also ZOEA, ZOOEA [n ZOAEAS or ZOAEAE]\n",
  "ZOAEAE": "ZOAEA, a larval stage of crabs, also ZOEA, ZOOEA [n]\n",
  "ZOAEAS": "ZOAEA, a larval stage of crabs, also ZOEA, ZOOEA [n]\n",
  "ZOANTHARIAN": "a member of the Zoantharia, the order including sea-anemones [n -S]\n",
  "ZOANTHARIANS": "ZOANTHARIAN, a member of the Zoantharia, the order including sea-anemones [n]\n",
  "ZOANTHROPIC": "relating to zoanthropy, a form of mental delusion in which a person believes himself or herself to be an animal [adj]\n",
  "ZOANTHROPIES": "ZOANTHROPY, a form of mental delusion in which a person believes himself or herself to be an animal [n]\n",
  "ZOANTHROPY": "a form of mental delusion in which a person believes himself or herself to be an animal [n ZOANTHROPIES]\n",
  "ZOARIA": "ZOARIUM, (Greek) a colony of zooids [n]\n",
  "ZOARIAL": "relating to a zoarium, the zooids of a polyzoan colony [adj]\n",
  "ZOARIUM": "(Greek) a colony of zooids [n ZOARIA]\n",
  "ZOBO": "(Tibetan) a male zo, also DSOBO, ZOBU [n -S]\n",
  "ZOBOS": "ZOBO, (Tibetan) a male zo, also DSOBO, ZOBU [n]\n",
  "ZOBU": "(Tibetan) a male zo, also DSOBO, ZOBO [n -S]\n",
  "ZOBUS": "ZOBU, (Tibetan) a male zo, also DSOBO, ZOBO [n]\n",
  "ZOCALO": "(Spanish) in Mexico, a public square or plaza [n -S]\n",
  "ZOCALOS": "ZOCALO, (Spanish) in Mexico, a public square or plaza [n]\n",
  "ZOCCO": "(Italian) a plain face or plinth at the foot of a wall, column etc., ZOCCOLO [n -S]\n",
  "ZOCCOLO": "(Italian) a plain face or plinth at the foot of a wall, column etc., also ZOCCO [n -S]\n",
  "ZOCCOLOS": "ZOCCOLO, (Italian) a plain face or plinth at the foot of a wall, column etc., also ZOCCO [n]\n",
  "ZOCCOS": "ZOCCO, (Italian) a plain face or plinth at the foot of a wall, column etc., ZOCCOLO [n]\n",
  "ZODIAC": "an imaginary belt in the heavens [n -S]\n",
  "ZODIACAL": "pertaining to the zodiac [adj]\n",
  "ZODIACS": "ZODIAC, an imaginary belt in the heavens [n]\n",
  "ZOEA": "(Greek) the larval stage of crabs, also ZOOEA, ZOOEA [n ZOEAS or ZOEAE]\n",
  "ZOEAE": "ZOEA, (Greek) the larval stage of crabs, also ZOOEA, ZOOEA [n]\n",
  "ZOEAL": "pertaining to a zoea, a larval stage in certain crustaceans [adj]\n",
  "ZOEAS": "ZOEA, (Greek) the larval stage of crabs, also ZOOEA, ZOOEA [n]\n",
  "ZOECHROME": "an early colour cinematographic process, aka zoetrope [n -S]\n",
  "ZOECHROMES": "ZOECHROME, an early colour cinematographic process, aka zoetrope [n]\n",
  "ZOECIA": "ZOECIUM, (Greek) a sac lived in by an aquatic organism, also ZOOECIUM [n]\n",
  "ZOECIUM": "(Greek) a sac lived in by an aquatic organism, also ZOOECIUM [n ZOECIA]\n",
  "ZOEFORM": "like a zoea, the larval stage of certain crustaceans [adj]\n",
  "ZOETIC": "relating to life [adj]\n",
  "ZOETROPE": "(Greek) a slotted rotating cylinder producing primitive animation, also ZOOTROPE [n -S]\n",
  "ZOETROPES": "ZOETROPE, (Greek) a slotted rotating cylinder producing primitive animation, also ZOOTROPE [n]\n",
  "ZOETROPIC": "of or like a zoetrope, a slotted rotating cylinder producing primitive animation [adj]\n",
  "ZOFTIG": "(Yiddish) having a full rounded figure, pleasingly plump, also ZAFTIG [adj]\n",
  "ZOIATRIA": "(Greek) veterinary surgery [n -S]\n",
  "ZOIATRIAS": "ZOIATRIA, (Greek) veterinary surgery [n]\n",
  "ZOIATRICS": "veterinary surgery [n]\n",
  "ZOIC": "pertaining to animals; containing evidence of life [adj]\n",
  "ZOISITE": "a silicate of calcium and aluminium [n -S]\n",
  "ZOISITES": "ZOISITE, a silicate of calcium and aluminium [n]\n",
  "ZOISM": "the doctrine that life originates from a single vital principle [n -S]\n",
  "ZOISMS": "ZOISM, the doctrine that life originates from a single vital principle [n]\n",
  "ZOIST": "a person who maintains the doctrine of zoism, the doctrine that life originates from a single vital principle [n -S]\n",
  "ZOISTS": "ZOIST, a person who maintains the doctrine of zoism, the doctrine that life originates from a single vital principle [n]\n",
  "ZOL": "(South African) a cannabis cigarette [n -S]\n",
  "ZOLPIDEM": "a prescription medication used for the short-term treatment of insomnia, as well as some brain disorders [n -S]\n",
  "ZOLPIDEMS": "ZOLPIDEM, a prescription medication used for the short-term treatment of insomnia, as well as some brain disorders [n]\n",
  "ZOLS": "ZOL, (South African) a cannabis cigarette [n]\n",
  "ZOMBI": "in West Indian magic, a reanimated corpse, also ZOMBIE [n -S]\n",
  "ZOMBIE": "in West Indian magic, a reanimated corpse, also ZOMBI [n -S]\n",
  "ZOMBIELIKE": "like a zombie [adj]\n",
  "ZOMBIES": "ZOMBIE, in West Indian magic, a reanimated corpse, also ZOMBI [n]\n",
  "ZOMBIFICATION": "the act of zombifying [n -S]\n",
  "ZOMBIFICATIONS": "ZOMBIFICATION, the act of zombifying [n]\n",
  "ZOMBIFIED": "ZOMBIFY, to make lethargic [v]\n",
  "ZOMBIFIES": "ZOMBIFY, to make lethargic [v]\n",
  "ZOMBIFY": "to make lethargic [v ZOMBIFIED, ZOMBIFYING, ZOMBIFIES]\n",
  "ZOMBIFYING": "ZOMBIFY, to make lethargic [v]\n",
  "ZOMBIISM": "belief in zombies [n -S]\n",
  "ZOMBIISMS": "ZOMBIISM, belief in zombies [n]\n",
  "ZOMBIS": "ZOMBI, in West Indian magic, a reanimated corpse, also ZOMBIE [n]\n",
  "ZOMBOID": "resembling zombies [adj]\n",
  "ZOMBORUK": "(Urdu) a small swivel-gun, esp. one mounted on the back of a camel, also ZAMBOORAK, ZUMBOORUK [n -S]\n",
  "ZOMBORUKS": "ZOMBORUK, (Urdu) a small swivel-gun, esp. one mounted on the back of a camel, also ZAMBOORAK, ZUMBOORUK [n]\n",
  "ZONA": "(Latin) a girdle or belt; a zone [n ZONAE]\n",
  "ZONAE": "ZONA, (Latin) a girdle or belt; a zone [n]\n",
  "ZONAL": "pertaining to a zone [adj ZONALLY]\n",
  "ZONALLY": "ZONAL, pertaining to a zone [adv]\n",
  "ZONARY": "pertaining to a zone [adj]\n",
  "ZONATE": "divided into zones, also ZONATED [adj]\n",
  "ZONATED": "divided into zones, also ZONATE [adj]\n",
  "ZONATION": "arrangement in zones [n -S]\n",
  "ZONATIONS": "ZONATION, arrangement in zones [n]\n",
  "ZONDA": "(Spanish) a dry, hot wind blowing from the Andes across the Argentine pampas, during July and August [n -S]\n",
  "ZONDAS": "ZONDA, (Spanish) a dry, hot wind blowing from the Andes across the Argentine pampas, during July and August [n]\n",
  "ZONE": "to arrange in areas [v ZONED, ZONING, ZONES]\n",
  "ZONED": "ZONE, to arrange in areas [v]\n",
  "ZONELESS": "without zones [adj]\n",
  "ZONER": "one who zones [n -S]\n",
  "ZONERS": "ZONER, one who zones [n]\n",
  "ZONES": "ZONE, to arrange in areas [v]\n",
  "ZONETIME": "standard time used at sea [n -S]\n",
  "ZONETIMES": "ZONETIME, standard time used at sea [n]\n",
  "ZONING": "division into zones [n -S]\n",
  "ZONINGS": "ZONING, division into zones [n]\n",
  "ZONK": "to exhaust [v -ED, -ING, -S]\n",
  "ZONKED": "ZONK, to exhaust [v]\n",
  "ZONKING": "ZONK, to exhaust [v]\n",
  "ZONKS": "ZONK, to exhaust [v]\n",
  "ZONOID": "a finite vector sum of line segments [n -S]\n",
  "ZONOIDS": "ZONOID, a finite vector sum of line segments [n]\n",
  "ZONULA": "(Latin) a small zone, also ZONULE, ZONULET [n ZONULAE or ZONULAS]\n",
  "ZONULAE": "ZONULA, (Latin) a small zone, also ZONULE, ZONULET [n]\n",
  "ZONULAR": "like a zone [adj]\n",
  "ZONULAS": "ZONULA, (Latin) a small zone, also ZONULE, ZONULET [n]\n",
  "ZONULE": "a small zone, also ZONULA, ZONULET [n -S]\n",
  "ZONULES": "ZONULE, a small zone, also ZONULA, ZONULET [n]\n",
  "ZONULET": "a small belt or girdle, also ZONULA, ZONULE [n -S]\n",
  "ZONULETS": "ZONULET, a small belt or girdle, also ZONULA, ZONULE [n]\n",
  "ZONURE": "a kind of tropical lizard [n -S]\n",
  "ZONURES": "ZONURE, a kind of tropical lizard [n]\n",
  "ZOO": "a home for animals in captivity [n -S]\n",
  "ZOOBIOTIC": "parasitic on, or living in association with, an animal [adj]\n",
  "ZOOBLAST": "an animal cell [n -S]\n",
  "ZOOBLASTS": "ZOOBLAST, an animal cell [n]\n",
  "ZOOCEPHALIC": "animal-headed [adj]\n",
  "ZOOCHEMICAL": "relating to zoochemistry, the chemistry of the animal body [adj]\n",
  "ZOOCHEMISTRIES": "ZOOCHEMISTRY, the chemistry of the animal body [n]\n",
  "ZOOCHEMISTRY": "the chemistry of the animal body [n ZOOCHEMISTRIES]\n",
  "ZOOCHORE": "a plant with seeds or spores dispersed by animals [n -S]\n",
  "ZOOCHORES": "ZOOCHORE, a plant with seeds or spores dispersed by animals [n]\n",
  "ZOOCHORIES": "ZOOCHORY, the condition of being dispersed by animals [n]\n",
  "ZOOCHOROUS": "of seeds or spores spread by animals [adj]\n",
  "ZOOCHORY": "the condition of being dispersed by animals [n ZOOCHORIES]\n",
  "ZOOCULTURE": "domestication of animals [n -S]\n",
  "ZOOCULTURES": "ZOOCULTURE, domestication of animals [n]\n",
  "ZOOCYTIA": "ZOOCYTIUM, (Greek) a hollow vessel [n]\n",
  "ZOOCYTIUM": "(Greek) a hollow vessel [n ZOOCYTIA]\n",
  "ZOODENDRIA": "ZOODENDRIUM, the branched stalk connecting the members of the colony in certain colonial Infusoria [n]\n",
  "ZOODENDRIUM": "the branched stalk connecting the members of the colony in certain colonial Infusoria [n ZOODENDRIA]\n",
  "ZOOEA": "(Greek) the larval stage of crabs, also ZOEA, ZOAEA [n ZOOEAS or ZOOEAE]\n",
  "ZOOEAE": "ZOOEA, (Greek) the larval stage of crabs, also ZOEA, ZOAEA [n]\n",
  "ZOOEAL": "of or like a zooea, a larval stage in certain crustaceans [adj]\n",
  "ZOOEAS": "ZOOEA, (Greek) the larval stage of crabs, also ZOEA, ZOAEA [n]\n",
  "ZOOECIA": "ZOOECIUM, (Greek) a sac lived in by an aquatic organism, also ZOECIUM [n]\n",
  "ZOOECIUM": "(Greek) a sac lived in by an aquatic organism, also ZOECIUM [n ZOOECIA]\n",
  "ZOOEY": "like a zoo [adj ZOOIER, ZOOIEST]\n",
  "ZOOGAMETE": "a motile gamete [n -S]\n",
  "ZOOGAMETES": "ZOOGAMETE, a motile gamete [n]\n",
  "ZOOGAMIES": "ZOOGAMY, sexual reproduction of animals [n]\n",
  "ZOOGAMOUS": "of or pertaining to zoogamy, sexual reproduction of animals [adj]\n",
  "ZOOGAMY": "sexual reproduction of animals [n ZOOGAMIES]\n",
  "ZOOGENIC": "produced from animals [adj]\n",
  "ZOOGENIES": "ZOOGENY, the doctrine of the beginning of beings, also ZOOGONY [n]\n",
  "ZOOGENOUS": "originating in animals [adj]\n",
  "ZOOGENY": "the doctrine of the beginning of beings, also ZOOGONY [n ZOOGENIES]\n",
  "ZOOGEOGRAPHER": "a student of zoogeography [n -S]\n",
  "ZOOGEOGRAPHERS": "ZOOGEOGRAPHER, a student of zoogeography [n]\n",
  "ZOOGEOGRAPHIC": "relating to zoogeography, also ZOOGEOGRAPHICAL [adj]\n",
  "ZOOGEOGRAPHICAL": "relating to zoogeography, also ZOOGEOGRAPHIC [adj]\n",
  "ZOOGEOGRAPHIES": "ZOOGEOGRAPHY, the study of the geographic distribution of animals [n]\n",
  "ZOOGEOGRAPHY": "the study of the geographic distribution of animals [n ZOOGEOGRAPHIES]\n",
  "ZOOGLEA": "(Greek) a jellylike mass of bacteria, also ZOOGLOEA [n ZOOGLEAS or ZOOGLEAE]\n",
  "ZOOGLEAE": "ZOOGLEA, (Greek) a jellylike mass of bacteria, also ZOOGLOEA [n]\n",
  "ZOOGLEAL": "of or like a zooglea, a mucilaginous mass of bacteria embedded in slimy material derived from swollen cell walls [adj]\n",
  "ZOOGLEAS": "ZOOGLEA, (Greek) a jellylike mass of bacteria, also ZOOGLOEA [n]\n",
  "ZOOGLOEA": "(Greek) a jellylike mass of bacteria, also ZOOGLEA [n ZOOGLOEAS or ZOOGLOEAE]\n",
  "ZOOGLOEAE": "ZOOGLOEA, (Greek) a jellylike mass of bacteria, also ZOOGLEA [n]\n",
  "ZOOGLOEAL": "of or like a zoogloea, a mucilaginous mass of bacteria, also ZOOGLOEIC, ZOOGLOEOID [adj]\n",
  "ZOOGLOEAS": "ZOOGLOEA, (Greek) a jellylike mass of bacteria, also ZOOGLEA [n]\n",
  "ZOOGLOEIC": "of or like a zoogloea, a mucilaginous mass of bacteria, also ZOOGLOEAL, ZOOGLOEOID [adj]\n",
  "ZOOGLOEOID": "of or like a zoogloea, a mucilaginous mass of bacteria, also ZOOGLOEAL, ZOOGLOEIC [adj]\n",
  "ZOOGONIDIA": "ZOOGONIDIUM, a swarm-spore [n]\n",
  "ZOOGONIDIUM": "a swarm-spore [n ZOOGONIDIA]\n",
  "ZOOGONIES": "ZOOGONY, the doctrine of the beginning of beings, also ZOOGENY [n]\n",
  "ZOOGONOUS": "giving birth to live offspring [adj]\n",
  "ZOOGONY": "the doctrine of the beginning of beings, also ZOOGENY [n ZOOGONIES]\n",
  "ZOOGRAFT": "animal tissue grafted onto a human [n -S]\n",
  "ZOOGRAFTING": "the grafting of tissue from an animal to a human [n -S]\n",
  "ZOOGRAFTINGS": "ZOOGRAFTING, the grafting of tissue from an animal to a human [n]\n",
  "ZOOGRAFTS": "ZOOGRAFT, animal tissue grafted onto a human [n]\n",
  "ZOOGRAPHER": "one who describes animals, their forms and habits, also ZOOGRAPHIST [n -S]\n",
  "ZOOGRAPHERS": "ZOOGRAPHER, one who describes animals, their forms and habits, also ZOOGRAPHIST [n]\n",
  "ZOOGRAPHIC": "relating to zoography, the painting or description of animals, also ZOOGRAPHICAL [adj]\n",
  "ZOOGRAPHICAL": "relating to zoography, the painting or description of animals, also ZOOGRAPHIC [adj]\n",
  "ZOOGRAPHIES": "ZOOGRAPHY, the painting or description of animals [n]\n",
  "ZOOGRAPHIST": "one who describes animals, their forms and habits, also ZOOGRAPHER [n -S]\n",
  "ZOOGRAPHISTS": "ZOOGRAPHIST, one who describes animals, their forms and habits, also ZOOGRAPHER [n]\n",
  "ZOOGRAPHY": "the painting or description of animals [n ZOOGRAPHIES]\n",
  "ZOOID": "an organic cell capable of independent movement [n -S]\n",
  "ZOOIDAL": "of or pertaining to a zooid, an asexually produced organism resembling an animal [adj]\n",
  "ZOOIDS": "ZOOID, an organic cell capable of independent movement [n]\n",
  "ZOOIER": "ZOOEY, like a zoo [adj]\n",
  "ZOOIEST": "ZOOEY, like a zoo [adj]\n",
  "ZOOKEEPER": "one who looks after animals in a zoo [n -S]\n",
  "ZOOKEEPERS": "ZOOKEEPER, one who looks after animals in a zoo [n]\n",
  "ZOOKS": "(obsolete) a mild oath, also GADZOOKS, ODZOOKS [interj]\n",
  "ZOOLATER": "one who worships animals [n -S]\n",
  "ZOOLATERS": "ZOOLATER, one who worships animals [n]\n",
  "ZOOLATRIA": "worship of animals, also ZOOLATRY [n -S]\n",
  "ZOOLATRIAS": "ZOOLATRIA, worship of animals, also ZOOLATRY [n]\n",
  "ZOOLATRIES": "ZOOLATRY, the worship of animals [n]\n",
  "ZOOLATROUS": "relating to zoolatry, the worship of animals [adj]\n",
  "ZOOLATRY": "the worship of animals [n ZOOLATRIES]\n",
  "ZOOLITE": "a fossil animal, also ZOOLITH [n -S]\n",
  "ZOOLITES": "ZOOLITE, a fossil animal, also ZOOLITH [n]\n",
  "ZOOLITH": "a fossil animal, also ZOOLITE [n -S]\n",
  "ZOOLITHIC": "of or like a zoolite, a fossil animal [adj]\n",
  "ZOOLITHS": "ZOOLITH, a fossil animal, also ZOOLITE [n]\n",
  "ZOOLITIC": "of or like a zoolite, a fossil animal [adj]\n",
  "ZOOLOGIC": "relating to zoology, also ZOOLOGICAL [adj ZOOLOGICALLY]\n",
  "ZOOLOGICAL": "relating to zoology, also ZOOLOGIC [adj ZOOLOGICALLY]\n",
  "ZOOLOGICALLY": "ZOOLOGICAL, relating to zoology, also ZOOLOGIC [adv]\n",
  "ZOOLOGIES": "ZOOLOGY, the science of animals [n]\n",
  "ZOOLOGIST": "one who studies zoology [n -S]\n",
  "ZOOLOGISTS": "ZOOLOGIST, one who studies zoology [n]\n",
  "ZOOLOGY": "the science of animals [n ZOOLOGIES]\n",
  "ZOOM": "to move with a buzzing sound [v -ED, -ING, -S]\n",
  "ZOOMABLE": "capable of being viewed at various levels of detail and magnification [adj]\n",
  "ZOOMAGNETIC": "relating to zoomagnetism, animal magnetism [adj]\n",
  "ZOOMAGNETISM": "animal magnetism [n -S]\n",
  "ZOOMAGNETISMS": "ZOOMAGNETISM, animal magnetism [n]\n",
  "ZOOMANCIES": "ZOOMANCY, (Greek) divination by observing animals [n]\n",
  "ZOOMANCY": "(Greek) divination by observing animals [n ZOOMANCIES]\n",
  "ZOOMANIA": "excessive interest in animals [n -S]\n",
  "ZOOMANIAS": "ZOOMANIA, excessive interest in animals [n]\n",
  "ZOOMANTIC": "relating to zoomancy, divination by observing animals [adj]\n",
  "ZOOMED": "ZOOM, to move with a buzzing sound [v]\n",
  "ZOOMETRIC": "relating to zoometry, the measurement of animals, also ZOOMETRICAL [adj]\n",
  "ZOOMETRICAL": "relating to zoometry, the measurement of animals, also ZOOMETRIC [adj]\n",
  "ZOOMETRIES": "ZOOMETRY, (Greek) comparing measurements of animals [n]\n",
  "ZOOMETRY": "(Greek) comparing measurements of animals [n ZOOMETRIES]\n",
  "ZOOMING": "ZOOM, to move with a buzzing sound [v]\n",
  "ZOOMORPH": "(Greek) a God symbol with an animal form [n -S]\n",
  "ZOOMORPHIC": "having the form of an animal; of, relating to, or being a deity conceived of in animal form or with animal attributes [adj]\n",
  "ZOOMORPHIES": "ZOOMORPHY, the conception of a god or man in animal form, also ZOOMORPHISM [n]\n",
  "ZOOMORPHISM": "the conception of a god or man in animal form, also ZOOMORPHY [n -S]\n",
  "ZOOMORPHISMS": "ZOOMORPHISM, the conception of a god or man in animal form, also ZOOMORPHY [n]\n",
  "ZOOMORPHS": "ZOOMORPH, (Greek) a God symbol with an animal form [n]\n",
  "ZOOMORPHY": "the conception of a god or man in animal form, also ZOOMORPHISM [n ZOOMORPHIES]\n",
  "ZOOMS": "ZOOM, to move with a buzzing sound [v]\n",
  "ZOON": "the whole product of one fertilized egg [n ZOONS or ZOA] / to zoom [v -ED, -ING, -S]\n",
  "ZOONAL": "like a zoon, an animal which is the sole product of a single egg, as opposed to zooid [adj]\n",
  "ZOONED": "ZOON, to zoom [v]\n",
  "ZOONIC": "relating to animals [adj]\n",
  "ZOONING": "ZOON, to zoom [v]\n",
  "ZOONITE": "one of the segments of the body of an articulate animal [n -S]\n",
  "ZOONITES": "ZOONITE, one of the segments of the body of an articulate animal [n]\n",
  "ZOONITIC": "like a zoonite, one of the segments of the body of an articulate animal [adj]\n",
  "ZOONOMIA": "animal physiology, also ZOONOMY [n -S]\n",
  "ZOONOMIAS": "ZOONOMIA, animal physiology, also ZOONOMY [n]\n",
  "ZOONOMIC": "relating to zoonomia, animal physiology [adj]\n",
  "ZOONOMIES": "ZOONOMY, animal physiology, also ZOONOMIA [n]\n",
  "ZOONOMIST": "an animal physiologist [n -S]\n",
  "ZOONOMISTS": "ZOONOMIST, an animal physiologist [n]\n",
  "ZOONOMY": "animal physiology, also ZOONOMIA [n ZOONOMIES]\n",
  "ZOONOSES": "ZOONOSIS, an animal disease which is infectious to humans [n]\n",
  "ZOONOSIS": "an animal disease which is infectious to humans [n ZOONOSES]\n",
  "ZOONOTIC": "of or like zoonosis, a disease of animals such as rabies that can be transmitted to humans [adj]\n",
  "ZOONS": "ZOON, to zoom [v]\n",
  "ZOOPATHIES": "ZOOPATHY, animal pathology [n]\n",
  "ZOOPATHOLOGIES": "ZOOPATHOLOGY, the study of animal diseases [n]\n",
  "ZOOPATHOLOGY": "the study of animal diseases [n ZOOPATHOLOGIES]\n",
  "ZOOPATHY": "animal pathology [n ZOOPATHIES]\n",
  "ZOOPERAL": "relating to zoopery, experimentation on animals [adj]\n",
  "ZOOPERIES": "ZOOPERY, experimentation on animals [n]\n",
  "ZOOPERIST": "one who experiments on lower animals [n -S]\n",
  "ZOOPERISTS": "ZOOPERIST, one who experiments on lower animals [n]\n",
  "ZOOPERY": "experimentation on animals [n ZOOPERIES]\n",
  "ZOOPHAGAN": "an animal that feeds on animal food [n -S]\n",
  "ZOOPHAGANS": "ZOOPHAGAN, an animal that feeds on animal food [n]\n",
  "ZOOPHAGIES": "ZOOPHAGY, the practice of feeding on animals [n]\n",
  "ZOOPHAGOUS": "feeding on animals [adj]\n",
  "ZOOPHAGY": "the practice of feeding on animals [n ZOOPHAGIES]\n",
  "ZOOPHILE": "a lover of animals [n -S]\n",
  "ZOOPHILES": "ZOOPHILE, a lover of animals [n]\n",
  "ZOOPHILIA": "the love of animals; erotic fondness for animals, also ZOOPHILISM, ZOOPHILY [n -S]\n",
  "ZOOPHILIAS": "ZOOPHILIA, the love of animals; erotic fondness for animals, also ZOOPHILISM, ZOOPHILY [n]\n",
  "ZOOPHILIC": "of or like zoophilia, the erotic love of animals [adj]\n",
  "ZOOPHILIES": "ZOOPHILY, the love of animals; erotic fondness of animals, also ZOOPHILIA, ZOOPHILISM [n]\n",
  "ZOOPHILISM": "the love of animals; erotic fondness for animals, also ZOOPHILIA, ZOOPHILY [n -S]\n",
  "ZOOPHILISMS": "ZOOPHILISM, the love of animals; erotic fondness for animals, also ZOOPHILIA, ZOOPHILY [n]\n",
  "ZOOPHILIST": "a lover of animals [n -S]\n",
  "ZOOPHILISTS": "ZOOPHILIST, a lover of animals [n]\n",
  "ZOOPHILOUS": "loving animals [adj]\n",
  "ZOOPHILY": "the love of animals; erotic fondness of animals, also ZOOPHILIA, ZOOPHILISM [n ZOOPHILIES]\n",
  "ZOOPHOBE": "one who fears or hates animals [n -S]\n",
  "ZOOPHOBES": "ZOOPHOBE, one who fears or hates animals [n]\n",
  "ZOOPHOBIA": "fear of animals [n -S]\n",
  "ZOOPHOBIAS": "ZOOPHOBIA, fear of animals [n]\n",
  "ZOOPHOBOUS": "having an abnormal fear of animals [adj]\n",
  "ZOOPHORI": "ZOOPHORUS, (Greek) a continuous frieze in relief, with people and animals [n]\n",
  "ZOOPHORIC": "bearing or supporting the figure of an animal; as, a zoophoric column [adj]\n",
  "ZOOPHORUS": "(Greek) a continuous frieze in relief, with people and animals [n ZOOPHORI]\n",
  "ZOOPHYSIOLOGIES": "ZOOPHYSIOLOGY, the study of animal physiology [n]\n",
  "ZOOPHYSIOLOGIST": "a student of animal physiology [n]\n",
  "ZOOPHYSIOLOGY": "the study of animal physiology [n ZOOPHYSIOLOGIES]\n",
  "ZOOPHYTE": "an animal (such as sponge, coral, sea anemone, etc.) resembling a plant [n -S]\n",
  "ZOOPHYTES": "ZOOPHYTE, an animal (such as sponge, coral, sea anemone, etc.) resembling a plant [n]\n",
  "ZOOPHYTIC": "relating to a zoophyte, a plantlike animal, as coral, sea anemone, etc., also ZOOPHYTICAL [adj]\n",
  "ZOOPHYTICAL": "relating to a zoophyte, a plantlike animal, as coral, sea anemone, etc., also ZOOPHYTIC [adj]\n",
  "ZOOPHYTOID": "pertaining to, or resembling, a zoophyte [adj]\n",
  "ZOOPHYTOLOGICAL": "relating to zoophytology [adj]\n",
  "ZOOPHYTOLOGIES": "ZOOPHYTOLOGY, the study of zoophytes, plantlike animals [n]\n",
  "ZOOPHYTOLOGIST": "one who studies zoophytes [n -S]\n",
  "ZOOPHYTOLOGISTS": "ZOOPHYTOLOGIST, one who studies zoophytes [n]\n",
  "ZOOPHYTOLOGY": "the study of zoophytes, plantlike animals [n ZOOPHYTOLOGIES]\n",
  "ZOOPLANKTER": "a single zooplankton [n -S]\n",
  "ZOOPLANKTERS": "ZOOPLANKTER, a single zooplankton [n]\n",
  "ZOOPLANKTON": "tiny, free-floating organisms in aquatic systems [n -S]\n",
  "ZOOPLANKTONIC": "relating to zooplankton [adj]\n",
  "ZOOPLANKTONS": "ZOOPLANKTON, tiny, free-floating organisms in aquatic systems [n]\n",
  "ZOOPLASTIC": "relating to zooplasty, the surgical transfer of tissue from an animal to man [adj]\n",
  "ZOOPLASTIES": "ZOOPLASTY, the surgical transfer of tissue from an animal to man [n]\n",
  "ZOOPLASTY": "the surgical transfer of tissue from an animal to man [n ZOOPLASTIES]\n",
  "ZOOPSYCHOLOGIES": "ZOOPSYCHOLOGY, the psychology of the lower animals [n]\n",
  "ZOOPSYCHOLOGY": "the psychology of the lower animals [n ZOOPSYCHOLOGIES]\n",
  "ZOOS": "ZOO, a home for animals in captivity [n]\n",
  "ZOOSCOPIC": "relating to zooscopy, a kind of hallucination in which imaginary animal forms are seen [adj]\n",
  "ZOOSCOPIES": "ZOOSCOPY, a delusion in which you see imaginary animals [n]\n",
  "ZOOSCOPY": "a delusion in which you see imaginary animals [n ZOOSCOPIES]\n",
  "ZOOSPERM": "one of the spermatic particles; a spermatozoid, also ZOOSPERMIUM [n -S]\n",
  "ZOOSPERMATIC": "of or like a zoosperm [adj]\n",
  "ZOOSPERMIA": "ZOOSPERMIUM, one of the spermatic particles; a spermatozoid, also ZOOSPERM [n]\n",
  "ZOOSPERMIUM": "one of the spermatic particles; a spermatozoid, also ZOOSPERM [n ZOOSPERMIA]\n",
  "ZOOSPERMS": "ZOOSPERM, one of the spermatic particles; a spermatozoid, also ZOOSPERMIUM [n]\n",
  "ZOOSPORANGIA": "ZOOSPORANGIUM, a spore case or sporangium bearing zoospores [n]\n",
  "ZOOSPORANGIAL": "relating to zoosporangia [adj]\n",
  "ZOOSPORANGIUM": "a spore case or sporangium bearing zoospores [n ZOOSPORANGIA]\n",
  "ZOOSPORE": "a motile flagellated spore, occurring in certain algae, fungi, and protozoans [n -S]\n",
  "ZOOSPORES": "ZOOSPORE, a motile flagellated spore, occurring in certain algae, fungi, and protozoans [n]\n",
  "ZOOSPORIC": "of or pertaining to zoospores [adj]\n",
  "ZOOSPOROUS": "of or like a zoospore, a swarm-spore [adj]\n",
  "ZOOSTEROL": "a sterol, such as cholesterol, of animal origin [n -S]\n",
  "ZOOSTEROLS": "ZOOSTEROL, a sterol, such as cholesterol, of animal origin [n]\n",
  "ZOOT": "as in zoot suit, a man's suit consisting of baggy trousers with tapered bottoms and a long jacket with wide padded shoulders [adj]\n",
  "ZOOTAXIES": "ZOOTAXY, systematic zoology [n]\n",
  "ZOOTAXY": "systematic zoology [n ZOOTAXIES]\n",
  "ZOOTECHNICAL": "of or relating to the technology of animal husbandry [adj]\n",
  "ZOOTECHNICS": "the science of breeding animals [n]\n",
  "ZOOTECHNIES": "ZOOTECHNY, the breeding and taming of animals [n]\n",
  "ZOOTECHNY": "the breeding and taming of animals [n ZOOTECHNIES]\n",
  "ZOOTHAPSES": "ZOOTHAPSIS, premature burial [n]\n",
  "ZOOTHAPSIS": "premature burial [n ZOOTHAPSES]\n",
  "ZOOTHECIA": "ZOOTHECIUM, the tubular sheath of certain infusorians [n]\n",
  "ZOOTHECIAL": "of or like a zoothecium, the tubular sheath of certain infusorians [adj]\n",
  "ZOOTHECIUM": "the tubular sheath of certain infusorians [n ZOOTHECIA]\n",
  "ZOOTHEISM": "the attribution of divine qualities to animals [n -S]\n",
  "ZOOTHEISMS": "ZOOTHEISM, the attribution of divine qualities to animals [n]\n",
  "ZOOTHEISTIC": "relating to zootheism, the attribution of divine qualities to animals [adj]\n",
  "ZOOTHERAPIES": "ZOOTHERAPY, veterinary therapeutics [n]\n",
  "ZOOTHERAPY": "veterinary therapeutics [n ZOOTHERAPIES]\n",
  "ZOOTHOME": "a group of zooids, such as a mass of coral [n -S]\n",
  "ZOOTHOMES": "ZOOTHOME, a group of zooids, such as a mass of coral [n]\n",
  "ZOOTIER": "ZOOTY, flashy in manner or style [adj]\n",
  "ZOOTIEST": "ZOOTY, flashy in manner or style [adj]\n",
  "ZOOTOMIC": "relating to zootomy, the dissection of animals, also ZOOTOMICAL [adj ZOOTOMICALLY]\n",
  "ZOOTOMICAL": "relating to zootomy, the dissection of animals, also ZOOTOMIC [adj ZOOTOMICALLY]\n",
  "ZOOTOMICALLY": "ZOOTOMICAL, relating to zootomy, the dissection of animals, also ZOOTOMIC [adv]\n",
  "ZOOTOMIES": "ZOOTOMY, the dissection of animals [n]\n",
  "ZOOTOMIST": "one who dissects animals, or is skilled in zootomy [n -S]\n",
  "ZOOTOMISTS": "ZOOTOMIST, one who dissects animals, or is skilled in zootomy [n]\n",
  "ZOOTOMY": "the dissection of animals [n ZOOTOMIES]\n",
  "ZOOTOXIC": "relating to a zootoxin, a poison derived from an animal [adj]\n",
  "ZOOTOXIN": "a toxin produced by an animal [n -S]\n",
  "ZOOTOXINS": "ZOOTOXIN, a toxin produced by an animal [n]\n",
  "ZOOTROPE": "(Greek) a slotted rotating cylinder producing primitive animation, also ZOETROPE [n -S]\n",
  "ZOOTROPES": "ZOOTROPE, (Greek) a slotted rotating cylinder producing primitive animation, also ZOETROPE [n]\n",
  "ZOOTROPHIC": "of or pertaining to the nourishment of animals [adj]\n",
  "ZOOTROPHIES": "ZOOTROPHY, the feeding of animals [n]\n",
  "ZOOTROPHY": "the feeding of animals [n ZOOTROPHIES]\n",
  "ZOOTSUITER": "someone who wears a zoot suit [n -S]\n",
  "ZOOTSUITERS": "ZOOTSUITER, someone who wears a zoot suit [n]\n",
  "ZOOTY": "flashy in manner or style [adj ZOOTIER, ZOOTIEST]\n",
  "ZOOTYPE": "an animal serving as a type [n -S]\n",
  "ZOOTYPES": "ZOOTYPE, an animal serving as a type [n]\n",
  "ZOOTYPIC": "of or like a zootype, an animal serving as a type [adj]\n",
  "ZOOXANTHELLA": "a symbiotic dinoflagellate of the genus Symbiodinium that lives in the tissues of a number of marine invertebrates and protists [n ZOOXANTHELLAE]\n",
  "ZOOXANTHELLAE": "ZOOXANTHELLA, a symbiotic dinoflagellate of the genus Symbiodinium that lives in the tissues of a number of marine invertebrates and protists [n]\n",
  "ZOOZOO": "the wood-pigeon [n -S]\n",
  "ZOOZOOS": "ZOOZOO, the wood-pigeon [n]\n",
  "ZOPILOTE": "(Nahuatl) the urubu or American black vulture [n -S]\n",
  "ZOPILOTES": "ZOPILOTE, (Nahuatl) the urubu or American black vulture [n]\n",
  "ZOPPA": "(Italian) having a syncopated or temporarily changing accent of a beat, also ZOPPO [adj]\n",
  "ZOPPO": "(Italian) having a syncopated or temporarily changing accent of a beat, also ZOPPA [adj]\n",
  "ZORBING": "a recreational activity, rolling downhill inside a large ball [n -S]\n",
  "ZORBINGS": "ZORBING, a recreational activity, rolling downhill inside a large ball [n]\n",
  "ZORBONAUT": "one who engages in zorbing [n -S]\n",
  "ZORBONAUTS": "ZORBONAUT, one who engages in zorbing [n]\n",
  "ZORGITE": "a metallic copper-lead selenide [n -S]\n",
  "ZORGITES": "ZORGITE, a metallic copper-lead selenide [n]\n",
  "ZORI": "(Japanese) a Japanese sandal consisting of a flat sole with a thong between the toes [n -S]\n",
  "ZORIL": "(Spanish) a small African mammal, also ZORILLA, ZORILLE, ZORILLO [n -S]\n",
  "ZORILLA": "(Spanish) a small African mammal, also ZORIL, ZORILLE, ZORILLO [n -S]\n",
  "ZORILLAS": "ZORILLA, (Spanish) a small African mammal, also ZORIL, ZORILLE, ZORILLO [n]\n",
  "ZORILLE": "(Spanish) a small African mammal, also ZORIL, ZORILLA, ZORILLO [n -S]\n",
  "ZORILLES": "ZORILLE, (Spanish) a small African mammal, also ZORIL, ZORILLA, ZORILLO [n]\n",
  "ZORILLO": "(Spanish) a small African mammal, also ZORIL, ZORILLA, ZORILLE [n -S]\n",
  "ZORILLOS": "ZORILLO, (Spanish) a small African mammal, also ZORIL, ZORILLA, ZORILLE [n]\n",
  "ZORILS": "ZORIL, (Spanish) a small African mammal, also ZORILLA, ZORILLE, ZORILLO [n]\n",
  "ZORINO": "(Spanish) a euphemism for skunk fur as used to make garments [n -S]\n",
  "ZORINOS": "ZORINO, (Spanish) a euphemism for skunk fur as used to make garments [n]\n",
  "ZORIS": "ZORI, (Japanese) a Japanese sandal consisting of a flat sole with a thong between the toes [n]\n",
  "ZORRO": "(Spanish) a kind of South American fox [n -S]\n",
  "ZORROS": "ZORRO, (Spanish) a kind of South American fox [n]\n",
  "ZOS": "ZO, (Tibetan) a cross between a yak and a cow, also DSO, DZHO, DZO, ZHO [n]\n",
  "ZOSTER": "(Greek) an ancient Greek waistbelt for men [n -S]\n",
  "ZOSTERS": "ZOSTER, (Greek) an ancient Greek waistbelt for men [n]\n",
  "ZOUAVE": "(French) a French infantry man who wears Arab dress [n -S]\n",
  "ZOUAVES": "ZOUAVE, (French) a French infantry man who wears Arab dress [n]\n",
  "ZOUK": "a style of Caribbean dance music [n -S]\n",
  "ZOUKS": "ZOUK, a style of Caribbean dance music [n]\n",
  "ZOUNDS": "(archaic) a mild oath (God's wounds) [interj]\n",
  "ZOWEE": "an interjection of surprise, also ZOWIE [interj]\n",
  "ZOWIE": "an interjection of surprise, also ZOWEE [interj]\n",
  "ZOYSIA": "a kind of perennial grass [n -S]\n",
  "ZOYSIAS": "ZOYSIA, a kind of perennial grass [n]\n",
  "ZUCCHETTI": "ZUCCHETTO, (Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCHETTA, ZUCHETTO [n]\n",
  "ZUCCHETTO": "(Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCHETTA, ZUCHETTO [n ZUCCHETTOS or ZUCCHETTI]\n",
  "ZUCCHETTOS": "ZUCCHETTO, (Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCHETTA, ZUCHETTO [n]\n",
  "ZUCCHINI": "(Italian) a courgette [n -S]\n",
  "ZUCCHINIS": "ZUCCHINI, (Italian) a courgette [n]\n",
  "ZUCHETTA": "(Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCCHETTO, ZUCHETTO [n -S]\n",
  "ZUCHETTAS": "ZUCHETTA, (Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCCHETTO, ZUCHETTO [n]\n",
  "ZUCHETTO": "(Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCCHETTO, ZUCHETTA [n -S]\n",
  "ZUCHETTOS": "ZUCHETTO, (Italian) a round skullcap worn by Catholic clergy to indicate rank, also ZUCCHETTO, ZUCHETTA [n]\n",
  "ZUFFOLI": "ZUFFOLO, (Italian) a small flute to train birds, also ZUFOLO [n]\n",
  "ZUFFOLO": "(Italian) a small flute to train birds, also ZUFOLO [n ZUFFOLI]\n",
  "ZUFOLI": "ZUFOLO, (Italian) a small flute used to train songbirds, also ZUFFOLO [n]\n",
  "ZUFOLO": "(Italian) a small flute used to train songbirds, also ZUFFOLO [n ZUFOLI or ZUFOLOS]\n",
  "ZUFOLOS": "ZUFOLO, (Italian) a small flute used to train songbirds, also ZUFFOLO [n]\n",
  "ZUGZWANG": "(German) a situation in a chess game in which a player is forced to make an undesirable or disadvantageous move [n -S] / to place in zugzwang [v -ED, -ING, -S]\n",
  "ZUGZWANGED": "ZUGZWANG, to place in zugzwang [v]\n",
  "ZUGZWANGING": "ZUGZWANG, to place in zugzwang [v]\n",
  "ZUGZWANGS": "ZUGZWANG, to place in zugzwang [v]\n",
  "ZULU": "a type of two-masted fishing vessel formerly used in Scotland [n -S]\n",
  "ZULUS": "ZULU, a type of two-masted fishing vessel formerly used in Scotland [n]\n",
  "ZUMBOORUK": "(Urdu) a small swivel-gun, esp. one mounted on the back of a camel, also ZAMBOORAK, ZOMBORUK [n -S]\n",
  "ZUMBOORUKS": "ZUMBOORUK, (Urdu) a small swivel-gun, esp. one mounted on the back of a camel, also ZAMBOORAK, ZOMBORUK [n]\n",
  "ZUPA": "(Serbo-Croat) in early Serbia, a confederation of villages, governed by a zupan [n -S]\n",
  "ZUPAN": "(Serbo-Croat) the body governing a zupa, a federation of Serbian villages [n -S]\n",
  "ZUPANS": "ZUPAN, (Serbo-Croat) the body governing a zupa, a federation of Serbian villages [n]\n",
  "ZUPAS": "ZUPA, (Serbo-Croat) in early Serbia, a confederation of villages, governed by a zupan [n]\n",
  "ZUPPA": "(Italian) an Italian fish soup [n -S]\n",
  "ZUPPAS": "ZUPPA, (Italian) an Italian fish soup [n]\n",
  "ZURF": "(Arabic) an ornamental metal holder for a handleless coffee cup, also ZARF [n -S]\n",
  "ZURFS": "ZURF, (Arabic) an ornamental metal holder for a handleless coffee cup, also ZARF [n]\n",
  "ZUZ": "a silver coin of ancient Palestine [n ZUZIM or ZUZZIM]\n",
  "ZUZIM": "ZUZ, a silver coin of ancient Palestine [n]\n",
  "ZUZZIM": "ZUZ, a silver coin of ancient Palestine [n]\n",
  "ZWANZIGER": "(German) an old Austrian silver coin, equivalent to twenty kreutzers [n -S]\n",
  "ZWANZIGERS": "ZWANZIGER, (German) an old Austrian silver coin, equivalent to twenty kreutzers [n]\n",
  "ZWIEBACK": "(German) a usually sweetened bread that is baked and then sliced and toasted until dry and crisp [n -S]\n",
  "ZWIEBACKS": "ZWIEBACK, (German) a usually sweetened bread that is baked and then sliced and toasted until dry and crisp [n]\n",
  "ZWISCHENZUG": "(German) in chess, a temporizing move (i.e. a delay in capturing, usually via a check) [n -S]\n",
  "ZWISCHENZUGS": "ZWISCHENZUG, (German) in chess, a temporizing move (i.e. a delay in capturing, usually via a check) [n]\n",
  "ZWITTERION": "an ion carrying both a positive and negative charge [n -S]\n",
  "ZWITTERIONIC": "of or like a zwitterion, an ion carrying both a positive and negative charge [adj]\n",
  "ZWITTERIONS": "ZWITTERION, an ion carrying both a positive and negative charge [n]\n",
  "ZYDECO": "(Creole) a popular music of southern Louisiana that combines tunes of French origin with elements of Caribbean music and the blues [n -S]\n",
  "ZYDECOS": "ZYDECO, (Creole) a popular music of southern Louisiana that combines tunes of French origin with elements of Caribbean music and the blues [n]\n",
  "ZYGA": "ZYGON, (Greek) an H-shaped fissure of the brain [n]\n",
  "ZYGAENID": "relating to the moth family Zygaenidae, that includes burnet moths, also ZYGAENOID [adj]\n",
  "ZYGAENOID": "relating to the moth family Zygaenidae, that includes burnet moths, also ZYGAENID [adj]\n",
  "ZYGAL": "formed like the letter H; of or relating to a yoke or union [adj]\n",
  "ZYGANTRA": "ZYGANTRUM, (Greek) extra vertebral articulation in snakes and some lizards [n]\n",
  "ZYGANTRUM": "(Greek) extra vertebral articulation in snakes and some lizards [n ZYGANTRUMS or ZYGANTRA]\n",
  "ZYGANTRUMS": "ZYGANTRUM, (Greek) extra vertebral articulation in snakes and some lizards [n]\n",
  "ZYGAPOPHYSEAL": "relating to the zygapophysis, also ZYGAPOPHYSIAL [adj]\n",
  "ZYGAPOPHYSES": "ZYGAPOPHYSIS, any of the yoke-pieces or articulations of the vertebrae [n]\n",
  "ZYGAPOPHYSIAL": "relating to the zygapophysis, also ZYGAPOPHYSEAL [adj]\n",
  "ZYGAPOPHYSIS": "any of the yoke-pieces or articulations of the vertebrae [n ZYGAPOPHYSES]\n",
  "ZYGOBRANCH": "a type of gastropod having paired, symmetrically placed gills, also ZYGOBRANCHIATE [n -S]\n",
  "ZYGOBRANCHIATE": "a type of gastropod having paired, symmetrically placed gills, also ZYGOBRANCH [n -S]\n",
  "ZYGOBRANCHIATES": "ZYGOBRANCHIATE, a type of gastropod having paired, symmetrically placed gills, also ZYGOBRANCH [n]\n",
  "ZYGOBRANCHS": "ZYGOBRANCH, a type of gastropod having paired, symmetrically placed gills, also ZYGOBRANCHIATE [n]\n",
  "ZYGOCACTI": "ZYGOCACTUS, a genus of Brazilian cactus, aka the Christmas cactus [n]\n",
  "ZYGOCACTUS": "a genus of Brazilian cactus, aka the Christmas cactus [n ZYGOCACTI or ZYGOCACTUSES]\n",
  "ZYGOCACTUSES": "ZYGOCACTUS, a genus of Brazilian cactus, aka the Christmas cactus [n]\n",
  "ZYGOCARDIAC": "denoting certain paired lateral ossicles in the gastric mill of Crustacea [adj]\n",
  "ZYGODACTYL": "having two toes pointing forward and two backwards [adj] / a bird, such as a woodpecker, having such toes [n -S]\n",
  "ZYGODACTYLIC": "having two toes in front and two behind [adj]\n",
  "ZYGODACTYLISM": "the state of being zygodactylic, having two toes in front and two behind [n -S]\n",
  "ZYGODACTYLISMS": "ZYGODACTYLISM, the state of being zygodactylic, having two toes in front and two behind [n]\n",
  "ZYGODACTYLOUS": "of or like a zygodactyl, having two toes pointing forward and two backwards [adj]\n",
  "ZYGODACTYLS": "ZYGODACTYL, a bird, such as a woodpecker, having such toes [n]\n",
  "ZYGODONT": "relating to molar teeth whose cusps are paired [adj]\n",
  "ZYGOID": "pertaining to a zygote [adj]\n",
  "ZYGOMA": "(Greek) the cheekbone [n ZYGOMAS or ZYGOMATA]\n",
  "ZYGOMAS": "ZYGOMA, (Greek) the cheekbone [n]\n",
  "ZYGOMATA": "ZYGOMA, (Greek) the cheekbone [n]\n",
  "ZYGOMATIC": "relating to the zygoma, the cheek bone [adj] / the cheek bone [n -S]\n",
  "ZYGOMATICS": "ZYGOMATIC, the cheek bone [n]\n",
  "ZYGOMORPHIC": "bilaterally symmetrical, also ZYGOMORPHOUS [adj]\n",
  "ZYGOMORPHIES": "ZYGOMORPHY, the state of having flowers symmetrical about one axis [n]\n",
  "ZYGOMORPHISM": "the state of being zygomorphic, bilaterally symmetrical [n -S]\n",
  "ZYGOMORPHISMS": "ZYGOMORPHISM, the state of being zygomorphic, bilaterally symmetrical [n]\n",
  "ZYGOMORPHOUS": "bilaterally symmetrical, also ZYGOMORPHIC [adj]\n",
  "ZYGOMORPHY": "the state of having flowers symmetrical about one axis [n ZYGOMORPHIES]\n",
  "ZYGOMYCETE": "one of a group of fungi marked by the production of zygospores [n -S]\n",
  "ZYGOMYCETES": "ZYGOMYCETE, one of a group of fungi marked by the production of zygospores [n]\n",
  "ZYGOMYCETOUS": "of or like a zygomycete, one of a group of fungi marked by the production of zygospores [adj]\n",
  "ZYGON": "(Greek) an H-shaped fissure of the brain [n ZYGA]\n",
  "ZYGOPHYLLACEOUS": "belonging to the Zygophyllaceae, the bean caper family [adj]\n",
  "ZYGOPHYTE": "a plant that reproduces by the union of two similar cells [n -S]\n",
  "ZYGOPHYTES": "ZYGOPHYTE, a plant that reproduces by the union of two similar cells [n]\n",
  "ZYGOPLEURAL": "bilaterally symmetrical [adj]\n",
  "ZYGOSE": "pertaining to zygosis, the union of two gametes [adj]\n",
  "ZYGOSES": "ZYGOSIS, (Greek) the union of two gametes [n]\n",
  "ZYGOSIS": "(Greek) the union of two gametes [n ZYGOSES]\n",
  "ZYGOSITIES": "ZYGOSITY, the makeup of a zygote [n]\n",
  "ZYGOSITY": "the makeup of a zygote [n ZYGOSITIES]\n",
  "ZYGOSPERM": "a spore formed by union of two similar cells, also ZYGOSPORE [n -S]\n",
  "ZYGOSPERMS": "ZYGOSPERM, a spore formed by union of two similar cells, also ZYGOSPORE [n]\n",
  "ZYGOSPHENE": "a median process on the front part of the neural arch of the vertebrae of most snakes and some lizards, which fits into a fossa, called the zygantrum, on the back part of the arch in front [n -S]\n",
  "ZYGOSPHENES": "ZYGOSPHENE, a median process on the front part of the neural arch of the vertebrae of most snakes and some lizards, which fits into a fossa, called the zygantrum, on the back part of the arch in front [n]\n",
  "ZYGOSPORE": "a spore formed by union of two similar cells, also ZYGOSPERM [n -S]\n",
  "ZYGOSPORES": "ZYGOSPORE, a spore formed by union of two similar cells, also ZYGOSPERM [n]\n",
  "ZYGOSPORIC": "of or like a zygospore, a spore formed by union of two similar cells [adj]\n",
  "ZYGOTE": "a cell formed from the union of two gametes [n -S]\n",
  "ZYGOTENE": "a stage in meiosis [n -S]\n",
  "ZYGOTENES": "ZYGOTENE, a stage in meiosis [n]\n",
  "ZYGOTES": "ZYGOTE, a cell formed from the union of two gametes [n]\n",
  "ZYGOTIC": "pertaining to a zygote, a cell formed by the union of two gametes [adj ZYGOTICALLY]\n",
  "ZYGOTICALLY": "ZYGOTIC, pertaining to a zygote, a cell formed by the union of two gametes [adv]\n",
  "ZYLONITE": "a non-thermosetting plastic of the nitrocellulose type, also XYLONITE [n -S]\n",
  "ZYLONITES": "ZYLONITE, a non-thermosetting plastic of the nitrocellulose type, also XYLONITE [n]\n",
  "ZYMASE": "an enzyme that converts sugar to alcohol and carbon dioxide [n -S]\n",
  "ZYMASES": "ZYMASE, an enzyme that converts sugar to alcohol and carbon dioxide [n]\n",
  "ZYME": "a ferment [n -S]\n",
  "ZYMES": "ZYME, a ferment [n]\n",
  "ZYMIC": "relating to fermentation [adj]\n",
  "ZYMITE": "a priest who uses leavened bread [n -S]\n",
  "ZYMITES": "ZYMITE, a priest who uses leavened bread [n]\n",
  "ZYMOGEN": "a substance that develops into an enzyme, also ZYMOGENE [n -S]\n",
  "ZYMOGENE": "a substance that develops into an enzyme, also ZYMOGEN [n -S]\n",
  "ZYMOGENES": "ZYMOGENE, a substance that develops into an enzyme, also ZYMOGEN [n]\n",
  "ZYMOGENESES": "ZYMOGENESIS, the conversion of a zymogen into an enzyme [n]\n",
  "ZYMOGENESIS": "the conversion of a zymogen into an enzyme [n ZYMOGENESES]\n",
  "ZYMOGENIC": "causing fermentation [adj]\n",
  "ZYMOGENS": "ZYMOGEN, a substance that develops into an enzyme, also ZYMOGENE [n]\n",
  "ZYMOGRAM": "a record of separated proteins [n -S]\n",
  "ZYMOGRAMS": "ZYMOGRAM, a record of separated proteins [n]\n",
  "ZYMOID": "like a ferment [adj]\n",
  "ZYMOLOGIC": "relating to zymology, the science of fermentation, also ZYMOLOGICAL [adj]\n",
  "ZYMOLOGICAL": "relating to zymology, the science of fermentation, also ZYMOLOGIC [adj]\n",
  "ZYMOLOGIES": "ZYMOLOGY, the science of fermentation [n]\n",
  "ZYMOLOGIST": "one who is skilled in zymology, or in the fermentation of liquors [n -S]\n",
  "ZYMOLOGISTS": "ZYMOLOGIST, one who is skilled in zymology, or in the fermentation of liquors [n]\n",
  "ZYMOLOGY": "the science of fermentation [n ZYMOLOGIES]\n",
  "ZYMOLYSES": "ZYMOLYSIS, the action of enzymes [n]\n",
  "ZYMOLYSIS": "the action of enzymes [n ZYMOLYSES]\n",
  "ZYMOLYTIC": "relating to zymolysis, the action of enzymes [adj]\n",
  "ZYMOME": "an old name for the part of gluten insoluble in alcohol [n -S]\n",
  "ZYMOMES": "ZYMOME, an old name for the part of gluten insoluble in alcohol [n]\n",
  "ZYMOMETER": "an instrument for measuring fermentation [n -S]\n",
  "ZYMOMETERS": "ZYMOMETER, an instrument for measuring fermentation [n]\n",
  "ZYMOSAN": "an insoluble carbohydrate in yeast cell walls [n -S]\n",
  "ZYMOSANS": "ZYMOSAN, an insoluble carbohydrate in yeast cell walls [n]\n",
  "ZYMOSES": "ZYMOSIS, (Greek) fermentation [n]\n",
  "ZYMOSIMETER": "an instrument for measuring fermentation [n -S]\n",
  "ZYMOSIMETERS": "ZYMOSIMETER, an instrument for measuring fermentation [n]\n",
  "ZYMOSIS": "(Greek) fermentation [n ZYMOSES]\n",
  "ZYMOTECHNIC": "producing and utilizing fermentation, also ZYMOTECHNICAL [adj]\n",
  "ZYMOTECHNICAL": "producing and utilizing fermentation, also ZYMOTECHNIC [adj]\n",
  "ZYMOTECHNICS": "the art of managing fermentation [n]\n",
  "ZYMOTIC": "of the nature of, relating to or causing an infectious disease [adj ZYMOTICALLY] / an infectious disease [n -S]\n",
  "ZYMOTICALLY": "ZYMOTIC, of the nature of, relating to or causing an infectious disease [adv]\n",
  "ZYMOTICS": "ZYMOTIC, an infectious disease [n]\n",
  "ZYMURGIES": "ZYMURGY, (Greek) the branch of applied chemistry dealing with fermentation processes [n]\n",
  "ZYMURGY": "(Greek) the branch of applied chemistry dealing with fermentation processes [n ZYMURGIES]\n",
  "ZYTHUM": "(Greek) a malt beer made by the ancient Egyptians [n -S]\n",
  "ZYTHUMS": "ZYTHUM, (Greek) a malt beer made by the ancient Egyptians [n]\n",
  "ZYZZYVA": "a tropical weevil [n -S]\n",
  "ZYZZYVAS": "ZYZZYVA, a tropical weevil [n]\n",
  "ZZZ": "an interjection expressing sleep [interj]\n",
  "ZZZS": "(colloquial) an informal noun for sleep, as in to catch a few zzzs [n]"
}
